webpackJsonp([0],{

/***/ "./mobile/src/components/buttons/cancel-btn/cancel-btn.html":
/***/ (function(module, exports) {

module.exports = "<button class=\"btn btn-default btn-full-width mt-10 mb-15\"\n        type=\"button\"\n        [disabled]=\"isDisabled\"\n        (click)=\"onBtnClick()\"\n>Cancel</button>\n"

/***/ }),

/***/ "./mobile/src/components/buttons/cancel-btn/cancel-btn.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var CancelBtnComponent = function () {
    function CancelBtnComponent() {
        _classCallCheck(this, CancelBtnComponent);

        this.action = new core_1.EventEmitter();
    }

    _createClass(CancelBtnComponent, [{
        key: "onBtnClick",
        value: function onBtnClick() {
            this.action.emit();
        }
    }]);

    return CancelBtnComponent;
}();
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], CancelBtnComponent.prototype, "action", void 0);
__decorate([core_1.Input('isDisabled'), __metadata("design:type", Boolean)], CancelBtnComponent.prototype, "isDisabled", void 0);
CancelBtnComponent = __decorate([core_1.Component({
    selector: 'cancel-btn',
    template: __webpack_require__("./mobile/src/components/buttons/cancel-btn/cancel-btn.html")
}), __metadata("design:paramtypes", [])], CancelBtnComponent);
exports.CancelBtnComponent = CancelBtnComponent;

/***/ }),

/***/ "./mobile/src/components/files/attachments/attachments.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"attachments__box\">\n  <input #inputFile (change)=\"renewFiles($event)\" [id]=\"'attachment-' + attachmentId\" class=\"attachments__input hide\" type=\"file\"/>\n  <h4 *ngIf=\"attachmentsView && attachmentsView.length > 0\" class=\"mt-15 mb-8 text-semi-bold\">Files attached</h4>\n  <ul class=\"attachments__list\">\n    <li *ngFor=\"let file of attachmentsView; let i = index\" class=\"file-type {{file.convertedType}}\">\n      <div class=\"file-content-wrapper\"> <b class=\"file-name\">{{ file.name }}</b>\n        <p class=\"mt-5 flex-basis-full \">{{ file.convertedSize }}Mb</p>\n      </div>\n      <div class=\"remove-btn-wrapper\">\n        <i class=\"fa fa-close file-remove\" (click)=\"removeAttachment(i)\"></i>\n      </div>\n    </li>\n  </ul>\n</div>\n"

/***/ }),

/***/ "./mobile/src/components/files/attachments/attachments.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var file_upload_service_1 = __webpack_require__("./shared/services/files/file-upload-service/file-upload.service.ts");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var image_converter_service_1 = __webpack_require__("./shared/services/files/image-converter.service.ts");
var AttachmentsComponent = function () {
    function AttachmentsComponent(fileUploadService, messageService, imageConverter) {
        _classCallCheck(this, AttachmentsComponent);

        this.fileUploadService = fileUploadService;
        this.messageService = messageService;
        this.imageConverter = imageConverter;
        this.attachmentsChanged = new core_1.EventEmitter();
        this.files = null;
        this.attachmentsView = [];
        this.unsubscribe = new Subject_1.Subject();
    }

    _createClass(AttachmentsComponent, [{
        key: "ngOnChanges",
        value: function ngOnChanges() {
            if (this.filesObj !== undefined) {
                this.attachmentsView = this.filesObj.attachments;
                this.handleAttachmentsView(this.attachmentsView);
            }
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "renewFiles",
        value: function renewFiles(event) {
            if (event && event.target.files) {
                var newFile = event.target.files[0];
                newFile = this.fileUploadService.addFileConvertedSize(newFile);
                this.attachmentsView.push(newFile);
                this.handleAttachmentsView(this.attachmentsView, newFile);
            }
        }
    }, {
        key: "removeAttachment",
        value: function removeAttachment(index) {
            this.attachmentsView.splice(index, 1);
            this.handleAttachmentsView(this.attachmentsView);
        }
    }, {
        key: "handleAttachmentsView",
        value: function handleAttachmentsView(attachmentsView, newFile) {
            if (attachmentsView && attachmentsView.length > 0) {
                var resultSize = this.fileUploadService.getTotalSize(attachmentsView);
                var maxSize = this.fileUploadService.maxAttachment;
                if (resultSize > maxSize) {
                    this.messageService.showToaster('w_0', 'attachments');
                    if (typeof newFile !== 'undefined') {
                        attachmentsView.pop(newFile);
                        return;
                    }
                }
                if (this.filesObj === undefined) {
                    this.filesObj = {};
                }
            }
            this.buildFileObj();
            this.attachmentsChanged.emit(this.filesObj);
        }
    }, {
        key: "buildFileObj",
        value: function buildFileObj() {
            var _this = this;

            if (this.attachmentsView !== undefined || this.attachmentsView !== null) {
                var max = this.attachmentsView.length;
                var size = 0;
                for (var i = 0; i < max; i++) {
                    var fileSize = this.attachmentsView[i].size || this.attachmentsView[i].bytesSize;
                    size += fileSize;
                }
                size /= 1024 * 1000;
                size = Number(size.toFixed(2));
                this.filesObj.filesSize = size;
                this.attachmentsView.forEach(function (value) {
                    value.convertedType = _this.imageConverter.getFileClass(value.name);
                    if (value.bytesSize) {
                        value.convertedSize = (parseInt(value.bytesSize) / (1024 * 1024)).toFixed(2); // convert from bytes to MB
                    } else {
                        value.convertedSize = (parseInt(value.size) / (1024 * 1024)).toFixed(2); // convert from bytes to MB
                    }
                });
                this.filesObj.attachments = this.attachmentsView;
            }
        }
    }]);

    return AttachmentsComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], AttachmentsComponent.prototype, "filesObj", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], AttachmentsComponent.prototype, "attachmentId", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], AttachmentsComponent.prototype, "attachmentsChanged", void 0);
AttachmentsComponent = __decorate([core_1.Component({
    selector: 'attachments',
    template: __webpack_require__("./mobile/src/components/files/attachments/attachments.html")
}), __metadata("design:paramtypes", [file_upload_service_1.FileUploadServiceProvider, message_service_1.MessageService, image_converter_service_1.ImageConverterProvider])], AttachmentsComponent);
exports.AttachmentsComponent = AttachmentsComponent;

/***/ }),

/***/ "./mobile/src/providers/ionic-message-service/ionic-message-service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var ionic_angular_1 = __webpack_require__("./node_modules/ionic-angular/index.js");
var IonicMessageServiceProvider = function () {
    function IonicMessageServiceProvider(toastCtrl) {
        _classCallCheck(this, IonicMessageServiceProvider);

        this.toastCtrl = toastCtrl;
        this.messageTypes = {
            e: 'error',
            s: 'success',
            i: 'info',
            w: 'warning'
        };
    }

    _createClass(IonicMessageServiceProvider, [{
        key: "showToaster",
        value: function showToaster(msgObject) {
            var messageType = msgObject.messageType,
                title = msgObject.title,
                text = msgObject.text;

            var cssClass = "ion-toast-" + this.messageTypes[messageType];
            var message = title + "\n" + text;
            try {
                this.toast.dismiss();
            } catch (error) {
                console.error(error);
            }
            this.toast = this.toastCtrl.create({
                message: message,
                cssClass: cssClass,
                duration: 2500,
                position: 'top',
                dismissOnPageChange: false
            });
            this.toast.onDidDismiss(function () {
                // console.log('Dismissed toast');
            });
            this.toast.present();
        }
    }]);

    return IonicMessageServiceProvider;
}();
IonicMessageServiceProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [ionic_angular_1.ToastController])], IonicMessageServiceProvider);
exports.IonicMessageServiceProvider = IonicMessageServiceProvider;

/***/ }),

/***/ "./mobile/src/providers/product-packages-service/product-packages.data.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = __webpack_require__("./node_modules/@angular/common/esm5/http.js");
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var BehaviorSubject_1 = __webpack_require__("./node_modules/rxjs/BehaviorSubject.js");
var ProductPackagesServiceProvider = function () {
    function ProductPackagesServiceProvider(http) {
        _classCallCheck(this, ProductPackagesServiceProvider);

        this.http = http;
        this.product = new BehaviorSubject_1.BehaviorSubject(null);
        this.changedProduct = new BehaviorSubject_1.BehaviorSubject(null);
        this.productToDelete = new BehaviorSubject_1.BehaviorSubject(null);
        this.productNames = new BehaviorSubject_1.BehaviorSubject(null);
        this.chosenPackages = new BehaviorSubject_1.BehaviorSubject(null);
        this.packagesStorage = [];
    }

    _createClass(ProductPackagesServiceProvider, [{
        key: "emitProduct",
        value: function emitProduct(product) {
            this.product.next(product);
        }
    }, {
        key: "emitProductNames",
        value: function emitProductNames(productNames) {
            this.productNames.next(productNames);
        }
    }, {
        key: "emitChangedProduct",
        value: function emitChangedProduct(product) {
            this.changedProduct.next(product);
        }
    }, {
        key: "emitChosenPackages",
        value: function emitChosenPackages(packages) {
            this.chosenPackages.next(packages);
        }
    }, {
        key: "emitProductIndexToDelete",
        value: function emitProductIndexToDelete(product) {
            this.productToDelete.next(product);
        }
    }, {
        key: "getPackageFromStorage",
        value: function getPackageFromStorage(id) {
            return this.packagesStorage[id];
        }
    }, {
        key: "setPackageInStorage",
        value: function setPackageInStorage(productPackage, id) {
            this.packagesStorage[id] = Object.assign({}, productPackage);
        }
    }, {
        key: "fetchPackage",
        value: function fetchPackage(packageId) {
            var url = "/protected/rest/invoice/package?id=" + packageId;
            return this.http.get(url);
        }
    }, {
        key: "getPackagesOnPage",
        value: function getPackagesOnPage(pageRequest) {
            var perPage = pageRequest.perPage,
                page = pageRequest.page,
                _pageRequest$pageOrde = pageRequest.pageOrder,
                predicate = _pageRequest$pageOrde.predicate,
                reverse = _pageRequest$pageOrde.reverse;

            var url = '/protected/rest/products';
            var params = new http_1.HttpParams();
            params = params.append('perPage', perPage);
            params = params.append('page', page);
            params = params.append('predicate', predicate);
            params = params.append('reverse', reverse);
            return this.http.get(url, { params: params });
        }
    }, {
        key: "productObservable",
        get: function get() {
            return this.product.asObservable();
        }
    }, {
        key: "changedProductObservable",
        get: function get() {
            return this.changedProduct.asObservable();
        }
    }, {
        key: "productNamesObservable",
        get: function get() {
            return this.productNames.asObservable();
        }
    }, {
        key: "chosenPackagesObservable",
        get: function get() {
            return this.chosenPackages.asObservable();
        }
    }, {
        key: "productToDeleteObservable",
        get: function get() {
            return this.productToDelete.asObservable();
        }
    }]);

    return ProductPackagesServiceProvider;
}();
ProductPackagesServiceProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [http_1.HttpClient])], ProductPackagesServiceProvider);
exports.ProductPackagesServiceProvider = ProductPackagesServiceProvider;

/***/ }),

/***/ "./mobile/src/store/selectors/settings.selector.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__("./node_modules/@ngrx/store/@ngrx/store.es5.js");
exports.getSettingsState = function (state) {
  return state.settings;
};
exports.getSettingsInfo = function (state) {
  return state.settings;
};
exports.getCustomisedLabelsState = function (state) {
  return state.labels;
};
exports.getBootstrapSettings = store_1.createSelector(exports.getSettingsState, exports.getSettingsInfo);
exports.getCustomizedLabels = store_1.createSelector(exports.getSettingsState, exports.getCustomisedLabelsState);

/***/ }),

/***/ "./node_modules/@angular/common/esm5/http.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpBackend", function() { return HttpBackend; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpHandler", function() { return HttpHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpClient", function() { return HttpClient; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpHeaders", function() { return HttpHeaders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HTTP_INTERCEPTORS", function() { return HTTP_INTERCEPTORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JsonpClientBackend", function() { return JsonpClientBackend; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JsonpInterceptor", function() { return JsonpInterceptor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpClientJsonpModule", function() { return HttpClientJsonpModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpClientModule", function() { return HttpClientModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpClientXsrfModule", function() { return HttpClientXsrfModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵinterceptingHandler", function() { return interceptingHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpParams", function() { return HttpParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpUrlEncodingCodec", function() { return HttpUrlEncodingCodec; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpRequest", function() { return HttpRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpErrorResponse", function() { return HttpErrorResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpEventType", function() { return HttpEventType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpHeaderResponse", function() { return HttpHeaderResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpResponse", function() { return HttpResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpResponseBase", function() { return HttpResponseBase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpXhrBackend", function() { return HttpXhrBackend; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "XhrFactory", function() { return XhrFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpXsrfTokenExtractor", function() { return HttpXsrfTokenExtractor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵa", function() { return NoopInterceptor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵb", function() { return JsonpCallbackContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵc", function() { return HttpInterceptingHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵd", function() { return jsonpCallbackContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵe", function() { return BrowserXhr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵh", function() { return HttpXsrfCookieExtractor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵi", function() { return HttpXsrfInterceptor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵf", function() { return XSRF_COOKIE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵg", function() { return XSRF_HEADER_NAME; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_observable_of__ = __webpack_require__("./node_modules/rxjs/observable/of.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_observable_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_observable_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_operator_concatMap__ = __webpack_require__("./node_modules/rxjs/operator/concatMap.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_operator_concatMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_operator_concatMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_filter__ = __webpack_require__("./node_modules/rxjs/operator/filter.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_operator_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_map__ = __webpack_require__("./node_modules/rxjs/operator/map.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__angular_common__ = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_Observable__ = __webpack_require__("./node_modules/rxjs/Observable.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_rxjs_Observable__);
/**
 * @license Angular v5.2.10
 * (c) 2010-2018 Google, Inc. https://angular.io/
 * License: MIT
 */









/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Transforms an `HttpRequest` into a stream of `HttpEvent`s, one of which will likely be a
 * `HttpResponse`.
 *
 * `HttpHandler` is injectable. When injected, the handler instance dispatches requests to the
 * first interceptor in the chain, which dispatches to the second, etc, eventually reaching the
 * `HttpBackend`.
 *
 * In an `HttpInterceptor`, the `HttpHandler` parameter is the next interceptor in the chain.
 *
 * \@stable
 * @abstract
 */
var HttpHandler = /** @class */ (function () {
    function HttpHandler() {
    }
    return HttpHandler;
}());
/**
 * A final `HttpHandler` which will dispatch the request via browser HTTP APIs to a backend.
 *
 * Interceptors sit between the `HttpClient` interface and the `HttpBackend`.
 *
 * When injected, `HttpBackend` dispatches requests directly to the backend, without going
 * through the interceptor chain.
 *
 * \@stable
 * @abstract
 */
var HttpBackend = /** @class */ (function () {
    function HttpBackend() {
    }
    return HttpBackend;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @record
 */
/**
 * Immutable set of Http headers, with lazy parsing.
 * \@stable
 */
var HttpHeaders = /** @class */ (function () {
    function HttpHeaders(headers) {
        var _this = this;
        /**
         * Internal map of lowercased header names to the normalized
         * form of the name (the form seen first).
         */
        this.normalizedNames = new Map();
        /**
         * Queued updates to be materialized the next initialization.
         */
        this.lazyUpdate = null;
        if (!headers) {
            this.headers = new Map();
        }
        else if (typeof headers === 'string') {
            this.lazyInit = function () {
                _this.headers = new Map();
                headers.split('\n').forEach(function (line) {
                    var /** @type {?} */ index = line.indexOf(':');
                    if (index > 0) {
                        var /** @type {?} */ name_1 = line.slice(0, index);
                        var /** @type {?} */ key = name_1.toLowerCase();
                        var /** @type {?} */ value = line.slice(index + 1).trim();
                        _this.maybeSetNormalizedName(name_1, key);
                        if (_this.headers.has(key)) {
                            /** @type {?} */ ((_this.headers.get(key))).push(value);
                        }
                        else {
                            _this.headers.set(key, [value]);
                        }
                    }
                });
            };
        }
        else {
            this.lazyInit = function () {
                _this.headers = new Map();
                Object.keys(headers).forEach(function (name) {
                    var /** @type {?} */ values = headers[name];
                    var /** @type {?} */ key = name.toLowerCase();
                    if (typeof values === 'string') {
                        values = [values];
                    }
                    if (values.length > 0) {
                        _this.headers.set(key, values);
                        _this.maybeSetNormalizedName(name, key);
                    }
                });
            };
        }
    }
    /**
     * Checks for existence of header by given name.
     */
    /**
     * Checks for existence of header by given name.
     * @param {?} name
     * @return {?}
     */
    HttpHeaders.prototype.has = /**
     * Checks for existence of header by given name.
     * @param {?} name
     * @return {?}
     */
    function (name) {
        this.init();
        return this.headers.has(name.toLowerCase());
    };
    /**
     * Returns first header that matches given name.
     */
    /**
     * Returns first header that matches given name.
     * @param {?} name
     * @return {?}
     */
    HttpHeaders.prototype.get = /**
     * Returns first header that matches given name.
     * @param {?} name
     * @return {?}
     */
    function (name) {
        this.init();
        var /** @type {?} */ values = this.headers.get(name.toLowerCase());
        return values && values.length > 0 ? values[0] : null;
    };
    /**
     * Returns the names of the headers
     */
    /**
     * Returns the names of the headers
     * @return {?}
     */
    HttpHeaders.prototype.keys = /**
     * Returns the names of the headers
     * @return {?}
     */
    function () {
        this.init();
        return Array.from(this.normalizedNames.values());
    };
    /**
     * Returns list of header values for a given name.
     */
    /**
     * Returns list of header values for a given name.
     * @param {?} name
     * @return {?}
     */
    HttpHeaders.prototype.getAll = /**
     * Returns list of header values for a given name.
     * @param {?} name
     * @return {?}
     */
    function (name) {
        this.init();
        return this.headers.get(name.toLowerCase()) || null;
    };
    /**
     * @param {?} name
     * @param {?} value
     * @return {?}
     */
    HttpHeaders.prototype.append = /**
     * @param {?} name
     * @param {?} value
     * @return {?}
     */
    function (name, value) {
        return this.clone({ name: name, value: value, op: 'a' });
    };
    /**
     * @param {?} name
     * @param {?} value
     * @return {?}
     */
    HttpHeaders.prototype.set = /**
     * @param {?} name
     * @param {?} value
     * @return {?}
     */
    function (name, value) {
        return this.clone({ name: name, value: value, op: 's' });
    };
    /**
     * @param {?} name
     * @param {?=} value
     * @return {?}
     */
    HttpHeaders.prototype.delete = /**
     * @param {?} name
     * @param {?=} value
     * @return {?}
     */
    function (name, value) {
        return this.clone({ name: name, value: value, op: 'd' });
    };
    /**
     * @param {?} name
     * @param {?} lcName
     * @return {?}
     */
    HttpHeaders.prototype.maybeSetNormalizedName = /**
     * @param {?} name
     * @param {?} lcName
     * @return {?}
     */
    function (name, lcName) {
        if (!this.normalizedNames.has(lcName)) {
            this.normalizedNames.set(lcName, name);
        }
    };
    /**
     * @return {?}
     */
    HttpHeaders.prototype.init = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (!!this.lazyInit) {
            if (this.lazyInit instanceof HttpHeaders) {
                this.copyFrom(this.lazyInit);
            }
            else {
                this.lazyInit();
            }
            this.lazyInit = null;
            if (!!this.lazyUpdate) {
                this.lazyUpdate.forEach(function (update) { return _this.applyUpdate(update); });
                this.lazyUpdate = null;
            }
        }
    };
    /**
     * @param {?} other
     * @return {?}
     */
    HttpHeaders.prototype.copyFrom = /**
     * @param {?} other
     * @return {?}
     */
    function (other) {
        var _this = this;
        other.init();
        Array.from(other.headers.keys()).forEach(function (key) {
            _this.headers.set(key, /** @type {?} */ ((other.headers.get(key))));
            _this.normalizedNames.set(key, /** @type {?} */ ((other.normalizedNames.get(key))));
        });
    };
    /**
     * @param {?} update
     * @return {?}
     */
    HttpHeaders.prototype.clone = /**
     * @param {?} update
     * @return {?}
     */
    function (update) {
        var /** @type {?} */ clone = new HttpHeaders();
        clone.lazyInit =
            (!!this.lazyInit && this.lazyInit instanceof HttpHeaders) ? this.lazyInit : this;
        clone.lazyUpdate = (this.lazyUpdate || []).concat([update]);
        return clone;
    };
    /**
     * @param {?} update
     * @return {?}
     */
    HttpHeaders.prototype.applyUpdate = /**
     * @param {?} update
     * @return {?}
     */
    function (update) {
        var /** @type {?} */ key = update.name.toLowerCase();
        switch (update.op) {
            case 'a':
            case 's':
                var /** @type {?} */ value = /** @type {?} */ ((update.value));
                if (typeof value === 'string') {
                    value = [value];
                }
                if (value.length === 0) {
                    return;
                }
                this.maybeSetNormalizedName(update.name, key);
                var /** @type {?} */ base = (update.op === 'a' ? this.headers.get(key) : undefined) || [];
                base.push.apply(base, value);
                this.headers.set(key, base);
                break;
            case 'd':
                var /** @type {?} */ toDelete_1 = /** @type {?} */ (update.value);
                if (!toDelete_1) {
                    this.headers.delete(key);
                    this.normalizedNames.delete(key);
                }
                else {
                    var /** @type {?} */ existing = this.headers.get(key);
                    if (!existing) {
                        return;
                    }
                    existing = existing.filter(function (value) { return toDelete_1.indexOf(value) === -1; });
                    if (existing.length === 0) {
                        this.headers.delete(key);
                        this.normalizedNames.delete(key);
                    }
                    else {
                        this.headers.set(key, existing);
                    }
                }
                break;
        }
    };
    /**
     * @internal
     */
    /**
     * \@internal
     * @param {?} fn
     * @return {?}
     */
    HttpHeaders.prototype.forEach = /**
     * \@internal
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        var _this = this;
        this.init();
        Array.from(this.normalizedNames.keys())
            .forEach(function (key) { return fn(/** @type {?} */ ((_this.normalizedNames.get(key))), /** @type {?} */ ((_this.headers.get(key)))); });
    };
    return HttpHeaders;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * A codec for encoding and decoding parameters in URLs.
 *
 * Used by `HttpParams`.
 *
 * \@stable
 *
 * @record
 */

/**
 * A `HttpParameterCodec` that uses `encodeURIComponent` and `decodeURIComponent` to
 * serialize and parse URL parameter keys and values.
 *
 * \@stable
 */
var HttpUrlEncodingCodec = /** @class */ (function () {
    function HttpUrlEncodingCodec() {
    }
    /**
     * @param {?} k
     * @return {?}
     */
    HttpUrlEncodingCodec.prototype.encodeKey = /**
     * @param {?} k
     * @return {?}
     */
    function (k) { return standardEncoding(k); };
    /**
     * @param {?} v
     * @return {?}
     */
    HttpUrlEncodingCodec.prototype.encodeValue = /**
     * @param {?} v
     * @return {?}
     */
    function (v) { return standardEncoding(v); };
    /**
     * @param {?} k
     * @return {?}
     */
    HttpUrlEncodingCodec.prototype.decodeKey = /**
     * @param {?} k
     * @return {?}
     */
    function (k) { return decodeURIComponent(k); };
    /**
     * @param {?} v
     * @return {?}
     */
    HttpUrlEncodingCodec.prototype.decodeValue = /**
     * @param {?} v
     * @return {?}
     */
    function (v) { return decodeURIComponent(v); };
    return HttpUrlEncodingCodec;
}());
/**
 * @param {?} rawParams
 * @param {?} codec
 * @return {?}
 */
function paramParser(rawParams, codec) {
    var /** @type {?} */ map$$1 = new Map();
    if (rawParams.length > 0) {
        var /** @type {?} */ params = rawParams.split('&');
        params.forEach(function (param) {
            var /** @type {?} */ eqIdx = param.indexOf('=');
            var _a = eqIdx == -1 ?
                [codec.decodeKey(param), ''] :
                [codec.decodeKey(param.slice(0, eqIdx)), codec.decodeValue(param.slice(eqIdx + 1))], key = _a[0], val = _a[1];
            var /** @type {?} */ list = map$$1.get(key) || [];
            list.push(val);
            map$$1.set(key, list);
        });
    }
    return map$$1;
}
/**
 * @param {?} v
 * @return {?}
 */
function standardEncoding(v) {
    return encodeURIComponent(v)
        .replace(/%40/gi, '@')
        .replace(/%3A/gi, ':')
        .replace(/%24/gi, '$')
        .replace(/%2C/gi, ',')
        .replace(/%3B/gi, ';')
        .replace(/%2B/gi, '+')
        .replace(/%3D/gi, '=')
        .replace(/%3F/gi, '?')
        .replace(/%2F/gi, '/');
}
/**
 * An HTTP request/response body that represents serialized parameters,
 * per the MIME type `application/x-www-form-urlencoded`.
 *
 * This class is immutable - all mutation operations return a new instance.
 *
 * \@stable
 */
var HttpParams = /** @class */ (function () {
    function HttpParams(options) {
        if (options === void 0) { options = /** @type {?} */ ({}); }
        var _this = this;
        this.updates = null;
        this.cloneFrom = null;
        this.encoder = options.encoder || new HttpUrlEncodingCodec();
        if (!!options.fromString) {
            if (!!options.fromObject) {
                throw new Error("Cannot specify both fromString and fromObject.");
            }
            this.map = paramParser(options.fromString, this.encoder);
        }
        else if (!!options.fromObject) {
            this.map = new Map();
            Object.keys(options.fromObject).forEach(function (key) {
                var /** @type {?} */ value = (/** @type {?} */ (options.fromObject))[key]; /** @type {?} */
                ((_this.map)).set(key, Array.isArray(value) ? value : [value]);
            });
        }
        else {
            this.map = null;
        }
    }
    /**
     * Check whether the body has one or more values for the given parameter name.
     */
    /**
     * Check whether the body has one or more values for the given parameter name.
     * @param {?} param
     * @return {?}
     */
    HttpParams.prototype.has = /**
     * Check whether the body has one or more values for the given parameter name.
     * @param {?} param
     * @return {?}
     */
    function (param) {
        this.init();
        return /** @type {?} */ ((this.map)).has(param);
    };
    /**
     * Get the first value for the given parameter name, or `null` if it's not present.
     */
    /**
     * Get the first value for the given parameter name, or `null` if it's not present.
     * @param {?} param
     * @return {?}
     */
    HttpParams.prototype.get = /**
     * Get the first value for the given parameter name, or `null` if it's not present.
     * @param {?} param
     * @return {?}
     */
    function (param) {
        this.init();
        var /** @type {?} */ res = /** @type {?} */ ((this.map)).get(param);
        return !!res ? res[0] : null;
    };
    /**
     * Get all values for the given parameter name, or `null` if it's not present.
     */
    /**
     * Get all values for the given parameter name, or `null` if it's not present.
     * @param {?} param
     * @return {?}
     */
    HttpParams.prototype.getAll = /**
     * Get all values for the given parameter name, or `null` if it's not present.
     * @param {?} param
     * @return {?}
     */
    function (param) {
        this.init();
        return /** @type {?} */ ((this.map)).get(param) || null;
    };
    /**
     * Get all the parameter names for this body.
     */
    /**
     * Get all the parameter names for this body.
     * @return {?}
     */
    HttpParams.prototype.keys = /**
     * Get all the parameter names for this body.
     * @return {?}
     */
    function () {
        this.init();
        return Array.from(/** @type {?} */ ((this.map)).keys());
    };
    /**
     * Construct a new body with an appended value for the given parameter name.
     */
    /**
     * Construct a new body with an appended value for the given parameter name.
     * @param {?} param
     * @param {?} value
     * @return {?}
     */
    HttpParams.prototype.append = /**
     * Construct a new body with an appended value for the given parameter name.
     * @param {?} param
     * @param {?} value
     * @return {?}
     */
    function (param, value) { return this.clone({ param: param, value: value, op: 'a' }); };
    /**
     * Construct a new body with a new value for the given parameter name.
     */
    /**
     * Construct a new body with a new value for the given parameter name.
     * @param {?} param
     * @param {?} value
     * @return {?}
     */
    HttpParams.prototype.set = /**
     * Construct a new body with a new value for the given parameter name.
     * @param {?} param
     * @param {?} value
     * @return {?}
     */
    function (param, value) { return this.clone({ param: param, value: value, op: 's' }); };
    /**
     * Construct a new body with either the given value for the given parameter
     * removed, if a value is given, or all values for the given parameter removed
     * if not.
     */
    /**
     * Construct a new body with either the given value for the given parameter
     * removed, if a value is given, or all values for the given parameter removed
     * if not.
     * @param {?} param
     * @param {?=} value
     * @return {?}
     */
    HttpParams.prototype.delete = /**
     * Construct a new body with either the given value for the given parameter
     * removed, if a value is given, or all values for the given parameter removed
     * if not.
     * @param {?} param
     * @param {?=} value
     * @return {?}
     */
    function (param, value) { return this.clone({ param: param, value: value, op: 'd' }); };
    /**
     * Serialize the body to an encoded string, where key-value pairs (separated by `=`) are
     * separated by `&`s.
     */
    /**
     * Serialize the body to an encoded string, where key-value pairs (separated by `=`) are
     * separated by `&`s.
     * @return {?}
     */
    HttpParams.prototype.toString = /**
     * Serialize the body to an encoded string, where key-value pairs (separated by `=`) are
     * separated by `&`s.
     * @return {?}
     */
    function () {
        var _this = this;
        this.init();
        return this.keys()
            .map(function (key) {
            var /** @type {?} */ eKey = _this.encoder.encodeKey(key);
            return /** @type {?} */ ((/** @type {?} */ ((_this.map)).get(key))).map(function (value) { return eKey + '=' + _this.encoder.encodeValue(value); }).join('&');
        })
            .join('&');
    };
    /**
     * @param {?} update
     * @return {?}
     */
    HttpParams.prototype.clone = /**
     * @param {?} update
     * @return {?}
     */
    function (update) {
        var /** @type {?} */ clone = new HttpParams({ encoder: this.encoder });
        clone.cloneFrom = this.cloneFrom || this;
        clone.updates = (this.updates || []).concat([update]);
        return clone;
    };
    /**
     * @return {?}
     */
    HttpParams.prototype.init = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.map === null) {
            this.map = new Map();
        }
        if (this.cloneFrom !== null) {
            this.cloneFrom.init();
            this.cloneFrom.keys().forEach(function (key) { return ((_this.map)).set(key, /** @type {?} */ ((/** @type {?} */ ((/** @type {?} */ ((_this.cloneFrom)).map)).get(key)))); }); /** @type {?} */
            ((this.updates)).forEach(function (update) {
                switch (update.op) {
                    case 'a':
                    case 's':
                        var /** @type {?} */ base = (update.op === 'a' ? /** @type {?} */ ((_this.map)).get(update.param) : undefined) || [];
                        base.push(/** @type {?} */ ((update.value))); /** @type {?} */
                        ((_this.map)).set(update.param, base);
                        break;
                    case 'd':
                        if (update.value !== undefined) {
                            var /** @type {?} */ base_1 = /** @type {?} */ ((_this.map)).get(update.param) || [];
                            var /** @type {?} */ idx = base_1.indexOf(update.value);
                            if (idx !== -1) {
                                base_1.splice(idx, 1);
                            }
                            if (base_1.length > 0) {
                                /** @type {?} */ ((_this.map)).set(update.param, base_1);
                            }
                            else {
                                /** @type {?} */ ((_this.map)).delete(update.param);
                            }
                        }
                        else {
                            /** @type {?} */ ((_this.map)).delete(update.param);
                            break;
                        }
                }
            });
            this.cloneFrom = null;
        }
    };
    return HttpParams;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Determine whether the given HTTP method may include a body.
 * @param {?} method
 * @return {?}
 */
function mightHaveBody(method) {
    switch (method) {
        case 'DELETE':
        case 'GET':
        case 'HEAD':
        case 'OPTIONS':
        case 'JSONP':
            return false;
        default:
            return true;
    }
}
/**
 * Safely assert whether the given value is an ArrayBuffer.
 *
 * In some execution environments ArrayBuffer is not defined.
 * @param {?} value
 * @return {?}
 */
function isArrayBuffer(value) {
    return typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer;
}
/**
 * Safely assert whether the given value is a Blob.
 *
 * In some execution environments Blob is not defined.
 * @param {?} value
 * @return {?}
 */
function isBlob(value) {
    return typeof Blob !== 'undefined' && value instanceof Blob;
}
/**
 * Safely assert whether the given value is a FormData instance.
 *
 * In some execution environments FormData is not defined.
 * @param {?} value
 * @return {?}
 */
function isFormData(value) {
    return typeof FormData !== 'undefined' && value instanceof FormData;
}
/**
 * An outgoing HTTP request with an optional typed body.
 *
 * `HttpRequest` represents an outgoing request, including URL, method,
 * headers, body, and other request configuration options. Instances should be
 * assumed to be immutable. To modify a `HttpRequest`, the `clone`
 * method should be used.
 *
 * \@stable
 * @template T
 */
var HttpRequest = /** @class */ (function () {
    function HttpRequest(method, url, third, fourth) {
        this.url = url;
        /**
         * The request body, or `null` if one isn't set.
         *
         * Bodies are not enforced to be immutable, as they can include a reference to any
         * user-defined data type. However, interceptors should take care to preserve
         * idempotence by treating them as such.
         */
        this.body = null;
        /**
         * Whether this request should be made in a way that exposes progress events.
         *
         * Progress events are expensive (change detection runs on each event) and so
         * they should only be requested if the consumer intends to monitor them.
         */
        this.reportProgress = false;
        /**
         * Whether this request should be sent with outgoing credentials (cookies).
         */
        this.withCredentials = false;
        /**
         * The expected response type of the server.
         *
         * This is used to parse the response appropriately before returning it to
         * the requestee.
         */
        this.responseType = 'json';
        this.method = method.toUpperCase();
        // Next, need to figure out which argument holds the HttpRequestInit
        // options, if any.
        var /** @type {?} */ options;
        // Check whether a body argument is expected. The only valid way to omit
        // the body argument is to use a known no-body method like GET.
        if (mightHaveBody(this.method) || !!fourth) {
            // Body is the third argument, options are the fourth.
            this.body = (third !== undefined) ? /** @type {?} */ (third) : null;
            options = fourth;
        }
        else {
            // No body required, options are the third argument. The body stays null.
            options = /** @type {?} */ (third);
        }
        // If options have been passed, interpret them.
        if (options) {
            // Normalize reportProgress and withCredentials.
            this.reportProgress = !!options.reportProgress;
            this.withCredentials = !!options.withCredentials;
            // Override default response type of 'json' if one is provided.
            if (!!options.responseType) {
                this.responseType = options.responseType;
            }
            // Override headers if they're provided.
            if (!!options.headers) {
                this.headers = options.headers;
            }
            if (!!options.params) {
                this.params = options.params;
            }
        }
        // If no headers have been passed in, construct a new HttpHeaders instance.
        if (!this.headers) {
            this.headers = new HttpHeaders();
        }
        // If no parameters have been passed in, construct a new HttpUrlEncodedParams instance.
        if (!this.params) {
            this.params = new HttpParams();
            this.urlWithParams = url;
        }
        else {
            // Encode the parameters to a string in preparation for inclusion in the URL.
            var /** @type {?} */ params = this.params.toString();
            if (params.length === 0) {
                // No parameters, the visible URL is just the URL given at creation time.
                this.urlWithParams = url;
            }
            else {
                // Does the URL already have query parameters? Look for '?'.
                var /** @type {?} */ qIdx = url.indexOf('?');
                // There are 3 cases to handle:
                // 1) No existing parameters -> append '?' followed by params.
                // 2) '?' exists and is followed by existing query string ->
                //    append '&' followed by params.
                // 3) '?' exists at the end of the url -> append params directly.
                // This basically amounts to determining the character, if any, with
                // which to join the URL and parameters.
                var /** @type {?} */ sep = qIdx === -1 ? '?' : (qIdx < url.length - 1 ? '&' : '');
                this.urlWithParams = url + sep + params;
            }
        }
    }
    /**
     * Transform the free-form body into a serialized format suitable for
     * transmission to the server.
     */
    /**
     * Transform the free-form body into a serialized format suitable for
     * transmission to the server.
     * @return {?}
     */
    HttpRequest.prototype.serializeBody = /**
     * Transform the free-form body into a serialized format suitable for
     * transmission to the server.
     * @return {?}
     */
    function () {
        // If no body is present, no need to serialize it.
        if (this.body === null) {
            return null;
        }
        // Check whether the body is already in a serialized form. If so,
        // it can just be returned directly.
        if (isArrayBuffer(this.body) || isBlob(this.body) || isFormData(this.body) ||
            typeof this.body === 'string') {
            return this.body;
        }
        // Check whether the body is an instance of HttpUrlEncodedParams.
        if (this.body instanceof HttpParams) {
            return this.body.toString();
        }
        // Check whether the body is an object or array, and serialize with JSON if so.
        if (typeof this.body === 'object' || typeof this.body === 'boolean' ||
            Array.isArray(this.body)) {
            return JSON.stringify(this.body);
        }
        // Fall back on toString() for everything else.
        return (/** @type {?} */ (this.body)).toString();
    };
    /**
     * Examine the body and attempt to infer an appropriate MIME type
     * for it.
     *
     * If no such type can be inferred, this method will return `null`.
     */
    /**
     * Examine the body and attempt to infer an appropriate MIME type
     * for it.
     *
     * If no such type can be inferred, this method will return `null`.
     * @return {?}
     */
    HttpRequest.prototype.detectContentTypeHeader = /**
     * Examine the body and attempt to infer an appropriate MIME type
     * for it.
     *
     * If no such type can be inferred, this method will return `null`.
     * @return {?}
     */
    function () {
        // An empty body has no content type.
        if (this.body === null) {
            return null;
        }
        // FormData bodies rely on the browser's content type assignment.
        if (isFormData(this.body)) {
            return null;
        }
        // Blobs usually have their own content type. If it doesn't, then
        // no type can be inferred.
        if (isBlob(this.body)) {
            return this.body.type || null;
        }
        // Array buffers have unknown contents and thus no type can be inferred.
        if (isArrayBuffer(this.body)) {
            return null;
        }
        // Technically, strings could be a form of JSON data, but it's safe enough
        // to assume they're plain strings.
        if (typeof this.body === 'string') {
            return 'text/plain';
        }
        // `HttpUrlEncodedParams` has its own content-type.
        if (this.body instanceof HttpParams) {
            return 'application/x-www-form-urlencoded;charset=UTF-8';
        }
        // Arrays, objects, and numbers will be encoded as JSON.
        if (typeof this.body === 'object' || typeof this.body === 'number' ||
            Array.isArray(this.body)) {
            return 'application/json';
        }
        // No type could be inferred.
        return null;
    };
    /**
     * @param {?=} update
     * @return {?}
     */
    HttpRequest.prototype.clone = /**
     * @param {?=} update
     * @return {?}
     */
    function (update) {
        if (update === void 0) { update = {}; }
        // For method, url, and responseType, take the current value unless
        // it is overridden in the update hash.
        var /** @type {?} */ method = update.method || this.method;
        var /** @type {?} */ url = update.url || this.url;
        var /** @type {?} */ responseType = update.responseType || this.responseType;
        // The body is somewhat special - a `null` value in update.body means
        // whatever current body is present is being overridden with an empty
        // body, whereas an `undefined` value in update.body implies no
        // override.
        var /** @type {?} */ body = (update.body !== undefined) ? update.body : this.body;
        // Carefully handle the boolean options to differentiate between
        // `false` and `undefined` in the update args.
        var /** @type {?} */ withCredentials = (update.withCredentials !== undefined) ? update.withCredentials : this.withCredentials;
        var /** @type {?} */ reportProgress = (update.reportProgress !== undefined) ? update.reportProgress : this.reportProgress;
        // Headers and params may be appended to if `setHeaders` or
        // `setParams` are used.
        var /** @type {?} */ headers = update.headers || this.headers;
        var /** @type {?} */ params = update.params || this.params;
        // Check whether the caller has asked to add headers.
        if (update.setHeaders !== undefined) {
            // Set every requested header.
            headers =
                Object.keys(update.setHeaders)
                    .reduce(function (headers, name) { return headers.set(name, /** @type {?} */ ((update.setHeaders))[name]); }, headers);
        }
        // Check whether the caller has asked to set params.
        if (update.setParams) {
            // Set every requested param.
            params = Object.keys(update.setParams)
                .reduce(function (params, param) { return params.set(param, /** @type {?} */ ((update.setParams))[param]); }, params);
        }
        // Finally, construct the new HttpRequest using the pieces from above.
        return new HttpRequest(method, url, body, {
            params: params, headers: headers, reportProgress: reportProgress, responseType: responseType, withCredentials: withCredentials,
        });
    };
    return HttpRequest;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/** @enum {number} */
var HttpEventType = {
    /**
       * The request was sent out over the wire.
       */
    Sent: 0,
    /**
       * An upload progress event was received.
       */
    UploadProgress: 1,
    /**
       * The response status code and headers were received.
       */
    ResponseHeader: 2,
    /**
       * A download progress event was received.
       */
    DownloadProgress: 3,
    /**
       * The full response including the body was received.
       */
    Response: 4,
    /**
       * A custom event from an interceptor or a backend.
       */
    User: 5,
};
HttpEventType[HttpEventType.Sent] = "Sent";
HttpEventType[HttpEventType.UploadProgress] = "UploadProgress";
HttpEventType[HttpEventType.ResponseHeader] = "ResponseHeader";
HttpEventType[HttpEventType.DownloadProgress] = "DownloadProgress";
HttpEventType[HttpEventType.Response] = "Response";
HttpEventType[HttpEventType.User] = "User";
/**
 * Base interface for progress events.
 *
 * \@stable
 * @record
 */

/**
 * A download progress event.
 *
 * \@stable
 * @record
 */

/**
 * An upload progress event.
 *
 * \@stable
 * @record
 */

/**
 * An event indicating that the request was sent to the server. Useful
 * when a request may be retried multiple times, to distinguish between
 * retries on the final event stream.
 *
 * \@stable
 * @record
 */

/**
 * A user-defined event.
 *
 * Grouping all custom events under this type ensures they will be handled
 * and forwarded by all implementations of interceptors.
 *
 * \@stable
 * @record
 * @template T
 */

/**
 * An error that represents a failed attempt to JSON.parse text coming back
 * from the server.
 *
 * It bundles the Error object with the actual response body that failed to parse.
 *
 * \@stable
 * @record
 */

/**
 * Base class for both `HttpResponse` and `HttpHeaderResponse`.
 *
 * \@stable
 * @abstract
 */
var HttpResponseBase = /** @class */ (function () {
    /**
     * Super-constructor for all responses.
     *
     * The single parameter accepted is an initialization hash. Any properties
     * of the response passed there will override the default values.
     */
    function HttpResponseBase(init, defaultStatus, defaultStatusText) {
        if (defaultStatus === void 0) { defaultStatus = 200; }
        if (defaultStatusText === void 0) { defaultStatusText = 'OK'; }
        // If the hash has values passed, use them to initialize the response.
        // Otherwise use the default values.
        this.headers = init.headers || new HttpHeaders();
        this.status = init.status !== undefined ? init.status : defaultStatus;
        this.statusText = init.statusText || defaultStatusText;
        this.url = init.url || null;
        // Cache the ok value to avoid defining a getter.
        this.ok = this.status >= 200 && this.status < 300;
    }
    return HttpResponseBase;
}());
/**
 * A partial HTTP response which only includes the status and header data,
 * but no response body.
 *
 * `HttpHeaderResponse` is a `HttpEvent` available on the response
 * event stream, only when progress events are requested.
 *
 * \@stable
 */
var HttpHeaderResponse = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_5_tslib__["d" /* __extends */])(HttpHeaderResponse, _super);
    /**
     * Create a new `HttpHeaderResponse` with the given parameters.
     */
    function HttpHeaderResponse(init) {
        if (init === void 0) { init = {}; }
        var _this = _super.call(this, init) || this;
        _this.type = HttpEventType.ResponseHeader;
        return _this;
    }
    /**
     * Copy this `HttpHeaderResponse`, overriding its contents with the
     * given parameter hash.
     */
    /**
     * Copy this `HttpHeaderResponse`, overriding its contents with the
     * given parameter hash.
     * @param {?=} update
     * @return {?}
     */
    HttpHeaderResponse.prototype.clone = /**
     * Copy this `HttpHeaderResponse`, overriding its contents with the
     * given parameter hash.
     * @param {?=} update
     * @return {?}
     */
    function (update) {
        if (update === void 0) { update = {}; }
        // Perform a straightforward initialization of the new HttpHeaderResponse,
        // overriding the current parameters with new ones if given.
        return new HttpHeaderResponse({
            headers: update.headers || this.headers,
            status: update.status !== undefined ? update.status : this.status,
            statusText: update.statusText || this.statusText,
            url: update.url || this.url || undefined,
        });
    };
    return HttpHeaderResponse;
}(HttpResponseBase));
/**
 * A full HTTP response, including a typed response body (which may be `null`
 * if one was not returned).
 *
 * `HttpResponse` is a `HttpEvent` available on the response event
 * stream.
 *
 * \@stable
 * @template T
 */
var HttpResponse = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_5_tslib__["d" /* __extends */])(HttpResponse, _super);
    /**
     * Construct a new `HttpResponse`.
     */
    function HttpResponse(init) {
        if (init === void 0) { init = {}; }
        var _this = _super.call(this, init) || this;
        _this.type = HttpEventType.Response;
        _this.body = init.body !== undefined ? init.body : null;
        return _this;
    }
    /**
     * @param {?=} update
     * @return {?}
     */
    HttpResponse.prototype.clone = /**
     * @param {?=} update
     * @return {?}
     */
    function (update) {
        if (update === void 0) { update = {}; }
        return new HttpResponse({
            body: (update.body !== undefined) ? update.body : this.body,
            headers: update.headers || this.headers,
            status: (update.status !== undefined) ? update.status : this.status,
            statusText: update.statusText || this.statusText,
            url: update.url || this.url || undefined,
        });
    };
    return HttpResponse;
}(HttpResponseBase));
/**
 * A response that represents an error or failure, either from a
 * non-successful HTTP status, an error while executing the request,
 * or some other failure which occurred during the parsing of the response.
 *
 * Any error returned on the `Observable` response stream will be
 * wrapped in an `HttpErrorResponse` to provide additional context about
 * the state of the HTTP layer when the error occurred. The error property
 * will contain either a wrapped Error object or the error response returned
 * from the server.
 *
 * \@stable
 */
var HttpErrorResponse = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_5_tslib__["d" /* __extends */])(HttpErrorResponse, _super);
    function HttpErrorResponse(init) {
        var _this = 
        // Initialize with a default status of 0 / Unknown Error.
        _super.call(this, init, 0, 'Unknown Error') || this;
        _this.name = 'HttpErrorResponse';
        /**
         * Errors are never okay, even when the status code is in the 2xx success range.
         */
        _this.ok = false;
        // If the response was successful, then this was a parse error. Otherwise, it was
        // a protocol-level failure of some sort. Either the request failed in transit
        // or the server returned an unsuccessful status code.
        if (_this.status >= 200 && _this.status < 300) {
            _this.message = "Http failure during parsing for " + (init.url || '(unknown url)');
        }
        else {
            _this.message =
                "Http failure response for " + (init.url || '(unknown url)') + ": " + init.status + " " + init.statusText;
        }
        _this.error = init.error || null;
        return _this;
    }
    return HttpErrorResponse;
}(HttpResponseBase));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Construct an instance of `HttpRequestOptions<T>` from a source `HttpMethodOptions` and
 * the given `body`. Basically, this clones the object and adds the body.
 * @template T
 * @param {?} options
 * @param {?} body
 * @return {?}
 */
function addBody(options, body) {
    return {
        body: body,
        headers: options.headers,
        observe: options.observe,
        params: options.params,
        reportProgress: options.reportProgress,
        responseType: options.responseType,
        withCredentials: options.withCredentials,
    };
}
/**
 * Perform HTTP requests.
 *
 * `HttpClient` is available as an injectable class, with methods to perform HTTP requests.
 * Each request method has multiple signatures, and the return type varies according to which
 * signature is called (mainly the values of `observe` and `responseType`).
 *
 * \@stable
 */
var HttpClient = /** @class */ (function () {
    function HttpClient(handler) {
        this.handler = handler;
    }
    /**
     * Constructs an `Observable` for a particular HTTP request that, when subscribed,
     * fires the request through the chain of registered interceptors and on to the
     * server.
     *
     * This method can be called in one of two ways. Either an `HttpRequest`
     * instance can be passed directly as the only parameter, or a method can be
     * passed as the first parameter, a string URL as the second, and an
     * options hash as the third.
     *
     * If a `HttpRequest` object is passed directly, an `Observable` of the
     * raw `HttpEvent` stream will be returned.
     *
     * If a request is instead built by providing a URL, the options object
     * determines the return type of `request()`. In addition to configuring
     * request parameters such as the outgoing headers and/or the body, the options
     * hash specifies two key pieces of information about the request: the
     * `responseType` and what to `observe`.
     *
     * The `responseType` value determines how a successful response body will be
     * parsed. If `responseType` is the default `json`, a type interface for the
     * resulting object may be passed as a type parameter to `request()`.
     *
     * The `observe` value determines the return type of `request()`, based on what
     * the consumer is interested in observing. A value of `events` will return an
     * `Observable<HttpEvent>` representing the raw `HttpEvent` stream,
     * including progress events by default. A value of `response` will return an
     * `Observable<HttpResponse<T>>` where the `T` parameter of `HttpResponse`
     * depends on the `responseType` and any optionally provided type parameter.
     * A value of `body` will return an `Observable<T>` with the same `T` body type.
     */
    /**
     * Constructs an `Observable` for a particular HTTP request that, when subscribed,
     * fires the request through the chain of registered interceptors and on to the
     * server.
     *
     * This method can be called in one of two ways. Either an `HttpRequest`
     * instance can be passed directly as the only parameter, or a method can be
     * passed as the first parameter, a string URL as the second, and an
     * options hash as the third.
     *
     * If a `HttpRequest` object is passed directly, an `Observable` of the
     * raw `HttpEvent` stream will be returned.
     *
     * If a request is instead built by providing a URL, the options object
     * determines the return type of `request()`. In addition to configuring
     * request parameters such as the outgoing headers and/or the body, the options
     * hash specifies two key pieces of information about the request: the
     * `responseType` and what to `observe`.
     *
     * The `responseType` value determines how a successful response body will be
     * parsed. If `responseType` is the default `json`, a type interface for the
     * resulting object may be passed as a type parameter to `request()`.
     *
     * The `observe` value determines the return type of `request()`, based on what
     * the consumer is interested in observing. A value of `events` will return an
     * `Observable<HttpEvent>` representing the raw `HttpEvent` stream,
     * including progress events by default. A value of `response` will return an
     * `Observable<HttpResponse<T>>` where the `T` parameter of `HttpResponse`
     * depends on the `responseType` and any optionally provided type parameter.
     * A value of `body` will return an `Observable<T>` with the same `T` body type.
     * @param {?} first
     * @param {?=} url
     * @param {?=} options
     * @return {?}
     */
    HttpClient.prototype.request = /**
     * Constructs an `Observable` for a particular HTTP request that, when subscribed,
     * fires the request through the chain of registered interceptors and on to the
     * server.
     *
     * This method can be called in one of two ways. Either an `HttpRequest`
     * instance can be passed directly as the only parameter, or a method can be
     * passed as the first parameter, a string URL as the second, and an
     * options hash as the third.
     *
     * If a `HttpRequest` object is passed directly, an `Observable` of the
     * raw `HttpEvent` stream will be returned.
     *
     * If a request is instead built by providing a URL, the options object
     * determines the return type of `request()`. In addition to configuring
     * request parameters such as the outgoing headers and/or the body, the options
     * hash specifies two key pieces of information about the request: the
     * `responseType` and what to `observe`.
     *
     * The `responseType` value determines how a successful response body will be
     * parsed. If `responseType` is the default `json`, a type interface for the
     * resulting object may be passed as a type parameter to `request()`.
     *
     * The `observe` value determines the return type of `request()`, based on what
     * the consumer is interested in observing. A value of `events` will return an
     * `Observable<HttpEvent>` representing the raw `HttpEvent` stream,
     * including progress events by default. A value of `response` will return an
     * `Observable<HttpResponse<T>>` where the `T` parameter of `HttpResponse`
     * depends on the `responseType` and any optionally provided type parameter.
     * A value of `body` will return an `Observable<T>` with the same `T` body type.
     * @param {?} first
     * @param {?=} url
     * @param {?=} options
     * @return {?}
     */
    function (first, url, options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        var /** @type {?} */ req;
        // Firstly, check whether the primary argument is an instance of `HttpRequest`.
        if (first instanceof HttpRequest) {
            // It is. The other arguments must be undefined (per the signatures) and can be
            // ignored.
            req = /** @type {?} */ (first);
        }
        else {
            // It's a string, so it represents a URL. Construct a request based on it,
            // and incorporate the remaining arguments (assuming GET unless a method is
            // provided.
            // Figure out the headers.
            var /** @type {?} */ headers = undefined;
            if (options.headers instanceof HttpHeaders) {
                headers = options.headers;
            }
            else {
                headers = new HttpHeaders(options.headers);
            }
            // Sort out parameters.
            var /** @type {?} */ params = undefined;
            if (!!options.params) {
                if (options.params instanceof HttpParams) {
                    params = options.params;
                }
                else {
                    params = new HttpParams({ fromObject: options.params });
                }
            }
            // Construct the request.
            req = new HttpRequest(first, /** @type {?} */ ((url)), (options.body !== undefined ? options.body : null), {
                headers: headers,
                params: params,
                reportProgress: options.reportProgress,
                // By default, JSON is assumed to be returned for all calls.
                responseType: options.responseType || 'json',
                withCredentials: options.withCredentials,
            });
        }
        // Start with an Observable.of() the initial request, and run the handler (which
        // includes all interceptors) inside a concatMap(). This way, the handler runs
        // inside an Observable chain, which causes interceptors to be re-run on every
        // subscription (this also makes retries re-run the handler, including interceptors).
        var /** @type {?} */ events$ = __WEBPACK_IMPORTED_MODULE_2_rxjs_operator_concatMap__["concatMap"].call(Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_observable_of__["of"])(req), function (req) { return _this.handler.handle(req); });
        // If coming via the API signature which accepts a previously constructed HttpRequest,
        // the only option is to get the event stream. Otherwise, return the event stream if
        // that is what was requested.
        if (first instanceof HttpRequest || options.observe === 'events') {
            return events$;
        }
        // The requested stream contains either the full response or the body. In either
        // case, the first step is to filter the event stream to extract a stream of
        // responses(s).
        var /** @type {?} */ res$ = __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_filter__["filter"].call(events$, function (event) { return event instanceof HttpResponse; });
        // Decide which stream to return.
        switch (options.observe || 'body') {
            case 'body':
                // The requested stream is the body. Map the response stream to the response
                // body. This could be done more simply, but a misbehaving interceptor might
                // transform the response body into a different format and ignore the requested
                // responseType. Guard against this by validating that the response is of the
                // requested type.
                switch (req.responseType) {
                    case 'arraybuffer':
                        return __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_map__["map"].call(res$, function (res) {
                            // Validate that the body is an ArrayBuffer.
                            if (res.body !== null && !(res.body instanceof ArrayBuffer)) {
                                throw new Error('Response is not an ArrayBuffer.');
                            }
                            return res.body;
                        });
                    case 'blob':
                        return __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_map__["map"].call(res$, function (res) {
                            // Validate that the body is a Blob.
                            if (res.body !== null && !(res.body instanceof Blob)) {
                                throw new Error('Response is not a Blob.');
                            }
                            return res.body;
                        });
                    case 'text':
                        return __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_map__["map"].call(res$, function (res) {
                            // Validate that the body is a string.
                            if (res.body !== null && typeof res.body !== 'string') {
                                throw new Error('Response is not a string.');
                            }
                            return res.body;
                        });
                    case 'json':
                    default:
                        // No validation needed for JSON responses, as they can be of any type.
                        return __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_map__["map"].call(res$, function (res) { return res.body; });
                }
            case 'response':
                // The response stream was requested directly, so return it.
                return res$;
            default:
                // Guard against new future observe types being added.
                throw new Error("Unreachable: unhandled observe type " + options.observe + "}");
        }
    };
    /**
     * Constructs an `Observable` which, when subscribed, will cause the configured
     * DELETE request to be executed on the server. See the individual overloads for
     * details of `delete()`'s return type based on the provided options.
     */
    /**
     * Constructs an `Observable` which, when subscribed, will cause the configured
     * DELETE request to be executed on the server. See the individual overloads for
     * details of `delete()`'s return type based on the provided options.
     * @param {?} url
     * @param {?=} options
     * @return {?}
     */
    HttpClient.prototype.delete = /**
     * Constructs an `Observable` which, when subscribed, will cause the configured
     * DELETE request to be executed on the server. See the individual overloads for
     * details of `delete()`'s return type based on the provided options.
     * @param {?} url
     * @param {?=} options
     * @return {?}
     */
    function (url, options) {
        if (options === void 0) { options = {}; }
        return this.request('DELETE', url, /** @type {?} */ (options));
    };
    /**
     * Constructs an `Observable` which, when subscribed, will cause the configured
     * GET request to be executed on the server. See the individual overloads for
     * details of `get()`'s return type based on the provided options.
     */
    /**
     * Constructs an `Observable` which, when subscribed, will cause the configured
     * GET request to be executed on the server. See the individual overloads for
     * details of `get()`'s return type based on the provided options.
     * @param {?} url
     * @param {?=} options
     * @return {?}
     */
    HttpClient.prototype.get = /**
     * Constructs an `Observable` which, when subscribed, will cause the configured
     * GET request to be executed on the server. See the individual overloads for
     * details of `get()`'s return type based on the provided options.
     * @param {?} url
     * @param {?=} options
     * @return {?}
     */
    function (url, options) {
        if (options === void 0) { options = {}; }
        return this.request('GET', url, /** @type {?} */ (options));
    };
    /**
     * Constructs an `Observable` which, when subscribed, will cause the configured
     * HEAD request to be executed on the server. See the individual overloads for
     * details of `head()`'s return type based on the provided options.
     */
    /**
     * Constructs an `Observable` which, when subscribed, will cause the configured
     * HEAD request to be executed on the server. See the individual overloads for
     * details of `head()`'s return type based on the provided options.
     * @param {?} url
     * @param {?=} options
     * @return {?}
     */
    HttpClient.prototype.head = /**
     * Constructs an `Observable` which, when subscribed, will cause the configured
     * HEAD request to be executed on the server. See the individual overloads for
     * details of `head()`'s return type based on the provided options.
     * @param {?} url
     * @param {?=} options
     * @return {?}
     */
    function (url, options) {
        if (options === void 0) { options = {}; }
        return this.request('HEAD', url, /** @type {?} */ (options));
    };
    /**
     * Constructs an `Observable` which, when subscribed, will cause a request
     * with the special method `JSONP` to be dispatched via the interceptor pipeline.
     *
     * A suitable interceptor must be installed (e.g. via the `HttpClientJsonpModule`).
     * If no such interceptor is reached, then the `JSONP` request will likely be
     * rejected by the configured backend.
     */
    /**
     * Constructs an `Observable` which, when subscribed, will cause a request
     * with the special method `JSONP` to be dispatched via the interceptor pipeline.
     *
     * A suitable interceptor must be installed (e.g. via the `HttpClientJsonpModule`).
     * If no such interceptor is reached, then the `JSONP` request will likely be
     * rejected by the configured backend.
     * @template T
     * @param {?} url
     * @param {?} callbackParam
     * @return {?}
     */
    HttpClient.prototype.jsonp = /**
     * Constructs an `Observable` which, when subscribed, will cause a request
     * with the special method `JSONP` to be dispatched via the interceptor pipeline.
     *
     * A suitable interceptor must be installed (e.g. via the `HttpClientJsonpModule`).
     * If no such interceptor is reached, then the `JSONP` request will likely be
     * rejected by the configured backend.
     * @template T
     * @param {?} url
     * @param {?} callbackParam
     * @return {?}
     */
    function (url, callbackParam) {
        return this.request('JSONP', url, {
            params: new HttpParams().append(callbackParam, 'JSONP_CALLBACK'),
            observe: 'body',
            responseType: 'json',
        });
    };
    /**
     * Constructs an `Observable` which, when subscribed, will cause the configured
     * OPTIONS request to be executed on the server. See the individual overloads for
     * details of `options()`'s return type based on the provided options.
     */
    /**
     * Constructs an `Observable` which, when subscribed, will cause the configured
     * OPTIONS request to be executed on the server. See the individual overloads for
     * details of `options()`'s return type based on the provided options.
     * @param {?} url
     * @param {?=} options
     * @return {?}
     */
    HttpClient.prototype.options = /**
     * Constructs an `Observable` which, when subscribed, will cause the configured
     * OPTIONS request to be executed on the server. See the individual overloads for
     * details of `options()`'s return type based on the provided options.
     * @param {?} url
     * @param {?=} options
     * @return {?}
     */
    function (url, options) {
        if (options === void 0) { options = {}; }
        return this.request('OPTIONS', url, /** @type {?} */ (options));
    };
    /**
     * Constructs an `Observable` which, when subscribed, will cause the configured
     * PATCH request to be executed on the server. See the individual overloads for
     * details of `patch()`'s return type based on the provided options.
     */
    /**
     * Constructs an `Observable` which, when subscribed, will cause the configured
     * PATCH request to be executed on the server. See the individual overloads for
     * details of `patch()`'s return type based on the provided options.
     * @param {?} url
     * @param {?} body
     * @param {?=} options
     * @return {?}
     */
    HttpClient.prototype.patch = /**
     * Constructs an `Observable` which, when subscribed, will cause the configured
     * PATCH request to be executed on the server. See the individual overloads for
     * details of `patch()`'s return type based on the provided options.
     * @param {?} url
     * @param {?} body
     * @param {?=} options
     * @return {?}
     */
    function (url, body, options) {
        if (options === void 0) { options = {}; }
        return this.request('PATCH', url, addBody(options, body));
    };
    /**
     * Constructs an `Observable` which, when subscribed, will cause the configured
     * POST request to be executed on the server. See the individual overloads for
     * details of `post()`'s return type based on the provided options.
     */
    /**
     * Constructs an `Observable` which, when subscribed, will cause the configured
     * POST request to be executed on the server. See the individual overloads for
     * details of `post()`'s return type based on the provided options.
     * @param {?} url
     * @param {?} body
     * @param {?=} options
     * @return {?}
     */
    HttpClient.prototype.post = /**
     * Constructs an `Observable` which, when subscribed, will cause the configured
     * POST request to be executed on the server. See the individual overloads for
     * details of `post()`'s return type based on the provided options.
     * @param {?} url
     * @param {?} body
     * @param {?=} options
     * @return {?}
     */
    function (url, body, options) {
        if (options === void 0) { options = {}; }
        return this.request('POST', url, addBody(options, body));
    };
    /**
     * Constructs an `Observable` which, when subscribed, will cause the configured
     * POST request to be executed on the server. See the individual overloads for
     * details of `post()`'s return type based on the provided options.
     */
    /**
     * Constructs an `Observable` which, when subscribed, will cause the configured
     * POST request to be executed on the server. See the individual overloads for
     * details of `post()`'s return type based on the provided options.
     * @param {?} url
     * @param {?} body
     * @param {?=} options
     * @return {?}
     */
    HttpClient.prototype.put = /**
     * Constructs an `Observable` which, when subscribed, will cause the configured
     * POST request to be executed on the server. See the individual overloads for
     * details of `post()`'s return type based on the provided options.
     * @param {?} url
     * @param {?} body
     * @param {?=} options
     * @return {?}
     */
    function (url, body, options) {
        if (options === void 0) { options = {}; }
        return this.request('PUT', url, addBody(options, body));
    };
    HttpClient.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    HttpClient.ctorParameters = function () { return [
        { type: HttpHandler, },
    ]; };
    return HttpClient;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Intercepts `HttpRequest` and handles them.
 *
 * Most interceptors will transform the outgoing request before passing it to the
 * next interceptor in the chain, by calling `next.handle(transformedReq)`.
 *
 * In rare cases, interceptors may wish to completely handle a request themselves,
 * and not delegate to the remainder of the chain. This behavior is allowed.
 *
 * \@stable
 * @record
 */

/**
 * `HttpHandler` which applies an `HttpInterceptor` to an `HttpRequest`.
 *
 * \@stable
 */
var HttpInterceptorHandler = /** @class */ (function () {
    function HttpInterceptorHandler(next, interceptor) {
        this.next = next;
        this.interceptor = interceptor;
    }
    /**
     * @param {?} req
     * @return {?}
     */
    HttpInterceptorHandler.prototype.handle = /**
     * @param {?} req
     * @return {?}
     */
    function (req) {
        return this.interceptor.intercept(req, this.next);
    };
    return HttpInterceptorHandler;
}());
/**
 * A multi-provider token which represents the array of `HttpInterceptor`s that
 * are registered.
 *
 * \@stable
 */
var HTTP_INTERCEPTORS = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["InjectionToken"]('HTTP_INTERCEPTORS');
var NoopInterceptor = /** @class */ (function () {
    function NoopInterceptor() {
    }
    /**
     * @param {?} req
     * @param {?} next
     * @return {?}
     */
    NoopInterceptor.prototype.intercept = /**
     * @param {?} req
     * @param {?} next
     * @return {?}
     */
    function (req, next) {
        return next.handle(req);
    };
    NoopInterceptor.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    NoopInterceptor.ctorParameters = function () { return []; };
    return NoopInterceptor;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
// Every request made through JSONP needs a callback name that's unique across the
// whole page. Each request is assigned an id and the callback name is constructed
// from that. The next id to be assigned is tracked in a global variable here that
// is shared among all applications on the page.
var nextRequestId = 0;
// Error text given when a JSONP script is injected, but doesn't invoke the callback
// passed in its URL.
var JSONP_ERR_NO_CALLBACK = 'JSONP injected script did not invoke callback.';
// Error text given when a request is passed to the JsonpClientBackend that doesn't
// have a request method JSONP.
var JSONP_ERR_WRONG_METHOD = 'JSONP requests must use JSONP request method.';
var JSONP_ERR_WRONG_RESPONSE_TYPE = 'JSONP requests must use Json response type.';
/**
 * DI token/abstract type representing a map of JSONP callbacks.
 *
 * In the browser, this should always be the `window` object.
 *
 * \@stable
 * @abstract
 */
var JsonpCallbackContext = /** @class */ (function () {
    function JsonpCallbackContext() {
    }
    return JsonpCallbackContext;
}());
/**
 * `HttpBackend` that only processes `HttpRequest` with the JSONP method,
 * by performing JSONP style requests.
 *
 * \@stable
 */
var JsonpClientBackend = /** @class */ (function () {
    function JsonpClientBackend(callbackMap, document) {
        this.callbackMap = callbackMap;
        this.document = document;
    }
    /**
     * Get the name of the next callback method, by incrementing the global `nextRequestId`.
     * @return {?}
     */
    JsonpClientBackend.prototype.nextCallback = /**
     * Get the name of the next callback method, by incrementing the global `nextRequestId`.
     * @return {?}
     */
    function () { return "ng_jsonp_callback_" + nextRequestId++; };
    /**
     * Process a JSONP request and return an event stream of the results.
     */
    /**
     * Process a JSONP request and return an event stream of the results.
     * @param {?} req
     * @return {?}
     */
    JsonpClientBackend.prototype.handle = /**
     * Process a JSONP request and return an event stream of the results.
     * @param {?} req
     * @return {?}
     */
    function (req) {
        var _this = this;
        // Firstly, check both the method and response type. If either doesn't match
        // then the request was improperly routed here and cannot be handled.
        if (req.method !== 'JSONP') {
            throw new Error(JSONP_ERR_WRONG_METHOD);
        }
        else if (req.responseType !== 'json') {
            throw new Error(JSONP_ERR_WRONG_RESPONSE_TYPE);
        }
        // Everything else happens inside the Observable boundary.
        return new __WEBPACK_IMPORTED_MODULE_7_rxjs_Observable__["Observable"](function (observer) {
            // The first step to make a request is to generate the callback name, and replace the
            // callback placeholder in the URL with the name. Care has to be taken here to ensure
            // a trailing &, if matched, gets inserted back into the URL in the correct place.
            var /** @type {?} */ callback = _this.nextCallback();
            var /** @type {?} */ url = req.urlWithParams.replace(/=JSONP_CALLBACK(&|$)/, "=" + callback + "$1");
            // Construct the <script> tag and point it at the URL.
            var /** @type {?} */ node = _this.document.createElement('script');
            node.src = url;
            // A JSONP request requires waiting for multiple callbacks. These variables
            // are closed over and track state across those callbacks.
            // The response object, if one has been received, or null otherwise.
            var /** @type {?} */ body = null;
            // Whether the response callback has been called.
            var /** @type {?} */ finished = false;
            // Whether the request has been cancelled (and thus any other callbacks)
            // should be ignored.
            var /** @type {?} */ cancelled = false;
            // Set the response callback in this.callbackMap (which will be the window
            // object in the browser. The script being loaded via the <script> tag will
            // eventually call this callback.
            // Set the response callback in this.callbackMap (which will be the window
            // object in the browser. The script being loaded via the <script> tag will
            // eventually call this callback.
            _this.callbackMap[callback] = function (data) {
                // Data has been received from the JSONP script. Firstly, delete this callback.
                delete _this.callbackMap[callback];
                // Next, make sure the request wasn't cancelled in the meantime.
                if (cancelled) {
                    return;
                }
                // Set state to indicate data was received.
                body = data;
                finished = true;
            };
            // cleanup() is a utility closure that removes the <script> from the page and
            // the response callback from the window. This logic is used in both the
            // success, error, and cancellation paths, so it's extracted out for convenience.
            var /** @type {?} */ cleanup = function () {
                // Remove the <script> tag if it's still on the page.
                if (node.parentNode) {
                    node.parentNode.removeChild(node);
                }
                // Remove the response callback from the callbackMap (window object in the
                // browser).
                delete _this.callbackMap[callback];
            };
            // onLoad() is the success callback which runs after the response callback
            // if the JSONP script loads successfully. The event itself is unimportant.
            // If something went wrong, onLoad() may run without the response callback
            // having been invoked.
            var /** @type {?} */ onLoad = function (event) {
                // Do nothing if the request has been cancelled.
                if (cancelled) {
                    return;
                }
                // Cleanup the page.
                cleanup();
                // Check whether the response callback has run.
                if (!finished) {
                    // It hasn't, something went wrong with the request. Return an error via
                    // the Observable error path. All JSONP errors have status 0.
                    observer.error(new HttpErrorResponse({
                        url: url,
                        status: 0,
                        statusText: 'JSONP Error',
                        error: new Error(JSONP_ERR_NO_CALLBACK),
                    }));
                    return;
                }
                // Success. body either contains the response body or null if none was
                // returned.
                observer.next(new HttpResponse({
                    body: body,
                    status: 200,
                    statusText: 'OK', url: url,
                }));
                // Complete the stream, the response is over.
                observer.complete();
            };
            // onError() is the error callback, which runs if the script returned generates
            // a Javascript error. It emits the error via the Observable error channel as
            // a HttpErrorResponse.
            var /** @type {?} */ onError = function (error) {
                // If the request was already cancelled, no need to emit anything.
                if (cancelled) {
                    return;
                }
                cleanup();
                // Wrap the error in a HttpErrorResponse.
                observer.error(new HttpErrorResponse({
                    error: error,
                    status: 0,
                    statusText: 'JSONP Error', url: url,
                }));
            };
            // Subscribe to both the success (load) and error events on the <script> tag,
            // and add it to the page.
            node.addEventListener('load', onLoad);
            node.addEventListener('error', onError);
            _this.document.body.appendChild(node);
            // The request has now been successfully sent.
            observer.next({ type: HttpEventType.Sent });
            // Cancellation handler.
            return function () {
                // Track the cancellation so event listeners won't do anything even if already scheduled.
                cancelled = true;
                // Remove the event listeners so they won't run if the events later fire.
                node.removeEventListener('load', onLoad);
                node.removeEventListener('error', onError);
                // And finally, clean up the page.
                cleanup();
            };
        });
    };
    JsonpClientBackend.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    JsonpClientBackend.ctorParameters = function () { return [
        { type: JsonpCallbackContext, },
        { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_6__angular_common__["DOCUMENT"],] },] },
    ]; };
    return JsonpClientBackend;
}());
/**
 * An `HttpInterceptor` which identifies requests with the method JSONP and
 * shifts them to the `JsonpClientBackend`.
 *
 * \@stable
 */
var JsonpInterceptor = /** @class */ (function () {
    function JsonpInterceptor(jsonp) {
        this.jsonp = jsonp;
    }
    /**
     * @param {?} req
     * @param {?} next
     * @return {?}
     */
    JsonpInterceptor.prototype.intercept = /**
     * @param {?} req
     * @param {?} next
     * @return {?}
     */
    function (req, next) {
        if (req.method === 'JSONP') {
            return this.jsonp.handle(/** @type {?} */ (req));
        }
        // Fall through for normal HTTP requests.
        return next.handle(req);
    };
    JsonpInterceptor.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    JsonpInterceptor.ctorParameters = function () { return [
        { type: JsonpClientBackend, },
    ]; };
    return JsonpInterceptor;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var XSSI_PREFIX = /^\)\]\}',?\n/;
/**
 * Determine an appropriate URL for the response, by checking either
 * XMLHttpRequest.responseURL or the X-Request-URL header.
 * @param {?} xhr
 * @return {?}
 */
function getResponseUrl(xhr) {
    if ('responseURL' in xhr && xhr.responseURL) {
        return xhr.responseURL;
    }
    if (/^X-Request-URL:/m.test(xhr.getAllResponseHeaders())) {
        return xhr.getResponseHeader('X-Request-URL');
    }
    return null;
}
/**
 * A wrapper around the `XMLHttpRequest` constructor.
 *
 * \@stable
 * @abstract
 */
var XhrFactory = /** @class */ (function () {
    function XhrFactory() {
    }
    return XhrFactory;
}());
/**
 * A factory for \@{link HttpXhrBackend} that uses the `XMLHttpRequest` browser API.
 *
 * \@stable
 */
var BrowserXhr = /** @class */ (function () {
    function BrowserXhr() {
    }
    /**
     * @return {?}
     */
    BrowserXhr.prototype.build = /**
     * @return {?}
     */
    function () { return /** @type {?} */ ((new XMLHttpRequest())); };
    BrowserXhr.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    BrowserXhr.ctorParameters = function () { return []; };
    return BrowserXhr;
}());
/**
 * An `HttpBackend` which uses the XMLHttpRequest API to send
 * requests to a backend server.
 *
 * \@stable
 */
var HttpXhrBackend = /** @class */ (function () {
    function HttpXhrBackend(xhrFactory) {
        this.xhrFactory = xhrFactory;
    }
    /**
     * Process a request and return a stream of response events.
     */
    /**
     * Process a request and return a stream of response events.
     * @param {?} req
     * @return {?}
     */
    HttpXhrBackend.prototype.handle = /**
     * Process a request and return a stream of response events.
     * @param {?} req
     * @return {?}
     */
    function (req) {
        var _this = this;
        // Quick check to give a better error message when a user attempts to use
        // HttpClient.jsonp() without installing the JsonpClientModule
        if (req.method === 'JSONP') {
            throw new Error("Attempted to construct Jsonp request without JsonpClientModule installed.");
        }
        // Everything happens on Observable subscription.
        return new __WEBPACK_IMPORTED_MODULE_7_rxjs_Observable__["Observable"](function (observer) {
            // Start by setting up the XHR object with request method, URL, and withCredentials flag.
            var /** @type {?} */ xhr = _this.xhrFactory.build();
            xhr.open(req.method, req.urlWithParams);
            if (!!req.withCredentials) {
                xhr.withCredentials = true;
            }
            // Add all the requested headers.
            req.headers.forEach(function (name, values) { return xhr.setRequestHeader(name, values.join(',')); });
            // Add an Accept header if one isn't present already.
            if (!req.headers.has('Accept')) {
                xhr.setRequestHeader('Accept', 'application/json, text/plain, */*');
            }
            // Auto-detect the Content-Type header if one isn't present already.
            if (!req.headers.has('Content-Type')) {
                var /** @type {?} */ detectedType = req.detectContentTypeHeader();
                // Sometimes Content-Type detection fails.
                if (detectedType !== null) {
                    xhr.setRequestHeader('Content-Type', detectedType);
                }
            }
            // Set the responseType if one was requested.
            if (req.responseType) {
                var /** @type {?} */ responseType = req.responseType.toLowerCase();
                // JSON responses need to be processed as text. This is because if the server
                // returns an XSSI-prefixed JSON response, the browser will fail to parse it,
                // xhr.response will be null, and xhr.responseText cannot be accessed to
                // retrieve the prefixed JSON data in order to strip the prefix. Thus, all JSON
                // is parsed by first requesting text and then applying JSON.parse.
                xhr.responseType = /** @type {?} */ (((responseType !== 'json') ? responseType : 'text'));
            }
            // Serialize the request body if one is present. If not, this will be set to null.
            var /** @type {?} */ reqBody = req.serializeBody();
            // If progress events are enabled, response headers will be delivered
            // in two events - the HttpHeaderResponse event and the full HttpResponse
            // event. However, since response headers don't change in between these
            // two events, it doesn't make sense to parse them twice. So headerResponse
            // caches the data extracted from the response whenever it's first parsed,
            // to ensure parsing isn't duplicated.
            var /** @type {?} */ headerResponse = null;
            // partialFromXhr extracts the HttpHeaderResponse from the current XMLHttpRequest
            // state, and memoizes it into headerResponse.
            var /** @type {?} */ partialFromXhr = function () {
                if (headerResponse !== null) {
                    return headerResponse;
                }
                // Read status and normalize an IE9 bug (http://bugs.jquery.com/ticket/1450).
                var /** @type {?} */ status = xhr.status === 1223 ? 204 : xhr.status;
                var /** @type {?} */ statusText = xhr.statusText || 'OK';
                // Parse headers from XMLHttpRequest - this step is lazy.
                var /** @type {?} */ headers = new HttpHeaders(xhr.getAllResponseHeaders());
                // Read the response URL from the XMLHttpResponse instance and fall back on the
                // request URL.
                var /** @type {?} */ url = getResponseUrl(xhr) || req.url;
                // Construct the HttpHeaderResponse and memoize it.
                headerResponse = new HttpHeaderResponse({ headers: headers, status: status, statusText: statusText, url: url });
                return headerResponse;
            };
            // Next, a few closures are defined for the various events which XMLHttpRequest can
            // emit. This allows them to be unregistered as event listeners later.
            // First up is the load event, which represents a response being fully available.
            var /** @type {?} */ onLoad = function () {
                // Read response state from the memoized partial data.
                var _a = partialFromXhr(), headers = _a.headers, status = _a.status, statusText = _a.statusText, url = _a.url;
                // The body will be read out if present.
                var /** @type {?} */ body = null;
                if (status !== 204) {
                    // Use XMLHttpRequest.response if set, responseText otherwise.
                    body = (typeof xhr.response === 'undefined') ? xhr.responseText : xhr.response;
                }
                // Normalize another potential bug (this one comes from CORS).
                if (status === 0) {
                    status = !!body ? 200 : 0;
                }
                // ok determines whether the response will be transmitted on the event or
                // error channel. Unsuccessful status codes (not 2xx) will always be errors,
                // but a successful status code can still result in an error if the user
                // asked for JSON data and the body cannot be parsed as such.
                var /** @type {?} */ ok = status >= 200 && status < 300;
                // Check whether the body needs to be parsed as JSON (in many cases the browser
                // will have done that already).
                if (req.responseType === 'json' && typeof body === 'string') {
                    // Save the original body, before attempting XSSI prefix stripping.
                    var /** @type {?} */ originalBody = body;
                    body = body.replace(XSSI_PREFIX, '');
                    try {
                        // Attempt the parse. If it fails, a parse error should be delivered to the user.
                        body = body !== '' ? JSON.parse(body) : null;
                    }
                    catch (/** @type {?} */ error) {
                        // Since the JSON.parse failed, it's reasonable to assume this might not have been a
                        // JSON response. Restore the original body (including any XSSI prefix) to deliver
                        // a better error response.
                        body = originalBody;
                        // If this was an error request to begin with, leave it as a string, it probably
                        // just isn't JSON. Otherwise, deliver the parsing error to the user.
                        if (ok) {
                            // Even though the response status was 2xx, this is still an error.
                            ok = false;
                            // The parse error contains the text of the body that failed to parse.
                            body = /** @type {?} */ ({ error: error, text: body });
                        }
                    }
                }
                if (ok) {
                    // A successful response is delivered on the event stream.
                    observer.next(new HttpResponse({
                        body: body,
                        headers: headers,
                        status: status,
                        statusText: statusText,
                        url: url || undefined,
                    }));
                    // The full body has been received and delivered, no further events
                    // are possible. This request is complete.
                    observer.complete();
                }
                else {
                    // An unsuccessful request is delivered on the error channel.
                    observer.error(new HttpErrorResponse({
                        // The error in this case is the response body (error from the server).
                        error: body,
                        headers: headers,
                        status: status,
                        statusText: statusText,
                        url: url || undefined,
                    }));
                }
            };
            // The onError callback is called when something goes wrong at the network level.
            // Connection timeout, DNS error, offline, etc. These are actual errors, and are
            // transmitted on the error channel.
            var /** @type {?} */ onError = function (error) {
                var /** @type {?} */ res = new HttpErrorResponse({
                    error: error,
                    status: xhr.status || 0,
                    statusText: xhr.statusText || 'Unknown Error',
                });
                observer.error(res);
            };
            // The sentHeaders flag tracks whether the HttpResponseHeaders event
            // has been sent on the stream. This is necessary to track if progress
            // is enabled since the event will be sent on only the first download
            // progerss event.
            var /** @type {?} */ sentHeaders = false;
            // The download progress event handler, which is only registered if
            // progress events are enabled.
            var /** @type {?} */ onDownProgress = function (event) {
                // Send the HttpResponseHeaders event if it hasn't been sent already.
                if (!sentHeaders) {
                    observer.next(partialFromXhr());
                    sentHeaders = true;
                }
                // Start building the download progress event to deliver on the response
                // event stream.
                var /** @type {?} */ progressEvent = {
                    type: HttpEventType.DownloadProgress,
                    loaded: event.loaded,
                };
                // Set the total number of bytes in the event if it's available.
                if (event.lengthComputable) {
                    progressEvent.total = event.total;
                }
                // If the request was for text content and a partial response is
                // available on XMLHttpRequest, include it in the progress event
                // to allow for streaming reads.
                if (req.responseType === 'text' && !!xhr.responseText) {
                    progressEvent.partialText = xhr.responseText;
                }
                // Finally, fire the event.
                observer.next(progressEvent);
            };
            // The upload progress event handler, which is only registered if
            // progress events are enabled.
            var /** @type {?} */ onUpProgress = function (event) {
                // Upload progress events are simpler. Begin building the progress
                // event.
                var /** @type {?} */ progress = {
                    type: HttpEventType.UploadProgress,
                    loaded: event.loaded,
                };
                // If the total number of bytes being uploaded is available, include
                // it.
                if (event.lengthComputable) {
                    progress.total = event.total;
                }
                // Send the event.
                observer.next(progress);
            };
            // By default, register for load and error events.
            xhr.addEventListener('load', onLoad);
            xhr.addEventListener('error', onError);
            // Progress events are only enabled if requested.
            if (req.reportProgress) {
                // Download progress is always enabled if requested.
                xhr.addEventListener('progress', onDownProgress);
                // Upload progress depends on whether there is a body to upload.
                if (reqBody !== null && xhr.upload) {
                    xhr.upload.addEventListener('progress', onUpProgress);
                }
            }
            // Fire the request, and notify the event stream that it was fired.
            xhr.send(reqBody);
            observer.next({ type: HttpEventType.Sent });
            // This is the return from the Observable function, which is the
            // request cancellation handler.
            return function () {
                // On a cancellation, remove all registered event listeners.
                xhr.removeEventListener('error', onError);
                xhr.removeEventListener('load', onLoad);
                if (req.reportProgress) {
                    xhr.removeEventListener('progress', onDownProgress);
                    if (reqBody !== null && xhr.upload) {
                        xhr.upload.removeEventListener('progress', onUpProgress);
                    }
                }
                // Finally, abort the in-flight request.
                xhr.abort();
            };
        });
    };
    HttpXhrBackend.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    HttpXhrBackend.ctorParameters = function () { return [
        { type: XhrFactory, },
    ]; };
    return HttpXhrBackend;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var XSRF_COOKIE_NAME = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["InjectionToken"]('XSRF_COOKIE_NAME');
var XSRF_HEADER_NAME = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["InjectionToken"]('XSRF_HEADER_NAME');
/**
 * Retrieves the current XSRF token to use with the next outgoing request.
 *
 * \@stable
 * @abstract
 */
var HttpXsrfTokenExtractor = /** @class */ (function () {
    function HttpXsrfTokenExtractor() {
    }
    return HttpXsrfTokenExtractor;
}());
/**
 * `HttpXsrfTokenExtractor` which retrieves the token from a cookie.
 */
var HttpXsrfCookieExtractor = /** @class */ (function () {
    function HttpXsrfCookieExtractor(doc, platform, cookieName) {
        this.doc = doc;
        this.platform = platform;
        this.cookieName = cookieName;
        this.lastCookieString = '';
        this.lastToken = null;
        /**
         * \@internal for testing
         */
        this.parseCount = 0;
    }
    /**
     * @return {?}
     */
    HttpXsrfCookieExtractor.prototype.getToken = /**
     * @return {?}
     */
    function () {
        if (this.platform === 'server') {
            return null;
        }
        var /** @type {?} */ cookieString = this.doc.cookie || '';
        if (cookieString !== this.lastCookieString) {
            this.parseCount++;
            this.lastToken = Object(__WEBPACK_IMPORTED_MODULE_6__angular_common__["ɵparseCookieValue"])(cookieString, this.cookieName);
            this.lastCookieString = cookieString;
        }
        return this.lastToken;
    };
    HttpXsrfCookieExtractor.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    HttpXsrfCookieExtractor.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_6__angular_common__["DOCUMENT"],] },] },
        { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_0__angular_core__["PLATFORM_ID"],] },] },
        { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [XSRF_COOKIE_NAME,] },] },
    ]; };
    return HttpXsrfCookieExtractor;
}());
/**
 * `HttpInterceptor` which adds an XSRF token to eligible outgoing requests.
 */
var HttpXsrfInterceptor = /** @class */ (function () {
    function HttpXsrfInterceptor(tokenService, headerName) {
        this.tokenService = tokenService;
        this.headerName = headerName;
    }
    /**
     * @param {?} req
     * @param {?} next
     * @return {?}
     */
    HttpXsrfInterceptor.prototype.intercept = /**
     * @param {?} req
     * @param {?} next
     * @return {?}
     */
    function (req, next) {
        var /** @type {?} */ lcUrl = req.url.toLowerCase();
        // Skip both non-mutating requests and absolute URLs.
        // Non-mutating requests don't require a token, and absolute URLs require special handling
        // anyway as the cookie set
        // on our origin is not the same as the token expected by another origin.
        if (req.method === 'GET' || req.method === 'HEAD' || lcUrl.startsWith('http://') ||
            lcUrl.startsWith('https://')) {
            return next.handle(req);
        }
        var /** @type {?} */ token = this.tokenService.getToken();
        // Be careful not to overwrite an existing header of the same name.
        if (token !== null && !req.headers.has(this.headerName)) {
            req = req.clone({ headers: req.headers.set(this.headerName, token) });
        }
        return next.handle(req);
    };
    HttpXsrfInterceptor.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    HttpXsrfInterceptor.ctorParameters = function () { return [
        { type: HttpXsrfTokenExtractor, },
        { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [XSRF_HEADER_NAME,] },] },
    ]; };
    return HttpXsrfInterceptor;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * An `HttpHandler` that applies a bunch of `HttpInterceptor`s
 * to a request before passing it to the given `HttpBackend`.
 *
 * The interceptors are loaded lazily from the injector, to allow
 * interceptors to themselves inject classes depending indirectly
 * on `HttpInterceptingHandler` itself.
 */
var HttpInterceptingHandler = /** @class */ (function () {
    function HttpInterceptingHandler(backend, injector) {
        this.backend = backend;
        this.injector = injector;
        this.chain = null;
    }
    /**
     * @param {?} req
     * @return {?}
     */
    HttpInterceptingHandler.prototype.handle = /**
     * @param {?} req
     * @return {?}
     */
    function (req) {
        if (this.chain === null) {
            var /** @type {?} */ interceptors = this.injector.get(HTTP_INTERCEPTORS, []);
            this.chain = interceptors.reduceRight(function (next, interceptor) { return new HttpInterceptorHandler(next, interceptor); }, this.backend);
        }
        return this.chain.handle(req);
    };
    HttpInterceptingHandler.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    HttpInterceptingHandler.ctorParameters = function () { return [
        { type: HttpBackend, },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injector"], },
    ]; };
    return HttpInterceptingHandler;
}());
/**
 * Constructs an `HttpHandler` that applies a bunch of `HttpInterceptor`s
 * to a request before passing it to the given `HttpBackend`.
 *
 * Meant to be used as a factory function within `HttpClientModule`.
 *
 * \@stable
 * @param {?} backend
 * @param {?=} interceptors
 * @return {?}
 */
function interceptingHandler(backend, interceptors) {
    if (interceptors === void 0) { interceptors = []; }
    if (!interceptors) {
        return backend;
    }
    return interceptors.reduceRight(function (next, interceptor) { return new HttpInterceptorHandler(next, interceptor); }, backend);
}
/**
 * Factory function that determines where to store JSONP callbacks.
 *
 * Ordinarily JSONP callbacks are stored on the `window` object, but this may not exist
 * in test environments. In that case, callbacks are stored on an anonymous object instead.
 *
 * \@stable
 * @return {?}
 */
function jsonpCallbackContext() {
    if (typeof window === 'object') {
        return window;
    }
    return {};
}
/**
 * `NgModule` which adds XSRF protection support to outgoing requests.
 *
 * Provided the server supports a cookie-based XSRF protection system, this
 * module can be used directly to configure XSRF protection with the correct
 * cookie and header names.
 *
 * If no such names are provided, the default is to use `X-XSRF-TOKEN` for
 * the header name and `XSRF-TOKEN` for the cookie name.
 *
 * \@stable
 */
var HttpClientXsrfModule = /** @class */ (function () {
    function HttpClientXsrfModule() {
    }
    /**
     * Disable the default XSRF protection.
     */
    /**
     * Disable the default XSRF protection.
     * @return {?}
     */
    HttpClientXsrfModule.disable = /**
     * Disable the default XSRF protection.
     * @return {?}
     */
    function () {
        return {
            ngModule: HttpClientXsrfModule,
            providers: [
                { provide: HttpXsrfInterceptor, useClass: NoopInterceptor },
            ],
        };
    };
    /**
     * Configure XSRF protection to use the given cookie name or header name,
     * or the default names (as described above) if not provided.
     */
    /**
     * Configure XSRF protection to use the given cookie name or header name,
     * or the default names (as described above) if not provided.
     * @param {?=} options
     * @return {?}
     */
    HttpClientXsrfModule.withOptions = /**
     * Configure XSRF protection to use the given cookie name or header name,
     * or the default names (as described above) if not provided.
     * @param {?=} options
     * @return {?}
     */
    function (options) {
        if (options === void 0) { options = {}; }
        return {
            ngModule: HttpClientXsrfModule,
            providers: [
                options.cookieName ? { provide: XSRF_COOKIE_NAME, useValue: options.cookieName } : [],
                options.headerName ? { provide: XSRF_HEADER_NAME, useValue: options.headerName } : [],
            ],
        };
    };
    HttpClientXsrfModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                    providers: [
                        HttpXsrfInterceptor,
                        { provide: HTTP_INTERCEPTORS, useExisting: HttpXsrfInterceptor, multi: true },
                        { provide: HttpXsrfTokenExtractor, useClass: HttpXsrfCookieExtractor },
                        { provide: XSRF_COOKIE_NAME, useValue: 'XSRF-TOKEN' },
                        { provide: XSRF_HEADER_NAME, useValue: 'X-XSRF-TOKEN' },
                    ],
                },] },
    ];
    /** @nocollapse */
    HttpClientXsrfModule.ctorParameters = function () { return []; };
    return HttpClientXsrfModule;
}());
/**
 * `NgModule` which provides the `HttpClient` and associated services.
 *
 * Interceptors can be added to the chain behind `HttpClient` by binding them
 * to the multiprovider for `HTTP_INTERCEPTORS`.
 *
 * \@stable
 */
var HttpClientModule = /** @class */ (function () {
    function HttpClientModule() {
    }
    HttpClientModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                    imports: [
                        HttpClientXsrfModule.withOptions({
                            cookieName: 'XSRF-TOKEN',
                            headerName: 'X-XSRF-TOKEN',
                        }),
                    ],
                    providers: [
                        HttpClient,
                        { provide: HttpHandler, useClass: HttpInterceptingHandler },
                        HttpXhrBackend,
                        { provide: HttpBackend, useExisting: HttpXhrBackend },
                        BrowserXhr,
                        { provide: XhrFactory, useExisting: BrowserXhr },
                    ],
                },] },
    ];
    /** @nocollapse */
    HttpClientModule.ctorParameters = function () { return []; };
    return HttpClientModule;
}());
/**
 * `NgModule` which enables JSONP support in `HttpClient`.
 *
 * Without this module, Jsonp requests will reach the backend
 * with method JSONP, where they'll be rejected.
 *
 * \@stable
 */
var HttpClientJsonpModule = /** @class */ (function () {
    function HttpClientJsonpModule() {
    }
    HttpClientJsonpModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                    providers: [
                        JsonpClientBackend,
                        { provide: JsonpCallbackContext, useFactory: jsonpCallbackContext },
                        { provide: HTTP_INTERCEPTORS, useClass: JsonpInterceptor, multi: true },
                    ],
                },] },
    ];
    /** @nocollapse */
    HttpClientJsonpModule.ctorParameters = function () { return []; };
    return HttpClientJsonpModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Generated bundle index. Do not edit.
 */


//# sourceMappingURL=http.js.map


/***/ }),

/***/ "./node_modules/@angular/forms/esm5/forms.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbstractControlDirective", function() { return AbstractControlDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbstractFormGroupDirective", function() { return AbstractFormGroupDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CheckboxControlValueAccessor", function() { return CheckboxControlValueAccessor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ControlContainer", function() { return ControlContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NG_VALUE_ACCESSOR", function() { return NG_VALUE_ACCESSOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COMPOSITION_BUFFER_MODE", function() { return COMPOSITION_BUFFER_MODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DefaultValueAccessor", function() { return DefaultValueAccessor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgControl", function() { return NgControl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgControlStatus", function() { return NgControlStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgControlStatusGroup", function() { return NgControlStatusGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgForm", function() { return NgForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgModel", function() { return NgModel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgModelGroup", function() { return NgModelGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RadioControlValueAccessor", function() { return RadioControlValueAccessor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormControlDirective", function() { return FormControlDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormControlName", function() { return FormControlName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormGroupDirective", function() { return FormGroupDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormArrayName", function() { return FormArrayName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormGroupName", function() { return FormGroupName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgSelectOption", function() { return NgSelectOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SelectControlValueAccessor", function() { return SelectControlValueAccessor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SelectMultipleControlValueAccessor", function() { return SelectMultipleControlValueAccessor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CheckboxRequiredValidator", function() { return CheckboxRequiredValidator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EmailValidator", function() { return EmailValidator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MaxLengthValidator", function() { return MaxLengthValidator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MinLengthValidator", function() { return MinLengthValidator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PatternValidator", function() { return PatternValidator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RequiredValidator", function() { return RequiredValidator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormBuilder", function() { return FormBuilder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbstractControl", function() { return AbstractControl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormArray", function() { return FormArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormControl", function() { return FormControl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormGroup", function() { return FormGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NG_ASYNC_VALIDATORS", function() { return NG_ASYNC_VALIDATORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NG_VALIDATORS", function() { return NG_VALIDATORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Validators", function() { return Validators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VERSION", function() { return VERSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormsModule", function() { return FormsModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReactiveFormsModule", function() { return ReactiveFormsModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵba", function() { return InternalFormsSharedModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵz", function() { return REACTIVE_DRIVEN_DIRECTIVES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵx", function() { return SHARED_FORM_DIRECTIVES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵy", function() { return TEMPLATE_DRIVEN_DIRECTIVES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵa", function() { return CHECKBOX_VALUE_ACCESSOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵb", function() { return DEFAULT_VALUE_ACCESSOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵc", function() { return AbstractControlStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵd", function() { return ngControlStatusHost; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵe", function() { return formDirectiveProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵf", function() { return formControlBinding; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵg", function() { return modelGroupProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵbf", function() { return NgNoValidate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵbb", function() { return NUMBER_VALUE_ACCESSOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵbc", function() { return NumberValueAccessor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵh", function() { return RADIO_VALUE_ACCESSOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵi", function() { return RadioControlRegistry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵbd", function() { return RANGE_VALUE_ACCESSOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵbe", function() { return RangeValueAccessor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵj", function() { return formControlBinding$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵk", function() { return controlNameBinding; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵl", function() { return formDirectiveProvider$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵn", function() { return formArrayNameProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵm", function() { return formGroupNameProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵo", function() { return SELECT_VALUE_ACCESSOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵq", function() { return NgSelectMultipleOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵp", function() { return SELECT_MULTIPLE_VALUE_ACCESSOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵs", function() { return CHECKBOX_REQUIRED_VALIDATOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵt", function() { return EMAIL_VALIDATOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵv", function() { return MAX_LENGTH_VALIDATOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵu", function() { return MIN_LENGTH_VALIDATOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵw", function() { return PATTERN_VALIDATOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵr", function() { return REQUIRED_VALIDATOR; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_observable_forkJoin__ = __webpack_require__("./node_modules/rxjs/observable/forkJoin.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_observable_forkJoin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_forkJoin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_observable_fromPromise__ = __webpack_require__("./node_modules/rxjs/observable/fromPromise.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_observable_fromPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_fromPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_map__ = __webpack_require__("./node_modules/rxjs/operator/map.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__angular_platform_browser__ = __webpack_require__("./node_modules/@angular/platform-browser/esm5/platform-browser.js");
/**
 * @license Angular v5.2.10
 * (c) 2010-2018 Google, Inc. https://angular.io/
 * License: MIT
 */







/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Base class for control directives.
 *
 * Only used internally in the forms module.
 *
 * \@stable
 * @abstract
 */
var AbstractControlDirective = /** @class */ (function () {
    function AbstractControlDirective() {
    }
    Object.defineProperty(AbstractControlDirective.prototype, "value", {
        /** The value of the control. */
        get: /**
         * The value of the control.
         * @return {?}
         */
        function () { return this.control ? this.control.value : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "valid", {
        /**
         * A control is `valid` when its `status === VALID`.
         *
         * In order to have this status, the control must have passed all its
         * validation checks.
         */
        get: /**
         * A control is `valid` when its `status === VALID`.
         *
         * In order to have this status, the control must have passed all its
         * validation checks.
         * @return {?}
         */
        function () { return this.control ? this.control.valid : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "invalid", {
        /**
         * A control is `invalid` when its `status === INVALID`.
         *
         * In order to have this status, the control must have failed
         * at least one of its validation checks.
         */
        get: /**
         * A control is `invalid` when its `status === INVALID`.
         *
         * In order to have this status, the control must have failed
         * at least one of its validation checks.
         * @return {?}
         */
        function () { return this.control ? this.control.invalid : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "pending", {
        /**
         * A control is `pending` when its `status === PENDING`.
         *
         * In order to have this status, the control must be in the
         * middle of conducting a validation check.
         */
        get: /**
         * A control is `pending` when its `status === PENDING`.
         *
         * In order to have this status, the control must be in the
         * middle of conducting a validation check.
         * @return {?}
         */
        function () { return this.control ? this.control.pending : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "disabled", {
        /**
         * A control is `disabled` when its `status === DISABLED`.
         *
         * Disabled controls are exempt from validation checks and
         * are not included in the aggregate value of their ancestor
         * controls.
         */
        get: /**
         * A control is `disabled` when its `status === DISABLED`.
         *
         * Disabled controls are exempt from validation checks and
         * are not included in the aggregate value of their ancestor
         * controls.
         * @return {?}
         */
        function () { return this.control ? this.control.disabled : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "enabled", {
        /**
         * A control is `enabled` as long as its `status !== DISABLED`.
         *
         * In other words, it has a status of `VALID`, `INVALID`, or
         * `PENDING`.
         */
        get: /**
         * A control is `enabled` as long as its `status !== DISABLED`.
         *
         * In other words, it has a status of `VALID`, `INVALID`, or
         * `PENDING`.
         * @return {?}
         */
        function () { return this.control ? this.control.enabled : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "errors", {
        /**
         * Returns any errors generated by failing validation. If there
         * are no errors, it will return null.
         */
        get: /**
         * Returns any errors generated by failing validation. If there
         * are no errors, it will return null.
         * @return {?}
         */
        function () { return this.control ? this.control.errors : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "pristine", {
        /**
         * A control is `pristine` if the user has not yet changed
         * the value in the UI.
         *
         * Note that programmatic changes to a control's value will
         * *not* mark it dirty.
         */
        get: /**
         * A control is `pristine` if the user has not yet changed
         * the value in the UI.
         *
         * Note that programmatic changes to a control's value will
         * *not* mark it dirty.
         * @return {?}
         */
        function () { return this.control ? this.control.pristine : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "dirty", {
        /**
         * A control is `dirty` if the user has changed the value
         * in the UI.
         *
         * Note that programmatic changes to a control's value will
         * *not* mark it dirty.
         */
        get: /**
         * A control is `dirty` if the user has changed the value
         * in the UI.
         *
         * Note that programmatic changes to a control's value will
         * *not* mark it dirty.
         * @return {?}
         */
        function () { return this.control ? this.control.dirty : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "touched", {
        /**
         * A control is marked `touched` once the user has triggered
         * a `blur` event on it.
         */
        get: /**
         * A control is marked `touched` once the user has triggered
         * a `blur` event on it.
         * @return {?}
         */
        function () { return this.control ? this.control.touched : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "status", {
        get: /**
         * @return {?}
         */
        function () { return this.control ? this.control.status : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "untouched", {
        /**
         * A control is `untouched` if the user has not yet triggered
         * a `blur` event on it.
         */
        get: /**
         * A control is `untouched` if the user has not yet triggered
         * a `blur` event on it.
         * @return {?}
         */
        function () { return this.control ? this.control.untouched : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "statusChanges", {
        /**
         * Emits an event every time the validation status of the control
         * is re-calculated.
         */
        get: /**
         * Emits an event every time the validation status of the control
         * is re-calculated.
         * @return {?}
         */
        function () {
            return this.control ? this.control.statusChanges : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "valueChanges", {
        /**
         * Emits an event every time the value of the control changes, in
         * the UI or programmatically.
         */
        get: /**
         * Emits an event every time the value of the control changes, in
         * the UI or programmatically.
         * @return {?}
         */
        function () {
            return this.control ? this.control.valueChanges : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "path", {
        /**
         * Returns an array that represents the path from the top-level form
         * to this control. Each index is the string name of the control on
         * that level.
         */
        get: /**
         * Returns an array that represents the path from the top-level form
         * to this control. Each index is the string name of the control on
         * that level.
         * @return {?}
         */
        function () { return null; },
        enumerable: true,
        configurable: true
    });
    /**
     * Resets the form control. This means by default:
     *
     * * it is marked as `pristine`
     * * it is marked as `untouched`
     * * value is set to null
     *
     * For more information, see {@link AbstractControl}.
     */
    /**
     * Resets the form control. This means by default:
     *
     * * it is marked as `pristine`
     * * it is marked as `untouched`
     * * value is set to null
     *
     * For more information, see {\@link AbstractControl}.
     * @param {?=} value
     * @return {?}
     */
    AbstractControlDirective.prototype.reset = /**
     * Resets the form control. This means by default:
     *
     * * it is marked as `pristine`
     * * it is marked as `untouched`
     * * value is set to null
     *
     * For more information, see {\@link AbstractControl}.
     * @param {?=} value
     * @return {?}
     */
    function (value) {
        if (value === void 0) { value = undefined; }
        if (this.control)
            this.control.reset(value);
    };
    /**
     * Returns true if the control with the given path has the error specified. Otherwise
     * returns false.
     *
     * If no path is given, it checks for the error on the present control.
     */
    /**
     * Returns true if the control with the given path has the error specified. Otherwise
     * returns false.
     *
     * If no path is given, it checks for the error on the present control.
     * @param {?} errorCode
     * @param {?=} path
     * @return {?}
     */
    AbstractControlDirective.prototype.hasError = /**
     * Returns true if the control with the given path has the error specified. Otherwise
     * returns false.
     *
     * If no path is given, it checks for the error on the present control.
     * @param {?} errorCode
     * @param {?=} path
     * @return {?}
     */
    function (errorCode, path) {
        return this.control ? this.control.hasError(errorCode, path) : false;
    };
    /**
     * Returns error data if the control with the given path has the error specified. Otherwise
     * returns null or undefined.
     *
     * If no path is given, it checks for the error on the present control.
     */
    /**
     * Returns error data if the control with the given path has the error specified. Otherwise
     * returns null or undefined.
     *
     * If no path is given, it checks for the error on the present control.
     * @param {?} errorCode
     * @param {?=} path
     * @return {?}
     */
    AbstractControlDirective.prototype.getError = /**
     * Returns error data if the control with the given path has the error specified. Otherwise
     * returns null or undefined.
     *
     * If no path is given, it checks for the error on the present control.
     * @param {?} errorCode
     * @param {?=} path
     * @return {?}
     */
    function (errorCode, path) {
        return this.control ? this.control.getError(errorCode, path) : null;
    };
    return AbstractControlDirective;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * A directive that contains multiple {\@link NgControl}s.
 *
 * Only used by the forms module.
 *
 * \@stable
 * @abstract
 */
var ControlContainer = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __extends */])(ControlContainer, _super);
    function ControlContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ControlContainer.prototype, "formDirective", {
        /**
         * Get the form to which this container belongs.
         */
        get: /**
         * Get the form to which this container belongs.
         * @return {?}
         */
        function () { return null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ControlContainer.prototype, "path", {
        /**
         * Get the path to this container.
         */
        get: /**
         * Get the path to this container.
         * @return {?}
         */
        function () { return null; },
        enumerable: true,
        configurable: true
    });
    return ControlContainer;
}(AbstractControlDirective));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @param {?} value
 * @return {?}
 */
function isEmptyInputValue(value) {
    // we don't check for string here so it also works with arrays
    return value == null || value.length === 0;
}
/**
 * Providers for validators to be used for {\@link FormControl}s in a form.
 *
 * Provide this using `multi: true` to add validators.
 *
 * ### Example
 *
 * ```typescript
 * \@Directive({
 *   selector: '[custom-validator]',
 *   providers: [{provide: NG_VALIDATORS, useExisting: CustomValidatorDirective, multi: true}]
 * })
 * class CustomValidatorDirective implements Validator {
 *   validate(control: AbstractControl): ValidationErrors | null {
 *     return {"custom": true};
 *   }
 * }
 * ```
 *
 * \@stable
 */
var NG_VALIDATORS = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["InjectionToken"]('NgValidators');
/**
 * Providers for asynchronous validators to be used for {\@link FormControl}s
 * in a form.
 *
 * Provide this using `multi: true` to add validators.
 *
 * See {\@link NG_VALIDATORS} for more details.
 *
 * \@stable
 */
var NG_ASYNC_VALIDATORS = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["InjectionToken"]('NgAsyncValidators');
var EMAIL_REGEXP = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/;
/**
 * Provides a set of validators used by form controls.
 *
 * A validator is a function that processes a {\@link FormControl} or collection of
 * controls and returns a map of errors. A null map means that validation has passed.
 *
 * ### Example
 *
 * ```typescript
 * var loginControl = new FormControl("", Validators.required)
 * ```
 *
 * \@stable
 */
var Validators = /** @class */ (function () {
    function Validators() {
    }
    /**
     * Validator that requires controls to have a value greater than a number.
     *`min()` exists only as a function, not as a directive. For example,
     * `control = new FormControl('', Validators.min(3));`.
     */
    /**
     * Validator that requires controls to have a value greater than a number.
     * `min()` exists only as a function, not as a directive. For example,
     * `control = new FormControl('', Validators.min(3));`.
     * @param {?} min
     * @return {?}
     */
    Validators.min = /**
     * Validator that requires controls to have a value greater than a number.
     * `min()` exists only as a function, not as a directive. For example,
     * `control = new FormControl('', Validators.min(3));`.
     * @param {?} min
     * @return {?}
     */
    function (min) {
        return function (control) {
            if (isEmptyInputValue(control.value) || isEmptyInputValue(min)) {
                return null; // don't validate empty values to allow optional controls
            }
            var /** @type {?} */ value = parseFloat(control.value);
            // Controls with NaN values after parsing should be treated as not having a
            // minimum, per the HTML forms spec: https://www.w3.org/TR/html5/forms.html#attr-input-min
            return !isNaN(value) && value < min ? { 'min': { 'min': min, 'actual': control.value } } : null;
        };
    };
    /**
     * Validator that requires controls to have a value less than a number.
     * `max()` exists only as a function, not as a directive. For example,
     * `control = new FormControl('', Validators.max(15));`.
     */
    /**
     * Validator that requires controls to have a value less than a number.
     * `max()` exists only as a function, not as a directive. For example,
     * `control = new FormControl('', Validators.max(15));`.
     * @param {?} max
     * @return {?}
     */
    Validators.max = /**
     * Validator that requires controls to have a value less than a number.
     * `max()` exists only as a function, not as a directive. For example,
     * `control = new FormControl('', Validators.max(15));`.
     * @param {?} max
     * @return {?}
     */
    function (max) {
        return function (control) {
            if (isEmptyInputValue(control.value) || isEmptyInputValue(max)) {
                return null; // don't validate empty values to allow optional controls
            }
            var /** @type {?} */ value = parseFloat(control.value);
            // Controls with NaN values after parsing should be treated as not having a
            // maximum, per the HTML forms spec: https://www.w3.org/TR/html5/forms.html#attr-input-max
            return !isNaN(value) && value > max ? { 'max': { 'max': max, 'actual': control.value } } : null;
        };
    };
    /**
     * Validator that requires controls to have a non-empty value.
     */
    /**
     * Validator that requires controls to have a non-empty value.
     * @param {?} control
     * @return {?}
     */
    Validators.required = /**
     * Validator that requires controls to have a non-empty value.
     * @param {?} control
     * @return {?}
     */
    function (control) {
        return isEmptyInputValue(control.value) ? { 'required': true } : null;
    };
    /**
     * Validator that requires control value to be true.
     */
    /**
     * Validator that requires control value to be true.
     * @param {?} control
     * @return {?}
     */
    Validators.requiredTrue = /**
     * Validator that requires control value to be true.
     * @param {?} control
     * @return {?}
     */
    function (control) {
        return control.value === true ? null : { 'required': true };
    };
    /**
     * Validator that performs email validation.
     */
    /**
     * Validator that performs email validation.
     * @param {?} control
     * @return {?}
     */
    Validators.email = /**
     * Validator that performs email validation.
     * @param {?} control
     * @return {?}
     */
    function (control) {
        return EMAIL_REGEXP.test(control.value) ? null : { 'email': true };
    };
    /**
     * Validator that requires controls to have a value of a minimum length.
     */
    /**
     * Validator that requires controls to have a value of a minimum length.
     * @param {?} minLength
     * @return {?}
     */
    Validators.minLength = /**
     * Validator that requires controls to have a value of a minimum length.
     * @param {?} minLength
     * @return {?}
     */
    function (minLength) {
        return function (control) {
            if (isEmptyInputValue(control.value)) {
                return null; // don't validate empty values to allow optional controls
            }
            var /** @type {?} */ length = control.value ? control.value.length : 0;
            return length < minLength ?
                { 'minlength': { 'requiredLength': minLength, 'actualLength': length } } :
                null;
        };
    };
    /**
     * Validator that requires controls to have a value of a maximum length.
     */
    /**
     * Validator that requires controls to have a value of a maximum length.
     * @param {?} maxLength
     * @return {?}
     */
    Validators.maxLength = /**
     * Validator that requires controls to have a value of a maximum length.
     * @param {?} maxLength
     * @return {?}
     */
    function (maxLength) {
        return function (control) {
            var /** @type {?} */ length = control.value ? control.value.length : 0;
            return length > maxLength ?
                { 'maxlength': { 'requiredLength': maxLength, 'actualLength': length } } :
                null;
        };
    };
    /**
     * Validator that requires a control to match a regex to its value.
     */
    /**
     * Validator that requires a control to match a regex to its value.
     * @param {?} pattern
     * @return {?}
     */
    Validators.pattern = /**
     * Validator that requires a control to match a regex to its value.
     * @param {?} pattern
     * @return {?}
     */
    function (pattern) {
        if (!pattern)
            return Validators.nullValidator;
        var /** @type {?} */ regex;
        var /** @type {?} */ regexStr;
        if (typeof pattern === 'string') {
            regexStr = '';
            if (pattern.charAt(0) !== '^')
                regexStr += '^';
            regexStr += pattern;
            if (pattern.charAt(pattern.length - 1) !== '$')
                regexStr += '$';
            regex = new RegExp(regexStr);
        }
        else {
            regexStr = pattern.toString();
            regex = pattern;
        }
        return function (control) {
            if (isEmptyInputValue(control.value)) {
                return null; // don't validate empty values to allow optional controls
            }
            var /** @type {?} */ value = control.value;
            return regex.test(value) ? null :
                { 'pattern': { 'requiredPattern': regexStr, 'actualValue': value } };
        };
    };
    /**
     * No-op validator.
     */
    /**
     * No-op validator.
     * @param {?} c
     * @return {?}
     */
    Validators.nullValidator = /**
     * No-op validator.
     * @param {?} c
     * @return {?}
     */
    function (c) { return null; };
    /**
     * @param {?} validators
     * @return {?}
     */
    Validators.compose = /**
     * @param {?} validators
     * @return {?}
     */
    function (validators) {
        if (!validators)
            return null;
        var /** @type {?} */ presentValidators = /** @type {?} */ (validators.filter(isPresent));
        if (presentValidators.length == 0)
            return null;
        return function (control) {
            return _mergeErrors(_executeValidators(control, presentValidators));
        };
    };
    /**
     * @param {?} validators
     * @return {?}
     */
    Validators.composeAsync = /**
     * @param {?} validators
     * @return {?}
     */
    function (validators) {
        if (!validators)
            return null;
        var /** @type {?} */ presentValidators = /** @type {?} */ (validators.filter(isPresent));
        if (presentValidators.length == 0)
            return null;
        return function (control) {
            var /** @type {?} */ observables = _executeAsyncValidators(control, presentValidators).map(toObservable);
            return __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_map__["map"].call(Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_forkJoin__["forkJoin"])(observables), _mergeErrors);
        };
    };
    return Validators;
}());
/**
 * @param {?} o
 * @return {?}
 */
function isPresent(o) {
    return o != null;
}
/**
 * @param {?} r
 * @return {?}
 */
function toObservable(r) {
    var /** @type {?} */ obs = Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵisPromise"])(r) ? Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_fromPromise__["fromPromise"])(r) : r;
    if (!(Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵisObservable"])(obs))) {
        throw new Error("Expected validator to return Promise or Observable.");
    }
    return obs;
}
/**
 * @param {?} control
 * @param {?} validators
 * @return {?}
 */
function _executeValidators(control, validators) {
    return validators.map(function (v) { return v(control); });
}
/**
 * @param {?} control
 * @param {?} validators
 * @return {?}
 */
function _executeAsyncValidators(control, validators) {
    return validators.map(function (v) { return v(control); });
}
/**
 * @param {?} arrayOfErrors
 * @return {?}
 */
function _mergeErrors(arrayOfErrors) {
    var /** @type {?} */ res = arrayOfErrors.reduce(function (res, errors) {
        return errors != null ? Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, /** @type {?} */ ((res)), errors) : /** @type {?} */ ((res));
    }, {});
    return Object.keys(res).length === 0 ? null : res;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * A `ControlValueAccessor` acts as a bridge between the Angular forms API and a
 * native element in the DOM.
 *
 * Implement this interface if you want to create a custom form control directive
 * that integrates with Angular forms.
 *
 * \@stable
 * @record
 */

/**
 * Used to provide a {\@link ControlValueAccessor} for form controls.
 *
 * See {\@link DefaultValueAccessor} for how to implement one.
 * \@stable
 */
var NG_VALUE_ACCESSOR = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["InjectionToken"]('NgValueAccessor');

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var CHECKBOX_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return CheckboxControlValueAccessor; }),
    multi: true,
};
/**
 * The accessor for writing a value and listening to changes on a checkbox input element.
 *
 *  ### Example
 *  ```
 *  <input type="checkbox" name="rememberLogin" ngModel>
 *  ```
 *
 *  \@stable
 */
var CheckboxControlValueAccessor = /** @class */ (function () {
    function CheckboxControlValueAccessor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this.onChange = function (_) { };
        this.onTouched = function () { };
    }
    /**
     * @param {?} value
     * @return {?}
     */
    CheckboxControlValueAccessor.prototype.writeValue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this._renderer.setProperty(this._elementRef.nativeElement, 'checked', value);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    CheckboxControlValueAccessor.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) { this.onChange = fn; };
    /**
     * @param {?} fn
     * @return {?}
     */
    CheckboxControlValueAccessor.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) { this.onTouched = fn; };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    CheckboxControlValueAccessor.prototype.setDisabledState = /**
     * @param {?} isDisabled
     * @return {?}
     */
    function (isDisabled) {
        this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    CheckboxControlValueAccessor.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{
                    selector: 'input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]',
                    host: { '(change)': 'onChange($event.target.checked)', '(blur)': 'onTouched()' },
                    providers: [CHECKBOX_VALUE_ACCESSOR]
                },] },
    ];
    /** @nocollapse */
    CheckboxControlValueAccessor.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Renderer2"], },
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], },
    ]; };
    return CheckboxControlValueAccessor;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var DEFAULT_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return DefaultValueAccessor; }),
    multi: true
};
/**
 * We must check whether the agent is Android because composition events
 * behave differently between iOS and Android.
 * @return {?}
 */
function _isAndroid() {
    var /** @type {?} */ userAgent = Object(__WEBPACK_IMPORTED_MODULE_5__angular_platform_browser__["ɵgetDOM"])() ? Object(__WEBPACK_IMPORTED_MODULE_5__angular_platform_browser__["ɵgetDOM"])().getUserAgent() : '';
    return /android (\d+)/.test(userAgent.toLowerCase());
}
/**
 * Turn this mode on if you want form directives to buffer IME input until compositionend
 * \@experimental
 */
var COMPOSITION_BUFFER_MODE = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["InjectionToken"]('CompositionEventMode');
/**
 * The default accessor for writing a value and listening to changes that is used by the
 * {\@link NgModel}, {\@link FormControlDirective}, and {\@link FormControlName} directives.
 *
 *  ### Example
 *  ```
 *  <input type="text" name="searchQuery" ngModel>
 *  ```
 *
 *  \@stable
 */
var DefaultValueAccessor = /** @class */ (function () {
    function DefaultValueAccessor(_renderer, _elementRef, _compositionMode) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this._compositionMode = _compositionMode;
        this.onChange = function (_) { };
        this.onTouched = function () { };
        /**
         * Whether the user is creating a composition string (IME events).
         */
        this._composing = false;
        if (this._compositionMode == null) {
            this._compositionMode = !_isAndroid();
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    DefaultValueAccessor.prototype.writeValue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        var /** @type {?} */ normalizedValue = value == null ? '' : value;
        this._renderer.setProperty(this._elementRef.nativeElement, 'value', normalizedValue);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    DefaultValueAccessor.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) { this.onChange = fn; };
    /**
     * @param {?} fn
     * @return {?}
     */
    DefaultValueAccessor.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) { this.onTouched = fn; };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    DefaultValueAccessor.prototype.setDisabledState = /**
     * @param {?} isDisabled
     * @return {?}
     */
    function (isDisabled) {
        this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    /** @internal */
    /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    DefaultValueAccessor.prototype._handleInput = /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    function (value) {
        if (!this._compositionMode || (this._compositionMode && !this._composing)) {
            this.onChange(value);
        }
    };
    /** @internal */
    /**
     * \@internal
     * @return {?}
     */
    DefaultValueAccessor.prototype._compositionStart = /**
     * \@internal
     * @return {?}
     */
    function () { this._composing = true; };
    /** @internal */
    /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    DefaultValueAccessor.prototype._compositionEnd = /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this._composing = false;
        this._compositionMode && this.onChange(value);
    };
    DefaultValueAccessor.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{
                    selector: 'input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]',
                    // TODO: vsavkin replace the above selector with the one below it once
                    // https://github.com/angular/angular/issues/3011 is implemented
                    // selector: '[ngModel],[formControl],[formControlName]',
                    host: {
                        '(input)': '$any(this)._handleInput($event.target.value)',
                        '(blur)': 'onTouched()',
                        '(compositionstart)': '$any(this)._compositionStart()',
                        '(compositionend)': '$any(this)._compositionEnd($event.target.value)'
                    },
                    providers: [DEFAULT_VALUE_ACCESSOR]
                },] },
    ];
    /** @nocollapse */
    DefaultValueAccessor.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Renderer2"], },
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], },
        { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [COMPOSITION_BUFFER_MODE,] },] },
    ]; };
    return DefaultValueAccessor;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @param {?} validator
 * @return {?}
 */
function normalizeValidator(validator) {
    if ((/** @type {?} */ (validator)).validate) {
        return function (c) { return (/** @type {?} */ (validator)).validate(c); };
    }
    else {
        return /** @type {?} */ (validator);
    }
}
/**
 * @param {?} validator
 * @return {?}
 */
function normalizeAsyncValidator(validator) {
    if ((/** @type {?} */ (validator)).validate) {
        return function (c) { return (/** @type {?} */ (validator)).validate(c); };
    }
    else {
        return /** @type {?} */ (validator);
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var NUMBER_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return NumberValueAccessor; }),
    multi: true
};
/**
 * The accessor for writing a number value and listening to changes that is used by the
 * {\@link NgModel}, {\@link FormControlDirective}, and {\@link FormControlName} directives.
 *
 *  ### Example
 *  ```
 *  <input type="number" [(ngModel)]="age">
 *  ```
 */
var NumberValueAccessor = /** @class */ (function () {
    function NumberValueAccessor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this.onChange = function (_) { };
        this.onTouched = function () { };
    }
    /**
     * @param {?} value
     * @return {?}
     */
    NumberValueAccessor.prototype.writeValue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        // The value needs to be normalized for IE9, otherwise it is set to 'null' when null
        var /** @type {?} */ normalizedValue = value == null ? '' : value;
        this._renderer.setProperty(this._elementRef.nativeElement, 'value', normalizedValue);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    NumberValueAccessor.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onChange = function (value) { fn(value == '' ? null : parseFloat(value)); };
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    NumberValueAccessor.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) { this.onTouched = fn; };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    NumberValueAccessor.prototype.setDisabledState = /**
     * @param {?} isDisabled
     * @return {?}
     */
    function (isDisabled) {
        this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    NumberValueAccessor.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{
                    selector: 'input[type=number][formControlName],input[type=number][formControl],input[type=number][ngModel]',
                    host: {
                        '(change)': 'onChange($event.target.value)',
                        '(input)': 'onChange($event.target.value)',
                        '(blur)': 'onTouched()'
                    },
                    providers: [NUMBER_VALUE_ACCESSOR]
                },] },
    ];
    /** @nocollapse */
    NumberValueAccessor.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Renderer2"], },
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], },
    ]; };
    return NumberValueAccessor;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @return {?}
 */
function unimplemented() {
    throw new Error('unimplemented');
}
/**
 * A base class that all control directive extend.
 * It binds a {\@link FormControl} object to a DOM element.
 *
 * Used internally by Angular forms.
 *
 * \@stable
 * @abstract
 */
var NgControl = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __extends */])(NgControl, _super);
    function NgControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * \@internal
         */
        _this._parent = null;
        _this.name = null;
        _this.valueAccessor = null;
        /**
         * \@internal
         */
        _this._rawValidators = [];
        /**
         * \@internal
         */
        _this._rawAsyncValidators = [];
        return _this;
    }
    Object.defineProperty(NgControl.prototype, "validator", {
        get: /**
         * @return {?}
         */
        function () { return /** @type {?} */ (unimplemented()); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgControl.prototype, "asyncValidator", {
        get: /**
         * @return {?}
         */
        function () { return /** @type {?} */ (unimplemented()); },
        enumerable: true,
        configurable: true
    });
    return NgControl;
}(AbstractControlDirective));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var RADIO_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return RadioControlValueAccessor; }),
    multi: true
};
/**
 * Internal class used by Angular to uncheck radio buttons with the matching name.
 */
var RadioControlRegistry = /** @class */ (function () {
    function RadioControlRegistry() {
        this._accessors = [];
    }
    /**
     * @param {?} control
     * @param {?} accessor
     * @return {?}
     */
    RadioControlRegistry.prototype.add = /**
     * @param {?} control
     * @param {?} accessor
     * @return {?}
     */
    function (control, accessor) {
        this._accessors.push([control, accessor]);
    };
    /**
     * @param {?} accessor
     * @return {?}
     */
    RadioControlRegistry.prototype.remove = /**
     * @param {?} accessor
     * @return {?}
     */
    function (accessor) {
        for (var /** @type {?} */ i = this._accessors.length - 1; i >= 0; --i) {
            if (this._accessors[i][1] === accessor) {
                this._accessors.splice(i, 1);
                return;
            }
        }
    };
    /**
     * @param {?} accessor
     * @return {?}
     */
    RadioControlRegistry.prototype.select = /**
     * @param {?} accessor
     * @return {?}
     */
    function (accessor) {
        var _this = this;
        this._accessors.forEach(function (c) {
            if (_this._isSameGroup(c, accessor) && c[1] !== accessor) {
                c[1].fireUncheck(accessor.value);
            }
        });
    };
    /**
     * @param {?} controlPair
     * @param {?} accessor
     * @return {?}
     */
    RadioControlRegistry.prototype._isSameGroup = /**
     * @param {?} controlPair
     * @param {?} accessor
     * @return {?}
     */
    function (controlPair, accessor) {
        if (!controlPair[0].control)
            return false;
        return controlPair[0]._parent === accessor._control._parent &&
            controlPair[1].name === accessor.name;
    };
    RadioControlRegistry.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    RadioControlRegistry.ctorParameters = function () { return []; };
    return RadioControlRegistry;
}());
/**
 * \@whatItDoes Writes radio control values and listens to radio control changes.
 *
 * Used by {\@link NgModel}, {\@link FormControlDirective}, and {\@link FormControlName}
 * to keep the view synced with the {\@link FormControl} model.
 *
 * \@howToUse
 *
 * If you have imported the {\@link FormsModule} or the {\@link ReactiveFormsModule}, this
 * value accessor will be active on any radio control that has a form directive. You do
 * **not** need to add a special selector to activate it.
 *
 * ### How to use radio buttons with form directives
 *
 * To use radio buttons in a template-driven form, you'll want to ensure that radio buttons
 * in the same group have the same `name` attribute.  Radio buttons with different `name`
 * attributes do not affect each other.
 *
 * {\@example forms/ts/radioButtons/radio_button_example.ts region='TemplateDriven'}
 *
 * When using radio buttons in a reactive form, radio buttons in the same group should have the
 * same `formControlName`. You can also add a `name` attribute, but it's optional.
 *
 * {\@example forms/ts/reactiveRadioButtons/reactive_radio_button_example.ts region='Reactive'}
 *
 *  * **npm package**: `\@angular/forms`
 *
 *  \@stable
 */
var RadioControlValueAccessor = /** @class */ (function () {
    function RadioControlValueAccessor(_renderer, _elementRef, _registry, _injector) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this._registry = _registry;
        this._injector = _injector;
        this.onChange = function () { };
        this.onTouched = function () { };
    }
    /**
     * @return {?}
     */
    RadioControlValueAccessor.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this._control = this._injector.get(NgControl);
        this._checkName();
        this._registry.add(this._control, this);
    };
    /**
     * @return {?}
     */
    RadioControlValueAccessor.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () { this._registry.remove(this); };
    /**
     * @param {?} value
     * @return {?}
     */
    RadioControlValueAccessor.prototype.writeValue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this._state = value === this.value;
        this._renderer.setProperty(this._elementRef.nativeElement, 'checked', this._state);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    RadioControlValueAccessor.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        var _this = this;
        this._fn = fn;
        this.onChange = function () {
            fn(_this.value);
            _this._registry.select(_this);
        };
    };
    /**
     * @param {?} value
     * @return {?}
     */
    RadioControlValueAccessor.prototype.fireUncheck = /**
     * @param {?} value
     * @return {?}
     */
    function (value) { this.writeValue(value); };
    /**
     * @param {?} fn
     * @return {?}
     */
    RadioControlValueAccessor.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) { this.onTouched = fn; };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    RadioControlValueAccessor.prototype.setDisabledState = /**
     * @param {?} isDisabled
     * @return {?}
     */
    function (isDisabled) {
        this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    /**
     * @return {?}
     */
    RadioControlValueAccessor.prototype._checkName = /**
     * @return {?}
     */
    function () {
        if (this.name && this.formControlName && this.name !== this.formControlName) {
            this._throwNameError();
        }
        if (!this.name && this.formControlName)
            this.name = this.formControlName;
    };
    /**
     * @return {?}
     */
    RadioControlValueAccessor.prototype._throwNameError = /**
     * @return {?}
     */
    function () {
        throw new Error("\n      If you define both a name and a formControlName attribute on your radio button, their values\n      must match. Ex: <input type=\"radio\" formControlName=\"food\" name=\"food\">\n    ");
    };
    RadioControlValueAccessor.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{
                    selector: 'input[type=radio][formControlName],input[type=radio][formControl],input[type=radio][ngModel]',
                    host: { '(change)': 'onChange()', '(blur)': 'onTouched()' },
                    providers: [RADIO_VALUE_ACCESSOR]
                },] },
    ];
    /** @nocollapse */
    RadioControlValueAccessor.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Renderer2"], },
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], },
        { type: RadioControlRegistry, },
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Injector"], },
    ]; };
    RadioControlValueAccessor.propDecorators = {
        "name": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
        "formControlName": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
        "value": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
    };
    return RadioControlValueAccessor;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var RANGE_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return RangeValueAccessor; }),
    multi: true
};
/**
 * The accessor for writing a range value and listening to changes that is used by the
 * {\@link NgModel}, {\@link FormControlDirective}, and {\@link FormControlName} directives.
 *
 *  ### Example
 *  ```
 *  <input type="range" [(ngModel)]="age" >
 *  ```
 */
var RangeValueAccessor = /** @class */ (function () {
    function RangeValueAccessor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this.onChange = function (_) { };
        this.onTouched = function () { };
    }
    /**
     * @param {?} value
     * @return {?}
     */
    RangeValueAccessor.prototype.writeValue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this._renderer.setProperty(this._elementRef.nativeElement, 'value', parseFloat(value));
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    RangeValueAccessor.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onChange = function (value) { fn(value == '' ? null : parseFloat(value)); };
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    RangeValueAccessor.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) { this.onTouched = fn; };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    RangeValueAccessor.prototype.setDisabledState = /**
     * @param {?} isDisabled
     * @return {?}
     */
    function (isDisabled) {
        this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    RangeValueAccessor.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{
                    selector: 'input[type=range][formControlName],input[type=range][formControl],input[type=range][ngModel]',
                    host: {
                        '(change)': 'onChange($event.target.value)',
                        '(input)': 'onChange($event.target.value)',
                        '(blur)': 'onTouched()'
                    },
                    providers: [RANGE_VALUE_ACCESSOR]
                },] },
    ];
    /** @nocollapse */
    RangeValueAccessor.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Renderer2"], },
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], },
    ]; };
    return RangeValueAccessor;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var SELECT_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return SelectControlValueAccessor; }),
    multi: true
};
/**
 * @param {?} id
 * @param {?} value
 * @return {?}
 */
function _buildValueString(id, value) {
    if (id == null)
        return "" + value;
    if (value && typeof value === 'object')
        value = 'Object';
    return (id + ": " + value).slice(0, 50);
}
/**
 * @param {?} valueString
 * @return {?}
 */
function _extractId(valueString) {
    return valueString.split(':')[0];
}
/**
 * \@whatItDoes Writes values and listens to changes on a select element.
 *
 * Used by {\@link NgModel}, {\@link FormControlDirective}, and {\@link FormControlName}
 * to keep the view synced with the {\@link FormControl} model.
 *
 * \@howToUse
 *
 * If you have imported the {\@link FormsModule} or the {\@link ReactiveFormsModule}, this
 * value accessor will be active on any select control that has a form directive. You do
 * **not** need to add a special selector to activate it.
 *
 * ### How to use select controls with form directives
 *
 * To use a select in a template-driven form, simply add an `ngModel` and a `name`
 * attribute to the main `<select>` tag.
 *
 * If your option values are simple strings, you can bind to the normal `value` property
 * on the option.  If your option values happen to be objects (and you'd like to save the
 * selection in your form as an object), use `ngValue` instead:
 *
 * {\@example forms/ts/selectControl/select_control_example.ts region='Component'}
 *
 * In reactive forms, you'll also want to add your form directive (`formControlName` or
 * `formControl`) on the main `<select>` tag. Like in the former example, you have the
 * choice of binding to the  `value` or `ngValue` property on the select's options.
 *
 * {\@example forms/ts/reactiveSelectControl/reactive_select_control_example.ts region='Component'}
 *
 * ### Caveat: Option selection
 *
 * Angular uses object identity to select option. It's possible for the identities of items
 * to change while the data does not. This can happen, for example, if the items are produced
 * from an RPC to the server, and that RPC is re-run. Even if the data hasn't changed, the
 * second response will produce objects with different identities.
 *
 * To customize the default option comparison algorithm, `<select>` supports `compareWith` input.
 * `compareWith` takes a **function** which has two arguments: `option1` and `option2`.
 * If `compareWith` is given, Angular selects option by the return value of the function.
 *
 * #### Syntax
 *
 * ```
 * <select [compareWith]="compareFn"  [(ngModel)]="selectedCountries">
 *     <option *ngFor="let country of countries" [ngValue]="country">
 *         {{country.name}}
 *     </option>
 * </select>
 *
 * compareFn(c1: Country, c2: Country): boolean {
 *     return c1 && c2 ? c1.id === c2.id : c1 === c2;
 * }
 * ```
 *
 * Note: We listen to the 'change' event because 'input' events aren't fired
 * for selects in Firefox and IE:
 * https://bugzilla.mozilla.org/show_bug.cgi?id=1024350
 * https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/4660045/
 *
 * * **npm package**: `\@angular/forms`
 *
 * \@stable
 */
var SelectControlValueAccessor = /** @class */ (function () {
    function SelectControlValueAccessor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        /**
         * \@internal
         */
        this._optionMap = new Map();
        /**
         * \@internal
         */
        this._idCounter = 0;
        this.onChange = function (_) { };
        this.onTouched = function () { };
        this._compareWith = __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵlooseIdentical"];
    }
    Object.defineProperty(SelectControlValueAccessor.prototype, "compareWith", {
        set: /**
         * @param {?} fn
         * @return {?}
         */
        function (fn) {
            if (typeof fn !== 'function') {
                throw new Error("compareWith must be a function, but received " + JSON.stringify(fn));
            }
            this._compareWith = fn;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} value
     * @return {?}
     */
    SelectControlValueAccessor.prototype.writeValue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this.value = value;
        var /** @type {?} */ id = this._getOptionId(value);
        if (id == null) {
            this._renderer.setProperty(this._elementRef.nativeElement, 'selectedIndex', -1);
        }
        var /** @type {?} */ valueString = _buildValueString(id, value);
        this._renderer.setProperty(this._elementRef.nativeElement, 'value', valueString);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    SelectControlValueAccessor.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        var _this = this;
        this.onChange = function (valueString) {
            _this.value = _this._getOptionValue(valueString);
            fn(_this.value);
        };
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    SelectControlValueAccessor.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) { this.onTouched = fn; };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    SelectControlValueAccessor.prototype.setDisabledState = /**
     * @param {?} isDisabled
     * @return {?}
     */
    function (isDisabled) {
        this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    /** @internal */
    /**
     * \@internal
     * @return {?}
     */
    SelectControlValueAccessor.prototype._registerOption = /**
     * \@internal
     * @return {?}
     */
    function () { return (this._idCounter++).toString(); };
    /** @internal */
    /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    SelectControlValueAccessor.prototype._getOptionId = /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    function (value) {
        for (var _i = 0, _a = Array.from(this._optionMap.keys()); _i < _a.length; _i++) {
            var id = _a[_i];
            if (this._compareWith(this._optionMap.get(id), value))
                return id;
        }
        return null;
    };
    /** @internal */
    /**
     * \@internal
     * @param {?} valueString
     * @return {?}
     */
    SelectControlValueAccessor.prototype._getOptionValue = /**
     * \@internal
     * @param {?} valueString
     * @return {?}
     */
    function (valueString) {
        var /** @type {?} */ id = _extractId(valueString);
        return this._optionMap.has(id) ? this._optionMap.get(id) : valueString;
    };
    SelectControlValueAccessor.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{
                    selector: 'select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]',
                    host: { '(change)': 'onChange($event.target.value)', '(blur)': 'onTouched()' },
                    providers: [SELECT_VALUE_ACCESSOR]
                },] },
    ];
    /** @nocollapse */
    SelectControlValueAccessor.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Renderer2"], },
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], },
    ]; };
    SelectControlValueAccessor.propDecorators = {
        "compareWith": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
    };
    return SelectControlValueAccessor;
}());
/**
 * \@whatItDoes Marks `<option>` as dynamic, so Angular can be notified when options change.
 *
 * \@howToUse
 *
 * See docs for {\@link SelectControlValueAccessor} for usage examples.
 *
 * \@stable
 */
var NgSelectOption = /** @class */ (function () {
    function NgSelectOption(_element, _renderer, _select) {
        this._element = _element;
        this._renderer = _renderer;
        this._select = _select;
        if (this._select)
            this.id = this._select._registerOption();
    }
    Object.defineProperty(NgSelectOption.prototype, "ngValue", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (this._select == null)
                return;
            this._select._optionMap.set(this.id, value);
            this._setElementValue(_buildValueString(this.id, value));
            this._select.writeValue(this._select.value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgSelectOption.prototype, "value", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._setElementValue(value);
            if (this._select)
                this._select.writeValue(this._select.value);
        },
        enumerable: true,
        configurable: true
    });
    /** @internal */
    /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    NgSelectOption.prototype._setElementValue = /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this._renderer.setProperty(this._element.nativeElement, 'value', value);
    };
    /**
     * @return {?}
     */
    NgSelectOption.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        if (this._select) {
            this._select._optionMap.delete(this.id);
            this._select.writeValue(this._select.value);
        }
    };
    NgSelectOption.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{ selector: 'option' },] },
    ];
    /** @nocollapse */
    NgSelectOption.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Renderer2"], },
        { type: SelectControlValueAccessor, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Host"] },] },
    ]; };
    NgSelectOption.propDecorators = {
        "ngValue": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"], args: ['ngValue',] },],
        "value": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"], args: ['value',] },],
    };
    return NgSelectOption;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var SELECT_MULTIPLE_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return SelectMultipleControlValueAccessor; }),
    multi: true
};
/**
 * @param {?} id
 * @param {?} value
 * @return {?}
 */
function _buildValueString$1(id, value) {
    if (id == null)
        return "" + value;
    if (typeof value === 'string')
        value = "'" + value + "'";
    if (value && typeof value === 'object')
        value = 'Object';
    return (id + ": " + value).slice(0, 50);
}
/**
 * @param {?} valueString
 * @return {?}
 */
function _extractId$1(valueString) {
    return valueString.split(':')[0];
}
/**
 * The accessor for writing a value and listening to changes on a select element.
 *
 *  ### Caveat: Options selection
 *
 * Angular uses object identity to select options. It's possible for the identities of items
 * to change while the data does not. This can happen, for example, if the items are produced
 * from an RPC to the server, and that RPC is re-run. Even if the data hasn't changed, the
 * second response will produce objects with different identities.
 *
 * To customize the default option comparison algorithm, `<select multiple>` supports `compareWith`
 * input. `compareWith` takes a **function** which has two arguments: `option1` and `option2`.
 * If `compareWith` is given, Angular selects options by the return value of the function.
 *
 * #### Syntax
 *
 * ```
 * <select multiple [compareWith]="compareFn"  [(ngModel)]="selectedCountries">
 *     <option *ngFor="let country of countries" [ngValue]="country">
 *         {{country.name}}
 *     </option>
 * </select>
 *
 * compareFn(c1: Country, c2: Country): boolean {
 *     return c1 && c2 ? c1.id === c2.id : c1 === c2;
 * }
 * ```
 *
 * \@stable
 */
var SelectMultipleControlValueAccessor = /** @class */ (function () {
    function SelectMultipleControlValueAccessor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        /**
         * \@internal
         */
        this._optionMap = new Map();
        /**
         * \@internal
         */
        this._idCounter = 0;
        this.onChange = function (_) { };
        this.onTouched = function () { };
        this._compareWith = __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵlooseIdentical"];
    }
    Object.defineProperty(SelectMultipleControlValueAccessor.prototype, "compareWith", {
        set: /**
         * @param {?} fn
         * @return {?}
         */
        function (fn) {
            if (typeof fn !== 'function') {
                throw new Error("compareWith must be a function, but received " + JSON.stringify(fn));
            }
            this._compareWith = fn;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} value
     * @return {?}
     */
    SelectMultipleControlValueAccessor.prototype.writeValue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        var _this = this;
        this.value = value;
        var /** @type {?} */ optionSelectedStateSetter;
        if (Array.isArray(value)) {
            // convert values to ids
            var /** @type {?} */ ids_1 = value.map(function (v) { return _this._getOptionId(v); });
            optionSelectedStateSetter = function (opt, o) { opt._setSelected(ids_1.indexOf(o.toString()) > -1); };
        }
        else {
            optionSelectedStateSetter = function (opt, o) { opt._setSelected(false); };
        }
        this._optionMap.forEach(optionSelectedStateSetter);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    SelectMultipleControlValueAccessor.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        var _this = this;
        this.onChange = function (_) {
            var /** @type {?} */ selected = [];
            if (_.hasOwnProperty('selectedOptions')) {
                var /** @type {?} */ options = _.selectedOptions;
                for (var /** @type {?} */ i = 0; i < options.length; i++) {
                    var /** @type {?} */ opt = options.item(i);
                    var /** @type {?} */ val = _this._getOptionValue(opt.value);
                    selected.push(val);
                }
            }
            else {
                var /** @type {?} */ options = /** @type {?} */ (_.options);
                for (var /** @type {?} */ i = 0; i < options.length; i++) {
                    var /** @type {?} */ opt = options.item(i);
                    if (opt.selected) {
                        var /** @type {?} */ val = _this._getOptionValue(opt.value);
                        selected.push(val);
                    }
                }
            }
            _this.value = selected;
            fn(selected);
        };
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    SelectMultipleControlValueAccessor.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) { this.onTouched = fn; };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    SelectMultipleControlValueAccessor.prototype.setDisabledState = /**
     * @param {?} isDisabled
     * @return {?}
     */
    function (isDisabled) {
        this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    /** @internal */
    /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    SelectMultipleControlValueAccessor.prototype._registerOption = /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    function (value) {
        var /** @type {?} */ id = (this._idCounter++).toString();
        this._optionMap.set(id, value);
        return id;
    };
    /** @internal */
    /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    SelectMultipleControlValueAccessor.prototype._getOptionId = /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    function (value) {
        for (var _i = 0, _a = Array.from(this._optionMap.keys()); _i < _a.length; _i++) {
            var id = _a[_i];
            if (this._compareWith(/** @type {?} */ ((this._optionMap.get(id)))._value, value))
                return id;
        }
        return null;
    };
    /** @internal */
    /**
     * \@internal
     * @param {?} valueString
     * @return {?}
     */
    SelectMultipleControlValueAccessor.prototype._getOptionValue = /**
     * \@internal
     * @param {?} valueString
     * @return {?}
     */
    function (valueString) {
        var /** @type {?} */ id = _extractId$1(valueString);
        return this._optionMap.has(id) ? /** @type {?} */ ((this._optionMap.get(id)))._value : valueString;
    };
    SelectMultipleControlValueAccessor.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{
                    selector: 'select[multiple][formControlName],select[multiple][formControl],select[multiple][ngModel]',
                    host: { '(change)': 'onChange($event.target)', '(blur)': 'onTouched()' },
                    providers: [SELECT_MULTIPLE_VALUE_ACCESSOR]
                },] },
    ];
    /** @nocollapse */
    SelectMultipleControlValueAccessor.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Renderer2"], },
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], },
    ]; };
    SelectMultipleControlValueAccessor.propDecorators = {
        "compareWith": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
    };
    return SelectMultipleControlValueAccessor;
}());
/**
 * Marks `<option>` as dynamic, so Angular can be notified when options change.
 *
 * ### Example
 *
 * ```
 * <select multiple name="city" ngModel>
 *   <option *ngFor="let c of cities" [value]="c"></option>
 * </select>
 * ```
 */
var NgSelectMultipleOption = /** @class */ (function () {
    function NgSelectMultipleOption(_element, _renderer, _select) {
        this._element = _element;
        this._renderer = _renderer;
        this._select = _select;
        if (this._select) {
            this.id = this._select._registerOption(this);
        }
    }
    Object.defineProperty(NgSelectMultipleOption.prototype, "ngValue", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (this._select == null)
                return;
            this._value = value;
            this._setElementValue(_buildValueString$1(this.id, value));
            this._select.writeValue(this._select.value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgSelectMultipleOption.prototype, "value", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (this._select) {
                this._value = value;
                this._setElementValue(_buildValueString$1(this.id, value));
                this._select.writeValue(this._select.value);
            }
            else {
                this._setElementValue(value);
            }
        },
        enumerable: true,
        configurable: true
    });
    /** @internal */
    /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    NgSelectMultipleOption.prototype._setElementValue = /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this._renderer.setProperty(this._element.nativeElement, 'value', value);
    };
    /** @internal */
    /**
     * \@internal
     * @param {?} selected
     * @return {?}
     */
    NgSelectMultipleOption.prototype._setSelected = /**
     * \@internal
     * @param {?} selected
     * @return {?}
     */
    function (selected) {
        this._renderer.setProperty(this._element.nativeElement, 'selected', selected);
    };
    /**
     * @return {?}
     */
    NgSelectMultipleOption.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        if (this._select) {
            this._select._optionMap.delete(this.id);
            this._select.writeValue(this._select.value);
        }
    };
    NgSelectMultipleOption.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{ selector: 'option' },] },
    ];
    /** @nocollapse */
    NgSelectMultipleOption.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Renderer2"], },
        { type: SelectMultipleControlValueAccessor, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Host"] },] },
    ]; };
    NgSelectMultipleOption.propDecorators = {
        "ngValue": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"], args: ['ngValue',] },],
        "value": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"], args: ['value',] },],
    };
    return NgSelectMultipleOption;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @param {?} name
 * @param {?} parent
 * @return {?}
 */
function controlPath(name, parent) {
    return /** @type {?} */ ((parent.path)).concat([name]);
}
/**
 * @param {?} control
 * @param {?} dir
 * @return {?}
 */
function setUpControl(control, dir) {
    if (!control)
        _throwError(dir, 'Cannot find control with');
    if (!dir.valueAccessor)
        _throwError(dir, 'No value accessor for form control with');
    control.validator = Validators.compose([/** @type {?} */ ((control.validator)), dir.validator]);
    control.asyncValidator = Validators.composeAsync([/** @type {?} */ ((control.asyncValidator)), dir.asyncValidator]); /** @type {?} */
    ((dir.valueAccessor)).writeValue(control.value);
    setUpViewChangePipeline(control, dir);
    setUpModelChangePipeline(control, dir);
    setUpBlurPipeline(control, dir);
    if (/** @type {?} */ ((dir.valueAccessor)).setDisabledState) {
        control.registerOnDisabledChange(function (isDisabled) { /** @type {?} */ ((/** @type {?} */ ((dir.valueAccessor)).setDisabledState))(isDisabled); });
    }
    // re-run validation when validator binding changes, e.g. minlength=3 -> minlength=4
    dir._rawValidators.forEach(function (validator) {
        if ((/** @type {?} */ (validator)).registerOnValidatorChange)
            /** @type {?} */ (((/** @type {?} */ (validator)).registerOnValidatorChange))(function () { return control.updateValueAndValidity(); });
    });
    dir._rawAsyncValidators.forEach(function (validator) {
        if ((/** @type {?} */ (validator)).registerOnValidatorChange)
            /** @type {?} */ (((/** @type {?} */ (validator)).registerOnValidatorChange))(function () { return control.updateValueAndValidity(); });
    });
}
/**
 * @param {?} control
 * @param {?} dir
 * @return {?}
 */
function cleanUpControl(control, dir) {
    /** @type {?} */ ((dir.valueAccessor)).registerOnChange(function () { return _noControlError(dir); }); /** @type {?} */
    ((dir.valueAccessor)).registerOnTouched(function () { return _noControlError(dir); });
    dir._rawValidators.forEach(function (validator) {
        if (validator.registerOnValidatorChange) {
            validator.registerOnValidatorChange(null);
        }
    });
    dir._rawAsyncValidators.forEach(function (validator) {
        if (validator.registerOnValidatorChange) {
            validator.registerOnValidatorChange(null);
        }
    });
    if (control)
        control._clearChangeFns();
}
/**
 * @param {?} control
 * @param {?} dir
 * @return {?}
 */
function setUpViewChangePipeline(control, dir) {
    /** @type {?} */ ((dir.valueAccessor)).registerOnChange(function (newValue) {
        control._pendingValue = newValue;
        control._pendingChange = true;
        control._pendingDirty = true;
        if (control.updateOn === 'change')
            updateControl(control, dir);
    });
}
/**
 * @param {?} control
 * @param {?} dir
 * @return {?}
 */
function setUpBlurPipeline(control, dir) {
    /** @type {?} */ ((dir.valueAccessor)).registerOnTouched(function () {
        control._pendingTouched = true;
        if (control.updateOn === 'blur' && control._pendingChange)
            updateControl(control, dir);
        if (control.updateOn !== 'submit')
            control.markAsTouched();
    });
}
/**
 * @param {?} control
 * @param {?} dir
 * @return {?}
 */
function updateControl(control, dir) {
    dir.viewToModelUpdate(control._pendingValue);
    if (control._pendingDirty)
        control.markAsDirty();
    control.setValue(control._pendingValue, { emitModelToViewChange: false });
    control._pendingChange = false;
}
/**
 * @param {?} control
 * @param {?} dir
 * @return {?}
 */
function setUpModelChangePipeline(control, dir) {
    control.registerOnChange(function (newValue, emitModelEvent) {
        /** @type {?} */ ((
        // control -> view
        dir.valueAccessor)).writeValue(newValue);
        // control -> ngModel
        if (emitModelEvent)
            dir.viewToModelUpdate(newValue);
    });
}
/**
 * @param {?} control
 * @param {?} dir
 * @return {?}
 */
function setUpFormContainer(control, dir) {
    if (control == null)
        _throwError(dir, 'Cannot find control with');
    control.validator = Validators.compose([control.validator, dir.validator]);
    control.asyncValidator = Validators.composeAsync([control.asyncValidator, dir.asyncValidator]);
}
/**
 * @param {?} dir
 * @return {?}
 */
function _noControlError(dir) {
    return _throwError(dir, 'There is no FormControl instance attached to form control element with');
}
/**
 * @param {?} dir
 * @param {?} message
 * @return {?}
 */
function _throwError(dir, message) {
    var /** @type {?} */ messageEnd;
    if (/** @type {?} */ ((dir.path)).length > 1) {
        messageEnd = "path: '" + (/** @type {?} */ ((dir.path))).join(' -> ') + "'";
    }
    else if (/** @type {?} */ ((dir.path))[0]) {
        messageEnd = "name: '" + dir.path + "'";
    }
    else {
        messageEnd = 'unspecified name attribute';
    }
    throw new Error(message + " " + messageEnd);
}
/**
 * @param {?} validators
 * @return {?}
 */
function composeValidators(validators) {
    return validators != null ? Validators.compose(validators.map(normalizeValidator)) : null;
}
/**
 * @param {?} validators
 * @return {?}
 */
function composeAsyncValidators(validators) {
    return validators != null ? Validators.composeAsync(validators.map(normalizeAsyncValidator)) :
        null;
}
/**
 * @param {?} changes
 * @param {?} viewModel
 * @return {?}
 */
function isPropertyUpdated(changes, viewModel) {
    if (!changes.hasOwnProperty('model'))
        return false;
    var /** @type {?} */ change = changes['model'];
    if (change.isFirstChange())
        return true;
    return !Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵlooseIdentical"])(viewModel, change.currentValue);
}
var BUILTIN_ACCESSORS = [
    CheckboxControlValueAccessor,
    RangeValueAccessor,
    NumberValueAccessor,
    SelectControlValueAccessor,
    SelectMultipleControlValueAccessor,
    RadioControlValueAccessor,
];
/**
 * @param {?} valueAccessor
 * @return {?}
 */
function isBuiltInAccessor(valueAccessor) {
    return BUILTIN_ACCESSORS.some(function (a) { return valueAccessor.constructor === a; });
}
/**
 * @param {?} form
 * @param {?} directives
 * @return {?}
 */
function syncPendingControls(form, directives) {
    form._syncPendingControls();
    directives.forEach(function (dir) {
        var /** @type {?} */ control = /** @type {?} */ (dir.control);
        if (control.updateOn === 'submit' && control._pendingChange) {
            dir.viewToModelUpdate(control._pendingValue);
            control._pendingChange = false;
        }
    });
}
/**
 * @param {?} dir
 * @param {?} valueAccessors
 * @return {?}
 */
function selectValueAccessor(dir, valueAccessors) {
    if (!valueAccessors)
        return null;
    if (!Array.isArray(valueAccessors))
        _throwError(dir, 'Value accessor was not provided as an array for form control with');
    var /** @type {?} */ defaultAccessor = undefined;
    var /** @type {?} */ builtinAccessor = undefined;
    var /** @type {?} */ customAccessor = undefined;
    valueAccessors.forEach(function (v) {
        if (v.constructor === DefaultValueAccessor) {
            defaultAccessor = v;
        }
        else if (isBuiltInAccessor(v)) {
            if (builtinAccessor)
                _throwError(dir, 'More than one built-in value accessor matches form control with');
            builtinAccessor = v;
        }
        else {
            if (customAccessor)
                _throwError(dir, 'More than one custom value accessor matches form control with');
            customAccessor = v;
        }
    });
    if (customAccessor)
        return customAccessor;
    if (builtinAccessor)
        return builtinAccessor;
    if (defaultAccessor)
        return defaultAccessor;
    _throwError(dir, 'No valid value accessor for form control with');
    return null;
}
/**
 * @template T
 * @param {?} list
 * @param {?} el
 * @return {?}
 */
function removeDir(list, el) {
    var /** @type {?} */ index = list.indexOf(el);
    if (index > -1)
        list.splice(index, 1);
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * This is a base class for code shared between {\@link NgModelGroup} and {\@link FormGroupName}.
 *
 * \@stable
 */
var AbstractFormGroupDirective = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __extends */])(AbstractFormGroupDirective, _super);
    function AbstractFormGroupDirective() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @return {?}
     */
    AbstractFormGroupDirective.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this._checkParentType(); /** @type {?} */
        ((this.formDirective)).addFormGroup(this);
    };
    /**
     * @return {?}
     */
    AbstractFormGroupDirective.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        if (this.formDirective) {
            this.formDirective.removeFormGroup(this);
        }
    };
    Object.defineProperty(AbstractFormGroupDirective.prototype, "control", {
        /**
         * Get the {@link FormGroup} backing this binding.
         */
        get: /**
         * Get the {\@link FormGroup} backing this binding.
         * @return {?}
         */
        function () { return /** @type {?} */ ((this.formDirective)).getFormGroup(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractFormGroupDirective.prototype, "path", {
        /**
         * Get the path to this control group.
         */
        get: /**
         * Get the path to this control group.
         * @return {?}
         */
        function () { return controlPath(this.name, this._parent); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractFormGroupDirective.prototype, "formDirective", {
        /**
         * Get the {@link Form} to which this group belongs.
         */
        get: /**
         * Get the {\@link Form} to which this group belongs.
         * @return {?}
         */
        function () { return this._parent ? this._parent.formDirective : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractFormGroupDirective.prototype, "validator", {
        get: /**
         * @return {?}
         */
        function () { return composeValidators(this._validators); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractFormGroupDirective.prototype, "asyncValidator", {
        get: /**
         * @return {?}
         */
        function () {
            return composeAsyncValidators(this._asyncValidators);
        },
        enumerable: true,
        configurable: true
    });
    /** @internal */
    /**
     * \@internal
     * @return {?}
     */
    AbstractFormGroupDirective.prototype._checkParentType = /**
     * \@internal
     * @return {?}
     */
    function () { };
    return AbstractFormGroupDirective;
}(ControlContainer));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var AbstractControlStatus = /** @class */ (function () {
    function AbstractControlStatus(cd) {
        this._cd = cd;
    }
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassUntouched", {
        get: /**
         * @return {?}
         */
        function () { return this._cd.control ? this._cd.control.untouched : false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassTouched", {
        get: /**
         * @return {?}
         */
        function () { return this._cd.control ? this._cd.control.touched : false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassPristine", {
        get: /**
         * @return {?}
         */
        function () { return this._cd.control ? this._cd.control.pristine : false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassDirty", {
        get: /**
         * @return {?}
         */
        function () { return this._cd.control ? this._cd.control.dirty : false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassValid", {
        get: /**
         * @return {?}
         */
        function () { return this._cd.control ? this._cd.control.valid : false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassInvalid", {
        get: /**
         * @return {?}
         */
        function () { return this._cd.control ? this._cd.control.invalid : false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassPending", {
        get: /**
         * @return {?}
         */
        function () { return this._cd.control ? this._cd.control.pending : false; },
        enumerable: true,
        configurable: true
    });
    return AbstractControlStatus;
}());
var ngControlStatusHost = {
    '[class.ng-untouched]': 'ngClassUntouched',
    '[class.ng-touched]': 'ngClassTouched',
    '[class.ng-pristine]': 'ngClassPristine',
    '[class.ng-dirty]': 'ngClassDirty',
    '[class.ng-valid]': 'ngClassValid',
    '[class.ng-invalid]': 'ngClassInvalid',
    '[class.ng-pending]': 'ngClassPending',
};
/**
 * Directive automatically applied to Angular form controls that sets CSS classes
 * based on control status. The following classes are applied as the properties
 * become true:
 *
 * * ng-valid
 * * ng-invalid
 * * ng-pending
 * * ng-pristine
 * * ng-dirty
 * * ng-untouched
 * * ng-touched
 *
 * \@stable
 */
var NgControlStatus = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __extends */])(NgControlStatus, _super);
    function NgControlStatus(cd) {
        return _super.call(this, cd) || this;
    }
    NgControlStatus.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{ selector: '[formControlName],[ngModel],[formControl]', host: ngControlStatusHost },] },
    ];
    /** @nocollapse */
    NgControlStatus.ctorParameters = function () { return [
        { type: NgControl, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] },] },
    ]; };
    return NgControlStatus;
}(AbstractControlStatus));
/**
 * Directive automatically applied to Angular form groups that sets CSS classes
 * based on control status (valid/invalid/dirty/etc).
 *
 * \@stable
 */
var NgControlStatusGroup = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __extends */])(NgControlStatusGroup, _super);
    function NgControlStatusGroup(cd) {
        return _super.call(this, cd) || this;
    }
    NgControlStatusGroup.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{
                    selector: '[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]',
                    host: ngControlStatusHost
                },] },
    ];
    /** @nocollapse */
    NgControlStatusGroup.ctorParameters = function () { return [
        { type: ControlContainer, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] },] },
    ]; };
    return NgControlStatusGroup;
}(AbstractControlStatus));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Indicates that a FormControl is valid, i.e. that no errors exist in the input value.
 */
var VALID = 'VALID';
/**
 * Indicates that a FormControl is invalid, i.e. that an error exists in the input value.
 */
var INVALID = 'INVALID';
/**
 * Indicates that a FormControl is pending, i.e. that async validation is occurring and
 * errors are not yet available for the input value.
 */
var PENDING = 'PENDING';
/**
 * Indicates that a FormControl is disabled, i.e. that the control is exempt from ancestor
 * calculations of validity or value.
 */
var DISABLED = 'DISABLED';
/**
 * @param {?} control
 * @param {?} path
 * @param {?} delimiter
 * @return {?}
 */
function _find(control, path, delimiter) {
    if (path == null)
        return null;
    if (!(path instanceof Array)) {
        path = (/** @type {?} */ (path)).split(delimiter);
    }
    if (path instanceof Array && (path.length === 0))
        return null;
    return (/** @type {?} */ (path)).reduce(function (v, name) {
        if (v instanceof FormGroup) {
            return v.controls[name] || null;
        }
        if (v instanceof FormArray) {
            return v.at(/** @type {?} */ (name)) || null;
        }
        return null;
    }, control);
}
/**
 * @param {?=} validatorOrOpts
 * @return {?}
 */
function coerceToValidator(validatorOrOpts) {
    var /** @type {?} */ validator = /** @type {?} */ ((isOptionsObj(validatorOrOpts) ? (/** @type {?} */ (validatorOrOpts)).validators :
        validatorOrOpts));
    return Array.isArray(validator) ? composeValidators(validator) : validator || null;
}
/**
 * @param {?=} asyncValidator
 * @param {?=} validatorOrOpts
 * @return {?}
 */
function coerceToAsyncValidator(asyncValidator, validatorOrOpts) {
    var /** @type {?} */ origAsyncValidator = /** @type {?} */ ((isOptionsObj(validatorOrOpts) ? (/** @type {?} */ (validatorOrOpts)).asyncValidators :
        asyncValidator));
    return Array.isArray(origAsyncValidator) ? composeAsyncValidators(origAsyncValidator) :
        origAsyncValidator || null;
}
/**
 * @record
 */

/**
 * @param {?=} validatorOrOpts
 * @return {?}
 */
function isOptionsObj(validatorOrOpts) {
    return validatorOrOpts != null && !Array.isArray(validatorOrOpts) &&
        typeof validatorOrOpts === 'object';
}
/**
 * \@whatItDoes This is the base class for {\@link FormControl}, {\@link FormGroup}, and
 * {\@link FormArray}.
 *
 * It provides some of the shared behavior that all controls and groups of controls have, like
 * running validators, calculating status, and resetting state. It also defines the properties
 * that are shared between all sub-classes, like `value`, `valid`, and `dirty`. It shouldn't be
 * instantiated directly.
 *
 * \@stable
 * @abstract
 */
var AbstractControl = /** @class */ (function () {
    function AbstractControl(validator, asyncValidator) {
        this.validator = validator;
        this.asyncValidator = asyncValidator;
        /**
         * \@internal
         */
        this._onCollectionChange = function () { };
        /**
         * A control is `pristine` if the user has not yet changed
         * the value in the UI.
         *
         * Note that programmatic changes to a control's value will
         * *not* mark it dirty.
         */
        this.pristine = true;
        /**
         * A control is marked `touched` once the user has triggered
         * a `blur` event on it.
         */
        this.touched = false;
        /**
         * \@internal
         */
        this._onDisabledChange = [];
    }
    Object.defineProperty(AbstractControl.prototype, "parent", {
        /**
         * The parent control.
         */
        get: /**
         * The parent control.
         * @return {?}
         */
        function () { return this._parent; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "valid", {
        /**
         * A control is `valid` when its `status === VALID`.
         *
         * In order to have this status, the control must have passed all its
         * validation checks.
         */
        get: /**
         * A control is `valid` when its `status === VALID`.
         *
         * In order to have this status, the control must have passed all its
         * validation checks.
         * @return {?}
         */
        function () { return this.status === VALID; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "invalid", {
        /**
         * A control is `invalid` when its `status === INVALID`.
         *
         * In order to have this status, the control must have failed
         * at least one of its validation checks.
         */
        get: /**
         * A control is `invalid` when its `status === INVALID`.
         *
         * In order to have this status, the control must have failed
         * at least one of its validation checks.
         * @return {?}
         */
        function () { return this.status === INVALID; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "pending", {
        /**
         * A control is `pending` when its `status === PENDING`.
         *
         * In order to have this status, the control must be in the
         * middle of conducting a validation check.
         */
        get: /**
         * A control is `pending` when its `status === PENDING`.
         *
         * In order to have this status, the control must be in the
         * middle of conducting a validation check.
         * @return {?}
         */
        function () { return this.status == PENDING; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "disabled", {
        /**
         * A control is `disabled` when its `status === DISABLED`.
         *
         * Disabled controls are exempt from validation checks and
         * are not included in the aggregate value of their ancestor
         * controls.
         */
        get: /**
         * A control is `disabled` when its `status === DISABLED`.
         *
         * Disabled controls are exempt from validation checks and
         * are not included in the aggregate value of their ancestor
         * controls.
         * @return {?}
         */
        function () { return this.status === DISABLED; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "enabled", {
        /**
         * A control is `enabled` as long as its `status !== DISABLED`.
         *
         * In other words, it has a status of `VALID`, `INVALID`, or
         * `PENDING`.
         */
        get: /**
         * A control is `enabled` as long as its `status !== DISABLED`.
         *
         * In other words, it has a status of `VALID`, `INVALID`, or
         * `PENDING`.
         * @return {?}
         */
        function () { return this.status !== DISABLED; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "dirty", {
        /**
         * A control is `dirty` if the user has changed the value
         * in the UI.
         *
         * Note that programmatic changes to a control's value will
         * *not* mark it dirty.
         */
        get: /**
         * A control is `dirty` if the user has changed the value
         * in the UI.
         *
         * Note that programmatic changes to a control's value will
         * *not* mark it dirty.
         * @return {?}
         */
        function () { return !this.pristine; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "untouched", {
        /**
         * A control is `untouched` if the user has not yet triggered
         * a `blur` event on it.
         */
        get: /**
         * A control is `untouched` if the user has not yet triggered
         * a `blur` event on it.
         * @return {?}
         */
        function () { return !this.touched; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "updateOn", {
        /**
         * Returns the update strategy of the `AbstractControl` (i.e.
         * the event on which the control will update itself).
         * Possible values: `'change'` (default) | `'blur'` | `'submit'`
         */
        get: /**
         * Returns the update strategy of the `AbstractControl` (i.e.
         * the event on which the control will update itself).
         * Possible values: `'change'` (default) | `'blur'` | `'submit'`
         * @return {?}
         */
        function () {
            return this._updateOn ? this._updateOn : (this.parent ? this.parent.updateOn : 'change');
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Sets the synchronous validators that are active on this control.  Calling
     * this will overwrite any existing sync validators.
     */
    /**
     * Sets the synchronous validators that are active on this control.  Calling
     * this will overwrite any existing sync validators.
     * @param {?} newValidator
     * @return {?}
     */
    AbstractControl.prototype.setValidators = /**
     * Sets the synchronous validators that are active on this control.  Calling
     * this will overwrite any existing sync validators.
     * @param {?} newValidator
     * @return {?}
     */
    function (newValidator) {
        this.validator = coerceToValidator(newValidator);
    };
    /**
     * Sets the async validators that are active on this control. Calling this
     * will overwrite any existing async validators.
     */
    /**
     * Sets the async validators that are active on this control. Calling this
     * will overwrite any existing async validators.
     * @param {?} newValidator
     * @return {?}
     */
    AbstractControl.prototype.setAsyncValidators = /**
     * Sets the async validators that are active on this control. Calling this
     * will overwrite any existing async validators.
     * @param {?} newValidator
     * @return {?}
     */
    function (newValidator) {
        this.asyncValidator = coerceToAsyncValidator(newValidator);
    };
    /**
     * Empties out the sync validator list.
     */
    /**
     * Empties out the sync validator list.
     * @return {?}
     */
    AbstractControl.prototype.clearValidators = /**
     * Empties out the sync validator list.
     * @return {?}
     */
    function () { this.validator = null; };
    /**
     * Empties out the async validator list.
     */
    /**
     * Empties out the async validator list.
     * @return {?}
     */
    AbstractControl.prototype.clearAsyncValidators = /**
     * Empties out the async validator list.
     * @return {?}
     */
    function () { this.asyncValidator = null; };
    /**
     * Marks the control as `touched`.
     *
     * This will also mark all direct ancestors as `touched` to maintain
     * the model.
     */
    /**
     * Marks the control as `touched`.
     *
     * This will also mark all direct ancestors as `touched` to maintain
     * the model.
     * @param {?=} opts
     * @return {?}
     */
    AbstractControl.prototype.markAsTouched = /**
     * Marks the control as `touched`.
     *
     * This will also mark all direct ancestors as `touched` to maintain
     * the model.
     * @param {?=} opts
     * @return {?}
     */
    function (opts) {
        if (opts === void 0) { opts = {}; }
        (/** @type {?} */ (this)).touched = true;
        if (this._parent && !opts.onlySelf) {
            this._parent.markAsTouched(opts);
        }
    };
    /**
     * Marks the control as `untouched`.
     *
     * If the control has any children, it will also mark all children as `untouched`
     * to maintain the model, and re-calculate the `touched` status of all parent
     * controls.
     */
    /**
     * Marks the control as `untouched`.
     *
     * If the control has any children, it will also mark all children as `untouched`
     * to maintain the model, and re-calculate the `touched` status of all parent
     * controls.
     * @param {?=} opts
     * @return {?}
     */
    AbstractControl.prototype.markAsUntouched = /**
     * Marks the control as `untouched`.
     *
     * If the control has any children, it will also mark all children as `untouched`
     * to maintain the model, and re-calculate the `touched` status of all parent
     * controls.
     * @param {?=} opts
     * @return {?}
     */
    function (opts) {
        if (opts === void 0) { opts = {}; }
        (/** @type {?} */ (this)).touched = false;
        this._pendingTouched = false;
        this._forEachChild(function (control) { control.markAsUntouched({ onlySelf: true }); });
        if (this._parent && !opts.onlySelf) {
            this._parent._updateTouched(opts);
        }
    };
    /**
     * Marks the control as `dirty`.
     *
     * This will also mark all direct ancestors as `dirty` to maintain
     * the model.
     */
    /**
     * Marks the control as `dirty`.
     *
     * This will also mark all direct ancestors as `dirty` to maintain
     * the model.
     * @param {?=} opts
     * @return {?}
     */
    AbstractControl.prototype.markAsDirty = /**
     * Marks the control as `dirty`.
     *
     * This will also mark all direct ancestors as `dirty` to maintain
     * the model.
     * @param {?=} opts
     * @return {?}
     */
    function (opts) {
        if (opts === void 0) { opts = {}; }
        (/** @type {?} */ (this)).pristine = false;
        if (this._parent && !opts.onlySelf) {
            this._parent.markAsDirty(opts);
        }
    };
    /**
     * Marks the control as `pristine`.
     *
     * If the control has any children, it will also mark all children as `pristine`
     * to maintain the model, and re-calculate the `pristine` status of all parent
     * controls.
     */
    /**
     * Marks the control as `pristine`.
     *
     * If the control has any children, it will also mark all children as `pristine`
     * to maintain the model, and re-calculate the `pristine` status of all parent
     * controls.
     * @param {?=} opts
     * @return {?}
     */
    AbstractControl.prototype.markAsPristine = /**
     * Marks the control as `pristine`.
     *
     * If the control has any children, it will also mark all children as `pristine`
     * to maintain the model, and re-calculate the `pristine` status of all parent
     * controls.
     * @param {?=} opts
     * @return {?}
     */
    function (opts) {
        if (opts === void 0) { opts = {}; }
        (/** @type {?} */ (this)).pristine = true;
        this._pendingDirty = false;
        this._forEachChild(function (control) { control.markAsPristine({ onlySelf: true }); });
        if (this._parent && !opts.onlySelf) {
            this._parent._updatePristine(opts);
        }
    };
    /**
     * Marks the control as `pending`.
     */
    /**
     * Marks the control as `pending`.
     * @param {?=} opts
     * @return {?}
     */
    AbstractControl.prototype.markAsPending = /**
     * Marks the control as `pending`.
     * @param {?=} opts
     * @return {?}
     */
    function (opts) {
        if (opts === void 0) { opts = {}; }
        (/** @type {?} */ (this)).status = PENDING;
        if (this._parent && !opts.onlySelf) {
            this._parent.markAsPending(opts);
        }
    };
    /**
     * Disables the control. This means the control will be exempt from validation checks and
     * excluded from the aggregate value of any parent. Its status is `DISABLED`.
     *
     * If the control has children, all children will be disabled to maintain the model.
     */
    /**
     * Disables the control. This means the control will be exempt from validation checks and
     * excluded from the aggregate value of any parent. Its status is `DISABLED`.
     *
     * If the control has children, all children will be disabled to maintain the model.
     * @param {?=} opts
     * @return {?}
     */
    AbstractControl.prototype.disable = /**
     * Disables the control. This means the control will be exempt from validation checks and
     * excluded from the aggregate value of any parent. Its status is `DISABLED`.
     *
     * If the control has children, all children will be disabled to maintain the model.
     * @param {?=} opts
     * @return {?}
     */
    function (opts) {
        if (opts === void 0) { opts = {}; }
        (/** @type {?} */ (this)).status = DISABLED;
        (/** @type {?} */ (this)).errors = null;
        this._forEachChild(function (control) { control.disable(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, opts, { onlySelf: true })); });
        this._updateValue();
        if (opts.emitEvent !== false) {
            (/** @type {?} */ (this.valueChanges)).emit(this.value);
            (/** @type {?} */ (this.statusChanges)).emit(this.status);
        }
        this._updateAncestors(opts);
        this._onDisabledChange.forEach(function (changeFn) { return changeFn(true); });
    };
    /**
     * Enables the control. This means the control will be included in validation checks and
     * the aggregate value of its parent. Its status is re-calculated based on its value and
     * its validators.
     *
     * If the control has children, all children will be enabled.
     */
    /**
     * Enables the control. This means the control will be included in validation checks and
     * the aggregate value of its parent. Its status is re-calculated based on its value and
     * its validators.
     *
     * If the control has children, all children will be enabled.
     * @param {?=} opts
     * @return {?}
     */
    AbstractControl.prototype.enable = /**
     * Enables the control. This means the control will be included in validation checks and
     * the aggregate value of its parent. Its status is re-calculated based on its value and
     * its validators.
     *
     * If the control has children, all children will be enabled.
     * @param {?=} opts
     * @return {?}
     */
    function (opts) {
        if (opts === void 0) { opts = {}; }
        (/** @type {?} */ (this)).status = VALID;
        this._forEachChild(function (control) { control.enable(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, opts, { onlySelf: true })); });
        this.updateValueAndValidity({ onlySelf: true, emitEvent: opts.emitEvent });
        this._updateAncestors(opts);
        this._onDisabledChange.forEach(function (changeFn) { return changeFn(false); });
    };
    /**
     * @param {?} opts
     * @return {?}
     */
    AbstractControl.prototype._updateAncestors = /**
     * @param {?} opts
     * @return {?}
     */
    function (opts) {
        if (this._parent && !opts.onlySelf) {
            this._parent.updateValueAndValidity(opts);
            this._parent._updatePristine();
            this._parent._updateTouched();
        }
    };
    /**
     * @param {?} parent
     * @return {?}
     */
    AbstractControl.prototype.setParent = /**
     * @param {?} parent
     * @return {?}
     */
    function (parent) { this._parent = parent; };
    /**
     * Re-calculates the value and validation status of the control.
     *
     * By default, it will also update the value and validity of its ancestors.
     */
    /**
     * Re-calculates the value and validation status of the control.
     *
     * By default, it will also update the value and validity of its ancestors.
     * @param {?=} opts
     * @return {?}
     */
    AbstractControl.prototype.updateValueAndValidity = /**
     * Re-calculates the value and validation status of the control.
     *
     * By default, it will also update the value and validity of its ancestors.
     * @param {?=} opts
     * @return {?}
     */
    function (opts) {
        if (opts === void 0) { opts = {}; }
        this._setInitialStatus();
        this._updateValue();
        if (this.enabled) {
            this._cancelExistingSubscription();
            (/** @type {?} */ (this)).errors = this._runValidator();
            (/** @type {?} */ (this)).status = this._calculateStatus();
            if (this.status === VALID || this.status === PENDING) {
                this._runAsyncValidator(opts.emitEvent);
            }
        }
        if (opts.emitEvent !== false) {
            (/** @type {?} */ (this.valueChanges)).emit(this.value);
            (/** @type {?} */ (this.statusChanges)).emit(this.status);
        }
        if (this._parent && !opts.onlySelf) {
            this._parent.updateValueAndValidity(opts);
        }
    };
    /** @internal */
    /**
     * \@internal
     * @param {?=} opts
     * @return {?}
     */
    AbstractControl.prototype._updateTreeValidity = /**
     * \@internal
     * @param {?=} opts
     * @return {?}
     */
    function (opts) {
        if (opts === void 0) { opts = { emitEvent: true }; }
        this._forEachChild(function (ctrl) { return ctrl._updateTreeValidity(opts); });
        this.updateValueAndValidity({ onlySelf: true, emitEvent: opts.emitEvent });
    };
    /**
     * @return {?}
     */
    AbstractControl.prototype._setInitialStatus = /**
     * @return {?}
     */
    function () {
        (/** @type {?} */ (this)).status = this._allControlsDisabled() ? DISABLED : VALID;
    };
    /**
     * @return {?}
     */
    AbstractControl.prototype._runValidator = /**
     * @return {?}
     */
    function () {
        return this.validator ? this.validator(this) : null;
    };
    /**
     * @param {?=} emitEvent
     * @return {?}
     */
    AbstractControl.prototype._runAsyncValidator = /**
     * @param {?=} emitEvent
     * @return {?}
     */
    function (emitEvent) {
        var _this = this;
        if (this.asyncValidator) {
            (/** @type {?} */ (this)).status = PENDING;
            var /** @type {?} */ obs = toObservable(this.asyncValidator(this));
            this._asyncValidationSubscription =
                obs.subscribe(function (errors) { return _this.setErrors(errors, { emitEvent: emitEvent }); });
        }
    };
    /**
     * @return {?}
     */
    AbstractControl.prototype._cancelExistingSubscription = /**
     * @return {?}
     */
    function () {
        if (this._asyncValidationSubscription) {
            this._asyncValidationSubscription.unsubscribe();
        }
    };
    /**
     * Sets errors on a form control.
     *
     * This is used when validations are run manually by the user, rather than automatically.
     *
     * Calling `setErrors` will also update the validity of the parent control.
     *
     * ### Example
     *
     * ```
     * const login = new FormControl("someLogin");
     * login.setErrors({
     *   "notUnique": true
     * });
     *
     * expect(login.valid).toEqual(false);
     * expect(login.errors).toEqual({"notUnique": true});
     *
     * login.setValue("someOtherLogin");
     *
     * expect(login.valid).toEqual(true);
     * ```
     */
    /**
     * Sets errors on a form control.
     *
     * This is used when validations are run manually by the user, rather than automatically.
     *
     * Calling `setErrors` will also update the validity of the parent control.
     *
     * ### Example
     *
     * ```
     * const login = new FormControl("someLogin");
     * login.setErrors({
     *   "notUnique": true
     * });
     *
     * expect(login.valid).toEqual(false);
     * expect(login.errors).toEqual({"notUnique": true});
     *
     * login.setValue("someOtherLogin");
     *
     * expect(login.valid).toEqual(true);
     * ```
     * @param {?} errors
     * @param {?=} opts
     * @return {?}
     */
    AbstractControl.prototype.setErrors = /**
     * Sets errors on a form control.
     *
     * This is used when validations are run manually by the user, rather than automatically.
     *
     * Calling `setErrors` will also update the validity of the parent control.
     *
     * ### Example
     *
     * ```
     * const login = new FormControl("someLogin");
     * login.setErrors({
     *   "notUnique": true
     * });
     *
     * expect(login.valid).toEqual(false);
     * expect(login.errors).toEqual({"notUnique": true});
     *
     * login.setValue("someOtherLogin");
     *
     * expect(login.valid).toEqual(true);
     * ```
     * @param {?} errors
     * @param {?=} opts
     * @return {?}
     */
    function (errors, opts) {
        if (opts === void 0) { opts = {}; }
        (/** @type {?} */ (this)).errors = errors;
        this._updateControlsErrors(opts.emitEvent !== false);
    };
    /**
     * Retrieves a child control given the control's name or path.
     *
     * Paths can be passed in as an array or a string delimited by a dot.
     *
     * To get a control nested within a `person` sub-group:
     *
     * * `this.form.get('person.name');`
     *
     * -OR-
     *
     * * `this.form.get(['person', 'name']);`
     */
    /**
     * Retrieves a child control given the control's name or path.
     *
     * Paths can be passed in as an array or a string delimited by a dot.
     *
     * To get a control nested within a `person` sub-group:
     *
     * * `this.form.get('person.name');`
     *
     * -OR-
     *
     * * `this.form.get(['person', 'name']);`
     * @param {?} path
     * @return {?}
     */
    AbstractControl.prototype.get = /**
     * Retrieves a child control given the control's name or path.
     *
     * Paths can be passed in as an array or a string delimited by a dot.
     *
     * To get a control nested within a `person` sub-group:
     *
     * * `this.form.get('person.name');`
     *
     * -OR-
     *
     * * `this.form.get(['person', 'name']);`
     * @param {?} path
     * @return {?}
     */
    function (path) { return _find(this, path, '.'); };
    /**
     * Returns error data if the control with the given path has the error specified. Otherwise
     * returns null or undefined.
     *
     * If no path is given, it checks for the error on the present control.
     */
    /**
     * Returns error data if the control with the given path has the error specified. Otherwise
     * returns null or undefined.
     *
     * If no path is given, it checks for the error on the present control.
     * @param {?} errorCode
     * @param {?=} path
     * @return {?}
     */
    AbstractControl.prototype.getError = /**
     * Returns error data if the control with the given path has the error specified. Otherwise
     * returns null or undefined.
     *
     * If no path is given, it checks for the error on the present control.
     * @param {?} errorCode
     * @param {?=} path
     * @return {?}
     */
    function (errorCode, path) {
        var /** @type {?} */ control = path ? this.get(path) : this;
        return control && control.errors ? control.errors[errorCode] : null;
    };
    /**
     * Returns true if the control with the given path has the error specified. Otherwise
     * returns false.
     *
     * If no path is given, it checks for the error on the present control.
     */
    /**
     * Returns true if the control with the given path has the error specified. Otherwise
     * returns false.
     *
     * If no path is given, it checks for the error on the present control.
     * @param {?} errorCode
     * @param {?=} path
     * @return {?}
     */
    AbstractControl.prototype.hasError = /**
     * Returns true if the control with the given path has the error specified. Otherwise
     * returns false.
     *
     * If no path is given, it checks for the error on the present control.
     * @param {?} errorCode
     * @param {?=} path
     * @return {?}
     */
    function (errorCode, path) { return !!this.getError(errorCode, path); };
    Object.defineProperty(AbstractControl.prototype, "root", {
        /**
         * Retrieves the top-level ancestor of this control.
         */
        get: /**
         * Retrieves the top-level ancestor of this control.
         * @return {?}
         */
        function () {
            var /** @type {?} */ x = this;
            while (x._parent) {
                x = x._parent;
            }
            return x;
        },
        enumerable: true,
        configurable: true
    });
    /** @internal */
    /**
     * \@internal
     * @param {?} emitEvent
     * @return {?}
     */
    AbstractControl.prototype._updateControlsErrors = /**
     * \@internal
     * @param {?} emitEvent
     * @return {?}
     */
    function (emitEvent) {
        (/** @type {?} */ (this)).status = this._calculateStatus();
        if (emitEvent) {
            (/** @type {?} */ (this.statusChanges)).emit(this.status);
        }
        if (this._parent) {
            this._parent._updateControlsErrors(emitEvent);
        }
    };
    /** @internal */
    /**
     * \@internal
     * @return {?}
     */
    AbstractControl.prototype._initObservables = /**
     * \@internal
     * @return {?}
     */
    function () {
        (/** @type {?} */ (this)).valueChanges = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
        (/** @type {?} */ (this)).statusChanges = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
    };
    /**
     * @return {?}
     */
    AbstractControl.prototype._calculateStatus = /**
     * @return {?}
     */
    function () {
        if (this._allControlsDisabled())
            return DISABLED;
        if (this.errors)
            return INVALID;
        if (this._anyControlsHaveStatus(PENDING))
            return PENDING;
        if (this._anyControlsHaveStatus(INVALID))
            return INVALID;
        return VALID;
    };
    /** @internal */
    /**
     * \@internal
     * @param {?} status
     * @return {?}
     */
    AbstractControl.prototype._anyControlsHaveStatus = /**
     * \@internal
     * @param {?} status
     * @return {?}
     */
    function (status) {
        return this._anyControls(function (control) { return control.status === status; });
    };
    /** @internal */
    /**
     * \@internal
     * @return {?}
     */
    AbstractControl.prototype._anyControlsDirty = /**
     * \@internal
     * @return {?}
     */
    function () {
        return this._anyControls(function (control) { return control.dirty; });
    };
    /** @internal */
    /**
     * \@internal
     * @return {?}
     */
    AbstractControl.prototype._anyControlsTouched = /**
     * \@internal
     * @return {?}
     */
    function () {
        return this._anyControls(function (control) { return control.touched; });
    };
    /** @internal */
    /**
     * \@internal
     * @param {?=} opts
     * @return {?}
     */
    AbstractControl.prototype._updatePristine = /**
     * \@internal
     * @param {?=} opts
     * @return {?}
     */
    function (opts) {
        if (opts === void 0) { opts = {}; }
        (/** @type {?} */ (this)).pristine = !this._anyControlsDirty();
        if (this._parent && !opts.onlySelf) {
            this._parent._updatePristine(opts);
        }
    };
    /** @internal */
    /**
     * \@internal
     * @param {?=} opts
     * @return {?}
     */
    AbstractControl.prototype._updateTouched = /**
     * \@internal
     * @param {?=} opts
     * @return {?}
     */
    function (opts) {
        if (opts === void 0) { opts = {}; }
        (/** @type {?} */ (this)).touched = this._anyControlsTouched();
        if (this._parent && !opts.onlySelf) {
            this._parent._updateTouched(opts);
        }
    };
    /** @internal */
    /**
     * \@internal
     * @param {?} formState
     * @return {?}
     */
    AbstractControl.prototype._isBoxedValue = /**
     * \@internal
     * @param {?} formState
     * @return {?}
     */
    function (formState) {
        return typeof formState === 'object' && formState !== null &&
            Object.keys(formState).length === 2 && 'value' in formState && 'disabled' in formState;
    };
    /** @internal */
    /**
     * \@internal
     * @param {?} fn
     * @return {?}
     */
    AbstractControl.prototype._registerOnCollectionChange = /**
     * \@internal
     * @param {?} fn
     * @return {?}
     */
    function (fn) { this._onCollectionChange = fn; };
    /** @internal */
    /**
     * \@internal
     * @param {?=} opts
     * @return {?}
     */
    AbstractControl.prototype._setUpdateStrategy = /**
     * \@internal
     * @param {?=} opts
     * @return {?}
     */
    function (opts) {
        if (isOptionsObj(opts) && (/** @type {?} */ (opts)).updateOn != null) {
            this._updateOn = /** @type {?} */ (((/** @type {?} */ (opts)).updateOn));
        }
    };
    return AbstractControl;
}());
/**
 * \@whatItDoes Tracks the value and validation status of an individual form control.
 *
 * It is one of the three fundamental building blocks of Angular forms, along with
 * {\@link FormGroup} and {\@link FormArray}.
 *
 * \@howToUse
 *
 * When instantiating a {\@link FormControl}, you can pass in an initial value as the
 * first argument. Example:
 *
 * ```ts
 * const ctrl = new FormControl('some value');
 * console.log(ctrl.value);     // 'some value'
 * ```
 *
 * You can also initialize the control with a form state object on instantiation,
 * which includes both the value and whether or not the control is disabled.
 * You can't use the value key without the disabled key; both are required
 * to use this way of initialization.
 *
 * ```ts
 * const ctrl = new FormControl({value: 'n/a', disabled: true});
 * console.log(ctrl.value);     // 'n/a'
 * console.log(ctrl.status);   // 'DISABLED'
 * ```
 *
 * The second {\@link FormControl} argument can accept one of three things:
 * * a sync validator function
 * * an array of sync validator functions
 * * an options object containing validator and/or async validator functions
 *
 * Example of a single sync validator function:
 *
 * ```ts
 * const ctrl = new FormControl('', Validators.required);
 * console.log(ctrl.value);     // ''
 * console.log(ctrl.status);   // 'INVALID'
 * ```
 *
 * Example using options object:
 *
 * ```ts
 * const ctrl = new FormControl('', {
 *    validators: Validators.required,
 *    asyncValidators: myAsyncValidator
 * });
 * ```
 *
 * The options object can also be used to define when the control should update.
 * By default, the value and validity of a control updates whenever the value
 * changes. You can configure it to update on the blur event instead by setting
 * the `updateOn` option to `'blur'`.
 *
 * ```ts
 * const c = new FormControl('', { updateOn: 'blur' });
 * ```
 *
 * You can also set `updateOn` to `'submit'`, which will delay value and validity
 * updates until the parent form of the control fires a submit event.
 *
 * See its superclass, {\@link AbstractControl}, for more properties and methods.
 *
 * * **npm package**: `\@angular/forms`
 *
 * \@stable
 */
var FormControl = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __extends */])(FormControl, _super);
    function FormControl(formState, validatorOrOpts, asyncValidator) {
        if (formState === void 0) { formState = null; }
        var _this = _super.call(this, coerceToValidator(validatorOrOpts), coerceToAsyncValidator(asyncValidator, validatorOrOpts)) || this;
        /**
         * \@internal
         */
        _this._onChange = [];
        _this._applyFormState(formState);
        _this._setUpdateStrategy(validatorOrOpts);
        _this.updateValueAndValidity({ onlySelf: true, emitEvent: false });
        _this._initObservables();
        return _this;
    }
    /**
     * Set the value of the form control to `value`.
     *
     * If `onlySelf` is `true`, this change will only affect the validation of this `FormControl`
     * and not its parent component. This defaults to false.
     *
     * If `emitEvent` is `true`, this
     * change will cause a `valueChanges` event on the `FormControl` to be emitted. This defaults
     * to true (as it falls through to `updateValueAndValidity`).
     *
     * If `emitModelToViewChange` is `true`, the view will be notified about the new value
     * via an `onChange` event. This is the default behavior if `emitModelToViewChange` is not
     * specified.
     *
     * If `emitViewToModelChange` is `true`, an ngModelChange event will be fired to update the
     * model.  This is the default behavior if `emitViewToModelChange` is not specified.
     */
    /**
     * Set the value of the form control to `value`.
     *
     * If `onlySelf` is `true`, this change will only affect the validation of this `FormControl`
     * and not its parent component. This defaults to false.
     *
     * If `emitEvent` is `true`, this
     * change will cause a `valueChanges` event on the `FormControl` to be emitted. This defaults
     * to true (as it falls through to `updateValueAndValidity`).
     *
     * If `emitModelToViewChange` is `true`, the view will be notified about the new value
     * via an `onChange` event. This is the default behavior if `emitModelToViewChange` is not
     * specified.
     *
     * If `emitViewToModelChange` is `true`, an ngModelChange event will be fired to update the
     * model.  This is the default behavior if `emitViewToModelChange` is not specified.
     * @param {?} value
     * @param {?=} options
     * @return {?}
     */
    FormControl.prototype.setValue = /**
     * Set the value of the form control to `value`.
     *
     * If `onlySelf` is `true`, this change will only affect the validation of this `FormControl`
     * and not its parent component. This defaults to false.
     *
     * If `emitEvent` is `true`, this
     * change will cause a `valueChanges` event on the `FormControl` to be emitted. This defaults
     * to true (as it falls through to `updateValueAndValidity`).
     *
     * If `emitModelToViewChange` is `true`, the view will be notified about the new value
     * via an `onChange` event. This is the default behavior if `emitModelToViewChange` is not
     * specified.
     *
     * If `emitViewToModelChange` is `true`, an ngModelChange event will be fired to update the
     * model.  This is the default behavior if `emitViewToModelChange` is not specified.
     * @param {?} value
     * @param {?=} options
     * @return {?}
     */
    function (value, options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        (/** @type {?} */ (this)).value = this._pendingValue = value;
        if (this._onChange.length && options.emitModelToViewChange !== false) {
            this._onChange.forEach(function (changeFn) { return changeFn(_this.value, options.emitViewToModelChange !== false); });
        }
        this.updateValueAndValidity(options);
    };
    /**
     * Patches the value of a control.
     *
     * This function is functionally the same as {@link FormControl#setValue setValue} at this level.
     * It exists for symmetry with {@link FormGroup#patchValue patchValue} on `FormGroups` and
     * `FormArrays`, where it does behave differently.
     */
    /**
     * Patches the value of a control.
     *
     * This function is functionally the same as {\@link FormControl#setValue setValue} at this level.
     * It exists for symmetry with {\@link FormGroup#patchValue patchValue} on `FormGroups` and
     * `FormArrays`, where it does behave differently.
     * @param {?} value
     * @param {?=} options
     * @return {?}
     */
    FormControl.prototype.patchValue = /**
     * Patches the value of a control.
     *
     * This function is functionally the same as {\@link FormControl#setValue setValue} at this level.
     * It exists for symmetry with {\@link FormGroup#patchValue patchValue} on `FormGroups` and
     * `FormArrays`, where it does behave differently.
     * @param {?} value
     * @param {?=} options
     * @return {?}
     */
    function (value, options) {
        if (options === void 0) { options = {}; }
        this.setValue(value, options);
    };
    /**
     * Resets the form control. This means by default:
     *
     * * it is marked as `pristine`
     * * it is marked as `untouched`
     * * value is set to null
     *
     * You can also reset to a specific form state by passing through a standalone
     * value or a form state object that contains both a value and a disabled state
     * (these are the only two properties that cannot be calculated).
     *
     * Ex:
     *
     * ```ts
     * this.control.reset('Nancy');
     *
     * console.log(this.control.value);  // 'Nancy'
     * ```
     *
     * OR
     *
     * ```
     * this.control.reset({value: 'Nancy', disabled: true});
     *
     * console.log(this.control.value);  // 'Nancy'
     * console.log(this.control.status);  // 'DISABLED'
     * ```
     */
    /**
     * Resets the form control. This means by default:
     *
     * * it is marked as `pristine`
     * * it is marked as `untouched`
     * * value is set to null
     *
     * You can also reset to a specific form state by passing through a standalone
     * value or a form state object that contains both a value and a disabled state
     * (these are the only two properties that cannot be calculated).
     *
     * Ex:
     *
     * ```ts
     * this.control.reset('Nancy');
     *
     * console.log(this.control.value);  // 'Nancy'
     * ```
     *
     * OR
     *
     * ```
     * this.control.reset({value: 'Nancy', disabled: true});
     *
     * console.log(this.control.value);  // 'Nancy'
     * console.log(this.control.status);  // 'DISABLED'
     * ```
     * @param {?=} formState
     * @param {?=} options
     * @return {?}
     */
    FormControl.prototype.reset = /**
     * Resets the form control. This means by default:
     *
     * * it is marked as `pristine`
     * * it is marked as `untouched`
     * * value is set to null
     *
     * You can also reset to a specific form state by passing through a standalone
     * value or a form state object that contains both a value and a disabled state
     * (these are the only two properties that cannot be calculated).
     *
     * Ex:
     *
     * ```ts
     * this.control.reset('Nancy');
     *
     * console.log(this.control.value);  // 'Nancy'
     * ```
     *
     * OR
     *
     * ```
     * this.control.reset({value: 'Nancy', disabled: true});
     *
     * console.log(this.control.value);  // 'Nancy'
     * console.log(this.control.status);  // 'DISABLED'
     * ```
     * @param {?=} formState
     * @param {?=} options
     * @return {?}
     */
    function (formState, options) {
        if (formState === void 0) { formState = null; }
        if (options === void 0) { options = {}; }
        this._applyFormState(formState);
        this.markAsPristine(options);
        this.markAsUntouched(options);
        this.setValue(this.value, options);
        this._pendingChange = false;
    };
    /**
     * @internal
     */
    /**
     * \@internal
     * @return {?}
     */
    FormControl.prototype._updateValue = /**
     * \@internal
     * @return {?}
     */
    function () { };
    /**
     * @internal
     */
    /**
     * \@internal
     * @param {?} condition
     * @return {?}
     */
    FormControl.prototype._anyControls = /**
     * \@internal
     * @param {?} condition
     * @return {?}
     */
    function (condition) { return false; };
    /**
     * @internal
     */
    /**
     * \@internal
     * @return {?}
     */
    FormControl.prototype._allControlsDisabled = /**
     * \@internal
     * @return {?}
     */
    function () { return this.disabled; };
    /**
     * Register a listener for change events.
     */
    /**
     * Register a listener for change events.
     * @param {?} fn
     * @return {?}
     */
    FormControl.prototype.registerOnChange = /**
     * Register a listener for change events.
     * @param {?} fn
     * @return {?}
     */
    function (fn) { this._onChange.push(fn); };
    /**
     * @internal
     */
    /**
     * \@internal
     * @return {?}
     */
    FormControl.prototype._clearChangeFns = /**
     * \@internal
     * @return {?}
     */
    function () {
        this._onChange = [];
        this._onDisabledChange = [];
        this._onCollectionChange = function () { };
    };
    /**
     * Register a listener for disabled events.
     */
    /**
     * Register a listener for disabled events.
     * @param {?} fn
     * @return {?}
     */
    FormControl.prototype.registerOnDisabledChange = /**
     * Register a listener for disabled events.
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this._onDisabledChange.push(fn);
    };
    /**
     * @internal
     */
    /**
     * \@internal
     * @param {?} cb
     * @return {?}
     */
    FormControl.prototype._forEachChild = /**
     * \@internal
     * @param {?} cb
     * @return {?}
     */
    function (cb) { };
    /** @internal */
    /**
     * \@internal
     * @return {?}
     */
    FormControl.prototype._syncPendingControls = /**
     * \@internal
     * @return {?}
     */
    function () {
        if (this.updateOn === 'submit') {
            if (this._pendingDirty)
                this.markAsDirty();
            if (this._pendingTouched)
                this.markAsTouched();
            if (this._pendingChange) {
                this.setValue(this._pendingValue, { onlySelf: true, emitModelToViewChange: false });
                return true;
            }
        }
        return false;
    };
    /**
     * @param {?} formState
     * @return {?}
     */
    FormControl.prototype._applyFormState = /**
     * @param {?} formState
     * @return {?}
     */
    function (formState) {
        if (this._isBoxedValue(formState)) {
            (/** @type {?} */ (this)).value = this._pendingValue = formState.value;
            formState.disabled ? this.disable({ onlySelf: true, emitEvent: false }) :
                this.enable({ onlySelf: true, emitEvent: false });
        }
        else {
            (/** @type {?} */ (this)).value = this._pendingValue = formState;
        }
    };
    return FormControl;
}(AbstractControl));
/**
 * \@whatItDoes Tracks the value and validity state of a group of {\@link FormControl}
 * instances.
 *
 * A `FormGroup` aggregates the values of each child {\@link FormControl} into one object,
 * with each control name as the key.  It calculates its status by reducing the statuses
 * of its children. For example, if one of the controls in a group is invalid, the entire
 * group becomes invalid.
 *
 * `FormGroup` is one of the three fundamental building blocks used to define forms in Angular,
 * along with {\@link FormControl} and {\@link FormArray}.
 *
 * \@howToUse
 *
 * When instantiating a {\@link FormGroup}, pass in a collection of child controls as the first
 * argument. The key for each child will be the name under which it is registered.
 *
 * ### Example
 *
 * ```
 * const form = new FormGroup({
 *   first: new FormControl('Nancy', Validators.minLength(2)),
 *   last: new FormControl('Drew'),
 * });
 *
 * console.log(form.value);   // {first: 'Nancy', last; 'Drew'}
 * console.log(form.status);  // 'VALID'
 * ```
 *
 * You can also include group-level validators as the second arg, or group-level async
 * validators as the third arg. These come in handy when you want to perform validation
 * that considers the value of more than one child control.
 *
 * ### Example
 *
 * ```
 * const form = new FormGroup({
 *   password: new FormControl('', Validators.minLength(2)),
 *   passwordConfirm: new FormControl('', Validators.minLength(2)),
 * }, passwordMatchValidator);
 *
 *
 * function passwordMatchValidator(g: FormGroup) {
 *    return g.get('password').value === g.get('passwordConfirm').value
 *       ? null : {'mismatch': true};
 * }
 * ```
 *
 * Like {\@link FormControl} instances, you can alternatively choose to pass in
 * validators and async validators as part of an options object.
 *
 * ```
 * const form = new FormGroup({
 *   password: new FormControl('')
 *   passwordConfirm: new FormControl('')
 * }, {validators: passwordMatchValidator, asyncValidators: otherValidator});
 * ```
 *
 * The options object can also be used to set a default value for each child
 * control's `updateOn` property. If you set `updateOn` to `'blur'` at the
 * group level, all child controls will default to 'blur', unless the child
 * has explicitly specified a different `updateOn` value.
 *
 * ```ts
 * const c = new FormGroup({
 *    one: new FormControl()
 * }, {updateOn: 'blur'});
 * ```
 *
 * * **npm package**: `\@angular/forms`
 *
 * \@stable
 */
var FormGroup = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __extends */])(FormGroup, _super);
    function FormGroup(controls, validatorOrOpts, asyncValidator) {
        var _this = _super.call(this, coerceToValidator(validatorOrOpts), coerceToAsyncValidator(asyncValidator, validatorOrOpts)) || this;
        _this.controls = controls;
        _this._initObservables();
        _this._setUpdateStrategy(validatorOrOpts);
        _this._setUpControls();
        _this.updateValueAndValidity({ onlySelf: true, emitEvent: false });
        return _this;
    }
    /**
     * Registers a control with the group's list of controls.
     *
     * This method does not update the value or validity of the control, so for most cases you'll want
     * to use {@link FormGroup#addControl addControl} instead.
     */
    /**
     * Registers a control with the group's list of controls.
     *
     * This method does not update the value or validity of the control, so for most cases you'll want
     * to use {\@link FormGroup#addControl addControl} instead.
     * @param {?} name
     * @param {?} control
     * @return {?}
     */
    FormGroup.prototype.registerControl = /**
     * Registers a control with the group's list of controls.
     *
     * This method does not update the value or validity of the control, so for most cases you'll want
     * to use {\@link FormGroup#addControl addControl} instead.
     * @param {?} name
     * @param {?} control
     * @return {?}
     */
    function (name, control) {
        if (this.controls[name])
            return this.controls[name];
        this.controls[name] = control;
        control.setParent(this);
        control._registerOnCollectionChange(this._onCollectionChange);
        return control;
    };
    /**
     * Add a control to this group.
     */
    /**
     * Add a control to this group.
     * @param {?} name
     * @param {?} control
     * @return {?}
     */
    FormGroup.prototype.addControl = /**
     * Add a control to this group.
     * @param {?} name
     * @param {?} control
     * @return {?}
     */
    function (name, control) {
        this.registerControl(name, control);
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    /**
     * Remove a control from this group.
     */
    /**
     * Remove a control from this group.
     * @param {?} name
     * @return {?}
     */
    FormGroup.prototype.removeControl = /**
     * Remove a control from this group.
     * @param {?} name
     * @return {?}
     */
    function (name) {
        if (this.controls[name])
            this.controls[name]._registerOnCollectionChange(function () { });
        delete (this.controls[name]);
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    /**
     * Replace an existing control.
     */
    /**
     * Replace an existing control.
     * @param {?} name
     * @param {?} control
     * @return {?}
     */
    FormGroup.prototype.setControl = /**
     * Replace an existing control.
     * @param {?} name
     * @param {?} control
     * @return {?}
     */
    function (name, control) {
        if (this.controls[name])
            this.controls[name]._registerOnCollectionChange(function () { });
        delete (this.controls[name]);
        if (control)
            this.registerControl(name, control);
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    /**
     * Check whether there is an enabled control with the given name in the group.
     *
     * It will return false for disabled controls. If you'd like to check for existence in the group
     * only, use {@link AbstractControl#get get} instead.
     */
    /**
     * Check whether there is an enabled control with the given name in the group.
     *
     * It will return false for disabled controls. If you'd like to check for existence in the group
     * only, use {\@link AbstractControl#get get} instead.
     * @param {?} controlName
     * @return {?}
     */
    FormGroup.prototype.contains = /**
     * Check whether there is an enabled control with the given name in the group.
     *
     * It will return false for disabled controls. If you'd like to check for existence in the group
     * only, use {\@link AbstractControl#get get} instead.
     * @param {?} controlName
     * @return {?}
     */
    function (controlName) {
        return this.controls.hasOwnProperty(controlName) && this.controls[controlName].enabled;
    };
    /**
     *  Sets the value of the {@link FormGroup}. It accepts an object that matches
     *  the structure of the group, with control names as keys.
     *
     * This method performs strict checks, so it will throw an error if you try
     * to set the value of a control that doesn't exist or if you exclude the
     * value of a control.
     *
     *  ### Example
     *
     *  ```
     *  const form = new FormGroup({
     *     first: new FormControl(),
     *     last: new FormControl()
     *  });
     *  console.log(form.value);   // {first: null, last: null}
     *
     *  form.setValue({first: 'Nancy', last: 'Drew'});
     *  console.log(form.value);   // {first: 'Nancy', last: 'Drew'}
     *
     *  ```
     */
    /**
     *  Sets the value of the {\@link FormGroup}. It accepts an object that matches
     *  the structure of the group, with control names as keys.
     *
     * This method performs strict checks, so it will throw an error if you try
     * to set the value of a control that doesn't exist or if you exclude the
     * value of a control.
     *
     *  ### Example
     *
     *  ```
     *  const form = new FormGroup({
     *     first: new FormControl(),
     *     last: new FormControl()
     *  });
     *  console.log(form.value);   // {first: null, last: null}
     *
     *  form.setValue({first: 'Nancy', last: 'Drew'});
     *  console.log(form.value);   // {first: 'Nancy', last: 'Drew'}
     *
     *  ```
     * @param {?} value
     * @param {?=} options
     * @return {?}
     */
    FormGroup.prototype.setValue = /**
     *  Sets the value of the {\@link FormGroup}. It accepts an object that matches
     *  the structure of the group, with control names as keys.
     *
     * This method performs strict checks, so it will throw an error if you try
     * to set the value of a control that doesn't exist or if you exclude the
     * value of a control.
     *
     *  ### Example
     *
     *  ```
     *  const form = new FormGroup({
     *     first: new FormControl(),
     *     last: new FormControl()
     *  });
     *  console.log(form.value);   // {first: null, last: null}
     *
     *  form.setValue({first: 'Nancy', last: 'Drew'});
     *  console.log(form.value);   // {first: 'Nancy', last: 'Drew'}
     *
     *  ```
     * @param {?} value
     * @param {?=} options
     * @return {?}
     */
    function (value, options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        this._checkAllValuesPresent(value);
        Object.keys(value).forEach(function (name) {
            _this._throwIfControlMissing(name);
            _this.controls[name].setValue(value[name], { onlySelf: true, emitEvent: options.emitEvent });
        });
        this.updateValueAndValidity(options);
    };
    /**
     *  Patches the value of the {@link FormGroup}. It accepts an object with control
     *  names as keys, and will do its best to match the values to the correct controls
     *  in the group.
     *
     *  It accepts both super-sets and sub-sets of the group without throwing an error.
     *
     *  ### Example
     *
     *  ```
     *  const form = new FormGroup({
     *     first: new FormControl(),
     *     last: new FormControl()
     *  });
     *  console.log(form.value);   // {first: null, last: null}
     *
     *  form.patchValue({first: 'Nancy'});
     *  console.log(form.value);   // {first: 'Nancy', last: null}
     *
     *  ```
     */
    /**
     *  Patches the value of the {\@link FormGroup}. It accepts an object with control
     *  names as keys, and will do its best to match the values to the correct controls
     *  in the group.
     *
     *  It accepts both super-sets and sub-sets of the group without throwing an error.
     *
     *  ### Example
     *
     *  ```
     *  const form = new FormGroup({
     *     first: new FormControl(),
     *     last: new FormControl()
     *  });
     *  console.log(form.value);   // {first: null, last: null}
     *
     *  form.patchValue({first: 'Nancy'});
     *  console.log(form.value);   // {first: 'Nancy', last: null}
     *
     *  ```
     * @param {?} value
     * @param {?=} options
     * @return {?}
     */
    FormGroup.prototype.patchValue = /**
     *  Patches the value of the {\@link FormGroup}. It accepts an object with control
     *  names as keys, and will do its best to match the values to the correct controls
     *  in the group.
     *
     *  It accepts both super-sets and sub-sets of the group without throwing an error.
     *
     *  ### Example
     *
     *  ```
     *  const form = new FormGroup({
     *     first: new FormControl(),
     *     last: new FormControl()
     *  });
     *  console.log(form.value);   // {first: null, last: null}
     *
     *  form.patchValue({first: 'Nancy'});
     *  console.log(form.value);   // {first: 'Nancy', last: null}
     *
     *  ```
     * @param {?} value
     * @param {?=} options
     * @return {?}
     */
    function (value, options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        Object.keys(value).forEach(function (name) {
            if (_this.controls[name]) {
                _this.controls[name].patchValue(value[name], { onlySelf: true, emitEvent: options.emitEvent });
            }
        });
        this.updateValueAndValidity(options);
    };
    /**
     * Resets the {@link FormGroup}. This means by default:
     *
     * * The group and all descendants are marked `pristine`
     * * The group and all descendants are marked `untouched`
     * * The value of all descendants will be null or null maps
     *
     * You can also reset to a specific form state by passing in a map of states
     * that matches the structure of your form, with control names as keys. The state
     * can be a standalone value or a form state object with both a value and a disabled
     * status.
     *
     * ### Example
     *
     * ```ts
     * this.form.reset({first: 'name', last: 'last name'});
     *
     * console.log(this.form.value);  // {first: 'name', last: 'last name'}
     * ```
     *
     * - OR -
     *
     * ```
     * this.form.reset({
     *   first: {value: 'name', disabled: true},
     *   last: 'last'
     * });
     *
     * console.log(this.form.value);  // {first: 'name', last: 'last name'}
     * console.log(this.form.get('first').status);  // 'DISABLED'
     * ```
     */
    /**
     * Resets the {\@link FormGroup}. This means by default:
     *
     * * The group and all descendants are marked `pristine`
     * * The group and all descendants are marked `untouched`
     * * The value of all descendants will be null or null maps
     *
     * You can also reset to a specific form state by passing in a map of states
     * that matches the structure of your form, with control names as keys. The state
     * can be a standalone value or a form state object with both a value and a disabled
     * status.
     *
     * ### Example
     *
     * ```ts
     * this.form.reset({first: 'name', last: 'last name'});
     *
     * console.log(this.form.value);  // {first: 'name', last: 'last name'}
     * ```
     *
     * - OR -
     *
     * ```
     * this.form.reset({
     *   first: {value: 'name', disabled: true},
     *   last: 'last'
     * });
     *
     * console.log(this.form.value);  // {first: 'name', last: 'last name'}
     * console.log(this.form.get('first').status);  // 'DISABLED'
     * ```
     * @param {?=} value
     * @param {?=} options
     * @return {?}
     */
    FormGroup.prototype.reset = /**
     * Resets the {\@link FormGroup}. This means by default:
     *
     * * The group and all descendants are marked `pristine`
     * * The group and all descendants are marked `untouched`
     * * The value of all descendants will be null or null maps
     *
     * You can also reset to a specific form state by passing in a map of states
     * that matches the structure of your form, with control names as keys. The state
     * can be a standalone value or a form state object with both a value and a disabled
     * status.
     *
     * ### Example
     *
     * ```ts
     * this.form.reset({first: 'name', last: 'last name'});
     *
     * console.log(this.form.value);  // {first: 'name', last: 'last name'}
     * ```
     *
     * - OR -
     *
     * ```
     * this.form.reset({
     *   first: {value: 'name', disabled: true},
     *   last: 'last'
     * });
     *
     * console.log(this.form.value);  // {first: 'name', last: 'last name'}
     * console.log(this.form.get('first').status);  // 'DISABLED'
     * ```
     * @param {?=} value
     * @param {?=} options
     * @return {?}
     */
    function (value, options) {
        if (value === void 0) { value = {}; }
        if (options === void 0) { options = {}; }
        this._forEachChild(function (control, name) {
            control.reset(value[name], { onlySelf: true, emitEvent: options.emitEvent });
        });
        this.updateValueAndValidity(options);
        this._updatePristine(options);
        this._updateTouched(options);
    };
    /**
     * The aggregate value of the {@link FormGroup}, including any disabled controls.
     *
     * If you'd like to include all values regardless of disabled status, use this method.
     * Otherwise, the `value` property is the best way to get the value of the group.
     */
    /**
     * The aggregate value of the {\@link FormGroup}, including any disabled controls.
     *
     * If you'd like to include all values regardless of disabled status, use this method.
     * Otherwise, the `value` property is the best way to get the value of the group.
     * @return {?}
     */
    FormGroup.prototype.getRawValue = /**
     * The aggregate value of the {\@link FormGroup}, including any disabled controls.
     *
     * If you'd like to include all values regardless of disabled status, use this method.
     * Otherwise, the `value` property is the best way to get the value of the group.
     * @return {?}
     */
    function () {
        return this._reduceChildren({}, function (acc, control, name) {
            acc[name] = control instanceof FormControl ? control.value : (/** @type {?} */ (control)).getRawValue();
            return acc;
        });
    };
    /** @internal */
    /**
     * \@internal
     * @return {?}
     */
    FormGroup.prototype._syncPendingControls = /**
     * \@internal
     * @return {?}
     */
    function () {
        var /** @type {?} */ subtreeUpdated = this._reduceChildren(false, function (updated, child) {
            return child._syncPendingControls() ? true : updated;
        });
        if (subtreeUpdated)
            this.updateValueAndValidity({ onlySelf: true });
        return subtreeUpdated;
    };
    /** @internal */
    /**
     * \@internal
     * @param {?} name
     * @return {?}
     */
    FormGroup.prototype._throwIfControlMissing = /**
     * \@internal
     * @param {?} name
     * @return {?}
     */
    function (name) {
        if (!Object.keys(this.controls).length) {
            throw new Error("\n        There are no form controls registered with this group yet.  If you're using ngModel,\n        you may want to check next tick (e.g. use setTimeout).\n      ");
        }
        if (!this.controls[name]) {
            throw new Error("Cannot find form control with name: " + name + ".");
        }
    };
    /** @internal */
    /**
     * \@internal
     * @param {?} cb
     * @return {?}
     */
    FormGroup.prototype._forEachChild = /**
     * \@internal
     * @param {?} cb
     * @return {?}
     */
    function (cb) {
        var _this = this;
        Object.keys(this.controls).forEach(function (k) { return cb(_this.controls[k], k); });
    };
    /** @internal */
    /**
     * \@internal
     * @return {?}
     */
    FormGroup.prototype._setUpControls = /**
     * \@internal
     * @return {?}
     */
    function () {
        var _this = this;
        this._forEachChild(function (control) {
            control.setParent(_this);
            control._registerOnCollectionChange(_this._onCollectionChange);
        });
    };
    /** @internal */
    /**
     * \@internal
     * @return {?}
     */
    FormGroup.prototype._updateValue = /**
     * \@internal
     * @return {?}
     */
    function () { (/** @type {?} */ (this)).value = this._reduceValue(); };
    /** @internal */
    /**
     * \@internal
     * @param {?} condition
     * @return {?}
     */
    FormGroup.prototype._anyControls = /**
     * \@internal
     * @param {?} condition
     * @return {?}
     */
    function (condition) {
        var _this = this;
        var /** @type {?} */ res = false;
        this._forEachChild(function (control, name) {
            res = res || (_this.contains(name) && condition(control));
        });
        return res;
    };
    /** @internal */
    /**
     * \@internal
     * @return {?}
     */
    FormGroup.prototype._reduceValue = /**
     * \@internal
     * @return {?}
     */
    function () {
        var _this = this;
        return this._reduceChildren({}, function (acc, control, name) {
            if (control.enabled || _this.disabled) {
                acc[name] = control.value;
            }
            return acc;
        });
    };
    /** @internal */
    /**
     * \@internal
     * @param {?} initValue
     * @param {?} fn
     * @return {?}
     */
    FormGroup.prototype._reduceChildren = /**
     * \@internal
     * @param {?} initValue
     * @param {?} fn
     * @return {?}
     */
    function (initValue, fn) {
        var /** @type {?} */ res = initValue;
        this._forEachChild(function (control, name) { res = fn(res, control, name); });
        return res;
    };
    /** @internal */
    /**
     * \@internal
     * @return {?}
     */
    FormGroup.prototype._allControlsDisabled = /**
     * \@internal
     * @return {?}
     */
    function () {
        for (var _i = 0, _a = Object.keys(this.controls); _i < _a.length; _i++) {
            var controlName = _a[_i];
            if (this.controls[controlName].enabled) {
                return false;
            }
        }
        return Object.keys(this.controls).length > 0 || this.disabled;
    };
    /** @internal */
    /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    FormGroup.prototype._checkAllValuesPresent = /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this._forEachChild(function (control, name) {
            if (value[name] === undefined) {
                throw new Error("Must supply a value for form control with name: '" + name + "'.");
            }
        });
    };
    return FormGroup;
}(AbstractControl));
/**
 * \@whatItDoes Tracks the value and validity state of an array of {\@link FormControl},
 * {\@link FormGroup} or {\@link FormArray} instances.
 *
 * A `FormArray` aggregates the values of each child {\@link FormControl} into an array.
 * It calculates its status by reducing the statuses of its children. For example, if one of
 * the controls in a `FormArray` is invalid, the entire array becomes invalid.
 *
 * `FormArray` is one of the three fundamental building blocks used to define forms in Angular,
 * along with {\@link FormControl} and {\@link FormGroup}.
 *
 * \@howToUse
 *
 * When instantiating a {\@link FormArray}, pass in an array of child controls as the first
 * argument.
 *
 * ### Example
 *
 * ```
 * const arr = new FormArray([
 *   new FormControl('Nancy', Validators.minLength(2)),
 *   new FormControl('Drew'),
 * ]);
 *
 * console.log(arr.value);   // ['Nancy', 'Drew']
 * console.log(arr.status);  // 'VALID'
 * ```
 *
 * You can also include array-level validators and async validators. These come in handy
 * when you want to perform validation that considers the value of more than one child
 * control.
 *
 * The two types of validators can be passed in separately as the second and third arg
 * respectively, or together as part of an options object.
 *
 * ```
 * const arr = new FormArray([
 *   new FormControl('Nancy'),
 *   new FormControl('Drew')
 * ], {validators: myValidator, asyncValidators: myAsyncValidator});
 * ```
 *
 * The options object can also be used to set a default value for each child
 * control's `updateOn` property. If you set `updateOn` to `'blur'` at the
 * array level, all child controls will default to 'blur', unless the child
 * has explicitly specified a different `updateOn` value.
 *
 * ```ts
 * const c = new FormArray([
 *    new FormControl()
 * ], {updateOn: 'blur'});
 * ```
 *
 * ### Adding or removing controls
 *
 * To change the controls in the array, use the `push`, `insert`, or `removeAt` methods
 * in `FormArray` itself. These methods ensure the controls are properly tracked in the
 * form's hierarchy. Do not modify the array of `AbstractControl`s used to instantiate
 * the `FormArray` directly, as that will result in strange and unexpected behavior such
 * as broken change detection.
 *
 * * **npm package**: `\@angular/forms`
 *
 * \@stable
 */
var FormArray = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __extends */])(FormArray, _super);
    function FormArray(controls, validatorOrOpts, asyncValidator) {
        var _this = _super.call(this, coerceToValidator(validatorOrOpts), coerceToAsyncValidator(asyncValidator, validatorOrOpts)) || this;
        _this.controls = controls;
        _this._initObservables();
        _this._setUpdateStrategy(validatorOrOpts);
        _this._setUpControls();
        _this.updateValueAndValidity({ onlySelf: true, emitEvent: false });
        return _this;
    }
    /**
     * Get the {@link AbstractControl} at the given `index` in the array.
     */
    /**
     * Get the {\@link AbstractControl} at the given `index` in the array.
     * @param {?} index
     * @return {?}
     */
    FormArray.prototype.at = /**
     * Get the {\@link AbstractControl} at the given `index` in the array.
     * @param {?} index
     * @return {?}
     */
    function (index) { return this.controls[index]; };
    /**
     * Insert a new {@link AbstractControl} at the end of the array.
     */
    /**
     * Insert a new {\@link AbstractControl} at the end of the array.
     * @param {?} control
     * @return {?}
     */
    FormArray.prototype.push = /**
     * Insert a new {\@link AbstractControl} at the end of the array.
     * @param {?} control
     * @return {?}
     */
    function (control) {
        this.controls.push(control);
        this._registerControl(control);
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    /** Insert a new {@link AbstractControl} at the given `index` in the array. */
    /**
     * Insert a new {\@link AbstractControl} at the given `index` in the array.
     * @param {?} index
     * @param {?} control
     * @return {?}
     */
    FormArray.prototype.insert = /**
     * Insert a new {\@link AbstractControl} at the given `index` in the array.
     * @param {?} index
     * @param {?} control
     * @return {?}
     */
    function (index, control) {
        this.controls.splice(index, 0, control);
        this._registerControl(control);
        this.updateValueAndValidity();
    };
    /** Remove the control at the given `index` in the array. */
    /**
     * Remove the control at the given `index` in the array.
     * @param {?} index
     * @return {?}
     */
    FormArray.prototype.removeAt = /**
     * Remove the control at the given `index` in the array.
     * @param {?} index
     * @return {?}
     */
    function (index) {
        if (this.controls[index])
            this.controls[index]._registerOnCollectionChange(function () { });
        this.controls.splice(index, 1);
        this.updateValueAndValidity();
    };
    /**
     * Replace an existing control.
     */
    /**
     * Replace an existing control.
     * @param {?} index
     * @param {?} control
     * @return {?}
     */
    FormArray.prototype.setControl = /**
     * Replace an existing control.
     * @param {?} index
     * @param {?} control
     * @return {?}
     */
    function (index, control) {
        if (this.controls[index])
            this.controls[index]._registerOnCollectionChange(function () { });
        this.controls.splice(index, 1);
        if (control) {
            this.controls.splice(index, 0, control);
            this._registerControl(control);
        }
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    Object.defineProperty(FormArray.prototype, "length", {
        /**
         * Length of the control array.
         */
        get: /**
         * Length of the control array.
         * @return {?}
         */
        function () { return this.controls.length; },
        enumerable: true,
        configurable: true
    });
    /**
     *  Sets the value of the {@link FormArray}. It accepts an array that matches
     *  the structure of the control.
     *
     * This method performs strict checks, so it will throw an error if you try
     * to set the value of a control that doesn't exist or if you exclude the
     * value of a control.
     *
     *  ### Example
     *
     *  ```
     *  const arr = new FormArray([
     *     new FormControl(),
     *     new FormControl()
     *  ]);
     *  console.log(arr.value);   // [null, null]
     *
     *  arr.setValue(['Nancy', 'Drew']);
     *  console.log(arr.value);   // ['Nancy', 'Drew']
     *  ```
     */
    /**
     *  Sets the value of the {\@link FormArray}. It accepts an array that matches
     *  the structure of the control.
     *
     * This method performs strict checks, so it will throw an error if you try
     * to set the value of a control that doesn't exist or if you exclude the
     * value of a control.
     *
     *  ### Example
     *
     *  ```
     *  const arr = new FormArray([
     *     new FormControl(),
     *     new FormControl()
     *  ]);
     *  console.log(arr.value);   // [null, null]
     *
     *  arr.setValue(['Nancy', 'Drew']);
     *  console.log(arr.value);   // ['Nancy', 'Drew']
     *  ```
     * @param {?} value
     * @param {?=} options
     * @return {?}
     */
    FormArray.prototype.setValue = /**
     *  Sets the value of the {\@link FormArray}. It accepts an array that matches
     *  the structure of the control.
     *
     * This method performs strict checks, so it will throw an error if you try
     * to set the value of a control that doesn't exist or if you exclude the
     * value of a control.
     *
     *  ### Example
     *
     *  ```
     *  const arr = new FormArray([
     *     new FormControl(),
     *     new FormControl()
     *  ]);
     *  console.log(arr.value);   // [null, null]
     *
     *  arr.setValue(['Nancy', 'Drew']);
     *  console.log(arr.value);   // ['Nancy', 'Drew']
     *  ```
     * @param {?} value
     * @param {?=} options
     * @return {?}
     */
    function (value, options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        this._checkAllValuesPresent(value);
        value.forEach(function (newValue, index) {
            _this._throwIfControlMissing(index);
            _this.at(index).setValue(newValue, { onlySelf: true, emitEvent: options.emitEvent });
        });
        this.updateValueAndValidity(options);
    };
    /**
     *  Patches the value of the {@link FormArray}. It accepts an array that matches the
     *  structure of the control, and will do its best to match the values to the correct
     *  controls in the group.
     *
     *  It accepts both super-sets and sub-sets of the array without throwing an error.
     *
     *  ### Example
     *
     *  ```
     *  const arr = new FormArray([
     *     new FormControl(),
     *     new FormControl()
     *  ]);
     *  console.log(arr.value);   // [null, null]
     *
     *  arr.patchValue(['Nancy']);
     *  console.log(arr.value);   // ['Nancy', null]
     *  ```
     */
    /**
     *  Patches the value of the {\@link FormArray}. It accepts an array that matches the
     *  structure of the control, and will do its best to match the values to the correct
     *  controls in the group.
     *
     *  It accepts both super-sets and sub-sets of the array without throwing an error.
     *
     *  ### Example
     *
     *  ```
     *  const arr = new FormArray([
     *     new FormControl(),
     *     new FormControl()
     *  ]);
     *  console.log(arr.value);   // [null, null]
     *
     *  arr.patchValue(['Nancy']);
     *  console.log(arr.value);   // ['Nancy', null]
     *  ```
     * @param {?} value
     * @param {?=} options
     * @return {?}
     */
    FormArray.prototype.patchValue = /**
     *  Patches the value of the {\@link FormArray}. It accepts an array that matches the
     *  structure of the control, and will do its best to match the values to the correct
     *  controls in the group.
     *
     *  It accepts both super-sets and sub-sets of the array without throwing an error.
     *
     *  ### Example
     *
     *  ```
     *  const arr = new FormArray([
     *     new FormControl(),
     *     new FormControl()
     *  ]);
     *  console.log(arr.value);   // [null, null]
     *
     *  arr.patchValue(['Nancy']);
     *  console.log(arr.value);   // ['Nancy', null]
     *  ```
     * @param {?} value
     * @param {?=} options
     * @return {?}
     */
    function (value, options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        value.forEach(function (newValue, index) {
            if (_this.at(index)) {
                _this.at(index).patchValue(newValue, { onlySelf: true, emitEvent: options.emitEvent });
            }
        });
        this.updateValueAndValidity(options);
    };
    /**
     * Resets the {@link FormArray}. This means by default:
     *
     * * The array and all descendants are marked `pristine`
     * * The array and all descendants are marked `untouched`
     * * The value of all descendants will be null or null maps
     *
     * You can also reset to a specific form state by passing in an array of states
     * that matches the structure of the control. The state can be a standalone value
     * or a form state object with both a value and a disabled status.
     *
     * ### Example
     *
     * ```ts
     * this.arr.reset(['name', 'last name']);
     *
     * console.log(this.arr.value);  // ['name', 'last name']
     * ```
     *
     * - OR -
     *
     * ```
     * this.arr.reset([
     *   {value: 'name', disabled: true},
     *   'last'
     * ]);
     *
     * console.log(this.arr.value);  // ['name', 'last name']
     * console.log(this.arr.get(0).status);  // 'DISABLED'
     * ```
     */
    /**
     * Resets the {\@link FormArray}. This means by default:
     *
     * * The array and all descendants are marked `pristine`
     * * The array and all descendants are marked `untouched`
     * * The value of all descendants will be null or null maps
     *
     * You can also reset to a specific form state by passing in an array of states
     * that matches the structure of the control. The state can be a standalone value
     * or a form state object with both a value and a disabled status.
     *
     * ### Example
     *
     * ```ts
     * this.arr.reset(['name', 'last name']);
     *
     * console.log(this.arr.value);  // ['name', 'last name']
     * ```
     *
     * - OR -
     *
     * ```
     * this.arr.reset([
     *   {value: 'name', disabled: true},
     *   'last'
     * ]);
     *
     * console.log(this.arr.value);  // ['name', 'last name']
     * console.log(this.arr.get(0).status);  // 'DISABLED'
     * ```
     * @param {?=} value
     * @param {?=} options
     * @return {?}
     */
    FormArray.prototype.reset = /**
     * Resets the {\@link FormArray}. This means by default:
     *
     * * The array and all descendants are marked `pristine`
     * * The array and all descendants are marked `untouched`
     * * The value of all descendants will be null or null maps
     *
     * You can also reset to a specific form state by passing in an array of states
     * that matches the structure of the control. The state can be a standalone value
     * or a form state object with both a value and a disabled status.
     *
     * ### Example
     *
     * ```ts
     * this.arr.reset(['name', 'last name']);
     *
     * console.log(this.arr.value);  // ['name', 'last name']
     * ```
     *
     * - OR -
     *
     * ```
     * this.arr.reset([
     *   {value: 'name', disabled: true},
     *   'last'
     * ]);
     *
     * console.log(this.arr.value);  // ['name', 'last name']
     * console.log(this.arr.get(0).status);  // 'DISABLED'
     * ```
     * @param {?=} value
     * @param {?=} options
     * @return {?}
     */
    function (value, options) {
        if (value === void 0) { value = []; }
        if (options === void 0) { options = {}; }
        this._forEachChild(function (control, index) {
            control.reset(value[index], { onlySelf: true, emitEvent: options.emitEvent });
        });
        this.updateValueAndValidity(options);
        this._updatePristine(options);
        this._updateTouched(options);
    };
    /**
     * The aggregate value of the array, including any disabled controls.
     *
     * If you'd like to include all values regardless of disabled status, use this method.
     * Otherwise, the `value` property is the best way to get the value of the array.
     */
    /**
     * The aggregate value of the array, including any disabled controls.
     *
     * If you'd like to include all values regardless of disabled status, use this method.
     * Otherwise, the `value` property is the best way to get the value of the array.
     * @return {?}
     */
    FormArray.prototype.getRawValue = /**
     * The aggregate value of the array, including any disabled controls.
     *
     * If you'd like to include all values regardless of disabled status, use this method.
     * Otherwise, the `value` property is the best way to get the value of the array.
     * @return {?}
     */
    function () {
        return this.controls.map(function (control) {
            return control instanceof FormControl ? control.value : (/** @type {?} */ (control)).getRawValue();
        });
    };
    /** @internal */
    /**
     * \@internal
     * @return {?}
     */
    FormArray.prototype._syncPendingControls = /**
     * \@internal
     * @return {?}
     */
    function () {
        var /** @type {?} */ subtreeUpdated = this.controls.reduce(function (updated, child) {
            return child._syncPendingControls() ? true : updated;
        }, false);
        if (subtreeUpdated)
            this.updateValueAndValidity({ onlySelf: true });
        return subtreeUpdated;
    };
    /** @internal */
    /**
     * \@internal
     * @param {?} index
     * @return {?}
     */
    FormArray.prototype._throwIfControlMissing = /**
     * \@internal
     * @param {?} index
     * @return {?}
     */
    function (index) {
        if (!this.controls.length) {
            throw new Error("\n        There are no form controls registered with this array yet.  If you're using ngModel,\n        you may want to check next tick (e.g. use setTimeout).\n      ");
        }
        if (!this.at(index)) {
            throw new Error("Cannot find form control at index " + index);
        }
    };
    /** @internal */
    /**
     * \@internal
     * @param {?} cb
     * @return {?}
     */
    FormArray.prototype._forEachChild = /**
     * \@internal
     * @param {?} cb
     * @return {?}
     */
    function (cb) {
        this.controls.forEach(function (control, index) { cb(control, index); });
    };
    /** @internal */
    /**
     * \@internal
     * @return {?}
     */
    FormArray.prototype._updateValue = /**
     * \@internal
     * @return {?}
     */
    function () {
        var _this = this;
        (/** @type {?} */ (this)).value =
            this.controls.filter(function (control) { return control.enabled || _this.disabled; })
                .map(function (control) { return control.value; });
    };
    /** @internal */
    /**
     * \@internal
     * @param {?} condition
     * @return {?}
     */
    FormArray.prototype._anyControls = /**
     * \@internal
     * @param {?} condition
     * @return {?}
     */
    function (condition) {
        return this.controls.some(function (control) { return control.enabled && condition(control); });
    };
    /** @internal */
    /**
     * \@internal
     * @return {?}
     */
    FormArray.prototype._setUpControls = /**
     * \@internal
     * @return {?}
     */
    function () {
        var _this = this;
        this._forEachChild(function (control) { return _this._registerControl(control); });
    };
    /** @internal */
    /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    FormArray.prototype._checkAllValuesPresent = /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this._forEachChild(function (control, i) {
            if (value[i] === undefined) {
                throw new Error("Must supply a value for form control at index: " + i + ".");
            }
        });
    };
    /** @internal */
    /**
     * \@internal
     * @return {?}
     */
    FormArray.prototype._allControlsDisabled = /**
     * \@internal
     * @return {?}
     */
    function () {
        for (var _i = 0, _a = this.controls; _i < _a.length; _i++) {
            var control = _a[_i];
            if (control.enabled)
                return false;
        }
        return this.controls.length > 0 || this.disabled;
    };
    /**
     * @param {?} control
     * @return {?}
     */
    FormArray.prototype._registerControl = /**
     * @param {?} control
     * @return {?}
     */
    function (control) {
        control.setParent(this);
        control._registerOnCollectionChange(this._onCollectionChange);
    };
    return FormArray;
}(AbstractControl));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var formDirectiveProvider = {
    provide: ControlContainer,
    useExisting: Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return NgForm; })
};
var resolvedPromise = Promise.resolve(null);
/**
 * \@whatItDoes Creates a top-level {\@link FormGroup} instance and binds it to a form
 * to track aggregate form value and validation status.
 *
 * \@howToUse
 *
 * As soon as you import the `FormsModule`, this directive becomes active by default on
 * all `<form>` tags.  You don't need to add a special selector.
 *
 * You can export the directive into a local template variable using `ngForm` as the key
 * (ex: `#myForm="ngForm"`). This is optional, but useful.  Many properties from the underlying
 * {\@link FormGroup} instance are duplicated on the directive itself, so a reference to it
 * will give you access to the aggregate value and validity status of the form, as well as
 * user interaction properties like `dirty` and `touched`.
 *
 * To register child controls with the form, you'll want to use {\@link NgModel} with a
 * `name` attribute.  You can also use {\@link NgModelGroup} if you'd like to create
 * sub-groups within the form.
 *
 * You can listen to the directive's `ngSubmit` event to be notified when the user has
 * triggered a form submission. The `ngSubmit` event will be emitted with the original form
 * submission event.
 *
 * In template driven forms, all `<form>` tags are automatically tagged as `NgForm`.
 * If you want to import the `FormsModule` but skip its usage in some forms,
 * for example, to use native HTML5 validation, you can add `ngNoForm` and the `<form>`
 * tags won't create an `NgForm` directive. In reactive forms, using `ngNoForm` is
 * unnecessary because the `<form>` tags are inert. In that case, you would
 * refrain from using the `formGroup` directive.
 *
 * {\@example forms/ts/simpleForm/simple_form_example.ts region='Component'}
 *
 * * **npm package**: `\@angular/forms`
 *
 * * **NgModule**: `FormsModule`
 *
 *  \@stable
 */
var NgForm = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __extends */])(NgForm, _super);
    function NgForm(validators, asyncValidators) {
        var _this = _super.call(this) || this;
        _this.submitted = false;
        _this._directives = [];
        _this.ngSubmit = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
        _this.form =
            new FormGroup({}, composeValidators(validators), composeAsyncValidators(asyncValidators));
        return _this;
    }
    /**
     * @return {?}
     */
    NgForm.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () { this._setUpdateStrategy(); };
    Object.defineProperty(NgForm.prototype, "formDirective", {
        get: /**
         * @return {?}
         */
        function () { return this; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForm.prototype, "control", {
        get: /**
         * @return {?}
         */
        function () { return this.form; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForm.prototype, "path", {
        get: /**
         * @return {?}
         */
        function () { return []; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForm.prototype, "controls", {
        get: /**
         * @return {?}
         */
        function () { return this.form.controls; },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} dir
     * @return {?}
     */
    NgForm.prototype.addControl = /**
     * @param {?} dir
     * @return {?}
     */
    function (dir) {
        var _this = this;
        resolvedPromise.then(function () {
            var /** @type {?} */ container = _this._findContainer(dir.path);
            (/** @type {?} */ (dir)).control = /** @type {?} */ (container.registerControl(dir.name, dir.control));
            setUpControl(dir.control, dir);
            dir.control.updateValueAndValidity({ emitEvent: false });
            _this._directives.push(dir);
        });
    };
    /**
     * @param {?} dir
     * @return {?}
     */
    NgForm.prototype.getControl = /**
     * @param {?} dir
     * @return {?}
     */
    function (dir) { return /** @type {?} */ (this.form.get(dir.path)); };
    /**
     * @param {?} dir
     * @return {?}
     */
    NgForm.prototype.removeControl = /**
     * @param {?} dir
     * @return {?}
     */
    function (dir) {
        var _this = this;
        resolvedPromise.then(function () {
            var /** @type {?} */ container = _this._findContainer(dir.path);
            if (container) {
                container.removeControl(dir.name);
            }
            removeDir(_this._directives, dir);
        });
    };
    /**
     * @param {?} dir
     * @return {?}
     */
    NgForm.prototype.addFormGroup = /**
     * @param {?} dir
     * @return {?}
     */
    function (dir) {
        var _this = this;
        resolvedPromise.then(function () {
            var /** @type {?} */ container = _this._findContainer(dir.path);
            var /** @type {?} */ group = new FormGroup({});
            setUpFormContainer(group, dir);
            container.registerControl(dir.name, group);
            group.updateValueAndValidity({ emitEvent: false });
        });
    };
    /**
     * @param {?} dir
     * @return {?}
     */
    NgForm.prototype.removeFormGroup = /**
     * @param {?} dir
     * @return {?}
     */
    function (dir) {
        var _this = this;
        resolvedPromise.then(function () {
            var /** @type {?} */ container = _this._findContainer(dir.path);
            if (container) {
                container.removeControl(dir.name);
            }
        });
    };
    /**
     * @param {?} dir
     * @return {?}
     */
    NgForm.prototype.getFormGroup = /**
     * @param {?} dir
     * @return {?}
     */
    function (dir) { return /** @type {?} */ (this.form.get(dir.path)); };
    /**
     * @param {?} dir
     * @param {?} value
     * @return {?}
     */
    NgForm.prototype.updateModel = /**
     * @param {?} dir
     * @param {?} value
     * @return {?}
     */
    function (dir, value) {
        var _this = this;
        resolvedPromise.then(function () {
            var /** @type {?} */ ctrl = /** @type {?} */ (_this.form.get(/** @type {?} */ ((dir.path))));
            ctrl.setValue(value);
        });
    };
    /**
     * @param {?} value
     * @return {?}
     */
    NgForm.prototype.setValue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) { this.control.setValue(value); };
    /**
     * @param {?} $event
     * @return {?}
     */
    NgForm.prototype.onSubmit = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        (/** @type {?} */ (this)).submitted = true;
        syncPendingControls(this.form, this._directives);
        this.ngSubmit.emit($event);
        return false;
    };
    /**
     * @return {?}
     */
    NgForm.prototype.onReset = /**
     * @return {?}
     */
    function () { this.resetForm(); };
    /**
     * @param {?=} value
     * @return {?}
     */
    NgForm.prototype.resetForm = /**
     * @param {?=} value
     * @return {?}
     */
    function (value) {
        if (value === void 0) { value = undefined; }
        this.form.reset(value);
        (/** @type {?} */ (this)).submitted = false;
    };
    /**
     * @return {?}
     */
    NgForm.prototype._setUpdateStrategy = /**
     * @return {?}
     */
    function () {
        if (this.options && this.options.updateOn != null) {
            this.form._updateOn = this.options.updateOn;
        }
    };
    /** @internal */
    /**
     * \@internal
     * @param {?} path
     * @return {?}
     */
    NgForm.prototype._findContainer = /**
     * \@internal
     * @param {?} path
     * @return {?}
     */
    function (path) {
        path.pop();
        return path.length ? /** @type {?} */ (this.form.get(path)) : this.form;
    };
    NgForm.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{
                    selector: 'form:not([ngNoForm]):not([formGroup]),ngForm,[ngForm]',
                    providers: [formDirectiveProvider],
                    host: { '(submit)': 'onSubmit($event)', '(reset)': 'onReset()' },
                    outputs: ['ngSubmit'],
                    exportAs: 'ngForm'
                },] },
    ];
    /** @nocollapse */
    NgForm.ctorParameters = function () { return [
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [NG_VALIDATORS,] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [NG_ASYNC_VALIDATORS,] },] },
    ]; };
    NgForm.propDecorators = {
        "options": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"], args: ['ngFormOptions',] },],
    };
    return NgForm;
}(ControlContainer));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var FormErrorExamples = {
    formControlName: "\n    <div [formGroup]=\"myGroup\">\n      <input formControlName=\"firstName\">\n    </div>\n\n    In your class:\n\n    this.myGroup = new FormGroup({\n       firstName: new FormControl()\n    });",
    formGroupName: "\n    <div [formGroup]=\"myGroup\">\n       <div formGroupName=\"person\">\n          <input formControlName=\"firstName\">\n       </div>\n    </div>\n\n    In your class:\n\n    this.myGroup = new FormGroup({\n       person: new FormGroup({ firstName: new FormControl() })\n    });",
    formArrayName: "\n    <div [formGroup]=\"myGroup\">\n      <div formArrayName=\"cities\">\n        <div *ngFor=\"let city of cityArray.controls; index as i\">\n          <input [formControlName]=\"i\">\n        </div>\n      </div>\n    </div>\n\n    In your class:\n\n    this.cityArray = new FormArray([new FormControl('SF')]);\n    this.myGroup = new FormGroup({\n      cities: this.cityArray\n    });",
    ngModelGroup: "\n    <form>\n       <div ngModelGroup=\"person\">\n          <input [(ngModel)]=\"person.name\" name=\"firstName\">\n       </div>\n    </form>",
    ngModelWithFormGroup: "\n    <div [formGroup]=\"myGroup\">\n       <input formControlName=\"firstName\">\n       <input [(ngModel)]=\"showMoreControls\" [ngModelOptions]=\"{standalone: true}\">\n    </div>\n  "
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var TemplateDrivenErrors = /** @class */ (function () {
    function TemplateDrivenErrors() {
    }
    /**
     * @return {?}
     */
    TemplateDrivenErrors.modelParentException = /**
     * @return {?}
     */
    function () {
        throw new Error("\n      ngModel cannot be used to register form controls with a parent formGroup directive.  Try using\n      formGroup's partner directive \"formControlName\" instead.  Example:\n\n      " + FormErrorExamples.formControlName + "\n\n      Or, if you'd like to avoid registering this form control, indicate that it's standalone in ngModelOptions:\n\n      Example:\n\n      " + FormErrorExamples.ngModelWithFormGroup);
    };
    /**
     * @return {?}
     */
    TemplateDrivenErrors.formGroupNameException = /**
     * @return {?}
     */
    function () {
        throw new Error("\n      ngModel cannot be used to register form controls with a parent formGroupName or formArrayName directive.\n\n      Option 1: Use formControlName instead of ngModel (reactive strategy):\n\n      " + FormErrorExamples.formGroupName + "\n\n      Option 2:  Update ngModel's parent be ngModelGroup (template-driven strategy):\n\n      " + FormErrorExamples.ngModelGroup);
    };
    /**
     * @return {?}
     */
    TemplateDrivenErrors.missingNameException = /**
     * @return {?}
     */
    function () {
        throw new Error("If ngModel is used within a form tag, either the name attribute must be set or the form\n      control must be defined as 'standalone' in ngModelOptions.\n\n      Example 1: <input [(ngModel)]=\"person.firstName\" name=\"first\">\n      Example 2: <input [(ngModel)]=\"person.firstName\" [ngModelOptions]=\"{standalone: true}\">");
    };
    /**
     * @return {?}
     */
    TemplateDrivenErrors.modelGroupParentException = /**
     * @return {?}
     */
    function () {
        throw new Error("\n      ngModelGroup cannot be used with a parent formGroup directive.\n\n      Option 1: Use formGroupName instead of ngModelGroup (reactive strategy):\n\n      " + FormErrorExamples.formGroupName + "\n\n      Option 2:  Use a regular form tag instead of the formGroup directive (template-driven strategy):\n\n      " + FormErrorExamples.ngModelGroup);
    };
    return TemplateDrivenErrors;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var modelGroupProvider = {
    provide: ControlContainer,
    useExisting: Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return NgModelGroup; })
};
/**
 * \@whatItDoes Creates and binds a {\@link FormGroup} instance to a DOM element.
 *
 * \@howToUse
 *
 * This directive can only be used as a child of {\@link NgForm} (or in other words,
 * within `<form>` tags).
 *
 * Use this directive if you'd like to create a sub-group within a form. This can
 * come in handy if you want to validate a sub-group of your form separately from
 * the rest of your form, or if some values in your domain model make more sense to
 * consume together in a nested object.
 *
 * Pass in the name you'd like this sub-group to have and it will become the key
 * for the sub-group in the form's full value. You can also export the directive into
 * a local template variable using `ngModelGroup` (ex: `#myGroup="ngModelGroup"`).
 *
 * {\@example forms/ts/ngModelGroup/ng_model_group_example.ts region='Component'}
 *
 * * **npm package**: `\@angular/forms`
 *
 * * **NgModule**: `FormsModule`
 *
 * \@stable
 */
var NgModelGroup = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __extends */])(NgModelGroup, _super);
    function NgModelGroup(parent, validators, asyncValidators) {
        var _this = _super.call(this) || this;
        _this._parent = parent;
        _this._validators = validators;
        _this._asyncValidators = asyncValidators;
        return _this;
    }
    /** @internal */
    /**
     * \@internal
     * @return {?}
     */
    NgModelGroup.prototype._checkParentType = /**
     * \@internal
     * @return {?}
     */
    function () {
        if (!(this._parent instanceof NgModelGroup) && !(this._parent instanceof NgForm)) {
            TemplateDrivenErrors.modelGroupParentException();
        }
    };
    NgModelGroup.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{ selector: '[ngModelGroup]', providers: [modelGroupProvider], exportAs: 'ngModelGroup' },] },
    ];
    /** @nocollapse */
    NgModelGroup.ctorParameters = function () { return [
        { type: ControlContainer, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Host"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["SkipSelf"] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [NG_VALIDATORS,] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [NG_ASYNC_VALIDATORS,] },] },
    ]; };
    NgModelGroup.propDecorators = {
        "name": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"], args: ['ngModelGroup',] },],
    };
    return NgModelGroup;
}(AbstractFormGroupDirective));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var formControlBinding = {
    provide: NgControl,
    useExisting: Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return NgModel; })
};
/**
 * `ngModel` forces an additional change detection run when its inputs change:
 * E.g.:
 * ```
 * <div>{{myModel.valid}}</div>
 * <input [(ngModel)]="myValue" #myModel="ngModel">
 * ```
 * I.e. `ngModel` can export itself on the element and then be used in the template.
 * Normally, this would result in expressions before the `input` that use the exported directive
 * to have and old value as they have been
 * dirty checked before. As this is a very common case for `ngModel`, we added this second change
 * detection run.
 *
 * Notes:
 * - this is just one extra run no matter how many `ngModel` have been changed.
 * - this is a general problem when using `exportAs` for directives!
 */
var resolvedPromise$1 = Promise.resolve(null);
/**
 * \@whatItDoes Creates a {\@link FormControl} instance from a domain model and binds it
 * to a form control element.
 *
 * The {\@link FormControl} instance will track the value, user interaction, and
 * validation status of the control and keep the view synced with the model. If used
 * within a parent form, the directive will also register itself with the form as a child
 * control.
 *
 * \@howToUse
 *
 * This directive can be used by itself or as part of a larger form. All you need is the
 * `ngModel` selector to activate it.
 *
 * It accepts a domain model as an optional {\@link Input}. If you have a one-way binding
 * to `ngModel` with `[]` syntax, changing the value of the domain model in the component
 * class will set the value in the view. If you have a two-way binding with `[()]` syntax
 * (also known as 'banana-box syntax'), the value in the UI will always be synced back to
 * the domain model in your class as well.
 *
 * If you wish to inspect the properties of the associated {\@link FormControl} (like
 * validity state), you can also export the directive into a local template variable using
 * `ngModel` as the key (ex: `#myVar="ngModel"`). You can then access the control using the
 * directive's `control` property, but most properties you'll need (like `valid` and `dirty`)
 * will fall through to the control anyway, so you can access them directly. You can see a
 * full list of properties directly available in {\@link AbstractControlDirective}.
 *
 * The following is an example of a simple standalone control using `ngModel`:
 *
 * {\@example forms/ts/simpleNgModel/simple_ng_model_example.ts region='Component'}
 *
 * When using the `ngModel` within `<form>` tags, you'll also need to supply a `name` attribute
 * so that the control can be registered with the parent form under that name.
 *
 * It's worth noting that in the context of a parent form, you often can skip one-way or
 * two-way binding because the parent form will sync the value for you. You can access
 * its properties by exporting it into a local template variable using `ngForm` (ex:
 * `#f="ngForm"`). Then you can pass it where it needs to go on submit.
 *
 * If you do need to populate initial values into your form, using a one-way binding for
 * `ngModel` tends to be sufficient as long as you use the exported form's value rather
 * than the domain model's value on submit.
 *
 * Take a look at an example of using `ngModel` within a form:
 *
 * {\@example forms/ts/simpleForm/simple_form_example.ts region='Component'}
 *
 * To see `ngModel` examples with different form control types, see:
 *
 * * Radio buttons: {\@link RadioControlValueAccessor}
 * * Selects: {\@link SelectControlValueAccessor}
 *
 * **npm package**: `\@angular/forms`
 *
 * **NgModule**: `FormsModule`
 *
 *  \@stable
 */
var NgModel = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __extends */])(NgModel, _super);
    function NgModel(parent, validators, asyncValidators, valueAccessors) {
        var _this = _super.call(this) || this;
        _this.control = new FormControl();
        /**
         * \@internal
         */
        _this._registered = false;
        _this.update = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
        _this._parent = parent;
        _this._rawValidators = validators || [];
        _this._rawAsyncValidators = asyncValidators || [];
        _this.valueAccessor = selectValueAccessor(_this, valueAccessors);
        return _this;
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    NgModel.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        this._checkForErrors();
        if (!this._registered)
            this._setUpControl();
        if ('isDisabled' in changes) {
            this._updateDisabled(changes);
        }
        if (isPropertyUpdated(changes, this.viewModel)) {
            this._updateValue(this.model);
            this.viewModel = this.model;
        }
    };
    /**
     * @return {?}
     */
    NgModel.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () { this.formDirective && this.formDirective.removeControl(this); };
    Object.defineProperty(NgModel.prototype, "path", {
        get: /**
         * @return {?}
         */
        function () {
            return this._parent ? controlPath(this.name, this._parent) : [this.name];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgModel.prototype, "formDirective", {
        get: /**
         * @return {?}
         */
        function () { return this._parent ? this._parent.formDirective : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgModel.prototype, "validator", {
        get: /**
         * @return {?}
         */
        function () { return composeValidators(this._rawValidators); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgModel.prototype, "asyncValidator", {
        get: /**
         * @return {?}
         */
        function () {
            return composeAsyncValidators(this._rawAsyncValidators);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} newValue
     * @return {?}
     */
    NgModel.prototype.viewToModelUpdate = /**
     * @param {?} newValue
     * @return {?}
     */
    function (newValue) {
        this.viewModel = newValue;
        this.update.emit(newValue);
    };
    /**
     * @return {?}
     */
    NgModel.prototype._setUpControl = /**
     * @return {?}
     */
    function () {
        this._setUpdateStrategy();
        this._isStandalone() ? this._setUpStandalone() :
            this.formDirective.addControl(this);
        this._registered = true;
    };
    /**
     * @return {?}
     */
    NgModel.prototype._setUpdateStrategy = /**
     * @return {?}
     */
    function () {
        if (this.options && this.options.updateOn != null) {
            this.control._updateOn = this.options.updateOn;
        }
    };
    /**
     * @return {?}
     */
    NgModel.prototype._isStandalone = /**
     * @return {?}
     */
    function () {
        return !this._parent || !!(this.options && this.options.standalone);
    };
    /**
     * @return {?}
     */
    NgModel.prototype._setUpStandalone = /**
     * @return {?}
     */
    function () {
        setUpControl(this.control, this);
        this.control.updateValueAndValidity({ emitEvent: false });
    };
    /**
     * @return {?}
     */
    NgModel.prototype._checkForErrors = /**
     * @return {?}
     */
    function () {
        if (!this._isStandalone()) {
            this._checkParentType();
        }
        this._checkName();
    };
    /**
     * @return {?}
     */
    NgModel.prototype._checkParentType = /**
     * @return {?}
     */
    function () {
        if (!(this._parent instanceof NgModelGroup) &&
            this._parent instanceof AbstractFormGroupDirective) {
            TemplateDrivenErrors.formGroupNameException();
        }
        else if (!(this._parent instanceof NgModelGroup) && !(this._parent instanceof NgForm)) {
            TemplateDrivenErrors.modelParentException();
        }
    };
    /**
     * @return {?}
     */
    NgModel.prototype._checkName = /**
     * @return {?}
     */
    function () {
        if (this.options && this.options.name)
            this.name = this.options.name;
        if (!this._isStandalone() && !this.name) {
            TemplateDrivenErrors.missingNameException();
        }
    };
    /**
     * @param {?} value
     * @return {?}
     */
    NgModel.prototype._updateValue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        var _this = this;
        resolvedPromise$1.then(function () { _this.control.setValue(value, { emitViewToModelChange: false }); });
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    NgModel.prototype._updateDisabled = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        var _this = this;
        var /** @type {?} */ disabledValue = changes['isDisabled'].currentValue;
        var /** @type {?} */ isDisabled = disabledValue === '' || (disabledValue && disabledValue !== 'false');
        resolvedPromise$1.then(function () {
            if (isDisabled && !_this.control.disabled) {
                _this.control.disable();
            }
            else if (!isDisabled && _this.control.disabled) {
                _this.control.enable();
            }
        });
    };
    NgModel.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{
                    selector: '[ngModel]:not([formControlName]):not([formControl])',
                    providers: [formControlBinding],
                    exportAs: 'ngModel'
                },] },
    ];
    /** @nocollapse */
    NgModel.ctorParameters = function () { return [
        { type: ControlContainer, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Host"] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [NG_VALIDATORS,] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [NG_ASYNC_VALIDATORS,] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [NG_VALUE_ACCESSOR,] },] },
    ]; };
    NgModel.propDecorators = {
        "name": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
        "isDisabled": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"], args: ['disabled',] },],
        "model": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"], args: ['ngModel',] },],
        "options": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"], args: ['ngModelOptions',] },],
        "update": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Output"], args: ['ngModelChange',] },],
    };
    return NgModel;
}(NgControl));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var ReactiveErrors = /** @class */ (function () {
    function ReactiveErrors() {
    }
    /**
     * @return {?}
     */
    ReactiveErrors.controlParentException = /**
     * @return {?}
     */
    function () {
        throw new Error("formControlName must be used with a parent formGroup directive.  You'll want to add a formGroup\n       directive and pass it an existing FormGroup instance (you can create one in your class).\n\n      Example:\n\n      " + FormErrorExamples.formControlName);
    };
    /**
     * @return {?}
     */
    ReactiveErrors.ngModelGroupException = /**
     * @return {?}
     */
    function () {
        throw new Error("formControlName cannot be used with an ngModelGroup parent. It is only compatible with parents\n       that also have a \"form\" prefix: formGroupName, formArrayName, or formGroup.\n\n       Option 1:  Update the parent to be formGroupName (reactive form strategy)\n\n        " + FormErrorExamples.formGroupName + "\n\n        Option 2: Use ngModel instead of formControlName (template-driven strategy)\n\n        " + FormErrorExamples.ngModelGroup);
    };
    /**
     * @return {?}
     */
    ReactiveErrors.missingFormException = /**
     * @return {?}
     */
    function () {
        throw new Error("formGroup expects a FormGroup instance. Please pass one in.\n\n       Example:\n\n       " + FormErrorExamples.formControlName);
    };
    /**
     * @return {?}
     */
    ReactiveErrors.groupParentException = /**
     * @return {?}
     */
    function () {
        throw new Error("formGroupName must be used with a parent formGroup directive.  You'll want to add a formGroup\n      directive and pass it an existing FormGroup instance (you can create one in your class).\n\n      Example:\n\n      " + FormErrorExamples.formGroupName);
    };
    /**
     * @return {?}
     */
    ReactiveErrors.arrayParentException = /**
     * @return {?}
     */
    function () {
        throw new Error("formArrayName must be used with a parent formGroup directive.  You'll want to add a formGroup\n       directive and pass it an existing FormGroup instance (you can create one in your class).\n\n        Example:\n\n        " + FormErrorExamples.formArrayName);
    };
    /**
     * @return {?}
     */
    ReactiveErrors.disabledAttrWarning = /**
     * @return {?}
     */
    function () {
        console.warn("\n      It looks like you're using the disabled attribute with a reactive form directive. If you set disabled to true\n      when you set up this control in your component class, the disabled attribute will actually be set in the DOM for\n      you. We recommend using this approach to avoid 'changed after checked' errors.\n       \n      Example: \n      form = new FormGroup({\n        first: new FormControl({value: 'Nancy', disabled: true}, Validators.required),\n        last: new FormControl('Drew', Validators.required)\n      });\n    ");
    };
    return ReactiveErrors;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var formControlBinding$1 = {
    provide: NgControl,
    useExisting: Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return FormControlDirective; })
};
/**
 * \@whatItDoes Syncs a standalone {\@link FormControl} instance to a form control element.
 *
 * In other words, this directive ensures that any values written to the {\@link FormControl}
 * instance programmatically will be written to the DOM element (model -> view). Conversely,
 * any values written to the DOM element through user input will be reflected in the
 * {\@link FormControl} instance (view -> model).
 *
 * \@howToUse
 *
 * Use this directive if you'd like to create and manage a {\@link FormControl} instance directly.
 * Simply create a {\@link FormControl}, save it to your component class, and pass it into the
 * {\@link FormControlDirective}.
 *
 * This directive is designed to be used as a standalone control.  Unlike {\@link FormControlName},
 * it does not require that your {\@link FormControl} instance be part of any parent
 * {\@link FormGroup}, and it won't be registered to any {\@link FormGroupDirective} that
 * exists above it.
 *
 * **Get the value**: the `value` property is always synced and available on the
 * {\@link FormControl} instance. See a full list of available properties in
 * {\@link AbstractControl}.
 *
 * **Set the value**: You can pass in an initial value when instantiating the {\@link FormControl},
 * or you can set it programmatically later using {\@link AbstractControl#setValue setValue} or
 * {\@link AbstractControl#patchValue patchValue}.
 *
 * **Listen to value**: If you want to listen to changes in the value of the control, you can
 * subscribe to the {\@link AbstractControl#valueChanges valueChanges} event.  You can also listen to
 * {\@link AbstractControl#statusChanges statusChanges} to be notified when the validation status is
 * re-calculated.
 *
 * ### Example
 *
 * {\@example forms/ts/simpleFormControl/simple_form_control_example.ts region='Component'}
 *
 * * **npm package**: `\@angular/forms`
 *
 * * **NgModule**: `ReactiveFormsModule`
 *
 *  \@stable
 */
var FormControlDirective = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __extends */])(FormControlDirective, _super);
    function FormControlDirective(validators, asyncValidators, valueAccessors) {
        var _this = _super.call(this) || this;
        _this.update = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
        _this._rawValidators = validators || [];
        _this._rawAsyncValidators = asyncValidators || [];
        _this.valueAccessor = selectValueAccessor(_this, valueAccessors);
        return _this;
    }
    Object.defineProperty(FormControlDirective.prototype, "isDisabled", {
        set: /**
         * @param {?} isDisabled
         * @return {?}
         */
        function (isDisabled) { ReactiveErrors.disabledAttrWarning(); },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} changes
     * @return {?}
     */
    FormControlDirective.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if (this._isControlChanged(changes)) {
            setUpControl(this.form, this);
            if (this.control.disabled && /** @type {?} */ ((this.valueAccessor)).setDisabledState) {
                /** @type {?} */ ((/** @type {?} */ ((this.valueAccessor)).setDisabledState))(true);
            }
            this.form.updateValueAndValidity({ emitEvent: false });
        }
        if (isPropertyUpdated(changes, this.viewModel)) {
            this.form.setValue(this.model);
            this.viewModel = this.model;
        }
    };
    Object.defineProperty(FormControlDirective.prototype, "path", {
        get: /**
         * @return {?}
         */
        function () { return []; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlDirective.prototype, "validator", {
        get: /**
         * @return {?}
         */
        function () { return composeValidators(this._rawValidators); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlDirective.prototype, "asyncValidator", {
        get: /**
         * @return {?}
         */
        function () {
            return composeAsyncValidators(this._rawAsyncValidators);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlDirective.prototype, "control", {
        get: /**
         * @return {?}
         */
        function () { return this.form; },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} newValue
     * @return {?}
     */
    FormControlDirective.prototype.viewToModelUpdate = /**
     * @param {?} newValue
     * @return {?}
     */
    function (newValue) {
        this.viewModel = newValue;
        this.update.emit(newValue);
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    FormControlDirective.prototype._isControlChanged = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        return changes.hasOwnProperty('form');
    };
    FormControlDirective.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{ selector: '[formControl]', providers: [formControlBinding$1], exportAs: 'ngForm' },] },
    ];
    /** @nocollapse */
    FormControlDirective.ctorParameters = function () { return [
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [NG_VALIDATORS,] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [NG_ASYNC_VALIDATORS,] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [NG_VALUE_ACCESSOR,] },] },
    ]; };
    FormControlDirective.propDecorators = {
        "form": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"], args: ['formControl',] },],
        "model": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"], args: ['ngModel',] },],
        "update": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Output"], args: ['ngModelChange',] },],
        "isDisabled": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"], args: ['disabled',] },],
    };
    return FormControlDirective;
}(NgControl));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var formDirectiveProvider$1 = {
    provide: ControlContainer,
    useExisting: Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return FormGroupDirective; })
};
/**
 * \@whatItDoes Binds an existing {\@link FormGroup} to a DOM element.
 *
 * \@howToUse
 *
 * This directive accepts an existing {\@link FormGroup} instance. It will then use this
 * {\@link FormGroup} instance to match any child {\@link FormControl}, {\@link FormGroup},
 * and {\@link FormArray} instances to child {\@link FormControlName}, {\@link FormGroupName},
 * and {\@link FormArrayName} directives.
 *
 * **Set value**: You can set the form's initial value when instantiating the
 * {\@link FormGroup}, or you can set it programmatically later using the {\@link FormGroup}'s
 * {\@link AbstractControl#setValue setValue} or {\@link AbstractControl#patchValue patchValue}
 * methods.
 *
 * **Listen to value**: If you want to listen to changes in the value of the form, you can subscribe
 * to the {\@link FormGroup}'s {\@link AbstractControl#valueChanges valueChanges} event.  You can also
 * listen to its {\@link AbstractControl#statusChanges statusChanges} event to be notified when the
 * validation status is re-calculated.
 *
 * Furthermore, you can listen to the directive's `ngSubmit` event to be notified when the user has
 * triggered a form submission. The `ngSubmit` event will be emitted with the original form
 * submission event.
 *
 * ### Example
 *
 * In this example, we create form controls for first name and last name.
 *
 * {\@example forms/ts/simpleFormGroup/simple_form_group_example.ts region='Component'}
 *
 * **npm package**: `\@angular/forms`
 *
 * **NgModule**: {\@link ReactiveFormsModule}
 *
 *  \@stable
 */
var FormGroupDirective = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __extends */])(FormGroupDirective, _super);
    function FormGroupDirective(_validators, _asyncValidators) {
        var _this = _super.call(this) || this;
        _this._validators = _validators;
        _this._asyncValidators = _asyncValidators;
        _this.submitted = false;
        _this.directives = [];
        _this.form = /** @type {?} */ ((null));
        _this.ngSubmit = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
        return _this;
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    FormGroupDirective.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        this._checkFormPresent();
        if (changes.hasOwnProperty('form')) {
            this._updateValidators();
            this._updateDomValue();
            this._updateRegistrations();
        }
    };
    Object.defineProperty(FormGroupDirective.prototype, "formDirective", {
        get: /**
         * @return {?}
         */
        function () { return this; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormGroupDirective.prototype, "control", {
        get: /**
         * @return {?}
         */
        function () { return this.form; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormGroupDirective.prototype, "path", {
        get: /**
         * @return {?}
         */
        function () { return []; },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.addControl = /**
     * @param {?} dir
     * @return {?}
     */
    function (dir) {
        var /** @type {?} */ ctrl = this.form.get(dir.path);
        setUpControl(ctrl, dir);
        ctrl.updateValueAndValidity({ emitEvent: false });
        this.directives.push(dir);
        return ctrl;
    };
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.getControl = /**
     * @param {?} dir
     * @return {?}
     */
    function (dir) { return /** @type {?} */ (this.form.get(dir.path)); };
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.removeControl = /**
     * @param {?} dir
     * @return {?}
     */
    function (dir) { removeDir(this.directives, dir); };
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.addFormGroup = /**
     * @param {?} dir
     * @return {?}
     */
    function (dir) {
        var /** @type {?} */ ctrl = this.form.get(dir.path);
        setUpFormContainer(ctrl, dir);
        ctrl.updateValueAndValidity({ emitEvent: false });
    };
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.removeFormGroup = /**
     * @param {?} dir
     * @return {?}
     */
    function (dir) { };
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.getFormGroup = /**
     * @param {?} dir
     * @return {?}
     */
    function (dir) { return /** @type {?} */ (this.form.get(dir.path)); };
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.addFormArray = /**
     * @param {?} dir
     * @return {?}
     */
    function (dir) {
        var /** @type {?} */ ctrl = this.form.get(dir.path);
        setUpFormContainer(ctrl, dir);
        ctrl.updateValueAndValidity({ emitEvent: false });
    };
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.removeFormArray = /**
     * @param {?} dir
     * @return {?}
     */
    function (dir) { };
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.getFormArray = /**
     * @param {?} dir
     * @return {?}
     */
    function (dir) { return /** @type {?} */ (this.form.get(dir.path)); };
    /**
     * @param {?} dir
     * @param {?} value
     * @return {?}
     */
    FormGroupDirective.prototype.updateModel = /**
     * @param {?} dir
     * @param {?} value
     * @return {?}
     */
    function (dir, value) {
        var /** @type {?} */ ctrl = /** @type {?} */ (this.form.get(dir.path));
        ctrl.setValue(value);
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    FormGroupDirective.prototype.onSubmit = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        (/** @type {?} */ (this)).submitted = true;
        syncPendingControls(this.form, this.directives);
        this.ngSubmit.emit($event);
        return false;
    };
    /**
     * @return {?}
     */
    FormGroupDirective.prototype.onReset = /**
     * @return {?}
     */
    function () { this.resetForm(); };
    /**
     * @param {?=} value
     * @return {?}
     */
    FormGroupDirective.prototype.resetForm = /**
     * @param {?=} value
     * @return {?}
     */
    function (value) {
        if (value === void 0) { value = undefined; }
        this.form.reset(value);
        (/** @type {?} */ (this)).submitted = false;
    };
    /** @internal */
    /**
     * \@internal
     * @return {?}
     */
    FormGroupDirective.prototype._updateDomValue = /**
     * \@internal
     * @return {?}
     */
    function () {
        var _this = this;
        this.directives.forEach(function (dir) {
            var /** @type {?} */ newCtrl = _this.form.get(dir.path);
            if (dir.control !== newCtrl) {
                cleanUpControl(dir.control, dir);
                if (newCtrl)
                    setUpControl(newCtrl, dir);
                (/** @type {?} */ (dir)).control = newCtrl;
            }
        });
        this.form._updateTreeValidity({ emitEvent: false });
    };
    /**
     * @return {?}
     */
    FormGroupDirective.prototype._updateRegistrations = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.form._registerOnCollectionChange(function () { return _this._updateDomValue(); });
        if (this._oldForm)
            this._oldForm._registerOnCollectionChange(function () { });
        this._oldForm = this.form;
    };
    /**
     * @return {?}
     */
    FormGroupDirective.prototype._updateValidators = /**
     * @return {?}
     */
    function () {
        var /** @type {?} */ sync = composeValidators(this._validators);
        this.form.validator = Validators.compose([/** @type {?} */ ((this.form.validator)), /** @type {?} */ ((sync))]);
        var /** @type {?} */ async = composeAsyncValidators(this._asyncValidators);
        this.form.asyncValidator = Validators.composeAsync([/** @type {?} */ ((this.form.asyncValidator)), /** @type {?} */ ((async))]);
    };
    /**
     * @return {?}
     */
    FormGroupDirective.prototype._checkFormPresent = /**
     * @return {?}
     */
    function () {
        if (!this.form) {
            ReactiveErrors.missingFormException();
        }
    };
    FormGroupDirective.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{
                    selector: '[formGroup]',
                    providers: [formDirectiveProvider$1],
                    host: { '(submit)': 'onSubmit($event)', '(reset)': 'onReset()' },
                    exportAs: 'ngForm'
                },] },
    ];
    /** @nocollapse */
    FormGroupDirective.ctorParameters = function () { return [
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [NG_VALIDATORS,] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [NG_ASYNC_VALIDATORS,] },] },
    ]; };
    FormGroupDirective.propDecorators = {
        "form": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"], args: ['formGroup',] },],
        "ngSubmit": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Output"] },],
    };
    return FormGroupDirective;
}(ControlContainer));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var formGroupNameProvider = {
    provide: ControlContainer,
    useExisting: Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return FormGroupName; })
};
/**
 * \@whatItDoes Syncs a nested {\@link FormGroup} to a DOM element.
 *
 * \@howToUse
 *
 * This directive can only be used with a parent {\@link FormGroupDirective} (selector:
 * `[formGroup]`).
 *
 * It accepts the string name of the nested {\@link FormGroup} you want to link, and
 * will look for a {\@link FormGroup} registered with that name in the parent
 * {\@link FormGroup} instance you passed into {\@link FormGroupDirective}.
 *
 * Nested form groups can come in handy when you want to validate a sub-group of a
 * form separately from the rest or when you'd like to group the values of certain
 * controls into their own nested object.
 *
 * **Access the group**: You can access the associated {\@link FormGroup} using the
 * {\@link AbstractControl#get get} method. Ex: `this.form.get('name')`.
 *
 * You can also access individual controls within the group using dot syntax.
 * Ex: `this.form.get('name.first')`
 *
 * **Get the value**: the `value` property is always synced and available on the
 * {\@link FormGroup}. See a full list of available properties in {\@link AbstractControl}.
 *
 * **Set the value**: You can set an initial value for each child control when instantiating
 * the {\@link FormGroup}, or you can set it programmatically later using
 * {\@link AbstractControl#setValue setValue} or {\@link AbstractControl#patchValue patchValue}.
 *
 * **Listen to value**: If you want to listen to changes in the value of the group, you can
 * subscribe to the {\@link AbstractControl#valueChanges valueChanges} event.  You can also listen to
 * {\@link AbstractControl#statusChanges statusChanges} to be notified when the validation status is
 * re-calculated.
 *
 * ### Example
 *
 * {\@example forms/ts/nestedFormGroup/nested_form_group_example.ts region='Component'}
 *
 * * **npm package**: `\@angular/forms`
 *
 * * **NgModule**: `ReactiveFormsModule`
 *
 * \@stable
 */
var FormGroupName = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __extends */])(FormGroupName, _super);
    function FormGroupName(parent, validators, asyncValidators) {
        var _this = _super.call(this) || this;
        _this._parent = parent;
        _this._validators = validators;
        _this._asyncValidators = asyncValidators;
        return _this;
    }
    /** @internal */
    /**
     * \@internal
     * @return {?}
     */
    FormGroupName.prototype._checkParentType = /**
     * \@internal
     * @return {?}
     */
    function () {
        if (_hasInvalidParent(this._parent)) {
            ReactiveErrors.groupParentException();
        }
    };
    FormGroupName.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{ selector: '[formGroupName]', providers: [formGroupNameProvider] },] },
    ];
    /** @nocollapse */
    FormGroupName.ctorParameters = function () { return [
        { type: ControlContainer, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Host"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["SkipSelf"] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [NG_VALIDATORS,] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [NG_ASYNC_VALIDATORS,] },] },
    ]; };
    FormGroupName.propDecorators = {
        "name": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"], args: ['formGroupName',] },],
    };
    return FormGroupName;
}(AbstractFormGroupDirective));
var formArrayNameProvider = {
    provide: ControlContainer,
    useExisting: Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return FormArrayName; })
};
/**
 * \@whatItDoes Syncs a nested {\@link FormArray} to a DOM element.
 *
 * \@howToUse
 *
 * This directive is designed to be used with a parent {\@link FormGroupDirective} (selector:
 * `[formGroup]`).
 *
 * It accepts the string name of the nested {\@link FormArray} you want to link, and
 * will look for a {\@link FormArray} registered with that name in the parent
 * {\@link FormGroup} instance you passed into {\@link FormGroupDirective}.
 *
 * Nested form arrays can come in handy when you have a group of form controls but
 * you're not sure how many there will be. Form arrays allow you to create new
 * form controls dynamically.
 *
 * **Access the array**: You can access the associated {\@link FormArray} using the
 * {\@link AbstractControl#get get} method on the parent {\@link FormGroup}.
 * Ex: `this.form.get('cities')`.
 *
 * **Get the value**: the `value` property is always synced and available on the
 * {\@link FormArray}. See a full list of available properties in {\@link AbstractControl}.
 *
 * **Set the value**: You can set an initial value for each child control when instantiating
 * the {\@link FormArray}, or you can set the value programmatically later using the
 * {\@link FormArray}'s {\@link AbstractControl#setValue setValue} or
 * {\@link AbstractControl#patchValue patchValue} methods.
 *
 * **Listen to value**: If you want to listen to changes in the value of the array, you can
 * subscribe to the {\@link FormArray}'s {\@link AbstractControl#valueChanges valueChanges} event.
 * You can also listen to its {\@link AbstractControl#statusChanges statusChanges} event to be
 * notified when the validation status is re-calculated.
 *
 * **Add new controls**: You can add new controls to the {\@link FormArray} dynamically by calling
 * its {\@link FormArray#push push} method.
 * Ex: `this.form.get('cities').push(new FormControl());`
 *
 * ### Example
 *
 * {\@example forms/ts/nestedFormArray/nested_form_array_example.ts region='Component'}
 *
 * * **npm package**: `\@angular/forms`
 *
 * * **NgModule**: `ReactiveFormsModule`
 *
 * \@stable
 */
var FormArrayName = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __extends */])(FormArrayName, _super);
    function FormArrayName(parent, validators, asyncValidators) {
        var _this = _super.call(this) || this;
        _this._parent = parent;
        _this._validators = validators;
        _this._asyncValidators = asyncValidators;
        return _this;
    }
    /**
     * @return {?}
     */
    FormArrayName.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this._checkParentType(); /** @type {?} */
        ((this.formDirective)).addFormArray(this);
    };
    /**
     * @return {?}
     */
    FormArrayName.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        if (this.formDirective) {
            this.formDirective.removeFormArray(this);
        }
    };
    Object.defineProperty(FormArrayName.prototype, "control", {
        get: /**
         * @return {?}
         */
        function () { return /** @type {?} */ ((this.formDirective)).getFormArray(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormArrayName.prototype, "formDirective", {
        get: /**
         * @return {?}
         */
        function () {
            return this._parent ? /** @type {?} */ (this._parent.formDirective) : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormArrayName.prototype, "path", {
        get: /**
         * @return {?}
         */
        function () { return controlPath(this.name, this._parent); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormArrayName.prototype, "validator", {
        get: /**
         * @return {?}
         */
        function () { return composeValidators(this._validators); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormArrayName.prototype, "asyncValidator", {
        get: /**
         * @return {?}
         */
        function () {
            return composeAsyncValidators(this._asyncValidators);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    FormArrayName.prototype._checkParentType = /**
     * @return {?}
     */
    function () {
        if (_hasInvalidParent(this._parent)) {
            ReactiveErrors.arrayParentException();
        }
    };
    FormArrayName.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{ selector: '[formArrayName]', providers: [formArrayNameProvider] },] },
    ];
    /** @nocollapse */
    FormArrayName.ctorParameters = function () { return [
        { type: ControlContainer, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Host"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["SkipSelf"] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [NG_VALIDATORS,] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [NG_ASYNC_VALIDATORS,] },] },
    ]; };
    FormArrayName.propDecorators = {
        "name": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"], args: ['formArrayName',] },],
    };
    return FormArrayName;
}(ControlContainer));
/**
 * @param {?} parent
 * @return {?}
 */
function _hasInvalidParent(parent) {
    return !(parent instanceof FormGroupName) && !(parent instanceof FormGroupDirective) &&
        !(parent instanceof FormArrayName);
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var controlNameBinding = {
    provide: NgControl,
    useExisting: Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return FormControlName; })
};
/**
 * \@whatItDoes Syncs a {\@link FormControl} in an existing {\@link FormGroup} to a form control
 * element by name.
 *
 * In other words, this directive ensures that any values written to the {\@link FormControl}
 * instance programmatically will be written to the DOM element (model -> view). Conversely,
 * any values written to the DOM element through user input will be reflected in the
 * {\@link FormControl} instance (view -> model).
 *
 * \@howToUse
 *
 * This directive is designed to be used with a parent {\@link FormGroupDirective} (selector:
 * `[formGroup]`).
 *
 * It accepts the string name of the {\@link FormControl} instance you want to
 * link, and will look for a {\@link FormControl} registered with that name in the
 * closest {\@link FormGroup} or {\@link FormArray} above it.
 *
 * **Access the control**: You can access the {\@link FormControl} associated with
 * this directive by using the {\@link AbstractControl#get get} method.
 * Ex: `this.form.get('first');`
 *
 * **Get value**: the `value` property is always synced and available on the {\@link FormControl}.
 * See a full list of available properties in {\@link AbstractControl}.
 *
 *  **Set value**: You can set an initial value for the control when instantiating the
 *  {\@link FormControl}, or you can set it programmatically later using
 *  {\@link AbstractControl#setValue setValue} or {\@link AbstractControl#patchValue patchValue}.
 *
 * **Listen to value**: If you want to listen to changes in the value of the control, you can
 * subscribe to the {\@link AbstractControl#valueChanges valueChanges} event.  You can also listen to
 * {\@link AbstractControl#statusChanges statusChanges} to be notified when the validation status is
 * re-calculated.
 *
 * ### Example
 *
 * In this example, we create form controls for first name and last name.
 *
 * {\@example forms/ts/simpleFormGroup/simple_form_group_example.ts region='Component'}
 *
 * To see `formControlName` examples with different form control types, see:
 *
 * * Radio buttons: {\@link RadioControlValueAccessor}
 * * Selects: {\@link SelectControlValueAccessor}
 *
 * **npm package**: `\@angular/forms`
 *
 * **NgModule**: {\@link ReactiveFormsModule}
 *
 *  \@stable
 */
var FormControlName = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __extends */])(FormControlName, _super);
    function FormControlName(parent, validators, asyncValidators, valueAccessors) {
        var _this = _super.call(this) || this;
        _this._added = false;
        _this.update = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
        _this._parent = parent;
        _this._rawValidators = validators || [];
        _this._rawAsyncValidators = asyncValidators || [];
        _this.valueAccessor = selectValueAccessor(_this, valueAccessors);
        return _this;
    }
    Object.defineProperty(FormControlName.prototype, "isDisabled", {
        set: /**
         * @param {?} isDisabled
         * @return {?}
         */
        function (isDisabled) { ReactiveErrors.disabledAttrWarning(); },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} changes
     * @return {?}
     */
    FormControlName.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if (!this._added)
            this._setUpControl();
        if (isPropertyUpdated(changes, this.viewModel)) {
            this.viewModel = this.model;
            this.formDirective.updateModel(this, this.model);
        }
    };
    /**
     * @return {?}
     */
    FormControlName.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        if (this.formDirective) {
            this.formDirective.removeControl(this);
        }
    };
    /**
     * @param {?} newValue
     * @return {?}
     */
    FormControlName.prototype.viewToModelUpdate = /**
     * @param {?} newValue
     * @return {?}
     */
    function (newValue) {
        this.viewModel = newValue;
        this.update.emit(newValue);
    };
    Object.defineProperty(FormControlName.prototype, "path", {
        get: /**
         * @return {?}
         */
        function () { return controlPath(this.name, /** @type {?} */ ((this._parent))); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlName.prototype, "formDirective", {
        get: /**
         * @return {?}
         */
        function () { return this._parent ? this._parent.formDirective : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlName.prototype, "validator", {
        get: /**
         * @return {?}
         */
        function () { return composeValidators(this._rawValidators); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlName.prototype, "asyncValidator", {
        get: /**
         * @return {?}
         */
        function () {
            return /** @type {?} */ ((composeAsyncValidators(this._rawAsyncValidators)));
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    FormControlName.prototype._checkParentType = /**
     * @return {?}
     */
    function () {
        if (!(this._parent instanceof FormGroupName) &&
            this._parent instanceof AbstractFormGroupDirective) {
            ReactiveErrors.ngModelGroupException();
        }
        else if (!(this._parent instanceof FormGroupName) && !(this._parent instanceof FormGroupDirective) &&
            !(this._parent instanceof FormArrayName)) {
            ReactiveErrors.controlParentException();
        }
    };
    /**
     * @return {?}
     */
    FormControlName.prototype._setUpControl = /**
     * @return {?}
     */
    function () {
        this._checkParentType();
        (/** @type {?} */ (this)).control = this.formDirective.addControl(this);
        if (this.control.disabled && /** @type {?} */ ((this.valueAccessor)).setDisabledState) {
            /** @type {?} */ ((/** @type {?} */ ((this.valueAccessor)).setDisabledState))(true);
        }
        this._added = true;
    };
    FormControlName.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{ selector: '[formControlName]', providers: [controlNameBinding] },] },
    ];
    /** @nocollapse */
    FormControlName.ctorParameters = function () { return [
        { type: ControlContainer, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Host"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["SkipSelf"] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [NG_VALIDATORS,] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [NG_ASYNC_VALIDATORS,] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [NG_VALUE_ACCESSOR,] },] },
    ]; };
    FormControlName.propDecorators = {
        "name": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"], args: ['formControlName',] },],
        "model": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"], args: ['ngModel',] },],
        "update": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Output"], args: ['ngModelChange',] },],
        "isDisabled": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"], args: ['disabled',] },],
    };
    return FormControlName;
}(NgControl));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * An interface that can be implemented by classes that can act as validators.
 *
 * ## Usage
 *
 * ```typescript
 * \@Directive({
 *   selector: '[custom-validator]',
 *   providers: [{provide: NG_VALIDATORS, useExisting: CustomValidatorDirective, multi: true}]
 * })
 * class CustomValidatorDirective implements Validator {
 *   validate(c: Control): {[key: string]: any} {
 *     return {"custom": true};
 *   }
 * }
 * ```
 *
 * \@stable
 * @record
 */

/**
 * \@experimental
 * @record
 */

var REQUIRED_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return RequiredValidator; }),
    multi: true
};
var CHECKBOX_REQUIRED_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return CheckboxRequiredValidator; }),
    multi: true
};
/**
 * A Directive that adds the `required` validator to any controls marked with the
 * `required` attribute, via the {\@link NG_VALIDATORS} binding.
 *
 * ### Example
 *
 * ```
 * <input name="fullName" ngModel required>
 * ```
 *
 * \@stable
 */
var RequiredValidator = /** @class */ (function () {
    function RequiredValidator() {
    }
    Object.defineProperty(RequiredValidator.prototype, "required", {
        get: /**
         * @return {?}
         */
        function () { return this._required; },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._required = value != null && value !== false && "" + value !== 'false';
            if (this._onChange)
                this._onChange();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} c
     * @return {?}
     */
    RequiredValidator.prototype.validate = /**
     * @param {?} c
     * @return {?}
     */
    function (c) {
        return this.required ? Validators.required(c) : null;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    RequiredValidator.prototype.registerOnValidatorChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) { this._onChange = fn; };
    RequiredValidator.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{
                    selector: ':not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]',
                    providers: [REQUIRED_VALIDATOR],
                    host: { '[attr.required]': 'required ? "" : null' }
                },] },
    ];
    /** @nocollapse */
    RequiredValidator.ctorParameters = function () { return []; };
    RequiredValidator.propDecorators = {
        "required": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
    };
    return RequiredValidator;
}());
/**
 * A Directive that adds the `required` validator to checkbox controls marked with the
 * `required` attribute, via the {\@link NG_VALIDATORS} binding.
 *
 * ### Example
 *
 * ```
 * <input type="checkbox" name="active" ngModel required>
 * ```
 *
 * \@experimental
 */
var CheckboxRequiredValidator = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __extends */])(CheckboxRequiredValidator, _super);
    function CheckboxRequiredValidator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param {?} c
     * @return {?}
     */
    CheckboxRequiredValidator.prototype.validate = /**
     * @param {?} c
     * @return {?}
     */
    function (c) {
        return this.required ? Validators.requiredTrue(c) : null;
    };
    CheckboxRequiredValidator.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{
                    selector: 'input[type=checkbox][required][formControlName],input[type=checkbox][required][formControl],input[type=checkbox][required][ngModel]',
                    providers: [CHECKBOX_REQUIRED_VALIDATOR],
                    host: { '[attr.required]': 'required ? "" : null' }
                },] },
    ];
    /** @nocollapse */
    CheckboxRequiredValidator.ctorParameters = function () { return []; };
    return CheckboxRequiredValidator;
}(RequiredValidator));
/**
 * Provider which adds {\@link EmailValidator} to {\@link NG_VALIDATORS}.
 */
var EMAIL_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return EmailValidator; }),
    multi: true
};
/**
 * A Directive that adds the `email` validator to controls marked with the
 * `email` attribute, via the {\@link NG_VALIDATORS} binding.
 *
 * ### Example
 *
 * ```
 * <input type="email" name="email" ngModel email>
 * <input type="email" name="email" ngModel email="true">
 * <input type="email" name="email" ngModel [email]="true">
 * ```
 *
 * \@experimental
 */
var EmailValidator = /** @class */ (function () {
    function EmailValidator() {
    }
    Object.defineProperty(EmailValidator.prototype, "email", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._enabled = value === '' || value === true || value === 'true';
            if (this._onChange)
                this._onChange();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} c
     * @return {?}
     */
    EmailValidator.prototype.validate = /**
     * @param {?} c
     * @return {?}
     */
    function (c) {
        return this._enabled ? Validators.email(c) : null;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    EmailValidator.prototype.registerOnValidatorChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) { this._onChange = fn; };
    EmailValidator.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{
                    selector: '[email][formControlName],[email][formControl],[email][ngModel]',
                    providers: [EMAIL_VALIDATOR]
                },] },
    ];
    /** @nocollapse */
    EmailValidator.ctorParameters = function () { return []; };
    EmailValidator.propDecorators = {
        "email": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
    };
    return EmailValidator;
}());
/**
 * \@stable
 * @record
 */

/**
 * \@stable
 * @record
 */

/**
 * Provider which adds {\@link MinLengthValidator} to {\@link NG_VALIDATORS}.
 *
 * ## Example:
 *
 * {\@example common/forms/ts/validators/validators.ts region='min'}
 */
var MIN_LENGTH_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return MinLengthValidator; }),
    multi: true
};
/**
 * A directive which installs the {\@link MinLengthValidator} for any `formControlName`,
 * `formControl`, or control with `ngModel` that also has a `minlength` attribute.
 *
 * \@stable
 */
var MinLengthValidator = /** @class */ (function () {
    function MinLengthValidator() {
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    MinLengthValidator.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if ('minlength' in changes) {
            this._createValidator();
            if (this._onChange)
                this._onChange();
        }
    };
    /**
     * @param {?} c
     * @return {?}
     */
    MinLengthValidator.prototype.validate = /**
     * @param {?} c
     * @return {?}
     */
    function (c) {
        return this.minlength == null ? null : this._validator(c);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    MinLengthValidator.prototype.registerOnValidatorChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) { this._onChange = fn; };
    /**
     * @return {?}
     */
    MinLengthValidator.prototype._createValidator = /**
     * @return {?}
     */
    function () {
        this._validator = Validators.minLength(parseInt(this.minlength, 10));
    };
    MinLengthValidator.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{
                    selector: '[minlength][formControlName],[minlength][formControl],[minlength][ngModel]',
                    providers: [MIN_LENGTH_VALIDATOR],
                    host: { '[attr.minlength]': 'minlength ? minlength : null' }
                },] },
    ];
    /** @nocollapse */
    MinLengthValidator.ctorParameters = function () { return []; };
    MinLengthValidator.propDecorators = {
        "minlength": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
    };
    return MinLengthValidator;
}());
/**
 * Provider which adds {\@link MaxLengthValidator} to {\@link NG_VALIDATORS}.
 *
 * ## Example:
 *
 * {\@example common/forms/ts/validators/validators.ts region='max'}
 */
var MAX_LENGTH_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return MaxLengthValidator; }),
    multi: true
};
/**
 * A directive which installs the {\@link MaxLengthValidator} for any `formControlName,
 * `formControl`,
 * or control with `ngModel` that also has a `maxlength` attribute.
 *
 * \@stable
 */
var MaxLengthValidator = /** @class */ (function () {
    function MaxLengthValidator() {
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    MaxLengthValidator.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if ('maxlength' in changes) {
            this._createValidator();
            if (this._onChange)
                this._onChange();
        }
    };
    /**
     * @param {?} c
     * @return {?}
     */
    MaxLengthValidator.prototype.validate = /**
     * @param {?} c
     * @return {?}
     */
    function (c) {
        return this.maxlength != null ? this._validator(c) : null;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    MaxLengthValidator.prototype.registerOnValidatorChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) { this._onChange = fn; };
    /**
     * @return {?}
     */
    MaxLengthValidator.prototype._createValidator = /**
     * @return {?}
     */
    function () {
        this._validator = Validators.maxLength(parseInt(this.maxlength, 10));
    };
    MaxLengthValidator.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{
                    selector: '[maxlength][formControlName],[maxlength][formControl],[maxlength][ngModel]',
                    providers: [MAX_LENGTH_VALIDATOR],
                    host: { '[attr.maxlength]': 'maxlength ? maxlength : null' }
                },] },
    ];
    /** @nocollapse */
    MaxLengthValidator.ctorParameters = function () { return []; };
    MaxLengthValidator.propDecorators = {
        "maxlength": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
    };
    return MaxLengthValidator;
}());
var PATTERN_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return PatternValidator; }),
    multi: true
};
/**
 * A Directive that adds the `pattern` validator to any controls marked with the
 * `pattern` attribute, via the {\@link NG_VALIDATORS} binding. Uses attribute value
 * as the regex to validate Control value against.  Follows pattern attribute
 * semantics; i.e. regex must match entire Control value.
 *
 * ### Example
 *
 * ```
 * <input [name]="fullName" pattern="[a-zA-Z ]*" ngModel>
 * ```
 * \@stable
 */
var PatternValidator = /** @class */ (function () {
    function PatternValidator() {
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    PatternValidator.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if ('pattern' in changes) {
            this._createValidator();
            if (this._onChange)
                this._onChange();
        }
    };
    /**
     * @param {?} c
     * @return {?}
     */
    PatternValidator.prototype.validate = /**
     * @param {?} c
     * @return {?}
     */
    function (c) { return this._validator(c); };
    /**
     * @param {?} fn
     * @return {?}
     */
    PatternValidator.prototype.registerOnValidatorChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) { this._onChange = fn; };
    /**
     * @return {?}
     */
    PatternValidator.prototype._createValidator = /**
     * @return {?}
     */
    function () { this._validator = Validators.pattern(this.pattern); };
    PatternValidator.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{
                    selector: '[pattern][formControlName],[pattern][formControl],[pattern][ngModel]',
                    providers: [PATTERN_VALIDATOR],
                    host: { '[attr.pattern]': 'pattern ? pattern : null' }
                },] },
    ];
    /** @nocollapse */
    PatternValidator.ctorParameters = function () { return []; };
    PatternValidator.propDecorators = {
        "pattern": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
    };
    return PatternValidator;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * \@whatItDoes Creates an {\@link AbstractControl} from a user-specified configuration.
 *
 * It is essentially syntactic sugar that shortens the `new FormGroup()`,
 * `new FormControl()`, and `new FormArray()` boilerplate that can build up in larger
 * forms.
 *
 * \@howToUse
 *
 * To use, inject `FormBuilder` into your component class. You can then call its methods
 * directly.
 *
 * {\@example forms/ts/formBuilder/form_builder_example.ts region='Component'}
 *
 *  * **npm package**: `\@angular/forms`
 *
 *  * **NgModule**: {\@link ReactiveFormsModule}
 *
 * \@stable
 */
var FormBuilder = /** @class */ (function () {
    function FormBuilder() {
    }
    /**
     * Construct a new {@link FormGroup} with the given map of configuration.
     * Valid keys for the `extra` parameter map are `validator` and `asyncValidator`.
     *
     * See the {@link FormGroup} constructor for more details.
     */
    /**
     * Construct a new {\@link FormGroup} with the given map of configuration.
     * Valid keys for the `extra` parameter map are `validator` and `asyncValidator`.
     *
     * See the {\@link FormGroup} constructor for more details.
     * @param {?} controlsConfig
     * @param {?=} extra
     * @return {?}
     */
    FormBuilder.prototype.group = /**
     * Construct a new {\@link FormGroup} with the given map of configuration.
     * Valid keys for the `extra` parameter map are `validator` and `asyncValidator`.
     *
     * See the {\@link FormGroup} constructor for more details.
     * @param {?} controlsConfig
     * @param {?=} extra
     * @return {?}
     */
    function (controlsConfig, extra) {
        if (extra === void 0) { extra = null; }
        var /** @type {?} */ controls = this._reduceControls(controlsConfig);
        var /** @type {?} */ validator = extra != null ? extra['validator'] : null;
        var /** @type {?} */ asyncValidator = extra != null ? extra['asyncValidator'] : null;
        return new FormGroup(controls, validator, asyncValidator);
    };
    /**
     * Construct a new {@link FormControl} with the given `formState`,`validator`, and
     * `asyncValidator`.
     *
     * `formState` can either be a standalone value for the form control or an object
     * that contains both a value and a disabled status.
     *
     */
    /**
     * Construct a new {\@link FormControl} with the given `formState`,`validator`, and
     * `asyncValidator`.
     *
     * `formState` can either be a standalone value for the form control or an object
     * that contains both a value and a disabled status.
     *
     * @param {?} formState
     * @param {?=} validator
     * @param {?=} asyncValidator
     * @return {?}
     */
    FormBuilder.prototype.control = /**
     * Construct a new {\@link FormControl} with the given `formState`,`validator`, and
     * `asyncValidator`.
     *
     * `formState` can either be a standalone value for the form control or an object
     * that contains both a value and a disabled status.
     *
     * @param {?} formState
     * @param {?=} validator
     * @param {?=} asyncValidator
     * @return {?}
     */
    function (formState, validator, asyncValidator) {
        return new FormControl(formState, validator, asyncValidator);
    };
    /**
     * Construct a {@link FormArray} from the given `controlsConfig` array of
     * configuration, with the given optional `validator` and `asyncValidator`.
     */
    /**
     * Construct a {\@link FormArray} from the given `controlsConfig` array of
     * configuration, with the given optional `validator` and `asyncValidator`.
     * @param {?} controlsConfig
     * @param {?=} validator
     * @param {?=} asyncValidator
     * @return {?}
     */
    FormBuilder.prototype.array = /**
     * Construct a {\@link FormArray} from the given `controlsConfig` array of
     * configuration, with the given optional `validator` and `asyncValidator`.
     * @param {?} controlsConfig
     * @param {?=} validator
     * @param {?=} asyncValidator
     * @return {?}
     */
    function (controlsConfig, validator, asyncValidator) {
        var _this = this;
        var /** @type {?} */ controls = controlsConfig.map(function (c) { return _this._createControl(c); });
        return new FormArray(controls, validator, asyncValidator);
    };
    /** @internal */
    /**
     * \@internal
     * @param {?} controlsConfig
     * @return {?}
     */
    FormBuilder.prototype._reduceControls = /**
     * \@internal
     * @param {?} controlsConfig
     * @return {?}
     */
    function (controlsConfig) {
        var _this = this;
        var /** @type {?} */ controls = {};
        Object.keys(controlsConfig).forEach(function (controlName) {
            controls[controlName] = _this._createControl(controlsConfig[controlName]);
        });
        return controls;
    };
    /** @internal */
    /**
     * \@internal
     * @param {?} controlConfig
     * @return {?}
     */
    FormBuilder.prototype._createControl = /**
     * \@internal
     * @param {?} controlConfig
     * @return {?}
     */
    function (controlConfig) {
        if (controlConfig instanceof FormControl || controlConfig instanceof FormGroup ||
            controlConfig instanceof FormArray) {
            return controlConfig;
        }
        else if (Array.isArray(controlConfig)) {
            var /** @type {?} */ value = controlConfig[0];
            var /** @type {?} */ validator = controlConfig.length > 1 ? controlConfig[1] : null;
            var /** @type {?} */ asyncValidator = controlConfig.length > 2 ? controlConfig[2] : null;
            return this.control(value, validator, asyncValidator);
        }
        else {
            return this.control(controlConfig);
        }
    };
    FormBuilder.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    FormBuilder.ctorParameters = function () { return []; };
    return FormBuilder;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * \@stable
 */
var VERSION = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["Version"]('5.2.10');

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * \@whatItDoes Adds `novalidate` attribute to all forms by default.
 *
 * `novalidate` is used to disable browser's native form validation.
 *
 * If you want to use native validation with Angular forms, just add `ngNativeValidate` attribute:
 *
 * ```
 * <form ngNativeValidate></form>
 * ```
 *
 * \@experimental
 */
var NgNoValidate = /** @class */ (function () {
    function NgNoValidate() {
    }
    NgNoValidate.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{
                    selector: 'form:not([ngNoForm]):not([ngNativeValidate])',
                    host: { 'novalidate': '' },
                },] },
    ];
    /** @nocollapse */
    NgNoValidate.ctorParameters = function () { return []; };
    return NgNoValidate;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var SHARED_FORM_DIRECTIVES = [
    NgNoValidate,
    NgSelectOption,
    NgSelectMultipleOption,
    DefaultValueAccessor,
    NumberValueAccessor,
    RangeValueAccessor,
    CheckboxControlValueAccessor,
    SelectControlValueAccessor,
    SelectMultipleControlValueAccessor,
    RadioControlValueAccessor,
    NgControlStatus,
    NgControlStatusGroup,
    RequiredValidator,
    MinLengthValidator,
    MaxLengthValidator,
    PatternValidator,
    CheckboxRequiredValidator,
    EmailValidator,
];
var TEMPLATE_DRIVEN_DIRECTIVES = [NgModel, NgModelGroup, NgForm];
var REACTIVE_DRIVEN_DIRECTIVES = [FormControlDirective, FormGroupDirective, FormControlName, FormGroupName, FormArrayName];
/**
 * Internal module used for sharing directives between FormsModule and ReactiveFormsModule
 */
var InternalFormsSharedModule = /** @class */ (function () {
    function InternalFormsSharedModule() {
    }
    InternalFormsSharedModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModule"], args: [{
                    declarations: SHARED_FORM_DIRECTIVES,
                    exports: SHARED_FORM_DIRECTIVES,
                },] },
    ];
    /** @nocollapse */
    InternalFormsSharedModule.ctorParameters = function () { return []; };
    return InternalFormsSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * The ng module for forms.
 * \@stable
 */
var FormsModule = /** @class */ (function () {
    function FormsModule() {
    }
    FormsModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModule"], args: [{
                    declarations: TEMPLATE_DRIVEN_DIRECTIVES,
                    providers: [RadioControlRegistry],
                    exports: [InternalFormsSharedModule, TEMPLATE_DRIVEN_DIRECTIVES]
                },] },
    ];
    /** @nocollapse */
    FormsModule.ctorParameters = function () { return []; };
    return FormsModule;
}());
/**
 * The ng module for reactive forms.
 * \@stable
 */
var ReactiveFormsModule = /** @class */ (function () {
    function ReactiveFormsModule() {
    }
    ReactiveFormsModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModule"], args: [{
                    declarations: [REACTIVE_DRIVEN_DIRECTIVES],
                    providers: [FormBuilder, RadioControlRegistry],
                    exports: [InternalFormsSharedModule, REACTIVE_DRIVEN_DIRECTIVES]
                },] },
    ];
    /** @nocollapse */
    ReactiveFormsModule.ctorParameters = function () { return []; };
    return ReactiveFormsModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * Entry point for all public APIs of this package.
 */

// This file only reexports content of the `src` folder. Keep it that way.

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Generated bundle index. Do not edit.
 */


//# sourceMappingURL=forms.js.map


/***/ }),

/***/ "./node_modules/@angular/upgrade/esm5/static.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵe", function() { return angular1Providers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵc", function() { return compileFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵa", function() { return injectorFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵd", function() { return parseFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵb", function() { return rootScopeFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAngularJSGlobal", function() { return getAngularJSGlobal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAngularLib", function() { return getAngularLib; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setAngularJSGlobal", function() { return setAngularJSGlobal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setAngularLib", function() { return setAngularLib; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "downgradeComponent", function() { return downgradeComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "downgradeInjectable", function() { return downgradeInjectable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VERSION", function() { return VERSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "downgradeModule", function() { return downgradeModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UpgradeComponent", function() { return UpgradeComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UpgradeModule", function() { return UpgradeModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_platform_browser__ = __webpack_require__("./node_modules/@angular/platform-browser/esm5/platform-browser.js");
/**
 * @license Angular v5.2.10
 * (c) 2010-2018 Google, Inc. https://angular.io/
 * License: MIT
 */



/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
function noNg() {
    throw new Error('AngularJS v1.x is not loaded!');
}
var angular = {
    bootstrap: noNg,
    module: noNg,
    element: noNg,
    version: undefined,
    resumeBootstrap: noNg,
    getTestability: noNg
};
try {
    if (window.hasOwnProperty('angular')) {
        angular = window.angular;
    }
}
catch (e) {
    // ignore in CJS mode.
}
/**
 * @deprecated Use {@link setAngularJSGlobal} instead.
 */
function setAngularLib(ng) {
    setAngularJSGlobal(ng);
}
/**
 * @deprecated Use {@link getAngularJSGlobal} instead.
 */
function getAngularLib() {
    return getAngularJSGlobal();
}
/**
 * Resets the AngularJS global.
 *
 * Used when AngularJS is loaded lazily, and not available on `window`.
 *
 * @stable
 */
function setAngularJSGlobal(ng) {
    angular = ng;
    version = ng && ng.version;
}
/**
 * Returns the current AngularJS global.
 *
 * @stable
 */
function getAngularJSGlobal() {
    return angular;
}
var bootstrap = function (e, modules, config) {
    return angular.bootstrap(e, modules, config);
};
var module$1 = function (prefix, dependencies) {
    return angular.module(prefix, dependencies);
};
var element = function (e) { return angular.element(e); };


var version = angular.version;

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var $COMPILE = '$compile';
var $CONTROLLER = '$controller';
var $DELEGATE = '$delegate';
var $HTTP_BACKEND = '$httpBackend';
var $INJECTOR = '$injector';
var $INTERVAL = '$interval';
var $PARSE = '$parse';
var $PROVIDE = '$provide';

var $SCOPE = '$scope';
var $TEMPLATE_CACHE = '$templateCache';

var $$TESTABILITY = '$$testability';


var INJECTOR_KEY = '$$angularInjector';
var LAZY_MODULE_REF = '$$angularLazyModuleRef';

var REQUIRE_INJECTOR = '?^^' + INJECTOR_KEY;
var REQUIRE_NG_MODEL = '?ngModel';
var UPGRADE_MODULE_NAME = '$$UpgradeModule';

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * A `PropertyBinding` represents a mapping between a property name
 * and an attribute name. It is parsed from a string of the form
 * `"prop: attr"`; or simply `"propAndAttr" where the property
 * and attribute have the same identifier.
 */
var PropertyBinding = /** @class */ (function () {
    function PropertyBinding(prop, attr) {
        this.prop = prop;
        this.attr = attr;
        this.parseBinding();
    }
    PropertyBinding.prototype.parseBinding = function () {
        this.bracketAttr = "[" + this.attr + "]";
        this.parenAttr = "(" + this.attr + ")";
        this.bracketParenAttr = "[(" + this.attr + ")]";
        var capitalAttr = this.attr.charAt(0).toUpperCase() + this.attr.substr(1);
        this.onAttr = "on" + capitalAttr;
        this.bindAttr = "bind" + capitalAttr;
        this.bindonAttr = "bindon" + capitalAttr;
    };
    return PropertyBinding;
}());

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var DIRECTIVE_PREFIX_REGEXP = /^(?:x|data)[:\-_]/i;
var DIRECTIVE_SPECIAL_CHARS_REGEXP = /[:\-_]+(.)/g;

function controllerKey(name) {
    return '$' + name + 'Controller';
}
function directiveNormalize(name) {
    return name.replace(DIRECTIVE_PREFIX_REGEXP, '')
        .replace(DIRECTIVE_SPECIAL_CHARS_REGEXP, function (_, letter) { return letter.toUpperCase(); });
}

function getComponentName(component) {
    // Return the name of the component or the first line of its stringified version.
    return component.overriddenName || component.name || component.toString().split('\n')[0];
}
function isFunction(value) {
    return typeof value === 'function';
}
/**
 * @return Whether the passed-in component implements the subset of the
 *     `ControlValueAccessor` interface needed for AngularJS `ng-model`
 *     compatibility.
 */
function supportsNgModel(component) {
    return typeof component.writeValue === 'function' &&
        typeof component.registerOnChange === 'function';
}
/**
 * Glue the AngularJS `NgModelController` (if it exists) to the component
 * (if it implements the needed subset of the `ControlValueAccessor` interface).
 */
function hookupNgModel(ngModel, component) {
    if (ngModel && supportsNgModel(component)) {
        ngModel.$render = function () { component.writeValue(ngModel.$viewValue); };
        component.registerOnChange(ngModel.$setViewValue.bind(ngModel));
        if (typeof component.registerOnTouched === 'function') {
            component.registerOnTouched(ngModel.$setTouched.bind(ngModel));
        }
    }
}
/**
 * Test two values for strict equality, accounting for the fact that `NaN !== NaN`.
 */
function strictEquals(val1, val2) {
    return val1 === val2 || (val1 !== val1 && val2 !== val2);
}

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var INITIAL_VALUE = {
    __UNINITIALIZED__: true
};
var DowngradeComponentAdapter = /** @class */ (function () {
    function DowngradeComponentAdapter(element, attrs, scope, ngModel, parentInjector, $injector, $compile, $parse, componentFactory, wrapCallback) {
        this.element = element;
        this.attrs = attrs;
        this.scope = scope;
        this.ngModel = ngModel;
        this.parentInjector = parentInjector;
        this.$injector = $injector;
        this.$compile = $compile;
        this.$parse = $parse;
        this.componentFactory = componentFactory;
        this.wrapCallback = wrapCallback;
        this.implementsOnChanges = false;
        this.inputChangeCount = 0;
        this.inputChanges = {};
        this.componentScope = scope.$new();
    }
    DowngradeComponentAdapter.prototype.compileContents = function () {
        var _this = this;
        var compiledProjectableNodes = [];
        var projectableNodes = this.groupProjectableNodes();
        var linkFns = projectableNodes.map(function (nodes) { return _this.$compile(nodes); });
        this.element.empty();
        linkFns.forEach(function (linkFn) {
            linkFn(_this.scope, function (clone) {
                compiledProjectableNodes.push(clone);
                _this.element.append(clone);
            });
        });
        return compiledProjectableNodes;
    };
    DowngradeComponentAdapter.prototype.createComponent = function (projectableNodes) {
        var providers = [{ provide: $SCOPE, useValue: this.componentScope }];
        var childInjector = __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injector"].create({ providers: providers, parent: this.parentInjector, name: 'DowngradeComponentAdapter' });
        this.componentRef =
            this.componentFactory.create(childInjector, projectableNodes, this.element[0]);
        this.viewChangeDetector = this.componentRef.injector.get(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"]);
        this.changeDetector = this.componentRef.changeDetectorRef;
        this.component = this.componentRef.instance;
        // testability hook is commonly added during component bootstrap in
        // packages/core/src/application_ref.bootstrap()
        // in downgraded application, component creation will take place here as well as adding the
        // testability hook.
        var testability = this.componentRef.injector.get(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Testability"], null);
        if (testability) {
            this.componentRef.injector.get(__WEBPACK_IMPORTED_MODULE_0__angular_core__["TestabilityRegistry"])
                .registerApplication(this.componentRef.location.nativeElement, testability);
        }
        hookupNgModel(this.ngModel, this.component);
    };
    DowngradeComponentAdapter.prototype.setupInputs = function (needsNgZone, propagateDigest) {
        var _this = this;
        if (propagateDigest === void 0) { propagateDigest = true; }
        var attrs = this.attrs;
        var inputs = this.componentFactory.inputs || [];
        var _loop_1 = function (i) {
            var input = new PropertyBinding(inputs[i].propName, inputs[i].templateName);
            var expr = null;
            if (attrs.hasOwnProperty(input.attr)) {
                var observeFn_1 = (function (prop) {
                    var prevValue = INITIAL_VALUE;
                    return function (currValue) {
                        // Initially, both `$observe()` and `$watch()` will call this function.
                        if (!strictEquals(prevValue, currValue)) {
                            if (prevValue === INITIAL_VALUE) {
                                prevValue = currValue;
                            }
                            _this.updateInput(prop, prevValue, currValue);
                            prevValue = currValue;
                        }
                    };
                })(input.prop);
                attrs.$observe(input.attr, observeFn_1);
                // Use `$watch()` (in addition to `$observe()`) in order to initialize the input in time
                // for `ngOnChanges()`. This is necessary if we are already in a `$digest`, which means that
                // `ngOnChanges()` (which is called by a watcher) will run before the `$observe()` callback.
                var unwatch_1 = this_1.componentScope.$watch(function () {
                    unwatch_1();
                    unwatch_1 = null;
                    observeFn_1(attrs[input.attr]);
                });
            }
            else if (attrs.hasOwnProperty(input.bindAttr)) {
                expr = attrs[input.bindAttr];
            }
            else if (attrs.hasOwnProperty(input.bracketAttr)) {
                expr = attrs[input.bracketAttr];
            }
            else if (attrs.hasOwnProperty(input.bindonAttr)) {
                expr = attrs[input.bindonAttr];
            }
            else if (attrs.hasOwnProperty(input.bracketParenAttr)) {
                expr = attrs[input.bracketParenAttr];
            }
            if (expr != null) {
                var watchFn = (function (prop) {
                    return function (currValue, prevValue) {
                        return _this.updateInput(prop, prevValue, currValue);
                    };
                })(input.prop);
                this_1.componentScope.$watch(expr, watchFn);
            }
        };
        var this_1 = this;
        for (var i = 0; i < inputs.length; i++) {
            _loop_1(i);
        }
        // Invoke `ngOnChanges()` and Change Detection (when necessary)
        var detectChanges = function () { return _this.changeDetector.detectChanges(); };
        var prototype = this.componentFactory.componentType.prototype;
        this.implementsOnChanges = !!(prototype && prototype.ngOnChanges);
        this.componentScope.$watch(function () { return _this.inputChangeCount; }, this.wrapCallback(function () {
            // Invoke `ngOnChanges()`
            if (_this.implementsOnChanges) {
                var inputChanges = _this.inputChanges;
                _this.inputChanges = {};
                _this.component.ngOnChanges((inputChanges));
            }
            _this.viewChangeDetector.markForCheck();
            // If opted out of propagating digests, invoke change detection when inputs change.
            if (!propagateDigest) {
                detectChanges();
            }
        }));
        // If not opted out of propagating digests, invoke change detection on every digest
        if (propagateDigest) {
            this.componentScope.$watch(this.wrapCallback(detectChanges));
        }
        // If necessary, attach the view so that it will be dirty-checked.
        // (Allow time for the initial input values to be set and `ngOnChanges()` to be called.)
        if (needsNgZone || !propagateDigest) {
            var unwatch_2 = this.componentScope.$watch(function () {
                unwatch_2();
                unwatch_2 = null;
                var appRef = _this.parentInjector.get(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ApplicationRef"]);
                appRef.attachView(_this.componentRef.hostView);
            });
        }
    };
    DowngradeComponentAdapter.prototype.setupOutputs = function () {
        var attrs = this.attrs;
        var outputs = this.componentFactory.outputs || [];
        for (var j = 0; j < outputs.length; j++) {
            var output = new PropertyBinding(outputs[j].propName, outputs[j].templateName);
            var bindonAttr = output.bindonAttr.substring(0, output.bindonAttr.length - 6);
            var bracketParenAttr = "[(" + output.bracketParenAttr.substring(2, output.bracketParenAttr.length - 8) + ")]";
            // order below is important - first update bindings then evaluate expressions
            if (attrs.hasOwnProperty(bindonAttr)) {
                this.subscribeToOutput(output, attrs[bindonAttr], true);
            }
            if (attrs.hasOwnProperty(bracketParenAttr)) {
                this.subscribeToOutput(output, attrs[bracketParenAttr], true);
            }
            if (attrs.hasOwnProperty(output.onAttr)) {
                this.subscribeToOutput(output, attrs[output.onAttr]);
            }
            if (attrs.hasOwnProperty(output.parenAttr)) {
                this.subscribeToOutput(output, attrs[output.parenAttr]);
            }
        }
    };
    DowngradeComponentAdapter.prototype.subscribeToOutput = function (output, expr, isAssignment) {
        var _this = this;
        if (isAssignment === void 0) { isAssignment = false; }
        var getter = this.$parse(expr);
        var setter = getter.assign;
        if (isAssignment && !setter) {
            throw new Error("Expression '" + expr + "' is not assignable!");
        }
        var emitter = this.component[output.prop];
        if (emitter) {
            emitter.subscribe({
                next: isAssignment ? function (v) { return setter(_this.scope, v); } :
                    function (v) { return getter(_this.scope, { '$event': v }); }
            });
        }
        else {
            throw new Error("Missing emitter '" + output.prop + "' on component '" + getComponentName(this.componentFactory.componentType) + "'!");
        }
    };
    DowngradeComponentAdapter.prototype.registerCleanup = function () {
        var _this = this;
        var destroyComponentRef = this.wrapCallback(function () { return _this.componentRef.destroy(); });
        var destroyed = false;
        this.element.on('$destroy', function () { return _this.componentScope.$destroy(); });
        this.componentScope.$on('$destroy', function () {
            if (!destroyed) {
                destroyed = true;
                _this.componentRef.injector.get(__WEBPACK_IMPORTED_MODULE_0__angular_core__["TestabilityRegistry"])
                    .unregisterApplication(_this.componentRef.location.nativeElement);
                destroyComponentRef();
            }
        });
    };
    DowngradeComponentAdapter.prototype.getInjector = function () { return this.componentRef.injector; };
    DowngradeComponentAdapter.prototype.updateInput = function (prop, prevValue, currValue) {
        if (this.implementsOnChanges) {
            this.inputChanges[prop] = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["SimpleChange"](prevValue, currValue, prevValue === currValue);
        }
        this.inputChangeCount++;
        this.component[prop] = currValue;
    };
    DowngradeComponentAdapter.prototype.groupProjectableNodes = function () {
        var ngContentSelectors = this.componentFactory.ngContentSelectors;
        return groupNodesBySelector(ngContentSelectors, this.element.contents());
    };
    return DowngradeComponentAdapter;
}());
/**
 * Group a set of DOM nodes into `ngContent` groups, based on the given content selectors.
 */
function groupNodesBySelector(ngContentSelectors, nodes) {
    var projectableNodes = [];
    var wildcardNgContentIndex;
    for (var i = 0, ii = ngContentSelectors.length; i < ii; ++i) {
        projectableNodes[i] = [];
    }
    for (var j = 0, jj = nodes.length; j < jj; ++j) {
        var node = nodes[j];
        var ngContentIndex = findMatchingNgContentIndex(node, ngContentSelectors);
        if (ngContentIndex != null) {
            projectableNodes[ngContentIndex].push(node);
        }
    }
    return projectableNodes;
}
function findMatchingNgContentIndex(element, ngContentSelectors) {
    var ngContentIndices = [];
    var wildcardNgContentIndex = -1;
    for (var i = 0; i < ngContentSelectors.length; i++) {
        var selector = ngContentSelectors[i];
        if (selector === '*') {
            wildcardNgContentIndex = i;
        }
        else {
            if (matchesSelector(element, selector)) {
                ngContentIndices.push(i);
            }
        }
    }
    ngContentIndices.sort();
    if (wildcardNgContentIndex !== -1) {
        ngContentIndices.push(wildcardNgContentIndex);
    }
    return ngContentIndices.length ? ngContentIndices[0] : null;
}
var _matches;
function matchesSelector(el, selector) {
    if (!_matches) {
        var elProto = Element.prototype;
        _matches = elProto.matches || elProto.matchesSelector || elProto.mozMatchesSelector ||
            elProto.msMatchesSelector || elProto.oMatchesSelector || elProto.webkitMatchesSelector;
    }
    return el.nodeType === Node.ELEMENT_NODE ? _matches.call(el, selector) : false;
}

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @whatItDoes
 *
 * *Part of the [upgrade/static](api?query=upgrade%2Fstatic)
 * library for hybrid upgrade apps that support AoT compilation*
 *
 * Allows an Angular component to be used from AngularJS.
 *
 * @howToUse
 *
 * Let's assume that you have an Angular component called `ng2Heroes` that needs
 * to be made available in AngularJS templates.
 *
 * {@example upgrade/static/ts/module.ts region="ng2-heroes"}
 *
 * We must create an AngularJS [directive](https://docs.angularjs.org/guide/directive)
 * that will make this Angular component available inside AngularJS templates.
 * The `downgradeComponent()` function returns a factory function that we
 * can use to define the AngularJS directive that wraps the "downgraded" component.
 *
 * {@example upgrade/static/ts/module.ts region="ng2-heroes-wrapper"}
 *
 * @description
 *
 * A helper function that returns a factory function to be used for registering an
 * AngularJS wrapper directive for "downgrading" an Angular component.
 *
 * The parameter contains information about the Component that is being downgraded:
 *
 * * `component: Type<any>`: The type of the Component that will be downgraded
 *
 * @experimental
 */
function downgradeComponent(info) {
    var directiveFactory = function ($compile, $injector, $parse) {
        // When using `UpgradeModule`, we don't need to ensure callbacks to Angular APIs (e.g. change
        // detection) are run inside the Angular zone, because `$digest()` will be run inside the zone
        // (except if explicitly escaped, in which case we shouldn't force it back in).
        // When using `downgradeModule()` though, we need to ensure such callbacks are run inside the
        // Angular zone.
        var needsNgZone = false;
        var wrapCallback = function (cb) { return cb; };
        var ngZone;
        return {
            restrict: 'E',
            terminal: true,
            require: [REQUIRE_INJECTOR, REQUIRE_NG_MODEL],
            link: function (scope, element, attrs, required) {
                // We might have to compile the contents asynchronously, because this might have been
                // triggered by `UpgradeNg1ComponentAdapterBuilder`, before the Angular templates have
                // been compiled.
                var ngModel = required[1];
                var parentInjector = required[0];
                var ranAsync = false;
                if (!parentInjector) {
                    var lazyModuleRef = $injector.get(LAZY_MODULE_REF);
                    needsNgZone = lazyModuleRef.needsNgZone;
                    parentInjector = lazyModuleRef.injector || lazyModuleRef.promise;
                }
                var doDowngrade = function (injector) {
                    var componentFactoryResolver = injector.get(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ComponentFactoryResolver"]);
                    var componentFactory = (componentFactoryResolver.resolveComponentFactory(info.component));
                    if (!componentFactory) {
                        throw new Error('Expecting ComponentFactory for: ' + getComponentName(info.component));
                    }
                    var injectorPromise = new ParentInjectorPromise(element);
                    var facade = new DowngradeComponentAdapter(element, attrs, scope, ngModel, injector, $injector, $compile, $parse, componentFactory, wrapCallback);
                    var projectableNodes = facade.compileContents();
                    facade.createComponent(projectableNodes);
                    facade.setupInputs(needsNgZone, info.propagateDigest);
                    facade.setupOutputs();
                    facade.registerCleanup();
                    injectorPromise.resolve(facade.getInjector());
                    if (ranAsync) {
                        // If this is run async, it is possible that it is not run inside a
                        // digest and initial input values will not be detected.
                        scope.$evalAsync(function () { });
                    }
                };
                var downgradeFn = !needsNgZone ? doDowngrade : function (injector) {
                    if (!ngZone) {
                        ngZone = injector.get(__WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"]);
                        wrapCallback = function (cb) {
                            return function () {
                                return __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"].isInAngularZone() ? cb() : ngZone.run(cb);
                            };
                        };
                    }
                    wrapCallback(function () { return doDowngrade(injector); })();
                };
                if (isThenable(parentInjector)) {
                    parentInjector.then(downgradeFn);
                }
                else {
                    downgradeFn(parentInjector);
                }
                ranAsync = true;
            }
        };
    };
    // bracket-notation because of closure - see #14441
    directiveFactory['$inject'] = [$COMPILE, $INJECTOR, $PARSE];
    return directiveFactory;
}
/**
 * Synchronous promise-like object to wrap parent injectors,
 * to preserve the synchronous nature of Angular 1's $compile.
 */
var ParentInjectorPromise = /** @class */ (function () {
    function ParentInjectorPromise(element) {
        this.element = element;
        this.injectorKey = controllerKey(INJECTOR_KEY);
        this.callbacks = [];
        // Store the promise on the element.
        // Store the promise on the element.
        element.data(this.injectorKey, this);
    }
    ParentInjectorPromise.prototype.then = function (callback) {
        if (this.injector) {
            callback(this.injector);
        }
        else {
            this.callbacks.push(callback);
        }
    };
    ParentInjectorPromise.prototype.resolve = function (injector) {
        this.injector = injector;
        // Store the real injector on the element.
        // Store the real injector on the element.
        this.element.data(this.injectorKey, injector);
        // Release the element to prevent memory leaks.
        this.element = (null);
        // Run the queued callbacks.
        this.callbacks.forEach(function (callback) { return callback(injector); });
        this.callbacks.length = 0;
    };
    return ParentInjectorPromise;
}());
function isThenable(obj) {
    return isFunction(obj.then);
}

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @whatItDoes
 *
 * *Part of the [upgrade/static](api?query=upgrade%2Fstatic)
 * library for hybrid upgrade apps that support AoT compilation*
 *
 * Allow an Angular service to be accessible from AngularJS.
 *
 * @howToUse
 *
 * First ensure that the service to be downgraded is provided in an {@link NgModule}
 * that will be part of the upgrade application. For example, let's assume we have
 * defined `HeroesService`
 *
 * {@example upgrade/static/ts/module.ts region="ng2-heroes-service"}
 *
 * and that we have included this in our upgrade app {@link NgModule}
 *
 * {@example upgrade/static/ts/module.ts region="ng2-module"}
 *
 * Now we can register the `downgradeInjectable` factory function for the service
 * on an AngularJS module.
 *
 * {@example upgrade/static/ts/module.ts region="downgrade-ng2-heroes-service"}
 *
 * Inside an AngularJS component's controller we can get hold of the
 * downgraded service via the name we gave when downgrading.
 *
 * {@example upgrade/static/ts/module.ts region="example-app"}
 *
 * @description
 *
 * Takes a `token` that identifies a service provided from Angular.
 *
 * Returns a [factory function](https://docs.angularjs.org/guide/di) that can be
 * used to register the service on an AngularJS module.
 *
 * The factory function provides access to the Angular service that
 * is identified by the `token` parameter.
 *
 * @experimental
 */
function downgradeInjectable(token) {
    var factory = function (i) { return i.get(token); };
    factory['$inject'] = [INJECTOR_KEY];
    return factory;
}

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @stable
 */
var VERSION = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["Version"]('5.2.10');

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
// We have to do a little dance to get the ng1 injector into the module injector.
// We store the ng1 injector so that the provider in the module injector can access it
// Then we "get" the ng1 injector from the module injector, which triggers the provider to read
// the stored injector and release the reference to it.
var tempInjectorRef;
function setTempInjectorRef(injector) {
    tempInjectorRef = injector;
}
function injectorFactory() {
    if (!tempInjectorRef) {
        throw new Error('Trying to get the AngularJS injector before it being set.');
    }
    var injector = tempInjectorRef;
    tempInjectorRef = null; // clear the value to prevent memory leaks
    return injector;
}
function rootScopeFactory(i) {
    return i.get('$rootScope');
}
function compileFactory(i) {
    return i.get('$compile');
}
function parseFactory(i) {
    return i.get('$parse');
}
var angular1Providers = [
    // We must use exported named functions for the ng2 factories to keep the compiler happy:
    // > Metadata collected contains an error that will be reported at runtime:
    // >   Function calls are not supported.
    // >   Consider replacing the function or lambda with a reference to an exported function
    { provide: '$injector', useFactory: injectorFactory, deps: [] },
    { provide: '$rootScope', useFactory: rootScopeFactory, deps: ['$injector'] },
    { provide: '$compile', useFactory: compileFactory, deps: ['$injector'] },
    { provide: '$parse', useFactory: parseFactory, deps: ['$injector'] }
];

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var NgAdapterInjector = /** @class */ (function () {
    function NgAdapterInjector(modInjector) {
        this.modInjector = modInjector;
    }
    // When Angular locate a service in the component injector tree, the not found value is set to
    // `NOT_FOUND_CHECK_ONLY_ELEMENT_INJECTOR`. In such a case we should not walk up to the module
    // injector.
    // AngularJS only supports a single tree and should always check the module injector.
    // When Angular locate a service in the component injector tree, the not found value is set to
    // `NOT_FOUND_CHECK_ONLY_ELEMENT_INJECTOR`. In such a case we should not walk up to the module
    // injector.
    // AngularJS only supports a single tree and should always check the module injector.
    NgAdapterInjector.prototype.get = 
    // When Angular locate a service in the component injector tree, the not found value is set to
    // `NOT_FOUND_CHECK_ONLY_ELEMENT_INJECTOR`. In such a case we should not walk up to the module
    // injector.
    // AngularJS only supports a single tree and should always check the module injector.
    function (token, notFoundValue) {
        if (notFoundValue === __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵNOT_FOUND_CHECK_ONLY_ELEMENT_INJECTOR"]) {
            return notFoundValue;
        }
        return this.modInjector.get(token, notFoundValue);
    };
    return NgAdapterInjector;
}());

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/** @experimental */
function downgradeModule(moduleFactoryOrBootstrapFn) {
    var LAZY_MODULE_NAME = UPGRADE_MODULE_NAME + '.lazy';
    var bootstrapFn = isFunction(moduleFactoryOrBootstrapFn) ?
        moduleFactoryOrBootstrapFn :
        function (extraProviders) {
            return Object(__WEBPACK_IMPORTED_MODULE_1__angular_platform_browser__["platformBrowser"])(extraProviders).bootstrapModuleFactory(moduleFactoryOrBootstrapFn);
        };
    var injector;
    // Create an ng1 module to bootstrap.
    module$1(LAZY_MODULE_NAME, [])
        .factory(INJECTOR_KEY, function () {
        if (!injector) {
            throw new Error('Trying to get the Angular injector before bootstrapping an Angular module.');
        }
        return injector;
    })
        .factory(LAZY_MODULE_REF, [
        $INJECTOR,
        function ($injector) {
            setTempInjectorRef($injector);
            var result = {
                needsNgZone: true,
                promise: bootstrapFn(angular1Providers).then(function (ref) {
                    injector = result.injector = new NgAdapterInjector(ref.injector);
                    injector.get($INJECTOR);
                    return injector;
                })
            };
            return result;
        }
    ]);
    return LAZY_MODULE_NAME;
}

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
// Constants
var REQUIRE_PREFIX_RE = /^(\^\^?)?(\?)?(\^\^?)?/;
// Classes
var UpgradeHelper = /** @class */ (function () {
    function UpgradeHelper(injector, name, elementRef, directive) {
        this.injector = injector;
        this.name = name;
        this.$injector = injector.get($INJECTOR);
        this.$compile = this.$injector.get($COMPILE);
        this.$controller = this.$injector.get($CONTROLLER);
        this.element = elementRef.nativeElement;
        this.$element = element(this.element);
        this.directive = directive || UpgradeHelper.getDirective(this.$injector, name);
    }
    UpgradeHelper.getDirective = function ($injector, name) {
        var directives = $injector.get(name + 'Directive');
        if (directives.length > 1) {
            throw new Error("Only support single directive definition for: " + name);
        }
        var directive = directives[0];
        // AngularJS will transform `link: xyz` to `compile: () => xyz`. So we can only tell there was a
        // user-defined `compile` if there is no `link`. In other cases, we will just ignore `compile`.
        if (directive.compile && !directive.link)
            notSupported(name, 'compile');
        if (directive.replace)
            notSupported(name, 'replace');
        if (directive.terminal)
            notSupported(name, 'terminal');
        return directive;
    };
    UpgradeHelper.getTemplate = function ($injector, directive, fetchRemoteTemplate) {
        if (fetchRemoteTemplate === void 0) { fetchRemoteTemplate = false; }
        if (directive.template !== undefined) {
            return getOrCall(directive.template);
        }
        else if (directive.templateUrl) {
            var $templateCache_1 = $injector.get($TEMPLATE_CACHE);
            var url_1 = getOrCall(directive.templateUrl);
            var template = $templateCache_1.get(url_1);
            if (template !== undefined) {
                return template;
            }
            else if (!fetchRemoteTemplate) {
                throw new Error('loading directive templates asynchronously is not supported');
            }
            return new Promise(function (resolve, reject) {
                var $httpBackend = $injector.get($HTTP_BACKEND);
                $httpBackend('GET', url_1, null, function (status, response) {
                    if (status === 200) {
                        resolve($templateCache_1.put(url_1, response));
                    }
                    else {
                        reject("GET component template from '" + url_1 + "' returned '" + status + ": " + response + "'");
                    }
                });
            });
        }
        else {
            throw new Error("Directive '" + directive.name + "' is not a component, it is missing template.");
        }
    };
    UpgradeHelper.prototype.buildController = function (controllerType, $scope) {
        // TODO: Document that we do not pre-assign bindings on the controller instance.
        // Quoted properties below so that this code can be optimized with Closure Compiler.
        var locals = { '$scope': $scope, '$element': this.$element };
        var controller = this.$controller(controllerType, locals, null, this.directive.controllerAs);
        this.$element.data(controllerKey((this.directive.name)), controller);
        return controller;
    };
    UpgradeHelper.prototype.compileTemplate = function (template) {
        if (template === undefined) {
            template = UpgradeHelper.getTemplate(this.$injector, this.directive);
        }
        return this.compileHtml(template);
    };
    UpgradeHelper.prototype.prepareTransclusion = function () {
        var _this = this;
        var transclude = this.directive.transclude;
        var contentChildNodes = this.extractChildNodes();
        var attachChildrenFn = function (scope, cloneAttachFn) {
            // Since AngularJS v1.5.8, `cloneAttachFn` will try to destroy the transclusion scope if
            // `$template` is empty. Since the transcluded content comes from Angular, not AngularJS,
            // there will be no transclusion scope here.
            // Provide a dummy `scope.$destroy()` method to prevent `cloneAttachFn` from throwing.
            scope = scope || { $destroy: function () { return undefined; } };
            return cloneAttachFn($template, scope);
        };
        var $template = contentChildNodes;
        if (transclude) {
            var slots_1 = Object.create(null);
            if (typeof transclude === 'object') {
                $template = [];
                var slotMap_1 = Object.create(null);
                var filledSlots_1 = Object.create(null);
                // Parse the element selectors.
                Object.keys(transclude).forEach(function (slotName) {
                    var selector = transclude[slotName];
                    var optional = selector.charAt(0) === '?';
                    selector = optional ? selector.substring(1) : selector;
                    slotMap_1[selector] = slotName;
                    slots_1[slotName] = null; // `null`: Defined but not yet filled.
                    filledSlots_1[slotName] = optional; // Consider optional slots as filled.
                });
                // Add the matching elements into their slot.
                contentChildNodes.forEach(function (node) {
                    var slotName = slotMap_1[directiveNormalize(node.nodeName.toLowerCase())];
                    if (slotName) {
                        filledSlots_1[slotName] = true;
                        slots_1[slotName] = slots_1[slotName] || [];
                        slots_1[slotName].push(node);
                    }
                    else {
                        $template.push(node);
                    }
                });
                // Check for required slots that were not filled.
                Object.keys(filledSlots_1).forEach(function (slotName) {
                    if (!filledSlots_1[slotName]) {
                        throw new Error("Required transclusion slot '" + slotName + "' on directive: " + _this.name);
                    }
                });
                Object.keys(slots_1).filter(function (slotName) { return slots_1[slotName]; }).forEach(function (slotName) {
                    var nodes = slots_1[slotName];
                    slots_1[slotName] = function (scope, cloneAttach) {
                        return cloneAttach(nodes, scope);
                    };
                });
            }
            // Attach `$$slots` to default slot transclude fn.
            attachChildrenFn.$$slots = slots_1;
            // AngularJS v1.6+ ignores empty or whitespace-only transcluded text nodes. But Angular
            // removes all text content after the first interpolation and updates it later, after
            // evaluating the expressions. This would result in AngularJS failing to recognize text
            // nodes that start with an interpolation as transcluded content and use the fallback
            // content instead.
            // To avoid this issue, we add a
            // [zero-width non-joiner character](https://en.wikipedia.org/wiki/Zero-width_non-joiner)
            // to empty text nodes (which can only be a result of Angular removing their initial content).
            // NOTE: Transcluded text content that starts with whitespace followed by an interpolation
            //       will still fail to be detected by AngularJS v1.6+
            $template.forEach(function (node) {
                if (node.nodeType === Node.TEXT_NODE && !node.nodeValue) {
                    node.nodeValue = '\u200C';
                }
            });
        }
        return attachChildrenFn;
    };
    UpgradeHelper.prototype.resolveAndBindRequiredControllers = function (controllerInstance) {
        var directiveRequire = this.getDirectiveRequire();
        var requiredControllers = this.resolveRequire(directiveRequire);
        if (controllerInstance && this.directive.bindToController && isMap(directiveRequire)) {
            var requiredControllersMap_1 = requiredControllers;
            Object.keys(requiredControllersMap_1).forEach(function (key) {
                controllerInstance[key] = requiredControllersMap_1[key];
            });
        }
        return requiredControllers;
    };
    UpgradeHelper.prototype.compileHtml = function (html) {
        this.element.innerHTML = html;
        return this.$compile(this.element.childNodes);
    };
    UpgradeHelper.prototype.extractChildNodes = function () {
        var childNodes = [];
        var childNode;
        while (childNode = this.element.firstChild) {
            this.element.removeChild(childNode);
            childNodes.push(childNode);
        }
        return childNodes;
    };
    UpgradeHelper.prototype.getDirectiveRequire = function () {
        var require = this.directive.require || ((this.directive.controller && this.directive.name));
        if (isMap(require)) {
            Object.keys(require).forEach(function (key) {
                var value = require[key];
                var match = (value.match(REQUIRE_PREFIX_RE));
                var name = value.substring(match[0].length);
                if (!name) {
                    require[key] = match[0] + key;
                }
            });
        }
        return require;
    };
    UpgradeHelper.prototype.resolveRequire = function (require, controllerInstance) {
        var _this = this;
        if (!require) {
            return null;
        }
        else if (Array.isArray(require)) {
            return require.map(function (req) { return _this.resolveRequire(req); });
        }
        else if (typeof require === 'object') {
            var value_1 = {};
            Object.keys(require).forEach(function (key) { return value_1[key] = (_this.resolveRequire(require[key])); });
            return value_1;
        }
        else if (typeof require === 'string') {
            var match = (require.match(REQUIRE_PREFIX_RE));
            var inheritType = match[1] || match[3];
            var name_1 = require.substring(match[0].length);
            var isOptional = !!match[2];
            var searchParents = !!inheritType;
            var startOnParent = inheritType === '^^';
            var ctrlKey = controllerKey(name_1);
            var elem = startOnParent ? this.$element.parent() : this.$element;
            var value = searchParents ? elem.inheritedData(ctrlKey) : elem.data(ctrlKey);
            if (!value && !isOptional) {
                throw new Error("Unable to find required '" + require + "' in upgraded directive '" + this.name + "'.");
            }
            return value;
        }
        else {
            throw new Error("Unrecognized 'require' syntax on upgraded directive '" + this.name + "': " + require);
        }
    };
    return UpgradeHelper;
}());
function getOrCall(property) {
    return isFunction(property) ? property() : property;
}
// NOTE: Only works for `typeof T !== 'object'`.
function isMap(value) {
    return value && !Array.isArray(value) && typeof value === 'object';
}
function notSupported(name, feature) {
    throw new Error("Upgraded directive '" + name + "' contains unsupported feature: '" + feature + "'.");
}

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var NOT_SUPPORTED = 'NOT_SUPPORTED';
var INITIAL_VALUE$1 = {
    __UNINITIALIZED__: true
};
var Bindings = /** @class */ (function () {
    function Bindings() {
        this.twoWayBoundProperties = [];
        this.twoWayBoundLastValues = [];
        this.expressionBoundProperties = [];
        this.propertyToOutputMap = {};
    }
    return Bindings;
}());
/**
 * @whatItDoes
 *
 * *Part of the [upgrade/static](api?query=upgrade%2Fstatic)
 * library for hybrid upgrade apps that support AoT compilation*
 *
 * Allows an AngularJS component to be used from Angular.
 *
 * @howToUse
 *
 * Let's assume that you have an AngularJS component called `ng1Hero` that needs
 * to be made available in Angular templates.
 *
 * {@example upgrade/static/ts/module.ts region="ng1-hero"}
 *
 * We must create a {@link Directive} that will make this AngularJS component
 * available inside Angular templates.
 *
 * {@example upgrade/static/ts/module.ts region="ng1-hero-wrapper"}
 *
 * In this example you can see that we must derive from the {@link UpgradeComponent}
 * base class but also provide an {@link Directive `@Directive`} decorator. This is
 * because the AoT compiler requires that this information is statically available at
 * compile time.
 *
 * Note that we must do the following:
 * * specify the directive's selector (`ng1-hero`)
 * * specify all inputs and outputs that the AngularJS component expects
 * * derive from `UpgradeComponent`
 * * call the base class from the constructor, passing
 *   * the AngularJS name of the component (`ng1Hero`)
 *   * the {@link ElementRef} and {@link Injector} for the component wrapper
 *
 * @description
 *
 * A helper class that should be used as a base class for creating Angular directives
 * that wrap AngularJS components that need to be "upgraded".
 *
 * @experimental
 */
var UpgradeComponent = /** @class */ (function () {
    /**
     * Create a new `UpgradeComponent` instance. You should not normally need to do this.
     * Instead you should derive a new class from this one and call the super constructor
     * from the base class.
     *
     * {@example upgrade/static/ts/module.ts region="ng1-hero-wrapper" }
     *
     * * The `name` parameter should be the name of the AngularJS directive.
     * * The `elementRef` and `injector` parameters should be acquired from Angular by dependency
     *   injection into the base class constructor.
     *
     * Note that we must manually implement lifecycle hooks that call through to the super class.
     * This is because, at the moment, the AoT compiler is not able to tell that the
     * `UpgradeComponent`
     * already implements them and so does not wire up calls to them at runtime.
     */
    function UpgradeComponent(name, elementRef, injector) {
        this.name = name;
        this.elementRef = elementRef;
        this.injector = injector;
        this.helper = new UpgradeHelper(injector, name, elementRef);
        this.$injector = this.helper.$injector;
        this.element = this.helper.element;
        this.$element = this.helper.$element;
        this.directive = this.helper.directive;
        this.bindings = this.initializeBindings(this.directive);
        // We ask for the AngularJS scope from the Angular injector, since
        // we will put the new component scope onto the new injector for each component
        var $parentScope = injector.get($SCOPE);
        // QUESTION 1: Should we create an isolated scope if the scope is only true?
        // QUESTION 2: Should we make the scope accessible through `$element.scope()/isolateScope()`?
        this.$componentScope = $parentScope.$new(!!this.directive.scope);
        this.initializeOutputs();
    }
    UpgradeComponent.prototype.ngOnInit = function () {
        var _this = this;
        // Collect contents, insert and compile template
        var attachChildNodes = this.helper.prepareTransclusion();
        var linkFn = this.helper.compileTemplate();
        // Instantiate controller
        var controllerType = this.directive.controller;
        var bindToController = this.directive.bindToController;
        if (controllerType) {
            this.controllerInstance = this.helper.buildController(controllerType, this.$componentScope);
        }
        else if (bindToController) {
            throw new Error("Upgraded directive '" + this.directive.name + "' specifies 'bindToController' but no controller.");
        }
        // Set up outputs
        this.bindingDestination = bindToController ? this.controllerInstance : this.$componentScope;
        this.bindOutputs();
        // Require other controllers
        var requiredControllers = this.helper.resolveAndBindRequiredControllers(this.controllerInstance);
        // Hook: $onChanges
        if (this.pendingChanges) {
            this.forwardChanges(this.pendingChanges);
            this.pendingChanges = null;
        }
        // Hook: $onInit
        if (this.controllerInstance && isFunction(this.controllerInstance.$onInit)) {
            this.controllerInstance.$onInit();
        }
        // Hook: $doCheck
        if (this.controllerInstance && isFunction(this.controllerInstance.$doCheck)) {
            var callDoCheck = function () { return _this.controllerInstance.$doCheck(); };
            this.unregisterDoCheckWatcher = this.$componentScope.$parent.$watch(callDoCheck);
            callDoCheck();
        }
        // Linking
        var link = this.directive.link;
        var preLink = (typeof link == 'object') && link.pre;
        var postLink = (typeof link == 'object') ? link.post : link;
        var attrs = NOT_SUPPORTED;
        var transcludeFn = NOT_SUPPORTED;
        if (preLink) {
            preLink(this.$componentScope, this.$element, attrs, requiredControllers, transcludeFn);
        }
        linkFn(this.$componentScope, (null), { parentBoundTranscludeFn: attachChildNodes });
        if (postLink) {
            postLink(this.$componentScope, this.$element, attrs, requiredControllers, transcludeFn);
        }
        // Hook: $postLink
        if (this.controllerInstance && isFunction(this.controllerInstance.$postLink)) {
            this.controllerInstance.$postLink();
        }
    };
    UpgradeComponent.prototype.ngOnChanges = function (changes) {
        if (!this.bindingDestination) {
            this.pendingChanges = changes;
        }
        else {
            this.forwardChanges(changes);
        }
    };
    UpgradeComponent.prototype.ngDoCheck = function () {
        var _this = this;
        var twoWayBoundProperties = this.bindings.twoWayBoundProperties;
        var twoWayBoundLastValues = this.bindings.twoWayBoundLastValues;
        var propertyToOutputMap = this.bindings.propertyToOutputMap;
        twoWayBoundProperties.forEach(function (propName, idx) {
            var newValue = _this.bindingDestination[propName];
            var oldValue = twoWayBoundLastValues[idx];
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵlooseIdentical"])(newValue, oldValue)) {
                var outputName = propertyToOutputMap[propName];
                var eventEmitter = _this[outputName];
                eventEmitter.emit(newValue);
                twoWayBoundLastValues[idx] = newValue;
            }
        });
    };
    UpgradeComponent.prototype.ngOnDestroy = function () {
        if (isFunction(this.unregisterDoCheckWatcher)) {
            this.unregisterDoCheckWatcher();
        }
        if (this.controllerInstance && isFunction(this.controllerInstance.$onDestroy)) {
            this.controllerInstance.$onDestroy();
        }
        this.$componentScope.$destroy();
    };
    UpgradeComponent.prototype.initializeBindings = function (directive) {
        var _this = this;
        var btcIsObject = typeof directive.bindToController === 'object';
        if (btcIsObject && Object.keys((directive.scope)).length) {
            throw new Error("Binding definitions on scope and controller at the same time is not supported.");
        }
        var context = (btcIsObject) ? directive.bindToController : directive.scope;
        var bindings = new Bindings();
        if (typeof context == 'object') {
            Object.keys(context).forEach(function (propName) {
                var definition = context[propName];
                var bindingType = definition.charAt(0);
                // QUESTION: What about `=*`? Ignore? Throw? Support?
                switch (bindingType) {
                    case '@':
                    case '<':
                        // We don't need to do anything special. They will be defined as inputs on the
                        // upgraded component facade and the change propagation will be handled by
                        // `ngOnChanges()`.
                        break;
                    case '=':
                        bindings.twoWayBoundProperties.push(propName);
                        bindings.twoWayBoundLastValues.push(INITIAL_VALUE$1);
                        bindings.propertyToOutputMap[propName] = propName + 'Change';
                        break;
                    case '&':
                        bindings.expressionBoundProperties.push(propName);
                        bindings.propertyToOutputMap[propName] = propName;
                        break;
                    default:
                        var json = JSON.stringify(context);
                        throw new Error("Unexpected mapping '" + bindingType + "' in '" + json + "' in '" + _this.name + "' directive.");
                }
            });
        }
        return bindings;
    };
    UpgradeComponent.prototype.initializeOutputs = function () {
        var _this = this;
        // Initialize the outputs for `=` and `&` bindings
        this.bindings.twoWayBoundProperties.concat(this.bindings.expressionBoundProperties)
            .forEach(function (propName) {
            var outputName = _this.bindings.propertyToOutputMap[propName];
            _this[outputName] = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        });
    };
    UpgradeComponent.prototype.bindOutputs = function () {
        var _this = this;
        // Bind `&` bindings to the corresponding outputs
        this.bindings.expressionBoundProperties.forEach(function (propName) {
            var outputName = _this.bindings.propertyToOutputMap[propName];
            var emitter = _this[outputName];
            _this.bindingDestination[propName] = function (value) { return emitter.emit(value); };
        });
    };
    UpgradeComponent.prototype.forwardChanges = function (changes) {
        var _this = this;
        // Forward input changes to `bindingDestination`
        Object.keys(changes).forEach(function (propName) { return _this.bindingDestination[propName] = changes[propName].currentValue; });
        if (isFunction(this.bindingDestination.$onChanges)) {
            this.bindingDestination.$onChanges(changes);
        }
    };
    return UpgradeComponent;
}());

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @whatItDoes
 *
 * *Part of the [upgrade/static](api?query=upgrade%2Fstatic)
 * library for hybrid upgrade apps that support AoT compilation*
 *
 * Allows AngularJS and Angular components to be used together inside a hybrid upgrade
 * application, which supports AoT compilation.
 *
 * Specifically, the classes and functions in the `upgrade/static` module allow the following:
 * 1. Creation of an Angular directive that wraps and exposes an AngularJS component so
 *    that it can be used in an Angular template. See {@link UpgradeComponent}.
 * 2. Creation of an AngularJS directive that wraps and exposes an Angular component so
 *    that it can be used in an AngularJS template. See {@link downgradeComponent}.
 * 3. Creation of an Angular root injector provider that wraps and exposes an AngularJS
 *    service so that it can be injected into an Angular context. See
 *    {@link UpgradeModule#upgrading-an-angular-1-service Upgrading an AngularJS service} below.
 * 4. Creation of an AngularJS service that wraps and exposes an Angular injectable
 *    so that it can be injected into an AngularJS context. See {@link downgradeInjectable}.
 * 3. Bootstrapping of a hybrid Angular application which contains both of the frameworks
 *    coexisting in a single application. See the
 *    {@link UpgradeModule#example example} below.
 *
 * ## Mental Model
 *
 * When reasoning about how a hybrid application works it is useful to have a mental model which
 * describes what is happening and explains what is happening at the lowest level.
 *
 * 1. There are two independent frameworks running in a single application, each framework treats
 *    the other as a black box.
 * 2. Each DOM element on the page is owned exactly by one framework. Whichever framework
 *    instantiated the element is the owner. Each framework only updates/interacts with its own
 *    DOM elements and ignores others.
 * 3. AngularJS directives always execute inside the AngularJS framework codebase regardless of
 *    where they are instantiated.
 * 4. Angular components always execute inside the Angular framework codebase regardless of
 *    where they are instantiated.
 * 5. An AngularJS component can be "upgraded"" to an Angular component. This is achieved by
 *    defining an Angular directive, which bootstraps the AngularJS component at its location
 *    in the DOM. See {@link UpgradeComponent}.
 * 6. An Angular component can be "downgraded"" to an AngularJS component. This is achieved by
 *    defining an AngularJS directive, which bootstraps the Angular component at its location
 *    in the DOM. See {@link downgradeComponent}.
 * 7. Whenever an "upgraded"/"downgraded" component is instantiated the host element is owned by
 *    the framework doing the instantiation. The other framework then instantiates and owns the
 *    view for that component.
 *    a. This implies that the component bindings will always follow the semantics of the
 *       instantiation framework.
 *    b. The DOM attributes are parsed by the framework that owns the current template. So
 * attributes
 *       in AngularJS templates must use kebab-case, while AngularJS templates must use camelCase.
 *    c. However the template binding syntax will always use the Angular style, e.g. square
 *       brackets (`[...]`) for property binding.
 * 8. Angular is bootstrapped first; AngularJS is bootstrapped second. AngularJS always owns the
 *    root component of the application.
 * 9. The new application is running in an Angular zone, and therefore it no longer needs calls
 * to
 *    `$apply()`.
 *
 * @howToUse
 *
 * `import {UpgradeModule} from '@angular/upgrade/static';`
 *
 * ## Example
 * Import the {@link UpgradeModule} into your top level {@link NgModule Angular `NgModule`}.
 *
 * {@example upgrade/static/ts/module.ts region='ng2-module'}
 *
 * Then bootstrap the hybrid upgrade app's module, get hold of the {@link UpgradeModule} instance
 * and use it to bootstrap the top level [AngularJS
 * module](https://docs.angularjs.org/api/ng/type/angular.Module).
 *
 * {@example upgrade/static/ts/module.ts region='bootstrap'}
 *
 * {@a upgrading-an-angular-1-service}
 *
 * ## Upgrading an AngularJS service
 *
 * There is no specific API for upgrading an AngularJS service. Instead you should just follow the
 * following recipe:
 *
 * Let's say you have an AngularJS service:
 *
 * {@example upgrade/static/ts/module.ts region="ng1-title-case-service"}
 *
 * Then you should define an Angular provider to be included in your {@link NgModule} `providers`
 * property.
 *
 * {@example upgrade/static/ts/module.ts region="upgrade-ng1-service"}
 *
 * Then you can use the "upgraded" AngularJS service by injecting it into an Angular component
 * or service.
 *
 * {@example upgrade/static/ts/module.ts region="use-ng1-upgraded-service"}
 *
 * @description
 *
 * This class is an `NgModule`, which you import to provide AngularJS core services,
 * and has an instance method used to bootstrap the hybrid upgrade application.
 *
 * ## Core AngularJS services
 * Importing this {@link NgModule} will add providers for the core
 * [AngularJS services](https://docs.angularjs.org/api/ng/service) to the root injector.
 *
 * ## Bootstrap
 * The runtime instance of this class contains a {@link UpgradeModule#bootstrap `bootstrap()`}
 * method, which you use to bootstrap the top level AngularJS module onto an element in the
 * DOM for the hybrid upgrade app.
 *
 * It also contains properties to access the {@link UpgradeModule#injector root injector}, the
 * bootstrap {@link NgZone} and the
 * [AngularJS $injector](https://docs.angularjs.org/api/auto/service/$injector).
 *
 * @experimental
 */
var UpgradeModule = /** @class */ (function () {
    function UpgradeModule(/** The root {@link Injector} for the upgrade application. */
        /** The root {@link Injector} for the upgrade application. */
        injector, /** The bootstrap zone for the upgrade application */
        ngZone) {
        this.ngZone = ngZone;
        this.injector = new NgAdapterInjector(injector);
    }
    /**
     * Bootstrap an AngularJS application from this NgModule
     * @param element the element on which to bootstrap the AngularJS application
     * @param [modules] the AngularJS modules to bootstrap for this application
     * @param [config] optional extra AngularJS bootstrap configuration
     */
    /**
       * Bootstrap an AngularJS application from this NgModule
       * @param element the element on which to bootstrap the AngularJS application
       * @param [modules] the AngularJS modules to bootstrap for this application
       * @param [config] optional extra AngularJS bootstrap configuration
       */
    UpgradeModule.prototype.bootstrap = /**
       * Bootstrap an AngularJS application from this NgModule
       * @param element the element on which to bootstrap the AngularJS application
       * @param [modules] the AngularJS modules to bootstrap for this application
       * @param [config] optional extra AngularJS bootstrap configuration
       */
    function (element$$1, modules, config /*angular.IAngularBootstrapConfig*/) {
        var _this = this;
        if (modules === void 0) { modules = []; }
        var INIT_MODULE_NAME = UPGRADE_MODULE_NAME + '.init';
        // Create an ng1 module to bootstrap
        var initModule = module$1(INIT_MODULE_NAME, [])
            .value(INJECTOR_KEY, this.injector)
            .factory(LAZY_MODULE_REF, [
            INJECTOR_KEY,
            function (injector) { return ({ injector: injector, needsNgZone: false }); }
        ])
            .config([
            $PROVIDE, $INJECTOR,
            function ($provide, $injector) {
                if ($injector.has($$TESTABILITY)) {
                    $provide.decorator($$TESTABILITY, [
                        $DELEGATE,
                        function (testabilityDelegate) {
                            var originalWhenStable = testabilityDelegate.whenStable;
                            var injector = _this.injector;
                            // Cannot use arrow function below because we need the context
                            var newWhenStable = function (callback) {
                                originalWhenStable.call(testabilityDelegate, function () {
                                    var ng2Testability = injector.get(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Testability"]);
                                    if (ng2Testability.isStable()) {
                                        callback();
                                    }
                                    else {
                                        ng2Testability.whenStable(newWhenStable.bind(testabilityDelegate, callback));
                                    }
                                });
                            };
                            testabilityDelegate.whenStable = newWhenStable;
                            return testabilityDelegate;
                        }
                    ]);
                }
                if ($injector.has($INTERVAL)) {
                    $provide.decorator($INTERVAL, [
                        $DELEGATE,
                        function (intervalDelegate) {
                            // Wrap the $interval service so that setInterval is called outside NgZone,
                            // but the callback is still invoked within it. This is so that $interval
                            // won't block stability, which preserves the behavior from AngularJS.
                            var wrappedInterval = function (fn, delay, count, invokeApply) {
                                var pass = [];
                                for (var _i = 4; _i < arguments.length; _i++) {
                                    pass[_i - 4] = arguments[_i];
                                }
                                return _this.ngZone.runOutsideAngular(function () {
                                    return intervalDelegate.apply(void 0, [function () {
                                            var args = [];
                                            for (var _i = 0; _i < arguments.length; _i++) {
                                                args[_i] = arguments[_i];
                                            }
                                            // Run callback in the next VM turn - $interval calls
                                            // $rootScope.$apply, and running the callback in NgZone will
                                            // cause a '$digest already in progress' error if it's in the
                                            // same vm turn.
                                            setTimeout(function () { _this.ngZone.run(function () { return fn.apply(void 0, args); }); });
                                        }, delay, count, invokeApply].concat(pass));
                                });
                            };
                            wrappedInterval['cancel'] = intervalDelegate.cancel;
                            return wrappedInterval;
                        }
                    ]);
                }
            }
        ])
            .run([
            $INJECTOR,
            function ($injector) {
                _this.$injector = $injector;
                // Initialize the ng1 $injector provider
                setTempInjectorRef($injector);
                _this.injector.get($INJECTOR);
                // Put the injector on the DOM, so that it can be "required"
                // Put the injector on the DOM, so that it can be "required"
                element(element$$1).data(controllerKey(INJECTOR_KEY), _this.injector);
                // Wire up the ng1 rootScope to run a digest cycle whenever the zone settles
                // We need to do this in the next tick so that we don't prevent the bootup
                // stabilizing
                setTimeout(function () {
                    var $rootScope = $injector.get('$rootScope');
                    var subscription = _this.ngZone.onMicrotaskEmpty.subscribe(function () { return $rootScope.$digest(); });
                    $rootScope.$on('$destroy', function () { subscription.unsubscribe(); });
                }, 0);
            }
        ]);
        var upgradeModule = module$1(UPGRADE_MODULE_NAME, [INIT_MODULE_NAME].concat(modules));
        // Make sure resumeBootstrap() only exists if the current bootstrap is deferred
        var windowAngular = window['angular'];
        windowAngular.resumeBootstrap = undefined;
        // Bootstrap the AngularJS application inside our zone
        this.ngZone.run(function () { bootstrap(element$$1, [upgradeModule.name], config); });
        // Patch resumeBootstrap() to run inside the ngZone
        if (windowAngular.resumeBootstrap) {
            var originalResumeBootstrap_1 = windowAngular.resumeBootstrap;
            var ngZone_1 = this.ngZone;
            windowAngular.resumeBootstrap = function () {
                var _this = this;
                var args = arguments;
                windowAngular.resumeBootstrap = originalResumeBootstrap_1;
                return ngZone_1.run(function () { return windowAngular.resumeBootstrap.apply(_this, args); });
            };
        }
    };
    UpgradeModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{ providers: [angular1Providers] },] },
    ];
    /** @nocollapse */
    UpgradeModule.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injector"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"], },
    ]; };
    return UpgradeModule;
}());

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

// This file only re-exports content of the `src` folder. Keep it that way.

/**
 * Generated bundle index. Do not edit.
 */


//# sourceMappingURL=static.js.map


/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/accordion/accordion-config.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NgbAccordionConfig; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");

/**
 * Configuration service for the NgbAccordion component.
 * You can inject this service, typically in your root component, and customize the values of its properties in
 * order to provide default values for all the accordions used in the application.
 */
var NgbAccordionConfig = /** @class */ (function () {
    function NgbAccordionConfig() {
        this.closeOthers = false;
    }
    NgbAccordionConfig.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    return NgbAccordionConfig;
}());

//# sourceMappingURL=accordion-config.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/accordion/accordion.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return NgbPanelTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return NgbPanelContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NgbPanel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NgbAccordion; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_util__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/util/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__accordion_config__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/accordion/accordion-config.js");



var nextId = 0;
/**
 * This directive should be used to wrap accordion panel titles that need to contain HTML markup or other directives.
 */
var NgbPanelTitle = /** @class */ (function () {
    function NgbPanelTitle(templateRef) {
        this.templateRef = templateRef;
    }
    NgbPanelTitle.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: 'ng-template[ngbPanelTitle]' },] },
    ];
    /** @nocollapse */
    NgbPanelTitle.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"], },
    ]; };
    return NgbPanelTitle;
}());

/**
 * This directive must be used to wrap accordion panel content.
 */
var NgbPanelContent = /** @class */ (function () {
    function NgbPanelContent(templateRef) {
        this.templateRef = templateRef;
    }
    NgbPanelContent.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: 'ng-template[ngbPanelContent]' },] },
    ];
    /** @nocollapse */
    NgbPanelContent.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"], },
    ]; };
    return NgbPanelContent;
}());

/**
 * The NgbPanel directive represents an individual panel with the title and collapsible
 * content
 */
var NgbPanel = /** @class */ (function () {
    function NgbPanel() {
        /**
           *  A flag determining whether the panel is disabled or not.
           *  When disabled, the panel cannot be toggled.
           */
        this.disabled = false;
        /**
           *  An optional id for the panel. The id should be unique.
           *  If not provided, it will be auto-generated.
           */
        this.id = "ngb-panel-" + nextId++;
        /**
           * A flag telling if the panel is currently open
           */
        this.isOpen = false;
    }
    NgbPanel.prototype.ngAfterContentChecked = function () {
        // We are using @ContentChildren instead of @ContantChild as in the Angular version being used
        // only @ContentChildren allows us to specify the {descendants: false} option.
        // Without {descendants: false} we are hitting bugs described in:
        // https://github.com/ng-bootstrap/ng-bootstrap/issues/2240
        this.titleTpl = this.titleTpls.first;
        this.contentTpl = this.contentTpls.first;
    };
    NgbPanel.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: 'ngb-panel' },] },
    ];
    /** @nocollapse */
    NgbPanel.propDecorators = {
        "disabled": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "id": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "title": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "type": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "titleTpls": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChildren"], args: [NgbPanelTitle, { descendants: false },] },],
        "contentTpls": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChildren"], args: [NgbPanelContent, { descendants: false },] },],
    };
    return NgbPanel;
}());

/**
 * The NgbAccordion directive is a collection of panels.
 * It can assure that only one panel can be opened at a time.
 */
var NgbAccordion = /** @class */ (function () {
    function NgbAccordion(config) {
        /**
           * An array or comma separated strings of panel identifiers that should be opened
           */
        this.activeIds = [];
        /**
           * Whether the closed panels should be hidden without destroying them
           */
        this.destroyOnHide = true;
        /**
           * A panel change event fired right before the panel toggle happens. See NgbPanelChangeEvent for payload details
           */
        this.panelChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.type = config.type;
        this.closeOtherPanels = config.closeOthers;
    }
    /**
     * Programmatically toggle a panel with a given id.
     */
    /**
       * Programmatically toggle a panel with a given id.
       */
    NgbAccordion.prototype.toggle = /**
       * Programmatically toggle a panel with a given id.
       */
    function (panelId) {
        var panel = this.panels.find(function (p) { return p.id === panelId; });
        if (panel && !panel.disabled) {
            var defaultPrevented_1 = false;
            this.panelChange.emit({ panelId: panelId, nextState: !panel.isOpen, preventDefault: function () { defaultPrevented_1 = true; } });
            if (!defaultPrevented_1) {
                panel.isOpen = !panel.isOpen;
                if (this.closeOtherPanels) {
                    this._closeOthers(panelId);
                }
                this._updateActiveIds();
            }
        }
    };
    NgbAccordion.prototype.ngAfterContentChecked = function () {
        var _this = this;
        // active id updates
        if (Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["e" /* isString */])(this.activeIds)) {
            this.activeIds = this.activeIds.split(/\s*,\s*/);
        }
        // update panels open states
        this.panels.forEach(function (panel) { return panel.isOpen = !panel.disabled && _this.activeIds.indexOf(panel.id) > -1; });
        // closeOthers updates
        if (this.activeIds.length > 1 && this.closeOtherPanels) {
            this._closeOthers(this.activeIds[0]);
            this._updateActiveIds();
        }
    };
    NgbAccordion.prototype._closeOthers = function (panelId) {
        this.panels.forEach(function (panel) {
            if (panel.id !== panelId) {
                panel.isOpen = false;
            }
        });
    };
    NgbAccordion.prototype._updateActiveIds = function () {
        this.activeIds = this.panels.filter(function (panel) { return panel.isOpen && !panel.disabled; }).map(function (panel) { return panel.id; });
    };
    NgbAccordion.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'ngb-accordion',
                    exportAs: 'ngbAccordion',
                    host: { 'class': 'accordion', 'role': 'tablist', '[attr.aria-multiselectable]': '!closeOtherPanels' },
                    template: "\n    <ng-template ngFor let-panel [ngForOf]=\"panels\">\n      <div class=\"card\">\n        <div role=\"tab\" id=\"{{panel.id}}-header\" [class]=\"'card-header ' + (panel.type ? 'bg-'+panel.type: type ? 'bg-'+type : '')\">\n          <a href (click)=\"!!toggle(panel.id)\" [class.text-muted]=\"panel.disabled\" [attr.tabindex]=\"(panel.disabled ? '-1' : null)\"\n            [attr.aria-expanded]=\"panel.isOpen\" [attr.aria-controls]=\"(panel.isOpen ? panel.id : null)\"\n            [attr.aria-disabled]=\"panel.disabled\">\n            {{panel.title}}<ng-template [ngTemplateOutlet]=\"panel.titleTpl?.templateRef\"></ng-template>\n          </a>\n        </div>\n        <div id=\"{{panel.id}}\" role=\"tabpanel\" [attr.aria-labelledby]=\"panel.id + '-header'\"\n             class=\"card-body collapse {{panel.isOpen ? 'show' : null}}\" *ngIf=\"!destroyOnHide || panel.isOpen\">\n             <ng-template [ngTemplateOutlet]=\"panel.contentTpl?.templateRef\"></ng-template>\n        </div>\n      </div>\n    </ng-template>\n  "
                },] },
    ];
    /** @nocollapse */
    NgbAccordion.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_2__accordion_config__["a" /* NgbAccordionConfig */], },
    ]; };
    NgbAccordion.propDecorators = {
        "panels": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChildren"], args: [NgbPanel,] },],
        "activeIds": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "closeOtherPanels": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['closeOthers',] },],
        "destroyOnHide": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "type": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "panelChange": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    };
    return NgbAccordion;
}());

//# sourceMappingURL=accordion.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/accordion/accordion.module.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return NgbAccordionModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_common__ = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__accordion__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/accordion/accordion.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__accordion_config__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/accordion/accordion-config.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__accordion__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__accordion__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_2__accordion__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__accordion__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__accordion_config__["a"]; });






var NGB_ACCORDION_DIRECTIVES = [__WEBPACK_IMPORTED_MODULE_2__accordion__["a" /* NgbAccordion */], __WEBPACK_IMPORTED_MODULE_2__accordion__["b" /* NgbPanel */], __WEBPACK_IMPORTED_MODULE_2__accordion__["d" /* NgbPanelTitle */], __WEBPACK_IMPORTED_MODULE_2__accordion__["c" /* NgbPanelContent */]];
var NgbAccordionModule = /** @class */ (function () {
    function NgbAccordionModule() {
    }
    NgbAccordionModule.forRoot = function () { return { ngModule: NgbAccordionModule, providers: [__WEBPACK_IMPORTED_MODULE_3__accordion_config__["a" /* NgbAccordionConfig */]] }; };
    NgbAccordionModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{ declarations: NGB_ACCORDION_DIRECTIVES, exports: NGB_ACCORDION_DIRECTIVES, imports: [__WEBPACK_IMPORTED_MODULE_1__angular_common__["CommonModule"]] },] },
    ];
    return NgbAccordionModule;
}());

//# sourceMappingURL=accordion.module.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/alert/alert-config.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NgbAlertConfig; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");

/**
 * Configuration service for the NgbAlert component.
 * You can inject this service, typically in your root component, and customize the values of its properties in
 * order to provide default values for all the alerts used in the application.
 */
var NgbAlertConfig = /** @class */ (function () {
    function NgbAlertConfig() {
        this.dismissible = true;
        this.type = 'warning';
    }
    NgbAlertConfig.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    return NgbAlertConfig;
}());

//# sourceMappingURL=alert-config.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/alert/alert.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NgbAlert; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__alert_config__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/alert/alert-config.js");


/**
 * Alerts can be used to provide feedback messages.
 */
var NgbAlert = /** @class */ (function () {
    function NgbAlert(config) {
        /**
           * An event emitted when the close button is clicked. This event has no payload. Only relevant for dismissible alerts.
           */
        this.close = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.dismissible = config.dismissible;
        this.type = config.type;
    }
    NgbAlert.prototype.closeHandler = function () { this.close.emit(null); };
    NgbAlert.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'ngb-alert',
                    changeDetection: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectionStrategy"].OnPush,
                    template: "\n    <div [class]=\"'alert alert-' + type + (dismissible ? ' alert-dismissible' : '')\" role=\"alert\">\n      <button *ngIf=\"dismissible\" type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"closeHandler()\">\n            <span aria-hidden=\"true\">&times;</span>\n      </button>\n      <ng-content></ng-content>\n    </div>\n    "
                },] },
    ];
    /** @nocollapse */
    NgbAlert.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__alert_config__["a" /* NgbAlertConfig */], },
    ]; };
    NgbAlert.propDecorators = {
        "dismissible": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "type": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "close": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    };
    return NgbAlert;
}());

//# sourceMappingURL=alert.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/alert/alert.module.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return NgbAlertModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_common__ = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__alert__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/alert/alert.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__alert_config__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/alert/alert-config.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__alert__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__alert_config__["a"]; });






var NgbAlertModule = /** @class */ (function () {
    function NgbAlertModule() {
    }
    NgbAlertModule.forRoot = function () { return { ngModule: NgbAlertModule, providers: [__WEBPACK_IMPORTED_MODULE_3__alert_config__["a" /* NgbAlertConfig */]] }; };
    NgbAlertModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{ declarations: [__WEBPACK_IMPORTED_MODULE_2__alert__["a" /* NgbAlert */]], exports: [__WEBPACK_IMPORTED_MODULE_2__alert__["a" /* NgbAlert */]], imports: [__WEBPACK_IMPORTED_MODULE_1__angular_common__["CommonModule"]], entryComponents: [__WEBPACK_IMPORTED_MODULE_2__alert__["a" /* NgbAlert */]] },] },
    ];
    return NgbAlertModule;
}());

//# sourceMappingURL=alert.module.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/buttons/buttons.module.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NgbButtonsModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__label__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/buttons/label.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__checkbox__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/buttons/checkbox.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__radio__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/buttons/radio.js");
/* unused harmony reexport NgbButtonLabel */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__checkbox__["a"]; });
/* unused harmony reexport NgbRadio */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__radio__["b"]; });







var NGB_BUTTON_DIRECTIVES = [__WEBPACK_IMPORTED_MODULE_1__label__["a" /* NgbButtonLabel */], __WEBPACK_IMPORTED_MODULE_2__checkbox__["a" /* NgbCheckBox */], __WEBPACK_IMPORTED_MODULE_3__radio__["b" /* NgbRadioGroup */], __WEBPACK_IMPORTED_MODULE_3__radio__["a" /* NgbRadio */]];
var NgbButtonsModule = /** @class */ (function () {
    function NgbButtonsModule() {
    }
    NgbButtonsModule.forRoot = function () { return { ngModule: NgbButtonsModule, providers: [] }; };
    NgbButtonsModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{ declarations: NGB_BUTTON_DIRECTIVES, exports: NGB_BUTTON_DIRECTIVES },] },
    ];
    return NgbButtonsModule;
}());

//# sourceMappingURL=buttons.module.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/buttons/checkbox.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NgbCheckBox; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__("./node_modules/@angular/forms/esm5/forms.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__label__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/buttons/label.js");



var NGB_CHECKBOX_VALUE_ACCESSOR = {
    provide: __WEBPACK_IMPORTED_MODULE_1__angular_forms__["NG_VALUE_ACCESSOR"],
    useExisting: Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return NgbCheckBox; }),
    multi: true
};
/**
 * Easily create Bootstrap-style checkbox buttons. A value of a checked button is bound to a variable
 * specified via ngModel.
 */
var NgbCheckBox = /** @class */ (function () {
    function NgbCheckBox(_label) {
        this._label = _label;
        /**
           * A flag indicating if a given checkbox button is disabled.
           */
        this.disabled = false;
        /**
           * Value to be propagated as model when the checkbox is checked.
           */
        this.valueChecked = true;
        /**
           * Value to be propagated as model when the checkbox is unchecked.
           */
        this.valueUnChecked = false;
        this.onChange = function (_) { };
        this.onTouched = function () { };
    }
    Object.defineProperty(NgbCheckBox.prototype, "focused", {
        set: function (isFocused) {
            this._label.focused = isFocused;
            if (!isFocused) {
                this.onTouched();
            }
        },
        enumerable: true,
        configurable: true
    });
    NgbCheckBox.prototype.onInputChange = function ($event) {
        var modelToPropagate = $event.target.checked ? this.valueChecked : this.valueUnChecked;
        this.onChange(modelToPropagate);
        this.onTouched();
        this.writeValue(modelToPropagate);
    };
    NgbCheckBox.prototype.registerOnChange = function (fn) { this.onChange = fn; };
    NgbCheckBox.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    NgbCheckBox.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
        this._label.disabled = isDisabled;
    };
    NgbCheckBox.prototype.writeValue = function (value) {
        this.checked = value === this.valueChecked;
        this._label.active = this.checked;
    };
    NgbCheckBox.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: '[ngbButton][type=checkbox]',
                    host: {
                        'autocomplete': 'off',
                        '[checked]': 'checked',
                        '[disabled]': 'disabled',
                        '(change)': 'onInputChange($event)',
                        '(focus)': 'focused = true',
                        '(blur)': 'focused = false'
                    },
                    providers: [NGB_CHECKBOX_VALUE_ACCESSOR]
                },] },
    ];
    /** @nocollapse */
    NgbCheckBox.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_2__label__["a" /* NgbButtonLabel */], },
    ]; };
    NgbCheckBox.propDecorators = {
        "disabled": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "valueChecked": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "valueUnChecked": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return NgbCheckBox;
}());

//# sourceMappingURL=checkbox.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/buttons/label.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NgbButtonLabel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");

var NgbButtonLabel = /** @class */ (function () {
    function NgbButtonLabel() {
    }
    NgbButtonLabel.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: '[ngbButtonLabel]',
                    host: { '[class.btn]': 'true', '[class.active]': 'active', '[class.disabled]': 'disabled', '[class.focus]': 'focused' }
                },] },
    ];
    return NgbButtonLabel;
}());

//# sourceMappingURL=label.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/buttons/radio.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NgbRadioGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NgbRadio; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__("./node_modules/@angular/forms/esm5/forms.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__label__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/buttons/label.js");



var NGB_RADIO_VALUE_ACCESSOR = {
    provide: __WEBPACK_IMPORTED_MODULE_1__angular_forms__["NG_VALUE_ACCESSOR"],
    useExisting: Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return NgbRadioGroup; }),
    multi: true
};
var nextId = 0;
/**
 * Easily create Bootstrap-style radio buttons. A value of a selected button is bound to a variable
 * specified via ngModel.
 */
var NgbRadioGroup = /** @class */ (function () {
    function NgbRadioGroup() {
        this._radios = new Set();
        this._value = null;
        /**
           * The name of the group. Unless enclosed inputs specify a name, this name is used as the name of the
           * enclosed inputs. If not specified, a name is generated automatically.
           */
        this.name = "ngb-radio-" + nextId++;
        this.onChange = function (_) { };
        this.onTouched = function () { };
    }
    Object.defineProperty(NgbRadioGroup.prototype, "disabled", {
        get: function () { return this._disabled; },
        set: function (isDisabled) { this.setDisabledState(isDisabled); },
        enumerable: true,
        configurable: true
    });
    NgbRadioGroup.prototype.onRadioChange = function (radio) {
        this.writeValue(radio.value);
        this.onChange(radio.value);
    };
    NgbRadioGroup.prototype.onRadioValueUpdate = function () { this._updateRadiosValue(); };
    NgbRadioGroup.prototype.register = function (radio) { this._radios.add(radio); };
    NgbRadioGroup.prototype.registerOnChange = function (fn) { this.onChange = fn; };
    NgbRadioGroup.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    NgbRadioGroup.prototype.setDisabledState = function (isDisabled) {
        this._disabled = isDisabled;
        this._updateRadiosDisabled();
    };
    NgbRadioGroup.prototype.unregister = function (radio) { this._radios.delete(radio); };
    NgbRadioGroup.prototype.writeValue = function (value) {
        this._value = value;
        this._updateRadiosValue();
    };
    NgbRadioGroup.prototype._updateRadiosValue = function () {
        var _this = this;
        this._radios.forEach(function (radio) { return radio.updateValue(_this._value); });
    };
    NgbRadioGroup.prototype._updateRadiosDisabled = function () { this._radios.forEach(function (radio) { return radio.updateDisabled(); }); };
    NgbRadioGroup.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[ngbRadioGroup]', host: { 'role': 'group' }, providers: [NGB_RADIO_VALUE_ACCESSOR] },] },
    ];
    /** @nocollapse */
    NgbRadioGroup.propDecorators = {
        "name": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return NgbRadioGroup;
}());

/**
 * Marks an input of type "radio" as part of the NgbRadioGroup.
 */
var NgbRadio = /** @class */ (function () {
    function NgbRadio(_group, _label, _renderer, _element) {
        this._group = _group;
        this._label = _label;
        this._renderer = _renderer;
        this._element = _element;
        this._value = null;
        this._group.register(this);
    }
    Object.defineProperty(NgbRadio.prototype, "value", {
        get: function () { return this._value; },
        set: /**
           * You can specify model value of a given radio by binding to the value property.
           */
        function (value) {
            this._value = value;
            var stringValue = value ? value.toString() : '';
            this._renderer.setProperty(this._element.nativeElement, 'value', stringValue);
            this._group.onRadioValueUpdate();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgbRadio.prototype, "disabled", {
        get: function () { return this._group.disabled || this._disabled; },
        set: /**
           * A flag indicating if a given radio button is disabled.
           */
        function (isDisabled) {
            this._disabled = isDisabled !== false;
            this.updateDisabled();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgbRadio.prototype, "focused", {
        set: function (isFocused) {
            if (this._label) {
                this._label.focused = isFocused;
            }
            if (!isFocused) {
                this._group.onTouched();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgbRadio.prototype, "checked", {
        get: function () { return this._checked; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgbRadio.prototype, "nameAttr", {
        get: function () { return this.name || this._group.name; },
        enumerable: true,
        configurable: true
    });
    NgbRadio.prototype.ngOnDestroy = function () { this._group.unregister(this); };
    NgbRadio.prototype.onChange = function () { this._group.onRadioChange(this); };
    NgbRadio.prototype.updateValue = function (value) {
        this._checked = this.value === value;
        this._label.active = this._checked;
    };
    NgbRadio.prototype.updateDisabled = function () { this._label.disabled = this.disabled; };
    NgbRadio.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: '[ngbButton][type=radio]',
                    host: {
                        '[checked]': 'checked',
                        '[disabled]': 'disabled',
                        '[name]': 'nameAttr',
                        '(change)': 'onChange()',
                        '(focus)': 'focused = true',
                        '(blur)': 'focused = false'
                    }
                },] },
    ];
    /** @nocollapse */
    NgbRadio.ctorParameters = function () { return [
        { type: NgbRadioGroup, },
        { type: __WEBPACK_IMPORTED_MODULE_2__label__["a" /* NgbButtonLabel */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    ]; };
    NgbRadio.propDecorators = {
        "name": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "value": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['value',] },],
        "disabled": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['disabled',] },],
    };
    return NgbRadio;
}());

//# sourceMappingURL=radio.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/carousel/carousel-config.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NgbCarouselConfig; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");

/**
 * Configuration service for the NgbCarousel component.
 * You can inject this service, typically in your root component, and customize the values of its properties in
 * order to provide default values for all the carousels used in the application.
 */
var NgbCarouselConfig = /** @class */ (function () {
    function NgbCarouselConfig() {
        this.interval = 5000;
        this.wrap = true;
        this.keyboard = true;
    }
    NgbCarouselConfig.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    return NgbCarouselConfig;
}());

//# sourceMappingURL=carousel-config.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/carousel/carousel.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return NgbSlide; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NgbCarousel; });
/* unused harmony export NgbSlideEventDirection */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NGB_CAROUSEL_DIRECTIVES; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__carousel_config__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/carousel/carousel-config.js");


var nextId = 0;
/**
 * Represents an individual slide to be used within a carousel.
 */
var NgbSlide = /** @class */ (function () {
    function NgbSlide(tplRef) {
        this.tplRef = tplRef;
        /**
           * Unique slide identifier. Must be unique for the entire document for proper accessibility support.
           * Will be auto-generated if not provided.
           */
        this.id = "ngb-slide-" + nextId++;
    }
    NgbSlide.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: 'ng-template[ngbSlide]' },] },
    ];
    /** @nocollapse */
    NgbSlide.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"], },
    ]; };
    NgbSlide.propDecorators = {
        "id": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return NgbSlide;
}());

/**
 * Directive to easily create carousels based on Bootstrap's markup.
 */
var NgbCarousel = /** @class */ (function () {
    function NgbCarousel(config) {
        /**
           * A carousel slide event fired when the slide transition is completed.
           * See NgbSlideEvent for payload details
           */
        this.slide = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.interval = config.interval;
        this.wrap = config.wrap;
        this.keyboard = config.keyboard;
    }
    NgbCarousel.prototype.ngAfterContentChecked = function () {
        var activeSlide = this._getSlideById(this.activeId);
        this.activeId = activeSlide ? activeSlide.id : (this.slides.length ? this.slides.first.id : null);
    };
    NgbCarousel.prototype.ngOnInit = function () { this._startTimer(); };
    NgbCarousel.prototype.ngOnChanges = function (changes) {
        if ('interval' in changes && !changes['interval'].isFirstChange()) {
            this._restartTimer();
        }
    };
    NgbCarousel.prototype.ngOnDestroy = function () { clearInterval(this._slideChangeInterval); };
    /**
     * Navigate to a slide with the specified identifier.
     */
    /**
       * Navigate to a slide with the specified identifier.
       */
    NgbCarousel.prototype.select = /**
       * Navigate to a slide with the specified identifier.
       */
    function (slideId) {
        this.cycleToSelected(slideId, this.getSlideEventDirection(this.activeId, slideId));
        this._restartTimer();
    };
    /**
     * Navigate to the next slide.
     */
    /**
       * Navigate to the next slide.
       */
    NgbCarousel.prototype.prev = /**
       * Navigate to the next slide.
       */
    function () {
        this.cycleToPrev();
        this._restartTimer();
    };
    /**
     * Navigate to the next slide.
     */
    /**
       * Navigate to the next slide.
       */
    NgbCarousel.prototype.next = /**
       * Navigate to the next slide.
       */
    function () {
        this.cycleToNext();
        this._restartTimer();
    };
    /**
     * Stops the carousel from cycling through items.
     */
    /**
       * Stops the carousel from cycling through items.
       */
    NgbCarousel.prototype.pause = /**
       * Stops the carousel from cycling through items.
       */
    function () { this._stopTimer(); };
    /**
     * Restarts cycling through the carousel slides from left to right.
     */
    /**
       * Restarts cycling through the carousel slides from left to right.
       */
    NgbCarousel.prototype.cycle = /**
       * Restarts cycling through the carousel slides from left to right.
       */
    function () { this._startTimer(); };
    NgbCarousel.prototype.cycleToNext = function () { this.cycleToSelected(this._getNextSlide(this.activeId), NgbSlideEventDirection.LEFT); };
    NgbCarousel.prototype.cycleToPrev = function () { this.cycleToSelected(this._getPrevSlide(this.activeId), NgbSlideEventDirection.RIGHT); };
    NgbCarousel.prototype.cycleToSelected = function (slideIdx, direction) {
        var selectedSlide = this._getSlideById(slideIdx);
        if (selectedSlide) {
            if (selectedSlide.id !== this.activeId) {
                this.slide.emit({ prev: this.activeId, current: selectedSlide.id, direction: direction });
            }
            this.activeId = selectedSlide.id;
        }
    };
    NgbCarousel.prototype.getSlideEventDirection = function (currentActiveSlideId, nextActiveSlideId) {
        var currentActiveSlideIdx = this._getSlideIdxById(currentActiveSlideId);
        var nextActiveSlideIdx = this._getSlideIdxById(nextActiveSlideId);
        return currentActiveSlideIdx > nextActiveSlideIdx ? NgbSlideEventDirection.RIGHT : NgbSlideEventDirection.LEFT;
    };
    NgbCarousel.prototype.keyPrev = function () {
        if (this.keyboard) {
            this.prev();
        }
    };
    NgbCarousel.prototype.keyNext = function () {
        if (this.keyboard) {
            this.next();
        }
    };
    NgbCarousel.prototype._restartTimer = function () {
        this._stopTimer();
        this._startTimer();
    };
    NgbCarousel.prototype._startTimer = function () {
        var _this = this;
        if (this.interval > 0) {
            this._slideChangeInterval = setInterval(function () { _this.cycleToNext(); }, this.interval);
        }
    };
    NgbCarousel.prototype._stopTimer = function () { clearInterval(this._slideChangeInterval); };
    NgbCarousel.prototype._getSlideById = function (slideId) {
        var slideWithId = this.slides.filter(function (slide) { return slide.id === slideId; });
        return slideWithId.length ? slideWithId[0] : null;
    };
    NgbCarousel.prototype._getSlideIdxById = function (slideId) {
        return this.slides.toArray().indexOf(this._getSlideById(slideId));
    };
    NgbCarousel.prototype._getNextSlide = function (currentSlideId) {
        var slideArr = this.slides.toArray();
        var currentSlideIdx = this._getSlideIdxById(currentSlideId);
        var isLastSlide = currentSlideIdx === slideArr.length - 1;
        return isLastSlide ? (this.wrap ? slideArr[0].id : slideArr[slideArr.length - 1].id) :
            slideArr[currentSlideIdx + 1].id;
    };
    NgbCarousel.prototype._getPrevSlide = function (currentSlideId) {
        var slideArr = this.slides.toArray();
        var currentSlideIdx = this._getSlideIdxById(currentSlideId);
        var isFirstSlide = currentSlideIdx === 0;
        return isFirstSlide ? (this.wrap ? slideArr[slideArr.length - 1].id : slideArr[0].id) :
            slideArr[currentSlideIdx - 1].id;
    };
    NgbCarousel.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'ngb-carousel',
                    exportAs: 'ngbCarousel',
                    host: {
                        'class': 'carousel slide',
                        '[style.display]': '"block"',
                        'tabIndex': '0',
                        '(mouseenter)': 'pause()',
                        '(mouseleave)': 'cycle()',
                        '(keydown.arrowLeft)': 'keyPrev()',
                        '(keydown.arrowRight)': 'keyNext()'
                    },
                    template: "\n    <ol class=\"carousel-indicators\">\n      <li *ngFor=\"let slide of slides\" [id]=\"slide.id\" [class.active]=\"slide.id === activeId\"\n          (click)=\"cycleToSelected(slide.id, getSlideEventDirection(activeId, slide.id))\"></li>\n    </ol>\n    <div class=\"carousel-inner\">\n      <div *ngFor=\"let slide of slides\" class=\"carousel-item\" [class.active]=\"slide.id === activeId\">\n        <ng-template [ngTemplateOutlet]=\"slide.tplRef\"></ng-template>\n      </div>\n    </div>\n    <a class=\"carousel-control-prev\" role=\"button\" (click)=\"cycleToPrev()\">\n      <span class=\"carousel-control-prev-icon\" aria-hidden=\"true\"></span>\n      <span class=\"sr-only\">Previous</span>\n    </a>\n    <a class=\"carousel-control-next\" role=\"button\" (click)=\"cycleToNext()\">\n      <span class=\"carousel-control-next-icon\" aria-hidden=\"true\"></span>\n      <span class=\"sr-only\">Next</span>\n    </a>\n    "
                },] },
    ];
    /** @nocollapse */
    NgbCarousel.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__carousel_config__["a" /* NgbCarouselConfig */], },
    ]; };
    NgbCarousel.propDecorators = {
        "slides": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChildren"], args: [NgbSlide,] },],
        "interval": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "wrap": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "keyboard": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "activeId": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "slide": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    };
    return NgbCarousel;
}());

/**
 * Enum to define the carousel slide event direction
 */
/**
 * Enum to define the carousel slide event direction
 */
var NgbSlideEventDirection;
/**
 * Enum to define the carousel slide event direction
 */
(function (NgbSlideEventDirection) {
    NgbSlideEventDirection[NgbSlideEventDirection["LEFT"] = 'left'] = "LEFT";
    NgbSlideEventDirection[NgbSlideEventDirection["RIGHT"] = 'right'] = "RIGHT";
})(NgbSlideEventDirection || (NgbSlideEventDirection = {}));
var NGB_CAROUSEL_DIRECTIVES = [NgbCarousel, NgbSlide];
//# sourceMappingURL=carousel.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/carousel/carousel.module.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return NgbCarouselModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_common__ = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__carousel__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/carousel/carousel.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__carousel_config__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/carousel/carousel-config.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__carousel__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__carousel__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__carousel_config__["a"]; });






var NgbCarouselModule = /** @class */ (function () {
    function NgbCarouselModule() {
    }
    NgbCarouselModule.forRoot = function () { return { ngModule: NgbCarouselModule, providers: [__WEBPACK_IMPORTED_MODULE_3__carousel_config__["a" /* NgbCarouselConfig */]] }; };
    NgbCarouselModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{ declarations: __WEBPACK_IMPORTED_MODULE_2__carousel__["a" /* NGB_CAROUSEL_DIRECTIVES */], exports: __WEBPACK_IMPORTED_MODULE_2__carousel__["a" /* NGB_CAROUSEL_DIRECTIVES */], imports: [__WEBPACK_IMPORTED_MODULE_1__angular_common__["CommonModule"]] },] },
    ];
    return NgbCarouselModule;
}());

//# sourceMappingURL=carousel.module.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/collapse/collapse.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NgbCollapse; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");

/**
 * The NgbCollapse directive provides a simple way to hide and show an element with animations.
 */
var NgbCollapse = /** @class */ (function () {
    function NgbCollapse() {
        /**
           * A flag indicating collapsed (true) or open (false) state.
           */
        this.collapsed = false;
    }
    NgbCollapse.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: '[ngbCollapse]',
                    exportAs: 'ngbCollapse',
                    host: { '[class.collapse]': 'true', '[class.show]': '!collapsed' }
                },] },
    ];
    /** @nocollapse */
    NgbCollapse.propDecorators = {
        "collapsed": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngbCollapse',] },],
    };
    return NgbCollapse;
}());

//# sourceMappingURL=collapse.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/collapse/collapse.module.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NgbCollapseModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__collapse__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/collapse/collapse.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__collapse__["a"]; });



var NgbCollapseModule = /** @class */ (function () {
    function NgbCollapseModule() {
    }
    NgbCollapseModule.forRoot = function () { return { ngModule: NgbCollapseModule, providers: [] }; };
    NgbCollapseModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{ declarations: [__WEBPACK_IMPORTED_MODULE_1__collapse__["a" /* NgbCollapse */]], exports: [__WEBPACK_IMPORTED_MODULE_1__collapse__["a" /* NgbCollapse */]] },] },
    ];
    return NgbCollapseModule;
}());

//# sourceMappingURL=collapse.module.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/datepicker-config.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NgbDatepickerConfig; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");

/**
 * Configuration service for the NgbDatepicker component.
 * You can inject this service, typically in your root component, and customize the values of its properties in
 * order to provide default values for all the datepickers used in the application.
 */
var NgbDatepickerConfig = /** @class */ (function () {
    function NgbDatepickerConfig() {
        this.displayMonths = 1;
        this.firstDayOfWeek = 1;
        this.navigation = 'select';
        this.outsideDays = 'visible';
        this.showWeekdays = true;
        this.showWeekNumbers = false;
    }
    NgbDatepickerConfig.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    return NgbDatepickerConfig;
}());

//# sourceMappingURL=datepicker-config.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/datepicker-day-view.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NgbDatepickerDayView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");

var NgbDatepickerDayView = /** @class */ (function () {
    function NgbDatepickerDayView() {
    }
    NgbDatepickerDayView.prototype.isMuted = function () { return !this.selected && (this.date.month !== this.currentMonth || this.disabled); };
    NgbDatepickerDayView.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: '[ngbDatepickerDayView]',
                    changeDetection: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectionStrategy"].OnPush,
                    styles: ["\n    :host {\n      text-align: center;\n      width: 2rem;\n      height: 2rem;\n      line-height: 2rem;\n      border-radius: 0.25rem;\n      background: transparent;\n    }\n    :host.outside {\n      opacity: 0.5;\n    }\n  "],
                    host: {
                        'class': 'btn-light',
                        '[class.bg-primary]': 'selected',
                        '[class.text-white]': 'selected',
                        '[class.text-muted]': 'isMuted()',
                        '[class.outside]': 'isMuted()',
                        '[class.active]': 'focused'
                    },
                    template: "{{ date.day }}"
                },] },
    ];
    /** @nocollapse */
    NgbDatepickerDayView.propDecorators = {
        "currentMonth": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "date": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "disabled": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "focused": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "selected": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return NgbDatepickerDayView;
}());

//# sourceMappingURL=datepicker-day-view.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/datepicker-i18n.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NgbDatepickerI18n; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NgbDatepickerI18nDefault; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_common__ = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



/**
 * Type of the service supplying month and weekday names to to NgbDatepicker component.
 * The default implementation of this service honors the Angular locale, and uses the registered locale data,
 * as explained in the Angular i18n guide.
 * See the i18n demo for how to extend this class and define a custom provider for i18n.
 */
var NgbDatepickerI18n = /** @class */ (function () {
    function NgbDatepickerI18n() {
    }
    NgbDatepickerI18n.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    return NgbDatepickerI18n;
}());

var NgbDatepickerI18nDefault = /** @class */ (function (_super) {
    __extends(NgbDatepickerI18nDefault, _super);
    function NgbDatepickerI18nDefault(_locale, _datePipe) {
        var _this = _super.call(this) || this;
        _this._locale = _locale;
        _this._datePipe = _datePipe;
        var weekdaysStartingOnSunday = Object(__WEBPACK_IMPORTED_MODULE_1__angular_common__["getLocaleDayNames"])(_locale, __WEBPACK_IMPORTED_MODULE_1__angular_common__["FormStyle"].Standalone, __WEBPACK_IMPORTED_MODULE_1__angular_common__["TranslationWidth"].Short);
        _this._weekdaysShort = weekdaysStartingOnSunday.map(function (day, index) { return weekdaysStartingOnSunday[(index + 1) % 7]; });
        _this._monthsShort = Object(__WEBPACK_IMPORTED_MODULE_1__angular_common__["getLocaleMonthNames"])(_locale, __WEBPACK_IMPORTED_MODULE_1__angular_common__["FormStyle"].Standalone, __WEBPACK_IMPORTED_MODULE_1__angular_common__["TranslationWidth"].Abbreviated);
        _this._monthsFull = Object(__WEBPACK_IMPORTED_MODULE_1__angular_common__["getLocaleMonthNames"])(_locale, __WEBPACK_IMPORTED_MODULE_1__angular_common__["FormStyle"].Standalone, __WEBPACK_IMPORTED_MODULE_1__angular_common__["TranslationWidth"].Wide);
        return _this;
    }
    NgbDatepickerI18nDefault.prototype.getWeekdayShortName = function (weekday) { return this._weekdaysShort[weekday - 1]; };
    NgbDatepickerI18nDefault.prototype.getMonthShortName = function (month) { return this._monthsShort[month - 1]; };
    NgbDatepickerI18nDefault.prototype.getMonthFullName = function (month) { return this._monthsFull[month - 1]; };
    NgbDatepickerI18nDefault.prototype.getDayAriaLabel = function (date) {
        var jsDate = new Date(date.year, date.month - 1, date.day);
        return this._datePipe.transform(jsDate, 'fullDate', null, this._locale);
    };
    NgbDatepickerI18nDefault.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    NgbDatepickerI18nDefault.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_0__angular_core__["LOCALE_ID"],] },] },
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_common__["DatePipe"], },
    ]; };
    return NgbDatepickerI18nDefault;
}(NgbDatepickerI18n));

//# sourceMappingURL=datepicker-i18n.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/datepicker-input.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NgbInputDatepicker; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__("./node_modules/@angular/forms/esm5/forms.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ngb_date__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/ngb-date.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__datepicker__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/datepicker.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ngb_date_parser_formatter__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/ngb-date-parser-formatter.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_positioning__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/util/positioning.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_focus_trap__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/util/focus-trap.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ngb_date_adapter__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/ngb-date-adapter.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ngb_calendar__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/ngb-calendar.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__datepicker_service__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/datepicker-service.js");










var NGB_DATEPICKER_VALUE_ACCESSOR = {
    provide: __WEBPACK_IMPORTED_MODULE_1__angular_forms__["NG_VALUE_ACCESSOR"],
    useExisting: Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return NgbInputDatepicker; }),
    multi: true
};
var NGB_DATEPICKER_VALIDATOR = {
    provide: __WEBPACK_IMPORTED_MODULE_1__angular_forms__["NG_VALIDATORS"],
    useExisting: Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return NgbInputDatepicker; }),
    multi: true
};
/**
 * A directive that makes it possible to have datepickers on input fields.
 * Manages integration with the input field itself (data entry) and ngModel (validation etc.).
 */
var NgbInputDatepicker = /** @class */ (function () {
    function NgbInputDatepicker(_parserFormatter, _elRef, _vcRef, _renderer, _cfr, ngZone, _service, _calendar, _ngbDateAdapter, _focusTrapFactory) {
        var _this = this;
        this._parserFormatter = _parserFormatter;
        this._elRef = _elRef;
        this._vcRef = _vcRef;
        this._renderer = _renderer;
        this._cfr = _cfr;
        this._service = _service;
        this._calendar = _calendar;
        this._ngbDateAdapter = _ngbDateAdapter;
        this._focusTrapFactory = _focusTrapFactory;
        this._cRef = null;
        this._disabled = false;
        this._focusTrap = null;
        /**
           * Indicates whether the datepicker popup should be closed automatically after date selection or not.
           * If the value is 'false', the popup can be closed via 'close()' or 'toggle()' methods.
           *
           * @since 1.1.0
           */
        this.autoClose = true;
        /**
              * Placement of a datepicker popup accepts:
              *    "top", "top-left", "top-right", "bottom", "bottom-left", "bottom-right",
              *    "left", "left-top", "left-bottom", "right", "right-top", "right-bottom"
              * and array of above values.
              */
        this.placement = 'bottom-left';
        /**
           * An event fired when user selects a date using keyboard or mouse.
           * The payload of the event is currently selected NgbDateStruct.
           *
           * @since 1.1.1
           */
        this.dateSelect = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
           * An event fired when navigation happens and currently displayed month changes.
           * See NgbDatepickerNavigateEvent for the payload info.
           */
        this.navigate = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this._onChange = function (_) { };
        this._onTouched = function () { };
        this._validatorChange = function () { };
        this._zoneSubscription = ngZone.onStable.subscribe(function () {
            if (_this._cRef) {
                Object(__WEBPACK_IMPORTED_MODULE_5__util_positioning__["a" /* positionElements */])(_this._elRef.nativeElement, _this._cRef.location.nativeElement, _this.placement, _this.container === 'body');
            }
        });
    }
    Object.defineProperty(NgbInputDatepicker.prototype, "disabled", {
        get: function () {
            return this._disabled;
        },
        set: function (value) {
            this._disabled = value === '' || (value && value !== 'false');
            if (this.isOpen()) {
                this._cRef.instance.setDisabledState(this._disabled);
            }
        },
        enumerable: true,
        configurable: true
    });
    NgbInputDatepicker.prototype.registerOnChange = function (fn) { this._onChange = fn; };
    NgbInputDatepicker.prototype.registerOnTouched = function (fn) { this._onTouched = fn; };
    NgbInputDatepicker.prototype.registerOnValidatorChange = function (fn) { this._validatorChange = fn; };
    ;
    NgbInputDatepicker.prototype.setDisabledState = function (isDisabled) { this.disabled = isDisabled; };
    NgbInputDatepicker.prototype.validate = function (c) {
        var value = c.value;
        if (value === null || value === undefined) {
            return null;
        }
        var ngbDate = this._fromDateStruct(this._ngbDateAdapter.fromModel(value));
        if (!this._calendar.isValid(ngbDate)) {
            return { 'ngbDate': { invalid: c.value } };
        }
        if (this.minDate && ngbDate.before(__WEBPACK_IMPORTED_MODULE_2__ngb_date__["a" /* NgbDate */].from(this.minDate))) {
            return { 'ngbDate': { requiredBefore: this.minDate } };
        }
        if (this.maxDate && ngbDate.after(__WEBPACK_IMPORTED_MODULE_2__ngb_date__["a" /* NgbDate */].from(this.maxDate))) {
            return { 'ngbDate': { requiredAfter: this.maxDate } };
        }
    };
    NgbInputDatepicker.prototype.writeValue = function (value) {
        this._model = this._fromDateStruct(this._ngbDateAdapter.fromModel(value));
        this._writeModelValue(this._model);
    };
    NgbInputDatepicker.prototype.manualDateChange = function (value, updateView) {
        if (updateView === void 0) { updateView = false; }
        this._model = this._fromDateStruct(this._parserFormatter.parse(value));
        this._onChange(this._model ? this._ngbDateAdapter.toModel(this._model) : (value === '' ? null : value));
        if (updateView && this._model) {
            this._writeModelValue(this._model);
        }
    };
    NgbInputDatepicker.prototype.isOpen = function () { return !!this._cRef; };
    /**
     * Opens the datepicker with the selected date indicated by the ngModel value.
     */
    /**
       * Opens the datepicker with the selected date indicated by the ngModel value.
       */
    NgbInputDatepicker.prototype.open = /**
       * Opens the datepicker with the selected date indicated by the ngModel value.
       */
    function () {
        var _this = this;
        if (!this.isOpen()) {
            var cf = this._cfr.resolveComponentFactory(__WEBPACK_IMPORTED_MODULE_3__datepicker__["a" /* NgbDatepicker */]);
            this._cRef = this._vcRef.createComponent(cf);
            this._applyPopupStyling(this._cRef.location.nativeElement);
            this._applyDatepickerInputs(this._cRef.instance);
            this._subscribeForDatepickerOutputs(this._cRef.instance);
            this._cRef.instance.ngOnInit();
            this._cRef.instance.writeValue(this._ngbDateAdapter.toModel(this._model));
            // date selection event handling
            this._cRef.instance.registerOnChange(function (selectedDate) {
                _this.writeValue(selectedDate);
                _this._onChange(selectedDate);
            });
            this._cRef.changeDetectorRef.detectChanges();
            this._cRef.instance.setDisabledState(this.disabled);
            if (this.container === 'body') {
                window.document.querySelector(this.container).appendChild(this._cRef.location.nativeElement);
            }
            this._focusTrap = this._focusTrapFactory.create(this._cRef.location.nativeElement, true);
            // focus handling
            this._cRef.instance.focus();
        }
    };
    /**
     * Closes the datepicker popup.
     */
    /**
       * Closes the datepicker popup.
       */
    NgbInputDatepicker.prototype.close = /**
       * Closes the datepicker popup.
       */
    function () {
        if (this.isOpen()) {
            this._vcRef.remove(this._vcRef.indexOf(this._cRef.hostView));
            this._cRef = null;
            this._focusTrap.destroy();
            this._focusTrap = null;
        }
    };
    /**
     * Toggles the datepicker popup (opens when closed and closes when opened).
     */
    /**
       * Toggles the datepicker popup (opens when closed and closes when opened).
       */
    NgbInputDatepicker.prototype.toggle = /**
       * Toggles the datepicker popup (opens when closed and closes when opened).
       */
    function () {
        if (this.isOpen()) {
            this.close();
        }
        else {
            this.open();
        }
    };
    /**
     * Navigates current view to provided date.
     * With default calendar we use ISO 8601: 'month' is 1=Jan ... 12=Dec.
     * If nothing or invalid date provided calendar will open current month.
     * Use 'startDate' input as an alternative
     */
    /**
       * Navigates current view to provided date.
       * With default calendar we use ISO 8601: 'month' is 1=Jan ... 12=Dec.
       * If nothing or invalid date provided calendar will open current month.
       * Use 'startDate' input as an alternative
       */
    NgbInputDatepicker.prototype.navigateTo = /**
       * Navigates current view to provided date.
       * With default calendar we use ISO 8601: 'month' is 1=Jan ... 12=Dec.
       * If nothing or invalid date provided calendar will open current month.
       * Use 'startDate' input as an alternative
       */
    function (date) {
        if (this.isOpen()) {
            this._cRef.instance.navigateTo(date);
        }
    };
    NgbInputDatepicker.prototype.onBlur = function () { this._onTouched(); };
    NgbInputDatepicker.prototype.ngOnChanges = function (changes) {
        if (changes['minDate'] || changes['maxDate']) {
            this._validatorChange();
        }
    };
    NgbInputDatepicker.prototype.ngOnDestroy = function () {
        this.close();
        this._zoneSubscription.unsubscribe();
    };
    NgbInputDatepicker.prototype._applyDatepickerInputs = function (datepickerInstance) {
        var _this = this;
        ['dayTemplate', 'displayMonths', 'firstDayOfWeek', 'markDisabled', 'minDate', 'maxDate', 'navigation',
            'outsideDays', 'showNavigation', 'showWeekdays', 'showWeekNumbers']
            .forEach(function (optionName) {
            if (_this[optionName] !== undefined) {
                datepickerInstance[optionName] = _this[optionName];
            }
        });
        datepickerInstance.startDate = this.startDate || this._model;
    };
    NgbInputDatepicker.prototype._applyPopupStyling = function (nativeElement) {
        this._renderer.addClass(nativeElement, 'dropdown-menu');
        this._renderer.setStyle(nativeElement, 'padding', '0');
        this._renderer.addClass(nativeElement, 'show');
    };
    NgbInputDatepicker.prototype._subscribeForDatepickerOutputs = function (datepickerInstance) {
        var _this = this;
        datepickerInstance.navigate.subscribe(function (date) { return _this.navigate.emit(date); });
        datepickerInstance.select.subscribe(function (date) {
            _this.dateSelect.emit(date);
            if (_this.autoClose) {
                _this.close();
            }
        });
    };
    NgbInputDatepicker.prototype._writeModelValue = function (model) {
        this._renderer.setProperty(this._elRef.nativeElement, 'value', this._parserFormatter.format(model));
        if (this.isOpen()) {
            this._cRef.instance.writeValue(this._ngbDateAdapter.toModel(model));
            this._onTouched();
        }
    };
    NgbInputDatepicker.prototype._fromDateStruct = function (date) {
        var ngbDate = date ? new __WEBPACK_IMPORTED_MODULE_2__ngb_date__["a" /* NgbDate */](date.year, date.month, date.day) : null;
        return this._calendar.isValid(ngbDate) ? ngbDate : null;
    };
    NgbInputDatepicker.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'input[ngbDatepicker]',
                    exportAs: 'ngbDatepicker',
                    host: {
                        '(input)': 'manualDateChange($event.target.value)',
                        '(change)': 'manualDateChange($event.target.value, true)',
                        '(keyup.esc)': 'close()',
                        '(blur)': 'onBlur()',
                        '[disabled]': 'disabled'
                    },
                    providers: [NGB_DATEPICKER_VALUE_ACCESSOR, NGB_DATEPICKER_VALIDATOR, __WEBPACK_IMPORTED_MODULE_9__datepicker_service__["a" /* NgbDatepickerService */]]
                },] },
    ];
    /** @nocollapse */
    NgbInputDatepicker.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_4__ngb_date_parser_formatter__["b" /* NgbDateParserFormatter */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ComponentFactoryResolver"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"], },
        { type: __WEBPACK_IMPORTED_MODULE_9__datepicker_service__["a" /* NgbDatepickerService */], },
        { type: __WEBPACK_IMPORTED_MODULE_8__ngb_calendar__["a" /* NgbCalendar */], },
        { type: __WEBPACK_IMPORTED_MODULE_7__ngb_date_adapter__["a" /* NgbDateAdapter */], },
        { type: __WEBPACK_IMPORTED_MODULE_6__util_focus_trap__["a" /* NgbFocusTrapFactory */], },
    ]; };
    NgbInputDatepicker.propDecorators = {
        "autoClose": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "dayTemplate": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "displayMonths": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "firstDayOfWeek": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "markDisabled": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "minDate": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "maxDate": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "navigation": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "outsideDays": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "placement": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "showWeekdays": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "showWeekNumbers": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "startDate": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "container": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "dateSelect": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "navigate": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "disabled": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return NgbInputDatepicker;
}());

//# sourceMappingURL=datepicker-input.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/datepicker-keymap-service.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NgbDatepickerKeyMapService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__datepicker_service__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/datepicker-service.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ngb_calendar__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/ngb-calendar.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_util__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/util/util.js");




var Key;
(function (Key) {
    Key[Key["Enter"] = 13] = "Enter";
    Key[Key["Space"] = 32] = "Space";
    Key[Key["PageUp"] = 33] = "PageUp";
    Key[Key["PageDown"] = 34] = "PageDown";
    Key[Key["End"] = 35] = "End";
    Key[Key["Home"] = 36] = "Home";
    Key[Key["ArrowLeft"] = 37] = "ArrowLeft";
    Key[Key["ArrowUp"] = 38] = "ArrowUp";
    Key[Key["ArrowRight"] = 39] = "ArrowRight";
    Key[Key["ArrowDown"] = 40] = "ArrowDown";
})(Key || (Key = {}));
var NgbDatepickerKeyMapService = /** @class */ (function () {
    function NgbDatepickerKeyMapService(_service, _calendar) {
        var _this = this;
        this._service = _service;
        this._calendar = _calendar;
        _service.model$.subscribe(function (model) {
            _this._minDate = model.minDate;
            _this._maxDate = model.maxDate;
            _this._firstViewDate = model.firstDate;
            _this._lastViewDate = model.lastDate;
        });
    }
    NgbDatepickerKeyMapService.prototype.processKey = function (event) {
        if (Key[Object(__WEBPACK_IMPORTED_MODULE_3__util_util__["i" /* toString */])(event.which)]) {
            switch (event.which) {
                case Key.PageUp:
                    this._service.focusMove(event.shiftKey ? 'y' : 'm', -1);
                    break;
                case Key.PageDown:
                    this._service.focusMove(event.shiftKey ? 'y' : 'm', 1);
                    break;
                case Key.End:
                    this._service.focus(event.shiftKey ? this._maxDate : this._lastViewDate);
                    break;
                case Key.Home:
                    this._service.focus(event.shiftKey ? this._minDate : this._firstViewDate);
                    break;
                case Key.ArrowLeft:
                    this._service.focusMove('d', -1);
                    break;
                case Key.ArrowUp:
                    this._service.focusMove('d', -this._calendar.getDaysPerWeek());
                    break;
                case Key.ArrowRight:
                    this._service.focusMove('d', 1);
                    break;
                case Key.ArrowDown:
                    this._service.focusMove('d', this._calendar.getDaysPerWeek());
                    break;
                case Key.Enter:
                case Key.Space:
                    this._service.focusSelect();
                    break;
                default:
                    return;
            }
            event.preventDefault();
            event.stopPropagation();
        }
    };
    NgbDatepickerKeyMapService.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    NgbDatepickerKeyMapService.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__datepicker_service__["a" /* NgbDatepickerService */], },
        { type: __WEBPACK_IMPORTED_MODULE_2__ngb_calendar__["a" /* NgbCalendar */], },
    ]; };
    return NgbDatepickerKeyMapService;
}());

//# sourceMappingURL=datepicker-keymap-service.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/datepicker-month-view.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NgbDatepickerMonthView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ngb_date__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/ngb-date.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__datepicker_i18n__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/datepicker-i18n.js");



var NgbDatepickerMonthView = /** @class */ (function () {
    function NgbDatepickerMonthView(i18n) {
        this.i18n = i18n;
        this.select = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
    }
    NgbDatepickerMonthView.prototype.doSelect = function (day) {
        if (!day.context.disabled && !this.isHidden(day)) {
            this.select.emit(__WEBPACK_IMPORTED_MODULE_1__ngb_date__["a" /* NgbDate */].from(day.date));
        }
    };
    NgbDatepickerMonthView.prototype.isCollapsed = function (week) {
        return this.outsideDays === 'collapsed' && week.days[0].date.month !== this.month.number &&
            week.days[week.days.length - 1].date.month !== this.month.number;
    };
    NgbDatepickerMonthView.prototype.isHidden = function (day) {
        return (this.outsideDays === 'hidden' || this.outsideDays === 'collapsed') && this.month.number !== day.date.month;
    };
    NgbDatepickerMonthView.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'ngb-datepicker-month-view',
                    host: { 'class': 'd-block', 'role': 'grid' },
                    styles: ["\n    .ngb-dp-weekday, .ngb-dp-week-number {\n      line-height: 2rem;\n      text-align: center;\n      font-style: italic;\n    }\n    .ngb-dp-weekday {\n      color: #5bc0de;\n      color: var(--info);\n    }\n    .ngb-dp-week {\n      border-radius: 0.25rem;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n    }\n    .ngb-dp-weekdays {\n      border-bottom: 1px solid rgba(0, 0, 0, 0.125);\n      border-radius: 0rem;\n    }\n    .ngb-dp-day, .ngb-dp-weekday, .ngb-dp-week-number {\n      width: 2rem;\n      height: 2rem;\n    }\n    .ngb-dp-day {\n      cursor: pointer;\n    }\n    .ngb-dp-day.disabled, .ngb-dp-day.hidden {\n      cursor: default;\n    }\n  "],
                    template: "\n    <div *ngIf=\"showWeekdays\" class=\"ngb-dp-week ngb-dp-weekdays bg-light\">\n      <div *ngIf=\"showWeekNumbers\" class=\"ngb-dp-weekday ngb-dp-showweek\"></div>\n      <div *ngFor=\"let w of month.weekdays\" class=\"ngb-dp-weekday small\">\n        {{ i18n.getWeekdayShortName(w) }}\n      </div>\n    </div>\n    <ng-template ngFor let-week [ngForOf]=\"month.weeks\">\n      <div *ngIf=\"!isCollapsed(week)\" class=\"ngb-dp-week\" role=\"row\">\n        <div *ngIf=\"showWeekNumbers\" class=\"ngb-dp-week-number small text-muted\">{{ week.number }}</div>\n        <div *ngFor=\"let day of week.days\" (click)=\"doSelect(day)\" class=\"ngb-dp-day\" role=\"gridcell\"\n          [class.disabled]=\"day.context.disabled\"\n          [tabindex]=\"day.tabindex\"\n          [class.hidden]=\"isHidden(day)\"\n          [attr.aria-label]=\"day.ariaLabel\">\n          <ng-template [ngIf]=\"!isHidden(day)\">\n            <ng-template [ngTemplateOutlet]=\"dayTemplate\" [ngTemplateOutletContext]=\"day.context\"></ng-template>\n          </ng-template>\n        </div>\n      </div>\n    </ng-template>\n  "
                },] },
    ];
    /** @nocollapse */
    NgbDatepickerMonthView.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_2__datepicker_i18n__["a" /* NgbDatepickerI18n */], },
    ]; };
    NgbDatepickerMonthView.propDecorators = {
        "dayTemplate": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "month": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "outsideDays": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "showWeekdays": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "showWeekNumbers": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "select": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    };
    return NgbDatepickerMonthView;
}());

//# sourceMappingURL=datepicker-month-view.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/datepicker-navigation-select.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NgbDatepickerNavigationSelect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ngb_date__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/ngb-date.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_util__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/util/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__datepicker_i18n__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/datepicker-i18n.js");




var NgbDatepickerNavigationSelect = /** @class */ (function () {
    function NgbDatepickerNavigationSelect(i18n) {
        this.i18n = i18n;
        this.select = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
    }
    NgbDatepickerNavigationSelect.prototype.changeMonth = function (month) { this.select.emit(new __WEBPACK_IMPORTED_MODULE_1__ngb_date__["a" /* NgbDate */](this.date.year, Object(__WEBPACK_IMPORTED_MODULE_2__util_util__["h" /* toInteger */])(month), 1)); };
    NgbDatepickerNavigationSelect.prototype.changeYear = function (year) { this.select.emit(new __WEBPACK_IMPORTED_MODULE_1__ngb_date__["a" /* NgbDate */](Object(__WEBPACK_IMPORTED_MODULE_2__util_util__["h" /* toInteger */])(year), this.date.month, 1)); };
    NgbDatepickerNavigationSelect.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'ngb-datepicker-navigation-select',
                    changeDetection: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectionStrategy"].OnPush,
                    styles: ["\n    :host>select {\n      /* to align with btn-sm */\n      padding: 0.25rem 0.5rem;\n      font-size: 0.875rem;\n      line-height: 1.25;\n      /* to cancel the custom height set by custom-select */\n      height: inherit;\n      width: 50%;\n      display: inline-block;\n    }\n  "],
                    template: "\n    <select\n      [disabled]=\"disabled\"\n      class=\"custom-select\"\n      [value]=\"date?.month\"\n      (change)=\"changeMonth($event.target.value)\">\n        <option *ngFor=\"let m of months\" [value]=\"m\">{{ i18n.getMonthShortName(m) }}</option>\n    </select><select\n      [disabled]=\"disabled\"\n      class=\"custom-select\"\n      [value]=\"date?.year\"\n      (change)=\"changeYear($event.target.value)\">\n        <option *ngFor=\"let y of years\" [value]=\"y\">{{ y }}</option>\n    </select>\n  "
                },] },
    ];
    /** @nocollapse */
    NgbDatepickerNavigationSelect.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_3__datepicker_i18n__["a" /* NgbDatepickerI18n */], },
    ]; };
    NgbDatepickerNavigationSelect.propDecorators = {
        "date": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "disabled": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "months": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "years": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "select": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    };
    return NgbDatepickerNavigationSelect;
}());

//# sourceMappingURL=datepicker-navigation-select.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/datepicker-navigation.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NgbDatepickerNavigation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__datepicker_view_model__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/datepicker-view-model.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ngb_date__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/ngb-date.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__datepicker_i18n__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/datepicker-i18n.js");




// The -ms- and -webkit- element for the CSS can be removed if we are generating the CSS using SASS.
var NgbDatepickerNavigation = /** @class */ (function () {
    function NgbDatepickerNavigation(i18n) {
        this.i18n = i18n;
        this.navigation = __WEBPACK_IMPORTED_MODULE_1__datepicker_view_model__["a" /* NavigationEvent */];
        this.months = [];
        this.navigate = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.select = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
    }
    NgbDatepickerNavigation.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'ngb-datepicker-navigation',
                    changeDetection: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectionStrategy"].OnPush,
                    styles: ["\n    :host {\n      height: 2rem;\n      line-height: 1.85rem;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n    }\n    .ngb-dp-navigation-chevron {\n      border-style: solid;\n      border-width: 0.2em 0.2em 0 0;\n      display: inline-block;\n      width: 0.75em;\n      height: 0.75em;\n      margin-left: 0.25em;\n      margin-right: 0.15em;\n      transform: rotate(-135deg);\n      -webkit-transform: rotate(-135deg);\n      -ms-transform: rotate(-135deg);\n    }\n    .right .ngb-dp-navigation-chevron {\n      -webkit-transform: rotate(45deg);\n      -ms-transform: rotate(45deg);\n      transform: rotate(45deg);\n      margin-left: 0.15em;\n      margin-right: 0.25em;\n    }\n    .ngb-dp-arrow {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-flex: 1 1 auto;\n      -ms-flex: 1 1 auto;\n      flex-basis: auto;\n      flex-grow: 1;\n      padding-right: 0px;\n      padding-left: 0px;\n      margin: 0px;\n      width: 2rem;\n      height: 2rem;\n    }\n    .ngb-dp-arrow.right {\n      -webkit-box-pack: end;\n      -ms-flex-pack: end;\n      justify-content: flex-end;\n    }\n    .ngb-dp-arrow-btn {\n      padding: 0rem 0.25rem;\n      margin: 0rem 0.5rem;\n      border: none;\n      background-color: transparent;\n      z-index: 1;\n    }\n    .ngb-dp-arrow-btn:focus {\n      outline-style: auto;\n      outline-width: 1px;\n    }\n    .ngb-dp-month-name {\n      font-size: larger;\n      height: 2rem;\n      line-height: 2rem;\n      text-align: center;\n    }\n    .ngb-dp-navigation-select {\n      -webkit-box-flex: 1 1 9rem;\n      -ms-flex:  1 1 9rem;\n      flex-grow: 1;\n      flex-basis: 9rem;\n    }\n  "],
                    template: "\n  <div class=\"ngb-dp-arrow\">\n    <button type=\"button\" class=\"btn btn-link ngb-dp-arrow-btn\"\n            (click)=\"!!navigate.emit(navigation.PREV)\" [disabled]=\"prevDisabled\">\n      <span class=\"ngb-dp-navigation-chevron\"></span>\n    </button>\n  </div>\n    <ngb-datepicker-navigation-select *ngIf=\"showSelect\" class=\"d-block ngb-dp-navigation-select\"\n      [date]=\"date\"\n      [disabled] = \"disabled\"\n      [months]=\"selectBoxes.months\"\n      [years]=\"selectBoxes.years\"\n      (select)=\"select.emit($event)\">\n    </ngb-datepicker-navigation-select>\n\n    <ng-template *ngIf=\"!showSelect\" ngFor let-month [ngForOf]=\"months\" let-i=\"index\">\n      <div class=\"ngb-dp-arrow\" *ngIf=\"i > 0\"></div>\n      <div class=\"ngb-dp-month-name d-block\">\n        {{ i18n.getMonthFullName(month.number) }} {{ month.year }}\n      </div>\n      <div class=\"ngb-dp-arrow\" *ngIf=\"i !== months.length - 1\"></div>\n    </ng-template>\n    <div class=\"ngb-dp-arrow right\">\n    <button type=\"button\" class=\"btn btn-link ngb-dp-arrow-btn\"\n            (click)=\"!!navigate.emit(navigation.NEXT)\" [disabled]=\"nextDisabled\">\n      <span class=\"ngb-dp-navigation-chevron\"></span>\n    </button>\n    </div>\n    "
                },] },
    ];
    /** @nocollapse */
    NgbDatepickerNavigation.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_3__datepicker_i18n__["a" /* NgbDatepickerI18n */], },
    ]; };
    NgbDatepickerNavigation.propDecorators = {
        "date": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "disabled": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "months": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "showSelect": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "prevDisabled": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "nextDisabled": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "selectBoxes": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "navigate": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "select": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    };
    return NgbDatepickerNavigation;
}());

//# sourceMappingURL=datepicker-navigation.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/datepicker-service.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NgbDatepickerService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ngb_calendar__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/ngb-calendar.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ngb_date__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/ngb-date.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_util__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/util/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs__ = __webpack_require__("./node_modules/rxjs/Rx.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__datepicker_tools__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/datepicker-tools.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_operators__ = __webpack_require__("./node_modules/rxjs/operators.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_operators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs_operators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__datepicker_i18n__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/datepicker-i18n.js");








var NgbDatepickerService = /** @class */ (function () {
    function NgbDatepickerService(_calendar, _i18n) {
        this._calendar = _calendar;
        this._i18n = _i18n;
        this._model$ = new __WEBPACK_IMPORTED_MODULE_4_rxjs__["Subject"]();
        this._select$ = new __WEBPACK_IMPORTED_MODULE_4_rxjs__["Subject"]();
        this._state = {
            disabled: false,
            displayMonths: 1,
            firstDayOfWeek: 1,
            focusVisible: false,
            months: [],
            navigation: 'select',
            prevDisabled: false,
            nextDisabled: false,
            selectBoxes: { years: [], months: [] },
            selectedDate: null
        };
    }
    Object.defineProperty(NgbDatepickerService.prototype, "model$", {
        get: function () { return this._model$.pipe(Object(__WEBPACK_IMPORTED_MODULE_6_rxjs_operators__["filter"])(function (model) { return model.months.length > 0; })); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgbDatepickerService.prototype, "select$", {
        get: function () { return this._select$.pipe(Object(__WEBPACK_IMPORTED_MODULE_6_rxjs_operators__["filter"])(function (date) { return date !== null; })); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgbDatepickerService.prototype, "disabled", {
        set: function (disabled) {
            if (this._state.disabled !== disabled) {
                this._nextState({ disabled: disabled });
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgbDatepickerService.prototype, "displayMonths", {
        set: function (displayMonths) {
            displayMonths = Object(__WEBPACK_IMPORTED_MODULE_3__util_util__["h" /* toInteger */])(displayMonths);
            if (Object(__WEBPACK_IMPORTED_MODULE_3__util_util__["c" /* isInteger */])(displayMonths) && displayMonths > 0 && this._state.displayMonths !== displayMonths) {
                this._nextState({ displayMonths: displayMonths });
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgbDatepickerService.prototype, "firstDayOfWeek", {
        set: function (firstDayOfWeek) {
            firstDayOfWeek = Object(__WEBPACK_IMPORTED_MODULE_3__util_util__["h" /* toInteger */])(firstDayOfWeek);
            if (Object(__WEBPACK_IMPORTED_MODULE_3__util_util__["c" /* isInteger */])(firstDayOfWeek) && firstDayOfWeek >= 0 && this._state.firstDayOfWeek !== firstDayOfWeek) {
                this._nextState({ firstDayOfWeek: firstDayOfWeek });
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgbDatepickerService.prototype, "focusVisible", {
        set: function (focusVisible) {
            if (this._state.focusVisible !== focusVisible && !this._state.disabled) {
                this._nextState({ focusVisible: focusVisible });
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgbDatepickerService.prototype, "maxDate", {
        set: function (date) {
            var maxDate = this.toValidDate(date, null);
            if (Object(__WEBPACK_IMPORTED_MODULE_5__datepicker_tools__["f" /* isChangedDate */])(this._state.maxDate, maxDate)) {
                this._nextState({ maxDate: maxDate });
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgbDatepickerService.prototype, "markDisabled", {
        set: function (markDisabled) {
            if (this._state.markDisabled !== markDisabled) {
                this._nextState({ markDisabled: markDisabled });
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgbDatepickerService.prototype, "minDate", {
        set: function (date) {
            var minDate = this.toValidDate(date, null);
            if (Object(__WEBPACK_IMPORTED_MODULE_5__datepicker_tools__["f" /* isChangedDate */])(this._state.minDate, minDate)) {
                this._nextState({ minDate: minDate });
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgbDatepickerService.prototype, "navigation", {
        set: function (navigation) {
            if (this._state.navigation !== navigation) {
                this._nextState({ navigation: navigation });
            }
        },
        enumerable: true,
        configurable: true
    });
    NgbDatepickerService.prototype.focus = function (date) {
        if (!this._state.disabled && this._calendar.isValid(date) && Object(__WEBPACK_IMPORTED_MODULE_5__datepicker_tools__["f" /* isChangedDate */])(this._state.focusDate, date)) {
            this._nextState({ focusDate: date });
        }
    };
    NgbDatepickerService.prototype.focusMove = function (period, number) {
        this.focus(this._calendar.getNext(this._state.focusDate, period, number));
    };
    NgbDatepickerService.prototype.focusSelect = function () {
        if (Object(__WEBPACK_IMPORTED_MODULE_5__datepicker_tools__["g" /* isDateSelectable */])(this._state.focusDate, this._state)) {
            this.select(this._state.focusDate, { emitEvent: true });
        }
    };
    NgbDatepickerService.prototype.open = function (date) {
        var firstDate = this.toValidDate(date, this._calendar.getToday());
        if (!this._state.disabled) {
            this._nextState({ firstDate: firstDate });
        }
    };
    NgbDatepickerService.prototype.select = function (date, options) {
        if (options === void 0) { options = {}; }
        var selectedDate = this.toValidDate(date, null);
        if (!this._state.disabled) {
            if (Object(__WEBPACK_IMPORTED_MODULE_5__datepicker_tools__["f" /* isChangedDate */])(this._state.selectedDate, selectedDate)) {
                this._nextState({ selectedDate: selectedDate });
            }
            if (options.emitEvent && Object(__WEBPACK_IMPORTED_MODULE_5__datepicker_tools__["g" /* isDateSelectable */])(selectedDate, this._state)) {
                this._select$.next(selectedDate);
            }
        }
    };
    NgbDatepickerService.prototype.toValidDate = function (date, defaultValue) {
        var ngbDate = __WEBPACK_IMPORTED_MODULE_1__ngb_date__["a" /* NgbDate */].from(date);
        if (defaultValue === undefined) {
            defaultValue = this._calendar.getToday();
        }
        return this._calendar.isValid(ngbDate) ? ngbDate : defaultValue;
    };
    NgbDatepickerService.prototype._nextState = function (patch) {
        var newState = this._updateState(patch);
        this._patchContexts(newState);
        this._state = newState;
        this._model$.next(this._state);
    };
    NgbDatepickerService.prototype._patchContexts = function (state) {
        state.months.forEach(function (month) {
            month.weeks.forEach(function (week) {
                week.days.forEach(function (day) {
                    // patch focus flag
                    if (state.focusDate) {
                        day.context.focused = state.focusDate.equals(day.date) && state.focusVisible;
                    }
                    day.tabindex =
                        (!state.disabled && day.date.equals(state.focusDate) && state.focusDate.month === month.number) ? 0 : -1;
                    // override context disabled
                    if (state.disabled === true) {
                        day.context.disabled = true;
                    }
                    // patch selection flag
                    if (state.selectedDate !== undefined) {
                        day.context.selected = state.selectedDate !== null && state.selectedDate.equals(day.date);
                    }
                });
            });
        });
    };
    NgbDatepickerService.prototype._updateState = function (patch) {
        // patching fields
        var state = Object.assign({}, this._state, patch);
        var startDate = state.firstDate;
        // min/max dates changed
        if ('minDate' in patch || 'maxDate' in patch) {
            Object(__WEBPACK_IMPORTED_MODULE_5__datepicker_tools__["c" /* checkMinBeforeMax */])(state.minDate, state.maxDate);
            state.focusDate = Object(__WEBPACK_IMPORTED_MODULE_5__datepicker_tools__["b" /* checkDateInRange */])(state.focusDate, state.minDate, state.maxDate);
            state.firstDate = Object(__WEBPACK_IMPORTED_MODULE_5__datepicker_tools__["b" /* checkDateInRange */])(state.firstDate, state.minDate, state.maxDate);
            startDate = state.focusDate;
        }
        // disabled
        if ('disabled' in patch) {
            state.focusVisible = false;
        }
        // initial rebuild via 'select()'
        if ('selectedDate' in patch && this._state.months.length === 0) {
            startDate = state.selectedDate;
        }
        // focus date changed
        if ('focusDate' in patch) {
            state.focusDate = Object(__WEBPACK_IMPORTED_MODULE_5__datepicker_tools__["b" /* checkDateInRange */])(state.focusDate, state.minDate, state.maxDate);
            startDate = state.focusDate;
            // nothing to rebuild if only focus changed and it is still visible
            if (state.months.length !== 0 && !state.focusDate.before(state.firstDate) &&
                !state.focusDate.after(state.lastDate)) {
                return state;
            }
        }
        // first date changed
        if ('firstDate' in patch) {
            state.firstDate = Object(__WEBPACK_IMPORTED_MODULE_5__datepicker_tools__["b" /* checkDateInRange */])(state.firstDate, state.minDate, state.maxDate);
            startDate = state.firstDate;
        }
        // rebuilding months
        if (startDate) {
            var forceRebuild = 'firstDayOfWeek' in patch || 'markDisabled' in patch || 'minDate' in patch ||
                'maxDate' in patch || 'disabled' in patch;
            var months = Object(__WEBPACK_IMPORTED_MODULE_5__datepicker_tools__["a" /* buildMonths */])(this._calendar, startDate, state, this._i18n, forceRebuild);
            // updating months and boundary dates
            state.months = months;
            state.firstDate = months.length > 0 ? months[0].firstDate : undefined;
            state.lastDate = months.length > 0 ? months[months.length - 1].lastDate : undefined;
            // reset selected date if 'markDisabled' returns true
            if ('selectedDate' in patch && !Object(__WEBPACK_IMPORTED_MODULE_5__datepicker_tools__["g" /* isDateSelectable */])(state.selectedDate, state)) {
                state.selectedDate = null;
            }
            // adjusting focus after months were built
            if ('firstDate' in patch) {
                if (state.focusDate === undefined || state.focusDate.before(state.firstDate) ||
                    state.focusDate.after(state.lastDate)) {
                    state.focusDate = startDate;
                }
            }
            // adjusting months/years for the select box navigation
            var yearChanged = !this._state.firstDate || this._state.firstDate.year !== state.firstDate.year;
            var monthChanged = !this._state.firstDate || this._state.firstDate.month !== state.firstDate.month;
            if (state.navigation === 'select') {
                // years ->  boundaries (min/max were changed)
                if ('minDate' in patch || 'maxDate' in patch || state.selectBoxes.years.length === 0 || yearChanged) {
                    state.selectBoxes.years = Object(__WEBPACK_IMPORTED_MODULE_5__datepicker_tools__["e" /* generateSelectBoxYears */])(state.focusDate, state.minDate, state.maxDate);
                }
                // months -> when current year or boundaries change
                if ('minDate' in patch || 'maxDate' in patch || state.selectBoxes.months.length === 0 || yearChanged) {
                    state.selectBoxes.months =
                        Object(__WEBPACK_IMPORTED_MODULE_5__datepicker_tools__["d" /* generateSelectBoxMonths */])(this._calendar, state.focusDate, state.minDate, state.maxDate);
                }
            }
            else {
                state.selectBoxes = { years: [], months: [] };
            }
            // updating navigation arrows -> boundaries change (min/max) or month/year changes
            if ((state.navigation === 'arrows' || state.navigation === 'select') &&
                (monthChanged || yearChanged || 'minDate' in patch || 'maxDate' in patch || 'disabled' in patch)) {
                state.prevDisabled = state.disabled || Object(__WEBPACK_IMPORTED_MODULE_5__datepicker_tools__["i" /* prevMonthDisabled */])(this._calendar, state.firstDate, state.minDate);
                state.nextDisabled = state.disabled || Object(__WEBPACK_IMPORTED_MODULE_5__datepicker_tools__["h" /* nextMonthDisabled */])(this._calendar, state.lastDate, state.maxDate);
            }
        }
        return state;
    };
    NgbDatepickerService.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    NgbDatepickerService.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_0__ngb_calendar__["a" /* NgbCalendar */], },
        { type: __WEBPACK_IMPORTED_MODULE_7__datepicker_i18n__["a" /* NgbDatepickerI18n */], },
    ]; };
    return NgbDatepickerService;
}());

//# sourceMappingURL=datepicker-service.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/datepicker-tools.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = isChangedDate;
/* unused harmony export dateComparator */
/* harmony export (immutable) */ __webpack_exports__["c"] = checkMinBeforeMax;
/* harmony export (immutable) */ __webpack_exports__["b"] = checkDateInRange;
/* harmony export (immutable) */ __webpack_exports__["g"] = isDateSelectable;
/* harmony export (immutable) */ __webpack_exports__["d"] = generateSelectBoxMonths;
/* harmony export (immutable) */ __webpack_exports__["e"] = generateSelectBoxYears;
/* harmony export (immutable) */ __webpack_exports__["h"] = nextMonthDisabled;
/* harmony export (immutable) */ __webpack_exports__["i"] = prevMonthDisabled;
/* harmony export (immutable) */ __webpack_exports__["a"] = buildMonths;
/* unused harmony export buildMonth */
/* unused harmony export getFirstViewDate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ngb_date__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/ngb-date.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_util__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/util/util.js");


function isChangedDate(prev, next) {
    return !dateComparator(prev, next);
}
function dateComparator(prev, next) {
    return (!prev && !next) || (!!prev && !!next && prev.equals(next));
}
function checkMinBeforeMax(minDate, maxDate) {
    if (maxDate && minDate && maxDate.before(minDate)) {
        throw new Error("'maxDate' " + maxDate + " should be greater than 'minDate' " + minDate);
    }
}
function checkDateInRange(date, minDate, maxDate) {
    if (date && minDate && date.before(minDate)) {
        return __WEBPACK_IMPORTED_MODULE_0__ngb_date__["a" /* NgbDate */].from(minDate);
    }
    if (date && maxDate && date.after(maxDate)) {
        return __WEBPACK_IMPORTED_MODULE_0__ngb_date__["a" /* NgbDate */].from(maxDate);
    }
    return date;
}
function isDateSelectable(date, state) {
    var minDate = state.minDate, maxDate = state.maxDate, disabled = state.disabled, markDisabled = state.markDisabled;
    // clang-format off
    return !(!Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["b" /* isDefined */])(date) ||
        disabled ||
        (markDisabled && markDisabled(date, { year: date.year, month: date.month })) ||
        (minDate && date.before(minDate)) ||
        (maxDate && date.after(maxDate)));
    // clang-format on
}
function generateSelectBoxMonths(calendar, date, minDate, maxDate) {
    if (!date) {
        return [];
    }
    var months = calendar.getMonths();
    if (minDate && date.year === minDate.year) {
        var index = months.findIndex(function (month) { return month === minDate.month; });
        months = months.slice(index);
    }
    if (maxDate && date.year === maxDate.year) {
        var index = months.findIndex(function (month) { return month === maxDate.month; });
        months = months.slice(0, index + 1);
    }
    return months;
}
function generateSelectBoxYears(date, minDate, maxDate) {
    if (!date) {
        return [];
    }
    var start = minDate && minDate.year || date.year - 10;
    var end = maxDate && maxDate.year || date.year + 10;
    return Array.from({ length: end - start + 1 }, function (e, i) { return start + i; });
}
function nextMonthDisabled(calendar, date, maxDate) {
    return maxDate && calendar.getNext(date, 'm').after(maxDate);
}
function prevMonthDisabled(calendar, date, minDate) {
    var prevDate = calendar.getPrev(date, 'm');
    return minDate && (prevDate.year === minDate.year && prevDate.month < minDate.month ||
        prevDate.year < minDate.year && minDate.month === 1);
}
function buildMonths(calendar, date, state, i18n, force) {
    var displayMonths = state.displayMonths, months = state.months;
    var newMonths = [];
    var _loop_1 = function (i) {
        var newDate = calendar.getNext(date, 'm', i);
        var index = months.findIndex(function (month) { return month.firstDate.equals(newDate); });
        if (force || index === -1) {
            newMonths.push(buildMonth(calendar, newDate, state, i18n));
        }
        else {
            newMonths.push(months[index]);
        }
    };
    for (var i = 0; i < displayMonths; i++) {
        _loop_1(i);
    }
    return newMonths;
}
function buildMonth(calendar, date, state, i18n) {
    var minDate = state.minDate, maxDate = state.maxDate, firstDayOfWeek = state.firstDayOfWeek, markDisabled = state.markDisabled;
    var month = { firstDate: null, lastDate: null, number: date.month, year: date.year, weeks: [], weekdays: [] };
    date = getFirstViewDate(calendar, date, firstDayOfWeek);
    // month has weeks
    for (var week = 0; week < calendar.getWeeksPerMonth(); week++) {
        var days = [];
        // week has days
        for (var day = 0; day < calendar.getDaysPerWeek(); day++) {
            if (week === 0) {
                month.weekdays.push(calendar.getWeekday(date));
            }
            var newDate = new __WEBPACK_IMPORTED_MODULE_0__ngb_date__["a" /* NgbDate */](date.year, date.month, date.day);
            var nextDate = calendar.getNext(newDate);
            var ariaLabel = i18n.getDayAriaLabel(newDate);
            // marking date as disabled
            var disabled = !!((minDate && newDate.before(minDate)) || (maxDate && newDate.after(maxDate)));
            if (!disabled && markDisabled) {
                disabled = markDisabled(newDate, { month: month.number, year: month.year });
            }
            // saving first date of the month
            if (month.firstDate === null && newDate.month === month.number) {
                month.firstDate = newDate;
            }
            // saving last date of the month
            if (newDate.month === month.number && nextDate.month !== month.number) {
                month.lastDate = newDate;
            }
            days.push({
                date: newDate,
                context: {
                    date: { year: newDate.year, month: newDate.month, day: newDate.day },
                    currentMonth: month.number,
                    disabled: disabled,
                    focused: false,
                    selected: false
                },
                tabindex: -1, ariaLabel: ariaLabel
            });
            date = nextDate;
        }
        month.weeks.push({ number: calendar.getWeekNumber(days.map(function (day) { return __WEBPACK_IMPORTED_MODULE_0__ngb_date__["a" /* NgbDate */].from(day.date); }), firstDayOfWeek), days: days });
    }
    return month;
}
function getFirstViewDate(calendar, date, firstDayOfWeek) {
    var daysPerWeek = calendar.getDaysPerWeek();
    var firstMonthDate = new __WEBPACK_IMPORTED_MODULE_0__ngb_date__["a" /* NgbDate */](date.year, date.month, 1);
    var dayOfWeek = calendar.getWeekday(firstMonthDate) % daysPerWeek;
    return calendar.getPrev(firstMonthDate, 'd', (daysPerWeek + dayOfWeek - firstDayOfWeek) % daysPerWeek);
}
//# sourceMappingURL=datepicker-tools.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/datepicker-view-model.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NavigationEvent; });
// clang-format on
// clang-format on
var NavigationEvent;
// clang-format on
(function (NavigationEvent) {
    NavigationEvent[NavigationEvent["PREV"] = 0] = "PREV";
    NavigationEvent[NavigationEvent["NEXT"] = 1] = "NEXT";
})(NavigationEvent || (NavigationEvent = {}));
//# sourceMappingURL=datepicker-view-model.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/datepicker.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NgbDatepicker; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_operators__ = __webpack_require__("./node_modules/rxjs/operators.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_operators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_operators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_forms__ = __webpack_require__("./node_modules/@angular/forms/esm5/forms.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ngb_calendar__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/ngb-calendar.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ngb_date__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/ngb-date.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__datepicker_service__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/datepicker-service.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__datepicker_keymap_service__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/datepicker-keymap-service.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__datepicker_view_model__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/datepicker-view-model.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__datepicker_config__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/datepicker-config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ngb_date_adapter__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/ngb-date-adapter.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__datepicker_i18n__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/datepicker-i18n.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__datepicker_tools__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/datepicker-tools.js");












var NGB_DATEPICKER_VALUE_ACCESSOR = {
    provide: __WEBPACK_IMPORTED_MODULE_2__angular_forms__["NG_VALUE_ACCESSOR"],
    useExisting: Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return NgbDatepicker; }),
    multi: true
};
/**
 * A lightweight and highly configurable datepicker directive
 */
var NgbDatepicker = /** @class */ (function () {
    function NgbDatepicker(_keyMapService, _service, _calendar, i18n, config, _cd, _elementRef, _ngbDateAdapter, _ngZone) {
        var _this = this;
        this._keyMapService = _keyMapService;
        this._service = _service;
        this._calendar = _calendar;
        this.i18n = i18n;
        this._cd = _cd;
        this._elementRef = _elementRef;
        this._ngbDateAdapter = _ngbDateAdapter;
        this._ngZone = _ngZone;
        /**
           * An event fired when navigation happens and currently displayed month changes.
           * See NgbDatepickerNavigateEvent for the payload info.
           */
        this.navigate = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
        /**
           * An event fired when user selects a date using keyboard or mouse.
           * The payload of the event is currently selected NgbDateStruct.
           */
        this.select = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
        this.onChange = function (_) { };
        this.onTouched = function () { };
        ['dayTemplate', 'displayMonths', 'firstDayOfWeek', 'markDisabled', 'minDate', 'maxDate', 'navigation',
            'outsideDays', 'showWeekdays', 'showWeekNumbers', 'startDate']
            .forEach(function (input) { return _this[input] = config[input]; });
        this._selectSubscription = _service.select$.subscribe(function (date) { _this.select.emit(date.toStruct()); });
        this._subscription = _service.model$.subscribe(function (model) {
            var newDate = model.firstDate;
            var oldDate = _this.model ? _this.model.firstDate : null;
            var newSelectedDate = model.selectedDate;
            var oldSelectedDate = _this.model ? _this.model.selectedDate : null;
            var newFocusedDate = model.focusDate;
            var oldFocusedDate = _this.model ? _this.model.focusDate : null;
            _this.model = model;
            // handling selection change
            if (Object(__WEBPACK_IMPORTED_MODULE_11__datepicker_tools__["f" /* isChangedDate */])(newSelectedDate, oldSelectedDate)) {
                _this.onTouched();
                _this.onChange(_this._ngbDateAdapter.toModel(newSelectedDate));
            }
            // handling focus change
            if (Object(__WEBPACK_IMPORTED_MODULE_11__datepicker_tools__["f" /* isChangedDate */])(newFocusedDate, oldFocusedDate) && oldFocusedDate && model.focusVisible) {
                _this.focus();
            }
            // emitting navigation event if the first month changes
            if (!newDate.equals(oldDate)) {
                _this.navigate.emit({
                    current: oldDate ? { year: oldDate.year, month: oldDate.month } : null,
                    next: { year: newDate.year, month: newDate.month }
                });
            }
            _cd.markForCheck();
        });
    }
    /**
     * Manually focus the focusable day in the datepicker
     */
    /**
       * Manually focus the focusable day in the datepicker
       */
    NgbDatepicker.prototype.focus = /**
       * Manually focus the focusable day in the datepicker
       */
    function () {
        var _this = this;
        this._ngZone.onStable.asObservable().pipe(Object(__WEBPACK_IMPORTED_MODULE_0_rxjs_operators__["take"])(1)).subscribe(function () {
            var elementToFocus = _this._elementRef.nativeElement.querySelector('div.ngb-dp-day[tabindex="0"]');
            if (elementToFocus) {
                elementToFocus.focus();
            }
        });
    };
    /**
     * Navigates current view to provided date.
     * With default calendar we use ISO 8601: 'month' is 1=Jan ... 12=Dec.
     * If nothing or invalid date provided calendar will open current month.
     * Use 'startDate' input as an alternative
     */
    /**
       * Navigates current view to provided date.
       * With default calendar we use ISO 8601: 'month' is 1=Jan ... 12=Dec.
       * If nothing or invalid date provided calendar will open current month.
       * Use 'startDate' input as an alternative
       */
    NgbDatepicker.prototype.navigateTo = /**
       * Navigates current view to provided date.
       * With default calendar we use ISO 8601: 'month' is 1=Jan ... 12=Dec.
       * If nothing or invalid date provided calendar will open current month.
       * Use 'startDate' input as an alternative
       */
    function (date) { this._service.open(__WEBPACK_IMPORTED_MODULE_4__ngb_date__["a" /* NgbDate */].from(date)); };
    NgbDatepicker.prototype.ngOnDestroy = function () {
        this._subscription.unsubscribe();
        this._selectSubscription.unsubscribe();
    };
    NgbDatepicker.prototype.ngOnInit = function () {
        var _this = this;
        if (this.model === undefined) {
            ['displayMonths', 'markDisabled', 'firstDayOfWeek', 'navigation', 'minDate', 'maxDate'].forEach(function (input) { return _this._service[input] = _this[input]; });
            this.navigateTo(this.startDate);
        }
    };
    NgbDatepicker.prototype.ngOnChanges = function (changes) {
        var _this = this;
        ['displayMonths', 'markDisabled', 'firstDayOfWeek', 'navigation', 'minDate', 'maxDate']
            .filter(function (input) { return input in changes; })
            .forEach(function (input) { return _this._service[input] = _this[input]; });
        if ('startDate' in changes) {
            this.navigateTo(this.startDate);
        }
    };
    NgbDatepicker.prototype.onDateSelect = function (date) {
        this._service.focus(date);
        this._service.select(date, { emitEvent: true });
    };
    NgbDatepicker.prototype.onKeyDown = function (event) { this._keyMapService.processKey(event); };
    NgbDatepicker.prototype.onNavigateDateSelect = function (date) { this._service.open(date); };
    NgbDatepicker.prototype.onNavigateEvent = function (event) {
        switch (event) {
            case __WEBPACK_IMPORTED_MODULE_7__datepicker_view_model__["a" /* NavigationEvent */].PREV:
                this._service.open(this._calendar.getPrev(this.model.firstDate, 'm', 1));
                break;
            case __WEBPACK_IMPORTED_MODULE_7__datepicker_view_model__["a" /* NavigationEvent */].NEXT:
                this._service.open(this._calendar.getNext(this.model.firstDate, 'm', 1));
                break;
        }
    };
    NgbDatepicker.prototype.registerOnChange = function (fn) { this.onChange = fn; };
    NgbDatepicker.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    NgbDatepicker.prototype.setDisabledState = function (isDisabled) { this._service.disabled = isDisabled; };
    NgbDatepicker.prototype.showFocus = function (focusVisible) { this._service.focusVisible = focusVisible; };
    NgbDatepicker.prototype.writeValue = function (value) { this._service.select(__WEBPACK_IMPORTED_MODULE_4__ngb_date__["a" /* NgbDate */].from(this._ngbDateAdapter.fromModel(value))); };
    NgbDatepicker.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"], args: [{
                    exportAs: 'ngbDatepicker',
                    selector: 'ngb-datepicker',
                    changeDetection: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ChangeDetectionStrategy"].OnPush,
                    styles: ["\n    :host {\n      border: 1px solid rgba(0, 0, 0, 0.125);\n      border-radius: 0.25rem;\n      display: inline-block;\n    }\n    .ngb-dp-month {\n      pointer-events: none;\n    }\n    .ngb-dp-header {\n      border-bottom: 0px;\n      border-radius: .25rem 0.25rem 0rem 0rem;\n      padding-top: 0.25rem;\n    }\n    ngb-datepicker-month-view {\n      pointer-events: auto;\n    }\n    .ngb-dp-month-name {\n      font-size: larger;\n      height: 2rem;\n      line-height: 2rem;\n      text-align: center;\n    }\n    /deep/ .ngb-dp-month + .ngb-dp-month > ngb-datepicker-month-view > .ngb-dp-week {\n      padding-left: 1rem;\n    }\n    /deep/ .ngb-dp-month + .ngb-dp-month > .ngb-dp-month-name {\n      padding-left: 1rem;\n    }\n    /deep/ .ngb-dp-month:last-child .ngb-dp-week {\n      padding-right: .25rem;\n    }\n    /deep/ .ngb-dp-month:first-child .ngb-dp-week {\n      padding-left: .25rem;\n    }\n    /deep/ .ngb-dp-month > ngb-datepicker-month-view > .ngb-dp-week:last-child {\n      padding-bottom: .25rem;\n    }\n    .ngb-dp-months {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n    }\n  "],
                    template: "\n    <ng-template #dt let-date=\"date\" let-currentMonth=\"currentMonth\" let-selected=\"selected\" let-disabled=\"disabled\" let-focused=\"focused\">\n      <div ngbDatepickerDayView\n        [date]=\"date\"\n        [currentMonth]=\"currentMonth\"\n        [selected]=\"selected\"\n        [disabled]=\"disabled\"\n        [focused]=\"focused\">\n      </div>\n    </ng-template>\n\n    <div class=\"ngb-dp-header bg-light\">\n      <ngb-datepicker-navigation *ngIf=\"navigation !== 'none'\"\n        [date]=\"model.firstDate\"\n        [months]=\"model.months\"\n        [disabled]=\"model.disabled\"\n        [showSelect]=\"model.navigation === 'select'\"\n        [prevDisabled]=\"model.prevDisabled\"\n        [nextDisabled]=\"model.nextDisabled\"\n        [selectBoxes]=\"model.selectBoxes\"\n        (navigate)=\"onNavigateEvent($event)\"\n        (select)=\"onNavigateDateSelect($event)\">\n      </ngb-datepicker-navigation>\n    </div>\n\n    <div class=\"ngb-dp-months\" (keydown)=\"onKeyDown($event)\" (focusin)=\"showFocus(true)\" (focusout)=\"showFocus(false)\">\n      <ng-template ngFor let-month [ngForOf]=\"model.months\" let-i=\"index\">\n        <div class=\"ngb-dp-month d-block\">\n          <div *ngIf=\"navigation === 'none' || (displayMonths > 1 && navigation === 'select')\"\n                class=\"ngb-dp-month-name bg-light\">\n            {{ i18n.getMonthFullName(month.number) }} {{ month.year }}\n          </div>\n          <ngb-datepicker-month-view\n            [month]=\"month\"\n            [dayTemplate]=\"dayTemplate || dt\"\n            [showWeekdays]=\"showWeekdays\"\n            [showWeekNumbers]=\"showWeekNumbers\"\n            [outsideDays]=\"(displayMonths === 1 ? outsideDays : 'hidden')\"\n            (select)=\"onDateSelect($event)\">\n          </ngb-datepicker-month-view>\n        </div>\n      </ng-template>\n    </div>\n  ",
                    providers: [NGB_DATEPICKER_VALUE_ACCESSOR, __WEBPACK_IMPORTED_MODULE_5__datepicker_service__["a" /* NgbDatepickerService */], __WEBPACK_IMPORTED_MODULE_6__datepicker_keymap_service__["a" /* NgbDatepickerKeyMapService */]]
                },] },
    ];
    /** @nocollapse */
    NgbDatepicker.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_6__datepicker_keymap_service__["a" /* NgbDatepickerKeyMapService */], },
        { type: __WEBPACK_IMPORTED_MODULE_5__datepicker_service__["a" /* NgbDatepickerService */], },
        { type: __WEBPACK_IMPORTED_MODULE_3__ngb_calendar__["a" /* NgbCalendar */], },
        { type: __WEBPACK_IMPORTED_MODULE_10__datepicker_i18n__["a" /* NgbDatepickerI18n */], },
        { type: __WEBPACK_IMPORTED_MODULE_8__datepicker_config__["a" /* NgbDatepickerConfig */], },
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ChangeDetectorRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_9__ngb_date_adapter__["a" /* NgbDateAdapter */], },
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["NgZone"], },
    ]; };
    NgbDatepicker.propDecorators = {
        "dayTemplate": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
        "displayMonths": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
        "firstDayOfWeek": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
        "markDisabled": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
        "maxDate": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
        "minDate": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
        "navigation": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
        "outsideDays": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
        "showWeekdays": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
        "showWeekNumbers": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
        "startDate": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
        "navigate": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Output"] },],
        "select": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Output"] },],
    };
    return NgbDatepicker;
}());

//# sourceMappingURL=datepicker.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/datepicker.module.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return NgbDatepickerModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_common__ = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_forms__ = __webpack_require__("./node_modules/@angular/forms/esm5/forms.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_focus_trap__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/util/focus-trap.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__datepicker__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/datepicker.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__datepicker_month_view__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/datepicker-month-view.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__datepicker_navigation__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/datepicker-navigation.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__datepicker_input__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/datepicker-input.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__datepicker_day_view__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/datepicker-day-view.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__datepicker_i18n__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/datepicker-i18n.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ngb_calendar__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/ngb-calendar.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ngb_date_parser_formatter__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/ngb-date-parser-formatter.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ngb_date_adapter__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/ngb-date-adapter.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__datepicker_navigation_select__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/datepicker-navigation-select.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__datepicker_config__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/datepicker-config.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_4__datepicker__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_7__datepicker_input__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_10__ngb_calendar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__hijri_ngb_calendar_islamic_civil__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/hijri/ngb-calendar-islamic-civil.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_15__hijri_ngb_calendar_islamic_civil__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__hijri_ngb_calendar_islamic_umalqura__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/hijri/ngb-calendar-islamic-umalqura.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_16__hijri_ngb_calendar_islamic_umalqura__["a"]; });
/* unused harmony reexport NgbDatepickerMonthView */
/* unused harmony reexport NgbDatepickerDayView */
/* unused harmony reexport NgbDatepickerNavigation */
/* unused harmony reexport NgbDatepickerNavigationSelect */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_14__datepicker_config__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_9__datepicker_i18n__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_12__ngb_date_adapter__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_11__ngb_date_parser_formatter__["b"]; });




























var NgbDatepickerModule = /** @class */ (function () {
    function NgbDatepickerModule() {
    }
    NgbDatepickerModule.forRoot = function () {
        return {
            ngModule: NgbDatepickerModule,
            providers: [
                { provide: __WEBPACK_IMPORTED_MODULE_10__ngb_calendar__["a" /* NgbCalendar */], useClass: __WEBPACK_IMPORTED_MODULE_10__ngb_calendar__["b" /* NgbCalendarGregorian */] },
                { provide: __WEBPACK_IMPORTED_MODULE_9__datepicker_i18n__["a" /* NgbDatepickerI18n */], useClass: __WEBPACK_IMPORTED_MODULE_9__datepicker_i18n__["b" /* NgbDatepickerI18nDefault */] },
                { provide: __WEBPACK_IMPORTED_MODULE_11__ngb_date_parser_formatter__["b" /* NgbDateParserFormatter */], useClass: __WEBPACK_IMPORTED_MODULE_11__ngb_date_parser_formatter__["a" /* NgbDateISOParserFormatter */] },
                { provide: __WEBPACK_IMPORTED_MODULE_12__ngb_date_adapter__["a" /* NgbDateAdapter */], useClass: __WEBPACK_IMPORTED_MODULE_12__ngb_date_adapter__["b" /* NgbDateStructAdapter */] }, __WEBPACK_IMPORTED_MODULE_14__datepicker_config__["a" /* NgbDatepickerConfig */], __WEBPACK_IMPORTED_MODULE_3__util_focus_trap__["a" /* NgbFocusTrapFactory */], __WEBPACK_IMPORTED_MODULE_1__angular_common__["DatePipe"]
            ]
        };
    };
    NgbDatepickerModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                    declarations: [
                        __WEBPACK_IMPORTED_MODULE_4__datepicker__["a" /* NgbDatepicker */], __WEBPACK_IMPORTED_MODULE_5__datepicker_month_view__["a" /* NgbDatepickerMonthView */], __WEBPACK_IMPORTED_MODULE_6__datepicker_navigation__["a" /* NgbDatepickerNavigation */], __WEBPACK_IMPORTED_MODULE_13__datepicker_navigation_select__["a" /* NgbDatepickerNavigationSelect */], __WEBPACK_IMPORTED_MODULE_8__datepicker_day_view__["a" /* NgbDatepickerDayView */],
                        __WEBPACK_IMPORTED_MODULE_7__datepicker_input__["a" /* NgbInputDatepicker */]
                    ],
                    exports: [__WEBPACK_IMPORTED_MODULE_4__datepicker__["a" /* NgbDatepicker */], __WEBPACK_IMPORTED_MODULE_7__datepicker_input__["a" /* NgbInputDatepicker */]],
                    imports: [__WEBPACK_IMPORTED_MODULE_1__angular_common__["CommonModule"], __WEBPACK_IMPORTED_MODULE_2__angular_forms__["FormsModule"]],
                    entryComponents: [__WEBPACK_IMPORTED_MODULE_4__datepicker__["a" /* NgbDatepicker */]]
                },] },
    ];
    return NgbDatepickerModule;
}());

//# sourceMappingURL=datepicker.module.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/hijri/ngb-calendar-hijri.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NgbCalendarHijri; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ngb_calendar__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/ngb-calendar.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_util__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/util/util.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var NgbCalendarHijri = /** @class */ (function (_super) {
    __extends(NgbCalendarHijri, _super);
    function NgbCalendarHijri() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NgbCalendarHijri.prototype.getDaysPerWeek = function () { return 7; };
    NgbCalendarHijri.prototype.getMonths = function () { return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]; };
    NgbCalendarHijri.prototype.getWeeksPerMonth = function () { return 6; };
    NgbCalendarHijri.prototype.isValid = function (date) {
        return date && Object(__WEBPACK_IMPORTED_MODULE_2__util_util__["d" /* isNumber */])(date.year) && Object(__WEBPACK_IMPORTED_MODULE_2__util_util__["d" /* isNumber */])(date.month) && Object(__WEBPACK_IMPORTED_MODULE_2__util_util__["d" /* isNumber */])(date.day) &&
            !isNaN(this.toGregorian(date).getTime());
    };
    NgbCalendarHijri.prototype.setDay = function (date, day) {
        day = +day;
        var mDays = this.getDaysInIslamicMonth(date.month, date.year);
        if (day <= 0) {
            while (day <= 0) {
                date = this.setMonth(date, date.month - 1);
                mDays = this.getDaysInIslamicMonth(date.month, date.year);
                day += mDays;
            }
        }
        else if (day > mDays) {
            while (day > mDays) {
                day -= mDays;
                date = this.setMonth(date, date.month + 1);
                mDays = this.getDaysInIslamicMonth(date.month, date.year);
            }
        }
        date.day = day;
        return date;
    };
    NgbCalendarHijri.prototype.setMonth = function (date, month) {
        month = +month;
        date.year = date.year + Math.floor((month - 1) / 12);
        date.month = Math.floor(((month - 1) % 12 + 12) % 12) + 1;
        return date;
    };
    NgbCalendarHijri.prototype.setYear = function (date, yearValue) {
        date.year = +yearValue;
        return date;
    };
    NgbCalendarHijri.prototype._isIslamicLeapYear = function (year) { return (14 + 11 * year) % 30 < 11; };
    /**
     * Returns the start of Hijri Month.
     * `month` is 0 for Muharram, 1 for Safar, etc.
     * `year` is any Hijri year.
     */
    /**
       * Returns the start of Hijri Month.
       * `month` is 0 for Muharram, 1 for Safar, etc.
       * `year` is any Hijri year.
       */
    NgbCalendarHijri.prototype._getMonthStart = /**
       * Returns the start of Hijri Month.
       * `month` is 0 for Muharram, 1 for Safar, etc.
       * `year` is any Hijri year.
       */
    function (year, month) {
        return Math.ceil(29.5 * month) + (year - 1) * 354 + Math.floor((3 + 11 * year) / 30.0);
    };
    /**
     * Returns the start of Hijri year.
     * `year` is any Hijri year.
     */
    /**
       * Returns the start of Hijri year.
       * `year` is any Hijri year.
       */
    NgbCalendarHijri.prototype._getYearStart = /**
       * Returns the start of Hijri year.
       * `year` is any Hijri year.
       */
    function (year) { return (year - 1) * 354 + Math.floor((3 + 11 * year) / 30.0); };
    NgbCalendarHijri.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"] },
    ];
    return NgbCalendarHijri;
}(__WEBPACK_IMPORTED_MODULE_0__ngb_calendar__["a" /* NgbCalendar */]));

//# sourceMappingURL=ngb-calendar-hijri.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/hijri/ngb-calendar-islamic-civil.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NgbCalendarIslamicCivil; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ngb_calendar_hijri__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/hijri/ngb-calendar-hijri.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ngb_date__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/ngb-date.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



function isGregorianLeapYear(date) {
    var year = date.getFullYear();
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
}
function mod(a, b) {
    return a - b * Math.floor(a / b);
}
/**
 * The civil calendar is one type of Hijri calendars used in islamic countries.
 * Uses a fixed cycle of alternating 29- and 30-day months,
 * with a leap day added to the last month of 11 out of every 30 years.
 * http://cldr.unicode.org/development/development-process/design-proposals/islamic-calendar-types
 * All the calculations here are based on the equations from "Calendrical Calculations" By Edward M. Reingold, Nachum
 * Dershowitz.
 */
var GREGORIAN_EPOCH = 1721425.5;
var ISLAMIC_EPOCH = 1948439.5;
var NgbCalendarIslamicCivil = /** @class */ (function (_super) {
    __extends(NgbCalendarIslamicCivil, _super);
    function NgbCalendarIslamicCivil() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Returns the equivalent islamic(civil) date value for a give input Gregorian date.
     * `gdate` is a JS Date to be converted to Hijri.
     */
    /**
       * Returns the equivalent islamic(civil) date value for a give input Gregorian date.
       * `gdate` is a JS Date to be converted to Hijri.
       */
    NgbCalendarIslamicCivil.prototype.fromGregorian = /**
       * Returns the equivalent islamic(civil) date value for a give input Gregorian date.
       * `gdate` is a JS Date to be converted to Hijri.
       */
    function (gdate) {
        var date = new Date(gdate);
        var gYear = date.getFullYear(), gMonth = date.getMonth(), gDay = date.getDate();
        var julianDay = GREGORIAN_EPOCH - 1 + 365 * (gYear - 1) + Math.floor((gYear - 1) / 4) +
            -Math.floor((gYear - 1) / 100) + Math.floor((gYear - 1) / 400) +
            Math.floor((367 * (gMonth + 1) - 362) / 12 + (gMonth + 1 <= 2 ? 0 : isGregorianLeapYear(date) ? -1 : -2) + gDay);
        julianDay = Math.floor(julianDay) + 0.5;
        var days = julianDay - ISLAMIC_EPOCH;
        var hYear = Math.floor((30 * days + 10646) / 10631.0);
        var hMonth = Math.ceil((days - 29 - this._getYearStart(hYear)) / 29.5);
        hMonth = Math.min(hMonth, 11);
        var hDay = Math.ceil(days - this._getMonthStart(hYear, hMonth)) + 1;
        return new __WEBPACK_IMPORTED_MODULE_1__ngb_date__["a" /* NgbDate */](hYear, hMonth + 1, hDay);
    };
    /**
     * Returns the equivalent JS date value for a give input islamic(civil) date.
     * `hijriDate` is an islamic(civil) date to be converted to Gregorian.
     */
    /**
       * Returns the equivalent JS date value for a give input islamic(civil) date.
       * `hijriDate` is an islamic(civil) date to be converted to Gregorian.
       */
    NgbCalendarIslamicCivil.prototype.toGregorian = /**
       * Returns the equivalent JS date value for a give input islamic(civil) date.
       * `hijriDate` is an islamic(civil) date to be converted to Gregorian.
       */
    function (hijriDate) {
        var hYear = hijriDate.year;
        var hMonth = hijriDate.month - 1;
        var hDate = hijriDate.day;
        var julianDay = hDate + Math.ceil(29.5 * hMonth) + (hYear - 1) * 354 + Math.floor((3 + 11 * hYear) / 30) + ISLAMIC_EPOCH - 1;
        var wjd = Math.floor(julianDay - 0.5) + 0.5, depoch = wjd - GREGORIAN_EPOCH, quadricent = Math.floor(depoch / 146097), dqc = mod(depoch, 146097), cent = Math.floor(dqc / 36524), dcent = mod(dqc, 36524), quad = Math.floor(dcent / 1461), dquad = mod(dcent, 1461), yindex = Math.floor(dquad / 365);
        var year = quadricent * 400 + cent * 100 + quad * 4 + yindex;
        if (!(cent === 4 || yindex === 4)) {
            year++;
        }
        var gYearStart = GREGORIAN_EPOCH + 365 * (year - 1) + Math.floor((year - 1) / 4) - Math.floor((year - 1) / 100) +
            Math.floor((year - 1) / 400);
        var yearday = wjd - gYearStart;
        var tjd = GREGORIAN_EPOCH - 1 + 365 * (year - 1) + Math.floor((year - 1) / 4) - Math.floor((year - 1) / 100) +
            Math.floor((year - 1) / 400) + Math.floor(739 / 12 + (isGregorianLeapYear(new Date(year, 3, 1)) ? -1 : -2) + 1);
        var leapadj = wjd < tjd ? 0 : isGregorianLeapYear(new Date(year, 3, 1)) ? 1 : 2;
        var month = Math.floor(((yearday + leapadj) * 12 + 373) / 367);
        var tjd2 = GREGORIAN_EPOCH - 1 + 365 * (year - 1) + Math.floor((year - 1) / 4) - Math.floor((year - 1) / 100) +
            Math.floor((year - 1) / 400) +
            Math.floor((367 * month - 362) / 12 + (month <= 2 ? 0 : isGregorianLeapYear(new Date(year, month - 1, 1)) ? -1 : -2) +
                1);
        var day = wjd - tjd2 + 1;
        return new Date(year, month - 1, day);
    };
    /**
     * Returns the number of days in a specific Hijri month.
     * `month` is 1 for Muharram, 2 for Safar, etc.
     * `year` is any Hijri year.
     */
    /**
       * Returns the number of days in a specific Hijri month.
       * `month` is 1 for Muharram, 2 for Safar, etc.
       * `year` is any Hijri year.
       */
    NgbCalendarIslamicCivil.prototype.getDaysInIslamicMonth = /**
       * Returns the number of days in a specific Hijri month.
       * `month` is 1 for Muharram, 2 for Safar, etc.
       * `year` is any Hijri year.
       */
    function (month, year) {
        year = year + Math.floor(month / 13);
        month = ((month - 1) % 12) + 1;
        var length = 29 + month % 2;
        if (month === 12 && this._isIslamicLeapYear(year)) {
            length++;
        }
        return length;
    };
    NgbCalendarIslamicCivil.prototype.getNext = function (date, period, number) {
        if (period === void 0) { period = 'd'; }
        if (number === void 0) { number = 1; }
        date = __WEBPACK_IMPORTED_MODULE_1__ngb_date__["a" /* NgbDate */].from(date);
        switch (period) {
            case 'y':
                date = this.setYear(date, date.year + number);
                date.month = 1;
                date.day = 1;
                return date;
            case 'm':
                date = this.setMonth(date, date.month + number);
                date.day = 1;
                return date;
            case 'd':
                return this.setDay(date, date.day + number);
            default:
                return date;
        }
    };
    NgbCalendarIslamicCivil.prototype.getPrev = function (date, period, number) {
        if (period === void 0) { period = 'd'; }
        if (number === void 0) { number = 1; }
        return this.getNext(date, period, -number);
    };
    NgbCalendarIslamicCivil.prototype.getWeekday = function (date) {
        var day = this.toGregorian(date).getDay();
        // in JS Date Sun=0, in ISO 8601 Sun=7
        return day === 0 ? 7 : day;
    };
    NgbCalendarIslamicCivil.prototype.getWeekNumber = function (week, firstDayOfWeek) {
        // in JS Date Sun=0, in ISO 8601 Sun=7
        if (firstDayOfWeek === 7) {
            firstDayOfWeek = 0;
        }
        var thursdayIndex = (4 + 7 - firstDayOfWeek) % 7;
        var date = week[thursdayIndex];
        var jsDate = this.toGregorian(date);
        jsDate.setDate(jsDate.getDate() + 4 - (jsDate.getDay() || 7)); // Thursday
        var time = jsDate.getTime();
        var MuhDate = this.toGregorian(new __WEBPACK_IMPORTED_MODULE_1__ngb_date__["a" /* NgbDate */](date.year, 1, 1)); // Compare with Muharram 1
        return Math.floor(Math.round((time - MuhDate.getTime()) / 86400000) / 7) + 1;
    };
    NgbCalendarIslamicCivil.prototype.getToday = function () { return this.fromGregorian(new Date()); };
    NgbCalendarIslamicCivil.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["Injectable"] },
    ];
    return NgbCalendarIslamicCivil;
}(__WEBPACK_IMPORTED_MODULE_0__ngb_calendar_hijri__["a" /* NgbCalendarHijri */]));

//# sourceMappingURL=ngb-calendar-islamic-civil.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/hijri/ngb-calendar-islamic-umalqura.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NgbCalendarIslamicUmalqura; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ngb_calendar_islamic_civil__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/hijri/ngb-calendar-islamic-civil.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ngb_calendar_hijri__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/hijri/ngb-calendar-hijri.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ngb_date__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/ngb-date.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




/**
 * Umalqura calendar is one type of Hijri calendars used in islamic countries.
 * This Calendar is used by Saudi Arabia for administrative purpose.
 * Unlike tabular calendars, the algorithm involves astronomical calculation, but it's still deterministic.
 * http://cldr.unicode.org/development/development-process/design-proposals/islamic-calendar-types
 */
var GREGORIAN_FIRST_DATE = new Date(1882, 10, 12);
var GREGORIAN_LAST_DATE = new Date(2174, 10, 25);
var HIJRI_BEGIN = 1300;
var HIJRI_END = 1600;
var ONE_DAY = 1000 * 60 * 60 * 24;
var ISLAMIC_CIVIL = new __WEBPACK_IMPORTED_MODULE_0__ngb_calendar_islamic_civil__["a" /* NgbCalendarIslamicCivil */]();
var MONTH_LENGTH = [
    '101010101010', '110101010100', '111011001001', '011011010100', '011011101010',
    '001101101100', '101010101101', '010101010101', '011010101001', '011110010010',
    '101110101001', '010111010100', '101011011010', '010101011100', '110100101101',
    '011010010101', '011101001010', '101101010100', '101101101010', '010110101101',
    '010010101110', '101001001111', '010100010111', '011010001011', '011010100101',
    '101011010101', '001011010110', '100101011011', '010010011101', '101001001101',
    '110100100110', '110110010101', '010110101100', '100110110110', '001010111010',
    '101001011011', '010100101011', '101010010101', '011011001010', '101011101001',
    '001011110100', '100101110110', '001010110110', '100101010110', '101011001010',
    '101110100100', '101111010010', '010111011001', '001011011100', '100101101101',
    '010101001101', '101010100101', '101101010010', '101110100101', '010110110100',
    '100110110110', '010101010111', '001010010111', '010101001011', '011010100011',
    '011101010010', '101101100101', '010101101010', '101010101011', '010100101011',
    '110010010101', '110101001010', '110110100101', '010111001010', '101011010110',
    '100101010111', '010010101011', '100101001011', '101010100101', '101101010010',
    '101101101010', '010101110101', '001001110110', '100010110111', '010001011011',
    '010101010101', '010110101001', '010110110100', '100111011010', '010011011101',
    '001001101110', '100100110110', '101010101010', '110101010100', '110110110010',
    '010111010101', '001011011010', '100101011011', '010010101011', '101001010101',
    '101101001001', '101101100100', '101101110001', '010110110100', '101010110101',
    '101001010101', '110100100101', '111010010010', '111011001001', '011011010100',
    '101011101001', '100101101011', '010010101011', '101010010011', '110101001001',
    '110110100100', '110110110010', '101010111001', '010010111010', '101001011011',
    '010100101011', '101010010101', '101100101010', '101101010101', '010101011100',
    '010010111101', '001000111101', '100100011101', '101010010101', '101101001010',
    '101101011010', '010101101101', '001010110110', '100100111011', '010010011011',
    '011001010101', '011010101001', '011101010100', '101101101010', '010101101100',
    '101010101101', '010101010101', '101100101001', '101110010010', '101110101001',
    '010111010100', '101011011010', '010101011010', '101010101011', '010110010101',
    '011101001001', '011101100100', '101110101010', '010110110101', '001010110110',
    '101001010110', '111001001101', '101100100101', '101101010010', '101101101010',
    '010110101101', '001010101110', '100100101111', '010010010111', '011001001011',
    '011010100101', '011010101100', '101011010110', '010101011101', '010010011101',
    '101001001101', '110100010110', '110110010101', '010110101010', '010110110101',
    '001011011010', '100101011011', '010010101101', '010110010101', '011011001010',
    '011011100100', '101011101010', '010011110101', '001010110110', '100101010110',
    '101010101010', '101101010100', '101111010010', '010111011001', '001011101010',
    '100101101101', '010010101101', '101010010101', '101101001010', '101110100101',
    '010110110010', '100110110101', '010011010110', '101010010111', '010101000111',
    '011010010011', '011101001001', '101101010101', '010101101010', '101001101011',
    '010100101011', '101010001011', '110101000110', '110110100011', '010111001010',
    '101011010110', '010011011011', '001001101011', '100101001011', '101010100101',
    '101101010010', '101101101001', '010101110101', '000101110110', '100010110111',
    '001001011011', '010100101011', '010101100101', '010110110100', '100111011010',
    '010011101101', '000101101101', '100010110110', '101010100110', '110101010010',
    '110110101001', '010111010100', '101011011010', '100101011011', '010010101011',
    '011001010011', '011100101001', '011101100010', '101110101001', '010110110010',
    '101010110101', '010101010101', '101100100101', '110110010010', '111011001001',
    '011011010010', '101011101001', '010101101011', '010010101011', '101001010101',
    '110100101001', '110101010100', '110110101010', '100110110101', '010010111010',
    '101000111011', '010010011011', '101001001101', '101010101010', '101011010101',
    '001011011010', '100101011101', '010001011110', '101000101110', '110010011010',
    '110101010101', '011010110010', '011010111001', '010010111010', '101001011101',
    '010100101101', '101010010101', '101101010010', '101110101000', '101110110100',
    '010110111001', '001011011010', '100101011010', '101101001010', '110110100100',
    '111011010001', '011011101000', '101101101010', '010101101101', '010100110101',
    '011010010101', '110101001010', '110110101000', '110111010100', '011011011010',
    '010101011011', '001010011101', '011000101011', '101100010101', '101101001010',
    '101110010101', '010110101010', '101010101110', '100100101110', '110010001111',
    '010100100111', '011010010101', '011010101010', '101011010110', '010101011101',
    '001010011101'
];
function getDaysDiff(date1, date2) {
    var diff = Math.abs(date1.getTime() - date2.getTime());
    return Math.round(diff / ONE_DAY);
}
var NgbCalendarIslamicUmalqura = /** @class */ (function (_super) {
    __extends(NgbCalendarIslamicUmalqura, _super);
    function NgbCalendarIslamicUmalqura() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
    * Returns the equivalent islamic(Umalqura) date value for a give input Gregorian date.
    * `gdate` is s JS Date to be converted to Hijri.
    */
    /**
      * Returns the equivalent islamic(Umalqura) date value for a give input Gregorian date.
      * `gdate` is s JS Date to be converted to Hijri.
      */
    NgbCalendarIslamicUmalqura.prototype.fromGregorian = /**
      * Returns the equivalent islamic(Umalqura) date value for a give input Gregorian date.
      * `gdate` is s JS Date to be converted to Hijri.
      */
    function (gDate) {
        var hDay = 1, hMonth = 0, hYear = 1300;
        var daysDiff = getDaysDiff(gDate, GREGORIAN_FIRST_DATE);
        if (gDate.getTime() - GREGORIAN_FIRST_DATE.getTime() >= 0 && gDate.getTime() - GREGORIAN_LAST_DATE.getTime() <= 0) {
            var year = 1300;
            for (var i = 0; i < MONTH_LENGTH.length; i++, year++) {
                for (var j = 0; j < 12; j++) {
                    var numOfDays = +MONTH_LENGTH[i][j] + 29;
                    if (daysDiff <= numOfDays) {
                        hDay = daysDiff + 1;
                        if (hDay > numOfDays) {
                            hDay = 1;
                            j++;
                        }
                        if (j > 11) {
                            j = 0;
                            year++;
                        }
                        hMonth = j;
                        hYear = year;
                        return new __WEBPACK_IMPORTED_MODULE_2__ngb_date__["a" /* NgbDate */](hYear, hMonth + 1, hDay);
                    }
                    daysDiff = daysDiff - numOfDays;
                }
            }
        }
        else {
            return ISLAMIC_CIVIL.fromGregorian(gDate);
        }
    };
    /**
    * Converts the current Hijri date to Gregorian.
    */
    /**
      * Converts the current Hijri date to Gregorian.
      */
    NgbCalendarIslamicUmalqura.prototype.toGregorian = /**
      * Converts the current Hijri date to Gregorian.
      */
    function (hijriDate) {
        var hYear = hijriDate.year;
        var hMonth = hijriDate.month - 1;
        var hDay = hijriDate.day;
        var gDate = new Date(GREGORIAN_FIRST_DATE);
        var dayDiff = hDay - 1;
        if (hYear >= HIJRI_BEGIN && hYear <= HIJRI_END) {
            for (var y = 0; y < hYear - HIJRI_BEGIN; y++) {
                for (var m = 0; m < 12; m++) {
                    dayDiff += +MONTH_LENGTH[y][m] + 29;
                }
            }
            for (var m = 0; m < hMonth; m++) {
                dayDiff += +MONTH_LENGTH[hYear - HIJRI_BEGIN][m] + 29;
            }
            gDate.setDate(GREGORIAN_FIRST_DATE.getDate() + dayDiff);
        }
        else {
            gDate = ISLAMIC_CIVIL.toGregorian(hijriDate);
        }
        return gDate;
    };
    /**
    * Returns the number of days in a specific Hijri month.
    * `month` is 1 for Muharram, 2 for Safar, etc.
    * `year` is any Hijri year.
    */
    /**
      * Returns the number of days in a specific Hijri month.
      * `month` is 1 for Muharram, 2 for Safar, etc.
      * `year` is any Hijri year.
      */
    NgbCalendarIslamicUmalqura.prototype.getDaysInIslamicMonth = /**
      * Returns the number of days in a specific Hijri month.
      * `month` is 1 for Muharram, 2 for Safar, etc.
      * `year` is any Hijri year.
      */
    function (month, year) {
        if (year >= HIJRI_BEGIN && year <= HIJRI_END) {
            var pos = year - HIJRI_BEGIN;
            return MONTH_LENGTH[pos].charAt(month - 1) === '1' ? 30 : 29;
        }
        return ISLAMIC_CIVIL.getDaysInIslamicMonth(month, year);
    };
    NgbCalendarIslamicUmalqura.prototype.getNext = function (date, period, number) {
        if (period === void 0) { period = 'd'; }
        if (number === void 0) { number = 1; }
        date = __WEBPACK_IMPORTED_MODULE_2__ngb_date__["a" /* NgbDate */].from(date);
        switch (period) {
            case 'y':
                date = this.setYear(date, date.year + number);
                date.month = 1;
                date.day = 1;
                return date;
            case 'm':
                date = this.setMonth(date, date.month + number);
                date.day = 1;
                return date;
            case 'd':
                return this.setDay(date, date.day + number);
            default:
                return date;
        }
    };
    NgbCalendarIslamicUmalqura.prototype.getPrev = function (date, period, number) {
        if (period === void 0) { period = 'd'; }
        if (number === void 0) { number = 1; }
        return this.getNext(date, period, -number);
    };
    NgbCalendarIslamicUmalqura.prototype.getWeekday = function (date) {
        var day = this.toGregorian(date).getDay();
        // in JS Date Sun=0, in ISO 8601 Sun=7
        return day === 0 ? 7 : day;
    };
    NgbCalendarIslamicUmalqura.prototype.getWeekNumber = function (week, firstDayOfWeek) {
        // in JS Date Sun=0, in ISO 8601 Sun=7
        if (firstDayOfWeek === 7) {
            firstDayOfWeek = 0;
        }
        var thursdayIndex = (4 + 7 - firstDayOfWeek) % 7;
        var date = week[thursdayIndex];
        var jsDate = this.toGregorian(date);
        jsDate.setDate(jsDate.getDate() + 4 - (jsDate.getDay() || 7)); // Thursday
        var time = jsDate.getTime();
        var MuhDate = this.toGregorian(new __WEBPACK_IMPORTED_MODULE_2__ngb_date__["a" /* NgbDate */](date.year, 1, 1)); // Compare with Muharram 1
        return Math.floor(Math.round((time - MuhDate.getTime()) / ONE_DAY) / 7) + 1;
    };
    NgbCalendarIslamicUmalqura.prototype.getToday = function () { return this.fromGregorian(new Date()); };
    NgbCalendarIslamicUmalqura.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_3__angular_core__["Injectable"] },
    ];
    return NgbCalendarIslamicUmalqura;
}(__WEBPACK_IMPORTED_MODULE_1__ngb_calendar_hijri__["a" /* NgbCalendarHijri */]));

//# sourceMappingURL=ngb-calendar-islamic-umalqura.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/ngb-calendar.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NgbCalendar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NgbCalendarGregorian; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ngb_date__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/ngb-date.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_util__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/util/util.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



function fromJSDate(jsDate) {
    return new __WEBPACK_IMPORTED_MODULE_0__ngb_date__["a" /* NgbDate */](jsDate.getFullYear(), jsDate.getMonth() + 1, jsDate.getDate());
}
function toJSDate(date) {
    var jsDate = new Date(date.year, date.month - 1, date.day, 12);
    // this is done avoid 30 -> 1930 conversion
    if (!isNaN(jsDate.getTime())) {
        jsDate.setFullYear(date.year);
    }
    return jsDate;
}
var NgbCalendar = /** @class */ (function () {
    function NgbCalendar() {
    }
    NgbCalendar.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"] },
    ];
    return NgbCalendar;
}());

var NgbCalendarGregorian = /** @class */ (function (_super) {
    __extends(NgbCalendarGregorian, _super);
    function NgbCalendarGregorian() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NgbCalendarGregorian.prototype.getDaysPerWeek = function () { return 7; };
    NgbCalendarGregorian.prototype.getMonths = function () { return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]; };
    NgbCalendarGregorian.prototype.getWeeksPerMonth = function () { return 6; };
    NgbCalendarGregorian.prototype.getNext = function (date, period, number) {
        if (period === void 0) { period = 'd'; }
        if (number === void 0) { number = 1; }
        var jsDate = toJSDate(date);
        switch (period) {
            case 'y':
                return new __WEBPACK_IMPORTED_MODULE_0__ngb_date__["a" /* NgbDate */](date.year + number, 1, 1);
            case 'm':
                jsDate = new Date(date.year, date.month + number - 1, 1, 12);
                break;
            case 'd':
                jsDate.setDate(jsDate.getDate() + number);
                break;
            default:
                return date;
        }
        return fromJSDate(jsDate);
    };
    NgbCalendarGregorian.prototype.getPrev = function (date, period, number) {
        if (period === void 0) { period = 'd'; }
        if (number === void 0) { number = 1; }
        return this.getNext(date, period, -number);
    };
    NgbCalendarGregorian.prototype.getWeekday = function (date) {
        var jsDate = toJSDate(date);
        var day = jsDate.getDay();
        // in JS Date Sun=0, in ISO 8601 Sun=7
        return day === 0 ? 7 : day;
    };
    NgbCalendarGregorian.prototype.getWeekNumber = function (week, firstDayOfWeek) {
        // in JS Date Sun=0, in ISO 8601 Sun=7
        if (firstDayOfWeek === 7) {
            firstDayOfWeek = 0;
        }
        var thursdayIndex = (4 + 7 - firstDayOfWeek) % 7;
        var date = week[thursdayIndex];
        var jsDate = toJSDate(date);
        jsDate.setDate(jsDate.getDate() + 4 - (jsDate.getDay() || 7)); // Thursday
        var time = jsDate.getTime();
        jsDate.setMonth(0); // Compare with Jan 1
        jsDate.setDate(1);
        return Math.floor(Math.round((time - jsDate.getTime()) / 86400000) / 7) + 1;
    };
    NgbCalendarGregorian.prototype.getToday = function () { return fromJSDate(new Date()); };
    NgbCalendarGregorian.prototype.isValid = function (date) {
        if (!date || !Object(__WEBPACK_IMPORTED_MODULE_2__util_util__["c" /* isInteger */])(date.year) || !Object(__WEBPACK_IMPORTED_MODULE_2__util_util__["c" /* isInteger */])(date.month) || !Object(__WEBPACK_IMPORTED_MODULE_2__util_util__["c" /* isInteger */])(date.day)) {
            return false;
        }
        var jsDate = toJSDate(date);
        return !isNaN(jsDate.getTime()) && jsDate.getFullYear() === date.year && jsDate.getMonth() + 1 === date.month &&
            jsDate.getDate() === date.day;
    };
    NgbCalendarGregorian.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"] },
    ];
    return NgbCalendarGregorian;
}(NgbCalendar));

//# sourceMappingURL=ngb-calendar.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/ngb-date-adapter.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NgbDateAdapter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NgbDateStructAdapter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

/**
 * Abstract type serving as a DI token for the service converting from your application Date model to internal
 * NgbDateStruct model.
 * A default implementation converting from and to NgbDateStruct is provided for retro-compatibility,
 * but you can provide another implementation to use an alternative format, ie for using with native Date Object.
 */
var NgbDateAdapter = /** @class */ (function () {
    function NgbDateAdapter() {
    }
    NgbDateAdapter.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    return NgbDateAdapter;
}());

var NgbDateStructAdapter = /** @class */ (function (_super) {
    __extends(NgbDateStructAdapter, _super);
    function NgbDateStructAdapter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Converts a NgbDateStruct value into NgbDateStruct value
     * @param  {NgbDateStruct} value
     * @return {NgbDateStruct}
     */
    /**
       * Converts a NgbDateStruct value into NgbDateStruct value
       * @param  {NgbDateStruct} value
       * @return {NgbDateStruct}
       */
    NgbDateStructAdapter.prototype.fromModel = /**
       * Converts a NgbDateStruct value into NgbDateStruct value
       * @param  {NgbDateStruct} value
       * @return {NgbDateStruct}
       */
    function (date) {
        return (date && date.year && date.month && date.day) ? { year: date.year, month: date.month, day: date.day } : null;
    };
    /**
     * Converts a NgbDateStruct value into NgbDateStruct value
     * @param  {NgbDateStruct} value
     * @return {NgbDateStruct}
     */
    /**
       * Converts a NgbDateStruct value into NgbDateStruct value
       * @param  {NgbDateStruct} value
       * @return {NgbDateStruct}
       */
    NgbDateStructAdapter.prototype.toModel = /**
       * Converts a NgbDateStruct value into NgbDateStruct value
       * @param  {NgbDateStruct} value
       * @return {NgbDateStruct}
       */
    function (date) {
        return (date && date.year && date.month && date.day) ? { year: date.year, month: date.month, day: date.day } : null;
    };
    NgbDateStructAdapter.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    return NgbDateStructAdapter;
}(NgbDateAdapter));

//# sourceMappingURL=ngb-date-adapter.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/ngb-date-parser-formatter.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NgbDateParserFormatter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NgbDateISOParserFormatter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_util__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/util/util.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

/**
 * Abstract type serving as a DI token for the service parsing and formatting dates for the NgbInputDatepicker
 * directive. A default implementation using the ISO 8601 format is provided, but you can provide another implementation
 * to use an alternative format.
 */
var /**
 * Abstract type serving as a DI token for the service parsing and formatting dates for the NgbInputDatepicker
 * directive. A default implementation using the ISO 8601 format is provided, but you can provide another implementation
 * to use an alternative format.
 */
NgbDateParserFormatter = /** @class */ (function () {
    function NgbDateParserFormatter() {
    }
    return NgbDateParserFormatter;
}());
/**
 * Abstract type serving as a DI token for the service parsing and formatting dates for the NgbInputDatepicker
 * directive. A default implementation using the ISO 8601 format is provided, but you can provide another implementation
 * to use an alternative format.
 */

var NgbDateISOParserFormatter = /** @class */ (function (_super) {
    __extends(NgbDateISOParserFormatter, _super);
    function NgbDateISOParserFormatter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NgbDateISOParserFormatter.prototype.parse = function (value) {
        if (value) {
            var dateParts = value.trim().split('-');
            if (dateParts.length === 1 && Object(__WEBPACK_IMPORTED_MODULE_0__util_util__["d" /* isNumber */])(dateParts[0])) {
                return { year: Object(__WEBPACK_IMPORTED_MODULE_0__util_util__["h" /* toInteger */])(dateParts[0]), month: null, day: null };
            }
            else if (dateParts.length === 2 && Object(__WEBPACK_IMPORTED_MODULE_0__util_util__["d" /* isNumber */])(dateParts[0]) && Object(__WEBPACK_IMPORTED_MODULE_0__util_util__["d" /* isNumber */])(dateParts[1])) {
                return { year: Object(__WEBPACK_IMPORTED_MODULE_0__util_util__["h" /* toInteger */])(dateParts[0]), month: Object(__WEBPACK_IMPORTED_MODULE_0__util_util__["h" /* toInteger */])(dateParts[1]), day: null };
            }
            else if (dateParts.length === 3 && Object(__WEBPACK_IMPORTED_MODULE_0__util_util__["d" /* isNumber */])(dateParts[0]) && Object(__WEBPACK_IMPORTED_MODULE_0__util_util__["d" /* isNumber */])(dateParts[1]) && Object(__WEBPACK_IMPORTED_MODULE_0__util_util__["d" /* isNumber */])(dateParts[2])) {
                return { year: Object(__WEBPACK_IMPORTED_MODULE_0__util_util__["h" /* toInteger */])(dateParts[0]), month: Object(__WEBPACK_IMPORTED_MODULE_0__util_util__["h" /* toInteger */])(dateParts[1]), day: Object(__WEBPACK_IMPORTED_MODULE_0__util_util__["h" /* toInteger */])(dateParts[2]) };
            }
        }
        return null;
    };
    NgbDateISOParserFormatter.prototype.format = function (date) {
        return date ?
            date.year + "-" + (Object(__WEBPACK_IMPORTED_MODULE_0__util_util__["d" /* isNumber */])(date.month) ? Object(__WEBPACK_IMPORTED_MODULE_0__util_util__["f" /* padNumber */])(date.month) : '') + "-" + (Object(__WEBPACK_IMPORTED_MODULE_0__util_util__["d" /* isNumber */])(date.day) ? Object(__WEBPACK_IMPORTED_MODULE_0__util_util__["f" /* padNumber */])(date.day) : '') :
            '';
    };
    return NgbDateISOParserFormatter;
}(NgbDateParserFormatter));

//# sourceMappingURL=ngb-date-parser-formatter.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/ngb-date.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NgbDate; });
var NgbDate = /** @class */ (function () {
    function NgbDate(year, month, day) {
        this.year = year;
        this.month = month;
        this.day = day;
    }
    NgbDate.from = function (date) {
        return date ? new NgbDate(date.year, date.month, date.day ? date.day : 1) : null;
    };
    NgbDate.prototype.equals = function (other) {
        return other && this.year === other.year && this.month === other.month && this.day === other.day;
    };
    NgbDate.prototype.before = function (other) {
        if (!other) {
            return false;
        }
        if (this.year === other.year) {
            if (this.month === other.month) {
                return this.day === other.day ? false : this.day < other.day;
            }
            else {
                return this.month < other.month;
            }
        }
        else {
            return this.year < other.year;
        }
    };
    NgbDate.prototype.after = function (other) {
        if (!other) {
            return false;
        }
        if (this.year === other.year) {
            if (this.month === other.month) {
                return this.day === other.day ? false : this.day > other.day;
            }
            else {
                return this.month > other.month;
            }
        }
        else {
            return this.year > other.year;
        }
    };
    NgbDate.prototype.toStruct = function () { return { year: this.year, month: this.month, day: this.day }; };
    NgbDate.prototype.toString = function () { return this.year + "-" + this.month + "-" + this.day; };
    return NgbDate;
}());

//# sourceMappingURL=ngb-date.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/dropdown/dropdown-config.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NgbDropdownConfig; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");

/**
 * Configuration service for the NgbDropdown directive.
 * You can inject this service, typically in your root component, and customize the values of its properties in
 * order to provide default values for all the dropdowns used in the application.
 */
var NgbDropdownConfig = /** @class */ (function () {
    function NgbDropdownConfig() {
        this.autoClose = true;
        this.placement = 'bottom-left';
    }
    NgbDropdownConfig.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    return NgbDropdownConfig;
}());

//# sourceMappingURL=dropdown-config.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/dropdown/dropdown.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return NgbDropdownMenu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NgbDropdownAnchor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return NgbDropdownToggle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NgbDropdown; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dropdown_config__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/dropdown/dropdown-config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_positioning__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/util/positioning.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



/**
 */
var NgbDropdownMenu = /** @class */ (function () {
    function NgbDropdownMenu(dropdown, _elementRef, _renderer) {
        this.dropdown = dropdown;
        this._elementRef = _elementRef;
        this._renderer = _renderer;
        this.placement = 'bottom';
        this.isOpen = false;
    }
    NgbDropdownMenu.prototype.isEventFrom = function ($event) { return this._elementRef.nativeElement.contains($event.target); };
    NgbDropdownMenu.prototype.position = function (triggerEl, placement) {
        this.applyPlacement(Object(__WEBPACK_IMPORTED_MODULE_2__util_positioning__["a" /* positionElements */])(triggerEl, this._elementRef.nativeElement, placement));
    };
    NgbDropdownMenu.prototype.applyPlacement = function (_placement) {
        // remove the current placement classes
        this._renderer.removeClass(this._elementRef.nativeElement.parentNode, 'dropup');
        this._renderer.removeClass(this._elementRef.nativeElement.parentNode, 'dropdown');
        this.placement = _placement;
        /**
             * apply the new placement
             * in case of top use up-arrow or down-arrow otherwise
             */
        if (_placement.search('^top') !== -1) {
            this._renderer.addClass(this._elementRef.nativeElement.parentNode, 'dropup');
        }
        else {
            this._renderer.addClass(this._elementRef.nativeElement.parentNode, 'dropdown');
        }
    };
    NgbDropdownMenu.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: '[ngbDropdownMenu]',
                    host: { '[class.dropdown-menu]': 'true', '[class.show]': 'dropdown.isOpen()', '[attr.x-placement]': 'placement' }
                },] },
    ];
    /** @nocollapse */
    NgbDropdownMenu.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return NgbDropdown; }),] },] },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"], },
    ]; };
    return NgbDropdownMenu;
}());

/**
 * Marks an element to which dropdown menu will be anchored. This is a simple version
 * of the NgbDropdownToggle directive. It plays the same role as NgbDropdownToggle but
 * doesn't listen to click events to toggle dropdown menu thus enabling support for
 * events other than click.
 *
 * @since 1.1.0
 */
var NgbDropdownAnchor = /** @class */ (function () {
    function NgbDropdownAnchor(dropdown, _elementRef) {
        this.dropdown = dropdown;
        this._elementRef = _elementRef;
        this.anchorEl = _elementRef.nativeElement;
    }
    NgbDropdownAnchor.prototype.isEventFrom = function ($event) { return this._elementRef.nativeElement.contains($event.target); };
    NgbDropdownAnchor.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: '[ngbDropdownAnchor]',
                    host: { 'class': 'dropdown-toggle', 'aria-haspopup': 'true', '[attr.aria-expanded]': 'dropdown.isOpen()' }
                },] },
    ];
    /** @nocollapse */
    NgbDropdownAnchor.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return NgbDropdown; }),] },] },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    ]; };
    return NgbDropdownAnchor;
}());

/**
 * Allows the dropdown to be toggled via click. This directive is optional: you can use NgbDropdownAnchor as an
 * alternative.
 */
var NgbDropdownToggle = /** @class */ (function (_super) {
    __extends(NgbDropdownToggle, _super);
    function NgbDropdownToggle(dropdown, elementRef) {
        return _super.call(this, dropdown, elementRef) || this;
    }
    NgbDropdownToggle.prototype.toggleOpen = function () { this.dropdown.toggle(); };
    NgbDropdownToggle.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: '[ngbDropdownToggle]',
                    host: {
                        'class': 'dropdown-toggle',
                        'aria-haspopup': 'true',
                        '[attr.aria-expanded]': 'dropdown.isOpen()',
                        '(click)': 'toggleOpen()'
                    },
                    providers: [{ provide: NgbDropdownAnchor, useExisting: Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return NgbDropdownToggle; }) }]
                },] },
    ];
    /** @nocollapse */
    NgbDropdownToggle.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return NgbDropdown; }),] },] },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    ]; };
    return NgbDropdownToggle;
}(NgbDropdownAnchor));

/**
 * Transforms a node into a dropdown.
 */
var NgbDropdown = /** @class */ (function () {
    function NgbDropdown(config, ngZone) {
        var _this = this;
        /**
           *  Defines whether or not the dropdown-menu is open initially.
           */
        this._open = false;
        /**
           *  An event fired when the dropdown is opened or closed.
           *  Event's payload equals whether dropdown is open.
           */
        this.openChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.placement = config.placement;
        this.autoClose = config.autoClose;
        this._zoneSubscription = ngZone.onStable.subscribe(function () { _this._positionMenu(); });
    }
    NgbDropdown.prototype.ngOnInit = function () {
        if (this._menu) {
            this._menu.applyPlacement(Array.isArray(this.placement) ? (this.placement[0]) : this.placement);
        }
    };
    /**
     * Checks if the dropdown menu is open or not.
     */
    /**
       * Checks if the dropdown menu is open or not.
       */
    NgbDropdown.prototype.isOpen = /**
       * Checks if the dropdown menu is open or not.
       */
    function () { return this._open; };
    /**
     * Opens the dropdown menu of a given navbar or tabbed navigation.
     */
    /**
       * Opens the dropdown menu of a given navbar or tabbed navigation.
       */
    NgbDropdown.prototype.open = /**
       * Opens the dropdown menu of a given navbar or tabbed navigation.
       */
    function () {
        if (!this._open) {
            this._open = true;
            this._positionMenu();
            this.openChange.emit(true);
        }
    };
    /**
     * Closes the dropdown menu of a given navbar or tabbed navigation.
     */
    /**
       * Closes the dropdown menu of a given navbar or tabbed navigation.
       */
    NgbDropdown.prototype.close = /**
       * Closes the dropdown menu of a given navbar or tabbed navigation.
       */
    function () {
        if (this._open) {
            this._open = false;
            this.openChange.emit(false);
        }
    };
    /**
     * Toggles the dropdown menu of a given navbar or tabbed navigation.
     */
    /**
       * Toggles the dropdown menu of a given navbar or tabbed navigation.
       */
    NgbDropdown.prototype.toggle = /**
       * Toggles the dropdown menu of a given navbar or tabbed navigation.
       */
    function () {
        if (this.isOpen()) {
            this.close();
        }
        else {
            this.open();
        }
    };
    NgbDropdown.prototype.closeFromClick = function ($event) {
        if (this.autoClose && $event.button !== 2 && !this._isEventFromToggle($event)) {
            if (this.autoClose === true) {
                this.close();
            }
            else if (this.autoClose === 'inside' && this._isEventFromMenu($event)) {
                this.close();
            }
            else if (this.autoClose === 'outside' && !this._isEventFromMenu($event)) {
                this.close();
            }
        }
    };
    NgbDropdown.prototype.closeFromOutsideEsc = function () {
        if (this.autoClose) {
            this.close();
        }
    };
    NgbDropdown.prototype.ngOnDestroy = function () { this._zoneSubscription.unsubscribe(); };
    NgbDropdown.prototype._isEventFromToggle = function ($event) { return this._anchor.isEventFrom($event); };
    NgbDropdown.prototype._isEventFromMenu = function ($event) { return this._menu ? this._menu.isEventFrom($event) : false; };
    NgbDropdown.prototype._positionMenu = function () {
        if (this.isOpen() && this._menu) {
            this._menu.position(this._anchor.anchorEl, this.placement);
        }
    };
    NgbDropdown.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: '[ngbDropdown]',
                    exportAs: 'ngbDropdown',
                    host: {
                        '[class.show]': 'isOpen()',
                        '(keyup.esc)': 'closeFromOutsideEsc()',
                        '(document:click)': 'closeFromClick($event)'
                    }
                },] },
    ];
    /** @nocollapse */
    NgbDropdown.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__dropdown_config__["a" /* NgbDropdownConfig */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"], },
    ]; };
    NgbDropdown.propDecorators = {
        "_menu": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChild"], args: [NgbDropdownMenu,] },],
        "_anchor": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChild"], args: [NgbDropdownAnchor,] },],
        "autoClose": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "_open": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['open',] },],
        "placement": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "openChange": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    };
    return NgbDropdown;
}());

//# sourceMappingURL=dropdown.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/dropdown/dropdown.module.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return NgbDropdownModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dropdown__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/dropdown/dropdown.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dropdown_config__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/dropdown/dropdown-config.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__dropdown__["a"]; });
/* unused harmony reexport NgbDropdownToggle */
/* unused harmony reexport NgbDropdownMenu */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__dropdown_config__["a"]; });





var NGB_DROPDOWN_DIRECTIVES = [__WEBPACK_IMPORTED_MODULE_1__dropdown__["a" /* NgbDropdown */], __WEBPACK_IMPORTED_MODULE_1__dropdown__["b" /* NgbDropdownAnchor */], __WEBPACK_IMPORTED_MODULE_1__dropdown__["d" /* NgbDropdownToggle */], __WEBPACK_IMPORTED_MODULE_1__dropdown__["c" /* NgbDropdownMenu */]];
var NgbDropdownModule = /** @class */ (function () {
    function NgbDropdownModule() {
    }
    NgbDropdownModule.forRoot = function () { return { ngModule: NgbDropdownModule, providers: [__WEBPACK_IMPORTED_MODULE_2__dropdown_config__["a" /* NgbDropdownConfig */]] }; };
    NgbDropdownModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{ declarations: NGB_DROPDOWN_DIRECTIVES, exports: NGB_DROPDOWN_DIRECTIVES },] },
    ];
    return NgbDropdownModule;
}());

//# sourceMappingURL=dropdown.module.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgbRootModule", function() { return NgbRootModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgbModule", function() { return NgbModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accordion_accordion_module__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/accordion/accordion.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__alert_alert_module__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/alert/alert.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__buttons_buttons_module__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/buttons/buttons.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__carousel_carousel_module__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/carousel/carousel.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__collapse_collapse_module__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/collapse/collapse.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__datepicker_datepicker_module__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/datepicker.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dropdown_dropdown_module__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/dropdown/dropdown.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modal_modal_module__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/modal/modal.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pagination_pagination_module__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/pagination/pagination.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__popover_popover_module__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/popover/popover.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__progressbar_progressbar_module__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/progressbar/progressbar.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__rating_rating_module__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/rating/rating.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__tabset_tabset_module__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/tabset/tabset.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__timepicker_timepicker_module__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/timepicker/timepicker.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__tooltip_tooltip_module__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/tooltip/tooltip.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__typeahead_typeahead_module__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/typeahead/typeahead.module.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbAccordionModule", function() { return __WEBPACK_IMPORTED_MODULE_1__accordion_accordion_module__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbAccordionConfig", function() { return __WEBPACK_IMPORTED_MODULE_1__accordion_accordion_module__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbAccordion", function() { return __WEBPACK_IMPORTED_MODULE_1__accordion_accordion_module__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbPanel", function() { return __WEBPACK_IMPORTED_MODULE_1__accordion_accordion_module__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbPanelTitle", function() { return __WEBPACK_IMPORTED_MODULE_1__accordion_accordion_module__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbPanelContent", function() { return __WEBPACK_IMPORTED_MODULE_1__accordion_accordion_module__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbAlertModule", function() { return __WEBPACK_IMPORTED_MODULE_2__alert_alert_module__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbAlertConfig", function() { return __WEBPACK_IMPORTED_MODULE_2__alert_alert_module__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbAlert", function() { return __WEBPACK_IMPORTED_MODULE_2__alert_alert_module__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbButtonsModule", function() { return __WEBPACK_IMPORTED_MODULE_3__buttons_buttons_module__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbCheckBox", function() { return __WEBPACK_IMPORTED_MODULE_3__buttons_buttons_module__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbRadioGroup", function() { return __WEBPACK_IMPORTED_MODULE_3__buttons_buttons_module__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbCarouselModule", function() { return __WEBPACK_IMPORTED_MODULE_4__carousel_carousel_module__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbCarouselConfig", function() { return __WEBPACK_IMPORTED_MODULE_4__carousel_carousel_module__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbCarousel", function() { return __WEBPACK_IMPORTED_MODULE_4__carousel_carousel_module__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbSlide", function() { return __WEBPACK_IMPORTED_MODULE_4__carousel_carousel_module__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbCollapseModule", function() { return __WEBPACK_IMPORTED_MODULE_5__collapse_collapse_module__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbCollapse", function() { return __WEBPACK_IMPORTED_MODULE_5__collapse_collapse_module__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbCalendar", function() { return __WEBPACK_IMPORTED_MODULE_6__datepicker_datepicker_module__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbCalendarIslamicCivil", function() { return __WEBPACK_IMPORTED_MODULE_6__datepicker_datepicker_module__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbCalendarIslamicUmalqura", function() { return __WEBPACK_IMPORTED_MODULE_6__datepicker_datepicker_module__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbDatepickerModule", function() { return __WEBPACK_IMPORTED_MODULE_6__datepicker_datepicker_module__["i"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbDatepickerI18n", function() { return __WEBPACK_IMPORTED_MODULE_6__datepicker_datepicker_module__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbDatepickerConfig", function() { return __WEBPACK_IMPORTED_MODULE_6__datepicker_datepicker_module__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbDateParserFormatter", function() { return __WEBPACK_IMPORTED_MODULE_6__datepicker_datepicker_module__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbDateAdapter", function() { return __WEBPACK_IMPORTED_MODULE_6__datepicker_datepicker_module__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbDatepicker", function() { return __WEBPACK_IMPORTED_MODULE_6__datepicker_datepicker_module__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbInputDatepicker", function() { return __WEBPACK_IMPORTED_MODULE_6__datepicker_datepicker_module__["j"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbDropdownModule", function() { return __WEBPACK_IMPORTED_MODULE_7__dropdown_dropdown_module__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbDropdownConfig", function() { return __WEBPACK_IMPORTED_MODULE_7__dropdown_dropdown_module__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbDropdown", function() { return __WEBPACK_IMPORTED_MODULE_7__dropdown_dropdown_module__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbModalModule", function() { return __WEBPACK_IMPORTED_MODULE_8__modal_modal_module__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbModal", function() { return __WEBPACK_IMPORTED_MODULE_8__modal_modal_module__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbActiveModal", function() { return __WEBPACK_IMPORTED_MODULE_8__modal_modal_module__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbModalRef", function() { return __WEBPACK_IMPORTED_MODULE_8__modal_modal_module__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ModalDismissReasons", function() { return __WEBPACK_IMPORTED_MODULE_8__modal_modal_module__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbPaginationModule", function() { return __WEBPACK_IMPORTED_MODULE_9__pagination_pagination_module__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbPaginationConfig", function() { return __WEBPACK_IMPORTED_MODULE_9__pagination_pagination_module__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbPagination", function() { return __WEBPACK_IMPORTED_MODULE_9__pagination_pagination_module__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbPopoverModule", function() { return __WEBPACK_IMPORTED_MODULE_10__popover_popover_module__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbPopoverConfig", function() { return __WEBPACK_IMPORTED_MODULE_10__popover_popover_module__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbPopover", function() { return __WEBPACK_IMPORTED_MODULE_10__popover_popover_module__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbProgressbarModule", function() { return __WEBPACK_IMPORTED_MODULE_11__progressbar_progressbar_module__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbProgressbarConfig", function() { return __WEBPACK_IMPORTED_MODULE_11__progressbar_progressbar_module__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbProgressbar", function() { return __WEBPACK_IMPORTED_MODULE_11__progressbar_progressbar_module__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbRatingModule", function() { return __WEBPACK_IMPORTED_MODULE_12__rating_rating_module__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbRatingConfig", function() { return __WEBPACK_IMPORTED_MODULE_12__rating_rating_module__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbRating", function() { return __WEBPACK_IMPORTED_MODULE_12__rating_rating_module__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbTabsetModule", function() { return __WEBPACK_IMPORTED_MODULE_13__tabset_tabset_module__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbTabsetConfig", function() { return __WEBPACK_IMPORTED_MODULE_13__tabset_tabset_module__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbTabset", function() { return __WEBPACK_IMPORTED_MODULE_13__tabset_tabset_module__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbTab", function() { return __WEBPACK_IMPORTED_MODULE_13__tabset_tabset_module__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbTabContent", function() { return __WEBPACK_IMPORTED_MODULE_13__tabset_tabset_module__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbTabTitle", function() { return __WEBPACK_IMPORTED_MODULE_13__tabset_tabset_module__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbTimepickerModule", function() { return __WEBPACK_IMPORTED_MODULE_14__timepicker_timepicker_module__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbTimepickerConfig", function() { return __WEBPACK_IMPORTED_MODULE_14__timepicker_timepicker_module__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbTimepicker", function() { return __WEBPACK_IMPORTED_MODULE_14__timepicker_timepicker_module__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbTooltipModule", function() { return __WEBPACK_IMPORTED_MODULE_15__tooltip_tooltip_module__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbTooltipConfig", function() { return __WEBPACK_IMPORTED_MODULE_15__tooltip_tooltip_module__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbTooltip", function() { return __WEBPACK_IMPORTED_MODULE_15__tooltip_tooltip_module__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbHighlight", function() { return __WEBPACK_IMPORTED_MODULE_16__typeahead_typeahead_module__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbTypeaheadModule", function() { return __WEBPACK_IMPORTED_MODULE_16__typeahead_typeahead_module__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbTypeaheadConfig", function() { return __WEBPACK_IMPORTED_MODULE_16__typeahead_typeahead_module__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgbTypeahead", function() { return __WEBPACK_IMPORTED_MODULE_16__typeahead_typeahead_module__["b"]; });

































var NGB_MODULES = [
    __WEBPACK_IMPORTED_MODULE_1__accordion_accordion_module__["c" /* NgbAccordionModule */], __WEBPACK_IMPORTED_MODULE_2__alert_alert_module__["c" /* NgbAlertModule */], __WEBPACK_IMPORTED_MODULE_3__buttons_buttons_module__["a" /* NgbButtonsModule */], __WEBPACK_IMPORTED_MODULE_4__carousel_carousel_module__["c" /* NgbCarouselModule */], __WEBPACK_IMPORTED_MODULE_5__collapse_collapse_module__["b" /* NgbCollapseModule */], __WEBPACK_IMPORTED_MODULE_6__datepicker_datepicker_module__["i" /* NgbDatepickerModule */],
    __WEBPACK_IMPORTED_MODULE_7__dropdown_dropdown_module__["c" /* NgbDropdownModule */], __WEBPACK_IMPORTED_MODULE_8__modal_modal_module__["d" /* NgbModalModule */], __WEBPACK_IMPORTED_MODULE_9__pagination_pagination_module__["c" /* NgbPaginationModule */], __WEBPACK_IMPORTED_MODULE_10__popover_popover_module__["c" /* NgbPopoverModule */], __WEBPACK_IMPORTED_MODULE_11__progressbar_progressbar_module__["c" /* NgbProgressbarModule */], __WEBPACK_IMPORTED_MODULE_12__rating_rating_module__["c" /* NgbRatingModule */],
    __WEBPACK_IMPORTED_MODULE_13__tabset_tabset_module__["f" /* NgbTabsetModule */], __WEBPACK_IMPORTED_MODULE_14__timepicker_timepicker_module__["c" /* NgbTimepickerModule */], __WEBPACK_IMPORTED_MODULE_15__tooltip_tooltip_module__["c" /* NgbTooltipModule */], __WEBPACK_IMPORTED_MODULE_16__typeahead_typeahead_module__["d" /* NgbTypeaheadModule */]
];
var NgbRootModule = /** @class */ (function () {
    function NgbRootModule() {
    }
    NgbRootModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                    imports: [
                        __WEBPACK_IMPORTED_MODULE_2__alert_alert_module__["c" /* NgbAlertModule */].forRoot(), __WEBPACK_IMPORTED_MODULE_3__buttons_buttons_module__["a" /* NgbButtonsModule */].forRoot(), __WEBPACK_IMPORTED_MODULE_5__collapse_collapse_module__["b" /* NgbCollapseModule */].forRoot(), __WEBPACK_IMPORTED_MODULE_11__progressbar_progressbar_module__["c" /* NgbProgressbarModule */].forRoot(),
                        __WEBPACK_IMPORTED_MODULE_15__tooltip_tooltip_module__["c" /* NgbTooltipModule */].forRoot(), __WEBPACK_IMPORTED_MODULE_16__typeahead_typeahead_module__["d" /* NgbTypeaheadModule */].forRoot(), __WEBPACK_IMPORTED_MODULE_1__accordion_accordion_module__["c" /* NgbAccordionModule */].forRoot(), __WEBPACK_IMPORTED_MODULE_4__carousel_carousel_module__["c" /* NgbCarouselModule */].forRoot(),
                        __WEBPACK_IMPORTED_MODULE_6__datepicker_datepicker_module__["i" /* NgbDatepickerModule */].forRoot(), __WEBPACK_IMPORTED_MODULE_7__dropdown_dropdown_module__["c" /* NgbDropdownModule */].forRoot(), __WEBPACK_IMPORTED_MODULE_8__modal_modal_module__["d" /* NgbModalModule */].forRoot(), __WEBPACK_IMPORTED_MODULE_9__pagination_pagination_module__["c" /* NgbPaginationModule */].forRoot(),
                        __WEBPACK_IMPORTED_MODULE_10__popover_popover_module__["c" /* NgbPopoverModule */].forRoot(), __WEBPACK_IMPORTED_MODULE_11__progressbar_progressbar_module__["c" /* NgbProgressbarModule */].forRoot(), __WEBPACK_IMPORTED_MODULE_12__rating_rating_module__["c" /* NgbRatingModule */].forRoot(), __WEBPACK_IMPORTED_MODULE_13__tabset_tabset_module__["f" /* NgbTabsetModule */].forRoot(),
                        __WEBPACK_IMPORTED_MODULE_14__timepicker_timepicker_module__["c" /* NgbTimepickerModule */].forRoot(), __WEBPACK_IMPORTED_MODULE_15__tooltip_tooltip_module__["c" /* NgbTooltipModule */].forRoot()
                    ],
                    exports: NGB_MODULES
                },] },
    ];
    return NgbRootModule;
}());

var NgbModule = /** @class */ (function () {
    function NgbModule() {
    }
    NgbModule.forRoot = function () { return { ngModule: NgbRootModule }; };
    NgbModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{ imports: NGB_MODULES, exports: NGB_MODULES },] },
    ];
    return NgbModule;
}());

//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/modal/modal-backdrop.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NgbModalBackdrop; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");

var NgbModalBackdrop = /** @class */ (function () {
    function NgbModalBackdrop() {
    }
    NgbModalBackdrop.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'ngb-modal-backdrop',
                    template: '',
                    host: { '[class]': '"modal-backdrop fade show" + (backdropClass ? " " + backdropClass : "")' }
                },] },
    ];
    /** @nocollapse */
    NgbModalBackdrop.propDecorators = {
        "backdropClass": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return NgbModalBackdrop;
}());

//# sourceMappingURL=modal-backdrop.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/modal/modal-dismiss-reasons.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModalDismissReasons; });
var ModalDismissReasons;
(function (ModalDismissReasons) {
    ModalDismissReasons[ModalDismissReasons["BACKDROP_CLICK"] = 0] = "BACKDROP_CLICK";
    ModalDismissReasons[ModalDismissReasons["ESC"] = 1] = "ESC";
})(ModalDismissReasons || (ModalDismissReasons = {}));
//# sourceMappingURL=modal-dismiss-reasons.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/modal/modal-ref.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NgbActiveModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NgbModalRef; });
/**
 * A reference to an active (currently opened) modal. Instances of this class
 * can be injected into components passed as modal content.
 */
var /**
 * A reference to an active (currently opened) modal. Instances of this class
 * can be injected into components passed as modal content.
 */
NgbActiveModal = /** @class */ (function () {
    function NgbActiveModal() {
    }
    /**
     * Can be used to close a modal, passing an optional result.
     */
    /**
       * Can be used to close a modal, passing an optional result.
       */
    NgbActiveModal.prototype.close = /**
       * Can be used to close a modal, passing an optional result.
       */
    function (result) { };
    /**
     * Can be used to dismiss a modal, passing an optional reason.
     */
    /**
       * Can be used to dismiss a modal, passing an optional reason.
       */
    NgbActiveModal.prototype.dismiss = /**
       * Can be used to dismiss a modal, passing an optional reason.
       */
    function (reason) { };
    return NgbActiveModal;
}());
/**
 * A reference to an active (currently opened) modal. Instances of this class
 * can be injected into components passed as modal content.
 */

/**
 * A reference to a newly opened modal.
 */
var /**
 * A reference to a newly opened modal.
 */
NgbModalRef = /** @class */ (function () {
    function NgbModalRef(_windowCmptRef, _contentRef, _backdropCmptRef, _beforeDismiss) {
        var _this = this;
        this._windowCmptRef = _windowCmptRef;
        this._contentRef = _contentRef;
        this._backdropCmptRef = _backdropCmptRef;
        this._beforeDismiss = _beforeDismiss;
        _windowCmptRef.instance.dismissEvent.subscribe(function (reason) { _this.dismiss(reason); });
        this.result = new Promise(function (resolve, reject) {
            _this._resolve = resolve;
            _this._reject = reject;
        });
        this.result.then(null, function () { });
    }
    Object.defineProperty(NgbModalRef.prototype, "componentInstance", {
        /**
         * The instance of component used as modal's content.
         * Undefined when a TemplateRef is used as modal's content.
         */
        get: /**
           * The instance of component used as modal's content.
           * Undefined when a TemplateRef is used as modal's content.
           */
        function () {
            if (this._contentRef.componentRef) {
                return this._contentRef.componentRef.instance;
            }
        },
        // only needed to keep TS1.8 compatibility
        set: 
        // only needed to keep TS1.8 compatibility
        function (instance) { },
        enumerable: true,
        configurable: true
    });
    /**
     * Can be used to close a modal, passing an optional result.
     */
    /**
       * Can be used to close a modal, passing an optional result.
       */
    NgbModalRef.prototype.close = /**
       * Can be used to close a modal, passing an optional result.
       */
    function (result) {
        if (this._windowCmptRef) {
            this._resolve(result);
            this._removeModalElements();
        }
    };
    /**
     * Can be used to dismiss a modal, passing an optional reason.
     */
    /**
       * Can be used to dismiss a modal, passing an optional reason.
       */
    NgbModalRef.prototype.dismiss = /**
       * Can be used to dismiss a modal, passing an optional reason.
       */
    function (reason) {
        if (this._windowCmptRef) {
            if (!this._beforeDismiss || this._beforeDismiss() !== false) {
                this._reject(reason);
                this._removeModalElements();
            }
        }
    };
    NgbModalRef.prototype._removeModalElements = function () {
        var windowNativeEl = this._windowCmptRef.location.nativeElement;
        windowNativeEl.parentNode.removeChild(windowNativeEl);
        this._windowCmptRef.destroy();
        if (this._backdropCmptRef) {
            var backdropNativeEl = this._backdropCmptRef.location.nativeElement;
            backdropNativeEl.parentNode.removeChild(backdropNativeEl);
            this._backdropCmptRef.destroy();
        }
        if (this._contentRef && this._contentRef.viewRef) {
            this._contentRef.viewRef.destroy();
        }
        this._windowCmptRef = null;
        this._backdropCmptRef = null;
        this._contentRef = null;
    };
    return NgbModalRef;
}());
/**
 * A reference to a newly opened modal.
 */

//# sourceMappingURL=modal-ref.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/modal/modal-stack.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgbModalStack", function() { return NgbModalStack; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_common__ = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_popup__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/util/popup.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_util__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/util/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modal_backdrop__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/modal/modal-backdrop.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modal_window__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/modal/modal-window.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modal_ref__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/modal/modal-ref.js");







var NgbModalStack = /** @class */ (function () {
    function NgbModalStack(_applicationRef, _injector, _componentFactoryResolver, document) {
        this._applicationRef = _applicationRef;
        this._injector = _injector;
        this._componentFactoryResolver = _componentFactoryResolver;
        this._windowAttributes = ['backdrop', 'centered', 'keyboard', 'size', 'windowClass'];
        this._backdropAttributes = ['backdropClass'];
        this._document = document;
    }
    NgbModalStack.prototype.open = function (moduleCFR, contentInjector, content, options) {
        var containerEl = Object(__WEBPACK_IMPORTED_MODULE_3__util_util__["b" /* isDefined */])(options.container) ? this._document.querySelector(options.container) : this._document.body;
        if (!containerEl) {
            throw new Error("The specified modal container \"" + (options.container || 'body') + "\" was not found in the DOM.");
        }
        var activeModal = new __WEBPACK_IMPORTED_MODULE_6__modal_ref__["a" /* NgbActiveModal */]();
        var contentRef = this._getContentRef(moduleCFR, options.injector || contentInjector, content, activeModal);
        var backdropCmptRef = options.backdrop !== false ? this._attachBackdrop(containerEl) : null;
        var windowCmptRef = this._attachWindowComponent(containerEl, contentRef);
        var ngbModalRef = new __WEBPACK_IMPORTED_MODULE_6__modal_ref__["b" /* NgbModalRef */](windowCmptRef, contentRef, backdropCmptRef, options.beforeDismiss);
        activeModal.close = function (result) { ngbModalRef.close(result); };
        activeModal.dismiss = function (reason) { ngbModalRef.dismiss(reason); };
        this._applyWindowOptions(windowCmptRef.instance, options);
        if (backdropCmptRef && backdropCmptRef.instance) {
            this._applyBackdropOptions(backdropCmptRef.instance, options);
        }
        return ngbModalRef;
    };
    NgbModalStack.prototype._attachBackdrop = function (containerEl) {
        var backdropFactory = this._componentFactoryResolver.resolveComponentFactory(__WEBPACK_IMPORTED_MODULE_4__modal_backdrop__["a" /* NgbModalBackdrop */]);
        var backdropCmptRef = backdropFactory.create(this._injector);
        this._applicationRef.attachView(backdropCmptRef.hostView);
        containerEl.appendChild(backdropCmptRef.location.nativeElement);
        return backdropCmptRef;
    };
    NgbModalStack.prototype._attachWindowComponent = function (containerEl, contentRef) {
        var windowFactory = this._componentFactoryResolver.resolveComponentFactory(__WEBPACK_IMPORTED_MODULE_5__modal_window__["a" /* NgbModalWindow */]);
        var windowCmptRef = windowFactory.create(this._injector, contentRef.nodes);
        this._applicationRef.attachView(windowCmptRef.hostView);
        containerEl.appendChild(windowCmptRef.location.nativeElement);
        return windowCmptRef;
    };
    NgbModalStack.prototype._applyWindowOptions = function (windowInstance, options) {
        this._windowAttributes.forEach(function (optionName) {
            if (Object(__WEBPACK_IMPORTED_MODULE_3__util_util__["b" /* isDefined */])(options[optionName])) {
                windowInstance[optionName] = options[optionName];
            }
        });
    };
    NgbModalStack.prototype._applyBackdropOptions = function (backdropInstance, options) {
        this._backdropAttributes.forEach(function (optionName) {
            if (Object(__WEBPACK_IMPORTED_MODULE_3__util_util__["b" /* isDefined */])(options[optionName])) {
                backdropInstance[optionName] = options[optionName];
            }
        });
    };
    NgbModalStack.prototype._getContentRef = function (moduleCFR, contentInjector, content, context) {
        if (!content) {
            return new __WEBPACK_IMPORTED_MODULE_2__util_popup__["a" /* ContentRef */]([]);
        }
        else if (content instanceof __WEBPACK_IMPORTED_MODULE_1__angular_core__["TemplateRef"]) {
            return this._createFromTemplateRef(content, context);
        }
        else if (Object(__WEBPACK_IMPORTED_MODULE_3__util_util__["e" /* isString */])(content)) {
            return this._createFromString(content);
        }
        else {
            return this._createFromComponent(moduleCFR, contentInjector, content, context);
        }
    };
    NgbModalStack.prototype._createFromTemplateRef = function (content, context) {
        var viewRef = content.createEmbeddedView(context);
        this._applicationRef.attachView(viewRef);
        return new __WEBPACK_IMPORTED_MODULE_2__util_popup__["a" /* ContentRef */]([viewRef.rootNodes], viewRef);
    };
    NgbModalStack.prototype._createFromString = function (content) {
        var component = this._document.createTextNode("" + content);
        return new __WEBPACK_IMPORTED_MODULE_2__util_popup__["a" /* ContentRef */]([[component]]);
    };
    NgbModalStack.prototype._createFromComponent = function (moduleCFR, contentInjector, content, context) {
        var contentCmptFactory = moduleCFR.resolveComponentFactory(content);
        var modalContentInjector = __WEBPACK_IMPORTED_MODULE_1__angular_core__["Injector"].create([{ provide: __WEBPACK_IMPORTED_MODULE_6__modal_ref__["a" /* NgbActiveModal */], useValue: context }], contentInjector);
        var componentRef = contentCmptFactory.create(modalContentInjector);
        this._applicationRef.attachView(componentRef.hostView);
        return new __WEBPACK_IMPORTED_MODULE_2__util_popup__["a" /* ContentRef */]([[componentRef.location.nativeElement]], componentRef.hostView, componentRef);
    };
    NgbModalStack.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    NgbModalStack.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ApplicationRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Injector"], },
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ComponentFactoryResolver"], },
        { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_0__angular_common__["DOCUMENT"],] },] },
    ]; };
    return NgbModalStack;
}());

//# sourceMappingURL=modal-stack.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/modal/modal-window.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NgbModalWindow; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_common__ = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal_dismiss_reasons__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/modal/modal-dismiss-reasons.js");



var NgbModalWindow = /** @class */ (function () {
    function NgbModalWindow(document, _elRef, _renderer) {
        this._elRef = _elRef;
        this._renderer = _renderer;
        this.backdrop = true;
        this.keyboard = true;
        this.dismissEvent = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
        this._document = document;
    }
    NgbModalWindow.prototype.backdropClick = function ($event) {
        if (this.backdrop === true && this._elRef.nativeElement === $event.target) {
            this.dismiss(__WEBPACK_IMPORTED_MODULE_2__modal_dismiss_reasons__["a" /* ModalDismissReasons */].BACKDROP_CLICK);
        }
    };
    NgbModalWindow.prototype.escKey = function ($event) {
        if (this.keyboard && !$event.defaultPrevented) {
            this.dismiss(__WEBPACK_IMPORTED_MODULE_2__modal_dismiss_reasons__["a" /* ModalDismissReasons */].ESC);
        }
    };
    NgbModalWindow.prototype.dismiss = function (reason) { this.dismissEvent.emit(reason); };
    NgbModalWindow.prototype.ngOnInit = function () {
        this._elWithFocus = this._document.activeElement;
        this._renderer.addClass(this._document.body, 'modal-open');
    };
    NgbModalWindow.prototype.ngAfterViewInit = function () {
        if (!this._elRef.nativeElement.contains(document.activeElement)) {
            this._elRef.nativeElement['focus'].apply(this._elRef.nativeElement, []);
        }
    };
    NgbModalWindow.prototype.ngOnDestroy = function () {
        var body = this._document.body;
        var elWithFocus = this._elWithFocus;
        var elementToFocus;
        if (elWithFocus && elWithFocus['focus'] && body.contains(elWithFocus)) {
            elementToFocus = elWithFocus;
        }
        else {
            elementToFocus = body;
        }
        elementToFocus['focus'].apply(elementToFocus, []);
        this._elWithFocus = null;
        this._renderer.removeClass(body, 'modal-open');
    };
    NgbModalWindow.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"], args: [{
                    selector: 'ngb-modal-window',
                    host: {
                        '[class]': '"modal fade show d-block" + (windowClass ? " " + windowClass : "")',
                        'role': 'dialog',
                        'tabindex': '-1',
                        '(keyup.esc)': 'escKey($event)',
                        '(click)': 'backdropClick($event)'
                    },
                    template: "\n    <div [class]=\"'modal-dialog' + (size ? ' modal-' + size : '') + (centered ? ' modal-dialog-centered' : '')\" role=\"document\">\n        <div class=\"modal-content\"><ng-content></ng-content></div>\n    </div>\n    "
                },] },
    ];
    /** @nocollapse */
    NgbModalWindow.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_0__angular_common__["DOCUMENT"],] },] },
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Renderer2"], },
    ]; };
    NgbModalWindow.propDecorators = {
        "backdrop": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
        "centered": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
        "keyboard": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
        "size": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
        "windowClass": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
        "dismissEvent": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Output"], args: ['dismiss',] },],
    };
    return NgbModalWindow;
}());

//# sourceMappingURL=modal-window.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/modal/modal.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NgbModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modal_stack__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/modal/modal-stack.js");


/**
 * A service to open modal windows. Creating a modal is straightforward: create a template and pass it as an argument to
 * the "open" method!
 */
var NgbModal = /** @class */ (function () {
    function NgbModal(_moduleCFR, _injector, _modalStack) {
        this._moduleCFR = _moduleCFR;
        this._injector = _injector;
        this._modalStack = _modalStack;
    }
    /**
     * Opens a new modal window with the specified content and using supplied options. Content can be provided
     * as a TemplateRef or a component type. If you pass a component type as content than instances of those
     * components can be injected with an instance of the NgbActiveModal class. You can use methods on the
     * NgbActiveModal class to close / dismiss modals from "inside" of a component.
     */
    /**
       * Opens a new modal window with the specified content and using supplied options. Content can be provided
       * as a TemplateRef or a component type. If you pass a component type as content than instances of those
       * components can be injected with an instance of the NgbActiveModal class. You can use methods on the
       * NgbActiveModal class to close / dismiss modals from "inside" of a component.
       */
    NgbModal.prototype.open = /**
       * Opens a new modal window with the specified content and using supplied options. Content can be provided
       * as a TemplateRef or a component type. If you pass a component type as content than instances of those
       * components can be injected with an instance of the NgbActiveModal class. You can use methods on the
       * NgbActiveModal class to close / dismiss modals from "inside" of a component.
       */
    function (content, options) {
        if (options === void 0) { options = {}; }
        return this._modalStack.open(this._moduleCFR, this._injector, content, options);
    };
    NgbModal.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    NgbModal.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ComponentFactoryResolver"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injector"], },
        { type: __WEBPACK_IMPORTED_MODULE_1__modal_stack__["NgbModalStack"], },
    ]; };
    return NgbModal;
}());

//# sourceMappingURL=modal.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/modal/modal.module.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return NgbModalModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modal_backdrop__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/modal/modal-backdrop.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal_window__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/modal/modal-window.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modal_stack__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/modal/modal-stack.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modal__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/modal/modal.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__modal__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modal_ref__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/modal/modal-ref.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_5__modal_ref__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_5__modal_ref__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modal_dismiss_reasons__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/modal/modal-dismiss-reasons.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_6__modal_dismiss_reasons__["a"]; });








var NgbModalModule = /** @class */ (function () {
    function NgbModalModule() {
    }
    NgbModalModule.forRoot = function () { return { ngModule: NgbModalModule, providers: [__WEBPACK_IMPORTED_MODULE_4__modal__["a" /* NgbModal */], __WEBPACK_IMPORTED_MODULE_3__modal_stack__["NgbModalStack"]] }; };
    NgbModalModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                    declarations: [__WEBPACK_IMPORTED_MODULE_1__modal_backdrop__["a" /* NgbModalBackdrop */], __WEBPACK_IMPORTED_MODULE_2__modal_window__["a" /* NgbModalWindow */]],
                    entryComponents: [__WEBPACK_IMPORTED_MODULE_1__modal_backdrop__["a" /* NgbModalBackdrop */], __WEBPACK_IMPORTED_MODULE_2__modal_window__["a" /* NgbModalWindow */]],
                    providers: [__WEBPACK_IMPORTED_MODULE_4__modal__["a" /* NgbModal */]]
                },] },
    ];
    return NgbModalModule;
}());

//# sourceMappingURL=modal.module.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/pagination/pagination-config.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NgbPaginationConfig; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");

/**
 * Configuration service for the NgbPagination component.
 * You can inject this service, typically in your root component, and customize the values of its properties in
 * order to provide default values for all the paginations used in the application.
 */
var NgbPaginationConfig = /** @class */ (function () {
    function NgbPaginationConfig() {
        this.disabled = false;
        this.boundaryLinks = false;
        this.directionLinks = true;
        this.ellipses = true;
        this.maxSize = 0;
        this.pageSize = 10;
        this.rotate = false;
    }
    NgbPaginationConfig.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    return NgbPaginationConfig;
}());

//# sourceMappingURL=pagination-config.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/pagination/pagination.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NgbPagination; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_util__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/util/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pagination_config__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/pagination/pagination-config.js");



/**
 * A directive that will take care of visualising a pagination bar and enable / disable buttons correctly!
 */
var NgbPagination = /** @class */ (function () {
    function NgbPagination(config) {
        this.pageCount = 0;
        this.pages = [];
        /**
           *  Current page. Page numbers start with 1
           */
        this.page = 1;
        /**
           *  An event fired when the page is changed.
           *  Event's payload equals to the newly selected page.
           *  Will fire only if collection size is set and all values are valid.
           *  Page numbers start with 1
           */
        this.pageChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"](true);
        this.disabled = config.disabled;
        this.boundaryLinks = config.boundaryLinks;
        this.directionLinks = config.directionLinks;
        this.ellipses = config.ellipses;
        this.maxSize = config.maxSize;
        this.pageSize = config.pageSize;
        this.rotate = config.rotate;
        this.size = config.size;
    }
    NgbPagination.prototype.hasPrevious = function () { return this.page > 1; };
    NgbPagination.prototype.hasNext = function () { return this.page < this.pageCount; };
    NgbPagination.prototype.selectPage = function (pageNumber) { this._updatePages(pageNumber); };
    NgbPagination.prototype.ngOnChanges = function (changes) { this._updatePages(this.page); };
    NgbPagination.prototype.isEllipsis = function (pageNumber) { return pageNumber === -1; };
    /**
     * Appends ellipses and first/last page number to the displayed pages
     */
    /**
       * Appends ellipses and first/last page number to the displayed pages
       */
    NgbPagination.prototype._applyEllipses = /**
       * Appends ellipses and first/last page number to the displayed pages
       */
    function (start, end) {
        if (this.ellipses) {
            if (start > 0) {
                if (start > 1) {
                    this.pages.unshift(-1);
                }
                this.pages.unshift(1);
            }
            if (end < this.pageCount) {
                if (end < (this.pageCount - 1)) {
                    this.pages.push(-1);
                }
                this.pages.push(this.pageCount);
            }
        }
    };
    /**
     * Rotates page numbers based on maxSize items visible.
     * Currently selected page stays in the middle:
     *
     * Ex. for selected page = 6:
     * [5,*6*,7] for maxSize = 3
     * [4,5,*6*,7] for maxSize = 4
     */
    /**
       * Rotates page numbers based on maxSize items visible.
       * Currently selected page stays in the middle:
       *
       * Ex. for selected page = 6:
       * [5,*6*,7] for maxSize = 3
       * [4,5,*6*,7] for maxSize = 4
       */
    NgbPagination.prototype._applyRotation = /**
       * Rotates page numbers based on maxSize items visible.
       * Currently selected page stays in the middle:
       *
       * Ex. for selected page = 6:
       * [5,*6*,7] for maxSize = 3
       * [4,5,*6*,7] for maxSize = 4
       */
    function () {
        var start = 0;
        var end = this.pageCount;
        var leftOffset = Math.floor(this.maxSize / 2);
        var rightOffset = this.maxSize % 2 === 0 ? leftOffset - 1 : leftOffset;
        if (this.page <= leftOffset) {
            // very beginning, no rotation -> [0..maxSize]
            end = this.maxSize;
        }
        else if (this.pageCount - this.page < leftOffset) {
            // very end, no rotation -> [len-maxSize..len]
            start = this.pageCount - this.maxSize;
        }
        else {
            // rotate
            start = this.page - leftOffset - 1;
            end = this.page + rightOffset;
        }
        return [start, end];
    };
    /**
     * Paginates page numbers based on maxSize items per page
     */
    /**
       * Paginates page numbers based on maxSize items per page
       */
    NgbPagination.prototype._applyPagination = /**
       * Paginates page numbers based on maxSize items per page
       */
    function () {
        var page = Math.ceil(this.page / this.maxSize) - 1;
        var start = page * this.maxSize;
        var end = start + this.maxSize;
        return [start, end];
    };
    NgbPagination.prototype._setPageInRange = function (newPageNo) {
        var prevPageNo = this.page;
        this.page = Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["a" /* getValueInRange */])(newPageNo, this.pageCount, 1);
        if (this.page !== prevPageNo && Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["d" /* isNumber */])(this.collectionSize)) {
            this.pageChange.emit(this.page);
        }
    };
    NgbPagination.prototype._updatePages = function (newPage) {
        this.pageCount = Math.ceil(this.collectionSize / this.pageSize);
        if (!Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["d" /* isNumber */])(this.pageCount)) {
            this.pageCount = 0;
        }
        // fill-in model needed to render pages
        this.pages.length = 0;
        for (var i = 1; i <= this.pageCount; i++) {
            this.pages.push(i);
        }
        // set page within 1..max range
        this._setPageInRange(newPage);
        // apply maxSize if necessary
        if (this.maxSize > 0 && this.pageCount > this.maxSize) {
            var start = 0;
            var end = this.pageCount;
            // either paginating or rotating page numbers
            if (this.rotate) {
                _a = this._applyRotation(), start = _a[0], end = _a[1];
            }
            else {
                _b = this._applyPagination(), start = _b[0], end = _b[1];
            }
            this.pages = this.pages.slice(start, end);
            // adding ellipses
            this._applyEllipses(start, end);
        }
        var _a, _b;
    };
    NgbPagination.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'ngb-pagination',
                    changeDetection: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectionStrategy"].OnPush,
                    host: { 'role': 'navigation' },
                    template: "\n    <ul [class]=\"'pagination' + (size ? ' pagination-' + size : '')\">\n      <li *ngIf=\"boundaryLinks\" class=\"page-item\"\n        [class.disabled]=\"!hasPrevious() || disabled\">\n        <a aria-label=\"First\" class=\"page-link\" href (click)=\"!!selectPage(1)\" [attr.tabindex]=\"(hasPrevious() ? null : '-1')\">\n          <span aria-hidden=\"true\">&laquo;&laquo;</span>\n        </a>\n      </li>\n\n      <li *ngIf=\"directionLinks\" class=\"page-item\"\n        [class.disabled]=\"!hasPrevious() || disabled\">\n        <a aria-label=\"Previous\" class=\"page-link\" href (click)=\"!!selectPage(page-1)\" [attr.tabindex]=\"(hasPrevious() ? null : '-1')\">\n          <span aria-hidden=\"true\">&laquo;</span>\n        </a>\n      </li>\n      <li *ngFor=\"let pageNumber of pages\" class=\"page-item\" [class.active]=\"pageNumber === page\"\n        [class.disabled]=\"isEllipsis(pageNumber) || disabled\">\n        <a *ngIf=\"isEllipsis(pageNumber)\" class=\"page-link\">...</a>\n        <a *ngIf=\"!isEllipsis(pageNumber)\" class=\"page-link\" href (click)=\"!!selectPage(pageNumber)\">\n          {{pageNumber}}\n          <span *ngIf=\"pageNumber === page\" class=\"sr-only\">(current)</span>\n        </a>\n      </li>\n      <li *ngIf=\"directionLinks\" class=\"page-item\" [class.disabled]=\"!hasNext() || disabled\">\n        <a aria-label=\"Next\" class=\"page-link\" href (click)=\"!!selectPage(page+1)\" [attr.tabindex]=\"(hasNext() ? null : '-1')\">\n          <span aria-hidden=\"true\">&raquo;</span>\n        </a>\n      </li>\n\n      <li *ngIf=\"boundaryLinks\" class=\"page-item\" [class.disabled]=\"!hasNext() || disabled\">\n        <a aria-label=\"Last\" class=\"page-link\" href (click)=\"!!selectPage(pageCount)\" [attr.tabindex]=\"(hasNext() ? null : '-1')\">\n          <span aria-hidden=\"true\">&raquo;&raquo;</span>\n        </a>\n      </li>\n    </ul>\n  "
                },] },
    ];
    /** @nocollapse */
    NgbPagination.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_2__pagination_config__["a" /* NgbPaginationConfig */], },
    ]; };
    NgbPagination.propDecorators = {
        "disabled": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "boundaryLinks": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "directionLinks": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "ellipses": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "rotate": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "collectionSize": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "maxSize": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "page": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "pageSize": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "pageChange": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "size": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return NgbPagination;
}());

//# sourceMappingURL=pagination.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/pagination/pagination.module.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return NgbPaginationModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_common__ = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pagination__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/pagination/pagination.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pagination_config__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/pagination/pagination-config.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__pagination__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__pagination_config__["a"]; });






var NgbPaginationModule = /** @class */ (function () {
    function NgbPaginationModule() {
    }
    NgbPaginationModule.forRoot = function () { return { ngModule: NgbPaginationModule, providers: [__WEBPACK_IMPORTED_MODULE_3__pagination_config__["a" /* NgbPaginationConfig */]] }; };
    NgbPaginationModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{ declarations: [__WEBPACK_IMPORTED_MODULE_2__pagination__["a" /* NgbPagination */]], exports: [__WEBPACK_IMPORTED_MODULE_2__pagination__["a" /* NgbPagination */]], imports: [__WEBPACK_IMPORTED_MODULE_1__angular_common__["CommonModule"]] },] },
    ];
    return NgbPaginationModule;
}());

//# sourceMappingURL=pagination.module.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/popover/popover-config.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NgbPopoverConfig; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");

/**
 * Configuration service for the NgbPopover directive.
 * You can inject this service, typically in your root component, and customize the values of its properties in
 * order to provide default values for all the popovers used in the application.
 */
var NgbPopoverConfig = /** @class */ (function () {
    function NgbPopoverConfig() {
        this.placement = 'top';
        this.triggers = 'click';
        this.disablePopover = false;
    }
    NgbPopoverConfig.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    return NgbPopoverConfig;
}());

//# sourceMappingURL=popover-config.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/popover/popover.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NgbPopoverWindow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NgbPopover; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_triggers__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/util/triggers.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_positioning__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/util/positioning.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_popup__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/util/popup.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__popover_config__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/popover/popover-config.js");





var nextId = 0;
var NgbPopoverWindow = /** @class */ (function () {
    function NgbPopoverWindow(_element, _renderer) {
        this._element = _element;
        this._renderer = _renderer;
        this.placement = 'top';
    }
    NgbPopoverWindow.prototype.applyPlacement = function (_placement) {
        // remove the current placement classes
        this._renderer.removeClass(this._element.nativeElement, 'bs-popover-' + this.placement.toString().split('-')[0]);
        this._renderer.removeClass(this._element.nativeElement, 'bs-popover-' + this.placement.toString());
        // set the new placement classes
        this.placement = _placement;
        // apply the new placement
        this._renderer.addClass(this._element.nativeElement, 'bs-popover-' + this.placement.toString().split('-')[0]);
        this._renderer.addClass(this._element.nativeElement, 'bs-popover-' + this.placement.toString());
    };
    NgbPopoverWindow.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'ngb-popover-window',
                    changeDetection: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectionStrategy"].OnPush,
                    host: {
                        '[class]': '"popover bs-popover-" + placement.split("-")[0]+" bs-popover-" + placement',
                        'role': 'tooltip',
                        '[id]': 'id'
                    },
                    template: "\n    <div class=\"arrow\"></div>\n    <h3 class=\"popover-header\">{{title}}</h3><div class=\"popover-body\"><ng-content></ng-content></div>",
                    styles: ["\n    :host.bs-popover-top .arrow, :host.bs-popover-bottom .arrow {\n      left: 50%;\n      margin-left: -5px;\n    }\n\n    :host.bs-popover-top-left .arrow, :host.bs-popover-bottom-left .arrow {\n      left: 2em;\n    }\n\n    :host.bs-popover-top-right .arrow, :host.bs-popover-bottom-right .arrow {\n      left: auto;\n      right: 2em;\n    }\n\n    :host.bs-popover-left .arrow, :host.bs-popover-right .arrow {\n      top: 50%;\n      margin-top: -5px;\n    }\n\n    :host.bs-popover-left-top .arrow, :host.bs-popover-right-top .arrow {\n      top: 0.7em;\n    }\n\n    :host.bs-popover-left-bottom .arrow, :host.bs-popover-right-bottom .arrow {\n      top: auto;\n      bottom: 0.7em;\n    }\n  "]
                },] },
    ];
    /** @nocollapse */
    NgbPopoverWindow.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"], },
    ]; };
    NgbPopoverWindow.propDecorators = {
        "placement": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "title": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "id": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return NgbPopoverWindow;
}());

/**
 * A lightweight, extensible directive for fancy popover creation.
 */
var NgbPopover = /** @class */ (function () {
    function NgbPopover(_elementRef, _renderer, injector, componentFactoryResolver, viewContainerRef, config, ngZone) {
        var _this = this;
        this._elementRef = _elementRef;
        this._renderer = _renderer;
        /**
           * Emits an event when the popover is shown
           */
        this.shown = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
           * Emits an event when the popover is hidden
           */
        this.hidden = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this._ngbPopoverWindowId = "ngb-popover-" + nextId++;
        this.placement = config.placement;
        this.triggers = config.triggers;
        this.container = config.container;
        this.disablePopover = config.disablePopover;
        this._popupService = new __WEBPACK_IMPORTED_MODULE_3__util_popup__["b" /* PopupService */](NgbPopoverWindow, injector, viewContainerRef, _renderer, componentFactoryResolver);
        this._zoneSubscription = ngZone.onStable.subscribe(function () {
            if (_this._windowRef) {
                _this._windowRef.instance.applyPlacement(Object(__WEBPACK_IMPORTED_MODULE_2__util_positioning__["a" /* positionElements */])(_this._elementRef.nativeElement, _this._windowRef.location.nativeElement, _this.placement, _this.container === 'body'));
            }
        });
    }
    NgbPopover.prototype._isDisabled = function () {
        if (this.disablePopover) {
            return true;
        }
        if (!this.ngbPopover && !this.popoverTitle) {
            return true;
        }
        return false;
    };
    /**
     * Opens an element’s popover. This is considered a “manual” triggering of the popover.
     * The context is an optional value to be injected into the popover template when it is created.
     */
    /**
       * Opens an element’s popover. This is considered a “manual” triggering of the popover.
       * The context is an optional value to be injected into the popover template when it is created.
       */
    NgbPopover.prototype.open = /**
       * Opens an element’s popover. This is considered a “manual” triggering of the popover.
       * The context is an optional value to be injected into the popover template when it is created.
       */
    function (context) {
        if (!this._windowRef && !this._isDisabled()) {
            this._windowRef = this._popupService.open(this.ngbPopover, context);
            this._windowRef.instance.title = this.popoverTitle;
            this._windowRef.instance.id = this._ngbPopoverWindowId;
            this._renderer.setAttribute(this._elementRef.nativeElement, 'aria-describedby', this._ngbPopoverWindowId);
            if (this.container === 'body') {
                window.document.querySelector(this.container).appendChild(this._windowRef.location.nativeElement);
            }
            // apply styling to set basic css-classes on target element, before going for positioning
            this._windowRef.changeDetectorRef.detectChanges();
            this._windowRef.changeDetectorRef.markForCheck();
            // position popover along the element
            this._windowRef.instance.applyPlacement(Object(__WEBPACK_IMPORTED_MODULE_2__util_positioning__["a" /* positionElements */])(this._elementRef.nativeElement, this._windowRef.location.nativeElement, this.placement, this.container === 'body'));
            this.shown.emit();
        }
    };
    /**
     * Closes an element’s popover. This is considered a “manual” triggering of the popover.
     */
    /**
       * Closes an element’s popover. This is considered a “manual” triggering of the popover.
       */
    NgbPopover.prototype.close = /**
       * Closes an element’s popover. This is considered a “manual” triggering of the popover.
       */
    function () {
        if (this._windowRef) {
            this._renderer.removeAttribute(this._elementRef.nativeElement, 'aria-describedby');
            this._popupService.close();
            this._windowRef = null;
            this.hidden.emit();
        }
    };
    /**
     * Toggles an element’s popover. This is considered a “manual” triggering of the popover.
     */
    /**
       * Toggles an element’s popover. This is considered a “manual” triggering of the popover.
       */
    NgbPopover.prototype.toggle = /**
       * Toggles an element’s popover. This is considered a “manual” triggering of the popover.
       */
    function () {
        if (this._windowRef) {
            this.close();
        }
        else {
            this.open();
        }
    };
    /**
     * Returns whether or not the popover is currently being shown
     */
    /**
       * Returns whether or not the popover is currently being shown
       */
    NgbPopover.prototype.isOpen = /**
       * Returns whether or not the popover is currently being shown
       */
    function () { return this._windowRef != null; };
    NgbPopover.prototype.ngOnInit = function () {
        this._unregisterListenersFn = Object(__WEBPACK_IMPORTED_MODULE_1__util_triggers__["a" /* listenToTriggers */])(this._renderer, this._elementRef.nativeElement, this.triggers, this.open.bind(this), this.close.bind(this), this.toggle.bind(this));
    };
    NgbPopover.prototype.ngOnChanges = function (changes) {
        // close popover if title and content become empty, or disablePopover set to true
        if ((changes['ngbPopover'] || changes['popoverTitle'] || changes['disablePopover']) && this._isDisabled()) {
            this.close();
        }
    };
    NgbPopover.prototype.ngOnDestroy = function () {
        this.close();
        this._unregisterListenersFn();
        this._zoneSubscription.unsubscribe();
    };
    NgbPopover.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[ngbPopover]', exportAs: 'ngbPopover' },] },
    ];
    /** @nocollapse */
    NgbPopover.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injector"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ComponentFactoryResolver"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_4__popover_config__["a" /* NgbPopoverConfig */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"], },
    ]; };
    NgbPopover.propDecorators = {
        "ngbPopover": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "popoverTitle": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "placement": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "triggers": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "container": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "disablePopover": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "shown": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "hidden": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    };
    return NgbPopover;
}());

//# sourceMappingURL=popover.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/popover/popover.module.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return NgbPopoverModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__popover__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/popover/popover.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__popover_config__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/popover/popover-config.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__popover__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__popover_config__["a"]; });





var NgbPopoverModule = /** @class */ (function () {
    function NgbPopoverModule() {
    }
    NgbPopoverModule.forRoot = function () { return { ngModule: NgbPopoverModule, providers: [__WEBPACK_IMPORTED_MODULE_2__popover_config__["a" /* NgbPopoverConfig */]] }; };
    NgbPopoverModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{ declarations: [__WEBPACK_IMPORTED_MODULE_1__popover__["a" /* NgbPopover */], __WEBPACK_IMPORTED_MODULE_1__popover__["b" /* NgbPopoverWindow */]], exports: [__WEBPACK_IMPORTED_MODULE_1__popover__["a" /* NgbPopover */]], entryComponents: [__WEBPACK_IMPORTED_MODULE_1__popover__["b" /* NgbPopoverWindow */]] },] },
    ];
    return NgbPopoverModule;
}());

//# sourceMappingURL=popover.module.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/progressbar/progressbar-config.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NgbProgressbarConfig; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");

/**
 * Configuration service for the NgbProgressbar component.
 * You can inject this service, typically in your root component, and customize the values of its properties in
 * order to provide default values for all the progress bars used in the application.
 */
var NgbProgressbarConfig = /** @class */ (function () {
    function NgbProgressbarConfig() {
        this.max = 100;
        this.animated = false;
        this.striped = false;
        this.showValue = false;
    }
    NgbProgressbarConfig.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    return NgbProgressbarConfig;
}());

//# sourceMappingURL=progressbar-config.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/progressbar/progressbar.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NgbProgressbar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_util__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/util/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__progressbar_config__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/progressbar/progressbar-config.js");



/**
 * Directive that can be used to provide feedback on the progress of a workflow or an action.
 */
var NgbProgressbar = /** @class */ (function () {
    function NgbProgressbar(config) {
        /**
           * Current value to be displayed in the progressbar. Should be smaller or equal to "max" value.
           */
        this.value = 0;
        this.max = config.max;
        this.animated = config.animated;
        this.striped = config.striped;
        this.type = config.type;
        this.showValue = config.showValue;
        this.height = config.height;
    }
    NgbProgressbar.prototype.getValue = function () { return Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["a" /* getValueInRange */])(this.value, this.max); };
    NgbProgressbar.prototype.getPercentValue = function () { return 100 * this.getValue() / this.max; };
    NgbProgressbar.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'ngb-progressbar',
                    changeDetection: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectionStrategy"].OnPush,
                    template: "\n    <div class=\"progress\" [style.height]=\"height\">\n      <div class=\"progress-bar{{type ? ' bg-' + type : ''}}{{animated ? ' progress-bar-animated' : ''}}{{striped ?\n    ' progress-bar-striped' : ''}}\" role=\"progressbar\" [style.width.%]=\"getPercentValue()\"\n    [attr.aria-valuenow]=\"getValue()\" aria-valuemin=\"0\" [attr.aria-valuemax]=\"max\">\n        <span *ngIf=\"showValue\">{{getPercentValue()}}%</span><ng-content></ng-content>\n      </div>\n    </div>\n  "
                },] },
    ];
    /** @nocollapse */
    NgbProgressbar.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_2__progressbar_config__["a" /* NgbProgressbarConfig */], },
    ]; };
    NgbProgressbar.propDecorators = {
        "max": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "animated": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "striped": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "showValue": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "type": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "value": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "height": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return NgbProgressbar;
}());

//# sourceMappingURL=progressbar.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/progressbar/progressbar.module.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return NgbProgressbarModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_common__ = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__progressbar__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/progressbar/progressbar.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__progressbar_config__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/progressbar/progressbar-config.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__progressbar__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__progressbar_config__["a"]; });






var NgbProgressbarModule = /** @class */ (function () {
    function NgbProgressbarModule() {
    }
    NgbProgressbarModule.forRoot = function () { return { ngModule: NgbProgressbarModule, providers: [__WEBPACK_IMPORTED_MODULE_3__progressbar_config__["a" /* NgbProgressbarConfig */]] }; };
    NgbProgressbarModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{ declarations: [__WEBPACK_IMPORTED_MODULE_2__progressbar__["a" /* NgbProgressbar */]], exports: [__WEBPACK_IMPORTED_MODULE_2__progressbar__["a" /* NgbProgressbar */]], imports: [__WEBPACK_IMPORTED_MODULE_1__angular_common__["CommonModule"]] },] },
    ];
    return NgbProgressbarModule;
}());

//# sourceMappingURL=progressbar.module.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/rating/rating-config.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NgbRatingConfig; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");

/**
 * Configuration service for the NgbRating component.
 * You can inject this service, typically in your root component, and customize the values of its properties in
 * order to provide default values for all the ratings used in the application.
 */
var NgbRatingConfig = /** @class */ (function () {
    function NgbRatingConfig() {
        this.max = 10;
        this.readonly = false;
        this.resettable = false;
    }
    NgbRatingConfig.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    return NgbRatingConfig;
}());

//# sourceMappingURL=rating-config.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/rating/rating.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NgbRating; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rating_config__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/rating/rating-config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_util__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/util/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_forms__ = __webpack_require__("./node_modules/@angular/forms/esm5/forms.js");




var Key;
(function (Key) {
    Key[Key["End"] = 35] = "End";
    Key[Key["Home"] = 36] = "Home";
    Key[Key["ArrowLeft"] = 37] = "ArrowLeft";
    Key[Key["ArrowUp"] = 38] = "ArrowUp";
    Key[Key["ArrowRight"] = 39] = "ArrowRight";
    Key[Key["ArrowDown"] = 40] = "ArrowDown";
})(Key || (Key = {}));
var NGB_RATING_VALUE_ACCESSOR = {
    provide: __WEBPACK_IMPORTED_MODULE_3__angular_forms__["NG_VALUE_ACCESSOR"],
    useExisting: Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return NgbRating; }),
    multi: true
};
/**
 * Rating directive that will take care of visualising a star rating bar.
 */
var NgbRating = /** @class */ (function () {
    function NgbRating(config, _changeDetectorRef) {
        this._changeDetectorRef = _changeDetectorRef;
        this.contexts = [];
        this.disabled = false;
        /**
           * An event fired when a user is hovering over a given rating.
           * Event's payload equals to the rating being hovered over.
           */
        this.hover = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
           * An event fired when a user stops hovering over a given rating.
           * Event's payload equals to the rating of the last item being hovered over.
           */
        this.leave = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
           * An event fired when a user selects a new rating.
           * Event's payload equals to the newly selected rating.
           */
        this.rateChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"](true);
        this.onChange = function (_) { };
        this.onTouched = function () { };
        this.max = config.max;
        this.readonly = config.readonly;
    }
    NgbRating.prototype.ariaValueText = function () { return this.nextRate + " out of " + this.max; };
    NgbRating.prototype.enter = function (value) {
        if (!this.readonly && !this.disabled) {
            this._updateState(value);
        }
        this.hover.emit(value);
    };
    NgbRating.prototype.handleBlur = function () { this.onTouched(); };
    NgbRating.prototype.handleClick = function (value) { this.update(this.resettable && this.rate === value ? 0 : value); };
    NgbRating.prototype.handleKeyDown = function (event) {
        if (Key[Object(__WEBPACK_IMPORTED_MODULE_2__util_util__["i" /* toString */])(event.which)]) {
            event.preventDefault();
            switch (event.which) {
                case Key.ArrowDown:
                case Key.ArrowLeft:
                    this.update(this.rate - 1);
                    break;
                case Key.ArrowUp:
                case Key.ArrowRight:
                    this.update(this.rate + 1);
                    break;
                case Key.Home:
                    this.update(0);
                    break;
                case Key.End:
                    this.update(this.max);
                    break;
            }
        }
    };
    NgbRating.prototype.ngOnChanges = function (changes) {
        if (changes['rate']) {
            this.update(this.rate);
        }
    };
    NgbRating.prototype.ngOnInit = function () {
        this.contexts = Array.from({ length: this.max }, function (v, k) { return ({ fill: 0, index: k }); });
        this._updateState(this.rate);
    };
    NgbRating.prototype.registerOnChange = function (fn) { this.onChange = fn; };
    NgbRating.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    NgbRating.prototype.reset = function () {
        this.leave.emit(this.nextRate);
        this._updateState(this.rate);
    };
    NgbRating.prototype.setDisabledState = function (isDisabled) { this.disabled = isDisabled; };
    NgbRating.prototype.update = function (value, internalChange) {
        if (internalChange === void 0) { internalChange = true; }
        var newRate = Object(__WEBPACK_IMPORTED_MODULE_2__util_util__["a" /* getValueInRange */])(value, this.max, 0);
        if (!this.readonly && !this.disabled && this.rate !== newRate) {
            this.rate = newRate;
            this.rateChange.emit(this.rate);
        }
        if (internalChange) {
            this.onChange(this.rate);
            this.onTouched();
        }
        this._updateState(this.rate);
    };
    NgbRating.prototype.writeValue = function (value) {
        this.update(value, false);
        this._changeDetectorRef.markForCheck();
    };
    NgbRating.prototype._getFillValue = function (index) {
        var diff = this.nextRate - index;
        if (diff >= 1) {
            return 100;
        }
        if (diff < 1 && diff > 0) {
            return Number.parseInt((diff * 100).toFixed(2));
        }
        return 0;
    };
    NgbRating.prototype._updateState = function (nextValue) {
        var _this = this;
        this.nextRate = nextValue;
        this.contexts.forEach(function (context, index) { return context.fill = _this._getFillValue(index); });
    };
    NgbRating.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'ngb-rating',
                    changeDetection: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectionStrategy"].OnPush,
                    host: {
                        'class': 'd-inline-flex',
                        'tabindex': '0',
                        'role': 'slider',
                        'aria-valuemin': '0',
                        '[attr.aria-valuemax]': 'max',
                        '[attr.aria-valuenow]': 'nextRate',
                        '[attr.aria-valuetext]': 'ariaValueText()',
                        '[attr.aria-disabled]': 'readonly ? true : null',
                        '(blur)': 'handleBlur()',
                        '(keydown)': 'handleKeyDown($event)',
                        '(mouseleave)': 'reset()'
                    },
                    template: "\n    <ng-template #t let-fill=\"fill\">{{ fill === 100 ? '&#9733;' : '&#9734;' }}</ng-template>\n    <ng-template ngFor [ngForOf]=\"contexts\" let-index=\"index\">\n      <span class=\"sr-only\">({{ index < nextRate ? '*' : ' ' }})</span>\n      <span (mouseenter)=\"enter(index + 1)\" (click)=\"handleClick(index + 1)\" [style.cursor]=\"readonly || disabled ? 'default' : 'pointer'\">\n        <ng-template [ngTemplateOutlet]=\"starTemplate || t\" [ngTemplateOutletContext]=\"contexts[index]\"></ng-template>\n      </span>\n    </ng-template>\n  ",
                    providers: [NGB_RATING_VALUE_ACCESSOR]
                },] },
    ];
    /** @nocollapse */
    NgbRating.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__rating_config__["a" /* NgbRatingConfig */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"], },
    ]; };
    NgbRating.propDecorators = {
        "max": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "rate": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "readonly": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "resettable": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "starTemplate": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChild"], args: [__WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"],] },],
        "hover": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "leave": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "rateChange": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    };
    return NgbRating;
}());

//# sourceMappingURL=rating.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/rating/rating.module.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return NgbRatingModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_common__ = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rating_config__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/rating/rating-config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rating__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/rating/rating.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__rating__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__rating_config__["a"]; });






var NgbRatingModule = /** @class */ (function () {
    function NgbRatingModule() {
    }
    NgbRatingModule.forRoot = function () { return { ngModule: NgbRatingModule, providers: [__WEBPACK_IMPORTED_MODULE_2__rating_config__["a" /* NgbRatingConfig */]] }; };
    NgbRatingModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{ declarations: [__WEBPACK_IMPORTED_MODULE_3__rating__["a" /* NgbRating */]], exports: [__WEBPACK_IMPORTED_MODULE_3__rating__["a" /* NgbRating */]], imports: [__WEBPACK_IMPORTED_MODULE_1__angular_common__["CommonModule"]] },] },
    ];
    return NgbRatingModule;
}());

//# sourceMappingURL=rating.module.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/tabset/tabset-config.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NgbTabsetConfig; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");

/**
 * Configuration service for the NgbTabset component.
 * You can inject this service, typically in your root component, and customize the values of its properties in
 * order to provide default values for all the tabsets used in the application.
 */
var NgbTabsetConfig = /** @class */ (function () {
    function NgbTabsetConfig() {
        this.justify = 'start';
        this.orientation = 'horizontal';
        this.type = 'tabs';
    }
    NgbTabsetConfig.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    return NgbTabsetConfig;
}());

//# sourceMappingURL=tabset-config.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/tabset/tabset.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return NgbTabTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NgbTabContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NgbTab; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return NgbTabset; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tabset_config__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/tabset/tabset-config.js");


var nextId = 0;
/**
 * This directive should be used to wrap tab titles that need to contain HTML markup or other directives.
 */
var NgbTabTitle = /** @class */ (function () {
    function NgbTabTitle(templateRef) {
        this.templateRef = templateRef;
    }
    NgbTabTitle.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: 'ng-template[ngbTabTitle]' },] },
    ];
    /** @nocollapse */
    NgbTabTitle.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"], },
    ]; };
    return NgbTabTitle;
}());

/**
 * This directive must be used to wrap content to be displayed in a tab.
 */
var NgbTabContent = /** @class */ (function () {
    function NgbTabContent(templateRef) {
        this.templateRef = templateRef;
    }
    NgbTabContent.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: 'ng-template[ngbTabContent]' },] },
    ];
    /** @nocollapse */
    NgbTabContent.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"], },
    ]; };
    return NgbTabContent;
}());

/**
 * A directive representing an individual tab.
 */
var NgbTab = /** @class */ (function () {
    function NgbTab() {
        /**
           * Unique tab identifier. Must be unique for the entire document for proper accessibility support.
           */
        this.id = "ngb-tab-" + nextId++;
        /**
           * Allows toggling disabled state of a given state. Disabled tabs can't be selected.
           */
        this.disabled = false;
    }
    NgbTab.prototype.ngAfterContentChecked = function () {
        // We are using @ContentChildren instead of @ContantChild as in the Angular version being used
        // only @ContentChildren allows us to specify the {descendants: false} option.
        // Without {descendants: false} we are hitting bugs described in:
        // https://github.com/ng-bootstrap/ng-bootstrap/issues/2240
        this.titleTpl = this.titleTpls.first;
        this.contentTpl = this.contentTpls.first;
    };
    NgbTab.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: 'ngb-tab' },] },
    ];
    /** @nocollapse */
    NgbTab.propDecorators = {
        "id": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "title": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "disabled": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "titleTpls": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChildren"], args: [NgbTabTitle, { descendants: false },] },],
        "contentTpls": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChildren"], args: [NgbTabContent, { descendants: false },] },],
    };
    return NgbTab;
}());

/**
 * A component that makes it easy to create tabbed interface.
 */
var NgbTabset = /** @class */ (function () {
    function NgbTabset(config) {
        /**
           * Whether the closed tabs should be hidden without destroying them
           */
        this.destroyOnHide = true;
        /**
           * A tab change event fired right before the tab selection happens. See NgbTabChangeEvent for payload details
           */
        this.tabChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.type = config.type;
        this.justify = config.justify;
        this.orientation = config.orientation;
    }
    Object.defineProperty(NgbTabset.prototype, "justify", {
        set: /**
           * The horizontal alignment of the nav with flexbox utilities. Can be one of 'start', 'center', 'end', 'fill' or
           * 'justified'
           * The default value is 'start'.
           */
        function (className) {
            if (className === 'fill' || className === 'justified') {
                this.justifyClass = "nav-" + className;
            }
            else {
                this.justifyClass = "justify-content-" + className;
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Selects the tab with the given id and shows its associated pane.
     * Any other tab that was previously selected becomes unselected and its associated pane is hidden.
     */
    /**
       * Selects the tab with the given id and shows its associated pane.
       * Any other tab that was previously selected becomes unselected and its associated pane is hidden.
       */
    NgbTabset.prototype.select = /**
       * Selects the tab with the given id and shows its associated pane.
       * Any other tab that was previously selected becomes unselected and its associated pane is hidden.
       */
    function (tabId) {
        var selectedTab = this._getTabById(tabId);
        if (selectedTab && !selectedTab.disabled && this.activeId !== selectedTab.id) {
            var defaultPrevented_1 = false;
            this.tabChange.emit({ activeId: this.activeId, nextId: selectedTab.id, preventDefault: function () { defaultPrevented_1 = true; } });
            if (!defaultPrevented_1) {
                this.activeId = selectedTab.id;
            }
        }
    };
    NgbTabset.prototype.ngAfterContentChecked = function () {
        // auto-correct activeId that might have been set incorrectly as input
        var activeTab = this._getTabById(this.activeId);
        this.activeId = activeTab ? activeTab.id : (this.tabs.length ? this.tabs.first.id : null);
    };
    NgbTabset.prototype._getTabById = function (id) {
        var tabsWithId = this.tabs.filter(function (tab) { return tab.id === id; });
        return tabsWithId.length ? tabsWithId[0] : null;
    };
    NgbTabset.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'ngb-tabset',
                    exportAs: 'ngbTabset',
                    template: "\n    <ul [class]=\"'nav nav-' + type + (orientation == 'horizontal'?  ' ' + justifyClass : ' flex-column')\" role=\"tablist\">\n      <li class=\"nav-item\" *ngFor=\"let tab of tabs\">\n        <a [id]=\"tab.id\" class=\"nav-link\" [class.active]=\"tab.id === activeId\" [class.disabled]=\"tab.disabled\"\n          href (click)=\"!!select(tab.id)\" role=\"tab\" [attr.tabindex]=\"(tab.disabled ? '-1': undefined)\"\n          [attr.aria-controls]=\"(!destroyOnHide || tab.id === activeId ? tab.id + '-panel' : null)\"\n          [attr.aria-expanded]=\"tab.id === activeId\" [attr.aria-disabled]=\"tab.disabled\">\n          {{tab.title}}<ng-template [ngTemplateOutlet]=\"tab.titleTpl?.templateRef\"></ng-template>\n        </a>\n      </li>\n    </ul>\n    <div class=\"tab-content\">\n      <ng-template ngFor let-tab [ngForOf]=\"tabs\">\n        <div\n          class=\"tab-pane {{tab.id === activeId ? 'active' : null}}\"\n          *ngIf=\"!destroyOnHide || tab.id === activeId\"\n          role=\"tabpanel\"\n          [attr.aria-labelledby]=\"tab.id\" id=\"{{tab.id}}-panel\"\n          [attr.aria-expanded]=\"tab.id === activeId\">\n          <ng-template [ngTemplateOutlet]=\"tab.contentTpl?.templateRef\"></ng-template>\n        </div>\n      </ng-template>\n    </div>\n  "
                },] },
    ];
    /** @nocollapse */
    NgbTabset.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__tabset_config__["a" /* NgbTabsetConfig */], },
    ]; };
    NgbTabset.propDecorators = {
        "tabs": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChildren"], args: [NgbTab,] },],
        "activeId": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "destroyOnHide": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "justify": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "orientation": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "type": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "tabChange": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    };
    return NgbTabset;
}());

//# sourceMappingURL=tabset.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/tabset/tabset.module.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return NgbTabsetModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_common__ = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tabset__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/tabset/tabset.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tabset_config__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/tabset/tabset-config.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__tabset__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__tabset__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__tabset__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__tabset__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__tabset_config__["a"]; });






var NGB_TABSET_DIRECTIVES = [__WEBPACK_IMPORTED_MODULE_2__tabset__["d" /* NgbTabset */], __WEBPACK_IMPORTED_MODULE_2__tabset__["a" /* NgbTab */], __WEBPACK_IMPORTED_MODULE_2__tabset__["b" /* NgbTabContent */], __WEBPACK_IMPORTED_MODULE_2__tabset__["c" /* NgbTabTitle */]];
var NgbTabsetModule = /** @class */ (function () {
    function NgbTabsetModule() {
    }
    NgbTabsetModule.forRoot = function () { return { ngModule: NgbTabsetModule, providers: [__WEBPACK_IMPORTED_MODULE_3__tabset_config__["a" /* NgbTabsetConfig */]] }; };
    NgbTabsetModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{ declarations: NGB_TABSET_DIRECTIVES, exports: NGB_TABSET_DIRECTIVES, imports: [__WEBPACK_IMPORTED_MODULE_1__angular_common__["CommonModule"]] },] },
    ];
    return NgbTabsetModule;
}());

//# sourceMappingURL=tabset.module.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/timepicker/ngb-time.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NgbTime; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_util__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/util/util.js");

var NgbTime = /** @class */ (function () {
    function NgbTime(hour, minute, second) {
        this.hour = Object(__WEBPACK_IMPORTED_MODULE_0__util_util__["h" /* toInteger */])(hour);
        this.minute = Object(__WEBPACK_IMPORTED_MODULE_0__util_util__["h" /* toInteger */])(minute);
        this.second = Object(__WEBPACK_IMPORTED_MODULE_0__util_util__["h" /* toInteger */])(second);
    }
    NgbTime.prototype.changeHour = function (step) {
        if (step === void 0) { step = 1; }
        this.updateHour((isNaN(this.hour) ? 0 : this.hour) + step);
    };
    NgbTime.prototype.updateHour = function (hour) {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__util_util__["d" /* isNumber */])(hour)) {
            this.hour = (hour < 0 ? 24 + hour : hour) % 24;
        }
        else {
            this.hour = NaN;
        }
    };
    NgbTime.prototype.changeMinute = function (step) {
        if (step === void 0) { step = 1; }
        this.updateMinute((isNaN(this.minute) ? 0 : this.minute) + step);
    };
    NgbTime.prototype.updateMinute = function (minute) {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__util_util__["d" /* isNumber */])(minute)) {
            this.minute = minute % 60 < 0 ? 60 + minute % 60 : minute % 60;
            this.changeHour(Math.floor(minute / 60));
        }
        else {
            this.minute = NaN;
        }
    };
    NgbTime.prototype.changeSecond = function (step) {
        if (step === void 0) { step = 1; }
        this.updateSecond((isNaN(this.second) ? 0 : this.second) + step);
    };
    NgbTime.prototype.updateSecond = function (second) {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__util_util__["d" /* isNumber */])(second)) {
            this.second = second < 0 ? 60 + second % 60 : second % 60;
            this.changeMinute(Math.floor(second / 60));
        }
        else {
            this.second = NaN;
        }
    };
    NgbTime.prototype.isValid = function (checkSecs) {
        if (checkSecs === void 0) { checkSecs = true; }
        return Object(__WEBPACK_IMPORTED_MODULE_0__util_util__["d" /* isNumber */])(this.hour) && Object(__WEBPACK_IMPORTED_MODULE_0__util_util__["d" /* isNumber */])(this.minute) && (checkSecs ? Object(__WEBPACK_IMPORTED_MODULE_0__util_util__["d" /* isNumber */])(this.second) : true);
    };
    NgbTime.prototype.toString = function () { return (this.hour || 0) + ":" + (this.minute || 0) + ":" + (this.second || 0); };
    return NgbTime;
}());

//# sourceMappingURL=ngb-time.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/timepicker/timepicker-config.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NgbTimepickerConfig; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");

/**
 * Configuration service for the NgbTimepicker component.
 * You can inject this service, typically in your root component, and customize the values of its properties in
 * order to provide default values for all the timepickers used in the application.
 */
var NgbTimepickerConfig = /** @class */ (function () {
    function NgbTimepickerConfig() {
        this.meridian = false;
        this.spinners = true;
        this.seconds = false;
        this.hourStep = 1;
        this.minuteStep = 1;
        this.secondStep = 1;
        this.disabled = false;
        this.readonlyInputs = false;
        this.size = 'medium';
    }
    NgbTimepickerConfig.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    return NgbTimepickerConfig;
}());

//# sourceMappingURL=timepicker-config.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/timepicker/timepicker.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NgbTimepicker; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__("./node_modules/@angular/forms/esm5/forms.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_util__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/util/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ngb_time__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/timepicker/ngb-time.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__timepicker_config__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/timepicker/timepicker-config.js");





var NGB_TIMEPICKER_VALUE_ACCESSOR = {
    provide: __WEBPACK_IMPORTED_MODULE_1__angular_forms__["NG_VALUE_ACCESSOR"],
    useExisting: Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return NgbTimepicker; }),
    multi: true
};
/**
 * A lightweight & configurable timepicker directive.
 */
var NgbTimepicker = /** @class */ (function () {
    function NgbTimepicker(config) {
        this.onChange = function (_) { };
        this.onTouched = function () { };
        this.meridian = config.meridian;
        this.spinners = config.spinners;
        this.seconds = config.seconds;
        this.hourStep = config.hourStep;
        this.minuteStep = config.minuteStep;
        this.secondStep = config.secondStep;
        this.disabled = config.disabled;
        this.readonlyInputs = config.readonlyInputs;
        this.size = config.size;
    }
    NgbTimepicker.prototype.writeValue = function (value) {
        this.model = value ? new __WEBPACK_IMPORTED_MODULE_3__ngb_time__["a" /* NgbTime */](value.hour, value.minute, value.second) : new __WEBPACK_IMPORTED_MODULE_3__ngb_time__["a" /* NgbTime */]();
        if (!this.seconds && (!value || !Object(__WEBPACK_IMPORTED_MODULE_2__util_util__["d" /* isNumber */])(value.second))) {
            this.model.second = 0;
        }
    };
    NgbTimepicker.prototype.registerOnChange = function (fn) { this.onChange = fn; };
    NgbTimepicker.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    NgbTimepicker.prototype.setDisabledState = function (isDisabled) { this.disabled = isDisabled; };
    NgbTimepicker.prototype.changeHour = function (step) {
        this.model.changeHour(step);
        this.propagateModelChange();
    };
    NgbTimepicker.prototype.changeMinute = function (step) {
        this.model.changeMinute(step);
        this.propagateModelChange();
    };
    NgbTimepicker.prototype.changeSecond = function (step) {
        this.model.changeSecond(step);
        this.propagateModelChange();
    };
    NgbTimepicker.prototype.updateHour = function (newVal) {
        var isPM = this.model.hour >= 12;
        var enteredHour = Object(__WEBPACK_IMPORTED_MODULE_2__util_util__["h" /* toInteger */])(newVal);
        if (this.meridian && (isPM && enteredHour < 12 || !isPM && enteredHour === 12)) {
            this.model.updateHour(enteredHour + 12);
        }
        else {
            this.model.updateHour(enteredHour);
        }
        this.propagateModelChange();
    };
    NgbTimepicker.prototype.updateMinute = function (newVal) {
        this.model.updateMinute(Object(__WEBPACK_IMPORTED_MODULE_2__util_util__["h" /* toInteger */])(newVal));
        this.propagateModelChange();
    };
    NgbTimepicker.prototype.updateSecond = function (newVal) {
        this.model.updateSecond(Object(__WEBPACK_IMPORTED_MODULE_2__util_util__["h" /* toInteger */])(newVal));
        this.propagateModelChange();
    };
    NgbTimepicker.prototype.toggleMeridian = function () {
        if (this.meridian) {
            this.changeHour(12);
        }
    };
    NgbTimepicker.prototype.formatHour = function (value) {
        if (Object(__WEBPACK_IMPORTED_MODULE_2__util_util__["d" /* isNumber */])(value)) {
            if (this.meridian) {
                return Object(__WEBPACK_IMPORTED_MODULE_2__util_util__["f" /* padNumber */])(value % 12 === 0 ? 12 : value % 12);
            }
            else {
                return Object(__WEBPACK_IMPORTED_MODULE_2__util_util__["f" /* padNumber */])(value % 24);
            }
        }
        else {
            return Object(__WEBPACK_IMPORTED_MODULE_2__util_util__["f" /* padNumber */])(NaN);
        }
    };
    NgbTimepicker.prototype.formatMinSec = function (value) { return Object(__WEBPACK_IMPORTED_MODULE_2__util_util__["f" /* padNumber */])(value); };
    NgbTimepicker.prototype.setFormControlSize = function () { return { 'form-control-sm': this.size === 'small', 'form-control-lg': this.size === 'large' }; };
    NgbTimepicker.prototype.setButtonSize = function () { return { 'btn-sm': this.size === 'small', 'btn-lg': this.size === 'large' }; };
    NgbTimepicker.prototype.ngOnChanges = function (changes) {
        if (changes['seconds'] && !this.seconds && this.model && !Object(__WEBPACK_IMPORTED_MODULE_2__util_util__["d" /* isNumber */])(this.model.second)) {
            this.model.second = 0;
            this.propagateModelChange(false);
        }
    };
    NgbTimepicker.prototype.propagateModelChange = function (touched) {
        if (touched === void 0) { touched = true; }
        if (touched) {
            this.onTouched();
        }
        if (this.model.isValid(this.seconds)) {
            this.onChange({ hour: this.model.hour, minute: this.model.minute, second: this.model.second });
        }
        else {
            this.onChange(null);
        }
    };
    NgbTimepicker.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'ngb-timepicker',
                    styles: ["\n    .ngb-tp {\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-align: center;\n      align-items: center;\n    }\n\n    .ngb-tp-hour, .ngb-tp-minute, .ngb-tp-second, .ngb-tp-meridian {\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-direction: column;\n      flex-direction: column;\n      -ms-flex-align: center;\n      align-items: center;\n      -ms-flex-pack: distribute;\n      justify-content: space-around;\n    }\n\n    .ngb-tp-spacer {\n      width: 1em;\n      text-align: center;\n    }\n\n    .chevron::before {\n      border-style: solid;\n      border-width: 0.29em 0.29em 0 0;\n      content: '';\n      display: inline-block;\n      height: 0.69em;\n      left: 0.05em;\n      position: relative;\n      top: 0.15em;\n      transform: rotate(-45deg);\n      -webkit-transform: rotate(-45deg);\n      -ms-transform: rotate(-45deg);\n      vertical-align: middle;\n      width: 0.71em;\n    }\n\n    .chevron.bottom:before {\n      top: -.3em;\n      -webkit-transform: rotate(135deg);\n      -ms-transform: rotate(135deg);\n      transform: rotate(135deg);\n    }\n\n    input {\n      text-align: center;\n      display: inline-block;\n      width: auto;\n    }\n  "],
                    template: "\n    <fieldset [disabled]=\"disabled\" [class.disabled]=\"disabled\">\n      <div class=\"ngb-tp\">\n        <div class=\"ngb-tp-hour\">\n          <button *ngIf=\"spinners\" type=\"button\" class=\"btn btn-link\" [ngClass]=\"setButtonSize()\" (click)=\"changeHour(hourStep)\"\n            [disabled]=\"disabled\" [class.disabled]=\"disabled\">\n            <span class=\"chevron\"></span>\n            <span class=\"sr-only\">Increment hours</span>\n          </button>\n          <input type=\"text\" class=\"form-control\" [ngClass]=\"setFormControlSize()\" maxlength=\"2\" size=\"2\" placeholder=\"HH\"\n            [value]=\"formatHour(model?.hour)\" (change)=\"updateHour($event.target.value)\"\n            [readonly]=\"readonlyInputs\" [disabled]=\"disabled\" aria-label=\"Hours\">\n          <button *ngIf=\"spinners\" type=\"button\" class=\"btn btn-link\" [ngClass]=\"setButtonSize()\" (click)=\"changeHour(-hourStep)\"\n            [disabled]=\"disabled\" [class.disabled]=\"disabled\">\n            <span class=\"chevron bottom\"></span>\n            <span class=\"sr-only\">Decrement hours</span>\n          </button>\n        </div>\n        <div class=\"ngb-tp-spacer\">:</div>\n        <div class=\"ngb-tp-minute\">\n          <button *ngIf=\"spinners\" type=\"button\" class=\"btn btn-link\" [ngClass]=\"setButtonSize()\" (click)=\"changeMinute(minuteStep)\"\n            [disabled]=\"disabled\" [class.disabled]=\"disabled\">\n            <span class=\"chevron\"></span>\n            <span class=\"sr-only\">Increment minutes</span>\n          </button>\n          <input type=\"text\" class=\"form-control\" [ngClass]=\"setFormControlSize()\" maxlength=\"2\" size=\"2\" placeholder=\"MM\"\n            [value]=\"formatMinSec(model?.minute)\" (change)=\"updateMinute($event.target.value)\"\n            [readonly]=\"readonlyInputs\" [disabled]=\"disabled\" aria-label=\"Minutes\">\n          <button *ngIf=\"spinners\" type=\"button\" class=\"btn btn-link\" [ngClass]=\"setButtonSize()\" (click)=\"changeMinute(-minuteStep)\"\n            [disabled]=\"disabled\" [class.disabled]=\"disabled\">\n            <span class=\"chevron bottom\"></span>\n            <span class=\"sr-only\">Decrement minutes</span>\n          </button>\n        </div>\n        <div *ngIf=\"seconds\" class=\"ngb-tp-spacer\">:</div>\n        <div *ngIf=\"seconds\" class=\"ngb-tp-second\">\n          <button *ngIf=\"spinners\" type=\"button\" class=\"btn btn-link\" [ngClass]=\"setButtonSize()\" (click)=\"changeSecond(secondStep)\"\n            [disabled]=\"disabled\" [class.disabled]=\"disabled\">\n            <span class=\"chevron\"></span>\n            <span class=\"sr-only\">Increment seconds</span>\n          </button>\n          <input type=\"text\" class=\"form-control\" [ngClass]=\"setFormControlSize()\" maxlength=\"2\" size=\"2\" placeholder=\"SS\"\n            [value]=\"formatMinSec(model?.second)\" (change)=\"updateSecond($event.target.value)\"\n            [readonly]=\"readonlyInputs\" [disabled]=\"disabled\" aria-label=\"Seconds\">\n          <button *ngIf=\"spinners\" type=\"button\" class=\"btn btn-link\" [ngClass]=\"setButtonSize()\" (click)=\"changeSecond(-secondStep)\"\n            [disabled]=\"disabled\" [class.disabled]=\"disabled\">\n            <span class=\"chevron bottom\"></span>\n            <span class=\"sr-only\">Decrement seconds</span>\n          </button>\n        </div>\n        <div *ngIf=\"meridian\" class=\"ngb-tp-spacer\"></div>\n        <div *ngIf=\"meridian\" class=\"ngb-tp-meridian\">\n          <button type=\"button\" class=\"btn btn-outline-primary\" [ngClass]=\"setButtonSize()\"\n            [disabled]=\"disabled\" [class.disabled]=\"disabled\"\n            (click)=\"toggleMeridian()\">{{model?.hour >= 12 ? 'PM' : 'AM'}}</button>\n        </div>\n      </div>\n    </fieldset>\n  ",
                    providers: [NGB_TIMEPICKER_VALUE_ACCESSOR]
                },] },
    ];
    /** @nocollapse */
    NgbTimepicker.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_4__timepicker_config__["a" /* NgbTimepickerConfig */], },
    ]; };
    NgbTimepicker.propDecorators = {
        "meridian": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "spinners": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "seconds": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "hourStep": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "minuteStep": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "secondStep": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "readonlyInputs": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "size": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return NgbTimepicker;
}());

//# sourceMappingURL=timepicker.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/timepicker/timepicker.module.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return NgbTimepickerModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_common__ = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__timepicker__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/timepicker/timepicker.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__timepicker_config__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/timepicker/timepicker-config.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__timepicker__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__timepicker_config__["a"]; });






var NgbTimepickerModule = /** @class */ (function () {
    function NgbTimepickerModule() {
    }
    NgbTimepickerModule.forRoot = function () { return { ngModule: NgbTimepickerModule, providers: [__WEBPACK_IMPORTED_MODULE_3__timepicker_config__["a" /* NgbTimepickerConfig */]] }; };
    NgbTimepickerModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{ declarations: [__WEBPACK_IMPORTED_MODULE_2__timepicker__["a" /* NgbTimepicker */]], exports: [__WEBPACK_IMPORTED_MODULE_2__timepicker__["a" /* NgbTimepicker */]], imports: [__WEBPACK_IMPORTED_MODULE_1__angular_common__["CommonModule"]] },] },
    ];
    return NgbTimepickerModule;
}());

//# sourceMappingURL=timepicker.module.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/tooltip/tooltip-config.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NgbTooltipConfig; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");

/**
 * Configuration service for the NgbTooltip directive.
 * You can inject this service, typically in your root component, and customize the values of its properties in
 * order to provide default values for all the tooltips used in the application.
 */
var NgbTooltipConfig = /** @class */ (function () {
    function NgbTooltipConfig() {
        this.placement = 'top';
        this.triggers = 'hover';
        this.disableTooltip = false;
    }
    NgbTooltipConfig.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    return NgbTooltipConfig;
}());

//# sourceMappingURL=tooltip-config.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/tooltip/tooltip.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NgbTooltipWindow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NgbTooltip; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_triggers__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/util/triggers.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_positioning__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/util/positioning.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_popup__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/util/popup.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tooltip_config__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/tooltip/tooltip-config.js");





var nextId = 0;
var NgbTooltipWindow = /** @class */ (function () {
    function NgbTooltipWindow(_element, _renderer) {
        this._element = _element;
        this._renderer = _renderer;
        this.placement = 'top';
    }
    NgbTooltipWindow.prototype.applyPlacement = function (_placement) {
        // remove the current placement classes
        this._renderer.removeClass(this._element.nativeElement, 'bs-tooltip-' + this.placement.toString().split('-')[0]);
        this._renderer.removeClass(this._element.nativeElement, 'bs-tooltip-' + this.placement.toString());
        // set the new placement classes
        this.placement = _placement;
        // apply the new placement
        this._renderer.addClass(this._element.nativeElement, 'bs-tooltip-' + this.placement.toString().split('-')[0]);
        this._renderer.addClass(this._element.nativeElement, 'bs-tooltip-' + this.placement.toString());
    };
    NgbTooltipWindow.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'ngb-tooltip-window',
                    changeDetection: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectionStrategy"].OnPush,
                    host: {
                        '[class]': '"tooltip show bs-tooltip-" + placement.split("-")[0]+" bs-tooltip-" + placement',
                        'role': 'tooltip',
                        '[id]': 'id'
                    },
                    template: "<div class=\"arrow\"></div><div class=\"tooltip-inner\"><ng-content></ng-content></div>",
                    styles: ["\n    :host.bs-tooltip-top .arrow, :host.bs-tooltip-bottom .arrow {\n      left: calc(50% - 0.4rem);\n    }\n\n    :host.bs-tooltip-top-left .arrow, :host.bs-tooltip-bottom-left .arrow {\n      left: 1em;\n    }\n\n    :host.bs-tooltip-top-right .arrow, :host.bs-tooltip-bottom-right .arrow {\n      left: auto;\n      right: 0.8rem;\n    }\n\n    :host.bs-tooltip-left .arrow, :host.bs-tooltip-right .arrow {\n      top: calc(50% - 0.4rem);\n    }\n\n    :host.bs-tooltip-left-top .arrow, :host.bs-tooltip-right-top .arrow {\n      top: 0.4rem;\n    }\n\n    :host.bs-tooltip-left-bottom .arrow, :host.bs-tooltip-right-bottom .arrow {\n      top: auto;\n      bottom: 0.4rem;\n    }\n  "]
                },] },
    ];
    /** @nocollapse */
    NgbTooltipWindow.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"], },
    ]; };
    NgbTooltipWindow.propDecorators = {
        "placement": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "id": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return NgbTooltipWindow;
}());

/**
 * A lightweight, extensible directive for fancy tooltip creation.
 */
var NgbTooltip = /** @class */ (function () {
    function NgbTooltip(_elementRef, _renderer, injector, componentFactoryResolver, viewContainerRef, config, ngZone) {
        var _this = this;
        this._elementRef = _elementRef;
        this._renderer = _renderer;
        /**
           * Emits an event when the tooltip is shown
           */
        this.shown = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
           * Emits an event when the tooltip is hidden
           */
        this.hidden = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this._ngbTooltipWindowId = "ngb-tooltip-" + nextId++;
        this.placement = config.placement;
        this.triggers = config.triggers;
        this.container = config.container;
        this.disableTooltip = config.disableTooltip;
        this._popupService = new __WEBPACK_IMPORTED_MODULE_3__util_popup__["b" /* PopupService */](NgbTooltipWindow, injector, viewContainerRef, _renderer, componentFactoryResolver);
        this._zoneSubscription = ngZone.onStable.subscribe(function () {
            if (_this._windowRef) {
                _this._windowRef.instance.applyPlacement(Object(__WEBPACK_IMPORTED_MODULE_2__util_positioning__["a" /* positionElements */])(_this._elementRef.nativeElement, _this._windowRef.location.nativeElement, _this.placement, _this.container === 'body'));
            }
        });
    }
    Object.defineProperty(NgbTooltip.prototype, "ngbTooltip", {
        get: function () { return this._ngbTooltip; },
        set: /**
           * Content to be displayed as tooltip. If falsy, the tooltip won't open.
           */
        function (value) {
            this._ngbTooltip = value;
            if (!value && this._windowRef) {
                this.close();
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Opens an element’s tooltip. This is considered a “manual” triggering of the tooltip.
     * The context is an optional value to be injected into the tooltip template when it is created.
     */
    /**
       * Opens an element’s tooltip. This is considered a “manual” triggering of the tooltip.
       * The context is an optional value to be injected into the tooltip template when it is created.
       */
    NgbTooltip.prototype.open = /**
       * Opens an element’s tooltip. This is considered a “manual” triggering of the tooltip.
       * The context is an optional value to be injected into the tooltip template when it is created.
       */
    function (context) {
        if (!this._windowRef && this._ngbTooltip && !this.disableTooltip) {
            this._windowRef = this._popupService.open(this._ngbTooltip, context);
            this._windowRef.instance.id = this._ngbTooltipWindowId;
            this._renderer.setAttribute(this._elementRef.nativeElement, 'aria-describedby', this._ngbTooltipWindowId);
            if (this.container === 'body') {
                window.document.querySelector(this.container).appendChild(this._windowRef.location.nativeElement);
            }
            this._windowRef.instance.placement = Array.isArray(this.placement) ? this.placement[0] : this.placement;
            // apply styling to set basic css-classes on target element, before going for positioning
            this._windowRef.changeDetectorRef.detectChanges();
            this._windowRef.changeDetectorRef.markForCheck();
            // position tooltip along the element
            this._windowRef.instance.applyPlacement(Object(__WEBPACK_IMPORTED_MODULE_2__util_positioning__["a" /* positionElements */])(this._elementRef.nativeElement, this._windowRef.location.nativeElement, this.placement, this.container === 'body'));
            this.shown.emit();
        }
    };
    /**
     * Closes an element’s tooltip. This is considered a “manual” triggering of the tooltip.
     */
    /**
       * Closes an element’s tooltip. This is considered a “manual” triggering of the tooltip.
       */
    NgbTooltip.prototype.close = /**
       * Closes an element’s tooltip. This is considered a “manual” triggering of the tooltip.
       */
    function () {
        if (this._windowRef != null) {
            this._renderer.removeAttribute(this._elementRef.nativeElement, 'aria-describedby');
            this._popupService.close();
            this._windowRef = null;
            this.hidden.emit();
        }
    };
    /**
     * Toggles an element’s tooltip. This is considered a “manual” triggering of the tooltip.
     */
    /**
       * Toggles an element’s tooltip. This is considered a “manual” triggering of the tooltip.
       */
    NgbTooltip.prototype.toggle = /**
       * Toggles an element’s tooltip. This is considered a “manual” triggering of the tooltip.
       */
    function () {
        if (this._windowRef) {
            this.close();
        }
        else {
            this.open();
        }
    };
    /**
     * Returns whether or not the tooltip is currently being shown
     */
    /**
       * Returns whether or not the tooltip is currently being shown
       */
    NgbTooltip.prototype.isOpen = /**
       * Returns whether or not the tooltip is currently being shown
       */
    function () { return this._windowRef != null; };
    NgbTooltip.prototype.ngOnInit = function () {
        this._unregisterListenersFn = Object(__WEBPACK_IMPORTED_MODULE_1__util_triggers__["a" /* listenToTriggers */])(this._renderer, this._elementRef.nativeElement, this.triggers, this.open.bind(this), this.close.bind(this), this.toggle.bind(this));
    };
    NgbTooltip.prototype.ngOnDestroy = function () {
        this.close();
        // This check is needed as it might happen that ngOnDestroy is called before ngOnInit
        // under certain conditions, see: https://github.com/ng-bootstrap/ng-bootstrap/issues/2199
        if (this._unregisterListenersFn) {
            this._unregisterListenersFn();
        }
        this._zoneSubscription.unsubscribe();
    };
    NgbTooltip.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[ngbTooltip]', exportAs: 'ngbTooltip' },] },
    ];
    /** @nocollapse */
    NgbTooltip.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injector"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ComponentFactoryResolver"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_4__tooltip_config__["a" /* NgbTooltipConfig */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"], },
    ]; };
    NgbTooltip.propDecorators = {
        "placement": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "triggers": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "container": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "disableTooltip": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "shown": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "hidden": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "ngbTooltip": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return NgbTooltip;
}());

//# sourceMappingURL=tooltip.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/tooltip/tooltip.module.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return NgbTooltipModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tooltip__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/tooltip/tooltip.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tooltip_config__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/tooltip/tooltip-config.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__tooltip_config__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__tooltip__["a"]; });





var NgbTooltipModule = /** @class */ (function () {
    function NgbTooltipModule() {
    }
    NgbTooltipModule.forRoot = function () { return { ngModule: NgbTooltipModule, providers: [__WEBPACK_IMPORTED_MODULE_2__tooltip_config__["a" /* NgbTooltipConfig */]] }; };
    NgbTooltipModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{ declarations: [__WEBPACK_IMPORTED_MODULE_1__tooltip__["a" /* NgbTooltip */], __WEBPACK_IMPORTED_MODULE_1__tooltip__["b" /* NgbTooltipWindow */]], exports: [__WEBPACK_IMPORTED_MODULE_1__tooltip__["a" /* NgbTooltip */]], entryComponents: [__WEBPACK_IMPORTED_MODULE_1__tooltip__["b" /* NgbTooltipWindow */]] },] },
    ];
    return NgbTooltipModule;
}());

//# sourceMappingURL=tooltip.module.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/typeahead/highlight.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NgbHighlight; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_util__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/util/util.js");


var NgbHighlight = /** @class */ (function () {
    function NgbHighlight() {
        this.highlightClass = 'ngb-highlight';
    }
    NgbHighlight.prototype.ngOnChanges = function (changes) {
        var resultStr = Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["i" /* toString */])(this.result);
        var resultLC = resultStr.toLowerCase();
        var termLC = Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["i" /* toString */])(this.term).toLowerCase();
        var currentIdx = 0;
        if (termLC.length > 0) {
            this.parts = resultLC.split(new RegExp("(" + Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["g" /* regExpEscape */])(termLC) + ")")).map(function (part) {
                var originalPart = resultStr.substr(currentIdx, part.length);
                currentIdx += part.length;
                return originalPart;
            });
        }
        else {
            this.parts = [resultStr];
        }
    };
    NgbHighlight.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'ngb-highlight',
                    changeDetection: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectionStrategy"].OnPush,
                    template: "<ng-template ngFor [ngForOf]=\"parts\" let-part let-isOdd=\"odd\">" +
                        "<span *ngIf=\"isOdd\" class=\"{{highlightClass}}\">{{part}}</span><ng-template [ngIf]=\"!isOdd\">{{part}}</ng-template>" +
                        "</ng-template>",
                    // template needs to be formatted in a certain way so we don't add empty text nodes
                    styles: ["\n    .ngb-highlight {\n      font-weight: bold;\n    }\n  "]
                },] },
    ];
    /** @nocollapse */
    NgbHighlight.propDecorators = {
        "highlightClass": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "result": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "term": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return NgbHighlight;
}());

//# sourceMappingURL=highlight.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/typeahead/typeahead-config.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NgbTypeaheadConfig; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");

/**
 * Configuration service for the NgbTypeahead component.
 * You can inject this service, typically in your root component, and customize the values of its properties in
 * order to provide default values for all the typeaheads used in the application.
 */
var NgbTypeaheadConfig = /** @class */ (function () {
    function NgbTypeaheadConfig() {
        this.editable = true;
        this.focusFirst = true;
        this.showHint = false;
        this.placement = 'bottom-left';
    }
    NgbTypeaheadConfig.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    return NgbTypeaheadConfig;
}());

//# sourceMappingURL=typeahead-config.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/typeahead/typeahead-window.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NgbTypeaheadWindow; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_util__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/util/util.js");


var NgbTypeaheadWindow = /** @class */ (function () {
    function NgbTypeaheadWindow() {
        this.activeIdx = 0;
        /**
           * Flag indicating if the first row should be active initially
           */
        this.focusFirst = true;
        /**
           * A function used to format a given result before display. This function should return a formatted string without any
           * HTML markup
           */
        this.formatter = __WEBPACK_IMPORTED_MODULE_1__util_util__["i" /* toString */];
        /**
           * Event raised when user selects a particular result row
           */
        this.selectEvent = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.activeChangeEvent = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
    }
    NgbTypeaheadWindow.prototype.hasActive = function () { return this.activeIdx > -1 && this.activeIdx < this.results.length; };
    NgbTypeaheadWindow.prototype.getActive = function () { return this.results[this.activeIdx]; };
    NgbTypeaheadWindow.prototype.markActive = function (activeIdx) {
        this.activeIdx = activeIdx;
        this._activeChanged();
    };
    NgbTypeaheadWindow.prototype.next = function () {
        if (this.activeIdx === this.results.length - 1) {
            this.activeIdx = this.focusFirst ? (this.activeIdx + 1) % this.results.length : -1;
        }
        else {
            this.activeIdx++;
        }
        this._activeChanged();
    };
    NgbTypeaheadWindow.prototype.prev = function () {
        if (this.activeIdx < 0) {
            this.activeIdx = this.results.length - 1;
        }
        else if (this.activeIdx === 0) {
            this.activeIdx = this.focusFirst ? this.results.length - 1 : -1;
        }
        else {
            this.activeIdx--;
        }
        this._activeChanged();
    };
    NgbTypeaheadWindow.prototype.resetActive = function () {
        this.activeIdx = this.focusFirst ? 0 : -1;
        this._activeChanged();
    };
    NgbTypeaheadWindow.prototype.select = function (item) { this.selectEvent.emit(item); };
    NgbTypeaheadWindow.prototype.ngOnInit = function () { this.resetActive(); };
    NgbTypeaheadWindow.prototype._activeChanged = function () {
        this.activeChangeEvent.emit(this.activeIdx >= 0 ? this.id + '-' + this.activeIdx : undefined);
    };
    NgbTypeaheadWindow.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'ngb-typeahead-window',
                    exportAs: 'ngbTypeaheadWindow',
                    host: { 'class': 'dropdown-menu show', 'role': 'listbox', '[id]': 'id' },
                    template: "\n    <ng-template #rt let-result=\"result\" let-term=\"term\" let-formatter=\"formatter\">\n      <ngb-highlight [result]=\"formatter(result)\" [term]=\"term\"></ngb-highlight>\n    </ng-template>\n    <ng-template ngFor [ngForOf]=\"results\" let-result let-idx=\"index\">\n      <button type=\"button\" class=\"dropdown-item\" role=\"option\"\n        [id]=\"id + '-' + idx\"\n        [class.active]=\"idx === activeIdx\"\n        (mouseenter)=\"markActive(idx)\"\n        (click)=\"select(result)\">\n          <ng-template [ngTemplateOutlet]=\"resultTemplate || rt\"\n          [ngTemplateOutletContext]=\"{result: result, term: term, formatter: formatter}\"></ng-template>\n      </button>\n    </ng-template>\n  "
                },] },
    ];
    /** @nocollapse */
    NgbTypeaheadWindow.propDecorators = {
        "id": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "focusFirst": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "results": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "term": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "formatter": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "resultTemplate": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "selectEvent": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"], args: ['select',] },],
        "activeChangeEvent": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"], args: ['activeChange',] },],
    };
    return NgbTypeaheadWindow;
}());

//# sourceMappingURL=typeahead-window.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/typeahead/typeahead.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NgbTypeahead; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__("./node_modules/@angular/forms/esm5/forms.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs__ = __webpack_require__("./node_modules/rxjs/Rx.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_positioning__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/util/positioning.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__typeahead_window__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/typeahead/typeahead-window.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_popup__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/util/popup.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_util__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/util/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_accessibility_live__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/util/accessibility/live.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__typeahead_config__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/typeahead/typeahead-config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rxjs_operators__ = __webpack_require__("./node_modules/rxjs/operators.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rxjs_operators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_rxjs_operators__);










var Key;
(function (Key) {
    Key[Key["Tab"] = 9] = "Tab";
    Key[Key["Enter"] = 13] = "Enter";
    Key[Key["Escape"] = 27] = "Escape";
    Key[Key["ArrowUp"] = 38] = "ArrowUp";
    Key[Key["ArrowDown"] = 40] = "ArrowDown";
})(Key || (Key = {}));
var NGB_TYPEAHEAD_VALUE_ACCESSOR = {
    provide: __WEBPACK_IMPORTED_MODULE_1__angular_forms__["NG_VALUE_ACCESSOR"],
    useExisting: Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return NgbTypeahead; }),
    multi: true
};
var nextWindowId = 0;
/**
 * NgbTypeahead directive provides a simple way of creating powerful typeaheads from any text input
 */
var NgbTypeahead = /** @class */ (function () {
    function NgbTypeahead(_elementRef, _viewContainerRef, _renderer, _injector, componentFactoryResolver, config, ngZone, _live) {
        var _this = this;
        this._elementRef = _elementRef;
        this._viewContainerRef = _viewContainerRef;
        this._renderer = _renderer;
        this._injector = _injector;
        this._live = _live;
        /** Placement of a typeahead accepts:
           *    "top", "top-left", "top-right", "bottom", "bottom-left", "bottom-right",
           *    "left", "left-top", "left-bottom", "right", "right-top", "right-bottom"
           * and array of above values.
          */
        this.placement = 'bottom-left';
        /**
           * An event emitted when a match is selected. Event payload is of type NgbTypeaheadSelectItemEvent.
           */
        this.selectItem = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.popupId = "ngb-typeahead-" + nextWindowId++;
        this._onTouched = function () { };
        this._onChange = function (_) { };
        this.container = config.container;
        this.editable = config.editable;
        this.focusFirst = config.focusFirst;
        this.showHint = config.showHint;
        this.placement = config.placement;
        this._valueChanges = Object(__WEBPACK_IMPORTED_MODULE_2_rxjs__["fromEvent"])(_elementRef.nativeElement, 'input')
            .pipe(Object(__WEBPACK_IMPORTED_MODULE_9_rxjs_operators__["map"])(function ($event) { return $event.target.value; }));
        this._resubscribeTypeahead = new __WEBPACK_IMPORTED_MODULE_2_rxjs__["BehaviorSubject"](null);
        this._popupService = new __WEBPACK_IMPORTED_MODULE_5__util_popup__["b" /* PopupService */](__WEBPACK_IMPORTED_MODULE_4__typeahead_window__["a" /* NgbTypeaheadWindow */], _injector, _viewContainerRef, _renderer, componentFactoryResolver);
        this._zoneSubscription = ngZone.onStable.subscribe(function () {
            if (_this.isPopupOpen()) {
                Object(__WEBPACK_IMPORTED_MODULE_3__util_positioning__["a" /* positionElements */])(_this._elementRef.nativeElement, _this._windowRef.location.nativeElement, _this.placement, _this.container === 'body');
            }
        });
    }
    NgbTypeahead.prototype.ngOnInit = function () {
        var _this = this;
        var inputValues$ = this._valueChanges.pipe(Object(__WEBPACK_IMPORTED_MODULE_9_rxjs_operators__["tap"])(function (value) {
            _this._inputValueBackup = value;
            if (_this.editable) {
                _this._onChange(value);
            }
        }));
        var results$ = inputValues$.pipe(this.ngbTypeahead);
        var processedResults$ = results$.pipe(Object(__WEBPACK_IMPORTED_MODULE_9_rxjs_operators__["tap"])(function () {
            if (!_this.editable) {
                _this._onChange(undefined);
            }
        }));
        var userInput$ = this._resubscribeTypeahead.pipe(Object(__WEBPACK_IMPORTED_MODULE_9_rxjs_operators__["switchMap"])(function () { return processedResults$; }));
        this._subscription = this._subscribeToUserInput(userInput$);
    };
    NgbTypeahead.prototype.ngOnDestroy = function () {
        this._closePopup();
        this._unsubscribeFromUserInput();
        this._zoneSubscription.unsubscribe();
    };
    NgbTypeahead.prototype.registerOnChange = function (fn) { this._onChange = fn; };
    NgbTypeahead.prototype.registerOnTouched = function (fn) { this._onTouched = fn; };
    NgbTypeahead.prototype.writeValue = function (value) { this._writeInputValue(this._formatItemForInput(value)); };
    NgbTypeahead.prototype.setDisabledState = function (isDisabled) {
        this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    NgbTypeahead.prototype.onDocumentClick = function (event) {
        if (event.target !== this._elementRef.nativeElement) {
            this.dismissPopup();
        }
    };
    /**
     * Dismisses typeahead popup window
     */
    /**
       * Dismisses typeahead popup window
       */
    NgbTypeahead.prototype.dismissPopup = /**
       * Dismisses typeahead popup window
       */
    function () {
        if (this.isPopupOpen()) {
            this._closePopup();
            this._writeInputValue(this._inputValueBackup);
        }
    };
    /**
     * Returns true if the typeahead popup window is displayed
     */
    /**
       * Returns true if the typeahead popup window is displayed
       */
    NgbTypeahead.prototype.isPopupOpen = /**
       * Returns true if the typeahead popup window is displayed
       */
    function () { return this._windowRef != null; };
    NgbTypeahead.prototype.handleBlur = function () {
        this._resubscribeTypeahead.next(null);
        this._onTouched();
    };
    NgbTypeahead.prototype.handleKeyDown = function (event) {
        if (!this.isPopupOpen()) {
            return;
        }
        if (Key[Object(__WEBPACK_IMPORTED_MODULE_6__util_util__["i" /* toString */])(event.which)]) {
            switch (event.which) {
                case Key.ArrowDown:
                    event.preventDefault();
                    this._windowRef.instance.next();
                    this._showHint();
                    break;
                case Key.ArrowUp:
                    event.preventDefault();
                    this._windowRef.instance.prev();
                    this._showHint();
                    break;
                case Key.Enter:
                case Key.Tab:
                    var result = this._windowRef.instance.getActive();
                    if (Object(__WEBPACK_IMPORTED_MODULE_6__util_util__["b" /* isDefined */])(result)) {
                        event.preventDefault();
                        event.stopPropagation();
                        this._selectResult(result);
                    }
                    this._closePopup();
                    break;
                case Key.Escape:
                    event.preventDefault();
                    this._resubscribeTypeahead.next(null);
                    this.dismissPopup();
                    break;
            }
        }
    };
    NgbTypeahead.prototype._openPopup = function () {
        var _this = this;
        if (!this.isPopupOpen()) {
            this._inputValueBackup = this._elementRef.nativeElement.value;
            this._windowRef = this._popupService.open();
            this._windowRef.instance.id = this.popupId;
            this._windowRef.instance.selectEvent.subscribe(function (result) { return _this._selectResultClosePopup(result); });
            this._windowRef.instance.activeChangeEvent.subscribe(function (activeId) { return _this.activeDescendant = activeId; });
            if (this.container === 'body') {
                window.document.querySelector(this.container).appendChild(this._windowRef.location.nativeElement);
            }
        }
    };
    NgbTypeahead.prototype._closePopup = function () {
        this._popupService.close();
        this._windowRef = null;
        this.activeDescendant = undefined;
    };
    NgbTypeahead.prototype._selectResult = function (result) {
        var defaultPrevented = false;
        this.selectItem.emit({ item: result, preventDefault: function () { defaultPrevented = true; } });
        this._resubscribeTypeahead.next(null);
        if (!defaultPrevented) {
            this.writeValue(result);
            this._onChange(result);
        }
    };
    NgbTypeahead.prototype._selectResultClosePopup = function (result) {
        this._selectResult(result);
        this._closePopup();
    };
    NgbTypeahead.prototype._showHint = function () {
        if (this.showHint && this._windowRef.instance.hasActive() && this._inputValueBackup != null) {
            var userInputLowerCase = this._inputValueBackup.toLowerCase();
            var formattedVal = this._formatItemForInput(this._windowRef.instance.getActive());
            if (userInputLowerCase === formattedVal.substr(0, this._inputValueBackup.length).toLowerCase()) {
                this._writeInputValue(this._inputValueBackup + formattedVal.substr(this._inputValueBackup.length));
                this._elementRef.nativeElement['setSelectionRange'].apply(this._elementRef.nativeElement, [this._inputValueBackup.length, formattedVal.length]);
            }
            else {
                this.writeValue(this._windowRef.instance.getActive());
            }
        }
    };
    NgbTypeahead.prototype._formatItemForInput = function (item) {
        return item && this.inputFormatter ? this.inputFormatter(item) : Object(__WEBPACK_IMPORTED_MODULE_6__util_util__["i" /* toString */])(item);
    };
    NgbTypeahead.prototype._writeInputValue = function (value) {
        this._renderer.setProperty(this._elementRef.nativeElement, 'value', Object(__WEBPACK_IMPORTED_MODULE_6__util_util__["i" /* toString */])(value));
    };
    NgbTypeahead.prototype._subscribeToUserInput = function (userInput$) {
        var _this = this;
        return userInput$.subscribe(function (results) {
            if (!results || results.length === 0) {
                _this._closePopup();
            }
            else {
                _this._openPopup();
                _this._windowRef.instance.focusFirst = _this.focusFirst;
                _this._windowRef.instance.results = results;
                _this._windowRef.instance.term = _this._elementRef.nativeElement.value;
                if (_this.resultFormatter) {
                    _this._windowRef.instance.formatter = _this.resultFormatter;
                }
                if (_this.resultTemplate) {
                    _this._windowRef.instance.resultTemplate = _this.resultTemplate;
                }
                _this._windowRef.instance.resetActive();
                // The observable stream we are subscribing to might have async steps
                // and if a component containing typeahead is using the OnPush strategy
                // the change detection turn wouldn't be invoked automatically.
                // The observable stream we are subscribing to might have async steps
                // and if a component containing typeahead is using the OnPush strategy
                // the change detection turn wouldn't be invoked automatically.
                _this._windowRef.changeDetectorRef.detectChanges();
                _this._showHint();
            }
            var count = results.length;
            _this._live.say(count === 0 ? 'No results available' : count + " result" + (count === 1 ? '' : 's') + " available");
        });
    };
    NgbTypeahead.prototype._unsubscribeFromUserInput = function () {
        if (this._subscription) {
            this._subscription.unsubscribe();
        }
        this._subscription = null;
    };
    NgbTypeahead.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'input[ngbTypeahead]',
                    exportAs: 'ngbTypeahead',
                    host: {
                        '(blur)': 'handleBlur()',
                        '[class.open]': 'isPopupOpen()',
                        '(document:click)': 'onDocumentClick($event)',
                        '(keydown)': 'handleKeyDown($event)',
                        'autocomplete': 'off',
                        'autocapitalize': 'off',
                        'autocorrect': 'off',
                        'role': 'combobox',
                        'aria-multiline': 'false',
                        '[attr.aria-autocomplete]': 'showHint ? "both" : "list"',
                        '[attr.aria-activedescendant]': 'activeDescendant',
                        '[attr.aria-owns]': 'isPopupOpen() ? popupId : null',
                        '[attr.aria-expanded]': 'isPopupOpen()'
                    },
                    providers: [NGB_TYPEAHEAD_VALUE_ACCESSOR]
                },] },
    ];
    /** @nocollapse */
    NgbTypeahead.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injector"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ComponentFactoryResolver"], },
        { type: __WEBPACK_IMPORTED_MODULE_8__typeahead_config__["a" /* NgbTypeaheadConfig */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"], },
        { type: __WEBPACK_IMPORTED_MODULE_7__util_accessibility_live__["c" /* Live */], },
    ]; };
    NgbTypeahead.propDecorators = {
        "container": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "editable": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "focusFirst": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "inputFormatter": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "ngbTypeahead": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "resultFormatter": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "resultTemplate": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "showHint": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "placement": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "selectItem": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    };
    return NgbTypeahead;
}());

//# sourceMappingURL=typeahead.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/typeahead/typeahead.module.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return NgbTypeaheadModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_common__ = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__highlight__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/typeahead/highlight.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__typeahead_window__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/typeahead/typeahead-window.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__typeahead__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/typeahead/typeahead.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__typeahead_config__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/typeahead/typeahead-config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_accessibility_live__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/util/accessibility/live.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__highlight__["a"]; });
/* unused harmony reexport NgbTypeaheadWindow */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_5__typeahead_config__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__typeahead__["a"]; });











var NgbTypeaheadModule = /** @class */ (function () {
    function NgbTypeaheadModule() {
    }
    NgbTypeaheadModule.forRoot = function () {
        return {
            ngModule: NgbTypeaheadModule,
            providers: [__WEBPACK_IMPORTED_MODULE_6__util_accessibility_live__["c" /* Live */], __WEBPACK_IMPORTED_MODULE_5__typeahead_config__["a" /* NgbTypeaheadConfig */], { provide: __WEBPACK_IMPORTED_MODULE_6__util_accessibility_live__["a" /* ARIA_LIVE_DELAY */], useValue: __WEBPACK_IMPORTED_MODULE_6__util_accessibility_live__["b" /* DEFAULT_ARIA_LIVE_DELAY */] }]
        };
    };
    NgbTypeaheadModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                    declarations: [__WEBPACK_IMPORTED_MODULE_4__typeahead__["a" /* NgbTypeahead */], __WEBPACK_IMPORTED_MODULE_2__highlight__["a" /* NgbHighlight */], __WEBPACK_IMPORTED_MODULE_3__typeahead_window__["a" /* NgbTypeaheadWindow */]],
                    exports: [__WEBPACK_IMPORTED_MODULE_4__typeahead__["a" /* NgbTypeahead */], __WEBPACK_IMPORTED_MODULE_2__highlight__["a" /* NgbHighlight */]],
                    imports: [__WEBPACK_IMPORTED_MODULE_1__angular_common__["CommonModule"]],
                    entryComponents: [__WEBPACK_IMPORTED_MODULE_3__typeahead_window__["a" /* NgbTypeaheadWindow */]]
                },] },
    ];
    return NgbTypeaheadModule;
}());

//# sourceMappingURL=typeahead.module.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/util/accessibility/live.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ARIA_LIVE_DELAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_ARIA_LIVE_DELAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Live; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_common__ = __webpack_require__("./node_modules/@angular/common/esm5/common.js");


var ARIA_LIVE_DELAY = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["InjectionToken"]('live announcer delay');
var DEFAULT_ARIA_LIVE_DELAY = 100;
function createLiveElement(document) {
    var element = document.createElement('div');
    element.setAttribute('aria-live', 'polite');
    element.setAttribute('aria-atomic', 'true');
    element.classList.add('sr-only');
    document.body.appendChild(element);
    return element;
}
var Live = /** @class */ (function () {
    function Live(document, _delay) {
        this._delay = _delay;
        this._element = createLiveElement(document);
    }
    Live.prototype.ngOnDestroy = function () { this._element.parentElement.removeChild(this._element); };
    Live.prototype.say = function (message) {
        var element = this._element;
        var delay = this._delay;
        element.textContent = '';
        var setText = function () { return element.textContent = message; };
        if (delay === null) {
            setText();
        }
        else {
            setTimeout(setText, delay);
        }
    };
    Live.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    Live.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_1__angular_common__["DOCUMENT"],] },] },
        { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [ARIA_LIVE_DELAY,] },] },
    ]; };
    return Live;
}());

//# sourceMappingURL=live.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/util/focus-trap.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NgbFocusTrap */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NgbFocusTrapFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_common__ = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");


var FOCUSABLE_ELEMENTS_SELECTOR = [
    'a[href]', 'button:not([disabled])', 'input:not([disabled]):not([type="hidden"])', 'select:not([disabled])',
    'textarea:not([disabled])', '[contenteditable]', '[tabindex]:not([tabindex="-1"])'
].join(', ');
var DIRECTION;
(function (DIRECTION) {
    DIRECTION[DIRECTION["BACKWARD"] = 0] = "BACKWARD";
    DIRECTION[DIRECTION["FORWARD"] = 1] = "FORWARD";
})(DIRECTION || (DIRECTION = {}));
/**
 * Class that enforce the browser focus to be trapped inside a DOM element.
 *
 * The implementation is rather simple, the class add a `focusin` listener on the document with capture phase.
 * Any focus event will then be caught, and therefore the class will only allow the one for elements contained inside
 * it's own element.
 *
 * In case the element is not contained, the class will determine which new element has to be focused based on the `tab`
 * navigation direction.
 *
 * Should not be used directly. Use only via {@link NgbFocusTrapFactory}
 */
var /**
 * Class that enforce the browser focus to be trapped inside a DOM element.
 *
 * The implementation is rather simple, the class add a `focusin` listener on the document with capture phase.
 * Any focus event will then be caught, and therefore the class will only allow the one for elements contained inside
 * it's own element.
 *
 * In case the element is not contained, the class will determine which new element has to be focused based on the `tab`
 * navigation direction.
 *
 * Should not be used directly. Use only via {@link NgbFocusTrapFactory}
 */
NgbFocusTrap = /** @class */ (function () {
    /**
     * @param _element The element around which focus will be trapped inside
     * @param autofocus Initially put the focus on specific element with a `ngbFocustrap` attribute. Will also remenber
     * and restore any previously focused element on destroy.
     * @param _document Document on which `focusin` and `keydown.TAB` events are listened
     * @param _ngZone The zone Angular is running in
     */
    function NgbFocusTrap(_element, autofocus, _document, _ngZone) {
        var _this = this;
        this._element = _element;
        this._document = _document;
        this._ngZone = _ngZone;
        this._direction = DIRECTION.FORWARD;
        this._previouslyFocused = null;
        this._endOfDocument = null;
        this._enforceFocus = this._enforceFocus.bind(this);
        this._detectDirection = this._detectDirection.bind(this);
        var eod = this._endOfDocument = this._document.createElement('i');
        eod.className = 'ngb-focustrap-eod';
        eod.tabIndex = 0;
        this._document.body.appendChild(eod);
        this._ngZone.runOutsideAngular(function () {
            _this._document.addEventListener('focusin', _this._enforceFocus, true);
            _this._document.addEventListener('keydown', _this._detectDirection);
            _this._removeDocumentListener = function () {
                _this._document.removeEventListener('focusin', _this._enforceFocus, true);
                _this._document.removeEventListener('keydown', _this._detectDirection);
            };
        });
        if (autofocus === true) {
            this._previouslyFocused = document.activeElement;
            this._focusInitial();
        }
    }
    Object.defineProperty(NgbFocusTrap.prototype, "focusableElement", {
        /**
         * Guess the next focusable element.
         * Computation is based on specific CSS selector and [tab] navigation direction
         */
        get: /**
           * Guess the next focusable element.
           * Computation is based on specific CSS selector and [tab] navigation direction
           */
        function () {
            var list = this._element.querySelectorAll(FOCUSABLE_ELEMENTS_SELECTOR);
            return this._direction === DIRECTION.BACKWARD ? list[list.length - 1] : list[0];
        },
        enumerable: true,
        configurable: true
    });
    /** Detect if incoming focus event should be prevented or not */
    /** Detect if incoming focus event should be prevented or not */
    NgbFocusTrap.prototype._enforceFocus = /** Detect if incoming focus event should be prevented or not */
    function (event) {
        var _this = this;
        var target = event.target;
        if (this._document !== target && this._element !== target && !this._element.contains(target)) {
            this._ngZone.run(function () {
                var element = _this.focusableElement;
                if (element) {
                    element.focus();
                    event.stopPropagation();
                }
            });
        }
    };
    /** Event handler detecting current `tab` navigation direction */
    /** Event handler detecting current `tab` navigation direction */
    NgbFocusTrap.prototype._detectDirection = /** Event handler detecting current `tab` navigation direction */
    function (event) {
        var shiftKey = event.shiftKey, key = event.key;
        if (key === 'Tab') {
            this._direction = shiftKey ? DIRECTION.BACKWARD : DIRECTION.FORWARD;
        }
    };
    /** Try to set focus on the first found element that has an ngbAutofocus attribute */
    /** Try to set focus on the first found element that has an ngbAutofocus attribute */
    NgbFocusTrap.prototype._focusInitial = /** Try to set focus on the first found element that has an ngbAutofocus attribute */
    function () {
        var element = this._element.querySelector('[ngbAutofocus]');
        if (element) {
            element.focus();
        }
    };
    /**
     * Destroys the focustrap by removing all event listeners set on document.
     *
     * Eventually put the focus back on the previously focused element at the time
     * focustrap has been initialized.
     */
    /**
       * Destroys the focustrap by removing all event listeners set on document.
       *
       * Eventually put the focus back on the previously focused element at the time
       * focustrap has been initialized.
       */
    NgbFocusTrap.prototype.destroy = /**
       * Destroys the focustrap by removing all event listeners set on document.
       *
       * Eventually put the focus back on the previously focused element at the time
       * focustrap has been initialized.
       */
    function () {
        this._removeDocumentListener();
        this._document.body.removeChild(this._endOfDocument);
        if (this._previouslyFocused) {
            this._previouslyFocused.focus();
        }
    };
    return NgbFocusTrap;
}());
/**
 * Class that enforce the browser focus to be trapped inside a DOM element.
 *
 * The implementation is rather simple, the class add a `focusin` listener on the document with capture phase.
 * Any focus event will then be caught, and therefore the class will only allow the one for elements contained inside
 * it's own element.
 *
 * In case the element is not contained, the class will determine which new element has to be focused based on the `tab`
 * navigation direction.
 *
 * Should not be used directly. Use only via {@link NgbFocusTrapFactory}
 */

/**
 * Factory service to easily create a `NgbFocusTrap` instance on an element
 */
var NgbFocusTrapFactory = /** @class */ (function () {
    function NgbFocusTrapFactory(_document, _ngZone) {
        this._document = _document;
        this._ngZone = _ngZone;
    }
    /**
     * Create an instance of {@link NgbFocusTrap} and return it
     * @param element HTMLElement to trap focus inside
     * @param autofocus Whether the focustrap should automatically move focus into the trapped element upon
     * initialization and return focus to the previous activeElement upon destruction.
     */
    /**
       * Create an instance of {@link NgbFocusTrap} and return it
       * @param element HTMLElement to trap focus inside
       * @param autofocus Whether the focustrap should automatically move focus into the trapped element upon
       * initialization and return focus to the previous activeElement upon destruction.
       */
    NgbFocusTrapFactory.prototype.create = /**
       * Create an instance of {@link NgbFocusTrap} and return it
       * @param element HTMLElement to trap focus inside
       * @param autofocus Whether the focustrap should automatically move focus into the trapped element upon
       * initialization and return focus to the previous activeElement upon destruction.
       */
    function (element, autofocus) {
        if (autofocus === void 0) { autofocus = false; }
        return new NgbFocusTrap(element, autofocus, this._document, this._ngZone);
    };
    NgbFocusTrapFactory.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    NgbFocusTrapFactory.ctorParameters = function () { return [
        { type: Document, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_0__angular_common__["DOCUMENT"],] },] },
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["NgZone"], },
    ]; };
    return NgbFocusTrapFactory;
}());

//# sourceMappingURL=focus-trap.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/util/popup.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContentRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PopupService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");

var ContentRef = /** @class */ (function () {
    function ContentRef(nodes, viewRef, componentRef) {
        this.nodes = nodes;
        this.viewRef = viewRef;
        this.componentRef = componentRef;
    }
    return ContentRef;
}());

var PopupService = /** @class */ (function () {
    function PopupService(_type, _injector, _viewContainerRef, _renderer, _componentFactoryResolver) {
        this._type = _type;
        this._injector = _injector;
        this._viewContainerRef = _viewContainerRef;
        this._renderer = _renderer;
        this._componentFactoryResolver = _componentFactoryResolver;
    }
    PopupService.prototype.open = function (content, context) {
        if (!this._windowRef) {
            this._contentRef = this._getContentRef(content, context);
            this._windowRef = this._viewContainerRef.createComponent(this._componentFactoryResolver.resolveComponentFactory(this._type), 0, this._injector, this._contentRef.nodes);
        }
        return this._windowRef;
    };
    PopupService.prototype.close = function () {
        if (this._windowRef) {
            this._viewContainerRef.remove(this._viewContainerRef.indexOf(this._windowRef.hostView));
            this._windowRef = null;
            if (this._contentRef.viewRef) {
                this._viewContainerRef.remove(this._viewContainerRef.indexOf(this._contentRef.viewRef));
                this._contentRef = null;
            }
        }
    };
    PopupService.prototype._getContentRef = function (content, context) {
        if (!content) {
            return new ContentRef([]);
        }
        else if (content instanceof __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"]) {
            var viewRef = this._viewContainerRef.createEmbeddedView(content, context);
            return new ContentRef([viewRef.rootNodes], viewRef);
        }
        else {
            return new ContentRef([[this._renderer.createText("" + content)]]);
        }
    };
    return PopupService;
}());

//# sourceMappingURL=popup.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/util/positioning.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Positioning */
/* harmony export (immutable) */ __webpack_exports__["a"] = positionElements;
// previous version:
// https://github.com/angular-ui/bootstrap/blob/07c31d0731f7cb068a1932b8e01d2312b796b4ec/src/position/position.js
var 
// previous version:
// https://github.com/angular-ui/bootstrap/blob/07c31d0731f7cb068a1932b8e01d2312b796b4ec/src/position/position.js
Positioning = /** @class */ (function () {
    function Positioning() {
    }
    Positioning.prototype.getAllStyles = function (element) { return window.getComputedStyle(element); };
    Positioning.prototype.getStyle = function (element, prop) { return this.getAllStyles(element)[prop]; };
    Positioning.prototype.isStaticPositioned = function (element) {
        return (this.getStyle(element, 'position') || 'static') === 'static';
    };
    Positioning.prototype.offsetParent = function (element) {
        var offsetParentEl = element.offsetParent || document.documentElement;
        while (offsetParentEl && offsetParentEl !== document.documentElement && this.isStaticPositioned(offsetParentEl)) {
            offsetParentEl = offsetParentEl.offsetParent;
        }
        return offsetParentEl || document.documentElement;
    };
    Positioning.prototype.position = function (element, round) {
        if (round === void 0) { round = true; }
        var elPosition;
        var parentOffset = { width: 0, height: 0, top: 0, bottom: 0, left: 0, right: 0 };
        if (this.getStyle(element, 'position') === 'fixed') {
            elPosition = element.getBoundingClientRect();
        }
        else {
            var offsetParentEl = this.offsetParent(element);
            elPosition = this.offset(element, false);
            if (offsetParentEl !== document.documentElement) {
                parentOffset = this.offset(offsetParentEl, false);
            }
            parentOffset.top += offsetParentEl.clientTop;
            parentOffset.left += offsetParentEl.clientLeft;
        }
        elPosition.top -= parentOffset.top;
        elPosition.bottom -= parentOffset.top;
        elPosition.left -= parentOffset.left;
        elPosition.right -= parentOffset.left;
        if (round) {
            elPosition.top = Math.round(elPosition.top);
            elPosition.bottom = Math.round(elPosition.bottom);
            elPosition.left = Math.round(elPosition.left);
            elPosition.right = Math.round(elPosition.right);
        }
        return elPosition;
    };
    Positioning.prototype.offset = function (element, round) {
        if (round === void 0) { round = true; }
        var elBcr = element.getBoundingClientRect();
        var viewportOffset = {
            top: window.pageYOffset - document.documentElement.clientTop,
            left: window.pageXOffset - document.documentElement.clientLeft
        };
        var elOffset = {
            height: elBcr.height || element.offsetHeight,
            width: elBcr.width || element.offsetWidth,
            top: elBcr.top + viewportOffset.top,
            bottom: elBcr.bottom + viewportOffset.top,
            left: elBcr.left + viewportOffset.left,
            right: elBcr.right + viewportOffset.left
        };
        if (round) {
            elOffset.height = Math.round(elOffset.height);
            elOffset.width = Math.round(elOffset.width);
            elOffset.top = Math.round(elOffset.top);
            elOffset.bottom = Math.round(elOffset.bottom);
            elOffset.left = Math.round(elOffset.left);
            elOffset.right = Math.round(elOffset.right);
        }
        return elOffset;
    };
    Positioning.prototype.positionElements = function (hostElement, targetElement, placement, appendToBody) {
        var hostElPosition = appendToBody ? this.offset(hostElement, false) : this.position(hostElement, false);
        var targetElStyles = this.getAllStyles(targetElement);
        var targetElBCR = targetElement.getBoundingClientRect();
        var placementPrimary = placement.split('-')[0] || 'top';
        var placementSecondary = placement.split('-')[1] || 'center';
        var targetElPosition = {
            'height': targetElBCR.height || targetElement.offsetHeight,
            'width': targetElBCR.width || targetElement.offsetWidth,
            'top': 0,
            'bottom': targetElBCR.height || targetElement.offsetHeight,
            'left': 0,
            'right': targetElBCR.width || targetElement.offsetWidth
        };
        switch (placementPrimary) {
            case 'top':
                targetElPosition.top =
                    hostElPosition.top - (targetElement.offsetHeight + parseFloat(targetElStyles.marginBottom));
                break;
            case 'bottom':
                targetElPosition.top = hostElPosition.top + hostElPosition.height;
                break;
            case 'left':
                targetElPosition.left =
                    hostElPosition.left - (targetElement.offsetWidth + parseFloat(targetElStyles.marginRight));
                break;
            case 'right':
                targetElPosition.left = hostElPosition.left + hostElPosition.width;
                break;
        }
        switch (placementSecondary) {
            case 'top':
                targetElPosition.top = hostElPosition.top;
                break;
            case 'bottom':
                targetElPosition.top = hostElPosition.top + hostElPosition.height - targetElement.offsetHeight;
                break;
            case 'left':
                targetElPosition.left = hostElPosition.left;
                break;
            case 'right':
                targetElPosition.left = hostElPosition.left + hostElPosition.width - targetElement.offsetWidth;
                break;
            case 'center':
                if (placementPrimary === 'top' || placementPrimary === 'bottom') {
                    targetElPosition.left = hostElPosition.left + hostElPosition.width / 2 - targetElement.offsetWidth / 2;
                }
                else {
                    targetElPosition.top = hostElPosition.top + hostElPosition.height / 2 - targetElement.offsetHeight / 2;
                }
                break;
        }
        targetElPosition.top = Math.round(targetElPosition.top);
        targetElPosition.bottom = Math.round(targetElPosition.bottom);
        targetElPosition.left = Math.round(targetElPosition.left);
        targetElPosition.right = Math.round(targetElPosition.right);
        return targetElPosition;
    };
    // get the availble placements of the target element in the viewport dependeing on the host element
    // get the availble placements of the target element in the viewport dependeing on the host element
    Positioning.prototype.getAvailablePlacements = 
    // get the availble placements of the target element in the viewport dependeing on the host element
    function (hostElement, targetElement) {
        var availablePlacements = [];
        var hostElemClientRect = hostElement.getBoundingClientRect();
        var targetElemClientRect = targetElement.getBoundingClientRect();
        var html = document.documentElement;
        // left: check if target width can be placed between host left and viewport start and also height of target is
        // inside viewport
        if (targetElemClientRect.width < hostElemClientRect.left) {
            // check for left only
            if ((hostElemClientRect.top + hostElemClientRect.height / 2 - targetElement.offsetHeight / 2) > 0) {
                availablePlacements.splice(availablePlacements.length, 1, 'left');
            }
            // check for left-top and left-bottom
            this.setSecondaryPlacementForLeftRight(hostElemClientRect, targetElemClientRect, 'left', availablePlacements);
        }
        // top: target height is less than host top
        if (targetElemClientRect.height < hostElemClientRect.top) {
            availablePlacements.splice(availablePlacements.length, 1, 'top');
            this.setSecondaryPlacementForTopBottom(hostElemClientRect, targetElemClientRect, 'top', availablePlacements);
        }
        // right: check if target width can be placed between host right and viewport end and also height of target is
        // inside viewport
        if ((window.innerWidth || html.clientWidth) - hostElemClientRect.right > targetElemClientRect.width) {
            // check for right only
            if ((hostElemClientRect.top + hostElemClientRect.height / 2 - targetElement.offsetHeight / 2) > 0) {
                availablePlacements.splice(availablePlacements.length, 1, 'right');
            }
            // check for right-top and right-bottom
            this.setSecondaryPlacementForLeftRight(hostElemClientRect, targetElemClientRect, 'right', availablePlacements);
        }
        // bottom: check if there is enough space between host bottom and viewport end for target height
        if ((window.innerHeight || html.clientHeight) - hostElemClientRect.bottom > targetElemClientRect.height) {
            availablePlacements.splice(availablePlacements.length, 1, 'bottom');
            this.setSecondaryPlacementForTopBottom(hostElemClientRect, targetElemClientRect, 'bottom', availablePlacements);
        }
        return availablePlacements;
    };
    /**
     * check if secondary placement for left and right are available i.e. left-top, left-bottom, right-top, right-bottom
     * primaryplacement: left|right
     * availablePlacementArr: array in which available placemets to be set
     */
    /**
       * check if secondary placement for left and right are available i.e. left-top, left-bottom, right-top, right-bottom
       * primaryplacement: left|right
       * availablePlacementArr: array in which available placemets to be set
       */
    Positioning.prototype.setSecondaryPlacementForLeftRight = /**
       * check if secondary placement for left and right are available i.e. left-top, left-bottom, right-top, right-bottom
       * primaryplacement: left|right
       * availablePlacementArr: array in which available placemets to be set
       */
    function (hostElemClientRect, targetElemClientRect, primaryPlacement, availablePlacementArr) {
        var html = document.documentElement;
        // check for left-bottom
        if (targetElemClientRect.height <= hostElemClientRect.bottom) {
            availablePlacementArr.splice(availablePlacementArr.length, 1, primaryPlacement + '-bottom');
        }
        if ((window.innerHeight || html.clientHeight) - hostElemClientRect.top >= targetElemClientRect.height) {
            availablePlacementArr.splice(availablePlacementArr.length, 1, primaryPlacement + '-top');
        }
    };
    /**
     * check if secondary placement for top and bottom are available i.e. top-left, top-right, bottom-left, bottom-right
     * primaryplacement: top|bottom
     * availablePlacementArr: array in which available placemets to be set
     */
    /**
       * check if secondary placement for top and bottom are available i.e. top-left, top-right, bottom-left, bottom-right
       * primaryplacement: top|bottom
       * availablePlacementArr: array in which available placemets to be set
       */
    Positioning.prototype.setSecondaryPlacementForTopBottom = /**
       * check if secondary placement for top and bottom are available i.e. top-left, top-right, bottom-left, bottom-right
       * primaryplacement: top|bottom
       * availablePlacementArr: array in which available placemets to be set
       */
    function (hostElemClientRect, targetElemClientRect, primaryPlacement, availablePlacementArr) {
        var html = document.documentElement;
        // check for left-bottom
        if ((window.innerWidth || html.clientWidth) - hostElemClientRect.left >= targetElemClientRect.width) {
            availablePlacementArr.splice(availablePlacementArr.length, 1, primaryPlacement + '-left');
        }
        if (targetElemClientRect.width <= hostElemClientRect.right) {
            availablePlacementArr.splice(availablePlacementArr.length, 1, primaryPlacement + '-right');
        }
    };
    return Positioning;
}());
// previous version:
// https://github.com/angular-ui/bootstrap/blob/07c31d0731f7cb068a1932b8e01d2312b796b4ec/src/position/position.js

var positionService = new Positioning();
/*
 * Accept the placement array and applies the appropriate placement dependent on the viewport.
 * Returns the applied placement.
 * In case of auto placement, placements are selected in order 'top', 'bottom', 'left', 'right'.
 * */
function positionElements(hostElement, targetElement, placement, appendToBody) {
    var placementVals = Array.isArray(placement) ? placement : [placement];
    // replace auto placement with other placements
    var hasAuto = placementVals.findIndex(function (val) { return val === 'auto'; });
    if (hasAuto >= 0) {
        ['top', 'right', 'bottom', 'left'].forEach(function (obj) {
            if (placementVals.find(function (val) { return val.search('^' + obj + '|^' + obj + '-') !== -1; }) == null) {
                placementVals.splice(hasAuto++, 1, obj);
            }
        });
    }
    // coordinates where to position
    var topVal = 0, leftVal = 0;
    var appliedPlacement;
    // get available placements
    var availablePlacements = positionService.getAvailablePlacements(hostElement, targetElement);
    var _loop_1 = function (item, index) {
        // check if passed placement is present in the available placement or otherwise apply the last placement in the
        // passed placement list
        if ((availablePlacements.find(function (val) { return val === item; }) != null) || (placementVals.length === index + 1)) {
            appliedPlacement = item;
            var pos = positionService.positionElements(hostElement, targetElement, item, appendToBody);
            topVal = pos.top;
            leftVal = pos.left;
            return "break";
        }
    };
    // iterate over all the passed placements
    for (var _i = 0, _a = toItemIndexes(placementVals); _i < _a.length; _i++) {
        var _b = _a[_i], item = _b.item, index = _b.index;
        var state_1 = _loop_1(item, index);
        if (state_1 === "break")
            break;
    }
    targetElement.style.top = topVal + "px";
    targetElement.style.left = leftVal + "px";
    return appliedPlacement;
}
// function to get index and item of an array
function toItemIndexes(a) {
    return a.map(function (item, index) { return ({ item: item, index: index }); });
}
//# sourceMappingURL=positioning.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/util/triggers.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Trigger */
/* unused harmony export parseTriggers */
/* harmony export (immutable) */ __webpack_exports__["a"] = listenToTriggers;
/* unused harmony export ɵ0 */
var Trigger = /** @class */ (function () {
    function Trigger(open, close) {
        this.open = open;
        this.close = close;
        if (!close) {
            this.close = open;
        }
    }
    Trigger.prototype.isManual = function () { return this.open === 'manual' || this.close === 'manual'; };
    return Trigger;
}());

var DEFAULT_ALIASES = {
    'hover': ['mouseenter', 'mouseleave']
};
function parseTriggers(triggers, aliases) {
    if (aliases === void 0) { aliases = DEFAULT_ALIASES; }
    var trimmedTriggers = (triggers || '').trim();
    if (trimmedTriggers.length === 0) {
        return [];
    }
    var parsedTriggers = trimmedTriggers.split(/\s+/).map(function (trigger) { return trigger.split(':'); }).map(function (triggerPair) {
        var alias = aliases[triggerPair[0]] || triggerPair;
        return new Trigger(alias[0], alias[1]);
    });
    var manualTriggers = parsedTriggers.filter(function (triggerPair) { return triggerPair.isManual(); });
    if (manualTriggers.length > 1) {
        throw 'Triggers parse error: only one manual trigger is allowed';
    }
    if (manualTriggers.length === 1 && parsedTriggers.length > 1) {
        throw 'Triggers parse error: manual trigger can\'t be mixed with other triggers';
    }
    return parsedTriggers;
}
var noopFn = function () { };
var ɵ0 = noopFn;
function listenToTriggers(renderer, nativeElement, triggers, openFn, closeFn, toggleFn) {
    var parsedTriggers = parseTriggers(triggers);
    var listeners = [];
    if (parsedTriggers.length === 1 && parsedTriggers[0].isManual()) {
        return noopFn;
    }
    parsedTriggers.forEach(function (trigger) {
        if (trigger.open === trigger.close) {
            listeners.push(renderer.listen(nativeElement, trigger.open, toggleFn));
        }
        else {
            listeners.push(renderer.listen(nativeElement, trigger.open, openFn), renderer.listen(nativeElement, trigger.close, closeFn));
        }
    });
    return function () { listeners.forEach(function (unsubscribeFn) { return unsubscribeFn(); }); };
}

//# sourceMappingURL=triggers.js.map

/***/ }),

/***/ "./node_modules/@ng-bootstrap/ng-bootstrap/util/util.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["h"] = toInteger;
/* harmony export (immutable) */ __webpack_exports__["i"] = toString;
/* harmony export (immutable) */ __webpack_exports__["a"] = getValueInRange;
/* harmony export (immutable) */ __webpack_exports__["e"] = isString;
/* harmony export (immutable) */ __webpack_exports__["d"] = isNumber;
/* harmony export (immutable) */ __webpack_exports__["c"] = isInteger;
/* harmony export (immutable) */ __webpack_exports__["b"] = isDefined;
/* harmony export (immutable) */ __webpack_exports__["f"] = padNumber;
/* harmony export (immutable) */ __webpack_exports__["g"] = regExpEscape;
function toInteger(value) {
    return parseInt("" + value, 10);
}
function toString(value) {
    return (value !== undefined && value !== null) ? "" + value : '';
}
function getValueInRange(value, max, min) {
    if (min === void 0) { min = 0; }
    return Math.max(Math.min(value, max), min);
}
function isString(value) {
    return typeof value === 'string';
}
function isNumber(value) {
    return !isNaN(toInteger(value));
}
function isInteger(value) {
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
}
function isDefined(value) {
    return value !== undefined && value !== null;
}
function padNumber(value) {
    if (isNumber(value)) {
        return ("0" + value).slice(-2);
    }
    else {
        return '';
    }
}
function regExpEscape(text) {
    return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}
//# sourceMappingURL=util.js.map

/***/ }),

/***/ "./node_modules/@ngrx/store/@ngrx/store.es5.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Store", function() { return Store; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "select", function() { return select; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "combineReducers", function() { return combineReducers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return compose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createReducerFactory", function() { return createReducerFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ActionsSubject", function() { return ActionsSubject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INIT", function() { return INIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReducerManager", function() { return ReducerManager; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReducerObservable", function() { return ReducerObservable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReducerManagerDispatcher", function() { return ReducerManagerDispatcher; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE", function() { return UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ScannedActionsSubject", function() { return ScannedActionsSubject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createSelector", function() { return createSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createSelectorFactory", function() { return createSelectorFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createFeatureSelector", function() { return createFeatureSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultMemoize", function() { return defaultMemoize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultStateFn", function() { return defaultStateFn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "State", function() { return State; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StateObservable", function() { return StateObservable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reduceState", function() { return reduceState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INITIAL_STATE", function() { return INITIAL_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_REDUCER_FACTORY", function() { return _REDUCER_FACTORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REDUCER_FACTORY", function() { return REDUCER_FACTORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_INITIAL_REDUCERS", function() { return _INITIAL_REDUCERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INITIAL_REDUCERS", function() { return INITIAL_REDUCERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STORE_FEATURES", function() { return STORE_FEATURES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_INITIAL_STATE", function() { return _INITIAL_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "META_REDUCERS", function() { return META_REDUCERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_STORE_REDUCERS", function() { return _STORE_REDUCERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_FEATURE_REDUCERS", function() { return _FEATURE_REDUCERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FEATURE_REDUCERS", function() { return FEATURE_REDUCERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_FEATURE_REDUCERS_TOKEN", function() { return _FEATURE_REDUCERS_TOKEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StoreModule", function() { return StoreModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StoreRootModule", function() { return StoreRootModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StoreFeatureModule", function() { return StoreFeatureModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_initialStateFactory", function() { return _initialStateFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_createStoreReducers", function() { return _createStoreReducers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_createFeatureReducers", function() { return _createFeatureReducers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵc", function() { return ACTIONS_SUBJECT_PROVIDERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵd", function() { return REDUCER_MANAGER_PROVIDERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵe", function() { return SCANNED_ACTIONS_SUBJECT_PROVIDERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵf", function() { return STATE_PROVIDERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵb", function() { return STORE_PROVIDERS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__ = __webpack_require__("./node_modules/rxjs/Observable.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_operator_map__ = __webpack_require__("./node_modules/rxjs/operator/map.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_pluck__ = __webpack_require__("./node_modules/rxjs/operator/pluck.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_pluck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_operator_pluck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_distinctUntilChanged__ = __webpack_require__("./node_modules/rxjs/operator/distinctUntilChanged.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_distinctUntilChanged___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_operator_distinctUntilChanged__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_BehaviorSubject__ = __webpack_require__("./node_modules/rxjs/BehaviorSubject.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_BehaviorSubject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_rxjs_BehaviorSubject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_scheduler_queue__ = __webpack_require__("./node_modules/rxjs/scheduler/queue.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_scheduler_queue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs_scheduler_queue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_operator_observeOn__ = __webpack_require__("./node_modules/rxjs/operator/observeOn.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_operator_observeOn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_rxjs_operator_observeOn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs_operator_withLatestFrom__ = __webpack_require__("./node_modules/rxjs/operator/withLatestFrom.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs_operator_withLatestFrom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_rxjs_operator_withLatestFrom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rxjs_operator_scan__ = __webpack_require__("./node_modules/rxjs/operator/scan.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rxjs_operator_scan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_rxjs_operator_scan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rxjs_Subject__ = __webpack_require__("./node_modules/rxjs/Subject.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rxjs_Subject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_rxjs_Subject__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();











/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var INIT = ('@ngrx/store/init');
var ActionsSubject = /** @class */ (function (_super) {
    __extends(ActionsSubject, _super);
    function ActionsSubject() {
        return _super.call(this, { type: INIT }) || this;
    }
    /**
     * @param {?} action
     * @return {?}
     */
    ActionsSubject.prototype.next = function (action) {
        if (typeof action === 'undefined') {
            throw new TypeError("Actions must be objects");
        }
        else if (typeof action.type === 'undefined') {
            throw new TypeError("Actions must have a type property");
        }
        _super.prototype.next.call(this, action);
    };
    /**
     * @return {?}
     */
    ActionsSubject.prototype.complete = function () {
        /* noop */
    };
    /**
     * @return {?}
     */
    ActionsSubject.prototype.ngOnDestroy = function () {
        _super.prototype.complete.call(this);
    };
    return ActionsSubject;
}(__WEBPACK_IMPORTED_MODULE_5_rxjs_BehaviorSubject__["BehaviorSubject"]));
ActionsSubject.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
];
/** @nocollapse */
ActionsSubject.ctorParameters = function () { return []; };
var ACTIONS_SUBJECT_PROVIDERS = [ActionsSubject];
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var _INITIAL_STATE = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["InjectionToken"]('@ngrx/store Internal Initial State');
var INITIAL_STATE = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["InjectionToken"]('@ngrx/store Initial State');
var REDUCER_FACTORY = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["InjectionToken"]('@ngrx/store Reducer Factory');
var _REDUCER_FACTORY = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["InjectionToken"]('@ngrx/store Reducer Factory Provider');
var INITIAL_REDUCERS = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["InjectionToken"]('@ngrx/store Initial Reducers');
var _INITIAL_REDUCERS = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["InjectionToken"]('@ngrx/store Internal Initial Reducers');
var META_REDUCERS = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["InjectionToken"]('@ngrx/store Meta Reducers');
var STORE_FEATURES = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["InjectionToken"]('@ngrx/store Store Features');
var _STORE_REDUCERS = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["InjectionToken"]('@ngrx/store Internal Store Reducers');
var _FEATURE_REDUCERS = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["InjectionToken"]('@ngrx/store Internal Feature Reducers');
var _FEATURE_REDUCERS_TOKEN = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["InjectionToken"]('@ngrx/store Internal Feature Reducers Token');
var FEATURE_REDUCERS = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["InjectionToken"]('@ngrx/store Feature Reducers');
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @param {?} reducers
 * @param {?=} initialState
 * @return {?}
 */
function combineReducers(reducers, initialState) {
    if (initialState === void 0) { initialState = {}; }
    var /** @type {?} */ reducerKeys = Object.keys(reducers);
    var /** @type {?} */ finalReducers = {};
    for (var /** @type {?} */ i = 0; i < reducerKeys.length; i++) {
        var /** @type {?} */ key = reducerKeys[i];
        if (typeof reducers[key] === 'function') {
            finalReducers[key] = reducers[key];
        }
    }
    var /** @type {?} */ finalReducerKeys = Object.keys(finalReducers);
    return function combination(state, action) {
        state = state === undefined ? initialState : state;
        var /** @type {?} */ hasChanged = false;
        var /** @type {?} */ nextState = {};
        for (var /** @type {?} */ i = 0; i < finalReducerKeys.length; i++) {
            var /** @type {?} */ key = finalReducerKeys[i];
            var /** @type {?} */ reducer = finalReducers[key];
            var /** @type {?} */ previousStateForKey = state[key];
            var /** @type {?} */ nextStateForKey = reducer(previousStateForKey, action);
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        return hasChanged ? nextState : state;
    };
}
/**
 * @template T
 * @param {?} object
 * @param {?} keyToRemove
 * @return {?}
 */
function omit(object, keyToRemove) {
    return Object.keys(object)
        .filter(function (key) { return key !== keyToRemove; })
        .reduce(function (result, key) {
        return Object.assign(result, (_a = {}, _a[key] = object[key], _a));
        var _a;
    }, {});
}
/**
 * @param {...?} functions
 * @return {?}
 */
function compose() {
    var functions = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        functions[_i] = arguments[_i];
    }
    return function (arg) {
        if (functions.length === 0) {
            return arg;
        }
        var /** @type {?} */ last = functions[functions.length - 1];
        var /** @type {?} */ rest = functions.slice(0, -1);
        return rest.reduceRight(function (composed, fn) { return fn(composed); }, last(arg));
    };
}
/**
 * @template T, V
 * @param {?} reducerFactory
 * @param {?=} metaReducers
 * @return {?}
 */
function createReducerFactory(reducerFactory, metaReducers) {
    if (Array.isArray(metaReducers) && metaReducers.length > 0) {
        return compose.apply(null, metaReducers.concat([reducerFactory]));
    }
    return reducerFactory;
}
/**
 * @template T, V
 * @param {?=} metaReducers
 * @return {?}
 */
function createFeatureReducerFactory(metaReducers) {
    var /** @type {?} */ reducerFactory = Array.isArray(metaReducers) && metaReducers.length > 0
        ? compose.apply(void 0, metaReducers) : function (r) { return r; };
    return function (reducer, initialState) {
        reducer = reducerFactory(reducer);
        return function (state, action) {
            state = state === undefined ? initialState : state;
            return reducer(state, action);
        };
    };
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @abstract
 */
var ReducerObservable = /** @class */ (function (_super) {
    __extends(ReducerObservable, _super);
    function ReducerObservable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ReducerObservable;
}(__WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"]));
/**
 * @abstract
 */
var ReducerManagerDispatcher = /** @class */ (function (_super) {
    __extends(ReducerManagerDispatcher, _super);
    function ReducerManagerDispatcher() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ReducerManagerDispatcher;
}(ActionsSubject));
var UPDATE = ('@ngrx/store/update-reducers');
var ReducerManager = /** @class */ (function (_super) {
    __extends(ReducerManager, _super);
    /**
     * @param {?} dispatcher
     * @param {?} initialState
     * @param {?} reducers
     * @param {?} reducerFactory
     */
    function ReducerManager(dispatcher, initialState, reducers, reducerFactory) {
        var _this = _super.call(this, reducerFactory(reducers, initialState)) || this;
        _this.dispatcher = dispatcher;
        _this.initialState = initialState;
        _this.reducers = reducers;
        _this.reducerFactory = reducerFactory;
        return _this;
    }
    /**
     * @param {?} __0
     * @return {?}
     */
    ReducerManager.prototype.addFeature = function (_a) {
        var reducers = _a.reducers, reducerFactory = _a.reducerFactory, metaReducers = _a.metaReducers, initialState = _a.initialState, key = _a.key;
        var /** @type {?} */ reducer = typeof reducers === 'function'
            ? createFeatureReducerFactory(metaReducers)(reducers, initialState)
            : createReducerFactory(reducerFactory, metaReducers)(reducers, initialState);
        this.addReducer(key, reducer);
    };
    /**
     * @param {?} __0
     * @return {?}
     */
    ReducerManager.prototype.removeFeature = function (_a) {
        var key = _a.key;
        this.removeReducer(key);
    };
    /**
     * @param {?} key
     * @param {?} reducer
     * @return {?}
     */
    ReducerManager.prototype.addReducer = function (key, reducer) {
        this.reducers = Object.assign({}, this.reducers, (_a = {}, _a[key] = reducer, _a));
        this.updateReducers(key);
        var _a;
    };
    /**
     * @param {?} key
     * @return {?}
     */
    ReducerManager.prototype.removeReducer = function (key) {
        this.reducers = /** @type {?} */ (omit(this.reducers, key) /*TODO(#823)*/);
        this.updateReducers(key);
    };
    /**
     * @param {?} key
     * @return {?}
     */
    ReducerManager.prototype.updateReducers = function (key) {
        this.next(this.reducerFactory(this.reducers, this.initialState));
        this.dispatcher.next(/** @type {?} */ ({ type: UPDATE, feature: key }));
    };
    /**
     * @return {?}
     */
    ReducerManager.prototype.ngOnDestroy = function () {
        this.complete();
    };
    return ReducerManager;
}(__WEBPACK_IMPORTED_MODULE_5_rxjs_BehaviorSubject__["BehaviorSubject"]));
ReducerManager.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
];
/** @nocollapse */
ReducerManager.ctorParameters = function () { return [
    { type: ReducerManagerDispatcher, },
    { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [INITIAL_STATE,] },] },
    { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [INITIAL_REDUCERS,] },] },
    { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [REDUCER_FACTORY,] },] },
]; };
var REDUCER_MANAGER_PROVIDERS = [
    ReducerManager,
    { provide: ReducerObservable, useExisting: ReducerManager },
    { provide: ReducerManagerDispatcher, useExisting: ActionsSubject },
];
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var ScannedActionsSubject = /** @class */ (function (_super) {
    __extends(ScannedActionsSubject, _super);
    function ScannedActionsSubject() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @return {?}
     */
    ScannedActionsSubject.prototype.ngOnDestroy = function () {
        this.complete();
    };
    return ScannedActionsSubject;
}(__WEBPACK_IMPORTED_MODULE_10_rxjs_Subject__["Subject"]));
ScannedActionsSubject.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
];
/** @nocollapse */
ScannedActionsSubject.ctorParameters = function () { return []; };
var SCANNED_ACTIONS_SUBJECT_PROVIDERS = [
    ScannedActionsSubject,
];
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @abstract
 */
var StateObservable = /** @class */ (function (_super) {
    __extends(StateObservable, _super);
    function StateObservable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return StateObservable;
}(__WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"]));
var State = /** @class */ (function (_super) {
    __extends(State, _super);
    /**
     * @param {?} actions$
     * @param {?} reducer$
     * @param {?} scannedActions
     * @param {?} initialState
     */
    function State(actions$, reducer$, scannedActions, initialState) {
        var _this = _super.call(this, initialState) || this;
        var /** @type {?} */ actionsOnQueue$ = __WEBPACK_IMPORTED_MODULE_7_rxjs_operator_observeOn__["observeOn"].call(actions$, __WEBPACK_IMPORTED_MODULE_6_rxjs_scheduler_queue__["queue"]);
        var /** @type {?} */ withLatestReducer$ = __WEBPACK_IMPORTED_MODULE_8_rxjs_operator_withLatestFrom__["withLatestFrom"].call(actionsOnQueue$, reducer$);
        var /** @type {?} */ stateAndAction$ = __WEBPACK_IMPORTED_MODULE_9_rxjs_operator_scan__["scan"].call(withLatestReducer$, reduceState, { state: initialState });
        _this.stateSubscription = stateAndAction$.subscribe(function (_a) {
            var state = _a.state, action = _a.action;
            _this.next(state);
            scannedActions.next(action);
        });
        return _this;
    }
    /**
     * @return {?}
     */
    State.prototype.ngOnDestroy = function () {
        this.stateSubscription.unsubscribe();
        this.complete();
    };
    return State;
}(__WEBPACK_IMPORTED_MODULE_5_rxjs_BehaviorSubject__["BehaviorSubject"]));
State.INIT = INIT;
State.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
];
/** @nocollapse */
State.ctorParameters = function () { return [
    { type: ActionsSubject, },
    { type: ReducerObservable, },
    { type: ScannedActionsSubject, },
    { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [INITIAL_STATE,] },] },
]; };
/**
 * @template T, V
 * @param {?=} stateActionPair
 * @param {?=} __1
 * @return {?}
 */
function reduceState(stateActionPair, _a) {
    if (stateActionPair === void 0) { stateActionPair = { state: undefined }; }
    var action = _a[0], reducer = _a[1];
    var state = stateActionPair.state;
    return { state: reducer(state, action), action: action };
}
var STATE_PROVIDERS = [
    State,
    { provide: StateObservable, useExisting: State },
];
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var Store = /** @class */ (function (_super) {
    __extends(Store, _super);
    /**
     * @param {?} state$
     * @param {?} actionsObserver
     * @param {?} reducerManager
     */
    function Store(state$, actionsObserver, reducerManager) {
        var _this = _super.call(this) || this;
        _this.actionsObserver = actionsObserver;
        _this.reducerManager = reducerManager;
        _this.source = state$;
        return _this;
    }
    /**
     * @param {?} pathOrMapFn
     * @param {...?} paths
     * @return {?}
     */
    Store.prototype.select = function (pathOrMapFn) {
        var paths = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            paths[_i - 1] = arguments[_i];
        }
        return select.apply(void 0, [pathOrMapFn].concat(paths))(this);
    };
    /**
     * @template R
     * @param {?} operator
     * @return {?}
     */
    Store.prototype.lift = function (operator) {
        var /** @type {?} */ store = new Store(this, this.actionsObserver, this.reducerManager);
        store.operator = operator;
        return store;
    };
    /**
     * @template V
     * @param {?} action
     * @return {?}
     */
    Store.prototype.dispatch = function (action) {
        this.actionsObserver.next(action);
    };
    /**
     * @param {?} action
     * @return {?}
     */
    Store.prototype.next = function (action) {
        this.actionsObserver.next(action);
    };
    /**
     * @param {?} err
     * @return {?}
     */
    Store.prototype.error = function (err) {
        this.actionsObserver.error(err);
    };
    /**
     * @return {?}
     */
    Store.prototype.complete = function () {
        this.actionsObserver.complete();
    };
    /**
     * @template State, Actions
     * @param {?} key
     * @param {?} reducer
     * @return {?}
     */
    Store.prototype.addReducer = function (key, reducer) {
        this.reducerManager.addReducer(key, reducer);
    };
    /**
     * @template Key
     * @param {?} key
     * @return {?}
     */
    Store.prototype.removeReducer = function (key) {
        this.reducerManager.removeReducer(key);
    };
    return Store;
}(__WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"]));
Store.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
];
/** @nocollapse */
Store.ctorParameters = function () { return [
    { type: StateObservable, },
    { type: ActionsSubject, },
    { type: ReducerManager, },
]; };
var STORE_PROVIDERS = [Store];
/**
 * @template T, K
 * @param {?} pathOrMapFn
 * @param {...?} paths
 * @return {?}
 */
function select(pathOrMapFn) {
    var paths = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        paths[_i - 1] = arguments[_i];
    }
    return function selectOperator(source$) {
        var /** @type {?} */ mapped$;
        if (typeof pathOrMapFn === 'string') {
            mapped$ = __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_pluck__["pluck"].call.apply(__WEBPACK_IMPORTED_MODULE_3_rxjs_operator_pluck__["pluck"], [source$, pathOrMapFn].concat(paths));
        }
        else if (typeof pathOrMapFn === 'function') {
            mapped$ = __WEBPACK_IMPORTED_MODULE_2_rxjs_operator_map__["map"].call(source$, pathOrMapFn);
        }
        else {
            throw new TypeError("Unexpected type '" + typeof pathOrMapFn + "' in select operator," +
                " expected 'string' or 'function'");
        }
        return __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_distinctUntilChanged__["distinctUntilChanged"].call(mapped$);
    };
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @record
 */
/**
 * @param {?} a
 * @param {?} b
 * @return {?}
 */
function isEqualCheck(a, b) {
    return a === b;
}
/**
 * @param {?} t
 * @param {?=} isEqual
 * @return {?}
 */
function defaultMemoize(t, isEqual) {
    if (isEqual === void 0) { isEqual = isEqualCheck; }
    var /** @type {?} */ lastArguments = null;
    var /** @type {?} */ lastResult = null;
    /**
     * @return {?}
     */
    function reset() {
        lastArguments = null;
        lastResult = null;
    }
    /**
     * @return {?}
     */
    function memoized() {
        if (!lastArguments) {
            lastResult = t.apply(null, arguments);
            lastArguments = arguments;
            return lastResult;
        }
        for (var /** @type {?} */ i = 0; i < arguments.length; i++) {
            if (!isEqual(arguments[i], lastArguments[i])) {
                lastResult = t.apply(null, arguments);
                lastArguments = arguments;
                return lastResult;
            }
        }
        return lastResult;
    }
    return { memoized: memoized, reset: reset };
}
/**
 * @param {...?} input
 * @return {?}
 */
function createSelector() {
    var input = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        input[_i] = arguments[_i];
    }
    return createSelectorFactory(defaultMemoize).apply(void 0, input);
}
/**
 * @param {?} state
 * @param {?} selectors
 * @param {?} memoizedProjector
 * @return {?}
 */
function defaultStateFn(state, selectors, memoizedProjector) {
    var /** @type {?} */ args = selectors.map(function (fn) { return fn(state); });
    return memoizedProjector.memoized.apply(null, args);
}
/**
 * @param {?} memoize
 * @param {?=} options
 * @return {?}
 */
function createSelectorFactory(memoize, options) {
    if (options === void 0) { options = {
        stateFn: defaultStateFn,
    }; }
    return function () {
        var input = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            input[_i] = arguments[_i];
        }
        var /** @type {?} */ args = input;
        if (Array.isArray(args[0])) {
            var head = args[0], tail = args.slice(1);
            args = head.concat(tail);
        }
        var /** @type {?} */ selectors = args.slice(0, args.length - 1);
        var /** @type {?} */ projector = args[args.length - 1];
        var /** @type {?} */ memoizedSelectors = selectors.filter(function (selector) { return selector.release && typeof selector.release === 'function'; });
        var /** @type {?} */ memoizedProjector = memoize(function () {
            var selectors = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                selectors[_i] = arguments[_i];
            }
            return projector.apply(null, selectors);
        });
        var /** @type {?} */ memoizedState = defaultMemoize(function (state) {
            return options.stateFn.apply(null, [state, selectors, memoizedProjector]);
        });
        /**
         * @return {?}
         */
        function release() {
            memoizedState.reset();
            memoizedProjector.reset();
            memoizedSelectors.forEach(function (selector) { return selector.release(); });
        }
        return Object.assign(memoizedState.memoized, {
            release: release,
            projector: memoizedProjector.memoized,
        });
    };
}
/**
 * @template T
 * @param {?} featureName
 * @return {?}
 */
function createFeatureSelector(featureName) {
    return createSelector(function (state) { return state[featureName]; }, function (featureState) { return featureState; });
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var StoreRootModule = /** @class */ (function () {
    /**
     * @param {?} actions$
     * @param {?} reducer$
     * @param {?} scannedActions$
     * @param {?} store
     */
    function StoreRootModule(actions$, reducer$, scannedActions$, store) {
    }
    return StoreRootModule;
}());
StoreRootModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{},] },
];
/** @nocollapse */
StoreRootModule.ctorParameters = function () { return [
    { type: ActionsSubject, },
    { type: ReducerObservable, },
    { type: ScannedActionsSubject, },
    { type: Store, },
]; };
var StoreFeatureModule = /** @class */ (function () {
    /**
     * @param {?} features
     * @param {?} featureReducers
     * @param {?} reducerManager
     * @param {?} root
     */
    function StoreFeatureModule(features, featureReducers, reducerManager, root) {
        this.features = features;
        this.featureReducers = featureReducers;
        this.reducerManager = reducerManager;
        features
            .map(function (feature, index) {
            var /** @type {?} */ featureReducerCollection = featureReducers.shift();
            var /** @type {?} */ reducers = ((featureReducerCollection))[index];
            return Object.assign({}, feature, { reducers: reducers, initialState: _initialStateFactory(feature.initialState) });
        })
            .forEach(function (feature) { return reducerManager.addFeature(feature); });
    }
    /**
     * @return {?}
     */
    StoreFeatureModule.prototype.ngOnDestroy = function () {
        var _this = this;
        this.features.forEach(function (feature) { return _this.reducerManager.removeFeature(feature); });
    };
    return StoreFeatureModule;
}());
StoreFeatureModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{},] },
];
/** @nocollapse */
StoreFeatureModule.ctorParameters = function () { return [
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [STORE_FEATURES,] },] },
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [FEATURE_REDUCERS,] },] },
    { type: ReducerManager, },
    { type: StoreRootModule, },
]; };
var StoreModule = /** @class */ (function () {
    function StoreModule() {
    }
    /**
     * @param {?} reducers
     * @param {?=} config
     * @return {?}
     */
    StoreModule.forRoot = function (reducers, config) {
        if (config === void 0) { config = {}; }
        return {
            ngModule: StoreRootModule,
            providers: [
                { provide: _INITIAL_STATE, useValue: config.initialState },
                {
                    provide: INITIAL_STATE,
                    useFactory: _initialStateFactory,
                    deps: [_INITIAL_STATE],
                },
                { provide: _INITIAL_REDUCERS, useValue: reducers },
                {
                    provide: _STORE_REDUCERS,
                    useExisting: reducers instanceof __WEBPACK_IMPORTED_MODULE_0__angular_core__["InjectionToken"] ? reducers : _INITIAL_REDUCERS,
                },
                {
                    provide: INITIAL_REDUCERS,
                    deps: [__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injector"], _INITIAL_REDUCERS, [new __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"](_STORE_REDUCERS)]],
                    useFactory: _createStoreReducers,
                },
                {
                    provide: META_REDUCERS,
                    useValue: config.metaReducers ? config.metaReducers : [],
                },
                {
                    provide: _REDUCER_FACTORY,
                    useValue: config.reducerFactory
                        ? config.reducerFactory
                        : combineReducers,
                },
                {
                    provide: REDUCER_FACTORY,
                    deps: [_REDUCER_FACTORY, META_REDUCERS],
                    useFactory: createReducerFactory,
                },
                ACTIONS_SUBJECT_PROVIDERS,
                REDUCER_MANAGER_PROVIDERS,
                SCANNED_ACTIONS_SUBJECT_PROVIDERS,
                STATE_PROVIDERS,
                STORE_PROVIDERS,
            ],
        };
    };
    /**
     * @param {?} featureName
     * @param {?} reducers
     * @param {?=} config
     * @return {?}
     */
    StoreModule.forFeature = function (featureName, reducers, config) {
        if (config === void 0) { config = {}; }
        return {
            ngModule: StoreFeatureModule,
            providers: [
                {
                    provide: STORE_FEATURES,
                    multi: true,
                    useValue: /** @type {?} */ ({
                        key: featureName,
                        reducerFactory: config.reducerFactory
                            ? config.reducerFactory
                            : combineReducers,
                        metaReducers: config.metaReducers ? config.metaReducers : [],
                        initialState: config.initialState,
                    }),
                },
                { provide: _FEATURE_REDUCERS, multi: true, useValue: reducers },
                {
                    provide: _FEATURE_REDUCERS_TOKEN,
                    multi: true,
                    useExisting: reducers instanceof __WEBPACK_IMPORTED_MODULE_0__angular_core__["InjectionToken"] ? reducers : _FEATURE_REDUCERS,
                },
                {
                    provide: FEATURE_REDUCERS,
                    multi: true,
                    deps: [
                        __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injector"],
                        _FEATURE_REDUCERS,
                        [new __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"](_FEATURE_REDUCERS_TOKEN)],
                    ],
                    useFactory: _createFeatureReducers,
                },
            ],
        };
    };
    return StoreModule;
}());
StoreModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{},] },
];
/** @nocollapse */
StoreModule.ctorParameters = function () { return []; };
/**
 * @param {?} injector
 * @param {?} reducers
 * @param {?} tokenReducers
 * @return {?}
 */
function _createStoreReducers(injector, reducers, tokenReducers) {
    return reducers instanceof __WEBPACK_IMPORTED_MODULE_0__angular_core__["InjectionToken"] ? injector.get(reducers) : reducers;
}
/**
 * @param {?} injector
 * @param {?} reducerCollection
 * @param {?} tokenReducerCollection
 * @return {?}
 */
function _createFeatureReducers(injector, reducerCollection, tokenReducerCollection) {
    var /** @type {?} */ reducers = reducerCollection.map(function (reducer, index) {
        return reducer instanceof __WEBPACK_IMPORTED_MODULE_0__angular_core__["InjectionToken"] ? injector.get(reducer) : reducer;
    });
    return reducers;
}
/**
 * @param {?} initialState
 * @return {?}
 */
function _initialStateFactory(initialState) {
    if (typeof initialState === 'function') {
        return initialState();
    }
    return initialState;
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Generated bundle index. Do not edit.
 */

//# sourceMappingURL=store.es5.js.map


/***/ }),

/***/ "./node_modules/angular2-multiselect-dropdown/clickOutside.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClickOutsideDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ScrollDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return styleDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setPosition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");

var ClickOutsideDirective = /** @class */ (function () {
    function ClickOutsideDirective(_elementRef) {
        this._elementRef = _elementRef;
        this.clickOutside = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
    }
    ClickOutsideDirective.prototype.onClick = function (event, targetElement) {
        if (!targetElement) {
            return;
        }
        var clickedInside = this._elementRef.nativeElement.contains(targetElement);
        if (!clickedInside) {
            this.clickOutside.emit(event);
        }
    };
    ClickOutsideDirective.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: '[clickOutside]'
                },] },
    ];
    /** @nocollapse */
    ClickOutsideDirective.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    ]; };
    ClickOutsideDirective.propDecorators = {
        'clickOutside': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        'onClick': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"], args: ['document:click', ['$event', '$event.target'],] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"], args: ['document:touchstart', ['$event', '$event.target'],] },],
    };
    return ClickOutsideDirective;
}());

var ScrollDirective = /** @class */ (function () {
    function ScrollDirective(_elementRef) {
        this._elementRef = _elementRef;
        this.scroll = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
    }
    ScrollDirective.prototype.onClick = function (event, targetElement) {
        this.scroll.emit(event);
    };
    ScrollDirective.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: '[scroll]'
                },] },
    ];
    /** @nocollapse */
    ScrollDirective.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    ]; };
    ScrollDirective.propDecorators = {
        'scroll': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        'onClick': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"], args: ['scroll', ['$event'],] },],
    };
    return ScrollDirective;
}());

var styleDirective = /** @class */ (function () {
    function styleDirective(el) {
        this.el = el;
    }
    styleDirective.prototype.ngOnInit = function () {
        this.el.nativeElement.style.top = this.styleVal;
    };
    styleDirective.prototype.ngOnChanges = function () {
        this.el.nativeElement.style.top = this.styleVal;
    };
    styleDirective.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: '[styleProp]'
                },] },
    ];
    /** @nocollapse */
    styleDirective.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    ]; };
    styleDirective.propDecorators = {
        'styleVal': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['styleProp',] },],
    };
    return styleDirective;
}());

var setPosition = /** @class */ (function () {
    function setPosition(el) {
        this.el = el;
    }
    setPosition.prototype.ngOnInit = function () {
        if (this.height) {
            this.el.nativeElement.style.bottom = parseInt(this.height + 15 + "") + 'px';
        }
    };
    setPosition.prototype.ngOnChanges = function () {
        if (this.height) {
            this.el.nativeElement.style.bottom = parseInt(this.height + 15 + "") + 'px';
        }
    };
    setPosition.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: '[setPosition]'
                },] },
    ];
    /** @nocollapse */
    setPosition.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    ]; };
    setPosition.propDecorators = {
        'height': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['setPosition',] },],
    };
    return setPosition;
}());

//# sourceMappingURL=clickOutside.js.map

/***/ }),

/***/ "./node_modules/angular2-multiselect-dropdown/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__multiselect_component__ = __webpack_require__("./node_modules/angular2-multiselect-dropdown/multiselect.component.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AngularMultiSelect", function() { return __WEBPACK_IMPORTED_MODULE_0__multiselect_component__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__clickOutside__ = __webpack_require__("./node_modules/angular2-multiselect-dropdown/clickOutside.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ClickOutsideDirective", function() { return __WEBPACK_IMPORTED_MODULE_1__clickOutside__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__list_filter__ = __webpack_require__("./node_modules/angular2-multiselect-dropdown/list-filter.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ListFilterPipe", function() { return __WEBPACK_IMPORTED_MODULE_2__list_filter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__menu_item__ = __webpack_require__("./node_modules/angular2-multiselect-dropdown/menu-item.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Item", function() { return __WEBPACK_IMPORTED_MODULE_3__menu_item__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TemplateRenderer", function() { return __WEBPACK_IMPORTED_MODULE_3__menu_item__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AngularMultiSelectModule", function() { return __WEBPACK_IMPORTED_MODULE_0__multiselect_component__["b"]; });






//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./node_modules/angular2-multiselect-dropdown/list-filter.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ListFilterPipe; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__multiselect_service__ = __webpack_require__("./node_modules/angular2-multiselect-dropdown/multiselect.service.js");


var ListFilterPipe = /** @class */ (function () {
    function ListFilterPipe(ds) {
        this.ds = ds;
        this.filteredList = [];
    }
    ListFilterPipe.prototype.transform = function (items, filter, searchBy) {
        var _this = this;
        if (!items || !filter) {
            this.ds.setData(items);
            return items;
        }
        this.filteredList = items.filter(function (item) { return _this.applyFilter(item, filter, searchBy); });
        this.ds.setData(this.filteredList);
        return this.filteredList;
    };
    ListFilterPipe.prototype.applyFilter = function (item, filter, searchBy) {
        var found = false;
        if (searchBy.length > 0) {
            for (var t = 0; t < searchBy.length; t++) {
                if (filter && item[searchBy[t]] && item[searchBy[t]] != "") {
                    if (item[searchBy[t]].toString().toLowerCase().indexOf(filter.toLowerCase()) >= 0) {
                        found = true;
                    }
                }
            }
        }
        else {
            for (var prop in item) {
                if (filter && item[prop]) {
                    if (item[prop].toString().toLowerCase().indexOf(filter.toLowerCase()) >= 0) {
                        found = true;
                    }
                }
            }
        }
        return found;
    };
    ListFilterPipe.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Pipe"], args: [{
                    name: 'listFilter',
                    pure: true
                },] },
    ];
    /** @nocollapse */
    ListFilterPipe.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__multiselect_service__["a" /* DataService */], },
    ]; };
    return ListFilterPipe;
}());

//# sourceMappingURL=list-filter.js.map

/***/ }),

/***/ "./node_modules/angular2-multiselect-dropdown/menu-item.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Item; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Badge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Search; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TemplateRenderer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");

var Item = /** @class */ (function () {
    function Item() {
    }
    Item.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'c-item',
                    template: ""
                },] },
    ];
    /** @nocollapse */
    Item.ctorParameters = function () { return []; };
    Item.propDecorators = {
        'template': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChild"], args: [__WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"],] },],
    };
    return Item;
}());

var Badge = /** @class */ (function () {
    function Badge() {
    }
    Badge.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'c-badge',
                    template: ""
                },] },
    ];
    /** @nocollapse */
    Badge.ctorParameters = function () { return []; };
    Badge.propDecorators = {
        'template': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChild"], args: [__WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"],] },],
    };
    return Badge;
}());

var Search = /** @class */ (function () {
    function Search() {
    }
    Search.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'c-search',
                    template: ""
                },] },
    ];
    /** @nocollapse */
    Search.ctorParameters = function () { return []; };
    Search.propDecorators = {
        'template': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChild"], args: [__WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"],] },],
    };
    return Search;
}());

var TemplateRenderer = /** @class */ (function () {
    function TemplateRenderer(viewContainer) {
        this.viewContainer = viewContainer;
    }
    TemplateRenderer.prototype.ngOnInit = function () {
        this.view = this.viewContainer.createEmbeddedView(this.data.template, {
            '\$implicit': this.data,
            'item': this.item
        });
    };
    TemplateRenderer.prototype.ngOnDestroy = function () {
        this.view.destroy();
    };
    TemplateRenderer.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'c-templateRenderer',
                    template: ""
                },] },
    ];
    /** @nocollapse */
    TemplateRenderer.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"], },
    ]; };
    TemplateRenderer.propDecorators = {
        'data': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'item': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return TemplateRenderer;
}());

//# sourceMappingURL=menu-item.js.map

/***/ }),

/***/ "./node_modules/angular2-multiselect-dropdown/multiselect.component.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DROPDOWN_CONTROL_VALUE_ACCESSOR */
/* unused harmony export DROPDOWN_CONTROL_VALIDATION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AngularMultiSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AngularMultiSelectModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__("./node_modules/@angular/forms/esm5/forms.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_common__ = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__multiselect_model__ = __webpack_require__("./node_modules/angular2-multiselect-dropdown/multiselect.model.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__clickOutside__ = __webpack_require__("./node_modules/angular2-multiselect-dropdown/clickOutside.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__list_filter__ = __webpack_require__("./node_modules/angular2-multiselect-dropdown/list-filter.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__menu_item__ = __webpack_require__("./node_modules/angular2-multiselect-dropdown/menu-item.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__multiselect_service__ = __webpack_require__("./node_modules/angular2-multiselect-dropdown/multiselect.service.js");








var DROPDOWN_CONTROL_VALUE_ACCESSOR = {
    provide: __WEBPACK_IMPORTED_MODULE_1__angular_forms__["NG_VALUE_ACCESSOR"],
    useExisting: Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return AngularMultiSelect; }),
    multi: true
};
var DROPDOWN_CONTROL_VALIDATION = {
    provide: __WEBPACK_IMPORTED_MODULE_1__angular_forms__["NG_VALIDATORS"],
    useExisting: Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return AngularMultiSelect; }),
    multi: true,
};
var noop = function () {
};
var AngularMultiSelect = /** @class */ (function () {
    function AngularMultiSelect(_elementRef, cdr, ds) {
        this._elementRef = _elementRef;
        this.cdr = cdr;
        this.ds = ds;
        this.onSelect = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.onDeSelect = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.onSelectAll = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.onDeSelectAll = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.onOpen = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.onClose = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.isActive = false;
        this.isSelectAll = false;
        this.isFilterSelectAll = false;
        this.isInfiniteFilterSelectAll = false;
        this.chunkIndex = [];
        this.cachedItems = [];
        this.itemHeight = 41.6;
        this.filterLength = 0;
        this.infiniteFilterLength = 0;
        this.defaultSettings = {
            singleSelection: false,
            text: 'Select',
            enableCheckAll: true,
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            filterSelectAllText: 'Select all filtered results',
            filterUnSelectAllText: 'UnSelect all filtered results',
            enableSearchFilter: false,
            searchBy: [],
            maxHeight: 300,
            badgeShowLimit: 999999999999,
            classes: '',
            disabled: false,
            searchPlaceholderText: 'Search',
            showCheckbox: true,
            noDataLabel: 'No Data Available',
            searchAutofocus: true,
            lazyLoading: false,
            labelKey: 'itemName',
            primaryKey: 'id',
            position: 'bottom',
            enableFilterSelectAll: true
        };
        this.filteredList = [];
        this.onTouchedCallback = noop;
        this.onChangeCallback = noop;
    }
    AngularMultiSelect.prototype.ngOnInit = function () {
        var _this = this;
        this.settings = Object.assign(this.defaultSettings, this.settings);
        if (this.settings.groupBy) {
            this.groupedData = this.transformData(this.data, this.settings.groupBy);
        }
        this.totalRows = (this.data && this.data.length);
        this.cachedItems = this.data;
        this.screenItemsLen = Math.ceil(this.settings.maxHeight / this.itemHeight);
        this.cachedItemsLen = this.screenItemsLen * 3;
        this.totalHeight = this.itemHeight * this.totalRows;
        this.maxBuffer = this.screenItemsLen * this.itemHeight;
        this.lastScrolled = 0;
        this.renderChunk(0, this.cachedItemsLen / 2);
        if (this.settings.position == 'top') {
            setTimeout(function () {
                _this.selectedListHeight = { val: 0 };
                _this.selectedListHeight.val = _this.selectedListElem.nativeElement.clientHeight;
            });
        }
        this.subscription = this.ds.getData().subscribe(function (data) {
            _this.filterLength = data.length;
            _this.onFilterChange(data);
        });
    };
    AngularMultiSelect.prototype.ngOnChanges = function (changes) {
        if (changes.data && !changes.data.firstChange) {
            if (this.settings.groupBy) {
                this.groupedData = this.transformData(this.data, this.settings.groupBy);
                if (this.data.length == 0) {
                    this.selectedItems = [];
                }
            }
        }
        if (changes.settings && !changes.settings.firstChange) {
            this.settings = Object.assign(this.defaultSettings, this.settings);
        }
    };
    AngularMultiSelect.prototype.ngDoCheck = function () {
        if (this.selectedItems) {
            if (this.selectedItems.length == 0 || this.data.length == 0 || this.selectedItems.length < this.data.length) {
                this.isSelectAll = false;
            }
        }
    };
    AngularMultiSelect.prototype.ngAfterViewInit = function () {
        if (this.settings.lazyLoading) {
            this._elementRef.nativeElement.getElementsByClassName("lazyContainer")[0].addEventListener('scroll', this.onScroll.bind(this));
        }
    };
    AngularMultiSelect.prototype.ngAfterViewChecked = function () {
        if (this.selectedListElem.nativeElement.clientHeight && this.settings.position == 'top' && this.selectedListHeight) {
            this.selectedListHeight.val = this.selectedListElem.nativeElement.clientHeight;
            this.cdr.detectChanges();
        }
    };
    AngularMultiSelect.prototype.onItemClick = function (item, index, evt) {
        if (this.settings.disabled) {
            return false;
        }
        var found = this.isSelected(item);
        var limit = this.selectedItems.length < this.settings.limitSelection ? true : false;
        if (!found) {
            if (this.settings.limitSelection) {
                if (limit) {
                    this.addSelected(item);
                    this.onSelect.emit(item);
                }
            }
            else {
                this.addSelected(item);
                this.onSelect.emit(item);
            }
        }
        else {
            this.removeSelected(item);
            this.onDeSelect.emit(item);
        }
        if (this.isSelectAll || this.data.length > this.selectedItems.length) {
            this.isSelectAll = false;
        }
        if (this.data.length == this.selectedItems.length) {
            this.isSelectAll = true;
        }
    };
    AngularMultiSelect.prototype.validate = function (c) {
        return null;
    };
    AngularMultiSelect.prototype.writeValue = function (value) {
        if (value !== undefined && value !== null) {
            if (this.settings.singleSelection) {
                try {
                    if (value.length > 1) {
                        this.selectedItems = [value[0]];
                        throw new __WEBPACK_IMPORTED_MODULE_3__multiselect_model__["a" /* MyException */](404, { "msg": "Single Selection Mode, Selected Items cannot have more than one item." });
                    }
                    else {
                        this.selectedItems = value;
                    }
                }
                catch (e) {
                    console.error(e.body.msg);
                }
            }
            else {
                if (this.settings.limitSelection) {
                    this.selectedItems = value.slice(0, this.settings.limitSelection);
                }
                else {
                    this.selectedItems = value;
                }
                if (this.selectedItems.length === this.data.length && this.data.length > 0) {
                    this.isSelectAll = true;
                }
            }
        }
        else {
            this.selectedItems = [];
        }
    };
    //From ControlValueAccessor interface
    AngularMultiSelect.prototype.registerOnChange = function (fn) {
        this.onChangeCallback = fn;
    };
    //From ControlValueAccessor interface
    AngularMultiSelect.prototype.registerOnTouched = function (fn) {
        this.onTouchedCallback = fn;
    };
    AngularMultiSelect.prototype.trackByFn = function (index, item) {
        return item[this.settings.primaryKey];
    };
    AngularMultiSelect.prototype.isSelected = function (clickedItem) {
        var _this = this;
        var found = false;
        this.selectedItems && this.selectedItems.forEach(function (item) {
            if (clickedItem[_this.settings.primaryKey] === item[_this.settings.primaryKey]) {
                found = true;
            }
        });
        return found;
    };
    AngularMultiSelect.prototype.addSelected = function (item) {
        if (this.settings.singleSelection) {
            this.selectedItems = [];
            this.selectedItems.push(item);
            this.closeDropdown();
        }
        else
            this.selectedItems.push(item);
        this.onChangeCallback(this.selectedItems);
        this.onTouchedCallback(this.selectedItems);
    };
    AngularMultiSelect.prototype.removeSelected = function (clickedItem) {
        var _this = this;
        this.selectedItems && this.selectedItems.forEach(function (item) {
            if (clickedItem[_this.settings.primaryKey] === item[_this.settings.primaryKey]) {
                _this.selectedItems.splice(_this.selectedItems.indexOf(item), 1);
            }
        });
        this.onChangeCallback(this.selectedItems);
        this.onTouchedCallback(this.selectedItems);
    };
    AngularMultiSelect.prototype.toggleDropdown = function (evt) {
        var _this = this;
        if (this.settings.disabled) {
            return false;
        }
        this.isActive = !this.isActive;
        if (this.isActive && this.searchInput) {
            if (this.settings.searchAutofocus && this.settings.enableSearchFilter && !this.searchTempl) {
                setTimeout(function () {
                    _this.searchInput.nativeElement.focus();
                }, 0);
            }
            this.onOpen.emit(true);
        }
        else {
            this.onClose.emit(false);
        }
        evt.preventDefault();
    };
    AngularMultiSelect.prototype.closeDropdown = function () {
        if (this.searchInput && this.settings.lazyLoading) {
            this.searchInput.nativeElement.value = "";
            this.data = [];
            this.data = this.cachedItems;
            this.totalHeight = this.itemHeight * this.data.length;
            this.totalRows = this.data.length;
            this.updateView(this.scrollTop);
        }
        if (this.searchInput) {
            this.searchInput.nativeElement.value = "";
        }
        this.filter = "";
        this.isActive = false;
        this.onClose.emit(false);
    };
    AngularMultiSelect.prototype.toggleSelectAll = function () {
        console.log(this.ds.getData());
        console.log(this.filter);
        if (!this.isSelectAll) {
            this.selectedItems = [];
            this.selectedItems = this.data.slice();
            this.isSelectAll = true;
            this.onChangeCallback(this.selectedItems);
            this.onTouchedCallback(this.selectedItems);
            this.onSelectAll.emit(this.selectedItems);
        }
        else {
            this.selectedItems = [];
            this.isSelectAll = false;
            this.onChangeCallback(this.selectedItems);
            this.onTouchedCallback(this.selectedItems);
            this.onDeSelectAll.emit(this.selectedItems);
        }
    };
    AngularMultiSelect.prototype.toggleFilterSelectAll = function () {
        var _this = this;
        if (!this.isFilterSelectAll) {
            this.ds.getFilteredData().forEach(function (item) {
                if (!_this.isSelected(item)) {
                    _this.addSelected(item);
                }
            });
            this.isFilterSelectAll = true;
        }
        else {
            this.ds.getFilteredData().forEach(function (item) {
                if (_this.isSelected(item)) {
                    _this.removeSelected(item);
                }
            });
            this.isFilterSelectAll = false;
        }
    };
    AngularMultiSelect.prototype.toggleInfiniteFilterSelectAll = function () {
        var _this = this;
        if (!this.isInfiniteFilterSelectAll) {
            this.data.forEach(function (item) {
                if (!_this.isSelected(item)) {
                    _this.addSelected(item);
                }
            });
            this.isInfiniteFilterSelectAll = true;
        }
        else {
            this.data.forEach(function (item) {
                if (_this.isSelected(item)) {
                    _this.removeSelected(item);
                }
            });
            this.isInfiniteFilterSelectAll = false;
        }
    };
    AngularMultiSelect.prototype.clearSearch = function () {
        this.filter = "";
        this.isFilterSelectAll = false;
    };
    AngularMultiSelect.prototype.onFilterChange = function (data) {
        var _this = this;
        if (this.filter && this.filter == "" || data.length == 0) {
            this.isFilterSelectAll = false;
        }
        var cnt = 0;
        data.forEach(function (item) {
            if (_this.isSelected(item)) {
                cnt++;
            }
        });
        if (cnt > 0 && this.filterLength == cnt) {
            this.isFilterSelectAll = true;
        }
        else if (cnt > 0 && this.filterLength != cnt) {
            this.isFilterSelectAll = false;
        }
        this.cdr.detectChanges();
    };
    AngularMultiSelect.prototype.transformData = function (arr, field) {
        var groupedObj = arr.reduce(function (prev, cur) {
            if (!prev[cur[field]]) {
                prev[cur[field]] = [cur];
            }
            else {
                prev[cur[field]].push(cur);
            }
            return prev;
        }, {});
        var tempArr = [];
        Object.keys(groupedObj).map(function (x) {
            tempArr.push({ key: x, value: groupedObj[x] });
        });
        return tempArr;
    };
    AngularMultiSelect.prototype.renderChunk = function (fromPos, howMany) {
        this.chunkArray = [];
        this.chunkIndex = [];
        var finalItem = fromPos + howMany;
        if (finalItem > this.totalRows)
            finalItem = this.totalRows;
        for (var i = fromPos; i < finalItem; i++) {
            this.chunkIndex.push((i * this.itemHeight) + 'px');
            this.chunkArray.push(this.data[i]);
        }
    };
    AngularMultiSelect.prototype.onScroll = function (e) {
        this.scrollTop = e.target.scrollTop;
        this.updateView(this.scrollTop);
    };
    AngularMultiSelect.prototype.updateView = function (scrollTop) {
        var scrollPos = scrollTop ? scrollTop : 0;
        var first = (scrollPos / this.itemHeight) - this.screenItemsLen;
        var firstTemp = "" + first;
        first = parseInt(firstTemp) < 0 ? 0 : parseInt(firstTemp);
        this.renderChunk(first, this.cachedItemsLen);
        this.lastRepaintY = scrollPos;
    };
    AngularMultiSelect.prototype.filterInfiniteList = function (evt) {
        var filteredElems = [];
        this.data = this.cachedItems.slice();
        if (evt.target.value.toString() != '') {
            this.data.filter(function (el) {
                for (var prop in el) {
                    if (el[prop].toString().toLowerCase().indexOf(evt.target.value.toString().toLowerCase()) >= 0) {
                        filteredElems.push(el);
                        break;
                    }
                }
            });
            //this.cachedItems = this.data;
            this.totalHeight = this.itemHeight * filteredElems.length;
            this.totalRows = filteredElems.length;
            this.data = [];
            this.data = filteredElems;
            this.infiniteFilterLength = this.data.length;
            this.updateView(this.scrollTop);
        }
        else if (evt.target.value.toString() == '' && this.cachedItems.length > 0) {
            this.data = [];
            this.data = this.cachedItems;
            this.totalHeight = this.itemHeight * this.data.length;
            this.totalRows = this.data.length;
            this.infiniteFilterLength = 0;
            this.updateView(this.scrollTop);
        }
    };
    AngularMultiSelect.prototype.resetInfiniteSearch = function () {
        this.filter = "";
        this.isInfiniteFilterSelectAll = false;
        this.data = [];
        this.data = this.cachedItems;
        this.totalHeight = this.itemHeight * this.data.length;
        this.totalRows = this.data.length;
        this.infiniteFilterLength = 0;
        this.updateView(this.scrollTop);
    };
    AngularMultiSelect.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
    };
    AngularMultiSelect.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'angular2-multiselect',
                    template: "\n      <div class=\"cuppa-dropdown\" (clickOutside)=\"closeDropdown()\">\n          <div class=\"selected-list\" #selectedList>\n              <div class=\"c-btn form-control\" (click)=\"toggleDropdown($event)\" [ngClass]=\"{'disabled': settings.disabled}\" [attr.tabindex]=\"0\">\n                  <span *ngIf=\"selectedItems?.length == 0\">{{settings.text}}</span>\n                  <span *ngIf=\"settings.singleSelection && !badgeTempl\">\n                      <span *ngFor=\"let item of selectedItems;trackBy: trackByFn.bind(this);\">\n                          {{item[settings.labelKey]}}\n                      </span>\n                  </span>\n                  <span class=\"c-list\" *ngIf=\"selectedItems?.length > 0 && settings.singleSelection && badgeTempl \">\n                      <div class=\"c-token\" *ngFor=\"let item of selectedItems;trackBy: trackByFn.bind(this);let k = index\">\n                      <span *ngIf=\"!badgeTempl\" class=\"c-label\">{{item[settings.labelKey]}}</span>\n                  <span *ngIf=\"badgeTempl\" class=\"c-label\">\n                                  <c-templateRenderer [data]=\"badgeTempl\" [item]=\"item\"></c-templateRenderer>\n                              </span>\n                  <span class=\"c-remove\" (click)=\"onItemClick(item,k,$event)\">\n                                  <svg width=\"100%\" height=\"100%\" version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n              viewBox=\"0 0 47.971 47.971\" style=\"enable-background:new 0 0 47.971 47.971;\" xml:space=\"preserve\">\n          <g>\n              <path d=\"M28.228,23.986L47.092,5.122c1.172-1.171,1.172-3.071,0-4.242c-1.172-1.172-3.07-1.172-4.242,0L23.986,19.744L5.121,0.88\n                  c-1.172-1.172-3.07-1.172-4.242,0c-1.172,1.171-1.172,3.071,0,4.242l18.865,18.864L0.879,42.85c-1.172,1.171-1.172,3.071,0,4.242\n                  C1.465,47.677,2.233,47.97,3,47.97s1.535-0.293,2.121-0.879l18.865-18.864L42.85,47.091c0.586,0.586,1.354,0.879,2.121,0.879\n                  s1.535-0.293,2.121-0.879c1.172-1.171,1.172-3.071,0-4.242L28.228,23.986z\"/>\n          </g>\n          </svg>\n\n                              </span>\n\n\n\n              </div>\n              </span>\n              <div class=\"c-list\" *ngIf=\"selectedItems?.length > 0 && !settings.singleSelection\">\n                  <div class=\"c-token\" *ngFor=\"let item of selectedItems;trackBy: trackByFn.bind(this);let k = index\" [hidden]=\"k > settings.badgeShowLimit-1\">\n                      <span *ngIf=\"!badgeTempl\" class=\"c-label\">{{item[settings.labelKey]}}</span>\n                      <span *ngIf=\"badgeTempl\" class=\"c-label\">\n                                  <c-templateRenderer [data]=\"badgeTempl\" [item]=\"item\"></c-templateRenderer>\n                              </span>\n                      <span class=\"c-remove\" (click)=\"onItemClick(item,k,$event)\">\n                                  <svg width=\"100%\" height=\"100%\" version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n              viewBox=\"0 0 47.971 47.971\" style=\"enable-background:new 0 0 47.971 47.971;\" xml:space=\"preserve\">\n          <g>\n              <path d=\"M28.228,23.986L47.092,5.122c1.172-1.171,1.172-3.071,0-4.242c-1.172-1.172-3.07-1.172-4.242,0L23.986,19.744L5.121,0.88\n                  c-1.172-1.172-3.07-1.172-4.242,0c-1.172,1.171-1.172,3.071,0,4.242l18.865,18.864L0.879,42.85c-1.172,1.171-1.172,3.071,0,4.242\n                  C1.465,47.677,2.233,47.97,3,47.97s1.535-0.293,2.121-0.879l18.865-18.864L42.85,47.091c0.586,0.586,1.354,0.879,2.121,0.879\n                  s1.535-0.293,2.121-0.879c1.172-1.171,1.172-3.071,0-4.242L28.228,23.986z\"/>\n          </g>\n          </svg>\n\n                              </span>\n                  </div>\n              </div>\n              <span class=\"countplaceholder\" *ngIf=\"selectedItems?.length > settings.badgeShowLimit\">+{{selectedItems?.length - settings.badgeShowLimit }}</span>\n              <!--            <span class=\"fa\" [ngClass]=\"{'c-angle-down': !isActive,'fa-angle-up':isActive}\"></span>\n      --><span *ngIf=\"!isActive\" class=\"c-angle-down\">\n                      <svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n      \t width=\"100%\" height=\"100%\" viewBox=\"0 0 612 612\" style=\"enable-background:new 0 0 612 612;\" xml:space=\"preserve\">\n      <g>\n      \t<g id=\"_x31_0_34_\">\n      \t\t<g>\n      \t\t\t<path d=\"M604.501,134.782c-9.999-10.05-26.222-10.05-36.221,0L306.014,422.558L43.721,134.782\n      \t\t\t\tc-9.999-10.05-26.223-10.05-36.222,0s-9.999,26.35,0,36.399l279.103,306.241c5.331,5.357,12.422,7.652,19.386,7.296\n      \t\t\t\tc6.988,0.356,14.055-1.939,19.386-7.296l279.128-306.268C614.5,161.106,614.5,144.832,604.501,134.782z\"/>\n      \t\t</g>\n      \t</g>\n      </g>\n      </svg>\n\n                  </span>\n              <span *ngIf=\"isActive\" class=\"c-angle-up\">\n                      <svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n      \t width=\"100%\" height=\"100%\" viewBox=\"0 0 612 612\" style=\"enable-background:new 0 0 612 612;\" xml:space=\"preserve\">\n      <g>\n      \t<g id=\"_x39__30_\">\n      \t\t<g>\n      \t\t\t<path d=\"M604.501,440.509L325.398,134.956c-5.331-5.357-12.423-7.627-19.386-7.27c-6.989-0.357-14.056,1.913-19.387,7.27\n      \t\t\t\tL7.499,440.509c-9.999,10.024-9.999,26.298,0,36.323s26.223,10.024,36.222,0l262.293-287.164L568.28,476.832\n      \t\t\t\tc9.999,10.024,26.222,10.024,36.221,0C614.5,466.809,614.5,450.534,604.501,440.509z\"/>\n      \t\t</g>\n      \t</g>\n      </g>\n\n      </svg>\n\n                  </span>\n          </div>\n      </div>\n      <div [setPosition]=\"selectedListHeight?.val\" class=\"dropdown-list\" [ngClass]=\"{'dropdown-list-top': settings.position == 'top'}\"\n          [hidden]=\"!isActive\">\n          <div [ngClass]=\"{'arrow-up': settings.position == 'bottom', 'arrow-down': settings.position == 'top'}\" class=\"arrow-2\"></div>\n          <div [ngClass]=\"{'arrow-up': settings.position == 'bottom', 'arrow-down': settings.position == 'top'}\"></div>\n          <div class=\"list-area\">\n              <div class=\"pure-checkbox select-all\" *ngIf=\"settings.enableCheckAll && !settings.singleSelection && !settings.limitSelection && data?.length > 0\"\n                  (click)=\"toggleSelectAll()\">\n                  <input *ngIf=\"settings.showCheckbox\" type=\"checkbox\" [checked]=\"isSelectAll\" [disabled]=\"settings.limitSelection == selectedItems?.length\"\n                  />\n                  <label>\n                      <span [hidden]=\"isSelectAll\">{{settings.selectAllText}}</span>\n                      <span [hidden]=\"!isSelectAll\">{{settings.unSelectAllText}}</span>\n                  </label>\n              </div>\n              <div class=\"list-filter\" *ngIf=\"settings.enableSearchFilter\">\n                  <span class=\"c-search\">\n                          <svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n      \t width=\"100%\" height=\"100%\" viewBox=\"0 0 615.52 615.52\" style=\"enable-background:new 0 0 615.52 615.52;\"\n      \t xml:space=\"preserve\">\n      <g>\n      \t<g>\n      \t\t<g id=\"Search__x28_and_thou_shall_find_x29_\">\n      \t\t\t<g>\n      \t\t\t\t<path d=\"M602.531,549.736l-184.31-185.368c26.679-37.72,42.528-83.729,42.528-133.548C460.75,103.35,357.997,0,231.258,0\n      \t\t\t\t\tC104.518,0,1.765,103.35,1.765,230.82c0,127.47,102.753,230.82,229.493,230.82c49.53,0,95.271-15.944,132.78-42.777\n      \t\t\t\t\tl184.31,185.366c7.482,7.521,17.292,11.291,27.102,11.291c9.812,0,19.62-3.77,27.083-11.291\n      \t\t\t\t\tC617.496,589.188,617.496,564.777,602.531,549.736z M355.9,319.763l-15.042,21.273L319.7,356.174\n      \t\t\t\t\tc-26.083,18.658-56.667,28.526-88.442,28.526c-84.365,0-152.995-69.035-152.995-153.88c0-84.846,68.63-153.88,152.995-153.88\n      \t\t\t\t\ts152.996,69.034,152.996,153.88C384.271,262.769,374.462,293.526,355.9,319.763z\"/>\n      \t\t\t</g>\n      \t\t</g>\n      \t</g>\n      </g>\n\n      </svg>\n                      </span>\n                  <span *ngIf=\"!settings.lazyLoading\" [hidden]=\"filter == undefined || filter?.length == 0\" class=\"c-clear\" (click)=\"clearSearch()\">\n      <svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n      \t viewBox=\"0 0 51.976 51.976\" style=\"enable-background:new 0 0 51.976 51.976;\" xml:space=\"preserve\">\n      <g>\n      \t<path d=\"M44.373,7.603c-10.137-10.137-26.632-10.138-36.77,0c-10.138,10.138-10.137,26.632,0,36.77s26.632,10.138,36.77,0\n      \t\tC54.51,34.235,54.51,17.74,44.373,7.603z M36.241,36.241c-0.781,0.781-2.047,0.781-2.828,0l-7.425-7.425l-7.778,7.778\n      \t\tc-0.781,0.781-2.047,0.781-2.828,0c-0.781-0.781-0.781-2.047,0-2.828l7.778-7.778l-7.425-7.425c-0.781-0.781-0.781-2.048,0-2.828\n      \t\tc0.781-0.781,2.047-0.781,2.828,0l7.425,7.425l7.071-7.071c0.781-0.781,2.047-0.781,2.828,0c0.781,0.781,0.781,2.047,0,2.828\n      \t\tl-7.071,7.071l7.425,7.425C37.022,34.194,37.022,35.46,36.241,36.241z\"/>\n      </g>\n      </svg>\n                      </span>\n                  <span *ngIf=\"settings.lazyLoading\" [hidden]=\"filter == undefined || filter?.length == 0\" class=\"c-clear\" (click)=\"resetInfiniteSearch()\">\n      <svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n      \t viewBox=\"0 0 51.976 51.976\" style=\"enable-background:new 0 0 51.976 51.976;\" xml:space=\"preserve\">\n      <g>\n      \t<path d=\"M44.373,7.603c-10.137-10.137-26.632-10.138-36.77,0c-10.138,10.138-10.137,26.632,0,36.77s26.632,10.138,36.77,0\n      \t\tC54.51,34.235,54.51,17.74,44.373,7.603z M36.241,36.241c-0.781,0.781-2.047,0.781-2.828,0l-7.425-7.425l-7.778,7.778\n      \t\tc-0.781,0.781-2.047,0.781-2.828,0c-0.781-0.781-0.781-2.047,0-2.828l7.778-7.778l-7.425-7.425c-0.781-0.781-0.781-2.048,0-2.828\n      \t\tc0.781-0.781,2.047-0.781,2.828,0l7.425,7.425l7.071-7.071c0.781-0.781,2.047-0.781,2.828,0c0.781,0.781,0.781,2.047,0,2.828\n      \t\tl-7.071,7.071l7.425,7.425C37.022,34.194,37.022,35.46,36.241,36.241z\"/>\n      </g>\n      </svg>\n                      </span>\n\n                  <input class=\"c-input\" *ngIf=\"!settings.lazyLoading && !searchTempl\" #searchInput type=\"text\" [placeholder]=\"settings.searchPlaceholderText\"\n                      [(ngModel)]=\"filter\">\n                  <input class=\"c-input\" *ngIf=\"settings.lazyLoading && !searchTempl\" #searchInput type=\"text\" [placeholder]=\"settings.searchPlaceholderText\"\n                      [(ngModel)]=\"filter\" (keyup)=\"filterInfiniteList($event)\">\n                  <c-templateRenderer *ngIf=\"searchTempl\" [data]=\"searchTempl\" [item]=\"item\"></c-templateRenderer>\n              </div>\n              <div class=\"filter-select-all\" *ngIf=\"!settings.lazyLoading && settings.enableFilterSelectAll\">\n                  <div class=\"pure-checkbox select-all\" *ngIf=\"filter?.length > 0 && filterLength > 0\" (click)=\"toggleFilterSelectAll()\">\n                      <input type=\"checkbox\" [checked]=\"isFilterSelectAll\" [disabled]=\"settings.limitSelection == selectedItems?.length\" />\n                      <label>\n                      <span [hidden]=\"isFilterSelectAll\">{{settings.filterSelectAllText}}</span>\n                      <span [hidden]=\"!isFilterSelectAll\">{{settings.filterUnSelectAllText}}</span>\n                  </label>\n                  </div>\n                  <label *ngIf=\"filterLength == 0\" [hidden]=\"filter == undefined || filter?.length == 0\">{{settings.noDataLabel}}</label>\n              </div>\n              <div class=\"filter-select-all\" *ngIf=\"settings.lazyLoading && settings.enableFilterSelectAll\">\n                  <div class=\"pure-checkbox select-all\" *ngIf=\"filter?.length > 0 && infiniteFilterLength > 0\" (click)=\"toggleInfiniteFilterSelectAll()\">\n                      <input type=\"checkbox\" [checked]=\"isInfiniteFilterSelectAll\" [disabled]=\"settings.limitSelection == selectedItems?.length\"\n                      />\n                      <label>\n                      <span [hidden]=\"isInfiniteFilterSelectAll\">{{settings.filterSelectAllText}}</span>\n                      <span [hidden]=\"!isInfiniteFilterSelectAll\">{{settings.filterUnSelectAllText}}</span>\n                  </label>\n                  </div>\n              </div>\n              <ul *ngIf=\"!settings.groupBy\" [style.maxHeight]=\"settings.maxHeight+'px'\" class=\"lazyContainer\">\n                  <span *ngIf=\"itemTempl\">\n                  <li *ngFor=\"let item of data | listFilter: filter : settings.searchBy; let i = index;\" (click)=\"onItemClick(item,i,$event)\" class=\"pure-checkbox\">\n                  <input *ngIf=\"settings.showCheckbox\" type=\"checkbox\" [checked]=\"isSelected(item)\" [disabled]=\"settings.limitSelection == selectedItems?.length && !isSelected(item)\"/>\n                  <label></label>\n                  <c-templateRenderer [data]=\"itemTempl\" [item]=\"item\"></c-templateRenderer>\n              </li>\n              </span>\n                  <span *ngIf=\"!itemTempl && !settings.lazyLoading\">\n              <li *ngFor=\"let item of data | listFilter:filter : settings.searchBy; let i = index;\" (click)=\"onItemClick(item,i,$event)\" class=\"pure-checkbox\">\n                  <input *ngIf=\"settings.showCheckbox\" type=\"checkbox\" [checked]=\"isSelected(item)\" [disabled]=\"settings.limitSelection == selectedItems?.length && !isSelected(item)\"/>\n                  <label>{{item[settings.labelKey]}}</label>\n              </li>\n              </span>\n                  <span *ngIf=\"!itemTempl && settings.lazyLoading\">\n                  <div [ngStyle]=\"{'height':totalHeight+'px'}\" style=\"position: relative;\">\n\n            \n              <li *ngFor=\"let item of chunkArray ; let i = index;\" (click)=\"onItemClick(item,i,$event)\" style=\"position: absolute;width: 100%;\" class=\"pure-checkbox\" [styleProp]=\"chunkIndex[i]\">\n                  <input *ngIf=\"settings.showCheckbox\" type=\"checkbox\" [checked]=\"isSelected(item)\" [disabled]=\"settings.limitSelection == selectedItems?.length && !isSelected(item)\"/>\n                  <label>{{item[settings.labelKey]}}</label>\n              </li>\n              </div>\n              </span>\n              </ul>\n              <div *ngIf=\"settings.groupBy\" [style.maxHeight]=\"settings.maxHeight+'px'\" style=\"overflow: auto;\">\n                  <ul *ngFor=\"let obj of groupedData ; let i = index;\" class=\"list-grp\">\n                      <h4 *ngIf=\"(obj.value | listFilter:filter : settings.searchBy )?.length > 0\">{{obj.key}}</h4>\n                      <span *ngIf=\"itemTempl\">\n              <li *ngFor=\"let item of obj.value | listFilter:filter : settings.searchBy; let i = index;\" (click)=\"onItemClick(item,i,$event)\" class=\"pure-checkbox\">\n                  <input *ngIf=\"settings.showCheckbox\" type=\"checkbox\" [checked]=\"isSelected(item)\" [disabled]=\"settings.limitSelection == selectedItems?.length && !isSelected(item)\"/>\n                  <label></label>\n                  <c-templateRenderer [data]=\"itemTempl\" [item]=\"item\"></c-templateRenderer>\n              </li>\n              </span>\n                      <span *ngIf=\"!itemTempl\">\n              <li *ngFor=\"let item of obj.value | listFilter:filter : settings.searchBy; let i = index;\" (click)=\"onItemClick(item,i,$event)\" class=\"pure-checkbox\">\n                  <input *ngIf=\"settings.showCheckbox\" type=\"checkbox\" [checked]=\"isSelected(item)\" [disabled]=\"settings.limitSelection == selectedItems?.length && !isSelected(item)\"/>\n                  <label>{{item[settings.labelKey]}}</label>\n              </li>\n              </span>\n                  </ul>\n              </div>\n              <h5 class=\"list-message\" *ngIf=\"data?.length == 0\">{{settings.noDataLabel}}</h5>\n          </div>\n      </div>\n      </div>\n    ",
                    host: { '[class]': 'defaultSettings.classes' },
                    styles: ["\n      .cuppa-dropdown{position:relative}.c-btn{display:inline-block;background:#fff;border:1px solid #ccc;border-radius:3px;font-size:14px;color:#333}.c-btn.disabled{background:#ccc}.selected-list .c-list{float:left;padding:0px;margin:0px;width:calc(100% - 20px)}.selected-list .c-list .c-token{list-style:none;padding:2px 8px;background:#0079FE;color:#fff;border-radius:2px;margin-right:4px;margin-top:2px;float:left;position:relative;padding-right:25px}.selected-list .c-list .c-token .c-label{display:block;float:left}.selected-list .c-list .c-token .c-remove{position:absolute;right:8px;top:50%;transform:translateY(-50%);width:10px}.selected-list .c-list .c-token .c-remove svg{fill:#fff}.selected-list .fa-angle-down,.selected-list .fa-angle-up{font-size:15pt;position:absolute;right:10px;top:50%;transform:translateY(-50%)}.selected-list .c-angle-down,.selected-list .c-angle-up{width:15px;height:15px;position:absolute;right:10px;top:50%;transform:translateY(-50%);pointer-events:none}.selected-list .c-angle-down svg,.selected-list .c-angle-up svg{fill:#333}.selected-list .countplaceholder{position:absolute;right:30px;top:50%;transform:translateY(-50%)}.selected-list .c-btn{width:100%;padding:10px;cursor:pointer;display:flex;position:relative}.selected-list .c-btn .c-icon{position:absolute;right:5px;top:50%;transform:translateY(-50%)}.dropdown-list{position:absolute;padding-top:14px;width:100%;z-index:9999}.dropdown-list ul{padding:0px;list-style:none;overflow:auto;margin:0px}.dropdown-list ul li{padding:10px 10px;cursor:pointer;text-align:left}.dropdown-list ul li:first-child{padding-top:10px}.dropdown-list ul li:last-child{padding-bottom:10px}.dropdown-list ul li:hover{background:#f5f5f5}.dropdown-list ::-webkit-scrollbar{width:8px}.dropdown-list ::-webkit-scrollbar-thumb{background:#cccccc;border-radius:5px}.dropdown-list ::-webkit-scrollbar-track{background:#f2f2f2}.arrow-up,.arrow-down{width:0;height:0;border-left:13px solid transparent;border-right:13px solid transparent;border-bottom:15px solid #fff;margin-left:15px;position:absolute;top:0}.arrow-down{bottom:-14px;top:unset;transform:rotate(180deg)}.arrow-2{border-bottom:15px solid #ccc;top:-1px}.arrow-down.arrow-2{top:unset;bottom:-16px}.list-area{border:1px solid #ccc;border-radius:3px;background:#fff;margin:0px;box-shadow:0px 1px 5px #959595}.select-all{padding:10px;border-bottom:1px solid #ccc;text-align:left}.list-filter{border-bottom:1px solid #ccc;position:relative;padding-left:35px;height:35px}.list-filter input{border:0px;width:100%;height:100%;padding:0px}.list-filter input:focus{outline:none}.list-filter .c-search{position:absolute;top:9px;left:10px;width:15px;height:15px}.list-filter .c-search svg{fill:#888}.list-filter .c-clear{position:absolute;top:10px;right:10px;width:15px;height:15px}.list-filter .c-clear svg{fill:#888}.pure-checkbox input[type=\"checkbox\"]{border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.pure-checkbox input[type=\"checkbox\"]:focus+label:before,.pure-checkbox input[type=\"checkbox\"]:hover+label:before{border-color:#0079FE;background-color:#f2f2f2}.pure-checkbox input[type=\"checkbox\"]:active+label:before{transition-duration:0s}.pure-checkbox input[type=\"checkbox\"]+label{position:relative;padding-left:2em;vertical-align:middle;user-select:none;cursor:pointer;margin:0px;color:#000;font-weight:300}.pure-checkbox input[type=\"checkbox\"]+label:before{box-sizing:content-box;content:'';color:#0079FE;position:absolute;top:50%;left:0;width:14px;height:14px;margin-top:-9px;border:2px solid #0079FE;text-align:center;transition:all 0.4s ease}.pure-checkbox input[type=\"checkbox\"]+label:after{box-sizing:content-box;content:'';background-color:#0079FE;position:absolute;top:50%;left:4px;width:10px;height:10px;margin-top:-5px;transform:scale(0);transform-origin:50%;transition:transform 200ms ease-out}.pure-checkbox input[type=\"checkbox\"]:disabled+label:before{border-color:#cccccc}.pure-checkbox input[type=\"checkbox\"]:disabled:focus+label:before .pure-checkbox input[type=\"checkbox\"]:disabled:hover+label:before{background-color:inherit}.pure-checkbox input[type=\"checkbox\"]:disabled:checked+label:before{background-color:#cccccc}.pure-checkbox input[type=\"checkbox\"]+label:after{background-color:transparent;top:50%;left:4px;width:8px;height:3px;margin-top:-4px;border-style:solid;border-color:#ffffff;border-width:0 0 3px 3px;border-image:none;transform:rotate(-45deg) scale(0)}.pure-checkbox input[type=\"checkbox\"]:checked+label:after{content:'';transform:rotate(-45deg) scale(1);transition:transform 200ms ease-out}.pure-checkbox input[type=\"radio\"]:checked+label:before{background-color:white}.pure-checkbox input[type=\"radio\"]:checked+label:after{transform:scale(1)}.pure-checkbox input[type=\"radio\"]+label:before{border-radius:50%}.pure-checkbox input[type=\"checkbox\"]:checked+label:before{background:#0079FE}.pure-checkbox input[type=\"checkbox\"]:checked+label:after{transform:rotate(-45deg) scale(1)}.list-message{text-align:center;margin:0px;padding:15px 0px;font-size:initial}.list-grp{padding:0 15px !important}.list-grp h4{text-transform:capitalize;margin:15px 0px 0px 0px;font-size:14px;font-weight:700}.list-grp>li{padding-left:15px !important}\n    "],
                    providers: [DROPDOWN_CONTROL_VALUE_ACCESSOR, DROPDOWN_CONTROL_VALIDATION],
                },] },
    ];
    /** @nocollapse */
    AngularMultiSelect.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_7__multiselect_service__["a" /* DataService */], },
    ]; };
    AngularMultiSelect.propDecorators = {
        'data': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'settings': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'onSelect': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"], args: ['onSelect',] },],
        'onDeSelect': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"], args: ['onDeSelect',] },],
        'onSelectAll': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"], args: ['onSelectAll',] },],
        'onDeSelectAll': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"], args: ['onDeSelectAll',] },],
        'onOpen': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"], args: ['onOpen',] },],
        'onClose': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"], args: ['onClose',] },],
        'itemTempl': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChild"], args: [__WEBPACK_IMPORTED_MODULE_6__menu_item__["b" /* Item */],] },],
        'badgeTempl': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChild"], args: [__WEBPACK_IMPORTED_MODULE_6__menu_item__["a" /* Badge */],] },],
        'searchTempl': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChild"], args: [__WEBPACK_IMPORTED_MODULE_6__menu_item__["c" /* Search */],] },],
        'searchInput': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"], args: ['searchInput',] },],
        'selectedListElem': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"], args: ['selectedList',] },],
    };
    return AngularMultiSelect;
}());

var AngularMultiSelectModule = /** @class */ (function () {
    function AngularMultiSelectModule() {
    }
    AngularMultiSelectModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                    imports: [__WEBPACK_IMPORTED_MODULE_2__angular_common__["CommonModule"], __WEBPACK_IMPORTED_MODULE_1__angular_forms__["FormsModule"]],
                    declarations: [AngularMultiSelect, __WEBPACK_IMPORTED_MODULE_4__clickOutside__["a" /* ClickOutsideDirective */], __WEBPACK_IMPORTED_MODULE_4__clickOutside__["b" /* ScrollDirective */], __WEBPACK_IMPORTED_MODULE_4__clickOutside__["d" /* styleDirective */], __WEBPACK_IMPORTED_MODULE_5__list_filter__["a" /* ListFilterPipe */], __WEBPACK_IMPORTED_MODULE_6__menu_item__["b" /* Item */], __WEBPACK_IMPORTED_MODULE_6__menu_item__["d" /* TemplateRenderer */], __WEBPACK_IMPORTED_MODULE_6__menu_item__["a" /* Badge */], __WEBPACK_IMPORTED_MODULE_6__menu_item__["c" /* Search */], __WEBPACK_IMPORTED_MODULE_4__clickOutside__["c" /* setPosition */]],
                    exports: [AngularMultiSelect, __WEBPACK_IMPORTED_MODULE_4__clickOutside__["a" /* ClickOutsideDirective */], __WEBPACK_IMPORTED_MODULE_4__clickOutside__["b" /* ScrollDirective */], __WEBPACK_IMPORTED_MODULE_4__clickOutside__["d" /* styleDirective */], __WEBPACK_IMPORTED_MODULE_5__list_filter__["a" /* ListFilterPipe */], __WEBPACK_IMPORTED_MODULE_6__menu_item__["b" /* Item */], __WEBPACK_IMPORTED_MODULE_6__menu_item__["d" /* TemplateRenderer */], __WEBPACK_IMPORTED_MODULE_6__menu_item__["a" /* Badge */], __WEBPACK_IMPORTED_MODULE_6__menu_item__["c" /* Search */], __WEBPACK_IMPORTED_MODULE_4__clickOutside__["c" /* setPosition */]],
                    providers: [__WEBPACK_IMPORTED_MODULE_7__multiselect_service__["a" /* DataService */]]
                },] },
    ];
    /** @nocollapse */
    AngularMultiSelectModule.ctorParameters = function () { return []; };
    return AngularMultiSelectModule;
}());

//# sourceMappingURL=multiselect.component.js.map

/***/ }),

/***/ "./node_modules/angular2-multiselect-dropdown/multiselect.model.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MyException; });
var MyException = /** @class */ (function () {
    function MyException(status, body) {
        this.status = status;
        this.body = body;
    }
    return MyException;
}());

//# sourceMappingURL=multiselect.model.js.map

/***/ }),

/***/ "./node_modules/angular2-multiselect-dropdown/multiselect.service.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DataService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs__ = __webpack_require__("./node_modules/rxjs/Rx.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs__);


var DataService = /** @class */ (function () {
    function DataService() {
        this.filteredData = [];
        this.subject = new __WEBPACK_IMPORTED_MODULE_1_rxjs__["Subject"]();
    }
    DataService.prototype.setData = function (data) {
        this.filteredData = data;
        this.subject.next(data);
    };
    DataService.prototype.getData = function () {
        return this.subject.asObservable();
    };
    DataService.prototype.getFilteredData = function () {
        if (this.filteredData && this.filteredData.length > 0) {
            return this.filteredData;
        }
        else {
            return [];
        }
    };
    DataService.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    DataService.ctorParameters = function () { return []; };
    return DataService;
}());

//# sourceMappingURL=multiselect.service.js.map

/***/ }),

/***/ "./node_modules/angular2-text-mask/dist/angular2TextMask.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var forms_1 = __webpack_require__("./node_modules/@angular/forms/esm5/forms.js");
var platform_browser_1 = __webpack_require__("./node_modules/@angular/platform-browser/esm5/platform-browser.js");
var textMaskCore_1 = __webpack_require__("./node_modules/text-mask-core/dist/textMaskCore.js");
var TextMaskConfig = /** @class */ (function () {
    function TextMaskConfig() {
    }
    return TextMaskConfig;
}());
exports.TextMaskConfig = TextMaskConfig;
exports.MASKEDINPUT_VALUE_ACCESSOR = {
    provide: forms_1.NG_VALUE_ACCESSOR,
    useExisting: core_1.forwardRef(function () { return MaskedInputDirective; }),
    multi: true
};
/**
 * We must check whether the agent is Android because composition events
 * behave differently between iOS and Android.
 */
function _isAndroid() {
    var userAgent = platform_browser_1.ɵgetDOM() ? platform_browser_1.ɵgetDOM().getUserAgent() : '';
    return /android (\d+)/.test(userAgent.toLowerCase());
}
var MaskedInputDirective = /** @class */ (function () {
    function MaskedInputDirective(_renderer, _elementRef, _compositionMode) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this._compositionMode = _compositionMode;
        this.textMaskConfig = {
            mask: [],
            guide: true,
            placeholderChar: '_',
            pipe: undefined,
            keepCharPositions: false,
        };
        this.onChange = function (_) { };
        this.onTouched = function () { };
        /** Whether the user is creating a composition string (IME events). */
        this._composing = false;
        if (this._compositionMode == null) {
            this._compositionMode = !_isAndroid();
        }
    }
    MaskedInputDirective.prototype.ngOnChanges = function (changes) {
        this._setupMask(true);
        if (this.textMaskInputElement !== undefined) {
            this.textMaskInputElement.update(this.inputElement.value);
        }
    };
    MaskedInputDirective.prototype.writeValue = function (value) {
        this._setupMask();
        // set the initial value for cases where the mask is disabled
        var normalizedValue = value == null ? '' : value;
        this._renderer.setProperty(this.inputElement, 'value', normalizedValue);
        if (this.textMaskInputElement !== undefined) {
            this.textMaskInputElement.update(value);
        }
    };
    MaskedInputDirective.prototype.registerOnChange = function (fn) { this.onChange = fn; };
    MaskedInputDirective.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    MaskedInputDirective.prototype.setDisabledState = function (isDisabled) {
        this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    MaskedInputDirective.prototype._handleInput = function (value) {
        if (!this._compositionMode || (this._compositionMode && !this._composing)) {
            this._setupMask();
            if (this.textMaskInputElement !== undefined) {
                this.textMaskInputElement.update(value);
                // get the updated value
                value = this.inputElement.value;
                this.onChange(value);
            }
        }
    };
    MaskedInputDirective.prototype._setupMask = function (create) {
        if (create === void 0) { create = false; }
        if (!this.inputElement) {
            if (this._elementRef.nativeElement.tagName.toUpperCase() === 'INPUT') {
                // `textMask` directive is used directly on an input element
                this.inputElement = this._elementRef.nativeElement;
            }
            else {
                // `textMask` directive is used on an abstracted input element, `md-input-container`, etc
                this.inputElement = this._elementRef.nativeElement.getElementsByTagName('INPUT')[0];
            }
        }
        if (this.inputElement && create) {
            this.textMaskInputElement = textMaskCore_1.createTextMaskInputElement(Object.assign({ inputElement: this.inputElement }, this.textMaskConfig));
        }
    };
    MaskedInputDirective.prototype._compositionStart = function () { this._composing = true; };
    MaskedInputDirective.prototype._compositionEnd = function (value) {
        this._composing = false;
        this._compositionMode && this._handleInput(value);
    };
    MaskedInputDirective.decorators = [
        { type: core_1.Directive, args: [{
                    host: {
                        '(input)': '_handleInput($event.target.value)',
                        '(blur)': 'onTouched()',
                        '(compositionstart)': '_compositionStart()',
                        '(compositionend)': '_compositionEnd($event.target.value)'
                    },
                    selector: '[textMask]',
                    exportAs: 'textMask',
                    providers: [exports.MASKEDINPUT_VALUE_ACCESSOR]
                },] },
    ];
    /** @nocollapse */
    MaskedInputDirective.ctorParameters = function () { return [
        { type: core_1.Renderer2, },
        { type: core_1.ElementRef, },
        { type: undefined, decorators: [{ type: core_1.Optional }, { type: core_1.Inject, args: [forms_1.COMPOSITION_BUFFER_MODE,] },] },
    ]; };
    MaskedInputDirective.propDecorators = {
        'textMaskConfig': [{ type: core_1.Input, args: ['textMask',] },],
    };
    return MaskedInputDirective;
}());
exports.MaskedInputDirective = MaskedInputDirective;
var TextMaskModule = /** @class */ (function () {
    function TextMaskModule() {
    }
    TextMaskModule.decorators = [
        { type: core_1.NgModule, args: [{
                    declarations: [MaskedInputDirective],
                    exports: [MaskedInputDirective]
                },] },
    ];
    /** @nocollapse */
    TextMaskModule.ctorParameters = function () { return []; };
    return TextMaskModule;
}());
exports.TextMaskModule = TextMaskModule;
var textMaskCore_2 = __webpack_require__("./node_modules/text-mask-core/dist/textMaskCore.js");
exports.conformToMask = textMaskCore_2.conformToMask;
//# sourceMappingURL=angular2TextMask.js.map

/***/ }),

/***/ "./node_modules/atoa/atoa.js":
/***/ (function(module, exports) {

module.exports = function atoa (a, n) { return Array.prototype.slice.call(a, n); }


/***/ }),

/***/ "./node_modules/babel-polyfill/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__("./node_modules/core-js/shim.js");

__webpack_require__("./node_modules/babel-polyfill/node_modules/regenerator-runtime/runtime.js");

__webpack_require__("./node_modules/core-js/fn/regexp/escape.js");

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/babel-polyfill/node_modules/regenerator-runtime/runtime.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/base64-js/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  for (var i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(
      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
    ))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ "./node_modules/buffer/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__("./node_modules/base64-js/index.js")
var ieee754 = __webpack_require__("./node_modules/ieee754/index.js")
var isArray = __webpack_require__("./node_modules/isarray/index.js")

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/c3/c3.js":
/***/ (function(module, exports, __webpack_require__) {

/* @license C3.js v0.6.12 | (c) C3 Team and other contributors | http://c3js.org/ */
(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global.c3 = factory());
}(this, (function () { 'use strict';

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function (obj) {
        return typeof obj;
      };
    } else {
      _typeof = function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function ChartInternal(api) {
    var $$ = this;
    $$.d3 = window.d3 ? window.d3 :  true ? __webpack_require__("./node_modules/d3/index.js") : undefined;
    $$.api = api;
    $$.config = $$.getDefaultConfig();
    $$.data = {};
    $$.cache = {};
    $$.axes = {};
  }

  function Chart(config) {
    var $$ = this.internal = new ChartInternal(this);
    $$.loadConfig(config);
    $$.beforeInit(config);
    $$.init();
    $$.afterInit(config); // bind "this" to nested API

    (function bindThis(fn, target, argThis) {
      Object.keys(fn).forEach(function (key) {
        target[key] = fn[key].bind(argThis);

        if (Object.keys(fn[key]).length > 0) {
          bindThis(fn[key], target[key], argThis);
        }
      });
    })(Chart.prototype, this, this);
  }

  function AxisInternal(component, params) {
    var internal = this;
    internal.component = component;
    internal.params = params || {};
    internal.d3 = component.d3;
    internal.scale = internal.d3.scaleLinear();
    internal.range;
    internal.orient = "bottom";
    internal.innerTickSize = 6;
    internal.outerTickSize = this.params.withOuterTick ? 6 : 0;
    internal.tickPadding = 3;
    internal.tickValues = null;
    internal.tickFormat;
    internal.tickArguments;
    internal.tickOffset = 0;
    internal.tickCulling = true;
    internal.tickCentered;
    internal.tickTextCharSize;
    internal.tickTextRotate = internal.params.tickTextRotate;
    internal.tickLength;
    internal.axis = internal.generateAxis();
  }

  AxisInternal.prototype.axisX = function (selection, x, tickOffset) {
    selection.attr("transform", function (d) {
      return "translate(" + Math.ceil(x(d) + tickOffset) + ", 0)";
    });
  };

  AxisInternal.prototype.axisY = function (selection, y) {
    selection.attr("transform", function (d) {
      return "translate(0," + Math.ceil(y(d)) + ")";
    });
  };

  AxisInternal.prototype.scaleExtent = function (domain) {
    var start = domain[0],
        stop = domain[domain.length - 1];
    return start < stop ? [start, stop] : [stop, start];
  };

  AxisInternal.prototype.generateTicks = function (scale) {
    var internal = this;
    var i,
        domain,
        ticks = [];

    if (scale.ticks) {
      return scale.ticks.apply(scale, internal.tickArguments);
    }

    domain = scale.domain();

    for (i = Math.ceil(domain[0]); i < domain[1]; i++) {
      ticks.push(i);
    }

    if (ticks.length > 0 && ticks[0] > 0) {
      ticks.unshift(ticks[0] - (ticks[1] - ticks[0]));
    }

    return ticks;
  };

  AxisInternal.prototype.copyScale = function () {
    var internal = this;
    var newScale = internal.scale.copy(),
        domain;

    if (internal.params.isCategory) {
      domain = internal.scale.domain();
      newScale.domain([domain[0], domain[1] - 1]);
    }

    return newScale;
  };

  AxisInternal.prototype.textFormatted = function (v) {
    var internal = this,
        formatted = internal.tickFormat ? internal.tickFormat(v) : v;
    return typeof formatted !== 'undefined' ? formatted : '';
  };

  AxisInternal.prototype.updateRange = function () {
    var internal = this;
    internal.range = internal.scale.rangeExtent ? internal.scale.rangeExtent() : internal.scaleExtent(internal.scale.range());
    return internal.range;
  };

  AxisInternal.prototype.updateTickTextCharSize = function (tick) {
    var internal = this;

    if (internal.tickTextCharSize) {
      return internal.tickTextCharSize;
    }

    var size = {
      h: 11.5,
      w: 5.5
    };
    tick.select('text').text(function (d) {
      return internal.textFormatted(d);
    }).each(function (d) {
      var box = this.getBoundingClientRect(),
          text = internal.textFormatted(d),
          h = box.height,
          w = text ? box.width / text.length : undefined;

      if (h && w) {
        size.h = h;
        size.w = w;
      }
    }).text('');
    internal.tickTextCharSize = size;
    return size;
  };

  AxisInternal.prototype.isVertical = function () {
    return this.orient === 'left' || this.orient === 'right';
  };

  AxisInternal.prototype.tspanData = function (d, i, scale) {
    var internal = this;
    var splitted = internal.params.tickMultiline ? internal.splitTickText(d, scale) : [].concat(internal.textFormatted(d));

    if (internal.params.tickMultiline && internal.params.tickMultilineMax > 0) {
      splitted = internal.ellipsify(splitted, internal.params.tickMultilineMax);
    }

    return splitted.map(function (s) {
      return {
        index: i,
        splitted: s,
        length: splitted.length
      };
    });
  };

  AxisInternal.prototype.splitTickText = function (d, scale) {
    var internal = this,
        tickText = internal.textFormatted(d),
        maxWidth = internal.params.tickWidth,
        subtext,
        spaceIndex,
        textWidth,
        splitted = [];

    if (Object.prototype.toString.call(tickText) === "[object Array]") {
      return tickText;
    }

    if (!maxWidth || maxWidth <= 0) {
      maxWidth = internal.isVertical() ? 95 : internal.params.isCategory ? Math.ceil(scale(1) - scale(0)) - 12 : 110;
    }

    function split(splitted, text) {
      spaceIndex = undefined;

      for (var i = 1; i < text.length; i++) {
        if (text.charAt(i) === ' ') {
          spaceIndex = i;
        }

        subtext = text.substr(0, i + 1);
        textWidth = internal.tickTextCharSize.w * subtext.length; // if text width gets over tick width, split by space index or crrent index

        if (maxWidth < textWidth) {
          return split(splitted.concat(text.substr(0, spaceIndex ? spaceIndex : i)), text.slice(spaceIndex ? spaceIndex + 1 : i));
        }
      }

      return splitted.concat(text);
    }

    return split(splitted, tickText + "");
  };

  AxisInternal.prototype.ellipsify = function (splitted, max) {
    if (splitted.length <= max) {
      return splitted;
    }

    var ellipsified = splitted.slice(0, max);
    var remaining = 3;

    for (var i = max - 1; i >= 0; i--) {
      var available = ellipsified[i].length;
      ellipsified[i] = ellipsified[i].substr(0, available - remaining).padEnd(available, '.');
      remaining -= available;

      if (remaining <= 0) {
        break;
      }
    }

    return ellipsified;
  };

  AxisInternal.prototype.updateTickLength = function () {
    var internal = this;
    internal.tickLength = Math.max(internal.innerTickSize, 0) + internal.tickPadding;
  };

  AxisInternal.prototype.lineY2 = function (d) {
    var internal = this,
        tickPosition = internal.scale(d) + (internal.tickCentered ? 0 : internal.tickOffset);
    return internal.range[0] < tickPosition && tickPosition < internal.range[1] ? internal.innerTickSize : 0;
  };

  AxisInternal.prototype.textY = function () {
    var internal = this,
        rotate = internal.tickTextRotate;
    return rotate ? 11.5 - 2.5 * (rotate / 15) * (rotate > 0 ? 1 : -1) : internal.tickLength;
  };

  AxisInternal.prototype.textTransform = function () {
    var internal = this,
        rotate = internal.tickTextRotate;
    return rotate ? "rotate(" + rotate + ")" : "";
  };

  AxisInternal.prototype.textTextAnchor = function () {
    var internal = this,
        rotate = internal.tickTextRotate;
    return rotate ? rotate > 0 ? "start" : "end" : "middle";
  };

  AxisInternal.prototype.tspanDx = function () {
    var internal = this,
        rotate = internal.tickTextRotate;
    return rotate ? 8 * Math.sin(Math.PI * (rotate / 180)) : 0;
  };

  AxisInternal.prototype.tspanDy = function (d, i) {
    var internal = this,
        dy = internal.tickTextCharSize.h;

    if (i === 0) {
      if (internal.isVertical()) {
        dy = -((d.length - 1) * (internal.tickTextCharSize.h / 2) - 3);
      } else {
        dy = ".71em";
      }
    }

    return dy;
  };

  AxisInternal.prototype.generateAxis = function () {
    var internal = this,
        d3 = internal.d3,
        params = internal.params;

    function axis(g, transition) {
      var self;
      g.each(function () {
        var g = axis.g = d3.select(this);
        var scale0 = this.__chart__ || internal.scale,
            scale1 = this.__chart__ = internal.copyScale();
        var ticksValues = internal.tickValues ? internal.tickValues : internal.generateTicks(scale1),
            ticks = g.selectAll(".tick").data(ticksValues, scale1),
            tickEnter = ticks.enter().insert("g", ".domain").attr("class", "tick").style("opacity", 1e-6),
            // MEMO: No exit transition. The reason is this transition affects max tick width calculation because old tick will be included in the ticks.
        tickExit = ticks.exit().remove(),
            tickUpdate = ticks.merge(tickEnter),
            tickTransform,
            tickX,
            tickY;

        if (params.isCategory) {
          internal.tickOffset = Math.ceil((scale1(1) - scale1(0)) / 2);
          tickX = internal.tickCentered ? 0 : internal.tickOffset;
          tickY = internal.tickCentered ? internal.tickOffset : 0;
        } else {
          internal.tickOffset = tickX = 0;
        }

        internal.updateRange();
        internal.updateTickLength();
        internal.updateTickTextCharSize(g.select('.tick'));
        var lineUpdate = tickUpdate.select("line").merge(tickEnter.append("line")),
            textUpdate = tickUpdate.select("text").merge(tickEnter.append("text"));
        var tspans = tickUpdate.selectAll('text').selectAll('tspan').data(function (d, i) {
          return internal.tspanData(d, i, scale1);
        }),
            tspanEnter = tspans.enter().append('tspan'),
            tspanUpdate = tspanEnter.merge(tspans).text(function (d) {
          return d.splitted;
        });
        tspans.exit().remove();
        var path = g.selectAll(".domain").data([0]),
            pathUpdate = path.enter().append("path").merge(path).attr("class", "domain"); // TODO: each attr should be one function and change its behavior by internal.orient, probably

        switch (internal.orient) {
          case "bottom":
            {
              tickTransform = internal.axisX;
              lineUpdate.attr("x1", tickX).attr("x2", tickX).attr("y2", function (d, i) {
                return internal.lineY2(d, i);
              });
              textUpdate.attr("x", 0).attr("y", function (d, i) {
                return internal.textY(d, i);
              }).attr("transform", function (d, i) {
                return internal.textTransform(d, i);
              }).style("text-anchor", function (d, i) {
                return internal.textTextAnchor(d, i);
              });
              tspanUpdate.attr('x', 0).attr("dy", function (d, i) {
                return internal.tspanDy(d, i);
              }).attr('dx', function (d, i) {
                return internal.tspanDx(d, i);
              });
              pathUpdate.attr("d", "M" + internal.range[0] + "," + internal.outerTickSize + "V0H" + internal.range[1] + "V" + internal.outerTickSize);
              break;
            }

          case "top":
            {
              // TODO: rotated tick text
              tickTransform = internal.axisX;
              lineUpdate.attr("x1", tickX).attr("x2", tickX).attr("y2", function (d, i) {
                return -1 * internal.lineY2(d, i);
              });
              textUpdate.attr("x", 0).attr("y", function (d, i) {
                return -1 * internal.textY(d, i) - (params.isCategory ? 2 : internal.tickLength - 2);
              }).attr("transform", function (d, i) {
                return internal.textTransform(d, i);
              }).style("text-anchor", function (d, i) {
                return internal.textTextAnchor(d, i);
              });
              tspanUpdate.attr('x', 0).attr("dy", function (d, i) {
                return internal.tspanDy(d, i);
              }).attr('dx', function (d, i) {
                return internal.tspanDx(d, i);
              });
              pathUpdate.attr("d", "M" + internal.range[0] + "," + -internal.outerTickSize + "V0H" + internal.range[1] + "V" + -internal.outerTickSize);
              break;
            }

          case "left":
            {
              tickTransform = internal.axisY;
              lineUpdate.attr("x2", -internal.innerTickSize).attr("y1", tickY).attr("y2", tickY);
              textUpdate.attr("x", -internal.tickLength).attr("y", internal.tickOffset).style("text-anchor", "end");
              tspanUpdate.attr('x', -internal.tickLength).attr("dy", function (d, i) {
                return internal.tspanDy(d, i);
              });
              pathUpdate.attr("d", "M" + -internal.outerTickSize + "," + internal.range[0] + "H0V" + internal.range[1] + "H" + -internal.outerTickSize);
              break;
            }

          case "right":
            {
              tickTransform = internal.axisY;
              lineUpdate.attr("x2", internal.innerTickSize).attr("y1", tickY).attr("y2", tickY);
              textUpdate.attr("x", internal.tickLength).attr("y", internal.tickOffset).style("text-anchor", "start");
              tspanUpdate.attr('x', internal.tickLength).attr("dy", function (d, i) {
                return internal.tspanDy(d, i);
              });
              pathUpdate.attr("d", "M" + internal.outerTickSize + "," + internal.range[0] + "H0V" + internal.range[1] + "H" + internal.outerTickSize);
              break;
            }
        }

        if (scale1.rangeBand) {
          var x = scale1,
              dx = x.rangeBand() / 2;

          scale0 = scale1 = function scale1(d) {
            return x(d) + dx;
          };
        } else if (scale0.rangeBand) {
          scale0 = scale1;
        } else {
          tickExit.call(tickTransform, scale1, internal.tickOffset);
        }

        tickEnter.call(tickTransform, scale0, internal.tickOffset);
        self = (transition ? tickUpdate.transition(transition) : tickUpdate).style('opacity', 1).call(tickTransform, scale1, internal.tickOffset);
      });
      return self;
    }

    axis.scale = function (x) {
      if (!arguments.length) {
        return internal.scale;
      }

      internal.scale = x;
      return axis;
    };

    axis.orient = function (x) {
      if (!arguments.length) {
        return internal.orient;
      }

      internal.orient = x in {
        top: 1,
        right: 1,
        bottom: 1,
        left: 1
      } ? x + "" : "bottom";
      return axis;
    };

    axis.tickFormat = function (format) {
      if (!arguments.length) {
        return internal.tickFormat;
      }

      internal.tickFormat = format;
      return axis;
    };

    axis.tickCentered = function (isCentered) {
      if (!arguments.length) {
        return internal.tickCentered;
      }

      internal.tickCentered = isCentered;
      return axis;
    };

    axis.tickOffset = function () {
      return internal.tickOffset;
    };

    axis.tickInterval = function () {
      var interval, length;

      if (params.isCategory) {
        interval = internal.tickOffset * 2;
      } else {
        length = axis.g.select('path.domain').node().getTotalLength() - internal.outerTickSize * 2;
        interval = length / axis.g.selectAll('line').size();
      }

      return interval === Infinity ? 0 : interval;
    };

    axis.ticks = function () {
      if (!arguments.length) {
        return internal.tickArguments;
      }

      internal.tickArguments = arguments;
      return axis;
    };

    axis.tickCulling = function (culling) {
      if (!arguments.length) {
        return internal.tickCulling;
      }

      internal.tickCulling = culling;
      return axis;
    };

    axis.tickValues = function (x) {
      if (typeof x === 'function') {
        internal.tickValues = function () {
          return x(internal.scale.domain());
        };
      } else {
        if (!arguments.length) {
          return internal.tickValues;
        }

        internal.tickValues = x;
      }

      return axis;
    };

    return axis;
  };

  var CLASS = {
    target: 'c3-target',
    chart: 'c3-chart',
    chartLine: 'c3-chart-line',
    chartLines: 'c3-chart-lines',
    chartBar: 'c3-chart-bar',
    chartBars: 'c3-chart-bars',
    chartText: 'c3-chart-text',
    chartTexts: 'c3-chart-texts',
    chartArc: 'c3-chart-arc',
    chartArcs: 'c3-chart-arcs',
    chartArcsTitle: 'c3-chart-arcs-title',
    chartArcsBackground: 'c3-chart-arcs-background',
    chartArcsGaugeUnit: 'c3-chart-arcs-gauge-unit',
    chartArcsGaugeMax: 'c3-chart-arcs-gauge-max',
    chartArcsGaugeMin: 'c3-chart-arcs-gauge-min',
    selectedCircle: 'c3-selected-circle',
    selectedCircles: 'c3-selected-circles',
    eventRect: 'c3-event-rect',
    eventRects: 'c3-event-rects',
    eventRectsSingle: 'c3-event-rects-single',
    eventRectsMultiple: 'c3-event-rects-multiple',
    zoomRect: 'c3-zoom-rect',
    brush: 'c3-brush',
    dragZoom: 'c3-drag-zoom',
    focused: 'c3-focused',
    defocused: 'c3-defocused',
    region: 'c3-region',
    regions: 'c3-regions',
    title: 'c3-title',
    tooltipContainer: 'c3-tooltip-container',
    tooltip: 'c3-tooltip',
    tooltipName: 'c3-tooltip-name',
    shape: 'c3-shape',
    shapes: 'c3-shapes',
    line: 'c3-line',
    lines: 'c3-lines',
    bar: 'c3-bar',
    bars: 'c3-bars',
    circle: 'c3-circle',
    circles: 'c3-circles',
    arc: 'c3-arc',
    arcLabelLine: 'c3-arc-label-line',
    arcs: 'c3-arcs',
    area: 'c3-area',
    areas: 'c3-areas',
    empty: 'c3-empty',
    text: 'c3-text',
    texts: 'c3-texts',
    gaugeValue: 'c3-gauge-value',
    grid: 'c3-grid',
    gridLines: 'c3-grid-lines',
    xgrid: 'c3-xgrid',
    xgrids: 'c3-xgrids',
    xgridLine: 'c3-xgrid-line',
    xgridLines: 'c3-xgrid-lines',
    xgridFocus: 'c3-xgrid-focus',
    ygrid: 'c3-ygrid',
    ygrids: 'c3-ygrids',
    ygridLine: 'c3-ygrid-line',
    ygridLines: 'c3-ygrid-lines',
    axis: 'c3-axis',
    axisX: 'c3-axis-x',
    axisXLabel: 'c3-axis-x-label',
    axisY: 'c3-axis-y',
    axisYLabel: 'c3-axis-y-label',
    axisY2: 'c3-axis-y2',
    axisY2Label: 'c3-axis-y2-label',
    legendBackground: 'c3-legend-background',
    legendItem: 'c3-legend-item',
    legendItemEvent: 'c3-legend-item-event',
    legendItemTile: 'c3-legend-item-tile',
    legendItemHidden: 'c3-legend-item-hidden',
    legendItemFocused: 'c3-legend-item-focused',
    dragarea: 'c3-dragarea',
    EXPANDED: '_expanded_',
    SELECTED: '_selected_',
    INCLUDED: '_included_'
  };

  var asHalfPixel = function asHalfPixel(n) {
    return Math.ceil(n) + 0.5;
  };
  var ceil10 = function ceil10(v) {
    return Math.ceil(v / 10) * 10;
  };
  var diffDomain = function diffDomain(d) {
    return d[1] - d[0];
  };
  var getOption = function getOption(options, key, defaultValue) {
    return isDefined(options[key]) ? options[key] : defaultValue;
  };
  var getPathBox = function getPathBox(path) {
    var box = path.getBoundingClientRect(),
        items = [path.pathSegList.getItem(0), path.pathSegList.getItem(1)],
        minX = items[0].x,
        minY = Math.min(items[0].y, items[1].y);
    return {
      x: minX,
      y: minY,
      width: box.width,
      height: box.height
    };
  };
  var hasValue = function hasValue(dict, value) {
    var found = false;
    Object.keys(dict).forEach(function (key) {
      if (dict[key] === value) {
        found = true;
      }
    });
    return found;
  };
  var isArray = function isArray(o) {
    return Array.isArray(o);
  };
  var isDefined = function isDefined(v) {
    return typeof v !== 'undefined';
  };
  var isEmpty = function isEmpty(o) {
    return typeof o === 'undefined' || o === null || isString(o) && o.length === 0 || _typeof(o) === 'object' && Object.keys(o).length === 0;
  };
  var isFunction = function isFunction(o) {
    return typeof o === 'function';
  };
  var isString = function isString(o) {
    return typeof o === 'string';
  };
  var isUndefined = function isUndefined(v) {
    return typeof v === 'undefined';
  };
  var isValue = function isValue(v) {
    return v || v === 0;
  };
  var notEmpty = function notEmpty(o) {
    return !isEmpty(o);
  };
  var sanitise = function sanitise(str) {
    return typeof str === 'string' ? str.replace(/</g, '&lt;').replace(/>/g, '&gt;') : str;
  };

  var Axis = function Axis(owner) {
    _classCallCheck(this, Axis);

    this.owner = owner;
    this.d3 = owner.d3;
    this.internal = AxisInternal;
  };

  Axis.prototype.init = function init() {
    var $$ = this.owner,
        config = $$.config,
        main = $$.main;
    $$.axes.x = main.append("g").attr("class", CLASS.axis + ' ' + CLASS.axisX).attr("clip-path", config.axis_x_inner ? "" : $$.clipPathForXAxis).attr("transform", $$.getTranslate('x')).style("visibility", config.axis_x_show ? 'visible' : 'hidden');
    $$.axes.x.append("text").attr("class", CLASS.axisXLabel).attr("transform", config.axis_rotated ? "rotate(-90)" : "").style("text-anchor", this.textAnchorForXAxisLabel.bind(this));
    $$.axes.y = main.append("g").attr("class", CLASS.axis + ' ' + CLASS.axisY).attr("clip-path", config.axis_y_inner ? "" : $$.clipPathForYAxis).attr("transform", $$.getTranslate('y')).style("visibility", config.axis_y_show ? 'visible' : 'hidden');
    $$.axes.y.append("text").attr("class", CLASS.axisYLabel).attr("transform", config.axis_rotated ? "" : "rotate(-90)").style("text-anchor", this.textAnchorForYAxisLabel.bind(this));
    $$.axes.y2 = main.append("g").attr("class", CLASS.axis + ' ' + CLASS.axisY2) // clip-path?
    .attr("transform", $$.getTranslate('y2')).style("visibility", config.axis_y2_show ? 'visible' : 'hidden');
    $$.axes.y2.append("text").attr("class", CLASS.axisY2Label).attr("transform", config.axis_rotated ? "" : "rotate(-90)").style("text-anchor", this.textAnchorForY2AxisLabel.bind(this));
  };

  Axis.prototype.getXAxis = function getXAxis(scale, orient, tickFormat, tickValues, withOuterTick, withoutTransition, withoutRotateTickText) {
    var $$ = this.owner,
        config = $$.config,
        axisParams = {
      isCategory: $$.isCategorized(),
      withOuterTick: withOuterTick,
      tickMultiline: config.axis_x_tick_multiline,
      tickMultilineMax: config.axis_x_tick_multiline ? Number(config.axis_x_tick_multilineMax) : 0,
      tickWidth: config.axis_x_tick_width,
      tickTextRotate: withoutRotateTickText ? 0 : config.axis_x_tick_rotate,
      withoutTransition: withoutTransition
    },
        axis = new this.internal(this, axisParams).axis.scale(scale).orient(orient);

    if ($$.isTimeSeries() && tickValues && typeof tickValues !== "function") {
      tickValues = tickValues.map(function (v) {
        return $$.parseDate(v);
      });
    } // Set tick


    axis.tickFormat(tickFormat).tickValues(tickValues);

    if ($$.isCategorized()) {
      axis.tickCentered(config.axis_x_tick_centered);

      if (isEmpty(config.axis_x_tick_culling)) {
        config.axis_x_tick_culling = false;
      }
    }

    return axis;
  };

  Axis.prototype.updateXAxisTickValues = function updateXAxisTickValues(targets, axis) {
    var $$ = this.owner,
        config = $$.config,
        tickValues;

    if (config.axis_x_tick_fit || config.axis_x_tick_count) {
      tickValues = this.generateTickValues($$.mapTargetsToUniqueXs(targets), config.axis_x_tick_count, $$.isTimeSeries());
    }

    if (axis) {
      axis.tickValues(tickValues);
    } else {
      $$.xAxis.tickValues(tickValues);
      $$.subXAxis.tickValues(tickValues);
    }

    return tickValues;
  };

  Axis.prototype.getYAxis = function getYAxis(scale, orient, tickFormat, tickValues, withOuterTick, withoutTransition, withoutRotateTickText) {
    var $$ = this.owner,
        config = $$.config,
        axisParams = {
      withOuterTick: withOuterTick,
      withoutTransition: withoutTransition,
      tickTextRotate: withoutRotateTickText ? 0 : config.axis_y_tick_rotate
    },
        axis = new this.internal(this, axisParams).axis.scale(scale).orient(orient).tickFormat(tickFormat);

    if ($$.isTimeSeriesY()) {
      axis.ticks(config.axis_y_tick_time_type, config.axis_y_tick_time_interval);
    } else {
      axis.tickValues(tickValues);
    }

    return axis;
  };

  Axis.prototype.getId = function getId(id) {
    var config = this.owner.config;
    return id in config.data_axes ? config.data_axes[id] : 'y';
  };

  Axis.prototype.getXAxisTickFormat = function getXAxisTickFormat() {
    // #2251 previously set any negative values to a whole number,
    // however both should be truncated according to the users format specification
    var $$ = this.owner,
        config = $$.config;
    var format = $$.isTimeSeries() ? $$.defaultAxisTimeFormat : $$.isCategorized() ? $$.categoryName : function (v) {
      return v;
    };

    if (config.axis_x_tick_format) {
      if (isFunction(config.axis_x_tick_format)) {
        format = config.axis_x_tick_format;
      } else if ($$.isTimeSeries()) {
        format = function format(date) {
          return date ? $$.axisTimeFormat(config.axis_x_tick_format)(date) : "";
        };
      }
    }

    return isFunction(format) ? function (v) {
      return format.call($$, v);
    } : format;
  };

  Axis.prototype.getTickValues = function getTickValues(tickValues, axis) {
    return tickValues ? tickValues : axis ? axis.tickValues() : undefined;
  };

  Axis.prototype.getXAxisTickValues = function getXAxisTickValues() {
    return this.getTickValues(this.owner.config.axis_x_tick_values, this.owner.xAxis);
  };

  Axis.prototype.getYAxisTickValues = function getYAxisTickValues() {
    return this.getTickValues(this.owner.config.axis_y_tick_values, this.owner.yAxis);
  };

  Axis.prototype.getY2AxisTickValues = function getY2AxisTickValues() {
    return this.getTickValues(this.owner.config.axis_y2_tick_values, this.owner.y2Axis);
  };

  Axis.prototype.getLabelOptionByAxisId = function getLabelOptionByAxisId(axisId) {
    var $$ = this.owner,
        config = $$.config,
        option;

    if (axisId === 'y') {
      option = config.axis_y_label;
    } else if (axisId === 'y2') {
      option = config.axis_y2_label;
    } else if (axisId === 'x') {
      option = config.axis_x_label;
    }

    return option;
  };

  Axis.prototype.getLabelText = function getLabelText(axisId) {
    var option = this.getLabelOptionByAxisId(axisId);
    return isString(option) ? option : option ? option.text : null;
  };

  Axis.prototype.setLabelText = function setLabelText(axisId, text) {
    var $$ = this.owner,
        config = $$.config,
        option = this.getLabelOptionByAxisId(axisId);

    if (isString(option)) {
      if (axisId === 'y') {
        config.axis_y_label = text;
      } else if (axisId === 'y2') {
        config.axis_y2_label = text;
      } else if (axisId === 'x') {
        config.axis_x_label = text;
      }
    } else if (option) {
      option.text = text;
    }
  };

  Axis.prototype.getLabelPosition = function getLabelPosition(axisId, defaultPosition) {
    var option = this.getLabelOptionByAxisId(axisId),
        position = option && _typeof(option) === 'object' && option.position ? option.position : defaultPosition;
    return {
      isInner: position.indexOf('inner') >= 0,
      isOuter: position.indexOf('outer') >= 0,
      isLeft: position.indexOf('left') >= 0,
      isCenter: position.indexOf('center') >= 0,
      isRight: position.indexOf('right') >= 0,
      isTop: position.indexOf('top') >= 0,
      isMiddle: position.indexOf('middle') >= 0,
      isBottom: position.indexOf('bottom') >= 0
    };
  };

  Axis.prototype.getXAxisLabelPosition = function getXAxisLabelPosition() {
    return this.getLabelPosition('x', this.owner.config.axis_rotated ? 'inner-top' : 'inner-right');
  };

  Axis.prototype.getYAxisLabelPosition = function getYAxisLabelPosition() {
    return this.getLabelPosition('y', this.owner.config.axis_rotated ? 'inner-right' : 'inner-top');
  };

  Axis.prototype.getY2AxisLabelPosition = function getY2AxisLabelPosition() {
    return this.getLabelPosition('y2', this.owner.config.axis_rotated ? 'inner-right' : 'inner-top');
  };

  Axis.prototype.getLabelPositionById = function getLabelPositionById(id) {
    return id === 'y2' ? this.getY2AxisLabelPosition() : id === 'y' ? this.getYAxisLabelPosition() : this.getXAxisLabelPosition();
  };

  Axis.prototype.textForXAxisLabel = function textForXAxisLabel() {
    return this.getLabelText('x');
  };

  Axis.prototype.textForYAxisLabel = function textForYAxisLabel() {
    return this.getLabelText('y');
  };

  Axis.prototype.textForY2AxisLabel = function textForY2AxisLabel() {
    return this.getLabelText('y2');
  };

  Axis.prototype.xForAxisLabel = function xForAxisLabel(forHorizontal, position) {
    var $$ = this.owner;

    if (forHorizontal) {
      return position.isLeft ? 0 : position.isCenter ? $$.width / 2 : $$.width;
    } else {
      return position.isBottom ? -$$.height : position.isMiddle ? -$$.height / 2 : 0;
    }
  };

  Axis.prototype.dxForAxisLabel = function dxForAxisLabel(forHorizontal, position) {
    if (forHorizontal) {
      return position.isLeft ? "0.5em" : position.isRight ? "-0.5em" : "0";
    } else {
      return position.isTop ? "-0.5em" : position.isBottom ? "0.5em" : "0";
    }
  };

  Axis.prototype.textAnchorForAxisLabel = function textAnchorForAxisLabel(forHorizontal, position) {
    if (forHorizontal) {
      return position.isLeft ? 'start' : position.isCenter ? 'middle' : 'end';
    } else {
      return position.isBottom ? 'start' : position.isMiddle ? 'middle' : 'end';
    }
  };

  Axis.prototype.xForXAxisLabel = function xForXAxisLabel() {
    return this.xForAxisLabel(!this.owner.config.axis_rotated, this.getXAxisLabelPosition());
  };

  Axis.prototype.xForYAxisLabel = function xForYAxisLabel() {
    return this.xForAxisLabel(this.owner.config.axis_rotated, this.getYAxisLabelPosition());
  };

  Axis.prototype.xForY2AxisLabel = function xForY2AxisLabel() {
    return this.xForAxisLabel(this.owner.config.axis_rotated, this.getY2AxisLabelPosition());
  };

  Axis.prototype.dxForXAxisLabel = function dxForXAxisLabel() {
    return this.dxForAxisLabel(!this.owner.config.axis_rotated, this.getXAxisLabelPosition());
  };

  Axis.prototype.dxForYAxisLabel = function dxForYAxisLabel() {
    return this.dxForAxisLabel(this.owner.config.axis_rotated, this.getYAxisLabelPosition());
  };

  Axis.prototype.dxForY2AxisLabel = function dxForY2AxisLabel() {
    return this.dxForAxisLabel(this.owner.config.axis_rotated, this.getY2AxisLabelPosition());
  };

  Axis.prototype.dyForXAxisLabel = function dyForXAxisLabel() {
    var $$ = this.owner,
        config = $$.config,
        position = this.getXAxisLabelPosition();

    if (config.axis_rotated) {
      return position.isInner ? "1.2em" : -25 - ($$.config.axis_x_inner ? 0 : this.getMaxTickWidth('x'));
    } else {
      return position.isInner ? "-0.5em" : config.axis_x_height ? config.axis_x_height - 10 : "3em";
    }
  };

  Axis.prototype.dyForYAxisLabel = function dyForYAxisLabel() {
    var $$ = this.owner,
        position = this.getYAxisLabelPosition();

    if ($$.config.axis_rotated) {
      return position.isInner ? "-0.5em" : "3em";
    } else {
      return position.isInner ? "1.2em" : -10 - ($$.config.axis_y_inner ? 0 : this.getMaxTickWidth('y') + 10);
    }
  };

  Axis.prototype.dyForY2AxisLabel = function dyForY2AxisLabel() {
    var $$ = this.owner,
        position = this.getY2AxisLabelPosition();

    if ($$.config.axis_rotated) {
      return position.isInner ? "1.2em" : "-2.2em";
    } else {
      return position.isInner ? "-0.5em" : 15 + ($$.config.axis_y2_inner ? 0 : this.getMaxTickWidth('y2') + 15);
    }
  };

  Axis.prototype.textAnchorForXAxisLabel = function textAnchorForXAxisLabel() {
    var $$ = this.owner;
    return this.textAnchorForAxisLabel(!$$.config.axis_rotated, this.getXAxisLabelPosition());
  };

  Axis.prototype.textAnchorForYAxisLabel = function textAnchorForYAxisLabel() {
    var $$ = this.owner;
    return this.textAnchorForAxisLabel($$.config.axis_rotated, this.getYAxisLabelPosition());
  };

  Axis.prototype.textAnchorForY2AxisLabel = function textAnchorForY2AxisLabel() {
    var $$ = this.owner;
    return this.textAnchorForAxisLabel($$.config.axis_rotated, this.getY2AxisLabelPosition());
  };

  Axis.prototype.getMaxTickWidth = function getMaxTickWidth(id, withoutRecompute) {
    var $$ = this.owner,
        config = $$.config,
        maxWidth = 0,
        targetsToShow,
        scale,
        axis,
        dummy,
        svg;

    if (withoutRecompute && $$.currentMaxTickWidths[id]) {
      return $$.currentMaxTickWidths[id];
    }

    if ($$.svg) {
      targetsToShow = $$.filterTargetsToShow($$.data.targets);

      if (id === 'y') {
        scale = $$.y.copy().domain($$.getYDomain(targetsToShow, 'y'));
        axis = this.getYAxis(scale, $$.yOrient, config.axis_y_tick_format, $$.yAxisTickValues, false, true, true);
      } else if (id === 'y2') {
        scale = $$.y2.copy().domain($$.getYDomain(targetsToShow, 'y2'));
        axis = this.getYAxis(scale, $$.y2Orient, config.axis_y2_tick_format, $$.y2AxisTickValues, false, true, true);
      } else {
        scale = $$.x.copy().domain($$.getXDomain(targetsToShow));
        axis = this.getXAxis(scale, $$.xOrient, $$.xAxisTickFormat, $$.xAxisTickValues, false, true, true);
        this.updateXAxisTickValues(targetsToShow, axis);
      }

      dummy = $$.d3.select('body').append('div').classed('c3', true);
      svg = dummy.append("svg").style('visibility', 'hidden').style('position', 'fixed').style('top', 0).style('left', 0), svg.append('g').call(axis).each(function () {
        $$.d3.select(this).selectAll('text').each(function () {
          var box = this.getBoundingClientRect();

          if (maxWidth < box.width) {
            maxWidth = box.width;
          }
        });
        dummy.remove();
      });
    }

    $$.currentMaxTickWidths[id] = maxWidth <= 0 ? $$.currentMaxTickWidths[id] : maxWidth;
    return $$.currentMaxTickWidths[id];
  };

  Axis.prototype.updateLabels = function updateLabels(withTransition) {
    var $$ = this.owner;
    var axisXLabel = $$.main.select('.' + CLASS.axisX + ' .' + CLASS.axisXLabel),
        axisYLabel = $$.main.select('.' + CLASS.axisY + ' .' + CLASS.axisYLabel),
        axisY2Label = $$.main.select('.' + CLASS.axisY2 + ' .' + CLASS.axisY2Label);
    (withTransition ? axisXLabel.transition() : axisXLabel).attr("x", this.xForXAxisLabel.bind(this)).attr("dx", this.dxForXAxisLabel.bind(this)).attr("dy", this.dyForXAxisLabel.bind(this)).text(this.textForXAxisLabel.bind(this));
    (withTransition ? axisYLabel.transition() : axisYLabel).attr("x", this.xForYAxisLabel.bind(this)).attr("dx", this.dxForYAxisLabel.bind(this)).attr("dy", this.dyForYAxisLabel.bind(this)).text(this.textForYAxisLabel.bind(this));
    (withTransition ? axisY2Label.transition() : axisY2Label).attr("x", this.xForY2AxisLabel.bind(this)).attr("dx", this.dxForY2AxisLabel.bind(this)).attr("dy", this.dyForY2AxisLabel.bind(this)).text(this.textForY2AxisLabel.bind(this));
  };

  Axis.prototype.getPadding = function getPadding(padding, key, defaultValue, domainLength) {
    var p = typeof padding === 'number' ? padding : padding[key];

    if (!isValue(p)) {
      return defaultValue;
    }

    if (padding.unit === 'ratio') {
      return padding[key] * domainLength;
    } // assume padding is pixels if unit is not specified


    return this.convertPixelsToAxisPadding(p, domainLength);
  };

  Axis.prototype.convertPixelsToAxisPadding = function convertPixelsToAxisPadding(pixels, domainLength) {
    var $$ = this.owner,
        length = $$.config.axis_rotated ? $$.width : $$.height;
    return domainLength * (pixels / length);
  };

  Axis.prototype.generateTickValues = function generateTickValues(values, tickCount, forTimeSeries) {
    var tickValues = values,
        targetCount,
        start,
        end,
        count,
        interval,
        i,
        tickValue;

    if (tickCount) {
      targetCount = isFunction(tickCount) ? tickCount() : tickCount; // compute ticks according to tickCount

      if (targetCount === 1) {
        tickValues = [values[0]];
      } else if (targetCount === 2) {
        tickValues = [values[0], values[values.length - 1]];
      } else if (targetCount > 2) {
        count = targetCount - 2;
        start = values[0];
        end = values[values.length - 1];
        interval = (end - start) / (count + 1); // re-construct unique values

        tickValues = [start];

        for (i = 0; i < count; i++) {
          tickValue = +start + interval * (i + 1);
          tickValues.push(forTimeSeries ? new Date(tickValue) : tickValue);
        }

        tickValues.push(end);
      }
    }

    if (!forTimeSeries) {
      tickValues = tickValues.sort(function (a, b) {
        return a - b;
      });
    }

    return tickValues;
  };

  Axis.prototype.generateTransitions = function generateTransitions(duration) {
    var $$ = this.owner,
        axes = $$.axes;
    return {
      axisX: duration ? axes.x.transition().duration(duration) : axes.x,
      axisY: duration ? axes.y.transition().duration(duration) : axes.y,
      axisY2: duration ? axes.y2.transition().duration(duration) : axes.y2,
      axisSubX: duration ? axes.subx.transition().duration(duration) : axes.subx
    };
  };

  Axis.prototype.redraw = function redraw(duration, isHidden) {
    var $$ = this.owner,
        transition = duration ? $$.d3.transition().duration(duration) : null;
    $$.axes.x.style("opacity", isHidden ? 0 : 1).call($$.xAxis, transition);
    $$.axes.y.style("opacity", isHidden ? 0 : 1).call($$.yAxis, transition);
    $$.axes.y2.style("opacity", isHidden ? 0 : 1).call($$.y2Axis, transition);
    $$.axes.subx.style("opacity", isHidden ? 0 : 1).call($$.subXAxis, transition);
  };

  var c3 = {
    version: "0.6.12",
    chart: {
      fn: Chart.prototype,
      internal: {
        fn: ChartInternal.prototype,
        axis: {
          fn: Axis.prototype,
          internal: {
            fn: AxisInternal.prototype
          }
        }
      }
    },
    generate: function generate(config) {
      return new Chart(config);
    }
  };

  ChartInternal.prototype.beforeInit = function () {// can do something
  };

  ChartInternal.prototype.afterInit = function () {// can do something
  };

  ChartInternal.prototype.init = function () {
    var $$ = this,
        config = $$.config;
    $$.initParams();

    if (config.data_url) {
      $$.convertUrlToData(config.data_url, config.data_mimeType, config.data_headers, config.data_keys, $$.initWithData);
    } else if (config.data_json) {
      $$.initWithData($$.convertJsonToData(config.data_json, config.data_keys));
    } else if (config.data_rows) {
      $$.initWithData($$.convertRowsToData(config.data_rows));
    } else if (config.data_columns) {
      $$.initWithData($$.convertColumnsToData(config.data_columns));
    } else {
      throw Error('url or json or rows or columns is required.');
    }
  };

  ChartInternal.prototype.initParams = function () {
    var $$ = this,
        d3 = $$.d3,
        config = $$.config; // MEMO: clipId needs to be unique because it conflicts when multiple charts exist

    $$.clipId = "c3-" + +new Date() + '-clip';
    $$.clipIdForXAxis = $$.clipId + '-xaxis';
    $$.clipIdForYAxis = $$.clipId + '-yaxis';
    $$.clipIdForGrid = $$.clipId + '-grid';
    $$.clipIdForSubchart = $$.clipId + '-subchart';
    $$.clipPath = $$.getClipPath($$.clipId);
    $$.clipPathForXAxis = $$.getClipPath($$.clipIdForXAxis);
    $$.clipPathForYAxis = $$.getClipPath($$.clipIdForYAxis);
    $$.clipPathForGrid = $$.getClipPath($$.clipIdForGrid);
    $$.clipPathForSubchart = $$.getClipPath($$.clipIdForSubchart);
    $$.dragStart = null;
    $$.dragging = false;
    $$.flowing = false;
    $$.cancelClick = false;
    $$.mouseover = false;
    $$.transiting = false;
    $$.color = $$.generateColor();
    $$.levelColor = $$.generateLevelColor();
    $$.dataTimeParse = (config.data_xLocaltime ? d3.timeParse : d3.utcParse)($$.config.data_xFormat);
    $$.axisTimeFormat = config.axis_x_localtime ? d3.timeFormat : d3.utcFormat;

    $$.defaultAxisTimeFormat = function (date) {
      if (date.getMilliseconds()) {
        return d3.timeFormat(".%L")(date);
      }

      if (date.getSeconds()) {
        return d3.timeFormat(":%S")(date);
      }

      if (date.getMinutes()) {
        return d3.timeFormat("%I:%M")(date);
      }

      if (date.getHours()) {
        return d3.timeFormat("%I %p")(date);
      }

      if (date.getDay() && date.getDate() !== 1) {
        return d3.timeFormat("%-m/%-d")(date);
      }

      if (date.getDate() !== 1) {
        return d3.timeFormat("%-m/%-d")(date);
      }

      if (date.getMonth()) {
        return d3.timeFormat("%-m/%-d")(date);
      }

      return d3.timeFormat("%Y/%-m/%-d")(date);
    };

    $$.hiddenTargetIds = [];
    $$.hiddenLegendIds = [];
    $$.focusedTargetIds = [];
    $$.defocusedTargetIds = [];
    $$.xOrient = config.axis_rotated ? config.axis_x_inner ? "right" : "left" : config.axis_x_inner ? "top" : "bottom";
    $$.yOrient = config.axis_rotated ? config.axis_y_inner ? "top" : "bottom" : config.axis_y_inner ? "right" : "left";
    $$.y2Orient = config.axis_rotated ? config.axis_y2_inner ? "bottom" : "top" : config.axis_y2_inner ? "left" : "right";
    $$.subXOrient = config.axis_rotated ? "left" : "bottom";
    $$.isLegendRight = config.legend_position === 'right';
    $$.isLegendInset = config.legend_position === 'inset';
    $$.isLegendTop = config.legend_inset_anchor === 'top-left' || config.legend_inset_anchor === 'top-right';
    $$.isLegendLeft = config.legend_inset_anchor === 'top-left' || config.legend_inset_anchor === 'bottom-left';
    $$.legendStep = 0;
    $$.legendItemWidth = 0;
    $$.legendItemHeight = 0;
    $$.currentMaxTickWidths = {
      x: 0,
      y: 0,
      y2: 0
    };
    $$.rotated_padding_left = 30;
    $$.rotated_padding_right = config.axis_rotated && !config.axis_x_show ? 0 : 30;
    $$.rotated_padding_top = 5;
    $$.withoutFadeIn = {};
    $$.intervalForObserveInserted = undefined;
    $$.axes.subx = d3.selectAll([]); // needs when excluding subchart.js
  };

  ChartInternal.prototype.initChartElements = function () {
    if (this.initBar) {
      this.initBar();
    }

    if (this.initLine) {
      this.initLine();
    }

    if (this.initArc) {
      this.initArc();
    }

    if (this.initGauge) {
      this.initGauge();
    }

    if (this.initText) {
      this.initText();
    }
  };

  ChartInternal.prototype.initWithData = function (data) {
    var $$ = this,
        d3 = $$.d3,
        config = $$.config;
    var defs,
        main,
        binding = true;
    $$.axis = new Axis($$);

    if (!config.bindto) {
      $$.selectChart = d3.selectAll([]);
    } else if (typeof config.bindto.node === 'function') {
      $$.selectChart = config.bindto;
    } else {
      $$.selectChart = d3.select(config.bindto);
    }

    if ($$.selectChart.empty()) {
      $$.selectChart = d3.select(document.createElement('div')).style('opacity', 0);
      $$.observeInserted($$.selectChart);
      binding = false;
    }

    $$.selectChart.html("").classed("c3", true); // Init data as targets

    $$.data.xs = {};
    $$.data.targets = $$.convertDataToTargets(data);

    if (config.data_filter) {
      $$.data.targets = $$.data.targets.filter(config.data_filter);
    } // Set targets to hide if needed


    if (config.data_hide) {
      $$.addHiddenTargetIds(config.data_hide === true ? $$.mapToIds($$.data.targets) : config.data_hide);
    }

    if (config.legend_hide) {
      $$.addHiddenLegendIds(config.legend_hide === true ? $$.mapToIds($$.data.targets) : config.legend_hide);
    } // Init sizes and scales


    $$.updateSizes();
    $$.updateScales(); // Set domains for each scale

    $$.x.domain(d3.extent($$.getXDomain($$.data.targets)));
    $$.y.domain($$.getYDomain($$.data.targets, 'y'));
    $$.y2.domain($$.getYDomain($$.data.targets, 'y2'));
    $$.subX.domain($$.x.domain());
    $$.subY.domain($$.y.domain());
    $$.subY2.domain($$.y2.domain()); // Save original x domain for zoom update

    $$.orgXDomain = $$.x.domain();
    /*-- Basic Elements --*/
    // Define svgs

    $$.svg = $$.selectChart.append("svg").style("overflow", "hidden").on('mouseenter', function () {
      return config.onmouseover.call($$);
    }).on('mouseleave', function () {
      return config.onmouseout.call($$);
    });

    if ($$.config.svg_classname) {
      $$.svg.attr('class', $$.config.svg_classname);
    } // Define defs


    defs = $$.svg.append("defs");
    $$.clipChart = $$.appendClip(defs, $$.clipId);
    $$.clipXAxis = $$.appendClip(defs, $$.clipIdForXAxis);
    $$.clipYAxis = $$.appendClip(defs, $$.clipIdForYAxis);
    $$.clipGrid = $$.appendClip(defs, $$.clipIdForGrid);
    $$.clipSubchart = $$.appendClip(defs, $$.clipIdForSubchart);
    $$.updateSvgSize(); // Define regions

    main = $$.main = $$.svg.append("g").attr("transform", $$.getTranslate('main'));

    if ($$.initPie) {
      $$.initPie();
    }

    if ($$.initDragZoom) {
      $$.initDragZoom();
    }

    if ($$.initSubchart) {
      $$.initSubchart();
    }

    if ($$.initTooltip) {
      $$.initTooltip();
    }

    if ($$.initLegend) {
      $$.initLegend();
    }

    if ($$.initTitle) {
      $$.initTitle();
    }

    if ($$.initZoom) {
      $$.initZoom();
    } // Update selection based on size and scale
    // TODO: currently this must be called after initLegend because of update of sizes, but it should be done in initSubchart.


    if ($$.initSubchartBrush) {
      $$.initSubchartBrush();
    }
    /*-- Main Region --*/
    // text when empty


    main.append("text").attr("class", CLASS.text + ' ' + CLASS.empty).attr("text-anchor", "middle") // horizontal centering of text at x position in all browsers.
    .attr("dominant-baseline", "middle"); // vertical centering of text at y position in all browsers, except IE.
    // Regions

    $$.initRegion(); // Grids

    $$.initGrid(); // Define g for chart area

    main.append('g').attr("clip-path", $$.clipPath).attr('class', CLASS.chart); // Grid lines

    if (config.grid_lines_front) {
      $$.initGridLines();
    } // Cover whole with rects for events


    $$.initEventRect(); // Define g for chart

    $$.initChartElements(); // Add Axis

    $$.axis.init(); // Set targets

    $$.updateTargets($$.data.targets); // Set default extent if defined

    if (config.axis_x_selection) {
      $$.brush.selectionAsValue($$.getDefaultSelection());
    } // Draw with targets


    if (binding) {
      $$.updateDimension();
      $$.config.oninit.call($$);
      $$.redraw({
        withTransition: false,
        withTransform: true,
        withUpdateXDomain: true,
        withUpdateOrgXDomain: true,
        withTransitionForAxis: false
      });
    } // Bind to resize event


    $$.bindResize(); // Bind to window focus event

    $$.bindWindowFocus(); // export element of the chart

    $$.api.element = $$.selectChart.node();
  };

  ChartInternal.prototype.smoothLines = function (el, type) {
    var $$ = this;

    if (type === 'grid') {
      el.each(function () {
        var g = $$.d3.select(this),
            x1 = g.attr('x1'),
            x2 = g.attr('x2'),
            y1 = g.attr('y1'),
            y2 = g.attr('y2');
        g.attr({
          'x1': Math.ceil(x1),
          'x2': Math.ceil(x2),
          'y1': Math.ceil(y1),
          'y2': Math.ceil(y2)
        });
      });
    }
  };

  ChartInternal.prototype.updateSizes = function () {
    var $$ = this,
        config = $$.config;
    var legendHeight = $$.legend ? $$.getLegendHeight() : 0,
        legendWidth = $$.legend ? $$.getLegendWidth() : 0,
        legendHeightForBottom = $$.isLegendRight || $$.isLegendInset ? 0 : legendHeight,
        hasArc = $$.hasArcType(),
        xAxisHeight = config.axis_rotated || hasArc ? 0 : $$.getHorizontalAxisHeight('x'),
        subchartHeight = config.subchart_show && !hasArc ? config.subchart_size_height + xAxisHeight : 0;
    $$.currentWidth = $$.getCurrentWidth();
    $$.currentHeight = $$.getCurrentHeight(); // for main

    $$.margin = config.axis_rotated ? {
      top: $$.getHorizontalAxisHeight('y2') + $$.getCurrentPaddingTop(),
      right: hasArc ? 0 : $$.getCurrentPaddingRight(),
      bottom: $$.getHorizontalAxisHeight('y') + legendHeightForBottom + $$.getCurrentPaddingBottom(),
      left: subchartHeight + (hasArc ? 0 : $$.getCurrentPaddingLeft())
    } : {
      top: 4 + $$.getCurrentPaddingTop(),
      // for top tick text
      right: hasArc ? 0 : $$.getCurrentPaddingRight(),
      bottom: xAxisHeight + subchartHeight + legendHeightForBottom + $$.getCurrentPaddingBottom(),
      left: hasArc ? 0 : $$.getCurrentPaddingLeft()
    }; // for subchart

    $$.margin2 = config.axis_rotated ? {
      top: $$.margin.top,
      right: NaN,
      bottom: 20 + legendHeightForBottom,
      left: $$.rotated_padding_left
    } : {
      top: $$.currentHeight - subchartHeight - legendHeightForBottom,
      right: NaN,
      bottom: xAxisHeight + legendHeightForBottom,
      left: $$.margin.left
    }; // for legend

    $$.margin3 = {
      top: 0,
      right: NaN,
      bottom: 0,
      left: 0
    };

    if ($$.updateSizeForLegend) {
      $$.updateSizeForLegend(legendHeight, legendWidth);
    }

    $$.width = $$.currentWidth - $$.margin.left - $$.margin.right;
    $$.height = $$.currentHeight - $$.margin.top - $$.margin.bottom;

    if ($$.width < 0) {
      $$.width = 0;
    }

    if ($$.height < 0) {
      $$.height = 0;
    }

    $$.width2 = config.axis_rotated ? $$.margin.left - $$.rotated_padding_left - $$.rotated_padding_right : $$.width;
    $$.height2 = config.axis_rotated ? $$.height : $$.currentHeight - $$.margin2.top - $$.margin2.bottom;

    if ($$.width2 < 0) {
      $$.width2 = 0;
    }

    if ($$.height2 < 0) {
      $$.height2 = 0;
    } // for arc


    $$.arcWidth = $$.width - ($$.isLegendRight ? legendWidth + 10 : 0);
    $$.arcHeight = $$.height - ($$.isLegendRight ? 0 : 10);

    if ($$.hasType('gauge') && !config.gauge_fullCircle) {
      $$.arcHeight += $$.height - $$.getGaugeLabelHeight();
    }

    if ($$.updateRadius) {
      $$.updateRadius();
    }

    if ($$.isLegendRight && hasArc) {
      $$.margin3.left = $$.arcWidth / 2 + $$.radiusExpanded * 1.1;
    }
  };

  ChartInternal.prototype.updateTargets = function (targets) {
    var $$ = this;
    /*-- Main --*/
    //-- Text --//

    $$.updateTargetsForText(targets); //-- Bar --//

    $$.updateTargetsForBar(targets); //-- Line --//

    $$.updateTargetsForLine(targets); //-- Arc --//

    if ($$.hasArcType() && $$.updateTargetsForArc) {
      $$.updateTargetsForArc(targets);
    }
    /*-- Sub --*/


    if ($$.updateTargetsForSubchart) {
      $$.updateTargetsForSubchart(targets);
    } // Fade-in each chart


    $$.showTargets();
  };

  ChartInternal.prototype.showTargets = function () {
    var $$ = this;
    $$.svg.selectAll('.' + CLASS.target).filter(function (d) {
      return $$.isTargetToShow(d.id);
    }).transition().duration($$.config.transition_duration).style("opacity", 1);
  };

  ChartInternal.prototype.redraw = function (options, transitions) {
    var $$ = this,
        main = $$.main,
        d3 = $$.d3,
        config = $$.config;
    var areaIndices = $$.getShapeIndices($$.isAreaType),
        barIndices = $$.getShapeIndices($$.isBarType),
        lineIndices = $$.getShapeIndices($$.isLineType);
    var withY, withSubchart, withTransition, withTransitionForExit, withTransitionForAxis, withTransform, withUpdateXDomain, withUpdateOrgXDomain, withTrimXDomain, withLegend, withEventRect, withDimension, withUpdateXAxis;
    var hideAxis = $$.hasArcType();
    var drawArea, drawBar, drawLine, xForText, yForText;
    var duration, durationForExit, durationForAxis;
    var transitionsToWait, waitForDraw, flow, transition;
    var targetsToShow = $$.filterTargetsToShow($$.data.targets),
        tickValues,
        i,
        intervalForCulling,
        xDomainForZoom;
    var xv = $$.xv.bind($$),
        cx,
        cy;
    options = options || {};
    withY = getOption(options, "withY", true);
    withSubchart = getOption(options, "withSubchart", true);
    withTransition = getOption(options, "withTransition", true);
    withTransform = getOption(options, "withTransform", false);
    withUpdateXDomain = getOption(options, "withUpdateXDomain", false);
    withUpdateOrgXDomain = getOption(options, "withUpdateOrgXDomain", false);
    withTrimXDomain = getOption(options, "withTrimXDomain", true);
    withUpdateXAxis = getOption(options, "withUpdateXAxis", withUpdateXDomain);
    withLegend = getOption(options, "withLegend", false);
    withEventRect = getOption(options, "withEventRect", true);
    withDimension = getOption(options, "withDimension", true);
    withTransitionForExit = getOption(options, "withTransitionForExit", withTransition);
    withTransitionForAxis = getOption(options, "withTransitionForAxis", withTransition);
    duration = withTransition ? config.transition_duration : 0;
    durationForExit = withTransitionForExit ? duration : 0;
    durationForAxis = withTransitionForAxis ? duration : 0;
    transitions = transitions || $$.axis.generateTransitions(durationForAxis); // update legend and transform each g

    if (withLegend && config.legend_show) {
      $$.updateLegend($$.mapToIds($$.data.targets), options, transitions);
    } else if (withDimension) {
      // need to update dimension (e.g. axis.y.tick.values) because y tick values should change
      // no need to update axis in it because they will be updated in redraw()
      $$.updateDimension(true);
    } // MEMO: needed for grids calculation


    if ($$.isCategorized() && targetsToShow.length === 0) {
      $$.x.domain([0, $$.axes.x.selectAll('.tick').size()]);
    }

    if (targetsToShow.length) {
      $$.updateXDomain(targetsToShow, withUpdateXDomain, withUpdateOrgXDomain, withTrimXDomain);

      if (!config.axis_x_tick_values) {
        tickValues = $$.axis.updateXAxisTickValues(targetsToShow);
      }
    } else {
      $$.xAxis.tickValues([]);
      $$.subXAxis.tickValues([]);
    }

    if (config.zoom_rescale && !options.flow) {
      xDomainForZoom = $$.x.orgDomain();
    }

    $$.y.domain($$.getYDomain(targetsToShow, 'y', xDomainForZoom));
    $$.y2.domain($$.getYDomain(targetsToShow, 'y2', xDomainForZoom));

    if (!config.axis_y_tick_values && config.axis_y_tick_count) {
      $$.yAxis.tickValues($$.axis.generateTickValues($$.y.domain(), config.axis_y_tick_count));
    }

    if (!config.axis_y2_tick_values && config.axis_y2_tick_count) {
      $$.y2Axis.tickValues($$.axis.generateTickValues($$.y2.domain(), config.axis_y2_tick_count));
    } // axes


    $$.axis.redraw(durationForAxis, hideAxis); // Update axis label

    $$.axis.updateLabels(withTransition); // show/hide if manual culling needed

    if ((withUpdateXDomain || withUpdateXAxis) && targetsToShow.length) {
      if (config.axis_x_tick_culling && tickValues) {
        for (i = 1; i < tickValues.length; i++) {
          if (tickValues.length / i < config.axis_x_tick_culling_max) {
            intervalForCulling = i;
            break;
          }
        }

        $$.svg.selectAll('.' + CLASS.axisX + ' .tick text').each(function (e) {
          var index = tickValues.indexOf(e);

          if (index >= 0) {
            d3.select(this).style('display', index % intervalForCulling ? 'none' : 'block');
          }
        });
      } else {
        $$.svg.selectAll('.' + CLASS.axisX + ' .tick text').style('display', 'block');
      }
    } // setup drawer - MEMO: these must be called after axis updated


    drawArea = $$.generateDrawArea ? $$.generateDrawArea(areaIndices, false) : undefined;
    drawBar = $$.generateDrawBar ? $$.generateDrawBar(barIndices) : undefined;
    drawLine = $$.generateDrawLine ? $$.generateDrawLine(lineIndices, false) : undefined;
    xForText = $$.generateXYForText(areaIndices, barIndices, lineIndices, true);
    yForText = $$.generateXYForText(areaIndices, barIndices, lineIndices, false); // update circleY based on updated parameters

    $$.updateCircleY(); // generate circle x/y functions depending on updated params

    cx = ($$.config.axis_rotated ? $$.circleY : $$.circleX).bind($$);
    cy = ($$.config.axis_rotated ? $$.circleX : $$.circleY).bind($$); // Update sub domain

    if (withY) {
      $$.subY.domain($$.getYDomain(targetsToShow, 'y'));
      $$.subY2.domain($$.getYDomain(targetsToShow, 'y2'));
    } // xgrid focus


    $$.updateXgridFocus(); // Data empty label positioning and text.

    main.select("text." + CLASS.text + '.' + CLASS.empty).attr("x", $$.width / 2).attr("y", $$.height / 2).text(config.data_empty_label_text).transition().style('opacity', targetsToShow.length ? 0 : 1); // event rect

    if (withEventRect) {
      $$.redrawEventRect();
    } // grid


    $$.updateGrid(duration); // rect for regions

    $$.updateRegion(duration); // bars

    $$.updateBar(durationForExit); // lines, areas and cricles

    $$.updateLine(durationForExit);
    $$.updateArea(durationForExit);
    $$.updateCircle(cx, cy); // text

    if ($$.hasDataLabel()) {
      $$.updateText(xForText, yForText, durationForExit);
    } // title


    if ($$.redrawTitle) {
      $$.redrawTitle();
    } // arc


    if ($$.redrawArc) {
      $$.redrawArc(duration, durationForExit, withTransform);
    } // subchart


    if ($$.redrawSubchart) {
      $$.redrawSubchart(withSubchart, transitions, duration, durationForExit, areaIndices, barIndices, lineIndices);
    } // circles for select


    main.selectAll('.' + CLASS.selectedCircles).filter($$.isBarType.bind($$)).selectAll('circle').remove();

    if (options.flow) {
      flow = $$.generateFlow({
        targets: targetsToShow,
        flow: options.flow,
        duration: options.flow.duration,
        drawBar: drawBar,
        drawLine: drawLine,
        drawArea: drawArea,
        cx: cx,
        cy: cy,
        xv: xv,
        xForText: xForText,
        yForText: yForText
      });
    }

    if ($$.isTabVisible()) {
      // Only use transition if tab visible. See #938.
      if (duration) {
        // transition should be derived from one transition
        transition = d3.transition().duration(duration);
        transitionsToWait = [];
        [$$.redrawBar(drawBar, true, transition), $$.redrawLine(drawLine, true, transition), $$.redrawArea(drawArea, true, transition), $$.redrawCircle(cx, cy, true, transition), $$.redrawText(xForText, yForText, options.flow, true, transition), $$.redrawRegion(true, transition), $$.redrawGrid(true, transition)].forEach(function (transitions) {
          transitions.forEach(function (transition) {
            transitionsToWait.push(transition);
          });
        }); // Wait for end of transitions to call flow and onrendered callback

        waitForDraw = $$.generateWait();
        transitionsToWait.forEach(function (t) {
          waitForDraw.add(t);
        });
        waitForDraw(function () {
          if (flow) {
            flow();
          }

          if (config.onrendered) {
            config.onrendered.call($$);
          }
        });
      } else {
        $$.redrawBar(drawBar);
        $$.redrawLine(drawLine);
        $$.redrawArea(drawArea);
        $$.redrawCircle(cx, cy);
        $$.redrawText(xForText, yForText, options.flow);
        $$.redrawRegion();
        $$.redrawGrid();

        if (flow) {
          flow();
        }

        if (config.onrendered) {
          config.onrendered.call($$);
        }
      }
    } // update fadein condition


    $$.mapToIds($$.data.targets).forEach(function (id) {
      $$.withoutFadeIn[id] = true;
    });
  };

  ChartInternal.prototype.updateAndRedraw = function (options) {
    var $$ = this,
        config = $$.config,
        transitions;
    options = options || {}; // same with redraw

    options.withTransition = getOption(options, "withTransition", true);
    options.withTransform = getOption(options, "withTransform", false);
    options.withLegend = getOption(options, "withLegend", false); // NOT same with redraw

    options.withUpdateXDomain = getOption(options, "withUpdateXDomain", true);
    options.withUpdateOrgXDomain = getOption(options, "withUpdateOrgXDomain", true);
    options.withTransitionForExit = false;
    options.withTransitionForTransform = getOption(options, "withTransitionForTransform", options.withTransition); // MEMO: this needs to be called before updateLegend and it means this ALWAYS needs to be called)

    $$.updateSizes(); // MEMO: called in updateLegend in redraw if withLegend

    if (!(options.withLegend && config.legend_show)) {
      transitions = $$.axis.generateTransitions(options.withTransitionForAxis ? config.transition_duration : 0); // Update scales

      $$.updateScales();
      $$.updateSvgSize(); // Update g positions

      $$.transformAll(options.withTransitionForTransform, transitions);
    } // Draw with new sizes & scales


    $$.redraw(options, transitions);
  };

  ChartInternal.prototype.redrawWithoutRescale = function () {
    this.redraw({
      withY: false,
      withSubchart: false,
      withEventRect: false,
      withTransitionForAxis: false
    });
  };

  ChartInternal.prototype.isTimeSeries = function () {
    return this.config.axis_x_type === 'timeseries';
  };

  ChartInternal.prototype.isCategorized = function () {
    return this.config.axis_x_type.indexOf('categor') >= 0;
  };

  ChartInternal.prototype.isCustomX = function () {
    var $$ = this,
        config = $$.config;
    return !$$.isTimeSeries() && (config.data_x || notEmpty(config.data_xs));
  };

  ChartInternal.prototype.isTimeSeriesY = function () {
    return this.config.axis_y_type === 'timeseries';
  };

  ChartInternal.prototype.getTranslate = function (target) {
    var $$ = this,
        config = $$.config,
        x,
        y;

    if (target === 'main') {
      x = asHalfPixel($$.margin.left);
      y = asHalfPixel($$.margin.top);
    } else if (target === 'context') {
      x = asHalfPixel($$.margin2.left);
      y = asHalfPixel($$.margin2.top);
    } else if (target === 'legend') {
      x = $$.margin3.left;
      y = $$.margin3.top;
    } else if (target === 'x') {
      x = 0;
      y = config.axis_rotated ? 0 : $$.height;
    } else if (target === 'y') {
      x = 0;
      y = config.axis_rotated ? $$.height : 0;
    } else if (target === 'y2') {
      x = config.axis_rotated ? 0 : $$.width;
      y = config.axis_rotated ? 1 : 0;
    } else if (target === 'subx') {
      x = 0;
      y = config.axis_rotated ? 0 : $$.height2;
    } else if (target === 'arc') {
      x = $$.arcWidth / 2;
      y = $$.arcHeight / 2 - ($$.hasType('gauge') ? 6 : 0); // to prevent wrong display of min and max label
    }

    return "translate(" + x + "," + y + ")";
  };

  ChartInternal.prototype.initialOpacity = function (d) {
    return d.value !== null && this.withoutFadeIn[d.id] ? 1 : 0;
  };

  ChartInternal.prototype.initialOpacityForCircle = function (d) {
    return d.value !== null && this.withoutFadeIn[d.id] ? this.opacityForCircle(d) : 0;
  };

  ChartInternal.prototype.opacityForCircle = function (d) {
    var isPointShouldBeShown = isFunction(this.config.point_show) ? this.config.point_show(d) : this.config.point_show;
    var opacity = isPointShouldBeShown ? 1 : 0;
    return isValue(d.value) ? this.isScatterType(d) ? 0.5 : opacity : 0;
  };

  ChartInternal.prototype.opacityForText = function () {
    return this.hasDataLabel() ? 1 : 0;
  };

  ChartInternal.prototype.xx = function (d) {
    return d ? this.x(d.x) : null;
  };

  ChartInternal.prototype.xv = function (d) {
    var $$ = this,
        value = d.value;

    if ($$.isTimeSeries()) {
      value = $$.parseDate(d.value);
    } else if ($$.isCategorized() && typeof d.value === 'string') {
      value = $$.config.axis_x_categories.indexOf(d.value);
    }

    return Math.ceil($$.x(value));
  };

  ChartInternal.prototype.yv = function (d) {
    var $$ = this,
        yScale = d.axis && d.axis === 'y2' ? $$.y2 : $$.y;
    return Math.ceil(yScale(d.value));
  };

  ChartInternal.prototype.subxx = function (d) {
    return d ? this.subX(d.x) : null;
  };

  ChartInternal.prototype.transformMain = function (withTransition, transitions) {
    var $$ = this,
        xAxis,
        yAxis,
        y2Axis;

    if (transitions && transitions.axisX) {
      xAxis = transitions.axisX;
    } else {
      xAxis = $$.main.select('.' + CLASS.axisX);

      if (withTransition) {
        xAxis = xAxis.transition();
      }
    }

    if (transitions && transitions.axisY) {
      yAxis = transitions.axisY;
    } else {
      yAxis = $$.main.select('.' + CLASS.axisY);

      if (withTransition) {
        yAxis = yAxis.transition();
      }
    }

    if (transitions && transitions.axisY2) {
      y2Axis = transitions.axisY2;
    } else {
      y2Axis = $$.main.select('.' + CLASS.axisY2);

      if (withTransition) {
        y2Axis = y2Axis.transition();
      }
    }

    (withTransition ? $$.main.transition() : $$.main).attr("transform", $$.getTranslate('main'));
    xAxis.attr("transform", $$.getTranslate('x'));
    yAxis.attr("transform", $$.getTranslate('y'));
    y2Axis.attr("transform", $$.getTranslate('y2'));
    $$.main.select('.' + CLASS.chartArcs).attr("transform", $$.getTranslate('arc'));
  };

  ChartInternal.prototype.transformAll = function (withTransition, transitions) {
    var $$ = this;
    $$.transformMain(withTransition, transitions);

    if ($$.config.subchart_show) {
      $$.transformContext(withTransition, transitions);
    }

    if ($$.legend) {
      $$.transformLegend(withTransition);
    }
  };

  ChartInternal.prototype.updateSvgSize = function () {
    var $$ = this,
        brush = $$.svg.select(".c3-brush .overlay");
    $$.svg.attr('width', $$.currentWidth).attr('height', $$.currentHeight);
    $$.svg.selectAll(['#' + $$.clipId, '#' + $$.clipIdForGrid]).select('rect').attr('width', $$.width).attr('height', $$.height);
    $$.svg.select('#' + $$.clipIdForXAxis).select('rect').attr('x', $$.getXAxisClipX.bind($$)).attr('y', $$.getXAxisClipY.bind($$)).attr('width', $$.getXAxisClipWidth.bind($$)).attr('height', $$.getXAxisClipHeight.bind($$));
    $$.svg.select('#' + $$.clipIdForYAxis).select('rect').attr('x', $$.getYAxisClipX.bind($$)).attr('y', $$.getYAxisClipY.bind($$)).attr('width', $$.getYAxisClipWidth.bind($$)).attr('height', $$.getYAxisClipHeight.bind($$));
    $$.svg.select('#' + $$.clipIdForSubchart).select('rect').attr('width', $$.width).attr('height', brush.size() ? brush.attr('height') : 0);
  };

  ChartInternal.prototype.updateDimension = function (withoutAxis) {
    var $$ = this;

    if (!withoutAxis) {
      if ($$.config.axis_rotated) {
        $$.axes.x.call($$.xAxis);
        $$.axes.subx.call($$.subXAxis);
      } else {
        $$.axes.y.call($$.yAxis);
        $$.axes.y2.call($$.y2Axis);
      }
    }

    $$.updateSizes();
    $$.updateScales();
    $$.updateSvgSize();
    $$.transformAll(false);
  };

  ChartInternal.prototype.observeInserted = function (selection) {
    var $$ = this,
        observer;

    if (typeof MutationObserver === 'undefined') {
      window.console.error("MutationObserver not defined.");
      return;
    }

    observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'childList' && mutation.previousSibling) {
          observer.disconnect(); // need to wait for completion of load because size calculation requires the actual sizes determined after that completion

          $$.intervalForObserveInserted = window.setInterval(function () {
            // parentNode will NOT be null when completed
            if (selection.node().parentNode) {
              window.clearInterval($$.intervalForObserveInserted);
              $$.updateDimension();

              if ($$.brush) {
                $$.brush.update();
              }

              $$.config.oninit.call($$);
              $$.redraw({
                withTransform: true,
                withUpdateXDomain: true,
                withUpdateOrgXDomain: true,
                withTransition: false,
                withTransitionForTransform: false,
                withLegend: true
              });
              selection.transition().style('opacity', 1);
            }
          }, 10);
        }
      });
    });
    observer.observe(selection.node(), {
      attributes: true,
      childList: true,
      characterData: true
    });
  };
  /**
   * Binds handlers to the window resize event.
   */


  ChartInternal.prototype.bindResize = function () {
    var $$ = this,
        config = $$.config;
    $$.resizeFunction = $$.generateResize(); // need to call .remove

    $$.resizeFunction.add(function () {
      config.onresize.call($$);
    });

    if (config.resize_auto) {
      $$.resizeFunction.add(function () {
        if ($$.resizeTimeout !== undefined) {
          window.clearTimeout($$.resizeTimeout);
        }

        $$.resizeTimeout = window.setTimeout(function () {
          delete $$.resizeTimeout;
          $$.updateAndRedraw({
            withUpdateXDomain: false,
            withUpdateOrgXDomain: false,
            withTransition: false,
            withTransitionForTransform: false,
            withLegend: true
          });

          if ($$.brush) {
            $$.brush.update();
          }
        }, 100);
      });
    }

    $$.resizeFunction.add(function () {
      config.onresized.call($$);
    });

    $$.resizeIfElementDisplayed = function () {
      // if element not displayed skip it
      if ($$.api == null || !$$.api.element.offsetParent) {
        return;
      }

      $$.resizeFunction();
    };

    if (window.attachEvent) {
      window.attachEvent('onresize', $$.resizeIfElementDisplayed);
    } else if (window.addEventListener) {
      window.addEventListener('resize', $$.resizeIfElementDisplayed, false);
    } else {
      // fallback to this, if this is a very old browser
      var wrapper = window.onresize;

      if (!wrapper) {
        // create a wrapper that will call all charts
        wrapper = $$.generateResize();
      } else if (!wrapper.add || !wrapper.remove) {
        // there is already a handler registered, make sure we call it too
        wrapper = $$.generateResize();
        wrapper.add(window.onresize);
      } // add this graph to the wrapper, we will be removed if the user calls destroy


      wrapper.add($$.resizeFunction);

      window.onresize = function () {
        // if element not displayed skip it
        if (!$$.api.element.offsetParent) {
          return;
        }

        wrapper();
      };
    }
  };
  /**
   * Binds handlers to the window focus event.
   */


  ChartInternal.prototype.bindWindowFocus = function () {
    var _this = this;

    if (this.windowFocusHandler) {
      // The handler is already set
      return;
    }

    this.windowFocusHandler = function () {
      _this.redraw();
    };

    window.addEventListener('focus', this.windowFocusHandler);
  };
  /**
   * Unbinds from the window focus event.
   */


  ChartInternal.prototype.unbindWindowFocus = function () {
    window.removeEventListener('focus', this.windowFocusHandler);
    delete this.windowFocusHandler;
  };

  ChartInternal.prototype.generateResize = function () {
    var resizeFunctions = [];

    function callResizeFunctions() {
      resizeFunctions.forEach(function (f) {
        f();
      });
    }

    callResizeFunctions.add = function (f) {
      resizeFunctions.push(f);
    };

    callResizeFunctions.remove = function (f) {
      for (var i = 0; i < resizeFunctions.length; i++) {
        if (resizeFunctions[i] === f) {
          resizeFunctions.splice(i, 1);
          break;
        }
      }
    };

    return callResizeFunctions;
  };

  ChartInternal.prototype.endall = function (transition, callback) {
    var n = 0;
    transition.each(function () {
      ++n;
    }).on("end", function () {
      if (! --n) {
        callback.apply(this, arguments);
      }
    });
  };

  ChartInternal.prototype.generateWait = function () {
    var transitionsToWait = [],
        f = function f(callback) {
      var timer = setInterval(function () {
        var done = 0;
        transitionsToWait.forEach(function (t) {
          if (t.empty()) {
            done += 1;
            return;
          }

          try {
            t.transition();
          } catch (e) {
            done += 1;
          }
        });

        if (done === transitionsToWait.length) {
          clearInterval(timer);

          if (callback) {
            callback();
          }
        }
      }, 50);
    };

    f.add = function (transition) {
      transitionsToWait.push(transition);
    };

    return f;
  };

  ChartInternal.prototype.parseDate = function (date) {
    var $$ = this,
        parsedDate;

    if (date instanceof Date) {
      parsedDate = date;
    } else if (typeof date === 'string') {
      parsedDate = $$.dataTimeParse(date);
    } else if (_typeof(date) === 'object') {
      parsedDate = new Date(+date);
    } else if (typeof date === 'number' && !isNaN(date)) {
      parsedDate = new Date(+date);
    }

    if (!parsedDate || isNaN(+parsedDate)) {
      window.console.error("Failed to parse x '" + date + "' to Date object");
    }

    return parsedDate;
  };

  ChartInternal.prototype.isTabVisible = function () {
    return !document.hidden;
  };

  ChartInternal.prototype.getPathBox = getPathBox;
  ChartInternal.prototype.CLASS = CLASS;

  /* jshint ignore:start */
  // SVGPathSeg API polyfill
  // https://github.com/progers/pathseg
  //
  // This is a drop-in replacement for the SVGPathSeg and SVGPathSegList APIs that were removed from
  // SVG2 (https://lists.w3.org/Archives/Public/www-svg/2015Jun/0044.html), including the latest spec
  // changes which were implemented in Firefox 43 and Chrome 46.
  (function () {

    if (!("SVGPathSeg" in window)) {
      // Spec: http://www.w3.org/TR/SVG11/single-page.html#paths-InterfaceSVGPathSeg
      window.SVGPathSeg = function (type, typeAsLetter, owningPathSegList) {
        this.pathSegType = type;
        this.pathSegTypeAsLetter = typeAsLetter;
        this._owningPathSegList = owningPathSegList;
      };

      window.SVGPathSeg.prototype.classname = "SVGPathSeg";
      window.SVGPathSeg.PATHSEG_UNKNOWN = 0;
      window.SVGPathSeg.PATHSEG_CLOSEPATH = 1;
      window.SVGPathSeg.PATHSEG_MOVETO_ABS = 2;
      window.SVGPathSeg.PATHSEG_MOVETO_REL = 3;
      window.SVGPathSeg.PATHSEG_LINETO_ABS = 4;
      window.SVGPathSeg.PATHSEG_LINETO_REL = 5;
      window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_ABS = 6;
      window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_REL = 7;
      window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_ABS = 8;
      window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_REL = 9;
      window.SVGPathSeg.PATHSEG_ARC_ABS = 10;
      window.SVGPathSeg.PATHSEG_ARC_REL = 11;
      window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_ABS = 12;
      window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_REL = 13;
      window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_ABS = 14;
      window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_REL = 15;
      window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_ABS = 16;
      window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_REL = 17;
      window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_ABS = 18;
      window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_REL = 19; // Notify owning PathSegList on any changes so they can be synchronized back to the path element.

      window.SVGPathSeg.prototype._segmentChanged = function () {
        if (this._owningPathSegList) this._owningPathSegList.segmentChanged(this);
      };

      window.SVGPathSegClosePath = function (owningPathSegList) {
        window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CLOSEPATH, "z", owningPathSegList);
      };

      window.SVGPathSegClosePath.prototype = Object.create(window.SVGPathSeg.prototype);

      window.SVGPathSegClosePath.prototype.toString = function () {
        return "[object SVGPathSegClosePath]";
      };

      window.SVGPathSegClosePath.prototype._asPathString = function () {
        return this.pathSegTypeAsLetter;
      };

      window.SVGPathSegClosePath.prototype.clone = function () {
        return new window.SVGPathSegClosePath(undefined);
      };

      window.SVGPathSegMovetoAbs = function (owningPathSegList, x, y) {
        window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_MOVETO_ABS, "M", owningPathSegList);
        this._x = x;
        this._y = y;
      };

      window.SVGPathSegMovetoAbs.prototype = Object.create(window.SVGPathSeg.prototype);

      window.SVGPathSegMovetoAbs.prototype.toString = function () {
        return "[object SVGPathSegMovetoAbs]";
      };

      window.SVGPathSegMovetoAbs.prototype._asPathString = function () {
        return this.pathSegTypeAsLetter + " " + this._x + " " + this._y;
      };

      window.SVGPathSegMovetoAbs.prototype.clone = function () {
        return new window.SVGPathSegMovetoAbs(undefined, this._x, this._y);
      };

      Object.defineProperty(window.SVGPathSegMovetoAbs.prototype, "x", {
        get: function get() {
          return this._x;
        },
        set: function set(x) {
          this._x = x;

          this._segmentChanged();
        },
        enumerable: true
      });
      Object.defineProperty(window.SVGPathSegMovetoAbs.prototype, "y", {
        get: function get() {
          return this._y;
        },
        set: function set(y) {
          this._y = y;

          this._segmentChanged();
        },
        enumerable: true
      });

      window.SVGPathSegMovetoRel = function (owningPathSegList, x, y) {
        window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_MOVETO_REL, "m", owningPathSegList);
        this._x = x;
        this._y = y;
      };

      window.SVGPathSegMovetoRel.prototype = Object.create(window.SVGPathSeg.prototype);

      window.SVGPathSegMovetoRel.prototype.toString = function () {
        return "[object SVGPathSegMovetoRel]";
      };

      window.SVGPathSegMovetoRel.prototype._asPathString = function () {
        return this.pathSegTypeAsLetter + " " + this._x + " " + this._y;
      };

      window.SVGPathSegMovetoRel.prototype.clone = function () {
        return new window.SVGPathSegMovetoRel(undefined, this._x, this._y);
      };

      Object.defineProperty(window.SVGPathSegMovetoRel.prototype, "x", {
        get: function get() {
          return this._x;
        },
        set: function set(x) {
          this._x = x;

          this._segmentChanged();
        },
        enumerable: true
      });
      Object.defineProperty(window.SVGPathSegMovetoRel.prototype, "y", {
        get: function get() {
          return this._y;
        },
        set: function set(y) {
          this._y = y;

          this._segmentChanged();
        },
        enumerable: true
      });

      window.SVGPathSegLinetoAbs = function (owningPathSegList, x, y) {
        window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_LINETO_ABS, "L", owningPathSegList);
        this._x = x;
        this._y = y;
      };

      window.SVGPathSegLinetoAbs.prototype = Object.create(window.SVGPathSeg.prototype);

      window.SVGPathSegLinetoAbs.prototype.toString = function () {
        return "[object SVGPathSegLinetoAbs]";
      };

      window.SVGPathSegLinetoAbs.prototype._asPathString = function () {
        return this.pathSegTypeAsLetter + " " + this._x + " " + this._y;
      };

      window.SVGPathSegLinetoAbs.prototype.clone = function () {
        return new window.SVGPathSegLinetoAbs(undefined, this._x, this._y);
      };

      Object.defineProperty(window.SVGPathSegLinetoAbs.prototype, "x", {
        get: function get() {
          return this._x;
        },
        set: function set(x) {
          this._x = x;

          this._segmentChanged();
        },
        enumerable: true
      });
      Object.defineProperty(window.SVGPathSegLinetoAbs.prototype, "y", {
        get: function get() {
          return this._y;
        },
        set: function set(y) {
          this._y = y;

          this._segmentChanged();
        },
        enumerable: true
      });

      window.SVGPathSegLinetoRel = function (owningPathSegList, x, y) {
        window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_LINETO_REL, "l", owningPathSegList);
        this._x = x;
        this._y = y;
      };

      window.SVGPathSegLinetoRel.prototype = Object.create(window.SVGPathSeg.prototype);

      window.SVGPathSegLinetoRel.prototype.toString = function () {
        return "[object SVGPathSegLinetoRel]";
      };

      window.SVGPathSegLinetoRel.prototype._asPathString = function () {
        return this.pathSegTypeAsLetter + " " + this._x + " " + this._y;
      };

      window.SVGPathSegLinetoRel.prototype.clone = function () {
        return new window.SVGPathSegLinetoRel(undefined, this._x, this._y);
      };

      Object.defineProperty(window.SVGPathSegLinetoRel.prototype, "x", {
        get: function get() {
          return this._x;
        },
        set: function set(x) {
          this._x = x;

          this._segmentChanged();
        },
        enumerable: true
      });
      Object.defineProperty(window.SVGPathSegLinetoRel.prototype, "y", {
        get: function get() {
          return this._y;
        },
        set: function set(y) {
          this._y = y;

          this._segmentChanged();
        },
        enumerable: true
      });

      window.SVGPathSegCurvetoCubicAbs = function (owningPathSegList, x, y, x1, y1, x2, y2) {
        window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_ABS, "C", owningPathSegList);
        this._x = x;
        this._y = y;
        this._x1 = x1;
        this._y1 = y1;
        this._x2 = x2;
        this._y2 = y2;
      };

      window.SVGPathSegCurvetoCubicAbs.prototype = Object.create(window.SVGPathSeg.prototype);

      window.SVGPathSegCurvetoCubicAbs.prototype.toString = function () {
        return "[object SVGPathSegCurvetoCubicAbs]";
      };

      window.SVGPathSegCurvetoCubicAbs.prototype._asPathString = function () {
        return this.pathSegTypeAsLetter + " " + this._x1 + " " + this._y1 + " " + this._x2 + " " + this._y2 + " " + this._x + " " + this._y;
      };

      window.SVGPathSegCurvetoCubicAbs.prototype.clone = function () {
        return new window.SVGPathSegCurvetoCubicAbs(undefined, this._x, this._y, this._x1, this._y1, this._x2, this._y2);
      };

      Object.defineProperty(window.SVGPathSegCurvetoCubicAbs.prototype, "x", {
        get: function get() {
          return this._x;
        },
        set: function set(x) {
          this._x = x;

          this._segmentChanged();
        },
        enumerable: true
      });
      Object.defineProperty(window.SVGPathSegCurvetoCubicAbs.prototype, "y", {
        get: function get() {
          return this._y;
        },
        set: function set(y) {
          this._y = y;

          this._segmentChanged();
        },
        enumerable: true
      });
      Object.defineProperty(window.SVGPathSegCurvetoCubicAbs.prototype, "x1", {
        get: function get() {
          return this._x1;
        },
        set: function set(x1) {
          this._x1 = x1;

          this._segmentChanged();
        },
        enumerable: true
      });
      Object.defineProperty(window.SVGPathSegCurvetoCubicAbs.prototype, "y1", {
        get: function get() {
          return this._y1;
        },
        set: function set(y1) {
          this._y1 = y1;

          this._segmentChanged();
        },
        enumerable: true
      });
      Object.defineProperty(window.SVGPathSegCurvetoCubicAbs.prototype, "x2", {
        get: function get() {
          return this._x2;
        },
        set: function set(x2) {
          this._x2 = x2;

          this._segmentChanged();
        },
        enumerable: true
      });
      Object.defineProperty(window.SVGPathSegCurvetoCubicAbs.prototype, "y2", {
        get: function get() {
          return this._y2;
        },
        set: function set(y2) {
          this._y2 = y2;

          this._segmentChanged();
        },
        enumerable: true
      });

      window.SVGPathSegCurvetoCubicRel = function (owningPathSegList, x, y, x1, y1, x2, y2) {
        window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_REL, "c", owningPathSegList);
        this._x = x;
        this._y = y;
        this._x1 = x1;
        this._y1 = y1;
        this._x2 = x2;
        this._y2 = y2;
      };

      window.SVGPathSegCurvetoCubicRel.prototype = Object.create(window.SVGPathSeg.prototype);

      window.SVGPathSegCurvetoCubicRel.prototype.toString = function () {
        return "[object SVGPathSegCurvetoCubicRel]";
      };

      window.SVGPathSegCurvetoCubicRel.prototype._asPathString = function () {
        return this.pathSegTypeAsLetter + " " + this._x1 + " " + this._y1 + " " + this._x2 + " " + this._y2 + " " + this._x + " " + this._y;
      };

      window.SVGPathSegCurvetoCubicRel.prototype.clone = function () {
        return new window.SVGPathSegCurvetoCubicRel(undefined, this._x, this._y, this._x1, this._y1, this._x2, this._y2);
      };

      Object.defineProperty(window.SVGPathSegCurvetoCubicRel.prototype, "x", {
        get: function get() {
          return this._x;
        },
        set: function set(x) {
          this._x = x;

          this._segmentChanged();
        },
        enumerable: true
      });
      Object.defineProperty(window.SVGPathSegCurvetoCubicRel.prototype, "y", {
        get: function get() {
          return this._y;
        },
        set: function set(y) {
          this._y = y;

          this._segmentChanged();
        },
        enumerable: true
      });
      Object.defineProperty(window.SVGPathSegCurvetoCubicRel.prototype, "x1", {
        get: function get() {
          return this._x1;
        },
        set: function set(x1) {
          this._x1 = x1;

          this._segmentChanged();
        },
        enumerable: true
      });
      Object.defineProperty(window.SVGPathSegCurvetoCubicRel.prototype, "y1", {
        get: function get() {
          return this._y1;
        },
        set: function set(y1) {
          this._y1 = y1;

          this._segmentChanged();
        },
        enumerable: true
      });
      Object.defineProperty(window.SVGPathSegCurvetoCubicRel.prototype, "x2", {
        get: function get() {
          return this._x2;
        },
        set: function set(x2) {
          this._x2 = x2;

          this._segmentChanged();
        },
        enumerable: true
      });
      Object.defineProperty(window.SVGPathSegCurvetoCubicRel.prototype, "y2", {
        get: function get() {
          return this._y2;
        },
        set: function set(y2) {
          this._y2 = y2;

          this._segmentChanged();
        },
        enumerable: true
      });

      window.SVGPathSegCurvetoQuadraticAbs = function (owningPathSegList, x, y, x1, y1) {
        window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_ABS, "Q", owningPathSegList);
        this._x = x;
        this._y = y;
        this._x1 = x1;
        this._y1 = y1;
      };

      window.SVGPathSegCurvetoQuadraticAbs.prototype = Object.create(window.SVGPathSeg.prototype);

      window.SVGPathSegCurvetoQuadraticAbs.prototype.toString = function () {
        return "[object SVGPathSegCurvetoQuadraticAbs]";
      };

      window.SVGPathSegCurvetoQuadraticAbs.prototype._asPathString = function () {
        return this.pathSegTypeAsLetter + " " + this._x1 + " " + this._y1 + " " + this._x + " " + this._y;
      };

      window.SVGPathSegCurvetoQuadraticAbs.prototype.clone = function () {
        return new window.SVGPathSegCurvetoQuadraticAbs(undefined, this._x, this._y, this._x1, this._y1);
      };

      Object.defineProperty(window.SVGPathSegCurvetoQuadraticAbs.prototype, "x", {
        get: function get() {
          return this._x;
        },
        set: function set(x) {
          this._x = x;

          this._segmentChanged();
        },
        enumerable: true
      });
      Object.defineProperty(window.SVGPathSegCurvetoQuadraticAbs.prototype, "y", {
        get: function get() {
          return this._y;
        },
        set: function set(y) {
          this._y = y;

          this._segmentChanged();
        },
        enumerable: true
      });
      Object.defineProperty(window.SVGPathSegCurvetoQuadraticAbs.prototype, "x1", {
        get: function get() {
          return this._x1;
        },
        set: function set(x1) {
          this._x1 = x1;

          this._segmentChanged();
        },
        enumerable: true
      });
      Object.defineProperty(window.SVGPathSegCurvetoQuadraticAbs.prototype, "y1", {
        get: function get() {
          return this._y1;
        },
        set: function set(y1) {
          this._y1 = y1;

          this._segmentChanged();
        },
        enumerable: true
      });

      window.SVGPathSegCurvetoQuadraticRel = function (owningPathSegList, x, y, x1, y1) {
        window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_REL, "q", owningPathSegList);
        this._x = x;
        this._y = y;
        this._x1 = x1;
        this._y1 = y1;
      };

      window.SVGPathSegCurvetoQuadraticRel.prototype = Object.create(window.SVGPathSeg.prototype);

      window.SVGPathSegCurvetoQuadraticRel.prototype.toString = function () {
        return "[object SVGPathSegCurvetoQuadraticRel]";
      };

      window.SVGPathSegCurvetoQuadraticRel.prototype._asPathString = function () {
        return this.pathSegTypeAsLetter + " " + this._x1 + " " + this._y1 + " " + this._x + " " + this._y;
      };

      window.SVGPathSegCurvetoQuadraticRel.prototype.clone = function () {
        return new window.SVGPathSegCurvetoQuadraticRel(undefined, this._x, this._y, this._x1, this._y1);
      };

      Object.defineProperty(window.SVGPathSegCurvetoQuadraticRel.prototype, "x", {
        get: function get() {
          return this._x;
        },
        set: function set(x) {
          this._x = x;

          this._segmentChanged();
        },
        enumerable: true
      });
      Object.defineProperty(window.SVGPathSegCurvetoQuadraticRel.prototype, "y", {
        get: function get() {
          return this._y;
        },
        set: function set(y) {
          this._y = y;

          this._segmentChanged();
        },
        enumerable: true
      });
      Object.defineProperty(window.SVGPathSegCurvetoQuadraticRel.prototype, "x1", {
        get: function get() {
          return this._x1;
        },
        set: function set(x1) {
          this._x1 = x1;

          this._segmentChanged();
        },
        enumerable: true
      });
      Object.defineProperty(window.SVGPathSegCurvetoQuadraticRel.prototype, "y1", {
        get: function get() {
          return this._y1;
        },
        set: function set(y1) {
          this._y1 = y1;

          this._segmentChanged();
        },
        enumerable: true
      });

      window.SVGPathSegArcAbs = function (owningPathSegList, x, y, r1, r2, angle, largeArcFlag, sweepFlag) {
        window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_ARC_ABS, "A", owningPathSegList);
        this._x = x;
        this._y = y;
        this._r1 = r1;
        this._r2 = r2;
        this._angle = angle;
        this._largeArcFlag = largeArcFlag;
        this._sweepFlag = sweepFlag;
      };

      window.SVGPathSegArcAbs.prototype = Object.create(window.SVGPathSeg.prototype);

      window.SVGPathSegArcAbs.prototype.toString = function () {
        return "[object SVGPathSegArcAbs]";
      };

      window.SVGPathSegArcAbs.prototype._asPathString = function () {
        return this.pathSegTypeAsLetter + " " + this._r1 + " " + this._r2 + " " + this._angle + " " + (this._largeArcFlag ? "1" : "0") + " " + (this._sweepFlag ? "1" : "0") + " " + this._x + " " + this._y;
      };

      window.SVGPathSegArcAbs.prototype.clone = function () {
        return new window.SVGPathSegArcAbs(undefined, this._x, this._y, this._r1, this._r2, this._angle, this._largeArcFlag, this._sweepFlag);
      };

      Object.defineProperty(window.SVGPathSegArcAbs.prototype, "x", {
        get: function get() {
          return this._x;
        },
        set: function set(x) {
          this._x = x;

          this._segmentChanged();
        },
        enumerable: true
      });
      Object.defineProperty(window.SVGPathSegArcAbs.prototype, "y", {
        get: function get() {
          return this._y;
        },
        set: function set(y) {
          this._y = y;

          this._segmentChanged();
        },
        enumerable: true
      });
      Object.defineProperty(window.SVGPathSegArcAbs.prototype, "r1", {
        get: function get() {
          return this._r1;
        },
        set: function set(r1) {
          this._r1 = r1;

          this._segmentChanged();
        },
        enumerable: true
      });
      Object.defineProperty(window.SVGPathSegArcAbs.prototype, "r2", {
        get: function get() {
          return this._r2;
        },
        set: function set(r2) {
          this._r2 = r2;

          this._segmentChanged();
        },
        enumerable: true
      });
      Object.defineProperty(window.SVGPathSegArcAbs.prototype, "angle", {
        get: function get() {
          return this._angle;
        },
        set: function set(angle) {
          this._angle = angle;

          this._segmentChanged();
        },
        enumerable: true
      });
      Object.defineProperty(window.SVGPathSegArcAbs.prototype, "largeArcFlag", {
        get: function get() {
          return this._largeArcFlag;
        },
        set: function set(largeArcFlag) {
          this._largeArcFlag = largeArcFlag;

          this._segmentChanged();
        },
        enumerable: true
      });
      Object.defineProperty(window.SVGPathSegArcAbs.prototype, "sweepFlag", {
        get: function get() {
          return this._sweepFlag;
        },
        set: function set(sweepFlag) {
          this._sweepFlag = sweepFlag;

          this._segmentChanged();
        },
        enumerable: true
      });

      window.SVGPathSegArcRel = function (owningPathSegList, x, y, r1, r2, angle, largeArcFlag, sweepFlag) {
        window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_ARC_REL, "a", owningPathSegList);
        this._x = x;
        this._y = y;
        this._r1 = r1;
        this._r2 = r2;
        this._angle = angle;
        this._largeArcFlag = largeArcFlag;
        this._sweepFlag = sweepFlag;
      };

      window.SVGPathSegArcRel.prototype = Object.create(window.SVGPathSeg.prototype);

      window.SVGPathSegArcRel.prototype.toString = function () {
        return "[object SVGPathSegArcRel]";
      };

      window.SVGPathSegArcRel.prototype._asPathString = function () {
        return this.pathSegTypeAsLetter + " " + this._r1 + " " + this._r2 + " " + this._angle + " " + (this._largeArcFlag ? "1" : "0") + " " + (this._sweepFlag ? "1" : "0") + " " + this._x + " " + this._y;
      };

      window.SVGPathSegArcRel.prototype.clone = function () {
        return new window.SVGPathSegArcRel(undefined, this._x, this._y, this._r1, this._r2, this._angle, this._largeArcFlag, this._sweepFlag);
      };

      Object.defineProperty(window.SVGPathSegArcRel.prototype, "x", {
        get: function get() {
          return this._x;
        },
        set: function set(x) {
          this._x = x;

          this._segmentChanged();
        },
        enumerable: true
      });
      Object.defineProperty(window.SVGPathSegArcRel.prototype, "y", {
        get: function get() {
          return this._y;
        },
        set: function set(y) {
          this._y = y;

          this._segmentChanged();
        },
        enumerable: true
      });
      Object.defineProperty(window.SVGPathSegArcRel.prototype, "r1", {
        get: function get() {
          return this._r1;
        },
        set: function set(r1) {
          this._r1 = r1;

          this._segmentChanged();
        },
        enumerable: true
      });
      Object.defineProperty(window.SVGPathSegArcRel.prototype, "r2", {
        get: function get() {
          return this._r2;
        },
        set: function set(r2) {
          this._r2 = r2;

          this._segmentChanged();
        },
        enumerable: true
      });
      Object.defineProperty(window.SVGPathSegArcRel.prototype, "angle", {
        get: function get() {
          return this._angle;
        },
        set: function set(angle) {
          this._angle = angle;

          this._segmentChanged();
        },
        enumerable: true
      });
      Object.defineProperty(window.SVGPathSegArcRel.prototype, "largeArcFlag", {
        get: function get() {
          return this._largeArcFlag;
        },
        set: function set(largeArcFlag) {
          this._largeArcFlag = largeArcFlag;

          this._segmentChanged();
        },
        enumerable: true
      });
      Object.defineProperty(window.SVGPathSegArcRel.prototype, "sweepFlag", {
        get: function get() {
          return this._sweepFlag;
        },
        set: function set(sweepFlag) {
          this._sweepFlag = sweepFlag;

          this._segmentChanged();
        },
        enumerable: true
      });

      window.SVGPathSegLinetoHorizontalAbs = function (owningPathSegList, x) {
        window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_ABS, "H", owningPathSegList);
        this._x = x;
      };

      window.SVGPathSegLinetoHorizontalAbs.prototype = Object.create(window.SVGPathSeg.prototype);

      window.SVGPathSegLinetoHorizontalAbs.prototype.toString = function () {
        return "[object SVGPathSegLinetoHorizontalAbs]";
      };

      window.SVGPathSegLinetoHorizontalAbs.prototype._asPathString = function () {
        return this.pathSegTypeAsLetter + " " + this._x;
      };

      window.SVGPathSegLinetoHorizontalAbs.prototype.clone = function () {
        return new window.SVGPathSegLinetoHorizontalAbs(undefined, this._x);
      };

      Object.defineProperty(window.SVGPathSegLinetoHorizontalAbs.prototype, "x", {
        get: function get() {
          return this._x;
        },
        set: function set(x) {
          this._x = x;

          this._segmentChanged();
        },
        enumerable: true
      });

      window.SVGPathSegLinetoHorizontalRel = function (owningPathSegList, x) {
        window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_REL, "h", owningPathSegList);
        this._x = x;
      };

      window.SVGPathSegLinetoHorizontalRel.prototype = Object.create(window.SVGPathSeg.prototype);

      window.SVGPathSegLinetoHorizontalRel.prototype.toString = function () {
        return "[object SVGPathSegLinetoHorizontalRel]";
      };

      window.SVGPathSegLinetoHorizontalRel.prototype._asPathString = function () {
        return this.pathSegTypeAsLetter + " " + this._x;
      };

      window.SVGPathSegLinetoHorizontalRel.prototype.clone = function () {
        return new window.SVGPathSegLinetoHorizontalRel(undefined, this._x);
      };

      Object.defineProperty(window.SVGPathSegLinetoHorizontalRel.prototype, "x", {
        get: function get() {
          return this._x;
        },
        set: function set(x) {
          this._x = x;

          this._segmentChanged();
        },
        enumerable: true
      });

      window.SVGPathSegLinetoVerticalAbs = function (owningPathSegList, y) {
        window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_ABS, "V", owningPathSegList);
        this._y = y;
      };

      window.SVGPathSegLinetoVerticalAbs.prototype = Object.create(window.SVGPathSeg.prototype);

      window.SVGPathSegLinetoVerticalAbs.prototype.toString = function () {
        return "[object SVGPathSegLinetoVerticalAbs]";
      };

      window.SVGPathSegLinetoVerticalAbs.prototype._asPathString = function () {
        return this.pathSegTypeAsLetter + " " + this._y;
      };

      window.SVGPathSegLinetoVerticalAbs.prototype.clone = function () {
        return new window.SVGPathSegLinetoVerticalAbs(undefined, this._y);
      };

      Object.defineProperty(window.SVGPathSegLinetoVerticalAbs.prototype, "y", {
        get: function get() {
          return this._y;
        },
        set: function set(y) {
          this._y = y;

          this._segmentChanged();
        },
        enumerable: true
      });

      window.SVGPathSegLinetoVerticalRel = function (owningPathSegList, y) {
        window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_REL, "v", owningPathSegList);
        this._y = y;
      };

      window.SVGPathSegLinetoVerticalRel.prototype = Object.create(window.SVGPathSeg.prototype);

      window.SVGPathSegLinetoVerticalRel.prototype.toString = function () {
        return "[object SVGPathSegLinetoVerticalRel]";
      };

      window.SVGPathSegLinetoVerticalRel.prototype._asPathString = function () {
        return this.pathSegTypeAsLetter + " " + this._y;
      };

      window.SVGPathSegLinetoVerticalRel.prototype.clone = function () {
        return new window.SVGPathSegLinetoVerticalRel(undefined, this._y);
      };

      Object.defineProperty(window.SVGPathSegLinetoVerticalRel.prototype, "y", {
        get: function get() {
          return this._y;
        },
        set: function set(y) {
          this._y = y;

          this._segmentChanged();
        },
        enumerable: true
      });

      window.SVGPathSegCurvetoCubicSmoothAbs = function (owningPathSegList, x, y, x2, y2) {
        window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_ABS, "S", owningPathSegList);
        this._x = x;
        this._y = y;
        this._x2 = x2;
        this._y2 = y2;
      };

      window.SVGPathSegCurvetoCubicSmoothAbs.prototype = Object.create(window.SVGPathSeg.prototype);

      window.SVGPathSegCurvetoCubicSmoothAbs.prototype.toString = function () {
        return "[object SVGPathSegCurvetoCubicSmoothAbs]";
      };

      window.SVGPathSegCurvetoCubicSmoothAbs.prototype._asPathString = function () {
        return this.pathSegTypeAsLetter + " " + this._x2 + " " + this._y2 + " " + this._x + " " + this._y;
      };

      window.SVGPathSegCurvetoCubicSmoothAbs.prototype.clone = function () {
        return new window.SVGPathSegCurvetoCubicSmoothAbs(undefined, this._x, this._y, this._x2, this._y2);
      };

      Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothAbs.prototype, "x", {
        get: function get() {
          return this._x;
        },
        set: function set(x) {
          this._x = x;

          this._segmentChanged();
        },
        enumerable: true
      });
      Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothAbs.prototype, "y", {
        get: function get() {
          return this._y;
        },
        set: function set(y) {
          this._y = y;

          this._segmentChanged();
        },
        enumerable: true
      });
      Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothAbs.prototype, "x2", {
        get: function get() {
          return this._x2;
        },
        set: function set(x2) {
          this._x2 = x2;

          this._segmentChanged();
        },
        enumerable: true
      });
      Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothAbs.prototype, "y2", {
        get: function get() {
          return this._y2;
        },
        set: function set(y2) {
          this._y2 = y2;

          this._segmentChanged();
        },
        enumerable: true
      });

      window.SVGPathSegCurvetoCubicSmoothRel = function (owningPathSegList, x, y, x2, y2) {
        window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_REL, "s", owningPathSegList);
        this._x = x;
        this._y = y;
        this._x2 = x2;
        this._y2 = y2;
      };

      window.SVGPathSegCurvetoCubicSmoothRel.prototype = Object.create(window.SVGPathSeg.prototype);

      window.SVGPathSegCurvetoCubicSmoothRel.prototype.toString = function () {
        return "[object SVGPathSegCurvetoCubicSmoothRel]";
      };

      window.SVGPathSegCurvetoCubicSmoothRel.prototype._asPathString = function () {
        return this.pathSegTypeAsLetter + " " + this._x2 + " " + this._y2 + " " + this._x + " " + this._y;
      };

      window.SVGPathSegCurvetoCubicSmoothRel.prototype.clone = function () {
        return new window.SVGPathSegCurvetoCubicSmoothRel(undefined, this._x, this._y, this._x2, this._y2);
      };

      Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothRel.prototype, "x", {
        get: function get() {
          return this._x;
        },
        set: function set(x) {
          this._x = x;

          this._segmentChanged();
        },
        enumerable: true
      });
      Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothRel.prototype, "y", {
        get: function get() {
          return this._y;
        },
        set: function set(y) {
          this._y = y;

          this._segmentChanged();
        },
        enumerable: true
      });
      Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothRel.prototype, "x2", {
        get: function get() {
          return this._x2;
        },
        set: function set(x2) {
          this._x2 = x2;

          this._segmentChanged();
        },
        enumerable: true
      });
      Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothRel.prototype, "y2", {
        get: function get() {
          return this._y2;
        },
        set: function set(y2) {
          this._y2 = y2;

          this._segmentChanged();
        },
        enumerable: true
      });

      window.SVGPathSegCurvetoQuadraticSmoothAbs = function (owningPathSegList, x, y) {
        window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_ABS, "T", owningPathSegList);
        this._x = x;
        this._y = y;
      };

      window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype = Object.create(window.SVGPathSeg.prototype);

      window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype.toString = function () {
        return "[object SVGPathSegCurvetoQuadraticSmoothAbs]";
      };

      window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype._asPathString = function () {
        return this.pathSegTypeAsLetter + " " + this._x + " " + this._y;
      };

      window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype.clone = function () {
        return new window.SVGPathSegCurvetoQuadraticSmoothAbs(undefined, this._x, this._y);
      };

      Object.defineProperty(window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype, "x", {
        get: function get() {
          return this._x;
        },
        set: function set(x) {
          this._x = x;

          this._segmentChanged();
        },
        enumerable: true
      });
      Object.defineProperty(window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype, "y", {
        get: function get() {
          return this._y;
        },
        set: function set(y) {
          this._y = y;

          this._segmentChanged();
        },
        enumerable: true
      });

      window.SVGPathSegCurvetoQuadraticSmoothRel = function (owningPathSegList, x, y) {
        window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_REL, "t", owningPathSegList);
        this._x = x;
        this._y = y;
      };

      window.SVGPathSegCurvetoQuadraticSmoothRel.prototype = Object.create(window.SVGPathSeg.prototype);

      window.SVGPathSegCurvetoQuadraticSmoothRel.prototype.toString = function () {
        return "[object SVGPathSegCurvetoQuadraticSmoothRel]";
      };

      window.SVGPathSegCurvetoQuadraticSmoothRel.prototype._asPathString = function () {
        return this.pathSegTypeAsLetter + " " + this._x + " " + this._y;
      };

      window.SVGPathSegCurvetoQuadraticSmoothRel.prototype.clone = function () {
        return new window.SVGPathSegCurvetoQuadraticSmoothRel(undefined, this._x, this._y);
      };

      Object.defineProperty(window.SVGPathSegCurvetoQuadraticSmoothRel.prototype, "x", {
        get: function get() {
          return this._x;
        },
        set: function set(x) {
          this._x = x;

          this._segmentChanged();
        },
        enumerable: true
      });
      Object.defineProperty(window.SVGPathSegCurvetoQuadraticSmoothRel.prototype, "y", {
        get: function get() {
          return this._y;
        },
        set: function set(y) {
          this._y = y;

          this._segmentChanged();
        },
        enumerable: true
      }); // Add createSVGPathSeg* functions to window.SVGPathElement.
      // Spec: http://www.w3.org/TR/SVG11/single-page.html#paths-Interfacewindow.SVGPathElement.

      window.SVGPathElement.prototype.createSVGPathSegClosePath = function () {
        return new window.SVGPathSegClosePath(undefined);
      };

      window.SVGPathElement.prototype.createSVGPathSegMovetoAbs = function (x, y) {
        return new window.SVGPathSegMovetoAbs(undefined, x, y);
      };

      window.SVGPathElement.prototype.createSVGPathSegMovetoRel = function (x, y) {
        return new window.SVGPathSegMovetoRel(undefined, x, y);
      };

      window.SVGPathElement.prototype.createSVGPathSegLinetoAbs = function (x, y) {
        return new window.SVGPathSegLinetoAbs(undefined, x, y);
      };

      window.SVGPathElement.prototype.createSVGPathSegLinetoRel = function (x, y) {
        return new window.SVGPathSegLinetoRel(undefined, x, y);
      };

      window.SVGPathElement.prototype.createSVGPathSegCurvetoCubicAbs = function (x, y, x1, y1, x2, y2) {
        return new window.SVGPathSegCurvetoCubicAbs(undefined, x, y, x1, y1, x2, y2);
      };

      window.SVGPathElement.prototype.createSVGPathSegCurvetoCubicRel = function (x, y, x1, y1, x2, y2) {
        return new window.SVGPathSegCurvetoCubicRel(undefined, x, y, x1, y1, x2, y2);
      };

      window.SVGPathElement.prototype.createSVGPathSegCurvetoQuadraticAbs = function (x, y, x1, y1) {
        return new window.SVGPathSegCurvetoQuadraticAbs(undefined, x, y, x1, y1);
      };

      window.SVGPathElement.prototype.createSVGPathSegCurvetoQuadraticRel = function (x, y, x1, y1) {
        return new window.SVGPathSegCurvetoQuadraticRel(undefined, x, y, x1, y1);
      };

      window.SVGPathElement.prototype.createSVGPathSegArcAbs = function (x, y, r1, r2, angle, largeArcFlag, sweepFlag) {
        return new window.SVGPathSegArcAbs(undefined, x, y, r1, r2, angle, largeArcFlag, sweepFlag);
      };

      window.SVGPathElement.prototype.createSVGPathSegArcRel = function (x, y, r1, r2, angle, largeArcFlag, sweepFlag) {
        return new window.SVGPathSegArcRel(undefined, x, y, r1, r2, angle, largeArcFlag, sweepFlag);
      };

      window.SVGPathElement.prototype.createSVGPathSegLinetoHorizontalAbs = function (x) {
        return new window.SVGPathSegLinetoHorizontalAbs(undefined, x);
      };

      window.SVGPathElement.prototype.createSVGPathSegLinetoHorizontalRel = function (x) {
        return new window.SVGPathSegLinetoHorizontalRel(undefined, x);
      };

      window.SVGPathElement.prototype.createSVGPathSegLinetoVerticalAbs = function (y) {
        return new window.SVGPathSegLinetoVerticalAbs(undefined, y);
      };

      window.SVGPathElement.prototype.createSVGPathSegLinetoVerticalRel = function (y) {
        return new window.SVGPathSegLinetoVerticalRel(undefined, y);
      };

      window.SVGPathElement.prototype.createSVGPathSegCurvetoCubicSmoothAbs = function (x, y, x2, y2) {
        return new window.SVGPathSegCurvetoCubicSmoothAbs(undefined, x, y, x2, y2);
      };

      window.SVGPathElement.prototype.createSVGPathSegCurvetoCubicSmoothRel = function (x, y, x2, y2) {
        return new window.SVGPathSegCurvetoCubicSmoothRel(undefined, x, y, x2, y2);
      };

      window.SVGPathElement.prototype.createSVGPathSegCurvetoQuadraticSmoothAbs = function (x, y) {
        return new window.SVGPathSegCurvetoQuadraticSmoothAbs(undefined, x, y);
      };

      window.SVGPathElement.prototype.createSVGPathSegCurvetoQuadraticSmoothRel = function (x, y) {
        return new window.SVGPathSegCurvetoQuadraticSmoothRel(undefined, x, y);
      };

      if (!("getPathSegAtLength" in window.SVGPathElement.prototype)) {
        // Add getPathSegAtLength to SVGPathElement.
        // Spec: https://www.w3.org/TR/SVG11/single-page.html#paths-__svg__SVGPathElement__getPathSegAtLength
        // This polyfill requires SVGPathElement.getTotalLength to implement the distance-along-a-path algorithm.
        window.SVGPathElement.prototype.getPathSegAtLength = function (distance) {
          if (distance === undefined || !isFinite(distance)) throw "Invalid arguments.";
          var measurementElement = document.createElementNS("http://www.w3.org/2000/svg", "path");
          measurementElement.setAttribute("d", this.getAttribute("d"));
          var lastPathSegment = measurementElement.pathSegList.numberOfItems - 1; // If the path is empty, return 0.

          if (lastPathSegment <= 0) return 0;

          do {
            measurementElement.pathSegList.removeItem(lastPathSegment);
            if (distance > measurementElement.getTotalLength()) break;
            lastPathSegment--;
          } while (lastPathSegment > 0);

          return lastPathSegment;
        };
      }
    }

    if (!("SVGPathSegList" in window)) {
      // Spec: http://www.w3.org/TR/SVG11/single-page.html#paths-InterfaceSVGPathSegList
      window.SVGPathSegList = function (pathElement) {
        this._pathElement = pathElement;
        this._list = this._parsePath(this._pathElement.getAttribute("d")); // Use a MutationObserver to catch changes to the path's "d" attribute.

        this._mutationObserverConfig = {
          "attributes": true,
          "attributeFilter": ["d"]
        };
        this._pathElementMutationObserver = new MutationObserver(this._updateListFromPathMutations.bind(this));

        this._pathElementMutationObserver.observe(this._pathElement, this._mutationObserverConfig);
      };

      window.SVGPathSegList.prototype.classname = "SVGPathSegList";
      Object.defineProperty(window.SVGPathSegList.prototype, "numberOfItems", {
        get: function get() {
          this._checkPathSynchronizedToList();

          return this._list.length;
        },
        enumerable: true
      }); // Add the pathSegList accessors to window.SVGPathElement.
      // Spec: http://www.w3.org/TR/SVG11/single-page.html#paths-InterfaceSVGAnimatedPathData

      Object.defineProperty(window.SVGPathElement.prototype, "pathSegList", {
        get: function get() {
          if (!this._pathSegList) this._pathSegList = new window.SVGPathSegList(this);
          return this._pathSegList;
        },
        enumerable: true
      }); // FIXME: The following are not implemented and simply return window.SVGPathElement.pathSegList.

      Object.defineProperty(window.SVGPathElement.prototype, "normalizedPathSegList", {
        get: function get() {
          return this.pathSegList;
        },
        enumerable: true
      });
      Object.defineProperty(window.SVGPathElement.prototype, "animatedPathSegList", {
        get: function get() {
          return this.pathSegList;
        },
        enumerable: true
      });
      Object.defineProperty(window.SVGPathElement.prototype, "animatedNormalizedPathSegList", {
        get: function get() {
          return this.pathSegList;
        },
        enumerable: true
      }); // Process any pending mutations to the path element and update the list as needed.
      // This should be the first call of all public functions and is needed because
      // MutationObservers are not synchronous so we can have pending asynchronous mutations.

      window.SVGPathSegList.prototype._checkPathSynchronizedToList = function () {
        this._updateListFromPathMutations(this._pathElementMutationObserver.takeRecords());
      };

      window.SVGPathSegList.prototype._updateListFromPathMutations = function (mutationRecords) {
        if (!this._pathElement) return;
        var hasPathMutations = false;
        mutationRecords.forEach(function (record) {
          if (record.attributeName == "d") hasPathMutations = true;
        });
        if (hasPathMutations) this._list = this._parsePath(this._pathElement.getAttribute("d"));
      }; // Serialize the list and update the path's 'd' attribute.


      window.SVGPathSegList.prototype._writeListToPath = function () {
        this._pathElementMutationObserver.disconnect();

        this._pathElement.setAttribute("d", window.SVGPathSegList._pathSegArrayAsString(this._list));

        this._pathElementMutationObserver.observe(this._pathElement, this._mutationObserverConfig);
      }; // When a path segment changes the list needs to be synchronized back to the path element.


      window.SVGPathSegList.prototype.segmentChanged = function (pathSeg) {
        this._writeListToPath();
      };

      window.SVGPathSegList.prototype.clear = function () {
        this._checkPathSynchronizedToList();

        this._list.forEach(function (pathSeg) {
          pathSeg._owningPathSegList = null;
        });

        this._list = [];

        this._writeListToPath();
      };

      window.SVGPathSegList.prototype.initialize = function (newItem) {
        this._checkPathSynchronizedToList();

        this._list = [newItem];
        newItem._owningPathSegList = this;

        this._writeListToPath();

        return newItem;
      };

      window.SVGPathSegList.prototype._checkValidIndex = function (index) {
        if (isNaN(index) || index < 0 || index >= this.numberOfItems) throw "INDEX_SIZE_ERR";
      };

      window.SVGPathSegList.prototype.getItem = function (index) {
        this._checkPathSynchronizedToList();

        this._checkValidIndex(index);

        return this._list[index];
      };

      window.SVGPathSegList.prototype.insertItemBefore = function (newItem, index) {
        this._checkPathSynchronizedToList(); // Spec: If the index is greater than or equal to numberOfItems, then the new item is appended to the end of the list.


        if (index > this.numberOfItems) index = this.numberOfItems;

        if (newItem._owningPathSegList) {
          // SVG2 spec says to make a copy.
          newItem = newItem.clone();
        }

        this._list.splice(index, 0, newItem);

        newItem._owningPathSegList = this;

        this._writeListToPath();

        return newItem;
      };

      window.SVGPathSegList.prototype.replaceItem = function (newItem, index) {
        this._checkPathSynchronizedToList();

        if (newItem._owningPathSegList) {
          // SVG2 spec says to make a copy.
          newItem = newItem.clone();
        }

        this._checkValidIndex(index);

        this._list[index] = newItem;
        newItem._owningPathSegList = this;

        this._writeListToPath();

        return newItem;
      };

      window.SVGPathSegList.prototype.removeItem = function (index) {
        this._checkPathSynchronizedToList();

        this._checkValidIndex(index);

        var item = this._list[index];

        this._list.splice(index, 1);

        this._writeListToPath();

        return item;
      };

      window.SVGPathSegList.prototype.appendItem = function (newItem) {
        this._checkPathSynchronizedToList();

        if (newItem._owningPathSegList) {
          // SVG2 spec says to make a copy.
          newItem = newItem.clone();
        }

        this._list.push(newItem);

        newItem._owningPathSegList = this; // TODO: Optimize this to just append to the existing attribute.

        this._writeListToPath();

        return newItem;
      };

      window.SVGPathSegList._pathSegArrayAsString = function (pathSegArray) {
        var string = "";
        var first = true;
        pathSegArray.forEach(function (pathSeg) {
          if (first) {
            first = false;
            string += pathSeg._asPathString();
          } else {
            string += " " + pathSeg._asPathString();
          }
        });
        return string;
      }; // This closely follows SVGPathParser::parsePath from Source/core/svg/SVGPathParser.cpp.


      window.SVGPathSegList.prototype._parsePath = function (string) {
        if (!string || string.length == 0) return [];
        var owningPathSegList = this;

        var Builder = function Builder() {
          this.pathSegList = [];
        };

        Builder.prototype.appendSegment = function (pathSeg) {
          this.pathSegList.push(pathSeg);
        };

        var Source = function Source(string) {
          this._string = string;
          this._currentIndex = 0;
          this._endIndex = this._string.length;
          this._previousCommand = window.SVGPathSeg.PATHSEG_UNKNOWN;

          this._skipOptionalSpaces();
        };

        Source.prototype._isCurrentSpace = function () {
          var character = this._string[this._currentIndex];
          return character <= " " && (character == " " || character == "\n" || character == "\t" || character == "\r" || character == "\f");
        };

        Source.prototype._skipOptionalSpaces = function () {
          while (this._currentIndex < this._endIndex && this._isCurrentSpace()) {
            this._currentIndex++;
          }

          return this._currentIndex < this._endIndex;
        };

        Source.prototype._skipOptionalSpacesOrDelimiter = function () {
          if (this._currentIndex < this._endIndex && !this._isCurrentSpace() && this._string.charAt(this._currentIndex) != ",") return false;

          if (this._skipOptionalSpaces()) {
            if (this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) == ",") {
              this._currentIndex++;

              this._skipOptionalSpaces();
            }
          }

          return this._currentIndex < this._endIndex;
        };

        Source.prototype.hasMoreData = function () {
          return this._currentIndex < this._endIndex;
        };

        Source.prototype.peekSegmentType = function () {
          var lookahead = this._string[this._currentIndex];
          return this._pathSegTypeFromChar(lookahead);
        };

        Source.prototype._pathSegTypeFromChar = function (lookahead) {
          switch (lookahead) {
            case "Z":
            case "z":
              return window.SVGPathSeg.PATHSEG_CLOSEPATH;

            case "M":
              return window.SVGPathSeg.PATHSEG_MOVETO_ABS;

            case "m":
              return window.SVGPathSeg.PATHSEG_MOVETO_REL;

            case "L":
              return window.SVGPathSeg.PATHSEG_LINETO_ABS;

            case "l":
              return window.SVGPathSeg.PATHSEG_LINETO_REL;

            case "C":
              return window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_ABS;

            case "c":
              return window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_REL;

            case "Q":
              return window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_ABS;

            case "q":
              return window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_REL;

            case "A":
              return window.SVGPathSeg.PATHSEG_ARC_ABS;

            case "a":
              return window.SVGPathSeg.PATHSEG_ARC_REL;

            case "H":
              return window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_ABS;

            case "h":
              return window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_REL;

            case "V":
              return window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_ABS;

            case "v":
              return window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_REL;

            case "S":
              return window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_ABS;

            case "s":
              return window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_REL;

            case "T":
              return window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_ABS;

            case "t":
              return window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_REL;

            default:
              return window.SVGPathSeg.PATHSEG_UNKNOWN;
          }
        };

        Source.prototype._nextCommandHelper = function (lookahead, previousCommand) {
          // Check for remaining coordinates in the current command.
          if ((lookahead == "+" || lookahead == "-" || lookahead == "." || lookahead >= "0" && lookahead <= "9") && previousCommand != window.SVGPathSeg.PATHSEG_CLOSEPATH) {
            if (previousCommand == window.SVGPathSeg.PATHSEG_MOVETO_ABS) return window.SVGPathSeg.PATHSEG_LINETO_ABS;
            if (previousCommand == window.SVGPathSeg.PATHSEG_MOVETO_REL) return window.SVGPathSeg.PATHSEG_LINETO_REL;
            return previousCommand;
          }

          return window.SVGPathSeg.PATHSEG_UNKNOWN;
        };

        Source.prototype.initialCommandIsMoveTo = function () {
          // If the path is empty it is still valid, so return true.
          if (!this.hasMoreData()) return true;
          var command = this.peekSegmentType(); // Path must start with moveTo.

          return command == window.SVGPathSeg.PATHSEG_MOVETO_ABS || command == window.SVGPathSeg.PATHSEG_MOVETO_REL;
        }; // Parse a number from an SVG path. This very closely follows genericParseNumber(...) from Source/core/svg/SVGParserUtilities.cpp.
        // Spec: http://www.w3.org/TR/SVG11/single-page.html#paths-PathDataBNF


        Source.prototype._parseNumber = function () {
          var exponent = 0;
          var integer = 0;
          var frac = 1;
          var decimal = 0;
          var sign = 1;
          var expsign = 1;
          var startIndex = this._currentIndex;

          this._skipOptionalSpaces(); // Read the sign.


          if (this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) == "+") this._currentIndex++;else if (this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) == "-") {
            this._currentIndex++;
            sign = -1;
          }
          if (this._currentIndex == this._endIndex || (this._string.charAt(this._currentIndex) < "0" || this._string.charAt(this._currentIndex) > "9") && this._string.charAt(this._currentIndex) != ".") // The first character of a number must be one of [0-9+-.].
            return undefined; // Read the integer part, build right-to-left.

          var startIntPartIndex = this._currentIndex;

          while (this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) >= "0" && this._string.charAt(this._currentIndex) <= "9") {
            this._currentIndex++;
          } // Advance to first non-digit.


          if (this._currentIndex != startIntPartIndex) {
            var scanIntPartIndex = this._currentIndex - 1;
            var multiplier = 1;

            while (scanIntPartIndex >= startIntPartIndex) {
              integer += multiplier * (this._string.charAt(scanIntPartIndex--) - "0");
              multiplier *= 10;
            }
          } // Read the decimals.


          if (this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) == ".") {
            this._currentIndex++; // There must be a least one digit following the .

            if (this._currentIndex >= this._endIndex || this._string.charAt(this._currentIndex) < "0" || this._string.charAt(this._currentIndex) > "9") return undefined;

            while (this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) >= "0" && this._string.charAt(this._currentIndex) <= "9") {
              frac *= 10;
              decimal += (this._string.charAt(this._currentIndex) - "0") / frac;
              this._currentIndex += 1;
            }
          } // Read the exponent part.


          if (this._currentIndex != startIndex && this._currentIndex + 1 < this._endIndex && (this._string.charAt(this._currentIndex) == "e" || this._string.charAt(this._currentIndex) == "E") && this._string.charAt(this._currentIndex + 1) != "x" && this._string.charAt(this._currentIndex + 1) != "m") {
            this._currentIndex++; // Read the sign of the exponent.

            if (this._string.charAt(this._currentIndex) == "+") {
              this._currentIndex++;
            } else if (this._string.charAt(this._currentIndex) == "-") {
              this._currentIndex++;
              expsign = -1;
            } // There must be an exponent.


            if (this._currentIndex >= this._endIndex || this._string.charAt(this._currentIndex) < "0" || this._string.charAt(this._currentIndex) > "9") return undefined;

            while (this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) >= "0" && this._string.charAt(this._currentIndex) <= "9") {
              exponent *= 10;
              exponent += this._string.charAt(this._currentIndex) - "0";
              this._currentIndex++;
            }
          }

          var number = integer + decimal;
          number *= sign;
          if (exponent) number *= Math.pow(10, expsign * exponent);
          if (startIndex == this._currentIndex) return undefined;

          this._skipOptionalSpacesOrDelimiter();

          return number;
        };

        Source.prototype._parseArcFlag = function () {
          if (this._currentIndex >= this._endIndex) return undefined;
          var flag = false;

          var flagChar = this._string.charAt(this._currentIndex++);

          if (flagChar == "0") flag = false;else if (flagChar == "1") flag = true;else return undefined;

          this._skipOptionalSpacesOrDelimiter();

          return flag;
        };

        Source.prototype.parseSegment = function () {
          var lookahead = this._string[this._currentIndex];

          var command = this._pathSegTypeFromChar(lookahead);

          if (command == window.SVGPathSeg.PATHSEG_UNKNOWN) {
            // Possibly an implicit command. Not allowed if this is the first command.
            if (this._previousCommand == window.SVGPathSeg.PATHSEG_UNKNOWN) return null;
            command = this._nextCommandHelper(lookahead, this._previousCommand);
            if (command == window.SVGPathSeg.PATHSEG_UNKNOWN) return null;
          } else {
            this._currentIndex++;
          }

          this._previousCommand = command;

          switch (command) {
            case window.SVGPathSeg.PATHSEG_MOVETO_REL:
              return new window.SVGPathSegMovetoRel(owningPathSegList, this._parseNumber(), this._parseNumber());

            case window.SVGPathSeg.PATHSEG_MOVETO_ABS:
              return new window.SVGPathSegMovetoAbs(owningPathSegList, this._parseNumber(), this._parseNumber());

            case window.SVGPathSeg.PATHSEG_LINETO_REL:
              return new window.SVGPathSegLinetoRel(owningPathSegList, this._parseNumber(), this._parseNumber());

            case window.SVGPathSeg.PATHSEG_LINETO_ABS:
              return new window.SVGPathSegLinetoAbs(owningPathSegList, this._parseNumber(), this._parseNumber());

            case window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_REL:
              return new window.SVGPathSegLinetoHorizontalRel(owningPathSegList, this._parseNumber());

            case window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_ABS:
              return new window.SVGPathSegLinetoHorizontalAbs(owningPathSegList, this._parseNumber());

            case window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_REL:
              return new window.SVGPathSegLinetoVerticalRel(owningPathSegList, this._parseNumber());

            case window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_ABS:
              return new window.SVGPathSegLinetoVerticalAbs(owningPathSegList, this._parseNumber());

            case window.SVGPathSeg.PATHSEG_CLOSEPATH:
              this._skipOptionalSpaces();

              return new window.SVGPathSegClosePath(owningPathSegList);

            case window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_REL:
              var points = {
                x1: this._parseNumber(),
                y1: this._parseNumber(),
                x2: this._parseNumber(),
                y2: this._parseNumber(),
                x: this._parseNumber(),
                y: this._parseNumber()
              };
              return new window.SVGPathSegCurvetoCubicRel(owningPathSegList, points.x, points.y, points.x1, points.y1, points.x2, points.y2);

            case window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_ABS:
              var points = {
                x1: this._parseNumber(),
                y1: this._parseNumber(),
                x2: this._parseNumber(),
                y2: this._parseNumber(),
                x: this._parseNumber(),
                y: this._parseNumber()
              };
              return new window.SVGPathSegCurvetoCubicAbs(owningPathSegList, points.x, points.y, points.x1, points.y1, points.x2, points.y2);

            case window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_REL:
              var points = {
                x2: this._parseNumber(),
                y2: this._parseNumber(),
                x: this._parseNumber(),
                y: this._parseNumber()
              };
              return new window.SVGPathSegCurvetoCubicSmoothRel(owningPathSegList, points.x, points.y, points.x2, points.y2);

            case window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_ABS:
              var points = {
                x2: this._parseNumber(),
                y2: this._parseNumber(),
                x: this._parseNumber(),
                y: this._parseNumber()
              };
              return new window.SVGPathSegCurvetoCubicSmoothAbs(owningPathSegList, points.x, points.y, points.x2, points.y2);

            case window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_REL:
              var points = {
                x1: this._parseNumber(),
                y1: this._parseNumber(),
                x: this._parseNumber(),
                y: this._parseNumber()
              };
              return new window.SVGPathSegCurvetoQuadraticRel(owningPathSegList, points.x, points.y, points.x1, points.y1);

            case window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_ABS:
              var points = {
                x1: this._parseNumber(),
                y1: this._parseNumber(),
                x: this._parseNumber(),
                y: this._parseNumber()
              };
              return new window.SVGPathSegCurvetoQuadraticAbs(owningPathSegList, points.x, points.y, points.x1, points.y1);

            case window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_REL:
              return new window.SVGPathSegCurvetoQuadraticSmoothRel(owningPathSegList, this._parseNumber(), this._parseNumber());

            case window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_ABS:
              return new window.SVGPathSegCurvetoQuadraticSmoothAbs(owningPathSegList, this._parseNumber(), this._parseNumber());

            case window.SVGPathSeg.PATHSEG_ARC_REL:
              var points = {
                x1: this._parseNumber(),
                y1: this._parseNumber(),
                arcAngle: this._parseNumber(),
                arcLarge: this._parseArcFlag(),
                arcSweep: this._parseArcFlag(),
                x: this._parseNumber(),
                y: this._parseNumber()
              };
              return new window.SVGPathSegArcRel(owningPathSegList, points.x, points.y, points.x1, points.y1, points.arcAngle, points.arcLarge, points.arcSweep);

            case window.SVGPathSeg.PATHSEG_ARC_ABS:
              var points = {
                x1: this._parseNumber(),
                y1: this._parseNumber(),
                arcAngle: this._parseNumber(),
                arcLarge: this._parseArcFlag(),
                arcSweep: this._parseArcFlag(),
                x: this._parseNumber(),
                y: this._parseNumber()
              };
              return new window.SVGPathSegArcAbs(owningPathSegList, points.x, points.y, points.x1, points.y1, points.arcAngle, points.arcLarge, points.arcSweep);

            default:
              throw "Unknown path seg type.";
          }
        };

        var builder = new Builder();
        var source = new Source(string);
        if (!source.initialCommandIsMoveTo()) return [];

        while (source.hasMoreData()) {
          var pathSeg = source.parseSegment();
          if (!pathSeg) return [];
          builder.appendSegment(pathSeg);
        }

        return builder.pathSegList;
      };
    }
  })(); // String.padEnd polyfill for IE11
  //
  // https://github.com/uxitten/polyfill/blob/master/string.polyfill.js
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/padEnd


  if (!String.prototype.padEnd) {
    String.prototype.padEnd = function padEnd(targetLength, padString) {
      targetLength = targetLength >> 0; //floor if number or convert non-number to 0;

      padString = String(typeof padString !== 'undefined' ? padString : ' ');

      if (this.length > targetLength) {
        return String(this);
      } else {
        targetLength = targetLength - this.length;

        if (targetLength > padString.length) {
          padString += padString.repeat(targetLength / padString.length); //append to original to ensure we are longer than needed
        }

        return String(this) + padString.slice(0, targetLength);
      }
    };
  }
  /* jshint ignore:end */

  Chart.prototype.axis = function () {};

  Chart.prototype.axis.labels = function (labels) {
    var $$ = this.internal;

    if (arguments.length) {
      Object.keys(labels).forEach(function (axisId) {
        $$.axis.setLabelText(axisId, labels[axisId]);
      });
      $$.axis.updateLabels();
    } // TODO: return some values?

  };

  Chart.prototype.axis.max = function (max) {
    var $$ = this.internal,
        config = $$.config;

    if (arguments.length) {
      if (_typeof(max) === 'object') {
        if (isValue(max.x)) {
          config.axis_x_max = max.x;
        }

        if (isValue(max.y)) {
          config.axis_y_max = max.y;
        }

        if (isValue(max.y2)) {
          config.axis_y2_max = max.y2;
        }
      } else {
        config.axis_y_max = config.axis_y2_max = max;
      }

      $$.redraw({
        withUpdateOrgXDomain: true,
        withUpdateXDomain: true
      });
    } else {
      return {
        x: config.axis_x_max,
        y: config.axis_y_max,
        y2: config.axis_y2_max
      };
    }
  };

  Chart.prototype.axis.min = function (min) {
    var $$ = this.internal,
        config = $$.config;

    if (arguments.length) {
      if (_typeof(min) === 'object') {
        if (isValue(min.x)) {
          config.axis_x_min = min.x;
        }

        if (isValue(min.y)) {
          config.axis_y_min = min.y;
        }

        if (isValue(min.y2)) {
          config.axis_y2_min = min.y2;
        }
      } else {
        config.axis_y_min = config.axis_y2_min = min;
      }

      $$.redraw({
        withUpdateOrgXDomain: true,
        withUpdateXDomain: true
      });
    } else {
      return {
        x: config.axis_x_min,
        y: config.axis_y_min,
        y2: config.axis_y2_min
      };
    }
  };

  Chart.prototype.axis.range = function (range) {
    if (arguments.length) {
      if (isDefined(range.max)) {
        this.axis.max(range.max);
      }

      if (isDefined(range.min)) {
        this.axis.min(range.min);
      }
    } else {
      return {
        max: this.axis.max(),
        min: this.axis.min()
      };
    }
  };

  Chart.prototype.category = function (i, category) {
    var $$ = this.internal,
        config = $$.config;

    if (arguments.length > 1) {
      config.axis_x_categories[i] = category;
      $$.redraw();
    }

    return config.axis_x_categories[i];
  };

  Chart.prototype.categories = function (categories) {
    var $$ = this.internal,
        config = $$.config;

    if (!arguments.length) {
      return config.axis_x_categories;
    }

    config.axis_x_categories = categories;
    $$.redraw();
    return config.axis_x_categories;
  };

  Chart.prototype.resize = function (size) {
    var $$ = this.internal,
        config = $$.config;
    config.size_width = size ? size.width : null;
    config.size_height = size ? size.height : null;
    this.flush();
  };

  Chart.prototype.flush = function () {
    var $$ = this.internal;
    $$.updateAndRedraw({
      withLegend: true,
      withTransition: false,
      withTransitionForTransform: false
    });
  };

  Chart.prototype.destroy = function () {
    var $$ = this.internal;
    window.clearInterval($$.intervalForObserveInserted);

    if ($$.resizeTimeout !== undefined) {
      window.clearTimeout($$.resizeTimeout);
    }

    if (window.detachEvent) {
      window.detachEvent('onresize', $$.resizeIfElementDisplayed);
    } else if (window.removeEventListener) {
      window.removeEventListener('resize', $$.resizeIfElementDisplayed);
    } else {
      var wrapper = window.onresize; // check if no one else removed our wrapper and remove our resizeFunction from it

      if (wrapper && wrapper.add && wrapper.remove) {
        wrapper.remove($$.resizeFunction);
      }
    } // Removes the inner resize functions


    $$.resizeFunction.remove(); // Unbinds from the window focus event

    $$.unbindWindowFocus();
    $$.selectChart.classed('c3', false).html(""); // MEMO: this is needed because the reference of some elements will not be released, then memory leak will happen.

    Object.keys($$).forEach(function (key) {
      $$[key] = null;
    });
    return null;
  };

  Chart.prototype.color = function (id) {
    var $$ = this.internal;
    return $$.color(id); // more patterns
  };

  Chart.prototype.data = function (targetIds) {
    var targets = this.internal.data.targets;
    return typeof targetIds === 'undefined' ? targets : targets.filter(function (t) {
      return [].concat(targetIds).indexOf(t.id) >= 0;
    });
  };

  Chart.prototype.data.shown = function (targetIds) {
    return this.internal.filterTargetsToShow(this.data(targetIds));
  };

  Chart.prototype.data.values = function (targetId) {
    var targets,
        values = null;

    if (targetId) {
      targets = this.data(targetId);
      values = targets[0] ? targets[0].values.map(function (d) {
        return d.value;
      }) : null;
    }

    return values;
  };

  Chart.prototype.data.names = function (names) {
    this.internal.clearLegendItemTextBoxCache();
    return this.internal.updateDataAttributes('names', names);
  };

  Chart.prototype.data.colors = function (colors) {
    return this.internal.updateDataAttributes('colors', colors);
  };

  Chart.prototype.data.axes = function (axes) {
    return this.internal.updateDataAttributes('axes', axes);
  };

  Chart.prototype.flow = function (args) {
    var $$ = this.internal,
        targets,
        data,
        notfoundIds = [],
        orgDataCount = $$.getMaxDataCount(),
        dataCount,
        domain,
        baseTarget,
        baseValue,
        length = 0,
        tail = 0,
        diff,
        to;

    if (args.json) {
      data = $$.convertJsonToData(args.json, args.keys);
    } else if (args.rows) {
      data = $$.convertRowsToData(args.rows);
    } else if (args.columns) {
      data = $$.convertColumnsToData(args.columns);
    } else {
      return;
    }

    targets = $$.convertDataToTargets(data, true); // Update/Add data

    $$.data.targets.forEach(function (t) {
      var found = false,
          i,
          j;

      for (i = 0; i < targets.length; i++) {
        if (t.id === targets[i].id) {
          found = true;

          if (t.values[t.values.length - 1]) {
            tail = t.values[t.values.length - 1].index + 1;
          }

          length = targets[i].values.length;

          for (j = 0; j < length; j++) {
            targets[i].values[j].index = tail + j;

            if (!$$.isTimeSeries()) {
              targets[i].values[j].x = tail + j;
            }
          }

          t.values = t.values.concat(targets[i].values);
          targets.splice(i, 1);
          break;
        }
      }

      if (!found) {
        notfoundIds.push(t.id);
      }
    }); // Append null for not found targets

    $$.data.targets.forEach(function (t) {
      var i, j;

      for (i = 0; i < notfoundIds.length; i++) {
        if (t.id === notfoundIds[i]) {
          tail = t.values[t.values.length - 1].index + 1;

          for (j = 0; j < length; j++) {
            t.values.push({
              id: t.id,
              index: tail + j,
              x: $$.isTimeSeries() ? $$.getOtherTargetX(tail + j) : tail + j,
              value: null
            });
          }
        }
      }
    }); // Generate null values for new target

    if ($$.data.targets.length) {
      targets.forEach(function (t) {
        var i,
            missing = [];

        for (i = $$.data.targets[0].values[0].index; i < tail; i++) {
          missing.push({
            id: t.id,
            index: i,
            x: $$.isTimeSeries() ? $$.getOtherTargetX(i) : i,
            value: null
          });
        }

        t.values.forEach(function (v) {
          v.index += tail;

          if (!$$.isTimeSeries()) {
            v.x += tail;
          }
        });
        t.values = missing.concat(t.values);
      });
    }

    $$.data.targets = $$.data.targets.concat(targets); // add remained
    // check data count because behavior needs to change when it's only one

    dataCount = $$.getMaxDataCount();
    baseTarget = $$.data.targets[0];
    baseValue = baseTarget.values[0]; // Update length to flow if needed

    if (isDefined(args.to)) {
      length = 0;
      to = $$.isTimeSeries() ? $$.parseDate(args.to) : args.to;
      baseTarget.values.forEach(function (v) {
        if (v.x < to) {
          length++;
        }
      });
    } else if (isDefined(args.length)) {
      length = args.length;
    } // If only one data, update the domain to flow from left edge of the chart


    if (!orgDataCount) {
      if ($$.isTimeSeries()) {
        if (baseTarget.values.length > 1) {
          diff = baseTarget.values[baseTarget.values.length - 1].x - baseValue.x;
        } else {
          diff = baseValue.x - $$.getXDomain($$.data.targets)[0];
        }
      } else {
        diff = 1;
      }

      domain = [baseValue.x - diff, baseValue.x];
      $$.updateXDomain(null, true, true, false, domain);
    } else if (orgDataCount === 1) {
      if ($$.isTimeSeries()) {
        diff = (baseTarget.values[baseTarget.values.length - 1].x - baseValue.x) / 2;
        domain = [new Date(+baseValue.x - diff), new Date(+baseValue.x + diff)];
        $$.updateXDomain(null, true, true, false, domain);
      }
    } // Set targets


    $$.updateTargets($$.data.targets); // Redraw with new targets

    $$.redraw({
      flow: {
        index: baseValue.index,
        length: length,
        duration: isValue(args.duration) ? args.duration : $$.config.transition_duration,
        done: args.done,
        orgDataCount: orgDataCount
      },
      withLegend: true,
      withTransition: orgDataCount > 1,
      withTrimXDomain: false,
      withUpdateXAxis: true
    });
  };

  ChartInternal.prototype.generateFlow = function (args) {
    var $$ = this,
        config = $$.config,
        d3 = $$.d3;
    return function () {
      var targets = args.targets,
          flow = args.flow,
          drawBar = args.drawBar,
          drawLine = args.drawLine,
          drawArea = args.drawArea,
          cx = args.cx,
          cy = args.cy,
          xv = args.xv,
          xForText = args.xForText,
          yForText = args.yForText,
          duration = args.duration;

      var translateX,
          scaleX = 1,
          transform,
          flowIndex = flow.index,
          flowLength = flow.length,
          flowStart = $$.getValueOnIndex($$.data.targets[0].values, flowIndex),
          flowEnd = $$.getValueOnIndex($$.data.targets[0].values, flowIndex + flowLength),
          orgDomain = $$.x.domain(),
          domain,
          durationForFlow = flow.duration || duration,
          done = flow.done || function () {},
          wait = $$.generateWait();

      var xgrid, xgridLines, mainRegion, mainText, mainBar, mainLine, mainArea, mainCircle; // set flag

      $$.flowing = true; // remove head data after rendered

      $$.data.targets.forEach(function (d) {
        d.values.splice(0, flowLength);
      }); // update x domain to generate axis elements for flow

      domain = $$.updateXDomain(targets, true, true); // update elements related to x scale

      if ($$.updateXGrid) {
        $$.updateXGrid(true);
      }

      xgrid = $$.xgrid || d3.selectAll([]); // xgrid needs to be obtained after updateXGrid

      xgridLines = $$.xgridLines || d3.selectAll([]);
      mainRegion = $$.mainRegion || d3.selectAll([]);
      mainText = $$.mainText || d3.selectAll([]);
      mainBar = $$.mainBar || d3.selectAll([]);
      mainLine = $$.mainLine || d3.selectAll([]);
      mainArea = $$.mainArea || d3.selectAll([]);
      mainCircle = $$.mainCircle || d3.selectAll([]); // generate transform to flow

      if (!flow.orgDataCount) {
        // if empty
        if ($$.data.targets[0].values.length !== 1) {
          translateX = $$.x(orgDomain[0]) - $$.x(domain[0]);
        } else {
          if ($$.isTimeSeries()) {
            flowStart = $$.getValueOnIndex($$.data.targets[0].values, 0);
            flowEnd = $$.getValueOnIndex($$.data.targets[0].values, $$.data.targets[0].values.length - 1);
            translateX = $$.x(flowStart.x) - $$.x(flowEnd.x);
          } else {
            translateX = diffDomain(domain) / 2;
          }
        }
      } else if (flow.orgDataCount === 1 || (flowStart && flowStart.x) === (flowEnd && flowEnd.x)) {
        translateX = $$.x(orgDomain[0]) - $$.x(domain[0]);
      } else {
        if ($$.isTimeSeries()) {
          translateX = $$.x(orgDomain[0]) - $$.x(domain[0]);
        } else {
          translateX = $$.x(flowStart.x) - $$.x(flowEnd.x);
        }
      }

      scaleX = diffDomain(orgDomain) / diffDomain(domain);
      transform = 'translate(' + translateX + ',0) scale(' + scaleX + ',1)';
      $$.hideXGridFocus();
      var flowTransition = d3.transition().ease(d3.easeLinear).duration(durationForFlow);
      wait.add($$.xAxis($$.axes.x, flowTransition));
      wait.add(mainBar.transition(flowTransition).attr('transform', transform));
      wait.add(mainLine.transition(flowTransition).attr('transform', transform));
      wait.add(mainArea.transition(flowTransition).attr('transform', transform));
      wait.add(mainCircle.transition(flowTransition).attr('transform', transform));
      wait.add(mainText.transition(flowTransition).attr('transform', transform));
      wait.add(mainRegion.filter($$.isRegionOnX).transition(flowTransition).attr('transform', transform));
      wait.add(xgrid.transition(flowTransition).attr('transform', transform));
      wait.add(xgridLines.transition(flowTransition).attr('transform', transform));
      wait(function () {
        var i,
            shapes = [],
            texts = []; // remove flowed elements

        if (flowLength) {
          for (i = 0; i < flowLength; i++) {
            shapes.push('.' + CLASS.shape + '-' + (flowIndex + i));
            texts.push('.' + CLASS.text + '-' + (flowIndex + i));
          }

          $$.svg.selectAll('.' + CLASS.shapes).selectAll(shapes).remove();
          $$.svg.selectAll('.' + CLASS.texts).selectAll(texts).remove();
          $$.svg.select('.' + CLASS.xgrid).remove();
        } // draw again for removing flowed elements and reverting attr


        xgrid.attr('transform', null).attr('x1', $$.xgridAttr.x1).attr('x2', $$.xgridAttr.x2).attr('y1', $$.xgridAttr.y1).attr('y2', $$.xgridAttr.y2).style("opacity", $$.xgridAttr.opacity);
        xgridLines.attr('transform', null);
        xgridLines.select('line').attr("x1", config.axis_rotated ? 0 : xv).attr("x2", config.axis_rotated ? $$.width : xv);
        xgridLines.select('text').attr("x", config.axis_rotated ? $$.width : 0).attr("y", xv);
        mainBar.attr('transform', null).attr("d", drawBar);
        mainLine.attr('transform', null).attr("d", drawLine);
        mainArea.attr('transform', null).attr("d", drawArea);
        mainCircle.attr('transform', null).attr("cx", cx).attr("cy", cy);
        mainText.attr('transform', null).attr('x', xForText).attr('y', yForText).style('fill-opacity', $$.opacityForText.bind($$));
        mainRegion.attr('transform', null);
        mainRegion.filter($$.isRegionOnX).attr("x", $$.regionX.bind($$)).attr("width", $$.regionWidth.bind($$)); // callback for end of flow

        done();
        $$.flowing = false;
      });
    };
  };

  Chart.prototype.focus = function (targetIds) {
    var $$ = this.internal,
        candidates;
    targetIds = $$.mapToTargetIds(targetIds);
    candidates = $$.svg.selectAll($$.selectorTargets(targetIds.filter($$.isTargetToShow, $$))), this.revert();
    this.defocus();
    candidates.classed(CLASS.focused, true).classed(CLASS.defocused, false);

    if ($$.hasArcType()) {
      $$.expandArc(targetIds);
    }

    $$.toggleFocusLegend(targetIds, true);
    $$.focusedTargetIds = targetIds;
    $$.defocusedTargetIds = $$.defocusedTargetIds.filter(function (id) {
      return targetIds.indexOf(id) < 0;
    });
  };

  Chart.prototype.defocus = function (targetIds) {
    var $$ = this.internal,
        candidates;
    targetIds = $$.mapToTargetIds(targetIds);
    candidates = $$.svg.selectAll($$.selectorTargets(targetIds.filter($$.isTargetToShow, $$))), candidates.classed(CLASS.focused, false).classed(CLASS.defocused, true);

    if ($$.hasArcType()) {
      $$.unexpandArc(targetIds);
    }

    $$.toggleFocusLegend(targetIds, false);
    $$.focusedTargetIds = $$.focusedTargetIds.filter(function (id) {
      return targetIds.indexOf(id) < 0;
    });
    $$.defocusedTargetIds = targetIds;
  };

  Chart.prototype.revert = function (targetIds) {
    var $$ = this.internal,
        candidates;
    targetIds = $$.mapToTargetIds(targetIds);
    candidates = $$.svg.selectAll($$.selectorTargets(targetIds)); // should be for all targets

    candidates.classed(CLASS.focused, false).classed(CLASS.defocused, false);

    if ($$.hasArcType()) {
      $$.unexpandArc(targetIds);
    }

    if ($$.config.legend_show) {
      $$.showLegend(targetIds.filter($$.isLegendToShow.bind($$)));
      $$.legend.selectAll($$.selectorLegends(targetIds)).filter(function () {
        return $$.d3.select(this).classed(CLASS.legendItemFocused);
      }).classed(CLASS.legendItemFocused, false);
    }

    $$.focusedTargetIds = [];
    $$.defocusedTargetIds = [];
  };

  Chart.prototype.xgrids = function (grids) {
    var $$ = this.internal,
        config = $$.config;

    if (!grids) {
      return config.grid_x_lines;
    }

    config.grid_x_lines = grids;
    $$.redrawWithoutRescale();
    return config.grid_x_lines;
  };

  Chart.prototype.xgrids.add = function (grids) {
    var $$ = this.internal;
    return this.xgrids($$.config.grid_x_lines.concat(grids ? grids : []));
  };

  Chart.prototype.xgrids.remove = function (params) {
    // TODO: multiple
    var $$ = this.internal;
    $$.removeGridLines(params, true);
  };

  Chart.prototype.ygrids = function (grids) {
    var $$ = this.internal,
        config = $$.config;

    if (!grids) {
      return config.grid_y_lines;
    }

    config.grid_y_lines = grids;
    $$.redrawWithoutRescale();
    return config.grid_y_lines;
  };

  Chart.prototype.ygrids.add = function (grids) {
    var $$ = this.internal;
    return this.ygrids($$.config.grid_y_lines.concat(grids ? grids : []));
  };

  Chart.prototype.ygrids.remove = function (params) {
    // TODO: multiple
    var $$ = this.internal;
    $$.removeGridLines(params, false);
  };

  Chart.prototype.groups = function (groups) {
    var $$ = this.internal,
        config = $$.config;

    if (isUndefined(groups)) {
      return config.data_groups;
    }

    config.data_groups = groups;
    $$.redraw();
    return config.data_groups;
  };

  Chart.prototype.legend = function () {};

  Chart.prototype.legend.show = function (targetIds) {
    var $$ = this.internal;
    $$.showLegend($$.mapToTargetIds(targetIds));
    $$.updateAndRedraw({
      withLegend: true
    });
  };

  Chart.prototype.legend.hide = function (targetIds) {
    var $$ = this.internal;
    $$.hideLegend($$.mapToTargetIds(targetIds));
    $$.updateAndRedraw({
      withLegend: false
    });
  };

  Chart.prototype.load = function (args) {
    var $$ = this.internal,
        config = $$.config; // update xs if specified

    if (args.xs) {
      $$.addXs(args.xs);
    } // update names if exists


    if ('names' in args) {
      Chart.prototype.data.names.bind(this)(args.names);
    } // update classes if exists


    if ('classes' in args) {
      Object.keys(args.classes).forEach(function (id) {
        config.data_classes[id] = args.classes[id];
      });
    } // update categories if exists


    if ('categories' in args && $$.isCategorized()) {
      config.axis_x_categories = args.categories;
    } // update axes if exists


    if ('axes' in args) {
      Object.keys(args.axes).forEach(function (id) {
        config.data_axes[id] = args.axes[id];
      });
    } // update colors if exists


    if ('colors' in args) {
      Object.keys(args.colors).forEach(function (id) {
        config.data_colors[id] = args.colors[id];
      });
    } // use cache if exists


    if ('cacheIds' in args && $$.hasCaches(args.cacheIds)) {
      $$.load($$.getCaches(args.cacheIds), args.done);
      return;
    } // unload if needed


    if ('unload' in args) {
      // TODO: do not unload if target will load (included in url/rows/columns)
      $$.unload($$.mapToTargetIds(typeof args.unload === 'boolean' && args.unload ? null : args.unload), function () {
        $$.loadFromArgs(args);
      });
    } else {
      $$.loadFromArgs(args);
    }
  };

  Chart.prototype.unload = function (args) {
    var $$ = this.internal;
    args = args || {};

    if (args instanceof Array) {
      args = {
        ids: args
      };
    } else if (typeof args === 'string') {
      args = {
        ids: [args]
      };
    }

    $$.unload($$.mapToTargetIds(args.ids), function () {
      $$.redraw({
        withUpdateOrgXDomain: true,
        withUpdateXDomain: true,
        withLegend: true
      });

      if (args.done) {
        args.done();
      }
    });
  };

  Chart.prototype.regions = function (regions) {
    var $$ = this.internal,
        config = $$.config;

    if (!regions) {
      return config.regions;
    }

    config.regions = regions;
    $$.redrawWithoutRescale();
    return config.regions;
  };

  Chart.prototype.regions.add = function (regions) {
    var $$ = this.internal,
        config = $$.config;

    if (!regions) {
      return config.regions;
    }

    config.regions = config.regions.concat(regions);
    $$.redrawWithoutRescale();
    return config.regions;
  };

  Chart.prototype.regions.remove = function (options) {
    var $$ = this.internal,
        config = $$.config,
        duration,
        classes,
        regions;
    options = options || {};
    duration = getOption(options, "duration", config.transition_duration);
    classes = getOption(options, "classes", [CLASS.region]);
    regions = $$.main.select('.' + CLASS.regions).selectAll(classes.map(function (c) {
      return '.' + c;
    }));
    (duration ? regions.transition().duration(duration) : regions).style('opacity', 0).remove();
    config.regions = config.regions.filter(function (region) {
      var found = false;

      if (!region['class']) {
        return true;
      }

      region['class'].split(' ').forEach(function (c) {
        if (classes.indexOf(c) >= 0) {
          found = true;
        }
      });
      return !found;
    });
    return config.regions;
  };

  Chart.prototype.selected = function (targetId) {
    var $$ = this.internal,
        d3 = $$.d3;
    return d3.merge($$.main.selectAll('.' + CLASS.shapes + $$.getTargetSelectorSuffix(targetId)).selectAll('.' + CLASS.shape).filter(function () {
      return d3.select(this).classed(CLASS.SELECTED);
    }).map(function (d) {
      return d.map(function (d) {
        var data = d.__data__;
        return data.data ? data.data : data;
      });
    }));
  };

  Chart.prototype.select = function (ids, indices, resetOther) {
    var $$ = this.internal,
        d3 = $$.d3,
        config = $$.config;

    if (!config.data_selection_enabled) {
      return;
    }

    $$.main.selectAll('.' + CLASS.shapes).selectAll('.' + CLASS.shape).each(function (d, i) {
      var shape = d3.select(this),
          id = d.data ? d.data.id : d.id,
          toggle = $$.getToggle(this, d).bind($$),
          isTargetId = config.data_selection_grouped || !ids || ids.indexOf(id) >= 0,
          isTargetIndex = !indices || indices.indexOf(i) >= 0,
          isSelected = shape.classed(CLASS.SELECTED); // line/area selection not supported yet

      if (shape.classed(CLASS.line) || shape.classed(CLASS.area)) {
        return;
      }

      if (isTargetId && isTargetIndex) {
        if (config.data_selection_isselectable(d) && !isSelected) {
          toggle(true, shape.classed(CLASS.SELECTED, true), d, i);
        }
      } else if (isDefined(resetOther) && resetOther) {
        if (isSelected) {
          toggle(false, shape.classed(CLASS.SELECTED, false), d, i);
        }
      }
    });
  };

  Chart.prototype.unselect = function (ids, indices) {
    var $$ = this.internal,
        d3 = $$.d3,
        config = $$.config;

    if (!config.data_selection_enabled) {
      return;
    }

    $$.main.selectAll('.' + CLASS.shapes).selectAll('.' + CLASS.shape).each(function (d, i) {
      var shape = d3.select(this),
          id = d.data ? d.data.id : d.id,
          toggle = $$.getToggle(this, d).bind($$),
          isTargetId = config.data_selection_grouped || !ids || ids.indexOf(id) >= 0,
          isTargetIndex = !indices || indices.indexOf(i) >= 0,
          isSelected = shape.classed(CLASS.SELECTED); // line/area selection not supported yet

      if (shape.classed(CLASS.line) || shape.classed(CLASS.area)) {
        return;
      }

      if (isTargetId && isTargetIndex) {
        if (config.data_selection_isselectable(d)) {
          if (isSelected) {
            toggle(false, shape.classed(CLASS.SELECTED, false), d, i);
          }
        }
      }
    });
  };

  Chart.prototype.show = function (targetIds, options) {
    var $$ = this.internal,
        targets;
    targetIds = $$.mapToTargetIds(targetIds);
    options = options || {};
    $$.removeHiddenTargetIds(targetIds);
    targets = $$.svg.selectAll($$.selectorTargets(targetIds));
    targets.transition().style('display', 'initial', 'important').style('opacity', 1, 'important').call($$.endall, function () {
      targets.style('opacity', null).style('opacity', 1);
    });

    if (options.withLegend) {
      $$.showLegend(targetIds);
    }

    $$.redraw({
      withUpdateOrgXDomain: true,
      withUpdateXDomain: true,
      withLegend: true
    });
  };

  Chart.prototype.hide = function (targetIds, options) {
    var $$ = this.internal,
        targets;
    targetIds = $$.mapToTargetIds(targetIds);
    options = options || {};
    $$.addHiddenTargetIds(targetIds);
    targets = $$.svg.selectAll($$.selectorTargets(targetIds));
    targets.transition().style('opacity', 0, 'important').call($$.endall, function () {
      targets.style('opacity', null).style('opacity', 0);
      targets.style('display', 'none');
    });

    if (options.withLegend) {
      $$.hideLegend(targetIds);
    }

    $$.redraw({
      withUpdateOrgXDomain: true,
      withUpdateXDomain: true,
      withLegend: true
    });
  };

  Chart.prototype.toggle = function (targetIds, options) {
    var that = this,
        $$ = this.internal;
    $$.mapToTargetIds(targetIds).forEach(function (targetId) {
      $$.isTargetToShow(targetId) ? that.hide(targetId, options) : that.show(targetId, options);
    });
  };

  Chart.prototype.tooltip = function () {};

  Chart.prototype.tooltip.show = function (args) {
    var $$ = this.internal,
        targets,
        data,
        mouse = {}; // determine mouse position on the chart

    if (args.mouse) {
      mouse = args.mouse;
    } else {
      // determine focus data
      if (args.data) {
        data = args.data;
      } else if (typeof args.x !== 'undefined') {
        if (args.id) {
          targets = $$.data.targets.filter(function (t) {
            return t.id === args.id;
          });
        } else {
          targets = $$.data.targets;
        }

        data = $$.filterByX(targets, args.x).slice(0, 1)[0];
      }

      mouse = data ? $$.getMousePosition(data) : null;
    } // emulate mouse events to show


    $$.dispatchEvent('mousemove', mouse);
    $$.config.tooltip_onshow.call($$, data);
  };

  Chart.prototype.tooltip.hide = function () {
    // TODO: get target data by checking the state of focus
    this.internal.dispatchEvent('mouseout', 0);
    this.internal.config.tooltip_onhide.call(this);
  };

  Chart.prototype.transform = function (type, targetIds) {
    var $$ = this.internal,
        options = ['pie', 'donut'].indexOf(type) >= 0 ? {
      withTransform: true
    } : null;
    $$.transformTo(targetIds, type, options);
  };

  ChartInternal.prototype.transformTo = function (targetIds, type, optionsForRedraw) {
    var $$ = this,
        withTransitionForAxis = !$$.hasArcType(),
        options = optionsForRedraw || {
      withTransitionForAxis: withTransitionForAxis
    };
    options.withTransitionForTransform = false;
    $$.transiting = false;
    $$.setTargetType(targetIds, type);
    $$.updateTargets($$.data.targets); // this is needed when transforming to arc

    $$.updateAndRedraw(options);
  };

  Chart.prototype.x = function (x) {
    var $$ = this.internal;

    if (arguments.length) {
      $$.updateTargetX($$.data.targets, x);
      $$.redraw({
        withUpdateOrgXDomain: true,
        withUpdateXDomain: true
      });
    }

    return $$.data.xs;
  };

  Chart.prototype.xs = function (xs) {
    var $$ = this.internal;

    if (arguments.length) {
      $$.updateTargetXs($$.data.targets, xs);
      $$.redraw({
        withUpdateOrgXDomain: true,
        withUpdateXDomain: true
      });
    }

    return $$.data.xs;
  };

  Chart.prototype.zoom = function (domain) {
    var $$ = this.internal;

    if (domain) {
      if ($$.isTimeSeries()) {
        domain = domain.map(function (x) {
          return $$.parseDate(x);
        });
      }

      if ($$.config.subchart_show) {
        $$.brush.selectionAsValue(domain, true);
      } else {
        $$.updateXDomain(null, true, false, false, domain);
        $$.redraw({
          withY: $$.config.zoom_rescale,
          withSubchart: false
        });
      }

      $$.config.zoom_onzoom.call(this, $$.x.orgDomain());
      return domain;
    } else {
      return $$.x.domain();
    }
  };

  Chart.prototype.zoom.enable = function (enabled) {
    var $$ = this.internal;
    $$.config.zoom_enabled = enabled;
    $$.updateAndRedraw();
  };

  Chart.prototype.unzoom = function () {
    var $$ = this.internal;

    if ($$.config.subchart_show) {
      $$.brush.clear();
    } else {
      $$.updateXDomain(null, true, false, false, $$.subX.domain());
      $$.redraw({
        withY: $$.config.zoom_rescale,
        withSubchart: false
      });
    }
  };

  Chart.prototype.zoom.max = function (max) {
    var $$ = this.internal,
        config = $$.config,
        d3 = $$.d3;

    if (max === 0 || max) {
      config.zoom_x_max = d3.max([$$.orgXDomain[1], max]);
    } else {
      return config.zoom_x_max;
    }
  };

  Chart.prototype.zoom.min = function (min) {
    var $$ = this.internal,
        config = $$.config,
        d3 = $$.d3;

    if (min === 0 || min) {
      config.zoom_x_min = d3.min([$$.orgXDomain[0], min]);
    } else {
      return config.zoom_x_min;
    }
  };

  Chart.prototype.zoom.range = function (range) {
    if (arguments.length) {
      if (isDefined(range.max)) {
        this.domain.max(range.max);
      }

      if (isDefined(range.min)) {
        this.domain.min(range.min);
      }
    } else {
      return {
        max: this.domain.max(),
        min: this.domain.min()
      };
    }
  };

  ChartInternal.prototype.initPie = function () {
    var $$ = this,
        d3 = $$.d3;
    $$.pie = d3.pie().value(function (d) {
      return d.values.reduce(function (a, b) {
        return a + b.value;
      }, 0);
    });
    var orderFct = $$.getOrderFunction(); // we need to reverse the returned order if asc or desc to have the slice in expected order.

    if (orderFct && ($$.isOrderAsc() || $$.isOrderDesc())) {
      var defaultSort = orderFct;

      orderFct = function orderFct(t1, t2) {
        return defaultSort(t1, t2) * -1;
      };
    }

    $$.pie.sort(orderFct || null);
  };

  ChartInternal.prototype.updateRadius = function () {
    var $$ = this,
        config = $$.config,
        w = config.gauge_width || config.donut_width,
        gaugeArcWidth = $$.filterTargetsToShow($$.data.targets).length * $$.config.gauge_arcs_minWidth;
    $$.radiusExpanded = Math.min($$.arcWidth, $$.arcHeight) / 2 * ($$.hasType('gauge') ? 0.85 : 1);
    $$.radius = $$.radiusExpanded * 0.95;
    $$.innerRadiusRatio = w ? ($$.radius - w) / $$.radius : 0.6;
    $$.innerRadius = $$.hasType('donut') || $$.hasType('gauge') ? $$.radius * $$.innerRadiusRatio : 0;
    $$.gaugeArcWidth = w ? w : gaugeArcWidth <= $$.radius - $$.innerRadius ? $$.radius - $$.innerRadius : gaugeArcWidth <= $$.radius ? gaugeArcWidth : $$.radius;
  };

  ChartInternal.prototype.updateArc = function () {
    var $$ = this;
    $$.svgArc = $$.getSvgArc();
    $$.svgArcExpanded = $$.getSvgArcExpanded();
    $$.svgArcExpandedSub = $$.getSvgArcExpanded(0.98);
  };

  ChartInternal.prototype.updateAngle = function (d) {
    var $$ = this,
        config = $$.config,
        found = false,
        index = 0,
        gMin,
        gMax,
        gTic,
        gValue;

    if (!config) {
      return null;
    }

    $$.pie($$.filterTargetsToShow($$.data.targets)).forEach(function (t) {
      if (!found && t.data.id === d.data.id) {
        found = true;
        d = t;
        d.index = index;
      }

      index++;
    });

    if (isNaN(d.startAngle)) {
      d.startAngle = 0;
    }

    if (isNaN(d.endAngle)) {
      d.endAngle = d.startAngle;
    }

    if ($$.isGaugeType(d.data)) {
      gMin = config.gauge_min;
      gMax = config.gauge_max;
      gTic = Math.PI * (config.gauge_fullCircle ? 2 : 1) / (gMax - gMin);
      gValue = d.value < gMin ? 0 : d.value < gMax ? d.value - gMin : gMax - gMin;
      d.startAngle = config.gauge_startingAngle;
      d.endAngle = d.startAngle + gTic * gValue;
    }

    return found ? d : null;
  };

  ChartInternal.prototype.getSvgArc = function () {
    var $$ = this,
        hasGaugeType = $$.hasType('gauge'),
        singleArcWidth = $$.gaugeArcWidth / $$.filterTargetsToShow($$.data.targets).length,
        arc = $$.d3.arc().outerRadius(function (d) {
      return hasGaugeType ? $$.radius - singleArcWidth * d.index : $$.radius;
    }).innerRadius(function (d) {
      return hasGaugeType ? $$.radius - singleArcWidth * (d.index + 1) : $$.innerRadius;
    }),
        newArc = function newArc(d, withoutUpdate) {
      var updated;

      if (withoutUpdate) {
        return arc(d);
      } // for interpolate


      updated = $$.updateAngle(d);
      return updated ? arc(updated) : "M 0 0";
    }; // TODO: extends all function


    newArc.centroid = arc.centroid;
    return newArc;
  };

  ChartInternal.prototype.getSvgArcExpanded = function (rate) {
    rate = rate || 1;
    var $$ = this,
        hasGaugeType = $$.hasType('gauge'),
        singleArcWidth = $$.gaugeArcWidth / $$.filterTargetsToShow($$.data.targets).length,
        expandWidth = Math.min($$.radiusExpanded * rate - $$.radius, singleArcWidth * 0.8 - (1 - rate) * 100),
        arc = $$.d3.arc().outerRadius(function (d) {
      return hasGaugeType ? $$.radius - singleArcWidth * d.index + expandWidth : $$.radiusExpanded * rate;
    }).innerRadius(function (d) {
      return hasGaugeType ? $$.radius - singleArcWidth * (d.index + 1) : $$.innerRadius;
    });
    return function (d) {
      var updated = $$.updateAngle(d);
      return updated ? arc(updated) : "M 0 0";
    };
  };

  ChartInternal.prototype.getArc = function (d, withoutUpdate, force) {
    return force || this.isArcType(d.data) ? this.svgArc(d, withoutUpdate) : "M 0 0";
  };

  ChartInternal.prototype.transformForArcLabel = function (d) {
    var $$ = this,
        config = $$.config,
        updated = $$.updateAngle(d),
        c,
        x,
        y,
        h,
        ratio,
        translate = "",
        hasGauge = $$.hasType('gauge');

    if (updated && !hasGauge) {
      c = this.svgArc.centroid(updated);
      x = isNaN(c[0]) ? 0 : c[0];
      y = isNaN(c[1]) ? 0 : c[1];
      h = Math.sqrt(x * x + y * y);

      if ($$.hasType('donut') && config.donut_label_ratio) {
        ratio = isFunction(config.donut_label_ratio) ? config.donut_label_ratio(d, $$.radius, h) : config.donut_label_ratio;
      } else if ($$.hasType('pie') && config.pie_label_ratio) {
        ratio = isFunction(config.pie_label_ratio) ? config.pie_label_ratio(d, $$.radius, h) : config.pie_label_ratio;
      } else {
        ratio = $$.radius && h ? (36 / $$.radius > 0.375 ? 1.175 - 36 / $$.radius : 0.8) * $$.radius / h : 0;
      }

      translate = "translate(" + x * ratio + ',' + y * ratio + ")";
    } else if (updated && hasGauge && $$.filterTargetsToShow($$.data.targets).length > 1) {
      var y1 = Math.sin(updated.endAngle - Math.PI / 2);
      x = Math.cos(updated.endAngle - Math.PI / 2) * ($$.radiusExpanded + 25);
      y = y1 * ($$.radiusExpanded + 15 - Math.abs(y1 * 10)) + 3;
      translate = "translate(" + x + ',' + y + ")";
    }

    return translate;
  };

  ChartInternal.prototype.getArcRatio = function (d) {
    var $$ = this,
        config = $$.config,
        whole = Math.PI * ($$.hasType('gauge') && !config.gauge_fullCircle ? 1 : 2);
    return d ? (d.endAngle - d.startAngle) / whole : null;
  };

  ChartInternal.prototype.convertToArcData = function (d) {
    return this.addName({
      id: d.data.id,
      value: d.value,
      ratio: this.getArcRatio(d),
      index: d.index
    });
  };

  ChartInternal.prototype.textForArcLabel = function (d) {
    var $$ = this,
        updated,
        value,
        ratio,
        id,
        format;

    if (!$$.shouldShowArcLabel()) {
      return "";
    }

    updated = $$.updateAngle(d);
    value = updated ? updated.value : null;
    ratio = $$.getArcRatio(updated);
    id = d.data.id;

    if (!$$.hasType('gauge') && !$$.meetsArcLabelThreshold(ratio)) {
      return "";
    }

    format = $$.getArcLabelFormat();
    return format ? format(value, ratio, id) : $$.defaultArcValueFormat(value, ratio);
  };

  ChartInternal.prototype.textForGaugeMinMax = function (value, isMax) {
    var $$ = this,
        format = $$.getGaugeLabelExtents();
    return format ? format(value, isMax) : value;
  };

  ChartInternal.prototype.expandArc = function (targetIds) {
    var $$ = this,
        interval; // MEMO: avoid to cancel transition

    if ($$.transiting) {
      interval = window.setInterval(function () {
        if (!$$.transiting) {
          window.clearInterval(interval);

          if ($$.legend.selectAll('.c3-legend-item-focused').size() > 0) {
            $$.expandArc(targetIds);
          }
        }
      }, 10);
      return;
    }

    targetIds = $$.mapToTargetIds(targetIds);
    $$.svg.selectAll($$.selectorTargets(targetIds, '.' + CLASS.chartArc)).each(function (d) {
      if (!$$.shouldExpand(d.data.id)) {
        return;
      }

      $$.d3.select(this).selectAll('path').transition().duration($$.expandDuration(d.data.id)).attr("d", $$.svgArcExpanded).transition().duration($$.expandDuration(d.data.id) * 2).attr("d", $$.svgArcExpandedSub).each(function (d) {
        if ($$.isDonutType(d.data)) ;
      });
    });
  };

  ChartInternal.prototype.unexpandArc = function (targetIds) {
    var $$ = this;

    if ($$.transiting) {
      return;
    }

    targetIds = $$.mapToTargetIds(targetIds);
    $$.svg.selectAll($$.selectorTargets(targetIds, '.' + CLASS.chartArc)).selectAll('path').transition().duration(function (d) {
      return $$.expandDuration(d.data.id);
    }).attr("d", $$.svgArc);
    $$.svg.selectAll('.' + CLASS.arc);
  };

  ChartInternal.prototype.expandDuration = function (id) {
    var $$ = this,
        config = $$.config;

    if ($$.isDonutType(id)) {
      return config.donut_expand_duration;
    } else if ($$.isGaugeType(id)) {
      return config.gauge_expand_duration;
    } else if ($$.isPieType(id)) {
      return config.pie_expand_duration;
    } else {
      return 50;
    }
  };

  ChartInternal.prototype.shouldExpand = function (id) {
    var $$ = this,
        config = $$.config;
    return $$.isDonutType(id) && config.donut_expand || $$.isGaugeType(id) && config.gauge_expand || $$.isPieType(id) && config.pie_expand;
  };

  ChartInternal.prototype.shouldShowArcLabel = function () {
    var $$ = this,
        config = $$.config,
        shouldShow = true;

    if ($$.hasType('donut')) {
      shouldShow = config.donut_label_show;
    } else if ($$.hasType('pie')) {
      shouldShow = config.pie_label_show;
    } // when gauge, always true


    return shouldShow;
  };

  ChartInternal.prototype.meetsArcLabelThreshold = function (ratio) {
    var $$ = this,
        config = $$.config,
        threshold = $$.hasType('donut') ? config.donut_label_threshold : config.pie_label_threshold;
    return ratio >= threshold;
  };

  ChartInternal.prototype.getArcLabelFormat = function () {
    var $$ = this,
        config = $$.config,
        format = config.pie_label_format;

    if ($$.hasType('gauge')) {
      format = config.gauge_label_format;
    } else if ($$.hasType('donut')) {
      format = config.donut_label_format;
    }

    return format;
  };

  ChartInternal.prototype.getGaugeLabelExtents = function () {
    var $$ = this,
        config = $$.config;
    return config.gauge_label_extents;
  };

  ChartInternal.prototype.getArcTitle = function () {
    var $$ = this;
    return $$.hasType('donut') ? $$.config.donut_title : "";
  };

  ChartInternal.prototype.updateTargetsForArc = function (targets) {
    var $$ = this,
        main = $$.main,
        mainPies,
        mainPieEnter,
        classChartArc = $$.classChartArc.bind($$),
        classArcs = $$.classArcs.bind($$),
        classFocus = $$.classFocus.bind($$);
    mainPies = main.select('.' + CLASS.chartArcs).selectAll('.' + CLASS.chartArc).data($$.pie(targets)).attr("class", function (d) {
      return classChartArc(d) + classFocus(d.data);
    });
    mainPieEnter = mainPies.enter().append("g").attr("class", classChartArc);
    mainPieEnter.append('g').attr('class', classArcs);
    mainPieEnter.append("text").attr("dy", $$.hasType('gauge') ? "-.1em" : ".35em").style("opacity", 0).style("text-anchor", "middle").style("pointer-events", "none"); // MEMO: can not keep same color..., but not bad to update color in redraw
    //mainPieUpdate.exit().remove();
  };

  ChartInternal.prototype.initArc = function () {
    var $$ = this;
    $$.arcs = $$.main.select('.' + CLASS.chart).append("g").attr("class", CLASS.chartArcs).attr("transform", $$.getTranslate('arc'));
    $$.arcs.append('text').attr('class', CLASS.chartArcsTitle).style("text-anchor", "middle").text($$.getArcTitle());
  };

  ChartInternal.prototype.redrawArc = function (duration, durationForExit, withTransform) {
    var $$ = this,
        d3 = $$.d3,
        config = $$.config,
        main = $$.main,
        arcs,
        mainArc,
        arcLabelLines,
        mainArcLabelLine,
        hasGaugeType = $$.hasType('gauge');
    arcs = main.selectAll('.' + CLASS.arcs).selectAll('.' + CLASS.arc).data($$.arcData.bind($$));
    mainArc = arcs.enter().append('path').attr("class", $$.classArc.bind($$)).style("fill", function (d) {
      return $$.color(d.data);
    }).style("cursor", function (d) {
      return config.interaction_enabled && config.data_selection_isselectable(d) ? "pointer" : null;
    }).each(function (d) {
      if ($$.isGaugeType(d.data)) {
        d.startAngle = d.endAngle = config.gauge_startingAngle;
      }

      this._current = d;
    }).merge(arcs);

    if (hasGaugeType) {
      arcLabelLines = main.selectAll('.' + CLASS.arcs).selectAll('.' + CLASS.arcLabelLine).data($$.arcData.bind($$));
      mainArcLabelLine = arcLabelLines.enter().append('rect').attr("class", function (d) {
        return CLASS.arcLabelLine + ' ' + CLASS.target + ' ' + CLASS.target + '-' + d.data.id;
      }).merge(arcLabelLines);

      if ($$.filterTargetsToShow($$.data.targets).length === 1) {
        mainArcLabelLine.style("display", "none");
      } else {
        mainArcLabelLine.style("fill", function (d) {
          return $$.levelColor ? $$.levelColor(d.data.values[0].value) : $$.color(d.data);
        }).style("display", config.gauge_labelLine_show ? "" : "none").each(function (d) {
          var lineLength = 0,
              lineThickness = 2,
              x = 0,
              y = 0,
              transform = "";

          if ($$.hiddenTargetIds.indexOf(d.data.id) < 0) {
            var updated = $$.updateAngle(d),
                innerLineLength = $$.gaugeArcWidth / $$.filterTargetsToShow($$.data.targets).length * (updated.index + 1),
                lineAngle = updated.endAngle - Math.PI / 2,
                arcInnerRadius = $$.radius - innerLineLength,
                linePositioningAngle = lineAngle - (arcInnerRadius === 0 ? 0 : 1 / arcInnerRadius);
            lineLength = $$.radiusExpanded - $$.radius + innerLineLength;
            x = Math.cos(linePositioningAngle) * arcInnerRadius;
            y = Math.sin(linePositioningAngle) * arcInnerRadius;
            transform = "rotate(" + lineAngle * 180 / Math.PI + ", " + x + ", " + y + ")";
          }

          d3.select(this).attr('x', x).attr('y', y).attr('width', lineLength).attr('height', lineThickness).attr('transform', transform).style("stroke-dasharray", "0, " + (lineLength + lineThickness) + ", 0");
        });
      }
    }

    mainArc.attr("transform", function (d) {
      return !$$.isGaugeType(d.data) && withTransform ? "scale(0)" : "";
    }).on('mouseover', config.interaction_enabled ? function (d) {
      var updated, arcData;

      if ($$.transiting) {
        // skip while transiting
        return;
      }

      updated = $$.updateAngle(d);

      if (updated) {
        arcData = $$.convertToArcData(updated); // transitions

        $$.expandArc(updated.data.id);
        $$.api.focus(updated.data.id);
        $$.toggleFocusLegend(updated.data.id, true);
        $$.config.data_onmouseover(arcData, this);
      }
    } : null).on('mousemove', config.interaction_enabled ? function (d) {
      var updated = $$.updateAngle(d),
          arcData,
          selectedData;

      if (updated) {
        arcData = $$.convertToArcData(updated), selectedData = [arcData];
        $$.showTooltip(selectedData, this);
      }
    } : null).on('mouseout', config.interaction_enabled ? function (d) {
      var updated, arcData;

      if ($$.transiting) {
        // skip while transiting
        return;
      }

      updated = $$.updateAngle(d);

      if (updated) {
        arcData = $$.convertToArcData(updated); // transitions

        $$.unexpandArc(updated.data.id);
        $$.api.revert();
        $$.revertLegend();
        $$.hideTooltip();
        $$.config.data_onmouseout(arcData, this);
      }
    } : null).on('click', config.interaction_enabled ? function (d, i) {
      var updated = $$.updateAngle(d),
          arcData;

      if (updated) {
        arcData = $$.convertToArcData(updated);

        if ($$.toggleShape) {
          $$.toggleShape(this, arcData, i);
        }

        $$.config.data_onclick.call($$.api, arcData, this);
      }
    } : null).each(function () {
      $$.transiting = true;
    }).transition().duration(duration).attrTween("d", function (d) {
      var updated = $$.updateAngle(d),
          interpolate;

      if (!updated) {
        return function () {
          return "M 0 0";
        };
      } //                if (this._current === d) {
      //                    this._current = {
      //                        startAngle: Math.PI*2,
      //                        endAngle: Math.PI*2,
      //                    };
      //                }


      if (isNaN(this._current.startAngle)) {
        this._current.startAngle = 0;
      }

      if (isNaN(this._current.endAngle)) {
        this._current.endAngle = this._current.startAngle;
      }

      interpolate = d3.interpolate(this._current, updated);
      this._current = interpolate(0);
      return function (t) {
        var interpolated = interpolate(t);
        interpolated.data = d.data; // data.id will be updated by interporator

        return $$.getArc(interpolated, true);
      };
    }).attr("transform", withTransform ? "scale(1)" : "").style("fill", function (d) {
      return $$.levelColor ? $$.levelColor(d.data.values[0].value) : $$.color(d.data.id);
    }) // Where gauge reading color would receive customization.
    .call($$.endall, function () {
      $$.transiting = false;
    });
    arcs.exit().transition().duration(durationForExit).style('opacity', 0).remove();
    main.selectAll('.' + CLASS.chartArc).select('text').style("opacity", 0).attr('class', function (d) {
      return $$.isGaugeType(d.data) ? CLASS.gaugeValue : '';
    }).text($$.textForArcLabel.bind($$)).attr("transform", $$.transformForArcLabel.bind($$)).style('font-size', function (d) {
      return $$.isGaugeType(d.data) && $$.filterTargetsToShow($$.data.targets).length === 1 ? Math.round($$.radius / 5) + 'px' : '';
    }).transition().duration(duration).style("opacity", function (d) {
      return $$.isTargetToShow(d.data.id) && $$.isArcType(d.data) ? 1 : 0;
    });
    main.select('.' + CLASS.chartArcsTitle).style("opacity", $$.hasType('donut') || hasGaugeType ? 1 : 0);

    if (hasGaugeType) {
      var index = 0;
      var backgroundArc = $$.arcs.select('g.' + CLASS.chartArcsBackground).selectAll('path.' + CLASS.chartArcsBackground).data($$.data.targets);
      backgroundArc.enter().append("path").attr("class", function (d, i) {
        return CLASS.chartArcsBackground + ' ' + CLASS.chartArcsBackground + '-' + i;
      }).merge(backgroundArc).attr("d", function (d1) {
        if ($$.hiddenTargetIds.indexOf(d1.id) >= 0) {
          return "M 0 0";
        }

        var d = {
          data: [{
            value: config.gauge_max
          }],
          startAngle: config.gauge_startingAngle,
          endAngle: -1 * config.gauge_startingAngle * (config.gauge_fullCircle ? Math.PI : 1),
          index: index++
        };
        return $$.getArc(d, true, true);
      });
      backgroundArc.exit().remove();
      $$.arcs.select('.' + CLASS.chartArcsGaugeUnit).attr("dy", ".75em").text(config.gauge_label_show ? config.gauge_units : '');
      $$.arcs.select('.' + CLASS.chartArcsGaugeMin).attr("dx", -1 * ($$.innerRadius + ($$.radius - $$.innerRadius) / (config.gauge_fullCircle ? 1 : 2)) + "px").attr("dy", "1.2em").text(config.gauge_label_show ? $$.textForGaugeMinMax(config.gauge_min, false) : '');
      $$.arcs.select('.' + CLASS.chartArcsGaugeMax).attr("dx", $$.innerRadius + ($$.radius - $$.innerRadius) / (config.gauge_fullCircle ? 1 : 2) + "px").attr("dy", "1.2em").text(config.gauge_label_show ? $$.textForGaugeMinMax(config.gauge_max, true) : '');
    }
  };

  ChartInternal.prototype.initGauge = function () {
    var arcs = this.arcs;

    if (this.hasType('gauge')) {
      arcs.append('g').attr("class", CLASS.chartArcsBackground);
      arcs.append("text").attr("class", CLASS.chartArcsGaugeUnit).style("text-anchor", "middle").style("pointer-events", "none");
      arcs.append("text").attr("class", CLASS.chartArcsGaugeMin).style("text-anchor", "middle").style("pointer-events", "none");
      arcs.append("text").attr("class", CLASS.chartArcsGaugeMax).style("text-anchor", "middle").style("pointer-events", "none");
    }
  };

  ChartInternal.prototype.getGaugeLabelHeight = function () {
    return this.config.gauge_label_show ? 20 : 0;
  };

  ChartInternal.prototype.hasCaches = function (ids) {
    for (var i = 0; i < ids.length; i++) {
      if (!(ids[i] in this.cache)) {
        return false;
      }
    }

    return true;
  };

  ChartInternal.prototype.addCache = function (id, target) {
    this.cache[id] = this.cloneTarget(target);
  };

  ChartInternal.prototype.getCaches = function (ids) {
    var targets = [],
        i;

    for (i = 0; i < ids.length; i++) {
      if (ids[i] in this.cache) {
        targets.push(this.cloneTarget(this.cache[ids[i]]));
      }
    }

    return targets;
  };

  ChartInternal.prototype.categoryName = function (i) {
    var config = this.config;
    return i < config.axis_x_categories.length ? config.axis_x_categories[i] : i;
  };

  ChartInternal.prototype.generateTargetClass = function (targetId) {
    return targetId || targetId === 0 ? ('-' + targetId).replace(/\s/g, '-') : '';
  };

  ChartInternal.prototype.generateClass = function (prefix, targetId) {
    return " " + prefix + " " + prefix + this.generateTargetClass(targetId);
  };

  ChartInternal.prototype.classText = function (d) {
    return this.generateClass(CLASS.text, d.index);
  };

  ChartInternal.prototype.classTexts = function (d) {
    return this.generateClass(CLASS.texts, d.id);
  };

  ChartInternal.prototype.classShape = function (d) {
    return this.generateClass(CLASS.shape, d.index);
  };

  ChartInternal.prototype.classShapes = function (d) {
    return this.generateClass(CLASS.shapes, d.id);
  };

  ChartInternal.prototype.classLine = function (d) {
    return this.classShape(d) + this.generateClass(CLASS.line, d.id);
  };

  ChartInternal.prototype.classLines = function (d) {
    return this.classShapes(d) + this.generateClass(CLASS.lines, d.id);
  };

  ChartInternal.prototype.classCircle = function (d) {
    return this.classShape(d) + this.generateClass(CLASS.circle, d.index);
  };

  ChartInternal.prototype.classCircles = function (d) {
    return this.classShapes(d) + this.generateClass(CLASS.circles, d.id);
  };

  ChartInternal.prototype.classBar = function (d) {
    return this.classShape(d) + this.generateClass(CLASS.bar, d.index);
  };

  ChartInternal.prototype.classBars = function (d) {
    return this.classShapes(d) + this.generateClass(CLASS.bars, d.id);
  };

  ChartInternal.prototype.classArc = function (d) {
    return this.classShape(d.data) + this.generateClass(CLASS.arc, d.data.id);
  };

  ChartInternal.prototype.classArcs = function (d) {
    return this.classShapes(d.data) + this.generateClass(CLASS.arcs, d.data.id);
  };

  ChartInternal.prototype.classArea = function (d) {
    return this.classShape(d) + this.generateClass(CLASS.area, d.id);
  };

  ChartInternal.prototype.classAreas = function (d) {
    return this.classShapes(d) + this.generateClass(CLASS.areas, d.id);
  };

  ChartInternal.prototype.classRegion = function (d, i) {
    return this.generateClass(CLASS.region, i) + ' ' + ('class' in d ? d['class'] : '');
  };

  ChartInternal.prototype.classEvent = function (d) {
    return this.generateClass(CLASS.eventRect, d.index);
  };

  ChartInternal.prototype.classTarget = function (id) {
    var $$ = this;
    var additionalClassSuffix = $$.config.data_classes[id],
        additionalClass = '';

    if (additionalClassSuffix) {
      additionalClass = ' ' + CLASS.target + '-' + additionalClassSuffix;
    }

    return $$.generateClass(CLASS.target, id) + additionalClass;
  };

  ChartInternal.prototype.classFocus = function (d) {
    return this.classFocused(d) + this.classDefocused(d);
  };

  ChartInternal.prototype.classFocused = function (d) {
    return ' ' + (this.focusedTargetIds.indexOf(d.id) >= 0 ? CLASS.focused : '');
  };

  ChartInternal.prototype.classDefocused = function (d) {
    return ' ' + (this.defocusedTargetIds.indexOf(d.id) >= 0 ? CLASS.defocused : '');
  };

  ChartInternal.prototype.classChartText = function (d) {
    return CLASS.chartText + this.classTarget(d.id);
  };

  ChartInternal.prototype.classChartLine = function (d) {
    return CLASS.chartLine + this.classTarget(d.id);
  };

  ChartInternal.prototype.classChartBar = function (d) {
    return CLASS.chartBar + this.classTarget(d.id);
  };

  ChartInternal.prototype.classChartArc = function (d) {
    return CLASS.chartArc + this.classTarget(d.data.id);
  };

  ChartInternal.prototype.getTargetSelectorSuffix = function (targetId) {
    return this.generateTargetClass(targetId).replace(/([?!@#$%^&*()_=+,.<>'":;\[\]\/|~`{}\\])/g, '\\$1');
  };

  ChartInternal.prototype.selectorTarget = function (id, prefix) {
    return (prefix || '') + '.' + CLASS.target + this.getTargetSelectorSuffix(id);
  };

  ChartInternal.prototype.selectorTargets = function (ids, prefix) {
    var $$ = this;
    ids = ids || [];
    return ids.length ? ids.map(function (id) {
      return $$.selectorTarget(id, prefix);
    }) : null;
  };

  ChartInternal.prototype.selectorLegend = function (id) {
    return '.' + CLASS.legendItem + this.getTargetSelectorSuffix(id);
  };

  ChartInternal.prototype.selectorLegends = function (ids) {
    var $$ = this;
    return ids && ids.length ? ids.map(function (id) {
      return $$.selectorLegend(id);
    }) : null;
  };

  ChartInternal.prototype.getClipPath = function (id) {
    var isIE9 = window.navigator.appVersion.toLowerCase().indexOf("msie 9.") >= 0;
    return "url(" + (isIE9 ? "" : document.URL.split('#')[0]) + "#" + id + ")";
  };

  ChartInternal.prototype.appendClip = function (parent, id) {
    return parent.append("clipPath").attr("id", id).append("rect");
  };

  ChartInternal.prototype.getAxisClipX = function (forHorizontal) {
    // axis line width + padding for left
    var left = Math.max(30, this.margin.left);
    return forHorizontal ? -(1 + left) : -(left - 1);
  };

  ChartInternal.prototype.getAxisClipY = function (forHorizontal) {
    return forHorizontal ? -20 : -this.margin.top;
  };

  ChartInternal.prototype.getXAxisClipX = function () {
    var $$ = this;
    return $$.getAxisClipX(!$$.config.axis_rotated);
  };

  ChartInternal.prototype.getXAxisClipY = function () {
    var $$ = this;
    return $$.getAxisClipY(!$$.config.axis_rotated);
  };

  ChartInternal.prototype.getYAxisClipX = function () {
    var $$ = this;
    return $$.config.axis_y_inner ? -1 : $$.getAxisClipX($$.config.axis_rotated);
  };

  ChartInternal.prototype.getYAxisClipY = function () {
    var $$ = this;
    return $$.getAxisClipY($$.config.axis_rotated);
  };

  ChartInternal.prototype.getAxisClipWidth = function (forHorizontal) {
    var $$ = this,
        left = Math.max(30, $$.margin.left),
        right = Math.max(30, $$.margin.right); // width + axis line width + padding for left/right

    return forHorizontal ? $$.width + 2 + left + right : $$.margin.left + 20;
  };

  ChartInternal.prototype.getAxisClipHeight = function (forHorizontal) {
    // less than 20 is not enough to show the axis label 'outer' without legend
    return (forHorizontal ? this.margin.bottom : this.margin.top + this.height) + 20;
  };

  ChartInternal.prototype.getXAxisClipWidth = function () {
    var $$ = this;
    return $$.getAxisClipWidth(!$$.config.axis_rotated);
  };

  ChartInternal.prototype.getXAxisClipHeight = function () {
    var $$ = this;
    return $$.getAxisClipHeight(!$$.config.axis_rotated);
  };

  ChartInternal.prototype.getYAxisClipWidth = function () {
    var $$ = this;
    return $$.getAxisClipWidth($$.config.axis_rotated) + ($$.config.axis_y_inner ? 20 : 0);
  };

  ChartInternal.prototype.getYAxisClipHeight = function () {
    var $$ = this;
    return $$.getAxisClipHeight($$.config.axis_rotated);
  };

  ChartInternal.prototype.generateColor = function () {
    var $$ = this,
        config = $$.config,
        d3 = $$.d3,
        colors = config.data_colors,
        pattern = notEmpty(config.color_pattern) ? config.color_pattern : d3.schemeCategory10,
        callback = config.data_color,
        ids = [];
    return function (d) {
      var id = d.id || d.data && d.data.id || d,
          color; // if callback function is provided

      if (colors[id] instanceof Function) {
        color = colors[id](d);
      } // if specified, choose that color
      else if (colors[id]) {
          color = colors[id];
        } // if not specified, choose from pattern
        else {
            if (ids.indexOf(id) < 0) {
              ids.push(id);
            }

            color = pattern[ids.indexOf(id) % pattern.length];
            colors[id] = color;
          }

      return callback instanceof Function ? callback(color, d) : color;
    };
  };

  ChartInternal.prototype.generateLevelColor = function () {
    var $$ = this,
        config = $$.config,
        colors = config.color_pattern,
        threshold = config.color_threshold,
        asValue = threshold.unit === 'value',
        values = threshold.values && threshold.values.length ? threshold.values : [],
        max = threshold.max || 100;
    return notEmpty(threshold) && notEmpty(colors) ? function (value) {
      var i,
          v,
          color = colors[colors.length - 1];

      for (i = 0; i < values.length; i++) {
        v = asValue ? value : value * 100 / max;

        if (v < values[i]) {
          color = colors[i];
          break;
        }
      }

      return color;
    } : null;
  };

  ChartInternal.prototype.getDefaultConfig = function () {
    var config = {
      bindto: '#chart',
      svg_classname: undefined,
      size_width: undefined,
      size_height: undefined,
      padding_left: undefined,
      padding_right: undefined,
      padding_top: undefined,
      padding_bottom: undefined,
      resize_auto: true,
      zoom_enabled: false,
      zoom_initialRange: undefined,
      zoom_type: 'scroll',
      zoom_disableDefaultBehavior: false,
      zoom_privileged: false,
      zoom_rescale: false,
      zoom_onzoom: function zoom_onzoom() {},
      zoom_onzoomstart: function zoom_onzoomstart() {},
      zoom_onzoomend: function zoom_onzoomend() {},
      zoom_x_min: undefined,
      zoom_x_max: undefined,
      interaction_brighten: true,
      interaction_enabled: true,
      onmouseover: function onmouseover() {},
      onmouseout: function onmouseout() {},
      onresize: function onresize() {},
      onresized: function onresized() {},
      oninit: function oninit() {},
      onrendered: function onrendered() {},
      transition_duration: 350,
      data_x: undefined,
      data_xs: {},
      data_xFormat: '%Y-%m-%d',
      data_xLocaltime: true,
      data_xSort: true,
      data_idConverter: function data_idConverter(id) {
        return id;
      },
      data_names: {},
      data_classes: {},
      data_groups: [],
      data_axes: {},
      data_type: undefined,
      data_types: {},
      data_labels: {},
      data_order: 'desc',
      data_regions: {},
      data_color: undefined,
      data_colors: {},
      data_hide: false,
      data_filter: undefined,
      data_selection_enabled: false,
      data_selection_grouped: false,
      data_selection_isselectable: function data_selection_isselectable() {
        return true;
      },
      data_selection_multiple: true,
      data_selection_draggable: false,
      data_onclick: function data_onclick() {},
      data_onmouseover: function data_onmouseover() {},
      data_onmouseout: function data_onmouseout() {},
      data_onselected: function data_onselected() {},
      data_onunselected: function data_onunselected() {},
      data_url: undefined,
      data_headers: undefined,
      data_json: undefined,
      data_rows: undefined,
      data_columns: undefined,
      data_mimeType: undefined,
      data_keys: undefined,
      // configuration for no plot-able data supplied.
      data_empty_label_text: "",
      // subchart
      subchart_show: false,
      subchart_size_height: 60,
      subchart_axis_x_show: true,
      subchart_onbrush: function subchart_onbrush() {},
      // color
      color_pattern: [],
      color_threshold: {},
      // legend
      legend_show: true,
      legend_hide: false,
      legend_position: 'bottom',
      legend_inset_anchor: 'top-left',
      legend_inset_x: 10,
      legend_inset_y: 0,
      legend_inset_step: undefined,
      legend_item_onclick: undefined,
      legend_item_onmouseover: undefined,
      legend_item_onmouseout: undefined,
      legend_equally: false,
      legend_padding: 0,
      legend_item_tile_width: 10,
      legend_item_tile_height: 10,
      // axis
      axis_rotated: false,
      axis_x_show: true,
      axis_x_type: 'indexed',
      axis_x_localtime: true,
      axis_x_categories: [],
      axis_x_tick_centered: false,
      axis_x_tick_format: undefined,
      axis_x_tick_culling: {},
      axis_x_tick_culling_max: 10,
      axis_x_tick_count: undefined,
      axis_x_tick_fit: true,
      axis_x_tick_values: null,
      axis_x_tick_rotate: 0,
      axis_x_tick_outer: true,
      axis_x_tick_multiline: true,
      axis_x_tick_multilineMax: 0,
      axis_x_tick_width: null,
      axis_x_max: undefined,
      axis_x_min: undefined,
      axis_x_padding: {},
      axis_x_height: undefined,
      axis_x_selection: undefined,
      axis_x_label: {},
      axis_x_inner: undefined,
      axis_y_show: true,
      axis_y_type: undefined,
      axis_y_max: undefined,
      axis_y_min: undefined,
      axis_y_inverted: false,
      axis_y_center: undefined,
      axis_y_inner: undefined,
      axis_y_label: {},
      axis_y_tick_format: undefined,
      axis_y_tick_outer: true,
      axis_y_tick_values: null,
      axis_y_tick_rotate: 0,
      axis_y_tick_count: undefined,
      axis_y_tick_time_type: undefined,
      axis_y_tick_time_interval: undefined,
      axis_y_padding: {},
      axis_y_default: undefined,
      axis_y2_show: false,
      axis_y2_max: undefined,
      axis_y2_min: undefined,
      axis_y2_inverted: false,
      axis_y2_center: undefined,
      axis_y2_inner: undefined,
      axis_y2_label: {},
      axis_y2_tick_format: undefined,
      axis_y2_tick_outer: true,
      axis_y2_tick_values: null,
      axis_y2_tick_count: undefined,
      axis_y2_padding: {},
      axis_y2_default: undefined,
      // grid
      grid_x_show: false,
      grid_x_type: 'tick',
      grid_x_lines: [],
      grid_y_show: false,
      // not used
      // grid_y_type: 'tick',
      grid_y_lines: [],
      grid_y_ticks: 10,
      grid_focus_show: true,
      grid_lines_front: true,
      // point - point of each data
      point_show: true,
      point_r: 2.5,
      point_sensitivity: 10,
      point_focus_expand_enabled: true,
      point_focus_expand_r: undefined,
      point_select_r: undefined,
      // line
      line_connectNull: false,
      line_step_type: 'step',
      // bar
      bar_width: undefined,
      bar_width_ratio: 0.6,
      bar_width_max: undefined,
      bar_zerobased: true,
      bar_space: 0,
      // area
      area_zerobased: true,
      area_above: false,
      // pie
      pie_label_show: true,
      pie_label_format: undefined,
      pie_label_threshold: 0.05,
      pie_label_ratio: undefined,
      pie_expand: {},
      pie_expand_duration: 50,
      // gauge
      gauge_fullCircle: false,
      gauge_label_show: true,
      gauge_labelLine_show: true,
      gauge_label_format: undefined,
      gauge_min: 0,
      gauge_max: 100,
      gauge_startingAngle: -1 * Math.PI / 2,
      gauge_label_extents: undefined,
      gauge_units: undefined,
      gauge_width: undefined,
      gauge_arcs_minWidth: 5,
      gauge_expand: {},
      gauge_expand_duration: 50,
      // donut
      donut_label_show: true,
      donut_label_format: undefined,
      donut_label_threshold: 0.05,
      donut_label_ratio: undefined,
      donut_width: undefined,
      donut_title: "",
      donut_expand: {},
      donut_expand_duration: 50,
      // spline
      spline_interpolation_type: 'cardinal',
      // region - region to change style
      regions: [],
      // tooltip - show when mouseover on each data
      tooltip_show: true,
      tooltip_grouped: true,
      tooltip_order: undefined,
      tooltip_format_title: undefined,
      tooltip_format_name: undefined,
      tooltip_format_value: undefined,
      tooltip_position: undefined,
      tooltip_contents: function tooltip_contents(d, defaultTitleFormat, defaultValueFormat, color) {
        return this.getTooltipContent ? this.getTooltipContent(d, defaultTitleFormat, defaultValueFormat, color) : '';
      },
      tooltip_init_show: false,
      tooltip_init_x: 0,
      tooltip_init_position: {
        top: '0px',
        left: '50px'
      },
      tooltip_onshow: function tooltip_onshow() {},
      tooltip_onhide: function tooltip_onhide() {},
      // title
      title_text: undefined,
      title_padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      },
      title_position: 'top-center'
    };
    Object.keys(this.additionalConfig).forEach(function (key) {
      config[key] = this.additionalConfig[key];
    }, this);
    return config;
  };

  ChartInternal.prototype.additionalConfig = {};

  ChartInternal.prototype.loadConfig = function (config) {
    var this_config = this.config,
        target,
        keys,
        read;

    function find() {
      var key = keys.shift(); //        console.log("key =>", key, ", target =>", target);

      if (key && target && _typeof(target) === 'object' && key in target) {
        target = target[key];
        return find();
      } else if (!key) {
        return target;
      } else {
        return undefined;
      }
    }

    Object.keys(this_config).forEach(function (key) {
      target = config;
      keys = key.split('_');
      read = find(); //        console.log("CONFIG : ", key, read);

      if (isDefined(read)) {
        this_config[key] = read;
      }
    });
  };

  ChartInternal.prototype.convertUrlToData = function (url, mimeType, headers, keys, done) {
    var $$ = this,
        type = mimeType ? mimeType : 'csv',
        f,
        converter;

    if (type === 'json') {
      f = $$.d3.json;
      converter = $$.convertJsonToData;
    } else if (type === 'tsv') {
      f = $$.d3.tsv;
      converter = $$.convertXsvToData;
    } else {
      f = $$.d3.csv;
      converter = $$.convertXsvToData;
    }

    f(url, headers).then(function (data) {
      done.call($$, converter.call($$, data, keys));
    }).catch(function (error) {
      throw error;
    });
  };

  ChartInternal.prototype.convertXsvToData = function (xsv) {
    var keys = xsv.columns,
        rows = xsv;

    if (rows.length === 0) {
      return {
        keys: keys,
        rows: [keys.reduce(function (row, key) {
          return Object.assign(row, _defineProperty({}, key, null));
        }, {})]
      };
    } else {
      // [].concat() is to convert result into a plain array otherwise
      // test is not happy because rows have properties.
      return {
        keys: keys,
        rows: [].concat(xsv)
      };
    }
  };

  ChartInternal.prototype.convertJsonToData = function (json, keys) {
    var $$ = this,
        new_rows = [],
        targetKeys,
        data;

    if (keys) {
      // when keys specified, json would be an array that includes objects
      if (keys.x) {
        targetKeys = keys.value.concat(keys.x);
        $$.config.data_x = keys.x;
      } else {
        targetKeys = keys.value;
      }

      new_rows.push(targetKeys);
      json.forEach(function (o) {
        var new_row = [];
        targetKeys.forEach(function (key) {
          // convert undefined to null because undefined data will be removed in convertDataToTargets()
          var v = $$.findValueInJson(o, key);

          if (isUndefined(v)) {
            v = null;
          }

          new_row.push(v);
        });
        new_rows.push(new_row);
      });
      data = $$.convertRowsToData(new_rows);
    } else {
      Object.keys(json).forEach(function (key) {
        new_rows.push([key].concat(json[key]));
      });
      data = $$.convertColumnsToData(new_rows);
    }

    return data;
  };

  ChartInternal.prototype.findValueInJson = function (object, path) {
    path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties (replace [] with .)

    path = path.replace(/^\./, ''); // strip a leading dot

    var pathArray = path.split('.');

    for (var i = 0; i < pathArray.length; ++i) {
      var k = pathArray[i];

      if (k in object) {
        object = object[k];
      } else {
        return;
      }
    }

    return object;
  };
  /**
   * Converts the rows to normalized data.
   * @param {any[][]} rows The row data
   * @return {Object}
   */


  ChartInternal.prototype.convertRowsToData = function (rows) {
    var newRows = [];
    var keys = rows[0];

    for (var i = 1; i < rows.length; i++) {
      var newRow = {};

      for (var j = 0; j < rows[i].length; j++) {
        if (isUndefined(rows[i][j])) {
          throw new Error("Source data is missing a component at (" + i + "," + j + ")!");
        }

        newRow[keys[j]] = rows[i][j];
      }

      newRows.push(newRow);
    }

    return {
      keys: keys,
      rows: newRows
    };
  };
  /**
   * Converts the columns to normalized data.
   * @param {any[][]} columns The column data
   * @return {Object}
   */


  ChartInternal.prototype.convertColumnsToData = function (columns) {
    var newRows = [];
    var keys = [];

    for (var i = 0; i < columns.length; i++) {
      var key = columns[i][0];

      for (var j = 1; j < columns[i].length; j++) {
        if (isUndefined(newRows[j - 1])) {
          newRows[j - 1] = {};
        }

        if (isUndefined(columns[i][j])) {
          throw new Error("Source data is missing a component at (" + i + "," + j + ")!");
        }

        newRows[j - 1][key] = columns[i][j];
      }

      keys.push(key);
    }

    return {
      keys: keys,
      rows: newRows
    };
  };
  /**
   * Converts the data format into the target format.
   * @param {!Object} data
   * @param {!Array} data.keys Ordered list of target IDs.
   * @param {!Array} data.rows Rows of data to convert.
   * @param {boolean} appendXs True to append to $$.data.xs, False to replace.
   * @return {!Array}
   */


  ChartInternal.prototype.convertDataToTargets = function (data, appendXs) {
    var $$ = this,
        config = $$.config,
        targets,
        ids,
        xs,
        keys; // handles format where keys are not orderly provided

    if (isArray(data)) {
      keys = Object.keys(data[0]);
    } else {
      keys = data.keys;
      data = data.rows;
    }

    ids = keys.filter($$.isNotX, $$);
    xs = keys.filter($$.isX, $$); // save x for update data by load when custom x and c3.x API

    ids.forEach(function (id) {
      var xKey = $$.getXKey(id);

      if ($$.isCustomX() || $$.isTimeSeries()) {
        // if included in input data
        if (xs.indexOf(xKey) >= 0) {
          $$.data.xs[id] = (appendXs && $$.data.xs[id] ? $$.data.xs[id] : []).concat(data.map(function (d) {
            return d[xKey];
          }).filter(isValue).map(function (rawX, i) {
            return $$.generateTargetX(rawX, id, i);
          }));
        } // if not included in input data, find from preloaded data of other id's x
        else if (config.data_x) {
            $$.data.xs[id] = $$.getOtherTargetXs();
          } // if not included in input data, find from preloaded data
          else if (notEmpty(config.data_xs)) {
              $$.data.xs[id] = $$.getXValuesOfXKey(xKey, $$.data.targets);
            } // MEMO: if no x included, use same x of current will be used

      } else {
        $$.data.xs[id] = data.map(function (d, i) {
          return i;
        });
      }
    }); // check x is defined

    ids.forEach(function (id) {
      if (!$$.data.xs[id]) {
        throw new Error('x is not defined for id = "' + id + '".');
      }
    }); // convert to target

    targets = ids.map(function (id, index) {
      var convertedId = config.data_idConverter(id);
      return {
        id: convertedId,
        id_org: id,
        values: data.map(function (d, i) {
          var xKey = $$.getXKey(id),
              rawX = d[xKey],
              value = d[id] !== null && !isNaN(d[id]) ? +d[id] : null,
              x; // use x as categories if custom x and categorized

          if ($$.isCustomX() && $$.isCategorized() && !isUndefined(rawX)) {
            if (index === 0 && i === 0) {
              config.axis_x_categories = [];
            }

            x = config.axis_x_categories.indexOf(rawX);

            if (x === -1) {
              x = config.axis_x_categories.length;
              config.axis_x_categories.push(rawX);
            }
          } else {
            x = $$.generateTargetX(rawX, id, i);
          } // mark as x = undefined if value is undefined and filter to remove after mapped


          if (isUndefined(d[id]) || $$.data.xs[id].length <= i) {
            x = undefined;
          }

          return {
            x: x,
            value: value,
            id: convertedId
          };
        }).filter(function (v) {
          return isDefined(v.x);
        })
      };
    }); // finish targets

    targets.forEach(function (t) {
      var i; // sort values by its x

      if (config.data_xSort) {
        t.values = t.values.sort(function (v1, v2) {
          var x1 = v1.x || v1.x === 0 ? v1.x : Infinity,
              x2 = v2.x || v2.x === 0 ? v2.x : Infinity;
          return x1 - x2;
        });
      } // indexing each value


      i = 0;
      t.values.forEach(function (v) {
        v.index = i++;
      }); // this needs to be sorted because its index and value.index is identical

      $$.data.xs[t.id].sort(function (v1, v2) {
        return v1 - v2;
      });
    }); // cache information about values

    $$.hasNegativeValue = $$.hasNegativeValueInTargets(targets);
    $$.hasPositiveValue = $$.hasPositiveValueInTargets(targets); // set target types

    if (config.data_type) {
      $$.setTargetType($$.mapToIds(targets).filter(function (id) {
        return !(id in config.data_types);
      }), config.data_type);
    } // cache as original id keyed


    targets.forEach(function (d) {
      $$.addCache(d.id_org, d);
    });
    return targets;
  };

  ChartInternal.prototype.isX = function (key) {
    var $$ = this,
        config = $$.config;
    return config.data_x && key === config.data_x || notEmpty(config.data_xs) && hasValue(config.data_xs, key);
  };

  ChartInternal.prototype.isNotX = function (key) {
    return !this.isX(key);
  };

  ChartInternal.prototype.getXKey = function (id) {
    var $$ = this,
        config = $$.config;
    return config.data_x ? config.data_x : notEmpty(config.data_xs) ? config.data_xs[id] : null;
  };

  ChartInternal.prototype.getXValuesOfXKey = function (key, targets) {
    var $$ = this,
        xValues,
        ids = targets && notEmpty(targets) ? $$.mapToIds(targets) : [];
    ids.forEach(function (id) {
      if ($$.getXKey(id) === key) {
        xValues = $$.data.xs[id];
      }
    });
    return xValues;
  };

  ChartInternal.prototype.getXValue = function (id, i) {
    var $$ = this;
    return id in $$.data.xs && $$.data.xs[id] && isValue($$.data.xs[id][i]) ? $$.data.xs[id][i] : i;
  };

  ChartInternal.prototype.getOtherTargetXs = function () {
    var $$ = this,
        idsForX = Object.keys($$.data.xs);
    return idsForX.length ? $$.data.xs[idsForX[0]] : null;
  };

  ChartInternal.prototype.getOtherTargetX = function (index) {
    var xs = this.getOtherTargetXs();
    return xs && index < xs.length ? xs[index] : null;
  };

  ChartInternal.prototype.addXs = function (xs) {
    var $$ = this;
    Object.keys(xs).forEach(function (id) {
      $$.config.data_xs[id] = xs[id];
    });
  };

  ChartInternal.prototype.addName = function (data) {
    var $$ = this,
        name;

    if (data) {
      name = $$.config.data_names[data.id];
      data.name = name !== undefined ? name : data.id;
    }

    return data;
  };

  ChartInternal.prototype.getValueOnIndex = function (values, index) {
    var valueOnIndex = values.filter(function (v) {
      return v.index === index;
    });
    return valueOnIndex.length ? valueOnIndex[0] : null;
  };

  ChartInternal.prototype.updateTargetX = function (targets, x) {
    var $$ = this;
    targets.forEach(function (t) {
      t.values.forEach(function (v, i) {
        v.x = $$.generateTargetX(x[i], t.id, i);
      });
      $$.data.xs[t.id] = x;
    });
  };

  ChartInternal.prototype.updateTargetXs = function (targets, xs) {
    var $$ = this;
    targets.forEach(function (t) {
      if (xs[t.id]) {
        $$.updateTargetX([t], xs[t.id]);
      }
    });
  };

  ChartInternal.prototype.generateTargetX = function (rawX, id, index) {
    var $$ = this,
        x;

    if ($$.isTimeSeries()) {
      x = rawX ? $$.parseDate(rawX) : $$.parseDate($$.getXValue(id, index));
    } else if ($$.isCustomX() && !$$.isCategorized()) {
      x = isValue(rawX) ? +rawX : $$.getXValue(id, index);
    } else {
      x = index;
    }

    return x;
  };

  ChartInternal.prototype.cloneTarget = function (target) {
    return {
      id: target.id,
      id_org: target.id_org,
      values: target.values.map(function (d) {
        return {
          x: d.x,
          value: d.value,
          id: d.id
        };
      })
    };
  };

  ChartInternal.prototype.getMaxDataCount = function () {
    var $$ = this;
    return $$.d3.max($$.data.targets, function (t) {
      return t.values.length;
    });
  };

  ChartInternal.prototype.mapToIds = function (targets) {
    return targets.map(function (d) {
      return d.id;
    });
  };

  ChartInternal.prototype.mapToTargetIds = function (ids) {
    var $$ = this;
    return ids ? [].concat(ids) : $$.mapToIds($$.data.targets);
  };

  ChartInternal.prototype.hasTarget = function (targets, id) {
    var ids = this.mapToIds(targets),
        i;

    for (i = 0; i < ids.length; i++) {
      if (ids[i] === id) {
        return true;
      }
    }

    return false;
  };

  ChartInternal.prototype.isTargetToShow = function (targetId) {
    return this.hiddenTargetIds.indexOf(targetId) < 0;
  };

  ChartInternal.prototype.isLegendToShow = function (targetId) {
    return this.hiddenLegendIds.indexOf(targetId) < 0;
  };

  ChartInternal.prototype.filterTargetsToShow = function (targets) {
    var $$ = this;
    return targets.filter(function (t) {
      return $$.isTargetToShow(t.id);
    });
  };

  ChartInternal.prototype.mapTargetsToUniqueXs = function (targets) {
    var $$ = this;
    var xs = $$.d3.set($$.d3.merge(targets.map(function (t) {
      return t.values.map(function (v) {
        return +v.x;
      });
    }))).values();
    xs = $$.isTimeSeries() ? xs.map(function (x) {
      return new Date(+x);
    }) : xs.map(function (x) {
      return +x;
    });
    return xs.sort(function (a, b) {
      return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
    });
  };

  ChartInternal.prototype.addHiddenTargetIds = function (targetIds) {
    targetIds = targetIds instanceof Array ? targetIds : new Array(targetIds);

    for (var i = 0; i < targetIds.length; i++) {
      if (this.hiddenTargetIds.indexOf(targetIds[i]) < 0) {
        this.hiddenTargetIds = this.hiddenTargetIds.concat(targetIds[i]);
      }
    }
  };

  ChartInternal.prototype.removeHiddenTargetIds = function (targetIds) {
    this.hiddenTargetIds = this.hiddenTargetIds.filter(function (id) {
      return targetIds.indexOf(id) < 0;
    });
  };

  ChartInternal.prototype.addHiddenLegendIds = function (targetIds) {
    targetIds = targetIds instanceof Array ? targetIds : new Array(targetIds);

    for (var i = 0; i < targetIds.length; i++) {
      if (this.hiddenLegendIds.indexOf(targetIds[i]) < 0) {
        this.hiddenLegendIds = this.hiddenLegendIds.concat(targetIds[i]);
      }
    }
  };

  ChartInternal.prototype.removeHiddenLegendIds = function (targetIds) {
    this.hiddenLegendIds = this.hiddenLegendIds.filter(function (id) {
      return targetIds.indexOf(id) < 0;
    });
  };

  ChartInternal.prototype.getValuesAsIdKeyed = function (targets) {
    var ys = {};
    targets.forEach(function (t) {
      ys[t.id] = [];
      t.values.forEach(function (v) {
        ys[t.id].push(v.value);
      });
    });
    return ys;
  };

  ChartInternal.prototype.checkValueInTargets = function (targets, checker) {
    var ids = Object.keys(targets),
        i,
        j,
        values;

    for (i = 0; i < ids.length; i++) {
      values = targets[ids[i]].values;

      for (j = 0; j < values.length; j++) {
        if (checker(values[j].value)) {
          return true;
        }
      }
    }

    return false;
  };

  ChartInternal.prototype.hasNegativeValueInTargets = function (targets) {
    return this.checkValueInTargets(targets, function (v) {
      return v < 0;
    });
  };

  ChartInternal.prototype.hasPositiveValueInTargets = function (targets) {
    return this.checkValueInTargets(targets, function (v) {
      return v > 0;
    });
  };

  ChartInternal.prototype.isOrderDesc = function () {
    var config = this.config;
    return typeof config.data_order === 'string' && config.data_order.toLowerCase() === 'desc';
  };

  ChartInternal.prototype.isOrderAsc = function () {
    var config = this.config;
    return typeof config.data_order === 'string' && config.data_order.toLowerCase() === 'asc';
  };

  ChartInternal.prototype.getOrderFunction = function () {
    var $$ = this,
        config = $$.config,
        orderAsc = $$.isOrderAsc(),
        orderDesc = $$.isOrderDesc();

    if (orderAsc || orderDesc) {
      var reducer = function reducer(p, c) {
        return p + Math.abs(c.value);
      };

      return function (t1, t2) {
        var t1Sum = t1.values.reduce(reducer, 0),
            t2Sum = t2.values.reduce(reducer, 0);
        return orderAsc ? t2Sum - t1Sum : t1Sum - t2Sum;
      };
    } else if (isFunction(config.data_order)) {
      return config.data_order;
    } else if (isArray(config.data_order)) {
      var order = config.data_order;
      return function (t1, t2) {
        return order.indexOf(t1.id) - order.indexOf(t2.id);
      };
    }
  };

  ChartInternal.prototype.orderTargets = function (targets) {
    var fct = this.getOrderFunction();

    if (fct) {
      targets.sort(fct);
    }

    return targets;
  };

  ChartInternal.prototype.filterByX = function (targets, x) {
    return this.d3.merge(targets.map(function (t) {
      return t.values;
    })).filter(function (v) {
      return v.x - x === 0;
    });
  };

  ChartInternal.prototype.filterRemoveNull = function (data) {
    return data.filter(function (d) {
      return isValue(d.value);
    });
  };

  ChartInternal.prototype.filterByXDomain = function (targets, xDomain) {
    return targets.map(function (t) {
      return {
        id: t.id,
        id_org: t.id_org,
        values: t.values.filter(function (v) {
          return xDomain[0] <= v.x && v.x <= xDomain[1];
        })
      };
    });
  };

  ChartInternal.prototype.hasDataLabel = function () {
    var config = this.config;

    if (typeof config.data_labels === 'boolean' && config.data_labels) {
      return true;
    } else if (_typeof(config.data_labels) === 'object' && notEmpty(config.data_labels)) {
      return true;
    }

    return false;
  };

  ChartInternal.prototype.getDataLabelLength = function (min, max, key) {
    var $$ = this,
        lengths = [0, 0],
        paddingCoef = 1.3;
    $$.selectChart.select('svg').selectAll('.dummy').data([min, max]).enter().append('text').text(function (d) {
      return $$.dataLabelFormat(d.id)(d);
    }).each(function (d, i) {
      lengths[i] = this.getBoundingClientRect()[key] * paddingCoef;
    }).remove();
    return lengths;
  };
  /**
   * Returns true if the given data point is not arc type, otherwise false.
   * @param {Object} d The data point
   * @return {boolean}
   */


  ChartInternal.prototype.isNoneArc = function (d) {
    return this.hasTarget(this.data.targets, d.id);
  };
  /**
   * Returns true if the given data point is arc type, otherwise false.
   * @param {Object} d The data point
   * @return {boolean}
   */


  ChartInternal.prototype.isArc = function (d) {
    return 'data' in d && this.hasTarget(this.data.targets, d.data.id);
  };

  ChartInternal.prototype.findClosestFromTargets = function (targets, pos) {
    var $$ = this,
        candidates; // map to array of closest points of each target

    candidates = targets.map(function (target) {
      return $$.findClosest(target.values, pos);
    }); // decide closest point and return

    return $$.findClosest(candidates, pos);
  };

  ChartInternal.prototype.findClosest = function (values, pos) {
    var $$ = this,
        minDist = $$.config.point_sensitivity,
        closest; // find mouseovering bar

    values.filter(function (v) {
      return v && $$.isBarType(v.id);
    }).forEach(function (v) {
      var shape = $$.main.select('.' + CLASS.bars + $$.getTargetSelectorSuffix(v.id) + ' .' + CLASS.bar + '-' + v.index).node();

      if (!closest && $$.isWithinBar($$.d3.mouse(shape), shape)) {
        closest = v;
      }
    }); // find closest point from non-bar

    values.filter(function (v) {
      return v && !$$.isBarType(v.id);
    }).forEach(function (v) {
      var d = $$.dist(v, pos);

      if (d < minDist) {
        minDist = d;
        closest = v;
      }
    });
    return closest;
  };

  ChartInternal.prototype.dist = function (data, pos) {
    var $$ = this,
        config = $$.config,
        xIndex = config.axis_rotated ? 1 : 0,
        yIndex = config.axis_rotated ? 0 : 1,
        y = $$.circleY(data, data.index),
        x = $$.x(data.x);
    return Math.sqrt(Math.pow(x - pos[xIndex], 2) + Math.pow(y - pos[yIndex], 2));
  };

  ChartInternal.prototype.convertValuesToStep = function (values) {
    var converted = [].concat(values),
        i;

    if (!this.isCategorized()) {
      return values;
    }

    for (i = values.length + 1; 0 < i; i--) {
      converted[i] = converted[i - 1];
    }

    converted[0] = {
      x: converted[0].x - 1,
      value: converted[0].value,
      id: converted[0].id
    };
    converted[values.length + 1] = {
      x: converted[values.length].x + 1,
      value: converted[values.length].value,
      id: converted[values.length].id
    };
    return converted;
  };

  ChartInternal.prototype.updateDataAttributes = function (name, attrs) {
    var $$ = this,
        config = $$.config,
        current = config['data_' + name];

    if (typeof attrs === 'undefined') {
      return current;
    }

    Object.keys(attrs).forEach(function (id) {
      current[id] = attrs[id];
    });
    $$.redraw({
      withLegend: true
    });
    return current;
  };

  ChartInternal.prototype.load = function (targets, args) {
    var $$ = this;

    if (targets) {
      // filter loading targets if needed
      if (args.filter) {
        targets = targets.filter(args.filter);
      } // set type if args.types || args.type specified


      if (args.type || args.types) {
        targets.forEach(function (t) {
          var type = args.types && args.types[t.id] ? args.types[t.id] : args.type;
          $$.setTargetType(t.id, type);
        });
      } // Update/Add data


      $$.data.targets.forEach(function (d) {
        for (var i = 0; i < targets.length; i++) {
          if (d.id === targets[i].id) {
            d.values = targets[i].values;
            targets.splice(i, 1);
            break;
          }
        }
      });
      $$.data.targets = $$.data.targets.concat(targets); // add remained
    } // Set targets


    $$.updateTargets($$.data.targets); // Redraw with new targets

    $$.redraw({
      withUpdateOrgXDomain: true,
      withUpdateXDomain: true,
      withLegend: true
    });

    if (args.done) {
      args.done();
    }
  };

  ChartInternal.prototype.loadFromArgs = function (args) {
    var $$ = this;

    if (args.data) {
      $$.load($$.convertDataToTargets(args.data), args);
    } else if (args.url) {
      $$.convertUrlToData(args.url, args.mimeType, args.headers, args.keys, function (data) {
        $$.load($$.convertDataToTargets(data), args);
      });
    } else if (args.json) {
      $$.load($$.convertDataToTargets($$.convertJsonToData(args.json, args.keys)), args);
    } else if (args.rows) {
      $$.load($$.convertDataToTargets($$.convertRowsToData(args.rows)), args);
    } else if (args.columns) {
      $$.load($$.convertDataToTargets($$.convertColumnsToData(args.columns)), args);
    } else {
      $$.load(null, args);
    }
  };

  ChartInternal.prototype.unload = function (targetIds, done) {
    var $$ = this;

    if (!done) {
      done = function done() {};
    } // filter existing target


    targetIds = targetIds.filter(function (id) {
      return $$.hasTarget($$.data.targets, id);
    }); // If no target, call done and return

    if (!targetIds || targetIds.length === 0) {
      done();
      return;
    }

    $$.svg.selectAll(targetIds.map(function (id) {
      return $$.selectorTarget(id);
    })).transition().style('opacity', 0).remove().call($$.endall, done);
    targetIds.forEach(function (id) {
      // Reset fadein for future load
      $$.withoutFadeIn[id] = false; // Remove target's elements

      if ($$.legend) {
        $$.legend.selectAll('.' + CLASS.legendItem + $$.getTargetSelectorSuffix(id)).remove();
      } // Remove target


      $$.data.targets = $$.data.targets.filter(function (t) {
        return t.id !== id;
      });
    });
  };

  ChartInternal.prototype.getYDomainMin = function (targets) {
    var $$ = this,
        config = $$.config,
        ids = $$.mapToIds(targets),
        ys = $$.getValuesAsIdKeyed(targets),
        j,
        k,
        baseId,
        idsInGroup,
        id,
        hasNegativeValue;

    if (config.data_groups.length > 0) {
      hasNegativeValue = $$.hasNegativeValueInTargets(targets);

      for (j = 0; j < config.data_groups.length; j++) {
        // Determine baseId
        idsInGroup = config.data_groups[j].filter(function (id) {
          return ids.indexOf(id) >= 0;
        });

        if (idsInGroup.length === 0) {
          continue;
        }

        baseId = idsInGroup[0]; // Consider negative values

        if (hasNegativeValue && ys[baseId]) {
          ys[baseId].forEach(function (v, i) {
            ys[baseId][i] = v < 0 ? v : 0;
          });
        } // Compute min


        for (k = 1; k < idsInGroup.length; k++) {
          id = idsInGroup[k];

          if (!ys[id]) {
            continue;
          }

          ys[id].forEach(function (v, i) {
            if ($$.axis.getId(id) === $$.axis.getId(baseId) && ys[baseId] && !(hasNegativeValue && +v > 0)) {
              ys[baseId][i] += +v;
            }
          });
        }
      }
    }

    return $$.d3.min(Object.keys(ys).map(function (key) {
      return $$.d3.min(ys[key]);
    }));
  };

  ChartInternal.prototype.getYDomainMax = function (targets) {
    var $$ = this,
        config = $$.config,
        ids = $$.mapToIds(targets),
        ys = $$.getValuesAsIdKeyed(targets),
        j,
        k,
        baseId,
        idsInGroup,
        id,
        hasPositiveValue;

    if (config.data_groups.length > 0) {
      hasPositiveValue = $$.hasPositiveValueInTargets(targets);

      for (j = 0; j < config.data_groups.length; j++) {
        // Determine baseId
        idsInGroup = config.data_groups[j].filter(function (id) {
          return ids.indexOf(id) >= 0;
        });

        if (idsInGroup.length === 0) {
          continue;
        }

        baseId = idsInGroup[0]; // Consider positive values

        if (hasPositiveValue && ys[baseId]) {
          ys[baseId].forEach(function (v, i) {
            ys[baseId][i] = v > 0 ? v : 0;
          });
        } // Compute max


        for (k = 1; k < idsInGroup.length; k++) {
          id = idsInGroup[k];

          if (!ys[id]) {
            continue;
          }

          ys[id].forEach(function (v, i) {
            if ($$.axis.getId(id) === $$.axis.getId(baseId) && ys[baseId] && !(hasPositiveValue && +v < 0)) {
              ys[baseId][i] += +v;
            }
          });
        }
      }
    }

    return $$.d3.max(Object.keys(ys).map(function (key) {
      return $$.d3.max(ys[key]);
    }));
  };

  ChartInternal.prototype.getYDomain = function (targets, axisId, xDomain) {
    var $$ = this,
        config = $$.config,
        targetsByAxisId = targets.filter(function (t) {
      return $$.axis.getId(t.id) === axisId;
    }),
        yTargets = xDomain ? $$.filterByXDomain(targetsByAxisId, xDomain) : targetsByAxisId,
        yMin = axisId === 'y2' ? config.axis_y2_min : config.axis_y_min,
        yMax = axisId === 'y2' ? config.axis_y2_max : config.axis_y_max,
        yDomainMin = $$.getYDomainMin(yTargets),
        yDomainMax = $$.getYDomainMax(yTargets),
        domain,
        domainLength,
        padding,
        padding_top,
        padding_bottom,
        center = axisId === 'y2' ? config.axis_y2_center : config.axis_y_center,
        yDomainAbs,
        lengths,
        diff,
        ratio,
        isAllPositive,
        isAllNegative,
        isZeroBased = $$.hasType('bar', yTargets) && config.bar_zerobased || $$.hasType('area', yTargets) && config.area_zerobased,
        isInverted = axisId === 'y2' ? config.axis_y2_inverted : config.axis_y_inverted,
        showHorizontalDataLabel = $$.hasDataLabel() && config.axis_rotated,
        showVerticalDataLabel = $$.hasDataLabel() && !config.axis_rotated; // MEMO: avoid inverting domain unexpectedly

    yDomainMin = isValue(yMin) ? yMin : isValue(yMax) ? yDomainMin < yMax ? yDomainMin : yMax - 10 : yDomainMin;
    yDomainMax = isValue(yMax) ? yMax : isValue(yMin) ? yMin < yDomainMax ? yDomainMax : yMin + 10 : yDomainMax;

    if (yTargets.length === 0) {
      // use current domain if target of axisId is none
      return axisId === 'y2' ? $$.y2.domain() : $$.y.domain();
    }

    if (isNaN(yDomainMin)) {
      // set minimum to zero when not number
      yDomainMin = 0;
    }

    if (isNaN(yDomainMax)) {
      // set maximum to have same value as yDomainMin
      yDomainMax = yDomainMin;
    }

    if (yDomainMin === yDomainMax) {
      yDomainMin < 0 ? yDomainMax = 0 : yDomainMin = 0;
    }

    isAllPositive = yDomainMin >= 0 && yDomainMax >= 0;
    isAllNegative = yDomainMin <= 0 && yDomainMax <= 0; // Cancel zerobased if axis_*_min / axis_*_max specified

    if (isValue(yMin) && isAllPositive || isValue(yMax) && isAllNegative) {
      isZeroBased = false;
    } // Bar/Area chart should be 0-based if all positive|negative


    if (isZeroBased) {
      if (isAllPositive) {
        yDomainMin = 0;
      }

      if (isAllNegative) {
        yDomainMax = 0;
      }
    }

    domainLength = Math.abs(yDomainMax - yDomainMin);
    padding = padding_top = padding_bottom = domainLength * 0.1;

    if (typeof center !== 'undefined') {
      yDomainAbs = Math.max(Math.abs(yDomainMin), Math.abs(yDomainMax));
      yDomainMax = center + yDomainAbs;
      yDomainMin = center - yDomainAbs;
    } // add padding for data label


    if (showHorizontalDataLabel) {
      lengths = $$.getDataLabelLength(yDomainMin, yDomainMax, 'width');
      diff = diffDomain($$.y.range());
      ratio = [lengths[0] / diff, lengths[1] / diff];
      padding_top += domainLength * (ratio[1] / (1 - ratio[0] - ratio[1]));
      padding_bottom += domainLength * (ratio[0] / (1 - ratio[0] - ratio[1]));
    } else if (showVerticalDataLabel) {
      lengths = $$.getDataLabelLength(yDomainMin, yDomainMax, 'height');
      padding_top += $$.axis.convertPixelsToAxisPadding(lengths[1], domainLength);
      padding_bottom += $$.axis.convertPixelsToAxisPadding(lengths[0], domainLength);
    }

    if (axisId === 'y' && notEmpty(config.axis_y_padding)) {
      padding_top = $$.axis.getPadding(config.axis_y_padding, 'top', padding_top, domainLength);
      padding_bottom = $$.axis.getPadding(config.axis_y_padding, 'bottom', padding_bottom, domainLength);
    }

    if (axisId === 'y2' && notEmpty(config.axis_y2_padding)) {
      padding_top = $$.axis.getPadding(config.axis_y2_padding, 'top', padding_top, domainLength);
      padding_bottom = $$.axis.getPadding(config.axis_y2_padding, 'bottom', padding_bottom, domainLength);
    } // Bar/Area chart should be 0-based if all positive|negative


    if (isZeroBased) {
      if (isAllPositive) {
        padding_bottom = yDomainMin;
      }

      if (isAllNegative) {
        padding_top = -yDomainMax;
      }
    }

    domain = [yDomainMin - padding_bottom, yDomainMax + padding_top];
    return isInverted ? domain.reverse() : domain;
  };

  ChartInternal.prototype.getXDomainMin = function (targets) {
    var $$ = this,
        config = $$.config;
    return isDefined(config.axis_x_min) ? $$.isTimeSeries() ? this.parseDate(config.axis_x_min) : config.axis_x_min : $$.d3.min(targets, function (t) {
      return $$.d3.min(t.values, function (v) {
        return v.x;
      });
    });
  };

  ChartInternal.prototype.getXDomainMax = function (targets) {
    var $$ = this,
        config = $$.config;
    return isDefined(config.axis_x_max) ? $$.isTimeSeries() ? this.parseDate(config.axis_x_max) : config.axis_x_max : $$.d3.max(targets, function (t) {
      return $$.d3.max(t.values, function (v) {
        return v.x;
      });
    });
  };

  ChartInternal.prototype.getXDomainPadding = function (domain) {
    var $$ = this,
        config = $$.config,
        diff = domain[1] - domain[0],
        maxDataCount,
        padding,
        paddingLeft,
        paddingRight;

    if ($$.isCategorized()) {
      padding = 0;
    } else if ($$.hasType('bar')) {
      maxDataCount = $$.getMaxDataCount();
      padding = maxDataCount > 1 ? diff / (maxDataCount - 1) / 2 : 0.5;
    } else {
      padding = diff * 0.01;
    }

    if (_typeof(config.axis_x_padding) === 'object' && notEmpty(config.axis_x_padding)) {
      paddingLeft = isValue(config.axis_x_padding.left) ? config.axis_x_padding.left : padding;
      paddingRight = isValue(config.axis_x_padding.right) ? config.axis_x_padding.right : padding;
    } else if (typeof config.axis_x_padding === 'number') {
      paddingLeft = paddingRight = config.axis_x_padding;
    } else {
      paddingLeft = paddingRight = padding;
    }

    return {
      left: paddingLeft,
      right: paddingRight
    };
  };

  ChartInternal.prototype.getXDomain = function (targets) {
    var $$ = this,
        xDomain = [$$.getXDomainMin(targets), $$.getXDomainMax(targets)],
        firstX = xDomain[0],
        lastX = xDomain[1],
        padding = $$.getXDomainPadding(xDomain),
        min = 0,
        max = 0; // show center of x domain if min and max are the same

    if (firstX - lastX === 0 && !$$.isCategorized()) {
      if ($$.isTimeSeries()) {
        firstX = new Date(firstX.getTime() * 0.5);
        lastX = new Date(lastX.getTime() * 1.5);
      } else {
        firstX = firstX === 0 ? 1 : firstX * 0.5;
        lastX = lastX === 0 ? -1 : lastX * 1.5;
      }
    }

    if (firstX || firstX === 0) {
      min = $$.isTimeSeries() ? new Date(firstX.getTime() - padding.left) : firstX - padding.left;
    }

    if (lastX || lastX === 0) {
      max = $$.isTimeSeries() ? new Date(lastX.getTime() + padding.right) : lastX + padding.right;
    }

    return [min, max];
  };

  ChartInternal.prototype.updateXDomain = function (targets, withUpdateXDomain, withUpdateOrgXDomain, withTrim, domain) {
    var $$ = this,
        config = $$.config;

    if (withUpdateOrgXDomain) {
      $$.x.domain(domain ? domain : $$.d3.extent($$.getXDomain(targets)));
      $$.orgXDomain = $$.x.domain();

      if (config.zoom_enabled) {
        $$.zoom.update();
      }

      $$.subX.domain($$.x.domain());

      if ($$.brush) {
        $$.brush.updateScale($$.subX);
      }
    }

    if (withUpdateXDomain) {
      $$.x.domain(domain ? domain : !$$.brush || $$.brush.empty() ? $$.orgXDomain : $$.brush.selectionAsValue());
    } // Trim domain when too big by zoom mousemove event


    if (withTrim) {
      $$.x.domain($$.trimXDomain($$.x.orgDomain()));
    }

    return $$.x.domain();
  };

  ChartInternal.prototype.trimXDomain = function (domain) {
    var zoomDomain = this.getZoomDomain(),
        min = zoomDomain[0],
        max = zoomDomain[1];

    if (domain[0] <= min) {
      domain[1] = +domain[1] + (min - domain[0]);
      domain[0] = min;
    }

    if (max <= domain[1]) {
      domain[0] = +domain[0] - (domain[1] - max);
      domain[1] = max;
    }

    return domain;
  };

  ChartInternal.prototype.drag = function (mouse) {
    var $$ = this,
        config = $$.config,
        main = $$.main,
        d3 = $$.d3;
    var sx, sy, mx, my, minX, maxX, minY, maxY;

    if ($$.hasArcType()) {
      return;
    }

    if (!config.data_selection_enabled) {
      return;
    } // do nothing if not selectable


    if (!config.data_selection_multiple) {
      return;
    } // skip when single selection because drag is used for multiple selection


    sx = $$.dragStart[0];
    sy = $$.dragStart[1];
    mx = mouse[0];
    my = mouse[1];
    minX = Math.min(sx, mx);
    maxX = Math.max(sx, mx);
    minY = config.data_selection_grouped ? $$.margin.top : Math.min(sy, my);
    maxY = config.data_selection_grouped ? $$.height : Math.max(sy, my);
    main.select('.' + CLASS.dragarea).attr('x', minX).attr('y', minY).attr('width', maxX - minX).attr('height', maxY - minY); // TODO: binary search when multiple xs

    main.selectAll('.' + CLASS.shapes).selectAll('.' + CLASS.shape).filter(function (d) {
      return config.data_selection_isselectable(d);
    }).each(function (d, i) {
      var shape = d3.select(this),
          isSelected = shape.classed(CLASS.SELECTED),
          isIncluded = shape.classed(CLASS.INCLUDED),
          _x,
          _y,
          _w,
          _h,
          toggle,
          isWithin = false,
          box;

      if (shape.classed(CLASS.circle)) {
        _x = shape.attr("cx") * 1;
        _y = shape.attr("cy") * 1;
        toggle = $$.togglePoint;
        isWithin = minX < _x && _x < maxX && minY < _y && _y < maxY;
      } else if (shape.classed(CLASS.bar)) {
        box = getPathBox(this);
        _x = box.x;
        _y = box.y;
        _w = box.width;
        _h = box.height;
        toggle = $$.togglePath;
        isWithin = !(maxX < _x || _x + _w < minX) && !(maxY < _y || _y + _h < minY);
      } else {
        // line/area selection not supported yet
        return;
      }

      if (isWithin ^ isIncluded) {
        shape.classed(CLASS.INCLUDED, !isIncluded); // TODO: included/unincluded callback here

        shape.classed(CLASS.SELECTED, !isSelected);
        toggle.call($$, !isSelected, shape, d, i);
      }
    });
  };

  ChartInternal.prototype.dragstart = function (mouse) {
    var $$ = this,
        config = $$.config;

    if ($$.hasArcType()) {
      return;
    }

    if (!config.data_selection_enabled) {
      return;
    } // do nothing if not selectable


    $$.dragStart = mouse;
    $$.main.select('.' + CLASS.chart).append('rect').attr('class', CLASS.dragarea).style('opacity', 0.1);
    $$.dragging = true;
  };

  ChartInternal.prototype.dragend = function () {
    var $$ = this,
        config = $$.config;

    if ($$.hasArcType()) {
      return;
    }

    if (!config.data_selection_enabled) {
      return;
    } // do nothing if not selectable


    $$.main.select('.' + CLASS.dragarea).transition().duration(100).style('opacity', 0).remove();
    $$.main.selectAll('.' + CLASS.shape).classed(CLASS.INCLUDED, false);
    $$.dragging = false;
  };

  ChartInternal.prototype.getYFormat = function (forArc) {
    var $$ = this,
        formatForY = forArc && !$$.hasType('gauge') ? $$.defaultArcValueFormat : $$.yFormat,
        formatForY2 = forArc && !$$.hasType('gauge') ? $$.defaultArcValueFormat : $$.y2Format;
    return function (v, ratio, id) {
      var format = $$.axis.getId(id) === 'y2' ? formatForY2 : formatForY;
      return format.call($$, v, ratio);
    };
  };

  ChartInternal.prototype.yFormat = function (v) {
    var $$ = this,
        config = $$.config,
        format = config.axis_y_tick_format ? config.axis_y_tick_format : $$.defaultValueFormat;
    return format(v);
  };

  ChartInternal.prototype.y2Format = function (v) {
    var $$ = this,
        config = $$.config,
        format = config.axis_y2_tick_format ? config.axis_y2_tick_format : $$.defaultValueFormat;
    return format(v);
  };

  ChartInternal.prototype.defaultValueFormat = function (v) {
    return isValue(v) ? +v : "";
  };

  ChartInternal.prototype.defaultArcValueFormat = function (v, ratio) {
    return (ratio * 100).toFixed(1) + '%';
  };

  ChartInternal.prototype.dataLabelFormat = function (targetId) {
    var $$ = this,
        data_labels = $$.config.data_labels,
        format,
        defaultFormat = function defaultFormat(v) {
      return isValue(v) ? +v : "";
    }; // find format according to axis id


    if (typeof data_labels.format === 'function') {
      format = data_labels.format;
    } else if (_typeof(data_labels.format) === 'object') {
      if (data_labels.format[targetId]) {
        format = data_labels.format[targetId] === true ? defaultFormat : data_labels.format[targetId];
      } else {
        format = function format() {
          return '';
        };
      }
    } else {
      format = defaultFormat;
    }

    return format;
  };

  ChartInternal.prototype.initGrid = function () {
    var $$ = this,
        config = $$.config,
        d3 = $$.d3;
    $$.grid = $$.main.append('g').attr("clip-path", $$.clipPathForGrid).attr('class', CLASS.grid);

    if (config.grid_x_show) {
      $$.grid.append("g").attr("class", CLASS.xgrids);
    }

    if (config.grid_y_show) {
      $$.grid.append('g').attr('class', CLASS.ygrids);
    }

    if (config.grid_focus_show) {
      $$.grid.append('g').attr("class", CLASS.xgridFocus).append('line').attr('class', CLASS.xgridFocus);
    }

    $$.xgrid = d3.selectAll([]);

    if (!config.grid_lines_front) {
      $$.initGridLines();
    }
  };

  ChartInternal.prototype.initGridLines = function () {
    var $$ = this,
        d3 = $$.d3;
    $$.gridLines = $$.main.append('g').attr("clip-path", $$.clipPathForGrid).attr('class', CLASS.grid + ' ' + CLASS.gridLines);
    $$.gridLines.append('g').attr("class", CLASS.xgridLines);
    $$.gridLines.append('g').attr('class', CLASS.ygridLines);
    $$.xgridLines = d3.selectAll([]);
  };

  ChartInternal.prototype.updateXGrid = function (withoutUpdate) {
    var $$ = this,
        config = $$.config,
        d3 = $$.d3,
        xgridData = $$.generateGridData(config.grid_x_type, $$.x),
        tickOffset = $$.isCategorized() ? $$.xAxis.tickOffset() : 0;
    $$.xgridAttr = config.axis_rotated ? {
      'x1': 0,
      'x2': $$.width,
      'y1': function y1(d) {
        return $$.x(d) - tickOffset;
      },
      'y2': function y2(d) {
        return $$.x(d) - tickOffset;
      }
    } : {
      'x1': function x1(d) {
        return $$.x(d) + tickOffset;
      },
      'x2': function x2(d) {
        return $$.x(d) + tickOffset;
      },
      'y1': 0,
      'y2': $$.height
    };

    $$.xgridAttr.opacity = function () {
      var pos = +d3.select(this).attr(config.axis_rotated ? 'y1' : 'x1');
      return pos === (config.axis_rotated ? $$.height : 0) ? 0 : 1;
    };

    var xgrid = $$.main.select('.' + CLASS.xgrids).selectAll('.' + CLASS.xgrid).data(xgridData);
    var xgridEnter = xgrid.enter().append('line').attr("class", CLASS.xgrid).attr('x1', $$.xgridAttr.x1).attr('x2', $$.xgridAttr.x2).attr('y1', $$.xgridAttr.y1).attr('y2', $$.xgridAttr.y2).style("opacity", 0);
    $$.xgrid = xgridEnter.merge(xgrid);

    if (!withoutUpdate) {
      $$.xgrid.attr('x1', $$.xgridAttr.x1).attr('x2', $$.xgridAttr.x2).attr('y1', $$.xgridAttr.y1).attr('y2', $$.xgridAttr.y2).style("opacity", $$.xgridAttr.opacity);
    }

    xgrid.exit().remove();
  };

  ChartInternal.prototype.updateYGrid = function () {
    var $$ = this,
        config = $$.config,
        gridValues = $$.yAxis.tickValues() || $$.y.ticks(config.grid_y_ticks);
    var ygrid = $$.main.select('.' + CLASS.ygrids).selectAll('.' + CLASS.ygrid).data(gridValues);
    var ygridEnter = ygrid.enter().append('line') // TODO: x1, x2, y1, y2, opacity need to be set here maybe
    .attr('class', CLASS.ygrid);
    $$.ygrid = ygridEnter.merge(ygrid);
    $$.ygrid.attr("x1", config.axis_rotated ? $$.y : 0).attr("x2", config.axis_rotated ? $$.y : $$.width).attr("y1", config.axis_rotated ? 0 : $$.y).attr("y2", config.axis_rotated ? $$.height : $$.y);
    ygrid.exit().remove();
    $$.smoothLines($$.ygrid, 'grid');
  };

  ChartInternal.prototype.gridTextAnchor = function (d) {
    return d.position ? d.position : "end";
  };

  ChartInternal.prototype.gridTextDx = function (d) {
    return d.position === 'start' ? 4 : d.position === 'middle' ? 0 : -4;
  };

  ChartInternal.prototype.xGridTextX = function (d) {
    return d.position === 'start' ? -this.height : d.position === 'middle' ? -this.height / 2 : 0;
  };

  ChartInternal.prototype.yGridTextX = function (d) {
    return d.position === 'start' ? 0 : d.position === 'middle' ? this.width / 2 : this.width;
  };

  ChartInternal.prototype.updateGrid = function (duration) {
    var $$ = this,
        main = $$.main,
        config = $$.config,
        xgridLine,
        xgridLineEnter,
        ygridLine,
        ygridLineEnter,
        xv = $$.xv.bind($$),
        yv = $$.yv.bind($$),
        xGridTextX = $$.xGridTextX.bind($$),
        yGridTextX = $$.yGridTextX.bind($$); // hide if arc type

    $$.grid.style('visibility', $$.hasArcType() ? 'hidden' : 'visible');
    main.select('line.' + CLASS.xgridFocus).style("visibility", "hidden");

    if (config.grid_x_show) {
      $$.updateXGrid();
    }

    xgridLine = main.select('.' + CLASS.xgridLines).selectAll('.' + CLASS.xgridLine).data(config.grid_x_lines); // enter

    xgridLineEnter = xgridLine.enter().append('g').attr("class", function (d) {
      return CLASS.xgridLine + (d['class'] ? ' ' + d['class'] : '');
    });
    xgridLineEnter.append('line').attr("x1", config.axis_rotated ? 0 : xv).attr("x2", config.axis_rotated ? $$.width : xv).attr("y1", config.axis_rotated ? xv : 0).attr("y2", config.axis_rotated ? xv : $$.height).style("opacity", 0);
    xgridLineEnter.append('text').attr("text-anchor", $$.gridTextAnchor).attr("transform", config.axis_rotated ? "" : "rotate(-90)").attr("x", config.axis_rotated ? yGridTextX : xGridTextX).attr("y", xv).attr('dx', $$.gridTextDx).attr('dy', -5).style("opacity", 0); // udpate

    $$.xgridLines = xgridLineEnter.merge(xgridLine); // done in d3.transition() of the end of this function
    // exit

    xgridLine.exit().transition().duration(duration).style("opacity", 0).remove(); // Y-Grid

    if (config.grid_y_show) {
      $$.updateYGrid();
    }

    ygridLine = main.select('.' + CLASS.ygridLines).selectAll('.' + CLASS.ygridLine).data(config.grid_y_lines); // enter

    ygridLineEnter = ygridLine.enter().append('g').attr("class", function (d) {
      return CLASS.ygridLine + (d['class'] ? ' ' + d['class'] : '');
    });
    ygridLineEnter.append('line').attr("x1", config.axis_rotated ? yv : 0).attr("x2", config.axis_rotated ? yv : $$.width).attr("y1", config.axis_rotated ? 0 : yv).attr("y2", config.axis_rotated ? $$.height : yv).style("opacity", 0);
    ygridLineEnter.append('text').attr("text-anchor", $$.gridTextAnchor).attr("transform", config.axis_rotated ? "rotate(-90)" : "").attr("x", config.axis_rotated ? xGridTextX : yGridTextX).attr("y", yv).attr('dx', $$.gridTextDx).attr('dy', -5).style("opacity", 0); // update

    $$.ygridLines = ygridLineEnter.merge(ygridLine);
    $$.ygridLines.select('line').transition().duration(duration).attr("x1", config.axis_rotated ? yv : 0).attr("x2", config.axis_rotated ? yv : $$.width).attr("y1", config.axis_rotated ? 0 : yv).attr("y2", config.axis_rotated ? $$.height : yv).style("opacity", 1);
    $$.ygridLines.select('text').transition().duration(duration).attr("x", config.axis_rotated ? $$.xGridTextX.bind($$) : $$.yGridTextX.bind($$)).attr("y", yv).text(function (d) {
      return d.text;
    }).style("opacity", 1); // exit

    ygridLine.exit().transition().duration(duration).style("opacity", 0).remove();
  };

  ChartInternal.prototype.redrawGrid = function (withTransition, transition) {
    var $$ = this,
        config = $$.config,
        xv = $$.xv.bind($$),
        lines = $$.xgridLines.select('line'),
        texts = $$.xgridLines.select('text');
    return [(withTransition ? lines.transition(transition) : lines).attr("x1", config.axis_rotated ? 0 : xv).attr("x2", config.axis_rotated ? $$.width : xv).attr("y1", config.axis_rotated ? xv : 0).attr("y2", config.axis_rotated ? xv : $$.height).style("opacity", 1), (withTransition ? texts.transition(transition) : texts).attr("x", config.axis_rotated ? $$.yGridTextX.bind($$) : $$.xGridTextX.bind($$)).attr("y", xv).text(function (d) {
      return d.text;
    }).style("opacity", 1)];
  };

  ChartInternal.prototype.showXGridFocus = function (selectedData) {
    var $$ = this,
        config = $$.config,
        dataToShow = selectedData.filter(function (d) {
      return d && isValue(d.value);
    }),
        focusEl = $$.main.selectAll('line.' + CLASS.xgridFocus),
        xx = $$.xx.bind($$);

    if (!config.tooltip_show) {
      return;
    } // Hide when scatter plot exists


    if ($$.hasType('scatter') || $$.hasArcType()) {
      return;
    }

    focusEl.style("visibility", "visible").data([dataToShow[0]]).attr(config.axis_rotated ? 'y1' : 'x1', xx).attr(config.axis_rotated ? 'y2' : 'x2', xx);
    $$.smoothLines(focusEl, 'grid');
  };

  ChartInternal.prototype.hideXGridFocus = function () {
    this.main.select('line.' + CLASS.xgridFocus).style("visibility", "hidden");
  };

  ChartInternal.prototype.updateXgridFocus = function () {
    var $$ = this,
        config = $$.config;
    $$.main.select('line.' + CLASS.xgridFocus).attr("x1", config.axis_rotated ? 0 : -10).attr("x2", config.axis_rotated ? $$.width : -10).attr("y1", config.axis_rotated ? -10 : 0).attr("y2", config.axis_rotated ? -10 : $$.height);
  };

  ChartInternal.prototype.generateGridData = function (type, scale) {
    var $$ = this,
        gridData = [],
        xDomain,
        firstYear,
        lastYear,
        i,
        tickNum = $$.main.select("." + CLASS.axisX).selectAll('.tick').size();

    if (type === 'year') {
      xDomain = $$.getXDomain();
      firstYear = xDomain[0].getFullYear();
      lastYear = xDomain[1].getFullYear();

      for (i = firstYear; i <= lastYear; i++) {
        gridData.push(new Date(i + '-01-01 00:00:00'));
      }
    } else {
      gridData = scale.ticks(10);

      if (gridData.length > tickNum) {
        // use only int
        gridData = gridData.filter(function (d) {
          return ("" + d).indexOf('.') < 0;
        });
      }
    }

    return gridData;
  };

  ChartInternal.prototype.getGridFilterToRemove = function (params) {
    return params ? function (line) {
      var found = false;
      [].concat(params).forEach(function (param) {
        if ('value' in param && line.value === param.value || 'class' in param && line['class'] === param['class']) {
          found = true;
        }
      });
      return found;
    } : function () {
      return true;
    };
  };

  ChartInternal.prototype.removeGridLines = function (params, forX) {
    var $$ = this,
        config = $$.config,
        toRemove = $$.getGridFilterToRemove(params),
        toShow = function toShow(line) {
      return !toRemove(line);
    },
        classLines = forX ? CLASS.xgridLines : CLASS.ygridLines,
        classLine = forX ? CLASS.xgridLine : CLASS.ygridLine;

    $$.main.select('.' + classLines).selectAll('.' + classLine).filter(toRemove).transition().duration(config.transition_duration).style('opacity', 0).remove();

    if (forX) {
      config.grid_x_lines = config.grid_x_lines.filter(toShow);
    } else {
      config.grid_y_lines = config.grid_y_lines.filter(toShow);
    }
  };

  ChartInternal.prototype.initEventRect = function () {
    var $$ = this,
        config = $$.config;
    $$.main.select('.' + CLASS.chart).append("g").attr("class", CLASS.eventRects).style('fill-opacity', 0);
    $$.eventRect = $$.main.select('.' + CLASS.eventRects).append('rect').attr('class', CLASS.eventRect); // event rect handle zoom event as well

    if (config.zoom_enabled && $$.zoom) {
      $$.eventRect.call($$.zoom).on("dblclick.zoom", null);

      if (config.zoom_initialRange) {
        // WORKAROUND: Add transition to apply transform immediately when no subchart
        $$.eventRect.transition().duration(0).call($$.zoom.transform, $$.zoomTransform(config.zoom_initialRange));
      }
    }
  };

  ChartInternal.prototype.redrawEventRect = function () {
    var $$ = this,
        d3 = $$.d3,
        config = $$.config,
        x,
        y,
        w,
        h; // TODO: rotated not supported yet

    x = 0;
    y = 0;
    w = $$.width;
    h = $$.height;

    function mouseout() {
      $$.svg.select('.' + CLASS.eventRect).style('cursor', null);
      $$.hideXGridFocus();
      $$.hideTooltip();
      $$.unexpandCircles();
      $$.unexpandBars();
    } // rects for mouseover


    $$.main.select('.' + CLASS.eventRects).style('cursor', config.zoom_enabled ? config.axis_rotated ? 'ns-resize' : 'ew-resize' : null);
    $$.eventRect.attr('x', x).attr('y', y).attr('width', w).attr('height', h).on('mouseout', config.interaction_enabled ? function () {
      if (!config) {
        return;
      } // chart is destroyed


      if ($$.hasArcType()) {
        return;
      }

      mouseout();
    } : null).on('mousemove', config.interaction_enabled ? function () {
      var targetsToShow, mouse, closest, sameXData, selectedData;

      if ($$.dragging) {
        return;
      } // do nothing when dragging


      if ($$.hasArcType(targetsToShow)) {
        return;
      }

      targetsToShow = $$.filterTargetsToShow($$.data.targets);
      mouse = d3.mouse(this);
      closest = $$.findClosestFromTargets(targetsToShow, mouse);

      if ($$.mouseover && (!closest || closest.id !== $$.mouseover.id)) {
        config.data_onmouseout.call($$.api, $$.mouseover);
        $$.mouseover = undefined;
      }

      if (!closest) {
        mouseout();
        return;
      }

      if ($$.isScatterType(closest) || !config.tooltip_grouped) {
        sameXData = [closest];
      } else {
        sameXData = $$.filterByX(targetsToShow, closest.x);
      } // show tooltip when cursor is close to some point


      selectedData = sameXData.map(function (d) {
        return $$.addName(d);
      });
      $$.showTooltip(selectedData, this); // expand points

      if (config.point_focus_expand_enabled) {
        $$.unexpandCircles();
        selectedData.forEach(function (d) {
          $$.expandCircles(d.index, d.id, false);
        });
      }

      $$.expandBars(closest.index, closest.id, true); // Show xgrid focus line

      $$.showXGridFocus(selectedData); // Show cursor as pointer if point is close to mouse position

      if ($$.isBarType(closest.id) || $$.dist(closest, mouse) < config.point_sensitivity) {
        $$.svg.select('.' + CLASS.eventRect).style('cursor', 'pointer');

        if (!$$.mouseover) {
          config.data_onmouseover.call($$.api, closest);
          $$.mouseover = closest;
        }
      }
    } : null).on('click', config.interaction_enabled ? function () {
      var targetsToShow, mouse, closest, sameXData;

      if ($$.hasArcType(targetsToShow)) {
        return;
      }

      targetsToShow = $$.filterTargetsToShow($$.data.targets);
      mouse = d3.mouse(this);
      closest = $$.findClosestFromTargets(targetsToShow, mouse);

      if (!closest) {
        return;
      } // select if selection enabled


      if ($$.isBarType(closest.id) || $$.dist(closest, mouse) < config.point_sensitivity) {
        if ($$.isScatterType(closest) || !config.data_selection_grouped) {
          sameXData = [closest];
        } else {
          sameXData = $$.filterByX(targetsToShow, closest.x);
        }

        sameXData.forEach(function (d) {
          $$.main.selectAll('.' + CLASS.shapes + $$.getTargetSelectorSuffix(d.id)).selectAll('.' + CLASS.shape + '-' + d.index).each(function () {
            if (config.data_selection_grouped || $$.isWithinShape(this, d)) {
              $$.toggleShape(this, d, d.index);
              config.data_onclick.call($$.api, d, this);
            }
          });
        });
      }
    } : null).call(config.interaction_enabled && config.data_selection_draggable && $$.drag ? d3.drag().on('drag', function () {
      $$.drag(d3.mouse(this));
    }).on('start', function () {
      $$.dragstart(d3.mouse(this));
    }).on('end', function () {
      $$.dragend();
    }) : function () {});
  };

  ChartInternal.prototype.getMousePosition = function (data) {
    var $$ = this;
    return [$$.x(data.x), $$.getYScale(data.id)(data.value)];
  };

  ChartInternal.prototype.dispatchEvent = function (type, mouse) {
    var $$ = this,
        selector = '.' + CLASS.eventRect,
        eventRect = $$.main.select(selector).node(),
        box = eventRect.getBoundingClientRect(),
        x = box.left + (mouse ? mouse[0] : 0),
        y = box.top + (mouse ? mouse[1] : 0),
        event = document.createEvent("MouseEvents");
    event.initMouseEvent(type, true, true, window, 0, x, y, x, y, false, false, false, false, 0, null);
    eventRect.dispatchEvent(event);
  };

  ChartInternal.prototype.initLegend = function () {
    var $$ = this;
    $$.legendItemTextBox = {};
    $$.legendHasRendered = false;
    $$.legend = $$.svg.append("g").attr("transform", $$.getTranslate('legend'));

    if (!$$.config.legend_show) {
      $$.legend.style('visibility', 'hidden');
      $$.hiddenLegendIds = $$.mapToIds($$.data.targets);
      return;
    } // MEMO: call here to update legend box and tranlate for all
    // MEMO: translate will be upated by this, so transform not needed in updateLegend()


    $$.updateLegendWithDefaults();
  };

  ChartInternal.prototype.updateLegendWithDefaults = function () {
    var $$ = this;
    $$.updateLegend($$.mapToIds($$.data.targets), {
      withTransform: false,
      withTransitionForTransform: false,
      withTransition: false
    });
  };

  ChartInternal.prototype.updateSizeForLegend = function (legendHeight, legendWidth) {
    var $$ = this,
        config = $$.config,
        insetLegendPosition = {
      top: $$.isLegendTop ? $$.getCurrentPaddingTop() + config.legend_inset_y + 5.5 : $$.currentHeight - legendHeight - $$.getCurrentPaddingBottom() - config.legend_inset_y,
      left: $$.isLegendLeft ? $$.getCurrentPaddingLeft() + config.legend_inset_x + 0.5 : $$.currentWidth - legendWidth - $$.getCurrentPaddingRight() - config.legend_inset_x + 0.5
    };
    $$.margin3 = {
      top: $$.isLegendRight ? 0 : $$.isLegendInset ? insetLegendPosition.top : $$.currentHeight - legendHeight,
      right: NaN,
      bottom: 0,
      left: $$.isLegendRight ? $$.currentWidth - legendWidth : $$.isLegendInset ? insetLegendPosition.left : 0
    };
  };

  ChartInternal.prototype.transformLegend = function (withTransition) {
    var $$ = this;
    (withTransition ? $$.legend.transition() : $$.legend).attr("transform", $$.getTranslate('legend'));
  };

  ChartInternal.prototype.updateLegendStep = function (step) {
    this.legendStep = step;
  };

  ChartInternal.prototype.updateLegendItemWidth = function (w) {
    this.legendItemWidth = w;
  };

  ChartInternal.prototype.updateLegendItemHeight = function (h) {
    this.legendItemHeight = h;
  };

  ChartInternal.prototype.getLegendWidth = function () {
    var $$ = this;
    return $$.config.legend_show ? $$.isLegendRight || $$.isLegendInset ? $$.legendItemWidth * ($$.legendStep + 1) : $$.currentWidth : 0;
  };

  ChartInternal.prototype.getLegendHeight = function () {
    var $$ = this,
        h = 0;

    if ($$.config.legend_show) {
      if ($$.isLegendRight) {
        h = $$.currentHeight;
      } else {
        h = Math.max(20, $$.legendItemHeight) * ($$.legendStep + 1);
      }
    }

    return h;
  };

  ChartInternal.prototype.opacityForLegend = function (legendItem) {
    return legendItem.classed(CLASS.legendItemHidden) ? null : 1;
  };

  ChartInternal.prototype.opacityForUnfocusedLegend = function (legendItem) {
    return legendItem.classed(CLASS.legendItemHidden) ? null : 0.3;
  };

  ChartInternal.prototype.toggleFocusLegend = function (targetIds, focus) {
    var $$ = this;
    targetIds = $$.mapToTargetIds(targetIds);
    $$.legend.selectAll('.' + CLASS.legendItem).filter(function (id) {
      return targetIds.indexOf(id) >= 0;
    }).classed(CLASS.legendItemFocused, focus).transition().duration(100).style('opacity', function () {
      var opacity = focus ? $$.opacityForLegend : $$.opacityForUnfocusedLegend;
      return opacity.call($$, $$.d3.select(this));
    });
  };

  ChartInternal.prototype.revertLegend = function () {
    var $$ = this,
        d3 = $$.d3;
    $$.legend.selectAll('.' + CLASS.legendItem).classed(CLASS.legendItemFocused, false).transition().duration(100).style('opacity', function () {
      return $$.opacityForLegend(d3.select(this));
    });
  };

  ChartInternal.prototype.showLegend = function (targetIds) {
    var $$ = this,
        config = $$.config;

    if (!config.legend_show) {
      config.legend_show = true;
      $$.legend.style('visibility', 'visible');

      if (!$$.legendHasRendered) {
        $$.updateLegendWithDefaults();
      }
    }

    $$.removeHiddenLegendIds(targetIds);
    $$.legend.selectAll($$.selectorLegends(targetIds)).style('visibility', 'visible').transition().style('opacity', function () {
      return $$.opacityForLegend($$.d3.select(this));
    });
  };

  ChartInternal.prototype.hideLegend = function (targetIds) {
    var $$ = this,
        config = $$.config;

    if (config.legend_show && isEmpty(targetIds)) {
      config.legend_show = false;
      $$.legend.style('visibility', 'hidden');
    }

    $$.addHiddenLegendIds(targetIds);
    $$.legend.selectAll($$.selectorLegends(targetIds)).style('opacity', 0).style('visibility', 'hidden');
  };

  ChartInternal.prototype.clearLegendItemTextBoxCache = function () {
    this.legendItemTextBox = {};
  };

  ChartInternal.prototype.updateLegend = function (targetIds, options, transitions) {
    var $$ = this,
        config = $$.config;
    var xForLegend, xForLegendText, xForLegendRect, yForLegend, yForLegendText, yForLegendRect, x1ForLegendTile, x2ForLegendTile, yForLegendTile;
    var paddingTop = 4,
        paddingRight = 10,
        maxWidth = 0,
        maxHeight = 0,
        posMin = 10,
        tileWidth = config.legend_item_tile_width + 5;
    var l,
        totalLength = 0,
        offsets = {},
        widths = {},
        heights = {},
        margins = [0],
        steps = {},
        step = 0;
    var withTransition, withTransitionForTransform;
    var texts, rects, tiles, background; // Skip elements when their name is set to null

    targetIds = targetIds.filter(function (id) {
      return !isDefined(config.data_names[id]) || config.data_names[id] !== null;
    });
    options = options || {};
    withTransition = getOption(options, "withTransition", true);
    withTransitionForTransform = getOption(options, "withTransitionForTransform", true);

    function getTextBox(textElement, id) {
      if (!$$.legendItemTextBox[id]) {
        $$.legendItemTextBox[id] = $$.getTextRect(textElement.textContent, CLASS.legendItem, textElement);
      }

      return $$.legendItemTextBox[id];
    }

    function updatePositions(textElement, id, index) {
      var reset = index === 0,
          isLast = index === targetIds.length - 1,
          box = getTextBox(textElement, id),
          itemWidth = box.width + tileWidth + (isLast && !($$.isLegendRight || $$.isLegendInset) ? 0 : paddingRight) + config.legend_padding,
          itemHeight = box.height + paddingTop,
          itemLength = $$.isLegendRight || $$.isLegendInset ? itemHeight : itemWidth,
          areaLength = $$.isLegendRight || $$.isLegendInset ? $$.getLegendHeight() : $$.getLegendWidth(),
          margin,
          maxLength; // MEMO: care about condifion of step, totalLength

      function updateValues(id, withoutStep) {
        if (!withoutStep) {
          margin = (areaLength - totalLength - itemLength) / 2;

          if (margin < posMin) {
            margin = (areaLength - itemLength) / 2;
            totalLength = 0;
            step++;
          }
        }

        steps[id] = step;
        margins[step] = $$.isLegendInset ? 10 : margin;
        offsets[id] = totalLength;
        totalLength += itemLength;
      }

      if (reset) {
        totalLength = 0;
        step = 0;
        maxWidth = 0;
        maxHeight = 0;
      }

      if (config.legend_show && !$$.isLegendToShow(id)) {
        widths[id] = heights[id] = steps[id] = offsets[id] = 0;
        return;
      }

      widths[id] = itemWidth;
      heights[id] = itemHeight;

      if (!maxWidth || itemWidth >= maxWidth) {
        maxWidth = itemWidth;
      }

      if (!maxHeight || itemHeight >= maxHeight) {
        maxHeight = itemHeight;
      }

      maxLength = $$.isLegendRight || $$.isLegendInset ? maxHeight : maxWidth;

      if (config.legend_equally) {
        Object.keys(widths).forEach(function (id) {
          widths[id] = maxWidth;
        });
        Object.keys(heights).forEach(function (id) {
          heights[id] = maxHeight;
        });
        margin = (areaLength - maxLength * targetIds.length) / 2;

        if (margin < posMin) {
          totalLength = 0;
          step = 0;
          targetIds.forEach(function (id) {
            updateValues(id);
          });
        } else {
          updateValues(id, true);
        }
      } else {
        updateValues(id);
      }
    }

    if ($$.isLegendInset) {
      step = config.legend_inset_step ? config.legend_inset_step : targetIds.length;
      $$.updateLegendStep(step);
    }

    if ($$.isLegendRight) {
      xForLegend = function xForLegend(id) {
        return maxWidth * steps[id];
      };

      yForLegend = function yForLegend(id) {
        return margins[steps[id]] + offsets[id];
      };
    } else if ($$.isLegendInset) {
      xForLegend = function xForLegend(id) {
        return maxWidth * steps[id] + 10;
      };

      yForLegend = function yForLegend(id) {
        return margins[steps[id]] + offsets[id];
      };
    } else {
      xForLegend = function xForLegend(id) {
        return margins[steps[id]] + offsets[id];
      };

      yForLegend = function yForLegend(id) {
        return maxHeight * steps[id];
      };
    }

    xForLegendText = function xForLegendText(id, i) {
      return xForLegend(id, i) + 4 + config.legend_item_tile_width;
    };

    yForLegendText = function yForLegendText(id, i) {
      return yForLegend(id, i) + 9;
    };

    xForLegendRect = function xForLegendRect(id, i) {
      return xForLegend(id, i);
    };

    yForLegendRect = function yForLegendRect(id, i) {
      return yForLegend(id, i) - 5;
    };

    x1ForLegendTile = function x1ForLegendTile(id, i) {
      return xForLegend(id, i) - 2;
    };

    x2ForLegendTile = function x2ForLegendTile(id, i) {
      return xForLegend(id, i) - 2 + config.legend_item_tile_width;
    };

    yForLegendTile = function yForLegendTile(id, i) {
      return yForLegend(id, i) + 4;
    }; // Define g for legend area


    l = $$.legend.selectAll('.' + CLASS.legendItem).data(targetIds).enter().append('g').attr('class', function (id) {
      return $$.generateClass(CLASS.legendItem, id);
    }).style('visibility', function (id) {
      return $$.isLegendToShow(id) ? 'visible' : 'hidden';
    }).style('cursor', 'pointer').on('click', function (id) {
      if (config.legend_item_onclick) {
        config.legend_item_onclick.call($$, id);
      } else {
        if ($$.d3.event.altKey) {
          $$.api.hide();
          $$.api.show(id);
        } else {
          $$.api.toggle(id);
          $$.isTargetToShow(id) ? $$.api.focus(id) : $$.api.revert();
        }
      }
    }).on('mouseover', function (id) {
      if (config.legend_item_onmouseover) {
        config.legend_item_onmouseover.call($$, id);
      } else {
        $$.d3.select(this).classed(CLASS.legendItemFocused, true);

        if (!$$.transiting && $$.isTargetToShow(id)) {
          $$.api.focus(id);
        }
      }
    }).on('mouseout', function (id) {
      if (config.legend_item_onmouseout) {
        config.legend_item_onmouseout.call($$, id);
      } else {
        $$.d3.select(this).classed(CLASS.legendItemFocused, false);
        $$.api.revert();
      }
    });
    l.append('text').text(function (id) {
      return isDefined(config.data_names[id]) ? config.data_names[id] : id;
    }).each(function (id, i) {
      updatePositions(this, id, i);
    }).style("pointer-events", "none").attr('x', $$.isLegendRight || $$.isLegendInset ? xForLegendText : -200).attr('y', $$.isLegendRight || $$.isLegendInset ? -200 : yForLegendText);
    l.append('rect').attr("class", CLASS.legendItemEvent).style('fill-opacity', 0).attr('x', $$.isLegendRight || $$.isLegendInset ? xForLegendRect : -200).attr('y', $$.isLegendRight || $$.isLegendInset ? -200 : yForLegendRect);
    l.append('line').attr('class', CLASS.legendItemTile).style('stroke', $$.color).style("pointer-events", "none").attr('x1', $$.isLegendRight || $$.isLegendInset ? x1ForLegendTile : -200).attr('y1', $$.isLegendRight || $$.isLegendInset ? -200 : yForLegendTile).attr('x2', $$.isLegendRight || $$.isLegendInset ? x2ForLegendTile : -200).attr('y2', $$.isLegendRight || $$.isLegendInset ? -200 : yForLegendTile).attr('stroke-width', config.legend_item_tile_height); // Set background for inset legend

    background = $$.legend.select('.' + CLASS.legendBackground + ' rect');

    if ($$.isLegendInset && maxWidth > 0 && background.size() === 0) {
      background = $$.legend.insert('g', '.' + CLASS.legendItem).attr("class", CLASS.legendBackground).append('rect');
    }

    texts = $$.legend.selectAll('text').data(targetIds).text(function (id) {
      return isDefined(config.data_names[id]) ? config.data_names[id] : id;
    }) // MEMO: needed for update
    .each(function (id, i) {
      updatePositions(this, id, i);
    });
    (withTransition ? texts.transition() : texts).attr('x', xForLegendText).attr('y', yForLegendText);
    rects = $$.legend.selectAll('rect.' + CLASS.legendItemEvent).data(targetIds);
    (withTransition ? rects.transition() : rects).attr('width', function (id) {
      return widths[id];
    }).attr('height', function (id) {
      return heights[id];
    }).attr('x', xForLegendRect).attr('y', yForLegendRect);
    tiles = $$.legend.selectAll('line.' + CLASS.legendItemTile).data(targetIds);
    (withTransition ? tiles.transition() : tiles).style('stroke', $$.levelColor ? function (id) {
      return $$.levelColor($$.cache[id].values[0].value);
    } : $$.color).attr('x1', x1ForLegendTile).attr('y1', yForLegendTile).attr('x2', x2ForLegendTile).attr('y2', yForLegendTile);

    if (background) {
      (withTransition ? background.transition() : background).attr('height', $$.getLegendHeight() - 12).attr('width', maxWidth * (step + 1) + 10);
    } // toggle legend state


    $$.legend.selectAll('.' + CLASS.legendItem).classed(CLASS.legendItemHidden, function (id) {
      return !$$.isTargetToShow(id);
    }); // Update all to reflect change of legend

    $$.updateLegendItemWidth(maxWidth);
    $$.updateLegendItemHeight(maxHeight);
    $$.updateLegendStep(step); // Update size and scale

    $$.updateSizes();
    $$.updateScales();
    $$.updateSvgSize(); // Update g positions

    $$.transformAll(withTransitionForTransform, transitions);
    $$.legendHasRendered = true;
  };

  ChartInternal.prototype.initRegion = function () {
    var $$ = this;
    $$.region = $$.main.append('g').attr("clip-path", $$.clipPath).attr("class", CLASS.regions);
  };

  ChartInternal.prototype.updateRegion = function (duration) {
    var $$ = this,
        config = $$.config; // hide if arc type

    $$.region.style('visibility', $$.hasArcType() ? 'hidden' : 'visible');
    var mainRegion = $$.main.select('.' + CLASS.regions).selectAll('.' + CLASS.region).data(config.regions);
    var mainRegionEnter = mainRegion.enter().append('rect').attr("x", $$.regionX.bind($$)).attr("y", $$.regionY.bind($$)).attr("width", $$.regionWidth.bind($$)).attr("height", $$.regionHeight.bind($$)).style("fill-opacity", 0);
    $$.mainRegion = mainRegionEnter.merge(mainRegion).attr('class', $$.classRegion.bind($$));
    mainRegion.exit().transition().duration(duration).style("opacity", 0).remove();
  };

  ChartInternal.prototype.redrawRegion = function (withTransition, transition) {
    var $$ = this,
        regions = $$.mainRegion;
    return [(withTransition ? regions.transition(transition) : regions).attr("x", $$.regionX.bind($$)).attr("y", $$.regionY.bind($$)).attr("width", $$.regionWidth.bind($$)).attr("height", $$.regionHeight.bind($$)).style("fill-opacity", function (d) {
      return isValue(d.opacity) ? d.opacity : 0.1;
    })];
  };

  ChartInternal.prototype.regionX = function (d) {
    var $$ = this,
        config = $$.config,
        xPos,
        yScale = d.axis === 'y' ? $$.y : $$.y2;

    if (d.axis === 'y' || d.axis === 'y2') {
      xPos = config.axis_rotated ? 'start' in d ? yScale(d.start) : 0 : 0;
    } else {
      xPos = config.axis_rotated ? 0 : 'start' in d ? $$.x($$.isTimeSeries() ? $$.parseDate(d.start) : d.start) : 0;
    }

    return xPos;
  };

  ChartInternal.prototype.regionY = function (d) {
    var $$ = this,
        config = $$.config,
        yPos,
        yScale = d.axis === 'y' ? $$.y : $$.y2;

    if (d.axis === 'y' || d.axis === 'y2') {
      yPos = config.axis_rotated ? 0 : 'end' in d ? yScale(d.end) : 0;
    } else {
      yPos = config.axis_rotated ? 'start' in d ? $$.x($$.isTimeSeries() ? $$.parseDate(d.start) : d.start) : 0 : 0;
    }

    return yPos;
  };

  ChartInternal.prototype.regionWidth = function (d) {
    var $$ = this,
        config = $$.config,
        start = $$.regionX(d),
        end,
        yScale = d.axis === 'y' ? $$.y : $$.y2;

    if (d.axis === 'y' || d.axis === 'y2') {
      end = config.axis_rotated ? 'end' in d ? yScale(d.end) : $$.width : $$.width;
    } else {
      end = config.axis_rotated ? $$.width : 'end' in d ? $$.x($$.isTimeSeries() ? $$.parseDate(d.end) : d.end) : $$.width;
    }

    return end < start ? 0 : end - start;
  };

  ChartInternal.prototype.regionHeight = function (d) {
    var $$ = this,
        config = $$.config,
        start = this.regionY(d),
        end,
        yScale = d.axis === 'y' ? $$.y : $$.y2;

    if (d.axis === 'y' || d.axis === 'y2') {
      end = config.axis_rotated ? $$.height : 'start' in d ? yScale(d.start) : $$.height;
    } else {
      end = config.axis_rotated ? 'end' in d ? $$.x($$.isTimeSeries() ? $$.parseDate(d.end) : d.end) : $$.height : $$.height;
    }

    return end < start ? 0 : end - start;
  };

  ChartInternal.prototype.isRegionOnX = function (d) {
    return !d.axis || d.axis === 'x';
  };

  ChartInternal.prototype.getScale = function (min, max, forTimeseries) {
    return (forTimeseries ? this.d3.scaleTime() : this.d3.scaleLinear()).range([min, max]);
  };

  ChartInternal.prototype.getX = function (min, max, domain, offset) {
    var $$ = this,
        scale = $$.getScale(min, max, $$.isTimeSeries()),
        _scale = domain ? scale.domain(domain) : scale,
        key; // Define customized scale if categorized axis


    if ($$.isCategorized()) {
      offset = offset || function () {
        return 0;
      };

      scale = function scale(d, raw) {
        var v = _scale(d) + offset(d);
        return raw ? v : Math.ceil(v);
      };
    } else {
      scale = function scale(d, raw) {
        var v = _scale(d);

        return raw ? v : Math.ceil(v);
      };
    } // define functions


    for (key in _scale) {
      scale[key] = _scale[key];
    }

    scale.orgDomain = function () {
      return _scale.domain();
    }; // define custom domain() for categorized axis


    if ($$.isCategorized()) {
      scale.domain = function (domain) {
        if (!arguments.length) {
          domain = this.orgDomain();
          return [domain[0], domain[1] + 1];
        }

        _scale.domain(domain);

        return scale;
      };
    }

    return scale;
  };

  ChartInternal.prototype.getY = function (min, max, domain) {
    var scale = this.getScale(min, max, this.isTimeSeriesY());

    if (domain) {
      scale.domain(domain);
    }

    return scale;
  };

  ChartInternal.prototype.getYScale = function (id) {
    return this.axis.getId(id) === 'y2' ? this.y2 : this.y;
  };

  ChartInternal.prototype.getSubYScale = function (id) {
    return this.axis.getId(id) === 'y2' ? this.subY2 : this.subY;
  };

  ChartInternal.prototype.updateScales = function () {
    var $$ = this,
        config = $$.config,
        forInit = !$$.x; // update edges

    $$.xMin = config.axis_rotated ? 1 : 0;
    $$.xMax = config.axis_rotated ? $$.height : $$.width;
    $$.yMin = config.axis_rotated ? 0 : $$.height;
    $$.yMax = config.axis_rotated ? $$.width : 1;
    $$.subXMin = $$.xMin;
    $$.subXMax = $$.xMax;
    $$.subYMin = config.axis_rotated ? 0 : $$.height2;
    $$.subYMax = config.axis_rotated ? $$.width2 : 1; // update scales

    $$.x = $$.getX($$.xMin, $$.xMax, forInit ? undefined : $$.x.orgDomain(), function () {
      return $$.xAxis.tickOffset();
    });
    $$.y = $$.getY($$.yMin, $$.yMax, forInit ? config.axis_y_default : $$.y.domain());
    $$.y2 = $$.getY($$.yMin, $$.yMax, forInit ? config.axis_y2_default : $$.y2.domain());
    $$.subX = $$.getX($$.xMin, $$.xMax, $$.orgXDomain, function (d) {
      return d % 1 ? 0 : $$.subXAxis.tickOffset();
    });
    $$.subY = $$.getY($$.subYMin, $$.subYMax, forInit ? config.axis_y_default : $$.subY.domain());
    $$.subY2 = $$.getY($$.subYMin, $$.subYMax, forInit ? config.axis_y2_default : $$.subY2.domain()); // update axes

    $$.xAxisTickFormat = $$.axis.getXAxisTickFormat();
    $$.xAxisTickValues = $$.axis.getXAxisTickValues();
    $$.yAxisTickValues = $$.axis.getYAxisTickValues();
    $$.y2AxisTickValues = $$.axis.getY2AxisTickValues();
    $$.xAxis = $$.axis.getXAxis($$.x, $$.xOrient, $$.xAxisTickFormat, $$.xAxisTickValues, config.axis_x_tick_outer);
    $$.subXAxis = $$.axis.getXAxis($$.subX, $$.subXOrient, $$.xAxisTickFormat, $$.xAxisTickValues, config.axis_x_tick_outer);
    $$.yAxis = $$.axis.getYAxis($$.y, $$.yOrient, config.axis_y_tick_format, $$.yAxisTickValues, config.axis_y_tick_outer);
    $$.y2Axis = $$.axis.getYAxis($$.y2, $$.y2Orient, config.axis_y2_tick_format, $$.y2AxisTickValues, config.axis_y2_tick_outer); // Set initialized scales to brush and zoom

    if (!forInit) {
      if ($$.brush) {
        $$.brush.updateScale($$.subX);
      }
    } // update for arc


    if ($$.updateArc) {
      $$.updateArc();
    }
  };

  ChartInternal.prototype.selectPoint = function (target, d, i) {
    var $$ = this,
        config = $$.config,
        cx = (config.axis_rotated ? $$.circleY : $$.circleX).bind($$),
        cy = (config.axis_rotated ? $$.circleX : $$.circleY).bind($$),
        r = $$.pointSelectR.bind($$);
    config.data_onselected.call($$.api, d, target.node()); // add selected-circle on low layer g

    $$.main.select('.' + CLASS.selectedCircles + $$.getTargetSelectorSuffix(d.id)).selectAll('.' + CLASS.selectedCircle + '-' + i).data([d]).enter().append('circle').attr("class", function () {
      return $$.generateClass(CLASS.selectedCircle, i);
    }).attr("cx", cx).attr("cy", cy).attr("stroke", function () {
      return $$.color(d);
    }).attr("r", function (d) {
      return $$.pointSelectR(d) * 1.4;
    }).transition().duration(100).attr("r", r);
  };

  ChartInternal.prototype.unselectPoint = function (target, d, i) {
    var $$ = this;
    $$.config.data_onunselected.call($$.api, d, target.node()); // remove selected-circle from low layer g

    $$.main.select('.' + CLASS.selectedCircles + $$.getTargetSelectorSuffix(d.id)).selectAll('.' + CLASS.selectedCircle + '-' + i).transition().duration(100).attr('r', 0).remove();
  };

  ChartInternal.prototype.togglePoint = function (selected, target, d, i) {
    selected ? this.selectPoint(target, d, i) : this.unselectPoint(target, d, i);
  };

  ChartInternal.prototype.selectPath = function (target, d) {
    var $$ = this;
    $$.config.data_onselected.call($$, d, target.node());

    if ($$.config.interaction_brighten) {
      target.transition().duration(100).style("fill", function () {
        return $$.d3.rgb($$.color(d)).brighter(0.75);
      });
    }
  };

  ChartInternal.prototype.unselectPath = function (target, d) {
    var $$ = this;
    $$.config.data_onunselected.call($$, d, target.node());

    if ($$.config.interaction_brighten) {
      target.transition().duration(100).style("fill", function () {
        return $$.color(d);
      });
    }
  };

  ChartInternal.prototype.togglePath = function (selected, target, d, i) {
    selected ? this.selectPath(target, d, i) : this.unselectPath(target, d, i);
  };

  ChartInternal.prototype.getToggle = function (that, d) {
    var $$ = this,
        toggle;

    if (that.nodeName === 'circle') {
      if ($$.isStepType(d)) {
        // circle is hidden in step chart, so treat as within the click area
        toggle = function toggle() {}; // TODO: how to select step chart?

      } else {
        toggle = $$.togglePoint;
      }
    } else if (that.nodeName === 'path') {
      toggle = $$.togglePath;
    }

    return toggle;
  };

  ChartInternal.prototype.toggleShape = function (that, d, i) {
    var $$ = this,
        d3 = $$.d3,
        config = $$.config,
        shape = d3.select(that),
        isSelected = shape.classed(CLASS.SELECTED),
        toggle = $$.getToggle(that, d).bind($$);

    if (config.data_selection_enabled && config.data_selection_isselectable(d)) {
      if (!config.data_selection_multiple) {
        $$.main.selectAll('.' + CLASS.shapes + (config.data_selection_grouped ? $$.getTargetSelectorSuffix(d.id) : "")).selectAll('.' + CLASS.shape).each(function (d, i) {
          var shape = d3.select(this);

          if (shape.classed(CLASS.SELECTED)) {
            toggle(false, shape.classed(CLASS.SELECTED, false), d, i);
          }
        });
      }

      shape.classed(CLASS.SELECTED, !isSelected);
      toggle(!isSelected, shape, d, i);
    }
  };

  ChartInternal.prototype.initBar = function () {
    var $$ = this;
    $$.main.select('.' + CLASS.chart).append("g").attr("class", CLASS.chartBars);
  };

  ChartInternal.prototype.updateTargetsForBar = function (targets) {
    var $$ = this,
        config = $$.config,
        mainBars,
        mainBarEnter,
        classChartBar = $$.classChartBar.bind($$),
        classBars = $$.classBars.bind($$),
        classFocus = $$.classFocus.bind($$);
    mainBars = $$.main.select('.' + CLASS.chartBars).selectAll('.' + CLASS.chartBar).data(targets).attr('class', function (d) {
      return classChartBar(d) + classFocus(d);
    });
    mainBarEnter = mainBars.enter().append('g').attr('class', classChartBar).style("pointer-events", "none"); // Bars for each data

    mainBarEnter.append('g').attr("class", classBars).style("cursor", function (d) {
      return config.data_selection_isselectable(d) ? "pointer" : null;
    });
  };

  ChartInternal.prototype.updateBar = function (durationForExit) {
    var $$ = this,
        barData = $$.barData.bind($$),
        classBar = $$.classBar.bind($$),
        initialOpacity = $$.initialOpacity.bind($$),
        color = function color(d) {
      return $$.color(d.id);
    };

    var mainBar = $$.main.selectAll('.' + CLASS.bars).selectAll('.' + CLASS.bar).data(barData);
    var mainBarEnter = mainBar.enter().append('path').attr("class", classBar).style("stroke", color).style("fill", color);
    $$.mainBar = mainBarEnter.merge(mainBar).style("opacity", initialOpacity);
    mainBar.exit().transition().duration(durationForExit).style("opacity", 0);
  };

  ChartInternal.prototype.redrawBar = function (drawBar, withTransition, transition) {
    return [(withTransition ? this.mainBar.transition(transition) : this.mainBar).attr('d', drawBar).style("stroke", this.color).style("fill", this.color).style("opacity", 1)];
  };

  ChartInternal.prototype.getBarW = function (axis, barTargetsNum) {
    var $$ = this,
        config = $$.config,
        w = typeof config.bar_width === 'number' ? config.bar_width : barTargetsNum ? axis.tickInterval() * config.bar_width_ratio / barTargetsNum : 0;
    return config.bar_width_max && w > config.bar_width_max ? config.bar_width_max : w;
  };

  ChartInternal.prototype.getBars = function (i, id) {
    var $$ = this;
    return (id ? $$.main.selectAll('.' + CLASS.bars + $$.getTargetSelectorSuffix(id)) : $$.main).selectAll('.' + CLASS.bar + (isValue(i) ? '-' + i : ''));
  };

  ChartInternal.prototype.expandBars = function (i, id, reset) {
    var $$ = this;

    if (reset) {
      $$.unexpandBars();
    }

    $$.getBars(i, id).classed(CLASS.EXPANDED, true);
  };

  ChartInternal.prototype.unexpandBars = function (i) {
    var $$ = this;
    $$.getBars(i).classed(CLASS.EXPANDED, false);
  };

  ChartInternal.prototype.generateDrawBar = function (barIndices, isSub) {
    var $$ = this,
        config = $$.config,
        getPoints = $$.generateGetBarPoints(barIndices, isSub);
    return function (d, i) {
      // 4 points that make a bar
      var points = getPoints(d, i); // switch points if axis is rotated, not applicable for sub chart

      var indexX = config.axis_rotated ? 1 : 0;
      var indexY = config.axis_rotated ? 0 : 1;
      var path = 'M ' + points[0][indexX] + ',' + points[0][indexY] + ' ' + 'L' + points[1][indexX] + ',' + points[1][indexY] + ' ' + 'L' + points[2][indexX] + ',' + points[2][indexY] + ' ' + 'L' + points[3][indexX] + ',' + points[3][indexY] + ' ' + 'z';
      return path;
    };
  };

  ChartInternal.prototype.generateGetBarPoints = function (barIndices, isSub) {
    var $$ = this,
        axis = isSub ? $$.subXAxis : $$.xAxis,
        barTargetsNum = barIndices.__max__ + 1,
        barW = $$.getBarW(axis, barTargetsNum),
        barX = $$.getShapeX(barW, barTargetsNum, barIndices, !!isSub),
        barY = $$.getShapeY(!!isSub),
        barOffset = $$.getShapeOffset($$.isBarType, barIndices, !!isSub),
        barSpaceOffset = barW * ($$.config.bar_space / 2),
        yScale = isSub ? $$.getSubYScale : $$.getYScale;
    return function (d, i) {
      var y0 = yScale.call($$, d.id)(0),
          offset = barOffset(d, i) || y0,
          // offset is for stacked bar chart
      posX = barX(d),
          posY = barY(d); // fix posY not to overflow opposite quadrant

      if ($$.config.axis_rotated) {
        if (0 < d.value && posY < y0 || d.value < 0 && y0 < posY) {
          posY = y0;
        }
      } // 4 points that make a bar


      return [[posX + barSpaceOffset, offset], [posX + barSpaceOffset, posY - (y0 - offset)], [posX + barW - barSpaceOffset, posY - (y0 - offset)], [posX + barW - barSpaceOffset, offset]];
    };
  };

  ChartInternal.prototype.isWithinBar = function (mouse, that) {
    var box = that.getBoundingClientRect(),
        seg0 = that.pathSegList.getItem(0),
        seg1 = that.pathSegList.getItem(1),
        x = Math.min(seg0.x, seg1.x),
        y = Math.min(seg0.y, seg1.y),
        w = box.width,
        h = box.height,
        offset = 2,
        sx = x - offset,
        ex = x + w + offset,
        sy = y + h + offset,
        ey = y - offset;
    return sx < mouse[0] && mouse[0] < ex && ey < mouse[1] && mouse[1] < sy;
  };

  ChartInternal.prototype.getShapeIndices = function (typeFilter) {
    var $$ = this,
        config = $$.config,
        indices = {},
        i = 0,
        j,
        k;
    $$.filterTargetsToShow($$.data.targets.filter(typeFilter, $$)).forEach(function (d) {
      for (j = 0; j < config.data_groups.length; j++) {
        if (config.data_groups[j].indexOf(d.id) < 0) {
          continue;
        }

        for (k = 0; k < config.data_groups[j].length; k++) {
          if (config.data_groups[j][k] in indices) {
            indices[d.id] = indices[config.data_groups[j][k]];
            break;
          }
        }
      }

      if (isUndefined(indices[d.id])) {
        indices[d.id] = i++;
      }
    });
    indices.__max__ = i - 1;
    return indices;
  };

  ChartInternal.prototype.getShapeX = function (offset, targetsNum, indices, isSub) {
    var $$ = this,
        scale = isSub ? $$.subX : $$.x;
    return function (d) {
      var index = d.id in indices ? indices[d.id] : 0;
      return d.x || d.x === 0 ? scale(d.x) - offset * (targetsNum / 2 - index) : 0;
    };
  };

  ChartInternal.prototype.getShapeY = function (isSub) {
    var $$ = this;
    return function (d) {
      var scale = isSub ? $$.getSubYScale(d.id) : $$.getYScale(d.id);
      return scale(d.value);
    };
  };

  ChartInternal.prototype.getShapeOffset = function (typeFilter, indices, isSub) {
    var $$ = this,
        targets = $$.orderTargets($$.filterTargetsToShow($$.data.targets.filter(typeFilter, $$))),
        targetIds = targets.map(function (t) {
      return t.id;
    });
    return function (d, i) {
      var scale = isSub ? $$.getSubYScale(d.id) : $$.getYScale(d.id),
          y0 = scale(0),
          offset = y0;
      targets.forEach(function (t) {
        var values = $$.isStepType(d) ? $$.convertValuesToStep(t.values) : t.values;

        if (t.id === d.id || indices[t.id] !== indices[d.id]) {
          return;
        }

        if (targetIds.indexOf(t.id) < targetIds.indexOf(d.id)) {
          // check if the x values line up
          if (typeof values[i] === 'undefined' || +values[i].x !== +d.x) {
            // "+" for timeseries
            // if not, try to find the value that does line up
            i = -1;
            values.forEach(function (v, j) {
              if (v.x === d.x) {
                i = j;
              }
            });
          }

          if (i in values && values[i].value * d.value >= 0) {
            offset += scale(values[i].value) - y0;
          }
        }
      });
      return offset;
    };
  };

  ChartInternal.prototype.isWithinShape = function (that, d) {
    var $$ = this,
        shape = $$.d3.select(that),
        isWithin;

    if (!$$.isTargetToShow(d.id)) {
      isWithin = false;
    } else if (that.nodeName === 'circle') {
      isWithin = $$.isStepType(d) ? $$.isWithinStep(that, $$.getYScale(d.id)(d.value)) : $$.isWithinCircle(that, $$.pointSelectR(d) * 1.5);
    } else if (that.nodeName === 'path') {
      isWithin = shape.classed(CLASS.bar) ? $$.isWithinBar($$.d3.mouse(that), that) : true;
    }

    return isWithin;
  };

  ChartInternal.prototype.getInterpolate = function (d) {
    var $$ = this,
        d3 = $$.d3,
        types = {
      'linear': d3.curveLinear,
      'linear-closed': d3.curveLinearClosed,
      'basis': d3.curveBasis,
      'basis-open': d3.curveBasisOpen,
      'basis-closed': d3.curveBasisClosed,
      'bundle': d3.curveBundle,
      'cardinal': d3.curveCardinal,
      'cardinal-open': d3.curveCardinalOpen,
      'cardinal-closed': d3.curveCardinalClosed,
      'monotone': d3.curveMonotoneX,
      'step': d3.curveStep,
      'step-before': d3.curveStepBefore,
      'step-after': d3.curveStepAfter
    },
        type;

    if ($$.isSplineType(d)) {
      type = types[$$.config.spline_interpolation_type] || types.cardinal;
    } else if ($$.isStepType(d)) {
      type = types[$$.config.line_step_type];
    } else {
      type = types.linear;
    }

    return type;
  };

  ChartInternal.prototype.initLine = function () {
    var $$ = this;
    $$.main.select('.' + CLASS.chart).append("g").attr("class", CLASS.chartLines);
  };

  ChartInternal.prototype.updateTargetsForLine = function (targets) {
    var $$ = this,
        config = $$.config,
        mainLines,
        mainLineEnter,
        classChartLine = $$.classChartLine.bind($$),
        classLines = $$.classLines.bind($$),
        classAreas = $$.classAreas.bind($$),
        classCircles = $$.classCircles.bind($$),
        classFocus = $$.classFocus.bind($$);
    mainLines = $$.main.select('.' + CLASS.chartLines).selectAll('.' + CLASS.chartLine).data(targets).attr('class', function (d) {
      return classChartLine(d) + classFocus(d);
    });
    mainLineEnter = mainLines.enter().append('g').attr('class', classChartLine).style('opacity', 0).style("pointer-events", "none"); // Lines for each data

    mainLineEnter.append('g').attr("class", classLines); // Areas

    mainLineEnter.append('g').attr('class', classAreas); // Circles for each data point on lines

    mainLineEnter.append('g').attr("class", function (d) {
      return $$.generateClass(CLASS.selectedCircles, d.id);
    });
    mainLineEnter.append('g').attr("class", classCircles).style("cursor", function (d) {
      return config.data_selection_isselectable(d) ? "pointer" : null;
    }); // Update date for selected circles

    targets.forEach(function (t) {
      $$.main.selectAll('.' + CLASS.selectedCircles + $$.getTargetSelectorSuffix(t.id)).selectAll('.' + CLASS.selectedCircle).each(function (d) {
        d.value = t.values[d.index].value;
      });
    }); // MEMO: can not keep same color...
    //mainLineUpdate.exit().remove();
  };

  ChartInternal.prototype.updateLine = function (durationForExit) {
    var $$ = this;
    var mainLine = $$.main.selectAll('.' + CLASS.lines).selectAll('.' + CLASS.line).data($$.lineData.bind($$));
    var mainLineEnter = mainLine.enter().append('path').attr('class', $$.classLine.bind($$)).style("stroke", $$.color);
    $$.mainLine = mainLineEnter.merge(mainLine).style("opacity", $$.initialOpacity.bind($$)).style('shape-rendering', function (d) {
      return $$.isStepType(d) ? 'crispEdges' : '';
    }).attr('transform', null);
    mainLine.exit().transition().duration(durationForExit).style('opacity', 0);
  };

  ChartInternal.prototype.redrawLine = function (drawLine, withTransition, transition) {
    return [(withTransition ? this.mainLine.transition(transition) : this.mainLine).attr("d", drawLine).style("stroke", this.color).style("opacity", 1)];
  };

  ChartInternal.prototype.generateDrawLine = function (lineIndices, isSub) {
    var $$ = this,
        config = $$.config,
        line = $$.d3.line(),
        getPoints = $$.generateGetLinePoints(lineIndices, isSub),
        yScaleGetter = isSub ? $$.getSubYScale : $$.getYScale,
        xValue = function xValue(d) {
      return (isSub ? $$.subxx : $$.xx).call($$, d);
    },
        yValue = function yValue(d, i) {
      return config.data_groups.length > 0 ? getPoints(d, i)[0][1] : yScaleGetter.call($$, d.id)(d.value);
    };

    line = config.axis_rotated ? line.x(yValue).y(xValue) : line.x(xValue).y(yValue);

    if (!config.line_connectNull) {
      line = line.defined(function (d) {
        return d.value != null;
      });
    }

    return function (d) {
      var values = config.line_connectNull ? $$.filterRemoveNull(d.values) : d.values,
          x = isSub ? $$.subX : $$.x,
          y = yScaleGetter.call($$, d.id),
          x0 = 0,
          y0 = 0,
          path;

      if ($$.isLineType(d)) {
        if (config.data_regions[d.id]) {
          path = $$.lineWithRegions(values, x, y, config.data_regions[d.id]);
        } else {
          if ($$.isStepType(d)) {
            values = $$.convertValuesToStep(values);
          }

          path = line.curve($$.getInterpolate(d))(values);
        }
      } else {
        if (values[0]) {
          x0 = x(values[0].x);
          y0 = y(values[0].value);
        }

        path = config.axis_rotated ? "M " + y0 + " " + x0 : "M " + x0 + " " + y0;
      }

      return path ? path : "M 0 0";
    };
  };

  ChartInternal.prototype.generateGetLinePoints = function (lineIndices, isSub) {
    // partial duplication of generateGetBarPoints
    var $$ = this,
        config = $$.config,
        lineTargetsNum = lineIndices.__max__ + 1,
        x = $$.getShapeX(0, lineTargetsNum, lineIndices, !!isSub),
        y = $$.getShapeY(!!isSub),
        lineOffset = $$.getShapeOffset($$.isLineType, lineIndices, !!isSub),
        yScale = isSub ? $$.getSubYScale : $$.getYScale;
    return function (d, i) {
      var y0 = yScale.call($$, d.id)(0),
          offset = lineOffset(d, i) || y0,
          // offset is for stacked area chart
      posX = x(d),
          posY = y(d); // fix posY not to overflow opposite quadrant

      if (config.axis_rotated) {
        if (0 < d.value && posY < y0 || d.value < 0 && y0 < posY) {
          posY = y0;
        }
      } // 1 point that marks the line position


      return [[posX, posY - (y0 - offset)], [posX, posY - (y0 - offset)], // needed for compatibility
      [posX, posY - (y0 - offset)], // needed for compatibility
      [posX, posY - (y0 - offset)] // needed for compatibility
      ];
    };
  };

  ChartInternal.prototype.lineWithRegions = function (d, x, y, _regions) {
    var $$ = this,
        config = $$.config,
        prev = -1,
        i,
        j,
        s = "M",
        sWithRegion,
        xp,
        yp,
        dx,
        dy,
        dd,
        diff,
        diffx2,
        xOffset = $$.isCategorized() ? 0.5 : 0,
        xValue,
        yValue,
        regions = [];

    function isWithinRegions(x, regions) {
      var i;

      for (i = 0; i < regions.length; i++) {
        if (regions[i].start < x && x <= regions[i].end) {
          return true;
        }
      }

      return false;
    } // Check start/end of regions


    if (isDefined(_regions)) {
      for (i = 0; i < _regions.length; i++) {
        regions[i] = {};

        if (isUndefined(_regions[i].start)) {
          regions[i].start = d[0].x;
        } else {
          regions[i].start = $$.isTimeSeries() ? $$.parseDate(_regions[i].start) : _regions[i].start;
        }

        if (isUndefined(_regions[i].end)) {
          regions[i].end = d[d.length - 1].x;
        } else {
          regions[i].end = $$.isTimeSeries() ? $$.parseDate(_regions[i].end) : _regions[i].end;
        }
      }
    } // Set scales


    xValue = config.axis_rotated ? function (d) {
      return y(d.value);
    } : function (d) {
      return x(d.x);
    };
    yValue = config.axis_rotated ? function (d) {
      return x(d.x);
    } : function (d) {
      return y(d.value);
    }; // Define svg generator function for region

    function generateM(points) {
      return 'M' + points[0][0] + ' ' + points[0][1] + ' ' + points[1][0] + ' ' + points[1][1];
    }

    if ($$.isTimeSeries()) {
      sWithRegion = function sWithRegion(d0, d1, j, diff) {
        var x0 = d0.x.getTime(),
            x_diff = d1.x - d0.x,
            xv0 = new Date(x0 + x_diff * j),
            xv1 = new Date(x0 + x_diff * (j + diff)),
            points;

        if (config.axis_rotated) {
          points = [[y(yp(j)), x(xv0)], [y(yp(j + diff)), x(xv1)]];
        } else {
          points = [[x(xv0), y(yp(j))], [x(xv1), y(yp(j + diff))]];
        }

        return generateM(points);
      };
    } else {
      sWithRegion = function sWithRegion(d0, d1, j, diff) {
        var points;

        if (config.axis_rotated) {
          points = [[y(yp(j), true), x(xp(j))], [y(yp(j + diff), true), x(xp(j + diff))]];
        } else {
          points = [[x(xp(j), true), y(yp(j))], [x(xp(j + diff), true), y(yp(j + diff))]];
        }

        return generateM(points);
      };
    } // Generate


    for (i = 0; i < d.length; i++) {
      // Draw as normal
      if (isUndefined(regions) || !isWithinRegions(d[i].x, regions)) {
        s += " " + xValue(d[i]) + " " + yValue(d[i]);
      } // Draw with region // TODO: Fix for horizotal charts
      else {
          xp = $$.getScale(d[i - 1].x + xOffset, d[i].x + xOffset, $$.isTimeSeries());
          yp = $$.getScale(d[i - 1].value, d[i].value);
          dx = x(d[i].x) - x(d[i - 1].x);
          dy = y(d[i].value) - y(d[i - 1].value);
          dd = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2));
          diff = 2 / dd;
          diffx2 = diff * 2;

          for (j = diff; j <= 1; j += diffx2) {
            s += sWithRegion(d[i - 1], d[i], j, diff);
          }
        }

      prev = d[i].x;
    }

    return s;
  };

  ChartInternal.prototype.updateArea = function (durationForExit) {
    var $$ = this,
        d3 = $$.d3;
    var mainArea = $$.main.selectAll('.' + CLASS.areas).selectAll('.' + CLASS.area).data($$.lineData.bind($$));
    var mainAreaEnter = mainArea.enter().append('path').attr("class", $$.classArea.bind($$)).style("fill", $$.color).style("opacity", function () {
      $$.orgAreaOpacity = +d3.select(this).style('opacity');
      return 0;
    });
    $$.mainArea = mainAreaEnter.merge(mainArea).style("opacity", $$.orgAreaOpacity);
    mainArea.exit().transition().duration(durationForExit).style('opacity', 0);
  };

  ChartInternal.prototype.redrawArea = function (drawArea, withTransition, transition) {
    return [(withTransition ? this.mainArea.transition(transition) : this.mainArea).attr("d", drawArea).style("fill", this.color).style("opacity", this.orgAreaOpacity)];
  };

  ChartInternal.prototype.generateDrawArea = function (areaIndices, isSub) {
    var $$ = this,
        config = $$.config,
        area = $$.d3.area(),
        getPoints = $$.generateGetAreaPoints(areaIndices, isSub),
        yScaleGetter = isSub ? $$.getSubYScale : $$.getYScale,
        xValue = function xValue(d) {
      return (isSub ? $$.subxx : $$.xx).call($$, d);
    },
        value0 = function value0(d, i) {
      return config.data_groups.length > 0 ? getPoints(d, i)[0][1] : yScaleGetter.call($$, d.id)($$.getAreaBaseValue(d.id));
    },
        value1 = function value1(d, i) {
      return config.data_groups.length > 0 ? getPoints(d, i)[1][1] : yScaleGetter.call($$, d.id)(d.value);
    };

    area = config.axis_rotated ? area.x0(value0).x1(value1).y(xValue) : area.x(xValue).y0(config.area_above ? 0 : value0).y1(value1);

    if (!config.line_connectNull) {
      area = area.defined(function (d) {
        return d.value !== null;
      });
    }

    return function (d) {
      var values = config.line_connectNull ? $$.filterRemoveNull(d.values) : d.values,
          x0 = 0,
          y0 = 0,
          path;

      if ($$.isAreaType(d)) {
        if ($$.isStepType(d)) {
          values = $$.convertValuesToStep(values);
        }

        path = area.curve($$.getInterpolate(d))(values);
      } else {
        if (values[0]) {
          x0 = $$.x(values[0].x);
          y0 = $$.getYScale(d.id)(values[0].value);
        }

        path = config.axis_rotated ? "M " + y0 + " " + x0 : "M " + x0 + " " + y0;
      }

      return path ? path : "M 0 0";
    };
  };

  ChartInternal.prototype.getAreaBaseValue = function () {
    return 0;
  };

  ChartInternal.prototype.generateGetAreaPoints = function (areaIndices, isSub) {
    // partial duplication of generateGetBarPoints
    var $$ = this,
        config = $$.config,
        areaTargetsNum = areaIndices.__max__ + 1,
        x = $$.getShapeX(0, areaTargetsNum, areaIndices, !!isSub),
        y = $$.getShapeY(!!isSub),
        areaOffset = $$.getShapeOffset($$.isAreaType, areaIndices, !!isSub),
        yScale = isSub ? $$.getSubYScale : $$.getYScale;
    return function (d, i) {
      var y0 = yScale.call($$, d.id)(0),
          offset = areaOffset(d, i) || y0,
          // offset is for stacked area chart
      posX = x(d),
          posY = y(d); // fix posY not to overflow opposite quadrant

      if (config.axis_rotated) {
        if (0 < d.value && posY < y0 || d.value < 0 && y0 < posY) {
          posY = y0;
        }
      } // 1 point that marks the area position


      return [[posX, offset], [posX, posY - (y0 - offset)], [posX, posY - (y0 - offset)], // needed for compatibility
      [posX, offset] // needed for compatibility
      ];
    };
  };

  ChartInternal.prototype.updateCircle = function (cx, cy) {
    var $$ = this;
    var mainCircle = $$.main.selectAll('.' + CLASS.circles).selectAll('.' + CLASS.circle).data($$.lineOrScatterData.bind($$));
    var mainCircleEnter = mainCircle.enter().append("circle").attr("class", $$.classCircle.bind($$)).attr("cx", cx).attr("cy", cy).attr("r", $$.pointR.bind($$)).style("fill", $$.color);
    $$.mainCircle = mainCircleEnter.merge(mainCircle).style("opacity", $$.initialOpacityForCircle.bind($$));
    mainCircle.exit().style("opacity", 0);
  };

  ChartInternal.prototype.redrawCircle = function (cx, cy, withTransition, transition) {
    var $$ = this,
        selectedCircles = $$.main.selectAll('.' + CLASS.selectedCircle);
    return [(withTransition ? $$.mainCircle.transition(transition) : $$.mainCircle).style('opacity', this.opacityForCircle.bind($$)).style("fill", $$.color).attr("cx", cx).attr("cy", cy), (withTransition ? selectedCircles.transition(transition) : selectedCircles).attr("cx", cx).attr("cy", cy)];
  };

  ChartInternal.prototype.circleX = function (d) {
    return d.x || d.x === 0 ? this.x(d.x) : null;
  };

  ChartInternal.prototype.updateCircleY = function () {
    var $$ = this,
        lineIndices,
        getPoints;

    if ($$.config.data_groups.length > 0) {
      lineIndices = $$.getShapeIndices($$.isLineType), getPoints = $$.generateGetLinePoints(lineIndices);

      $$.circleY = function (d, i) {
        return getPoints(d, i)[0][1];
      };
    } else {
      $$.circleY = function (d) {
        return $$.getYScale(d.id)(d.value);
      };
    }
  };

  ChartInternal.prototype.getCircles = function (i, id) {
    var $$ = this;
    return (id ? $$.main.selectAll('.' + CLASS.circles + $$.getTargetSelectorSuffix(id)) : $$.main).selectAll('.' + CLASS.circle + (isValue(i) ? '-' + i : ''));
  };

  ChartInternal.prototype.expandCircles = function (i, id, reset) {
    var $$ = this,
        r = $$.pointExpandedR.bind($$);

    if (reset) {
      $$.unexpandCircles();
    }

    $$.getCircles(i, id).classed(CLASS.EXPANDED, true).attr('r', r);
  };

  ChartInternal.prototype.unexpandCircles = function (i) {
    var $$ = this,
        r = $$.pointR.bind($$);
    $$.getCircles(i).filter(function () {
      return $$.d3.select(this).classed(CLASS.EXPANDED);
    }).classed(CLASS.EXPANDED, false).attr('r', r);
  };

  ChartInternal.prototype.pointR = function (d) {
    var $$ = this,
        config = $$.config;
    return $$.isStepType(d) ? 0 : isFunction(config.point_r) ? config.point_r(d) : config.point_r;
  };

  ChartInternal.prototype.pointExpandedR = function (d) {
    var $$ = this,
        config = $$.config;

    if (config.point_focus_expand_enabled) {
      return isFunction(config.point_focus_expand_r) ? config.point_focus_expand_r(d) : config.point_focus_expand_r ? config.point_focus_expand_r : $$.pointR(d) * 1.75;
    } else {
      return $$.pointR(d);
    }
  };

  ChartInternal.prototype.pointSelectR = function (d) {
    var $$ = this,
        config = $$.config;
    return isFunction(config.point_select_r) ? config.point_select_r(d) : config.point_select_r ? config.point_select_r : $$.pointR(d) * 4;
  };

  ChartInternal.prototype.isWithinCircle = function (that, r) {
    var d3 = this.d3,
        mouse = d3.mouse(that),
        d3_this = d3.select(that),
        cx = +d3_this.attr("cx"),
        cy = +d3_this.attr("cy");
    return Math.sqrt(Math.pow(cx - mouse[0], 2) + Math.pow(cy - mouse[1], 2)) < r;
  };

  ChartInternal.prototype.isWithinStep = function (that, y) {
    return Math.abs(y - this.d3.mouse(that)[1]) < 30;
  };

  ChartInternal.prototype.getCurrentWidth = function () {
    var $$ = this,
        config = $$.config;
    return config.size_width ? config.size_width : $$.getParentWidth();
  };

  ChartInternal.prototype.getCurrentHeight = function () {
    var $$ = this,
        config = $$.config,
        h = config.size_height ? config.size_height : $$.getParentHeight();
    return h > 0 ? h : 320 / ($$.hasType('gauge') && !config.gauge_fullCircle ? 2 : 1);
  };

  ChartInternal.prototype.getCurrentPaddingTop = function () {
    var $$ = this,
        config = $$.config,
        padding = isValue(config.padding_top) ? config.padding_top : 0;

    if ($$.title && $$.title.node()) {
      padding += $$.getTitlePadding();
    }

    return padding;
  };

  ChartInternal.prototype.getCurrentPaddingBottom = function () {
    var config = this.config;
    return isValue(config.padding_bottom) ? config.padding_bottom : 0;
  };

  ChartInternal.prototype.getCurrentPaddingLeft = function (withoutRecompute) {
    var $$ = this,
        config = $$.config;

    if (isValue(config.padding_left)) {
      return config.padding_left;
    } else if (config.axis_rotated) {
      return !config.axis_x_show || config.axis_x_inner ? 1 : Math.max(ceil10($$.getAxisWidthByAxisId('x', withoutRecompute)), 40);
    } else if (!config.axis_y_show || config.axis_y_inner) {
      // && !config.axis_rotated
      return $$.axis.getYAxisLabelPosition().isOuter ? 30 : 1;
    } else {
      return ceil10($$.getAxisWidthByAxisId('y', withoutRecompute));
    }
  };

  ChartInternal.prototype.getCurrentPaddingRight = function () {
    var $$ = this,
        config = $$.config,
        defaultPadding = 10,
        legendWidthOnRight = $$.isLegendRight ? $$.getLegendWidth() + 20 : 0;

    if (isValue(config.padding_right)) {
      return config.padding_right + 1; // 1 is needed not to hide tick line
    } else if (config.axis_rotated) {
      return defaultPadding + legendWidthOnRight;
    } else if (!config.axis_y2_show || config.axis_y2_inner) {
      // && !config.axis_rotated
      return 2 + legendWidthOnRight + ($$.axis.getY2AxisLabelPosition().isOuter ? 20 : 0);
    } else {
      return ceil10($$.getAxisWidthByAxisId('y2')) + legendWidthOnRight;
    }
  };

  ChartInternal.prototype.getParentRectValue = function (key) {
    var parent = this.selectChart.node(),
        v;

    while (parent && parent.tagName !== 'BODY') {
      try {
        v = parent.getBoundingClientRect()[key];
      } catch (e) {
        if (key === 'width') {
          // In IE in certain cases getBoundingClientRect
          // will cause an "unspecified error"
          v = parent.offsetWidth;
        }
      }

      if (v) {
        break;
      }

      parent = parent.parentNode;
    }

    return v;
  };

  ChartInternal.prototype.getParentWidth = function () {
    return this.getParentRectValue('width');
  };

  ChartInternal.prototype.getParentHeight = function () {
    return this.getParentRectValue('height');
  };

  ChartInternal.prototype.getSvgLeft = function (withoutRecompute) {
    var $$ = this,
        config = $$.config,
        hasLeftAxisRect = config.axis_rotated || !config.axis_rotated && !config.axis_y_inner,
        leftAxisClass = config.axis_rotated ? CLASS.axisX : CLASS.axisY,
        leftAxis = $$.main.select('.' + leftAxisClass).node(),
        svgRect = leftAxis && hasLeftAxisRect ? leftAxis.getBoundingClientRect() : {
      right: 0
    },
        chartRect = $$.selectChart.node().getBoundingClientRect(),
        hasArc = $$.hasArcType(),
        svgLeft = svgRect.right - chartRect.left - (hasArc ? 0 : $$.getCurrentPaddingLeft(withoutRecompute));
    return svgLeft > 0 ? svgLeft : 0;
  };

  ChartInternal.prototype.getAxisWidthByAxisId = function (id, withoutRecompute) {
    var $$ = this,
        position = $$.axis.getLabelPositionById(id);
    return $$.axis.getMaxTickWidth(id, withoutRecompute) + (position.isInner ? 20 : 40);
  };

  ChartInternal.prototype.getHorizontalAxisHeight = function (axisId) {
    var $$ = this,
        config = $$.config,
        h = 30;

    if (axisId === 'x' && !config.axis_x_show) {
      return 8;
    }

    if (axisId === 'x' && config.axis_x_height) {
      return config.axis_x_height;
    }

    if (axisId === 'y' && !config.axis_y_show) {
      return config.legend_show && !$$.isLegendRight && !$$.isLegendInset ? 10 : 1;
    }

    if (axisId === 'y2' && !config.axis_y2_show) {
      return $$.rotated_padding_top;
    } // Calculate x axis height when tick rotated


    if (axisId === 'x' && !config.axis_rotated && config.axis_x_tick_rotate) {
      h = 30 + $$.axis.getMaxTickWidth(axisId) * Math.cos(Math.PI * (90 - Math.abs(config.axis_x_tick_rotate)) / 180);
    } // Calculate y axis height when tick rotated


    if (axisId === 'y' && config.axis_rotated && config.axis_y_tick_rotate) {
      h = 30 + $$.axis.getMaxTickWidth(axisId) * Math.cos(Math.PI * (90 - Math.abs(config.axis_y_tick_rotate)) / 180);
    }

    return h + ($$.axis.getLabelPositionById(axisId).isInner ? 0 : 10) + (axisId === 'y2' ? -10 : 0);
  };

  ChartInternal.prototype.initBrush = function (scale) {
    var $$ = this,
        d3 = $$.d3; // TODO: dynamically change brushY/brushX according to axis_rotated.

    $$.brush = ($$.config.axis_rotated ? d3.brushY() : d3.brushX()).on("brush", function () {
      var event = d3.event.sourceEvent;

      if (event && event.type === "zoom") {
        return;
      }

      $$.redrawForBrush();
    }).on("end", function () {
      var event = d3.event.sourceEvent;

      if (event && event.type === "zoom") {
        return;
      }

      if ($$.brush.empty() && event && event.type !== 'end') {
        $$.brush.clear();
      }
    });

    $$.brush.updateExtent = function () {
      var range = this.scale.range(),
          extent;

      if ($$.config.axis_rotated) {
        extent = [[0, range[0]], [$$.width2, range[1]]];
      } else {
        extent = [[range[0], 0], [range[1], $$.height2]];
      }

      this.extent(extent);
      return this;
    };

    $$.brush.updateScale = function (scale) {
      this.scale = scale;
      return this;
    };

    $$.brush.update = function (scale) {
      this.updateScale(scale || $$.subX).updateExtent();
      $$.context.select('.' + CLASS.brush).call(this);
    };

    $$.brush.clear = function () {
      $$.context.select('.' + CLASS.brush).call($$.brush.move, null);
    };

    $$.brush.selection = function () {
      return d3.brushSelection($$.context.select('.' + CLASS.brush).node());
    };

    $$.brush.selectionAsValue = function (selectionAsValue, withTransition) {
      var selection, brush;

      if (selectionAsValue) {
        if ($$.context) {
          selection = [this.scale(selectionAsValue[0]), this.scale(selectionAsValue[1])];
          brush = $$.context.select('.' + CLASS.brush);

          if (withTransition) {
            brush = brush.transition();
          }

          $$.brush.move(brush, selection);
        }

        return [];
      }

      selection = $$.brush.selection() || [0, 0];
      return [this.scale.invert(selection[0]), this.scale.invert(selection[1])];
    };

    $$.brush.empty = function () {
      var selection = $$.brush.selection();
      return !selection || selection[0] === selection[1];
    };

    return $$.brush.updateScale(scale);
  };

  ChartInternal.prototype.initSubchart = function () {
    var $$ = this,
        config = $$.config,
        context = $$.context = $$.svg.append("g").attr("transform", $$.getTranslate('context')),
        visibility = config.subchart_show ? 'visible' : 'hidden'; // set style

    context.style('visibility', visibility); // Define g for chart area

    context.append('g').attr("clip-path", $$.clipPathForSubchart).attr('class', CLASS.chart); // Define g for bar chart area

    context.select('.' + CLASS.chart).append("g").attr("class", CLASS.chartBars); // Define g for line chart area

    context.select('.' + CLASS.chart).append("g").attr("class", CLASS.chartLines); // Add extent rect for Brush

    context.append("g").attr("clip-path", $$.clipPath).attr("class", CLASS.brush); // ATTENTION: This must be called AFTER chart added
    // Add Axis

    $$.axes.subx = context.append("g").attr("class", CLASS.axisX).attr("transform", $$.getTranslate('subx')).attr("clip-path", config.axis_rotated ? "" : $$.clipPathForXAxis);
  };

  ChartInternal.prototype.initSubchartBrush = function () {
    var $$ = this; // Add extent rect for Brush

    $$.initBrush($$.subX).updateExtent();
    $$.context.select('.' + CLASS.brush).call($$.brush);
  };

  ChartInternal.prototype.updateTargetsForSubchart = function (targets) {
    var $$ = this,
        context = $$.context,
        config = $$.config,
        contextLineEnter,
        contextLine,
        contextBarEnter,
        contextBar,
        classChartBar = $$.classChartBar.bind($$),
        classBars = $$.classBars.bind($$),
        classChartLine = $$.classChartLine.bind($$),
        classLines = $$.classLines.bind($$),
        classAreas = $$.classAreas.bind($$);

    if (config.subchart_show) {
      //-- Bar --//
      contextBar = context.select('.' + CLASS.chartBars).selectAll('.' + CLASS.chartBar).data(targets);
      contextBarEnter = contextBar.enter().append('g').style('opacity', 0);
      contextBarEnter.merge(contextBar).attr('class', classChartBar); // Bars for each data

      contextBarEnter.append('g').attr("class", classBars); //-- Line --//

      contextLine = context.select('.' + CLASS.chartLines).selectAll('.' + CLASS.chartLine).data(targets);
      contextLineEnter = contextLine.enter().append('g').style('opacity', 0);
      contextLineEnter.merge(contextLine).attr('class', classChartLine); // Lines for each data

      contextLineEnter.append("g").attr("class", classLines); // Area

      contextLineEnter.append("g").attr("class", classAreas); //-- Brush --//

      context.selectAll('.' + CLASS.brush + ' rect').attr(config.axis_rotated ? "width" : "height", config.axis_rotated ? $$.width2 : $$.height2);
    }
  };

  ChartInternal.prototype.updateBarForSubchart = function (durationForExit) {
    var $$ = this;
    var contextBar = $$.context.selectAll('.' + CLASS.bars).selectAll('.' + CLASS.bar).data($$.barData.bind($$));
    var contextBarEnter = contextBar.enter().append('path').attr("class", $$.classBar.bind($$)).style("stroke", 'none').style("fill", $$.color);
    contextBar.exit().transition().duration(durationForExit).style('opacity', 0).remove();
    $$.contextBar = contextBarEnter.merge(contextBar).style("opacity", $$.initialOpacity.bind($$));
  };

  ChartInternal.prototype.redrawBarForSubchart = function (drawBarOnSub, withTransition, duration) {
    (withTransition ? this.contextBar.transition(Math.random().toString()).duration(duration) : this.contextBar).attr('d', drawBarOnSub).style('opacity', 1);
  };

  ChartInternal.prototype.updateLineForSubchart = function (durationForExit) {
    var $$ = this;
    var contextLine = $$.context.selectAll('.' + CLASS.lines).selectAll('.' + CLASS.line).data($$.lineData.bind($$));
    var contextLineEnter = contextLine.enter().append('path').attr('class', $$.classLine.bind($$)).style('stroke', $$.color);
    contextLine.exit().transition().duration(durationForExit).style('opacity', 0).remove();
    $$.contextLine = contextLineEnter.merge(contextLine).style("opacity", $$.initialOpacity.bind($$));
  };

  ChartInternal.prototype.redrawLineForSubchart = function (drawLineOnSub, withTransition, duration) {
    (withTransition ? this.contextLine.transition(Math.random().toString()).duration(duration) : this.contextLine).attr("d", drawLineOnSub).style('opacity', 1);
  };

  ChartInternal.prototype.updateAreaForSubchart = function (durationForExit) {
    var $$ = this,
        d3 = $$.d3;
    var contextArea = $$.context.selectAll('.' + CLASS.areas).selectAll('.' + CLASS.area).data($$.lineData.bind($$));
    var contextAreaEnter = contextArea.enter().append('path').attr("class", $$.classArea.bind($$)).style("fill", $$.color).style("opacity", function () {
      $$.orgAreaOpacity = +d3.select(this).style('opacity');
      return 0;
    });
    contextArea.exit().transition().duration(durationForExit).style('opacity', 0).remove();
    $$.contextArea = contextAreaEnter.merge(contextArea).style("opacity", 0);
  };

  ChartInternal.prototype.redrawAreaForSubchart = function (drawAreaOnSub, withTransition, duration) {
    (withTransition ? this.contextArea.transition(Math.random().toString()).duration(duration) : this.contextArea).attr("d", drawAreaOnSub).style("fill", this.color).style("opacity", this.orgAreaOpacity);
  };

  ChartInternal.prototype.redrawSubchart = function (withSubchart, transitions, duration, durationForExit, areaIndices, barIndices, lineIndices) {
    var $$ = this,
        d3 = $$.d3,
        config = $$.config,
        drawAreaOnSub,
        drawBarOnSub,
        drawLineOnSub;
    $$.context.style('visibility', config.subchart_show ? 'visible' : 'hidden'); // subchart

    if (config.subchart_show) {
      // reflect main chart to extent on subchart if zoomed
      if (d3.event && d3.event.type === 'zoom') {
        $$.brush.selectionAsValue($$.x.orgDomain());
      } // update subchart elements if needed


      if (withSubchart) {
        // extent rect
        if (!$$.brush.empty()) {
          $$.brush.selectionAsValue($$.x.orgDomain());
        } // setup drawer - MEMO: this must be called after axis updated


        drawAreaOnSub = $$.generateDrawArea(areaIndices, true);
        drawBarOnSub = $$.generateDrawBar(barIndices, true);
        drawLineOnSub = $$.generateDrawLine(lineIndices, true);
        $$.updateBarForSubchart(duration);
        $$.updateLineForSubchart(duration);
        $$.updateAreaForSubchart(duration);
        $$.redrawBarForSubchart(drawBarOnSub, duration, duration);
        $$.redrawLineForSubchart(drawLineOnSub, duration, duration);
        $$.redrawAreaForSubchart(drawAreaOnSub, duration, duration);
      }
    }
  };

  ChartInternal.prototype.redrawForBrush = function () {
    var $$ = this,
        x = $$.x,
        d3 = $$.d3,
        s;
    $$.redraw({
      withTransition: false,
      withY: $$.config.zoom_rescale,
      withSubchart: false,
      withUpdateXDomain: true,
      withEventRect: false,
      withDimension: false
    }); // update zoom transation binded to event rect

    s = d3.event.selection || $$.brush.scale.range();
    $$.main.select('.' + CLASS.eventRect).call($$.zoom.transform, d3.zoomIdentity.scale($$.width / (s[1] - s[0])).translate(-s[0], 0));
    $$.config.subchart_onbrush.call($$.api, x.orgDomain());
  };

  ChartInternal.prototype.transformContext = function (withTransition, transitions) {
    var $$ = this,
        subXAxis;

    if (transitions && transitions.axisSubX) {
      subXAxis = transitions.axisSubX;
    } else {
      subXAxis = $$.context.select('.' + CLASS.axisX);

      if (withTransition) {
        subXAxis = subXAxis.transition();
      }
    }

    $$.context.attr("transform", $$.getTranslate('context'));
    subXAxis.attr("transform", $$.getTranslate('subx'));
  };

  ChartInternal.prototype.getDefaultSelection = function () {
    var $$ = this,
        config = $$.config,
        selection = isFunction(config.axis_x_selection) ? config.axis_x_selection($$.getXDomain($$.data.targets)) : config.axis_x_selection;

    if ($$.isTimeSeries()) {
      selection = [$$.parseDate(selection[0]), $$.parseDate(selection[1])];
    }

    return selection;
  };

  ChartInternal.prototype.initText = function () {
    var $$ = this;
    $$.main.select('.' + CLASS.chart).append("g").attr("class", CLASS.chartTexts);
    $$.mainText = $$.d3.selectAll([]);
  };

  ChartInternal.prototype.updateTargetsForText = function (targets) {
    var $$ = this,
        classChartText = $$.classChartText.bind($$),
        classTexts = $$.classTexts.bind($$),
        classFocus = $$.classFocus.bind($$);
    var mainText = $$.main.select('.' + CLASS.chartTexts).selectAll('.' + CLASS.chartText).data(targets);
    var mainTextEnter = mainText.enter().append('g').attr('class', classChartText).style('opacity', 0).style("pointer-events", "none");
    mainTextEnter.append('g').attr('class', classTexts);
    mainTextEnter.merge(mainText).attr('class', function (d) {
      return classChartText(d) + classFocus(d);
    });
  };

  ChartInternal.prototype.updateText = function (xForText, yForText, durationForExit) {
    var $$ = this,
        config = $$.config,
        barOrLineData = $$.barOrLineData.bind($$),
        classText = $$.classText.bind($$);
    var mainText = $$.main.selectAll('.' + CLASS.texts).selectAll('.' + CLASS.text).data(barOrLineData);
    var mainTextEnter = mainText.enter().append('text').attr("class", classText).attr('text-anchor', function (d) {
      return config.axis_rotated ? d.value < 0 ? 'end' : 'start' : 'middle';
    }).style("stroke", 'none').attr('x', xForText).attr('y', yForText).style("fill", function (d) {
      return $$.color(d);
    }).style("fill-opacity", 0);
    $$.mainText = mainTextEnter.merge(mainText).text(function (d, i, j) {
      return $$.dataLabelFormat(d.id)(d.value, d.id, i, j);
    });
    mainText.exit().transition().duration(durationForExit).style('fill-opacity', 0).remove();
  };

  ChartInternal.prototype.redrawText = function (xForText, yForText, forFlow, withTransition, transition) {
    return [(withTransition ? this.mainText.transition(transition) : this.mainText).attr('x', xForText).attr('y', yForText).style("fill", this.color).style("fill-opacity", forFlow ? 0 : this.opacityForText.bind(this))];
  };

  ChartInternal.prototype.getTextRect = function (text, cls, element) {
    var dummy = this.d3.select('body').append('div').classed('c3', true),
        svg = dummy.append("svg").style('visibility', 'hidden').style('position', 'fixed').style('top', 0).style('left', 0),
        font = this.d3.select(element).style('font'),
        rect;
    svg.selectAll('.dummy').data([text]).enter().append('text').classed(cls ? cls : "", true).style('font', font).text(text).each(function () {
      rect = this.getBoundingClientRect();
    });
    dummy.remove();
    return rect;
  };

  ChartInternal.prototype.generateXYForText = function (areaIndices, barIndices, lineIndices, forX) {
    var $$ = this,
        getAreaPoints = $$.generateGetAreaPoints(areaIndices, false),
        getBarPoints = $$.generateGetBarPoints(barIndices, false),
        getLinePoints = $$.generateGetLinePoints(lineIndices, false),
        getter = forX ? $$.getXForText : $$.getYForText;
    return function (d, i) {
      var getPoints = $$.isAreaType(d) ? getAreaPoints : $$.isBarType(d) ? getBarPoints : getLinePoints;
      return getter.call($$, getPoints(d, i), d, this);
    };
  };

  ChartInternal.prototype.getXForText = function (points, d, textElement) {
    var $$ = this,
        box = textElement.getBoundingClientRect(),
        xPos,
        padding;

    if ($$.config.axis_rotated) {
      padding = $$.isBarType(d) ? 4 : 6;
      xPos = points[2][1] + padding * (d.value < 0 ? -1 : 1);
    } else {
      xPos = $$.hasType('bar') ? (points[2][0] + points[0][0]) / 2 : points[0][0];
    } // show labels regardless of the domain if value is null


    if (d.value === null) {
      if (xPos > $$.width) {
        xPos = $$.width - box.width;
      } else if (xPos < 0) {
        xPos = 4;
      }
    }

    return xPos;
  };

  ChartInternal.prototype.getYForText = function (points, d, textElement) {
    var $$ = this,
        box = textElement.getBoundingClientRect(),
        yPos;

    if ($$.config.axis_rotated) {
      yPos = (points[0][0] + points[2][0] + box.height * 0.6) / 2;
    } else {
      yPos = points[2][1];

      if (d.value < 0 || d.value === 0 && !$$.hasPositiveValue) {
        yPos += box.height;

        if ($$.isBarType(d) && $$.isSafari()) {
          yPos -= 3;
        } else if (!$$.isBarType(d) && $$.isChrome()) {
          yPos += 3;
        }
      } else {
        yPos += $$.isBarType(d) ? -3 : -6;
      }
    } // show labels regardless of the domain if value is null


    if (d.value === null && !$$.config.axis_rotated) {
      if (yPos < box.height) {
        yPos = box.height;
      } else if (yPos > this.height) {
        yPos = this.height - 4;
      }
    }

    return yPos;
  };

  ChartInternal.prototype.initTitle = function () {
    var $$ = this;
    $$.title = $$.svg.append("text").text($$.config.title_text).attr("class", $$.CLASS.title);
  };

  ChartInternal.prototype.redrawTitle = function () {
    var $$ = this;
    $$.title.attr("x", $$.xForTitle.bind($$)).attr("y", $$.yForTitle.bind($$));
  };

  ChartInternal.prototype.xForTitle = function () {
    var $$ = this,
        config = $$.config,
        position = config.title_position || 'left',
        x;

    if (position.indexOf('right') >= 0) {
      x = $$.currentWidth - $$.getTextRect($$.title.node().textContent, $$.CLASS.title, $$.title.node()).width - config.title_padding.right;
    } else if (position.indexOf('center') >= 0) {
      x = ($$.currentWidth - $$.getTextRect($$.title.node().textContent, $$.CLASS.title, $$.title.node()).width) / 2;
    } else {
      // left
      x = config.title_padding.left;
    }

    return x;
  };

  ChartInternal.prototype.yForTitle = function () {
    var $$ = this;
    return $$.config.title_padding.top + $$.getTextRect($$.title.node().textContent, $$.CLASS.title, $$.title.node()).height;
  };

  ChartInternal.prototype.getTitlePadding = function () {
    var $$ = this;
    return $$.yForTitle() + $$.config.title_padding.bottom;
  };

  ChartInternal.prototype.initTooltip = function () {
    var $$ = this,
        config = $$.config,
        i;
    $$.tooltip = $$.selectChart.style("position", "relative").append("div").attr('class', CLASS.tooltipContainer).style("position", "absolute").style("pointer-events", "none").style("display", "none"); // Show tooltip if needed

    if (config.tooltip_init_show) {
      if ($$.isTimeSeries() && isString(config.tooltip_init_x)) {
        config.tooltip_init_x = $$.parseDate(config.tooltip_init_x);

        for (i = 0; i < $$.data.targets[0].values.length; i++) {
          if ($$.data.targets[0].values[i].x - config.tooltip_init_x === 0) {
            break;
          }
        }

        config.tooltip_init_x = i;
      }

      $$.tooltip.html(config.tooltip_contents.call($$, $$.data.targets.map(function (d) {
        return $$.addName(d.values[config.tooltip_init_x]);
      }), $$.axis.getXAxisTickFormat(), $$.getYFormat($$.hasArcType()), $$.color));
      $$.tooltip.style("top", config.tooltip_init_position.top).style("left", config.tooltip_init_position.left).style("display", "block");
    }
  };

  ChartInternal.prototype.getTooltipSortFunction = function () {
    var $$ = this,
        config = $$.config;

    if (config.data_groups.length === 0 || config.tooltip_order !== undefined) {
      // if data are not grouped or if an order is specified
      // for the tooltip values we sort them by their values
      var order = config.tooltip_order;

      if (order === undefined) {
        order = config.data_order;
      }

      var valueOf = function valueOf(obj) {
        return obj ? obj.value : null;
      }; // if data are not grouped, we sort them by their value


      if (isString(order) && order.toLowerCase() === 'asc') {
        return function (a, b) {
          return valueOf(a) - valueOf(b);
        };
      } else if (isString(order) && order.toLowerCase() === 'desc') {
        return function (a, b) {
          return valueOf(b) - valueOf(a);
        };
      } else if (isFunction(order)) {
        // if the function is from data_order we need
        // to wrap the returned function in order to format
        // the sorted value to the expected format
        var sortFunction = order;

        if (config.tooltip_order === undefined) {
          sortFunction = function sortFunction(a, b) {
            return order(a ? {
              id: a.id,
              values: [a]
            } : null, b ? {
              id: b.id,
              values: [b]
            } : null);
          };
        }

        return sortFunction;
      } else if (isArray(order)) {
        return function (a, b) {
          return order.indexOf(a.id) - order.indexOf(b.id);
        };
      }
    } else {
      // if data are grouped, we follow the order of grouped targets
      var ids = $$.orderTargets($$.data.targets).map(function (i) {
        return i.id;
      }); // if it was either asc or desc we need to invert the order
      // returned by orderTargets

      if ($$.isOrderAsc() || $$.isOrderDesc()) {
        ids = ids.reverse();
      }

      return function (a, b) {
        return ids.indexOf(a.id) - ids.indexOf(b.id);
      };
    }
  };

  ChartInternal.prototype.getTooltipContent = function (d, defaultTitleFormat, defaultValueFormat, color) {
    var $$ = this,
        config = $$.config,
        titleFormat = config.tooltip_format_title || defaultTitleFormat,
        nameFormat = config.tooltip_format_name || function (name) {
      return name;
    },
        valueFormat = config.tooltip_format_value || defaultValueFormat,
        text,
        i,
        title,
        value,
        name,
        bgcolor;

    var tooltipSortFunction = this.getTooltipSortFunction();

    if (tooltipSortFunction) {
      d.sort(tooltipSortFunction);
    }

    for (i = 0; i < d.length; i++) {
      if (!(d[i] && (d[i].value || d[i].value === 0))) {
        continue;
      }

      if (!text) {
        title = sanitise(titleFormat ? titleFormat(d[i].x, d[i].index) : d[i].x);
        text = "<table class='" + $$.CLASS.tooltip + "'>" + (title || title === 0 ? "<tr><th colspan='2'>" + title + "</th></tr>" : "");
      }

      value = sanitise(valueFormat(d[i].value, d[i].ratio, d[i].id, d[i].index, d));

      if (value !== undefined) {
        // Skip elements when their name is set to null
        if (d[i].name === null) {
          continue;
        }

        name = sanitise(nameFormat(d[i].name, d[i].ratio, d[i].id, d[i].index));
        bgcolor = $$.levelColor ? $$.levelColor(d[i].value) : color(d[i].id);
        text += "<tr class='" + $$.CLASS.tooltipName + "-" + $$.getTargetSelectorSuffix(d[i].id) + "'>";
        text += "<td class='name'><span style='background-color:" + bgcolor + "'></span>" + name + "</td>";
        text += "<td class='value'>" + value + "</td>";
        text += "</tr>";
      }
    }

    return text + "</table>";
  };

  ChartInternal.prototype.tooltipPosition = function (dataToShow, tWidth, tHeight, element) {
    var $$ = this,
        config = $$.config,
        d3 = $$.d3;
    var svgLeft, tooltipLeft, tooltipRight, tooltipTop, chartRight;
    var forArc = $$.hasArcType(),
        mouse = d3.mouse(element); // Determin tooltip position

    if (forArc) {
      tooltipLeft = ($$.width - ($$.isLegendRight ? $$.getLegendWidth() : 0)) / 2 + mouse[0];
      tooltipTop = ($$.hasType('gauge') ? $$.height : $$.height / 2) + mouse[1] + 20;
    } else {
      svgLeft = $$.getSvgLeft(true);

      if (config.axis_rotated) {
        tooltipLeft = svgLeft + mouse[0] + 100;
        tooltipRight = tooltipLeft + tWidth;
        chartRight = $$.currentWidth - $$.getCurrentPaddingRight();
        tooltipTop = $$.x(dataToShow[0].x) + 20;
      } else {
        tooltipLeft = svgLeft + $$.getCurrentPaddingLeft(true) + $$.x(dataToShow[0].x) + 20;
        tooltipRight = tooltipLeft + tWidth;
        chartRight = svgLeft + $$.currentWidth - $$.getCurrentPaddingRight();
        tooltipTop = mouse[1] + 15;
      }

      if (tooltipRight > chartRight) {
        // 20 is needed for Firefox to keep tooltip width
        tooltipLeft -= tooltipRight - chartRight + 20;
      }

      if (tooltipTop + tHeight > $$.currentHeight) {
        tooltipTop -= tHeight + 30;
      }
    }

    if (tooltipTop < 0) {
      tooltipTop = 0;
    }

    return {
      top: tooltipTop,
      left: tooltipLeft
    };
  };

  ChartInternal.prototype.showTooltip = function (selectedData, element) {
    var $$ = this,
        config = $$.config;
    var tWidth, tHeight, position;
    var forArc = $$.hasArcType(),
        dataToShow = selectedData.filter(function (d) {
      return d && isValue(d.value);
    }),
        positionFunction = config.tooltip_position || ChartInternal.prototype.tooltipPosition;

    if (dataToShow.length === 0 || !config.tooltip_show) {
      return;
    }

    $$.tooltip.html(config.tooltip_contents.call($$, selectedData, $$.axis.getXAxisTickFormat(), $$.getYFormat(forArc), $$.color)).style("display", "block"); // Get tooltip dimensions

    tWidth = $$.tooltip.property('offsetWidth');
    tHeight = $$.tooltip.property('offsetHeight');
    position = positionFunction.call(this, dataToShow, tWidth, tHeight, element); // Set tooltip

    $$.tooltip.style("top", position.top + "px").style("left", position.left + 'px');
  };

  ChartInternal.prototype.hideTooltip = function () {
    this.tooltip.style("display", "none");
  };

  ChartInternal.prototype.setTargetType = function (targetIds, type) {
    var $$ = this,
        config = $$.config;
    $$.mapToTargetIds(targetIds).forEach(function (id) {
      $$.withoutFadeIn[id] = type === config.data_types[id];
      config.data_types[id] = type;
    });

    if (!targetIds) {
      config.data_type = type;
    }
  };

  ChartInternal.prototype.hasType = function (type, targets) {
    var $$ = this,
        types = $$.config.data_types,
        has = false;
    targets = targets || $$.data.targets;

    if (targets && targets.length) {
      targets.forEach(function (target) {
        var t = types[target.id];

        if (t && t.indexOf(type) >= 0 || !t && type === 'line') {
          has = true;
        }
      });
    } else if (Object.keys(types).length) {
      Object.keys(types).forEach(function (id) {
        if (types[id] === type) {
          has = true;
        }
      });
    } else {
      has = $$.config.data_type === type;
    }

    return has;
  };

  ChartInternal.prototype.hasArcType = function (targets) {
    return this.hasType('pie', targets) || this.hasType('donut', targets) || this.hasType('gauge', targets);
  };

  ChartInternal.prototype.isLineType = function (d) {
    var config = this.config,
        id = isString(d) ? d : d.id;
    return !config.data_types[id] || ['line', 'spline', 'area', 'area-spline', 'step', 'area-step'].indexOf(config.data_types[id]) >= 0;
  };

  ChartInternal.prototype.isStepType = function (d) {
    var id = isString(d) ? d : d.id;
    return ['step', 'area-step'].indexOf(this.config.data_types[id]) >= 0;
  };

  ChartInternal.prototype.isSplineType = function (d) {
    var id = isString(d) ? d : d.id;
    return ['spline', 'area-spline'].indexOf(this.config.data_types[id]) >= 0;
  };

  ChartInternal.prototype.isAreaType = function (d) {
    var id = isString(d) ? d : d.id;
    return ['area', 'area-spline', 'area-step'].indexOf(this.config.data_types[id]) >= 0;
  };

  ChartInternal.prototype.isBarType = function (d) {
    var id = isString(d) ? d : d.id;
    return this.config.data_types[id] === 'bar';
  };

  ChartInternal.prototype.isScatterType = function (d) {
    var id = isString(d) ? d : d.id;
    return this.config.data_types[id] === 'scatter';
  };

  ChartInternal.prototype.isPieType = function (d) {
    var id = isString(d) ? d : d.id;
    return this.config.data_types[id] === 'pie';
  };

  ChartInternal.prototype.isGaugeType = function (d) {
    var id = isString(d) ? d : d.id;
    return this.config.data_types[id] === 'gauge';
  };

  ChartInternal.prototype.isDonutType = function (d) {
    var id = isString(d) ? d : d.id;
    return this.config.data_types[id] === 'donut';
  };

  ChartInternal.prototype.isArcType = function (d) {
    return this.isPieType(d) || this.isDonutType(d) || this.isGaugeType(d);
  };

  ChartInternal.prototype.lineData = function (d) {
    return this.isLineType(d) ? [d] : [];
  };

  ChartInternal.prototype.arcData = function (d) {
    return this.isArcType(d.data) ? [d] : [];
  };
  /* not used
   function scatterData(d) {
   return isScatterType(d) ? d.values : [];
   }
   */


  ChartInternal.prototype.barData = function (d) {
    return this.isBarType(d) ? d.values : [];
  };

  ChartInternal.prototype.lineOrScatterData = function (d) {
    return this.isLineType(d) || this.isScatterType(d) ? d.values : [];
  };

  ChartInternal.prototype.barOrLineData = function (d) {
    return this.isBarType(d) || this.isLineType(d) ? d.values : [];
  };

  ChartInternal.prototype.isSafari = function () {
    var ua = window.navigator.userAgent;
    return ua.indexOf('Safari') >= 0 && ua.indexOf('Chrome') < 0;
  };

  ChartInternal.prototype.isChrome = function () {
    var ua = window.navigator.userAgent;
    return ua.indexOf('Chrome') >= 0;
  };

  ChartInternal.prototype.initZoom = function () {
    var $$ = this,
        d3 = $$.d3,
        config = $$.config,
        startEvent;
    $$.zoom = d3.zoom().on("start", function () {
      if (config.zoom_type !== 'scroll') {
        return;
      }

      var e = d3.event.sourceEvent;

      if (e && e.type === "brush") {
        return;
      }

      startEvent = e;
      config.zoom_onzoomstart.call($$.api, e);
    }).on("zoom", function () {
      if (config.zoom_type !== 'scroll') {
        return;
      }

      var e = d3.event.sourceEvent;

      if (e && e.type === "brush") {
        return;
      }

      $$.redrawForZoom();
      config.zoom_onzoom.call($$.api, $$.x.orgDomain());
    }).on('end', function () {
      if (config.zoom_type !== 'scroll') {
        return;
      }

      var e = d3.event.sourceEvent;

      if (e && e.type === "brush") {
        return;
      } // if click, do nothing. otherwise, click interaction will be canceled.


      if (e && startEvent.clientX === e.clientX && startEvent.clientY === e.clientY) {
        return;
      }

      config.zoom_onzoomend.call($$.api, $$.x.orgDomain());
    });

    $$.zoom.updateDomain = function () {
      if (d3.event && d3.event.transform) {
        $$.x.domain(d3.event.transform.rescaleX($$.subX).domain());
      }

      return this;
    };

    $$.zoom.updateExtent = function () {
      this.scaleExtent([1, Infinity]).translateExtent([[0, 0], [$$.width, $$.height]]).extent([[0, 0], [$$.width, $$.height]]);
      return this;
    };

    $$.zoom.update = function () {
      return this.updateExtent().updateDomain();
    };

    return $$.zoom.updateExtent();
  };

  ChartInternal.prototype.zoomTransform = function (range) {
    var $$ = this,
        s = [$$.x(range[0]), $$.x(range[1])];
    return $$.d3.zoomIdentity.scale($$.width / (s[1] - s[0])).translate(-s[0], 0);
  };

  ChartInternal.prototype.initDragZoom = function () {
    var $$ = this;
    var d3 = $$.d3;
    var config = $$.config;
    var context = $$.context = $$.svg;
    var brushXPos = $$.margin.left + 20.5;
    var brushYPos = $$.margin.top + 0.5;

    if (!(config.zoom_type === 'drag' && config.zoom_enabled)) {
      return;
    }

    var getZoomedDomain = function getZoomedDomain(selection) {
      return selection && selection.map(function (x) {
        return $$.x.invert(x);
      });
    };

    var brush = $$.dragZoomBrush = d3.brushX().on("start", function () {
      $$.api.unzoom();
      $$.svg.select("." + CLASS.dragZoom).classed("disabled", false);
      config.zoom_onzoomstart.call($$.api, d3.event.sourceEvent);
    }).on("brush", function () {
      config.zoom_onzoom.call($$.api, getZoomedDomain(d3.event.selection));
    }).on("end", function () {
      if (d3.event.selection == null) {
        return;
      }

      var zoomedDomain = getZoomedDomain(d3.event.selection);

      if (!config.zoom_disableDefaultBehavior) {
        $$.api.zoom(zoomedDomain);
      }

      $$.svg.select("." + CLASS.dragZoom).classed("disabled", true);
      config.zoom_onzoomend.call($$.api, zoomedDomain);
    });
    context.append("g").classed(CLASS.dragZoom, true).attr("clip-path", $$.clipPath).attr("transform", "translate(" + brushXPos + "," + brushYPos + ")").call(brush);
  };

  ChartInternal.prototype.getZoomDomain = function () {
    var $$ = this,
        config = $$.config,
        d3 = $$.d3,
        min = d3.min([$$.orgXDomain[0], config.zoom_x_min]),
        max = d3.max([$$.orgXDomain[1], config.zoom_x_max]);
    return [min, max];
  };

  ChartInternal.prototype.redrawForZoom = function () {
    var $$ = this,
        d3 = $$.d3,
        config = $$.config,
        zoom = $$.zoom,
        x = $$.x;

    if (!config.zoom_enabled) {
      return;
    }

    if ($$.filterTargetsToShow($$.data.targets).length === 0) {
      return;
    }

    zoom.update();

    if (config.zoom_disableDefaultBehavior) {
      return;
    }

    if ($$.isCategorized() && x.orgDomain()[0] === $$.orgXDomain[0]) {
      x.domain([$$.orgXDomain[0] - 1e-10, x.orgDomain()[1]]);
    }

    $$.redraw({
      withTransition: false,
      withY: config.zoom_rescale,
      withSubchart: false,
      withEventRect: false,
      withDimension: false
    });

    if (d3.event.sourceEvent && d3.event.sourceEvent.type === 'mousemove') {
      $$.cancelClick = true;
    }
  };

  return c3;

})));


/***/ }),

/***/ "./node_modules/charm/index.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {var tty = __webpack_require__("./node_modules/tty-browserify/index.js");
var encode = __webpack_require__("./node_modules/charm/lib/encode.js");
var Stream = __webpack_require__("./node_modules/stream-browserify/index.js").Stream;

var exports = module.exports = function () {
    var input = null;
    function setInput (s) {
        if (input) throw new Error('multiple inputs specified')
        else input = s
    }
    
    var output = null;
    function setOutput (s) {
        if (output) throw new Error('multiple outputs specified')
        else output = s
    }
    
    for (var i = 0; i < arguments.length; i++) {
        var arg = arguments[i];
        if (!arg) continue;
        if (arg.readable) setInput(arg)
        else if (arg.stdin || arg.input) setInput(arg.stdin || arg.input)
        
        if (arg.writable) setOutput(arg)
        else if (arg.stdout || arg.output) setOutput(arg.stdout || arg.output)
        
    }
    
    if (input && typeof input.fd === 'number' && tty.isatty(input.fd)) {
        if (process.stdin.setRawMode) {
            process.stdin.setRawMode(true);
        }
        else tty.setRawMode(true);
    }
    
    var charm = new Charm;
    if (input) {
        input.pipe(charm);
    }
    
    if (output) {
        charm.pipe(output);
    }
    
    charm.once('^C', process.exit);
    charm.once('end', function () {
      if (input) {
          if (typeof input.fd === 'number' && tty.isatty(input.fd)) {
            if (process.stdin.setRawMode) {
                process.stdin.setRawMode(false);
            }
            else tty.setRawMode(false);
          }
          input.destroy();
      }
    });

    return charm;
};

var Charm = exports.Charm = function Charm () {
    this.writable = true;
    this.readable = true;
    this.pending = [];
}

Charm.prototype = new Stream;

Charm.prototype.write = function (buf) {
    var self = this;
    
    if (self.pending.length) {
        var codes = extractCodes(buf);
        var matched = false;
        
        for (var i = 0; i < codes.length; i++) {
            for (var j = 0; j < self.pending.length; j++) {
                var cb = self.pending[j];
                if (cb(codes[i])) {
                    matched = true;
                    self.pending.splice(j, 1);
                    break;
                }
            }
        }
        
        if (matched) return;
    }
    
    if (buf.length === 1) {
        if (buf[0] === 3) self.emit('^C');
        if (buf[0] === 4) self.emit('^D');
    }
    
    self.emit('data', buf);
    
    return self;
};


Charm.prototype.destroy = function () {
    this.end();
};

Charm.prototype.end = function (buf) {
    if (buf) this.write(buf);
    this.emit('end');
};

Charm.prototype.reset = function (cb) {
    this.write(encode('c'));
    return this;
};

Charm.prototype.position = function (x, y) {
    // get/set absolute coordinates
    if (typeof x === 'function') {
        var cb = x;
        this.pending.push(function (buf) {
            if (buf[0] === 27 && buf[1] === encode.ord('[')
            && buf[buf.length-1] === encode.ord('R')) {
                var pos = buf.toString()
                    .slice(2,-1)
                    .split(';')
                    .map(Number)
                ;
                cb(pos[1], pos[0]);
                return true;
            }
        });
        this.write(encode('[6n'));
    }
    else {
        this.write(encode(
            '[' + Math.floor(y) + ';' + Math.floor(x) + 'f'
        ));
    }
    return this;
};

Charm.prototype.move = function (x, y) {
    // set relative coordinates
    var bufs = [];
    
    if (y < 0) this.up(-y)
    else if (y > 0) this.down(y)
    
    if (x > 0) this.right(x)
    else if (x < 0) this.left(-x)
    
    return this;
};

Charm.prototype.up = function (y) {
    if (y === undefined) y = 1;
    this.write(encode('[' + Math.floor(y) + 'A'));
    return this;
};

Charm.prototype.down = function (y) {
    if (y === undefined) y = 1;
    this.write(encode('[' + Math.floor(y) + 'B'));
    return this;
};

Charm.prototype.right = function (x) {
    if (x === undefined) x = 1;
    this.write(encode('[' + Math.floor(x) + 'C'));
    return this;
};

Charm.prototype.left = function (x) {
    if (x === undefined) x = 1;
    this.write(encode('[' + Math.floor(x) + 'D'));
    return this;
};

Charm.prototype.column = function (x) {
    this.write(encode('[' + Math.floor(x) + 'G'));
    return this;
};

Charm.prototype.push = function (withAttributes) {
    this.write(encode(withAttributes ? '7' : '[s'));
    return this;
};

Charm.prototype.pop = function (withAttributes) {
    this.write(encode(withAttributes ? '8' : '[u'));
    return this;
};

Charm.prototype.erase = function (s) {
    if (s === 'end' || s === '$') {
        this.write(encode('[K'));
    }
    else if (s === 'start' || s === '^') {
        this.write(encode('[1K'));
    }
    else if (s === 'line') {
        this.write(encode('[2K'));
    }
    else if (s === 'down') {
        this.write(encode('[J'));
    }
    else if (s === 'up') {
        this.write(encode('[1J'));
    }
    else if (s === 'screen') {
        this.write(encode('[1J'));
    }
    else {
        this.emit('error', new Error('Unknown erase type: ' + s));
    }
    return this;
};

Charm.prototype.display = function (attr) {
    var c = {
        reset : 0,
        bright : 1,
        dim : 2,
        underscore : 4,
        blink : 5,
        reverse : 7,
        hidden : 8
    }[attr];
    if (c === undefined) {
        this.emit('error', new Error('Unknown attribute: ' + attr));
    }
    this.write(encode('[' + c + 'm'));
    return this;
};

Charm.prototype.foreground = function (color) {
    if (typeof color === 'number') {
        if (color < 0 || color >= 256) {
            this.emit('error', new Error('Color out of range: ' + color));
        }
        this.write(encode('[38;5;' + color + 'm'));
    }
    else {
        var c = {
            black : 30,
            red : 31,
            green : 32,
            yellow : 33,
            blue : 34,
            magenta : 35,
            cyan : 36,
            white : 37
        }[color.toLowerCase()];
        
        if (!c) this.emit('error', new Error('Unknown color: ' + color));
        this.write(encode('[' + c + 'm'));
    }
    return this;
};

Charm.prototype.background = function (color) {
    if (typeof color === 'number') {
        if (color < 0 || color >= 256) {
            this.emit('error', new Error('Color out of range: ' + color));
        }
        this.write(encode('[48;5;' + color + 'm'));
    }
    else {
        var c = {
          black : 40,
          red : 41,
          green : 42,
          yellow : 43,
          blue : 44,
          magenta : 45,
          cyan : 46,
          white : 47
        }[color.toLowerCase()];
        
        if (!c) this.emit('error', new Error('Unknown color: ' + color));
        this.write(encode('[' + c + 'm'));
    }
    return this;
};

Charm.prototype.cursor = function (visible) {
    this.write(encode(visible ? '[?25h' : '[?25l'));
    return this;
};

var extractCodes = exports.extractCodes = function (buf) {
    var codes = [];
    var start = -1;
    
    for (var i = 0; i < buf.length; i++) {
        if (buf[i] === 27) {
            if (start >= 0) codes.push(buf.slice(start, i));
            start = i;
        }
        else if (start >= 0 && i === buf.length - 1) {
            codes.push(buf.slice(start));
        }
    }
    
    return codes;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/charm/lib/encode.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var encode = module.exports = function (xs) {
    function bytes (s) {
        if (typeof s === 'string') {
            return s.split('').map(ord);
        }
        else if (Array.isArray(s)) {
            return s.reduce(function (acc, c) {
                return acc.concat(bytes(c));
            }, []);
        }
    }
    
    return new Buffer([ 0x1b ].concat(bytes(xs)));
};

var ord = encode.ord = function ord (c) {
    return c.charCodeAt(0)
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/buffer/index.js").Buffer))

/***/ }),

/***/ "./node_modules/contra/debounce.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ticky = __webpack_require__("./node_modules/ticky/ticky-browser.js");

module.exports = function debounce (fn, args, ctx) {
  if (!fn) { return; }
  ticky(function run () {
    fn.apply(ctx || null, args || []);
  });
};


/***/ }),

/***/ "./node_modules/contra/emitter.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var atoa = __webpack_require__("./node_modules/atoa/atoa.js");
var debounce = __webpack_require__("./node_modules/contra/debounce.js");

module.exports = function emitter (thing, options) {
  var opts = options || {};
  var evt = {};
  if (thing === undefined) { thing = {}; }
  thing.on = function (type, fn) {
    if (!evt[type]) {
      evt[type] = [fn];
    } else {
      evt[type].push(fn);
    }
    return thing;
  };
  thing.once = function (type, fn) {
    fn._once = true; // thing.off(fn) still works!
    thing.on(type, fn);
    return thing;
  };
  thing.off = function (type, fn) {
    var c = arguments.length;
    if (c === 1) {
      delete evt[type];
    } else if (c === 0) {
      evt = {};
    } else {
      var et = evt[type];
      if (!et) { return thing; }
      et.splice(et.indexOf(fn), 1);
    }
    return thing;
  };
  thing.emit = function () {
    var args = atoa(arguments);
    return thing.emitterSnapshot(args.shift()).apply(this, args);
  };
  thing.emitterSnapshot = function (type) {
    var et = (evt[type] || []).slice(0);
    return function () {
      var args = atoa(arguments);
      var ctx = this || thing;
      if (type === 'error' && opts.throws !== false && !et.length) { throw args.length === 1 ? args[0] : args; }
      et.forEach(function emitter (listen) {
        if (opts.async) { debounce(listen, args, ctx); } else { listen.apply(ctx, args); }
        if (listen._once) { thing.off(type, listen); }
      });
      return thing;
    };
  };
  return thing;
};


/***/ }),

/***/ "./node_modules/core-js/fn/regexp/escape.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/modules/core.regexp.escape.js");
module.exports = __webpack_require__("./node_modules/core-js/modules/_core.js").RegExp.escape;


/***/ }),

/***/ "./node_modules/core-js/modules/_a-function.js":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_a-number-value.js":
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__("./node_modules/core-js/modules/_cof.js");
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_add-to-unscopables.js":
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__("./node_modules/core-js/modules/_wks.js")('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__("./node_modules/core-js/modules/_hide.js")(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_an-instance.js":
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_an-object.js":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_array-copy-within.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__("./node_modules/core-js/modules/_to-object.js");
var toAbsoluteIndex = __webpack_require__("./node_modules/core-js/modules/_to-absolute-index.js");
var toLength = __webpack_require__("./node_modules/core-js/modules/_to-length.js");

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_array-fill.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__("./node_modules/core-js/modules/_to-object.js");
var toAbsoluteIndex = __webpack_require__("./node_modules/core-js/modules/_to-absolute-index.js");
var toLength = __webpack_require__("./node_modules/core-js/modules/_to-length.js");
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_array-from-iterable.js":
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__("./node_modules/core-js/modules/_for-of.js");

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_array-includes.js":
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__("./node_modules/core-js/modules/_to-iobject.js");
var toLength = __webpack_require__("./node_modules/core-js/modules/_to-length.js");
var toAbsoluteIndex = __webpack_require__("./node_modules/core-js/modules/_to-absolute-index.js");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ "./node_modules/core-js/modules/_array-methods.js":
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__("./node_modules/core-js/modules/_ctx.js");
var IObject = __webpack_require__("./node_modules/core-js/modules/_iobject.js");
var toObject = __webpack_require__("./node_modules/core-js/modules/_to-object.js");
var toLength = __webpack_require__("./node_modules/core-js/modules/_to-length.js");
var asc = __webpack_require__("./node_modules/core-js/modules/_array-species-create.js");
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),

/***/ "./node_modules/core-js/modules/_array-reduce.js":
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__("./node_modules/core-js/modules/_a-function.js");
var toObject = __webpack_require__("./node_modules/core-js/modules/_to-object.js");
var IObject = __webpack_require__("./node_modules/core-js/modules/_iobject.js");
var toLength = __webpack_require__("./node_modules/core-js/modules/_to-length.js");

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_array-species-constructor.js":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");
var isArray = __webpack_require__("./node_modules/core-js/modules/_is-array.js");
var SPECIES = __webpack_require__("./node_modules/core-js/modules/_wks.js")('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_array-species-create.js":
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__("./node_modules/core-js/modules/_array-species-constructor.js");

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),

/***/ "./node_modules/core-js/modules/_bind.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__("./node_modules/core-js/modules/_a-function.js");
var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");
var invoke = __webpack_require__("./node_modules/core-js/modules/_invoke.js");
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_classof.js":
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__("./node_modules/core-js/modules/_cof.js");
var TAG = __webpack_require__("./node_modules/core-js/modules/_wks.js")('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_cof.js":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "./node_modules/core-js/modules/_collection-strong.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__("./node_modules/core-js/modules/_object-dp.js").f;
var create = __webpack_require__("./node_modules/core-js/modules/_object-create.js");
var redefineAll = __webpack_require__("./node_modules/core-js/modules/_redefine-all.js");
var ctx = __webpack_require__("./node_modules/core-js/modules/_ctx.js");
var anInstance = __webpack_require__("./node_modules/core-js/modules/_an-instance.js");
var forOf = __webpack_require__("./node_modules/core-js/modules/_for-of.js");
var $iterDefine = __webpack_require__("./node_modules/core-js/modules/_iter-define.js");
var step = __webpack_require__("./node_modules/core-js/modules/_iter-step.js");
var setSpecies = __webpack_require__("./node_modules/core-js/modules/_set-species.js");
var DESCRIPTORS = __webpack_require__("./node_modules/core-js/modules/_descriptors.js");
var fastKey = __webpack_require__("./node_modules/core-js/modules/_meta.js").fastKey;
var validate = __webpack_require__("./node_modules/core-js/modules/_validate-collection.js");
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),

/***/ "./node_modules/core-js/modules/_collection-to-json.js":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__("./node_modules/core-js/modules/_classof.js");
var from = __webpack_require__("./node_modules/core-js/modules/_array-from-iterable.js");
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),

/***/ "./node_modules/core-js/modules/_collection-weak.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__("./node_modules/core-js/modules/_redefine-all.js");
var getWeak = __webpack_require__("./node_modules/core-js/modules/_meta.js").getWeak;
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");
var anInstance = __webpack_require__("./node_modules/core-js/modules/_an-instance.js");
var forOf = __webpack_require__("./node_modules/core-js/modules/_for-of.js");
var createArrayMethod = __webpack_require__("./node_modules/core-js/modules/_array-methods.js");
var $has = __webpack_require__("./node_modules/core-js/modules/_has.js");
var validate = __webpack_require__("./node_modules/core-js/modules/_validate-collection.js");
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),

/***/ "./node_modules/core-js/modules/_collection.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("./node_modules/core-js/modules/_global.js");
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var redefine = __webpack_require__("./node_modules/core-js/modules/_redefine.js");
var redefineAll = __webpack_require__("./node_modules/core-js/modules/_redefine-all.js");
var meta = __webpack_require__("./node_modules/core-js/modules/_meta.js");
var forOf = __webpack_require__("./node_modules/core-js/modules/_for-of.js");
var anInstance = __webpack_require__("./node_modules/core-js/modules/_an-instance.js");
var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");
var fails = __webpack_require__("./node_modules/core-js/modules/_fails.js");
var $iterDetect = __webpack_require__("./node_modules/core-js/modules/_iter-detect.js");
var setToStringTag = __webpack_require__("./node_modules/core-js/modules/_set-to-string-tag.js");
var inheritIfRequired = __webpack_require__("./node_modules/core-js/modules/_inherit-if-required.js");

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_core.js":
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.6' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ "./node_modules/core-js/modules/_create-property.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__("./node_modules/core-js/modules/_object-dp.js");
var createDesc = __webpack_require__("./node_modules/core-js/modules/_property-desc.js");

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_ctx.js":
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__("./node_modules/core-js/modules/_a-function.js");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "./node_modules/core-js/modules/_date-to-iso-string.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__("./node_modules/core-js/modules/_fails.js");
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),

/***/ "./node_modules/core-js/modules/_date-to-primitive.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var toPrimitive = __webpack_require__("./node_modules/core-js/modules/_to-primitive.js");
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),

/***/ "./node_modules/core-js/modules/_defined.js":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_descriptors.js":
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("./node_modules/core-js/modules/_fails.js")(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "./node_modules/core-js/modules/_dom-create.js":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");
var document = __webpack_require__("./node_modules/core-js/modules/_global.js").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ "./node_modules/core-js/modules/_enum-bug-keys.js":
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ "./node_modules/core-js/modules/_enum-keys.js":
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__("./node_modules/core-js/modules/_object-keys.js");
var gOPS = __webpack_require__("./node_modules/core-js/modules/_object-gops.js");
var pIE = __webpack_require__("./node_modules/core-js/modules/_object-pie.js");
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_export.js":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("./node_modules/core-js/modules/_global.js");
var core = __webpack_require__("./node_modules/core-js/modules/_core.js");
var hide = __webpack_require__("./node_modules/core-js/modules/_hide.js");
var redefine = __webpack_require__("./node_modules/core-js/modules/_redefine.js");
var ctx = __webpack_require__("./node_modules/core-js/modules/_ctx.js");
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ "./node_modules/core-js/modules/_fails-is-regexp.js":
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__("./node_modules/core-js/modules/_wks.js")('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_fails.js":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ "./node_modules/core-js/modules/_fix-re-wks.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var hide = __webpack_require__("./node_modules/core-js/modules/_hide.js");
var redefine = __webpack_require__("./node_modules/core-js/modules/_redefine.js");
var fails = __webpack_require__("./node_modules/core-js/modules/_fails.js");
var defined = __webpack_require__("./node_modules/core-js/modules/_defined.js");
var wks = __webpack_require__("./node_modules/core-js/modules/_wks.js");

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);
  var fns = exec(defined, SYMBOL, ''[KEY]);
  var strfn = fns[0];
  var rxfn = fns[1];
  if (fails(function () {
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  })) {
    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),

/***/ "./node_modules/core-js/modules/_flags.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_flatten-into-array.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__("./node_modules/core-js/modules/_is-array.js");
var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");
var toLength = __webpack_require__("./node_modules/core-js/modules/_to-length.js");
var ctx = __webpack_require__("./node_modules/core-js/modules/_ctx.js");
var IS_CONCAT_SPREADABLE = __webpack_require__("./node_modules/core-js/modules/_wks.js")('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),

/***/ "./node_modules/core-js/modules/_for-of.js":
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__("./node_modules/core-js/modules/_ctx.js");
var call = __webpack_require__("./node_modules/core-js/modules/_iter-call.js");
var isArrayIter = __webpack_require__("./node_modules/core-js/modules/_is-array-iter.js");
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var toLength = __webpack_require__("./node_modules/core-js/modules/_to-length.js");
var getIterFn = __webpack_require__("./node_modules/core-js/modules/core.get-iterator-method.js");
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),

/***/ "./node_modules/core-js/modules/_global.js":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ "./node_modules/core-js/modules/_has.js":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "./node_modules/core-js/modules/_hide.js":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("./node_modules/core-js/modules/_object-dp.js");
var createDesc = __webpack_require__("./node_modules/core-js/modules/_property-desc.js");
module.exports = __webpack_require__("./node_modules/core-js/modules/_descriptors.js") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_html.js":
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__("./node_modules/core-js/modules/_global.js").document;
module.exports = document && document.documentElement;


/***/ }),

/***/ "./node_modules/core-js/modules/_ie8-dom-define.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__("./node_modules/core-js/modules/_descriptors.js") && !__webpack_require__("./node_modules/core-js/modules/_fails.js")(function () {
  return Object.defineProperty(__webpack_require__("./node_modules/core-js/modules/_dom-create.js")('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "./node_modules/core-js/modules/_inherit-if-required.js":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");
var setPrototypeOf = __webpack_require__("./node_modules/core-js/modules/_set-proto.js").set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_invoke.js":
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),

/***/ "./node_modules/core-js/modules/_iobject.js":
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__("./node_modules/core-js/modules/_cof.js");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ "./node_modules/core-js/modules/_is-array-iter.js":
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__("./node_modules/core-js/modules/_iterators.js");
var ITERATOR = __webpack_require__("./node_modules/core-js/modules/_wks.js")('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),

/***/ "./node_modules/core-js/modules/_is-array.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__("./node_modules/core-js/modules/_cof.js");
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ "./node_modules/core-js/modules/_is-integer.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_is-object.js":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "./node_modules/core-js/modules/_is-regexp.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");
var cof = __webpack_require__("./node_modules/core-js/modules/_cof.js");
var MATCH = __webpack_require__("./node_modules/core-js/modules/_wks.js")('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),

/***/ "./node_modules/core-js/modules/_iter-call.js":
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),

/***/ "./node_modules/core-js/modules/_iter-create.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__("./node_modules/core-js/modules/_object-create.js");
var descriptor = __webpack_require__("./node_modules/core-js/modules/_property-desc.js");
var setToStringTag = __webpack_require__("./node_modules/core-js/modules/_set-to-string-tag.js");
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__("./node_modules/core-js/modules/_hide.js")(IteratorPrototype, __webpack_require__("./node_modules/core-js/modules/_wks.js")('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),

/***/ "./node_modules/core-js/modules/_iter-define.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("./node_modules/core-js/modules/_library.js");
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var redefine = __webpack_require__("./node_modules/core-js/modules/_redefine.js");
var hide = __webpack_require__("./node_modules/core-js/modules/_hide.js");
var Iterators = __webpack_require__("./node_modules/core-js/modules/_iterators.js");
var $iterCreate = __webpack_require__("./node_modules/core-js/modules/_iter-create.js");
var setToStringTag = __webpack_require__("./node_modules/core-js/modules/_set-to-string-tag.js");
var getPrototypeOf = __webpack_require__("./node_modules/core-js/modules/_object-gpo.js");
var ITERATOR = __webpack_require__("./node_modules/core-js/modules/_wks.js")('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_iter-detect.js":
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__("./node_modules/core-js/modules/_wks.js")('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_iter-step.js":
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),

/***/ "./node_modules/core-js/modules/_iterators.js":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "./node_modules/core-js/modules/_library.js":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "./node_modules/core-js/modules/_math-expm1.js":
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),

/***/ "./node_modules/core-js/modules/_math-fround.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__("./node_modules/core-js/modules/_math-sign.js");
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_math-log1p.js":
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),

/***/ "./node_modules/core-js/modules/_math-scale.js":
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_math-sign.js":
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_meta.js":
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__("./node_modules/core-js/modules/_uid.js")('meta');
var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");
var has = __webpack_require__("./node_modules/core-js/modules/_has.js");
var setDesc = __webpack_require__("./node_modules/core-js/modules/_object-dp.js").f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__("./node_modules/core-js/modules/_fails.js")(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),

/***/ "./node_modules/core-js/modules/_metadata.js":
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__("./node_modules/core-js/modules/es6.map.js");
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var shared = __webpack_require__("./node_modules/core-js/modules/_shared.js")('metadata');
var store = shared.store || (shared.store = new (__webpack_require__("./node_modules/core-js/modules/es6.weak-map.js"))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),

/***/ "./node_modules/core-js/modules/_microtask.js":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("./node_modules/core-js/modules/_global.js");
var macrotask = __webpack_require__("./node_modules/core-js/modules/_task.js").set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__("./node_modules/core-js/modules/_cof.js")(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),

/***/ "./node_modules/core-js/modules/_new-promise-capability.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__("./node_modules/core-js/modules/_a-function.js");

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),

/***/ "./node_modules/core-js/modules/_object-assign.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__("./node_modules/core-js/modules/_object-keys.js");
var gOPS = __webpack_require__("./node_modules/core-js/modules/_object-gops.js");
var pIE = __webpack_require__("./node_modules/core-js/modules/_object-pie.js");
var toObject = __webpack_require__("./node_modules/core-js/modules/_to-object.js");
var IObject = __webpack_require__("./node_modules/core-js/modules/_iobject.js");
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__("./node_modules/core-js/modules/_fails.js")(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),

/***/ "./node_modules/core-js/modules/_object-create.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var dPs = __webpack_require__("./node_modules/core-js/modules/_object-dps.js");
var enumBugKeys = __webpack_require__("./node_modules/core-js/modules/_enum-bug-keys.js");
var IE_PROTO = __webpack_require__("./node_modules/core-js/modules/_shared-key.js")('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__("./node_modules/core-js/modules/_dom-create.js")('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__("./node_modules/core-js/modules/_html.js").appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ "./node_modules/core-js/modules/_object-dp.js":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var IE8_DOM_DEFINE = __webpack_require__("./node_modules/core-js/modules/_ie8-dom-define.js");
var toPrimitive = __webpack_require__("./node_modules/core-js/modules/_to-primitive.js");
var dP = Object.defineProperty;

exports.f = __webpack_require__("./node_modules/core-js/modules/_descriptors.js") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_object-dps.js":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("./node_modules/core-js/modules/_object-dp.js");
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var getKeys = __webpack_require__("./node_modules/core-js/modules/_object-keys.js");

module.exports = __webpack_require__("./node_modules/core-js/modules/_descriptors.js") ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_object-forced-pam.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__("./node_modules/core-js/modules/_library.js") || !__webpack_require__("./node_modules/core-js/modules/_fails.js")(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__("./node_modules/core-js/modules/_global.js")[K];
});


/***/ }),

/***/ "./node_modules/core-js/modules/_object-gopd.js":
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__("./node_modules/core-js/modules/_object-pie.js");
var createDesc = __webpack_require__("./node_modules/core-js/modules/_property-desc.js");
var toIObject = __webpack_require__("./node_modules/core-js/modules/_to-iobject.js");
var toPrimitive = __webpack_require__("./node_modules/core-js/modules/_to-primitive.js");
var has = __webpack_require__("./node_modules/core-js/modules/_has.js");
var IE8_DOM_DEFINE = __webpack_require__("./node_modules/core-js/modules/_ie8-dom-define.js");
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__("./node_modules/core-js/modules/_descriptors.js") ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),

/***/ "./node_modules/core-js/modules/_object-gopn-ext.js":
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__("./node_modules/core-js/modules/_to-iobject.js");
var gOPN = __webpack_require__("./node_modules/core-js/modules/_object-gopn.js").f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),

/***/ "./node_modules/core-js/modules/_object-gopn.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__("./node_modules/core-js/modules/_object-keys-internal.js");
var hiddenKeys = __webpack_require__("./node_modules/core-js/modules/_enum-bug-keys.js").concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),

/***/ "./node_modules/core-js/modules/_object-gops.js":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "./node_modules/core-js/modules/_object-gpo.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__("./node_modules/core-js/modules/_has.js");
var toObject = __webpack_require__("./node_modules/core-js/modules/_to-object.js");
var IE_PROTO = __webpack_require__("./node_modules/core-js/modules/_shared-key.js")('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_object-keys-internal.js":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("./node_modules/core-js/modules/_has.js");
var toIObject = __webpack_require__("./node_modules/core-js/modules/_to-iobject.js");
var arrayIndexOf = __webpack_require__("./node_modules/core-js/modules/_array-includes.js")(false);
var IE_PROTO = __webpack_require__("./node_modules/core-js/modules/_shared-key.js")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_object-keys.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__("./node_modules/core-js/modules/_object-keys-internal.js");
var enumBugKeys = __webpack_require__("./node_modules/core-js/modules/_enum-bug-keys.js");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ "./node_modules/core-js/modules/_object-pie.js":
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ "./node_modules/core-js/modules/_object-sap.js":
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var core = __webpack_require__("./node_modules/core-js/modules/_core.js");
var fails = __webpack_require__("./node_modules/core-js/modules/_fails.js");
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),

/***/ "./node_modules/core-js/modules/_object-to-array.js":
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__("./node_modules/core-js/modules/_object-keys.js");
var toIObject = __webpack_require__("./node_modules/core-js/modules/_to-iobject.js");
var isEnum = __webpack_require__("./node_modules/core-js/modules/_object-pie.js").f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};


/***/ }),

/***/ "./node_modules/core-js/modules/_own-keys.js":
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__("./node_modules/core-js/modules/_object-gopn.js");
var gOPS = __webpack_require__("./node_modules/core-js/modules/_object-gops.js");
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var Reflect = __webpack_require__("./node_modules/core-js/modules/_global.js").Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_parse-float.js":
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__("./node_modules/core-js/modules/_global.js").parseFloat;
var $trim = __webpack_require__("./node_modules/core-js/modules/_string-trim.js").trim;

module.exports = 1 / $parseFloat(__webpack_require__("./node_modules/core-js/modules/_string-ws.js") + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),

/***/ "./node_modules/core-js/modules/_parse-int.js":
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__("./node_modules/core-js/modules/_global.js").parseInt;
var $trim = __webpack_require__("./node_modules/core-js/modules/_string-trim.js").trim;
var ws = __webpack_require__("./node_modules/core-js/modules/_string-ws.js");
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),

/***/ "./node_modules/core-js/modules/_perform.js":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),

/***/ "./node_modules/core-js/modules/_promise-resolve.js":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");
var newPromiseCapability = __webpack_require__("./node_modules/core-js/modules/_new-promise-capability.js");

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_property-desc.js":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "./node_modules/core-js/modules/_redefine-all.js":
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__("./node_modules/core-js/modules/_redefine.js");
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_redefine.js":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("./node_modules/core-js/modules/_global.js");
var hide = __webpack_require__("./node_modules/core-js/modules/_hide.js");
var has = __webpack_require__("./node_modules/core-js/modules/_has.js");
var SRC = __webpack_require__("./node_modules/core-js/modules/_uid.js")('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__("./node_modules/core-js/modules/_core.js").inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),

/***/ "./node_modules/core-js/modules/_replacer.js":
/***/ (function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};


/***/ }),

/***/ "./node_modules/core-js/modules/_same-value.js":
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_set-collection-from.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var aFunction = __webpack_require__("./node_modules/core-js/modules/_a-function.js");
var ctx = __webpack_require__("./node_modules/core-js/modules/_ctx.js");
var forOf = __webpack_require__("./node_modules/core-js/modules/_for-of.js");

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),

/***/ "./node_modules/core-js/modules/_set-collection-of.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),

/***/ "./node_modules/core-js/modules/_set-proto.js":
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__("./node_modules/core-js/modules/_ctx.js")(Function.call, __webpack_require__("./node_modules/core-js/modules/_object-gopd.js").f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),

/***/ "./node_modules/core-js/modules/_set-species.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("./node_modules/core-js/modules/_global.js");
var dP = __webpack_require__("./node_modules/core-js/modules/_object-dp.js");
var DESCRIPTORS = __webpack_require__("./node_modules/core-js/modules/_descriptors.js");
var SPECIES = __webpack_require__("./node_modules/core-js/modules/_wks.js")('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),

/***/ "./node_modules/core-js/modules/_set-to-string-tag.js":
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__("./node_modules/core-js/modules/_object-dp.js").f;
var has = __webpack_require__("./node_modules/core-js/modules/_has.js");
var TAG = __webpack_require__("./node_modules/core-js/modules/_wks.js")('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),

/***/ "./node_modules/core-js/modules/_shared-key.js":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("./node_modules/core-js/modules/_shared.js")('keys');
var uid = __webpack_require__("./node_modules/core-js/modules/_uid.js");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ "./node_modules/core-js/modules/_shared.js":
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__("./node_modules/core-js/modules/_core.js");
var global = __webpack_require__("./node_modules/core-js/modules/_global.js");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__("./node_modules/core-js/modules/_library.js") ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "./node_modules/core-js/modules/_species-constructor.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var aFunction = __webpack_require__("./node_modules/core-js/modules/_a-function.js");
var SPECIES = __webpack_require__("./node_modules/core-js/modules/_wks.js")('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),

/***/ "./node_modules/core-js/modules/_strict-method.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("./node_modules/core-js/modules/_fails.js");

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),

/***/ "./node_modules/core-js/modules/_string-at.js":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("./node_modules/core-js/modules/_to-integer.js");
var defined = __webpack_require__("./node_modules/core-js/modules/_defined.js");
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),

/***/ "./node_modules/core-js/modules/_string-context.js":
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__("./node_modules/core-js/modules/_is-regexp.js");
var defined = __webpack_require__("./node_modules/core-js/modules/_defined.js");

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),

/***/ "./node_modules/core-js/modules/_string-html.js":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var fails = __webpack_require__("./node_modules/core-js/modules/_fails.js");
var defined = __webpack_require__("./node_modules/core-js/modules/_defined.js");
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),

/***/ "./node_modules/core-js/modules/_string-pad.js":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__("./node_modules/core-js/modules/_to-length.js");
var repeat = __webpack_require__("./node_modules/core-js/modules/_string-repeat.js");
var defined = __webpack_require__("./node_modules/core-js/modules/_defined.js");

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_string-repeat.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__("./node_modules/core-js/modules/_to-integer.js");
var defined = __webpack_require__("./node_modules/core-js/modules/_defined.js");

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_string-trim.js":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var defined = __webpack_require__("./node_modules/core-js/modules/_defined.js");
var fails = __webpack_require__("./node_modules/core-js/modules/_fails.js");
var spaces = __webpack_require__("./node_modules/core-js/modules/_string-ws.js");
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),

/***/ "./node_modules/core-js/modules/_string-ws.js":
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),

/***/ "./node_modules/core-js/modules/_task.js":
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__("./node_modules/core-js/modules/_ctx.js");
var invoke = __webpack_require__("./node_modules/core-js/modules/_invoke.js");
var html = __webpack_require__("./node_modules/core-js/modules/_html.js");
var cel = __webpack_require__("./node_modules/core-js/modules/_dom-create.js");
var global = __webpack_require__("./node_modules/core-js/modules/_global.js");
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__("./node_modules/core-js/modules/_cof.js")(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),

/***/ "./node_modules/core-js/modules/_to-absolute-index.js":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("./node_modules/core-js/modules/_to-integer.js");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ "./node_modules/core-js/modules/_to-index.js":
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__("./node_modules/core-js/modules/_to-integer.js");
var toLength = __webpack_require__("./node_modules/core-js/modules/_to-length.js");
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_to-integer.js":
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ "./node_modules/core-js/modules/_to-iobject.js":
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__("./node_modules/core-js/modules/_iobject.js");
var defined = __webpack_require__("./node_modules/core-js/modules/_defined.js");
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ "./node_modules/core-js/modules/_to-length.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__("./node_modules/core-js/modules/_to-integer.js");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ "./node_modules/core-js/modules/_to-object.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__("./node_modules/core-js/modules/_defined.js");
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ "./node_modules/core-js/modules/_to-primitive.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "./node_modules/core-js/modules/_typed-array.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__("./node_modules/core-js/modules/_descriptors.js")) {
  var LIBRARY = __webpack_require__("./node_modules/core-js/modules/_library.js");
  var global = __webpack_require__("./node_modules/core-js/modules/_global.js");
  var fails = __webpack_require__("./node_modules/core-js/modules/_fails.js");
  var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
  var $typed = __webpack_require__("./node_modules/core-js/modules/_typed.js");
  var $buffer = __webpack_require__("./node_modules/core-js/modules/_typed-buffer.js");
  var ctx = __webpack_require__("./node_modules/core-js/modules/_ctx.js");
  var anInstance = __webpack_require__("./node_modules/core-js/modules/_an-instance.js");
  var propertyDesc = __webpack_require__("./node_modules/core-js/modules/_property-desc.js");
  var hide = __webpack_require__("./node_modules/core-js/modules/_hide.js");
  var redefineAll = __webpack_require__("./node_modules/core-js/modules/_redefine-all.js");
  var toInteger = __webpack_require__("./node_modules/core-js/modules/_to-integer.js");
  var toLength = __webpack_require__("./node_modules/core-js/modules/_to-length.js");
  var toIndex = __webpack_require__("./node_modules/core-js/modules/_to-index.js");
  var toAbsoluteIndex = __webpack_require__("./node_modules/core-js/modules/_to-absolute-index.js");
  var toPrimitive = __webpack_require__("./node_modules/core-js/modules/_to-primitive.js");
  var has = __webpack_require__("./node_modules/core-js/modules/_has.js");
  var classof = __webpack_require__("./node_modules/core-js/modules/_classof.js");
  var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");
  var toObject = __webpack_require__("./node_modules/core-js/modules/_to-object.js");
  var isArrayIter = __webpack_require__("./node_modules/core-js/modules/_is-array-iter.js");
  var create = __webpack_require__("./node_modules/core-js/modules/_object-create.js");
  var getPrototypeOf = __webpack_require__("./node_modules/core-js/modules/_object-gpo.js");
  var gOPN = __webpack_require__("./node_modules/core-js/modules/_object-gopn.js").f;
  var getIterFn = __webpack_require__("./node_modules/core-js/modules/core.get-iterator-method.js");
  var uid = __webpack_require__("./node_modules/core-js/modules/_uid.js");
  var wks = __webpack_require__("./node_modules/core-js/modules/_wks.js");
  var createArrayMethod = __webpack_require__("./node_modules/core-js/modules/_array-methods.js");
  var createArrayIncludes = __webpack_require__("./node_modules/core-js/modules/_array-includes.js");
  var speciesConstructor = __webpack_require__("./node_modules/core-js/modules/_species-constructor.js");
  var ArrayIterators = __webpack_require__("./node_modules/core-js/modules/es6.array.iterator.js");
  var Iterators = __webpack_require__("./node_modules/core-js/modules/_iterators.js");
  var $iterDetect = __webpack_require__("./node_modules/core-js/modules/_iter-detect.js");
  var setSpecies = __webpack_require__("./node_modules/core-js/modules/_set-species.js");
  var arrayFill = __webpack_require__("./node_modules/core-js/modules/_array-fill.js");
  var arrayCopyWithin = __webpack_require__("./node_modules/core-js/modules/_array-copy-within.js");
  var $DP = __webpack_require__("./node_modules/core-js/modules/_object-dp.js");
  var $GOPD = __webpack_require__("./node_modules/core-js/modules/_object-gopd.js");
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),

/***/ "./node_modules/core-js/modules/_typed-buffer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("./node_modules/core-js/modules/_global.js");
var DESCRIPTORS = __webpack_require__("./node_modules/core-js/modules/_descriptors.js");
var LIBRARY = __webpack_require__("./node_modules/core-js/modules/_library.js");
var $typed = __webpack_require__("./node_modules/core-js/modules/_typed.js");
var hide = __webpack_require__("./node_modules/core-js/modules/_hide.js");
var redefineAll = __webpack_require__("./node_modules/core-js/modules/_redefine-all.js");
var fails = __webpack_require__("./node_modules/core-js/modules/_fails.js");
var anInstance = __webpack_require__("./node_modules/core-js/modules/_an-instance.js");
var toInteger = __webpack_require__("./node_modules/core-js/modules/_to-integer.js");
var toLength = __webpack_require__("./node_modules/core-js/modules/_to-length.js");
var toIndex = __webpack_require__("./node_modules/core-js/modules/_to-index.js");
var gOPN = __webpack_require__("./node_modules/core-js/modules/_object-gopn.js").f;
var dP = __webpack_require__("./node_modules/core-js/modules/_object-dp.js").f;
var arrayFill = __webpack_require__("./node_modules/core-js/modules/_array-fill.js");
var setToStringTag = __webpack_require__("./node_modules/core-js/modules/_set-to-string-tag.js");
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),

/***/ "./node_modules/core-js/modules/_typed.js":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("./node_modules/core-js/modules/_global.js");
var hide = __webpack_require__("./node_modules/core-js/modules/_hide.js");
var uid = __webpack_require__("./node_modules/core-js/modules/_uid.js");
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),

/***/ "./node_modules/core-js/modules/_uid.js":
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ "./node_modules/core-js/modules/_user-agent.js":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("./node_modules/core-js/modules/_global.js");
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),

/***/ "./node_modules/core-js/modules/_validate-collection.js":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_wks-define.js":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("./node_modules/core-js/modules/_global.js");
var core = __webpack_require__("./node_modules/core-js/modules/_core.js");
var LIBRARY = __webpack_require__("./node_modules/core-js/modules/_library.js");
var wksExt = __webpack_require__("./node_modules/core-js/modules/_wks-ext.js");
var defineProperty = __webpack_require__("./node_modules/core-js/modules/_object-dp.js").f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),

/***/ "./node_modules/core-js/modules/_wks-ext.js":
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__("./node_modules/core-js/modules/_wks.js");


/***/ }),

/***/ "./node_modules/core-js/modules/_wks.js":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("./node_modules/core-js/modules/_shared.js")('wks');
var uid = __webpack_require__("./node_modules/core-js/modules/_uid.js");
var Symbol = __webpack_require__("./node_modules/core-js/modules/_global.js").Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),

/***/ "./node_modules/core-js/modules/core.get-iterator-method.js":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("./node_modules/core-js/modules/_classof.js");
var ITERATOR = __webpack_require__("./node_modules/core-js/modules/_wks.js")('iterator');
var Iterators = __webpack_require__("./node_modules/core-js/modules/_iterators.js");
module.exports = __webpack_require__("./node_modules/core-js/modules/_core.js").getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ "./node_modules/core-js/modules/core.regexp.escape.js":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var $re = __webpack_require__("./node_modules/core-js/modules/_replacer.js")(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),

/***/ "./node_modules/core-js/modules/es6.array.copy-within.js":
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.P, 'Array', { copyWithin: __webpack_require__("./node_modules/core-js/modules/_array-copy-within.js") });

__webpack_require__("./node_modules/core-js/modules/_add-to-unscopables.js")('copyWithin');


/***/ }),

/***/ "./node_modules/core-js/modules/es6.array.every.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var $every = __webpack_require__("./node_modules/core-js/modules/_array-methods.js")(4);

$export($export.P + $export.F * !__webpack_require__("./node_modules/core-js/modules/_strict-method.js")([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.array.fill.js":
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.P, 'Array', { fill: __webpack_require__("./node_modules/core-js/modules/_array-fill.js") });

__webpack_require__("./node_modules/core-js/modules/_add-to-unscopables.js")('fill');


/***/ }),

/***/ "./node_modules/core-js/modules/es6.array.filter.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var $filter = __webpack_require__("./node_modules/core-js/modules/_array-methods.js")(2);

$export($export.P + $export.F * !__webpack_require__("./node_modules/core-js/modules/_strict-method.js")([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.array.find-index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var $find = __webpack_require__("./node_modules/core-js/modules/_array-methods.js")(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__("./node_modules/core-js/modules/_add-to-unscopables.js")(KEY);


/***/ }),

/***/ "./node_modules/core-js/modules/es6.array.find.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var $find = __webpack_require__("./node_modules/core-js/modules/_array-methods.js")(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__("./node_modules/core-js/modules/_add-to-unscopables.js")(KEY);


/***/ }),

/***/ "./node_modules/core-js/modules/es6.array.for-each.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var $forEach = __webpack_require__("./node_modules/core-js/modules/_array-methods.js")(0);
var STRICT = __webpack_require__("./node_modules/core-js/modules/_strict-method.js")([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.array.from.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__("./node_modules/core-js/modules/_ctx.js");
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var toObject = __webpack_require__("./node_modules/core-js/modules/_to-object.js");
var call = __webpack_require__("./node_modules/core-js/modules/_iter-call.js");
var isArrayIter = __webpack_require__("./node_modules/core-js/modules/_is-array-iter.js");
var toLength = __webpack_require__("./node_modules/core-js/modules/_to-length.js");
var createProperty = __webpack_require__("./node_modules/core-js/modules/_create-property.js");
var getIterFn = __webpack_require__("./node_modules/core-js/modules/core.get-iterator-method.js");

$export($export.S + $export.F * !__webpack_require__("./node_modules/core-js/modules/_iter-detect.js")(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.array.index-of.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var $indexOf = __webpack_require__("./node_modules/core-js/modules/_array-includes.js")(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__("./node_modules/core-js/modules/_strict-method.js")($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.array.is-array.js":
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.S, 'Array', { isArray: __webpack_require__("./node_modules/core-js/modules/_is-array.js") });


/***/ }),

/***/ "./node_modules/core-js/modules/es6.array.iterator.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__("./node_modules/core-js/modules/_add-to-unscopables.js");
var step = __webpack_require__("./node_modules/core-js/modules/_iter-step.js");
var Iterators = __webpack_require__("./node_modules/core-js/modules/_iterators.js");
var toIObject = __webpack_require__("./node_modules/core-js/modules/_to-iobject.js");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__("./node_modules/core-js/modules/_iter-define.js")(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "./node_modules/core-js/modules/es6.array.join.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var toIObject = __webpack_require__("./node_modules/core-js/modules/_to-iobject.js");
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__("./node_modules/core-js/modules/_iobject.js") != Object || !__webpack_require__("./node_modules/core-js/modules/_strict-method.js")(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.array.last-index-of.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var toIObject = __webpack_require__("./node_modules/core-js/modules/_to-iobject.js");
var toInteger = __webpack_require__("./node_modules/core-js/modules/_to-integer.js");
var toLength = __webpack_require__("./node_modules/core-js/modules/_to-length.js");
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__("./node_modules/core-js/modules/_strict-method.js")($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.array.map.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var $map = __webpack_require__("./node_modules/core-js/modules/_array-methods.js")(1);

$export($export.P + $export.F * !__webpack_require__("./node_modules/core-js/modules/_strict-method.js")([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.array.of.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var createProperty = __webpack_require__("./node_modules/core-js/modules/_create-property.js");

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__("./node_modules/core-js/modules/_fails.js")(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.array.reduce-right.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var $reduce = __webpack_require__("./node_modules/core-js/modules/_array-reduce.js");

$export($export.P + $export.F * !__webpack_require__("./node_modules/core-js/modules/_strict-method.js")([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.array.reduce.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var $reduce = __webpack_require__("./node_modules/core-js/modules/_array-reduce.js");

$export($export.P + $export.F * !__webpack_require__("./node_modules/core-js/modules/_strict-method.js")([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.array.slice.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var html = __webpack_require__("./node_modules/core-js/modules/_html.js");
var cof = __webpack_require__("./node_modules/core-js/modules/_cof.js");
var toAbsoluteIndex = __webpack_require__("./node_modules/core-js/modules/_to-absolute-index.js");
var toLength = __webpack_require__("./node_modules/core-js/modules/_to-length.js");
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__("./node_modules/core-js/modules/_fails.js")(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.array.some.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var $some = __webpack_require__("./node_modules/core-js/modules/_array-methods.js")(3);

$export($export.P + $export.F * !__webpack_require__("./node_modules/core-js/modules/_strict-method.js")([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.array.sort.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var aFunction = __webpack_require__("./node_modules/core-js/modules/_a-function.js");
var toObject = __webpack_require__("./node_modules/core-js/modules/_to-object.js");
var fails = __webpack_require__("./node_modules/core-js/modules/_fails.js");
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__("./node_modules/core-js/modules/_strict-method.js")($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.array.species.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/modules/_set-species.js")('Array');


/***/ }),

/***/ "./node_modules/core-js/modules/es6.date.now.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),

/***/ "./node_modules/core-js/modules/es6.date.to-iso-string.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var toISOString = __webpack_require__("./node_modules/core-js/modules/_date-to-iso-string.js");

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.date.to-json.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var toObject = __webpack_require__("./node_modules/core-js/modules/_to-object.js");
var toPrimitive = __webpack_require__("./node_modules/core-js/modules/_to-primitive.js");

$export($export.P + $export.F * __webpack_require__("./node_modules/core-js/modules/_fails.js")(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.date.to-primitive.js":
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__("./node_modules/core-js/modules/_wks.js")('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__("./node_modules/core-js/modules/_hide.js")(proto, TO_PRIMITIVE, __webpack_require__("./node_modules/core-js/modules/_date-to-primitive.js"));


/***/ }),

/***/ "./node_modules/core-js/modules/es6.date.to-string.js":
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__("./node_modules/core-js/modules/_redefine.js")(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),

/***/ "./node_modules/core-js/modules/es6.function.bind.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.P, 'Function', { bind: __webpack_require__("./node_modules/core-js/modules/_bind.js") });


/***/ }),

/***/ "./node_modules/core-js/modules/es6.function.has-instance.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");
var getPrototypeOf = __webpack_require__("./node_modules/core-js/modules/_object-gpo.js");
var HAS_INSTANCE = __webpack_require__("./node_modules/core-js/modules/_wks.js")('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__("./node_modules/core-js/modules/_object-dp.js").f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),

/***/ "./node_modules/core-js/modules/es6.function.name.js":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("./node_modules/core-js/modules/_object-dp.js").f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__("./node_modules/core-js/modules/_descriptors.js") && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.map.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__("./node_modules/core-js/modules/_collection-strong.js");
var validate = __webpack_require__("./node_modules/core-js/modules/_validate-collection.js");
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__("./node_modules/core-js/modules/_collection.js")(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),

/***/ "./node_modules/core-js/modules/es6.math.acosh.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var log1p = __webpack_require__("./node_modules/core-js/modules/_math-log1p.js");
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.math.asinh.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),

/***/ "./node_modules/core-js/modules/es6.math.atanh.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.math.cbrt.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var sign = __webpack_require__("./node_modules/core-js/modules/_math-sign.js");

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.math.clz32.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.math.cosh.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.math.expm1.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var $expm1 = __webpack_require__("./node_modules/core-js/modules/_math-expm1.js");

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),

/***/ "./node_modules/core-js/modules/es6.math.fround.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.S, 'Math', { fround: __webpack_require__("./node_modules/core-js/modules/_math-fround.js") });


/***/ }),

/***/ "./node_modules/core-js/modules/es6.math.hypot.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.math.imul.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__("./node_modules/core-js/modules/_fails.js")(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.math.log10.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.math.log1p.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.S, 'Math', { log1p: __webpack_require__("./node_modules/core-js/modules/_math-log1p.js") });


/***/ }),

/***/ "./node_modules/core-js/modules/es6.math.log2.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.math.sign.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.S, 'Math', { sign: __webpack_require__("./node_modules/core-js/modules/_math-sign.js") });


/***/ }),

/***/ "./node_modules/core-js/modules/es6.math.sinh.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var expm1 = __webpack_require__("./node_modules/core-js/modules/_math-expm1.js");
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__("./node_modules/core-js/modules/_fails.js")(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.math.tanh.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var expm1 = __webpack_require__("./node_modules/core-js/modules/_math-expm1.js");
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.math.trunc.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.number.constructor.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("./node_modules/core-js/modules/_global.js");
var has = __webpack_require__("./node_modules/core-js/modules/_has.js");
var cof = __webpack_require__("./node_modules/core-js/modules/_cof.js");
var inheritIfRequired = __webpack_require__("./node_modules/core-js/modules/_inherit-if-required.js");
var toPrimitive = __webpack_require__("./node_modules/core-js/modules/_to-primitive.js");
var fails = __webpack_require__("./node_modules/core-js/modules/_fails.js");
var gOPN = __webpack_require__("./node_modules/core-js/modules/_object-gopn.js").f;
var gOPD = __webpack_require__("./node_modules/core-js/modules/_object-gopd.js").f;
var dP = __webpack_require__("./node_modules/core-js/modules/_object-dp.js").f;
var $trim = __webpack_require__("./node_modules/core-js/modules/_string-trim.js").trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__("./node_modules/core-js/modules/_object-create.js")(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__("./node_modules/core-js/modules/_descriptors.js") ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__("./node_modules/core-js/modules/_redefine.js")(global, NUMBER, $Number);
}


/***/ }),

/***/ "./node_modules/core-js/modules/es6.number.epsilon.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),

/***/ "./node_modules/core-js/modules/es6.number.is-finite.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var _isFinite = __webpack_require__("./node_modules/core-js/modules/_global.js").isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.number.is-integer.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.S, 'Number', { isInteger: __webpack_require__("./node_modules/core-js/modules/_is-integer.js") });


/***/ }),

/***/ "./node_modules/core-js/modules/es6.number.is-nan.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.number.is-safe-integer.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var isInteger = __webpack_require__("./node_modules/core-js/modules/_is-integer.js");
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.number.max-safe-integer.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),

/***/ "./node_modules/core-js/modules/es6.number.min-safe-integer.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),

/***/ "./node_modules/core-js/modules/es6.number.parse-float.js":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var $parseFloat = __webpack_require__("./node_modules/core-js/modules/_parse-float.js");
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),

/***/ "./node_modules/core-js/modules/es6.number.parse-int.js":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var $parseInt = __webpack_require__("./node_modules/core-js/modules/_parse-int.js");
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),

/***/ "./node_modules/core-js/modules/es6.number.to-fixed.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var toInteger = __webpack_require__("./node_modules/core-js/modules/_to-integer.js");
var aNumberValue = __webpack_require__("./node_modules/core-js/modules/_a-number-value.js");
var repeat = __webpack_require__("./node_modules/core-js/modules/_string-repeat.js");
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__("./node_modules/core-js/modules/_fails.js")(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.number.to-precision.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var $fails = __webpack_require__("./node_modules/core-js/modules/_fails.js");
var aNumberValue = __webpack_require__("./node_modules/core-js/modules/_a-number-value.js");
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.object.assign.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.S + $export.F, 'Object', { assign: __webpack_require__("./node_modules/core-js/modules/_object-assign.js") });


/***/ }),

/***/ "./node_modules/core-js/modules/es6.object.create.js":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__("./node_modules/core-js/modules/_object-create.js") });


/***/ }),

/***/ "./node_modules/core-js/modules/es6.object.define-properties.js":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__("./node_modules/core-js/modules/_descriptors.js"), 'Object', { defineProperties: __webpack_require__("./node_modules/core-js/modules/_object-dps.js") });


/***/ }),

/***/ "./node_modules/core-js/modules/es6.object.define-property.js":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__("./node_modules/core-js/modules/_descriptors.js"), 'Object', { defineProperty: __webpack_require__("./node_modules/core-js/modules/_object-dp.js").f });


/***/ }),

/***/ "./node_modules/core-js/modules/es6.object.freeze.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");
var meta = __webpack_require__("./node_modules/core-js/modules/_meta.js").onFreeze;

__webpack_require__("./node_modules/core-js/modules/_object-sap.js")('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.object.get-own-property-descriptor.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__("./node_modules/core-js/modules/_to-iobject.js");
var $getOwnPropertyDescriptor = __webpack_require__("./node_modules/core-js/modules/_object-gopd.js").f;

__webpack_require__("./node_modules/core-js/modules/_object-sap.js")('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.object.get-own-property-names.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__("./node_modules/core-js/modules/_object-sap.js")('getOwnPropertyNames', function () {
  return __webpack_require__("./node_modules/core-js/modules/_object-gopn-ext.js").f;
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.object.get-prototype-of.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__("./node_modules/core-js/modules/_to-object.js");
var $getPrototypeOf = __webpack_require__("./node_modules/core-js/modules/_object-gpo.js");

__webpack_require__("./node_modules/core-js/modules/_object-sap.js")('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.object.is-extensible.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");

__webpack_require__("./node_modules/core-js/modules/_object-sap.js")('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.object.is-frozen.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");

__webpack_require__("./node_modules/core-js/modules/_object-sap.js")('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.object.is-sealed.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");

__webpack_require__("./node_modules/core-js/modules/_object-sap.js")('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.object.is.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
$export($export.S, 'Object', { is: __webpack_require__("./node_modules/core-js/modules/_same-value.js") });


/***/ }),

/***/ "./node_modules/core-js/modules/es6.object.keys.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__("./node_modules/core-js/modules/_to-object.js");
var $keys = __webpack_require__("./node_modules/core-js/modules/_object-keys.js");

__webpack_require__("./node_modules/core-js/modules/_object-sap.js")('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.object.prevent-extensions.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");
var meta = __webpack_require__("./node_modules/core-js/modules/_meta.js").onFreeze;

__webpack_require__("./node_modules/core-js/modules/_object-sap.js")('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.object.seal.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");
var meta = __webpack_require__("./node_modules/core-js/modules/_meta.js").onFreeze;

__webpack_require__("./node_modules/core-js/modules/_object-sap.js")('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.object.set-prototype-of.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__("./node_modules/core-js/modules/_set-proto.js").set });


/***/ }),

/***/ "./node_modules/core-js/modules/es6.object.to-string.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__("./node_modules/core-js/modules/_classof.js");
var test = {};
test[__webpack_require__("./node_modules/core-js/modules/_wks.js")('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__("./node_modules/core-js/modules/_redefine.js")(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),

/***/ "./node_modules/core-js/modules/es6.parse-float.js":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var $parseFloat = __webpack_require__("./node_modules/core-js/modules/_parse-float.js");
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),

/***/ "./node_modules/core-js/modules/es6.parse-int.js":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var $parseInt = __webpack_require__("./node_modules/core-js/modules/_parse-int.js");
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),

/***/ "./node_modules/core-js/modules/es6.promise.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("./node_modules/core-js/modules/_library.js");
var global = __webpack_require__("./node_modules/core-js/modules/_global.js");
var ctx = __webpack_require__("./node_modules/core-js/modules/_ctx.js");
var classof = __webpack_require__("./node_modules/core-js/modules/_classof.js");
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");
var aFunction = __webpack_require__("./node_modules/core-js/modules/_a-function.js");
var anInstance = __webpack_require__("./node_modules/core-js/modules/_an-instance.js");
var forOf = __webpack_require__("./node_modules/core-js/modules/_for-of.js");
var speciesConstructor = __webpack_require__("./node_modules/core-js/modules/_species-constructor.js");
var task = __webpack_require__("./node_modules/core-js/modules/_task.js").set;
var microtask = __webpack_require__("./node_modules/core-js/modules/_microtask.js")();
var newPromiseCapabilityModule = __webpack_require__("./node_modules/core-js/modules/_new-promise-capability.js");
var perform = __webpack_require__("./node_modules/core-js/modules/_perform.js");
var userAgent = __webpack_require__("./node_modules/core-js/modules/_user-agent.js");
var promiseResolve = __webpack_require__("./node_modules/core-js/modules/_promise-resolve.js");
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__("./node_modules/core-js/modules/_wks.js")('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__("./node_modules/core-js/modules/_redefine-all.js")($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__("./node_modules/core-js/modules/_set-to-string-tag.js")($Promise, PROMISE);
__webpack_require__("./node_modules/core-js/modules/_set-species.js")(PROMISE);
Wrapper = __webpack_require__("./node_modules/core-js/modules/_core.js")[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__("./node_modules/core-js/modules/_iter-detect.js")(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.reflect.apply.js":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var aFunction = __webpack_require__("./node_modules/core-js/modules/_a-function.js");
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var rApply = (__webpack_require__("./node_modules/core-js/modules/_global.js").Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__("./node_modules/core-js/modules/_fails.js")(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.reflect.construct.js":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var create = __webpack_require__("./node_modules/core-js/modules/_object-create.js");
var aFunction = __webpack_require__("./node_modules/core-js/modules/_a-function.js");
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");
var fails = __webpack_require__("./node_modules/core-js/modules/_fails.js");
var bind = __webpack_require__("./node_modules/core-js/modules/_bind.js");
var rConstruct = (__webpack_require__("./node_modules/core-js/modules/_global.js").Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.reflect.define-property.js":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__("./node_modules/core-js/modules/_object-dp.js");
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var toPrimitive = __webpack_require__("./node_modules/core-js/modules/_to-primitive.js");

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__("./node_modules/core-js/modules/_fails.js")(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.reflect.delete-property.js":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var gOPD = __webpack_require__("./node_modules/core-js/modules/_object-gopd.js").f;
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.reflect.enumerate.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__("./node_modules/core-js/modules/_iter-create.js")(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.reflect.get-own-property-descriptor.js":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__("./node_modules/core-js/modules/_object-gopd.js");
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.reflect.get-prototype-of.js":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var getProto = __webpack_require__("./node_modules/core-js/modules/_object-gpo.js");
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.reflect.get.js":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__("./node_modules/core-js/modules/_object-gopd.js");
var getPrototypeOf = __webpack_require__("./node_modules/core-js/modules/_object-gpo.js");
var has = __webpack_require__("./node_modules/core-js/modules/_has.js");
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),

/***/ "./node_modules/core-js/modules/es6.reflect.has.js":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.reflect.is-extensible.js":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.reflect.own-keys.js":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.S, 'Reflect', { ownKeys: __webpack_require__("./node_modules/core-js/modules/_own-keys.js") });


/***/ }),

/***/ "./node_modules/core-js/modules/es6.reflect.prevent-extensions.js":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.reflect.set-prototype-of.js":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var setProto = __webpack_require__("./node_modules/core-js/modules/_set-proto.js");

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.reflect.set.js":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__("./node_modules/core-js/modules/_object-dp.js");
var gOPD = __webpack_require__("./node_modules/core-js/modules/_object-gopd.js");
var getPrototypeOf = __webpack_require__("./node_modules/core-js/modules/_object-gpo.js");
var has = __webpack_require__("./node_modules/core-js/modules/_has.js");
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var createDesc = __webpack_require__("./node_modules/core-js/modules/_property-desc.js");
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),

/***/ "./node_modules/core-js/modules/es6.regexp.constructor.js":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("./node_modules/core-js/modules/_global.js");
var inheritIfRequired = __webpack_require__("./node_modules/core-js/modules/_inherit-if-required.js");
var dP = __webpack_require__("./node_modules/core-js/modules/_object-dp.js").f;
var gOPN = __webpack_require__("./node_modules/core-js/modules/_object-gopn.js").f;
var isRegExp = __webpack_require__("./node_modules/core-js/modules/_is-regexp.js");
var $flags = __webpack_require__("./node_modules/core-js/modules/_flags.js");
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__("./node_modules/core-js/modules/_descriptors.js") && (!CORRECT_NEW || __webpack_require__("./node_modules/core-js/modules/_fails.js")(function () {
  re2[__webpack_require__("./node_modules/core-js/modules/_wks.js")('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__("./node_modules/core-js/modules/_redefine.js")(global, 'RegExp', $RegExp);
}

__webpack_require__("./node_modules/core-js/modules/_set-species.js")('RegExp');


/***/ }),

/***/ "./node_modules/core-js/modules/es6.regexp.flags.js":
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__("./node_modules/core-js/modules/_descriptors.js") && /./g.flags != 'g') __webpack_require__("./node_modules/core-js/modules/_object-dp.js").f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__("./node_modules/core-js/modules/_flags.js")
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.regexp.match.js":
/***/ (function(module, exports, __webpack_require__) {

// @@match logic
__webpack_require__("./node_modules/core-js/modules/_fix-re-wks.js")('match', 1, function (defined, MATCH, $match) {
  // 21.1.3.11 String.prototype.match(regexp)
  return [function match(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[MATCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
  }, $match];
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.regexp.replace.js":
/***/ (function(module, exports, __webpack_require__) {

// @@replace logic
__webpack_require__("./node_modules/core-js/modules/_fix-re-wks.js")('replace', 2, function (defined, REPLACE, $replace) {
  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
  return [function replace(searchValue, replaceValue) {
    'use strict';
    var O = defined(this);
    var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
    return fn !== undefined
      ? fn.call(searchValue, O, replaceValue)
      : $replace.call(String(O), searchValue, replaceValue);
  }, $replace];
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.regexp.search.js":
/***/ (function(module, exports, __webpack_require__) {

// @@search logic
__webpack_require__("./node_modules/core-js/modules/_fix-re-wks.js")('search', 1, function (defined, SEARCH, $search) {
  // 21.1.3.15 String.prototype.search(regexp)
  return [function search(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[SEARCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
  }, $search];
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.regexp.split.js":
/***/ (function(module, exports, __webpack_require__) {

// @@split logic
__webpack_require__("./node_modules/core-js/modules/_fix-re-wks.js")('split', 2, function (defined, SPLIT, $split) {
  'use strict';
  var isRegExp = __webpack_require__("./node_modules/core-js/modules/_is-regexp.js");
  var _split = $split;
  var $push = [].push;
  var $SPLIT = 'split';
  var LENGTH = 'length';
  var LAST_INDEX = 'lastIndex';
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
    // based on es5-shim implementation, need to rework it
    $split = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return _split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var separator2, match, lastIndex, lastLength, i;
      // Doesn't need flags gy, but they don't hurt
      if (!NPCG) separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
      while (match = separatorCopy.exec(string)) {
        // `separatorCopy.lastIndex` is not reliable cross-browser
        lastIndex = match.index + match[0][LENGTH];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
          // eslint-disable-next-line no-loop-func
          if (!NPCG && match[LENGTH] > 1) match[0].replace(separator2, function () {
            for (i = 1; i < arguments[LENGTH] - 2; i++) if (arguments[i] === undefined) match[i] = undefined;
          });
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    $split = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
    };
  }
  // 21.1.3.17 String.prototype.split(separator, limit)
  return [function split(separator, limit) {
    var O = defined(this);
    var fn = separator == undefined ? undefined : separator[SPLIT];
    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
  }, $split];
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.regexp.to-string.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__("./node_modules/core-js/modules/es6.regexp.flags.js");
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var $flags = __webpack_require__("./node_modules/core-js/modules/_flags.js");
var DESCRIPTORS = __webpack_require__("./node_modules/core-js/modules/_descriptors.js");
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__("./node_modules/core-js/modules/_redefine.js")(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__("./node_modules/core-js/modules/_fails.js")(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),

/***/ "./node_modules/core-js/modules/es6.set.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__("./node_modules/core-js/modules/_collection-strong.js");
var validate = __webpack_require__("./node_modules/core-js/modules/_validate-collection.js");
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__("./node_modules/core-js/modules/_collection.js")(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),

/***/ "./node_modules/core-js/modules/es6.string.anchor.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__("./node_modules/core-js/modules/_string-html.js")('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.string.big.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__("./node_modules/core-js/modules/_string-html.js")('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.string.blink.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__("./node_modules/core-js/modules/_string-html.js")('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.string.bold.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__("./node_modules/core-js/modules/_string-html.js")('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.string.code-point-at.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var $at = __webpack_require__("./node_modules/core-js/modules/_string-at.js")(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.string.ends-with.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var toLength = __webpack_require__("./node_modules/core-js/modules/_to-length.js");
var context = __webpack_require__("./node_modules/core-js/modules/_string-context.js");
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__("./node_modules/core-js/modules/_fails-is-regexp.js")(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.string.fixed.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__("./node_modules/core-js/modules/_string-html.js")('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.string.fontcolor.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__("./node_modules/core-js/modules/_string-html.js")('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.string.fontsize.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__("./node_modules/core-js/modules/_string-html.js")('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.string.from-code-point.js":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var toAbsoluteIndex = __webpack_require__("./node_modules/core-js/modules/_to-absolute-index.js");
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.string.includes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var context = __webpack_require__("./node_modules/core-js/modules/_string-context.js");
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__("./node_modules/core-js/modules/_fails-is-regexp.js")(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.string.italics.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__("./node_modules/core-js/modules/_string-html.js")('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.string.iterator.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__("./node_modules/core-js/modules/_string-at.js")(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__("./node_modules/core-js/modules/_iter-define.js")(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.string.link.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__("./node_modules/core-js/modules/_string-html.js")('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.string.raw.js":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var toIObject = __webpack_require__("./node_modules/core-js/modules/_to-iobject.js");
var toLength = __webpack_require__("./node_modules/core-js/modules/_to-length.js");

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.string.repeat.js":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__("./node_modules/core-js/modules/_string-repeat.js")
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.string.small.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__("./node_modules/core-js/modules/_string-html.js")('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.string.starts-with.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var toLength = __webpack_require__("./node_modules/core-js/modules/_to-length.js");
var context = __webpack_require__("./node_modules/core-js/modules/_string-context.js");
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__("./node_modules/core-js/modules/_fails-is-regexp.js")(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.string.strike.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__("./node_modules/core-js/modules/_string-html.js")('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.string.sub.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__("./node_modules/core-js/modules/_string-html.js")('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.string.sup.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__("./node_modules/core-js/modules/_string-html.js")('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.string.trim.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__("./node_modules/core-js/modules/_string-trim.js")('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.symbol.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__("./node_modules/core-js/modules/_global.js");
var has = __webpack_require__("./node_modules/core-js/modules/_has.js");
var DESCRIPTORS = __webpack_require__("./node_modules/core-js/modules/_descriptors.js");
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var redefine = __webpack_require__("./node_modules/core-js/modules/_redefine.js");
var META = __webpack_require__("./node_modules/core-js/modules/_meta.js").KEY;
var $fails = __webpack_require__("./node_modules/core-js/modules/_fails.js");
var shared = __webpack_require__("./node_modules/core-js/modules/_shared.js");
var setToStringTag = __webpack_require__("./node_modules/core-js/modules/_set-to-string-tag.js");
var uid = __webpack_require__("./node_modules/core-js/modules/_uid.js");
var wks = __webpack_require__("./node_modules/core-js/modules/_wks.js");
var wksExt = __webpack_require__("./node_modules/core-js/modules/_wks-ext.js");
var wksDefine = __webpack_require__("./node_modules/core-js/modules/_wks-define.js");
var enumKeys = __webpack_require__("./node_modules/core-js/modules/_enum-keys.js");
var isArray = __webpack_require__("./node_modules/core-js/modules/_is-array.js");
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");
var toIObject = __webpack_require__("./node_modules/core-js/modules/_to-iobject.js");
var toPrimitive = __webpack_require__("./node_modules/core-js/modules/_to-primitive.js");
var createDesc = __webpack_require__("./node_modules/core-js/modules/_property-desc.js");
var _create = __webpack_require__("./node_modules/core-js/modules/_object-create.js");
var gOPNExt = __webpack_require__("./node_modules/core-js/modules/_object-gopn-ext.js");
var $GOPD = __webpack_require__("./node_modules/core-js/modules/_object-gopd.js");
var $DP = __webpack_require__("./node_modules/core-js/modules/_object-dp.js");
var $keys = __webpack_require__("./node_modules/core-js/modules/_object-keys.js");
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__("./node_modules/core-js/modules/_object-gopn.js").f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__("./node_modules/core-js/modules/_object-pie.js").f = $propertyIsEnumerable;
  __webpack_require__("./node_modules/core-js/modules/_object-gops.js").f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__("./node_modules/core-js/modules/_library.js")) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__("./node_modules/core-js/modules/_hide.js")($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),

/***/ "./node_modules/core-js/modules/es6.typed.array-buffer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var $typed = __webpack_require__("./node_modules/core-js/modules/_typed.js");
var buffer = __webpack_require__("./node_modules/core-js/modules/_typed-buffer.js");
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var toAbsoluteIndex = __webpack_require__("./node_modules/core-js/modules/_to-absolute-index.js");
var toLength = __webpack_require__("./node_modules/core-js/modules/_to-length.js");
var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");
var ArrayBuffer = __webpack_require__("./node_modules/core-js/modules/_global.js").ArrayBuffer;
var speciesConstructor = __webpack_require__("./node_modules/core-js/modules/_species-constructor.js");
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__("./node_modules/core-js/modules/_fails.js")(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var final = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < final) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__("./node_modules/core-js/modules/_set-species.js")(ARRAY_BUFFER);


/***/ }),

/***/ "./node_modules/core-js/modules/es6.typed.data-view.js":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
$export($export.G + $export.W + $export.F * !__webpack_require__("./node_modules/core-js/modules/_typed.js").ABV, {
  DataView: __webpack_require__("./node_modules/core-js/modules/_typed-buffer.js").DataView
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.typed.float32-array.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/modules/_typed-array.js")('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.typed.float64-array.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/modules/_typed-array.js")('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.typed.int16-array.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/modules/_typed-array.js")('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.typed.int32-array.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/modules/_typed-array.js")('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.typed.int8-array.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/modules/_typed-array.js")('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.typed.uint16-array.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/modules/_typed-array.js")('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.typed.uint32-array.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/modules/_typed-array.js")('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.typed.uint8-array.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/modules/_typed-array.js")('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.typed.uint8-clamped-array.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/modules/_typed-array.js")('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),

/***/ "./node_modules/core-js/modules/es6.weak-map.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var each = __webpack_require__("./node_modules/core-js/modules/_array-methods.js")(0);
var redefine = __webpack_require__("./node_modules/core-js/modules/_redefine.js");
var meta = __webpack_require__("./node_modules/core-js/modules/_meta.js");
var assign = __webpack_require__("./node_modules/core-js/modules/_object-assign.js");
var weak = __webpack_require__("./node_modules/core-js/modules/_collection-weak.js");
var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");
var fails = __webpack_require__("./node_modules/core-js/modules/_fails.js");
var validate = __webpack_require__("./node_modules/core-js/modules/_validate-collection.js");
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var tmp = {};
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__("./node_modules/core-js/modules/_collection.js")(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),

/***/ "./node_modules/core-js/modules/es6.weak-set.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__("./node_modules/core-js/modules/_collection-weak.js");
var validate = __webpack_require__("./node_modules/core-js/modules/_validate-collection.js");
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__("./node_modules/core-js/modules/_collection.js")(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),

/***/ "./node_modules/core-js/modules/es7.array.flat-map.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var flattenIntoArray = __webpack_require__("./node_modules/core-js/modules/_flatten-into-array.js");
var toObject = __webpack_require__("./node_modules/core-js/modules/_to-object.js");
var toLength = __webpack_require__("./node_modules/core-js/modules/_to-length.js");
var aFunction = __webpack_require__("./node_modules/core-js/modules/_a-function.js");
var arraySpeciesCreate = __webpack_require__("./node_modules/core-js/modules/_array-species-create.js");

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__("./node_modules/core-js/modules/_add-to-unscopables.js")('flatMap');


/***/ }),

/***/ "./node_modules/core-js/modules/es7.array.flatten.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var flattenIntoArray = __webpack_require__("./node_modules/core-js/modules/_flatten-into-array.js");
var toObject = __webpack_require__("./node_modules/core-js/modules/_to-object.js");
var toLength = __webpack_require__("./node_modules/core-js/modules/_to-length.js");
var toInteger = __webpack_require__("./node_modules/core-js/modules/_to-integer.js");
var arraySpeciesCreate = __webpack_require__("./node_modules/core-js/modules/_array-species-create.js");

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__("./node_modules/core-js/modules/_add-to-unscopables.js")('flatten');


/***/ }),

/***/ "./node_modules/core-js/modules/es7.array.includes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var $includes = __webpack_require__("./node_modules/core-js/modules/_array-includes.js")(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__("./node_modules/core-js/modules/_add-to-unscopables.js")('includes');


/***/ }),

/***/ "./node_modules/core-js/modules/es7.asap.js":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var microtask = __webpack_require__("./node_modules/core-js/modules/_microtask.js")();
var process = __webpack_require__("./node_modules/core-js/modules/_global.js").process;
var isNode = __webpack_require__("./node_modules/core-js/modules/_cof.js")(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es7.error.is-error.js":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var cof = __webpack_require__("./node_modules/core-js/modules/_cof.js");

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es7.global.js":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.G, { global: __webpack_require__("./node_modules/core-js/modules/_global.js") });


/***/ }),

/***/ "./node_modules/core-js/modules/es7.map.from.js":
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__("./node_modules/core-js/modules/_set-collection-from.js")('Map');


/***/ }),

/***/ "./node_modules/core-js/modules/es7.map.of.js":
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__("./node_modules/core-js/modules/_set-collection-of.js")('Map');


/***/ }),

/***/ "./node_modules/core-js/modules/es7.map.to-json.js":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__("./node_modules/core-js/modules/_collection-to-json.js")('Map') });


/***/ }),

/***/ "./node_modules/core-js/modules/es7.math.clamp.js":
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es7.math.deg-per-rad.js":
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),

/***/ "./node_modules/core-js/modules/es7.math.degrees.js":
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es7.math.fscale.js":
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var scale = __webpack_require__("./node_modules/core-js/modules/_math-scale.js");
var fround = __webpack_require__("./node_modules/core-js/modules/_math-fround.js");

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es7.math.iaddh.js":
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es7.math.imulh.js":
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es7.math.isubh.js":
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es7.math.rad-per-deg.js":
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),

/***/ "./node_modules/core-js/modules/es7.math.radians.js":
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es7.math.scale.js":
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.S, 'Math', { scale: __webpack_require__("./node_modules/core-js/modules/_math-scale.js") });


/***/ }),

/***/ "./node_modules/core-js/modules/es7.math.signbit.js":
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),

/***/ "./node_modules/core-js/modules/es7.math.umulh.js":
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es7.object.define-getter.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var toObject = __webpack_require__("./node_modules/core-js/modules/_to-object.js");
var aFunction = __webpack_require__("./node_modules/core-js/modules/_a-function.js");
var $defineProperty = __webpack_require__("./node_modules/core-js/modules/_object-dp.js");

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__("./node_modules/core-js/modules/_descriptors.js") && $export($export.P + __webpack_require__("./node_modules/core-js/modules/_object-forced-pam.js"), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es7.object.define-setter.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var toObject = __webpack_require__("./node_modules/core-js/modules/_to-object.js");
var aFunction = __webpack_require__("./node_modules/core-js/modules/_a-function.js");
var $defineProperty = __webpack_require__("./node_modules/core-js/modules/_object-dp.js");

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__("./node_modules/core-js/modules/_descriptors.js") && $export($export.P + __webpack_require__("./node_modules/core-js/modules/_object-forced-pam.js"), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es7.object.entries.js":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var $entries = __webpack_require__("./node_modules/core-js/modules/_object-to-array.js")(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var ownKeys = __webpack_require__("./node_modules/core-js/modules/_own-keys.js");
var toIObject = __webpack_require__("./node_modules/core-js/modules/_to-iobject.js");
var gOPD = __webpack_require__("./node_modules/core-js/modules/_object-gopd.js");
var createProperty = __webpack_require__("./node_modules/core-js/modules/_create-property.js");

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es7.object.lookup-getter.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var toObject = __webpack_require__("./node_modules/core-js/modules/_to-object.js");
var toPrimitive = __webpack_require__("./node_modules/core-js/modules/_to-primitive.js");
var getPrototypeOf = __webpack_require__("./node_modules/core-js/modules/_object-gpo.js");
var getOwnPropertyDescriptor = __webpack_require__("./node_modules/core-js/modules/_object-gopd.js").f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__("./node_modules/core-js/modules/_descriptors.js") && $export($export.P + __webpack_require__("./node_modules/core-js/modules/_object-forced-pam.js"), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es7.object.lookup-setter.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var toObject = __webpack_require__("./node_modules/core-js/modules/_to-object.js");
var toPrimitive = __webpack_require__("./node_modules/core-js/modules/_to-primitive.js");
var getPrototypeOf = __webpack_require__("./node_modules/core-js/modules/_object-gpo.js");
var getOwnPropertyDescriptor = __webpack_require__("./node_modules/core-js/modules/_object-gopd.js").f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__("./node_modules/core-js/modules/_descriptors.js") && $export($export.P + __webpack_require__("./node_modules/core-js/modules/_object-forced-pam.js"), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es7.object.values.js":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var $values = __webpack_require__("./node_modules/core-js/modules/_object-to-array.js")(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es7.observable.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var global = __webpack_require__("./node_modules/core-js/modules/_global.js");
var core = __webpack_require__("./node_modules/core-js/modules/_core.js");
var microtask = __webpack_require__("./node_modules/core-js/modules/_microtask.js")();
var OBSERVABLE = __webpack_require__("./node_modules/core-js/modules/_wks.js")('observable');
var aFunction = __webpack_require__("./node_modules/core-js/modules/_a-function.js");
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var anInstance = __webpack_require__("./node_modules/core-js/modules/_an-instance.js");
var redefineAll = __webpack_require__("./node_modules/core-js/modules/_redefine-all.js");
var hide = __webpack_require__("./node_modules/core-js/modules/_hide.js");
var forOf = __webpack_require__("./node_modules/core-js/modules/_for-of.js");
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__("./node_modules/core-js/modules/_set-species.js")('Observable');


/***/ }),

/***/ "./node_modules/core-js/modules/es7.promise.finally.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var core = __webpack_require__("./node_modules/core-js/modules/_core.js");
var global = __webpack_require__("./node_modules/core-js/modules/_global.js");
var speciesConstructor = __webpack_require__("./node_modules/core-js/modules/_species-constructor.js");
var promiseResolve = __webpack_require__("./node_modules/core-js/modules/_promise-resolve.js");

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),

/***/ "./node_modules/core-js/modules/es7.promise.try.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var newPromiseCapability = __webpack_require__("./node_modules/core-js/modules/_new-promise-capability.js");
var perform = __webpack_require__("./node_modules/core-js/modules/_perform.js");

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),

/***/ "./node_modules/core-js/modules/es7.reflect.define-metadata.js":
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__("./node_modules/core-js/modules/_metadata.js");
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),

/***/ "./node_modules/core-js/modules/es7.reflect.delete-metadata.js":
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__("./node_modules/core-js/modules/_metadata.js");
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),

/***/ "./node_modules/core-js/modules/es7.reflect.get-metadata-keys.js":
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__("./node_modules/core-js/modules/es6.set.js");
var from = __webpack_require__("./node_modules/core-js/modules/_array-from-iterable.js");
var metadata = __webpack_require__("./node_modules/core-js/modules/_metadata.js");
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var getPrototypeOf = __webpack_require__("./node_modules/core-js/modules/_object-gpo.js");
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),

/***/ "./node_modules/core-js/modules/es7.reflect.get-metadata.js":
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__("./node_modules/core-js/modules/_metadata.js");
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var getPrototypeOf = __webpack_require__("./node_modules/core-js/modules/_object-gpo.js");
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),

/***/ "./node_modules/core-js/modules/es7.reflect.get-own-metadata-keys.js":
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__("./node_modules/core-js/modules/_metadata.js");
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),

/***/ "./node_modules/core-js/modules/es7.reflect.get-own-metadata.js":
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__("./node_modules/core-js/modules/_metadata.js");
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),

/***/ "./node_modules/core-js/modules/es7.reflect.has-metadata.js":
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__("./node_modules/core-js/modules/_metadata.js");
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var getPrototypeOf = __webpack_require__("./node_modules/core-js/modules/_object-gpo.js");
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),

/***/ "./node_modules/core-js/modules/es7.reflect.has-own-metadata.js":
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__("./node_modules/core-js/modules/_metadata.js");
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),

/***/ "./node_modules/core-js/modules/es7.reflect.metadata.js":
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__("./node_modules/core-js/modules/_metadata.js");
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var aFunction = __webpack_require__("./node_modules/core-js/modules/_a-function.js");
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),

/***/ "./node_modules/core-js/modules/es7.set.from.js":
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__("./node_modules/core-js/modules/_set-collection-from.js")('Set');


/***/ }),

/***/ "./node_modules/core-js/modules/es7.set.of.js":
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__("./node_modules/core-js/modules/_set-collection-of.js")('Set');


/***/ }),

/***/ "./node_modules/core-js/modules/es7.set.to-json.js":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__("./node_modules/core-js/modules/_collection-to-json.js")('Set') });


/***/ }),

/***/ "./node_modules/core-js/modules/es7.string.at.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var $at = __webpack_require__("./node_modules/core-js/modules/_string-at.js")(true);

$export($export.P, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es7.string.match-all.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var defined = __webpack_require__("./node_modules/core-js/modules/_defined.js");
var toLength = __webpack_require__("./node_modules/core-js/modules/_to-length.js");
var isRegExp = __webpack_require__("./node_modules/core-js/modules/_is-regexp.js");
var getFlags = __webpack_require__("./node_modules/core-js/modules/_flags.js");
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__("./node_modules/core-js/modules/_iter-create.js")($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es7.string.pad-end.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var $pad = __webpack_require__("./node_modules/core-js/modules/_string-pad.js");
var userAgent = __webpack_require__("./node_modules/core-js/modules/_user-agent.js");

// https://github.com/zloirock/core-js/issues/280
$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es7.string.pad-start.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var $pad = __webpack_require__("./node_modules/core-js/modules/_string-pad.js");
var userAgent = __webpack_require__("./node_modules/core-js/modules/_user-agent.js");

// https://github.com/zloirock/core-js/issues/280
$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es7.string.trim-left.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__("./node_modules/core-js/modules/_string-trim.js")('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),

/***/ "./node_modules/core-js/modules/es7.string.trim-right.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__("./node_modules/core-js/modules/_string-trim.js")('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),

/***/ "./node_modules/core-js/modules/es7.symbol.async-iterator.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/modules/_wks-define.js")('asyncIterator');


/***/ }),

/***/ "./node_modules/core-js/modules/es7.symbol.observable.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/modules/_wks-define.js")('observable');


/***/ }),

/***/ "./node_modules/core-js/modules/es7.system.global.js":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.S, 'System', { global: __webpack_require__("./node_modules/core-js/modules/_global.js") });


/***/ }),

/***/ "./node_modules/core-js/modules/es7.weak-map.from.js":
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__("./node_modules/core-js/modules/_set-collection-from.js")('WeakMap');


/***/ }),

/***/ "./node_modules/core-js/modules/es7.weak-map.of.js":
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__("./node_modules/core-js/modules/_set-collection-of.js")('WeakMap');


/***/ }),

/***/ "./node_modules/core-js/modules/es7.weak-set.from.js":
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__("./node_modules/core-js/modules/_set-collection-from.js")('WeakSet');


/***/ }),

/***/ "./node_modules/core-js/modules/es7.weak-set.of.js":
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__("./node_modules/core-js/modules/_set-collection-of.js")('WeakSet');


/***/ }),

/***/ "./node_modules/core-js/modules/web.dom.iterable.js":
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__("./node_modules/core-js/modules/es6.array.iterator.js");
var getKeys = __webpack_require__("./node_modules/core-js/modules/_object-keys.js");
var redefine = __webpack_require__("./node_modules/core-js/modules/_redefine.js");
var global = __webpack_require__("./node_modules/core-js/modules/_global.js");
var hide = __webpack_require__("./node_modules/core-js/modules/_hide.js");
var Iterators = __webpack_require__("./node_modules/core-js/modules/_iterators.js");
var wks = __webpack_require__("./node_modules/core-js/modules/_wks.js");
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),

/***/ "./node_modules/core-js/modules/web.immediate.js":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var $task = __webpack_require__("./node_modules/core-js/modules/_task.js");
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),

/***/ "./node_modules/core-js/modules/web.timers.js":
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__("./node_modules/core-js/modules/_global.js");
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var userAgent = __webpack_require__("./node_modules/core-js/modules/_user-agent.js");
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),

/***/ "./node_modules/core-js/shim.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/modules/es6.symbol.js");
__webpack_require__("./node_modules/core-js/modules/es6.object.create.js");
__webpack_require__("./node_modules/core-js/modules/es6.object.define-property.js");
__webpack_require__("./node_modules/core-js/modules/es6.object.define-properties.js");
__webpack_require__("./node_modules/core-js/modules/es6.object.get-own-property-descriptor.js");
__webpack_require__("./node_modules/core-js/modules/es6.object.get-prototype-of.js");
__webpack_require__("./node_modules/core-js/modules/es6.object.keys.js");
__webpack_require__("./node_modules/core-js/modules/es6.object.get-own-property-names.js");
__webpack_require__("./node_modules/core-js/modules/es6.object.freeze.js");
__webpack_require__("./node_modules/core-js/modules/es6.object.seal.js");
__webpack_require__("./node_modules/core-js/modules/es6.object.prevent-extensions.js");
__webpack_require__("./node_modules/core-js/modules/es6.object.is-frozen.js");
__webpack_require__("./node_modules/core-js/modules/es6.object.is-sealed.js");
__webpack_require__("./node_modules/core-js/modules/es6.object.is-extensible.js");
__webpack_require__("./node_modules/core-js/modules/es6.object.assign.js");
__webpack_require__("./node_modules/core-js/modules/es6.object.is.js");
__webpack_require__("./node_modules/core-js/modules/es6.object.set-prototype-of.js");
__webpack_require__("./node_modules/core-js/modules/es6.object.to-string.js");
__webpack_require__("./node_modules/core-js/modules/es6.function.bind.js");
__webpack_require__("./node_modules/core-js/modules/es6.function.name.js");
__webpack_require__("./node_modules/core-js/modules/es6.function.has-instance.js");
__webpack_require__("./node_modules/core-js/modules/es6.parse-int.js");
__webpack_require__("./node_modules/core-js/modules/es6.parse-float.js");
__webpack_require__("./node_modules/core-js/modules/es6.number.constructor.js");
__webpack_require__("./node_modules/core-js/modules/es6.number.to-fixed.js");
__webpack_require__("./node_modules/core-js/modules/es6.number.to-precision.js");
__webpack_require__("./node_modules/core-js/modules/es6.number.epsilon.js");
__webpack_require__("./node_modules/core-js/modules/es6.number.is-finite.js");
__webpack_require__("./node_modules/core-js/modules/es6.number.is-integer.js");
__webpack_require__("./node_modules/core-js/modules/es6.number.is-nan.js");
__webpack_require__("./node_modules/core-js/modules/es6.number.is-safe-integer.js");
__webpack_require__("./node_modules/core-js/modules/es6.number.max-safe-integer.js");
__webpack_require__("./node_modules/core-js/modules/es6.number.min-safe-integer.js");
__webpack_require__("./node_modules/core-js/modules/es6.number.parse-float.js");
__webpack_require__("./node_modules/core-js/modules/es6.number.parse-int.js");
__webpack_require__("./node_modules/core-js/modules/es6.math.acosh.js");
__webpack_require__("./node_modules/core-js/modules/es6.math.asinh.js");
__webpack_require__("./node_modules/core-js/modules/es6.math.atanh.js");
__webpack_require__("./node_modules/core-js/modules/es6.math.cbrt.js");
__webpack_require__("./node_modules/core-js/modules/es6.math.clz32.js");
__webpack_require__("./node_modules/core-js/modules/es6.math.cosh.js");
__webpack_require__("./node_modules/core-js/modules/es6.math.expm1.js");
__webpack_require__("./node_modules/core-js/modules/es6.math.fround.js");
__webpack_require__("./node_modules/core-js/modules/es6.math.hypot.js");
__webpack_require__("./node_modules/core-js/modules/es6.math.imul.js");
__webpack_require__("./node_modules/core-js/modules/es6.math.log10.js");
__webpack_require__("./node_modules/core-js/modules/es6.math.log1p.js");
__webpack_require__("./node_modules/core-js/modules/es6.math.log2.js");
__webpack_require__("./node_modules/core-js/modules/es6.math.sign.js");
__webpack_require__("./node_modules/core-js/modules/es6.math.sinh.js");
__webpack_require__("./node_modules/core-js/modules/es6.math.tanh.js");
__webpack_require__("./node_modules/core-js/modules/es6.math.trunc.js");
__webpack_require__("./node_modules/core-js/modules/es6.string.from-code-point.js");
__webpack_require__("./node_modules/core-js/modules/es6.string.raw.js");
__webpack_require__("./node_modules/core-js/modules/es6.string.trim.js");
__webpack_require__("./node_modules/core-js/modules/es6.string.iterator.js");
__webpack_require__("./node_modules/core-js/modules/es6.string.code-point-at.js");
__webpack_require__("./node_modules/core-js/modules/es6.string.ends-with.js");
__webpack_require__("./node_modules/core-js/modules/es6.string.includes.js");
__webpack_require__("./node_modules/core-js/modules/es6.string.repeat.js");
__webpack_require__("./node_modules/core-js/modules/es6.string.starts-with.js");
__webpack_require__("./node_modules/core-js/modules/es6.string.anchor.js");
__webpack_require__("./node_modules/core-js/modules/es6.string.big.js");
__webpack_require__("./node_modules/core-js/modules/es6.string.blink.js");
__webpack_require__("./node_modules/core-js/modules/es6.string.bold.js");
__webpack_require__("./node_modules/core-js/modules/es6.string.fixed.js");
__webpack_require__("./node_modules/core-js/modules/es6.string.fontcolor.js");
__webpack_require__("./node_modules/core-js/modules/es6.string.fontsize.js");
__webpack_require__("./node_modules/core-js/modules/es6.string.italics.js");
__webpack_require__("./node_modules/core-js/modules/es6.string.link.js");
__webpack_require__("./node_modules/core-js/modules/es6.string.small.js");
__webpack_require__("./node_modules/core-js/modules/es6.string.strike.js");
__webpack_require__("./node_modules/core-js/modules/es6.string.sub.js");
__webpack_require__("./node_modules/core-js/modules/es6.string.sup.js");
__webpack_require__("./node_modules/core-js/modules/es6.date.now.js");
__webpack_require__("./node_modules/core-js/modules/es6.date.to-json.js");
__webpack_require__("./node_modules/core-js/modules/es6.date.to-iso-string.js");
__webpack_require__("./node_modules/core-js/modules/es6.date.to-string.js");
__webpack_require__("./node_modules/core-js/modules/es6.date.to-primitive.js");
__webpack_require__("./node_modules/core-js/modules/es6.array.is-array.js");
__webpack_require__("./node_modules/core-js/modules/es6.array.from.js");
__webpack_require__("./node_modules/core-js/modules/es6.array.of.js");
__webpack_require__("./node_modules/core-js/modules/es6.array.join.js");
__webpack_require__("./node_modules/core-js/modules/es6.array.slice.js");
__webpack_require__("./node_modules/core-js/modules/es6.array.sort.js");
__webpack_require__("./node_modules/core-js/modules/es6.array.for-each.js");
__webpack_require__("./node_modules/core-js/modules/es6.array.map.js");
__webpack_require__("./node_modules/core-js/modules/es6.array.filter.js");
__webpack_require__("./node_modules/core-js/modules/es6.array.some.js");
__webpack_require__("./node_modules/core-js/modules/es6.array.every.js");
__webpack_require__("./node_modules/core-js/modules/es6.array.reduce.js");
__webpack_require__("./node_modules/core-js/modules/es6.array.reduce-right.js");
__webpack_require__("./node_modules/core-js/modules/es6.array.index-of.js");
__webpack_require__("./node_modules/core-js/modules/es6.array.last-index-of.js");
__webpack_require__("./node_modules/core-js/modules/es6.array.copy-within.js");
__webpack_require__("./node_modules/core-js/modules/es6.array.fill.js");
__webpack_require__("./node_modules/core-js/modules/es6.array.find.js");
__webpack_require__("./node_modules/core-js/modules/es6.array.find-index.js");
__webpack_require__("./node_modules/core-js/modules/es6.array.species.js");
__webpack_require__("./node_modules/core-js/modules/es6.array.iterator.js");
__webpack_require__("./node_modules/core-js/modules/es6.regexp.constructor.js");
__webpack_require__("./node_modules/core-js/modules/es6.regexp.to-string.js");
__webpack_require__("./node_modules/core-js/modules/es6.regexp.flags.js");
__webpack_require__("./node_modules/core-js/modules/es6.regexp.match.js");
__webpack_require__("./node_modules/core-js/modules/es6.regexp.replace.js");
__webpack_require__("./node_modules/core-js/modules/es6.regexp.search.js");
__webpack_require__("./node_modules/core-js/modules/es6.regexp.split.js");
__webpack_require__("./node_modules/core-js/modules/es6.promise.js");
__webpack_require__("./node_modules/core-js/modules/es6.map.js");
__webpack_require__("./node_modules/core-js/modules/es6.set.js");
__webpack_require__("./node_modules/core-js/modules/es6.weak-map.js");
__webpack_require__("./node_modules/core-js/modules/es6.weak-set.js");
__webpack_require__("./node_modules/core-js/modules/es6.typed.array-buffer.js");
__webpack_require__("./node_modules/core-js/modules/es6.typed.data-view.js");
__webpack_require__("./node_modules/core-js/modules/es6.typed.int8-array.js");
__webpack_require__("./node_modules/core-js/modules/es6.typed.uint8-array.js");
__webpack_require__("./node_modules/core-js/modules/es6.typed.uint8-clamped-array.js");
__webpack_require__("./node_modules/core-js/modules/es6.typed.int16-array.js");
__webpack_require__("./node_modules/core-js/modules/es6.typed.uint16-array.js");
__webpack_require__("./node_modules/core-js/modules/es6.typed.int32-array.js");
__webpack_require__("./node_modules/core-js/modules/es6.typed.uint32-array.js");
__webpack_require__("./node_modules/core-js/modules/es6.typed.float32-array.js");
__webpack_require__("./node_modules/core-js/modules/es6.typed.float64-array.js");
__webpack_require__("./node_modules/core-js/modules/es6.reflect.apply.js");
__webpack_require__("./node_modules/core-js/modules/es6.reflect.construct.js");
__webpack_require__("./node_modules/core-js/modules/es6.reflect.define-property.js");
__webpack_require__("./node_modules/core-js/modules/es6.reflect.delete-property.js");
__webpack_require__("./node_modules/core-js/modules/es6.reflect.enumerate.js");
__webpack_require__("./node_modules/core-js/modules/es6.reflect.get.js");
__webpack_require__("./node_modules/core-js/modules/es6.reflect.get-own-property-descriptor.js");
__webpack_require__("./node_modules/core-js/modules/es6.reflect.get-prototype-of.js");
__webpack_require__("./node_modules/core-js/modules/es6.reflect.has.js");
__webpack_require__("./node_modules/core-js/modules/es6.reflect.is-extensible.js");
__webpack_require__("./node_modules/core-js/modules/es6.reflect.own-keys.js");
__webpack_require__("./node_modules/core-js/modules/es6.reflect.prevent-extensions.js");
__webpack_require__("./node_modules/core-js/modules/es6.reflect.set.js");
__webpack_require__("./node_modules/core-js/modules/es6.reflect.set-prototype-of.js");
__webpack_require__("./node_modules/core-js/modules/es7.array.includes.js");
__webpack_require__("./node_modules/core-js/modules/es7.array.flat-map.js");
__webpack_require__("./node_modules/core-js/modules/es7.array.flatten.js");
__webpack_require__("./node_modules/core-js/modules/es7.string.at.js");
__webpack_require__("./node_modules/core-js/modules/es7.string.pad-start.js");
__webpack_require__("./node_modules/core-js/modules/es7.string.pad-end.js");
__webpack_require__("./node_modules/core-js/modules/es7.string.trim-left.js");
__webpack_require__("./node_modules/core-js/modules/es7.string.trim-right.js");
__webpack_require__("./node_modules/core-js/modules/es7.string.match-all.js");
__webpack_require__("./node_modules/core-js/modules/es7.symbol.async-iterator.js");
__webpack_require__("./node_modules/core-js/modules/es7.symbol.observable.js");
__webpack_require__("./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js");
__webpack_require__("./node_modules/core-js/modules/es7.object.values.js");
__webpack_require__("./node_modules/core-js/modules/es7.object.entries.js");
__webpack_require__("./node_modules/core-js/modules/es7.object.define-getter.js");
__webpack_require__("./node_modules/core-js/modules/es7.object.define-setter.js");
__webpack_require__("./node_modules/core-js/modules/es7.object.lookup-getter.js");
__webpack_require__("./node_modules/core-js/modules/es7.object.lookup-setter.js");
__webpack_require__("./node_modules/core-js/modules/es7.map.to-json.js");
__webpack_require__("./node_modules/core-js/modules/es7.set.to-json.js");
__webpack_require__("./node_modules/core-js/modules/es7.map.of.js");
__webpack_require__("./node_modules/core-js/modules/es7.set.of.js");
__webpack_require__("./node_modules/core-js/modules/es7.weak-map.of.js");
__webpack_require__("./node_modules/core-js/modules/es7.weak-set.of.js");
__webpack_require__("./node_modules/core-js/modules/es7.map.from.js");
__webpack_require__("./node_modules/core-js/modules/es7.set.from.js");
__webpack_require__("./node_modules/core-js/modules/es7.weak-map.from.js");
__webpack_require__("./node_modules/core-js/modules/es7.weak-set.from.js");
__webpack_require__("./node_modules/core-js/modules/es7.global.js");
__webpack_require__("./node_modules/core-js/modules/es7.system.global.js");
__webpack_require__("./node_modules/core-js/modules/es7.error.is-error.js");
__webpack_require__("./node_modules/core-js/modules/es7.math.clamp.js");
__webpack_require__("./node_modules/core-js/modules/es7.math.deg-per-rad.js");
__webpack_require__("./node_modules/core-js/modules/es7.math.degrees.js");
__webpack_require__("./node_modules/core-js/modules/es7.math.fscale.js");
__webpack_require__("./node_modules/core-js/modules/es7.math.iaddh.js");
__webpack_require__("./node_modules/core-js/modules/es7.math.isubh.js");
__webpack_require__("./node_modules/core-js/modules/es7.math.imulh.js");
__webpack_require__("./node_modules/core-js/modules/es7.math.rad-per-deg.js");
__webpack_require__("./node_modules/core-js/modules/es7.math.radians.js");
__webpack_require__("./node_modules/core-js/modules/es7.math.scale.js");
__webpack_require__("./node_modules/core-js/modules/es7.math.umulh.js");
__webpack_require__("./node_modules/core-js/modules/es7.math.signbit.js");
__webpack_require__("./node_modules/core-js/modules/es7.promise.finally.js");
__webpack_require__("./node_modules/core-js/modules/es7.promise.try.js");
__webpack_require__("./node_modules/core-js/modules/es7.reflect.define-metadata.js");
__webpack_require__("./node_modules/core-js/modules/es7.reflect.delete-metadata.js");
__webpack_require__("./node_modules/core-js/modules/es7.reflect.get-metadata.js");
__webpack_require__("./node_modules/core-js/modules/es7.reflect.get-metadata-keys.js");
__webpack_require__("./node_modules/core-js/modules/es7.reflect.get-own-metadata.js");
__webpack_require__("./node_modules/core-js/modules/es7.reflect.get-own-metadata-keys.js");
__webpack_require__("./node_modules/core-js/modules/es7.reflect.has-metadata.js");
__webpack_require__("./node_modules/core-js/modules/es7.reflect.has-own-metadata.js");
__webpack_require__("./node_modules/core-js/modules/es7.reflect.metadata.js");
__webpack_require__("./node_modules/core-js/modules/es7.asap.js");
__webpack_require__("./node_modules/core-js/modules/es7.observable.js");
__webpack_require__("./node_modules/core-js/modules/web.timers.js");
__webpack_require__("./node_modules/core-js/modules/web.immediate.js");
__webpack_require__("./node_modules/core-js/modules/web.dom.iterable.js");
module.exports = __webpack_require__("./node_modules/core-js/modules/_core.js");


/***/ }),

/***/ "./node_modules/core-util-is/lib/util.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.

function isArray(arg) {
  if (Array.isArray) {
    return Array.isArray(arg);
  }
  return objectToString(arg) === '[object Array]';
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = Buffer.isBuffer;

function objectToString(o) {
  return Object.prototype.toString.call(o);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/buffer/index.js").Buffer))

/***/ }),

/***/ "./node_modules/crossvent/src/crossvent.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var customEvent = __webpack_require__("./node_modules/custom-event/index.js");
var eventmap = __webpack_require__("./node_modules/crossvent/src/eventmap.js");
var doc = global.document;
var addEvent = addEventEasy;
var removeEvent = removeEventEasy;
var hardCache = [];

if (!global.addEventListener) {
  addEvent = addEventHard;
  removeEvent = removeEventHard;
}

module.exports = {
  add: addEvent,
  remove: removeEvent,
  fabricate: fabricateEvent
};

function addEventEasy (el, type, fn, capturing) {
  return el.addEventListener(type, fn, capturing);
}

function addEventHard (el, type, fn) {
  return el.attachEvent('on' + type, wrap(el, type, fn));
}

function removeEventEasy (el, type, fn, capturing) {
  return el.removeEventListener(type, fn, capturing);
}

function removeEventHard (el, type, fn) {
  var listener = unwrap(el, type, fn);
  if (listener) {
    return el.detachEvent('on' + type, listener);
  }
}

function fabricateEvent (el, type, model) {
  var e = eventmap.indexOf(type) === -1 ? makeCustomEvent() : makeClassicEvent();
  if (el.dispatchEvent) {
    el.dispatchEvent(e);
  } else {
    el.fireEvent('on' + type, e);
  }
  function makeClassicEvent () {
    var e;
    if (doc.createEvent) {
      e = doc.createEvent('Event');
      e.initEvent(type, true, true);
    } else if (doc.createEventObject) {
      e = doc.createEventObject();
    }
    return e;
  }
  function makeCustomEvent () {
    return new customEvent(type, { detail: model });
  }
}

function wrapperFactory (el, type, fn) {
  return function wrapper (originalEvent) {
    var e = originalEvent || global.event;
    e.target = e.target || e.srcElement;
    e.preventDefault = e.preventDefault || function preventDefault () { e.returnValue = false; };
    e.stopPropagation = e.stopPropagation || function stopPropagation () { e.cancelBubble = true; };
    e.which = e.which || e.keyCode;
    fn.call(el, e);
  };
}

function wrap (el, type, fn) {
  var wrapper = unwrap(el, type, fn) || wrapperFactory(el, type, fn);
  hardCache.push({
    wrapper: wrapper,
    element: el,
    type: type,
    fn: fn
  });
  return wrapper;
}

function unwrap (el, type, fn) {
  var i = find(el, type, fn);
  if (i) {
    var wrapper = hardCache[i].wrapper;
    hardCache.splice(i, 1); // free up a tad of memory
    return wrapper;
  }
}

function find (el, type, fn) {
  var i, item;
  for (i = 0; i < hardCache.length; i++) {
    item = hardCache[i];
    if (item.element === el && item.type === type && item.fn === fn) {
      return i;
    }
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/crossvent/src/eventmap.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var eventmap = [];
var eventname = '';
var ron = /^on/;

for (eventname in global) {
  if (ron.test(eventname)) {
    eventmap.push(eventname.slice(2));
  }
}

module.exports = eventmap;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/custom-event/index.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
var NativeCustomEvent = global.CustomEvent;

function useNative () {
  try {
    var p = new NativeCustomEvent('cat', { detail: { foo: 'bar' } });
    return  'cat' === p.type && 'bar' === p.detail.foo;
  } catch (e) {
  }
  return false;
}

/**
 * Cross-browser `CustomEvent` constructor.
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent.CustomEvent
 *
 * @public
 */

module.exports = useNative() ? NativeCustomEvent :

// IE >= 9
'function' === typeof document.createEvent ? function CustomEvent (type, params) {
  var e = document.createEvent('CustomEvent');
  if (params) {
    e.initCustomEvent(type, params.bubbles, params.cancelable, params.detail);
  } else {
    e.initCustomEvent(type, false, false, void 0);
  }
  return e;
} :

// IE <= 8
function CustomEvent (type, params) {
  var e = document.createEventObject();
  e.type = type;
  if (params) {
    e.bubbles = Boolean(params.bubbles);
    e.cancelable = Boolean(params.cancelable);
    e.detail = params.detail;
  } else {
    e.bubbles = false;
    e.cancelable = false;
    e.detail = void 0;
  }
  return e;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/d3-array/src/array.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return slice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return map; });
var array = Array.prototype;

var slice = array.slice;
var map = array.map;


/***/ }),

/***/ "./node_modules/d3-array/src/ascending.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
});


/***/ }),

/***/ "./node_modules/d3-array/src/bisect.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return bisectRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bisectLeft; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__("./node_modules/d3-array/src/ascending.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bisector__ = __webpack_require__("./node_modules/d3-array/src/bisector.js");



var ascendingBisect = Object(__WEBPACK_IMPORTED_MODULE_1__bisector__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */]);
var bisectRight = ascendingBisect.right;
var bisectLeft = ascendingBisect.left;
/* harmony default export */ __webpack_exports__["c"] = (bisectRight);


/***/ }),

/***/ "./node_modules/d3-array/src/bisector.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__("./node_modules/d3-array/src/ascending.js");


/* harmony default export */ __webpack_exports__["a"] = (function(compare) {
  if (compare.length === 1) compare = ascendingComparator(compare);
  return {
    left: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) < 0) lo = mid + 1;
        else hi = mid;
      }
      return lo;
    },
    right: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) > 0) hi = mid;
        else lo = mid + 1;
      }
      return lo;
    }
  };
});

function ascendingComparator(f) {
  return function(d, x) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */])(f(d), x);
  };
}


/***/ }),

/***/ "./node_modules/d3-array/src/constant.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),

/***/ "./node_modules/d3-array/src/cross.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pairs__ = __webpack_require__("./node_modules/d3-array/src/pairs.js");


/* harmony default export */ __webpack_exports__["a"] = (function(values0, values1, reduce) {
  var n0 = values0.length,
      n1 = values1.length,
      values = new Array(n0 * n1),
      i0,
      i1,
      i,
      value0;

  if (reduce == null) reduce = __WEBPACK_IMPORTED_MODULE_0__pairs__["b" /* pair */];

  for (i0 = i = 0; i0 < n0; ++i0) {
    for (value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i) {
      values[i] = reduce(value0, values1[i1]);
    }
  }

  return values;
});


/***/ }),

/***/ "./node_modules/d3-array/src/descending.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
});


/***/ }),

/***/ "./node_modules/d3-array/src/deviation.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__variance__ = __webpack_require__("./node_modules/d3-array/src/variance.js");


/* harmony default export */ __webpack_exports__["a"] = (function(array, f) {
  var v = Object(__WEBPACK_IMPORTED_MODULE_0__variance__["a" /* default */])(array, f);
  return v ? Math.sqrt(v) : v;
});


/***/ }),

/***/ "./node_modules/d3-array/src/extent.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      min,
      max;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        min = max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null) {
            if (min > value) min = value;
            if (max < value) max = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        min = max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null) {
            if (min > value) min = value;
            if (max < value) max = value;
          }
        }
      }
    }
  }

  return [min, max];
});


/***/ }),

/***/ "./node_modules/d3-array/src/histogram.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__("./node_modules/d3-array/src/array.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bisect__ = __webpack_require__("./node_modules/d3-array/src/bisect.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__("./node_modules/d3-array/src/constant.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__extent__ = __webpack_require__("./node_modules/d3-array/src/extent.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__identity__ = __webpack_require__("./node_modules/d3-array/src/identity.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__range__ = __webpack_require__("./node_modules/d3-array/src/range.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ticks__ = __webpack_require__("./node_modules/d3-array/src/ticks.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__threshold_sturges__ = __webpack_require__("./node_modules/d3-array/src/threshold/sturges.js");









/* harmony default export */ __webpack_exports__["a"] = (function() {
  var value = __WEBPACK_IMPORTED_MODULE_4__identity__["a" /* default */],
      domain = __WEBPACK_IMPORTED_MODULE_3__extent__["a" /* default */],
      threshold = __WEBPACK_IMPORTED_MODULE_7__threshold_sturges__["a" /* default */];

  function histogram(data) {
    var i,
        n = data.length,
        x,
        values = new Array(n);

    for (i = 0; i < n; ++i) {
      values[i] = value(data[i], i, data);
    }

    var xz = domain(values),
        x0 = xz[0],
        x1 = xz[1],
        tz = threshold(values, x0, x1);

    // Convert number of thresholds into uniform thresholds.
    if (!Array.isArray(tz)) {
      tz = Object(__WEBPACK_IMPORTED_MODULE_6__ticks__["c" /* tickStep */])(x0, x1, tz);
      tz = Object(__WEBPACK_IMPORTED_MODULE_5__range__["a" /* default */])(Math.ceil(x0 / tz) * tz, x1, tz); // exclusive
    }

    // Remove any thresholds outside the domain.
    var m = tz.length;
    while (tz[0] <= x0) tz.shift(), --m;
    while (tz[m - 1] > x1) tz.pop(), --m;

    var bins = new Array(m + 1),
        bin;

    // Initialize bins.
    for (i = 0; i <= m; ++i) {
      bin = bins[i] = [];
      bin.x0 = i > 0 ? tz[i - 1] : x0;
      bin.x1 = i < m ? tz[i] : x1;
    }

    // Assign data to bins by value, ignoring any outside the domain.
    for (i = 0; i < n; ++i) {
      x = values[i];
      if (x0 <= x && x <= x1) {
        bins[Object(__WEBPACK_IMPORTED_MODULE_1__bisect__["c" /* default */])(tz, x, 0, m)].push(data[i]);
      }
    }

    return bins;
  }

  histogram.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(_), histogram) : value;
  };

  histogram.domain = function(_) {
    return arguments.length ? (domain = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])([_[0], _[1]]), histogram) : domain;
  };

  histogram.thresholds = function(_) {
    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__array__["b" /* slice */].call(_)) : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(_), histogram) : threshold;
  };

  return histogram;
});


/***/ }),

/***/ "./node_modules/d3-array/src/identity.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),

/***/ "./node_modules/d3-array/src/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bisect__ = __webpack_require__("./node_modules/d3-array/src/bisect.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__bisect__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__bisect__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__bisect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ascending__ = __webpack_require__("./node_modules/d3-array/src/ascending.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__ascending__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bisector__ = __webpack_require__("./node_modules/d3-array/src/bisector.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__bisector__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cross__ = __webpack_require__("./node_modules/d3-array/src/cross.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__cross__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__descending__ = __webpack_require__("./node_modules/d3-array/src/descending.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_4__descending__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__deviation__ = __webpack_require__("./node_modules/d3-array/src/deviation.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_5__deviation__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__extent__ = __webpack_require__("./node_modules/d3-array/src/extent.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_6__extent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__histogram__ = __webpack_require__("./node_modules/d3-array/src/histogram.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_7__histogram__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__threshold_freedmanDiaconis__ = __webpack_require__("./node_modules/d3-array/src/threshold/freedmanDiaconis.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_8__threshold_freedmanDiaconis__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__threshold_scott__ = __webpack_require__("./node_modules/d3-array/src/threshold/scott.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_9__threshold_scott__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__threshold_sturges__ = __webpack_require__("./node_modules/d3-array/src/threshold/sturges.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_10__threshold_sturges__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__max__ = __webpack_require__("./node_modules/d3-array/src/max.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_11__max__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mean__ = __webpack_require__("./node_modules/d3-array/src/mean.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_12__mean__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__median__ = __webpack_require__("./node_modules/d3-array/src/median.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_13__median__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__merge__ = __webpack_require__("./node_modules/d3-array/src/merge.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_14__merge__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__min__ = __webpack_require__("./node_modules/d3-array/src/min.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_15__min__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pairs__ = __webpack_require__("./node_modules/d3-array/src/pairs.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_16__pairs__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__permute__ = __webpack_require__("./node_modules/d3-array/src/permute.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_17__permute__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__quantile__ = __webpack_require__("./node_modules/d3-array/src/quantile.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_18__quantile__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__range__ = __webpack_require__("./node_modules/d3-array/src/range.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_19__range__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__scan__ = __webpack_require__("./node_modules/d3-array/src/scan.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_20__scan__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__shuffle__ = __webpack_require__("./node_modules/d3-array/src/shuffle.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_21__shuffle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__sum__ = __webpack_require__("./node_modules/d3-array/src/sum.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_22__sum__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__ticks__ = __webpack_require__("./node_modules/d3-array/src/ticks.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_23__ticks__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_23__ticks__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_23__ticks__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__transpose__ = __webpack_require__("./node_modules/d3-array/src/transpose.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_24__transpose__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__variance__ = __webpack_require__("./node_modules/d3-array/src/variance.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_25__variance__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__zip__ = __webpack_require__("./node_modules/d3-array/src/zip.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_26__zip__["a"]; });





























/***/ }),

/***/ "./node_modules/d3-array/src/max.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      max;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null && value > max) {
            max = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && value > max) {
            max = value;
          }
        }
      }
    }
  }

  return max;
});


/***/ }),

/***/ "./node_modules/d3-array/src/mean.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__("./node_modules/d3-array/src/number.js");


/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      m = n,
      i = -1,
      value,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(values[i]))) sum += value;
      else --m;
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(valueof(values[i], i, values)))) sum += value;
      else --m;
    }
  }

  if (m) return sum / m;
});


/***/ }),

/***/ "./node_modules/d3-array/src/median.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__("./node_modules/d3-array/src/ascending.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__number__ = __webpack_require__("./node_modules/d3-array/src/number.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__quantile__ = __webpack_require__("./node_modules/d3-array/src/quantile.js");




/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      numbers = [];

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_1__number__["a" /* default */])(values[i]))) {
        numbers.push(value);
      }
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_1__number__["a" /* default */])(valueof(values[i], i, values)))) {
        numbers.push(value);
      }
    }
  }

  return Object(__WEBPACK_IMPORTED_MODULE_2__quantile__["a" /* default */])(numbers.sort(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */]), 0.5);
});


/***/ }),

/***/ "./node_modules/d3-array/src/merge.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(arrays) {
  var n = arrays.length,
      m,
      i = -1,
      j = 0,
      merged,
      array;

  while (++i < n) j += arrays[i].length;
  merged = new Array(j);

  while (--n >= 0) {
    array = arrays[n];
    m = array.length;
    while (--m >= 0) {
      merged[--j] = array[m];
    }
  }

  return merged;
});


/***/ }),

/***/ "./node_modules/d3-array/src/min.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      min;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        min = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null && min > value) {
            min = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        min = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && min > value) {
            min = value;
          }
        }
      }
    }
  }

  return min;
});


/***/ }),

/***/ "./node_modules/d3-array/src/number.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x === null ? NaN : +x;
});


/***/ }),

/***/ "./node_modules/d3-array/src/pairs.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = pair;
/* harmony default export */ __webpack_exports__["a"] = (function(array, f) {
  if (f == null) f = pair;
  var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
  while (i < n) pairs[i] = f(p, p = array[++i]);
  return pairs;
});

function pair(a, b) {
  return [a, b];
}


/***/ }),

/***/ "./node_modules/d3-array/src/permute.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(array, indexes) {
  var i = indexes.length, permutes = new Array(i);
  while (i--) permutes[i] = array[indexes[i]];
  return permutes;
});


/***/ }),

/***/ "./node_modules/d3-array/src/quantile.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__("./node_modules/d3-array/src/number.js");


/* harmony default export */ __webpack_exports__["a"] = (function(values, p, valueof) {
  if (valueof == null) valueof = __WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */];
  if (!(n = values.length)) return;
  if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
  var n,
      i = (n - 1) * p,
      i0 = Math.floor(i),
      value0 = +valueof(values[i0], i0, values),
      value1 = +valueof(values[i0 + 1], i0 + 1, values);
  return value0 + (value1 - value0) * (i - i0);
});


/***/ }),

/***/ "./node_modules/d3-array/src/range.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(start, stop, step) {
  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;

  var i = -1,
      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
      range = new Array(n);

  while (++i < n) {
    range[i] = start + i * step;
  }

  return range;
});


/***/ }),

/***/ "./node_modules/d3-array/src/scan.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__("./node_modules/d3-array/src/ascending.js");


/* harmony default export */ __webpack_exports__["a"] = (function(values, compare) {
  if (!(n = values.length)) return;
  var n,
      i = 0,
      j = 0,
      xi,
      xj = values[j];

  if (compare == null) compare = __WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */];

  while (++i < n) {
    if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) {
      xj = xi, j = i;
    }
  }

  if (compare(xj, xj) === 0) return j;
});


/***/ }),

/***/ "./node_modules/d3-array/src/shuffle.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(array, i0, i1) {
  var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
      t,
      i;

  while (m) {
    i = Math.random() * m-- | 0;
    t = array[m + i0];
    array[m + i0] = array[i + i0];
    array[i + i0] = t;
  }

  return array;
});


/***/ }),

/***/ "./node_modules/d3-array/src/sum.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
    }
  }

  else {
    while (++i < n) {
      if (value = +valueof(values[i], i, values)) sum += value;
    }
  }

  return sum;
});


/***/ }),

/***/ "./node_modules/d3-array/src/threshold/freedmanDiaconis.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__("./node_modules/d3-array/src/array.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ascending__ = __webpack_require__("./node_modules/d3-array/src/ascending.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__number__ = __webpack_require__("./node_modules/d3-array/src/number.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__quantile__ = __webpack_require__("./node_modules/d3-array/src/quantile.js");





/* harmony default export */ __webpack_exports__["a"] = (function(values, min, max) {
  values = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* map */].call(values, __WEBPACK_IMPORTED_MODULE_2__number__["a" /* default */]).sort(__WEBPACK_IMPORTED_MODULE_1__ascending__["a" /* default */]);
  return Math.ceil((max - min) / (2 * (Object(__WEBPACK_IMPORTED_MODULE_3__quantile__["a" /* default */])(values, 0.75) - Object(__WEBPACK_IMPORTED_MODULE_3__quantile__["a" /* default */])(values, 0.25)) * Math.pow(values.length, -1 / 3)));
});


/***/ }),

/***/ "./node_modules/d3-array/src/threshold/scott.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__deviation__ = __webpack_require__("./node_modules/d3-array/src/deviation.js");


/* harmony default export */ __webpack_exports__["a"] = (function(values, min, max) {
  return Math.ceil((max - min) / (3.5 * Object(__WEBPACK_IMPORTED_MODULE_0__deviation__["a" /* default */])(values) * Math.pow(values.length, -1 / 3)));
});


/***/ }),

/***/ "./node_modules/d3-array/src/threshold/sturges.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values) {
  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
});


/***/ }),

/***/ "./node_modules/d3-array/src/ticks.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = tickIncrement;
/* harmony export (immutable) */ __webpack_exports__["c"] = tickStep;
var e10 = Math.sqrt(50),
    e5 = Math.sqrt(10),
    e2 = Math.sqrt(2);

/* harmony default export */ __webpack_exports__["a"] = (function(start, stop, count) {
  var reverse,
      i = -1,
      n,
      ticks,
      step;

  stop = +stop, start = +start, count = +count;
  if (start === stop && count > 0) return [start];
  if (reverse = stop < start) n = start, start = stop, stop = n;
  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];

  if (step > 0) {
    start = Math.ceil(start / step);
    stop = Math.floor(stop / step);
    ticks = new Array(n = Math.ceil(stop - start + 1));
    while (++i < n) ticks[i] = (start + i) * step;
  } else {
    start = Math.floor(start * step);
    stop = Math.ceil(stop * step);
    ticks = new Array(n = Math.ceil(start - stop + 1));
    while (++i < n) ticks[i] = (start - i) / step;
  }

  if (reverse) ticks.reverse();

  return ticks;
});

function tickIncrement(start, stop, count) {
  var step = (stop - start) / Math.max(0, count),
      power = Math.floor(Math.log(step) / Math.LN10),
      error = step / Math.pow(10, power);
  return power >= 0
      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
}

function tickStep(start, stop, count) {
  var step0 = Math.abs(stop - start) / Math.max(0, count),
      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
      error = step0 / step1;
  if (error >= e10) step1 *= 10;
  else if (error >= e5) step1 *= 5;
  else if (error >= e2) step1 *= 2;
  return stop < start ? -step1 : step1;
}


/***/ }),

/***/ "./node_modules/d3-array/src/transpose.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__min__ = __webpack_require__("./node_modules/d3-array/src/min.js");


/* harmony default export */ __webpack_exports__["a"] = (function(matrix) {
  if (!(n = matrix.length)) return [];
  for (var i = -1, m = Object(__WEBPACK_IMPORTED_MODULE_0__min__["a" /* default */])(matrix, length), transpose = new Array(m); ++i < m;) {
    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
      row[j] = matrix[j][i];
    }
  }
  return transpose;
});

function length(d) {
  return d.length;
}


/***/ }),

/***/ "./node_modules/d3-array/src/variance.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__("./node_modules/d3-array/src/number.js");


/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      m = 0,
      i = -1,
      mean = 0,
      value,
      delta,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(values[i]))) {
        delta = value - mean;
        mean += delta / ++m;
        sum += delta * (value - mean);
      }
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(valueof(values[i], i, values)))) {
        delta = value - mean;
        mean += delta / ++m;
        sum += delta * (value - mean);
      }
    }
  }

  if (m > 1) return sum / (m - 1);
});


/***/ }),

/***/ "./node_modules/d3-array/src/zip.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transpose__ = __webpack_require__("./node_modules/d3-array/src/transpose.js");


/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__transpose__["a" /* default */])(arguments);
});


/***/ }),

/***/ "./node_modules/d3-axis/src/array.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return slice; });
var slice = Array.prototype.slice;


/***/ }),

/***/ "./node_modules/d3-axis/src/axis.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = axisTop;
/* harmony export (immutable) */ __webpack_exports__["c"] = axisRight;
/* harmony export (immutable) */ __webpack_exports__["a"] = axisBottom;
/* harmony export (immutable) */ __webpack_exports__["b"] = axisLeft;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__("./node_modules/d3-axis/src/array.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__identity__ = __webpack_require__("./node_modules/d3-axis/src/identity.js");



var top = 1,
    right = 2,
    bottom = 3,
    left = 4,
    epsilon = 1e-6;

function translateX(x) {
  return "translate(" + (x + 0.5) + ",0)";
}

function translateY(y) {
  return "translate(0," + (y + 0.5) + ")";
}

function number(scale) {
  return function(d) {
    return +scale(d);
  };
}

function center(scale) {
  var offset = Math.max(0, scale.bandwidth() - 1) / 2; // Adjust for 0.5px offset.
  if (scale.round()) offset = Math.round(offset);
  return function(d) {
    return +scale(d) + offset;
  };
}

function entering() {
  return !this.__axis;
}

function axis(orient, scale) {
  var tickArguments = [],
      tickValues = null,
      tickFormat = null,
      tickSizeInner = 6,
      tickSizeOuter = 6,
      tickPadding = 3,
      k = orient === top || orient === left ? -1 : 1,
      x = orient === left || orient === right ? "x" : "y",
      transform = orient === top || orient === bottom ? translateX : translateY;

  function axis(context) {
    var values = tickValues == null ? (scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain()) : tickValues,
        format = tickFormat == null ? (scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : __WEBPACK_IMPORTED_MODULE_1__identity__["a" /* default */]) : tickFormat,
        spacing = Math.max(tickSizeInner, 0) + tickPadding,
        range = scale.range(),
        range0 = +range[0] + 0.5,
        range1 = +range[range.length - 1] + 0.5,
        position = (scale.bandwidth ? center : number)(scale.copy()),
        selection = context.selection ? context.selection() : context,
        path = selection.selectAll(".domain").data([null]),
        tick = selection.selectAll(".tick").data(values, scale).order(),
        tickExit = tick.exit(),
        tickEnter = tick.enter().append("g").attr("class", "tick"),
        line = tick.select("line"),
        text = tick.select("text");

    path = path.merge(path.enter().insert("path", ".tick")
        .attr("class", "domain")
        .attr("stroke", "currentColor"));

    tick = tick.merge(tickEnter);

    line = line.merge(tickEnter.append("line")
        .attr("stroke", "currentColor")
        .attr(x + "2", k * tickSizeInner));

    text = text.merge(tickEnter.append("text")
        .attr("fill", "currentColor")
        .attr(x, k * spacing)
        .attr("dy", orient === top ? "0em" : orient === bottom ? "0.71em" : "0.32em"));

    if (context !== selection) {
      path = path.transition(context);
      tick = tick.transition(context);
      line = line.transition(context);
      text = text.transition(context);

      tickExit = tickExit.transition(context)
          .attr("opacity", epsilon)
          .attr("transform", function(d) { return isFinite(d = position(d)) ? transform(d) : this.getAttribute("transform"); });

      tickEnter
          .attr("opacity", epsilon)
          .attr("transform", function(d) { var p = this.parentNode.__axis; return transform(p && isFinite(p = p(d)) ? p : position(d)); });
    }

    tickExit.remove();

    path
        .attr("d", orient === left || orient == right
            ? (tickSizeOuter ? "M" + k * tickSizeOuter + "," + range0 + "H0.5V" + range1 + "H" + k * tickSizeOuter : "M0.5," + range0 + "V" + range1)
            : (tickSizeOuter ? "M" + range0 + "," + k * tickSizeOuter + "V0.5H" + range1 + "V" + k * tickSizeOuter : "M" + range0 + ",0.5H" + range1));

    tick
        .attr("opacity", 1)
        .attr("transform", function(d) { return transform(position(d)); });

    line
        .attr(x + "2", k * tickSizeInner);

    text
        .attr(x, k * spacing)
        .text(format);

    selection.filter(entering)
        .attr("fill", "none")
        .attr("font-size", 10)
        .attr("font-family", "sans-serif")
        .attr("text-anchor", orient === right ? "start" : orient === left ? "end" : "middle");

    selection
        .each(function() { this.__axis = position; });
  }

  axis.scale = function(_) {
    return arguments.length ? (scale = _, axis) : scale;
  };

  axis.ticks = function() {
    return tickArguments = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(arguments), axis;
  };

  axis.tickArguments = function(_) {
    return arguments.length ? (tickArguments = _ == null ? [] : __WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(_), axis) : tickArguments.slice();
  };

  axis.tickValues = function(_) {
    return arguments.length ? (tickValues = _ == null ? null : __WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(_), axis) : tickValues && tickValues.slice();
  };

  axis.tickFormat = function(_) {
    return arguments.length ? (tickFormat = _, axis) : tickFormat;
  };

  axis.tickSize = function(_) {
    return arguments.length ? (tickSizeInner = tickSizeOuter = +_, axis) : tickSizeInner;
  };

  axis.tickSizeInner = function(_) {
    return arguments.length ? (tickSizeInner = +_, axis) : tickSizeInner;
  };

  axis.tickSizeOuter = function(_) {
    return arguments.length ? (tickSizeOuter = +_, axis) : tickSizeOuter;
  };

  axis.tickPadding = function(_) {
    return arguments.length ? (tickPadding = +_, axis) : tickPadding;
  };

  return axis;
}

function axisTop(scale) {
  return axis(top, scale);
}

function axisRight(scale) {
  return axis(right, scale);
}

function axisBottom(scale) {
  return axis(bottom, scale);
}

function axisLeft(scale) {
  return axis(left, scale);
}


/***/ }),

/***/ "./node_modules/d3-axis/src/identity.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),

/***/ "./node_modules/d3-axis/src/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axis__ = __webpack_require__("./node_modules/d3-axis/src/axis.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__axis__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__axis__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__axis__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__axis__["b"]; });



/***/ }),

/***/ "./node_modules/d3-brush/src/brush.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = brushSelection;
/* harmony export (immutable) */ __webpack_exports__["b"] = brushX;
/* harmony export (immutable) */ __webpack_exports__["c"] = brushY;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_dispatch__ = __webpack_require__("./node_modules/d3-dispatch/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_drag__ = __webpack_require__("./node_modules/d3-drag/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_interpolate__ = __webpack_require__("./node_modules/d3-interpolate/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_selection__ = __webpack_require__("./node_modules/d3-selection/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_transition__ = __webpack_require__("./node_modules/d3-transition/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constant__ = __webpack_require__("./node_modules/d3-brush/src/constant.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__event__ = __webpack_require__("./node_modules/d3-brush/src/event.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__noevent__ = __webpack_require__("./node_modules/d3-brush/src/noevent.js");









var MODE_DRAG = {name: "drag"},
    MODE_SPACE = {name: "space"},
    MODE_HANDLE = {name: "handle"},
    MODE_CENTER = {name: "center"};

var X = {
  name: "x",
  handles: ["e", "w"].map(type),
  input: function(x, e) { return x && [[x[0], e[0][1]], [x[1], e[1][1]]]; },
  output: function(xy) { return xy && [xy[0][0], xy[1][0]]; }
};

var Y = {
  name: "y",
  handles: ["n", "s"].map(type),
  input: function(y, e) { return y && [[e[0][0], y[0]], [e[1][0], y[1]]]; },
  output: function(xy) { return xy && [xy[0][1], xy[1][1]]; }
};

var XY = {
  name: "xy",
  handles: ["n", "e", "s", "w", "nw", "ne", "se", "sw"].map(type),
  input: function(xy) { return xy; },
  output: function(xy) { return xy; }
};

var cursors = {
  overlay: "crosshair",
  selection: "move",
  n: "ns-resize",
  e: "ew-resize",
  s: "ns-resize",
  w: "ew-resize",
  nw: "nwse-resize",
  ne: "nesw-resize",
  se: "nwse-resize",
  sw: "nesw-resize"
};

var flipX = {
  e: "w",
  w: "e",
  nw: "ne",
  ne: "nw",
  se: "sw",
  sw: "se"
};

var flipY = {
  n: "s",
  s: "n",
  nw: "sw",
  ne: "se",
  se: "ne",
  sw: "nw"
};

var signsX = {
  overlay: +1,
  selection: +1,
  n: null,
  e: +1,
  s: null,
  w: -1,
  nw: -1,
  ne: +1,
  se: +1,
  sw: -1
};

var signsY = {
  overlay: +1,
  selection: +1,
  n: -1,
  e: null,
  s: +1,
  w: null,
  nw: -1,
  ne: -1,
  se: +1,
  sw: +1
};

function type(t) {
  return {type: t};
}

// Ignore right-click, since that should open the context menu.
function defaultFilter() {
  return !__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* event */].button;
}

function defaultExtent() {
  var svg = this.ownerSVGElement || this;
  return [[0, 0], [svg.width.baseVal.value, svg.height.baseVal.value]];
}

// Like d3.local, but with the name “__brush” rather than auto-generated.
function local(node) {
  while (!node.__brush) if (!(node = node.parentNode)) return;
  return node.__brush;
}

function empty(extent) {
  return extent[0][0] === extent[1][0]
      || extent[0][1] === extent[1][1];
}

function brushSelection(node) {
  var state = node.__brush;
  return state ? state.dim.output(state.selection) : null;
}

function brushX() {
  return brush(X);
}

function brushY() {
  return brush(Y);
}

/* harmony default export */ __webpack_exports__["d"] = (function() {
  return brush(XY);
});

function brush(dim) {
  var extent = defaultExtent,
      filter = defaultFilter,
      listeners = Object(__WEBPACK_IMPORTED_MODULE_0_d3_dispatch__["a" /* dispatch */])(brush, "start", "brush", "end"),
      handleSize = 6,
      touchending;

  function brush(group) {
    var overlay = group
        .property("__brush", initialize)
      .selectAll(".overlay")
      .data([type("overlay")]);

    overlay.enter().append("rect")
        .attr("class", "overlay")
        .attr("pointer-events", "all")
        .attr("cursor", cursors.overlay)
      .merge(overlay)
        .each(function() {
          var extent = local(this).extent;
          Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["k" /* select */])(this)
              .attr("x", extent[0][0])
              .attr("y", extent[0][1])
              .attr("width", extent[1][0] - extent[0][0])
              .attr("height", extent[1][1] - extent[0][1]);
        });

    group.selectAll(".selection")
      .data([type("selection")])
      .enter().append("rect")
        .attr("class", "selection")
        .attr("cursor", cursors.selection)
        .attr("fill", "#777")
        .attr("fill-opacity", 0.3)
        .attr("stroke", "#fff")
        .attr("shape-rendering", "crispEdges");

    var handle = group.selectAll(".handle")
      .data(dim.handles, function(d) { return d.type; });

    handle.exit().remove();

    handle.enter().append("rect")
        .attr("class", function(d) { return "handle handle--" + d.type; })
        .attr("cursor", function(d) { return cursors[d.type]; });

    group
        .each(redraw)
        .attr("fill", "none")
        .attr("pointer-events", "all")
        .style("-webkit-tap-highlight-color", "rgba(0,0,0,0)")
        .on("mousedown.brush touchstart.brush", started);
  }

  brush.move = function(group, selection) {
    if (group.selection) {
      group
          .on("start.brush", function() { emitter(this, arguments).beforestart().start(); })
          .on("interrupt.brush end.brush", function() { emitter(this, arguments).end(); })
          .tween("brush", function() {
            var that = this,
                state = that.__brush,
                emit = emitter(that, arguments),
                selection0 = state.selection,
                selection1 = dim.input(typeof selection === "function" ? selection.apply(this, arguments) : selection, state.extent),
                i = Object(__WEBPACK_IMPORTED_MODULE_2_d3_interpolate__["a" /* interpolate */])(selection0, selection1);

            function tween(t) {
              state.selection = t === 1 && empty(selection1) ? null : i(t);
              redraw.call(that);
              emit.brush();
            }

            return selection0 && selection1 ? tween : tween(1);
          });
    } else {
      group
          .each(function() {
            var that = this,
                args = arguments,
                state = that.__brush,
                selection1 = dim.input(typeof selection === "function" ? selection.apply(that, args) : selection, state.extent),
                emit = emitter(that, args).beforestart();

            Object(__WEBPACK_IMPORTED_MODULE_4_d3_transition__["b" /* interrupt */])(that);
            state.selection = selection1 == null || empty(selection1) ? null : selection1;
            redraw.call(that);
            emit.start().brush().end();
          });
    }
  };

  function redraw() {
    var group = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["k" /* select */])(this),
        selection = local(this).selection;

    if (selection) {
      group.selectAll(".selection")
          .style("display", null)
          .attr("x", selection[0][0])
          .attr("y", selection[0][1])
          .attr("width", selection[1][0] - selection[0][0])
          .attr("height", selection[1][1] - selection[0][1]);

      group.selectAll(".handle")
          .style("display", null)
          .attr("x", function(d) { return d.type[d.type.length - 1] === "e" ? selection[1][0] - handleSize / 2 : selection[0][0] - handleSize / 2; })
          .attr("y", function(d) { return d.type[0] === "s" ? selection[1][1] - handleSize / 2 : selection[0][1] - handleSize / 2; })
          .attr("width", function(d) { return d.type === "n" || d.type === "s" ? selection[1][0] - selection[0][0] + handleSize : handleSize; })
          .attr("height", function(d) { return d.type === "e" || d.type === "w" ? selection[1][1] - selection[0][1] + handleSize : handleSize; });
    }

    else {
      group.selectAll(".selection,.handle")
          .style("display", "none")
          .attr("x", null)
          .attr("y", null)
          .attr("width", null)
          .attr("height", null);
    }
  }

  function emitter(that, args) {
    return that.__brush.emitter || new Emitter(that, args);
  }

  function Emitter(that, args) {
    this.that = that;
    this.args = args;
    this.state = that.__brush;
    this.active = 0;
  }

  Emitter.prototype = {
    beforestart: function() {
      if (++this.active === 1) this.state.emitter = this, this.starting = true;
      return this;
    },
    start: function() {
      if (this.starting) this.starting = false, this.emit("start");
      return this;
    },
    brush: function() {
      this.emit("brush");
      return this;
    },
    end: function() {
      if (--this.active === 0) delete this.state.emitter, this.emit("end");
      return this;
    },
    emit: function(type) {
      Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["d" /* customEvent */])(new __WEBPACK_IMPORTED_MODULE_6__event__["a" /* default */](brush, type, dim.output(this.state.selection)), listeners.apply, listeners, [type, this.that, this.args]);
    }
  };

  function started() {
    if (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* event */].touches) { if (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* event */].changedTouches.length < __WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* event */].touches.length) return Object(__WEBPACK_IMPORTED_MODULE_7__noevent__["a" /* default */])(); }
    else if (touchending) return;
    if (!filter.apply(this, arguments)) return;

    var that = this,
        type = __WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* event */].target.__data__.type,
        mode = (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* event */].metaKey ? type = "overlay" : type) === "selection" ? MODE_DRAG : (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* event */].altKey ? MODE_CENTER : MODE_HANDLE),
        signX = dim === Y ? null : signsX[type],
        signY = dim === X ? null : signsY[type],
        state = local(that),
        extent = state.extent,
        selection = state.selection,
        W = extent[0][0], w0, w1,
        N = extent[0][1], n0, n1,
        E = extent[1][0], e0, e1,
        S = extent[1][1], s0, s1,
        dx,
        dy,
        moving,
        shifting = signX && signY && __WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* event */].shiftKey,
        lockX,
        lockY,
        point0 = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["h" /* mouse */])(that),
        point = point0,
        emit = emitter(that, arguments).beforestart();

    if (type === "overlay") {
      state.selection = selection = [
        [w0 = dim === Y ? W : point0[0], n0 = dim === X ? N : point0[1]],
        [e0 = dim === Y ? E : w0, s0 = dim === X ? S : n0]
      ];
    } else {
      w0 = selection[0][0];
      n0 = selection[0][1];
      e0 = selection[1][0];
      s0 = selection[1][1];
    }

    w1 = w0;
    n1 = n0;
    e1 = e0;
    s1 = s0;

    var group = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["k" /* select */])(that)
        .attr("pointer-events", "none");

    var overlay = group.selectAll(".overlay")
        .attr("cursor", cursors[type]);

    if (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* event */].touches) {
      group
          .on("touchmove.brush", moved, true)
          .on("touchend.brush touchcancel.brush", ended, true);
    } else {
      var view = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["k" /* select */])(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* event */].view)
          .on("keydown.brush", keydowned, true)
          .on("keyup.brush", keyupped, true)
          .on("mousemove.brush", moved, true)
          .on("mouseup.brush", ended, true);

      Object(__WEBPACK_IMPORTED_MODULE_1_d3_drag__["b" /* dragDisable */])(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* event */].view);
    }

    Object(__WEBPACK_IMPORTED_MODULE_7__noevent__["b" /* nopropagation */])();
    Object(__WEBPACK_IMPORTED_MODULE_4_d3_transition__["b" /* interrupt */])(that);
    redraw.call(that);
    emit.start();

    function moved() {
      var point1 = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["h" /* mouse */])(that);
      if (shifting && !lockX && !lockY) {
        if (Math.abs(point1[0] - point[0]) > Math.abs(point1[1] - point[1])) lockY = true;
        else lockX = true;
      }
      point = point1;
      moving = true;
      Object(__WEBPACK_IMPORTED_MODULE_7__noevent__["a" /* default */])();
      move();
    }

    function move() {
      var t;

      dx = point[0] - point0[0];
      dy = point[1] - point0[1];

      switch (mode) {
        case MODE_SPACE:
        case MODE_DRAG: {
          if (signX) dx = Math.max(W - w0, Math.min(E - e0, dx)), w1 = w0 + dx, e1 = e0 + dx;
          if (signY) dy = Math.max(N - n0, Math.min(S - s0, dy)), n1 = n0 + dy, s1 = s0 + dy;
          break;
        }
        case MODE_HANDLE: {
          if (signX < 0) dx = Math.max(W - w0, Math.min(E - w0, dx)), w1 = w0 + dx, e1 = e0;
          else if (signX > 0) dx = Math.max(W - e0, Math.min(E - e0, dx)), w1 = w0, e1 = e0 + dx;
          if (signY < 0) dy = Math.max(N - n0, Math.min(S - n0, dy)), n1 = n0 + dy, s1 = s0;
          else if (signY > 0) dy = Math.max(N - s0, Math.min(S - s0, dy)), n1 = n0, s1 = s0 + dy;
          break;
        }
        case MODE_CENTER: {
          if (signX) w1 = Math.max(W, Math.min(E, w0 - dx * signX)), e1 = Math.max(W, Math.min(E, e0 + dx * signX));
          if (signY) n1 = Math.max(N, Math.min(S, n0 - dy * signY)), s1 = Math.max(N, Math.min(S, s0 + dy * signY));
          break;
        }
      }

      if (e1 < w1) {
        signX *= -1;
        t = w0, w0 = e0, e0 = t;
        t = w1, w1 = e1, e1 = t;
        if (type in flipX) overlay.attr("cursor", cursors[type = flipX[type]]);
      }

      if (s1 < n1) {
        signY *= -1;
        t = n0, n0 = s0, s0 = t;
        t = n1, n1 = s1, s1 = t;
        if (type in flipY) overlay.attr("cursor", cursors[type = flipY[type]]);
      }

      if (state.selection) selection = state.selection; // May be set by brush.move!
      if (lockX) w1 = selection[0][0], e1 = selection[1][0];
      if (lockY) n1 = selection[0][1], s1 = selection[1][1];

      if (selection[0][0] !== w1
          || selection[0][1] !== n1
          || selection[1][0] !== e1
          || selection[1][1] !== s1) {
        state.selection = [[w1, n1], [e1, s1]];
        redraw.call(that);
        emit.brush();
      }
    }

    function ended() {
      Object(__WEBPACK_IMPORTED_MODULE_7__noevent__["b" /* nopropagation */])();
      if (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* event */].touches) {
        if (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* event */].touches.length) return;
        if (touchending) clearTimeout(touchending);
        touchending = setTimeout(function() { touchending = null; }, 500); // Ghost clicks are delayed!
        group.on("touchmove.brush touchend.brush touchcancel.brush", null);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_d3_drag__["c" /* dragEnable */])(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* event */].view, moving);
        view.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
      }
      group.attr("pointer-events", "all");
      overlay.attr("cursor", cursors.overlay);
      if (state.selection) selection = state.selection; // May be set by brush.move (on start)!
      if (empty(selection)) state.selection = null, redraw.call(that);
      emit.end();
    }

    function keydowned() {
      switch (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* event */].keyCode) {
        case 16: { // SHIFT
          shifting = signX && signY;
          break;
        }
        case 18: { // ALT
          if (mode === MODE_HANDLE) {
            if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
            if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
            mode = MODE_CENTER;
            move();
          }
          break;
        }
        case 32: { // SPACE; takes priority over ALT
          if (mode === MODE_HANDLE || mode === MODE_CENTER) {
            if (signX < 0) e0 = e1 - dx; else if (signX > 0) w0 = w1 - dx;
            if (signY < 0) s0 = s1 - dy; else if (signY > 0) n0 = n1 - dy;
            mode = MODE_SPACE;
            overlay.attr("cursor", cursors.selection);
            move();
          }
          break;
        }
        default: return;
      }
      Object(__WEBPACK_IMPORTED_MODULE_7__noevent__["a" /* default */])();
    }

    function keyupped() {
      switch (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* event */].keyCode) {
        case 16: { // SHIFT
          if (shifting) {
            lockX = lockY = shifting = false;
            move();
          }
          break;
        }
        case 18: { // ALT
          if (mode === MODE_CENTER) {
            if (signX < 0) e0 = e1; else if (signX > 0) w0 = w1;
            if (signY < 0) s0 = s1; else if (signY > 0) n0 = n1;
            mode = MODE_HANDLE;
            move();
          }
          break;
        }
        case 32: { // SPACE
          if (mode === MODE_SPACE) {
            if (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* event */].altKey) {
              if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
              if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
              mode = MODE_CENTER;
            } else {
              if (signX < 0) e0 = e1; else if (signX > 0) w0 = w1;
              if (signY < 0) s0 = s1; else if (signY > 0) n0 = n1;
              mode = MODE_HANDLE;
            }
            overlay.attr("cursor", cursors[type]);
            move();
          }
          break;
        }
        default: return;
      }
      Object(__WEBPACK_IMPORTED_MODULE_7__noevent__["a" /* default */])();
    }
  }

  function initialize() {
    var state = this.__brush || {selection: null};
    state.extent = extent.apply(this, arguments);
    state.dim = dim;
    return state;
  }

  brush.extent = function(_) {
    return arguments.length ? (extent = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_5__constant__["a" /* default */])([[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]]), brush) : extent;
  };

  brush.filter = function(_) {
    return arguments.length ? (filter = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_5__constant__["a" /* default */])(!!_), brush) : filter;
  };

  brush.handleSize = function(_) {
    return arguments.length ? (handleSize = +_, brush) : handleSize;
  };

  brush.on = function() {
    var value = listeners.on.apply(listeners, arguments);
    return value === listeners ? brush : value;
  };

  return brush;
}


/***/ }),

/***/ "./node_modules/d3-brush/src/constant.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),

/***/ "./node_modules/d3-brush/src/event.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(target, type, selection) {
  this.target = target;
  this.type = type;
  this.selection = selection;
});


/***/ }),

/***/ "./node_modules/d3-brush/src/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__brush__ = __webpack_require__("./node_modules/d3-brush/src/brush.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__brush__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__brush__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__brush__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__brush__["a"]; });



/***/ }),

/***/ "./node_modules/d3-brush/src/noevent.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = nopropagation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__("./node_modules/d3-selection/src/index.js");


function nopropagation() {
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["e" /* event */].stopImmediatePropagation();
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["e" /* event */].preventDefault();
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["e" /* event */].stopImmediatePropagation();
});


/***/ }),

/***/ "./node_modules/d3-chord/src/array.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return slice; });
var slice = Array.prototype.slice;


/***/ }),

/***/ "./node_modules/d3-chord/src/chord.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__("./node_modules/d3-array/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__("./node_modules/d3-chord/src/math.js");



function compareValue(compare) {
  return function(a, b) {
    return compare(
      a.source.value + a.target.value,
      b.source.value + b.target.value
    );
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var padAngle = 0,
      sortGroups = null,
      sortSubgroups = null,
      sortChords = null;

  function chord(matrix) {
    var n = matrix.length,
        groupSums = [],
        groupIndex = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["s" /* range */])(n),
        subgroupIndex = [],
        chords = [],
        groups = chords.groups = new Array(n),
        subgroups = new Array(n * n),
        k,
        x,
        x0,
        dx,
        i,
        j;

    // Compute the sum.
    k = 0, i = -1; while (++i < n) {
      x = 0, j = -1; while (++j < n) {
        x += matrix[i][j];
      }
      groupSums.push(x);
      subgroupIndex.push(Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["s" /* range */])(n));
      k += x;
    }

    // Sort groups…
    if (sortGroups) groupIndex.sort(function(a, b) {
      return sortGroups(groupSums[a], groupSums[b]);
    });

    // Sort subgroups…
    if (sortSubgroups) subgroupIndex.forEach(function(d, i) {
      d.sort(function(a, b) {
        return sortSubgroups(matrix[i][a], matrix[i][b]);
      });
    });

    // Convert the sum to scaling factor for [0, 2pi].
    // TODO Allow start and end angle to be specified?
    // TODO Allow padding to be specified as percentage?
    k = Object(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* max */])(0, __WEBPACK_IMPORTED_MODULE_1__math__["e" /* tau */] - padAngle * n) / k;
    dx = k ? padAngle : __WEBPACK_IMPORTED_MODULE_1__math__["e" /* tau */] / n;

    // Compute the start and end angle for each group and subgroup.
    // Note: Opera has a bug reordering object literal properties!
    x = 0, i = -1; while (++i < n) {
      x0 = x, j = -1; while (++j < n) {
        var di = groupIndex[i],
            dj = subgroupIndex[di][j],
            v = matrix[di][dj],
            a0 = x,
            a1 = x += v * k;
        subgroups[dj * n + di] = {
          index: di,
          subindex: dj,
          startAngle: a0,
          endAngle: a1,
          value: v
        };
      }
      groups[di] = {
        index: di,
        startAngle: x0,
        endAngle: x,
        value: groupSums[di]
      };
      x += dx;
    }

    // Generate chords for each (non-empty) subgroup-subgroup link.
    i = -1; while (++i < n) {
      j = i - 1; while (++j < n) {
        var source = subgroups[j * n + i],
            target = subgroups[i * n + j];
        if (source.value || target.value) {
          chords.push(source.value < target.value
              ? {source: target, target: source}
              : {source: source, target: target});
        }
      }
    }

    return sortChords ? chords.sort(sortChords) : chords;
  }

  chord.padAngle = function(_) {
    return arguments.length ? (padAngle = Object(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* max */])(0, _), chord) : padAngle;
  };

  chord.sortGroups = function(_) {
    return arguments.length ? (sortGroups = _, chord) : sortGroups;
  };

  chord.sortSubgroups = function(_) {
    return arguments.length ? (sortSubgroups = _, chord) : sortSubgroups;
  };

  chord.sortChords = function(_) {
    return arguments.length ? (_ == null ? sortChords = null : (sortChords = compareValue(_))._ = _, chord) : sortChords && sortChords._;
  };

  return chord;
});


/***/ }),

/***/ "./node_modules/d3-chord/src/constant.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),

/***/ "./node_modules/d3-chord/src/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chord__ = __webpack_require__("./node_modules/d3-chord/src/chord.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__chord__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ribbon__ = __webpack_require__("./node_modules/d3-chord/src/ribbon.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__ribbon__["a"]; });




/***/ }),

/***/ "./node_modules/d3-chord/src/math.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return sin; });
/* unused harmony export pi */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return halfPi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return tau; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return max; });
var cos = Math.cos;
var sin = Math.sin;
var pi = Math.PI;
var halfPi = pi / 2;
var tau = pi * 2;
var max = Math.max;


/***/ }),

/***/ "./node_modules/d3-chord/src/ribbon.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__("./node_modules/d3-chord/src/array.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__("./node_modules/d3-chord/src/constant.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__("./node_modules/d3-chord/src/math.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_path__ = __webpack_require__("./node_modules/d3-path/src/index.js");





function defaultSource(d) {
  return d.source;
}

function defaultTarget(d) {
  return d.target;
}

function defaultRadius(d) {
  return d.radius;
}

function defaultStartAngle(d) {
  return d.startAngle;
}

function defaultEndAngle(d) {
  return d.endAngle;
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var source = defaultSource,
      target = defaultTarget,
      radius = defaultRadius,
      startAngle = defaultStartAngle,
      endAngle = defaultEndAngle,
      context = null;

  function ribbon() {
    var buffer,
        argv = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(arguments),
        s = source.apply(this, argv),
        t = target.apply(this, argv),
        sr = +radius.apply(this, (argv[0] = s, argv)),
        sa0 = startAngle.apply(this, argv) - __WEBPACK_IMPORTED_MODULE_2__math__["b" /* halfPi */],
        sa1 = endAngle.apply(this, argv) - __WEBPACK_IMPORTED_MODULE_2__math__["b" /* halfPi */],
        sx0 = sr * Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" /* cos */])(sa0),
        sy0 = sr * Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* sin */])(sa0),
        tr = +radius.apply(this, (argv[0] = t, argv)),
        ta0 = startAngle.apply(this, argv) - __WEBPACK_IMPORTED_MODULE_2__math__["b" /* halfPi */],
        ta1 = endAngle.apply(this, argv) - __WEBPACK_IMPORTED_MODULE_2__math__["b" /* halfPi */];

    if (!context) context = buffer = Object(__WEBPACK_IMPORTED_MODULE_3_d3_path__["a" /* path */])();

    context.moveTo(sx0, sy0);
    context.arc(0, 0, sr, sa0, sa1);
    if (sa0 !== ta0 || sa1 !== ta1) { // TODO sr !== tr?
      context.quadraticCurveTo(0, 0, tr * Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" /* cos */])(ta0), tr * Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* sin */])(ta0));
      context.arc(0, 0, tr, ta0, ta1);
    }
    context.quadraticCurveTo(0, 0, sx0, sy0);
    context.closePath();

    if (buffer) return context = null, buffer + "" || null;
  }

  ribbon.radius = function(_) {
    return arguments.length ? (radius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), ribbon) : radius;
  };

  ribbon.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), ribbon) : startAngle;
  };

  ribbon.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), ribbon) : endAngle;
  };

  ribbon.source = function(_) {
    return arguments.length ? (source = _, ribbon) : source;
  };

  ribbon.target = function(_) {
    return arguments.length ? (target = _, ribbon) : target;
  };

  ribbon.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), ribbon) : context;
  };

  return ribbon;
});


/***/ }),

/***/ "./node_modules/d3-collection/src/entries.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(map) {
  var entries = [];
  for (var key in map) entries.push({key: key, value: map[key]});
  return entries;
});


/***/ }),

/***/ "./node_modules/d3-collection/src/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nest__ = __webpack_require__("./node_modules/d3-collection/src/nest.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__nest__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__set__ = __webpack_require__("./node_modules/d3-collection/src/set.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__set__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__map__ = __webpack_require__("./node_modules/d3-collection/src/map.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__map__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__keys__ = __webpack_require__("./node_modules/d3-collection/src/keys.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__keys__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__values__ = __webpack_require__("./node_modules/d3-collection/src/values.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_4__values__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__entries__ = __webpack_require__("./node_modules/d3-collection/src/entries.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__entries__["a"]; });








/***/ }),

/***/ "./node_modules/d3-collection/src/keys.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(map) {
  var keys = [];
  for (var key in map) keys.push(key);
  return keys;
});


/***/ }),

/***/ "./node_modules/d3-collection/src/map.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return prefix; });
var prefix = "$";

function Map() {}

Map.prototype = map.prototype = {
  constructor: Map,
  has: function(key) {
    return (prefix + key) in this;
  },
  get: function(key) {
    return this[prefix + key];
  },
  set: function(key, value) {
    this[prefix + key] = value;
    return this;
  },
  remove: function(key) {
    var property = prefix + key;
    return property in this && delete this[property];
  },
  clear: function() {
    for (var property in this) if (property[0] === prefix) delete this[property];
  },
  keys: function() {
    var keys = [];
    for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
    return keys;
  },
  values: function() {
    var values = [];
    for (var property in this) if (property[0] === prefix) values.push(this[property]);
    return values;
  },
  entries: function() {
    var entries = [];
    for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
    return entries;
  },
  size: function() {
    var size = 0;
    for (var property in this) if (property[0] === prefix) ++size;
    return size;
  },
  empty: function() {
    for (var property in this) if (property[0] === prefix) return false;
    return true;
  },
  each: function(f) {
    for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
  }
};

function map(object, f) {
  var map = new Map;

  // Copy constructor.
  if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });

  // Index array by numeric index or specified key function.
  else if (Array.isArray(object)) {
    var i = -1,
        n = object.length,
        o;

    if (f == null) while (++i < n) map.set(i, object[i]);
    else while (++i < n) map.set(f(o = object[i], i, object), o);
  }

  // Convert object to map.
  else if (object) for (var key in object) map.set(key, object[key]);

  return map;
}

/* harmony default export */ __webpack_exports__["a"] = (map);


/***/ }),

/***/ "./node_modules/d3-collection/src/nest.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__map__ = __webpack_require__("./node_modules/d3-collection/src/map.js");


/* harmony default export */ __webpack_exports__["a"] = (function() {
  var keys = [],
      sortKeys = [],
      sortValues,
      rollup,
      nest;

  function apply(array, depth, createResult, setResult) {
    if (depth >= keys.length) {
      if (sortValues != null) array.sort(sortValues);
      return rollup != null ? rollup(array) : array;
    }

    var i = -1,
        n = array.length,
        key = keys[depth++],
        keyValue,
        value,
        valuesByKey = Object(__WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */])(),
        values,
        result = createResult();

    while (++i < n) {
      if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
        values.push(value);
      } else {
        valuesByKey.set(keyValue, [value]);
      }
    }

    valuesByKey.each(function(values, key) {
      setResult(result, key, apply(values, depth, createResult, setResult));
    });

    return result;
  }

  function entries(map, depth) {
    if (++depth > keys.length) return map;
    var array, sortKey = sortKeys[depth - 1];
    if (rollup != null && depth >= keys.length) array = map.entries();
    else array = [], map.each(function(v, k) { array.push({key: k, values: entries(v, depth)}); });
    return sortKey != null ? array.sort(function(a, b) { return sortKey(a.key, b.key); }) : array;
  }

  return nest = {
    object: function(array) { return apply(array, 0, createObject, setObject); },
    map: function(array) { return apply(array, 0, createMap, setMap); },
    entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
    key: function(d) { keys.push(d); return nest; },
    sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
    sortValues: function(order) { sortValues = order; return nest; },
    rollup: function(f) { rollup = f; return nest; }
  };
});

function createObject() {
  return {};
}

function setObject(object, key, value) {
  object[key] = value;
}

function createMap() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */])();
}

function setMap(map, key, value) {
  map.set(key, value);
}


/***/ }),

/***/ "./node_modules/d3-collection/src/set.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__map__ = __webpack_require__("./node_modules/d3-collection/src/map.js");


function Set() {}

var proto = __WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */].prototype;

Set.prototype = set.prototype = {
  constructor: Set,
  has: proto.has,
  add: function(value) {
    value += "";
    this[__WEBPACK_IMPORTED_MODULE_0__map__["b" /* prefix */] + value] = value;
    return this;
  },
  remove: proto.remove,
  clear: proto.clear,
  values: proto.keys,
  size: proto.size,
  empty: proto.empty,
  each: proto.each
};

function set(object, f) {
  var set = new Set;

  // Copy constructor.
  if (object instanceof Set) object.each(function(value) { set.add(value); });

  // Otherwise, assume it’s an array.
  else if (object) {
    var i = -1, n = object.length;
    if (f == null) while (++i < n) set.add(object[i]);
    else while (++i < n) set.add(f(object[i], i, object));
  }

  return set;
}

/* harmony default export */ __webpack_exports__["a"] = (set);


/***/ }),

/***/ "./node_modules/d3-collection/src/values.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(map) {
  var values = [];
  for (var key in map) values.push(map[key]);
  return values;
});


/***/ }),

/***/ "./node_modules/d3-color/src/color.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Color;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return darker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return brighter; });
/* harmony export (immutable) */ __webpack_exports__["e"] = color;
/* harmony export (immutable) */ __webpack_exports__["h"] = rgbConvert;
/* harmony export (immutable) */ __webpack_exports__["g"] = rgb;
/* harmony export (immutable) */ __webpack_exports__["b"] = Rgb;
/* unused harmony export hslConvert */
/* harmony export (immutable) */ __webpack_exports__["f"] = hsl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__("./node_modules/d3-color/src/define.js");


function Color() {}

var darker = 0.7;
var brighter = 1 / darker;

var reI = "\\s*([+-]?\\d+)\\s*",
    reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
    reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
    reHex3 = /^#([0-9a-f]{3})$/,
    reHex6 = /^#([0-9a-f]{6})$/,
    reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
    reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
    reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
    reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
    reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
    reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");

var named = {
  aliceblue: 0xf0f8ff,
  antiquewhite: 0xfaebd7,
  aqua: 0x00ffff,
  aquamarine: 0x7fffd4,
  azure: 0xf0ffff,
  beige: 0xf5f5dc,
  bisque: 0xffe4c4,
  black: 0x000000,
  blanchedalmond: 0xffebcd,
  blue: 0x0000ff,
  blueviolet: 0x8a2be2,
  brown: 0xa52a2a,
  burlywood: 0xdeb887,
  cadetblue: 0x5f9ea0,
  chartreuse: 0x7fff00,
  chocolate: 0xd2691e,
  coral: 0xff7f50,
  cornflowerblue: 0x6495ed,
  cornsilk: 0xfff8dc,
  crimson: 0xdc143c,
  cyan: 0x00ffff,
  darkblue: 0x00008b,
  darkcyan: 0x008b8b,
  darkgoldenrod: 0xb8860b,
  darkgray: 0xa9a9a9,
  darkgreen: 0x006400,
  darkgrey: 0xa9a9a9,
  darkkhaki: 0xbdb76b,
  darkmagenta: 0x8b008b,
  darkolivegreen: 0x556b2f,
  darkorange: 0xff8c00,
  darkorchid: 0x9932cc,
  darkred: 0x8b0000,
  darksalmon: 0xe9967a,
  darkseagreen: 0x8fbc8f,
  darkslateblue: 0x483d8b,
  darkslategray: 0x2f4f4f,
  darkslategrey: 0x2f4f4f,
  darkturquoise: 0x00ced1,
  darkviolet: 0x9400d3,
  deeppink: 0xff1493,
  deepskyblue: 0x00bfff,
  dimgray: 0x696969,
  dimgrey: 0x696969,
  dodgerblue: 0x1e90ff,
  firebrick: 0xb22222,
  floralwhite: 0xfffaf0,
  forestgreen: 0x228b22,
  fuchsia: 0xff00ff,
  gainsboro: 0xdcdcdc,
  ghostwhite: 0xf8f8ff,
  gold: 0xffd700,
  goldenrod: 0xdaa520,
  gray: 0x808080,
  green: 0x008000,
  greenyellow: 0xadff2f,
  grey: 0x808080,
  honeydew: 0xf0fff0,
  hotpink: 0xff69b4,
  indianred: 0xcd5c5c,
  indigo: 0x4b0082,
  ivory: 0xfffff0,
  khaki: 0xf0e68c,
  lavender: 0xe6e6fa,
  lavenderblush: 0xfff0f5,
  lawngreen: 0x7cfc00,
  lemonchiffon: 0xfffacd,
  lightblue: 0xadd8e6,
  lightcoral: 0xf08080,
  lightcyan: 0xe0ffff,
  lightgoldenrodyellow: 0xfafad2,
  lightgray: 0xd3d3d3,
  lightgreen: 0x90ee90,
  lightgrey: 0xd3d3d3,
  lightpink: 0xffb6c1,
  lightsalmon: 0xffa07a,
  lightseagreen: 0x20b2aa,
  lightskyblue: 0x87cefa,
  lightslategray: 0x778899,
  lightslategrey: 0x778899,
  lightsteelblue: 0xb0c4de,
  lightyellow: 0xffffe0,
  lime: 0x00ff00,
  limegreen: 0x32cd32,
  linen: 0xfaf0e6,
  magenta: 0xff00ff,
  maroon: 0x800000,
  mediumaquamarine: 0x66cdaa,
  mediumblue: 0x0000cd,
  mediumorchid: 0xba55d3,
  mediumpurple: 0x9370db,
  mediumseagreen: 0x3cb371,
  mediumslateblue: 0x7b68ee,
  mediumspringgreen: 0x00fa9a,
  mediumturquoise: 0x48d1cc,
  mediumvioletred: 0xc71585,
  midnightblue: 0x191970,
  mintcream: 0xf5fffa,
  mistyrose: 0xffe4e1,
  moccasin: 0xffe4b5,
  navajowhite: 0xffdead,
  navy: 0x000080,
  oldlace: 0xfdf5e6,
  olive: 0x808000,
  olivedrab: 0x6b8e23,
  orange: 0xffa500,
  orangered: 0xff4500,
  orchid: 0xda70d6,
  palegoldenrod: 0xeee8aa,
  palegreen: 0x98fb98,
  paleturquoise: 0xafeeee,
  palevioletred: 0xdb7093,
  papayawhip: 0xffefd5,
  peachpuff: 0xffdab9,
  peru: 0xcd853f,
  pink: 0xffc0cb,
  plum: 0xdda0dd,
  powderblue: 0xb0e0e6,
  purple: 0x800080,
  rebeccapurple: 0x663399,
  red: 0xff0000,
  rosybrown: 0xbc8f8f,
  royalblue: 0x4169e1,
  saddlebrown: 0x8b4513,
  salmon: 0xfa8072,
  sandybrown: 0xf4a460,
  seagreen: 0x2e8b57,
  seashell: 0xfff5ee,
  sienna: 0xa0522d,
  silver: 0xc0c0c0,
  skyblue: 0x87ceeb,
  slateblue: 0x6a5acd,
  slategray: 0x708090,
  slategrey: 0x708090,
  snow: 0xfffafa,
  springgreen: 0x00ff7f,
  steelblue: 0x4682b4,
  tan: 0xd2b48c,
  teal: 0x008080,
  thistle: 0xd8bfd8,
  tomato: 0xff6347,
  turquoise: 0x40e0d0,
  violet: 0xee82ee,
  wheat: 0xf5deb3,
  white: 0xffffff,
  whitesmoke: 0xf5f5f5,
  yellow: 0xffff00,
  yellowgreen: 0x9acd32
};

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Color, color, {
  displayable: function() {
    return this.rgb().displayable();
  },
  hex: function() {
    return this.rgb().hex();
  },
  toString: function() {
    return this.rgb() + "";
  }
});

function color(format) {
  var m;
  format = (format + "").trim().toLowerCase();
  return (m = reHex3.exec(format)) ? (m = parseInt(m[1], 16), new Rgb((m >> 8 & 0xf) | (m >> 4 & 0x0f0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1)) // #f00
      : (m = reHex6.exec(format)) ? rgbn(parseInt(m[1], 16)) // #ff0000
      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
      : named.hasOwnProperty(format) ? rgbn(named[format])
      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
      : null;
}

function rgbn(n) {
  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}

function rgba(r, g, b, a) {
  if (a <= 0) r = g = b = NaN;
  return new Rgb(r, g, b, a);
}

function rgbConvert(o) {
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Rgb;
  o = o.rgb();
  return new Rgb(o.r, o.g, o.b, o.opacity);
}

function rgb(r, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}

function Rgb(r, g, b, opacity) {
  this.r = +r;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Rgb, rgb, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  rgb: function() {
    return this;
  },
  displayable: function() {
    return (0 <= this.r && this.r <= 255)
        && (0 <= this.g && this.g <= 255)
        && (0 <= this.b && this.b <= 255)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  hex: function() {
    return "#" + hex(this.r) + hex(this.g) + hex(this.b);
  },
  toString: function() {
    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(")
        + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
        + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
        + Math.max(0, Math.min(255, Math.round(this.b) || 0))
        + (a === 1 ? ")" : ", " + a + ")");
  }
}));

function hex(value) {
  value = Math.max(0, Math.min(255, Math.round(value) || 0));
  return (value < 16 ? "0" : "") + value.toString(16);
}

function hsla(h, s, l, a) {
  if (a <= 0) h = s = l = NaN;
  else if (l <= 0 || l >= 1) h = s = NaN;
  else if (s <= 0) h = NaN;
  return new Hsl(h, s, l, a);
}

function hslConvert(o) {
  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Hsl;
  if (o instanceof Hsl) return o;
  o = o.rgb();
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      h = NaN,
      s = max - min,
      l = (max + min) / 2;
  if (s) {
    if (r === max) h = (g - b) / s + (g < b) * 6;
    else if (g === max) h = (b - r) / s + 2;
    else h = (r - g) / s + 4;
    s /= l < 0.5 ? max + min : 2 - max - min;
    h *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h;
  }
  return new Hsl(h, s, l, o.opacity);
}

function hsl(h, s, l, opacity) {
  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}

function Hsl(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Hsl, hsl, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = this.h % 360 + (this.h < 0) * 360,
        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
        l = this.l,
        m2 = l + (l < 0.5 ? l : 1 - l) * s,
        m1 = 2 * l - m2;
    return new Rgb(
      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
      hsl2rgb(h, m1, m2),
      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
      this.opacity
    );
  },
  displayable: function() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
        && (0 <= this.l && this.l <= 1)
        && (0 <= this.opacity && this.opacity <= 1);
  }
}));

/* From FvD 13.37, CSS Color Module Level 3 */
function hsl2rgb(h, m1, m2) {
  return (h < 60 ? m1 + (m2 - m1) * h / 60
      : h < 180 ? m2
      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
      : m1) * 255;
}


/***/ }),

/***/ "./node_modules/d3-color/src/cubehelix.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cubehelix;
/* unused harmony export Cubehelix */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__("./node_modules/d3-color/src/define.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__("./node_modules/d3-color/src/color.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__("./node_modules/d3-color/src/math.js");




var A = -0.14861,
    B = +1.78277,
    C = -0.29227,
    D = -0.90649,
    E = +1.97294,
    ED = E * D,
    EB = E * B,
    BC_DA = B * C - D * A;

function cubehelixConvert(o) {
  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof __WEBPACK_IMPORTED_MODULE_1__color__["b" /* Rgb */])) o = Object(__WEBPACK_IMPORTED_MODULE_1__color__["h" /* rgbConvert */])(o);
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
      bl = b - l,
      k = (E * (g - l) - C * bl) / D,
      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
      h = s ? Math.atan2(k, bl) * __WEBPACK_IMPORTED_MODULE_2__math__["b" /* rad2deg */] - 120 : NaN;
  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}

function cubehelix(h, s, l, opacity) {
  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}

function Cubehelix(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Cubehelix, cubehelix, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* Color */], {
  brighter: function(k) {
    k = k == null ? __WEBPACK_IMPORTED_MODULE_1__color__["c" /* brighter */] : Math.pow(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* brighter */], k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? __WEBPACK_IMPORTED_MODULE_1__color__["d" /* darker */] : Math.pow(__WEBPACK_IMPORTED_MODULE_1__color__["d" /* darker */], k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = isNaN(this.h) ? 0 : (this.h + 120) * __WEBPACK_IMPORTED_MODULE_2__math__["a" /* deg2rad */],
        l = +this.l,
        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
        cosh = Math.cos(h),
        sinh = Math.sin(h);
    return new __WEBPACK_IMPORTED_MODULE_1__color__["b" /* Rgb */](
      255 * (l + a * (A * cosh + B * sinh)),
      255 * (l + a * (C * cosh + D * sinh)),
      255 * (l + a * (E * cosh)),
      this.opacity
    );
  }
}));


/***/ }),

/***/ "./node_modules/d3-color/src/define.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = extend;
/* harmony default export */ __webpack_exports__["a"] = (function(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
});

function extend(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition) prototype[key] = definition[key];
  return prototype;
}


/***/ }),

/***/ "./node_modules/d3-color/src/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__color__ = __webpack_require__("./node_modules/d3-color/src/color.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__color__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_0__color__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__color__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lab__ = __webpack_require__("./node_modules/d3-color/src/lab.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_1__lab__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__lab__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_1__lab__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__lab__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cubehelix__ = __webpack_require__("./node_modules/d3-color/src/cubehelix.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__cubehelix__["a"]; });





/***/ }),

/***/ "./node_modules/d3-color/src/lab.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = gray;
/* harmony export (immutable) */ __webpack_exports__["a"] = lab;
/* unused harmony export Lab */
/* harmony export (immutable) */ __webpack_exports__["d"] = lch;
/* harmony export (immutable) */ __webpack_exports__["c"] = hcl;
/* unused harmony export Hcl */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__("./node_modules/d3-color/src/define.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__("./node_modules/d3-color/src/color.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__("./node_modules/d3-color/src/math.js");




// https://beta.observablehq.com/@mbostock/lab-and-rgb
var K = 18,
    Xn = 0.96422,
    Yn = 1,
    Zn = 0.82521,
    t0 = 4 / 29,
    t1 = 6 / 29,
    t2 = 3 * t1 * t1,
    t3 = t1 * t1 * t1;

function labConvert(o) {
  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
  if (o instanceof Hcl) {
    if (isNaN(o.h)) return new Lab(o.l, 0, 0, o.opacity);
    var h = o.h * __WEBPACK_IMPORTED_MODULE_2__math__["a" /* deg2rad */];
    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
  }
  if (!(o instanceof __WEBPACK_IMPORTED_MODULE_1__color__["b" /* Rgb */])) o = Object(__WEBPACK_IMPORTED_MODULE_1__color__["h" /* rgbConvert */])(o);
  var r = rgb2lrgb(o.r),
      g = rgb2lrgb(o.g),
      b = rgb2lrgb(o.b),
      y = xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / Yn), x, z;
  if (r === g && g === b) x = z = y; else {
    x = xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / Xn);
    z = xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / Zn);
  }
  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}

function gray(l, opacity) {
  return new Lab(l, 0, 0, opacity == null ? 1 : opacity);
}

function lab(l, a, b, opacity) {
  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
}

function Lab(l, a, b, opacity) {
  this.l = +l;
  this.a = +a;
  this.b = +b;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Lab, lab, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* Color */], {
  brighter: function(k) {
    return new Lab(this.l + K * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  darker: function(k) {
    return new Lab(this.l - K * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  rgb: function() {
    var y = (this.l + 16) / 116,
        x = isNaN(this.a) ? y : y + this.a / 500,
        z = isNaN(this.b) ? y : y - this.b / 200;
    x = Xn * lab2xyz(x);
    y = Yn * lab2xyz(y);
    z = Zn * lab2xyz(z);
    return new __WEBPACK_IMPORTED_MODULE_1__color__["b" /* Rgb */](
      lrgb2rgb( 3.1338561 * x - 1.6168667 * y - 0.4906146 * z),
      lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z),
      lrgb2rgb( 0.0719453 * x - 0.2289914 * y + 1.4052427 * z),
      this.opacity
    );
  }
}));

function xyz2lab(t) {
  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
}

function lab2xyz(t) {
  return t > t1 ? t * t * t : t2 * (t - t0);
}

function lrgb2rgb(x) {
  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}

function rgb2lrgb(x) {
  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}

function hclConvert(o) {
  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
  if (!(o instanceof Lab)) o = labConvert(o);
  if (o.a === 0 && o.b === 0) return new Hcl(NaN, 0, o.l, o.opacity);
  var h = Math.atan2(o.b, o.a) * __WEBPACK_IMPORTED_MODULE_2__math__["b" /* rad2deg */];
  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}

function lch(l, c, h, opacity) {
  return arguments.length === 1 ? hclConvert(l) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}

function hcl(h, c, l, opacity) {
  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}

function Hcl(h, c, l, opacity) {
  this.h = +h;
  this.c = +c;
  this.l = +l;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Hcl, hcl, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* Color */], {
  brighter: function(k) {
    return new Hcl(this.h, this.c, this.l + K * (k == null ? 1 : k), this.opacity);
  },
  darker: function(k) {
    return new Hcl(this.h, this.c, this.l - K * (k == null ? 1 : k), this.opacity);
  },
  rgb: function() {
    return labConvert(this).rgb();
  }
}));


/***/ }),

/***/ "./node_modules/d3-color/src/math.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return deg2rad; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return rad2deg; });
var deg2rad = Math.PI / 180;
var rad2deg = 180 / Math.PI;


/***/ }),

/***/ "./node_modules/d3-contour/src/area.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(ring) {
  var i = 0, n = ring.length, area = ring[n - 1][1] * ring[0][0] - ring[n - 1][0] * ring[0][1];
  while (++i < n) area += ring[i - 1][1] * ring[i][0] - ring[i - 1][0] * ring[i][1];
  return area;
});


/***/ }),

/***/ "./node_modules/d3-contour/src/array.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return slice; });
var array = Array.prototype;

var slice = array.slice;


/***/ }),

/***/ "./node_modules/d3-contour/src/ascending.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a - b;
});


/***/ }),

/***/ "./node_modules/d3-contour/src/blur.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = blurX;
/* harmony export (immutable) */ __webpack_exports__["b"] = blurY;
// TODO Optimize edge cases.
// TODO Optimize index calculation.
// TODO Optimize arguments.
function blurX(source, target, r) {
  var n = source.width,
      m = source.height,
      w = (r << 1) + 1;
  for (var j = 0; j < m; ++j) {
    for (var i = 0, sr = 0; i < n + r; ++i) {
      if (i < n) {
        sr += source.data[i + j * n];
      }
      if (i >= r) {
        if (i >= w) {
          sr -= source.data[i - w + j * n];
        }
        target.data[i - r + j * n] = sr / Math.min(i + 1, n - 1 + w - i, w);
      }
    }
  }
}

// TODO Optimize edge cases.
// TODO Optimize index calculation.
// TODO Optimize arguments.
function blurY(source, target, r) {
  var n = source.width,
      m = source.height,
      w = (r << 1) + 1;
  for (var i = 0; i < n; ++i) {
    for (var j = 0, sr = 0; j < m + r; ++j) {
      if (j < m) {
        sr += source.data[i + j * n];
      }
      if (j >= r) {
        if (j >= w) {
          sr -= source.data[i + (j - w) * n];
        }
        target.data[i + (j - r) * n] = sr / Math.min(j + 1, m - 1 + w - j, w);
      }
    }
  }
}


/***/ }),

/***/ "./node_modules/d3-contour/src/constant.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),

/***/ "./node_modules/d3-contour/src/contains.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(ring, hole) {
  var i = -1, n = hole.length, c;
  while (++i < n) if (c = ringContains(ring, hole[i])) return c;
  return 0;
});

function ringContains(ring, point) {
  var x = point[0], y = point[1], contains = -1;
  for (var i = 0, n = ring.length, j = n - 1; i < n; j = i++) {
    var pi = ring[i], xi = pi[0], yi = pi[1], pj = ring[j], xj = pj[0], yj = pj[1];
    if (segmentContains(pi, pj, point)) return 0;
    if (((yi > y) !== (yj > y)) && ((x < (xj - xi) * (y - yi) / (yj - yi) + xi))) contains = -contains;
  }
  return contains;
}

function segmentContains(a, b, c) {
  var i; return collinear(a, b, c) && within(a[i = +(a[0] === b[0])], c[i], b[i]);
}

function collinear(a, b, c) {
  return (b[0] - a[0]) * (c[1] - a[1]) === (c[0] - a[0]) * (b[1] - a[1]);
}

function within(p, q, r) {
  return p <= q && q <= r || r <= q && q <= p;
}


/***/ }),

/***/ "./node_modules/d3-contour/src/contours.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__("./node_modules/d3-array/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__("./node_modules/d3-contour/src/array.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ascending__ = __webpack_require__("./node_modules/d3-contour/src/ascending.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__area__ = __webpack_require__("./node_modules/d3-contour/src/area.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constant__ = __webpack_require__("./node_modules/d3-contour/src/constant.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__contains__ = __webpack_require__("./node_modules/d3-contour/src/contains.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__noop__ = __webpack_require__("./node_modules/d3-contour/src/noop.js");








var cases = [
  [],
  [[[1.0, 1.5], [0.5, 1.0]]],
  [[[1.5, 1.0], [1.0, 1.5]]],
  [[[1.5, 1.0], [0.5, 1.0]]],
  [[[1.0, 0.5], [1.5, 1.0]]],
  [[[1.0, 1.5], [0.5, 1.0]], [[1.0, 0.5], [1.5, 1.0]]],
  [[[1.0, 0.5], [1.0, 1.5]]],
  [[[1.0, 0.5], [0.5, 1.0]]],
  [[[0.5, 1.0], [1.0, 0.5]]],
  [[[1.0, 1.5], [1.0, 0.5]]],
  [[[0.5, 1.0], [1.0, 0.5]], [[1.5, 1.0], [1.0, 1.5]]],
  [[[1.5, 1.0], [1.0, 0.5]]],
  [[[0.5, 1.0], [1.5, 1.0]]],
  [[[1.0, 1.5], [1.5, 1.0]]],
  [[[0.5, 1.0], [1.0, 1.5]]],
  []
];

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var dx = 1,
      dy = 1,
      threshold = __WEBPACK_IMPORTED_MODULE_0_d3_array__["y" /* thresholdSturges */],
      smooth = smoothLinear;

  function contours(values) {
    var tz = threshold(values);

    // Convert number of thresholds into uniform thresholds.
    if (!Array.isArray(tz)) {
      var domain = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["i" /* extent */])(values), start = domain[0], stop = domain[1];
      tz = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["A" /* tickStep */])(start, stop, tz);
      tz = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["s" /* range */])(Math.floor(start / tz) * tz, Math.floor(stop / tz) * tz, tz);
    } else {
      tz = tz.slice().sort(__WEBPACK_IMPORTED_MODULE_2__ascending__["a" /* default */]);
    }

    return tz.map(function(value) {
      return contour(values, value);
    });
  }

  // Accumulate, smooth contour rings, assign holes to exterior rings.
  // Based on https://github.com/mbostock/shapefile/blob/v0.6.2/shp/polygon.js
  function contour(values, value) {
    var polygons = [],
        holes = [];

    isorings(values, value, function(ring) {
      smooth(ring, values, value);
      if (Object(__WEBPACK_IMPORTED_MODULE_3__area__["a" /* default */])(ring) > 0) polygons.push([ring]);
      else holes.push(ring);
    });

    holes.forEach(function(hole) {
      for (var i = 0, n = polygons.length, polygon; i < n; ++i) {
        if (Object(__WEBPACK_IMPORTED_MODULE_5__contains__["a" /* default */])((polygon = polygons[i])[0], hole) !== -1) {
          polygon.push(hole);
          return;
        }
      }
    });

    return {
      type: "MultiPolygon",
      value: value,
      coordinates: polygons
    };
  }

  // Marching squares with isolines stitched into rings.
  // Based on https://github.com/topojson/topojson-client/blob/v3.0.0/src/stitch.js
  function isorings(values, value, callback) {
    var fragmentByStart = new Array,
        fragmentByEnd = new Array,
        x, y, t0, t1, t2, t3;

    // Special case for the first row (y = -1, t2 = t3 = 0).
    x = y = -1;
    t1 = values[0] >= value;
    cases[t1 << 1].forEach(stitch);
    while (++x < dx - 1) {
      t0 = t1, t1 = values[x + 1] >= value;
      cases[t0 | t1 << 1].forEach(stitch);
    }
    cases[t1 << 0].forEach(stitch);

    // General case for the intermediate rows.
    while (++y < dy - 1) {
      x = -1;
      t1 = values[y * dx + dx] >= value;
      t2 = values[y * dx] >= value;
      cases[t1 << 1 | t2 << 2].forEach(stitch);
      while (++x < dx - 1) {
        t0 = t1, t1 = values[y * dx + dx + x + 1] >= value;
        t3 = t2, t2 = values[y * dx + x + 1] >= value;
        cases[t0 | t1 << 1 | t2 << 2 | t3 << 3].forEach(stitch);
      }
      cases[t1 | t2 << 3].forEach(stitch);
    }

    // Special case for the last row (y = dy - 1, t0 = t1 = 0).
    x = -1;
    t2 = values[y * dx] >= value;
    cases[t2 << 2].forEach(stitch);
    while (++x < dx - 1) {
      t3 = t2, t2 = values[y * dx + x + 1] >= value;
      cases[t2 << 2 | t3 << 3].forEach(stitch);
    }
    cases[t2 << 3].forEach(stitch);

    function stitch(line) {
      var start = [line[0][0] + x, line[0][1] + y],
          end = [line[1][0] + x, line[1][1] + y],
          startIndex = index(start),
          endIndex = index(end),
          f, g;
      if (f = fragmentByEnd[startIndex]) {
        if (g = fragmentByStart[endIndex]) {
          delete fragmentByEnd[f.end];
          delete fragmentByStart[g.start];
          if (f === g) {
            f.ring.push(end);
            callback(f.ring);
          } else {
            fragmentByStart[f.start] = fragmentByEnd[g.end] = {start: f.start, end: g.end, ring: f.ring.concat(g.ring)};
          }
        } else {
          delete fragmentByEnd[f.end];
          f.ring.push(end);
          fragmentByEnd[f.end = endIndex] = f;
        }
      } else if (f = fragmentByStart[endIndex]) {
        if (g = fragmentByEnd[startIndex]) {
          delete fragmentByStart[f.start];
          delete fragmentByEnd[g.end];
          if (f === g) {
            f.ring.push(end);
            callback(f.ring);
          } else {
            fragmentByStart[g.start] = fragmentByEnd[f.end] = {start: g.start, end: f.end, ring: g.ring.concat(f.ring)};
          }
        } else {
          delete fragmentByStart[f.start];
          f.ring.unshift(start);
          fragmentByStart[f.start = startIndex] = f;
        }
      } else {
        fragmentByStart[startIndex] = fragmentByEnd[endIndex] = {start: startIndex, end: endIndex, ring: [start, end]};
      }
    }
  }

  function index(point) {
    return point[0] * 2 + point[1] * (dx + 1) * 4;
  }

  function smoothLinear(ring, values, value) {
    ring.forEach(function(point) {
      var x = point[0],
          y = point[1],
          xt = x | 0,
          yt = y | 0,
          v0,
          v1 = values[yt * dx + xt];
      if (x > 0 && x < dx && xt === x) {
        v0 = values[yt * dx + xt - 1];
        point[0] = x + (value - v0) / (v1 - v0) - 0.5;
      }
      if (y > 0 && y < dy && yt === y) {
        v0 = values[(yt - 1) * dx + xt];
        point[1] = y + (value - v0) / (v1 - v0) - 0.5;
      }
    });
  }

  contours.contour = contour;

  contours.size = function(_) {
    if (!arguments.length) return [dx, dy];
    var _0 = Math.ceil(_[0]), _1 = Math.ceil(_[1]);
    if (!(_0 > 0) || !(_1 > 0)) throw new Error("invalid size");
    return dx = _0, dy = _1, contours;
  };

  contours.thresholds = function(_) {
    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? Object(__WEBPACK_IMPORTED_MODULE_4__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__array__["a" /* slice */].call(_)) : Object(__WEBPACK_IMPORTED_MODULE_4__constant__["a" /* default */])(_), contours) : threshold;
  };

  contours.smooth = function(_) {
    return arguments.length ? (smooth = _ ? smoothLinear : __WEBPACK_IMPORTED_MODULE_6__noop__["a" /* default */], contours) : smooth === smoothLinear;
  };

  return contours;
});


/***/ }),

/***/ "./node_modules/d3-contour/src/density.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__("./node_modules/d3-array/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__("./node_modules/d3-contour/src/array.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__blur__ = __webpack_require__("./node_modules/d3-contour/src/blur.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constant__ = __webpack_require__("./node_modules/d3-contour/src/constant.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__contours__ = __webpack_require__("./node_modules/d3-contour/src/contours.js");






function defaultX(d) {
  return d[0];
}

function defaultY(d) {
  return d[1];
}

function defaultWeight() {
  return 1;
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var x = defaultX,
      y = defaultY,
      weight = defaultWeight,
      dx = 960,
      dy = 500,
      r = 20, // blur radius
      k = 2, // log2(grid cell size)
      o = r * 3, // grid offset, to pad for blur
      n = (dx + o * 2) >> k, // grid width
      m = (dy + o * 2) >> k, // grid height
      threshold = Object(__WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */])(20);

  function density(data) {
    var values0 = new Float32Array(n * m),
        values1 = new Float32Array(n * m);

    data.forEach(function(d, i, data) {
      var xi = (+x(d, i, data) + o) >> k,
          yi = (+y(d, i, data) + o) >> k,
          wi = +weight(d, i, data);
      if (xi >= 0 && xi < n && yi >= 0 && yi < m) {
        values0[xi + yi * n] += wi;
      }
    });

    // TODO Optimize.
    Object(__WEBPACK_IMPORTED_MODULE_2__blur__["a" /* blurX */])({width: n, height: m, data: values0}, {width: n, height: m, data: values1}, r >> k);
    Object(__WEBPACK_IMPORTED_MODULE_2__blur__["b" /* blurY */])({width: n, height: m, data: values1}, {width: n, height: m, data: values0}, r >> k);
    Object(__WEBPACK_IMPORTED_MODULE_2__blur__["a" /* blurX */])({width: n, height: m, data: values0}, {width: n, height: m, data: values1}, r >> k);
    Object(__WEBPACK_IMPORTED_MODULE_2__blur__["b" /* blurY */])({width: n, height: m, data: values1}, {width: n, height: m, data: values0}, r >> k);
    Object(__WEBPACK_IMPORTED_MODULE_2__blur__["a" /* blurX */])({width: n, height: m, data: values0}, {width: n, height: m, data: values1}, r >> k);
    Object(__WEBPACK_IMPORTED_MODULE_2__blur__["b" /* blurY */])({width: n, height: m, data: values1}, {width: n, height: m, data: values0}, r >> k);

    var tz = threshold(values0);

    // Convert number of thresholds into uniform thresholds.
    if (!Array.isArray(tz)) {
      var stop = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["k" /* max */])(values0);
      tz = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["A" /* tickStep */])(0, stop, tz);
      tz = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["s" /* range */])(0, Math.floor(stop / tz) * tz, tz);
      tz.shift();
    }

    return Object(__WEBPACK_IMPORTED_MODULE_4__contours__["a" /* default */])()
        .thresholds(tz)
        .size([n, m])
      (values0)
        .map(transform);
  }

  function transform(geometry) {
    geometry.value *= Math.pow(2, -2 * k); // Density in points per square pixel.
    geometry.coordinates.forEach(transformPolygon);
    return geometry;
  }

  function transformPolygon(coordinates) {
    coordinates.forEach(transformRing);
  }

  function transformRing(coordinates) {
    coordinates.forEach(transformPoint);
  }

  // TODO Optimize.
  function transformPoint(coordinates) {
    coordinates[0] = coordinates[0] * Math.pow(2, k) - o;
    coordinates[1] = coordinates[1] * Math.pow(2, k) - o;
  }

  function resize() {
    o = r * 3;
    n = (dx + o * 2) >> k;
    m = (dy + o * 2) >> k;
    return density;
  }

  density.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */])(+_), density) : x;
  };

  density.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */])(+_), density) : y;
  };

  density.weight = function(_) {
    return arguments.length ? (weight = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */])(+_), density) : weight;
  };

  density.size = function(_) {
    if (!arguments.length) return [dx, dy];
    var _0 = Math.ceil(_[0]), _1 = Math.ceil(_[1]);
    if (!(_0 >= 0) && !(_0 >= 0)) throw new Error("invalid size");
    return dx = _0, dy = _1, resize();
  };

  density.cellSize = function(_) {
    if (!arguments.length) return 1 << k;
    if (!((_ = +_) >= 1)) throw new Error("invalid cell size");
    return k = Math.floor(Math.log(_) / Math.LN2), resize();
  };

  density.thresholds = function(_) {
    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? Object(__WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__array__["a" /* slice */].call(_)) : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */])(_), density) : threshold;
  };

  density.bandwidth = function(_) {
    if (!arguments.length) return Math.sqrt(r * (r + 1));
    if (!((_ = +_) >= 0)) throw new Error("invalid bandwidth");
    return r = Math.round((Math.sqrt(4 * _ * _ + 1) - 1) / 2), resize();
  };

  return density;
});


/***/ }),

/***/ "./node_modules/d3-contour/src/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contours__ = __webpack_require__("./node_modules/d3-contour/src/contours.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__contours__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__density__ = __webpack_require__("./node_modules/d3-contour/src/density.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__density__["a"]; });




/***/ }),

/***/ "./node_modules/d3-contour/src/noop.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {});


/***/ }),

/***/ "./node_modules/d3-dispatch/src/dispatch.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var noop = {value: function() {}};

function dispatch() {
  for (var i = 0, n = arguments.length, _ = {}, t; i < n; ++i) {
    if (!(t = arguments[i] + "") || (t in _)) throw new Error("illegal type: " + t);
    _[t] = [];
  }
  return new Dispatch(_);
}

function Dispatch(_) {
  this._ = _;
}

function parseTypenames(typenames, types) {
  return typenames.trim().split(/^|\s+/).map(function(t) {
    var name = "", i = t.indexOf(".");
    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
    if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
    return {type: t, name: name};
  });
}

Dispatch.prototype = dispatch.prototype = {
  constructor: Dispatch,
  on: function(typename, callback) {
    var _ = this._,
        T = parseTypenames(typename + "", _),
        t,
        i = -1,
        n = T.length;

    // If no callback was specified, return the callback of the given type and name.
    if (arguments.length < 2) {
      while (++i < n) if ((t = (typename = T[i]).type) && (t = get(_[t], typename.name))) return t;
      return;
    }

    // If a type was specified, set the callback for the given type and name.
    // Otherwise, if a null callback was specified, remove callbacks of the given name.
    if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
    while (++i < n) {
      if (t = (typename = T[i]).type) _[t] = set(_[t], typename.name, callback);
      else if (callback == null) for (t in _) _[t] = set(_[t], typename.name, null);
    }

    return this;
  },
  copy: function() {
    var copy = {}, _ = this._;
    for (var t in _) copy[t] = _[t].slice();
    return new Dispatch(copy);
  },
  call: function(type, that) {
    if ((n = arguments.length - 2) > 0) for (var args = new Array(n), i = 0, n, t; i < n; ++i) args[i] = arguments[i + 2];
    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
    for (t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
  },
  apply: function(type, that, args) {
    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
    for (var t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
  }
};

function get(type, name) {
  for (var i = 0, n = type.length, c; i < n; ++i) {
    if ((c = type[i]).name === name) {
      return c.value;
    }
  }
}

function set(type, name, callback) {
  for (var i = 0, n = type.length; i < n; ++i) {
    if (type[i].name === name) {
      type[i] = noop, type = type.slice(0, i).concat(type.slice(i + 1));
      break;
    }
  }
  if (callback != null) type.push({name: name, value: callback});
  return type;
}

/* harmony default export */ __webpack_exports__["a"] = (dispatch);


/***/ }),

/***/ "./node_modules/d3-dispatch/src/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dispatch__ = __webpack_require__("./node_modules/d3-dispatch/src/dispatch.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__dispatch__["a"]; });



/***/ }),

/***/ "./node_modules/d3-drag/src/constant.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),

/***/ "./node_modules/d3-drag/src/drag.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_dispatch__ = __webpack_require__("./node_modules/d3-dispatch/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_selection__ = __webpack_require__("./node_modules/d3-selection/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nodrag__ = __webpack_require__("./node_modules/d3-drag/src/nodrag.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__noevent__ = __webpack_require__("./node_modules/d3-drag/src/noevent.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constant__ = __webpack_require__("./node_modules/d3-drag/src/constant.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__event__ = __webpack_require__("./node_modules/d3-drag/src/event.js");







// Ignore right-click, since that should open the context menu.
function defaultFilter() {
  return !__WEBPACK_IMPORTED_MODULE_1_d3_selection__["e" /* event */].button;
}

function defaultContainer() {
  return this.parentNode;
}

function defaultSubject(d) {
  return d == null ? {x: __WEBPACK_IMPORTED_MODULE_1_d3_selection__["e" /* event */].x, y: __WEBPACK_IMPORTED_MODULE_1_d3_selection__["e" /* event */].y} : d;
}

function defaultTouchable() {
  return "ontouchstart" in this;
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var filter = defaultFilter,
      container = defaultContainer,
      subject = defaultSubject,
      touchable = defaultTouchable,
      gestures = {},
      listeners = Object(__WEBPACK_IMPORTED_MODULE_0_d3_dispatch__["a" /* dispatch */])("start", "drag", "end"),
      active = 0,
      mousedownx,
      mousedowny,
      mousemoving,
      touchending,
      clickDistance2 = 0;

  function drag(selection) {
    selection
        .on("mousedown.drag", mousedowned)
      .filter(touchable)
        .on("touchstart.drag", touchstarted)
        .on("touchmove.drag", touchmoved)
        .on("touchend.drag touchcancel.drag", touchended)
        .style("touch-action", "none")
        .style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }

  function mousedowned() {
    if (touchending || !filter.apply(this, arguments)) return;
    var gesture = beforestart("mouse", container.apply(this, arguments), __WEBPACK_IMPORTED_MODULE_1_d3_selection__["h" /* mouse */], this, arguments);
    if (!gesture) return;
    Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["k" /* select */])(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["e" /* event */].view).on("mousemove.drag", mousemoved, true).on("mouseup.drag", mouseupped, true);
    Object(__WEBPACK_IMPORTED_MODULE_2__nodrag__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["e" /* event */].view);
    Object(__WEBPACK_IMPORTED_MODULE_3__noevent__["b" /* nopropagation */])();
    mousemoving = false;
    mousedownx = __WEBPACK_IMPORTED_MODULE_1_d3_selection__["e" /* event */].clientX;
    mousedowny = __WEBPACK_IMPORTED_MODULE_1_d3_selection__["e" /* event */].clientY;
    gesture("start");
  }

  function mousemoved() {
    Object(__WEBPACK_IMPORTED_MODULE_3__noevent__["a" /* default */])();
    if (!mousemoving) {
      var dx = __WEBPACK_IMPORTED_MODULE_1_d3_selection__["e" /* event */].clientX - mousedownx, dy = __WEBPACK_IMPORTED_MODULE_1_d3_selection__["e" /* event */].clientY - mousedowny;
      mousemoving = dx * dx + dy * dy > clickDistance2;
    }
    gestures.mouse("drag");
  }

  function mouseupped() {
    Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["k" /* select */])(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["e" /* event */].view).on("mousemove.drag mouseup.drag", null);
    Object(__WEBPACK_IMPORTED_MODULE_2__nodrag__["b" /* yesdrag */])(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["e" /* event */].view, mousemoving);
    Object(__WEBPACK_IMPORTED_MODULE_3__noevent__["a" /* default */])();
    gestures.mouse("end");
  }

  function touchstarted() {
    if (!filter.apply(this, arguments)) return;
    var touches = __WEBPACK_IMPORTED_MODULE_1_d3_selection__["e" /* event */].changedTouches,
        c = container.apply(this, arguments),
        n = touches.length, i, gesture;

    for (i = 0; i < n; ++i) {
      if (gesture = beforestart(touches[i].identifier, c, __WEBPACK_IMPORTED_MODULE_1_d3_selection__["q" /* touch */], this, arguments)) {
        Object(__WEBPACK_IMPORTED_MODULE_3__noevent__["b" /* nopropagation */])();
        gesture("start");
      }
    }
  }

  function touchmoved() {
    var touches = __WEBPACK_IMPORTED_MODULE_1_d3_selection__["e" /* event */].changedTouches,
        n = touches.length, i, gesture;

    for (i = 0; i < n; ++i) {
      if (gesture = gestures[touches[i].identifier]) {
        Object(__WEBPACK_IMPORTED_MODULE_3__noevent__["a" /* default */])();
        gesture("drag");
      }
    }
  }

  function touchended() {
    var touches = __WEBPACK_IMPORTED_MODULE_1_d3_selection__["e" /* event */].changedTouches,
        n = touches.length, i, gesture;

    if (touchending) clearTimeout(touchending);
    touchending = setTimeout(function() { touchending = null; }, 500); // Ghost clicks are delayed!
    for (i = 0; i < n; ++i) {
      if (gesture = gestures[touches[i].identifier]) {
        Object(__WEBPACK_IMPORTED_MODULE_3__noevent__["b" /* nopropagation */])();
        gesture("end");
      }
    }
  }

  function beforestart(id, container, point, that, args) {
    var p = point(container, id), s, dx, dy,
        sublisteners = listeners.copy();

    if (!Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["d" /* customEvent */])(new __WEBPACK_IMPORTED_MODULE_5__event__["a" /* default */](drag, "beforestart", s, id, active, p[0], p[1], 0, 0, sublisteners), function() {
      if ((__WEBPACK_IMPORTED_MODULE_1_d3_selection__["e" /* event */].subject = s = subject.apply(that, args)) == null) return false;
      dx = s.x - p[0] || 0;
      dy = s.y - p[1] || 0;
      return true;
    })) return;

    return function gesture(type) {
      var p0 = p, n;
      switch (type) {
        case "start": gestures[id] = gesture, n = active++; break;
        case "end": delete gestures[id], --active; // nobreak
        case "drag": p = point(container, id), n = active; break;
      }
      Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["d" /* customEvent */])(new __WEBPACK_IMPORTED_MODULE_5__event__["a" /* default */](drag, type, s, id, n, p[0] + dx, p[1] + dy, p[0] - p0[0], p[1] - p0[1], sublisteners), sublisteners.apply, sublisteners, [type, that, args]);
    };
  }

  drag.filter = function(_) {
    return arguments.length ? (filter = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_4__constant__["a" /* default */])(!!_), drag) : filter;
  };

  drag.container = function(_) {
    return arguments.length ? (container = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_4__constant__["a" /* default */])(_), drag) : container;
  };

  drag.subject = function(_) {
    return arguments.length ? (subject = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_4__constant__["a" /* default */])(_), drag) : subject;
  };

  drag.touchable = function(_) {
    return arguments.length ? (touchable = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_4__constant__["a" /* default */])(!!_), drag) : touchable;
  };

  drag.on = function() {
    var value = listeners.on.apply(listeners, arguments);
    return value === listeners ? drag : value;
  };

  drag.clickDistance = function(_) {
    return arguments.length ? (clickDistance2 = (_ = +_) * _, drag) : Math.sqrt(clickDistance2);
  };

  return drag;
});


/***/ }),

/***/ "./node_modules/d3-drag/src/event.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = DragEvent;
function DragEvent(target, type, subject, id, active, x, y, dx, dy, dispatch) {
  this.target = target;
  this.type = type;
  this.subject = subject;
  this.identifier = id;
  this.active = active;
  this.x = x;
  this.y = y;
  this.dx = dx;
  this.dy = dy;
  this._ = dispatch;
}

DragEvent.prototype.on = function() {
  var value = this._.on.apply(this._, arguments);
  return value === this._ ? this : value;
};


/***/ }),

/***/ "./node_modules/d3-drag/src/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__drag__ = __webpack_require__("./node_modules/d3-drag/src/drag.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__drag__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nodrag__ = __webpack_require__("./node_modules/d3-drag/src/nodrag.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__nodrag__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__nodrag__["b"]; });




/***/ }),

/***/ "./node_modules/d3-drag/src/nodrag.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = yesdrag;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__("./node_modules/d3-selection/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__noevent__ = __webpack_require__("./node_modules/d3-drag/src/noevent.js");



/* harmony default export */ __webpack_exports__["a"] = (function(view) {
  var root = view.document.documentElement,
      selection = Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["k" /* select */])(view).on("dragstart.drag", __WEBPACK_IMPORTED_MODULE_1__noevent__["a" /* default */], true);
  if ("onselectstart" in root) {
    selection.on("selectstart.drag", __WEBPACK_IMPORTED_MODULE_1__noevent__["a" /* default */], true);
  } else {
    root.__noselect = root.style.MozUserSelect;
    root.style.MozUserSelect = "none";
  }
});

function yesdrag(view, noclick) {
  var root = view.document.documentElement,
      selection = Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["k" /* select */])(view).on("dragstart.drag", null);
  if (noclick) {
    selection.on("click.drag", __WEBPACK_IMPORTED_MODULE_1__noevent__["a" /* default */], true);
    setTimeout(function() { selection.on("click.drag", null); }, 0);
  }
  if ("onselectstart" in root) {
    selection.on("selectstart.drag", null);
  } else {
    root.style.MozUserSelect = root.__noselect;
    delete root.__noselect;
  }
}


/***/ }),

/***/ "./node_modules/d3-drag/src/noevent.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = nopropagation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__("./node_modules/d3-selection/src/index.js");


function nopropagation() {
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["e" /* event */].stopImmediatePropagation();
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["e" /* event */].preventDefault();
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["e" /* event */].stopImmediatePropagation();
});


/***/ }),

/***/ "./node_modules/d3-dsv/src/csv.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return csvParse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return csvParseRows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return csvFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return csvFormatRows; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dsv__ = __webpack_require__("./node_modules/d3-dsv/src/dsv.js");


var csv = Object(__WEBPACK_IMPORTED_MODULE_0__dsv__["a" /* default */])(",");

var csvParse = csv.parse;
var csvParseRows = csv.parseRows;
var csvFormat = csv.format;
var csvFormatRows = csv.formatRows;


/***/ }),

/***/ "./node_modules/d3-dsv/src/dsv.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var EOL = {},
    EOF = {},
    QUOTE = 34,
    NEWLINE = 10,
    RETURN = 13;

function objectConverter(columns) {
  return new Function("d", "return {" + columns.map(function(name, i) {
    return JSON.stringify(name) + ": d[" + i + "]";
  }).join(",") + "}");
}

function customConverter(columns, f) {
  var object = objectConverter(columns);
  return function(row, i) {
    return f(object(row), i, columns);
  };
}

// Compute unique columns in order of discovery.
function inferColumns(rows) {
  var columnSet = Object.create(null),
      columns = [];

  rows.forEach(function(row) {
    for (var column in row) {
      if (!(column in columnSet)) {
        columns.push(columnSet[column] = column);
      }
    }
  });

  return columns;
}

/* harmony default export */ __webpack_exports__["a"] = (function(delimiter) {
  var reFormat = new RegExp("[\"" + delimiter + "\n\r]"),
      DELIMITER = delimiter.charCodeAt(0);

  function parse(text, f) {
    var convert, columns, rows = parseRows(text, function(row, i) {
      if (convert) return convert(row, i - 1);
      columns = row, convert = f ? customConverter(row, f) : objectConverter(row);
    });
    rows.columns = columns || [];
    return rows;
  }

  function parseRows(text, f) {
    var rows = [], // output rows
        N = text.length,
        I = 0, // current character index
        n = 0, // current line number
        t, // current token
        eof = N <= 0, // current token followed by EOF?
        eol = false; // current token followed by EOL?

    // Strip the trailing newline.
    if (text.charCodeAt(N - 1) === NEWLINE) --N;
    if (text.charCodeAt(N - 1) === RETURN) --N;

    function token() {
      if (eof) return EOF;
      if (eol) return eol = false, EOL;

      // Unescape quotes.
      var i, j = I, c;
      if (text.charCodeAt(j) === QUOTE) {
        while (I++ < N && text.charCodeAt(I) !== QUOTE || text.charCodeAt(++I) === QUOTE);
        if ((i = I) >= N) eof = true;
        else if ((c = text.charCodeAt(I++)) === NEWLINE) eol = true;
        else if (c === RETURN) { eol = true; if (text.charCodeAt(I) === NEWLINE) ++I; }
        return text.slice(j + 1, i - 1).replace(/""/g, "\"");
      }

      // Find next delimiter or newline.
      while (I < N) {
        if ((c = text.charCodeAt(i = I++)) === NEWLINE) eol = true;
        else if (c === RETURN) { eol = true; if (text.charCodeAt(I) === NEWLINE) ++I; }
        else if (c !== DELIMITER) continue;
        return text.slice(j, i);
      }

      // Return last token before EOF.
      return eof = true, text.slice(j, N);
    }

    while ((t = token()) !== EOF) {
      var row = [];
      while (t !== EOL && t !== EOF) row.push(t), t = token();
      if (f && (row = f(row, n++)) == null) continue;
      rows.push(row);
    }

    return rows;
  }

  function format(rows, columns) {
    if (columns == null) columns = inferColumns(rows);
    return [columns.map(formatValue).join(delimiter)].concat(rows.map(function(row) {
      return columns.map(function(column) {
        return formatValue(row[column]);
      }).join(delimiter);
    })).join("\n");
  }

  function formatRows(rows) {
    return rows.map(formatRow).join("\n");
  }

  function formatRow(row) {
    return row.map(formatValue).join(delimiter);
  }

  function formatValue(text) {
    return text == null ? ""
        : reFormat.test(text += "") ? "\"" + text.replace(/"/g, "\"\"") + "\""
        : text;
  }

  return {
    parse: parse,
    parseRows: parseRows,
    format: format,
    formatRows: formatRows
  };
});


/***/ }),

/***/ "./node_modules/d3-dsv/src/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dsv__ = __webpack_require__("./node_modules/d3-dsv/src/dsv.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__dsv__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__csv__ = __webpack_require__("./node_modules/d3-dsv/src/csv.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__csv__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__csv__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__csv__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__csv__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tsv__ = __webpack_require__("./node_modules/d3-dsv/src/tsv.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_2__tsv__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_2__tsv__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_2__tsv__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_2__tsv__["b"]; });





/***/ }),

/***/ "./node_modules/d3-dsv/src/tsv.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return tsvParse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return tsvParseRows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return tsvFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return tsvFormatRows; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dsv__ = __webpack_require__("./node_modules/d3-dsv/src/dsv.js");


var tsv = Object(__WEBPACK_IMPORTED_MODULE_0__dsv__["a" /* default */])("\t");

var tsvParse = tsv.parse;
var tsvParseRows = tsv.parseRows;
var tsvFormat = tsv.format;
var tsvFormatRows = tsv.formatRows;


/***/ }),

/***/ "./node_modules/d3-ease/src/back.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return backIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return backOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return backInOut; });
var overshoot = 1.70158;

var backIn = (function custom(s) {
  s = +s;

  function backIn(t) {
    return t * t * ((s + 1) * t - s);
  }

  backIn.overshoot = custom;

  return backIn;
})(overshoot);

var backOut = (function custom(s) {
  s = +s;

  function backOut(t) {
    return --t * t * ((s + 1) * t + s) + 1;
  }

  backOut.overshoot = custom;

  return backOut;
})(overshoot);

var backInOut = (function custom(s) {
  s = +s;

  function backInOut(t) {
    return ((t *= 2) < 1 ? t * t * ((s + 1) * t - s) : (t -= 2) * t * ((s + 1) * t + s) + 2) / 2;
  }

  backInOut.overshoot = custom;

  return backInOut;
})(overshoot);


/***/ }),

/***/ "./node_modules/d3-ease/src/bounce.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bounceIn;
/* harmony export (immutable) */ __webpack_exports__["c"] = bounceOut;
/* harmony export (immutable) */ __webpack_exports__["b"] = bounceInOut;
var b1 = 4 / 11,
    b2 = 6 / 11,
    b3 = 8 / 11,
    b4 = 3 / 4,
    b5 = 9 / 11,
    b6 = 10 / 11,
    b7 = 15 / 16,
    b8 = 21 / 22,
    b9 = 63 / 64,
    b0 = 1 / b1 / b1;

function bounceIn(t) {
  return 1 - bounceOut(1 - t);
}

function bounceOut(t) {
  return (t = +t) < b1 ? b0 * t * t : t < b3 ? b0 * (t -= b2) * t + b4 : t < b6 ? b0 * (t -= b5) * t + b7 : b0 * (t -= b8) * t + b9;
}

function bounceInOut(t) {
  return ((t *= 2) <= 1 ? 1 - bounceOut(1 - t) : bounceOut(t - 1) + 1) / 2;
}


/***/ }),

/***/ "./node_modules/d3-ease/src/circle.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = circleIn;
/* harmony export (immutable) */ __webpack_exports__["c"] = circleOut;
/* harmony export (immutable) */ __webpack_exports__["b"] = circleInOut;
function circleIn(t) {
  return 1 - Math.sqrt(1 - t * t);
}

function circleOut(t) {
  return Math.sqrt(1 - --t * t);
}

function circleInOut(t) {
  return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
}


/***/ }),

/***/ "./node_modules/d3-ease/src/cubic.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cubicIn;
/* harmony export (immutable) */ __webpack_exports__["c"] = cubicOut;
/* harmony export (immutable) */ __webpack_exports__["b"] = cubicInOut;
function cubicIn(t) {
  return t * t * t;
}

function cubicOut(t) {
  return --t * t * t + 1;
}

function cubicInOut(t) {
  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}


/***/ }),

/***/ "./node_modules/d3-ease/src/elastic.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return elasticIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return elasticOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return elasticInOut; });
var tau = 2 * Math.PI,
    amplitude = 1,
    period = 0.3;

var elasticIn = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticIn(t) {
    return a * Math.pow(2, 10 * --t) * Math.sin((s - t) / p);
  }

  elasticIn.amplitude = function(a) { return custom(a, p * tau); };
  elasticIn.period = function(p) { return custom(a, p); };

  return elasticIn;
})(amplitude, period);

var elasticOut = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticOut(t) {
    return 1 - a * Math.pow(2, -10 * (t = +t)) * Math.sin((t + s) / p);
  }

  elasticOut.amplitude = function(a) { return custom(a, p * tau); };
  elasticOut.period = function(p) { return custom(a, p); };

  return elasticOut;
})(amplitude, period);

var elasticInOut = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticInOut(t) {
    return ((t = t * 2 - 1) < 0
        ? a * Math.pow(2, 10 * t) * Math.sin((s - t) / p)
        : 2 - a * Math.pow(2, -10 * t) * Math.sin((s + t) / p)) / 2;
  }

  elasticInOut.amplitude = function(a) { return custom(a, p * tau); };
  elasticInOut.period = function(p) { return custom(a, p); };

  return elasticInOut;
})(amplitude, period);


/***/ }),

/***/ "./node_modules/d3-ease/src/exp.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = expIn;
/* harmony export (immutable) */ __webpack_exports__["c"] = expOut;
/* harmony export (immutable) */ __webpack_exports__["b"] = expInOut;
function expIn(t) {
  return Math.pow(2, 10 * t - 10);
}

function expOut(t) {
  return 1 - Math.pow(2, -10 * t);
}

function expInOut(t) {
  return ((t *= 2) <= 1 ? Math.pow(2, 10 * t - 10) : 2 - Math.pow(2, 10 - 10 * t)) / 2;
}


/***/ }),

/***/ "./node_modules/d3-ease/src/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__linear__ = __webpack_require__("./node_modules/d3-ease/src/linear.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_0__linear__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__quad__ = __webpack_require__("./node_modules/d3-ease/src/quad.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_1__quad__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_1__quad__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_1__quad__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_1__quad__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cubic__ = __webpack_require__("./node_modules/d3-ease/src/cubic.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_2__cubic__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_2__cubic__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_2__cubic__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_2__cubic__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__poly__ = __webpack_require__("./node_modules/d3-ease/src/poly.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_3__poly__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_3__poly__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_3__poly__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_3__poly__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sin__ = __webpack_require__("./node_modules/d3-ease/src/sin.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_4__sin__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_4__sin__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_4__sin__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_4__sin__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__exp__ = __webpack_require__("./node_modules/d3-ease/src/exp.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_5__exp__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_5__exp__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_5__exp__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_5__exp__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__circle__ = __webpack_require__("./node_modules/d3-ease/src/circle.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_6__circle__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_6__circle__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_6__circle__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_6__circle__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__bounce__ = __webpack_require__("./node_modules/d3-ease/src/bounce.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_7__bounce__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_7__bounce__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_7__bounce__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_7__bounce__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__back__ = __webpack_require__("./node_modules/d3-ease/src/back.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_8__back__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_8__back__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_8__back__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_8__back__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__elastic__ = __webpack_require__("./node_modules/d3-ease/src/elastic.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_9__elastic__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_9__elastic__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_9__elastic__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_9__elastic__["b"]; });





















/***/ }),

/***/ "./node_modules/d3-ease/src/linear.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = linear;
function linear(t) {
  return +t;
}


/***/ }),

/***/ "./node_modules/d3-ease/src/poly.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return polyIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return polyOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return polyInOut; });
var exponent = 3;

var polyIn = (function custom(e) {
  e = +e;

  function polyIn(t) {
    return Math.pow(t, e);
  }

  polyIn.exponent = custom;

  return polyIn;
})(exponent);

var polyOut = (function custom(e) {
  e = +e;

  function polyOut(t) {
    return 1 - Math.pow(1 - t, e);
  }

  polyOut.exponent = custom;

  return polyOut;
})(exponent);

var polyInOut = (function custom(e) {
  e = +e;

  function polyInOut(t) {
    return ((t *= 2) <= 1 ? Math.pow(t, e) : 2 - Math.pow(2 - t, e)) / 2;
  }

  polyInOut.exponent = custom;

  return polyInOut;
})(exponent);


/***/ }),

/***/ "./node_modules/d3-ease/src/quad.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = quadIn;
/* harmony export (immutable) */ __webpack_exports__["c"] = quadOut;
/* harmony export (immutable) */ __webpack_exports__["b"] = quadInOut;
function quadIn(t) {
  return t * t;
}

function quadOut(t) {
  return t * (2 - t);
}

function quadInOut(t) {
  return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
}


/***/ }),

/***/ "./node_modules/d3-ease/src/sin.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sinIn;
/* harmony export (immutable) */ __webpack_exports__["c"] = sinOut;
/* harmony export (immutable) */ __webpack_exports__["b"] = sinInOut;
var pi = Math.PI,
    halfPi = pi / 2;

function sinIn(t) {
  return 1 - Math.cos(t * halfPi);
}

function sinOut(t) {
  return Math.sin(t * halfPi);
}

function sinInOut(t) {
  return (1 - Math.cos(pi * t)) / 2;
}


/***/ }),

/***/ "./node_modules/d3-fetch/src/blob.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function responseBlob(response) {
  if (!response.ok) throw new Error(response.status + " " + response.statusText);
  return response.blob();
}

/* harmony default export */ __webpack_exports__["a"] = (function(input, init) {
  return fetch(input, init).then(responseBlob);
});


/***/ }),

/***/ "./node_modules/d3-fetch/src/buffer.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function responseArrayBuffer(response) {
  if (!response.ok) throw new Error(response.status + " " + response.statusText);
  return response.arrayBuffer();
}

/* harmony default export */ __webpack_exports__["a"] = (function(input, init) {
  return fetch(input, init).then(responseArrayBuffer);
});


/***/ }),

/***/ "./node_modules/d3-fetch/src/dsv.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = dsv;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return csv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return tsv; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_dsv__ = __webpack_require__("./node_modules/d3-dsv/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__text__ = __webpack_require__("./node_modules/d3-fetch/src/text.js");



function dsvParse(parse) {
  return function(input, init, row) {
    if (arguments.length === 2 && typeof init === "function") row = init, init = undefined;
    return Object(__WEBPACK_IMPORTED_MODULE_1__text__["a" /* default */])(input, init).then(function(response) {
      return parse(response, row);
    });
  };
}

function dsv(delimiter, input, init, row) {
  if (arguments.length === 3 && typeof init === "function") row = init, init = undefined;
  var format = Object(__WEBPACK_IMPORTED_MODULE_0_d3_dsv__["e" /* dsvFormat */])(delimiter);
  return Object(__WEBPACK_IMPORTED_MODULE_1__text__["a" /* default */])(input, init).then(function(response) {
    return format.parse(response, row);
  });
}

var csv = dsvParse(__WEBPACK_IMPORTED_MODULE_0_d3_dsv__["c" /* csvParse */]);
var tsv = dsvParse(__WEBPACK_IMPORTED_MODULE_0_d3_dsv__["h" /* tsvParse */]);


/***/ }),

/***/ "./node_modules/d3-fetch/src/image.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(input, init) {
  return new Promise(function(resolve, reject) {
    var image = new Image;
    for (var key in init) image[key] = init[key];
    image.onerror = reject;
    image.onload = function() { resolve(image); };
    image.src = input;
  });
});


/***/ }),

/***/ "./node_modules/d3-fetch/src/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__blob__ = __webpack_require__("./node_modules/d3-fetch/src/blob.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__blob__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__buffer__ = __webpack_require__("./node_modules/d3-fetch/src/buffer.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__buffer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dsv__ = __webpack_require__("./node_modules/d3-fetch/src/dsv.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__dsv__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__dsv__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_2__dsv__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__image__ = __webpack_require__("./node_modules/d3-fetch/src/image.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__image__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__json__ = __webpack_require__("./node_modules/d3-fetch/src/json.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_4__json__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__text__ = __webpack_require__("./node_modules/d3-fetch/src/text.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_5__text__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__xml__ = __webpack_require__("./node_modules/d3-fetch/src/xml.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_6__xml__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_6__xml__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_6__xml__["c"]; });









/***/ }),

/***/ "./node_modules/d3-fetch/src/json.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function responseJson(response) {
  if (!response.ok) throw new Error(response.status + " " + response.statusText);
  return response.json();
}

/* harmony default export */ __webpack_exports__["a"] = (function(input, init) {
  return fetch(input, init).then(responseJson);
});


/***/ }),

/***/ "./node_modules/d3-fetch/src/text.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function responseText(response) {
  if (!response.ok) throw new Error(response.status + " " + response.statusText);
  return response.text();
}

/* harmony default export */ __webpack_exports__["a"] = (function(input, init) {
  return fetch(input, init).then(responseText);
});


/***/ }),

/***/ "./node_modules/d3-fetch/src/xml.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return html; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return svg; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__text__ = __webpack_require__("./node_modules/d3-fetch/src/text.js");


function parser(type) {
  return function(input, init)  {
    return Object(__WEBPACK_IMPORTED_MODULE_0__text__["a" /* default */])(input, init).then(function(text) {
      return (new DOMParser).parseFromString(text, type);
    });
  };
}

/* harmony default export */ __webpack_exports__["a"] = (parser("application/xml"));

var html = parser("text/html");

var svg = parser("image/svg+xml");


/***/ }),

/***/ "./node_modules/d3-force/src/center.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x, y) {
  var nodes;

  if (x == null) x = 0;
  if (y == null) y = 0;

  function force() {
    var i,
        n = nodes.length,
        node,
        sx = 0,
        sy = 0;

    for (i = 0; i < n; ++i) {
      node = nodes[i], sx += node.x, sy += node.y;
    }

    for (sx = sx / n - x, sy = sy / n - y, i = 0; i < n; ++i) {
      node = nodes[i], node.x -= sx, node.y -= sy;
    }
  }

  force.initialize = function(_) {
    nodes = _;
  };

  force.x = function(_) {
    return arguments.length ? (x = +_, force) : x;
  };

  force.y = function(_) {
    return arguments.length ? (y = +_, force) : y;
  };

  return force;
});


/***/ }),

/***/ "./node_modules/d3-force/src/collide.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__("./node_modules/d3-force/src/constant.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jiggle__ = __webpack_require__("./node_modules/d3-force/src/jiggle.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_quadtree__ = __webpack_require__("./node_modules/d3-quadtree/src/index.js");




function x(d) {
  return d.x + d.vx;
}

function y(d) {
  return d.y + d.vy;
}

/* harmony default export */ __webpack_exports__["a"] = (function(radius) {
  var nodes,
      radii,
      strength = 1,
      iterations = 1;

  if (typeof radius !== "function") radius = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(radius == null ? 1 : +radius);

  function force() {
    var i, n = nodes.length,
        tree,
        node,
        xi,
        yi,
        ri,
        ri2;

    for (var k = 0; k < iterations; ++k) {
      tree = Object(__WEBPACK_IMPORTED_MODULE_2_d3_quadtree__["a" /* quadtree */])(nodes, x, y).visitAfter(prepare);
      for (i = 0; i < n; ++i) {
        node = nodes[i];
        ri = radii[node.index], ri2 = ri * ri;
        xi = node.x + node.vx;
        yi = node.y + node.vy;
        tree.visit(apply);
      }
    }

    function apply(quad, x0, y0, x1, y1) {
      var data = quad.data, rj = quad.r, r = ri + rj;
      if (data) {
        if (data.index > node.index) {
          var x = xi - data.x - data.vx,
              y = yi - data.y - data.vy,
              l = x * x + y * y;
          if (l < r * r) {
            if (x === 0) x = Object(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" /* default */])(), l += x * x;
            if (y === 0) y = Object(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" /* default */])(), l += y * y;
            l = (r - (l = Math.sqrt(l))) / l * strength;
            node.vx += (x *= l) * (r = (rj *= rj) / (ri2 + rj));
            node.vy += (y *= l) * r;
            data.vx -= x * (r = 1 - r);
            data.vy -= y * r;
          }
        }
        return;
      }
      return x0 > xi + r || x1 < xi - r || y0 > yi + r || y1 < yi - r;
    }
  }

  function prepare(quad) {
    if (quad.data) return quad.r = radii[quad.data.index];
    for (var i = quad.r = 0; i < 4; ++i) {
      if (quad[i] && quad[i].r > quad.r) {
        quad.r = quad[i].r;
      }
    }
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length, node;
    radii = new Array(n);
    for (i = 0; i < n; ++i) node = nodes[i], radii[node.index] = +radius(node, i, nodes);
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.iterations = function(_) {
    return arguments.length ? (iterations = +_, force) : iterations;
  };

  force.strength = function(_) {
    return arguments.length ? (strength = +_, force) : strength;
  };

  force.radius = function(_) {
    return arguments.length ? (radius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initialize(), force) : radius;
  };

  return force;
});


/***/ }),

/***/ "./node_modules/d3-force/src/constant.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),

/***/ "./node_modules/d3-force/src/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__center__ = __webpack_require__("./node_modules/d3-force/src/center.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__center__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__collide__ = __webpack_require__("./node_modules/d3-force/src/collide.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__collide__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__link__ = __webpack_require__("./node_modules/d3-force/src/link.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__manyBody__ = __webpack_require__("./node_modules/d3-force/src/manyBody.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__manyBody__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__radial__ = __webpack_require__("./node_modules/d3-force/src/radial.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__radial__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__simulation__ = __webpack_require__("./node_modules/d3-force/src/simulation.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__simulation__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__x__ = __webpack_require__("./node_modules/d3-force/src/x.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_6__x__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__y__ = __webpack_require__("./node_modules/d3-force/src/y.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_7__y__["a"]; });










/***/ }),

/***/ "./node_modules/d3-force/src/jiggle.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  return (Math.random() - 0.5) * 1e-6;
});


/***/ }),

/***/ "./node_modules/d3-force/src/link.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__("./node_modules/d3-force/src/constant.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jiggle__ = __webpack_require__("./node_modules/d3-force/src/jiggle.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_collection__ = __webpack_require__("./node_modules/d3-collection/src/index.js");




function index(d) {
  return d.index;
}

function find(nodeById, nodeId) {
  var node = nodeById.get(nodeId);
  if (!node) throw new Error("missing: " + nodeId);
  return node;
}

/* harmony default export */ __webpack_exports__["a"] = (function(links) {
  var id = index,
      strength = defaultStrength,
      strengths,
      distance = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(30),
      distances,
      nodes,
      count,
      bias,
      iterations = 1;

  if (links == null) links = [];

  function defaultStrength(link) {
    return 1 / Math.min(count[link.source.index], count[link.target.index]);
  }

  function force(alpha) {
    for (var k = 0, n = links.length; k < iterations; ++k) {
      for (var i = 0, link, source, target, x, y, l, b; i < n; ++i) {
        link = links[i], source = link.source, target = link.target;
        x = target.x + target.vx - source.x - source.vx || Object(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" /* default */])();
        y = target.y + target.vy - source.y - source.vy || Object(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" /* default */])();
        l = Math.sqrt(x * x + y * y);
        l = (l - distances[i]) / l * alpha * strengths[i];
        x *= l, y *= l;
        target.vx -= x * (b = bias[i]);
        target.vy -= y * b;
        source.vx += x * (b = 1 - b);
        source.vy += y * b;
      }
    }
  }

  function initialize() {
    if (!nodes) return;

    var i,
        n = nodes.length,
        m = links.length,
        nodeById = Object(__WEBPACK_IMPORTED_MODULE_2_d3_collection__["c" /* map */])(nodes, id),
        link;

    for (i = 0, count = new Array(n); i < m; ++i) {
      link = links[i], link.index = i;
      if (typeof link.source !== "object") link.source = find(nodeById, link.source);
      if (typeof link.target !== "object") link.target = find(nodeById, link.target);
      count[link.source.index] = (count[link.source.index] || 0) + 1;
      count[link.target.index] = (count[link.target.index] || 0) + 1;
    }

    for (i = 0, bias = new Array(m); i < m; ++i) {
      link = links[i], bias[i] = count[link.source.index] / (count[link.source.index] + count[link.target.index]);
    }

    strengths = new Array(m), initializeStrength();
    distances = new Array(m), initializeDistance();
  }

  function initializeStrength() {
    if (!nodes) return;

    for (var i = 0, n = links.length; i < n; ++i) {
      strengths[i] = +strength(links[i], i, links);
    }
  }

  function initializeDistance() {
    if (!nodes) return;

    for (var i = 0, n = links.length; i < n; ++i) {
      distances[i] = +distance(links[i], i, links);
    }
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.links = function(_) {
    return arguments.length ? (links = _, initialize(), force) : links;
  };

  force.id = function(_) {
    return arguments.length ? (id = _, force) : id;
  };

  force.iterations = function(_) {
    return arguments.length ? (iterations = +_, force) : iterations;
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initializeStrength(), force) : strength;
  };

  force.distance = function(_) {
    return arguments.length ? (distance = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initializeDistance(), force) : distance;
  };

  return force;
});


/***/ }),

/***/ "./node_modules/d3-force/src/manyBody.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__("./node_modules/d3-force/src/constant.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jiggle__ = __webpack_require__("./node_modules/d3-force/src/jiggle.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_quadtree__ = __webpack_require__("./node_modules/d3-quadtree/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__simulation__ = __webpack_require__("./node_modules/d3-force/src/simulation.js");





/* harmony default export */ __webpack_exports__["a"] = (function() {
  var nodes,
      node,
      alpha,
      strength = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(-30),
      strengths,
      distanceMin2 = 1,
      distanceMax2 = Infinity,
      theta2 = 0.81;

  function force(_) {
    var i, n = nodes.length, tree = Object(__WEBPACK_IMPORTED_MODULE_2_d3_quadtree__["a" /* quadtree */])(nodes, __WEBPACK_IMPORTED_MODULE_3__simulation__["b" /* x */], __WEBPACK_IMPORTED_MODULE_3__simulation__["c" /* y */]).visitAfter(accumulate);
    for (alpha = _, i = 0; i < n; ++i) node = nodes[i], tree.visit(apply);
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length, node;
    strengths = new Array(n);
    for (i = 0; i < n; ++i) node = nodes[i], strengths[node.index] = +strength(node, i, nodes);
  }

  function accumulate(quad) {
    var strength = 0, q, c, weight = 0, x, y, i;

    // For internal nodes, accumulate forces from child quadrants.
    if (quad.length) {
      for (x = y = i = 0; i < 4; ++i) {
        if ((q = quad[i]) && (c = Math.abs(q.value))) {
          strength += q.value, weight += c, x += c * q.x, y += c * q.y;
        }
      }
      quad.x = x / weight;
      quad.y = y / weight;
    }

    // For leaf nodes, accumulate forces from coincident quadrants.
    else {
      q = quad;
      q.x = q.data.x;
      q.y = q.data.y;
      do strength += strengths[q.data.index];
      while (q = q.next);
    }

    quad.value = strength;
  }

  function apply(quad, x1, _, x2) {
    if (!quad.value) return true;

    var x = quad.x - node.x,
        y = quad.y - node.y,
        w = x2 - x1,
        l = x * x + y * y;

    // Apply the Barnes-Hut approximation if possible.
    // Limit forces for very close nodes; randomize direction if coincident.
    if (w * w / theta2 < l) {
      if (l < distanceMax2) {
        if (x === 0) x = Object(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" /* default */])(), l += x * x;
        if (y === 0) y = Object(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" /* default */])(), l += y * y;
        if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
        node.vx += x * quad.value * alpha / l;
        node.vy += y * quad.value * alpha / l;
      }
      return true;
    }

    // Otherwise, process points directly.
    else if (quad.length || l >= distanceMax2) return;

    // Limit forces for very close nodes; randomize direction if coincident.
    if (quad.data !== node || quad.next) {
      if (x === 0) x = Object(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" /* default */])(), l += x * x;
      if (y === 0) y = Object(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" /* default */])(), l += y * y;
      if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
    }

    do if (quad.data !== node) {
      w = strengths[quad.data.index] * alpha / l;
      node.vx += x * w;
      node.vy += y * w;
    } while (quad = quad.next);
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initialize(), force) : strength;
  };

  force.distanceMin = function(_) {
    return arguments.length ? (distanceMin2 = _ * _, force) : Math.sqrt(distanceMin2);
  };

  force.distanceMax = function(_) {
    return arguments.length ? (distanceMax2 = _ * _, force) : Math.sqrt(distanceMax2);
  };

  force.theta = function(_) {
    return arguments.length ? (theta2 = _ * _, force) : Math.sqrt(theta2);
  };

  return force;
});


/***/ }),

/***/ "./node_modules/d3-force/src/radial.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__("./node_modules/d3-force/src/constant.js");


/* harmony default export */ __webpack_exports__["a"] = (function(radius, x, y) {
  var nodes,
      strength = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(0.1),
      strengths,
      radiuses;

  if (typeof radius !== "function") radius = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+radius);
  if (x == null) x = 0;
  if (y == null) y = 0;

  function force(alpha) {
    for (var i = 0, n = nodes.length; i < n; ++i) {
      var node = nodes[i],
          dx = node.x - x || 1e-6,
          dy = node.y - y || 1e-6,
          r = Math.sqrt(dx * dx + dy * dy),
          k = (radiuses[i] - r) * strengths[i] * alpha / r;
      node.vx += dx * k;
      node.vy += dy * k;
    }
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length;
    strengths = new Array(n);
    radiuses = new Array(n);
    for (i = 0; i < n; ++i) {
      radiuses[i] = +radius(nodes[i], i, nodes);
      strengths[i] = isNaN(radiuses[i]) ? 0 : +strength(nodes[i], i, nodes);
    }
  }

  force.initialize = function(_) {
    nodes = _, initialize();
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initialize(), force) : strength;
  };

  force.radius = function(_) {
    return arguments.length ? (radius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initialize(), force) : radius;
  };

  force.x = function(_) {
    return arguments.length ? (x = +_, force) : x;
  };

  force.y = function(_) {
    return arguments.length ? (y = +_, force) : y;
  };

  return force;
});


/***/ }),

/***/ "./node_modules/d3-force/src/simulation.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = x;
/* harmony export (immutable) */ __webpack_exports__["c"] = y;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_dispatch__ = __webpack_require__("./node_modules/d3-dispatch/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_collection__ = __webpack_require__("./node_modules/d3-collection/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_timer__ = __webpack_require__("./node_modules/d3-timer/src/index.js");




function x(d) {
  return d.x;
}

function y(d) {
  return d.y;
}

var initialRadius = 10,
    initialAngle = Math.PI * (3 - Math.sqrt(5));

/* harmony default export */ __webpack_exports__["a"] = (function(nodes) {
  var simulation,
      alpha = 1,
      alphaMin = 0.001,
      alphaDecay = 1 - Math.pow(alphaMin, 1 / 300),
      alphaTarget = 0,
      velocityDecay = 0.6,
      forces = Object(__WEBPACK_IMPORTED_MODULE_1_d3_collection__["c" /* map */])(),
      stepper = Object(__WEBPACK_IMPORTED_MODULE_2_d3_timer__["d" /* timer */])(step),
      event = Object(__WEBPACK_IMPORTED_MODULE_0_d3_dispatch__["a" /* dispatch */])("tick", "end");

  if (nodes == null) nodes = [];

  function step() {
    tick();
    event.call("tick", simulation);
    if (alpha < alphaMin) {
      stepper.stop();
      event.call("end", simulation);
    }
  }

  function tick() {
    var i, n = nodes.length, node;

    alpha += (alphaTarget - alpha) * alphaDecay;

    forces.each(function(force) {
      force(alpha);
    });

    for (i = 0; i < n; ++i) {
      node = nodes[i];
      if (node.fx == null) node.x += node.vx *= velocityDecay;
      else node.x = node.fx, node.vx = 0;
      if (node.fy == null) node.y += node.vy *= velocityDecay;
      else node.y = node.fy, node.vy = 0;
    }
  }

  function initializeNodes() {
    for (var i = 0, n = nodes.length, node; i < n; ++i) {
      node = nodes[i], node.index = i;
      if (isNaN(node.x) || isNaN(node.y)) {
        var radius = initialRadius * Math.sqrt(i), angle = i * initialAngle;
        node.x = radius * Math.cos(angle);
        node.y = radius * Math.sin(angle);
      }
      if (isNaN(node.vx) || isNaN(node.vy)) {
        node.vx = node.vy = 0;
      }
    }
  }

  function initializeForce(force) {
    if (force.initialize) force.initialize(nodes);
    return force;
  }

  initializeNodes();

  return simulation = {
    tick: tick,

    restart: function() {
      return stepper.restart(step), simulation;
    },

    stop: function() {
      return stepper.stop(), simulation;
    },

    nodes: function(_) {
      return arguments.length ? (nodes = _, initializeNodes(), forces.each(initializeForce), simulation) : nodes;
    },

    alpha: function(_) {
      return arguments.length ? (alpha = +_, simulation) : alpha;
    },

    alphaMin: function(_) {
      return arguments.length ? (alphaMin = +_, simulation) : alphaMin;
    },

    alphaDecay: function(_) {
      return arguments.length ? (alphaDecay = +_, simulation) : +alphaDecay;
    },

    alphaTarget: function(_) {
      return arguments.length ? (alphaTarget = +_, simulation) : alphaTarget;
    },

    velocityDecay: function(_) {
      return arguments.length ? (velocityDecay = 1 - _, simulation) : 1 - velocityDecay;
    },

    force: function(name, _) {
      return arguments.length > 1 ? ((_ == null ? forces.remove(name) : forces.set(name, initializeForce(_))), simulation) : forces.get(name);
    },

    find: function(x, y, radius) {
      var i = 0,
          n = nodes.length,
          dx,
          dy,
          d2,
          node,
          closest;

      if (radius == null) radius = Infinity;
      else radius *= radius;

      for (i = 0; i < n; ++i) {
        node = nodes[i];
        dx = x - node.x;
        dy = y - node.y;
        d2 = dx * dx + dy * dy;
        if (d2 < radius) closest = node, radius = d2;
      }

      return closest;
    },

    on: function(name, _) {
      return arguments.length > 1 ? (event.on(name, _), simulation) : event.on(name);
    }
  };
});


/***/ }),

/***/ "./node_modules/d3-force/src/x.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__("./node_modules/d3-force/src/constant.js");


/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  var strength = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(0.1),
      nodes,
      strengths,
      xz;

  if (typeof x !== "function") x = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(x == null ? 0 : +x);

  function force(alpha) {
    for (var i = 0, n = nodes.length, node; i < n; ++i) {
      node = nodes[i], node.vx += (xz[i] - node.x) * strengths[i] * alpha;
    }
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length;
    strengths = new Array(n);
    xz = new Array(n);
    for (i = 0; i < n; ++i) {
      strengths[i] = isNaN(xz[i] = +x(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
    }
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initialize(), force) : strength;
  };

  force.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initialize(), force) : x;
  };

  return force;
});


/***/ }),

/***/ "./node_modules/d3-force/src/y.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__("./node_modules/d3-force/src/constant.js");


/* harmony default export */ __webpack_exports__["a"] = (function(y) {
  var strength = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(0.1),
      nodes,
      strengths,
      yz;

  if (typeof y !== "function") y = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(y == null ? 0 : +y);

  function force(alpha) {
    for (var i = 0, n = nodes.length, node; i < n; ++i) {
      node = nodes[i], node.vy += (yz[i] - node.y) * strengths[i] * alpha;
    }
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length;
    strengths = new Array(n);
    yz = new Array(n);
    for (i = 0; i < n; ++i) {
      strengths[i] = isNaN(yz[i] = +y(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
    }
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initialize(), force) : strength;
  };

  force.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initialize(), force) : y;
  };

  return force;
});


/***/ }),

/***/ "./node_modules/d3-format/src/defaultLocale.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return format; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return formatPrefix; });
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultLocale;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale__ = __webpack_require__("./node_modules/d3-format/src/locale.js");


var locale;
var format;
var formatPrefix;

defaultLocale({
  decimal: ".",
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});

function defaultLocale(definition) {
  locale = Object(__WEBPACK_IMPORTED_MODULE_0__locale__["a" /* default */])(definition);
  format = locale.format;
  formatPrefix = locale.formatPrefix;
  return locale;
}


/***/ }),

/***/ "./node_modules/d3-format/src/exponent.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal__ = __webpack_require__("./node_modules/d3-format/src/formatDecimal.js");


/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x = Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(Math.abs(x)), x ? x[1] : NaN;
});


/***/ }),

/***/ "./node_modules/d3-format/src/formatDecimal.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimal(1.23) returns ["123", 0].
/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
  var i, coefficient = x.slice(0, i);

  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
  return [
    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
    +x.slice(i + 1)
  ];
});


/***/ }),

/***/ "./node_modules/d3-format/src/formatGroup.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(grouping, thousands) {
  return function(value, width) {
    var i = value.length,
        t = [],
        j = 0,
        g = grouping[0],
        length = 0;

    while (i > 0 && g > 0) {
      if (length + g + 1 > width) g = Math.max(1, width - length);
      t.push(value.substring(i -= g, i + g));
      if ((length += g + 1) > width) break;
      g = grouping[j = (j + 1) % grouping.length];
    }

    return t.reverse().join(thousands);
  };
});


/***/ }),

/***/ "./node_modules/d3-format/src/formatNumerals.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(numerals) {
  return function(value) {
    return value.replace(/[0-9]/g, function(i) {
      return numerals[+i];
    });
  };
});


/***/ }),

/***/ "./node_modules/d3-format/src/formatPrefixAuto.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return prefixExponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal__ = __webpack_require__("./node_modules/d3-format/src/formatDecimal.js");


var prefixExponent;

/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  var d = Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1],
      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
      n = coefficient.length;
  return i === n ? coefficient
      : i > n ? coefficient + new Array(i - n + 1).join("0")
      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
      : "0." + new Array(1 - i).join("0") + Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(x, Math.max(0, p + i - 1))[0]; // less than 1y!
});


/***/ }),

/***/ "./node_modules/d3-format/src/formatRounded.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal__ = __webpack_require__("./node_modules/d3-format/src/formatDecimal.js");


/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  var d = Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1];
  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
});


/***/ }),

/***/ "./node_modules/d3-format/src/formatSpecifier.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatSpecifier;
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;

function formatSpecifier(specifier) {
  return new FormatSpecifier(specifier);
}

formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof

function FormatSpecifier(specifier) {
  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
  var match;
  this.fill = match[1] || " ";
  this.align = match[2] || ">";
  this.sign = match[3] || "-";
  this.symbol = match[4] || "";
  this.zero = !!match[5];
  this.width = match[6] && +match[6];
  this.comma = !!match[7];
  this.precision = match[8] && +match[8].slice(1);
  this.trim = !!match[9];
  this.type = match[10] || "";
}

FormatSpecifier.prototype.toString = function() {
  return this.fill
      + this.align
      + this.sign
      + this.symbol
      + (this.zero ? "0" : "")
      + (this.width == null ? "" : Math.max(1, this.width | 0))
      + (this.comma ? "," : "")
      + (this.precision == null ? "" : "." + Math.max(0, this.precision | 0))
      + (this.trim ? "~" : "")
      + this.type;
};


/***/ }),

/***/ "./node_modules/d3-format/src/formatTrim.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
/* harmony default export */ __webpack_exports__["a"] = (function(s) {
  out: for (var n = s.length, i = 1, i0 = -1, i1; i < n; ++i) {
    switch (s[i]) {
      case ".": i0 = i1 = i; break;
      case "0": if (i0 === 0) i0 = i; i1 = i; break;
      default: if (i0 > 0) { if (!+s[i]) break out; i0 = 0; } break;
    }
  }
  return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
});


/***/ }),

/***/ "./node_modules/d3-format/src/formatTypes.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatPrefixAuto__ = __webpack_require__("./node_modules/d3-format/src/formatPrefixAuto.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__formatRounded__ = __webpack_require__("./node_modules/d3-format/src/formatRounded.js");



/* harmony default export */ __webpack_exports__["a"] = ({
  "%": function(x, p) { return (x * 100).toFixed(p); },
  "b": function(x) { return Math.round(x).toString(2); },
  "c": function(x) { return x + ""; },
  "d": function(x) { return Math.round(x).toString(10); },
  "e": function(x, p) { return x.toExponential(p); },
  "f": function(x, p) { return x.toFixed(p); },
  "g": function(x, p) { return x.toPrecision(p); },
  "o": function(x) { return Math.round(x).toString(8); },
  "p": function(x, p) { return Object(__WEBPACK_IMPORTED_MODULE_1__formatRounded__["a" /* default */])(x * 100, p); },
  "r": __WEBPACK_IMPORTED_MODULE_1__formatRounded__["a" /* default */],
  "s": __WEBPACK_IMPORTED_MODULE_0__formatPrefixAuto__["a" /* default */],
  "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
  "x": function(x) { return Math.round(x).toString(16); }
});


/***/ }),

/***/ "./node_modules/d3-format/src/identity.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),

/***/ "./node_modules/d3-format/src/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultLocale__ = __webpack_require__("./node_modules/d3-format/src/defaultLocale.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__defaultLocale__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__defaultLocale__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__defaultLocale__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__locale__ = __webpack_require__("./node_modules/d3-format/src/locale.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__locale__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__formatSpecifier__ = __webpack_require__("./node_modules/d3-format/src/formatSpecifier.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__formatSpecifier__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__precisionFixed__ = __webpack_require__("./node_modules/d3-format/src/precisionFixed.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__precisionFixed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__precisionPrefix__ = __webpack_require__("./node_modules/d3-format/src/precisionPrefix.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_4__precisionPrefix__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__precisionRound__ = __webpack_require__("./node_modules/d3-format/src/precisionRound.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_5__precisionRound__["a"]; });








/***/ }),

/***/ "./node_modules/d3-format/src/locale.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__("./node_modules/d3-format/src/exponent.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__formatGroup__ = __webpack_require__("./node_modules/d3-format/src/formatGroup.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__formatNumerals__ = __webpack_require__("./node_modules/d3-format/src/formatNumerals.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__formatSpecifier__ = __webpack_require__("./node_modules/d3-format/src/formatSpecifier.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__formatTrim__ = __webpack_require__("./node_modules/d3-format/src/formatTrim.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__formatTypes__ = __webpack_require__("./node_modules/d3-format/src/formatTypes.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__formatPrefixAuto__ = __webpack_require__("./node_modules/d3-format/src/formatPrefixAuto.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__identity__ = __webpack_require__("./node_modules/d3-format/src/identity.js");









var prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];

/* harmony default export */ __webpack_exports__["a"] = (function(locale) {
  var group = locale.grouping && locale.thousands ? Object(__WEBPACK_IMPORTED_MODULE_1__formatGroup__["a" /* default */])(locale.grouping, locale.thousands) : __WEBPACK_IMPORTED_MODULE_7__identity__["a" /* default */],
      currency = locale.currency,
      decimal = locale.decimal,
      numerals = locale.numerals ? Object(__WEBPACK_IMPORTED_MODULE_2__formatNumerals__["a" /* default */])(locale.numerals) : __WEBPACK_IMPORTED_MODULE_7__identity__["a" /* default */],
      percent = locale.percent || "%";

  function newFormat(specifier) {
    specifier = Object(__WEBPACK_IMPORTED_MODULE_3__formatSpecifier__["a" /* default */])(specifier);

    var fill = specifier.fill,
        align = specifier.align,
        sign = specifier.sign,
        symbol = specifier.symbol,
        zero = specifier.zero,
        width = specifier.width,
        comma = specifier.comma,
        precision = specifier.precision,
        trim = specifier.trim,
        type = specifier.type;

    // The "n" type is an alias for ",g".
    if (type === "n") comma = true, type = "g";

    // The "" type, and any invalid type, is an alias for ".12~g".
    else if (!__WEBPACK_IMPORTED_MODULE_5__formatTypes__["a" /* default */][type]) precision == null && (precision = 12), trim = true, type = "g";

    // If zero fill is specified, padding goes after sign and before digits.
    if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";

    // Compute the prefix and suffix.
    // For SI-prefix, the suffix is lazily computed.
    var prefix = symbol === "$" ? currency[0] : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
        suffix = symbol === "$" ? currency[1] : /[%p]/.test(type) ? percent : "";

    // What format function should we use?
    // Is this an integer type?
    // Can this type generate exponential notation?
    var formatType = __WEBPACK_IMPORTED_MODULE_5__formatTypes__["a" /* default */][type],
        maybeSuffix = /[defgprs%]/.test(type);

    // Set the default precision if not specified,
    // or clamp the specified precision to the supported range.
    // For significant precision, it must be in [1, 21].
    // For fixed precision, it must be in [0, 20].
    precision = precision == null ? 6
        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
        : Math.max(0, Math.min(20, precision));

    function format(value) {
      var valuePrefix = prefix,
          valueSuffix = suffix,
          i, n, c;

      if (type === "c") {
        valueSuffix = formatType(value) + valueSuffix;
        value = "";
      } else {
        value = +value;

        // Perform the initial formatting.
        var valueNegative = value < 0;
        value = formatType(Math.abs(value), precision);

        // Trim insignificant zeros.
        if (trim) value = Object(__WEBPACK_IMPORTED_MODULE_4__formatTrim__["a" /* default */])(value);

        // If a negative value rounds to zero during formatting, treat as positive.
        if (valueNegative && +value === 0) valueNegative = false;

        // Compute the prefix and suffix.
        valuePrefix = (valueNegative ? (sign === "(" ? sign : "-") : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
        valueSuffix = (type === "s" ? prefixes[8 + __WEBPACK_IMPORTED_MODULE_6__formatPrefixAuto__["b" /* prefixExponent */] / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");

        // Break the formatted value into the integer “value” part that can be
        // grouped, and fractional or exponential “suffix” part that is not.
        if (maybeSuffix) {
          i = -1, n = value.length;
          while (++i < n) {
            if (c = value.charCodeAt(i), 48 > c || c > 57) {
              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
              value = value.slice(0, i);
              break;
            }
          }
        }
      }

      // If the fill character is not "0", grouping is applied before padding.
      if (comma && !zero) value = group(value, Infinity);

      // Compute the padding.
      var length = valuePrefix.length + value.length + valueSuffix.length,
          padding = length < width ? new Array(width - length + 1).join(fill) : "";

      // If the fill character is "0", grouping is applied after padding.
      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";

      // Reconstruct the final output based on the desired alignment.
      switch (align) {
        case "<": value = valuePrefix + value + valueSuffix + padding; break;
        case "=": value = valuePrefix + padding + value + valueSuffix; break;
        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
        default: value = padding + valuePrefix + value + valueSuffix; break;
      }

      return numerals(value);
    }

    format.toString = function() {
      return specifier + "";
    };

    return format;
  }

  function formatPrefix(specifier, value) {
    var f = newFormat((specifier = Object(__WEBPACK_IMPORTED_MODULE_3__formatSpecifier__["a" /* default */])(specifier), specifier.type = "f", specifier)),
        e = Math.max(-8, Math.min(8, Math.floor(Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(value) / 3))) * 3,
        k = Math.pow(10, -e),
        prefix = prefixes[8 + e / 3];
    return function(value) {
      return f(k * value) + prefix;
    };
  }

  return {
    format: newFormat,
    formatPrefix: formatPrefix
  };
});


/***/ }),

/***/ "./node_modules/d3-format/src/precisionFixed.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__("./node_modules/d3-format/src/exponent.js");


/* harmony default export */ __webpack_exports__["a"] = (function(step) {
  return Math.max(0, -Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(Math.abs(step)));
});


/***/ }),

/***/ "./node_modules/d3-format/src/precisionPrefix.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__("./node_modules/d3-format/src/exponent.js");


/* harmony default export */ __webpack_exports__["a"] = (function(step, value) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(value) / 3))) * 3 - Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(Math.abs(step)));
});


/***/ }),

/***/ "./node_modules/d3-format/src/precisionRound.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__("./node_modules/d3-format/src/exponent.js");


/* harmony default export */ __webpack_exports__["a"] = (function(step, max) {
  step = Math.abs(step), max = Math.abs(max) - step;
  return Math.max(0, Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(max) - Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(step)) + 1;
});


/***/ }),

/***/ "./node_modules/d3-geo/src/adder.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Adds floating point numbers with twice the normal precision.
// Reference: J. R. Shewchuk, Adaptive Precision Floating-Point Arithmetic and
// Fast Robust Geometric Predicates, Discrete & Computational Geometry 18(3)
// 305–363 (1997).
// Code adapted from GeographicLib by Charles F. F. Karney,
// http://geographiclib.sourceforge.net/

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return new Adder;
});

function Adder() {
  this.reset();
}

Adder.prototype = {
  constructor: Adder,
  reset: function() {
    this.s = // rounded value
    this.t = 0; // exact error
  },
  add: function(y) {
    add(temp, y, this.t);
    add(this, temp.s, this.s);
    if (this.s) this.t += temp.t;
    else this.s = temp.t;
  },
  valueOf: function() {
    return this.s;
  }
};

var temp = new Adder;

function add(adder, a, b) {
  var x = adder.s = a + b,
      bv = x - a,
      av = x - bv;
  adder.t = (a - av) + (b - bv);
}


/***/ }),

/***/ "./node_modules/d3-geo/src/area.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return areaRingSum; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return areaStream; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adder__ = __webpack_require__("./node_modules/d3-geo/src/adder.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__("./node_modules/d3-geo/src/math.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__noop__ = __webpack_require__("./node_modules/d3-geo/src/noop.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stream__ = __webpack_require__("./node_modules/d3-geo/src/stream.js");





var areaRingSum = Object(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])();

var areaSum = Object(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])(),
    lambda00,
    phi00,
    lambda0,
    cosPhi0,
    sinPhi0;

var areaStream = {
  point: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  lineStart: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  lineEnd: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  polygonStart: function() {
    areaRingSum.reset();
    areaStream.lineStart = areaRingStart;
    areaStream.lineEnd = areaRingEnd;
  },
  polygonEnd: function() {
    var areaRing = +areaRingSum;
    areaSum.add(areaRing < 0 ? __WEBPACK_IMPORTED_MODULE_1__math__["w" /* tau */] + areaRing : areaRing);
    this.lineStart = this.lineEnd = this.point = __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */];
  },
  sphere: function() {
    areaSum.add(__WEBPACK_IMPORTED_MODULE_1__math__["w" /* tau */]);
  }
};

function areaRingStart() {
  areaStream.point = areaPointFirst;
}

function areaRingEnd() {
  areaPoint(lambda00, phi00);
}

function areaPointFirst(lambda, phi) {
  areaStream.point = areaPoint;
  lambda00 = lambda, phi00 = phi;
  lambda *= __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */];
  lambda0 = lambda, cosPhi0 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(phi = phi / 2 + __WEBPACK_IMPORTED_MODULE_1__math__["q" /* quarterPi */]), sinPhi0 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(phi);
}

function areaPoint(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */];
  phi = phi / 2 + __WEBPACK_IMPORTED_MODULE_1__math__["q" /* quarterPi */]; // half the angular distance from south pole

  // Spherical excess E for a spherical triangle with vertices: south pole,
  // previous point, current point.  Uses a formula derived from Cagnoli’s
  // theorem.  See Todhunter, Spherical Trig. (1871), Sec. 103, Eq. (2).
  var dLambda = lambda - lambda0,
      sdLambda = dLambda >= 0 ? 1 : -1,
      adLambda = sdLambda * dLambda,
      cosPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(phi),
      sinPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(phi),
      k = sinPhi0 * sinPhi,
      u = cosPhi0 * cosPhi + k * Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(adLambda),
      v = k * sdLambda * Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(adLambda);
  areaRingSum.add(Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* atan2 */])(v, u));

  // Advance the previous points.
  lambda0 = lambda, cosPhi0 = cosPhi, sinPhi0 = sinPhi;
}

/* harmony default export */ __webpack_exports__["c"] = (function(object) {
  areaSum.reset();
  Object(__WEBPACK_IMPORTED_MODULE_3__stream__["a" /* default */])(object, areaStream);
  return areaSum * 2;
});


/***/ }),

/***/ "./node_modules/d3-geo/src/bounds.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adder__ = __webpack_require__("./node_modules/d3-geo/src/adder.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__area__ = __webpack_require__("./node_modules/d3-geo/src/area.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cartesian__ = __webpack_require__("./node_modules/d3-geo/src/cartesian.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__math__ = __webpack_require__("./node_modules/d3-geo/src/math.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stream__ = __webpack_require__("./node_modules/d3-geo/src/stream.js");






var lambda0, phi0, lambda1, phi1, // bounds
    lambda2, // previous lambda-coordinate
    lambda00, phi00, // first point
    p0, // previous 3D point
    deltaSum = Object(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])(),
    ranges,
    range;

var boundsStream = {
  point: boundsPoint,
  lineStart: boundsLineStart,
  lineEnd: boundsLineEnd,
  polygonStart: function() {
    boundsStream.point = boundsRingPoint;
    boundsStream.lineStart = boundsRingStart;
    boundsStream.lineEnd = boundsRingEnd;
    deltaSum.reset();
    __WEBPACK_IMPORTED_MODULE_1__area__["b" /* areaStream */].polygonStart();
  },
  polygonEnd: function() {
    __WEBPACK_IMPORTED_MODULE_1__area__["b" /* areaStream */].polygonEnd();
    boundsStream.point = boundsPoint;
    boundsStream.lineStart = boundsLineStart;
    boundsStream.lineEnd = boundsLineEnd;
    if (__WEBPACK_IMPORTED_MODULE_1__area__["a" /* areaRingSum */] < 0) lambda0 = -(lambda1 = 180), phi0 = -(phi1 = 90);
    else if (deltaSum > __WEBPACK_IMPORTED_MODULE_3__math__["i" /* epsilon */]) phi1 = 90;
    else if (deltaSum < -__WEBPACK_IMPORTED_MODULE_3__math__["i" /* epsilon */]) phi0 = -90;
    range[0] = lambda0, range[1] = lambda1;
  }
};

function boundsPoint(lambda, phi) {
  ranges.push(range = [lambda0 = lambda, lambda1 = lambda]);
  if (phi < phi0) phi0 = phi;
  if (phi > phi1) phi1 = phi;
}

function linePoint(lambda, phi) {
  var p = Object(__WEBPACK_IMPORTED_MODULE_2__cartesian__["a" /* cartesian */])([lambda * __WEBPACK_IMPORTED_MODULE_3__math__["r" /* radians */], phi * __WEBPACK_IMPORTED_MODULE_3__math__["r" /* radians */]]);
  if (p0) {
    var normal = Object(__WEBPACK_IMPORTED_MODULE_2__cartesian__["c" /* cartesianCross */])(p0, p),
        equatorial = [normal[1], -normal[0], 0],
        inflection = Object(__WEBPACK_IMPORTED_MODULE_2__cartesian__["c" /* cartesianCross */])(equatorial, normal);
    Object(__WEBPACK_IMPORTED_MODULE_2__cartesian__["e" /* cartesianNormalizeInPlace */])(inflection);
    inflection = Object(__WEBPACK_IMPORTED_MODULE_2__cartesian__["g" /* spherical */])(inflection);
    var delta = lambda - lambda2,
        sign = delta > 0 ? 1 : -1,
        lambdai = inflection[0] * __WEBPACK_IMPORTED_MODULE_3__math__["h" /* degrees */] * sign,
        phii,
        antimeridian = Object(__WEBPACK_IMPORTED_MODULE_3__math__["a" /* abs */])(delta) > 180;
    if (antimeridian ^ (sign * lambda2 < lambdai && lambdai < sign * lambda)) {
      phii = inflection[1] * __WEBPACK_IMPORTED_MODULE_3__math__["h" /* degrees */];
      if (phii > phi1) phi1 = phii;
    } else if (lambdai = (lambdai + 360) % 360 - 180, antimeridian ^ (sign * lambda2 < lambdai && lambdai < sign * lambda)) {
      phii = -inflection[1] * __WEBPACK_IMPORTED_MODULE_3__math__["h" /* degrees */];
      if (phii < phi0) phi0 = phii;
    } else {
      if (phi < phi0) phi0 = phi;
      if (phi > phi1) phi1 = phi;
    }
    if (antimeridian) {
      if (lambda < lambda2) {
        if (angle(lambda0, lambda) > angle(lambda0, lambda1)) lambda1 = lambda;
      } else {
        if (angle(lambda, lambda1) > angle(lambda0, lambda1)) lambda0 = lambda;
      }
    } else {
      if (lambda1 >= lambda0) {
        if (lambda < lambda0) lambda0 = lambda;
        if (lambda > lambda1) lambda1 = lambda;
      } else {
        if (lambda > lambda2) {
          if (angle(lambda0, lambda) > angle(lambda0, lambda1)) lambda1 = lambda;
        } else {
          if (angle(lambda, lambda1) > angle(lambda0, lambda1)) lambda0 = lambda;
        }
      }
    }
  } else {
    ranges.push(range = [lambda0 = lambda, lambda1 = lambda]);
  }
  if (phi < phi0) phi0 = phi;
  if (phi > phi1) phi1 = phi;
  p0 = p, lambda2 = lambda;
}

function boundsLineStart() {
  boundsStream.point = linePoint;
}

function boundsLineEnd() {
  range[0] = lambda0, range[1] = lambda1;
  boundsStream.point = boundsPoint;
  p0 = null;
}

function boundsRingPoint(lambda, phi) {
  if (p0) {
    var delta = lambda - lambda2;
    deltaSum.add(Object(__WEBPACK_IMPORTED_MODULE_3__math__["a" /* abs */])(delta) > 180 ? delta + (delta > 0 ? 360 : -360) : delta);
  } else {
    lambda00 = lambda, phi00 = phi;
  }
  __WEBPACK_IMPORTED_MODULE_1__area__["b" /* areaStream */].point(lambda, phi);
  linePoint(lambda, phi);
}

function boundsRingStart() {
  __WEBPACK_IMPORTED_MODULE_1__area__["b" /* areaStream */].lineStart();
}

function boundsRingEnd() {
  boundsRingPoint(lambda00, phi00);
  __WEBPACK_IMPORTED_MODULE_1__area__["b" /* areaStream */].lineEnd();
  if (Object(__WEBPACK_IMPORTED_MODULE_3__math__["a" /* abs */])(deltaSum) > __WEBPACK_IMPORTED_MODULE_3__math__["i" /* epsilon */]) lambda0 = -(lambda1 = 180);
  range[0] = lambda0, range[1] = lambda1;
  p0 = null;
}

// Finds the left-right distance between two longitudes.
// This is almost the same as (lambda1 - lambda0 + 360°) % 360°, except that we want
// the distance between ±180° to be 360°.
function angle(lambda0, lambda1) {
  return (lambda1 -= lambda0) < 0 ? lambda1 + 360 : lambda1;
}

function rangeCompare(a, b) {
  return a[0] - b[0];
}

function rangeContains(range, x) {
  return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
}

/* harmony default export */ __webpack_exports__["a"] = (function(feature) {
  var i, n, a, b, merged, deltaMax, delta;

  phi1 = lambda1 = -(lambda0 = phi0 = Infinity);
  ranges = [];
  Object(__WEBPACK_IMPORTED_MODULE_4__stream__["a" /* default */])(feature, boundsStream);

  // First, sort ranges by their minimum longitudes.
  if (n = ranges.length) {
    ranges.sort(rangeCompare);

    // Then, merge any ranges that overlap.
    for (i = 1, a = ranges[0], merged = [a]; i < n; ++i) {
      b = ranges[i];
      if (rangeContains(a, b[0]) || rangeContains(a, b[1])) {
        if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
        if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
      } else {
        merged.push(a = b);
      }
    }

    // Finally, find the largest gap between the merged ranges.
    // The final bounding box will be the inverse of this gap.
    for (deltaMax = -Infinity, n = merged.length - 1, i = 0, a = merged[n]; i <= n; a = b, ++i) {
      b = merged[i];
      if ((delta = angle(a[1], b[0])) > deltaMax) deltaMax = delta, lambda0 = b[0], lambda1 = a[1];
    }
  }

  ranges = range = null;

  return lambda0 === Infinity || phi0 === Infinity
      ? [[NaN, NaN], [NaN, NaN]]
      : [[lambda0, phi0], [lambda1, phi1]];
});


/***/ }),

/***/ "./node_modules/d3-geo/src/cartesian.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["g"] = spherical;
/* harmony export (immutable) */ __webpack_exports__["a"] = cartesian;
/* harmony export (immutable) */ __webpack_exports__["d"] = cartesianDot;
/* harmony export (immutable) */ __webpack_exports__["c"] = cartesianCross;
/* harmony export (immutable) */ __webpack_exports__["b"] = cartesianAddInPlace;
/* harmony export (immutable) */ __webpack_exports__["f"] = cartesianScale;
/* harmony export (immutable) */ __webpack_exports__["e"] = cartesianNormalizeInPlace;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__("./node_modules/d3-geo/src/math.js");


function spherical(cartesian) {
  return [Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(cartesian[1], cartesian[0]), Object(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* asin */])(cartesian[2])];
}

function cartesian(spherical) {
  var lambda = spherical[0], phi = spherical[1], cosPhi = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(phi);
  return [cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(lambda), cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(lambda), Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(phi)];
}

function cartesianDot(a, b) {
  return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}

function cartesianCross(a, b) {
  return [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]];
}

// TODO return a
function cartesianAddInPlace(a, b) {
  a[0] += b[0], a[1] += b[1], a[2] += b[2];
}

function cartesianScale(vector, k) {
  return [vector[0] * k, vector[1] * k, vector[2] * k];
}

// TODO return d
function cartesianNormalizeInPlace(d) {
  var l = Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
  d[0] /= l, d[1] /= l, d[2] /= l;
}


/***/ }),

/***/ "./node_modules/d3-geo/src/centroid.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__("./node_modules/d3-geo/src/math.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__noop__ = __webpack_require__("./node_modules/d3-geo/src/noop.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stream__ = __webpack_require__("./node_modules/d3-geo/src/stream.js");




var W0, W1,
    X0, Y0, Z0,
    X1, Y1, Z1,
    X2, Y2, Z2,
    lambda00, phi00, // first point
    x0, y0, z0; // previous point

var centroidStream = {
  sphere: __WEBPACK_IMPORTED_MODULE_1__noop__["a" /* default */],
  point: centroidPoint,
  lineStart: centroidLineStart,
  lineEnd: centroidLineEnd,
  polygonStart: function() {
    centroidStream.lineStart = centroidRingStart;
    centroidStream.lineEnd = centroidRingEnd;
  },
  polygonEnd: function() {
    centroidStream.lineStart = centroidLineStart;
    centroidStream.lineEnd = centroidLineEnd;
  }
};

// Arithmetic mean of Cartesian vectors.
function centroidPoint(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */];
  var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(phi);
  centroidPointCartesian(cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(lambda), cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(lambda), Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(phi));
}

function centroidPointCartesian(x, y, z) {
  ++W0;
  X0 += (x - X0) / W0;
  Y0 += (y - Y0) / W0;
  Z0 += (z - Z0) / W0;
}

function centroidLineStart() {
  centroidStream.point = centroidLinePointFirst;
}

function centroidLinePointFirst(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */];
  var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(phi);
  x0 = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(lambda);
  y0 = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(lambda);
  z0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(phi);
  centroidStream.point = centroidLinePoint;
  centroidPointCartesian(x0, y0, z0);
}

function centroidLinePoint(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */];
  var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(phi),
      x = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(lambda),
      y = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(lambda),
      z = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(phi),
      w = Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
  W1 += w;
  X1 += w * (x0 + (x0 = x));
  Y1 += w * (y0 + (y0 = y));
  Z1 += w * (z0 + (z0 = z));
  centroidPointCartesian(x0, y0, z0);
}

function centroidLineEnd() {
  centroidStream.point = centroidPoint;
}

// See J. E. Brock, The Inertia Tensor for a Spherical Triangle,
// J. Applied Mechanics 42, 239 (1975).
function centroidRingStart() {
  centroidStream.point = centroidRingPointFirst;
}

function centroidRingEnd() {
  centroidRingPoint(lambda00, phi00);
  centroidStream.point = centroidPoint;
}

function centroidRingPointFirst(lambda, phi) {
  lambda00 = lambda, phi00 = phi;
  lambda *= __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */];
  centroidStream.point = centroidRingPoint;
  var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(phi);
  x0 = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(lambda);
  y0 = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(lambda);
  z0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(phi);
  centroidPointCartesian(x0, y0, z0);
}

function centroidRingPoint(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */];
  var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(phi),
      x = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(lambda),
      y = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(lambda),
      z = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(phi),
      cx = y0 * z - z0 * y,
      cy = z0 * x - x0 * z,
      cz = x0 * y - y0 * x,
      m = Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(cx * cx + cy * cy + cz * cz),
      w = Object(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* asin */])(m), // line weight = angle
      v = m && -w / m; // area weight multiplier
  X2 += v * cx;
  Y2 += v * cy;
  Z2 += v * cz;
  W1 += w;
  X1 += w * (x0 + (x0 = x));
  Y1 += w * (y0 + (y0 = y));
  Z1 += w * (z0 + (z0 = z));
  centroidPointCartesian(x0, y0, z0);
}

/* harmony default export */ __webpack_exports__["a"] = (function(object) {
  W0 = W1 =
  X0 = Y0 = Z0 =
  X1 = Y1 = Z1 =
  X2 = Y2 = Z2 = 0;
  Object(__WEBPACK_IMPORTED_MODULE_2__stream__["a" /* default */])(object, centroidStream);

  var x = X2,
      y = Y2,
      z = Z2,
      m = x * x + y * y + z * z;

  // If the area-weighted ccentroid is undefined, fall back to length-weighted ccentroid.
  if (m < __WEBPACK_IMPORTED_MODULE_0__math__["j" /* epsilon2 */]) {
    x = X1, y = Y1, z = Z1;
    // If the feature has zero length, fall back to arithmetic mean of point vectors.
    if (W1 < __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]) x = X0, y = Y0, z = Z0;
    m = x * x + y * y + z * z;
    // If the feature still has an undefined ccentroid, then return.
    if (m < __WEBPACK_IMPORTED_MODULE_0__math__["j" /* epsilon2 */]) return [NaN, NaN];
  }

  return [Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(y, x) * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */], Object(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* asin */])(z / Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(m)) * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */]];
});


/***/ }),

/***/ "./node_modules/d3-geo/src/circle.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = circleStream;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cartesian__ = __webpack_require__("./node_modules/d3-geo/src/cartesian.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__("./node_modules/d3-geo/src/constant.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__("./node_modules/d3-geo/src/math.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rotation__ = __webpack_require__("./node_modules/d3-geo/src/rotation.js");





// Generates a circle centered at [0°, 0°], with a given radius and precision.
function circleStream(stream, radius, delta, direction, t0, t1) {
  if (!delta) return;
  var cosRadius = Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* cos */])(radius),
      sinRadius = Object(__WEBPACK_IMPORTED_MODULE_2__math__["t" /* sin */])(radius),
      step = direction * delta;
  if (t0 == null) {
    t0 = radius + direction * __WEBPACK_IMPORTED_MODULE_2__math__["w" /* tau */];
    t1 = radius - step / 2;
  } else {
    t0 = circleRadius(cosRadius, t0);
    t1 = circleRadius(cosRadius, t1);
    if (direction > 0 ? t0 < t1 : t0 > t1) t0 += direction * __WEBPACK_IMPORTED_MODULE_2__math__["w" /* tau */];
  }
  for (var point, t = t0; direction > 0 ? t > t1 : t < t1; t -= step) {
    point = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["g" /* spherical */])([cosRadius, -sinRadius * Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* cos */])(t), -sinRadius * Object(__WEBPACK_IMPORTED_MODULE_2__math__["t" /* sin */])(t)]);
    stream.point(point[0], point[1]);
  }
}

// Returns the signed angle of a cartesian point relative to [cosRadius, 0, 0].
function circleRadius(cosRadius, point) {
  point = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["a" /* cartesian */])(point), point[0] -= cosRadius;
  Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["e" /* cartesianNormalizeInPlace */])(point);
  var radius = Object(__WEBPACK_IMPORTED_MODULE_2__math__["b" /* acos */])(-point[1]);
  return ((-point[2] < 0 ? -radius : radius) + __WEBPACK_IMPORTED_MODULE_2__math__["w" /* tau */] - __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */]) % __WEBPACK_IMPORTED_MODULE_2__math__["w" /* tau */];
}

/* harmony default export */ __webpack_exports__["b"] = (function() {
  var center = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])([0, 0]),
      radius = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(90),
      precision = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(6),
      ring,
      rotate,
      stream = {point: point};

  function point(x, y) {
    ring.push(x = rotate(x, y));
    x[0] *= __WEBPACK_IMPORTED_MODULE_2__math__["h" /* degrees */], x[1] *= __WEBPACK_IMPORTED_MODULE_2__math__["h" /* degrees */];
  }

  function circle() {
    var c = center.apply(this, arguments),
        r = radius.apply(this, arguments) * __WEBPACK_IMPORTED_MODULE_2__math__["r" /* radians */],
        p = precision.apply(this, arguments) * __WEBPACK_IMPORTED_MODULE_2__math__["r" /* radians */];
    ring = [];
    rotate = Object(__WEBPACK_IMPORTED_MODULE_3__rotation__["b" /* rotateRadians */])(-c[0] * __WEBPACK_IMPORTED_MODULE_2__math__["r" /* radians */], -c[1] * __WEBPACK_IMPORTED_MODULE_2__math__["r" /* radians */], 0).invert;
    circleStream(stream, r, p, 1);
    c = {type: "Polygon", coordinates: [ring]};
    ring = rotate = null;
    return c;
  }

  circle.center = function(_) {
    return arguments.length ? (center = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])([+_[0], +_[1]]), circle) : center;
  };

  circle.radius = function(_) {
    return arguments.length ? (radius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), circle) : radius;
  };

  circle.precision = function(_) {
    return arguments.length ? (precision = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), circle) : precision;
  };

  return circle;
});


/***/ }),

/***/ "./node_modules/d3-geo/src/clip/antimeridian.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__("./node_modules/d3-geo/src/clip/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__("./node_modules/d3-geo/src/math.js");



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])(
  function() { return true; },
  clipAntimeridianLine,
  clipAntimeridianInterpolate,
  [-__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */], -__WEBPACK_IMPORTED_MODULE_1__math__["l" /* halfPi */]]
));

// Takes a line and cuts into visible segments. Return values: 0 - there were
// intersections or the line was empty; 1 - no intersections; 2 - there were
// intersections, and the first and last segments should be rejoined.
function clipAntimeridianLine(stream) {
  var lambda0 = NaN,
      phi0 = NaN,
      sign0 = NaN,
      clean; // no intersections

  return {
    lineStart: function() {
      stream.lineStart();
      clean = 1;
    },
    point: function(lambda1, phi1) {
      var sign1 = lambda1 > 0 ? __WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */] : -__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */],
          delta = Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(lambda1 - lambda0);
      if (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(delta - __WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */]) < __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]) { // line crosses a pole
        stream.point(lambda0, phi0 = (phi0 + phi1) / 2 > 0 ? __WEBPACK_IMPORTED_MODULE_1__math__["l" /* halfPi */] : -__WEBPACK_IMPORTED_MODULE_1__math__["l" /* halfPi */]);
        stream.point(sign0, phi0);
        stream.lineEnd();
        stream.lineStart();
        stream.point(sign1, phi0);
        stream.point(lambda1, phi0);
        clean = 0;
      } else if (sign0 !== sign1 && delta >= __WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */]) { // line crosses antimeridian
        if (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(lambda0 - sign0) < __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]) lambda0 -= sign0 * __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]; // handle degeneracies
        if (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(lambda1 - sign1) < __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]) lambda1 -= sign1 * __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */];
        phi0 = clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1);
        stream.point(sign0, phi0);
        stream.lineEnd();
        stream.lineStart();
        stream.point(sign1, phi0);
        clean = 0;
      }
      stream.point(lambda0 = lambda1, phi0 = phi1);
      sign0 = sign1;
    },
    lineEnd: function() {
      stream.lineEnd();
      lambda0 = phi0 = NaN;
    },
    clean: function() {
      return 2 - clean; // if intersections, rejoin first and last segments
    }
  };
}

function clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1) {
  var cosPhi0,
      cosPhi1,
      sinLambda0Lambda1 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(lambda0 - lambda1);
  return Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(sinLambda0Lambda1) > __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]
      ? Object(__WEBPACK_IMPORTED_MODULE_1__math__["d" /* atan */])((Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(phi0) * (cosPhi1 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(phi1)) * Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(lambda1)
          - Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(phi1) * (cosPhi0 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(phi0)) * Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(lambda0))
          / (cosPhi0 * cosPhi1 * sinLambda0Lambda1))
      : (phi0 + phi1) / 2;
}

function clipAntimeridianInterpolate(from, to, direction, stream) {
  var phi;
  if (from == null) {
    phi = direction * __WEBPACK_IMPORTED_MODULE_1__math__["l" /* halfPi */];
    stream.point(-__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */], phi);
    stream.point(0, phi);
    stream.point(__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */], phi);
    stream.point(__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */], 0);
    stream.point(__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */], -phi);
    stream.point(0, -phi);
    stream.point(-__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */], -phi);
    stream.point(-__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */], 0);
    stream.point(-__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */], phi);
  } else if (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(from[0] - to[0]) > __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]) {
    var lambda = from[0] < to[0] ? __WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */] : -__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */];
    phi = direction * lambda / 2;
    stream.point(-lambda, phi);
    stream.point(0, phi);
    stream.point(lambda, phi);
  } else {
    stream.point(to[0], to[1]);
  }
}


/***/ }),

/***/ "./node_modules/d3-geo/src/clip/buffer.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__("./node_modules/d3-geo/src/noop.js");


/* harmony default export */ __webpack_exports__["a"] = (function() {
  var lines = [],
      line;
  return {
    point: function(x, y) {
      line.push([x, y]);
    },
    lineStart: function() {
      lines.push(line = []);
    },
    lineEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
    rejoin: function() {
      if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
    },
    result: function() {
      var result = lines;
      lines = [];
      line = null;
      return result;
    }
  };
});


/***/ }),

/***/ "./node_modules/d3-geo/src/clip/circle.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cartesian__ = __webpack_require__("./node_modules/d3-geo/src/cartesian.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__circle__ = __webpack_require__("./node_modules/d3-geo/src/circle.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__("./node_modules/d3-geo/src/math.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pointEqual__ = __webpack_require__("./node_modules/d3-geo/src/pointEqual.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index__ = __webpack_require__("./node_modules/d3-geo/src/clip/index.js");






/* harmony default export */ __webpack_exports__["a"] = (function(radius) {
  var cr = Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* cos */])(radius),
      delta = 6 * __WEBPACK_IMPORTED_MODULE_2__math__["r" /* radians */],
      smallRadius = cr > 0,
      notHemisphere = Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" /* abs */])(cr) > __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */]; // TODO optimise for this common case

  function interpolate(from, to, direction, stream) {
    Object(__WEBPACK_IMPORTED_MODULE_1__circle__["a" /* circleStream */])(stream, radius, delta, direction, from, to);
  }

  function visible(lambda, phi) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* cos */])(lambda) * Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* cos */])(phi) > cr;
  }

  // Takes a line and cuts into visible segments. Return values used for polygon
  // clipping: 0 - there were intersections or the line was empty; 1 - no
  // intersections 2 - there were intersections, and the first and last segments
  // should be rejoined.
  function clipLine(stream) {
    var point0, // previous point
        c0, // code for previous point
        v0, // visibility of previous point
        v00, // visibility of first point
        clean; // no intersections
    return {
      lineStart: function() {
        v00 = v0 = false;
        clean = 1;
      },
      point: function(lambda, phi) {
        var point1 = [lambda, phi],
            point2,
            v = visible(lambda, phi),
            c = smallRadius
              ? v ? 0 : code(lambda, phi)
              : v ? code(lambda + (lambda < 0 ? __WEBPACK_IMPORTED_MODULE_2__math__["o" /* pi */] : -__WEBPACK_IMPORTED_MODULE_2__math__["o" /* pi */]), phi) : 0;
        if (!point0 && (v00 = v0 = v)) stream.lineStart();
        // Handle degeneracies.
        // TODO ignore if not clipping polygons.
        if (v !== v0) {
          point2 = intersect(point0, point1);
          if (!point2 || Object(__WEBPACK_IMPORTED_MODULE_3__pointEqual__["a" /* default */])(point0, point2) || Object(__WEBPACK_IMPORTED_MODULE_3__pointEqual__["a" /* default */])(point1, point2)) {
            point1[0] += __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */];
            point1[1] += __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */];
            v = visible(point1[0], point1[1]);
          }
        }
        if (v !== v0) {
          clean = 0;
          if (v) {
            // outside going in
            stream.lineStart();
            point2 = intersect(point1, point0);
            stream.point(point2[0], point2[1]);
          } else {
            // inside going out
            point2 = intersect(point0, point1);
            stream.point(point2[0], point2[1]);
            stream.lineEnd();
          }
          point0 = point2;
        } else if (notHemisphere && point0 && smallRadius ^ v) {
          var t;
          // If the codes for two points are different, or are both zero,
          // and there this segment intersects with the small circle.
          if (!(c & c0) && (t = intersect(point1, point0, true))) {
            clean = 0;
            if (smallRadius) {
              stream.lineStart();
              stream.point(t[0][0], t[0][1]);
              stream.point(t[1][0], t[1][1]);
              stream.lineEnd();
            } else {
              stream.point(t[1][0], t[1][1]);
              stream.lineEnd();
              stream.lineStart();
              stream.point(t[0][0], t[0][1]);
            }
          }
        }
        if (v && (!point0 || !Object(__WEBPACK_IMPORTED_MODULE_3__pointEqual__["a" /* default */])(point0, point1))) {
          stream.point(point1[0], point1[1]);
        }
        point0 = point1, v0 = v, c0 = c;
      },
      lineEnd: function() {
        if (v0) stream.lineEnd();
        point0 = null;
      },
      // Rejoin first and last segments if there were intersections and the first
      // and last points were visible.
      clean: function() {
        return clean | ((v00 && v0) << 1);
      }
    };
  }

  // Intersects the great circle between a and b with the clip circle.
  function intersect(a, b, two) {
    var pa = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["a" /* cartesian */])(a),
        pb = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["a" /* cartesian */])(b);

    // We have two planes, n1.p = d1 and n2.p = d2.
    // Find intersection line p(t) = c1 n1 + c2 n2 + t (n1 ⨯ n2).
    var n1 = [1, 0, 0], // normal
        n2 = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["c" /* cartesianCross */])(pa, pb),
        n2n2 = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["d" /* cartesianDot */])(n2, n2),
        n1n2 = n2[0], // cartesianDot(n1, n2),
        determinant = n2n2 - n1n2 * n1n2;

    // Two polar points.
    if (!determinant) return !two && a;

    var c1 =  cr * n2n2 / determinant,
        c2 = -cr * n1n2 / determinant,
        n1xn2 = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["c" /* cartesianCross */])(n1, n2),
        A = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["f" /* cartesianScale */])(n1, c1),
        B = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["f" /* cartesianScale */])(n2, c2);
    Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["b" /* cartesianAddInPlace */])(A, B);

    // Solve |p(t)|^2 = 1.
    var u = n1xn2,
        w = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["d" /* cartesianDot */])(A, u),
        uu = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["d" /* cartesianDot */])(u, u),
        t2 = w * w - uu * (Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["d" /* cartesianDot */])(A, A) - 1);

    if (t2 < 0) return;

    var t = Object(__WEBPACK_IMPORTED_MODULE_2__math__["u" /* sqrt */])(t2),
        q = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["f" /* cartesianScale */])(u, (-w - t) / uu);
    Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["b" /* cartesianAddInPlace */])(q, A);
    q = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["g" /* spherical */])(q);

    if (!two) return q;

    // Two intersection points.
    var lambda0 = a[0],
        lambda1 = b[0],
        phi0 = a[1],
        phi1 = b[1],
        z;

    if (lambda1 < lambda0) z = lambda0, lambda0 = lambda1, lambda1 = z;

    var delta = lambda1 - lambda0,
        polar = Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" /* abs */])(delta - __WEBPACK_IMPORTED_MODULE_2__math__["o" /* pi */]) < __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */],
        meridian = polar || delta < __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */];

    if (!polar && phi1 < phi0) z = phi0, phi0 = phi1, phi1 = z;

    // Check that the first point is between a and b.
    if (meridian
        ? polar
          ? phi0 + phi1 > 0 ^ q[1] < (Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" /* abs */])(q[0] - lambda0) < __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */] ? phi0 : phi1)
          : phi0 <= q[1] && q[1] <= phi1
        : delta > __WEBPACK_IMPORTED_MODULE_2__math__["o" /* pi */] ^ (lambda0 <= q[0] && q[0] <= lambda1)) {
      var q1 = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["f" /* cartesianScale */])(u, (-w + t) / uu);
      Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["b" /* cartesianAddInPlace */])(q1, A);
      return [q, Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["g" /* spherical */])(q1)];
    }
  }

  // Generates a 4-bit vector representing the location of a point relative to
  // the small circle's bounding box.
  function code(lambda, phi) {
    var r = smallRadius ? radius : __WEBPACK_IMPORTED_MODULE_2__math__["o" /* pi */] - radius,
        code = 0;
    if (lambda < -r) code |= 1; // left
    else if (lambda > r) code |= 2; // right
    if (phi < -r) code |= 4; // below
    else if (phi > r) code |= 8; // above
    return code;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_4__index__["a" /* default */])(visible, clipLine, interpolate, smallRadius ? [0, -radius] : [-__WEBPACK_IMPORTED_MODULE_2__math__["o" /* pi */], radius - __WEBPACK_IMPORTED_MODULE_2__math__["o" /* pi */]]);
});


/***/ }),

/***/ "./node_modules/d3-geo/src/clip/extent.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rectangle__ = __webpack_require__("./node_modules/d3-geo/src/clip/rectangle.js");


/* harmony default export */ __webpack_exports__["a"] = (function() {
  var x0 = 0,
      y0 = 0,
      x1 = 960,
      y1 = 500,
      cache,
      cacheStream,
      clip;

  return clip = {
    stream: function(stream) {
      return cache && cacheStream === stream ? cache : cache = Object(__WEBPACK_IMPORTED_MODULE_0__rectangle__["a" /* default */])(x0, y0, x1, y1)(cacheStream = stream);
    },
    extent: function(_) {
      return arguments.length ? (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1], cache = cacheStream = null, clip) : [[x0, y0], [x1, y1]];
    }
  };
});


/***/ }),

/***/ "./node_modules/d3-geo/src/clip/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__buffer__ = __webpack_require__("./node_modules/d3-geo/src/clip/buffer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rejoin__ = __webpack_require__("./node_modules/d3-geo/src/clip/rejoin.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__("./node_modules/d3-geo/src/math.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__polygonContains__ = __webpack_require__("./node_modules/d3-geo/src/polygonContains.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_array__ = __webpack_require__("./node_modules/d3-array/src/index.js");






/* harmony default export */ __webpack_exports__["a"] = (function(pointVisible, clipLine, interpolate, start) {
  return function(sink) {
    var line = clipLine(sink),
        ringBuffer = Object(__WEBPACK_IMPORTED_MODULE_0__buffer__["a" /* default */])(),
        ringSink = clipLine(ringBuffer),
        polygonStarted = false,
        polygon,
        segments,
        ring;

    var clip = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: function() {
        clip.point = pointRing;
        clip.lineStart = ringStart;
        clip.lineEnd = ringEnd;
        segments = [];
        polygon = [];
      },
      polygonEnd: function() {
        clip.point = point;
        clip.lineStart = lineStart;
        clip.lineEnd = lineEnd;
        segments = Object(__WEBPACK_IMPORTED_MODULE_4_d3_array__["n" /* merge */])(segments);
        var startInside = Object(__WEBPACK_IMPORTED_MODULE_3__polygonContains__["a" /* default */])(polygon, start);
        if (segments.length) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          Object(__WEBPACK_IMPORTED_MODULE_1__rejoin__["a" /* default */])(segments, compareIntersection, startInside, interpolate, sink);
        } else if (startInside) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          sink.lineStart();
          interpolate(null, null, 1, sink);
          sink.lineEnd();
        }
        if (polygonStarted) sink.polygonEnd(), polygonStarted = false;
        segments = polygon = null;
      },
      sphere: function() {
        sink.polygonStart();
        sink.lineStart();
        interpolate(null, null, 1, sink);
        sink.lineEnd();
        sink.polygonEnd();
      }
    };

    function point(lambda, phi) {
      if (pointVisible(lambda, phi)) sink.point(lambda, phi);
    }

    function pointLine(lambda, phi) {
      line.point(lambda, phi);
    }

    function lineStart() {
      clip.point = pointLine;
      line.lineStart();
    }

    function lineEnd() {
      clip.point = point;
      line.lineEnd();
    }

    function pointRing(lambda, phi) {
      ring.push([lambda, phi]);
      ringSink.point(lambda, phi);
    }

    function ringStart() {
      ringSink.lineStart();
      ring = [];
    }

    function ringEnd() {
      pointRing(ring[0][0], ring[0][1]);
      ringSink.lineEnd();

      var clean = ringSink.clean(),
          ringSegments = ringBuffer.result(),
          i, n = ringSegments.length, m,
          segment,
          point;

      ring.pop();
      polygon.push(ring);
      ring = null;

      if (!n) return;

      // No intersections.
      if (clean & 1) {
        segment = ringSegments[0];
        if ((m = segment.length - 1) > 0) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          sink.lineStart();
          for (i = 0; i < m; ++i) sink.point((point = segment[i])[0], point[1]);
          sink.lineEnd();
        }
        return;
      }

      // Rejoin connected segments.
      // TODO reuse ringBuffer.rejoin()?
      if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));

      segments.push(ringSegments.filter(validSegment));
    }

    return clip;
  };
});

function validSegment(segment) {
  return segment.length > 1;
}

// Intersections are sorted along the clip edge. For both antimeridian cutting
// and circle clipping, the same comparison is used.
function compareIntersection(a, b) {
  return ((a = a.x)[0] < 0 ? a[1] - __WEBPACK_IMPORTED_MODULE_2__math__["l" /* halfPi */] - __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */] : __WEBPACK_IMPORTED_MODULE_2__math__["l" /* halfPi */] - a[1])
       - ((b = b.x)[0] < 0 ? b[1] - __WEBPACK_IMPORTED_MODULE_2__math__["l" /* halfPi */] - __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */] : __WEBPACK_IMPORTED_MODULE_2__math__["l" /* halfPi */] - b[1]);
}


/***/ }),

/***/ "./node_modules/d3-geo/src/clip/line.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b, x0, y0, x1, y1) {
  var ax = a[0],
      ay = a[1],
      bx = b[0],
      by = b[1],
      t0 = 0,
      t1 = 1,
      dx = bx - ax,
      dy = by - ay,
      r;

  r = x0 - ax;
  if (!dx && r > 0) return;
  r /= dx;
  if (dx < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dx > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = x1 - ax;
  if (!dx && r < 0) return;
  r /= dx;
  if (dx < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dx > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  r = y0 - ay;
  if (!dy && r > 0) return;
  r /= dy;
  if (dy < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dy > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = y1 - ay;
  if (!dy && r < 0) return;
  r /= dy;
  if (dy < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dy > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  if (t0 > 0) a[0] = ax + t0 * dx, a[1] = ay + t0 * dy;
  if (t1 < 1) b[0] = ax + t1 * dx, b[1] = ay + t1 * dy;
  return true;
});


/***/ }),

/***/ "./node_modules/d3-geo/src/clip/rectangle.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = clipRectangle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__("./node_modules/d3-geo/src/math.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__buffer__ = __webpack_require__("./node_modules/d3-geo/src/clip/buffer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__line__ = __webpack_require__("./node_modules/d3-geo/src/clip/line.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rejoin__ = __webpack_require__("./node_modules/d3-geo/src/clip/rejoin.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_array__ = __webpack_require__("./node_modules/d3-array/src/index.js");






var clipMax = 1e9, clipMin = -clipMax;

// TODO Use d3-polygon’s polygonContains here for the ring check?
// TODO Eliminate duplicate buffering in clipBuffer and polygon.push?

function clipRectangle(x0, y0, x1, y1) {

  function visible(x, y) {
    return x0 <= x && x <= x1 && y0 <= y && y <= y1;
  }

  function interpolate(from, to, direction, stream) {
    var a = 0, a1 = 0;
    if (from == null
        || (a = corner(from, direction)) !== (a1 = corner(to, direction))
        || comparePoint(from, to) < 0 ^ direction > 0) {
      do stream.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
      while ((a = (a + direction + 4) % 4) !== a1);
    } else {
      stream.point(to[0], to[1]);
    }
  }

  function corner(p, direction) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(p[0] - x0) < __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */] ? direction > 0 ? 0 : 3
        : Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(p[0] - x1) < __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */] ? direction > 0 ? 2 : 1
        : Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(p[1] - y0) < __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */] ? direction > 0 ? 1 : 0
        : direction > 0 ? 3 : 2; // abs(p[1] - y1) < epsilon
  }

  function compareIntersection(a, b) {
    return comparePoint(a.x, b.x);
  }

  function comparePoint(a, b) {
    var ca = corner(a, 1),
        cb = corner(b, 1);
    return ca !== cb ? ca - cb
        : ca === 0 ? b[1] - a[1]
        : ca === 1 ? a[0] - b[0]
        : ca === 2 ? a[1] - b[1]
        : b[0] - a[0];
  }

  return function(stream) {
    var activeStream = stream,
        bufferStream = Object(__WEBPACK_IMPORTED_MODULE_1__buffer__["a" /* default */])(),
        segments,
        polygon,
        ring,
        x__, y__, v__, // first point
        x_, y_, v_, // previous point
        first,
        clean;

    var clipStream = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: polygonStart,
      polygonEnd: polygonEnd
    };

    function point(x, y) {
      if (visible(x, y)) activeStream.point(x, y);
    }

    function polygonInside() {
      var winding = 0;

      for (var i = 0, n = polygon.length; i < n; ++i) {
        for (var ring = polygon[i], j = 1, m = ring.length, point = ring[0], a0, a1, b0 = point[0], b1 = point[1]; j < m; ++j) {
          a0 = b0, a1 = b1, point = ring[j], b0 = point[0], b1 = point[1];
          if (a1 <= y1) { if (b1 > y1 && (b0 - a0) * (y1 - a1) > (b1 - a1) * (x0 - a0)) ++winding; }
          else { if (b1 <= y1 && (b0 - a0) * (y1 - a1) < (b1 - a1) * (x0 - a0)) --winding; }
        }
      }

      return winding;
    }

    // Buffer geometry within a polygon and then clip it en masse.
    function polygonStart() {
      activeStream = bufferStream, segments = [], polygon = [], clean = true;
    }

    function polygonEnd() {
      var startInside = polygonInside(),
          cleanInside = clean && startInside,
          visible = (segments = Object(__WEBPACK_IMPORTED_MODULE_4_d3_array__["n" /* merge */])(segments)).length;
      if (cleanInside || visible) {
        stream.polygonStart();
        if (cleanInside) {
          stream.lineStart();
          interpolate(null, null, 1, stream);
          stream.lineEnd();
        }
        if (visible) {
          Object(__WEBPACK_IMPORTED_MODULE_3__rejoin__["a" /* default */])(segments, compareIntersection, startInside, interpolate, stream);
        }
        stream.polygonEnd();
      }
      activeStream = stream, segments = polygon = ring = null;
    }

    function lineStart() {
      clipStream.point = linePoint;
      if (polygon) polygon.push(ring = []);
      first = true;
      v_ = false;
      x_ = y_ = NaN;
    }

    // TODO rather than special-case polygons, simply handle them separately.
    // Ideally, coincident intersection points should be jittered to avoid
    // clipping issues.
    function lineEnd() {
      if (segments) {
        linePoint(x__, y__);
        if (v__ && v_) bufferStream.rejoin();
        segments.push(bufferStream.result());
      }
      clipStream.point = point;
      if (v_) activeStream.lineEnd();
    }

    function linePoint(x, y) {
      var v = visible(x, y);
      if (polygon) ring.push([x, y]);
      if (first) {
        x__ = x, y__ = y, v__ = v;
        first = false;
        if (v) {
          activeStream.lineStart();
          activeStream.point(x, y);
        }
      } else {
        if (v && v_) activeStream.point(x, y);
        else {
          var a = [x_ = Math.max(clipMin, Math.min(clipMax, x_)), y_ = Math.max(clipMin, Math.min(clipMax, y_))],
              b = [x = Math.max(clipMin, Math.min(clipMax, x)), y = Math.max(clipMin, Math.min(clipMax, y))];
          if (Object(__WEBPACK_IMPORTED_MODULE_2__line__["a" /* default */])(a, b, x0, y0, x1, y1)) {
            if (!v_) {
              activeStream.lineStart();
              activeStream.point(a[0], a[1]);
            }
            activeStream.point(b[0], b[1]);
            if (!v) activeStream.lineEnd();
            clean = false;
          } else if (v) {
            activeStream.lineStart();
            activeStream.point(x, y);
            clean = false;
          }
        }
      }
      x_ = x, y_ = y, v_ = v;
    }

    return clipStream;
  };
}


/***/ }),

/***/ "./node_modules/d3-geo/src/clip/rejoin.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pointEqual__ = __webpack_require__("./node_modules/d3-geo/src/pointEqual.js");


function Intersection(point, points, other, entry) {
  this.x = point;
  this.z = points;
  this.o = other; // another intersection
  this.e = entry; // is an entry?
  this.v = false; // visited
  this.n = this.p = null; // next & previous
}

// A generalized polygon clipping algorithm: given a polygon that has been cut
// into its visible line segments, and rejoins the segments by interpolating
// along the clip edge.
/* harmony default export */ __webpack_exports__["a"] = (function(segments, compareIntersection, startInside, interpolate, stream) {
  var subject = [],
      clip = [],
      i,
      n;

  segments.forEach(function(segment) {
    if ((n = segment.length - 1) <= 0) return;
    var n, p0 = segment[0], p1 = segment[n], x;

    // If the first and last points of a segment are coincident, then treat as a
    // closed ring. TODO if all rings are closed, then the winding order of the
    // exterior ring should be checked.
    if (Object(__WEBPACK_IMPORTED_MODULE_0__pointEqual__["a" /* default */])(p0, p1)) {
      stream.lineStart();
      for (i = 0; i < n; ++i) stream.point((p0 = segment[i])[0], p0[1]);
      stream.lineEnd();
      return;
    }

    subject.push(x = new Intersection(p0, segment, null, true));
    clip.push(x.o = new Intersection(p0, null, x, false));
    subject.push(x = new Intersection(p1, segment, null, false));
    clip.push(x.o = new Intersection(p1, null, x, true));
  });

  if (!subject.length) return;

  clip.sort(compareIntersection);
  link(subject);
  link(clip);

  for (i = 0, n = clip.length; i < n; ++i) {
    clip[i].e = startInside = !startInside;
  }

  var start = subject[0],
      points,
      point;

  while (1) {
    // Find first unvisited intersection.
    var current = start,
        isSubject = true;
    while (current.v) if ((current = current.n) === start) return;
    points = current.z;
    stream.lineStart();
    do {
      current.v = current.o.v = true;
      if (current.e) {
        if (isSubject) {
          for (i = 0, n = points.length; i < n; ++i) stream.point((point = points[i])[0], point[1]);
        } else {
          interpolate(current.x, current.n.x, 1, stream);
        }
        current = current.n;
      } else {
        if (isSubject) {
          points = current.p.z;
          for (i = points.length - 1; i >= 0; --i) stream.point((point = points[i])[0], point[1]);
        } else {
          interpolate(current.x, current.p.x, -1, stream);
        }
        current = current.p;
      }
      current = current.o;
      points = current.z;
      isSubject = !isSubject;
    } while (!current.v);
    stream.lineEnd();
  }
});

function link(array) {
  if (!(n = array.length)) return;
  var n,
      i = 0,
      a = array[0],
      b;
  while (++i < n) {
    a.n = b = array[i];
    b.p = a;
    a = b;
  }
  a.n = b = array[0];
  b.p = a;
}


/***/ }),

/***/ "./node_modules/d3-geo/src/compose.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {

  function compose(x, y) {
    return x = a(x, y), b(x[0], x[1]);
  }

  if (a.invert && b.invert) compose.invert = function(x, y) {
    return x = b.invert(x, y), x && a.invert(x[0], x[1]);
  };

  return compose;
});


/***/ }),

/***/ "./node_modules/d3-geo/src/constant.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),

/***/ "./node_modules/d3-geo/src/contains.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__polygonContains__ = __webpack_require__("./node_modules/d3-geo/src/polygonContains.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__distance__ = __webpack_require__("./node_modules/d3-geo/src/distance.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__("./node_modules/d3-geo/src/math.js");




var containsObjectType = {
  Feature: function(object, point) {
    return containsGeometry(object.geometry, point);
  },
  FeatureCollection: function(object, point) {
    var features = object.features, i = -1, n = features.length;
    while (++i < n) if (containsGeometry(features[i].geometry, point)) return true;
    return false;
  }
};

var containsGeometryType = {
  Sphere: function() {
    return true;
  },
  Point: function(object, point) {
    return containsPoint(object.coordinates, point);
  },
  MultiPoint: function(object, point) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) if (containsPoint(coordinates[i], point)) return true;
    return false;
  },
  LineString: function(object, point) {
    return containsLine(object.coordinates, point);
  },
  MultiLineString: function(object, point) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) if (containsLine(coordinates[i], point)) return true;
    return false;
  },
  Polygon: function(object, point) {
    return containsPolygon(object.coordinates, point);
  },
  MultiPolygon: function(object, point) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) if (containsPolygon(coordinates[i], point)) return true;
    return false;
  },
  GeometryCollection: function(object, point) {
    var geometries = object.geometries, i = -1, n = geometries.length;
    while (++i < n) if (containsGeometry(geometries[i], point)) return true;
    return false;
  }
};

function containsGeometry(geometry, point) {
  return geometry && containsGeometryType.hasOwnProperty(geometry.type)
      ? containsGeometryType[geometry.type](geometry, point)
      : false;
}

function containsPoint(coordinates, point) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__distance__["a" /* default */])(coordinates, point) === 0;
}

function containsLine(coordinates, point) {
  var ab = Object(__WEBPACK_IMPORTED_MODULE_1__distance__["a" /* default */])(coordinates[0], coordinates[1]),
      ao = Object(__WEBPACK_IMPORTED_MODULE_1__distance__["a" /* default */])(coordinates[0], point),
      ob = Object(__WEBPACK_IMPORTED_MODULE_1__distance__["a" /* default */])(point, coordinates[1]);
  return ao + ob <= ab + __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */];
}

function containsPolygon(coordinates, point) {
  return !!Object(__WEBPACK_IMPORTED_MODULE_0__polygonContains__["a" /* default */])(coordinates.map(ringRadians), pointRadians(point));
}

function ringRadians(ring) {
  return ring = ring.map(pointRadians), ring.pop(), ring;
}

function pointRadians(point) {
  return [point[0] * __WEBPACK_IMPORTED_MODULE_2__math__["r" /* radians */], point[1] * __WEBPACK_IMPORTED_MODULE_2__math__["r" /* radians */]];
}

/* harmony default export */ __webpack_exports__["a"] = (function(object, point) {
  return (object && containsObjectType.hasOwnProperty(object.type)
      ? containsObjectType[object.type]
      : containsGeometry)(object, point);
});


/***/ }),

/***/ "./node_modules/d3-geo/src/distance.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__length__ = __webpack_require__("./node_modules/d3-geo/src/length.js");


var coordinates = [null, null],
    object = {type: "LineString", coordinates: coordinates};

/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  coordinates[0] = a;
  coordinates[1] = b;
  return Object(__WEBPACK_IMPORTED_MODULE_0__length__["a" /* default */])(object);
});


/***/ }),

/***/ "./node_modules/d3-geo/src/graticule.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = graticule;
/* harmony export (immutable) */ __webpack_exports__["b"] = graticule10;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__("./node_modules/d3-array/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__("./node_modules/d3-geo/src/math.js");



function graticuleX(y0, y1, dy) {
  var y = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["s" /* range */])(y0, y1 - __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */], dy).concat(y1);
  return function(x) { return y.map(function(y) { return [x, y]; }); };
}

function graticuleY(x0, x1, dx) {
  var x = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["s" /* range */])(x0, x1 - __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */], dx).concat(x1);
  return function(y) { return x.map(function(x) { return [x, y]; }); };
}

function graticule() {
  var x1, x0, X1, X0,
      y1, y0, Y1, Y0,
      dx = 10, dy = dx, DX = 90, DY = 360,
      x, y, X, Y,
      precision = 2.5;

  function graticule() {
    return {type: "MultiLineString", coordinates: lines()};
  }

  function lines() {
    return Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["s" /* range */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["f" /* ceil */])(X0 / DX) * DX, X1, DX).map(X)
        .concat(Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["s" /* range */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["f" /* ceil */])(Y0 / DY) * DY, Y1, DY).map(Y))
        .concat(Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["s" /* range */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["f" /* ceil */])(x0 / dx) * dx, x1, dx).filter(function(x) { return Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(x % DX) > __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]; }).map(x))
        .concat(Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["s" /* range */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["f" /* ceil */])(y0 / dy) * dy, y1, dy).filter(function(y) { return Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(y % DY) > __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]; }).map(y));
  }

  graticule.lines = function() {
    return lines().map(function(coordinates) { return {type: "LineString", coordinates: coordinates}; });
  };

  graticule.outline = function() {
    return {
      type: "Polygon",
      coordinates: [
        X(X0).concat(
        Y(Y1).slice(1),
        X(X1).reverse().slice(1),
        Y(Y0).reverse().slice(1))
      ]
    };
  };

  graticule.extent = function(_) {
    if (!arguments.length) return graticule.extentMinor();
    return graticule.extentMajor(_).extentMinor(_);
  };

  graticule.extentMajor = function(_) {
    if (!arguments.length) return [[X0, Y0], [X1, Y1]];
    X0 = +_[0][0], X1 = +_[1][0];
    Y0 = +_[0][1], Y1 = +_[1][1];
    if (X0 > X1) _ = X0, X0 = X1, X1 = _;
    if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
    return graticule.precision(precision);
  };

  graticule.extentMinor = function(_) {
    if (!arguments.length) return [[x0, y0], [x1, y1]];
    x0 = +_[0][0], x1 = +_[1][0];
    y0 = +_[0][1], y1 = +_[1][1];
    if (x0 > x1) _ = x0, x0 = x1, x1 = _;
    if (y0 > y1) _ = y0, y0 = y1, y1 = _;
    return graticule.precision(precision);
  };

  graticule.step = function(_) {
    if (!arguments.length) return graticule.stepMinor();
    return graticule.stepMajor(_).stepMinor(_);
  };

  graticule.stepMajor = function(_) {
    if (!arguments.length) return [DX, DY];
    DX = +_[0], DY = +_[1];
    return graticule;
  };

  graticule.stepMinor = function(_) {
    if (!arguments.length) return [dx, dy];
    dx = +_[0], dy = +_[1];
    return graticule;
  };

  graticule.precision = function(_) {
    if (!arguments.length) return precision;
    precision = +_;
    x = graticuleX(y0, y1, 90);
    y = graticuleY(x0, x1, precision);
    X = graticuleX(Y0, Y1, 90);
    Y = graticuleY(X0, X1, precision);
    return graticule;
  };

  return graticule
      .extentMajor([[-180, -90 + __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]], [180, 90 - __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]]])
      .extentMinor([[-180, -80 - __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]], [180, 80 + __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]]]);
}

function graticule10() {
  return graticule()();
}


/***/ }),

/***/ "./node_modules/d3-geo/src/identity.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),

/***/ "./node_modules/d3-geo/src/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__area__ = __webpack_require__("./node_modules/d3-geo/src/area.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__area__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bounds__ = __webpack_require__("./node_modules/d3-geo/src/bounds.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_1__bounds__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__centroid__ = __webpack_require__("./node_modules/d3-geo/src/centroid.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_2__centroid__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__circle__ = __webpack_require__("./node_modules/d3-geo/src/circle.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_3__circle__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__clip_antimeridian__ = __webpack_require__("./node_modules/d3-geo/src/clip/antimeridian.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_4__clip_antimeridian__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__clip_circle__ = __webpack_require__("./node_modules/d3-geo/src/clip/circle.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_5__clip_circle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__clip_extent__ = __webpack_require__("./node_modules/d3-geo/src/clip/extent.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_6__clip_extent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__clip_rectangle__ = __webpack_require__("./node_modules/d3-geo/src/clip/rectangle.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_7__clip_rectangle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__contains__ = __webpack_require__("./node_modules/d3-geo/src/contains.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_8__contains__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__distance__ = __webpack_require__("./node_modules/d3-geo/src/distance.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_9__distance__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__graticule__ = __webpack_require__("./node_modules/d3-geo/src/graticule.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_10__graticule__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_10__graticule__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__interpolate__ = __webpack_require__("./node_modules/d3-geo/src/interpolate.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_11__interpolate__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__length__ = __webpack_require__("./node_modules/d3-geo/src/length.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_12__length__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__path_index__ = __webpack_require__("./node_modules/d3-geo/src/path/index.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_13__path_index__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__projection_albers__ = __webpack_require__("./node_modules/d3-geo/src/projection/albers.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_14__projection_albers__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__projection_albersUsa__ = __webpack_require__("./node_modules/d3-geo/src/projection/albersUsa.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_15__projection_albersUsa__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__projection_azimuthalEqualArea__ = __webpack_require__("./node_modules/d3-geo/src/projection/azimuthalEqualArea.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_16__projection_azimuthalEqualArea__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_16__projection_azimuthalEqualArea__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__projection_azimuthalEquidistant__ = __webpack_require__("./node_modules/d3-geo/src/projection/azimuthalEquidistant.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_17__projection_azimuthalEquidistant__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_17__projection_azimuthalEquidistant__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__projection_conicConformal__ = __webpack_require__("./node_modules/d3-geo/src/projection/conicConformal.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_18__projection_conicConformal__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_18__projection_conicConformal__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__projection_conicEqualArea__ = __webpack_require__("./node_modules/d3-geo/src/projection/conicEqualArea.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_19__projection_conicEqualArea__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_19__projection_conicEqualArea__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__projection_conicEquidistant__ = __webpack_require__("./node_modules/d3-geo/src/projection/conicEquidistant.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_20__projection_conicEquidistant__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_20__projection_conicEquidistant__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__projection_equalEarth__ = __webpack_require__("./node_modules/d3-geo/src/projection/equalEarth.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_21__projection_equalEarth__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_21__projection_equalEarth__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__projection_equirectangular__ = __webpack_require__("./node_modules/d3-geo/src/projection/equirectangular.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_22__projection_equirectangular__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_22__projection_equirectangular__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__projection_gnomonic__ = __webpack_require__("./node_modules/d3-geo/src/projection/gnomonic.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_23__projection_gnomonic__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_23__projection_gnomonic__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__projection_identity__ = __webpack_require__("./node_modules/d3-geo/src/projection/identity.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_24__projection_identity__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__projection_index__ = __webpack_require__("./node_modules/d3-geo/src/projection/index.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_25__projection_index__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_25__projection_index__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__projection_mercator__ = __webpack_require__("./node_modules/d3-geo/src/projection/mercator.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_26__projection_mercator__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_26__projection_mercator__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__projection_naturalEarth1__ = __webpack_require__("./node_modules/d3-geo/src/projection/naturalEarth1.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_27__projection_naturalEarth1__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_27__projection_naturalEarth1__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__projection_orthographic__ = __webpack_require__("./node_modules/d3-geo/src/projection/orthographic.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_28__projection_orthographic__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_28__projection_orthographic__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__projection_stereographic__ = __webpack_require__("./node_modules/d3-geo/src/projection/stereographic.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return __WEBPACK_IMPORTED_MODULE_29__projection_stereographic__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return __WEBPACK_IMPORTED_MODULE_29__projection_stereographic__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__projection_transverseMercator__ = __webpack_require__("./node_modules/d3-geo/src/projection/transverseMercator.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return __WEBPACK_IMPORTED_MODULE_30__projection_transverseMercator__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return __WEBPACK_IMPORTED_MODULE_30__projection_transverseMercator__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__rotation__ = __webpack_require__("./node_modules/d3-geo/src/rotation.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return __WEBPACK_IMPORTED_MODULE_31__rotation__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__stream__ = __webpack_require__("./node_modules/d3-geo/src/stream.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return __WEBPACK_IMPORTED_MODULE_32__stream__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__transform__ = __webpack_require__("./node_modules/d3-geo/src/transform.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return __WEBPACK_IMPORTED_MODULE_33__transform__["a"]; });






 // DEPRECATED! Use d3.geoIdentity().clipExtent(…).





























/***/ }),

/***/ "./node_modules/d3-geo/src/interpolate.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__("./node_modules/d3-geo/src/math.js");


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var x0 = a[0] * __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */],
      y0 = a[1] * __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */],
      x1 = b[0] * __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */],
      y1 = b[1] * __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */],
      cy0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(y0),
      sy0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y0),
      cy1 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(y1),
      sy1 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y1),
      kx0 = cy0 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(x0),
      ky0 = cy0 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(x0),
      kx1 = cy1 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(x1),
      ky1 = cy1 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(x1),
      d = 2 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* asin */])(Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(Object(__WEBPACK_IMPORTED_MODULE_0__math__["m" /* haversin */])(y1 - y0) + cy0 * cy1 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["m" /* haversin */])(x1 - x0))),
      k = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(d);

  var interpolate = d ? function(t) {
    var B = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(t *= d) / k,
        A = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(d - t) / k,
        x = A * kx0 + B * kx1,
        y = A * ky0 + B * ky1,
        z = A * sy0 + B * sy1;
    return [
      Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(y, x) * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */],
      Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(z, Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(x * x + y * y)) * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */]
    ];
  } : function() {
    return [x0 * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */], y0 * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */]];
  };

  interpolate.distance = d;

  return interpolate;
});


/***/ }),

/***/ "./node_modules/d3-geo/src/length.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adder__ = __webpack_require__("./node_modules/d3-geo/src/adder.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__("./node_modules/d3-geo/src/math.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__noop__ = __webpack_require__("./node_modules/d3-geo/src/noop.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stream__ = __webpack_require__("./node_modules/d3-geo/src/stream.js");





var lengthSum = Object(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])(),
    lambda0,
    sinPhi0,
    cosPhi0;

var lengthStream = {
  sphere: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  point: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  lineStart: lengthLineStart,
  lineEnd: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  polygonStart: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  polygonEnd: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */]
};

function lengthLineStart() {
  lengthStream.point = lengthPointFirst;
  lengthStream.lineEnd = lengthLineEnd;
}

function lengthLineEnd() {
  lengthStream.point = lengthStream.lineEnd = __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */];
}

function lengthPointFirst(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */];
  lambda0 = lambda, sinPhi0 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(phi), cosPhi0 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(phi);
  lengthStream.point = lengthPoint;
}

function lengthPoint(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */];
  var sinPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(phi),
      cosPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(phi),
      delta = Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(lambda - lambda0),
      cosDelta = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(delta),
      sinDelta = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(delta),
      x = cosPhi * sinDelta,
      y = cosPhi0 * sinPhi - sinPhi0 * cosPhi * cosDelta,
      z = sinPhi0 * sinPhi + cosPhi0 * cosPhi * cosDelta;
  lengthSum.add(Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* atan2 */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["u" /* sqrt */])(x * x + y * y), z));
  lambda0 = lambda, sinPhi0 = sinPhi, cosPhi0 = cosPhi;
}

/* harmony default export */ __webpack_exports__["a"] = (function(object) {
  lengthSum.reset();
  Object(__WEBPACK_IMPORTED_MODULE_3__stream__["a" /* default */])(object, lengthStream);
  return +lengthSum;
});


/***/ }),

/***/ "./node_modules/d3-geo/src/math.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return epsilon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return epsilon2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return pi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return halfPi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return quarterPi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return tau; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return degrees; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return radians; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return abs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return atan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return atan2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return cos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ceil; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return exp; });
/* unused harmony export floor */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return log; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return pow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return sin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return sign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return sqrt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return tan; });
/* harmony export (immutable) */ __webpack_exports__["b"] = acos;
/* harmony export (immutable) */ __webpack_exports__["c"] = asin;
/* harmony export (immutable) */ __webpack_exports__["m"] = haversin;
var epsilon = 1e-6;
var epsilon2 = 1e-12;
var pi = Math.PI;
var halfPi = pi / 2;
var quarterPi = pi / 4;
var tau = pi * 2;

var degrees = 180 / pi;
var radians = pi / 180;

var abs = Math.abs;
var atan = Math.atan;
var atan2 = Math.atan2;
var cos = Math.cos;
var ceil = Math.ceil;
var exp = Math.exp;
var floor = Math.floor;
var log = Math.log;
var pow = Math.pow;
var sin = Math.sin;
var sign = Math.sign || function(x) { return x > 0 ? 1 : x < 0 ? -1 : 0; };
var sqrt = Math.sqrt;
var tan = Math.tan;

function acos(x) {
  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}

function asin(x) {
  return x > 1 ? halfPi : x < -1 ? -halfPi : Math.asin(x);
}

function haversin(x) {
  return (x = sin(x / 2)) * x;
}


/***/ }),

/***/ "./node_modules/d3-geo/src/noop.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = noop;
function noop() {}


/***/ }),

/***/ "./node_modules/d3-geo/src/path/area.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adder__ = __webpack_require__("./node_modules/d3-geo/src/adder.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__("./node_modules/d3-geo/src/math.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__noop__ = __webpack_require__("./node_modules/d3-geo/src/noop.js");




var areaSum = Object(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])(),
    areaRingSum = Object(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])(),
    x00,
    y00,
    x0,
    y0;

var areaStream = {
  point: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  lineStart: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  lineEnd: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  polygonStart: function() {
    areaStream.lineStart = areaRingStart;
    areaStream.lineEnd = areaRingEnd;
  },
  polygonEnd: function() {
    areaStream.lineStart = areaStream.lineEnd = areaStream.point = __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */];
    areaSum.add(Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(areaRingSum));
    areaRingSum.reset();
  },
  result: function() {
    var area = areaSum / 2;
    areaSum.reset();
    return area;
  }
};

function areaRingStart() {
  areaStream.point = areaPointFirst;
}

function areaPointFirst(x, y) {
  areaStream.point = areaPoint;
  x00 = x0 = x, y00 = y0 = y;
}

function areaPoint(x, y) {
  areaRingSum.add(y0 * x - x0 * y);
  x0 = x, y0 = y;
}

function areaRingEnd() {
  areaPoint(x00, y00);
}

/* harmony default export */ __webpack_exports__["a"] = (areaStream);


/***/ }),

/***/ "./node_modules/d3-geo/src/path/bounds.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__("./node_modules/d3-geo/src/noop.js");


var x0 = Infinity,
    y0 = x0,
    x1 = -x0,
    y1 = x1;

var boundsStream = {
  point: boundsPoint,
  lineStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  lineEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  polygonStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  polygonEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  result: function() {
    var bounds = [[x0, y0], [x1, y1]];
    x1 = y1 = -(y0 = x0 = Infinity);
    return bounds;
  }
};

function boundsPoint(x, y) {
  if (x < x0) x0 = x;
  if (x > x1) x1 = x;
  if (y < y0) y0 = y;
  if (y > y1) y1 = y;
}

/* harmony default export */ __webpack_exports__["a"] = (boundsStream);


/***/ }),

/***/ "./node_modules/d3-geo/src/path/centroid.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__("./node_modules/d3-geo/src/math.js");


// TODO Enforce positive area for exterior, negative area for interior?

var X0 = 0,
    Y0 = 0,
    Z0 = 0,
    X1 = 0,
    Y1 = 0,
    Z1 = 0,
    X2 = 0,
    Y2 = 0,
    Z2 = 0,
    x00,
    y00,
    x0,
    y0;

var centroidStream = {
  point: centroidPoint,
  lineStart: centroidLineStart,
  lineEnd: centroidLineEnd,
  polygonStart: function() {
    centroidStream.lineStart = centroidRingStart;
    centroidStream.lineEnd = centroidRingEnd;
  },
  polygonEnd: function() {
    centroidStream.point = centroidPoint;
    centroidStream.lineStart = centroidLineStart;
    centroidStream.lineEnd = centroidLineEnd;
  },
  result: function() {
    var centroid = Z2 ? [X2 / Z2, Y2 / Z2]
        : Z1 ? [X1 / Z1, Y1 / Z1]
        : Z0 ? [X0 / Z0, Y0 / Z0]
        : [NaN, NaN];
    X0 = Y0 = Z0 =
    X1 = Y1 = Z1 =
    X2 = Y2 = Z2 = 0;
    return centroid;
  }
};

function centroidPoint(x, y) {
  X0 += x;
  Y0 += y;
  ++Z0;
}

function centroidLineStart() {
  centroidStream.point = centroidPointFirstLine;
}

function centroidPointFirstLine(x, y) {
  centroidStream.point = centroidPointLine;
  centroidPoint(x0 = x, y0 = y);
}

function centroidPointLine(x, y) {
  var dx = x - x0, dy = y - y0, z = Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(dx * dx + dy * dy);
  X1 += z * (x0 + x) / 2;
  Y1 += z * (y0 + y) / 2;
  Z1 += z;
  centroidPoint(x0 = x, y0 = y);
}

function centroidLineEnd() {
  centroidStream.point = centroidPoint;
}

function centroidRingStart() {
  centroidStream.point = centroidPointFirstRing;
}

function centroidRingEnd() {
  centroidPointRing(x00, y00);
}

function centroidPointFirstRing(x, y) {
  centroidStream.point = centroidPointRing;
  centroidPoint(x00 = x0 = x, y00 = y0 = y);
}

function centroidPointRing(x, y) {
  var dx = x - x0,
      dy = y - y0,
      z = Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(dx * dx + dy * dy);

  X1 += z * (x0 + x) / 2;
  Y1 += z * (y0 + y) / 2;
  Z1 += z;

  z = y0 * x - x0 * y;
  X2 += z * (x0 + x);
  Y2 += z * (y0 + y);
  Z2 += z * 3;
  centroidPoint(x0 = x, y0 = y);
}

/* harmony default export */ __webpack_exports__["a"] = (centroidStream);


/***/ }),

/***/ "./node_modules/d3-geo/src/path/context.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PathContext;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__("./node_modules/d3-geo/src/math.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__noop__ = __webpack_require__("./node_modules/d3-geo/src/noop.js");



function PathContext(context) {
  this._context = context;
}

PathContext.prototype = {
  _radius: 4.5,
  pointRadius: function(_) {
    return this._radius = _, this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line === 0) this._context.closePath();
    this._point = NaN;
  },
  point: function(x, y) {
    switch (this._point) {
      case 0: {
        this._context.moveTo(x, y);
        this._point = 1;
        break;
      }
      case 1: {
        this._context.lineTo(x, y);
        break;
      }
      default: {
        this._context.moveTo(x + this._radius, y);
        this._context.arc(x, y, this._radius, 0, __WEBPACK_IMPORTED_MODULE_0__math__["w" /* tau */]);
        break;
      }
    }
  },
  result: __WEBPACK_IMPORTED_MODULE_1__noop__["a" /* default */]
};


/***/ }),

/***/ "./node_modules/d3-geo/src/path/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__identity__ = __webpack_require__("./node_modules/d3-geo/src/identity.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stream__ = __webpack_require__("./node_modules/d3-geo/src/stream.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__area__ = __webpack_require__("./node_modules/d3-geo/src/path/area.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bounds__ = __webpack_require__("./node_modules/d3-geo/src/path/bounds.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__centroid__ = __webpack_require__("./node_modules/d3-geo/src/path/centroid.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__context__ = __webpack_require__("./node_modules/d3-geo/src/path/context.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__measure__ = __webpack_require__("./node_modules/d3-geo/src/path/measure.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__string__ = __webpack_require__("./node_modules/d3-geo/src/path/string.js");









/* harmony default export */ __webpack_exports__["a"] = (function(projection, context) {
  var pointRadius = 4.5,
      projectionStream,
      contextStream;

  function path(object) {
    if (object) {
      if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
      Object(__WEBPACK_IMPORTED_MODULE_1__stream__["a" /* default */])(object, projectionStream(contextStream));
    }
    return contextStream.result();
  }

  path.area = function(object) {
    Object(__WEBPACK_IMPORTED_MODULE_1__stream__["a" /* default */])(object, projectionStream(__WEBPACK_IMPORTED_MODULE_2__area__["a" /* default */]));
    return __WEBPACK_IMPORTED_MODULE_2__area__["a" /* default */].result();
  };

  path.measure = function(object) {
    Object(__WEBPACK_IMPORTED_MODULE_1__stream__["a" /* default */])(object, projectionStream(__WEBPACK_IMPORTED_MODULE_6__measure__["a" /* default */]));
    return __WEBPACK_IMPORTED_MODULE_6__measure__["a" /* default */].result();
  };

  path.bounds = function(object) {
    Object(__WEBPACK_IMPORTED_MODULE_1__stream__["a" /* default */])(object, projectionStream(__WEBPACK_IMPORTED_MODULE_3__bounds__["a" /* default */]));
    return __WEBPACK_IMPORTED_MODULE_3__bounds__["a" /* default */].result();
  };

  path.centroid = function(object) {
    Object(__WEBPACK_IMPORTED_MODULE_1__stream__["a" /* default */])(object, projectionStream(__WEBPACK_IMPORTED_MODULE_4__centroid__["a" /* default */]));
    return __WEBPACK_IMPORTED_MODULE_4__centroid__["a" /* default */].result();
  };

  path.projection = function(_) {
    return arguments.length ? (projectionStream = _ == null ? (projection = null, __WEBPACK_IMPORTED_MODULE_0__identity__["a" /* default */]) : (projection = _).stream, path) : projection;
  };

  path.context = function(_) {
    if (!arguments.length) return context;
    contextStream = _ == null ? (context = null, new __WEBPACK_IMPORTED_MODULE_7__string__["a" /* default */]) : new __WEBPACK_IMPORTED_MODULE_5__context__["a" /* default */](context = _);
    if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
    return path;
  };

  path.pointRadius = function(_) {
    if (!arguments.length) return pointRadius;
    pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
    return path;
  };

  return path.projection(projection).context(context);
});


/***/ }),

/***/ "./node_modules/d3-geo/src/path/measure.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adder__ = __webpack_require__("./node_modules/d3-geo/src/adder.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__("./node_modules/d3-geo/src/math.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__noop__ = __webpack_require__("./node_modules/d3-geo/src/noop.js");




var lengthSum = Object(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])(),
    lengthRing,
    x00,
    y00,
    x0,
    y0;

var lengthStream = {
  point: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  lineStart: function() {
    lengthStream.point = lengthPointFirst;
  },
  lineEnd: function() {
    if (lengthRing) lengthPoint(x00, y00);
    lengthStream.point = __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */];
  },
  polygonStart: function() {
    lengthRing = true;
  },
  polygonEnd: function() {
    lengthRing = null;
  },
  result: function() {
    var length = +lengthSum;
    lengthSum.reset();
    return length;
  }
};

function lengthPointFirst(x, y) {
  lengthStream.point = lengthPoint;
  x00 = x0 = x, y00 = y0 = y;
}

function lengthPoint(x, y) {
  x0 -= x, y0 -= y;
  lengthSum.add(Object(__WEBPACK_IMPORTED_MODULE_1__math__["u" /* sqrt */])(x0 * x0 + y0 * y0));
  x0 = x, y0 = y;
}

/* harmony default export */ __webpack_exports__["a"] = (lengthStream);


/***/ }),

/***/ "./node_modules/d3-geo/src/path/string.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PathString;
function PathString() {
  this._string = [];
}

PathString.prototype = {
  _radius: 4.5,
  _circle: circle(4.5),
  pointRadius: function(_) {
    if ((_ = +_) !== this._radius) this._radius = _, this._circle = null;
    return this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line === 0) this._string.push("Z");
    this._point = NaN;
  },
  point: function(x, y) {
    switch (this._point) {
      case 0: {
        this._string.push("M", x, ",", y);
        this._point = 1;
        break;
      }
      case 1: {
        this._string.push("L", x, ",", y);
        break;
      }
      default: {
        if (this._circle == null) this._circle = circle(this._radius);
        this._string.push("M", x, ",", y, this._circle);
        break;
      }
    }
  },
  result: function() {
    if (this._string.length) {
      var result = this._string.join("");
      this._string = [];
      return result;
    } else {
      return null;
    }
  }
};

function circle(radius) {
  return "m0," + radius
      + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius
      + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius
      + "z";
}


/***/ }),

/***/ "./node_modules/d3-geo/src/pointEqual.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__("./node_modules/d3-geo/src/math.js");


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(a[0] - b[0]) < __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */] && Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(a[1] - b[1]) < __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */];
});


/***/ }),

/***/ "./node_modules/d3-geo/src/polygonContains.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adder__ = __webpack_require__("./node_modules/d3-geo/src/adder.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cartesian__ = __webpack_require__("./node_modules/d3-geo/src/cartesian.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__("./node_modules/d3-geo/src/math.js");




var sum = Object(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])();

/* harmony default export */ __webpack_exports__["a"] = (function(polygon, point) {
  var lambda = point[0],
      phi = point[1],
      sinPhi = Object(__WEBPACK_IMPORTED_MODULE_2__math__["t" /* sin */])(phi),
      normal = [Object(__WEBPACK_IMPORTED_MODULE_2__math__["t" /* sin */])(lambda), -Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* cos */])(lambda), 0],
      angle = 0,
      winding = 0;

  sum.reset();

  if (sinPhi === 1) phi = __WEBPACK_IMPORTED_MODULE_2__math__["l" /* halfPi */] + __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */];
  else if (sinPhi === -1) phi = -__WEBPACK_IMPORTED_MODULE_2__math__["l" /* halfPi */] - __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */];

  for (var i = 0, n = polygon.length; i < n; ++i) {
    if (!(m = (ring = polygon[i]).length)) continue;
    var ring,
        m,
        point0 = ring[m - 1],
        lambda0 = point0[0],
        phi0 = point0[1] / 2 + __WEBPACK_IMPORTED_MODULE_2__math__["q" /* quarterPi */],
        sinPhi0 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["t" /* sin */])(phi0),
        cosPhi0 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* cos */])(phi0);

    for (var j = 0; j < m; ++j, lambda0 = lambda1, sinPhi0 = sinPhi1, cosPhi0 = cosPhi1, point0 = point1) {
      var point1 = ring[j],
          lambda1 = point1[0],
          phi1 = point1[1] / 2 + __WEBPACK_IMPORTED_MODULE_2__math__["q" /* quarterPi */],
          sinPhi1 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["t" /* sin */])(phi1),
          cosPhi1 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* cos */])(phi1),
          delta = lambda1 - lambda0,
          sign = delta >= 0 ? 1 : -1,
          absDelta = sign * delta,
          antimeridian = absDelta > __WEBPACK_IMPORTED_MODULE_2__math__["o" /* pi */],
          k = sinPhi0 * sinPhi1;

      sum.add(Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* atan2 */])(k * sign * Object(__WEBPACK_IMPORTED_MODULE_2__math__["t" /* sin */])(absDelta), cosPhi0 * cosPhi1 + k * Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* cos */])(absDelta)));
      angle += antimeridian ? delta + sign * __WEBPACK_IMPORTED_MODULE_2__math__["w" /* tau */] : delta;

      // Are the longitudes either side of the point’s meridian (lambda),
      // and are the latitudes smaller than the parallel (phi)?
      if (antimeridian ^ lambda0 >= lambda ^ lambda1 >= lambda) {
        var arc = Object(__WEBPACK_IMPORTED_MODULE_1__cartesian__["c" /* cartesianCross */])(Object(__WEBPACK_IMPORTED_MODULE_1__cartesian__["a" /* cartesian */])(point0), Object(__WEBPACK_IMPORTED_MODULE_1__cartesian__["a" /* cartesian */])(point1));
        Object(__WEBPACK_IMPORTED_MODULE_1__cartesian__["e" /* cartesianNormalizeInPlace */])(arc);
        var intersection = Object(__WEBPACK_IMPORTED_MODULE_1__cartesian__["c" /* cartesianCross */])(normal, arc);
        Object(__WEBPACK_IMPORTED_MODULE_1__cartesian__["e" /* cartesianNormalizeInPlace */])(intersection);
        var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * Object(__WEBPACK_IMPORTED_MODULE_2__math__["c" /* asin */])(intersection[2]);
        if (phi > phiArc || phi === phiArc && (arc[0] || arc[1])) {
          winding += antimeridian ^ delta >= 0 ? 1 : -1;
        }
      }
    }
  }

  // First, determine whether the South pole is inside or outside:
  //
  // It is inside if:
  // * the polygon winds around it in a clockwise direction.
  // * the polygon does not (cumulatively) wind around it, but has a negative
  //   (counter-clockwise) area.
  //
  // Second, count the (signed) number of times a segment crosses a lambda
  // from the point to the South pole.  If it is zero, then the point is the
  // same side as the South pole.

  return (angle < -__WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */] || angle < __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */] && sum < -__WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */]) ^ (winding & 1);
});


/***/ }),

/***/ "./node_modules/d3-geo/src/projection/albers.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__conicEqualArea__ = __webpack_require__("./node_modules/d3-geo/src/projection/conicEqualArea.js");


/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__conicEqualArea__["b" /* default */])()
      .parallels([29.5, 45.5])
      .scale(1070)
      .translate([480, 250])
      .rotate([96, 0])
      .center([-0.6, 38.7]);
});


/***/ }),

/***/ "./node_modules/d3-geo/src/projection/albersUsa.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__("./node_modules/d3-geo/src/math.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__albers__ = __webpack_require__("./node_modules/d3-geo/src/projection/albers.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__conicEqualArea__ = __webpack_require__("./node_modules/d3-geo/src/projection/conicEqualArea.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fit__ = __webpack_require__("./node_modules/d3-geo/src/projection/fit.js");





// The projections must have mutually exclusive clip regions on the sphere,
// as this will avoid emitting interleaving lines and polygons.
function multiplex(streams) {
  var n = streams.length;
  return {
    point: function(x, y) { var i = -1; while (++i < n) streams[i].point(x, y); },
    sphere: function() { var i = -1; while (++i < n) streams[i].sphere(); },
    lineStart: function() { var i = -1; while (++i < n) streams[i].lineStart(); },
    lineEnd: function() { var i = -1; while (++i < n) streams[i].lineEnd(); },
    polygonStart: function() { var i = -1; while (++i < n) streams[i].polygonStart(); },
    polygonEnd: function() { var i = -1; while (++i < n) streams[i].polygonEnd(); }
  };
}

// A composite projection for the United States, configured by default for
// 960×500. The projection also works quite well at 960×600 if you change the
// scale to 1285 and adjust the translate accordingly. The set of standard
// parallels for each region comes from USGS, which is published here:
// http://egsc.usgs.gov/isb/pubs/MapProjections/projections.html#albers
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var cache,
      cacheStream,
      lower48 = Object(__WEBPACK_IMPORTED_MODULE_1__albers__["a" /* default */])(), lower48Point,
      alaska = Object(__WEBPACK_IMPORTED_MODULE_2__conicEqualArea__["b" /* default */])().rotate([154, 0]).center([-2, 58.5]).parallels([55, 65]), alaskaPoint, // EPSG:3338
      hawaii = Object(__WEBPACK_IMPORTED_MODULE_2__conicEqualArea__["b" /* default */])().rotate([157, 0]).center([-3, 19.9]).parallels([8, 18]), hawaiiPoint, // ESRI:102007
      point, pointStream = {point: function(x, y) { point = [x, y]; }};

  function albersUsa(coordinates) {
    var x = coordinates[0], y = coordinates[1];
    return point = null,
        (lower48Point.point(x, y), point)
        || (alaskaPoint.point(x, y), point)
        || (hawaiiPoint.point(x, y), point);
  }

  albersUsa.invert = function(coordinates) {
    var k = lower48.scale(),
        t = lower48.translate(),
        x = (coordinates[0] - t[0]) / k,
        y = (coordinates[1] - t[1]) / k;
    return (y >= 0.120 && y < 0.234 && x >= -0.425 && x < -0.214 ? alaska
        : y >= 0.166 && y < 0.234 && x >= -0.214 && x < -0.115 ? hawaii
        : lower48).invert(coordinates);
  };

  albersUsa.stream = function(stream) {
    return cache && cacheStream === stream ? cache : cache = multiplex([lower48.stream(cacheStream = stream), alaska.stream(stream), hawaii.stream(stream)]);
  };

  albersUsa.precision = function(_) {
    if (!arguments.length) return lower48.precision();
    lower48.precision(_), alaska.precision(_), hawaii.precision(_);
    return reset();
  };

  albersUsa.scale = function(_) {
    if (!arguments.length) return lower48.scale();
    lower48.scale(_), alaska.scale(_ * 0.35), hawaii.scale(_);
    return albersUsa.translate(lower48.translate());
  };

  albersUsa.translate = function(_) {
    if (!arguments.length) return lower48.translate();
    var k = lower48.scale(), x = +_[0], y = +_[1];

    lower48Point = lower48
        .translate(_)
        .clipExtent([[x - 0.455 * k, y - 0.238 * k], [x + 0.455 * k, y + 0.238 * k]])
        .stream(pointStream);

    alaskaPoint = alaska
        .translate([x - 0.307 * k, y + 0.201 * k])
        .clipExtent([[x - 0.425 * k + __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */], y + 0.120 * k + __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]], [x - 0.214 * k - __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */], y + 0.234 * k - __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]]])
        .stream(pointStream);

    hawaiiPoint = hawaii
        .translate([x - 0.205 * k, y + 0.212 * k])
        .clipExtent([[x - 0.214 * k + __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */], y + 0.166 * k + __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]], [x - 0.115 * k - __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */], y + 0.234 * k - __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]]])
        .stream(pointStream);

    return reset();
  };

  albersUsa.fitExtent = function(extent, object) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__fit__["a" /* fitExtent */])(albersUsa, extent, object);
  };

  albersUsa.fitSize = function(size, object) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__fit__["c" /* fitSize */])(albersUsa, size, object);
  };

  albersUsa.fitWidth = function(width, object) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__fit__["d" /* fitWidth */])(albersUsa, width, object);
  };

  albersUsa.fitHeight = function(height, object) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__fit__["b" /* fitHeight */])(albersUsa, height, object);
  };

  function reset() {
    cache = cacheStream = null;
    return albersUsa;
  }

  return albersUsa.scale(1070);
});


/***/ }),

/***/ "./node_modules/d3-geo/src/projection/azimuthal.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = azimuthalRaw;
/* harmony export (immutable) */ __webpack_exports__["a"] = azimuthalInvert;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__("./node_modules/d3-geo/src/math.js");


function azimuthalRaw(scale) {
  return function(x, y) {
    var cx = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(x),
        cy = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(y),
        k = scale(cx * cy);
    return [
      k * cy * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(x),
      k * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y)
    ];
  }
}

function azimuthalInvert(angle) {
  return function(x, y) {
    var z = Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(x * x + y * y),
        c = angle(z),
        sc = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(c),
        cc = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(c);
    return [
      Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(x * sc, z * cc),
      Object(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* asin */])(z && y * sc / z)
    ];
  }
}


/***/ }),

/***/ "./node_modules/d3-geo/src/projection/azimuthalEqualArea.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return azimuthalEqualAreaRaw; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__("./node_modules/d3-geo/src/math.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azimuthal__ = __webpack_require__("./node_modules/d3-geo/src/projection/azimuthal.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__("./node_modules/d3-geo/src/projection/index.js");




var azimuthalEqualAreaRaw = Object(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["b" /* azimuthalRaw */])(function(cxcy) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(2 / (1 + cxcy));
});

azimuthalEqualAreaRaw.invert = Object(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["a" /* azimuthalInvert */])(function(z) {
  return 2 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* asin */])(z / 2);
});

/* harmony default export */ __webpack_exports__["b"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* default */])(azimuthalEqualAreaRaw)
      .scale(124.75)
      .clipAngle(180 - 1e-3);
});


/***/ }),

/***/ "./node_modules/d3-geo/src/projection/azimuthalEquidistant.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return azimuthalEquidistantRaw; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__("./node_modules/d3-geo/src/math.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azimuthal__ = __webpack_require__("./node_modules/d3-geo/src/projection/azimuthal.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__("./node_modules/d3-geo/src/projection/index.js");




var azimuthalEquidistantRaw = Object(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["b" /* azimuthalRaw */])(function(c) {
  return (c = Object(__WEBPACK_IMPORTED_MODULE_0__math__["b" /* acos */])(c)) && c / Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(c);
});

azimuthalEquidistantRaw.invert = Object(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["a" /* azimuthalInvert */])(function(z) {
  return z;
});

/* harmony default export */ __webpack_exports__["b"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* default */])(azimuthalEquidistantRaw)
      .scale(79.4188)
      .clipAngle(180 - 1e-3);
});


/***/ }),

/***/ "./node_modules/d3-geo/src/projection/conic.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = conicProjection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__("./node_modules/d3-geo/src/math.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__("./node_modules/d3-geo/src/projection/index.js");



function conicProjection(projectAt) {
  var phi0 = 0,
      phi1 = __WEBPACK_IMPORTED_MODULE_0__math__["o" /* pi */] / 3,
      m = Object(__WEBPACK_IMPORTED_MODULE_1__index__["b" /* projectionMutator */])(projectAt),
      p = m(phi0, phi1);

  p.parallels = function(_) {
    return arguments.length ? m(phi0 = _[0] * __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */], phi1 = _[1] * __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */]) : [phi0 * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */], phi1 * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */]];
  };

  return p;
}


/***/ }),

/***/ "./node_modules/d3-geo/src/projection/conicConformal.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = conicConformalRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__("./node_modules/d3-geo/src/math.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__conic__ = __webpack_require__("./node_modules/d3-geo/src/projection/conic.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mercator__ = __webpack_require__("./node_modules/d3-geo/src/projection/mercator.js");




function tany(y) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__math__["v" /* tan */])((__WEBPACK_IMPORTED_MODULE_0__math__["l" /* halfPi */] + y) / 2);
}

function conicConformalRaw(y0, y1) {
  var cy0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(y0),
      n = y0 === y1 ? Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y0) : Object(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* log */])(cy0 / Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(y1)) / Object(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* log */])(tany(y1) / tany(y0)),
      f = cy0 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["p" /* pow */])(tany(y0), n) / n;

  if (!n) return __WEBPACK_IMPORTED_MODULE_2__mercator__["c" /* mercatorRaw */];

  function project(x, y) {
    if (f > 0) { if (y < -__WEBPACK_IMPORTED_MODULE_0__math__["l" /* halfPi */] + __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]) y = -__WEBPACK_IMPORTED_MODULE_0__math__["l" /* halfPi */] + __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]; }
    else { if (y > __WEBPACK_IMPORTED_MODULE_0__math__["l" /* halfPi */] - __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]) y = __WEBPACK_IMPORTED_MODULE_0__math__["l" /* halfPi */] - __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]; }
    var r = f / Object(__WEBPACK_IMPORTED_MODULE_0__math__["p" /* pow */])(tany(y), n);
    return [r * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(n * x), f - r * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(n * x)];
  }

  project.invert = function(x, y) {
    var fy = f - y, r = Object(__WEBPACK_IMPORTED_MODULE_0__math__["s" /* sign */])(n) * Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(x * x + fy * fy);
    return [Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(x, Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(fy)) / n * Object(__WEBPACK_IMPORTED_MODULE_0__math__["s" /* sign */])(fy), 2 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* atan */])(Object(__WEBPACK_IMPORTED_MODULE_0__math__["p" /* pow */])(f / r, 1 / n)) - __WEBPACK_IMPORTED_MODULE_0__math__["l" /* halfPi */]];
  };

  return project;
}

/* harmony default export */ __webpack_exports__["b"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_1__conic__["a" /* conicProjection */])(conicConformalRaw)
      .scale(109.5)
      .parallels([30, 30]);
});


/***/ }),

/***/ "./node_modules/d3-geo/src/projection/conicEqualArea.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = conicEqualAreaRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__("./node_modules/d3-geo/src/math.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__conic__ = __webpack_require__("./node_modules/d3-geo/src/projection/conic.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cylindricalEqualArea__ = __webpack_require__("./node_modules/d3-geo/src/projection/cylindricalEqualArea.js");




function conicEqualAreaRaw(y0, y1) {
  var sy0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y0), n = (sy0 + Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y1)) / 2;

  // Are the parallels symmetrical around the Equator?
  if (Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(n) < __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]) return Object(__WEBPACK_IMPORTED_MODULE_2__cylindricalEqualArea__["a" /* cylindricalEqualAreaRaw */])(y0);

  var c = 1 + sy0 * (2 * n - sy0), r0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(c) / n;

  function project(x, y) {
    var r = Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(c - 2 * n * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y)) / n;
    return [r * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(x *= n), r0 - r * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(x)];
  }

  project.invert = function(x, y) {
    var r0y = r0 - y;
    return [Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(x, Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(r0y)) / n * Object(__WEBPACK_IMPORTED_MODULE_0__math__["s" /* sign */])(r0y), Object(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* asin */])((c - (x * x + r0y * r0y) * n * n) / (2 * n))];
  };

  return project;
}

/* harmony default export */ __webpack_exports__["b"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_1__conic__["a" /* conicProjection */])(conicEqualAreaRaw)
      .scale(155.424)
      .center([0, 33.6442]);
});


/***/ }),

/***/ "./node_modules/d3-geo/src/projection/conicEquidistant.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = conicEquidistantRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__("./node_modules/d3-geo/src/math.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__conic__ = __webpack_require__("./node_modules/d3-geo/src/projection/conic.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__equirectangular__ = __webpack_require__("./node_modules/d3-geo/src/projection/equirectangular.js");




function conicEquidistantRaw(y0, y1) {
  var cy0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(y0),
      n = y0 === y1 ? Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y0) : (cy0 - Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(y1)) / (y1 - y0),
      g = cy0 / n + y0;

  if (Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(n) < __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]) return __WEBPACK_IMPORTED_MODULE_2__equirectangular__["b" /* equirectangularRaw */];

  function project(x, y) {
    var gy = g - y, nx = n * x;
    return [gy * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(nx), g - gy * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(nx)];
  }

  project.invert = function(x, y) {
    var gy = g - y;
    return [Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(x, Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(gy)) / n * Object(__WEBPACK_IMPORTED_MODULE_0__math__["s" /* sign */])(gy), g - Object(__WEBPACK_IMPORTED_MODULE_0__math__["s" /* sign */])(n) * Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(x * x + gy * gy)];
  };

  return project;
}

/* harmony default export */ __webpack_exports__["b"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_1__conic__["a" /* conicProjection */])(conicEquidistantRaw)
      .scale(131.154)
      .center([0, 13.9389]);
});


/***/ }),

/***/ "./node_modules/d3-geo/src/projection/cylindricalEqualArea.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cylindricalEqualAreaRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__("./node_modules/d3-geo/src/math.js");


function cylindricalEqualAreaRaw(phi0) {
  var cosPhi0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(phi0);

  function forward(lambda, phi) {
    return [lambda * cosPhi0, Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(phi) / cosPhi0];
  }

  forward.invert = function(x, y) {
    return [x / cosPhi0, Object(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* asin */])(y * cosPhi0)];
  };

  return forward;
}


/***/ }),

/***/ "./node_modules/d3-geo/src/projection/equalEarth.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = equalEarthRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_js__ = __webpack_require__("./node_modules/d3-geo/src/projection/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math_js__ = __webpack_require__("./node_modules/d3-geo/src/math.js");



var A1 = 1.340264,
    A2 = -0.081106,
    A3 = 0.000893,
    A4 = 0.003796,
    M = Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["u" /* sqrt */])(3) / 2,
    iterations = 12;

function equalEarthRaw(lambda, phi) {
  var l = Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["c" /* asin */])(M * Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["t" /* sin */])(phi)), l2 = l * l, l6 = l2 * l2 * l2;
  return [
    lambda * Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["g" /* cos */])(l) / (M * (A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2))),
    l * (A1 + A2 * l2 + l6 * (A3 + A4 * l2))
  ];
}

equalEarthRaw.invert = function(x, y) {
  var l = y, l2 = l * l, l6 = l2 * l2 * l2;
  for (var i = 0, delta, fy, fpy; i < iterations; ++i) {
    fy = l * (A1 + A2 * l2 + l6 * (A3 + A4 * l2)) - y;
    fpy = A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2);
    l -= delta = fy / fpy, l2 = l * l, l6 = l2 * l2 * l2;
    if (Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["a" /* abs */])(delta) < __WEBPACK_IMPORTED_MODULE_1__math_js__["j" /* epsilon2 */]) break;
  }
  return [
    M * x * (A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2)) / Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["g" /* cos */])(l),
    Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["c" /* asin */])(Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["t" /* sin */])(l) / M)
  ];
};

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__index_js__["a" /* default */])(equalEarthRaw)
      .scale(177.158);
});


/***/ }),

/***/ "./node_modules/d3-geo/src/projection/equirectangular.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = equirectangularRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__("./node_modules/d3-geo/src/projection/index.js");


function equirectangularRaw(lambda, phi) {
  return [lambda, phi];
}

equirectangularRaw.invert = equirectangularRaw;

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])(equirectangularRaw)
      .scale(152.63);
});


/***/ }),

/***/ "./node_modules/d3-geo/src/projection/fit.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fitExtent;
/* harmony export (immutable) */ __webpack_exports__["c"] = fitSize;
/* harmony export (immutable) */ __webpack_exports__["d"] = fitWidth;
/* harmony export (immutable) */ __webpack_exports__["b"] = fitHeight;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stream__ = __webpack_require__("./node_modules/d3-geo/src/stream.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__path_bounds__ = __webpack_require__("./node_modules/d3-geo/src/path/bounds.js");



function fit(projection, fitBounds, object) {
  var clip = projection.clipExtent && projection.clipExtent();
  projection.scale(150).translate([0, 0]);
  if (clip != null) projection.clipExtent(null);
  Object(__WEBPACK_IMPORTED_MODULE_0__stream__["a" /* default */])(object, projection.stream(__WEBPACK_IMPORTED_MODULE_1__path_bounds__["a" /* default */]));
  fitBounds(__WEBPACK_IMPORTED_MODULE_1__path_bounds__["a" /* default */].result());
  if (clip != null) projection.clipExtent(clip);
  return projection;
}

function fitExtent(projection, extent, object) {
  return fit(projection, function(b) {
    var w = extent[1][0] - extent[0][0],
        h = extent[1][1] - extent[0][1],
        k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1])),
        x = +extent[0][0] + (w - k * (b[1][0] + b[0][0])) / 2,
        y = +extent[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;
    projection.scale(150 * k).translate([x, y]);
  }, object);
}

function fitSize(projection, size, object) {
  return fitExtent(projection, [[0, 0], size], object);
}

function fitWidth(projection, width, object) {
  return fit(projection, function(b) {
    var w = +width,
        k = w / (b[1][0] - b[0][0]),
        x = (w - k * (b[1][0] + b[0][0])) / 2,
        y = -k * b[0][1];
    projection.scale(150 * k).translate([x, y]);
  }, object);
}

function fitHeight(projection, height, object) {
  return fit(projection, function(b) {
    var h = +height,
        k = h / (b[1][1] - b[0][1]),
        x = -k * b[0][0],
        y = (h - k * (b[1][1] + b[0][1])) / 2;
    projection.scale(150 * k).translate([x, y]);
  }, object);
}


/***/ }),

/***/ "./node_modules/d3-geo/src/projection/gnomonic.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = gnomonicRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__("./node_modules/d3-geo/src/math.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azimuthal__ = __webpack_require__("./node_modules/d3-geo/src/projection/azimuthal.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__("./node_modules/d3-geo/src/projection/index.js");




function gnomonicRaw(x, y) {
  var cy = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(y), k = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(x) * cy;
  return [cy * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(x) / k, Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y) / k];
}

gnomonicRaw.invert = Object(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["a" /* azimuthalInvert */])(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* atan */]);

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* default */])(gnomonicRaw)
      .scale(144.049)
      .clipAngle(60);
});


/***/ }),

/***/ "./node_modules/d3-geo/src/projection/identity.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__clip_rectangle__ = __webpack_require__("./node_modules/d3-geo/src/clip/rectangle.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__identity__ = __webpack_require__("./node_modules/d3-geo/src/identity.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__transform__ = __webpack_require__("./node_modules/d3-geo/src/transform.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fit__ = __webpack_require__("./node_modules/d3-geo/src/projection/fit.js");





function scaleTranslate(kx, ky, tx, ty) {
  return kx === 1 && ky === 1 && tx === 0 && ty === 0 ? __WEBPACK_IMPORTED_MODULE_1__identity__["a" /* default */] : Object(__WEBPACK_IMPORTED_MODULE_2__transform__["b" /* transformer */])({
    point: function(x, y) {
      this.stream.point(x * kx + tx, y * ky + ty);
    }
  });
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var k = 1, tx = 0, ty = 0, sx = 1, sy = 1, transform = __WEBPACK_IMPORTED_MODULE_1__identity__["a" /* default */], // scale, translate and reflect
      x0 = null, y0, x1, y1, // clip extent
      postclip = __WEBPACK_IMPORTED_MODULE_1__identity__["a" /* default */],
      cache,
      cacheStream,
      projection;

  function reset() {
    cache = cacheStream = null;
    return projection;
  }

  return projection = {
    stream: function(stream) {
      return cache && cacheStream === stream ? cache : cache = transform(postclip(cacheStream = stream));
    },
    postclip: function(_) {
      return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
    },
    clipExtent: function(_) {
      return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, __WEBPACK_IMPORTED_MODULE_1__identity__["a" /* default */]) : Object(__WEBPACK_IMPORTED_MODULE_0__clip_rectangle__["a" /* default */])(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
    },
    scale: function(_) {
      return arguments.length ? (transform = scaleTranslate((k = +_) * sx, k * sy, tx, ty), reset()) : k;
    },
    translate: function(_) {
      return arguments.length ? (transform = scaleTranslate(k * sx, k * sy, tx = +_[0], ty = +_[1]), reset()) : [tx, ty];
    },
    reflectX: function(_) {
      return arguments.length ? (transform = scaleTranslate(k * (sx = _ ? -1 : 1), k * sy, tx, ty), reset()) : sx < 0;
    },
    reflectY: function(_) {
      return arguments.length ? (transform = scaleTranslate(k * sx, k * (sy = _ ? -1 : 1), tx, ty), reset()) : sy < 0;
    },
    fitExtent: function(extent, object) {
      return Object(__WEBPACK_IMPORTED_MODULE_3__fit__["a" /* fitExtent */])(projection, extent, object);
    },
    fitSize: function(size, object) {
      return Object(__WEBPACK_IMPORTED_MODULE_3__fit__["c" /* fitSize */])(projection, size, object);
    },
    fitWidth: function(width, object) {
      return Object(__WEBPACK_IMPORTED_MODULE_3__fit__["d" /* fitWidth */])(projection, width, object);
    },
    fitHeight: function(height, object) {
      return Object(__WEBPACK_IMPORTED_MODULE_3__fit__["b" /* fitHeight */])(projection, height, object);
    }
  };
});


/***/ }),

/***/ "./node_modules/d3-geo/src/projection/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = projection;
/* harmony export (immutable) */ __webpack_exports__["b"] = projectionMutator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__clip_antimeridian__ = __webpack_require__("./node_modules/d3-geo/src/clip/antimeridian.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__clip_circle__ = __webpack_require__("./node_modules/d3-geo/src/clip/circle.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__clip_rectangle__ = __webpack_require__("./node_modules/d3-geo/src/clip/rectangle.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__compose__ = __webpack_require__("./node_modules/d3-geo/src/compose.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__identity__ = __webpack_require__("./node_modules/d3-geo/src/identity.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__math__ = __webpack_require__("./node_modules/d3-geo/src/math.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rotation__ = __webpack_require__("./node_modules/d3-geo/src/rotation.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__transform__ = __webpack_require__("./node_modules/d3-geo/src/transform.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fit__ = __webpack_require__("./node_modules/d3-geo/src/projection/fit.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__resample__ = __webpack_require__("./node_modules/d3-geo/src/projection/resample.js");











var transformRadians = Object(__WEBPACK_IMPORTED_MODULE_7__transform__["b" /* transformer */])({
  point: function(x, y) {
    this.stream.point(x * __WEBPACK_IMPORTED_MODULE_5__math__["r" /* radians */], y * __WEBPACK_IMPORTED_MODULE_5__math__["r" /* radians */]);
  }
});

function transformRotate(rotate) {
  return Object(__WEBPACK_IMPORTED_MODULE_7__transform__["b" /* transformer */])({
    point: function(x, y) {
      var r = rotate(x, y);
      return this.stream.point(r[0], r[1]);
    }
  });
}

function scaleTranslate(k, dx, dy) {
  function transform(x, y) {
    return [dx + k * x, dy - k * y];
  }
  transform.invert = function(x, y) {
    return [(x - dx) / k, (dy - y) / k];
  };
  return transform;
}

function scaleTranslateRotate(k, dx, dy, alpha) {
  var cosAlpha = Object(__WEBPACK_IMPORTED_MODULE_5__math__["g" /* cos */])(alpha),
      sinAlpha = Object(__WEBPACK_IMPORTED_MODULE_5__math__["t" /* sin */])(alpha),
      a = cosAlpha * k,
      b = sinAlpha * k,
      ai = cosAlpha / k,
      bi = sinAlpha / k,
      ci = (sinAlpha * dy - cosAlpha * dx) / k,
      fi = (sinAlpha * dx + cosAlpha * dy) / k;
  function transform(x, y) {
    return [a * x - b * y + dx, dy - b * x - a * y];
  }
  transform.invert = function(x, y) {
    return [ai * x - bi * y + ci, fi - bi * x - ai * y];
  };
  return transform;
}

function projection(project) {
  return projectionMutator(function() { return project; })();
}

function projectionMutator(projectAt) {
  var project,
      k = 150, // scale
      x = 480, y = 250, // translate
      lambda = 0, phi = 0, // center
      deltaLambda = 0, deltaPhi = 0, deltaGamma = 0, rotate, // pre-rotate
      alpha = 0, // post-rotate
      theta = null, preclip = __WEBPACK_IMPORTED_MODULE_0__clip_antimeridian__["a" /* default */], // pre-clip angle
      x0 = null, y0, x1, y1, postclip = __WEBPACK_IMPORTED_MODULE_4__identity__["a" /* default */], // post-clip extent
      delta2 = 0.5, // precision
      projectResample,
      projectTransform,
      projectRotateTransform,
      cache,
      cacheStream;

  function projection(point) {
    return projectRotateTransform(point[0] * __WEBPACK_IMPORTED_MODULE_5__math__["r" /* radians */], point[1] * __WEBPACK_IMPORTED_MODULE_5__math__["r" /* radians */]);
  }

  function invert(point) {
    point = projectRotateTransform.invert(point[0], point[1]);
    return point && [point[0] * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */], point[1] * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */]];
  }

  projection.stream = function(stream) {
    return cache && cacheStream === stream ? cache : cache = transformRadians(transformRotate(rotate)(preclip(projectResample(postclip(cacheStream = stream)))));
  };

  projection.preclip = function(_) {
    return arguments.length ? (preclip = _, theta = undefined, reset()) : preclip;
  };

  projection.postclip = function(_) {
    return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
  };

  projection.clipAngle = function(_) {
    return arguments.length ? (preclip = +_ ? Object(__WEBPACK_IMPORTED_MODULE_1__clip_circle__["a" /* default */])(theta = _ * __WEBPACK_IMPORTED_MODULE_5__math__["r" /* radians */]) : (theta = null, __WEBPACK_IMPORTED_MODULE_0__clip_antimeridian__["a" /* default */]), reset()) : theta * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */];
  };

  projection.clipExtent = function(_) {
    return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, __WEBPACK_IMPORTED_MODULE_4__identity__["a" /* default */]) : Object(__WEBPACK_IMPORTED_MODULE_2__clip_rectangle__["a" /* default */])(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
  };

  projection.scale = function(_) {
    return arguments.length ? (k = +_, recenter()) : k;
  };

  projection.translate = function(_) {
    return arguments.length ? (x = +_[0], y = +_[1], recenter()) : [x, y];
  };

  projection.center = function(_) {
    return arguments.length ? (lambda = _[0] % 360 * __WEBPACK_IMPORTED_MODULE_5__math__["r" /* radians */], phi = _[1] % 360 * __WEBPACK_IMPORTED_MODULE_5__math__["r" /* radians */], recenter()) : [lambda * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */], phi * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */]];
  };

  projection.rotate = function(_) {
    return arguments.length ? (deltaLambda = _[0] % 360 * __WEBPACK_IMPORTED_MODULE_5__math__["r" /* radians */], deltaPhi = _[1] % 360 * __WEBPACK_IMPORTED_MODULE_5__math__["r" /* radians */], deltaGamma = _.length > 2 ? _[2] % 360 * __WEBPACK_IMPORTED_MODULE_5__math__["r" /* radians */] : 0, recenter()) : [deltaLambda * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */], deltaPhi * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */], deltaGamma * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */]];
  };

  projection.angle = function(_) {
    return arguments.length ? (alpha = _ % 360 * __WEBPACK_IMPORTED_MODULE_5__math__["r" /* radians */], recenter()) : alpha * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */];
  };

  projection.precision = function(_) {
    return arguments.length ? (projectResample = Object(__WEBPACK_IMPORTED_MODULE_9__resample__["a" /* default */])(projectTransform, delta2 = _ * _), reset()) : Object(__WEBPACK_IMPORTED_MODULE_5__math__["u" /* sqrt */])(delta2);
  };

  projection.fitExtent = function(extent, object) {
    return Object(__WEBPACK_IMPORTED_MODULE_8__fit__["a" /* fitExtent */])(projection, extent, object);
  };

  projection.fitSize = function(size, object) {
    return Object(__WEBPACK_IMPORTED_MODULE_8__fit__["c" /* fitSize */])(projection, size, object);
  };

  projection.fitWidth = function(width, object) {
    return Object(__WEBPACK_IMPORTED_MODULE_8__fit__["d" /* fitWidth */])(projection, width, object);
  };

  projection.fitHeight = function(height, object) {
    return Object(__WEBPACK_IMPORTED_MODULE_8__fit__["b" /* fitHeight */])(projection, height, object);
  };

  function recenter() {
    var center = scaleTranslateRotate(k, 0, 0, alpha).apply(null, project(lambda, phi)),
        transform = (alpha ? scaleTranslateRotate : scaleTranslate)(k, x - center[0], y - center[1], alpha);
    rotate = Object(__WEBPACK_IMPORTED_MODULE_6__rotation__["b" /* rotateRadians */])(deltaLambda, deltaPhi, deltaGamma);
    projectTransform = Object(__WEBPACK_IMPORTED_MODULE_3__compose__["a" /* default */])(project, transform);
    projectRotateTransform = Object(__WEBPACK_IMPORTED_MODULE_3__compose__["a" /* default */])(rotate, projectTransform);
    projectResample = Object(__WEBPACK_IMPORTED_MODULE_9__resample__["a" /* default */])(projectTransform, delta2);
    return reset();
  }

  function reset() {
    cache = cacheStream = null;
    return projection;
  }

  return function() {
    project = projectAt.apply(this, arguments);
    projection.invert = project.invert && invert;
    return recenter();
  };
}


/***/ }),

/***/ "./node_modules/d3-geo/src/projection/mercator.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = mercatorRaw;
/* harmony export (immutable) */ __webpack_exports__["b"] = mercatorProjection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__("./node_modules/d3-geo/src/math.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rotation__ = __webpack_require__("./node_modules/d3-geo/src/rotation.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__("./node_modules/d3-geo/src/projection/index.js");




function mercatorRaw(lambda, phi) {
  return [lambda, Object(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* log */])(Object(__WEBPACK_IMPORTED_MODULE_0__math__["v" /* tan */])((__WEBPACK_IMPORTED_MODULE_0__math__["l" /* halfPi */] + phi) / 2))];
}

mercatorRaw.invert = function(x, y) {
  return [x, 2 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* atan */])(Object(__WEBPACK_IMPORTED_MODULE_0__math__["k" /* exp */])(y)) - __WEBPACK_IMPORTED_MODULE_0__math__["l" /* halfPi */]];
};

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return mercatorProjection(mercatorRaw)
      .scale(961 / __WEBPACK_IMPORTED_MODULE_0__math__["w" /* tau */]);
});

function mercatorProjection(project) {
  var m = Object(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* default */])(project),
      center = m.center,
      scale = m.scale,
      translate = m.translate,
      clipExtent = m.clipExtent,
      x0 = null, y0, x1, y1; // clip extent

  m.scale = function(_) {
    return arguments.length ? (scale(_), reclip()) : scale();
  };

  m.translate = function(_) {
    return arguments.length ? (translate(_), reclip()) : translate();
  };

  m.center = function(_) {
    return arguments.length ? (center(_), reclip()) : center();
  };

  m.clipExtent = function(_) {
    return arguments.length ? ((_ == null ? x0 = y0 = x1 = y1 = null : (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1])), reclip()) : x0 == null ? null : [[x0, y0], [x1, y1]];
  };

  function reclip() {
    var k = __WEBPACK_IMPORTED_MODULE_0__math__["o" /* pi */] * scale(),
        t = m(Object(__WEBPACK_IMPORTED_MODULE_1__rotation__["a" /* default */])(m.rotate()).invert([0, 0]));
    return clipExtent(x0 == null
        ? [[t[0] - k, t[1] - k], [t[0] + k, t[1] + k]] : project === mercatorRaw
        ? [[Math.max(t[0] - k, x0), y0], [Math.min(t[0] + k, x1), y1]]
        : [[x0, Math.max(t[1] - k, y0)], [x1, Math.min(t[1] + k, y1)]]);
  }

  return reclip();
}


/***/ }),

/***/ "./node_modules/d3-geo/src/projection/naturalEarth1.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = naturalEarth1Raw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__("./node_modules/d3-geo/src/projection/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__("./node_modules/d3-geo/src/math.js");



function naturalEarth1Raw(lambda, phi) {
  var phi2 = phi * phi, phi4 = phi2 * phi2;
  return [
    lambda * (0.8707 - 0.131979 * phi2 + phi4 * (-0.013791 + phi4 * (0.003971 * phi2 - 0.001529 * phi4))),
    phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4)))
  ];
}

naturalEarth1Raw.invert = function(x, y) {
  var phi = y, i = 25, delta;
  do {
    var phi2 = phi * phi, phi4 = phi2 * phi2;
    phi -= delta = (phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4))) - y) /
        (1.007226 + phi2 * (0.015085 * 3 + phi4 * (-0.044475 * 7 + 0.028874 * 9 * phi2 - 0.005916 * 11 * phi4)));
  } while (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(delta) > __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */] && --i > 0);
  return [
    x / (0.8707 + (phi2 = phi * phi) * (-0.131979 + phi2 * (-0.013791 + phi2 * phi2 * phi2 * (0.003971 - 0.001529 * phi2)))),
    phi
  ];
};

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])(naturalEarth1Raw)
      .scale(175.295);
});


/***/ }),

/***/ "./node_modules/d3-geo/src/projection/orthographic.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = orthographicRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__("./node_modules/d3-geo/src/math.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azimuthal__ = __webpack_require__("./node_modules/d3-geo/src/projection/azimuthal.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__("./node_modules/d3-geo/src/projection/index.js");




function orthographicRaw(x, y) {
  return [Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(y) * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(x), Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y)];
}

orthographicRaw.invert = Object(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["a" /* azimuthalInvert */])(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* asin */]);

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* default */])(orthographicRaw)
      .scale(249.5)
      .clipAngle(90 + __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]);
});


/***/ }),

/***/ "./node_modules/d3-geo/src/projection/resample.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cartesian__ = __webpack_require__("./node_modules/d3-geo/src/cartesian.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__("./node_modules/d3-geo/src/math.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__transform__ = __webpack_require__("./node_modules/d3-geo/src/transform.js");




var maxDepth = 16, // maximum depth of subdivision
    cosMinDistance = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(30 * __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */]); // cos(minimum angular distance)

/* harmony default export */ __webpack_exports__["a"] = (function(project, delta2) {
  return +delta2 ? resample(project, delta2) : resampleNone(project);
});

function resampleNone(project) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__transform__["b" /* transformer */])({
    point: function(x, y) {
      x = project(x, y);
      this.stream.point(x[0], x[1]);
    }
  });
}

function resample(project, delta2) {

  function resampleLineTo(x0, y0, lambda0, a0, b0, c0, x1, y1, lambda1, a1, b1, c1, depth, stream) {
    var dx = x1 - x0,
        dy = y1 - y0,
        d2 = dx * dx + dy * dy;
    if (d2 > 4 * delta2 && depth--) {
      var a = a0 + a1,
          b = b0 + b1,
          c = c0 + c1,
          m = Object(__WEBPACK_IMPORTED_MODULE_1__math__["u" /* sqrt */])(a * a + b * b + c * c),
          phi2 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* asin */])(c /= m),
          lambda2 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(c) - 1) < __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */] || Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(lambda0 - lambda1) < __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */] ? (lambda0 + lambda1) / 2 : Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* atan2 */])(b, a),
          p = project(lambda2, phi2),
          x2 = p[0],
          y2 = p[1],
          dx2 = x2 - x0,
          dy2 = y2 - y0,
          dz = dy * dx2 - dx * dy2;
      if (dz * dz / d2 > delta2 // perpendicular projected distance
          || Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 // midpoint close to an end
          || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) { // angular distance
        resampleLineTo(x0, y0, lambda0, a0, b0, c0, x2, y2, lambda2, a /= m, b /= m, c, depth, stream);
        stream.point(x2, y2);
        resampleLineTo(x2, y2, lambda2, a, b, c, x1, y1, lambda1, a1, b1, c1, depth, stream);
      }
    }
  }
  return function(stream) {
    var lambda00, x00, y00, a00, b00, c00, // first point
        lambda0, x0, y0, a0, b0, c0; // previous point

    var resampleStream = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: function() { stream.polygonStart(); resampleStream.lineStart = ringStart; },
      polygonEnd: function() { stream.polygonEnd(); resampleStream.lineStart = lineStart; }
    };

    function point(x, y) {
      x = project(x, y);
      stream.point(x[0], x[1]);
    }

    function lineStart() {
      x0 = NaN;
      resampleStream.point = linePoint;
      stream.lineStart();
    }

    function linePoint(lambda, phi) {
      var c = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["a" /* cartesian */])([lambda, phi]), p = project(lambda, phi);
      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x0 = p[0], y0 = p[1], lambda0 = lambda, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
      stream.point(x0, y0);
    }

    function lineEnd() {
      resampleStream.point = point;
      stream.lineEnd();
    }

    function ringStart() {
      lineStart();
      resampleStream.point = ringPoint;
      resampleStream.lineEnd = ringEnd;
    }

    function ringPoint(lambda, phi) {
      linePoint(lambda00 = lambda, phi), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
      resampleStream.point = linePoint;
    }

    function ringEnd() {
      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x00, y00, lambda00, a00, b00, c00, maxDepth, stream);
      resampleStream.lineEnd = lineEnd;
      lineEnd();
    }

    return resampleStream;
  };
}


/***/ }),

/***/ "./node_modules/d3-geo/src/projection/stereographic.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = stereographicRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__("./node_modules/d3-geo/src/math.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azimuthal__ = __webpack_require__("./node_modules/d3-geo/src/projection/azimuthal.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__("./node_modules/d3-geo/src/projection/index.js");




function stereographicRaw(x, y) {
  var cy = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(y), k = 1 + Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(x) * cy;
  return [cy * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(x) / k, Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y) / k];
}

stereographicRaw.invert = Object(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["a" /* azimuthalInvert */])(function(z) {
  return 2 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* atan */])(z);
});

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* default */])(stereographicRaw)
      .scale(250)
      .clipAngle(142);
});


/***/ }),

/***/ "./node_modules/d3-geo/src/projection/transverseMercator.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = transverseMercatorRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__("./node_modules/d3-geo/src/math.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mercator__ = __webpack_require__("./node_modules/d3-geo/src/projection/mercator.js");



function transverseMercatorRaw(lambda, phi) {
  return [Object(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* log */])(Object(__WEBPACK_IMPORTED_MODULE_0__math__["v" /* tan */])((__WEBPACK_IMPORTED_MODULE_0__math__["l" /* halfPi */] + phi) / 2)), -lambda];
}

transverseMercatorRaw.invert = function(x, y) {
  return [-y, 2 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* atan */])(Object(__WEBPACK_IMPORTED_MODULE_0__math__["k" /* exp */])(x)) - __WEBPACK_IMPORTED_MODULE_0__math__["l" /* halfPi */]];
};

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var m = Object(__WEBPACK_IMPORTED_MODULE_1__mercator__["b" /* mercatorProjection */])(transverseMercatorRaw),
      center = m.center,
      rotate = m.rotate;

  m.center = function(_) {
    return arguments.length ? center([-_[1], _[0]]) : (_ = center(), [_[1], -_[0]]);
  };

  m.rotate = function(_) {
    return arguments.length ? rotate([_[0], _[1], _.length > 2 ? _[2] + 90 : 90]) : (_ = rotate(), [_[0], _[1], _[2] - 90]);
  };

  return rotate([0, 0, 90])
      .scale(159.155);
});


/***/ }),

/***/ "./node_modules/d3-geo/src/rotation.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = rotateRadians;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__("./node_modules/d3-geo/src/compose.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__("./node_modules/d3-geo/src/math.js");



function rotationIdentity(lambda, phi) {
  return [Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(lambda) > __WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */] ? lambda + Math.round(-lambda / __WEBPACK_IMPORTED_MODULE_1__math__["w" /* tau */]) * __WEBPACK_IMPORTED_MODULE_1__math__["w" /* tau */] : lambda, phi];
}

rotationIdentity.invert = rotationIdentity;

function rotateRadians(deltaLambda, deltaPhi, deltaGamma) {
  return (deltaLambda %= __WEBPACK_IMPORTED_MODULE_1__math__["w" /* tau */]) ? (deltaPhi || deltaGamma ? Object(__WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */])(rotationLambda(deltaLambda), rotationPhiGamma(deltaPhi, deltaGamma))
    : rotationLambda(deltaLambda))
    : (deltaPhi || deltaGamma ? rotationPhiGamma(deltaPhi, deltaGamma)
    : rotationIdentity);
}

function forwardRotationLambda(deltaLambda) {
  return function(lambda, phi) {
    return lambda += deltaLambda, [lambda > __WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */] ? lambda - __WEBPACK_IMPORTED_MODULE_1__math__["w" /* tau */] : lambda < -__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */] ? lambda + __WEBPACK_IMPORTED_MODULE_1__math__["w" /* tau */] : lambda, phi];
  };
}

function rotationLambda(deltaLambda) {
  var rotation = forwardRotationLambda(deltaLambda);
  rotation.invert = forwardRotationLambda(-deltaLambda);
  return rotation;
}

function rotationPhiGamma(deltaPhi, deltaGamma) {
  var cosDeltaPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(deltaPhi),
      sinDeltaPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(deltaPhi),
      cosDeltaGamma = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(deltaGamma),
      sinDeltaGamma = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(deltaGamma);

  function rotation(lambda, phi) {
    var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(phi),
        x = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(lambda) * cosPhi,
        y = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(lambda) * cosPhi,
        z = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(phi),
        k = z * cosDeltaPhi + x * sinDeltaPhi;
    return [
      Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* atan2 */])(y * cosDeltaGamma - k * sinDeltaGamma, x * cosDeltaPhi - z * sinDeltaPhi),
      Object(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* asin */])(k * cosDeltaGamma + y * sinDeltaGamma)
    ];
  }

  rotation.invert = function(lambda, phi) {
    var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(phi),
        x = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(lambda) * cosPhi,
        y = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(lambda) * cosPhi,
        z = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(phi),
        k = z * cosDeltaGamma - y * sinDeltaGamma;
    return [
      Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* atan2 */])(y * cosDeltaGamma + z * sinDeltaGamma, x * cosDeltaPhi + k * sinDeltaPhi),
      Object(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* asin */])(k * cosDeltaPhi - x * sinDeltaPhi)
    ];
  };

  return rotation;
}

/* harmony default export */ __webpack_exports__["a"] = (function(rotate) {
  rotate = rotateRadians(rotate[0] * __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */], rotate[1] * __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */], rotate.length > 2 ? rotate[2] * __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */] : 0);

  function forward(coordinates) {
    coordinates = rotate(coordinates[0] * __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */], coordinates[1] * __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */]);
    return coordinates[0] *= __WEBPACK_IMPORTED_MODULE_1__math__["h" /* degrees */], coordinates[1] *= __WEBPACK_IMPORTED_MODULE_1__math__["h" /* degrees */], coordinates;
  }

  forward.invert = function(coordinates) {
    coordinates = rotate.invert(coordinates[0] * __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */], coordinates[1] * __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */]);
    return coordinates[0] *= __WEBPACK_IMPORTED_MODULE_1__math__["h" /* degrees */], coordinates[1] *= __WEBPACK_IMPORTED_MODULE_1__math__["h" /* degrees */], coordinates;
  };

  return forward;
});


/***/ }),

/***/ "./node_modules/d3-geo/src/stream.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function streamGeometry(geometry, stream) {
  if (geometry && streamGeometryType.hasOwnProperty(geometry.type)) {
    streamGeometryType[geometry.type](geometry, stream);
  }
}

var streamObjectType = {
  Feature: function(object, stream) {
    streamGeometry(object.geometry, stream);
  },
  FeatureCollection: function(object, stream) {
    var features = object.features, i = -1, n = features.length;
    while (++i < n) streamGeometry(features[i].geometry, stream);
  }
};

var streamGeometryType = {
  Sphere: function(object, stream) {
    stream.sphere();
  },
  Point: function(object, stream) {
    object = object.coordinates;
    stream.point(object[0], object[1], object[2]);
  },
  MultiPoint: function(object, stream) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) object = coordinates[i], stream.point(object[0], object[1], object[2]);
  },
  LineString: function(object, stream) {
    streamLine(object.coordinates, stream, 0);
  },
  MultiLineString: function(object, stream) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) streamLine(coordinates[i], stream, 0);
  },
  Polygon: function(object, stream) {
    streamPolygon(object.coordinates, stream);
  },
  MultiPolygon: function(object, stream) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) streamPolygon(coordinates[i], stream);
  },
  GeometryCollection: function(object, stream) {
    var geometries = object.geometries, i = -1, n = geometries.length;
    while (++i < n) streamGeometry(geometries[i], stream);
  }
};

function streamLine(coordinates, stream, closed) {
  var i = -1, n = coordinates.length - closed, coordinate;
  stream.lineStart();
  while (++i < n) coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
  stream.lineEnd();
}

function streamPolygon(coordinates, stream) {
  var i = -1, n = coordinates.length;
  stream.polygonStart();
  while (++i < n) streamLine(coordinates[i], stream, 1);
  stream.polygonEnd();
}

/* harmony default export */ __webpack_exports__["a"] = (function(object, stream) {
  if (object && streamObjectType.hasOwnProperty(object.type)) {
    streamObjectType[object.type](object, stream);
  } else {
    streamGeometry(object, stream);
  }
});


/***/ }),

/***/ "./node_modules/d3-geo/src/transform.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = transformer;
/* harmony default export */ __webpack_exports__["a"] = (function(methods) {
  return {
    stream: transformer(methods)
  };
});

function transformer(methods) {
  return function(stream) {
    var s = new TransformStream;
    for (var key in methods) s[key] = methods[key];
    s.stream = stream;
    return s;
  };
}

function TransformStream() {}

TransformStream.prototype = {
  constructor: TransformStream,
  point: function(x, y) { this.stream.point(x, y); },
  sphere: function() { this.stream.sphere(); },
  lineStart: function() { this.stream.lineStart(); },
  lineEnd: function() { this.stream.lineEnd(); },
  polygonStart: function() { this.stream.polygonStart(); },
  polygonEnd: function() { this.stream.polygonEnd(); }
};


/***/ }),

/***/ "./node_modules/d3-hierarchy/src/accessors.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = optional;
/* harmony export (immutable) */ __webpack_exports__["b"] = required;
function optional(f) {
  return f == null ? null : required(f);
}

function required(f) {
  if (typeof f !== "function") throw new Error;
  return f;
}


/***/ }),

/***/ "./node_modules/d3-hierarchy/src/array.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return slice; });
/* harmony export (immutable) */ __webpack_exports__["a"] = shuffle;
var slice = Array.prototype.slice;

function shuffle(array) {
  var m = array.length,
      t,
      i;

  while (m) {
    i = Math.random() * m-- | 0;
    t = array[m];
    array[m] = array[i];
    array[i] = t;
  }

  return array;
}


/***/ }),

/***/ "./node_modules/d3-hierarchy/src/cluster.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function defaultSeparation(a, b) {
  return a.parent === b.parent ? 1 : 2;
}

function meanX(children) {
  return children.reduce(meanXReduce, 0) / children.length;
}

function meanXReduce(x, c) {
  return x + c.x;
}

function maxY(children) {
  return 1 + children.reduce(maxYReduce, 0);
}

function maxYReduce(y, c) {
  return Math.max(y, c.y);
}

function leafLeft(node) {
  var children;
  while (children = node.children) node = children[0];
  return node;
}

function leafRight(node) {
  var children;
  while (children = node.children) node = children[children.length - 1];
  return node;
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var separation = defaultSeparation,
      dx = 1,
      dy = 1,
      nodeSize = false;

  function cluster(root) {
    var previousNode,
        x = 0;

    // First walk, computing the initial x & y values.
    root.eachAfter(function(node) {
      var children = node.children;
      if (children) {
        node.x = meanX(children);
        node.y = maxY(children);
      } else {
        node.x = previousNode ? x += separation(node, previousNode) : 0;
        node.y = 0;
        previousNode = node;
      }
    });

    var left = leafLeft(root),
        right = leafRight(root),
        x0 = left.x - separation(left, right) / 2,
        x1 = right.x + separation(right, left) / 2;

    // Second walk, normalizing x & y to the desired size.
    return root.eachAfter(nodeSize ? function(node) {
      node.x = (node.x - root.x) * dx;
      node.y = (root.y - node.y) * dy;
    } : function(node) {
      node.x = (node.x - x0) / (x1 - x0) * dx;
      node.y = (1 - (root.y ? node.y / root.y : 1)) * dy;
    });
  }

  cluster.separation = function(x) {
    return arguments.length ? (separation = x, cluster) : separation;
  };

  cluster.size = function(x) {
    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], cluster) : (nodeSize ? null : [dx, dy]);
  };

  cluster.nodeSize = function(x) {
    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], cluster) : (nodeSize ? [dx, dy] : null);
  };

  return cluster;
});


/***/ }),

/***/ "./node_modules/d3-hierarchy/src/constant.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = constantZero;
function constantZero() {
  return 0;
}

/* harmony default export */ __webpack_exports__["b"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),

/***/ "./node_modules/d3-hierarchy/src/hierarchy/ancestors.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var node = this, nodes = [node];
  while (node = node.parent) {
    nodes.push(node);
  }
  return nodes;
});


/***/ }),

/***/ "./node_modules/d3-hierarchy/src/hierarchy/count.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function count(node) {
  var sum = 0,
      children = node.children,
      i = children && children.length;
  if (!i) sum = 1;
  else while (--i >= 0) sum += children[i].value;
  node.value = sum;
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return this.eachAfter(count);
});


/***/ }),

/***/ "./node_modules/d3-hierarchy/src/hierarchy/descendants.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var nodes = [];
  this.each(function(node) {
    nodes.push(node);
  });
  return nodes;
});


/***/ }),

/***/ "./node_modules/d3-hierarchy/src/hierarchy/each.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(callback) {
  var node = this, current, next = [node], children, i, n;
  do {
    current = next.reverse(), next = [];
    while (node = current.pop()) {
      callback(node), children = node.children;
      if (children) for (i = 0, n = children.length; i < n; ++i) {
        next.push(children[i]);
      }
    }
  } while (next.length);
  return this;
});


/***/ }),

/***/ "./node_modules/d3-hierarchy/src/hierarchy/eachAfter.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(callback) {
  var node = this, nodes = [node], next = [], children, i, n;
  while (node = nodes.pop()) {
    next.push(node), children = node.children;
    if (children) for (i = 0, n = children.length; i < n; ++i) {
      nodes.push(children[i]);
    }
  }
  while (node = next.pop()) {
    callback(node);
  }
  return this;
});


/***/ }),

/***/ "./node_modules/d3-hierarchy/src/hierarchy/eachBefore.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(callback) {
  var node = this, nodes = [node], children, i;
  while (node = nodes.pop()) {
    callback(node), children = node.children;
    if (children) for (i = children.length - 1; i >= 0; --i) {
      nodes.push(children[i]);
    }
  }
  return this;
});


/***/ }),

/***/ "./node_modules/d3-hierarchy/src/hierarchy/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = hierarchy;
/* harmony export (immutable) */ __webpack_exports__["b"] = computeHeight;
/* harmony export (immutable) */ __webpack_exports__["a"] = Node;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__count__ = __webpack_require__("./node_modules/d3-hierarchy/src/hierarchy/count.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__each__ = __webpack_require__("./node_modules/d3-hierarchy/src/hierarchy/each.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eachBefore__ = __webpack_require__("./node_modules/d3-hierarchy/src/hierarchy/eachBefore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__eachAfter__ = __webpack_require__("./node_modules/d3-hierarchy/src/hierarchy/eachAfter.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sum__ = __webpack_require__("./node_modules/d3-hierarchy/src/hierarchy/sum.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sort__ = __webpack_require__("./node_modules/d3-hierarchy/src/hierarchy/sort.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__path__ = __webpack_require__("./node_modules/d3-hierarchy/src/hierarchy/path.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ancestors__ = __webpack_require__("./node_modules/d3-hierarchy/src/hierarchy/ancestors.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__descendants__ = __webpack_require__("./node_modules/d3-hierarchy/src/hierarchy/descendants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__leaves__ = __webpack_require__("./node_modules/d3-hierarchy/src/hierarchy/leaves.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__links__ = __webpack_require__("./node_modules/d3-hierarchy/src/hierarchy/links.js");












function hierarchy(data, children) {
  var root = new Node(data),
      valued = +data.value && (root.value = data.value),
      node,
      nodes = [root],
      child,
      childs,
      i,
      n;

  if (children == null) children = defaultChildren;

  while (node = nodes.pop()) {
    if (valued) node.value = +node.data.value;
    if ((childs = children(node.data)) && (n = childs.length)) {
      node.children = new Array(n);
      for (i = n - 1; i >= 0; --i) {
        nodes.push(child = node.children[i] = new Node(childs[i]));
        child.parent = node;
        child.depth = node.depth + 1;
      }
    }
  }

  return root.eachBefore(computeHeight);
}

function node_copy() {
  return hierarchy(this).eachBefore(copyData);
}

function defaultChildren(d) {
  return d.children;
}

function copyData(node) {
  node.data = node.data.data;
}

function computeHeight(node) {
  var height = 0;
  do node.height = height;
  while ((node = node.parent) && (node.height < ++height));
}

function Node(data) {
  this.data = data;
  this.depth =
  this.height = 0;
  this.parent = null;
}

Node.prototype = hierarchy.prototype = {
  constructor: Node,
  count: __WEBPACK_IMPORTED_MODULE_0__count__["a" /* default */],
  each: __WEBPACK_IMPORTED_MODULE_1__each__["a" /* default */],
  eachAfter: __WEBPACK_IMPORTED_MODULE_3__eachAfter__["a" /* default */],
  eachBefore: __WEBPACK_IMPORTED_MODULE_2__eachBefore__["a" /* default */],
  sum: __WEBPACK_IMPORTED_MODULE_4__sum__["a" /* default */],
  sort: __WEBPACK_IMPORTED_MODULE_5__sort__["a" /* default */],
  path: __WEBPACK_IMPORTED_MODULE_6__path__["a" /* default */],
  ancestors: __WEBPACK_IMPORTED_MODULE_7__ancestors__["a" /* default */],
  descendants: __WEBPACK_IMPORTED_MODULE_8__descendants__["a" /* default */],
  leaves: __WEBPACK_IMPORTED_MODULE_9__leaves__["a" /* default */],
  links: __WEBPACK_IMPORTED_MODULE_10__links__["a" /* default */],
  copy: node_copy
};


/***/ }),

/***/ "./node_modules/d3-hierarchy/src/hierarchy/leaves.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var leaves = [];
  this.eachBefore(function(node) {
    if (!node.children) {
      leaves.push(node);
    }
  });
  return leaves;
});


/***/ }),

/***/ "./node_modules/d3-hierarchy/src/hierarchy/links.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var root = this, links = [];
  root.each(function(node) {
    if (node !== root) { // Don’t include the root’s parent, if any.
      links.push({source: node.parent, target: node});
    }
  });
  return links;
});


/***/ }),

/***/ "./node_modules/d3-hierarchy/src/hierarchy/path.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(end) {
  var start = this,
      ancestor = leastCommonAncestor(start, end),
      nodes = [start];
  while (start !== ancestor) {
    start = start.parent;
    nodes.push(start);
  }
  var k = nodes.length;
  while (end !== ancestor) {
    nodes.splice(k, 0, end);
    end = end.parent;
  }
  return nodes;
});

function leastCommonAncestor(a, b) {
  if (a === b) return a;
  var aNodes = a.ancestors(),
      bNodes = b.ancestors(),
      c = null;
  a = aNodes.pop();
  b = bNodes.pop();
  while (a === b) {
    c = a;
    a = aNodes.pop();
    b = bNodes.pop();
  }
  return c;
}


/***/ }),

/***/ "./node_modules/d3-hierarchy/src/hierarchy/sort.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(compare) {
  return this.eachBefore(function(node) {
    if (node.children) {
      node.children.sort(compare);
    }
  });
});


/***/ }),

/***/ "./node_modules/d3-hierarchy/src/hierarchy/sum.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  return this.eachAfter(function(node) {
    var sum = +value(node.data) || 0,
        children = node.children,
        i = children && children.length;
    while (--i >= 0) sum += children[i].value;
    node.value = sum;
  });
});


/***/ }),

/***/ "./node_modules/d3-hierarchy/src/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cluster__ = __webpack_require__("./node_modules/d3-hierarchy/src/cluster.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__cluster__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hierarchy_index__ = __webpack_require__("./node_modules/d3-hierarchy/src/hierarchy/index.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__hierarchy_index__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pack_index__ = __webpack_require__("./node_modules/d3-hierarchy/src/pack/index.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__pack_index__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pack_siblings__ = __webpack_require__("./node_modules/d3-hierarchy/src/pack/siblings.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__pack_siblings__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pack_enclose__ = __webpack_require__("./node_modules/d3-hierarchy/src/pack/enclose.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__pack_enclose__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__partition__ = __webpack_require__("./node_modules/d3-hierarchy/src/partition.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__partition__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__stratify__ = __webpack_require__("./node_modules/d3-hierarchy/src/stratify.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_6__stratify__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tree__ = __webpack_require__("./node_modules/d3-hierarchy/src/tree.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_7__tree__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__treemap_index__ = __webpack_require__("./node_modules/d3-hierarchy/src/treemap/index.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_8__treemap_index__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__treemap_binary__ = __webpack_require__("./node_modules/d3-hierarchy/src/treemap/binary.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_9__treemap_binary__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__treemap_dice__ = __webpack_require__("./node_modules/d3-hierarchy/src/treemap/dice.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_10__treemap_dice__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__treemap_slice__ = __webpack_require__("./node_modules/d3-hierarchy/src/treemap/slice.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_11__treemap_slice__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__treemap_sliceDice__ = __webpack_require__("./node_modules/d3-hierarchy/src/treemap/sliceDice.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_12__treemap_sliceDice__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__treemap_squarify__ = __webpack_require__("./node_modules/d3-hierarchy/src/treemap/squarify.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_13__treemap_squarify__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__treemap_resquarify__ = __webpack_require__("./node_modules/d3-hierarchy/src/treemap/resquarify.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_14__treemap_resquarify__["a"]; });

















/***/ }),

/***/ "./node_modules/d3-hierarchy/src/pack/enclose.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__("./node_modules/d3-hierarchy/src/array.js");


/* harmony default export */ __webpack_exports__["a"] = (function(circles) {
  var i = 0, n = (circles = Object(__WEBPACK_IMPORTED_MODULE_0__array__["a" /* shuffle */])(__WEBPACK_IMPORTED_MODULE_0__array__["b" /* slice */].call(circles))).length, B = [], p, e;

  while (i < n) {
    p = circles[i];
    if (e && enclosesWeak(e, p)) ++i;
    else e = encloseBasis(B = extendBasis(B, p)), i = 0;
  }

  return e;
});

function extendBasis(B, p) {
  var i, j;

  if (enclosesWeakAll(p, B)) return [p];

  // If we get here then B must have at least one element.
  for (i = 0; i < B.length; ++i) {
    if (enclosesNot(p, B[i])
        && enclosesWeakAll(encloseBasis2(B[i], p), B)) {
      return [B[i], p];
    }
  }

  // If we get here then B must have at least two elements.
  for (i = 0; i < B.length - 1; ++i) {
    for (j = i + 1; j < B.length; ++j) {
      if (enclosesNot(encloseBasis2(B[i], B[j]), p)
          && enclosesNot(encloseBasis2(B[i], p), B[j])
          && enclosesNot(encloseBasis2(B[j], p), B[i])
          && enclosesWeakAll(encloseBasis3(B[i], B[j], p), B)) {
        return [B[i], B[j], p];
      }
    }
  }

  // If we get here then something is very wrong.
  throw new Error;
}

function enclosesNot(a, b) {
  var dr = a.r - b.r, dx = b.x - a.x, dy = b.y - a.y;
  return dr < 0 || dr * dr < dx * dx + dy * dy;
}

function enclosesWeak(a, b) {
  var dr = a.r - b.r + 1e-6, dx = b.x - a.x, dy = b.y - a.y;
  return dr > 0 && dr * dr > dx * dx + dy * dy;
}

function enclosesWeakAll(a, B) {
  for (var i = 0; i < B.length; ++i) {
    if (!enclosesWeak(a, B[i])) {
      return false;
    }
  }
  return true;
}

function encloseBasis(B) {
  switch (B.length) {
    case 1: return encloseBasis1(B[0]);
    case 2: return encloseBasis2(B[0], B[1]);
    case 3: return encloseBasis3(B[0], B[1], B[2]);
  }
}

function encloseBasis1(a) {
  return {
    x: a.x,
    y: a.y,
    r: a.r
  };
}

function encloseBasis2(a, b) {
  var x1 = a.x, y1 = a.y, r1 = a.r,
      x2 = b.x, y2 = b.y, r2 = b.r,
      x21 = x2 - x1, y21 = y2 - y1, r21 = r2 - r1,
      l = Math.sqrt(x21 * x21 + y21 * y21);
  return {
    x: (x1 + x2 + x21 / l * r21) / 2,
    y: (y1 + y2 + y21 / l * r21) / 2,
    r: (l + r1 + r2) / 2
  };
}

function encloseBasis3(a, b, c) {
  var x1 = a.x, y1 = a.y, r1 = a.r,
      x2 = b.x, y2 = b.y, r2 = b.r,
      x3 = c.x, y3 = c.y, r3 = c.r,
      a2 = x1 - x2,
      a3 = x1 - x3,
      b2 = y1 - y2,
      b3 = y1 - y3,
      c2 = r2 - r1,
      c3 = r3 - r1,
      d1 = x1 * x1 + y1 * y1 - r1 * r1,
      d2 = d1 - x2 * x2 - y2 * y2 + r2 * r2,
      d3 = d1 - x3 * x3 - y3 * y3 + r3 * r3,
      ab = a3 * b2 - a2 * b3,
      xa = (b2 * d3 - b3 * d2) / (ab * 2) - x1,
      xb = (b3 * c2 - b2 * c3) / ab,
      ya = (a3 * d2 - a2 * d3) / (ab * 2) - y1,
      yb = (a2 * c3 - a3 * c2) / ab,
      A = xb * xb + yb * yb - 1,
      B = 2 * (r1 + xa * xb + ya * yb),
      C = xa * xa + ya * ya - r1 * r1,
      r = -(A ? (B + Math.sqrt(B * B - 4 * A * C)) / (2 * A) : C / B);
  return {
    x: x1 + xa + xb * r,
    y: y1 + ya + yb * r,
    r: r
  };
}


/***/ }),

/***/ "./node_modules/d3-hierarchy/src/pack/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__siblings__ = __webpack_require__("./node_modules/d3-hierarchy/src/pack/siblings.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessors__ = __webpack_require__("./node_modules/d3-hierarchy/src/accessors.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__("./node_modules/d3-hierarchy/src/constant.js");




function defaultRadius(d) {
  return Math.sqrt(d.value);
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var radius = null,
      dx = 1,
      dy = 1,
      padding = __WEBPACK_IMPORTED_MODULE_2__constant__["a" /* constantZero */];

  function pack(root) {
    root.x = dx / 2, root.y = dy / 2;
    if (radius) {
      root.eachBefore(radiusLeaf(radius))
          .eachAfter(packChildren(padding, 0.5))
          .eachBefore(translateChild(1));
    } else {
      root.eachBefore(radiusLeaf(defaultRadius))
          .eachAfter(packChildren(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* constantZero */], 1))
          .eachAfter(packChildren(padding, root.r / Math.min(dx, dy)))
          .eachBefore(translateChild(Math.min(dx, dy) / (2 * root.r)));
    }
    return root;
  }

  pack.radius = function(x) {
    return arguments.length ? (radius = Object(__WEBPACK_IMPORTED_MODULE_1__accessors__["a" /* optional */])(x), pack) : radius;
  };

  pack.size = function(x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], pack) : [dx, dy];
  };

  pack.padding = function(x) {
    return arguments.length ? (padding = typeof x === "function" ? x : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["b" /* default */])(+x), pack) : padding;
  };

  return pack;
});

function radiusLeaf(radius) {
  return function(node) {
    if (!node.children) {
      node.r = Math.max(0, +radius(node) || 0);
    }
  };
}

function packChildren(padding, k) {
  return function(node) {
    if (children = node.children) {
      var children,
          i,
          n = children.length,
          r = padding(node) * k || 0,
          e;

      if (r) for (i = 0; i < n; ++i) children[i].r += r;
      e = Object(__WEBPACK_IMPORTED_MODULE_0__siblings__["b" /* packEnclose */])(children);
      if (r) for (i = 0; i < n; ++i) children[i].r -= r;
      node.r = e + r;
    }
  };
}

function translateChild(k) {
  return function(node) {
    var parent = node.parent;
    node.r *= k;
    if (parent) {
      node.x = parent.x + k * node.x;
      node.y = parent.y + k * node.y;
    }
  };
}


/***/ }),

/***/ "./node_modules/d3-hierarchy/src/pack/siblings.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = packEnclose;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__enclose__ = __webpack_require__("./node_modules/d3-hierarchy/src/pack/enclose.js");


function place(b, a, c) {
  var dx = b.x - a.x, x, a2,
      dy = b.y - a.y, y, b2,
      d2 = dx * dx + dy * dy;
  if (d2) {
    a2 = a.r + c.r, a2 *= a2;
    b2 = b.r + c.r, b2 *= b2;
    if (a2 > b2) {
      x = (d2 + b2 - a2) / (2 * d2);
      y = Math.sqrt(Math.max(0, b2 / d2 - x * x));
      c.x = b.x - x * dx - y * dy;
      c.y = b.y - x * dy + y * dx;
    } else {
      x = (d2 + a2 - b2) / (2 * d2);
      y = Math.sqrt(Math.max(0, a2 / d2 - x * x));
      c.x = a.x + x * dx - y * dy;
      c.y = a.y + x * dy + y * dx;
    }
  } else {
    c.x = a.x + c.r;
    c.y = a.y;
  }
}

function intersects(a, b) {
  var dr = a.r + b.r - 1e-6, dx = b.x - a.x, dy = b.y - a.y;
  return dr > 0 && dr * dr > dx * dx + dy * dy;
}

function score(node) {
  var a = node._,
      b = node.next._,
      ab = a.r + b.r,
      dx = (a.x * b.r + b.x * a.r) / ab,
      dy = (a.y * b.r + b.y * a.r) / ab;
  return dx * dx + dy * dy;
}

function Node(circle) {
  this._ = circle;
  this.next = null;
  this.previous = null;
}

function packEnclose(circles) {
  if (!(n = circles.length)) return 0;

  var a, b, c, n, aa, ca, i, j, k, sj, sk;

  // Place the first circle.
  a = circles[0], a.x = 0, a.y = 0;
  if (!(n > 1)) return a.r;

  // Place the second circle.
  b = circles[1], a.x = -b.r, b.x = a.r, b.y = 0;
  if (!(n > 2)) return a.r + b.r;

  // Place the third circle.
  place(b, a, c = circles[2]);

  // Initialize the front-chain using the first three circles a, b and c.
  a = new Node(a), b = new Node(b), c = new Node(c);
  a.next = c.previous = b;
  b.next = a.previous = c;
  c.next = b.previous = a;

  // Attempt to place each remaining circle…
  pack: for (i = 3; i < n; ++i) {
    place(a._, b._, c = circles[i]), c = new Node(c);

    // Find the closest intersecting circle on the front-chain, if any.
    // “Closeness” is determined by linear distance along the front-chain.
    // “Ahead” or “behind” is likewise determined by linear distance.
    j = b.next, k = a.previous, sj = b._.r, sk = a._.r;
    do {
      if (sj <= sk) {
        if (intersects(j._, c._)) {
          b = j, a.next = b, b.previous = a, --i;
          continue pack;
        }
        sj += j._.r, j = j.next;
      } else {
        if (intersects(k._, c._)) {
          a = k, a.next = b, b.previous = a, --i;
          continue pack;
        }
        sk += k._.r, k = k.previous;
      }
    } while (j !== k.next);

    // Success! Insert the new circle c between a and b.
    c.previous = a, c.next = b, a.next = b.previous = b = c;

    // Compute the new closest circle pair to the centroid.
    aa = score(a);
    while ((c = c.next) !== b) {
      if ((ca = score(c)) < aa) {
        a = c, aa = ca;
      }
    }
    b = a.next;
  }

  // Compute the enclosing circle of the front chain.
  a = [b._], c = b; while ((c = c.next) !== b) a.push(c._); c = Object(__WEBPACK_IMPORTED_MODULE_0__enclose__["a" /* default */])(a);

  // Translate the circles to put the enclosing circle around the origin.
  for (i = 0; i < n; ++i) a = circles[i], a.x -= c.x, a.y -= c.y;

  return c.r;
}

/* harmony default export */ __webpack_exports__["a"] = (function(circles) {
  packEnclose(circles);
  return circles;
});


/***/ }),

/***/ "./node_modules/d3-hierarchy/src/partition.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__treemap_round__ = __webpack_require__("./node_modules/d3-hierarchy/src/treemap/round.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__treemap_dice__ = __webpack_require__("./node_modules/d3-hierarchy/src/treemap/dice.js");



/* harmony default export */ __webpack_exports__["a"] = (function() {
  var dx = 1,
      dy = 1,
      padding = 0,
      round = false;

  function partition(root) {
    var n = root.height + 1;
    root.x0 =
    root.y0 = padding;
    root.x1 = dx;
    root.y1 = dy / n;
    root.eachBefore(positionNode(dy, n));
    if (round) root.eachBefore(__WEBPACK_IMPORTED_MODULE_0__treemap_round__["a" /* default */]);
    return root;
  }

  function positionNode(dy, n) {
    return function(node) {
      if (node.children) {
        Object(__WEBPACK_IMPORTED_MODULE_1__treemap_dice__["a" /* default */])(node, node.x0, dy * (node.depth + 1) / n, node.x1, dy * (node.depth + 2) / n);
      }
      var x0 = node.x0,
          y0 = node.y0,
          x1 = node.x1 - padding,
          y1 = node.y1 - padding;
      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
      node.x0 = x0;
      node.y0 = y0;
      node.x1 = x1;
      node.y1 = y1;
    };
  }

  partition.round = function(x) {
    return arguments.length ? (round = !!x, partition) : round;
  };

  partition.size = function(x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], partition) : [dx, dy];
  };

  partition.padding = function(x) {
    return arguments.length ? (padding = +x, partition) : padding;
  };

  return partition;
});


/***/ }),

/***/ "./node_modules/d3-hierarchy/src/stratify.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__accessors__ = __webpack_require__("./node_modules/d3-hierarchy/src/accessors.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hierarchy_index__ = __webpack_require__("./node_modules/d3-hierarchy/src/hierarchy/index.js");



var keyPrefix = "$", // Protect against keys like “__proto__”.
    preroot = {depth: -1},
    ambiguous = {};

function defaultId(d) {
  return d.id;
}

function defaultParentId(d) {
  return d.parentId;
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var id = defaultId,
      parentId = defaultParentId;

  function stratify(data) {
    var d,
        i,
        n = data.length,
        root,
        parent,
        node,
        nodes = new Array(n),
        nodeId,
        nodeKey,
        nodeByKey = {};

    for (i = 0; i < n; ++i) {
      d = data[i], node = nodes[i] = new __WEBPACK_IMPORTED_MODULE_1__hierarchy_index__["a" /* Node */](d);
      if ((nodeId = id(d, i, data)) != null && (nodeId += "")) {
        nodeKey = keyPrefix + (node.id = nodeId);
        nodeByKey[nodeKey] = nodeKey in nodeByKey ? ambiguous : node;
      }
    }

    for (i = 0; i < n; ++i) {
      node = nodes[i], nodeId = parentId(data[i], i, data);
      if (nodeId == null || !(nodeId += "")) {
        if (root) throw new Error("multiple roots");
        root = node;
      } else {
        parent = nodeByKey[keyPrefix + nodeId];
        if (!parent) throw new Error("missing: " + nodeId);
        if (parent === ambiguous) throw new Error("ambiguous: " + nodeId);
        if (parent.children) parent.children.push(node);
        else parent.children = [node];
        node.parent = parent;
      }
    }

    if (!root) throw new Error("no root");
    root.parent = preroot;
    root.eachBefore(function(node) { node.depth = node.parent.depth + 1; --n; }).eachBefore(__WEBPACK_IMPORTED_MODULE_1__hierarchy_index__["b" /* computeHeight */]);
    root.parent = null;
    if (n > 0) throw new Error("cycle");

    return root;
  }

  stratify.id = function(x) {
    return arguments.length ? (id = Object(__WEBPACK_IMPORTED_MODULE_0__accessors__["b" /* required */])(x), stratify) : id;
  };

  stratify.parentId = function(x) {
    return arguments.length ? (parentId = Object(__WEBPACK_IMPORTED_MODULE_0__accessors__["b" /* required */])(x), stratify) : parentId;
  };

  return stratify;
});


/***/ }),

/***/ "./node_modules/d3-hierarchy/src/tree.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hierarchy_index__ = __webpack_require__("./node_modules/d3-hierarchy/src/hierarchy/index.js");


function defaultSeparation(a, b) {
  return a.parent === b.parent ? 1 : 2;
}

// function radialSeparation(a, b) {
//   return (a.parent === b.parent ? 1 : 2) / a.depth;
// }

// This function is used to traverse the left contour of a subtree (or
// subforest). It returns the successor of v on this contour. This successor is
// either given by the leftmost child of v or by the thread of v. The function
// returns null if and only if v is on the highest level of its subtree.
function nextLeft(v) {
  var children = v.children;
  return children ? children[0] : v.t;
}

// This function works analogously to nextLeft.
function nextRight(v) {
  var children = v.children;
  return children ? children[children.length - 1] : v.t;
}

// Shifts the current subtree rooted at w+. This is done by increasing
// prelim(w+) and mod(w+) by shift.
function moveSubtree(wm, wp, shift) {
  var change = shift / (wp.i - wm.i);
  wp.c -= change;
  wp.s += shift;
  wm.c += change;
  wp.z += shift;
  wp.m += shift;
}

// All other shifts, applied to the smaller subtrees between w- and w+, are
// performed by this function. To prepare the shifts, we have to adjust
// change(w+), shift(w+), and change(w-).
function executeShifts(v) {
  var shift = 0,
      change = 0,
      children = v.children,
      i = children.length,
      w;
  while (--i >= 0) {
    w = children[i];
    w.z += shift;
    w.m += shift;
    shift += w.s + (change += w.c);
  }
}

// If vi-’s ancestor is a sibling of v, returns vi-’s ancestor. Otherwise,
// returns the specified (default) ancestor.
function nextAncestor(vim, v, ancestor) {
  return vim.a.parent === v.parent ? vim.a : ancestor;
}

function TreeNode(node, i) {
  this._ = node;
  this.parent = null;
  this.children = null;
  this.A = null; // default ancestor
  this.a = this; // ancestor
  this.z = 0; // prelim
  this.m = 0; // mod
  this.c = 0; // change
  this.s = 0; // shift
  this.t = null; // thread
  this.i = i; // number
}

TreeNode.prototype = Object.create(__WEBPACK_IMPORTED_MODULE_0__hierarchy_index__["a" /* Node */].prototype);

function treeRoot(root) {
  var tree = new TreeNode(root, 0),
      node,
      nodes = [tree],
      child,
      children,
      i,
      n;

  while (node = nodes.pop()) {
    if (children = node._.children) {
      node.children = new Array(n = children.length);
      for (i = n - 1; i >= 0; --i) {
        nodes.push(child = node.children[i] = new TreeNode(children[i], i));
        child.parent = node;
      }
    }
  }

  (tree.parent = new TreeNode(null, 0)).children = [tree];
  return tree;
}

// Node-link tree diagram using the Reingold-Tilford "tidy" algorithm
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var separation = defaultSeparation,
      dx = 1,
      dy = 1,
      nodeSize = null;

  function tree(root) {
    var t = treeRoot(root);

    // Compute the layout using Buchheim et al.’s algorithm.
    t.eachAfter(firstWalk), t.parent.m = -t.z;
    t.eachBefore(secondWalk);

    // If a fixed node size is specified, scale x and y.
    if (nodeSize) root.eachBefore(sizeNode);

    // If a fixed tree size is specified, scale x and y based on the extent.
    // Compute the left-most, right-most, and depth-most nodes for extents.
    else {
      var left = root,
          right = root,
          bottom = root;
      root.eachBefore(function(node) {
        if (node.x < left.x) left = node;
        if (node.x > right.x) right = node;
        if (node.depth > bottom.depth) bottom = node;
      });
      var s = left === right ? 1 : separation(left, right) / 2,
          tx = s - left.x,
          kx = dx / (right.x + s + tx),
          ky = dy / (bottom.depth || 1);
      root.eachBefore(function(node) {
        node.x = (node.x + tx) * kx;
        node.y = node.depth * ky;
      });
    }

    return root;
  }

  // Computes a preliminary x-coordinate for v. Before that, FIRST WALK is
  // applied recursively to the children of v, as well as the function
  // APPORTION. After spacing out the children by calling EXECUTE SHIFTS, the
  // node v is placed to the midpoint of its outermost children.
  function firstWalk(v) {
    var children = v.children,
        siblings = v.parent.children,
        w = v.i ? siblings[v.i - 1] : null;
    if (children) {
      executeShifts(v);
      var midpoint = (children[0].z + children[children.length - 1].z) / 2;
      if (w) {
        v.z = w.z + separation(v._, w._);
        v.m = v.z - midpoint;
      } else {
        v.z = midpoint;
      }
    } else if (w) {
      v.z = w.z + separation(v._, w._);
    }
    v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
  }

  // Computes all real x-coordinates by summing up the modifiers recursively.
  function secondWalk(v) {
    v._.x = v.z + v.parent.m;
    v.m += v.parent.m;
  }

  // The core of the algorithm. Here, a new subtree is combined with the
  // previous subtrees. Threads are used to traverse the inside and outside
  // contours of the left and right subtree up to the highest common level. The
  // vertices used for the traversals are vi+, vi-, vo-, and vo+, where the
  // superscript o means outside and i means inside, the subscript - means left
  // subtree and + means right subtree. For summing up the modifiers along the
  // contour, we use respective variables si+, si-, so-, and so+. Whenever two
  // nodes of the inside contours conflict, we compute the left one of the
  // greatest uncommon ancestors using the function ANCESTOR and call MOVE
  // SUBTREE to shift the subtree and prepare the shifts of smaller subtrees.
  // Finally, we add a new thread (if necessary).
  function apportion(v, w, ancestor) {
    if (w) {
      var vip = v,
          vop = v,
          vim = w,
          vom = vip.parent.children[0],
          sip = vip.m,
          sop = vop.m,
          sim = vim.m,
          som = vom.m,
          shift;
      while (vim = nextRight(vim), vip = nextLeft(vip), vim && vip) {
        vom = nextLeft(vom);
        vop = nextRight(vop);
        vop.a = v;
        shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
        if (shift > 0) {
          moveSubtree(nextAncestor(vim, v, ancestor), v, shift);
          sip += shift;
          sop += shift;
        }
        sim += vim.m;
        sip += vip.m;
        som += vom.m;
        sop += vop.m;
      }
      if (vim && !nextRight(vop)) {
        vop.t = vim;
        vop.m += sim - sop;
      }
      if (vip && !nextLeft(vom)) {
        vom.t = vip;
        vom.m += sip - som;
        ancestor = v;
      }
    }
    return ancestor;
  }

  function sizeNode(node) {
    node.x *= dx;
    node.y = node.depth * dy;
  }

  tree.separation = function(x) {
    return arguments.length ? (separation = x, tree) : separation;
  };

  tree.size = function(x) {
    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], tree) : (nodeSize ? null : [dx, dy]);
  };

  tree.nodeSize = function(x) {
    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], tree) : (nodeSize ? [dx, dy] : null);
  };

  return tree;
});


/***/ }),

/***/ "./node_modules/d3-hierarchy/src/treemap/binary.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      i, n = nodes.length,
      sum, sums = new Array(n + 1);

  for (sums[0] = sum = i = 0; i < n; ++i) {
    sums[i + 1] = sum += nodes[i].value;
  }

  partition(0, n, parent.value, x0, y0, x1, y1);

  function partition(i, j, value, x0, y0, x1, y1) {
    if (i >= j - 1) {
      var node = nodes[i];
      node.x0 = x0, node.y0 = y0;
      node.x1 = x1, node.y1 = y1;
      return;
    }

    var valueOffset = sums[i],
        valueTarget = (value / 2) + valueOffset,
        k = i + 1,
        hi = j - 1;

    while (k < hi) {
      var mid = k + hi >>> 1;
      if (sums[mid] < valueTarget) k = mid + 1;
      else hi = mid;
    }

    if ((valueTarget - sums[k - 1]) < (sums[k] - valueTarget) && i + 1 < k) --k;

    var valueLeft = sums[k] - valueOffset,
        valueRight = value - valueLeft;

    if ((x1 - x0) > (y1 - y0)) {
      var xk = (x0 * valueRight + x1 * valueLeft) / value;
      partition(i, k, valueLeft, x0, y0, xk, y1);
      partition(k, j, valueRight, xk, y0, x1, y1);
    } else {
      var yk = (y0 * valueRight + y1 * valueLeft) / value;
      partition(i, k, valueLeft, x0, y0, x1, yk);
      partition(k, j, valueRight, x0, yk, x1, y1);
    }
  }
});


/***/ }),

/***/ "./node_modules/d3-hierarchy/src/treemap/dice.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      node,
      i = -1,
      n = nodes.length,
      k = parent.value && (x1 - x0) / parent.value;

  while (++i < n) {
    node = nodes[i], node.y0 = y0, node.y1 = y1;
    node.x0 = x0, node.x1 = x0 += node.value * k;
  }
});


/***/ }),

/***/ "./node_modules/d3-hierarchy/src/treemap/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__round__ = __webpack_require__("./node_modules/d3-hierarchy/src/treemap/round.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__squarify__ = __webpack_require__("./node_modules/d3-hierarchy/src/treemap/squarify.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__accessors__ = __webpack_require__("./node_modules/d3-hierarchy/src/accessors.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constant__ = __webpack_require__("./node_modules/d3-hierarchy/src/constant.js");





/* harmony default export */ __webpack_exports__["a"] = (function() {
  var tile = __WEBPACK_IMPORTED_MODULE_1__squarify__["a" /* default */],
      round = false,
      dx = 1,
      dy = 1,
      paddingStack = [0],
      paddingInner = __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* constantZero */],
      paddingTop = __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* constantZero */],
      paddingRight = __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* constantZero */],
      paddingBottom = __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* constantZero */],
      paddingLeft = __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* constantZero */];

  function treemap(root) {
    root.x0 =
    root.y0 = 0;
    root.x1 = dx;
    root.y1 = dy;
    root.eachBefore(positionNode);
    paddingStack = [0];
    if (round) root.eachBefore(__WEBPACK_IMPORTED_MODULE_0__round__["a" /* default */]);
    return root;
  }

  function positionNode(node) {
    var p = paddingStack[node.depth],
        x0 = node.x0 + p,
        y0 = node.y0 + p,
        x1 = node.x1 - p,
        y1 = node.y1 - p;
    if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
    if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
    node.x0 = x0;
    node.y0 = y0;
    node.x1 = x1;
    node.y1 = y1;
    if (node.children) {
      p = paddingStack[node.depth + 1] = paddingInner(node) / 2;
      x0 += paddingLeft(node) - p;
      y0 += paddingTop(node) - p;
      x1 -= paddingRight(node) - p;
      y1 -= paddingBottom(node) - p;
      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
      tile(node, x0, y0, x1, y1);
    }
  }

  treemap.round = function(x) {
    return arguments.length ? (round = !!x, treemap) : round;
  };

  treemap.size = function(x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], treemap) : [dx, dy];
  };

  treemap.tile = function(x) {
    return arguments.length ? (tile = Object(__WEBPACK_IMPORTED_MODULE_2__accessors__["b" /* required */])(x), treemap) : tile;
  };

  treemap.padding = function(x) {
    return arguments.length ? treemap.paddingInner(x).paddingOuter(x) : treemap.paddingInner();
  };

  treemap.paddingInner = function(x) {
    return arguments.length ? (paddingInner = typeof x === "function" ? x : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["b" /* default */])(+x), treemap) : paddingInner;
  };

  treemap.paddingOuter = function(x) {
    return arguments.length ? treemap.paddingTop(x).paddingRight(x).paddingBottom(x).paddingLeft(x) : treemap.paddingTop();
  };

  treemap.paddingTop = function(x) {
    return arguments.length ? (paddingTop = typeof x === "function" ? x : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["b" /* default */])(+x), treemap) : paddingTop;
  };

  treemap.paddingRight = function(x) {
    return arguments.length ? (paddingRight = typeof x === "function" ? x : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["b" /* default */])(+x), treemap) : paddingRight;
  };

  treemap.paddingBottom = function(x) {
    return arguments.length ? (paddingBottom = typeof x === "function" ? x : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["b" /* default */])(+x), treemap) : paddingBottom;
  };

  treemap.paddingLeft = function(x) {
    return arguments.length ? (paddingLeft = typeof x === "function" ? x : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["b" /* default */])(+x), treemap) : paddingLeft;
  };

  return treemap;
});


/***/ }),

/***/ "./node_modules/d3-hierarchy/src/treemap/resquarify.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dice__ = __webpack_require__("./node_modules/d3-hierarchy/src/treemap/dice.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slice__ = __webpack_require__("./node_modules/d3-hierarchy/src/treemap/slice.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__squarify__ = __webpack_require__("./node_modules/d3-hierarchy/src/treemap/squarify.js");




/* harmony default export */ __webpack_exports__["a"] = ((function custom(ratio) {

  function resquarify(parent, x0, y0, x1, y1) {
    if ((rows = parent._squarify) && (rows.ratio === ratio)) {
      var rows,
          row,
          nodes,
          i,
          j = -1,
          n,
          m = rows.length,
          value = parent.value;

      while (++j < m) {
        row = rows[j], nodes = row.children;
        for (i = row.value = 0, n = nodes.length; i < n; ++i) row.value += nodes[i].value;
        if (row.dice) Object(__WEBPACK_IMPORTED_MODULE_0__dice__["a" /* default */])(row, x0, y0, x1, y0 += (y1 - y0) * row.value / value);
        else Object(__WEBPACK_IMPORTED_MODULE_1__slice__["a" /* default */])(row, x0, y0, x0 += (x1 - x0) * row.value / value, y1);
        value -= row.value;
      }
    } else {
      parent._squarify = rows = Object(__WEBPACK_IMPORTED_MODULE_2__squarify__["c" /* squarifyRatio */])(ratio, parent, x0, y0, x1, y1);
      rows.ratio = ratio;
    }
  }

  resquarify.ratio = function(x) {
    return custom((x = +x) > 1 ? x : 1);
  };

  return resquarify;
})(__WEBPACK_IMPORTED_MODULE_2__squarify__["b" /* phi */]));


/***/ }),

/***/ "./node_modules/d3-hierarchy/src/treemap/round.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(node) {
  node.x0 = Math.round(node.x0);
  node.y0 = Math.round(node.y0);
  node.x1 = Math.round(node.x1);
  node.y1 = Math.round(node.y1);
});


/***/ }),

/***/ "./node_modules/d3-hierarchy/src/treemap/slice.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      node,
      i = -1,
      n = nodes.length,
      k = parent.value && (y1 - y0) / parent.value;

  while (++i < n) {
    node = nodes[i], node.x0 = x0, node.x1 = x1;
    node.y0 = y0, node.y1 = y0 += node.value * k;
  }
});


/***/ }),

/***/ "./node_modules/d3-hierarchy/src/treemap/sliceDice.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dice__ = __webpack_require__("./node_modules/d3-hierarchy/src/treemap/dice.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slice__ = __webpack_require__("./node_modules/d3-hierarchy/src/treemap/slice.js");



/* harmony default export */ __webpack_exports__["a"] = (function(parent, x0, y0, x1, y1) {
  (parent.depth & 1 ? __WEBPACK_IMPORTED_MODULE_1__slice__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_0__dice__["a" /* default */])(parent, x0, y0, x1, y1);
});


/***/ }),

/***/ "./node_modules/d3-hierarchy/src/treemap/squarify.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return phi; });
/* harmony export (immutable) */ __webpack_exports__["c"] = squarifyRatio;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dice__ = __webpack_require__("./node_modules/d3-hierarchy/src/treemap/dice.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slice__ = __webpack_require__("./node_modules/d3-hierarchy/src/treemap/slice.js");



var phi = (1 + Math.sqrt(5)) / 2;

function squarifyRatio(ratio, parent, x0, y0, x1, y1) {
  var rows = [],
      nodes = parent.children,
      row,
      nodeValue,
      i0 = 0,
      i1 = 0,
      n = nodes.length,
      dx, dy,
      value = parent.value,
      sumValue,
      minValue,
      maxValue,
      newRatio,
      minRatio,
      alpha,
      beta;

  while (i0 < n) {
    dx = x1 - x0, dy = y1 - y0;

    // Find the next non-empty node.
    do sumValue = nodes[i1++].value; while (!sumValue && i1 < n);
    minValue = maxValue = sumValue;
    alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
    beta = sumValue * sumValue * alpha;
    minRatio = Math.max(maxValue / beta, beta / minValue);

    // Keep adding nodes while the aspect ratio maintains or improves.
    for (; i1 < n; ++i1) {
      sumValue += nodeValue = nodes[i1].value;
      if (nodeValue < minValue) minValue = nodeValue;
      if (nodeValue > maxValue) maxValue = nodeValue;
      beta = sumValue * sumValue * alpha;
      newRatio = Math.max(maxValue / beta, beta / minValue);
      if (newRatio > minRatio) { sumValue -= nodeValue; break; }
      minRatio = newRatio;
    }

    // Position and record the row orientation.
    rows.push(row = {value: sumValue, dice: dx < dy, children: nodes.slice(i0, i1)});
    if (row.dice) Object(__WEBPACK_IMPORTED_MODULE_0__dice__["a" /* default */])(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);
    else Object(__WEBPACK_IMPORTED_MODULE_1__slice__["a" /* default */])(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
    value -= sumValue, i0 = i1;
  }

  return rows;
}

/* harmony default export */ __webpack_exports__["a"] = ((function custom(ratio) {

  function squarify(parent, x0, y0, x1, y1) {
    squarifyRatio(ratio, parent, x0, y0, x1, y1);
  }

  squarify.ratio = function(x) {
    return custom((x = +x) > 1 ? x : 1);
  };

  return squarify;
})(phi));


/***/ }),

/***/ "./node_modules/d3-interpolate/src/array.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value__ = __webpack_require__("./node_modules/d3-interpolate/src/value.js");


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var nb = b ? b.length : 0,
      na = a ? Math.min(nb, a.length) : 0,
      x = new Array(na),
      c = new Array(nb),
      i;

  for (i = 0; i < na; ++i) x[i] = Object(__WEBPACK_IMPORTED_MODULE_0__value__["a" /* default */])(a[i], b[i]);
  for (; i < nb; ++i) c[i] = b[i];

  return function(t) {
    for (i = 0; i < na; ++i) c[i] = x[i](t);
    return c;
  };
});


/***/ }),

/***/ "./node_modules/d3-interpolate/src/basis.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = basis;
function basis(t1, v0, v1, v2, v3) {
  var t2 = t1 * t1, t3 = t2 * t1;
  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
      + (4 - 6 * t2 + 3 * t3) * v1
      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
      + t3 * v3) / 6;
}

/* harmony default export */ __webpack_exports__["b"] = (function(values) {
  var n = values.length - 1;
  return function(t) {
    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
        v1 = values[i],
        v2 = values[i + 1],
        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
    return basis((t - i / n) * n, v0, v1, v2, v3);
  };
});


/***/ }),

/***/ "./node_modules/d3-interpolate/src/basisClosed.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis__ = __webpack_require__("./node_modules/d3-interpolate/src/basis.js");


/* harmony default export */ __webpack_exports__["a"] = (function(values) {
  var n = values.length;
  return function(t) {
    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
        v0 = values[(i + n - 1) % n],
        v1 = values[i % n],
        v2 = values[(i + 1) % n],
        v3 = values[(i + 2) % n];
    return Object(__WEBPACK_IMPORTED_MODULE_0__basis__["a" /* basis */])((t - i / n) * n, v0, v1, v2, v3);
  };
});


/***/ }),

/***/ "./node_modules/d3-interpolate/src/color.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = hue;
/* harmony export (immutable) */ __webpack_exports__["b"] = gamma;
/* harmony export (immutable) */ __webpack_exports__["a"] = nogamma;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__("./node_modules/d3-interpolate/src/constant.js");


function linear(a, d) {
  return function(t) {
    return a + t * d;
  };
}

function exponential(a, b, y) {
  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
    return Math.pow(a + t * b, y);
  };
}

function hue(a, b) {
  var d = b - a;
  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
}

function gamma(y) {
  return (y = +y) === 1 ? nogamma : function(a, b) {
    return b - a ? exponential(a, b, y) : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
  };
}

function nogamma(a, b) {
  var d = b - a;
  return d ? linear(a, d) : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
}


/***/ }),

/***/ "./node_modules/d3-interpolate/src/constant.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),

/***/ "./node_modules/d3-interpolate/src/cubehelix.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cubehelixLong; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__("./node_modules/d3-color/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__("./node_modules/d3-interpolate/src/color.js");



function cubehelix(hue) {
  return (function cubehelixGamma(y) {
    y = +y;

    function cubehelix(start, end) {
      var h = hue((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(start)).h, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(end)).h),
          s = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.s, end.s),
          l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
          opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
      return function(t) {
        start.h = h(t);
        start.s = s(t);
        start.l = l(Math.pow(t, y));
        start.opacity = opacity(t);
        return start + "";
      };
    }

    cubehelix.gamma = cubehelixGamma;

    return cubehelix;
  })(1);
}

/* harmony default export */ __webpack_exports__["b"] = (cubehelix(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* hue */]));
var cubehelixLong = cubehelix(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),

/***/ "./node_modules/d3-interpolate/src/date.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var d = new Date;
  return a = +a, b -= a, function(t) {
    return d.setTime(a + b * t), d;
  };
});


/***/ }),

/***/ "./node_modules/d3-interpolate/src/discrete.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(range) {
  var n = range.length;
  return function(t) {
    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
  };
});


/***/ }),

/***/ "./node_modules/d3-interpolate/src/hcl.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hclLong; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__("./node_modules/d3-color/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__("./node_modules/d3-interpolate/src/color.js");



function hcl(hue) {
  return function(start, end) {
    var h = hue((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["d" /* hcl */])(start)).h, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["d" /* hcl */])(end)).h),
        c = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.c, end.c),
        l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
        opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.c = c(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

/* harmony default export */ __webpack_exports__["a"] = (hcl(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* hue */]));
var hclLong = hcl(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),

/***/ "./node_modules/d3-interpolate/src/hsl.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hslLong; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__("./node_modules/d3-color/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__("./node_modules/d3-interpolate/src/color.js");



function hsl(hue) {
  return function(start, end) {
    var h = hue((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["e" /* hsl */])(start)).h, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["e" /* hsl */])(end)).h),
        s = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.s, end.s),
        l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
        opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.s = s(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

/* harmony default export */ __webpack_exports__["a"] = (hsl(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* hue */]));
var hslLong = hsl(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),

/***/ "./node_modules/d3-interpolate/src/hue.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__color__ = __webpack_require__("./node_modules/d3-interpolate/src/color.js");


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var i = Object(__WEBPACK_IMPORTED_MODULE_0__color__["c" /* hue */])(+a, +b);
  return function(t) {
    var x = i(t);
    return x - 360 * Math.floor(x / 360);
  };
});


/***/ }),

/***/ "./node_modules/d3-interpolate/src/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value__ = __webpack_require__("./node_modules/d3-interpolate/src/value.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__value__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__("./node_modules/d3-interpolate/src/array.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__array__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__basis__ = __webpack_require__("./node_modules/d3-interpolate/src/basis.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__basis__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__basisClosed__ = __webpack_require__("./node_modules/d3-interpolate/src/basisClosed.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__basisClosed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__date__ = __webpack_require__("./node_modules/d3-interpolate/src/date.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_4__date__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__discrete__ = __webpack_require__("./node_modules/d3-interpolate/src/discrete.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_5__discrete__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hue__ = __webpack_require__("./node_modules/d3-interpolate/src/hue.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_6__hue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__number__ = __webpack_require__("./node_modules/d3-interpolate/src/number.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_7__number__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__object__ = __webpack_require__("./node_modules/d3-interpolate/src/object.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_8__object__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__round__ = __webpack_require__("./node_modules/d3-interpolate/src/round.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_9__round__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__string__ = __webpack_require__("./node_modules/d3-interpolate/src/string.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_10__string__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__transform_index__ = __webpack_require__("./node_modules/d3-interpolate/src/transform/index.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_11__transform_index__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_11__transform_index__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__zoom__ = __webpack_require__("./node_modules/d3-interpolate/src/zoom.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_12__zoom__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__rgb__ = __webpack_require__("./node_modules/d3-interpolate/src/rgb.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_13__rgb__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_13__rgb__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_13__rgb__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__hsl__ = __webpack_require__("./node_modules/d3-interpolate/src/hsl.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_14__hsl__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_14__hsl__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lab__ = __webpack_require__("./node_modules/d3-interpolate/src/lab.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_15__lab__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__hcl__ = __webpack_require__("./node_modules/d3-interpolate/src/hcl.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_16__hcl__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_16__hcl__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__cubehelix__ = __webpack_require__("./node_modules/d3-interpolate/src/cubehelix.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_17__cubehelix__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_17__cubehelix__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__piecewise__ = __webpack_require__("./node_modules/d3-interpolate/src/piecewise.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_18__piecewise__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__quantize__ = __webpack_require__("./node_modules/d3-interpolate/src/quantize.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_19__quantize__["a"]; });






















/***/ }),

/***/ "./node_modules/d3-interpolate/src/lab.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = lab;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__("./node_modules/d3-color/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__("./node_modules/d3-interpolate/src/color.js");



function lab(start, end) {
  var l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["f" /* lab */])(start)).l, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["f" /* lab */])(end)).l),
      a = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.a, end.a),
      b = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.b, end.b),
      opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
  return function(t) {
    start.l = l(t);
    start.a = a(t);
    start.b = b(t);
    start.opacity = opacity(t);
    return start + "";
  };
}


/***/ }),

/***/ "./node_modules/d3-interpolate/src/number.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a = +a, b -= a, function(t) {
    return a + b * t;
  };
});


/***/ }),

/***/ "./node_modules/d3-interpolate/src/object.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value__ = __webpack_require__("./node_modules/d3-interpolate/src/value.js");


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var i = {},
      c = {},
      k;

  if (a === null || typeof a !== "object") a = {};
  if (b === null || typeof b !== "object") b = {};

  for (k in b) {
    if (k in a) {
      i[k] = Object(__WEBPACK_IMPORTED_MODULE_0__value__["a" /* default */])(a[k], b[k]);
    } else {
      c[k] = b[k];
    }
  }

  return function(t) {
    for (k in i) c[k] = i[k](t);
    return c;
  };
});


/***/ }),

/***/ "./node_modules/d3-interpolate/src/piecewise.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = piecewise;
function piecewise(interpolate, values) {
  var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
  while (i < n) I[i] = interpolate(v, v = values[++i]);
  return function(t) {
    var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
    return I[i](t - i);
  };
}


/***/ }),

/***/ "./node_modules/d3-interpolate/src/quantize.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(interpolator, n) {
  var samples = new Array(n);
  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
  return samples;
});


/***/ }),

/***/ "./node_modules/d3-interpolate/src/rgb.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return rgbBasis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return rgbBasisClosed; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__("./node_modules/d3-color/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basis__ = __webpack_require__("./node_modules/d3-interpolate/src/basis.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__basisClosed__ = __webpack_require__("./node_modules/d3-interpolate/src/basisClosed.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__color__ = __webpack_require__("./node_modules/d3-interpolate/src/color.js");





/* harmony default export */ __webpack_exports__["a"] = ((function rgbGamma(y) {
  var color = Object(__WEBPACK_IMPORTED_MODULE_3__color__["b" /* gamma */])(y);

  function rgb(start, end) {
    var r = color((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["h" /* rgb */])(start)).r, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["h" /* rgb */])(end)).r),
        g = color(start.g, end.g),
        b = color(start.b, end.b),
        opacity = Object(__WEBPACK_IMPORTED_MODULE_3__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.r = r(t);
      start.g = g(t);
      start.b = b(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }

  rgb.gamma = rgbGamma;

  return rgb;
})(1));

function rgbSpline(spline) {
  return function(colors) {
    var n = colors.length,
        r = new Array(n),
        g = new Array(n),
        b = new Array(n),
        i, color;
    for (i = 0; i < n; ++i) {
      color = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["h" /* rgb */])(colors[i]);
      r[i] = color.r || 0;
      g[i] = color.g || 0;
      b[i] = color.b || 0;
    }
    r = spline(r);
    g = spline(g);
    b = spline(b);
    color.opacity = 1;
    return function(t) {
      color.r = r(t);
      color.g = g(t);
      color.b = b(t);
      return color + "";
    };
  };
}

var rgbBasis = rgbSpline(__WEBPACK_IMPORTED_MODULE_1__basis__["b" /* default */]);
var rgbBasisClosed = rgbSpline(__WEBPACK_IMPORTED_MODULE_2__basisClosed__["a" /* default */]);


/***/ }),

/***/ "./node_modules/d3-interpolate/src/round.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a = +a, b -= a, function(t) {
    return Math.round(a + b * t);
  };
});


/***/ }),

/***/ "./node_modules/d3-interpolate/src/string.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__("./node_modules/d3-interpolate/src/number.js");


var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
    reB = new RegExp(reA.source, "g");

function zero(b) {
  return function() {
    return b;
  };
}

function one(b) {
  return function(t) {
    return b(t) + "";
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
      am, // current match in a
      bm, // current match in b
      bs, // string preceding current number in b, if any
      i = -1, // index in s
      s = [], // string constants and placeholders
      q = []; // number interpolators

  // Coerce inputs to strings.
  a = a + "", b = b + "";

  // Interpolate pairs of numbers in a & b.
  while ((am = reA.exec(a))
      && (bm = reB.exec(b))) {
    if ((bs = bm.index) > bi) { // a string precedes the next number in b
      bs = b.slice(bi, bs);
      if (s[i]) s[i] += bs; // coalesce with previous string
      else s[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
      if (s[i]) s[i] += bm; // coalesce with previous string
      else s[++i] = bm;
    } else { // interpolate non-matching numbers
      s[++i] = null;
      q.push({i: i, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(am, bm)});
    }
    bi = reB.lastIndex;
  }

  // Add remains of b.
  if (bi < b.length) {
    bs = b.slice(bi);
    if (s[i]) s[i] += bs; // coalesce with previous string
    else s[++i] = bs;
  }

  // Special optimization for only a single match.
  // Otherwise, interpolate each of the numbers and rejoin the string.
  return s.length < 2 ? (q[0]
      ? one(q[0].x)
      : zero(b))
      : (b = q.length, function(t) {
          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
          return s.join("");
        });
});


/***/ }),

/***/ "./node_modules/d3-interpolate/src/transform/decompose.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return identity; });
var degrees = 180 / Math.PI;

var identity = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};

/* harmony default export */ __webpack_exports__["a"] = (function(a, b, c, d, e, f) {
  var scaleX, scaleY, skewX;
  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
  return {
    translateX: e,
    translateY: f,
    rotate: Math.atan2(b, a) * degrees,
    skewX: Math.atan(skewX) * degrees,
    scaleX: scaleX,
    scaleY: scaleY
  };
});


/***/ }),

/***/ "./node_modules/d3-interpolate/src/transform/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return interpolateTransformCss; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return interpolateTransformSvg; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__("./node_modules/d3-interpolate/src/number.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parse__ = __webpack_require__("./node_modules/d3-interpolate/src/transform/parse.js");



function interpolateTransform(parse, pxComma, pxParen, degParen) {

  function pop(s) {
    return s.length ? s.pop() + " " : "";
  }

  function translate(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push("translate(", null, pxComma, null, pxParen);
      q.push({i: i - 4, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(xa, xb)}, {i: i - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(ya, yb)});
    } else if (xb || yb) {
      s.push("translate(" + xb + pxComma + yb + pxParen);
    }
  }

  function rotate(a, b, s, q) {
    if (a !== b) {
      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(a, b)});
    } else if (b) {
      s.push(pop(s) + "rotate(" + b + degParen);
    }
  }

  function skewX(a, b, s, q) {
    if (a !== b) {
      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(a, b)});
    } else if (b) {
      s.push(pop(s) + "skewX(" + b + degParen);
    }
  }

  function scale(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
      q.push({i: i - 4, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(xa, xb)}, {i: i - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(ya, yb)});
    } else if (xb !== 1 || yb !== 1) {
      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
  }

  return function(a, b) {
    var s = [], // string constants and placeholders
        q = []; // number interpolators
    a = parse(a), b = parse(b);
    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
    rotate(a.rotate, b.rotate, s, q);
    skewX(a.skewX, b.skewX, s, q);
    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
    a = b = null; // gc
    return function(t) {
      var i = -1, n = q.length, o;
      while (++i < n) s[(o = q[i]).i] = o.x(t);
      return s.join("");
    };
  };
}

var interpolateTransformCss = interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse__["a" /* parseCss */], "px, ", "px)", "deg)");
var interpolateTransformSvg = interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse__["b" /* parseSvg */], ", ", ")", ")");


/***/ }),

/***/ "./node_modules/d3-interpolate/src/transform/parse.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseCss;
/* harmony export (immutable) */ __webpack_exports__["b"] = parseSvg;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__decompose__ = __webpack_require__("./node_modules/d3-interpolate/src/transform/decompose.js");


var cssNode,
    cssRoot,
    cssView,
    svgNode;

function parseCss(value) {
  if (value === "none") return __WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* identity */];
  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
  cssNode.style.transform = value;
  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
  cssRoot.removeChild(cssNode);
  value = value.slice(7, -1).split(",");
  return Object(__WEBPACK_IMPORTED_MODULE_0__decompose__["a" /* default */])(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
}

function parseSvg(value) {
  if (value == null) return __WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* identity */];
  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
  svgNode.setAttribute("transform", value);
  if (!(value = svgNode.transform.baseVal.consolidate())) return __WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* identity */];
  value = value.matrix;
  return Object(__WEBPACK_IMPORTED_MODULE_0__decompose__["a" /* default */])(value.a, value.b, value.c, value.d, value.e, value.f);
}


/***/ }),

/***/ "./node_modules/d3-interpolate/src/value.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__("./node_modules/d3-color/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rgb__ = __webpack_require__("./node_modules/d3-interpolate/src/rgb.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__array__ = __webpack_require__("./node_modules/d3-interpolate/src/array.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__date__ = __webpack_require__("./node_modules/d3-interpolate/src/date.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__number__ = __webpack_require__("./node_modules/d3-interpolate/src/number.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__object__ = __webpack_require__("./node_modules/d3-interpolate/src/object.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__string__ = __webpack_require__("./node_modules/d3-interpolate/src/string.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constant__ = __webpack_require__("./node_modules/d3-interpolate/src/constant.js");









/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var t = typeof b, c;
  return b == null || t === "boolean" ? Object(__WEBPACK_IMPORTED_MODULE_7__constant__["a" /* default */])(b)
      : (t === "number" ? __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */]
      : t === "string" ? ((c = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* color */])(b)) ? (b = c, __WEBPACK_IMPORTED_MODULE_1__rgb__["a" /* default */]) : __WEBPACK_IMPORTED_MODULE_6__string__["a" /* default */])
      : b instanceof __WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* color */] ? __WEBPACK_IMPORTED_MODULE_1__rgb__["a" /* default */]
      : b instanceof Date ? __WEBPACK_IMPORTED_MODULE_3__date__["a" /* default */]
      : Array.isArray(b) ? __WEBPACK_IMPORTED_MODULE_2__array__["a" /* default */]
      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? __WEBPACK_IMPORTED_MODULE_5__object__["a" /* default */]
      : __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */])(a, b);
});


/***/ }),

/***/ "./node_modules/d3-interpolate/src/zoom.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var rho = Math.SQRT2,
    rho2 = 2,
    rho4 = 4,
    epsilon2 = 1e-12;

function cosh(x) {
  return ((x = Math.exp(x)) + 1 / x) / 2;
}

function sinh(x) {
  return ((x = Math.exp(x)) - 1 / x) / 2;
}

function tanh(x) {
  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}

// p0 = [ux0, uy0, w0]
// p1 = [ux1, uy1, w1]
/* harmony default export */ __webpack_exports__["a"] = (function(p0, p1) {
  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
      dx = ux1 - ux0,
      dy = uy1 - uy0,
      d2 = dx * dx + dy * dy,
      i,
      S;

  // Special case for u0 ≅ u1.
  if (d2 < epsilon2) {
    S = Math.log(w1 / w0) / rho;
    i = function(t) {
      return [
        ux0 + t * dx,
        uy0 + t * dy,
        w0 * Math.exp(rho * t * S)
      ];
    }
  }

  // General case.
  else {
    var d1 = Math.sqrt(d2),
        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
    S = (r1 - r0) / rho;
    i = function(t) {
      var s = t * S,
          coshr0 = cosh(r0),
          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
      return [
        ux0 + u * dx,
        uy0 + u * dy,
        w0 * coshr0 / cosh(rho * s + r0)
      ];
    }
  }

  i.duration = S * 1000;

  return i;
});


/***/ }),

/***/ "./node_modules/d3-path/src/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__path__ = __webpack_require__("./node_modules/d3-path/src/path.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__path__["a"]; });



/***/ }),

/***/ "./node_modules/d3-path/src/path.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var pi = Math.PI,
    tau = 2 * pi,
    epsilon = 1e-6,
    tauEpsilon = tau - epsilon;

function Path() {
  this._x0 = this._y0 = // start of current subpath
  this._x1 = this._y1 = null; // end of current subpath
  this._ = "";
}

function path() {
  return new Path;
}

Path.prototype = path.prototype = {
  constructor: Path,
  moveTo: function(x, y) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
  },
  closePath: function() {
    if (this._x1 !== null) {
      this._x1 = this._x0, this._y1 = this._y0;
      this._ += "Z";
    }
  },
  lineTo: function(x, y) {
    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  quadraticCurveTo: function(x1, y1, x, y) {
    this._ += "Q" + (+x1) + "," + (+y1) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
    this._ += "C" + (+x1) + "," + (+y1) + "," + (+x2) + "," + (+y2) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  arcTo: function(x1, y1, x2, y2, r) {
    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
    var x0 = this._x1,
        y0 = this._y1,
        x21 = x2 - x1,
        y21 = y2 - y1,
        x01 = x0 - x1,
        y01 = y0 - y1,
        l01_2 = x01 * x01 + y01 * y01;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x1,y1).
    if (this._x1 === null) {
      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
    else if (!(l01_2 > epsilon));

    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
    // Equivalently, is (x1,y1) coincident with (x2,y2)?
    // Or, is the radius zero? Line to (x1,y1).
    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) {
      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Otherwise, draw an arc!
    else {
      var x20 = x2 - x0,
          y20 = y2 - y0,
          l21_2 = x21 * x21 + y21 * y21,
          l20_2 = x20 * x20 + y20 * y20,
          l21 = Math.sqrt(l21_2),
          l01 = Math.sqrt(l01_2),
          l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
          t01 = l / l01,
          t21 = l / l21;

      // If the start tangent is not coincident with (x0,y0), line to.
      if (Math.abs(t01 - 1) > epsilon) {
        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
      }

      this._ += "A" + r + "," + r + ",0,0," + (+(y01 * x20 > x01 * y20)) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
    }
  },
  arc: function(x, y, r, a0, a1, ccw) {
    x = +x, y = +y, r = +r;
    var dx = r * Math.cos(a0),
        dy = r * Math.sin(a0),
        x0 = x + dx,
        y0 = y + dy,
        cw = 1 ^ ccw,
        da = ccw ? a0 - a1 : a1 - a0;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x0,y0).
    if (this._x1 === null) {
      this._ += "M" + x0 + "," + y0;
    }

    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
    else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) {
      this._ += "L" + x0 + "," + y0;
    }

    // Is this arc empty? We’re done.
    if (!r) return;

    // Does the angle go the wrong way? Flip the direction.
    if (da < 0) da = da % tau + tau;

    // Is this a complete circle? Draw two arcs to complete the circle.
    if (da > tauEpsilon) {
      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
    }

    // Is this arc non-empty? Draw an arc!
    else if (da > epsilon) {
      this._ += "A" + r + "," + r + ",0," + (+(da >= pi)) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    }
  },
  rect: function(x, y, w, h) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + (+w) + "v" + (+h) + "h" + (-w) + "Z";
  },
  toString: function() {
    return this._;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (path);


/***/ }),

/***/ "./node_modules/d3-polygon/src/area.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(polygon) {
  var i = -1,
      n = polygon.length,
      a,
      b = polygon[n - 1],
      area = 0;

  while (++i < n) {
    a = b;
    b = polygon[i];
    area += a[1] * b[0] - a[0] * b[1];
  }

  return area / 2;
});


/***/ }),

/***/ "./node_modules/d3-polygon/src/centroid.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(polygon) {
  var i = -1,
      n = polygon.length,
      x = 0,
      y = 0,
      a,
      b = polygon[n - 1],
      c,
      k = 0;

  while (++i < n) {
    a = b;
    b = polygon[i];
    k += c = a[0] * b[1] - b[0] * a[1];
    x += (a[0] + b[0]) * c;
    y += (a[1] + b[1]) * c;
  }

  return k *= 3, [x / k, y / k];
});


/***/ }),

/***/ "./node_modules/d3-polygon/src/contains.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(polygon, point) {
  var n = polygon.length,
      p = polygon[n - 1],
      x = point[0], y = point[1],
      x0 = p[0], y0 = p[1],
      x1, y1,
      inside = false;

  for (var i = 0; i < n; ++i) {
    p = polygon[i], x1 = p[0], y1 = p[1];
    if (((y1 > y) !== (y0 > y)) && (x < (x0 - x1) * (y - y1) / (y0 - y1) + x1)) inside = !inside;
    x0 = x1, y0 = y1;
  }

  return inside;
});


/***/ }),

/***/ "./node_modules/d3-polygon/src/cross.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Returns the 2D cross product of AB and AC vectors, i.e., the z-component of
// the 3D cross product in a quadrant I Cartesian coordinate system (+x is
// right, +y is up). Returns a positive value if ABC is counter-clockwise,
// negative if clockwise, and zero if the points are collinear.
/* harmony default export */ __webpack_exports__["a"] = (function(a, b, c) {
  return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
});


/***/ }),

/***/ "./node_modules/d3-polygon/src/hull.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cross__ = __webpack_require__("./node_modules/d3-polygon/src/cross.js");


function lexicographicOrder(a, b) {
  return a[0] - b[0] || a[1] - b[1];
}

// Computes the upper convex hull per the monotone chain algorithm.
// Assumes points.length >= 3, is sorted by x, unique in y.
// Returns an array of indices into points in left-to-right order.
function computeUpperHullIndexes(points) {
  var n = points.length,
      indexes = [0, 1],
      size = 2;

  for (var i = 2; i < n; ++i) {
    while (size > 1 && Object(__WEBPACK_IMPORTED_MODULE_0__cross__["a" /* default */])(points[indexes[size - 2]], points[indexes[size - 1]], points[i]) <= 0) --size;
    indexes[size++] = i;
  }

  return indexes.slice(0, size); // remove popped points
}

/* harmony default export */ __webpack_exports__["a"] = (function(points) {
  if ((n = points.length) < 3) return null;

  var i,
      n,
      sortedPoints = new Array(n),
      flippedPoints = new Array(n);

  for (i = 0; i < n; ++i) sortedPoints[i] = [+points[i][0], +points[i][1], i];
  sortedPoints.sort(lexicographicOrder);
  for (i = 0; i < n; ++i) flippedPoints[i] = [sortedPoints[i][0], -sortedPoints[i][1]];

  var upperIndexes = computeUpperHullIndexes(sortedPoints),
      lowerIndexes = computeUpperHullIndexes(flippedPoints);

  // Construct the hull polygon, removing possible duplicate endpoints.
  var skipLeft = lowerIndexes[0] === upperIndexes[0],
      skipRight = lowerIndexes[lowerIndexes.length - 1] === upperIndexes[upperIndexes.length - 1],
      hull = [];

  // Add upper hull in right-to-l order.
  // Then add lower hull in left-to-right order.
  for (i = upperIndexes.length - 1; i >= 0; --i) hull.push(points[sortedPoints[upperIndexes[i]][2]]);
  for (i = +skipLeft; i < lowerIndexes.length - skipRight; ++i) hull.push(points[sortedPoints[lowerIndexes[i]][2]]);

  return hull;
});


/***/ }),

/***/ "./node_modules/d3-polygon/src/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__area__ = __webpack_require__("./node_modules/d3-polygon/src/area.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__area__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__centroid__ = __webpack_require__("./node_modules/d3-polygon/src/centroid.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__centroid__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hull__ = __webpack_require__("./node_modules/d3-polygon/src/hull.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__hull__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__contains__ = __webpack_require__("./node_modules/d3-polygon/src/contains.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__contains__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__length__ = __webpack_require__("./node_modules/d3-polygon/src/length.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__length__["a"]; });







/***/ }),

/***/ "./node_modules/d3-polygon/src/length.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(polygon) {
  var i = -1,
      n = polygon.length,
      b = polygon[n - 1],
      xa,
      ya,
      xb = b[0],
      yb = b[1],
      perimeter = 0;

  while (++i < n) {
    xa = xb;
    ya = yb;
    b = polygon[i];
    xb = b[0];
    yb = b[1];
    xa -= xb;
    ya -= yb;
    perimeter += Math.sqrt(xa * xa + ya * ya);
  }

  return perimeter;
});


/***/ }),

/***/ "./node_modules/d3-quadtree/src/add.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addAll;
/* harmony default export */ __webpack_exports__["b"] = (function(d) {
  var x = +this._x.call(null, d),
      y = +this._y.call(null, d);
  return add(this.cover(x, y), x, y, d);
});

function add(tree, x, y, d) {
  if (isNaN(x) || isNaN(y)) return tree; // ignore invalid points

  var parent,
      node = tree._root,
      leaf = {data: d},
      x0 = tree._x0,
      y0 = tree._y0,
      x1 = tree._x1,
      y1 = tree._y1,
      xm,
      ym,
      xp,
      yp,
      right,
      bottom,
      i,
      j;

  // If the tree is empty, initialize the root as a leaf.
  if (!node) return tree._root = leaf, tree;

  // Find the existing leaf for the new point, or add it.
  while (node.length) {
    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
    if (parent = node, !(node = node[i = bottom << 1 | right])) return parent[i] = leaf, tree;
  }

  // Is the new point is exactly coincident with the existing point?
  xp = +tree._x.call(null, node.data);
  yp = +tree._y.call(null, node.data);
  if (x === xp && y === yp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;

  // Otherwise, split the leaf node until the old and new point are separated.
  do {
    parent = parent ? parent[i] = new Array(4) : tree._root = new Array(4);
    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
  } while ((i = bottom << 1 | right) === (j = (yp >= ym) << 1 | (xp >= xm)));
  return parent[j] = node, parent[i] = leaf, tree;
}

function addAll(data) {
  var d, i, n = data.length,
      x,
      y,
      xz = new Array(n),
      yz = new Array(n),
      x0 = Infinity,
      y0 = Infinity,
      x1 = -Infinity,
      y1 = -Infinity;

  // Compute the points and their extent.
  for (i = 0; i < n; ++i) {
    if (isNaN(x = +this._x.call(null, d = data[i])) || isNaN(y = +this._y.call(null, d))) continue;
    xz[i] = x;
    yz[i] = y;
    if (x < x0) x0 = x;
    if (x > x1) x1 = x;
    if (y < y0) y0 = y;
    if (y > y1) y1 = y;
  }

  // If there were no (valid) points, inherit the existing extent.
  if (x1 < x0) x0 = this._x0, x1 = this._x1;
  if (y1 < y0) y0 = this._y0, y1 = this._y1;

  // Expand the tree to cover the new points.
  this.cover(x0, y0).cover(x1, y1);

  // Add the new points.
  for (i = 0; i < n; ++i) {
    add(this, xz[i], yz[i], data[i]);
  }

  return this;
}


/***/ }),

/***/ "./node_modules/d3-quadtree/src/cover.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x, y) {
  if (isNaN(x = +x) || isNaN(y = +y)) return this; // ignore invalid points

  var x0 = this._x0,
      y0 = this._y0,
      x1 = this._x1,
      y1 = this._y1;

  // If the quadtree has no extent, initialize them.
  // Integer extent are necessary so that if we later double the extent,
  // the existing quadrant boundaries don’t change due to floating point error!
  if (isNaN(x0)) {
    x1 = (x0 = Math.floor(x)) + 1;
    y1 = (y0 = Math.floor(y)) + 1;
  }

  // Otherwise, double repeatedly to cover.
  else if (x0 > x || x > x1 || y0 > y || y > y1) {
    var z = x1 - x0,
        node = this._root,
        parent,
        i;

    switch (i = (y < (y0 + y1) / 2) << 1 | (x < (x0 + x1) / 2)) {
      case 0: {
        do parent = new Array(4), parent[i] = node, node = parent;
        while (z *= 2, x1 = x0 + z, y1 = y0 + z, x > x1 || y > y1);
        break;
      }
      case 1: {
        do parent = new Array(4), parent[i] = node, node = parent;
        while (z *= 2, x0 = x1 - z, y1 = y0 + z, x0 > x || y > y1);
        break;
      }
      case 2: {
        do parent = new Array(4), parent[i] = node, node = parent;
        while (z *= 2, x1 = x0 + z, y0 = y1 - z, x > x1 || y0 > y);
        break;
      }
      case 3: {
        do parent = new Array(4), parent[i] = node, node = parent;
        while (z *= 2, x0 = x1 - z, y0 = y1 - z, x0 > x || y0 > y);
        break;
      }
    }

    if (this._root && this._root.length) this._root = node;
  }

  // If the quadtree covers the point already, just return.
  else return this;

  this._x0 = x0;
  this._y0 = y0;
  this._x1 = x1;
  this._y1 = y1;
  return this;
});


/***/ }),

/***/ "./node_modules/d3-quadtree/src/data.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var data = [];
  this.visit(function(node) {
    if (!node.length) do data.push(node.data); while (node = node.next)
  });
  return data;
});


/***/ }),

/***/ "./node_modules/d3-quadtree/src/extent.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(_) {
  return arguments.length
      ? this.cover(+_[0][0], +_[0][1]).cover(+_[1][0], +_[1][1])
      : isNaN(this._x0) ? undefined : [[this._x0, this._y0], [this._x1, this._y1]];
});


/***/ }),

/***/ "./node_modules/d3-quadtree/src/find.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__quad__ = __webpack_require__("./node_modules/d3-quadtree/src/quad.js");


/* harmony default export */ __webpack_exports__["a"] = (function(x, y, radius) {
  var data,
      x0 = this._x0,
      y0 = this._y0,
      x1,
      y1,
      x2,
      y2,
      x3 = this._x1,
      y3 = this._y1,
      quads = [],
      node = this._root,
      q,
      i;

  if (node) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](node, x0, y0, x3, y3));
  if (radius == null) radius = Infinity;
  else {
    x0 = x - radius, y0 = y - radius;
    x3 = x + radius, y3 = y + radius;
    radius *= radius;
  }

  while (q = quads.pop()) {

    // Stop searching if this quadrant can’t contain a closer node.
    if (!(node = q.node)
        || (x1 = q.x0) > x3
        || (y1 = q.y0) > y3
        || (x2 = q.x1) < x0
        || (y2 = q.y1) < y0) continue;

    // Bisect the current quadrant.
    if (node.length) {
      var xm = (x1 + x2) / 2,
          ym = (y1 + y2) / 2;

      quads.push(
        new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](node[3], xm, ym, x2, y2),
        new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](node[2], x1, ym, xm, y2),
        new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](node[1], xm, y1, x2, ym),
        new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](node[0], x1, y1, xm, ym)
      );

      // Visit the closest quadrant first.
      if (i = (y >= ym) << 1 | (x >= xm)) {
        q = quads[quads.length - 1];
        quads[quads.length - 1] = quads[quads.length - 1 - i];
        quads[quads.length - 1 - i] = q;
      }
    }

    // Visit this point. (Visiting coincident points isn’t necessary!)
    else {
      var dx = x - +this._x.call(null, node.data),
          dy = y - +this._y.call(null, node.data),
          d2 = dx * dx + dy * dy;
      if (d2 < radius) {
        var d = Math.sqrt(radius = d2);
        x0 = x - d, y0 = y - d;
        x3 = x + d, y3 = y + d;
        data = node.data;
      }
    }
  }

  return data;
});


/***/ }),

/***/ "./node_modules/d3-quadtree/src/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__quadtree__ = __webpack_require__("./node_modules/d3-quadtree/src/quadtree.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__quadtree__["a"]; });



/***/ }),

/***/ "./node_modules/d3-quadtree/src/quad.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(node, x0, y0, x1, y1) {
  this.node = node;
  this.x0 = x0;
  this.y0 = y0;
  this.x1 = x1;
  this.y1 = y1;
});


/***/ }),

/***/ "./node_modules/d3-quadtree/src/quadtree.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = quadtree;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__add__ = __webpack_require__("./node_modules/d3-quadtree/src/add.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cover__ = __webpack_require__("./node_modules/d3-quadtree/src/cover.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data__ = __webpack_require__("./node_modules/d3-quadtree/src/data.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__extent__ = __webpack_require__("./node_modules/d3-quadtree/src/extent.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__find__ = __webpack_require__("./node_modules/d3-quadtree/src/find.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__remove__ = __webpack_require__("./node_modules/d3-quadtree/src/remove.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__root__ = __webpack_require__("./node_modules/d3-quadtree/src/root.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__size__ = __webpack_require__("./node_modules/d3-quadtree/src/size.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__visit__ = __webpack_require__("./node_modules/d3-quadtree/src/visit.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__visitAfter__ = __webpack_require__("./node_modules/d3-quadtree/src/visitAfter.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__x__ = __webpack_require__("./node_modules/d3-quadtree/src/x.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__y__ = __webpack_require__("./node_modules/d3-quadtree/src/y.js");













function quadtree(nodes, x, y) {
  var tree = new Quadtree(x == null ? __WEBPACK_IMPORTED_MODULE_10__x__["b" /* defaultX */] : x, y == null ? __WEBPACK_IMPORTED_MODULE_11__y__["b" /* defaultY */] : y, NaN, NaN, NaN, NaN);
  return nodes == null ? tree : tree.addAll(nodes);
}

function Quadtree(x, y, x0, y0, x1, y1) {
  this._x = x;
  this._y = y;
  this._x0 = x0;
  this._y0 = y0;
  this._x1 = x1;
  this._y1 = y1;
  this._root = undefined;
}

function leaf_copy(leaf) {
  var copy = {data: leaf.data}, next = copy;
  while (leaf = leaf.next) next = next.next = {data: leaf.data};
  return copy;
}

var treeProto = quadtree.prototype = Quadtree.prototype;

treeProto.copy = function() {
  var copy = new Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1),
      node = this._root,
      nodes,
      child;

  if (!node) return copy;

  if (!node.length) return copy._root = leaf_copy(node), copy;

  nodes = [{source: node, target: copy._root = new Array(4)}];
  while (node = nodes.pop()) {
    for (var i = 0; i < 4; ++i) {
      if (child = node.source[i]) {
        if (child.length) nodes.push({source: child, target: node.target[i] = new Array(4)});
        else node.target[i] = leaf_copy(child);
      }
    }
  }

  return copy;
};

treeProto.add = __WEBPACK_IMPORTED_MODULE_0__add__["b" /* default */];
treeProto.addAll = __WEBPACK_IMPORTED_MODULE_0__add__["a" /* addAll */];
treeProto.cover = __WEBPACK_IMPORTED_MODULE_1__cover__["a" /* default */];
treeProto.data = __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */];
treeProto.extent = __WEBPACK_IMPORTED_MODULE_3__extent__["a" /* default */];
treeProto.find = __WEBPACK_IMPORTED_MODULE_4__find__["a" /* default */];
treeProto.remove = __WEBPACK_IMPORTED_MODULE_5__remove__["a" /* default */];
treeProto.removeAll = __WEBPACK_IMPORTED_MODULE_5__remove__["b" /* removeAll */];
treeProto.root = __WEBPACK_IMPORTED_MODULE_6__root__["a" /* default */];
treeProto.size = __WEBPACK_IMPORTED_MODULE_7__size__["a" /* default */];
treeProto.visit = __WEBPACK_IMPORTED_MODULE_8__visit__["a" /* default */];
treeProto.visitAfter = __WEBPACK_IMPORTED_MODULE_9__visitAfter__["a" /* default */];
treeProto.x = __WEBPACK_IMPORTED_MODULE_10__x__["a" /* default */];
treeProto.y = __WEBPACK_IMPORTED_MODULE_11__y__["a" /* default */];


/***/ }),

/***/ "./node_modules/d3-quadtree/src/remove.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = removeAll;
/* harmony default export */ __webpack_exports__["a"] = (function(d) {
  if (isNaN(x = +this._x.call(null, d)) || isNaN(y = +this._y.call(null, d))) return this; // ignore invalid points

  var parent,
      node = this._root,
      retainer,
      previous,
      next,
      x0 = this._x0,
      y0 = this._y0,
      x1 = this._x1,
      y1 = this._y1,
      x,
      y,
      xm,
      ym,
      right,
      bottom,
      i,
      j;

  // If the tree is empty, initialize the root as a leaf.
  if (!node) return this;

  // Find the leaf node for the point.
  // While descending, also retain the deepest parent with a non-removed sibling.
  if (node.length) while (true) {
    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
    if (!(parent = node, node = node[i = bottom << 1 | right])) return this;
    if (!node.length) break;
    if (parent[(i + 1) & 3] || parent[(i + 2) & 3] || parent[(i + 3) & 3]) retainer = parent, j = i;
  }

  // Find the point to remove.
  while (node.data !== d) if (!(previous = node, node = node.next)) return this;
  if (next = node.next) delete node.next;

  // If there are multiple coincident points, remove just the point.
  if (previous) return (next ? previous.next = next : delete previous.next), this;

  // If this is the root point, remove it.
  if (!parent) return this._root = next, this;

  // Remove this leaf.
  next ? parent[i] = next : delete parent[i];

  // If the parent now contains exactly one leaf, collapse superfluous parents.
  if ((node = parent[0] || parent[1] || parent[2] || parent[3])
      && node === (parent[3] || parent[2] || parent[1] || parent[0])
      && !node.length) {
    if (retainer) retainer[j] = node;
    else this._root = node;
  }

  return this;
});

function removeAll(data) {
  for (var i = 0, n = data.length; i < n; ++i) this.remove(data[i]);
  return this;
}


/***/ }),

/***/ "./node_modules/d3-quadtree/src/root.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  return this._root;
});


/***/ }),

/***/ "./node_modules/d3-quadtree/src/size.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var size = 0;
  this.visit(function(node) {
    if (!node.length) do ++size; while (node = node.next)
  });
  return size;
});


/***/ }),

/***/ "./node_modules/d3-quadtree/src/visit.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__quad__ = __webpack_require__("./node_modules/d3-quadtree/src/quad.js");


/* harmony default export */ __webpack_exports__["a"] = (function(callback) {
  var quads = [], q, node = this._root, child, x0, y0, x1, y1;
  if (node) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](node, this._x0, this._y0, this._x1, this._y1));
  while (q = quads.pop()) {
    if (!callback(node = q.node, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1) && node.length) {
      var xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
      if (child = node[3]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, xm, ym, x1, y1));
      if (child = node[2]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, x0, ym, xm, y1));
      if (child = node[1]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, xm, y0, x1, ym));
      if (child = node[0]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, x0, y0, xm, ym));
    }
  }
  return this;
});


/***/ }),

/***/ "./node_modules/d3-quadtree/src/visitAfter.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__quad__ = __webpack_require__("./node_modules/d3-quadtree/src/quad.js");


/* harmony default export */ __webpack_exports__["a"] = (function(callback) {
  var quads = [], next = [], q;
  if (this._root) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](this._root, this._x0, this._y0, this._x1, this._y1));
  while (q = quads.pop()) {
    var node = q.node;
    if (node.length) {
      var child, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1, xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
      if (child = node[0]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, x0, y0, xm, ym));
      if (child = node[1]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, xm, y0, x1, ym));
      if (child = node[2]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, x0, ym, xm, y1));
      if (child = node[3]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, xm, ym, x1, y1));
    }
    next.push(q);
  }
  while (q = next.pop()) {
    callback(q.node, q.x0, q.y0, q.x1, q.y1);
  }
  return this;
});


/***/ }),

/***/ "./node_modules/d3-quadtree/src/x.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = defaultX;
function defaultX(d) {
  return d[0];
}

/* harmony default export */ __webpack_exports__["a"] = (function(_) {
  return arguments.length ? (this._x = _, this) : this._x;
});


/***/ }),

/***/ "./node_modules/d3-quadtree/src/y.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = defaultY;
function defaultY(d) {
  return d[1];
}

/* harmony default export */ __webpack_exports__["a"] = (function(_) {
  return arguments.length ? (this._y = _, this) : this._y;
});


/***/ }),

/***/ "./node_modules/d3-random/src/bates.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultSource__ = __webpack_require__("./node_modules/d3-random/src/defaultSource.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__irwinHall__ = __webpack_require__("./node_modules/d3-random/src/irwinHall.js");



/* harmony default export */ __webpack_exports__["a"] = ((function sourceRandomBates(source) {
  function randomBates(n) {
    var randomIrwinHall = __WEBPACK_IMPORTED_MODULE_1__irwinHall__["a" /* default */].source(source)(n);
    return function() {
      return randomIrwinHall() / n;
    };
  }

  randomBates.source = sourceRandomBates;

  return randomBates;
})(__WEBPACK_IMPORTED_MODULE_0__defaultSource__["a" /* default */]));


/***/ }),

/***/ "./node_modules/d3-random/src/defaultSource.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Math.random();
});


/***/ }),

/***/ "./node_modules/d3-random/src/exponential.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultSource__ = __webpack_require__("./node_modules/d3-random/src/defaultSource.js");


/* harmony default export */ __webpack_exports__["a"] = ((function sourceRandomExponential(source) {
  function randomExponential(lambda) {
    return function() {
      return -Math.log(1 - source()) / lambda;
    };
  }

  randomExponential.source = sourceRandomExponential;

  return randomExponential;
})(__WEBPACK_IMPORTED_MODULE_0__defaultSource__["a" /* default */]));


/***/ }),

/***/ "./node_modules/d3-random/src/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__uniform__ = __webpack_require__("./node_modules/d3-random/src/uniform.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__uniform__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__normal__ = __webpack_require__("./node_modules/d3-random/src/normal.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__normal__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__logNormal__ = __webpack_require__("./node_modules/d3-random/src/logNormal.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__logNormal__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bates__ = __webpack_require__("./node_modules/d3-random/src/bates.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__bates__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__irwinHall__ = __webpack_require__("./node_modules/d3-random/src/irwinHall.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__irwinHall__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__exponential__ = __webpack_require__("./node_modules/d3-random/src/exponential.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_5__exponential__["a"]; });








/***/ }),

/***/ "./node_modules/d3-random/src/irwinHall.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultSource__ = __webpack_require__("./node_modules/d3-random/src/defaultSource.js");


/* harmony default export */ __webpack_exports__["a"] = ((function sourceRandomIrwinHall(source) {
  function randomIrwinHall(n) {
    return function() {
      for (var sum = 0, i = 0; i < n; ++i) sum += source();
      return sum;
    };
  }

  randomIrwinHall.source = sourceRandomIrwinHall;

  return randomIrwinHall;
})(__WEBPACK_IMPORTED_MODULE_0__defaultSource__["a" /* default */]));


/***/ }),

/***/ "./node_modules/d3-random/src/logNormal.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultSource__ = __webpack_require__("./node_modules/d3-random/src/defaultSource.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__normal__ = __webpack_require__("./node_modules/d3-random/src/normal.js");



/* harmony default export */ __webpack_exports__["a"] = ((function sourceRandomLogNormal(source) {
  function randomLogNormal() {
    var randomNormal = __WEBPACK_IMPORTED_MODULE_1__normal__["a" /* default */].source(source).apply(this, arguments);
    return function() {
      return Math.exp(randomNormal());
    };
  }

  randomLogNormal.source = sourceRandomLogNormal;

  return randomLogNormal;
})(__WEBPACK_IMPORTED_MODULE_0__defaultSource__["a" /* default */]));


/***/ }),

/***/ "./node_modules/d3-random/src/normal.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultSource__ = __webpack_require__("./node_modules/d3-random/src/defaultSource.js");


/* harmony default export */ __webpack_exports__["a"] = ((function sourceRandomNormal(source) {
  function randomNormal(mu, sigma) {
    var x, r;
    mu = mu == null ? 0 : +mu;
    sigma = sigma == null ? 1 : +sigma;
    return function() {
      var y;

      // If available, use the second previously-generated uniform random.
      if (x != null) y = x, x = null;

      // Otherwise, generate a new x and y.
      else do {
        x = source() * 2 - 1;
        y = source() * 2 - 1;
        r = x * x + y * y;
      } while (!r || r > 1);

      return mu + sigma * y * Math.sqrt(-2 * Math.log(r) / r);
    };
  }

  randomNormal.source = sourceRandomNormal;

  return randomNormal;
})(__WEBPACK_IMPORTED_MODULE_0__defaultSource__["a" /* default */]));


/***/ }),

/***/ "./node_modules/d3-random/src/uniform.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultSource__ = __webpack_require__("./node_modules/d3-random/src/defaultSource.js");


/* harmony default export */ __webpack_exports__["a"] = ((function sourceRandomUniform(source) {
  function randomUniform(min, max) {
    min = min == null ? 0 : +min;
    max = max == null ? 1 : +max;
    if (arguments.length === 1) max = min, min = 0;
    else max -= min;
    return function() {
      return source() * max + min;
    };
  }

  randomUniform.source = sourceRandomUniform;

  return randomUniform;
})(__WEBPACK_IMPORTED_MODULE_0__defaultSource__["a" /* default */]));


/***/ }),

/***/ "./node_modules/d3-scale-chromatic/src/categorical/Accent.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/colors.js");


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666"));


/***/ }),

/***/ "./node_modules/d3-scale-chromatic/src/categorical/Dark2.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/colors.js");


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666"));


/***/ }),

/***/ "./node_modules/d3-scale-chromatic/src/categorical/Paired.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/colors.js");


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928"));


/***/ }),

/***/ "./node_modules/d3-scale-chromatic/src/categorical/Pastel1.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/colors.js");


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2"));


/***/ }),

/***/ "./node_modules/d3-scale-chromatic/src/categorical/Pastel2.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/colors.js");


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc"));


/***/ }),

/***/ "./node_modules/d3-scale-chromatic/src/categorical/Set1.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/colors.js");


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("e41a1c377eb84daf4a984ea3ff7f00ffff33a65628f781bf999999"));


/***/ }),

/***/ "./node_modules/d3-scale-chromatic/src/categorical/Set2.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/colors.js");


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3"));


/***/ }),

/***/ "./node_modules/d3-scale-chromatic/src/categorical/Set3.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/colors.js");


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f"));


/***/ }),

/***/ "./node_modules/d3-scale-chromatic/src/categorical/category10.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/colors.js");


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf"));


/***/ }),

/***/ "./node_modules/d3-scale-chromatic/src/colors.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(specifier) {
  var n = specifier.length / 6 | 0, colors = new Array(n), i = 0;
  while (i < n) colors[i] = "#" + specifier.slice(i * 6, ++i * 6);
  return colors;
});


/***/ }),

/***/ "./node_modules/d3-scale-chromatic/src/diverging/BrBG.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/colors.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/ramp.js");



var scheme = new Array(3).concat(
  "d8b365f5f5f55ab4ac",
  "a6611adfc27d80cdc1018571",
  "a6611adfc27df5f5f580cdc1018571",
  "8c510ad8b365f6e8c3c7eae55ab4ac01665e",
  "8c510ad8b365f6e8c3f5f5f5c7eae55ab4ac01665e",
  "8c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e",
  "8c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e",
  "5430058c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e003c30",
  "5430058c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e003c30"
).map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));


/***/ }),

/***/ "./node_modules/d3-scale-chromatic/src/diverging/PRGn.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/colors.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/ramp.js");



var scheme = new Array(3).concat(
  "af8dc3f7f7f77fbf7b",
  "7b3294c2a5cfa6dba0008837",
  "7b3294c2a5cff7f7f7a6dba0008837",
  "762a83af8dc3e7d4e8d9f0d37fbf7b1b7837",
  "762a83af8dc3e7d4e8f7f7f7d9f0d37fbf7b1b7837",
  "762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b7837",
  "762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b7837",
  "40004b762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b783700441b",
  "40004b762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b783700441b"
).map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));


/***/ }),

/***/ "./node_modules/d3-scale-chromatic/src/diverging/PiYG.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/colors.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/ramp.js");



var scheme = new Array(3).concat(
  "e9a3c9f7f7f7a1d76a",
  "d01c8bf1b6dab8e1864dac26",
  "d01c8bf1b6daf7f7f7b8e1864dac26",
  "c51b7de9a3c9fde0efe6f5d0a1d76a4d9221",
  "c51b7de9a3c9fde0eff7f7f7e6f5d0a1d76a4d9221",
  "c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221",
  "c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221",
  "8e0152c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221276419",
  "8e0152c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221276419"
).map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));


/***/ }),

/***/ "./node_modules/d3-scale-chromatic/src/diverging/PuOr.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/colors.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/ramp.js");



var scheme = new Array(3).concat(
  "998ec3f7f7f7f1a340",
  "5e3c99b2abd2fdb863e66101",
  "5e3c99b2abd2f7f7f7fdb863e66101",
  "542788998ec3d8daebfee0b6f1a340b35806",
  "542788998ec3d8daebf7f7f7fee0b6f1a340b35806",
  "5427888073acb2abd2d8daebfee0b6fdb863e08214b35806",
  "5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b35806",
  "2d004b5427888073acb2abd2d8daebfee0b6fdb863e08214b358067f3b08",
  "2d004b5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b358067f3b08"
).map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));


/***/ }),

/***/ "./node_modules/d3-scale-chromatic/src/diverging/RdBu.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/colors.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/ramp.js");



var scheme = new Array(3).concat(
  "ef8a62f7f7f767a9cf",
  "ca0020f4a58292c5de0571b0",
  "ca0020f4a582f7f7f792c5de0571b0",
  "b2182bef8a62fddbc7d1e5f067a9cf2166ac",
  "b2182bef8a62fddbc7f7f7f7d1e5f067a9cf2166ac",
  "b2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac",
  "b2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac",
  "67001fb2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac053061",
  "67001fb2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac053061"
).map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));


/***/ }),

/***/ "./node_modules/d3-scale-chromatic/src/diverging/RdGy.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/colors.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/ramp.js");



var scheme = new Array(3).concat(
  "ef8a62ffffff999999",
  "ca0020f4a582bababa404040",
  "ca0020f4a582ffffffbababa404040",
  "b2182bef8a62fddbc7e0e0e09999994d4d4d",
  "b2182bef8a62fddbc7ffffffe0e0e09999994d4d4d",
  "b2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d",
  "b2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d",
  "67001fb2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d1a1a1a",
  "67001fb2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d1a1a1a"
).map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));


/***/ }),

/***/ "./node_modules/d3-scale-chromatic/src/diverging/RdYlBu.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/colors.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/ramp.js");



var scheme = new Array(3).concat(
  "fc8d59ffffbf91bfdb",
  "d7191cfdae61abd9e92c7bb6",
  "d7191cfdae61ffffbfabd9e92c7bb6",
  "d73027fc8d59fee090e0f3f891bfdb4575b4",
  "d73027fc8d59fee090ffffbfe0f3f891bfdb4575b4",
  "d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4",
  "d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4",
  "a50026d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4313695",
  "a50026d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4313695"
).map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));


/***/ }),

/***/ "./node_modules/d3-scale-chromatic/src/diverging/RdYlGn.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/colors.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/ramp.js");



var scheme = new Array(3).concat(
  "fc8d59ffffbf91cf60",
  "d7191cfdae61a6d96a1a9641",
  "d7191cfdae61ffffbfa6d96a1a9641",
  "d73027fc8d59fee08bd9ef8b91cf601a9850",
  "d73027fc8d59fee08bffffbfd9ef8b91cf601a9850",
  "d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850",
  "d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850",
  "a50026d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850006837",
  "a50026d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850006837"
).map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));


/***/ }),

/***/ "./node_modules/d3-scale-chromatic/src/diverging/Spectral.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/colors.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/ramp.js");



var scheme = new Array(3).concat(
  "fc8d59ffffbf99d594",
  "d7191cfdae61abdda42b83ba",
  "d7191cfdae61ffffbfabdda42b83ba",
  "d53e4ffc8d59fee08be6f59899d5943288bd",
  "d53e4ffc8d59fee08bffffbfe6f59899d5943288bd",
  "d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd",
  "d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd",
  "9e0142d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd5e4fa2",
  "9e0142d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd5e4fa2"
).map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));


/***/ }),

/***/ "./node_modules/d3-scale-chromatic/src/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__categorical_category10__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/categorical/category10.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_0__categorical_category10__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__categorical_Accent__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/categorical/Accent.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_1__categorical_Accent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__categorical_Dark2__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/categorical/Dark2.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return __WEBPACK_IMPORTED_MODULE_2__categorical_Dark2__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__categorical_Paired__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/categorical/Paired.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return __WEBPACK_IMPORTED_MODULE_3__categorical_Paired__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__categorical_Pastel1__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/categorical/Pastel1.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return __WEBPACK_IMPORTED_MODULE_4__categorical_Pastel1__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__categorical_Pastel2__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/categorical/Pastel2.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return __WEBPACK_IMPORTED_MODULE_5__categorical_Pastel2__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__categorical_Set1__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/categorical/Set1.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return __WEBPACK_IMPORTED_MODULE_6__categorical_Set1__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__categorical_Set2__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/categorical/Set2.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return __WEBPACK_IMPORTED_MODULE_7__categorical_Set2__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__categorical_Set3__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/categorical/Set3.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return __WEBPACK_IMPORTED_MODULE_8__categorical_Set3__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__diverging_BrBG__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/diverging/BrBG.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_9__diverging_BrBG__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_9__diverging_BrBG__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__diverging_PRGn__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/diverging/PRGn.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_10__diverging_PRGn__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return __WEBPACK_IMPORTED_MODULE_10__diverging_PRGn__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__diverging_PiYG__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/diverging/PiYG.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_11__diverging_PiYG__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return __WEBPACK_IMPORTED_MODULE_11__diverging_PiYG__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__diverging_PuOr__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/diverging/PuOr.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_12__diverging_PuOr__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return __WEBPACK_IMPORTED_MODULE_12__diverging_PuOr__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__diverging_RdBu__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/diverging/RdBu.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_13__diverging_RdBu__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return __WEBPACK_IMPORTED_MODULE_13__diverging_RdBu__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__diverging_RdGy__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/diverging/RdGy.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_14__diverging_RdGy__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return __WEBPACK_IMPORTED_MODULE_14__diverging_RdGy__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__diverging_RdYlBu__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/diverging/RdYlBu.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_15__diverging_RdYlBu__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return __WEBPACK_IMPORTED_MODULE_15__diverging_RdYlBu__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__diverging_RdYlGn__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/diverging/RdYlGn.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_16__diverging_RdYlGn__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return __WEBPACK_IMPORTED_MODULE_16__diverging_RdYlGn__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__diverging_Spectral__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/diverging/Spectral.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_17__diverging_Spectral__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return __WEBPACK_IMPORTED_MODULE_17__diverging_Spectral__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__sequential_multi_BuGn__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/sequential-multi/BuGn.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_18__sequential_multi_BuGn__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_18__sequential_multi_BuGn__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__sequential_multi_BuPu__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/sequential-multi/BuPu.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_19__sequential_multi_BuPu__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_19__sequential_multi_BuPu__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__sequential_multi_GnBu__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/sequential-multi/GnBu.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_20__sequential_multi_GnBu__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return __WEBPACK_IMPORTED_MODULE_20__sequential_multi_GnBu__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__sequential_multi_OrRd__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/sequential-multi/OrRd.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_21__sequential_multi_OrRd__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return __WEBPACK_IMPORTED_MODULE_21__sequential_multi_OrRd__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__sequential_multi_PuBuGn__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/sequential-multi/PuBuGn.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_22__sequential_multi_PuBuGn__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return __WEBPACK_IMPORTED_MODULE_22__sequential_multi_PuBuGn__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__sequential_multi_PuBu__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/sequential-multi/PuBu.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_23__sequential_multi_PuBu__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return __WEBPACK_IMPORTED_MODULE_23__sequential_multi_PuBu__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__sequential_multi_PuRd__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/sequential-multi/PuRd.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_24__sequential_multi_PuRd__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return __WEBPACK_IMPORTED_MODULE_24__sequential_multi_PuRd__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__sequential_multi_RdPu__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/sequential-multi/RdPu.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_25__sequential_multi_RdPu__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return __WEBPACK_IMPORTED_MODULE_25__sequential_multi_RdPu__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__sequential_multi_YlGnBu__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/sequential-multi/YlGnBu.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_26__sequential_multi_YlGnBu__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return __WEBPACK_IMPORTED_MODULE_26__sequential_multi_YlGnBu__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__sequential_multi_YlGn__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/sequential-multi/YlGn.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_27__sequential_multi_YlGn__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return __WEBPACK_IMPORTED_MODULE_27__sequential_multi_YlGn__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__sequential_multi_YlOrBr__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/sequential-multi/YlOrBr.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_28__sequential_multi_YlOrBr__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return __WEBPACK_IMPORTED_MODULE_28__sequential_multi_YlOrBr__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__sequential_multi_YlOrRd__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/sequential-multi/YlOrRd.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_29__sequential_multi_YlOrRd__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return __WEBPACK_IMPORTED_MODULE_29__sequential_multi_YlOrRd__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__sequential_single_Blues__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/sequential-single/Blues.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_30__sequential_single_Blues__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_30__sequential_single_Blues__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__sequential_single_Greens__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/sequential-single/Greens.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_31__sequential_single_Greens__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return __WEBPACK_IMPORTED_MODULE_31__sequential_single_Greens__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__sequential_single_Greys__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/sequential-single/Greys.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_32__sequential_single_Greys__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return __WEBPACK_IMPORTED_MODULE_32__sequential_single_Greys__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__sequential_single_Purples__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/sequential-single/Purples.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_33__sequential_single_Purples__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return __WEBPACK_IMPORTED_MODULE_33__sequential_single_Purples__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__sequential_single_Reds__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/sequential-single/Reds.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_34__sequential_single_Reds__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return __WEBPACK_IMPORTED_MODULE_34__sequential_single_Reds__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__sequential_single_Oranges__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/sequential-single/Oranges.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_35__sequential_single_Oranges__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return __WEBPACK_IMPORTED_MODULE_35__sequential_single_Oranges__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__sequential_multi_cubehelix__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/sequential-multi/cubehelix.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_36__sequential_multi_cubehelix__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__sequential_multi_rainbow__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/sequential-multi/rainbow.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_37__sequential_multi_rainbow__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_37__sequential_multi_rainbow__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_37__sequential_multi_rainbow__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__sequential_multi_sinebow__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/sequential-multi/sinebow.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_38__sequential_multi_sinebow__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__sequential_multi_viridis__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/sequential-multi/viridis.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_39__sequential_multi_viridis__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_39__sequential_multi_viridis__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_39__sequential_multi_viridis__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_39__sequential_multi_viridis__["d"]; });










































/***/ }),

/***/ "./node_modules/d3-scale-chromatic/src/ramp.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_interpolate__ = __webpack_require__("./node_modules/d3-interpolate/src/index.js");


/* harmony default export */ __webpack_exports__["a"] = (function(scheme) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_interpolate__["r" /* interpolateRgbBasis */])(scheme[scheme.length - 1]);
});


/***/ }),

/***/ "./node_modules/d3-scale-chromatic/src/sequential-multi/BuGn.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/colors.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/ramp.js");



var scheme = new Array(3).concat(
  "e5f5f999d8c92ca25f",
  "edf8fbb2e2e266c2a4238b45",
  "edf8fbb2e2e266c2a42ca25f006d2c",
  "edf8fbccece699d8c966c2a42ca25f006d2c",
  "edf8fbccece699d8c966c2a441ae76238b45005824",
  "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45005824",
  "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45006d2c00441b"
).map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));


/***/ }),

/***/ "./node_modules/d3-scale-chromatic/src/sequential-multi/BuPu.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/colors.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/ramp.js");



var scheme = new Array(3).concat(
  "e0ecf49ebcda8856a7",
  "edf8fbb3cde38c96c688419d",
  "edf8fbb3cde38c96c68856a7810f7c",
  "edf8fbbfd3e69ebcda8c96c68856a7810f7c",
  "edf8fbbfd3e69ebcda8c96c68c6bb188419d6e016b",
  "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d6e016b",
  "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d810f7c4d004b"
).map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));


/***/ }),

/***/ "./node_modules/d3-scale-chromatic/src/sequential-multi/GnBu.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/colors.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/ramp.js");



var scheme = new Array(3).concat(
  "e0f3dba8ddb543a2ca",
  "f0f9e8bae4bc7bccc42b8cbe",
  "f0f9e8bae4bc7bccc443a2ca0868ac",
  "f0f9e8ccebc5a8ddb57bccc443a2ca0868ac",
  "f0f9e8ccebc5a8ddb57bccc44eb3d32b8cbe08589e",
  "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe08589e",
  "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe0868ac084081"
).map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));


/***/ }),

/***/ "./node_modules/d3-scale-chromatic/src/sequential-multi/OrRd.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/colors.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/ramp.js");



var scheme = new Array(3).concat(
  "fee8c8fdbb84e34a33",
  "fef0d9fdcc8afc8d59d7301f",
  "fef0d9fdcc8afc8d59e34a33b30000",
  "fef0d9fdd49efdbb84fc8d59e34a33b30000",
  "fef0d9fdd49efdbb84fc8d59ef6548d7301f990000",
  "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301f990000",
  "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301fb300007f0000"
).map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));


/***/ }),

/***/ "./node_modules/d3-scale-chromatic/src/sequential-multi/PuBu.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/colors.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/ramp.js");



var scheme = new Array(3).concat(
  "ece7f2a6bddb2b8cbe",
  "f1eef6bdc9e174a9cf0570b0",
  "f1eef6bdc9e174a9cf2b8cbe045a8d",
  "f1eef6d0d1e6a6bddb74a9cf2b8cbe045a8d",
  "f1eef6d0d1e6a6bddb74a9cf3690c00570b0034e7b",
  "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0034e7b",
  "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0045a8d023858"
).map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));


/***/ }),

/***/ "./node_modules/d3-scale-chromatic/src/sequential-multi/PuBuGn.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/colors.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/ramp.js");



var scheme = new Array(3).concat(
  "ece2f0a6bddb1c9099",
  "f6eff7bdc9e167a9cf02818a",
  "f6eff7bdc9e167a9cf1c9099016c59",
  "f6eff7d0d1e6a6bddb67a9cf1c9099016c59",
  "f6eff7d0d1e6a6bddb67a9cf3690c002818a016450",
  "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016450",
  "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016c59014636"
).map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));


/***/ }),

/***/ "./node_modules/d3-scale-chromatic/src/sequential-multi/PuRd.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/colors.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/ramp.js");



var scheme = new Array(3).concat(
  "e7e1efc994c7dd1c77",
  "f1eef6d7b5d8df65b0ce1256",
  "f1eef6d7b5d8df65b0dd1c77980043",
  "f1eef6d4b9dac994c7df65b0dd1c77980043",
  "f1eef6d4b9dac994c7df65b0e7298ace125691003f",
  "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125691003f",
  "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125698004367001f"
).map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));


/***/ }),

/***/ "./node_modules/d3-scale-chromatic/src/sequential-multi/RdPu.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/colors.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/ramp.js");



var scheme = new Array(3).concat(
  "fde0ddfa9fb5c51b8a",
  "feebe2fbb4b9f768a1ae017e",
  "feebe2fbb4b9f768a1c51b8a7a0177",
  "feebe2fcc5c0fa9fb5f768a1c51b8a7a0177",
  "feebe2fcc5c0fa9fb5f768a1dd3497ae017e7a0177",
  "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a0177",
  "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a017749006a"
).map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));


/***/ }),

/***/ "./node_modules/d3-scale-chromatic/src/sequential-multi/YlGn.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/colors.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/ramp.js");



var scheme = new Array(3).concat(
  "f7fcb9addd8e31a354",
  "ffffccc2e69978c679238443",
  "ffffccc2e69978c67931a354006837",
  "ffffccd9f0a3addd8e78c67931a354006837",
  "ffffccd9f0a3addd8e78c67941ab5d238443005a32",
  "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443005a32",
  "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443006837004529"
).map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));


/***/ }),

/***/ "./node_modules/d3-scale-chromatic/src/sequential-multi/YlGnBu.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/colors.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/ramp.js");



var scheme = new Array(3).concat(
  "edf8b17fcdbb2c7fb8",
  "ffffcca1dab441b6c4225ea8",
  "ffffcca1dab441b6c42c7fb8253494",
  "ffffccc7e9b47fcdbb41b6c42c7fb8253494",
  "ffffccc7e9b47fcdbb41b6c41d91c0225ea80c2c84",
  "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea80c2c84",
  "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea8253494081d58"
).map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));


/***/ }),

/***/ "./node_modules/d3-scale-chromatic/src/sequential-multi/YlOrBr.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/colors.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/ramp.js");



var scheme = new Array(3).concat(
  "fff7bcfec44fd95f0e",
  "ffffd4fed98efe9929cc4c02",
  "ffffd4fed98efe9929d95f0e993404",
  "ffffd4fee391fec44ffe9929d95f0e993404",
  "ffffd4fee391fec44ffe9929ec7014cc4c028c2d04",
  "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c028c2d04",
  "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c02993404662506"
).map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));


/***/ }),

/***/ "./node_modules/d3-scale-chromatic/src/sequential-multi/YlOrRd.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/colors.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/ramp.js");



var scheme = new Array(3).concat(
  "ffeda0feb24cf03b20",
  "ffffb2fecc5cfd8d3ce31a1c",
  "ffffb2fecc5cfd8d3cf03b20bd0026",
  "ffffb2fed976feb24cfd8d3cf03b20bd0026",
  "ffffb2fed976feb24cfd8d3cfc4e2ae31a1cb10026",
  "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cb10026",
  "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cbd0026800026"
).map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));


/***/ }),

/***/ "./node_modules/d3-scale-chromatic/src/sequential-multi/cubehelix.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__("./node_modules/d3-color/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__("./node_modules/d3-interpolate/src/index.js");



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["f" /* interpolateCubehelixLong */])(Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(300, 0.5, 0.0), Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(-240, 0.5, 1.0)));


/***/ }),

/***/ "./node_modules/d3-scale-chromatic/src/sequential-multi/rainbow.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return warm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cool; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__("./node_modules/d3-color/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__("./node_modules/d3-interpolate/src/index.js");



var warm = Object(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["f" /* interpolateCubehelixLong */])(Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(-100, 0.75, 0.35), Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(80, 1.50, 0.8));

var cool = Object(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["f" /* interpolateCubehelixLong */])(Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(260, 0.75, 0.35), Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(80, 1.50, 0.8));

var c = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])();

/* harmony default export */ __webpack_exports__["b"] = (function(t) {
  if (t < 0 || t > 1) t -= Math.floor(t);
  var ts = Math.abs(t - 0.5);
  c.h = 360 * t - 100;
  c.s = 1.5 - 1.5 * ts;
  c.l = 0.8 - 0.9 * ts;
  return c + "";
});


/***/ }),

/***/ "./node_modules/d3-scale-chromatic/src/sequential-multi/sinebow.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__("./node_modules/d3-color/src/index.js");


var c = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["h" /* rgb */])(),
    pi_1_3 = Math.PI / 3,
    pi_2_3 = Math.PI * 2 / 3;

/* harmony default export */ __webpack_exports__["a"] = (function(t) {
  var x;
  t = (0.5 - t) * Math.PI;
  c.r = 255 * (x = Math.sin(t)) * x;
  c.g = 255 * (x = Math.sin(t + pi_1_3)) * x;
  c.b = 255 * (x = Math.sin(t + pi_2_3)) * x;
  return c + "";
});


/***/ }),

/***/ "./node_modules/d3-scale-chromatic/src/sequential-multi/viridis.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return magma; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return inferno; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return plasma; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/colors.js");


function ramp(range) {
  var n = range.length;
  return function(t) {
    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (ramp(Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725")));

var magma = ramp(Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));

var inferno = ramp(Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));

var plasma = ramp(Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));


/***/ }),

/***/ "./node_modules/d3-scale-chromatic/src/sequential-single/Blues.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/colors.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/ramp.js");



var scheme = new Array(3).concat(
  "deebf79ecae13182bd",
  "eff3ffbdd7e76baed62171b5",
  "eff3ffbdd7e76baed63182bd08519c",
  "eff3ffc6dbef9ecae16baed63182bd08519c",
  "eff3ffc6dbef9ecae16baed64292c62171b5084594",
  "f7fbffdeebf7c6dbef9ecae16baed64292c62171b5084594",
  "f7fbffdeebf7c6dbef9ecae16baed64292c62171b508519c08306b"
).map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));


/***/ }),

/***/ "./node_modules/d3-scale-chromatic/src/sequential-single/Greens.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/colors.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/ramp.js");



var scheme = new Array(3).concat(
  "e5f5e0a1d99b31a354",
  "edf8e9bae4b374c476238b45",
  "edf8e9bae4b374c47631a354006d2c",
  "edf8e9c7e9c0a1d99b74c47631a354006d2c",
  "edf8e9c7e9c0a1d99b74c47641ab5d238b45005a32",
  "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45005a32",
  "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45006d2c00441b"
).map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));


/***/ }),

/***/ "./node_modules/d3-scale-chromatic/src/sequential-single/Greys.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/colors.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/ramp.js");



var scheme = new Array(3).concat(
  "f0f0f0bdbdbd636363",
  "f7f7f7cccccc969696525252",
  "f7f7f7cccccc969696636363252525",
  "f7f7f7d9d9d9bdbdbd969696636363252525",
  "f7f7f7d9d9d9bdbdbd969696737373525252252525",
  "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525",
  "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525000000"
).map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));


/***/ }),

/***/ "./node_modules/d3-scale-chromatic/src/sequential-single/Oranges.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/colors.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/ramp.js");



var scheme = new Array(3).concat(
  "fee6cefdae6be6550d",
  "feeddefdbe85fd8d3cd94701",
  "feeddefdbe85fd8d3ce6550da63603",
  "feeddefdd0a2fdae6bfd8d3ce6550da63603",
  "feeddefdd0a2fdae6bfd8d3cf16913d948018c2d04",
  "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d948018c2d04",
  "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d94801a636037f2704"
).map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));


/***/ }),

/***/ "./node_modules/d3-scale-chromatic/src/sequential-single/Purples.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/colors.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/ramp.js");



var scheme = new Array(3).concat(
  "efedf5bcbddc756bb1",
  "f2f0f7cbc9e29e9ac86a51a3",
  "f2f0f7cbc9e29e9ac8756bb154278f",
  "f2f0f7dadaebbcbddc9e9ac8756bb154278f",
  "f2f0f7dadaebbcbddc9e9ac8807dba6a51a34a1486",
  "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a34a1486",
  "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a354278f3f007d"
).map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));


/***/ }),

/***/ "./node_modules/d3-scale-chromatic/src/sequential-single/Reds.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/colors.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/ramp.js");



var scheme = new Array(3).concat(
  "fee0d2fc9272de2d26",
  "fee5d9fcae91fb6a4acb181d",
  "fee5d9fcae91fb6a4ade2d26a50f15",
  "fee5d9fcbba1fc9272fb6a4ade2d26a50f15",
  "fee5d9fcbba1fc9272fb6a4aef3b2ccb181d99000d",
  "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181d99000d",
  "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181da50f1567000d"
).map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));


/***/ }),

/***/ "./node_modules/d3-scale/src/array.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return map; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return slice; });
var array = Array.prototype;

var map = array.map;
var slice = array.slice;


/***/ }),

/***/ "./node_modules/d3-scale/src/band.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = band;
/* harmony export (immutable) */ __webpack_exports__["b"] = point;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__("./node_modules/d3-array/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ordinal__ = __webpack_require__("./node_modules/d3-scale/src/ordinal.js");



function band() {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_1__ordinal__["a" /* default */])().unknown(undefined),
      domain = scale.domain,
      ordinalRange = scale.range,
      range = [0, 1],
      step,
      bandwidth,
      round = false,
      paddingInner = 0,
      paddingOuter = 0,
      align = 0.5;

  delete scale.unknown;

  function rescale() {
    var n = domain().length,
        reverse = range[1] < range[0],
        start = range[reverse - 0],
        stop = range[1 - reverse];
    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
    if (round) step = Math.floor(step);
    start += (stop - start - step * (n - paddingInner)) * align;
    bandwidth = step * (1 - paddingInner);
    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
    var values = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["s" /* range */])(n).map(function(i) { return start + step * i; });
    return ordinalRange(reverse ? values.reverse() : values);
  }

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.range = function(_) {
    return arguments.length ? (range = [+_[0], +_[1]], rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = [+_[0], +_[1]], round = true, rescale();
  };

  scale.bandwidth = function() {
    return bandwidth;
  };

  scale.step = function() {
    return step;
  };

  scale.round = function(_) {
    return arguments.length ? (round = !!_, rescale()) : round;
  };

  scale.padding = function(_) {
    return arguments.length ? (paddingInner = paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
  };

  scale.paddingInner = function(_) {
    return arguments.length ? (paddingInner = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
  };

  scale.paddingOuter = function(_) {
    return arguments.length ? (paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingOuter;
  };

  scale.align = function(_) {
    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
  };

  scale.copy = function() {
    return band()
        .domain(domain())
        .range(range)
        .round(round)
        .paddingInner(paddingInner)
        .paddingOuter(paddingOuter)
        .align(align);
  };

  return rescale();
}

function pointish(scale) {
  var copy = scale.copy;

  scale.padding = scale.paddingOuter;
  delete scale.paddingInner;
  delete scale.paddingOuter;

  scale.copy = function() {
    return pointish(copy());
  };

  return scale;
}

function point() {
  return pointish(band().paddingInner(1));
}


/***/ }),

/***/ "./node_modules/d3-scale/src/constant.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),

/***/ "./node_modules/d3-scale/src/continuous.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = deinterpolateLinear;
/* harmony export (immutable) */ __webpack_exports__["a"] = copy;
/* harmony export (immutable) */ __webpack_exports__["b"] = continuous;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__("./node_modules/d3-array/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__("./node_modules/d3-interpolate/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__array__ = __webpack_require__("./node_modules/d3-scale/src/array.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constant__ = __webpack_require__("./node_modules/d3-scale/src/constant.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__number__ = __webpack_require__("./node_modules/d3-scale/src/number.js");






var unit = [0, 1];

function deinterpolateLinear(a, b) {
  return (b -= (a = +a))
      ? function(x) { return (x - a) / b; }
      : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */])(b);
}

function deinterpolateClamp(deinterpolate) {
  return function(a, b) {
    var d = deinterpolate(a = +a, b = +b);
    return function(x) { return x <= a ? 0 : x >= b ? 1 : d(x); };
  };
}

function reinterpolateClamp(reinterpolate) {
  return function(a, b) {
    var r = reinterpolate(a = +a, b = +b);
    return function(t) { return t <= 0 ? a : t >= 1 ? b : r(t); };
  };
}

function bimap(domain, range, deinterpolate, reinterpolate) {
  var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
  if (d1 < d0) d0 = deinterpolate(d1, d0), r0 = reinterpolate(r1, r0);
  else d0 = deinterpolate(d0, d1), r0 = reinterpolate(r0, r1);
  return function(x) { return r0(d0(x)); };
}

function polymap(domain, range, deinterpolate, reinterpolate) {
  var j = Math.min(domain.length, range.length) - 1,
      d = new Array(j),
      r = new Array(j),
      i = -1;

  // Reverse descending domains.
  if (domain[j] < domain[0]) {
    domain = domain.slice().reverse();
    range = range.slice().reverse();
  }

  while (++i < j) {
    d[i] = deinterpolate(domain[i], domain[i + 1]);
    r[i] = reinterpolate(range[i], range[i + 1]);
  }

  return function(x) {
    var i = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" /* bisect */])(domain, x, 1, j) - 1;
    return r[i](d[i](x));
  };
}

function copy(source, target) {
  return target
      .domain(source.domain())
      .range(source.range())
      .interpolate(source.interpolate())
      .clamp(source.clamp());
}

// deinterpolate(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// reinterpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding domain value x in [a,b].
function continuous(deinterpolate, reinterpolate) {
  var domain = unit,
      range = unit,
      interpolate = __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["a" /* interpolate */],
      clamp = false,
      piecewise,
      output,
      input;

  function rescale() {
    piecewise = Math.min(domain.length, range.length) > 2 ? polymap : bimap;
    output = input = null;
    return scale;
  }

  function scale(x) {
    return (output || (output = piecewise(domain, range, clamp ? deinterpolateClamp(deinterpolate) : deinterpolate, interpolate)))(+x);
  }

  scale.invert = function(y) {
    return (input || (input = piecewise(range, domain, deinterpolateLinear, clamp ? reinterpolateClamp(reinterpolate) : reinterpolate)))(+y);
  };

  scale.domain = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_2__array__["a" /* map */].call(_, __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */]), rescale()) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_2__array__["b" /* slice */].call(_), rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = __WEBPACK_IMPORTED_MODULE_2__array__["b" /* slice */].call(_), interpolate = __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["t" /* interpolateRound */], rescale();
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, rescale()) : clamp;
  };

  scale.interpolate = function(_) {
    return arguments.length ? (interpolate = _, rescale()) : interpolate;
  };

  return rescale();
}


/***/ }),

/***/ "./node_modules/d3-scale/src/diverging.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = diverging;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__linear__ = __webpack_require__("./node_modules/d3-scale/src/linear.js");


function diverging(interpolator) {
  var x0 = 0,
      x1 = 0.5,
      x2 = 1,
      k10 = 1,
      k21 = 1,
      clamp = false;

  function scale(x) {
    var t = 0.5 + ((x = +x) - x1) * (x < x1 ? k10 : k21);
    return interpolator(clamp ? Math.max(0, Math.min(1, t)) : t);
  }

  scale.domain = function(_) {
    return arguments.length ? (x0 = +_[0], x1 = +_[1], x2 = +_[2], k10 = x0 === x1 ? 0 : 0.5 / (x1 - x0), k21 = x1 === x2 ? 0 : 0.5 / (x2 - x1), scale) : [x0, x1, x2];
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, scale) : clamp;
  };

  scale.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale) : interpolator;
  };

  scale.copy = function() {
    return diverging(interpolator).domain([x0, x1, x2]).clamp(clamp);
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__linear__["b" /* linearish */])(scale);
}


/***/ }),

/***/ "./node_modules/d3-scale/src/identity.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = identity;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__("./node_modules/d3-scale/src/array.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__linear__ = __webpack_require__("./node_modules/d3-scale/src/linear.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__number__ = __webpack_require__("./node_modules/d3-scale/src/number.js");




function identity() {
  var domain = [0, 1];

  function scale(x) {
    return +x;
  }

  scale.invert = scale;

  scale.domain = scale.range = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* map */].call(_, __WEBPACK_IMPORTED_MODULE_2__number__["a" /* default */]), scale) : domain.slice();
  };

  scale.copy = function() {
    return identity().domain(domain);
  };

  return Object(__WEBPACK_IMPORTED_MODULE_1__linear__["b" /* linearish */])(scale);
}


/***/ }),

/***/ "./node_modules/d3-scale/src/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__band__ = __webpack_require__("./node_modules/d3-scale/src/band.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__band__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_0__band__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__identity__ = __webpack_require__("./node_modules/d3-scale/src/identity.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__identity__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__linear__ = __webpack_require__("./node_modules/d3-scale/src/linear.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__linear__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__log__ = __webpack_require__("./node_modules/d3-scale/src/log.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__log__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ordinal__ = __webpack_require__("./node_modules/d3-scale/src/ordinal.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_4__ordinal__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__ordinal__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pow__ = __webpack_require__("./node_modules/d3-scale/src/pow.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_5__pow__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_5__pow__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__quantile__ = __webpack_require__("./node_modules/d3-scale/src/quantile.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_6__quantile__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__quantize__ = __webpack_require__("./node_modules/d3-scale/src/quantize.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_7__quantize__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__threshold__ = __webpack_require__("./node_modules/d3-scale/src/threshold.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_8__threshold__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__time__ = __webpack_require__("./node_modules/d3-scale/src/time.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_9__time__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utcTime__ = __webpack_require__("./node_modules/d3-scale/src/utcTime.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_10__utcTime__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__sequential__ = __webpack_require__("./node_modules/d3-scale/src/sequential.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_11__sequential__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__diverging__ = __webpack_require__("./node_modules/d3-scale/src/diverging.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_12__diverging__["a"]; });



























/***/ }),

/***/ "./node_modules/d3-scale/src/linear.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = linearish;
/* harmony export (immutable) */ __webpack_exports__["a"] = linear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__("./node_modules/d3-array/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__("./node_modules/d3-interpolate/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__continuous__ = __webpack_require__("./node_modules/d3-scale/src/continuous.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tickFormat__ = __webpack_require__("./node_modules/d3-scale/src/tickFormat.js");





function linearish(scale) {
  var domain = scale.domain;

  scale.ticks = function(count) {
    var d = domain();
    return Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["B" /* ticks */])(d[0], d[d.length - 1], count == null ? 10 : count);
  };

  scale.tickFormat = function(count, specifier) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__tickFormat__["a" /* default */])(domain(), count, specifier);
  };

  scale.nice = function(count) {
    if (count == null) count = 10;

    var d = domain(),
        i0 = 0,
        i1 = d.length - 1,
        start = d[i0],
        stop = d[i1],
        step;

    if (stop < start) {
      step = start, start = stop, stop = step;
      step = i0, i0 = i1, i1 = step;
    }

    step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["z" /* tickIncrement */])(start, stop, count);

    if (step > 0) {
      start = Math.floor(start / step) * step;
      stop = Math.ceil(stop / step) * step;
      step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["z" /* tickIncrement */])(start, stop, count);
    } else if (step < 0) {
      start = Math.ceil(start * step) / step;
      stop = Math.floor(stop * step) / step;
      step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["z" /* tickIncrement */])(start, stop, count);
    }

    if (step > 0) {
      d[i0] = Math.floor(start / step) * step;
      d[i1] = Math.ceil(stop / step) * step;
      domain(d);
    } else if (step < 0) {
      d[i0] = Math.ceil(start * step) / step;
      d[i1] = Math.floor(stop * step) / step;
      domain(d);
    }

    return scale;
  };

  return scale;
}

function linear() {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_2__continuous__["b" /* default */])(__WEBPACK_IMPORTED_MODULE_2__continuous__["c" /* deinterpolateLinear */], __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["o" /* interpolateNumber */]);

  scale.copy = function() {
    return Object(__WEBPACK_IMPORTED_MODULE_2__continuous__["a" /* copy */])(scale, linear());
  };

  return linearish(scale);
}


/***/ }),

/***/ "./node_modules/d3-scale/src/log.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = log;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__("./node_modules/d3-array/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_format__ = __webpack_require__("./node_modules/d3-format/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__("./node_modules/d3-scale/src/constant.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nice__ = __webpack_require__("./node_modules/d3-scale/src/nice.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__continuous__ = __webpack_require__("./node_modules/d3-scale/src/continuous.js");






function deinterpolate(a, b) {
  return (b = Math.log(b / a))
      ? function(x) { return Math.log(x / a) / b; }
      : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(b);
}

function reinterpolate(a, b) {
  return a < 0
      ? function(t) { return -Math.pow(-b, t) * Math.pow(-a, 1 - t); }
      : function(t) { return Math.pow(b, t) * Math.pow(a, 1 - t); };
}

function pow10(x) {
  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}

function powp(base) {
  return base === 10 ? pow10
      : base === Math.E ? Math.exp
      : function(x) { return Math.pow(base, x); };
}

function logp(base) {
  return base === Math.E ? Math.log
      : base === 10 && Math.log10
      || base === 2 && Math.log2
      || (base = Math.log(base), function(x) { return Math.log(x) / base; });
}

function reflect(f) {
  return function(x) {
    return -f(-x);
  };
}

function log() {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_4__continuous__["b" /* default */])(deinterpolate, reinterpolate).domain([1, 10]),
      domain = scale.domain,
      base = 10,
      logs = logp(10),
      pows = powp(10);

  function rescale() {
    logs = logp(base), pows = powp(base);
    if (domain()[0] < 0) logs = reflect(logs), pows = reflect(pows);
    return scale;
  }

  scale.base = function(_) {
    return arguments.length ? (base = +_, rescale()) : base;
  };

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.ticks = function(count) {
    var d = domain(),
        u = d[0],
        v = d[d.length - 1],
        r;

    if (r = v < u) i = u, u = v, v = i;

    var i = logs(u),
        j = logs(v),
        p,
        k,
        t,
        n = count == null ? 10 : +count,
        z = [];

    if (!(base % 1) && j - i < n) {
      i = Math.round(i) - 1, j = Math.round(j) + 1;
      if (u > 0) for (; i < j; ++i) {
        for (k = 1, p = pows(i); k < base; ++k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      } else for (; i < j; ++i) {
        for (k = base - 1, p = pows(i); k >= 1; --k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      }
    } else {
      z = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["B" /* ticks */])(i, j, Math.min(j - i, n)).map(pows);
    }

    return r ? z.reverse() : z;
  };

  scale.tickFormat = function(count, specifier) {
    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
    if (typeof specifier !== "function") specifier = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["a" /* format */])(specifier);
    if (count === Infinity) return specifier;
    if (count == null) count = 10;
    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
    return function(d) {
      var i = d / pows(Math.round(logs(d)));
      if (i * base < base - 0.5) i *= base;
      return i <= k ? specifier(d) : "";
    };
  };

  scale.nice = function() {
    return domain(Object(__WEBPACK_IMPORTED_MODULE_3__nice__["a" /* default */])(domain(), {
      floor: function(x) { return pows(Math.floor(logs(x))); },
      ceil: function(x) { return pows(Math.ceil(logs(x))); }
    }));
  };

  scale.copy = function() {
    return Object(__WEBPACK_IMPORTED_MODULE_4__continuous__["a" /* copy */])(scale, log().base(base));
  };

  return scale;
}


/***/ }),

/***/ "./node_modules/d3-scale/src/nice.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(domain, interval) {
  domain = domain.slice();

  var i0 = 0,
      i1 = domain.length - 1,
      x0 = domain[i0],
      x1 = domain[i1],
      t;

  if (x1 < x0) {
    t = i0, i0 = i1, i1 = t;
    t = x0, x0 = x1, x1 = t;
  }

  domain[i0] = interval.floor(x0);
  domain[i1] = interval.ceil(x1);
  return domain;
});


/***/ }),

/***/ "./node_modules/d3-scale/src/number.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return +x;
});


/***/ }),

/***/ "./node_modules/d3-scale/src/ordinal.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return implicit; });
/* harmony export (immutable) */ __webpack_exports__["a"] = ordinal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_collection__ = __webpack_require__("./node_modules/d3-collection/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__("./node_modules/d3-scale/src/array.js");



var implicit = {name: "implicit"};

function ordinal(range) {
  var index = Object(__WEBPACK_IMPORTED_MODULE_0_d3_collection__["c" /* map */])(),
      domain = [],
      unknown = implicit;

  range = range == null ? [] : __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(range);

  function scale(d) {
    var key = d + "", i = index.get(key);
    if (!i) {
      if (unknown !== implicit) return unknown;
      index.set(key, i = domain.push(d));
    }
    return range[(i - 1) % range.length];
  }

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [], index = Object(__WEBPACK_IMPORTED_MODULE_0_d3_collection__["c" /* map */])();
    var i = -1, n = _.length, d, key;
    while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
    return scale;
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), scale) : range.slice();
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function() {
    return ordinal()
        .domain(domain)
        .range(range)
        .unknown(unknown);
  };

  return scale;
}


/***/ }),

/***/ "./node_modules/d3-scale/src/pow.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pow;
/* harmony export (immutable) */ __webpack_exports__["b"] = sqrt;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__("./node_modules/d3-scale/src/constant.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__linear__ = __webpack_require__("./node_modules/d3-scale/src/linear.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__continuous__ = __webpack_require__("./node_modules/d3-scale/src/continuous.js");




function raise(x, exponent) {
  return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
}

function pow() {
  var exponent = 1,
      scale = Object(__WEBPACK_IMPORTED_MODULE_2__continuous__["b" /* default */])(deinterpolate, reinterpolate),
      domain = scale.domain;

  function deinterpolate(a, b) {
    return (b = raise(b, exponent) - (a = raise(a, exponent)))
        ? function(x) { return (raise(x, exponent) - a) / b; }
        : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(b);
  }

  function reinterpolate(a, b) {
    b = raise(b, exponent) - (a = raise(a, exponent));
    return function(t) { return raise(a + b * t, 1 / exponent); };
  }

  scale.exponent = function(_) {
    return arguments.length ? (exponent = +_, domain(domain())) : exponent;
  };

  scale.copy = function() {
    return Object(__WEBPACK_IMPORTED_MODULE_2__continuous__["a" /* copy */])(scale, pow().exponent(exponent));
  };

  return Object(__WEBPACK_IMPORTED_MODULE_1__linear__["b" /* linearish */])(scale);
}

function sqrt() {
  return pow().exponent(0.5);
}


/***/ }),

/***/ "./node_modules/d3-scale/src/quantile.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = quantile;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__("./node_modules/d3-array/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__("./node_modules/d3-scale/src/array.js");



function quantile() {
  var domain = [],
      range = [],
      thresholds = [];

  function rescale() {
    var i = 0, n = Math.max(1, range.length);
    thresholds = new Array(n - 1);
    while (++i < n) thresholds[i - 1] = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["r" /* quantile */])(domain, i / n);
    return scale;
  }

  function scale(x) {
    if (!isNaN(x = +x)) return range[Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" /* bisect */])(thresholds, x)];
  }

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN] : [
      i > 0 ? thresholds[i - 1] : domain[0],
      i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
    ];
  };

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [];
    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
    domain.sort(__WEBPACK_IMPORTED_MODULE_0_d3_array__["a" /* ascending */]);
    return rescale();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), rescale()) : range.slice();
  };

  scale.quantiles = function() {
    return thresholds.slice();
  };

  scale.copy = function() {
    return quantile()
        .domain(domain)
        .range(range);
  };

  return scale;
}


/***/ }),

/***/ "./node_modules/d3-scale/src/quantize.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = quantize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__("./node_modules/d3-array/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__("./node_modules/d3-scale/src/array.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__linear__ = __webpack_require__("./node_modules/d3-scale/src/linear.js");




function quantize() {
  var x0 = 0,
      x1 = 1,
      n = 1,
      domain = [0.5],
      range = [0, 1];

  function scale(x) {
    if (x <= x) return range[Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" /* bisect */])(domain, x, 0, n)];
  }

  function rescale() {
    var i = -1;
    domain = new Array(n);
    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
    return scale;
  }

  scale.domain = function(_) {
    return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
  };

  scale.range = function(_) {
    return arguments.length ? (n = (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_)).length - 1, rescale()) : range.slice();
  };

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN]
        : i < 1 ? [x0, domain[0]]
        : i >= n ? [domain[n - 1], x1]
        : [domain[i - 1], domain[i]];
  };

  scale.copy = function() {
    return quantize()
        .domain([x0, x1])
        .range(range);
  };

  return Object(__WEBPACK_IMPORTED_MODULE_2__linear__["b" /* linearish */])(scale);
}


/***/ }),

/***/ "./node_modules/d3-scale/src/sequential.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sequential;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__linear__ = __webpack_require__("./node_modules/d3-scale/src/linear.js");


function sequential(interpolator) {
  var x0 = 0,
      x1 = 1,
      k10 = 1,
      clamp = false;

  function scale(x) {
    var t = (x - x0) * k10;
    return interpolator(clamp ? Math.max(0, Math.min(1, t)) : t);
  }

  scale.domain = function(_) {
    return arguments.length ? (x0 = +_[0], x1 = +_[1], k10 = x0 === x1 ? 0 : 1 / (x1 - x0), scale) : [x0, x1];
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, scale) : clamp;
  };

  scale.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale) : interpolator;
  };

  scale.copy = function() {
    return sequential(interpolator).domain([x0, x1]).clamp(clamp);
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__linear__["b" /* linearish */])(scale);
}


/***/ }),

/***/ "./node_modules/d3-scale/src/threshold.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = threshold;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__("./node_modules/d3-array/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__("./node_modules/d3-scale/src/array.js");



function threshold() {
  var domain = [0.5],
      range = [0, 1],
      n = 1;

  function scale(x) {
    if (x <= x) return range[Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" /* bisect */])(domain, x, 0, n)];
  }

  scale.domain = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
  };

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return [domain[i - 1], domain[i]];
  };

  scale.copy = function() {
    return threshold()
        .domain(domain)
        .range(range);
  };

  return scale;
}


/***/ }),

/***/ "./node_modules/d3-scale/src/tickFormat.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__("./node_modules/d3-array/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_format__ = __webpack_require__("./node_modules/d3-format/src/index.js");



/* harmony default export */ __webpack_exports__["a"] = (function(domain, count, specifier) {
  var start = domain[0],
      stop = domain[domain.length - 1],
      step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["A" /* tickStep */])(start, stop, count == null ? 10 : count),
      precision;
  specifier = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["e" /* formatSpecifier */])(specifier == null ? ",f" : specifier);
  switch (specifier.type) {
    case "s": {
      var value = Math.max(Math.abs(start), Math.abs(stop));
      if (specifier.precision == null && !isNaN(precision = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["g" /* precisionPrefix */])(step, value))) specifier.precision = precision;
      return Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["d" /* formatPrefix */])(specifier, value);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      if (specifier.precision == null && !isNaN(precision = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["h" /* precisionRound */])(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
      break;
    }
    case "f":
    case "%": {
      if (specifier.precision == null && !isNaN(precision = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["f" /* precisionFixed */])(step))) specifier.precision = precision - (specifier.type === "%") * 2;
      break;
    }
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["a" /* format */])(specifier);
});


/***/ }),

/***/ "./node_modules/d3-scale/src/time.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = calendar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__("./node_modules/d3-array/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__("./node_modules/d3-interpolate/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_time__ = __webpack_require__("./node_modules/d3-time/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_time_format__ = __webpack_require__("./node_modules/d3-time-format/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__array__ = __webpack_require__("./node_modules/d3-scale/src/array.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__continuous__ = __webpack_require__("./node_modules/d3-scale/src/continuous.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__nice__ = __webpack_require__("./node_modules/d3-scale/src/nice.js");








var durationSecond = 1000,
    durationMinute = durationSecond * 60,
    durationHour = durationMinute * 60,
    durationDay = durationHour * 24,
    durationWeek = durationDay * 7,
    durationMonth = durationDay * 30,
    durationYear = durationDay * 365;

function date(t) {
  return new Date(t);
}

function number(t) {
  return t instanceof Date ? +t : +new Date(+t);
}

function calendar(year, month, week, day, hour, minute, second, millisecond, format) {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_5__continuous__["b" /* default */])(__WEBPACK_IMPORTED_MODULE_5__continuous__["c" /* deinterpolateLinear */], __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["o" /* interpolateNumber */]),
      invert = scale.invert,
      domain = scale.domain;

  var formatMillisecond = format(".%L"),
      formatSecond = format(":%S"),
      formatMinute = format("%I:%M"),
      formatHour = format("%I %p"),
      formatDay = format("%a %d"),
      formatWeek = format("%b %d"),
      formatMonth = format("%B"),
      formatYear = format("%Y");

  var tickIntervals = [
    [second,  1,      durationSecond],
    [second,  5,  5 * durationSecond],
    [second, 15, 15 * durationSecond],
    [second, 30, 30 * durationSecond],
    [minute,  1,      durationMinute],
    [minute,  5,  5 * durationMinute],
    [minute, 15, 15 * durationMinute],
    [minute, 30, 30 * durationMinute],
    [  hour,  1,      durationHour  ],
    [  hour,  3,  3 * durationHour  ],
    [  hour,  6,  6 * durationHour  ],
    [  hour, 12, 12 * durationHour  ],
    [   day,  1,      durationDay   ],
    [   day,  2,  2 * durationDay   ],
    [  week,  1,      durationWeek  ],
    [ month,  1,      durationMonth ],
    [ month,  3,  3 * durationMonth ],
    [  year,  1,      durationYear  ]
  ];

  function tickFormat(date) {
    return (second(date) < date ? formatMillisecond
        : minute(date) < date ? formatSecond
        : hour(date) < date ? formatMinute
        : day(date) < date ? formatHour
        : month(date) < date ? (week(date) < date ? formatDay : formatWeek)
        : year(date) < date ? formatMonth
        : formatYear)(date);
  }

  function tickInterval(interval, start, stop, step) {
    if (interval == null) interval = 10;

    // If a desired tick count is specified, pick a reasonable tick interval
    // based on the extent of the domain and a rough estimate of tick size.
    // Otherwise, assume interval is already a time interval and use it.
    if (typeof interval === "number") {
      var target = Math.abs(stop - start) / interval,
          i = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["e" /* bisector */])(function(i) { return i[2]; }).right(tickIntervals, target);
      if (i === tickIntervals.length) {
        step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["A" /* tickStep */])(start / durationYear, stop / durationYear, interval);
        interval = year;
      } else if (i) {
        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        step = i[1];
        interval = i[0];
      } else {
        step = Math.max(Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["A" /* tickStep */])(start, stop, interval), 1);
        interval = millisecond;
      }
    }

    return step == null ? interval : interval.every(step);
  }

  scale.invert = function(y) {
    return new Date(invert(y));
  };

  scale.domain = function(_) {
    return arguments.length ? domain(__WEBPACK_IMPORTED_MODULE_4__array__["a" /* map */].call(_, number)) : domain().map(date);
  };

  scale.ticks = function(interval, step) {
    var d = domain(),
        t0 = d[0],
        t1 = d[d.length - 1],
        r = t1 < t0,
        t;
    if (r) t = t0, t0 = t1, t1 = t;
    t = tickInterval(interval, t0, t1, step);
    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
    return r ? t.reverse() : t;
  };

  scale.tickFormat = function(count, specifier) {
    return specifier == null ? tickFormat : format(specifier);
  };

  scale.nice = function(interval, step) {
    var d = domain();
    return (interval = tickInterval(interval, d[0], d[d.length - 1], step))
        ? domain(Object(__WEBPACK_IMPORTED_MODULE_6__nice__["a" /* default */])(d, interval))
        : scale;
  };

  scale.copy = function() {
    return Object(__WEBPACK_IMPORTED_MODULE_5__continuous__["a" /* copy */])(scale, calendar(year, month, week, day, hour, minute, second, millisecond, format));
  };

  return scale;
}

/* harmony default export */ __webpack_exports__["b"] = (function() {
  return calendar(__WEBPACK_IMPORTED_MODULE_2_d3_time__["D" /* timeYear */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["n" /* timeMonth */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["B" /* timeWeek */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["a" /* timeDay */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["e" /* timeHour */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["j" /* timeMinute */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["r" /* timeSecond */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["h" /* timeMillisecond */], __WEBPACK_IMPORTED_MODULE_3_d3_time_format__["c" /* timeFormat */]).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]);
});


/***/ }),

/***/ "./node_modules/d3-scale/src/utcTime.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__time__ = __webpack_require__("./node_modules/d3-scale/src/time.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_time_format__ = __webpack_require__("./node_modules/d3-time-format/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_time__ = __webpack_require__("./node_modules/d3-time/src/index.js");




/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__time__["a" /* calendar */])(__WEBPACK_IMPORTED_MODULE_2_d3_time__["_7" /* utcYear */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["R" /* utcMonth */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["_5" /* utcWeek */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["F" /* utcDay */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["J" /* utcHour */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["N" /* utcMinute */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["V" /* utcSecond */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["L" /* utcMillisecond */], __WEBPACK_IMPORTED_MODULE_1_d3_time_format__["g" /* utcFormat */]).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]);
});


/***/ }),

/***/ "./node_modules/d3-selection/src/constant.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),

/***/ "./node_modules/d3-selection/src/create.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__creator__ = __webpack_require__("./node_modules/d3-selection/src/creator.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__select__ = __webpack_require__("./node_modules/d3-selection/src/select.js");



/* harmony default export */ __webpack_exports__["a"] = (function(name) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__select__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__creator__["a" /* default */])(name).call(document.documentElement));
});


/***/ }),

/***/ "./node_modules/d3-selection/src/creator.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__namespace__ = __webpack_require__("./node_modules/d3-selection/src/namespace.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__namespaces__ = __webpack_require__("./node_modules/d3-selection/src/namespaces.js");



function creatorInherit(name) {
  return function() {
    var document = this.ownerDocument,
        uri = this.namespaceURI;
    return uri === __WEBPACK_IMPORTED_MODULE_1__namespaces__["b" /* xhtml */] && document.documentElement.namespaceURI === __WEBPACK_IMPORTED_MODULE_1__namespaces__["b" /* xhtml */]
        ? document.createElement(name)
        : document.createElementNS(uri, name);
  };
}

function creatorFixed(fullname) {
  return function() {
    return this.ownerDocument.createElementNS(fullname.space, fullname.local);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name) {
  var fullname = Object(__WEBPACK_IMPORTED_MODULE_0__namespace__["a" /* default */])(name);
  return (fullname.local
      ? creatorFixed
      : creatorInherit)(fullname);
});


/***/ }),

/***/ "./node_modules/d3-selection/src/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__create__ = __webpack_require__("./node_modules/d3-selection/src/create.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__create__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__creator__ = __webpack_require__("./node_modules/d3-selection/src/creator.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__creator__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__local__ = __webpack_require__("./node_modules/d3-selection/src/local.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_2__local__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__matcher__ = __webpack_require__("./node_modules/d3-selection/src/matcher.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_3__matcher__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mouse__ = __webpack_require__("./node_modules/d3-selection/src/mouse.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_4__mouse__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__namespace__ = __webpack_require__("./node_modules/d3-selection/src/namespace.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_5__namespace__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__namespaces__ = __webpack_require__("./node_modules/d3-selection/src/namespaces.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_6__namespaces__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__point__ = __webpack_require__("./node_modules/d3-selection/src/point.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_7__point__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__select__ = __webpack_require__("./node_modules/d3-selection/src/select.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_8__select__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__selectAll__ = __webpack_require__("./node_modules/d3-selection/src/selectAll.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_9__selectAll__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__selection_index__ = __webpack_require__("./node_modules/d3-selection/src/selection/index.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_10__selection_index__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__selector__ = __webpack_require__("./node_modules/d3-selection/src/selector.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_11__selector__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__selectorAll__ = __webpack_require__("./node_modules/d3-selection/src/selectorAll.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_12__selectorAll__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__selection_style__ = __webpack_require__("./node_modules/d3-selection/src/selection/style.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_13__selection_style__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__touch__ = __webpack_require__("./node_modules/d3-selection/src/touch.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_14__touch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__touches__ = __webpack_require__("./node_modules/d3-selection/src/touches.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_15__touches__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__window__ = __webpack_require__("./node_modules/d3-selection/src/window.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_16__window__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__selection_on__ = __webpack_require__("./node_modules/d3-selection/src/selection/on.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_17__selection_on__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_17__selection_on__["a"]; });




















/***/ }),

/***/ "./node_modules/d3-selection/src/local.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = local;
var nextId = 0;

function local() {
  return new Local;
}

function Local() {
  this._ = "@" + (++nextId).toString(36);
}

Local.prototype = local.prototype = {
  constructor: Local,
  get: function(node) {
    var id = this._;
    while (!(id in node)) if (!(node = node.parentNode)) return;
    return node[id];
  },
  set: function(node, value) {
    return node[this._] = value;
  },
  remove: function(node) {
    return this._ in node && delete node[this._];
  },
  toString: function() {
    return this._;
  }
};


/***/ }),

/***/ "./node_modules/d3-selection/src/matcher.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var matcher = function(selector) {
  return function() {
    return this.matches(selector);
  };
};

if (typeof document !== "undefined") {
  var element = document.documentElement;
  if (!element.matches) {
    var vendorMatches = element.webkitMatchesSelector
        || element.msMatchesSelector
        || element.mozMatchesSelector
        || element.oMatchesSelector;
    matcher = function(selector) {
      return function() {
        return vendorMatches.call(this, selector);
      };
    };
  }
}

/* harmony default export */ __webpack_exports__["a"] = (matcher);


/***/ }),

/***/ "./node_modules/d3-selection/src/mouse.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sourceEvent__ = __webpack_require__("./node_modules/d3-selection/src/sourceEvent.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__point__ = __webpack_require__("./node_modules/d3-selection/src/point.js");



/* harmony default export */ __webpack_exports__["a"] = (function(node) {
  var event = Object(__WEBPACK_IMPORTED_MODULE_0__sourceEvent__["a" /* default */])();
  if (event.changedTouches) event = event.changedTouches[0];
  return Object(__WEBPACK_IMPORTED_MODULE_1__point__["a" /* default */])(node, event);
});


/***/ }),

/***/ "./node_modules/d3-selection/src/namespace.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__namespaces__ = __webpack_require__("./node_modules/d3-selection/src/namespaces.js");


/* harmony default export */ __webpack_exports__["a"] = (function(name) {
  var prefix = name += "", i = prefix.indexOf(":");
  if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
  return __WEBPACK_IMPORTED_MODULE_0__namespaces__["a" /* default */].hasOwnProperty(prefix) ? {space: __WEBPACK_IMPORTED_MODULE_0__namespaces__["a" /* default */][prefix], local: name} : name;
});


/***/ }),

/***/ "./node_modules/d3-selection/src/namespaces.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return xhtml; });
var xhtml = "http://www.w3.org/1999/xhtml";

/* harmony default export */ __webpack_exports__["a"] = ({
  svg: "http://www.w3.org/2000/svg",
  xhtml: xhtml,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
});


/***/ }),

/***/ "./node_modules/d3-selection/src/point.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(node, event) {
  var svg = node.ownerSVGElement || node;

  if (svg.createSVGPoint) {
    var point = svg.createSVGPoint();
    point.x = event.clientX, point.y = event.clientY;
    point = point.matrixTransform(node.getScreenCTM().inverse());
    return [point.x, point.y];
  }

  var rect = node.getBoundingClientRect();
  return [event.clientX - rect.left - node.clientLeft, event.clientY - rect.top - node.clientTop];
});


/***/ }),

/***/ "./node_modules/d3-selection/src/select.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selection_index__ = __webpack_require__("./node_modules/d3-selection/src/selection/index.js");


/* harmony default export */ __webpack_exports__["a"] = (function(selector) {
  return typeof selector === "string"
      ? new __WEBPACK_IMPORTED_MODULE_0__selection_index__["a" /* Selection */]([[document.querySelector(selector)]], [document.documentElement])
      : new __WEBPACK_IMPORTED_MODULE_0__selection_index__["a" /* Selection */]([[selector]], __WEBPACK_IMPORTED_MODULE_0__selection_index__["c" /* root */]);
});


/***/ }),

/***/ "./node_modules/d3-selection/src/selectAll.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selection_index__ = __webpack_require__("./node_modules/d3-selection/src/selection/index.js");


/* harmony default export */ __webpack_exports__["a"] = (function(selector) {
  return typeof selector === "string"
      ? new __WEBPACK_IMPORTED_MODULE_0__selection_index__["a" /* Selection */]([document.querySelectorAll(selector)], [document.documentElement])
      : new __WEBPACK_IMPORTED_MODULE_0__selection_index__["a" /* Selection */]([selector == null ? [] : selector], __WEBPACK_IMPORTED_MODULE_0__selection_index__["c" /* root */]);
});


/***/ }),

/***/ "./node_modules/d3-selection/src/selection/append.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__creator__ = __webpack_require__("./node_modules/d3-selection/src/creator.js");


/* harmony default export */ __webpack_exports__["a"] = (function(name) {
  var create = typeof name === "function" ? name : Object(__WEBPACK_IMPORTED_MODULE_0__creator__["a" /* default */])(name);
  return this.select(function() {
    return this.appendChild(create.apply(this, arguments));
  });
});


/***/ }),

/***/ "./node_modules/d3-selection/src/selection/attr.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__namespace__ = __webpack_require__("./node_modules/d3-selection/src/namespace.js");


function attrRemove(name) {
  return function() {
    this.removeAttribute(name);
  };
}

function attrRemoveNS(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}

function attrConstant(name, value) {
  return function() {
    this.setAttribute(name, value);
  };
}

function attrConstantNS(fullname, value) {
  return function() {
    this.setAttributeNS(fullname.space, fullname.local, value);
  };
}

function attrFunction(name, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.removeAttribute(name);
    else this.setAttribute(name, v);
  };
}

function attrFunctionNS(fullname, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
    else this.setAttributeNS(fullname.space, fullname.local, v);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  var fullname = Object(__WEBPACK_IMPORTED_MODULE_0__namespace__["a" /* default */])(name);

  if (arguments.length < 2) {
    var node = this.node();
    return fullname.local
        ? node.getAttributeNS(fullname.space, fullname.local)
        : node.getAttribute(fullname);
  }

  return this.each((value == null
      ? (fullname.local ? attrRemoveNS : attrRemove) : (typeof value === "function"
      ? (fullname.local ? attrFunctionNS : attrFunction)
      : (fullname.local ? attrConstantNS : attrConstant)))(fullname, value));
});


/***/ }),

/***/ "./node_modules/d3-selection/src/selection/call.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var callback = arguments[0];
  arguments[0] = this;
  callback.apply(null, arguments);
  return this;
});


/***/ }),

/***/ "./node_modules/d3-selection/src/selection/classed.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function classArray(string) {
  return string.trim().split(/^|\s+/);
}

function classList(node) {
  return node.classList || new ClassList(node);
}

function ClassList(node) {
  this._node = node;
  this._names = classArray(node.getAttribute("class") || "");
}

ClassList.prototype = {
  add: function(name) {
    var i = this._names.indexOf(name);
    if (i < 0) {
      this._names.push(name);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  remove: function(name) {
    var i = this._names.indexOf(name);
    if (i >= 0) {
      this._names.splice(i, 1);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  contains: function(name) {
    return this._names.indexOf(name) >= 0;
  }
};

function classedAdd(node, names) {
  var list = classList(node), i = -1, n = names.length;
  while (++i < n) list.add(names[i]);
}

function classedRemove(node, names) {
  var list = classList(node), i = -1, n = names.length;
  while (++i < n) list.remove(names[i]);
}

function classedTrue(names) {
  return function() {
    classedAdd(this, names);
  };
}

function classedFalse(names) {
  return function() {
    classedRemove(this, names);
  };
}

function classedFunction(names, value) {
  return function() {
    (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  var names = classArray(name + "");

  if (arguments.length < 2) {
    var list = classList(this.node()), i = -1, n = names.length;
    while (++i < n) if (!list.contains(names[i])) return false;
    return true;
  }

  return this.each((typeof value === "function"
      ? classedFunction : value
      ? classedTrue
      : classedFalse)(names, value));
});


/***/ }),

/***/ "./node_modules/d3-selection/src/selection/clone.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function selection_cloneShallow() {
  return this.parentNode.insertBefore(this.cloneNode(false), this.nextSibling);
}

function selection_cloneDeep() {
  return this.parentNode.insertBefore(this.cloneNode(true), this.nextSibling);
}

/* harmony default export */ __webpack_exports__["a"] = (function(deep) {
  return this.select(deep ? selection_cloneDeep : selection_cloneShallow);
});


/***/ }),

/***/ "./node_modules/d3-selection/src/selection/data.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__("./node_modules/d3-selection/src/selection/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__enter__ = __webpack_require__("./node_modules/d3-selection/src/selection/enter.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__("./node_modules/d3-selection/src/constant.js");




var keyPrefix = "$"; // Protect against keys like “__proto__”.

function bindIndex(parent, group, enter, update, exit, data) {
  var i = 0,
      node,
      groupLength = group.length,
      dataLength = data.length;

  // Put any non-null nodes that fit into update.
  // Put any null nodes into enter.
  // Put any remaining data into enter.
  for (; i < dataLength; ++i) {
    if (node = group[i]) {
      node.__data__ = data[i];
      update[i] = node;
    } else {
      enter[i] = new __WEBPACK_IMPORTED_MODULE_1__enter__["a" /* EnterNode */](parent, data[i]);
    }
  }

  // Put any non-null nodes that don’t fit into exit.
  for (; i < groupLength; ++i) {
    if (node = group[i]) {
      exit[i] = node;
    }
  }
}

function bindKey(parent, group, enter, update, exit, data, key) {
  var i,
      node,
      nodeByKeyValue = {},
      groupLength = group.length,
      dataLength = data.length,
      keyValues = new Array(groupLength),
      keyValue;

  // Compute the key for each node.
  // If multiple nodes have the same key, the duplicates are added to exit.
  for (i = 0; i < groupLength; ++i) {
    if (node = group[i]) {
      keyValues[i] = keyValue = keyPrefix + key.call(node, node.__data__, i, group);
      if (keyValue in nodeByKeyValue) {
        exit[i] = node;
      } else {
        nodeByKeyValue[keyValue] = node;
      }
    }
  }

  // Compute the key for each datum.
  // If there a node associated with this key, join and add it to update.
  // If there is not (or the key is a duplicate), add it to enter.
  for (i = 0; i < dataLength; ++i) {
    keyValue = keyPrefix + key.call(parent, data[i], i, data);
    if (node = nodeByKeyValue[keyValue]) {
      update[i] = node;
      node.__data__ = data[i];
      nodeByKeyValue[keyValue] = null;
    } else {
      enter[i] = new __WEBPACK_IMPORTED_MODULE_1__enter__["a" /* EnterNode */](parent, data[i]);
    }
  }

  // Add any remaining nodes that were not bound to data to exit.
  for (i = 0; i < groupLength; ++i) {
    if ((node = group[i]) && (nodeByKeyValue[keyValues[i]] === node)) {
      exit[i] = node;
    }
  }
}

/* harmony default export */ __webpack_exports__["a"] = (function(value, key) {
  if (!value) {
    data = new Array(this.size()), j = -1;
    this.each(function(d) { data[++j] = d; });
    return data;
  }

  var bind = key ? bindKey : bindIndex,
      parents = this._parents,
      groups = this._groups;

  if (typeof value !== "function") value = Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(value);

  for (var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j) {
    var parent = parents[j],
        group = groups[j],
        groupLength = group.length,
        data = value.call(parent, parent && parent.__data__, j, parents),
        dataLength = data.length,
        enterGroup = enter[j] = new Array(dataLength),
        updateGroup = update[j] = new Array(dataLength),
        exitGroup = exit[j] = new Array(groupLength);

    bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);

    // Now connect the enter nodes to their following update node, such that
    // appendChild can insert the materialized enter node before this node,
    // rather than at the end of the parent node.
    for (var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0) {
      if (previous = enterGroup[i0]) {
        if (i0 >= i1) i1 = i0 + 1;
        while (!(next = updateGroup[i1]) && ++i1 < dataLength);
        previous._next = next || null;
      }
    }
  }

  update = new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](update, parents);
  update._enter = enter;
  update._exit = exit;
  return update;
});


/***/ }),

/***/ "./node_modules/d3-selection/src/selection/datum.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  return arguments.length
      ? this.property("__data__", value)
      : this.node().__data__;
});


/***/ }),

/***/ "./node_modules/d3-selection/src/selection/dispatch.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__window__ = __webpack_require__("./node_modules/d3-selection/src/window.js");


function dispatchEvent(node, type, params) {
  var window = Object(__WEBPACK_IMPORTED_MODULE_0__window__["a" /* default */])(node),
      event = window.CustomEvent;

  if (typeof event === "function") {
    event = new event(type, params);
  } else {
    event = window.document.createEvent("Event");
    if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
    else event.initEvent(type, false, false);
  }

  node.dispatchEvent(event);
}

function dispatchConstant(type, params) {
  return function() {
    return dispatchEvent(this, type, params);
  };
}

function dispatchFunction(type, params) {
  return function() {
    return dispatchEvent(this, type, params.apply(this, arguments));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(type, params) {
  return this.each((typeof params === "function"
      ? dispatchFunction
      : dispatchConstant)(type, params));
});


/***/ }),

/***/ "./node_modules/d3-selection/src/selection/each.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(callback) {

  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length, node; i < n; ++i) {
      if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
  }

  return this;
});


/***/ }),

/***/ "./node_modules/d3-selection/src/selection/empty.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  return !this.node();
});


/***/ }),

/***/ "./node_modules/d3-selection/src/selection/enter.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = EnterNode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sparse__ = __webpack_require__("./node_modules/d3-selection/src/selection/sparse.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__("./node_modules/d3-selection/src/selection/index.js");



/* harmony default export */ __webpack_exports__["b"] = (function() {
  return new __WEBPACK_IMPORTED_MODULE_1__index__["a" /* Selection */](this._enter || this._groups.map(__WEBPACK_IMPORTED_MODULE_0__sparse__["a" /* default */]), this._parents);
});

function EnterNode(parent, datum) {
  this.ownerDocument = parent.ownerDocument;
  this.namespaceURI = parent.namespaceURI;
  this._next = null;
  this._parent = parent;
  this.__data__ = datum;
}

EnterNode.prototype = {
  constructor: EnterNode,
  appendChild: function(child) { return this._parent.insertBefore(child, this._next); },
  insertBefore: function(child, next) { return this._parent.insertBefore(child, next); },
  querySelector: function(selector) { return this._parent.querySelector(selector); },
  querySelectorAll: function(selector) { return this._parent.querySelectorAll(selector); }
};


/***/ }),

/***/ "./node_modules/d3-selection/src/selection/exit.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sparse__ = __webpack_require__("./node_modules/d3-selection/src/selection/sparse.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__("./node_modules/d3-selection/src/selection/index.js");



/* harmony default export */ __webpack_exports__["a"] = (function() {
  return new __WEBPACK_IMPORTED_MODULE_1__index__["a" /* Selection */](this._exit || this._groups.map(__WEBPACK_IMPORTED_MODULE_0__sparse__["a" /* default */]), this._parents);
});


/***/ }),

/***/ "./node_modules/d3-selection/src/selection/filter.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__("./node_modules/d3-selection/src/selection/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__matcher__ = __webpack_require__("./node_modules/d3-selection/src/matcher.js");



/* harmony default export */ __webpack_exports__["a"] = (function(match) {
  if (typeof match !== "function") match = Object(__WEBPACK_IMPORTED_MODULE_1__matcher__["a" /* default */])(match);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
        subgroup.push(node);
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](subgroups, this._parents);
});


/***/ }),

/***/ "./node_modules/d3-selection/src/selection/html.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function htmlRemove() {
  this.innerHTML = "";
}

function htmlConstant(value) {
  return function() {
    this.innerHTML = value;
  };
}

function htmlFunction(value) {
  return function() {
    var v = value.apply(this, arguments);
    this.innerHTML = v == null ? "" : v;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  return arguments.length
      ? this.each(value == null
          ? htmlRemove : (typeof value === "function"
          ? htmlFunction
          : htmlConstant)(value))
      : this.node().innerHTML;
});


/***/ }),

/***/ "./node_modules/d3-selection/src/selection/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return root; });
/* harmony export (immutable) */ __webpack_exports__["a"] = Selection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__select__ = __webpack_require__("./node_modules/d3-selection/src/selection/select.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selectAll__ = __webpack_require__("./node_modules/d3-selection/src/selection/selectAll.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filter__ = __webpack_require__("./node_modules/d3-selection/src/selection/filter.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data__ = __webpack_require__("./node_modules/d3-selection/src/selection/data.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__enter__ = __webpack_require__("./node_modules/d3-selection/src/selection/enter.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__exit__ = __webpack_require__("./node_modules/d3-selection/src/selection/exit.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__merge__ = __webpack_require__("./node_modules/d3-selection/src/selection/merge.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__order__ = __webpack_require__("./node_modules/d3-selection/src/selection/order.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__sort__ = __webpack_require__("./node_modules/d3-selection/src/selection/sort.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__call__ = __webpack_require__("./node_modules/d3-selection/src/selection/call.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__nodes__ = __webpack_require__("./node_modules/d3-selection/src/selection/nodes.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__node__ = __webpack_require__("./node_modules/d3-selection/src/selection/node.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__size__ = __webpack_require__("./node_modules/d3-selection/src/selection/size.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__empty__ = __webpack_require__("./node_modules/d3-selection/src/selection/empty.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__each__ = __webpack_require__("./node_modules/d3-selection/src/selection/each.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__attr__ = __webpack_require__("./node_modules/d3-selection/src/selection/attr.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__style__ = __webpack_require__("./node_modules/d3-selection/src/selection/style.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__property__ = __webpack_require__("./node_modules/d3-selection/src/selection/property.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__classed__ = __webpack_require__("./node_modules/d3-selection/src/selection/classed.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__text__ = __webpack_require__("./node_modules/d3-selection/src/selection/text.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__html__ = __webpack_require__("./node_modules/d3-selection/src/selection/html.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__raise__ = __webpack_require__("./node_modules/d3-selection/src/selection/raise.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__lower__ = __webpack_require__("./node_modules/d3-selection/src/selection/lower.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__append__ = __webpack_require__("./node_modules/d3-selection/src/selection/append.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__insert__ = __webpack_require__("./node_modules/d3-selection/src/selection/insert.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__remove__ = __webpack_require__("./node_modules/d3-selection/src/selection/remove.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__clone__ = __webpack_require__("./node_modules/d3-selection/src/selection/clone.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__datum__ = __webpack_require__("./node_modules/d3-selection/src/selection/datum.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__on__ = __webpack_require__("./node_modules/d3-selection/src/selection/on.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__dispatch__ = __webpack_require__("./node_modules/d3-selection/src/selection/dispatch.js");































var root = [null];

function Selection(groups, parents) {
  this._groups = groups;
  this._parents = parents;
}

function selection() {
  return new Selection([[document.documentElement]], root);
}

Selection.prototype = selection.prototype = {
  constructor: Selection,
  select: __WEBPACK_IMPORTED_MODULE_0__select__["a" /* default */],
  selectAll: __WEBPACK_IMPORTED_MODULE_1__selectAll__["a" /* default */],
  filter: __WEBPACK_IMPORTED_MODULE_2__filter__["a" /* default */],
  data: __WEBPACK_IMPORTED_MODULE_3__data__["a" /* default */],
  enter: __WEBPACK_IMPORTED_MODULE_4__enter__["b" /* default */],
  exit: __WEBPACK_IMPORTED_MODULE_5__exit__["a" /* default */],
  merge: __WEBPACK_IMPORTED_MODULE_6__merge__["a" /* default */],
  order: __WEBPACK_IMPORTED_MODULE_7__order__["a" /* default */],
  sort: __WEBPACK_IMPORTED_MODULE_8__sort__["a" /* default */],
  call: __WEBPACK_IMPORTED_MODULE_9__call__["a" /* default */],
  nodes: __WEBPACK_IMPORTED_MODULE_10__nodes__["a" /* default */],
  node: __WEBPACK_IMPORTED_MODULE_11__node__["a" /* default */],
  size: __WEBPACK_IMPORTED_MODULE_12__size__["a" /* default */],
  empty: __WEBPACK_IMPORTED_MODULE_13__empty__["a" /* default */],
  each: __WEBPACK_IMPORTED_MODULE_14__each__["a" /* default */],
  attr: __WEBPACK_IMPORTED_MODULE_15__attr__["a" /* default */],
  style: __WEBPACK_IMPORTED_MODULE_16__style__["a" /* default */],
  property: __WEBPACK_IMPORTED_MODULE_17__property__["a" /* default */],
  classed: __WEBPACK_IMPORTED_MODULE_18__classed__["a" /* default */],
  text: __WEBPACK_IMPORTED_MODULE_19__text__["a" /* default */],
  html: __WEBPACK_IMPORTED_MODULE_20__html__["a" /* default */],
  raise: __WEBPACK_IMPORTED_MODULE_21__raise__["a" /* default */],
  lower: __WEBPACK_IMPORTED_MODULE_22__lower__["a" /* default */],
  append: __WEBPACK_IMPORTED_MODULE_23__append__["a" /* default */],
  insert: __WEBPACK_IMPORTED_MODULE_24__insert__["a" /* default */],
  remove: __WEBPACK_IMPORTED_MODULE_25__remove__["a" /* default */],
  clone: __WEBPACK_IMPORTED_MODULE_26__clone__["a" /* default */],
  datum: __WEBPACK_IMPORTED_MODULE_27__datum__["a" /* default */],
  on: __WEBPACK_IMPORTED_MODULE_28__on__["b" /* default */],
  dispatch: __WEBPACK_IMPORTED_MODULE_29__dispatch__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["b"] = (selection);


/***/ }),

/***/ "./node_modules/d3-selection/src/selection/insert.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__creator__ = __webpack_require__("./node_modules/d3-selection/src/creator.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__("./node_modules/d3-selection/src/selector.js");



function constantNull() {
  return null;
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, before) {
  var create = typeof name === "function" ? name : Object(__WEBPACK_IMPORTED_MODULE_0__creator__["a" /* default */])(name),
      select = before == null ? constantNull : typeof before === "function" ? before : Object(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* default */])(before);
  return this.select(function() {
    return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
  });
});


/***/ }),

/***/ "./node_modules/d3-selection/src/selection/lower.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function lower() {
  if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return this.each(lower);
});


/***/ }),

/***/ "./node_modules/d3-selection/src/selection/merge.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__("./node_modules/d3-selection/src/selection/index.js");


/* harmony default export */ __webpack_exports__["a"] = (function(selection) {

  for (var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group0[i] || group1[i]) {
        merge[i] = node;
      }
    }
  }

  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](merges, this._parents);
});


/***/ }),

/***/ "./node_modules/d3-selection/src/selection/node.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {

  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length; i < n; ++i) {
      var node = group[i];
      if (node) return node;
    }
  }

  return null;
});


/***/ }),

/***/ "./node_modules/d3-selection/src/selection/nodes.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var nodes = new Array(this.size()), i = -1;
  this.each(function() { nodes[++i] = this; });
  return nodes;
});


/***/ }),

/***/ "./node_modules/d3-selection/src/selection/on.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return event; });
/* harmony export (immutable) */ __webpack_exports__["a"] = customEvent;
var filterEvents = {};

var event = null;

if (typeof document !== "undefined") {
  var element = document.documentElement;
  if (!("onmouseenter" in element)) {
    filterEvents = {mouseenter: "mouseover", mouseleave: "mouseout"};
  }
}

function filterContextListener(listener, index, group) {
  listener = contextListener(listener, index, group);
  return function(event) {
    var related = event.relatedTarget;
    if (!related || (related !== this && !(related.compareDocumentPosition(this) & 8))) {
      listener.call(this, event);
    }
  };
}

function contextListener(listener, index, group) {
  return function(event1) {
    var event0 = event; // Events can be reentrant (e.g., focus).
    event = event1;
    try {
      listener.call(this, this.__data__, index, group);
    } finally {
      event = event0;
    }
  };
}

function parseTypenames(typenames) {
  return typenames.trim().split(/^|\s+/).map(function(t) {
    var name = "", i = t.indexOf(".");
    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
    return {type: t, name: name};
  });
}

function onRemove(typename) {
  return function() {
    var on = this.__on;
    if (!on) return;
    for (var j = 0, i = -1, m = on.length, o; j < m; ++j) {
      if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.capture);
      } else {
        on[++i] = o;
      }
    }
    if (++i) on.length = i;
    else delete this.__on;
  };
}

function onAdd(typename, value, capture) {
  var wrap = filterEvents.hasOwnProperty(typename.type) ? filterContextListener : contextListener;
  return function(d, i, group) {
    var on = this.__on, o, listener = wrap(value, i, group);
    if (on) for (var j = 0, m = on.length; j < m; ++j) {
      if ((o = on[j]).type === typename.type && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.capture);
        this.addEventListener(o.type, o.listener = listener, o.capture = capture);
        o.value = value;
        return;
      }
    }
    this.addEventListener(typename.type, listener, capture);
    o = {type: typename.type, name: typename.name, value: value, listener: listener, capture: capture};
    if (!on) this.__on = [o];
    else on.push(o);
  };
}

/* harmony default export */ __webpack_exports__["b"] = (function(typename, value, capture) {
  var typenames = parseTypenames(typename + ""), i, n = typenames.length, t;

  if (arguments.length < 2) {
    var on = this.node().__on;
    if (on) for (var j = 0, m = on.length, o; j < m; ++j) {
      for (i = 0, o = on[j]; i < n; ++i) {
        if ((t = typenames[i]).type === o.type && t.name === o.name) {
          return o.value;
        }
      }
    }
    return;
  }

  on = value ? onAdd : onRemove;
  if (capture == null) capture = false;
  for (i = 0; i < n; ++i) this.each(on(typenames[i], value, capture));
  return this;
});

function customEvent(event1, listener, that, args) {
  var event0 = event;
  event1.sourceEvent = event;
  event = event1;
  try {
    return listener.apply(that, args);
  } finally {
    event = event0;
  }
}


/***/ }),

/***/ "./node_modules/d3-selection/src/selection/order.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {

  for (var groups = this._groups, j = -1, m = groups.length; ++j < m;) {
    for (var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;) {
      if (node = group[i]) {
        if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
        next = node;
      }
    }
  }

  return this;
});


/***/ }),

/***/ "./node_modules/d3-selection/src/selection/property.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function propertyRemove(name) {
  return function() {
    delete this[name];
  };
}

function propertyConstant(name, value) {
  return function() {
    this[name] = value;
  };
}

function propertyFunction(name, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) delete this[name];
    else this[name] = v;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  return arguments.length > 1
      ? this.each((value == null
          ? propertyRemove : typeof value === "function"
          ? propertyFunction
          : propertyConstant)(name, value))
      : this.node()[name];
});


/***/ }),

/***/ "./node_modules/d3-selection/src/selection/raise.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function raise() {
  if (this.nextSibling) this.parentNode.appendChild(this);
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return this.each(raise);
});


/***/ }),

/***/ "./node_modules/d3-selection/src/selection/remove.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function remove() {
  var parent = this.parentNode;
  if (parent) parent.removeChild(this);
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return this.each(remove);
});


/***/ }),

/***/ "./node_modules/d3-selection/src/selection/select.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__("./node_modules/d3-selection/src/selection/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__("./node_modules/d3-selection/src/selector.js");



/* harmony default export */ __webpack_exports__["a"] = (function(select) {
  if (typeof select !== "function") select = Object(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* default */])(select);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
      if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
        if ("__data__" in node) subnode.__data__ = node.__data__;
        subgroup[i] = subnode;
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](subgroups, this._parents);
});


/***/ }),

/***/ "./node_modules/d3-selection/src/selection/selectAll.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__("./node_modules/d3-selection/src/selection/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selectorAll__ = __webpack_require__("./node_modules/d3-selection/src/selectorAll.js");



/* harmony default export */ __webpack_exports__["a"] = (function(select) {
  if (typeof select !== "function") select = Object(__WEBPACK_IMPORTED_MODULE_1__selectorAll__["a" /* default */])(select);

  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        subgroups.push(select.call(node, node.__data__, i, group));
        parents.push(node);
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](subgroups, parents);
});


/***/ }),

/***/ "./node_modules/d3-selection/src/selection/size.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var size = 0;
  this.each(function() { ++size; });
  return size;
});


/***/ }),

/***/ "./node_modules/d3-selection/src/selection/sort.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__("./node_modules/d3-selection/src/selection/index.js");


/* harmony default export */ __webpack_exports__["a"] = (function(compare) {
  if (!compare) compare = ascending;

  function compareNode(a, b) {
    return a && b ? compare(a.__data__, b.__data__) : !a - !b;
  }

  for (var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        sortgroup[i] = node;
      }
    }
    sortgroup.sort(compareNode);
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](sortgroups, this._parents).order();
});

function ascending(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}


/***/ }),

/***/ "./node_modules/d3-selection/src/selection/sparse.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(update) {
  return new Array(update.length);
});


/***/ }),

/***/ "./node_modules/d3-selection/src/selection/style.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = styleValue;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__window__ = __webpack_require__("./node_modules/d3-selection/src/window.js");


function styleRemove(name) {
  return function() {
    this.style.removeProperty(name);
  };
}

function styleConstant(name, value, priority) {
  return function() {
    this.style.setProperty(name, value, priority);
  };
}

function styleFunction(name, value, priority) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.style.removeProperty(name);
    else this.style.setProperty(name, v, priority);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value, priority) {
  return arguments.length > 1
      ? this.each((value == null
            ? styleRemove : typeof value === "function"
            ? styleFunction
            : styleConstant)(name, value, priority == null ? "" : priority))
      : styleValue(this.node(), name);
});

function styleValue(node, name) {
  return node.style.getPropertyValue(name)
      || Object(__WEBPACK_IMPORTED_MODULE_0__window__["a" /* default */])(node).getComputedStyle(node, null).getPropertyValue(name);
}


/***/ }),

/***/ "./node_modules/d3-selection/src/selection/text.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function textRemove() {
  this.textContent = "";
}

function textConstant(value) {
  return function() {
    this.textContent = value;
  };
}

function textFunction(value) {
  return function() {
    var v = value.apply(this, arguments);
    this.textContent = v == null ? "" : v;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  return arguments.length
      ? this.each(value == null
          ? textRemove : (typeof value === "function"
          ? textFunction
          : textConstant)(value))
      : this.node().textContent;
});


/***/ }),

/***/ "./node_modules/d3-selection/src/selector.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function none() {}

/* harmony default export */ __webpack_exports__["a"] = (function(selector) {
  return selector == null ? none : function() {
    return this.querySelector(selector);
  };
});


/***/ }),

/***/ "./node_modules/d3-selection/src/selectorAll.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function empty() {
  return [];
}

/* harmony default export */ __webpack_exports__["a"] = (function(selector) {
  return selector == null ? empty : function() {
    return this.querySelectorAll(selector);
  };
});


/***/ }),

/***/ "./node_modules/d3-selection/src/sourceEvent.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selection_on__ = __webpack_require__("./node_modules/d3-selection/src/selection/on.js");


/* harmony default export */ __webpack_exports__["a"] = (function() {
  var current = __WEBPACK_IMPORTED_MODULE_0__selection_on__["c" /* event */], source;
  while (source = current.sourceEvent) current = source;
  return current;
});


/***/ }),

/***/ "./node_modules/d3-selection/src/touch.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sourceEvent__ = __webpack_require__("./node_modules/d3-selection/src/sourceEvent.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__point__ = __webpack_require__("./node_modules/d3-selection/src/point.js");



/* harmony default export */ __webpack_exports__["a"] = (function(node, touches, identifier) {
  if (arguments.length < 3) identifier = touches, touches = Object(__WEBPACK_IMPORTED_MODULE_0__sourceEvent__["a" /* default */])().changedTouches;

  for (var i = 0, n = touches ? touches.length : 0, touch; i < n; ++i) {
    if ((touch = touches[i]).identifier === identifier) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__point__["a" /* default */])(node, touch);
    }
  }

  return null;
});


/***/ }),

/***/ "./node_modules/d3-selection/src/touches.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sourceEvent__ = __webpack_require__("./node_modules/d3-selection/src/sourceEvent.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__point__ = __webpack_require__("./node_modules/d3-selection/src/point.js");



/* harmony default export */ __webpack_exports__["a"] = (function(node, touches) {
  if (touches == null) touches = Object(__WEBPACK_IMPORTED_MODULE_0__sourceEvent__["a" /* default */])().touches;

  for (var i = 0, n = touches ? touches.length : 0, points = new Array(n); i < n; ++i) {
    points[i] = Object(__WEBPACK_IMPORTED_MODULE_1__point__["a" /* default */])(node, touches[i]);
  }

  return points;
});


/***/ }),

/***/ "./node_modules/d3-selection/src/window.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(node) {
  return (node.ownerDocument && node.ownerDocument.defaultView) // node is a Node
      || (node.document && node) // node is a Window
      || node.defaultView; // node is a Document
});


/***/ }),

/***/ "./node_modules/d3-shape/src/arc.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__("./node_modules/d3-path/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__("./node_modules/d3-shape/src/constant.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__("./node_modules/d3-shape/src/math.js");




function arcInnerRadius(d) {
  return d.innerRadius;
}

function arcOuterRadius(d) {
  return d.outerRadius;
}

function arcStartAngle(d) {
  return d.startAngle;
}

function arcEndAngle(d) {
  return d.endAngle;
}

function arcPadAngle(d) {
  return d && d.padAngle; // Note: optional!
}

function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
  var x10 = x1 - x0, y10 = y1 - y0,
      x32 = x3 - x2, y32 = y3 - y2,
      t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / (y32 * x10 - x32 * y10);
  return [x0 + t * x10, y0 + t * y10];
}

// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
  var x01 = x0 - x1,
      y01 = y0 - y1,
      lo = (cw ? rc : -rc) / Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* sqrt */])(x01 * x01 + y01 * y01),
      ox = lo * y01,
      oy = -lo * x01,
      x11 = x0 + ox,
      y11 = y0 + oy,
      x10 = x1 + ox,
      y10 = y1 + oy,
      x00 = (x11 + x10) / 2,
      y00 = (y11 + y10) / 2,
      dx = x10 - x11,
      dy = y10 - y11,
      d2 = dx * dx + dy * dy,
      r = r1 - rc,
      D = x11 * y10 - x10 * y11,
      d = (dy < 0 ? -1 : 1) * Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* sqrt */])(Object(__WEBPACK_IMPORTED_MODULE_2__math__["h" /* max */])(0, r * r * d2 - D * D)),
      cx0 = (D * dy - dx * d) / d2,
      cy0 = (-D * dx - dy * d) / d2,
      cx1 = (D * dy + dx * d) / d2,
      cy1 = (-D * dx + dy * d) / d2,
      dx0 = cx0 - x00,
      dy0 = cy0 - y00,
      dx1 = cx1 - x00,
      dy1 = cy1 - y00;

  // Pick the closer of the two intersection points.
  // TODO Is there a faster way to determine which intersection to use?
  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;

  return {
    cx: cx0,
    cy: cy0,
    x01: -ox,
    y01: -oy,
    x11: cx0 * (r1 / r - 1),
    y11: cy0 * (r1 / r - 1)
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var innerRadius = arcInnerRadius,
      outerRadius = arcOuterRadius,
      cornerRadius = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(0),
      padRadius = null,
      startAngle = arcStartAngle,
      endAngle = arcEndAngle,
      padAngle = arcPadAngle,
      context = null;

  function arc() {
    var buffer,
        r,
        r0 = +innerRadius.apply(this, arguments),
        r1 = +outerRadius.apply(this, arguments),
        a0 = startAngle.apply(this, arguments) - __WEBPACK_IMPORTED_MODULE_2__math__["g" /* halfPi */],
        a1 = endAngle.apply(this, arguments) - __WEBPACK_IMPORTED_MODULE_2__math__["g" /* halfPi */],
        da = Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" /* abs */])(a1 - a0),
        cw = a1 > a0;

    if (!context) context = buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])();

    // Ensure that the outer radius is always larger than the inner radius.
    if (r1 < r0) r = r1, r1 = r0, r0 = r;

    // Is it a point?
    if (!(r1 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */])) context.moveTo(0, 0);

    // Or is it a circle or annulus?
    else if (da > __WEBPACK_IMPORTED_MODULE_2__math__["m" /* tau */] - __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) {
      context.moveTo(r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a0), r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a0));
      context.arc(0, 0, r1, a0, a1, !cw);
      if (r0 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) {
        context.moveTo(r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a1), r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a1));
        context.arc(0, 0, r0, a1, a0, cw);
      }
    }

    // Or is it a circular or annular sector?
    else {
      var a01 = a0,
          a11 = a1,
          a00 = a0,
          a10 = a1,
          da0 = da,
          da1 = da,
          ap = padAngle.apply(this, arguments) / 2,
          rp = (ap > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) && (padRadius ? +padRadius.apply(this, arguments) : Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* sqrt */])(r0 * r0 + r1 * r1)),
          rc = Object(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* min */])(Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" /* abs */])(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
          rc0 = rc,
          rc1 = rc,
          t0,
          t1;

      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
      if (rp > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) {
        var p0 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["c" /* asin */])(rp / r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(ap)),
            p1 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["c" /* asin */])(rp / r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(ap));
        if ((da0 -= p0 * 2) > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
        if ((da1 -= p1 * 2) > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
      }

      var x01 = r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a01),
          y01 = r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a01),
          x10 = r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a10),
          y10 = r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a10);

      // Apply rounded corners?
      if (rc > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) {
        var x11 = r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a11),
            y11 = r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a11),
            x00 = r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a00),
            y00 = r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a00);

        // Restrict the corner radius according to the sector angle.
        if (da < __WEBPACK_IMPORTED_MODULE_2__math__["j" /* pi */]) {
          var oc = da0 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */] ? intersect(x01, y01, x00, y00, x11, y11, x10, y10) : [x10, y10],
              ax = x01 - oc[0],
              ay = y01 - oc[1],
              bx = x11 - oc[0],
              by = y11 - oc[1],
              kc = 1 / Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(Object(__WEBPACK_IMPORTED_MODULE_2__math__["b" /* acos */])((ax * bx + ay * by) / (Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* sqrt */])(ax * ax + ay * ay) * Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* sqrt */])(bx * bx + by * by))) / 2),
              lc = Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* sqrt */])(oc[0] * oc[0] + oc[1] * oc[1]);
          rc0 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* min */])(rc, (r0 - lc) / (kc - 1));
          rc1 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* min */])(rc, (r1 - lc) / (kc + 1));
        }
      }

      // Is the sector collapsed to a line?
      if (!(da1 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */])) context.moveTo(x01, y01);

      // Does the sector’s outer ring have rounded corners?
      else if (rc1 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) {
        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);

        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.y01, t0.x01), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc1, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.y01, t0.x01), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r1, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.cy + t0.y11, t0.cx + t0.x11), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
          context.arc(t1.cx, t1.cy, rc1, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.y11, t1.x11), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the outer ring just a circular arc?
      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);

      // Is there no inner ring, and it’s a circular sector?
      // Or perhaps it’s an annular sector collapsed due to padding?
      if (!(r0 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) || !(da0 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */])) context.lineTo(x10, y10);

      // Does the sector’s inner ring (or point) have rounded corners?
      else if (rc0 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) {
        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);

        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.y01, t0.x01), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc0, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.y01, t0.x01), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r0, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.cy + t0.y11, t0.cx + t0.x11), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.cy + t1.y11, t1.cx + t1.x11), cw);
          context.arc(t1.cx, t1.cy, rc0, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.y11, t1.x11), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the inner ring just a circular arc?
      else context.arc(0, 0, r0, a10, a00, cw);
    }

    context.closePath();

    if (buffer) return context = null, buffer + "" || null;
  }

  arc.centroid = function() {
    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - __WEBPACK_IMPORTED_MODULE_2__math__["j" /* pi */] / 2;
    return [Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a) * r, Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a) * r];
  };

  arc.innerRadius = function(_) {
    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : innerRadius;
  };

  arc.outerRadius = function(_) {
    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : outerRadius;
  };

  arc.cornerRadius = function(_) {
    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : cornerRadius;
  };

  arc.padRadius = function(_) {
    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : padRadius;
  };

  arc.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : startAngle;
  };

  arc.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : endAngle;
  };

  arc.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : padAngle;
  };

  arc.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
  };

  return arc;
});


/***/ }),

/***/ "./node_modules/d3-shape/src/area.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__("./node_modules/d3-path/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__("./node_modules/d3-shape/src/constant.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__curve_linear__ = __webpack_require__("./node_modules/d3-shape/src/curve/linear.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__line__ = __webpack_require__("./node_modules/d3-shape/src/line.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__point__ = __webpack_require__("./node_modules/d3-shape/src/point.js");






/* harmony default export */ __webpack_exports__["a"] = (function() {
  var x0 = __WEBPACK_IMPORTED_MODULE_4__point__["a" /* x */],
      x1 = null,
      y0 = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(0),
      y1 = __WEBPACK_IMPORTED_MODULE_4__point__["b" /* y */],
      defined = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(true),
      context = null,
      curve = __WEBPACK_IMPORTED_MODULE_2__curve_linear__["a" /* default */],
      output = null;

  function area(data) {
    var i,
        j,
        k,
        n = data.length,
        d,
        defined0 = false,
        buffer,
        x0z = new Array(n),
        y0z = new Array(n);

    if (context == null) output = curve(buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) {
          j = i;
          output.areaStart();
          output.lineStart();
        } else {
          output.lineEnd();
          output.lineStart();
          for (k = i - 1; k >= j; --k) {
            output.point(x0z[k], y0z[k]);
          }
          output.lineEnd();
          output.areaEnd();
        }
      }
      if (defined0) {
        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
      }
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  function arealine() {
    return Object(__WEBPACK_IMPORTED_MODULE_3__line__["a" /* default */])().defined(defined).curve(curve).context(context);
  }

  area.x = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), x1 = null, area) : x0;
  };

  area.x0 = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : x0;
  };

  area.x1 = function(_) {
    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : x1;
  };

  area.y = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), y1 = null, area) : y0;
  };

  area.y0 = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : y0;
  };

  area.y1 = function(_) {
    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : y1;
  };

  area.lineX0 =
  area.lineY0 = function() {
    return arealine().x(x0).y(y0);
  };

  area.lineY1 = function() {
    return arealine().x(x0).y(y1);
  };

  area.lineX1 = function() {
    return arealine().x(x1).y(y0);
  };

  area.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(!!_), area) : defined;
  };

  area.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
  };

  area.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
  };

  return area;
});


/***/ }),

/***/ "./node_modules/d3-shape/src/areaRadial.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curve_radial__ = __webpack_require__("./node_modules/d3-shape/src/curve/radial.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__area__ = __webpack_require__("./node_modules/d3-shape/src/area.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lineRadial__ = __webpack_require__("./node_modules/d3-shape/src/lineRadial.js");




/* harmony default export */ __webpack_exports__["a"] = (function() {
  var a = Object(__WEBPACK_IMPORTED_MODULE_1__area__["a" /* default */])().curve(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["a" /* curveRadialLinear */]),
      c = a.curve,
      x0 = a.lineX0,
      x1 = a.lineX1,
      y0 = a.lineY0,
      y1 = a.lineY1;

  a.angle = a.x, delete a.x;
  a.startAngle = a.x0, delete a.x0;
  a.endAngle = a.x1, delete a.x1;
  a.radius = a.y, delete a.y;
  a.innerRadius = a.y0, delete a.y0;
  a.outerRadius = a.y1, delete a.y1;
  a.lineStartAngle = function() { return Object(__WEBPACK_IMPORTED_MODULE_2__lineRadial__["b" /* lineRadial */])(x0()); }, delete a.lineX0;
  a.lineEndAngle = function() { return Object(__WEBPACK_IMPORTED_MODULE_2__lineRadial__["b" /* lineRadial */])(x1()); }, delete a.lineX1;
  a.lineInnerRadius = function() { return Object(__WEBPACK_IMPORTED_MODULE_2__lineRadial__["b" /* lineRadial */])(y0()); }, delete a.lineY0;
  a.lineOuterRadius = function() { return Object(__WEBPACK_IMPORTED_MODULE_2__lineRadial__["b" /* lineRadial */])(y1()); }, delete a.lineY1;

  a.curve = function(_) {
    return arguments.length ? c(Object(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["b" /* default */])(_)) : c()._curve;
  };

  return a;
});


/***/ }),

/***/ "./node_modules/d3-shape/src/array.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return slice; });
var slice = Array.prototype.slice;


/***/ }),

/***/ "./node_modules/d3-shape/src/constant.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function constant() {
    return x;
  };
});


/***/ }),

/***/ "./node_modules/d3-shape/src/curve/basis.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = point;
/* harmony export (immutable) */ __webpack_exports__["a"] = Basis;
function point(that, x, y) {
  that._context.bezierCurveTo(
    (2 * that._x0 + that._x1) / 3,
    (2 * that._y0 + that._y1) / 3,
    (that._x0 + 2 * that._x1) / 3,
    (that._y0 + 2 * that._y1) / 3,
    (that._x0 + 4 * that._x1 + x) / 6,
    (that._y0 + 4 * that._y1 + y) / 6
  );
}

function Basis(context) {
  this._context = context;
}

Basis.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3: point(this, this._x1, this._y1); // proceed
      case 2: this._context.lineTo(this._x1, this._y1); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
      default: point(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

/* harmony default export */ __webpack_exports__["b"] = (function(context) {
  return new Basis(context);
});


/***/ }),

/***/ "./node_modules/d3-shape/src/curve/basisClosed.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__("./node_modules/d3-shape/src/noop.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basis__ = __webpack_require__("./node_modules/d3-shape/src/curve/basis.js");



function BasisClosed(context) {
  this._context = context;
}

BasisClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2);
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._x2 = x, this._y2 = y; break;
      case 1: this._point = 2; this._x3 = x, this._y3 = y; break;
      case 2: this._point = 3; this._x4 = x, this._y4 = y; this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6); break;
      default: Object(__WEBPACK_IMPORTED_MODULE_1__basis__["c" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new BasisClosed(context);
});


/***/ }),

/***/ "./node_modules/d3-shape/src/curve/basisOpen.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis__ = __webpack_require__("./node_modules/d3-shape/src/curve/basis.js");


function BasisOpen(context) {
  this._context = context;
}

BasisOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6; this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0); break;
      case 3: this._point = 4; // proceed
      default: Object(__WEBPACK_IMPORTED_MODULE_0__basis__["c" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new BasisOpen(context);
});


/***/ }),

/***/ "./node_modules/d3-shape/src/curve/bundle.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis__ = __webpack_require__("./node_modules/d3-shape/src/curve/basis.js");


function Bundle(context, beta) {
  this._basis = new __WEBPACK_IMPORTED_MODULE_0__basis__["a" /* Basis */](context);
  this._beta = beta;
}

Bundle.prototype = {
  lineStart: function() {
    this._x = [];
    this._y = [];
    this._basis.lineStart();
  },
  lineEnd: function() {
    var x = this._x,
        y = this._y,
        j = x.length - 1;

    if (j > 0) {
      var x0 = x[0],
          y0 = y[0],
          dx = x[j] - x0,
          dy = y[j] - y0,
          i = -1,
          t;

      while (++i <= j) {
        t = i / j;
        this._basis.point(
          this._beta * x[i] + (1 - this._beta) * (x0 + t * dx),
          this._beta * y[i] + (1 - this._beta) * (y0 + t * dy)
        );
      }
    }

    this._x = this._y = null;
    this._basis.lineEnd();
  },
  point: function(x, y) {
    this._x.push(+x);
    this._y.push(+y);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ((function custom(beta) {

  function bundle(context) {
    return beta === 1 ? new __WEBPACK_IMPORTED_MODULE_0__basis__["a" /* Basis */](context) : new Bundle(context, beta);
  }

  bundle.beta = function(beta) {
    return custom(+beta);
  };

  return bundle;
})(0.85));


/***/ }),

/***/ "./node_modules/d3-shape/src/curve/cardinal.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = point;
/* harmony export (immutable) */ __webpack_exports__["a"] = Cardinal;
function point(that, x, y) {
  that._context.bezierCurveTo(
    that._x1 + that._k * (that._x2 - that._x0),
    that._y1 + that._k * (that._y2 - that._y0),
    that._x2 + that._k * (that._x1 - x),
    that._y2 + that._k * (that._y1 - y),
    that._x2,
    that._y2
  );
}

function Cardinal(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

Cardinal.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x2, this._y2); break;
      case 3: point(this, this._x1, this._y1); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; this._x1 = x, this._y1 = y; break;
      case 2: this._point = 3; // proceed
      default: point(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ __webpack_exports__["b"] = ((function custom(tension) {

  function cardinal(context) {
    return new Cardinal(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));


/***/ }),

/***/ "./node_modules/d3-shape/src/curve/cardinalClosed.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CardinalClosed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__("./node_modules/d3-shape/src/noop.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cardinal__ = __webpack_require__("./node_modules/d3-shape/src/curve/cardinal.js");



function CardinalClosed(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

CardinalClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
      default: Object(__WEBPACK_IMPORTED_MODULE_1__cardinal__["c" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ __webpack_exports__["b"] = ((function custom(tension) {

  function cardinal(context) {
    return new CardinalClosed(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));


/***/ }),

/***/ "./node_modules/d3-shape/src/curve/cardinalOpen.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CardinalOpen;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cardinal__ = __webpack_require__("./node_modules/d3-shape/src/curve/cardinal.js");


function CardinalOpen(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

CardinalOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
      case 3: this._point = 4; // proceed
      default: Object(__WEBPACK_IMPORTED_MODULE_0__cardinal__["c" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ __webpack_exports__["b"] = ((function custom(tension) {

  function cardinal(context) {
    return new CardinalOpen(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));


/***/ }),

/***/ "./node_modules/d3-shape/src/curve/catmullRom.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = point;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__("./node_modules/d3-shape/src/math.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cardinal__ = __webpack_require__("./node_modules/d3-shape/src/curve/cardinal.js");



function point(that, x, y) {
  var x1 = that._x1,
      y1 = that._y1,
      x2 = that._x2,
      y2 = that._y2;

  if (that._l01_a > __WEBPACK_IMPORTED_MODULE_0__math__["f" /* epsilon */]) {
    var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
        n = 3 * that._l01_a * (that._l01_a + that._l12_a);
    x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
    y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
  }

  if (that._l23_a > __WEBPACK_IMPORTED_MODULE_0__math__["f" /* epsilon */]) {
    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
        m = 3 * that._l23_a * (that._l23_a + that._l12_a);
    x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
    y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
  }

  that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}

function CatmullRom(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRom.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x2, this._y2); break;
      case 3: this.point(this._x2, this._y2); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; // proceed
      default: point(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRom(context, alpha) : new __WEBPACK_IMPORTED_MODULE_1__cardinal__["a" /* Cardinal */](context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));


/***/ }),

/***/ "./node_modules/d3-shape/src/curve/catmullRomClosed.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cardinalClosed__ = __webpack_require__("./node_modules/d3-shape/src/curve/cardinalClosed.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__noop__ = __webpack_require__("./node_modules/d3-shape/src/noop.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__catmullRom__ = __webpack_require__("./node_modules/d3-shape/src/curve/catmullRom.js");




function CatmullRomClosed(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRomClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_1__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_1__noop__["a" /* default */],
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
      default: Object(__WEBPACK_IMPORTED_MODULE_2__catmullRom__["b" /* point */])(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRomClosed(context, alpha) : new __WEBPACK_IMPORTED_MODULE_0__cardinalClosed__["a" /* CardinalClosed */](context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));


/***/ }),

/***/ "./node_modules/d3-shape/src/curve/catmullRomOpen.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cardinalOpen__ = __webpack_require__("./node_modules/d3-shape/src/curve/cardinalOpen.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__catmullRom__ = __webpack_require__("./node_modules/d3-shape/src/curve/catmullRom.js");



function CatmullRomOpen(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRomOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
      case 3: this._point = 4; // proceed
      default: Object(__WEBPACK_IMPORTED_MODULE_1__catmullRom__["b" /* point */])(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRomOpen(context, alpha) : new __WEBPACK_IMPORTED_MODULE_0__cardinalOpen__["a" /* CardinalOpen */](context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));


/***/ }),

/***/ "./node_modules/d3-shape/src/curve/linear.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function Linear(context) {
  this._context = context;
}

Linear.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; // proceed
      default: this._context.lineTo(x, y); break;
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new Linear(context);
});


/***/ }),

/***/ "./node_modules/d3-shape/src/curve/linearClosed.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__("./node_modules/d3-shape/src/noop.js");


function LinearClosed(context) {
  this._context = context;
}

LinearClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._point) this._context.closePath();
  },
  point: function(x, y) {
    x = +x, y = +y;
    if (this._point) this._context.lineTo(x, y);
    else this._point = 1, this._context.moveTo(x, y);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new LinearClosed(context);
});


/***/ }),

/***/ "./node_modules/d3-shape/src/curve/monotone.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = monotoneX;
/* harmony export (immutable) */ __webpack_exports__["b"] = monotoneY;
function sign(x) {
  return x < 0 ? -1 : 1;
}

// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function slope3(that, x2, y2) {
  var h0 = that._x1 - that._x0,
      h1 = x2 - that._x1,
      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
      p = (s0 * h1 + s1 * h0) / (h0 + h1);
  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}

// Calculate a one-sided slope.
function slope2(that, t) {
  var h = that._x1 - that._x0;
  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}

// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function point(that, t0, t1) {
  var x0 = that._x0,
      y0 = that._y0,
      x1 = that._x1,
      y1 = that._y1,
      dx = (x1 - x0) / 3;
  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}

function MonotoneX(context) {
  this._context = context;
}

MonotoneX.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 =
    this._t0 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x1, this._y1); break;
      case 3: point(this, this._t0, slope2(this, this._t0)); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    var t1 = NaN;

    x = +x, y = +y;
    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; point(this, slope2(this, t1 = slope3(this, x, y)), t1); break;
      default: point(this, this._t0, t1 = slope3(this, x, y)); break;
    }

    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
    this._t0 = t1;
  }
}

function MonotoneY(context) {
  this._context = new ReflectContext(context);
}

(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
  MonotoneX.prototype.point.call(this, y, x);
};

function ReflectContext(context) {
  this._context = context;
}

ReflectContext.prototype = {
  moveTo: function(x, y) { this._context.moveTo(y, x); },
  closePath: function() { this._context.closePath(); },
  lineTo: function(x, y) { this._context.lineTo(y, x); },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) { this._context.bezierCurveTo(y1, x1, y2, x2, y, x); }
};

function monotoneX(context) {
  return new MonotoneX(context);
}

function monotoneY(context) {
  return new MonotoneY(context);
}


/***/ }),

/***/ "./node_modules/d3-shape/src/curve/natural.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function Natural(context) {
  this._context = context;
}

Natural.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [];
    this._y = [];
  },
  lineEnd: function() {
    var x = this._x,
        y = this._y,
        n = x.length;

    if (n) {
      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
      if (n === 2) {
        this._context.lineTo(x[1], y[1]);
      } else {
        var px = controlPoints(x),
            py = controlPoints(y);
        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
        }
      }
    }

    if (this._line || (this._line !== 0 && n === 1)) this._context.closePath();
    this._line = 1 - this._line;
    this._x = this._y = null;
  },
  point: function(x, y) {
    this._x.push(+x);
    this._y.push(+y);
  }
};

// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function controlPoints(x) {
  var i,
      n = x.length - 1,
      m,
      a = new Array(n),
      b = new Array(n),
      r = new Array(n);
  a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
  for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
  a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
  for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
  a[n - 1] = r[n - 1] / b[n - 1];
  for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
  b[n - 1] = (x[n] + a[n - 1]) / 2;
  for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
  return [a, b];
}

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new Natural(context);
});


/***/ }),

/***/ "./node_modules/d3-shape/src/curve/radial.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return curveRadialLinear; });
/* harmony export (immutable) */ __webpack_exports__["b"] = curveRadial;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__linear__ = __webpack_require__("./node_modules/d3-shape/src/curve/linear.js");


var curveRadialLinear = curveRadial(__WEBPACK_IMPORTED_MODULE_0__linear__["a" /* default */]);

function Radial(curve) {
  this._curve = curve;
}

Radial.prototype = {
  areaStart: function() {
    this._curve.areaStart();
  },
  areaEnd: function() {
    this._curve.areaEnd();
  },
  lineStart: function() {
    this._curve.lineStart();
  },
  lineEnd: function() {
    this._curve.lineEnd();
  },
  point: function(a, r) {
    this._curve.point(r * Math.sin(a), r * -Math.cos(a));
  }
};

function curveRadial(curve) {

  function radial(context) {
    return new Radial(curve(context));
  }

  radial._curve = curve;

  return radial;
}


/***/ }),

/***/ "./node_modules/d3-shape/src/curve/step.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = stepBefore;
/* harmony export (immutable) */ __webpack_exports__["b"] = stepAfter;
function Step(context, t) {
  this._context = context;
  this._t = t;
}

Step.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; // proceed
      default: {
        if (this._t <= 0) {
          this._context.lineTo(this._x, y);
          this._context.lineTo(x, y);
        } else {
          var x1 = this._x * (1 - this._t) + x * this._t;
          this._context.lineTo(x1, this._y);
          this._context.lineTo(x1, y);
        }
        break;
      }
    }
    this._x = x, this._y = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new Step(context, 0.5);
});

function stepBefore(context) {
  return new Step(context, 0);
}

function stepAfter(context) {
  return new Step(context, 1);
}


/***/ }),

/***/ "./node_modules/d3-shape/src/descending.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
});


/***/ }),

/***/ "./node_modules/d3-shape/src/identity.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(d) {
  return d;
});


/***/ }),

/***/ "./node_modules/d3-shape/src/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arc__ = __webpack_require__("./node_modules/d3-shape/src/arc.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__arc__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__area__ = __webpack_require__("./node_modules/d3-shape/src/area.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__area__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__line__ = __webpack_require__("./node_modules/d3-shape/src/line.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_2__line__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pie__ = __webpack_require__("./node_modules/d3-shape/src/pie.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_3__pie__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__areaRadial__ = __webpack_require__("./node_modules/d3-shape/src/areaRadial.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__areaRadial__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_4__areaRadial__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lineRadial__ = __webpack_require__("./node_modules/d3-shape/src/lineRadial.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_5__lineRadial__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_5__lineRadial__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pointRadial__ = __webpack_require__("./node_modules/d3-shape/src/pointRadial.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_6__pointRadial__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__link_index__ = __webpack_require__("./node_modules/d3-shape/src/link/index.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_7__link_index__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_7__link_index__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_7__link_index__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__symbol__ = __webpack_require__("./node_modules/d3-shape/src/symbol.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_8__symbol__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return __WEBPACK_IMPORTED_MODULE_8__symbol__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__symbol_circle__ = __webpack_require__("./node_modules/d3-shape/src/symbol/circle.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return __WEBPACK_IMPORTED_MODULE_9__symbol_circle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__symbol_cross__ = __webpack_require__("./node_modules/d3-shape/src/symbol/cross.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return __WEBPACK_IMPORTED_MODULE_10__symbol_cross__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__symbol_diamond__ = __webpack_require__("./node_modules/d3-shape/src/symbol/diamond.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return __WEBPACK_IMPORTED_MODULE_11__symbol_diamond__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__symbol_square__ = __webpack_require__("./node_modules/d3-shape/src/symbol/square.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return __WEBPACK_IMPORTED_MODULE_12__symbol_square__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__symbol_star__ = __webpack_require__("./node_modules/d3-shape/src/symbol/star.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return __WEBPACK_IMPORTED_MODULE_13__symbol_star__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__symbol_triangle__ = __webpack_require__("./node_modules/d3-shape/src/symbol/triangle.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return __WEBPACK_IMPORTED_MODULE_14__symbol_triangle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__symbol_wye__ = __webpack_require__("./node_modules/d3-shape/src/symbol/wye.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return __WEBPACK_IMPORTED_MODULE_15__symbol_wye__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__curve_basisClosed__ = __webpack_require__("./node_modules/d3-shape/src/curve/basisClosed.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_16__curve_basisClosed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__curve_basisOpen__ = __webpack_require__("./node_modules/d3-shape/src/curve/basisOpen.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_17__curve_basisOpen__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__curve_basis__ = __webpack_require__("./node_modules/d3-shape/src/curve/basis.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_18__curve_basis__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__curve_bundle__ = __webpack_require__("./node_modules/d3-shape/src/curve/bundle.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_19__curve_bundle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__curve_cardinalClosed__ = __webpack_require__("./node_modules/d3-shape/src/curve/cardinalClosed.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_20__curve_cardinalClosed__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__curve_cardinalOpen__ = __webpack_require__("./node_modules/d3-shape/src/curve/cardinalOpen.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_21__curve_cardinalOpen__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__curve_cardinal__ = __webpack_require__("./node_modules/d3-shape/src/curve/cardinal.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_22__curve_cardinal__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__curve_catmullRomClosed__ = __webpack_require__("./node_modules/d3-shape/src/curve/catmullRomClosed.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_23__curve_catmullRomClosed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__curve_catmullRomOpen__ = __webpack_require__("./node_modules/d3-shape/src/curve/catmullRomOpen.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_24__curve_catmullRomOpen__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__curve_catmullRom__ = __webpack_require__("./node_modules/d3-shape/src/curve/catmullRom.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_25__curve_catmullRom__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__curve_linearClosed__ = __webpack_require__("./node_modules/d3-shape/src/curve/linearClosed.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_26__curve_linearClosed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__curve_linear__ = __webpack_require__("./node_modules/d3-shape/src/curve/linear.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_27__curve_linear__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__curve_monotone__ = __webpack_require__("./node_modules/d3-shape/src/curve/monotone.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_28__curve_monotone__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_28__curve_monotone__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__curve_natural__ = __webpack_require__("./node_modules/d3-shape/src/curve/natural.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_29__curve_natural__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__curve_step__ = __webpack_require__("./node_modules/d3-shape/src/curve/step.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_30__curve_step__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_30__curve_step__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_30__curve_step__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__stack__ = __webpack_require__("./node_modules/d3-shape/src/stack.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_31__stack__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__offset_expand__ = __webpack_require__("./node_modules/d3-shape/src/offset/expand.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_32__offset_expand__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__offset_diverging__ = __webpack_require__("./node_modules/d3-shape/src/offset/diverging.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_33__offset_diverging__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__offset_none__ = __webpack_require__("./node_modules/d3-shape/src/offset/none.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_34__offset_none__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__offset_silhouette__ = __webpack_require__("./node_modules/d3-shape/src/offset/silhouette.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_35__offset_silhouette__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__offset_wiggle__ = __webpack_require__("./node_modules/d3-shape/src/offset/wiggle.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_36__offset_wiggle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__order_ascending__ = __webpack_require__("./node_modules/d3-shape/src/order/ascending.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_37__order_ascending__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__order_descending__ = __webpack_require__("./node_modules/d3-shape/src/order/descending.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_38__order_descending__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__order_insideOut__ = __webpack_require__("./node_modules/d3-shape/src/order/insideOut.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_39__order_insideOut__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__order_none__ = __webpack_require__("./node_modules/d3-shape/src/order/none.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_40__order_none__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__order_reverse__ = __webpack_require__("./node_modules/d3-shape/src/order/reverse.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_41__order_reverse__["a"]; });




 // Note: radialArea is deprecated!
 // Note: radialLine is deprecated!









































/***/ }),

/***/ "./node_modules/d3-shape/src/line.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__("./node_modules/d3-path/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__("./node_modules/d3-shape/src/constant.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__curve_linear__ = __webpack_require__("./node_modules/d3-shape/src/curve/linear.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__point__ = __webpack_require__("./node_modules/d3-shape/src/point.js");





/* harmony default export */ __webpack_exports__["a"] = (function() {
  var x = __WEBPACK_IMPORTED_MODULE_3__point__["a" /* x */],
      y = __WEBPACK_IMPORTED_MODULE_3__point__["b" /* y */],
      defined = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(true),
      context = null,
      curve = __WEBPACK_IMPORTED_MODULE_2__curve_linear__["a" /* default */],
      output = null;

  function line(data) {
    var i,
        n = data.length,
        d,
        defined0 = false,
        buffer;

    if (context == null) output = curve(buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) output.lineStart();
        else output.lineEnd();
      }
      if (defined0) output.point(+x(d, i, data), +y(d, i, data));
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  line.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), line) : x;
  };

  line.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), line) : y;
  };

  line.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(!!_), line) : defined;
  };

  line.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
  };

  line.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
  };

  return line;
});


/***/ }),

/***/ "./node_modules/d3-shape/src/lineRadial.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = lineRadial;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curve_radial__ = __webpack_require__("./node_modules/d3-shape/src/curve/radial.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__line__ = __webpack_require__("./node_modules/d3-shape/src/line.js");



function lineRadial(l) {
  var c = l.curve;

  l.angle = l.x, delete l.x;
  l.radius = l.y, delete l.y;

  l.curve = function(_) {
    return arguments.length ? c(Object(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["b" /* default */])(_)) : c()._curve;
  };

  return l;
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return lineRadial(Object(__WEBPACK_IMPORTED_MODULE_1__line__["a" /* default */])().curve(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["a" /* curveRadialLinear */]));
});


/***/ }),

/***/ "./node_modules/d3-shape/src/link/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = linkHorizontal;
/* harmony export (immutable) */ __webpack_exports__["c"] = linkVertical;
/* harmony export (immutable) */ __webpack_exports__["b"] = linkRadial;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__("./node_modules/d3-path/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__("./node_modules/d3-shape/src/array.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__("./node_modules/d3-shape/src/constant.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__point__ = __webpack_require__("./node_modules/d3-shape/src/point.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pointRadial__ = __webpack_require__("./node_modules/d3-shape/src/pointRadial.js");






function linkSource(d) {
  return d.source;
}

function linkTarget(d) {
  return d.target;
}

function link(curve) {
  var source = linkSource,
      target = linkTarget,
      x = __WEBPACK_IMPORTED_MODULE_3__point__["a" /* x */],
      y = __WEBPACK_IMPORTED_MODULE_3__point__["b" /* y */],
      context = null;

  function link() {
    var buffer, argv = __WEBPACK_IMPORTED_MODULE_1__array__["a" /* slice */].call(arguments), s = source.apply(this, argv), t = target.apply(this, argv);
    if (!context) context = buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])();
    curve(context, +x.apply(this, (argv[0] = s, argv)), +y.apply(this, argv), +x.apply(this, (argv[0] = t, argv)), +y.apply(this, argv));
    if (buffer) return context = null, buffer + "" || null;
  }

  link.source = function(_) {
    return arguments.length ? (source = _, link) : source;
  };

  link.target = function(_) {
    return arguments.length ? (target = _, link) : target;
  };

  link.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(+_), link) : x;
  };

  link.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(+_), link) : y;
  };

  link.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), link) : context;
  };

  return link;
}

function curveHorizontal(context, x0, y0, x1, y1) {
  context.moveTo(x0, y0);
  context.bezierCurveTo(x0 = (x0 + x1) / 2, y0, x0, y1, x1, y1);
}

function curveVertical(context, x0, y0, x1, y1) {
  context.moveTo(x0, y0);
  context.bezierCurveTo(x0, y0 = (y0 + y1) / 2, x1, y0, x1, y1);
}

function curveRadial(context, x0, y0, x1, y1) {
  var p0 = Object(__WEBPACK_IMPORTED_MODULE_4__pointRadial__["a" /* default */])(x0, y0),
      p1 = Object(__WEBPACK_IMPORTED_MODULE_4__pointRadial__["a" /* default */])(x0, y0 = (y0 + y1) / 2),
      p2 = Object(__WEBPACK_IMPORTED_MODULE_4__pointRadial__["a" /* default */])(x1, y0),
      p3 = Object(__WEBPACK_IMPORTED_MODULE_4__pointRadial__["a" /* default */])(x1, y1);
  context.moveTo(p0[0], p0[1]);
  context.bezierCurveTo(p1[0], p1[1], p2[0], p2[1], p3[0], p3[1]);
}

function linkHorizontal() {
  return link(curveHorizontal);
}

function linkVertical() {
  return link(curveVertical);
}

function linkRadial() {
  var l = link(curveRadial);
  l.angle = l.x, delete l.x;
  l.radius = l.y, delete l.y;
  return l;
}


/***/ }),

/***/ "./node_modules/d3-shape/src/math.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return abs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return atan2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return cos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return max; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return min; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return sin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return sqrt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return epsilon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return pi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return halfPi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return tau; });
/* harmony export (immutable) */ __webpack_exports__["b"] = acos;
/* harmony export (immutable) */ __webpack_exports__["c"] = asin;
var abs = Math.abs;
var atan2 = Math.atan2;
var cos = Math.cos;
var max = Math.max;
var min = Math.min;
var sin = Math.sin;
var sqrt = Math.sqrt;

var epsilon = 1e-12;
var pi = Math.PI;
var halfPi = pi / 2;
var tau = 2 * pi;

function acos(x) {
  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}

function asin(x) {
  return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
}


/***/ }),

/***/ "./node_modules/d3-shape/src/noop.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {});


/***/ }),

/***/ "./node_modules/d3-shape/src/offset/diverging.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 1)) return;
  for (var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j) {
    for (yp = yn = 0, i = 0; i < n; ++i) {
      if ((dy = (d = series[order[i]][j])[1] - d[0]) >= 0) {
        d[0] = yp, d[1] = yp += dy;
      } else if (dy < 0) {
        d[1] = yn, d[0] = yn += dy;
      } else {
        d[0] = yp;
      }
    }
  }
});


/***/ }),

/***/ "./node_modules/d3-shape/src/offset/expand.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__("./node_modules/d3-shape/src/offset/none.js");


/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
    for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
    if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series, order);
});


/***/ }),

/***/ "./node_modules/d3-shape/src/offset/none.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 1)) return;
  for (var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
    s0 = s1, s1 = series[order[i]];
    for (j = 0; j < m; ++j) {
      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
  }
});


/***/ }),

/***/ "./node_modules/d3-shape/src/offset/silhouette.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__("./node_modules/d3-shape/src/offset/none.js");


/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
    for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;
    s0[j][1] += s0[j][0] = -y / 2;
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series, order);
});


/***/ }),

/***/ "./node_modules/d3-shape/src/offset/wiggle.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__("./node_modules/d3-shape/src/offset/none.js");


/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
  for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
      var si = series[order[i]],
          sij0 = si[j][1] || 0,
          sij1 = si[j - 1][1] || 0,
          s3 = (sij0 - sij1) / 2;
      for (var k = 0; k < i; ++k) {
        var sk = series[order[k]],
            skj0 = sk[j][1] || 0,
            skj1 = sk[j - 1][1] || 0;
        s3 += skj0 - skj1;
      }
      s1 += sij0, s2 += s3 * sij0;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    if (s1) y -= s2 / s1;
  }
  s0[j - 1][1] += s0[j - 1][0] = y;
  Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series, order);
});


/***/ }),

/***/ "./node_modules/d3-shape/src/order/ascending.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = sum;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__("./node_modules/d3-shape/src/order/none.js");


/* harmony default export */ __webpack_exports__["a"] = (function(series) {
  var sums = series.map(sum);
  return Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series).sort(function(a, b) { return sums[a] - sums[b]; });
});

function sum(series) {
  var s = 0, i = -1, n = series.length, v;
  while (++i < n) if (v = +series[i][1]) s += v;
  return s;
}


/***/ }),

/***/ "./node_modules/d3-shape/src/order/descending.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__("./node_modules/d3-shape/src/order/ascending.js");


/* harmony default export */ __webpack_exports__["a"] = (function(series) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */])(series).reverse();
});


/***/ }),

/***/ "./node_modules/d3-shape/src/order/insideOut.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__("./node_modules/d3-shape/src/order/none.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ascending__ = __webpack_require__("./node_modules/d3-shape/src/order/ascending.js");



/* harmony default export */ __webpack_exports__["a"] = (function(series) {
  var n = series.length,
      i,
      j,
      sums = series.map(__WEBPACK_IMPORTED_MODULE_1__ascending__["b" /* sum */]),
      order = Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series).sort(function(a, b) { return sums[b] - sums[a]; }),
      top = 0,
      bottom = 0,
      tops = [],
      bottoms = [];

  for (i = 0; i < n; ++i) {
    j = order[i];
    if (top < bottom) {
      top += sums[j];
      tops.push(j);
    } else {
      bottom += sums[j];
      bottoms.push(j);
    }
  }

  return bottoms.reverse().concat(tops);
});


/***/ }),

/***/ "./node_modules/d3-shape/src/order/none.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(series) {
  var n = series.length, o = new Array(n);
  while (--n >= 0) o[n] = n;
  return o;
});


/***/ }),

/***/ "./node_modules/d3-shape/src/order/reverse.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__("./node_modules/d3-shape/src/order/none.js");


/* harmony default export */ __webpack_exports__["a"] = (function(series) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series).reverse();
});


/***/ }),

/***/ "./node_modules/d3-shape/src/pie.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__("./node_modules/d3-shape/src/constant.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__descending__ = __webpack_require__("./node_modules/d3-shape/src/descending.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__identity__ = __webpack_require__("./node_modules/d3-shape/src/identity.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__math__ = __webpack_require__("./node_modules/d3-shape/src/math.js");





/* harmony default export */ __webpack_exports__["a"] = (function() {
  var value = __WEBPACK_IMPORTED_MODULE_2__identity__["a" /* default */],
      sortValues = __WEBPACK_IMPORTED_MODULE_1__descending__["a" /* default */],
      sort = null,
      startAngle = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(0),
      endAngle = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__math__["m" /* tau */]),
      padAngle = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(0);

  function pie(data) {
    var i,
        n = data.length,
        j,
        k,
        sum = 0,
        index = new Array(n),
        arcs = new Array(n),
        a0 = +startAngle.apply(this, arguments),
        da = Math.min(__WEBPACK_IMPORTED_MODULE_3__math__["m" /* tau */], Math.max(-__WEBPACK_IMPORTED_MODULE_3__math__["m" /* tau */], endAngle.apply(this, arguments) - a0)),
        a1,
        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
        pa = p * (da < 0 ? -1 : 1),
        v;

    for (i = 0; i < n; ++i) {
      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
        sum += v;
      }
    }

    // Optionally sort the arcs by previously-computed values or by data.
    if (sortValues != null) index.sort(function(i, j) { return sortValues(arcs[i], arcs[j]); });
    else if (sort != null) index.sort(function(i, j) { return sort(data[i], data[j]); });

    // Compute the arcs! They are stored in the original data's order.
    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
        data: data[j],
        index: i,
        value: v,
        startAngle: a0,
        endAngle: a1,
        padAngle: p
      };
    }

    return arcs;
  }

  pie.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : value;
  };

  pie.sortValues = function(_) {
    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
  };

  pie.sort = function(_) {
    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
  };

  pie.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : startAngle;
  };

  pie.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : endAngle;
  };

  pie.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : padAngle;
  };

  return pie;
});


/***/ }),

/***/ "./node_modules/d3-shape/src/point.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = x;
/* harmony export (immutable) */ __webpack_exports__["b"] = y;
function x(p) {
  return p[0];
}

function y(p) {
  return p[1];
}


/***/ }),

/***/ "./node_modules/d3-shape/src/pointRadial.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x, y) {
  return [(y = +y) * Math.cos(x -= Math.PI / 2), y * Math.sin(x)];
});


/***/ }),

/***/ "./node_modules/d3-shape/src/stack.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__("./node_modules/d3-shape/src/array.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__("./node_modules/d3-shape/src/constant.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__offset_none__ = __webpack_require__("./node_modules/d3-shape/src/offset/none.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__order_none__ = __webpack_require__("./node_modules/d3-shape/src/order/none.js");





function stackValue(d, key) {
  return d[key];
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var keys = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])([]),
      order = __WEBPACK_IMPORTED_MODULE_3__order_none__["a" /* default */],
      offset = __WEBPACK_IMPORTED_MODULE_2__offset_none__["a" /* default */],
      value = stackValue;

  function stack(data) {
    var kz = keys.apply(this, arguments),
        i,
        m = data.length,
        n = kz.length,
        sz = new Array(n),
        oz;

    for (i = 0; i < n; ++i) {
      for (var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j) {
        si[j] = sij = [0, +value(data[j], ki, j, data)];
        sij.data = data[j];
      }
      si.key = ki;
    }

    for (i = 0, oz = order(sz); i < n; ++i) {
      sz[oz[i]].index = i;
    }

    offset(sz, oz);
    return sz;
  }

  stack.keys = function(_) {
    return arguments.length ? (keys = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(_)), stack) : keys;
  };

  stack.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), stack) : value;
  };

  stack.order = function(_) {
    return arguments.length ? (order = _ == null ? __WEBPACK_IMPORTED_MODULE_3__order_none__["a" /* default */] : typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(_)), stack) : order;
  };

  stack.offset = function(_) {
    return arguments.length ? (offset = _ == null ? __WEBPACK_IMPORTED_MODULE_2__offset_none__["a" /* default */] : _, stack) : offset;
  };

  return stack;
});


/***/ }),

/***/ "./node_modules/d3-shape/src/symbol.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return symbols; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__("./node_modules/d3-path/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__symbol_circle__ = __webpack_require__("./node_modules/d3-shape/src/symbol/circle.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__symbol_cross__ = __webpack_require__("./node_modules/d3-shape/src/symbol/cross.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__symbol_diamond__ = __webpack_require__("./node_modules/d3-shape/src/symbol/diamond.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__symbol_star__ = __webpack_require__("./node_modules/d3-shape/src/symbol/star.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__symbol_square__ = __webpack_require__("./node_modules/d3-shape/src/symbol/square.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__symbol_triangle__ = __webpack_require__("./node_modules/d3-shape/src/symbol/triangle.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__symbol_wye__ = __webpack_require__("./node_modules/d3-shape/src/symbol/wye.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constant__ = __webpack_require__("./node_modules/d3-shape/src/constant.js");










var symbols = [
  __WEBPACK_IMPORTED_MODULE_1__symbol_circle__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_2__symbol_cross__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_3__symbol_diamond__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_5__symbol_square__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_4__symbol_star__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_6__symbol_triangle__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_7__symbol_wye__["a" /* default */]
];

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var type = Object(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__symbol_circle__["a" /* default */]),
      size = Object(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(64),
      context = null;

  function symbol() {
    var buffer;
    if (!context) context = buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])();
    type.apply(this, arguments).draw(context, +size.apply(this, arguments));
    if (buffer) return context = null, buffer + "" || null;
  }

  symbol.type = function(_) {
    return arguments.length ? (type = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(_), symbol) : type;
  };

  symbol.size = function(_) {
    return arguments.length ? (size = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(+_), symbol) : size;
  };

  symbol.context = function(_) {
    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
  };

  return symbol;
});


/***/ }),

/***/ "./node_modules/d3-shape/src/symbol/circle.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__("./node_modules/d3-shape/src/math.js");


/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / __WEBPACK_IMPORTED_MODULE_0__math__["j" /* pi */]);
    context.moveTo(r, 0);
    context.arc(0, 0, r, 0, __WEBPACK_IMPORTED_MODULE_0__math__["m" /* tau */]);
  }
});


/***/ }),

/***/ "./node_modules/d3-shape/src/symbol/cross.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / 5) / 2;
    context.moveTo(-3 * r, -r);
    context.lineTo(-r, -r);
    context.lineTo(-r, -3 * r);
    context.lineTo(r, -3 * r);
    context.lineTo(r, -r);
    context.lineTo(3 * r, -r);
    context.lineTo(3 * r, r);
    context.lineTo(r, r);
    context.lineTo(r, 3 * r);
    context.lineTo(-r, 3 * r);
    context.lineTo(-r, r);
    context.lineTo(-3 * r, r);
    context.closePath();
  }
});


/***/ }),

/***/ "./node_modules/d3-shape/src/symbol/diamond.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var tan30 = Math.sqrt(1 / 3),
    tan30_2 = tan30 * 2;

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var y = Math.sqrt(size / tan30_2),
        x = y * tan30;
    context.moveTo(0, -y);
    context.lineTo(x, 0);
    context.lineTo(0, y);
    context.lineTo(-x, 0);
    context.closePath();
  }
});


/***/ }),

/***/ "./node_modules/d3-shape/src/symbol/square.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var w = Math.sqrt(size),
        x = -w / 2;
    context.rect(x, x, w, w);
  }
});


/***/ }),

/***/ "./node_modules/d3-shape/src/symbol/star.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__("./node_modules/d3-shape/src/math.js");


var ka = 0.89081309152928522810,
    kr = Math.sin(__WEBPACK_IMPORTED_MODULE_0__math__["j" /* pi */] / 10) / Math.sin(7 * __WEBPACK_IMPORTED_MODULE_0__math__["j" /* pi */] / 10),
    kx = Math.sin(__WEBPACK_IMPORTED_MODULE_0__math__["m" /* tau */] / 10) * kr,
    ky = -Math.cos(__WEBPACK_IMPORTED_MODULE_0__math__["m" /* tau */] / 10) * kr;

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size * ka),
        x = kx * r,
        y = ky * r;
    context.moveTo(0, -r);
    context.lineTo(x, y);
    for (var i = 1; i < 5; ++i) {
      var a = __WEBPACK_IMPORTED_MODULE_0__math__["m" /* tau */] * i / 5,
          c = Math.cos(a),
          s = Math.sin(a);
      context.lineTo(s * r, -c * r);
      context.lineTo(c * x - s * y, s * x + c * y);
    }
    context.closePath();
  }
});


/***/ }),

/***/ "./node_modules/d3-shape/src/symbol/triangle.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var sqrt3 = Math.sqrt(3);

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var y = -Math.sqrt(size / (sqrt3 * 3));
    context.moveTo(0, y * 2);
    context.lineTo(-sqrt3 * y, -y);
    context.lineTo(sqrt3 * y, -y);
    context.closePath();
  }
});


/***/ }),

/***/ "./node_modules/d3-shape/src/symbol/wye.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var c = -0.5,
    s = Math.sqrt(3) / 2,
    k = 1 / Math.sqrt(12),
    a = (k / 2 + 1) * 3;

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / a),
        x0 = r / 2,
        y0 = r * k,
        x1 = x0,
        y1 = r * k + r,
        x2 = -x1,
        y2 = y1;
    context.moveTo(x0, y0);
    context.lineTo(x1, y1);
    context.lineTo(x2, y2);
    context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
    context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
    context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
    context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
    context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
    context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
    context.closePath();
  }
});


/***/ }),

/***/ "./node_modules/d3-time-format/src/defaultLocale.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return timeFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return timeParse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return utcFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return utcParse; });
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultLocale;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale__ = __webpack_require__("./node_modules/d3-time-format/src/locale.js");


var locale;
var timeFormat;
var timeParse;
var utcFormat;
var utcParse;

defaultLocale({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});

function defaultLocale(definition) {
  locale = Object(__WEBPACK_IMPORTED_MODULE_0__locale__["a" /* default */])(definition);
  timeFormat = locale.format;
  timeParse = locale.parse;
  utcFormat = locale.utcFormat;
  utcParse = locale.utcParse;
  return locale;
}


/***/ }),

/***/ "./node_modules/d3-time-format/src/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultLocale__ = __webpack_require__("./node_modules/d3-time-format/src/defaultLocale.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__defaultLocale__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__defaultLocale__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__defaultLocale__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_0__defaultLocale__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_0__defaultLocale__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__locale__ = __webpack_require__("./node_modules/d3-time-format/src/locale.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__locale__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isoFormat__ = __webpack_require__("./node_modules/d3-time-format/src/isoFormat.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__isoFormat__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isoParse__ = __webpack_require__("./node_modules/d3-time-format/src/isoParse.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__isoParse__["a"]; });






/***/ }),

/***/ "./node_modules/d3-time-format/src/isoFormat.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isoSpecifier; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultLocale__ = __webpack_require__("./node_modules/d3-time-format/src/defaultLocale.js");


var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";

function formatIsoNative(date) {
  return date.toISOString();
}

var formatIso = Date.prototype.toISOString
    ? formatIsoNative
    : Object(__WEBPACK_IMPORTED_MODULE_0__defaultLocale__["d" /* utcFormat */])(isoSpecifier);

/* harmony default export */ __webpack_exports__["a"] = (formatIso);


/***/ }),

/***/ "./node_modules/d3-time-format/src/isoParse.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isoFormat__ = __webpack_require__("./node_modules/d3-time-format/src/isoFormat.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defaultLocale__ = __webpack_require__("./node_modules/d3-time-format/src/defaultLocale.js");



function parseIsoNative(string) {
  var date = new Date(string);
  return isNaN(date) ? null : date;
}

var parseIso = +new Date("2000-01-01T00:00:00.000Z")
    ? parseIsoNative
    : Object(__WEBPACK_IMPORTED_MODULE_1__defaultLocale__["e" /* utcParse */])(__WEBPACK_IMPORTED_MODULE_0__isoFormat__["b" /* isoSpecifier */]);

/* harmony default export */ __webpack_exports__["a"] = (parseIso);


/***/ }),

/***/ "./node_modules/d3-time-format/src/locale.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatLocale;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_time__ = __webpack_require__("./node_modules/d3-time/src/index.js");


function localDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
    date.setFullYear(d.y);
    return date;
  }
  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}

function utcDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
    date.setUTCFullYear(d.y);
    return date;
  }
  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}

function newYear(y) {
  return {y: y, m: 0, d: 1, H: 0, M: 0, S: 0, L: 0};
}

function formatLocale(locale) {
  var locale_dateTime = locale.dateTime,
      locale_date = locale.date,
      locale_time = locale.time,
      locale_periods = locale.periods,
      locale_weekdays = locale.days,
      locale_shortWeekdays = locale.shortDays,
      locale_months = locale.months,
      locale_shortMonths = locale.shortMonths;

  var periodRe = formatRe(locale_periods),
      periodLookup = formatLookup(locale_periods),
      weekdayRe = formatRe(locale_weekdays),
      weekdayLookup = formatLookup(locale_weekdays),
      shortWeekdayRe = formatRe(locale_shortWeekdays),
      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
      monthRe = formatRe(locale_months),
      monthLookup = formatLookup(locale_months),
      shortMonthRe = formatRe(locale_shortMonths),
      shortMonthLookup = formatLookup(locale_shortMonths);

  var formats = {
    "a": formatShortWeekday,
    "A": formatWeekday,
    "b": formatShortMonth,
    "B": formatMonth,
    "c": null,
    "d": formatDayOfMonth,
    "e": formatDayOfMonth,
    "f": formatMicroseconds,
    "H": formatHour24,
    "I": formatHour12,
    "j": formatDayOfYear,
    "L": formatMilliseconds,
    "m": formatMonthNumber,
    "M": formatMinutes,
    "p": formatPeriod,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatSeconds,
    "u": formatWeekdayNumberMonday,
    "U": formatWeekNumberSunday,
    "V": formatWeekNumberISO,
    "w": formatWeekdayNumberSunday,
    "W": formatWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatYear,
    "Y": formatFullYear,
    "Z": formatZone,
    "%": formatLiteralPercent
  };

  var utcFormats = {
    "a": formatUTCShortWeekday,
    "A": formatUTCWeekday,
    "b": formatUTCShortMonth,
    "B": formatUTCMonth,
    "c": null,
    "d": formatUTCDayOfMonth,
    "e": formatUTCDayOfMonth,
    "f": formatUTCMicroseconds,
    "H": formatUTCHour24,
    "I": formatUTCHour12,
    "j": formatUTCDayOfYear,
    "L": formatUTCMilliseconds,
    "m": formatUTCMonthNumber,
    "M": formatUTCMinutes,
    "p": formatUTCPeriod,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatUTCSeconds,
    "u": formatUTCWeekdayNumberMonday,
    "U": formatUTCWeekNumberSunday,
    "V": formatUTCWeekNumberISO,
    "w": formatUTCWeekdayNumberSunday,
    "W": formatUTCWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatUTCYear,
    "Y": formatUTCFullYear,
    "Z": formatUTCZone,
    "%": formatLiteralPercent
  };

  var parses = {
    "a": parseShortWeekday,
    "A": parseWeekday,
    "b": parseShortMonth,
    "B": parseMonth,
    "c": parseLocaleDateTime,
    "d": parseDayOfMonth,
    "e": parseDayOfMonth,
    "f": parseMicroseconds,
    "H": parseHour24,
    "I": parseHour24,
    "j": parseDayOfYear,
    "L": parseMilliseconds,
    "m": parseMonthNumber,
    "M": parseMinutes,
    "p": parsePeriod,
    "Q": parseUnixTimestamp,
    "s": parseUnixTimestampSeconds,
    "S": parseSeconds,
    "u": parseWeekdayNumberMonday,
    "U": parseWeekNumberSunday,
    "V": parseWeekNumberISO,
    "w": parseWeekdayNumberSunday,
    "W": parseWeekNumberMonday,
    "x": parseLocaleDate,
    "X": parseLocaleTime,
    "y": parseYear,
    "Y": parseFullYear,
    "Z": parseZone,
    "%": parseLiteralPercent
  };

  // These recursive directive definitions must be deferred.
  formats.x = newFormat(locale_date, formats);
  formats.X = newFormat(locale_time, formats);
  formats.c = newFormat(locale_dateTime, formats);
  utcFormats.x = newFormat(locale_date, utcFormats);
  utcFormats.X = newFormat(locale_time, utcFormats);
  utcFormats.c = newFormat(locale_dateTime, utcFormats);

  function newFormat(specifier, formats) {
    return function(date) {
      var string = [],
          i = -1,
          j = 0,
          n = specifier.length,
          c,
          pad,
          format;

      if (!(date instanceof Date)) date = new Date(+date);

      while (++i < n) {
        if (specifier.charCodeAt(i) === 37) {
          string.push(specifier.slice(j, i));
          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
          else pad = c === "e" ? " " : "0";
          if (format = formats[c]) c = format(date, pad);
          string.push(c);
          j = i + 1;
        }
      }

      string.push(specifier.slice(j, i));
      return string.join("");
    };
  }

  function newParse(specifier, newDate) {
    return function(string) {
      var d = newYear(1900),
          i = parseSpecifier(d, specifier, string += "", 0),
          week, day;
      if (i != string.length) return null;

      // If a UNIX timestamp is specified, return it.
      if ("Q" in d) return new Date(d.Q);

      // The am-pm flag is 0 for AM, and 1 for PM.
      if ("p" in d) d.H = d.H % 12 + d.p * 12;

      // Convert day-of-week and week-of-year to day-of-year.
      if ("V" in d) {
        if (d.V < 1 || d.V > 53) return null;
        if (!("w" in d)) d.w = 1;
        if ("Z" in d) {
          week = utcDate(newYear(d.y)), day = week.getUTCDay();
          week = day > 4 || day === 0 ? __WEBPACK_IMPORTED_MODULE_0_d3_time__["P" /* utcMonday */].ceil(week) : Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["P" /* utcMonday */])(week);
          week = __WEBPACK_IMPORTED_MODULE_0_d3_time__["F" /* utcDay */].offset(week, (d.V - 1) * 7);
          d.y = week.getUTCFullYear();
          d.m = week.getUTCMonth();
          d.d = week.getUTCDate() + (d.w + 6) % 7;
        } else {
          week = newDate(newYear(d.y)), day = week.getDay();
          week = day > 4 || day === 0 ? __WEBPACK_IMPORTED_MODULE_0_d3_time__["l" /* timeMonday */].ceil(week) : Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["l" /* timeMonday */])(week);
          week = __WEBPACK_IMPORTED_MODULE_0_d3_time__["a" /* timeDay */].offset(week, (d.V - 1) * 7);
          d.y = week.getFullYear();
          d.m = week.getMonth();
          d.d = week.getDate() + (d.w + 6) % 7;
        }
      } else if ("W" in d || "U" in d) {
        if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
        day = "Z" in d ? utcDate(newYear(d.y)).getUTCDay() : newDate(newYear(d.y)).getDay();
        d.m = 0;
        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
      }

      // If a time zone is specified, all fields are interpreted as UTC and then
      // offset according to the specified time zone.
      if ("Z" in d) {
        d.H += d.Z / 100 | 0;
        d.M += d.Z % 100;
        return utcDate(d);
      }

      // Otherwise, all fields are in local time.
      return newDate(d);
    };
  }

  function parseSpecifier(d, specifier, string, j) {
    var i = 0,
        n = specifier.length,
        m = string.length,
        c,
        parse;

    while (i < n) {
      if (j >= m) return -1;
      c = specifier.charCodeAt(i++);
      if (c === 37) {
        c = specifier.charAt(i++);
        parse = parses[c in pads ? specifier.charAt(i++) : c];
        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
      } else if (c != string.charCodeAt(j++)) {
        return -1;
      }
    }

    return j;
  }

  function parsePeriod(d, string, i) {
    var n = periodRe.exec(string.slice(i));
    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortWeekday(d, string, i) {
    var n = shortWeekdayRe.exec(string.slice(i));
    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseWeekday(d, string, i) {
    var n = weekdayRe.exec(string.slice(i));
    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortMonth(d, string, i) {
    var n = shortMonthRe.exec(string.slice(i));
    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseMonth(d, string, i) {
    var n = monthRe.exec(string.slice(i));
    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseLocaleDateTime(d, string, i) {
    return parseSpecifier(d, locale_dateTime, string, i);
  }

  function parseLocaleDate(d, string, i) {
    return parseSpecifier(d, locale_date, string, i);
  }

  function parseLocaleTime(d, string, i) {
    return parseSpecifier(d, locale_time, string, i);
  }

  function formatShortWeekday(d) {
    return locale_shortWeekdays[d.getDay()];
  }

  function formatWeekday(d) {
    return locale_weekdays[d.getDay()];
  }

  function formatShortMonth(d) {
    return locale_shortMonths[d.getMonth()];
  }

  function formatMonth(d) {
    return locale_months[d.getMonth()];
  }

  function formatPeriod(d) {
    return locale_periods[+(d.getHours() >= 12)];
  }

  function formatUTCShortWeekday(d) {
    return locale_shortWeekdays[d.getUTCDay()];
  }

  function formatUTCWeekday(d) {
    return locale_weekdays[d.getUTCDay()];
  }

  function formatUTCShortMonth(d) {
    return locale_shortMonths[d.getUTCMonth()];
  }

  function formatUTCMonth(d) {
    return locale_months[d.getUTCMonth()];
  }

  function formatUTCPeriod(d) {
    return locale_periods[+(d.getUTCHours() >= 12)];
  }

  return {
    format: function(specifier) {
      var f = newFormat(specifier += "", formats);
      f.toString = function() { return specifier; };
      return f;
    },
    parse: function(specifier) {
      var p = newParse(specifier += "", localDate);
      p.toString = function() { return specifier; };
      return p;
    },
    utcFormat: function(specifier) {
      var f = newFormat(specifier += "", utcFormats);
      f.toString = function() { return specifier; };
      return f;
    },
    utcParse: function(specifier) {
      var p = newParse(specifier, utcDate);
      p.toString = function() { return specifier; };
      return p;
    }
  };
}

var pads = {"-": "", "_": " ", "0": "0"},
    numberRe = /^\s*\d+/, // note: ignores next directive
    percentRe = /^%/,
    requoteRe = /[\\^$*+?|[\]().{}]/g;

function pad(value, fill, width) {
  var sign = value < 0 ? "-" : "",
      string = (sign ? -value : value) + "",
      length = string.length;
  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}

function requote(s) {
  return s.replace(requoteRe, "\\$&");
}

function formatRe(names) {
  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}

function formatLookup(names) {
  var map = {}, i = -1, n = names.length;
  while (++i < n) map[names[i].toLowerCase()] = i;
  return map;
}

function parseWeekdayNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.w = +n[0], i + n[0].length) : -1;
}

function parseWeekdayNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.u = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.U = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberISO(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.V = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.W = +n[0], i + n[0].length) : -1;
}

function parseFullYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 4));
  return n ? (d.y = +n[0], i + n[0].length) : -1;
}

function parseYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}

function parseZone(d, string, i) {
  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}

function parseMonthNumber(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}

function parseDayOfMonth(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.d = +n[0], i + n[0].length) : -1;
}

function parseDayOfYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}

function parseHour24(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.H = +n[0], i + n[0].length) : -1;
}

function parseMinutes(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.M = +n[0], i + n[0].length) : -1;
}

function parseSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.S = +n[0], i + n[0].length) : -1;
}

function parseMilliseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.L = +n[0], i + n[0].length) : -1;
}

function parseMicroseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 6));
  return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}

function parseLiteralPercent(d, string, i) {
  var n = percentRe.exec(string.slice(i, i + 1));
  return n ? i + n[0].length : -1;
}

function parseUnixTimestamp(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.Q = +n[0], i + n[0].length) : -1;
}

function parseUnixTimestampSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.Q = (+n[0]) * 1000, i + n[0].length) : -1;
}

function formatDayOfMonth(d, p) {
  return pad(d.getDate(), p, 2);
}

function formatHour24(d, p) {
  return pad(d.getHours(), p, 2);
}

function formatHour12(d, p) {
  return pad(d.getHours() % 12 || 12, p, 2);
}

function formatDayOfYear(d, p) {
  return pad(1 + __WEBPACK_IMPORTED_MODULE_0_d3_time__["a" /* timeDay */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["D" /* timeYear */])(d), d), p, 3);
}

function formatMilliseconds(d, p) {
  return pad(d.getMilliseconds(), p, 3);
}

function formatMicroseconds(d, p) {
  return formatMilliseconds(d, p) + "000";
}

function formatMonthNumber(d, p) {
  return pad(d.getMonth() + 1, p, 2);
}

function formatMinutes(d, p) {
  return pad(d.getMinutes(), p, 2);
}

function formatSeconds(d, p) {
  return pad(d.getSeconds(), p, 2);
}

function formatWeekdayNumberMonday(d) {
  var day = d.getDay();
  return day === 0 ? 7 : day;
}

function formatWeekNumberSunday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["t" /* timeSunday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["D" /* timeYear */])(d), d), p, 2);
}

function formatWeekNumberISO(d, p) {
  var day = d.getDay();
  d = (day >= 4 || day === 0) ? Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["v" /* timeThursday */])(d) : __WEBPACK_IMPORTED_MODULE_0_d3_time__["v" /* timeThursday */].ceil(d);
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["v" /* timeThursday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["D" /* timeYear */])(d), d) + (Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["D" /* timeYear */])(d).getDay() === 4), p, 2);
}

function formatWeekdayNumberSunday(d) {
  return d.getDay();
}

function formatWeekNumberMonday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["l" /* timeMonday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["D" /* timeYear */])(d), d), p, 2);
}

function formatYear(d, p) {
  return pad(d.getFullYear() % 100, p, 2);
}

function formatFullYear(d, p) {
  return pad(d.getFullYear() % 10000, p, 4);
}

function formatZone(d) {
  var z = d.getTimezoneOffset();
  return (z > 0 ? "-" : (z *= -1, "+"))
      + pad(z / 60 | 0, "0", 2)
      + pad(z % 60, "0", 2);
}

function formatUTCDayOfMonth(d, p) {
  return pad(d.getUTCDate(), p, 2);
}

function formatUTCHour24(d, p) {
  return pad(d.getUTCHours(), p, 2);
}

function formatUTCHour12(d, p) {
  return pad(d.getUTCHours() % 12 || 12, p, 2);
}

function formatUTCDayOfYear(d, p) {
  return pad(1 + __WEBPACK_IMPORTED_MODULE_0_d3_time__["F" /* utcDay */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["_7" /* utcYear */])(d), d), p, 3);
}

function formatUTCMilliseconds(d, p) {
  return pad(d.getUTCMilliseconds(), p, 3);
}

function formatUTCMicroseconds(d, p) {
  return formatUTCMilliseconds(d, p) + "000";
}

function formatUTCMonthNumber(d, p) {
  return pad(d.getUTCMonth() + 1, p, 2);
}

function formatUTCMinutes(d, p) {
  return pad(d.getUTCMinutes(), p, 2);
}

function formatUTCSeconds(d, p) {
  return pad(d.getUTCSeconds(), p, 2);
}

function formatUTCWeekdayNumberMonday(d) {
  var dow = d.getUTCDay();
  return dow === 0 ? 7 : dow;
}

function formatUTCWeekNumberSunday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["X" /* utcSunday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["_7" /* utcYear */])(d), d), p, 2);
}

function formatUTCWeekNumberISO(d, p) {
  var day = d.getUTCDay();
  d = (day >= 4 || day === 0) ? Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["Z" /* utcThursday */])(d) : __WEBPACK_IMPORTED_MODULE_0_d3_time__["Z" /* utcThursday */].ceil(d);
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["Z" /* utcThursday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["_7" /* utcYear */])(d), d) + (Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["_7" /* utcYear */])(d).getUTCDay() === 4), p, 2);
}

function formatUTCWeekdayNumberSunday(d) {
  return d.getUTCDay();
}

function formatUTCWeekNumberMonday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["P" /* utcMonday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["_7" /* utcYear */])(d), d), p, 2);
}

function formatUTCYear(d, p) {
  return pad(d.getUTCFullYear() % 100, p, 2);
}

function formatUTCFullYear(d, p) {
  return pad(d.getUTCFullYear() % 10000, p, 4);
}

function formatUTCZone() {
  return "+0000";
}

function formatLiteralPercent() {
  return "%";
}

function formatUnixTimestamp(d) {
  return +d;
}

function formatUnixTimestampSeconds(d) {
  return Math.floor(+d / 1000);
}


/***/ }),

/***/ "./node_modules/d3-time/src/day.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return days; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__("./node_modules/d3-time/src/interval.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__("./node_modules/d3-time/src/duration.js");



var day = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setDate(date.getDate() + step);
}, function(start, end) {
  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */]) / __WEBPACK_IMPORTED_MODULE_1__duration__["a" /* durationDay */];
}, function(date) {
  return date.getDate() - 1;
});

/* harmony default export */ __webpack_exports__["b"] = (day);
var days = day.range;


/***/ }),

/***/ "./node_modules/d3-time/src/duration.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return durationSecond; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return durationMinute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return durationHour; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return durationDay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return durationWeek; });
var durationSecond = 1e3;
var durationMinute = 6e4;
var durationHour = 36e5;
var durationDay = 864e5;
var durationWeek = 6048e5;


/***/ }),

/***/ "./node_modules/d3-time/src/hour.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hours; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__("./node_modules/d3-time/src/interval.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__("./node_modules/d3-time/src/duration.js");



var hour = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  var offset = date.getTimezoneOffset() * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */] % __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */];
  if (offset < 0) offset += __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */];
  date.setTime(Math.floor((+date - offset) / __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */]) * __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */] + offset);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */];
}, function(date) {
  return date.getHours();
});

/* harmony default export */ __webpack_exports__["a"] = (hour);
var hours = hour.range;


/***/ }),

/***/ "./node_modules/d3-time/src/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__("./node_modules/d3-time/src/interval.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_0__interval__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__millisecond__ = __webpack_require__("./node_modules/d3-time/src/millisecond.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_1__millisecond__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_1__millisecond__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_1__millisecond__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_1__millisecond__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__second__ = __webpack_require__("./node_modules/d3-time/src/second.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_2__second__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_2__second__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return __WEBPACK_IMPORTED_MODULE_2__second__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return __WEBPACK_IMPORTED_MODULE_2__second__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__minute__ = __webpack_require__("./node_modules/d3-time/src/minute.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_3__minute__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_3__minute__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hour__ = __webpack_require__("./node_modules/d3-time/src/hour.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__hour__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_4__hour__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__day__ = __webpack_require__("./node_modules/d3-time/src/day.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__day__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_5__day__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__week__ = __webpack_require__("./node_modules/d3-time/src/week.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_6__week__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_6__week__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_6__week__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_6__week__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_6__week__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_6__week__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_6__week__["k"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_6__week__["l"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_6__week__["m"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_6__week__["n"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_6__week__["i"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_6__week__["j"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_6__week__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_6__week__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_6__week__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_6__week__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__month__ = __webpack_require__("./node_modules/d3-time/src/month.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_7__month__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_7__month__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__year__ = __webpack_require__("./node_modules/d3-time/src/year.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_8__year__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_8__year__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utcMinute__ = __webpack_require__("./node_modules/d3-time/src/utcMinute.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_9__utcMinute__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_9__utcMinute__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utcHour__ = __webpack_require__("./node_modules/d3-time/src/utcHour.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_10__utcHour__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_10__utcHour__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utcDay__ = __webpack_require__("./node_modules/d3-time/src/utcDay.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_11__utcDay__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_11__utcDay__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utcWeek__ = __webpack_require__("./node_modules/d3-time/src/utcWeek.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return __WEBPACK_IMPORTED_MODULE_12__utcWeek__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return __WEBPACK_IMPORTED_MODULE_12__utcWeek__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return __WEBPACK_IMPORTED_MODULE_12__utcWeek__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return __WEBPACK_IMPORTED_MODULE_12__utcWeek__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_12__utcWeek__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return __WEBPACK_IMPORTED_MODULE_12__utcWeek__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return __WEBPACK_IMPORTED_MODULE_12__utcWeek__["k"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return __WEBPACK_IMPORTED_MODULE_12__utcWeek__["l"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return __WEBPACK_IMPORTED_MODULE_12__utcWeek__["m"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return __WEBPACK_IMPORTED_MODULE_12__utcWeek__["n"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return __WEBPACK_IMPORTED_MODULE_12__utcWeek__["i"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return __WEBPACK_IMPORTED_MODULE_12__utcWeek__["j"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_12__utcWeek__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_12__utcWeek__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return __WEBPACK_IMPORTED_MODULE_12__utcWeek__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return __WEBPACK_IMPORTED_MODULE_12__utcWeek__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utcMonth__ = __webpack_require__("./node_modules/d3-time/src/utcMonth.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return __WEBPACK_IMPORTED_MODULE_13__utcMonth__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return __WEBPACK_IMPORTED_MODULE_13__utcMonth__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utcYear__ = __webpack_require__("./node_modules/d3-time/src/utcYear.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return __WEBPACK_IMPORTED_MODULE_14__utcYear__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return __WEBPACK_IMPORTED_MODULE_14__utcYear__["b"]; });































/***/ }),

/***/ "./node_modules/d3-time/src/interval.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = newInterval;
var t0 = new Date,
    t1 = new Date;

function newInterval(floori, offseti, count, field) {

  function interval(date) {
    return floori(date = new Date(+date)), date;
  }

  interval.floor = interval;

  interval.ceil = function(date) {
    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
  };

  interval.round = function(date) {
    var d0 = interval(date),
        d1 = interval.ceil(date);
    return date - d0 < d1 - date ? d0 : d1;
  };

  interval.offset = function(date, step) {
    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
  };

  interval.range = function(start, stop, step) {
    var range = [], previous;
    start = interval.ceil(start);
    step = step == null ? 1 : Math.floor(step);
    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
    do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
    while (previous < start && start < stop);
    return range;
  };

  interval.filter = function(test) {
    return newInterval(function(date) {
      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
    }, function(date, step) {
      if (date >= date) {
        if (step < 0) while (++step <= 0) {
          while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
        } else while (--step >= 0) {
          while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty
        }
      }
    });
  };

  if (count) {
    interval.count = function(start, end) {
      t0.setTime(+start), t1.setTime(+end);
      floori(t0), floori(t1);
      return Math.floor(count(t0, t1));
    };

    interval.every = function(step) {
      step = Math.floor(step);
      return !isFinite(step) || !(step > 0) ? null
          : !(step > 1) ? interval
          : interval.filter(field
              ? function(d) { return field(d) % step === 0; }
              : function(d) { return interval.count(0, d) % step === 0; });
    };
  }

  return interval;
}


/***/ }),

/***/ "./node_modules/d3-time/src/millisecond.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return milliseconds; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__("./node_modules/d3-time/src/interval.js");


var millisecond = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function() {
  // noop
}, function(date, step) {
  date.setTime(+date + step);
}, function(start, end) {
  return end - start;
});

// An optimized implementation for this simple case.
millisecond.every = function(k) {
  k = Math.floor(k);
  if (!isFinite(k) || !(k > 0)) return null;
  if (!(k > 1)) return millisecond;
  return Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setTime(Math.floor(date / k) * k);
  }, function(date, step) {
    date.setTime(+date + step * k);
  }, function(start, end) {
    return (end - start) / k;
  });
};

/* harmony default export */ __webpack_exports__["a"] = (millisecond);
var milliseconds = millisecond.range;


/***/ }),

/***/ "./node_modules/d3-time/src/minute.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return minutes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__("./node_modules/d3-time/src/interval.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__("./node_modules/d3-time/src/duration.js");



var minute = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setTime(Math.floor(date / __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */]) * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */]);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */];
}, function(date) {
  return date.getMinutes();
});

/* harmony default export */ __webpack_exports__["a"] = (minute);
var minutes = minute.range;


/***/ }),

/***/ "./node_modules/d3-time/src/month.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return months; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__("./node_modules/d3-time/src/interval.js");


var month = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setMonth(date.getMonth() + step);
}, function(start, end) {
  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
  return date.getMonth();
});

/* harmony default export */ __webpack_exports__["a"] = (month);
var months = month.range;


/***/ }),

/***/ "./node_modules/d3-time/src/second.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return seconds; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__("./node_modules/d3-time/src/interval.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__("./node_modules/d3-time/src/duration.js");



var second = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setTime(Math.floor(date / __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationSecond */]) * __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationSecond */]);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationSecond */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationSecond */];
}, function(date) {
  return date.getUTCSeconds();
});

/* harmony default export */ __webpack_exports__["a"] = (second);
var seconds = second.range;


/***/ }),

/***/ "./node_modules/d3-time/src/utcDay.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return utcDays; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__("./node_modules/d3-time/src/interval.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__("./node_modules/d3-time/src/duration.js");



var utcDay = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["a" /* durationDay */];
}, function(date) {
  return date.getUTCDate() - 1;
});

/* harmony default export */ __webpack_exports__["a"] = (utcDay);
var utcDays = utcDay.range;


/***/ }),

/***/ "./node_modules/d3-time/src/utcHour.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return utcHours; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__("./node_modules/d3-time/src/interval.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__("./node_modules/d3-time/src/duration.js");



var utcHour = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */];
}, function(date) {
  return date.getUTCHours();
});

/* harmony default export */ __webpack_exports__["a"] = (utcHour);
var utcHours = utcHour.range;


/***/ }),

/***/ "./node_modules/d3-time/src/utcMinute.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return utcMinutes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__("./node_modules/d3-time/src/interval.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__("./node_modules/d3-time/src/duration.js");



var utcMinute = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCSeconds(0, 0);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */];
}, function(date) {
  return date.getUTCMinutes();
});

/* harmony default export */ __webpack_exports__["a"] = (utcMinute);
var utcMinutes = utcMinute.range;


/***/ }),

/***/ "./node_modules/d3-time/src/utcMonth.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return utcMonths; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__("./node_modules/d3-time/src/interval.js");


var utcMonth = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCDate(1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
  return date.getUTCMonth();
});

/* harmony default export */ __webpack_exports__["a"] = (utcMonth);
var utcMonths = utcMonth.range;


/***/ }),

/***/ "./node_modules/d3-time/src/utcWeek.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return utcSunday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return utcMonday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return utcTuesday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return utcWednesday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return utcThursday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return utcFriday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return utcSaturday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return utcSundays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return utcMondays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return utcTuesdays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return utcWednesdays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return utcThursdays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return utcFridays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return utcSaturdays; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__("./node_modules/d3-time/src/interval.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__("./node_modules/d3-time/src/duration.js");



function utcWeekday(i) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step * 7);
  }, function(start, end) {
    return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["e" /* durationWeek */];
  });
}

var utcSunday = utcWeekday(0);
var utcMonday = utcWeekday(1);
var utcTuesday = utcWeekday(2);
var utcWednesday = utcWeekday(3);
var utcThursday = utcWeekday(4);
var utcFriday = utcWeekday(5);
var utcSaturday = utcWeekday(6);

var utcSundays = utcSunday.range;
var utcMondays = utcMonday.range;
var utcTuesdays = utcTuesday.range;
var utcWednesdays = utcWednesday.range;
var utcThursdays = utcThursday.range;
var utcFridays = utcFriday.range;
var utcSaturdays = utcSaturday.range;


/***/ }),

/***/ "./node_modules/d3-time/src/utcYear.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return utcYears; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__("./node_modules/d3-time/src/interval.js");


var utcYear = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
  return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
  return date.getUTCFullYear();
});

// An optimized implementation for this simple case.
utcYear.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step * k);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (utcYear);
var utcYears = utcYear.range;


/***/ }),

/***/ "./node_modules/d3-time/src/week.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return sunday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return monday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return tuesday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return wednesday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return thursday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return friday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return saturday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return sundays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return mondays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return tuesdays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return wednesdays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return thursdays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fridays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return saturdays; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__("./node_modules/d3-time/src/interval.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__("./node_modules/d3-time/src/duration.js");



function weekday(i) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setDate(date.getDate() + step * 7);
  }, function(start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */]) / __WEBPACK_IMPORTED_MODULE_1__duration__["e" /* durationWeek */];
  });
}

var sunday = weekday(0);
var monday = weekday(1);
var tuesday = weekday(2);
var wednesday = weekday(3);
var thursday = weekday(4);
var friday = weekday(5);
var saturday = weekday(6);

var sundays = sunday.range;
var mondays = monday.range;
var tuesdays = tuesday.range;
var wednesdays = wednesday.range;
var thursdays = thursday.range;
var fridays = friday.range;
var saturdays = saturday.range;


/***/ }),

/***/ "./node_modules/d3-time/src/year.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return years; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__("./node_modules/d3-time/src/interval.js");


var year = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setMonth(0, 1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
  return end.getFullYear() - start.getFullYear();
}, function(date) {
  return date.getFullYear();
});

// An optimized implementation for this simple case.
year.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setFullYear(date.getFullYear() + step * k);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (year);
var years = year.range;


/***/ }),

/***/ "./node_modules/d3-timer/src/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__timer__ = __webpack_require__("./node_modules/d3-timer/src/timer.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__timer__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__timer__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__timer__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__timeout__ = __webpack_require__("./node_modules/d3-timer/src/timeout.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__timeout__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__interval__ = __webpack_require__("./node_modules/d3-timer/src/interval.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__interval__["a"]; });







/***/ }),

/***/ "./node_modules/d3-timer/src/interval.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__timer__ = __webpack_require__("./node_modules/d3-timer/src/timer.js");


/* harmony default export */ __webpack_exports__["a"] = (function(callback, delay, time) {
  var t = new __WEBPACK_IMPORTED_MODULE_0__timer__["a" /* Timer */], total = delay;
  if (delay == null) return t.restart(callback, delay, time), t;
  delay = +delay, time = time == null ? Object(__WEBPACK_IMPORTED_MODULE_0__timer__["b" /* now */])() : +time;
  t.restart(function tick(elapsed) {
    elapsed += total;
    t.restart(tick, total += delay, time);
    callback(elapsed);
  }, delay, time);
  return t;
});


/***/ }),

/***/ "./node_modules/d3-timer/src/timeout.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__timer__ = __webpack_require__("./node_modules/d3-timer/src/timer.js");


/* harmony default export */ __webpack_exports__["a"] = (function(callback, delay, time) {
  var t = new __WEBPACK_IMPORTED_MODULE_0__timer__["a" /* Timer */];
  delay = delay == null ? 0 : +delay;
  t.restart(function(elapsed) {
    t.stop();
    callback(elapsed + delay);
  }, delay, time);
  return t;
});


/***/ }),

/***/ "./node_modules/d3-timer/src/timer.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = now;
/* harmony export (immutable) */ __webpack_exports__["a"] = Timer;
/* harmony export (immutable) */ __webpack_exports__["c"] = timer;
/* harmony export (immutable) */ __webpack_exports__["d"] = timerFlush;
var frame = 0, // is an animation frame pending?
    timeout = 0, // is a timeout pending?
    interval = 0, // are any timers active?
    pokeDelay = 1000, // how frequently we check for clock skew
    taskHead,
    taskTail,
    clockLast = 0,
    clockNow = 0,
    clockSkew = 0,
    clock = typeof performance === "object" && performance.now ? performance : Date,
    setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) { setTimeout(f, 17); };

function now() {
  return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
}

function clearNow() {
  clockNow = 0;
}

function Timer() {
  this._call =
  this._time =
  this._next = null;
}

Timer.prototype = timer.prototype = {
  constructor: Timer,
  restart: function(callback, delay, time) {
    if (typeof callback !== "function") throw new TypeError("callback is not a function");
    time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
    if (!this._next && taskTail !== this) {
      if (taskTail) taskTail._next = this;
      else taskHead = this;
      taskTail = this;
    }
    this._call = callback;
    this._time = time;
    sleep();
  },
  stop: function() {
    if (this._call) {
      this._call = null;
      this._time = Infinity;
      sleep();
    }
  }
};

function timer(callback, delay, time) {
  var t = new Timer;
  t.restart(callback, delay, time);
  return t;
}

function timerFlush() {
  now(); // Get the current time, if not already set.
  ++frame; // Pretend we’ve set an alarm, if we haven’t already.
  var t = taskHead, e;
  while (t) {
    if ((e = clockNow - t._time) >= 0) t._call.call(null, e);
    t = t._next;
  }
  --frame;
}

function wake() {
  clockNow = (clockLast = clock.now()) + clockSkew;
  frame = timeout = 0;
  try {
    timerFlush();
  } finally {
    frame = 0;
    nap();
    clockNow = 0;
  }
}

function poke() {
  var now = clock.now(), delay = now - clockLast;
  if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
}

function nap() {
  var t0, t1 = taskHead, t2, time = Infinity;
  while (t1) {
    if (t1._call) {
      if (time > t1._time) time = t1._time;
      t0 = t1, t1 = t1._next;
    } else {
      t2 = t1._next, t1._next = null;
      t1 = t0 ? t0._next = t2 : taskHead = t2;
    }
  }
  taskTail = t0;
  sleep(time);
}

function sleep(time) {
  if (frame) return; // Soonest alarm already set, or will be.
  if (timeout) timeout = clearTimeout(timeout);
  var delay = time - clockNow; // Strictly less than if we recomputed clockNow.
  if (delay > 24) {
    if (time < Infinity) timeout = setTimeout(wake, time - clock.now() - clockSkew);
    if (interval) interval = clearInterval(interval);
  } else {
    if (!interval) clockLast = clock.now(), interval = setInterval(poke, pokeDelay);
    frame = 1, setFrame(wake);
  }
}


/***/ }),

/***/ "./node_modules/d3-transition/src/active.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transition_index__ = __webpack_require__("./node_modules/d3-transition/src/transition/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__transition_schedule__ = __webpack_require__("./node_modules/d3-transition/src/transition/schedule.js");



var root = [null];

/* harmony default export */ __webpack_exports__["a"] = (function(node, name) {
  var schedules = node.__transition,
      schedule,
      i;

  if (schedules) {
    name = name == null ? null : name + "";
    for (i in schedules) {
      if ((schedule = schedules[i]).state > __WEBPACK_IMPORTED_MODULE_1__transition_schedule__["c" /* SCHEDULED */] && schedule.name === name) {
        return new __WEBPACK_IMPORTED_MODULE_0__transition_index__["a" /* Transition */]([[node]], root, name, +i);
      }
    }
  }

  return null;
});


/***/ }),

/***/ "./node_modules/d3-transition/src/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selection_index__ = __webpack_require__("./node_modules/d3-transition/src/selection/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__transition_index__ = __webpack_require__("./node_modules/d3-transition/src/transition/index.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__transition_index__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__active__ = __webpack_require__("./node_modules/d3-transition/src/active.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__active__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__interrupt__ = __webpack_require__("./node_modules/d3-transition/src/interrupt.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__interrupt__["a"]; });






/***/ }),

/***/ "./node_modules/d3-transition/src/interrupt.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transition_schedule__ = __webpack_require__("./node_modules/d3-transition/src/transition/schedule.js");


/* harmony default export */ __webpack_exports__["a"] = (function(node, name) {
  var schedules = node.__transition,
      schedule,
      active,
      empty = true,
      i;

  if (!schedules) return;

  name = name == null ? null : name + "";

  for (i in schedules) {
    if ((schedule = schedules[i]).name !== name) { empty = false; continue; }
    active = schedule.state > __WEBPACK_IMPORTED_MODULE_0__transition_schedule__["d" /* STARTING */] && schedule.state < __WEBPACK_IMPORTED_MODULE_0__transition_schedule__["b" /* ENDING */];
    schedule.state = __WEBPACK_IMPORTED_MODULE_0__transition_schedule__["a" /* ENDED */];
    schedule.timer.stop();
    if (active) schedule.on.call("interrupt", node, node.__data__, schedule.index, schedule.group);
    delete schedules[i];
  }

  if (empty) delete node.__transition;
});


/***/ }),

/***/ "./node_modules/d3-transition/src/selection/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__("./node_modules/d3-selection/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__interrupt__ = __webpack_require__("./node_modules/d3-transition/src/selection/interrupt.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__transition__ = __webpack_require__("./node_modules/d3-transition/src/selection/transition.js");




__WEBPACK_IMPORTED_MODULE_0_d3_selection__["m" /* selection */].prototype.interrupt = __WEBPACK_IMPORTED_MODULE_1__interrupt__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0_d3_selection__["m" /* selection */].prototype.transition = __WEBPACK_IMPORTED_MODULE_2__transition__["a" /* default */];


/***/ }),

/***/ "./node_modules/d3-transition/src/selection/interrupt.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interrupt__ = __webpack_require__("./node_modules/d3-transition/src/interrupt.js");


/* harmony default export */ __webpack_exports__["a"] = (function(name) {
  return this.each(function() {
    Object(__WEBPACK_IMPORTED_MODULE_0__interrupt__["a" /* default */])(this, name);
  });
});


/***/ }),

/***/ "./node_modules/d3-transition/src/selection/transition.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transition_index__ = __webpack_require__("./node_modules/d3-transition/src/transition/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__transition_schedule__ = __webpack_require__("./node_modules/d3-transition/src/transition/schedule.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_ease__ = __webpack_require__("./node_modules/d3-ease/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_timer__ = __webpack_require__("./node_modules/d3-timer/src/index.js");





var defaultTiming = {
  time: null, // Set on use.
  delay: 0,
  duration: 250,
  ease: __WEBPACK_IMPORTED_MODULE_2_d3_ease__["o" /* easeCubicInOut */]
};

function inherit(node, id) {
  var timing;
  while (!(timing = node.__transition) || !(timing = timing[id])) {
    if (!(node = node.parentNode)) {
      return defaultTiming.time = Object(__WEBPACK_IMPORTED_MODULE_3_d3_timer__["b" /* now */])(), defaultTiming;
    }
  }
  return timing;
}

/* harmony default export */ __webpack_exports__["a"] = (function(name) {
  var id,
      timing;

  if (name instanceof __WEBPACK_IMPORTED_MODULE_0__transition_index__["a" /* Transition */]) {
    id = name._id, name = name._name;
  } else {
    id = Object(__WEBPACK_IMPORTED_MODULE_0__transition_index__["c" /* newId */])(), (timing = defaultTiming).time = Object(__WEBPACK_IMPORTED_MODULE_3_d3_timer__["b" /* now */])(), name = name == null ? null : name + "";
  }

  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        Object(__WEBPACK_IMPORTED_MODULE_1__transition_schedule__["e" /* default */])(node, name, id, i, group, timing || inherit(node, id));
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_0__transition_index__["a" /* Transition */](groups, this._parents, name, id);
});


/***/ }),

/***/ "./node_modules/d3-transition/src/transition/attr.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_interpolate__ = __webpack_require__("./node_modules/d3-interpolate/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_selection__ = __webpack_require__("./node_modules/d3-selection/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tween__ = __webpack_require__("./node_modules/d3-transition/src/transition/tween.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__interpolate__ = __webpack_require__("./node_modules/d3-transition/src/transition/interpolate.js");





function attrRemove(name) {
  return function() {
    this.removeAttribute(name);
  };
}

function attrRemoveNS(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}

function attrConstant(name, interpolate, value1) {
  var value00,
      interpolate0;
  return function() {
    var value0 = this.getAttribute(name);
    return value0 === value1 ? null
        : value0 === value00 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value1);
  };
}

function attrConstantNS(fullname, interpolate, value1) {
  var value00,
      interpolate0;
  return function() {
    var value0 = this.getAttributeNS(fullname.space, fullname.local);
    return value0 === value1 ? null
        : value0 === value00 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value1);
  };
}

function attrFunction(name, interpolate, value) {
  var value00,
      value10,
      interpolate0;
  return function() {
    var value0, value1 = value(this);
    if (value1 == null) return void this.removeAttribute(name);
    value0 = this.getAttribute(name);
    return value0 === value1 ? null
        : value0 === value00 && value1 === value10 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value10 = value1);
  };
}

function attrFunctionNS(fullname, interpolate, value) {
  var value00,
      value10,
      interpolate0;
  return function() {
    var value0, value1 = value(this);
    if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
    value0 = this.getAttributeNS(fullname.space, fullname.local);
    return value0 === value1 ? null
        : value0 === value00 && value1 === value10 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value10 = value1);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  var fullname = Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["i" /* namespace */])(name), i = fullname === "transform" ? __WEBPACK_IMPORTED_MODULE_0_d3_interpolate__["w" /* interpolateTransformSvg */] : __WEBPACK_IMPORTED_MODULE_3__interpolate__["a" /* default */];
  return this.attrTween(name, typeof value === "function"
      ? (fullname.local ? attrFunctionNS : attrFunction)(fullname, i, Object(__WEBPACK_IMPORTED_MODULE_2__tween__["b" /* tweenValue */])(this, "attr." + name, value))
      : value == null ? (fullname.local ? attrRemoveNS : attrRemove)(fullname)
      : (fullname.local ? attrConstantNS : attrConstant)(fullname, i, value + ""));
});


/***/ }),

/***/ "./node_modules/d3-transition/src/transition/attrTween.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__("./node_modules/d3-selection/src/index.js");


function attrTweenNS(fullname, value) {
  function tween() {
    var node = this, i = value.apply(node, arguments);
    return i && function(t) {
      node.setAttributeNS(fullname.space, fullname.local, i(t));
    };
  }
  tween._value = value;
  return tween;
}

function attrTween(name, value) {
  function tween() {
    var node = this, i = value.apply(node, arguments);
    return i && function(t) {
      node.setAttribute(name, i(t));
    };
  }
  tween._value = value;
  return tween;
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  var key = "attr." + name;
  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error;
  var fullname = Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["i" /* namespace */])(name);
  return this.tween(key, (fullname.local ? attrTweenNS : attrTween)(fullname, value));
});


/***/ }),

/***/ "./node_modules/d3-transition/src/transition/delay.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__schedule__ = __webpack_require__("./node_modules/d3-transition/src/transition/schedule.js");


function delayFunction(id, value) {
  return function() {
    Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["g" /* init */])(this, id).delay = +value.apply(this, arguments);
  };
}

function delayConstant(id, value) {
  return value = +value, function() {
    Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["g" /* init */])(this, id).delay = value;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  var id = this._id;

  return arguments.length
      ? this.each((typeof value === "function"
          ? delayFunction
          : delayConstant)(id, value))
      : Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["f" /* get */])(this.node(), id).delay;
});


/***/ }),

/***/ "./node_modules/d3-transition/src/transition/duration.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__schedule__ = __webpack_require__("./node_modules/d3-transition/src/transition/schedule.js");


function durationFunction(id, value) {
  return function() {
    Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["h" /* set */])(this, id).duration = +value.apply(this, arguments);
  };
}

function durationConstant(id, value) {
  return value = +value, function() {
    Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["h" /* set */])(this, id).duration = value;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  var id = this._id;

  return arguments.length
      ? this.each((typeof value === "function"
          ? durationFunction
          : durationConstant)(id, value))
      : Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["f" /* get */])(this.node(), id).duration;
});


/***/ }),

/***/ "./node_modules/d3-transition/src/transition/ease.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__schedule__ = __webpack_require__("./node_modules/d3-transition/src/transition/schedule.js");


function easeConstant(id, value) {
  if (typeof value !== "function") throw new Error;
  return function() {
    Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["h" /* set */])(this, id).ease = value;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  var id = this._id;

  return arguments.length
      ? this.each(easeConstant(id, value))
      : Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["f" /* get */])(this.node(), id).ease;
});


/***/ }),

/***/ "./node_modules/d3-transition/src/transition/filter.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__("./node_modules/d3-selection/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__("./node_modules/d3-transition/src/transition/index.js");



/* harmony default export */ __webpack_exports__["a"] = (function(match) {
  if (typeof match !== "function") match = Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["g" /* matcher */])(match);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
        subgroup.push(node);
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_1__index__["a" /* Transition */](subgroups, this._parents, this._name, this._id);
});


/***/ }),

/***/ "./node_modules/d3-transition/src/transition/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Transition;
/* harmony export (immutable) */ __webpack_exports__["b"] = transition;
/* harmony export (immutable) */ __webpack_exports__["c"] = newId;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__("./node_modules/d3-selection/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__attr__ = __webpack_require__("./node_modules/d3-transition/src/transition/attr.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__attrTween__ = __webpack_require__("./node_modules/d3-transition/src/transition/attrTween.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__delay__ = __webpack_require__("./node_modules/d3-transition/src/transition/delay.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__duration__ = __webpack_require__("./node_modules/d3-transition/src/transition/duration.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ease__ = __webpack_require__("./node_modules/d3-transition/src/transition/ease.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__filter__ = __webpack_require__("./node_modules/d3-transition/src/transition/filter.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__merge__ = __webpack_require__("./node_modules/d3-transition/src/transition/merge.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__on__ = __webpack_require__("./node_modules/d3-transition/src/transition/on.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__remove__ = __webpack_require__("./node_modules/d3-transition/src/transition/remove.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__select__ = __webpack_require__("./node_modules/d3-transition/src/transition/select.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__selectAll__ = __webpack_require__("./node_modules/d3-transition/src/transition/selectAll.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__selection__ = __webpack_require__("./node_modules/d3-transition/src/transition/selection.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__style__ = __webpack_require__("./node_modules/d3-transition/src/transition/style.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styleTween__ = __webpack_require__("./node_modules/d3-transition/src/transition/styleTween.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__text__ = __webpack_require__("./node_modules/d3-transition/src/transition/text.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__transition__ = __webpack_require__("./node_modules/d3-transition/src/transition/transition.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__tween__ = __webpack_require__("./node_modules/d3-transition/src/transition/tween.js");



















var id = 0;

function Transition(groups, parents, name, id) {
  this._groups = groups;
  this._parents = parents;
  this._name = name;
  this._id = id;
}

function transition(name) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["m" /* selection */])().transition(name);
}

function newId() {
  return ++id;
}

var selection_prototype = __WEBPACK_IMPORTED_MODULE_0_d3_selection__["m" /* selection */].prototype;

Transition.prototype = transition.prototype = {
  constructor: Transition,
  select: __WEBPACK_IMPORTED_MODULE_10__select__["a" /* default */],
  selectAll: __WEBPACK_IMPORTED_MODULE_11__selectAll__["a" /* default */],
  filter: __WEBPACK_IMPORTED_MODULE_6__filter__["a" /* default */],
  merge: __WEBPACK_IMPORTED_MODULE_7__merge__["a" /* default */],
  selection: __WEBPACK_IMPORTED_MODULE_12__selection__["a" /* default */],
  transition: __WEBPACK_IMPORTED_MODULE_16__transition__["a" /* default */],
  call: selection_prototype.call,
  nodes: selection_prototype.nodes,
  node: selection_prototype.node,
  size: selection_prototype.size,
  empty: selection_prototype.empty,
  each: selection_prototype.each,
  on: __WEBPACK_IMPORTED_MODULE_8__on__["a" /* default */],
  attr: __WEBPACK_IMPORTED_MODULE_1__attr__["a" /* default */],
  attrTween: __WEBPACK_IMPORTED_MODULE_2__attrTween__["a" /* default */],
  style: __WEBPACK_IMPORTED_MODULE_13__style__["a" /* default */],
  styleTween: __WEBPACK_IMPORTED_MODULE_14__styleTween__["a" /* default */],
  text: __WEBPACK_IMPORTED_MODULE_15__text__["a" /* default */],
  remove: __WEBPACK_IMPORTED_MODULE_9__remove__["a" /* default */],
  tween: __WEBPACK_IMPORTED_MODULE_17__tween__["a" /* default */],
  delay: __WEBPACK_IMPORTED_MODULE_3__delay__["a" /* default */],
  duration: __WEBPACK_IMPORTED_MODULE_4__duration__["a" /* default */],
  ease: __WEBPACK_IMPORTED_MODULE_5__ease__["a" /* default */]
};


/***/ }),

/***/ "./node_modules/d3-transition/src/transition/interpolate.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__("./node_modules/d3-color/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__("./node_modules/d3-interpolate/src/index.js");



/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var c;
  return (typeof b === "number" ? __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["o" /* interpolateNumber */]
      : b instanceof __WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* color */] ? __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["q" /* interpolateRgb */]
      : (c = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* color */])(b)) ? (b = c, __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["q" /* interpolateRgb */])
      : __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["u" /* interpolateString */])(a, b);
});


/***/ }),

/***/ "./node_modules/d3-transition/src/transition/merge.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__("./node_modules/d3-transition/src/transition/index.js");


/* harmony default export */ __webpack_exports__["a"] = (function(transition) {
  if (transition._id !== this._id) throw new Error;

  for (var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group0[i] || group1[i]) {
        merge[i] = node;
      }
    }
  }

  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Transition */](merges, this._parents, this._name, this._id);
});


/***/ }),

/***/ "./node_modules/d3-transition/src/transition/on.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__schedule__ = __webpack_require__("./node_modules/d3-transition/src/transition/schedule.js");


function start(name) {
  return (name + "").trim().split(/^|\s+/).every(function(t) {
    var i = t.indexOf(".");
    if (i >= 0) t = t.slice(0, i);
    return !t || t === "start";
  });
}

function onFunction(id, name, listener) {
  var on0, on1, sit = start(name) ? __WEBPACK_IMPORTED_MODULE_0__schedule__["g" /* init */] : __WEBPACK_IMPORTED_MODULE_0__schedule__["h" /* set */];
  return function() {
    var schedule = sit(this, id),
        on = schedule.on;

    // If this node shared a dispatch with the previous node,
    // just assign the updated shared dispatch and we’re done!
    // Otherwise, copy-on-write.
    if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);

    schedule.on = on1;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, listener) {
  var id = this._id;

  return arguments.length < 2
      ? Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["f" /* get */])(this.node(), id).on.on(name)
      : this.each(onFunction(id, name, listener));
});


/***/ }),

/***/ "./node_modules/d3-transition/src/transition/remove.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function removeFunction(id) {
  return function() {
    var parent = this.parentNode;
    for (var i in this.__transition) if (+i !== id) return;
    if (parent) parent.removeChild(this);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return this.on("end.remove", removeFunction(this._id));
});


/***/ }),

/***/ "./node_modules/d3-transition/src/transition/schedule.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CREATED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SCHEDULED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return STARTING; });
/* unused harmony export STARTED */
/* unused harmony export RUNNING */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ENDED; });
/* harmony export (immutable) */ __webpack_exports__["g"] = init;
/* harmony export (immutable) */ __webpack_exports__["h"] = set;
/* harmony export (immutable) */ __webpack_exports__["f"] = get;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_dispatch__ = __webpack_require__("./node_modules/d3-dispatch/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_timer__ = __webpack_require__("./node_modules/d3-timer/src/index.js");



var emptyOn = Object(__WEBPACK_IMPORTED_MODULE_0_d3_dispatch__["a" /* dispatch */])("start", "end", "interrupt");
var emptyTween = [];

var CREATED = 0;
var SCHEDULED = 1;
var STARTING = 2;
var STARTED = 3;
var RUNNING = 4;
var ENDING = 5;
var ENDED = 6;

/* harmony default export */ __webpack_exports__["e"] = (function(node, name, id, index, group, timing) {
  var schedules = node.__transition;
  if (!schedules) node.__transition = {};
  else if (id in schedules) return;
  create(node, id, {
    name: name,
    index: index, // For context during callback.
    group: group, // For context during callback.
    on: emptyOn,
    tween: emptyTween,
    time: timing.time,
    delay: timing.delay,
    duration: timing.duration,
    ease: timing.ease,
    timer: null,
    state: CREATED
  });
});

function init(node, id) {
  var schedule = get(node, id);
  if (schedule.state > CREATED) throw new Error("too late; already scheduled");
  return schedule;
}

function set(node, id) {
  var schedule = get(node, id);
  if (schedule.state > STARTING) throw new Error("too late; already started");
  return schedule;
}

function get(node, id) {
  var schedule = node.__transition;
  if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
  return schedule;
}

function create(node, id, self) {
  var schedules = node.__transition,
      tween;

  // Initialize the self timer when the transition is created.
  // Note the actual delay is not known until the first callback!
  schedules[id] = self;
  self.timer = Object(__WEBPACK_IMPORTED_MODULE_1_d3_timer__["d" /* timer */])(schedule, 0, self.time);

  function schedule(elapsed) {
    self.state = SCHEDULED;
    self.timer.restart(start, self.delay, self.time);

    // If the elapsed delay is less than our first sleep, start immediately.
    if (self.delay <= elapsed) start(elapsed - self.delay);
  }

  function start(elapsed) {
    var i, j, n, o;

    // If the state is not SCHEDULED, then we previously errored on start.
    if (self.state !== SCHEDULED) return stop();

    for (i in schedules) {
      o = schedules[i];
      if (o.name !== self.name) continue;

      // While this element already has a starting transition during this frame,
      // defer starting an interrupting transition until that transition has a
      // chance to tick (and possibly end); see d3/d3-transition#54!
      if (o.state === STARTED) return Object(__WEBPACK_IMPORTED_MODULE_1_d3_timer__["c" /* timeout */])(start);

      // Interrupt the active transition, if any.
      // Dispatch the interrupt event.
      if (o.state === RUNNING) {
        o.state = ENDED;
        o.timer.stop();
        o.on.call("interrupt", node, node.__data__, o.index, o.group);
        delete schedules[i];
      }

      // Cancel any pre-empted transitions. No interrupt event is dispatched
      // because the cancelled transitions never started. Note that this also
      // removes this transition from the pending list!
      else if (+i < id) {
        o.state = ENDED;
        o.timer.stop();
        delete schedules[i];
      }
    }

    // Defer the first tick to end of the current frame; see d3/d3#1576.
    // Note the transition may be canceled after start and before the first tick!
    // Note this must be scheduled before the start event; see d3/d3-transition#16!
    // Assuming this is successful, subsequent callbacks go straight to tick.
    Object(__WEBPACK_IMPORTED_MODULE_1_d3_timer__["c" /* timeout */])(function() {
      if (self.state === STARTED) {
        self.state = RUNNING;
        self.timer.restart(tick, self.delay, self.time);
        tick(elapsed);
      }
    });

    // Dispatch the start event.
    // Note this must be done before the tween are initialized.
    self.state = STARTING;
    self.on.call("start", node, node.__data__, self.index, self.group);
    if (self.state !== STARTING) return; // interrupted
    self.state = STARTED;

    // Initialize the tween, deleting null tween.
    tween = new Array(n = self.tween.length);
    for (i = 0, j = -1; i < n; ++i) {
      if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) {
        tween[++j] = o;
      }
    }
    tween.length = j + 1;
  }

  function tick(elapsed) {
    var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = ENDING, 1),
        i = -1,
        n = tween.length;

    while (++i < n) {
      tween[i].call(null, t);
    }

    // Dispatch the end event.
    if (self.state === ENDING) {
      self.on.call("end", node, node.__data__, self.index, self.group);
      stop();
    }
  }

  function stop() {
    self.state = ENDED;
    self.timer.stop();
    delete schedules[id];
    for (var i in schedules) return; // eslint-disable-line no-unused-vars
    delete node.__transition;
  }
}


/***/ }),

/***/ "./node_modules/d3-transition/src/transition/select.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__("./node_modules/d3-selection/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__("./node_modules/d3-transition/src/transition/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__schedule__ = __webpack_require__("./node_modules/d3-transition/src/transition/schedule.js");




/* harmony default export */ __webpack_exports__["a"] = (function(select) {
  var name = this._name,
      id = this._id;

  if (typeof select !== "function") select = Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["n" /* selector */])(select);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
      if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
        if ("__data__" in node) subnode.__data__ = node.__data__;
        subgroup[i] = subnode;
        Object(__WEBPACK_IMPORTED_MODULE_2__schedule__["e" /* default */])(subgroup[i], name, id, i, subgroup, Object(__WEBPACK_IMPORTED_MODULE_2__schedule__["f" /* get */])(node, id));
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_1__index__["a" /* Transition */](subgroups, this._parents, name, id);
});


/***/ }),

/***/ "./node_modules/d3-transition/src/transition/selectAll.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__("./node_modules/d3-selection/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__("./node_modules/d3-transition/src/transition/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__schedule__ = __webpack_require__("./node_modules/d3-transition/src/transition/schedule.js");




/* harmony default export */ __webpack_exports__["a"] = (function(select) {
  var name = this._name,
      id = this._id;

  if (typeof select !== "function") select = Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["o" /* selectorAll */])(select);

  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        for (var children = select.call(node, node.__data__, i, group), child, inherit = Object(__WEBPACK_IMPORTED_MODULE_2__schedule__["f" /* get */])(node, id), k = 0, l = children.length; k < l; ++k) {
          if (child = children[k]) {
            Object(__WEBPACK_IMPORTED_MODULE_2__schedule__["e" /* default */])(child, name, id, k, children, inherit);
          }
        }
        subgroups.push(children);
        parents.push(node);
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_1__index__["a" /* Transition */](subgroups, parents, name, id);
});


/***/ }),

/***/ "./node_modules/d3-transition/src/transition/selection.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__("./node_modules/d3-selection/src/index.js");


var Selection = __WEBPACK_IMPORTED_MODULE_0_d3_selection__["m" /* selection */].prototype.constructor;

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return new Selection(this._groups, this._parents);
});


/***/ }),

/***/ "./node_modules/d3-transition/src/transition/style.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_interpolate__ = __webpack_require__("./node_modules/d3-interpolate/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_selection__ = __webpack_require__("./node_modules/d3-selection/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tween__ = __webpack_require__("./node_modules/d3-transition/src/transition/tween.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__interpolate__ = __webpack_require__("./node_modules/d3-transition/src/transition/interpolate.js");





function styleRemove(name, interpolate) {
  var value00,
      value10,
      interpolate0;
  return function() {
    var value0 = Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["p" /* style */])(this, name),
        value1 = (this.style.removeProperty(name), Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["p" /* style */])(this, name));
    return value0 === value1 ? null
        : value0 === value00 && value1 === value10 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value10 = value1);
  };
}

function styleRemoveEnd(name) {
  return function() {
    this.style.removeProperty(name);
  };
}

function styleConstant(name, interpolate, value1) {
  var value00,
      interpolate0;
  return function() {
    var value0 = Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["p" /* style */])(this, name);
    return value0 === value1 ? null
        : value0 === value00 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value1);
  };
}

function styleFunction(name, interpolate, value) {
  var value00,
      value10,
      interpolate0;
  return function() {
    var value0 = Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["p" /* style */])(this, name),
        value1 = value(this);
    if (value1 == null) value1 = (this.style.removeProperty(name), Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["p" /* style */])(this, name));
    return value0 === value1 ? null
        : value0 === value00 && value1 === value10 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value10 = value1);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value, priority) {
  var i = (name += "") === "transform" ? __WEBPACK_IMPORTED_MODULE_0_d3_interpolate__["v" /* interpolateTransformCss */] : __WEBPACK_IMPORTED_MODULE_3__interpolate__["a" /* default */];
  return value == null ? this
          .styleTween(name, styleRemove(name, i))
          .on("end.style." + name, styleRemoveEnd(name))
      : this.styleTween(name, typeof value === "function"
          ? styleFunction(name, i, Object(__WEBPACK_IMPORTED_MODULE_2__tween__["b" /* tweenValue */])(this, "style." + name, value))
          : styleConstant(name, i, value + ""), priority);
});


/***/ }),

/***/ "./node_modules/d3-transition/src/transition/styleTween.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function styleTween(name, value, priority) {
  function tween() {
    var node = this, i = value.apply(node, arguments);
    return i && function(t) {
      node.style.setProperty(name, i(t), priority);
    };
  }
  tween._value = value;
  return tween;
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value, priority) {
  var key = "style." + (name += "");
  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error;
  return this.tween(key, styleTween(name, value, priority == null ? "" : priority));
});


/***/ }),

/***/ "./node_modules/d3-transition/src/transition/text.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tween__ = __webpack_require__("./node_modules/d3-transition/src/transition/tween.js");


function textConstant(value) {
  return function() {
    this.textContent = value;
  };
}

function textFunction(value) {
  return function() {
    var value1 = value(this);
    this.textContent = value1 == null ? "" : value1;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  return this.tween("text", typeof value === "function"
      ? textFunction(Object(__WEBPACK_IMPORTED_MODULE_0__tween__["b" /* tweenValue */])(this, "text", value))
      : textConstant(value == null ? "" : value + ""));
});


/***/ }),

/***/ "./node_modules/d3-transition/src/transition/transition.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__("./node_modules/d3-transition/src/transition/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__schedule__ = __webpack_require__("./node_modules/d3-transition/src/transition/schedule.js");



/* harmony default export */ __webpack_exports__["a"] = (function() {
  var name = this._name,
      id0 = this._id,
      id1 = Object(__WEBPACK_IMPORTED_MODULE_0__index__["c" /* newId */])();

  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        var inherit = Object(__WEBPACK_IMPORTED_MODULE_1__schedule__["f" /* get */])(node, id0);
        Object(__WEBPACK_IMPORTED_MODULE_1__schedule__["e" /* default */])(node, name, id1, i, group, {
          time: inherit.time + inherit.delay + inherit.duration,
          delay: 0,
          duration: inherit.duration,
          ease: inherit.ease
        });
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Transition */](groups, this._parents, name, id1);
});


/***/ }),

/***/ "./node_modules/d3-transition/src/transition/tween.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = tweenValue;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__schedule__ = __webpack_require__("./node_modules/d3-transition/src/transition/schedule.js");


function tweenRemove(id, name) {
  var tween0, tween1;
  return function() {
    var schedule = Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["h" /* set */])(this, id),
        tween = schedule.tween;

    // If this node shared tween with the previous node,
    // just assign the updated shared tween and we’re done!
    // Otherwise, copy-on-write.
    if (tween !== tween0) {
      tween1 = tween0 = tween;
      for (var i = 0, n = tween1.length; i < n; ++i) {
        if (tween1[i].name === name) {
          tween1 = tween1.slice();
          tween1.splice(i, 1);
          break;
        }
      }
    }

    schedule.tween = tween1;
  };
}

function tweenFunction(id, name, value) {
  var tween0, tween1;
  if (typeof value !== "function") throw new Error;
  return function() {
    var schedule = Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["h" /* set */])(this, id),
        tween = schedule.tween;

    // If this node shared tween with the previous node,
    // just assign the updated shared tween and we’re done!
    // Otherwise, copy-on-write.
    if (tween !== tween0) {
      tween1 = (tween0 = tween).slice();
      for (var t = {name: name, value: value}, i = 0, n = tween1.length; i < n; ++i) {
        if (tween1[i].name === name) {
          tween1[i] = t;
          break;
        }
      }
      if (i === n) tween1.push(t);
    }

    schedule.tween = tween1;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  var id = this._id;

  name += "";

  if (arguments.length < 2) {
    var tween = Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["f" /* get */])(this.node(), id).tween;
    for (var i = 0, n = tween.length, t; i < n; ++i) {
      if ((t = tween[i]).name === name) {
        return t.value;
      }
    }
    return null;
  }

  return this.each((value == null ? tweenRemove : tweenFunction)(id, name, value));
});

function tweenValue(transition, name, value) {
  var id = transition._id;

  transition.each(function() {
    var schedule = Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["h" /* set */])(this, id);
    (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
  });

  return function(node) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["f" /* get */])(node, id).value[name];
  };
}


/***/ }),

/***/ "./node_modules/d3-voronoi/src/Beach.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = removeBeach;
/* harmony export (immutable) */ __webpack_exports__["a"] = addBeach;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RedBlackTree__ = __webpack_require__("./node_modules/d3-voronoi/src/RedBlackTree.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Cell__ = __webpack_require__("./node_modules/d3-voronoi/src/Cell.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Circle__ = __webpack_require__("./node_modules/d3-voronoi/src/Circle.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Edge__ = __webpack_require__("./node_modules/d3-voronoi/src/Edge.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Diagram__ = __webpack_require__("./node_modules/d3-voronoi/src/Diagram.js");






var beachPool = [];

function Beach() {
  Object(__WEBPACK_IMPORTED_MODULE_0__RedBlackTree__["a" /* RedBlackNode */])(this);
  this.edge =
  this.site =
  this.circle = null;
}

function createBeach(site) {
  var beach = beachPool.pop() || new Beach;
  beach.site = site;
  return beach;
}

function detachBeach(beach) {
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["b" /* detachCircle */])(beach);
  __WEBPACK_IMPORTED_MODULE_4__Diagram__["a" /* beaches */].remove(beach);
  beachPool.push(beach);
  Object(__WEBPACK_IMPORTED_MODULE_0__RedBlackTree__["a" /* RedBlackNode */])(beach);
}

function removeBeach(beach) {
  var circle = beach.circle,
      x = circle.x,
      y = circle.cy,
      vertex = [x, y],
      previous = beach.P,
      next = beach.N,
      disappearing = [beach];

  detachBeach(beach);

  var lArc = previous;
  while (lArc.circle
      && Math.abs(x - lArc.circle.x) < __WEBPACK_IMPORTED_MODULE_4__Diagram__["f" /* epsilon */]
      && Math.abs(y - lArc.circle.cy) < __WEBPACK_IMPORTED_MODULE_4__Diagram__["f" /* epsilon */]) {
    previous = lArc.P;
    disappearing.unshift(lArc);
    detachBeach(lArc);
    lArc = previous;
  }

  disappearing.unshift(lArc);
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["b" /* detachCircle */])(lArc);

  var rArc = next;
  while (rArc.circle
      && Math.abs(x - rArc.circle.x) < __WEBPACK_IMPORTED_MODULE_4__Diagram__["f" /* epsilon */]
      && Math.abs(y - rArc.circle.cy) < __WEBPACK_IMPORTED_MODULE_4__Diagram__["f" /* epsilon */]) {
    next = rArc.N;
    disappearing.push(rArc);
    detachBeach(rArc);
    rArc = next;
  }

  disappearing.push(rArc);
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["b" /* detachCircle */])(rArc);

  var nArcs = disappearing.length,
      iArc;
  for (iArc = 1; iArc < nArcs; ++iArc) {
    rArc = disappearing[iArc];
    lArc = disappearing[iArc - 1];
    Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["d" /* setEdgeEnd */])(rArc.edge, lArc.site, rArc.site, vertex);
  }

  lArc = disappearing[0];
  rArc = disappearing[nArcs - 1];
  rArc.edge = Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["c" /* createEdge */])(lArc.site, rArc.site, null, vertex);

  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["a" /* attachCircle */])(lArc);
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["a" /* attachCircle */])(rArc);
}

function addBeach(site) {
  var x = site[0],
      directrix = site[1],
      lArc,
      rArc,
      dxl,
      dxr,
      node = __WEBPACK_IMPORTED_MODULE_4__Diagram__["a" /* beaches */]._;

  while (node) {
    dxl = leftBreakPoint(node, directrix) - x;
    if (dxl > __WEBPACK_IMPORTED_MODULE_4__Diagram__["f" /* epsilon */]) node = node.L; else {
      dxr = x - rightBreakPoint(node, directrix);
      if (dxr > __WEBPACK_IMPORTED_MODULE_4__Diagram__["f" /* epsilon */]) {
        if (!node.R) {
          lArc = node;
          break;
        }
        node = node.R;
      } else {
        if (dxl > -__WEBPACK_IMPORTED_MODULE_4__Diagram__["f" /* epsilon */]) {
          lArc = node.P;
          rArc = node;
        } else if (dxr > -__WEBPACK_IMPORTED_MODULE_4__Diagram__["f" /* epsilon */]) {
          lArc = node;
          rArc = node.N;
        } else {
          lArc = rArc = node;
        }
        break;
      }
    }
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__Cell__["c" /* createCell */])(site);
  var newArc = createBeach(site);
  __WEBPACK_IMPORTED_MODULE_4__Diagram__["a" /* beaches */].insert(lArc, newArc);

  if (!lArc && !rArc) return;

  if (lArc === rArc) {
    Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["b" /* detachCircle */])(lArc);
    rArc = createBeach(lArc.site);
    __WEBPACK_IMPORTED_MODULE_4__Diagram__["a" /* beaches */].insert(newArc, rArc);
    newArc.edge = rArc.edge = Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["c" /* createEdge */])(lArc.site, newArc.site);
    Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["a" /* attachCircle */])(lArc);
    Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["a" /* attachCircle */])(rArc);
    return;
  }

  if (!rArc) { // && lArc
    newArc.edge = Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["c" /* createEdge */])(lArc.site, newArc.site);
    return;
  }

  // else lArc !== rArc
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["b" /* detachCircle */])(lArc);
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["b" /* detachCircle */])(rArc);

  var lSite = lArc.site,
      ax = lSite[0],
      ay = lSite[1],
      bx = site[0] - ax,
      by = site[1] - ay,
      rSite = rArc.site,
      cx = rSite[0] - ax,
      cy = rSite[1] - ay,
      d = 2 * (bx * cy - by * cx),
      hb = bx * bx + by * by,
      hc = cx * cx + cy * cy,
      vertex = [(cy * hb - by * hc) / d + ax, (bx * hc - cx * hb) / d + ay];

  Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["d" /* setEdgeEnd */])(rArc.edge, lSite, rSite, vertex);
  newArc.edge = Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["c" /* createEdge */])(lSite, site, null, vertex);
  rArc.edge = Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["c" /* createEdge */])(site, rSite, null, vertex);
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["a" /* attachCircle */])(lArc);
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["a" /* attachCircle */])(rArc);
}

function leftBreakPoint(arc, directrix) {
  var site = arc.site,
      rfocx = site[0],
      rfocy = site[1],
      pby2 = rfocy - directrix;

  if (!pby2) return rfocx;

  var lArc = arc.P;
  if (!lArc) return -Infinity;

  site = lArc.site;
  var lfocx = site[0],
      lfocy = site[1],
      plby2 = lfocy - directrix;

  if (!plby2) return lfocx;

  var hl = lfocx - rfocx,
      aby2 = 1 / pby2 - 1 / plby2,
      b = hl / plby2;

  if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;

  return (rfocx + lfocx) / 2;
}

function rightBreakPoint(arc, directrix) {
  var rArc = arc.N;
  if (rArc) return leftBreakPoint(rArc, directrix);
  var site = arc.site;
  return site[1] === directrix ? site[0] : Infinity;
}


/***/ }),

/***/ "./node_modules/d3-voronoi/src/Cell.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = createCell;
/* harmony export (immutable) */ __webpack_exports__["a"] = cellHalfedgeStart;
/* unused harmony export cellHalfedgeEnd */
/* harmony export (immutable) */ __webpack_exports__["d"] = sortCellHalfedges;
/* harmony export (immutable) */ __webpack_exports__["b"] = clipCells;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Edge__ = __webpack_require__("./node_modules/d3-voronoi/src/Edge.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Diagram__ = __webpack_require__("./node_modules/d3-voronoi/src/Diagram.js");



function createCell(site) {
  return __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* cells */][site.index] = {
    site: site,
    halfedges: []
  };
}

function cellHalfedgeAngle(cell, edge) {
  var site = cell.site,
      va = edge.left,
      vb = edge.right;
  if (site === vb) vb = va, va = site;
  if (vb) return Math.atan2(vb[1] - va[1], vb[0] - va[0]);
  if (site === va) va = edge[1], vb = edge[0];
  else va = edge[0], vb = edge[1];
  return Math.atan2(va[0] - vb[0], vb[1] - va[1]);
}

function cellHalfedgeStart(cell, edge) {
  return edge[+(edge.left !== cell.site)];
}

function cellHalfedgeEnd(cell, edge) {
  return edge[+(edge.left === cell.site)];
}

function sortCellHalfedges() {
  for (var i = 0, n = __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* cells */].length, cell, halfedges, j, m; i < n; ++i) {
    if ((cell = __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* cells */][i]) && (m = (halfedges = cell.halfedges).length)) {
      var index = new Array(m),
          array = new Array(m);
      for (j = 0; j < m; ++j) index[j] = j, array[j] = cellHalfedgeAngle(cell, __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */][halfedges[j]]);
      index.sort(function(i, j) { return array[j] - array[i]; });
      for (j = 0; j < m; ++j) array[j] = halfedges[index[j]];
      for (j = 0; j < m; ++j) halfedges[j] = array[j];
    }
  }
}

function clipCells(x0, y0, x1, y1) {
  var nCells = __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* cells */].length,
      iCell,
      cell,
      site,
      iHalfedge,
      halfedges,
      nHalfedges,
      start,
      startX,
      startY,
      end,
      endX,
      endY,
      cover = true;

  for (iCell = 0; iCell < nCells; ++iCell) {
    if (cell = __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* cells */][iCell]) {
      site = cell.site;
      halfedges = cell.halfedges;
      iHalfedge = halfedges.length;

      // Remove any dangling clipped edges.
      while (iHalfedge--) {
        if (!__WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */][halfedges[iHalfedge]]) {
          halfedges.splice(iHalfedge, 1);
        }
      }

      // Insert any border edges as necessary.
      iHalfedge = 0, nHalfedges = halfedges.length;
      while (iHalfedge < nHalfedges) {
        end = cellHalfedgeEnd(cell, __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */][halfedges[iHalfedge]]), endX = end[0], endY = end[1];
        start = cellHalfedgeStart(cell, __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */][halfedges[++iHalfedge % nHalfedges]]), startX = start[0], startY = start[1];
        if (Math.abs(endX - startX) > __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] || Math.abs(endY - startY) > __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */]) {
          halfedges.splice(iHalfedge, 0, __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */].push(Object(__WEBPACK_IMPORTED_MODULE_0__Edge__["b" /* createBorderEdge */])(site, end,
              Math.abs(endX - x0) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] && y1 - endY > __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] ? [x0, Math.abs(startX - x0) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] ? startY : y1]
              : Math.abs(endY - y1) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] && x1 - endX > __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] ? [Math.abs(startY - y1) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] ? startX : x1, y1]
              : Math.abs(endX - x1) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] && endY - y0 > __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] ? [x1, Math.abs(startX - x1) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] ? startY : y0]
              : Math.abs(endY - y0) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] && endX - x0 > __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] ? [Math.abs(startY - y0) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] ? startX : x0, y0]
              : null)) - 1);
          ++nHalfedges;
        }
      }

      if (nHalfedges) cover = false;
    }
  }

  // If there weren’t any edges, have the closest site cover the extent.
  // It doesn’t matter which corner of the extent we measure!
  if (cover) {
    var dx, dy, d2, dc = Infinity;

    for (iCell = 0, cover = null; iCell < nCells; ++iCell) {
      if (cell = __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* cells */][iCell]) {
        site = cell.site;
        dx = site[0] - x0;
        dy = site[1] - y0;
        d2 = dx * dx + dy * dy;
        if (d2 < dc) dc = d2, cover = cell;
      }
    }

    if (cover) {
      var v00 = [x0, y0], v01 = [x0, y1], v11 = [x1, y1], v10 = [x1, y0];
      cover.halfedges.push(
        __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */].push(Object(__WEBPACK_IMPORTED_MODULE_0__Edge__["b" /* createBorderEdge */])(site = cover.site, v00, v01)) - 1,
        __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */].push(Object(__WEBPACK_IMPORTED_MODULE_0__Edge__["b" /* createBorderEdge */])(site, v01, v11)) - 1,
        __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */].push(Object(__WEBPACK_IMPORTED_MODULE_0__Edge__["b" /* createBorderEdge */])(site, v11, v10)) - 1,
        __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */].push(Object(__WEBPACK_IMPORTED_MODULE_0__Edge__["b" /* createBorderEdge */])(site, v10, v00)) - 1
      );
    }
  }

  // Lastly delete any cells with no edges; these were entirely clipped.
  for (iCell = 0; iCell < nCells; ++iCell) {
    if (cell = __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* cells */][iCell]) {
      if (!cell.halfedges.length) {
        delete __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* cells */][iCell];
      }
    }
  }
}


/***/ }),

/***/ "./node_modules/d3-voronoi/src/Circle.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return firstCircle; });
/* harmony export (immutable) */ __webpack_exports__["a"] = attachCircle;
/* harmony export (immutable) */ __webpack_exports__["b"] = detachCircle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RedBlackTree__ = __webpack_require__("./node_modules/d3-voronoi/src/RedBlackTree.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Diagram__ = __webpack_require__("./node_modules/d3-voronoi/src/Diagram.js");



var circlePool = [];

var firstCircle;

function Circle() {
  Object(__WEBPACK_IMPORTED_MODULE_0__RedBlackTree__["a" /* RedBlackNode */])(this);
  this.x =
  this.y =
  this.arc =
  this.site =
  this.cy = null;
}

function attachCircle(arc) {
  var lArc = arc.P,
      rArc = arc.N;

  if (!lArc || !rArc) return;

  var lSite = lArc.site,
      cSite = arc.site,
      rSite = rArc.site;

  if (lSite === rSite) return;

  var bx = cSite[0],
      by = cSite[1],
      ax = lSite[0] - bx,
      ay = lSite[1] - by,
      cx = rSite[0] - bx,
      cy = rSite[1] - by;

  var d = 2 * (ax * cy - ay * cx);
  if (d >= -__WEBPACK_IMPORTED_MODULE_1__Diagram__["g" /* epsilon2 */]) return;

  var ha = ax * ax + ay * ay,
      hc = cx * cx + cy * cy,
      x = (cy * ha - ay * hc) / d,
      y = (ax * hc - cx * ha) / d;

  var circle = circlePool.pop() || new Circle;
  circle.arc = arc;
  circle.site = cSite;
  circle.x = x + bx;
  circle.y = (circle.cy = y + by) + Math.sqrt(x * x + y * y); // y bottom

  arc.circle = circle;

  var before = null,
      node = __WEBPACK_IMPORTED_MODULE_1__Diagram__["c" /* circles */]._;

  while (node) {
    if (circle.y < node.y || (circle.y === node.y && circle.x <= node.x)) {
      if (node.L) node = node.L;
      else { before = node.P; break; }
    } else {
      if (node.R) node = node.R;
      else { before = node; break; }
    }
  }

  __WEBPACK_IMPORTED_MODULE_1__Diagram__["c" /* circles */].insert(before, circle);
  if (!before) firstCircle = circle;
}

function detachCircle(arc) {
  var circle = arc.circle;
  if (circle) {
    if (!circle.P) firstCircle = circle.N;
    __WEBPACK_IMPORTED_MODULE_1__Diagram__["c" /* circles */].remove(circle);
    circlePool.push(circle);
    Object(__WEBPACK_IMPORTED_MODULE_0__RedBlackTree__["a" /* RedBlackNode */])(circle);
    arc.circle = null;
  }
}


/***/ }),

/***/ "./node_modules/d3-voronoi/src/Diagram.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return epsilon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return epsilon2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return beaches; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return cells; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return circles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return edges; });
/* harmony export (immutable) */ __webpack_exports__["d"] = Diagram;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Beach__ = __webpack_require__("./node_modules/d3-voronoi/src/Beach.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Cell__ = __webpack_require__("./node_modules/d3-voronoi/src/Cell.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Circle__ = __webpack_require__("./node_modules/d3-voronoi/src/Circle.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Edge__ = __webpack_require__("./node_modules/d3-voronoi/src/Edge.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RedBlackTree__ = __webpack_require__("./node_modules/d3-voronoi/src/RedBlackTree.js");






var epsilon = 1e-6;
var epsilon2 = 1e-12;
var beaches;
var cells;
var circles;
var edges;

function triangleArea(a, b, c) {
  return (a[0] - c[0]) * (b[1] - a[1]) - (a[0] - b[0]) * (c[1] - a[1]);
}

function lexicographic(a, b) {
  return b[1] - a[1]
      || b[0] - a[0];
}

function Diagram(sites, extent) {
  var site = sites.sort(lexicographic).pop(),
      x,
      y,
      circle;

  edges = [];
  cells = new Array(sites.length);
  beaches = new __WEBPACK_IMPORTED_MODULE_4__RedBlackTree__["b" /* default */];
  circles = new __WEBPACK_IMPORTED_MODULE_4__RedBlackTree__["b" /* default */];

  while (true) {
    circle = __WEBPACK_IMPORTED_MODULE_2__Circle__["c" /* firstCircle */];
    if (site && (!circle || site[1] < circle.y || (site[1] === circle.y && site[0] < circle.x))) {
      if (site[0] !== x || site[1] !== y) {
        Object(__WEBPACK_IMPORTED_MODULE_0__Beach__["a" /* addBeach */])(site);
        x = site[0], y = site[1];
      }
      site = sites.pop();
    } else if (circle) {
      Object(__WEBPACK_IMPORTED_MODULE_0__Beach__["b" /* removeBeach */])(circle.arc);
    } else {
      break;
    }
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__Cell__["d" /* sortCellHalfedges */])();

  if (extent) {
    var x0 = +extent[0][0],
        y0 = +extent[0][1],
        x1 = +extent[1][0],
        y1 = +extent[1][1];
    Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["a" /* clipEdges */])(x0, y0, x1, y1);
    Object(__WEBPACK_IMPORTED_MODULE_1__Cell__["b" /* clipCells */])(x0, y0, x1, y1);
  }

  this.edges = edges;
  this.cells = cells;

  beaches =
  circles =
  edges =
  cells = null;
}

Diagram.prototype = {
  constructor: Diagram,

  polygons: function() {
    var edges = this.edges;

    return this.cells.map(function(cell) {
      var polygon = cell.halfedges.map(function(i) { return Object(__WEBPACK_IMPORTED_MODULE_1__Cell__["a" /* cellHalfedgeStart */])(cell, edges[i]); });
      polygon.data = cell.site.data;
      return polygon;
    });
  },

  triangles: function() {
    var triangles = [],
        edges = this.edges;

    this.cells.forEach(function(cell, i) {
      if (!(m = (halfedges = cell.halfedges).length)) return;
      var site = cell.site,
          halfedges,
          j = -1,
          m,
          s0,
          e1 = edges[halfedges[m - 1]],
          s1 = e1.left === site ? e1.right : e1.left;

      while (++j < m) {
        s0 = s1;
        e1 = edges[halfedges[j]];
        s1 = e1.left === site ? e1.right : e1.left;
        if (s0 && s1 && i < s0.index && i < s1.index && triangleArea(site, s0, s1) < 0) {
          triangles.push([site.data, s0.data, s1.data]);
        }
      }
    });

    return triangles;
  },

  links: function() {
    return this.edges.filter(function(edge) {
      return edge.right;
    }).map(function(edge) {
      return {
        source: edge.left.data,
        target: edge.right.data
      };
    });
  },

  find: function(x, y, radius) {
    var that = this, i0, i1 = that._found || 0, n = that.cells.length, cell;

    // Use the previously-found cell, or start with an arbitrary one.
    while (!(cell = that.cells[i1])) if (++i1 >= n) return null;
    var dx = x - cell.site[0], dy = y - cell.site[1], d2 = dx * dx + dy * dy;

    // Traverse the half-edges to find a closer cell, if any.
    do {
      cell = that.cells[i0 = i1], i1 = null;
      cell.halfedges.forEach(function(e) {
        var edge = that.edges[e], v = edge.left;
        if ((v === cell.site || !v) && !(v = edge.right)) return;
        var vx = x - v[0], vy = y - v[1], v2 = vx * vx + vy * vy;
        if (v2 < d2) d2 = v2, i1 = v.index;
      });
    } while (i1 !== null);

    that._found = i0;

    return radius == null || d2 <= radius * radius ? cell.site : null;
  }
}


/***/ }),

/***/ "./node_modules/d3-voronoi/src/Edge.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = createEdge;
/* harmony export (immutable) */ __webpack_exports__["b"] = createBorderEdge;
/* harmony export (immutable) */ __webpack_exports__["d"] = setEdgeEnd;
/* harmony export (immutable) */ __webpack_exports__["a"] = clipEdges;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Diagram__ = __webpack_require__("./node_modules/d3-voronoi/src/Diagram.js");


function createEdge(left, right, v0, v1) {
  var edge = [null, null],
      index = __WEBPACK_IMPORTED_MODULE_0__Diagram__["e" /* edges */].push(edge) - 1;
  edge.left = left;
  edge.right = right;
  if (v0) setEdgeEnd(edge, left, right, v0);
  if (v1) setEdgeEnd(edge, right, left, v1);
  __WEBPACK_IMPORTED_MODULE_0__Diagram__["b" /* cells */][left.index].halfedges.push(index);
  __WEBPACK_IMPORTED_MODULE_0__Diagram__["b" /* cells */][right.index].halfedges.push(index);
  return edge;
}

function createBorderEdge(left, v0, v1) {
  var edge = [v0, v1];
  edge.left = left;
  return edge;
}

function setEdgeEnd(edge, left, right, vertex) {
  if (!edge[0] && !edge[1]) {
    edge[0] = vertex;
    edge.left = left;
    edge.right = right;
  } else if (edge.left === right) {
    edge[1] = vertex;
  } else {
    edge[0] = vertex;
  }
}

// Liang–Barsky line clipping.
function clipEdge(edge, x0, y0, x1, y1) {
  var a = edge[0],
      b = edge[1],
      ax = a[0],
      ay = a[1],
      bx = b[0],
      by = b[1],
      t0 = 0,
      t1 = 1,
      dx = bx - ax,
      dy = by - ay,
      r;

  r = x0 - ax;
  if (!dx && r > 0) return;
  r /= dx;
  if (dx < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dx > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = x1 - ax;
  if (!dx && r < 0) return;
  r /= dx;
  if (dx < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dx > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  r = y0 - ay;
  if (!dy && r > 0) return;
  r /= dy;
  if (dy < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dy > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = y1 - ay;
  if (!dy && r < 0) return;
  r /= dy;
  if (dy < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dy > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  if (!(t0 > 0) && !(t1 < 1)) return true; // TODO Better check?

  if (t0 > 0) edge[0] = [ax + t0 * dx, ay + t0 * dy];
  if (t1 < 1) edge[1] = [ax + t1 * dx, ay + t1 * dy];
  return true;
}

function connectEdge(edge, x0, y0, x1, y1) {
  var v1 = edge[1];
  if (v1) return true;

  var v0 = edge[0],
      left = edge.left,
      right = edge.right,
      lx = left[0],
      ly = left[1],
      rx = right[0],
      ry = right[1],
      fx = (lx + rx) / 2,
      fy = (ly + ry) / 2,
      fm,
      fb;

  if (ry === ly) {
    if (fx < x0 || fx >= x1) return;
    if (lx > rx) {
      if (!v0) v0 = [fx, y0];
      else if (v0[1] >= y1) return;
      v1 = [fx, y1];
    } else {
      if (!v0) v0 = [fx, y1];
      else if (v0[1] < y0) return;
      v1 = [fx, y0];
    }
  } else {
    fm = (lx - rx) / (ry - ly);
    fb = fy - fm * fx;
    if (fm < -1 || fm > 1) {
      if (lx > rx) {
        if (!v0) v0 = [(y0 - fb) / fm, y0];
        else if (v0[1] >= y1) return;
        v1 = [(y1 - fb) / fm, y1];
      } else {
        if (!v0) v0 = [(y1 - fb) / fm, y1];
        else if (v0[1] < y0) return;
        v1 = [(y0 - fb) / fm, y0];
      }
    } else {
      if (ly < ry) {
        if (!v0) v0 = [x0, fm * x0 + fb];
        else if (v0[0] >= x1) return;
        v1 = [x1, fm * x1 + fb];
      } else {
        if (!v0) v0 = [x1, fm * x1 + fb];
        else if (v0[0] < x0) return;
        v1 = [x0, fm * x0 + fb];
      }
    }
  }

  edge[0] = v0;
  edge[1] = v1;
  return true;
}

function clipEdges(x0, y0, x1, y1) {
  var i = __WEBPACK_IMPORTED_MODULE_0__Diagram__["e" /* edges */].length,
      edge;

  while (i--) {
    if (!connectEdge(edge = __WEBPACK_IMPORTED_MODULE_0__Diagram__["e" /* edges */][i], x0, y0, x1, y1)
        || !clipEdge(edge, x0, y0, x1, y1)
        || !(Math.abs(edge[0][0] - edge[1][0]) > __WEBPACK_IMPORTED_MODULE_0__Diagram__["f" /* epsilon */]
            || Math.abs(edge[0][1] - edge[1][1]) > __WEBPACK_IMPORTED_MODULE_0__Diagram__["f" /* epsilon */])) {
      delete __WEBPACK_IMPORTED_MODULE_0__Diagram__["e" /* edges */][i];
    }
  }
}


/***/ }),

/***/ "./node_modules/d3-voronoi/src/RedBlackTree.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = RedBlackNode;
function RedBlackTree() {
  this._ = null; // root node
}

function RedBlackNode(node) {
  node.U = // parent node
  node.C = // color - true for red, false for black
  node.L = // left node
  node.R = // right node
  node.P = // previous node
  node.N = null; // next node
}

RedBlackTree.prototype = {
  constructor: RedBlackTree,

  insert: function(after, node) {
    var parent, grandpa, uncle;

    if (after) {
      node.P = after;
      node.N = after.N;
      if (after.N) after.N.P = node;
      after.N = node;
      if (after.R) {
        after = after.R;
        while (after.L) after = after.L;
        after.L = node;
      } else {
        after.R = node;
      }
      parent = after;
    } else if (this._) {
      after = RedBlackFirst(this._);
      node.P = null;
      node.N = after;
      after.P = after.L = node;
      parent = after;
    } else {
      node.P = node.N = null;
      this._ = node;
      parent = null;
    }
    node.L = node.R = null;
    node.U = parent;
    node.C = true;

    after = node;
    while (parent && parent.C) {
      grandpa = parent.U;
      if (parent === grandpa.L) {
        uncle = grandpa.R;
        if (uncle && uncle.C) {
          parent.C = uncle.C = false;
          grandpa.C = true;
          after = grandpa;
        } else {
          if (after === parent.R) {
            RedBlackRotateLeft(this, parent);
            after = parent;
            parent = after.U;
          }
          parent.C = false;
          grandpa.C = true;
          RedBlackRotateRight(this, grandpa);
        }
      } else {
        uncle = grandpa.L;
        if (uncle && uncle.C) {
          parent.C = uncle.C = false;
          grandpa.C = true;
          after = grandpa;
        } else {
          if (after === parent.L) {
            RedBlackRotateRight(this, parent);
            after = parent;
            parent = after.U;
          }
          parent.C = false;
          grandpa.C = true;
          RedBlackRotateLeft(this, grandpa);
        }
      }
      parent = after.U;
    }
    this._.C = false;
  },

  remove: function(node) {
    if (node.N) node.N.P = node.P;
    if (node.P) node.P.N = node.N;
    node.N = node.P = null;

    var parent = node.U,
        sibling,
        left = node.L,
        right = node.R,
        next,
        red;

    if (!left) next = right;
    else if (!right) next = left;
    else next = RedBlackFirst(right);

    if (parent) {
      if (parent.L === node) parent.L = next;
      else parent.R = next;
    } else {
      this._ = next;
    }

    if (left && right) {
      red = next.C;
      next.C = node.C;
      next.L = left;
      left.U = next;
      if (next !== right) {
        parent = next.U;
        next.U = node.U;
        node = next.R;
        parent.L = node;
        next.R = right;
        right.U = next;
      } else {
        next.U = parent;
        parent = next;
        node = next.R;
      }
    } else {
      red = node.C;
      node = next;
    }

    if (node) node.U = parent;
    if (red) return;
    if (node && node.C) { node.C = false; return; }

    do {
      if (node === this._) break;
      if (node === parent.L) {
        sibling = parent.R;
        if (sibling.C) {
          sibling.C = false;
          parent.C = true;
          RedBlackRotateLeft(this, parent);
          sibling = parent.R;
        }
        if ((sibling.L && sibling.L.C)
            || (sibling.R && sibling.R.C)) {
          if (!sibling.R || !sibling.R.C) {
            sibling.L.C = false;
            sibling.C = true;
            RedBlackRotateRight(this, sibling);
            sibling = parent.R;
          }
          sibling.C = parent.C;
          parent.C = sibling.R.C = false;
          RedBlackRotateLeft(this, parent);
          node = this._;
          break;
        }
      } else {
        sibling = parent.L;
        if (sibling.C) {
          sibling.C = false;
          parent.C = true;
          RedBlackRotateRight(this, parent);
          sibling = parent.L;
        }
        if ((sibling.L && sibling.L.C)
          || (sibling.R && sibling.R.C)) {
          if (!sibling.L || !sibling.L.C) {
            sibling.R.C = false;
            sibling.C = true;
            RedBlackRotateLeft(this, sibling);
            sibling = parent.L;
          }
          sibling.C = parent.C;
          parent.C = sibling.L.C = false;
          RedBlackRotateRight(this, parent);
          node = this._;
          break;
        }
      }
      sibling.C = true;
      node = parent;
      parent = parent.U;
    } while (!node.C);

    if (node) node.C = false;
  }
};

function RedBlackRotateLeft(tree, node) {
  var p = node,
      q = node.R,
      parent = p.U;

  if (parent) {
    if (parent.L === p) parent.L = q;
    else parent.R = q;
  } else {
    tree._ = q;
  }

  q.U = parent;
  p.U = q;
  p.R = q.L;
  if (p.R) p.R.U = p;
  q.L = p;
}

function RedBlackRotateRight(tree, node) {
  var p = node,
      q = node.L,
      parent = p.U;

  if (parent) {
    if (parent.L === p) parent.L = q;
    else parent.R = q;
  } else {
    tree._ = q;
  }

  q.U = parent;
  p.U = q;
  p.L = q.R;
  if (p.L) p.L.U = p;
  q.R = p;
}

function RedBlackFirst(node) {
  while (node.L) node = node.L;
  return node;
}

/* harmony default export */ __webpack_exports__["b"] = (RedBlackTree);


/***/ }),

/***/ "./node_modules/d3-voronoi/src/constant.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),

/***/ "./node_modules/d3-voronoi/src/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__voronoi__ = __webpack_require__("./node_modules/d3-voronoi/src/voronoi.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__voronoi__["a"]; });



/***/ }),

/***/ "./node_modules/d3-voronoi/src/point.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = x;
/* harmony export (immutable) */ __webpack_exports__["b"] = y;
function x(d) {
  return d[0];
}

function y(d) {
  return d[1];
}


/***/ }),

/***/ "./node_modules/d3-voronoi/src/voronoi.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__("./node_modules/d3-voronoi/src/constant.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__point__ = __webpack_require__("./node_modules/d3-voronoi/src/point.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Diagram__ = __webpack_require__("./node_modules/d3-voronoi/src/Diagram.js");




/* harmony default export */ __webpack_exports__["a"] = (function() {
  var x = __WEBPACK_IMPORTED_MODULE_1__point__["a" /* x */],
      y = __WEBPACK_IMPORTED_MODULE_1__point__["b" /* y */],
      extent = null;

  function voronoi(data) {
    return new __WEBPACK_IMPORTED_MODULE_2__Diagram__["d" /* default */](data.map(function(d, i) {
      var s = [Math.round(x(d, i, data) / __WEBPACK_IMPORTED_MODULE_2__Diagram__["f" /* epsilon */]) * __WEBPACK_IMPORTED_MODULE_2__Diagram__["f" /* epsilon */], Math.round(y(d, i, data) / __WEBPACK_IMPORTED_MODULE_2__Diagram__["f" /* epsilon */]) * __WEBPACK_IMPORTED_MODULE_2__Diagram__["f" /* epsilon */]];
      s.index = i;
      s.data = d;
      return s;
    }), extent);
  }

  voronoi.polygons = function(data) {
    return voronoi(data).polygons();
  };

  voronoi.links = function(data) {
    return voronoi(data).links();
  };

  voronoi.triangles = function(data) {
    return voronoi(data).triangles();
  };

  voronoi.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), voronoi) : x;
  };

  voronoi.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), voronoi) : y;
  };

  voronoi.extent = function(_) {
    return arguments.length ? (extent = _ == null ? null : [[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]], voronoi) : extent && [[extent[0][0], extent[0][1]], [extent[1][0], extent[1][1]]];
  };

  voronoi.size = function(_) {
    return arguments.length ? (extent = _ == null ? null : [[0, 0], [+_[0], +_[1]]], voronoi) : extent && [extent[1][0] - extent[0][0], extent[1][1] - extent[0][1]];
  };

  return voronoi;
});


/***/ }),

/***/ "./node_modules/d3-zoom/src/constant.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),

/***/ "./node_modules/d3-zoom/src/event.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ZoomEvent;
function ZoomEvent(target, type, transform) {
  this.target = target;
  this.type = type;
  this.transform = transform;
}


/***/ }),

/***/ "./node_modules/d3-zoom/src/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__zoom__ = __webpack_require__("./node_modules/d3-zoom/src/zoom.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__zoom__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__transform__ = __webpack_require__("./node_modules/d3-zoom/src/transform.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__transform__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__transform__["c"]; });




/***/ }),

/***/ "./node_modules/d3-zoom/src/noevent.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = nopropagation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__("./node_modules/d3-selection/src/index.js");


function nopropagation() {
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["e" /* event */].stopImmediatePropagation();
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["e" /* event */].preventDefault();
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["e" /* event */].stopImmediatePropagation();
});


/***/ }),

/***/ "./node_modules/d3-zoom/src/transform.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Transform;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return identity; });
/* harmony export (immutable) */ __webpack_exports__["b"] = transform;
function Transform(k, x, y) {
  this.k = k;
  this.x = x;
  this.y = y;
}

Transform.prototype = {
  constructor: Transform,
  scale: function(k) {
    return k === 1 ? this : new Transform(this.k * k, this.x, this.y);
  },
  translate: function(x, y) {
    return x === 0 & y === 0 ? this : new Transform(this.k, this.x + this.k * x, this.y + this.k * y);
  },
  apply: function(point) {
    return [point[0] * this.k + this.x, point[1] * this.k + this.y];
  },
  applyX: function(x) {
    return x * this.k + this.x;
  },
  applyY: function(y) {
    return y * this.k + this.y;
  },
  invert: function(location) {
    return [(location[0] - this.x) / this.k, (location[1] - this.y) / this.k];
  },
  invertX: function(x) {
    return (x - this.x) / this.k;
  },
  invertY: function(y) {
    return (y - this.y) / this.k;
  },
  rescaleX: function(x) {
    return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
  },
  rescaleY: function(y) {
    return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
  },
  toString: function() {
    return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
  }
};

var identity = new Transform(1, 0, 0);

transform.prototype = Transform.prototype;

function transform(node) {
  return node.__zoom || identity;
}


/***/ }),

/***/ "./node_modules/d3-zoom/src/zoom.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_dispatch__ = __webpack_require__("./node_modules/d3-dispatch/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_drag__ = __webpack_require__("./node_modules/d3-drag/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_interpolate__ = __webpack_require__("./node_modules/d3-interpolate/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_selection__ = __webpack_require__("./node_modules/d3-selection/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_transition__ = __webpack_require__("./node_modules/d3-transition/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constant__ = __webpack_require__("./node_modules/d3-zoom/src/constant.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__event__ = __webpack_require__("./node_modules/d3-zoom/src/event.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__transform__ = __webpack_require__("./node_modules/d3-zoom/src/transform.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__noevent__ = __webpack_require__("./node_modules/d3-zoom/src/noevent.js");










// Ignore right-click, since that should open the context menu.
function defaultFilter() {
  return !__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* event */].button;
}

function defaultExtent() {
  var e = this, w, h;
  if (e instanceof SVGElement) {
    e = e.ownerSVGElement || e;
    w = e.width.baseVal.value;
    h = e.height.baseVal.value;
  } else {
    w = e.clientWidth;
    h = e.clientHeight;
  }
  return [[0, 0], [w, h]];
}

function defaultTransform() {
  return this.__zoom || __WEBPACK_IMPORTED_MODULE_7__transform__["c" /* identity */];
}

function defaultWheelDelta() {
  return -__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* event */].deltaY * (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* event */].deltaMode ? 120 : 1) / 500;
}

function defaultTouchable() {
  return "ontouchstart" in this;
}

function defaultConstrain(transform, extent, translateExtent) {
  var dx0 = transform.invertX(extent[0][0]) - translateExtent[0][0],
      dx1 = transform.invertX(extent[1][0]) - translateExtent[1][0],
      dy0 = transform.invertY(extent[0][1]) - translateExtent[0][1],
      dy1 = transform.invertY(extent[1][1]) - translateExtent[1][1];
  return transform.translate(
    dx1 > dx0 ? (dx0 + dx1) / 2 : Math.min(0, dx0) || Math.max(0, dx1),
    dy1 > dy0 ? (dy0 + dy1) / 2 : Math.min(0, dy0) || Math.max(0, dy1)
  );
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var filter = defaultFilter,
      extent = defaultExtent,
      constrain = defaultConstrain,
      wheelDelta = defaultWheelDelta,
      touchable = defaultTouchable,
      scaleExtent = [0, Infinity],
      translateExtent = [[-Infinity, -Infinity], [Infinity, Infinity]],
      duration = 250,
      interpolate = __WEBPACK_IMPORTED_MODULE_2_d3_interpolate__["x" /* interpolateZoom */],
      gestures = [],
      listeners = Object(__WEBPACK_IMPORTED_MODULE_0_d3_dispatch__["a" /* dispatch */])("start", "zoom", "end"),
      touchstarting,
      touchending,
      touchDelay = 500,
      wheelDelay = 150,
      clickDistance2 = 0;

  function zoom(selection) {
    selection
        .property("__zoom", defaultTransform)
        .on("wheel.zoom", wheeled)
        .on("mousedown.zoom", mousedowned)
        .on("dblclick.zoom", dblclicked)
      .filter(touchable)
        .on("touchstart.zoom", touchstarted)
        .on("touchmove.zoom", touchmoved)
        .on("touchend.zoom touchcancel.zoom", touchended)
        .style("touch-action", "none")
        .style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }

  zoom.transform = function(collection, transform) {
    var selection = collection.selection ? collection.selection() : collection;
    selection.property("__zoom", defaultTransform);
    if (collection !== selection) {
      schedule(collection, transform);
    } else {
      selection.interrupt().each(function() {
        gesture(this, arguments)
            .start()
            .zoom(null, typeof transform === "function" ? transform.apply(this, arguments) : transform)
            .end();
      });
    }
  };

  zoom.scaleBy = function(selection, k) {
    zoom.scaleTo(selection, function() {
      var k0 = this.__zoom.k,
          k1 = typeof k === "function" ? k.apply(this, arguments) : k;
      return k0 * k1;
    });
  };

  zoom.scaleTo = function(selection, k) {
    zoom.transform(selection, function() {
      var e = extent.apply(this, arguments),
          t0 = this.__zoom,
          p0 = centroid(e),
          p1 = t0.invert(p0),
          k1 = typeof k === "function" ? k.apply(this, arguments) : k;
      return constrain(translate(scale(t0, k1), p0, p1), e, translateExtent);
    });
  };

  zoom.translateBy = function(selection, x, y) {
    zoom.transform(selection, function() {
      return constrain(this.__zoom.translate(
        typeof x === "function" ? x.apply(this, arguments) : x,
        typeof y === "function" ? y.apply(this, arguments) : y
      ), extent.apply(this, arguments), translateExtent);
    });
  };

  zoom.translateTo = function(selection, x, y) {
    zoom.transform(selection, function() {
      var e = extent.apply(this, arguments),
          t = this.__zoom,
          p = centroid(e);
      return constrain(__WEBPACK_IMPORTED_MODULE_7__transform__["c" /* identity */].translate(p[0], p[1]).scale(t.k).translate(
        typeof x === "function" ? -x.apply(this, arguments) : -x,
        typeof y === "function" ? -y.apply(this, arguments) : -y
      ), e, translateExtent);
    });
  };

  function scale(transform, k) {
    k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], k));
    return k === transform.k ? transform : new __WEBPACK_IMPORTED_MODULE_7__transform__["a" /* Transform */](k, transform.x, transform.y);
  }

  function translate(transform, p0, p1) {
    var x = p0[0] - p1[0] * transform.k, y = p0[1] - p1[1] * transform.k;
    return x === transform.x && y === transform.y ? transform : new __WEBPACK_IMPORTED_MODULE_7__transform__["a" /* Transform */](transform.k, x, y);
  }

  function centroid(extent) {
    return [(+extent[0][0] + +extent[1][0]) / 2, (+extent[0][1] + +extent[1][1]) / 2];
  }

  function schedule(transition, transform, center) {
    transition
        .on("start.zoom", function() { gesture(this, arguments).start(); })
        .on("interrupt.zoom end.zoom", function() { gesture(this, arguments).end(); })
        .tween("zoom", function() {
          var that = this,
              args = arguments,
              g = gesture(that, args),
              e = extent.apply(that, args),
              p = center || centroid(e),
              w = Math.max(e[1][0] - e[0][0], e[1][1] - e[0][1]),
              a = that.__zoom,
              b = typeof transform === "function" ? transform.apply(that, args) : transform,
              i = interpolate(a.invert(p).concat(w / a.k), b.invert(p).concat(w / b.k));
          return function(t) {
            if (t === 1) t = b; // Avoid rounding error on end.
            else { var l = i(t), k = w / l[2]; t = new __WEBPACK_IMPORTED_MODULE_7__transform__["a" /* Transform */](k, p[0] - l[0] * k, p[1] - l[1] * k); }
            g.zoom(null, t);
          };
        });
  }

  function gesture(that, args) {
    for (var i = 0, n = gestures.length, g; i < n; ++i) {
      if ((g = gestures[i]).that === that) {
        return g;
      }
    }
    return new Gesture(that, args);
  }

  function Gesture(that, args) {
    this.that = that;
    this.args = args;
    this.index = -1;
    this.active = 0;
    this.extent = extent.apply(that, args);
  }

  Gesture.prototype = {
    start: function() {
      if (++this.active === 1) {
        this.index = gestures.push(this) - 1;
        this.emit("start");
      }
      return this;
    },
    zoom: function(key, transform) {
      if (this.mouse && key !== "mouse") this.mouse[1] = transform.invert(this.mouse[0]);
      if (this.touch0 && key !== "touch") this.touch0[1] = transform.invert(this.touch0[0]);
      if (this.touch1 && key !== "touch") this.touch1[1] = transform.invert(this.touch1[0]);
      this.that.__zoom = transform;
      this.emit("zoom");
      return this;
    },
    end: function() {
      if (--this.active === 0) {
        gestures.splice(this.index, 1);
        this.index = -1;
        this.emit("end");
      }
      return this;
    },
    emit: function(type) {
      Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["d" /* customEvent */])(new __WEBPACK_IMPORTED_MODULE_6__event__["a" /* default */](zoom, type, this.that.__zoom), listeners.apply, listeners, [type, this.that, this.args]);
    }
  };

  function wheeled() {
    if (!filter.apply(this, arguments)) return;
    var g = gesture(this, arguments),
        t = this.__zoom,
        k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], t.k * Math.pow(2, wheelDelta.apply(this, arguments)))),
        p = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["h" /* mouse */])(this);

    // If the mouse is in the same location as before, reuse it.
    // If there were recent wheel events, reset the wheel idle timeout.
    if (g.wheel) {
      if (g.mouse[0][0] !== p[0] || g.mouse[0][1] !== p[1]) {
        g.mouse[1] = t.invert(g.mouse[0] = p);
      }
      clearTimeout(g.wheel);
    }

    // If this wheel event won’t trigger a transform change, ignore it.
    else if (t.k === k) return;

    // Otherwise, capture the mouse point and location at the start.
    else {
      g.mouse = [p, t.invert(p)];
      Object(__WEBPACK_IMPORTED_MODULE_4_d3_transition__["b" /* interrupt */])(this);
      g.start();
    }

    Object(__WEBPACK_IMPORTED_MODULE_8__noevent__["a" /* default */])();
    g.wheel = setTimeout(wheelidled, wheelDelay);
    g.zoom("mouse", constrain(translate(scale(t, k), g.mouse[0], g.mouse[1]), g.extent, translateExtent));

    function wheelidled() {
      g.wheel = null;
      g.end();
    }
  }

  function mousedowned() {
    if (touchending || !filter.apply(this, arguments)) return;
    var g = gesture(this, arguments),
        v = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["k" /* select */])(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* event */].view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true),
        p = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["h" /* mouse */])(this),
        x0 = __WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* event */].clientX,
        y0 = __WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* event */].clientY;

    Object(__WEBPACK_IMPORTED_MODULE_1_d3_drag__["b" /* dragDisable */])(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* event */].view);
    Object(__WEBPACK_IMPORTED_MODULE_8__noevent__["b" /* nopropagation */])();
    g.mouse = [p, this.__zoom.invert(p)];
    Object(__WEBPACK_IMPORTED_MODULE_4_d3_transition__["b" /* interrupt */])(this);
    g.start();

    function mousemoved() {
      Object(__WEBPACK_IMPORTED_MODULE_8__noevent__["a" /* default */])();
      if (!g.moved) {
        var dx = __WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* event */].clientX - x0, dy = __WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* event */].clientY - y0;
        g.moved = dx * dx + dy * dy > clickDistance2;
      }
      g.zoom("mouse", constrain(translate(g.that.__zoom, g.mouse[0] = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["h" /* mouse */])(g.that), g.mouse[1]), g.extent, translateExtent));
    }

    function mouseupped() {
      v.on("mousemove.zoom mouseup.zoom", null);
      Object(__WEBPACK_IMPORTED_MODULE_1_d3_drag__["c" /* dragEnable */])(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* event */].view, g.moved);
      Object(__WEBPACK_IMPORTED_MODULE_8__noevent__["a" /* default */])();
      g.end();
    }
  }

  function dblclicked() {
    if (!filter.apply(this, arguments)) return;
    var t0 = this.__zoom,
        p0 = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["h" /* mouse */])(this),
        p1 = t0.invert(p0),
        k1 = t0.k * (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* event */].shiftKey ? 0.5 : 2),
        t1 = constrain(translate(scale(t0, k1), p0, p1), extent.apply(this, arguments), translateExtent);

    Object(__WEBPACK_IMPORTED_MODULE_8__noevent__["a" /* default */])();
    if (duration > 0) Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["k" /* select */])(this).transition().duration(duration).call(schedule, t1, p0);
    else Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["k" /* select */])(this).call(zoom.transform, t1);
  }

  function touchstarted() {
    if (!filter.apply(this, arguments)) return;
    var g = gesture(this, arguments),
        touches = __WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* event */].changedTouches,
        started,
        n = touches.length, i, t, p;

    Object(__WEBPACK_IMPORTED_MODULE_8__noevent__["b" /* nopropagation */])();
    for (i = 0; i < n; ++i) {
      t = touches[i], p = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["q" /* touch */])(this, touches, t.identifier);
      p = [p, this.__zoom.invert(p), t.identifier];
      if (!g.touch0) g.touch0 = p, started = true;
      else if (!g.touch1) g.touch1 = p;
    }

    // If this is a dbltap, reroute to the (optional) dblclick.zoom handler.
    if (touchstarting) {
      touchstarting = clearTimeout(touchstarting);
      if (!g.touch1) {
        g.end();
        p = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["k" /* select */])(this).on("dblclick.zoom");
        if (p) p.apply(this, arguments);
        return;
      }
    }

    if (started) {
      touchstarting = setTimeout(function() { touchstarting = null; }, touchDelay);
      Object(__WEBPACK_IMPORTED_MODULE_4_d3_transition__["b" /* interrupt */])(this);
      g.start();
    }
  }

  function touchmoved() {
    var g = gesture(this, arguments),
        touches = __WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* event */].changedTouches,
        n = touches.length, i, t, p, l;

    Object(__WEBPACK_IMPORTED_MODULE_8__noevent__["a" /* default */])();
    if (touchstarting) touchstarting = clearTimeout(touchstarting);
    for (i = 0; i < n; ++i) {
      t = touches[i], p = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["q" /* touch */])(this, touches, t.identifier);
      if (g.touch0 && g.touch0[2] === t.identifier) g.touch0[0] = p;
      else if (g.touch1 && g.touch1[2] === t.identifier) g.touch1[0] = p;
    }
    t = g.that.__zoom;
    if (g.touch1) {
      var p0 = g.touch0[0], l0 = g.touch0[1],
          p1 = g.touch1[0], l1 = g.touch1[1],
          dp = (dp = p1[0] - p0[0]) * dp + (dp = p1[1] - p0[1]) * dp,
          dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
      t = scale(t, Math.sqrt(dp / dl));
      p = [(p0[0] + p1[0]) / 2, (p0[1] + p1[1]) / 2];
      l = [(l0[0] + l1[0]) / 2, (l0[1] + l1[1]) / 2];
    }
    else if (g.touch0) p = g.touch0[0], l = g.touch0[1];
    else return;
    g.zoom("touch", constrain(translate(t, p, l), g.extent, translateExtent));
  }

  function touchended() {
    var g = gesture(this, arguments),
        touches = __WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" /* event */].changedTouches,
        n = touches.length, i, t;

    Object(__WEBPACK_IMPORTED_MODULE_8__noevent__["b" /* nopropagation */])();
    if (touchending) clearTimeout(touchending);
    touchending = setTimeout(function() { touchending = null; }, touchDelay);
    for (i = 0; i < n; ++i) {
      t = touches[i];
      if (g.touch0 && g.touch0[2] === t.identifier) delete g.touch0;
      else if (g.touch1 && g.touch1[2] === t.identifier) delete g.touch1;
    }
    if (g.touch1 && !g.touch0) g.touch0 = g.touch1, delete g.touch1;
    if (g.touch0) g.touch0[1] = this.__zoom.invert(g.touch0[0]);
    else g.end();
  }

  zoom.wheelDelta = function(_) {
    return arguments.length ? (wheelDelta = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_5__constant__["a" /* default */])(+_), zoom) : wheelDelta;
  };

  zoom.filter = function(_) {
    return arguments.length ? (filter = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_5__constant__["a" /* default */])(!!_), zoom) : filter;
  };

  zoom.touchable = function(_) {
    return arguments.length ? (touchable = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_5__constant__["a" /* default */])(!!_), zoom) : touchable;
  };

  zoom.extent = function(_) {
    return arguments.length ? (extent = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_5__constant__["a" /* default */])([[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]]), zoom) : extent;
  };

  zoom.scaleExtent = function(_) {
    return arguments.length ? (scaleExtent[0] = +_[0], scaleExtent[1] = +_[1], zoom) : [scaleExtent[0], scaleExtent[1]];
  };

  zoom.translateExtent = function(_) {
    return arguments.length ? (translateExtent[0][0] = +_[0][0], translateExtent[1][0] = +_[1][0], translateExtent[0][1] = +_[0][1], translateExtent[1][1] = +_[1][1], zoom) : [[translateExtent[0][0], translateExtent[0][1]], [translateExtent[1][0], translateExtent[1][1]]];
  };

  zoom.constrain = function(_) {
    return arguments.length ? (constrain = _, zoom) : constrain;
  };

  zoom.duration = function(_) {
    return arguments.length ? (duration = +_, zoom) : duration;
  };

  zoom.interpolate = function(_) {
    return arguments.length ? (interpolate = _, zoom) : interpolate;
  };

  zoom.on = function() {
    var value = listeners.on.apply(listeners, arguments);
    return value === listeners ? zoom : value;
  };

  zoom.clickDistance = function(_) {
    return arguments.length ? (clickDistance2 = (_ = +_) * _, zoom) : Math.sqrt(clickDistance2);
  };

  return zoom;
});


/***/ }),

/***/ "./node_modules/d3/dist/package.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export name */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return version; });
/* unused harmony export description */
/* unused harmony export keywords */
/* unused harmony export homepage */
/* unused harmony export license */
/* unused harmony export author */
/* unused harmony export main */
/* unused harmony export unpkg */
/* unused harmony export jsdelivr */
/* unused harmony export module */
/* unused harmony export repository */
/* unused harmony export scripts */
/* unused harmony export devDependencies */
/* unused harmony export dependencies */
var name = "d3";
var version = "5.7.0";
var description = "Data-Driven Documents";
var keywords = ["dom","visualization","svg","animation","canvas"];
var homepage = "https://d3js.org";
var license = "BSD-3-Clause";
var author = {"name":"Mike Bostock","url":"https://bost.ocks.org/mike"};
var main = "dist/d3.node.js";
var unpkg = "dist/d3.min.js";
var jsdelivr = "dist/d3.min.js";
var module = "index.js";
var repository = {"type":"git","url":"https://github.com/d3/d3.git"};
var scripts = {"pretest":"rimraf dist && mkdir dist && json2module package.json > dist/package.js && node rollup.node","test":"tape 'test/**/*-test.js'","prepublishOnly":"yarn test && rollup -c","postpublish":"git push && git push --tags && cd ../d3.github.com && git pull && cp ../d3/dist/d3.js d3.v5.js && cp ../d3/dist/d3.min.js d3.v5.min.js && git add d3.v5.js d3.v5.min.js && git commit -m \"d3 ${npm_package_version}\" && git push && cd - && cd ../d3-bower && git pull && cp ../d3/LICENSE ../d3/README.md ../d3/dist/d3.js ../d3/dist/d3.min.js . && git add -- LICENSE README.md d3.js d3.min.js && git commit -m \"${npm_package_version}\" && git tag -am \"${npm_package_version}\" v${npm_package_version} && git push && git push --tags && cd - && zip -j dist/d3.zip -- LICENSE README.md API.md CHANGES.md dist/d3.js dist/d3.min.js"};
var devDependencies = {"json2module":"0.0","rimraf":"2","rollup":"0.64","rollup-plugin-ascii":"0.0","rollup-plugin-node-resolve":"3","rollup-plugin-terser":"1","tape":"4"};
var dependencies = {"d3-array":"1","d3-axis":"1","d3-brush":"1","d3-chord":"1","d3-collection":"1","d3-color":"1","d3-contour":"1","d3-dispatch":"1","d3-drag":"1","d3-dsv":"1","d3-ease":"1","d3-fetch":"1","d3-force":"1","d3-format":"1","d3-geo":"1","d3-hierarchy":"1","d3-interpolate":"1","d3-path":"1","d3-polygon":"1","d3-quadtree":"1","d3-random":"1","d3-scale":"2","d3-scale-chromatic":"1","d3-selection":"1","d3-shape":"1","d3-time":"1","d3-time-format":"2","d3-timer":"1","d3-transition":"1","d3-voronoi":"1","d3-zoom":"1"};


/***/ }),

/***/ "./node_modules/d3/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dist_package__ = __webpack_require__("./node_modules/d3/dist/package.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "version", function() { return __WEBPACK_IMPORTED_MODULE_0__dist_package__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_array__ = __webpack_require__("./node_modules/d3-array/src/index.js");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "bisect", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "bisectRight", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "bisectLeft", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "ascending", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "bisector", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "cross", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "descending", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "deviation", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "extent", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "histogram", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["j"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "thresholdFreedmanDiaconis", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["w"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "thresholdScott", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["x"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "thresholdSturges", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["y"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "max", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["k"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "mean", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["l"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "median", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["m"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "merge", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["n"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "min", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["o"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "pairs", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["p"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "permute", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["q"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "quantile", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["r"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "range", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["s"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "scan", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["t"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "shuffle", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["u"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "sum", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["v"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "ticks", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["B"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "tickIncrement", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["z"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "tickStep", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["A"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "transpose", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["C"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "variance", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["D"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "zip", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["E"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_axis__ = __webpack_require__("./node_modules/d3-axis/src/index.js");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "axisTop", function() { return __WEBPACK_IMPORTED_MODULE_2_d3_axis__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "axisRight", function() { return __WEBPACK_IMPORTED_MODULE_2_d3_axis__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "axisBottom", function() { return __WEBPACK_IMPORTED_MODULE_2_d3_axis__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "axisLeft", function() { return __WEBPACK_IMPORTED_MODULE_2_d3_axis__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_brush__ = __webpack_require__("./node_modules/d3-brush/src/index.js");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "brush", function() { return __WEBPACK_IMPORTED_MODULE_3_d3_brush__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "brushX", function() { return __WEBPACK_IMPORTED_MODULE_3_d3_brush__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "brushY", function() { return __WEBPACK_IMPORTED_MODULE_3_d3_brush__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "brushSelection", function() { return __WEBPACK_IMPORTED_MODULE_3_d3_brush__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_chord__ = __webpack_require__("./node_modules/d3-chord/src/index.js");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "chord", function() { return __WEBPACK_IMPORTED_MODULE_4_d3_chord__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "ribbon", function() { return __WEBPACK_IMPORTED_MODULE_4_d3_chord__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_d3_collection__ = __webpack_require__("./node_modules/d3-collection/src/index.js");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "nest", function() { return __WEBPACK_IMPORTED_MODULE_5_d3_collection__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "set", function() { return __WEBPACK_IMPORTED_MODULE_5_d3_collection__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "map", function() { return __WEBPACK_IMPORTED_MODULE_5_d3_collection__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "keys", function() { return __WEBPACK_IMPORTED_MODULE_5_d3_collection__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "values", function() { return __WEBPACK_IMPORTED_MODULE_5_d3_collection__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "entries", function() { return __WEBPACK_IMPORTED_MODULE_5_d3_collection__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_d3_color__ = __webpack_require__("./node_modules/d3-color/src/index.js");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "color", function() { return __WEBPACK_IMPORTED_MODULE_6_d3_color__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "rgb", function() { return __WEBPACK_IMPORTED_MODULE_6_d3_color__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "hsl", function() { return __WEBPACK_IMPORTED_MODULE_6_d3_color__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "lab", function() { return __WEBPACK_IMPORTED_MODULE_6_d3_color__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "hcl", function() { return __WEBPACK_IMPORTED_MODULE_6_d3_color__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "lch", function() { return __WEBPACK_IMPORTED_MODULE_6_d3_color__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "gray", function() { return __WEBPACK_IMPORTED_MODULE_6_d3_color__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "cubehelix", function() { return __WEBPACK_IMPORTED_MODULE_6_d3_color__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_d3_contour__ = __webpack_require__("./node_modules/d3-contour/src/index.js");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "contours", function() { return __WEBPACK_IMPORTED_MODULE_7_d3_contour__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "contourDensity", function() { return __WEBPACK_IMPORTED_MODULE_7_d3_contour__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_d3_dispatch__ = __webpack_require__("./node_modules/d3-dispatch/src/index.js");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "dispatch", function() { return __WEBPACK_IMPORTED_MODULE_8_d3_dispatch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_d3_drag__ = __webpack_require__("./node_modules/d3-drag/src/index.js");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "drag", function() { return __WEBPACK_IMPORTED_MODULE_9_d3_drag__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "dragDisable", function() { return __WEBPACK_IMPORTED_MODULE_9_d3_drag__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "dragEnable", function() { return __WEBPACK_IMPORTED_MODULE_9_d3_drag__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_d3_dsv__ = __webpack_require__("./node_modules/d3-dsv/src/index.js");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "dsvFormat", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_dsv__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "csvParse", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_dsv__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "csvParseRows", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_dsv__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "csvFormat", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_dsv__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "csvFormatRows", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_dsv__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "tsvParse", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_dsv__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "tsvParseRows", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_dsv__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "tsvFormat", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_dsv__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "tsvFormatRows", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_dsv__["g"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_d3_ease__ = __webpack_require__("./node_modules/d3-ease/src/index.js");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeLinear", function() { return __WEBPACK_IMPORTED_MODULE_11_d3_ease__["y"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeQuad", function() { return __WEBPACK_IMPORTED_MODULE_11_d3_ease__["D"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeQuadIn", function() { return __WEBPACK_IMPORTED_MODULE_11_d3_ease__["E"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeQuadOut", function() { return __WEBPACK_IMPORTED_MODULE_11_d3_ease__["G"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeQuadInOut", function() { return __WEBPACK_IMPORTED_MODULE_11_d3_ease__["F"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeCubic", function() { return __WEBPACK_IMPORTED_MODULE_11_d3_ease__["m"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeCubicIn", function() { return __WEBPACK_IMPORTED_MODULE_11_d3_ease__["n"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeCubicOut", function() { return __WEBPACK_IMPORTED_MODULE_11_d3_ease__["p"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeCubicInOut", function() { return __WEBPACK_IMPORTED_MODULE_11_d3_ease__["o"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easePoly", function() { return __WEBPACK_IMPORTED_MODULE_11_d3_ease__["z"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easePolyIn", function() { return __WEBPACK_IMPORTED_MODULE_11_d3_ease__["A"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easePolyOut", function() { return __WEBPACK_IMPORTED_MODULE_11_d3_ease__["C"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easePolyInOut", function() { return __WEBPACK_IMPORTED_MODULE_11_d3_ease__["B"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeSin", function() { return __WEBPACK_IMPORTED_MODULE_11_d3_ease__["H"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeSinIn", function() { return __WEBPACK_IMPORTED_MODULE_11_d3_ease__["I"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeSinOut", function() { return __WEBPACK_IMPORTED_MODULE_11_d3_ease__["K"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeSinInOut", function() { return __WEBPACK_IMPORTED_MODULE_11_d3_ease__["J"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeExp", function() { return __WEBPACK_IMPORTED_MODULE_11_d3_ease__["u"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeExpIn", function() { return __WEBPACK_IMPORTED_MODULE_11_d3_ease__["v"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeExpOut", function() { return __WEBPACK_IMPORTED_MODULE_11_d3_ease__["x"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeExpInOut", function() { return __WEBPACK_IMPORTED_MODULE_11_d3_ease__["w"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeCircle", function() { return __WEBPACK_IMPORTED_MODULE_11_d3_ease__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeCircleIn", function() { return __WEBPACK_IMPORTED_MODULE_11_d3_ease__["j"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeCircleOut", function() { return __WEBPACK_IMPORTED_MODULE_11_d3_ease__["l"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeCircleInOut", function() { return __WEBPACK_IMPORTED_MODULE_11_d3_ease__["k"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeBounce", function() { return __WEBPACK_IMPORTED_MODULE_11_d3_ease__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeBounceIn", function() { return __WEBPACK_IMPORTED_MODULE_11_d3_ease__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeBounceOut", function() { return __WEBPACK_IMPORTED_MODULE_11_d3_ease__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeBounceInOut", function() { return __WEBPACK_IMPORTED_MODULE_11_d3_ease__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeBack", function() { return __WEBPACK_IMPORTED_MODULE_11_d3_ease__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeBackIn", function() { return __WEBPACK_IMPORTED_MODULE_11_d3_ease__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeBackOut", function() { return __WEBPACK_IMPORTED_MODULE_11_d3_ease__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeBackInOut", function() { return __WEBPACK_IMPORTED_MODULE_11_d3_ease__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeElastic", function() { return __WEBPACK_IMPORTED_MODULE_11_d3_ease__["q"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeElasticIn", function() { return __WEBPACK_IMPORTED_MODULE_11_d3_ease__["r"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeElasticOut", function() { return __WEBPACK_IMPORTED_MODULE_11_d3_ease__["t"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "easeElasticInOut", function() { return __WEBPACK_IMPORTED_MODULE_11_d3_ease__["s"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_d3_fetch__ = __webpack_require__("./node_modules/d3-fetch/src/index.js");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "blob", function() { return __WEBPACK_IMPORTED_MODULE_12_d3_fetch__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "buffer", function() { return __WEBPACK_IMPORTED_MODULE_12_d3_fetch__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "dsv", function() { return __WEBPACK_IMPORTED_MODULE_12_d3_fetch__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "csv", function() { return __WEBPACK_IMPORTED_MODULE_12_d3_fetch__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "tsv", function() { return __WEBPACK_IMPORTED_MODULE_12_d3_fetch__["j"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "image", function() { return __WEBPACK_IMPORTED_MODULE_12_d3_fetch__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "json", function() { return __WEBPACK_IMPORTED_MODULE_12_d3_fetch__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "text", function() { return __WEBPACK_IMPORTED_MODULE_12_d3_fetch__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "xml", function() { return __WEBPACK_IMPORTED_MODULE_12_d3_fetch__["k"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "html", function() { return __WEBPACK_IMPORTED_MODULE_12_d3_fetch__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "svg", function() { return __WEBPACK_IMPORTED_MODULE_12_d3_fetch__["h"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_d3_force__ = __webpack_require__("./node_modules/d3-force/src/index.js");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "forceCenter", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_force__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "forceCollide", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_force__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "forceLink", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_force__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "forceManyBody", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_force__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "forceRadial", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_force__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "forceSimulation", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_force__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "forceX", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_force__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "forceY", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_force__["h"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_d3_format__ = __webpack_require__("./node_modules/d3-format/src/index.js");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "formatDefaultLocale", function() { return __WEBPACK_IMPORTED_MODULE_14_d3_format__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "format", function() { return __WEBPACK_IMPORTED_MODULE_14_d3_format__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "formatPrefix", function() { return __WEBPACK_IMPORTED_MODULE_14_d3_format__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "formatLocale", function() { return __WEBPACK_IMPORTED_MODULE_14_d3_format__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "formatSpecifier", function() { return __WEBPACK_IMPORTED_MODULE_14_d3_format__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "precisionFixed", function() { return __WEBPACK_IMPORTED_MODULE_14_d3_format__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "precisionPrefix", function() { return __WEBPACK_IMPORTED_MODULE_14_d3_format__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "precisionRound", function() { return __WEBPACK_IMPORTED_MODULE_14_d3_format__["h"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_d3_geo__ = __webpack_require__("./node_modules/d3-geo/src/index.js");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoArea", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_geo__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoBounds", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_geo__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoCentroid", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_geo__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoCircle", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_geo__["j"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoClipAntimeridian", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_geo__["k"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoClipCircle", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_geo__["l"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoClipExtent", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_geo__["m"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoClipRectangle", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_geo__["n"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoContains", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_geo__["u"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoDistance", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_geo__["v"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoGraticule", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_geo__["C"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoGraticule10", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_geo__["D"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoInterpolate", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_geo__["F"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoLength", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_geo__["G"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoPath", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_geo__["N"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoAlbers", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_geo__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoAlbersUsa", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_geo__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoAzimuthalEqualArea", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_geo__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoAzimuthalEqualAreaRaw", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_geo__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoAzimuthalEquidistant", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_geo__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoAzimuthalEquidistantRaw", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_geo__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoConicConformal", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_geo__["o"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoConicConformalRaw", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_geo__["p"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoConicEqualArea", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_geo__["q"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoConicEqualAreaRaw", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_geo__["r"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoConicEquidistant", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_geo__["s"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoConicEquidistantRaw", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_geo__["t"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoEqualEarth", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_geo__["w"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoEqualEarthRaw", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_geo__["x"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoEquirectangular", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_geo__["y"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoEquirectangularRaw", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_geo__["z"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoGnomonic", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_geo__["A"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoGnomonicRaw", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_geo__["B"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoIdentity", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_geo__["E"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoProjection", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_geo__["O"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoProjectionMutator", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_geo__["P"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoMercator", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_geo__["H"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoMercatorRaw", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_geo__["I"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoNaturalEarth1", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_geo__["J"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoNaturalEarth1Raw", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_geo__["K"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoOrthographic", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_geo__["L"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoOrthographicRaw", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_geo__["M"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoStereographic", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_geo__["R"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoStereographicRaw", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_geo__["S"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoTransverseMercator", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_geo__["V"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoTransverseMercatorRaw", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_geo__["W"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoRotation", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_geo__["Q"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoStream", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_geo__["T"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geoTransform", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_geo__["U"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_d3_hierarchy__ = __webpack_require__("./node_modules/d3-hierarchy/src/index.js");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "cluster", function() { return __WEBPACK_IMPORTED_MODULE_16_d3_hierarchy__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "hierarchy", function() { return __WEBPACK_IMPORTED_MODULE_16_d3_hierarchy__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "pack", function() { return __WEBPACK_IMPORTED_MODULE_16_d3_hierarchy__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "packSiblings", function() { return __WEBPACK_IMPORTED_MODULE_16_d3_hierarchy__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "packEnclose", function() { return __WEBPACK_IMPORTED_MODULE_16_d3_hierarchy__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "partition", function() { return __WEBPACK_IMPORTED_MODULE_16_d3_hierarchy__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "stratify", function() { return __WEBPACK_IMPORTED_MODULE_16_d3_hierarchy__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "tree", function() { return __WEBPACK_IMPORTED_MODULE_16_d3_hierarchy__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "treemap", function() { return __WEBPACK_IMPORTED_MODULE_16_d3_hierarchy__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "treemapBinary", function() { return __WEBPACK_IMPORTED_MODULE_16_d3_hierarchy__["j"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "treemapDice", function() { return __WEBPACK_IMPORTED_MODULE_16_d3_hierarchy__["k"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "treemapSlice", function() { return __WEBPACK_IMPORTED_MODULE_16_d3_hierarchy__["m"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "treemapSliceDice", function() { return __WEBPACK_IMPORTED_MODULE_16_d3_hierarchy__["n"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "treemapSquarify", function() { return __WEBPACK_IMPORTED_MODULE_16_d3_hierarchy__["o"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "treemapResquarify", function() { return __WEBPACK_IMPORTED_MODULE_16_d3_hierarchy__["l"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_d3_interpolate__ = __webpack_require__("./node_modules/d3-interpolate/src/index.js");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolate", function() { return __WEBPACK_IMPORTED_MODULE_17_d3_interpolate__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateArray", function() { return __WEBPACK_IMPORTED_MODULE_17_d3_interpolate__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateBasis", function() { return __WEBPACK_IMPORTED_MODULE_17_d3_interpolate__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateBasisClosed", function() { return __WEBPACK_IMPORTED_MODULE_17_d3_interpolate__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateDate", function() { return __WEBPACK_IMPORTED_MODULE_17_d3_interpolate__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateDiscrete", function() { return __WEBPACK_IMPORTED_MODULE_17_d3_interpolate__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateHue", function() { return __WEBPACK_IMPORTED_MODULE_17_d3_interpolate__["m"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateNumber", function() { return __WEBPACK_IMPORTED_MODULE_17_d3_interpolate__["o"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateObject", function() { return __WEBPACK_IMPORTED_MODULE_17_d3_interpolate__["p"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateRound", function() { return __WEBPACK_IMPORTED_MODULE_17_d3_interpolate__["t"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateString", function() { return __WEBPACK_IMPORTED_MODULE_17_d3_interpolate__["u"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateTransformCss", function() { return __WEBPACK_IMPORTED_MODULE_17_d3_interpolate__["v"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateTransformSvg", function() { return __WEBPACK_IMPORTED_MODULE_17_d3_interpolate__["w"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateZoom", function() { return __WEBPACK_IMPORTED_MODULE_17_d3_interpolate__["x"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateRgb", function() { return __WEBPACK_IMPORTED_MODULE_17_d3_interpolate__["q"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateRgbBasis", function() { return __WEBPACK_IMPORTED_MODULE_17_d3_interpolate__["r"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateRgbBasisClosed", function() { return __WEBPACK_IMPORTED_MODULE_17_d3_interpolate__["s"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateHsl", function() { return __WEBPACK_IMPORTED_MODULE_17_d3_interpolate__["k"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateHslLong", function() { return __WEBPACK_IMPORTED_MODULE_17_d3_interpolate__["l"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateLab", function() { return __WEBPACK_IMPORTED_MODULE_17_d3_interpolate__["n"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateHcl", function() { return __WEBPACK_IMPORTED_MODULE_17_d3_interpolate__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateHclLong", function() { return __WEBPACK_IMPORTED_MODULE_17_d3_interpolate__["j"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateCubehelix", function() { return __WEBPACK_IMPORTED_MODULE_17_d3_interpolate__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateCubehelixLong", function() { return __WEBPACK_IMPORTED_MODULE_17_d3_interpolate__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "piecewise", function() { return __WEBPACK_IMPORTED_MODULE_17_d3_interpolate__["y"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "quantize", function() { return __WEBPACK_IMPORTED_MODULE_17_d3_interpolate__["z"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_d3_path__ = __webpack_require__("./node_modules/d3-path/src/index.js");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "path", function() { return __WEBPACK_IMPORTED_MODULE_18_d3_path__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_d3_polygon__ = __webpack_require__("./node_modules/d3-polygon/src/index.js");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "polygonArea", function() { return __WEBPACK_IMPORTED_MODULE_19_d3_polygon__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "polygonCentroid", function() { return __WEBPACK_IMPORTED_MODULE_19_d3_polygon__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "polygonHull", function() { return __WEBPACK_IMPORTED_MODULE_19_d3_polygon__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "polygonContains", function() { return __WEBPACK_IMPORTED_MODULE_19_d3_polygon__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "polygonLength", function() { return __WEBPACK_IMPORTED_MODULE_19_d3_polygon__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_d3_quadtree__ = __webpack_require__("./node_modules/d3-quadtree/src/index.js");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "quadtree", function() { return __WEBPACK_IMPORTED_MODULE_20_d3_quadtree__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_d3_random__ = __webpack_require__("./node_modules/d3-random/src/index.js");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "randomUniform", function() { return __WEBPACK_IMPORTED_MODULE_21_d3_random__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "randomNormal", function() { return __WEBPACK_IMPORTED_MODULE_21_d3_random__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "randomLogNormal", function() { return __WEBPACK_IMPORTED_MODULE_21_d3_random__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "randomBates", function() { return __WEBPACK_IMPORTED_MODULE_21_d3_random__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "randomIrwinHall", function() { return __WEBPACK_IMPORTED_MODULE_21_d3_random__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "randomExponential", function() { return __WEBPACK_IMPORTED_MODULE_21_d3_random__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_d3_scale__ = __webpack_require__("./node_modules/d3-scale/src/index.js");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "scaleBand", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "scalePoint", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "scaleIdentity", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "scaleLinear", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "scaleLog", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "scaleOrdinal", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "scaleImplicit", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "scalePow", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "scaleSqrt", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["m"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "scaleQuantile", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["j"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "scaleQuantize", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["k"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "scaleThreshold", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["n"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "scaleTime", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["o"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "scaleUtc", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["p"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "scaleSequential", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["l"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "scaleDiverging", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__ = __webpack_require__("./node_modules/d3-scale-chromatic/src/index.js");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "schemeCategory10", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["P"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "schemeAccent", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["K"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "schemeDark2", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["Q"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "schemePaired", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["X"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "schemePastel1", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["Y"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "schemePastel2", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["Z"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "schemeSet1", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["_12"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "schemeSet2", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["_13"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "schemeSet3", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["_14"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateBrBG", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "schemeBrBG", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["M"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolatePRGn", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["n"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "schemePRGn", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["W"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolatePiYG", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["o"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "schemePiYG", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["_0"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolatePuOr", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["s"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "schemePuOr", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["_3"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateRdBu", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["w"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "schemeRdBu", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["_6"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateRdGy", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["x"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "schemeRdGy", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["_7"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateRdYlBu", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["z"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "schemeRdYlBu", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["_9"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateRdYlGn", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["A"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "schemeRdYlGn", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["_10"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateSpectral", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["D"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "schemeSpectral", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["_15"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateBuGn", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "schemeBuGn", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["N"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateBuPu", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "schemeBuPu", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["O"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateGnBu", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "schemeGnBu", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["R"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateOrRd", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["l"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "schemeOrRd", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["U"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolatePuBuGn", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["r"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "schemePuBuGn", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["_2"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolatePuBu", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["q"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "schemePuBu", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["_1"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolatePuRd", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["t"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "schemePuRd", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["_4"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateRdPu", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["y"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "schemeRdPu", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["_8"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateYlGnBu", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["H"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "schemeYlGnBu", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["_17"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateYlGn", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["G"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "schemeYlGn", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["_16"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateYlOrBr", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["I"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "schemeYlOrBr", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["_18"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateYlOrRd", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["J"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "schemeYlOrRd", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["_19"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateBlues", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "schemeBlues", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["L"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateGreens", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "schemeGreens", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["S"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateGreys", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "schemeGreys", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["T"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolatePurples", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["u"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "schemePurples", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["_5"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateReds", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["B"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "schemeReds", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["_11"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateOranges", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["m"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "schemeOranges", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["V"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateCubehelixDefault", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateRainbow", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["v"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateWarm", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["F"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateCool", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateSinebow", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["C"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateViridis", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["E"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateMagma", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["k"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolateInferno", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["j"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interpolatePlasma", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_scale_chromatic__["p"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_d3_selection__ = __webpack_require__("./node_modules/d3-selection/src/index.js");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "create", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_selection__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "creator", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_selection__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "local", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_selection__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "matcher", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_selection__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "mouse", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_selection__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "namespace", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_selection__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "namespaces", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_selection__["j"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "clientPoint", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_selection__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "select", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_selection__["k"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "selectAll", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_selection__["l"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "selection", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_selection__["m"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "selector", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_selection__["n"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "selectorAll", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_selection__["o"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "style", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_selection__["p"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "touch", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_selection__["q"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "touches", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_selection__["r"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "window", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_selection__["s"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "event", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_selection__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "customEvent", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_selection__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_d3_shape__ = __webpack_require__("./node_modules/d3-shape/src/index.js");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "arc", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_shape__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "area", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_shape__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "line", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_shape__["v"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "pie", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_shape__["A"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "areaRadial", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_shape__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "radialArea", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_shape__["C"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "lineRadial", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_shape__["w"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "radialLine", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_shape__["D"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "pointRadial", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_shape__["B"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "linkHorizontal", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_shape__["x"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "linkVertical", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_shape__["z"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "linkRadial", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_shape__["y"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "symbol", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_shape__["P"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "symbols", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_shape__["X"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "symbolCircle", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_shape__["Q"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "symbolCross", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_shape__["R"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "symbolDiamond", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_shape__["S"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "symbolSquare", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_shape__["T"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "symbolStar", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_shape__["U"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "symbolTriangle", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_shape__["V"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "symbolWye", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_shape__["W"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "curveBasisClosed", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_shape__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "curveBasisOpen", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_shape__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "curveBasis", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_shape__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "curveBundle", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_shape__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "curveCardinalClosed", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_shape__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "curveCardinalOpen", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_shape__["j"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "curveCardinal", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_shape__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "curveCatmullRomClosed", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_shape__["l"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "curveCatmullRomOpen", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_shape__["m"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "curveCatmullRom", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_shape__["k"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "curveLinearClosed", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_shape__["o"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "curveLinear", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_shape__["n"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "curveMonotoneX", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_shape__["p"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "curveMonotoneY", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_shape__["q"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "curveNatural", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_shape__["r"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "curveStep", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_shape__["s"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "curveStepAfter", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_shape__["t"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "curveStepBefore", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_shape__["u"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "stack", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_shape__["E"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "stackOffsetExpand", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_shape__["G"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "stackOffsetDiverging", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_shape__["F"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "stackOffsetNone", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_shape__["H"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "stackOffsetSilhouette", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_shape__["I"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "stackOffsetWiggle", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_shape__["J"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "stackOrderAscending", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_shape__["K"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "stackOrderDescending", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_shape__["L"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "stackOrderInsideOut", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_shape__["M"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "stackOrderNone", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_shape__["N"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "stackOrderReverse", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_shape__["O"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_d3_time__ = __webpack_require__("./node_modules/d3-time/src/index.js");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeInterval", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeMillisecond", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeMilliseconds", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcMillisecond", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time__["L"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcMilliseconds", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time__["M"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeSecond", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time__["r"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeSeconds", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time__["s"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcSecond", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time__["V"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcSeconds", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time__["W"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeMinute", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time__["j"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeMinutes", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time__["k"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeHour", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeHours", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeDay", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeDays", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeWeek", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time__["B"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeWeeks", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time__["C"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeSunday", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time__["t"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeSundays", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time__["u"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeMonday", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time__["l"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeMondays", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time__["m"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeTuesday", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time__["x"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeTuesdays", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time__["y"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeWednesday", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time__["z"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeWednesdays", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time__["A"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeThursday", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time__["v"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeThursdays", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time__["w"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeFriday", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeFridays", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeSaturday", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time__["p"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeSaturdays", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time__["q"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeMonth", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time__["n"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeMonths", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time__["o"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeYear", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time__["D"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeYears", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time__["E"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcMinute", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time__["N"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcMinutes", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time__["O"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcHour", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time__["J"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcHours", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time__["K"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcDay", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time__["F"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcDays", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time__["G"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcWeek", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time__["_5"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcWeeks", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time__["_6"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcSunday", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time__["X"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcSundays", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time__["Y"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcMonday", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time__["P"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcMondays", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time__["Q"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcTuesday", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time__["_1"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcTuesdays", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time__["_2"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcWednesday", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time__["_3"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcWednesdays", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time__["_4"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcThursday", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time__["Z"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcThursdays", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time__["_0"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcFriday", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time__["H"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcFridays", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time__["I"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcSaturday", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time__["T"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcSaturdays", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time__["U"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcMonth", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time__["R"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcMonths", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time__["S"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcYear", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time__["_7"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcYears", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time__["_8"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_d3_time_format__ = __webpack_require__("./node_modules/d3-time-format/src/index.js");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeFormatDefaultLocale", function() { return __WEBPACK_IMPORTED_MODULE_27_d3_time_format__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeFormat", function() { return __WEBPACK_IMPORTED_MODULE_27_d3_time_format__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeParse", function() { return __WEBPACK_IMPORTED_MODULE_27_d3_time_format__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcFormat", function() { return __WEBPACK_IMPORTED_MODULE_27_d3_time_format__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utcParse", function() { return __WEBPACK_IMPORTED_MODULE_27_d3_time_format__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeFormatLocale", function() { return __WEBPACK_IMPORTED_MODULE_27_d3_time_format__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isoFormat", function() { return __WEBPACK_IMPORTED_MODULE_27_d3_time_format__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isoParse", function() { return __WEBPACK_IMPORTED_MODULE_27_d3_time_format__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_d3_timer__ = __webpack_require__("./node_modules/d3-timer/src/index.js");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "now", function() { return __WEBPACK_IMPORTED_MODULE_28_d3_timer__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timer", function() { return __WEBPACK_IMPORTED_MODULE_28_d3_timer__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timerFlush", function() { return __WEBPACK_IMPORTED_MODULE_28_d3_timer__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "timeout", function() { return __WEBPACK_IMPORTED_MODULE_28_d3_timer__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interval", function() { return __WEBPACK_IMPORTED_MODULE_28_d3_timer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_d3_transition__ = __webpack_require__("./node_modules/d3-transition/src/index.js");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "transition", function() { return __WEBPACK_IMPORTED_MODULE_29_d3_transition__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "active", function() { return __WEBPACK_IMPORTED_MODULE_29_d3_transition__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "interrupt", function() { return __WEBPACK_IMPORTED_MODULE_29_d3_transition__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_d3_voronoi__ = __webpack_require__("./node_modules/d3-voronoi/src/index.js");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "voronoi", function() { return __WEBPACK_IMPORTED_MODULE_30_d3_voronoi__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_d3_zoom__ = __webpack_require__("./node_modules/d3-zoom/src/index.js");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "zoom", function() { return __WEBPACK_IMPORTED_MODULE_31_d3_zoom__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "zoomTransform", function() { return __WEBPACK_IMPORTED_MODULE_31_d3_zoom__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "zoomIdentity", function() { return __WEBPACK_IMPORTED_MODULE_31_d3_zoom__["b"]; });


































/***/ }),

/***/ "./node_modules/deep-object-diff/dist/added/index.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__("./node_modules/deep-object-diff/dist/utils/index.js")], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module, exports, require('../utils'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports, global.utils);
    global.index = mod.exports;
  }
})(this, function (module, exports, _utils) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var addedDiff = function addedDiff(lhs, rhs) {

    if (lhs === rhs || !(0, _utils.isObject)(lhs) || !(0, _utils.isObject)(rhs)) return {};

    var l = (0, _utils.properObject)(lhs);
    var r = (0, _utils.properObject)(rhs);

    return Object.keys(r).reduce(function (acc, key) {
      if (l.hasOwnProperty(key)) {
        var difference = addedDiff(l[key], r[key]);

        if ((0, _utils.isObject)(difference) && (0, _utils.isEmpty)(difference)) return acc;

        return _extends({}, acc, _defineProperty({}, key, difference));
      }

      return _extends({}, acc, _defineProperty({}, key, r[key]));
    }, {});
  };

  exports.default = addedDiff;
  module.exports = exports['default'];
});

/***/ }),

/***/ "./node_modules/deep-object-diff/dist/deleted/index.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__("./node_modules/deep-object-diff/dist/utils/index.js")], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module, exports, require('../utils'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports, global.utils);
    global.index = mod.exports;
  }
})(this, function (module, exports, _utils) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var deletedDiff = function deletedDiff(lhs, rhs) {
    if (lhs === rhs || !(0, _utils.isObject)(lhs) || !(0, _utils.isObject)(rhs)) return {};

    var l = (0, _utils.properObject)(lhs);
    var r = (0, _utils.properObject)(rhs);

    return Object.keys(l).reduce(function (acc, key) {
      if (r.hasOwnProperty(key)) {
        var difference = deletedDiff(l[key], r[key]);

        if ((0, _utils.isObject)(difference) && (0, _utils.isEmpty)(difference)) return acc;

        return _extends({}, acc, _defineProperty({}, key, difference));
      }

      return _extends({}, acc, _defineProperty({}, key, undefined));
    }, {});
  };

  exports.default = deletedDiff;
  module.exports = exports['default'];
});

/***/ }),

/***/ "./node_modules/deep-object-diff/dist/detailed/index.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__("./node_modules/deep-object-diff/dist/added/index.js"), __webpack_require__("./node_modules/deep-object-diff/dist/deleted/index.js"), __webpack_require__("./node_modules/deep-object-diff/dist/updated/index.js")], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module, exports, require('../added'), require('../deleted'), require('../updated'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports, global.added, global.deleted, global.updated);
    global.index = mod.exports;
  }
})(this, function (module, exports, _added, _deleted, _updated) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _added2 = _interopRequireDefault(_added);

  var _deleted2 = _interopRequireDefault(_deleted);

  var _updated2 = _interopRequireDefault(_updated);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var detailedDiff = function detailedDiff(lhs, rhs) {
    return {
      added: (0, _added2.default)(lhs, rhs),
      deleted: (0, _deleted2.default)(lhs, rhs),
      updated: (0, _updated2.default)(lhs, rhs)
    };
  };

  exports.default = detailedDiff;
  module.exports = exports['default'];
});

/***/ }),

/***/ "./node_modules/deep-object-diff/dist/diff/index.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__("./node_modules/deep-object-diff/dist/utils/index.js")], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module, exports, require('../utils'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports, global.utils);
    global.index = mod.exports;
  }
})(this, function (module, exports, _utils) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var diff = function diff(lhs, rhs) {
    if (lhs === rhs) return {}; // equal return no diff

    if (!(0, _utils.isObject)(lhs) || !(0, _utils.isObject)(rhs)) return rhs; // return updated rhs

    var l = (0, _utils.properObject)(lhs);
    var r = (0, _utils.properObject)(rhs);

    var deletedValues = Object.keys(l).reduce(function (acc, key) {
      return r.hasOwnProperty(key) ? acc : _extends({}, acc, _defineProperty({}, key, undefined));
    }, {});

    if ((0, _utils.isDate)(l) || (0, _utils.isDate)(r)) {
      if (l.valueOf() == r.valueOf()) return {};
      return r;
    }

    return Object.keys(r).reduce(function (acc, key) {
      if (!l.hasOwnProperty(key)) return _extends({}, acc, _defineProperty({}, key, r[key])); // return added r key

      var difference = diff(l[key], r[key]);

      if ((0, _utils.isObject)(difference) && (0, _utils.isEmpty)(difference) && !(0, _utils.isDate)(difference)) return acc; // return no diff

      return _extends({}, acc, _defineProperty({}, key, difference)); // return updated key
    }, deletedValues);
  };

  exports.default = diff;
  module.exports = exports['default'];
});

/***/ }),

/***/ "./node_modules/deep-object-diff/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__("./node_modules/deep-object-diff/dist/diff/index.js"), __webpack_require__("./node_modules/deep-object-diff/dist/added/index.js"), __webpack_require__("./node_modules/deep-object-diff/dist/deleted/index.js"), __webpack_require__("./node_modules/deep-object-diff/dist/updated/index.js"), __webpack_require__("./node_modules/deep-object-diff/dist/detailed/index.js")], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./diff'), require('./added'), require('./deleted'), require('./updated'), require('./detailed'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.diff, global.added, global.deleted, global.updated, global.detailed);
    global.index = mod.exports;
  }
})(this, function (exports, _diff, _added, _deleted, _updated, _detailed) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.detailedDiff = exports.updatedDiff = exports.deletedDiff = exports.diff = exports.addedDiff = undefined;

  var _diff2 = _interopRequireDefault(_diff);

  var _added2 = _interopRequireDefault(_added);

  var _deleted2 = _interopRequireDefault(_deleted);

  var _updated2 = _interopRequireDefault(_updated);

  var _detailed2 = _interopRequireDefault(_detailed);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.addedDiff = _added2.default;
  exports.diff = _diff2.default;
  exports.deletedDiff = _deleted2.default;
  exports.updatedDiff = _updated2.default;
  exports.detailedDiff = _detailed2.default;
});

/***/ }),

/***/ "./node_modules/deep-object-diff/dist/updated/index.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__("./node_modules/deep-object-diff/dist/utils/index.js")], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module, exports, require('../utils'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports, global.utils);
    global.index = mod.exports;
  }
})(this, function (module, exports, _utils) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var updatedDiff = function updatedDiff(lhs, rhs) {

    if (lhs === rhs) return {};

    if (!(0, _utils.isObject)(lhs) || !(0, _utils.isObject)(rhs)) return rhs;

    var l = (0, _utils.properObject)(lhs);
    var r = (0, _utils.properObject)(rhs);

    if ((0, _utils.isDate)(l) || (0, _utils.isDate)(r)) {
      if (l.valueOf() == r.valueOf()) return {};
      return r;
    }

    return Object.keys(r).reduce(function (acc, key) {

      if (l.hasOwnProperty(key)) {
        var difference = updatedDiff(l[key], r[key]);

        if ((0, _utils.isObject)(difference) && (0, _utils.isEmpty)(difference) && !(0, _utils.isDate)(difference)) return acc;

        return _extends({}, acc, _defineProperty({}, key, difference));
      }

      return acc;
    }, {});
  };

  exports.default = updatedDiff;
  module.exports = exports['default'];
});

/***/ }),

/***/ "./node_modules/deep-object-diff/dist/utils/index.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.index = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };

  var isDate = exports.isDate = function isDate(d) {
    return d instanceof Date;
  };
  var isEmpty = exports.isEmpty = function isEmpty(o) {
    return Object.keys(o).length === 0;
  };
  var isObject = exports.isObject = function isObject(o) {
    return o != null && (typeof o === 'undefined' ? 'undefined' : _typeof(o)) === 'object';
  };
  var properObject = exports.properObject = function properObject(o) {
    return isObject(o) && !o.hasOwnProperty ? _extends({}, o) : o;
  };
});

/***/ }),

/***/ "./node_modules/dragula/classes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var cache = {};
var start = '(?:^|\\s)';
var end = '(?:\\s|$)';

function lookupClass (className) {
  var cached = cache[className];
  if (cached) {
    cached.lastIndex = 0;
  } else {
    cache[className] = cached = new RegExp(start + className + end, 'g');
  }
  return cached;
}

function addClass (el, className) {
  var current = el.className;
  if (!current.length) {
    el.className = className;
  } else if (!lookupClass(className).test(current)) {
    el.className += ' ' + className;
  }
}

function rmClass (el, className) {
  el.className = el.className.replace(lookupClass(className), ' ').trim();
}

module.exports = {
  add: addClass,
  rm: rmClass
};


/***/ }),

/***/ "./node_modules/dragula/dragula.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var emitter = __webpack_require__("./node_modules/contra/emitter.js");
var crossvent = __webpack_require__("./node_modules/crossvent/src/crossvent.js");
var classes = __webpack_require__("./node_modules/dragula/classes.js");
var doc = document;
var documentElement = doc.documentElement;

function dragula (initialContainers, options) {
  var len = arguments.length;
  if (len === 1 && Array.isArray(initialContainers) === false) {
    options = initialContainers;
    initialContainers = [];
  }
  var _mirror; // mirror image
  var _source; // source container
  var _item; // item being dragged
  var _offsetX; // reference x
  var _offsetY; // reference y
  var _moveX; // reference move x
  var _moveY; // reference move y
  var _initialSibling; // reference sibling when grabbed
  var _currentSibling; // reference sibling now
  var _copy; // item used for copying
  var _renderTimer; // timer for setTimeout renderMirrorImage
  var _lastDropTarget = null; // last container item was over
  var _grabbed; // holds mousedown context until first mousemove

  var o = options || {};
  if (o.moves === void 0) { o.moves = always; }
  if (o.accepts === void 0) { o.accepts = always; }
  if (o.invalid === void 0) { o.invalid = invalidTarget; }
  if (o.containers === void 0) { o.containers = initialContainers || []; }
  if (o.isContainer === void 0) { o.isContainer = never; }
  if (o.copy === void 0) { o.copy = false; }
  if (o.copySortSource === void 0) { o.copySortSource = false; }
  if (o.revertOnSpill === void 0) { o.revertOnSpill = false; }
  if (o.removeOnSpill === void 0) { o.removeOnSpill = false; }
  if (o.direction === void 0) { o.direction = 'vertical'; }
  if (o.ignoreInputTextSelection === void 0) { o.ignoreInputTextSelection = true; }
  if (o.mirrorContainer === void 0) { o.mirrorContainer = doc.body; }

  var drake = emitter({
    containers: o.containers,
    start: manualStart,
    end: end,
    cancel: cancel,
    remove: remove,
    destroy: destroy,
    canMove: canMove,
    dragging: false
  });

  if (o.removeOnSpill === true) {
    drake.on('over', spillOver).on('out', spillOut);
  }

  events();

  return drake;

  function isContainer (el) {
    return drake.containers.indexOf(el) !== -1 || o.isContainer(el);
  }

  function events (remove) {
    var op = remove ? 'remove' : 'add';
    touchy(documentElement, op, 'mousedown', grab);
    touchy(documentElement, op, 'mouseup', release);
  }

  function eventualMovements (remove) {
    var op = remove ? 'remove' : 'add';
    touchy(documentElement, op, 'mousemove', startBecauseMouseMoved);
  }

  function movements (remove) {
    var op = remove ? 'remove' : 'add';
    crossvent[op](documentElement, 'selectstart', preventGrabbed); // IE8
    crossvent[op](documentElement, 'click', preventGrabbed);
  }

  function destroy () {
    events(true);
    release({});
  }

  function preventGrabbed (e) {
    if (_grabbed) {
      e.preventDefault();
    }
  }

  function grab (e) {
    _moveX = e.clientX;
    _moveY = e.clientY;

    var ignore = whichMouseButton(e) !== 1 || e.metaKey || e.ctrlKey;
    if (ignore) {
      return; // we only care about honest-to-god left clicks and touch events
    }
    var item = e.target;
    var context = canStart(item);
    if (!context) {
      return;
    }
    _grabbed = context;
    eventualMovements();
    if (e.type === 'mousedown') {
      if (isInput(item)) { // see also: https://github.com/bevacqua/dragula/issues/208
        item.focus(); // fixes https://github.com/bevacqua/dragula/issues/176
      } else {
        e.preventDefault(); // fixes https://github.com/bevacqua/dragula/issues/155
      }
    }
  }

  function startBecauseMouseMoved (e) {
    if (!_grabbed) {
      return;
    }
    if (whichMouseButton(e) === 0) {
      release({});
      return; // when text is selected on an input and then dragged, mouseup doesn't fire. this is our only hope
    }
    // truthy check fixes #239, equality fixes #207
    if (e.clientX !== void 0 && e.clientX === _moveX && e.clientY !== void 0 && e.clientY === _moveY) {
      return;
    }
    if (o.ignoreInputTextSelection) {
      var clientX = getCoord('clientX', e);
      var clientY = getCoord('clientY', e);
      var elementBehindCursor = doc.elementFromPoint(clientX, clientY);
      if (isInput(elementBehindCursor)) {
        return;
      }
    }

    var grabbed = _grabbed; // call to end() unsets _grabbed
    eventualMovements(true);
    movements();
    end();
    start(grabbed);

    var offset = getOffset(_item);
    _offsetX = getCoord('pageX', e) - offset.left;
    _offsetY = getCoord('pageY', e) - offset.top;

    classes.add(_copy || _item, 'gu-transit');
    renderMirrorImage();
    drag(e);
  }

  function canStart (item) {
    if (drake.dragging && _mirror) {
      return;
    }
    if (isContainer(item)) {
      return; // don't drag container itself
    }
    var handle = item;
    while (getParent(item) && isContainer(getParent(item)) === false) {
      if (o.invalid(item, handle)) {
        return;
      }
      item = getParent(item); // drag target should be a top element
      if (!item) {
        return;
      }
    }
    var source = getParent(item);
    if (!source) {
      return;
    }
    if (o.invalid(item, handle)) {
      return;
    }

    var movable = o.moves(item, source, handle, nextEl(item));
    if (!movable) {
      return;
    }

    return {
      item: item,
      source: source
    };
  }

  function canMove (item) {
    return !!canStart(item);
  }

  function manualStart (item) {
    var context = canStart(item);
    if (context) {
      start(context);
    }
  }

  function start (context) {
    if (isCopy(context.item, context.source)) {
      _copy = context.item.cloneNode(true);
      drake.emit('cloned', _copy, context.item, 'copy');
    }

    _source = context.source;
    _item = context.item;
    _initialSibling = _currentSibling = nextEl(context.item);

    drake.dragging = true;
    drake.emit('drag', _item, _source);
  }

  function invalidTarget () {
    return false;
  }

  function end () {
    if (!drake.dragging) {
      return;
    }
    var item = _copy || _item;
    drop(item, getParent(item));
  }

  function ungrab () {
    _grabbed = false;
    eventualMovements(true);
    movements(true);
  }

  function release (e) {
    ungrab();

    if (!drake.dragging) {
      return;
    }
    var item = _copy || _item;
    var clientX = getCoord('clientX', e);
    var clientY = getCoord('clientY', e);
    var elementBehindCursor = getElementBehindPoint(_mirror, clientX, clientY);
    var dropTarget = findDropTarget(elementBehindCursor, clientX, clientY);
    if (dropTarget && ((_copy && o.copySortSource) || (!_copy || dropTarget !== _source))) {
      drop(item, dropTarget);
    } else if (o.removeOnSpill) {
      remove();
    } else {
      cancel();
    }
  }

  function drop (item, target) {
    var parent = getParent(item);
    if (_copy && o.copySortSource && target === _source) {
      parent.removeChild(_item);
    }
    if (isInitialPlacement(target)) {
      drake.emit('cancel', item, _source, _source);
    } else {
      drake.emit('drop', item, target, _source, _currentSibling);
    }
    cleanup();
  }

  function remove () {
    if (!drake.dragging) {
      return;
    }
    var item = _copy || _item;
    var parent = getParent(item);
    if (parent) {
      parent.removeChild(item);
    }
    drake.emit(_copy ? 'cancel' : 'remove', item, parent, _source);
    cleanup();
  }

  function cancel (revert) {
    if (!drake.dragging) {
      return;
    }
    var reverts = arguments.length > 0 ? revert : o.revertOnSpill;
    var item = _copy || _item;
    var parent = getParent(item);
    var initial = isInitialPlacement(parent);
    if (initial === false && reverts) {
      if (_copy) {
        if (parent) {
          parent.removeChild(_copy);
        }
      } else {
        _source.insertBefore(item, _initialSibling);
      }
    }
    if (initial || reverts) {
      drake.emit('cancel', item, _source, _source);
    } else {
      drake.emit('drop', item, parent, _source, _currentSibling);
    }
    cleanup();
  }

  function cleanup () {
    var item = _copy || _item;
    ungrab();
    removeMirrorImage();
    if (item) {
      classes.rm(item, 'gu-transit');
    }
    if (_renderTimer) {
      clearTimeout(_renderTimer);
    }
    drake.dragging = false;
    if (_lastDropTarget) {
      drake.emit('out', item, _lastDropTarget, _source);
    }
    drake.emit('dragend', item);
    _source = _item = _copy = _initialSibling = _currentSibling = _renderTimer = _lastDropTarget = null;
  }

  function isInitialPlacement (target, s) {
    var sibling;
    if (s !== void 0) {
      sibling = s;
    } else if (_mirror) {
      sibling = _currentSibling;
    } else {
      sibling = nextEl(_copy || _item);
    }
    return target === _source && sibling === _initialSibling;
  }

  function findDropTarget (elementBehindCursor, clientX, clientY) {
    var target = elementBehindCursor;
    while (target && !accepted()) {
      target = getParent(target);
    }
    return target;

    function accepted () {
      var droppable = isContainer(target);
      if (droppable === false) {
        return false;
      }

      var immediate = getImmediateChild(target, elementBehindCursor);
      var reference = getReference(target, immediate, clientX, clientY);
      var initial = isInitialPlacement(target, reference);
      if (initial) {
        return true; // should always be able to drop it right back where it was
      }
      return o.accepts(_item, target, _source, reference);
    }
  }

  function drag (e) {
    if (!_mirror) {
      return;
    }
    e.preventDefault();

    var clientX = getCoord('clientX', e);
    var clientY = getCoord('clientY', e);
    var x = clientX - _offsetX;
    var y = clientY - _offsetY;

    _mirror.style.left = x + 'px';
    _mirror.style.top = y + 'px';

    var item = _copy || _item;
    var elementBehindCursor = getElementBehindPoint(_mirror, clientX, clientY);
    var dropTarget = findDropTarget(elementBehindCursor, clientX, clientY);
    var changed = dropTarget !== null && dropTarget !== _lastDropTarget;
    if (changed || dropTarget === null) {
      out();
      _lastDropTarget = dropTarget;
      over();
    }
    var parent = getParent(item);
    if (dropTarget === _source && _copy && !o.copySortSource) {
      if (parent) {
        parent.removeChild(item);
      }
      return;
    }
    var reference;
    var immediate = getImmediateChild(dropTarget, elementBehindCursor);
    if (immediate !== null) {
      reference = getReference(dropTarget, immediate, clientX, clientY);
    } else if (o.revertOnSpill === true && !_copy) {
      reference = _initialSibling;
      dropTarget = _source;
    } else {
      if (_copy && parent) {
        parent.removeChild(item);
      }
      return;
    }
    if (
      (reference === null && changed) ||
      reference !== item &&
      reference !== nextEl(item)
    ) {
      _currentSibling = reference;
      dropTarget.insertBefore(item, reference);
      drake.emit('shadow', item, dropTarget, _source);
    }
    function moved (type) { drake.emit(type, item, _lastDropTarget, _source); }
    function over () { if (changed) { moved('over'); } }
    function out () { if (_lastDropTarget) { moved('out'); } }
  }

  function spillOver (el) {
    classes.rm(el, 'gu-hide');
  }

  function spillOut (el) {
    if (drake.dragging) { classes.add(el, 'gu-hide'); }
  }

  function renderMirrorImage () {
    if (_mirror) {
      return;
    }
    var rect = _item.getBoundingClientRect();
    _mirror = _item.cloneNode(true);
    _mirror.style.width = getRectWidth(rect) + 'px';
    _mirror.style.height = getRectHeight(rect) + 'px';
    classes.rm(_mirror, 'gu-transit');
    classes.add(_mirror, 'gu-mirror');
    o.mirrorContainer.appendChild(_mirror);
    touchy(documentElement, 'add', 'mousemove', drag);
    classes.add(o.mirrorContainer, 'gu-unselectable');
    drake.emit('cloned', _mirror, _item, 'mirror');
  }

  function removeMirrorImage () {
    if (_mirror) {
      classes.rm(o.mirrorContainer, 'gu-unselectable');
      touchy(documentElement, 'remove', 'mousemove', drag);
      getParent(_mirror).removeChild(_mirror);
      _mirror = null;
    }
  }

  function getImmediateChild (dropTarget, target) {
    var immediate = target;
    while (immediate !== dropTarget && getParent(immediate) !== dropTarget) {
      immediate = getParent(immediate);
    }
    if (immediate === documentElement) {
      return null;
    }
    return immediate;
  }

  function getReference (dropTarget, target, x, y) {
    var horizontal = o.direction === 'horizontal';
    var reference = target !== dropTarget ? inside() : outside();
    return reference;

    function outside () { // slower, but able to figure out any position
      var len = dropTarget.children.length;
      var i;
      var el;
      var rect;
      for (i = 0; i < len; i++) {
        el = dropTarget.children[i];
        rect = el.getBoundingClientRect();
        if (horizontal && (rect.left + rect.width / 2) > x) { return el; }
        if (!horizontal && (rect.top + rect.height / 2) > y) { return el; }
      }
      return null;
    }

    function inside () { // faster, but only available if dropped inside a child element
      var rect = target.getBoundingClientRect();
      if (horizontal) {
        return resolve(x > rect.left + getRectWidth(rect) / 2);
      }
      return resolve(y > rect.top + getRectHeight(rect) / 2);
    }

    function resolve (after) {
      return after ? nextEl(target) : target;
    }
  }

  function isCopy (item, container) {
    return typeof o.copy === 'boolean' ? o.copy : o.copy(item, container);
  }
}

function touchy (el, op, type, fn) {
  var touch = {
    mouseup: 'touchend',
    mousedown: 'touchstart',
    mousemove: 'touchmove'
  };
  var pointers = {
    mouseup: 'pointerup',
    mousedown: 'pointerdown',
    mousemove: 'pointermove'
  };
  var microsoft = {
    mouseup: 'MSPointerUp',
    mousedown: 'MSPointerDown',
    mousemove: 'MSPointerMove'
  };
  if (global.navigator.pointerEnabled) {
    crossvent[op](el, pointers[type], fn);
  } else if (global.navigator.msPointerEnabled) {
    crossvent[op](el, microsoft[type], fn);
  } else {
    crossvent[op](el, touch[type], fn);
    crossvent[op](el, type, fn);
  }
}

function whichMouseButton (e) {
  if (e.touches !== void 0) { return e.touches.length; }
  if (e.which !== void 0 && e.which !== 0) { return e.which; } // see https://github.com/bevacqua/dragula/issues/261
  if (e.buttons !== void 0) { return e.buttons; }
  var button = e.button;
  if (button !== void 0) { // see https://github.com/jquery/jquery/blob/99e8ff1baa7ae341e94bb89c3e84570c7c3ad9ea/src/event.js#L573-L575
    return button & 1 ? 1 : button & 2 ? 3 : (button & 4 ? 2 : 0);
  }
}

function getOffset (el) {
  var rect = el.getBoundingClientRect();
  return {
    left: rect.left + getScroll('scrollLeft', 'pageXOffset'),
    top: rect.top + getScroll('scrollTop', 'pageYOffset')
  };
}

function getScroll (scrollProp, offsetProp) {
  if (typeof global[offsetProp] !== 'undefined') {
    return global[offsetProp];
  }
  if (documentElement.clientHeight) {
    return documentElement[scrollProp];
  }
  return doc.body[scrollProp];
}

function getElementBehindPoint (point, x, y) {
  var p = point || {};
  var state = p.className;
  var el;
  p.className += ' gu-hide';
  el = doc.elementFromPoint(x, y);
  p.className = state;
  return el;
}

function never () { return false; }
function always () { return true; }
function getRectWidth (rect) { return rect.width || (rect.right - rect.left); }
function getRectHeight (rect) { return rect.height || (rect.bottom - rect.top); }
function getParent (el) { return el.parentNode === doc ? null : el.parentNode; }
function isInput (el) { return el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' || el.tagName === 'SELECT' || isEditable(el); }
function isEditable (el) {
  if (!el) { return false; } // no parents were editable
  if (el.contentEditable === 'false') { return false; } // stop the lookup
  if (el.contentEditable === 'true') { return true; } // found a contentEditable element in the chain
  return isEditable(getParent(el)); // contentEditable is set to 'inherit'
}

function nextEl (el) {
  return el.nextElementSibling || manually();
  function manually () {
    var sibling = el;
    do {
      sibling = sibling.nextSibling;
    } while (sibling && sibling.nodeType !== 1);
    return sibling;
  }
}

function getEventHost (e) {
  // on touchend event, we have to use `e.changedTouches`
  // see http://stackoverflow.com/questions/7192563/touchend-event-properties
  // see https://github.com/bevacqua/dragula/issues/34
  if (e.targetTouches && e.targetTouches.length) {
    return e.targetTouches[0];
  }
  if (e.changedTouches && e.changedTouches.length) {
    return e.changedTouches[0];
  }
  return e;
}

function getCoord (coord, e) {
  var host = getEventHost(e);
  var missMap = {
    pageX: 'clientX', // IE8
    pageY: 'clientY' // IE8
  };
  if (coord in missMap && !(coord in host) && missMap[coord] in host) {
    coord = missMap[coord];
  }
  return host[coord];
}

module.exports = dragula;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/dropzone/dist/dropzone.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery, module) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
 *
 * More info at [www.dropzonejs.com](http://www.dropzonejs.com)
 *
 * Copyright (c) 2012, Matias Meno
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *
 */

// The Emitter class provides the ability to call `.on()` on Dropzone to listen
// to events.
// It is strongly based on component's emitter class, and I removed the
// functionality because of the dependency hell with different frameworks.
var Emitter = function () {
  function Emitter() {
    _classCallCheck(this, Emitter);
  }

  _createClass(Emitter, [{
    key: "on",

    // Add an event listener for given event
    value: function on(event, fn) {
      this._callbacks = this._callbacks || {};
      // Create namespace for this event
      if (!this._callbacks[event]) {
        this._callbacks[event] = [];
      }
      this._callbacks[event].push(fn);
      return this;
    }
  }, {
    key: "emit",
    value: function emit(event) {
      this._callbacks = this._callbacks || {};
      var callbacks = this._callbacks[event];

      if (callbacks) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        for (var _iterator = callbacks, _isArray = true, _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
          var _ref;

          if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
          } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
          }

          var callback = _ref;

          callback.apply(this, args);
        }
      }

      return this;
    }

    // Remove event listener for given event. If fn is not provided, all event
    // listeners for that event will be removed. If neither is provided, all
    // event listeners will be removed.

  }, {
    key: "off",
    value: function off(event, fn) {
      if (!this._callbacks || arguments.length === 0) {
        this._callbacks = {};
        return this;
      }

      // specific event
      var callbacks = this._callbacks[event];
      if (!callbacks) {
        return this;
      }

      // remove all handlers
      if (arguments.length === 1) {
        delete this._callbacks[event];
        return this;
      }

      // remove specific handler
      for (var i = 0; i < callbacks.length; i++) {
        var callback = callbacks[i];
        if (callback === fn) {
          callbacks.splice(i, 1);
          break;
        }
      }

      return this;
    }
  }]);

  return Emitter;
}();

var Dropzone = function (_Emitter) {
  _inherits(Dropzone, _Emitter);

  _createClass(Dropzone, null, [{
    key: "initClass",
    value: function initClass() {

      // Exposing the emitter class, mainly for tests
      this.prototype.Emitter = Emitter;

      /*
       This is a list of all available events you can register on a dropzone object.
        You can register an event handler like this:
        dropzone.on("dragEnter", function() { });
        */
      this.prototype.events = ["drop", "dragstart", "dragend", "dragenter", "dragover", "dragleave", "addedfile", "addedfiles", "removedfile", "thumbnail", "error", "errormultiple", "processing", "processingmultiple", "uploadprogress", "totaluploadprogress", "sending", "sendingmultiple", "success", "successmultiple", "canceled", "canceledmultiple", "complete", "completemultiple", "reset", "maxfilesexceeded", "maxfilesreached", "queuecomplete"];

      this.prototype.defaultOptions = {
        /**
         * Has to be specified on elements other than form (or when the form
         * doesn't have an `action` attribute). You can also
         * provide a function that will be called with `files` and
         * must return the url (since `v3.12.0`)
         */
        url: null,

        /**
         * Can be changed to `"put"` if necessary. You can also provide a function
         * that will be called with `files` and must return the method (since `v3.12.0`).
         */
        method: "post",

        /**
         * Will be set on the XHRequest.
         */
        withCredentials: false,

        /**
         * The timeout for the XHR requests in milliseconds (since `v4.4.0`).
         */
        timeout: 30000,

        /**
         * How many file uploads to process in parallel (See the
         * Enqueuing file uploads* documentation section for more info)
         */
        parallelUploads: 2,

        /**
         * Whether to send multiple files in one request. If
         * this it set to true, then the fallback file input element will
         * have the `multiple` attribute as well. This option will
         * also trigger additional events (like `processingmultiple`). See the events
         * documentation section for more information.
         */
        uploadMultiple: false,

        /**
         * Whether you want files to be uploaded in chunks to your server. This can't be
         * used in combination with `uploadMultiple`.
         *
         * See [chunksUploaded](#config-chunksUploaded) for the callback to finalise an upload.
         */
        chunking: false,

        /**
         * If `chunking` is enabled, this defines whether **every** file should be chunked,
         * even if the file size is below chunkSize. This means, that the additional chunk
         * form data will be submitted and the `chunksUploaded` callback will be invoked.
         */
        forceChunking: false,

        /**
         * If `chunking` is `true`, then this defines the chunk size in bytes.
         */
        chunkSize: 2000000,

        /**
         * If `true`, the individual chunks of a file are being uploaded simultaneously.
         */
        parallelChunkUploads: false,

        /**
         * Whether a chunk should be retried if it fails.
         */
        retryChunks: false,

        /**
         * If `retryChunks` is true, how many times should it be retried.
         */
        retryChunksLimit: 3,

        /**
         * If not `null` defines how many files this Dropzone handles. If it exceeds,
         * the event `maxfilesexceeded` will be called. The dropzone element gets the
         * class `dz-max-files-reached` accordingly so you can provide visual feedback.
         */
        maxFilesize: 256,

        /**
         * The name of the file param that gets transferred.
         * **NOTE**: If you have the option  `uploadMultiple` set to `true`, then
         * Dropzone will append `[]` to the name.
         */
        paramName: "file",

        /**
         * Whether thumbnails for images should be generated
         */
        createImageThumbnails: true,

        /**
         * In MB. When the filename exceeds this limit, the thumbnail will not be generated.
         */
        maxThumbnailFilesize: 10,

        /**
         * If `null`, the ratio of the image will be used to calculate it.
         */
        thumbnailWidth: 120,

        /**
         * The same as `thumbnailWidth`. If both are null, images will not be resized.
         */
        thumbnailHeight: 120,

        /**
         * How the images should be scaled down in case both, `thumbnailWidth` and `thumbnailHeight` are provided.
         * Can be either `contain` or `crop`.
         */
        thumbnailMethod: 'crop',

        /**
         * If set, images will be resized to these dimensions before being **uploaded**.
         * If only one, `resizeWidth` **or** `resizeHeight` is provided, the original aspect
         * ratio of the file will be preserved.
         *
         * The `options.transformFile` function uses these options, so if the `transformFile` function
         * is overridden, these options don't do anything.
         */
        resizeWidth: null,

        /**
         * See `resizeWidth`.
         */
        resizeHeight: null,

        /**
         * The mime type of the resized image (before it gets uploaded to the server).
         * If `null` the original mime type will be used. To force jpeg, for example, use `image/jpeg`.
         * See `resizeWidth` for more information.
         */
        resizeMimeType: null,

        /**
         * The quality of the resized images. See `resizeWidth`.
         */
        resizeQuality: 0.8,

        /**
         * How the images should be scaled down in case both, `resizeWidth` and `resizeHeight` are provided.
         * Can be either `contain` or `crop`.
         */
        resizeMethod: 'contain',

        /**
         * The base that is used to calculate the filesize. You can change this to
         * 1024 if you would rather display kibibytes, mebibytes, etc...
         * 1024 is technically incorrect, because `1024 bytes` are `1 kibibyte` not `1 kilobyte`.
         * You can change this to `1024` if you don't care about validity.
         */
        filesizeBase: 1000,

        /**
         * Can be used to limit the maximum number of files that will be handled by this Dropzone
         */
        maxFiles: null,

        /**
         * An optional object to send additional headers to the server. Eg:
         * `{ "My-Awesome-Header": "header value" }`
         */
        headers: null,

        /**
         * If `true`, the dropzone element itself will be clickable, if `false`
         * nothing will be clickable.
         *
         * You can also pass an HTML element, a CSS selector (for multiple elements)
         * or an array of those. In that case, all of those elements will trigger an
         * upload when clicked.
         */
        clickable: true,

        /**
         * Whether hidden files in directories should be ignored.
         */
        ignoreHiddenFiles: true,

        /**
         * The default implementation of `accept` checks the file's mime type or
         * extension against this list. This is a comma separated list of mime
         * types or file extensions.
         *
         * Eg.: `image/*,application/pdf,.psd`
         *
         * If the Dropzone is `clickable` this option will also be used as
         * [`accept`](https://developer.mozilla.org/en-US/docs/HTML/Element/input#attr-accept)
         * parameter on the hidden file input as well.
         */
        acceptedFiles: null,

        /**
         * **Deprecated!**
         * Use acceptedFiles instead.
         */
        acceptedMimeTypes: null,

        /**
         * If false, files will be added to the queue but the queue will not be
         * processed automatically.
         * This can be useful if you need some additional user input before sending
         * files (or if you want want all files sent at once).
         * If you're ready to send the file simply call `myDropzone.processQueue()`.
         *
         * See the [enqueuing file uploads](#enqueuing-file-uploads) documentation
         * section for more information.
         */
        autoProcessQueue: true,

        /**
         * If false, files added to the dropzone will not be queued by default.
         * You'll have to call `enqueueFile(file)` manually.
         */
        autoQueue: true,

        /**
         * If `true`, this will add a link to every file preview to remove or cancel (if
         * already uploading) the file. The `dictCancelUpload`, `dictCancelUploadConfirmation`
         * and `dictRemoveFile` options are used for the wording.
         */
        addRemoveLinks: false,

        /**
         * Defines where to display the file previews – if `null` the
         * Dropzone element itself is used. Can be a plain `HTMLElement` or a CSS
         * selector. The element should have the `dropzone-previews` class so
         * the previews are displayed properly.
         */
        previewsContainer: null,

        /**
         * This is the element the hidden input field (which is used when clicking on the
         * dropzone to trigger file selection) will be appended to. This might
         * be important in case you use frameworks to switch the content of your page.
         */
        hiddenInputContainer: "body",

        /**
         * If null, no capture type will be specified
         * If camera, mobile devices will skip the file selection and choose camera
         * If microphone, mobile devices will skip the file selection and choose the microphone
         * If camcorder, mobile devices will skip the file selection and choose the camera in video mode
         * On apple devices multiple must be set to false.  AcceptedFiles may need to
         * be set to an appropriate mime type (e.g. "image/*", "audio/*", or "video/*").
         */
        capture: null,

        /**
         * **Deprecated**. Use `renameFile` instead.
         */
        renameFilename: null,

        /**
         * A function that is invoked before the file is uploaded to the server and renames the file.
         * This function gets the `File` as argument and can use the `file.name`. The actual name of the
         * file that gets used during the upload can be accessed through `file.upload.filename`.
         */
        renameFile: null,

        /**
         * If `true` the fallback will be forced. This is very useful to test your server
         * implementations first and make sure that everything works as
         * expected without dropzone if you experience problems, and to test
         * how your fallbacks will look.
         */
        forceFallback: false,

        /**
         * The text used before any files are dropped.
         */
        dictDefaultMessage: "Drop files here to upload",

        /**
         * The text that replaces the default message text it the browser is not supported.
         */
        dictFallbackMessage: "Your browser does not support drag'n'drop file uploads.",

        /**
         * The text that will be added before the fallback form.
         * If you provide a  fallback element yourself, or if this option is `null` this will
         * be ignored.
         */
        dictFallbackText: "Please use the fallback form below to upload your files like in the olden days.",

        /**
         * If the filesize is too big.
         * `{{filesize}}` and `{{maxFilesize}}` will be replaced with the respective configuration values.
         */
        dictFileTooBig: "File is too big ({{filesize}}MiB). Max filesize: {{maxFilesize}}MiB.",

        /**
         * If the file doesn't match the file type.
         */
        dictInvalidFileType: "You can't upload files of this type.",

        /**
         * If the server response was invalid.
         * `{{statusCode}}` will be replaced with the servers status code.
         */
        dictResponseError: "Server responded with {{statusCode}} code.",

        /**
         * If `addRemoveLinks` is true, the text to be used for the cancel upload link.
         */
        dictCancelUpload: "Cancel upload",

        /**
         * The text that is displayed if an upload was manually canceled
         */
        dictUploadCanceled: "Upload canceled.",

        /**
         * If `addRemoveLinks` is true, the text to be used for confirmation when cancelling upload.
         */
        dictCancelUploadConfirmation: "Are you sure you want to cancel this upload?",

        /**
         * If `addRemoveLinks` is true, the text to be used to remove a file.
         */
        dictRemoveFile: "Remove file",

        /**
         * If this is not null, then the user will be prompted before removing a file.
         */
        dictRemoveFileConfirmation: null,

        /**
         * Displayed if `maxFiles` is st and exceeded.
         * The string `{{maxFiles}}` will be replaced by the configuration value.
         */
        dictMaxFilesExceeded: "You can not upload any more files.",

        /**
         * Allows you to translate the different units. Starting with `tb` for terabytes and going down to
         * `b` for bytes.
         */
        dictFileSizeUnits: { tb: "TB", gb: "GB", mb: "MB", kb: "KB", b: "b" },
        /**
         * Called when dropzone initialized
         * You can add event listeners here
         */
        init: function init() {},


        /**
         * Can be an **object** of additional parameters to transfer to the server, **or** a `Function`
         * that gets invoked with the `files`, `xhr` and, if it's a chunked upload, `chunk` arguments. In case
         * of a function, this needs to return a map.
         *
         * The default implementation does nothing for normal uploads, but adds relevant information for
         * chunked uploads.
         *
         * This is the same as adding hidden input fields in the form element.
         */
        params: function params(files, xhr, chunk) {
          if (chunk) {
            return {
              dzuuid: chunk.file.upload.uuid,
              dzchunkindex: chunk.index,
              dztotalfilesize: chunk.file.size,
              dzchunksize: this.options.chunkSize,
              dztotalchunkcount: chunk.file.upload.totalChunkCount,
              dzchunkbyteoffset: chunk.index * this.options.chunkSize
            };
          }
        },


        /**
         * A function that gets a [file](https://developer.mozilla.org/en-US/docs/DOM/File)
         * and a `done` function as parameters.
         *
         * If the done function is invoked without arguments, the file is "accepted" and will
         * be processed. If you pass an error message, the file is rejected, and the error
         * message will be displayed.
         * This function will not be called if the file is too big or doesn't match the mime types.
         */
        accept: function accept(file, done) {
          return done();
        },


        /**
         * The callback that will be invoked when all chunks have been uploaded for a file.
         * It gets the file for which the chunks have been uploaded as the first parameter,
         * and the `done` function as second. `done()` needs to be invoked when everything
         * needed to finish the upload process is done.
         */
        chunksUploaded: function chunksUploaded(file, done) {
          done();
        },

        /**
         * Gets called when the browser is not supported.
         * The default implementation shows the fallback input field and adds
         * a text.
         */
        fallback: function fallback() {
          // This code should pass in IE7... :(
          var messageElement = void 0;
          this.element.className = this.element.className + " dz-browser-not-supported";

          for (var _iterator2 = this.element.getElementsByTagName("div"), _isArray2 = true, _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
            var _ref2;

            if (_isArray2) {
              if (_i2 >= _iterator2.length) break;
              _ref2 = _iterator2[_i2++];
            } else {
              _i2 = _iterator2.next();
              if (_i2.done) break;
              _ref2 = _i2.value;
            }

            var child = _ref2;

            if (/(^| )dz-message($| )/.test(child.className)) {
              messageElement = child;
              child.className = "dz-message"; // Removes the 'dz-default' class
              break;
            }
          }
          if (!messageElement) {
            messageElement = Dropzone.createElement("<div class=\"dz-message\"><span></span></div>");
            this.element.appendChild(messageElement);
          }

          var span = messageElement.getElementsByTagName("span")[0];
          if (span) {
            if (span.textContent != null) {
              span.textContent = this.options.dictFallbackMessage;
            } else if (span.innerText != null) {
              span.innerText = this.options.dictFallbackMessage;
            }
          }

          return this.element.appendChild(this.getFallbackForm());
        },


        /**
         * Gets called to calculate the thumbnail dimensions.
         *
         * It gets `file`, `width` and `height` (both may be `null`) as parameters and must return an object containing:
         *
         *  - `srcWidth` & `srcHeight` (required)
         *  - `trgWidth` & `trgHeight` (required)
         *  - `srcX` & `srcY` (optional, default `0`)
         *  - `trgX` & `trgY` (optional, default `0`)
         *
         * Those values are going to be used by `ctx.drawImage()`.
         */
        resize: function resize(file, width, height, resizeMethod) {
          var info = {
            srcX: 0,
            srcY: 0,
            srcWidth: file.width,
            srcHeight: file.height
          };

          var srcRatio = file.width / file.height;

          // Automatically calculate dimensions if not specified
          if (width == null && height == null) {
            width = info.srcWidth;
            height = info.srcHeight;
          } else if (width == null) {
            width = height * srcRatio;
          } else if (height == null) {
            height = width / srcRatio;
          }

          // Make sure images aren't upscaled
          width = Math.min(width, info.srcWidth);
          height = Math.min(height, info.srcHeight);

          var trgRatio = width / height;

          if (info.srcWidth > width || info.srcHeight > height) {
            // Image is bigger and needs rescaling
            if (resizeMethod === 'crop') {
              if (srcRatio > trgRatio) {
                info.srcHeight = file.height;
                info.srcWidth = info.srcHeight * trgRatio;
              } else {
                info.srcWidth = file.width;
                info.srcHeight = info.srcWidth / trgRatio;
              }
            } else if (resizeMethod === 'contain') {
              // Method 'contain'
              if (srcRatio > trgRatio) {
                height = width / srcRatio;
              } else {
                width = height * srcRatio;
              }
            } else {
              throw new Error("Unknown resizeMethod '" + resizeMethod + "'");
            }
          }

          info.srcX = (file.width - info.srcWidth) / 2;
          info.srcY = (file.height - info.srcHeight) / 2;

          info.trgWidth = width;
          info.trgHeight = height;

          return info;
        },


        /**
         * Can be used to transform the file (for example, resize an image if necessary).
         *
         * The default implementation uses `resizeWidth` and `resizeHeight` (if provided) and resizes
         * images according to those dimensions.
         *
         * Gets the `file` as the first parameter, and a `done()` function as the second, that needs
         * to be invoked with the file when the transformation is done.
         */
        transformFile: function transformFile(file, done) {
          if ((this.options.resizeWidth || this.options.resizeHeight) && file.type.match(/image.*/)) {
            return this.resizeImage(file, this.options.resizeWidth, this.options.resizeHeight, this.options.resizeMethod, done);
          } else {
            return done(file);
          }
        },


        /**
         * A string that contains the template used for each dropped
         * file. Change it to fulfill your needs but make sure to properly
         * provide all elements.
         *
         * If you want to use an actual HTML element instead of providing a String
         * as a config option, you could create a div with the id `tpl`,
         * put the template inside it and provide the element like this:
         *
         *     document
         *       .querySelector('#tpl')
         *       .innerHTML
         *
         */
        previewTemplate: "<div class=\"dz-preview dz-file-preview\">\n  <div class=\"dz-image\"><img data-dz-thumbnail /></div>\n  <div class=\"dz-details\">\n    <div class=\"dz-size\"><span data-dz-size></span></div>\n    <div class=\"dz-filename\"><span data-dz-name></span></div>\n  </div>\n  <div class=\"dz-progress\"><span class=\"dz-upload\" data-dz-uploadprogress></span></div>\n  <div class=\"dz-error-message\"><span data-dz-errormessage></span></div>\n  <div class=\"dz-success-mark\">\n    <svg width=\"54px\" height=\"54px\" viewBox=\"0 0 54 54\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns:sketch=\"http://www.bohemiancoding.com/sketch/ns\">\n      <title>Check</title>\n      <defs></defs>\n      <g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" sketch:type=\"MSPage\">\n        <path d=\"M23.5,31.8431458 L17.5852419,25.9283877 C16.0248253,24.3679711 13.4910294,24.366835 11.9289322,25.9289322 C10.3700136,27.4878508 10.3665912,30.0234455 11.9283877,31.5852419 L20.4147581,40.0716123 C20.5133999,40.1702541 20.6159315,40.2626649 20.7218615,40.3488435 C22.2835669,41.8725651 24.794234,41.8626202 26.3461564,40.3106978 L43.3106978,23.3461564 C44.8771021,21.7797521 44.8758057,19.2483887 43.3137085,17.6862915 C41.7547899,16.1273729 39.2176035,16.1255422 37.6538436,17.6893022 L23.5,31.8431458 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z\" id=\"Oval-2\" stroke-opacity=\"0.198794158\" stroke=\"#747474\" fill-opacity=\"0.816519475\" fill=\"#FFFFFF\" sketch:type=\"MSShapeGroup\"></path>\n      </g>\n    </svg>\n  </div>\n  <div class=\"dz-error-mark\">\n    <svg width=\"54px\" height=\"54px\" viewBox=\"0 0 54 54\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns:sketch=\"http://www.bohemiancoding.com/sketch/ns\">\n      <title>Error</title>\n      <defs></defs>\n      <g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" sketch:type=\"MSPage\">\n        <g id=\"Check-+-Oval-2\" sketch:type=\"MSLayerGroup\" stroke=\"#747474\" stroke-opacity=\"0.198794158\" fill=\"#FFFFFF\" fill-opacity=\"0.816519475\">\n          <path d=\"M32.6568542,29 L38.3106978,23.3461564 C39.8771021,21.7797521 39.8758057,19.2483887 38.3137085,17.6862915 C36.7547899,16.1273729 34.2176035,16.1255422 32.6538436,17.6893022 L27,23.3431458 L21.3461564,17.6893022 C19.7823965,16.1255422 17.2452101,16.1273729 15.6862915,17.6862915 C14.1241943,19.2483887 14.1228979,21.7797521 15.6893022,23.3461564 L21.3431458,29 L15.6893022,34.6538436 C14.1228979,36.2202479 14.1241943,38.7516113 15.6862915,40.3137085 C17.2452101,41.8726271 19.7823965,41.8744578 21.3461564,40.3106978 L27,34.6568542 L32.6538436,40.3106978 C34.2176035,41.8744578 36.7547899,41.8726271 38.3137085,40.3137085 C39.8758057,38.7516113 39.8771021,36.2202479 38.3106978,34.6538436 L32.6568542,29 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z\" id=\"Oval-2\" sketch:type=\"MSShapeGroup\"></path>\n        </g>\n      </g>\n    </svg>\n  </div>\n</div>",

        // END OPTIONS
        // (Required by the dropzone documentation parser)


        /*
         Those functions register themselves to the events on init and handle all
         the user interface specific stuff. Overwriting them won't break the upload
         but can break the way it's displayed.
         You can overwrite them if you don't like the default behavior. If you just
         want to add an additional event handler, register it on the dropzone object
         and don't overwrite those options.
         */

        // Those are self explanatory and simply concern the DragnDrop.
        drop: function drop(e) {
          return this.element.classList.remove("dz-drag-hover");
        },
        dragstart: function dragstart(e) {},
        dragend: function dragend(e) {
          return this.element.classList.remove("dz-drag-hover");
        },
        dragenter: function dragenter(e) {
          return this.element.classList.add("dz-drag-hover");
        },
        dragover: function dragover(e) {
          return this.element.classList.add("dz-drag-hover");
        },
        dragleave: function dragleave(e) {
          return this.element.classList.remove("dz-drag-hover");
        },
        paste: function paste(e) {},


        // Called whenever there are no files left in the dropzone anymore, and the
        // dropzone should be displayed as if in the initial state.
        reset: function reset() {
          return this.element.classList.remove("dz-started");
        },


        // Called when a file is added to the queue
        // Receives `file`
        addedfile: function addedfile(file) {
          var _this2 = this;

          if (this.element === this.previewsContainer) {
            this.element.classList.add("dz-started");
          }

          if (this.previewsContainer) {
            file.previewElement = Dropzone.createElement(this.options.previewTemplate.trim());
            file.previewTemplate = file.previewElement; // Backwards compatibility

            this.previewsContainer.appendChild(file.previewElement);
            for (var _iterator3 = file.previewElement.querySelectorAll("[data-dz-name]"), _isArray3 = true, _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
              var _ref3;

              if (_isArray3) {
                if (_i3 >= _iterator3.length) break;
                _ref3 = _iterator3[_i3++];
              } else {
                _i3 = _iterator3.next();
                if (_i3.done) break;
                _ref3 = _i3.value;
              }

              var node = _ref3;

              node.textContent = file.name;
            }
            for (var _iterator4 = file.previewElement.querySelectorAll("[data-dz-size]"), _isArray4 = true, _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
              if (_isArray4) {
                if (_i4 >= _iterator4.length) break;
                node = _iterator4[_i4++];
              } else {
                _i4 = _iterator4.next();
                if (_i4.done) break;
                node = _i4.value;
              }

              node.innerHTML = this.filesize(file.size);
            }

            if (this.options.addRemoveLinks) {
              file._removeLink = Dropzone.createElement("<a class=\"dz-remove\" href=\"javascript:undefined;\" data-dz-remove>" + this.options.dictRemoveFile + "</a>");
              file.previewElement.appendChild(file._removeLink);
            }

            var removeFileEvent = function removeFileEvent(e) {
              e.preventDefault();
              e.stopPropagation();
              if (file.status === Dropzone.UPLOADING) {
                return Dropzone.confirm(_this2.options.dictCancelUploadConfirmation, function () {
                  return _this2.removeFile(file);
                });
              } else {
                if (_this2.options.dictRemoveFileConfirmation) {
                  return Dropzone.confirm(_this2.options.dictRemoveFileConfirmation, function () {
                    return _this2.removeFile(file);
                  });
                } else {
                  return _this2.removeFile(file);
                }
              }
            };

            for (var _iterator5 = file.previewElement.querySelectorAll("[data-dz-remove]"), _isArray5 = true, _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _iterator5[Symbol.iterator]();;) {
              var _ref4;

              if (_isArray5) {
                if (_i5 >= _iterator5.length) break;
                _ref4 = _iterator5[_i5++];
              } else {
                _i5 = _iterator5.next();
                if (_i5.done) break;
                _ref4 = _i5.value;
              }

              var removeLink = _ref4;

              removeLink.addEventListener("click", removeFileEvent);
            }
          }
        },


        // Called whenever a file is removed.
        removedfile: function removedfile(file) {
          if (file.previewElement != null && file.previewElement.parentNode != null) {
            file.previewElement.parentNode.removeChild(file.previewElement);
          }
          return this._updateMaxFilesReachedClass();
        },


        // Called when a thumbnail has been generated
        // Receives `file` and `dataUrl`
        thumbnail: function thumbnail(file, dataUrl) {
          if (file.previewElement) {
            file.previewElement.classList.remove("dz-file-preview");
            for (var _iterator6 = file.previewElement.querySelectorAll("[data-dz-thumbnail]"), _isArray6 = true, _i6 = 0, _iterator6 = _isArray6 ? _iterator6 : _iterator6[Symbol.iterator]();;) {
              var _ref5;

              if (_isArray6) {
                if (_i6 >= _iterator6.length) break;
                _ref5 = _iterator6[_i6++];
              } else {
                _i6 = _iterator6.next();
                if (_i6.done) break;
                _ref5 = _i6.value;
              }

              var thumbnailElement = _ref5;

              thumbnailElement.alt = file.name;
              thumbnailElement.src = dataUrl;
            }

            return setTimeout(function () {
              return file.previewElement.classList.add("dz-image-preview");
            }, 1);
          }
        },


        // Called whenever an error occurs
        // Receives `file` and `message`
        error: function error(file, message) {
          if (file.previewElement) {
            file.previewElement.classList.add("dz-error");
            if (typeof message !== "String" && message.error) {
              message = message.error;
            }
            for (var _iterator7 = file.previewElement.querySelectorAll("[data-dz-errormessage]"), _isArray7 = true, _i7 = 0, _iterator7 = _isArray7 ? _iterator7 : _iterator7[Symbol.iterator]();;) {
              var _ref6;

              if (_isArray7) {
                if (_i7 >= _iterator7.length) break;
                _ref6 = _iterator7[_i7++];
              } else {
                _i7 = _iterator7.next();
                if (_i7.done) break;
                _ref6 = _i7.value;
              }

              var node = _ref6;

              node.textContent = message;
            }
          }
        },
        errormultiple: function errormultiple() {},


        // Called when a file gets processed. Since there is a cue, not all added
        // files are processed immediately.
        // Receives `file`
        processing: function processing(file) {
          if (file.previewElement) {
            file.previewElement.classList.add("dz-processing");
            if (file._removeLink) {
              return file._removeLink.textContent = this.options.dictCancelUpload;
            }
          }
        },
        processingmultiple: function processingmultiple() {},


        // Called whenever the upload progress gets updated.
        // Receives `file`, `progress` (percentage 0-100) and `bytesSent`.
        // To get the total number of bytes of the file, use `file.size`
        uploadprogress: function uploadprogress(file, progress, bytesSent) {
          if (file.previewElement) {
            for (var _iterator8 = file.previewElement.querySelectorAll("[data-dz-uploadprogress]"), _isArray8 = true, _i8 = 0, _iterator8 = _isArray8 ? _iterator8 : _iterator8[Symbol.iterator]();;) {
              var _ref7;

              if (_isArray8) {
                if (_i8 >= _iterator8.length) break;
                _ref7 = _iterator8[_i8++];
              } else {
                _i8 = _iterator8.next();
                if (_i8.done) break;
                _ref7 = _i8.value;
              }

              var node = _ref7;

              node.nodeName === 'PROGRESS' ? node.value = progress : node.style.width = progress + "%";
            }
          }
        },


        // Called whenever the total upload progress gets updated.
        // Called with totalUploadProgress (0-100), totalBytes and totalBytesSent
        totaluploadprogress: function totaluploadprogress() {},


        // Called just before the file is sent. Gets the `xhr` object as second
        // parameter, so you can modify it (for example to add a CSRF token) and a
        // `formData` object to add additional information.
        sending: function sending() {},
        sendingmultiple: function sendingmultiple() {},


        // When the complete upload is finished and successful
        // Receives `file`
        success: function success(file) {
          if (file.previewElement) {
            return file.previewElement.classList.add("dz-success");
          }
        },
        successmultiple: function successmultiple() {},


        // When the upload is canceled.
        canceled: function canceled(file) {
          return this.emit("error", file, this.options.dictUploadCanceled);
        },
        canceledmultiple: function canceledmultiple() {},


        // When the upload is finished, either with success or an error.
        // Receives `file`
        complete: function complete(file) {
          if (file._removeLink) {
            file._removeLink.textContent = this.options.dictRemoveFile;
          }
          if (file.previewElement) {
            return file.previewElement.classList.add("dz-complete");
          }
        },
        completemultiple: function completemultiple() {},
        maxfilesexceeded: function maxfilesexceeded() {},
        maxfilesreached: function maxfilesreached() {},
        queuecomplete: function queuecomplete() {},
        addedfiles: function addedfiles() {}
      };

      this.prototype._thumbnailQueue = [];
      this.prototype._processingThumbnail = false;
    }

    // global utility

  }, {
    key: "extend",
    value: function extend(target) {
      for (var _len2 = arguments.length, objects = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        objects[_key2 - 1] = arguments[_key2];
      }

      for (var _iterator9 = objects, _isArray9 = true, _i9 = 0, _iterator9 = _isArray9 ? _iterator9 : _iterator9[Symbol.iterator]();;) {
        var _ref8;

        if (_isArray9) {
          if (_i9 >= _iterator9.length) break;
          _ref8 = _iterator9[_i9++];
        } else {
          _i9 = _iterator9.next();
          if (_i9.done) break;
          _ref8 = _i9.value;
        }

        var object = _ref8;

        for (var key in object) {
          var val = object[key];
          target[key] = val;
        }
      }
      return target;
    }
  }]);

  function Dropzone(el, options) {
    _classCallCheck(this, Dropzone);

    var _this = _possibleConstructorReturn(this, (Dropzone.__proto__ || Object.getPrototypeOf(Dropzone)).call(this));

    var fallback = void 0,
        left = void 0;
    _this.element = el;
    // For backwards compatibility since the version was in the prototype previously
    _this.version = Dropzone.version;

    _this.defaultOptions.previewTemplate = _this.defaultOptions.previewTemplate.replace(/\n*/g, "");

    _this.clickableElements = [];
    _this.listeners = [];
    _this.files = []; // All files

    if (typeof _this.element === "string") {
      _this.element = document.querySelector(_this.element);
    }

    // Not checking if instance of HTMLElement or Element since IE9 is extremely weird.
    if (!_this.element || _this.element.nodeType == null) {
      throw new Error("Invalid dropzone element.");
    }

    if (_this.element.dropzone) {
      throw new Error("Dropzone already attached.");
    }

    // Now add this dropzone to the instances.
    Dropzone.instances.push(_this);

    // Put the dropzone inside the element itself.
    _this.element.dropzone = _this;

    var elementOptions = (left = Dropzone.optionsForElement(_this.element)) != null ? left : {};

    _this.options = Dropzone.extend({}, _this.defaultOptions, elementOptions, options != null ? options : {});

    // If the browser failed, just call the fallback and leave
    if (_this.options.forceFallback || !Dropzone.isBrowserSupported()) {
      var _ret;

      return _ret = _this.options.fallback.call(_this), _possibleConstructorReturn(_this, _ret);
    }

    // @options.url = @element.getAttribute "action" unless @options.url?
    if (_this.options.url == null) {
      _this.options.url = _this.element.getAttribute("action");
    }

    if (!_this.options.url) {
      throw new Error("No URL provided.");
    }

    if (_this.options.acceptedFiles && _this.options.acceptedMimeTypes) {
      throw new Error("You can't provide both 'acceptedFiles' and 'acceptedMimeTypes'. 'acceptedMimeTypes' is deprecated.");
    }

    if (_this.options.uploadMultiple && _this.options.chunking) {
      throw new Error('You cannot set both: uploadMultiple and chunking.');
    }

    // Backwards compatibility
    if (_this.options.acceptedMimeTypes) {
      _this.options.acceptedFiles = _this.options.acceptedMimeTypes;
      delete _this.options.acceptedMimeTypes;
    }

    // Backwards compatibility
    if (_this.options.renameFilename != null) {
      _this.options.renameFile = function (file) {
        return _this.options.renameFilename.call(_this, file.name, file);
      };
    }

    _this.options.method = _this.options.method.toUpperCase();

    if ((fallback = _this.getExistingFallback()) && fallback.parentNode) {
      // Remove the fallback
      fallback.parentNode.removeChild(fallback);
    }

    // Display previews in the previewsContainer element or the Dropzone element unless explicitly set to false
    if (_this.options.previewsContainer !== false) {
      if (_this.options.previewsContainer) {
        _this.previewsContainer = Dropzone.getElement(_this.options.previewsContainer, "previewsContainer");
      } else {
        _this.previewsContainer = _this.element;
      }
    }

    if (_this.options.clickable) {
      if (_this.options.clickable === true) {
        _this.clickableElements = [_this.element];
      } else {
        _this.clickableElements = Dropzone.getElements(_this.options.clickable, "clickable");
      }
    }

    _this.init();
    return _this;
  }

  // Returns all files that have been accepted


  _createClass(Dropzone, [{
    key: "getAcceptedFiles",
    value: function getAcceptedFiles() {
      return this.files.filter(function (file) {
        return file.accepted;
      }).map(function (file) {
        return file;
      });
    }

    // Returns all files that have been rejected
    // Not sure when that's going to be useful, but added for completeness.

  }, {
    key: "getRejectedFiles",
    value: function getRejectedFiles() {
      return this.files.filter(function (file) {
        return !file.accepted;
      }).map(function (file) {
        return file;
      });
    }
  }, {
    key: "getFilesWithStatus",
    value: function getFilesWithStatus(status) {
      return this.files.filter(function (file) {
        return file.status === status;
      }).map(function (file) {
        return file;
      });
    }

    // Returns all files that are in the queue

  }, {
    key: "getQueuedFiles",
    value: function getQueuedFiles() {
      return this.getFilesWithStatus(Dropzone.QUEUED);
    }
  }, {
    key: "getUploadingFiles",
    value: function getUploadingFiles() {
      return this.getFilesWithStatus(Dropzone.UPLOADING);
    }
  }, {
    key: "getAddedFiles",
    value: function getAddedFiles() {
      return this.getFilesWithStatus(Dropzone.ADDED);
    }

    // Files that are either queued or uploading

  }, {
    key: "getActiveFiles",
    value: function getActiveFiles() {
      return this.files.filter(function (file) {
        return file.status === Dropzone.UPLOADING || file.status === Dropzone.QUEUED;
      }).map(function (file) {
        return file;
      });
    }

    // The function that gets called when Dropzone is initialized. You
    // can (and should) setup event listeners inside this function.

  }, {
    key: "init",
    value: function init() {
      var _this3 = this;

      // In case it isn't set already
      if (this.element.tagName === "form") {
        this.element.setAttribute("enctype", "multipart/form-data");
      }

      if (this.element.classList.contains("dropzone") && !this.element.querySelector(".dz-message")) {
        this.element.appendChild(Dropzone.createElement("<div class=\"dz-default dz-message\"><span>" + this.options.dictDefaultMessage + "</span></div>"));
      }

      if (this.clickableElements.length) {
        var setupHiddenFileInput = function setupHiddenFileInput() {
          if (_this3.hiddenFileInput) {
            _this3.hiddenFileInput.parentNode.removeChild(_this3.hiddenFileInput);
          }
          _this3.hiddenFileInput = document.createElement("input");
          _this3.hiddenFileInput.setAttribute("type", "file");
          if (_this3.options.maxFiles === null || _this3.options.maxFiles > 1) {
            _this3.hiddenFileInput.setAttribute("multiple", "multiple");
          }
          _this3.hiddenFileInput.className = "dz-hidden-input";

          if (_this3.options.acceptedFiles !== null) {
            _this3.hiddenFileInput.setAttribute("accept", _this3.options.acceptedFiles);
          }
          if (_this3.options.capture !== null) {
            _this3.hiddenFileInput.setAttribute("capture", _this3.options.capture);
          }

          // Not setting `display="none"` because some browsers don't accept clicks
          // on elements that aren't displayed.
          _this3.hiddenFileInput.style.visibility = "hidden";
          _this3.hiddenFileInput.style.position = "absolute";
          _this3.hiddenFileInput.style.top = "0";
          _this3.hiddenFileInput.style.left = "0";
          _this3.hiddenFileInput.style.height = "0";
          _this3.hiddenFileInput.style.width = "0";
          document.querySelector(_this3.options.hiddenInputContainer).appendChild(_this3.hiddenFileInput);
          return _this3.hiddenFileInput.addEventListener("change", function () {
            var files = _this3.hiddenFileInput.files;

            if (files.length) {
              for (var _iterator10 = files, _isArray10 = true, _i10 = 0, _iterator10 = _isArray10 ? _iterator10 : _iterator10[Symbol.iterator]();;) {
                var _ref9;

                if (_isArray10) {
                  if (_i10 >= _iterator10.length) break;
                  _ref9 = _iterator10[_i10++];
                } else {
                  _i10 = _iterator10.next();
                  if (_i10.done) break;
                  _ref9 = _i10.value;
                }

                var file = _ref9;

                _this3.addFile(file);
              }
            }
            _this3.emit("addedfiles", files);
            return setupHiddenFileInput();
          });
        };
        setupHiddenFileInput();
      }

      this.URL = window.URL !== null ? window.URL : window.webkitURL;

      // Setup all event listeners on the Dropzone object itself.
      // They're not in @setupEventListeners() because they shouldn't be removed
      // again when the dropzone gets disabled.
      for (var _iterator11 = this.events, _isArray11 = true, _i11 = 0, _iterator11 = _isArray11 ? _iterator11 : _iterator11[Symbol.iterator]();;) {
        var _ref10;

        if (_isArray11) {
          if (_i11 >= _iterator11.length) break;
          _ref10 = _iterator11[_i11++];
        } else {
          _i11 = _iterator11.next();
          if (_i11.done) break;
          _ref10 = _i11.value;
        }

        var eventName = _ref10;

        this.on(eventName, this.options[eventName]);
      }

      this.on("uploadprogress", function () {
        return _this3.updateTotalUploadProgress();
      });

      this.on("removedfile", function () {
        return _this3.updateTotalUploadProgress();
      });

      this.on("canceled", function (file) {
        return _this3.emit("complete", file);
      });

      // Emit a `queuecomplete` event if all files finished uploading.
      this.on("complete", function (file) {
        if (_this3.getAddedFiles().length === 0 && _this3.getUploadingFiles().length === 0 && _this3.getQueuedFiles().length === 0) {
          // This needs to be deferred so that `queuecomplete` really triggers after `complete`
          return setTimeout(function () {
            return _this3.emit("queuecomplete");
          }, 0);
        }
      });

      var noPropagation = function noPropagation(e) {
        e.stopPropagation();
        if (e.preventDefault) {
          return e.preventDefault();
        } else {
          return e.returnValue = false;
        }
      };

      // Create the listeners
      this.listeners = [{
        element: this.element,
        events: {
          "dragstart": function dragstart(e) {
            return _this3.emit("dragstart", e);
          },
          "dragenter": function dragenter(e) {
            noPropagation(e);
            return _this3.emit("dragenter", e);
          },
          "dragover": function dragover(e) {
            // Makes it possible to drag files from chrome's download bar
            // http://stackoverflow.com/questions/19526430/drag-and-drop-file-uploads-from-chrome-downloads-bar
            // Try is required to prevent bug in Internet Explorer 11 (SCRIPT65535 exception)
            var efct = void 0;
            try {
              efct = e.dataTransfer.effectAllowed;
            } catch (error) {}
            e.dataTransfer.dropEffect = 'move' === efct || 'linkMove' === efct ? 'move' : 'copy';

            noPropagation(e);
            return _this3.emit("dragover", e);
          },
          "dragleave": function dragleave(e) {
            return _this3.emit("dragleave", e);
          },
          "drop": function drop(e) {
            noPropagation(e);
            return _this3.drop(e);
          },
          "dragend": function dragend(e) {
            return _this3.emit("dragend", e);
          }

          // This is disabled right now, because the browsers don't implement it properly.
          // "paste": (e) =>
          //   noPropagation e
          //   @paste e
        } }];

      this.clickableElements.forEach(function (clickableElement) {
        return _this3.listeners.push({
          element: clickableElement,
          events: {
            "click": function click(evt) {
              // Only the actual dropzone or the message element should trigger file selection
              if (clickableElement !== _this3.element || evt.target === _this3.element || Dropzone.elementInside(evt.target, _this3.element.querySelector(".dz-message"))) {
                _this3.hiddenFileInput.click(); // Forward the click
              }
              return true;
            }
          }
        });
      });

      this.enable();

      return this.options.init.call(this);
    }

    // Not fully tested yet

  }, {
    key: "destroy",
    value: function destroy() {
      this.disable();
      this.removeAllFiles(true);
      if (this.hiddenFileInput != null ? this.hiddenFileInput.parentNode : undefined) {
        this.hiddenFileInput.parentNode.removeChild(this.hiddenFileInput);
        this.hiddenFileInput = null;
      }
      delete this.element.dropzone;
      return Dropzone.instances.splice(Dropzone.instances.indexOf(this), 1);
    }
  }, {
    key: "updateTotalUploadProgress",
    value: function updateTotalUploadProgress() {
      var totalUploadProgress = void 0;
      var totalBytesSent = 0;
      var totalBytes = 0;

      var activeFiles = this.getActiveFiles();

      if (activeFiles.length) {
        for (var _iterator12 = this.getActiveFiles(), _isArray12 = true, _i12 = 0, _iterator12 = _isArray12 ? _iterator12 : _iterator12[Symbol.iterator]();;) {
          var _ref11;

          if (_isArray12) {
            if (_i12 >= _iterator12.length) break;
            _ref11 = _iterator12[_i12++];
          } else {
            _i12 = _iterator12.next();
            if (_i12.done) break;
            _ref11 = _i12.value;
          }

          var file = _ref11;

          totalBytesSent += file.upload.bytesSent;
          totalBytes += file.upload.total;
        }
        totalUploadProgress = 100 * totalBytesSent / totalBytes;
      } else {
        totalUploadProgress = 100;
      }

      return this.emit("totaluploadprogress", totalUploadProgress, totalBytes, totalBytesSent);
    }

    // @options.paramName can be a function taking one parameter rather than a string.
    // A parameter name for a file is obtained simply by calling this with an index number.

  }, {
    key: "_getParamName",
    value: function _getParamName(n) {
      if (typeof this.options.paramName === "function") {
        return this.options.paramName(n);
      } else {
        return "" + this.options.paramName + (this.options.uploadMultiple ? "[" + n + "]" : "");
      }
    }

    // If @options.renameFile is a function,
    // the function will be used to rename the file.name before appending it to the formData

  }, {
    key: "_renameFile",
    value: function _renameFile(file) {
      if (typeof this.options.renameFile !== "function") {
        return file.name;
      }
      return this.options.renameFile(file);
    }

    // Returns a form that can be used as fallback if the browser does not support DragnDrop
    //
    // If the dropzone is already a form, only the input field and button are returned. Otherwise a complete form element is provided.
    // This code has to pass in IE7 :(

  }, {
    key: "getFallbackForm",
    value: function getFallbackForm() {
      var existingFallback = void 0,
          form = void 0;
      if (existingFallback = this.getExistingFallback()) {
        return existingFallback;
      }

      var fieldsString = "<div class=\"dz-fallback\">";
      if (this.options.dictFallbackText) {
        fieldsString += "<p>" + this.options.dictFallbackText + "</p>";
      }
      fieldsString += "<input type=\"file\" name=\"" + this._getParamName(0) + "\" " + (this.options.uploadMultiple ? 'multiple="multiple"' : undefined) + " /><input type=\"submit\" value=\"Upload!\"></div>";

      var fields = Dropzone.createElement(fieldsString);
      if (this.element.tagName !== "FORM") {
        form = Dropzone.createElement("<form action=\"" + this.options.url + "\" enctype=\"multipart/form-data\" method=\"" + this.options.method + "\"></form>");
        form.appendChild(fields);
      } else {
        // Make sure that the enctype and method attributes are set properly
        this.element.setAttribute("enctype", "multipart/form-data");
        this.element.setAttribute("method", this.options.method);
      }
      return form != null ? form : fields;
    }

    // Returns the fallback elements if they exist already
    //
    // This code has to pass in IE7 :(

  }, {
    key: "getExistingFallback",
    value: function getExistingFallback() {
      var getFallback = function getFallback(elements) {
        for (var _iterator13 = elements, _isArray13 = true, _i13 = 0, _iterator13 = _isArray13 ? _iterator13 : _iterator13[Symbol.iterator]();;) {
          var _ref12;

          if (_isArray13) {
            if (_i13 >= _iterator13.length) break;
            _ref12 = _iterator13[_i13++];
          } else {
            _i13 = _iterator13.next();
            if (_i13.done) break;
            _ref12 = _i13.value;
          }

          var el = _ref12;

          if (/(^| )fallback($| )/.test(el.className)) {
            return el;
          }
        }
      };

      var _arr = ["div", "form"];
      for (var _i14 = 0; _i14 < _arr.length; _i14++) {
        var tagName = _arr[_i14];
        var fallback;
        if (fallback = getFallback(this.element.getElementsByTagName(tagName))) {
          return fallback;
        }
      }
    }

    // Activates all listeners stored in @listeners

  }, {
    key: "setupEventListeners",
    value: function setupEventListeners() {
      return this.listeners.map(function (elementListeners) {
        return function () {
          var result = [];
          for (var event in elementListeners.events) {
            var listener = elementListeners.events[event];
            result.push(elementListeners.element.addEventListener(event, listener, false));
          }
          return result;
        }();
      });
    }

    // Deactivates all listeners stored in @listeners

  }, {
    key: "removeEventListeners",
    value: function removeEventListeners() {
      return this.listeners.map(function (elementListeners) {
        return function () {
          var result = [];
          for (var event in elementListeners.events) {
            var listener = elementListeners.events[event];
            result.push(elementListeners.element.removeEventListener(event, listener, false));
          }
          return result;
        }();
      });
    }

    // Removes all event listeners and cancels all files in the queue or being processed.

  }, {
    key: "disable",
    value: function disable() {
      var _this4 = this;

      this.clickableElements.forEach(function (element) {
        return element.classList.remove("dz-clickable");
      });
      this.removeEventListeners();
      this.disabled = true;

      return this.files.map(function (file) {
        return _this4.cancelUpload(file);
      });
    }
  }, {
    key: "enable",
    value: function enable() {
      delete this.disabled;
      this.clickableElements.forEach(function (element) {
        return element.classList.add("dz-clickable");
      });
      return this.setupEventListeners();
    }

    // Returns a nicely formatted filesize

  }, {
    key: "filesize",
    value: function filesize(size) {
      var selectedSize = 0;
      var selectedUnit = "b";

      if (size > 0) {
        var units = ['tb', 'gb', 'mb', 'kb', 'b'];

        for (var i = 0; i < units.length; i++) {
          var unit = units[i];
          var cutoff = Math.pow(this.options.filesizeBase, 4 - i) / 10;

          if (size >= cutoff) {
            selectedSize = size / Math.pow(this.options.filesizeBase, 4 - i);
            selectedUnit = unit;
            break;
          }
        }

        selectedSize = Math.round(10 * selectedSize) / 10; // Cutting of digits
      }

      return "<strong>" + selectedSize + "</strong> " + this.options.dictFileSizeUnits[selectedUnit];
    }

    // Adds or removes the `dz-max-files-reached` class from the form.

  }, {
    key: "_updateMaxFilesReachedClass",
    value: function _updateMaxFilesReachedClass() {
      if (this.options.maxFiles != null && this.getAcceptedFiles().length >= this.options.maxFiles) {
        if (this.getAcceptedFiles().length === this.options.maxFiles) {
          this.emit('maxfilesreached', this.files);
        }
        return this.element.classList.add("dz-max-files-reached");
      } else {
        return this.element.classList.remove("dz-max-files-reached");
      }
    }
  }, {
    key: "drop",
    value: function drop(e) {
      if (!e.dataTransfer) {
        return;
      }
      this.emit("drop", e);

      // Convert the FileList to an Array
      // This is necessary for IE11
      var files = [];
      for (var i = 0; i < e.dataTransfer.files.length; i++) {
        files[i] = e.dataTransfer.files[i];
      }

      this.emit("addedfiles", files);

      // Even if it's a folder, files.length will contain the folders.
      if (files.length) {
        var items = e.dataTransfer.items;

        if (items && items.length && items[0].webkitGetAsEntry != null) {
          // The browser supports dropping of folders, so handle items instead of files
          this._addFilesFromItems(items);
        } else {
          this.handleFiles(files);
        }
      }
    }
  }, {
    key: "paste",
    value: function paste(e) {
      if (__guard__(e != null ? e.clipboardData : undefined, function (x) {
        return x.items;
      }) == null) {
        return;
      }

      this.emit("paste", e);
      var items = e.clipboardData.items;


      if (items.length) {
        return this._addFilesFromItems(items);
      }
    }
  }, {
    key: "handleFiles",
    value: function handleFiles(files) {
      for (var _iterator14 = files, _isArray14 = true, _i15 = 0, _iterator14 = _isArray14 ? _iterator14 : _iterator14[Symbol.iterator]();;) {
        var _ref13;

        if (_isArray14) {
          if (_i15 >= _iterator14.length) break;
          _ref13 = _iterator14[_i15++];
        } else {
          _i15 = _iterator14.next();
          if (_i15.done) break;
          _ref13 = _i15.value;
        }

        var file = _ref13;

        this.addFile(file);
      }
    }

    // When a folder is dropped (or files are pasted), items must be handled
    // instead of files.

  }, {
    key: "_addFilesFromItems",
    value: function _addFilesFromItems(items) {
      var _this5 = this;

      return function () {
        var result = [];
        for (var _iterator15 = items, _isArray15 = true, _i16 = 0, _iterator15 = _isArray15 ? _iterator15 : _iterator15[Symbol.iterator]();;) {
          var _ref14;

          if (_isArray15) {
            if (_i16 >= _iterator15.length) break;
            _ref14 = _iterator15[_i16++];
          } else {
            _i16 = _iterator15.next();
            if (_i16.done) break;
            _ref14 = _i16.value;
          }

          var item = _ref14;

          var entry;
          if (item.webkitGetAsEntry != null && (entry = item.webkitGetAsEntry())) {
            if (entry.isFile) {
              result.push(_this5.addFile(item.getAsFile()));
            } else if (entry.isDirectory) {
              // Append all files from that directory to files
              result.push(_this5._addFilesFromDirectory(entry, entry.name));
            } else {
              result.push(undefined);
            }
          } else if (item.getAsFile != null) {
            if (item.kind == null || item.kind === "file") {
              result.push(_this5.addFile(item.getAsFile()));
            } else {
              result.push(undefined);
            }
          } else {
            result.push(undefined);
          }
        }
        return result;
      }();
    }

    // Goes through the directory, and adds each file it finds recursively

  }, {
    key: "_addFilesFromDirectory",
    value: function _addFilesFromDirectory(directory, path) {
      var _this6 = this;

      var dirReader = directory.createReader();

      var errorHandler = function errorHandler(error) {
        return __guardMethod__(console, 'log', function (o) {
          return o.log(error);
        });
      };

      var readEntries = function readEntries() {
        return dirReader.readEntries(function (entries) {
          if (entries.length > 0) {
            for (var _iterator16 = entries, _isArray16 = true, _i17 = 0, _iterator16 = _isArray16 ? _iterator16 : _iterator16[Symbol.iterator]();;) {
              var _ref15;

              if (_isArray16) {
                if (_i17 >= _iterator16.length) break;
                _ref15 = _iterator16[_i17++];
              } else {
                _i17 = _iterator16.next();
                if (_i17.done) break;
                _ref15 = _i17.value;
              }

              var entry = _ref15;

              if (entry.isFile) {
                entry.file(function (file) {
                  if (_this6.options.ignoreHiddenFiles && file.name.substring(0, 1) === '.') {
                    return;
                  }
                  file.fullPath = path + "/" + file.name;
                  return _this6.addFile(file);
                });
              } else if (entry.isDirectory) {
                _this6._addFilesFromDirectory(entry, path + "/" + entry.name);
              }
            }

            // Recursively call readEntries() again, since browser only handle
            // the first 100 entries.
            // See: https://developer.mozilla.org/en-US/docs/Web/API/DirectoryReader#readEntries
            readEntries();
          }
          return null;
        }, errorHandler);
      };

      return readEntries();
    }

    // If `done()` is called without argument the file is accepted
    // If you call it with an error message, the file is rejected
    // (This allows for asynchronous validation)
    //
    // This function checks the filesize, and if the file.type passes the
    // `acceptedFiles` check.

  }, {
    key: "accept",
    value: function accept(file, done) {
      if (file.size > this.options.maxFilesize * 1024 * 1024) {
        return done(this.options.dictFileTooBig.replace("{{filesize}}", Math.round(file.size / 1024 / 10.24) / 100).replace("{{maxFilesize}}", this.options.maxFilesize));
      } else if (!Dropzone.isValidFile(file, this.options.acceptedFiles)) {
        return done(this.options.dictInvalidFileType);
      } else if (this.options.maxFiles != null && this.getAcceptedFiles().length >= this.options.maxFiles) {
        done(this.options.dictMaxFilesExceeded.replace("{{maxFiles}}", this.options.maxFiles));
        return this.emit("maxfilesexceeded", file);
      } else {
        return this.options.accept.call(this, file, done);
      }
    }
  }, {
    key: "addFile",
    value: function addFile(file) {
      var _this7 = this;

      file.upload = {
        uuid: Dropzone.uuidv4(),
        progress: 0,
        // Setting the total upload size to file.size for the beginning
        // It's actual different than the size to be transmitted.
        total: file.size,
        bytesSent: 0,
        filename: this._renameFile(file),
        chunked: this.options.chunking && (this.options.forceChunking || file.size > this.options.chunkSize),
        totalChunkCount: Math.ceil(file.size / this.options.chunkSize)
      };
      this.files.push(file);

      file.status = Dropzone.ADDED;

      this.emit("addedfile", file);

      this._enqueueThumbnail(file);

      return this.accept(file, function (error) {
        if (error) {
          file.accepted = false;
          _this7._errorProcessing([file], error); // Will set the file.status
        } else {
          file.accepted = true;
          if (_this7.options.autoQueue) {
            _this7.enqueueFile(file);
          } // Will set .accepted = true
        }
        return _this7._updateMaxFilesReachedClass();
      });
    }

    // Wrapper for enqueueFile

  }, {
    key: "enqueueFiles",
    value: function enqueueFiles(files) {
      for (var _iterator17 = files, _isArray17 = true, _i18 = 0, _iterator17 = _isArray17 ? _iterator17 : _iterator17[Symbol.iterator]();;) {
        var _ref16;

        if (_isArray17) {
          if (_i18 >= _iterator17.length) break;
          _ref16 = _iterator17[_i18++];
        } else {
          _i18 = _iterator17.next();
          if (_i18.done) break;
          _ref16 = _i18.value;
        }

        var file = _ref16;

        this.enqueueFile(file);
      }
      return null;
    }
  }, {
    key: "enqueueFile",
    value: function enqueueFile(file) {
      var _this8 = this;

      if (file.status === Dropzone.ADDED && file.accepted === true) {
        file.status = Dropzone.QUEUED;
        if (this.options.autoProcessQueue) {
          return setTimeout(function () {
            return _this8.processQueue();
          }, 0); // Deferring the call
        }
      } else {
        throw new Error("This file can't be queued because it has already been processed or was rejected.");
      }
    }
  }, {
    key: "_enqueueThumbnail",
    value: function _enqueueThumbnail(file) {
      var _this9 = this;

      if (this.options.createImageThumbnails && file.type.match(/image.*/) && file.size <= this.options.maxThumbnailFilesize * 1024 * 1024) {
        this._thumbnailQueue.push(file);
        return setTimeout(function () {
          return _this9._processThumbnailQueue();
        }, 0); // Deferring the call
      }
    }
  }, {
    key: "_processThumbnailQueue",
    value: function _processThumbnailQueue() {
      var _this10 = this;

      if (this._processingThumbnail || this._thumbnailQueue.length === 0) {
        return;
      }

      this._processingThumbnail = true;
      var file = this._thumbnailQueue.shift();
      return this.createThumbnail(file, this.options.thumbnailWidth, this.options.thumbnailHeight, this.options.thumbnailMethod, true, function (dataUrl) {
        _this10.emit("thumbnail", file, dataUrl);
        _this10._processingThumbnail = false;
        return _this10._processThumbnailQueue();
      });
    }

    // Can be called by the user to remove a file

  }, {
    key: "removeFile",
    value: function removeFile(file) {
      if (file.status === Dropzone.UPLOADING) {
        this.cancelUpload(file);
      }
      this.files = without(this.files, file);

      this.emit("removedfile", file);
      if (this.files.length === 0) {
        return this.emit("reset");
      }
    }

    // Removes all files that aren't currently processed from the list

  }, {
    key: "removeAllFiles",
    value: function removeAllFiles(cancelIfNecessary) {
      // Create a copy of files since removeFile() changes the @files array.
      if (cancelIfNecessary == null) {
        cancelIfNecessary = false;
      }
      for (var _iterator18 = this.files.slice(), _isArray18 = true, _i19 = 0, _iterator18 = _isArray18 ? _iterator18 : _iterator18[Symbol.iterator]();;) {
        var _ref17;

        if (_isArray18) {
          if (_i19 >= _iterator18.length) break;
          _ref17 = _iterator18[_i19++];
        } else {
          _i19 = _iterator18.next();
          if (_i19.done) break;
          _ref17 = _i19.value;
        }

        var file = _ref17;

        if (file.status !== Dropzone.UPLOADING || cancelIfNecessary) {
          this.removeFile(file);
        }
      }
      return null;
    }

    // Resizes an image before it gets sent to the server. This function is the default behavior of
    // `options.transformFile` if `resizeWidth` or `resizeHeight` are set. The callback is invoked with
    // the resized blob.

  }, {
    key: "resizeImage",
    value: function resizeImage(file, width, height, resizeMethod, callback) {
      var _this11 = this;

      return this.createThumbnail(file, width, height, resizeMethod, false, function (dataUrl, canvas) {
        if (canvas == null) {
          // The image has not been resized
          return callback(file);
        } else {
          var resizeMimeType = _this11.options.resizeMimeType;

          if (resizeMimeType == null) {
            resizeMimeType = file.type;
          }
          var resizedDataURL = canvas.toDataURL(resizeMimeType, _this11.options.resizeQuality);
          if (resizeMimeType === 'image/jpeg' || resizeMimeType === 'image/jpg') {
            // Now add the original EXIF information
            resizedDataURL = ExifRestore.restore(file.dataURL, resizedDataURL);
          }
          return callback(Dropzone.dataURItoBlob(resizedDataURL));
        }
      });
    }
  }, {
    key: "createThumbnail",
    value: function createThumbnail(file, width, height, resizeMethod, fixOrientation, callback) {
      var _this12 = this;

      var fileReader = new FileReader();

      fileReader.onload = function () {

        file.dataURL = fileReader.result;

        // Don't bother creating a thumbnail for SVG images since they're vector
        if (file.type === "image/svg+xml") {
          if (callback != null) {
            callback(fileReader.result);
          }
          return;
        }

        return _this12.createThumbnailFromUrl(file, width, height, resizeMethod, fixOrientation, callback);
      };

      return fileReader.readAsDataURL(file);
    }
  }, {
    key: "createThumbnailFromUrl",
    value: function createThumbnailFromUrl(file, width, height, resizeMethod, fixOrientation, callback, crossOrigin) {
      var _this13 = this;

      // Not using `new Image` here because of a bug in latest Chrome versions.
      // See https://github.com/enyo/dropzone/pull/226
      var img = document.createElement("img");

      if (crossOrigin) {
        img.crossOrigin = crossOrigin;
      }

      img.onload = function () {
        var loadExif = function loadExif(callback) {
          return callback(1);
        };
        if (typeof EXIF !== 'undefined' && EXIF !== null && fixOrientation) {
          loadExif = function loadExif(callback) {
            return EXIF.getData(img, function () {
              return callback(EXIF.getTag(this, 'Orientation'));
            });
          };
        }

        return loadExif(function (orientation) {
          file.width = img.width;
          file.height = img.height;

          var resizeInfo = _this13.options.resize.call(_this13, file, width, height, resizeMethod);

          var canvas = document.createElement("canvas");
          var ctx = canvas.getContext("2d");

          canvas.width = resizeInfo.trgWidth;
          canvas.height = resizeInfo.trgHeight;

          if (orientation > 4) {
            canvas.width = resizeInfo.trgHeight;
            canvas.height = resizeInfo.trgWidth;
          }

          switch (orientation) {
            case 2:
              // horizontal flip
              ctx.translate(canvas.width, 0);
              ctx.scale(-1, 1);
              break;
            case 3:
              // 180° rotate left
              ctx.translate(canvas.width, canvas.height);
              ctx.rotate(Math.PI);
              break;
            case 4:
              // vertical flip
              ctx.translate(0, canvas.height);
              ctx.scale(1, -1);
              break;
            case 5:
              // vertical flip + 90 rotate right
              ctx.rotate(0.5 * Math.PI);
              ctx.scale(1, -1);
              break;
            case 6:
              // 90° rotate right
              ctx.rotate(0.5 * Math.PI);
              ctx.translate(0, -canvas.height);
              break;
            case 7:
              // horizontal flip + 90 rotate right
              ctx.rotate(0.5 * Math.PI);
              ctx.translate(canvas.width, -canvas.height);
              ctx.scale(-1, 1);
              break;
            case 8:
              // 90° rotate left
              ctx.rotate(-0.5 * Math.PI);
              ctx.translate(-canvas.width, 0);
              break;
          }

          // This is a bugfix for iOS' scaling bug.
          drawImageIOSFix(ctx, img, resizeInfo.srcX != null ? resizeInfo.srcX : 0, resizeInfo.srcY != null ? resizeInfo.srcY : 0, resizeInfo.srcWidth, resizeInfo.srcHeight, resizeInfo.trgX != null ? resizeInfo.trgX : 0, resizeInfo.trgY != null ? resizeInfo.trgY : 0, resizeInfo.trgWidth, resizeInfo.trgHeight);

          var thumbnail = canvas.toDataURL("image/png");

          if (callback != null) {
            return callback(thumbnail, canvas);
          }
        });
      };

      if (callback != null) {
        img.onerror = callback;
      }

      return img.src = file.dataURL;
    }

    // Goes through the queue and processes files if there aren't too many already.

  }, {
    key: "processQueue",
    value: function processQueue() {
      var parallelUploads = this.options.parallelUploads;

      var processingLength = this.getUploadingFiles().length;
      var i = processingLength;

      // There are already at least as many files uploading than should be
      if (processingLength >= parallelUploads) {
        return;
      }

      var queuedFiles = this.getQueuedFiles();

      if (!(queuedFiles.length > 0)) {
        return;
      }

      if (this.options.uploadMultiple) {
        // The files should be uploaded in one request
        return this.processFiles(queuedFiles.slice(0, parallelUploads - processingLength));
      } else {
        while (i < parallelUploads) {
          if (!queuedFiles.length) {
            return;
          } // Nothing left to process
          this.processFile(queuedFiles.shift());
          i++;
        }
      }
    }

    // Wrapper for `processFiles`

  }, {
    key: "processFile",
    value: function processFile(file) {
      return this.processFiles([file]);
    }

    // Loads the file, then calls finishedLoading()

  }, {
    key: "processFiles",
    value: function processFiles(files) {
      for (var _iterator19 = files, _isArray19 = true, _i20 = 0, _iterator19 = _isArray19 ? _iterator19 : _iterator19[Symbol.iterator]();;) {
        var _ref18;

        if (_isArray19) {
          if (_i20 >= _iterator19.length) break;
          _ref18 = _iterator19[_i20++];
        } else {
          _i20 = _iterator19.next();
          if (_i20.done) break;
          _ref18 = _i20.value;
        }

        var file = _ref18;

        file.processing = true; // Backwards compatibility
        file.status = Dropzone.UPLOADING;

        this.emit("processing", file);
      }

      if (this.options.uploadMultiple) {
        this.emit("processingmultiple", files);
      }

      return this.uploadFiles(files);
    }
  }, {
    key: "_getFilesWithXhr",
    value: function _getFilesWithXhr(xhr) {
      var files = void 0;
      return files = this.files.filter(function (file) {
        return file.xhr === xhr;
      }).map(function (file) {
        return file;
      });
    }

    // Cancels the file upload and sets the status to CANCELED
    // **if** the file is actually being uploaded.
    // If it's still in the queue, the file is being removed from it and the status
    // set to CANCELED.

  }, {
    key: "cancelUpload",
    value: function cancelUpload(file) {
      if (file.status === Dropzone.UPLOADING) {
        var groupedFiles = this._getFilesWithXhr(file.xhr);
        for (var _iterator20 = groupedFiles, _isArray20 = true, _i21 = 0, _iterator20 = _isArray20 ? _iterator20 : _iterator20[Symbol.iterator]();;) {
          var _ref19;

          if (_isArray20) {
            if (_i21 >= _iterator20.length) break;
            _ref19 = _iterator20[_i21++];
          } else {
            _i21 = _iterator20.next();
            if (_i21.done) break;
            _ref19 = _i21.value;
          }

          var groupedFile = _ref19;

          groupedFile.status = Dropzone.CANCELED;
        }
        if (typeof file.xhr !== 'undefined') {
          file.xhr.abort();
        }
        for (var _iterator21 = groupedFiles, _isArray21 = true, _i22 = 0, _iterator21 = _isArray21 ? _iterator21 : _iterator21[Symbol.iterator]();;) {
          var _ref20;

          if (_isArray21) {
            if (_i22 >= _iterator21.length) break;
            _ref20 = _iterator21[_i22++];
          } else {
            _i22 = _iterator21.next();
            if (_i22.done) break;
            _ref20 = _i22.value;
          }

          var _groupedFile = _ref20;

          this.emit("canceled", _groupedFile);
        }
        if (this.options.uploadMultiple) {
          this.emit("canceledmultiple", groupedFiles);
        }
      } else if (file.status === Dropzone.ADDED || file.status === Dropzone.QUEUED) {
        file.status = Dropzone.CANCELED;
        this.emit("canceled", file);
        if (this.options.uploadMultiple) {
          this.emit("canceledmultiple", [file]);
        }
      }

      if (this.options.autoProcessQueue) {
        return this.processQueue();
      }
    }
  }, {
    key: "resolveOption",
    value: function resolveOption(option) {
      if (typeof option === 'function') {
        for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
          args[_key3 - 1] = arguments[_key3];
        }

        return option.apply(this, args);
      }
      return option;
    }
  }, {
    key: "uploadFile",
    value: function uploadFile(file) {
      return this.uploadFiles([file]);
    }
  }, {
    key: "uploadFiles",
    value: function uploadFiles(files) {
      var _this14 = this;

      this._transformFiles(files, function (transformedFiles) {
        if (files[0].upload.chunked) {
          // This file should be sent in chunks!

          // If the chunking option is set, we **know** that there can only be **one** file, since
          // uploadMultiple is not allowed with this option.
          var file = files[0];
          var transformedFile = transformedFiles[0];
          var startedChunkCount = 0;

          file.upload.chunks = [];

          var handleNextChunk = function handleNextChunk() {
            var chunkIndex = 0;

            // Find the next item in file.upload.chunks that is not defined yet.
            while (file.upload.chunks[chunkIndex] !== undefined) {
              chunkIndex++;
            }

            // This means, that all chunks have already been started.
            if (chunkIndex >= file.upload.totalChunkCount) return;

            startedChunkCount++;

            var start = chunkIndex * _this14.options.chunkSize;
            var end = Math.min(start + _this14.options.chunkSize, file.size);

            var dataBlock = {
              name: _this14._getParamName(0),
              data: transformedFile.webkitSlice ? transformedFile.webkitSlice(start, end) : transformedFile.slice(start, end),
              filename: file.upload.filename,
              chunkIndex: chunkIndex
            };

            file.upload.chunks[chunkIndex] = {
              file: file,
              index: chunkIndex,
              dataBlock: dataBlock, // In case we want to retry.
              status: Dropzone.UPLOADING,
              progress: 0,
              retries: 0 // The number of times this block has been retried.
            };

            _this14._uploadData(files, [dataBlock]);
          };

          file.upload.finishedChunkUpload = function (chunk) {
            var allFinished = true;
            chunk.status = Dropzone.SUCCESS;

            // Clear the data from the chunk
            chunk.dataBlock = null;

            for (var i = 0; i < file.upload.totalChunkCount; i++) {
              if (file.upload.chunks[i] === undefined) {
                return handleNextChunk();
              }
              if (file.upload.chunks[i].status !== Dropzone.SUCCESS) {
                allFinished = false;
              }
            }

            if (allFinished) {
              _this14.options.chunksUploaded(file, function () {
                _this14._finished(files, '', null);
              });
            }
          };

          if (_this14.options.parallelChunkUploads) {
            for (var i = 0; i < file.upload.totalChunkCount; i++) {
              handleNextChunk();
            }
          } else {
            handleNextChunk();
          }
        } else {
          var dataBlocks = [];
          for (var _i23 = 0; _i23 < files.length; _i23++) {
            dataBlocks[_i23] = {
              name: _this14._getParamName(_i23),
              data: transformedFiles[_i23],
              filename: files[_i23].upload.filename
            };
          }
          _this14._uploadData(files, dataBlocks);
        }
      });
    }

    /// Returns the right chunk for given file and xhr

  }, {
    key: "_getChunk",
    value: function _getChunk(file, xhr) {
      for (var i = 0; i < file.upload.totalChunkCount; i++) {
        if (file.upload.chunks[i] !== undefined && file.upload.chunks[i].xhr === xhr) {
          return file.upload.chunks[i];
        }
      }
    }

    // This function actually uploads the file(s) to the server.
    // If dataBlocks contains the actual data to upload (meaning, that this could either be transformed
    // files, or individual chunks for chunked upload).

  }, {
    key: "_uploadData",
    value: function _uploadData(files, dataBlocks) {
      var _this15 = this;

      var xhr = new XMLHttpRequest();

      // Put the xhr object in the file objects to be able to reference it later.
      for (var _iterator22 = files, _isArray22 = true, _i24 = 0, _iterator22 = _isArray22 ? _iterator22 : _iterator22[Symbol.iterator]();;) {
        var _ref21;

        if (_isArray22) {
          if (_i24 >= _iterator22.length) break;
          _ref21 = _iterator22[_i24++];
        } else {
          _i24 = _iterator22.next();
          if (_i24.done) break;
          _ref21 = _i24.value;
        }

        var file = _ref21;

        file.xhr = xhr;
      }
      if (files[0].upload.chunked) {
        // Put the xhr object in the right chunk object, so it can be associated later, and found with _getChunk
        files[0].upload.chunks[dataBlocks[0].chunkIndex].xhr = xhr;
      }

      var method = this.resolveOption(this.options.method, files);
      var url = this.resolveOption(this.options.url, files);
      xhr.open(method, url, true);

      // Setting the timeout after open because of IE11 issue: https://gitlab.com/meno/dropzone/issues/8
      xhr.timeout = this.resolveOption(this.options.timeout, files);

      // Has to be after `.open()`. See https://github.com/enyo/dropzone/issues/179
      xhr.withCredentials = !!this.options.withCredentials;

      xhr.onload = function (e) {
        _this15._finishedUploading(files, xhr, e);
      };

      xhr.onerror = function () {
        _this15._handleUploadError(files, xhr);
      };

      // Some browsers do not have the .upload property
      var progressObj = xhr.upload != null ? xhr.upload : xhr;
      progressObj.onprogress = function (e) {
        return _this15._updateFilesUploadProgress(files, xhr, e);
      };

      var headers = {
        "Accept": "application/json",
        "Cache-Control": "no-cache",
        "X-Requested-With": "XMLHttpRequest"
      };

      if (this.options.headers) {
        Dropzone.extend(headers, this.options.headers);
      }

      for (var headerName in headers) {
        var headerValue = headers[headerName];
        if (headerValue) {
          xhr.setRequestHeader(headerName, headerValue);
        }
      }

      var formData = new FormData();

      // Adding all @options parameters
      if (this.options.params) {
        var additionalParams = this.options.params;
        if (typeof additionalParams === 'function') {
          additionalParams = additionalParams.call(this, files, xhr, files[0].upload.chunked ? this._getChunk(files[0], xhr) : null);
        }

        for (var key in additionalParams) {
          var value = additionalParams[key];
          formData.append(key, value);
        }
      }

      // Let the user add additional data if necessary
      for (var _iterator23 = files, _isArray23 = true, _i25 = 0, _iterator23 = _isArray23 ? _iterator23 : _iterator23[Symbol.iterator]();;) {
        var _ref22;

        if (_isArray23) {
          if (_i25 >= _iterator23.length) break;
          _ref22 = _iterator23[_i25++];
        } else {
          _i25 = _iterator23.next();
          if (_i25.done) break;
          _ref22 = _i25.value;
        }

        var _file = _ref22;

        this.emit("sending", _file, xhr, formData);
      }
      if (this.options.uploadMultiple) {
        this.emit("sendingmultiple", files, xhr, formData);
      }

      this._addFormElementData(formData);

      // Finally add the files
      // Has to be last because some servers (eg: S3) expect the file to be the last parameter
      for (var i = 0; i < dataBlocks.length; i++) {
        var dataBlock = dataBlocks[i];
        formData.append(dataBlock.name, dataBlock.data, dataBlock.filename);
      }

      this.submitRequest(xhr, formData, files);
    }

    // Transforms all files with this.options.transformFile and invokes done with the transformed files when done.

  }, {
    key: "_transformFiles",
    value: function _transformFiles(files, done) {
      var _this16 = this;

      var transformedFiles = [];
      // Clumsy way of handling asynchronous calls, until I get to add a proper Future library.
      var doneCounter = 0;

      var _loop = function _loop(i) {
        _this16.options.transformFile.call(_this16, files[i], function (transformedFile) {
          transformedFiles[i] = transformedFile;
          if (++doneCounter === files.length) {
            done(transformedFiles);
          }
        });
      };

      for (var i = 0; i < files.length; i++) {
        _loop(i);
      }
    }

    // Takes care of adding other input elements of the form to the AJAX request

  }, {
    key: "_addFormElementData",
    value: function _addFormElementData(formData) {
      // Take care of other input elements
      if (this.element.tagName === "FORM") {
        for (var _iterator24 = this.element.querySelectorAll("input, textarea, select, button"), _isArray24 = true, _i26 = 0, _iterator24 = _isArray24 ? _iterator24 : _iterator24[Symbol.iterator]();;) {
          var _ref23;

          if (_isArray24) {
            if (_i26 >= _iterator24.length) break;
            _ref23 = _iterator24[_i26++];
          } else {
            _i26 = _iterator24.next();
            if (_i26.done) break;
            _ref23 = _i26.value;
          }

          var input = _ref23;

          var inputName = input.getAttribute("name");
          var inputType = input.getAttribute("type");
          if (inputType) inputType = inputType.toLowerCase();

          // If the input doesn't have a name, we can't use it.
          if (typeof inputName === 'undefined' || inputName === null) continue;

          if (input.tagName === "SELECT" && input.hasAttribute("multiple")) {
            // Possibly multiple values
            for (var _iterator25 = input.options, _isArray25 = true, _i27 = 0, _iterator25 = _isArray25 ? _iterator25 : _iterator25[Symbol.iterator]();;) {
              var _ref24;

              if (_isArray25) {
                if (_i27 >= _iterator25.length) break;
                _ref24 = _iterator25[_i27++];
              } else {
                _i27 = _iterator25.next();
                if (_i27.done) break;
                _ref24 = _i27.value;
              }

              var option = _ref24;

              if (option.selected) {
                formData.append(inputName, option.value);
              }
            }
          } else if (!inputType || inputType !== "checkbox" && inputType !== "radio" || input.checked) {
            formData.append(inputName, input.value);
          }
        }
      }
    }

    // Invoked when there is new progress information about given files.
    // If e is not provided, it is assumed that the upload is finished.

  }, {
    key: "_updateFilesUploadProgress",
    value: function _updateFilesUploadProgress(files, xhr, e) {
      var progress = void 0;
      if (typeof e !== 'undefined') {
        progress = 100 * e.loaded / e.total;

        if (files[0].upload.chunked) {
          var file = files[0];
          // Since this is a chunked upload, we need to update the appropriate chunk progress.
          var chunk = this._getChunk(file, xhr);
          chunk.progress = progress;
          chunk.total = e.total;
          chunk.bytesSent = e.loaded;
          var fileProgress = 0,
              fileTotal = void 0,
              fileBytesSent = void 0;
          file.upload.progress = 0;
          file.upload.total = 0;
          file.upload.bytesSent = 0;
          for (var i = 0; i < file.upload.totalChunkCount; i++) {
            if (file.upload.chunks[i] !== undefined && file.upload.chunks[i].progress !== undefined) {
              file.upload.progress += file.upload.chunks[i].progress;
              file.upload.total += file.upload.chunks[i].total;
              file.upload.bytesSent += file.upload.chunks[i].bytesSent;
            }
          }
          file.upload.progress = file.upload.progress / file.upload.totalChunkCount;
        } else {
          for (var _iterator26 = files, _isArray26 = true, _i28 = 0, _iterator26 = _isArray26 ? _iterator26 : _iterator26[Symbol.iterator]();;) {
            var _ref25;

            if (_isArray26) {
              if (_i28 >= _iterator26.length) break;
              _ref25 = _iterator26[_i28++];
            } else {
              _i28 = _iterator26.next();
              if (_i28.done) break;
              _ref25 = _i28.value;
            }

            var _file2 = _ref25;

            _file2.upload.progress = progress;
            _file2.upload.total = e.total;
            _file2.upload.bytesSent = e.loaded;
          }
        }
        for (var _iterator27 = files, _isArray27 = true, _i29 = 0, _iterator27 = _isArray27 ? _iterator27 : _iterator27[Symbol.iterator]();;) {
          var _ref26;

          if (_isArray27) {
            if (_i29 >= _iterator27.length) break;
            _ref26 = _iterator27[_i29++];
          } else {
            _i29 = _iterator27.next();
            if (_i29.done) break;
            _ref26 = _i29.value;
          }

          var _file3 = _ref26;

          this.emit("uploadprogress", _file3, _file3.upload.progress, _file3.upload.bytesSent);
        }
      } else {
        // Called when the file finished uploading

        var allFilesFinished = true;

        progress = 100;

        for (var _iterator28 = files, _isArray28 = true, _i30 = 0, _iterator28 = _isArray28 ? _iterator28 : _iterator28[Symbol.iterator]();;) {
          var _ref27;

          if (_isArray28) {
            if (_i30 >= _iterator28.length) break;
            _ref27 = _iterator28[_i30++];
          } else {
            _i30 = _iterator28.next();
            if (_i30.done) break;
            _ref27 = _i30.value;
          }

          var _file4 = _ref27;

          if (_file4.upload.progress !== 100 || _file4.upload.bytesSent !== _file4.upload.total) {
            allFilesFinished = false;
          }
          _file4.upload.progress = progress;
          _file4.upload.bytesSent = _file4.upload.total;
        }

        // Nothing to do, all files already at 100%
        if (allFilesFinished) {
          return;
        }

        for (var _iterator29 = files, _isArray29 = true, _i31 = 0, _iterator29 = _isArray29 ? _iterator29 : _iterator29[Symbol.iterator]();;) {
          var _ref28;

          if (_isArray29) {
            if (_i31 >= _iterator29.length) break;
            _ref28 = _iterator29[_i31++];
          } else {
            _i31 = _iterator29.next();
            if (_i31.done) break;
            _ref28 = _i31.value;
          }

          var _file5 = _ref28;

          this.emit("uploadprogress", _file5, progress, _file5.upload.bytesSent);
        }
      }
    }
  }, {
    key: "_finishedUploading",
    value: function _finishedUploading(files, xhr, e) {
      var response = void 0;

      if (files[0].status === Dropzone.CANCELED) {
        return;
      }

      if (xhr.readyState !== 4) {
        return;
      }

      if (xhr.responseType !== 'arraybuffer' && xhr.responseType !== 'blob') {
        response = xhr.responseText;

        if (xhr.getResponseHeader("content-type") && ~xhr.getResponseHeader("content-type").indexOf("application/json")) {
          try {
            response = JSON.parse(response);
          } catch (error) {
            e = error;
            response = "Invalid JSON response from server.";
          }
        }
      }

      this._updateFilesUploadProgress(files);

      if (!(200 <= xhr.status && xhr.status < 300)) {
        this._handleUploadError(files, xhr, response);
      } else {
        if (files[0].upload.chunked) {
          files[0].upload.finishedChunkUpload(this._getChunk(files[0], xhr));
        } else {
          this._finished(files, response, e);
        }
      }
    }
  }, {
    key: "_handleUploadError",
    value: function _handleUploadError(files, xhr, response) {
      if (files[0].status === Dropzone.CANCELED) {
        return;
      }

      if (files[0].upload.chunked && this.options.retryChunks) {
        var chunk = this._getChunk(files[0], xhr);
        if (chunk.retries++ < this.options.retryChunksLimit) {
          this._uploadData(files, [chunk.dataBlock]);
          return;
        } else {
          console.warn('Retried this chunk too often. Giving up.');
        }
      }

      for (var _iterator30 = files, _isArray30 = true, _i32 = 0, _iterator30 = _isArray30 ? _iterator30 : _iterator30[Symbol.iterator]();;) {
        var _ref29;

        if (_isArray30) {
          if (_i32 >= _iterator30.length) break;
          _ref29 = _iterator30[_i32++];
        } else {
          _i32 = _iterator30.next();
          if (_i32.done) break;
          _ref29 = _i32.value;
        }

        var file = _ref29;

        this._errorProcessing(files, response || this.options.dictResponseError.replace("{{statusCode}}", xhr.status), xhr);
      }
    }
  }, {
    key: "submitRequest",
    value: function submitRequest(xhr, formData, files) {
      xhr.send(formData);
    }

    // Called internally when processing is finished.
    // Individual callbacks have to be called in the appropriate sections.

  }, {
    key: "_finished",
    value: function _finished(files, responseText, e) {
      for (var _iterator31 = files, _isArray31 = true, _i33 = 0, _iterator31 = _isArray31 ? _iterator31 : _iterator31[Symbol.iterator]();;) {
        var _ref30;

        if (_isArray31) {
          if (_i33 >= _iterator31.length) break;
          _ref30 = _iterator31[_i33++];
        } else {
          _i33 = _iterator31.next();
          if (_i33.done) break;
          _ref30 = _i33.value;
        }

        var file = _ref30;

        file.status = Dropzone.SUCCESS;
        this.emit("success", file, responseText, e);
        this.emit("complete", file);
      }
      if (this.options.uploadMultiple) {
        this.emit("successmultiple", files, responseText, e);
        this.emit("completemultiple", files);
      }

      if (this.options.autoProcessQueue) {
        return this.processQueue();
      }
    }

    // Called internally when processing is finished.
    // Individual callbacks have to be called in the appropriate sections.

  }, {
    key: "_errorProcessing",
    value: function _errorProcessing(files, message, xhr) {
      for (var _iterator32 = files, _isArray32 = true, _i34 = 0, _iterator32 = _isArray32 ? _iterator32 : _iterator32[Symbol.iterator]();;) {
        var _ref31;

        if (_isArray32) {
          if (_i34 >= _iterator32.length) break;
          _ref31 = _iterator32[_i34++];
        } else {
          _i34 = _iterator32.next();
          if (_i34.done) break;
          _ref31 = _i34.value;
        }

        var file = _ref31;

        file.status = Dropzone.ERROR;
        this.emit("error", file, message, xhr);
        this.emit("complete", file);
      }
      if (this.options.uploadMultiple) {
        this.emit("errormultiple", files, message, xhr);
        this.emit("completemultiple", files);
      }

      if (this.options.autoProcessQueue) {
        return this.processQueue();
      }
    }
  }], [{
    key: "uuidv4",
    value: function uuidv4() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
            v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
      });
    }
  }]);

  return Dropzone;
}(Emitter);

Dropzone.initClass();

Dropzone.version = "5.4.0";

// This is a map of options for your different dropzones. Add configurations
// to this object for your different dropzone elemens.
//
// Example:
//
//     Dropzone.options.myDropzoneElementId = { maxFilesize: 1 };
//
// To disable autoDiscover for a specific element, you can set `false` as an option:
//
//     Dropzone.options.myDisabledElementId = false;
//
// And in html:
//
//     <form action="/upload" id="my-dropzone-element-id" class="dropzone"></form>
Dropzone.options = {};

// Returns the options for an element or undefined if none available.
Dropzone.optionsForElement = function (element) {
  // Get the `Dropzone.options.elementId` for this element if it exists
  if (element.getAttribute("id")) {
    return Dropzone.options[camelize(element.getAttribute("id"))];
  } else {
    return undefined;
  }
};

// Holds a list of all dropzone instances
Dropzone.instances = [];

// Returns the dropzone for given element if any
Dropzone.forElement = function (element) {
  if (typeof element === "string") {
    element = document.querySelector(element);
  }
  if ((element != null ? element.dropzone : undefined) == null) {
    throw new Error("No Dropzone found for given element. This is probably because you're trying to access it before Dropzone had the time to initialize. Use the `init` option to setup any additional observers on your Dropzone.");
  }
  return element.dropzone;
};

// Set to false if you don't want Dropzone to automatically find and attach to .dropzone elements.
Dropzone.autoDiscover = true;

// Looks for all .dropzone elements and creates a dropzone for them
Dropzone.discover = function () {
  var dropzones = void 0;
  if (document.querySelectorAll) {
    dropzones = document.querySelectorAll(".dropzone");
  } else {
    dropzones = [];
    // IE :(
    var checkElements = function checkElements(elements) {
      return function () {
        var result = [];
        for (var _iterator33 = elements, _isArray33 = true, _i35 = 0, _iterator33 = _isArray33 ? _iterator33 : _iterator33[Symbol.iterator]();;) {
          var _ref32;

          if (_isArray33) {
            if (_i35 >= _iterator33.length) break;
            _ref32 = _iterator33[_i35++];
          } else {
            _i35 = _iterator33.next();
            if (_i35.done) break;
            _ref32 = _i35.value;
          }

          var el = _ref32;

          if (/(^| )dropzone($| )/.test(el.className)) {
            result.push(dropzones.push(el));
          } else {
            result.push(undefined);
          }
        }
        return result;
      }();
    };
    checkElements(document.getElementsByTagName("div"));
    checkElements(document.getElementsByTagName("form"));
  }

  return function () {
    var result = [];
    for (var _iterator34 = dropzones, _isArray34 = true, _i36 = 0, _iterator34 = _isArray34 ? _iterator34 : _iterator34[Symbol.iterator]();;) {
      var _ref33;

      if (_isArray34) {
        if (_i36 >= _iterator34.length) break;
        _ref33 = _iterator34[_i36++];
      } else {
        _i36 = _iterator34.next();
        if (_i36.done) break;
        _ref33 = _i36.value;
      }

      var dropzone = _ref33;

      // Create a dropzone unless auto discover has been disabled for specific element
      if (Dropzone.optionsForElement(dropzone) !== false) {
        result.push(new Dropzone(dropzone));
      } else {
        result.push(undefined);
      }
    }
    return result;
  }();
};

// Since the whole Drag'n'Drop API is pretty new, some browsers implement it,
// but not correctly.
// So I created a blacklist of userAgents. Yes, yes. Browser sniffing, I know.
// But what to do when browsers *theoretically* support an API, but crash
// when using it.
//
// This is a list of regular expressions tested against navigator.userAgent
//
// ** It should only be used on browser that *do* support the API, but
// incorrectly **
//
Dropzone.blacklistedBrowsers = [
// The mac os and windows phone version of opera 12 seems to have a problem with the File drag'n'drop API.
/opera.*(Macintosh|Windows Phone).*version\/12/i];

// Checks if the browser is supported
Dropzone.isBrowserSupported = function () {
  var capableBrowser = true;

  if (window.File && window.FileReader && window.FileList && window.Blob && window.FormData && document.querySelector) {
    if (!("classList" in document.createElement("a"))) {
      capableBrowser = false;
    } else {
      // The browser supports the API, but may be blacklisted.
      for (var _iterator35 = Dropzone.blacklistedBrowsers, _isArray35 = true, _i37 = 0, _iterator35 = _isArray35 ? _iterator35 : _iterator35[Symbol.iterator]();;) {
        var _ref34;

        if (_isArray35) {
          if (_i37 >= _iterator35.length) break;
          _ref34 = _iterator35[_i37++];
        } else {
          _i37 = _iterator35.next();
          if (_i37.done) break;
          _ref34 = _i37.value;
        }

        var regex = _ref34;

        if (regex.test(navigator.userAgent)) {
          capableBrowser = false;
          continue;
        }
      }
    }
  } else {
    capableBrowser = false;
  }

  return capableBrowser;
};

Dropzone.dataURItoBlob = function (dataURI) {
  // convert base64 to raw binary data held in a string
  // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
  var byteString = atob(dataURI.split(',')[1]);

  // separate out the mime component
  var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

  // write the bytes of the string to an ArrayBuffer
  var ab = new ArrayBuffer(byteString.length);
  var ia = new Uint8Array(ab);
  for (var i = 0, end = byteString.length, asc = 0 <= end; asc ? i <= end : i >= end; asc ? i++ : i--) {
    ia[i] = byteString.charCodeAt(i);
  }

  // write the ArrayBuffer to a blob
  return new Blob([ab], { type: mimeString });
};

// Returns an array without the rejected item
var without = function without(list, rejectedItem) {
  return list.filter(function (item) {
    return item !== rejectedItem;
  }).map(function (item) {
    return item;
  });
};

// abc-def_ghi -> abcDefGhi
var camelize = function camelize(str) {
  return str.replace(/[\-_](\w)/g, function (match) {
    return match.charAt(1).toUpperCase();
  });
};

// Creates an element from string
Dropzone.createElement = function (string) {
  var div = document.createElement("div");
  div.innerHTML = string;
  return div.childNodes[0];
};

// Tests if given element is inside (or simply is) the container
Dropzone.elementInside = function (element, container) {
  if (element === container) {
    return true;
  } // Coffeescript doesn't support do/while loops
  while (element = element.parentNode) {
    if (element === container) {
      return true;
    }
  }
  return false;
};

Dropzone.getElement = function (el, name) {
  var element = void 0;
  if (typeof el === "string") {
    element = document.querySelector(el);
  } else if (el.nodeType != null) {
    element = el;
  }
  if (element == null) {
    throw new Error("Invalid `" + name + "` option provided. Please provide a CSS selector or a plain HTML element.");
  }
  return element;
};

Dropzone.getElements = function (els, name) {
  var el = void 0,
      elements = void 0;
  if (els instanceof Array) {
    elements = [];
    try {
      for (var _iterator36 = els, _isArray36 = true, _i38 = 0, _iterator36 = _isArray36 ? _iterator36 : _iterator36[Symbol.iterator]();;) {
        if (_isArray36) {
          if (_i38 >= _iterator36.length) break;
          el = _iterator36[_i38++];
        } else {
          _i38 = _iterator36.next();
          if (_i38.done) break;
          el = _i38.value;
        }

        elements.push(this.getElement(el, name));
      }
    } catch (e) {
      elements = null;
    }
  } else if (typeof els === "string") {
    elements = [];
    for (var _iterator37 = document.querySelectorAll(els), _isArray37 = true, _i39 = 0, _iterator37 = _isArray37 ? _iterator37 : _iterator37[Symbol.iterator]();;) {
      if (_isArray37) {
        if (_i39 >= _iterator37.length) break;
        el = _iterator37[_i39++];
      } else {
        _i39 = _iterator37.next();
        if (_i39.done) break;
        el = _i39.value;
      }

      elements.push(el);
    }
  } else if (els.nodeType != null) {
    elements = [els];
  }

  if (elements == null || !elements.length) {
    throw new Error("Invalid `" + name + "` option provided. Please provide a CSS selector, a plain HTML element or a list of those.");
  }

  return elements;
};

// Asks the user the question and calls accepted or rejected accordingly
//
// The default implementation just uses `window.confirm` and then calls the
// appropriate callback.
Dropzone.confirm = function (question, accepted, rejected) {
  if (window.confirm(question)) {
    return accepted();
  } else if (rejected != null) {
    return rejected();
  }
};

// Validates the mime type like this:
//
// https://developer.mozilla.org/en-US/docs/HTML/Element/input#attr-accept
Dropzone.isValidFile = function (file, acceptedFiles) {
  if (!acceptedFiles) {
    return true;
  } // If there are no accepted mime types, it's OK
  acceptedFiles = acceptedFiles.split(",");

  var mimeType = file.type;
  var baseMimeType = mimeType.replace(/\/.*$/, "");

  for (var _iterator38 = acceptedFiles, _isArray38 = true, _i40 = 0, _iterator38 = _isArray38 ? _iterator38 : _iterator38[Symbol.iterator]();;) {
    var _ref35;

    if (_isArray38) {
      if (_i40 >= _iterator38.length) break;
      _ref35 = _iterator38[_i40++];
    } else {
      _i40 = _iterator38.next();
      if (_i40.done) break;
      _ref35 = _i40.value;
    }

    var validType = _ref35;

    validType = validType.trim();
    if (validType.charAt(0) === ".") {
      if (file.name.toLowerCase().indexOf(validType.toLowerCase(), file.name.length - validType.length) !== -1) {
        return true;
      }
    } else if (/\/\*$/.test(validType)) {
      // This is something like a image/* mime type
      if (baseMimeType === validType.replace(/\/.*$/, "")) {
        return true;
      }
    } else {
      if (mimeType === validType) {
        return true;
      }
    }
  }

  return false;
};

// Augment jQuery
if (typeof jQuery !== 'undefined' && jQuery !== null) {
  jQuery.fn.dropzone = function (options) {
    return this.each(function () {
      return new Dropzone(this, options);
    });
  };
}

if (typeof module !== 'undefined' && module !== null) {
  module.exports = Dropzone;
} else {
  window.Dropzone = Dropzone;
}

// Dropzone file status codes
Dropzone.ADDED = "added";

Dropzone.QUEUED = "queued";
// For backwards compatibility. Now, if a file is accepted, it's either queued
// or uploading.
Dropzone.ACCEPTED = Dropzone.QUEUED;

Dropzone.UPLOADING = "uploading";
Dropzone.PROCESSING = Dropzone.UPLOADING; // alias

Dropzone.CANCELED = "canceled";
Dropzone.ERROR = "error";
Dropzone.SUCCESS = "success";

/*

 Bugfix for iOS 6 and 7
 Source: http://stackoverflow.com/questions/11929099/html5-canvas-drawimage-ratio-bug-ios
 based on the work of https://github.com/stomita/ios-imagefile-megapixel

 */

// Detecting vertical squash in loaded image.
// Fixes a bug which squash image vertically while drawing into canvas for some images.
// This is a bug in iOS6 devices. This function from https://github.com/stomita/ios-imagefile-megapixel
var detectVerticalSquash = function detectVerticalSquash(img) {
  var iw = img.naturalWidth;
  var ih = img.naturalHeight;
  var canvas = document.createElement("canvas");
  canvas.width = 1;
  canvas.height = ih;
  var ctx = canvas.getContext("2d");
  ctx.drawImage(img, 0, 0);

  var _ctx$getImageData = ctx.getImageData(1, 0, 1, ih),
      data = _ctx$getImageData.data;

  // search image edge pixel position in case it is squashed vertically.


  var sy = 0;
  var ey = ih;
  var py = ih;
  while (py > sy) {
    var alpha = data[(py - 1) * 4 + 3];

    if (alpha === 0) {
      ey = py;
    } else {
      sy = py;
    }

    py = ey + sy >> 1;
  }
  var ratio = py / ih;

  if (ratio === 0) {
    return 1;
  } else {
    return ratio;
  }
};

// A replacement for context.drawImage
// (args are for source and destination).
var drawImageIOSFix = function drawImageIOSFix(ctx, img, sx, sy, sw, sh, dx, dy, dw, dh) {
  var vertSquashRatio = detectVerticalSquash(img);
  return ctx.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh / vertSquashRatio);
};

// Based on MinifyJpeg
// Source: http://www.perry.cz/files/ExifRestorer.js
// http://elicon.blog57.fc2.com/blog-entry-206.html

var ExifRestore = function () {
  function ExifRestore() {
    _classCallCheck(this, ExifRestore);
  }

  _createClass(ExifRestore, null, [{
    key: "initClass",
    value: function initClass() {
      this.KEY_STR = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    }
  }, {
    key: "encode64",
    value: function encode64(input) {
      var output = '';
      var chr1 = undefined;
      var chr2 = undefined;
      var chr3 = '';
      var enc1 = undefined;
      var enc2 = undefined;
      var enc3 = undefined;
      var enc4 = '';
      var i = 0;
      while (true) {
        chr1 = input[i++];
        chr2 = input[i++];
        chr3 = input[i++];
        enc1 = chr1 >> 2;
        enc2 = (chr1 & 3) << 4 | chr2 >> 4;
        enc3 = (chr2 & 15) << 2 | chr3 >> 6;
        enc4 = chr3 & 63;
        if (isNaN(chr2)) {
          enc3 = enc4 = 64;
        } else if (isNaN(chr3)) {
          enc4 = 64;
        }
        output = output + this.KEY_STR.charAt(enc1) + this.KEY_STR.charAt(enc2) + this.KEY_STR.charAt(enc3) + this.KEY_STR.charAt(enc4);
        chr1 = chr2 = chr3 = '';
        enc1 = enc2 = enc3 = enc4 = '';
        if (!(i < input.length)) {
          break;
        }
      }
      return output;
    }
  }, {
    key: "restore",
    value: function restore(origFileBase64, resizedFileBase64) {
      if (!origFileBase64.match('data:image/jpeg;base64,')) {
        return resizedFileBase64;
      }
      var rawImage = this.decode64(origFileBase64.replace('data:image/jpeg;base64,', ''));
      var segments = this.slice2Segments(rawImage);
      var image = this.exifManipulation(resizedFileBase64, segments);
      return "data:image/jpeg;base64," + this.encode64(image);
    }
  }, {
    key: "exifManipulation",
    value: function exifManipulation(resizedFileBase64, segments) {
      var exifArray = this.getExifArray(segments);
      var newImageArray = this.insertExif(resizedFileBase64, exifArray);
      var aBuffer = new Uint8Array(newImageArray);
      return aBuffer;
    }
  }, {
    key: "getExifArray",
    value: function getExifArray(segments) {
      var seg = undefined;
      var x = 0;
      while (x < segments.length) {
        seg = segments[x];
        if (seg[0] === 255 & seg[1] === 225) {
          return seg;
        }
        x++;
      }
      return [];
    }
  }, {
    key: "insertExif",
    value: function insertExif(resizedFileBase64, exifArray) {
      var imageData = resizedFileBase64.replace('data:image/jpeg;base64,', '');
      var buf = this.decode64(imageData);
      var separatePoint = buf.indexOf(255, 3);
      var mae = buf.slice(0, separatePoint);
      var ato = buf.slice(separatePoint);
      var array = mae;
      array = array.concat(exifArray);
      array = array.concat(ato);
      return array;
    }
  }, {
    key: "slice2Segments",
    value: function slice2Segments(rawImageArray) {
      var head = 0;
      var segments = [];
      while (true) {
        var length;
        if (rawImageArray[head] === 255 & rawImageArray[head + 1] === 218) {
          break;
        }
        if (rawImageArray[head] === 255 & rawImageArray[head + 1] === 216) {
          head += 2;
        } else {
          length = rawImageArray[head + 2] * 256 + rawImageArray[head + 3];
          var endPoint = head + length + 2;
          var seg = rawImageArray.slice(head, endPoint);
          segments.push(seg);
          head = endPoint;
        }
        if (head > rawImageArray.length) {
          break;
        }
      }
      return segments;
    }
  }, {
    key: "decode64",
    value: function decode64(input) {
      var output = '';
      var chr1 = undefined;
      var chr2 = undefined;
      var chr3 = '';
      var enc1 = undefined;
      var enc2 = undefined;
      var enc3 = undefined;
      var enc4 = '';
      var i = 0;
      var buf = [];
      // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
      var base64test = /[^A-Za-z0-9\+\/\=]/g;
      if (base64test.exec(input)) {
        console.warn('There were invalid base64 characters in the input text.\nValid base64 characters are A-Z, a-z, 0-9, \'+\', \'/\',and \'=\'\nExpect errors in decoding.');
      }
      input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');
      while (true) {
        enc1 = this.KEY_STR.indexOf(input.charAt(i++));
        enc2 = this.KEY_STR.indexOf(input.charAt(i++));
        enc3 = this.KEY_STR.indexOf(input.charAt(i++));
        enc4 = this.KEY_STR.indexOf(input.charAt(i++));
        chr1 = enc1 << 2 | enc2 >> 4;
        chr2 = (enc2 & 15) << 4 | enc3 >> 2;
        chr3 = (enc3 & 3) << 6 | enc4;
        buf.push(chr1);
        if (enc3 !== 64) {
          buf.push(chr2);
        }
        if (enc4 !== 64) {
          buf.push(chr3);
        }
        chr1 = chr2 = chr3 = '';
        enc1 = enc2 = enc3 = enc4 = '';
        if (!(i < input.length)) {
          break;
        }
      }
      return buf;
    }
  }]);

  return ExifRestore;
}();

ExifRestore.initClass();

/*
 * contentloaded.js
 *
 * Author: Diego Perini (diego.perini at gmail.com)
 * Summary: cross-browser wrapper for DOMContentLoaded
 * Updated: 20101020
 * License: MIT
 * Version: 1.2
 *
 * URL:
 * http://javascript.nwbox.com/ContentLoaded/
 * http://javascript.nwbox.com/ContentLoaded/MIT-LICENSE
 */

// @win window reference
// @fn function reference
var contentLoaded = function contentLoaded(win, fn) {
  var done = false;
  var top = true;
  var doc = win.document;
  var root = doc.documentElement;
  var add = doc.addEventListener ? "addEventListener" : "attachEvent";
  var rem = doc.addEventListener ? "removeEventListener" : "detachEvent";
  var pre = doc.addEventListener ? "" : "on";
  var init = function init(e) {
    if (e.type === "readystatechange" && doc.readyState !== "complete") {
      return;
    }
    (e.type === "load" ? win : doc)[rem](pre + e.type, init, false);
    if (!done && (done = true)) {
      return fn.call(win, e.type || e);
    }
  };

  var poll = function poll() {
    try {
      root.doScroll("left");
    } catch (e) {
      setTimeout(poll, 50);
      return;
    }
    return init("poll");
  };

  if (doc.readyState !== "complete") {
    if (doc.createEventObject && root.doScroll) {
      try {
        top = !win.frameElement;
      } catch (error) {}
      if (top) {
        poll();
      }
    }
    doc[add](pre + "DOMContentLoaded", init, false);
    doc[add](pre + "readystatechange", init, false);
    return win[add](pre + "load", init, false);
  }
};

// As a single function to be able to write tests.
Dropzone._autoDiscoverFunction = function () {
  if (Dropzone.autoDiscover) {
    return Dropzone.discover();
  }
};
contentLoaded(window, Dropzone._autoDiscoverFunction);

function __guard__(value, transform) {
  return typeof value !== 'undefined' && value !== null ? transform(value) : undefined;
}
function __guardMethod__(obj, methodName, transform) {
  if (typeof obj !== 'undefined' && obj !== null && typeof obj[methodName] === 'function') {
    return transform(obj, methodName);
  } else {
    return undefined;
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js"), __webpack_require__("./node_modules/webpack/buildin/module.js")(module)))

/***/ }),

/***/ "./node_modules/events/events.js":
/***/ (function(module, exports) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

function EventEmitter() {
  this._events = this._events || {};
  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function(n) {
  if (!isNumber(n) || n < 0 || isNaN(n))
    throw TypeError('n must be a positive number');
  this._maxListeners = n;
  return this;
};

EventEmitter.prototype.emit = function(type) {
  var er, handler, len, args, i, listeners;

  if (!this._events)
    this._events = {};

  // If there is no 'error' event listener then throw.
  if (type === 'error') {
    if (!this._events.error ||
        (isObject(this._events.error) && !this._events.error.length)) {
      er = arguments[1];
      if (er instanceof Error) {
        throw er; // Unhandled 'error' event
      } else {
        // At least give some kind of context to the user
        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
        err.context = er;
        throw err;
      }
    }
  }

  handler = this._events[type];

  if (isUndefined(handler))
    return false;

  if (isFunction(handler)) {
    switch (arguments.length) {
      // fast cases
      case 1:
        handler.call(this);
        break;
      case 2:
        handler.call(this, arguments[1]);
        break;
      case 3:
        handler.call(this, arguments[1], arguments[2]);
        break;
      // slower
      default:
        args = Array.prototype.slice.call(arguments, 1);
        handler.apply(this, args);
    }
  } else if (isObject(handler)) {
    args = Array.prototype.slice.call(arguments, 1);
    listeners = handler.slice();
    len = listeners.length;
    for (i = 0; i < len; i++)
      listeners[i].apply(this, args);
  }

  return true;
};

EventEmitter.prototype.addListener = function(type, listener) {
  var m;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events)
    this._events = {};

  // To avoid recursion in the case that type === "newListener"! Before
  // adding it to the listeners, first emit "newListener".
  if (this._events.newListener)
    this.emit('newListener', type,
              isFunction(listener.listener) ?
              listener.listener : listener);

  if (!this._events[type])
    // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
  else if (isObject(this._events[type]))
    // If we've already got an array, just append.
    this._events[type].push(listener);
  else
    // Adding the second element, need to change to array.
    this._events[type] = [this._events[type], listener];

  // Check for listener leak
  if (isObject(this._events[type]) && !this._events[type].warned) {
    if (!isUndefined(this._maxListeners)) {
      m = this._maxListeners;
    } else {
      m = EventEmitter.defaultMaxListeners;
    }

    if (m && m > 0 && this._events[type].length > m) {
      this._events[type].warned = true;
      console.error('(node) warning: possible EventEmitter memory ' +
                    'leak detected. %d listeners added. ' +
                    'Use emitter.setMaxListeners() to increase limit.',
                    this._events[type].length);
      if (typeof console.trace === 'function') {
        // not supported in IE 10
        console.trace();
      }
    }
  }

  return this;
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.once = function(type, listener) {
  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  var fired = false;

  function g() {
    this.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(this, arguments);
    }
  }

  g.listener = listener;
  this.on(type, g);

  return this;
};

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener = function(type, listener) {
  var list, position, length, i;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events || !this._events[type])
    return this;

  list = this._events[type];
  length = list.length;
  position = -1;

  if (list === listener ||
      (isFunction(list.listener) && list.listener === listener)) {
    delete this._events[type];
    if (this._events.removeListener)
      this.emit('removeListener', type, listener);

  } else if (isObject(list)) {
    for (i = length; i-- > 0;) {
      if (list[i] === listener ||
          (list[i].listener && list[i].listener === listener)) {
        position = i;
        break;
      }
    }

    if (position < 0)
      return this;

    if (list.length === 1) {
      list.length = 0;
      delete this._events[type];
    } else {
      list.splice(position, 1);
    }

    if (this._events.removeListener)
      this.emit('removeListener', type, listener);
  }

  return this;
};

EventEmitter.prototype.removeAllListeners = function(type) {
  var key, listeners;

  if (!this._events)
    return this;

  // not listening for removeListener, no need to emit
  if (!this._events.removeListener) {
    if (arguments.length === 0)
      this._events = {};
    else if (this._events[type])
      delete this._events[type];
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    for (key in this._events) {
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = {};
    return this;
  }

  listeners = this._events[type];

  if (isFunction(listeners)) {
    this.removeListener(type, listeners);
  } else if (listeners) {
    // LIFO order
    while (listeners.length)
      this.removeListener(type, listeners[listeners.length - 1]);
  }
  delete this._events[type];

  return this;
};

EventEmitter.prototype.listeners = function(type) {
  var ret;
  if (!this._events || !this._events[type])
    ret = [];
  else if (isFunction(this._events[type]))
    ret = [this._events[type]];
  else
    ret = this._events[type].slice();
  return ret;
};

EventEmitter.prototype.listenerCount = function(type) {
  if (this._events) {
    var evlistener = this._events[type];

    if (isFunction(evlistener))
      return 1;
    else if (evlistener)
      return evlistener.length;
  }
  return 0;
};

EventEmitter.listenerCount = function(emitter, type) {
  return emitter.listenerCount(type);
};

function isFunction(arg) {
  return typeof arg === 'function';
}

function isNumber(arg) {
  return typeof arg === 'number';
}

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}

function isUndefined(arg) {
  return arg === void 0;
}


/***/ }),

/***/ "./node_modules/file-saver/FileSaver.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/* FileSaver.js
 * A saveAs() FileSaver implementation.
 * 1.3.2
 * 2016-06-16 18:25:19
 *
 * By Eli Grey, http://eligrey.com
 * License: MIT
 *   See https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md
 */

/*global self */
/*jslint bitwise: true, indent: 4, laxbreak: true, laxcomma: true, smarttabs: true, plusplus: true */

/*! @source http://purl.eligrey.com/github/FileSaver.js/blob/master/FileSaver.js */

var saveAs = saveAs || (function(view) {
	"use strict";
	// IE <10 is explicitly unsupported
	if (typeof view === "undefined" || typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) {
		return;
	}
	var
		  doc = view.document
		  // only get URL when necessary in case Blob.js hasn't overridden it yet
		, get_URL = function() {
			return view.URL || view.webkitURL || view;
		}
		, save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a")
		, can_use_save_link = "download" in save_link
		, click = function(node) {
			var event = new MouseEvent("click");
			node.dispatchEvent(event);
		}
		, is_safari = /constructor/i.test(view.HTMLElement) || view.safari
		, is_chrome_ios =/CriOS\/[\d]+/.test(navigator.userAgent)
		, throw_outside = function(ex) {
			(view.setImmediate || view.setTimeout)(function() {
				throw ex;
			}, 0);
		}
		, force_saveable_type = "application/octet-stream"
		// the Blob API is fundamentally broken as there is no "downloadfinished" event to subscribe to
		, arbitrary_revoke_timeout = 1000 * 40 // in ms
		, revoke = function(file) {
			var revoker = function() {
				if (typeof file === "string") { // file is an object URL
					get_URL().revokeObjectURL(file);
				} else { // file is a File
					file.remove();
				}
			};
			setTimeout(revoker, arbitrary_revoke_timeout);
		}
		, dispatch = function(filesaver, event_types, event) {
			event_types = [].concat(event_types);
			var i = event_types.length;
			while (i--) {
				var listener = filesaver["on" + event_types[i]];
				if (typeof listener === "function") {
					try {
						listener.call(filesaver, event || filesaver);
					} catch (ex) {
						throw_outside(ex);
					}
				}
			}
		}
		, auto_bom = function(blob) {
			// prepend BOM for UTF-8 XML and text/* types (including HTML)
			// note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
			if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) {
				return new Blob([String.fromCharCode(0xFEFF), blob], {type: blob.type});
			}
			return blob;
		}
		, FileSaver = function(blob, name, no_auto_bom) {
			if (!no_auto_bom) {
				blob = auto_bom(blob);
			}
			// First try a.download, then web filesystem, then object URLs
			var
				  filesaver = this
				, type = blob.type
				, force = type === force_saveable_type
				, object_url
				, dispatch_all = function() {
					dispatch(filesaver, "writestart progress write writeend".split(" "));
				}
				// on any filesys errors revert to saving with object URLs
				, fs_error = function() {
					if ((is_chrome_ios || (force && is_safari)) && view.FileReader) {
						// Safari doesn't allow downloading of blob urls
						var reader = new FileReader();
						reader.onloadend = function() {
							var url = is_chrome_ios ? reader.result : reader.result.replace(/^data:[^;]*;/, 'data:attachment/file;');
							var popup = view.open(url, '_blank');
							if(!popup) view.location.href = url;
							url=undefined; // release reference before dispatching
							filesaver.readyState = filesaver.DONE;
							dispatch_all();
						};
						reader.readAsDataURL(blob);
						filesaver.readyState = filesaver.INIT;
						return;
					}
					// don't create more object URLs than needed
					if (!object_url) {
						object_url = get_URL().createObjectURL(blob);
					}
					if (force) {
						view.location.href = object_url;
					} else {
						var opened = view.open(object_url, "_blank");
						if (!opened) {
							// Apple does not allow window.open, see https://developer.apple.com/library/safari/documentation/Tools/Conceptual/SafariExtensionGuide/WorkingwithWindowsandTabs/WorkingwithWindowsandTabs.html
							view.location.href = object_url;
						}
					}
					filesaver.readyState = filesaver.DONE;
					dispatch_all();
					revoke(object_url);
				}
			;
			filesaver.readyState = filesaver.INIT;

			if (can_use_save_link) {
				object_url = get_URL().createObjectURL(blob);
				setTimeout(function() {
					save_link.href = object_url;
					save_link.download = name;
					click(save_link);
					dispatch_all();
					revoke(object_url);
					filesaver.readyState = filesaver.DONE;
				});
				return;
			}

			fs_error();
		}
		, FS_proto = FileSaver.prototype
		, saveAs = function(blob, name, no_auto_bom) {
			return new FileSaver(blob, name || blob.name || "download", no_auto_bom);
		}
	;
	// IE 10+ (native saveAs)
	if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) {
		return function(blob, name, no_auto_bom) {
			name = name || blob.name || "download";

			if (!no_auto_bom) {
				blob = auto_bom(blob);
			}
			return navigator.msSaveOrOpenBlob(blob, name);
		};
	}

	FS_proto.abort = function(){};
	FS_proto.readyState = FS_proto.INIT = 0;
	FS_proto.WRITING = 1;
	FS_proto.DONE = 2;

	FS_proto.error =
	FS_proto.onwritestart =
	FS_proto.onprogress =
	FS_proto.onwrite =
	FS_proto.onabort =
	FS_proto.onerror =
	FS_proto.onwriteend =
		null;

	return saveAs;
}(
	   typeof self !== "undefined" && self
	|| typeof window !== "undefined" && window
	|| this.content
));
// `self` is undefined in Firefox for Android content script context
// while `this` is nsIContentFrameMessageManager
// with an attribute `content` that corresponds to the window

if (typeof module !== "undefined" && module.exports) {
  module.exports.saveAs = saveAs;
} else if (("function" !== "undefined" && __webpack_require__("./node_modules/webpack/buildin/amd-define.js") !== null) && (__webpack_require__("./node_modules/webpack/buildin/amd-options.js") !== null)) {
  !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
    return saveAs;
  }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}


/***/ }),

/***/ "./node_modules/ieee754/index.js":
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ "./node_modules/iframe-resizer/index.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("./node_modules/iframe-resizer/js/index.js")


/***/ }),

/***/ "./node_modules/iframe-resizer/js/iframeResizer.contentWindow.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {/*
 * File: iframeResizer.contentWindow.js
 * Desc: Include this file in any page being loaded into an iframe
 *       to force the iframe to resize to the content size.
 * Requires: iframeResizer.js on host page.
 * Doc: https://github.com/davidjbradshaw/iframe-resizer
 * Author: David J. Bradshaw - dave@bradshaw.net
 *
 */

// eslint-disable-next-line sonarjs/cognitive-complexity, no-shadow-restricted-names
;(function(undefined) {
  if (typeof window === 'undefined') return // don't run for server side render

  var autoResize = true,
    base = 10,
    bodyBackground = '',
    bodyMargin = 0,
    bodyMarginStr = '',
    bodyObserver = null,
    bodyPadding = '',
    calculateWidth = false,
    doubleEventList = { resize: 1, click: 1 },
    eventCancelTimer = 128,
    firstRun = true,
    height = 1,
    heightCalcModeDefault = 'bodyOffset',
    heightCalcMode = heightCalcModeDefault,
    initLock = true,
    initMsg = '',
    inPageLinks = {},
    interval = 32,
    intervalTimer = null,
    logging = false,
    msgID = '[iFrameSizer]', // Must match host page msg ID
    msgIdLen = msgID.length,
    myID = '',
    resetRequiredMethods = {
      max: 1,
      min: 1,
      bodyScroll: 1,
      documentElementScroll: 1
    },
    resizeFrom = 'child',
    sendPermit = true,
    target = window.parent,
    targetOriginDefault = '*',
    tolerance = 0,
    triggerLocked = false,
    triggerLockedTimer = null,
    throttledTimer = 16,
    width = 1,
    widthCalcModeDefault = 'scroll',
    widthCalcMode = widthCalcModeDefault,
    win = window,
    onMessage = function() {
      warn('onMessage function not defined')
    },
    onReady = function() {},
    onPageInfo = function() {},
    customCalcMethods = {
      height: function() {
        warn('Custom height calculation function not defined')
        return document.documentElement.offsetHeight
      },
      width: function() {
        warn('Custom width calculation function not defined')
        return document.body.scrollWidth
      }
    },
    eventHandlersByName = {},
    passiveSupported = false

  function noop() {}

  try {
    var options = Object.create(
      {},
      {
        passive: {
          get: function() {
            passiveSupported = true
          }
        }
      }
    )
    window.addEventListener('test', noop, options)
    window.removeEventListener('test', noop, options)
  } catch (error) {
    /* */
  }

  function addEventListener(el, evt, func, options) {
    el.addEventListener(evt, func, passiveSupported ? options || {} : false)
  }

  function removeEventListener(el, evt, func) {
    el.removeEventListener(evt, func, false)
  }

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1)
  }

  // Based on underscore.js
  function throttle(func) {
    var context,
      args,
      result,
      timeout = null,
      previous = 0,
      later = function() {
        previous = getNow()
        timeout = null
        result = func.apply(context, args)
        if (!timeout) {
          // eslint-disable-next-line no-multi-assign
          context = args = null
        }
      }

    return function() {
      var now = getNow()

      if (!previous) {
        previous = now
      }

      var remaining = throttledTimer - (now - previous)

      context = this
      args = arguments

      if (remaining <= 0 || remaining > throttledTimer) {
        if (timeout) {
          clearTimeout(timeout)
          timeout = null
        }

        previous = now
        result = func.apply(context, args)

        if (!timeout) {
          // eslint-disable-next-line no-multi-assign
          context = args = null
        }
      } else if (!timeout) {
        timeout = setTimeout(later, remaining)
      }

      return result
    }
  }

  var getNow =
    Date.now ||
    function() {
      /* istanbul ignore next */ // Not testable in PhantonJS
      return new Date().getTime()
    }

  function formatLogMsg(msg) {
    return msgID + '[' + myID + '] ' + msg
  }

  function log(msg) {
    if (logging && 'object' === typeof window.console) {
      // eslint-disable-next-line no-console
      console.log(formatLogMsg(msg))
    }
  }

  function warn(msg) {
    if ('object' === typeof window.console) {
      // eslint-disable-next-line no-console
      console.warn(formatLogMsg(msg))
    }
  }

  function init() {
    readDataFromParent()
    log('Initialising iFrame (' + location.href + ')')
    readDataFromPage()
    setMargin()
    setBodyStyle('background', bodyBackground)
    setBodyStyle('padding', bodyPadding)
    injectClearFixIntoBodyElement()
    checkHeightMode()
    checkWidthMode()
    stopInfiniteResizingOfIFrame()
    setupPublicMethods()
    startEventListeners()
    inPageLinks = setupInPageLinks()
    sendSize('init', 'Init message from host page')
    onReady()
  }

  function readDataFromParent() {
    function strBool(str) {
      return 'true' === str
    }

    var data = initMsg.substr(msgIdLen).split(':')

    myID = data[0]
    bodyMargin = undefined !== data[1] ? Number(data[1]) : bodyMargin // For V1 compatibility
    calculateWidth = undefined !== data[2] ? strBool(data[2]) : calculateWidth
    logging = undefined !== data[3] ? strBool(data[3]) : logging
    interval = undefined !== data[4] ? Number(data[4]) : interval
    autoResize = undefined !== data[6] ? strBool(data[6]) : autoResize
    bodyMarginStr = data[7]
    heightCalcMode = undefined !== data[8] ? data[8] : heightCalcMode
    bodyBackground = data[9]
    bodyPadding = data[10]
    tolerance = undefined !== data[11] ? Number(data[11]) : tolerance
    inPageLinks.enable = undefined !== data[12] ? strBool(data[12]) : false
    resizeFrom = undefined !== data[13] ? data[13] : resizeFrom
    widthCalcMode = undefined !== data[14] ? data[14] : widthCalcMode
  }

  function depricate(key) {
    var splitName = key.split('Callback')

    if (splitName.length === 2) {
      var name =
        'on' + splitName[0].charAt(0).toUpperCase() + splitName[0].slice(1)
      this[name] = this[key]
      delete this[key]
      warn(
        "Deprecated: '" +
          key +
          "' has been renamed '" +
          name +
          "'. The old method will be removed in the next major version."
      )
    }
  }

  function readDataFromPage() {
    function readData() {
      var data = window.iFrameResizer

      log('Reading data from page: ' + JSON.stringify(data))
      Object.keys(data).forEach(depricate, data)

      onMessage = 'onMessage' in data ? data.onMessage : onMessage
      onReady = 'onReady' in data ? data.onReady : onReady
      targetOriginDefault =
        'targetOrigin' in data ? data.targetOrigin : targetOriginDefault
      heightCalcMode =
        'heightCalculationMethod' in data
          ? data.heightCalculationMethod
          : heightCalcMode
      widthCalcMode =
        'widthCalculationMethod' in data
          ? data.widthCalculationMethod
          : widthCalcMode
    }

    function setupCustomCalcMethods(calcMode, calcFunc) {
      if ('function' === typeof calcMode) {
        log('Setup custom ' + calcFunc + 'CalcMethod')
        customCalcMethods[calcFunc] = calcMode
        calcMode = 'custom'
      }

      return calcMode
    }

    if (
      'iFrameResizer' in window &&
      Object === window.iFrameResizer.constructor
    ) {
      readData()
      heightCalcMode = setupCustomCalcMethods(heightCalcMode, 'height')
      widthCalcMode = setupCustomCalcMethods(widthCalcMode, 'width')
    }

    log('TargetOrigin for parent set to: ' + targetOriginDefault)
  }

  function chkCSS(attr, value) {
    if (-1 !== value.indexOf('-')) {
      warn('Negative CSS value ignored for ' + attr)
      value = ''
    }
    return value
  }

  function setBodyStyle(attr, value) {
    if (undefined !== value && '' !== value && 'null' !== value) {
      document.body.style[attr] = value
      log('Body ' + attr + ' set to "' + value + '"')
    }
  }

  function setMargin() {
    // If called via V1 script, convert bodyMargin from int to str
    if (undefined === bodyMarginStr) {
      bodyMarginStr = bodyMargin + 'px'
    }

    setBodyStyle('margin', chkCSS('margin', bodyMarginStr))
  }

  function stopInfiniteResizingOfIFrame() {
    document.documentElement.style.height = ''
    document.body.style.height = ''
    log('HTML & body height set to "auto"')
  }

  function manageTriggerEvent(options) {
    var listener = {
      add: function(eventName) {
        function handleEvent() {
          sendSize(options.eventName, options.eventType)
        }

        eventHandlersByName[eventName] = handleEvent

        addEventListener(window, eventName, handleEvent, { passive: true })
      },
      remove: function(eventName) {
        var handleEvent = eventHandlersByName[eventName]
        delete eventHandlersByName[eventName]

        removeEventListener(window, eventName, handleEvent)
      }
    }

    if (options.eventNames && Array.prototype.map) {
      options.eventName = options.eventNames[0]
      options.eventNames.map(listener[options.method])
    } else {
      listener[options.method](options.eventName)
    }

    log(
      capitalizeFirstLetter(options.method) +
        ' event listener: ' +
        options.eventType
    )
  }

  function manageEventListeners(method) {
    manageTriggerEvent({
      method: method,
      eventType: 'Animation Start',
      eventNames: ['animationstart', 'webkitAnimationStart']
    })
    manageTriggerEvent({
      method: method,
      eventType: 'Animation Iteration',
      eventNames: ['animationiteration', 'webkitAnimationIteration']
    })
    manageTriggerEvent({
      method: method,
      eventType: 'Animation End',
      eventNames: ['animationend', 'webkitAnimationEnd']
    })
    manageTriggerEvent({
      method: method,
      eventType: 'Input',
      eventName: 'input'
    })
    manageTriggerEvent({
      method: method,
      eventType: 'Mouse Up',
      eventName: 'mouseup'
    })
    manageTriggerEvent({
      method: method,
      eventType: 'Mouse Down',
      eventName: 'mousedown'
    })
    manageTriggerEvent({
      method: method,
      eventType: 'Orientation Change',
      eventName: 'orientationchange'
    })
    manageTriggerEvent({
      method: method,
      eventType: 'Print',
      eventName: ['afterprint', 'beforeprint']
    })
    manageTriggerEvent({
      method: method,
      eventType: 'Ready State Change',
      eventName: 'readystatechange'
    })
    manageTriggerEvent({
      method: method,
      eventType: 'Touch Start',
      eventName: 'touchstart'
    })
    manageTriggerEvent({
      method: method,
      eventType: 'Touch End',
      eventName: 'touchend'
    })
    manageTriggerEvent({
      method: method,
      eventType: 'Touch Cancel',
      eventName: 'touchcancel'
    })
    manageTriggerEvent({
      method: method,
      eventType: 'Transition Start',
      eventNames: [
        'transitionstart',
        'webkitTransitionStart',
        'MSTransitionStart',
        'oTransitionStart',
        'otransitionstart'
      ]
    })
    manageTriggerEvent({
      method: method,
      eventType: 'Transition Iteration',
      eventNames: [
        'transitioniteration',
        'webkitTransitionIteration',
        'MSTransitionIteration',
        'oTransitionIteration',
        'otransitioniteration'
      ]
    })
    manageTriggerEvent({
      method: method,
      eventType: 'Transition End',
      eventNames: [
        'transitionend',
        'webkitTransitionEnd',
        'MSTransitionEnd',
        'oTransitionEnd',
        'otransitionend'
      ]
    })
    if ('child' === resizeFrom) {
      manageTriggerEvent({
        method: method,
        eventType: 'IFrame Resized',
        eventName: 'resize'
      })
    }
  }

  function checkCalcMode(calcMode, calcModeDefault, modes, type) {
    if (calcModeDefault !== calcMode) {
      if (!(calcMode in modes)) {
        warn(
          calcMode + ' is not a valid option for ' + type + 'CalculationMethod.'
        )
        calcMode = calcModeDefault
      }
      log(type + ' calculation method set to "' + calcMode + '"')
    }

    return calcMode
  }

  function checkHeightMode() {
    heightCalcMode = checkCalcMode(
      heightCalcMode,
      heightCalcModeDefault,
      getHeight,
      'height'
    )
  }

  function checkWidthMode() {
    widthCalcMode = checkCalcMode(
      widthCalcMode,
      widthCalcModeDefault,
      getWidth,
      'width'
    )
  }

  function startEventListeners() {
    if (true === autoResize) {
      manageEventListeners('add')
      setupMutationObserver()
    } else {
      log('Auto Resize disabled')
    }
  }

  //   function stopMsgsToParent() {
  //     log('Disable outgoing messages')
  //     sendPermit = false
  //   }

  //   function removeMsgListener() {
  //     log('Remove event listener: Message')
  //     removeEventListener(window, 'message', receiver)
  //   }

  function disconnectMutationObserver() {
    if (null !== bodyObserver) {
      /* istanbul ignore next */ // Not testable in PhantonJS
      bodyObserver.disconnect()
    }
  }

  function stopEventListeners() {
    manageEventListeners('remove')
    disconnectMutationObserver()
    clearInterval(intervalTimer)
  }

  //   function teardown() {
  //     stopMsgsToParent()
  //     removeMsgListener()
  //     if (true === autoResize) stopEventListeners()
  //   }

  function injectClearFixIntoBodyElement() {
    var clearFix = document.createElement('div')
    clearFix.style.clear = 'both'
    // Guard against the following having been globally redefined in CSS.
    clearFix.style.display = 'block'
    clearFix.style.height = '0'
    document.body.appendChild(clearFix)
  }

  function setupInPageLinks() {
    function getPagePosition() {
      return {
        x:
          window.pageXOffset !== undefined
            ? window.pageXOffset
            : document.documentElement.scrollLeft,
        y:
          window.pageYOffset !== undefined
            ? window.pageYOffset
            : document.documentElement.scrollTop
      }
    }

    function getElementPosition(el) {
      var elPosition = el.getBoundingClientRect(),
        pagePosition = getPagePosition()

      return {
        x: parseInt(elPosition.left, 10) + parseInt(pagePosition.x, 10),
        y: parseInt(elPosition.top, 10) + parseInt(pagePosition.y, 10)
      }
    }

    function findTarget(location) {
      function jumpToTarget(target) {
        var jumpPosition = getElementPosition(target)

        log(
          'Moving to in page link (#' +
            hash +
            ') at x: ' +
            jumpPosition.x +
            ' y: ' +
            jumpPosition.y
        )
        sendMsg(jumpPosition.y, jumpPosition.x, 'scrollToOffset') // X&Y reversed at sendMsg uses height/width
      }

      var hash = location.split('#')[1] || location, // Remove # if present
        hashData = decodeURIComponent(hash),
        target =
          document.getElementById(hashData) ||
          document.getElementsByName(hashData)[0]

      if (undefined !== target) {
        jumpToTarget(target)
      } else {
        log(
          'In page link (#' +
            hash +
            ') not found in iFrame, so sending to parent'
        )
        sendMsg(0, 0, 'inPageLink', '#' + hash)
      }
    }

    function checkLocationHash() {
      if ('' !== location.hash && '#' !== location.hash) {
        findTarget(location.href)
      }
    }

    function bindAnchors() {
      function setupLink(el) {
        function linkClicked(e) {
          e.preventDefault()

          /* jshint validthis:true */
          findTarget(this.getAttribute('href'))
        }

        if ('#' !== el.getAttribute('href')) {
          addEventListener(el, 'click', linkClicked)
        }
      }

      Array.prototype.forEach.call(
        document.querySelectorAll('a[href^="#"]'),
        setupLink
      )
    }

    function bindLocationHash() {
      addEventListener(window, 'hashchange', checkLocationHash)
    }

    function initCheck() {
      // Check if page loaded with location hash after init resize
      setTimeout(checkLocationHash, eventCancelTimer)
    }

    function enableInPageLinks() {
      /* istanbul ignore else */ // Not testable in phantonJS
      if (Array.prototype.forEach && document.querySelectorAll) {
        log('Setting up location.hash handlers')
        bindAnchors()
        bindLocationHash()
        initCheck()
      } else {
        warn(
          'In page linking not fully supported in this browser! (See README.md for IE8 workaround)'
        )
      }
    }

    if (inPageLinks.enable) {
      enableInPageLinks()
    } else {
      log('In page linking not enabled')
    }

    return {
      findTarget: findTarget
    }
  }

  function setupPublicMethods() {
    log('Enable public methods')

    win.parentIFrame = {
      autoResize: function autoResizeF(resize) {
        if (true === resize && false === autoResize) {
          autoResize = true
          startEventListeners()
        } else if (false === resize && true === autoResize) {
          autoResize = false
          stopEventListeners()
        }
        sendMsg(0, 0, 'autoResize', JSON.stringify(autoResize))
        return autoResize
      },

      close: function closeF() {
        sendMsg(0, 0, 'close')
        // teardown()
      },

      getId: function getIdF() {
        return myID
      },

      getPageInfo: function getPageInfoF(callback) {
        if ('function' === typeof callback) {
          onPageInfo = callback
          sendMsg(0, 0, 'pageInfo')
        } else {
          onPageInfo = function() {}
          sendMsg(0, 0, 'pageInfoStop')
        }
      },

      moveToAnchor: function moveToAnchorF(hash) {
        inPageLinks.findTarget(hash)
      },

      reset: function resetF() {
        resetIFrame('parentIFrame.reset')
      },

      scrollTo: function scrollToF(x, y) {
        sendMsg(y, x, 'scrollTo') // X&Y reversed at sendMsg uses height/width
      },

      scrollToOffset: function scrollToF(x, y) {
        sendMsg(y, x, 'scrollToOffset') // X&Y reversed at sendMsg uses height/width
      },

      sendMessage: function sendMessageF(msg, targetOrigin) {
        sendMsg(0, 0, 'message', JSON.stringify(msg), targetOrigin)
      },

      setHeightCalculationMethod: function setHeightCalculationMethodF(
        heightCalculationMethod
      ) {
        heightCalcMode = heightCalculationMethod
        checkHeightMode()
      },

      setWidthCalculationMethod: function setWidthCalculationMethodF(
        widthCalculationMethod
      ) {
        widthCalcMode = widthCalculationMethod
        checkWidthMode()
      },

      setTargetOrigin: function setTargetOriginF(targetOrigin) {
        log('Set targetOrigin: ' + targetOrigin)
        targetOriginDefault = targetOrigin
      },

      size: function sizeF(customHeight, customWidth) {
        var valString =
          '' + (customHeight || '') + (customWidth ? ',' + customWidth : '')
        sendSize(
          'size',
          'parentIFrame.size(' + valString + ')',
          customHeight,
          customWidth
        )
      }
    }
  }

  function initInterval() {
    if (0 !== interval) {
      log('setInterval: ' + interval + 'ms')
      intervalTimer = setInterval(function() {
        sendSize('interval', 'setInterval: ' + interval)
      }, Math.abs(interval))
    }
  }

  // Not testable in PhantomJS
  /* istanbul ignore next */
  function setupBodyMutationObserver() {
    function addImageLoadListners(mutation) {
      function addImageLoadListener(element) {
        if (false === element.complete) {
          log('Attach listeners to ' + element.src)
          element.addEventListener('load', imageLoaded, false)
          element.addEventListener('error', imageError, false)
          elements.push(element)
        }
      }

      if (mutation.type === 'attributes' && mutation.attributeName === 'src') {
        addImageLoadListener(mutation.target)
      } else if (mutation.type === 'childList') {
        Array.prototype.forEach.call(
          mutation.target.querySelectorAll('img'),
          addImageLoadListener
        )
      }
    }

    function removeFromArray(element) {
      elements.splice(elements.indexOf(element), 1)
    }

    function removeImageLoadListener(element) {
      log('Remove listeners from ' + element.src)
      element.removeEventListener('load', imageLoaded, false)
      element.removeEventListener('error', imageError, false)
      removeFromArray(element)
    }

    function imageEventTriggered(event, type, typeDesc) {
      removeImageLoadListener(event.target)
      sendSize(type, typeDesc + ': ' + event.target.src, undefined, undefined)
    }

    function imageLoaded(event) {
      imageEventTriggered(event, 'imageLoad', 'Image loaded')
    }

    function imageError(event) {
      imageEventTriggered(event, 'imageLoadFailed', 'Image load failed')
    }

    function mutationObserved(mutations) {
      sendSize(
        'mutationObserver',
        'mutationObserver: ' + mutations[0].target + ' ' + mutations[0].type
      )

      // Deal with WebKit / Blink asyncing image loading when tags are injected into the page
      mutations.forEach(addImageLoadListners)
    }

    function createMutationObserver() {
      var target = document.querySelector('body'),
        config = {
          attributes: true,
          attributeOldValue: false,
          characterData: true,
          characterDataOldValue: false,
          childList: true,
          subtree: true
        }

      observer = new MutationObserver(mutationObserved)

      log('Create body MutationObserver')
      observer.observe(target, config)

      return observer
    }

    var elements = [],
      MutationObserver =
        window.MutationObserver || window.WebKitMutationObserver,
      observer = createMutationObserver()

    return {
      disconnect: function() {
        if ('disconnect' in observer) {
          log('Disconnect body MutationObserver')
          observer.disconnect()
          elements.forEach(removeImageLoadListener)
        }
      }
    }
  }

  function setupMutationObserver() {
    var forceIntervalTimer = 0 > interval

    // Not testable in PhantomJS
    /* istanbul ignore if */ if (
      window.MutationObserver ||
      window.WebKitMutationObserver
    ) {
      if (forceIntervalTimer) {
        initInterval()
      } else {
        bodyObserver = setupBodyMutationObserver()
      }
    } else {
      log('MutationObserver not supported in this browser!')
      initInterval()
    }
  }

  // document.documentElement.offsetHeight is not reliable, so
  // we have to jump through hoops to get a better value.
  function getComputedStyle(prop, el) {
    var retVal = 0
    el = el || document.body // Not testable in phantonJS

    retVal = document.defaultView.getComputedStyle(el, null)
    retVal = null !== retVal ? retVal[prop] : 0

    return parseInt(retVal, base)
  }

  function chkEventThottle(timer) {
    if (timer > throttledTimer / 2) {
      throttledTimer = 2 * timer
      log('Event throttle increased to ' + throttledTimer + 'ms')
    }
  }

  // Idea from https://github.com/guardian/iframe-messenger
  function getMaxElement(side, elements) {
    var elementsLength = elements.length,
      elVal = 0,
      maxVal = 0,
      Side = capitalizeFirstLetter(side),
      timer = getNow()

    for (var i = 0; i < elementsLength; i++) {
      elVal =
        elements[i].getBoundingClientRect()[side] +
        getComputedStyle('margin' + Side, elements[i])
      if (elVal > maxVal) {
        maxVal = elVal
      }
    }

    timer = getNow() - timer

    log('Parsed ' + elementsLength + ' HTML elements')
    log('Element position calculated in ' + timer + 'ms')

    chkEventThottle(timer)

    return maxVal
  }

  function getAllMeasurements(dimention) {
    return [
      dimention.bodyOffset(),
      dimention.bodyScroll(),
      dimention.documentElementOffset(),
      dimention.documentElementScroll()
    ]
  }

  function getTaggedElements(side, tag) {
    function noTaggedElementsFound() {
      warn('No tagged elements (' + tag + ') found on page')
      return document.querySelectorAll('body *')
    }

    var elements = document.querySelectorAll('[' + tag + ']')

    if (0 === elements.length) noTaggedElementsFound()

    return getMaxElement(side, elements)
  }

  function getAllElements() {
    return document.querySelectorAll('body *')
  }

  var getHeight = {
      bodyOffset: function getBodyOffsetHeight() {
        return (
          document.body.offsetHeight +
          getComputedStyle('marginTop') +
          getComputedStyle('marginBottom')
        )
      },

      offset: function() {
        return getHeight.bodyOffset() // Backwards compatability
      },

      bodyScroll: function getBodyScrollHeight() {
        return document.body.scrollHeight
      },

      custom: function getCustomWidth() {
        return customCalcMethods.height()
      },

      documentElementOffset: function getDEOffsetHeight() {
        return document.documentElement.offsetHeight
      },

      documentElementScroll: function getDEScrollHeight() {
        return document.documentElement.scrollHeight
      },

      max: function getMaxHeight() {
        return Math.max.apply(null, getAllMeasurements(getHeight))
      },

      min: function getMinHeight() {
        return Math.min.apply(null, getAllMeasurements(getHeight))
      },

      grow: function growHeight() {
        return getHeight.max() // Run max without the forced downsizing
      },

      lowestElement: function getBestHeight() {
        return Math.max(
          getHeight.bodyOffset() || getHeight.documentElementOffset(),
          getMaxElement('bottom', getAllElements())
        )
      },

      taggedElement: function getTaggedElementsHeight() {
        return getTaggedElements('bottom', 'data-iframe-height')
      }
    },
    getWidth = {
      bodyScroll: function getBodyScrollWidth() {
        return document.body.scrollWidth
      },

      bodyOffset: function getBodyOffsetWidth() {
        return document.body.offsetWidth
      },

      custom: function getCustomWidth() {
        return customCalcMethods.width()
      },

      documentElementScroll: function getDEScrollWidth() {
        return document.documentElement.scrollWidth
      },

      documentElementOffset: function getDEOffsetWidth() {
        return document.documentElement.offsetWidth
      },

      scroll: function getMaxWidth() {
        return Math.max(getWidth.bodyScroll(), getWidth.documentElementScroll())
      },

      max: function getMaxWidth() {
        return Math.max.apply(null, getAllMeasurements(getWidth))
      },

      min: function getMinWidth() {
        return Math.min.apply(null, getAllMeasurements(getWidth))
      },

      rightMostElement: function rightMostElement() {
        return getMaxElement('right', getAllElements())
      },

      taggedElement: function getTaggedElementsWidth() {
        return getTaggedElements('right', 'data-iframe-width')
      }
    }

  function sizeIFrame(
    triggerEvent,
    triggerEventDesc,
    customHeight,
    customWidth
  ) {
    function resizeIFrame() {
      height = currentHeight
      width = currentWidth

      sendMsg(height, width, triggerEvent)
    }

    function isSizeChangeDetected() {
      function checkTolarance(a, b) {
        var retVal = Math.abs(a - b) <= tolerance
        return !retVal
      }

      currentHeight =
        undefined !== customHeight ? customHeight : getHeight[heightCalcMode]()
      currentWidth =
        undefined !== customWidth ? customWidth : getWidth[widthCalcMode]()

      return (
        checkTolarance(height, currentHeight) ||
        (calculateWidth && checkTolarance(width, currentWidth))
      )
    }

    function isForceResizableEvent() {
      return !(triggerEvent in { init: 1, interval: 1, size: 1 })
    }

    function isForceResizableCalcMode() {
      return (
        heightCalcMode in resetRequiredMethods ||
        (calculateWidth && widthCalcMode in resetRequiredMethods)
      )
    }

    function logIgnored() {
      log('No change in size detected')
    }

    function checkDownSizing() {
      if (isForceResizableEvent() && isForceResizableCalcMode()) {
        resetIFrame(triggerEventDesc)
      } else if (!(triggerEvent in { interval: 1 })) {
        logIgnored()
      }
    }

    var currentHeight, currentWidth

    if (isSizeChangeDetected() || 'init' === triggerEvent) {
      lockTrigger()
      resizeIFrame()
    } else {
      checkDownSizing()
    }
  }

  var sizeIFrameThrottled = throttle(sizeIFrame)

  function sendSize(triggerEvent, triggerEventDesc, customHeight, customWidth) {
    function recordTrigger() {
      if (!(triggerEvent in { reset: 1, resetPage: 1, init: 1 })) {
        log('Trigger event: ' + triggerEventDesc)
      }
    }

    function isDoubleFiredEvent() {
      return triggerLocked && triggerEvent in doubleEventList
    }

    if (!isDoubleFiredEvent()) {
      recordTrigger()
      if (triggerEvent === 'init') {
        sizeIFrame(triggerEvent, triggerEventDesc, customHeight, customWidth)
      } else {
        sizeIFrameThrottled(
          triggerEvent,
          triggerEventDesc,
          customHeight,
          customWidth
        )
      }
    } else {
      log('Trigger event cancelled: ' + triggerEvent)
    }
  }

  function lockTrigger() {
    if (!triggerLocked) {
      triggerLocked = true
      log('Trigger event lock on')
    }
    clearTimeout(triggerLockedTimer)
    triggerLockedTimer = setTimeout(function() {
      triggerLocked = false
      log('Trigger event lock off')
      log('--')
    }, eventCancelTimer)
  }

  function triggerReset(triggerEvent) {
    height = getHeight[heightCalcMode]()
    width = getWidth[widthCalcMode]()

    sendMsg(height, width, triggerEvent)
  }

  function resetIFrame(triggerEventDesc) {
    var hcm = heightCalcMode
    heightCalcMode = heightCalcModeDefault

    log('Reset trigger event: ' + triggerEventDesc)
    lockTrigger()
    triggerReset('reset')

    heightCalcMode = hcm
  }

  function sendMsg(height, width, triggerEvent, msg, targetOrigin) {
    function setTargetOrigin() {
      if (undefined === targetOrigin) {
        targetOrigin = targetOriginDefault
      } else {
        log('Message targetOrigin: ' + targetOrigin)
      }
    }

    function sendToParent() {
      var size = height + ':' + width,
        message =
          myID +
          ':' +
          size +
          ':' +
          triggerEvent +
          (undefined !== msg ? ':' + msg : '')

      log('Sending message to host page (' + message + ')')
      target.postMessage(msgID + message, targetOrigin)
    }

    if (true === sendPermit) {
      setTargetOrigin()
      sendToParent()
    }
  }

  function receiver(event) {
    var processRequestFromParent = {
      init: function initFromParent() {
        initMsg = event.data
        target = event.source

        init()
        firstRun = false
        setTimeout(function() {
          initLock = false
        }, eventCancelTimer)
      },

      reset: function resetFromParent() {
        if (!initLock) {
          log('Page size reset by host page')
          triggerReset('resetPage')
        } else {
          log('Page reset ignored by init')
        }
      },

      resize: function resizeFromParent() {
        sendSize('resizeParent', 'Parent window requested size check')
      },

      moveToAnchor: function moveToAnchorF() {
        inPageLinks.findTarget(getData())
      },
      inPageLink: function inPageLinkF() {
        this.moveToAnchor()
      }, // Backward compatability

      pageInfo: function pageInfoFromParent() {
        var msgBody = getData()
        log('PageInfoFromParent called from parent: ' + msgBody)
        onPageInfo(JSON.parse(msgBody))
        log(' --')
      },

      message: function messageFromParent() {
        var msgBody = getData()

        log('onMessage called from parent: ' + msgBody)
        // eslint-disable-next-line sonarjs/no-extra-arguments
        onMessage(JSON.parse(msgBody))
        log(' --')
      }
    }

    function isMessageForUs() {
      return msgID === ('' + event.data).substr(0, msgIdLen) // ''+ Protects against non-string messages
    }

    function getMessageType() {
      return event.data.split(']')[1].split(':')[0]
    }

    function getData() {
      return event.data.substr(event.data.indexOf(':') + 1)
    }

    function isMiddleTier() {
      return (
        (!(typeof module !== 'undefined' && module.exports) &&
          'iFrameResize' in window) ||
        ('jQuery' in window && 'iFrameResize' in __webpack_provided_window_dot_jQuery.prototype)
      )
    }

    function isInitMsg() {
      // Test if this message is from a child below us. This is an ugly test, however, updating
      // the message format would break backwards compatibity.
      return event.data.split(':')[2] in { true: 1, false: 1 }
    }

    function callFromParent() {
      var messageType = getMessageType()

      if (messageType in processRequestFromParent) {
        processRequestFromParent[messageType]()
      } else if (!isMiddleTier() && !isInitMsg()) {
        warn('Unexpected message (' + event.data + ')')
      }
    }

    function processMessage() {
      if (false === firstRun) {
        callFromParent()
      } else if (isInitMsg()) {
        processRequestFromParent.init()
      } else {
        log(
          'Ignored message of type "' +
            getMessageType() +
            '". Received before initialization.'
        )
      }
    }

    if (isMessageForUs()) {
      processMessage()
    }
  }

  // Normally the parent kicks things off when it detects the iFrame has loaded.
  // If this script is async-loaded, then tell parent page to retry init.
  function chkLateLoaded() {
    if ('loading' !== document.readyState) {
      window.parent.postMessage('[iFrameResizerChild]Ready', '*')
    }
  }

  addEventListener(window, 'message', receiver)
  addEventListener(window, 'readystatechange', chkLateLoaded)
  chkLateLoaded()

  
})()

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./node_modules/iframe-resizer/js/iframeResizer.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 * File: iframeResizer.js
 * Desc: Force iframes to size to content.
 * Requires: iframeResizer.contentWindow.js to be loaded into the target frame.
 * Doc: https://github.com/davidjbradshaw/iframe-resizer
 * Author: David J. Bradshaw - dave@bradshaw.net
 * Contributor: Jure Mav - jure.mav@gmail.com
 * Contributor: Reed Dadoune - reed@dadoune.com
 */

// eslint-disable-next-line sonarjs/cognitive-complexity, no-shadow-restricted-names
;(function(undefined) {
  if (typeof window === 'undefined') return // don't run for server side render

  var count = 0,
    logEnabled = false,
    hiddenCheckEnabled = false,
    msgHeader = 'message',
    msgHeaderLen = msgHeader.length,
    msgId = '[iFrameSizer]', // Must match iframe msg ID
    msgIdLen = msgId.length,
    pagePosition = null,
    requestAnimationFrame = window.requestAnimationFrame,
    resetRequiredMethods = {
      max: 1,
      scroll: 1,
      bodyScroll: 1,
      documentElementScroll: 1
    },
    settings = {},
    timer = null,
    defaults = {
      autoResize: true,
      bodyBackground: null,
      bodyMargin: null,
      bodyMarginV1: 8,
      bodyPadding: null,
      checkOrigin: true,
      inPageLinks: false,
      enablePublicMethods: true,
      heightCalculationMethod: 'bodyOffset',
      id: 'iFrameResizer',
      interval: 32,
      log: false,
      maxHeight: Infinity,
      maxWidth: Infinity,
      minHeight: 0,
      minWidth: 0,
      resizeFrom: 'parent',
      scrolling: false,
      sizeHeight: true,
      sizeWidth: false,
      warningTimeout: 5000,
      tolerance: 0,
      widthCalculationMethod: 'scroll',
      onClose: function() {
        return true
      },
      onClosed: function() {},
      onInit: function() {},
      onMessage: function() {
        warn('onMessage function not defined')
      },
      onResized: function() {},
      onScroll: function() {
        return true
      }
    }

  function getMutationObserver() {
    return (
      window.MutationObserver ||
      window.WebKitMutationObserver ||
      window.MozMutationObserver
    )
  }

  function addEventListener(el, evt, func) {
    el.addEventListener(evt, func, false)
  }

  function removeEventListener(el, evt, func) {
    el.removeEventListener(evt, func, false)
  }

  function setupRequestAnimationFrame() {
    var vendors = ['moz', 'webkit', 'o', 'ms']
    var x

    // Remove vendor prefixing if prefixed and break early if not
    for (x = 0; x < vendors.length && !requestAnimationFrame; x += 1) {
      requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame']
    }

    if (!requestAnimationFrame) {
      log('setup', 'RequestAnimationFrame not supported')
    } else {
      // Firefox extension content-scripts have a globalThis object that is not the same as window.
      // Binding `requestAnimationFrame` to window allows the function to work and prevents errors
      // being thrown when run in that context, and should be a no-op in every other context.
      requestAnimationFrame = requestAnimationFrame.bind(window);
    }
  }

  function getMyID(iframeId) {
    var retStr = 'Host page: ' + iframeId

    if (window.top !== window.self) {
      if (window.parentIFrame && window.parentIFrame.getId) {
        retStr = window.parentIFrame.getId() + ': ' + iframeId
      } else {
        retStr = 'Nested host page: ' + iframeId
      }
    }

    return retStr
  }

  function formatLogHeader(iframeId) {
    return msgId + '[' + getMyID(iframeId) + ']'
  }

  function isLogEnabled(iframeId) {
    return settings[iframeId] ? settings[iframeId].log : logEnabled
  }

  function log(iframeId, msg) {
    output('log', iframeId, msg, isLogEnabled(iframeId))
  }

  function info(iframeId, msg) {
    output('info', iframeId, msg, isLogEnabled(iframeId))
  }

  function warn(iframeId, msg) {
    output('warn', iframeId, msg, true)
  }

  function output(type, iframeId, msg, enabled) {
    if (true === enabled && 'object' === typeof window.console) {
      // eslint-disable-next-line no-console
      console[type](formatLogHeader(iframeId), msg)
    }
  }

  function iFrameListener(event) {
    function resizeIFrame() {
      function resize() {
        setSize(messageData)
        setPagePosition(iframeId)
        on('onResized', messageData)
      }

      ensureInRange('Height')
      ensureInRange('Width')

      syncResize(resize, messageData, 'init')
    }

    function processMsg() {
      var data = msg.substr(msgIdLen).split(':')
      var height = data[1] ? parseInt(data[1], 10) : 0;
      var iframe = settings[data[0]] && settings[data[0]].iframe;
      var compStyle = getComputedStyle(iframe)

      return {
        iframe: iframe,
        id: data[0],
        height: height + getPaddingEnds(compStyle) + getBorderEnds(compStyle),
        width: data[2],
        type: data[3]
      }
    }

    function getPaddingEnds(compStyle) {
      if (compStyle.boxSizing !== 'border-box') {
        return 0;
      }
      var top = compStyle.paddingTop ? parseInt(compStyle.paddingTop, 10) : 0
      var bot = compStyle.paddingBottom ? parseInt(compStyle.paddingBottom, 10) : 0
      return top + bot
    }

    function getBorderEnds(compStyle) {
      if (compStyle.boxSizing !== 'border-box') {
        return 0;
      }
      var top = compStyle.borderTopWidth ? parseInt(compStyle.borderTopWidth, 10) : 0
      var bot = compStyle.borderBottomWidth ? parseInt(compStyle.borderBottomWidth, 10) : 0
      return top + bot
    }

    function ensureInRange(Dimension) {
      var max = Number(settings[iframeId]['max' + Dimension]),
        min = Number(settings[iframeId]['min' + Dimension]),
        dimension = Dimension.toLowerCase(),
        size = Number(messageData[dimension])

      log(iframeId, 'Checking ' + dimension + ' is in range ' + min + '-' + max)

      if (size < min) {
        size = min
        log(iframeId, 'Set ' + dimension + ' to min value')
      }

      if (size > max) {
        size = max
        log(iframeId, 'Set ' + dimension + ' to max value')
      }

      messageData[dimension] = '' + size
    }

    function isMessageFromIFrame() {
      function checkAllowedOrigin() {
        function checkList() {
          var i = 0,
            retCode = false

          log(
            iframeId,
            'Checking connection is from allowed list of origins: ' +
              checkOrigin
          )

          for (; i < checkOrigin.length; i++) {
            if (checkOrigin[i] === origin) {
              retCode = true
              break
            }
          }
          return retCode
        }

        function checkSingle() {
          var remoteHost = settings[iframeId] && settings[iframeId].remoteHost
          log(iframeId, 'Checking connection is from: ' + remoteHost)
          return origin === remoteHost
        }

        return checkOrigin.constructor === Array ? checkList() : checkSingle()
      }

      var origin = event.origin,
        checkOrigin = settings[iframeId] && settings[iframeId].checkOrigin

      if (checkOrigin && '' + origin !== 'null' && !checkAllowedOrigin()) {
        throw new Error(
          'Unexpected message received from: ' +
            origin +
            ' for ' +
            messageData.iframe.id +
            '. Message was: ' +
            event.data +
            '. This error can be disabled by setting the checkOrigin: false option or by providing of array of trusted domains.'
        )
      }

      return true
    }

    function isMessageForUs() {
      return (
        msgId === ('' + msg).substr(0, msgIdLen) &&
        msg.substr(msgIdLen).split(':')[0] in settings
      ) // ''+Protects against non-string msg
    }

    function isMessageFromMetaParent() {
      // Test if this message is from a parent above us. This is an ugly test, however, updating
      // the message format would break backwards compatibity.
      var retCode = messageData.type in { true: 1, false: 1, undefined: 1 }

      if (retCode) {
        log(iframeId, 'Ignoring init message from meta parent page')
      }

      return retCode
    }

    function getMsgBody(offset) {
      return msg.substr(msg.indexOf(':') + msgHeaderLen + offset)
    }

    function forwardMsgFromIFrame(msgBody) {
      log(
        iframeId,
        'onMessage passed: {iframe: ' +
          messageData.iframe.id +
          ', message: ' +
          msgBody +
          '}'
      )
      on('onMessage', {
        iframe: messageData.iframe,
        message: JSON.parse(msgBody)
      })
      log(iframeId, '--')
    }

    function getPageInfo() {
      var bodyPosition = document.body.getBoundingClientRect(),
        iFramePosition = messageData.iframe.getBoundingClientRect()

      return JSON.stringify({
        iframeHeight: iFramePosition.height,
        iframeWidth: iFramePosition.width,
        clientHeight: Math.max(
          document.documentElement.clientHeight,
          window.innerHeight || 0
        ),
        clientWidth: Math.max(
          document.documentElement.clientWidth,
          window.innerWidth || 0
        ),
        offsetTop: parseInt(iFramePosition.top - bodyPosition.top, 10),
        offsetLeft: parseInt(iFramePosition.left - bodyPosition.left, 10),
        scrollTop: window.pageYOffset,
        scrollLeft: window.pageXOffset,
        documentHeight: document.documentElement.clientHeight,
        documentWidth: document.documentElement.clientWidth,
        windowHeight: window.innerHeight,
        windowWidth: window.innerWidth
      })
    }

    function sendPageInfoToIframe(iframe, iframeId) {
      function debouncedTrigger() {
        trigger('Send Page Info', 'pageInfo:' + getPageInfo(), iframe, iframeId)
      }
      debounceFrameEvents(debouncedTrigger, 32, iframeId)
    }

    function startPageInfoMonitor() {
      function setListener(type, func) {
        function sendPageInfo() {
          if (settings[id]) {
            sendPageInfoToIframe(settings[id].iframe, id)
          } else {
            stop()
          }
        }

        ;['scroll', 'resize'].forEach(function(evt) {
          log(id, type + evt + ' listener for sendPageInfo')
          func(window, evt, sendPageInfo)
        })
      }

      function stop() {
        setListener('Remove ', removeEventListener)
      }

      function start() {
        setListener('Add ', addEventListener)
      }

      var id = iframeId // Create locally scoped copy of iFrame ID

      start()

      if (settings[id]) {
        settings[id].stopPageInfo = stop
      }
    }

    function stopPageInfoMonitor() {
      if (settings[iframeId] && settings[iframeId].stopPageInfo) {
        settings[iframeId].stopPageInfo()
        delete settings[iframeId].stopPageInfo
      }
    }

    function checkIFrameExists() {
      var retBool = true

      if (null === messageData.iframe) {
        warn(iframeId, 'IFrame (' + messageData.id + ') not found')
        retBool = false
      }
      return retBool
    }

    function getElementPosition(target) {
      var iFramePosition = target.getBoundingClientRect()

      getPagePosition(iframeId)

      return {
        x: Math.floor(Number(iFramePosition.left) + Number(pagePosition.x)),
        y: Math.floor(Number(iFramePosition.top) + Number(pagePosition.y))
      }
    }

    function scrollRequestFromChild(addOffset) {
      /* istanbul ignore next */ // Not testable in Karma
      function reposition() {
        pagePosition = newPosition
        scrollTo()
        log(iframeId, '--')
      }

      function calcOffset() {
        return {
          x: Number(messageData.width) + offset.x,
          y: Number(messageData.height) + offset.y
        }
      }

      function scrollParent() {
        if (window.parentIFrame) {
          window.parentIFrame['scrollTo' + (addOffset ? 'Offset' : '')](
            newPosition.x,
            newPosition.y
          )
        } else {
          warn(
            iframeId,
            'Unable to scroll to requested position, window.parentIFrame not found'
          )
        }
      }

      var offset = addOffset
          ? getElementPosition(messageData.iframe)
          : { x: 0, y: 0 },
        newPosition = calcOffset()

      log(
        iframeId,
        'Reposition requested from iFrame (offset x:' +
          offset.x +
          ' y:' +
          offset.y +
          ')'
      )

      if (window.top !== window.self) {
        scrollParent()
      } else {
        reposition()
      }
    }

    function scrollTo() {
      if (false !== on('onScroll', pagePosition)) {
        setPagePosition(iframeId)
      } else {
        unsetPagePosition()
      }
    }

    function findTarget(location) {
      function jumpToTarget() {
        var jumpPosition = getElementPosition(target)

        log(
          iframeId,
          'Moving to in page link (#' +
            hash +
            ') at x: ' +
            jumpPosition.x +
            ' y: ' +
            jumpPosition.y
        )
        pagePosition = {
          x: jumpPosition.x,
          y: jumpPosition.y
        }

        scrollTo()
        log(iframeId, '--')
      }

      function jumpToParent() {
        if (window.parentIFrame) {
          window.parentIFrame.moveToAnchor(hash)
        } else {
          log(
            iframeId,
            'In page link #' +
              hash +
              ' not found and window.parentIFrame not found'
          )
        }
      }

      var hash = location.split('#')[1] || '',
        hashData = decodeURIComponent(hash),
        target =
          document.getElementById(hashData) ||
          document.getElementsByName(hashData)[0]

      if (target) {
        jumpToTarget()
      } else if (window.top !== window.self) {
        jumpToParent()
      } else {
        log(iframeId, 'In page link #' + hash + ' not found')
      }
    }

    function on(funcName, val) {
      return chkEvent(iframeId, funcName, val)
    }

    function actionMsg() {
      if (settings[iframeId] && settings[iframeId].firstRun) firstRun()

      switch (messageData.type) {
        case 'close':
          closeIFrame(messageData.iframe)
          break

        case 'message':
          forwardMsgFromIFrame(getMsgBody(6))
          break

        case 'autoResize':
          settings[iframeId].autoResize = JSON.parse(getMsgBody(9))
          break

        case 'scrollTo':
          scrollRequestFromChild(false)
          break

        case 'scrollToOffset':
          scrollRequestFromChild(true)
          break

        case 'pageInfo':
          sendPageInfoToIframe(
            settings[iframeId] && settings[iframeId].iframe,
            iframeId
          )
          startPageInfoMonitor()
          break

        case 'pageInfoStop':
          stopPageInfoMonitor()
          break

        case 'inPageLink':
          findTarget(getMsgBody(9))
          break

        case 'reset':
          resetIFrame(messageData)
          break

        case 'init':
          resizeIFrame()
          on('onInit', messageData.iframe)
          break

        default:
          resizeIFrame()
      }
    }

    function hasSettings(iframeId) {
      var retBool = true

      if (!settings[iframeId]) {
        retBool = false
        warn(
          messageData.type +
            ' No settings for ' +
            iframeId +
            '. Message was: ' +
            msg
        )
      }

      return retBool
    }

    function iFrameReadyMsgReceived() {
      // eslint-disable-next-line no-restricted-syntax, guard-for-in
      for (var iframeId in settings) {
        trigger(
          'iFrame requested init',
          createOutgoingMsg(iframeId),
          settings[iframeId].iframe,
          iframeId
        )
      }
    }

    function firstRun() {
      if (settings[iframeId]) {
        settings[iframeId].firstRun = false
      }
    }

    var msg = event.data,
      messageData = {},
      iframeId = null

    if ('[iFrameResizerChild]Ready' === msg) {
      iFrameReadyMsgReceived()
    } else if (isMessageForUs()) {
      messageData = processMsg()
      iframeId = messageData.id
      if (settings[iframeId]) {
        settings[iframeId].loaded = true
      }

      if (!isMessageFromMetaParent() && hasSettings(iframeId)) {
        log(iframeId, 'Received: ' + msg)

        if (checkIFrameExists() && isMessageFromIFrame()) {
          actionMsg()
        }
      }
    } else {
      info(iframeId, 'Ignored: ' + msg)
    }
  }

  function chkEvent(iframeId, funcName, val) {
    var func = null,
      retVal = null

    if (settings[iframeId]) {
      func = settings[iframeId][funcName]

      if ('function' === typeof func) {
        retVal = func(val)
      } else {
        throw new TypeError(
          funcName + ' on iFrame[' + iframeId + '] is not a function'
        )
      }
    }

    return retVal
  }

  function removeIframeListeners(iframe) {
    var iframeId = iframe.id
    delete settings[iframeId]
  }

  function closeIFrame(iframe) {
    var iframeId = iframe.id
    if (chkEvent(iframeId, 'onClose', iframeId) === false) {
      log(iframeId, 'Close iframe cancelled by onClose event')
      return
    }
    log(iframeId, 'Removing iFrame: ' + iframeId)

    try {
      // Catch race condition error with React
      if (iframe.parentNode) {
        iframe.parentNode.removeChild(iframe)
      }
    } catch (error) {
      warn(error)
    }

    chkEvent(iframeId, 'onClosed', iframeId)
    log(iframeId, '--')
    removeIframeListeners(iframe)
  }

  function getPagePosition(iframeId) {
    if (null === pagePosition) {
      pagePosition = {
        x:
          window.pageXOffset !== undefined
            ? window.pageXOffset
            : document.documentElement.scrollLeft,
        y:
          window.pageYOffset !== undefined
            ? window.pageYOffset
            : document.documentElement.scrollTop
      }
      log(
        iframeId,
        'Get page position: ' + pagePosition.x + ',' + pagePosition.y
      )
    }
  }

  function setPagePosition(iframeId) {
    if (null !== pagePosition) {
      window.scrollTo(pagePosition.x, pagePosition.y)
      log(
        iframeId,
        'Set page position: ' + pagePosition.x + ',' + pagePosition.y
      )
      unsetPagePosition()
    }
  }

  function unsetPagePosition() {
    pagePosition = null
  }

  function resetIFrame(messageData) {
    function reset() {
      setSize(messageData)
      trigger('reset', 'reset', messageData.iframe, messageData.id)
    }

    log(
      messageData.id,
      'Size reset requested by ' +
        ('init' === messageData.type ? 'host page' : 'iFrame')
    )
    getPagePosition(messageData.id)
    syncResize(reset, messageData, 'reset')
  }

  function setSize(messageData) {
    function setDimension(dimension) {
      if (!messageData.id) {
        log('undefined', 'messageData id not set')
        return
      }
      messageData.iframe.style[dimension] = messageData[dimension] + 'px'
      log(
        messageData.id,
        'IFrame (' +
          iframeId +
          ') ' +
          dimension +
          ' set to ' +
          messageData[dimension] +
          'px'
      )
    }

    function chkZero(dimension) {
      // FireFox sets dimension of hidden iFrames to zero.
      // So if we detect that set up an event to check for
      // when iFrame becomes visible.

      /* istanbul ignore next */ // Not testable in PhantomJS
      if (!hiddenCheckEnabled && '0' === messageData[dimension]) {
        hiddenCheckEnabled = true
        log(iframeId, 'Hidden iFrame detected, creating visibility listener')
        fixHiddenIFrames()
      }
    }

    function processDimension(dimension) {
      setDimension(dimension)
      chkZero(dimension)
    }

    var iframeId = messageData.iframe.id

    if (settings[iframeId]) {
      if (settings[iframeId].sizeHeight) {
        processDimension('height')
      }
      if (settings[iframeId].sizeWidth) {
        processDimension('width')
      }
    }
  }

  function syncResize(func, messageData, doNotSync) {
    /* istanbul ignore if */ // Not testable in PhantomJS
    if (doNotSync !== messageData.type && requestAnimationFrame &&
        // including check for jasmine because had trouble getting spy to work in unit test using requestAnimationFrame
        !window.jasmine) {
      log(messageData.id, 'Requesting animation frame')
      requestAnimationFrame(func)
    } else {
      func()
    }
  }

  function trigger(calleeMsg, msg, iframe, id, noResponseWarning) {
    function postMessageToIFrame() {
      var target = settings[id] && settings[id].targetOrigin
      log(
        id,
        '[' +
          calleeMsg +
          '] Sending msg to iframe[' +
          id +
          '] (' +
          msg +
          ') targetOrigin: ' +
          target
      )
      iframe.contentWindow.postMessage(msgId + msg, target)
    }

    function iFrameNotFound() {
      warn(id, '[' + calleeMsg + '] IFrame(' + id + ') not found')
    }

    function chkAndSend() {
      if (
        iframe &&
        'contentWindow' in iframe &&
        null !== iframe.contentWindow
      ) {
        // Null test for PhantomJS
        postMessageToIFrame()
      } else {
        iFrameNotFound()
      }
    }

    function warnOnNoResponse() {
      function warning() {
        if (settings[id] && !settings[id].loaded && !errorShown) {
          errorShown = true
          warn(
            id,
            'IFrame has not responded within ' +
              settings[id].warningTimeout / 1000 +
              ' seconds. Check iFrameResizer.contentWindow.js has been loaded in iFrame. This message can be ignored if everything is working, or you can set the warningTimeout option to a higher value or zero to suppress this warning.'
          )
        }
      }

      if (
        !!noResponseWarning &&
        settings[id] &&
        !!settings[id].warningTimeout
      ) {
        settings[id].msgTimeout = setTimeout(
          warning,
          settings[id].warningTimeout
        )
      }
    }

    var errorShown = false

    id = id || iframe.id

    if (settings[id]) {
      chkAndSend()
      warnOnNoResponse()
    }
  }

  function createOutgoingMsg(iframeId) {
    return (
      iframeId +
      ':' +
      settings[iframeId].bodyMarginV1 +
      ':' +
      settings[iframeId].sizeWidth +
      ':' +
      settings[iframeId].log +
      ':' +
      settings[iframeId].interval +
      ':' +
      settings[iframeId].enablePublicMethods +
      ':' +
      settings[iframeId].autoResize +
      ':' +
      settings[iframeId].bodyMargin +
      ':' +
      settings[iframeId].heightCalculationMethod +
      ':' +
      settings[iframeId].bodyBackground +
      ':' +
      settings[iframeId].bodyPadding +
      ':' +
      settings[iframeId].tolerance +
      ':' +
      settings[iframeId].inPageLinks +
      ':' +
      settings[iframeId].resizeFrom +
      ':' +
      settings[iframeId].widthCalculationMethod
    )
  }

  function setupIFrame(iframe, options) {
    function setLimits() {
      function addStyle(style) {
        if (
          Infinity !== settings[iframeId][style] &&
          0 !== settings[iframeId][style]
        ) {
          iframe.style[style] = settings[iframeId][style] + 'px'
          log(
            iframeId,
            'Set ' + style + ' = ' + settings[iframeId][style] + 'px'
          )
        }
      }

      function chkMinMax(dimension) {
        if (
          settings[iframeId]['min' + dimension] >
          settings[iframeId]['max' + dimension]
        ) {
          throw new Error(
            'Value for min' +
              dimension +
              ' can not be greater than max' +
              dimension
          )
        }
      }

      chkMinMax('Height')
      chkMinMax('Width')

      addStyle('maxHeight')
      addStyle('minHeight')
      addStyle('maxWidth')
      addStyle('minWidth')
    }

    function newId() {
      var id = (options && options.id) || defaults.id + count++
      if (null !== document.getElementById(id)) {
        id += count++
      }
      return id
    }

    function ensureHasId(iframeId) {
      if ('' === iframeId) {
        // eslint-disable-next-line no-multi-assign
        iframe.id = iframeId = newId()
        logEnabled = (options || {}).log
        log(
          iframeId,
          'Added missing iframe ID: ' + iframeId + ' (' + iframe.src + ')'
        )
      }

      return iframeId
    }

    function setScrolling() {
      log(
        iframeId,
        'IFrame scrolling ' +
          (settings[iframeId] && settings[iframeId].scrolling
            ? 'enabled'
            : 'disabled') +
          ' for ' +
          iframeId
      )
      iframe.style.overflow =
        false === (settings[iframeId] && settings[iframeId].scrolling)
          ? 'hidden'
          : 'auto'
      switch (settings[iframeId] && settings[iframeId].scrolling) {
        case 'omit':
          break

        case true:
          iframe.scrolling = 'yes'
          break

        case false:
          iframe.scrolling = 'no'
          break

        default:
          iframe.scrolling = settings[iframeId]
            ? settings[iframeId].scrolling
            : 'no'
      }
    }

    // The V1 iFrame script expects an int, where as in V2 expects a CSS
    // string value such as '1px 3em', so if we have an int for V2, set V1=V2
    // and then convert V2 to a string PX value.
    function setupBodyMarginValues() {
      if (
        'number' ===
          typeof (settings[iframeId] && settings[iframeId].bodyMargin) ||
        '0' === (settings[iframeId] && settings[iframeId].bodyMargin)
      ) {
        settings[iframeId].bodyMarginV1 = settings[iframeId].bodyMargin
        settings[iframeId].bodyMargin =
          '' + settings[iframeId].bodyMargin + 'px'
      }
    }

    function checkReset() {
      // Reduce scope of firstRun to function, because IE8's JS execution
      // context stack is borked and this value gets externally
      // changed midway through running this function!!!
      var firstRun = settings[iframeId] && settings[iframeId].firstRun,
        resetRequertMethod =
          settings[iframeId] &&
          settings[iframeId].heightCalculationMethod in resetRequiredMethods

      if (!firstRun && resetRequertMethod) {
        resetIFrame({ iframe: iframe, height: 0, width: 0, type: 'init' })
      }
    }

    function setupIFrameObject() {
      if (settings[iframeId]) {
        settings[iframeId].iframe.iFrameResizer = {
          close: closeIFrame.bind(null, settings[iframeId].iframe),

          removeListeners: removeIframeListeners.bind(
            null,
            settings[iframeId].iframe
          ),

          resize: trigger.bind(
            null,
            'Window resize',
            'resize',
            settings[iframeId].iframe
          ),

          moveToAnchor: function(anchor) {
            trigger(
              'Move to anchor',
              'moveToAnchor:' + anchor,
              settings[iframeId].iframe,
              iframeId
            )
          },

          sendMessage: function(message) {
            message = JSON.stringify(message)
            trigger(
              'Send Message',
              'message:' + message,
              settings[iframeId].iframe,
              iframeId
            )
          }
        }
      }
    }

    // We have to call trigger twice, as we can not be sure if all
    // iframes have completed loading when this code runs. The
    // event listener also catches the page changing in the iFrame.
    function init(msg) {
      function iFrameLoaded() {
        trigger('iFrame.onload', msg, iframe, undefined, true)
        checkReset()
      }

      function createDestroyObserver(MutationObserver) {
        if (!iframe.parentNode) {
          return
        }

        var destroyObserver = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            var removedNodes = Array.prototype.slice.call(mutation.removedNodes) // Transform NodeList into an Array
            removedNodes.forEach(function(removedNode) {
              if (removedNode === iframe) {
                closeIFrame(iframe)
              }
            })
          })
        })
        destroyObserver.observe(iframe.parentNode, {
          childList: true
        })
      }

      var MutationObserver = getMutationObserver()
      if (MutationObserver) {
        createDestroyObserver(MutationObserver)
      }

      addEventListener(iframe, 'load', iFrameLoaded)
      trigger('init', msg, iframe, undefined, true)
    }

    function checkOptions(options) {
      if ('object' !== typeof options) {
        throw new TypeError('Options is not an object')
      }
    }

    function copyOptions(options) {
      // eslint-disable-next-line no-restricted-syntax
      for (var option in defaults) {
        if (Object.prototype.hasOwnProperty.call(defaults, option)) {
          settings[iframeId][option] = Object.prototype.hasOwnProperty.call(
            options,
            option
          )
            ? options[option]
            : defaults[option]
        }
      }
    }

    function getTargetOrigin(remoteHost) {
      return '' === remoteHost || null !== remoteHost.match(/^(about:blank|javascript:|file:\/\/)/) ? '*' : remoteHost
    }

    function depricate(key) {
      var splitName = key.split('Callback')

      if (splitName.length === 2) {
        var name =
          'on' + splitName[0].charAt(0).toUpperCase() + splitName[0].slice(1)
        this[name] = this[key]
        delete this[key]
        warn(
          iframeId,
          "Deprecated: '" +
            key +
            "' has been renamed '" +
            name +
            "'. The old method will be removed in the next major version."
        )
      }
    }

    function processOptions(options) {
      options = options || {}
      settings[iframeId] = {
        firstRun: true,
        iframe: iframe,
        remoteHost:
          iframe.src &&
          iframe.src
            .split('/')
            .slice(0, 3)
            .join('/')
      }

      checkOptions(options)
      Object.keys(options).forEach(depricate, options)
      copyOptions(options)

      if (settings[iframeId]) {
        settings[iframeId].targetOrigin =
          true === settings[iframeId].checkOrigin
            ? getTargetOrigin(settings[iframeId].remoteHost)
            : '*'
      }
    }

    function beenHere() {
      return iframeId in settings && 'iFrameResizer' in iframe
    }

    var iframeId = ensureHasId(iframe.id)

    if (!beenHere()) {
      processOptions(options)
      setScrolling()
      setLimits()
      setupBodyMarginValues()
      init(createOutgoingMsg(iframeId))
      setupIFrameObject()
    } else {
      warn(iframeId, 'Ignored iFrame, already setup.')
    }
  }

  function debouce(fn, time) {
    if (null === timer) {
      timer = setTimeout(function() {
        timer = null
        fn()
      }, time)
    }
  }

  var frameTimer = {}
  function debounceFrameEvents(fn, time, frameId) {
    if (!frameTimer[frameId]) {
      frameTimer[frameId] = setTimeout(function() {
        frameTimer[frameId] = null
        fn()
      }, time)
    }
  }

  // Not testable in PhantomJS
  /* istanbul ignore next */

  function fixHiddenIFrames() {
    function checkIFrames() {
      function checkIFrame(settingId) {
        function chkDimension(dimension) {
          return (
            '0px' ===
            (settings[settingId] && settings[settingId].iframe.style[dimension])
          )
        }

        function isVisible(el) {
          return null !== el.offsetParent
        }

        if (
          settings[settingId] &&
          isVisible(settings[settingId].iframe) &&
          (chkDimension('height') || chkDimension('width'))
        ) {
          trigger(
            'Visibility change',
            'resize',
            settings[settingId].iframe,
            settingId
          )
        }
      }

      Object.keys(settings).forEach(function(key) {
        checkIFrame(key)
      })
    }

    function mutationObserved(mutations) {
      log(
        'window',
        'Mutation observed: ' + mutations[0].target + ' ' + mutations[0].type
      )
      debouce(checkIFrames, 16)
    }

    function createMutationObserver() {
      var target = document.querySelector('body'),
        config = {
          attributes: true,
          attributeOldValue: false,
          characterData: true,
          characterDataOldValue: false,
          childList: true,
          subtree: true
        },
        observer = new MutationObserver(mutationObserved)

      observer.observe(target, config)
    }

    var MutationObserver = getMutationObserver()
    if (MutationObserver) {
      createMutationObserver()
    }
  }

  function resizeIFrames(event) {
    function resize() {
      sendTriggerMsg('Window ' + event, 'resize')
    }

    log('window', 'Trigger event: ' + event)
    debouce(resize, 16)
  }

  // Not testable in PhantomJS
  /* istanbul ignore next */
  function tabVisible() {
    function resize() {
      sendTriggerMsg('Tab Visable', 'resize')
    }

    if ('hidden' !== document.visibilityState) {
      log('document', 'Trigger event: Visiblity change')
      debouce(resize, 16)
    }
  }

  function sendTriggerMsg(eventName, event) {
    function isIFrameResizeEnabled(iframeId) {
      return (
        settings[iframeId] &&
        'parent' === settings[iframeId].resizeFrom &&
        settings[iframeId].autoResize &&
        !settings[iframeId].firstRun
      )
    }

    Object.keys(settings).forEach(function(iframeId) {
      if (isIFrameResizeEnabled(iframeId)) {
        trigger(eventName, event, settings[iframeId].iframe, iframeId)
      }
    })
  }

  function setupEventListeners() {
    addEventListener(window, 'message', iFrameListener)

    addEventListener(window, 'resize', function() {
      resizeIFrames('resize')
    })

    addEventListener(document, 'visibilitychange', tabVisible)

    addEventListener(document, '-webkit-visibilitychange', tabVisible)
  }

  function factory() {
    function init(options, element) {
      function chkType() {
        if (!element.tagName) {
          throw new TypeError('Object is not a valid DOM element')
        } else if ('IFRAME' !== element.tagName.toUpperCase()) {
          throw new TypeError(
            'Expected <IFRAME> tag, found <' + element.tagName + '>'
          )
        }
      }

      if (element) {
        chkType()
        setupIFrame(element, options)
        iFrames.push(element)
      }
    }

    function warnDeprecatedOptions(options) {
      if (options && options.enablePublicMethods) {
        warn(
          'enablePublicMethods option has been removed, public methods are now always available in the iFrame'
        )
      }
    }

    var iFrames

    setupRequestAnimationFrame()
    setupEventListeners()

    return function iFrameResizeF(options, target) {
      iFrames = [] // Only return iFrames past in on this call

      warnDeprecatedOptions(options)

      switch (typeof target) {
        case 'undefined':
        case 'string':
          Array.prototype.forEach.call(
            document.querySelectorAll(target || 'iframe'),
            init.bind(undefined, options)
          )
          break

        case 'object':
          init(options, target)
          break

        default:
          throw new TypeError('Unexpected data type (' + typeof target + ')')
      }

      return iFrames
    }
  }

  function createJQueryPublicMethod($) {
    if (!$.fn) {
      info('', 'Unable to bind to jQuery, it is not fully loaded.')
    } else if (!$.fn.iFrameResize) {
      $.fn.iFrameResize = function $iFrameResizeF(options) {
        function init(index, element) {
          setupIFrame(element, options)
        }

        return this.filter('iframe')
          .each(init)
          .end()
      }
    }
  }

  if (__webpack_provided_window_dot_jQuery) {
    createJQueryPublicMethod(__webpack_provided_window_dot_jQuery)
  }

  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof module === 'object' && typeof module.exports === 'object') {
    // Node for browserfy
    module.exports = factory()
  }
  window.iFrameResize = window.iFrameResize || factory()
})()

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./node_modules/iframe-resizer/js/index.js":
/***/ (function(module, exports, __webpack_require__) {

var iframeResize = __webpack_require__("./node_modules/iframe-resizer/js/iframeResizer.js")

exports.iframeResize = iframeResize
exports.iframeResizer = iframeResize // Backwards compatability
exports.iframeResizerContentWindow = __webpack_require__("./node_modules/iframe-resizer/js/iframeResizer.contentWindow.js")


/***/ }),

/***/ "./node_modules/inherits/inherits_browser.js":
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),

/***/ "./node_modules/ionic-angular/animations/animation.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Animation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");

/**
 * @hidden
 */
var Animation = (function () {
    function Animation(plt, ele, opts) {
        this._dur = null;
        this._es = null;
        this._rvEs = null;
        this.hasChildren = false;
        this.isPlaying = false;
        this.hasCompleted = false;
        this.plt = plt;
        this.element(ele);
        this.opts = opts;
    }
    Animation.prototype.element = function (ele) {
        if (ele) {
            if (typeof ele === 'string') {
                ele = this.plt.doc().querySelectorAll(ele);
                for (var i = 0; i < ele.length; i++) {
                    this._addEle(ele[i]);
                }
            }
            else if (ele.length) {
                for (var i = 0; i < ele.length; i++) {
                    this._addEle(ele[i]);
                }
            }
            else {
                this._addEle(ele);
            }
        }
        return this;
    };
    /**
     * NO DOM
     */
    Animation.prototype._addEle = function (ele) {
        if (ele.nativeElement) {
            ele = ele.nativeElement;
        }
        if (ele.nodeType === 1) {
            this._eL = (this._e = this._e || []).push(ele);
        }
    };
    /**
     * Add a child animation to this animation.
     */
    Animation.prototype.add = function (childAnimation) {
        childAnimation.parent = this;
        this.hasChildren = true;
        this._cL = (this._c = this._c || []).push(childAnimation);
        return this;
    };
    /**
     * Get the duration of this animation. If this animation does
     * not have a duration, then it'll get the duration from its parent.
     */
    Animation.prototype.getDuration = function (opts) {
        if (opts && Object(__WEBPACK_IMPORTED_MODULE_0__util_util__["h" /* isDefined */])(opts.duration)) {
            return opts.duration;
        }
        else if (this._dur !== null) {
            return this._dur;
        }
        else if (this.parent) {
            return this.parent.getDuration();
        }
        return 0;
    };
    /**
     * Returns if the animation is a root one.
     */
    Animation.prototype.isRoot = function () {
        return !this.parent;
    };
    /**
     * Set the duration for this animation.
     */
    Animation.prototype.duration = function (milliseconds) {
        this._dur = milliseconds;
        return this;
    };
    /**
     * Get the easing of this animation. If this animation does
     * not have an easing, then it'll get the easing from its parent.
     */
    Animation.prototype.getEasing = function () {
        if (this._rv && this._rvEs) {
            return this._rvEs;
        }
        return this._es !== null ? this._es : (this.parent && this.parent.getEasing()) || null;
    };
    /**
     * Set the easing for this animation.
     */
    Animation.prototype.easing = function (name) {
        this._es = name;
        return this;
    };
    /**
     * Set the easing for this reversed animation.
     */
    Animation.prototype.easingReverse = function (name) {
        this._rvEs = name;
        return this;
    };
    /**
     * Add the "from" value for a specific property.
     */
    Animation.prototype.from = function (prop, val) {
        this._addProp('from', prop, val);
        return this;
    };
    /**
     * Add the "to" value for a specific property.
     */
    Animation.prototype.to = function (prop, val, clearProperyAfterTransition) {
        var fx = this._addProp('to', prop, val);
        if (clearProperyAfterTransition) {
            // if this effect is a transform then clear the transform effect
            // otherwise just clear the actual property
            this.afterClearStyles([fx.trans ? this.plt.Css.transform : prop]);
        }
        return this;
    };
    /**
     * Shortcut to add both the "from" and "to" for the same property.
     */
    Animation.prototype.fromTo = function (prop, fromVal, toVal, clearProperyAfterTransition) {
        return this.from(prop, fromVal).to(prop, toVal, clearProperyAfterTransition);
    };
    /**
     * @hidden
     * NO DOM
     */
    Animation.prototype._getProp = function (name) {
        if (this._fx) {
            return this._fx.find(function (prop) { return prop.name === name; });
        }
        else {
            this._fx = [];
        }
        return null;
    };
    Animation.prototype._addProp = function (state, prop, val) {
        var fxProp = this._getProp(prop);
        if (!fxProp) {
            // first time we've see this EffectProperty
            var shouldTrans = (ANIMATION_TRANSFORMS[prop] === 1);
            fxProp = {
                name: prop,
                trans: shouldTrans,
                // add the will-change property for transforms or opacity
                wc: (shouldTrans ? this.plt.Css.transform : prop)
            };
            this._fx.push(fxProp);
        }
        // add from/to EffectState to the EffectProperty
        var fxState = {
            val: val,
            num: null,
            unit: '',
        };
        fxProp[state] = fxState;
        if (typeof val === 'string' && val.indexOf(' ') < 0) {
            var r = val.match(ANIMATION_CSS_VALUE_REGEX);
            var num = parseFloat(r[1]);
            if (!isNaN(num)) {
                fxState.num = num;
            }
            fxState.unit = (r[0] !== r[2] ? r[2] : '');
        }
        else if (typeof val === 'number') {
            fxState.num = val;
        }
        return fxProp;
    };
    /**
     * Add CSS class to this animation's elements
     * before the animation begins.
     */
    Animation.prototype.beforeAddClass = function (className) {
        (this._bfAdd = this._bfAdd || []).push(className);
        return this;
    };
    /**
     * Remove CSS class from this animation's elements
     * before the animation begins.
     */
    Animation.prototype.beforeRemoveClass = function (className) {
        (this._bfRm = this._bfRm || []).push(className);
        return this;
    };
    /**
     * Set CSS inline styles to this animation's elements
     * before the animation begins.
     */
    Animation.prototype.beforeStyles = function (styles) {
        this._bfSty = styles;
        return this;
    };
    /**
     * Clear CSS inline styles from this animation's elements
     * before the animation begins.
     */
    Animation.prototype.beforeClearStyles = function (propertyNames) {
        this._bfSty = this._bfSty || {};
        for (var i = 0; i < propertyNames.length; i++) {
            this._bfSty[propertyNames[i]] = '';
        }
        return this;
    };
    /**
     * Add a function which contains DOM reads, which will run
     * before the animation begins.
     */
    Animation.prototype.beforeAddRead = function (domReadFn) {
        (this._rdFn = this._rdFn || []).push(domReadFn);
        return this;
    };
    /**
     * Add a function which contains DOM writes, which will run
     * before the animation begins.
     */
    Animation.prototype.beforeAddWrite = function (domWriteFn) {
        (this._wrFn = this._wrFn || []).push(domWriteFn);
        return this;
    };
    /**
     * Add CSS class to this animation's elements
     * after the animation finishes.
     */
    Animation.prototype.afterAddClass = function (className) {
        (this._afAdd = this._afAdd || []).push(className);
        return this;
    };
    /**
     * Remove CSS class from this animation's elements
     * after the animation finishes.
     */
    Animation.prototype.afterRemoveClass = function (className) {
        (this._afRm = this._afRm || []).push(className);
        return this;
    };
    /**
     * Set CSS inline styles to this animation's elements
     * after the animation finishes.
     */
    Animation.prototype.afterStyles = function (styles) {
        this._afSty = styles;
        return this;
    };
    /**
     * Clear CSS inline styles from this animation's elements
     * after the animation finishes.
     */
    Animation.prototype.afterClearStyles = function (propertyNames) {
        this._afSty = this._afSty || {};
        for (var i = 0; i < propertyNames.length; i++) {
            this._afSty[propertyNames[i]] = '';
        }
        return this;
    };
    /**
     * Play the animation.
     */
    Animation.prototype.play = function (opts) {
        var _this = this;
        // If the animation was already invalidated (it did finish), do nothing
        if (!this.plt) {
            return;
        }
        // this is the top level animation and is in full control
        // of when the async play() should actually kick off
        // if there is no duration then it'll set the TO property immediately
        // if there is a duration, then it'll stage all animations at the
        // FROM property and transition duration, wait a few frames, then
        // kick off the animation by setting the TO property for each animation
        this._isAsync = this._hasDuration(opts);
        // ensure all past transition end events have been cleared
        this._clearAsync();
        // recursively kicks off the correct progress step for each child animation
        // ******** DOM WRITE ****************
        this._playInit(opts);
        // doubling up RAFs since this animation was probably triggered
        // from an input event, and just having one RAF would have this code
        // run within the same frame as the triggering input event, and the
        // input event probably already did way too much work for one frame
        this.plt.raf(function () {
            _this.plt.raf(_this._playDomInspect.bind(_this, opts));
        });
    };
    Animation.prototype.syncPlay = function () {
        // If the animation was already invalidated (it did finish), do nothing
        if (!this.plt) {
            return;
        }
        var opts = { duration: 0 };
        this._isAsync = false;
        this._clearAsync();
        this._playInit(opts);
        this._playDomInspect(opts);
    };
    /**
     * @hidden
     * DOM WRITE
     * RECURSION
     */
    Animation.prototype._playInit = function (opts) {
        // always default that an animation does not tween
        // a tween requires that an Animation class has an element
        // and that it has at least one FROM/TO effect
        // and that the FROM/TO effect can tween numeric values
        this._twn = false;
        this.isPlaying = true;
        this.hasCompleted = false;
        this._hasDur = (this.getDuration(opts) > ANIMATION_DURATION_MIN);
        var children = this._c;
        for (var i = 0; i < this._cL; i++) {
            // ******** DOM WRITE ****************
            children[i]._playInit(opts);
        }
        if (this._hasDur) {
            // if there is a duration then we want to start at step 0
            // ******** DOM WRITE ****************
            this._progress(0);
            // add the will-change properties
            // ******** DOM WRITE ****************
            this._willChg(true);
        }
    };
    /**
     * @hidden
     * DOM WRITE
     * NO RECURSION
     * ROOT ANIMATION
     */
    Animation.prototype._playDomInspect = function (opts) {
        // fire off all the "before" function that have DOM READS in them
        // elements will be in the DOM, however visibily hidden
        // so we can read their dimensions if need be
        // ******** DOM READ ****************
        // ******** DOM WRITE ****************
        this._beforeAnimation();
        // for the root animation only
        // set the async TRANSITION END event
        // and run onFinishes when the transition ends
        var dur = this.getDuration(opts);
        if (this._isAsync) {
            this._asyncEnd(dur, true);
        }
        // ******** DOM WRITE ****************
        this._playProgress(opts);
        if (this._isAsync && this.plt) {
            // this animation has a duration so we need another RAF
            // for the CSS TRANSITION properties to kick in
            this.plt.raf(this._playToStep.bind(this, 1));
        }
    };
    /**
     * @hidden
     * DOM WRITE
     * RECURSION
     */
    Animation.prototype._playProgress = function (opts) {
        var children = this._c;
        for (var i = 0; i < this._cL; i++) {
            // ******** DOM WRITE ****************
            children[i]._playProgress(opts);
        }
        if (this._hasDur) {
            // set the CSS TRANSITION duration/easing
            // ******** DOM WRITE ****************
            this._setTrans(this.getDuration(opts), false);
        }
        else {
            // this animation does not have a duration, so it should not animate
            // just go straight to the TO properties and call it done
            // ******** DOM WRITE ****************
            this._progress(1);
            // since there was no animation, immediately run the after
            // ******** DOM WRITE ****************
            this._setAfterStyles();
            // this animation has no duration, so it has finished
            // other animations could still be running
            this._didFinish(true);
        }
    };
    /**
     * @hidden
     * DOM WRITE
     * RECURSION
     */
    Animation.prototype._playToStep = function (stepValue) {
        var children = this._c;
        for (var i = 0; i < this._cL; i++) {
            // ******** DOM WRITE ****************
            children[i]._playToStep(stepValue);
        }
        if (this._hasDur) {
            // browser had some time to render everything in place
            // and the transition duration/easing is set
            // now set the TO properties which will trigger the transition to begin
            // ******** DOM WRITE ****************
            this._progress(stepValue);
        }
    };
    /**
     * @hidden
     * DOM WRITE
     * NO RECURSION
     * ROOT ANIMATION
     */
    Animation.prototype._asyncEnd = function (dur, shouldComplete) {
        (void 0) /* assert */;
        (void 0) /* assert */;
        (void 0) /* assert */;
        var self = this;
        function onTransitionEnd() {
            // congrats! a successful transition completed!
            // ensure transition end events and timeouts have been cleared
            self._clearAsync();
            // ******** DOM WRITE ****************
            self._playEnd();
            // transition finished
            self._didFinishAll(shouldComplete, true, false);
        }
        function onTransitionFallback() {
            (void 0) /* console.debug */;
            // oh noz! the transition end event didn't fire in time!
            // instead the fallback timer when first
            // if all goes well this fallback should never fire
            // clear the other async end events from firing
            self._tm = undefined;
            self._clearAsync();
            // set the after styles
            // ******** DOM WRITE ****************
            self._playEnd(shouldComplete ? 1 : 0);
            // transition finished
            self._didFinishAll(shouldComplete, true, false);
        }
        // set the TRANSITION END event on one of the transition elements
        self._unrgTrns = this.plt.transitionEnd(self._transEl(), onTransitionEnd, false);
        // set a fallback timeout if the transition end event never fires, or is too slow
        // transition end fallback: (animation duration + XXms)
        self._tm = self.plt.timeout(onTransitionFallback, (dur + ANIMATION_TRANSITION_END_FALLBACK_PADDING_MS));
    };
    /**
     * @hidden
     * DOM WRITE
     * RECURSION
     */
    Animation.prototype._playEnd = function (stepValue) {
        var children = this._c;
        for (var i = 0; i < this._cL; i++) {
            // ******** DOM WRITE ****************
            children[i]._playEnd(stepValue);
        }
        if (this._hasDur) {
            if (Object(__WEBPACK_IMPORTED_MODULE_0__util_util__["h" /* isDefined */])(stepValue)) {
                // too late to have a smooth animation, just finish it
                // ******** DOM WRITE ****************
                this._setTrans(0, true);
                // ensure the ending progress step gets rendered
                // ******** DOM WRITE ****************
                this._progress(stepValue);
            }
            // set the after styles
            // ******** DOM WRITE ****************
            this._setAfterStyles();
            // remove the will-change properties
            // ******** DOM WRITE ****************
            this._willChg(false);
        }
    };
    /**
     * @hidden
     * NO DOM
     * RECURSION
     */
    Animation.prototype._hasDuration = function (opts) {
        if (this.getDuration(opts) > ANIMATION_DURATION_MIN) {
            return true;
        }
        var children = this._c;
        for (var i = 0; i < this._cL; i++) {
            if (children[i]._hasDuration(opts)) {
                return true;
            }
        }
        return false;
    };
    /**
     * @hidden
     * NO DOM
     * RECURSION
     */
    Animation.prototype._hasDomReads = function () {
        if (this._rdFn && this._rdFn.length) {
            return true;
        }
        var children = this._c;
        for (var i = 0; i < this._cL; i++) {
            if (children[i]._hasDomReads()) {
                return true;
            }
        }
        return false;
    };
    /**
     * Immediately stop at the end of the animation.
     */
    Animation.prototype.stop = function (stepValue) {
        if (stepValue === void 0) { stepValue = 1; }
        // ensure all past transition end events have been cleared
        this._clearAsync();
        this._hasDur = true;
        this._playEnd(stepValue);
    };
    /**
     * @hidden
     * NO DOM
     * NO RECURSION
     */
    Animation.prototype._clearAsync = function () {
        this._unrgTrns && this._unrgTrns();
        this._tm && clearTimeout(this._tm);
        this._tm = this._unrgTrns = undefined;
    };
    /**
     * @hidden
     * DOM WRITE
     * NO RECURSION
     */
    Animation.prototype._progress = function (stepValue) {
        // bread 'n butter
        var val;
        var effects = this._fx;
        var nuElements = this._eL;
        if (!effects || !nuElements) {
            return;
        }
        // flip the number if we're going in reverse
        if (this._rv) {
            stepValue = ((stepValue * -1) + 1);
        }
        var i, j;
        var finalTransform = '';
        var elements = this._e;
        for (i = 0; i < effects.length; i++) {
            var fx = effects[i];
            if (fx.from && fx.to) {
                var fromNum = fx.from.num;
                var toNum = fx.to.num;
                var tweenEffect = (fromNum !== toNum);
                (void 0) /* assert */;
                if (tweenEffect) {
                    this._twn = true;
                }
                if (stepValue === 0) {
                    // FROM
                    val = fx.from.val;
                }
                else if (stepValue === 1) {
                    // TO
                    val = fx.to.val;
                }
                else if (tweenEffect) {
                    // EVERYTHING IN BETWEEN
                    var valNum = (((toNum - fromNum) * stepValue) + fromNum);
                    var unit = fx.to.unit;
                    if (unit === 'px') {
                        valNum = Math.round(valNum);
                    }
                    val = valNum + unit;
                }
                if (val !== null) {
                    var prop = fx.name;
                    if (fx.trans) {
                        finalTransform += prop + '(' + val + ') ';
                    }
                    else {
                        for (j = 0; j < nuElements; j++) {
                            // ******** DOM WRITE ****************
                            elements[j].style[prop] = val;
                        }
                    }
                }
            }
        }
        // place all transforms on the same property
        if (finalTransform.length) {
            if (!this._rv && stepValue !== 1 || this._rv && stepValue !== 0) {
                finalTransform += 'translateZ(0px)';
            }
            var cssTransform = this.plt.Css.transform;
            for (i = 0; i < elements.length; i++) {
                // ******** DOM WRITE ****************
                elements[i].style[cssTransform] = finalTransform;
            }
        }
    };
    /**
     * @hidden
     * DOM WRITE
     * NO RECURSION
     */
    Animation.prototype._setTrans = function (dur, forcedLinearEasing) {
        // Transition is not enabled if there are not effects
        if (!this._fx) {
            return;
        }
        // set the TRANSITION properties inline on the element
        var elements = this._e;
        var easing = (forcedLinearEasing ? 'linear' : this.getEasing());
        var durString = dur + 'ms';
        var Css = this.plt.Css;
        var cssTransform = Css.transition;
        var cssTransitionDuration = Css.transitionDuration;
        var cssTransitionTimingFn = Css.transitionTimingFn;
        var eleStyle;
        for (var i = 0; i < this._eL; i++) {
            eleStyle = elements[i].style;
            if (dur > 0) {
                // ******** DOM WRITE ****************
                eleStyle[cssTransform] = '';
                eleStyle[cssTransitionDuration] = durString;
                // each animation can have a different easing
                if (easing) {
                    // ******** DOM WRITE ****************
                    eleStyle[cssTransitionTimingFn] = easing;
                }
            }
            else {
                eleStyle[cssTransform] = 'none';
            }
        }
    };
    /**
     * @hidden
     * DOM READ
     * DOM WRITE
     * RECURSION
     */
    Animation.prototype._beforeAnimation = function () {
        // fire off all the "before" function that have DOM READS in them
        // elements will be in the DOM, however visibily hidden
        // so we can read their dimensions if need be
        // ******** DOM READ ****************
        this._fireBeforeReadFunc();
        // ******** DOM READS ABOVE / DOM WRITES BELOW ****************
        // fire off all the "before" function that have DOM WRITES in them
        // ******** DOM WRITE ****************
        this._fireBeforeWriteFunc();
        // stage all of the before css classes and inline styles
        // ******** DOM WRITE ****************
        this._setBeforeStyles();
    };
    /**
     * @hidden
     * DOM WRITE
     * RECURSION
     */
    Animation.prototype._setBeforeStyles = function () {
        var i, j;
        var children = this._c;
        for (i = 0; i < this._cL; i++) {
            children[i]._setBeforeStyles();
        }
        // before the animations have started
        // only set before styles if animation is not reversed
        if (this._rv) {
            return;
        }
        var addClasses = this._bfAdd;
        var removeClasses = this._bfRm;
        var ele;
        var eleClassList;
        var prop;
        for (i = 0; i < this._eL; i++) {
            ele = this._e[i];
            eleClassList = ele.classList;
            // css classes to add before the animation
            if (addClasses) {
                for (j = 0; j < addClasses.length; j++) {
                    // ******** DOM WRITE ****************
                    eleClassList.add(addClasses[j]);
                }
            }
            // css classes to remove before the animation
            if (removeClasses) {
                for (j = 0; j < removeClasses.length; j++) {
                    // ******** DOM WRITE ****************
                    eleClassList.remove(removeClasses[j]);
                }
            }
            // inline styles to add before the animation
            if (this._bfSty) {
                for (prop in this._bfSty) {
                    // ******** DOM WRITE ****************
                    ele.style[prop] = this._bfSty[prop];
                }
            }
        }
    };
    /**
     * @hidden
     * DOM READ
     * RECURSION
     */
    Animation.prototype._fireBeforeReadFunc = function () {
        var children = this._c;
        for (var i = 0; i < this._cL; i++) {
            // ******** DOM READ ****************
            children[i]._fireBeforeReadFunc();
        }
        var readFunctions = this._rdFn;
        if (readFunctions) {
            for (var i = 0; i < readFunctions.length; i++) {
                // ******** DOM READ ****************
                readFunctions[i]();
            }
        }
    };
    /**
     * @hidden
     * DOM WRITE
     * RECURSION
     */
    Animation.prototype._fireBeforeWriteFunc = function () {
        var children = this._c;
        for (var i = 0; i < this._cL; i++) {
            // ******** DOM WRITE ****************
            children[i]._fireBeforeWriteFunc();
        }
        var writeFunctions = this._wrFn;
        if (this._wrFn) {
            for (var i = 0; i < writeFunctions.length; i++) {
                // ******** DOM WRITE ****************
                writeFunctions[i]();
            }
        }
    };
    /**
     * @hidden
     * DOM WRITE
     */
    Animation.prototype._setAfterStyles = function () {
        var i, j;
        var ele;
        var eleClassList;
        var elements = this._e;
        for (i = 0; i < this._eL; i++) {
            ele = elements[i];
            eleClassList = ele.classList;
            // remove the transition duration/easing
            // ******** DOM WRITE ****************
            ele.style[this.plt.Css.transitionDuration] = ele.style[this.plt.Css.transitionTimingFn] = '';
            if (this._rv) {
                // finished in reverse direction
                // css classes that were added before the animation should be removed
                if (this._bfAdd) {
                    for (j = 0; j < this._bfAdd.length; j++) {
                        // ******** DOM WRITE ****************
                        eleClassList.remove(this._bfAdd[j]);
                    }
                }
                // css classes that were removed before the animation should be added
                if (this._bfRm) {
                    for (j = 0; j < this._bfRm.length; j++) {
                        // ******** DOM WRITE ****************
                        eleClassList.add(this._bfRm[j]);
                    }
                }
                // inline styles that were added before the animation should be removed
                if (this._bfSty) {
                    for (var prop in this._bfSty) {
                        // ******** DOM WRITE ****************
                        ele.style[prop] = '';
                    }
                }
            }
            else {
                // finished in forward direction
                // css classes to add after the animation
                if (this._afAdd) {
                    for (j = 0; j < this._afAdd.length; j++) {
                        // ******** DOM WRITE ****************
                        eleClassList.add(this._afAdd[j]);
                    }
                }
                // css classes to remove after the animation
                if (this._afRm) {
                    for (j = 0; j < this._afRm.length; j++) {
                        // ******** DOM WRITE ****************
                        eleClassList.remove(this._afRm[j]);
                    }
                }
                // inline styles to add after the animation
                if (this._afSty) {
                    for (var prop in this._afSty) {
                        // ******** DOM WRITE ****************
                        ele.style[prop] = this._afSty[prop];
                    }
                }
            }
        }
    };
    /**
     * @hidden
     * DOM WRITE
     * NO RECURSION
     */
    Animation.prototype._willChg = function (addWillChange) {
        var wc;
        var effects = this._fx;
        var willChange;
        if (addWillChange && effects) {
            wc = [];
            for (var i = 0; i < effects.length; i++) {
                var propWC = effects[i].wc;
                if (propWC === 'webkitTransform') {
                    wc.push('transform', '-webkit-transform');
                }
                else {
                    wc.push(propWC);
                }
            }
            willChange = wc.join(',');
        }
        else {
            willChange = '';
        }
        for (var i = 0; i < this._eL; i++) {
            // ******** DOM WRITE ****************
            this._e[i].style.willChange = willChange;
        }
    };
    /**
     * Start the animation with a user controlled progress.
     */
    Animation.prototype.progressStart = function () {
        // ensure all past transition end events have been cleared
        this._clearAsync();
        // ******** DOM READ/WRITE ****************
        this._beforeAnimation();
        // ******** DOM WRITE ****************
        this._progressStart();
    };
    /**
     * @hidden
     * DOM WRITE
     * RECURSION
     */
    Animation.prototype._progressStart = function () {
        var children = this._c;
        for (var i = 0; i < this._cL; i++) {
            // ******** DOM WRITE ****************
            children[i]._progressStart();
        }
        // force no duration, linear easing
        // ******** DOM WRITE ****************
        this._setTrans(0, true);
        // ******** DOM WRITE ****************
        this._willChg(true);
    };
    /**
     * Set the progress step for this animation.
     * progressStep() is not debounced, so it should not be called faster than 60FPS.
     */
    Animation.prototype.progressStep = function (stepValue) {
        // only update if the last update was more than 16ms ago
        stepValue = Math.min(1, Math.max(0, stepValue));
        var children = this._c;
        for (var i = 0; i < this._cL; i++) {
            // ******** DOM WRITE ****************
            children[i].progressStep(stepValue);
        }
        if (this._rv) {
            // if the animation is going in reverse then
            // flip the step value: 0 becomes 1, 1 becomes 0
            stepValue = ((stepValue * -1) + 1);
        }
        // ******** DOM WRITE ****************
        this._progress(stepValue);
    };
    /**
     * End the progress animation.
     */
    Animation.prototype.progressEnd = function (shouldComplete, currentStepValue, dur) {
        if (dur === void 0) { dur = -1; }
        (void 0) /* console.debug */;
        if (this._rv) {
            // if the animation is going in reverse then
            // flip the step value: 0 becomes 1, 1 becomes 0
            currentStepValue = ((currentStepValue * -1) + 1);
        }
        var stepValue = shouldComplete ? 1 : 0;
        var diff = Math.abs(currentStepValue - stepValue);
        if (diff < 0.05) {
            dur = 0;
        }
        else if (dur < 0) {
            dur = this._dur;
        }
        this._isAsync = (dur > 30);
        this._progressEnd(shouldComplete, stepValue, dur, this._isAsync);
        if (this._isAsync) {
            // for the root animation only
            // set the async TRANSITION END event
            // and run onFinishes when the transition ends
            // ******** DOM WRITE ****************
            this._asyncEnd(dur, shouldComplete);
            // this animation has a duration so we need another RAF
            // for the CSS TRANSITION properties to kick in
            this.plt && this.plt.raf(this._playToStep.bind(this, stepValue));
        }
    };
    /**
     * @hidden
     * DOM WRITE
     * RECURSION
     */
    Animation.prototype._progressEnd = function (shouldComplete, stepValue, dur, isAsync) {
        var children = this._c;
        for (var i = 0; i < this._cL; i++) {
            // ******** DOM WRITE ****************
            children[i]._progressEnd(shouldComplete, stepValue, dur, isAsync);
        }
        if (!isAsync) {
            // stop immediately
            // set all the animations to their final position
            // ******** DOM WRITE ****************
            this._progress(stepValue);
            this._willChg(false);
            this._setAfterStyles();
            this._didFinish(shouldComplete);
        }
        else {
            // animate it back to it's ending position
            this.isPlaying = true;
            this.hasCompleted = false;
            this._hasDur = true;
            // ******** DOM WRITE ****************
            this._willChg(true);
            this._setTrans(dur, false);
        }
    };
    /**
     * Add a callback to fire when the animation has finished.
     */
    Animation.prototype.onFinish = function (callback, onceTimeCallback, clearOnFinishCallacks) {
        if (onceTimeCallback === void 0) { onceTimeCallback = false; }
        if (clearOnFinishCallacks === void 0) { clearOnFinishCallacks = false; }
        if (clearOnFinishCallacks) {
            this._fFn = this._fOneFn = undefined;
        }
        if (onceTimeCallback) {
            this._fOneFn = this._fOneFn || [];
            this._fOneFn.push(callback);
        }
        else {
            this._fFn = this._fFn || [];
            this._fFn.push(callback);
        }
        return this;
    };
    /**
     * @hidden
     * NO DOM
     * RECURSION
     */
    Animation.prototype._didFinishAll = function (hasCompleted, finishAsyncAnimations, finishNoDurationAnimations) {
        var children = this._c;
        for (var i = 0; i < this._cL; i++) {
            children[i]._didFinishAll(hasCompleted, finishAsyncAnimations, finishNoDurationAnimations);
        }
        if (finishAsyncAnimations && this._isAsync || finishNoDurationAnimations && !this._isAsync) {
            this._didFinish(hasCompleted);
        }
    };
    /**
     * @hidden
     * NO RECURSION
     */
    Animation.prototype._didFinish = function (hasCompleted) {
        this.isPlaying = false;
        this.hasCompleted = hasCompleted;
        if (this._fFn) {
            // run all finish callbacks
            for (var i = 0; i < this._fFn.length; i++) {
                this._fFn[i](this);
            }
        }
        if (this._fOneFn) {
            // run all "onetime" finish callbacks
            for (var i = 0; i < this._fOneFn.length; i++) {
                this._fOneFn[i](this);
            }
            this._fOneFn.length = 0;
        }
    };
    /**
     * Reverse the animation.
     */
    Animation.prototype.reverse = function (shouldReverse) {
        if (shouldReverse === void 0) { shouldReverse = true; }
        var children = this._c;
        for (var i = 0; i < this._cL; i++) {
            children[i].reverse(shouldReverse);
        }
        this._rv = shouldReverse;
        return this;
    };
    /**
     * Recursively destroy this animation and all child animations.
     */
    Animation.prototype.destroy = function () {
        var children = this._c;
        for (var i = 0; i < this._cL; i++) {
            children[i].destroy();
        }
        this._clearAsync();
        this.parent = this.plt = this._e = this._rdFn = this._wrFn = null;
        if (this._c) {
            this._c.length = this._cL = 0;
        }
        if (this._fFn) {
            this._fFn.length = 0;
        }
        if (this._fOneFn) {
            this._fOneFn.length = 0;
        }
    };
    /**
     * @hidden
     * NO DOM
     */
    Animation.prototype._transEl = function () {
        // get the lowest level element that has an Animation
        var targetEl;
        for (var i = 0; i < this._cL; i++) {
            targetEl = this._c[i]._transEl();
            if (targetEl) {
                return targetEl;
            }
        }
        return (this._twn && this._hasDur && this._eL ? this._e[0] : null);
    };
    return Animation;
}());

var ANIMATION_TRANSFORMS = {
    'translateX': 1,
    'translateY': 1,
    'translateZ': 1,
    'scale': 1,
    'scaleX': 1,
    'scaleY': 1,
    'scaleZ': 1,
    'rotate': 1,
    'rotateX': 1,
    'rotateY': 1,
    'rotateZ': 1,
    'skewX': 1,
    'skewY': 1,
    'perspective': 1
};
var ANIMATION_CSS_VALUE_REGEX = /(^-?\d*\.?\d*)(.*)/;
var ANIMATION_DURATION_MIN = 32;
var ANIMATION_TRANSITION_END_FALLBACK_PADDING_MS = 400;
//# sourceMappingURL=animation.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/action-sheet/action-sheet-component.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionSheetCmp; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gestures_gesture_controller__ = __webpack_require__("./node_modules/ionic-angular/gestures/gesture-controller.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__platform_key__ = __webpack_require__("./node_modules/ionic-angular/platform/key.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__navigation_nav_params__ = __webpack_require__("./node_modules/ionic-angular/navigation/nav-params.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__navigation_view_controller__ = __webpack_require__("./node_modules/ionic-angular/navigation/view-controller.js");






/**
 * @hidden
 */
var ActionSheetCmp = (function () {
    function ActionSheetCmp(_viewCtrl, config, _elementRef, gestureCtrl, params, renderer) {
        this._viewCtrl = _viewCtrl;
        this._elementRef = _elementRef;
        this.gestureBlocker = gestureCtrl.createBlocker(__WEBPACK_IMPORTED_MODULE_1__gestures_gesture_controller__["a" /* BLOCK_ALL */]);
        this.d = params.data;
        this.mode = config.get('mode');
        renderer.setElementClass(_elementRef.nativeElement, "action-sheet-" + this.mode, true);
        if (this.d.cssClass) {
            this.d.cssClass.split(' ').forEach(function (cssClass) {
                // Make sure the class isn't whitespace, otherwise it throws exceptions
                if (cssClass.trim() !== '')
                    renderer.setElementClass(_elementRef.nativeElement, cssClass, true);
            });
        }
        this.id = (++actionSheetIds);
        if (this.d.title) {
            this.hdrId = 'acst-hdr-' + this.id;
        }
        if (this.d.subTitle) {
            this.descId = 'acst-subhdr-' + this.id;
        }
    }
    ActionSheetCmp.prototype.ionViewDidLoad = function () {
        var _this = this;
        // normalize the data
        this.d.buttons = this.d.buttons.map(function (button) {
            if (typeof button === 'string') {
                button = { text: button };
            }
            if (!button.cssClass) {
                button.cssClass = '';
            }
            switch (button.role) {
                case 'cancel':
                    _this.cancelButton = button;
                    return null;
                case 'destructive':
                    button.cssClass = (button.cssClass + ' ' || '') + 'action-sheet-destructive';
                    break;
                case 'selected':
                    button.cssClass = (button.cssClass + ' ' || '') + 'action-sheet-selected';
                    break;
            }
            return button;
        }).filter(function (button) { return button !== null; });
    };
    ActionSheetCmp.prototype.ionViewWillEnter = function () {
        this.gestureBlocker.block();
    };
    ActionSheetCmp.prototype.ionViewDidLeave = function () {
        this.gestureBlocker.unblock();
    };
    ActionSheetCmp.prototype.ionViewDidEnter = function () {
        var focusableEle = this._elementRef.nativeElement.querySelector('button');
        if (focusableEle) {
            focusableEle.focus();
        }
        this.enabled = true;
    };
    ActionSheetCmp.prototype.keyUp = function (ev) {
        if (this.enabled && ev.keyCode === __WEBPACK_IMPORTED_MODULE_3__platform_key__["c" /* KEY_ESCAPE */] && this._viewCtrl.isLast()) {
            (void 0) /* console.debug */;
            this.bdClick();
        }
    };
    ActionSheetCmp.prototype.click = function (button) {
        if (!this.enabled) {
            return;
        }
        var shouldDismiss = true;
        if (button.handler) {
            // a handler has been provided, execute it
            if (button.handler() === false) {
                // if the return value of the handler is false then do not dismiss
                shouldDismiss = false;
            }
        }
        if (shouldDismiss) {
            this.dismiss(button.role);
        }
    };
    ActionSheetCmp.prototype.bdClick = function () {
        if (this.enabled && this.d.enableBackdropDismiss) {
            if (this.cancelButton) {
                this.click(this.cancelButton);
            }
            else {
                this.dismiss('backdrop');
            }
        }
    };
    ActionSheetCmp.prototype.dismiss = function (role) {
        var opts = {
            minClickBlockDuration: 400
        };
        return this._viewCtrl.dismiss(null, role, opts);
    };
    ActionSheetCmp.prototype.ngOnDestroy = function () {
        (void 0) /* assert */;
        this.d = this.cancelButton = null;
        this.gestureBlocker.destroy();
    };
    ActionSheetCmp.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'ion-action-sheet',
                    template: '<ion-backdrop (click)="bdClick()" [class.backdrop-no-tappable]="!d.enableBackdropDismiss"></ion-backdrop>' +
                        '<div class="action-sheet-wrapper">' +
                        '<div class="action-sheet-container">' +
                        '<div class="action-sheet-group">' +
                        '<div class="action-sheet-title" id="{{hdrId}}" *ngIf="d.title">{{d.title}}</div>' +
                        '<div class="action-sheet-sub-title" id="{{descId}}" *ngIf="d.subTitle">{{d.subTitle}}</div>' +
                        '<button ion-button="action-sheet-button" (click)="click(b)" *ngFor="let b of d.buttons" class="disable-hover" [attr.icon-start]="b.icon ? \'\' : null" [ngClass]="b.cssClass">' +
                        '<ion-icon [name]="b.icon" *ngIf="b.icon" class="action-sheet-icon"></ion-icon>' +
                        '{{b.text}}' +
                        '</button>' +
                        '</div>' +
                        '<div class="action-sheet-group action-sheet-group-cancel" *ngIf="cancelButton">' +
                        '<button ion-button="action-sheet-button" (click)="click(cancelButton)" class="action-sheet-cancel disable-hover" [attr.icon-start]="cancelButton.icon ? \'\' : null" [ngClass]="cancelButton.cssClass">' +
                        '<ion-icon [name]="cancelButton.icon" *ngIf="cancelButton.icon" class="action-sheet-icon"></ion-icon>' +
                        '{{cancelButton.text}}' +
                        '</button>' +
                        '</div>' +
                        '</div>' +
                        '</div>',
                    host: {
                        'role': 'dialog',
                        '[attr.aria-labelledby]': 'hdrId',
                        '[attr.aria-describedby]': 'descId'
                    },
                    encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None,
                },] },
    ];
    /** @nocollapse */
    ActionSheetCmp.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_5__navigation_view_controller__["a" /* ViewController */], },
        { type: __WEBPACK_IMPORTED_MODULE_2__config_config__["a" /* Config */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_1__gestures_gesture_controller__["m" /* GestureController */], },
        { type: __WEBPACK_IMPORTED_MODULE_4__navigation_nav_params__["a" /* NavParams */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    ]; };
    ActionSheetCmp.propDecorators = {
        'keyUp': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"], args: ['body:keyup', ['$event'],] },],
    };
    return ActionSheetCmp;
}());

var actionSheetIds = -1;
//# sourceMappingURL=action-sheet-component.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/action-sheet/action-sheet-controller.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionSheetController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__action_sheet__ = __webpack_require__("./node_modules/ionic-angular/components/action-sheet/action-sheet.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_app__ = __webpack_require__("./node_modules/ionic-angular/components/app/app.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");




/**
 * @name ActionSheetController
 * @description
 * An Action Sheet is a dialog that lets the user choose from a set of
 * options. It appears on top of the app's content, and must be manually
 * dismissed by the user before they can resume interaction with the app.
 * Dangerous (destructive) options are made obvious in `ios` mode. There are easy
 * ways to cancel out of the action sheet, such as tapping the backdrop or
 * hitting the escape key on desktop.
 *
 * An action sheet is created from an array of `buttons`, with each button
 * including properties for its `text`, and optionally a `handler` and `role`.
 * If a handler returns `false` then the action sheet will not be dismissed. An
 * action sheet can also optionally have a `title`, `subTitle` and an `icon`.
 *
 * A button's `role` property can either be `destructive` or `cancel`. Buttons
 * without a role property will have the default look for the platform. Buttons
 * with the `cancel` role will always load as the bottom button, no matter where
 * they are in the array. All other buttons will be displayed in the order they
 * have been added to the `buttons` array. Note: We recommend that `destructive`
 * buttons are always the first button in the array, making them the top button.
 * Additionally, if the action sheet is dismissed by tapping the backdrop, then
 * it will fire the handler from the button with the cancel role.
 *
 * You can pass all of the action sheet's options in the first argument of
 * the create method: `ActionSheet.create(opts)`. Otherwise the action sheet's
 * instance has methods to add options, like `setTitle()` or `addButton()`.
 *
 * @usage
 * ```ts
 * import { ActionSheetController } from 'ionic-angular'
 *
 * export class MyClass{
 *
 *  constructor(public actionSheetCtrl: ActionSheetController) { }
 *
 *  presentActionSheet() {
 *    const actionSheet = this.actionSheetCtrl.create({
 *      title: 'Modify your album',
 *      buttons: [
 *        {
 *          text: 'Destructive',
 *          role: 'destructive',
 *          handler: () => {
 *            console.log('Destructive clicked');
 *          }
 *        },
 *        {
 *          text: 'Archive',
 *          handler: () => {
 *            console.log('Archive clicked');
 *          }
 *        },
 *        {
 *          text: 'Cancel',
 *          role: 'cancel',
 *          handler: () => {
 *            console.log('Cancel clicked');
 *          }
 *        }
 *      ]
 *    });
 *
 *    actionSheet.present();
 *  }
 * }
 * ```
 *
 * @advanced
 *
 * ActionSheet create options
 *
 * | Option                | Type       | Description                                                        |
 * |-----------------------|------------|--------------------------------------------------------------------|
 * | title                 |`string`    | The title for the Action Sheet.                                    |
 * | subTitle              |`string`    | The sub-title for the Action Sheet.                                |
 * | cssClass              |`string`    | Additional classes for custom styles, separated by spaces.         |
 * | enableBackdropDismiss |`boolean`   | If the Action Sheet should close when the user taps the backdrop.  |
 * | buttons               |`array<any>`| An array of buttons to display.                                    |
 *
 * ActionSheet button options
 *
 * | Option   | Type     | Description                                                                                                                                      |
 * |----------|----------|--------------------------------------------------------------------------------------------------------------------------------------------------|
 * | text     | `string` | The buttons text.                                                                                                                                |
 * | icon     | `icon`   | The buttons icons.                                                                                                                               |
 * | handler  | `any`    | An express the button should evaluate.                                                                                                           |
 * | cssClass | `string` | Additional classes for custom styles, separated by spaces.                                                                                       |
 * | role     | `string` | How the button should be displayed, `destructive` or `cancel`. If no role is provided, it will display the button without any additional styles. |
 *
 *
 * ### Dismissing And Async Navigation
 *
 * After an action sheet has been dismissed, the app may need to also transition
 * to another page depending on the handler's logic. However, because multiple
 * transitions were fired at roughly the same time, it's difficult for the
 * nav controller to cleanly animate multiple transitions that may
 * have been kicked off asynchronously. This is further described in the
 * [`Nav Transition Promises`](../../nav/NavController/#nav-transition-promises) section. For action sheets,
 * this means it's best to wait for the action sheet to finish its transition
 * out before starting a new transition on the same nav controller.
 *
 * In the example below, after the button has been clicked, its handler
 * waits on async operation to complete, *then* it uses `pop` to navigate
 * back a page in the same stack. The potential problem is that the async operation
 * may have been completed before the action sheet has even finished its transition
 * out. In this case, it's best to ensure the action sheet has finished its transition
 * out first, *then* start the next transition.
 *
 * ```ts
 * const actionSheet = this.actionSheetCtrl.create({
 *   title: 'Hello',
 *   buttons: [{
 *     text: 'Ok',
 *     handler: () => {
 *       // user has clicked the action sheet button
 *       // begin the action sheet's dimiss transition
 *       let navTransition = actionSheet.dismiss();
 *
 *       // start some async method
 *       someAsyncOperation().then(() => {
 *         // once the async operation has completed
 *         // then run the next nav transition after the
 *         // first transition has finished animating out
 *
 *         navTransition.then(() => {
 *           this.nav.pop();
 *         });
 *       });
 *       return false;
 *     }
 *   }]
 * });
 *
 * actionSheet.present();
 * ```
 *
 * It's important to note that the handler returns `false`. A feature of
 * button handlers is that they automatically dismiss the action sheet when their button
 * was clicked, however, we'll need more control regarding the transition. Because
 * the handler returns `false`, then the action sheet does not automatically dismiss
 * itself. Instead, you now have complete control of when the action sheet has finished
 * transitioning, and the ability to wait for the action sheet to finish transitioning
 * out before starting a new transition.
 *
 *
 * @demo /docs/demos/src/action-sheet/
 * @see {@link /docs/components#action-sheets ActionSheet Component Docs}
 */
var ActionSheetController = (function () {
    function ActionSheetController(_app, config) {
        this._app = _app;
        this.config = config;
    }
    /**
     * Open an action sheet with a title, subTitle, and an array of buttons
     * @param {ActionSheetOptions} opts Action sheet options
     */
    ActionSheetController.prototype.create = function (opts) {
        if (opts === void 0) { opts = {}; }
        return new __WEBPACK_IMPORTED_MODULE_1__action_sheet__["a" /* ActionSheet */](this._app, opts, this.config);
    };
    ActionSheetController.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    ActionSheetController.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_2__app_app__["a" /* App */], },
        { type: __WEBPACK_IMPORTED_MODULE_3__config_config__["a" /* Config */], },
    ]; };
    return ActionSheetController;
}());

//# sourceMappingURL=action-sheet-controller.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/action-sheet/action-sheet-transitions.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ActionSheetSlideIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ActionSheetSlideOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionSheetMdSlideIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ActionSheetMdSlideOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ActionSheetWpSlideIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ActionSheetWpSlideOut; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__animations_animation__ = __webpack_require__("./node_modules/ionic-angular/animations/animation.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__transitions_transition__ = __webpack_require__("./node_modules/ionic-angular/transitions/transition.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var ActionSheetSlideIn = (function (_super) {
    __extends(ActionSheetSlideIn, _super);
    function ActionSheetSlideIn() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ActionSheetSlideIn.prototype.init = function () {
        var ele = this.enteringView.pageRef().nativeElement;
        var backdrop = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](this.plt, ele.querySelector('ion-backdrop'));
        var wrapper = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](this.plt, ele.querySelector('.action-sheet-wrapper'));
        backdrop.fromTo('opacity', 0.01, 0.4);
        wrapper.fromTo('translateY', '100%', '0%');
        this.easing('cubic-bezier(.36,.66,.04,1)').duration(400).add(backdrop).add(wrapper);
    };
    return ActionSheetSlideIn;
}(__WEBPACK_IMPORTED_MODULE_1__transitions_transition__["a" /* Transition */]));

var ActionSheetSlideOut = (function (_super) {
    __extends(ActionSheetSlideOut, _super);
    function ActionSheetSlideOut() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ActionSheetSlideOut.prototype.init = function () {
        var ele = this.leavingView.pageRef().nativeElement;
        var backdrop = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](this.plt, ele.querySelector('ion-backdrop'));
        var wrapper = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](this.plt, ele.querySelector('.action-sheet-wrapper'));
        backdrop.fromTo('opacity', 0.4, 0);
        wrapper.fromTo('translateY', '0%', '100%');
        this.easing('cubic-bezier(.36,.66,.04,1)').duration(300).add(backdrop).add(wrapper);
    };
    return ActionSheetSlideOut;
}(__WEBPACK_IMPORTED_MODULE_1__transitions_transition__["a" /* Transition */]));

var ActionSheetMdSlideIn = (function (_super) {
    __extends(ActionSheetMdSlideIn, _super);
    function ActionSheetMdSlideIn() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ActionSheetMdSlideIn.prototype.init = function () {
        var ele = this.enteringView.pageRef().nativeElement;
        var backdrop = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](this.plt, ele.querySelector('ion-backdrop'));
        var wrapper = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](this.plt, ele.querySelector('.action-sheet-wrapper'));
        backdrop.fromTo('opacity', 0.01, 0.26);
        wrapper.fromTo('translateY', '100%', '0%');
        this.easing('cubic-bezier(.36,.66,.04,1)').duration(400).add(backdrop).add(wrapper);
    };
    return ActionSheetMdSlideIn;
}(__WEBPACK_IMPORTED_MODULE_1__transitions_transition__["a" /* Transition */]));

var ActionSheetMdSlideOut = (function (_super) {
    __extends(ActionSheetMdSlideOut, _super);
    function ActionSheetMdSlideOut() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ActionSheetMdSlideOut.prototype.init = function () {
        var ele = this.leavingView.pageRef().nativeElement;
        var backdrop = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](this.plt, ele.querySelector('ion-backdrop'));
        var wrapper = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](this.plt, ele.querySelector('.action-sheet-wrapper'));
        backdrop.fromTo('opacity', 0.26, 0);
        wrapper.fromTo('translateY', '0%', '100%');
        this.easing('cubic-bezier(.36,.66,.04,1)').duration(450).add(backdrop).add(wrapper);
    };
    return ActionSheetMdSlideOut;
}(__WEBPACK_IMPORTED_MODULE_1__transitions_transition__["a" /* Transition */]));

var ActionSheetWpSlideIn = (function (_super) {
    __extends(ActionSheetWpSlideIn, _super);
    function ActionSheetWpSlideIn() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ActionSheetWpSlideIn.prototype.init = function () {
        var ele = this.enteringView.pageRef().nativeElement;
        var backdrop = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](this.plt, ele.querySelector('ion-backdrop'));
        var wrapper = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](this.plt, ele.querySelector('.action-sheet-wrapper'));
        backdrop.fromTo('opacity', 0.01, 0.16);
        wrapper.fromTo('translateY', '100%', '0%');
        this.easing('cubic-bezier(.36,.66,.04,1)').duration(400).add(backdrop).add(wrapper);
    };
    return ActionSheetWpSlideIn;
}(__WEBPACK_IMPORTED_MODULE_1__transitions_transition__["a" /* Transition */]));

var ActionSheetWpSlideOut = (function (_super) {
    __extends(ActionSheetWpSlideOut, _super);
    function ActionSheetWpSlideOut() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ActionSheetWpSlideOut.prototype.init = function () {
        var ele = this.leavingView.pageRef().nativeElement;
        var backdrop = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](this.plt, ele.querySelector('ion-backdrop'));
        var wrapper = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](this.plt, ele.querySelector('.action-sheet-wrapper'));
        backdrop.fromTo('opacity', 0.1, 0);
        wrapper.fromTo('translateY', '0%', '100%');
        this.easing('cubic-bezier(.36,.66,.04,1)').duration(450).add(backdrop).add(wrapper);
    };
    return ActionSheetWpSlideOut;
}(__WEBPACK_IMPORTED_MODULE_1__transitions_transition__["a" /* Transition */]));

//# sourceMappingURL=action-sheet-transitions.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/action-sheet/action-sheet.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionSheet; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__action_sheet_component__ = __webpack_require__("./node_modules/ionic-angular/components/action-sheet/action-sheet-component.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__action_sheet_transitions__ = __webpack_require__("./node_modules/ionic-angular/components/action-sheet/action-sheet-transitions.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__navigation_view_controller__ = __webpack_require__("./node_modules/ionic-angular/navigation/view-controller.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




/**
 * @hidden
 */
var ActionSheet = (function (_super) {
    __extends(ActionSheet, _super);
    function ActionSheet(app, opts, config) {
        var _this = this;
        opts.buttons = opts.buttons || [];
        opts.enableBackdropDismiss = Object(__WEBPACK_IMPORTED_MODULE_2__util_util__["l" /* isPresent */])(opts.enableBackdropDismiss) ? !!opts.enableBackdropDismiss : true;
        _this = _super.call(this, __WEBPACK_IMPORTED_MODULE_0__action_sheet_component__["a" /* ActionSheetCmp */], opts, null) || this;
        _this._app = app;
        _this.isOverlay = true;
        config.setTransition('action-sheet-slide-in', __WEBPACK_IMPORTED_MODULE_1__action_sheet_transitions__["c" /* ActionSheetSlideIn */]);
        config.setTransition('action-sheet-slide-out', __WEBPACK_IMPORTED_MODULE_1__action_sheet_transitions__["d" /* ActionSheetSlideOut */]);
        config.setTransition('action-sheet-md-slide-in', __WEBPACK_IMPORTED_MODULE_1__action_sheet_transitions__["a" /* ActionSheetMdSlideIn */]);
        config.setTransition('action-sheet-md-slide-out', __WEBPACK_IMPORTED_MODULE_1__action_sheet_transitions__["b" /* ActionSheetMdSlideOut */]);
        config.setTransition('action-sheet-wp-slide-in', __WEBPACK_IMPORTED_MODULE_1__action_sheet_transitions__["e" /* ActionSheetWpSlideIn */]);
        config.setTransition('action-sheet-wp-slide-out', __WEBPACK_IMPORTED_MODULE_1__action_sheet_transitions__["f" /* ActionSheetWpSlideOut */]);
        return _this;
    }
    /**
     * @hidden
     */
    ActionSheet.prototype.getTransitionName = function (direction) {
        var key = 'actionSheet' + (direction === 'back' ? 'Leave' : 'Enter');
        return this._nav && this._nav.config.get(key);
    };
    /**
     * @param {string} title Action sheet title
     */
    ActionSheet.prototype.setTitle = function (title) {
        this.data.title = title;
        return this;
    };
    /**
     * @param {string} subTitle Action sheet subtitle
     */
    ActionSheet.prototype.setSubTitle = function (subTitle) {
        this.data.subTitle = subTitle;
        return this;
    };
    /**
     * @param {object} button Action sheet button
     */
    ActionSheet.prototype.addButton = function (button) {
        this.data.buttons.push(button);
        return this;
    };
    /**
     * Present the action sheet instance.
     *
     * @param {NavOptions} [navOptions={}] Nav options to go with this transition.
     * @returns {Promise} Returns a promise which is resolved when the transition has completed.
     */
    ActionSheet.prototype.present = function (navOptions) {
        if (navOptions === void 0) { navOptions = {}; }
        navOptions.minClickBlockDuration = navOptions.minClickBlockDuration || 400;
        return this._app.present(this, navOptions);
    };
    return ActionSheet;
}(__WEBPACK_IMPORTED_MODULE_3__navigation_view_controller__["a" /* ViewController */]));

//# sourceMappingURL=action-sheet.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/alert/alert-component.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AlertCmp; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_dom__ = __webpack_require__("./node_modules/ionic-angular/util/dom.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gestures_gesture_controller__ = __webpack_require__("./node_modules/ionic-angular/gestures/gesture-controller.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__platform_key__ = __webpack_require__("./node_modules/ionic-angular/platform/key.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__navigation_nav_params__ = __webpack_require__("./node_modules/ionic-angular/navigation/nav-params.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__platform_platform__ = __webpack_require__("./node_modules/ionic-angular/platform/platform.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__navigation_view_controller__ = __webpack_require__("./node_modules/ionic-angular/navigation/view-controller.js");









/**
 * @hidden
 */
var AlertCmp = (function () {
    function AlertCmp(_viewCtrl, _elementRef, config, gestureCtrl, params, _renderer, _plt) {
        this._viewCtrl = _viewCtrl;
        this._elementRef = _elementRef;
        this._renderer = _renderer;
        this._plt = _plt;
        // gesture blocker is used to disable gestures dynamically
        this.gestureBlocker = gestureCtrl.createBlocker(__WEBPACK_IMPORTED_MODULE_3__gestures_gesture_controller__["a" /* BLOCK_ALL */]);
        this.d = params.data;
        this.mode = this.d.mode || config.get('mode');
        this.keyboardResizes = config.getBoolean('keyboardResizes', false);
        _renderer.setElementClass(_elementRef.nativeElement, "alert-" + this.mode, true);
        if (this.d.cssClass) {
            this.d.cssClass.split(' ').forEach(function (cssClass) {
                // Make sure the class isn't whitespace, otherwise it throws exceptions
                if (cssClass.trim() !== '')
                    _renderer.setElementClass(_elementRef.nativeElement, cssClass, true);
            });
        }
        this.id = (++alertIds);
        this.descId = '';
        this.hdrId = 'alert-hdr-' + this.id;
        this.subHdrId = 'alert-subhdr-' + this.id;
        this.msgId = 'alert-msg-' + this.id;
        this.activeId = '';
        this.lastClick = 0;
        if (this.d.message) {
            this.descId = this.msgId;
        }
        else if (this.d.subTitle) {
            this.descId = this.subHdrId;
        }
        if (!this.d.message) {
            this.d.message = '';
        }
    }
    AlertCmp.prototype.ionViewDidLoad = function () {
        var _this = this;
        // normalize the data
        var data = this.d;
        data.buttons = data.buttons.map(function (button) {
            if (typeof button === 'string') {
                return { text: button };
            }
            return button;
        });
        data.inputs = data.inputs.map(function (input, index) {
            var r = {
                type: input.type || 'text',
                name: Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["l" /* isPresent */])(input.name) ? input.name : index + '',
                placeholder: Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["l" /* isPresent */])(input.placeholder) ? input.placeholder : '',
                value: Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["l" /* isPresent */])(input.value) ? input.value : '',
                label: input.label,
                checked: !!input.checked,
                disabled: !!input.disabled,
                id: Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["l" /* isPresent */])(input.id) ? input.id : "alert-input-" + _this.id + "-" + index,
                handler: Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["l" /* isPresent */])(input.handler) ? input.handler : null,
                min: Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["l" /* isPresent */])(input.min) ? input.min : null,
                max: Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["l" /* isPresent */])(input.max) ? input.max : null
            };
            return r;
        });
        // An alert can be created with several different inputs. Radios,
        // checkboxes and inputs are all accepted, but they cannot be mixed.
        var inputTypes = [];
        data.inputs.forEach(function (input) {
            if (inputTypes.indexOf(input.type) < 0) {
                inputTypes.push(input.type);
            }
        });
        if (inputTypes.length > 1 && (inputTypes.indexOf('checkbox') > -1 || inputTypes.indexOf('radio') > -1)) {
            console.warn("Alert cannot mix input types: " + (inputTypes.join('/')) + ". Please see alert docs for more info.");
        }
        this.inputType = inputTypes.length ? inputTypes[0] : null;
        var checkedInput = this.d.inputs.find(function (input) { return input.checked; });
        if (checkedInput) {
            this.activeId = checkedInput.id;
        }
        var hasTextInput = (this.d.inputs.length && this.d.inputs.some(function (i) { return !(__WEBPACK_IMPORTED_MODULE_2__util_dom__["a" /* NON_TEXT_INPUT_REGEX */].test(i.type)); }));
        if (!this.keyboardResizes && hasTextInput && this._plt.is('mobile')) {
            // this alert has a text input and it's on a mobile device so we should align
            // the alert up high because we need to leave space for the virtual keboard
            // this also helps prevent the layout getting all messed up from
            // the browser trying to scroll the input into a safe area
            this._renderer.setElementClass(this._elementRef.nativeElement, 'alert-top', true);
        }
    };
    AlertCmp.prototype.ionViewWillEnter = function () {
        this.gestureBlocker.block();
    };
    AlertCmp.prototype.ionViewDidLeave = function () {
        this.gestureBlocker.unblock();
    };
    AlertCmp.prototype.ionViewDidEnter = function () {
        // set focus on the first input or button in the alert
        // note that this does not always work and bring up the keyboard on
        // devices since the focus command must come from the user's touch event
        // and ionViewDidEnter is not in the same callstack as the touch event :(
        var focusableEle = this._elementRef.nativeElement.querySelector('input,button');
        if (focusableEle) {
            setTimeout(function () { return focusableEle.focus(); });
        }
        this.enabled = true;
    };
    AlertCmp.prototype.keyUp = function (ev) {
        if (this.enabled && this._viewCtrl.isLast()) {
            if (ev.keyCode === __WEBPACK_IMPORTED_MODULE_5__platform_key__["b" /* KEY_ENTER */]) {
                if (this.lastClick + 1000 < Date.now()) {
                    // do not fire this click if there recently was already a click
                    // this can happen when the button has focus and used the enter
                    // key to click the button. However, both the click handler and
                    // this keyup event will fire, so only allow one of them to go.
                    (void 0) /* console.debug */;
                    var button = this.d.buttons[this.d.buttons.length - 1];
                    this.btnClick(button);
                }
            }
            else if (ev.keyCode === __WEBPACK_IMPORTED_MODULE_5__platform_key__["c" /* KEY_ESCAPE */]) {
                (void 0) /* console.debug */;
                this.bdClick();
            }
        }
    };
    AlertCmp.prototype.btnClick = function (button) {
        if (!this.enabled) {
            return;
        }
        // keep the time of the most recent button click
        this.lastClick = Date.now();
        var shouldDismiss = true;
        if (button.handler) {
            // a handler has been provided, execute it
            // pass the handler the values from the inputs
            if (button.handler(this.getValues()) === false) {
                // if the return value of the handler is false then do not dismiss
                shouldDismiss = false;
            }
        }
        if (shouldDismiss) {
            this.dismiss(button.role);
        }
    };
    AlertCmp.prototype.rbClick = function (checkedInput) {
        if (this.enabled) {
            this.d.inputs.forEach(function (input) {
                input.checked = (checkedInput === input);
            });
            this.activeId = checkedInput.id;
            if (checkedInput.handler) {
                checkedInput.handler(checkedInput);
            }
        }
    };
    AlertCmp.prototype.cbClick = function (checkedInput) {
        if (this.enabled) {
            checkedInput.checked = !checkedInput.checked;
            if (checkedInput.handler) {
                checkedInput.handler(checkedInput);
            }
        }
    };
    AlertCmp.prototype.bdClick = function () {
        if (this.enabled && this.d.enableBackdropDismiss) {
            var cancelBtn = this.d.buttons.find(function (b) { return b.role === 'cancel'; });
            if (cancelBtn) {
                this.btnClick(cancelBtn);
            }
            else {
                this.dismiss('backdrop');
            }
        }
    };
    AlertCmp.prototype.dismiss = function (role) {
        var opts = {
            minClickBlockDuration: 400
        };
        return this._viewCtrl.dismiss(this.getValues(), role, opts);
    };
    AlertCmp.prototype.getValues = function () {
        if (this.inputType === 'radio') {
            // this is an alert with radio buttons (single value select)
            // return the one value which is checked, otherwise undefined
            var checkedInput = this.d.inputs.find(function (i) { return i.checked; });
            return checkedInput ? checkedInput.value : undefined;
        }
        if (this.inputType === 'checkbox') {
            // this is an alert with checkboxes (multiple value select)
            // return an array of all the checked values
            return this.d.inputs.filter(function (i) { return i.checked; }).map(function (i) { return i.value; });
        }
        if (this.d.inputs.length === 0) {
            // this is an alert without any options/inputs at all
            return undefined;
        }
        // this is an alert with text inputs
        // return an object of all the values with the input name as the key
        var values = {};
        this.d.inputs.forEach(function (i) {
            values[i.name] = i.value;
        });
        return values;
    };
    AlertCmp.prototype.ngOnDestroy = function () {
        (void 0) /* assert */;
        this.gestureBlocker.destroy();
    };
    AlertCmp.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'ion-alert',
                    template: '<ion-backdrop (click)="bdClick()" [class.backdrop-no-tappable]="!d.enableBackdropDismiss"></ion-backdrop>' +
                        '<div class="alert-wrapper">' +
                        '<div class="alert-head">' +
                        '<h2 id="{{hdrId}}" class="alert-title" *ngIf="d.title" [innerHTML]="d.title"></h2>' +
                        '<h3 id="{{subHdrId}}" class="alert-sub-title" *ngIf="d.subTitle" [innerHTML]="d.subTitle"></h3>' +
                        '</div>' +
                        '<div id="{{msgId}}" class="alert-message" [innerHTML]="d.message"></div>' +
                        '<div *ngIf="d.inputs.length" [ngSwitch]="inputType">' +
                        '<ng-template ngSwitchCase="radio">' +
                        '<div class="alert-radio-group" role="radiogroup" [attr.aria-labelledby]="hdrId" [attr.aria-activedescendant]="activeId">' +
                        '<button ion-button="alert-radio-button" *ngFor="let i of d.inputs" (click)="rbClick(i)" [attr.aria-checked]="i.checked" [disabled]="i.disabled" [attr.id]="i.id" class="alert-tappable alert-radio" role="radio">' +
                        '<div class="alert-radio-icon"><div class="alert-radio-inner"></div></div>' +
                        '<div class="alert-radio-label">' +
                        '{{i.label}}' +
                        '</div>' +
                        '</button>' +
                        '</div>' +
                        '</ng-template>' +
                        '<ng-template ngSwitchCase="checkbox">' +
                        '<div class="alert-checkbox-group">' +
                        '<button ion-button="alert-checkbox-button" *ngFor="let i of d.inputs" (click)="cbClick(i)" [attr.aria-checked]="i.checked" [attr.id]="i.id" [disabled]="i.disabled" class="alert-tappable alert-checkbox" role="checkbox">' +
                        '<div class="alert-checkbox-icon"><div class="alert-checkbox-inner"></div></div>' +
                        '<div class="alert-checkbox-label">' +
                        '{{i.label}}' +
                        '</div>' +
                        '</button>' +
                        '</div>' +
                        '</ng-template>' +
                        '<ng-template ngSwitchDefault>' +
                        '<div class="alert-input-group">' +
                        '<div *ngFor="let i of d.inputs" class="alert-input-wrapper">' +
                        '<input [placeholder]="i.placeholder" [(ngModel)]="i.value" [type]="i.type" dir="auto" [min]="i.min" [max]="i.max" [attr.id]="i.id" [disabled]="i.disabled" class="alert-input">' +
                        '</div>' +
                        '</div>' +
                        '</ng-template>' +
                        '</div>' +
                        '<div class="alert-button-group" [ngClass]="{\'alert-button-group-vertical\':d.buttons.length>2}">' +
                        '<button ion-button="alert-button" *ngFor="let b of d.buttons" (click)="btnClick(b)" [ngClass]="b.cssClass">' +
                        '{{b.text}}' +
                        '</button>' +
                        '</div>' +
                        '</div>',
                    host: {
                        'role': 'dialog',
                        '[attr.aria-labelledby]': 'hdrId',
                        '[attr.aria-describedby]': 'descId'
                    },
                    encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None,
                },] },
    ];
    /** @nocollapse */
    AlertCmp.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_8__navigation_view_controller__["a" /* ViewController */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_1__config_config__["a" /* Config */], },
        { type: __WEBPACK_IMPORTED_MODULE_3__gestures_gesture_controller__["m" /* GestureController */], },
        { type: __WEBPACK_IMPORTED_MODULE_6__navigation_nav_params__["a" /* NavParams */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: __WEBPACK_IMPORTED_MODULE_7__platform_platform__["a" /* Platform */], },
    ]; };
    AlertCmp.propDecorators = {
        'keyUp': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"], args: ['body:keyup', ['$event'],] },],
    };
    return AlertCmp;
}());

var alertIds = -1;
//# sourceMappingURL=alert-component.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/alert/alert-controller.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AlertController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__alert__ = __webpack_require__("./node_modules/ionic-angular/components/alert/alert.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_app__ = __webpack_require__("./node_modules/ionic-angular/components/app/app.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");




/**
 * @name AlertController
 * @description
 * An Alert is a dialog that presents users with information or collects
 * information from the user using inputs. An alert appears on top
 * of the app's content, and must be manually dismissed by the user before
 * they can resume interaction with the app. It can also optionally have a
 * `title`, `subTitle` and `message`.
 *
 * You can pass all of the alert's options in the first argument of
 * the create method: `create(opts)`. Otherwise the alert's instance
 * has methods to add options, such as `setTitle()` or `addButton()`.
 *
 *
 * ### Alert Buttons
 *
 * In the array of `buttons`, each button includes properties for its `text`,
 * and optionally a `handler`. If a handler returns `false` then the alert
 * will not automatically be dismissed when the button is clicked. All
 * buttons will show up in the order they have been added to the `buttons`
 * array, from left to right. Note: The right most button (the last one in
 * the array) is the main button.
 *
 * Optionally, a `role` property can be added to a button, such as `cancel`.
 * If a `cancel` role is on one of the buttons, then if the alert is
 * dismissed by tapping the backdrop, then it will fire the handler from
 * the button with a cancel role.
 *
 *
 * ### Alert Inputs
 *
 * Alerts can also include several different inputs whose data can be passed
 * back to the app. Inputs can be used as a simple way to prompt users for
 * information. Radios, checkboxes and text inputs are all accepted, but they
 * cannot be mixed. For example, an alert could have all radio button inputs,
 * or all checkbox inputs, but the same alert cannot mix radio and checkbox
 * inputs. Do note however, different types of "text"" inputs can be mixed,
 * such as `url`, `email`, `text`, etc. If you require a complex form UI
 * which doesn't fit within the guidelines of an alert then we recommend
 * building the form within a modal instead.
 *
 *
 * @usage
 * ```ts
 * import { AlertController } from 'ionic-angular';
 *
 * constructor(public alertCtrl: AlertController) { }
 *
 * presentAlert() {
 *   const alert = this.alertCtrl.create({
 *     title: 'Low battery',
 *     subTitle: '10% of battery remaining',
 *     buttons: ['Dismiss']
 *   });
 *   alert.onDidDismiss(() => console.log('Alert was dismissed by the user'));
 *   alert.present();
 * }
 *
 * presentConfirm() {
 *   const alert = this.alertCtrl.create({
 *     title: 'Confirm purchase',
 *     message: 'Do you want to buy this book?',
 *     buttons: [
 *       {
 *         text: 'Cancel',
 *         role: 'cancel',
 *         handler: () => {
 *           console.log('Cancel clicked');
 *         }
 *       },
 *       {
 *         text: 'Buy',
 *         handler: () => {
 *           console.log('Buy clicked');
 *         }
 *       }
 *     ]
 *   });
 *   alert.onDidDismiss(() => console.log('Alert was dismissed by the user'));
 *   alert.present();
 * }
 *
 * presentPrompt() {
 *   const alert = this.alertCtrl.create({
 *     title: 'Login',
 *     inputs: [
 *       {
 *         name: 'username',
 *         placeholder: 'Username'
 *       },
 *       {
 *         name: 'password',
 *         placeholder: 'Password',
 *         type: 'password'
 *       }
 *     ],
 *     buttons: [
 *       {
 *         text: 'Cancel',
 *         role: 'cancel',
 *         handler: data => {
 *           console.log('Cancel clicked');
 *         }
 *       },
 *       {
 *         text: 'Login',
 *         handler: data => {
 *           if (User.isValid(data.username, data.password)) {
 *             // logged in!
 *           } else {
 *             // invalid login
 *             return false;
 *           }
 *         }
 *       }
 *     ]
 *   });
 *   alert.present();
 * }
 * ```
 * @advanced
 *
 *
 *  Alert options
 *
 *  | Property              | Type      | Description                                                                  |
 *  |-----------------------|-----------|------------------------------------------------------------------------------|
 *  | title                 | `string`  | The title for the alert.                                                     |
 *  | subTitle              | `string`  | The subtitle for the alert.                                                  |
 *  | message               | `string`  | The message for the alert.                                                   |
 *  | cssClass              | `string`  | Additional classes for custom styles, separated by spaces.                   |
 *  | inputs                | `array`   | An array of inputs for the alert. See input options.                         |
 *  | buttons               | `array`   | An array of buttons for the alert. See buttons options.                      |
 *  | enableBackdropDismiss | `boolean` | Whether the alert should be dismissed by tapping the backdrop. Default true. |
 *
 *
 *  Input options
 *
 *  | Property    | Type      | Description                                                     |
 *  |-------------|-----------|-----------------------------------------------------------------|
 *  | type        | `string`  | The type the input should be: text, tel, number, etc.           |
 *  | name        | `string`  | The name for the input.                                         |
 *  | placeholder | `string`  | The input's placeholder (for textual/numeric inputs)            |
 *  | value       | `string`  | The input's value.                                              |
 *  | label       | `string`  | The input's label (only for radio/checkbox inputs)              |
 *  | checked     | `boolean` | Whether or not the input is checked.                            |
 *  | disabled    | `boolean` | Whether or not the input is disabled.                           |
 *  | id          | `string`  | The input's id.                                                 |
 *
 *  Button options
 *
 *  | Property | Type     | Description                                                     |
 *  |----------|----------|-----------------------------------------------------------------|
 *  | text     | `string` | The buttons displayed text.                                     |
 *  | handler  | `any`    | Emitted when the button is pressed.                             |
 *  | cssClass | `string` | An additional CSS class for the button.                         |
 *  | role     | `string` | The buttons role, null or `cancel`.                             |
 *
 * ### Detecting dismissal
 *
 * Any dismissal of the alert (including backdrop) can be detected
 * using the method `onDidDismiss(() => {})`.
 *
 * ### Dismissing And Async Navigation
 *
 * After an alert has been dismissed, the app may need to also transition
 * to another page depending on the handler's logic. However, because multiple
 * transitions were fired at roughly the same time, it's difficult for the
 * nav controller to cleanly animate multiple transitions that may
 * have been kicked off asynchronously. This is further described in the
 * [`Nav Transition Promises`](../../nav/NavController) section. For alerts,
 * this means it's best to wait for the alert to finish its transition
 * out before starting a new transition on the same nav controller.
 *
 * In the example below, after the alert button has been clicked, its handler
 * waits on async operation to complete, *then* it uses `pop` to navigate
 * back a page in the same stack. The potential problem is that the async operation
 * may have been completed before the alert has even finished its transition
 * out. In this case, it's best to ensure the alert has finished its transition
 * out first, *then* start the next transition.
 *
 * ```ts
 * const alert = this.alertCtrl.create({
 *   title: 'Hello',
 *   buttons: [{
 *     text: 'Ok',
 *     handler: () => {
 *       // user has clicked the alert button
 *       // begin the alert's dismiss transition
 *       const navTransition = alert.dismiss();
 *
 *       // start some async method
 *       someAsyncOperation().then(() => {
 *         // once the async operation has completed
 *         // then run the next nav transition after the
 *         // first transition has finished animating out
 *
 *         navTransition.then(() => {
 *           this.nav.pop();
 *         });
 *       });
 *       return false;
 *     }
 *   }]
 * });
 *
 * alert.present();
 * ```
 *
 * It's important to note that the handler returns `false`. A feature of
 * button handlers is that they automatically dismiss the alert when their button
 * was clicked, however, we'll need more control regarding the transition. Because
 * the handler returns `false`, then the alert does not automatically dismiss
 * itself. Instead, you now have complete control of when the alert has finished
 * transitioning, and the ability to wait for the alert to finish transitioning
 * out before starting a new transition.
 *
 *
 * @demo /docs/demos/src/alert/
 */
var AlertController = (function () {
    function AlertController(_app, config) {
        this._app = _app;
        this.config = config;
    }
    /**
     * Display an alert with a title, inputs, and buttons
     * @param {AlertOptions} opts Alert. See the table below
     */
    AlertController.prototype.create = function (opts) {
        if (opts === void 0) { opts = {}; }
        return new __WEBPACK_IMPORTED_MODULE_1__alert__["a" /* Alert */](this._app, opts, this.config);
    };
    AlertController.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    AlertController.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_2__app_app__["a" /* App */], },
        { type: __WEBPACK_IMPORTED_MODULE_3__config_config__["a" /* Config */], },
    ]; };
    return AlertController;
}());

//# sourceMappingURL=alert-controller.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/alert/alert-transitions.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AlertPopIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return AlertPopOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AlertMdPopIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AlertMdPopOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return AlertWpPopIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return AlertWpPopOut; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__animations_animation__ = __webpack_require__("./node_modules/ionic-angular/animations/animation.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__transitions_transition__ = __webpack_require__("./node_modules/ionic-angular/transitions/transition.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


/**
 * Animations for alerts
 */
var AlertPopIn = (function (_super) {
    __extends(AlertPopIn, _super);
    function AlertPopIn() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AlertPopIn.prototype.init = function () {
        var ele = this.enteringView.pageRef().nativeElement;
        var backdrop = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](this.plt, ele.querySelector('ion-backdrop'));
        var wrapper = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](this.plt, ele.querySelector('.alert-wrapper'));
        wrapper.fromTo('opacity', 0.01, 1).fromTo('scale', 1.1, 1);
        backdrop.fromTo('opacity', 0.01, 0.3);
        this
            .easing('ease-in-out')
            .duration(200)
            .add(backdrop)
            .add(wrapper);
    };
    return AlertPopIn;
}(__WEBPACK_IMPORTED_MODULE_1__transitions_transition__["a" /* Transition */]));

var AlertPopOut = (function (_super) {
    __extends(AlertPopOut, _super);
    function AlertPopOut() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AlertPopOut.prototype.init = function () {
        var ele = this.leavingView.pageRef().nativeElement;
        var backdrop = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](this.plt, ele.querySelector('ion-backdrop'));
        var wrapper = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](this.plt, ele.querySelector('.alert-wrapper'));
        wrapper.fromTo('opacity', 0.99, 0).fromTo('scale', 1, 0.9);
        backdrop.fromTo('opacity', 0.3, 0);
        this
            .easing('ease-in-out')
            .duration(200)
            .add(backdrop)
            .add(wrapper);
    };
    return AlertPopOut;
}(__WEBPACK_IMPORTED_MODULE_1__transitions_transition__["a" /* Transition */]));

var AlertMdPopIn = (function (_super) {
    __extends(AlertMdPopIn, _super);
    function AlertMdPopIn() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AlertMdPopIn.prototype.init = function () {
        var ele = this.enteringView.pageRef().nativeElement;
        var backdrop = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](this.plt, ele.querySelector('ion-backdrop'));
        var wrapper = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](this.plt, ele.querySelector('.alert-wrapper'));
        wrapper.fromTo('opacity', 0.01, 1).fromTo('scale', 1.1, 1);
        backdrop.fromTo('opacity', 0.01, 0.5);
        this
            .easing('ease-in-out')
            .duration(200)
            .add(backdrop)
            .add(wrapper);
    };
    return AlertMdPopIn;
}(__WEBPACK_IMPORTED_MODULE_1__transitions_transition__["a" /* Transition */]));

var AlertMdPopOut = (function (_super) {
    __extends(AlertMdPopOut, _super);
    function AlertMdPopOut() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AlertMdPopOut.prototype.init = function () {
        var ele = this.leavingView.pageRef().nativeElement;
        var backdrop = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](this.plt, ele.querySelector('ion-backdrop'));
        var wrapper = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](this.plt, ele.querySelector('.alert-wrapper'));
        wrapper.fromTo('opacity', 0.99, 0).fromTo('scale', 1, 0.9);
        backdrop.fromTo('opacity', 0.5, 0);
        this
            .easing('ease-in-out')
            .duration(200)
            .add(backdrop)
            .add(wrapper);
    };
    return AlertMdPopOut;
}(__WEBPACK_IMPORTED_MODULE_1__transitions_transition__["a" /* Transition */]));

var AlertWpPopIn = (function (_super) {
    __extends(AlertWpPopIn, _super);
    function AlertWpPopIn() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AlertWpPopIn.prototype.init = function () {
        var ele = this.enteringView.pageRef().nativeElement;
        var backdrop = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](this.plt, ele.querySelector('ion-backdrop'));
        var wrapper = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](this.plt, ele.querySelector('.alert-wrapper'));
        wrapper.fromTo('opacity', 0.01, 1).fromTo('scale', 1.3, 1);
        backdrop.fromTo('opacity', 0.01, 0.5);
        this
            .easing('cubic-bezier(0,0,0.05,1)')
            .duration(200)
            .add(backdrop)
            .add(wrapper);
    };
    return AlertWpPopIn;
}(__WEBPACK_IMPORTED_MODULE_1__transitions_transition__["a" /* Transition */]));

var AlertWpPopOut = (function (_super) {
    __extends(AlertWpPopOut, _super);
    function AlertWpPopOut() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AlertWpPopOut.prototype.init = function () {
        var ele = this.leavingView.pageRef().nativeElement;
        var backdrop = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](this.plt, ele.querySelector('ion-backdrop'));
        var wrapper = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](this.plt, ele.querySelector('.alert-wrapper'));
        wrapper.fromTo('opacity', 0.99, 0).fromTo('scale', 1, 1.3);
        backdrop.fromTo('opacity', 0.5, 0);
        this
            .easing('ease-out')
            .duration(150)
            .add(backdrop)
            .add(wrapper);
    };
    return AlertWpPopOut;
}(__WEBPACK_IMPORTED_MODULE_1__transitions_transition__["a" /* Transition */]));

//# sourceMappingURL=alert-transitions.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/alert/alert.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Alert; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__alert_component__ = __webpack_require__("./node_modules/ionic-angular/components/alert/alert-component.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__alert_transitions__ = __webpack_require__("./node_modules/ionic-angular/components/alert/alert-transitions.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__navigation_view_controller__ = __webpack_require__("./node_modules/ionic-angular/navigation/view-controller.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




/**
 * @hidden
 */
var Alert = (function (_super) {
    __extends(Alert, _super);
    function Alert(app, opts, config) {
        if (opts === void 0) { opts = {}; }
        var _this = this;
        opts.inputs = opts.inputs || [];
        opts.buttons = opts.buttons || [];
        opts.enableBackdropDismiss = Object(__WEBPACK_IMPORTED_MODULE_2__util_util__["l" /* isPresent */])(opts.enableBackdropDismiss) ? !!opts.enableBackdropDismiss : true;
        _this = _super.call(this, __WEBPACK_IMPORTED_MODULE_0__alert_component__["a" /* AlertCmp */], opts, null) || this;
        _this._app = app;
        _this.isOverlay = true;
        config.setTransition('alert-pop-in', __WEBPACK_IMPORTED_MODULE_1__alert_transitions__["c" /* AlertPopIn */]);
        config.setTransition('alert-pop-out', __WEBPACK_IMPORTED_MODULE_1__alert_transitions__["d" /* AlertPopOut */]);
        config.setTransition('alert-md-pop-in', __WEBPACK_IMPORTED_MODULE_1__alert_transitions__["a" /* AlertMdPopIn */]);
        config.setTransition('alert-md-pop-out', __WEBPACK_IMPORTED_MODULE_1__alert_transitions__["b" /* AlertMdPopOut */]);
        config.setTransition('alert-wp-pop-in', __WEBPACK_IMPORTED_MODULE_1__alert_transitions__["e" /* AlertWpPopIn */]);
        config.setTransition('alert-wp-pop-out', __WEBPACK_IMPORTED_MODULE_1__alert_transitions__["f" /* AlertWpPopOut */]);
        return _this;
    }
    /**
    * @hidden
    */
    Alert.prototype.getTransitionName = function (direction) {
        var key = (direction === 'back' ? 'alertLeave' : 'alertEnter');
        return this._nav && this._nav.config.get(key);
    };
    /**
     * @param {string} title Alert title
     */
    Alert.prototype.setTitle = function (title) {
        this.data.title = title;
        return this;
    };
    /**
     * @param {string} subTitle Alert subtitle
     */
    Alert.prototype.setSubTitle = function (subTitle) {
        this.data.subTitle = subTitle;
        return this;
    };
    /**
     * @param {string} message  Alert message content
     */
    Alert.prototype.setMessage = function (message) {
        this.data.message = message;
        return this;
    };
    /**
     * @param {object} input Alert input
     */
    Alert.prototype.addInput = function (input) {
        this.data.inputs.push(input);
        return this;
    };
    /**
     * @param {any} button Alert button
     */
    Alert.prototype.addButton = function (button) {
        this.data.buttons.push(button);
        return this;
    };
    /**
     * @param {string} cssClass Set the CSS class names on the alert's outer wrapper.
     */
    Alert.prototype.setCssClass = function (cssClass) {
        this.data.cssClass = cssClass;
        return this;
    };
    /**
     * @param {string} mode Set the mode of the alert (ios, md, wp).
     */
    Alert.prototype.setMode = function (mode) {
        this.data.mode = mode;
    };
    /**
     * Present the alert instance.
     *
     * @param {NavOptions} [navOptions={}] Nav options to go with this transition.
     * @returns {Promise} Returns a promise which is resolved when the transition has completed.
     */
    Alert.prototype.present = function (navOptions) {
        if (navOptions === void 0) { navOptions = {}; }
        navOptions.minClickBlockDuration = navOptions.minClickBlockDuration || 400;
        return this._app.present(this, navOptions);
    };
    return Alert;
}(__WEBPACK_IMPORTED_MODULE_3__navigation_view_controller__["a" /* ViewController */]));

//# sourceMappingURL=alert.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/app/app-constants.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PORTAL_DEFAULT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PORTAL_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PORTAL_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PORTAL_TOAST; });
var PORTAL_DEFAULT = 1;
var PORTAL_MODAL = 2;
var PORTAL_LOADING = 3;
var PORTAL_TOAST = 4;
//# sourceMappingURL=app-constants.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/app/app-root.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppRootToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IonicApp; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__("./node_modules/ionic-angular/components/app/app.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ion__ = __webpack_require__("./node_modules/ionic-angular/components/ion.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__overlay_portal__ = __webpack_require__("./node_modules/ionic-angular/components/app/overlay-portal.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__platform_platform__ = __webpack_require__("./node_modules/ionic-angular/platform/platform.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__app_constants__ = __webpack_require__("./node_modules/ionic-angular/components/app/app-constants.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();







var AppRootToken = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["InjectionToken"]('USERROOT');
/**
 * @hidden
 */
var IonicApp = (function (_super) {
    __extends(IonicApp, _super);
    function IonicApp(_userCmp, _cfr, elementRef, renderer, config, _plt, app) {
        var _this = _super.call(this, config, elementRef, renderer, 'app-root') || this;
        _this._userCmp = _userCmp;
        _this._cfr = _cfr;
        _this._plt = _plt;
        // register with App that this is Ionic's appRoot component. tada!
        app._appRoot = _this;
        _this._stopScrollPlugin = window['IonicStopScroll'];
        return _this;
    }
    IonicApp.prototype.ngOnInit = function () {
        var _this = this;
        // load the user root component
        // into Ionic's root component
        var factory = this._cfr.resolveComponentFactory(this._userCmp);
        var componentRef = this._viewport.createComponent(factory);
        this._renderer.setElementClass(componentRef.location.nativeElement, 'app-root', true);
        componentRef.changeDetectorRef.detectChanges();
        // set the mode class name
        // ios/md/wp
        this.setElementClass(this._config.get('mode'), true);
        var versions = this._plt.versions();
        this._plt.platforms().forEach(function (platformName) {
            // platform-ios
            var platformClass = 'platform-' + platformName;
            _this.setElementClass(platformClass, true);
            var platformVersion = versions[platformName];
            if (platformVersion) {
                // platform-ios9
                platformClass += platformVersion.major;
                _this.setElementClass(platformClass, true);
                // platform-ios9_3
                _this.setElementClass(platformClass + '_' + platformVersion.minor, true);
            }
        });
        // touch devices should not use :hover CSS pseudo
        // enable :hover CSS when the "hoverCSS" setting is not false
        if (this._config.getBoolean('hoverCSS', true)) {
            this.setElementClass('enable-hover', true);
        }
        // sweet, the app root has loaded!
        // which means angular and ionic has fully loaded!
        // fire off the platform prepare ready, which could
        // have been switched out by any of the platform engines
        this._plt.prepareReady();
    };
    /**
     * @hidden
     */
    IonicApp.prototype._getPortal = function (portal) {
        if (portal === __WEBPACK_IMPORTED_MODULE_6__app_constants__["b" /* PORTAL_LOADING */]) {
            return this._loadingPortal;
        }
        if (portal === __WEBPACK_IMPORTED_MODULE_6__app_constants__["d" /* PORTAL_TOAST */]) {
            return this._toastPortal;
        }
        // Modals need their own overlay becuase we don't want an ActionSheet
        // or Alert to trigger lifecycle events inside a modal
        if (portal === __WEBPACK_IMPORTED_MODULE_6__app_constants__["c" /* PORTAL_MODAL */]) {
            return this._modalPortal;
        }
        return this._overlayPortal;
    };
    IonicApp.prototype._getActivePortal = function () {
        var defaultPortal = this._overlayPortal;
        var modalPortal = this._modalPortal;
        var hasModal = modalPortal.length() > 0;
        var hasDefault = defaultPortal.length() > 0;
        if (!hasModal && !hasDefault) {
            return null;
        }
        else if (hasModal && hasDefault) {
            var defaultIndex = defaultPortal.getActive().getZIndex();
            var modalIndex = modalPortal.getActive().getZIndex();
            if (defaultIndex > modalIndex) {
                return defaultPortal;
            }
            else {
                (void 0) /* assert */;
                return modalPortal;
            }
        }
        if (hasModal) {
            return modalPortal;
        }
        else if (hasDefault) {
            return defaultPortal;
        }
    };
    IonicApp.prototype._disableScroll = function (shouldDisableScroll) {
        var _this = this;
        if (shouldDisableScroll) {
            this.stopScroll().then(function () {
                _this._tmr = _this._plt.timeout(function () {
                    (void 0) /* console.debug */;
                    _this.setElementClass('disable-scroll', true);
                }, 32);
            });
        }
        else {
            var plugin = this._stopScrollPlugin;
            if (plugin && plugin.cancel) {
                plugin.cancel();
            }
            clearTimeout(this._tmr);
            (void 0) /* console.debug */;
            this.setElementClass('disable-scroll', false);
            /**
             * On iOS 12.2 there is a bug that
             * prevents pointer-events from being
             * re-enabled when removing the
             * disable-scroll class.
             */
            var plaform_1 = this._plt;
            plaform_1.raf(function () {
                _this.setElementStyle('z-index', '1');
                plaform_1.raf(function () {
                    _this.setElementStyle('z-index', null);
                });
            });
        }
    };
    IonicApp.prototype.stopScroll = function () {
        var _this = this;
        if (this._stopScrollPlugin) {
            return new Promise(function (resolve) {
                _this._stopScrollPlugin.stop(function () { return resolve(true); });
            });
        }
        else {
            return Promise.resolve(false);
        }
    };
    IonicApp.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'ion-app',
                    template: '<div #viewport app-viewport></div>' +
                        '<div #modalPortal overlay-portal></div>' +
                        '<div #overlayPortal overlay-portal></div>' +
                        '<div #loadingPortal class="loading-portal" overlay-portal></div>' +
                        '<div #toastPortal class="toast-portal" [overlay-portal]="10000"></div>' +
                        '<div class="click-block"></div>'
                },] },
    ];
    /** @nocollapse */
    IonicApp.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [AppRootToken,] },] },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ComponentFactoryResolver"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: __WEBPACK_IMPORTED_MODULE_2__config_config__["a" /* Config */], },
        { type: __WEBPACK_IMPORTED_MODULE_5__platform_platform__["a" /* Platform */], },
        { type: __WEBPACK_IMPORTED_MODULE_1__app__["a" /* App */], },
    ]; };
    IonicApp.propDecorators = {
        '_viewport': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"], args: ['viewport', { read: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"] },] },],
        '_modalPortal': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"], args: ['modalPortal', { read: __WEBPACK_IMPORTED_MODULE_4__overlay_portal__["a" /* OverlayPortal */] },] },],
        '_overlayPortal': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"], args: ['overlayPortal', { read: __WEBPACK_IMPORTED_MODULE_4__overlay_portal__["a" /* OverlayPortal */] },] },],
        '_loadingPortal': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"], args: ['loadingPortal', { read: __WEBPACK_IMPORTED_MODULE_4__overlay_portal__["a" /* OverlayPortal */] },] },],
        '_toastPortal': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"], args: ['toastPortal', { read: __WEBPACK_IMPORTED_MODULE_4__overlay_portal__["a" /* OverlayPortal */] },] },],
    };
    return IonicApp;
}(__WEBPACK_IMPORTED_MODULE_3__ion__["a" /* Ion */]));

//# sourceMappingURL=app-root.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/app/app.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return App; });
/* unused harmony export getNavByIdOrName */
/* unused harmony export findTopNavs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_platform_browser__ = __webpack_require__("./node_modules/@angular/platform-browser/esm5/platform-browser.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_constants__ = __webpack_require__("./node_modules/ionic-angular/components/app/app-constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__navigation_nav_util__ = __webpack_require__("./node_modules/ionic-angular/navigation/nav-util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__menu_controller__ = __webpack_require__("./node_modules/ionic-angular/components/app/menu-controller.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__platform_platform__ = __webpack_require__("./node_modules/ionic-angular/platform/platform.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__transitions_transition_ios__ = __webpack_require__("./node_modules/ionic-angular/transitions/transition-ios.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__transitions_transition_md__ = __webpack_require__("./node_modules/ionic-angular/transitions/transition-md.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__transitions_transition_wp__ = __webpack_require__("./node_modules/ionic-angular/transitions/transition-wp.js");










/**
 * @name App
 * @description
 * App is a utility class used in Ionic to get information about various aspects of an app
 */
var App = (function () {
    function App(_config, _plt, _menuCtrl) {
        this._config = _config;
        this._plt = _plt;
        this._menuCtrl = _menuCtrl;
        this._disTime = 0;
        this._scrollTime = 0;
        this._title = '';
        this._titleSrv = new __WEBPACK_IMPORTED_MODULE_1__angular_platform_browser__["Title"](__WEBPACK_IMPORTED_MODULE_1__angular_platform_browser__["DOCUMENT"]);
        this._rootNavs = new Map();
        this._didScroll = false;
        /**
         * Observable that emits whenever a view loads in the app.
         * @returns {Observable} Returns an observable
         */
        this.viewDidLoad = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
         * Observable that emits before any view is entered in the app.
         * @returns {Observable} Returns an observable
         */
        this.viewWillEnter = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
         * Observable that emits after any view is entered in the app.
         * @returns {Observable} Returns an observable
         */
        this.viewDidEnter = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
         * Observable that emits before any view is exited in the app.
         * @returns {Observable} Returns an observable
         */
        this.viewWillLeave = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
         * Observable that emits after any view is exited in the app.
         * @returns {Observable} Returns an observable
         */
        this.viewDidLeave = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
         * Observable that emits before any view unloads in the app.
         * @returns {Observable} Returns an observable
         */
        this.viewWillUnload = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        // listen for hardware back button events
        // register this back button action with a default priority
        _plt.registerBackButtonAction(this.goBack.bind(this));
        this._disableScrollAssist = _config.getBoolean('disableScrollAssist', false);
        var blurring = _config.getBoolean('inputBlurring', false);
        if (blurring) {
            this._enableInputBlurring();
        }
        (void 0) /* runInDev */;
        _config.setTransition('ios-transition', __WEBPACK_IMPORTED_MODULE_7__transitions_transition_ios__["a" /* IOSTransition */]);
        _config.setTransition('md-transition', __WEBPACK_IMPORTED_MODULE_8__transitions_transition_md__["a" /* MDTransition */]);
        _config.setTransition('wp-transition', __WEBPACK_IMPORTED_MODULE_9__transitions_transition_wp__["a" /* WPTransition */]);
    }
    /**
     * Sets the document title.
     * @param {string} val  Value to set the document title to.
     */
    App.prototype.setTitle = function (val) {
        if (val !== this._title) {
            this._title = val;
            this._titleSrv.setTitle(val);
        }
    };
    /**
     * @hidden
     */
    App.prototype.setElementClass = function (className, isAdd) {
        this._appRoot.setElementClass(className, isAdd);
    };
    /**
     * @hidden
     * Sets if the app is currently enabled or not, meaning if it's
     * available to accept new user commands. For example, this is set to `false`
     * while views transition, a modal slides up, an action-sheet
     * slides up, etc. After the transition completes it is set back to `true`.
     * @param {boolean} isEnabled `true` for enabled, `false` for disabled
     * @param {number} duration  When `isEnabled` is set to `false`, this argument
     * is used to set the maximum number of milliseconds that app will wait until
     * it will automatically enable the app again. It's basically a fallback incase
     * something goes wrong during a transition and the app wasn't re-enabled correctly.
     */
    App.prototype.setEnabled = function (isEnabled, duration, minDuration) {
        if (duration === void 0) { duration = 700; }
        if (minDuration === void 0) { minDuration = 0; }
        this._disTime = (isEnabled ? 0 : Date.now() + duration);
        if (this._clickBlock) {
            if (isEnabled) {
                // disable the click block if it's enabled, or the duration is tiny
                this._clickBlock.activate(false, CLICK_BLOCK_BUFFER_IN_MILLIS, minDuration);
            }
            else {
                // show the click block for duration + some number
                this._clickBlock.activate(true, duration + CLICK_BLOCK_BUFFER_IN_MILLIS, minDuration);
            }
        }
    };
    /**
     * @hidden
     * Toggles whether an application can be scrolled
     * @param {boolean} disableScroll when set to `false`, the application's
     * scrolling is enabled. When set to `true`, scrolling is disabled.
     */
    App.prototype._setDisableScroll = function (disableScroll) {
        if (this._disableScrollAssist) {
            this._appRoot._disableScroll(disableScroll);
        }
    };
    /**
     * @hidden
     * Boolean if the app is actively enabled or not.
     * @return {boolean}
     */
    App.prototype.isEnabled = function () {
        var disTime = this._disTime;
        if (disTime === 0) {
            return true;
        }
        return (disTime < Date.now());
    };
    /**
     * @hidden
     */
    App.prototype.setScrolling = function () {
        this._scrollTime = Date.now() + ACTIVE_SCROLLING_TIME;
        this._didScroll = true;
    };
    /**
     * Boolean if the app is actively scrolling or not.
     * @return {boolean} returns true or false
     */
    App.prototype.isScrolling = function () {
        var scrollTime = this._scrollTime;
        if (scrollTime === 0) {
            return false;
        }
        if (scrollTime < Date.now()) {
            this._scrollTime = 0;
            return false;
        }
        return true;
    };
    /**
     * @return {NavController} Returns the first Active Nav Controller from the list. This method is deprecated
     */
    App.prototype.getActiveNav = function () {
        console.warn('(getActiveNav) is deprecated and will be removed in the next major release. Use getActiveNavs instead.');
        var navs = this.getActiveNavs();
        if (navs && navs.length) {
            return navs[0];
        }
        return null;
    };
    /**
     * @return {NavController[]} Returns the active NavControllers. Using this method is preferred when we need access to the top-level navigation controller while on the outside views and handlers like `registerBackButtonAction()`
     */
    App.prototype.getActiveNavs = function (rootNavId) {
        var portal = this._appRoot._getPortal(__WEBPACK_IMPORTED_MODULE_2__app_constants__["c" /* PORTAL_MODAL */]);
        if (portal.length() > 0) {
            return findTopNavs(portal);
        }
        if (!this._rootNavs || !this._rootNavs.size) {
            return [];
        }
        if (this._rootNavs.size === 1) {
            return findTopNavs(this._rootNavs.values().next().value);
        }
        if (rootNavId) {
            return findTopNavs(this._rootNavs.get(rootNavId));
        }
        // fallback to just using all root names
        var activeNavs = [];
        this._rootNavs.forEach(function (nav) {
            var topNavs = findTopNavs(nav);
            activeNavs = activeNavs.concat(topNavs);
        });
        return activeNavs;
    };
    App.prototype.getRootNav = function () {
        console.warn('(getRootNav) is deprecated and will be removed in the next major release. Use getRootNavById instead.');
        var rootNavs = this.getRootNavs();
        if (rootNavs.length === 0) {
            return null;
        }
        else if (rootNavs.length > 1) {
            console.warn('(getRootNav) there are multiple root navs, use getRootNavs instead');
        }
        return rootNavs[0];
    };
    App.prototype.getRootNavs = function () {
        var navs = [];
        this._rootNavs.forEach(function (nav) { return navs.push(nav); });
        return navs;
    };
    /**
     * @return {NavController} Returns the root NavController
     */
    App.prototype.getRootNavById = function (navId) {
        return this._rootNavs.get(navId);
    };
    /**
     * @hidden
     */
    App.prototype.registerRootNav = function (nav) {
        this._rootNavs.set(nav.id, nav);
    };
    /**
     * @hidden
     */
    App.prototype.unregisterRootNav = function (nav) {
        this._rootNavs.delete(nav.id);
    };
    App.prototype.getActiveNavContainers = function () {
        // for each root nav container, get it's active nav
        var list = [];
        this._rootNavs.forEach(function (container) {
            list = list.concat(findTopNavs(container));
        });
        return list;
    };
    /**
     * @hidden
     */
    App.prototype.present = function (enteringView, opts, appPortal) {
        (void 0) /* assert */;
        var portal = this._appRoot._getPortal(appPortal);
        // Set Nav must be set here in order to dimiss() work synchnously.
        // TODO: move _setNav() to the earlier stages of NavController. _queueTrns()
        enteringView._setNav(portal);
        opts.direction = __WEBPACK_IMPORTED_MODULE_4__navigation_nav_util__["b" /* DIRECTION_FORWARD */];
        if (!opts.animation) {
            opts.animation = enteringView.getTransitionName(__WEBPACK_IMPORTED_MODULE_4__navigation_nav_util__["b" /* DIRECTION_FORWARD */]);
        }
        enteringView.setLeavingOpts({
            keyboardClose: opts.keyboardClose,
            direction: __WEBPACK_IMPORTED_MODULE_4__navigation_nav_util__["a" /* DIRECTION_BACK */],
            animation: enteringView.getTransitionName(__WEBPACK_IMPORTED_MODULE_4__navigation_nav_util__["a" /* DIRECTION_BACK */]),
            ev: opts.ev
        });
        return portal.insertPages(-1, [enteringView], opts);
    };
    /**
     * @hidden
     */
    App.prototype.goBack = function () {
        if (this._menuCtrl && this._menuCtrl.isOpen()) {
            return this._menuCtrl.close();
        }
        var navPromise = this.navPop();
        if (!navPromise) {
            // no views to go back to
            // let's exit the app
            if (this._config.getBoolean('navExitApp', true)) {
                (void 0) /* console.debug */;
                this._plt.exitApp();
            }
        }
        return navPromise;
    };
    /**
     * @hidden
     */
    App.prototype.navPop = function () {
        var _this = this;
        if (!this._rootNavs || this._rootNavs.size === 0 || !this.isEnabled()) {
            return Promise.resolve();
        }
        // If there are any alert/actionsheet open, let's do nothing
        var portal = this._appRoot._getPortal(__WEBPACK_IMPORTED_MODULE_2__app_constants__["a" /* PORTAL_DEFAULT */]);
        if (portal.length() > 0) {
            return Promise.resolve();
        }
        var navToPop = null;
        var mostRecentVC = null;
        this._rootNavs.forEach(function (navContainer) {
            var activeNavs = _this.getActiveNavs(navContainer.id);
            var poppableNavs = activeNavs.map(function (activeNav) { return getPoppableNav(activeNav); }).filter(function (nav) { return !!nav; });
            poppableNavs.forEach(function (poppable) {
                var topViewController = poppable.last();
                if (poppable._isPortal || (topViewController && poppable.length() > 1 && (!mostRecentVC || topViewController._ts >= mostRecentVC._ts))) {
                    mostRecentVC = topViewController;
                    navToPop = poppable;
                }
            });
        });
        if (navToPop) {
            return navToPop.pop();
        }
    };
    /**
     * @hidden
     */
    App.prototype._enableInputBlurring = function () {
        (void 0) /* console.debug */;
        var focused = true;
        var self = this;
        var platform = this._plt;
        platform.registerListener(platform.doc(), 'focusin', onFocusin, { capture: true, zone: false, passive: true });
        platform.registerListener(platform.doc(), 'touchend', onTouchend, { capture: false, zone: false, passive: true });
        function onFocusin() {
            focused = true;
        }
        function onTouchend(ev) {
            // if app did scroll return early
            if (self._didScroll) {
                self._didScroll = false;
                return;
            }
            var active = self._plt.getActiveElement();
            if (!active) {
                return;
            }
            // only blur if the active element is a text-input or a textarea
            if (SKIP_BLURRING.indexOf(active.tagName) === -1) {
                return;
            }
            // if the selected target is the active element, do not blur
            var tapped = ev.target;
            if (tapped === active) {
                return;
            }
            if (SKIP_BLURRING.indexOf(tapped.tagName) >= 0) {
                return;
            }
            // skip if div is a cover
            if (tapped.classList.contains('input-cover')) {
                return;
            }
            focused = false;
            // TODO: find a better way, why 50ms?
            platform.timeout(function () {
                if (!focused) {
                    active.blur();
                }
            }, 50);
        }
    };
    App.prototype.getNavByIdOrName = function (id) {
        var navs = Array.from(this._rootNavs.values());
        for (var _i = 0, navs_1 = navs; _i < navs_1.length; _i++) {
            var navContainer = navs_1[_i];
            var match = getNavByIdOrName(navContainer, id);
            if (match) {
                return match;
            }
        }
        return null;
    };
    App.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    App.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_3__config_config__["a" /* Config */], },
        { type: __WEBPACK_IMPORTED_MODULE_6__platform_platform__["a" /* Platform */], },
        { type: __WEBPACK_IMPORTED_MODULE_5__menu_controller__["a" /* MenuController */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
    ]; };
    return App;
}());

function getNavByIdOrName(nav, id) {
    if (nav.id === id || nav.name === id) {
        return nav;
    }
    for (var _i = 0, _a = nav.getAllChildNavs(); _i < _a.length; _i++) {
        var child = _a[_i];
        var tmp = getNavByIdOrName(child, id);
        if (tmp) {
            return tmp;
        }
    }
    return null;
}
function getPoppableNav(nav) {
    if (!nav) {
        return null;
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_4__navigation_nav_util__["o" /* isTabs */])(nav)) {
        // tabs aren't a nav, so just call this function again immediately on the parent on tabs
        return getPoppableNav(nav.parent);
    }
    var len = nav.length();
    if (len > 1 || (nav._isPortal && len > 0)) {
        // this nav controller has more than one view
        // use this nav!
        return nav;
    }
    // try again using the parent nav (if there is one)
    return getPoppableNav(nav.parent);
}
function findTopNavs(nav) {
    var containers = [];
    var childNavs = nav.getActiveChildNavs();
    if (!childNavs || !childNavs.length) {
        containers.push(nav);
    }
    else {
        childNavs.forEach(function (childNav) {
            var topNavs = findTopNavs(childNav);
            containers = containers.concat(topNavs);
        });
    }
    return containers;
}
var SKIP_BLURRING = ['INPUT', 'TEXTAREA', 'ION-INPUT', 'ION-TEXTAREA'];
var ACTIVE_SCROLLING_TIME = 100;
var CLICK_BLOCK_BUFFER_IN_MILLIS = 64;
//# sourceMappingURL=app.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/app/click-block.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClickBlock; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_app__ = __webpack_require__("./node_modules/ionic-angular/components/app/app.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__platform_platform__ = __webpack_require__("./node_modules/ionic-angular/platform/platform.js");




/**
 * @hidden
 */
var ClickBlock = (function () {
    function ClickBlock(app, config, plt, elementRef, renderer) {
        this.plt = plt;
        this.elementRef = elementRef;
        this.renderer = renderer;
        this._showing = false;
        app._clickBlock = this;
        var enabled = this.isEnabled = config.getBoolean('clickBlock', true);
        if (enabled) {
            this._setElementClass('click-block-enabled', true);
        }
    }
    ClickBlock.prototype.activate = function (shouldShow, expire, minDuration) {
        if (expire === void 0) { expire = 100; }
        if (minDuration === void 0) { minDuration = 0; }
        if (this.isEnabled) {
            this.plt.cancelTimeout(this._tmr);
            if (shouldShow) {
                // remember when we started the click block
                this._start = Date.now();
                // figure out the minimum time it should be showing until
                // this is useful for transitions that are less than 300ms
                this._minEnd = this._start + (minDuration || 0);
                this._activate(true);
            }
            this._tmr = this.plt.timeout(this._activate.bind(this, false), expire);
        }
    };
    /** @internal */
    ClickBlock.prototype._activate = function (shouldShow) {
        if (this._showing !== shouldShow) {
            if (!shouldShow) {
                // check if it was enabled before the minimum duration
                // this is useful for transitions that are less than 300ms
                var now = Date.now();
                if (now < this._minEnd) {
                    this._tmr = this.plt.timeout(this._activate.bind(this, false), this._minEnd - now);
                    return;
                }
            }
            this._setElementClass('click-block-active', shouldShow);
            this._showing = shouldShow;
        }
    };
    ClickBlock.prototype._setElementClass = function (className, add) {
        this.renderer.setElementClass(this.elementRef.nativeElement, className, add);
    };
    ClickBlock.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: '.click-block'
                },] },
    ];
    /** @nocollapse */
    ClickBlock.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__app_app__["a" /* App */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return __WEBPACK_IMPORTED_MODULE_1__app_app__["a" /* App */]; }),] },] },
        { type: __WEBPACK_IMPORTED_MODULE_2__config_config__["a" /* Config */], },
        { type: __WEBPACK_IMPORTED_MODULE_3__platform_platform__["a" /* Platform */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    ]; };
    return ClickBlock;
}());

//# sourceMappingURL=click-block.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/app/menu-controller.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MenuController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");

/**
 * @name MenuController
 * @description
 * The MenuController is a provider which makes it easy to control a [Menu](../../menu/Menu/).
 * Its methods can be used to display the menu, enable the menu, toggle the menu, and more.
 * The controller will grab a reference to the menu by the `side`, `id`, or, if neither
 * of these are passed to it, it will grab the first menu it finds.
 *
 *
 * @usage
 *
 * Add a basic menu component to start with. See the [Menu](../../menu/Menu/) API docs
 * for more information on adding menu components.
 *
 * ```html
 * <ion-menu [content]="mycontent">
 *   <ion-content>
 *     <ion-list>
 *     ...
 *     </ion-list>
 *   </ion-content>
 * </ion-menu>
 *
 * <ion-nav #mycontent [root]="rootPage"></ion-nav>
 * ```
 *
 * To call the controller methods, inject the `MenuController` provider
 * into the page. Then, create some methods for opening, closing, and
 * toggling the menu.
 *
 * ```ts
 * import { Component } from '@angular/core';
 * import { MenuController } from 'ionic-angular';
 *
 * @Component({...})
 * export class MyPage {
 *
 *  constructor(public menuCtrl: MenuController) {
 *
 *  }
 *
 *  openMenu() {
 *    this.menuCtrl.open();
 *  }
 *
 *  closeMenu() {
 *    this.menuCtrl.close();
 *  }
 *
 *  toggleMenu() {
 *    this.menuCtrl.toggle();
 *  }
 *
 * }
 * ```
 *
 * Since only one menu exists, the `MenuController` will grab the
 * correct menu and call the correct method for each.
 *
 *
 * ### Multiple Menus on Different Sides
 *
 * For applications with both a left and right menu, the desired menu can be
 * grabbed by passing the `side` of the menu. If nothing is passed, it will
 * default to the `"left"` menu.
 *
 * ```html
 * <ion-menu side="left" [content]="mycontent">...</ion-menu>
 * <ion-menu side="right" [content]="mycontent">...</ion-menu>
 * <ion-nav #mycontent [root]="rootPage"></ion-nav>
 * ```
 *
 * ```ts
 *  toggleLeftMenu() {
 *    this.menuCtrl.toggle();
 *  }
 *
 *  toggleRightMenu() {
 *    this.menuCtrl.toggle('right');
 *  }
 * ```
 *
 *
 * ### Multiple Menus on the Same Side
 *
 * An application can have multiple menus on the same side. In order to determine
 * the menu to control, an `id` should be passed. In the example below, the menu
 * with the `authenticated` id will be enabled, and the menu with the `unauthenticated`
 * id will be disabled.
 *
 * ```html
 * <ion-menu id="authenticated" side="left" [content]="mycontent">...</ion-menu>
 * <ion-menu id="unauthenticated" side="left" [content]="mycontent">...</ion-menu>
 * <ion-nav #mycontent [root]="rootPage"></ion-nav>
 * ```
 *
 * ```ts
 *  enableAuthenticatedMenu() {
 *    this.menuCtrl.enable(true, 'authenticated');
 *    this.menuCtrl.enable(false, 'unauthenticated');
 *  }
 * ```
 *
 * Note: if an app only has one menu, there is no reason to pass an `id`.
 *
 *
 * @demo /docs/demos/src/menu/
 *
 * @see {@link /docs/components#menus Menu Component Docs}
 * @see {@link /docs/api/components/menu/Menu/ Menu API Docs}
 *
 */
var MenuController = (function () {
    function MenuController() {
        this._menus = [];
    }
    /**
     * Programatically open the Menu.
     * @param {string} [menuId]  Optionally get the menu by its id, or side.
     * @return {Promise} returns a promise when the menu is fully opened
     */
    MenuController.prototype.open = function (menuId) {
        var menu = this.get(menuId);
        if (menu && !this.isAnimating()) {
            var openedMenu = this.getOpen();
            if (openedMenu && menu !== openedMenu) {
                openedMenu.setOpen(false, false);
            }
            return menu.open();
        }
        return Promise.resolve(false);
    };
    /**
     * Programatically close the Menu. If no `menuId` is given as the first
     * argument then it'll close any menu which is open. If a `menuId`
     * is given then it'll close that exact menu.
     * @param {string} [menuId]  Optionally get the menu by its id, or side.
     * @return {Promise} returns a promise when the menu is fully closed
     */
    MenuController.prototype.close = function (menuId) {
        var menu;
        if (menuId) {
            // find the menu by its id
            menu = this.get(menuId);
        }
        else {
            // find the menu that is open
            menu = this.getOpen();
        }
        if (menu) {
            // close the menu
            return menu.close();
        }
        return Promise.resolve(false);
    };
    /**
     * Toggle the menu. If it's closed, it will open, and if opened, it
     * will close.
     * @param {string} [menuId]  Optionally get the menu by its id, or side.
     * @return {Promise} returns a promise when the menu has been toggled
     */
    MenuController.prototype.toggle = function (menuId) {
        var menu = this.get(menuId);
        if (menu && !this.isAnimating()) {
            var openedMenu = this.getOpen();
            if (openedMenu && menu !== openedMenu) {
                openedMenu.setOpen(false, false);
            }
            return menu.toggle();
        }
        return Promise.resolve(false);
    };
    /**
     * Used to enable or disable a menu. For example, there could be multiple
     * left menus, but only one of them should be able to be opened at the same
     * time. If there are multiple menus on the same side, then enabling one menu
     * will also automatically disable all the others that are on the same side.
     * @param {string} [menuId]  Optionally get the menu by its id, or side.
     * @return {Menu}  Returns the instance of the menu, which is useful for chaining.
     */
    MenuController.prototype.enable = function (shouldEnable, menuId) {
        var menu = this.get(menuId);
        if (menu) {
            return menu.enable(shouldEnable);
        }
    };
    /**
     * Used to enable or disable the ability to swipe open the menu.
     * @param {boolean} shouldEnable  True if it should be swipe-able, false if not.
     * @param {string} [menuId]  Optionally get the menu by its id, or side.
     * @return {Menu}  Returns the instance of the menu, which is useful for chaining.
     */
    MenuController.prototype.swipeEnable = function (shouldEnable, menuId) {
        var menu = this.get(menuId);
        if (menu) {
            return menu.swipeEnable(shouldEnable);
        }
    };
    /**
     * @param {string} [menuId] Optionally get the menu by its id, or side.
     * @return {boolean} Returns true if the specified menu is currently open, otherwise false.
     * If the menuId is not specified, it returns true if ANY menu is currenly open.
     */
    MenuController.prototype.isOpen = function (menuId) {
        if (menuId) {
            var menu = this.get(menuId);
            return menu && menu.isOpen || false;
        }
        else {
            return !!this.getOpen();
        }
    };
    /**
     * @param {string} [menuId]  Optionally get the menu by its id, or side.
     * @return {boolean} Returns true if the menu is currently enabled, otherwise false.
     */
    MenuController.prototype.isEnabled = function (menuId) {
        var menu = this.get(menuId);
        return menu && menu.enabled || false;
    };
    /**
     * Used to get a menu instance. If a `menuId` is not provided then it'll
     * return the first menu found. If a `menuId` is `left` or `right`, then
     * it'll return the enabled menu on that side. Otherwise, if a `menuId` is
     * provided, then it'll try to find the menu using the menu's `id`
     * property. If a menu is not found then it'll return `null`.
     * @param {string} [menuId]  Optionally get the menu by its id, or side.
     * @return {Menu} Returns the instance of the menu if found, otherwise `null`.
     */
    MenuController.prototype.get = function (menuId) {
        var menu;
        if (menuId === 'left' || menuId === 'right') {
            // there could be more than one menu on the same side
            // so first try to get the enabled one
            menu = this._menus.find(function (m) { return m.side === menuId && m.enabled; });
            if (menu) {
                return menu;
            }
            // didn't find a menu side that is enabled
            // so try to get the first menu side found
            return this._menus.find(function (m) { return m.side === menuId; }) || null;
        }
        else if (menuId) {
            // the menuId was not left or right
            // so try to get the menu by its "id"
            return this._menus.find(function (m) { return m.id === menuId; }) || null;
        }
        // return the first enabled menu
        menu = this._menus.find(function (m) { return m.enabled; });
        if (menu) {
            return menu;
        }
        // get the first menu in the array, if one exists
        return (this._menus.length ? this._menus[0] : null);
    };
    /**
     * @return {Menu} Returns the instance of the menu already opened, otherwise `null`.
     */
    MenuController.prototype.getOpen = function () {
        return this._menus.find(function (m) { return m.isOpen; });
    };
    /**
     * @return {Array<Menu>}  Returns an array of all menu instances.
     */
    MenuController.prototype.getMenus = function () {
        return this._menus;
    };
    /**
     * @hidden
     * @return {boolean} if any menu is currently animating
     */
    MenuController.prototype.isAnimating = function () {
        return this._menus.some(function (menu) { return menu.isAnimating(); });
    };
    /**
     * @hidden
     */
    MenuController.prototype._register = function (menu) {
        (void 0) /* assert */;
        this._menus.push(menu);
    };
    /**
     * @hidden
     */
    MenuController.prototype._unregister = function (menu) {
        (void 0) /* assert */;
        Object(__WEBPACK_IMPORTED_MODULE_0__util_util__["r" /* removeArrayItem */])(this._menus, menu);
    };
    /**
     * @hidden
     */
    MenuController.prototype._setActiveMenu = function (menu) {
        (void 0) /* assert */;
        (void 0) /* assert */;
        // if this menu should be enabled
        // then find all the other menus on this same side
        // and automatically disable other same side menus
        var side = menu.side;
        this._menus
            .filter(function (m) { return m.side === side && m !== menu; })
            .map(function (m) { return m.enable(false); });
    };
    /**
     * @hidden
     */
    MenuController.registerType = function (name, cls) {
        menuTypes[name] = cls;
    };
    /**
     * @hidden
     */
    MenuController.create = function (type, menuCmp, plt) {
        return new menuTypes[type](menuCmp, plt);
    };
    return MenuController;
}());

var menuTypes = {};
//# sourceMappingURL=menu-controller.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/app/overlay-portal.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OverlayPortal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__("./node_modules/ionic-angular/components/app/app.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__navigation_deep_linker__ = __webpack_require__("./node_modules/ionic-angular/navigation/deep-linker.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__platform_dom_controller__ = __webpack_require__("./node_modules/ionic-angular/platform/dom-controller.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__gestures_gesture_controller__ = __webpack_require__("./node_modules/ionic-angular/gestures/gesture-controller.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__navigation_nav_controller_base__ = __webpack_require__("./node_modules/ionic-angular/navigation/nav-controller-base.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__platform_platform__ = __webpack_require__("./node_modules/ionic-angular/platform/platform.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__transitions_transition_controller__ = __webpack_require__("./node_modules/ionic-angular/transitions/transition-controller.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();









/**
 * @hidden
 */
var OverlayPortal = (function (_super) {
    __extends(OverlayPortal, _super);
    function OverlayPortal(app, config, plt, elementRef, zone, renderer, cfr, gestureCtrl, transCtrl, linker, viewPort, domCtrl, errHandler) {
        var _this = _super.call(this, null, app, config, plt, elementRef, zone, renderer, cfr, gestureCtrl, transCtrl, linker, domCtrl, errHandler) || this;
        _this._isPortal = true;
        _this._init = true;
        _this.setViewport(viewPort);
        // on every page change make sure the portal has
        // dismissed any views that should be auto dismissed on page change
        app.viewDidLeave.subscribe(function (view) {
            if (!view.isOverlay) {
                _this.dismissPageChangeViews();
            }
        });
        return _this;
    }
    Object.defineProperty(OverlayPortal.prototype, "_overlayPortal", {
        set: function (val) {
            this._zIndexOffset = (val || 0);
        },
        enumerable: true,
        configurable: true
    });
    OverlayPortal.prototype.ngOnDestroy = function () {
        this.destroy();
    };
    /*
     * @private
     */
    OverlayPortal.prototype.getType = function () {
        return 'portal';
    };
    /*
     * @private
     */
    OverlayPortal.prototype.getSecondaryIdentifier = function () {
        return null;
    };
    OverlayPortal.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: '[overlay-portal]',
                },] },
    ];
    /** @nocollapse */
    OverlayPortal.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__app__["a" /* App */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return __WEBPACK_IMPORTED_MODULE_1__app__["a" /* App */]; }),] },] },
        { type: __WEBPACK_IMPORTED_MODULE_2__config_config__["a" /* Config */], },
        { type: __WEBPACK_IMPORTED_MODULE_7__platform_platform__["a" /* Platform */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ComponentFactoryResolver"], },
        { type: __WEBPACK_IMPORTED_MODULE_5__gestures_gesture_controller__["m" /* GestureController */], },
        { type: __WEBPACK_IMPORTED_MODULE_8__transitions_transition_controller__["a" /* TransitionController */], },
        { type: __WEBPACK_IMPORTED_MODULE_3__navigation_deep_linker__["a" /* DeepLinker */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_4__platform_dom_controller__["a" /* DomController */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ErrorHandler"], },
    ]; };
    OverlayPortal.propDecorators = {
        '_overlayPortal': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['overlay-portal',] },],
    };
    return OverlayPortal;
}(__WEBPACK_IMPORTED_MODULE_6__navigation_nav_controller_base__["a" /* NavControllerBase */]));

//# sourceMappingURL=overlay-portal.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/avatar/avatar.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Avatar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");

/**
  * @name Avatar
  * @module ionic
  * @description
  * An Avatar is a component that creates a circular image for an item.
  * Avatars can be placed on the left or right side of an item with the `item-start` or `item-end` directive.
  * @see {@link /docs/components/#avatar-list Avatar Component Docs}
 */
var Avatar = (function () {
    function Avatar() {
    }
    Avatar.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'ion-avatar'
                },] },
    ];
    /** @nocollapse */
    Avatar.ctorParameters = function () { return []; };
    return Avatar;
}());

//# sourceMappingURL=avatar.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/backdrop/backdrop.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Backdrop; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");

/**
 * @hidden
 */
var Backdrop = (function () {
    function Backdrop(_elementRef, _renderer) {
        this._elementRef = _elementRef;
        this._renderer = _renderer;
    }
    Backdrop.prototype.getNativeElement = function () {
        return this._elementRef.nativeElement;
    };
    Backdrop.prototype.setElementClass = function (className, add) {
        this._renderer.setElementClass(this._elementRef.nativeElement, className, add);
    };
    Backdrop.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'ion-backdrop',
                    host: {
                        'role': 'presentation',
                        'tappable': '',
                        'disable-activated': ''
                    },
                },] },
    ];
    /** @nocollapse */
    Backdrop.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    ]; };
    return Backdrop;
}());

//# sourceMappingURL=backdrop.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/badge/badge.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Badge; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ion__ = __webpack_require__("./node_modules/ionic-angular/components/ion.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



/**
  * @name Badge
  * @module ionic
  * @description
  * Badges are simple components in Ionic containing numbers or text. You can display a badge to indicate that there is new information associated with the item it is on.
  * @see {@link /docs/components/#badges Badges Component Docs}
 */
var Badge = (function (_super) {
    __extends(Badge, _super);
    function Badge(config, elementRef, renderer) {
        return _super.call(this, config, elementRef, renderer, 'badge') || this;
    }
    Badge.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'ion-badge'
                },] },
    ];
    /** @nocollapse */
    Badge.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__config_config__["a" /* Config */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    ]; };
    return Badge;
}(__WEBPACK_IMPORTED_MODULE_2__ion__["a" /* Ion */]));

//# sourceMappingURL=badge.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/button/button.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Button; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ion__ = __webpack_require__("./node_modules/ionic-angular/components/ion.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




/**
  * @name Button
  * @module ionic
  * @description
  * Buttons are simple components in Ionic. They can consist of text and icons
  * and be enhanced by a wide range of attributes.
  *
  * @usage
  *
  * ```html
  *
  *  <!-- Colors -->
  *  <button ion-button>Default</button>
  *
  *  <button ion-button color="secondary">Secondary</button>
  *
  *  <button ion-button color="danger">Danger</button>
  *
  *  <button ion-button color="light">Light</button>
  *
  *  <button ion-button color="dark">Dark</button>
  *
  *  <!-- Shapes -->
  *  <button ion-button full>Full Button</button>
  *
  *  <button ion-button block>Block Button</button>
  *
  *  <button ion-button round>Round Button</button>
  *
  *  <!-- Outline -->
  *  <button ion-button full outline>Outline + Full</button>
  *
  *  <button ion-button block outline>Outline + Block</button>
  *
  *  <button ion-button round outline>Outline + Round</button>
  *
  *  <!-- Icons -->
  *  <button ion-button icon-start>
  *    <ion-icon name="star"></ion-icon>
  *    Left Icon
  *  </button>
  *
  *  <button ion-button icon-end>
  *    Right Icon
  *    <ion-icon name="star"></ion-icon>
  *  </button>
  *
  *  <button ion-button icon-only>
  *    <ion-icon name="star"></ion-icon>
  *  </button>
  *
  *  <!-- Sizes -->
  *  <button ion-button large>Large</button>
  *
  *  <button ion-button>Default</button>
  *
  *  <button ion-button small>Small</button>
  * ```
  *
  * @advanced
  *
  * ```html
  *
  * <!-- Bind the color and outline inputs to an expression -->
  * <button ion-button [color]="isDanger ? 'danger' : 'primary'" [outline]="isOutline">
  *   Danger (Solid)
  * </button>
  *
  * <!-- Bind the color and round inputs to an expression -->
  * <button ion-button [color]="myColor" [round]="isRound">
  *   Secondary (Round)
  * </button>
  *
  * <!-- Bind the color and clear inputs to an expression -->
  * <button ion-button [color]="isSecondary ? 'secondary' : 'primary'"  [clear]="isClear">
  *   Primary (Clear)
  * </button>
  *
  * <!-- Bind the color, outline and round inputs to an expression -->
  * <button ion-button [color]="myColor2" [outline]="isOutline" [round]="isRound">
  *   Dark (Solid + Round)
  * </button>
  *
  * <!-- Bind the click event to a method -->
  * <button ion-button (click)="logEvent($event)">
  *   Click me!
  * </button>
  * ```
  *
  * ```ts
  * @Component({
  *   templateUrl: 'main.html'
  * })
  * class E2EPage {
  *   isDanger: boolean = true;
  *   isSecondary: boolean = false;
  *   isRound: boolean = true;
  *   isOutline: boolean = false;
  *   isClear: boolean = true;
  *   myColor: string = 'secondary';
  *   myColor2: string = 'dark';
  *
  *   logEvent(event) {
  *     console.log(event)
  *   }
  * }
  *
  * ```
  *
  * @demo /docs/demos/src/button/
  * @see {@link /docs/components#buttons Button Component Docs}
  * @see {@link /docs/components#fabs FabButton Docs}
  * @see {@link ../../fab/FabButton FabButton API Docs}
  * @see {@link ../../fab/FabContainer FabContainer API Docs}
 */
var Button = (function (_super) {
    __extends(Button, _super);
    function Button(ionButton, config, elementRef, renderer) {
        var _this = _super.call(this, config, elementRef, renderer) || this;
        /** @hidden */
        _this._role = 'button'; // bar-button
        /** @hidden */
        _this._style = 'default'; // outline/clear/solid
        _this._mode = config.get('mode');
        if (config.get('hoverCSS') === false) {
            _this.setElementClass('disable-hover', true);
        }
        if (ionButton.trim().length > 0) {
            _this.setRole(ionButton);
        }
        return _this;
    }
    Object.defineProperty(Button.prototype, "large", {
        /**
         * @input {boolean} If true, activates the large button size.
         */
        set: function (val) {
            this._attr('_size', 'large', val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "small", {
        /**
         * @input {boolean} If true, activates the small button size.
         */
        set: function (val) {
            this._attr('_size', 'small', val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "default", {
        /**
         * @input {boolean} If true, activates the default button size. Normally the default, useful for buttons in an item.
         */
        set: function (val) {
            this._attr('_size', 'default', val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "outline", {
        /**
         * @input {boolean} If true, activates a transparent button style with a border.
         */
        set: function (val) {
            this._attr('_style', 'outline', val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "clear", {
        /**
         * @input {boolean} If true, activates a transparent button style without a border.
         */
        set: function (val) {
            this._attr('_style', 'clear', val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "solid", {
        /**
         * @input {boolean} If true, activates a solid button style. Normally the default, useful for buttons in a toolbar.
         */
        set: function (val) {
            this._attr('_style', 'solid', val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "round", {
        /**
         * @input {boolean} If true, activates a button with rounded corners.
         */
        set: function (val) {
            this._attr('_shape', 'round', val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "block", {
        /**
         * @input {boolean} If true, activates a button style that fills the available width.
         */
        set: function (val) {
            this._attr('_display', 'block', val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "full", {
        /**
         * @input {boolean} If true, activates a button style that fills the available width without
         * a left and right border.
         */
        set: function (val) {
            this._attr('_display', 'full', val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "strong", {
        /**
         * @input {boolean} If true, activates a button with a heavier font weight.
         */
        set: function (val) {
            this._attr('_decorator', 'strong', val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "mode", {
        /**
         * @input {string} The mode determines which platform styles to use.
         * Possible values are: `"ios"`, `"md"`, or `"wp"`.
         * For more information, see [Platform Styles](/docs/theming/platform-specific-styles).
         */
        set: function (val) {
            this._assignCss(false);
            this._mode = val;
            this._assignCss(true);
        },
        enumerable: true,
        configurable: true
    });
    /** @hidden */
    Button.prototype._attr = function (type, attrName, attrValue) {
        if (type === '_style') {
            this._updateColor(this._color, false);
        }
        this._setClass(this[type], false);
        if (Object(__WEBPACK_IMPORTED_MODULE_3__util_util__["o" /* isTrueProperty */])(attrValue)) {
            this[type] = attrName;
            this._setClass(attrName, true);
        }
        else {
            // Special handling for '_style' which defaults to 'default'.
            this[type] = (type === '_style' ? 'default' : null);
            this._setClass(this[type], true);
        }
        if (type === '_style') {
            this._updateColor(this._color, true);
        }
    };
    Object.defineProperty(Button.prototype, "color", {
        /**
         * @input {string} The color to use from your Sass `$colors` map.
         * Default options are: `"primary"`, `"secondary"`, `"danger"`, `"light"`, and `"dark"`.
         * For more information, see [Theming your App](/docs/theming/theming-your-app).
         */
        set: function (val) {
            this._updateColor(this._color, false);
            this._updateColor(val, true);
            this._color = val;
        },
        enumerable: true,
        configurable: true
    });
    /** @hidden */
    Button.prototype.ngAfterContentInit = function () {
        this._init = true;
        this._assignCss(true);
    };
    /**
     * @hidden
     */
    Button.prototype.setRole = function (val) {
        this._assignCss(false);
        this._role = val;
        this._assignCss(true);
    };
    /**
     * @hidden
     */
    Button.prototype._assignCss = function (assignCssClass) {
        var role = this._role;
        if (role) {
            this.setElementClass(role, assignCssClass); // button
            this.setElementClass(role + "-" + this._mode, assignCssClass); // button
            this._setClass(this._style, assignCssClass); // button-clear
            this._setClass(this._shape, assignCssClass); // button-round
            this._setClass(this._display, assignCssClass); // button-full
            this._setClass(this._size, assignCssClass); // button-small
            this._setClass(this._decorator, assignCssClass); // button-strong
            this._updateColor(this._color, assignCssClass); // button-secondary, bar-button-secondary
        }
    };
    /**
     * @hidden
     */
    Button.prototype._setClass = function (type, assignCssClass) {
        if (type && this._init) {
            type = type.toLocaleLowerCase();
            this.setElementClass(this._role + "-" + type, assignCssClass);
            this.setElementClass(this._role + "-" + type + "-" + this._mode, assignCssClass);
        }
    };
    /**
     * @hidden
     */
    Button.prototype._updateColor = function (color, isAdd) {
        if (color && this._init) {
            // The class should begin with the button role
            // button, bar-button
            var className = this._role;
            // If the role is not a bar-button, don't apply the solid style
            var style = this._style;
            style = (this._role !== 'bar-button' && style === 'solid' ? 'default' : style);
            className += (style !== null && style !== '' && style !== 'default' ? '-' + style.toLowerCase() : '');
            if (color !== null && color !== '') {
                this.setElementClass(className + "-" + this._mode + "-" + color, isAdd);
            }
        }
    };
    Button.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: '[ion-button]',
                    template: '<span class="button-inner">' +
                        '<ng-content></ng-content>' +
                        '</span>' +
                        '<div class="button-effect"></div>',
                    changeDetection: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectionStrategy"].OnPush,
                    encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None,
                },] },
    ];
    /** @nocollapse */
    Button.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Attribute"], args: ['ion-button',] },] },
        { type: __WEBPACK_IMPORTED_MODULE_1__config_config__["a" /* Config */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    ]; };
    Button.propDecorators = {
        'large': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'small': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'default': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'outline': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'clear': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'solid': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'round': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'block': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'full': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'strong': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'mode': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'color': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return Button;
}(__WEBPACK_IMPORTED_MODULE_2__ion__["a" /* Ion */]));

//# sourceMappingURL=button.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/card/card-content.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CardContent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ion__ = __webpack_require__("./node_modules/ionic-angular/components/ion.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



/**
 * @hidden
 */
var CardContent = (function (_super) {
    __extends(CardContent, _super);
    function CardContent(config, elementRef, renderer) {
        return _super.call(this, config, elementRef, renderer, 'card-content') || this;
    }
    CardContent.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'ion-card-content'
                },] },
    ];
    /** @nocollapse */
    CardContent.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__config_config__["a" /* Config */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    ]; };
    return CardContent;
}(__WEBPACK_IMPORTED_MODULE_2__ion__["a" /* Ion */]));

//# sourceMappingURL=card-content.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/card/card-header.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CardHeader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ion__ = __webpack_require__("./node_modules/ionic-angular/components/ion.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



/**
 * @hidden
 */
var CardHeader = (function (_super) {
    __extends(CardHeader, _super);
    function CardHeader(config, elementRef, renderer) {
        return _super.call(this, config, elementRef, renderer, 'card-header') || this;
    }
    CardHeader.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'ion-card-header'
                },] },
    ];
    /** @nocollapse */
    CardHeader.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__config_config__["a" /* Config */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    ]; };
    return CardHeader;
}(__WEBPACK_IMPORTED_MODULE_2__ion__["a" /* Ion */]));

//# sourceMappingURL=card-header.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/card/card-title.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CardTitle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ion__ = __webpack_require__("./node_modules/ionic-angular/components/ion.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



/**
 * @hidden
 */
var CardTitle = (function (_super) {
    __extends(CardTitle, _super);
    function CardTitle(config, elementRef, renderer) {
        return _super.call(this, config, elementRef, renderer, 'card-title') || this;
    }
    CardTitle.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'ion-card-title'
                },] },
    ];
    /** @nocollapse */
    CardTitle.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__config_config__["a" /* Config */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    ]; };
    return CardTitle;
}(__WEBPACK_IMPORTED_MODULE_2__ion__["a" /* Ion */]));

//# sourceMappingURL=card-title.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/card/card.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Card; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ion__ = __webpack_require__("./node_modules/ionic-angular/components/ion.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



/**
  * @hidden
  */
var Card = (function (_super) {
    __extends(Card, _super);
    function Card(config, elementRef, renderer) {
        return _super.call(this, config, elementRef, renderer, 'card') || this;
    }
    Card.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'ion-card'
                },] },
    ];
    /** @nocollapse */
    Card.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__config_config__["a" /* Config */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    ]; };
    return Card;
}(__WEBPACK_IMPORTED_MODULE_2__ion__["a" /* Ion */]));

//# sourceMappingURL=card.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/checkbox/checkbox.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Checkbox; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__("./node_modules/@angular/forms/esm5/forms.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_form__ = __webpack_require__("./node_modules/ionic-angular/util/form.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_base_input__ = __webpack_require__("./node_modules/ionic-angular/util/base-input.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__item_item__ = __webpack_require__("./node_modules/ionic-angular/components/item/item.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();







/**
 * @name Checkbox
 * @module ionic
 *
 * @description
 * The Checkbox is a simple component styled based on the mode. It can be
 * placed in an `ion-item` or used as a stand-alone checkbox.
 *
 * See the [Angular Docs](https://angular.io/docs/ts/latest/guide/forms.html)
 * for more info on forms and inputs.
 *
 *
 * @usage
 * ```html
 *
 *  <ion-list>
 *
 *    <ion-item>
 *      <ion-label>Pepperoni</ion-label>
 *      <ion-checkbox [(ngModel)]="pepperoni"></ion-checkbox>
 *    </ion-item>
 *
 *    <ion-item>
 *      <ion-label>Sausage</ion-label>
 *      <ion-checkbox [(ngModel)]="sausage" disabled="true"></ion-checkbox>
 *    </ion-item>
 *
 *    <ion-item>
 *      <ion-label>Mushrooms</ion-label>
 *      <ion-checkbox [(ngModel)]="mushrooms"></ion-checkbox>
 *    </ion-item>
 *
 *  </ion-list>
 * ```
 *
 * @advanced
 *
 * ```html
 *
 * <!-- Call function when state changes -->
 *  <ion-list>
 *
 *    <ion-item>
 *      <ion-label>Cucumber</ion-label>
 *      <ion-checkbox [(ngModel)]="cucumber" (ionChange)="updateCucumber()"></ion-checkbox>
 *    </ion-item>
 *
 *  </ion-list>
 * ```
 *
 * ```ts
 * @Component({
 *   templateUrl: 'main.html'
 * })
 * class SaladPage {
 *   cucumber: boolean;
 *
 *   updateCucumber() {
 *     console.log('Cucumbers new state:' + this.cucumber);
 *   }
 * }
 * ```
 *
 * @demo /docs/demos/src/checkbox/
 * @see {@link /docs/components#checkbox Checkbox Component Docs}
 */
var Checkbox = (function (_super) {
    __extends(Checkbox, _super);
    function Checkbox(config, form, item, elementRef, renderer) {
        return _super.call(this, config, elementRef, renderer, 'checkbox', false, form, item, null) || this;
    }
    Object.defineProperty(Checkbox.prototype, "checked", {
        /**
         * @input {boolean} If true, the element is selected.
         */
        get: function () {
            return this.value;
        },
        set: function (val) {
            this.value = val;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @hidden
     */
    Checkbox.prototype._click = function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        this.value = !this.value;
        this._fireTouched();
    };
    /**
     * @hidden
     */
    Checkbox.prototype._inputNormalize = function (val) {
        return Object(__WEBPACK_IMPORTED_MODULE_3__util_util__["o" /* isTrueProperty */])(val);
    };
    /**
     * @hidden
     */
    Checkbox.prototype._inputUpdated = function () {
        this._item && this._item.setElementClass('item-checkbox-checked', this._value);
    };
    Checkbox.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'ion-checkbox',
                    template: '<div class="checkbox-icon" [class.checkbox-checked]="_value">' +
                        '<div class="checkbox-inner"></div>' +
                        '</div>' +
                        '<button role="checkbox" ' +
                        'type="button" ' +
                        'ion-button="item-cover" ' +
                        '[id]="id" ' +
                        '[attr.aria-checked]="_value" ' +
                        '[attr.aria-labelledby]="_labelId" ' +
                        '[attr.aria-disabled]="_disabled" ' +
                        'class="item-cover"> ' +
                        '</button>',
                    host: {
                        '[class.checkbox-disabled]': '_disabled'
                    },
                    providers: [{ provide: __WEBPACK_IMPORTED_MODULE_1__angular_forms__["NG_VALUE_ACCESSOR"], useExisting: Checkbox, multi: true }],
                    encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None,
                },] },
    ];
    /** @nocollapse */
    Checkbox.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_2__config_config__["a" /* Config */], },
        { type: __WEBPACK_IMPORTED_MODULE_4__util_form__["a" /* Form */], },
        { type: __WEBPACK_IMPORTED_MODULE_6__item_item__["a" /* Item */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    ]; };
    Checkbox.propDecorators = {
        'checked': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        '_click': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"], args: ['click', ['$event'],] },],
    };
    return Checkbox;
}(__WEBPACK_IMPORTED_MODULE_5__util_base_input__["a" /* BaseInput */]));

//# sourceMappingURL=checkbox.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/chip/chip.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Chip; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ion__ = __webpack_require__("./node_modules/ionic-angular/components/ion.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



/**
  * @name Chip
  * @module ionic
  * @description
  * Chips represent complex entities in small blocks, such as a contact.
  *
  *
  * @usage
  *
  * ```html
  * <ion-chip>
  *   <ion-label>Default</ion-label>
  * </ion-chip>
  *
  * <ion-chip>
  *   <ion-label color="secondary">Secondary Label</ion-label>
  * </ion-chip>
  *
  * <ion-chip color="secondary">
  *   <ion-label color="dark">Secondary w/ Dark label</ion-label>
  * </ion-chip>
  *
  * <ion-chip color="danger">
  *   <ion-label>Danger</ion-label>
  * </ion-chip>
  *
  * <ion-chip>
  *   <ion-icon name="pin"></ion-icon>
  *   <ion-label>Default</ion-label>
  * </ion-chip>
  *
  * <ion-chip>
  *   <ion-icon name="heart" color="dark"></ion-icon>
  *   <ion-label>Default</ion-label>
  * </ion-chip>
  *
  * <ion-chip>
  *   <ion-avatar>
  *     <img src="assets/img/my-img.png">
  *   </ion-avatar>
  *   <ion-label>Default</ion-label>
  * </ion-chip>
  * ```
  *
  *
  * @advanced
  *
  * ```html
  * <ion-chip #chip1>
  *   <ion-label>Default</ion-label>
  *   <button ion-button clear color="light" (click)="delete(chip1)">
  *     <ion-icon name="close-circle"></ion-icon>
  *   </button>
  * </ion-chip>
  *
  * <ion-chip #chip2>
  *   <ion-icon name="pin" color="primary"></ion-icon>
  *   <ion-label>With Icon</ion-label>
  *   <button ion-button (click)="delete(chip2)">
  *     <ion-icon name="close"></ion-icon>
  *   </button>
  * </ion-chip>
  *
  * <ion-chip #chip3>
  *   <ion-avatar>
  *     <img src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAAAAACH5BAAAAAAALAAAAAABAAEAAAICTAEAOw==">
  *   </ion-avatar>
  *   <ion-label>With Avatar</ion-label>
  *   <button ion-button clear color="dark" (click)="delete(chip3)">
  *     <ion-icon name="close-circle"></ion-icon>
  *   </button>
  * </ion-chip>
  * ```
  *
  * ```ts
  * @Component({
  *   templateUrl: 'main.html'
  * })
  * class E2EPage {
  *   delete(chip: Element) {
  *     chip.remove();
  *   }
  * }
  * ```
  *
  * @demo /docs/demos/src/chip/
 **/
var Chip = (function (_super) {
    __extends(Chip, _super);
    function Chip(config, elementRef, renderer) {
        return _super.call(this, config, elementRef, renderer, 'chip') || this;
    }
    Chip.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'ion-chip'
                },] },
    ];
    /** @nocollapse */
    Chip.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__config_config__["a" /* Config */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    ]; };
    return Chip;
}(__WEBPACK_IMPORTED_MODULE_2__ion__["a" /* Ion */]));

//# sourceMappingURL=chip.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/content/content.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export EventEmitterProxy */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Content; });
/* unused harmony export updateImgs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_app__ = __webpack_require__("./node_modules/ionic-angular/components/app/app.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__platform_dom_controller__ = __webpack_require__("./node_modules/ionic-angular/platform/dom-controller.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ion__ = __webpack_require__("./node_modules/ionic-angular/components/ion.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__navigation_nav_util__ = __webpack_require__("./node_modules/ionic-angular/navigation/nav-util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__platform_keyboard__ = __webpack_require__("./node_modules/ionic-angular/platform/keyboard.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__navigation_nav_controller__ = __webpack_require__("./node_modules/ionic-angular/navigation/nav-controller.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__platform_platform__ = __webpack_require__("./node_modules/ionic-angular/platform/platform.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_scroll_view__ = __webpack_require__("./node_modules/ionic-angular/util/scroll-view.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__navigation_view_controller__ = __webpack_require__("./node_modules/ionic-angular/navigation/view-controller.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();












var EventEmitterProxy = (function (_super) {
    __extends(EventEmitterProxy, _super);
    function EventEmitterProxy() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EventEmitterProxy.prototype.subscribe = function (generatorOrNext, error, complete) {
        this.onSubscribe();
        return _super.prototype.subscribe.call(this, generatorOrNext, error, complete);
    };
    return EventEmitterProxy;
}(__WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]));

/**
 * @name Content
 * @description
 * The Content component provides an easy to use content area with
 * some useful methods to control the scrollable area. There should
 * only be one content in a single view component. If additional scrollable
 * elements are needed, use [ionScroll](../../scroll/Scroll).
 *
 *
 * The content area can also implement pull-to-refresh with the
 * [Refresher](../../refresher/Refresher) component.
 *
 * @usage
 * ```html
 * <ion-content>
 *   Add your content here!
 * </ion-content>
 * ```
 *
 * To get a reference to the content component from a Page's logic,
 * you can use Angular's `@ViewChild` annotation:
 *
 * ```ts
 * import { Component, ViewChild } from '@angular/core';
 * import { Content } from 'ionic-angular';
 *
 * @Component({...})
 * export class MyPage{
 *   @ViewChild(Content) content: Content;
 *
 *   scrollToTop() {
 *     this.content.scrollToTop();
 *   }
 * }
 * ```
 *
 * @advanced
 *
 * ### Scroll Events
 *
 * Scroll events happen outside of Angular's Zones. This is for performance reasons. So
 * if you're trying to bind a value to any scroll event, it will need to be wrapped in
 * a `zone.run()`
 *
 * ```ts
 * import { Component, NgZone } from '@angular/core';
 * @Component({
 *   template: `
 *     <ion-header>
 *       <ion-navbar>
 *         <ion-title>{{scrollAmount}}</ion-title>
 *       </ion-navbar>
 *     </ion-header>
 *     <ion-content (ionScroll)="scrollHandler($event)">
 *        <p> Some realllllllly long content </p>
 *     </ion-content>
 * `})
 * class E2EPage {
 *  public scrollAmount = 0;
 *  constructor( public zone: NgZone){}
 *  scrollHandler(event) {
 *    console.log(`ScrollEvent: ${event}`)
 *    this.zone.run(()=>{
 *      // since scrollAmount is data-binded,
 *      // the update needs to happen in zone
 *      this.scrollAmount++
 *    })
 *  }
 * }
 * ```
 *
 * This goes for any scroll event, not just `ionScroll`.
 *
 * ### Resizing the content
 *
 * If the height of `ion-header`, `ion-footer` or `ion-tabbar`
 * changes dynamically, `content.resize()` has to be called in order to update the
 * layout of `Content`.
 *
 *
 * ```ts
 * @Component({
 *   template: `
 *     <ion-header>
 *       <ion-navbar>
 *         <ion-title>Main Navbar</ion-title>
 *       </ion-navbar>
 *       <ion-toolbar *ngIf="showToolbar">
 *         <ion-title>Dynamic Toolbar</ion-title>
 *       </ion-toolbar>
 *     </ion-header>
 *     <ion-content>
 *       <button ion-button (click)="toggleToolbar()">Toggle Toolbar</button>
 *     </ion-content>
 * `})
 *
 * class E2EPage {
 *   @ViewChild(Content) content: Content;
 *   showToolbar: boolean = false;
 *
 *   toggleToolbar() {
 *     this.showToolbar = !this.showToolbar;
 *     this.content.resize();
 *   }
 * }
 * ```
 *
 *
 * Scroll to a specific position
 *
 * ```ts
 * import { Component, ViewChild } from '@angular/core';
 * import { Content } from 'ionic-angular';
 *
 * @Component({
 *   template: `<ion-content>
 *                <button ion-button (click)="scrollTo()">Down 500px</button>
 *              </ion-content>`
 * )}
 * export class MyPage{
 *   @ViewChild(Content) content: Content;
 *
 *   scrollTo() {
 *     // set the scrollLeft to 0px, and scrollTop to 500px
 *     // the scroll duration should take 200ms
 *     this.content.scrollTo(0, 500, 200);
 *   }
 * }
 * ```
 *
 */
var Content = (function (_super) {
    __extends(Content, _super);
    function Content(config, _plt, _dom, elementRef, renderer, _app, _keyboard, _zone, viewCtrl, navCtrl) {
        var _this = _super.call(this, config, elementRef, renderer, 'content') || this;
        _this._plt = _plt;
        _this._dom = _dom;
        _this._app = _app;
        _this._keyboard = _keyboard;
        _this._zone = _zone;
        /** @internal */
        _this._scrollPadding = 0;
        /** @internal */
        _this._inputPolling = false;
        /** @internal */
        _this._hasRefresher = false;
        /** @internal */
        _this._imgs = [];
        /** @internal */
        _this._scrollDownOnLoad = false;
        /**
         * @output {ScrollEvent} Emitted when the scrolling first starts.
         */
        _this.ionScrollStart = new EventEmitterProxy();
        /**
         * @output {ScrollEvent} Emitted on every scroll event.
         */
        _this.ionScroll = new EventEmitterProxy();
        /**
         * @output {ScrollEvent} Emitted when scrolling ends.
         */
        _this.ionScrollEnd = new EventEmitterProxy();
        var enableScrollListener = function () { return _this._scroll.enableEvents(); };
        _this.ionScroll.onSubscribe = enableScrollListener;
        _this.ionScrollStart.onSubscribe = enableScrollListener;
        _this.ionScrollEnd.onSubscribe = enableScrollListener;
        _this.statusbarPadding = config.getBoolean('statusbarPadding', false);
        _this._imgReqBfr = config.getNumber('imgRequestBuffer', 1400);
        _this._imgRndBfr = config.getNumber('imgRenderBuffer', 400);
        _this._imgVelMax = config.getNumber('imgVelocityMax', 3);
        _this._scroll = new __WEBPACK_IMPORTED_MODULE_10__util_scroll_view__["a" /* ScrollView */](_app, _plt, _dom);
        while (navCtrl) {
            if (Object(__WEBPACK_IMPORTED_MODULE_5__navigation_nav_util__["o" /* isTabs */])(navCtrl)) {
                _this._tabs = navCtrl;
                break;
            }
            navCtrl = navCtrl.parent;
        }
        if (viewCtrl) {
            _this._viewCtrl = viewCtrl;
            // content has a view controller
            viewCtrl._setIONContent(_this);
            viewCtrl._setIONContentRef(elementRef);
            _this._viewCtrlReadSub = viewCtrl.readReady.subscribe(function () {
                _this._viewCtrlReadSub.unsubscribe();
                _this._readDimensions();
            });
            _this._viewCtrlWriteSub = viewCtrl.writeReady.subscribe(function () {
                _this._viewCtrlWriteSub.unsubscribe();
                _this._writeDimensions();
            });
        }
        else {
            // content does not have a view controller
            _dom.read(_this._readDimensions.bind(_this));
            _dom.write(_this._writeDimensions.bind(_this));
        }
        return _this;
    }
    Object.defineProperty(Content.prototype, "contentHeight", {
        /**
         * Content height of the viewable area. This does not include content
         * which is outside the overflow area, or content area which is under
         * headers and footers. Read-only.
         *
         * @return {number}
         */
        get: function () {
            return this._scroll.ev.contentHeight;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Content.prototype, "contentWidth", {
        /**
         * Content width including content which is not visible on the screen
         * due to overflow. Read-only.
         *
         * @return {number}
         */
        get: function () {
            return this._scroll.ev.contentWidth;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Content.prototype, "scrollHeight", {
        /**
         * Content height including content which is not visible on the screen
         * due to overflow. Read-only.
         *
         * @return {number}
         */
        get: function () {
            return this._scroll.ev.scrollHeight;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Content.prototype, "scrollWidth", {
        /**
         * Content width including content which is not visible due to
         * overflow. Read-only.
         *
         * @return {number}
         */
        get: function () {
            return this._scroll.ev.scrollWidth;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Content.prototype, "scrollTop", {
        /**
         * The distance of the content's top to its topmost visible content.
         *
         * @return {number}
         */
        get: function () {
            return this._scroll.ev.scrollTop;
        },
        /**
         * @param {number} top
         */
        set: function (top) {
            this._scroll.setTop(top);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Content.prototype, "scrollLeft", {
        /**
         * The distance of the content's left to its leftmost visible content.
         *
         * @return {number}
         */
        get: function () {
            return this._scroll.ev.scrollLeft;
        },
        /**
         * @param {number} top
         */
        set: function (top) {
            this._scroll.setLeft(top);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Content.prototype, "isScrolling", {
        /**
         * If the content is actively scrolling or not.
         *
         * @return {boolean}
         */
        get: function () {
            return this._scroll.isScrolling;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Content.prototype, "directionY", {
        /**
         * The current, or last known, vertical scroll direction. Possible
         * string values include `down` and `up`.
         *
         * @return {string}
         */
        get: function () {
            return this._scroll.ev.directionY;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Content.prototype, "directionX", {
        /**
         * The current, or last known, horizontal scroll direction. Possible
         * string values include `right` and `left`.
         *
         * @return {string}
         */
        get: function () {
            return this._scroll.ev.directionX;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @hidden
     */
    Content.prototype.ngAfterViewInit = function () {
        var _this = this;
        (void 0) /* assert */;
        (void 0) /* assert */;
        var scroll = this._scroll;
        scroll.ev.fixedElement = this.getFixedElement();
        scroll.ev.scrollElement = this.getScrollElement();
        // subscribe to the scroll start
        scroll.onScrollStart = function (ev) {
            _this.ionScrollStart.emit(ev);
        };
        // subscribe to every scroll move
        scroll.onScroll = function (ev) {
            // emit to all of our other friends things be scrolling
            _this.ionScroll.emit(ev);
            _this.imgsUpdate();
        };
        // subscribe to the scroll end
        scroll.onScrollEnd = function (ev) {
            _this.ionScrollEnd.emit(ev);
            _this.imgsUpdate();
        };
    };
    /**
     * @hidden
     */
    Content.prototype.enableJsScroll = function () {
        this._scroll.enableJsScroll(this._cTop, this._cBottom);
    };
    /**
     * @hidden
     */
    Content.prototype.ngOnDestroy = function () {
        this._scLsn && this._scLsn();
        this._viewCtrlReadSub && this._viewCtrlReadSub.unsubscribe();
        this._viewCtrlWriteSub && this._viewCtrlWriteSub.unsubscribe();
        this._viewCtrlReadSub = this._viewCtrlWriteSub = null;
        this._scroll && this._scroll.destroy();
        this._footerEle = this._scLsn = this._scroll = null;
    };
    /**
     * @hidden
     */
    Content.prototype.getScrollElement = function () {
        return this._scrollContent.nativeElement;
    };
    /**
     * @private
     */
    Content.prototype.getFixedElement = function () {
        return this._fixedContent.nativeElement;
    };
    /**
     * @hidden
     */
    Content.prototype.onScrollElementTransitionEnd = function (callback) {
        this._plt.transitionEnd(this.getScrollElement(), callback);
    };
    /**
     * Scroll to the specified position.
     *
     * @param {number} x  The x-value to scroll to.
     * @param {number} y  The y-value to scroll to.
     * @param {number} [duration]  Duration of the scroll animation in milliseconds. Defaults to `300`.
     * @returns {Promise} Returns a promise which is resolved when the scroll has completed.
     */
    Content.prototype.scrollTo = function (x, y, duration, done) {
        if (duration === void 0) { duration = 300; }
        (void 0) /* console.debug */;
        return this._scroll.scrollTo(x, y, duration, done);
    };
    /**
     * Scroll to the top of the content component.
     *
     * @param {number} [duration]  Duration of the scroll animation in milliseconds. Defaults to `300`.
     * @returns {Promise} Returns a promise which is resolved when the scroll has completed.
     */
    Content.prototype.scrollToTop = function (duration) {
        if (duration === void 0) { duration = 300; }
        (void 0) /* console.debug */;
        return this._scroll.scrollToTop(duration);
    };
    /**
     * Scroll to the bottom of the content component.
     *
     * @param {number} [duration]  Duration of the scroll animation in milliseconds. Defaults to `300`.
     * @returns {Promise} Returns a promise which is resolved when the scroll has completed.
     */
    Content.prototype.scrollToBottom = function (duration) {
        if (duration === void 0) { duration = 300; }
        (void 0) /* console.debug */;
        return this._scroll.scrollToBottom(duration);
    };
    Object.defineProperty(Content.prototype, "fullscreen", {
        /**
         * @input {boolean} If true, the content will scroll behind the headers
         * and footers. This effect can easily be seen by setting the toolbar
         * to transparent.
         */
        get: function () {
            return this._fullscreen;
        },
        set: function (val) {
            this._fullscreen = Object(__WEBPACK_IMPORTED_MODULE_6__util_util__["o" /* isTrueProperty */])(val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Content.prototype, "scrollDownOnLoad", {
        /**
         * @input {boolean} If true, the content will scroll down on load.
         */
        get: function () {
            return this._scrollDownOnLoad;
        },
        set: function (val) {
            this._scrollDownOnLoad = Object(__WEBPACK_IMPORTED_MODULE_6__util_util__["o" /* isTrueProperty */])(val);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @private
     */
    Content.prototype.addImg = function (img) {
        this._imgs.push(img);
    };
    /**
     * @hidden
     */
    Content.prototype.removeImg = function (img) {
        Object(__WEBPACK_IMPORTED_MODULE_6__util_util__["r" /* removeArrayItem */])(this._imgs, img);
    };
    /**
     * @hidden
     * DOM WRITE
     */
    Content.prototype.setScrollElementStyle = function (prop, val) {
        var scrollEle = this.getScrollElement();
        if (scrollEle) {
            this._dom.write(function () {
                scrollEle.style[prop] = val;
            });
        }
    };
    /**
     * Returns the content and scroll elements' dimensions.
     * @returns {object} dimensions  The content and scroll elements' dimensions
     * {number} dimensions.contentHeight  content offsetHeight
     * {number} dimensions.contentTop  content offsetTop
     * {number} dimensions.contentBottom  content offsetTop+offsetHeight
     * {number} dimensions.contentWidth  content offsetWidth
     * {number} dimensions.contentLeft  content offsetLeft
     * {number} dimensions.contentRight  content offsetLeft + offsetWidth
     * {number} dimensions.scrollHeight  scroll scrollHeight
     * {number} dimensions.scrollTop  scroll scrollTop
     * {number} dimensions.scrollBottom  scroll scrollTop + scrollHeight
     * {number} dimensions.scrollWidth  scroll scrollWidth
     * {number} dimensions.scrollLeft  scroll scrollLeft
     * {number} dimensions.scrollRight  scroll scrollLeft + scrollWidth
     */
    Content.prototype.getContentDimensions = function () {
        var scrollEle = this.getScrollElement();
        var parentElement = scrollEle.parentElement;
        return {
            contentHeight: parentElement.offsetHeight - this._cTop - this._cBottom,
            contentTop: this._cTop,
            contentBottom: this._cBottom,
            contentWidth: parentElement.offsetWidth,
            contentLeft: parentElement.offsetLeft,
            scrollHeight: scrollEle.scrollHeight,
            scrollTop: scrollEle.scrollTop,
            scrollWidth: scrollEle.scrollWidth,
            scrollLeft: scrollEle.scrollLeft,
        };
    };
    /**
     * @hidden
     * DOM WRITE
     * Adds padding to the bottom of the scroll element when the keyboard is open
     * so content below the keyboard can be scrolled into view.
     */
    Content.prototype.addScrollPadding = function (newPadding) {
        (void 0) /* assert */;
        if (newPadding === 0) {
            this._inputPolling = false;
            this._scrollPadding = -1;
        }
        if (newPadding > this._scrollPadding) {
            (void 0) /* console.debug */;
            this._scrollPadding = newPadding;
            var scrollEle = this.getScrollElement();
            if (scrollEle) {
                this._dom.write(function () {
                    scrollEle.style.paddingBottom = (newPadding > 0) ? newPadding + 'px' : '';
                });
            }
        }
    };
    /**
     * @hidden
     * DOM WRITE
     */
    Content.prototype.clearScrollPaddingFocusOut = function () {
        var _this = this;
        if (!this._inputPolling) {
            (void 0) /* console.debug */;
            this._inputPolling = true;
            this._keyboard.onClose(function () {
                (void 0) /* console.debug */;
                _this.addScrollPadding(0);
            }, 200, 3000);
        }
    };
    /**
     * Tell the content to recalculate its dimensions. This should be called
     * after dynamically adding/removing headers, footers, or tabs.
     */
    Content.prototype.resize = function () {
        this._dom.read(this._readDimensions.bind(this));
        this._dom.write(this._writeDimensions.bind(this));
    };
    /**
     * @hidden
     * DOM READ
     */
    Content.prototype._readDimensions = function () {
        var cachePaddingTop = this._pTop;
        var cachePaddingRight = this._pRight;
        var cachePaddingBottom = this._pBottom;
        var cachePaddingLeft = this._pLeft;
        var cacheHeaderHeight = this._hdrHeight;
        var cacheFooterHeight = this._ftrHeight;
        var cacheTabsPlacement = this._tabsPlacement;
        var tabsTop = 0;
        var scrollEvent;
        this._pTop = 0;
        this._pRight = 0;
        this._pBottom = 0;
        this._pLeft = 0;
        this._hdrHeight = 0;
        this._ftrHeight = 0;
        this._tabsPlacement = null;
        this._tTop = 0;
        this._fTop = 0;
        this._fBottom = 0;
        // In certain cases this._scroll is undefined
        // if that is the case then we should just return
        if (!this._scroll) {
            return;
        }
        scrollEvent = this._scroll.ev;
        var ele = this.getNativeElement();
        if (!ele) {
            (void 0) /* assert */;
            return;
        }
        var computedStyle;
        var tagName;
        var parentEle = ele.parentElement;
        var children = parentEle.children;
        for (var i = children.length - 1; i >= 0; i--) {
            ele = children[i];
            tagName = ele.tagName;
            if (tagName === 'ION-CONTENT') {
                scrollEvent.contentElement = ele;
                if (this._fullscreen) {
                    // ******** DOM READ ****************
                    computedStyle = getComputedStyle(ele);
                    this._pTop = parsePxUnit(computedStyle.paddingTop);
                    this._pBottom = parsePxUnit(computedStyle.paddingBottom);
                    this._pRight = parsePxUnit(computedStyle.paddingRight);
                    this._pLeft = parsePxUnit(computedStyle.paddingLeft);
                }
            }
            else if (tagName === 'ION-HEADER') {
                scrollEvent.headerElement = ele;
                // ******** DOM READ ****************
                this._hdrHeight = ele.clientHeight;
            }
            else if (tagName === 'ION-FOOTER') {
                scrollEvent.footerElement = ele;
                // ******** DOM READ ****************
                this._ftrHeight = ele.clientHeight;
                this._footerEle = ele;
            }
        }
        ele = parentEle;
        var tabbarEle;
        while (ele && ele.tagName !== 'ION-MODAL' && !ele.classList.contains('tab-subpage')) {
            if (ele.tagName === 'ION-TABS') {
                tabbarEle = ele.firstElementChild;
                // ******** DOM READ ****************
                this._tabbarHeight = tabbarEle.clientHeight;
                if (this._tabsPlacement === null) {
                    // this is the first tabbar found, remember it's position
                    this._tabsPlacement = ele.getAttribute('tabsplacement');
                }
            }
            ele = ele.parentElement;
        }
        // Tabs top
        if (this._tabs && this._tabsPlacement === 'top') {
            this._tTop = this._hdrHeight;
            tabsTop = this._tabs._top;
        }
        // Toolbar height
        this._cTop = this._hdrHeight;
        this._cBottom = this._ftrHeight;
        // Tabs height
        if (this._tabsPlacement === 'top') {
            this._cTop += this._tabbarHeight;
        }
        else if (this._tabsPlacement === 'bottom') {
            this._cBottom += this._tabbarHeight;
        }
        // Refresher uses a border which should be hidden unless pulled
        if (this._hasRefresher) {
            this._cTop -= 1;
        }
        // Fixed content shouldn't include content padding
        this._fTop = this._cTop;
        this._fBottom = this._cBottom;
        // Handle fullscreen viewport (padding vs margin)
        if (this._fullscreen) {
            this._cTop += this._pTop;
            this._cBottom += this._pBottom;
        }
        // ******** DOM READ ****************
        var contentDimensions = this.getContentDimensions();
        scrollEvent.scrollHeight = contentDimensions.scrollHeight;
        scrollEvent.scrollWidth = contentDimensions.scrollWidth;
        scrollEvent.contentHeight = contentDimensions.contentHeight;
        scrollEvent.contentWidth = contentDimensions.contentWidth;
        scrollEvent.contentTop = contentDimensions.contentTop;
        scrollEvent.contentBottom = contentDimensions.contentBottom;
        this._dirty = (cachePaddingTop !== this._pTop ||
            cachePaddingBottom !== this._pBottom ||
            cachePaddingLeft !== this._pLeft ||
            cachePaddingRight !== this._pRight ||
            cacheHeaderHeight !== this._hdrHeight ||
            cacheFooterHeight !== this._ftrHeight ||
            cacheTabsPlacement !== this._tabsPlacement ||
            tabsTop !== this._tTop ||
            this._cTop !== this.contentTop ||
            this._cBottom !== this.contentBottom);
        this._scroll.init(this.getScrollElement(), this._cTop, this._cBottom);
        // initial imgs refresh
        this.imgsUpdate();
    };
    /**
     * @hidden
     * DOM WRITE
     */
    Content.prototype._writeDimensions = function () {
        if (!this._dirty) {
            (void 0) /* console.debug */;
            return;
        }
        var scrollEle = this.getScrollElement();
        if (!scrollEle) {
            (void 0) /* assert */;
            return;
        }
        var fixedEle = this.getFixedElement();
        if (!fixedEle) {
            (void 0) /* assert */;
            return;
        }
        // Tabs height
        if (this._tabsPlacement === 'bottom' && this._cBottom > 0 && this._footerEle) {
            var footerPos = this._cBottom - this._ftrHeight;
            (void 0) /* assert */;
            // ******** DOM WRITE ****************
            this._footerEle.style.bottom = cssFormat(footerPos);
        }
        // Handle fullscreen viewport (padding vs margin)
        var topProperty = 'marginTop';
        var bottomProperty = 'marginBottom';
        var fixedTop = this._fTop;
        var fixedBottom = this._fBottom;
        if (this._fullscreen) {
            (void 0) /* assert */;
            (void 0) /* assert */;
            // adjust the content with padding, allowing content to scroll under headers/footers
            // however, on iOS you cannot control the margins of the scrollbar (last tested iOS9.2)
            // only add inline padding styles if the computed padding value, which would
            // have come from the app's css, is different than the new padding value
            topProperty = 'paddingTop';
            bottomProperty = 'paddingBottom';
        }
        // Only update top margin if value changed
        if (this._cTop !== this.contentTop) {
            (void 0) /* assert */;
            (void 0) /* assert */;
            // ******** DOM WRITE ****************
            scrollEle.style[topProperty] = cssFormat(this._cTop);
            // ******** DOM WRITE ****************
            fixedEle.style.marginTop = cssFormat(fixedTop);
            this.contentTop = this._cTop;
        }
        // Only update bottom margin if value changed
        if (this._cBottom !== this.contentBottom) {
            (void 0) /* assert */;
            (void 0) /* assert */;
            // ******** DOM WRITE ****************
            scrollEle.style[bottomProperty] = cssFormat(this._cBottom);
            // ******** DOM WRITE ****************
            fixedEle.style.marginBottom = cssFormat(fixedBottom);
            this.contentBottom = this._cBottom;
        }
        if (this._tabsPlacement !== null && this._tabs) {
            // set the position of the tabbar
            if (this._tabsPlacement === 'top') {
                // ******** DOM WRITE ****************
                this._tabs.setTabbarPosition(this._tTop, -1);
            }
            else {
                (void 0) /* assert */;
                // ******** DOM WRITE ****************
                this._tabs.setTabbarPosition(-1, 0);
            }
        }
        // Scroll the page all the way down after setting dimensions
        if (this._scrollDownOnLoad) {
            this.scrollToBottom(0);
            this._scrollDownOnLoad = false;
        }
    };
    /**
     * @hidden
     */
    Content.prototype.imgsUpdate = function () {
        if (this._scroll.initialized && this._imgs.length && this.isImgsUpdatable()) {
            updateImgs(this._imgs, this.scrollTop, this.contentHeight, this.directionY, this._imgReqBfr, this._imgRndBfr);
        }
    };
    /**
     * @hidden
     */
    Content.prototype.isImgsUpdatable = function () {
        // an image is only "updatable" if the content isn't scrolling too fast
        // if scroll speed is above the maximum velocity, then let current
        // requests finish, but do not start new requets or render anything
        // if scroll speed is below the maximum velocity, then it's ok
        // to start new requests and render images
        return Math.abs(this._scroll.ev.velocityY) < this._imgVelMax;
    };
    Content.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'ion-content',
                    template: '<div class="fixed-content" #fixedContent>' +
                        '<ng-content select="[ion-fixed],ion-fab"></ng-content>' +
                        '</div>' +
                        '<div class="scroll-content" #scrollContent>' +
                        '<ng-content></ng-content>' +
                        '</div>' +
                        '<ng-content select="ion-refresher"></ng-content>',
                    host: {
                        '[class.statusbar-padding]': 'statusbarPadding',
                        '[class.has-refresher]': '_hasRefresher'
                    },
                    changeDetection: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectionStrategy"].OnPush,
                    encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None
                },] },
    ];
    /** @nocollapse */
    Content.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_2__config_config__["a" /* Config */], },
        { type: __WEBPACK_IMPORTED_MODULE_9__platform_platform__["a" /* Platform */], },
        { type: __WEBPACK_IMPORTED_MODULE_3__platform_dom_controller__["a" /* DomController */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: __WEBPACK_IMPORTED_MODULE_1__app_app__["a" /* App */], },
        { type: __WEBPACK_IMPORTED_MODULE_7__platform_keyboard__["a" /* Keyboard */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"], },
        { type: __WEBPACK_IMPORTED_MODULE_11__navigation_view_controller__["a" /* ViewController */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
        { type: __WEBPACK_IMPORTED_MODULE_8__navigation_nav_controller__["a" /* NavController */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
    ]; };
    Content.propDecorators = {
        '_fixedContent': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"], args: ['fixedContent', { read: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"] },] },],
        '_scrollContent': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"], args: ['scrollContent', { read: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"] },] },],
        'ionScrollStart': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        'ionScroll': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        'ionScrollEnd': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        'fullscreen': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'scrollDownOnLoad': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return Content;
}(__WEBPACK_IMPORTED_MODULE_4__ion__["a" /* Ion */]));

function updateImgs(imgs, viewableTop, contentHeight, scrollDirectionY, requestableBuffer, renderableBuffer) {
    // ok, so it's time to see which images, if any, should be requested and rendered
    // ultimately, if we're scrolling fast then don't bother requesting or rendering
    // when scrolling is done, then it needs to do a check to see which images are
    // important to request and render, and which image requests should be aborted.
    // Additionally, images which are not near the viewable area should not be
    // rendered at all in order to save browser resources.
    var viewableBottom = (viewableTop + contentHeight);
    var priority1 = [];
    var priority2 = [];
    var img;
    // all images should be paused
    for (var i = 0, ilen = imgs.length; i < ilen; i++) {
        img = imgs[i];
        if (scrollDirectionY === 'up') {
            // scrolling up
            if (img.top < viewableBottom && img.bottom > viewableTop - renderableBuffer) {
                // scrolling up, img is within viewable area
                // or about to be viewable area
                img.canRequest = img.canRender = true;
                priority1.push(img);
                continue;
            }
            if (img.bottom <= viewableTop && img.bottom > viewableTop - requestableBuffer) {
                // scrolling up, img is within requestable area
                img.canRequest = true;
                img.canRender = false;
                priority2.push(img);
                continue;
            }
            if (img.top >= viewableBottom && img.top < viewableBottom + renderableBuffer) {
                // scrolling up, img below viewable area
                // but it's still within renderable area
                // don't allow a reset
                img.canRequest = img.canRender = false;
                continue;
            }
        }
        else {
            // scrolling down
            if (img.bottom > viewableTop && img.top < viewableBottom + renderableBuffer) {
                // scrolling down, img is within viewable area
                // or about to be viewable area
                img.canRequest = img.canRender = true;
                priority1.push(img);
                continue;
            }
            if (img.top >= viewableBottom && img.top < viewableBottom + requestableBuffer) {
                // scrolling down, img is within requestable area
                img.canRequest = true;
                img.canRender = false;
                priority2.push(img);
                continue;
            }
            if (img.bottom <= viewableTop && img.bottom > viewableTop - renderableBuffer) {
                // scrolling down, img above viewable area
                // but it's still within renderable area
                // don't allow a reset
                img.canRequest = img.canRender = false;
                continue;
            }
        }
        img.canRequest = img.canRender = false;
        img.reset();
    }
    // update all imgs which are viewable
    priority1.sort(sortTopToBottom).forEach(function (i) { return i.update(); });
    if (scrollDirectionY === 'up') {
        // scrolling up
        priority2.sort(sortTopToBottom).reverse().forEach(function (i) { return i.update(); });
    }
    else {
        // scrolling down
        priority2.sort(sortTopToBottom).forEach(function (i) { return i.update(); });
    }
}
function sortTopToBottom(a, b) {
    if (a.top < b.top) {
        return -1;
    }
    if (a.top > b.top) {
        return 1;
    }
    return 0;
}
function parsePxUnit(val) {
    return (val.indexOf('px') > 0) ? parseInt(val, 10) : 0;
}
function cssFormat(val) {
    return (val > 0 ? val + 'px' : '');
}
//# sourceMappingURL=content.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/datetime/datetime.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DateTime; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__("./node_modules/@angular/forms/esm5/forms.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__picker_picker_controller__ = __webpack_require__("./node_modules/ionic-angular/components/picker/picker-controller.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_form__ = __webpack_require__("./node_modules/ionic-angular/util/form.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_base_input__ = __webpack_require__("./node_modules/ionic-angular/util/base-input.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__item_item__ = __webpack_require__("./node_modules/ionic-angular/components/item/item.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_datetime_util__ = __webpack_require__("./node_modules/ionic-angular/util/datetime-util.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};









/**
 * @name DateTime
 * @description
 * The DateTime component is used to present an interface which makes it easy for
 * users to select dates and times. Tapping on `<ion-datetime>` will display a picker
 * interface that slides up from the bottom of the page. The picker then displays
 * scrollable columns that can be used to individually select years, months, days,
 * hours and minute values. The DateTime component is similar to the native
 * `<input type="datetime-local">` element, however, Ionic's DateTime component makes
 * it easy to display the date and time in a preferred format, and manage the datetime
 * values.
 *
 * ```html
 * <ion-item>
 *   <ion-label>Date</ion-label>
 *   <ion-datetime displayFormat="MM/DD/YYYY" [(ngModel)]="myDate"></ion-datetime>
 * </ion-item>
 * ```
 *
 *
 * ## Display and Picker Formats
 *
 * The DateTime component displays the values in two places: in the `<ion-datetime>`
 * component, and in the interface that is presented from the bottom of the screen.
 * The following chart lists all of the formats that can be used.
 *
 * | Format  | Description                    | Example                 |
 * |---------|--------------------------------|-------------------------|
 * | `YYYY`  | Year, 4 digits                 | `2018`                  |
 * | `YY`    | Year, 2 digits                 | `18`                    |
 * | `M`     | Month                          | `1` ... `12`            |
 * | `MM`    | Month, leading zero            | `01` ... `12`           |
 * | `MMM`   | Month, short name              | `Jan`                   |
 * | `MMMM`  | Month, full name               | `January`               |
 * | `D`     | Day                            | `1` ... `31`            |
 * | `DD`    | Day, leading zero              | `01` ... `31`           |
 * | `DDD`   | Day, short name                | `Fri`                   |
 * | `DDDD`  | Day, full name                 | `Friday`                |
 * | `H`     | Hour, 24-hour                  | `0` ... `23`            |
 * | `HH`    | Hour, 24-hour, leading zero    | `00` ... `23`           |
 * | `h`     | Hour, 12-hour                  | `1` ... `12`            |
 * | `hh`    | Hour, 12-hour, leading zero    | `01` ... `12`           |
 * | `a`     | 12-hour time period, lowercase | `am` `pm`               |
 * | `A`     | 12-hour time period, uppercase | `AM` `PM`               |
 * | `m`     | Minute                         | `1` ... `59`            |
 * | `mm`    | Minute, leading zero           | `01` ... `59`           |
 * | `s`     | Second                         | `1` ... `59`            |
 * | `ss`    | Second, leading zero           | `01` ... `59`           |
 * | `Z`     | UTC Timezone Offset            | `Z or +HH:mm or -HH:mm` |
 *
 * **Important**: See the [Month Names and Day of the Week Names](#month-names-and-day-of-the-week-names)
 * section below on how to use different names for the month and day.
 *
 * ### Display Format
 *
 * The `displayFormat` input property specifies how a datetime's value should be
 * printed, as formatted text, within the `ion-datetime` component.
 *
 * In the following example, the display in the `<ion-datetime>` will use the
 * month's short name, the numerical day with a leading zero, a comma and the
 * four-digit year. In addition to the date, it will display the time with the hours
 * in the 24-hour format and the minutes. Any character can be used as a separator.
 * An example display using this format is: `Jun 17, 2005 11:06`.
 *
 * ```html
 * <ion-item>
 *   <ion-label>Date</ion-label>
 *   <ion-datetime displayFormat="MMM DD, YYYY HH:mm" [(ngModel)]="myDate"></ion-datetime>
 * </ion-item>
 * ```
 *
 * ### Picker Format
 *
 * The `pickerFormat` input property determines which columns should be shown in the
 * interface, the order of the columns, and which format to use within each column.
 * If the `pickerFormat` input is not provided then it will default to the `displayFormat`.
 *
 * In the following example, the display in the `<ion-datetime>` will use the
 * `MM/YYYY` format, such as `06/2020`. However, the picker interface
 * will display two columns with the month's long name, and the four-digit year.
 *
 * ```html
 * <ion-item>
 *   <ion-label>Date</ion-label>
 *   <ion-datetime displayFormat="MM/YYYY" pickerFormat="MMMM YYYY" [(ngModel)]="myDate"></ion-datetime>
 * </ion-item>
 * ```
 *
 * ### Datetime Data
 *
 * Historically, handling datetime values within JavaScript, or even within HTML
 * inputs, has always been a challenge. Specifically, JavaScript's `Date` object is
 * notoriously difficult to correctly parse apart datetime strings or to format
 * datetime values. Even worse is how different browsers and JavaScript versions
 * parse various datetime strings differently, especially per locale.
 *
 * But no worries, all is not lost! Ionic's datetime input has been designed so
 * developers can avoid the common pitfalls, allowing developers to easily format
 * datetime values within the input, and give the user a simple datetime picker for a
 * great user experience.
 *
 * ##### ISO 8601 Datetime Format: YYYY-MM-DDTHH:mmZ
 *
 * Ionic uses the [ISO 8601 datetime format](https://www.w3.org/TR/NOTE-datetime)
 * for its value. The value is simply a string, rather than using JavaScript's `Date`
 * object. Additionally, when using the ISO datetime format, it makes it easier
 * to serialize and pass within JSON objects, and sending databases a standardized
 * format which it can be easily parsed if need be.
 *
 * To create an ISO datetime string for the current date and time, e.g. use `const currentDate = (new Date()).toISOString();`.
 *
 * An ISO format can be used as a simple year, or just the hour and minute, or get more
 * detailed down to the millisecond and timezone. Any of the ISO formats below can be used,
 * and after a user selects a new value, Ionic will continue to use the same ISO format
 * which datetime value was originally given as.
 *
 * | Description          | Format                 | Datetime Value Example       |
 * |----------------------|------------------------|------------------------------|
 * | Year                 | YYYY                   | 1994                         |
 * | Year and Month       | YYYY-MM                | 1994-12                      |
 * | Complete Date        | YYYY-MM-DD             | 1994-12-15                   |
 * | Date and Time        | YYYY-MM-DDTHH:mm       | 1994-12-15T13:47             |
 * | UTC Timezone         | YYYY-MM-DDTHH:mm:ssTZD | 1994-12-15T13:47:20.789Z     |
 * | Timezone Offset      | YYYY-MM-DDTHH:mm:ssTZD | 1994-12-15T13:47:20.789+5:00 |
 * | Hour and Minute      | HH:mm                  | 13:47                        |
 * | Hour, Minute, Second | HH:mm:ss               | 13:47:20                     |
 *
 * Note that the year is always four-digits, milliseconds (if it's added) is always
 * three-digits, and all others are always two-digits. So the number representing
 * January always has a leading zero, such as `01`. Additionally, the hour is always
 * in the 24-hour format, so `00` is `12am` on a 12-hour clock, `13` means `1pm`,
 * and `23` means `11pm`.
 *
 * It's also important to note that neither the `displayFormat` or `pickerFormat` can
 * set the datetime value's output, which is the value that is set by the component's
 * `ngModel`. The format's are merely for displaying the value as text and the picker's
 * interface, but the datetime's value is always persisted as a valid ISO 8601 datetime
 * string.
 *
 *
 * ## Min and Max Datetimes
 *
 * Dates are infinite in either direction, so for a user's selection there should be at
 * least some form of restricting the dates that can be selected. By default, the maximum
 * date is to the end of the current year, and the minimum date is from the beginning
 * of the year that was 100 years ago.
 *
 * To customize the minimum and maximum datetime values, the `min` and `max` component
 * inputs can be provided which may make more sense for the app's use-case, rather
 * than the default of the last 100 years. Following the same IS0 8601 format listed
 * in the table above, each component can restrict which dates can be selected by the
 * user. Below is an example of restricting the date selection between the beginning
 * of 2016, and October 31st of 2020:
 *
 * ```html
 * <ion-item>
 *   <ion-label>Date</ion-label>
 *   <ion-datetime displayFormat="MMMM YYYY" min="2016" max="2020-10-31" [(ngModel)]="myDate">
 *   </ion-datetime>
 * </ion-item>
 * ```
 *
 *
 * ## Month Names and Day of the Week Names
 *
 * At this time, there is no one-size-fits-all standard to automatically choose the correct
 * language/spelling for a month name, or day of the week name, depending on the language
 * or locale. Good news is that there is an
 * [Intl.DateTimeFormat](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat)
 * standard which *most* browsers have adopted. However, at this time the standard has not
 * been fully implemented by all popular browsers so Ionic is unavailable to take advantage
 * of it *yet*. Additionally, Angular also provides an internationalization service, but it
 * is still under heavy development so Ionic does not depend on it at this time.
 *
 * All things considered, the by far easiest solution is to just provide an array of names
 * if the app needs to use names other than the default English version of month and day
 * names. The month names and day names can be either configured at the app level, or
 * individual `ion-datetime` level.
 *
 * ### App Config Level
 *
 * ```ts
 * //app.module.ts
 * @NgModule({
 * ...,
 * imports: [
 *   IonicModule.forRoot(MyApp, {
 *   monthNames: ['janeiro', 'fevereiro', 'mar\u00e7o', ... ],
 *   monthShortNames: ['jan', 'fev', 'mar', ... ],
 *   dayNames: ['domingo', 'segunda-feira', 'ter\u00e7a-feira', ... ],
 *   dayShortNames: ['dom', 'seg', 'ter', ... ],
 * })
 * ],
 * ...
 * })
 * ```
 *
 * ### Component Input Level
 *
 * ```html
 * <ion-item>
 *   <ion-label>Período</ion-label>
 *   <ion-datetime displayFormat="DDDD MMM D, YYYY" [(ngModel)]="myDate"
 *     monthNames="janeiro, fevereiro, mar\u00e7o, ..."
 *     monthShortNames="jan, fev, mar, ..."
 *     dayNames="domingo, segunda-feira, ter\u00e7a-feira, ..."
 *     dayShortNames="dom, seg, ter, ..."></ion-datetime>
 * </ion-item>
 * ```
 *
 *
 * ### Advanced Datetime Validation and Manipulation
 *
 * The datetime picker provides the simplicity of selecting an exact format, and persists
 * the datetime values as a string using the standardized
 * [ISO 8601 datetime format](https://www.w3.org/TR/NOTE-datetime).
 * However, it's important to note that `ion-datetime` does not attempt to solve all
 * situtations when validating and manipulating datetime values. If datetime values need
 * to be parsed from a certain format, or manipulated (such as adding 5 days to a date,
 * subtracting 30 minutes, etc.), or even formatting data to a specific locale, then we highly
 * recommend using [moment.js](http://momentjs.com/) to "Parse, validate, manipulate, and
 * display dates in JavaScript". [Moment.js](http://momentjs.com/) has quickly become
 * our goto standard when dealing with datetimes within JavaScript, but Ionic does not
 * prepackage this dependency since most apps will not require it, and its locale
 * configuration should be decided by the end-developer.
 *
 *
 * @usage
 * ```html
 * <ion-item>
 *   <ion-label>Date</ion-label>
 *   <ion-datetime displayFormat="MM/DD/YYYY" [(ngModel)]="myDate">
 *   </ion-datetime>
 * </ion-item>
 * ```
 *
 *
 * @demo /docs/demos/src/datetime/
 */
var DateTime = (function (_super) {
    __extends(DateTime, _super);
    function DateTime(form, config, elementRef, renderer, item, _pickerCtrl) {
        var _this = _super.call(this, config, elementRef, renderer, 'datetime', {}, form, item, null) || this;
        _this._pickerCtrl = _pickerCtrl;
        _this._text = '';
        _this._locale = {};
        /**
         * @input {string} The text to display on the picker's cancel button. Default: `Cancel`.
         */
        _this.cancelText = 'Cancel';
        /**
         * @input {string} The text to display on the picker's "Done" button. Default: `Done`.
         */
        _this.doneText = 'Done';
        /**
         * @input {any} Any additional options that the picker interface can accept.
         * See the [Picker API docs](../../picker/Picker) for the picker options.
         */
        _this.pickerOptions = {};
        /**
         * @input {string} The text to display when there's no date selected yet.
         * Using lowercase to match the input attribute
         */
        _this.placeholder = '';
        /**
         * @output {any} Emitted when the datetime selection was cancelled.
         */
        _this.ionCancel = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        return _this;
    }
    /**
     * @hidden
     */
    DateTime.prototype.ngAfterContentInit = function () {
        var _this = this;
        // first see if locale names were provided in the inputs
        // then check to see if they're in the config
        // if neither were provided then it will use default English names
        ['monthNames', 'monthShortNames', 'dayNames', 'dayShortNames'].forEach(function (type) {
            _this._locale[type] = convertToArrayOfStrings(Object(__WEBPACK_IMPORTED_MODULE_7__util_util__["l" /* isPresent */])(_this[type]) ? _this[type] : _this._config.get(type), type);
        });
        this._initialize();
    };
    /**
     * @hidden
     */
    DateTime.prototype._inputNormalize = function (val) {
        Object(__WEBPACK_IMPORTED_MODULE_8__util_datetime_util__["m" /* updateDate */])(this._value, val);
        return this._value;
    };
    /**
     * @hidden
     */
    DateTime.prototype._inputUpdated = function () {
        _super.prototype._inputUpdated.call(this);
        this.updateText();
    };
    /**
     * @hidden
     */
    DateTime.prototype._inputShouldChange = function () {
        return true;
    };
    /**
     * TODO: REMOVE THIS
     * @hidden
     */
    DateTime.prototype._inputChangeEvent = function () {
        return this.value;
    };
    /**
     * @hidden
     */
    DateTime.prototype._inputNgModelEvent = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_8__util_datetime_util__["b" /* convertDataToISO */])(this.value);
    };
    DateTime.prototype._click = function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        this.open();
    };
    DateTime.prototype._keyup = function () {
        this.open();
    };
    /**
     * @hidden
     */
    DateTime.prototype.open = function () {
        var _this = this;
        if (this.isFocus() || this._disabled) {
            return;
        }
        (void 0) /* console.debug */;
        // the user may have assigned some options specifically for the picker
        var pickerOptions = __assign({}, this.pickerOptions);
        // Add a cancel and done button by default to the picker
        var defaultButtons = [{
                text: this.cancelText,
                role: 'cancel',
                handler: function () { return _this.ionCancel.emit(_this); }
            }, {
                text: this.doneText,
                handler: function (data) { return _this.value = data; },
            }];
        pickerOptions.buttons = (pickerOptions.buttons || []).concat(defaultButtons);
        // Configure picker under the hood
        var picker = this._picker = this._pickerCtrl.create(pickerOptions);
        picker.ionChange.subscribe(function () {
            _this.validate();
            picker.refresh();
        });
        // Update picker status before presenting
        this.generate();
        this.validate();
        // Present picker
        this._fireFocus();
        picker.present(pickerOptions);
        picker.onDidDismiss(function () {
            _this._fireBlur();
        });
    };
    /**
     * @hidden
     */
    DateTime.prototype.generate = function () {
        var _this = this;
        var picker = this._picker;
        // if a picker format wasn't provided, then fallback
        // to use the display format
        var template = this.pickerFormat || this.displayFormat || DEFAULT_FORMAT;
        if (Object(__WEBPACK_IMPORTED_MODULE_7__util_util__["l" /* isPresent */])(template)) {
            // make sure we've got up to date sizing information
            this.calcMinMax();
            // does not support selecting by day name
            // automaticallly remove any day name formats
            template = template.replace('DDDD', '{~}').replace('DDD', '{~}');
            if (template.indexOf('D') === -1) {
                // there is not a day in the template
                // replace the day name with a numeric one if it exists
                template = template.replace('{~}', 'D');
            }
            // make sure no day name replacer is left in the string
            template = template.replace(/{~}/g, '');
            // parse apart the given template into an array of "formats"
            Object(__WEBPACK_IMPORTED_MODULE_8__util_datetime_util__["j" /* parseTemplate */])(template).forEach(function (format) {
                // loop through each format in the template
                // create a new picker column to build up with data
                var key = Object(__WEBPACK_IMPORTED_MODULE_8__util_datetime_util__["c" /* convertFormatToKey */])(format);
                var values;
                // first see if they have exact values to use for this input
                if (Object(__WEBPACK_IMPORTED_MODULE_7__util_util__["l" /* isPresent */])(_this[key + 'Values'])) {
                    // user provide exact values for this date part
                    values = convertToArrayOfNumbers(_this[key + 'Values'], key);
                }
                else {
                    // use the default date part values
                    values = Object(__WEBPACK_IMPORTED_MODULE_8__util_datetime_util__["f" /* dateValueRange */])(format, _this._min, _this._max);
                }
                var column = {
                    name: key,
                    selectedIndex: 0,
                    options: values.map(function (val) {
                        return {
                            value: val,
                            text: Object(__WEBPACK_IMPORTED_MODULE_8__util_datetime_util__["l" /* renderTextFormat */])(format, val, null, _this._locale),
                        };
                    })
                };
                // cool, we've loaded up the columns with options
                // preselect the option for this column
                var optValue = Object(__WEBPACK_IMPORTED_MODULE_8__util_datetime_util__["h" /* getValueFromFormat */])(_this.getValueOrDefault(), format);
                var selectedIndex = column.options.findIndex(function (opt) { return opt.value === optValue; });
                if (selectedIndex >= 0) {
                    // set the select index for this column's options
                    column.selectedIndex = selectedIndex;
                }
                // add our newly created column to the picker
                picker.addColumn(column);
            });
            // Normalize min/max
            var min_1 = this._min;
            var max_1 = this._max;
            var columns_1 = this._picker.getColumns();
            ['month', 'day', 'hour', 'minute']
                .filter(function (name) { return !columns_1.find(function (column) { return column.name === name; }); })
                .forEach(function (name) {
                min_1[name] = 0;
                max_1[name] = 0;
            });
            this.divyColumns();
        }
    };
    /**
     * @hidden
     */
    DateTime.prototype.validateColumn = function (name, index, min, max, lowerBounds, upperBounds) {
        (void 0) /* assert */;
        (void 0) /* assert */;
        var column = this._picker.getColumn(name);
        if (!column) {
            return 0;
        }
        var lb = lowerBounds.slice();
        var ub = upperBounds.slice();
        var options = column.options;
        var indexMin = options.length - 1;
        var indexMax = 0;
        for (var i = 0; i < options.length; i++) {
            var opt = options[i];
            var value = opt.value;
            lb[index] = opt.value;
            ub[index] = opt.value;
            var disabled = opt.disabled = (value < lowerBounds[index] ||
                value > upperBounds[index] ||
                Object(__WEBPACK_IMPORTED_MODULE_8__util_datetime_util__["e" /* dateSortValue */])(ub[0], ub[1], ub[2], ub[3], ub[4]) < min ||
                Object(__WEBPACK_IMPORTED_MODULE_8__util_datetime_util__["e" /* dateSortValue */])(lb[0], lb[1], lb[2], lb[3], lb[4]) > max);
            if (!disabled) {
                indexMin = Math.min(indexMin, i);
                indexMax = Math.max(indexMax, i);
            }
        }
        var selectedIndex = column.selectedIndex = Object(__WEBPACK_IMPORTED_MODULE_7__util_util__["a" /* clamp */])(indexMin, column.selectedIndex, indexMax);
        opt = column.options[selectedIndex];
        if (opt) {
            return opt.value;
        }
        return 0;
    };
    /**
     * @private
     */
    DateTime.prototype.validate = function () {
        var today = new Date();
        var minCompareVal = Object(__WEBPACK_IMPORTED_MODULE_8__util_datetime_util__["d" /* dateDataSortValue */])(this._min);
        var maxCompareVal = Object(__WEBPACK_IMPORTED_MODULE_8__util_datetime_util__["d" /* dateDataSortValue */])(this._max);
        var yearCol = this._picker.getColumn('year');
        (void 0) /* assert */;
        var selectedYear = today.getFullYear();
        if (yearCol) {
            // default to the first value if the current year doesn't exist in the options
            if (!yearCol.options.find(function (col) { return col.value === today.getFullYear(); })) {
                selectedYear = yearCol.options[0].value;
            }
            var yearOpt = yearCol.options[yearCol.selectedIndex];
            if (yearOpt) {
                // they have a selected year value
                selectedYear = yearOpt.value;
            }
        }
        var selectedMonth = this.validateColumn('month', 1, minCompareVal, maxCompareVal, [selectedYear, 0, 0, 0, 0], [selectedYear, 12, 31, 23, 59]);
        var numDaysInMonth = Object(__WEBPACK_IMPORTED_MODULE_8__util_datetime_util__["g" /* daysInMonth */])(selectedMonth, selectedYear);
        var selectedDay = this.validateColumn('day', 2, minCompareVal, maxCompareVal, [selectedYear, selectedMonth, 0, 0, 0], [selectedYear, selectedMonth, numDaysInMonth, 23, 59]);
        var selectedHour = this.validateColumn('hour', 3, minCompareVal, maxCompareVal, [selectedYear, selectedMonth, selectedDay, 0, 0], [selectedYear, selectedMonth, selectedDay, 23, 59]);
        this.validateColumn('minute', 4, minCompareVal, maxCompareVal, [selectedYear, selectedMonth, selectedDay, selectedHour, 0], [selectedYear, selectedMonth, selectedDay, selectedHour, 59]);
    };
    /**
     * @hidden
     */
    DateTime.prototype.divyColumns = function () {
        var pickerColumns = this._picker.getColumns();
        var columnsWidth = [];
        var col;
        var width;
        for (var i = 0; i < pickerColumns.length; i++) {
            col = pickerColumns[i];
            columnsWidth.push(0);
            for (var j = 0; j < col.options.length; j++) {
                width = col.options[j].text.length;
                if (width > columnsWidth[i]) {
                    columnsWidth[i] = width;
                }
            }
        }
        if (columnsWidth.length === 2) {
            width = Math.max(columnsWidth[0], columnsWidth[1]);
            pickerColumns[0].align = 'right';
            pickerColumns[1].align = 'left';
            pickerColumns[0].optionsWidth = pickerColumns[1].optionsWidth = width * 17 + "px";
        }
        else if (columnsWidth.length === 3) {
            width = Math.max(columnsWidth[0], columnsWidth[2]);
            pickerColumns[0].align = 'right';
            pickerColumns[1].columnWidth = columnsWidth[1] * 17 + "px";
            pickerColumns[0].optionsWidth = pickerColumns[2].optionsWidth = width * 17 + "px";
            pickerColumns[2].align = 'left';
        }
    };
    /**
     * @hidden
     */
    DateTime.prototype.updateText = function () {
        // create the text of the formatted data
        var template = this.displayFormat || this.pickerFormat || DEFAULT_FORMAT;
        this._text = Object(__WEBPACK_IMPORTED_MODULE_8__util_datetime_util__["k" /* renderDateTime */])(template, this.getValue(), this._locale);
    };
    /**
     * @hidden
     */
    DateTime.prototype.getValue = function () {
        return this._value;
    };
    /**
     * @hidden
     */
    DateTime.prototype.getValueOrDefault = function () {
        if (this.hasValue()) {
            return this._value;
        }
        var initialDateString = this.getDefaultValueDateString();
        var _default = {};
        Object(__WEBPACK_IMPORTED_MODULE_8__util_datetime_util__["m" /* updateDate */])(_default, initialDateString);
        return _default;
    };
    /**
     * Get the default value as a date string
     * @hidden
     */
    DateTime.prototype.getDefaultValueDateString = function () {
        if (this.initialValue) {
            return this.initialValue;
        }
        var nowString = (new Date).toISOString();
        if (this.max) {
            var now = Object(__WEBPACK_IMPORTED_MODULE_8__util_datetime_util__["i" /* parseDate */])(nowString);
            var max = Object(__WEBPACK_IMPORTED_MODULE_8__util_datetime_util__["i" /* parseDate */])(this.max);
            var v = void 0;
            for (var i in max) {
                v = max[i];
                if (v === null) {
                    max[i] = now[i];
                }
            }
            var diff = Object(__WEBPACK_IMPORTED_MODULE_8__util_datetime_util__["a" /* compareDates */])(now, max);
            // If max is before current time, return max
            if (diff > 0) {
                return this.max;
            }
        }
        return nowString;
    };
    /**
     * @hidden
     */
    DateTime.prototype.hasValue = function () {
        var val = this._value;
        return Object(__WEBPACK_IMPORTED_MODULE_7__util_util__["l" /* isPresent */])(val)
            && Object(__WEBPACK_IMPORTED_MODULE_7__util_util__["k" /* isObject */])(val)
            && Object.keys(val).length > 0;
    };
    /**
     * @hidden
     */
    DateTime.prototype.calcMinMax = function (now) {
        var todaysYear = (now || new Date()).getFullYear();
        if (Object(__WEBPACK_IMPORTED_MODULE_7__util_util__["l" /* isPresent */])(this.yearValues)) {
            var years = convertToArrayOfNumbers(this.yearValues, 'year');
            if (Object(__WEBPACK_IMPORTED_MODULE_7__util_util__["f" /* isBlank */])(this.min)) {
                this.min = Math.min.apply(Math, years);
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_7__util_util__["f" /* isBlank */])(this.max)) {
                this.max = Math.max.apply(Math, years);
            }
        }
        else {
            if (Object(__WEBPACK_IMPORTED_MODULE_7__util_util__["f" /* isBlank */])(this.min)) {
                this.min = (todaysYear - 100).toString();
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_7__util_util__["f" /* isBlank */])(this.max)) {
                this.max = todaysYear.toString();
            }
        }
        var min = this._min = Object(__WEBPACK_IMPORTED_MODULE_8__util_datetime_util__["i" /* parseDate */])(this.min);
        var max = this._max = Object(__WEBPACK_IMPORTED_MODULE_8__util_datetime_util__["i" /* parseDate */])(this.max);
        min.year = min.year || todaysYear;
        max.year = max.year || todaysYear;
        min.month = min.month || 1;
        max.month = max.month || 12;
        min.day = min.day || 1;
        max.day = max.day || 31;
        min.hour = min.hour || 0;
        max.hour = max.hour || 23;
        min.minute = min.minute || 0;
        max.minute = max.minute || 59;
        min.second = min.second || 0;
        max.second = max.second || 59;
        // Ensure min/max constraits
        if (min.year > max.year) {
            console.error('min.year > max.year');
            min.year = max.year - 100;
        }
        if (min.year === max.year) {
            if (min.month > max.month) {
                console.error('min.month > max.month');
                min.month = 1;
            }
            else if (min.month === max.month && min.day > max.day) {
                console.error('min.day > max.day');
                min.day = 1;
            }
        }
    };
    DateTime.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'ion-datetime',
                    template: '<div *ngIf="!_text" class="datetime-text datetime-placeholder">{{placeholder}}</div>' +
                        '<div *ngIf="_text" class="datetime-text">{{_text}}</div>' +
                        '<button aria-haspopup="true" ' +
                        'type="button" ' +
                        '[id]="id" ' +
                        'ion-button="item-cover" ' +
                        '[attr.aria-labelledby]="_labelId" ' +
                        '[attr.aria-disabled]="_disabled" ' +
                        'class="item-cover">' +
                        '</button>',
                    host: {
                        '[class.datetime-disabled]': '_disabled'
                    },
                    providers: [{ provide: __WEBPACK_IMPORTED_MODULE_1__angular_forms__["NG_VALUE_ACCESSOR"], useExisting: DateTime, multi: true }],
                    encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None,
                },] },
    ];
    /** @nocollapse */
    DateTime.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_4__util_form__["a" /* Form */], },
        { type: __WEBPACK_IMPORTED_MODULE_2__config_config__["a" /* Config */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: __WEBPACK_IMPORTED_MODULE_6__item_item__["a" /* Item */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
        { type: __WEBPACK_IMPORTED_MODULE_3__picker_picker_controller__["a" /* PickerController */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
    ]; };
    DateTime.propDecorators = {
        'min': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'max': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'displayFormat': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'initialValue': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'pickerFormat': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'cancelText': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'doneText': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'yearValues': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'monthValues': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'dayValues': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'hourValues': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'minuteValues': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'monthNames': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'monthShortNames': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'dayNames': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'dayShortNames': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'pickerOptions': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'placeholder': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'ionCancel': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        '_click': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"], args: ['click', ['$event'],] },],
        '_keyup': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"], args: ['keyup.space',] },],
    };
    return DateTime;
}(__WEBPACK_IMPORTED_MODULE_5__util_base_input__["a" /* BaseInput */]));

/**
 * @hidden
 * Use to convert a string of comma separated numbers or
 * an array of numbers, and clean up any user input
 */
function convertToArrayOfNumbers(input, type) {
    if (Object(__WEBPACK_IMPORTED_MODULE_7__util_util__["n" /* isString */])(input)) {
        // convert the string to an array of strings
        // auto remove any whitespace and [] characters
        input = input.replace(/\[|\]|\s/g, '').split(',');
    }
    var values;
    if (Object(__WEBPACK_IMPORTED_MODULE_7__util_util__["e" /* isArray */])(input)) {
        // ensure each value is an actual number in the returned array
        values = input
            .map(function (num) { return parseInt(num, 10); })
            .filter(isFinite);
    }
    if (!values || !values.length) {
        console.warn("Invalid \"" + type + "Values\". Must be an array of numbers, or a comma separated string of numbers.");
    }
    return values;
}
/**
 * @hidden
 * Use to convert a string of comma separated strings or
 * an array of strings, and clean up any user input
 */
function convertToArrayOfStrings(input, type) {
    if (Object(__WEBPACK_IMPORTED_MODULE_7__util_util__["l" /* isPresent */])(input)) {
        if (Object(__WEBPACK_IMPORTED_MODULE_7__util_util__["n" /* isString */])(input)) {
            // convert the string to an array of strings
            // auto remove any [] characters
            input = input.replace(/\[|\]/g, '').split(',');
        }
        var values;
        if (Object(__WEBPACK_IMPORTED_MODULE_7__util_util__["e" /* isArray */])(input)) {
            // trim up each string value
            values = input.map(function (val) { return val.trim(); });
        }
        if (!values || !values.length) {
            console.warn("Invalid \"" + type + "Names\". Must be an array of strings, or a comma separated string.");
        }
        return values;
    }
}
var DEFAULT_FORMAT = 'MMM D, YYYY';
//# sourceMappingURL=datetime.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/fab/fab-container.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FabContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__platform_platform__ = __webpack_require__("./node_modules/ionic-angular/platform/platform.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gestures_ui_event_manager__ = __webpack_require__("./node_modules/ionic-angular/gestures/ui-event-manager.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fab__ = __webpack_require__("./node_modules/ionic-angular/components/fab/fab.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fab_list__ = __webpack_require__("./node_modules/ionic-angular/components/fab/fab-list.js");





/**
  * @name FabContainer
  * @module ionic
  *
  * @description
  * `<ion-fab>` is not a FAB button by itself but a container that assist the fab button (`<button ion-fab>`) allowing it
  * to be placed in fixed position that does not scroll with the content. It is also used to implement "material design speed dial",
  * ie. a FAB buttons displays a small lists of related actions when clicked.
  *
  * @property [top] - Places the container on the top of the content
  * @property [bottom] - Places the container on the bottom  of the content
  * @property [left] - Places the container on the left
  * @property [right] - Places the container on the right
  * @property [middle] - Places the container on the middle vertically
  * @property [center] - Places the container on the center horizontally
  * @property [edge] - Used to place the container between the content and the header/footer
  *
  * @usage
  *
  * ```html
  * <!-- this fab is placed at top right -->
  * <ion-content>
  *  <ion-fab top right>
  *    <button ion-fab>Button</button>
  *  </ion-fab>
  *
  *  <!-- this fab is placed at the center of the content viewport -->
  *  <ion-fab center middle>
  *    <button ion-fab>Button</button>
  *  </ion-fab>
  * </ion-content>
  * ```
  *
  * Ionic's FAB also supports "material design's fab speed dial". It is a normal fab button
  * that shows a list of related actions when clicked.
  *
  * The same `ion-fab` container can contain several `ion-fab-list` with different side values:
  * `top`, `bottom`, `left` and `right`. For example, if you want to have a list of button that are
  * on the top of the main button, you should use `side="top"` and so on. By default, if side is ommited, `side="bottom"`.
  *
  * ```html
  * <ion-content>
  *  <!-- this fab is placed at bottom right -->
  *  <ion-fab bottom right >
  *    <button ion-fab>Share</button>
  *    <ion-fab-list side="top">
  *      <button ion-fab>Facebook</button>
  *      <button ion-fab>Twitter</button>
  *      <button ion-fab>Youtube</button>
  *    </ion-fab-list>
  *    <ion-fab-list side="left">
  *      <button ion-fab>Vimeo</button>
  *    </ion-fab-list>
  *  </ion-fab>
  * </ion-content>
  * ```
  *
  * A FAB speed dial can also be closed programatically.
  *
  * ```html
  * <ion-content>
  *  <ion-fab bottom right #fab>
  *    <button ion-fab>Share</button>
  *    <ion-fab-list side="top">
  *      <button ion-fab (click)="share('facebook', fab)">Facebook</button>
  *      <button ion-fab (click)="share('twitter', fab)">Twitter</button>
  *    </ion-fab-list>
  *  </ion-fab>
  * </ion-content>
  * ```
  *
  * ```ts
  * share(socialNet: string, fab: FabContainer) {
  *   fab.close();
  *   console.log("Sharing in", socialNet);
  * }
  * ```
  *
  * @demo /docs/demos/src/fab/
  * @see {@link /docs/components#fabs FAB Component Docs}
 */
var FabContainer = (function () {
    function FabContainer(plt) {
        /**
         * @hidden
         */
        this._listsActive = false;
        this._events = new __WEBPACK_IMPORTED_MODULE_2__gestures_ui_event_manager__["a" /* UIEventManager */](plt);
    }
    /**
     * @hidden
     */
    FabContainer.prototype.ngAfterContentInit = function () {
        var mainButton = this._mainButton;
        if (!mainButton || !mainButton.getNativeElement()) {
            console.error('FAB container needs a main <button ion-fab>');
            return;
        }
        this._events.listen(mainButton.getNativeElement(), 'click', this.clickHandler.bind(this), { zone: true });
    };
    /**
     * @hidden
     */
    FabContainer.prototype.clickHandler = function (ev) {
        if (this.canActivateList(ev)) {
            this.toggleList();
        }
    };
    /**
     * @hidden
     */
    FabContainer.prototype.canActivateList = function (ev) {
        if (this._fabLists.length > 0 && this._mainButton && ev.target) {
            var ele = ev.target.closest('ion-fab>[ion-fab]');
            return (ele && ele === this._mainButton.getNativeElement());
        }
        return false;
    };
    /**
     * @hidden
     */
    FabContainer.prototype.toggleList = function () {
        this.setActiveLists(!this._listsActive);
    };
    /**
     * @hidden
     */
    FabContainer.prototype.setActiveLists = function (isActive) {
        if (isActive === this._listsActive) {
            return;
        }
        var lists = this._fabLists.toArray();
        for (var _i = 0, lists_1 = lists; _i < lists_1.length; _i++) {
            var list = lists_1[_i];
            list.setVisible(isActive);
        }
        this._mainButton.setActiveClose(isActive);
        this._listsActive = isActive;
    };
    /**
     * Close an active FAB list container
     */
    FabContainer.prototype.close = function () {
        this.setActiveLists(false);
    };
    /**
     * @hidden
     */
    FabContainer.prototype.ngOnDestroy = function () {
        this._events.destroy();
    };
    FabContainer.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'ion-fab',
                    template: '<ng-content></ng-content>'
                },] },
    ];
    /** @nocollapse */
    FabContainer.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__platform_platform__["a" /* Platform */], },
    ]; };
    FabContainer.propDecorators = {
        '_mainButton': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChild"], args: [__WEBPACK_IMPORTED_MODULE_3__fab__["a" /* FabButton */],] },],
        '_fabLists': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChildren"], args: [__WEBPACK_IMPORTED_MODULE_4__fab_list__["a" /* FabList */],] },],
    };
    return FabContainer;
}());

//# sourceMappingURL=fab-container.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/fab/fab-list.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FabList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__platform_platform__ = __webpack_require__("./node_modules/ionic-angular/platform/platform.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fab__ = __webpack_require__("./node_modules/ionic-angular/components/fab/fab.js");





/**
  * @name FabList
  * @description
  * `ion-fab-list` is a container for multiple FAB buttons. They are components of `ion-fab` and allow you to specificy the buttons position, left, right, top, bottom.
  * @usage
  *
  * ```html
  *  <ion-fab bottom right >
  *    <button ion-fab>Share</button>
  *    <ion-fab-list side="top">
  *      <button ion-fab>Facebook</button>
  *      <button ion-fab>Twitter</button>
  *      <button ion-fab>Youtube</button>
  *    </ion-fab-list>
  *    <ion-fab-list side="left">
  *      <button ion-fab>Vimeo</button>
  *    </ion-fab-list>
  *  </ion-fab>
  * ```
  * @module ionic
  *
  * @demo /docs/demos/src/fab/
  * @see {@link /docs/components#fab Fab Component Docs}
 */
var FabList = (function () {
    function FabList(_elementRef, _renderer, config, _plt) {
        this._elementRef = _elementRef;
        this._renderer = _renderer;
        this._plt = _plt;
        this._visible = false;
        this._fabs = [];
        this._mode = config.get('mode');
    }
    Object.defineProperty(FabList.prototype, "_setbuttons", {
        set: function (query) {
            var fabs = this._fabs = query.toArray();
            var className = "fab-" + this._mode + "-in-list";
            for (var _i = 0, fabs_1 = fabs; _i < fabs_1.length; _i++) {
                var fab = fabs_1[_i];
                fab.setElementClass('fab-in-list', true);
                fab.setElementClass(className, true);
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @hidden
     */
    FabList.prototype.setVisible = function (val) {
        var _this = this;
        var visible = Object(__WEBPACK_IMPORTED_MODULE_2__util_util__["o" /* isTrueProperty */])(val);
        if (visible === this._visible) {
            return;
        }
        this._visible = visible;
        var fabs = this._fabs;
        var i = 1;
        if (visible) {
            fabs.forEach(function (fab) {
                _this._plt.timeout(function () { return fab.setElementClass('show', true); }, i * 30);
                i++;
            });
        }
        else {
            fabs.forEach(function (fab) { return fab.setElementClass('show', false); });
        }
        this.setElementClass('fab-list-active', visible);
    };
    /**
     * @internal
     */
    FabList.prototype.setElementClass = function (className, add) {
        this._renderer.setElementClass(this._elementRef.nativeElement, className, add);
    };
    FabList.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'ion-fab-list',
                },] },
    ];
    /** @nocollapse */
    FabList.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: __WEBPACK_IMPORTED_MODULE_1__config_config__["a" /* Config */], },
        { type: __WEBPACK_IMPORTED_MODULE_3__platform_platform__["a" /* Platform */], },
    ]; };
    FabList.propDecorators = {
        '_setbuttons': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChildren"], args: [__WEBPACK_IMPORTED_MODULE_4__fab__["a" /* FabButton */],] },],
    };
    return FabList;
}());

//# sourceMappingURL=fab-list.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/fab/fab.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FabButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ion__ = __webpack_require__("./node_modules/ionic-angular/components/ion.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



/**
  * @name FabButton
  * @module ionic
  *
  * @description
  * FABs (Floating Action Buttons) are standard material design components. They are shaped as a circle that represents a promoted action. When pressed, it may contain more related actions.
  * FABs as its name suggests are floating over the content in a fixed position. This is not achieved exclusively with `<button ion-fab>Button</button>` but it has to be wrapped with the `<ion-fab>` component, like this:
  *
  * ```html
  * <ion-content>
  *  <!-- Real floating action button, fixed. It will not scroll with the content -->
  *  <ion-fab>
  *    <button ion-fab>Button</button>
  *  </ion-fab>
  *
  *  <!-- Button shaped as a circle that just like a normal button scrolls with the content -->
  *  <button ion-fab>Button</button>
  * </ion-content>
  *
  * ```
  *
  * In case the button is not wrapped with `<ion-fab>`, the fab button will behave like a normal button, scrolling with the content.
  *
  * See [ion-fab] to learn more information about how to position the fab button.
  *
  * @property [mini] - Makes a fab button with a reduced size.
  *
  * @usage
  *
  * ```html
  *
  * <!-- Colors -->
  * <ion-fab>
  *   <button ion-fab color="primary">Button</button>
  * </ion-fab>
  *
  * <!-- Mini -->
  * <ion-fab>
  *   <button ion-fab mini>Small</button>
  * </ion-fab>
  * ```
  *
  * @demo /docs/demos/src/fab/
  * @see {@link /docs/components#fabs FAB Component Docs}
 */
var FabButton = (function (_super) {
    __extends(FabButton, _super);
    function FabButton(config, elementRef, renderer) {
        return _super.call(this, config, elementRef, renderer, 'fab') || this;
    }
    /**
     * @hidden
     */
    FabButton.prototype.setActiveClose = function (closeVisible) {
        this.setElementClass('fab-close-active', closeVisible);
    };
    FabButton.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: '[ion-fab]',
                    template: '<ion-icon name="close" class="fab-close-icon"></ion-icon>' +
                        '<span class="button-inner">' +
                        '<ng-content></ng-content>' +
                        '</span>' +
                        '<div class="button-effect"></div>',
                    changeDetection: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectionStrategy"].OnPush,
                    encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None,
                },] },
    ];
    /** @nocollapse */
    FabButton.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__config_config__["a" /* Config */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    ]; };
    return FabButton;
}(__WEBPACK_IMPORTED_MODULE_2__ion__["a" /* Ion */]));

//# sourceMappingURL=fab.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/grid/col.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Col; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");

/**
  * @name Col
  * @module ionic
  * @description
  *
  * Columns are cellular components of the [grid](../Grid) system and go inside of a [row](../Row).
  * They will expand to fill their row. All content within a grid should go inside of a column.
  *
  * ## Column attributes
  *
  * By default, columns will stretch to fill the entire height of the row.
  * There are several attributes that can be added to a column to customize this behavior.
  *
  * | Property              | Description                                                                                                 |
  * |-----------------------|-------------------------------------------------------------------------------------------------------------|
  * | align-self-start      | Adds `align-self: flex-start`. The column will be vertically aligned at the top.                            |
  * | align-self-center     | Adds `align-self: center`. The column will be vertically aligned in the center.                             |
  * | align-self-end        | Adds `align-self: flex-end`. The column will be vertically aligned at the bottom.                           |
  * | align-self-stretch    | Adds `align-self: stretch`. The column will be stretched to take up the entire height of the row.           |
  * | align-self-baseline   | Adds `align-self: baseline`. The column will be vertically aligned at its baseline.                         |
  *
  *
 */
var Col = (function () {
    function Col() {
    }
    Col.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'ion-col, [ion-col]',
                    host: {
                        'class': 'col'
                    }
                },] },
    ];
    /** @nocollapse */
    Col.ctorParameters = function () { return []; };
    return Col;
}());

//# sourceMappingURL=col.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/grid/grid.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Grid; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");

/**
  * @name Grid
  * @module ionic
  * @description
  *
  * The grid is a powerful mobile-first flexbox system for building custom layouts.
  * It is heavily influenced by [Bootstrap's grid system](http://v4-alpha.getbootstrap.com/layout/grid/).
  *
  * The grid is composed of three units — a grid, row(s) and column(s). Columns will expand to fill their
  * row, and will resize to fit additional columns. It is based on a 12 column layout with different
  * breakpoints based on the screen size. The number of columns and breakpoints can be fully customized
  * using Sass.
  *
  * - [How it works](#how-it-works)
  * - [Grid size](#grid-size)
  * - [Grid attributes](#grid-attributes)
  * - [Default breakpoints](#default-breakpoints)
  * - [Auto-layout columns](#auto-layout-columns)
  *   - [Equal-width](#equal-width)
  *   - [Setting one column width](#setting-one-column-width)
  *   - [Variable-width](#variable-width)
  * - [Responsive attributes](#responsive-attributes)
  *   - [All breakpoints](#all-breakpoints)
  *   - [Stacked to horizontal](#stacked-to-horizontal)
  * - [Reordering](#reordering)
  *   - [Offsetting columns](#offsetting-columns)
  *   - [Push and pull](#push-and-pull)
  * - [Alignment](#alignment)
  *   - [Vertical Alignment](#vertical-alignment)
  *   - [Horizontal Alignment](#horizontal-alignment)
  * - [Customizing the grid](#customizing-the-grid)
  *   - [Number of columns and padding](#number-of-columns-and-padding)
  *   - [Grid tiers](#grid-tiers)
  *
  *
  * ## How it works
  *
  * The grid is a mobile-first system made up of any number of rows and columns.
  * It is built with flexbox making it extremely responsive. The components that
  * make up the grid can be written as an element (e.g., `<ion-grid>`) or added as
  * an attribute to any element (e.g., `<div ion-row>`).
  *
  * Here's how it works:
  *
  * - Grids act as a container for all rows and columns. Grids take up the full width of their container,
  * but adding the `fixed` attribute will specify the width per screen size, see [grid size](#grid-size) below.
  * - Rows are horizontal groups of columns that line the columns up properly.
  * - Content should be placed within columns, and only columns may be immediate children of rows.
  * - Grid columns without a specified width will automatically have equal widths.
  * For example, four instances of `col-sm` will each automatically be 25% wide for small breakpoints.
  * - Column attributes indicate the number of columns to use out of the default 12 per row.
  * So, `col-4` can be added in order to have three equal-width columns.
  * - Column widths are set as a percentage, so they’re always fluid and sized relative to their parent element.
  * - Columns have padding between individual columns, however, the padding can be removed from the grid and
  * columns by adding `no-padding` on the grid.
  * - There are five grid tiers by default, one for each responsive breakpoint: all breakpoints (extra small),
  * small, medium, large, and extra large.
  * - Grid tiers are based on minimum widths, meaning they apply to their tier and all those larger than it
  * (e.g., `col-sm-4` applies to small, medium, large, and extra large devices).
  * - Grids can easily be customized via Sass variables. See [customizing the grid](#customizing-the-grid).
  *
  * There are some [known bugs with flexbox](https://github.com/philipwalton/flexbugs) that
  * should be checked prior to creating issues with Ionic.
  *
  * ## Grid size
  *
  * By default, the grid will take up 100% width. To set a maximum width based on the screen
  * size add the `fixed` attribute. The maximum width of the grid for each breakpoint is defined
  * in the `$grid-max-widths` Sass variable. For more information, see
  * [customizing the grid](#customizing-the-grid).
  *
  * | Name     | Value    | Description                                         |
  * |----------|----------|-----------------------------------------------------|
  * | xs       | auto     | Don't set the grid width for xs screens             |
  * | sm       | 540px    | Set grid width to 540px when (min-width: 576px)     |
  * | md       | 720px    | Set grid width to 720px when (min-width: 768px)     |
  * | lg       | 960px    | Set grid width to 960px when (min-width: 992px)     |
  * | xl       | 1140px   | Set grid width to 1140px when (min-width: 1200px)   |
  *
  *
  * ## Grid attributes
  *
  * The grid takes up full width and has padding added to it based on the screen size. There are two
  * attributes that can be used to adjust this behavior.
  *
  * | Property        | Description                                                                                                       |
  * |-----------------|-------------------------------------------------------------------------------------------------------------------|
  * | no-padding      | Removes padding from the grid and immediate children columns.                                                     |
  * | fixed           | Set a max width based on the screen size.                                                                         |
  *
  *
  * ## Default breakpoints
  *
  * The default breakpoints are defined by the `$grid-breakpoints` Sass variable. It can be
  * customized to use different values for the breakpoint, rename and add/remove breakpoints.
  * For more information, see [customizing the grid](#customizing-the-grid).
  *
  * | Name     | Value    | Width Prefix | Offset Prefix | Push Prefix  | Pull Prefix | Description                                       |
  * |----------|----------|--------------|---------------|--------------|-------------|---------------------------------------------------|
  * | xs       | 0        | `col-`       | `offset-`     | `push-`      | `pull-`     | Set columns when (min-width: 0)                   |
  * | sm       | 576px    | `col-sm-`    | `offset-sm-`  | `push-sm-`   | `pull-sm-`  | Set columns when (min-width: 576px)               |
  * | md       | 768px    | `col-md-`    | `offset-md-`  | `push-md-`   | `pull-md-`  | Set columns when (min-width: 768px)               |
  * | lg       | 992px    | `col-lg-`    | `offset-lg-`  | `push-lg-`   | `pull-lg-`  | Set columns when (min-width: 992px)               |
  * | xl       | 1200px   | `col-xl-`    | `offset-xl-`  | `push-xl-`   | `pull-xl-`  | Set columns when (min-width: 1200px)              |
  *
  * _Note: the first breakpoint must have the value set to 0 and all breakpoint values must be in
  * ascending order._
  *
  * ## Auto-layout columns
  *
  * ### Equal-width
  *
  * By default, columns will take up equal width inside of a row for all devices and screen sizes.
  *
  * ```
  * <ion-grid>
  *   <ion-row>
  *     <ion-col>
  *       1 of 2
  *     </ion-col>
  *     <ion-col>
  *       2 of 2
  *     </ion-col>
  *   </ion-row>
  *   <ion-row>
  *     <ion-col>
  *       1 of 3
  *     </ion-col>
  *     <ion-col>
  *       2 of 3
  *     </ion-col>
  *     <ion-col>
  *       3 of 3
  *     </ion-col>
  *   </ion-row>
  * </ion-grid>
  * ```
  *
  * ### Setting one column width
  *
  * Set the width of one column and the others will automatically resize around it.
  * This can be done using our predefined grid attributes. In the example below,
  * the other columns will resize no matter the width of the center column.
  *
  * ```
  * <ion-grid>
  *   <ion-row>
  *     <ion-col>
  *       1 of 3
  *     </ion-col>
  *     <ion-col col-8>
  *       2 of 3 (wider)
  *     </ion-col>
  *     <ion-col>
  *       3 of 3
  *     </ion-col>
  *   </ion-row>
  *   <ion-row>
  *     <ion-col>
  *       1 of 3
  *     </ion-col>
  *     <ion-col col-6>
  *       2 of 3 (wider)
  *     </ion-col>
  *     <ion-col>
  *       3 of 3
  *     </ion-col>
  *   </ion-row>
  * </ion-grid>
  * ```
  *
  * ### Variable-width
  *
  * Using the `col-{breakpoint}-auto` attributes, the column can size itself based on the
  * natural width of its content. This is extremely useful for setting a column width
  * using pixels. The columns next to the variable-width column will resize to fill the row.
  *
  * ```
  * <ion-grid>
  *   <ion-row>
  *     <ion-col>
  *       1 of 3
  *     </ion-col>
  *     <ion-col col-auto>
  *       Variable width content
  *     </ion-col>
  *     <ion-col>
  *       3 of 3
  *     </ion-col>
  *   </ion-row>
  *   <ion-row>
  *     <ion-col>
  *       1 of 4
  *     </ion-col>
  *     <ion-col>
  *       2 of 4
  *     </ion-col>
  *     <ion-col col-auto>
  *       <ion-input placeholder="Variable width input"></ion-input>
  *     </ion-col>
  *     <ion-col>
  *       4 of 4
  *     </ion-col>
  *   </ion-row>
  * </ion-grid>
  * ```
  *
  *
  * ## Responsive attributes
  *
  * ### All breakpoints
  *
  * To customize a column's width for all devices and screens, add the `col-*`
  * attribute. These attributes tell the column to take up `*` columns out
  * of the available columns.
  *
  * ```
  * <ion-grid>
  *   <ion-row>
  *     <ion-col col-4>
  *       1 of 4
  *     </ion-col>
  *     <ion-col col-2>
  *       2 of 4
  *     </ion-col>
  *     <ion-col col-2>
  *       3 of 4
  *     </ion-col>
  *     <ion-col col-4>
  *       4 of 4
  *     </ion-col>
  *   </ion-row>
  * </ion-grid>
  * ```
  *
  * ###  Stacked to horizontal
  *
  * Use a combination of width and breakpoint attributes to create a grid that starts out stacked
  * on extra small screens before becoming horizontal on small screens.
  *
  * ```
  * <ion-grid>
  *   <ion-row>
  *     <ion-col col-12 col-sm>
  *       1 of 4
  *     </ion-col>
  *     <ion-col col-12 col-sm>
  *       2 of 4
  *     </ion-col>
  *     <ion-col col-12 col-sm>
  *       3 of 4
  *     </ion-col>
  *     <ion-col col-12 col-sm>
  *       4 of 4
  *     </ion-col>
  *   </ion-row>
  * </ion-grid>
  * ```
  *
  *
  * ## Reordering
  *
  * ### Offsetting columns
  *
  * Move columns to the right by adding the `offset-*` attributes. These attributes
  * increase the margin start of the column by `*` columns. For example, in the following
  * grid the last column will be offset by 3 columns and take up 3 columns:
  *
  * ```
  * <ion-grid>
  *   <ion-row>
  *     <ion-col col-3>
  *       1 of 2
  *     </ion-col>
  *     <ion-col col-3 offset-3>
  *       2 of 2
  *     </ion-col>
  *   </ion-row>
  * </ion-grid>
  * ```
  *
  * Offsets can also be added based on screen breakpoints. Here's an example of a
  * grid where the last column will be offset by 3 columns for `md` screens and up:
  *
  * ```
  * <ion-grid>
  *   <ion-row>
  *     <ion-col col-md-3>
  *       1 of 3
  *     </ion-col>
  *     <ion-col col-md-3>
  *       2 of 3
  *     </ion-col>
  *     <ion-col col-md-3 offset-md-3>
  *       3 of 3
  *     </ion-col>
  *   </ion-row>
  * </ion-grid>
  * ```
  *
  * ### Push and pull
  *
  * Reorder the columns by adding the `push-*` and `pull-*` attributes. These attributes
  * adjust the `left` and `right` of the columns by `*` columns making it easy to reorder
  * columns. For example, in the following grid the column with the `1st col` description
  * will actually be the last column and the `2nd col` will be the first column.
  *
  * ```
  * <ion-grid>
  *   <ion-row>
  *     <ion-col col-9 push-3>
  *       1 of 2
  *     </ion-col>
  *     <ion-col col-3 pull-9>
  *       2 of 2
  *     </ion-col>
  *   </ion-row>
  * </ion-grid>
  * ```
  *
  * Push and pull can also be added based on screen breakpoints. In the following example,
  * the column with the `3rd` column description will actually be the first column for
  * `md` screens and up:
  *
  * ```
  * <ion-grid>
  *   <ion-row>
  *     <ion-col col-md-6 push-md-3>
  *       1 of 3
  *     </ion-col>
  *     <ion-col col-md-3 push-md-3>
  *       2 of 3
  *     </ion-col>
  *     <ion-col col-md-3 pull-md-9>
  *       3 of 3
  *     </ion-col>
  *   </ion-row>
  * </ion-grid>
  * ```
  *
  *
  * ## Alignment
  *
  * ### Vertical alignment
  *
  * All columns can be vertically aligned inside of a row by adding different
  * attributes to the row. For a list of available attributes, see
  * [row attributes](../Row#row-attributes).
  *
  * ```
  * <ion-grid>
  *   <ion-row align-items-start>
  *     <ion-col>
  *       1 of 4
  *     </ion-col>
  *     <ion-col>
  *       2 of 4
  *     </ion-col>
  *     <ion-col>
  *       3 of 4
  *     </ion-col>
  *     <ion-col>
  *       4 of 4 <br>#<br>#<br>#
  *     </ion-col>
  *   </ion-row>
  *
  *   <ion-row align-items-center>
  *     <ion-col>
  *       1 of 4
  *     </ion-col>
  *     <ion-col>
  *       2 of 4
  *     </ion-col>
  *     <ion-col>
  *       3 of 4
  *     </ion-col>
  *     <ion-col>
  *       4 of 4 <br>#<br>#<br>#
  *     </ion-col>
  *   </ion-row>
  *
  *   <ion-row align-items-end>
  *     <ion-col>
  *       1 of 4
  *     </ion-col>
  *     <ion-col>
  *       2 of 4
  *     </ion-col>
  *     <ion-col>
  *       3 of 4
  *     </ion-col>
  *     <ion-col>
  *       4 of 4 <br>#<br>#<br>#
  *     </ion-col>
  *   </ion-row>
  * </ion-grid>
  * ```
  *
  * Columns can also align themselves differently than other columns by
  * adding the alignment attribute directly to the column. For a list of available
  * attributes, see [column attributes](../Col#column-attributes).
  *
  * ```
  * <ion-grid>
  *   <ion-row>
  *     <ion-col align-self-start>
  *       <div>
  *         1 of 4
  *       </div>
  *     </ion-col>
  *     <ion-col align-self-center>
  *       <div>
  *         2 of 4
  *       </div>
  *     </ion-col>
  *     <ion-col align-self-end>
  *       <div>
  *         3 of 4
  *       </div>
  *     </ion-col>
  *     <ion-col>
  *       <div>
  *         4 of 4 <br>#<br>#<br>#
  *       </div>
  *     </ion-col>
  *   </ion-row>
  * </ion-grid>
  * ```
  *
  * ### Horizontal alignment
  *
  * All columns can be horizontally aligned inside of a row by adding different
  * attributes to the row. For a list of available attributes, see
  * [row attributes](../Row#row-attributes).
  *
  * ```
  * <ion-grid>
  *   <ion-row justify-content-start>
  *     <ion-col col-3>
  *       1 of 2
  *     </ion-col>
  *     <ion-col col-3>
  *       2 of 2
  *     </ion-col>
  *   </ion-row>
  *
  *   <ion-row justify-content-center>
  *     <ion-col col-3>
  *       1 of 2
  *     </ion-col>
  *     <ion-col col-3>
  *       2 of 2
  *     </ion-col>
  *   </ion-row>
  *
  *   <ion-row justify-content-end>
  *     <ion-col col-3>
  *       1 of 2
  *     </ion-col>
  *     <ion-col col-3>
  *       2 of 2
  *     </ion-col>
  *   </ion-row>
  *
  *   <ion-row justify-content-around>
  *     <ion-col col-3>
  *       1 of 2
  *     </ion-col>
  *     <ion-col col-3>
  *       2 of 2
  *     </ion-col>
  *   </ion-row>
  *
  *   <ion-row justify-content-between>
  *     <ion-col col-3>
  *       1 of 2
  *     </ion-col>
  *     <ion-col col-3>
  *       2 of 2
  *     </ion-col>
  *   </ion-row>
  * </ion-grid>
  * ```
  *
  *
  * ## Customizing the grid
  *
  * Using our built-in grid Sass variables and maps, it’s possible to completely customize
  * the predefined grid attributes. Change the number of breakpoints, the media query values,
  * the number of columns, and more.
  *
  * ### Number of columns and padding
  *
  * The number of grid columns and their padding can be modified via Sass variables.
  * `$grid-columns` is used to generate the widths (in percent) of each individual column.
  * `$grid-padding-width` is used for the padding on the grid, while `$grid-padding-widths`
  * allows breakpoint-specific widths that are divided evenly across `padding-left` and
  * `padding-right` as well as `padding-top` and `padding-bottom` of the grid and columns.
  *
  * ```
  * $grid-columns:               12 !default;
  *
  * $grid-padding-width:         10px !default;
  *
  * $grid-padding-widths: (
  *   xs: $grid-padding-width,
  *   sm: $grid-padding-width,
  *   md: $grid-padding-width,
  *   lg: $grid-padding-width,
  *   xl: $grid-padding-width
  * ) !default;
  * ```
  *
  * ### Grid tiers
  *
  * To customize the breakpoints and their values, override the values of
  * `$grid-breakpoints` and `$grid-max-widths`. For example, to only use
  * 3 breakpoints, the following could be written:
  *
  * ```
  * $grid-breakpoints: (
  *   sm: 0,
  *   md: 768px,
  *   lg: 1024px
  * );
  *
  * $grid-max-widths: (
  *   sm: 420px,
  *   md: 720px,
  *   lg: 960px
  * );
  * ```
  *
 */
var Grid = (function () {
    function Grid() {
    }
    Grid.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'ion-grid, [ion-grid]',
                    host: {
                        'class': 'grid'
                    }
                },] },
    ];
    /** @nocollapse */
    Grid.ctorParameters = function () { return []; };
    return Grid;
}());

//# sourceMappingURL=grid.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/grid/row.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Row; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");

/**
  * @name Row
  * @module ionic
  * @description
  *
  * Rows are horizontal components of the [grid](../Grid) system and contain varying numbers of
  * [columns](../Col). They ensure the columns are positioned properly.
  *
  * ## Row attributes
  *
  * By default, columns will stretch to fill the entire height of the row and wrap when necessary.
  * There are several attributes that can be added to a row to customize this behavior.
  *
  * | Property                    | Description                                                                                                                                      |
  * |-----------------------------|--------------------------------------------------------------------------------------------------------------------------------------------------|
  * | nowrap                      | Adds `flex-wrap: nowrap`. Forces the columns to a single row.                                                                                    |
  * | wrap-reverse                | Adds `flex-wrap: wrap-reverse`. The columns will wrap in reverse.                                                                                |
  * | align-items-start           | Adds `align-items: flex-start`. All columns will be vertically aligned at the top, unless they specify their own alignment.                      |
  * | align-items-center          | Adds `align-items: center`. All columns will be vertically aligned in the center, unless they specify their own alignment.                       |
  * | align-items-end             | Adds `align-items: flex-end`. All columns will be vertically aligned at the bottom, unless they specify their own alignment.                     |
  * | align-items-stretch         | Adds `align-items: stretch`. All columns will be stretched to take up the entire height of the row, unless they specify their own alignment.     |
  * | align-items-baseline        | Adds `align-items: baseline`. All columns will be vertically aligned at their baselines, unless they specify their own alignment.                |
  * | justify-content-start       | Adds `justify-content: start`. All columns will be horizontally aligned at the start.                                                            |
  * | justify-content-center      | Adds `justify-content: center`. All columns will be horizontally aligned at the center.                                                          |
  * | justify-content-end         | Adds `justify-content: end`. All columns will be horizontally aligned at the end.                                                                |
  * | justify-content-around      | Adds `justify-content: space-around`. All columns will be horizontally aligned with equal space around them.                                     |
  * | justify-content-between     | Adds `justify-content: space-between`. All columns will be horizontally aligned with a half-size space on either end.                            |
  *
  *
 */
var Row = (function () {
    function Row() {
    }
    Row.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'ion-row, [ion-row]',
                    host: {
                        'class': 'row'
                    }
                },] },
    ];
    /** @nocollapse */
    Row.ctorParameters = function () { return []; };
    return Row;
}());

//# sourceMappingURL=row.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/icon/icon.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Icon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ion__ = __webpack_require__("./node_modules/ionic-angular/components/ion.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




/**
 * @name Icon
 * @description
 * Icons can be used on their own, or inside of a number of Ionic components.
 * For a full list of available icons, check out the
 * [Ionicons docs](../../../../ionicons).
 *
 * One feature of Ionicons in Ionic is when icon names are set, the actual icon
 * which is rendered can change slightly depending on the mode the app is
 * running from. For example, by setting the icon name of `alarm`, on iOS the
 * icon will automatically apply `ios-alarm`, and on Material Design it will
 * automatically apply `md-alarm`. This allows the developer to write the
 * markup once while Ionic applies the appropriate icon based on the mode.
 *
 * @usage
 * ```html
 * <!-- automatically uses the correct "star" icon depending on the mode -->
 * <ion-icon name="star"></ion-icon>
 *
 * <!-- explicity set the icon for each mode -->
 * <ion-icon ios="ios-home" md="md-home"></ion-icon>
 *
 * <!-- always use the same icon, no matter what the mode -->
 * <ion-icon name="ios-clock"></ion-icon>
 * <ion-icon name="logo-twitter"></ion-icon>
 * ```
 *
 * @demo /docs/demos/src/icon/
 * @see {@link /docs/components#icons Icon Component Docs}
 *
 */
var Icon = (function (_super) {
    __extends(Icon, _super);
    function Icon(config, elementRef, renderer) {
        var _this = _super.call(this, config, elementRef, renderer, 'icon') || this;
        /** @hidden */
        _this._isActive = true;
        /** @hidden */
        _this._name = '';
        /** @hidden */
        _this._ios = '';
        /** @hidden */
        _this._md = '';
        /** @hidden */
        _this._css = '';
        /**
         * @hidden
         */
        _this._hidden = false;
        _this._iconMode = config.get('iconMode');
        return _this;
    }
    /**
     * @hidden
     */
    Icon.prototype.ngOnDestroy = function () {
        if (this._css) {
            this.setElementClass(this._css, false);
        }
    };
    Object.defineProperty(Icon.prototype, "name", {
        /**
         * @input {string} Specifies which icon to use. The appropriate icon will be used based on the mode.
         * For more information, see [Ionicons](/docs/ionicons/).
         */
        get: function () {
            return this._name;
        },
        set: function (val) {
            if (!(/^md-|^ios-|^logo-/.test(val))) {
                // this does not have one of the defaults
                // so lets auto add in the mode prefix for them
                this._name = this._iconMode + '-' + val;
            }
            else {
                this._name = val;
            }
            this.update();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Icon.prototype, "ios", {
        /**
         * @input {string} Specifies which icon to use on `ios` mode.
         */
        get: function () {
            return this._ios;
        },
        set: function (val) {
            this._ios = val;
            this.update();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Icon.prototype, "md", {
        /**
         * @input {string} Specifies which icon to use on `md` mode.
         */
        get: function () {
            return this._md;
        },
        set: function (val) {
            this._md = val;
            this.update();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Icon.prototype, "isActive", {
        /**
         * @input {boolean} If true, the icon is styled with an "active" appearance.
         * An active icon is filled in, and an inactive icon is the outline of the icon.
         * The `isActive` property is largely used by the tabbar. Only affects `ios` icons.
         */
        get: function () {
            return this._isActive;
        },
        set: function (val) {
            this._isActive = Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["o" /* isTrueProperty */])(val);
            this.update();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @hidden
     */
    Icon.prototype.update = function () {
        var iconName;
        if (this._ios && this._iconMode === 'ios') {
            iconName = this._ios;
        }
        else if (this._md && this._iconMode === 'md') {
            iconName = this._md;
        }
        else {
            iconName = this._name;
        }
        var hidden = this._hidden = (iconName === null);
        if (hidden) {
            return;
        }
        var iconMode = iconName.split('-', 2)[0];
        if (iconMode === 'ios' &&
            !this._isActive &&
            iconName.indexOf('logo-') < 0 &&
            iconName.indexOf('-outline') < 0) {
            iconName += '-outline';
        }
        var css = 'ion-' + iconName;
        if (this._css === css) {
            return;
        }
        if (this._css) {
            this.setElementClass(this._css, false);
        }
        this._css = css;
        this.setElementClass(css, true);
        var label = iconName
            .replace('ios-', '')
            .replace('md-', '')
            .replace('-', ' ');
        this.setElementAttribute('aria-label', label);
    };
    Icon.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'ion-icon',
                    host: {
                        'role': 'img'
                    }
                },] },
    ];
    /** @nocollapse */
    Icon.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_2__config_config__["a" /* Config */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    ]; };
    Icon.propDecorators = {
        'name': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'ios': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'md': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'isActive': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        '_hidden': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostBinding"], args: ['class.hide',] },],
    };
    return Icon;
}(__WEBPACK_IMPORTED_MODULE_3__ion__["a" /* Ion */]));

//# sourceMappingURL=icon.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/img/img.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Img; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__content_content__ = __webpack_require__("./node_modules/ionic-angular/components/content/content.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__platform_dom_controller__ = __webpack_require__("./node_modules/ionic-angular/platform/dom-controller.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__platform_platform__ = __webpack_require__("./node_modules/ionic-angular/platform/platform.js");





/**
 * @name Img
 * @description
 * Two of the biggest cuprits of scroll jank is starting up a new HTTP
 * request, and rendering images. These two reasons is largely why
 * `ion-img` was created. The standard HTML `img` element is often a large
 * source of these problems, and what makes matters worse is that the app
 * does not have fine-grained control of requests and rendering for each
 * `img` element.
 *
 * The `ion-img` component is similar to the standard `img` element,
 * but it also adds features in order to provide improved performance.
 * Features include only loading images which are visible, using web workers
 * for HTTP requests, preventing jank while scrolling and in-memory caching.
 *
 * Note that `ion-img` also comes with a few more restrictions in comparison
 * to the standard `img` element. A good rule is, if there are only a few
 * images to be rendered on a page, then the standard `img` is probably
 * best. However, if a page has the potential for hundreds or even thousands
 * of images within a scrollable area, then `ion-img` would be better suited
 * for the job.
 *
 * > Note: `ion-img` is only meant to be used inside of [virtual-scroll](/docs/api/components/virtual-scroll/VirtualScroll/)
 *
 *
 * ### Lazy Loading
 *
 * Lazy loading images refers to only loading images which are actually
 * visible within the user's viewport. This also means that images which are
 * not viewable on the initial load would not be downloaded or rendered. Next,
 * as the user scrolls, each image which becomes visible is then requested
 * then rendered on-demand.
 *
 * The benefits of this approach is that unnecessary and resource intensive
 * HTTP requests are not started, valuable bandwidth isn't wasted, and this
 * allows the browser to free up resources which would be wasted on images
 * which are not even viewable. For example, animated GIFs are enourmous
 * performance drains, however, with `ion-img` the app is able to dedicate
 * resources to just the viewable images. But again, if the problems listed
 * above are not problems within your app, then the standard `img` element
 * may be best.
 *
 *
 * ### Image Dimensions
 *
 * By providing image dimensions up front, Ionic is able to accurately size
 * up the image's location within the viewport, which helps lazy load only
 * images which are viewable. Image dimensions can either by set as
 * properties, inline styles, or external stylesheets. It doesn't matter
 * which method of setting dimensions is used, but it's important that somehow
 * each `ion-img` has been given an exact size.
 *
 * For example, by default `<ion-avatar>` and `<ion-thumbnail>` already come
 * with exact sizes when placed within an `<ion-item>`. By giving each image
 * an exact size, this then further locks in the size of each `ion-item`,
 * which again helps improve scroll performance.
 *
 * ```html
 * <!-- dimensions set using attributes -->
 * <ion-img width="80" height="80" src="..."></ion-img>
 *
 * <!-- dimensions set using input properties -->
 * <ion-img [width]="imgWidth" [height]="imgHeight" src="..."></ion-img>
 *
 * <!-- dimensions set using inline styles -->
 * <ion-img style="width: 80px; height: 80px;" src="..."></ion-img>
 * ```
 *
 * Additionally, each `ion-img` uses the `object-fit: cover` CSS property.
 * What this means is that the actual rendered image will center itself within
 * it's container. Or to really get detailed: The image is sized to maintain
 * its aspect ratio while filling the containing element’s entire content box.
 * Its concrete object size is resolved as a cover constraint against the
 * element’s used width and height.
 *
 * ### Future Optimizations
 *
 * Future goals are to place image requests within web workers, and cache
 * images in-memory as datauris. This method has proven to be effective,
 * however there are some current limitations with Cordova which we are
 * currently working on.
 *
 */
var Img = (function () {
    function Img(_elementRef, _renderer, _plt, _content, _dom) {
        this._elementRef = _elementRef;
        this._renderer = _renderer;
        this._plt = _plt;
        this._content = _content;
        this._dom = _dom;
        /** @internal */
        this._cache = true;
        /** @internal */
        this._w = '';
        /** @internal */
        this._h = '';
        /** @internal */
        this._wQ = '';
        /** @internal */
        this._hQ = '';
        /**
         * @input {string}  Set the `alt` attribute which gets assigned to
         * the inner `img` element.
         */
        this.alt = '';
        if (!this._content) {
            console.warn("ion-img can only be used within an ion-content");
        }
        else {
            this._content.addImg(this);
        }
        this._isLoaded(false);
    }
    Object.defineProperty(Img.prototype, "src", {
        /**
         * @input {string} The source of the image.
         */
        get: function () {
            return this._src;
        },
        set: function (newSrc) {
            // if the source hasn't changed, then um, let's not change it
            if (newSrc !== this._src) {
                // we're changing the source
                // so abort any active http requests
                // and render the image empty
                this.reset();
                // update to the new src
                this._src = newSrc;
                // Are they using an actual datauri already,
                // or reset any existing datauri we might be holding onto
                this._hasLoaded = newSrc.indexOf('data:') === 0;
                // run update to kick off requests or render if everything is good
                this.update();
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @hidden
     */
    Img.prototype.reset = function () {
        if (this._requestingSrc) {
            // abort any active requests
            (void 0) /* console.debug */;
            this._srcAttr('');
            this._requestingSrc = null;
        }
        if (this._renderedSrc) {
            // clear out the currently rendered img
            (void 0) /* console.debug */;
            this._renderedSrc = null;
            this._isLoaded(false);
        }
    };
    /**
     * @hidden
     */
    Img.prototype.update = function () {
        var _this = this;
        // only attempt an update if there is an active src
        // and the content containing the image considers it updatable
        if (this._src && this._content.isImgsUpdatable()) {
            if (this.canRequest && (this._src !== this._renderedSrc && this._src !== this._requestingSrc) && !this._hasLoaded) {
                // only begin the request if we "can" request
                // begin the image request if the src is different from the rendered src
                // and if we don't already has a tmpDataUri
                (void 0) /* console.debug */;
                this._requestingSrc = this._src;
                this._isLoaded(false);
                this._srcAttr(this._src);
                // set the dimensions of the image if we do have different data
                this._setDims();
            }
            if (this.canRender && this._hasLoaded && this._src !== this._renderedSrc) {
                // we can render and we have a datauri to render
                this._renderedSrc = this._src;
                this._setDims();
                this._dom.write(function () {
                    if (_this._hasLoaded) {
                        (void 0) /* console.debug */;
                        _this._isLoaded(true);
                        _this._srcAttr(_this._src);
                    }
                });
            }
        }
    };
    /**
     * @internal
     */
    Img.prototype._isLoaded = function (isLoaded) {
        var renderer = this._renderer;
        var ele = this._elementRef.nativeElement;
        renderer.setElementClass(ele, 'img-loaded', isLoaded);
        renderer.setElementClass(ele, 'img-unloaded', !isLoaded);
    };
    /**
     * @internal
     */
    Img.prototype._srcAttr = function (srcAttr) {
        var imgEle = this._img;
        var renderer = this._renderer;
        if (imgEle && imgEle.src !== srcAttr) {
            renderer.setElementAttribute(this._img, 'src', srcAttr);
            renderer.setElementAttribute(this._img, 'alt', this.alt);
        }
    };
    Object.defineProperty(Img.prototype, "top", {
        /**
         * @hidden
         */
        get: function () {
            var bounds = this._getBounds();
            return bounds && bounds.top || 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Img.prototype, "bottom", {
        /**
         * @hidden
         */
        get: function () {
            var bounds = this._getBounds();
            return bounds && bounds.bottom || 0;
        },
        enumerable: true,
        configurable: true
    });
    Img.prototype._getBounds = function () {
        if (this._bounds) {
            // we've been manually passed bounds data
            // this is probably from Virtual Scroll items
            return this._bounds;
        }
        if (!this._rect) {
            // we don't have bounds from virtual scroll
            // so let's do the raw DOM lookup w/ getBoundingClientRect
            this._rect = this._elementRef.nativeElement.getBoundingClientRect();
            (void 0) /* console.debug */;
        }
        return this._rect;
    };
    Object.defineProperty(Img.prototype, "bounds", {
        /**
         * @input {any}  Sets the bounding rectangle of the element relative to the viewport.
         * When using `VirtualScroll`, each virtual item should pass its bounds to each
         * `ion-img`. The passed in data object should include `top` and `bottom` properties.
         */
        set: function (b) {
            if (Object(__WEBPACK_IMPORTED_MODULE_3__util_util__["l" /* isPresent */])(b)) {
                this._bounds = b;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Img.prototype, "cache", {
        /**
         * @input {boolean}  After an image has been successfully downloaded, it can be cached
         * in-memory. This is useful for `VirtualScroll` by allowing image responses to be
         * cached, and not rendered, until after scrolling has completed, which allows for
         * smoother scrolling.
         */
        get: function () {
            return this._cache;
        },
        set: function (val) {
            this._cache = Object(__WEBPACK_IMPORTED_MODULE_3__util_util__["o" /* isTrueProperty */])(val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Img.prototype, "width", {
        /**
         * @input {string}  Image width. If this property is not set it's important that
         * the dimensions are still set using CSS. If the dimension is just a number it
         * will assume the `px` unit.
         */
        set: function (val) {
            this._wQ = getUnitValue(val);
            this._setDims();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Img.prototype, "height", {
        /**
         * @input {string}  Image height. If this property is not set it's important that
         * the dimensions are still set using CSS. If the dimension is just a number it
         * will assume the `px` unit.
         */
        set: function (val) {
            this._hQ = getUnitValue(val);
            this._setDims();
        },
        enumerable: true,
        configurable: true
    });
    Img.prototype._setDims = function () {
        var _this = this;
        // only set the dimensions if we can render
        // and only if the dimensions have changed from when we last set it
        if (this.canRender && (this._w !== this._wQ || this._h !== this._hQ)) {
            var wrapperEle = this._elementRef.nativeElement;
            var renderer = this._renderer;
            this._dom.write(function () {
                if (_this._w !== _this._wQ) {
                    _this._w = _this._wQ;
                    renderer.setElementStyle(wrapperEle, 'width', _this._w);
                }
                if (_this._h !== _this._hQ) {
                    _this._h = _this._hQ;
                    renderer.setElementStyle(wrapperEle, 'height', _this._h);
                }
            });
        }
    };
    /**
     * @hidden
     */
    Img.prototype.ngAfterContentInit = function () {
        var _this = this;
        this._img = this._elementRef.nativeElement.firstChild;
        this._unreg = this._plt.registerListener(this._img, 'load', function () {
            _this._hasLoaded = true;
            _this.update();
        }, { passive: true });
    };
    /**
     * @hidden
     */
    Img.prototype.ngOnDestroy = function () {
        this._unreg && this._unreg();
        this._content && this._content.removeImg(this);
    };
    Img.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'ion-img',
                    template: '<img>',
                    changeDetection: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectionStrategy"].OnPush,
                    encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None,
                },] },
    ];
    /** @nocollapse */
    Img.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: __WEBPACK_IMPORTED_MODULE_4__platform_platform__["a" /* Platform */], },
        { type: __WEBPACK_IMPORTED_MODULE_1__content_content__["a" /* Content */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
        { type: __WEBPACK_IMPORTED_MODULE_2__platform_dom_controller__["a" /* DomController */], },
    ]; };
    Img.propDecorators = {
        'src': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'bounds': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'cache': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'width': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'height': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'alt': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return Img;
}());

function getUnitValue(val) {
    if (Object(__WEBPACK_IMPORTED_MODULE_3__util_util__["l" /* isPresent */])(val)) {
        if (typeof val === 'string') {
            if (val.indexOf('%') > -1 || val.indexOf('px') > -1) {
                return val;
            }
            if (val.length) {
                return val + 'px';
            }
        }
        else if (typeof val === 'number') {
            return val + 'px';
        }
    }
    return '';
}
//# sourceMappingURL=img.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/infinite-scroll/infinite-scroll-content.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InfiniteScrollContent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__infinite_scroll__ = __webpack_require__("./node_modules/ionic-angular/components/infinite-scroll/infinite-scroll.js");



/**
 * @hidden
 */
var InfiniteScrollContent = (function () {
    function InfiniteScrollContent(inf, _config) {
        this.inf = inf;
        this._config = _config;
    }
    /**
     * @hidden
     */
    InfiniteScrollContent.prototype.ngOnInit = function () {
        if (!this.loadingSpinner) {
            this.loadingSpinner = this._config.get('infiniteLoadingSpinner', this._config.get('spinner', 'ios'));
        }
    };
    InfiniteScrollContent.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'ion-infinite-scroll-content',
                    template: '<div class="infinite-loading">' +
                        '<div class="infinite-loading-spinner" *ngIf="loadingSpinner">' +
                        '<ion-spinner [name]="loadingSpinner"></ion-spinner>' +
                        '</div>' +
                        '<div class="infinite-loading-text" [innerHTML]="loadingText" *ngIf="loadingText"></div>' +
                        '</div>',
                    host: {
                        '[attr.state]': 'inf.state'
                    },
                    encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None,
                },] },
    ];
    /** @nocollapse */
    InfiniteScrollContent.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_2__infinite_scroll__["a" /* InfiniteScroll */], },
        { type: __WEBPACK_IMPORTED_MODULE_1__config_config__["a" /* Config */], },
    ]; };
    InfiniteScrollContent.propDecorators = {
        'loadingSpinner': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'loadingText': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return InfiniteScrollContent;
}());

//# sourceMappingURL=infinite-scroll-content.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/infinite-scroll/infinite-scroll.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InfiniteScroll; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__content_content__ = __webpack_require__("./node_modules/ionic-angular/components/content/content.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__platform_dom_controller__ = __webpack_require__("./node_modules/ionic-angular/platform/dom-controller.js");



/**
 * @name InfiniteScroll
 * @description
 * The Infinite Scroll allows you to perform an action when the user
 * scrolls a specified distance from the bottom or top of the page.
 *
 * The expression assigned to the `infinite` event is called when
 * the user scrolls to the specified distance. When this expression
 * has finished its tasks, it should call the `complete()` method
 * on the infinite scroll instance.
 *
 * @usage
 * ```html
 * <ion-content>
 *
 *  <ion-list>
 *    <ion-item *ngFor="let i of items">{% raw %}{{i}}{% endraw %}</ion-item>
 *  </ion-list>
 *
 *  <ion-infinite-scroll (ionInfinite)="doInfinite($event)">
 *    <ion-infinite-scroll-content></ion-infinite-scroll-content>
 *  </ion-infinite-scroll>
 *
 * </ion-content>
 * ```
 *
 * ```ts
 * @Component({...})
 * export class NewsFeedPage {
 *   items = [];
 *
 *   constructor() {
 *     for (let i = 0; i < 30; i++) {
 *       this.items.push( this.items.length );
 *     }
 *   }
 *
 *   doInfinite(infiniteScroll) {
 *     console.log('Begin async operation');
 *
 *     setTimeout(() => {
 *       for (let i = 0; i < 30; i++) {
 *         this.items.push( this.items.length );
 *       }
 *
 *       console.log('Async operation has ended');
 *       infiniteScroll.complete();
 *     }, 500);
 *   }
 *
 * }
 * ```
 *
 * ## `waitFor` method of InfiniteScroll
 *
 * In case if your async operation returns promise you can utilize
 * `waitFor` method inside your template.
 *
 * ```html
 * <ion-content>
 *
 *  <ion-list>
 *    <ion-item *ngFor="let item of items">{{item}}</ion-item>
 *  </ion-list>
 *
 *  <ion-infinite-scroll (ionInfinite)="$event.waitFor(doInfinite())">
 *    <ion-infinite-scroll-content></ion-infinite-scroll-content>
 *  </ion-infinite-scroll>
 *
 * </ion-content>
 * ```
 *
 * ```ts
 * @Component({...})
 * export class NewsFeedPage {
 *   items = [];
 *
 *   constructor() {
 *     for (var i = 0; i < 30; i++) {
 *       this.items.push( this.items.length );
 *     }
 *   }
 *
 *   doInfinite(): Promise<any> {
 *     console.log('Begin async operation');
 *
 *     return new Promise((resolve) => {
 *       setTimeout(() => {
 *         for (var i = 0; i < 30; i++) {
 *           this.items.push( this.items.length );
 *         }
 *
 *         console.log('Async operation has ended');
 *         resolve();
 *       }, 500);
 *     })
 *   }
 * }
 * ```
 *
 * ## Infinite Scroll Content
 *
 * By default, Ionic uses the infinite scroll spinner that looks
 * best for the platform the user is on. However, you can change the
 * default spinner or add text by adding properties to the
 * `ion-infinite-scroll-content` component.
 *
 *  ```html
 *  <ion-content>
 *
 *    <ion-infinite-scroll (ionInfinite)="doInfinite($event)">
 *      <ion-infinite-scroll-content
 *        loadingSpinner="bubbles"
 *        loadingText="Loading more data...">
 *      </ion-infinite-scroll-content>
 *    </ion-infinite-scroll>
 *
 *  </ion-content>
 *  ```
 *
 *
 * ## Further Customizing Infinite Scroll Content
 *
 * The `ion-infinite-scroll` component holds the infinite scroll logic.
 * It requires a child component in order to display the content.
 * Ionic uses `ion-infinite-scroll-content` by default. This component
 * displays the infinite scroll and changes the look depending
 * on the infinite scroll's state. Separating these components allows
 * developers to create their own infinite scroll content components.
 * You could replace our default content with custom SVG or CSS animations.
 *
 * @demo /docs/demos/src/infinite-scroll/
 *
 */
var InfiniteScroll = (function () {
    function InfiniteScroll(_content, _zone, _elementRef, _dom) {
        this._content = _content;
        this._zone = _zone;
        this._elementRef = _elementRef;
        this._dom = _dom;
        this._lastCheck = 0;
        this._highestY = 0;
        this._thr = '15%';
        this._thrPx = 0;
        this._thrPc = 0.15;
        this._position = POSITION_BOTTOM;
        this._init = false;
        /**
         * @internal
         */
        this.state = STATE_ENABLED;
        /**
         * @output {event} Emitted when the scroll reaches
         * the threshold distance. From within your infinite handler,
         * you must call the infinite scroll's `complete()` method when
         * your async operation has completed.
         */
        this.ionInfinite = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        _content.setElementClass('has-infinite-scroll', true);
    }
    Object.defineProperty(InfiniteScroll.prototype, "threshold", {
        /**
         * @input {string} The threshold distance from the bottom
         * of the content to call the `infinite` output event when scrolled.
         * The threshold value can be either a percent, or
         * in pixels. For example, use the value of `10%` for the `infinite`
         * output event to get called when the user has scrolled 10%
         * from the bottom of the page. Use the value `100px` when the
         * scroll is within 100 pixels from the bottom of the page.
         * Default is `15%`.
         */
        get: function () {
            return this._thr;
        },
        set: function (val) {
            this._thr = val;
            if (val.indexOf('%') > -1) {
                this._thrPx = 0;
                this._thrPc = (parseFloat(val) / 100);
            }
            else {
                this._thrPx = parseFloat(val);
                this._thrPc = 0;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfiniteScroll.prototype, "enabled", {
        /**
         * @input {boolean} If true, Whether or not the infinite scroll should be
         * enabled or not. Setting to `false` will remove scroll event listeners
         * and hide the display.
         */
        set: function (shouldEnable) {
            this.enable(shouldEnable);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfiniteScroll.prototype, "position", {
        /**
         * @input {string} The position of the infinite scroll element.
         * The value can be either `top` or `bottom`.
         * Default is `bottom`.
         */
        get: function () {
            return this._position;
        },
        set: function (val) {
            if (val === POSITION_TOP || val === POSITION_BOTTOM) {
                this._position = val;
            }
            else {
                console.error("Invalid value for ion-infinite-scroll's position input. Its value should be '" + POSITION_BOTTOM + "' or '" + POSITION_TOP + "'.");
            }
        },
        enumerable: true,
        configurable: true
    });
    InfiniteScroll.prototype._onScroll = function (ev) {
        var _this = this;
        if (this.state === STATE_LOADING || this.state === STATE_DISABLED) {
            return 1;
        }
        if (this._lastCheck + 32 > ev.timeStamp) {
            // no need to check less than every XXms
            return 2;
        }
        this._lastCheck = ev.timeStamp;
        // ******** DOM READ ****************
        var infiniteHeight = this._elementRef.nativeElement.scrollHeight;
        if (!infiniteHeight) {
            // if there is no height of this element then do nothing
            return 3;
        }
        // ******** DOM READ ****************
        var d = this._content.getContentDimensions();
        var height = d.contentHeight;
        var threshold = this._thrPc ? (height * this._thrPc) : this._thrPx;
        // ******** DOM READS ABOVE / DOM WRITES BELOW ****************
        var distanceFromInfinite;
        if (this._position === POSITION_BOTTOM) {
            distanceFromInfinite = d.scrollHeight - infiniteHeight - d.scrollTop - height - threshold;
        }
        else {
            (void 0) /* assert */;
            distanceFromInfinite = d.scrollTop - infiniteHeight - threshold;
        }
        if (distanceFromInfinite < 0) {
            // ******** DOM WRITE ****************
            this._dom.write(function () {
                _this._zone.run(function () {
                    if (_this.state !== STATE_LOADING && _this.state !== STATE_DISABLED) {
                        _this.state = STATE_LOADING;
                        _this.ionInfinite.emit(_this);
                    }
                });
            });
            return 5;
        }
        return 6;
    };
    /**
     * Call `complete()` within the `infinite` output event handler when
     * your async operation has completed. For example, the `loading`
     * state is while the app is performing an asynchronous operation,
     * such as receiving more data from an AJAX request to add more items
     * to a data list. Once the data has been received and UI updated, you
     * then call this method to signify that the loading has completed.
     * This method will change the infinite scroll's state from `loading`
     * to `enabled`.
     */
    InfiniteScroll.prototype.complete = function () {
        var _this = this;
        if (this.state !== STATE_LOADING) {
            return;
        }
        if (this._position === POSITION_BOTTOM) {
            this.state = STATE_ENABLED;
            return;
        }
        (void 0) /* assert */;
        /* New content is being added at the top, but the scrollTop position stays the same,
          which causes a scroll jump visually. This algorithm makes sure to prevent this.
    
          (Frame 1)
            complete() is called, but the UI hasn't had time to update yet.
            Save the current content dimensions.
            Wait for the next frame using _dom.read, so the UI will be updated.
    
          (Frame 2)
            Read the new content dimensions.
            Calculate the height difference and the new scroll position.
            Delay the scroll position change until other possible dom reads are done using _dom.write to be performant.
    
          (Still frame 2, if I'm correct)
            Change the scroll position (= visually maintain the scroll position).
            Change the state to re-enable the InfiniteScroll. This should be after changing the scroll position, or it could cause the InfiniteScroll to be triggered again immediately.
    
          (Frame 3)
            Done.
        */
        // ******** DOM READ ****************
        // Save the current content dimensions before the UI updates
        var prevDim = this._content.getContentDimensions();
        // ******** DOM READ ****************
        this._dom.read(function () {
            // UI has updated, save the new content dimensions
            var newDim = _this._content.getContentDimensions();
            // New content was added on top, so the scroll position should be changed immediately to prevent it from jumping around
            var newScrollTop = newDim.scrollHeight - (prevDim.scrollHeight - prevDim.scrollTop);
            // ******** DOM WRITE ****************
            _this._dom.write(function () {
                _this._content.scrollTop = newScrollTop;
                _this.state = STATE_ENABLED;
            });
        });
    };
    /**
    * Pass a promise inside `waitFor()` within the `infinite` output event handler in order to
    * change state of infiniteScroll to "complete"
    */
    InfiniteScroll.prototype.waitFor = function (action) {
        var enable = this.complete.bind(this);
        action.then(enable, enable);
    };
    /**
     * Call `enable(false)` to disable the infinite scroll from actively
     * trying to receive new data while scrolling. This method is useful
     * when it is known that there is no more data that can be added, and
     * the infinite scroll is no longer needed.
     * @param {boolean} shouldEnable  If the infinite scroll should be
     * enabled or not. Setting to `false` will remove scroll event listeners
     * and hide the display.
     */
    InfiniteScroll.prototype.enable = function (shouldEnable) {
        this.state = (shouldEnable ? STATE_ENABLED : STATE_DISABLED);
        this._setListeners(shouldEnable);
    };
    /**
     * @hidden
     */
    InfiniteScroll.prototype._setListeners = function (shouldListen) {
        if (this._init) {
            if (shouldListen) {
                if (!this._scLsn) {
                    this._scLsn = this._content.ionScroll.subscribe(this._onScroll.bind(this));
                }
            }
            else {
                this._scLsn && this._scLsn.unsubscribe();
                this._scLsn = null;
            }
        }
    };
    /**
     * @hidden
     */
    InfiniteScroll.prototype.ngAfterContentInit = function () {
        this._init = true;
        this._setListeners(this.state !== STATE_DISABLED);
        if (this._position === POSITION_TOP) {
            this._content.scrollDownOnLoad = true;
        }
    };
    /**
     * @hidden
     */
    InfiniteScroll.prototype.ngOnDestroy = function () {
        this._setListeners(false);
    };
    InfiniteScroll.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'ion-infinite-scroll'
                },] },
    ];
    /** @nocollapse */
    InfiniteScroll.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__content_content__["a" /* Content */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_2__platform_dom_controller__["a" /* DomController */], },
    ]; };
    InfiniteScroll.propDecorators = {
        'threshold': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'enabled': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'position': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'ionInfinite': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    };
    return InfiniteScroll;
}());

var STATE_ENABLED = 'enabled';
var STATE_DISABLED = 'disabled';
var STATE_LOADING = 'loading';
var POSITION_TOP = 'top';
var POSITION_BOTTOM = 'bottom';
//# sourceMappingURL=infinite-scroll.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/input/input.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TextInput; });
/* unused harmony export getScrollData */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__("./node_modules/@angular/forms/esm5/forms.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Subject__ = __webpack_require__("./node_modules/rxjs/Subject.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Subject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_Subject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_takeUntil__ = __webpack_require__("./node_modules/rxjs/add/operator/takeUntil.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_takeUntil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_takeUntil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_app__ = __webpack_require__("./node_modules/ionic-angular/components/app/app.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__content_content__ = __webpack_require__("./node_modules/ionic-angular/components/content/content.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_dom__ = __webpack_require__("./node_modules/ionic-angular/util/dom.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__platform_dom_controller__ = __webpack_require__("./node_modules/ionic-angular/platform/dom-controller.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_form__ = __webpack_require__("./node_modules/ionic-angular/util/form.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_base_input__ = __webpack_require__("./node_modules/ionic-angular/util/base-input.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__item_item__ = __webpack_require__("./node_modules/ionic-angular/components/item/item.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__platform_platform__ = __webpack_require__("./node_modules/ionic-angular/platform/platform.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();














/**
 * @name Input
 * @description
 *
 * `ion-input` is meant for text type inputs only, such as `text`,
 * `password`, `email`, `number`, `search`, `tel`, and `url`. Ionic
 * still uses an actual `<input type="text">` HTML element within the
 * component, however, with Ionic wrapping the native HTML input
 * element it's better able to handle the user experience and
 * interactivity.
 *
 * Similarly, `<ion-textarea>` should be used in place of `<textarea>`.
 *
 * An `ion-input` is **not** used for non-text type inputs, such as a
 * `checkbox`, `radio`, `toggle`, `range`, `select`, etc.
 *
 * Along with the blur/focus events, `input` support all standard text input
 * events like `keyup`, `keydown`, `keypress`, `input`, etc. Any standard event
 * can be attached and will function as expected. Example: `<ion-input (click)="someFunction()"></ion-input>`
 *
 * @usage
 * ```html
 * <ion-list>
 *   <ion-item>
 *     <ion-label color="primary">Inline Label</ion-label>
 *     <ion-input placeholder="Text Input"></ion-input>
 *   </ion-item>
 *
 *   <ion-item>
 *     <ion-label color="primary" fixed>Fixed Label</ion-label>
 *     <ion-input type="tel" placeholder="Tel Input"></ion-input>
 *   </ion-item>
 *
 *   <ion-item>
 *     <ion-input type="number" placeholder="Number Input with no label"></ion-input>
 *   </ion-item>
 *
 *   <ion-item>
 *     <ion-label color="primary" stacked>Stacked Label</ion-label>
 *     <ion-input type="email" placeholder="Email Input"></ion-input>
 *   </ion-item>
 *
 *   <ion-item>
 *     <ion-label color="primary" stacked>Stacked Label</ion-label>
 *     <ion-input type="password" placeholder="Password Input"></ion-input>
 *   </ion-item>
 *
 *   <ion-item>
 *     <ion-label color="primary" floating>Floating Label</ion-label>
 *     <ion-input></ion-input>
 *   </ion-item>
 *
 *   <ion-item>
 *     <ion-input placeholder="Clear Input" clearInput></ion-input>
 *   </ion-item>
 *
 *   <ion-item>
 *     <ion-textarea placeholder="Enter a description"></ion-textarea>
 *   </ion-item>
 * </ion-list>
 * ```
 *
 * @demo /docs/demos/src/input/
 */
var TextInput = (function (_super) {
    __extends(TextInput, _super);
    function TextInput(config, _plt, _form, _app, elementRef, renderer, _content, _item, ngControl, _dom) {
        var _this = _super.call(this, config, elementRef, renderer, 'input', '', _form, _item, ngControl) || this;
        _this._plt = _plt;
        _this._app = _app;
        _this._content = _content;
        _this.ngControl = ngControl;
        _this._dom = _dom;
        _this._clearInput = false;
        _this._readonly = false;
        _this._type = 'text';
        _this._isTextarea = false;
        _this._onDestroy = new __WEBPACK_IMPORTED_MODULE_2_rxjs_Subject__["Subject"]();
        _this._useAssist = false;
        _this._relocated = false;
        /**
         * @input {string} Set the input's autocomplete property. Values: `"on"`, `"off"`. Default `"off"`.
         */
        _this.autocomplete = '';
        /**
         * @input {string} Set the input's autocorrect property. Values: `"on"`, `"off"`. Default `"off"`.
         */
        _this.autocorrect = '';
        /**
         * @input {string} Instructional text that shows before the input has a value.
         */
        _this.placeholder = '';
        /**
         * @input {any} The minimum value, which must not be greater than its maximum (max attribute) value.
         */
        _this.min = null;
        /**
         * @input {any} The maximum value, which must not be less than its minimum (min attribute) value.
         */
        _this.max = null;
        /**
         * @input {any} Works with the min and max attributes to limit the increments at which a value can be set.
         */
        _this.step = null;
        /**
         * @hidden
         */
        _this.input = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
         * @hidden
         */
        _this.blur = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
         * @hidden
         */
        _this.focus = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        _this.autocomplete = config.get('autocomplete', 'off');
        _this.autocorrect = config.get('autocorrect', 'off');
        _this._autoFocusAssist = config.get('autoFocusAssist', 'delay');
        _this._keyboardHeight = config.getNumber('keyboardHeight');
        _this._isTextarea = !!(elementRef.nativeElement.tagName === 'ION-TEXTAREA');
        if (_this._isTextarea && _item) {
            _item.setElementClass('item-textarea', true);
        }
        // If not inside content, let's disable all the hacks
        if (!_content) {
            return _this;
        }
        var hideCaretOnScroll = config.getBoolean('hideCaretOnScroll', false);
        if (hideCaretOnScroll) {
            _this._enableHideCaretOnScroll();
        }
        var win = _plt.win();
        var keyboardPlugin = win.Ionic && win.Ionic.keyboardPlugin;
        if (keyboardPlugin) {
            var keyboardResizes = config.getBoolean('keyboardResizes', false);
            if (keyboardResizes) {
                _this._keyboardHeight = config.getNumber('keyboardSafeArea', 60);
                _this._enableScrollMove();
            }
            else {
                _this._enableScrollPadding();
                _this._enableScrollMove();
            }
        }
        else {
            _this._useAssist = config.getBoolean('scrollAssist', false);
            var usePadding = config.getBoolean('scrollPadding', _this._useAssist);
            if (usePadding) {
                _this._enableScrollPadding();
            }
        }
        return _this;
    }
    Object.defineProperty(TextInput.prototype, "clearInput", {
        /**
         * @input {boolean} If true, a clear icon will appear in the input when there is a value. Clicking it clears the input.
         */
        get: function () {
            return this._clearInput;
        },
        set: function (val) {
            this._clearInput = (!this._isTextarea && Object(__WEBPACK_IMPORTED_MODULE_11__util_util__["o" /* isTrueProperty */])(val));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextInput.prototype, "type", {
        /**
         * @input {string} The type of control to display. The default type is text.
         * Possible values are: `"text"`, `"password"`, `"email"`, `"number"`, `"search"`, `"tel"`, or `"url"`.
         */
        get: function () {
            return (this._isTextarea)
                ? 'text'
                : this._type;
        },
        set: function (val) {
            this._type = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextInput.prototype, "readonly", {
        /**
         * @input {boolean} If true, the user cannot modify the value.
         */
        get: function () {
            return this._readonly;
        },
        set: function (val) {
            this._readonly = Object(__WEBPACK_IMPORTED_MODULE_11__util_util__["o" /* isTrueProperty */])(val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextInput.prototype, "clearOnEdit", {
        /**
         * @input {boolean} If true, the value will be cleared after focus upon edit.
         * Defaults to `true` when `type` is `"password"`, `false` for all other types.
         */
        get: function () {
            return this._clearOnEdit;
        },
        set: function (val) {
            this._clearOnEdit = Object(__WEBPACK_IMPORTED_MODULE_11__util_util__["o" /* isTrueProperty */])(val);
        },
        enumerable: true,
        configurable: true
    });
    TextInput.prototype.ngAfterContentInit = function () { };
    /**
     * @hidden
     */
    TextInput.prototype.ngAfterViewInit = function () {
        (void 0) /* assert */;
        // By default, password inputs clear after focus when they have content
        if (this.clearOnEdit !== false && this.type === 'password') {
            this.clearOnEdit = true;
        }
        var ionInputEle = this._elementRef.nativeElement;
        var nativeInputEle = this._native.nativeElement;
        // Copy remaining attributes, not handled by ionic/angular
        Object(__WEBPACK_IMPORTED_MODULE_7__util_dom__["b" /* copyInputAttributes */])(ionInputEle, nativeInputEle);
        // prevent having tabIndex duplicated
        if (ionInputEle.hasAttribute('tabIndex')) {
            ionInputEle.removeAttribute('tabIndex');
        }
        // handle the autofocus attribute
        if (ionInputEle.hasAttribute('autofocus')) {
            ionInputEle.removeAttribute('autofocus');
            switch (this._autoFocusAssist) {
                case 'immediate':
                    // config says to immediate focus on the input
                    // works best on android devices
                    nativeInputEle.focus();
                    break;
                case 'delay':
                    // config says to chill out a bit and focus on the input after transitions
                    // works best on desktop
                    this._plt.timeout(function () { return nativeInputEle.focus(); }, 800);
                    break;
            }
            // traditionally iOS has big issues with autofocus on actual devices
            // autoFocus is disabled by default with the iOS mode config
        }
        // Initialize the input (can start emitting events)
        this._initialize();
        if (this.focus.observers.length > 0) {
            console.warn('(focus) is deprecated in ion-input, use (ionFocus) instead');
        }
        if (this.blur.observers.length > 0) {
            console.warn('(blur) is deprecated in ion-input, use (ionBlur) instead');
        }
    };
    /**
     * @hidden
     */
    TextInput.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        this._onDestroy.next();
        this._onDestroy = null;
    };
    /**
     * @hidden
     */
    TextInput.prototype.initFocus = function () {
        this.setFocus();
    };
    /**
     * @hidden
     */
    TextInput.prototype.setFocus = function () {
        // let's set focus to the element
        // but only if it does not already have focus
        if (!this.isFocus()) {
            this._native.nativeElement.focus();
        }
    };
    /**
     * @hidden
     */
    TextInput.prototype.setBlur = function () {
        if (this.isFocus()) {
            this._native.nativeElement.blur();
        }
    };
    /**
     * @hidden
     */
    TextInput.prototype.onInput = function (ev) {
        this.value = ev.target.value;
        // TODO: deprecate this
        this.input.emit(ev);
    };
    /**
     * @hidden
     */
    TextInput.prototype.onBlur = function (ev) {
        this._fireBlur();
        // TODO: deprecate this (06/07/2017)
        this.blur.emit(ev);
        this._scrollData = null;
        if (this._clearOnEdit && this.hasValue()) {
            this._didBlurAfterEdit = true;
        }
    };
    /**
     * @hidden
     */
    TextInput.prototype.onFocus = function (ev) {
        this._fireFocus();
        // TODO: deprecate this (06/07/2017)
        this.focus.emit(ev);
    };
    /**
     * @hidden
     */
    TextInput.prototype.onKeydown = function (ev) {
        if (ev && this._clearOnEdit) {
            this.checkClearOnEdit(ev.target.value);
        }
    };
    /**
     * @hidden
     */
    TextInput.prototype._inputUpdated = function () {
        _super.prototype._inputUpdated.call(this);
        var inputEle = this._native.nativeElement;
        var value = this._value;
        if (inputEle.value !== value) {
            inputEle.value = value;
        }
    };
    /**
     * @hidden
     */
    TextInput.prototype.clearTextInput = function () {
        this.value = '';
    };
    /**
    * Check if we need to clear the text input if clearOnEdit is enabled
    * @hidden
    */
    TextInput.prototype.checkClearOnEdit = function (_) {
        if (!this._clearOnEdit) {
            return;
        }
        // Did the input value change after it was blurred and edited?
        if (this._didBlurAfterEdit && this.hasValue()) {
            // Clear the input
            this.clearTextInput();
        }
        // Reset the flag
        this._didBlurAfterEdit = false;
    };
    TextInput.prototype._getScrollData = function () {
        if (!this._content) {
            return newScrollData();
        }
        // get container of this input, probably an ion-item a few nodes up
        if (this._scrollData) {
            return this._scrollData;
        }
        var ele = this._elementRef.nativeElement;
        ele = ele.closest('ion-item,[ion-item]') || ele;
        return this._scrollData = getScrollData(ele.offsetTop, ele.offsetHeight, this._content.getContentDimensions(), this._keyboardHeight, this._plt.height());
    };
    TextInput.prototype._relocateInput = function (shouldRelocate) {
        if (this._relocated === shouldRelocate) {
            return;
        }
        var platform = this._plt;
        var componentEle = this.getNativeElement();
        var focusedInputEle = this._native.nativeElement;
        (void 0) /* console.debug */;
        if (shouldRelocate) {
            // this allows for the actual input to receive the focus from
            // the user's touch event, but before it receives focus, it
            // moves the actual input to a location that will not screw
            // up the app's layout, and does not allow the native browser
            // to attempt to scroll the input into place (messing up headers/footers)
            // the cloned input fills the area of where native input should be
            // while the native input fakes out the browser by relocating itself
            // before it receives the actual focus event
            // We hide the focused input (with the visible caret) invisiable by making it scale(0),
            cloneInputComponent(platform, componentEle, focusedInputEle);
            var inputRelativeY = this._getScrollData().inputSafeY;
            // fix for #11817
            var tx = this._plt.isRTL ? 9999 : -9999;
            focusedInputEle.style[platform.Css.transform] = "translate3d(" + tx + "px," + inputRelativeY + "px,0)";
            focusedInputEle.style.opacity = '0';
        }
        else {
            removeClone(platform, componentEle, focusedInputEle);
        }
        this._relocated = shouldRelocate;
    };
    TextInput.prototype._enableScrollPadding = function () {
        var _this = this;
        (void 0) /* assert */;
        (void 0) /* console.debug */;
        this.ionFocus.subscribe(function () {
            var content = _this._content;
            var scrollPadding = _this._getScrollData().scrollPadding;
            content.addScrollPadding(scrollPadding);
            content.clearScrollPaddingFocusOut();
        });
    };
    TextInput.prototype._enableHideCaretOnScroll = function () {
        var _this = this;
        (void 0) /* assert */;
        var content = this._content;
        (void 0) /* console.debug */;
        content.ionScrollStart
            .takeUntil(this._onDestroy)
            .subscribe(function () { return scrollHideCaret(true); });
        content.ionScrollEnd
            .takeUntil(this._onDestroy)
            .subscribe(function () { return scrollHideCaret(false); });
        this.ionBlur.subscribe(function () { return _this._relocateInput(false); });
        var self = this;
        function scrollHideCaret(shouldHideCaret) {
            // if it does have focus, then do the dom write
            if (self.isFocus()) {
                self._dom.write(function () { return self._relocateInput(shouldHideCaret); });
            }
        }
    };
    TextInput.prototype._enableScrollMove = function () {
        var _this = this;
        (void 0) /* assert */;
        (void 0) /* console.debug */;
        this.ionFocus.subscribe(function () {
            var scrollData = _this._getScrollData();
            if (Math.abs(scrollData.scrollAmount) > 4) {
                _this._content.scrollTo(0, scrollData.scrollTo, scrollData.scrollDuration);
            }
        });
    };
    TextInput.prototype._pointerStart = function (ev) {
        (void 0) /* assert */;
        // input cover touchstart
        if (ev.type === 'touchstart') {
            this._isTouch = true;
        }
        if ((this._isTouch || (!this._isTouch && ev.type === 'mousedown')) && this._app.isEnabled()) {
            // remember where the touchstart/mousedown started
            this._coord = Object(__WEBPACK_IMPORTED_MODULE_7__util_dom__["f" /* pointerCoord */])(ev);
        }
        (void 0) /* console.debug */;
    };
    TextInput.prototype._pointerEnd = function (ev) {
        (void 0) /* assert */;
        // input cover touchend/mouseup
        (void 0) /* console.debug */;
        if ((this._isTouch && ev.type === 'mouseup') || !this._app.isEnabled()) {
            // the app is actively doing something right now
            // don't try to scroll in the input
            ev.preventDefault();
            ev.stopPropagation();
        }
        else if (this._coord) {
            // get where the touchend/mouseup ended
            var endCoord = Object(__WEBPACK_IMPORTED_MODULE_7__util_dom__["f" /* pointerCoord */])(ev);
            // focus this input if the pointer hasn't moved XX pixels
            // and the input doesn't already have focus
            if (!Object(__WEBPACK_IMPORTED_MODULE_7__util_dom__["d" /* hasPointerMoved */])(8, this._coord, endCoord) && !this.isFocus()) {
                ev.preventDefault();
                ev.stopPropagation();
                // begin the input focus process
                this._jsSetFocus();
            }
        }
        this._coord = null;
    };
    TextInput.prototype._jsSetFocus = function () {
        var _this = this;
        (void 0) /* assert */;
        // begin the process of setting focus to the inner input element
        var content = this._content;
        (void 0) /* console.debug */;
        if (!content) {
            // not inside of a scroll view, just focus it
            this.setFocus();
        }
        var scrollData = this._getScrollData();
        if (Math.abs(scrollData.scrollAmount) < 4) {
            // the text input is in a safe position that doesn't
            // require it to be scrolled into view, just set focus now
            this.setFocus();
            return;
        }
        // temporarily move the focus to the focus holder so the browser
        // doesn't freak out while it's trying to get the input in place
        // at this point the native text input still does not have focus
        this._relocateInput(true);
        this.setFocus();
        // scroll the input into place
        content.scrollTo(0, scrollData.scrollTo, scrollData.scrollDuration, function () {
            // the scroll view is in the correct position now
            // give the native text input focus
            _this._relocateInput(false);
            // ensure this is the focused input
            _this.setFocus();
        });
    };
    TextInput.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'ion-input,ion-textarea',
                    template: '<input #textInput *ngIf="!_isTextarea" class="text-input" ' +
                        '[ngClass]="\'text-input-\' + _mode"' +
                        '(input)="onInput($event)" ' +
                        '(blur)="onBlur($event)" ' +
                        '(focus)="onFocus($event)" ' +
                        '(keydown)="onKeydown($event)" ' +
                        '[type]="_type" ' +
                        'dir="auto" ' +
                        '[attr.aria-labelledby]="_labelId" ' +
                        '[attr.min]="min" ' +
                        '[attr.max]="max" ' +
                        '[attr.step]="step" ' +
                        '[attr.autocomplete]="autocomplete" ' +
                        '[attr.autocorrect]="autocorrect" ' +
                        '[placeholder]="placeholder" ' +
                        '[disabled]="_disabled" ' +
                        '[readonly]="_readonly">' +
                        '<textarea #textInput *ngIf="_isTextarea" class="text-input" ' +
                        '[ngClass]="\'text-input-\' + _mode"' +
                        '(input)="onInput($event)" ' +
                        '(blur)="onBlur($event)" ' +
                        '(focus)="onFocus($event)" ' +
                        '(keydown)="onKeydown($event)" ' +
                        '[attr.aria-labelledby]="_labelId" ' +
                        '[attr.autocomplete]="autocomplete" ' +
                        '[attr.autocorrect]="autocorrect" ' +
                        '[placeholder]="placeholder" ' +
                        '[disabled]="_disabled" ' +
                        '[readonly]="_readonly"></textarea>' +
                        '<button ion-button *ngIf="_clearInput" clear class="text-input-clear-icon" ' +
                        'type="button" ' +
                        '(click)="clearTextInput($event)" ' +
                        '(mousedown)="clearTextInput($event)" ' +
                        'tabindex="-1"></button>' +
                        '<div class="input-cover" *ngIf="_useAssist" ' +
                        '(touchstart)="_pointerStart($event)" ' +
                        '(touchend)="_pointerEnd($event)" ' +
                        '(mousedown)="_pointerStart($event)" ' +
                        '(mouseup)="_pointerEnd($event)"></div>',
                    encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None,
                    changeDetection: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectionStrategy"].OnPush,
                    inputs: ['value']
                },] },
    ];
    /** @nocollapse */
    TextInput.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_5__config_config__["a" /* Config */], },
        { type: __WEBPACK_IMPORTED_MODULE_13__platform_platform__["a" /* Platform */], },
        { type: __WEBPACK_IMPORTED_MODULE_9__util_form__["a" /* Form */], },
        { type: __WEBPACK_IMPORTED_MODULE_4__app_app__["a" /* App */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: __WEBPACK_IMPORTED_MODULE_6__content_content__["a" /* Content */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
        { type: __WEBPACK_IMPORTED_MODULE_12__item_item__["a" /* Item */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_forms__["NgControl"], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
        { type: __WEBPACK_IMPORTED_MODULE_8__platform_dom_controller__["a" /* DomController */], },
    ]; };
    TextInput.propDecorators = {
        'clearInput': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'type': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'readonly': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'clearOnEdit': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        '_native': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"], args: ['textInput', { read: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"] },] },],
        'autocomplete': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'autocorrect': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'placeholder': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'min': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'max': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'step': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'input': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        'blur': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        'focus': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    };
    return TextInput;
}(__WEBPACK_IMPORTED_MODULE_10__util_base_input__["a" /* BaseInput */]));

/**
 * @name TextArea
 * @description
 *
 * `ion-textarea` is used for multi-line text inputs. Ionic still
 * uses an actual `<textarea>` HTML element within the component;
 * however, with Ionic wrapping the native HTML text area element, Ionic
 * is able to better handle the user experience and interactivity.
 *
 * Note that `<ion-textarea>` must load its value from the `value` or
 * `[(ngModel)]` attribute. Unlike the native `<textarea>` element,
 * `<ion-textarea>` does not support loading its value from the
 * textarea's inner content.
 *
 * When requiring only a single-line text input, we recommend using
 * `<ion-input>` instead.
 *
 * @usage
 * ```html
 *  <ion-item>
 *    <ion-label>Comments</ion-label>
 *    <ion-textarea></ion-textarea>
 *  </ion-item>
 *
 *  <ion-item>
 *    <ion-label stacked>Message</ion-label>
 *    <ion-textarea [(ngModel)]="msg"></ion-textarea>
 *  </ion-item>
 *
 *  <ion-item>
 *    <ion-label floating>Description</ion-label>
 *    <ion-textarea></ion-textarea>
 *  </ion-item>
 *
 * <ion-item>
 *    <ion-label>Long Description</ion-label>
 *    <ion-textarea rows="6" placeholder="enter long description here..."></ion-textarea>
 *  </ion-item>
 * ```
 *
 * @demo /docs/demos/src/textarea/
 */
var SCROLL_ASSIST_SPEED = 0.3;
function newScrollData() {
    return {
        scrollAmount: 0,
        scrollTo: 0,
        scrollPadding: 0,
        scrollDuration: 0,
        inputSafeY: 0
    };
}
/**
 * @hidden
 */
function getScrollData(inputOffsetTop, inputOffsetHeight, scrollViewDimensions, keyboardHeight, plaformHeight) {
    // compute input's Y values relative to the body
    var inputTop = (inputOffsetTop + scrollViewDimensions.contentTop - scrollViewDimensions.scrollTop);
    var inputBottom = (inputTop + inputOffsetHeight);
    // compute the safe area which is the viewable content area when the soft keyboard is up
    var safeAreaTop = scrollViewDimensions.contentTop;
    var safeAreaHeight = (plaformHeight - keyboardHeight - safeAreaTop) / 2;
    var safeAreaBottom = safeAreaTop + safeAreaHeight;
    // figure out if each edge of teh input is within the safe area
    var inputTopWithinSafeArea = (inputTop >= safeAreaTop && inputTop <= safeAreaBottom);
    var inputTopAboveSafeArea = (inputTop < safeAreaTop);
    var inputTopBelowSafeArea = (inputTop > safeAreaBottom);
    var inputBottomWithinSafeArea = (inputBottom >= safeAreaTop && inputBottom <= safeAreaBottom);
    var inputBottomBelowSafeArea = (inputBottom > safeAreaBottom);
    /*
    Text Input Scroll To Scenarios
    ---------------------------------------
    1) Input top within safe area, bottom within safe area
    2) Input top within safe area, bottom below safe area, room to scroll
    3) Input top above safe area, bottom within safe area, room to scroll
    4) Input top below safe area, no room to scroll, input smaller than safe area
    5) Input top within safe area, bottom below safe area, no room to scroll, input smaller than safe area
    6) Input top within safe area, bottom below safe area, no room to scroll, input larger than safe area
    7) Input top below safe area, no room to scroll, input larger than safe area
    */
    var scrollData = newScrollData();
    // when auto-scrolling, there also needs to be enough
    // content padding at the bottom of the scroll view
    // always add scroll padding when a text input has focus
    // this allows for the content to scroll above of the keyboard
    // content behind the keyboard would be blank
    // some cases may not need it, but when jumping around it's best
    // to have the padding already rendered so there's no jank
    scrollData.scrollPadding = keyboardHeight;
    if (inputTopWithinSafeArea && inputBottomWithinSafeArea) {
        // Input top within safe area, bottom within safe area
        // no need to scroll to a position, it's good as-is
        return scrollData;
    }
    // looks like we'll have to do some auto-scrolling
    if (inputTopBelowSafeArea || inputBottomBelowSafeArea || inputTopAboveSafeArea) {
        // Input top or bottom below safe area
        // auto scroll the input up so at least the top of it shows
        if (safeAreaHeight > inputOffsetHeight) {
            // safe area height is taller than the input height, so we
            // can bring up the input just enough to show the input bottom
            scrollData.scrollAmount = Math.round(safeAreaBottom - inputBottom);
        }
        else {
            // safe area height is smaller than the input height, so we can
            // only scroll it up so the input top is at the top of the safe area
            // however the input bottom will be below the safe area
            scrollData.scrollAmount = Math.round(safeAreaTop - inputTop);
        }
        scrollData.inputSafeY = -(inputTop - safeAreaTop) + 4;
        if (inputTopAboveSafeArea && scrollData.scrollAmount > inputOffsetHeight) {
            // the input top is above the safe area and we're already scrolling it into place
            // don't let it scroll more than the height of the input
            scrollData.scrollAmount = inputOffsetHeight;
        }
    }
    // figure out where it should scroll to for the best position to the input
    scrollData.scrollTo = (scrollViewDimensions.scrollTop - scrollData.scrollAmount);
    // calculate animation duration
    var distance = Math.abs(scrollData.scrollAmount);
    var duration = distance / SCROLL_ASSIST_SPEED;
    scrollData.scrollDuration = Math.min(400, Math.max(150, duration));
    return scrollData;
}
function cloneInputComponent(plt, srcComponentEle, srcNativeInputEle) {
    // Make sure we kill all the clones before creating new ones
    // It is a defensive, removeClone() should do nothing
    // removeClone(plt, srcComponentEle, srcNativeInputEle);
    (void 0) /* assert */;
    // given a native <input> or <textarea> element
    // find its parent wrapping component like <ion-input> or <ion-textarea>
    // then clone the entire component
    if (srcComponentEle) {
        // DOM READ
        var srcTop = srcComponentEle.offsetTop;
        var srcLeft = srcComponentEle.offsetLeft;
        var srcWidth = srcComponentEle.offsetWidth;
        var srcHeight = srcComponentEle.offsetHeight;
        // DOM WRITE
        // not using deep clone so we don't pull in unnecessary nodes
        var clonedComponentEle = srcComponentEle.cloneNode(false);
        var clonedStyle = clonedComponentEle.style;
        clonedComponentEle.classList.add('cloned-input');
        clonedComponentEle.setAttribute('aria-hidden', 'true');
        clonedStyle.pointerEvents = 'none';
        clonedStyle.position = 'absolute';
        clonedStyle.top = srcTop + 'px';
        clonedStyle.left = srcLeft + 'px';
        clonedStyle.width = srcWidth + 'px';
        clonedStyle.height = srcHeight + 'px';
        var clonedNativeInputEle = srcNativeInputEle.cloneNode(false);
        clonedNativeInputEle.value = srcNativeInputEle.value;
        clonedNativeInputEle.tabIndex = -1;
        clonedComponentEle.appendChild(clonedNativeInputEle);
        srcComponentEle.parentNode.appendChild(clonedComponentEle);
        srcComponentEle.style.pointerEvents = 'none';
    }
    srcNativeInputEle.style[plt.Css.transform] = 'scale(0)';
}
function removeClone(plt, srcComponentEle, srcNativeInputEle) {
    if (srcComponentEle && srcComponentEle.parentElement) {
        var clonedInputEles = srcComponentEle.parentElement.querySelectorAll('.cloned-input');
        for (var i = 0; i < clonedInputEles.length; i++) {
            clonedInputEles[i].parentNode.removeChild(clonedInputEles[i]);
        }
        srcComponentEle.style.pointerEvents = '';
    }
    srcNativeInputEle.style[plt.Css.transform] = '';
    srcNativeInputEle.style.opacity = '';
}
//# sourceMappingURL=input.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/ion.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Ion; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");

/**
 * Base class for all Ionic components. Exposes some common functionality
 * that all Ionic components need, such as accessing underlying native elements and
 * sending/receiving app-level events.
 */
/** @hidden */
var Ion = (function () {
    function Ion(config, elementRef, renderer, componentName) {
        this._config = config;
        this._elementRef = elementRef;
        this._renderer = renderer;
        this._componentName = componentName;
        if (componentName) {
            this._setComponentName();
            this._setMode(config.get('mode'));
        }
    }
    Object.defineProperty(Ion.prototype, "color", {
        get: function () {
            return this._color;
        },
        /**
         * @input {string} The color to use from your Sass `$colors` map.
         * Default options are: `"primary"`, `"secondary"`, `"danger"`, `"light"`, and `"dark"`.
         * For more information, see [Theming your App](/docs/theming/theming-your-app).
         */
        set: function (val) {
            this._setColor(val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Ion.prototype, "mode", {
        get: function () {
            return this._mode;
        },
        /**
         * @input {string} The mode determines which platform styles to use.
         * Possible values are: `"ios"`, `"md"`, or `"wp"`.
         * For more information, see [Platform Styles](/docs/theming/platform-specific-styles).
         */
        set: function (val) {
            this._setMode(val);
        },
        enumerable: true,
        configurable: true
    });
    /** @hidden */
    Ion.prototype.setElementClass = function (className, isAdd) {
        this._renderer.setElementClass(this._elementRef.nativeElement, className, isAdd);
    };
    /** @hidden */
    Ion.prototype.setElementAttribute = function (attributeName, attributeValue) {
        this._renderer.setElementAttribute(this._elementRef.nativeElement, attributeName, attributeValue);
    };
    /** @hidden */
    Ion.prototype.setElementStyle = function (property, value) {
        this._renderer.setElementStyle(this._elementRef.nativeElement, property, value);
    };
    /** @hidden */
    Ion.prototype._setColor = function (newColor, componentName) {
        if (componentName) {
            // This is needed for the item-radio
            this._componentName = componentName;
        }
        if (this._color) {
            this.setElementClass(this._componentName + "-" + this._mode + "-" + this._color, false);
        }
        if (newColor) {
            this.setElementClass(this._componentName + "-" + this._mode + "-" + newColor, true);
            this._color = newColor;
        }
    };
    /** @hidden */
    Ion.prototype._setMode = function (newMode) {
        if (this._mode) {
            this.setElementClass(this._componentName + "-" + this._mode, false);
        }
        if (newMode) {
            this.setElementClass(this._componentName + "-" + newMode, true);
            // Remove the color class associated with the previous mode,
            // change the mode, then add the new color class
            this._setColor(null);
            this._mode = newMode;
            this._setColor(this._color);
        }
    };
    /** @hidden */
    Ion.prototype._setComponentName = function () {
        this.setElementClass(this._componentName, true);
    };
    /** @hidden */
    Ion.prototype.getElementRef = function () {
        return this._elementRef;
    };
    /** @hidden */
    Ion.prototype.getNativeElement = function () {
        return this._elementRef.nativeElement;
    };
    Ion.propDecorators = {
        'color': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'mode': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return Ion;
}());

//# sourceMappingURL=ion.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/item/item-content.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ItemContent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");

/**
 * @hidden
 */
var ItemContent = (function () {
    function ItemContent() {
    }
    ItemContent.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'ion-item,[ion-item]',
                    host: {
                        'class': 'item-block'
                    }
                },] },
    ];
    /** @nocollapse */
    ItemContent.ctorParameters = function () { return []; };
    return ItemContent;
}());

//# sourceMappingURL=item-content.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/item/item-divider.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ItemDivider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ion__ = __webpack_require__("./node_modules/ionic-angular/components/ion.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



/**
 * @hidden
 */
var ItemDivider = (function (_super) {
    __extends(ItemDivider, _super);
    function ItemDivider(config, elementRef, renderer) {
        return _super.call(this, config, elementRef, renderer, 'item-divider') || this;
    }
    ItemDivider.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'ion-item-divider',
                    host: {
                        'class': 'item-divider'
                    }
                },] },
    ];
    /** @nocollapse */
    ItemDivider.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__config_config__["a" /* Config */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    ]; };
    return ItemDivider;
}(__WEBPACK_IMPORTED_MODULE_2__ion__["a" /* Ion */]));

//# sourceMappingURL=item-divider.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/item/item-group.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ItemGroup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");

/**
  * @hidden
  */
var ItemGroup = (function () {
    function ItemGroup() {
    }
    ItemGroup.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'ion-item-group'
                },] },
    ];
    /** @nocollapse */
    ItemGroup.ctorParameters = function () { return []; };
    return ItemGroup;
}());

//# sourceMappingURL=item-group.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/item/item-options.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ItemOptions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__platform_platform__ = __webpack_require__("./node_modules/ionic-angular/platform/platform.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");



/**
 * @name ItemOptions
 * @description
 * The option buttons for an `ion-item-sliding`. These buttons can be placed either on the left or right side.
 * You can combine the `(ionSwipe)` event plus the `expandable` directive to create a full swipe action for the item.
 *
 * @usage
 *
 * ```html
 * <ion-item-sliding>
 *   <ion-item>
 *     Item 1
 *   </ion-item>
 *   <ion-item-options side="right" (ionSwipe)="saveItem(item)">
 *     <button ion-button expandable (click)="saveItem(item)">
 *       <ion-icon name="star"></ion-icon>
 *     </button>
 *   </ion-item-options>
 * </ion-item-sliding>
 *```
 */
var ItemOptions = (function () {
    function ItemOptions(_elementRef, _plt) {
        this._elementRef = _elementRef;
        this._plt = _plt;
        /**
         * @output {event} Emitted when the item has been fully swiped.
         */
        this.ionSwipe = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
    }
    /**
     * @hidden
     */
    ItemOptions.prototype.isRightSide = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_2__util_util__["m" /* isRightSide */])(this.side, this._plt.isRTL, true);
    };
    /**
     * @hidden
     */
    ItemOptions.prototype.width = function () {
        return this._elementRef.nativeElement.offsetWidth;
    };
    ItemOptions.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'ion-item-options',
                },] },
    ];
    /** @nocollapse */
    ItemOptions.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_1__platform_platform__["a" /* Platform */], },
    ]; };
    ItemOptions.propDecorators = {
        'side': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'ionSwipe': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    };
    return ItemOptions;
}());

//# sourceMappingURL=item-options.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/item/item-reorder-gesture.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ItemReorderGesture; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__item_reorder_util__ = __webpack_require__("./node_modules/ionic-angular/components/item/item-reorder-util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_dom__ = __webpack_require__("./node_modules/ionic-angular/util/dom.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gestures_ui_event_manager__ = __webpack_require__("./node_modules/ionic-angular/gestures/ui-event-manager.js");



/**
 * @hidden
 */
var ItemReorderGesture = (function () {
    function ItemReorderGesture(plt, reorderList) {
        this.plt = plt;
        this.reorderList = reorderList;
        this.selectedItemEle = null;
        this.events = new __WEBPACK_IMPORTED_MODULE_2__gestures_ui_event_manager__["a" /* UIEventManager */](plt);
        this.events.pointerEvents({
            element: this.reorderList.getNativeElement(),
            pointerDown: this.onDragStart.bind(this),
            pointerMove: this.onDragMove.bind(this),
            pointerUp: this.onDragEnd.bind(this),
            zone: false
        });
    }
    ItemReorderGesture.prototype.onDragStart = function (ev) {
        if (this.selectedItemEle) {
            return false;
        }
        var reorderElement = ev.target;
        if (reorderElement.nodeName !== 'ION-REORDER') {
            return false;
        }
        var reorderMark = reorderElement['$ionComponent'];
        if (!reorderMark) {
            console.error('ion-reorder does not contain $ionComponent');
            return false;
        }
        this.reorderList._reorderPrepare();
        var item = reorderMark.getReorderNode();
        if (!item) {
            console.error('reorder node not found');
            return false;
        }
        ev.preventDefault();
        // Preparing state
        this.selectedItemEle = item;
        this.selectedItemHeight = item.offsetHeight;
        this.lastYcoord = -100;
        this.lastToIndex = Object(__WEBPACK_IMPORTED_MODULE_0__item_reorder_util__["b" /* indexForItem */])(item);
        this.windowHeight = this.plt.height() - AUTO_SCROLL_MARGIN;
        this.lastScrollPosition = this.reorderList._scrollContent(0);
        this.offset = Object(__WEBPACK_IMPORTED_MODULE_1__util_dom__["f" /* pointerCoord */])(ev);
        this.offset.y += this.lastScrollPosition;
        item.classList.add(ITEM_REORDER_ACTIVE);
        this.reorderList._reorderStart();
        return true;
    };
    ItemReorderGesture.prototype.onDragMove = function (ev) {
        var selectedItem = this.selectedItemEle;
        if (!selectedItem) {
            return;
        }
        ev.preventDefault();
        // Get coordinate
        var coord = Object(__WEBPACK_IMPORTED_MODULE_1__util_dom__["f" /* pointerCoord */])(ev);
        var posY = coord.y;
        // Scroll if we reach the scroll margins
        var scrollPosition = this.scroll(posY);
        // Only perform hit test if we moved at least 30px from previous position
        if (Math.abs(posY - this.lastYcoord) > 30) {
            var overItem = this.itemForCoord(coord);
            if (overItem) {
                var toIndex = Object(__WEBPACK_IMPORTED_MODULE_0__item_reorder_util__["b" /* indexForItem */])(overItem);
                if (toIndex !== undefined && (toIndex !== this.lastToIndex || this.emptyZone)) {
                    var fromIndex = Object(__WEBPACK_IMPORTED_MODULE_0__item_reorder_util__["b" /* indexForItem */])(selectedItem);
                    this.lastToIndex = toIndex;
                    this.lastYcoord = posY;
                    this.emptyZone = false;
                    this.reorderList._reorderMove(fromIndex, toIndex, this.selectedItemHeight);
                }
            }
            else {
                this.emptyZone = true;
            }
        }
        // Update selected item position
        var ydiff = Math.round(posY - this.offset.y + scrollPosition);
        selectedItem.style[this.plt.Css.transform] = "translateY(" + ydiff + "px)";
    };
    ItemReorderGesture.prototype.onDragEnd = function (ev) {
        var _this = this;
        var selectedItem = this.selectedItemEle;
        if (!selectedItem) {
            return;
        }
        if (ev) {
            ev.preventDefault();
            ev.stopPropagation();
        }
        var toIndex = this.lastToIndex;
        var fromIndex = Object(__WEBPACK_IMPORTED_MODULE_0__item_reorder_util__["b" /* indexForItem */])(selectedItem);
        var reorderInactive = function () {
            _this.selectedItemEle.style.transition = '';
            _this.selectedItemEle.classList.remove(ITEM_REORDER_ACTIVE);
            _this.selectedItemEle = null;
        };
        if (toIndex === fromIndex) {
            selectedItem.style.transition = 'transform 200ms ease-in-out';
            setTimeout(reorderInactive, 200);
        }
        else {
            reorderInactive();
        }
        this.reorderList._reorderEmit(fromIndex, toIndex);
    };
    ItemReorderGesture.prototype.itemForCoord = function (coord) {
        var sideOffset = this.reorderList._isStart === this.plt.isRTL ? -100 : 100;
        var x = this.offset.x + sideOffset;
        var y = coord.y;
        var element = this.plt.getElementFromPoint(x, y);
        return Object(__WEBPACK_IMPORTED_MODULE_0__item_reorder_util__["a" /* findReorderItem */])(element, this.reorderList.getNativeElement());
    };
    ItemReorderGesture.prototype.scroll = function (posY) {
        if (posY < AUTO_SCROLL_MARGIN) {
            this.lastScrollPosition = this.reorderList._scrollContent(-SCROLL_JUMP);
        }
        else if (posY > this.windowHeight) {
            this.lastScrollPosition = this.reorderList._scrollContent(SCROLL_JUMP);
        }
        return this.lastScrollPosition;
    };
    /**
     * @hidden
     */
    ItemReorderGesture.prototype.destroy = function () {
        this.onDragEnd(null);
        this.events.destroy();
        this.events = null;
        this.reorderList = null;
    };
    return ItemReorderGesture;
}());

var AUTO_SCROLL_MARGIN = 60;
var SCROLL_JUMP = 10;
var ITEM_REORDER_ACTIVE = 'reorder-active';
//# sourceMappingURL=item-reorder-gesture.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/item/item-reorder-util.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = indexForItem;
/* unused harmony export reorderListForItem */
/* harmony export (immutable) */ __webpack_exports__["a"] = findReorderItem;
/**
 * @hidden
 */
function indexForItem(element) {
    return element['$ionIndex'];
}
/**
 * @hidden
 */
function reorderListForItem(element) {
    return element['$ionReorderList'];
}
/**
 * @hidden
 */
function findReorderItem(node, listNode) {
    var nested = 0;
    while (node && nested < 4) {
        if (indexForItem(node) !== undefined) {
            if (listNode && node.parentNode !== listNode) {
                return null;
            }
            return node;
        }
        node = node.parentNode;
        nested++;
    }
    return null;
}
//# sourceMappingURL=item-reorder-util.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/item/item-reorder.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ReorderIndexes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ItemReorder; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__content_content__ = __webpack_require__("./node_modules/ionic-angular/components/content/content.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__platform_dom_controller__ = __webpack_require__("./node_modules/ionic-angular/platform/dom-controller.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__item_reorder_gesture__ = __webpack_require__("./node_modules/ionic-angular/components/item/item-reorder-gesture.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__platform_platform__ = __webpack_require__("./node_modules/ionic-angular/platform/platform.js");






var ReorderIndexes = (function () {
    function ReorderIndexes(from, to) {
        this.from = from;
        this.to = to;
    }
    ReorderIndexes.prototype.applyTo = function (array) {
        Object(__WEBPACK_IMPORTED_MODULE_3__util_util__["s" /* reorderArray */])(array, this);
    };
    return ReorderIndexes;
}());

/**
 * @name ItemReorder
 * @description
 * Item reorder adds the ability to change an item's order in a group.
 * It can be used within an `ion-list` or `ion-item-group` to provide a
 * visual drag and drop interface.
 *
 * ## Grouping Items
 *
 * All reorderable items must be grouped in the same element. If an item
 * should not be reordered, it shouldn't be included in this group. For
 * example, the following code works because the items are grouped in the
 * `<ion-list>`:
 *
 *  ```html
 *  <ion-list reorder="true">
 *    <ion-item *ngFor="let item of items">{% raw %}{{ item }}{% endraw %}</ion-item>
 *  </ion-list>
 *  ```
 *
 * However, the below list includes a header that shouldn't be reordered:
 *
 *  ```html
 *  <ion-list reorder="true">
 *    <ion-list-header>Header</ion-list-header>
 *    <ion-item *ngFor="let item of items">{% raw %}{{ item }}{% endraw %}</ion-item>
 *  </ion-list>
 *  ```
 *
 * In order to mix different sets of items, `ion-item-group` should be used to
 * group the reorderable items:
 *
 *  ```html
 *  <ion-list>
 *    <ion-list-header>Header</ion-list-header>
 *    <ion-item-group reorder="true">
 *      <ion-item *ngFor="let item of items">{% raw %}{{ item }}{% endraw %}</ion-item>
 *    </ion-item-group>
 *  </ion-list>
 *  ```
 *
 * It's important to note that in this example, the `[reorder]` directive is applied to
 * the `<ion-item-group>` instead of the `<ion-list>`. This way makes it possible to
 * mix items that should and shouldn't be reordered.
 *
 *
 * ## Implementing the Reorder Function
 *
 * When the item is dragged and dropped into the new position, the `(ionItemReorder)` event is
 * emitted. This event provides the initial index (from) and the new index (to) of the reordered
 * item. For example, if the first item is dragged to the fifth position, the event will emit
 * `{from: 0, to: 4}`. Note that the index starts at zero.
 *
 * A function should be called when the event is emitted that handles the reordering of the items.
 * See [usage](#usage) below for some examples.
 *
 *
 * @usage
 *
 * ```html
 * <ion-list>
 *   <ion-list-header>Header</ion-list-header>
 *   <ion-item-group reorder="true" (ionItemReorder)="reorderItems($event)">
 *     <ion-item *ngFor="let item of items">{% raw %}{{ item }}{% endraw %}</ion-item>
 *   </ion-item-group>
 * </ion-list>
 * ```
 *
 * ```ts
 * class MyComponent {
 *   items = [];
 *
 *   constructor() {
 *     for (let x = 0; x < 5; x++) {
 *       this.items.push(x);
 *     }
 *   }
 *
 *   reorderItems(indexes) {
 *     let element = this.items[indexes.from];
 *     this.items.splice(indexes.from, 1);
 *     this.items.splice(indexes.to, 0, element);
 *   }
 * }
 * ```
 *
 * Ionic also provides a helper function called `reorderArray` to
 * reorder the array of items. This can be used instead:
 *
 * ```ts
 * import { reorderArray } from 'ionic-angular';
 *
 * class MyComponent {
 *   items = [];
 *
 *   constructor() {
 *     for (let x = 0; x < 5; x++) {
 *       this.items.push(x);
 *     }
 *   }
 *
 *   reorderItems(indexes) {
 *     this.items = reorderArray(this.items, indexes);
 *   }
 * }
 * ```
 * Alternatevely you can execute helper function inside template:
 *
 * ```html
 * <ion-list>
 *   <ion-list-header>Header</ion-list-header>
 *   <ion-item-group reorder="true" (ionItemReorder)="$event.applyTo(items)">
 *     <ion-item *ngFor="let item of items">{% raw %}{{ item }}{% endraw %}</ion-item>
 *   </ion-item-group>
 * </ion-list>
 * ```
 *
 * @demo /docs/demos/src/item-reorder/
 * @see {@link /docs/components#lists List Component Docs}
 * @see {@link ../../list/List List API Docs}
 * @see {@link ../Item Item API Docs}
 */
var ItemReorder = (function () {
    function ItemReorder(_plt, _dom, elementRef, _rendered, _zone, _content) {
        this._plt = _plt;
        this._dom = _dom;
        this._rendered = _rendered;
        this._zone = _zone;
        this._content = _content;
        this._enableReorder = false;
        this._visibleReorder = false;
        this._isStart = false;
        this._lastToIndex = -1;
        /**
         * @output {object} Emitted when the item is reordered. Emits an object
         * with `from` and `to` properties.
         */
        this.ionItemReorder = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this._element = elementRef.nativeElement;
    }
    Object.defineProperty(ItemReorder.prototype, "side", {
        /**
         * @input {string} Which side of the view the ion-reorder should be placed. Default `"end"`.
         */
        set: function (side) {
            this._isStart = side === 'start';
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @hidden
     */
    ItemReorder.prototype.ngOnDestroy = function () {
        this._element = null;
        this._reorderGesture && this._reorderGesture.destroy();
    };
    Object.defineProperty(ItemReorder.prototype, "reorder", {
        /**
         * @hidden
         */
        get: function () {
            return this._enableReorder;
        },
        set: function (val) {
            var _this = this;
            var enabled = Object(__WEBPACK_IMPORTED_MODULE_3__util_util__["o" /* isTrueProperty */])(val);
            if (!enabled && this._reorderGesture) {
                this._reorderGesture.destroy();
                this._reorderGesture = null;
                this._visibleReorder = false;
                setTimeout(function () { return _this._enableReorder = false; }, 400);
            }
            else if (enabled && !this._reorderGesture) {
                (void 0) /* console.debug */;
                this._reorderGesture = new __WEBPACK_IMPORTED_MODULE_4__item_reorder_gesture__["a" /* ItemReorderGesture */](this._plt, this);
                this._enableReorder = true;
                this._dom.write(function () {
                    _this._zone.run(function () {
                        _this._visibleReorder = true;
                    });
                }, 16);
            }
        },
        enumerable: true,
        configurable: true
    });
    ItemReorder.prototype._reorderPrepare = function () {
        var ele = this._element;
        var children = ele.children;
        for (var i = 0, ilen = children.length; i < ilen; i++) {
            var child = children[i];
            child.$ionIndex = i;
            child.$ionReorderList = ele;
        }
    };
    ItemReorder.prototype._reorderStart = function () {
        this.setElementClass('reorder-list-active', true);
    };
    ItemReorder.prototype._reorderEmit = function (fromIndex, toIndex) {
        var _this = this;
        this._reorderReset();
        if (fromIndex !== toIndex) {
            this._zone.run(function () {
                var indexes = new ReorderIndexes(fromIndex, toIndex);
                _this.ionItemReorder.emit(indexes);
            });
        }
    };
    ItemReorder.prototype._scrollContent = function (scroll) {
        var scrollTop = this._content.scrollTop + scroll;
        if (scroll !== 0) {
            this._content.scrollTo(0, scrollTop, 0);
        }
        return scrollTop;
    };
    ItemReorder.prototype._reorderReset = function () {
        var children = this._element.children;
        var len = children.length;
        this.setElementClass('reorder-list-active', false);
        var transform = this._plt.Css.transform;
        for (var i = 0; i < len; i++) {
            children[i].style[transform] = '';
        }
        this._lastToIndex = -1;
    };
    ItemReorder.prototype._reorderMove = function (fromIndex, toIndex, itemHeight) {
        if (this._lastToIndex === -1) {
            this._lastToIndex = fromIndex;
        }
        var lastToIndex = this._lastToIndex;
        this._lastToIndex = toIndex;
        // TODO: I think both loops can be merged into a single one
        // but I had no luck last time I tried
        /********* DOM READ ********** */
        var children = this._element.children;
        /********* DOM WRITE ********* */
        var transform = this._plt.Css.transform;
        if (toIndex >= lastToIndex) {
            for (var i = lastToIndex; i <= toIndex; i++) {
                if (i !== fromIndex) {
                    children[i].style[transform] = (i > fromIndex)
                        ? "translateY(" + -itemHeight + "px)" : '';
                }
            }
        }
        if (toIndex <= lastToIndex) {
            for (var i = toIndex; i <= lastToIndex; i++) {
                if (i !== fromIndex) {
                    children[i].style[transform] = (i < fromIndex)
                        ? "translateY(" + itemHeight + "px)" : '';
                }
            }
        }
    };
    /**
     * @hidden
     */
    ItemReorder.prototype.setElementClass = function (classname, add) {
        this._rendered.setElementClass(this._element, classname, add);
    };
    /**
     * @hidden
     */
    ItemReorder.prototype.getNativeElement = function () {
        return this._element;
    };
    ItemReorder.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'ion-list[reorder],ion-item-group[reorder]',
                    host: {
                        '[class.reorder-enabled]': '_enableReorder',
                        '[class.reorder-visible]': '_visibleReorder',
                        '[class.reorder-side-start]': '_isStart'
                    }
                },] },
    ];
    /** @nocollapse */
    ItemReorder.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_5__platform_platform__["a" /* Platform */], },
        { type: __WEBPACK_IMPORTED_MODULE_2__platform_dom_controller__["a" /* DomController */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"], },
        { type: __WEBPACK_IMPORTED_MODULE_1__content_content__["a" /* Content */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
    ]; };
    ItemReorder.propDecorators = {
        'ionItemReorder': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        'side': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['side',] },],
        'reorder': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return ItemReorder;
}());

//# sourceMappingURL=item-reorder.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/item/item-sliding-gesture.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ItemSlidingGesture; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gestures_gesture_controller__ = __webpack_require__("./node_modules/ionic-angular/gestures/gesture-controller.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gestures_pan_gesture__ = __webpack_require__("./node_modules/ionic-angular/gestures/pan-gesture.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_dom__ = __webpack_require__("./node_modules/ionic-angular/util/dom.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



/**
 * @hidden
 */
var ItemSlidingGesture = (function (_super) {
    __extends(ItemSlidingGesture, _super);
    function ItemSlidingGesture(plt, list, gestureCtrl, domCtrl) {
        var _this = _super.call(this, plt, list.getNativeElement(), {
            maxAngle: 20,
            threshold: 5,
            zone: false,
            domController: domCtrl,
            gesture: gestureCtrl.createGesture({
                name: __WEBPACK_IMPORTED_MODULE_0__gestures_gesture_controller__["d" /* GESTURE_ITEM_SWIPE */],
                priority: __WEBPACK_IMPORTED_MODULE_0__gestures_gesture_controller__["i" /* GESTURE_PRIORITY_SLIDING_ITEM */],
                disableScroll: true
            })
        }) || this;
        _this.list = list;
        _this.preSelectedContainer = null;
        _this.selectedContainer = null;
        _this.openContainer = null;
        return _this;
    }
    ItemSlidingGesture.prototype.canStart = function (ev) {
        if (this.selectedContainer) {
            return false;
        }
        // Get swiped sliding container
        var container = getContainer(ev);
        if (!container) {
            this.closeOpened();
            return false;
        }
        // Close open container if it is not the selected one.
        if (container !== this.openContainer) {
            this.closeOpened();
        }
        var coord = Object(__WEBPACK_IMPORTED_MODULE_2__util_dom__["f" /* pointerCoord */])(ev);
        this.preSelectedContainer = container;
        this.firstCoordX = coord.x;
        this.firstTimestamp = Date.now();
        return true;
    };
    ItemSlidingGesture.prototype.onDragStart = function (ev) {
        ev.preventDefault();
        var coord = Object(__WEBPACK_IMPORTED_MODULE_2__util_dom__["f" /* pointerCoord */])(ev);
        this.selectedContainer = this.openContainer = this.preSelectedContainer;
        this.selectedContainer.startSliding(coord.x);
    };
    ItemSlidingGesture.prototype.onDragMove = function (ev) {
        ev.preventDefault();
        this.selectedContainer.moveSliding(Object(__WEBPACK_IMPORTED_MODULE_2__util_dom__["f" /* pointerCoord */])(ev).x);
    };
    ItemSlidingGesture.prototype.onDragEnd = function (ev) {
        ev.preventDefault();
        var coordX = Object(__WEBPACK_IMPORTED_MODULE_2__util_dom__["f" /* pointerCoord */])(ev).x;
        var deltaX = (coordX - this.firstCoordX);
        var deltaT = (Date.now() - this.firstTimestamp);
        this.selectedContainer.endSliding(deltaX / deltaT);
        this.selectedContainer = null;
        this.preSelectedContainer = null;
    };
    ItemSlidingGesture.prototype.notCaptured = function (ev) {
        if (!clickedOptionButton(ev)) {
            this.closeOpened();
        }
    };
    ItemSlidingGesture.prototype.closeOpened = function () {
        this.selectedContainer = null;
        if (this.openContainer) {
            this.openContainer.close();
            this.openContainer = null;
            return true;
        }
        return false;
    };
    ItemSlidingGesture.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
        this.closeOpened();
        this.list = null;
        this.preSelectedContainer = null;
        this.selectedContainer = null;
        this.openContainer = null;
    };
    return ItemSlidingGesture;
}(__WEBPACK_IMPORTED_MODULE_1__gestures_pan_gesture__["a" /* PanGesture */]));

function getContainer(ev) {
    var ele = ev.target.closest('ion-item-sliding');
    if (ele) {
        return ele['$ionComponent'];
    }
    return null;
}
function clickedOptionButton(ev) {
    var ele = ev.target.closest('ion-item-options>button');
    return !!ele;
}
//# sourceMappingURL=item-sliding-gesture.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/item/item-sliding.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ItemSliding; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__item__ = __webpack_require__("./node_modules/ionic-angular/components/item/item.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__list_list__ = __webpack_require__("./node_modules/ionic-angular/components/list/list.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__platform_platform__ = __webpack_require__("./node_modules/ionic-angular/platform/platform.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__item_options__ = __webpack_require__("./node_modules/ionic-angular/components/item/item-options.js");






var SWIPE_MARGIN = 30;
var ELASTIC_FACTOR = 0.55;
var ITEM_SIDE_FLAG_NONE = 0;
var ITEM_SIDE_FLAG_LEFT = 1 << 0;
var ITEM_SIDE_FLAG_RIGHT = 1 << 1;
var ITEM_SIDE_FLAG_BOTH = ITEM_SIDE_FLAG_LEFT | ITEM_SIDE_FLAG_RIGHT;
/**
 * @name ItemSliding
 * @description
 * A sliding item is a list item that can be swiped to reveal buttons. It requires
 * an [Item](../Item) component as a child and a [List](../../list/List) component as
 * a parent. All buttons to reveal can be placed in the `<ion-item-options>` element.
 *
 * @usage
 * ```html
 * <ion-list>
 *   <ion-item-sliding #item>
 *     <ion-item>
 *       Item
 *     </ion-item>
 *     <ion-item-options side="left">
 *       <button ion-button (click)="favorite(item)">Favorite</button>
 *       <button ion-button color="danger" (click)="share(item)">Share</button>
 *     </ion-item-options>
 *
 *     <ion-item-options side="right">
 *       <button ion-button (click)="unread(item)">Unread</button>
 *     </ion-item-options>
 *   </ion-item-sliding>
 * </ion-list>
 * ```
 *
 * ### Swipe Direction
 * By default, the buttons are revealed when the sliding item is swiped from right to left,
 * so the buttons are placed in the right side. But it's also possible to reveal them
 * in the right side (sliding from left to right) by setting the `side` attribute
 * on the `ion-item-options` element. Up to 2 `ion-item-options` can used at the same time
 * in order to reveal two different sets of buttons depending the swipping direction.
 *
 * ```html
 * <ion-item-options side="right">
 *   <button ion-button (click)="archive(item)">
 *     <ion-icon name="archive"></ion-icon>
 *     Archive
 *   </button>
 * </ion-item-options>
 *
 * <ion-item-options side="left">
 *   <button ion-button (click)="archive(item)">
 *     <ion-icon name="archive"></ion-icon>
 *     Archive
 *   </button>
 * </ion-item-options>
 * ```
 *
 * ### Listening for events (ionDrag) and (ionSwipe)
 * It's possible to know the current relative position of the sliding item by subscribing
 * to the (ionDrag)` event.
 *
 * ```html
 * <ion-item-sliding (ionDrag)="logDrag($event)">
 *   <ion-item>Item</ion-item>
 *   <ion-item-options>
 *     <button ion-button>Favorite</button>
 *   </ion-item-options>
 * </ion-item-sliding>
 * ```
 *
 * ### Button Layout
 * If an icon is placed with text in the option button, by default it will
 * display the icon on top of the text. This can be changed to display the icon
 * to the left of the text by setting `icon-start` as an attribute on the
 * `<ion-item-options>` element.
 *
 * ```html
 * <ion-item-options icon-start>
 *    <button ion-button (click)="archive(item)">
 *      <ion-icon name="archive"></ion-icon>
 *      Archive
 *    </button>
 *  </ion-item-options>
 *
 * ```
 *
 * ### Expandable Options
 *
 * Options can be expanded to take up the full width of the item if you swipe past
 * a certain point. This can be combined with the `ionSwipe` event to call methods
 * on the class.
 *
 * ```html
 *
 * <ion-item-sliding>
 *   <ion-item>Item</ion-item>
 *   <ion-item-options (ionSwipe)="delete(item)">
 *     <button ion-button expandable (click)="delete(item)">Delete</button>
 *   </ion-item-options>
 * </ion-item-sliding>
 * ```
 *
 * We can call `delete` by either clicking the button, or by doing a full swipe on the item.
 *
 * @demo /docs/demos/src/item-sliding/
 * @see {@link /docs/components#lists List Component Docs}
 * @see {@link ../Item Item API Docs}
 * @see {@link ../../list/List List API Docs}
 */
var ItemSliding = (function () {
    function ItemSliding(list, _plt, _renderer, _elementRef, _zone) {
        this._plt = _plt;
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this._zone = _zone;
        this._openAmount = 0;
        this._startX = 0;
        this._optsWidthRightSide = 0;
        this._optsWidthLeftSide = 0;
        this._tmr = null;
        this._optsDirty = true;
        this._state = 2 /* Disabled */;
        /**
         * @output {event} Emitted when the sliding position changes.
         * It reports the relative position.
         *
         * ```ts
         * ondrag(item) {
         *   let percent = item.getSlidingPercent();
         *   if (percent > 0) {
         *     // positive
         *     console.log('right side');
         *   } else {
         *     // negative
         *     console.log('left side');
         *   }
         *   if (Math.abs(percent) > 1) {
         *     console.log('overscroll');
         *   }
         * }
         * ```
         *
         */
        this.ionDrag = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        list && list.containsSlidingItem(true);
        _elementRef.nativeElement.$ionComponent = this;
        this.setElementClass('item-wrapper', true);
    }
    Object.defineProperty(ItemSliding.prototype, "_itemOptions", {
        set: function (itemOptions) {
            var sides = 0;
            // Reset left and right options in case they were removed
            this._leftOptions = this._rightOptions = null;
            for (var _i = 0, _a = itemOptions.toArray(); _i < _a.length; _i++) {
                var item = _a[_i];
                if (item.isRightSide()) {
                    this._rightOptions = item;
                    sides |= ITEM_SIDE_FLAG_RIGHT;
                }
                else {
                    this._leftOptions = item;
                    sides |= ITEM_SIDE_FLAG_LEFT;
                }
            }
            this._optsDirty = true;
            this._sides = sides;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @hidden
     */
    ItemSliding.prototype.getOpenAmount = function () {
        return this._openAmount;
    };
    /**
     * @hidden
     */
    ItemSliding.prototype.getSlidingPercent = function () {
        var openAmount = this._openAmount;
        if (openAmount > 0) {
            return openAmount / this._optsWidthRightSide;
        }
        else if (openAmount < 0) {
            return openAmount / this._optsWidthLeftSide;
        }
        else {
            return 0;
        }
    };
    /**
     * @hidden
     */
    ItemSliding.prototype.startSliding = function (startX) {
        if (this._tmr) {
            this._plt.cancelTimeout(this._tmr);
            this._tmr = null;
        }
        if (this._openAmount === 0) {
            this._optsDirty = true;
            this._setState(4 /* Enabled */);
        }
        this._startX = startX + this._openAmount;
        this.item.setElementStyle(this._plt.Css.transition, 'none');
    };
    /**
     * @hidden
     */
    ItemSliding.prototype.moveSliding = function (x) {
        if (this._optsDirty) {
            this.calculateOptsWidth();
            return;
        }
        var openAmount = (this._startX - x);
        switch (this._sides) {
            case ITEM_SIDE_FLAG_RIGHT:
                openAmount = Math.max(0, openAmount);
                break;
            case ITEM_SIDE_FLAG_LEFT:
                openAmount = Math.min(0, openAmount);
                break;
            case ITEM_SIDE_FLAG_BOTH: break;
            case ITEM_SIDE_FLAG_NONE: return;
            default:
                (void 0) /* assert */;
                break;
        }
        if (openAmount > this._optsWidthRightSide) {
            var optsWidth = this._optsWidthRightSide;
            openAmount = optsWidth + (openAmount - optsWidth) * ELASTIC_FACTOR;
        }
        else if (openAmount < -this._optsWidthLeftSide) {
            var optsWidth = -this._optsWidthLeftSide;
            openAmount = optsWidth + (openAmount - optsWidth) * ELASTIC_FACTOR;
        }
        this._setOpenAmount(openAmount, false);
        return openAmount;
    };
    /**
     * @hidden
     */
    ItemSliding.prototype.endSliding = function (velocity) {
        var restingPoint = (this._openAmount > 0)
            ? this._optsWidthRightSide
            : -this._optsWidthLeftSide;
        // Check if the drag didn't clear the buttons mid-point
        // and we aren't moving fast enough to swipe open
        var isResetDirection = (this._openAmount > 0) === !(velocity < 0);
        var isMovingFast = Math.abs(velocity) > 0.3;
        var isOnCloseZone = Math.abs(this._openAmount) < Math.abs(restingPoint / 2);
        if (Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["u" /* swipeShouldReset */])(isResetDirection, isMovingFast, isOnCloseZone)) {
            restingPoint = 0;
        }
        this.fireSwipeEvent();
        this._setOpenAmount(restingPoint, true);
        return restingPoint;
    };
    /**
     * @hidden
     */
    ItemSliding.prototype.fireSwipeEvent = function () {
        var _this = this;
        if (this._state & 32 /* SwipeRight */) {
            this._zone.run(function () { return _this._rightOptions.ionSwipe.emit(_this); });
        }
        else if (this._state & 64 /* SwipeLeft */) {
            this._zone.run(function () { return _this._leftOptions.ionSwipe.emit(_this); });
        }
    };
    /**
     * @hidden
     */
    ItemSliding.prototype.calculateOptsWidth = function () {
        if (!this._optsDirty) {
            return;
        }
        this._optsWidthRightSide = 0;
        if (this._rightOptions) {
            this._optsWidthRightSide = this._rightOptions.width();
            (void 0) /* assert */;
        }
        this._optsWidthLeftSide = 0;
        if (this._leftOptions) {
            this._optsWidthLeftSide = this._leftOptions.width();
            (void 0) /* assert */;
        }
        this._optsDirty = false;
    };
    ItemSliding.prototype._setOpenAmount = function (openAmount, isFinal) {
        var _this = this;
        var platform = this._plt;
        if (this._tmr) {
            platform.cancelTimeout(this._tmr);
            this._tmr = null;
        }
        this._openAmount = openAmount;
        if (isFinal) {
            this.item.setElementStyle(platform.Css.transition, '');
        }
        if (openAmount > 0) {
            var state = (openAmount >= (this._optsWidthRightSide + SWIPE_MARGIN))
                ? 8 /* Right */ | 32 /* SwipeRight */
                : 8 /* Right */;
            this._setState(state);
        }
        else if (openAmount < 0) {
            var state_1 = (openAmount <= (-this._optsWidthLeftSide - SWIPE_MARGIN))
                ? 16 /* Left */ | 64 /* SwipeLeft */
                : 16 /* Left */;
            this._setState(state_1);
        }
        else {
            (void 0) /* assert */;
            this._tmr = platform.timeout(function () {
                _this._setState(2 /* Disabled */);
                _this._tmr = null;
            }, 600);
            this.item.setElementStyle(platform.Css.transform, '');
            return;
        }
        this.item.setElementStyle(platform.Css.transform, "translate3d(" + -openAmount + "px,0,0)");
        var ionDrag = this.ionDrag;
        if (ionDrag.observers.length > 0) {
            ionDrag.emit(this);
        }
    };
    ItemSliding.prototype._setState = function (state) {
        if (state === this._state) {
            return;
        }
        this.setElementClass('active-slide', (state !== 2 /* Disabled */));
        this.setElementClass('active-options-right', !!(state & 8 /* Right */));
        this.setElementClass('active-options-left', !!(state & 16 /* Left */));
        this.setElementClass('active-swipe-right', !!(state & 32 /* SwipeRight */));
        this.setElementClass('active-swipe-left', !!(state & 64 /* SwipeLeft */));
        this._state = state;
    };
    /**
     * Close the sliding item. Items can also be closed from the [List](../../list/List).
     *
     * The sliding item can be closed by grabbing a reference to `ItemSliding`. In the
     * below example, the template reference variable `slidingItem` is placed on the element
     * and passed to the `share` method.
     *
     * ```html
     * <ion-list>
     *   <ion-item-sliding #slidingItem>
     *     <ion-item>
     *       Item
     *     </ion-item>
     *     <ion-item-options>
     *       <button ion-button (click)="share(slidingItem)">Share</button>
     *     </ion-item-options>
     *   </ion-item-sliding>
     * </ion-list>
     * ```
     *
     * ```ts
     * import { Component } from '@angular/core';
     * import { ItemSliding } from 'ionic-angular';
     *
     * @Component({...})
     * export class MyClass {
     *   constructor() { }
     *
     *   share(slidingItem: ItemSliding) {
     *     slidingItem.close();
     *   }
     * }
     * ```
     */
    ItemSliding.prototype.close = function () {
        this._setOpenAmount(0, true);
    };
    /**
     * @hidden
     */
    ItemSliding.prototype.setElementClass = function (cssClass, shouldAdd) {
        this._renderer.setElementClass(this._elementRef.nativeElement, cssClass, shouldAdd);
    };
    ItemSliding.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'ion-item-sliding',
                    template: "\n    <ng-content select=\"ion-item,[ion-item]\"></ng-content>\n    <ng-content select=\"ion-item-options\"></ng-content>\n  ",
                    changeDetection: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectionStrategy"].OnPush,
                    encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None
                },] },
    ];
    /** @nocollapse */
    ItemSliding.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_3__list_list__["a" /* List */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
        { type: __WEBPACK_IMPORTED_MODULE_4__platform_platform__["a" /* Platform */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"], },
    ]; };
    ItemSliding.propDecorators = {
        'item': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChild"], args: [__WEBPACK_IMPORTED_MODULE_2__item__["a" /* Item */],] },],
        'ionDrag': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        '_itemOptions': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChildren"], args: [Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return __WEBPACK_IMPORTED_MODULE_5__item_options__["a" /* ItemOptions */]; }),] },],
    };
    return ItemSliding;
}());

//# sourceMappingURL=item-sliding.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/item/item.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Item; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__button_button__ = __webpack_require__("./node_modules/ionic-angular/components/button/button.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_form__ = __webpack_require__("./node_modules/ionic-angular/util/form.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__icon_icon__ = __webpack_require__("./node_modules/ionic-angular/components/icon/icon.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ion__ = __webpack_require__("./node_modules/ionic-angular/components/ion.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__label_label__ = __webpack_require__("./node_modules/ionic-angular/components/label/label.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__item_reorder__ = __webpack_require__("./node_modules/ionic-angular/components/item/item-reorder.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();








/**
 * @name Item
 * @description
 * An item can contain text, images, and anything else. Generally it is placed in a list with other
 * items. It can easily be swiped, deleted, reordered, edited, and more. An item is only required to
 * be in a [List](../../list/List) if manipulating the item via gestures is required. It requires an
 * [ItemSliding](../ItemSliding) wrapper element in order to be swiped.
 *
 *
 * ## Common Usage
 * There are a few elements that are considered items, but not all of them are styled to look the same.
 * The basic item can be written as an `<ion-item>` element or it can be added to any element by adding
 * `ion-item` as an attribute. List headers and item dividers, although styled differently, are also items
 * and can be written as `<ion-list-header>` and `<ion-item-divider>`, respectively.
 *
 * ### As an Element
 * A basic item should be written as a `<ion-item>` element when it is not clickable.
 *
 * ```html
 * <ion-item>
 *   Item
 * </ion-item>
 * ```
 *
 * A list header should be written as `<ion-list-header>`.
 *
 * ```html
 * <ion-list-header>
 *   List Header
 * </ion-list-header>
 * ```
 *
 * An item divider should be written as `<ion-item-divider>`.
 *
 * ```html
 * <ion-item-divider>
 *   Item Divider
 * </ion-item-divider>
 * ```
 *
 * ### As an Attribute
 * The attribute `ion-item` should be added to a `<button>` when the item can be clicked or tapped. It
 * should be added to an `<a>` element when the item needs to contain a `href`. It can be added as an
 * attribute to any element to take on the item styling.
 *
 * ```html
 * <button ion-item (click)="buttonClick()">
 *   Button Item
 * </button>
 *
 * <a ion-item href="https://www.ionicframework.com">
 *   Anchor Item
 * </a>
 * ```
 *
 * Note: do not add `ion-item` as an attribute to an `<ion-list-header>` or `<ion-item-divider>` element
 * as they are already items and their styling will be changed to look like a basic item.
 *
 * ## Detail Arrows
 * By default, `<button>` and `<a>` elements with the `ion-item` attribute will display a right arrow icon
 * on `ios` mode. To hide the right arrow icon on either of these elements, add the `detail-none` attribute
 * to the item. To show the right arrow icon on an element that doesn't display it naturally, add the
 * `detail-push` attribute to the item.
 *
 * ```html
 * <ion-item detail-push>
 *   Item with Detail Arrow
 * </ion-item>
 *
 * <button ion-item (click)="buttonClick()">
 *   Button Item with Detail Arrow
 * </button>
 *
 * <a ion-item detail-none href="https://www.ionicframework.com">
 *   Anchor Item with no Detail Arrow
 * </a>
 * ```
 *
 * This feature is not enabled by default for `md` and `wp` modes, but it can be enabled by setting the
 * Sass variables `$item-md-detail-push-show` and `$item-wp-detail-push-show`, respectively, to `true`.
 * It can also be disabled for ios by setting `$item-ios-detail-push-show` to `false`. See the
 * [theming documentation](http://ionicframework.com/docs/theming/overriding-ionic-variables/) for
 * more information on overriding Sass variables.
 *
 *
 * ## Item Placement
 * Items rely heavily on content projection to position content. The item grabs content based on the
 * element or attribute and positions it that way. This logic makes it possible to write a complex
 * item with simple, understandable markup without having to worry about styling and positioning
 * the elements.
 *
 * The below chart details the attributes item looks for and where it will place the element with
 * that attribute inside of the item:
 *
 *  | Attribute      | Description                                                                                          |
 *  |----------------|----------------------------------------------------------------------------------------------------- |
 *  | `item-start`   | Placed to the left of all other elements, outside of the inner item.                                 |
 *  | `item-end`     | Placed to the right of all other elements, inside of the inner item, outside of the input wrapper.   |
 *  | `item-content` | Placed to the right of any `ion-label`, inside of the input wrapper.                                 |
 *
 * ### Checkboxes, Radios and Toggles
 * [Checkboxes](../../checkbox/Checkbox) are positioned in the same place as the `item-start` attribute.
 * [Radios](../../radio/RadioButton) and [Toggles](../../toggle/Toggle) are positioned in the same place
 * as the `item-end` attribute. All of these components can be positioned differently by adding the
 * `item-start` or `item-end` attribute.
 *
 * ### Content and Inputs
 * A [Label](../../label/Label) is placed inside of the item to the left of all content and inputs. The
 * following components are all placed in the same position as the `item-content` attribute: [Select](../../select/Select),
 * [Input](../../input/Input), [TextArea](../../input/TextArea), [DateTime](../../datetime/DateTime), and
 * [Range](../../range/Range).
 *
 * Any element directly placed inside of an `<ion-item>` that does not have one of the previously mentioned
 * attributes and isn't one of the above elements will be placed inside of a [Label](../../label/Label).
 *
 * ### Text Alignment
 * By default, Items will align text to the left and add an ellipsis when the text is wider than the item.
 * See the [Utility Attributes Documentation](../../../../theming/css-utilities/) for attributes that can
 * be added to `ion-item` to transform the text.
 *
 * @usage
 *
 * ```html
 * <ion-list>
 *
 *   <ion-list-header>
 *     Header
 *   </ion-list-header>
 *
 *   <ion-item>
 *     Item
 *   </ion-item>
 *
 *   <ion-item detail-push>
 *     Item with Detail Arrow
 *   </ion-item>
 *
 *   <button ion-item (click)="buttonClick()">
 *     Button Item
 *   </button>
 *
 *   <ion-item-divider>
 *     Item Divider
 *   </ion-item-divider>
 *
 *   <button ion-item detail-none (click)="buttonClick()">
 *     Button Item with no Detail Arrow
 *   </button>
 *
 *   <a ion-item href="https://www.ionicframework.com">
 *     Anchor Item
 *   </a>
 *
 *   <ion-item no-lines>
 *     Item with no border
 *   </ion-item>
 *
 *   <ion-item text-wrap>
 *     Multiline text that should wrap when it is too long
 *     to fit on one line in the item.
 *   </ion-item>
 *
 * </ion-list>
 * ```
 *
 *
 * @advanced
 *
 * ```html
 * <ion-list>
 *
 *   <!-- List header with buttons on each side -->
 *   <ion-list-header>
 *     <button ion-button item-start (click)="buttonClick()">Button</button>
 *     List Header
 *     <button ion-button outline item-end (click)="buttonClick()">Outline</button>
 *   </ion-list-header>
 *
 *   <!-- Loops through and creates multiple items -->
 *   <ion-item *ngFor="let item of items">
 *     Item {% raw %}{{item}}{% endraw %}
 *   </ion-item>
 *
 *   <!-- Button item with an icon on the left -->
 *   <button ion-item>
 *     <ion-icon name="star" item-start></ion-icon>
 *     Button Item
 *   </button>
 *
 *   <!-- Item with a label and content -->
 *   <ion-item>
 *     <ion-label>
 *       Item Label
 *     </ion-label>
 *     <div item-content>
 *       Item Content next to the label
 *     </div>
 *   </ion-item>
 *
 *   <!-- Item with left and right buttons -->
 *   <ion-item>
 *     <button ion-button item-start (click)="buttonClick()">Button</button>
 *     Item
 *     <button ion-button outline item-end (click)="buttonClick()">Outline</button>
 *   </ion-item>
 *
 *   <!-- Item divider with a right button -->
 *   <ion-item-divider>
 *     Item Divider
 *     <button ion-button item-end>Button</button>
 *   </ion-item-divider>
 *
 *   <!-- Disabled button item with left and right buttons -->
 *   <button ion-item disabled>
 *     <button ion-button item-start (click)="buttonClick()">
 *       <ion-icon name="home"></ion-icon>
 *       Left Icon
 *     </button>
 *     Disabled Button Item
 *     <button ion-button outline item-end (click)="buttonClick()">
 *       <ion-icon name="star"></ion-icon>
 *       Left Icon
 *     </button>
 *   </button>
 *
 *   <!-- Item with an avatar on the left and button on the right -->
 *   <ion-item>
 *     <ion-avatar item-start>
 *       <img src="img/my-avatar.png">
 *     </ion-avatar>
 *     Avatar Item
 *     <button ion-button outline item-end>View</button>
 *   </ion-item>
 *
 *   <!-- Item with a thumbnail on the right -->
 *   <ion-item>
 *     <h2>Item</h2>
 *     <p>Item Paragraph</p>
 *     <ion-thumbnail item-end>
 *       <img src="img/my-thumbnail.png">
 *     </ion-thumbnail>
 *   </ion-item>
 *
 *   <!-- Sliding item -->
 *   <ion-item-sliding>
 *     <ion-item>
 *       Item
 *     </ion-item>
 *     <ion-item-options>
 *       <button ion-button color="primary" (click)="archive()">Archive</button>
 *     </ion-item-options>
 *   </ion-item-sliding>
 *
 * </ion-list>
 * ```
 *
 *
 * @demo /docs/demos/src/item/
 * @see {@link /docs/components#lists List Component Docs}
 * @see {@link ../../list/List List API Docs}
 * @see {@link ../ItemSliding ItemSliding API Docs}
 */
var Item = (function (_super) {
    __extends(Item, _super);
    function Item(form, config, elementRef, renderer, reorder) {
        var _this = _super.call(this, config, elementRef, renderer, 'item') || this;
        _this._ids = -1;
        _this._inputs = [];
        _this._viewLabel = true;
        _this._name = 'item';
        /**
         * @hidden
         */
        _this.labelId = null;
        _this._setName(elementRef);
        _this._hasReorder = !!reorder;
        _this.id = form.nextId().toString();
        _this.labelId = 'lbl-' + _this.id;
        // auto add "tappable" attribute to ion-item components that have a click listener
        if (!renderer.orgListen) {
            renderer.orgListen = renderer.listen;
            renderer.listen = function (renderElement, name, callback) {
                if (name === 'click' && renderElement.setAttribute) {
                    renderElement.setAttribute('tappable', '');
                }
                return renderer.orgListen(renderElement, name, callback);
            };
        }
        return _this;
    }
    /**
     * @hidden
     */
    Item.prototype.registerInput = function (type) {
        this._inputs.push(type);
        return this.id + '-' + (++this._ids);
    };
    /**
     * @hidden
     */
    Item.prototype.ngAfterContentInit = function () {
        if (this._viewLabel && this._inputs.length) {
            var labelText = this.getLabelText().trim();
            this._viewLabel = (labelText.length > 0);
        }
        if (this._inputs.length > 1) {
            this.setElementClass('item-multiple-inputs', true);
        }
    };
    /**
     * @hidden
     */
    Item.prototype._updateColor = function (newColor, componentName) {
        componentName = componentName || 'item'; // item-radio
        this._setColor(newColor, componentName);
    };
    /**
     * @hidden
     */
    Item.prototype._setName = function (elementRef) {
        var nodeName = elementRef.nativeElement.nodeName.replace('ION-', '');
        if (nodeName === 'LIST-HEADER' || nodeName === 'ITEM-DIVIDER') {
            this._name = nodeName;
        }
    };
    /**
     * @hidden
     */
    Item.prototype.getLabelText = function () {
        return this._label ? this._label.text : '';
    };
    Object.defineProperty(Item.prototype, "contentLabel", {
        /**
         * @hidden
         */
        set: function (label) {
            if (label) {
                this._label = label;
                label.id = this.labelId;
                if (label.type) {
                    this.setElementClass('item-label-' + label.type, true);
                }
                this._viewLabel = false;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Item.prototype, "viewLabel", {
        /**
         * @hidden
         */
        set: function (label) {
            if (!this._label) {
                this._label = label;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Item.prototype, "_buttons", {
        /**
         * @hidden
         */
        set: function (buttons) {
            buttons.forEach(function (button) {
                if (!button._size) {
                    button.setElementClass('item-button', true);
                }
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Item.prototype, "_icons", {
        /**
         * @hidden
         */
        set: function (icons) {
            icons.forEach(function (icon) {
                icon.setElementClass('item-icon', true);
            });
        },
        enumerable: true,
        configurable: true
    });
    Item.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'ion-list-header,ion-item,[ion-item],ion-item-divider',
                    template: '<ng-content select="[item-start],[item-left],ion-checkbox:not([item-end]):not([item-right])"></ng-content>' +
                        '<div class="item-inner">' +
                        '<div class="input-wrapper">' +
                        '<ng-content select="ion-label"></ng-content>' +
                        '<ion-label *ngIf="_viewLabel">' +
                        '<ng-content></ng-content>' +
                        '</ion-label>' +
                        '<ng-content select="ion-select,ion-input,ion-textarea,ion-datetime,ion-range,[item-content]"></ng-content>' +
                        '</div>' +
                        '<ng-content select="[item-end],[item-right],ion-radio,ion-toggle"></ng-content>' +
                        '<ion-reorder *ngIf="_hasReorder"></ion-reorder>' +
                        '</div>' +
                        '<div class="button-effect"></div>',
                    host: {
                        'class': 'item'
                    },
                    changeDetection: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectionStrategy"].OnPush,
                    encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None,
                },] },
    ];
    /** @nocollapse */
    Item.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_3__util_form__["a" /* Form */], },
        { type: __WEBPACK_IMPORTED_MODULE_2__config_config__["a" /* Config */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: __WEBPACK_IMPORTED_MODULE_7__item_reorder__["a" /* ItemReorder */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
    ]; };
    Item.propDecorators = {
        'contentLabel': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChild"], args: [__WEBPACK_IMPORTED_MODULE_6__label_label__["a" /* Label */],] },],
        'viewLabel': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"], args: [__WEBPACK_IMPORTED_MODULE_6__label_label__["a" /* Label */],] },],
        '_buttons': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChildren"], args: [__WEBPACK_IMPORTED_MODULE_1__button_button__["a" /* Button */],] },],
        '_icons': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChildren"], args: [__WEBPACK_IMPORTED_MODULE_4__icon_icon__["a" /* Icon */],] },],
    };
    return Item;
}(__WEBPACK_IMPORTED_MODULE_5__ion__["a" /* Ion */]));

//# sourceMappingURL=item.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/item/reorder.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Reorder; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__item_reorder_util__ = __webpack_require__("./node_modules/ionic-angular/components/item/item-reorder-util.js");


/**
 * @hidden
 */
var Reorder = (function () {
    function Reorder(elementRef) {
        this.elementRef = elementRef;
        elementRef.nativeElement['$ionComponent'] = this;
    }
    Reorder.prototype.getReorderNode = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1__item_reorder_util__["a" /* findReorderItem */])(this.elementRef.nativeElement, null);
    };
    Reorder.prototype.onClick = function (ev) {
        // Stop propagation if click event reaches ion-reorder
        ev.preventDefault();
        ev.stopPropagation();
    };
    Reorder.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'ion-reorder',
                    template: "<ion-icon name=\"reorder\"></ion-icon>"
                },] },
    ];
    /** @nocollapse */
    Reorder.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    ]; };
    Reorder.propDecorators = {
        'onClick': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"], args: ['click', ['$event'],] },],
    };
    return Reorder;
}());

//# sourceMappingURL=reorder.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/label/label.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Label; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ion__ = __webpack_require__("./node_modules/ionic-angular/components/ion.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



/**
 * @name Label
 * @description
 * Labels are placed inside of an `ion-item` element and can be used
 * to describe an `ion-input`, `ion-toggle`, `ion-checkbox`, and more.
 *
 * @property [fixed] - A persistent label that sits next the input.
 * @property [floating] - A label that will float above the input if the input is empty or loses focus.
 * @property [stacked] - A stacked label will always appear on top of the input.

 *
 * @usage
 * ```html
 *  <ion-item>
 *    <ion-label>Username</ion-label>
 *    <ion-input></ion-input>
 *  </ion-item>
 *
 *  <ion-item>
 *    <ion-label fixed>Website</ion-label>
 *    <ion-input type="url"></ion-input>
 *  </ion-item>
 *
 *  <ion-item>
 *    <ion-label floating>Email</ion-label>
 *    <ion-input type="email"></ion-input>
 *  </ion-item>
 *
 *  <ion-item>
 *    <ion-label stacked>Phone</ion-label>
 *    <ion-input type="tel"></ion-input>
 *  </ion-item>
 *
 *  <ion-item>
 *    <ion-label>Toggle</ion-label>
 *    <ion-toggle></ion-toggle>
 *  </ion-item>
 *
 *  <ion-item>
 *    <ion-label>Checkbox</ion-label>
 *    <ion-checkbox></ion-checkbox>
 *  </ion-item>
 * ```
 *
 * @demo /docs/demos/src/label/
 * @see {@link ../../../../components#inputs Input Component Docs}
 * @see {@link ../../input/Input Input API Docs}
 *
 */
var Label = (function (_super) {
    __extends(Label, _super);
    function Label(config, elementRef, renderer, isFloating, isStacked, isFixed, isInset) {
        var _this = _super.call(this, config, elementRef, renderer, 'label') || this;
        _this.type = (isFloating === '' ? 'floating' : (isStacked === '' ? 'stacked' : (isFixed === '' ? 'fixed' : (isInset === '' ? 'inset' : null))));
        return _this;
    }
    Object.defineProperty(Label.prototype, "id", {
        /**
         * @hidden
         */
        get: function () {
            return this._id;
        },
        set: function (val) {
            this._id = val;
            if (val) {
                this.setElementAttribute('id', val);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Label.prototype, "text", {
        /**
         * @hidden
         */
        get: function () {
            return this.getNativeElement().textContent || '';
        },
        enumerable: true,
        configurable: true
    });
    Label.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'ion-label'
                },] },
    ];
    /** @nocollapse */
    Label.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__config_config__["a" /* Config */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Attribute"], args: ['floating',] },] },
        { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Attribute"], args: ['stacked',] },] },
        { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Attribute"], args: ['fixed',] },] },
        { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Attribute"], args: ['inset',] },] },
    ]; };
    Label.propDecorators = {
        'id': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return Label;
}(__WEBPACK_IMPORTED_MODULE_2__ion__["a" /* Ion */]));

//# sourceMappingURL=label.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/list/list-header.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ListHeader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ion__ = __webpack_require__("./node_modules/ionic-angular/components/ion.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



/**
 * @hidden
 */
var ListHeader = (function (_super) {
    __extends(ListHeader, _super);
    function ListHeader(config, renderer, elementRef, _id) {
        var _this = _super.call(this, config, elementRef, renderer, 'list-header') || this;
        _this._id = _id;
        return _this;
    }
    Object.defineProperty(ListHeader.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (val) {
            this._id = val;
            this.setElementAttribute('id', val);
        },
        enumerable: true,
        configurable: true
    });
    ListHeader.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'ion-list-header'
                },] },
    ];
    /** @nocollapse */
    ListHeader.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__config_config__["a" /* Config */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Attribute"], args: ['id',] },] },
    ]; };
    return ListHeader;
}(__WEBPACK_IMPORTED_MODULE_2__ion__["a" /* Ion */]));

//# sourceMappingURL=list-header.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/list/list.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return List; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__platform_dom_controller__ = __webpack_require__("./node_modules/ionic-angular/platform/dom-controller.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gestures_gesture_controller__ = __webpack_require__("./node_modules/ionic-angular/gestures/gesture-controller.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ion__ = __webpack_require__("./node_modules/ionic-angular/components/ion.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__item_item_sliding_gesture__ = __webpack_require__("./node_modules/ionic-angular/components/item/item-sliding-gesture.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__platform_platform__ = __webpack_require__("./node_modules/ionic-angular/platform/platform.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();








/**
 * The List is a widely used interface element in almost any mobile app,
 * and can include content ranging from basic text all the way to
 * buttons, toggles, icons, and thumbnails.
 *
 * Both the list, which contains items, and the list items themselves
 * can be any HTML element.
 *
 * Using the List and Item components make it easy to support various
 * interaction modes such as swipe to edit, drag to reorder, and
 * removing items.
 *
 * @demo /docs/demos/src/list/
 * @see {@link /docs/components#lists List Component Docs}
 * @advanced
 *
 * Enable the sliding items.
 *
 * ```ts
 * import { Component, ViewChild } from '@angular/core';
 * import { List } from 'ionic-angular';
 *
 * @Component({...})
 * export class MyClass {
 *   @ViewChild(List) list: List;
 *
 *   constructor() { }
 *
 *   stopSliding() {
 *     this.list.enableSlidingItems(false);
 *   }
 * }
 * ```
 *
 */
var List = (function (_super) {
    __extends(List, _super);
    function List(config, elementRef, renderer, _plt, _gestureCtrl, _domCtrl) {
        var _this = _super.call(this, config, elementRef, renderer, 'list') || this;
        _this._plt = _plt;
        _this._gestureCtrl = _gestureCtrl;
        _this._domCtrl = _domCtrl;
        _this._enableSliding = true;
        _this._containsSlidingItems = false;
        return _this;
    }
    Object.defineProperty(List.prototype, "sliding", {
        /**
         * @input {boolean} If true, the sliding items will be enabled.
         */
        get: function () {
            return this._enableSliding;
        },
        set: function (val) {
            this._enableSliding = Object(__WEBPACK_IMPORTED_MODULE_5__util_util__["o" /* isTrueProperty */])(val);
            this._updateSlidingState();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @hidden
     */
    List.prototype.containsSlidingItem = function (contains) {
        this._containsSlidingItems = contains;
        this._updateSlidingState();
    };
    List.prototype._updateSlidingState = function () {
        var shouldSlide = this._enableSliding && this._containsSlidingItems;
        if (!shouldSlide) {
            this._slidingGesture && this._slidingGesture.destroy();
            this._slidingGesture = null;
        }
        else if (!this._slidingGesture) {
            (void 0) /* console.debug */;
            this._slidingGesture = new __WEBPACK_IMPORTED_MODULE_6__item_item_sliding_gesture__["a" /* ItemSlidingGesture */](this._plt, this, this._gestureCtrl, this._domCtrl);
            this._slidingGesture.listen();
        }
    };
    /**
     * Close any sliding items that are open.
     */
    List.prototype.closeSlidingItems = function () {
        this._slidingGesture && this._slidingGesture.closeOpened();
    };
    /**
     * @hidden
     */
    List.prototype.destroy = function () {
        this._slidingGesture && this._slidingGesture.destroy();
    };
    List.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'ion-list',
                },] },
    ];
    /** @nocollapse */
    List.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__config_config__["a" /* Config */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: __WEBPACK_IMPORTED_MODULE_7__platform_platform__["a" /* Platform */], },
        { type: __WEBPACK_IMPORTED_MODULE_3__gestures_gesture_controller__["m" /* GestureController */], },
        { type: __WEBPACK_IMPORTED_MODULE_2__platform_dom_controller__["a" /* DomController */], },
    ]; };
    List.propDecorators = {
        'sliding': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return List;
}(__WEBPACK_IMPORTED_MODULE_4__ion__["a" /* Ion */]));

//# sourceMappingURL=list.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/loading/loading-component.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LoadingCmp; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gestures_gesture_controller__ = __webpack_require__("./node_modules/ionic-angular/gestures/gesture-controller.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__platform_key__ = __webpack_require__("./node_modules/ionic-angular/platform/key.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__navigation_nav_params__ = __webpack_require__("./node_modules/ionic-angular/navigation/nav-params.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__navigation_view_controller__ = __webpack_require__("./node_modules/ionic-angular/navigation/view-controller.js");







/**
* @hidden
*/
var LoadingCmp = (function () {
    function LoadingCmp(_viewCtrl, _config, _elementRef, gestureCtrl, params, renderer) {
        this._viewCtrl = _viewCtrl;
        this._config = _config;
        (void 0) /* assert */;
        this.gestureBlocker = gestureCtrl.createBlocker(__WEBPACK_IMPORTED_MODULE_2__gestures_gesture_controller__["a" /* BLOCK_ALL */]);
        this.d = params.data;
        renderer.setElementClass(_elementRef.nativeElement, "loading-" + _config.get('mode'), true);
        if (this.d.cssClass) {
            this.d.cssClass.split(' ').forEach(function (cssClass) {
                // Make sure the class isn't whitespace, otherwise it throws exceptions
                if (cssClass.trim() !== '')
                    renderer.setElementClass(_elementRef.nativeElement, cssClass, true);
            });
        }
        this.id = (++loadingIds);
    }
    LoadingCmp.prototype.ngOnInit = function () {
        // If no spinner was passed in loading options we need to fall back
        // to the loadingSpinner in the app's config, then the mode spinner
        if (Object(__WEBPACK_IMPORTED_MODULE_3__util_util__["p" /* isUndefined */])(this.d.spinner)) {
            this.d.spinner = this._config.get('loadingSpinner', this._config.get('spinner', 'ios'));
        }
        // If the user passed hide to the spinner we don't want to show it
        this.showSpinner = Object(__WEBPACK_IMPORTED_MODULE_3__util_util__["h" /* isDefined */])(this.d.spinner) && this.d.spinner !== 'hide';
    };
    LoadingCmp.prototype.ionViewWillEnter = function () {
        this.gestureBlocker.block();
    };
    LoadingCmp.prototype.ionViewDidLeave = function () {
        this.gestureBlocker.unblock();
    };
    LoadingCmp.prototype.ionViewDidEnter = function () {
        var _this = this;
        // If there is a duration, dismiss after that amount of time
        if (this.d && this.d.duration) {
            this.durationTimeout = setTimeout(function () { return _this.dismiss('backdrop'); }, this.d.duration);
        }
    };
    LoadingCmp.prototype.keyUp = function (ev) {
        if (this._viewCtrl.isLast() && ev.keyCode === __WEBPACK_IMPORTED_MODULE_4__platform_key__["c" /* KEY_ESCAPE */]) {
            this.bdClick();
        }
    };
    LoadingCmp.prototype.bdClick = function () {
        if (this.d.enableBackdropDismiss) {
            this.dismiss('backdrop');
        }
    };
    LoadingCmp.prototype.dismiss = function (role) {
        if (this.durationTimeout) {
            clearTimeout(this.durationTimeout);
        }
        return this._viewCtrl.dismiss(null, role);
    };
    LoadingCmp.prototype.ngOnDestroy = function () {
        (void 0) /* assert */;
        this.gestureBlocker.destroy();
    };
    LoadingCmp.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'ion-loading',
                    template: '<ion-backdrop [hidden]="!d.showBackdrop" (click)="bdClick()" [class.backdrop-no-tappable]="!d.enableBackdropDismiss"></ion-backdrop>' +
                        '<div class="loading-wrapper">' +
                        '<div *ngIf="showSpinner" class="loading-spinner">' +
                        '<ion-spinner [name]="d.spinner"></ion-spinner>' +
                        '</div>' +
                        '<div *ngIf="d.content" [innerHTML]="d.content" class="loading-content"></div>' +
                        '</div>',
                    host: {
                        'role': 'dialog'
                    },
                    encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None,
                },] },
    ];
    /** @nocollapse */
    LoadingCmp.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_6__navigation_view_controller__["a" /* ViewController */], },
        { type: __WEBPACK_IMPORTED_MODULE_1__config_config__["a" /* Config */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_2__gestures_gesture_controller__["m" /* GestureController */], },
        { type: __WEBPACK_IMPORTED_MODULE_5__navigation_nav_params__["a" /* NavParams */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    ]; };
    LoadingCmp.propDecorators = {
        'keyUp': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"], args: ['body:keyup', ['$event'],] },],
    };
    return LoadingCmp;
}());

var loadingIds = -1;
//# sourceMappingURL=loading-component.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/loading/loading-controller.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LoadingController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_app__ = __webpack_require__("./node_modules/ionic-angular/components/app/app.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loading__ = __webpack_require__("./node_modules/ionic-angular/components/loading/loading.js");




/**
 * @name LoadingController
 * @description
 * An overlay that can be used to indicate activity while blocking user
 * interaction. The loading indicator appears on top of the app's content,
 * and can be dismissed by the app to resume user interaction with
 * the app. It includes an optional backdrop, which can be disabled
 * by setting `showBackdrop: false` upon creation.
 *
 * ### Creating
 * You can pass all of the loading options in the first argument of
 * the create method: `create(opts)`. The spinner name should be
 * passed in the `spinner` property, and any optional HTML can be passed
 * in the `content` property. If you do not pass a value to `spinner`
 * the loading indicator will use the spinner specified by the mode. To
 * set the spinner name across the app, set the value of `loadingSpinner`
 * in your app's config. To hide the spinner, set `loadingSpinner: 'hide'`
 * in the app's config or pass `spinner: 'hide'` in the loading
 * options. See the [create](#create) method below for all available options.
 *
 * ### Dismissing
 * The loading indicator can be dismissed automatically after a specific
 * amount of time by passing the number of milliseconds to display it in
 * the `duration` of the loading options. By default the loading indicator
 * will show even during page changes, but this can be disabled by setting
 * `dismissOnPageChange` to `true`. To dismiss the loading indicator after
 * creation, call the `dismiss()` method on the Loading instance. The
 * `onDidDismiss` function can be called to perform an action after the loading
 * indicator is dismissed.
 *
 * >Note that after the component is dismissed, it will not be usable anymore
 * and another one must be created. This can be avoided by wrapping the
 * creation and presentation of the component in a reusable function as shown
 * in the `usage` section below.
 *
 * ### Limitations
 * The element is styled to appear on top of other content by setting its
 * `z-index` property. You must ensure no element has a stacking context with
 * a higher `z-index` than this element.
 *
 * @usage
 * ```ts
 * import { LoadingController } from 'ionic-angular';
 *
 * constructor(public loadingCtrl: LoadingController) { }
 *
 * presentLoadingDefault() {
 *   const loading = this.loadingCtrl.create({
 *     content: 'Please wait...'
 *   });
 *
 *   loading.present();
 *
 *   setTimeout(() => {
 *     loading.dismiss();
 *   }, 5000);
 * }
 *
 * presentLoadingCustom() {
 *   const loading = this.loadingCtrl.create({
 *     spinner: 'hide',
 *     content: `
 *       <div class="custom-spinner-container">
 *         <div class="custom-spinner-box"></div>
 *       </div>`,
 *     duration: 5000
 *   });
 *
 *   loading.onDidDismiss(() => {
 *     console.log('Dismissed loading');
 *   });
 *
 *   loading.present();
 * }
 *
 * presentLoadingText() {
 *   const loading = this.loadingCtrl.create({
 *     spinner: 'hide',
 *     content: 'Loading Please Wait...'
 *   });
 *
 *   loading.present();
 *
 *   setTimeout(() => {
 *     this.nav.push(Page2);
 *   }, 1000);
 *
 *   setTimeout(() => {
 *     loading.dismiss();
 *   }, 5000);
 * }
 * ```
 * @advanced
 *
 * Loading options
 *
 * | Option                | Type       | Description                                                                                                      |
 * |-----------------------|------------|------------------------------------------------------------------------------------------------------------------|
 * | spinner               |`string`    | The name of the SVG spinner for the loading indicator.                                                           |
 * | content               |`string`    | The html content for the loading indicator.                                                                      |
 * | cssClass              |`string`    | Additional classes for custom styles, separated by spaces.                                                       |
 * | showBackdrop          |`boolean`   | Whether to show the backdrop. Default true.                                                                      |
 * | enableBackdropDismiss | `boolean`  | Whether the loading indicator should be dismissed by tapping the backdrop. Default false.                        |
 * | dismissOnPageChange   |`boolean`   | Whether to dismiss the indicator when navigating to a new page. Default false.                                   |
 * | duration              |`number`    | How many milliseconds to wait before hiding the indicator. By default, it will show until `dismiss()` is called. |
 *
 * @demo /docs/demos/src/loading/
 * @see {@link /docs/api/components/spinner/Spinner Spinner API Docs}
 */
var LoadingController = (function () {
    function LoadingController(_app, config) {
        this._app = _app;
        this.config = config;
    }
    /**
     * Create a loading indicator. See below for options.
     * @param {LoadingOptions} [opts] Loading options
     * @returns {Loading} Returns a Loading Instance
     */
    LoadingController.prototype.create = function (opts) {
        if (opts === void 0) { opts = {}; }
        return new __WEBPACK_IMPORTED_MODULE_3__loading__["a" /* Loading */](this._app, opts, this.config);
    };
    LoadingController.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    LoadingController.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__app_app__["a" /* App */], },
        { type: __WEBPACK_IMPORTED_MODULE_2__config_config__["a" /* Config */], },
    ]; };
    return LoadingController;
}());

//# sourceMappingURL=loading-controller.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/loading/loading-transitions.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LoadingPopIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LoadingPopOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LoadingMdPopIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LoadingMdPopOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LoadingWpPopIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return LoadingWpPopOut; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__animations_animation__ = __webpack_require__("./node_modules/ionic-angular/animations/animation.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__transitions_transition__ = __webpack_require__("./node_modules/ionic-angular/transitions/transition.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


/**
 * Animations for loading
 */
var LoadingPopIn = (function (_super) {
    __extends(LoadingPopIn, _super);
    function LoadingPopIn() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LoadingPopIn.prototype.init = function () {
        var ele = this.enteringView.pageRef().nativeElement;
        var backdrop = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](this.plt, ele.querySelector('ion-backdrop'));
        var wrapper = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](this.plt, ele.querySelector('.loading-wrapper'));
        wrapper.fromTo('opacity', 0.01, 1).fromTo('scale', 1.1, 1);
        backdrop.fromTo('opacity', 0.01, 0.3);
        this
            .easing('ease-in-out')
            .duration(200)
            .add(backdrop)
            .add(wrapper);
    };
    return LoadingPopIn;
}(__WEBPACK_IMPORTED_MODULE_1__transitions_transition__["a" /* Transition */]));

var LoadingPopOut = (function (_super) {
    __extends(LoadingPopOut, _super);
    function LoadingPopOut() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LoadingPopOut.prototype.init = function () {
        var ele = this.leavingView.pageRef().nativeElement;
        var backdrop = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](this.plt, ele.querySelector('ion-backdrop'));
        var wrapper = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](this.plt, ele.querySelector('.loading-wrapper'));
        wrapper.fromTo('opacity', 0.99, 0).fromTo('scale', 1, 0.9);
        backdrop.fromTo('opacity', 0.3, 0);
        this
            .easing('ease-in-out')
            .duration(200)
            .add(backdrop)
            .add(wrapper);
    };
    return LoadingPopOut;
}(__WEBPACK_IMPORTED_MODULE_1__transitions_transition__["a" /* Transition */]));

var LoadingMdPopIn = (function (_super) {
    __extends(LoadingMdPopIn, _super);
    function LoadingMdPopIn() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LoadingMdPopIn.prototype.init = function () {
        var ele = this.enteringView.pageRef().nativeElement;
        var backdrop = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](this.plt, ele.querySelector('ion-backdrop'));
        var wrapper = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](this.plt, ele.querySelector('.loading-wrapper'));
        wrapper.fromTo('opacity', 0.01, 1).fromTo('scale', 1.1, 1);
        backdrop.fromTo('opacity', 0.01, 0.5);
        this
            .easing('ease-in-out')
            .duration(200)
            .add(backdrop)
            .add(wrapper);
    };
    return LoadingMdPopIn;
}(__WEBPACK_IMPORTED_MODULE_1__transitions_transition__["a" /* Transition */]));

var LoadingMdPopOut = (function (_super) {
    __extends(LoadingMdPopOut, _super);
    function LoadingMdPopOut() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LoadingMdPopOut.prototype.init = function () {
        var ele = this.leavingView.pageRef().nativeElement;
        var backdrop = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](this.plt, ele.querySelector('ion-backdrop'));
        var wrapper = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](this.plt, ele.querySelector('.loading-wrapper'));
        wrapper.fromTo('opacity', 0.99, 0).fromTo('scale', 1, 0.9);
        backdrop.fromTo('opacity', 0.5, 0);
        this
            .easing('ease-in-out')
            .duration(200)
            .add(backdrop)
            .add(wrapper);
    };
    return LoadingMdPopOut;
}(__WEBPACK_IMPORTED_MODULE_1__transitions_transition__["a" /* Transition */]));

var LoadingWpPopIn = (function (_super) {
    __extends(LoadingWpPopIn, _super);
    function LoadingWpPopIn() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LoadingWpPopIn.prototype.init = function () {
        var ele = this.enteringView.pageRef().nativeElement;
        var backdrop = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](this.plt, ele.querySelector('ion-backdrop'));
        var wrapper = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](this.plt, ele.querySelector('.loading-wrapper'));
        wrapper.fromTo('opacity', 0.01, 1).fromTo('scale', 1.3, 1);
        backdrop.fromTo('opacity', 0.01, 0.16);
        this
            .easing('cubic-bezier(0,0,0.05,1)')
            .duration(200)
            .add(backdrop)
            .add(wrapper);
    };
    return LoadingWpPopIn;
}(__WEBPACK_IMPORTED_MODULE_1__transitions_transition__["a" /* Transition */]));

var LoadingWpPopOut = (function (_super) {
    __extends(LoadingWpPopOut, _super);
    function LoadingWpPopOut() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LoadingWpPopOut.prototype.init = function () {
        var ele = this.leavingView.pageRef().nativeElement;
        var backdrop = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](this.plt, ele.querySelector('ion-backdrop'));
        var wrapper = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](this.plt, ele.querySelector('.loading-wrapper'));
        wrapper.fromTo('opacity', 0.99, 0).fromTo('scale', 1, 1.3);
        backdrop.fromTo('opacity', 0.16, 0);
        this
            .easing('ease-out')
            .duration(150)
            .add(backdrop)
            .add(wrapper);
    };
    return LoadingWpPopOut;
}(__WEBPACK_IMPORTED_MODULE_1__transitions_transition__["a" /* Transition */]));

//# sourceMappingURL=loading-transitions.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/loading/loading.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Loading; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_app_constants__ = __webpack_require__("./node_modules/ionic-angular/components/app/app-constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loading_component__ = __webpack_require__("./node_modules/ionic-angular/components/loading/loading-component.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loading_transitions__ = __webpack_require__("./node_modules/ionic-angular/components/loading/loading-transitions.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__navigation_view_controller__ = __webpack_require__("./node_modules/ionic-angular/navigation/view-controller.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





/**
 * @hidden
 */
var Loading = (function (_super) {
    __extends(Loading, _super);
    function Loading(app, opts, config) {
        if (opts === void 0) { opts = {}; }
        var _this = this;
        opts.showBackdrop = Object(__WEBPACK_IMPORTED_MODULE_0__util_util__["l" /* isPresent */])(opts.showBackdrop) ? !!opts.showBackdrop : true;
        opts.enableBackdropDismiss = Object(__WEBPACK_IMPORTED_MODULE_0__util_util__["l" /* isPresent */])(opts.enableBackdropDismiss) ? !!opts.enableBackdropDismiss : false;
        opts.dismissOnPageChange = Object(__WEBPACK_IMPORTED_MODULE_0__util_util__["l" /* isPresent */])(opts.dismissOnPageChange) ? !!opts.dismissOnPageChange : false;
        _this = _super.call(this, __WEBPACK_IMPORTED_MODULE_2__loading_component__["a" /* LoadingCmp */], opts, null) || this;
        _this._app = app;
        _this.isOverlay = true;
        config.setTransition('loading-pop-in', __WEBPACK_IMPORTED_MODULE_3__loading_transitions__["c" /* LoadingPopIn */]);
        config.setTransition('loading-pop-out', __WEBPACK_IMPORTED_MODULE_3__loading_transitions__["d" /* LoadingPopOut */]);
        config.setTransition('loading-md-pop-in', __WEBPACK_IMPORTED_MODULE_3__loading_transitions__["a" /* LoadingMdPopIn */]);
        config.setTransition('loading-md-pop-out', __WEBPACK_IMPORTED_MODULE_3__loading_transitions__["b" /* LoadingMdPopOut */]);
        config.setTransition('loading-wp-pop-in', __WEBPACK_IMPORTED_MODULE_3__loading_transitions__["e" /* LoadingWpPopIn */]);
        config.setTransition('loading-wp-pop-out', __WEBPACK_IMPORTED_MODULE_3__loading_transitions__["f" /* LoadingWpPopOut */]);
        return _this;
    }
    /**
     * @hidden
     */
    Loading.prototype.getTransitionName = function (direction) {
        var key = (direction === 'back' ? 'loadingLeave' : 'loadingEnter');
        return this._nav && this._nav.config.get(key);
    };
    /**
     * @param {string} content sets the html content for the loading indicator.
     */
    Loading.prototype.setContent = function (content) {
        this.data.content = content;
        return this;
    };
    /**
     * @param {string} spinner sets the name of the SVG spinner for the loading indicator.
     */
    Loading.prototype.setSpinner = function (spinner) {
        this.data.spinner = spinner;
        return this;
    };
    /**
     * @param {string} cssClass sets additional classes for custom styles, separated by spaces.
     */
    Loading.prototype.setCssClass = function (cssClass) {
        this.data.cssClass = cssClass;
        return this;
    };
    /**
     * @param {boolean} showBackdrop sets whether to show the backdrop.
     */
    Loading.prototype.setShowBackdrop = function (showBackdrop) {
        this.data.showBackdrop = showBackdrop;
        return this;
    };
    /**
     * @param {number} dur how many milliseconds to wait before hiding the indicator.
     */
    Loading.prototype.setDuration = function (dur) {
        this.data.duration = dur;
        return this;
    };
    /**
     * Present the loading instance.
     *
     * @param {NavOptions} [navOptions={}] Nav options to go with this transition.
     * @returns {Promise} Returns a promise which is resolved when the transition has completed.
     */
    Loading.prototype.present = function (navOptions) {
        if (navOptions === void 0) { navOptions = {}; }
        return this._app.present(this, navOptions, __WEBPACK_IMPORTED_MODULE_1__app_app_constants__["b" /* PORTAL_LOADING */]);
    };
    /**
     * Dismiss all loading components which have been presented.
     */
    Loading.prototype.dismissAll = function () {
        this._nav && this._nav.popAll();
    };
    return Loading;
}(__WEBPACK_IMPORTED_MODULE_4__navigation_view_controller__["a" /* ViewController */]));

//# sourceMappingURL=loading.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/menu/menu-close.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MenuClose; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_menu_controller__ = __webpack_require__("./node_modules/ionic-angular/components/app/menu-controller.js");


/**
 * @name MenuClose
 * @description
 * The `menuClose` directive can be placed on any button to close an open menu.
 *
 * @usage
 *
 * A simple `menuClose` button can be added using the following markup:
 *
 * ```html
 * <button ion-button menuClose>Close Menu</button>
 * ```
 *
 * To close a certain menu by its id or side, give the `menuClose`
 * directive a value.
 *
 * ```html
 * <button ion-button menuClose="left">Close Left Menu</button>
 * ```
 *
 * @demo /docs/demos/src/menu/
 * @see {@link /docs/components#menus Menu Component Docs}
 * @see {@link ../../menu/Menu Menu API Docs}
 */
var MenuClose = (function () {
    function MenuClose(_menu) {
        this._menu = _menu;
    }
    /**
    * @hidden
    */
    MenuClose.prototype.close = function () {
        var menu = this._menu.get(this.menuClose);
        menu && menu.close();
    };
    MenuClose.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: '[menuClose]'
                },] },
    ];
    /** @nocollapse */
    MenuClose.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__app_menu_controller__["a" /* MenuController */], },
    ]; };
    MenuClose.propDecorators = {
        'menuClose': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'close': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"], args: ['click',] },],
    };
    return MenuClose;
}());

//# sourceMappingURL=menu-close.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/menu/menu-gestures.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MenuContentGesture; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gestures_gesture_controller__ = __webpack_require__("./node_modules/ionic-angular/gestures/gesture-controller.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gestures_slide_edge_gesture__ = __webpack_require__("./node_modules/ionic-angular/gestures/slide-edge-gesture.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


/**
 * Gesture attached to the content which the menu is assigned to
 */
var MenuContentGesture = (function (_super) {
    __extends(MenuContentGesture, _super);
    function MenuContentGesture(plt, menu, gestureCtrl, domCtrl) {
        var _this = _super.call(this, plt, plt.doc().body, {
            direction: 'x',
            edge: menu.side,
            threshold: 5,
            maxEdgeStart: menu.maxEdgeStart || 50,
            zone: false,
            passive: true,
            domController: domCtrl,
            gesture: gestureCtrl.createGesture({
                name: __WEBPACK_IMPORTED_MODULE_0__gestures_gesture_controller__["e" /* GESTURE_MENU_SWIPE */],
                priority: __WEBPACK_IMPORTED_MODULE_0__gestures_gesture_controller__["g" /* GESTURE_PRIORITY_MENU_SWIPE */],
                disableScroll: true
            })
        }) || this;
        _this.menu = menu;
        return _this;
    }
    MenuContentGesture.prototype.canStart = function (ev) {
        var menu = this.menu;
        if (!menu.canSwipe()) {
            return false;
        }
        if (menu.isOpen) {
            return true;
        }
        else if (menu.getMenuController().getOpen()) {
            return false;
        }
        return _super.prototype.canStart.call(this, ev);
    };
    // Set CSS, then wait one frame for it to apply before sliding starts
    MenuContentGesture.prototype.onSlideBeforeStart = function () {
        (void 0) /* console.debug */;
        this.menu._swipeBeforeStart();
    };
    MenuContentGesture.prototype.onSlideStart = function () {
        (void 0) /* console.debug */;
        this.menu._swipeStart();
    };
    MenuContentGesture.prototype.onSlide = function (slide) {
        var z = (this.menu.isRightSide !== this.plt.isRTL ? slide.min : slide.max);
        var stepValue = (slide.distance / z);
        this.menu._swipeProgress(stepValue);
    };
    MenuContentGesture.prototype.onSlideEnd = function (slide) {
        var z = (this.menu.isRightSide !== this.plt.isRTL ? slide.min : slide.max);
        var currentStepValue = (slide.distance / z);
        var velocity = slide.velocity;
        z = Math.abs(z * 0.5);
        var shouldCompleteRight = (velocity >= 0)
            && (velocity > 0.2 || slide.delta > z);
        var shouldCompleteLeft = (velocity <= 0)
            && (velocity < -0.2 || slide.delta < -z);
        (void 0) /* console.debug */;
        this.menu._swipeEnd(shouldCompleteLeft, shouldCompleteRight, currentStepValue, velocity);
    };
    MenuContentGesture.prototype.getElementStartPos = function (slide) {
        var menu = this.menu;
        if (menu.isRightSide !== this.plt.isRTL) {
            return menu.isOpen ? slide.min : slide.max;
        }
        // left menu
        return menu.isOpen ? slide.max : slide.min;
    };
    MenuContentGesture.prototype.getSlideBoundaries = function () {
        var menu = this.menu;
        if (menu.isRightSide !== this.plt.isRTL) {
            return {
                min: -menu.width(),
                max: 0
            };
        }
        // left menu
        return {
            min: 0,
            max: menu.width()
        };
    };
    return MenuContentGesture;
}(__WEBPACK_IMPORTED_MODULE_1__gestures_slide_edge_gesture__["a" /* SlideEdgeGesture */]));

//# sourceMappingURL=menu-gestures.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/menu/menu-toggle.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MenuToggle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__button_button__ = __webpack_require__("./node_modules/ionic-angular/components/button/button.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_menu_controller__ = __webpack_require__("./node_modules/ionic-angular/components/app/menu-controller.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toolbar_navbar__ = __webpack_require__("./node_modules/ionic-angular/components/toolbar/navbar.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__navigation_view_controller__ = __webpack_require__("./node_modules/ionic-angular/navigation/view-controller.js");





/**
 * @name MenuToggle
 * @description
 * The `menuToggle` directive can be placed on any button to toggle a menu open or closed.
 * If it is added to the [NavBar](../../toolbar/Navbar) of a page, the button will only appear
 * when the page it's in is currently a root page. See the [Menu Navigation Bar Behavior](../Menu#navigation-bar-behavior)
 * docs for more information.
 *
 *
 * @usage
 *
 * A simple `menuToggle` button can be added using the following markup:
 *
 * ```html
 * <button ion-button menuToggle>Toggle Menu</button>
 * ```
 *
 * To toggle a specific menu by its id or side, give the `menuToggle`
 * directive a value.
 *
 * ```html
 * <button ion-button menuToggle="right">Toggle Right Menu</button>
 * ```
 *
 * If placing the `menuToggle` in a navbar or toolbar, it should be
 * placed as a child of the `<ion-navbar>` or `<ion-toolbar>`, and not in
 * the `<ion-buttons>` element:
 *
 * ```html
 * <ion-header>
 *
 *   <ion-navbar>
 *     <ion-buttons start>
 *       <button ion-button>
 *         <ion-icon name="contact"></ion-icon>
 *       </button>
 *     </ion-buttons>
 *     <button ion-button menuToggle>
 *       <ion-icon name="menu"></ion-icon>
 *     </button>
 *     <ion-title>
 *       Title
 *     </ion-title>
 *     <ion-buttons end>
 *       <button ion-button (click)="doClick()">
 *         <ion-icon name="more"></ion-icon>
 *       </button>
 *     </ion-buttons>
 *   </ion-navbar>
 *
 * </ion-header>
 * ```
 *
 * Similar to `<ion-buttons>`, the `menuToggle` can be positioned using
 * `start`, `end`, `left`, or `right`:
 *
 * ```html
 * <ion-toolbar>
 *   <button ion-button menuToggle right>
 *     <ion-icon name="menu"></ion-icon>
 *   </button>
 *   <ion-title>
 *     Title
 *   </ion-title>
 *   <ion-buttons end>
 *     <button ion-button (click)="doClick()">
 *       <ion-icon name="more"></ion-icon>
 *     </button>
 *   </ion-buttons>
 * </ion-toolbar>
 * ```
 *
 * See the [Toolbar API docs](../../toolbar/Toolbar) for more information
 * on the different positions.
 *
 * @demo /docs/demos/src/menu/
 * @see {@link /docs/components#menus Menu Component Docs}
 * @see {@link ../../menu/Menu Menu API Docs}
 */
var MenuToggle = (function () {
    function MenuToggle(_menu, _viewCtrl, _button, _navbar) {
        this._menu = _menu;
        this._viewCtrl = _viewCtrl;
        this._button = _button;
        this._isButton = !!_button;
        this._inNavbar = !!_navbar;
    }
    MenuToggle.prototype.ngAfterContentInit = function () {
        // Add the bar-button-menutoggle / button-menutoggle class
        if (this._isButton) {
            this._button._setClass('menutoggle', true);
        }
    };
    /**
    * @hidden
    */
    MenuToggle.prototype.toggle = function () {
        var menu = this._menu.get(this.menuToggle);
        menu && menu.toggle();
    };
    Object.defineProperty(MenuToggle.prototype, "isHidden", {
        /**
        * @hidden
        */
        get: function () {
            var menu = this._menu.get(this.menuToggle);
            if (this._inNavbar && this._viewCtrl) {
                if (!menu || !menu._canOpen()) {
                    return true;
                }
                if (this._viewCtrl.isFirst()) {
                    // this is the first view, so it should always show
                    return false;
                }
                if (menu) {
                    // this is not the root view, so see if this menu
                    // is configured to still be enabled if it's not the root view
                    return !menu.persistent;
                }
            }
            return false;
        },
        enumerable: true,
        configurable: true
    });
    MenuToggle.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: '[menuToggle]',
                    host: {
                        '[hidden]': 'isHidden'
                    }
                },] },
    ];
    /** @nocollapse */
    MenuToggle.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_2__app_menu_controller__["a" /* MenuController */], },
        { type: __WEBPACK_IMPORTED_MODULE_4__navigation_view_controller__["a" /* ViewController */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
        { type: __WEBPACK_IMPORTED_MODULE_1__button_button__["a" /* Button */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
        { type: __WEBPACK_IMPORTED_MODULE_3__toolbar_navbar__["a" /* Navbar */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
    ]; };
    MenuToggle.propDecorators = {
        'menuToggle': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'toggle': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"], args: ['click',] },],
    };
    return MenuToggle;
}());

//# sourceMappingURL=menu-toggle.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/menu/menu-types.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MenuType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__animations_animation__ = __webpack_require__("./node_modules/ionic-angular/animations/animation.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_menu_controller__ = __webpack_require__("./node_modules/ionic-angular/components/app/menu-controller.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


/**
 * @hidden
 * Menu Type
 * Base class which is extended by the various types. Each
 * type will provide their own animations for open and close
 * and registers itself with Menu.
 */
var MenuType = (function () {
    function MenuType(plt) {
        this.ani = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](plt);
        this.ani
            .easing('cubic-bezier(0.0, 0.0, 0.2, 1)')
            .easingReverse('cubic-bezier(0.4, 0.0, 0.6, 1)')
            .duration(280);
    }
    MenuType.prototype.setOpen = function (shouldOpen, animated, done) {
        var ani = this.ani
            .onFinish(done, true, true)
            .reverse(!shouldOpen);
        if (animated) {
            ani.play();
        }
        else {
            ani.syncPlay();
        }
    };
    MenuType.prototype.setProgressStart = function (isOpen) {
        this.isOpening = !isOpen;
        // the cloned animation should not use an easing curve during seek
        this.ani
            .reverse(isOpen)
            .progressStart();
    };
    MenuType.prototype.setProgessStep = function (stepValue) {
        // adjust progress value depending if it opening or closing
        this.ani.progressStep(stepValue);
    };
    MenuType.prototype.setProgressEnd = function (shouldComplete, currentStepValue, velocity, done) {
        var _this = this;
        var isOpen = (this.isOpening && shouldComplete);
        if (!this.isOpening && !shouldComplete) {
            isOpen = true;
        }
        var ani = this.ani;
        ani.onFinish(function () {
            _this.isOpening = false;
            done(isOpen);
        }, true);
        var factor = 1 - Math.min(Math.abs(velocity) / 4, 0.7);
        var dur = ani.getDuration() * factor;
        ani.progressEnd(shouldComplete, currentStepValue, dur);
    };
    MenuType.prototype.destroy = function () {
        this.ani.destroy();
        this.ani = null;
    };
    return MenuType;
}());

/**
 * @hidden
 * Menu Reveal Type
 * The content slides over to reveal the menu underneath.
 * The menu itself, which is under the content, does not move.
 */
var MenuRevealType = (function (_super) {
    __extends(MenuRevealType, _super);
    function MenuRevealType(menu, plt) {
        var _this = _super.call(this, plt) || this;
        var openedX = (menu.width() * (menu.isRightSide ? -1 : 1)) + 'px';
        var contentOpen = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](plt, menu.getContentElement());
        contentOpen.fromTo('translateX', '0px', openedX);
        _this.ani.add(contentOpen);
        return _this;
    }
    return MenuRevealType;
}(MenuType));
__WEBPACK_IMPORTED_MODULE_1__app_menu_controller__["a" /* MenuController */].registerType('reveal', MenuRevealType);
/**
 * @hidden
 * Menu Push Type
 * The content slides over to reveal the menu underneath.
 * The menu itself also slides over to reveal its bad self.
 */
var MenuPushType = (function (_super) {
    __extends(MenuPushType, _super);
    function MenuPushType(menu, plt) {
        var _this = _super.call(this, plt) || this;
        var contentOpenedX, menuClosedX, menuOpenedX;
        var width = menu.width();
        if (menu.isRightSide) {
            // right side
            contentOpenedX = -width + 'px';
            menuClosedX = width + 'px';
            menuOpenedX = '0px';
        }
        else {
            contentOpenedX = width + 'px';
            menuOpenedX = '0px';
            menuClosedX = -width + 'px';
        }
        var menuAni = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](plt, menu.getMenuElement());
        menuAni.fromTo('translateX', menuClosedX, menuOpenedX);
        _this.ani.add(menuAni);
        var contentApi = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](plt, menu.getContentElement());
        contentApi.fromTo('translateX', '0px', contentOpenedX);
        _this.ani.add(contentApi);
        return _this;
    }
    return MenuPushType;
}(MenuType));
__WEBPACK_IMPORTED_MODULE_1__app_menu_controller__["a" /* MenuController */].registerType('push', MenuPushType);
/**
 * @hidden
 * Menu Overlay Type
 * The menu slides over the content. The content
 * itself, which is under the menu, does not move.
 */
var MenuOverlayType = (function (_super) {
    __extends(MenuOverlayType, _super);
    function MenuOverlayType(menu, plt) {
        var _this = _super.call(this, plt) || this;
        var closedX, openedX;
        var width = menu.width();
        if (menu.isRightSide) {
            // right side
            closedX = 8 + width + 'px';
            openedX = '0px';
        }
        else {
            // left side
            closedX = -(8 + width) + 'px';
            openedX = '0px';
        }
        var menuAni = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](plt, menu.getMenuElement());
        menuAni.fromTo('translateX', closedX, openedX);
        _this.ani.add(menuAni);
        var backdropApi = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](plt, menu.getBackdropElement());
        backdropApi.fromTo('opacity', 0.01, 0.35);
        _this.ani.add(backdropApi);
        return _this;
    }
    return MenuOverlayType;
}(MenuType));
__WEBPACK_IMPORTED_MODULE_1__app_menu_controller__["a" /* MenuController */].registerType('overlay', MenuOverlayType);
//# sourceMappingURL=menu-types.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/menu/menu.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Menu; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_app__ = __webpack_require__("./node_modules/ionic-angular/components/app/app.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__backdrop_backdrop__ = __webpack_require__("./node_modules/ionic-angular/components/backdrop/backdrop.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__content_content__ = __webpack_require__("./node_modules/ionic-angular/components/content/content.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__platform_dom_controller__ = __webpack_require__("./node_modules/ionic-angular/platform/dom-controller.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__gestures_gesture_controller__ = __webpack_require__("./node_modules/ionic-angular/gestures/gesture-controller.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__platform_keyboard__ = __webpack_require__("./node_modules/ionic-angular/platform/keyboard.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__menu_gestures__ = __webpack_require__("./node_modules/ionic-angular/components/menu/menu-gestures.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__app_menu_controller__ = __webpack_require__("./node_modules/ionic-angular/components/app/menu-controller.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__nav_nav__ = __webpack_require__("./node_modules/ionic-angular/components/nav/nav.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__platform_platform__ = __webpack_require__("./node_modules/ionic-angular/platform/platform.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__gestures_ui_event_manager__ = __webpack_require__("./node_modules/ionic-angular/gestures/ui-event-manager.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__split_pane_split_pane__ = __webpack_require__("./node_modules/ionic-angular/components/split-pane/split-pane.js");















/**
 * @name Menu
 * @description
 * The Menu component is a navigation drawer that slides in from the side of the current
 * view. By default, it slides in from the left, but the side can be overridden. The menu
 * will be displayed differently based on the mode, however the display type can be changed
 * to any of the available [menu types](#menu-types). The menu element should be a sibling
 * to the app's content element. There can be any number of menus attached to the content.
 * These can be controlled from the templates, or programmatically using the [MenuController](../../app/MenuController).
 *
 * @usage
 *
 * ```html
 * <ion-menu [content]="mycontent">
 *   <ion-content>
 *     <ion-list>
 *       <p>some menu content, could be list items</p>
 *     </ion-list>
 *   </ion-content>
 * </ion-menu>
 *
 * <ion-nav #mycontent [root]="rootPage"></ion-nav>
 * ```
 *
 * To add a menu to an app, the `<ion-menu>` element should be added as a sibling to the `ion-nav` it will belong
 * to. A [local variable](https://angular.io/docs/ts/latest/guide/user-input.html#local-variables)
 * should be added to the `ion-nav` and passed to the `ion-menu`s `content` property.
 *
 * This tells the menu what it is bound to and what element to watch for gestures.
 * In the below example, `content` is using [property binding](https://angular.io/docs/ts/latest/guide/template-syntax.html#!#property-binding)
 * because `mycontent` is a reference to the `<ion-nav>` element, and not a string.
 *
 *
 * ### Opening/Closing Menus
 *
 * There are several ways to open or close a menu. The menu can be **toggled** open or closed
 * from the template using the [MenuToggle](../MenuToggle) directive. It can also be
 * **closed** from the template using the [MenuClose](../MenuClose) directive. To display a menu
 * programmatically, inject the [MenuController](../MenuController) provider and call any of the
 * `MenuController` methods.
 *
 *
 * ### Menu Types
 *
 * The menu supports several display types: `overlay`, `reveal` and `push`. By default,
 * it will use the correct type based on the mode, but this can be changed. The default
 * type for both Material Design and Windows mode is `overlay`, and `reveal` is the default
 * type for iOS mode. The menu type can be changed in the app's [config](../../config/Config)
 * via the `menuType` property, or passed in the `type` property on the `<ion-menu>` element.
 * See [usage](#usage) below for examples of changing the menu type.
 *
 *
 * ### Navigation Bar Behavior
 *
 * If a [MenuToggle](../MenuToggle) button is added to the [Navbar](../../navbar/Navbar) of
 * a page, the button will only appear when the page it's in is currently a root page. The
 * root page is the initial page loaded in the app, or a page that has been set as the root
 * using the [setRoot](../../nav/NavController/#setRoot) method on the [NavController](../../nav/NavController).
 *
 * For example, say the application has two pages, `Page1` and `Page2`, and both have a
 * `MenuToggle` button in their navigation bars. Assume the initial page loaded into the app
 * is `Page1`, making it the root page. `Page1` will display the `MenuToggle` button, but once
 * `Page2` is pushed onto the navigation stack, the `MenuToggle` will not be displayed.
 *
 *
 * ### Persistent Menus
 *
 * Persistent menus display the [MenuToggle](../MenuToggle) button in the [Navbar](../../navbar/Navbar)
 * on all pages in the navigation stack. To make a menu persistent set `persistent` to `true` on the
 * `<ion-menu>` element. Note that this will only affect the `MenuToggle` button in the `Navbar` attached
 * to the `Menu` with `persistent` set to true, any other `MenuToggle` buttons will not be affected.
 * ### Menu Side
 *
 * By default, menus slide in from the left, but this can be overridden by passing `right`
 * to the `side` property:
 *
 * ```html
 * <ion-menu side="right" [content]="mycontent">...</ion-menu>
 * ```
 *
 *
 * ### Menu Type
 *
 * The menu type can be changed by passing the value to `type` on the `<ion-menu>`:
 *
 * ```html
 * <ion-menu type="overlay" [content]="mycontent">...</ion-menu>
 * ```
 *
 * It can also be set in the app's config. The below will set the menu type to
 * `push` for all modes, and then set the type to `overlay` for the `ios` mode.
 *
 * ```ts
 * // in NgModules
 *
 * imports: [
 *   IonicModule.forRoot(MyApp,{
 *     menuType: 'push',
 *     platforms: {
 *       ios: {
 *         menuType: 'overlay',
 *       }
 *     }
 *   })
 * ],
 * ```
 *
 *
 * ### Displaying the Menu
 *
 * To toggle a menu from the template, add a button with the `menuToggle`
 * directive anywhere in the page's template:
 *
 * ```html
 * <button ion-button menuToggle>Toggle Menu</button>
 * ```
 *
 * To close a menu, add the `menuClose` button. It can be added anywhere
 * in the content, or even the menu itself. Below it is added to the menu's
 * content:
 *
 * ```html
 * <ion-menu [content]="mycontent">
 *   <ion-content>
 *     <ion-list>
 *       <ion-item menuClose detail-none>Close Menu</ion-item>
 *     </ion-list>
 *   </ion-content>
 * </ion-menu>
 * ```
 *
 * See the [MenuToggle](../MenuToggle) and [MenuClose](../MenuClose) docs
 * for more information on these directives.
 *
 * The menu can also be controlled from the Page by using the `MenuController`.
 * Inject the `MenuController` provider into the page and then call any of its
 * methods. In the below example, the `openMenu` method will open the menu
 * when it is called.
 *
 * ```ts
 * import { Component } from '@angular/core';
 * import { MenuController } from 'ionic-angular';
 *
 * @Component({...})
 * export class MyPage {
 *  constructor(public menuCtrl: MenuController) {}
 *
 *  openMenu() {
 *    this.menuCtrl.open();
 *  }
 * }
 * ```
 *
 * See the [MenuController](../../app/MenuController) API docs for all of the methods
 * and usage information.
 *
 *
 * @demo /docs/demos/src/menu/
 *
 * @see {@link /docs/components#menus Menu Component Docs}
 * @see {@link ../../app/MenuController MenuController API Docs}
 * @see {@link ../../nav/Nav Nav API Docs}
 * @see {@link ../../nav/NavController NavController API Docs}
 */
var Menu = (function () {
    function Menu(_menuCtrl, _elementRef, _config, _plt, _renderer, _keyboard, _gestureCtrl, _domCtrl, _app) {
        this._menuCtrl = _menuCtrl;
        this._elementRef = _elementRef;
        this._config = _config;
        this._plt = _plt;
        this._renderer = _renderer;
        this._keyboard = _keyboard;
        this._gestureCtrl = _gestureCtrl;
        this._domCtrl = _domCtrl;
        this._app = _app;
        this._isSwipeEnabled = true;
        this._isAnimating = false;
        this._isPersistent = false;
        this._init = false;
        this._isPane = false;
        /**
         * @hidden
         */
        this.isOpen = false;
        /**
         * @hidden
         */
        this.isRightSide = false;
        /**
         * @output {event} Emitted when the menu is being dragged open.
         */
        this.ionDrag = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
         * @output {event} Emitted when the menu has been opened.
         */
        this.ionOpen = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
         * @output {event} Emitted when the menu has been closed.
         */
        this.ionClose = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this._events = new __WEBPACK_IMPORTED_MODULE_13__gestures_ui_event_manager__["a" /* UIEventManager */](_plt);
        this._gestureBlocker = _gestureCtrl.createBlocker({
            disable: [__WEBPACK_IMPORTED_MODULE_6__gestures_gesture_controller__["c" /* GESTURE_GO_BACK_SWIPE */]]
        });
        this.side = 'start';
    }
    Object.defineProperty(Menu.prototype, "enabled", {
        /**
         * @input {boolean} If true, the menu is enabled. Default `true`.
         */
        get: function () {
            return this._isEnabled;
        },
        set: function (val) {
            var isEnabled = Object(__WEBPACK_IMPORTED_MODULE_7__util_util__["o" /* isTrueProperty */])(val);
            this.enable(isEnabled);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Menu.prototype, "side", {
        /**
         * @input {string} Which side of the view the menu should be placed. Default `"left"`.
         */
        get: function () {
            return this._side;
        },
        set: function (val) {
            this.isRightSide = Object(__WEBPACK_IMPORTED_MODULE_7__util_util__["m" /* isRightSide */])(val, this._plt.isRTL);
            if (this.isRightSide) {
                this._side = 'right';
            }
            else {
                this._side = 'left';
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Menu.prototype, "swipeEnabled", {
        /**
         * @input {boolean} If true, swiping the menu is enabled. Default `true`.
         */
        get: function () {
            return this._isSwipeEnabled;
        },
        set: function (val) {
            var isEnabled = Object(__WEBPACK_IMPORTED_MODULE_7__util_util__["o" /* isTrueProperty */])(val);
            this.swipeEnable(isEnabled);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Menu.prototype, "persistent", {
        /**
         * @input {boolean} If true, the menu will persist on child pages.
         */
        get: function () {
            return this._isPersistent;
        },
        set: function (val) {
            this._isPersistent = Object(__WEBPACK_IMPORTED_MODULE_7__util_util__["o" /* isTrueProperty */])(val);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @hidden
     */
    Menu.prototype.ngOnInit = function () {
        var _this = this;
        this._init = true;
        var content = this.content;
        this._cntEle = (content instanceof Node) ? content : content && content.getNativeElement && content.getNativeElement();
        // requires content element
        if (!this._cntEle) {
            return console.error('Menu: must have a [content] element to listen for drag events on. Example:\n\n<ion-menu [content]="content"></ion-menu>\n\n<ion-nav #content></ion-nav>');
        }
        this.setElementAttribute('side', this._side);
        // normalize the "type"
        if (!this.type) {
            this.type = this._config.get('menuType');
        }
        this.setElementAttribute('type', this.type);
        // add the gestures
        this._gesture = new __WEBPACK_IMPORTED_MODULE_9__menu_gestures__["a" /* MenuContentGesture */](this._plt, this, this._gestureCtrl, this._domCtrl);
        // add menu's content classes
        this._cntEle.classList.add('menu-content');
        this._cntEle.classList.add('menu-content-' + this.type);
        var isEnabled = this._isEnabled;
        if (isEnabled === true || typeof isEnabled === 'undefined') {
            // check if more than one menu is on the same side
            isEnabled = !this._menuCtrl.getMenus().some(function (m) {
                return m.side === _this.side && m.enabled;
            });
        }
        // register this menu with the app's menu controller
        this._menuCtrl._register(this);
        // mask it as enabled / disabled
        this.enable(isEnabled);
    };
    /**
     * @hidden
     */
    Menu.prototype.onBackdropClick = function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        this._menuCtrl.close();
    };
    /**
     * @hidden
     */
    Menu.prototype._getType = function () {
        if (!this._type) {
            this._type = __WEBPACK_IMPORTED_MODULE_10__app_menu_controller__["a" /* MenuController */].create(this.type, this, this._plt);
            if (this._config.get('animate') === false) {
                this._type.ani.duration(0);
            }
        }
        return this._type;
    };
    /**
     * @hidden
     */
    Menu.prototype.setOpen = function (shouldOpen, animated) {
        var _this = this;
        if (animated === void 0) { animated = true; }
        // If the menu is disabled or it is currenly being animated, let's do nothing
        if ((shouldOpen === this.isOpen) || !this._canOpen() || this._isAnimating) {
            return Promise.resolve(this.isOpen);
        }
        return new Promise(function (resolve) {
            _this._before();
            _this._getType().setOpen(shouldOpen, animated, function () {
                _this._after(shouldOpen);
                resolve(_this.isOpen);
            });
        });
    };
    Menu.prototype._forceClosing = function () {
        var _this = this;
        (void 0) /* assert */;
        this._isAnimating = true;
        this._getType().setOpen(false, false, function () {
            _this._after(false);
        });
    };
    /**
     * @hidden
     */
    Menu.prototype.canSwipe = function () {
        return this._isSwipeEnabled &&
            !this._isAnimating &&
            this._canOpen() &&
            this._app.isEnabled();
    };
    /**
     * @hidden
     */
    Menu.prototype.isAnimating = function () {
        return this._isAnimating;
    };
    Menu.prototype._swipeBeforeStart = function () {
        if (!this.canSwipe()) {
            (void 0) /* assert */;
            return;
        }
        this._before();
    };
    Menu.prototype._swipeStart = function () {
        if (!this._isAnimating) {
            (void 0) /* assert */;
            return;
        }
        this._getType().setProgressStart(this.isOpen);
    };
    Menu.prototype._swipeProgress = function (stepValue) {
        if (!this._isAnimating) {
            (void 0) /* assert */;
            return;
        }
        this._getType().setProgessStep(stepValue);
        var ionDrag = this.ionDrag;
        if (ionDrag.observers.length > 0) {
            ionDrag.emit(stepValue);
        }
    };
    Menu.prototype._swipeEnd = function (shouldCompleteLeft, shouldCompleteRight, stepValue, velocity) {
        var _this = this;
        if (!this._isAnimating) {
            (void 0) /* assert */;
            return;
        }
        // user has finished dragging the menu
        var isRightSide = this.isRightSide;
        var isRTL = this._plt.isRTL;
        var opening = !this.isOpen;
        var shouldComplete = (opening)
            ? (isRightSide !== isRTL) ? shouldCompleteLeft : shouldCompleteRight
            : (isRightSide !== isRTL) ? shouldCompleteRight : shouldCompleteLeft;
        this._getType().setProgressEnd(shouldComplete, stepValue, velocity, function (isOpen) {
            (void 0) /* console.debug */;
            _this._after(isOpen);
        });
    };
    Menu.prototype._before = function () {
        (void 0) /* assert */;
        // this places the menu into the correct location before it animates in
        // this css class doesn't actually kick off any animations
        this.setElementClass('show-menu', true);
        this.backdrop.setElementClass('show-backdrop', true);
        this.resize();
        this._keyboard.close();
        this._isAnimating = true;
    };
    Menu.prototype._after = function (isOpen) {
        (void 0) /* assert */;
        this._app.setEnabled(false, 100);
        // keep opening/closing the menu disabled for a touch more yet
        // only add listeners/css if it's enabled and isOpen
        // and only remove listeners/css if it's not open
        // emit opened/closed events
        this.isOpen = isOpen;
        this._isAnimating = false;
        this._events.unlistenAll();
        if (isOpen) {
            // Disable swipe to go back gesture
            this._gestureBlocker.block();
            this._cntEle.classList.add('menu-content-open');
            var callback = this.onBackdropClick.bind(this);
            this._events.listen(this._cntEle, 'click', callback, { capture: true });
            this._events.listen(this.backdrop.getNativeElement(), 'click', callback, { capture: true });
            this.ionOpen.emit(true);
        }
        else {
            // Enable swipe to go back gesture
            this._gestureBlocker.unblock();
            this._cntEle.classList.remove('menu-content-open');
            this.setElementClass('show-menu', false);
            this.backdrop.setElementClass('show-menu', false);
            this.ionClose.emit(true);
        }
    };
    /**
     * @hidden
     */
    Menu.prototype.open = function () {
        return this.setOpen(true);
    };
    /**
     * @hidden
     */
    Menu.prototype.close = function () {
        return this.setOpen(false);
    };
    /**
     * @hidden
     */
    Menu.prototype.resize = function () {
        var content = this.menuContent
            ? this.menuContent
            : this.menuNav;
        content && content.resize();
    };
    /**
     * @hidden
     */
    Menu.prototype.toggle = function () {
        return this.setOpen(!this.isOpen);
    };
    Menu.prototype._canOpen = function () {
        return this._isEnabled && !this._isPane;
    };
    /**
     * @hidden
     */
    Menu.prototype._updateState = function () {
        var canOpen = this._canOpen();
        // Close menu inmediately
        if (!canOpen && this.isOpen) {
            (void 0) /* assert */;
            // close if this menu is open, and should not be enabled
            this._forceClosing();
        }
        if (this._isEnabled && this._menuCtrl) {
            this._menuCtrl._setActiveMenu(this);
        }
        if (!this._init) {
            return;
        }
        var gesture = this._gesture;
        // only listen/unlisten if the menu has initialized
        if (canOpen && this._isSwipeEnabled && !gesture.isListening) {
            // should listen, but is not currently listening
            (void 0) /* console.debug */;
            gesture.listen();
        }
        else if (gesture.isListening && (!canOpen || !this._isSwipeEnabled)) {
            // should not listen, but is currently listening
            (void 0) /* console.debug */;
            gesture.unlisten();
        }
        if (this.isOpen || (this._isPane && this._isEnabled)) {
            this.resize();
        }
        (void 0) /* assert */;
    };
    /**
     * @hidden
     */
    Menu.prototype.enable = function (shouldEnable) {
        this._isEnabled = shouldEnable;
        this.setElementClass('menu-enabled', shouldEnable);
        this._updateState();
        return this;
    };
    /**
     * @internal
     */
    Menu.prototype.initPane = function () {
        return false;
    };
    /**
     * @internal
     */
    Menu.prototype.paneChanged = function (isPane) {
        this._isPane = isPane;
        this._updateState();
    };
    /**
     * @hidden
     */
    Menu.prototype.swipeEnable = function (shouldEnable) {
        this._isSwipeEnabled = shouldEnable;
        this._updateState();
        return this;
    };
    /**
     * @hidden
     */
    Menu.prototype.getNativeElement = function () {
        return this._elementRef.nativeElement;
    };
    /**
     * @hidden
     */
    Menu.prototype.getMenuElement = function () {
        return this.getNativeElement().querySelector('.menu-inner');
    };
    /**
     * @hidden
     */
    Menu.prototype.getContentElement = function () {
        return this._cntEle;
    };
    /**
     * @hidden
     */
    Menu.prototype.getBackdropElement = function () {
        return this.backdrop.getNativeElement();
    };
    /**
     * @hidden
     */
    Menu.prototype.width = function () {
        return this.getMenuElement().offsetWidth;
    };
    /**
     * @hidden
     */
    Menu.prototype.getMenuController = function () {
        return this._menuCtrl;
    };
    /**
     * @hidden
     */
    Menu.prototype.setElementClass = function (className, add) {
        this._renderer.setElementClass(this._elementRef.nativeElement, className, add);
    };
    /**
     * @hidden
     */
    Menu.prototype.setElementAttribute = function (attributeName, value) {
        this._renderer.setElementAttribute(this._elementRef.nativeElement, attributeName, value);
    };
    /**
     * @hidden
     */
    Menu.prototype.getElementRef = function () {
        return this._elementRef;
    };
    /**
     * @hidden
     */
    Menu.prototype.ngOnDestroy = function () {
        this._menuCtrl._unregister(this);
        this._events.destroy();
        this._gesture && this._gesture.destroy();
        this._type && this._type.destroy();
        this._gesture = null;
        this._type = null;
        this._cntEle = null;
    };
    Menu.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'ion-menu',
                    template: '<div class="menu-inner"><ng-content></ng-content></div>' +
                        '<ion-backdrop></ion-backdrop>',
                    host: {
                        'role': 'navigation'
                    },
                    changeDetection: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectionStrategy"].OnPush,
                    encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None,
                    providers: [{ provide: __WEBPACK_IMPORTED_MODULE_14__split_pane_split_pane__["a" /* RootNode */], useExisting: Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return Menu; }) }]
                },] },
    ];
    /** @nocollapse */
    Menu.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_10__app_menu_controller__["a" /* MenuController */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_3__config_config__["a" /* Config */], },
        { type: __WEBPACK_IMPORTED_MODULE_12__platform_platform__["a" /* Platform */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: __WEBPACK_IMPORTED_MODULE_8__platform_keyboard__["a" /* Keyboard */], },
        { type: __WEBPACK_IMPORTED_MODULE_6__gestures_gesture_controller__["m" /* GestureController */], },
        { type: __WEBPACK_IMPORTED_MODULE_5__platform_dom_controller__["a" /* DomController */], },
        { type: __WEBPACK_IMPORTED_MODULE_1__app_app__["a" /* App */], },
    ]; };
    Menu.propDecorators = {
        'backdrop': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"], args: [__WEBPACK_IMPORTED_MODULE_2__backdrop_backdrop__["a" /* Backdrop */],] },],
        'menuContent': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChild"], args: [__WEBPACK_IMPORTED_MODULE_4__content_content__["a" /* Content */],] },],
        'menuNav': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChild"], args: [__WEBPACK_IMPORTED_MODULE_11__nav_nav__["a" /* Nav */],] },],
        'content': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'id': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'type': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'enabled': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'side': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'swipeEnabled': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'persistent': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'maxEdgeStart': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'ionDrag': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        'ionOpen': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        'ionClose': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    };
    return Menu;
}());

//# sourceMappingURL=menu.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/modal/modal-component.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModalCmp; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__platform_key__ = __webpack_require__("./node_modules/ionic-angular/platform/key.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__navigation_nav_params__ = __webpack_require__("./node_modules/ionic-angular/navigation/nav-params.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__navigation_view_controller__ = __webpack_require__("./node_modules/ionic-angular/navigation/view-controller.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__gestures_gesture_controller__ = __webpack_require__("./node_modules/ionic-angular/gestures/gesture-controller.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_module_loader__ = __webpack_require__("./node_modules/ionic-angular/util/module-loader.js");






/**
 * @hidden
 */
var ModalCmp = (function () {
    function ModalCmp(_cfr, _renderer, _elementRef, _navParams, _viewCtrl, gestureCtrl, moduleLoader) {
        this._cfr = _cfr;
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this._navParams = _navParams;
        this._viewCtrl = _viewCtrl;
        this.moduleLoader = moduleLoader;
        var opts = _navParams.get('opts');
        (void 0) /* assert */;
        this._gestureBlocker = gestureCtrl.createBlocker({
            disable: [__WEBPACK_IMPORTED_MODULE_4__gestures_gesture_controller__["e" /* GESTURE_MENU_SWIPE */], __WEBPACK_IMPORTED_MODULE_4__gestures_gesture_controller__["c" /* GESTURE_GO_BACK_SWIPE */]]
        });
        this._bdDismiss = opts.enableBackdropDismiss;
        if (opts.cssClass) {
            opts.cssClass.split(' ').forEach(function (cssClass) {
                // Make sure the class isn't whitespace, otherwise it throws exceptions
                if (cssClass.trim() !== '')
                    _renderer.setElementClass(_elementRef.nativeElement, cssClass, true);
            });
        }
    }
    ModalCmp.prototype.ionViewPreLoad = function () {
        var component = this._navParams.data.component;
        if (!component) {
            console.warn('modal\'s page was not defined');
            return;
        }
        var cfr = this.moduleLoader.getComponentFactoryResolver(component);
        if (!cfr) {
            cfr = this._cfr;
        }
        var componentFactory = cfr.resolveComponentFactory(component);
        // ******** DOM WRITE ****************
        var componentRef = this._viewport.createComponent(componentFactory, this._viewport.length, this._viewport.parentInjector, []);
        this._setCssClass(componentRef, 'ion-page');
        this._setCssClass(componentRef, 'show-page');
        // Change the viewcontroller's instance to point the user provided page
        // Lifecycle events will be sent to the new instance, instead of the modal's component
        // we need to manually subscribe to them
        this._viewCtrl._setInstance(componentRef.instance);
        this._viewCtrl.willEnter.subscribe(this._viewWillEnter.bind(this));
        this._viewCtrl.didLeave.subscribe(this._viewDidLeave.bind(this));
        this._enabled = true;
    };
    ModalCmp.prototype._viewWillEnter = function () {
        this._gestureBlocker.block();
    };
    ModalCmp.prototype._viewDidLeave = function () {
        this._gestureBlocker.unblock();
    };
    ModalCmp.prototype._setCssClass = function (componentRef, className) {
        this._renderer.setElementClass(componentRef.location.nativeElement, className, true);
    };
    ModalCmp.prototype._bdClick = function () {
        if (this._enabled && this._bdDismiss) {
            var opts = {
                minClickBlockDuration: 400
            };
            return this._viewCtrl.dismiss(null, 'backdrop', opts);
        }
    };
    ModalCmp.prototype._keyUp = function (ev) {
        if (this._enabled && this._viewCtrl.isLast() && ev.keyCode === __WEBPACK_IMPORTED_MODULE_1__platform_key__["c" /* KEY_ESCAPE */]) {
            this._bdClick();
        }
    };
    ModalCmp.prototype.ngOnDestroy = function () {
        (void 0) /* assert */;
        this._gestureBlocker.destroy();
    };
    ModalCmp.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'ion-modal',
                    template: '<ion-backdrop (click)="_bdClick()" [class.backdrop-no-tappable]="!_bdDismiss"></ion-backdrop>' +
                        '<div class="modal-wrapper">' +
                        '<div #viewport nav-viewport></div>' +
                        '</div>'
                },] },
    ];
    /** @nocollapse */
    ModalCmp.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ComponentFactoryResolver"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_2__navigation_nav_params__["a" /* NavParams */], },
        { type: __WEBPACK_IMPORTED_MODULE_3__navigation_view_controller__["a" /* ViewController */], },
        { type: __WEBPACK_IMPORTED_MODULE_4__gestures_gesture_controller__["m" /* GestureController */], },
        { type: __WEBPACK_IMPORTED_MODULE_5__util_module_loader__["b" /* ModuleLoader */], },
    ]; };
    ModalCmp.propDecorators = {
        '_viewport': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"], args: ['viewport', { read: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"] },] },],
        '_keyUp': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"], args: ['body:keyup', ['$event'],] },],
    };
    return ModalCmp;
}());

//# sourceMappingURL=modal-component.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/modal/modal-controller.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModalController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_app__ = __webpack_require__("./node_modules/ionic-angular/components/app/app.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modal__ = __webpack_require__("./node_modules/ionic-angular/components/modal/modal.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__navigation_deep_linker__ = __webpack_require__("./node_modules/ionic-angular/navigation/deep-linker.js");





/**
 * @name ModalController
 * @description
 * A Modal is a content pane that goes over the user's current page.
 * Usually it is used for making a choice or editing an item. A modal uses the
 * `NavController` to
 * {@link /docs/api/components/nav/NavController/#present present}
 * itself in the root nav stack. It is added to the stack similar to how
 * {@link /docs/api/components/nav/NavController/#push NavController.push}
 * works.
 *
 * When a modal (or any other overlay such as an alert or actionsheet) is
 * "presented" to a nav controller, the overlay is added to the app's root nav.
 * After the modal has been presented, from within the component instance, the
 * modal can later be closed or "dismissed" by using the ViewController's
 * `dismiss` method. Additionally, you can dismiss any overlay by using `pop`
 * on the root nav controller. Modals are not reusable. When a modal is dismissed
 * it is destroyed.
 *
 * Data can be passed to a new modal through `Modal.create()` as the second
 * argument. The data can then be accessed from the opened page by injecting
 * `NavParams`. Note that the page, which opened as a modal, has no special
 * "modal" logic within it, but uses `NavParams` no differently than a
 * standard page.
 *
 * @usage
 * ```ts
 * import { ModalController, NavParams } from 'ionic-angular';
 *
 * @Component(...)
 * class HomePage {
 *
 *  constructor(public modalCtrl: ModalController) { }
 *
 *  presentProfileModal() {
 *    const profileModal = this.modalCtrl.create(Profile, { userId: 8675309 });
 *    profileModal.present();
 *  }
 *
 * }
 *
 * @Component(...)
 * class Profile {
 *
 *  constructor(params: NavParams) {
 *    console.log('UserId', params.get('userId'));
 *  }
 *
 * }
 * ```
 *
 * @advanced
 *
 * | Option                | Type       | Description                                                                                                      |
 * |-----------------------|------------|------------------------------------------------------------------------------------------------------------------|
 * | showBackdrop          |`boolean`   | Whether to show the backdrop. Default true.                                                                      |
 * | enableBackdropDismiss |`boolean`   | Whether the popover should be dismissed by tapping the backdrop. Default true.                                   |
 * | cssClass              |`string`    | Additional classes for custom styles, separated by spaces.                                                       |
 *
 * A modal can also emit data, which is useful when it is used to add or edit
 * data. For example, a profile page could slide up in a modal, and on submit,
 * the submit button could pass the updated profile data, then dismiss the
 * modal.
 *
 * ```ts
 * import { Component } from '@angular/core';
 * import { ModalController, ViewController } from 'ionic-angular';
 *
 * @Component(...)
 * class HomePage {
 *
 *   constructor(public modalCtrl: ModalController) {
 *
 *   }
 *
 *   presentContactModal() {
 *     let contactModal = this.modalCtrl.create(ContactUs);
 *     contactModal.present();
 *   }
 *
 *   presentProfileModal() {
 *     let profileModal = this.modalCtrl.create(Profile, { userId: 8675309 });
 *
 *     // fires after dismiss animation finishes
 *     profileModal.onDidDismiss(data => {
 *       console.log(data);
 *     });
 *
 *     // fires before dismiss animation begins
 *     profileModal.onWillDismiss(data => {
 *       console.log(data);
 *     });
 *
 *     profileModal.present();
 *   }
 * }
 *
 * @Component(...)
 * class Profile {
 *
 *   constructor(public viewCtrl: ViewController) {
 *
 *   }
 *
 *   dismiss() {
 *     let data = { 'foo': 'bar' };
 *     this.viewCtrl.dismiss(data);
 *   }
 * }
 * ```
 *
 * A common issue is that a developer may try to implement navigation in a modal, but when you try NavController.push(),
 * you will notice that the status bar on iOS gets cut off. The proper way to implement navigation in a modal is to
 * make the modal component a navigation container, and set the root page to the page you want to show in your modal.
 *
 * ```ts
 * @Component({
 *   template: '<ion-nav [root]="rootPage" [rootParams]="rootParams"></ion-nav>'
 * })
 * export class MyModalWrapper {
 *   rootPage = 'MyModalContentPage'; // This is the page you want your modal to display
 *   rootParams;
 *
 *   constructor(navParams: NavParams, private viewCtrl: ViewController) {
 *       this.rootParams = Object.assign({}, navParams.data, {viewCtrl: viewCtrl});
 *       // This line will send the view controller into your child views, so you can dismiss the modals from there.
 *   }
 * }
 * ```
 * @demo /docs/demos/src/modal/
 * @see {@link /docs/components#modals Modal Component Docs}
 */
var ModalController = (function () {
    function ModalController(_app, config, deepLinker) {
        this._app = _app;
        this.config = config;
        this.deepLinker = deepLinker;
    }
    /**
     * Create a modal to display. See below for options.
     *
     * @param {object} component The Modal view
     * @param {object} data Any data to pass to the Modal view
     * @param {object} opts Modal options
     */
    ModalController.prototype.create = function (component, data, opts) {
        if (data === void 0) { data = {}; }
        if (opts === void 0) { opts = {}; }
        return new __WEBPACK_IMPORTED_MODULE_3__modal__["a" /* Modal */](this._app, component, data, opts, this.config, this.deepLinker);
    };
    ModalController.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    ModalController.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__app_app__["a" /* App */], },
        { type: __WEBPACK_IMPORTED_MODULE_2__config_config__["a" /* Config */], },
        { type: __WEBPACK_IMPORTED_MODULE_4__navigation_deep_linker__["a" /* DeepLinker */], },
    ]; };
    return ModalController;
}());

//# sourceMappingURL=modal-controller.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/modal/modal-impl.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModalImpl; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_app_constants__ = __webpack_require__("./node_modules/ionic-angular/components/app/app-constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal_component__ = __webpack_require__("./node_modules/ionic-angular/components/modal/modal-component.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modal_transitions__ = __webpack_require__("./node_modules/ionic-angular/components/modal/modal-transitions.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__navigation_view_controller__ = __webpack_require__("./node_modules/ionic-angular/navigation/view-controller.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





/**
 * @hidden
 */
var ModalImpl = (function (_super) {
    __extends(ModalImpl, _super);
    function ModalImpl(app, component, data, opts, config) {
        if (opts === void 0) { opts = {}; }
        var _this = this;
        data = data || {};
        data.component = component;
        opts.showBackdrop = Object(__WEBPACK_IMPORTED_MODULE_0__util_util__["l" /* isPresent */])(opts.showBackdrop) ? !!opts.showBackdrop : true;
        opts.enableBackdropDismiss = Object(__WEBPACK_IMPORTED_MODULE_0__util_util__["l" /* isPresent */])(opts.enableBackdropDismiss) ? !!opts.enableBackdropDismiss : true;
        data.opts = opts;
        _this = _super.call(this, __WEBPACK_IMPORTED_MODULE_2__modal_component__["a" /* ModalCmp */], data, null) || this;
        _this._app = app;
        _this._enterAnimation = opts.enterAnimation;
        _this._leaveAnimation = opts.leaveAnimation;
        _this.isOverlay = true;
        config.setTransition('modal-slide-in', __WEBPACK_IMPORTED_MODULE_3__modal_transitions__["c" /* ModalSlideIn */]);
        config.setTransition('modal-slide-out', __WEBPACK_IMPORTED_MODULE_3__modal_transitions__["d" /* ModalSlideOut */]);
        config.setTransition('modal-md-slide-in', __WEBPACK_IMPORTED_MODULE_3__modal_transitions__["a" /* ModalMDSlideIn */]);
        config.setTransition('modal-md-slide-out', __WEBPACK_IMPORTED_MODULE_3__modal_transitions__["b" /* ModalMDSlideOut */]);
        return _this;
    }
    /**
     * @hidden
     */
    ModalImpl.prototype.getTransitionName = function (direction) {
        var key;
        if (direction === 'back') {
            if (this._leaveAnimation) {
                return this._leaveAnimation;
            }
            key = 'modalLeave';
        }
        else {
            if (this._enterAnimation) {
                return this._enterAnimation;
            }
            key = 'modalEnter';
        }
        return this._nav && this._nav.config.get(key);
    };
    /**
     * Present the action sheet instance.
     *
     * @param {NavOptions} [navOptions={}] Nav options to go with this transition.
     * @returns {Promise} Returns a promise which is resolved when the transition has completed.
     */
    ModalImpl.prototype.present = function (navOptions) {
        if (navOptions === void 0) { navOptions = {}; }
        navOptions.minClickBlockDuration = navOptions.minClickBlockDuration || 400;
        return this._app.present(this, navOptions, __WEBPACK_IMPORTED_MODULE_1__app_app_constants__["c" /* PORTAL_MODAL */]);
    };
    return ModalImpl;
}(__WEBPACK_IMPORTED_MODULE_4__navigation_view_controller__["a" /* ViewController */]));

//# sourceMappingURL=modal-impl.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/modal/modal-transitions.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ModalSlideIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ModalSlideOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModalMDSlideIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ModalMDSlideOut; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__animations_animation__ = __webpack_require__("./node_modules/ionic-angular/animations/animation.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__transitions_page_transition__ = __webpack_require__("./node_modules/ionic-angular/transitions/page-transition.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


/**
 * Animations for modals
 */
var ModalSlideIn = (function (_super) {
    __extends(ModalSlideIn, _super);
    function ModalSlideIn() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ModalSlideIn.prototype.init = function () {
        _super.prototype.init.call(this);
        var ele = this.enteringView.pageRef().nativeElement;
        var backdropEle = ele.querySelector('ion-backdrop');
        var backdrop = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](this.plt, backdropEle);
        var wrapper = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](this.plt, ele.querySelector('.modal-wrapper'));
        wrapper.beforeStyles({ 'opacity': 1 });
        wrapper.fromTo('translateY', '100%', '0%');
        backdrop.fromTo('opacity', 0.01, 0.4);
        this
            .element(this.enteringView.pageRef())
            .easing('cubic-bezier(0.36,0.66,0.04,1)')
            .duration(400)
            .add(backdrop)
            .add(wrapper);
    };
    return ModalSlideIn;
}(__WEBPACK_IMPORTED_MODULE_1__transitions_page_transition__["a" /* PageTransition */]));

var ModalSlideOut = (function (_super) {
    __extends(ModalSlideOut, _super);
    function ModalSlideOut() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ModalSlideOut.prototype.init = function () {
        _super.prototype.init.call(this);
        var ele = this.leavingView.pageRef().nativeElement;
        var backdrop = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](this.plt, ele.querySelector('ion-backdrop'));
        var wrapperEle = ele.querySelector('.modal-wrapper');
        var wrapperEleRect = wrapperEle.getBoundingClientRect();
        var wrapper = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](this.plt, wrapperEle);
        // height of the screen - top of the container tells us how much to scoot it down
        // so it's off-screen
        wrapper.fromTo('translateY', '0px', this.plt.height() - wrapperEleRect.top + "px");
        backdrop.fromTo('opacity', 0.4, 0.0);
        this
            .element(this.leavingView.pageRef())
            .easing('ease-out')
            .duration(250)
            .add(backdrop)
            .add(wrapper);
    };
    return ModalSlideOut;
}(__WEBPACK_IMPORTED_MODULE_1__transitions_page_transition__["a" /* PageTransition */]));

var ModalMDSlideIn = (function (_super) {
    __extends(ModalMDSlideIn, _super);
    function ModalMDSlideIn() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ModalMDSlideIn.prototype.init = function () {
        _super.prototype.init.call(this);
        var ele = this.enteringView.pageRef().nativeElement;
        var backdrop = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](this.plt, ele.querySelector('ion-backdrop'));
        var wrapper = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](this.plt, ele.querySelector('.modal-wrapper'));
        backdrop.fromTo('opacity', 0.01, 0.4);
        wrapper.fromTo('translateY', '40px', '0px');
        wrapper.fromTo('opacity', 0.01, 1);
        var DURATION = 280;
        var EASING = 'cubic-bezier(0.36,0.66,0.04,1)';
        this.element(this.enteringView.pageRef()).easing(EASING).duration(DURATION)
            .add(backdrop)
            .add(wrapper);
    };
    return ModalMDSlideIn;
}(__WEBPACK_IMPORTED_MODULE_1__transitions_page_transition__["a" /* PageTransition */]));

var ModalMDSlideOut = (function (_super) {
    __extends(ModalMDSlideOut, _super);
    function ModalMDSlideOut() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ModalMDSlideOut.prototype.init = function () {
        _super.prototype.init.call(this);
        var ele = this.leavingView.pageRef().nativeElement;
        var backdrop = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](this.plt, ele.querySelector('ion-backdrop'));
        var wrapper = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](this.plt, ele.querySelector('.modal-wrapper'));
        backdrop.fromTo('opacity', 0.4, 0.0);
        wrapper.fromTo('translateY', '0px', '40px');
        wrapper.fromTo('opacity', 0.99, 0);
        this
            .element(this.leavingView.pageRef())
            .duration(200)
            .easing('cubic-bezier(0.47,0,0.745,0.715)')
            .add(wrapper)
            .add(backdrop);
    };
    return ModalMDSlideOut;
}(__WEBPACK_IMPORTED_MODULE_1__transitions_page_transition__["a" /* PageTransition */]));

//# sourceMappingURL=modal-transitions.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/modal/modal.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Modal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__navigation_overlay_proxy__ = __webpack_require__("./node_modules/ionic-angular/navigation/overlay-proxy.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modal_impl__ = __webpack_require__("./node_modules/ionic-angular/components/modal/modal-impl.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


/**
 * @hidden
 */
var Modal = (function (_super) {
    __extends(Modal, _super);
    function Modal(app, component, data, opts, config, deepLinker) {
        if (opts === void 0) { opts = {}; }
        var _this = _super.call(this, app, component, config, deepLinker) || this;
        _this.data = data;
        _this.opts = opts;
        _this.isOverlay = true;
        return _this;
    }
    Modal.prototype.getImplementation = function () {
        return new __WEBPACK_IMPORTED_MODULE_1__modal_impl__["a" /* ModalImpl */](this._app, this._component, this.data, this.opts, this._config);
    };
    return Modal;
}(__WEBPACK_IMPORTED_MODULE_0__navigation_overlay_proxy__["a" /* OverlayProxy */]));

//# sourceMappingURL=modal.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/nav/nav-pop-anchor.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NavPopAnchor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__navigation_deep_linker__ = __webpack_require__("./node_modules/ionic-angular/navigation/deep-linker.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__navigation_view_controller__ = __webpack_require__("./node_modules/ionic-angular/navigation/view-controller.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nav_pop__ = __webpack_require__("./node_modules/ionic-angular/components/nav/nav-pop.js");




/**
 * @hidden
 */
var NavPopAnchor = (function () {
    function NavPopAnchor(host, linker, viewCtrl) {
        this.host = host;
        this.linker = linker;
        this.viewCtrl = viewCtrl;
    }
    NavPopAnchor.prototype.updateHref = function () {
        if (this.host && this.viewCtrl) {
            var previousView = this.host._nav.getPrevious(this.viewCtrl);
            this._href = (previousView && this.linker.createUrl(this.host._nav, this.viewCtrl.component, this.viewCtrl.data)) || '#';
        }
        else {
            this._href = '#';
        }
    };
    NavPopAnchor.prototype.ngAfterContentInit = function () {
        this.updateHref();
    };
    NavPopAnchor.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'a[navPop]',
                    host: {
                        '[attr.href]': '_href'
                    }
                },] },
    ];
    /** @nocollapse */
    NavPopAnchor.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_3__nav_pop__["a" /* NavPop */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
        { type: __WEBPACK_IMPORTED_MODULE_1__navigation_deep_linker__["a" /* DeepLinker */], },
        { type: __WEBPACK_IMPORTED_MODULE_2__navigation_view_controller__["a" /* ViewController */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
    ]; };
    return NavPopAnchor;
}());

//# sourceMappingURL=nav-pop-anchor.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/nav/nav-pop.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NavPop; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__navigation_nav_controller__ = __webpack_require__("./node_modules/ionic-angular/navigation/nav-controller.js");


/**
 * @name NavPop
 * @description
 * Directive to declaratively pop the current page off from the
 * navigation stack.
 *
 * @usage
 * ```html
 * <ion-content>
 *
 *  <button ion-button navPop>Go Back</button>
 *
 * </ion-content>
 * ```
 *
 * Similar to {@link /docs/api/components/nav/NavPush/ `NavPush` }
 * @demo /docs/demos/src/navigation/
 * @see {@link /docs/components#navigation Navigation Component Docs}
 * @see {@link ../NavPush NavPush API Docs}
 */
var NavPop = (function () {
    function NavPop(_nav) {
        this._nav = _nav;
        if (!_nav) {
            console.error('navPop must be within a NavController');
        }
    }
    /**
     * @hidden
     */
    NavPop.prototype.onClick = function () {
        // If no target, or if target is _self, prevent default browser behavior
        if (this._nav) {
            this._nav.pop().catch(function () {
                (void 0) /* console.debug */;
            });
            return false;
        }
        return true;
    };
    NavPop.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: '[navPop]'
                },] },
    ];
    /** @nocollapse */
    NavPop.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__navigation_nav_controller__["a" /* NavController */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
    ]; };
    NavPop.propDecorators = {
        'onClick': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"], args: ['click',] },],
    };
    return NavPop;
}());

//# sourceMappingURL=nav-pop.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/nav/nav-push-anchor.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NavPushAnchor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__navigation_deep_linker__ = __webpack_require__("./node_modules/ionic-angular/navigation/deep-linker.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nav_push__ = __webpack_require__("./node_modules/ionic-angular/components/nav/nav-push.js");



/**
 * @hidden
 */
var NavPushAnchor = (function () {
    function NavPushAnchor(host, linker) {
        this.host = host;
        this.linker = linker;
    }
    NavPushAnchor.prototype.updateHref = function () {
        if (this.host && this.linker) {
            this._href = this.linker.createUrl(this.host._nav, this.host.navPush, this.host.navParams) || '#';
        }
        else {
            this._href = '#';
        }
    };
    NavPushAnchor.prototype.ngAfterContentInit = function () {
        this.updateHref();
    };
    NavPushAnchor.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'a[navPush]',
                    host: {
                        '[attr.href]': '_href'
                    }
                },] },
    ];
    /** @nocollapse */
    NavPushAnchor.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_2__nav_push__["a" /* NavPush */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Host"] },] },
        { type: __WEBPACK_IMPORTED_MODULE_1__navigation_deep_linker__["a" /* DeepLinker */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
    ]; };
    return NavPushAnchor;
}());

//# sourceMappingURL=nav-push-anchor.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/nav/nav-push.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NavPush; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__navigation_nav_controller__ = __webpack_require__("./node_modules/ionic-angular/navigation/nav-controller.js");


/**
 * @name NavPush
 * @description
 * Directive to declaratively push a new page to the current nav
 * stack.
 *
 * @usage
 * ```html
 * <button ion-button [navPush]="pushPage"></button>
 * ```
 *
 * To specify parameters you can use array syntax or the `navParams`
 * property:
 *
 * ```html
 * <button ion-button [navPush]="pushPage" [navParams]="params">Go</button>
 * ```
 *
 * Where `pushPage` and `params` are specified in your component,
 * and `pushPage` contains a reference to a
 * component you would like to push:
 *
 * ```ts
 * import { LoginPage } from './login';
 *
 * @Component({
 *   template: `<button ion-button [navPush]="pushPage" [navParams]="params">Go</button>`
 * })
 * class MyPage {
 *   pushPage: any;
 *   params: Object;
 *   constructor(){
 *     this.pushPage = LoginPage;
 *     this.params = { id: 42 };
 *   }
 * }
 * ```
 *
 * @demo /docs/demos/src/navigation/
 * @see {@link /docs/components#navigation Navigation Component Docs}
 * @see {@link ../NavPop NavPop API Docs}
 *
 */
var NavPush = (function () {
    function NavPush(_nav) {
        this._nav = _nav;
        if (!_nav) {
            console.error('navPush must be within a NavController');
        }
    }
    /**
     * @hidden
     */
    NavPush.prototype.onClick = function () {
        if (this._nav && this.navPush) {
            this._nav.push(this.navPush, this.navParams);
            return false;
        }
        return true;
    };
    NavPush.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: '[navPush]'
                },] },
    ];
    /** @nocollapse */
    NavPush.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__navigation_nav_controller__["a" /* NavController */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
    ]; };
    NavPush.propDecorators = {
        'navPush': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'navParams': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'onClick': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"], args: ['click',] },],
    };
    return NavPush;
}());

//# sourceMappingURL=nav-push.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/nav/nav.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Nav; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_app__ = __webpack_require__("./node_modules/ionic-angular/components/app/app.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__navigation_deep_linker__ = __webpack_require__("./node_modules/ionic-angular/navigation/deep-linker.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__platform_dom_controller__ = __webpack_require__("./node_modules/ionic-angular/platform/dom-controller.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__gestures_gesture_controller__ = __webpack_require__("./node_modules/ionic-angular/gestures/gesture-controller.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__navigation_nav_controller__ = __webpack_require__("./node_modules/ionic-angular/navigation/nav-controller.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__navigation_nav_controller_base__ = __webpack_require__("./node_modules/ionic-angular/navigation/nav-controller-base.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__platform_platform__ = __webpack_require__("./node_modules/ionic-angular/platform/platform.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__transitions_transition_controller__ = __webpack_require__("./node_modules/ionic-angular/transitions/transition-controller.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__navigation_view_controller__ = __webpack_require__("./node_modules/ionic-angular/navigation/view-controller.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__split_pane_split_pane__ = __webpack_require__("./node_modules/ionic-angular/components/split-pane/split-pane.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();












/**
 * @name Nav
 * @description
 *
 * `ion-nav` is the declarative component for a [NavController](../../../navigation/NavController/).
 *
 * For more information on using nav controllers like Nav or [Tab](../../Tabs/Tab/),
 * take a look at the [NavController API Docs](../../../navigation/NavController/).
 *
 *
 * @usage
 * You must set a root page to be loaded initially by any Nav you create, using
 * the 'root' property:
 *
 * ```ts
 * import { Component } from '@angular/core';
 * import { GettingStartedPage } from './getting-started';
 *
 * @Component({
 *   template: `<ion-nav [root]="root"></ion-nav>`
 * })
 * class MyApp {
 *   root = GettingStartedPage;
 *
 *   constructor(){
 *   }
 * }
 * ```
 *
 * @demo /docs/demos/src/navigation/
 * @see {@link /docs/components#navigation Navigation Component Docs}
 */
var Nav = (function (_super) {
    __extends(Nav, _super);
    function Nav(viewCtrl, parent, app, config, plt, elementRef, zone, renderer, cfr, gestureCtrl, transCtrl, linker, domCtrl, errHandler) {
        var _this = _super.call(this, parent, app, config, plt, elementRef, zone, renderer, cfr, gestureCtrl, transCtrl, linker, domCtrl, errHandler) || this;
        _this._hasInit = false;
        if (viewCtrl) {
            // an ion-nav can also act as an ion-page within a parent ion-nav
            // this would happen when an ion-nav nests a child ion-nav.
            viewCtrl._setContent(_this);
        }
        if (parent) {
            // this Nav has a parent Nav
            parent.registerChildNav(_this);
        }
        else if (viewCtrl && viewCtrl.getNav()) {
            // this Nav was opened from a modal
            _this.parent = viewCtrl.getNav();
            _this.parent.registerChildNav(_this);
        }
        else if (app && !app.getRootNavById(_this.id)) {
            // a root nav has not been registered yet with the app
            // this is the root navcontroller for the entire app
            app.registerRootNav(_this);
        }
        return _this;
    }
    Object.defineProperty(Nav.prototype, "_vp", {
        /**
         * @hidden
         */
        set: function (val) {
            this.setViewport(val);
        },
        enumerable: true,
        configurable: true
    });
    Nav.prototype.ngAfterViewInit = function () {
        var _this = this;
        this._hasInit = true;
        var segment = this._linker.getSegmentByNavIdOrName(this.id, this.name);
        if (segment && (segment.component || segment.loadChildren)) {
            return this._linker.initViews(segment).then(function (views) {
                return _this.setPages(views, null, null);
            });
        }
        else if (this._root) {
            // no segment match, so use the root property but don't set the url I guess
            var setUrl = segment ? false : true;
            return this.push(this._root, this.rootParams, {
                isNavRoot: (this._app.getRootNavById(this.id) === this),
                updateUrl: setUrl
            }, null);
        }
    };
    Object.defineProperty(Nav.prototype, "root", {
        /**
         * @input {Page} The Page component to load as the root page within this nav.
         */
        get: function () {
            return this._root;
        },
        set: function (page) {
            this._root = page;
            if (this._hasInit) {
                this.setRoot(page);
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @hidden
     */
    Nav.prototype.ngOnDestroy = function () {
        this.destroy();
    };
    Nav.prototype.initPane = function () {
        var isMain = this._elementRef.nativeElement.hasAttribute('main');
        return isMain;
    };
    Nav.prototype.paneChanged = function (isPane) {
        if (isPane) {
            this.resize();
        }
    };
    Nav.prototype.goToRoot = function (opts) {
        return this.setRoot(this._root, this.rootParams, opts, null);
    };
    /*
     * @private
     */
    Nav.prototype.getType = function () {
        return 'nav';
    };
    /*
     * @private
     */
    Nav.prototype.getSecondaryIdentifier = function () {
        return null;
    };
    Nav.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'ion-nav',
                    template: '<div #viewport nav-viewport></div>' +
                        '<div class="nav-decor"></div>',
                    encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None,
                    providers: [{ provide: __WEBPACK_IMPORTED_MODULE_11__split_pane_split_pane__["a" /* RootNode */], useExisting: Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return Nav; }) }]
                },] },
    ];
    /** @nocollapse */
    Nav.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_10__navigation_view_controller__["a" /* ViewController */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
        { type: __WEBPACK_IMPORTED_MODULE_6__navigation_nav_controller__["a" /* NavController */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
        { type: __WEBPACK_IMPORTED_MODULE_1__app_app__["a" /* App */], },
        { type: __WEBPACK_IMPORTED_MODULE_2__config_config__["a" /* Config */], },
        { type: __WEBPACK_IMPORTED_MODULE_8__platform_platform__["a" /* Platform */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ComponentFactoryResolver"], },
        { type: __WEBPACK_IMPORTED_MODULE_5__gestures_gesture_controller__["m" /* GestureController */], },
        { type: __WEBPACK_IMPORTED_MODULE_9__transitions_transition_controller__["a" /* TransitionController */], },
        { type: __WEBPACK_IMPORTED_MODULE_3__navigation_deep_linker__["a" /* DeepLinker */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
        { type: __WEBPACK_IMPORTED_MODULE_4__platform_dom_controller__["a" /* DomController */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ErrorHandler"], },
    ]; };
    Nav.propDecorators = {
        '_vp': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"], args: ['viewport', { read: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"] },] },],
        'root': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'rootParams': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'name': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return Nav;
}(__WEBPACK_IMPORTED_MODULE_7__navigation_nav_controller_base__["a" /* NavControllerBase */]));

//# sourceMappingURL=nav.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/note/note.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Note; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ion__ = __webpack_require__("./node_modules/ionic-angular/components/ion.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



/**
  * @name Note
  * @module ionic
  * @description
  * A note is detailed item in an ion-item. It creates greyed out element that can be on the left or right side of an item.
  * @usage
  *
  * ```html
  * <ion-content>
  *   <ion-list>
  *     <ion-item>
  *       <ion-note item-start>
  *         Left Note
  *       </ion-note>
  *       My Item
  *       <ion-note item-end>
  *         Right Note
  *       </ion-note>
  *     </ion-item>
  *   </ion-list>
  * </ion-content>
  *```
 * {@link /docs/api/components/api/components/item/item ion-item}
  */
var Note = (function (_super) {
    __extends(Note, _super);
    function Note(config, elementRef, renderer) {
        return _super.call(this, config, elementRef, renderer, 'note') || this;
    }
    Note.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'ion-note'
                },] },
    ];
    /** @nocollapse */
    Note.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__config_config__["a" /* Config */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    ]; };
    return Note;
}(__WEBPACK_IMPORTED_MODULE_2__ion__["a" /* Ion */]));

//# sourceMappingURL=note.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/option/option.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Option; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");


/**
 * @name Option
 * @description
 * `ion-option` is a child component of `ion-select`. Similar to the native option element, `ion-option` can take a value and a selected property.
 *
 * @demo /docs/demos/src/select/
 */
var Option = (function () {
    function Option(_elementRef) {
        this._elementRef = _elementRef;
        this._selected = false;
        this._disabled = false;
        /**
         * @output {any} Event to evaluate when option is selected.
         */
        this.ionSelect = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
    }
    Object.defineProperty(Option.prototype, "disabled", {
        /**
         * @input {boolean} If true, the user cannot interact with this element.
         */
        get: function () {
            return this._disabled;
        },
        set: function (val) {
            this._disabled = Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["o" /* isTrueProperty */])(val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Option.prototype, "selected", {
        /**
         * @input {boolean} If true, the element is selected.
         */
        get: function () {
            return this._selected;
        },
        set: function (val) {
            this._selected = Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["o" /* isTrueProperty */])(val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Option.prototype, "value", {
        /**
         * @input {any} The value of the option.
         */
        get: function () {
            if (Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["l" /* isPresent */])(this._value)) {
                return this._value;
            }
            return this.text;
        },
        set: function (val) {
            this._value = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Option.prototype, "text", {
        /**
         * @hidden
         */
        get: function () {
            return this._elementRef.nativeElement.textContent;
        },
        enumerable: true,
        configurable: true
    });
    Option.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'ion-option'
                },] },
    ];
    /** @nocollapse */
    Option.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    ]; };
    Option.propDecorators = {
        'disabled': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'selected': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'value': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'ionSelect': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    };
    return Option;
}());

//# sourceMappingURL=option.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/picker/picker-column.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PickerColumnCmp; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__platform_dom_controller__ = __webpack_require__("./node_modules/ionic-angular/platform/dom-controller.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tap_click_haptic__ = __webpack_require__("./node_modules/ionic-angular/tap-click/haptic.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__picker_options__ = __webpack_require__("./node_modules/ionic-angular/components/picker/picker-options.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__platform_platform__ = __webpack_require__("./node_modules/ionic-angular/platform/platform.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_dom__ = __webpack_require__("./node_modules/ionic-angular/util/dom.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__gestures_ui_event_manager__ = __webpack_require__("./node_modules/ionic-angular/gestures/ui-event-manager.js");









/**
 * @hidden
 */
var PickerColumnCmp = (function () {
    function PickerColumnCmp(config, _plt, elementRef, _zone, _haptic, plt, domCtrl) {
        this.config = config;
        this._plt = _plt;
        this.elementRef = elementRef;
        this._zone = _zone;
        this._haptic = _haptic;
        this.y = 0;
        this.pos = [];
        this.startY = null;
        this.ionChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.events = new __WEBPACK_IMPORTED_MODULE_8__gestures_ui_event_manager__["a" /* UIEventManager */](plt);
        this.decelerateFunc = this.decelerate.bind(this);
        this.debouncer = domCtrl.debouncer();
    }
    PickerColumnCmp.prototype.ngAfterViewInit = function () {
        // get the scrollable element within the column
        var colEle = this.colEle.nativeElement;
        this.colHeight = colEle.clientHeight;
        // get the height of one option
        this.optHeight = (colEle.firstElementChild ? colEle.firstElementChild.clientHeight : 0);
        // Listening for pointer events
        this.events.pointerEvents({
            element: this.elementRef.nativeElement,
            pointerDown: this.pointerStart.bind(this),
            pointerMove: this.pointerMove.bind(this),
            pointerUp: this.pointerEnd.bind(this),
            capture: true,
            zone: false
        });
        this.rotateFactor = this.config.getNumber('pickerRotateFactor', 0);
        this.scaleFactor = this.config.getNumber('pickerScaleFactor', 1);
        if (this.col.mode) {
            var configMode = this.config.getModeConfig(this.col.mode);
            var getRotateFactor = configMode.pickerRotateFactor;
            var getScaleFactor = configMode.pickerScaleFactor;
            if (getRotateFactor !== undefined) {
                this.rotateFactor = this.config.parseNumber(getRotateFactor, this.rotateFactor);
            }
            if (getScaleFactor !== undefined) {
                this.scaleFactor = this.config.parseNumber(getScaleFactor, this.scaleFactor);
            }
        }
    };
    PickerColumnCmp.prototype.ngOnDestroy = function () {
        this._plt.cancelRaf(this.rafId);
        this.events.destroy();
    };
    PickerColumnCmp.prototype.pointerStart = function (ev) {
        (void 0) /* console.debug */;
        this._haptic.gestureSelectionStart();
        // We have to prevent default in order to block scrolling under the picker
        // but we DO NOT have to stop propagation, since we still want
        // some "click" events to capture
        ev.preventDefault();
        // cancel any previous raf's that haven't fired yet
        this._plt.cancelRaf(this.rafId);
        // remember where the pointer started from`
        this.startY = Object(__WEBPACK_IMPORTED_MODULE_7__util_dom__["f" /* pointerCoord */])(ev).y;
        // reset everything
        this.velocity = 0;
        this.pos.length = 0;
        this.pos.push(this.startY, Date.now());
        var options = this.col.options;
        var minY = (options.length - 1);
        var maxY = 0;
        for (var i = 0; i < options.length; i++) {
            if (!options[i].disabled) {
                minY = Math.min(minY, i);
                maxY = Math.max(maxY, i);
            }
        }
        this.minY = (minY * this.optHeight * -1);
        this.maxY = (maxY * this.optHeight * -1);
        return true;
    };
    PickerColumnCmp.prototype.pointerMove = function (ev) {
        var _this = this;
        ev.preventDefault();
        ev.stopPropagation();
        var currentY = Object(__WEBPACK_IMPORTED_MODULE_7__util_dom__["f" /* pointerCoord */])(ev).y;
        this.pos.push(currentY, Date.now());
        this.debouncer.write(function () {
            if (_this.startY === null) {
                return;
            }
            // update the scroll position relative to pointer start position
            var y = _this.y + (currentY - _this.startY);
            if (y > _this.minY) {
                // scrolling up higher than scroll area
                y = Math.pow(y, 0.8);
                _this.bounceFrom = y;
            }
            else if (y < _this.maxY) {
                // scrolling down below scroll area
                y += Math.pow(_this.maxY - y, 0.9);
                _this.bounceFrom = y;
            }
            else {
                _this.bounceFrom = 0;
            }
            _this.update(y, 0, false, false);
            var currentIndex = Math.max(Math.abs(Math.round(y / _this.optHeight)), 0);
            if (currentIndex !== _this.lastTempIndex) {
                // Trigger a haptic event for physical feedback that the index has changed
                _this._haptic.gestureSelectionChanged();
                _this.lastTempIndex = currentIndex;
            }
        });
    };
    PickerColumnCmp.prototype.pointerEnd = function (ev) {
        ev.preventDefault();
        this.debouncer.cancel();
        if (this.startY === null) {
            return;
        }
        (void 0) /* console.debug */;
        this.velocity = 0;
        if (this.bounceFrom > 0) {
            // bounce back up
            this.update(this.minY, 100, true, true);
            return;
        }
        else if (this.bounceFrom < 0) {
            // bounce back down
            this.update(this.maxY, 100, true, true);
            return;
        }
        var endY = Object(__WEBPACK_IMPORTED_MODULE_7__util_dom__["f" /* pointerCoord */])(ev).y;
        this.pos.push(endY, Date.now());
        var endPos = (this.pos.length - 1);
        var startPos = endPos;
        var timeRange = (Date.now() - 100);
        // move pointer to position measured 100ms ago
        for (var i = endPos; i > 0 && this.pos[i] > timeRange; i -= 2) {
            startPos = i;
        }
        if (startPos !== endPos) {
            // compute relative movement between these two points
            var timeOffset = (this.pos[endPos] - this.pos[startPos]);
            var movedTop = (this.pos[startPos - 1] - this.pos[endPos - 1]);
            // based on XXms compute the movement to apply for each render step
            var velocity = ((movedTop / timeOffset) * __WEBPACK_IMPORTED_MODULE_5__picker_options__["b" /* FRAME_MS */]);
            this.velocity = Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["a" /* clamp */])(-__WEBPACK_IMPORTED_MODULE_5__picker_options__["c" /* MAX_PICKER_SPEED */], velocity, __WEBPACK_IMPORTED_MODULE_5__picker_options__["c" /* MAX_PICKER_SPEED */]);
        }
        if (Math.abs(endY - this.startY) > 3) {
            var y = this.y + (endY - this.startY);
            this.update(y, 0, true, true);
        }
        this.startY = null;
        this.decelerate();
    };
    PickerColumnCmp.prototype.decelerate = function () {
        var y = 0;
        if (isNaN(this.y) || !this.optHeight) {
            // fallback in case numbers get outta wack
            this.update(y, 0, true, true);
            this._haptic.gestureSelectionEnd();
        }
        else if (Math.abs(this.velocity) > 0) {
            // still decelerating
            this.velocity *= __WEBPACK_IMPORTED_MODULE_5__picker_options__["a" /* DECELERATION_FRICTION */];
            // do not let it go slower than a velocity of 1
            this.velocity = (this.velocity > 0)
                ? Math.max(this.velocity, 1)
                : Math.min(this.velocity, -1);
            y = Math.round(this.y - this.velocity);
            if (y > this.minY) {
                // whoops, it's trying to scroll up farther than the options we have!
                y = this.minY;
                this.velocity = 0;
            }
            else if (y < this.maxY) {
                // gahh, it's trying to scroll down farther than we can!
                y = this.maxY;
                this.velocity = 0;
            }
            var notLockedIn = (y % this.optHeight !== 0 || Math.abs(this.velocity) > 1);
            this.update(y, 0, true, !notLockedIn);
            if (notLockedIn) {
                // isn't locked in yet, keep decelerating until it is
                this.rafId = this._plt.raf(this.decelerateFunc);
            }
        }
        else if (this.y % this.optHeight !== 0) {
            // needs to still get locked into a position so options line up
            var currentPos = Math.abs(this.y % this.optHeight);
            // create a velocity in the direction it needs to scroll
            this.velocity = (currentPos > (this.optHeight / 2) ? 1 : -1);
            this._haptic.gestureSelectionEnd();
            this.decelerate();
        }
        var currentIndex = Math.max(Math.abs(Math.round(y / this.optHeight)), 0);
        if (currentIndex !== this.lastTempIndex) {
            // Trigger a haptic event for physical feedback that the index has changed
            this._haptic.gestureSelectionChanged();
        }
        this.lastTempIndex = currentIndex;
    };
    PickerColumnCmp.prototype.optClick = function (ev, index) {
        if (!this.velocity) {
            ev.preventDefault();
            ev.stopPropagation();
            this.setSelected(index, 150);
        }
    };
    PickerColumnCmp.prototype.setSelected = function (selectedIndex, duration) {
        // if there is a selected index, then figure out it's y position
        // if there isn't a selected index, then just use the top y position
        var y = (selectedIndex > -1) ? ((selectedIndex * this.optHeight) * -1) : 0;
        this._plt.cancelRaf(this.rafId);
        this.velocity = 0;
        // so what y position we're at
        this.update(y, duration, true, true);
    };
    PickerColumnCmp.prototype.update = function (y, duration, saveY, emitChange) {
        // ensure we've got a good round number :)
        y = Math.round(y);
        var i;
        var button;
        var opt;
        var optOffset;
        var visible;
        var translateX;
        var translateY;
        var translateZ;
        var rotateX;
        var transform;
        var selected;
        var parent = this.colEle.nativeElement;
        var children = parent.children;
        var length = children.length;
        var selectedIndex = this.col.selectedIndex = Math.min(Math.max(Math.round(-y / this.optHeight), 0), length - 1);
        var durationStr = (duration === 0) ? null : duration + 'ms';
        var scaleStr = "scale(" + this.scaleFactor + ")";
        for (i = 0; i < length; i++) {
            button = children[i];
            opt = this.col.options[i];
            optOffset = (i * this.optHeight) + y;
            visible = true;
            transform = '';
            if (this.rotateFactor !== 0) {
                rotateX = optOffset * this.rotateFactor;
                if (Math.abs(rotateX) > 90) {
                    visible = false;
                }
                else {
                    translateX = 0;
                    translateY = 0;
                    translateZ = 90;
                    transform = "rotateX(" + rotateX + "deg) ";
                }
            }
            else {
                translateX = 0;
                translateZ = 0;
                translateY = optOffset;
                if (Math.abs(translateY) > 170) {
                    visible = false;
                }
            }
            selected = selectedIndex === i;
            if (visible) {
                transform += "translate3d(0px," + translateY + "px," + translateZ + "px) ";
                if (this.scaleFactor !== 1 && !selected) {
                    transform += scaleStr;
                }
            }
            else {
                transform = 'translate3d(-9999px,0px,0px)';
            }
            // Update transition duration
            if (duration !== opt._dur) {
                opt._dur = duration;
                button.style[this._plt.Css.transitionDuration] = durationStr;
            }
            // Update transform
            if (transform !== opt._trans) {
                opt._trans = transform;
                button.style[this._plt.Css.transform] = transform;
            }
            // Update selected item
            if (selected !== opt._selected) {
                opt._selected = selected;
                if (selected) {
                    button.classList.add(__WEBPACK_IMPORTED_MODULE_5__picker_options__["d" /* PICKER_OPT_SELECTED */]);
                }
                else {
                    button.classList.remove(__WEBPACK_IMPORTED_MODULE_5__picker_options__["d" /* PICKER_OPT_SELECTED */]);
                }
            }
        }
        this.col.prevSelected = selectedIndex;
        if (saveY) {
            this.y = y;
        }
        if (emitChange) {
            if (this.lastIndex === undefined) {
                // have not set a last index yet
                this.lastIndex = this.col.selectedIndex;
            }
            else if (this.lastIndex !== this.col.selectedIndex) {
                // new selected index has changed from the last index
                // update the lastIndex and emit that it has changed
                this.lastIndex = this.col.selectedIndex;
                var ionChange = this.ionChange;
                if (ionChange.observers.length > 0) {
                    this._zone.run(ionChange.emit.bind(ionChange, this.col.options[this.col.selectedIndex]));
                }
            }
        }
    };
    PickerColumnCmp.prototype.refresh = function () {
        var min = this.col.options.length - 1;
        var max = 0;
        var options = this.col.options;
        for (var i = 0; i < options.length; i++) {
            if (!options[i].disabled) {
                min = Math.min(min, i);
                max = Math.max(max, i);
            }
        }
        var selectedIndex = Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["a" /* clamp */])(min, this.col.selectedIndex, max);
        if (this.col.prevSelected !== selectedIndex) {
            var y = (selectedIndex * this.optHeight) * -1;
            this._plt.cancelRaf(this.rafId);
            this.velocity = 0;
            this.update(y, 150, true, false);
        }
    };
    PickerColumnCmp.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: '.picker-col',
                    template: '<div *ngIf="col.prefix" class="picker-prefix" [style.width]="col.prefixWidth">{{col.prefix}}</div>' +
                        '<div class="picker-opts" #colEle [style.max-width]="col.optionsWidth">' +
                        '<button *ngFor="let o of col.options; let i=index"' +
                        '[class.picker-opt-disabled]="o.disabled" ' +
                        'class="picker-opt" disable-activated (click)="optClick($event, i)">' +
                        '{{o.text}}' +
                        '</button>' +
                        '</div>' +
                        '<div *ngIf="col.suffix" class="picker-suffix" [style.width]="col.suffixWidth">{{col.suffix}}</div>',
                    host: {
                        '[style.max-width]': 'col.columnWidth',
                        '[class.picker-opts-left]': 'col.align=="left"',
                        '[class.picker-opts-right]': 'col.align=="right"',
                    }
                },] },
    ];
    /** @nocollapse */
    PickerColumnCmp.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_2__config_config__["a" /* Config */], },
        { type: __WEBPACK_IMPORTED_MODULE_6__platform_platform__["a" /* Platform */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"], },
        { type: __WEBPACK_IMPORTED_MODULE_4__tap_click_haptic__["a" /* Haptic */], },
        { type: __WEBPACK_IMPORTED_MODULE_6__platform_platform__["a" /* Platform */], },
        { type: __WEBPACK_IMPORTED_MODULE_3__platform_dom_controller__["a" /* DomController */], },
    ]; };
    PickerColumnCmp.propDecorators = {
        'colEle': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"], args: ['colEle',] },],
        'col': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'ionChange': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    };
    return PickerColumnCmp;
}());

//# sourceMappingURL=picker-column.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/picker/picker-component.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PickerCmp; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gestures_gesture_controller__ = __webpack_require__("./node_modules/ionic-angular/gestures/gesture-controller.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__platform_key__ = __webpack_require__("./node_modules/ionic-angular/platform/key.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__navigation_nav_params__ = __webpack_require__("./node_modules/ionic-angular/navigation/nav-params.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__navigation_view_controller__ = __webpack_require__("./node_modules/ionic-angular/navigation/view-controller.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__picker_column__ = __webpack_require__("./node_modules/ionic-angular/components/picker/picker-column.js");








/**
 * @hidden
 */
var PickerCmp = (function () {
    function PickerCmp(_viewCtrl, _elementRef, config, gestureCtrl, params, renderer) {
        this._viewCtrl = _viewCtrl;
        this._elementRef = _elementRef;
        this._gestureBlocker = gestureCtrl.createBlocker(__WEBPACK_IMPORTED_MODULE_3__gestures_gesture_controller__["a" /* BLOCK_ALL */]);
        this.d = params.data;
        this.mode = this.d.mode || config.get('mode');
        renderer.setElementClass(_elementRef.nativeElement, "picker-" + this.mode, true);
        if (this.d.cssClass) {
            this.d.cssClass.split(' ').forEach(function (cssClass) {
                renderer.setElementClass(_elementRef.nativeElement, cssClass, true);
            });
        }
        this.id = (++pickerIds);
        this.lastClick = 0;
    }
    PickerCmp.prototype.ionViewWillLoad = function () {
        var _this = this;
        // normalize the data
        var data = this.d;
        data.buttons = data.buttons.map(function (button) {
            if (Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["n" /* isString */])(button)) {
                return { text: button };
            }
            if (button.role) {
                button.cssRole = "picker-toolbar-" + button.role;
            }
            return button;
        });
        // clean up dat data
        data.columns = data.columns.map(function (column) {
            if (!Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["l" /* isPresent */])(column.options)) {
                column.options = [];
            }
            column.mode = _this.mode;
            column.selectedIndex = column.selectedIndex || 0;
            column.options = column.options.map(function (inputOpt) {
                var opt = {
                    text: '',
                    value: '',
                    disabled: inputOpt.disabled
                };
                if (Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["l" /* isPresent */])(inputOpt)) {
                    if (Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["n" /* isString */])(inputOpt) || Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["j" /* isNumber */])(inputOpt)) {
                        opt.text = inputOpt.toString();
                        opt.value = inputOpt;
                    }
                    else {
                        opt.text = Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["l" /* isPresent */])(inputOpt.text) ? inputOpt.text : inputOpt.value;
                        opt.value = Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["l" /* isPresent */])(inputOpt.value) ? inputOpt.value : inputOpt.text;
                    }
                }
                return opt;
            });
            return column;
        });
    };
    PickerCmp.prototype.ionViewDidLoad = function () {
        this.refresh();
    };
    PickerCmp.prototype.ionViewWillEnter = function () {
        this._gestureBlocker.block();
    };
    PickerCmp.prototype.ionViewDidLeave = function () {
        this._gestureBlocker.unblock();
    };
    PickerCmp.prototype.refresh = function () {
        this._cols.forEach(function (column) { return column.refresh(); });
    };
    PickerCmp.prototype._colChange = function () {
        // one of the columns has changed its selected index
        var picker = this._viewCtrl;
        picker.ionChange.emit(this.getSelected());
    };
    PickerCmp.prototype._keyUp = function (ev) {
        if (this.enabled && this._viewCtrl.isLast()) {
            if (ev.keyCode === __WEBPACK_IMPORTED_MODULE_4__platform_key__["b" /* KEY_ENTER */]) {
                if (this.lastClick + 1000 < Date.now()) {
                    // do not fire this click if there recently was already a click
                    // this can happen when the button has focus and used the enter
                    // key to click the button. However, both the click handler and
                    // this keyup event will fire, so only allow one of them to go.
                    (void 0) /* console.debug */;
                    var button = this.d.buttons[this.d.buttons.length - 1];
                    this.btnClick(button);
                }
            }
            else if (ev.keyCode === __WEBPACK_IMPORTED_MODULE_4__platform_key__["c" /* KEY_ESCAPE */]) {
                (void 0) /* console.debug */;
                this.bdClick();
            }
        }
    };
    PickerCmp.prototype.ionViewDidEnter = function () {
        var focusableEle = this._elementRef.nativeElement.querySelector('button');
        if (focusableEle) {
            focusableEle.focus();
        }
        this.enabled = true;
    };
    PickerCmp.prototype.btnClick = function (button) {
        if (!this.enabled) {
            return;
        }
        // keep the time of the most recent button click
        this.lastClick = Date.now();
        var shouldDismiss = true;
        if (button.handler) {
            // a handler has been provided, execute it
            // pass the handler the values from the inputs
            if (button.handler(this.getSelected()) === false) {
                // if the return value of the handler is false then do not dismiss
                shouldDismiss = false;
            }
        }
        if (shouldDismiss) {
            this.dismiss(button.role);
        }
    };
    PickerCmp.prototype.bdClick = function () {
        if (this.enabled && this.d.enableBackdropDismiss) {
            var cancelBtn = this.d.buttons.find(function (b) { return b.role === 'cancel'; });
            if (cancelBtn) {
                this.btnClick(cancelBtn);
            }
            else {
                this.dismiss('backdrop');
            }
        }
    };
    PickerCmp.prototype.dismiss = function (role) {
        return this._viewCtrl.dismiss(this.getSelected(), role);
    };
    PickerCmp.prototype.getSelected = function () {
        var selected = {};
        this.d.columns.forEach(function (col, index) {
            var selectedColumn = col.options[col.selectedIndex];
            selected[col.name] = {
                text: selectedColumn ? selectedColumn.text : null,
                value: selectedColumn ? selectedColumn.value : null,
                columnIndex: index,
            };
        });
        return selected;
    };
    PickerCmp.prototype.ngOnDestroy = function () {
        (void 0) /* assert */;
        this._gestureBlocker.destroy();
    };
    PickerCmp.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'ion-picker-cmp',
                    template: "\n    <ion-backdrop (click)=\"bdClick()\"></ion-backdrop>\n    <div class=\"picker-wrapper\">\n      <div class=\"picker-toolbar\">\n        <div *ngFor=\"let b of d.buttons\" class=\"picker-toolbar-button\" [ngClass]=\"b.cssRole\">\n          <button ion-button (click)=\"btnClick(b)\" [ngClass]=\"b.cssClass\" class=\"picker-button\" clear>\n            {{b.text}}\n          </button>\n        </div>\n      </div>\n      <div class=\"picker-columns\">\n        <div class=\"picker-above-highlight\"></div>\n        <div *ngFor=\"let c of d.columns\" [col]=\"c\" class=\"picker-col\" (ionChange)=\"_colChange($event)\"></div>\n        <div class=\"picker-below-highlight\"></div>\n      </div>\n    </div>\n  ",
                    host: {
                        'role': 'dialog'
                    },
                    encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None,
                },] },
    ];
    /** @nocollapse */
    PickerCmp.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_6__navigation_view_controller__["a" /* ViewController */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_2__config_config__["a" /* Config */], },
        { type: __WEBPACK_IMPORTED_MODULE_3__gestures_gesture_controller__["m" /* GestureController */], },
        { type: __WEBPACK_IMPORTED_MODULE_5__navigation_nav_params__["a" /* NavParams */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    ]; };
    PickerCmp.propDecorators = {
        '_cols': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChildren"], args: [__WEBPACK_IMPORTED_MODULE_7__picker_column__["a" /* PickerColumnCmp */],] },],
        '_keyUp': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"], args: ['body:keyup', ['$event'],] },],
    };
    return PickerCmp;
}());

var pickerIds = -1;
//# sourceMappingURL=picker-component.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/picker/picker-controller.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PickerController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_app__ = __webpack_require__("./node_modules/ionic-angular/components/app/app.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__picker__ = __webpack_require__("./node_modules/ionic-angular/components/picker/picker.js");




/**
 * @hidden
 * @name PickerController
 * @description
 *
 */
var PickerController = (function () {
    function PickerController(_app, config) {
        this._app = _app;
        this.config = config;
    }
    /**
     * Open a picker.
     */
    PickerController.prototype.create = function (opts) {
        if (opts === void 0) { opts = {}; }
        return new __WEBPACK_IMPORTED_MODULE_3__picker__["a" /* Picker */](this._app, opts, this.config);
    };
    PickerController.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    PickerController.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__app_app__["a" /* App */], },
        { type: __WEBPACK_IMPORTED_MODULE_2__config_config__["a" /* Config */], },
    ]; };
    return PickerController;
}());

//# sourceMappingURL=picker-controller.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/picker/picker-options.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PICKER_OPT_SELECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DECELERATION_FRICTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FRAME_MS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MAX_PICKER_SPEED; });
var PICKER_OPT_SELECTED = 'picker-opt-selected';
var DECELERATION_FRICTION = 0.97;
var FRAME_MS = (1000 / 60);
var MAX_PICKER_SPEED = 60;
//# sourceMappingURL=picker-options.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/picker/picker-transitions.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PickerSlideIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PickerSlideOut; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__animations_animation__ = __webpack_require__("./node_modules/ionic-angular/animations/animation.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__transitions_transition__ = __webpack_require__("./node_modules/ionic-angular/transitions/transition.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


/**
 * Animations for pickers
 */
var PickerSlideIn = (function (_super) {
    __extends(PickerSlideIn, _super);
    function PickerSlideIn() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PickerSlideIn.prototype.init = function () {
        var ele = this.enteringView.pageRef().nativeElement;
        var backdrop = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](this.plt, ele.querySelector('ion-backdrop'));
        var wrapper = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](this.plt, ele.querySelector('.picker-wrapper'));
        backdrop.fromTo('opacity', 0.01, 0.26);
        wrapper.fromTo('translateY', '100%', '0%');
        this.easing('cubic-bezier(.36,.66,.04,1)').duration(400).add(backdrop).add(wrapper);
    };
    return PickerSlideIn;
}(__WEBPACK_IMPORTED_MODULE_1__transitions_transition__["a" /* Transition */]));

var PickerSlideOut = (function (_super) {
    __extends(PickerSlideOut, _super);
    function PickerSlideOut() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PickerSlideOut.prototype.init = function () {
        var ele = this.leavingView.pageRef().nativeElement;
        var backdrop = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](this.plt, ele.querySelector('ion-backdrop'));
        var wrapper = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](this.plt, ele.querySelector('.picker-wrapper'));
        backdrop.fromTo('opacity', 0.26, 0);
        wrapper.fromTo('translateY', '0%', '100%');
        this.easing('cubic-bezier(.36,.66,.04,1)').duration(450).add(backdrop).add(wrapper);
    };
    return PickerSlideOut;
}(__WEBPACK_IMPORTED_MODULE_1__transitions_transition__["a" /* Transition */]));

//# sourceMappingURL=picker-transitions.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/picker/picker.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Picker; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__picker_component__ = __webpack_require__("./node_modules/ionic-angular/components/picker/picker-component.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__picker_transitions__ = __webpack_require__("./node_modules/ionic-angular/components/picker/picker-transitions.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__navigation_view_controller__ = __webpack_require__("./node_modules/ionic-angular/navigation/view-controller.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





/**
 * @hidden
 */
var Picker = (function (_super) {
    __extends(Picker, _super);
    function Picker(app, opts, config) {
        if (opts === void 0) { opts = {}; }
        var _this = this;
        if (!opts) {
            opts = {};
        }
        opts.columns = opts.columns || [];
        opts.buttons = opts.buttons || [];
        opts.enableBackdropDismiss = Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["l" /* isPresent */])(opts.enableBackdropDismiss) ? Boolean(opts.enableBackdropDismiss) : true;
        _this = _super.call(this, __WEBPACK_IMPORTED_MODULE_2__picker_component__["a" /* PickerCmp */], opts, null) || this;
        _this._app = app;
        _this.isOverlay = true;
        _this.ionChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        config.setTransition('picker-slide-in', __WEBPACK_IMPORTED_MODULE_3__picker_transitions__["a" /* PickerSlideIn */]);
        config.setTransition('picker-slide-out', __WEBPACK_IMPORTED_MODULE_3__picker_transitions__["b" /* PickerSlideOut */]);
        return _this;
    }
    /**
    * @hidden
    */
    Picker.prototype.getTransitionName = function (direction) {
        var key = (direction === 'back' ? 'pickerLeave' : 'pickerEnter');
        return this._nav && this._nav.config.get(key);
    };
    /**
     * @param {any} button Picker toolbar button
     */
    Picker.prototype.addButton = function (button) {
        this.data.buttons.push(button);
    };
    /**
     * @param {PickerColumn} column Picker toolbar button
     */
    Picker.prototype.addColumn = function (column) {
        this.data.columns.push(column);
    };
    Picker.prototype.getColumns = function () {
        return this.data.columns;
    };
    Picker.prototype.getColumn = function (name) {
        return this.getColumns().find(function (column) { return column.name === name; });
    };
    Picker.prototype.refresh = function () {
        (void 0) /* assert */;
        (void 0) /* assert */;
        this._cmp && this._cmp.instance.refresh && this._cmp.instance.refresh();
    };
    /**
     * @param {string} cssClass CSS class name to add to the picker's outer wrapper.
     */
    Picker.prototype.setCssClass = function (cssClass) {
        this.data.cssClass = cssClass;
    };
    /**
     * Present the picker instance.
     *
     * @param {NavOptions} [navOptions={}] Nav options to go with this transition.
     * @returns {Promise} Returns a promise which is resolved when the transition has completed.
     */
    Picker.prototype.present = function (navOptions) {
        if (navOptions === void 0) { navOptions = {}; }
        return this._app.present(this, navOptions);
    };
    Picker.propDecorators = {
        'ionChange': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    };
    return Picker;
}(__WEBPACK_IMPORTED_MODULE_4__navigation_view_controller__["a" /* ViewController */]));

//# sourceMappingURL=picker.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/popover/popover-component.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PopoverCmp; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__platform_key__ = __webpack_require__("./node_modules/ionic-angular/platform/key.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__navigation_nav_params__ = __webpack_require__("./node_modules/ionic-angular/navigation/nav-params.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__navigation_view_controller__ = __webpack_require__("./node_modules/ionic-angular/navigation/view-controller.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__gestures_gesture_controller__ = __webpack_require__("./node_modules/ionic-angular/gestures/gesture-controller.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_module_loader__ = __webpack_require__("./node_modules/ionic-angular/util/module-loader.js");







/**
 * @hidden
 */
var PopoverCmp = (function () {
    function PopoverCmp(_cfr, _elementRef, _renderer, _config, _navParams, _viewCtrl, gestureCtrl, moduleLoader) {
        this._cfr = _cfr;
        this._elementRef = _elementRef;
        this._renderer = _renderer;
        this._config = _config;
        this._navParams = _navParams;
        this._viewCtrl = _viewCtrl;
        this.moduleLoader = moduleLoader;
        this._gestureBlocker = gestureCtrl.createBlocker(__WEBPACK_IMPORTED_MODULE_5__gestures_gesture_controller__["a" /* BLOCK_ALL */]);
        this.d = _navParams.data.opts;
        _renderer.setElementClass(_elementRef.nativeElement, "popover-" + _config.get('mode'), true);
        if (this.d.cssClass) {
            this.d.cssClass.split(' ').forEach(function (cssClass) {
                // Make sure the class isn't whitespace, otherwise it throws exceptions
                if (cssClass.trim() !== '')
                    _renderer.setElementClass(_elementRef.nativeElement, cssClass, true);
            });
        }
        this.id = (++popoverIds);
    }
    PopoverCmp.prototype.ionViewPreLoad = function () {
        this._load(this._navParams.data.component);
    };
    PopoverCmp.prototype._load = function (component) {
        if (component) {
            var cfr = this.moduleLoader.getComponentFactoryResolver(component);
            if (!cfr) {
                cfr = this._cfr;
            }
            var componentFactory = cfr.resolveComponentFactory(component);
            // ******** DOM WRITE ****************
            var componentRef = this._viewport.createComponent(componentFactory, this._viewport.length, this._viewport.parentInjector, []);
            this._viewCtrl._setInstance(componentRef.instance);
            this._enabled = true;
            // Subscribe to events in order to block gestures
            // TODO, should we unsubscribe? memory leak?
            this._viewCtrl.willEnter.subscribe(this._viewWillEnter.bind(this));
            this._viewCtrl.didLeave.subscribe(this._viewDidLeave.bind(this));
        }
    };
    PopoverCmp.prototype._viewWillEnter = function () {
        this._gestureBlocker.block();
    };
    PopoverCmp.prototype._viewDidLeave = function () {
        this._gestureBlocker.unblock();
    };
    PopoverCmp.prototype._setCssClass = function (componentRef, className) {
        this._renderer.setElementClass(componentRef.location.nativeElement, className, true);
    };
    PopoverCmp.prototype._bdClick = function () {
        if (this._enabled && this.d.enableBackdropDismiss) {
            return this._viewCtrl.dismiss(null, 'backdrop');
        }
    };
    PopoverCmp.prototype._keyUp = function (ev) {
        if (this._enabled && ev.keyCode === __WEBPACK_IMPORTED_MODULE_2__platform_key__["c" /* KEY_ESCAPE */] && this._viewCtrl.isLast()) {
            this._bdClick();
        }
    };
    PopoverCmp.prototype.ngOnDestroy = function () {
        (void 0) /* assert */;
        this._gestureBlocker.destroy();
    };
    PopoverCmp.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'ion-popover',
                    template: '<ion-backdrop (click)="_bdClick()" [hidden]="!d.showBackdrop"></ion-backdrop>' +
                        '<div class="popover-wrapper">' +
                        '<div class="popover-arrow"></div>' +
                        '<div class="popover-content">' +
                        '<div class="popover-viewport">' +
                        '<div #viewport nav-viewport></div>' +
                        '</div>' +
                        '</div>' +
                        '</div>'
                },] },
    ];
    /** @nocollapse */
    PopoverCmp.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ComponentFactoryResolver"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: __WEBPACK_IMPORTED_MODULE_1__config_config__["a" /* Config */], },
        { type: __WEBPACK_IMPORTED_MODULE_3__navigation_nav_params__["a" /* NavParams */], },
        { type: __WEBPACK_IMPORTED_MODULE_4__navigation_view_controller__["a" /* ViewController */], },
        { type: __WEBPACK_IMPORTED_MODULE_5__gestures_gesture_controller__["m" /* GestureController */], },
        { type: __WEBPACK_IMPORTED_MODULE_6__util_module_loader__["b" /* ModuleLoader */], },
    ]; };
    PopoverCmp.propDecorators = {
        '_viewport': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"], args: ['viewport', { read: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"] },] },],
        '_keyUp': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"], args: ['body:keyup', ['$event'],] },],
    };
    return PopoverCmp;
}());

var popoverIds = -1;
//# sourceMappingURL=popover-component.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/popover/popover-controller.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PopoverController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_app__ = __webpack_require__("./node_modules/ionic-angular/components/app/app.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__popover__ = __webpack_require__("./node_modules/ionic-angular/components/popover/popover.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__navigation_deep_linker__ = __webpack_require__("./node_modules/ionic-angular/navigation/deep-linker.js");





/**
 * @name PopoverController
 * @description
 * A Popover is a dialog that appears on top of the current page.
 * It can be used for anything, but generally it is used for overflow
 * actions that don't fit in the navigation bar.
 *
 * ### Creating
 * A popover can be created by calling the `create` method. The view
 * to display in the popover should be passed as the first argument.
 * Any data to pass to the popover view can optionally be passed in
 * the second argument. Options for the popover can optionally be
 * passed in the third argument. See the [create](#create) method
 * below for all available options.
 *
 * ### Presenting
 * To present a popover, call the `present` method on a PopoverController instance.
 * In order to position the popover relative to the element clicked, a click event
 * needs to be passed into the options of the the `present method. If the event
 * is not passed, the popover will be positioned in the center of the current
 * view. See the [usage](#usage) section for an example of passing this event.
 *
 * ### Dismissing
 * To dismiss the popover after creation, call the `dismiss()` method on the
 * `Popover` instance. The popover can also be dismissed from within the popover's
 * view by calling the `dismiss()` method on the [ViewController](../../navigation/ViewController).
 * The `dismiss()` call accepts an optional parameter that will be passed to the callback described
 * as follows. The `onDidDismiss(<func>)` function can be called to set up a callback action that will
 * be performed after the popover is dismissed, receiving the parameter passed to `dismiss()`.
 * The popover will dismiss when the backdrop is clicked by implicitly performing `dismiss(null)`,
 * but this can be disabled by setting `enableBackdropDismiss` to `false` in the popover options.
 *
 * > Note that after the component is dismissed, it will not be usable anymore and
 * another one must be created. This can be avoided by wrapping the creation and
 * presentation of the component in a reusable function as shown in the [usage](#usage)
 * section below.
 *
 * @usage
 *
 * To open a popover on the click of a button, pass `$event` to the method
 * which creates and presents the popover:
 *
 * ```html
 * <button ion-button icon-only (click)="presentPopover($event)">
 *   <ion-icon name="more"></ion-icon>
 * </button>
 * ```
 *
 * ```ts
 * import { PopoverController } from 'ionic-angular';
 *
 * @Component({})
 * class MyPage {
 *   constructor(public popoverCtrl: PopoverController) {}
 *
 *   presentPopover(myEvent) {
 *     let popover = this.popoverCtrl.create(PopoverPage);
 *     popover.present({
 *       ev: myEvent
 *     });
 *   }
 * }
 * ```
 *
 * The `PopoverPage` will display inside of the popover, and
 * can be anything. Below is an example of a page with items
 * that close the popover on click.
 *
 * ```ts
 * @Component({
 *   template: `
 *     <ion-list>
 *       <ion-list-header>Ionic</ion-list-header>
 *       <button ion-item (click)="close()">Learn Ionic</button>
 *       <button ion-item (click)="close()">Documentation</button>
 *       <button ion-item (click)="close()">Showcase</button>
 *       <button ion-item (click)="close()">GitHub Repo</button>
 *     </ion-list>
 *   `
 * })
 * class PopoverPage {
 *   constructor(public viewCtrl: ViewController) {}
 *
 *   close() {
 *     this.viewCtrl.dismiss();
 *   }
 * }
 * ```
 * @advanced
 * Popover Options
 *
 * | Option                | Type       | Description                                                                                                      |
 * |-----------------------|------------|------------------------------------------------------------------------------------------------------------------|
 * | cssClass              |`string`    | Additional classes for custom styles, separated by spaces.                                                       |
 * | showBackdrop          |`boolean`   | Whether to show the backdrop. Default true.                                                                      |
 * | enableBackdropDismiss |`boolean`   | Whether the popover should be dismissed by tapping the backdrop. Default true.                                   |
 *
 *
 *
 * @demo /docs/demos/src/popover/
 */
var PopoverController = (function () {
    function PopoverController(_app, config, _deepLinker) {
        this._app = _app;
        this.config = config;
        this._deepLinker = _deepLinker;
    }
    /**
     * Present a popover. See below for options
     * @param {object} component The Popover
     * @param {object} data Any data to pass to the Popover view
     * @param {PopoverOptions} opts Popover options
     */
    PopoverController.prototype.create = function (component, data, opts) {
        if (data === void 0) { data = {}; }
        if (opts === void 0) { opts = {}; }
        return new __WEBPACK_IMPORTED_MODULE_3__popover__["a" /* Popover */](this._app, component, data, opts, this.config, this._deepLinker);
    };
    PopoverController.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    PopoverController.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__app_app__["a" /* App */], },
        { type: __WEBPACK_IMPORTED_MODULE_2__config_config__["a" /* Config */], },
        { type: __WEBPACK_IMPORTED_MODULE_4__navigation_deep_linker__["a" /* DeepLinker */], },
    ]; };
    return PopoverController;
}());

//# sourceMappingURL=popover-controller.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/popover/popover-impl.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PopoverImpl; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__popover_component__ = __webpack_require__("./node_modules/ionic-angular/components/popover/popover-component.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__popover_transitions__ = __webpack_require__("./node_modules/ionic-angular/components/popover/popover-transitions.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__navigation_view_controller__ = __webpack_require__("./node_modules/ionic-angular/navigation/view-controller.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




/**
 * @hidden
 */
var PopoverImpl = (function (_super) {
    __extends(PopoverImpl, _super);
    function PopoverImpl(app, component, data, opts, config) {
        if (data === void 0) { data = {}; }
        if (opts === void 0) { opts = {}; }
        var _this = this;
        opts.showBackdrop = Object(__WEBPACK_IMPORTED_MODULE_0__util_util__["l" /* isPresent */])(opts.showBackdrop) ? !!opts.showBackdrop : true;
        opts.enableBackdropDismiss = Object(__WEBPACK_IMPORTED_MODULE_0__util_util__["l" /* isPresent */])(opts.enableBackdropDismiss) ? !!opts.enableBackdropDismiss : true;
        data.component = component;
        data.opts = opts;
        _this = _super.call(this, __WEBPACK_IMPORTED_MODULE_1__popover_component__["a" /* PopoverCmp */], data, null) || this;
        _this._app = app;
        _this.isOverlay = true;
        config.setTransition('popover-pop-in', __WEBPACK_IMPORTED_MODULE_2__popover_transitions__["c" /* PopoverPopIn */]);
        config.setTransition('popover-pop-out', __WEBPACK_IMPORTED_MODULE_2__popover_transitions__["d" /* PopoverPopOut */]);
        config.setTransition('popover-md-pop-in', __WEBPACK_IMPORTED_MODULE_2__popover_transitions__["a" /* PopoverMdPopIn */]);
        config.setTransition('popover-md-pop-out', __WEBPACK_IMPORTED_MODULE_2__popover_transitions__["b" /* PopoverMdPopOut */]);
        return _this;
    }
    /**
     * @hidden
     */
    PopoverImpl.prototype.getTransitionName = function (direction) {
        var key = (direction === 'back' ? 'popoverLeave' : 'popoverEnter');
        return this._nav && this._nav.config.get(key);
    };
    /**
     * Present the popover instance.
     *
     * @param {NavOptions} [navOptions={}] Nav options to go with this transition.
     * @returns {Promise} Returns a promise which is resolved when the transition has completed.
     */
    PopoverImpl.prototype.present = function (navOptions) {
        if (navOptions === void 0) { navOptions = {}; }
        return this._app.present(this, navOptions);
    };
    return PopoverImpl;
}(__WEBPACK_IMPORTED_MODULE_3__navigation_view_controller__["a" /* ViewController */]));

//# sourceMappingURL=popover-impl.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/popover/popover-transitions.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PopoverTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PopoverPopIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PopoverPopOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PopoverMdPopIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PopoverMdPopOut; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__animations_animation__ = __webpack_require__("./node_modules/ionic-angular/animations/animation.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__transitions_page_transition__ = __webpack_require__("./node_modules/ionic-angular/transitions/page-transition.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


/**
 * Animations for popover
 */
var PopoverTransition = (function (_super) {
    __extends(PopoverTransition, _super);
    function PopoverTransition() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PopoverTransition.prototype.mdPositionView = function (nativeEle, ev) {
        var originY = 'top';
        var originX = 'left';
        var popoverWrapperEle = nativeEle.querySelector('.popover-wrapper');
        // Popover content width and height
        var popoverEle = nativeEle.querySelector('.popover-content');
        var popoverDim = popoverEle.getBoundingClientRect();
        var popoverWidth = popoverDim.width;
        var popoverHeight = popoverDim.height;
        // Window body width and height
        var bodyWidth = this.plt.width();
        var bodyHeight = this.plt.height();
        // If ev was passed, use that for target element
        var targetDim = ev && ev.target && ev.target.getBoundingClientRect();
        var targetTop = (targetDim && 'top' in targetDim) ? targetDim.top : (bodyHeight / 2) - (popoverHeight / 2);
        var targetLeft = (targetDim && 'left' in targetDim) ? targetDim.left : (bodyWidth / 2) - (popoverWidth / 2);
        var targetHeight = targetDim && targetDim.height || 0;
        var popoverCSS = {
            top: targetTop,
            left: targetLeft
        };
        // If the popover left is less than the padding it is off screen
        // to the left so adjust it, else if the width of the popover
        // exceeds the body width it is off screen to the right so adjust
        if (popoverCSS.left < POPOVER_MD_BODY_PADDING) {
            popoverCSS.left = POPOVER_MD_BODY_PADDING;
        }
        else if (popoverWidth + POPOVER_MD_BODY_PADDING + popoverCSS.left > bodyWidth) {
            popoverCSS.left = bodyWidth - popoverWidth - POPOVER_MD_BODY_PADDING;
            originX = 'right';
        }
        // If the popover when popped down stretches past bottom of screen,
        // make it pop up if there's room above
        if (targetTop + targetHeight + popoverHeight > bodyHeight && targetTop - popoverHeight > 0) {
            popoverCSS.top = targetTop - popoverHeight;
            nativeEle.className = nativeEle.className + ' popover-bottom';
            originY = 'bottom';
            // If there isn't room for it to pop up above the target cut it off
        }
        else if (targetTop + targetHeight + popoverHeight > bodyHeight) {
            popoverEle.style.bottom = POPOVER_MD_BODY_PADDING + 'px';
        }
        popoverEle.style.top = popoverCSS.top + 'px';
        popoverEle.style.left = popoverCSS.left + 'px';
        popoverEle.style[this.plt.Css.transformOrigin] = originY + ' ' + originX;
        // Since the transition starts before styling is done we
        // want to wait for the styles to apply before showing the wrapper
        popoverWrapperEle.style.opacity = '1';
    };
    PopoverTransition.prototype.iosPositionView = function (nativeEle, ev) {
        var originY = 'top';
        var originX = 'left';
        var popoverWrapperEle = nativeEle.querySelector('.popover-wrapper');
        // Popover content width and height
        var popoverEle = nativeEle.querySelector('.popover-content');
        var popoverDim = popoverEle.getBoundingClientRect();
        var popoverWidth = popoverDim.width;
        var popoverHeight = popoverDim.height;
        // Window body width and height
        var bodyWidth = this.plt.width();
        var bodyHeight = this.plt.height();
        // If ev was passed, use that for target element
        var targetDim = ev && ev.target && ev.target.getBoundingClientRect();
        var targetTop = (targetDim && 'top' in targetDim) ? targetDim.top : (bodyHeight / 2) - (popoverHeight / 2);
        var targetLeft = (targetDim && 'left' in targetDim) ? targetDim.left : (bodyWidth / 2);
        var targetWidth = targetDim && targetDim.width || 0;
        var targetHeight = targetDim && targetDim.height || 0;
        // The arrow that shows above the popover on iOS
        var arrowEle = nativeEle.querySelector('.popover-arrow');
        var arrowDim = arrowEle.getBoundingClientRect();
        var arrowWidth = arrowDim.width;
        var arrowHeight = arrowDim.height;
        // If no ev was passed, hide the arrow
        if (!targetDim) {
            arrowEle.style.display = 'none';
        }
        var arrowCSS = {
            top: targetTop + targetHeight,
            left: targetLeft + (targetWidth / 2) - (arrowWidth / 2)
        };
        var popoverCSS = {
            top: targetTop + targetHeight + (arrowHeight - 1),
            left: targetLeft + (targetWidth / 2) - (popoverWidth / 2)
        };
        // If the popover left is less than the padding it is off screen
        // to the left so adjust it, else if the width of the popover
        // exceeds the body width it is off screen to the right so adjust
        //
        var checkSafeAreaLeft = false;
        var checkSafeAreaRight = false;
        // If the popover left is less than the padding it is off screen
        // to the left so adjust it, else if the width of the popover
        // exceeds the body width it is off screen to the right so adjust
        // 25 is a random/arbitrary number. It seems to work fine for ios11
        // and iPhoneX. Is it perfect? No. Does it work? Yes.
        if (popoverCSS.left < (POPOVER_IOS_BODY_PADDING + 25)) {
            checkSafeAreaLeft = true;
            popoverCSS.left = POPOVER_IOS_BODY_PADDING;
        }
        else if ((popoverWidth + POPOVER_IOS_BODY_PADDING + popoverCSS.left + 25) > bodyWidth) {
            // Ok, so we're on the right side of the screen,
            // but now we need to make sure we're still a bit further right
            // cus....notchurally... Again, 25 is random. It works tho
            checkSafeAreaRight = true;
            popoverCSS.left = bodyWidth - popoverWidth - POPOVER_IOS_BODY_PADDING;
            originX = 'right';
        }
        // make it pop up if there's room above
        if (targetTop + targetHeight + popoverHeight > bodyHeight && targetTop - popoverHeight > 0) {
            arrowCSS.top = targetTop - (arrowHeight + 1);
            popoverCSS.top = targetTop - popoverHeight - (arrowHeight - 1);
            nativeEle.className = nativeEle.className + ' popover-bottom';
            originY = 'bottom';
            // If there isn't room for it to pop up above the target cut it off
        }
        else if (targetTop + targetHeight + popoverHeight > bodyHeight) {
            popoverEle.style.bottom = POPOVER_IOS_BODY_PADDING + '%';
        }
        arrowEle.style.top = arrowCSS.top + 'px';
        arrowEle.style.left = arrowCSS.left + 'px';
        popoverEle.style.top = popoverCSS.top + 'px';
        popoverEle.style.left = popoverCSS.left + 'px';
        if (checkSafeAreaLeft) {
            if (CSS.supports('left', 'constant(safe-area-inset-left)')) {
                popoverEle.style.left = "calc(" + popoverCSS.left + "px + constant(safe-area-inset-left)";
            }
            else if (CSS.supports('left', 'env(safe-area-inset-left)')) {
                popoverEle.style.left = "calc(" + popoverCSS.left + "px + env(safe-area-inset-left)";
            }
        }
        if (checkSafeAreaRight) {
            if (CSS.supports('right', 'constant(safe-area-inset-right)')) {
                popoverEle.style.left = "calc(" + popoverCSS.left + "px - constant(safe-area-inset-right)";
            }
            else if (CSS.supports('right', 'env(safe-area-inset-right)')) {
                popoverEle.style.left = "calc(" + popoverCSS.left + "px - env(safe-area-inset-right)";
            }
        }
        popoverEle.style[this.plt.Css.transformOrigin] = originY + ' ' + originX;
        // Since the transition starts before styling is done we
        // want to wait for the styles to apply before showing the wrapper
        popoverWrapperEle.style.opacity = '1';
    };
    return PopoverTransition;
}(__WEBPACK_IMPORTED_MODULE_1__transitions_page_transition__["a" /* PageTransition */]));

var PopoverPopIn = (function (_super) {
    __extends(PopoverPopIn, _super);
    function PopoverPopIn() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PopoverPopIn.prototype.init = function () {
        var ele = this.enteringView.pageRef().nativeElement;
        var backdrop = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](this.plt, ele.querySelector('ion-backdrop'));
        var wrapper = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](this.plt, ele.querySelector('.popover-wrapper'));
        wrapper.fromTo('opacity', 0.01, 1);
        backdrop.fromTo('opacity', 0.01, 0.08);
        this
            .easing('ease')
            .duration(100)
            .add(backdrop)
            .add(wrapper);
    };
    PopoverPopIn.prototype.play = function () {
        var _this = this;
        this.plt.raf(function () {
            _this.iosPositionView(_this.enteringView.pageRef().nativeElement, _this.opts.ev);
            _super.prototype.play.call(_this);
        });
    };
    return PopoverPopIn;
}(PopoverTransition));

var PopoverPopOut = (function (_super) {
    __extends(PopoverPopOut, _super);
    function PopoverPopOut() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PopoverPopOut.prototype.init = function () {
        var ele = this.leavingView.pageRef().nativeElement;
        var backdrop = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](this.plt, ele.querySelector('ion-backdrop'));
        var wrapper = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](this.plt, ele.querySelector('.popover-wrapper'));
        wrapper.fromTo('opacity', 0.99, 0);
        backdrop.fromTo('opacity', 0.08, 0);
        this
            .easing('ease')
            .duration(500)
            .add(backdrop)
            .add(wrapper);
    };
    return PopoverPopOut;
}(PopoverTransition));

var PopoverMdPopIn = (function (_super) {
    __extends(PopoverMdPopIn, _super);
    function PopoverMdPopIn() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PopoverMdPopIn.prototype.init = function () {
        var ele = this.enteringView.pageRef().nativeElement;
        var content = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](this.plt, ele.querySelector('.popover-content'));
        var viewport = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](this.plt, ele.querySelector('.popover-viewport'));
        content.fromTo('scale', 0.001, 1);
        viewport.fromTo('opacity', 0.01, 1);
        this
            .easing('cubic-bezier(0.36,0.66,0.04,1)')
            .duration(300)
            .add(content)
            .add(viewport);
    };
    PopoverMdPopIn.prototype.play = function () {
        var _this = this;
        this.plt.raf(function () {
            _this.mdPositionView(_this.enteringView.pageRef().nativeElement, _this.opts.ev);
            _super.prototype.play.call(_this);
        });
    };
    return PopoverMdPopIn;
}(PopoverTransition));

var PopoverMdPopOut = (function (_super) {
    __extends(PopoverMdPopOut, _super);
    function PopoverMdPopOut() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PopoverMdPopOut.prototype.init = function () {
        var ele = this.leavingView.pageRef().nativeElement;
        var wrapper = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](this.plt, ele.querySelector('.popover-wrapper'));
        wrapper.fromTo('opacity', 0.99, 0);
        this
            .easing('ease')
            .duration(500)
            .fromTo('opacity', 0.01, 1)
            .add(wrapper);
    };
    return PopoverMdPopOut;
}(PopoverTransition));

var POPOVER_IOS_BODY_PADDING = 2;
var POPOVER_MD_BODY_PADDING = 12;
//# sourceMappingURL=popover-transitions.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/popover/popover.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Popover; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__navigation_overlay_proxy__ = __webpack_require__("./node_modules/ionic-angular/navigation/overlay-proxy.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__popover_impl__ = __webpack_require__("./node_modules/ionic-angular/components/popover/popover-impl.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


/**
 * @hidden
 */
var Popover = (function (_super) {
    __extends(Popover, _super);
    function Popover(app, component, data, opts, config, deepLinker) {
        if (opts === void 0) { opts = {}; }
        var _this = _super.call(this, app, component, config, deepLinker) || this;
        _this.data = data;
        _this.opts = opts;
        _this.isOverlay = true;
        return _this;
    }
    Popover.prototype.getImplementation = function () {
        return new __WEBPACK_IMPORTED_MODULE_1__popover_impl__["a" /* PopoverImpl */](this._app, this._component, this.data, this.opts, this._config);
    };
    return Popover;
}(__WEBPACK_IMPORTED_MODULE_0__navigation_overlay_proxy__["a" /* OverlayProxy */]));

//# sourceMappingURL=popover.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/radio/radio-button.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RadioButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_form__ = __webpack_require__("./node_modules/ionic-angular/util/form.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ion__ = __webpack_require__("./node_modules/ionic-angular/components/ion.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__item_item__ = __webpack_require__("./node_modules/ionic-angular/components/item/item.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__radio_group__ = __webpack_require__("./node_modules/ionic-angular/components/radio/radio-group.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();







/**
 * @description
 * A radio button is a button that can be either checked or unchecked. A user can tap
 * the button to check or uncheck it. It can also be checked from the template using
 * the `checked` property.
 *
 * Use an element with a `radio-group` attribute to group a set of radio buttons. When
 * radio buttons are inside a [radio group](../RadioGroup), exactly one radio button
 * in the group can be checked at any time. If a radio button is not placed in a group,
 * they will all have the ability to be checked at the same time.
 *
 * See the [Angular Forms Docs](https://angular.io/docs/ts/latest/guide/forms.html) for
 * more information on forms and input.
 *
 * @usage
 * ```html
 * <ion-list radio-group [(ngModel)]="relationship">
 *   <ion-item>
 *     <ion-label>Friends</ion-label>
 *     <ion-radio value="friends" checked></ion-radio>
 *   </ion-item>
 *   <ion-item>
 *     <ion-label>Family</ion-label>
 *     <ion-radio value="family"></ion-radio>
 *   </ion-item>
 *   <ion-item>
 *     <ion-label>Enemies</ion-label>
 *     <ion-radio value="enemies" [disabled]="isDisabled"></ion-radio>
 *   </ion-item>
 * </ion-list>
 * ```
 * @demo /docs/demos/src/radio/
 * @see {@link /docs/components#radio Radio Component Docs}
 * @see {@link ../RadioGroup RadioGroup API Docs}
 */
var RadioButton = (function (_super) {
    __extends(RadioButton, _super);
    function RadioButton(_form, config, elementRef, renderer, _item, _group) {
        var _this = _super.call(this, config, elementRef, renderer, 'radio') || this;
        _this._form = _form;
        _this._item = _item;
        _this._group = _group;
        /**
         * @internal
         */
        _this._checked = false;
        /**
         * @internal
         */
        _this._disabled = false;
        /**
         * @internal
         */
        _this._value = null;
        /**
         * @output {any} Emitted when the radio button is selected.
         */
        _this.ionSelect = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        _form.register(_this);
        if (_group) {
            // register with the radiogroup
            _this.id = 'rb-' + _group.add(_this);
        }
        if (_item) {
            // register the input inside of the item
            // reset to the item's id instead of the radiogroup id
            _this.id = 'rb-' + _item.registerInput('radio');
            _this._labelId = 'lbl-' + _item.id;
            _this._item.setElementClass('item-radio', true);
        }
        return _this;
    }
    Object.defineProperty(RadioButton.prototype, "color", {
        /**
         * @input {string} The color to use from your Sass `$colors` map.
         * Default options are: `"primary"`, `"secondary"`, `"danger"`, `"light"`, and `"dark"`.
         * For more information, see [Theming your App](/docs/theming/theming-your-app).
         */
        set: function (val) {
            this._setColor(val);
            if (this._item) {
                this._item._updateColor(val, 'item-radio');
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RadioButton.prototype, "value", {
        /**
         * @input {any} The value of the radio button. Defaults to the generated id.
         */
        get: function () {
            // if the value is not defined then use it's unique id
            return Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["f" /* isBlank */])(this._value) ? this.id : this._value;
        },
        set: function (val) {
            this._value = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RadioButton.prototype, "checked", {
        /**
         * @input {boolean} If true, the element is selected, and other buttons in the group are unselected.
         */
        get: function () {
            return this._checked;
        },
        set: function (val) {
            this._checked = Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["o" /* isTrueProperty */])(val);
            if (this._item) {
                this._item.setElementClass('item-radio-checked', this._checked);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RadioButton.prototype, "disabled", {
        /**
         * @input {boolean} If true, the user cannot interact with this element.
         */
        get: function () {
            return this._disabled || (this._group != null && this._group.disabled);
        },
        set: function (val) {
            this._disabled = Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["o" /* isTrueProperty */])(val);
            this._item && this._item.setElementClass('item-radio-disabled', this._disabled);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @hidden
     */
    RadioButton.prototype.initFocus = function () {
        this._elementRef.nativeElement.querySelector('button').focus();
    };
    /**
     * @internal
     */
    RadioButton.prototype._click = function (ev) {
        (void 0) /* console.debug */;
        ev.preventDefault();
        ev.stopPropagation();
        this.checked = true;
        this.ionSelect.emit(this.value);
    };
    /**
     * @internal
     */
    RadioButton.prototype.ngOnInit = function () {
        if (this._group && Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["l" /* isPresent */])(this._group.value)) {
            this.checked = Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["g" /* isCheckedProperty */])(this._group.value, this.value);
        }
        if (this._group && this._group.disabled) {
            this.disabled = this._group.disabled;
        }
    };
    /**
     * @internal
     */
    RadioButton.prototype.ngOnDestroy = function () {
        this._form.deregister(this);
        this._group && this._group.remove(this);
    };
    RadioButton.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'ion-radio',
                    template: '<div class="radio-icon" [class.radio-checked]="_checked"> ' +
                        '<div class="radio-inner"></div> ' +
                        '</div> ' +
                        '<button role="radio" ' +
                        'type="button" ' +
                        'ion-button="item-cover" ' +
                        '[id]="id" ' +
                        '[attr.aria-checked]="_checked" ' +
                        '[attr.aria-labelledby]="_labelId" ' +
                        '[attr.aria-disabled]="_disabled" ' +
                        'class="item-cover"> ' +
                        '</button>',
                    host: {
                        '[class.radio-disabled]': '_disabled'
                    },
                    encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None,
                },] },
    ];
    /** @nocollapse */
    RadioButton.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_2__util_form__["a" /* Form */], },
        { type: __WEBPACK_IMPORTED_MODULE_1__config_config__["a" /* Config */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: __WEBPACK_IMPORTED_MODULE_5__item_item__["a" /* Item */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
        { type: __WEBPACK_IMPORTED_MODULE_6__radio_group__["a" /* RadioGroup */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
    ]; };
    RadioButton.propDecorators = {
        'color': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'ionSelect': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        'value': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'checked': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'disabled': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        '_click': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"], args: ['click', ['$event'],] },],
    };
    return RadioButton;
}(__WEBPACK_IMPORTED_MODULE_3__ion__["a" /* Ion */]));

//# sourceMappingURL=radio-button.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/radio/radio-group.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RadioGroup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__("./node_modules/@angular/forms/esm5/forms.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__list_list_header__ = __webpack_require__("./node_modules/ionic-angular/components/list/list-header.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");




/**
 * @name RadioGroup
 * @description
 * A radio group is a group of [radio buttons](../RadioButton). It allows
 * a user to select at most one radio button from a set. Checking one radio
 * button that belongs to a radio group unchecks any previous checked
 * radio button within the same group.
 *
 * See the [Angular Forms Docs](https://angular.io/docs/ts/latest/guide/forms.html)
 * for more information on forms and inputs.
 *
 * @usage
 * ```html
 * <ion-list radio-group [(ngModel)]="autoManufacturers">
 *
 *   <ion-list-header>
 *     Auto Manufacturers
 *   </ion-list-header>
 *
 *   <ion-item>
 *     <ion-label>Cord</ion-label>
 *     <ion-radio value="cord"></ion-radio>
 *   </ion-item>
 *
 *   <ion-item>
 *     <ion-label>Duesenberg</ion-label>
 *     <ion-radio value="duesenberg"></ion-radio>
 *   </ion-item>
 *
 *   <ion-item>
 *     <ion-label>Hudson</ion-label>
 *     <ion-radio value="hudson"></ion-radio>
 *   </ion-item>
 *
 *   <ion-item>
 *     <ion-label>Packard</ion-label>
 *     <ion-radio value="packard"></ion-radio>
 *   </ion-item>
 *
 *   <ion-item>
 *     <ion-label>Studebaker</ion-label>
 *     <ion-radio value="studebaker"></ion-radio>
 *   </ion-item>
 *
 * </ion-list>
 * ```
 *
 * @demo /docs/demos/src/radio/
 * @see {@link /docs/components#radio Radio Component Docs}
 * @see {@link ../RadioButton RadioButton API Docs}
*/
var RadioGroup = (function () {
    function RadioGroup(_renderer, _elementRef, _cd) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this._cd = _cd;
        /**
         * @internal
         */
        this._disabled = false;
        /**
         * @hidden
         */
        this._btns = [];
        /**
         * @hidden
         */
        this._ids = -1;
        /**
         * @hidden
         */
        this._init = false;
        /**
         * @output {any} Emitted when the selected button has changed.
         */
        this.ionChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.id = ++radioGroupIds;
    }
    Object.defineProperty(RadioGroup.prototype, "disabled", {
        /**
         * @input {boolean} If true, the user cannot interact with any of the buttons in the group.
         */
        get: function () {
            return this._disabled;
        },
        set: function (val) {
            this._disabled = Object(__WEBPACK_IMPORTED_MODULE_3__util_util__["o" /* isTrueProperty */])(val);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @hidden
     */
    RadioGroup.prototype.ngAfterContentInit = function () {
        var activeButton = this._btns.find(function (b) { return b.checked; });
        if (activeButton) {
            this._setActive(activeButton);
        }
    };
    /**
     * @hidden
     */
    RadioGroup.prototype.writeValue = function (val) {
        (void 0) /* console.debug */;
        this.value = val;
        if (this._init) {
            this._update();
            this.onTouched();
            this.ionChange.emit(val);
        }
        this._init = true;
    };
    /**
     * @hidden
     */
    RadioGroup.prototype.registerOnChange = function (fn) {
        var _this = this;
        this._fn = fn;
        this.onChange = function (val) {
            // onChange used when there's an formControlName
            (void 0) /* console.debug */;
            fn(val);
            _this.value = val;
            _this._update();
            _this.onTouched();
            _this.ionChange.emit(val);
        };
    };
    /**
     * @hidden
     */
    RadioGroup.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    /**
     * @hidden
     */
    RadioGroup.prototype._update = function () {
        var _this = this;
        // loop through each of the radiobuttons
        var hasChecked = false;
        this._btns.forEach(function (radioButton) {
            // check this radiobutton if its value is
            // the same as the radiogroups value
            radioButton.checked = Object(__WEBPACK_IMPORTED_MODULE_3__util_util__["g" /* isCheckedProperty */])(_this.value, radioButton.value) && !hasChecked;
            if (radioButton.checked) {
                // if this button is checked, then set it as
                // the radiogroup's active descendant
                _this._setActive(radioButton);
                hasChecked = true;
            }
        });
    };
    /**
     * @hidden
     */
    RadioGroup.prototype._setActive = function (radioButton) {
        this._renderer.setElementAttribute(this._elementRef.nativeElement, 'aria-activedescendant', radioButton.id);
    };
    /**
     * @hidden
     */
    RadioGroup.prototype.add = function (button) {
        var _this = this;
        this._btns.push(button);
        // listen for radiobutton select events
        button.ionSelect.subscribe(function (val) {
            // this radiobutton has been selected
            _this.onChange(val);
        });
        return this.id + '-' + (++this._ids);
    };
    /**
     * @hidden
     */
    RadioGroup.prototype.remove = function (button) {
        var index = this._btns.indexOf(button);
        if (index > -1) {
            if (button.value === this.value) {
                this.value = null;
            }
            this._btns.splice(index, 1);
        }
    };
    Object.defineProperty(RadioGroup.prototype, "_header", {
        /**
         * @hidden
         */
        set: function (header) {
            if (header) {
                if (!header.id) {
                    header.id = 'rg-hdr-' + this.id;
                }
                this._renderer.setElementAttribute(this._elementRef.nativeElement, 'aria-describedby', header.id);
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @hidden
     */
    RadioGroup.prototype.onChange = function (val) {
        // onChange used when there is not an formControlName
        (void 0) /* console.debug */;
        this.value = val;
        this._update();
        this.onTouched();
        this.ionChange.emit(val);
        this._cd.detectChanges();
    };
    /**
     * @hidden
     */
    RadioGroup.prototype.onTouched = function () { };
    /**
     * @hidden
     */
    RadioGroup.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
    };
    RadioGroup.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: '[radio-group]',
                    host: {
                        'role': 'radiogroup'
                    },
                    providers: [{ provide: __WEBPACK_IMPORTED_MODULE_1__angular_forms__["NG_VALUE_ACCESSOR"], useExisting: RadioGroup, multi: true }],
                },] },
    ];
    /** @nocollapse */
    RadioGroup.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"], },
    ]; };
    RadioGroup.propDecorators = {
        'disabled': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'ionChange': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        '_header': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChild"], args: [__WEBPACK_IMPORTED_MODULE_2__list_list_header__["a" /* ListHeader */],] },],
    };
    return RadioGroup;
}());

var radioGroupIds = -1;
//# sourceMappingURL=radio-group.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/range/range-knob.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RangeKnob; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__platform_key__ = __webpack_require__("./node_modules/ionic-angular/platform/key.js");


/**
 * @hidden
 */
var RangeKnob = (function () {
    function RangeKnob() {
        this.ionIncrease = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.ionDecrease = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
    }
    Object.defineProperty(RangeKnob.prototype, "ratio", {
        set: function (r) {
            this._x = r * 100 + "%";
        },
        enumerable: true,
        configurable: true
    });
    RangeKnob.prototype._keyup = function (ev) {
        var keyCode = ev.keyCode;
        if (keyCode === __WEBPACK_IMPORTED_MODULE_1__platform_key__["d" /* KEY_LEFT */] || keyCode === __WEBPACK_IMPORTED_MODULE_1__platform_key__["a" /* KEY_DOWN */]) {
            (void 0) /* console.debug */;
            this.ionDecrease.emit();
            ev.preventDefault();
            ev.stopPropagation();
        }
        else if (keyCode === __WEBPACK_IMPORTED_MODULE_1__platform_key__["e" /* KEY_RIGHT */] || keyCode === __WEBPACK_IMPORTED_MODULE_1__platform_key__["h" /* KEY_UP */]) {
            (void 0) /* console.debug */;
            this.ionIncrease.emit();
            ev.preventDefault();
            ev.stopPropagation();
        }
    };
    RangeKnob.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: '.range-knob-handle',
                    template: '<div class="range-pin" *ngIf="pin" role="presentation">{{val}}</div>' +
                        '<div class="range-knob" role="presentation"></div>',
                    host: {
                        '[class.range-knob-pressed]': 'pressed',
                        '[class.range-knob-min]': 'val===min||val===undefined',
                        '[class.range-knob-max]': 'val===max',
                        '[style.left]': '_x',
                        '[attr.aria-valuenow]': 'val',
                        '[attr.aria-valuemin]': 'min',
                        '[attr.aria-valuemax]': 'max',
                        '[attr.aria-disabled]': 'disabled',
                        '[attr.aria-labelledby]': 'labelId',
                        '[tabindex]': 'disabled?-1:0',
                        'role': 'slider'
                    }
                },] },
    ];
    /** @nocollapse */
    RangeKnob.ctorParameters = function () { return []; };
    RangeKnob.propDecorators = {
        'ratio': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'pressed': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'pin': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'min': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'max': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'val': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'disabled': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'labelId': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'ionIncrease': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        'ionDecrease': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        '_keyup': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"], args: ['keydown', ['$event'],] },],
    };
    return RangeKnob;
}());

//# sourceMappingURL=range-knob.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/range/range.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Range; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__("./node_modules/@angular/forms/esm5/forms.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__platform_dom_controller__ = __webpack_require__("./node_modules/ionic-angular/platform/dom-controller.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_form__ = __webpack_require__("./node_modules/ionic-angular/util/form.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tap_click_haptic__ = __webpack_require__("./node_modules/ionic-angular/tap-click/haptic.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_base_input__ = __webpack_require__("./node_modules/ionic-angular/util/base-input.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__item_item__ = __webpack_require__("./node_modules/ionic-angular/components/item/item.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__platform_platform__ = __webpack_require__("./node_modules/ionic-angular/platform/platform.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_dom__ = __webpack_require__("./node_modules/ionic-angular/util/dom.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__gestures_ui_event_manager__ = __webpack_require__("./node_modules/ionic-angular/gestures/ui-event-manager.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();












/**
 * @name Range
 * @description
 * The Range slider lets users select from a range of values by moving
 * the slider knob. It can accept dual knobs, but by default one knob
 * controls the value of the range.
 *
 * ### Range Labels
 * Labels can be placed on either side of the range by adding the
 * `range-left` or `range-right` property to the element. The element
 * doesn't have to be an `ion-label`, it can be added to any element
 * to place it to the left or right of the range. See [usage](#usage)
 * below for examples.
 *
 *
 * ### Minimum and Maximum Values
 * Minimum and maximum values can be passed to the range through the `min`
 * and `max` properties, respectively. By default, the range sets the `min`
 * to `0` and the `max` to `100`.
 *
 *
 * ### Steps and Snaps
 * The `step` property specifies the value granularity of the range's value.
 * It can be useful to set the `step` when the value isn't in increments of `1`.
 * Setting the `step` property will show tick marks on the range for each step.
 * The `snaps` property can be set to automatically move the knob to the nearest
 * tick mark based on the step property value.
 *
 *
 * ### Dual Knobs
 * Setting the `dualKnobs` property to `true` on the range component will
 * enable two knobs on the range. If the range has two knobs, the value will
 * be an object containing two properties: `lower` and `upper`.
 *
 *
 * @usage
 * ```html
 * <ion-list>
 *   <ion-item>
 *     <ion-range [(ngModel)]="singleValue" color="danger" pin="true"></ion-range>
 *   </ion-item>
 *
 *   <ion-item>
 *     <ion-range min="-200" max="200" [(ngModel)]="saturation" color="secondary">
 *       <ion-label range-left>-200</ion-label>
 *       <ion-label range-right>200</ion-label>
 *     </ion-range>
 *   </ion-item>
 *
 *  <ion-item>
 *    <ion-range min="20" max="80" step="2" [(ngModel)]="brightness">
 *      <ion-icon small range-left name="sunny"></ion-icon>
 *      <ion-icon range-right name="sunny"></ion-icon>
 *    </ion-range>
 *  </ion-item>
 *
 *   <ion-item>
 *     <ion-label>step=100, snaps, {{singleValue4}}</ion-label>
 *     <ion-range min="1000" max="2000" step="100" snaps="true" color="secondary" [(ngModel)]="singleValue4"></ion-range>
 *   </ion-item>
 *
 *   <ion-item>
 *     <ion-label>dual, step=3, snaps, {{dualValue2 | json}}</ion-label>
 *     <ion-range dualKnobs="true" [(ngModel)]="dualValue2" min="21" max="72" step="3" snaps="true"></ion-range>
 *   </ion-item>
 * </ion-list>
 * ```
 *
 *
 * @demo /docs/demos/src/range/
 */
var Range = (function (_super) {
    __extends(Range, _super);
    function Range(form, _haptic, item, config, _plt, elementRef, renderer, _dom, _cd) {
        var _this = _super.call(this, config, elementRef, renderer, 'range', 0, form, item, null) || this;
        _this._haptic = _haptic;
        _this._plt = _plt;
        _this._dom = _dom;
        _this._cd = _cd;
        _this._min = 0;
        _this._max = 100;
        _this._step = 1;
        _this._valA = 0;
        _this._valB = 0;
        _this._ratioA = 0;
        _this._ratioB = 0;
        _this._events = new __WEBPACK_IMPORTED_MODULE_11__gestures_ui_event_manager__["a" /* UIEventManager */](_plt);
        return _this;
    }
    Object.defineProperty(Range.prototype, "min", {
        /**
         * @input {number} Minimum integer value of the range. Defaults to `0`.
         */
        get: function () {
            return this._min;
        },
        set: function (val) {
            val = Math.round(val);
            if (!isNaN(val)) {
                this._min = val;
                this._inputUpdated();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Range.prototype, "max", {
        /**
         * @input {number} Maximum integer value of the range. Defaults to `100`.
         */
        get: function () {
            return this._max;
        },
        set: function (val) {
            val = Math.round(val);
            if (!isNaN(val)) {
                this._max = val;
                this._inputUpdated();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Range.prototype, "step", {
        /**
         * @input {number} Specifies the value granularity. Defaults to `1`.
         */
        get: function () {
            return this._step;
        },
        set: function (val) {
            val = Math.round(val);
            if (!isNaN(val) && val > 0) {
                this._step = val;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Range.prototype, "snaps", {
        /**
         * @input {boolean} If true, the knob snaps to tick marks evenly spaced based
         * on the step property value. Defaults to `false`.
         */
        get: function () {
            return this._snaps;
        },
        set: function (val) {
            this._snaps = Object(__WEBPACK_IMPORTED_MODULE_2__util_util__["o" /* isTrueProperty */])(val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Range.prototype, "pin", {
        /**
         * @input {boolean} If true, a pin with integer value is shown when the knob
         * is pressed. Defaults to `false`.
         */
        get: function () {
            return this._pin;
        },
        set: function (val) {
            this._pin = Object(__WEBPACK_IMPORTED_MODULE_2__util_util__["o" /* isTrueProperty */])(val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Range.prototype, "debounce", {
        /**
         * @input {number} How long, in milliseconds, to wait to trigger the
         * `ionChange` event after each change in the range value. Default `0`.
         */
        get: function () {
            return this._debouncer.wait;
        },
        set: function (val) {
            this._debouncer.wait = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Range.prototype, "dualKnobs", {
        /**
         * @input {boolean} Show two knobs. Defaults to `false`.
         */
        get: function () {
            return this._dual;
        },
        set: function (val) {
            this._dual = Object(__WEBPACK_IMPORTED_MODULE_2__util_util__["o" /* isTrueProperty */])(val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Range.prototype, "ratio", {
        /**
         * Returns the ratio of the knob's is current location, which is a number
         * between `0` and `1`. If two knobs are used, this property represents
         * the lower value.
         */
        get: function () {
            if (this._dual) {
                return Math.min(this._ratioA, this._ratioB);
            }
            return this._ratioA;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Range.prototype, "ratioUpper", {
        /**
         * Returns the ratio of the upper value's is current location, which is
         * a number between `0` and `1`. If there is only one knob, then this
         * will return `null`.
         */
        get: function () {
            if (this._dual) {
                return Math.max(this._ratioA, this._ratioB);
            }
            return null;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @hidden
     */
    Range.prototype.ngAfterContentInit = function () {
        this._initialize();
        // add touchstart/mousedown listeners
        this._events.pointerEvents({
            element: this._slider.nativeElement,
            pointerDown: this._pointerDown.bind(this),
            pointerMove: this._pointerMove.bind(this),
            pointerUp: this._pointerUp.bind(this),
            zone: true
        });
        // build all the ticks if there are any to show
        this._createTicks();
    };
    /** @internal */
    Range.prototype._pointerDown = function (ev) {
        // TODO: we could stop listening for events instead of checking this._disabled.
        // since there are a lot of events involved, this solution is
        // enough for the moment
        if (this._disabled) {
            return false;
        }
        // trigger ionFocus event
        this._fireFocus();
        // prevent default so scrolling does not happen
        ev.preventDefault();
        ev.stopPropagation();
        // get the start coordinates
        var current = Object(__WEBPACK_IMPORTED_MODULE_10__util_dom__["f" /* pointerCoord */])(ev);
        // get the full dimensions of the slider element
        var rect = this._rect = this._plt.getElementBoundingClientRect(this._slider.nativeElement);
        // figure out which knob they started closer to
        var ratio = Object(__WEBPACK_IMPORTED_MODULE_2__util_util__["a" /* clamp */])(0, (current.x - rect.left) / (rect.width), 1);
        this._activeB = this._dual && (Math.abs(ratio - this._ratioA) > Math.abs(ratio - this._ratioB));
        // update the active knob's position
        this._update(current, rect, true);
        // trigger a haptic start
        this._haptic.gestureSelectionStart();
        // return true so the pointer events
        // know everything's still valid
        return true;
    };
    /** @internal */
    Range.prototype._pointerMove = function (ev) {
        if (this._disabled) {
            return;
        }
        // prevent default so scrolling does not happen
        ev.preventDefault();
        ev.stopPropagation();
        // update the active knob's position
        var hasChanged = this._update(Object(__WEBPACK_IMPORTED_MODULE_10__util_dom__["f" /* pointerCoord */])(ev), this._rect, true);
        if (hasChanged && this._snaps) {
            // trigger a haptic selection changed event
            // if this is a snap range
            this._haptic.gestureSelectionChanged();
        }
    };
    /** @internal */
    Range.prototype._pointerUp = function (ev) {
        if (this._disabled) {
            return;
        }
        // prevent default so scrolling does not happen
        ev.preventDefault();
        ev.stopPropagation();
        // update the active knob's position
        this._update(Object(__WEBPACK_IMPORTED_MODULE_10__util_dom__["f" /* pointerCoord */])(ev), this._rect, false);
        // trigger a haptic end
        this._haptic.gestureSelectionEnd();
        // trigger ionBlur event
        this._fireBlur();
    };
    /** @internal */
    Range.prototype._update = function (current, rect, isPressed) {
        // figure out where the pointer is currently at
        // update the knob being interacted with
        var ratio = Object(__WEBPACK_IMPORTED_MODULE_2__util_util__["a" /* clamp */])(0, (current.x - rect.left) / (rect.width), 1);
        var val = this._ratioToValue(ratio);
        if (this._snaps) {
            // snaps the ratio to the current value
            ratio = this._valueToRatio(val);
        }
        // update which knob is pressed
        this._pressed = isPressed;
        var valChanged = false;
        if (this._activeB) {
            // when the pointer down started it was determined
            // that knob B was the one they were interacting with
            this._pressedB = isPressed;
            this._pressedA = false;
            this._ratioB = ratio;
            valChanged = val === this._valB;
            this._valB = val;
        }
        else {
            // interacting with knob A
            this._pressedA = isPressed;
            this._pressedB = false;
            this._ratioA = ratio;
            valChanged = val === this._valA;
            this._valA = val;
        }
        this._updateBar();
        if (valChanged) {
            return false;
        }
        // value has been updated
        var value;
        if (this._dual) {
            // dual knobs have an lower and upper value
            value = {
                lower: Math.min(this._valA, this._valB),
                upper: Math.max(this._valA, this._valB)
            };
            (void 0) /* console.debug */;
        }
        else {
            // single knob only has one value
            value = this._valA;
            (void 0) /* console.debug */;
        }
        // Update input value
        this.value = value;
        return true;
    };
    /** @internal */
    Range.prototype._updateBar = function () {
        var ratioA = this._ratioA;
        var ratioB = this._ratioB;
        if (this._dual) {
            this._barL = (Math.min(ratioA, ratioB) * 100) + "%";
            this._barR = 100 - (Math.max(ratioA, ratioB) * 100) + "%";
        }
        else {
            this._barL = '';
            this._barR = 100 - (ratioA * 100) + "%";
        }
        this._updateTicks();
    };
    /** @internal */
    Range.prototype._createTicks = function () {
        var _this = this;
        if (this._snaps) {
            this._dom.write(function () {
                // TODO: Fix to not use RAF
                _this._ticks = [];
                for (var value = _this._min; value <= _this._max; value += _this._step) {
                    var ratio = _this._valueToRatio(value);
                    _this._ticks.push({
                        ratio: ratio,
                        left: ratio * 100 + "%",
                    });
                }
                _this._updateTicks();
            });
        }
    };
    /** @internal */
    Range.prototype._updateTicks = function () {
        var ticks = this._ticks;
        var ratio = this.ratio;
        if (this._snaps && ticks) {
            if (this._dual) {
                var upperRatio = this.ratioUpper;
                ticks.forEach(function (t) {
                    t.active = (t.ratio >= ratio && t.ratio <= upperRatio);
                });
            }
            else {
                ticks.forEach(function (t) {
                    t.active = (t.ratio <= ratio);
                });
            }
        }
    };
    /** @hidden */
    Range.prototype._keyChg = function (isIncrease, isKnobB) {
        var step = this._step;
        if (isKnobB) {
            if (isIncrease) {
                this._valB += step;
            }
            else {
                this._valB -= step;
            }
            this._valB = Object(__WEBPACK_IMPORTED_MODULE_2__util_util__["a" /* clamp */])(this._min, this._valB, this._max);
            this._ratioB = this._valueToRatio(this._valB);
        }
        else {
            if (isIncrease) {
                this._valA += step;
            }
            else {
                this._valA -= step;
            }
            this._valA = Object(__WEBPACK_IMPORTED_MODULE_2__util_util__["a" /* clamp */])(this._min, this._valA, this._max);
            this._ratioA = this._valueToRatio(this._valA);
        }
        this._updateBar();
    };
    /** @internal */
    Range.prototype._ratioToValue = function (ratio) {
        ratio = Math.round(((this._max - this._min) * ratio));
        ratio = Math.round(ratio / this._step) * this._step + this._min;
        return Object(__WEBPACK_IMPORTED_MODULE_2__util_util__["a" /* clamp */])(this._min, ratio, this._max);
    };
    /** @internal */
    Range.prototype._valueToRatio = function (value) {
        value = Math.round((value - this._min) / this._step) * this._step;
        value = value / (this._max - this._min);
        return Object(__WEBPACK_IMPORTED_MODULE_2__util_util__["a" /* clamp */])(0, value, 1);
    };
    Range.prototype._inputNormalize = function (val) {
        if (this._dual) {
            return val;
        }
        else {
            val = parseFloat(val);
            return isNaN(val) ? undefined : val;
        }
    };
    /**
     * @hidden
     */
    Range.prototype._inputUpdated = function () {
        var val = this.value;
        if (this._dual) {
            this._valA = val.lower;
            this._valB = val.upper;
            this._ratioA = this._valueToRatio(val.lower);
            this._ratioB = this._valueToRatio(val.upper);
        }
        else {
            this._valA = val;
            this._ratioA = this._valueToRatio(val);
        }
        this._updateBar();
        this._cd.detectChanges();
    };
    /**
     * @hidden
     */
    Range.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        this._events.destroy();
    };
    Range.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'ion-range',
                    template: '<ng-content select="[range-left]"></ng-content>' +
                        '<div class="range-slider" #slider>' +
                        '<div class="range-tick" *ngFor="let t of _ticks" [style.left]="t.left" [class.range-tick-active]="t.active" role="presentation"></div>' +
                        '<div class="range-bar" role="presentation"></div>' +
                        '<div class="range-bar range-bar-active" [style.left]="_barL" [style.right]="_barR" #bar role="presentation"></div>' +
                        '<div class="range-knob-handle" (ionIncrease)="_keyChg(true, false)" (ionDecrease)="_keyChg(false, false)" [ratio]="_ratioA" [val]="_valA" [pin]="_pin" [pressed]="_pressedA" [min]="_min" [max]="_max" [disabled]="_disabled" [labelId]="_labelId"></div>' +
                        '<div class="range-knob-handle" (ionIncrease)="_keyChg(true, true)" (ionDecrease)="_keyChg(false, true)" [ratio]="_ratioB" [val]="_valB" [pin]="_pin" [pressed]="_pressedB" [min]="_min" [max]="_max" [disabled]="_disabled" [labelId]="_labelId" *ngIf="_dual"></div>' +
                        '</div>' +
                        '<ng-content select="[range-right]"></ng-content>',
                    host: {
                        '[class.range-disabled]': '_disabled',
                        '[class.range-pressed]': '_pressed',
                        '[class.range-has-pin]': '_pin'
                    },
                    providers: [{ provide: __WEBPACK_IMPORTED_MODULE_1__angular_forms__["NG_VALUE_ACCESSOR"], useExisting: Range, multi: true }],
                    encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None,
                },] },
    ];
    /** @nocollapse */
    Range.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_5__util_form__["a" /* Form */], },
        { type: __WEBPACK_IMPORTED_MODULE_6__tap_click_haptic__["a" /* Haptic */], },
        { type: __WEBPACK_IMPORTED_MODULE_8__item_item__["a" /* Item */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
        { type: __WEBPACK_IMPORTED_MODULE_3__config_config__["a" /* Config */], },
        { type: __WEBPACK_IMPORTED_MODULE_9__platform_platform__["a" /* Platform */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: __WEBPACK_IMPORTED_MODULE_4__platform_dom_controller__["a" /* DomController */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"], },
    ]; };
    Range.propDecorators = {
        '_slider': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"], args: ['slider',] },],
        'min': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'max': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'step': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'snaps': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'pin': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'debounce': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'dualKnobs': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return Range;
}(__WEBPACK_IMPORTED_MODULE_7__util_base_input__["a" /* BaseInput */]));

//# sourceMappingURL=range.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/refresher/refresher-content.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RefresherContent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__refresher__ = __webpack_require__("./node_modules/ionic-angular/components/refresher/refresher.js");



/**
 * @hidden
 */
var RefresherContent = (function () {
    function RefresherContent(r, _config) {
        this.r = r;
        this._config = _config;
    }
    /**
     * @hidden
     */
    RefresherContent.prototype.ngOnInit = function () {
        if (!this.pullingIcon) {
            this.pullingIcon = this._config.get('ionPullIcon', 'arrow-down');
        }
        if (!this.refreshingSpinner) {
            this.refreshingSpinner = this._config.get('ionRefreshingSpinner', this._config.get('spinner', 'ios'));
        }
    };
    RefresherContent.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'ion-refresher-content',
                    template: '<div class="refresher-pulling">' +
                        '<div class="refresher-pulling-icon" *ngIf="pullingIcon">' +
                        '<ion-icon [name]="pullingIcon"></ion-icon>' +
                        '</div>' +
                        '<div class="refresher-pulling-text" [innerHTML]="pullingText" *ngIf="pullingText"></div>' +
                        '</div>' +
                        '<div class="refresher-refreshing">' +
                        '<div class="refresher-refreshing-icon">' +
                        '<ion-spinner [name]="refreshingSpinner"></ion-spinner>' +
                        '</div>' +
                        '<div class="refresher-refreshing-text" [innerHTML]="refreshingText" *ngIf="refreshingText"></div>' +
                        '</div>',
                    host: {
                        '[attr.state]': 'r.state'
                    },
                    encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None,
                },] },
    ];
    /** @nocollapse */
    RefresherContent.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_2__refresher__["a" /* Refresher */], },
        { type: __WEBPACK_IMPORTED_MODULE_1__config_config__["a" /* Config */], },
    ]; };
    RefresherContent.propDecorators = {
        'pullingIcon': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'pullingText': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'refreshingSpinner': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'refreshingText': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return RefresherContent;
}());

//# sourceMappingURL=refresher-content.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/refresher/refresher.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Refresher; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__content_content__ = __webpack_require__("./node_modules/ionic-angular/components/content/content.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gestures_gesture_controller__ = __webpack_require__("./node_modules/ionic-angular/gestures/gesture-controller.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__platform_platform__ = __webpack_require__("./node_modules/ionic-angular/platform/platform.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_dom__ = __webpack_require__("./node_modules/ionic-angular/util/dom.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__gestures_ui_event_manager__ = __webpack_require__("./node_modules/ionic-angular/gestures/ui-event-manager.js");







/**
 * @name Refresher
 * @description
 * The Refresher provides pull-to-refresh functionality on a content component.
 * Place the `ion-refresher` as the first child of your `ion-content` element.
 *
 * Pages can then listen to the refresher's various output events. The
 * `refresh` output event is fired when the user has pulled down far
 * enough to kick off the refreshing process. Once the async operation
 * has completed and the refreshing should end, call `complete()`.
 *
 * Note: Do not wrap the `ion-refresher` in a `*ngIf`. It will not render
 * properly this way. Please use the `enabled` property instead to
 * display or hide the refresher.
 *
 * @usage
 * ```html
 * <ion-content>
 *
 *   <ion-refresher (ionRefresh)="doRefresh($event)">
 *     <ion-refresher-content></ion-refresher-content>
 *   </ion-refresher>
 *
 * </ion-content>
 * ```
 *
 * ```ts
 * @Component({...})
 * export class NewsFeedPage {
 *
 *   doRefresh(refresher) {
 *     console.log('Begin async operation', refresher);
 *
 *     setTimeout(() => {
 *       console.log('Async operation has ended');
 *       refresher.complete();
 *     }, 2000);
 *   }
 *
 * }
 * ```
 *
 *
 * ## Refresher Content
 *
 * By default, Ionic provides the pulling icon and refreshing spinner that
 * looks best for the platform the user is on. However, you can change the
 * default icon and spinner, along with adding text for each state by
 * adding properties to the child `ion-refresher-content` component.
 *
 *  ```html
 *  <ion-content>
 *
 *    <ion-refresher (ionRefresh)="doRefresh($event)">
 *      <ion-refresher-content
 *        pullingIcon="arrow-dropdown"
 *        pullingText="Pull to refresh"
 *        refreshingSpinner="circles"
 *        refreshingText="Refreshing...">
 *      </ion-refresher-content>
 *    </ion-refresher>
 *
 *  </ion-content>
 *  ```
 *
 *
 * ## Further Customizing Refresher Content
 *
 * The `ion-refresher` component holds the refresh logic.
 * It requires a child component in order to display the content.
 * Ionic uses `ion-refresher-content` by default. This component
 * displays the refresher and changes the look depending
 * on the refresher's state. Separating these components
 * allows developers to create their own refresher content
 * components. You could replace our default content with
 * custom SVG or CSS animations.
 *
 * @demo /docs/demos/src/refresher/
 *
 */
var Refresher = (function () {
    function Refresher(_plt, _content, _zone, gestureCtrl) {
        this._plt = _plt;
        this._content = _content;
        this._zone = _zone;
        this._appliedStyles = false;
        this._lastCheck = 0;
        this._isEnabled = true;
        this._top = '';
        /**
         * The current state which the refresher is in. The refresher's states include:
         *
         * - `inactive` - The refresher is not being pulled down or refreshing and is currently hidden.
         * - `pulling` - The user is actively pulling down the refresher, but has not reached the point yet that if the user lets go, it'll refresh.
         * - `cancelling` - The user pulled down the refresher and let go, but did not pull down far enough to kick off the `refreshing` state. After letting go, the refresher is in the `cancelling` state while it is closing, and will go back to the `inactive` state once closed.
         * - `ready` - The user has pulled down the refresher far enough that if they let go, it'll begin the `refreshing` state.
         * - `refreshing` - The refresher is actively waiting on the async operation to end. Once the refresh handler calls `complete()` it will begin the `completing` state.
         * - `completing` - The `refreshing` state has finished and the refresher is in the process of closing itself. Once closed, the refresher will go back to the `inactive` state.
         */
        this.state = STATE_INACTIVE;
        /**
         * The Y coordinate of where the user started to the pull down the content.
         */
        this.startY = null;
        /**
         * The current touch or mouse event's Y coordinate.
         */
        this.currentY = null;
        /**
         * The distance between the start of the pull and the current touch or
         * mouse event's Y coordinate.
         */
        this.deltaY = null;
        /**
         * A number representing how far down the user has pulled.
         * The number `0` represents the user hasn't pulled down at all. The
         * number `1`, and anything greater than `1`, represents that the user
         * has pulled far enough down that when they let go then the refresh will
         * happen. If they let go and the number is less than `1`, then the
         * refresh will not happen, and the content will return to it's original
         * position.
         */
        this.progress = 0;
        /**
         * @input {number} The min distance the user must pull down until the
         * refresher can go into the `refreshing` state. Default is `60`.
         */
        this.pullMin = 60;
        /**
         * @input {number} The maximum distance of the pull until the refresher
         * will automatically go into the `refreshing` state. By default, the pull
         * maximum will be the result of `pullMin + 60`.
         */
        this.pullMax = this.pullMin + 60;
        /**
         * @input {number} How many milliseconds it takes to close the refresher. Default is `280`.
         */
        this.closeDuration = 280;
        /**
         * @input {number} How many milliseconds it takes the refresher to to snap back to the `refreshing` state. Default is `280`.
         */
        this.snapbackDuration = 280;
        /**
         * @output {event} Emitted when the user lets go and has pulled down
         * far enough, which would be farther than the `pullMin`, then your refresh hander if
         * fired and the state is updated to `refreshing`. From within your refresh handler,
         * you must call the `complete()` method when your async operation has completed.
         */
        this.ionRefresh = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
         * @output {event} Emitted while the user is pulling down the content and exposing the refresher.
         */
        this.ionPull = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
         * @output {event} Emitted when the user begins to start pulling down.
         */
        this.ionStart = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this._events = new __WEBPACK_IMPORTED_MODULE_6__gestures_ui_event_manager__["a" /* UIEventManager */](_plt);
        _content._hasRefresher = true;
        this._gesture = gestureCtrl.createGesture({
            name: __WEBPACK_IMPORTED_MODULE_2__gestures_gesture_controller__["k" /* GESTURE_REFRESHER */],
            priority: __WEBPACK_IMPORTED_MODULE_2__gestures_gesture_controller__["h" /* GESTURE_PRIORITY_REFRESHER */]
        });
    }
    Object.defineProperty(Refresher.prototype, "enabled", {
        /**
         * @input {boolean} If the refresher is enabled or not. This should be used in place of an `ngIf`. Default is `true`.
         */
        get: function () {
            return this._isEnabled;
        },
        set: function (val) {
            this._isEnabled = Object(__WEBPACK_IMPORTED_MODULE_3__util_util__["o" /* isTrueProperty */])(val);
            this._setListeners(this._isEnabled);
        },
        enumerable: true,
        configurable: true
    });
    Refresher.prototype._onStart = function (ev) {
        // if multitouch then get out immediately
        if (ev.touches && ev.touches.length > 1) {
            return false;
        }
        if (this.state !== STATE_INACTIVE) {
            return false;
        }
        var scrollHostScrollTop = this._content.getContentDimensions().scrollTop;
        // if the scrollTop is greater than zero then it's
        // not possible to pull the content down yet
        if (scrollHostScrollTop > 0) {
            return false;
        }
        if (!this._gesture.canStart()) {
            return false;
        }
        var coord = Object(__WEBPACK_IMPORTED_MODULE_5__util_dom__["f" /* pointerCoord */])(ev);
        (void 0) /* console.debug */;
        if (this._content.contentTop > 0) {
            var newTop = this._content.contentTop + 'px';
            if (this._top !== newTop) {
                this._top = newTop;
            }
        }
        this.startY = this.currentY = coord.y;
        this.progress = 0;
        this.state = STATE_INACTIVE;
        return true;
    };
    Refresher.prototype._onMove = function (ev) {
        // this method can get called like a bazillion times per second,
        // so it's built to be as efficient as possible, and does its
        // best to do any DOM read/writes only when absolutely necessary
        var _this = this;
        // if multitouch then get out immediately
        if (ev.touches && ev.touches.length > 1) {
            return 1;
        }
        if (!this._gesture.canStart()) {
            return 0;
        }
        // do nothing if it's actively refreshing
        // or it's in the process of closing
        // or this was never a startY
        if (this.startY === null || this.state === STATE_REFRESHING || this.state === STATE_CANCELLING || this.state === STATE_COMPLETING) {
            return 2;
        }
        // if we just updated stuff less than 16ms ago
        // then don't check again, just chillout plz
        var now = Date.now();
        if (this._lastCheck + 16 > now) {
            return 3;
        }
        // remember the last time we checked all this
        this._lastCheck = now;
        // get the current pointer coordinates
        var coord = Object(__WEBPACK_IMPORTED_MODULE_5__util_dom__["f" /* pointerCoord */])(ev);
        this.currentY = coord.y;
        // it's now possible they could be pulling down the content
        // how far have they pulled so far?
        this.deltaY = (coord.y - this.startY);
        // don't bother if they're scrolling up
        // and have not already started dragging
        if (this.deltaY <= 0) {
            // the current Y is higher than the starting Y
            // so they scrolled up enough to be ignored
            this.progress = 0;
            if (this.state !== STATE_INACTIVE) {
                this._zone.run(function () {
                    _this.state = STATE_INACTIVE;
                });
            }
            if (this._appliedStyles) {
                // reset the styles only if they were applied
                this._setCss(0, '', false, '');
                return 5;
            }
            return 6;
        }
        if (this.state === STATE_INACTIVE) {
            // this refresh is not already actively pulling down
            // get the content's scrollTop
            var scrollHostScrollTop = this._content.getContentDimensions().scrollTop;
            // if the scrollTop is greater than zero then it's
            // not possible to pull the content down yet
            if (scrollHostScrollTop > 0) {
                this.progress = 0;
                this.startY = null;
                return 7;
            }
            // content scrolled all the way to the top, and dragging down
            this.state = STATE_PULLING;
        }
        // prevent native scroll events
        ev.preventDefault();
        // the refresher is actively pulling at this point
        // move the scroll element within the content element
        this._setCss(this.deltaY, '0ms', true, '');
        if (!this.deltaY) {
            // don't continue if there's no delta yet
            this.progress = 0;
            return 8;
        }
        // so far so good, let's run this all back within zone now
        this._zone.run(function () {
            _this._onMoveInZone();
        });
    };
    Refresher.prototype._onMoveInZone = function () {
        // set pull progress
        this.progress = (this.deltaY / this.pullMin);
        // emit "start" if it hasn't started yet
        if (!this._didStart) {
            this._didStart = true;
            this.ionStart.emit(this);
        }
        // emit "pulling" on every move
        this.ionPull.emit(this);
        // do nothing if the delta is less than the pull threshold
        if (this.deltaY < this.pullMin) {
            // ensure it stays in the pulling state, cuz its not ready yet
            this.state = STATE_PULLING;
            return 2;
        }
        if (this.deltaY > this.pullMax) {
            // they pulled farther than the max, so kick off the refresh
            this._beginRefresh();
            return 3;
        }
        // pulled farther than the pull min!!
        // it is now in the `ready` state!!
        // if they let go then it'll refresh, kerpow!!
        this.state = STATE_READY;
        return 4;
    };
    Refresher.prototype._onEnd = function () {
        // only run in a zone when absolutely necessary
        var _this = this;
        if (this.state === STATE_READY) {
            this._zone.run(function () {
                // they pulled down far enough, so it's ready to refresh
                _this._beginRefresh();
            });
        }
        else if (this.state === STATE_PULLING) {
            this._zone.run(function () {
                // they were pulling down, but didn't pull down far enough
                // set the content back to it's original location
                // and close the refresher
                // set that the refresh is actively cancelling
                _this.cancel();
            });
        }
        // reset on any touchend/mouseup
        this.startY = null;
    };
    Refresher.prototype._beginRefresh = function () {
        // assumes we're already back in a zone
        // they pulled down far enough, so it's ready to refresh
        this.state = STATE_REFRESHING;
        // place the content in a hangout position while it thinks
        this._setCss(this.pullMin, (this.snapbackDuration + 'ms'), true, '');
        // emit "refresh" because it was pulled down far enough
        // and they let go to begin refreshing
        this.ionRefresh.emit(this);
    };
    /**
     * Call `complete()` when your async operation has completed.
     * For example, the `refreshing` state is while the app is performing
     * an asynchronous operation, such as receiving more data from an
     * AJAX request. Once the data has been received, you then call this
     * method to signify that the refreshing has completed and to close
     * the refresher. This method also changes the refresher's state from
     * `refreshing` to `completing`.
     */
    Refresher.prototype.complete = function () {
        this._close(STATE_COMPLETING, '120ms');
    };
    /**
     * Changes the refresher's state from `refreshing` to `cancelling`.
     */
    Refresher.prototype.cancel = function () {
        this._close(STATE_CANCELLING, '');
    };
    Refresher.prototype._close = function (state, delay) {
        var timer;
        function close(ev) {
            // closing is done, return to inactive state
            if (ev) {
                clearTimeout(timer);
            }
            this.state = STATE_INACTIVE;
            this.progress = 0;
            this._didStart = this.startY = this.currentY = this.deltaY = null;
            this._setCss(0, '0ms', false, '');
        }
        // create fallback timer incase something goes wrong with transitionEnd event
        timer = setTimeout(close.bind(this), 600);
        // create transition end event on the content's scroll element
        this._content.onScrollElementTransitionEnd(close.bind(this));
        // reset set the styles on the scroll element
        // set that the refresh is actively cancelling/completing
        this.state = state;
        this._setCss(0, '', true, delay);
        if (this._pointerEvents) {
            this._pointerEvents.stop();
        }
    };
    Refresher.prototype._setCss = function (y, duration, overflowVisible, delay) {
        this._appliedStyles = (y > 0);
        var content = this._content;
        var Css = this._plt.Css;
        content.setScrollElementStyle(Css.transform, ((y > 0) ? 'translateY(' + y + 'px) translateZ(0px)' : 'translateZ(0px)'));
        content.setScrollElementStyle(Css.transitionDuration, duration);
        content.setScrollElementStyle(Css.transitionDelay, delay);
        content.setScrollElementStyle('overflow', (overflowVisible ? 'hidden' : ''));
    };
    Refresher.prototype._setListeners = function (shouldListen) {
        this._events.unlistenAll();
        this._pointerEvents = null;
        if (shouldListen) {
            this._pointerEvents = this._events.pointerEvents({
                element: this._content.getScrollElement(),
                pointerDown: this._onStart.bind(this),
                pointerMove: this._onMove.bind(this),
                pointerUp: this._onEnd.bind(this),
                zone: false
            });
        }
    };
    /**
     * @hidden
     */
    Refresher.prototype.ngOnInit = function () {
        // bind event listeners
        // save the unregister listener functions to use onDestroy
        this._setListeners(this._isEnabled);
    };
    /**
     * @hidden
     */
    Refresher.prototype.ngOnDestroy = function () {
        this._setListeners(false);
        this._events.destroy();
        this._gesture.destroy();
    };
    Refresher.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'ion-refresher',
                    host: {
                        '[class.refresher-active]': 'state !== "inactive"',
                        '[style.top]': '_top'
                    }
                },] },
    ];
    /** @nocollapse */
    Refresher.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_4__platform_platform__["a" /* Platform */], },
        { type: __WEBPACK_IMPORTED_MODULE_1__content_content__["a" /* Content */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Host"] },] },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"], },
        { type: __WEBPACK_IMPORTED_MODULE_2__gestures_gesture_controller__["m" /* GestureController */], },
    ]; };
    Refresher.propDecorators = {
        'pullMin': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'pullMax': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'closeDuration': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'snapbackDuration': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'enabled': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'ionRefresh': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        'ionPull': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        'ionStart': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    };
    return Refresher;
}());

var STATE_INACTIVE = 'inactive';
var STATE_PULLING = 'pulling';
var STATE_READY = 'ready';
var STATE_REFRESHING = 'refreshing';
var STATE_CANCELLING = 'cancelling';
var STATE_COMPLETING = 'completing';
//# sourceMappingURL=refresher.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/scroll/scroll.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Scroll; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");


/**
 * @name Scroll
 * @description
 * Scroll is a non-flexboxed scroll area that can scroll horizontally or vertically. `ion-Scroll` Can be used in places where you may not need a full page scroller, but a highly customized one, such as image scubber or comment scroller.
 * @usage
 * ```html
 * <ion-scroll scrollX="true">
 * </ion-scroll>
 *
 * <ion-scroll scrollY="true">
 * </ion-scroll>
 *
 * <ion-scroll scrollX="true" scrollY="true">
 * </ion-scroll>
 * ```
 * @demo /docs/demos/src/scroll/
 */
var Scroll = (function () {
    function Scroll() {
        this._scrollX = false;
        this._scrollY = false;
        this._zoom = false;
        this._maxZoom = 1;
        /**
         * @hidden
         */
        this.maxScale = 3;
        /**
         * @hidden
         */
        this.zoomDuration = 250;
    }
    Object.defineProperty(Scroll.prototype, "scrollX", {
        /**
         * @input {boolean} If true, scrolling along the X axis is enabled.
         */
        get: function () {
            return this._scrollX;
        },
        set: function (val) {
            this._scrollX = Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["o" /* isTrueProperty */])(val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Scroll.prototype, "scrollY", {
        /**
         * @input {boolean} If true, scrolling along the Y axis is enabled; requires the following CSS declaration: ion-scroll { white-space: nowrap; }
         */
        get: function () {
            return this._scrollY;
        },
        set: function (val) {
            this._scrollY = Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["o" /* isTrueProperty */])(val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Scroll.prototype, "zoom", {
        /**
         * @input {boolean} If true, zooming is enabled.
         */
        get: function () {
            return this._zoom;
        },
        set: function (val) {
            this._zoom = Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["o" /* isTrueProperty */])(val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Scroll.prototype, "maxZoom", {
        /**
         * @input {number} Set the max zoom amount.
         */
        get: function () {
            return this._maxZoom;
        },
        set: function (val) {
            this._maxZoom = val;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @hidden
     * Add a scroll event handler to the scroll element if it exists.
     * @param {Function} handler  The scroll handler to add to the scroll element.
     * @returns {?Function} a function to remove the specified handler, otherwise
     * undefined if the scroll element doesn't exist.
     */
    Scroll.prototype.addScrollEventListener = function (handler) {
        (void 0) /* assert */;
        var ele = this._scrollContent.nativeElement;
        ele.addEventListener('scroll', handler);
        return function () {
            ele.removeEventListener('scroll', handler);
        };
    };
    Scroll.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'ion-scroll',
                    template: '<div class="scroll-content" #scrollContent>' +
                        '<div class="scroll-zoom-wrapper">' +
                        '<ng-content></ng-content>' +
                        '</div>' +
                        '</div>',
                    host: {
                        '[class.scroll-x]': 'scrollX',
                        '[class.scroll-y]': 'scrollY'
                    },
                    changeDetection: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectionStrategy"].OnPush,
                    encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None,
                },] },
    ];
    /** @nocollapse */
    Scroll.ctorParameters = function () { return []; };
    Scroll.propDecorators = {
        'scrollX': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'scrollY': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'zoom': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'maxZoom': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        '_scrollContent': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"], args: ['scrollContent', { read: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"] },] },],
    };
    return Scroll;
}());

//# sourceMappingURL=scroll.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/searchbar/searchbar.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Searchbar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__("./node_modules/@angular/forms/esm5/forms.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_base_input__ = __webpack_require__("./node_modules/ionic-angular/util/base-input.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_debouncer__ = __webpack_require__("./node_modules/ionic-angular/util/debouncer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__platform_platform__ = __webpack_require__("./node_modules/ionic-angular/platform/platform.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();







/**
 * @name Searchbar
 * @module ionic
 * @description
 * Manages the display of a Searchbar which can be used to search or filter items.
 *
 * @usage
 * ```html
 * <ion-searchbar
 *   [(ngModel)]="myInput"
 *   [showCancelButton]="shouldShowCancel"
 *   (ionInput)="onInput($event)"
 *   (ionCancel)="onCancel($event)">
 * </ion-searchbar>
 * ```
 *
 * @demo /docs/demos/src/searchbar/
 * @see {@link /docs/components#searchbar Searchbar Component Docs}
 */
var Searchbar = (function (_super) {
    __extends(Searchbar, _super);
    function Searchbar(config, _plt, elementRef, renderer, ngControl) {
        var _this = _super.call(this, config, elementRef, renderer, 'searchbar', '', null, null, ngControl) || this;
        _this._plt = _plt;
        _this._shouldBlur = true;
        _this._shouldAlignLeft = true;
        _this._isCancelVisible = false;
        _this._spellcheck = false;
        _this._autocomplete = 'off';
        _this._autocorrect = 'off';
        _this._isActive = false;
        _this._showCancelButton = false;
        _this._animated = false;
        _this._inputDebouncer = new __WEBPACK_IMPORTED_MODULE_5__util_debouncer__["a" /* TimeoutDebouncer */](0);
        /**
         * @input {string} Set the the cancel button text. Default: `"Cancel"`.
         */
        _this.cancelButtonText = 'Cancel';
        /**
         * @input {string} Set the input's placeholder. Default `"Search"`.
         */
        _this.placeholder = 'Search';
        /**
         * @input {string} Set the type of the input. Values: `"text"`, `"password"`, `"email"`, `"number"`, `"search"`, `"tel"`, `"url"`. Default `"search"`.
         */
        _this.type = 'search';
        /**
         * @output {event} Emitted when the Searchbar input has changed, including when it's cleared.
         */
        _this.ionInput = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
         * @output {event} Emitted when the cancel button is clicked.
         */
        _this.ionCancel = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
         * @output {event} Emitted when the clear input button is clicked.
         */
        _this.ionClear = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        _this.debounce = 250;
        return _this;
    }
    Object.defineProperty(Searchbar.prototype, "showCancelButton", {
        /**
         * @input {boolean} If true, show the cancel button. Default `false`.
         */
        get: function () {
            return this._showCancelButton;
        },
        set: function (val) {
            this._showCancelButton = Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["o" /* isTrueProperty */])(val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Searchbar.prototype, "debounce", {
        /**
         * @input {number} How long, in milliseconds, to wait to trigger the `ionInput` event after each keystroke. Default `250`.
         */
        get: function () {
            return this._debouncer.wait;
        },
        set: function (val) {
            this._debouncer.wait = val;
            this._inputDebouncer.wait = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Searchbar.prototype, "autocomplete", {
        /**
         * @input {string} Set the input's autocomplete property. Values: `"on"`, `"off"`. Default `"off"`.
         */
        set: function (val) {
            this._autocomplete = (val === '' || val === 'on') ? 'on' : this._config.get('autocomplete', 'off');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Searchbar.prototype, "autocorrect", {
        /**
         * @input {string} Set the input's autocorrect property. Values: `"on"`, `"off"`. Default `"off"`.
         */
        set: function (val) {
            this._autocorrect = (val === '' || val === 'on') ? 'on' : this._config.get('autocorrect', 'off');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Searchbar.prototype, "spellcheck", {
        /**
         * @input {string|boolean} Set the input's spellcheck property. Values: `true`, `false`. Default `false`.
         */
        set: function (val) {
            this._spellcheck = (val === '' || val === 'true' || val === true) ? true : this._config.getBoolean('spellcheck', false);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Searchbar.prototype, "animated", {
        /**
         * @input {boolean} If true, enable searchbar animation. Default `false`.
         */
        get: function () {
            return this._animated;
        },
        set: function (val) {
            this._animated = Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["o" /* isTrueProperty */])(val);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @hidden
     * On Initialization check for attributes
     */
    Searchbar.prototype.ngOnInit = function () {
        var showCancelButton = this.showCancelButton;
        if (typeof showCancelButton === 'string') {
            this.showCancelButton = (showCancelButton === '' || showCancelButton === 'true');
        }
    };
    /**
     * @hidden
     */
    Searchbar.prototype._inputUpdated = function () {
        var ele = this._searchbarInput.nativeElement;
        var value = this._value;
        // It is important not to re-assign the value if it is the same, because,
        // otherwise, the caret is moved to the end of the input
        if (ele.value !== value) {
            ele.value = value;
        }
        this.positionElements();
    };
    /**
     * @hidden
     * Positions the input search icon, placeholder, and the cancel button
     * based on the input value and if it is focused. (ios only)
     */
    Searchbar.prototype.positionElements = function () {
        var isAnimated = this._animated;
        var prevAlignLeft = this._shouldAlignLeft;
        var shouldAlignLeft = (!isAnimated || (this._value && this._value.toString().trim() !== '') || this._isFocus === true);
        this._shouldAlignLeft = shouldAlignLeft;
        if (this._mode !== 'ios') {
            return;
        }
        if (prevAlignLeft !== shouldAlignLeft) {
            this.positionPlaceholder();
        }
        if (isAnimated) {
            this.positionCancelButton();
        }
    };
    Searchbar.prototype.positionPlaceholder = function () {
        var inputEle = this._searchbarInput.nativeElement;
        var iconEle = this._searchbarIcon.nativeElement;
        if (this._shouldAlignLeft) {
            inputEle.removeAttribute('style');
            iconEle.removeAttribute('style');
        }
        else {
            // Create a dummy span to get the placeholder width
            var doc = this._plt.doc();
            var tempSpan = doc.createElement('span');
            tempSpan.innerHTML = this.placeholder;
            doc.body.appendChild(tempSpan);
            // Get the width of the span then remove it
            var textWidth = tempSpan.offsetWidth;
            doc.body.removeChild(tempSpan);
            // Set the input padding start
            var inputLeft = 'calc(50% - ' + (textWidth / 2) + 'px)';
            if (this._plt.isRTL) {
                inputEle.style.paddingRight = inputLeft;
            }
            else {
                inputEle.style.paddingLeft = inputLeft;
            }
            // Set the icon margin start
            var iconLeft = 'calc(50% - ' + ((textWidth / 2) + 30) + 'px)';
            if (this._plt.isRTL) {
                iconEle.style.marginRight = iconLeft;
            }
            else {
                iconEle.style.marginLeft = iconLeft;
            }
        }
    };
    /**
     * @hidden
     * Show the iOS Cancel button on focus, hide it offscreen otherwise
     */
    Searchbar.prototype.positionCancelButton = function () {
        var showShowCancel = this._isFocus;
        if (showShowCancel !== this._isCancelVisible) {
            var cancelStyleEle = this._cancelButton.nativeElement;
            var cancelStyle = cancelStyleEle.style;
            this._isCancelVisible = showShowCancel;
            if (showShowCancel) {
                if (this._plt.isRTL) {
                    cancelStyle.marginLeft = '0';
                }
                else {
                    cancelStyle.marginRight = '0';
                }
            }
            else {
                var offset = cancelStyleEle.offsetWidth;
                if (offset > 0) {
                    if (this._plt.isRTL) {
                        cancelStyle.marginLeft = -offset + 'px';
                    }
                    else {
                        cancelStyle.marginRight = -offset + 'px';
                    }
                }
            }
        }
    };
    /**
     * @hidden
     * Update the Searchbar input value when the input changes
     */
    Searchbar.prototype.inputChanged = function (ev) {
        var _this = this;
        this.value = ev.target.value;
        this._inputDebouncer.debounce(function () {
            _this.ionInput.emit(ev);
        });
    };
    /**
     * @hidden
     * Sets the Searchbar to focused and active on input focus.
     */
    Searchbar.prototype.inputFocused = function () {
        this._isActive = true;
        this._fireFocus();
        this.positionElements();
    };
    /**
     * @hidden
     * Sets the Searchbar to not focused and checks if it should align left
     * based on whether there is a value in the searchbar or not.
     */
    Searchbar.prototype.inputBlurred = function () {
        // _shouldBlur determines if it should blur
        // if we are clearing the input we still want to stay focused in the input
        if (this._shouldBlur === false) {
            this._searchbarInput.nativeElement.focus();
            this._shouldBlur = true;
            return;
        }
        this._fireBlur();
        this.positionElements();
    };
    /**
     * @hidden
     * Clears the input field and triggers the control change.
     */
    Searchbar.prototype.clearInput = function (ev) {
        var _this = this;
        this.ionClear.emit(ev);
        // setTimeout() fixes https://github.com/ionic-team/ionic/issues/7527
        // wait for 4 frames
        setTimeout(function () {
            var value = _this._value;
            if (Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["l" /* isPresent */])(value) && value !== '') {
                _this.value = ''; // DOM WRITE
                _this.ionInput.emit(ev);
            }
        }, 16 * 4);
        this._shouldBlur = false;
    };
    /**
     * @hidden
     * Clears the input field and tells the input to blur since
     * the clearInput function doesn't want the input to blur
     * then calls the custom cancel function if the user passed one in.
     */
    Searchbar.prototype.cancelSearchbar = function (ev) {
        this.ionCancel.emit(ev);
        this.clearInput(ev);
        this._shouldBlur = true;
        this._isActive = false;
    };
    Searchbar.prototype.setFocus = function () {
        this._renderer.invokeElementMethod(this._searchbarInput.nativeElement, 'focus');
    };
    Searchbar.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'ion-searchbar',
                    template: '<div class="searchbar-input-container">' +
                        '<button ion-button mode="md" (click)="cancelSearchbar($event)" (mousedown)="cancelSearchbar($event)" clear color="dark" class="searchbar-md-cancel" type="button">' +
                        '<ion-icon name="md-arrow-back"></ion-icon>' +
                        '</button>' +
                        '<div #searchbarIcon class="searchbar-search-icon"></div>' +
                        '<input #searchbarInput class="searchbar-input" (input)="inputChanged($event)" (blur)="inputBlurred()" (focus)="inputFocused()" ' +
                        'dir="auto" ' +
                        '[attr.placeholder]="placeholder" ' +
                        '[attr.type]="type" ' +
                        '[attr.autocomplete]="_autocomplete" ' +
                        '[attr.autocorrect]="_autocorrect" ' +
                        '[attr.spellcheck]="_spellcheck">' +
                        '<button ion-button clear class="searchbar-clear-icon" [mode]="_mode" (click)="clearInput($event)" (mousedown)="clearInput($event)" type="button"></button>' +
                        '</div>' +
                        '<button ion-button #cancelButton mode="ios" [tabindex]="_isActive ? 1 : -1" clear (click)="cancelSearchbar($event)" (mousedown)="cancelSearchbar($event)" class="searchbar-ios-cancel" type="button">{{cancelButtonText}}</button>',
                    host: {
                        '[class.searchbar-animated]': '_animated',
                        '[class.searchbar-has-value]': '_value',
                        '[class.searchbar-active]': '_isActive',
                        '[class.searchbar-show-cancel]': '_showCancelButton',
                        '[class.searchbar-left-aligned]': '_shouldAlignLeft',
                        '[class.searchbar-has-focus]': '_isFocus'
                    },
                    encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None
                },] },
    ];
    /** @nocollapse */
    Searchbar.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_2__config_config__["a" /* Config */], },
        { type: __WEBPACK_IMPORTED_MODULE_6__platform_platform__["a" /* Platform */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_forms__["NgControl"], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
    ]; };
    Searchbar.propDecorators = {
        'cancelButtonText': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'showCancelButton': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'debounce': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'placeholder': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'autocomplete': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'autocorrect': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'spellcheck': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'type': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'animated': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'ionInput': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        'ionCancel': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        'ionClear': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        '_searchbarInput': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"], args: ['searchbarInput',] },],
        '_searchbarIcon': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"], args: ['searchbarIcon',] },],
        '_cancelButton': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"], args: ['cancelButton', { read: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"] },] },],
    };
    return Searchbar;
}(__WEBPACK_IMPORTED_MODULE_3__util_base_input__["a" /* BaseInput */]));

//# sourceMappingURL=searchbar.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/segment/segment-button.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SegmentButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");


/**
 * @name SegmentButton
 * @description
 * The child buttons of the `ion-segment` component. Each `ion-segment-button` must have a value.
 *
 * @usage
 *
 * ```html
 * <ion-content>
 *   <!-- Segment buttons with icons -->
 *   <ion-segment [(ngModel)]="icons" color="secondary">
 *     <ion-segment-button value="camera">
 *       <ion-icon name="camera"></ion-icon>
 *     </ion-segment-button>
 *     <ion-segment-button value="bookmark">
 *       <ion-icon name="bookmark"></ion-icon>
 *     </ion-segment-button>
 *   </ion-segment>
 *
 *   <!-- Segment buttons with text -->
 *   <ion-segment [(ngModel)]="relationship" color="primary">
 *     <ion-segment-button value="friends" (ionSelect)="selectedFriends()">
 *       Friends
 *     </ion-segment-button>
 *     <ion-segment-button value="enemies" (ionSelect)="selectedEnemies()">
 *       Enemies
 *     </ion-segment-button>
 *   </ion-segment>
 * </ion-content>
 * ```
 *
 *
 * @demo /docs/demos/src/segment/
 * @see {@link /docs/components#segment Segment Component Docs}
 * @see {@link /docs/api/components/segment/Segment/ Segment API Docs}
 */
var SegmentButton = (function () {
    function SegmentButton() {
        this.isActive = false;
        this._disabled = false;
        /**
         * @output {SegmentButton} Emitted when a segment button has been clicked.
         */
        this.ionSelect = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
    }
    Object.defineProperty(SegmentButton.prototype, "disabled", {
        /**
         * @input {boolean} If true, the user cannot interact with this element.
         */
        get: function () {
            return this._disabled;
        },
        set: function (val) {
            this._disabled = Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["o" /* isTrueProperty */])(val);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @hidden
     * On click of a SegmentButton
     */
    SegmentButton.prototype.onClick = function () {
        (void 0) /* console.debug */;
        this.ionSelect.emit(this);
    };
    /**
     * @hidden
     */
    SegmentButton.prototype.ngOnInit = function () {
        if (!Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["l" /* isPresent */])(this.value)) {
            console.warn('<ion-segment-button> requires a "value" attribute');
        }
    };
    SegmentButton.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'ion-segment-button',
                    template: '<ng-content></ng-content>' +
                        '<div class="button-effect"></div>',
                    host: {
                        'tappable': '',
                        'class': 'segment-button',
                        'role': 'button',
                        '[class.segment-button-disabled]': '_disabled',
                        '[class.segment-activated]': 'isActive',
                        '[attr.aria-pressed]': 'isActive'
                    },
                    encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None,
                },] },
    ];
    /** @nocollapse */
    SegmentButton.ctorParameters = function () { return []; };
    SegmentButton.propDecorators = {
        'value': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'ionSelect': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        'disabled': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'onClick': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"], args: ['click',] },],
    };
    return SegmentButton;
}());

//# sourceMappingURL=segment-button.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/segment/segment.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Segment; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__("./node_modules/@angular/forms/esm5/forms.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_base_input__ = __webpack_require__("./node_modules/ionic-angular/util/base-input.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__segment_button__ = __webpack_require__("./node_modules/ionic-angular/components/segment/segment-button.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





/**
 * @name Segment
 * @description
 * A Segment is a group of buttons, sometimes known as Segmented Controls, that allow the user to interact with a compact group of a number of controls.
 * Segments provide functionality similar to tabs, selecting one will unselect all others. You should use a tab bar instead of a segmented control when you want to let the user move back and forth between distinct pages in your app.
 * You could use Angular's `ngModel` or `FormBuilder` API. For an overview on how `FormBuilder` works, checkout [Angular Forms](http://learnangular2.com/forms/), or [Angular FormBuilder](https://angular.io/docs/ts/latest/api/forms/index/FormBuilder-class.html)
 *
 *
 * ```html
 * <!-- Segment in a header -->
 * <ion-header>
 *   <ion-toolbar>
 *     <ion-segment [(ngModel)]="icons" color="secondary">
 *       <ion-segment-button value="camera">
 *         <ion-icon name="camera"></ion-icon>
 *       </ion-segment-button>
 *       <ion-segment-button value="bookmark">
 *         <ion-icon name="bookmark"></ion-icon>
 *       </ion-segment-button>
 *     </ion-segment>
 *   </ion-toolbar>
 * </ion-header>
 *
 * <ion-content>
 *   <!-- Segment in content with material design mode on all devices -->
 *   <ion-segment [(ngModel)]="relationship" color="primary" mode="md" (ionChange)="segmentChanged($event)">
 *     <ion-segment-button value="friends">
 *       Friends
 *     </ion-segment-button>
 *     <ion-segment-button value="enemies">
 *       Enemies
 *     </ion-segment-button>
 *   </ion-segment>
 *
 *   <!-- Segment in a form -->
 *   <form [formGroup]="myForm">
 *     <ion-segment formControlName="mapStyle" color="danger">
 *       <ion-segment-button value="standard">
 *         Standard
 *       </ion-segment-button>
 *       <ion-segment-button value="hybrid">
 *         Hybrid
 *       </ion-segment-button>
 *       <ion-segment-button value="sat">
 *         Satellite
 *       </ion-segment-button>
 *     </ion-segment>
 *   </form>
 * </ion-content>
 * ```
 *
 *
 * @demo /docs/demos/src/segment/
 * @see {@link /docs/components#segment Segment Component Docs}
 * @see [Angular Forms](http://learnangular2.com/forms/)
 */
var Segment = (function (_super) {
    __extends(Segment, _super);
    function Segment(config, elementRef, renderer, ngControl) {
        return _super.call(this, config, elementRef, renderer, 'segment', null, null, null, ngControl) || this;
    }
    /**
     * @hidden
     */
    Segment.prototype.ngAfterContentInit = function () {
        var _this = this;
        this._initialize();
        this._buttons.forEach(function (button) {
            button.ionSelect.subscribe(function (selectedButton) {
                _this.value = selectedButton.value;
                _this._fireTouched();
            });
        });
    };
    /**
     * @hidden
     * Write a new value to the element.
     */
    Segment.prototype._inputUpdated = function () {
        if (!this._buttons) {
            (void 0) /* assert */;
            return;
        }
        var buttons = this._buttons.toArray();
        var value = this.value;
        for (var _i = 0, buttons_1 = buttons; _i < buttons_1.length; _i++) {
            var button = buttons_1[_i];
            button.isActive = (button.value === value);
        }
    };
    Segment.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'ion-segment',
                    host: {
                        '[class.segment-disabled]': '_disabled'
                    }
                },] },
    ];
    /** @nocollapse */
    Segment.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_2__config_config__["a" /* Config */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_forms__["NgControl"], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
    ]; };
    Segment.propDecorators = {
        '_buttons': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChildren"], args: [__WEBPACK_IMPORTED_MODULE_4__segment_button__["a" /* SegmentButton */],] },],
    };
    return Segment;
}(__WEBPACK_IMPORTED_MODULE_3__util_base_input__["a" /* BaseInput */]));

//# sourceMappingURL=segment.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/select/select-popover-component.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SelectPopover; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__navigation_nav_params__ = __webpack_require__("./node_modules/ionic-angular/navigation/nav-params.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__navigation_view_controller__ = __webpack_require__("./node_modules/ionic-angular/navigation/view-controller.js");



/** @hidden */
var SelectPopover = (function () {
    function SelectPopover(navParams, viewController) {
        this.navParams = navParams;
        this.viewController = viewController;
    }
    Object.defineProperty(SelectPopover.prototype, "value", {
        get: function () {
            var checkedOption = this.options.find(function (option) { return option.checked; });
            return checkedOption ? checkedOption.value : undefined;
        },
        set: function (value) {
            var checkedOption = this.options.find(function (option) { return option.value === value; });
            if (checkedOption && checkedOption.handler) {
                checkedOption.handler();
            }
            this.viewController.dismiss(value);
        },
        enumerable: true,
        configurable: true
    });
    SelectPopover.prototype.ngOnInit = function () {
        this.options = this.navParams.data.options;
    };
    SelectPopover.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    template: "\n    <ion-list radio-group [(ngModel)]=\"value\">\n      <ion-item *ngFor=\"let option of options\">\n        <ion-label>{{option.text}}</ion-label>\n        <ion-radio [checked]=\"option.checked\" [value]=\"option.value\" [disabled]=\"option.disabled\"></ion-radio>\n      </ion-item>\n    </ion-list>\n  "
                },] },
    ];
    /** @nocollapse */
    SelectPopover.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__navigation_nav_params__["a" /* NavParams */], },
        { type: __WEBPACK_IMPORTED_MODULE_2__navigation_view_controller__["a" /* ViewController */], },
    ]; };
    return SelectPopover;
}());

//# sourceMappingURL=select-popover-component.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/select/select.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Select; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__("./node_modules/@angular/forms/esm5/forms.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__action_sheet_action_sheet__ = __webpack_require__("./node_modules/ionic-angular/components/action-sheet/action-sheet.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__alert_alert__ = __webpack_require__("./node_modules/ionic-angular/components/alert/alert.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__popover_popover__ = __webpack_require__("./node_modules/ionic-angular/components/popover/popover.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__app_app__ = __webpack_require__("./node_modules/ionic-angular/components/app/app.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__navigation_deep_linker__ = __webpack_require__("./node_modules/ionic-angular/navigation/deep-linker.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_form__ = __webpack_require__("./node_modules/ionic-angular/util/form.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_base_input__ = __webpack_require__("./node_modules/ionic-angular/util/base-input.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__item_item__ = __webpack_require__("./node_modules/ionic-angular/components/item/item.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__option_option__ = __webpack_require__("./node_modules/ionic-angular/components/option/option.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__select_popover_component__ = __webpack_require__("./node_modules/ionic-angular/components/select/select-popover-component.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();














/**
 * @name Select
 * @description
 * The `ion-select` component is similar to an HTML `<select>` element, however,
 * Ionic's select component makes it easier for users to sort through and select
 * the preferred option or options. When users tap the select component, a
 * dialog will appear with all of the options in a large, easy to select list
 * for users.
 *
 * The select component takes child `ion-option` components. If `ion-option` is not
 * given a `value` attribute then it will use its text as the value.
 *
 * If `ngModel` is bound to `ion-select`, the selected value will be based on the
 * bound value of the model. Otherwise, the `selected` attribute can be used on
 * `ion-option` components.
 *
 * ### Interfaces
 *
 * By default, the `ion-select` uses the {@link ../../alert/AlertController AlertController API}
 * to open up the overlay of options in an alert. The interface can be changed to use the
 * {@link ../../action-sheet/ActionSheetController ActionSheetController API} or
 * {@link ../../popover/PopoverController PopoverController API} by passing `action-sheet` or `popover`,
 * respectively, to the `interface` property. Read on to the other sections for the limitations
 * of the different interfaces.
 *
 * ### Single Value: Radio Buttons
 *
 * The standard `ion-select` component allows the user to select only one
 * option. When selecting only one option the alert interface presents users with
 * a radio button styled list of options. The action sheet interface can only be
 * used with a single value select. If the number of options exceed 6, it will
 * use the `alert` interface even if `action-sheet` is passed. The `ion-select`
 * component's value receives the value of the selected option's value.
 *
 * ```html
 * <ion-item>
 *   <ion-label>Gender</ion-label>
 *   <ion-select [(ngModel)]="gender">
 *     <ion-option value="f">Female</ion-option>
 *     <ion-option value="m">Male</ion-option>
 *   </ion-select>
 * </ion-item>
 * ```
 *
 * ### Multiple Value: Checkboxes
 *
 * By adding the `multiple="true"` attribute to `ion-select`, users are able
 * to select multiple options. When multiple options can be selected, the alert
 * overlay presents users with a checkbox styled list of options. The
 * `ion-select multiple="true"` component's value receives an array of all the
 * selected option values. In the example below, because each option is not given
 * a `value`, then it'll use its text as the value instead.
 *
 * Note: the `action-sheet` and `popover` interfaces will not work with a multi-value select.
 *
 * ```html
 * <ion-item>
 *   <ion-label>Toppings</ion-label>
 *   <ion-select [(ngModel)]="toppings" multiple="true">
 *     <ion-option>Bacon</ion-option>
 *     <ion-option>Black Olives</ion-option>
 *     <ion-option>Extra Cheese</ion-option>
 *     <ion-option>Mushrooms</ion-option>
 *     <ion-option>Pepperoni</ion-option>
 *     <ion-option>Sausage</ion-option>
 *   </ion-select>
 * </ion-item>
 * ```
 *
 * ### Select Buttons
 * By default, the two buttons read `Cancel` and `OK`. Each button's text
 * can be customized using the `cancelText` and `okText` attributes:
 *
 * ```html
 * <ion-select okText="Okay" cancelText="Dismiss">
 *   ...
 * </ion-select>
 * ```
 *
 * The `action-sheet` and `popover` interfaces do not have an `OK` button, clicking
 * on any of the options will automatically close the overlay and select
 * that value.
 *
 * ### Select Options
 *
 * Since `ion-select` uses the `Alert`, `Action Sheet` and `Popover` interfaces, options can be
 * passed to these components through the `selectOptions` property. This can be used
 * to pass a custom title, subtitle, css class, and more. See the
 * {@link ../../alert/AlertController/#create AlertController API docs},
 * {@link ../../action-sheet/ActionSheetController/#create ActionSheetController API docs}, and
 * {@link ../../popover/PopoverController/#create PopoverController API docs}
 * for the properties that each interface accepts.
 *
 * For example, to change the `mode` of the overlay, pass it into `selectOptions`.
 *
 * ```html
 * <ion-select [selectOptions]="selectOptions">
 *   ...
 * </ion-select>
 * ```
 *
 * ```ts
 * this.selectOptions = {
 *   title: 'Pizza Toppings',
 *   subTitle: 'Select your toppings',
 *   mode: 'md'
 * };
 * ```
 *
 * ### Object Value References
 *
 * When using objects for select values, it is possible for the identities of these objects to
 * change if they are coming from a server or database, while the selected value's identity
 * remains the same. For example, this can occur when an existing record with the desired object value
 * is loaded into the select, but the newly retrieved select options now have different identities. This will
 * result in the select appearing to have no value at all, even though the original selection in still intact.
 *
 * Using the `compareWith` `Input` is the solution to this problem
 *
 * ```html
 * <ion-item>
 *   <ion-label>Employee</ion-label>
 *   <ion-select [(ngModel)]="employee" [compareWith]="compareFn">
 *     <ion-option *ngFor="let employee of employees" [value]="employee">{{employee.name}}</ion-option>
 *   </ion-select>
 * </ion-item>
 * ```
 *
 * ```ts
 * compareFn(e1: Employee, e2: Employee): boolean {
 *   return e1 && e2 ? e1.id === e2.id : e1 === e2;
 * }
 * ```
 *
 * @demo /docs/demos/src/select/
 */
var Select = (function (_super) {
    __extends(Select, _super);
    function Select(_app, form, config, elementRef, renderer, item, deepLinker) {
        var _this = _super.call(this, config, elementRef, renderer, 'select', [], form, item, null) || this;
        _this._app = _app;
        _this.config = config;
        _this.deepLinker = deepLinker;
        _this._multi = false;
        _this._texts = [];
        _this._text = '';
        _this._compareWith = __WEBPACK_IMPORTED_MODULE_10__util_util__["g" /* isCheckedProperty */];
        /**
         * @input {string} The text to display on the cancel button. Default: `Cancel`.
         */
        _this.cancelText = 'Cancel';
        /**
         * @input {string} The text to display on the ok button. Default: `OK`.
         */
        _this.okText = 'OK';
        /**
         * @input {any} Any additional options that the `alert` or `action-sheet` interface can take.
         * See the [AlertController API docs](../../alert/AlertController/#create) and the
         * [ActionSheetController API docs](../../action-sheet/ActionSheetController/#create) for the
         * create options for each interface.
         */
        _this.selectOptions = {};
        /**
         * @input {string} The interface the select should use: `action-sheet`, `popover` or `alert`. Default: `alert`.
         */
        _this.interface = '';
        /**
         * @input {string} The text to display instead of the selected option's value.
         */
        _this.selectedText = '';
        /**
         * @output {any} Emitted when the selection was cancelled.
         */
        _this.ionCancel = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        return _this;
    }
    Object.defineProperty(Select.prototype, "compareWith", {
        /**
         * @input {Function} The function that will be called to compare object values
         */
        set: function (fn) {
            if (typeof fn !== 'function') {
                throw new Error("compareWith must be a function, but received " + JSON.stringify(fn));
            }
            this._compareWith = fn;
        },
        enumerable: true,
        configurable: true
    });
    Select.prototype._click = function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        this.open(ev);
    };
    Select.prototype._keyup = function () {
        this.open();
    };
    /**
     * @hidden
     */
    Select.prototype.getValues = function () {
        var values = Array.isArray(this._value) ? this._value : [this._value];
        (void 0) /* assert */;
        return values;
    };
    /**
     * Open the select interface.
     */
    Select.prototype.open = function (ev) {
        var _this = this;
        if (this.isFocus() || this._disabled) {
            return;
        }
        (void 0) /* console.debug */;
        // the user may have assigned some options specifically for the alert
        var selectOptions = Object(__WEBPACK_IMPORTED_MODULE_10__util_util__["b" /* deepCopy */])(this.selectOptions);
        // make sure their buttons array is removed from the options
        // and we create a new array for the alert's two buttons
        selectOptions.buttons = [{
                text: this.cancelText,
                role: 'cancel',
                handler: function () {
                    _this.ionCancel.emit(_this);
                }
            }];
        // if the selectOptions didn't provide a title then use the label's text
        if (!selectOptions.title && this._item) {
            selectOptions.title = this._item.getLabelText();
        }
        var options = this._options.toArray();
        if ((this.interface === 'action-sheet' || this.interface === 'popover') && this._multi) {
            console.warn('Interface cannot be "' + this.interface + '" with a multi-value select. Using the "alert" interface.');
            this.interface = 'alert';
        }
        if (this.interface === 'popover' && !ev) {
            console.warn('Interface cannot be "popover" without UIEvent.');
            this.interface = 'alert';
        }
        var overlay;
        if (this.interface === 'action-sheet') {
            selectOptions.buttons = selectOptions.buttons.concat(options.map(function (input) {
                return {
                    role: (input.selected ? 'selected' : ''),
                    text: input.text,
                    handler: function () {
                        _this.value = input.value;
                        input.ionSelect.emit(input.value);
                    }
                };
            }));
            var selectCssClass = 'select-action-sheet';
            // If the user passed a cssClass for the select, add it
            selectCssClass += selectOptions.cssClass ? ' ' + selectOptions.cssClass : '';
            selectOptions.cssClass = selectCssClass;
            overlay = new __WEBPACK_IMPORTED_MODULE_2__action_sheet_action_sheet__["a" /* ActionSheet */](this._app, selectOptions, this.config);
        }
        else if (this.interface === 'popover') {
            var popoverOptions = options.map(function (input) { return ({
                text: input.text,
                checked: input.selected,
                disabled: input.disabled,
                value: input.value,
                handler: function () {
                    _this.value = input.value;
                    input.ionSelect.emit(input.value);
                }
            }); });
            var popoverCssClass = 'select-popover';
            // If the user passed a cssClass for the select, add it
            popoverCssClass += selectOptions.cssClass ? ' ' + selectOptions.cssClass : '';
            overlay = new __WEBPACK_IMPORTED_MODULE_4__popover_popover__["a" /* Popover */](this._app, __WEBPACK_IMPORTED_MODULE_13__select_popover_component__["a" /* SelectPopover */], {
                options: popoverOptions
            }, {
                cssClass: popoverCssClass
            }, this.config, this.deepLinker);
            // ev.target is readonly.
            // place popover regarding to ion-select instead of .button-inner
            Object.defineProperty(ev, 'target', { value: ev.currentTarget });
            selectOptions.ev = ev;
        }
        else {
            // default to use the alert interface
            this.interface = 'alert';
            // user cannot provide inputs from selectOptions
            // alert inputs must be created by ionic from ion-options
            selectOptions.inputs = this._options.map(function (input) {
                return {
                    type: (_this._multi ? 'checkbox' : 'radio'),
                    label: input.text,
                    value: input.value,
                    checked: input.selected,
                    disabled: input.disabled,
                    handler: function (selectedOption) {
                        // Only emit the select event if it is being checked
                        // For multi selects this won't emit when unchecking
                        if (selectedOption.checked) {
                            input.ionSelect.emit(input.value);
                        }
                    }
                };
            });
            var selectCssClass_1 = 'select-alert';
            // create the alert instance from our built up selectOptions
            overlay = new __WEBPACK_IMPORTED_MODULE_3__alert_alert__["a" /* Alert */](this._app, selectOptions, this.config);
            if (this._multi) {
                // use checkboxes
                selectCssClass_1 += ' multiple-select-alert';
            }
            else {
                // use radio buttons
                selectCssClass_1 += ' single-select-alert';
            }
            // If the user passed a cssClass for the select, add it
            selectCssClass_1 += selectOptions.cssClass ? ' ' + selectOptions.cssClass : '';
            overlay.setCssClass(selectCssClass_1);
            overlay.addButton({
                text: this.okText,
                handler: function (selectedValues) { return _this.value = selectedValues; }
            });
        }
        overlay.present(selectOptions);
        this._fireFocus();
        overlay.onDidDismiss(function () {
            _this._fireBlur();
            _this._overlay = undefined;
        });
        this._overlay = overlay;
    };
    /**
     * Close the select interface.
     */
    Select.prototype.close = function () {
        if (!this._overlay || !this.isFocus()) {
            return;
        }
        return this._overlay.dismiss();
    };
    Object.defineProperty(Select.prototype, "multiple", {
        /**
         * @input {boolean} If true, the element can accept multiple values.
         */
        get: function () {
            return this._multi;
        },
        set: function (val) {
            this._multi = Object(__WEBPACK_IMPORTED_MODULE_10__util_util__["o" /* isTrueProperty */])(val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Select.prototype, "text", {
        /**
         * @hidden
         */
        get: function () {
            return (this._multi ? this._texts : this._texts.join());
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Select.prototype, "options", {
        /**
         * @private
         */
        set: function (val) {
            this._options = val;
            var values = this.getValues();
            if (values.length === 0) {
                // there are no values set at this point
                // so check to see who should be selected
                // we use writeValue() because we don't want to update ngModel
                this.writeValue(val.filter(function (o) { return o.selected; }).map(function (o) { return o.value; }));
            }
            else {
                this._updateText();
            }
        },
        enumerable: true,
        configurable: true
    });
    Select.prototype._inputShouldChange = function (val) {
        return !Object(__WEBPACK_IMPORTED_MODULE_10__util_util__["c" /* deepEqual */])(this._value, val);
    };
    /**
     * TODO: REMOVE THIS
     * @hidden
     */
    Select.prototype._inputChangeEvent = function () {
        return this.value;
    };
    /**
     * @hidden
     */
    Select.prototype._updateText = function () {
        var _this = this;
        this._texts.length = 0;
        if (this._options) {
            this._options.forEach(function (option) {
                // check this option if the option's value is in the values array
                option.selected = _this.getValues().some(function (selectValue) {
                    return _this._compareWith(selectValue, option.value);
                });
                if (option.selected) {
                    _this._texts.push(option.text);
                }
            });
        }
        this._text = this._texts.join(', ');
    };
    /**
     * @hidden
     */
    Select.prototype._inputUpdated = function () {
        this._updateText();
        _super.prototype._inputUpdated.call(this);
    };
    Select.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'ion-select',
                    template: '<div *ngIf="!_text" class="select-placeholder select-text">{{placeholder}}</div>' +
                        '<div *ngIf="_text" class="select-text">{{selectedText || _text}}</div>' +
                        '<div class="select-icon">' +
                        '<div class="select-icon-inner"></div>' +
                        '</div>' +
                        '<button aria-haspopup="true" ' +
                        'type="button" ' +
                        '[id]="id" ' +
                        'ion-button="item-cover" ' +
                        '[attr.aria-labelledby]="_labelId" ' +
                        '[attr.aria-disabled]="_disabled" ' +
                        'class="item-cover">' +
                        '</button>',
                    host: {
                        '[class.select-disabled]': '_disabled'
                    },
                    providers: [{ provide: __WEBPACK_IMPORTED_MODULE_1__angular_forms__["NG_VALUE_ACCESSOR"], useExisting: Select, multi: true }],
                    encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None,
                },] },
    ];
    /** @nocollapse */
    Select.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_5__app_app__["a" /* App */], },
        { type: __WEBPACK_IMPORTED_MODULE_8__util_form__["a" /* Form */], },
        { type: __WEBPACK_IMPORTED_MODULE_6__config_config__["a" /* Config */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: __WEBPACK_IMPORTED_MODULE_11__item_item__["a" /* Item */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
        { type: __WEBPACK_IMPORTED_MODULE_7__navigation_deep_linker__["a" /* DeepLinker */], },
    ]; };
    Select.propDecorators = {
        'cancelText': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'okText': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'placeholder': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'selectOptions': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'interface': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'selectedText': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'compareWith': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'ionCancel': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        '_click': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"], args: ['click', ['$event'],] },],
        '_keyup': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"], args: ['keyup.space',] },],
        'multiple': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'options': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChildren"], args: [__WEBPACK_IMPORTED_MODULE_12__option_option__["a" /* Option */],] },],
    };
    return Select;
}(__WEBPACK_IMPORTED_MODULE_9__util_base_input__["a" /* BaseInput */]));

//# sourceMappingURL=select.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/show-hide-when/display-when.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DisplayWhen; });
/**
 * @hidden
 */
var DisplayWhen = (function () {
    function DisplayWhen(conditions, _plt, zone) {
        this._plt = _plt;
        this.zone = zone;
        this.isMatch = false;
        if (!conditions)
            return;
        this.conditions = conditions.replace(/\s/g, '').split(',');
        // check if its one of the matching platforms first
        // a platform does not change during the life of an app
        for (var i = 0; i < this.conditions.length; i++) {
            if (this.conditions[i] && _plt.is(this.conditions[i])) {
                this.isMatch = true;
                return;
            }
        }
        if (this.orientation()) {
            // add window resize listener
            this.resizeObs = _plt.resize.subscribe(this.orientation.bind(this));
        }
    }
    DisplayWhen.prototype.orientation = function () {
        for (var i = 0; i < this.conditions.length; i++) {
            if (this.conditions[i] === 'portrait') {
                this.isMatch = this._plt.isPortrait();
                return true;
            }
            if (this.conditions[i] === 'landscape') {
                this.isMatch = this._plt.isLandscape();
                return true;
            }
        }
        return false;
    };
    DisplayWhen.prototype.ngOnDestroy = function () {
        this.resizeObs && this.resizeObs.unsubscribe();
        this.resizeObs = null;
    };
    return DisplayWhen;
}());

//# sourceMappingURL=display-when.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/show-hide-when/hide-when.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HideWhen; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__platform_platform__ = __webpack_require__("./node_modules/ionic-angular/platform/platform.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__display_when__ = __webpack_require__("./node_modules/ionic-angular/components/show-hide-when/display-when.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



/**
 * @name HideWhen
 * @description
 * The `hideWhen` attribute takes a string that represents a plaform or screen orientation.
 * The element the attribute is added to will only be hidden when that platform or screen orientation is active.
 *
 * Complements the [showWhen attribute](../ShowWhen). If the `hideWhen` attribute is used on an
 * element that also has the `showWhen` attribute, the element will not show if `hideWhen` evaluates
 * to `true` or `showWhen` evaluates to `false`. If the `hidden` attribute is also added, the element
 * will not show if `hidden` evaluates to `true`.
 *
 * View the [Platform API docs](../../../platform/Platform) for more information on the different
 * platforms you can use.
 *
 * @usage
 * ```html
 * <div hideWhen="android">
 *  I am hidden on Android!
 * </div>
 *
 * <div hideWhen="ios">
 *  I am hidden on iOS!
 * </div>
 *
 * <div hideWhen="android,ios">
 *  I am hidden on Android and iOS!
 * </div>
 *
 * <div hideWhen="portrait">
 *  I am hidden on Portrait!
 * </div>
 *
 * <div hideWhen="landscape">
 *  I am hidden on Landscape!
 * </div>
 * ```
 *
 * @demo /docs/demos/src/hide-when/
 * @see {@link ../ShowWhen ShowWhen API Docs}
 * @see {@link ../../../platform/Platform Platform API Docs}
*/
var HideWhen = (function (_super) {
    __extends(HideWhen, _super);
    function HideWhen(hideWhen, plt, zone) {
        return _super.call(this, hideWhen, plt, zone) || this;
    }
    HideWhen.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: '[hideWhen]',
                    host: {
                        '[class.hidden-hide-when]': 'isMatch'
                    }
                },] },
    ];
    /** @nocollapse */
    HideWhen.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Attribute"], args: ['hideWhen',] },] },
        { type: __WEBPACK_IMPORTED_MODULE_1__platform_platform__["a" /* Platform */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"], },
    ]; };
    return HideWhen;
}(__WEBPACK_IMPORTED_MODULE_2__display_when__["a" /* DisplayWhen */]));

//# sourceMappingURL=hide-when.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/show-hide-when/show-when.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ShowWhen; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__display_when__ = __webpack_require__("./node_modules/ionic-angular/components/show-hide-when/display-when.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__platform_platform__ = __webpack_require__("./node_modules/ionic-angular/platform/platform.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



/**
 *
 * @name ShowWhen
 * @description
 * The `showWhen` attribute takes a string that represents a platform or screen orientation.
 * The element the attribute is added to will only be shown when that platform or screen orientation is active.
 *
 * Complements the [hideWhen attribute](../HideWhen). If the `showWhen` attribute is used on an
 * element that also has the `hideWhen` attribute, the element will not show if `hideWhen` evaluates
 * to `true` or `showWhen` evaluates to `false`. If the `hidden` attribute is also added, the element
 * will not show if `hidden` evaluates to `true`.
 *
 * View the [Platform API docs](../../../platform/Platform) for more information on the different
 * platforms you can use.
 *
 * @usage
 * ```html
 * <div showWhen="android">
 *  I am visible on Android!
 * </div>
 *
 * <div showWhen="ios">
 *  I am visible on iOS!
 * </div>
 *
 * <div showWhen="android,ios">
 *  I am visible on Android and iOS!
 * </div>
 *
 * <div showWhen="portrait">
 *  I am visible on Portrait!
 * </div>
 *
 * <div showWhen="landscape">
 *  I am visible on Landscape!
 * </div>
 * ```
 * @demo /docs/demos/src/show-when/
 * @see {@link ../HideWhen HideWhen API Docs}
 * @see {@link ../../../platform/Platform Platform API Docs}
 */
var ShowWhen = (function (_super) {
    __extends(ShowWhen, _super);
    function ShowWhen(showWhen, plt, zone) {
        return _super.call(this, showWhen, plt, zone) || this;
    }
    // ngOnDestroy is implemented in DisplayWhen
    ShowWhen.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: '[showWhen]',
                    host: {
                        '[class.hidden-show-when]': '!isMatch'
                    }
                },] },
    ];
    /** @nocollapse */
    ShowWhen.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Attribute"], args: ['showWhen',] },] },
        { type: __WEBPACK_IMPORTED_MODULE_2__platform_platform__["a" /* Platform */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"], },
    ]; };
    return ShowWhen;
}(__WEBPACK_IMPORTED_MODULE_1__display_when__["a" /* DisplayWhen */]));

//# sourceMappingURL=show-when.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/slides/slide.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Slide; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slides__ = __webpack_require__("./node_modules/ionic-angular/components/slides/slides.js");


/**
 * @name Slide
 * @description
 * The Slide component is a child component of [Slides](../Slides). The template
 * should be written as `ion-slide`. Any slide content should be written
 * in this component and it should be used in conjunction with [Slides](../Slides).
 *
 * See the [Slides API Docs](../Slides) for more usage information.
 *
 * @demo /docs/demos/src/slides/
 * @see {@link /docs/api/components/slides/Slides/ Slides API Docs}
 */
var Slide = (function () {
    function Slide(elementRef, renderer, _slides) {
        this._slides = _slides;
        renderer.setElementClass(elementRef.nativeElement, 'swiper-slide', true);
        _slides.update(10);
    }
    /**
     * @hidden
     */
    Slide.prototype.ngOnDestroy = function () {
        this._slides.update(10);
    };
    Slide.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'ion-slide',
                    template: '<div class="slide-zoom">' +
                        '<ng-content></ng-content>' +
                        '</div>',
                    changeDetection: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectionStrategy"].OnPush,
                    encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None,
                },] },
    ];
    /** @nocollapse */
    Slide.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: __WEBPACK_IMPORTED_MODULE_1__slides__["a" /* Slides */], },
    ]; };
    return Slide;
}());

//# sourceMappingURL=slide.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/slides/slides.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Slides; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__swiper_swiper_keyboard__ = __webpack_require__("./node_modules/ionic-angular/components/slides/swiper/swiper-keyboard.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ion__ = __webpack_require__("./node_modules/ionic-angular/components/ion.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__swiper_swiper_events__ = __webpack_require__("./node_modules/ionic-angular/components/slides/swiper/swiper-events.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__swiper_swiper_zoom__ = __webpack_require__("./node_modules/ionic-angular/components/slides/swiper/swiper-zoom.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__platform_platform__ = __webpack_require__("./node_modules/ionic-angular/platform/platform.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__swiper_swiper__ = __webpack_require__("./node_modules/ionic-angular/components/slides/swiper/swiper.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__swiper_swiper_effects__ = __webpack_require__("./node_modules/ionic-angular/components/slides/swiper/swiper-effects.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__navigation_view_controller__ = __webpack_require__("./node_modules/ionic-angular/navigation/view-controller.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();











/**
 * @name Slides
 * @description
 * The Slides component is a multi-section container. Each section can be swiped
 * or dragged between. It contains any number of [Slide](../Slide) components.
 *
 *
 * ### Creating
 * You should use a template to create slides and listen to slide events. The template
 * should contain the slide container, an `<ion-slides>` element, and any number of
 * [Slide](../Slide) components, written as `<ion-slide>`. Basic configuration
 * values can be set as input properties, which are listed below. Slides events
 * can also be listened to such as the slide changing by placing the event on the
 * `<ion-slides>` element. See [Usage](#usage) below for more information.
 *
 *
 * ### Navigating
 * After creating and configuring the slides, you can navigate between them
 * by swiping or calling methods on the `Slides` instance. You can call `slideTo()` to
 * navigate to a specific slide, or `slideNext()` to change to the slide that follows
 * the active slide. All of the [methods](#instance-members) provided by the `Slides`
 * instance are listed below. See [Usage](#usage) below for more information on
 * navigating between slides.
 *
 *
 * @usage
 *
 * You can add slides to a `@Component` using the following template:
 *
 * ```html
 * <ion-slides>
 *   <ion-slide>
 *     <h1>Slide 1</h1>
 *   </ion-slide>
 *   <ion-slide>
 *     <h1>Slide 2</h1>
 *   </ion-slide>
 *   <ion-slide>
 *     <h1>Slide 3</h1>
 *   </ion-slide>
 * </ion-slides>
 * ```
 *
 * Next, we can use `ViewChild` to assign the Slides instance to
 * your `slides` property. Now we can call any of the `Slides`
 * [methods](#instance-members), for example we can use the Slide's
 * `slideTo()` method in order to navigate to a specific slide on
 * a button click. Below we call the `goToSlide()` method and it
 * navigates to the 3rd slide:
 *
 * ```ts
 * import { ViewChild } from '@angular/core';
 * import { Slides } from 'ionic-angular';
 *
 * class MyPage {
 *   @ViewChild(Slides) slides: Slides;
 *
 *   goToSlide() {
 *     this.slides.slideTo(2, 500);
 *   }
 * }
 * ```
 *
 * We can also add events to listen to on the `<ion-slides>` element.
 * Let's add the `ionSlideDidChange` event and call a method when the slide changes:
 *
 * ```html
 * <ion-slides (ionSlideDidChange)="slideChanged()">
 * ```
 *
 * In our class, we add the `slideChanged()` method which gets the active
 * index and prints it:
 *
 * ```ts
 * class MyPage {
 *   ...
 *
 *   slideChanged() {
 *     let currentIndex = this.slides.getActiveIndex();
 *     console.log('Current index is', currentIndex);
 *   }
 * }
 * ```
 *
 * ### Zooming
 * If your slides contain images, you can enable zooming on them by setting `zoom="true" and
 * wrapping each image in a `div` with the class `swiper-zoom-container`. Zoom supports
 * `img`, `svg`, `canvas`, and `ion-img`.
 *
 * ```html
 * <ion-slides zoom="true">
 *   <ion-slide>
 *     <div class="swiper-zoom-container">
 *       <img src="assets/img/dog.jpg">
 *     </div>
 *     <ion-label>Woof</ion-label>
 *   </ion-slide>
 *   <ion-slide>
 *     <div class="swiper-zoom-container">
 *       <img src="assets/img/cat.jpg">
 *     </div>
 *     <ion-label>Meow</ion-label>
 *   </ion-slide>
 *   <ion-slide>
 *     <div class="swiper-zoom-container">
 *       <img src="assets/img/fish.jpg">
 *     </div>
 *     <ion-label>Just keep swimming</ion-label>
 *   </ion-slide>
 * </ion-slides>
 * ```
 *
 * @advanced
 *
 * There are several options available to create customized slides. Ionic exposes
 * the most commonly used options as [inputs](http://learnangular2.com/inputs/).
 * In order to use an option that isn't exposed as an input the following code
 * should be used, where `freeMode` is the option to change:
 *
 * ```ts
 * import { ViewChild } from '@angular/core';
 * import { Slides } from 'ionic-angular';

 * class MyPage {
 *   @ViewChild(Slides) slides: Slides;
 *
 *   ngAfterViewInit() {
 *     this.slides.freeMode = true;
 *   }
 * }
 *
 * ```
 *
 * To see all of the available options, take a look at the
 * [source for slides](https://github.com/ionic-team/ionic/blob/v3/src/components/slides/slides.ts).
 *
 * @demo /docs/demos/src/slides/
 * @see {@link /docs/components#slides Slides Component Docs}
 *
 * Adopted from Swiper.js:
 * The most modern mobile touch slider and framework with
 * hardware accelerated transitions.
 *
 * http://www.idangero.us/swiper/
 *
 * Copyright 2016, Vladimir Kharlampidi
 * The iDangero.us
 * http://www.idangero.us/
 *
 * Licensed under MIT
 */
var Slides = (function (_super) {
    __extends(Slides, _super);
    function Slides(config, _plt, zone, viewCtrl, elementRef, renderer) {
        var _this = _super.call(this, config, elementRef, renderer, 'slides') || this;
        _this._plt = _plt;
        _this._control = null;
        _this._effectName = 'slide';
        _this._direction = 'horizontal';
        _this._initialSlide = 0;
        _this._isLoop = false;
        _this._pager = false;
        _this._paginationType = 'bullets';
        /** @hidden */
        _this.paginationBulletRender = null;
        _this._isParallax = false;
        _this._speedMs = 300;
        _this._isZoom = false;
        /**
         * @hidden
         * Enabled this option and swiper will be operated as usual except it will
         * not move, real translate values on wrapper will not be set. Useful when
         * you may need to create custom slide transition.
         */
        _this.virtualTranslate = false;
        /**
         * @hidden
         * Set to true to round values of slides width and height to prevent blurry
         * texts on usual resolution screens (if you have such)
         */
        _this.roundLengths = false;
        _this._spaceBetween = 0;
        _this._slidesPerView = 1;
        _this._centeredSlides = false;
        /**
         * @hidden
         */
        _this.slidesPerColumn = 1;
        /**
         * @hidden
         */
        _this.slidesPerColumnFill = 'column';
        /**
         * @hidden
         */
        _this.slidesPerGroup = 1;
        /**
         * @hidden
         */
        _this.slidesOffsetBefore = 0;
        /**
         * @hidden
         */
        _this.slidesOffsetAfter = 0;
        // autoplay
        /**
         * @hidden
         */
        _this.autoplayDisableOnInteraction = true;
        /**
         * @hidden
         */
        _this.autoplayStopOnLast = false;
        // Free mode
        /**
         * @hidden
         */
        _this.freeMode = false;
        /**
         * @hidden
         */
        _this.freeModeMomentum = true;
        /**
         * @hidden
         */
        _this.freeModeMomentumRatio = 1;
        /**
         * @hidden
         */
        _this.freeModeMomentumBounce = true;
        /**
         * @hidden
         */
        _this.freeModeMomentumBounceRatio = 1;
        /**
         * @hidden
         */
        _this.freeModeMomentumVelocityRatio = 1;
        /**
         * @hidden
         */
        _this.freeModeSticky = false;
        /**
         * @hidden
         */
        _this.freeModeMinimumVelocity = 0.02;
        // Autoheight
        /**
         * @hidden
         */
        _this.autoHeight = false;
        // Set wrapper width
        /**
         * @hidden
         */
        _this.setWrapperSize = false;
        // Zoom
        /**
         * @hidden
         */
        _this.zoomMax = 3;
        /**
         * @hidden
         */
        _this.zoomMin = 1;
        /**
         * @hidden
         */
        _this.zoomToggle = true;
        // Touches
        /**
         * @hidden
         */
        _this.touchRatio = 1;
        /**
         * @hidden
         */
        _this.touchAngle = 45;
        /**
         * @hidden
         */
        _this.simulateTouch = true;
        /**
         * @hidden
         */
        _this.shortSwipes = true;
        /**
         * @hidden
         */
        _this.longSwipes = true;
        /**
         * @hidden
         */
        _this.longSwipesRatio = 0.5;
        /**
         * @hidden
         */
        _this.longSwipesMs = 300;
        /**
         * @hidden
         */
        _this.followFinger = true;
        /**
         * @hidden
         */
        _this.onlyExternal = false;
        /**
         * @hidden
         */
        _this.threshold = 0;
        /**
         * @hidden
         */
        _this.touchMoveStopPropagation = true;
        /**
         * @hidden
         */
        _this.touchReleaseOnEdges = false;
        // To support iOS's swipe-to-go-back gesture (when being used in-app, with UIWebView).
        /**
         * @hidden
         */
        _this.iOSEdgeSwipeDetection = false;
        /**
         * @hidden
         */
        _this.iOSEdgeSwipeThreshold = 20;
        // Pagination
        /**
         * @hidden
         */
        _this.paginationClickable = false;
        /**
         * @hidden
         */
        _this.paginationHide = false;
        // Resistance
        /** @hidden */
        _this.resistance = true;
        /** @hidden */
        _this.resistanceRatio = 0.85;
        // Progress
        /** @hidden */
        _this.watchSlidesProgress = false;
        /** @hidden */
        _this.watchSlidesVisibility = false;
        // Clicks
        /**
         * @hidden
         */
        _this.preventClicks = true;
        /**
         * @hidden
         */
        _this.preventClicksPropagation = true;
        /**
         * @hidden
         */
        _this.slideToClickedSlide = false;
        // loop
        /**
         * @hidden
         */
        _this.loopAdditionalSlides = 0;
        /**
         * @hidden
         */
        _this.loopedSlides = null;
        // Swiping/no swiping
        /**
         * @hidden
         */
        _this.swipeHandler = null;
        /**
         * @hidden
         */
        _this.noSwiping = true;
        // Callbacks
        /** @hidden */
        _this.runCallbacksOnInit = true;
        // Controller
        _this.controlBy = 'slide';
        _this.controlInverse = false;
        // Keyboard
        /**
         * @hidden
         */
        _this.keyboardControl = true;
        // Effects
        /**
         * @hidden
         */
        _this.coverflow = {
            rotate: 50,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows: true
        };
        /**
         * @hidden
         */
        _this.flip = {
            slideShadows: true,
            limitRotation: true
        };
        /**
         * @hidden
         */
        _this.cube = {
            slideShadows: true,
            shadow: true,
            shadowOffset: 20,
            shadowScale: 0.94
        };
        /**
         * @hidden
         */
        _this.fade = {
            crossFade: false
        };
        // Accessibility
        /**
         * @hidden
         */
        _this.prevSlideMessage = 'Previous slide';
        /**
         * @hidden
         */
        _this.nextSlideMessage = 'Next slide';
        /**
         * @hidden
         */
        _this.firstSlideMessage = 'This is the first slide';
        /**
         * @hidden
         */
        _this.lastSlideMessage = 'This is the last slide';
        /**
         * @output {Slides} Emitted when a slide change starts.
         */
        _this.ionSlideWillChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
         * @output {Slides} Emitted when a slide change ends.
         */
        _this.ionSlideDidChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
         * @output {Slides} Emitted when a slide moves.
         */
        _this.ionSlideDrag = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
         * @output {Slides} Emitted when slides reaches its beginning (initial position).
         */
        _this.ionSlideReachStart = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
         * @output {Slides} Emitted when slides reaches its last slide.
         */
        _this.ionSlideReachEnd = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
         * @output {Slides} Emitted when a slide moves.
         */
        _this.ionSlideAutoplay = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
         * @output {Slides} Emitted when a autoplay starts.
         */
        _this.ionSlideAutoplayStart = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
         * @output {Slides} Emitted when a autoplay stops.
         */
        _this.ionSlideAutoplayStop = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
         * @output {Slides} Emitted when a slide change starts with the "forward" direction.
         */
        _this.ionSlideNextStart = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
         * @output {Slides} Emitted when a slide change starts with the "backward" direction.
         */
        _this.ionSlidePrevStart = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
         * @output {Slides} Emitted when a slide change ends with the "forward" direction.
         */
        _this.ionSlideNextEnd = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
         * @output {Slides} Emitted when a slide change ends with the "backward" direction.
         */
        _this.ionSlidePrevEnd = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
         * @output {Slides} Emitted when the user taps/clicks on the slide's container.
         */
        _this.ionSlideTap = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
         * @output {Slides} Emitted when the user double taps on the slide's container.
         */
        _this.ionSlideDoubleTap = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /** @hidden */
        _this.ionSlideProgress = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /** @hidden */
        _this.ionSlideTransitionStart = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /** @hidden */
        _this.ionSlideTransitionEnd = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /** @hidden */
        _this.ionSlideTouchStart = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /** @hidden */
        _this.ionSlideTouchEnd = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        _this._unregs = [];
        /** @internal */
        _this._allowSwipeToNext = true;
        /** @internal */
        _this._allowSwipeToPrev = true;
        _this._zone = zone;
        _this.id = ++slidesId;
        _this.slideId = 'slides-' + _this.id;
        _this.setElementClass(_this.slideId, true);
        // only initialize the slides whent the content is ready
        if (viewCtrl) {
            var subscription = viewCtrl.readReady.subscribe(function () {
                subscription.unsubscribe();
                _this._initSlides();
            });
        }
        return _this;
    }
    Object.defineProperty(Slides.prototype, "autoplay", {
        /**
         * @input {number} Delay between transitions (in milliseconds). If this
         * parameter is not passed, autoplay is disabled. Default does
         * not have a value and does not autoplay.
         * Default: `null`.
         */
        get: function () {
            return this._autoplayMs;
        },
        set: function (val) {
            this._autoplayMs = parseInt(val, 10);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Slides.prototype, "control", {
        /**
         * @input {Slides} Pass another Slides instance or array of Slides instances
         * that should be controlled by this Slides instance.
         * Default: `null`.
         */
        get: function () {
            return this._control;
        },
        set: function (val) {
            if (val instanceof Slides || Array.isArray(val)) {
                this._control = val;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Slides.prototype, "effect", {
        /**
         * @input {string} The animation effect of the slides.
         * Possible values are: `slide`, `fade`, `cube`, `coverflow` or `flip`.
         * Default: `slide`.
         */
        get: function () {
            return this._effectName;
        },
        set: function (effectName) {
            if (__WEBPACK_IMPORTED_MODULE_9__swiper_swiper_effects__["a" /* SWIPER_EFFECTS */][effectName]) {
                this._effectName = effectName;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Slides.prototype, "direction", {
        /**
         * @input {string}  Swipe direction: 'horizontal' or 'vertical'.
         * Default: `horizontal`.
         */
        get: function () {
            return this._direction;
        },
        set: function (val) {
            if (val === 'horizontal' || val === 'vertical') {
                this._direction = val;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Slides.prototype, "initialSlide", {
        /**
         * @input {number}  Index number of initial slide. Default: `0`.
         */
        get: function () {
            return this._initialSlide;
        },
        set: function (val) {
            this._initialSlide = parseInt(val, 10);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Slides.prototype, "loop", {
        /**
         * @input {boolean} If true, continuously loop from the last slide to the
         * first slide.
         */
        get: function () {
            return this._isLoop;
        },
        set: function (val) {
            this._isLoop = Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["o" /* isTrueProperty */])(val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Slides.prototype, "pager", {
        /**
         * @input {boolean}  If true, show the pager.
         */
        get: function () {
            return this._pager;
        },
        set: function (val) {
            this._pager = Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["o" /* isTrueProperty */])(val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Slides.prototype, "dir", {
        /**
         * @input {string} If dir attribute is equal to rtl, set interal _rtl to true;
         */
        set: function (val) {
            this._rtl = (val.toLowerCase() === 'rtl');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Slides.prototype, "paginationType", {
        /**
         * @input {string}  Type of pagination. Possible values are:
         * `bullets`, `fraction`, `progress`. Default: `bullets`.
         * (Note that the pager will not show unless `pager` input
         * is set to true).
         */
        get: function () {
            return this._paginationType;
        },
        set: function (val) {
            if (val === 'bullets' || val === 'fraction' || val === 'progress') {
                this._paginationType = val;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Slides.prototype, "parallax", {
        /**
         * @input {boolean} If true, allows you to use "parallaxed" elements inside of
         * slider.
         */
        get: function () {
            return this._isParallax;
        },
        set: function (val) {
            this._isParallax = Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["o" /* isTrueProperty */])(val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Slides.prototype, "speed", {
        /**
         * @input {number} Duration of transition between slides
         * (in milliseconds). Default: `300`.
         */
        get: function () {
            return this._speedMs;
        },
        set: function (val) {
            this._speedMs = parseInt(val, 10);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Slides.prototype, "zoom", {
        /**
         * @input {boolean} If true, enables zooming functionality.
         */
        get: function () {
            return this._isZoom;
        },
        set: function (val) {
            this._isZoom = Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["o" /* isTrueProperty */])(val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Slides.prototype, "spaceBetween", {
        // Slides grid
        /**
         * @input {number} Distance between slides in px. Default: `0`.
         */
        get: function () {
            return this._spaceBetween;
        },
        set: function (val) {
            this._spaceBetween = parseInt(val, 10);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Slides.prototype, "slidesPerView", {
        /**
         * @input {number} Slides per view. Slides visible at the same time. Default: `1`.
         */
        get: function () {
            return this._slidesPerView;
        },
        set: function (val) {
            this._slidesPerView = val === 'auto' ? 'auto' : parseFloat(val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Slides.prototype, "centeredSlides", {
        /**
         * @input {boolean} Center a slide in the middle of the screen.
         */
        get: function () {
            return this._centeredSlides;
        },
        set: function (val) {
            this._centeredSlides = Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["o" /* isTrueProperty */])(val);
        },
        enumerable: true,
        configurable: true
    });
    Slides.prototype._initSlides = function () {
        if (!this._init) {
            (void 0) /* console.debug */;
            var s = this;
            var plt = s._plt;
            s.container = this.getNativeElement().children[0];
            // init swiper core
            Object(__WEBPACK_IMPORTED_MODULE_8__swiper_swiper__["d" /* initSwiper */])(s, plt);
            // init core event listeners
            this._unregs.push(Object(__WEBPACK_IMPORTED_MODULE_5__swiper_swiper_events__["a" /* initEvents */])(s, plt));
            if (this.zoom) {
                // init zoom event listeners
                this._unregs.push(Object(__WEBPACK_IMPORTED_MODULE_6__swiper_swiper_zoom__["a" /* initZoom */])(s, plt));
            }
            if (this.keyboardControl) {
                // init keyboard event listeners
                s.enableKeyboardControl(true);
            }
            this._init = true;
        }
    };
    /**
     * @hidden
     */
    Slides.prototype.ngAfterContentInit = function () {
        var _this = this;
        this._plt.timeout(function () {
            _this._initSlides();
        }, 300);
    };
    /**
     * Update the underlying slider implementation. Call this if you've added or removed
     * child slides.
     */
    Slides.prototype.update = function (debounce) {
        var _this = this;
        if (debounce === void 0) { debounce = 300; }
        if (this._init) {
            this._plt.cancelTimeout(this._tmr);
            this._tmr = this._plt.timeout(function () {
                Object(__WEBPACK_IMPORTED_MODULE_8__swiper_swiper__["n" /* update */])(_this, _this._plt);
                // Don't allow pager to show with > 10 slides
                if (_this.length() > 10) {
                    _this.paginationType = undefined;
                }
            }, debounce);
        }
    };
    Slides.prototype.resize = function () {
        if (this._init) {
        }
    };
    /**
     * Transition to the specified slide.
     *
     * @param {number} index  The index number of the slide.
     * @param {number} [speed]  Transition duration (in ms).
     * @param {boolean} [runCallbacks] Whether or not to emit the `ionSlideWillChange`/`ionSlideDidChange` events. Default true.
     */
    Slides.prototype.slideTo = function (index, speed, runCallbacks) {
        Object(__WEBPACK_IMPORTED_MODULE_8__swiper_swiper__["k" /* slideTo */])(this, this._plt, index, speed, runCallbacks);
    };
    /**
     * Transition to the next slide.
     *
     * @param {number} [speed]  Transition duration (in ms).
     * @param {boolean} [runCallbacks]  Whether or not to emit the `ionSlideWillChange`/`ionSlideDidChange` events. Default true.
     */
    Slides.prototype.slideNext = function (speed, runCallbacks) {
        Object(__WEBPACK_IMPORTED_MODULE_8__swiper_swiper__["h" /* slideNext */])(this, this._plt, runCallbacks, speed, true);
    };
    /**
     * Transition to the previous slide.
     *
     * @param {number} [speed]  Transition duration (in ms).
     * @param {boolean} [runCallbacks]  Whether or not to emit the `ionSlideWillChange`/`ionSlideDidChange` events. Default true.
     */
    Slides.prototype.slidePrev = function (speed, runCallbacks) {
        Object(__WEBPACK_IMPORTED_MODULE_8__swiper_swiper__["i" /* slidePrev */])(this, this._plt, runCallbacks, speed, true);
    };
    /**
     * Get the index of the active slide.
     *
     * @returns {number} The index number of the current slide.
     */
    Slides.prototype.getActiveIndex = function () {
        return this._activeIndex;
    };
    /**
     * Get the index of the previous slide.
     *
     * @returns {number} The index number of the previous slide.
     */
    Slides.prototype.getPreviousIndex = function () {
        return this._previousIndex;
    };
    /**
     * Get the total number of slides.
     *
     * @returns {number} The total number of slides.
     */
    Slides.prototype.length = function () {
        return this._slides.length;
    };
    /**
     * Get whether or not the current slide is the last slide.
     *
     * @returns {boolean} If the slide is the last slide or not.
     */
    Slides.prototype.isEnd = function () {
        return this._isEnd;
    };
    /**
     * Get whether or not the current slide is the first slide.
     *
     * @returns {boolean} If the slide is the first slide or not.
     */
    Slides.prototype.isBeginning = function () {
        return this._isBeginning;
    };
    /**
     * Start auto play.
     */
    Slides.prototype.startAutoplay = function () {
        Object(__WEBPACK_IMPORTED_MODULE_8__swiper_swiper__["l" /* startAutoplay */])(this, this._plt);
    };
    /**
     * Stop auto play.
     */
    Slides.prototype.stopAutoplay = function () {
        Object(__WEBPACK_IMPORTED_MODULE_8__swiper_swiper__["m" /* stopAutoplay */])(this);
    };
    /**
     * Lock or unlock the ability to slide to the next slides.
     * @param {boolean} shouldLockSwipeToNext If set to true the user will not be able to swipe to the next slide.
     * Set to false to unlock this behaviour.
     */
    Slides.prototype.lockSwipeToNext = function (shouldLockSwipeToNext) {
        this._allowSwipeToNext = !shouldLockSwipeToNext;
    };
    /**
     * Lock or unlock the ability to slide to the previous slides.
     * @param {boolean} shouldLockSwipeToPrev If set to true the user will not be able to swipe to the previous slide.
     * Set to false to unlock this behaviour.
     */
    Slides.prototype.lockSwipeToPrev = function (shouldLockSwipeToPrev) {
        this._allowSwipeToPrev = !shouldLockSwipeToPrev;
    };
    /**
     * Lock or unlock the ability to slide to change slides.
     * @param {boolean} shouldLockSwipes If set to true user can not swipe in either direction on slide.
     * False allows swiping in both directions.
     */
    Slides.prototype.lockSwipes = function (shouldLockSwipes) {
        this._allowSwipeToNext = this._allowSwipeToPrev = !shouldLockSwipes;
    };
    /**
     * Enable or disable keyboard control.
     * @param {boolean} shouldEnableKeyboard If set to true the slider can be controled by a keyboard.
     */
    Slides.prototype.enableKeyboardControl = function (shouldEnableKeyboard) {
        Object(__WEBPACK_IMPORTED_MODULE_2__swiper_swiper_keyboard__["a" /* enableKeyboardControl */])(this, this._plt, shouldEnableKeyboard);
    };
    /**
     * @hidden
     */
    Slides.prototype.ngOnDestroy = function () {
        this._init = false;
        this._unregs.forEach(function (unReg) {
            unReg();
        });
        this._unregs.length = 0;
        Object(__WEBPACK_IMPORTED_MODULE_8__swiper_swiper__["b" /* destroySwiper */])(this);
        this.enableKeyboardControl(false);
    };
    Slides.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'ion-slides',
                    template: '<div class="swiper-container" [attr.dir]="_rtl? \'rtl\' : null">' +
                        '<div class="swiper-wrapper">' +
                        '<ng-content></ng-content>' +
                        '</div>' +
                        '<div [class.hide]="!pager" class="swiper-pagination"></div>' +
                        '</div>',
                    changeDetection: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectionStrategy"].OnPush,
                    encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None,
                },] },
    ];
    /** @nocollapse */
    Slides.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__config_config__["a" /* Config */], },
        { type: __WEBPACK_IMPORTED_MODULE_7__platform_platform__["a" /* Platform */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"], },
        { type: __WEBPACK_IMPORTED_MODULE_10__navigation_view_controller__["a" /* ViewController */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    ]; };
    Slides.propDecorators = {
        'autoplay': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'control': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'effect': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'direction': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'initialSlide': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'loop': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'pager': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'dir': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'paginationType': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'parallax': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'speed': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'zoom': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'spaceBetween': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'slidesPerView': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'centeredSlides': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'ionSlideWillChange': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        'ionSlideDidChange': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        'ionSlideDrag': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        'ionSlideReachStart': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        'ionSlideReachEnd': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        'ionSlideAutoplay': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        'ionSlideAutoplayStart': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        'ionSlideAutoplayStop': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        'ionSlideNextStart': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        'ionSlidePrevStart': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        'ionSlideNextEnd': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        'ionSlidePrevEnd': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        'ionSlideTap': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        'ionSlideDoubleTap': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    };
    return Slides;
}(__WEBPACK_IMPORTED_MODULE_3__ion__["a" /* Ion */]));

var slidesId = -1;
//# sourceMappingURL=slides.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/slides/swiper/swiper-a11y.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initA11y */
/* unused harmony export makeFocusable */
/* unused harmony export addRole */
/* unused harmony export addLabel */
/* harmony export (immutable) */ __webpack_exports__["a"] = ariaDisable;
/* harmony export (immutable) */ __webpack_exports__["b"] = ariaHidden;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__swiper_utils__ = __webpack_require__("./node_modules/ionic-angular/components/slides/swiper/swiper-utils.js");

function initA11y(s, plt) {
    var unregs = [];
    s._liveRegion = plt.doc().createElement('span');
    s._liveRegion.className = __WEBPACK_IMPORTED_MODULE_0__swiper_utils__["a" /* CLS */].notification;
    s._liveRegion.setAttribute('aria-live', 'assertive');
    s._liveRegion.setAttribute('aria-atomic', 'true');
    s.container.appendChild(s._liveRegion);
    // Setup accessibility
    if (s.nextButton) {
        makeFocusable(s.nextButton);
        addRole(s.nextButton, 'button');
        addLabel(s.nextButton, s.nextSlideMessage);
        plt.registerListener(s.nextButton, 'keydown', function (ev) {
            onEnterKey(s, ev);
        }, { zone: false }, unregs);
    }
    if (s.prevButton) {
        makeFocusable(s.prevButton);
        addRole(s.prevButton, 'button');
        addLabel(s.prevButton, s.prevSlideMessage);
        plt.registerListener(s.prevButton, 'keydown', function (ev) {
            onEnterKey(s, ev);
        }, { zone: false }, unregs);
    }
    return function () {
        unregs.forEach(function (unreg) {
            unreg();
        });
        unregs = null;
        if (s._liveRegion) {
            s._liveRegion.parentElement.removeChild(s._liveRegion);
        }
    };
}
function makeFocusable(ele) {
    ele.setAttribute('tabIndex', '0');
}
function addRole(ele, role) {
    ele.setAttribute('role', role);
}
function addLabel(ele, label) {
    ele.setAttribute('aria-label', label);
}
function ariaDisable(ele, isDisabled) {
    if (isDisabled) {
        ele.setAttribute('aria-disabled', 'true');
    }
    else if (ele.hasAttribute('aria-disabled')) {
        ele.removeAttribute('aria-disabled');
    }
}
function ariaHidden(ele, isHidden) {
    if (isHidden) {
        ele.setAttribute('aria-hidden', 'true');
    }
    else if (ele.hasAttribute('aria-hidden')) {
        ele.removeAttribute('aria-hidden');
    }
}
function onEnterKey(_, __) {
    // if (event.keyCode !== 13) return;
    // const target: HTMLElement = <any>event.target;
    // if (target.classList.contains(PARAMS.nextButtonClass)) {
    //   if (s.isEnd) {
    //     notify(s, PARAMS.lastSlideMessage);
    //   } else {
    //     notify(s, PARAMS.nextSlideMessage);
    //   }
    // } else if (target.classList.contains(PARAMS.prevButtonClass)) {
    //   if (s.isBeginning) {
    //     notify(s, PARAMS.firstSlideMessage);
    //   } else {
    //     notify(s, PARAMS.prevSlideMessage);
    //   }
    // }
}
// function notify(s: Slides, message: string) {
//   var notification = s._liveRegion;
//   if (notification) {
//     notification.innerHTML = message || '';
//   }
// }
//# sourceMappingURL=swiper-a11y.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/slides/swiper/swiper-classes.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = updateClasses;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__swiper_a11y__ = __webpack_require__("./node_modules/ionic-angular/components/slides/swiper/swiper-a11y.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__swiper_utils__ = __webpack_require__("./node_modules/ionic-angular/components/slides/swiper/swiper-utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__swiper_pagination__ = __webpack_require__("./node_modules/ionic-angular/components/slides/swiper/swiper-pagination.js");



/*=========================
  Classes
  ===========================*/
function updateClasses(s) {
    var childElements;
    Object(__WEBPACK_IMPORTED_MODULE_1__swiper_utils__["l" /* removeClass */])(s._slides, [__WEBPACK_IMPORTED_MODULE_1__swiper_utils__["a" /* CLS */].slideActive, __WEBPACK_IMPORTED_MODULE_1__swiper_utils__["a" /* CLS */].slideNext, __WEBPACK_IMPORTED_MODULE_1__swiper_utils__["a" /* CLS */].slidePrev, __WEBPACK_IMPORTED_MODULE_1__swiper_utils__["a" /* CLS */].slideDuplicateActive, __WEBPACK_IMPORTED_MODULE_1__swiper_utils__["a" /* CLS */].slideDuplicateNext, __WEBPACK_IMPORTED_MODULE_1__swiper_utils__["a" /* CLS */].slideDuplicatePrev]);
    for (var i = 0; i < s._slides.length; i++) {
        Object(__WEBPACK_IMPORTED_MODULE_0__swiper_a11y__["b" /* ariaHidden */])(s._slides[i], true);
    }
    var activeSlide = s._slides[s._activeIndex];
    if (!activeSlide) {
        return;
    }
    // Active classes
    Object(__WEBPACK_IMPORTED_MODULE_1__swiper_utils__["b" /* addClass */])(activeSlide, __WEBPACK_IMPORTED_MODULE_1__swiper_utils__["a" /* CLS */].slideActive);
    Object(__WEBPACK_IMPORTED_MODULE_0__swiper_a11y__["b" /* ariaHidden */])(activeSlide, false);
    if (s.loop) {
        // Duplicate to all looped slides
        if (activeSlide.classList.contains(__WEBPACK_IMPORTED_MODULE_1__swiper_utils__["a" /* CLS */].slideDuplicate)) {
            childElements = Object(__WEBPACK_IMPORTED_MODULE_1__swiper_utils__["k" /* queryChildren */])(s._wrapper, '.' + __WEBPACK_IMPORTED_MODULE_1__swiper_utils__["a" /* CLS */].slide + ':not(.' + __WEBPACK_IMPORTED_MODULE_1__swiper_utils__["a" /* CLS */].slideDuplicate + ')[data-swiper-slide-index="' + s.realIndex + '"]');
        }
        else {
            childElements = Object(__WEBPACK_IMPORTED_MODULE_1__swiper_utils__["k" /* queryChildren */])(s._wrapper, '.' + __WEBPACK_IMPORTED_MODULE_1__swiper_utils__["a" /* CLS */].slide + '.' + __WEBPACK_IMPORTED_MODULE_1__swiper_utils__["a" /* CLS */].slideDuplicate + '[data-swiper-slide-index="' + s.realIndex + '"]');
        }
        Object(__WEBPACK_IMPORTED_MODULE_1__swiper_utils__["b" /* addClass */])(childElements, __WEBPACK_IMPORTED_MODULE_1__swiper_utils__["a" /* CLS */].slideDuplicateActive);
    }
    // Next Slide
    var nextSlide = activeSlide.nextElementSibling;
    if (s.loop && !nextSlide) {
        nextSlide = s._slides[0];
    }
    nextSlide && nextSlide.classList.add(__WEBPACK_IMPORTED_MODULE_1__swiper_utils__["a" /* CLS */].slideNext);
    // Prev Slide
    var prevSlide = activeSlide.previousElementSibling;
    if (s.loop && !prevSlide) {
        prevSlide = s._slides[s._slides.length - 1];
    }
    prevSlide && prevSlide.classList.add(__WEBPACK_IMPORTED_MODULE_1__swiper_utils__["a" /* CLS */].slidePrev);
    if (s.loop) {
        // Duplicate to all looped slides
        if (nextSlide.classList.contains(__WEBPACK_IMPORTED_MODULE_1__swiper_utils__["a" /* CLS */].slideDuplicate)) {
            childElements = Object(__WEBPACK_IMPORTED_MODULE_1__swiper_utils__["k" /* queryChildren */])(s._wrapper, '.' + __WEBPACK_IMPORTED_MODULE_1__swiper_utils__["a" /* CLS */].slide + ':not(.' + __WEBPACK_IMPORTED_MODULE_1__swiper_utils__["a" /* CLS */].slideDuplicate + ')[data-swiper-slide-index="' + nextSlide.getAttribute('data-swiper-slide-index') + '"]');
        }
        else {
            childElements = Object(__WEBPACK_IMPORTED_MODULE_1__swiper_utils__["k" /* queryChildren */])(s._wrapper, '.' + __WEBPACK_IMPORTED_MODULE_1__swiper_utils__["a" /* CLS */].slide + '.' + __WEBPACK_IMPORTED_MODULE_1__swiper_utils__["a" /* CLS */].slideDuplicate + '[data-swiper-slide-index="' + nextSlide.getAttribute('data-swiper-slide-index') + '"]');
        }
        Object(__WEBPACK_IMPORTED_MODULE_1__swiper_utils__["b" /* addClass */])(childElements, __WEBPACK_IMPORTED_MODULE_1__swiper_utils__["a" /* CLS */].slideDuplicateNext);
        if (prevSlide.classList.contains(__WEBPACK_IMPORTED_MODULE_1__swiper_utils__["a" /* CLS */].slideDuplicate)) {
            childElements = Object(__WEBPACK_IMPORTED_MODULE_1__swiper_utils__["k" /* queryChildren */])(s._wrapper, '.' + __WEBPACK_IMPORTED_MODULE_1__swiper_utils__["a" /* CLS */].slide + ':not(.' + __WEBPACK_IMPORTED_MODULE_1__swiper_utils__["a" /* CLS */].slideDuplicate + ')[data-swiper-slide-index="' + prevSlide.getAttribute('data-swiper-slide-index') + '"]');
        }
        else {
            childElements = Object(__WEBPACK_IMPORTED_MODULE_1__swiper_utils__["k" /* queryChildren */])(s._wrapper, '.' + __WEBPACK_IMPORTED_MODULE_1__swiper_utils__["a" /* CLS */].slide + '.' + __WEBPACK_IMPORTED_MODULE_1__swiper_utils__["a" /* CLS */].slideDuplicate + '[data-swiper-slide-index="' + prevSlide.getAttribute('data-swiper-slide-index') + '"]');
        }
        Object(__WEBPACK_IMPORTED_MODULE_1__swiper_utils__["b" /* addClass */])(childElements, __WEBPACK_IMPORTED_MODULE_1__swiper_utils__["a" /* CLS */].slideDuplicatePrev);
    }
    // Pagination
    if (s._paginationContainer) {
        Object(__WEBPACK_IMPORTED_MODULE_2__swiper_pagination__["b" /* updatePaginationClasses */])(s);
    }
    // Next/active buttons
    if (!s.loop) {
        if (s.prevButton) {
            if (s._isBeginning) {
                s.prevButton.classList.add(__WEBPACK_IMPORTED_MODULE_1__swiper_utils__["a" /* CLS */].buttonDisabled);
                Object(__WEBPACK_IMPORTED_MODULE_0__swiper_a11y__["a" /* ariaDisable */])(s.prevButton, true);
            }
            else {
                s.prevButton.classList.remove(__WEBPACK_IMPORTED_MODULE_1__swiper_utils__["a" /* CLS */].buttonDisabled);
                Object(__WEBPACK_IMPORTED_MODULE_0__swiper_a11y__["a" /* ariaDisable */])(s.prevButton, false);
            }
        }
        if (s.nextButton) {
            if (s._isEnd) {
                s.nextButton.classList.add(__WEBPACK_IMPORTED_MODULE_1__swiper_utils__["a" /* CLS */].buttonDisabled);
                Object(__WEBPACK_IMPORTED_MODULE_0__swiper_a11y__["a" /* ariaDisable */])(s.nextButton, true);
            }
            else {
                s.nextButton.classList.remove(__WEBPACK_IMPORTED_MODULE_1__swiper_utils__["a" /* CLS */].buttonDisabled);
                Object(__WEBPACK_IMPORTED_MODULE_0__swiper_a11y__["a" /* ariaDisable */])(s.nextButton, false);
            }
        }
    }
}
//# sourceMappingURL=swiper-classes.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/slides/swiper/swiper-controller.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SWIPER_CONTROLLER; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__swiper__ = __webpack_require__("./node_modules/ionic-angular/components/slides/swiper/swiper.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__swiper_index__ = __webpack_require__("./node_modules/ionic-angular/components/slides/swiper/swiper-index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__swiper_utils__ = __webpack_require__("./node_modules/ionic-angular/components/slides/swiper/swiper-utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__swiper_progress__ = __webpack_require__("./node_modules/ionic-angular/components/slides/swiper/swiper-progress.js");




/*=========================
  Controller
  ===========================*/
var SWIPER_CONTROLLER = {
    LinearSpline: function (_s, _platform, x, y) {
        this.x = x;
        this.y = y;
        this.lastIndex = x.length - 1;
        // Given an x value (x2), return the expected y2 value:
        // (x1,y1) is the known point before given value,
        // (x3,y3) is the known point after given value.
        var i1, i3;
        this.interpolate = function (x2) {
            if (!x2)
                return 0;
            // Get the indexes of x1 and x3 (the array indexes before and after given x2):
            i3 = binarySearch(this.x, x2);
            i1 = i3 - 1;
            // We have our indexes i1 & i3, so we can calculate already:
            // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
            return ((x2 - this.x[i1]) * (this.y[i3] - this.y[i1])) / (this.x[i3] - this.x[i1]) + this.y[i1];
        };
        var binarySearch = (function () {
            var maxIndex, minIndex, guess;
            return function (array, val) {
                minIndex = -1;
                maxIndex = array.length;
                while (maxIndex - minIndex > 1)
                    if (array[guess = maxIndex + minIndex >> 1] <= val) {
                        minIndex = guess;
                    }
                    else {
                        maxIndex = guess;
                    }
                return maxIndex;
            };
        })();
    },
    // xxx: for now i will just save one spline function to to
    getInterpolateFunction: function (s, plt, c) {
        if (!s._spline)
            s._spline = s.loop ?
                new SWIPER_CONTROLLER.LinearSpline(s, plt, s._slidesGrid, c._slidesGrid) :
                new SWIPER_CONTROLLER.LinearSpline(s, plt, s._snapGrid, c._snapGrid);
    },
    setTranslate: function (s, plt, translate, byController, setWrapperTranslate) {
        var controlled = s.control;
        var multiplier, controlledTranslate;
        function setControlledTranslate(c) {
            // this will create an Interpolate function based on the snapGrids
            // x is the Grid of the scrolled scroller and y will be the controlled scroller
            // it makes sense to create this only once and recall it for the interpolation
            // the function does a lot of value caching for performance
            translate = c._rtl && Object(__WEBPACK_IMPORTED_MODULE_2__swiper_utils__["g" /* isHorizontal */])(c) ? -s._translate : s._translate;
            if (s.controlBy === 'slide') {
                SWIPER_CONTROLLER.getInterpolateFunction(s, plt, c);
                // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
                // but it did not work out
                controlledTranslate = -s._spline.interpolate(-translate);
            }
            if (!controlledTranslate || s.controlBy === 'container') {
                multiplier = (Object(__WEBPACK_IMPORTED_MODULE_2__swiper_utils__["h" /* maxTranslate */])(c) - Object(__WEBPACK_IMPORTED_MODULE_2__swiper_utils__["i" /* minTranslate */])(c)) / (Object(__WEBPACK_IMPORTED_MODULE_2__swiper_utils__["h" /* maxTranslate */])(s) - Object(__WEBPACK_IMPORTED_MODULE_2__swiper_utils__["i" /* minTranslate */])(s));
                controlledTranslate = (translate - Object(__WEBPACK_IMPORTED_MODULE_2__swiper_utils__["i" /* minTranslate */])(s)) * multiplier + Object(__WEBPACK_IMPORTED_MODULE_2__swiper_utils__["i" /* minTranslate */])(c);
            }
            if (s.controlInverse) {
                controlledTranslate = Object(__WEBPACK_IMPORTED_MODULE_2__swiper_utils__["h" /* maxTranslate */])(c) - controlledTranslate;
            }
            Object(__WEBPACK_IMPORTED_MODULE_3__swiper_progress__["a" /* updateProgress */])(c, controlledTranslate);
            setWrapperTranslate(c, plt, controlledTranslate, false, s);
            Object(__WEBPACK_IMPORTED_MODULE_1__swiper_index__["a" /* updateActiveIndex */])(c);
        }
        if (Array.isArray(controlled)) {
            for (var i = 0; i < controlled.length; i++) {
                if (controlled[i] !== byController) {
                    setControlledTranslate(controlled[i]);
                }
            }
        }
        else if (byController !== controlled) {
            setControlledTranslate(controlled);
        }
    },
    setTransition: function (s, plt, duration, byController, setWrapperTransition) {
        var controlled = s.control;
        var i;
        function setControlledTransition(c) {
            setWrapperTransition(c, plt, duration, s);
            if (duration !== 0) {
                Object(__WEBPACK_IMPORTED_MODULE_0__swiper__["f" /* onTransitionStart */])(c);
                plt.transitionEnd(c._wrapper, function () {
                    if (!controlled)
                        return;
                    if (c.loop && s.controlBy === 'slide') {
                        Object(__WEBPACK_IMPORTED_MODULE_0__swiper__["c" /* fixLoop */])(c, plt);
                    }
                    Object(__WEBPACK_IMPORTED_MODULE_0__swiper__["e" /* onTransitionEnd */])(c, plt);
                });
            }
        }
        if (Array.isArray(controlled)) {
            for (i = 0; i < controlled.length; i++) {
                if (controlled[i] !== byController) {
                    setControlledTransition(controlled[i]);
                }
            }
        }
        else if (byController !== controlled) {
            setControlledTransition(controlled);
        }
    }
};
//# sourceMappingURL=swiper-controller.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/slides/swiper/swiper-effects.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SWIPER_EFFECTS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__swiper_utils__ = __webpack_require__("./node_modules/ionic-angular/components/slides/swiper/swiper-utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__platform_platform_utils__ = __webpack_require__("./node_modules/ionic-angular/platform/platform-utils.js");


/*=========================
  Effects
  ===========================*/
var SWIPER_EFFECTS = {
    'fade': {
        setTranslate: function (s) {
            for (var i = 0; i < s._slides.length; i++) {
                var slide = s._slides[i];
                var offset = slide.swiperSlideOffset;
                var tx = -offset;
                if (!s.virtualTranslate) {
                    tx = tx - s._translate;
                }
                var ty = 0;
                if (!Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["g" /* isHorizontal */])(s)) {
                    ty = tx;
                    tx = 0;
                }
                var slideOpacity = s.fade.crossFade ?
                    Math.max(1 - Math.abs(slide.progress), 0) :
                    1 + Math.min(Math.max(slide.progress, -1), 0);
                slide.style.opacity = slideOpacity;
                Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["n" /* transform */])(slide, 'translate3d(' + tx + 'px, ' + ty + 'px, 0px)');
            }
        },
        setTransition: function (s, plt, duration) {
            var slides = s._slides;
            for (var i = 0; i < slides.length; i++) {
                Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["o" /* transition */])(slides[i], duration);
            }
            if (s.virtualTranslate && duration !== 0) {
                var eventTriggered = false;
                for (var i_1 = 0; i_1 < slides.length; i_1++) {
                    plt.transitionEnd(slides[i_1], function () {
                        if (eventTriggered || !s)
                            return;
                        eventTriggered = true;
                        s._animating = false;
                        Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["p" /* triggerTransitionEnd */])(plt, s._wrapper);
                    });
                }
            }
        }
    },
    'flip': {
        setTranslate: function (s, plt) {
            for (var i = 0; i < s._slides.length; i++) {
                var slide = s._slides[i];
                var progress = slide.progress;
                if (s.flip.limitRotation) {
                    progress = Math.max(Math.min(slide.progress, 1), -1);
                }
                var offset = slide.swiperSlideOffset;
                var rotate = -180 * progress, rotateY = rotate, rotateX = 0, tx = -offset, ty = 0;
                if (!Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["g" /* isHorizontal */])(s)) {
                    ty = tx;
                    tx = 0;
                    rotateX = -rotateY;
                    rotateY = 0;
                }
                else if (s._rtl) {
                    rotateY = -rotateY;
                }
                slide.style.zIndex = -Math.abs(Math.round(progress)) + s._slides.length;
                if (s.flip.slideShadows) {
                    // Set shadows
                    var shadowBefore = (Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["g" /* isHorizontal */])(s) ? slide.querySelector('.swiper-slide-shadow-left') : slide.querySelector('.swiper-slide-shadow-top'));
                    var shadowAfter = (Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["g" /* isHorizontal */])(s) ? slide.querySelector('.swiper-slide-shadow-right') : slide.querySelector('.swiper-slide-shadow-bottom'));
                    if (!shadowBefore) {
                        shadowBefore = plt.doc().createElement('div');
                        shadowBefore.className = 'swiper-slide-shadow-' + (Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["g" /* isHorizontal */])(s) ? 'left' : 'top');
                        slide.appendChild(shadowBefore);
                    }
                    if (!shadowAfter) {
                        shadowAfter = plt.doc().createElement('div');
                        shadowAfter.className = 'swiper-slide-shadow-' + (Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["g" /* isHorizontal */])(s) ? 'right' : 'bottom');
                        slide.appendChild(shadowAfter);
                    }
                    if (shadowBefore) {
                        shadowBefore.style.opacity = Math.max(-progress, 0);
                    }
                    if (shadowAfter) {
                        shadowAfter.style.opacity = Math.max(progress, 0);
                    }
                }
                Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["n" /* transform */])(slide, 'translate3d(' + tx + 'px, ' + ty + 'px, 0px) rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg)');
            }
        },
        setTransition: function (s, plt, duration) {
            for (var i = 0; i < s._slides.length; i++) {
                var slide = s._slides[i];
                Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["o" /* transition */])(slide, duration);
                Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["c" /* eachChild */])(slide, '.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left', function (el) {
                    Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["o" /* transition */])(el, duration);
                });
            }
            if (s.virtualTranslate && duration !== 0) {
                var eventTriggered = false;
                plt.transitionEnd(s._slides[s._activeIndex], function (ev) {
                    if (eventTriggered || !s)
                        return;
                    if (!ev.target.classList.contains(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["a" /* CLS */].slideActive)) {
                        return;
                    }
                    eventTriggered = true;
                    s._animating = false;
                    Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["p" /* triggerTransitionEnd */])(plt, s._wrapper);
                });
            }
        }
    },
    'cube': {
        setTranslate: function (s, plt) {
            var wrapperRotate = 0;
            var cubeShadow;
            if (s.cube.shadow) {
                if (Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["g" /* isHorizontal */])(s)) {
                    cubeShadow = s._wrapper.querySelector('.swiper-cube-shadow');
                    if (!cubeShadow) {
                        cubeShadow = plt.doc().createElement('div');
                        cubeShadow.className = 'swiper-cube-shadow';
                        s._wrapper.appendChild(cubeShadow);
                    }
                    cubeShadow.style.height = s.renderedWidth + 'px';
                }
                else {
                    cubeShadow = s.container.querySelector('.swiper-cube-shadow');
                    if (!cubeShadow) {
                        cubeShadow = plt.doc().createElement('div');
                        cubeShadow.className = 'swiper-cube-shadow';
                        s._wrapper.appendChild(cubeShadow);
                    }
                }
            }
            for (var i = 0; i < s._slides.length; i++) {
                var slide = s._slides[i];
                var slideAngle = i * 90;
                var round = Math.floor(slideAngle / 360);
                if (s._rtl) {
                    slideAngle = -slideAngle;
                    round = Math.floor(-slideAngle / 360);
                }
                var progress = Math.max(Math.min(slide.progress, 1), -1);
                var tx = 0, ty = 0, tz = 0;
                if (i % 4 === 0) {
                    tx = -round * 4 * s._renderedSize;
                    tz = 0;
                }
                else if ((i - 1) % 4 === 0) {
                    tx = 0;
                    tz = -round * 4 * s._renderedSize;
                }
                else if ((i - 2) % 4 === 0) {
                    tx = s._renderedSize + round * 4 * s._renderedSize;
                    tz = s._renderedSize;
                }
                else if ((i - 3) % 4 === 0) {
                    tx = -s._renderedSize;
                    tz = 3 * s._renderedSize + s._renderedSize * 4 * round;
                }
                if (s._rtl) {
                    tx = -tx;
                }
                if (!Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["g" /* isHorizontal */])(s)) {
                    ty = tx;
                    tx = 0;
                }
                var transformStr = 'rotateX(' + (Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["g" /* isHorizontal */])(s) ? 0 : -slideAngle) + 'deg) rotateY(' + (Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["g" /* isHorizontal */])(s) ? slideAngle : 0) + 'deg) translate3d(' + tx + 'px, ' + ty + 'px, ' + tz + 'px)';
                if (progress <= 1 && progress > -1) {
                    wrapperRotate = i * 90 + progress * 90;
                    if (s._rtl)
                        wrapperRotate = -i * 90 - progress * 90;
                }
                Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["n" /* transform */])(slide, transformStr);
                if (s.cube.slideShadows) {
                    // Set shadows
                    var shadowBefore = (Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["g" /* isHorizontal */])(s) ? slide.querySelector('.swiper-slide-shadow-left') : slide.querySelector('.swiper-slide-shadow-top'));
                    var shadowAfter = (Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["g" /* isHorizontal */])(s) ? slide.querySelector('.swiper-slide-shadow-right') : slide.querySelector('.swiper-slide-shadow-bottom'));
                    if (!shadowBefore) {
                        shadowBefore = plt.doc().createElement('div');
                        shadowBefore.className = 'swiper-slide-shadow-' + (Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["g" /* isHorizontal */])(s) ? 'left' : 'top');
                        slide.appendChild(shadowBefore);
                    }
                    if (!shadowAfter) {
                        shadowAfter = plt.doc().createElement('div');
                        shadowAfter.className = 'swiper-slide-shadow-' + (Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["g" /* isHorizontal */])(s) ? 'right' : 'bottom');
                        slide.appendChild(shadowAfter);
                    }
                    if (shadowBefore)
                        shadowBefore.style.opacity = Math.max(-progress, 0);
                    if (shadowAfter)
                        shadowAfter.style.opacity = Math.max(progress, 0);
                }
            }
            s._wrapper.style.transformOrigin = s._wrapper.style.webkitTransformOrigin = '50% 50% -' + (s._renderedSize / 2) + 'px';
            if (s.cube.shadow) {
                if (Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["g" /* isHorizontal */])(s)) {
                    Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["n" /* transform */])(cubeShadow, 'translate3d(0px, ' + (s.renderedWidth / 2 + s.cube.shadowOffset) + 'px, ' + (-s.renderedWidth / 2) + 'px) rotateX(90deg) rotateZ(0deg) scale(' + (s.cube.shadowScale) + ')');
                }
                else {
                    var shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
                    var multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
                    var scale1 = s.cube.shadowScale;
                    var scale2 = s.cube.shadowScale / multiplier;
                    var offset = s.cube.shadowOffset;
                    Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["n" /* transform */])(cubeShadow, 'scale3d(' + scale1 + ', 1, ' + scale2 + ') translate3d(0px, ' + (s.renderedHeight / 2 + offset) + 'px, ' + (-s.renderedHeight / 2 / scale2) + 'px) rotateX(-90deg)');
                }
            }
            var zFactor = (Object(__WEBPACK_IMPORTED_MODULE_1__platform_platform_utils__["e" /* isSafari */])(plt) || Object(__WEBPACK_IMPORTED_MODULE_1__platform_platform_utils__["d" /* isIosUIWebView */])(plt)) ? (-s._renderedSize / 2) : 0;
            Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["n" /* transform */])(s._wrapper, 'translate3d(0px,0,' + zFactor + 'px) rotateX(' + (Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["g" /* isHorizontal */])(s) ? 0 : wrapperRotate) + 'deg) rotateY(' + (Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["g" /* isHorizontal */])(s) ? -wrapperRotate : 0) + 'deg)');
        },
        setTransition: function (s, _plt, duration) {
            for (var i = 0; i < s._slides.length; i++) {
                var slide = s._slides[i];
                Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["o" /* transition */])(slide, duration);
                Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["c" /* eachChild */])(slide, '.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left', function (el) {
                    Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["o" /* transition */])(el, duration);
                });
            }
            if (s.cube.shadow && !Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["g" /* isHorizontal */])(s)) {
                Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["c" /* eachChild */])(s.container, '.swiper-cube-shadow', function (el) {
                    Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["o" /* transition */])(el, duration);
                });
            }
        }
    },
    'coverflow': {
        setTranslate: function (s, plt) {
            var transformStr = s._translate;
            var center = Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["g" /* isHorizontal */])(s) ? -transformStr + s.renderedWidth / 2 : -transformStr + s.renderedHeight / 2;
            var rotate = Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["g" /* isHorizontal */])(s) ? s.coverflow.rotate : -s.coverflow.rotate;
            var translate = s.coverflow.depth;
            // Each slide offset from center
            for (var i = 0, length = s._slides.length; i < length; i++) {
                var slide = s._slides[i];
                var slideSize = s._slidesSizesGrid[i];
                var slideOffset = slide.swiperSlideOffset;
                var offsetMultiplier = (center - slideOffset - slideSize / 2) / slideSize * s.coverflow.modifier;
                var rotateY = Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["g" /* isHorizontal */])(s) ? rotate * offsetMultiplier : 0;
                var rotateX = Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["g" /* isHorizontal */])(s) ? 0 : rotate * offsetMultiplier;
                // var rotateZ = 0
                var translateZ = -translate * Math.abs(offsetMultiplier);
                var translateY = Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["g" /* isHorizontal */])(s) ? 0 : s.coverflow.stretch * (offsetMultiplier);
                var translateX = Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["g" /* isHorizontal */])(s) ? s.coverflow.stretch * (offsetMultiplier) : 0;
                // Fix for ultra small values
                if (Math.abs(translateX) < 0.001)
                    translateX = 0;
                if (Math.abs(translateY) < 0.001)
                    translateY = 0;
                if (Math.abs(translateZ) < 0.001)
                    translateZ = 0;
                if (Math.abs(rotateY) < 0.001)
                    rotateY = 0;
                if (Math.abs(rotateX) < 0.001)
                    rotateX = 0;
                var slideTransform = 'translate3d(' + translateX + 'px,' + translateY + 'px,' + translateZ + 'px)  rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg)';
                Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["n" /* transform */])(slide, slideTransform);
                slide.style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
                if (s.coverflow.slideShadows) {
                    // Set shadows
                    var shadowBefore = (Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["g" /* isHorizontal */])(s) ? slide.querySelector('.swiper-slide-shadow-left') : slide.querySelector('.swiper-slide-shadow-top'));
                    var shadowAfter = (Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["g" /* isHorizontal */])(s) ? slide.querySelector('.swiper-slide-shadow-right') : slide.querySelector('.swiper-slide-shadow-bottom'));
                    if (!shadowBefore) {
                        shadowBefore = plt.doc().createElement('div');
                        shadowBefore.className = 'swiper-slide-shadow-' + (Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["g" /* isHorizontal */])(s) ? 'left' : 'top');
                        slide.appendChild(shadowBefore);
                    }
                    if (!shadowAfter) {
                        shadowAfter = plt.doc().createElement('div');
                        shadowAfter.className = 'swiper-slide-shadow-' + (Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["g" /* isHorizontal */])(s) ? 'right' : 'bottom');
                        slide.appendChild(shadowAfter);
                    }
                    if (shadowBefore) {
                        shadowBefore.style.opacity = (offsetMultiplier > 0 ? offsetMultiplier : 0);
                    }
                    if (shadowAfter) {
                        shadowAfter.style.opacity = ((-offsetMultiplier) > 0 ? -offsetMultiplier : 0);
                    }
                }
            }
        },
        setTransition: function (s, _plt, duration) {
            for (var i = 0; i < s._slides.length; i++) {
                var slide = s._slides[i];
                Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["o" /* transition */])(slide, duration);
                Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["c" /* eachChild */])(slide, '.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left', function (el) {
                    Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["o" /* transition */])(el, duration);
                });
            }
        }
    }
};
//# sourceMappingURL=swiper-effects.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/slides/swiper/swiper-events.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initEvents;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__swiper_utils__ = __webpack_require__("./node_modules/ionic-angular/components/slides/swiper/swiper-utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__swiper_transition__ = __webpack_require__("./node_modules/ionic-angular/components/slides/swiper/swiper-transition.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__swiper__ = __webpack_require__("./node_modules/ionic-angular/components/slides/swiper/swiper.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__swiper_progress__ = __webpack_require__("./node_modules/ionic-angular/components/slides/swiper/swiper-progress.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__swiper_index__ = __webpack_require__("./node_modules/ionic-angular/components/slides/swiper/swiper-index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__swiper_pagination__ = __webpack_require__("./node_modules/ionic-angular/components/slides/swiper/swiper-pagination.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__swiper_classes__ = __webpack_require__("./node_modules/ionic-angular/components/slides/swiper/swiper-classes.js");







/*=========================
  Events
  ===========================*/
// Attach/detach events
function initEvents(s, plt) {
    var win = plt.win();
    var doc = plt.doc();
    s._supportTouch = (function () {
        return !!(('ontouchstart' in win) || win.DocumentTouch && doc instanceof win.DocumentTouch);
    })();
    // Define Touch Events
    s._touchEventsDesktop = { start: 'mousedown', move: 'mousemove', end: 'mouseup' };
    if (win.navigator.pointerEnabled) {
        s._touchEventsDesktop = { start: 'pointerdown', move: 'pointermove', end: 'pointerup' };
    }
    else if (win.navigator.msPointerEnabled) {
        s._touchEventsDesktop = { start: 'MSPointerDown', move: 'MSPointerMove', end: 'MSPointerUp' };
    }
    s._touchEvents = {
        start: s._supportTouch || !s.simulateTouch ? 'touchstart' : s._touchEventsDesktop.start,
        move: s._supportTouch || !s.simulateTouch ? 'touchmove' : s._touchEventsDesktop.move,
        end: s._supportTouch || !s.simulateTouch ? 'touchend' : s._touchEventsDesktop.end
    };
    // WP8 Touch Events Fix
    if (win.navigator.pointerEnabled || win.navigator.msPointerEnabled) {
        (s.touchEventsTarget === 'container' ? s.container : s._wrapper).classList.add('swiper-wp8-' + s.direction);
    }
    var unregs = [];
    var touchEventsTarget = s.touchEventsTarget === 'container' ? s.container : s._wrapper;
    // Touch Events
    if (s._supportTouch) {
        // touchstart
        plt.registerListener(touchEventsTarget, s._touchEvents.start, function (ev) {
            onTouchStart(s, plt, ev);
        }, { passive: true, zone: false }, unregs);
        // touchmove
        plt.registerListener(touchEventsTarget, s._touchEvents.move, function (ev) {
            onTouchMove(s, plt, ev);
        }, { zone: false }, unregs);
        // touchend
        plt.registerListener(touchEventsTarget, s._touchEvents.end, function (ev) {
            onTouchEnd(s, plt, ev);
        }, { passive: true, zone: false }, unregs);
    }
    if ((s.simulateTouch && !plt.is('ios') && !plt.is('android')) || (s.simulateTouch && !s._supportTouch && plt.is('ios')) || plt.getQueryParam('ionicPlatform')) {
        // mousedown
        plt.registerListener(touchEventsTarget, 'mousedown', function (ev) {
            onTouchStart(s, plt, ev);
        }, { zone: false }, unregs);
        // mousemove
        plt.registerListener(touchEventsTarget, 'mousemove', function (ev) {
            onTouchMove(s, plt, ev);
        }, { zone: false }, unregs);
        // mouseup
        plt.registerListener(touchEventsTarget, 'mouseup', function (ev) {
            onTouchEnd(s, plt, ev);
        }, { zone: false }, unregs);
    }
    // onresize
    var resizeObs = plt.resize.subscribe(function () { return onResize(s, plt, false); });
    // Next, Prev, Index
    if (s.nextButton) {
        plt.registerListener(s.nextButton, 'click', function (ev) {
            onClickNext(s, plt, ev);
        }, { zone: false }, unregs);
    }
    if (s.prevButton) {
        plt.registerListener(s.prevButton, 'click', function (ev) {
            onClickPrev(s, plt, ev);
        }, { zone: false }, unregs);
    }
    if (s.paginationType) {
        plt.registerListener(s._paginationContainer, 'click', function (ev) {
            onClickIndex(s, plt, ev);
        }, { zone: false }, unregs);
    }
    // Prevent Links Clicks
    if (s.preventClicks || s.preventClicksPropagation) {
        plt.registerListener(touchEventsTarget, 'click', function (ev) {
            preventClicks(s, ev);
        }, { zone: false, capture: true }, unregs);
    }
    // return a function that removes all of the added listeners
    return function () {
        resizeObs.unsubscribe();
        unregs.forEach(function (unreg) {
            unreg();
        });
        unregs = null;
    };
}
/*=========================
  Handle Clicks
  ===========================*/
// Prevent Clicks
function preventClicks(s, e) {
    if (!s._allowClick) {
        if (s.preventClicks) {
            e.preventDefault();
        }
        if (s.preventClicksPropagation && s._animating) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
    }
}
// Clicks
function onClickNext(s, plt, e) {
    e.preventDefault();
    if (s._isEnd && !s.loop) {
        return;
    }
    Object(__WEBPACK_IMPORTED_MODULE_2__swiper__["h" /* slideNext */])(s, plt);
}
function onClickPrev(s, plt, e) {
    e.preventDefault();
    if (s._isBeginning && !s.loop) {
        return;
    }
    Object(__WEBPACK_IMPORTED_MODULE_2__swiper__["i" /* slidePrev */])(s, plt);
}
function onClickIndex(s, plt, e) {
    var indexStr = e.target.getAttribute('data-slide-index');
    if (indexStr) {
        var index = parseInt(indexStr, 10);
        e.preventDefault();
        if (s.loop) {
            index = index + s.loopedSlides;
        }
        Object(__WEBPACK_IMPORTED_MODULE_2__swiper__["k" /* slideTo */])(s, plt, index);
    }
}
/*=========================
  Handle Touches
  ===========================*/
function findElementInEvent(e, selector) {
    var el = e.target;
    if (!el.matches(selector)) {
        if (typeof selector === 'string') {
            el = el.closest(selector);
        }
        else if (selector.nodeType) {
            var parentEl = el.parentElement;
            while (parentEl) {
                if (parentEl === selector) {
                    return selector;
                }
            }
            return undefined;
        }
    }
    return el;
}
function updateClickedSlide(s, plt, e) {
    var slide = findElementInEvent(e, '.' + __WEBPACK_IMPORTED_MODULE_0__swiper_utils__["a" /* CLS */].slide);
    var slideIndex = -1;
    if (slide) {
        for (var i = 0; i < s._slides.length; i++) {
            if (s._slides[i] === slide) {
                slideIndex = i;
                break;
            }
        }
    }
    if (slide && slideIndex > -1) {
        s.clickedSlide = slide;
        s.clickedIndex = slideIndex;
    }
    else {
        s.clickedSlide = undefined;
        s.clickedIndex = undefined;
        return;
    }
    if (s.slideToClickedSlide && s.clickedIndex !== undefined && s.clickedIndex !== s._activeIndex) {
        var slideToIndex = s.clickedIndex;
        var realIndex;
        var slidesPerView = s.slidesPerView === 'auto' ? Object(__WEBPACK_IMPORTED_MODULE_2__swiper__["a" /* currentSlidesPerView */])(s) : s.slidesPerView;
        if (s.loop) {
            if (s._animating)
                return;
            realIndex = parseInt(s.clickedSlide.getAttribute('data-swiper-slide-index'), 10);
            if (s.centeredSlides) {
                if ((slideToIndex < s.loopedSlides - slidesPerView / 2) || (slideToIndex > s._slides.length - s.loopedSlides + slidesPerView / 2)) {
                    Object(__WEBPACK_IMPORTED_MODULE_2__swiper__["c" /* fixLoop */])(s, plt);
                    slideToIndex = Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["d" /* getElementIndex */])(s._wrapper.querySelector('.' + __WEBPACK_IMPORTED_MODULE_0__swiper_utils__["a" /* CLS */].slide + '[data-swiper-slide-index="' + realIndex + '"]:not(.' + __WEBPACK_IMPORTED_MODULE_0__swiper_utils__["a" /* CLS */].slideDuplicate + ')'));
                    plt.timeout(function () {
                        Object(__WEBPACK_IMPORTED_MODULE_2__swiper__["k" /* slideTo */])(s, plt, slideToIndex);
                    });
                }
                else {
                    Object(__WEBPACK_IMPORTED_MODULE_2__swiper__["k" /* slideTo */])(s, plt, slideToIndex);
                }
            }
            else {
                if (slideToIndex > s._slides.length - slidesPerView) {
                    Object(__WEBPACK_IMPORTED_MODULE_2__swiper__["c" /* fixLoop */])(s, plt);
                    slideToIndex = Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["d" /* getElementIndex */])(s._wrapper.querySelector('.' + __WEBPACK_IMPORTED_MODULE_0__swiper_utils__["a" /* CLS */].slide + '[data-swiper-slide-index="' + realIndex + '"]:not(.' + __WEBPACK_IMPORTED_MODULE_0__swiper_utils__["a" /* CLS */].slideDuplicate + ')'));
                    plt.timeout(function () {
                        Object(__WEBPACK_IMPORTED_MODULE_2__swiper__["k" /* slideTo */])(s, plt, slideToIndex);
                    });
                }
                else {
                    Object(__WEBPACK_IMPORTED_MODULE_2__swiper__["k" /* slideTo */])(s, plt, slideToIndex);
                }
            }
        }
        else {
            Object(__WEBPACK_IMPORTED_MODULE_2__swiper__["k" /* slideTo */])(s, plt, slideToIndex);
        }
    }
}
var isTouched;
var isMoved;
var allowTouchCallbacks;
var touchStartTime;
var isScrolling;
var currentTranslate;
var startTranslate;
var allowThresholdMove;
// Last click time
var lastClickTime = Date.now();
var clickTimeout;
// Velocities
var velocities = [];
var allowMomentumBounce;
// Touch handlers
var isTouchEvent;
var startMoving;
function onTouchStart(s, plt, ev) {
    (void 0) /* console.debug */;
    if (ev.originalEvent) {
        ev = ev.originalEvent;
    }
    s.originalEvent = ev;
    isTouchEvent = ev.type === 'touchstart';
    if (!isTouchEvent && 'which' in ev && ev.which === 3) {
        return;
    }
    if (s.noSwiping && findElementInEvent(ev, '.' + __WEBPACK_IMPORTED_MODULE_0__swiper_utils__["a" /* CLS */].noSwiping)) {
        s._allowClick = true;
        return;
    }
    if (s.swipeHandler) {
        if (!findElementInEvent(ev, s.swipeHandler))
            return;
    }
    var startX = s._touches.currentX = ev.type === 'touchstart' ? ev.targetTouches[0].pageX : ev.pageX;
    var startY = s._touches.currentY = ev.type === 'touchstart' ? ev.targetTouches[0].pageY : ev.pageY;
    // Do NOT start if iOS edge swipe is detected. Otherwise iOS app (UIWebView) cannot swipe-to-go-back anymore
    if (plt.is('ios') && s.iOSEdgeSwipeDetection && startX <= s.iOSEdgeSwipeThreshold) {
        return;
    }
    isTouched = true;
    isMoved = false;
    allowTouchCallbacks = true;
    isScrolling = undefined;
    startMoving = undefined;
    s._touches.startX = startX;
    s._touches.startY = startY;
    touchStartTime = Date.now();
    s._allowClick = true;
    Object(__WEBPACK_IMPORTED_MODULE_2__swiper__["p" /* updateContainerSize */])(s, plt);
    s.swipeDirection = undefined;
    if (s.threshold > 0) {
        allowThresholdMove = false;
    }
    if (ev.type !== 'touchstart') {
        var preventDefault = true;
        if (Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["f" /* isFormElement */])(ev.target)) {
            preventDefault = false;
        }
        plt.focusOutActiveElement();
        if (preventDefault) {
            ev.preventDefault();
        }
    }
    s.ionSlideTouchStart.emit(ev);
}
function onTouchMove(s, plt, ev) {
    (void 0) /* console.debug */;
    if (ev.originalEvent) {
        ev = ev.originalEvent;
    }
    s.originalEvent = ev;
    if (isTouchEvent && ev.type === 'mousemove')
        return;
    if (ev.preventedByNestedSwiper) {
        s._touches.startX = ev.type === 'touchmove' ? ev.targetTouches[0].pageX : ev.pageX;
        s._touches.startY = ev.type === 'touchmove' ? ev.targetTouches[0].pageY : ev.pageY;
        return;
    }
    if (s.onlyExternal) {
        // isMoved = true;
        s._allowClick = false;
        if (isTouched) {
            s._touches.startX = s._touches.currentX = ev.type === 'touchmove' ? ev.targetTouches[0].pageX : ev.pageX;
            s._touches.startY = s._touches.currentY = ev.type === 'touchmove' ? ev.targetTouches[0].pageY : ev.pageY;
            touchStartTime = Date.now();
        }
        return;
    }
    if (isTouchEvent && s.touchReleaseOnEdges && !s.loop) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["g" /* isHorizontal */])(s)) {
            // Vertical
            if ((s._touches.currentY < s._touches.startY && s._translate <= Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["h" /* maxTranslate */])(s)) ||
                (s._touches.currentY > s._touches.startY && s._translate >= Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["i" /* minTranslate */])(s))) {
                return;
            }
        }
        else {
            if ((s._touches.currentX < s._touches.startX && s._translate <= Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["h" /* maxTranslate */])(s)) ||
                (s._touches.currentX > s._touches.startX && s._translate >= Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["i" /* minTranslate */])(s))) {
                return;
            }
        }
    }
    var activeEle = plt.getActiveElement();
    if (isTouchEvent && activeEle) {
        if (ev.target === activeEle && Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["f" /* isFormElement */])(ev.target)) {
            isMoved = true;
            s._allowClick = false;
            return;
        }
    }
    if (ev.targetTouches && ev.targetTouches.length > 1)
        return;
    s._touches.currentX = ev.type === 'touchmove' ? ev.targetTouches[0].pageX : ev.pageX;
    s._touches.currentY = ev.type === 'touchmove' ? ev.targetTouches[0].pageY : ev.pageY;
    if (typeof isScrolling === 'undefined') {
        var touchAngle;
        if (Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["g" /* isHorizontal */])(s) && s._touches.currentY === s._touches.startY || !Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["g" /* isHorizontal */])(s) && s._touches.currentX === s._touches.startX) {
            isScrolling = false;
        }
        else {
            touchAngle = Math.atan2(Math.abs(s._touches.currentY - s._touches.startY), Math.abs(s._touches.currentX - s._touches.startX)) * 180 / Math.PI;
            isScrolling = Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["g" /* isHorizontal */])(s) ? touchAngle > s.touchAngle : (90 - touchAngle > s.touchAngle);
        }
    }
    if (!isTouched)
        return;
    if (isScrolling) {
        isTouched = false;
        return;
    }
    s._allowClick = false;
    s.ionSlideDrag.emit(s);
    ev.preventDefault();
    if (s.touchMoveStopPropagation) {
        ev.stopPropagation();
    }
    if (!isMoved) {
        if (s.loop) {
            Object(__WEBPACK_IMPORTED_MODULE_2__swiper__["c" /* fixLoop */])(s, plt);
        }
        startTranslate = Object(__WEBPACK_IMPORTED_MODULE_1__swiper_transition__["b" /* getWrapperTranslate */])(s, plt);
        Object(__WEBPACK_IMPORTED_MODULE_1__swiper_transition__["c" /* setWrapperTransition */])(s, plt, 0);
        if (s._animating) {
            Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["p" /* triggerTransitionEnd */])(plt, s._wrapper);
        }
        if (s.autoplay && s._autoplaying) {
            if (s.autoplayDisableOnInteraction) {
                Object(__WEBPACK_IMPORTED_MODULE_2__swiper__["m" /* stopAutoplay */])(s);
            }
            else {
                Object(__WEBPACK_IMPORTED_MODULE_2__swiper__["g" /* pauseAutoplay */])(s, plt);
            }
        }
        allowMomentumBounce = false;
    }
    isMoved = true;
    var diff = s._touches.diff = Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["g" /* isHorizontal */])(s) ? s._touches.currentX - s._touches.startX : s._touches.currentY - s._touches.startY;
    diff = diff * s.touchRatio;
    if (s._rtl)
        diff = -diff;
    s.swipeDirection = diff > 0 ? 'prev' : 'next';
    currentTranslate = diff + startTranslate;
    var disableParentSwiper = true;
    if ((diff > 0 && currentTranslate > Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["i" /* minTranslate */])(s))) {
        disableParentSwiper = false;
        if (s.resistance) {
            currentTranslate = Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["i" /* minTranslate */])(s) - 1 + Math.pow(-Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["i" /* minTranslate */])(s) + startTranslate + diff, s.resistanceRatio);
        }
    }
    else if (diff < 0 && currentTranslate < Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["h" /* maxTranslate */])(s)) {
        disableParentSwiper = false;
        if (s.resistance)
            currentTranslate = Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["h" /* maxTranslate */])(s) + 1 - Math.pow(Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["h" /* maxTranslate */])(s) - startTranslate - diff, s.resistanceRatio);
    }
    if (disableParentSwiper) {
        ev.preventedByNestedSwiper = true;
    }
    // Directions locks
    if (!s._allowSwipeToNext && s.swipeDirection === 'next' && currentTranslate < startTranslate) {
        currentTranslate = startTranslate;
    }
    if (!s._allowSwipeToPrev && s.swipeDirection === 'prev' && currentTranslate > startTranslate) {
        currentTranslate = startTranslate;
    }
    // Threshold
    if (s.threshold > 0) {
        if (Math.abs(diff) > s.threshold || allowThresholdMove) {
            if (!allowThresholdMove) {
                allowThresholdMove = true;
                s._touches.startX = s._touches.currentX;
                s._touches.startY = s._touches.currentY;
                currentTranslate = startTranslate;
                s._touches.diff = Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["g" /* isHorizontal */])(s) ? s._touches.currentX - s._touches.startX : s._touches.currentY - s._touches.startY;
                return;
            }
        }
        else {
            currentTranslate = startTranslate;
            return;
        }
    }
    if (!s.followFinger)
        return;
    // Update active index in free mode
    if (s.freeMode || s.watchSlidesProgress) {
        Object(__WEBPACK_IMPORTED_MODULE_4__swiper_index__["a" /* updateActiveIndex */])(s);
    }
    if (s.freeMode) {
        // Velocity
        if (velocities.length === 0) {
            velocities.push({
                position: s._touches[Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["g" /* isHorizontal */])(s) ? 'startX' : 'startY'],
                time: touchStartTime
            });
        }
        velocities.push({
            position: s._touches[Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["g" /* isHorizontal */])(s) ? 'currentX' : 'currentY'],
            time: (new Date()).getTime()
        });
    }
    // Update progress
    Object(__WEBPACK_IMPORTED_MODULE_3__swiper_progress__["a" /* updateProgress */])(s, currentTranslate);
    // Update translate
    Object(__WEBPACK_IMPORTED_MODULE_1__swiper_transition__["d" /* setWrapperTranslate */])(s, plt, currentTranslate);
}
function onTouchEnd(s, plt, ev) {
    (void 0) /* console.debug */;
    if (ev.originalEvent) {
        ev = ev.originalEvent;
    }
    s.originalEvent = ev;
    if (allowTouchCallbacks) {
        s.ionSlideTouchEnd.emit(ev);
    }
    allowTouchCallbacks = false;
    if (!isTouched)
        return;
    // Time diff
    var touchEndTime = Date.now();
    var timeDiff = touchEndTime - touchStartTime;
    // Tap, doubleTap, Click
    if (s._allowClick) {
        updateClickedSlide(s, plt, ev);
        s._zone.run(function () {
            s.ionSlideTap.emit(s);
            if (timeDiff < 300 && (touchEndTime - lastClickTime) > 300) {
                if (clickTimeout) {
                    plt.cancelTimeout(clickTimeout);
                }
                clickTimeout = plt.timeout(function () {
                    if (!s)
                        return;
                    if (s.paginationHide && s._paginationContainer && !ev.target.classList.contains(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["a" /* CLS */].bullet)) {
                        s._paginationContainer.classList.toggle(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["a" /* CLS */].paginationHidden);
                    }
                }, 300);
            }
            if (timeDiff < 300 && (touchEndTime - lastClickTime) < 300) {
                if (clickTimeout)
                    clearTimeout(clickTimeout);
                s.ionSlideDoubleTap.emit(s);
            }
        });
    }
    lastClickTime = Date.now();
    plt.timeout(function () {
        if (s) {
            s._allowClick = true;
        }
    });
    if (!isTouched || !isMoved || !s.swipeDirection || s._touches.diff === 0 || currentTranslate === startTranslate) {
        isTouched = isMoved = false;
        return;
    }
    isTouched = isMoved = false;
    var currentPos;
    if (s.followFinger) {
        currentPos = s._rtl ? s._translate : -s._translate;
    }
    else {
        currentPos = -currentTranslate;
    }
    if (s.freeMode) {
        if (currentPos < -Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["i" /* minTranslate */])(s)) {
            Object(__WEBPACK_IMPORTED_MODULE_2__swiper__["k" /* slideTo */])(s, plt, s._activeIndex);
            return;
        }
        else if (currentPos > -Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["h" /* maxTranslate */])(s)) {
            if (s._slides.length < s._snapGrid.length) {
                Object(__WEBPACK_IMPORTED_MODULE_2__swiper__["k" /* slideTo */])(s, plt, s._snapGrid.length - 1);
            }
            else {
                Object(__WEBPACK_IMPORTED_MODULE_2__swiper__["k" /* slideTo */])(s, plt, s._slides.length - 1);
            }
            return;
        }
        if (s.freeModeMomentum) {
            if (velocities.length > 1) {
                var lastMoveEvent = velocities.pop(), velocityEvent = velocities.pop();
                var distance = lastMoveEvent.position - velocityEvent.position;
                var time = lastMoveEvent.time - velocityEvent.time;
                s.velocity = distance / time;
                s.velocity = s.velocity / 2;
                if (Math.abs(s.velocity) < s.freeModeMinimumVelocity) {
                    s.velocity = 0;
                }
                // this implies that the user stopped moving a finger then released.
                // There would be no events with distance zero, so the last event is stale.
                if (time > 150 || (new Date().getTime() - lastMoveEvent.time) > 300) {
                    s.velocity = 0;
                }
            }
            else {
                s.velocity = 0;
            }
            s.velocity = s.velocity * s.freeModeMomentumVelocityRatio;
            velocities.length = 0;
            var momentumDuration = 1000 * s.freeModeMomentumRatio;
            var momentumDistance = s.velocity * momentumDuration;
            var newPosition = s._translate + momentumDistance;
            if (s._rtl)
                newPosition = -newPosition;
            var doBounce = false;
            var afterBouncePosition;
            var bounceAmount = Math.abs(s.velocity) * 20 * s.freeModeMomentumBounceRatio;
            if (newPosition < Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["h" /* maxTranslate */])(s)) {
                if (s.freeModeMomentumBounce) {
                    if (newPosition + Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["h" /* maxTranslate */])(s) < -bounceAmount) {
                        newPosition = Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["h" /* maxTranslate */])(s) - bounceAmount;
                    }
                    afterBouncePosition = Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["h" /* maxTranslate */])(s);
                    doBounce = true;
                    allowMomentumBounce = true;
                }
                else {
                    newPosition = Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["h" /* maxTranslate */])(s);
                }
            }
            else if (newPosition > Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["i" /* minTranslate */])(s)) {
                if (s.freeModeMomentumBounce) {
                    if (newPosition - Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["i" /* minTranslate */])(s) > bounceAmount) {
                        newPosition = Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["i" /* minTranslate */])(s) + bounceAmount;
                    }
                    afterBouncePosition = Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["i" /* minTranslate */])(s);
                    doBounce = true;
                    allowMomentumBounce = true;
                }
                else {
                    newPosition = Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["i" /* minTranslate */])(s);
                }
            }
            else if (s.freeModeSticky) {
                var j = 0;
                var nextSlide;
                for (j = 0; j < s._snapGrid.length; j += 1) {
                    if (s._snapGrid[j] > -newPosition) {
                        nextSlide = j;
                        break;
                    }
                }
                if (Math.abs(s._snapGrid[nextSlide] - newPosition) < Math.abs(s._snapGrid[nextSlide - 1] - newPosition) || s.swipeDirection === 'next') {
                    newPosition = s._snapGrid[nextSlide];
                }
                else {
                    newPosition = s._snapGrid[nextSlide - 1];
                }
                if (!s._rtl)
                    newPosition = -newPosition;
            }
            // Fix duration
            if (s.velocity !== 0) {
                if (s._rtl) {
                    momentumDuration = Math.abs((-newPosition - s._translate) / s.velocity);
                }
                else {
                    momentumDuration = Math.abs((newPosition - s._translate) / s.velocity);
                }
            }
            else if (s.freeModeSticky) {
                Object(__WEBPACK_IMPORTED_MODULE_2__swiper__["j" /* slideReset */])(s, plt);
                return;
            }
            if (s.freeModeMomentumBounce && doBounce) {
                Object(__WEBPACK_IMPORTED_MODULE_3__swiper_progress__["a" /* updateProgress */])(s, afterBouncePosition);
                Object(__WEBPACK_IMPORTED_MODULE_1__swiper_transition__["c" /* setWrapperTransition */])(s, plt, momentumDuration);
                Object(__WEBPACK_IMPORTED_MODULE_1__swiper_transition__["d" /* setWrapperTranslate */])(s, plt, newPosition);
                Object(__WEBPACK_IMPORTED_MODULE_2__swiper__["f" /* onTransitionStart */])(s);
                s._animating = true;
                plt.transitionEnd(s._wrapper, function () {
                    if (!s || !allowMomentumBounce)
                        return;
                    Object(__WEBPACK_IMPORTED_MODULE_1__swiper_transition__["c" /* setWrapperTransition */])(s, plt, s.speed);
                    Object(__WEBPACK_IMPORTED_MODULE_1__swiper_transition__["d" /* setWrapperTranslate */])(s, plt, afterBouncePosition);
                    plt.transitionEnd(s._wrapper, function () {
                        if (!s)
                            return;
                        Object(__WEBPACK_IMPORTED_MODULE_2__swiper__["e" /* onTransitionEnd */])(s, plt);
                    });
                });
            }
            else if (s.velocity) {
                Object(__WEBPACK_IMPORTED_MODULE_3__swiper_progress__["a" /* updateProgress */])(s, newPosition);
                Object(__WEBPACK_IMPORTED_MODULE_1__swiper_transition__["c" /* setWrapperTransition */])(s, plt, momentumDuration);
                Object(__WEBPACK_IMPORTED_MODULE_1__swiper_transition__["d" /* setWrapperTranslate */])(s, plt, newPosition);
                Object(__WEBPACK_IMPORTED_MODULE_2__swiper__["f" /* onTransitionStart */])(s);
                if (!s._animating) {
                    s._animating = true;
                    plt.transitionEnd(s._wrapper, function () {
                        if (!s)
                            return;
                        Object(__WEBPACK_IMPORTED_MODULE_2__swiper__["e" /* onTransitionEnd */])(s, plt);
                    });
                }
            }
            else {
                Object(__WEBPACK_IMPORTED_MODULE_3__swiper_progress__["a" /* updateProgress */])(s, newPosition);
            }
            Object(__WEBPACK_IMPORTED_MODULE_4__swiper_index__["a" /* updateActiveIndex */])(s);
        }
        if (!s.freeModeMomentum || timeDiff >= s.longSwipesMs) {
            Object(__WEBPACK_IMPORTED_MODULE_3__swiper_progress__["a" /* updateProgress */])(s);
            Object(__WEBPACK_IMPORTED_MODULE_4__swiper_index__["a" /* updateActiveIndex */])(s);
        }
        return;
    }
    // Find current slide
    var stopIndex = 0;
    var groupSize = s._slidesSizesGrid[0];
    for (var i = 0; i < s._slidesGrid.length; i += s.slidesPerGroup) {
        if (typeof s._slidesGrid[i + s.slidesPerGroup] !== 'undefined') {
            if (currentPos >= s._slidesGrid[i] && currentPos < s._slidesGrid[i + s.slidesPerGroup]) {
                stopIndex = i;
                groupSize = s._slidesGrid[i + s.slidesPerGroup] - s._slidesGrid[i];
            }
        }
        else {
            if (currentPos >= s._slidesGrid[i]) {
                stopIndex = i;
                groupSize = s._slidesGrid[s._slidesGrid.length - 1] - s._slidesGrid[s._slidesGrid.length - 2];
            }
        }
    }
    // Find current slide size
    var ratio = (currentPos - s._slidesGrid[stopIndex]) / groupSize;
    if (timeDiff > s.longSwipesMs) {
        // Long touches
        if (!s.longSwipes) {
            Object(__WEBPACK_IMPORTED_MODULE_2__swiper__["k" /* slideTo */])(s, plt, s._activeIndex);
            return;
        }
        if (s.swipeDirection === 'next') {
            if (ratio >= s.longSwipesRatio) {
                Object(__WEBPACK_IMPORTED_MODULE_2__swiper__["k" /* slideTo */])(s, plt, stopIndex + s.slidesPerGroup);
            }
            else {
                Object(__WEBPACK_IMPORTED_MODULE_2__swiper__["k" /* slideTo */])(s, plt, stopIndex);
            }
        }
        if (s.swipeDirection === 'prev') {
            if (ratio > (1 - s.longSwipesRatio)) {
                Object(__WEBPACK_IMPORTED_MODULE_2__swiper__["k" /* slideTo */])(s, plt, stopIndex + s.slidesPerGroup);
            }
            else {
                Object(__WEBPACK_IMPORTED_MODULE_2__swiper__["k" /* slideTo */])(s, plt, stopIndex);
            }
        }
    }
    else {
        // Short swipes
        if (!s.shortSwipes) {
            Object(__WEBPACK_IMPORTED_MODULE_2__swiper__["k" /* slideTo */])(s, plt, s._activeIndex);
            return;
        }
        if (s.swipeDirection === 'next') {
            Object(__WEBPACK_IMPORTED_MODULE_2__swiper__["k" /* slideTo */])(s, plt, stopIndex + s.slidesPerGroup);
        }
        if (s.swipeDirection === 'prev') {
            Object(__WEBPACK_IMPORTED_MODULE_2__swiper__["k" /* slideTo */])(s, plt, stopIndex);
        }
    }
}
/*=========================
  Resize Handler
  ===========================*/
var resizeId;
function onResize(s, plt, forceUpdatePagination) {
    // TODO: hacky, we should use Resize Observer in the future
    if (resizeId) {
        plt.cancelTimeout(resizeId);
        resizeId = null;
    }
    resizeId = plt.timeout(function () { return doResize(s, plt, forceUpdatePagination); }, 200);
}
function doResize(s, plt, forceUpdatePagination) {
    resizeId = null;
    // Disable locks on resize
    var allowSwipeToPrev = s._allowSwipeToPrev;
    var allowSwipeToNext = s._allowSwipeToNext;
    s._allowSwipeToPrev = s._allowSwipeToNext = true;
    Object(__WEBPACK_IMPORTED_MODULE_2__swiper__["p" /* updateContainerSize */])(s, plt);
    Object(__WEBPACK_IMPORTED_MODULE_2__swiper__["q" /* updateSlidesSize */])(s, plt);
    if (s.slidesPerView === 'auto' || s.freeMode || forceUpdatePagination) {
        Object(__WEBPACK_IMPORTED_MODULE_5__swiper_pagination__["a" /* updatePagination */])(s);
    }
    if (s._spline) {
        s._spline = undefined;
    }
    var slideChangedBySlideTo = false;
    if (s.freeMode) {
        var newTranslate = Math.min(Math.max(s._translate, Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["h" /* maxTranslate */])(s)), Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["i" /* minTranslate */])(s));
        Object(__WEBPACK_IMPORTED_MODULE_1__swiper_transition__["d" /* setWrapperTranslate */])(s, plt, newTranslate);
        Object(__WEBPACK_IMPORTED_MODULE_4__swiper_index__["a" /* updateActiveIndex */])(s);
        Object(__WEBPACK_IMPORTED_MODULE_6__swiper_classes__["a" /* updateClasses */])(s);
        if (s.autoHeight) {
            Object(__WEBPACK_IMPORTED_MODULE_2__swiper__["o" /* updateAutoHeight */])(s);
        }
    }
    else {
        Object(__WEBPACK_IMPORTED_MODULE_6__swiper_classes__["a" /* updateClasses */])(s);
        if ((s.slidesPerView === 'auto' || s.slidesPerView > 1) && s._isEnd && !s.centeredSlides) {
            slideChangedBySlideTo = Object(__WEBPACK_IMPORTED_MODULE_2__swiper__["k" /* slideTo */])(s, plt, s._slides.length - 1, 0, false, true);
        }
        else {
            slideChangedBySlideTo = Object(__WEBPACK_IMPORTED_MODULE_2__swiper__["k" /* slideTo */])(s, plt, s._activeIndex, 0, false, true);
        }
    }
    // Return locks after resize
    s._allowSwipeToPrev = allowSwipeToPrev;
    s._allowSwipeToNext = allowSwipeToNext;
}
//# sourceMappingURL=swiper-events.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/slides/swiper/swiper-index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = updateActiveIndex;
/* harmony export (immutable) */ __webpack_exports__["b"] = updateRealIndex;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__swiper_classes__ = __webpack_require__("./node_modules/ionic-angular/components/slides/swiper/swiper-classes.js");

function updateActiveIndex(s) {
    var translate = s._rtl ? s._translate : -s._translate;
    var newActiveIndex;
    var i;
    var snapIndex;
    for (i = 0; i < s._slidesGrid.length; i++) {
        if (typeof s._slidesGrid[i + 1] !== 'undefined') {
            if (translate >= s._slidesGrid[i] && translate < s._slidesGrid[i + 1] - (s._slidesGrid[i + 1] - s._slidesGrid[i]) / 2) {
                newActiveIndex = i;
            }
            else if (translate >= s._slidesGrid[i] && translate < s._slidesGrid[i + 1]) {
                newActiveIndex = i + 1;
            }
        }
        else {
            if (translate >= s._slidesGrid[i]) {
                newActiveIndex = i;
            }
        }
    }
    snapIndex = Math.floor(newActiveIndex / s.slidesPerGroup);
    if (snapIndex >= s._snapGrid.length)
        snapIndex = s._snapGrid.length - 1;
    if (newActiveIndex === s._activeIndex) {
        return;
    }
    s._snapIndex = snapIndex;
    s._previousIndex = s._activeIndex;
    s._activeIndex = newActiveIndex;
    Object(__WEBPACK_IMPORTED_MODULE_0__swiper_classes__["a" /* updateClasses */])(s);
    updateRealIndex(s);
}
function updateRealIndex(s) {
    var activeSlide = s._slides[s._activeIndex];
    if (activeSlide) {
        s.realIndex = parseInt(activeSlide.getAttribute('data-swiper-slide-index') || s._activeIndex, 10);
    }
}
//# sourceMappingURL=swiper-index.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/slides/swiper/swiper-keyboard.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = enableKeyboardControl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__swiper_utils__ = __webpack_require__("./node_modules/ionic-angular/components/slides/swiper/swiper-utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__swiper__ = __webpack_require__("./node_modules/ionic-angular/components/slides/swiper/swiper.js");


/*=========================
  Keyboard Control
  ===========================*/
function handleKeyboard(s, plt, e) {
    var win = plt.win();
    var kc = e.keyCode || e.charCode;
    // Directions locks
    if (!s._allowSwipeToNext && (Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["g" /* isHorizontal */])(s) && kc === 39 || !Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["g" /* isHorizontal */])(s) && kc === 40)) {
        return false;
    }
    if (!s._allowSwipeToPrev && (Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["g" /* isHorizontal */])(s) && kc === 37 || !Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["g" /* isHorizontal */])(s) && kc === 38)) {
        return false;
    }
    if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) {
        return;
    }
    var activeEle = plt.getActiveElement();
    if (activeEle && activeEle.nodeName && (activeEle.nodeName.toLowerCase() === 'input' || activeEle.nodeName.toLowerCase() === 'textarea')) {
        return;
    }
    if (kc === 37 || kc === 39 || kc === 38 || kc === 40) {
        var inView = false;
        // Check that swiper should be inside of visible area of window
        if (s.container.closest('.' + __WEBPACK_IMPORTED_MODULE_0__swiper_utils__["a" /* CLS */].slide) && !s.container.closest('.' + __WEBPACK_IMPORTED_MODULE_0__swiper_utils__["a" /* CLS */].slideActive)) {
            return;
        }
        var windowScroll = {
            left: win.pageXOffset,
            top: win.pageYOffset
        };
        var windowWidth = plt.width();
        var windowHeight = plt.height();
        var swiperOffset = Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["j" /* offset */])(s.container, plt);
        if (s._rtl) {
            swiperOffset.left = swiperOffset.left - s.container.scrollLeft;
        }
        var swiperCoord = [
            [swiperOffset.left, swiperOffset.top],
            [swiperOffset.left + s.renderedWidth, swiperOffset.top],
            [swiperOffset.left, swiperOffset.top + s.renderedHeight],
            [swiperOffset.left + s.renderedWidth, swiperOffset.top + s.renderedHeight]
        ];
        for (var i = 0; i < swiperCoord.length; i++) {
            var point = swiperCoord[i];
            if (point[0] >= windowScroll.left && point[0] <= windowScroll.left + windowWidth &&
                point[1] >= windowScroll.top && point[1] <= windowScroll.top + windowHeight) {
                inView = true;
            }
        }
        if (!inView)
            return;
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["g" /* isHorizontal */])(s)) {
        if (kc === 37 || kc === 39) {
            if (e.preventDefault) {
                e.preventDefault();
            }
            else {
                e.returnValue = false;
            }
        }
        if ((kc === 39 && !s._rtl) || (kc === 37 && s._rtl)) {
            Object(__WEBPACK_IMPORTED_MODULE_1__swiper__["h" /* slideNext */])(s, plt);
        }
        if ((kc === 37 && !s._rtl) || (kc === 39 && s._rtl)) {
            Object(__WEBPACK_IMPORTED_MODULE_1__swiper__["i" /* slidePrev */])(s, plt);
        }
    }
    else {
        if (kc === 38 || kc === 40) {
            if (e.preventDefault) {
                e.preventDefault();
            }
            else {
                e.returnValue = false;
            }
        }
        if (kc === 40) {
            Object(__WEBPACK_IMPORTED_MODULE_1__swiper__["h" /* slideNext */])(s, plt);
        }
        if (kc === 38) {
            Object(__WEBPACK_IMPORTED_MODULE_1__swiper__["i" /* slidePrev */])(s, plt);
        }
    }
}
function enableKeyboardControl(s, plt, shouldEnable) {
    if (shouldEnable && !s._keyboardUnReg) {
        s._keyboardUnReg = plt.registerListener(plt.doc(), 'keydown', function (ev) {
            handleKeyboard(s, plt, ev);
        }, { zone: false });
    }
    else if (!shouldEnable && s._keyboardUnReg) {
        s._keyboardUnReg();
    }
}
//# sourceMappingURL=swiper-keyboard.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/slides/swiper/swiper-pagination.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = updatePagination;
/* harmony export (immutable) */ __webpack_exports__["b"] = updatePaginationClasses;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__swiper_utils__ = __webpack_require__("./node_modules/ionic-angular/components/slides/swiper/swiper-utils.js");

/*=========================
  Pagination
  ===========================*/
function updatePagination(s) {
    if (!s.paginationType || !s._paginationContainer)
        return;
    var paginationHTML = '';
    if (s.paginationType === 'bullets') {
        var numberOfBullets = s.loop ? Math.ceil((s._slides.length - s.loopedSlides * 2) / s.slidesPerGroup) : s._snapGrid.length;
        for (var i = 0; i < numberOfBullets; i++) {
            if (s.paginationBulletRender) {
                paginationHTML += s.paginationBulletRender(i, __WEBPACK_IMPORTED_MODULE_0__swiper_utils__["a" /* CLS */].bullet);
            }
            else {
                paginationHTML += "<button class=\"" + __WEBPACK_IMPORTED_MODULE_0__swiper_utils__["a" /* CLS */].bullet + "\" aria-label=\"Go to slide " + (i + 1) + "\" data-slide-index=\"" + i + "\"></button>";
            }
        }
    }
    else if (s.paginationType === 'fraction') {
        paginationHTML =
            '<span class="' + __WEBPACK_IMPORTED_MODULE_0__swiper_utils__["a" /* CLS */].paginationCurrent + '"></span>' +
                ' / ' +
                '<span class="' + __WEBPACK_IMPORTED_MODULE_0__swiper_utils__["a" /* CLS */].paginationTotal + '"></span>';
    }
    else if (s.paginationType === 'progress') {
        paginationHTML = '<span class="' + __WEBPACK_IMPORTED_MODULE_0__swiper_utils__["a" /* CLS */].paginationProgressbar + '"></span>';
    }
    s._paginationContainer.innerHTML = paginationHTML;
    s._bullets = s._paginationContainer.querySelectorAll('.' + __WEBPACK_IMPORTED_MODULE_0__swiper_utils__["a" /* CLS */].bullet);
}
function updatePaginationClasses(s) {
    // Current/Total
    var current;
    var total = s.loop ? Math.ceil((s._slides.length - s.loopedSlides * 2) / s.slidesPerGroup) : s._snapGrid.length;
    if (s.loop) {
        current = Math.ceil((s._activeIndex - s.loopedSlides) / s.slidesPerGroup);
        if (current > s._slides.length - 1 - s.loopedSlides * 2) {
            current = current - (s._slides.length - s.loopedSlides * 2);
        }
        if (current > total - 1) {
            current = current - total;
        }
        if (current < 0 && s.paginationType !== 'bullets') {
            current = total + current;
        }
    }
    else {
        if (typeof s._snapIndex !== 'undefined') {
            current = s._snapIndex;
        }
        else {
            current = s._activeIndex || 0;
        }
    }
    // Types
    if (s.paginationType === 'bullets' && s._bullets) {
        var selector = current + (current < 0 ? s._bullets.length : 0);
        for (var i = 0; i < s._bullets.length; i++) {
            if (i === selector) {
                Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["b" /* addClass */])(s._bullets[i], __WEBPACK_IMPORTED_MODULE_0__swiper_utils__["a" /* CLS */].bulletActive);
            }
            else {
                Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["l" /* removeClass */])(s._bullets[i], __WEBPACK_IMPORTED_MODULE_0__swiper_utils__["a" /* CLS */].bulletActive);
            }
        }
    }
    if (s.paginationType === 'fraction') {
        Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["c" /* eachChild */])(s._paginationContainer, '.' + __WEBPACK_IMPORTED_MODULE_0__swiper_utils__["a" /* CLS */].paginationCurrent, function (ele) {
            ele.textContent = (current + 1);
        });
        Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["c" /* eachChild */])(s._paginationContainer, '.' + __WEBPACK_IMPORTED_MODULE_0__swiper_utils__["a" /* CLS */].paginationTotal, function (ele) {
            ele.textContent = total;
        });
    }
    if (s.paginationType === 'progress') {
        var scale = (current + 1) / total, scaleX = scale, scaleY = 1;
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["g" /* isHorizontal */])(s)) {
            scaleY = scale;
            scaleX = 1;
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["c" /* eachChild */])(s._paginationContainer, '.' + __WEBPACK_IMPORTED_MODULE_0__swiper_utils__["a" /* CLS */].paginationProgressbar, function (ele) {
            Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["n" /* transform */])(ele, 'translate3d(0,0,0) scaleX(' + scaleX + ') scaleY(' + scaleY + ')');
            Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["o" /* transition */])(ele, s.speed);
        });
    }
}
//# sourceMappingURL=swiper-pagination.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/slides/swiper/swiper-parallax.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = parallaxSetTranslate;
/* harmony export (immutable) */ __webpack_exports__["a"] = parallaxSetTransition;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__swiper_utils__ = __webpack_require__("./node_modules/ionic-angular/components/slides/swiper/swiper-utils.js");

/*=========================
  Parallax
  ===========================*/
function setParallaxTransform(s, el, progress) {
    var p;
    var pX;
    var pY;
    var rtlFactor = s._rtl ? -1 : 1;
    p = el.getAttribute('data-swiper-parallax') || '0';
    pX = el.getAttribute('data-swiper-parallax-x');
    pY = el.getAttribute('data-swiper-parallax-y');
    if (pX || pY) {
        pX = pX || '0';
        pY = pY || '0';
    }
    else {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["g" /* isHorizontal */])(s)) {
            pX = p;
            pY = '0';
        }
        else {
            pY = p;
            pX = '0';
        }
    }
    if ((pX).indexOf('%') >= 0) {
        pX = parseInt(pX, 10) * progress * rtlFactor + '%';
    }
    else {
        pX = pX * progress * rtlFactor + 'px';
    }
    if ((pY).indexOf('%') >= 0) {
        pY = parseInt(pY, 10) * progress + '%';
    }
    else {
        pY = pY * progress + 'px';
    }
    Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["n" /* transform */])(el, 'translate3d(' + pX + ', ' + pY + ',0px)');
}
function parallaxSetTranslate(s) {
    Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["c" /* eachChild */])(s.container, '[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]', function (el) {
        setParallaxTransform(s, el, s.progress);
    });
    for (var i = 0; i < s._slides.length; i++) {
        var slide = s._slides[i];
        Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["c" /* eachChild */])(slide, '[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]', function () {
            var progress = Math.min(Math.max(slide.progress, -1), 1);
            setParallaxTransform(s, slide, progress);
        });
    }
}
function parallaxSetTransition(s, duration) {
    if (typeof duration === 'undefined')
        duration = s.speed;
    Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["c" /* eachChild */])(s.container, '[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]', function (el) {
        var parallaxDuration = parseInt(el.getAttribute('data-swiper-parallax-duration'), 10) || duration;
        if (duration === 0)
            parallaxDuration = 0;
        Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["o" /* transition */])(el, parallaxDuration);
    });
}
//# sourceMappingURL=swiper-parallax.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/slides/swiper/swiper-progress.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = updateProgress;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__swiper_utils__ = __webpack_require__("./node_modules/ionic-angular/components/slides/swiper/swiper-utils.js");

function updateProgress(s, translate) {
    if (typeof translate === 'undefined') {
        translate = s._translate || 0;
    }
    var translatesDiff = Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["h" /* maxTranslate */])(s) - Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["i" /* minTranslate */])(s);
    var wasBeginning = s._isBeginning;
    var wasEnd = s._isEnd;
    if (translatesDiff === 0) {
        s.progress = 0;
        s._isBeginning = s._isEnd = true;
    }
    else {
        s.progress = (translate - Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["i" /* minTranslate */])(s)) / (translatesDiff);
        s._isBeginning = s.progress <= 0;
        s._isEnd = s.progress >= 1;
    }
    s._zone.run(function () {
        if (s._isBeginning && !wasBeginning) {
            s.ionSlideReachStart.emit();
        }
        if (s._isEnd && !wasEnd) {
            s.ionSlideReachEnd.emit();
        }
        if (s.watchSlidesProgress) {
            updateSlidesProgress(s, translate);
        }
        s.ionSlideProgress.emit(s.progress);
    });
}
function updateSlidesProgress(s, translate) {
    if (typeof translate === 'undefined') {
        translate = s._translate || 0;
    }
    if (s._slides.length === 0)
        return;
    if (typeof s._slides[0].swiperSlideOffset === 'undefined') {
        Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["q" /* updateSlidesOffset */])(s);
    }
    var offsetCenter = -translate;
    if (s._rtl)
        offsetCenter = translate;
    // Visible Slides
    Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["l" /* removeClass */])(s._slides, __WEBPACK_IMPORTED_MODULE_0__swiper_utils__["a" /* CLS */].slideVisible);
    for (var i = 0; i < s._slides.length; i++) {
        var slide = s._slides[i];
        var slideProgress = (offsetCenter + (s.centeredSlides ? Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["i" /* minTranslate */])(s) : 0) - slide.swiperSlideOffset) / (slide.swiperSlideSize + s.spaceBetween);
        if (s.watchSlidesVisibility) {
            var slideBefore = -(offsetCenter - slide.swiperSlideOffset);
            var slideAfter = slideBefore + s._slidesSizesGrid[i];
            var isVisible = (slideBefore >= 0 && slideBefore < s._renderedSize) ||
                (slideAfter > 0 && slideAfter <= s._renderedSize) ||
                (slideBefore <= 0 && slideAfter >= s._renderedSize);
            if (isVisible) {
                s._slides[i].classList.add(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["a" /* CLS */].slideVisible);
            }
        }
        slide.progress = s._rtl ? -slideProgress : slideProgress;
    }
}
//# sourceMappingURL=swiper-progress.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/slides/swiper/swiper-transition.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = setWrapperTranslate;
/* harmony export (immutable) */ __webpack_exports__["a"] = getTranslate;
/* harmony export (immutable) */ __webpack_exports__["b"] = getWrapperTranslate;
/* harmony export (immutable) */ __webpack_exports__["c"] = setWrapperTransition;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__swiper_utils__ = __webpack_require__("./node_modules/ionic-angular/components/slides/swiper/swiper-utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__swiper_parallax__ = __webpack_require__("./node_modules/ionic-angular/components/slides/swiper/swiper-parallax.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__swiper_progress__ = __webpack_require__("./node_modules/ionic-angular/components/slides/swiper/swiper-progress.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__swiper_index__ = __webpack_require__("./node_modules/ionic-angular/components/slides/swiper/swiper-index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__swiper_controller__ = __webpack_require__("./node_modules/ionic-angular/components/slides/swiper/swiper-controller.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__swiper_effects__ = __webpack_require__("./node_modules/ionic-angular/components/slides/swiper/swiper-effects.js");






function setWrapperTranslate(s, plt, translate, shouldUpdateActiveIndex, byController) {
    var x = 0, y = 0, z = 0;
    if (Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["g" /* isHorizontal */])(s)) {
        x = s._rtl ? -translate : translate;
    }
    else {
        y = translate;
    }
    if (s.roundLengths) {
        x = Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["m" /* round */])(x);
        y = Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["m" /* round */])(y);
    }
    if (!s.virtualTranslate) {
        Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["n" /* transform */])(s._wrapper, 'translate3d(' + x + 'px, ' + y + 'px, ' + z + 'px)');
    }
    s._translate = Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["g" /* isHorizontal */])(s) ? x : y;
    // Check if we need to update progress
    var progress;
    var translatesDiff = Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["h" /* maxTranslate */])(s) - Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["i" /* minTranslate */])(s);
    if (translatesDiff === 0) {
        progress = 0;
    }
    else {
        progress = (translate - Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["i" /* minTranslate */])(s)) / (translatesDiff);
    }
    if (progress !== s.progress) {
        Object(__WEBPACK_IMPORTED_MODULE_2__swiper_progress__["a" /* updateProgress */])(s, translate);
    }
    if (shouldUpdateActiveIndex) {
        Object(__WEBPACK_IMPORTED_MODULE_3__swiper_index__["a" /* updateActiveIndex */])(s);
    }
    if (s.effect !== 'slide' && __WEBPACK_IMPORTED_MODULE_5__swiper_effects__["a" /* SWIPER_EFFECTS */][s.effect]) {
        __WEBPACK_IMPORTED_MODULE_5__swiper_effects__["a" /* SWIPER_EFFECTS */][s.effect].setTranslate(s, plt);
    }
    if (s.parallax) {
        Object(__WEBPACK_IMPORTED_MODULE_1__swiper_parallax__["b" /* parallaxSetTranslate */])(s);
    }
    if (s.control) {
        __WEBPACK_IMPORTED_MODULE_4__swiper_controller__["a" /* SWIPER_CONTROLLER */].setTranslate(s, plt, s._translate, byController, setWrapperTranslate);
    }
}
function getTranslate(s, plt, el, axis) {
    var win = plt.win();
    var matrix;
    var curTransform;
    var curStyle;
    var transformMatrix;
    // automatic axis detection
    if (typeof axis === 'undefined') {
        axis = 'x';
    }
    if (s.virtualTranslate) {
        return s._rtl ? -s._translate : s._translate;
    }
    curStyle = plt.getElementComputedStyle(el);
    if (win.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
        if (curTransform.split(',').length > 6) {
            curTransform = curTransform.split(', ').map(function (a) {
                return a.replace(',', '.');
            }).join(', ');
        }
        // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case
        transformMatrix = new win.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
    }
    else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
        matrix = transformMatrix.toString().split(',');
    }
    if (axis === 'x') {
        if (win.WebKitCSSMatrix) {
            // Latest Chrome and webkits Fix
            curTransform = transformMatrix.m41;
        }
        else if (matrix.length === 16) {
            // Crazy IE10 Matrix
            curTransform = parseFloat(matrix[12]);
        }
        else {
            // Normal Browsers
            curTransform = parseFloat(matrix[4]);
        }
    }
    if (axis === 'y') {
        if (win.WebKitCSSMatrix) {
            // Latest Chrome and webkits Fix
            curTransform = transformMatrix.m42;
        }
        else if (matrix.length === 16) {
            // Crazy IE10 Matrix
            curTransform = parseFloat(matrix[13]);
        }
        else {
            // Normal Browsers
            curTransform = parseFloat(matrix[5]);
        }
    }
    if (s._rtl && curTransform) {
        curTransform = -curTransform;
    }
    return curTransform || 0;
}
function getWrapperTranslate(s, plt, axis) {
    if (typeof axis === 'undefined') {
        axis = Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["g" /* isHorizontal */])(s) ? 'x' : 'y';
    }
    return getTranslate(s, plt, s._wrapper, axis);
}
function setWrapperTransition(s, plt, duration, byController) {
    Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["o" /* transition */])(s._wrapper, duration);
    if (s.effect !== 'slide' && __WEBPACK_IMPORTED_MODULE_5__swiper_effects__["a" /* SWIPER_EFFECTS */][s.effect]) {
        __WEBPACK_IMPORTED_MODULE_5__swiper_effects__["a" /* SWIPER_EFFECTS */][s.effect].setTransition(s, plt, duration);
    }
    if (s.parallax) {
        Object(__WEBPACK_IMPORTED_MODULE_1__swiper_parallax__["a" /* parallaxSetTransition */])(s, duration);
    }
    if (s.control) {
        __WEBPACK_IMPORTED_MODULE_4__swiper_controller__["a" /* SWIPER_CONTROLLER */].setTransition(s, plt, duration, byController, setWrapperTransition);
    }
}
//# sourceMappingURL=swiper-transition.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/slides/swiper/swiper-utils.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["m"] = round;
/* harmony export (immutable) */ __webpack_exports__["e"] = inlineStyle;
/* harmony export (immutable) */ __webpack_exports__["b"] = addClass;
/* harmony export (immutable) */ __webpack_exports__["l"] = removeClass;
/* harmony export (immutable) */ __webpack_exports__["d"] = getElementIndex;
/* harmony export (immutable) */ __webpack_exports__["k"] = queryChildren;
/* harmony export (immutable) */ __webpack_exports__["c"] = eachChild;
/* harmony export (immutable) */ __webpack_exports__["n"] = transform;
/* harmony export (immutable) */ __webpack_exports__["o"] = transition;
/* harmony export (immutable) */ __webpack_exports__["p"] = triggerTransitionEnd;
/* harmony export (immutable) */ __webpack_exports__["j"] = offset;
/* harmony export (immutable) */ __webpack_exports__["q"] = updateSlidesOffset;
/* harmony export (immutable) */ __webpack_exports__["g"] = isHorizontal;
/* harmony export (immutable) */ __webpack_exports__["f"] = isFormElement;
/* harmony export (immutable) */ __webpack_exports__["i"] = minTranslate;
/* harmony export (immutable) */ __webpack_exports__["h"] = maxTranslate;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLS; });
function round(a) {
    return Math.floor(a);
}
function inlineStyle(ele, styles) {
    if (ele) {
        if (ele.length) {
            for (var i = 0; i < ele.length; i++) {
                inlineStyle(ele[i], styles);
            }
        }
        else if (ele.nodeType) {
            var cssProps = Object.keys(styles);
            for (var i_1 = 0; i_1 < cssProps.length; i_1++) {
                ele.style[cssProps[i_1]] = styles[cssProps[i_1]];
            }
        }
    }
}
function addClass(ele, className) {
    if (ele) {
        if (ele.length) {
            for (var i = 0; i < ele.length; i++) {
                addClass(ele[i], className);
            }
        }
        else if (ele.nodeType) {
            if (Array.isArray(className)) {
                className.forEach(function (cls) {
                    ele.classList.add(cls);
                });
            }
            else {
                ele.classList.add(className);
            }
        }
    }
}
function removeClass(ele, className) {
    if (ele) {
        if (ele.length) {
            for (var i = 0; i < ele.length; i++) {
                removeClass(ele[i], className);
            }
        }
        else if (ele.nodeType) {
            if (Array.isArray(className)) {
                className.forEach(function (cls) {
                    ele.classList.remove(cls);
                });
            }
            else {
                ele.classList.remove(className);
            }
        }
    }
}
function getElementIndex(ele) {
    var i = 0;
    if (ele) {
        while ((ele = ele.previousSibling) !== null) {
            if (ele.nodeType === 1)
                i++;
        }
    }
    return i;
}
function queryChildren(parentEle, query) {
    if (parentEle) {
        return parentEle.querySelectorAll(query);
    }
    return [];
}
function eachChild(parentEle, query, callback) {
    if (parentEle) {
        var nodes = parentEle.querySelectorAll(query);
        for (var i = 0; i < nodes.length; i++) {
            callback(nodes[i]);
        }
    }
}
function transform(ele, val) {
    if (ele) {
        var elStyle = ele.style;
        elStyle.webkitTransform = elStyle.MsTransform = elStyle.msTransform = elStyle.transform = val;
    }
}
function transition(ele, duration) {
    if (ele) {
        if (typeof duration !== 'string') {
            duration = duration + 'ms';
        }
        var elStyle = ele.style;
        elStyle.webkitTransitionDuration = elStyle.MsTransitionDuration = elStyle.msTransitionDuration = elStyle.transitionDuration = duration;
    }
}
function triggerTransitionEnd(plt, ele) {
    try {
        var win = plt.win();
        var evt = new win.CustomEvent('transitionend', { bubbles: true, cancelable: true });
        ele.dispatchEvent(evt);
    }
    catch (e) { }
}
function offset(ele, plt) {
    if (ele) {
        var box = plt.getElementBoundingClientRect(ele);
        var body = plt.doc().body;
        var win = plt.win();
        var clientTop = ele.clientTop || body.clientTop || 0;
        var clientLeft = ele.clientLeft || body.clientLeft || 0;
        var scrollTop = win.pageYOffset || ele.scrollTop;
        var scrollLeft = win.pageXOffset || ele.scrollLeft;
        return {
            top: box.top + scrollTop - clientTop,
            left: box.left + scrollLeft - clientLeft
        };
    }
    return null;
}
function updateSlidesOffset(s) {
    for (var i = 0; i < s._slides.length; i++) {
        s._slides[i].swiperSlideOffset = isHorizontal(s) ? s._slides[i].offsetLeft : s._slides[i].offsetTop;
    }
}
function isHorizontal(s) {
    return s.direction === 'horizontal';
}
var formElements = ['INPUT', 'SELECT', 'TEXTAREA', 'BUTTON', 'VIDEO'];
function isFormElement(el) {
    return !!el && formElements.indexOf(el.tagName) > -1;
}
/*=========================
  Min/Max Translate
  ===========================*/
function minTranslate(s) {
    return (-s._snapGrid[0]);
}
function maxTranslate(s) {
    return (-s._snapGrid[s._snapGrid.length - 1]);
}
var CLS = {
    // Classnames
    noSwiping: 'swiper-no-swiping',
    containerModifier: 'swiper-container-',
    slide: 'swiper-slide',
    slideActive: 'swiper-slide-active',
    slideDuplicateActive: 'swiper-slide-duplicate-active',
    slideVisible: 'swiper-slide-visible',
    slideDuplicate: 'swiper-slide-duplicate',
    slideNext: 'swiper-slide-next',
    slideDuplicateNext: 'swiper-slide-duplicate-next',
    slidePrev: 'swiper-slide-prev',
    slideDuplicatePrev: 'swiper-slide-duplicate-prev',
    wrapper: 'swiper-wrapper',
    bullet: 'swiper-pagination-bullet',
    bulletActive: 'swiper-pagination-bullet-active',
    buttonDisabled: 'swiper-button-disabled',
    paginationCurrent: 'swiper-pagination-current',
    paginationTotal: 'swiper-pagination-total',
    paginationHidden: 'swiper-pagination-hidden',
    paginationProgressbar: 'swiper-pagination-progressbar',
    paginationClickable: 'swiper-pagination-clickable',
    paginationModifier: 'swiper-pagination-',
    lazyLoading: 'swiper-lazy',
    lazyStatusLoading: 'swiper-lazy-loading',
    lazyStatusLoaded: 'swiper-lazy-loaded',
    lazyPreloader: 'swiper-lazy-preloader',
    notification: 'swiper-notification',
    preloader: 'preloader',
    zoomContainer: 'swiper-zoom-container',
};
//# sourceMappingURL=swiper-utils.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/slides/swiper/swiper-zoom.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initZoom;
/* harmony export (immutable) */ __webpack_exports__["b"] = resetZoomEvents;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__swiper_utils__ = __webpack_require__("./node_modules/ionic-angular/components/slides/swiper/swiper-utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__swiper_transition__ = __webpack_require__("./node_modules/ionic-angular/components/slides/swiper/swiper-transition.js");


function initZoom(s, plt) {
    s._supportGestures = ('ongesturestart' in plt.win());
    s._zoom = {
        // "Global" Props
        scale: 1,
        currentScale: 1,
        isScaling: false,
        gesture: {
            slide: undefined,
            slideWidth: undefined,
            slideHeight: undefined,
            image: undefined,
            imageWrap: undefined,
            zoomMax: s.zoomMax
        },
        image: {
            isTouched: undefined,
            isMoved: undefined,
            currentX: undefined,
            currentY: undefined,
            minX: undefined,
            minY: undefined,
            maxX: undefined,
            maxY: undefined,
            width: undefined,
            height: undefined,
            startX: undefined,
            startY: undefined,
            touchesStart: {},
            touchesCurrent: {}
        },
        velocity: {
            x: undefined,
            y: undefined,
            prevPositionX: undefined,
            prevPositionY: undefined,
            prevTime: undefined
        },
        unRegs: []
    };
    resetZoomEvents(s, plt);
    return function () {
        detachZoomEvents(s);
    };
}
// Calc Scale From Multi-touches
function getDistanceBetweenTouches(ev) {
    if (ev.targetTouches.length < 2)
        return 1;
    var x1 = ev.targetTouches[0].pageX, y1 = ev.targetTouches[0].pageY, x2 = ev.targetTouches[1].pageX, y2 = ev.targetTouches[1].pageY;
    return Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
}
// Events
function onGestureStart(s, _plt, ev) {
    var z = s._zoom;
    s.originalEvent = ev;
    if (!s._supportGestures) {
        if (ev.type !== 'touchstart' || ev.type === 'touchstart' && ev.targetTouches.length < 2) {
            return;
        }
        z.gesture.scaleStart = getDistanceBetweenTouches(ev);
    }
    if (!z.gesture.slide) {
        if (ev.currentTarget && ev.currentTarget.classList.contains(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["a" /* CLS */].slide)) {
            z.gesture.slide = ev.currentTarget;
        }
        if (!z.gesture.slide) {
            z.gesture.slide = s._slides[s._activeIndex];
        }
        z.gesture.image = z.gesture.slide.querySelector('img, svg, canvas, ion-img');
        if (z.gesture.image) {
            z.gesture.imageWrap = z.gesture.image.closest('.' + __WEBPACK_IMPORTED_MODULE_0__swiper_utils__["a" /* CLS */].zoomContainer);
            if (!z.gesture.imageWrap) {
                z.gesture.image = undefined;
                return;
            }
            z.gesture.zoomMax = parseInt(z.gesture.imageWrap.getAttribute('data-swiper-zoom') || s.zoomMax, 10);
        }
    }
    Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["o" /* transition */])(z.gesture.image, 0);
    z.isScaling = true;
}
function onGestureChange(s, _plt, ev) {
    var z = s._zoom;
    s.originalEvent = ev;
    if (!s._supportGestures) {
        if (ev.type !== 'touchmove' || ev.type === 'touchmove' && ev.targetTouches.length < 2) {
            return;
        }
        z.gesture.scaleMove = getDistanceBetweenTouches(ev);
    }
    if (!z.gesture.image)
        return;
    if (s._supportGestures) {
        z.scale = ev.scale * z.currentScale;
    }
    else {
        z.scale = (z.gesture.scaleMove / z.gesture.scaleStart) * z.currentScale;
    }
    if (z.scale > z.gesture.zoomMax) {
        z.scale = z.gesture.zoomMax - 1 + Math.pow((z.scale - z.gesture.zoomMax + 1), 0.5);
    }
    if (z.scale < s.zoomMin) {
        z.scale = s.zoomMin + 1 - Math.pow((s.zoomMin - z.scale + 1), 0.5);
    }
    Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["n" /* transform */])(z.gesture.image, 'translate3d(0,0,0) scale(' + z.scale + ')');
}
function onGestureEnd(s, _plt, ev) {
    var z = s._zoom;
    s.originalEvent = ev;
    if (!s._supportGestures) {
        if (ev.type !== 'touchend' || ev.type === 'touchend' && ev.changedTouches.length < 2) {
            return;
        }
    }
    if (!z.gesture.image)
        return;
    z.scale = Math.max(Math.min(z.scale, z.gesture.zoomMax), s.zoomMin);
    Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["o" /* transition */])(z.gesture.image, s.speed);
    Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["n" /* transform */])(z.gesture.image, 'translate3d(0,0,0) scale(' + z.scale + ')');
    z.currentScale = z.scale;
    z.isScaling = false;
    if (z.scale === 1) {
        z.gesture.slide = undefined;
    }
}
function onTouchStart(s, plt, ev) {
    var z = s._zoom;
    s.originalEvent = ev;
    if (!z.gesture.image || z.image.isTouched)
        return;
    if (plt.is('android')) {
        ev.preventDefault();
    }
    z.image.isTouched = true;
    z.image.touchesStart.x = ev.type === 'touchstart' ? ev.targetTouches[0].pageX : ev.pageX;
    z.image.touchesStart.y = ev.type === 'touchstart' ? ev.targetTouches[0].pageY : ev.pageY;
}
function onTouchMove(s, plt, ev) {
    var z = s._zoom;
    s.originalEvent = ev;
    if (!z.gesture.image)
        return;
    s._allowClick = false;
    if (!z.image.isTouched || !z.gesture.slide)
        return;
    if (!z.image.isMoved) {
        z.image.width = z.gesture.image.offsetWidth;
        z.image.height = z.gesture.image.offsetHeight;
        z.image.startX = Object(__WEBPACK_IMPORTED_MODULE_1__swiper_transition__["a" /* getTranslate */])(s, plt, z.gesture.imageWrap, 'x') || 0;
        z.image.startY = Object(__WEBPACK_IMPORTED_MODULE_1__swiper_transition__["a" /* getTranslate */])(s, plt, z.gesture.imageWrap, 'y') || 0;
        z.gesture.slideWidth = z.gesture.slide.offsetWidth;
        z.gesture.slideHeight = z.gesture.slide.offsetHeight;
        Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["o" /* transition */])(z.gesture.imageWrap, 0);
        if (s._rtl) {
            z.image.startX = -z.image.startX;
            z.image.startY = -z.image.startY;
        }
    }
    // Define if we need image drag
    var scaledWidth = z.image.width * z.scale;
    var scaledHeight = z.image.height * z.scale;
    if (scaledWidth < z.gesture.slideWidth && scaledHeight < z.gesture.slideHeight) {
        return;
    }
    z.image.minX = Math.min((z.gesture.slideWidth / 2 - scaledWidth / 2), 0);
    z.image.maxX = -z.image.minX;
    z.image.minY = Math.min((z.gesture.slideHeight / 2 - scaledHeight / 2), 0);
    z.image.maxY = -z.image.minY;
    z.image.touchesCurrent.x = ev.type === 'touchmove' ? ev.targetTouches[0].pageX : ev.pageX;
    z.image.touchesCurrent.y = ev.type === 'touchmove' ? ev.targetTouches[0].pageY : ev.pageY;
    if (!z.image.isMoved && !z.isScaling) {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["g" /* isHorizontal */])(s) &&
            (Math.floor(z.image.minX) === Math.floor(z.image.startX) && z.image.touchesCurrent.x < z.image.touchesStart.x) ||
            (Math.floor(z.image.maxX) === Math.floor(z.image.startX) && z.image.touchesCurrent.x > z.image.touchesStart.x)) {
            z.image.isTouched = false;
            return;
        }
        else if (!Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["g" /* isHorizontal */])(s) &&
            (Math.floor(z.image.minY) === Math.floor(z.image.startY) && z.image.touchesCurrent.y < z.image.touchesStart.y) ||
            (Math.floor(z.image.maxY) === Math.floor(z.image.startY) && z.image.touchesCurrent.y > z.image.touchesStart.y)) {
            z.image.isTouched = false;
            return;
        }
    }
    ev.preventDefault();
    ev.stopPropagation();
    z.image.isMoved = true;
    z.image.currentX = z.image.touchesCurrent.x - z.image.touchesStart.x + z.image.startX;
    z.image.currentY = z.image.touchesCurrent.y - z.image.touchesStart.y + z.image.startY;
    if (z.image.currentX < z.image.minX) {
        z.image.currentX = z.image.minX + 1 - Math.pow((z.image.minX - z.image.currentX + 1), 0.8);
    }
    if (z.image.currentX > z.image.maxX) {
        z.image.currentX = z.image.maxX - 1 + Math.pow((z.image.currentX - z.image.maxX + 1), 0.8);
    }
    if (z.image.currentY < z.image.minY) {
        z.image.currentY = z.image.minY + 1 - Math.pow((z.image.minY - z.image.currentY + 1), 0.8);
    }
    if (z.image.currentY > z.image.maxY) {
        z.image.currentY = z.image.maxY - 1 + Math.pow((z.image.currentY - z.image.maxY + 1), 0.8);
    }
    // Velocity
    if (!z.velocity.prevPositionX)
        z.velocity.prevPositionX = z.image.touchesCurrent.x;
    if (!z.velocity.prevPositionY)
        z.velocity.prevPositionY = z.image.touchesCurrent.y;
    if (!z.velocity.prevTime)
        z.velocity.prevTime = Date.now();
    z.velocity.x = (z.image.touchesCurrent.x - z.velocity.prevPositionX) / (Date.now() - z.velocity.prevTime) / 2;
    z.velocity.y = (z.image.touchesCurrent.y - z.velocity.prevPositionY) / (Date.now() - z.velocity.prevTime) / 2;
    if (Math.abs(z.image.touchesCurrent.x - z.velocity.prevPositionX) < 2)
        z.velocity.x = 0;
    if (Math.abs(z.image.touchesCurrent.y - z.velocity.prevPositionY) < 2)
        z.velocity.y = 0;
    z.velocity.prevPositionX = z.image.touchesCurrent.x;
    z.velocity.prevPositionY = z.image.touchesCurrent.y;
    z.velocity.prevTime = Date.now();
    Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["n" /* transform */])(z.gesture.imageWrap, 'translate3d(' + z.image.currentX + 'px, ' + z.image.currentY + 'px,0)');
}
function onTouchEnd(s) {
    var z = s._zoom;
    if (!z.gesture.image)
        return;
    if (!z.image.isTouched || !z.image.isMoved) {
        z.image.isTouched = false;
        z.image.isMoved = false;
        return;
    }
    z.image.isTouched = false;
    z.image.isMoved = false;
    var momentumDurationX = 300;
    var momentumDurationY = 300;
    var momentumDistanceX = z.velocity.x * momentumDurationX;
    var newPositionX = z.image.currentX + momentumDistanceX;
    var momentumDistanceY = z.velocity.y * momentumDurationY;
    var newPositionY = z.image.currentY + momentumDistanceY;
    // Fix duration
    if (z.velocity.x !== 0)
        momentumDurationX = Math.abs((newPositionX - z.image.currentX) / z.velocity.x);
    if (z.velocity.y !== 0)
        momentumDurationY = Math.abs((newPositionY - z.image.currentY) / z.velocity.y);
    var momentumDuration = Math.max(momentumDurationX, momentumDurationY);
    z.image.currentX = newPositionX;
    z.image.currentY = newPositionY;
    // Define if we need image drag
    var scaledWidth = z.image.width * z.scale;
    var scaledHeight = z.image.height * z.scale;
    z.image.minX = Math.min((z.gesture.slideWidth / 2 - scaledWidth / 2), 0);
    z.image.maxX = -z.image.minX;
    z.image.minY = Math.min((z.gesture.slideHeight / 2 - scaledHeight / 2), 0);
    z.image.maxY = -z.image.minY;
    z.image.currentX = Math.max(Math.min(z.image.currentX, z.image.maxX), z.image.minX);
    z.image.currentY = Math.max(Math.min(z.image.currentY, z.image.maxY), z.image.minY);
    Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["o" /* transition */])(z.gesture.imageWrap, momentumDuration);
    Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["n" /* transform */])(z.gesture.imageWrap, 'translate3d(' + z.image.currentX + 'px, ' + z.image.currentY + 'px,0)');
}
function onTransitionEnd(s) {
    var z = s._zoom;
    if (z.gesture.slide && s._previousIndex !== s._activeIndex) {
        Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["n" /* transform */])(z.gesture.image, 'translate3d(0,0,0) scale(1)');
        Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["n" /* transform */])(z.gesture.imageWrap, 'translate3d(0,0,0)');
        z.gesture.slide = z.gesture.image = z.gesture.imageWrap = undefined;
        z.scale = z.currentScale = 1;
    }
}
function toggleZoom(s, plt) {
    var z = s._zoom;
    var ev = s.originalEvent;
    if (!z.gesture.slide) {
        z.gesture.slide = s.clickedSlide ? s.clickedSlide : s._slides[s._activeIndex];
        z.gesture.image = z.gesture.slide.querySelector('img, svg, canvas, ion-img');
        z.gesture.imageWrap = z.gesture.image && z.gesture.image.closest('.' + __WEBPACK_IMPORTED_MODULE_0__swiper_utils__["a" /* CLS */].zoomContainer);
    }
    if (!z.gesture.imageWrap)
        return;
    var touchX;
    var touchY;
    var offsetX;
    var offsetY;
    var diffX;
    var diffY;
    var translateX;
    var translateY;
    var imageWidth;
    var imageHeight;
    var scaledWidth;
    var scaledHeight;
    var translateMinX;
    var translateMinY;
    var translateMaxX;
    var translateMaxY;
    var slideWidth;
    var slideHeight;
    if (typeof z.image.touchesStart.x === 'undefined' && ev) {
        touchX = ev.type === 'touchend' ? ev.changedTouches[0].pageX : ev.pageX;
        touchY = ev.type === 'touchend' ? ev.changedTouches[0].pageY : ev.pageY;
    }
    else {
        touchX = z.image.touchesStart.x;
        touchY = z.image.touchesStart.y;
    }
    if (z.scale && z.scale !== 1) {
        // Zoom Out
        z.scale = z.currentScale = 1;
        Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["o" /* transition */])(z.gesture.imageWrap, 300);
        Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["n" /* transform */])(z.gesture.imageWrap, 'translate3d(0,0,0)');
        Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["o" /* transition */])(z.gesture.image, 300);
        Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["n" /* transform */])(z.gesture.image, 'translate3d(0,0,0) scale(1)');
        z.gesture.slide = undefined;
    }
    else {
        // Zoom In
        z.scale = z.currentScale = parseInt(z.gesture.imageWrap.getAttribute('data-swiper-zoom') || s.zoomMax, 10);
        if (ev) {
            slideWidth = z.gesture.slide.offsetWidth;
            slideHeight = z.gesture.slide.offsetHeight;
            var slideOffsets = Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["j" /* offset */])(z.gesture.slide, plt);
            offsetX = slideOffsets.left;
            offsetY = slideOffsets.top;
            diffX = offsetX + slideWidth / 2 - touchX;
            diffY = offsetY + slideHeight / 2 - touchY;
            imageWidth = z.gesture.image.offsetWidth;
            imageHeight = z.gesture.image.offsetHeight;
            scaledWidth = imageWidth * z.scale;
            scaledHeight = imageHeight * z.scale;
            translateMinX = Math.min((slideWidth / 2 - scaledWidth / 2), 0);
            translateMinY = Math.min((slideHeight / 2 - scaledHeight / 2), 0);
            translateMaxX = -translateMinX;
            translateMaxY = -translateMinY;
            translateX = diffX * z.scale;
            translateY = diffY * z.scale;
            if (translateX < translateMinX) {
                translateX = translateMinX;
            }
            if (translateX > translateMaxX) {
                translateX = translateMaxX;
            }
            if (translateY < translateMinY) {
                translateY = translateMinY;
            }
            if (translateY > translateMaxY) {
                translateY = translateMaxY;
            }
        }
        else {
            translateX = 0;
            translateY = 0;
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["o" /* transition */])(z.gesture.imageWrap, 300);
        Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["n" /* transform */])(z.gesture.imageWrap, 'translate3d(' + translateX + 'px, ' + translateY + 'px,0)');
        Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["o" /* transition */])(z.gesture.image, 300);
        Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["n" /* transform */])(z.gesture.image, 'translate3d(0,0,0) scale(' + z.scale + ')');
    }
}
function resetZoomEvents(s, plt) {
    detachZoomEvents(s);
    var unRegs = s._zoom.unRegs;
    var evtOpts = { passive: s._touchEvents.start === 'touchstart', zone: false };
    var slides = s._slides;
    var slide;
    // Scale image
    if (s._supportGestures) {
        for (var i = 0; i < slides.length; i++) {
            slide = slides[i];
            // gesturestart
            plt.registerListener(slide, 'gesturestart', function (ev) {
                onGestureStart(s, plt, ev);
            }, evtOpts, unRegs);
            // gesturechange
            plt.registerListener(slide, 'gesturechange', function (ev) {
                onGestureChange(s, plt, ev);
            }, evtOpts, unRegs);
            // gestureend
            plt.registerListener(slide, 'gestureend', function (ev) {
                onGestureEnd(s, plt, ev);
            }, evtOpts, unRegs);
        }
    }
    else if (s._touchEvents.start === 'touchstart') {
        for (var i = 0; i < slides.length; i++) {
            slide = slides[i];
            // touchstart
            plt.registerListener(slide, s._touchEvents.start, function (ev) {
                onGestureStart(s, plt, ev);
            }, evtOpts, unRegs);
            // touchmove
            plt.registerListener(slide, s._touchEvents.move, function (ev) {
                onGestureChange(s, plt, ev);
            }, evtOpts, unRegs);
            // touchend
            plt.registerListener(slide, s._touchEvents.end, function (ev) {
                onGestureEnd(s, plt, ev);
            }, evtOpts, unRegs);
        }
    }
    // Move image
    var touchStartSub = s.ionSlideTouchStart.subscribe(function (ev) {
        onTouchStart(s, plt, ev);
    });
    unRegs.push(function () { touchStartSub.unsubscribe(); });
    for (var i = 0; i < slides.length; i++) {
        slide = slides[i];
        if (slide.querySelector('.' + __WEBPACK_IMPORTED_MODULE_0__swiper_utils__["a" /* CLS */].zoomContainer)) {
            plt.registerListener(slide, 's.touchEvents.move', function (ev) {
                onTouchMove(s, plt, ev);
            }, evtOpts, unRegs);
        }
    }
    var touchEndSub = s.ionSlideTouchEnd.subscribe(function () {
        onTouchEnd(s);
    });
    unRegs.push(function () { touchEndSub.unsubscribe(); });
    // Scale Out
    var transEndSub = s.ionSlideTouchEnd.subscribe(function () {
        onTransitionEnd(s);
    });
    unRegs.push(function () { transEndSub.unsubscribe(); });
    if (s.zoomToggle) {
        var doubleTapSub = s.ionSlideDoubleTap.subscribe(function () {
            toggleZoom(s, plt);
        });
        unRegs.push(function () { doubleTapSub.unsubscribe(); });
    }
}
function detachZoomEvents(s) {
    s._zoom.unRegs.forEach(function (unReg) {
        unReg();
    });
    s._zoom.unRegs.length = 0;
}
//# sourceMappingURL=swiper-zoom.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/slides/swiper/swiper.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = initSwiper;
/* harmony export (immutable) */ __webpack_exports__["l"] = startAutoplay;
/* harmony export (immutable) */ __webpack_exports__["m"] = stopAutoplay;
/* harmony export (immutable) */ __webpack_exports__["g"] = pauseAutoplay;
/* harmony export (immutable) */ __webpack_exports__["o"] = updateAutoHeight;
/* harmony export (immutable) */ __webpack_exports__["p"] = updateContainerSize;
/* harmony export (immutable) */ __webpack_exports__["q"] = updateSlidesSize;
/* harmony export (immutable) */ __webpack_exports__["a"] = currentSlidesPerView;
/* harmony export (immutable) */ __webpack_exports__["n"] = update;
/* harmony export (immutable) */ __webpack_exports__["c"] = fixLoop;
/* harmony export (immutable) */ __webpack_exports__["k"] = slideTo;
/* harmony export (immutable) */ __webpack_exports__["f"] = onTransitionStart;
/* harmony export (immutable) */ __webpack_exports__["e"] = onTransitionEnd;
/* harmony export (immutable) */ __webpack_exports__["h"] = slideNext;
/* harmony export (immutable) */ __webpack_exports__["i"] = slidePrev;
/* harmony export (immutable) */ __webpack_exports__["j"] = slideReset;
/* unused harmony export disableTouchControl */
/* unused harmony export enableTouchControl */
/* harmony export (immutable) */ __webpack_exports__["b"] = destroySwiper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__swiper_utils__ = __webpack_require__("./node_modules/ionic-angular/components/slides/swiper/swiper-utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__swiper_transition__ = __webpack_require__("./node_modules/ionic-angular/components/slides/swiper/swiper-transition.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__swiper_progress__ = __webpack_require__("./node_modules/ionic-angular/components/slides/swiper/swiper-progress.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__swiper_classes__ = __webpack_require__("./node_modules/ionic-angular/components/slides/swiper/swiper-classes.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__swiper_parallax__ = __webpack_require__("./node_modules/ionic-angular/components/slides/swiper/swiper-parallax.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__swiper_index__ = __webpack_require__("./node_modules/ionic-angular/components/slides/swiper/swiper-index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__swiper_effects__ = __webpack_require__("./node_modules/ionic-angular/components/slides/swiper/swiper-effects.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__swiper_pagination__ = __webpack_require__("./node_modules/ionic-angular/components/slides/swiper/swiper-pagination.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__swiper_zoom__ = __webpack_require__("./node_modules/ionic-angular/components/slides/swiper/swiper-zoom.js");
/**
 * Adopted from Swiper
 * Most modern mobile touch slider and framework with hardware
 * accelerated transitions.
 *
 * http://www.idangero.us/swiper/
 *
 * Copyright 2016, Vladimir Kharlampidi
 * The iDangero.us
 * http://www.idangero.us/
 *
 * Licensed under MIT
 */









function initSwiper(s, plt) {
    // Classname
    s._classNames = [];
    /*=========================
      Preparation - Define Container, Wrapper and Pagination
      ===========================*/
    if (!s.container) {
        return;
    }
    // Save instance in container HTML Element and in data
    s.container.swiper = s;
    var containerModifierClass = __WEBPACK_IMPORTED_MODULE_0__swiper_utils__["a" /* CLS */].containerModifier;
    s._classNames.push(containerModifierClass + s.direction);
    if (s.freeMode) {
        s._classNames.push(containerModifierClass + 'free-mode');
    }
    if (s.autoHeight) {
        s._classNames.push(containerModifierClass + 'autoheight');
    }
    // Enable slides progress when required
    if (s.parallax || s.watchSlidesVisibility) {
        s.watchSlidesProgress = true;
    }
    // Max resistance when touchReleaseOnEdges
    if (s.touchReleaseOnEdges) {
        s.resistanceRatio = 0;
    }
    var effect = s.effect;
    // Coverflow / 3D
    if (['cube', 'coverflow', 'flip'].indexOf(effect) >= 0) {
        s.watchSlidesProgress = true;
        s._classNames.push(containerModifierClass + '3d');
    }
    if (effect !== 'slide') {
        s._classNames.push(containerModifierClass + effect);
    }
    if (effect === 'cube') {
        s.resistanceRatio = 0;
        s.slidesPerView = 1;
        s.slidesPerColumn = 1;
        s.slidesPerGroup = 1;
        s.centeredSlides = false;
        s.spaceBetween = 0;
        s.virtualTranslate = true;
        s.setWrapperSize = false;
    }
    if (effect === 'fade' || effect === 'flip') {
        s.slidesPerView = 1;
        s.slidesPerColumn = 1;
        s.slidesPerGroup = 1;
        s.watchSlidesProgress = true;
        s.spaceBetween = 0;
        s.setWrapperSize = false;
        s.virtualTranslate = true;
    }
    // Wrapper
    s._wrapper = s.container.querySelector('.' + __WEBPACK_IMPORTED_MODULE_0__swiper_utils__["a" /* CLS */].wrapper);
    // Pagination
    if (s.paginationType) {
        s._paginationContainer = s.container.querySelector('.swiper-pagination');
        if (s.paginationType === 'bullets') {
            s._paginationContainer.classList.add(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["a" /* CLS */].paginationModifier + 'clickable');
        }
        s._paginationContainer.classList.add(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["a" /* CLS */].paginationModifier + s.paginationType);
    }
    // Next/Prev Buttons
    // if (s.nextButton || s.prevButton) {
    //   if (s.nextButton) {
    //     s.nextButton = <any>s.container.closest('ion-content').querySelector(s.nextButton);
    //   }
    //   if (s.prevButton) {
    //     s.prevButton = <any>s.container.closest('ion-content').querySelector(s.prevButton);
    //   }
    // }
    // RTL
    s._rtl = Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["g" /* isHorizontal */])(s) && (s.container.dir.toLowerCase() === 'rtl' || s.container.style.direction === 'rtl');
    if (s._rtl) {
        s._classNames.push(containerModifierClass + 'rtl');
    }
    // Columns
    if (s.slidesPerColumn > 1) {
        s._classNames.push(containerModifierClass + 'multirow');
    }
    // Check for Android
    if (plt.is('android')) {
        s._classNames.push(containerModifierClass + 'android');
    }
    // Add classes
    s._classNames.forEach(function (clsName) {
        s.container.classList.add(clsName);
    });
    // Translate
    s._translate = 0;
    // Progress
    s.progress = 0;
    // Velocity
    s.velocity = 0;
    /*=========================
      Autoplay
      ===========================*/
    s._autoplayTimeoutId = undefined;
    s._autoplaying = false;
    s._autoplayPaused = false;
    s._allowClick = true;
    // Animating Flag
    s._animating = false;
    // Touches information
    s._touches = {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
    };
    if (s.loop) {
        createLoop(s);
    }
    updateContainerSize(s, plt);
    updateSlidesSize(s, plt);
    Object(__WEBPACK_IMPORTED_MODULE_7__swiper_pagination__["a" /* updatePagination */])(s);
    if (effect !== 'slide' && __WEBPACK_IMPORTED_MODULE_6__swiper_effects__["a" /* SWIPER_EFFECTS */][effect]) {
        if (!s.loop) {
            Object(__WEBPACK_IMPORTED_MODULE_2__swiper_progress__["a" /* updateProgress */])(s);
        }
        __WEBPACK_IMPORTED_MODULE_6__swiper_effects__["a" /* SWIPER_EFFECTS */][effect].setTranslate(s, plt);
    }
    if (s.loop) {
        slideTo(s, plt, s.initialSlide + s.loopedSlides, 0, s.runCallbacksOnInit);
    }
    else {
        slideTo(s, plt, s.initialSlide, 0, s.runCallbacksOnInit);
        if (s.initialSlide === 0) {
            Object(__WEBPACK_IMPORTED_MODULE_4__swiper_parallax__["b" /* parallaxSetTranslate */])(s);
        }
    }
    if (s.autoplay) {
        startAutoplay(s, plt);
    }
}
/*=========================
  Autoplay
  ===========================*/
function autoplay(s, plt) {
    var autoplayDelay = s.autoplay;
    var activeSlide = s._slides[s._activeIndex];
    if (activeSlide.hasAttribute('data-swiper-autoplay')) {
        autoplayDelay = (activeSlide.getAttribute('data-swiper-autoplay') || s.autoplay);
    }
    s._autoplayTimeoutId = plt.timeout(function () {
        s._zone.run(function () {
            if (s.loop) {
                fixLoop(s, plt);
                slideNext(s, plt, true, undefined, true);
                s.ionSlideAutoplay.emit(s);
            }
            else {
                if (!s._isEnd) {
                    slideNext(s, plt, true, undefined, true);
                    s.ionSlideAutoplay.emit(s);
                }
                else {
                    if (!s.autoplayStopOnLast) {
                        slideTo(s, plt, 0);
                        s.ionSlideAutoplay.emit(s);
                    }
                    else {
                        stopAutoplay(s);
                    }
                }
            }
        });
    }, autoplayDelay);
}
function startAutoplay(s, plt) {
    if (typeof s._autoplayTimeoutId !== 'undefined')
        return false;
    if (!s.autoplay || s._autoplaying) {
        return false;
    }
    s._autoplaying = true;
    s._zone.run(function () {
        s.ionSlideAutoplayStart.emit(s);
    });
    autoplay(s, plt);
}
function stopAutoplay(s) {
    if (!s._autoplayTimeoutId)
        return;
    if (s._autoplayTimeoutId)
        clearTimeout(s._autoplayTimeoutId);
    s._autoplaying = false;
    s._autoplayTimeoutId = undefined;
    s._zone.run(function () {
        s.ionSlideAutoplayStop.emit(s);
    });
}
function pauseAutoplay(s, plt, speed) {
    if (s._autoplayPaused)
        return;
    if (s._autoplayTimeoutId)
        clearTimeout(s._autoplayTimeoutId);
    s._autoplayPaused = true;
    if (speed === 0) {
        s._autoplayPaused = false;
        autoplay(s, plt);
    }
    else {
        plt.transitionEnd(s._wrapper, function () {
            if (!s)
                return;
            s._autoplayPaused = false;
            if (!s._autoplaying) {
                stopAutoplay(s);
            }
            else {
                autoplay(s, plt);
            }
        });
    }
}
/*=========================
  Slider/slides sizes
  ===========================*/
function updateAutoHeight(s) {
    var activeSlides = [];
    var newHeight = 0;
    var i;
    // Find slides currently in view
    if (s.slidesPerView !== 'auto' && s.slidesPerView > 1) {
        for (i = 0; i < Math.ceil(s.slidesPerView); i++) {
            var index = s._activeIndex + i;
            if (index > s._slides.length)
                break;
            activeSlides.push(s._slides[index]);
        }
    }
    else {
        activeSlides.push(s._slides[s._activeIndex]);
    }
    // Find new height from heighest slide in view
    for (i = 0; i < activeSlides.length; i++) {
        if (typeof activeSlides[i] !== 'undefined') {
            var height = activeSlides[i].offsetHeight;
            newHeight = height > newHeight ? height : newHeight;
        }
    }
    // Update Height
    if (newHeight) {
        s._wrapper.style.height = newHeight + 'px';
    }
}
function updateContainerSize(s, plt) {
    var container = s.container;
    var width;
    var height;
    if (typeof s.width !== 'undefined') {
        // manually assign user width
        width = s.width;
    }
    else {
        width = container.clientWidth;
    }
    if (typeof s.renderedHeight !== 'undefined') {
        // manually assign user height
        height = s.renderedHeight;
    }
    else {
        height = container.clientHeight;
    }
    if (width === 0 && Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["g" /* isHorizontal */])(s) || height === 0 && !Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["g" /* isHorizontal */])(s)) {
        return;
    }
    // Subtract paddings
    var containerStyles = plt.getElementComputedStyle(container);
    width = width - parseInt(containerStyles.paddingLeft, 10) - parseInt(containerStyles.paddingRight, 10);
    height = height - parseInt(containerStyles.paddingTop, 10) - parseInt(containerStyles.paddingBottom, 10);
    // Store values
    s.renderedWidth = width;
    s.renderedHeight = height;
    s._renderedSize = Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["g" /* isHorizontal */])(s) ? width : height;
}
function updateSlidesSize(s, plt) {
    s._slides = s._wrapper.querySelectorAll('.' + __WEBPACK_IMPORTED_MODULE_0__swiper_utils__["a" /* CLS */].slide);
    s._snapGrid = [];
    s._slidesGrid = [];
    s._slidesSizesGrid = [];
    var spaceBetween = s.spaceBetween;
    var slidePosition = -s.slidesOffsetBefore;
    var i;
    var prevSlideSize = 0;
    var index = 0;
    if (typeof s._renderedSize === 'undefined')
        return;
    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
        spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * s._renderedSize;
    }
    s._virtualSize = -spaceBetween;
    // reset margins
    if (s._rtl) {
        Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["e" /* inlineStyle */])(s._slides, { marginLeft: '', marginTop: '' });
    }
    else {
        Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["e" /* inlineStyle */])(s._slides, { marginRight: '', marginBottom: '' });
    }
    var slidesNumberEvenToRows;
    if (s.slidesPerColumn > 1) {
        if (Math.floor(s._slides.length / s.slidesPerColumn) === s._slides.length / s.slidesPerColumn) {
            slidesNumberEvenToRows = s._slides.length;
        }
        else {
            slidesNumberEvenToRows = Math.ceil(s._slides.length / s.slidesPerColumn) * s.slidesPerColumn;
        }
        if (s.slidesPerView !== 'auto' && s.slidesPerColumnFill === 'row') {
            slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, s.slidesPerView * s.slidesPerColumn);
        }
    }
    // Calc slides
    var slideSize;
    var slidesPerColumn = s.slidesPerColumn;
    var slidesPerRow = slidesNumberEvenToRows / slidesPerColumn;
    var numFullColumns = slidesPerRow - (s.slidesPerColumn * slidesPerRow - s._slides.length);
    for (i = 0; i < s._slides.length; i++) {
        slideSize = 0;
        var slide = s._slides[i];
        if (s.slidesPerColumn > 1) {
            // Set slides order
            var newSlideOrderIndex;
            var column;
            var row;
            if (s.slidesPerColumnFill === 'column') {
                column = Math.floor(i / slidesPerColumn);
                row = i - column * slidesPerColumn;
                if (column > numFullColumns || (column === numFullColumns && row === slidesPerColumn - 1)) {
                    if (++row >= slidesPerColumn) {
                        row = 0;
                        column++;
                    }
                }
                newSlideOrderIndex = column + row * slidesNumberEvenToRows / slidesPerColumn;
                Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["e" /* inlineStyle */])(slide, {
                    '-webkit-box-ordinal-group': newSlideOrderIndex,
                    '-moz-box-ordinal-group': newSlideOrderIndex,
                    '-ms-flex-order': newSlideOrderIndex,
                    '-webkit-order': newSlideOrderIndex,
                    'order': newSlideOrderIndex
                });
            }
            else {
                row = Math.floor(i / slidesPerRow);
                column = i - row * slidesPerRow;
            }
            var cssVal = (row !== 0 && s.spaceBetween) && (s.spaceBetween + 'px');
            var cssObj = {};
            if (Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["g" /* isHorizontal */])(s)) {
                cssObj['marginTop'] = cssVal;
            }
            else {
                cssObj['marginLeft'] = cssVal;
            }
            Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["e" /* inlineStyle */])(slide, cssObj);
            slide.setAttribute('data-swiper-column', column);
            slide.setAttribute('data-swiper-row', row);
        }
        if (slide.style.display === 'none') {
            continue;
        }
        if (s.slidesPerView === 'auto') {
            var styles = plt.getElementComputedStyle(slide);
            if (Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["g" /* isHorizontal */])(s)) {
                slideSize = slide.offsetWidth + parseFloat(styles.marginRight) + parseFloat(styles.marginLeft);
            }
            else {
                slideSize = slide.offsetHeight + parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
            }
            if (s.roundLengths)
                slideSize = Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["m" /* round */])(slideSize);
        }
        else {
            slideSize = (s._renderedSize - (s.slidesPerView - 1) * spaceBetween) / s.slidesPerView;
            if (s.roundLengths)
                slideSize = Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["m" /* round */])(slideSize);
            if (Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["g" /* isHorizontal */])(s)) {
                s._slides[i].style.width = slideSize + 'px';
            }
            else {
                s._slides[i].style.height = slideSize + 'px';
            }
        }
        s._slides[i].swiperSlideSize = slideSize;
        s._slidesSizesGrid.push(slideSize);
        if (s.centeredSlides) {
            slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
            if (i === 0)
                slidePosition = slidePosition - s._renderedSize / 2 - spaceBetween;
            if (Math.abs(slidePosition) < 1 / 1000)
                slidePosition = 0;
            if ((index) % s.slidesPerGroup === 0)
                s._snapGrid.push(slidePosition);
            s._slidesGrid.push(slidePosition);
        }
        else {
            if ((index) % s.slidesPerGroup === 0)
                s._snapGrid.push(slidePosition);
            s._slidesGrid.push(slidePosition);
            slidePosition = slidePosition + slideSize + spaceBetween;
        }
        s._virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        index++;
    }
    s._virtualSize = Math.max(s._virtualSize, s._renderedSize) + s.slidesOffsetAfter;
    var newSlidesGrid;
    if (s._rtl && (s.effect === 'slide' || s.effect === 'coverflow')) {
        Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["e" /* inlineStyle */])(s._wrapper, { width: s._virtualSize + s.spaceBetween + 'px' });
    }
    if (s.setWrapperSize) {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["g" /* isHorizontal */])(s)) {
            Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["e" /* inlineStyle */])(s._wrapper, { width: s._virtualSize + s.spaceBetween + 'px' });
        }
        else {
            Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["e" /* inlineStyle */])(s._wrapper, { height: s._virtualSize + s.spaceBetween + 'px' });
        }
    }
    if (s.slidesPerColumn > 1) {
        s._virtualSize = (slideSize + s.spaceBetween) * slidesNumberEvenToRows;
        s._virtualSize = Math.ceil(s._virtualSize / s.slidesPerColumn) - s.spaceBetween;
        if (Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["g" /* isHorizontal */])(s)) {
            Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["e" /* inlineStyle */])(s._wrapper, { width: s._virtualSize + s.spaceBetween + 'px' });
        }
        else {
            Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["e" /* inlineStyle */])(s._wrapper, { height: s._virtualSize + s.spaceBetween + 'px' });
        }
        if (s.centeredSlides) {
            newSlidesGrid = [];
            for (i = 0; i < s._snapGrid.length; i++) {
                if (s._snapGrid[i] < s._virtualSize + s._snapGrid[0])
                    newSlidesGrid.push(s._snapGrid[i]);
            }
            s._snapGrid = newSlidesGrid;
        }
    }
    // Remove last grid elements depending on width
    if (!s.centeredSlides) {
        newSlidesGrid = [];
        for (i = 0; i < s._snapGrid.length; i++) {
            if (s._snapGrid[i] <= s._virtualSize - s._renderedSize) {
                newSlidesGrid.push(s._snapGrid[i]);
            }
        }
        s._snapGrid = newSlidesGrid;
        if (Math.floor(s._virtualSize - s._renderedSize) - Math.floor(s._snapGrid[s._snapGrid.length - 1]) > 1) {
            s._snapGrid.push(s._virtualSize - s._renderedSize);
        }
    }
    if (s._snapGrid.length === 0)
        s._snapGrid = [0];
    if (s.spaceBetween !== 0) {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["g" /* isHorizontal */])(s)) {
            if (s._rtl) {
                Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["e" /* inlineStyle */])(s._slides, { marginLeft: spaceBetween + 'px' });
            }
            else {
                Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["e" /* inlineStyle */])(s._slides, { marginRight: spaceBetween + 'px' });
            }
        }
        else {
            Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["e" /* inlineStyle */])(s._slides, { marginBottom: spaceBetween + 'px' });
        }
    }
    if (s.watchSlidesProgress) {
        Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["q" /* updateSlidesOffset */])(s);
    }
}
/*=========================
  Dynamic Slides Per View
  ===========================*/
function currentSlidesPerView(s) {
    var spv = 1;
    var i;
    var j;
    if (s.centeredSlides) {
        var size = s._slides[s._activeIndex].swiperSlideSize;
        var breakLoop;
        for (i = s._activeIndex + 1; i < s._slides.length; i++) {
            if (s._slides[i] && !breakLoop) {
                size += s._slides[i].swiperSlideSize;
                spv++;
                if (size > s._renderedSize)
                    breakLoop = true;
            }
        }
        for (j = s._activeIndex - 1; j >= 0; j--) {
            if (s._slides[j] && !breakLoop) {
                size += s._slides[j].swiperSlideSize;
                spv++;
                if (size > s._renderedSize)
                    breakLoop = true;
            }
        }
    }
    else {
        for (i = s._activeIndex + 1; i < s._slides.length; i++) {
            if (s._slidesGrid[i] - s._slidesGrid[s._activeIndex] < s._renderedSize) {
                spv++;
            }
        }
    }
    return spv;
}
/*=========================
  Common update method
  ===========================*/
function update(s, plt, updateTranslate) {
    if (!s)
        return;
    updateContainerSize(s, plt);
    updateSlidesSize(s, plt);
    Object(__WEBPACK_IMPORTED_MODULE_2__swiper_progress__["a" /* updateProgress */])(s);
    Object(__WEBPACK_IMPORTED_MODULE_7__swiper_pagination__["a" /* updatePagination */])(s);
    Object(__WEBPACK_IMPORTED_MODULE_3__swiper_classes__["a" /* updateClasses */])(s);
    if (s.zoom) {
        Object(__WEBPACK_IMPORTED_MODULE_8__swiper_zoom__["b" /* resetZoomEvents */])(s, plt);
    }
    var translated;
    var newTranslate;
    function forceSetTranslate() {
        newTranslate = Math.min(Math.max(s._translate, Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["h" /* maxTranslate */])(s)), Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["i" /* minTranslate */])(s));
        Object(__WEBPACK_IMPORTED_MODULE_1__swiper_transition__["d" /* setWrapperTranslate */])(s, plt, newTranslate);
        Object(__WEBPACK_IMPORTED_MODULE_5__swiper_index__["a" /* updateActiveIndex */])(s);
        Object(__WEBPACK_IMPORTED_MODULE_3__swiper_classes__["a" /* updateClasses */])(s);
    }
    if (updateTranslate) {
        if (s._spline) {
            s._spline = undefined;
        }
        if (s.freeMode) {
            forceSetTranslate();
            if (s.autoHeight) {
                updateAutoHeight(s);
            }
        }
        else {
            if ((s.slidesPerView === 'auto' || s.slidesPerView > 1) && s._isEnd && !s.centeredSlides) {
                translated = slideTo(s, plt, s._slides.length - 1, 0, false, true);
            }
            else {
                translated = slideTo(s, plt, s._activeIndex, 0, false, true);
            }
            if (!translated) {
                forceSetTranslate();
            }
        }
    }
    else if (s.autoHeight) {
        updateAutoHeight(s);
    }
}
/*=========================
  Loop
  ===========================*/
// Create looped slides
function createLoop(s) {
    // Remove duplicated slides
    Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["c" /* eachChild */])(s._wrapper, '.' + __WEBPACK_IMPORTED_MODULE_0__swiper_utils__["a" /* CLS */].slide + '.' + __WEBPACK_IMPORTED_MODULE_0__swiper_utils__["a" /* CLS */].slideDuplicate, function (ele) {
        ele.parentElement.removeChild(ele);
    });
    var slides = s._wrapper.querySelectorAll('.' + __WEBPACK_IMPORTED_MODULE_0__swiper_utils__["a" /* CLS */].slide);
    if (s.slidesPerView === 'auto' && !s.loopedSlides) {
        s.loopedSlides = slides.length;
    }
    s.loopedSlides = parseInt((s.loopedSlides || s.slidesPerView), 10);
    s.loopedSlides = s.loopedSlides + s.loopAdditionalSlides;
    if (s.loopedSlides > slides.length) {
        s.loopedSlides = slides.length;
    }
    var prependSlides = [];
    var appendSlides = [];
    for (var i = 0; i < slides.length; i++) {
        var slide = slides[i];
        if (i < s.loopedSlides)
            appendSlides.push(slide);
        if (i < slides.length && i >= slides.length - s.loopedSlides)
            prependSlides.push(slide);
        slide.setAttribute('data-swiper-slide-index', i);
    }
    for (i = 0; i < appendSlides.length; i++) {
        var appendClone = appendSlides[i].cloneNode(true);
        Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["b" /* addClass */])(appendClone, __WEBPACK_IMPORTED_MODULE_0__swiper_utils__["a" /* CLS */].slideDuplicate);
        s._wrapper.appendChild(appendClone);
    }
    for (i = prependSlides.length - 1; i >= 0; i--) {
        var prependClone = prependSlides[i].cloneNode(true);
        Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["b" /* addClass */])(prependClone, __WEBPACK_IMPORTED_MODULE_0__swiper_utils__["a" /* CLS */].slideDuplicate);
        s._wrapper.insertBefore(prependClone, s._wrapper.firstElementChild);
    }
}
function destroyLoop(s) {
    Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["c" /* eachChild */])(s._wrapper, '.' + __WEBPACK_IMPORTED_MODULE_0__swiper_utils__["a" /* CLS */].slide + '.' + __WEBPACK_IMPORTED_MODULE_0__swiper_utils__["a" /* CLS */].slideDuplicate, function (ele) {
        ele.parentElement.removeChild(ele);
    });
    if (s._slides) {
        for (var i = 0; i < s._slides.length; i++) {
            s._slides[i].removeAttribute('data-swiper-slide-index');
        }
    }
}
function fixLoop(s, plt) {
    var newIndex;
    if (s._activeIndex < s.loopedSlides) {
        // Fix For Negative Oversliding
        newIndex = s._slides.length - s.loopedSlides * 3 + s._activeIndex;
        newIndex = newIndex + s.loopedSlides;
        slideTo(s, plt, newIndex, 0, false, true);
    }
    else if ((s.slidesPerView === 'auto' && s._activeIndex >= s.loopedSlides * 2) || (s._activeIndex > s._slides.length - s.slidesPerView * 2)) {
        // Fix For Positive Oversliding
        newIndex = -s._slides.length + s._activeIndex + s.loopedSlides;
        newIndex = newIndex + s.loopedSlides;
        slideTo(s, plt, newIndex, 0, false, true);
    }
}
/*=========================
  Transitions
  ===========================*/
function slideTo(s, plt, slideIndex, speed, runCallbacks, internal) {
    if (runCallbacks === void 0) { runCallbacks = true; }
    if (typeof slideIndex === 'undefined')
        slideIndex = 0;
    if (slideIndex < 0)
        slideIndex = 0;
    s._snapIndex = Math.floor(slideIndex / s.slidesPerGroup);
    if (s._snapIndex >= s._snapGrid.length)
        s._snapIndex = s._snapGrid.length - 1;
    var translate = -s._snapGrid[s._snapIndex];
    // Stop autoplay
    if (s.autoplay && s._autoplaying) {
        if (internal || !s.autoplayDisableOnInteraction) {
            pauseAutoplay(s, plt, speed);
        }
        else {
            stopAutoplay(s);
        }
    }
    // Update progress
    Object(__WEBPACK_IMPORTED_MODULE_2__swiper_progress__["a" /* updateProgress */])(s, translate);
    // Directions locks
    if (!s._allowSwipeToNext && translate < s._translate && translate < Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["i" /* minTranslate */])(s)) {
        return false;
    }
    if (!s._allowSwipeToPrev && translate > s._translate && translate > Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["h" /* maxTranslate */])(s)) {
        if ((s._activeIndex || 0) !== slideIndex)
            return false;
    }
    // Update Index
    if (typeof speed === 'undefined')
        speed = s.speed;
    s._previousIndex = s._activeIndex || 0;
    s._activeIndex = slideIndex;
    Object(__WEBPACK_IMPORTED_MODULE_5__swiper_index__["b" /* updateRealIndex */])(s);
    if ((s._rtl && -translate === s._translate) || (!s._rtl && translate === s._translate)) {
        // Update Height
        if (s.autoHeight) {
            updateAutoHeight(s);
        }
        Object(__WEBPACK_IMPORTED_MODULE_3__swiper_classes__["a" /* updateClasses */])(s);
        if (s.effect !== 'slide') {
            Object(__WEBPACK_IMPORTED_MODULE_1__swiper_transition__["d" /* setWrapperTranslate */])(s, plt, translate);
        }
        return false;
    }
    Object(__WEBPACK_IMPORTED_MODULE_3__swiper_classes__["a" /* updateClasses */])(s);
    onTransitionStart(s, runCallbacks);
    if (speed === 0) {
        Object(__WEBPACK_IMPORTED_MODULE_1__swiper_transition__["d" /* setWrapperTranslate */])(s, plt, translate);
        Object(__WEBPACK_IMPORTED_MODULE_1__swiper_transition__["c" /* setWrapperTransition */])(s, plt, 0);
        onTransitionEnd(s, plt, runCallbacks);
    }
    else {
        Object(__WEBPACK_IMPORTED_MODULE_1__swiper_transition__["d" /* setWrapperTranslate */])(s, plt, translate);
        Object(__WEBPACK_IMPORTED_MODULE_1__swiper_transition__["c" /* setWrapperTransition */])(s, plt, speed);
        if (!s._animating) {
            s._animating = true;
            plt.transitionEnd(s._wrapper, function () {
                if (!s)
                    return;
                onTransitionEnd(s, plt, runCallbacks);
            });
        }
    }
    return true;
}
function onTransitionStart(s, runCallbacks) {
    if (runCallbacks === void 0) { runCallbacks = true; }
    if (s.autoHeight) {
        updateAutoHeight(s);
    }
    if (runCallbacks) {
        s._zone.run(function () {
            s.ionSlideTransitionStart.emit(s);
            if (s._activeIndex !== s._previousIndex) {
                s.ionSlideWillChange.emit(s);
                if (s._activeIndex > s._previousIndex) {
                    s.ionSlideNextStart.emit(s);
                }
                else {
                    s.ionSlidePrevStart.emit(s);
                }
            }
        });
    }
}
function onTransitionEnd(s, plt, runCallbacks) {
    if (runCallbacks === void 0) { runCallbacks = true; }
    s._animating = false;
    Object(__WEBPACK_IMPORTED_MODULE_1__swiper_transition__["c" /* setWrapperTransition */])(s, plt, 0);
    if (runCallbacks) {
        s._zone.run(function () {
            s.ionSlideTransitionEnd.emit(s);
            if (s._activeIndex !== s._previousIndex) {
                s.ionSlideDidChange.emit(s);
                if (s._activeIndex > s._previousIndex) {
                    s.ionSlideNextEnd.emit(s);
                }
                else {
                    s.ionSlidePrevEnd.emit(s);
                }
            }
        });
    }
}
function slideNext(s, plt, runCallbacks, speed, internal) {
    if (s.loop) {
        if (s._animating)
            return false;
        fixLoop(s, plt);
        s.container.clientLeft;
        return slideTo(s, plt, s._activeIndex + s.slidesPerGroup, speed, runCallbacks, internal);
    }
    var nextSlide = s._activeIndex + s.slidesPerGroup;
    if (nextSlide < s._slides.length) {
        return slideTo(s, plt, nextSlide, speed, runCallbacks, internal);
    }
    return false;
}
function slidePrev(s, plt, runCallbacks, speed, internal) {
    if (s.loop) {
        if (s._animating)
            return false;
        fixLoop(s, plt);
        s.container.clientLeft;
        return slideTo(s, plt, s._activeIndex - 1, speed, runCallbacks, internal);
    }
    var previousSlide = s._activeIndex - 1;
    if (previousSlide >= 0) {
        return slideTo(s, plt, s._activeIndex - 1, speed, runCallbacks, internal);
    }
    return false;
}
function slideReset(s, plt, runCallbacks, speed) {
    return slideTo(s, plt, s._activeIndex, speed, runCallbacks, true);
}
function disableTouchControl(s) {
    s.onlyExternal = true;
    return true;
}
function enableTouchControl(s) {
    s.onlyExternal = false;
    return true;
}
/*=========================
  Translate/transition helpers
  ===========================*/
// Cleanup dynamic styles
function cleanupStyles(s) {
    if (!s.container || !s._wrapper) {
        // fix #10830
        return;
    }
    // Container
    if (s.container) {
        Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["l" /* removeClass */])(s.container, s._classNames);
        s.container.removeAttribute('style');
    }
    // Wrapper
    s._wrapper.removeAttribute('style');
    // Slides
    if (s._slides && s._slides.length) {
        Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["l" /* removeClass */])(s._slides, [
            __WEBPACK_IMPORTED_MODULE_0__swiper_utils__["a" /* CLS */].slideVisible,
            __WEBPACK_IMPORTED_MODULE_0__swiper_utils__["a" /* CLS */].slideActive,
            __WEBPACK_IMPORTED_MODULE_0__swiper_utils__["a" /* CLS */].slideNext,
            __WEBPACK_IMPORTED_MODULE_0__swiper_utils__["a" /* CLS */].slidePrev
        ]);
        for (var i = 0; i < s._slides.length; i++) {
            var slide = s._slides[i];
            slide.removeAttribute('style');
            slide.removeAttribute('data-swiper-column');
            slide.removeAttribute('data-swiper-row');
        }
    }
    // Pagination/Bullets
    Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["l" /* removeClass */])(s._bullets, __WEBPACK_IMPORTED_MODULE_0__swiper_utils__["a" /* CLS */].bulletActive);
    // Buttons
    Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["l" /* removeClass */])(s.prevButton, __WEBPACK_IMPORTED_MODULE_0__swiper_utils__["a" /* CLS */].buttonDisabled);
    Object(__WEBPACK_IMPORTED_MODULE_0__swiper_utils__["l" /* removeClass */])(s.nextButton, __WEBPACK_IMPORTED_MODULE_0__swiper_utils__["a" /* CLS */].buttonDisabled);
}
// Destroy
function destroySwiper(s) {
    // Stop autoplay
    stopAutoplay(s);
    // Destroy loop
    if (s.loop) {
        destroyLoop(s);
    }
    // Cleanup styles
    cleanupStyles(s);
}
//# sourceMappingURL=swiper.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/spinner/spinner.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Spinner; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ion__ = __webpack_require__("./node_modules/ionic-angular/components/ion.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




/**
 * @name Spinner
 * @description
 * The `ion-spinner` component provides a variety of animated SVG spinners.
 * Spinners enables you to give users feedback that the app is actively
 * processing/thinking/waiting/chillin’ out, or whatever you’d like it to indicate.
 * By default, the `ion-refresher` feature uses this spinner component while it's
 * the refresher is in the `refreshing` state.
 *
 * Ionic offers a handful of spinners out of the box, and by default, it will use
 * the appropriate spinner for the platform on which it’s running.
 *
 * <table class="table spinner-table">
 *  <tr>
 *    <th>
 *      <code>ios</code>
 *    </th>
 *    <td>
 *      <ion-spinner name="ios"></ion-spinner>
 *    </td>
 *  </tr>
 *  <tr>
 *    <th>
 *      <code>ios-small</code>
 *    </th>
 *    <td>
 *      <ion-spinner name="ios-small"></ion-spinner>
 *    </td>
 *  </tr>
 *  <tr>
 *    <th>
 *      <code>bubbles</code>
 *    </th>
 *    <td>
 *      <ion-spinner name="bubbles"></ion-spinner>
 *    </td>
 *  </tr>
 *  <tr>
 *    <th>
 *      <code>circles</code>
 *    </th>
 *    <td>
 *      <ion-spinner name="circles"></ion-spinner>
 *    </td>
 *  </tr>
 *  <tr>
 *    <th>
 *      <code>crescent</code>
 *    </th>
 *    <td>
 *      <ion-spinner name="crescent"></ion-spinner>
 *    </td>
 *  </tr>
 *  <tr>
 *    <th>
 *      <code>dots</code>
 *    </th>
 *    <td>
 *      <ion-spinner name="dots"></ion-spinner>
 *    </td>
 *  </tr>
 * </table>
 *
 * @usage
 * The following code would use the default spinner for the platform it's
 * running from. If it's neither iOS or Android, it'll default to use `ios`.
 *
 * ```html
 * <ion-spinner></ion-spinner>
 * ```
 *
 * By setting the `name` property, you can specify which predefined spinner to
 * use, no matter what the platform is.
 *
 * ```html
 * <ion-spinner name="bubbles"></ion-spinner>
 * ```
 *
 * ## Styling SVG with CSS
 * One cool thing about SVG is its ability to be styled with CSS! One thing to note
 * is that some of the CSS properties on an SVG element have different names. For
 * example, SVG uses the term `stroke` instead of `border`, and `fill` instead
 * of `background-color`.
 *
 * ```css
 * ion-spinner * {
 *   width: 28px;
 *   height: 28px;
 *   stroke: #444;
 *   fill: #222;
 * }
 * ```
 */
var Spinner = (function (_super) {
    __extends(Spinner, _super);
    function Spinner(config, elementRef, renderer) {
        var _this = _super.call(this, config, elementRef, renderer, 'spinner') || this;
        _this._dur = null;
        _this._paused = false;
        return _this;
    }
    Object.defineProperty(Spinner.prototype, "name", {
        /**
         * @input {string} SVG spinner name.
         */
        get: function () {
            return this._name;
        },
        set: function (val) {
            this._name = val;
            this.load();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Spinner.prototype, "duration", {
        /**
         * @input {string} How long it takes it to do one loop.
         */
        get: function () {
            return this._dur;
        },
        set: function (val) {
            this._dur = val;
            this.load();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Spinner.prototype, "paused", {
        /**
         * @input {boolean} If true, pause the animation.
         */
        get: function () {
            return this._paused;
        },
        set: function (val) {
            this._paused = Object(__WEBPACK_IMPORTED_MODULE_3__util_util__["o" /* isTrueProperty */])(val);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @hidden
     */
    Spinner.prototype.ngOnInit = function () {
        this._init = true;
        this.load();
    };
    /**
     * @hidden
     */
    Spinner.prototype.load = function () {
        if (this._init) {
            this._l = [];
            this._c = [];
            var name = this._name || this._config.get('spinner', 'ios');
            var spinner = SPINNERS[name];
            if (spinner) {
                if (spinner.lines) {
                    for (var i = 0, l = spinner.lines; i < l; i++) {
                        this._l.push(this._loadEle(spinner, i, l));
                    }
                }
                else if (spinner.circles) {
                    for (var i = 0, l = spinner.circles; i < l; i++) {
                        this._c.push(this._loadEle(spinner, i, l));
                    }
                }
                this.setElementClass("spinner-" + name, true);
                this.setElementClass("spinner-" + this._mode + "-" + name, true);
            }
        }
    };
    Spinner.prototype._loadEle = function (spinner, index, total) {
        var duration = this._dur || spinner.dur;
        var data = spinner.fn(duration, index, total);
        data.style.animationDuration = duration + 'ms';
        return data;
    };
    Spinner.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'ion-spinner',
                    template: '<svg viewBox="0 0 64 64" *ngFor="let i of _c" [ngStyle]="i.style">' +
                        '<circle [attr.r]="i.r" transform="translate(32,32)"></circle>' +
                        '</svg>' +
                        '<svg viewBox="0 0 64 64" *ngFor="let i of _l" [ngStyle]="i.style">' +
                        '<line [attr.y1]="i.y1" [attr.y2]="i.y2" transform="translate(32,32)"></line>' +
                        '</svg>',
                    host: {
                        '[class.spinner-paused]': '_paused'
                    },
                    changeDetection: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectionStrategy"].OnPush,
                    encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None,
                },] },
    ];
    /** @nocollapse */
    Spinner.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__config_config__["a" /* Config */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    ]; };
    Spinner.propDecorators = {
        'name': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'duration': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'paused': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return Spinner;
}(__WEBPACK_IMPORTED_MODULE_2__ion__["a" /* Ion */]));

var SPINNERS = {
    ios: {
        dur: 1000,
        lines: 12,
        fn: function (dur, index, total) {
            var transform = 'rotate(' + (30 * index + (index < 6 ? 180 : -180)) + 'deg)';
            var animationDelay = -(dur - ((dur / total) * index)) + 'ms';
            return {
                y1: 17,
                y2: 29,
                style: {
                    transform: transform,
                    webkitTransform: transform,
                    animationDelay: animationDelay,
                    webkitAnimationDelay: animationDelay
                }
            };
        }
    },
    'ios-small': {
        dur: 1000,
        lines: 12,
        fn: function (dur, index, total) {
            var transform = 'rotate(' + (30 * index + (index < 6 ? 180 : -180)) + 'deg)';
            var animationDelay = -(dur - ((dur / total) * index)) + 'ms';
            return {
                y1: 12,
                y2: 20,
                style: {
                    transform: transform,
                    webkitTransform: transform,
                    animationDelay: animationDelay,
                    webkitAnimationDelay: animationDelay
                }
            };
        }
    },
    bubbles: {
        dur: 1000,
        circles: 9,
        fn: function (dur, index, total) {
            var animationDelay = -(dur - ((dur / total) * index)) + 'ms';
            return {
                r: 5,
                style: {
                    top: (9 * Math.sin(2 * Math.PI * index / total)) + 'px',
                    left: (9 * Math.cos(2 * Math.PI * index / total)) + 'px',
                    animationDelay: animationDelay,
                    webkitAnimationDelay: animationDelay
                }
            };
        }
    },
    circles: {
        dur: 1000,
        circles: 8,
        fn: function (dur, index, total) {
            var animationDelay = -(dur - ((dur / total) * index)) + 'ms';
            return {
                r: 5,
                style: {
                    top: (9 * Math.sin(2 * Math.PI * index / total)) + 'px',
                    left: (9 * Math.cos(2 * Math.PI * index / total)) + 'px',
                    animationDelay: animationDelay,
                    webkitAnimationDelay: animationDelay
                }
            };
        }
    },
    crescent: {
        dur: 750,
        circles: 1,
        fn: function () {
            return {
                r: 26,
                style: {}
            };
        }
    },
    dots: {
        dur: 750,
        circles: 3,
        fn: function (_dur, index) {
            var animationDelay = -(110 * index) + 'ms';
            return {
                r: 6,
                style: {
                    left: (9 - (9 * index)) + 'px',
                    animationDelay: animationDelay,
                    webkitAnimationDelay: animationDelay
                }
            };
        }
    }
};
//# sourceMappingURL=spinner.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/split-pane/split-pane.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RootNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SplitPane; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ion__ = __webpack_require__("./node_modules/ionic-angular/components/ion.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__platform_platform__ = __webpack_require__("./node_modules/ionic-angular/platform/platform.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var QUERY = {
    xs: '(min-width: 0px)',
    sm: '(min-width: 576px)',
    md: '(min-width: 768px)',
    lg: '(min-width: 992px)',
    xl: '(min-width: 1200px)',
    never: ''
};
/**
 * @hidden
 */
var RootNode = (function () {
    function RootNode() {
    }
    return RootNode;
}());

/**
 * @name SplitPane
 *
 * @description
 * SplitPane is a component that makes it possible to create multi-view layout.
 * Similar to iPad apps, SplitPane allows UI elements, like Menus, to be
 * displayed as the viewport increases.
 *
 * If the devices screen size is below a certain size, the SplitPane will
 * collapse and the menu will become hidden again. This is especially useful when
 * creating an app that will be served over a browser or deployed through the app
 * store to phones and tablets.
 *
 * @usage
 * To use SplitPane, simply add the component around your root component.
 * In this example, we'll be using a sidemenu layout, similar to what is
 * provided from the sidemenu starter template.
 *
 *  ```html
 *  <ion-split-pane>
 *    <!--  our side menu  -->
 *    <ion-menu [content]="content">
 *      <ion-header>
 *        <ion-toolbar>
 *          <ion-title>Menu</ion-title>
 *        </ion-toolbar>
 *      </ion-header>
 *    </ion-menu>
 *
 *    <!-- the main content -->
 *    <ion-nav [root]="root" main #content></ion-nav>
 *  </ion-split-pane>
 *  ```
 *
 *  Here, SplitPane will look for the element with the `main` attribute and make
 *  that the central component on larger screens. The `main` component can be any
 *  Ionic component (`ion-nav` or `ion-tabs`) except `ion-menu`.
 *
 *  ### Setting breakpoints
 *
 *  By default, SplitPane will expand when the screen is larger than 768px.
 *  If you want to customize this, use the `when` input. The `when` input can
 *  accept any valid media query, as it uses `matchMedia()` underneath.
 *
 *  ```
 *  <ion-split-pane when="(min-width: 475px)">
 *
 *    <!--  our side menu  -->
 *    <ion-menu [content]="content">
 *    ....
 *    </ion-menu>
 *
 *    <!-- the main content -->
 *    <ion-nav [root]="root" main #content></ion-nav>
 *  </ion-split-pane>
 *  ```
 *
 *  SplitPane also provides some predefined media queries that can be used.
 *
 *  ```html
 *  <!-- could be "xs", "sm", "md", "lg", or "xl" -->
 *  <ion-split-pane when="lg">
 *  ...
 *  </ion-split-pane>
 *  ```
 *
 *
 *  | Size | Value                 | Description                                                           |
 *  |------|-----------------------|-----------------------------------------------------------------------|
 *  | `xs` | `(min-width: 0px)`    | Show the split-pane when the min-width is 0px (meaning, always)       |
 *  | `sm` | `(min-width: 576px)`  | Show the split-pane when the min-width is 576px                       |
 *  | `md` | `(min-width: 768px)`  | Show the split-pane when the min-width is 768px (default break point) |
 *  | `lg` | `(min-width: 992px)`  | Show the split-pane when the min-width is 992px                       |
 *  | `xl` | `(min-width: 1200px)` | Show the split-pane when the min-width is 1200px                      |
 *
 *  You can also pass in boolean values that will trigger SplitPane when the value
 *  or expression evaluates to true.
 *
 *
 *  ```html
 *  <ion-split-pane [when]="isLarge">
 *  ...
 *  </ion-split-pane>
 *  ```
 *
 *  ```ts
 *  class MyClass {
 *    public isLarge = false;
 *    constructor(){}
 *  }
 *  ```
 *
 *  Or
 *
 *  ```html
 *  <ion-split-pane [when]="shouldShow()">
 *  ...
 *  </ion-split-pane>
 *  ```
 *
 *  ```ts
 *  class MyClass {
 *    constructor(){}
 *    shouldShow(){
 *      if(conditionA){
 *        return true
 *      } else {
 *        return false
 *      }
 *    }
 *  }
 *  ```
 *
 */
var SplitPane = (function (_super) {
    __extends(SplitPane, _super);
    function SplitPane(_zone, _plt, config, elementRef, renderer) {
        var _this = _super.call(this, config, elementRef, renderer, 'split-pane') || this;
        _this._zone = _zone;
        _this._plt = _plt;
        _this._init = false;
        _this._visible = false;
        _this._isEnabled = true;
        _this._mediaQuery = QUERY['md'];
        /**
         * @hidden
         */
        _this.sideContent = null;
        /**
         * @hidden
         */
        _this.mainContent = null;
        /**
         * @output {any} Expression to be called when the split-pane visibility has changed
         */
        _this.ionChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        return _this;
    }
    Object.defineProperty(SplitPane.prototype, "_setchildren", {
        /**
         * @hidden
         */
        set: function (query) {
            var _this = this;
            var children = this._children = query.filter((function (child) { return child !== _this; }));
            children.forEach(function (child) {
                var isMain = child.initPane();
                _this._setPaneCSSClass(child.getElementRef(), isMain);
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SplitPane.prototype, "when", {
        get: function () {
            return this._mediaQuery;
        },
        /**
         * @input {string | boolean} When the split-pane should be shown.
         * Can be a CSS media query expression, or a shortcut expression.
         * Can also be a boolean expression.
         */
        set: function (query) {
            if (typeof query === 'boolean') {
                this._mediaQuery = query;
            }
            else {
                var defaultQuery = QUERY[query];
                this._mediaQuery = (defaultQuery)
                    ? defaultQuery
                    : query;
            }
            this._update();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SplitPane.prototype, "enabled", {
        get: function () {
            return this._isEnabled;
        },
        /**
         * @input {boolean} If `false`, the split-pane is disabled, ie. the side pane will
         * never be displayed. Default `true`.
         */
        set: function (val) {
            this._isEnabled = Object(__WEBPACK_IMPORTED_MODULE_2__util_util__["o" /* isTrueProperty */])(val);
            this._update();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @hidden
     */
    SplitPane.prototype._register = function (node, isMain, callback) {
        if (this.getElementRef().nativeElement !== node.getElementRef().nativeElement.parentNode) {
            return false;
        }
        this._setPaneCSSClass(node.getElementRef(), isMain);
        if (callback) {
            this.ionChange.subscribe(callback);
        }
        if (isMain) {
            if (this.mainContent) {
                console.error('split pane: main content was already set');
            }
            this.mainContent = node;
        }
        return true;
    };
    /**
     * @hidden
     */
    SplitPane.prototype.ngAfterViewInit = function () {
        this._init = true;
        this._update();
    };
    /**
     * @hidden
     */
    SplitPane.prototype._update = function () {
        var _this = this;
        if (!this._init) {
            return;
        }
        // Unlisten
        this._rmListener && this._rmListener();
        this._rmListener = null;
        // Check if the split-pane is disabled
        if (!this._isEnabled) {
            this._setVisible(false);
            return;
        }
        var query = this._mediaQuery;
        if (typeof query === 'boolean') {
            this._setVisible(query);
            return;
        }
        if (query && query.length > 0) {
            // Listen
            var callback_1 = function (query) { return _this._setVisible(query.matches); };
            var mediaList_1 = this._plt.win().matchMedia(query);
            mediaList_1.addListener(callback_1);
            this._setVisible(mediaList_1.matches);
            this._rmListener = function () {
                mediaList_1.removeListener(callback_1);
            };
        }
        else {
            this._setVisible(false);
        }
    };
    /**
     * @hidden
     */
    SplitPane.prototype._updateChildren = function () {
        this.mainContent = null;
        this.sideContent = null;
        var visible = this._visible;
        this._children.forEach(function (child) { return child.paneChanged && child.paneChanged(visible); });
    };
    /**
     * @hidden
     */
    SplitPane.prototype._setVisible = function (visible) {
        var _this = this;
        if (this._visible === visible) {
            return;
        }
        this._visible = visible;
        this.setElementClass('split-pane-visible', visible);
        this._updateChildren();
        this._zone.run(function () {
            _this.ionChange.emit(_this);
        });
    };
    /**
     * @hidden
     */
    SplitPane.prototype.isVisible = function () {
        return this._visible;
    };
    /**
     * @hidden
     */
    SplitPane.prototype.setElementClass = function (className, add) {
        this._renderer.setElementClass(this._elementRef.nativeElement, className, add);
    };
    /**
     * @hidden
     */
    SplitPane.prototype._setPaneCSSClass = function (elementRef, isMain) {
        var ele = elementRef.nativeElement;
        this._renderer.setElementClass(ele, 'split-pane-main', isMain);
        this._renderer.setElementClass(ele, 'split-pane-side', !isMain);
    };
    /**
     * @hidden
     */
    SplitPane.prototype.ngOnDestroy = function () {
        (void 0) /* assert */;
        this._rmListener && this._rmListener();
        this._rmListener = null;
    };
    /**
     * @hidden
     */
    SplitPane.prototype.initPane = function () {
        return true;
    };
    SplitPane.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'ion-split-pane',
                    providers: [{ provide: RootNode, useExisting: Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return SplitPane; }) }]
                },] },
    ];
    /** @nocollapse */
    SplitPane.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"], },
        { type: __WEBPACK_IMPORTED_MODULE_4__platform_platform__["a" /* Platform */], },
        { type: __WEBPACK_IMPORTED_MODULE_3__config_config__["a" /* Config */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    ]; };
    SplitPane.propDecorators = {
        '_setchildren': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChildren"], args: [RootNode, { descendants: false },] },],
        'when': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'enabled': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'ionChange': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    };
    return SplitPane;
}(__WEBPACK_IMPORTED_MODULE_1__ion__["a" /* Ion */]));

//# sourceMappingURL=split-pane.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/tabs/tab-button.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TabButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ion__ = __webpack_require__("./node_modules/ionic-angular/components/ion.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



/**
 * @hidden
 */
var TabButton = (function (_super) {
    __extends(TabButton, _super);
    function TabButton(config, elementRef, renderer) {
        var _this = _super.call(this, config, elementRef, renderer) || this;
        _this.ionSelect = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        _this.disHover = (config.get('hoverCSS') === false);
        _this.layout = config.get('tabsLayout');
        return _this;
    }
    TabButton.prototype.ngOnInit = function () {
        this.tab.btn = this;
        this.layout = this.tab.parent.tabsLayout || this.layout;
        this.hasTitle = !!this.tab.tabTitle;
        this.hasIcon = !!this.tab.tabIcon && this.layout !== 'icon-hide';
        this.hasTitleOnly = (this.hasTitle && !this.hasIcon);
        this.hasIconOnly = (this.hasIcon && !this.hasTitle);
        this.hasBadge = !!this.tab.tabBadge;
    };
    TabButton.prototype.onClick = function () {
        this.ionSelect.emit(this.tab);
        return false;
    };
    TabButton.prototype.updateHref = function (href) {
        this.setElementAttribute('href', href);
    };
    TabButton.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: '.tab-button',
                    template: '<ion-icon *ngIf="tab.tabIcon" [name]="tab.tabIcon" [attr.aria-hidden]="hasTitle ? \'true\' : null" [isActive]="tab.isSelected" class="tab-button-icon"></ion-icon>' +
                        '<span *ngIf="tab.tabTitle" class="tab-button-text">{{tab.tabTitle}}</span>' +
                        '<ion-badge *ngIf="tab.tabBadge" class="tab-badge" [color]="tab.tabBadgeStyle">{{tab.tabBadge}}</ion-badge>' +
                        '<div class="button-effect"></div>',
                    host: {
                        '[attr.id]': 'tab._btnId',
                        '[attr.aria-controls]': 'tab._tabId',
                        '[attr.aria-selected]': 'tab.isSelected',
                        '[class.has-title]': 'hasTitle',
                        '[class.has-icon]': 'hasIcon',
                        '[class.has-title-only]': 'hasTitleOnly',
                        '[class.icon-only]': 'hasIconOnly',
                        '[class.has-badge]': 'hasBadge',
                        '[class.disable-hover]': 'disHover',
                        '[class.tab-disabled]': '!tab.enabled',
                        '[class.tab-hidden]': '!tab.show',
                    }
                },] },
    ];
    /** @nocollapse */
    TabButton.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__config_config__["a" /* Config */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    ]; };
    TabButton.propDecorators = {
        'tab': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'ionSelect': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        'onClick': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"], args: ['click',] },],
    };
    return TabButton;
}(__WEBPACK_IMPORTED_MODULE_2__ion__["a" /* Ion */]));

//# sourceMappingURL=tab-button.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/tabs/tab-highlight.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TabHighlight; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__platform_dom_controller__ = __webpack_require__("./node_modules/ionic-angular/platform/dom-controller.js");


/**
 * @hidden
 */
var TabHighlight = (function () {
    function TabHighlight(_elementRef, _dom) {
        this._elementRef = _elementRef;
        this._dom = _dom;
    }
    TabHighlight.prototype.select = function (tab) {
        var _this = this;
        if (!tab) {
            return;
        }
        var dom = this._dom;
        dom.read(function () {
            var btnEle = tab.btn.getNativeElement();
            var transform = "translate3d(" + btnEle.offsetLeft + "px,0,0) scaleX(" + btnEle.offsetWidth + ")";
            dom.write(function () {
                var ele = _this._elementRef.nativeElement;
                ele.style[dom.plt.Css.transform] = transform;
                if (!_this._init) {
                    _this._init = true;
                    dom.write(function () {
                        ele.classList.add('animate');
                    }, 80);
                }
            });
        }, 32);
    };
    TabHighlight.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: '.tab-highlight'
                },] },
    ];
    /** @nocollapse */
    TabHighlight.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_1__platform_dom_controller__["a" /* DomController */], },
    ]; };
    return TabHighlight;
}());

//# sourceMappingURL=tab-highlight.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/tabs/tab.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Tab; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_app__ = __webpack_require__("./node_modules/ionic-angular/components/app/app.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__navigation_deep_linker__ = __webpack_require__("./node_modules/ionic-angular/navigation/deep-linker.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__platform_dom_controller__ = __webpack_require__("./node_modules/ionic-angular/platform/dom-controller.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__gestures_gesture_controller__ = __webpack_require__("./node_modules/ionic-angular/gestures/gesture-controller.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__navigation_nav_controller_base__ = __webpack_require__("./node_modules/ionic-angular/navigation/nav-controller-base.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__platform_platform__ = __webpack_require__("./node_modules/ionic-angular/platform/platform.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__tabs__ = __webpack_require__("./node_modules/ionic-angular/components/tabs/tabs.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__transitions_transition_controller__ = __webpack_require__("./node_modules/ionic-angular/transitions/transition-controller.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();











/**
 * @name Tab
 * @description
 * The Tab component, written `<ion-tab>`, is styled based on the mode and should
 * be used in conjunction with the [Tabs](../Tabs/) component.
 *
 * Each `ion-tab` is a declarative component for a [NavController](../../../navigation/NavController/).
 * Basically, each tab is a `NavController`. For more information on using
 * navigation controllers take a look at the [NavController API Docs](../../../navigation/NavController/).
 *
 * See the [Tabs API Docs](../Tabs/) for more details on configuring Tabs.
 *
 * @usage
 *
 * To add a basic tab, you can use the following markup where the `root` property
 * is the page you want to load for that tab, `tabTitle` is the optional text to
 * display on the tab, and `tabIcon` is the optional [icon](../../icon/Icon/).
 *
 * ```html
 * <ion-tabs>
 *  <ion-tab [root]="chatRoot" tabTitle="Chat" tabIcon="chat"></ion-tab>
 * </ion-tabs>
 * ```
 *
 * Then, in your class you can set `chatRoot` to an imported class:
 *
 * ```ts
 * import { ChatPage } from '../chat/chat';
 *
 * export class Tabs {
 *   // here we'll set the property of chatRoot to
 *   // the imported class of ChatPage
 *   chatRoot = ChatPage;
 *
 *   constructor() {
 *
 *   }
 * }
 * ```
 *
 * You can also pass some parameters to the root page of the tab through
 * `rootParams`. Below we pass `chatParams` to the Chat tab:
 *
 * ```html
 * <ion-tabs>
 *  <ion-tab [root]="chatRoot" [rootParams]="chatParams" tabTitle="Chat" tabIcon="chat"></ion-tab>
 * </ion-tabs>
 * ```
 *
 * ```ts
 * export class Tabs {
 *   chatRoot = ChatPage;
 *
 *   // set some user information on chatParams
 *   chatParams = {
 *     user1: 'admin',
 *     user2: 'ionic'
 *   };
 *
 *   constructor() {
 *
 *   }
 * }
 * ```
 *
 * And in `ChatPage` you can get the data from `NavParams`:
 *
 * ```ts
 * export class ChatPage {
 *   constructor(navParams: NavParams) {
 *     console.log('Passed params', navParams.data);
 *   }
 * }
 * ```
 *
 * Sometimes you may want to call a method instead of navigating to a new
 * page. You can use the `(ionSelect)` event to call a method on your class when
 * the tab is selected. Below is an example of presenting a modal from one of
 * the tabs.
 *
 * ```html
 * <ion-tabs>
 *   <ion-tab (ionSelect)="chat()" tabTitle="Show Modal"></ion-tab>
 * </ion-tabs>pop
 * ```
 *
 * ```ts
 * export class Tabs {
 *   constructor(public modalCtrl: ModalController) {
 *
 *   }
 *
 *   chat() {
 *     let modal = this.modalCtrl.create(ChatPage);
 *     modal.present();
 *   }
 * }
 * ```
 *
 *
 * @demo /docs/demos/src/tabs/
 * @see {@link /docs/components#tabs Tabs Component Docs}
 * @see {@link ../../tabs/Tabs Tabs API Docs}
 * @see {@link ../../nav/Nav Nav API Docs}
 * @see {@link ../../nav/NavController NavController API Docs}
 */
var Tab = (function (_super) {
    __extends(Tab, _super);
    function Tab(parent, app, config, plt, elementRef, zone, renderer, cfr, _cd, gestureCtrl, transCtrl, linker, _dom, errHandler) {
        var _this = 
        // A Tab is a NavController for its child pages
        _super.call(this, parent, app, config, plt, elementRef, zone, renderer, cfr, gestureCtrl, transCtrl, linker, _dom, errHandler) || this;
        _this._cd = _cd;
        _this.linker = linker;
        _this._dom = _dom;
        /**
         * @hidden
         */
        _this._isEnabled = true;
        /**
         * @hidden
         */
        _this._isShown = true;
        /**
         * @output {Tab} Emitted when the current tab is selected.
         */
        _this.ionSelect = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        _this.id = parent.add(_this);
        _this._tabsHideOnSubPages = config.getBoolean('tabsHideOnSubPages');
        _this._tabId = 'tabpanel-' + _this.id;
        _this._btnId = 'tab-' + _this.id;
        return _this;
    }
    Object.defineProperty(Tab.prototype, "enabled", {
        /**
         * @input {boolean} If true, enable the tab. If false,
         * the user cannot interact with this element.
         * Default: `true`.
         */
        get: function () {
            return this._isEnabled;
        },
        set: function (val) {
            this._isEnabled = Object(__WEBPACK_IMPORTED_MODULE_6__util_util__["o" /* isTrueProperty */])(val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Tab.prototype, "show", {
        /**
         * @input {boolean} If true, the tab button is visible within the
         * tabbar. Default: `true`.
         */
        get: function () {
            return this._isShown;
        },
        set: function (val) {
            this._isShown = Object(__WEBPACK_IMPORTED_MODULE_6__util_util__["o" /* isTrueProperty */])(val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Tab.prototype, "tabsHideOnSubPages", {
        /**
         * @input {boolean} If true, hide the tabs on child pages.
         */
        get: function () {
            return this._tabsHideOnSubPages;
        },
        set: function (val) {
            this._tabsHideOnSubPages = Object(__WEBPACK_IMPORTED_MODULE_6__util_util__["o" /* isTrueProperty */])(val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Tab.prototype, "_vp", {
        /**
         * @hidden
         */
        set: function (val) {
            this.setViewport(val);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @hidden
     */
    Tab.prototype.ngOnInit = function () {
        this.tabBadgeStyle = this.tabBadgeStyle ? this.tabBadgeStyle : 'default';
    };
    /**
     * @hidden
     */
    Tab.prototype.load = function (opts) {
        var _this = this;
        var segment = this._segment;
        if (segment || (!this._loaded && this.root)) {
            this.setElementClass('show-tab', true);
            // okay, first thing we need to do if check if the view already exists
            var nameToUse = segment && segment.name ? segment.name : this.root;
            var dataToUse = segment ? segment.data : this.rootParams;
            var numViews = this.length() - 1;
            for (var i = numViews; i >= 0; i--) {
                var viewController = this.getByIndex(i);
                if (viewController && (viewController.id === nameToUse || viewController.component === nameToUse)) {
                    if (i === numViews) {
                        // this is the last view in the stack and it's the same
                        // as the segment so there's no change needed
                        return Promise.resolve();
                    }
                    else {
                        // it's not the exact view as the end
                        // let's have this nav go back to this exact view
                        return this.popTo(viewController, {
                            animate: false,
                            updateUrl: false,
                        });
                    }
                }
            }
            var promise = null;
            if (segment && segment.defaultHistory && segment.defaultHistory.length && this._views.length === 0) {
                promise = this.linker.initViews(segment).then(function (views) {
                    return _this.setPages(views, opts);
                });
            }
            else {
                promise = this.push(nameToUse, dataToUse, opts);
            }
            return promise.then(function () {
                _this._segment = null;
                _this._loaded = true;
            });
        }
        else {
            // if this is not the Tab's initial load then we need
            // to refresh the tabbar and content dimensions to be sure
            // they're lined up correctly
            this._dom.read(function () {
                _this.resize();
            });
            return Promise.resolve();
        }
    };
    /**
     * @hidden
     */
    Tab.prototype.resize = function () {
        var active = this.getActive();
        if (!active) {
            return;
        }
        var content = active.getIONContent();
        content && content.resize();
    };
    /**
     * @hidden
     */
    Tab.prototype._viewAttachToDOM = function (viewCtrl, componentRef, viewport) {
        var isTabSubPage = (this._tabsHideOnSubPages && viewCtrl.index > 0);
        if (isTabSubPage) {
            viewport = this.parent.portal;
        }
        _super.prototype._viewAttachToDOM.call(this, viewCtrl, componentRef, viewport);
        if (isTabSubPage) {
            // add the .tab-subpage css class to tabs pages that should act like subpages
            var pageEleRef = viewCtrl.pageRef();
            if (pageEleRef) {
                this._renderer.setElementClass(pageEleRef.nativeElement, 'tab-subpage', true);
            }
        }
    };
    /**
     * @hidden
     */
    Tab.prototype.setSelected = function (isSelected) {
        this.isSelected = isSelected;
        this.setElementClass('show-tab', isSelected);
        this.setElementAttribute('aria-hidden', (!isSelected).toString());
        if (isSelected) {
            // this is the selected tab, detect changes
            this._cd.reattach();
        }
        else {
            // this tab is not selected, do not detect changes
            this._cd.detach();
        }
    };
    Object.defineProperty(Tab.prototype, "index", {
        /**
         * @hidden
         */
        get: function () {
            return this.parent.getIndex(this);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @hidden
     */
    Tab.prototype.updateHref = function (component, data) {
        if (this.btn && this.linker) {
            var href = this.linker.createUrl(this.parent, component, data) || '#';
            this.btn.updateHref(href);
        }
    };
    /**
     * @hidden
     */
    Tab.prototype.ngOnDestroy = function () {
        this.destroy();
    };
    /**
     * @hidden
     */
    Tab.prototype.getType = function () {
        return 'tab';
    };
    Tab.prototype.goToRoot = function (opts) {
        return this.setRoot(this.root, this.rootParams, opts, null);
    };
    Tab.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'ion-tab',
                    template: '<div #viewport></div><div class="nav-decor"></div>',
                    host: {
                        '[attr.id]': '_tabId',
                        '[attr.aria-labelledby]': '_btnId',
                        'role': 'tabpanel'
                    },
                    encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None,
                },] },
    ];
    /** @nocollapse */
    Tab.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_9__tabs__["a" /* Tabs */], },
        { type: __WEBPACK_IMPORTED_MODULE_1__app_app__["a" /* App */], },
        { type: __WEBPACK_IMPORTED_MODULE_2__config_config__["a" /* Config */], },
        { type: __WEBPACK_IMPORTED_MODULE_8__platform_platform__["a" /* Platform */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ComponentFactoryResolver"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_5__gestures_gesture_controller__["m" /* GestureController */], },
        { type: __WEBPACK_IMPORTED_MODULE_10__transitions_transition_controller__["a" /* TransitionController */], },
        { type: __WEBPACK_IMPORTED_MODULE_3__navigation_deep_linker__["a" /* DeepLinker */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
        { type: __WEBPACK_IMPORTED_MODULE_4__platform_dom_controller__["a" /* DomController */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ErrorHandler"], },
    ]; };
    Tab.propDecorators = {
        'root': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'rootParams': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'tabUrlPath': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'tabTitle': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'tabIcon': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'tabBadge': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'tabBadgeStyle': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'enabled': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'show': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'tabsHideOnSubPages': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'ionSelect': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        '_vp': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"], args: ['viewport', { read: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"] },] },],
    };
    return Tab;
}(__WEBPACK_IMPORTED_MODULE_7__navigation_nav_controller_base__["a" /* NavControllerBase */]));

//# sourceMappingURL=tab.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/tabs/tabs.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Tabs; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Subject__ = __webpack_require__("./node_modules/rxjs/Subject.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Subject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_Subject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_add_operator_takeUntil__ = __webpack_require__("./node_modules/rxjs/add/operator/takeUntil.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_add_operator_takeUntil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_add_operator_takeUntil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_app__ = __webpack_require__("./node_modules/ionic-angular/components/app/app.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__navigation_deep_linker__ = __webpack_require__("./node_modules/ionic-angular/navigation/deep-linker.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ion__ = __webpack_require__("./node_modules/ionic-angular/components/ion.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__platform_keyboard__ = __webpack_require__("./node_modules/ionic-angular/platform/keyboard.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__navigation_nav_controller__ = __webpack_require__("./node_modules/ionic-angular/navigation/nav-controller.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__navigation_nav_util__ = __webpack_require__("./node_modules/ionic-angular/navigation/nav-util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__navigation_url_serializer__ = __webpack_require__("./node_modules/ionic-angular/navigation/url-serializer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__split_pane_split_pane__ = __webpack_require__("./node_modules/ionic-angular/components/split-pane/split-pane.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__platform_platform__ = __webpack_require__("./node_modules/ionic-angular/platform/platform.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__tab_highlight__ = __webpack_require__("./node_modules/ionic-angular/components/tabs/tab-highlight.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__navigation_view_controller__ = __webpack_require__("./node_modules/ionic-angular/navigation/view-controller.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
















/**
 * @name Tabs
 * @description
 * Tabs make it easy to navigate between different pages or functional
 * aspects of an app. The Tabs component, written as `<ion-tabs>`, is
 * a container of individual [Tab](../Tab/) components. Each individual `ion-tab`
 * is a declarative component for a [NavController](../../../navigation/NavController/)
 *
 * For more information on using nav controllers like Tab or [Nav](../../nav/Nav/),
 * take a look at the [NavController API Docs](../../../navigation/NavController/).
 *
 * ### Placement
 *
 * The position of the tabs relative to the content varies based on
 * the mode. The tabs are placed at the bottom of the screen
 * for iOS and Android, and at the top for Windows by default. The position can
 * be configured using the `tabsPlacement` attribute on the `<ion-tabs>` component,
 * or in an app's [config](../../config/Config/).
 * See the [Input Properties](#input-properties) below for the available
 * values of `tabsPlacement`.
 *
 * ### Layout
 *
 * The layout for all of the tabs can be defined using the `tabsLayout`
 * property. If the individual tab has a title and icon, the icons will
 * show on top of the title by default. All tabs can be changed by setting
 * the value of `tabsLayout` on the `<ion-tabs>` element, or in your
 * app's [config](../../config/Config/). For example, this is useful if
 * you want to show tabs with a title only on Android, but show icons
 * and a title for iOS. See the [Input Properties](#input-properties)
 * below for the available values of `tabsLayout`.
 *
 * ### Selecting a Tab
 *
 * There are different ways you can select a specific tab from the tabs
 * component. You can use the `selectedIndex` property to set the index
 * on the `<ion-tabs>` element, or you can call `select()` from the `Tabs`
 * instance after creation. See [usage](#usage) below for more information.
 *
 * @usage
 *
 * You can add a basic tabs template to a `@Component` using the following
 * template:
 *
 * ```html
 * <ion-tabs>
 *   <ion-tab [root]="tab1Root"></ion-tab>
 *   <ion-tab [root]="tab2Root"></ion-tab>
 *   <ion-tab [root]="tab3Root"></ion-tab>
 * </ion-tabs>
 * ```
 *
 * Where `tab1Root`, `tab2Root`, and `tab3Root` are each a page:
 *
 *```ts
 * @Component({
 *   templateUrl: 'build/pages/tabs/tabs.html'
 * })
 * export class TabsPage {
 *   // this tells the tabs component which Pages
 *   // should be each tab's root Page
 *   tab1Root = Page1;
 *   tab2Root = Page2;
 *   tab3Root = Page3;
 *
 *   constructor() {
 *
 *   }
 * }
 *```
 *
 * By default, the first tab will be selected upon navigation to the
 * Tabs page. We can change the selected tab by using `selectedIndex`
 * on the `<ion-tabs>` element:
 *
 * ```html
 * <ion-tabs selectedIndex="2">
 *   <ion-tab [root]="tab1Root"></ion-tab>
 *   <ion-tab [root]="tab2Root"></ion-tab>
 *   <ion-tab [root]="tab3Root"></ion-tab>
 * </ion-tabs>
 * ```
 *
 * Since the index starts at `0`, this will select the 3rd tab which has
 * root set to `tab3Root`. If you wanted to change it dynamically from
 * your class, you could use [property binding](https://angular.io/docs/ts/latest/guide/template-syntax.html#!#property-binding).
 *
 * Alternatively, you can grab the `Tabs` instance and call the `select()`
 * method. This requires the `<ion-tabs>` element to have an `id`. For
 * example, set the value of `id` to `myTabs`:
 *
 * ```html
 * <ion-tabs #myTabs>
 *   <ion-tab [root]="tab1Root"></ion-tab>
 *   <ion-tab [root]="tab2Root"></ion-tab>
 *   <ion-tab [root]="tab3Root"></ion-tab>
 * </ion-tabs>
 * ```
 *
 * Then in your class you can grab the `Tabs` instance and call `select()`,
 * passing the index of the tab as the argument. Here we're grabbing the tabs
 * by using ViewChild.
 *
 *```ts
 * export class TabsPage {
 *
 * @ViewChild('myTabs') tabRef: Tabs;
 *
 * ionViewDidEnter() {
 *   this.tabRef.select(2);
 *  }
 *
 * }
 *```
 *
 * You can also switch tabs from a child component by calling `select()` on the
 * parent view using the `NavController` instance. For example, assuming you have
 * a `TabsPage` component, you could call the following from any of the child
 * components to switch to `TabsRoot3`:
 *
 *```ts
 * switchTabs() {
 *   this.navCtrl.parent.select(2);
 * }
 *```
 * @demo /docs/demos/src/tabs/
 *
 * @see {@link /docs/components#tabs Tabs Component Docs}
 * @see {@link ../Tab Tab API Docs}
 * @see {@link ../../config/Config Config API Docs}
 *
 */
var Tabs = (function (_super) {
    __extends(Tabs, _super);
    function Tabs(parent, viewCtrl, _app, config, elementRef, _plt, renderer, _linker, keyboard) {
        var _this = _super.call(this, config, elementRef, renderer, 'tabs') || this;
        _this.viewCtrl = viewCtrl;
        _this._app = _app;
        _this._plt = _plt;
        _this._linker = _linker;
        /** @internal */
        _this._ids = -1;
        /** @internal */
        _this._tabs = [];
        /** @internal */
        _this._selectHistory = [];
        /** @internal */
        _this._onDestroy = new __WEBPACK_IMPORTED_MODULE_1_rxjs_Subject__["Subject"]();
        /**
         * @output {any} Emitted when the tab changes.
         */
        _this.ionChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        _this.parent = parent;
        _this.id = 't' + (++tabIds);
        _this._sbPadding = config.getBoolean('statusbarPadding');
        _this.tabsHighlight = config.getBoolean('tabsHighlight');
        if (_this.parent) {
            // this Tabs has a parent Nav
            _this.parent.registerChildNav(_this);
        }
        else if (viewCtrl && viewCtrl.getNav()) {
            // this Nav was opened from a modal
            _this.parent = viewCtrl.getNav();
            _this.parent.registerChildNav(_this);
        }
        else if (_this._app) {
            // this is the root navcontroller for the entire app
            _this._app.registerRootNav(_this);
        }
        // Tabs may also be an actual ViewController which was navigated to
        // if Tabs is static and not navigated to within a NavController
        // then skip this and don't treat it as it's own ViewController
        if (viewCtrl) {
            viewCtrl._setContent(_this);
            viewCtrl._setContentRef(elementRef);
        }
        var keyboardResizes = config.getBoolean('keyboardResizes', false);
        if (keyboard && keyboardResizes) {
            keyboard.willHide
                .takeUntil(_this._onDestroy)
                .subscribe(function () {
                _this._plt.timeout(function () { return _this.setTabbarHidden(false); }, 50);
            });
            keyboard.willShow
                .takeUntil(_this._onDestroy)
                .subscribe(function () { return _this.setTabbarHidden(true); });
        }
        return _this;
    }
    /**
     * @internal
     */
    Tabs.prototype.setTabbarHidden = function (tabbarHidden) {
        this.setElementClass('tabbar-hidden', tabbarHidden);
        this.resize();
    };
    /**
     * @internal
     */
    Tabs.prototype.ngOnDestroy = function () {
        this._onDestroy.next();
        if (this.parent) {
            this.parent.unregisterChildNav(this);
        }
        else {
            this._app.unregisterRootNav(this);
        }
    };
    /**
     * @internal
     */
    Tabs.prototype.ngAfterViewInit = function () {
        var _this = this;
        this._setConfig('tabsPlacement', 'bottom');
        this._setConfig('tabsLayout', 'icon-top');
        this._setConfig('tabsHighlight', this.tabsHighlight);
        if (this.tabsHighlight) {
            this._plt.resize
                .takeUntil(this._onDestroy)
                .subscribe(function () { return _this._highlight.select(_this.getSelected()); });
        }
        this.initTabs();
    };
    /**
     * @internal
     */
    Tabs.prototype.initTabs = function () {
        var _this = this;
        // get the selected index from the input
        // otherwise default it to use the first index
        var selectedIndex = (Object(__WEBPACK_IMPORTED_MODULE_7__util_util__["f" /* isBlank */])(this.selectedIndex) ? 0 : parseInt(this.selectedIndex, 10));
        // now see if the deep linker can find a tab index
        var tabsSegment = this._linker.getSegmentByNavIdOrName(this.id, this.name);
        if (tabsSegment) {
            // we found a segment which probably represents which tab to select
            selectedIndex = this._getSelectedTabIndex(tabsSegment.secondaryId, selectedIndex);
        }
        // get the selectedIndex and ensure it isn't hidden or disabled
        var selectedTab = this._tabs.find(function (t, i) { return i === selectedIndex && t.enabled && t.show; });
        if (!selectedTab) {
            // wasn't able to select the tab they wanted
            // try to find the first tab that's available
            selectedTab = this._tabs.find(function (t) { return t.enabled && t.show; });
        }
        var promise = Promise.resolve();
        if (selectedTab) {
            selectedTab._segment = tabsSegment;
            promise = this.select(selectedTab);
        }
        return promise.then(function () {
            // set the initial href attribute values for each tab
            _this._tabs.forEach(function (t) {
                t.updateHref(t.root, t.rootParams);
            });
        });
    };
    /**
     * @internal
     */
    Tabs.prototype._setConfig = function (attrKey, fallback) {
        var val = this[attrKey];
        if (Object(__WEBPACK_IMPORTED_MODULE_7__util_util__["f" /* isBlank */])(val)) {
            val = this._config.get(attrKey, fallback);
        }
        this.setElementAttribute(attrKey, val);
    };
    /**
     * @hidden
     */
    Tabs.prototype.add = function (tab) {
        this._tabs.push(tab);
        return this.id + '-' + (++this._ids);
    };
    /**
     * @param {number|Tab} tabOrIndex Index, or the Tab instance, of the tab to select.
     */
    Tabs.prototype.select = function (tabOrIndex, opts, fromUrl) {
        var _this = this;
        if (opts === void 0) { opts = {}; }
        if (fromUrl === void 0) { fromUrl = false; }
        var selectedTab = (typeof tabOrIndex === 'number' ? this.getByIndex(tabOrIndex) : tabOrIndex);
        if (Object(__WEBPACK_IMPORTED_MODULE_7__util_util__["f" /* isBlank */])(selectedTab)) {
            return Promise.resolve();
        }
        // If the selected tab is the current selected tab, we do not switch
        var currentTab = this.getSelected();
        if (selectedTab === currentTab && currentTab.getActive()) {
            return this._updateCurrentTab(selectedTab, fromUrl);
        }
        // If the selected tab does not have a root, we do not switch (#9392)
        // it's possible the tab is only for opening modal's or signing out
        // and doesn't actually have content. In the case there's no content
        // for a tab then do nothing and leave the current view as is
        if (selectedTab.root) {
            // At this point we are going to perform a page switch
            // Let's fire willLeave in the current tab page
            var currentPage;
            if (currentTab) {
                currentPage = currentTab.getActive();
                currentPage && currentPage._willLeave(false);
            }
            // Fire willEnter in the new selected tab
            var selectedPage_1 = selectedTab.getActive();
            selectedPage_1 && selectedPage_1._willEnter();
            // Let's start the transition
            opts.animate = false;
            return selectedTab.load(opts).then(function () {
                _this._tabSwitchEnd(selectedTab, selectedPage_1, currentPage);
                if (opts.updateUrl !== false) {
                    _this._linker.navChange(__WEBPACK_IMPORTED_MODULE_10__navigation_nav_util__["c" /* DIRECTION_SWITCH */]);
                }
                (void 0) /* assert */;
                _this._fireChangeEvent(selectedTab);
            });
        }
        else {
            this._fireChangeEvent(selectedTab);
            return Promise.resolve();
        }
    };
    Tabs.prototype._fireChangeEvent = function (selectedTab) {
        selectedTab.ionSelect.emit(selectedTab);
        this.ionChange.emit(selectedTab);
    };
    Tabs.prototype._tabSwitchEnd = function (selectedTab, selectedPage, currentPage) {
        (void 0) /* assert */;
        (void 0) /* assert */;
        // Update tabs selection state
        var tabs = this._tabs;
        var tab;
        for (var i = 0; i < tabs.length; i++) {
            tab = tabs[i];
            tab.setSelected(tab === selectedTab);
        }
        if (this.tabsHighlight) {
            this._highlight.select(selectedTab);
        }
        // Fire didEnter/didLeave lifecycle events
        if (selectedPage) {
            selectedPage._didEnter();
            this._app.viewDidEnter.emit(selectedPage);
        }
        if (currentPage) {
            currentPage && currentPage._didLeave();
            this._app.viewDidLeave.emit(currentPage);
        }
        // track the order of which tabs have been selected, by their index
        // do not track if the tab index is the same as the previous
        if (this._selectHistory[this._selectHistory.length - 1] !== selectedTab.id) {
            this._selectHistory.push(selectedTab.id);
        }
    };
    /**
     * Get the previously selected Tab which is currently not disabled or hidden.
     * @param {boolean} trimHistory If the selection history should be trimmed up to the previous tab selection or not.
     * @returns {Tab}
     */
    Tabs.prototype.previousTab = function (trimHistory) {
        var _this = this;
        if (trimHistory === void 0) { trimHistory = true; }
        // walk backwards through the tab selection history
        // and find the first previous tab that is enabled and shown
        (void 0) /* console.debug */;
        for (var i = this._selectHistory.length - 2; i >= 0; i--) {
            var tab = this._tabs.find(function (t) { return t.id === _this._selectHistory[i]; });
            if (tab && tab.enabled && tab.show) {
                if (trimHistory) {
                    this._selectHistory.splice(i + 1);
                }
                return tab;
            }
        }
        return null;
    };
    /**
     * @param {number} index Index of the tab you want to get
     * @returns {Tab} Returns the tab who's index matches the one passed
     */
    Tabs.prototype.getByIndex = function (index) {
        return this._tabs[index];
    };
    /**
     * @return {Tab} Returns the currently selected tab
     */
    Tabs.prototype.getSelected = function () {
        var tabs = this._tabs;
        for (var i = 0; i < tabs.length; i++) {
            if (tabs[i].isSelected) {
                return tabs[i];
            }
        }
        return null;
    };
    /**
     * @internal
     */
    Tabs.prototype.getActiveChildNavs = function () {
        var selected = this.getSelected();
        return selected ? [selected] : [];
    };
    /**
     * @internal
     */
    Tabs.prototype.getAllChildNavs = function () {
        return this._tabs;
    };
    /**
     * @internal
     */
    Tabs.prototype.getIndex = function (tab) {
        return this._tabs.indexOf(tab);
    };
    /**
     * @internal
     */
    Tabs.prototype.length = function () {
        return this._tabs.length;
    };
    /**
     * "Touch" the active tab, going back to the root view of the tab
     * or optionally letting the tab handle the event
     */
    Tabs.prototype._updateCurrentTab = function (tab, fromUrl) {
        var active = tab.getActive();
        if (active) {
            if (fromUrl && tab._segment) {
                // see if the view controller exists
                var vc = tab.getViewById(tab._segment.name);
                if (vc) {
                    // the view is already in the stack
                    return tab.popTo(vc, {
                        animate: false,
                        updateUrl: false,
                    });
                }
                else if (tab._views.length === 0 && tab._segment.defaultHistory && tab._segment.defaultHistory.length) {
                    return this._linker.initViews(tab._segment).then(function (views) {
                        return tab.setPages(views, {
                            animate: false, updateUrl: false
                        });
                    }).then(function () {
                        tab._segment = null;
                    });
                }
                else {
                    return tab.setRoot(tab._segment.name, tab._segment.data, {
                        animate: false, updateUrl: false
                    }).then(function () {
                        tab._segment = null;
                    });
                }
            }
            else if (active._cmp && active._cmp.instance.ionSelected) {
                // if they have a custom tab selected handler, call it
                active._cmp.instance.ionSelected();
                return Promise.resolve();
            }
            else if (tab.length() > 1) {
                // if we're a few pages deep, pop to root
                return tab.popToRoot();
            }
            else {
                return Object(__WEBPACK_IMPORTED_MODULE_10__navigation_nav_util__["l" /* getComponent */])(this._linker, tab.root).then(function (viewController) {
                    if (viewController.component !== active.component) {
                        // Otherwise, if the page we're on is not our real root
                        // reset it to our default root type
                        return tab.setRoot(tab.root);
                    }
                }).catch(function () {
                    (void 0) /* console.debug */;
                });
            }
        }
    };
    /**
     * @internal
     * DOM WRITE
     */
    Tabs.prototype.setTabbarPosition = function (top, bottom) {
        if (this._top !== top || this._bottom !== bottom) {
            var tabbarEle = this._tabbar.nativeElement;
            tabbarEle.style.top = (top > -1 ? top + 'px' : '');
            tabbarEle.style.bottom = (bottom > -1 ? bottom + 'px' : '');
            tabbarEle.classList.add('show-tabbar');
            this._top = top;
            this._bottom = bottom;
        }
    };
    /**
     * @internal
     */
    Tabs.prototype.resize = function () {
        var tab = this.getSelected();
        tab && tab.resize();
    };
    /**
     * @internal
     */
    Tabs.prototype.initPane = function () {
        var isMain = this._elementRef.nativeElement.hasAttribute('main');
        return isMain;
    };
    /**
     * @internal
     */
    Tabs.prototype.paneChanged = function (isPane) {
        if (isPane) {
            this.resize();
        }
    };
    Tabs.prototype.goToRoot = function (opts) {
        if (this._tabs.length) {
            return this.select(this._tabs[0], opts);
        }
    };
    /*
     * @private
     */
    Tabs.prototype.getType = function () {
        return 'tabs';
    };
    /*
     * @private
     */
    Tabs.prototype.getSecondaryIdentifier = function () {
        var tabs = this.getActiveChildNavs();
        if (tabs && tabs.length) {
            return this._linker._getTabSelector(tabs[0]);
        }
        return '';
    };
    /**
     * @private
     */
    Tabs.prototype._getSelectedTabIndex = function (secondaryId, fallbackIndex) {
        if (secondaryId === void 0) { secondaryId = ''; }
        if (fallbackIndex === void 0) { fallbackIndex = 0; }
        // we found a segment which probably represents which tab to select
        var indexMatch = secondaryId.match(/tab-(\d+)/);
        if (indexMatch) {
            // awesome, the segment name was something "tab-0", and
            // the numbe represents which tab to select
            return parseInt(indexMatch[1], 10);
        }
        // wasn't in the "tab-0" format so maybe it's using a word
        var tab = this._tabs.find(function (t) {
            return (Object(__WEBPACK_IMPORTED_MODULE_7__util_util__["l" /* isPresent */])(t.tabUrlPath) && t.tabUrlPath === secondaryId) ||
                (Object(__WEBPACK_IMPORTED_MODULE_7__util_util__["l" /* isPresent */])(t.tabTitle) && Object(__WEBPACK_IMPORTED_MODULE_11__navigation_url_serializer__["c" /* formatUrlPart */])(t.tabTitle) === secondaryId);
        });
        return Object(__WEBPACK_IMPORTED_MODULE_7__util_util__["l" /* isPresent */])(tab) ? tab.index : fallbackIndex;
    };
    Tabs.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'ion-tabs',
                    template: '<div class="tabbar" role="tablist" #tabbar>' +
                        '<a *ngFor="let t of _tabs" [tab]="t" class="tab-button" role="tab" href="#" (ionSelect)="select(t)"></a>' +
                        '<div class="tab-highlight"></div>' +
                        '</div>' +
                        '<ng-content></ng-content>' +
                        '<div #portal tab-portal></div>',
                    encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None,
                    providers: [{ provide: __WEBPACK_IMPORTED_MODULE_12__split_pane_split_pane__["a" /* RootNode */], useExisting: Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return Tabs; }) }]
                },] },
    ];
    /** @nocollapse */
    Tabs.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_9__navigation_nav_controller__["a" /* NavController */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
        { type: __WEBPACK_IMPORTED_MODULE_15__navigation_view_controller__["a" /* ViewController */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
        { type: __WEBPACK_IMPORTED_MODULE_3__app_app__["a" /* App */], },
        { type: __WEBPACK_IMPORTED_MODULE_4__config_config__["a" /* Config */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_13__platform_platform__["a" /* Platform */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: __WEBPACK_IMPORTED_MODULE_5__navigation_deep_linker__["a" /* DeepLinker */], },
        { type: __WEBPACK_IMPORTED_MODULE_8__platform_keyboard__["a" /* Keyboard */], },
    ]; };
    Tabs.propDecorators = {
        'name': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'selectedIndex': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'tabsLayout': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'tabsPlacement': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'tabsHighlight': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'ionChange': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        '_highlight': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"], args: [__WEBPACK_IMPORTED_MODULE_14__tab_highlight__["a" /* TabHighlight */],] },],
        '_tabbar': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"], args: ['tabbar',] },],
        'portal': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"], args: ['portal', { read: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"] },] },],
    };
    return Tabs;
}(__WEBPACK_IMPORTED_MODULE_6__ion__["a" /* Ion */]));

var tabIds = -1;
//# sourceMappingURL=tabs.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/thumbnail/thumbnail.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Thumbnail; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");

/**
  * @name Thumbnail
  * @module ionic
  * @description
  * A Thumbnail is a component that creates a squared image for an item.
  * Thumbnails can be place on the left or right side of an item with the `item-start` or `item-end` directive.
  * @see {@link /docs/components/#thumbnail-list Thumbnail Component Docs}
 */
var Thumbnail = (function () {
    function Thumbnail() {
    }
    Thumbnail.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'ion-thumbnail'
                },] },
    ];
    /** @nocollapse */
    Thumbnail.ctorParameters = function () { return []; };
    return Thumbnail;
}());

//# sourceMappingURL=thumbnail.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/toast/toast-component.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ToastCmp; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__navigation_nav_params__ = __webpack_require__("./node_modules/ionic-angular/navigation/nav-params.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__navigation_view_controller__ = __webpack_require__("./node_modules/ionic-angular/navigation/view-controller.js");




/**
 * @hidden
 */
var ToastCmp = (function () {
    function ToastCmp(_viewCtrl, _config, _elementRef, params, renderer) {
        this._viewCtrl = _viewCtrl;
        this._config = _config;
        this._elementRef = _elementRef;
        this.dismissTimeout = undefined;
        renderer.setElementClass(_elementRef.nativeElement, "toast-" + _config.get('mode'), true);
        this.d = params.data;
        if (this.d.cssClass) {
            this.d.cssClass.split(' ').forEach(function (cssClass) {
                // Make sure the class isn't whitespace, otherwise it throws exceptions
                if (cssClass.trim() !== '')
                    renderer.setElementClass(_elementRef.nativeElement, cssClass, true);
            });
        }
        this.id = (++toastIds);
        if (this.d.message) {
            this.hdrId = 'toast-hdr-' + this.id;
        }
    }
    ToastCmp.prototype.ngAfterViewInit = function () {
        var _this = this;
        // if there's a `duration` set, automatically dismiss.
        if (this.d.duration) {
            this.dismissTimeout = setTimeout(function () {
                _this.dismiss('backdrop');
            }, this.d.duration);
        }
        this.enabled = true;
    };
    ToastCmp.prototype.ionViewDidEnter = function () {
        var activeElement = document.activeElement;
        if (activeElement) {
            activeElement.blur();
        }
        var focusableEle = this._elementRef.nativeElement.querySelector('button');
        if (focusableEle) {
            focusableEle.focus();
        }
    };
    ToastCmp.prototype.cbClick = function () {
        if (this.enabled) {
            this.dismiss('close');
        }
    };
    ToastCmp.prototype.dismiss = function (role) {
        clearTimeout(this.dismissTimeout);
        this.dismissTimeout = undefined;
        return this._viewCtrl.dismiss(null, role, { disableApp: false });
    };
    ToastCmp.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'ion-toast',
                    template: '<div class="toast-wrapper" ' +
                        '[class.toast-bottom]="d.position === \'bottom\'" ' +
                        '[class.toast-middle]="d.position === \'middle\'" ' +
                        '[class.toast-top]="d.position === \'top\'"> ' +
                        '<div class="toast-container"> ' +
                        '<div class="toast-message" id="{{hdrId}}" *ngIf="d.message">{{d.message}}</div> ' +
                        '<button ion-button clear class="toast-button" *ngIf="d.showCloseButton" (click)="cbClick()"> ' +
                        '{{ d.closeButtonText || \'Close\' }} ' +
                        '</button> ' +
                        '</div> ' +
                        '</div>',
                    host: {
                        'role': 'dialog',
                        '[attr.aria-labelledby]': 'hdrId',
                        '[attr.aria-describedby]': 'descId',
                    },
                },] },
    ];
    /** @nocollapse */
    ToastCmp.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_3__navigation_view_controller__["a" /* ViewController */], },
        { type: __WEBPACK_IMPORTED_MODULE_1__config_config__["a" /* Config */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_2__navigation_nav_params__["a" /* NavParams */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    ]; };
    return ToastCmp;
}());

var toastIds = -1;
//# sourceMappingURL=toast-component.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/toast/toast-controller.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ToastController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_app__ = __webpack_require__("./node_modules/ionic-angular/components/app/app.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toast__ = __webpack_require__("./node_modules/ionic-angular/components/toast/toast.js");




/**
 * @name ToastController
 * @description
 * A Toast is a subtle notification commonly used in modern applications.
 * It can be used to provide feedback about an operation or to
 * display a system message. The toast appears on top of the app's content,
 * and can be dismissed by the app to resume user interaction with
 * the app.
 *
 * ### Creating
 * All of the toast options should be passed in the first argument of
 * the create method: `create(opts)`. The message to display should be
 * passed in the `message` property. The `showCloseButton` option can be set to
 * true in order to display a close button on the toast. See the [create](#create)
 * method below for all available options.
 *
 * ### Positioning
 * Toasts can be positioned at the top, bottom or middle of the
 * view port. The position can be passed to the `Toast.create(opts)` method.
 * The position option is a string, and the values accepted are `top`, `bottom` and `middle`.
 * If the position is not specified, the toast will be displayed at the bottom of the view port.
 *
 * ### Dismissing
 * The toast can be dismissed automatically after a specific amount of time
 * by passing the number of milliseconds to display it in the `duration` of
 * the toast options. If `showCloseButton` is set to true, then the close button
 * will dismiss the toast. To dismiss the toast after creation, call the `dismiss()`
 * method on the Toast instance. The `onDidDismiss` function can be called to perform an action after the toast
 * is dismissed.
 *
 * @usage
 * ```ts
 * import { ToastController } from 'ionic-angular';
 *
 * constructor(public toastCtrl: ToastController) { }
 *
 * presentToast() {
 *   const toast = this.toastCtrl.create({
 *     message: 'User was added successfully',
 *     duration: 3000,
 *     position: 'top'
 *   });
 *
 *   toast.onDidDismiss(() => {
 *     console.log('Dismissed toast');
 *   });
 *
 *   toast.present();
 * }
 * ```
 * @advanced
 * | Property              | Type      | Default         | Description                                                                                                   |
 * |-----------------------|-----------|-----------------|---------------------------------------------------------------------------------------------------------------|
 * | message               | `string`  | -               | The message for the toast. Long strings will wrap and the toast container will expand.                        |
 * | duration              | `number`  | -               | How many milliseconds to wait before hiding the toast. By default, it will show until `dismiss()` is called.  |
 * | position              | `string`  | "bottom"        | The position of the toast on the screen. Accepted values: "top", "middle", "bottom".                          |
 * | cssClass              | `string`  | -               | Additional classes for custom styles, separated by spaces.                                                    |
 * | showCloseButton       | `boolean` | false           | Whether or not to show a button to close the toast.                                                           |
 * | closeButtonText       | `string`  | "Close"         | Text to display in the close button.                                                                          |
 * | dismissOnPageChange   | `boolean` | false           | Whether to dismiss the toast when navigating to a new page.                                                   |
 *
 * @demo /docs/demos/src/toast/
 */
var ToastController = (function () {
    function ToastController(_app, config) {
        this._app = _app;
        this.config = config;
    }
    /**
     * Create a new toast component. See options below
     * @param {ToastOptions} opts Toast options. See the below table for available options.
     */
    ToastController.prototype.create = function (opts) {
        if (opts === void 0) { opts = {}; }
        return new __WEBPACK_IMPORTED_MODULE_3__toast__["a" /* Toast */](this._app, opts, this.config);
    };
    ToastController.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    ToastController.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__app_app__["a" /* App */], },
        { type: __WEBPACK_IMPORTED_MODULE_2__config_config__["a" /* Config */], },
    ]; };
    return ToastController;
}());

//# sourceMappingURL=toast-controller.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/toast/toast-transitions.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ToastSlideIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ToastSlideOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ToastMdSlideIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ToastMdSlideOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ToastWpPopIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ToastWpPopOut; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__animations_animation__ = __webpack_require__("./node_modules/ionic-angular/animations/animation.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__transitions_transition__ = __webpack_require__("./node_modules/ionic-angular/transitions/transition.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var ToastSlideIn = (function (_super) {
    __extends(ToastSlideIn, _super);
    function ToastSlideIn() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ToastSlideIn.prototype.init = function () {
        // DOM READS
        var ele = this.enteringView.pageRef().nativeElement;
        var wrapperEle = ele.querySelector('.toast-wrapper');
        var wrapper = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](this.plt, wrapperEle);
        if (this.enteringView.data && this.enteringView.data.position === TOAST_POSITION_TOP) {
            // top
            // by default, it is -100% hidden (above the screen)
            // so move from that to 10px below top: 0px;
            wrapper.fromTo('translateY', '-100%', 10 + "px");
        }
        else if (this.enteringView.data && this.enteringView.data.position === TOAST_POSITION_MIDDLE) {
            // Middle
            // just center it and fade it in
            var topPosition = Math.floor(ele.clientHeight / 2 - wrapperEle.clientHeight / 2);
            // DOM WRITE
            wrapperEle.style.top = topPosition + "px";
            wrapper.fromTo('opacity', 0.01, 1);
        }
        else {
            // bottom
            // by default, it is 100% hidden (below the screen),
            // so move from that to 10 px above bottom: 0px
            wrapper.fromTo('translateY', '100%', 0 - 10 + "px");
        }
        this.easing('cubic-bezier(.36,.66,.04,1)').duration(400).add(wrapper);
    };
    return ToastSlideIn;
}(__WEBPACK_IMPORTED_MODULE_1__transitions_transition__["a" /* Transition */]));

var ToastSlideOut = (function (_super) {
    __extends(ToastSlideOut, _super);
    function ToastSlideOut() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ToastSlideOut.prototype.init = function () {
        var ele = this.leavingView.pageRef().nativeElement;
        var wrapperEle = ele.querySelector('.toast-wrapper');
        var wrapper = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](this.plt, wrapperEle);
        if (this.leavingView.data && this.leavingView.data.position === TOAST_POSITION_TOP) {
            // top
            // reverse arguments from enter transition
            wrapper.fromTo('translateY', 10 + "px", '-100%');
        }
        else if (this.leavingView.data && this.leavingView.data.position === TOAST_POSITION_MIDDLE) {
            // Middle
            // just fade it out
            wrapper.fromTo('opacity', 0.99, 0);
        }
        else {
            // bottom
            // reverse arguments from enter transition
            wrapper.fromTo('translateY', 0 - 10 + "px", '100%');
        }
        this.easing('cubic-bezier(.36,.66,.04,1)').duration(300).add(wrapper);
    };
    return ToastSlideOut;
}(__WEBPACK_IMPORTED_MODULE_1__transitions_transition__["a" /* Transition */]));

var ToastMdSlideIn = (function (_super) {
    __extends(ToastMdSlideIn, _super);
    function ToastMdSlideIn() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ToastMdSlideIn.prototype.init = function () {
        // DOM reads
        var ele = this.enteringView.pageRef().nativeElement;
        var wrapperEle = ele.querySelector('.toast-wrapper');
        var wrapper = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](this.plt, wrapperEle);
        if (this.enteringView.data && this.enteringView.data.position === TOAST_POSITION_TOP) {
            // top
            // by default, it is -100% hidden (above the screen)
            // so move from that to top: 0px;
            wrapper.fromTo('translateY', '-100%', "0%");
        }
        else if (this.enteringView.data && this.enteringView.data.position === TOAST_POSITION_MIDDLE) {
            // Middle
            // just center it and fade it in
            var topPosition = Math.floor(ele.clientHeight / 2 - wrapperEle.clientHeight / 2);
            // DOM WRITE
            wrapperEle.style.top = topPosition + "px";
            wrapper.fromTo('opacity', 0.01, 1);
        }
        else {
            // bottom
            // by default, it is 100% hidden (below the screen),
            // so move from that to bottom: 0px
            wrapper.fromTo('translateY', '100%', "0%");
        }
        this.easing('cubic-bezier(.36,.66,.04,1)').duration(400).add(wrapper);
    };
    return ToastMdSlideIn;
}(__WEBPACK_IMPORTED_MODULE_1__transitions_transition__["a" /* Transition */]));

var ToastMdSlideOut = (function (_super) {
    __extends(ToastMdSlideOut, _super);
    function ToastMdSlideOut() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ToastMdSlideOut.prototype.init = function () {
        var ele = this.leavingView.pageRef().nativeElement;
        var wrapperEle = ele.querySelector('.toast-wrapper');
        var wrapper = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](this.plt, wrapperEle);
        if (this.leavingView.data && this.leavingView.data.position === TOAST_POSITION_TOP) {
            // top
            // reverse arguments from enter transition
            wrapper.fromTo('translateY', 0 + "%", '-100%');
        }
        else if (this.leavingView.data && this.leavingView.data.position === TOAST_POSITION_MIDDLE) {
            // Middle
            // just fade it out
            wrapper.fromTo('opacity', 0.99, 0);
        }
        else {
            // bottom
            // reverse arguments from enter transition
            wrapper.fromTo('translateY', 0 + "%", '100%');
        }
        this.easing('cubic-bezier(.36,.66,.04,1)').duration(450).add(wrapper);
    };
    return ToastMdSlideOut;
}(__WEBPACK_IMPORTED_MODULE_1__transitions_transition__["a" /* Transition */]));

var ToastWpPopIn = (function (_super) {
    __extends(ToastWpPopIn, _super);
    function ToastWpPopIn() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ToastWpPopIn.prototype.init = function () {
        var ele = this.enteringView.pageRef().nativeElement;
        var wrapperEle = ele.querySelector('.toast-wrapper');
        var wrapper = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](this.plt, wrapperEle);
        if (this.enteringView.data && this.enteringView.data.position === TOAST_POSITION_TOP) {
            // top
            wrapper.fromTo('opacity', 0.01, 1);
            wrapper.fromTo('scale', 1.3, 1);
        }
        else if (this.enteringView.data && this.enteringView.data.position === TOAST_POSITION_MIDDLE) {
            // Middle
            // just center it and fade it in
            var topPosition = Math.floor(ele.clientHeight / 2 - wrapperEle.clientHeight / 2);
            // DOM WRITE
            wrapperEle.style.top = topPosition + "px";
            wrapper.fromTo('opacity', 0.01, 1);
            wrapper.fromTo('scale', 1.3, 1);
        }
        else {
            // bottom
            wrapper.fromTo('opacity', 0.01, 1);
            wrapper.fromTo('scale', 1.3, 1);
        }
        this.easing('cubic-bezier(0,0,0.05,1)').duration(200).add(wrapper);
    };
    return ToastWpPopIn;
}(__WEBPACK_IMPORTED_MODULE_1__transitions_transition__["a" /* Transition */]));

var ToastWpPopOut = (function (_super) {
    __extends(ToastWpPopOut, _super);
    function ToastWpPopOut() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ToastWpPopOut.prototype.init = function () {
        // DOM reads
        var ele = this.leavingView.pageRef().nativeElement;
        var wrapperEle = ele.querySelector('.toast-wrapper');
        var wrapper = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](this.plt, wrapperEle);
        if (this.leavingView.data && this.leavingView.data.position === TOAST_POSITION_TOP) {
            // top
            // reverse arguments from enter transition
            wrapper.fromTo('opacity', 0.99, 0);
            wrapper.fromTo('scale', 1, 1.3);
        }
        else if (this.leavingView.data && this.leavingView.data.position === TOAST_POSITION_MIDDLE) {
            // Middle
            // just fade it out
            wrapper.fromTo('opacity', 0.99, 0);
            wrapper.fromTo('scale', 1, 1.3);
        }
        else {
            // bottom
            // reverse arguments from enter transition
            wrapper.fromTo('opacity', 0.99, 0);
            wrapper.fromTo('scale', 1, 1.3);
        }
        // DOM writes
        var EASE = 'ease-out';
        var DURATION = 150;
        this.easing(EASE).duration(DURATION).add(wrapper);
    };
    return ToastWpPopOut;
}(__WEBPACK_IMPORTED_MODULE_1__transitions_transition__["a" /* Transition */]));

var TOAST_POSITION_TOP = 'top';
var TOAST_POSITION_MIDDLE = 'middle';
//# sourceMappingURL=toast-transitions.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/toast/toast.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Toast; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_app_constants__ = __webpack_require__("./node_modules/ionic-angular/components/app/app-constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toast_component__ = __webpack_require__("./node_modules/ionic-angular/components/toast/toast-component.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toast_transitions__ = __webpack_require__("./node_modules/ionic-angular/components/toast/toast-transitions.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__navigation_view_controller__ = __webpack_require__("./node_modules/ionic-angular/navigation/view-controller.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





/**
 * @hidden
 */
var Toast = (function (_super) {
    __extends(Toast, _super);
    function Toast(app, opts, config) {
        if (opts === void 0) { opts = {}; }
        var _this = this;
        opts.dismissOnPageChange = Object(__WEBPACK_IMPORTED_MODULE_0__util_util__["l" /* isPresent */])(opts.dismissOnPageChange) ? !!opts.dismissOnPageChange : false;
        _this = _super.call(this, __WEBPACK_IMPORTED_MODULE_2__toast_component__["a" /* ToastCmp */], opts, null) || this;
        _this._app = app;
        // set the position to the bottom if not provided
        if (!opts.position || !_this.isValidPosition(opts.position)) {
            opts.position = TOAST_POSITION_BOTTOM;
        }
        _this.isOverlay = true;
        config.setTransition('toast-slide-in', __WEBPACK_IMPORTED_MODULE_3__toast_transitions__["c" /* ToastSlideIn */]);
        config.setTransition('toast-slide-out', __WEBPACK_IMPORTED_MODULE_3__toast_transitions__["d" /* ToastSlideOut */]);
        config.setTransition('toast-md-slide-in', __WEBPACK_IMPORTED_MODULE_3__toast_transitions__["a" /* ToastMdSlideIn */]);
        config.setTransition('toast-md-slide-out', __WEBPACK_IMPORTED_MODULE_3__toast_transitions__["b" /* ToastMdSlideOut */]);
        config.setTransition('toast-wp-slide-out', __WEBPACK_IMPORTED_MODULE_3__toast_transitions__["f" /* ToastWpPopOut */]);
        config.setTransition('toast-wp-slide-in', __WEBPACK_IMPORTED_MODULE_3__toast_transitions__["e" /* ToastWpPopIn */]);
        return _this;
    }
    /**
    * @hidden
    */
    Toast.prototype.getTransitionName = function (direction) {
        var key = 'toast' + (direction === 'back' ? 'Leave' : 'Enter');
        return this._nav && this._nav.config.get(key);
    };
    /**
    * @hidden
    */
    Toast.prototype.isValidPosition = function (position) {
        return position === TOAST_POSITION_TOP || position === TOAST_POSITION_MIDDLE || position === TOAST_POSITION_BOTTOM;
    };
    /**
     * @param {string} message  Toast message content
     */
    Toast.prototype.setMessage = function (message) {
        this.data.message = message;
        return this;
    };
    /**
     * @param {number} dur  Toast message duration
     */
    Toast.prototype.setDuration = function (dur) {
        this.data.duration = dur;
        return this;
    };
    /**
     * @param {'top'|'middle'|'bottom'} pos  Toast message position
     */
    Toast.prototype.setPosition = function (pos) {
        this.data.position = pos;
        return this;
    };
    /**
     * @param {string} cssClass  Toast message CSS class
     */
    Toast.prototype.setCssClass = function (cssClass) {
        this.data.cssClass = cssClass;
        return this;
    };
    /**
     * @param {boolean} closeButton  Toast message close button
     */
    Toast.prototype.setShowCloseButton = function (closeButton) {
        this.data.showCloseButton = closeButton;
        return this;
    };
    /**
     * Present the toast instance.
     *
     * @param {NavOptions} [navOptions={}] Nav options to go with this transition.
     * @returns {Promise} Returns a promise which is resolved when the transition has completed.
     */
    Toast.prototype.present = function (navOptions) {
        if (navOptions === void 0) { navOptions = {}; }
        navOptions.disableApp = false;
        navOptions.keyboardClose = false;
        return this._app.present(this, navOptions, __WEBPACK_IMPORTED_MODULE_1__app_app_constants__["d" /* PORTAL_TOAST */]);
    };
    /**
     * Dismiss all toast components which have been presented.
     */
    Toast.prototype.dismissAll = function () {
        this._nav && this._nav.popAll();
    };
    return Toast;
}(__WEBPACK_IMPORTED_MODULE_4__navigation_view_controller__["a" /* ViewController */]));

var TOAST_POSITION_TOP = 'top';
var TOAST_POSITION_MIDDLE = 'middle';
var TOAST_POSITION_BOTTOM = 'bottom';
//# sourceMappingURL=toast.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/toggle/toggle-gesture.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ToggleGesture; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gestures_gesture_controller__ = __webpack_require__("./node_modules/ionic-angular/gestures/gesture-controller.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gestures_pan_gesture__ = __webpack_require__("./node_modules/ionic-angular/gestures/pan-gesture.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_dom__ = __webpack_require__("./node_modules/ionic-angular/util/dom.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



/**
 * @hidden
 */
var ToggleGesture = (function (_super) {
    __extends(ToggleGesture, _super);
    function ToggleGesture(plt, toggle, gestureCtrl, domCtrl) {
        var _this = _super.call(this, plt, toggle.getNativeElement(), {
            threshold: 0,
            zone: false,
            domController: domCtrl,
            gesture: gestureCtrl.createGesture({
                name: __WEBPACK_IMPORTED_MODULE_0__gestures_gesture_controller__["l" /* GESTURE_TOGGLE */],
                priority: __WEBPACK_IMPORTED_MODULE_0__gestures_gesture_controller__["j" /* GESTURE_PRIORITY_TOGGLE */]
            })
        }) || this;
        _this.toggle = toggle;
        return _this;
    }
    ToggleGesture.prototype.canStart = function () {
        return true;
    };
    ToggleGesture.prototype.onDragStart = function (ev) {
        ev.preventDefault();
        this.toggle._onDragStart(Object(__WEBPACK_IMPORTED_MODULE_2__util_dom__["f" /* pointerCoord */])(ev).x);
    };
    ToggleGesture.prototype.onDragMove = function (ev) {
        ev.preventDefault();
        this.toggle._onDragMove(Object(__WEBPACK_IMPORTED_MODULE_2__util_dom__["f" /* pointerCoord */])(ev).x);
    };
    ToggleGesture.prototype.onDragEnd = function (ev) {
        ev.preventDefault();
        this.toggle._onDragEnd(Object(__WEBPACK_IMPORTED_MODULE_2__util_dom__["f" /* pointerCoord */])(ev).x);
    };
    return ToggleGesture;
}(__WEBPACK_IMPORTED_MODULE_1__gestures_pan_gesture__["a" /* PanGesture */]));

//# sourceMappingURL=toggle-gesture.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/toggle/toggle.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Toggle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__("./node_modules/@angular/forms/esm5/forms.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__platform_dom_controller__ = __webpack_require__("./node_modules/ionic-angular/platform/dom-controller.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_form__ = __webpack_require__("./node_modules/ionic-angular/util/form.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__gestures_gesture_controller__ = __webpack_require__("./node_modules/ionic-angular/gestures/gesture-controller.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tap_click_haptic__ = __webpack_require__("./node_modules/ionic-angular/tap-click/haptic.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_base_input__ = __webpack_require__("./node_modules/ionic-angular/util/base-input.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__item_item__ = __webpack_require__("./node_modules/ionic-angular/components/item/item.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__platform_key__ = __webpack_require__("./node_modules/ionic-angular/platform/key.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__platform_platform__ = __webpack_require__("./node_modules/ionic-angular/platform/platform.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__toggle_gesture__ = __webpack_require__("./node_modules/ionic-angular/components/toggle/toggle-gesture.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();













/**
 * @name Toggle
 * @description
 * A toggle technically is the same thing as an HTML checkbox input,
 * except it looks different and is easier to use on a touch device.
 * Toggles can also have colors assigned to them, by adding any color
 * attribute.
 *
 * See the [Angular Docs](https://angular.io/docs/ts/latest/guide/forms)
 * for more info on forms and inputs.
 *
 * @usage
 * ```html
 *
 *  <ion-list>
 *
 *    <ion-item>
 *      <ion-label>Pepperoni</ion-label>
 *      <ion-toggle [(ngModel)]="pepperoni"></ion-toggle>
 *    </ion-item>
 *
 *    <ion-item>
 *      <ion-label>Sausage</ion-label>
 *      <ion-toggle [(ngModel)]="sausage" disabled="true"></ion-toggle>
 *    </ion-item>
 *
 *    <ion-item>
 *      <ion-label>Mushrooms</ion-label>
 *      <ion-toggle [(ngModel)]="mushrooms"></ion-toggle>
 *    </ion-item>
 *
 *  </ion-list>
 * ```
 *
 * @demo /docs/demos/src/toggle/
 * @see {@link /docs/components#toggle Toggle Component Docs}
 */
var Toggle = (function (_super) {
    __extends(Toggle, _super);
    function Toggle(form, config, _plt, elementRef, renderer, _haptic, item, _gestureCtrl, _domCtrl, _zone) {
        var _this = _super.call(this, config, elementRef, renderer, 'toggle', false, form, item, null) || this;
        _this._plt = _plt;
        _this._haptic = _haptic;
        _this._gestureCtrl = _gestureCtrl;
        _this._domCtrl = _domCtrl;
        _this._zone = _zone;
        _this._activated = false;
        return _this;
    }
    Object.defineProperty(Toggle.prototype, "checked", {
        /**
         * @input {boolean} If true, the element is selected.
         */
        get: function () {
            return this.value;
        },
        set: function (val) {
            this.value = val;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @hidden
     */
    Toggle.prototype.ngAfterContentInit = function () {
        this._initialize();
        this._gesture = new __WEBPACK_IMPORTED_MODULE_12__toggle_gesture__["a" /* ToggleGesture */](this._plt, this, this._gestureCtrl, this._domCtrl);
        this._gesture.listen();
    };
    /**
     * @hidden
     */
    Toggle.prototype._inputUpdated = function () { };
    /**
     * @hidden
     */
    Toggle.prototype._inputNormalize = function (val) {
        return Object(__WEBPACK_IMPORTED_MODULE_7__util_util__["o" /* isTrueProperty */])(val);
    };
    /**
     * @hidden
     */
    Toggle.prototype._onDragStart = function (startX) {
        var _this = this;
        (void 0) /* assert */;
        (void 0) /* console.debug */;
        this._zone.run(function () {
            _this._startX = startX;
            _this._fireFocus();
            _this._activated = true;
        });
    };
    /**
     * @hidden
     */
    Toggle.prototype._onDragMove = function (currentX) {
        var _this = this;
        if (!this._startX) {
            (void 0) /* assert */;
            return;
        }
        if (this._shouldToggle(currentX, -15)) {
            this._zone.run(function () {
                _this.value = !_this.value;
                _this._startX = currentX;
                _this._haptic.selection();
            });
        }
    };
    /**
     * @hidden
     */
    Toggle.prototype._onDragEnd = function (endX) {
        var _this = this;
        if (!this._startX) {
            (void 0) /* assert */;
            return;
        }
        (void 0) /* console.debug */;
        this._zone.run(function () {
            if (_this._shouldToggle(endX, 4)) {
                _this.value = !_this.value;
                _this._haptic.selection();
            }
            _this._activated = false;
            _this._fireBlur();
            _this._startX = null;
        });
    };
    /**
     * @hidden
     */
    Toggle.prototype._shouldToggle = function (currentX, margin) {
        var isLTR = !this._plt.isRTL;
        var startX = this._startX;
        if (this._value) {
            return (isLTR && (startX + margin > currentX)) ||
                (!isLTR && (startX - margin < currentX));
        }
        else {
            return (isLTR && (startX - margin < currentX)) ||
                (!isLTR && (startX + margin > currentX));
        }
    };
    /**
     * @hidden
     */
    Toggle.prototype._keyup = function (ev) {
        if (ev.keyCode === __WEBPACK_IMPORTED_MODULE_10__platform_key__["f" /* KEY_SPACE */] || ev.keyCode === __WEBPACK_IMPORTED_MODULE_10__platform_key__["b" /* KEY_ENTER */]) {
            (void 0) /* console.debug */;
            ev.preventDefault();
            ev.stopPropagation();
            this.value = !this.value;
        }
    };
    /**
     * @hidden
     */
    Toggle.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        this._gesture && this._gesture.destroy();
    };
    Toggle.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'ion-toggle',
                    template: '<div class="toggle-icon">' +
                        '<div class="toggle-inner"></div>' +
                        '</div>' +
                        '<button role="checkbox" ' +
                        'type="button" ' +
                        'ion-button="item-cover" ' +
                        '[id]="id" ' +
                        '[attr.aria-checked]="_value" ' +
                        '[attr.aria-labelledby]="_labelId" ' +
                        '[attr.aria-disabled]="_disabled" ' +
                        'class="item-cover" disable-activated>' +
                        '</button>',
                    host: {
                        '[class.toggle-disabled]': '_disabled',
                        '[class.toggle-checked]': '_value',
                        '[class.toggle-activated]': '_activated',
                    },
                    providers: [{ provide: __WEBPACK_IMPORTED_MODULE_1__angular_forms__["NG_VALUE_ACCESSOR"], useExisting: Toggle, multi: true }],
                    encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None,
                },] },
    ];
    /** @nocollapse */
    Toggle.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_4__util_form__["a" /* Form */], },
        { type: __WEBPACK_IMPORTED_MODULE_2__config_config__["a" /* Config */], },
        { type: __WEBPACK_IMPORTED_MODULE_11__platform_platform__["a" /* Platform */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: __WEBPACK_IMPORTED_MODULE_6__tap_click_haptic__["a" /* Haptic */], },
        { type: __WEBPACK_IMPORTED_MODULE_9__item_item__["a" /* Item */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
        { type: __WEBPACK_IMPORTED_MODULE_5__gestures_gesture_controller__["m" /* GestureController */], },
        { type: __WEBPACK_IMPORTED_MODULE_3__platform_dom_controller__["a" /* DomController */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"], },
    ]; };
    Toggle.propDecorators = {
        'checked': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        '_keyup': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"], args: ['keyup', ['$event'],] },],
    };
    return Toggle;
}(__WEBPACK_IMPORTED_MODULE_8__util_base_input__["a" /* BaseInput */]));

//# sourceMappingURL=toggle.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/toolbar/navbar.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Navbar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_app__ = __webpack_require__("./node_modules/ionic-angular/components/app/app.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__navigation_nav_controller__ = __webpack_require__("./node_modules/ionic-angular/navigation/nav-controller.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__toolbar_base__ = __webpack_require__("./node_modules/ionic-angular/components/toolbar/toolbar-base.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__navigation_view_controller__ = __webpack_require__("./node_modules/ionic-angular/navigation/view-controller.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();







/**
 * @name Navbar
 * @description
 * Navbar acts as the navigational toolbar, which also comes with a back
 * button. A navbar can contain a `ion-title`, any number of buttons,
 * a segment, or a searchbar. Navbars must be placed within an
 * `<ion-header>` in order for them to be placed above the content.
 * It's important to note that navbar's are part of the dynamic navigation
 * stack. If you need a static toolbar, use ion-toolbar.
 *
 * @usage
 * ```html
 * <ion-header>
 *
 *   <ion-navbar>
 *     <button ion-button icon-only menuToggle>
 *       <ion-icon name="menu"></ion-icon>
 *     </button>
 *
 *     <ion-title>
 *       Page Title
 *     </ion-title>
 *
 *     <ion-buttons end>
 *       <button ion-button icon-only (click)="openModal()">
 *         <ion-icon name="options"></ion-icon>
 *       </button>
 *     </ion-buttons>
 *   </ion-navbar>
 *
 * </ion-header>
 * ```
 *
 * @demo /docs/demos/src/navbar/
 * @see {@link ../../toolbar/Toolbar/ Toolbar API Docs}
 */
var Navbar = (function (_super) {
    __extends(Navbar, _super);
    function Navbar(_app, viewCtrl, navCtrl, config, elementRef, renderer) {
        var _this = _super.call(this, config, elementRef, renderer) || this;
        _this._app = _app;
        _this.navCtrl = navCtrl;
        /**
         * @hidden
         */
        _this._hidden = false;
        /**
         * @hidden
         */
        _this._hideBb = false;
        viewCtrl && viewCtrl._setNavbar(_this);
        _this._bbIcon = config.get('backButtonIcon');
        _this._sbPadding = config.getBoolean('statusbarPadding');
        _this._backText = config.get('backButtonText', 'Back');
        return _this;
    }
    Object.defineProperty(Navbar.prototype, "hideBackButton", {
        /**
         * @input {boolean} If true, the back button will be hidden.
         */
        get: function () {
            return this._hideBb;
        },
        set: function (val) {
            this._hideBb = Object(__WEBPACK_IMPORTED_MODULE_3__util_util__["o" /* isTrueProperty */])(val);
        },
        enumerable: true,
        configurable: true
    });
    Navbar.prototype.backButtonClick = function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        this.navCtrl && this.navCtrl.pop(null, null);
    };
    /**
     * Set the text of the Back Button in the Nav Bar. Defaults to "Back".
     */
    Navbar.prototype.setBackButtonText = function (text) {
        this._backText = text;
    };
    /**
     * @hidden
     */
    Navbar.prototype.didEnter = function () {
        try {
            this._app.setTitle(this.getTitleText());
        }
        catch (e) {
            console.error(e);
        }
    };
    /**
     * @hidden
     */
    Navbar.prototype.setHidden = function (isHidden) {
        // used to display none/block the navbar
        this._hidden = isHidden;
    };
    Navbar.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'ion-navbar',
                    template: '<div class="toolbar-background" [ngClass]="\'toolbar-background-\' + _mode"></div>' +
                        '<button (click)="backButtonClick($event)" ion-button="bar-button" class="back-button" [ngClass]="\'back-button-\' + _mode" [hidden]="_hideBb">' +
                        '<ion-icon class="back-button-icon" [ngClass]="\'back-button-icon-\' + _mode" [name]="_bbIcon"></ion-icon>' +
                        '<span class="back-button-text" [ngClass]="\'back-button-text-\' + _mode">{{_backText}}</span>' +
                        '</button>' +
                        '<ng-content select="[menuToggle],ion-buttons[left]"></ng-content>' +
                        '<ng-content select="ion-buttons[start]"></ng-content>' +
                        '<ng-content select="ion-buttons[end],ion-buttons[right]"></ng-content>' +
                        '<div class="toolbar-content" [ngClass]="\'toolbar-content-\' + _mode">' +
                        '<ng-content></ng-content>' +
                        '</div>',
                    host: {
                        '[hidden]': '_hidden',
                        'class': 'toolbar',
                        '[class.statusbar-padding]': '_sbPadding'
                    }
                },] },
    ];
    /** @nocollapse */
    Navbar.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__app_app__["a" /* App */], },
        { type: __WEBPACK_IMPORTED_MODULE_6__navigation_view_controller__["a" /* ViewController */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
        { type: __WEBPACK_IMPORTED_MODULE_4__navigation_nav_controller__["a" /* NavController */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
        { type: __WEBPACK_IMPORTED_MODULE_2__config_config__["a" /* Config */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    ]; };
    Navbar.propDecorators = {
        'hideBackButton': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return Navbar;
}(__WEBPACK_IMPORTED_MODULE_5__toolbar_base__["a" /* ToolbarBase */]));

//# sourceMappingURL=navbar.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/toolbar/toolbar-base.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ToolbarBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ion__ = __webpack_require__("./node_modules/ionic-angular/components/ion.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

/**
 * @hidden
 */
var ToolbarBase = (function (_super) {
    __extends(ToolbarBase, _super);
    function ToolbarBase(config, elementRef, renderer) {
        return _super.call(this, config, elementRef, renderer, 'toolbar') || this;
    }
    /**
     * @hidden
     */
    ToolbarBase.prototype._setTitle = function (titleCmp) {
        this._title = titleCmp;
    };
    /**
     * @hidden
     * Returns the toolbar title text if it exists or an empty string
     */
    ToolbarBase.prototype.getTitleText = function () {
        return (this._title && this._title.getTitleText()) || '';
    };
    return ToolbarBase;
}(__WEBPACK_IMPORTED_MODULE_0__ion__["a" /* Ion */]));

//# sourceMappingURL=toolbar-base.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/toolbar/toolbar-footer.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Footer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ion__ = __webpack_require__("./node_modules/ionic-angular/components/ion.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__navigation_view_controller__ = __webpack_require__("./node_modules/ionic-angular/navigation/view-controller.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




/**
 * @name Footer
 * @description
 * Footer is a root component of a page that sits at the bottom of the page.
 * Footer can be a wrapper for `ion-toolbar` to make sure the content area is sized correctly.
 *
 * @usage
 *
 * ```html
 * <ion-content></ion-content>
 *
 * <ion-footer>
 *   <ion-toolbar>
 *     <ion-title>Footer</ion-title>
 *   </ion-toolbar>
 * </ion-footer>
 * ```
 *
 */
var Footer = (function (_super) {
    __extends(Footer, _super);
    function Footer(config, elementRef, renderer, viewCtrl) {
        var _this = _super.call(this, config, elementRef, renderer, 'footer') || this;
        viewCtrl && viewCtrl._setFooter(_this);
        return _this;
    }
    Footer.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'ion-footer'
                },] },
    ];
    /** @nocollapse */
    Footer.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__config_config__["a" /* Config */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: __WEBPACK_IMPORTED_MODULE_3__navigation_view_controller__["a" /* ViewController */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
    ]; };
    return Footer;
}(__WEBPACK_IMPORTED_MODULE_2__ion__["a" /* Ion */]));

//# sourceMappingURL=toolbar-footer.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/toolbar/toolbar-header.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Header; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ion__ = __webpack_require__("./node_modules/ionic-angular/components/ion.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__navigation_view_controller__ = __webpack_require__("./node_modules/ionic-angular/navigation/view-controller.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




/**
 * @name Header
 * @description
 * Header is a parent component that holds the navbar and toolbar component.
 * It's important to note that `ion-header` needs to be one of the three root elements of a page
 *
 * @usage
 *
 * ```html
 * <ion-header>
 *   <ion-navbar>
 *     <ion-title>Page1</ion-title>
 *   </ion-navbar>
 *
 *   <ion-toolbar>
 *     <ion-title>Subheader</ion-title>
 *   </ion-toolbar>
 * </ion-header>
 *
 * <ion-content></ion-content>
 * ```
 *
 */
var Header = (function (_super) {
    __extends(Header, _super);
    function Header(config, elementRef, renderer, viewCtrl) {
        var _this = _super.call(this, config, elementRef, renderer, 'header') || this;
        viewCtrl && viewCtrl._setHeader(_this);
        return _this;
    }
    Header.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'ion-header'
                },] },
    ];
    /** @nocollapse */
    Header.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__config_config__["a" /* Config */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: __WEBPACK_IMPORTED_MODULE_3__navigation_view_controller__["a" /* ViewController */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
    ]; };
    return Header;
}(__WEBPACK_IMPORTED_MODULE_2__ion__["a" /* Ion */]));

//# sourceMappingURL=toolbar-header.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/toolbar/toolbar-item.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ToolbarItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__button_button__ = __webpack_require__("./node_modules/ionic-angular/components/button/button.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ion__ = __webpack_require__("./node_modules/ionic-angular/components/ion.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__navbar__ = __webpack_require__("./node_modules/ionic-angular/components/toolbar/navbar.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__toolbar__ = __webpack_require__("./node_modules/ionic-angular/components/toolbar/toolbar.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






/**
 * @hidden
 */
var ToolbarItem = (function (_super) {
    __extends(ToolbarItem, _super);
    function ToolbarItem(config, elementRef, renderer, toolbar, navbar) {
        var _this = _super.call(this, config, elementRef, renderer, 'bar-buttons') || this;
        _this.inToolbar = !!(toolbar || navbar);
        return _this;
    }
    Object.defineProperty(ToolbarItem.prototype, "_buttons", {
        set: function (buttons) {
            if (this.inToolbar) {
                buttons.forEach(function (button) {
                    button.setRole('bar-button');
                });
            }
        },
        enumerable: true,
        configurable: true
    });
    ToolbarItem.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'ion-buttons,[menuToggle]'
                },] },
    ];
    /** @nocollapse */
    ToolbarItem.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_2__config_config__["a" /* Config */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: __WEBPACK_IMPORTED_MODULE_5__toolbar__["a" /* Toolbar */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
        { type: __WEBPACK_IMPORTED_MODULE_4__navbar__["a" /* Navbar */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return __WEBPACK_IMPORTED_MODULE_4__navbar__["a" /* Navbar */]; }),] },] },
    ]; };
    ToolbarItem.propDecorators = {
        '_buttons': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChildren"], args: [__WEBPACK_IMPORTED_MODULE_1__button_button__["a" /* Button */],] },],
    };
    return ToolbarItem;
}(__WEBPACK_IMPORTED_MODULE_3__ion__["a" /* Ion */]));

//# sourceMappingURL=toolbar-item.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/toolbar/toolbar-title.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ToolbarTitle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ion__ = __webpack_require__("./node_modules/ionic-angular/components/ion.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__navbar__ = __webpack_require__("./node_modules/ionic-angular/components/toolbar/navbar.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__toolbar__ = __webpack_require__("./node_modules/ionic-angular/components/toolbar/toolbar.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





/**
 * @name Title
 * @description
 * `ion-title` is a component that sets the title of the `Toolbar` or `Navbar`
 *
 * @usage
 *
 * ```html
 * <ion-header>
 *
 *   <ion-navbar>
 *     <ion-title>Settings</ion-title>
 *   </ion-navbar>
 *
 * </ion-header>
 * ```
 *
 * Or to create a navbar with a toolbar as a subheader:
 *
 * ```html
 * <ion-header>
 *
 *   <ion-navbar>
 *     <ion-title>Main Header</ion-title>
 *   </ion-navbar>
 *
 *   <ion-toolbar>
 *     <ion-title>Subheader</ion-title>
 *   </ion-toolbar>
 *
 * </ion-header>
 * ```
 *
 * @demo /docs/demos/src/title/
 */
var ToolbarTitle = (function (_super) {
    __extends(ToolbarTitle, _super);
    function ToolbarTitle(config, elementRef, renderer, toolbar, navbar) {
        var _this = _super.call(this, config, elementRef, renderer, 'title') || this;
        toolbar && toolbar._setTitle(_this);
        navbar && navbar._setTitle(_this);
        return _this;
    }
    /**
     * @hidden
     */
    ToolbarTitle.prototype.getTitleText = function () {
        return this._elementRef.nativeElement.textContent;
    };
    ToolbarTitle.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'ion-title',
                    template: '<div class="toolbar-title" [ngClass]="\'toolbar-title-\' + _mode">' +
                        '<ng-content></ng-content>' +
                        '</div>',
                    changeDetection: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectionStrategy"].OnPush,
                    encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None,
                },] },
    ];
    /** @nocollapse */
    ToolbarTitle.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__config_config__["a" /* Config */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: __WEBPACK_IMPORTED_MODULE_4__toolbar__["a" /* Toolbar */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
        { type: __WEBPACK_IMPORTED_MODULE_3__navbar__["a" /* Navbar */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return __WEBPACK_IMPORTED_MODULE_3__navbar__["a" /* Navbar */]; }),] },] },
    ]; };
    return ToolbarTitle;
}(__WEBPACK_IMPORTED_MODULE_2__ion__["a" /* Ion */]));

//# sourceMappingURL=toolbar-title.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/toolbar/toolbar.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Toolbar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toolbar_base__ = __webpack_require__("./node_modules/ionic-angular/components/toolbar/toolbar-base.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



/**
 * @name Toolbar
 * @description
 * A Toolbar is a generic bar that is positioned above or below content.
 * Unlike a [Navbar](../Navbar/), a toolbar can be used as a subheader.
 * When toolbars are placed within an `<ion-header>` or `<ion-footer>`,
 * the toolbars stay fixed in their respective location. When placed within
 * `<ion-content>`, toolbars will scroll with the content.
 *
 *
 * ### Buttons in a Toolbar
 * Buttons placed in a toolbar should be placed inside of the `<ion-buttons>`
 * element. An exception to this is a [menuToggle](../../menu/MenuToggle) button.
 * It should not be placed inside of the `<ion-buttons>` element. Both the
 * `<ion-buttons>` element and the `menuToggle` can be positioned inside of the
 * toolbar using different properties. The below chart has a description of each
 * property.
 *
 * | Property    | Description                                                                                                           |
 * |-------------|-----------------------------------------------------------------------------------------------------------------------|
 * | `start`     | Positions element to the left of the content in `ios` mode, and directly to the right in `md` and `wp` mode.    |
 * | `end`       | Positions element to the right of the content in `ios` mode, and to the far right in `md` and `wp` mode.        |
 * | `left`      | Positions element to the left of all other elements.                                                            |
 * | `right`     | Positions element to the right of all other elements.                                                           |
 *
 *
 * ### Header / Footer Box Shadow and Border
 * In `md` mode, the `<ion-header>` will receive a box-shadow on the bottom, and the
 * `<ion-footer>` will receive a box-shadow on the top.  In `ios` mode, the `<ion-header>`
 * will receive a border on the bottom, and the `<ion-footer>` will receive a border on the
 * top. Both the `md` box-shadow and the `ios` border can be removed by adding the `no-border`
 * attribute to the element.
 *
 * ```html
 * <ion-header no-border>
 *   <ion-toolbar>
 *     <ion-title>Header</ion-title>
 *   </ion-toolbar>
 * </ion-header>
 *
 * <ion-content>
 * </ion-content>
 *
 * <ion-footer no-border>
 *   <ion-toolbar>
 *     <ion-title>Footer</ion-title>
 *   </ion-toolbar>
 * </ion-footer>
 * ```
 *
 * @usage
 *
 * ```html
 *
 * <ion-header no-border>
 *
 *   <ion-toolbar>
 *     <ion-title>My Toolbar Title</ion-title>
 *   </ion-toolbar>
 *
 *   <ion-toolbar>
 *     <ion-title>I'm a subheader</ion-title>
 *   </ion-toolbar>
 *
 * <ion-header>
 *
 *
 * <ion-content>
 *
 *   <ion-toolbar>
 *     <ion-title>Scrolls with the content</ion-title>
 *   </ion-toolbar>
 *
 * </ion-content>
 *
 *
 * <ion-footer no-border>
 *
 *   <ion-toolbar>
 *     <ion-title>I'm a footer</ion-title>
 *   </ion-toolbar>
 *
 * </ion-footer>
 *  ```
 *
 * @demo /docs/demos/src/toolbar/
 * @see {@link ../Navbar/ Navbar API Docs}
 */
var Toolbar = (function (_super) {
    __extends(Toolbar, _super);
    function Toolbar(config, elementRef, renderer) {
        var _this = _super.call(this, config, elementRef, renderer) || this;
        _this._sbPadding = config.getBoolean('statusbarPadding');
        return _this;
    }
    Toolbar.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'ion-toolbar',
                    template: '<div class="toolbar-background" [ngClass]="\'toolbar-background-\' + _mode"></div>' +
                        '<ng-content select="[menuToggle],ion-buttons[left]"></ng-content>' +
                        '<ng-content select="ion-buttons[start]"></ng-content>' +
                        '<ng-content select="ion-buttons[end],ion-buttons[right]"></ng-content>' +
                        '<div class="toolbar-content" [ngClass]="\'toolbar-content-\' + _mode">' +
                        '<ng-content></ng-content>' +
                        '</div>',
                    host: {
                        'class': 'toolbar',
                        '[class.statusbar-padding]': '_sbPadding'
                    },
                    changeDetection: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectionStrategy"].OnPush,
                },] },
    ];
    /** @nocollapse */
    Toolbar.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__config_config__["a" /* Config */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    ]; };
    return Toolbar;
}(__WEBPACK_IMPORTED_MODULE_2__toolbar_base__["a" /* ToolbarBase */]));

//# sourceMappingURL=toolbar.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/typography/typography.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Typography; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ion__ = __webpack_require__("./node_modules/ionic-angular/components/ion.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



/**
  * @name Typography
  * @module ionic
  * @description
  *
  * The Typography component is a simple component that can be used to style the text color of any element.
  * The `ion-text` attribute should be added to the element in order to pass a color from the Sass `$colors`
  * map and change the text color of that element.
  *
  * @usage
  *
  * ```html
  * <h1 ion-text color="secondary">H1: The quick brown fox jumps over the lazy dog</h1>
  *
  * <h2 ion-text color="primary">H2: The quick brown fox jumps over the lazy dog</h2>
  *
  * <h3 ion-text color="light">H3: The quick brown fox jumps over the lazy dog</h3>
  *
  * <h4 ion-text color="danger">H4: The quick brown fox jumps over the lazy dog</h4>
  *
  * <h5 ion-text color="dark">H5: The quick brown fox jumps over the lazy dog</h5>
  *
  * <h6 ion-text [color]="dynamicColor">H6: The quick brown fox jumps over the lazy dog</h6>
  *
  * <p>
  *   I saw a werewolf with a Chinese menu in his hand.
  *   Walking through the <sub ion-text color="danger">streets</sub> of Soho in the rain.
  *   He <i ion-text color="primary">was</i> looking for a place called Lee Ho Fook's.
  *   Gonna get a <a ion-text color="secondary">big dish of beef chow mein.</a>
  * </p>
  *
  * <p>
  *   He's the hairy-handed gent who ran amuck in Kent.
  *   Lately he's <sup ion-text color="primary">been</sup> overheard in Mayfair.
  *   Better stay away from him.
  *   He'll rip your lungs out, Jim.
  *   I'd like to meet his tailor.
  * </p>
  * ```
  *
 */
var Typography = (function (_super) {
    __extends(Typography, _super);
    function Typography(config, elementRef, renderer) {
        return _super.call(this, config, elementRef, renderer, 'text') || this;
    }
    Typography.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: '[ion-text]'
                },] },
    ];
    /** @nocollapse */
    Typography.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__config_config__["a" /* Config */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    ]; };
    return Typography;
}(__WEBPACK_IMPORTED_MODULE_2__ion__["a" /* Ion */]));

//# sourceMappingURL=typography.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/virtual-scroll/virtual-footer.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VirtualFooter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");

/**
 * @hidden
 */
var VirtualFooter = (function () {
    function VirtualFooter(templateRef) {
        this.templateRef = templateRef;
    }
    VirtualFooter.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[virtualFooter]' },] },
    ];
    /** @nocollapse */
    VirtualFooter.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"], },
    ]; };
    return VirtualFooter;
}());

//# sourceMappingURL=virtual-footer.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/virtual-scroll/virtual-header.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VirtualHeader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");

/**
 * @hidden
 */
var VirtualHeader = (function () {
    function VirtualHeader(templateRef) {
        this.templateRef = templateRef;
    }
    VirtualHeader.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[virtualHeader]' },] },
    ];
    /** @nocollapse */
    VirtualHeader.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"], },
    ]; };
    return VirtualHeader;
}());

//# sourceMappingURL=virtual-header.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/virtual-scroll/virtual-item.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VirtualItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");

/**
 * @hidden
 */
var VirtualItem = (function () {
    function VirtualItem(templateRef, viewContainer) {
        this.templateRef = templateRef;
        this.viewContainer = viewContainer;
    }
    VirtualItem.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[virtualItem]' },] },
    ];
    /** @nocollapse */
    VirtualItem.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"], },
    ]; };
    return VirtualItem;
}());

//# sourceMappingURL=virtual-item.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/virtual-scroll/virtual-scroll.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VirtualScroll; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__virtual_util__ = __webpack_require__("./node_modules/ionic-angular/components/virtual-scroll/virtual-util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__content_content__ = __webpack_require__("./node_modules/ionic-angular/components/content/content.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__platform_dom_controller__ = __webpack_require__("./node_modules/ionic-angular/platform/dom-controller.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__platform_platform__ = __webpack_require__("./node_modules/ionic-angular/platform/platform.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__navigation_view_controller__ = __webpack_require__("./node_modules/ionic-angular/navigation/view-controller.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__virtual_item__ = __webpack_require__("./node_modules/ionic-angular/components/virtual-scroll/virtual-item.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__virtual_footer__ = __webpack_require__("./node_modules/ionic-angular/components/virtual-scroll/virtual-footer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__virtual_header__ = __webpack_require__("./node_modules/ionic-angular/components/virtual-scroll/virtual-header.js");











/**
 * @name VirtualScroll
 * @description
 * Virtual Scroll displays a virtual, "infinite" list. An array of records
 * is passed to the virtual scroll containing the data to create templates
 * for. The template created for each record, referred to as a cell, can
 * consist of items, headers, and footers.
 *
 * For performance reasons, not every record in the list is rendered at once;
 * instead a small subset of records (enough to fill the viewport) are rendered
 * and reused as the user scrolls.
 *
 * ### The Basics
 *
 * The array of records should be passed to the `virtualScroll` property.
 * The data given to the `virtualScroll` property must be an array. An item
 * template with the `*virtualItem` property is required in the `virtualScroll`.
 * The `virtualScroll` and `*virtualItem` properties can be added to any element.
 *
 * ```html
 * <ion-list [virtualScroll]="items">
 *
 *   <ion-item *virtualItem="let item">
 *     {% raw %}{{ item }}{% endraw %}
 *   </ion-item>
 *
 * </ion-list>
 * ```
 *
 *
 * ### Section Headers and Footers
 *
 * Section headers and footers are optional. They can be dynamically created
 * from developer-defined functions. For example, a large list of contacts
 * usually has a divider for each letter in the alphabet. Developers provide
 * their own custom function to be called on each record. The logic in the
 * custom function should determine whether to create the section template
 * and what data to provide to the template. The custom function should
 * return `null` if a template shouldn't be created.
 *
 * ```html
 * <ion-list [virtualScroll]="items" [headerFn]="myHeaderFn">
 *
 *   <ion-item-divider *virtualHeader="let header">
 *     Header: {% raw %}{{ header }}{% endraw %}
 *   </ion-item-divider>
 *
 *   <ion-item *virtualItem="let item">
 *     Item: {% raw %}{{ item }}{% endraw %}
 *   </ion-item>
 *
 * </ion-list>
 * ```
 *
 * Below is an example of a custom function called on every record. It
 * gets passed the individual record, the record's index number,
 * and the entire array of records. In this example, after every 20
 * records a header will be inserted. So between the 19th and 20th records,
 * between the 39th and 40th, and so on, a `<ion-item-divider>` will
 * be created and the template's data will come from the function's
 * returned data.
 *
 * ```ts
 * myHeaderFn(record, recordIndex, records) {
 *   if (recordIndex % 20 === 0) {
 *     return 'Header ' + recordIndex;
 *   }
 *   return null;
 * }
 * ```
 *
 *
 * ### Approximate Widths and Heights
 *
 * If the height of items in the virtual scroll are not close to the
 * default size of 40px, it is extremely important to provide a value for
 * approxItemHeight height. An exact pixel-perfect size is not necessary,
 * but without an estimate the virtual scroll will not render correctly.
 *
 * The approximate width and height of each template is used to help
 * determine how many cells should be created, and to help calculate
 * the height of the scrollable area. Note that the actual rendered size
 * of each cell comes from the app's CSS, whereas this approximation
 * is only used to help calculate initial dimensions.
 *
 * It's also important to know that Ionic's default item sizes have
 * slightly different heights between platforms, which is perfectly fine.
 *
 *
 * ### Images Within Virtual Scroll
 *
 * HTTP requests, image decoding, and image rendering can cause jank while
 * scrolling. In order to better control images, Ionic provides `<ion-img>`
 * to manage HTTP requests and image rendering. While scrolling through items
 * quickly, `<ion-img>` knows when and when not to make requests, when and
 * when not to render images, and only loads the images that are viewable
 * after scrolling. [Read more about `ion-img`.](../../img/Img/)
 *
 * It's also important for app developers to ensure image sizes are locked in,
 * and after images have fully loaded they do not change size and affect any
 * other element sizes. Simply put, to ensure rendering bugs are not introduced,
 * it's vital that elements within a virtual item does not dynamically change.
 *
 * For virtual scrolling, the natural effects of the `<img>` are not desirable
 * features. We recommend using the `<ion-img>` component over the native
 * `<img>` element because when an `<img>` element is added to the DOM, it
 * immediately makes a HTTP request for the image file. Additionally, `<img>`
 * renders whenever it wants which could be while the user is scrolling. However,
 * `<ion-img>` is governed by the containing `ion-content` and does not render
 * images while scrolling quickly.
 *
 * ```html
 * <ion-list [virtualScroll]="items">
 *
 *   <ion-item *virtualItem="let item">
 *     <ion-avatar item-start>
 *       <ion-img [src]="item.avatarUrl"></ion-img>
 *     </ion-avatar>
 *    {% raw %} {{ item.firstName }} {{ item.lastName }}{% endraw %}
 *   </ion-item>
 *
 * </ion-list>
 * ```
 *
 *
 * ### Custom Components
 *
 * If a custom component is going to be used within Virtual Scroll, it's best
 * to wrap it with a good old `<div>` to ensure the component is rendered
 * correctly. Since each custom component's implementation and internals can be
 * quite different, wrapping within a `<div>` is a safe way to make sure
 * dimensions are measured correctly.
 *
 * ```html
 * <ion-list [virtualScroll]="items">
 *
 *   <div *virtualItem="let item">
 *     <my-custom-item [item]="item">
 *       {% raw %} {{ item }}{% endraw %}
 *     </my-custom-item>
 *   </div>
 *
 * </ion-list>
 * ```
 *
 *
 * ## Virtual Scroll Performance Tips
 *
 * #### iOS Cordova WKWebView
 *
 * When deploying to iOS with Cordova, it's highly recommended to use the
 * [WKWebView plugin](http://blog.ionic.io/cordova-ios-performance-improvements-drop-in-speed-with-wkwebview/)
 * in order to take advantage of iOS's higher performimg webview. Additionally,
 * WKWebView is superior at scrolling efficiently in comparision to the older
 * UIWebView.
 *
 * #### Lock in element dimensions and locations
 *
 * In order for virtual scroll to efficiently size and locate every item, it's
 * very important every element within each virtual item does not dynamically
 * change its dimensions or location. The best way to ensure size and location
 * does not change, it's recommended each virtual item has locked in its size
 * via CSS.
 *
 * #### Use `ion-img` for images
 *
 * When including images within Virtual Scroll, be sure to use
 * [`ion-img`](../img/Img/) rather than the standard `<img>` HTML element.
 * With `ion-img`, images are lazy loaded so only the viewable ones are
 * rendered, and HTTP requests are efficiently controlled while scrolling.
 *
 * #### Set Approximate Widths and Heights
 *
 * As mentioned above, all elements should lock in their dimensions. However,
 * virtual scroll isn't aware of the dimensions until after they have been
 * rendered. For the initial render, virtual scroll still needs to set
 * how many items should be built. With "approx" property inputs, such as
 * `approxItemHeight`, we're able to give virtual scroll an approximate size,
 * therefore allowing virtual scroll to decide how many items should be
 * created.
 *
 * #### Changing dataset should use `virtualTrackBy`
 *
 * It is possible for the identities of elements in the iterator to change
 * while the data does not. This can happen, for example, if the iterator
 * produced from an RPC to the server, and that RPC is re-run. Even if the
 * "data" hasn't changed, the second response will produce objects with
 * different identities, and Ionic will tear down the entire DOM and rebuild
 * it. This is an expensive operation and should be avoided if possible.
 *
 * #### Efficient headers and footer functions
 *
 * Each virtual item must stay extremely efficient, but one way to really
 * kill its performance is to perform any DOM operations within section header
 * and footer functions. These functions are called for every record in the
 * dataset, so please make sure they're performant.
 *
 */
var VirtualScroll = (function () {
    function VirtualScroll(_iterableDiffers, _elementRef, _renderer, _zone, _cd, _content, _plt, _ctrl, _config, _dom) {
        var _this = this;
        this._iterableDiffers = _iterableDiffers;
        this._elementRef = _elementRef;
        this._renderer = _renderer;
        this._zone = _zone;
        this._cd = _cd;
        this._content = _content;
        this._plt = _plt;
        this._ctrl = _ctrl;
        this._config = _config;
        this._dom = _dom;
        this._init = false;
        this._lastEle = false;
        this._records = [];
        this._cells = [];
        this._nodes = [];
        this._vHeight = 0;
        this._lastCheck = 0;
        this._recordSize = 0;
        this._data = {
            scrollTop: 0,
        };
        this._queue = 1 /* NoChanges */;
        /**
         * @input {number} The buffer ratio is used to decide how many cells
         * should get created when initially rendered. The number is a
         * multiplier against the viewable area's height. For example, if it
         * takes `20` cells to fill up the height of the viewable area, then
         * with a buffer ratio of `3` it will create `60` cells that are
         * available for reuse while scrolling. For better performance, it's
         * better to have more cells than what are required to fill the
         * viewable area. Default is `3`.
         * In case more than one items are rendered per row, bufferRatio
         * has to account for that and a multiple number should be used.
         * For example if a single item per row list used 3 as bufferRatio
         * a 4 item per row list should use 3 * 4 = 12 as buffer ratio.
         */
        this.bufferRatio = 3;
        /**
         * @input {string} The approximate width of each item template's cell.
         * This dimension is used to help determine how many cells should
         * be created when initialized, and to help calculate the height of
         * the scrollable area. This value can use either `px` or `%` units.
         * Note that the actual rendered size of each cell comes from the
         * app's CSS, whereas this approximation is used to help calculate
         * initial dimensions before the item has been rendered. Default is
         * `100%`.
         */
        this.approxItemWidth = '100%';
        /**
         * @input {string} The approximate width of each header template's cell.
         * This dimension is used to help determine how many cells should
         * be created when initialized, and to help calculate the height of
         * the scrollable area. This value can use either `px` or `%` units.
         * Note that the actual rendered size of each cell comes from the
         * app's CSS, whereas this approximation is used to help calculate
         * initial dimensions. Default is `100%`.
         */
        this.approxHeaderWidth = '100%';
        /**
         * @input {string} The approximate height of each header template's cell.
         * This dimension is used to help determine how many cells should
         * be created when initialized, and to help calculate the height of
         * the scrollable area. This height value can only use `px` units.
         * Note that the actual rendered size of each cell comes from the
         * app's CSS, whereas this approximation is used to help calculate
         * initial dimensions before the item has been rendered. Default is `40px`.
         */
        this.approxHeaderHeight = '40px';
        /**
         * @input {string} The approximate width of each footer template's cell.
         * This dimension is used to help determine how many cells should
         * be created when initialized, and to help calculate the height of
         * the scrollable area. This value can use either `px` or `%` units.
         * Note that the actual rendered size of each cell comes from the
         * app's CSS, whereas this approximation is used to help calculate
         * initial dimensions before the item has been rendered. Default is `100%`.
         */
        this.approxFooterWidth = '100%';
        /**
         * @input {string} The approximate height of each footer template's cell.
         * This dimension is used to help determine how many cells should
         * be created when initialized, and to help calculate the height of
         * the scrollable area. This height value can only use `px` units.
         * Note that the actual rendered size of each cell comes from the
         * app's CSS, whereas this approximation is used to help calculate
         * initial dimensions before the item has been rendered. Default is `40px`.
         */
        this.approxFooterHeight = '40px';
        // hide the virtual scroll element with opacity so we don't
        // see jank as it loads up, but we're still able to read
        // dimensions because it's still rendered and only opacity hidden
        this.setElementClass('virtual-loading', true);
        // wait for the content to be rendered and has readable dimensions
        var readSub = _ctrl.readReady.subscribe(function () {
            readSub.unsubscribe();
            _this.readUpdate(true);
        });
        // wait for the content to be writable
        var writeSub = _ctrl.writeReady.subscribe(function () {
            writeSub.unsubscribe();
            _this._init = true;
            _this.writeUpdate(true);
            _this._listeners();
        });
    }
    Object.defineProperty(VirtualScroll.prototype, "virtualScroll", {
        get: function () {
            return this._records;
        },
        /**
         * @input {array} The data that builds the templates within the virtual scroll.
         * This is the same data that you'd pass to `*ngFor`. It's important to note
         * that when this data has changed, then the entire virtual scroll is reset,
         * which is an expensive operation and should be avoided if possible.
         */
        set: function (val) {
            this._records = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VirtualScroll.prototype, "headerFn", {
        /**
         * @input {function} Section headers and the data used within its given
         * template can be dynamically created by passing a function to `headerFn`.
         * For example, a large list of contacts usually has dividers between each
         * letter in the alphabet. App's can provide their own custom `headerFn`
         * which is called with each record within the dataset. The logic within
         * the header function can decide if the header template should be used,
         * and what data to give to the header template. The function must return
         * `null` if a header cell shouldn't be created.
         */
        set: function (val) {
            if (Object(__WEBPACK_IMPORTED_MODULE_5__util_util__["i" /* isFunction */])(val)) {
                this._hdrFn = val.bind((this._ctrl._cmp) || this);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VirtualScroll.prototype, "footerFn", {
        /**
         * @input {function} Section footers and the data used within its given
         * template can be dynamically created by passing a function to `footerFn`.
         * The logic within the footer function can decide if the footer template
         * should be used, and what data to give to the footer template. The function
         * must return `null` if a footer cell shouldn't be created.
         */
        set: function (val) {
            if (Object(__WEBPACK_IMPORTED_MODULE_5__util_util__["i" /* isFunction */])(val)) {
                this._ftrFn = val.bind((this._ctrl._cmp) || this);
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @hidden
     */
    VirtualScroll.prototype.firstRecord = function () {
        var cells = this._cells;
        return (cells.length > 0) ? cells[0].record : 0;
    };
    /**
     * @hidden
     */
    VirtualScroll.prototype.lastRecord = function () {
        var cells = this._cells;
        return (cells.length > 0) ? cells[cells.length - 1].record : 0;
    };
    /**
    * @hidden
    */
    VirtualScroll.prototype.ngOnChanges = function (changes) {
        if ('virtualScroll' in changes) {
            // React on virtualScroll changes only once all inputs have been initialized
            var value = changes['virtualScroll'].currentValue;
            if (!Object(__WEBPACK_IMPORTED_MODULE_5__util_util__["l" /* isPresent */])(this._differ) && Object(__WEBPACK_IMPORTED_MODULE_5__util_util__["l" /* isPresent */])(value)) {
                try {
                    this._differ = this._iterableDiffers.find(value).create(this.virtualTrackBy);
                }
                catch (e) {
                    throw new Error("Cannot find a differ supporting object '" + value + "'. VirtualScroll only supports binding to Iterables such as Arrays.");
                }
            }
        }
    };
    /**
     * @hidden
     */
    VirtualScroll.prototype.ngDoCheck = function () {
        // only continue if we've already initialized
        if (!this._init) {
            return;
        }
        // and if there actually are changes
        var changes = Object(__WEBPACK_IMPORTED_MODULE_5__util_util__["l" /* isPresent */])(this._differ) ? this._differ.diff(this.virtualScroll) : null;
        if (!Object(__WEBPACK_IMPORTED_MODULE_5__util_util__["l" /* isPresent */])(changes)) {
            return;
        }
        var needClean = false;
        var lastRecord = this._recordSize;
        changes.forEachOperation(function (_, pindex, cindex) {
            // add new record after current position
            if (pindex === null && (cindex < lastRecord)) {
                (void 0) /* console.debug */;
                needClean = true;
                return;
            }
            // remove record after current position
            if (pindex < lastRecord && cindex === null) {
                (void 0) /* console.debug */;
                needClean = true;
                return;
            }
        });
        this._recordSize = this._records ? this._records.length : 0;
        this.readUpdate(needClean);
        this.writeUpdate(needClean);
    };
    /**
     * @hidden
     */
    VirtualScroll.prototype.readUpdate = function (needClean) {
        if (needClean) {
            // reset everything
            (void 0) /* console.debug */;
            this._cells.length = 0;
            // this._nodes.length = 0;
            // this._itmTmp.viewContainer.clear();
            // ******** DOM READ ****************
            this.calcDimensions();
        }
        else {
            (void 0) /* console.debug */;
        }
    };
    /**
     * @hidden
     */
    VirtualScroll.prototype.writeUpdate = function (needClean) {
        (void 0) /* console.debug */;
        var data = this._data;
        var stopAtHeight = (data.scrollTop + data.renderHeight);
        data.scrollDiff = SCROLL_DIFFERENCE_MINIMUM + 1;
        Object(__WEBPACK_IMPORTED_MODULE_1__virtual_util__["f" /* processRecords */])(stopAtHeight, this._records, this._cells, this._hdrFn, this._ftrFn, this._data);
        // ******** DOM WRITE ****************
        this.renderVirtual(needClean);
    };
    /**
     * @hidden
     */
    VirtualScroll.prototype.calcDimensions = function () {
        Object(__WEBPACK_IMPORTED_MODULE_1__virtual_util__["b" /* calcDimensions */])(this._data, this._elementRef.nativeElement, this.approxItemWidth, this.approxItemHeight, this.approxHeaderWidth, this.approxHeaderHeight, this.approxFooterWidth, this.approxFooterHeight, this.bufferRatio);
    };
    /**
     * @hidden
     * DOM WRITE
     */
    VirtualScroll.prototype.renderVirtual = function (needClean) {
        var _this = this;
        this._plt.raf(function () {
            var nodes = _this._nodes;
            var cells = _this._cells;
            var data = _this._data;
            var records = _this._records;
            if (needClean) {
                // ******** DOM WRITE ****************
                Object(__WEBPACK_IMPORTED_MODULE_1__virtual_util__["g" /* updateDimensions */])(_this._plt, nodes, cells, data, true);
                data.topCell = 0;
                data.bottomCell = (cells.length - 1);
            }
            Object(__WEBPACK_IMPORTED_MODULE_1__virtual_util__["a" /* adjustRendered */])(cells, data);
            _this._zone.run(function () {
                Object(__WEBPACK_IMPORTED_MODULE_1__virtual_util__["e" /* populateNodeData */])(data.topCell, data.bottomCell, true, cells, records, nodes, _this._itmTmp.viewContainer, _this._itmTmp.templateRef, _this._hdrTmp && _this._hdrTmp.templateRef, _this._ftrTmp && _this._ftrTmp.templateRef);
            });
            if (needClean) {
                _this._cd.detectChanges();
            }
            // at this point, this fn was called from within another
            // requestAnimationFrame, so the next dom reads/writes within the next frame
            // wait a frame before trying to read and calculate the dimensions
            // ******** DOM READ ****************
            _this._dom.read(function () { return Object(__WEBPACK_IMPORTED_MODULE_1__virtual_util__["d" /* initReadNodes */])(_this._plt, nodes, cells, data); });
            _this._dom.write(function () {
                // update the bound context for each node
                Object(__WEBPACK_IMPORTED_MODULE_1__virtual_util__["h" /* updateNodeContext */])(nodes, cells, data);
                // ******** DOM WRITE ****************
                _this._stepChangeDetection();
                // ******** DOM WRITE ****************
                _this._stepDOMWrite();
                // ******** DOM WRITE ****************
                _this._content.imgsUpdate();
                // First time load
                if (!_this._lastEle) {
                    // add an element at the end so :last-child css doesn't get messed up
                    // ******** DOM WRITE ****************
                    var ele = _this._elementRef.nativeElement;
                    var lastEle = _this._renderer.createElement(ele, 'div');
                    lastEle.className = 'virtual-last';
                    _this._lastEle = true;
                    // ******** DOM WRITE ****************
                    _this.setElementClass('virtual-scroll', true);
                    // ******** DOM WRITE ****************
                    _this.setElementClass('virtual-loading', false);
                }
                (void 0) /* assert */;
            });
        });
    };
    /**
     * @hidden
     */
    VirtualScroll.prototype.resize = function () {
        // only continue if we've already initialized
        if (!this._init) {
            return;
        }
        // check if component is rendered in the dom currently
        if (this._elementRef.nativeElement.offsetParent === null) {
            return;
        }
        (void 0) /* console.debug */;
        this.calcDimensions();
        this.writeUpdate(false);
    };
    /**
     * @hidden
     */
    VirtualScroll.prototype._stepDOMWrite = function () {
        var cells = this._cells;
        var nodes = this._nodes;
        // ******** DOM WRITE ****************
        Object(__WEBPACK_IMPORTED_MODULE_1__virtual_util__["i" /* writeToNodes */])(this._plt, nodes, cells, this._recordSize);
        // ******** DOM WRITE ****************
        this._setHeight(Object(__WEBPACK_IMPORTED_MODULE_1__virtual_util__["c" /* estimateHeight */])(this._recordSize, cells[cells.length - 1], this._vHeight, 0.25));
        // we're done here, good work
        this._queue = 1 /* NoChanges */;
    };
    /**
     * @hidden
     */
    VirtualScroll.prototype._stepChangeDetection = function () {
        // we need to do some change detection in this frame
        // we've got work painting do, let's throw it in the
        // domWrite callback so everyone plays nice
        // ******** DOM WRITE ****************
        var nodes = this._nodes;
        for (var i = 0; i < nodes.length; i++) {
            if (nodes[i].hasChanges) {
                nodes[i].view.detectChanges();
            }
        }
        // on the next frame we need write to the dom nodes manually
        this._queue = 3 /* DomWrite */;
    };
    /**
     * @hidden
     */
    VirtualScroll.prototype._stepNoChanges = function () {
        var data = this._data;
        // let's see if we've scroll far enough to require another check
        var diff = data.scrollDiff = (data.scrollTop - this._lastCheck);
        if (Math.abs(diff) < SCROLL_DIFFERENCE_MINIMUM) {
            return;
        }
        var cells = this._cells;
        var nodes = this._nodes;
        var records = this._records;
        // don't bother updating if the scrollTop hasn't changed much
        this._lastCheck = data.scrollTop;
        if (diff > 0) {
            // load data we may not have processed yet
            var stopAtHeight = (data.scrollTop + data.renderHeight);
            Object(__WEBPACK_IMPORTED_MODULE_1__virtual_util__["f" /* processRecords */])(stopAtHeight, records, cells, this._hdrFn, this._ftrFn, data);
        }
        // ******** DOM READ ****************
        Object(__WEBPACK_IMPORTED_MODULE_1__virtual_util__["g" /* updateDimensions */])(this._plt, nodes, cells, data, false);
        Object(__WEBPACK_IMPORTED_MODULE_1__virtual_util__["a" /* adjustRendered */])(cells, data);
        var hasChanges = Object(__WEBPACK_IMPORTED_MODULE_1__virtual_util__["e" /* populateNodeData */])(data.topCell, data.bottomCell, diff > 0, cells, records, nodes, this._itmTmp.viewContainer, this._itmTmp.templateRef, this._hdrTmp && this._hdrTmp.templateRef, this._ftrTmp && this._ftrTmp.templateRef);
        if (hasChanges) {
            // queue making updates in the next frame
            this._queue = 2 /* ChangeDetection */;
            // update the bound context for each node
            Object(__WEBPACK_IMPORTED_MODULE_1__virtual_util__["h" /* updateNodeContext */])(nodes, cells, data);
        }
    };
    /**
     * @hidden
     */
    VirtualScroll.prototype.scrollUpdate = function (ev) {
        var _this = this;
        // ensure no empty are processed
        if (!ev) {
            return;
        }
        // set the scroll top from the scroll event
        this._data.scrollTop = ev.scrollTop;
        // there is a queue system so that we can
        // spread out the work over multiple frames
        var queue = this._queue;
        if (queue === 1 /* NoChanges */) {
            // no dom writes or change detection to take care of
            this._stepNoChanges();
        }
        else if (queue === 2 /* ChangeDetection */) {
            this._dom.write(function () { return _this._stepChangeDetection(); });
        }
        else {
            (void 0) /* assert */;
            // there are DOM writes we need to take care of in this frame
            this._dom.write(function () { return _this._stepDOMWrite(); });
        }
    };
    /**
     * @hidden
     * DOM WRITE
     */
    VirtualScroll.prototype.scrollEnd = function () {
        var _this = this;
        // ******** DOM READ ****************
        Object(__WEBPACK_IMPORTED_MODULE_1__virtual_util__["g" /* updateDimensions */])(this._plt, this._nodes, this._cells, this._data, false);
        Object(__WEBPACK_IMPORTED_MODULE_1__virtual_util__["a" /* adjustRendered */])(this._cells, this._data);
        Object(__WEBPACK_IMPORTED_MODULE_1__virtual_util__["e" /* populateNodeData */])(this._data.topCell, this._data.bottomCell, true, this._cells, this._records, this._nodes, this._itmTmp.viewContainer, this._itmTmp.templateRef, this._hdrTmp && this._hdrTmp.templateRef, this._ftrTmp && this._ftrTmp.templateRef);
        // ******** DOM WRITE ***************
        this._dom.write(function () {
            // update the bound context for each node
            Object(__WEBPACK_IMPORTED_MODULE_1__virtual_util__["h" /* updateNodeContext */])(_this._nodes, _this._cells, _this._data);
            // ******** DOM WRITE ***************
            _this._stepChangeDetection();
            // ******** DOM WRITE ****************
            _this._stepDOMWrite();
        });
    };
    /**
     * @hidden
     * NO DOM
     */
    VirtualScroll.prototype._listeners = function () {
        (void 0) /* assert */;
        if (!this._scrollSub) {
            if (this._config.getBoolean('virtualScrollEventAssist')) {
                // use JS scrolling for iOS UIWebView
                // goal is to completely remove this when iOS
                // fully supports scroll events
                // listen to JS scroll events
                this._content.enableJsScroll();
            }
            this._resizeSub = this._plt.resize.subscribe(this.resize.bind(this));
            this._scrollSub = this._content.ionScroll.subscribe(this.scrollUpdate.bind(this));
            this._scrollEndSub = this._content.ionScrollEnd.subscribe(this.scrollEnd.bind(this));
        }
    };
    /**
     * @hidden
     * DOM WRITE
     */
    VirtualScroll.prototype._setHeight = function (newVirtualHeight) {
        if (newVirtualHeight !== this._vHeight) {
            // ******** DOM WRITE ****************
            this._renderer.setElementStyle(this._elementRef.nativeElement, 'height', newVirtualHeight > 0 ? newVirtualHeight + 'px' : '');
            this._vHeight = newVirtualHeight;
            (void 0) /* console.debug */;
        }
    };
    /**
     * @hidden
     */
    VirtualScroll.prototype.ngAfterContentInit = function () {
        (void 0) /* assert */;
        if (!this.approxItemHeight) {
            this.approxItemHeight = '40px';
            console.warn('Virtual Scroll: Please provide an "approxItemHeight" input to ensure proper virtual scroll rendering');
        }
    };
    /**
     * @hidden
     */
    VirtualScroll.prototype.setElementClass = function (className, add) {
        this._renderer.setElementClass(this._elementRef.nativeElement, className, add);
    };
    /**
     * @hidden
     */
    VirtualScroll.prototype.ngOnDestroy = function () {
        this._resizeSub && this._resizeSub.unsubscribe();
        this._scrollSub && this._scrollSub.unsubscribe();
        this._scrollEndSub && this._scrollEndSub.unsubscribe();
        this._resizeSub = this._scrollEndSub = this._scrollSub = null;
        this._hdrFn = this._ftrFn = this._records = this._cells = this._nodes = this._data = null;
    };
    VirtualScroll.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: '[virtualScroll]'
                },] },
    ];
    /** @nocollapse */
    VirtualScroll.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["IterableDiffers"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_3__content_content__["a" /* Content */], },
        { type: __WEBPACK_IMPORTED_MODULE_6__platform_platform__["a" /* Platform */], },
        { type: __WEBPACK_IMPORTED_MODULE_7__navigation_view_controller__["a" /* ViewController */], },
        { type: __WEBPACK_IMPORTED_MODULE_2__config_config__["a" /* Config */], },
        { type: __WEBPACK_IMPORTED_MODULE_4__platform_dom_controller__["a" /* DomController */], },
    ]; };
    VirtualScroll.propDecorators = {
        '_itmTmp': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChild"], args: [__WEBPACK_IMPORTED_MODULE_8__virtual_item__["a" /* VirtualItem */],] },],
        '_hdrTmp': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChild"], args: [__WEBPACK_IMPORTED_MODULE_10__virtual_header__["a" /* VirtualHeader */],] },],
        '_ftrTmp': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChild"], args: [__WEBPACK_IMPORTED_MODULE_9__virtual_footer__["a" /* VirtualFooter */],] },],
        'virtualScroll': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'bufferRatio': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'approxItemWidth': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'approxItemHeight': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'approxHeaderWidth': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'approxHeaderHeight': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'approxFooterWidth': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'approxFooterHeight': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'headerFn': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'footerFn': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'virtualTrackBy': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return VirtualScroll;
}());

var SCROLL_DIFFERENCE_MINIMUM = 40;
//# sourceMappingURL=virtual-scroll.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/components/virtual-scroll/virtual-util.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = processRecords;
/* harmony export (immutable) */ __webpack_exports__["e"] = populateNodeData;
/* harmony export (immutable) */ __webpack_exports__["d"] = initReadNodes;
/* harmony export (immutable) */ __webpack_exports__["g"] = updateDimensions;
/* harmony export (immutable) */ __webpack_exports__["h"] = updateNodeContext;
/* harmony export (immutable) */ __webpack_exports__["i"] = writeToNodes;
/* harmony export (immutable) */ __webpack_exports__["a"] = adjustRendered;
/* unused harmony export getVirtualHeight */
/* harmony export (immutable) */ __webpack_exports__["c"] = estimateHeight;
/* harmony export (immutable) */ __webpack_exports__["b"] = calcDimensions;
/* unused harmony export VirtualContext */
var PREVIOUS_CELL = {
    row: 0,
    width: 0,
    height: 0,
    top: 0,
    left: 0,
    tmpl: -1
};
/**
 * NO DOM
 */
function processRecords(stopAtHeight, records, cells, headerFn, footerFn, data) {
    var record;
    var startRecordIndex;
    var previousCell;
    var tmpData;
    var lastRecordIndex = records ? (records.length - 1) : -1;
    if (cells.length) {
        // we already have cells
        previousCell = cells[cells.length - 1];
        if (previousCell.top + previousCell.height > stopAtHeight) {
            return;
        }
        startRecordIndex = (previousCell.record + 1);
    }
    else {
        // no cells have been created yet
        previousCell = PREVIOUS_CELL;
        startRecordIndex = 0;
    }
    var processedTotal = 0;
    for (var recordIndex = startRecordIndex; recordIndex <= lastRecordIndex; recordIndex++) {
        record = records[recordIndex];
        if (headerFn) {
            tmpData = headerFn(record, recordIndex, records);
            if (tmpData !== null) {
                // add header data
                previousCell = addCell(previousCell, recordIndex, 1 /* Header */, tmpData, data.hdrWidth, data.hdrHeight, data.viewWidth);
                cells.push(previousCell);
            }
        }
        // add item data
        previousCell = addCell(previousCell, recordIndex, 0 /* Item */, null, data.itmWidth, data.itmHeight, data.viewWidth);
        cells.push(previousCell);
        if (footerFn) {
            tmpData = footerFn(record, recordIndex, records);
            if (tmpData !== null) {
                // add footer data
                previousCell = addCell(previousCell, recordIndex, 2 /* Footer */, tmpData, data.ftrWidth, data.ftrHeight, data.viewWidth);
                cells.push(previousCell);
            }
        }
        if (previousCell.record === lastRecordIndex) {
            previousCell.isLast = true;
        }
        // should always process at least 3 records
        processedTotal++;
        if (previousCell.top + previousCell.height + data.itmHeight > stopAtHeight && processedTotal > 3) {
            return;
        }
    }
}
function addCell(previousCell, recordIndex, tmpl, tmplData, cellWidth, cellHeight, viewportWidth) {
    var newCell = {
        record: recordIndex,
        tmpl: tmpl,
        width: cellWidth,
        height: cellHeight,
        reads: 0
    };
    if (previousCell.left + previousCell.width + cellWidth > viewportWidth) {
        // add a new cell in a new row
        newCell.row = (previousCell.row + 1);
        newCell.top = (previousCell.top + previousCell.height);
        newCell.left = 0;
    }
    else {
        // add a new cell in the same row
        newCell.row = previousCell.row;
        newCell.top = previousCell.top;
        newCell.left = (previousCell.left + previousCell.width);
    }
    if (tmplData) {
        newCell.data = tmplData;
    }
    return newCell;
}
/**
 * NO DOM
 */
function populateNodeData(startCellIndex, endCellIndex, scrollingDown, cells, records, nodes, viewContainer, itmTmp, hdrTmp, ftrTmp) {
    if (!records || records.length === 0) {
        nodes.length = 0;
        viewContainer.clear();
        return true;
    }
    var recordsLength = records.length;
    var hasChanges = false;
    // let node: VirtualNode;
    var availableNode;
    var cell;
    var viewInsertIndex = null;
    var totalNodes = nodes.length;
    var templateRef;
    startCellIndex = Math.max(startCellIndex, 0);
    endCellIndex = Math.min(endCellIndex, cells.length - 1);
    var usedNodes = [];
    for (var cellIndex = startCellIndex; cellIndex <= endCellIndex; cellIndex++) {
        cell = cells[cellIndex];
        availableNode = null;
        // find the first one that's available
        var existingNode = nodes.find(function (n) { return n.cell === cellIndex && n.tmpl === cell.tmpl; });
        if (existingNode) {
            if (existingNode.view.context.$implicit === records[cell.record]) {
                usedNodes.push(existingNode);
                continue; // optimization: node data is the same no need to update
            }
            (void 0) /* console.debug */;
            availableNode = existingNode; // update existing node
        }
        else {
            (void 0) /* console.debug */;
            for (var i = 0; i < totalNodes; i++) {
                var node = nodes[i];
                if (cell.tmpl !== node.tmpl || i === 0 && cellIndex !== 0) {
                    // the cell must use the correct template
                    // first node can only be used by the first cell (css :first-child reasons)
                    // this node is never available to be reused
                    continue;
                }
                if (node.cell < startCellIndex || node.cell > endCellIndex) {
                    if (!availableNode) {
                        // havent gotten an available node yet
                        availableNode = node;
                        (void 0) /* console.debug */;
                    }
                    else if (scrollingDown) {
                        // scrolling down
                        if (node.cell < availableNode.cell) {
                            availableNode = node;
                            (void 0) /* console.debug */;
                        }
                    }
                    else {
                        // scrolling up
                        if (node.cell > availableNode.cell) {
                            availableNode = node;
                            (void 0) /* console.debug */;
                        }
                    }
                }
            }
        }
        if (!availableNode) {
            // did not find an available node to put the cell data into
            // insert a new node after existing ones
            if (viewInsertIndex === null) {
                viewInsertIndex = -1;
                for (var j = totalNodes - 1; j >= 0; j--) {
                    var node = nodes[j];
                    if (node) {
                        viewInsertIndex = viewContainer.indexOf(node.view);
                        break;
                    }
                }
            }
            // select which templateRef should be used for this cell
            templateRef = cell.tmpl === 1 /* Header */ ? hdrTmp : cell.tmpl === 2 /* Footer */ ? ftrTmp : itmTmp;
            if (!templateRef) {
                console.error("virtual" + (cell.tmpl === 1 /* Header */ ? 'Header' : cell.tmpl === 2 /* Footer */ ? 'Footer' : 'Item') + " template required");
                continue;
            }
            availableNode = {
                tmpl: cell.tmpl,
                view: viewContainer.createEmbeddedView(templateRef, new VirtualContext(null, null, null), viewInsertIndex)
            };
            totalNodes = nodes.push(availableNode);
        }
        // assign who's the new cell index for this node
        availableNode.cell = cellIndex;
        // apply the cell's data to this node
        var context = availableNode.view.context;
        context.$implicit = cell.data || records[cell.record];
        context.index = cellIndex;
        context.count = recordsLength;
        availableNode.hasChanges = true;
        availableNode.lastTransform = null;
        hasChanges = true;
        usedNodes.push(availableNode);
    }
    var unusedNodes = nodes.filter(function (n) { return usedNodes.indexOf(n) < 0; });
    unusedNodes.forEach(function (node) {
        var index = viewContainer.indexOf(node.view);
        viewContainer.remove(index);
        var removeIndex = nodes.findIndex(function (n) { return n === node; });
        nodes.splice(removeIndex, 1);
    });
    usedNodes.length = 0;
    unusedNodes.length = 0;
    return hasChanges;
}
/**
 * DOM READ
 */
function initReadNodes(plt, nodes, cells, data) {
    if (nodes.length && cells.length) {
        // first node
        // ******** DOM READ ****************
        var ele = getElement(nodes[0]);
        var firstCell = cells[0];
        firstCell.top = ele.clientTop;
        firstCell.left = ele.clientLeft;
        firstCell.row = 0;
        // ******** DOM READ ****************
        updateDimensions(plt, nodes, cells, data, true);
    }
}
/**
 * DOM READ
 */
function updateDimensions(plt, nodes, cells, data, initialUpdate) {
    var node;
    var element;
    var cell;
    var previousCell;
    var totalCells = cells.length;
    for (var i = 0; i < nodes.length; i++) {
        node = nodes[i];
        cell = cells[node.cell];
        // read element dimensions if they haven't been checked enough times
        if (cell && cell.reads < REQUIRED_DOM_READS) {
            element = getElement(node);
            // ******** DOM READ ****************
            readElements(plt, cell, element);
            if (initialUpdate) {
                // update estimated dimensions with more accurate dimensions
                if (cell.tmpl === 1 /* Header */) {
                    data.hdrHeight = cell.height;
                    if (cell.left === 0) {
                        data.hdrWidth = cell.width;
                    }
                }
                else if (cell.tmpl === 2 /* Footer */) {
                    data.ftrHeight = cell.height;
                    if (cell.left === 0) {
                        data.ftrWidth = cell.width;
                    }
                }
                else {
                    data.itmHeight = cell.height;
                    if (cell.left === 0) {
                        data.itmWidth = cell.width;
                    }
                }
            }
            cell.reads++;
        }
    }
    // figure out which cells are currently viewable within the viewport
    var viewableBottom = (data.scrollTop + data.viewHeight);
    data.topViewCell = totalCells;
    data.bottomViewCell = 0;
    if (totalCells > 0) {
        // completely realign position to ensure they're all accurately placed
        cell = cells[0];
        previousCell = {
            row: 0,
            width: 0,
            height: 0,
            top: cell.top,
            left: 0,
            tmpl: -1
        };
        for (var i_1 = 0; i_1 < totalCells; i_1++) {
            cell = cells[i_1];
            if (previousCell.left + previousCell.width + cell.width > data.viewWidth) {
                // new row
                cell.row++;
                cell.top = (previousCell.top + previousCell.height);
                cell.left = 0;
            }
            else {
                // same row
                cell.row = previousCell.row;
                cell.top = previousCell.top;
                cell.left = (previousCell.left + previousCell.width);
            }
            // figure out which cells are viewable within the viewport
            if (cell.top + cell.height > data.scrollTop && i_1 < data.topViewCell) {
                data.topViewCell = i_1;
            }
            else if (cell.top < viewableBottom && i_1 > data.bottomViewCell) {
                data.bottomViewCell = i_1;
            }
            previousCell = cell;
        }
    }
}
function updateNodeContext(nodes, cells, data) {
    // ensure each node has the correct bounds in its context
    var node;
    var cell;
    var bounds;
    for (var i = 0, ilen = nodes.length; i < ilen; i++) {
        node = nodes[i];
        cell = cells[node.cell];
        if (node && cell) {
            bounds = node.view.context.bounds;
            bounds.top = cell.top + data.viewTop;
            bounds.bottom = bounds.top + cell.height;
            bounds.left = cell.left + data.viewLeft;
            bounds.right = bounds.left + cell.width;
            bounds.width = cell.width;
            bounds.height = cell.height;
        }
    }
}
/**
 * DOM READ
 */
function readElements(plt, cell, element) {
    // ******** DOM READ ****************
    var styles = plt.getElementComputedStyle(element);
    // ******** DOM READ ****************
    cell.left = (element.clientLeft - parseFloat(styles.marginLeft));
    // ******** DOM READ ****************
    cell.width = (element.offsetWidth + parseFloat(styles.marginLeft) + parseFloat(styles.marginRight));
    // ******** DOM READ ****************
    cell.height = (element.offsetHeight + parseFloat(styles.marginTop) + parseFloat(styles.marginBottom));
}
/**
 * DOM WRITE
 */
function writeToNodes(plt, nodes, cells, totalRecords) {
    var node;
    var element;
    var cell;
    var transform;
    var totalCells = Math.max(totalRecords, cells.length);
    for (var i = 0, ilen = nodes.length; i < ilen; i++) {
        node = nodes[i];
        cell = cells[node.cell];
        transform = "translate3d(" + cell.left + "px," + cell.top + "px,0px)";
        if (node.lastTransform !== transform) {
            element = getElement(node);
            if (element) {
                // ******** DOM WRITE ****************
                element.style[plt.Css.transform] = node.lastTransform = transform;
                // ******** DOM WRITE ****************
                element.classList.add('virtual-position');
                // https://www.w3.org/TR/wai-aria/states_and_properties#aria-posinset
                // ******** DOM WRITE ****************
                element.setAttribute('aria-posinset', node.cell + 1);
                // https://www.w3.org/TR/wai-aria/states_and_properties#aria-setsize
                // ******** DOM WRITE ****************
                element.setAttribute('aria-setsize', totalCells);
            }
        }
    }
}
/**
 * NO DOM
 */
function adjustRendered(cells, data) {
    var maxRenderHeight = (data.renderHeight - data.itmHeight);
    var totalCells = cells.length;
    var viewableRenderedPadding = (data.itmHeight < 90 ? VIEWABLE_RENDERED_PADDING : 0);
    if (data.scrollDiff > 0) {
        // scrolling down
        data.topCell = Math.max(data.topViewCell - viewableRenderedPadding, 0);
        data.bottomCell = data.topCell;
        var cellsRenderHeight = 0;
        for (var i = data.topCell; i < totalCells; i++) {
            cellsRenderHeight += cells[i].height;
            if (i > data.bottomCell)
                data.bottomCell = i;
            if (cellsRenderHeight >= maxRenderHeight)
                break;
        }
        if (cellsRenderHeight < maxRenderHeight) {
            // there are no more cells at the bottom, so move topCell to a smaller index
            for (var i = data.topCell - 1; i >= 0; i--) {
                cellsRenderHeight += cells[i].height;
                data.topCell = i;
                if (cellsRenderHeight >= maxRenderHeight)
                    break;
            }
        }
    }
    else {
        // scroll up
        data.bottomCell = Math.min(data.bottomViewCell + viewableRenderedPadding, totalCells - 1);
        data.topCell = data.bottomCell;
        var cellsRenderHeight = 0;
        (void 0) /* assert */;
        for (var i = data.bottomCell; i >= 0; i--) {
            cellsRenderHeight += cells[i].height;
            if (i < data.topCell)
                data.topCell = i;
            if (cellsRenderHeight >= maxRenderHeight)
                break;
        }
        if (cellsRenderHeight < maxRenderHeight) {
            // there are no more cells at the top, so move bottomCell to a higher index
            for (var i = data.bottomCell; i < totalCells; i++) {
                cellsRenderHeight += cells[i].height;
                data.bottomCell = i;
                if (cellsRenderHeight >= maxRenderHeight)
                    break;
            }
        }
    }
}
/**
 * NO DOM
 */
function getVirtualHeight(totalRecords, lastCell) {
    if (lastCell.record >= totalRecords - 1) {
        return (lastCell.top + lastCell.height);
    }
    var unknownRecords = (totalRecords - lastCell.record - 1);
    var knownHeight = (lastCell.top + lastCell.height);
    return Math.ceil(knownHeight + ((knownHeight / (totalRecords - unknownRecords)) * unknownRecords));
}
/**
 * NO DOM
 */
function estimateHeight(totalRecords, lastCell, existingHeight, difference) {
    if (!totalRecords || !lastCell) {
        return 0;
    }
    var newHeight = getVirtualHeight(totalRecords, lastCell);
    var percentToBottom = (lastCell.record / (totalRecords - 1));
    var diff = Math.abs(existingHeight - newHeight);
    if ((diff > (newHeight * difference)) ||
        (percentToBottom > .995)) {
        return newHeight;
    }
    return existingHeight;
}
/**
 * DOM READ
 */
function calcDimensions(data, virtualScrollElement, approxItemWidth, approxItemHeight, appoxHeaderWidth, approxHeaderHeight, approxFooterWidth, approxFooterHeight, bufferRatio) {
    // get the parent container's viewport bounds
    var viewportElement = virtualScrollElement.parentElement;
    // ******** DOM READ ****************
    data.viewWidth = viewportElement.offsetWidth;
    // ******** DOM READ ****************
    data.viewHeight = viewportElement.offsetHeight;
    // get the virtual scroll element's offset data
    // ******** DOM READ ****************
    data.viewTop = virtualScrollElement.offsetTop;
    // ******** DOM READ ****************
    data.viewLeft = virtualScrollElement.offsetLeft;
    // the height we'd like to render, which is larger than viewable
    data.renderHeight = (data.viewHeight * bufferRatio);
    if (data.viewWidth > 0 && data.viewHeight > 0) {
        data.itmWidth = calcWidth(data.viewWidth, approxItemWidth);
        data.itmHeight = calcHeight(data.viewHeight, approxItemHeight);
        data.hdrWidth = calcWidth(data.viewWidth, appoxHeaderWidth);
        data.hdrHeight = calcHeight(data.viewHeight, approxHeaderHeight);
        data.ftrWidth = calcWidth(data.viewWidth, approxFooterWidth);
        data.ftrHeight = calcHeight(data.viewHeight, approxFooterHeight);
        data.valid = true;
    }
}
/**
 * NO DOM
 */
function calcWidth(viewportWidth, approxWidth) {
    if (approxWidth.indexOf('%') > 0) {
        return (viewportWidth * (parseFloat(approxWidth) / 100));
    }
    else if (approxWidth.indexOf('px') > 0) {
        return parseFloat(approxWidth);
    }
    throw new Error('virtual scroll width can only use "%" or "px" units');
}
/**
 * NO DOM
 */
function calcHeight(_viewportHeight, approxHeight) {
    if (approxHeight.indexOf('px') > 0) {
        return parseFloat(approxHeight);
    }
    throw new Error('virtual scroll height must use "px" units');
}
/**
 * NO DOM
 */
function getElement(node) {
    var rootNodes = node.view.rootNodes;
    for (var i = 0; i < rootNodes.length; i++) {
        if (rootNodes[i].nodeType === 1) {
            return rootNodes[i];
        }
    }
    return null;
}
var VirtualContext = (function () {
    function VirtualContext($implicit, index, count) {
        this.$implicit = $implicit;
        this.index = index;
        this.count = count;
        this.bounds = {};
    }
    Object.defineProperty(VirtualContext.prototype, "first", {
        get: function () { return this.index === 0; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VirtualContext.prototype, "last", {
        get: function () { return this.index === this.count - 1; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VirtualContext.prototype, "even", {
        get: function () { return this.index % 2 === 0; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VirtualContext.prototype, "odd", {
        get: function () { return !this.even; },
        enumerable: true,
        configurable: true
    });
    return VirtualContext;
}());

var VIEWABLE_RENDERED_PADDING = 3;
var REQUIRED_DOM_READS = 2;
//# sourceMappingURL=virtual-util.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/config/config.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Config; });
/* harmony export (immutable) */ __webpack_exports__["c"] = setupConfig;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ConfigToken; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");


/**
 * @name Config
 * @demo /docs/demos/src/config/
 * @description
 * The Config lets you configure your entire app or specific platforms.
 * You can set the tab placement, icon mode, animations, and more here.
 *
 * ```ts
 * import { IonicApp, IonicModule } from 'ionic-angular';
 *
 * @NgModule({
 *   declarations: [ MyApp ],
 *   imports: [
 *     BrowserModule,
 *     IonicModule.forRoot(MyApp, {
 *       backButtonText: 'Go Back',
 *       iconMode: 'ios',
 *       modalEnter: 'modal-slide-in',
 *       modalLeave: 'modal-slide-out',
 *       tabsPlacement: 'bottom',
 *       pageTransition: 'ios-transition'
 *     }, {}
 *   )],
 *   bootstrap: [IonicApp],
 *   entryComponents: [ MyApp ],
 *   providers: []
 * })
 * ```
 *
 *
 * Config can be overwritten at multiple levels allowing for more granular configuration.
 * Below is an example where an app can override any setting we want based on a platform.
 *
 * ```ts
 * import { IonicModule } from 'ionic-angular';
 *
 * @NgModule({
 *   ...
 *   imports: [
 *     BrowserModule,
 *     IonicModule.forRoot(MyApp, {
 *       tabsPlacement: 'bottom',
 *       platforms: {
 *         ios: {
 *           tabsPlacement: 'top',
 *         }
 *       }
 *     }, {}
 *   )],
 *   ...
 * })
 * ```
 *
 * We could also configure these values at a component level. Take `tabsPlacement`,
 * we can configure this as a property on our `ion-tabs`.
 *
 * ```html
 * <ion-tabs tabsPlacement="top">
 *   <ion-tab tabTitle="Dash" tabIcon="pulse" [root]="tabRoot"></ion-tab>
 * </ion-tabs>
 * ```
 *
 * The last way we could configure is through URL query strings. This is useful for testing
 * while in the browser. Simply add `?ionic<PROPERTYNAME>=<value>` to the url.
 *
 * ```bash
 * http://localhost:8100/?ionicTabsPlacement=bottom
 * ```
 *
 * Any value can be added to config, and looked up at a later in any component.
 *
 * ```js
 * config.set('ios', 'favoriteColor', 'green');
 *
 * // from any page in your app:
 * config.get('favoriteColor'); // 'green' when iOS
 * ```
 *
 *
 * A config value can come from anywhere and be anything, but there are default
 * values for each mode. The [theming](../../../theming/platform-specific-styles/)
 * documentation has a chart of the default mode configuration. The following
 * chart displays each property with a description of what it controls.
 *
 *
 * | Config Property          | Type                | Details                                                                                                                                          |
 * |--------------------------|---------------------|--------------------------------------------------------------------------------------------------------------------------------------------------|
 * | `activator`              | `string`            | Used for buttons, changes the effect of pressing on a button. Available options: `"ripple"`, `"highlight"`.                                      |
 * | `actionSheetEnter`       | `string`            | The name of the transition to use while an action sheet is presented.                                                                            |
 * | `actionSheetLeave`       | `string`            | The name of the transition to use while an action sheet is dismissed.                                                                            |
 * | `alertEnter`             | `string`            | The name of the transition to use while an alert is presented.                                                                                   |
 * | `alertLeave`             | `string`            | The name of the transition to use while an alert is dismissed.                                                                                   |
 * | `backButtonText`         | `string`            | The text to display by the back button icon in the navbar.                                                                                       |
 * | `backButtonIcon`         | `string`            | The icon to use as the back button icon.                                                                                                         |
 * | `iconMode`               | `string`            | The mode to use for all icons throughout the application. Available options: `"ios"`, `"md"`                                                     |
 * | `locationStrategy`       | `string`            | Set to 'path' to remove hashbangs when using Deeplinking.                                                                                        |
 * | `loadingEnter`           | `string`            | The name of the transition to use while a loading indicator is presented.                                                                        |
 * | `loadingLeave`           | `string`            | The name of the transition to use while a loading indicator is dismissed.                                                                        |
 * | `menuType`               | `string`            | Type of menu to display. Available options: `"overlay"`, `"reveal"`, `"push"`.                                                                   |
 * | `modalEnter`             | `string`            | The name of the transition to use while a modal is presented.                                                                                    |
 * | `modalLeave`             | `string`            | The name of the transition to use while a modal is dismiss.                                                                                      |
 * | `mode`                   | `string`            | The mode to use throughout the application.                                                                                                      |
 * | `pageTransition`         | `string`            | The name of the transition to use while changing pages. Available options: `"ios-transition"`, `"md-transition"`, `"wp-transition"`.             |
 * | `pickerEnter`            | `string`            | The name of the transition to use while a picker is presented.                                                                                   |
 * | `pickerLeave`            | `string`            | The name of the transition to use while a picker is dismissed.                                                                                   |
 * | `popoverEnter`           | `string`            | The name of the transition to use while a popover is presented.                                                                                  |
 * | `popoverLeave`           | `string`            | The name of the transition to use while a popover is dismissed.
 * | `scrollAssist`           | `boolean`           | Used to avoid the input to be hidden by the keyboard if it's near the bottom of the page.
 * | `scrollPadding`          | `boolean`           | Used to remove the extra padding on ion-content when keyboard is displayed.
 * | `spinner`                | `string`            | The default spinner to use when a name is not defined.                                                                                           |
 * | `statusbarPadding`       | `boolean`           | Whether to hide extra padding for statusbar.                                                                                                     |
 * | `swipeBackEnabled`       | `boolean`           | Whether native iOS swipe to go back functionality is enabled.                                                                                    |
 * | `tabsHighlight`          | `boolean`           | Whether to show a highlight line under the tab when it is selected.                                                                              |
 * | `tabsLayout`             | `string`            | The layout to use for all tabs. Available options: `"icon-top"`, `"icon-start"`, `"icon-end"`, `"icon-bottom"`, `"icon-hide"`, `"title-hide"`.   |
 * | `tabsPlacement`          | `string`            | The position of the tabs relative to the content. Available options: `"top"`, `"bottom"`                                                         |
 * | `tabsHideOnSubPages`     | `boolean`           | Whether to hide the tabs on child pages or not. If `true` it will not show the tabs on child pages.                                              |
 * | `toastEnter`             | `string`            | The name of the transition to use while a toast is presented.                                                                                    |
 * | `toastLeave`             | `string`            | The name of the transition to use while a toast is dismissed.                                                                                    |
 *
**/
var Config = (function () {
    function Config() {
        this._c = {};
        this._s = {};
        this._modes = {};
        this._trns = {};
    }
    /**
     * @hidden
     */
    Config.prototype.init = function (config, plt) {
        this._s = config && Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["k" /* isObject */])(config) && !Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["e" /* isArray */])(config) ? config : {};
        this.plt = plt;
    };
    /**
     * @name get
     * @description
     * Returns a single config value, given a key.
     *
     * @param {string} [key] - the key for the config value
     * @param {any} [fallbackValue] - a fallback value to use when the config
     * value was not found, or is config value is `null`. Fallback value
     *  defaults to `null`.
     */
    Config.prototype.get = function (key, fallbackValue) {
        if (fallbackValue === void 0) { fallbackValue = null; }
        var platform = this.plt;
        if (!Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["h" /* isDefined */])(this._c[key])) {
            if (!Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["h" /* isDefined */])(key)) {
                throw 'config key is not defined';
            }
            // if the value was already set this will all be skipped
            // if there was no user config then it'll check each of
            // the user config's platforms, which already contains
            // settings from default platform configs
            var userPlatformValue = undefined;
            var userDefaultValue = this._s[key];
            var userPlatformModeValue = undefined;
            var userDefaultModeValue = undefined;
            var platformValue = undefined;
            var platformModeValue = undefined;
            var configObj = null;
            if (platform) {
                var queryStringValue = platform.getQueryParam('ionic' + key);
                if (Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["h" /* isDefined */])(queryStringValue)) {
                    return this._c[key] = (queryStringValue === 'true' ? true : queryStringValue === 'false' ? false : queryStringValue);
                }
                // check the platform settings object for this value
                // loop though each of the active platforms
                // array of active platforms, which also knows the hierarchy,
                // with the last one the most important
                var activePlatformKeys = platform.platforms();
                // loop through all of the active platforms we're on
                for (var i = 0, ilen = activePlatformKeys.length; i < ilen; i++) {
                    // get user defined platform values
                    if (this._s.platforms) {
                        configObj = this._s.platforms[activePlatformKeys[i]];
                        if (configObj) {
                            if (Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["h" /* isDefined */])(configObj[key])) {
                                userPlatformValue = configObj[key];
                            }
                            configObj = this.getModeConfig(configObj.mode);
                            if (configObj && Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["h" /* isDefined */])(configObj[key])) {
                                userPlatformModeValue = configObj[key];
                            }
                        }
                    }
                    // get default platform's setting
                    configObj = platform.getPlatformConfig(activePlatformKeys[i]);
                    if (configObj && configObj.settings) {
                        if (Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["h" /* isDefined */])(configObj.settings[key])) {
                            // found a setting for this platform
                            platformValue = configObj.settings[key];
                        }
                        configObj = this.getModeConfig(configObj.settings.mode);
                        if (configObj && Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["h" /* isDefined */])(configObj[key])) {
                            // found setting for this platform's mode
                            platformModeValue = configObj[key];
                        }
                    }
                }
            }
            configObj = this.getModeConfig(this._s.mode);
            if (configObj && Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["h" /* isDefined */])(configObj[key])) {
                userDefaultModeValue = configObj[key];
            }
            // cache the value
            this._c[key] = Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["h" /* isDefined */])(userPlatformValue) ? userPlatformValue :
                Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["h" /* isDefined */])(userDefaultValue) ? userDefaultValue :
                    Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["h" /* isDefined */])(userPlatformModeValue) ? userPlatformModeValue :
                        Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["h" /* isDefined */])(userDefaultModeValue) ? userDefaultModeValue :
                            Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["h" /* isDefined */])(platformValue) ? platformValue :
                                Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["h" /* isDefined */])(platformModeValue) ? platformModeValue :
                                    null;
        }
        // return key's value
        // either it came directly from the user config
        // or it was from the users platform configs
        // or it was from the default platform configs
        // in that order
        var rtnVal = this._c[key];
        if (Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["i" /* isFunction */])(rtnVal)) {
            rtnVal = rtnVal(platform);
        }
        return (rtnVal !== null ? rtnVal : fallbackValue);
    };
    /**
     * @name getBoolean
     * @description
     * Same as `get()`, however always returns a boolean value. If the
     * value from `get()` is `null`, then it'll return the `fallbackValue`
     * which defaults to `false`. Otherwise, `getBoolean()` will return
     * if the config value is truthy or not. It also returns `true` if
     * the config value was the string value `"true"`.
     * @param {string} [key] - the key for the config value
     * @param {boolean} [fallbackValue] - a fallback value to use when the config
     * value was `null`. Fallback value defaults to `false`.
     */
    Config.prototype.getBoolean = function (key, fallbackValue) {
        if (fallbackValue === void 0) { fallbackValue = false; }
        var val = this.get(key);
        if (val === null) {
            return fallbackValue;
        }
        if (typeof val === 'string') {
            return val === 'true';
        }
        return !!val;
    };
    /**
     * @name getNumber
     * @description
     * Same as `get()`, however always returns a number value. Uses `parseFloat()`
     * on the value received from `get()`. If the result from the parse is `NaN`,
     * then it will return the value passed to `fallbackValue`. If no fallback
     * value was provided then it'll default to returning `NaN` when the result
     * is not a valid number.
     * @param {string} [key] - the key for the config value
     * @param {number} [fallbackValue] - a fallback value to use when the config
     * value turned out to be `NaN`. Fallback value defaults to `NaN`.
     */
    Config.prototype.getNumber = function (key, fallbackValue) {
        if (fallbackValue === void 0) { fallbackValue = NaN; }
        return this.parseNumber(this.get(key), fallbackValue);
    };
    Config.prototype.parseNumber = function (value, fallbackValue) {
        if (fallbackValue === void 0) { fallbackValue = NaN; }
        var val = parseFloat(value);
        return isNaN(val) ? fallbackValue : val;
    };
    /**
     * @name set
     * @description
     * Sets a single config value.
     *
     * @param {string} [platform] - The platform (either 'ios' or 'android') that the config value should apply to. Leaving this blank will apply the config value to all platforms.
     * @param {string} [key] - The key used to look up the value at a later point in time.
     * @param {string} [value] - The config value being stored.
     */
    Config.prototype.set = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var arg0 = args[0];
        var arg1 = args[1];
        switch (args.length) {
            case 2:
                // set('key', 'value') = set key/value pair
                // arg1 = value
                this._s[arg0] = arg1;
                delete this._c[arg0]; // clear cache
                break;
            case 3:
                // setting('ios', 'key', 'value') = set key/value pair for platform
                // arg0 = platform
                // arg1 = key
                // arg2 = value
                this._s.platforms = this._s.platforms || {};
                this._s.platforms[arg0] = this._s.platforms[arg0] || {};
                this._s.platforms[arg0][arg1] = args[2];
                delete this._c[arg1]; // clear cache
                break;
        }
        return this;
    };
    /**
     * @hidden
     * @name settings()
     * @description
     */
    Config.prototype.settings = function (arg0, arg1) {
        switch (arguments.length) {
            case 0:
                return this._s;
            case 1:
                // settings({...})
                this._s = arg0;
                this._c = {}; // clear cache
                break;
            case 2:
                // settings('ios', {...})
                this._s.platforms = this._s.platforms || {};
                this._s.platforms[arg0] = arg1;
                this._c = {}; // clear cache
                break;
        }
        return this;
    };
    /**
     * @hidden
     */
    Config.prototype.setModeConfig = function (modeName, modeConfig) {
        this._modes[modeName] = modeConfig;
    };
    /**
     * @hidden
     */
    Config.prototype.getModeConfig = function (modeName) {
        return this._modes[modeName] || null;
    };
    /**
     * @hidden
     */
    Config.prototype.setTransition = function (trnsName, trnsClass) {
        this._trns[trnsName] = trnsClass;
    };
    /**
     * @hidden
     */
    Config.prototype.getTransition = function (trnsName) {
        return this._trns[trnsName] || null;
    };
    return Config;
}());

/**
 * @hidden
 */
function setupConfig(userConfig, plt) {
    var config = new Config();
    config.init(userConfig, plt);
    // add the config obj to the window
    var win = plt.win();
    win['Ionic'] = win['Ionic'] || {};
    win['Ionic']['config'] = config;
    return config;
}
/**
 * @hidden
 */
var ConfigToken = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["InjectionToken"]('USERCONFIG');
//# sourceMappingURL=config.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/config/mode-registry.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MODE_IOS */
/* unused harmony export MODE_MD */
/* unused harmony export MODE_WP */
/* harmony export (immutable) */ __webpack_exports__["a"] = registerModeConfigs;
var MODE_IOS = {
    activator: 'highlight',
    actionSheetEnter: 'action-sheet-slide-in',
    actionSheetLeave: 'action-sheet-slide-out',
    alertEnter: 'alert-pop-in',
    alertLeave: 'alert-pop-out',
    backButtonText: 'Back',
    backButtonIcon: 'ios-arrow-back',
    iconMode: 'ios',
    loadingEnter: 'loading-pop-in',
    loadingLeave: 'loading-pop-out',
    menuType: 'reveal',
    modalEnter: 'modal-slide-in',
    modalLeave: 'modal-slide-out',
    pageTransition: 'ios-transition',
    pickerEnter: 'picker-slide-in',
    pickerLeave: 'picker-slide-out',
    pickerRotateFactor: -0.46,
    pickerScaleFactor: 1,
    popoverEnter: 'popover-pop-in',
    popoverLeave: 'popover-pop-out',
    spinner: 'ios',
    tabsHighlight: false,
    tabsPlacement: 'bottom',
    tabsHideOnSubPages: false,
    toastEnter: 'toast-slide-in',
    toastLeave: 'toast-slide-out',
};
var MODE_MD = {
    activator: 'ripple',
    actionSheetEnter: 'action-sheet-md-slide-in',
    actionSheetLeave: 'action-sheet-md-slide-out',
    alertEnter: 'alert-md-pop-in',
    alertLeave: 'alert-md-pop-out',
    backButtonText: '',
    backButtonIcon: 'md-arrow-back',
    iconMode: 'md',
    loadingEnter: 'loading-md-pop-in',
    loadingLeave: 'loading-md-pop-out',
    menuType: 'overlay',
    modalEnter: 'modal-md-slide-in',
    modalLeave: 'modal-md-slide-out',
    pageTransition: 'md-transition',
    pickerEnter: 'picker-slide-in',
    pickerLeave: 'picker-slide-out',
    pickerRotateFactor: 0,
    pickerScaleFactor: 0.81,
    popoverEnter: 'popover-md-pop-in',
    popoverLeave: 'popover-md-pop-out',
    spinner: 'crescent',
    tabsHighlight: false,
    tabsPlacement: 'bottom',
    tabsHideOnSubPages: false,
    toastEnter: 'toast-md-slide-in',
    toastLeave: 'toast-md-slide-out',
};
var MODE_WP = {
    activator: 'highlight',
    actionSheetEnter: 'action-sheet-wp-slide-in',
    actionSheetLeave: 'action-sheet-wp-slide-out',
    alertEnter: 'alert-wp-pop-in',
    alertLeave: 'alert-wp-pop-out',
    backButtonText: '',
    backButtonIcon: 'ios-arrow-back',
    iconMode: 'ios',
    loadingEnter: 'loading-wp-pop-in',
    loadingLeave: 'loading-wp-pop-out',
    menuType: 'overlay',
    modalEnter: 'modal-md-slide-in',
    modalLeave: 'modal-md-slide-out',
    pageTransition: 'wp-transition',
    pickerEnter: 'picker-slide-in',
    pickerLeave: 'picker-slide-out',
    pickerRotateFactor: 0,
    pickerScaleFactor: 0.81,
    popoverEnter: 'popover-md-pop-in',
    popoverLeave: 'popover-md-pop-out',
    spinner: 'circles',
    tabsHighlight: false,
    tabsPlacement: 'top',
    tabsHideOnSubPages: true,
    toastEnter: 'toast-wp-slide-in',
    toastLeave: 'toast-wp-slide-out',
};
function registerModeConfigs(config) {
    return function () {
        // iOS Mode Settings
        config.setModeConfig('ios', MODE_IOS);
        // Material Design Mode Settings
        config.setModeConfig('md', MODE_MD);
        // Windows Mode Settings
        config.setModeConfig('wp', MODE_WP);
    };
}
//# sourceMappingURL=mode-registry.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/gestures/gesture-config.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IonicGestureConfig; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_platform_browser__ = __webpack_require__("./node_modules/@angular/platform-browser/esm5/platform-browser.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


/**
 * @hidden
 * This class overrides the default Angular gesture config.
 */
var IonicGestureConfig = (function (_super) {
    __extends(IonicGestureConfig, _super);
    function IonicGestureConfig() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IonicGestureConfig.prototype.buildHammer = function (element) {
        var mc = new window.Hammer(element);
        for (var eventName in this.overrides) {
            mc.get(eventName).set(this.overrides[eventName]);
        }
        return mc;
    };
    IonicGestureConfig.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    IonicGestureConfig.ctorParameters = function () { return []; };
    return IonicGestureConfig;
}(__WEBPACK_IMPORTED_MODULE_1__angular_platform_browser__["HammerGestureConfig"]));

//# sourceMappingURL=gesture-config.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/gestures/gesture-controller.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GESTURE_GO_BACK_SWIPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return GESTURE_MENU_SWIPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GESTURE_ITEM_SWIPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return GESTURE_REFRESHER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return GESTURE_TOGGLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return GESTURE_PRIORITY_SLIDING_ITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return GESTURE_PRIORITY_REFRESHER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return GESTURE_PRIORITY_MENU_SWIPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return GESTURE_PRIORITY_GO_BACK_SWIPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return GESTURE_PRIORITY_TOGGLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BLOCK_ALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return GestureController; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return GestureDelegate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BlockerDelegate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_app_app__ = __webpack_require__("./node_modules/ionic-angular/components/app/app.js");


/** @hidden */
var GESTURE_GO_BACK_SWIPE = 'goback-swipe';
/** @hidden */
var GESTURE_MENU_SWIPE = 'menu-swipe';
/** @hidden */
var GESTURE_ITEM_SWIPE = 'item-swipe';
/** @hidden */
var GESTURE_REFRESHER = 'refresher';
/** @hidden */
var GESTURE_TOGGLE = 'toggle';
/** @hidden */
var GESTURE_PRIORITY_SLIDING_ITEM = -10;
/** @hidden */
var GESTURE_PRIORITY_REFRESHER = 0;
/** @hidden */
var GESTURE_PRIORITY_MENU_SWIPE = 10;
/** @hidden */
var GESTURE_PRIORITY_GO_BACK_SWIPE = 20;
/** @hidden */
var GESTURE_PRIORITY_TOGGLE = 30;
/**
* @hidden
*/
var BLOCK_ALL = {
    disable: [GESTURE_MENU_SWIPE, GESTURE_GO_BACK_SWIPE],
    disableScroll: true
};
/**
* @hidden
*/
var GestureController = (function () {
    function GestureController(_app) {
        this._app = _app;
        this.id = 1;
        this.requestedStart = {};
        this.disabledGestures = {};
        this.disabledScroll = new Set();
        this.capturedID = null;
    }
    GestureController.prototype.createGesture = function (opts) {
        if (!opts.name) {
            throw new Error('name is undefined');
        }
        return new GestureDelegate(opts.name, this.newID(), this, opts.priority || 0, !!opts.disableScroll);
    };
    GestureController.prototype.createBlocker = function (opts) {
        if (opts === void 0) { opts = {}; }
        return new BlockerDelegate(this.newID(), this, opts.disable, !!opts.disableScroll);
    };
    GestureController.prototype.newID = function () {
        var id = this.id;
        this.id++;
        return id;
    };
    GestureController.prototype.start = function (gestureName, id, priority) {
        if (!this.canStart(gestureName)) {
            delete this.requestedStart[id];
            return false;
        }
        this.requestedStart[id] = priority;
        return true;
    };
    GestureController.prototype.capture = function (gestureName, id, priority) {
        if (!this.start(gestureName, id, priority)) {
            return false;
        }
        var requestedStart = this.requestedStart;
        var maxPriority = -10000;
        for (var gestureID in requestedStart) {
            maxPriority = Math.max(maxPriority, requestedStart[gestureID]);
        }
        if (maxPriority === priority) {
            this.capturedID = id;
            this.requestedStart = {};
            (void 0) /* console.debug */;
            return true;
        }
        delete requestedStart[id];
        (void 0) /* console.debug */;
        return false;
    };
    GestureController.prototype.release = function (id) {
        delete this.requestedStart[id];
        if (this.capturedID && id === this.capturedID) {
            this.capturedID = null;
        }
    };
    GestureController.prototype.disableGesture = function (gestureName, id) {
        var set = this.disabledGestures[gestureName];
        if (!set) {
            set = new Set();
            this.disabledGestures[gestureName] = set;
        }
        set.add(id);
    };
    GestureController.prototype.enableGesture = function (gestureName, id) {
        var set = this.disabledGestures[gestureName];
        if (set) {
            set.delete(id);
        }
    };
    GestureController.prototype.disableScroll = function (id) {
        var isEnabled = !this.isScrollDisabled();
        this.disabledScroll.add(id);
        if (this._app && isEnabled && this.isScrollDisabled()) {
            (void 0) /* console.debug */;
            this._app._setDisableScroll(true);
        }
    };
    GestureController.prototype.enableScroll = function (id) {
        var isDisabled = this.isScrollDisabled();
        this.disabledScroll.delete(id);
        if (this._app && isDisabled && !this.isScrollDisabled()) {
            (void 0) /* console.debug */;
            this._app._setDisableScroll(false);
        }
    };
    GestureController.prototype.canStart = function (gestureName) {
        if (this.capturedID) {
            (void 0) /* console.debug */;
            // a gesture already captured
            return false;
        }
        if (this.isDisabled(gestureName)) {
            (void 0) /* console.debug */;
            return false;
        }
        return true;
    };
    GestureController.prototype.isCaptured = function () {
        return !!this.capturedID;
    };
    GestureController.prototype.isScrollDisabled = function () {
        return this.disabledScroll.size > 0;
    };
    GestureController.prototype.isDisabled = function (gestureName) {
        var disabled = this.disabledGestures[gestureName];
        return !!(disabled && disabled.size > 0);
    };
    GestureController.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    GestureController.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__components_app_app__["a" /* App */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return __WEBPACK_IMPORTED_MODULE_1__components_app_app__["a" /* App */]; }),] },] },
    ]; };
    return GestureController;
}());

/**
* @hidden
*/
var GestureDelegate = (function () {
    function GestureDelegate(name, id, controller, priority, disableScroll) {
        this.name = name;
        this.id = id;
        this.controller = controller;
        this.priority = priority;
        this.disableScroll = disableScroll;
    }
    GestureDelegate.prototype.canStart = function () {
        if (!this.controller) {
            (void 0) /* assert */;
            return false;
        }
        return this.controller.canStart(this.name);
    };
    GestureDelegate.prototype.start = function () {
        if (!this.controller) {
            (void 0) /* assert */;
            return false;
        }
        return this.controller.start(this.name, this.id, this.priority);
    };
    GestureDelegate.prototype.capture = function () {
        if (!this.controller) {
            (void 0) /* assert */;
            return false;
        }
        var captured = this.controller.capture(this.name, this.id, this.priority);
        if (captured && this.disableScroll) {
            this.controller.disableScroll(this.id);
        }
        return captured;
    };
    GestureDelegate.prototype.release = function () {
        if (!this.controller) {
            (void 0) /* assert */;
            return;
        }
        this.controller.release(this.id);
        if (this.disableScroll) {
            this.controller.enableScroll(this.id);
        }
    };
    GestureDelegate.prototype.destroy = function () {
        this.release();
        this.controller = null;
    };
    return GestureDelegate;
}());

/**
* @hidden
*/
var BlockerDelegate = (function () {
    function BlockerDelegate(id, controller, disable, disableScroll) {
        this.id = id;
        this.controller = controller;
        this.disable = disable;
        this.disableScroll = disableScroll;
        this.blocked = false;
    }
    BlockerDelegate.prototype.block = function () {
        var _this = this;
        if (!this.controller) {
            (void 0) /* assert */;
            return;
        }
        if (this.disable) {
            this.disable.forEach(function (gesture) {
                _this.controller.disableGesture(gesture, _this.id);
            });
        }
        if (this.disableScroll) {
            this.controller.disableScroll(this.id);
        }
        this.blocked = true;
    };
    BlockerDelegate.prototype.unblock = function () {
        var _this = this;
        if (!this.controller) {
            (void 0) /* assert */;
            return;
        }
        if (this.disable) {
            this.disable.forEach(function (gesture) {
                _this.controller.enableGesture(gesture, _this.id);
            });
        }
        if (this.disableScroll) {
            this.controller.enableScroll(this.id);
        }
        this.blocked = false;
    };
    BlockerDelegate.prototype.destroy = function () {
        this.unblock();
        this.controller = null;
    };
    return BlockerDelegate;
}());

//# sourceMappingURL=gesture-controller.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/gestures/gesture.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Gesture; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hammer__ = __webpack_require__("./node_modules/ionic-angular/gestures/hammer.js");


/**
 * @hidden
 * A gesture recognizer class.
 *
 * TODO(mlynch): Re-enable the DOM event simulation that was causing issues (or verify hammer does this already, it might);
 */
var Gesture = (function () {
    function Gesture(element, opts) {
        if (opts === void 0) { opts = {}; }
        this._callbacks = {};
        this.isListening = false;
        Object(__WEBPACK_IMPORTED_MODULE_0__util_util__["d" /* defaults */])(opts, {
            domEvents: true
        });
        this.element = element;
        // Map 'x' or 'y' string to hammerjs opts
        this.direction = opts.direction || 'x';
        opts.direction = this.direction === 'x' ?
            __WEBPACK_IMPORTED_MODULE_1__hammer__["a" /* DIRECTION_HORIZONTAL */] :
            __WEBPACK_IMPORTED_MODULE_1__hammer__["b" /* DIRECTION_VERTICAL */];
        this._options = opts;
    }
    Gesture.prototype.options = function (opts) {
        Object.assign(this._options, opts);
    };
    Gesture.prototype.on = function (type, cb) {
        if (type === 'pinch' || type === 'rotate') {
            this._hammer.get(type).set({ enable: true });
        }
        this._hammer.on(type, cb);
        (this._callbacks[type] || (this._callbacks[type] = [])).push(cb);
    };
    Gesture.prototype.off = function (type, cb) {
        this._hammer.off(type, this._callbacks[type] ? cb : null);
    };
    Gesture.prototype.listen = function () {
        if (!this.isListening) {
            this._hammer = Object(__WEBPACK_IMPORTED_MODULE_1__hammer__["c" /* Hammer */])(this.element, this._options);
        }
        this.isListening = true;
    };
    Gesture.prototype.unlisten = function () {
        var eventType;
        var i;
        if (this._hammer && this.isListening) {
            for (eventType in this._callbacks) {
                for (i = 0; i < this._callbacks[eventType].length; i++) {
                    this._hammer.off(eventType, this._callbacks[eventType]);
                }
            }
            this._hammer.destroy();
        }
        this._callbacks = {};
        this._hammer = null;
        this.isListening = false;
    };
    Gesture.prototype.destroy = function () {
        this.unlisten();
        this.element = this._options = null;
    };
    return Gesture;
}());

//# sourceMappingURL=gesture.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/gestures/hammer.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DIRECTION_LEFT */
/* unused harmony export DIRECTION_RIGHT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DIRECTION_HORIZONTAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DIRECTION_VERTICAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Hammer; });
/* tslint:disable */
var win = window;
var doc = document;
/*! Hammer.JS - v2.0.6 - 2015-12-23
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2015 Jorik Tangelder;
 * Licensed under the  license */
var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = doc.createElement('div');
var TYPE_FUNCTION = 'function';
var round = Math.round;
var abs = Math.abs;
var now = Date.now;
/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}
/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}
/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;
    if (!obj) {
        return;
    }
    if (obj.forEach) {
        obj.forEach(iterator, context);
    }
    else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    }
    else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}
/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype, childP;
    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;
    if (properties) {
        Object.assign(childP, properties);
    }
}
/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}
/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}
/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}
/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function (type) {
        target.addEventListener(type, handler, false);
    });
}
/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function (type) {
        target.removeEventListener(type, handler, false);
    });
}
/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}
/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}
/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}
/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    }
    else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}
/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}
/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;
    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }
    if (sort) {
        if (!key) {
            results = results.sort();
        }
        else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key] ? 1 : 0;
            });
        }
    }
    return results;
}
/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);
    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;
        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}
/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}
/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}
var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;
var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);
var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';
var COMPUTE_INTERVAL = 25;
var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;
var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;
var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;
var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];
/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;
    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function (ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };
    this.init();
}
Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function () { },
    /**
     * bind the events
     */
    init: function () {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },
    /**
     * unbind the events
     */
    destroy: function () {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};
/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;
    if (inputClass) {
        Type = inputClass;
    }
    else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    }
    else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    }
    else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    }
    else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}
/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));
    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;
    if (isFirst) {
        manager.session = {};
    }
    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;
    // compute scale, rotation etc
    computeInputData(manager, input);
    // emit secret event
    manager.emit('hammer.input', input);
    manager.recognize(input);
    manager.session.prevInput = input;
}
/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;
    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }
    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    }
    else if (pointersLength === 1) {
        session.firstMultiple = false;
    }
    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;
    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;
    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);
    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);
    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;
    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;
    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);
    computeIntervalInputData(session, input);
    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}
function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};
    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };
        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }
    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}
/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input, deltaTime = input.timeStamp - last.timeStamp, velocity, velocityX, velocityY, direction;
    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;
        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);
        session.lastInterval = input;
    }
    else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }
    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}
/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }
    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}
/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;
    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }
    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }
    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}
/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}
/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }
    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}
/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]], y = p2[props[1]] - p1[props[1]];
    return Math.sqrt((x * x) + (y * y));
}
/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]], y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}
/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}
/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}
var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};
var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';
/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput(_manager, _handler) {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;
    this.allow = true; // used by Input.TouchMouse to disable mouse events
    this.pressed = false; // mousedown state
    Input.apply(this, arguments);
}
inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];
        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }
        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }
        // mouse must be down, and mouse events are allowed (see the TouchMouse input)
        if (!this.pressed || !this.allow) {
            return;
        }
        if (eventType & INPUT_END) {
            this.pressed = false;
        }
        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});
var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};
// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};
var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';
// IE10 has prefixed support, and case-sensitive
if (win.MSPointerEvent && !win.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}
/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;
    Input.apply(this, arguments);
    this.store = (this.manager.session.pointerEvents = []);
}
inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;
        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;
        var isTouch = (pointerType == INPUT_TYPE_TOUCH);
        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');
        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        }
        else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }
        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }
        // update the event in the store
        store[storeIndex] = ev;
        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });
        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});
var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};
var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';
/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;
    Input.apply(this, arguments);
}
inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];
        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }
        if (!this.started) {
            return;
        }
        var touches = normalizeSingleTouches.call(this, ev, type);
        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }
        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});
/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);
    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }
    return [all, changed];
}
var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};
var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';
/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput(_manager, _handler) {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};
    Input.apply(this, arguments);
}
inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }
        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});
/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;
    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }
    var i, targetTouches, changedTouches = toArray(ev.changedTouches), changedTargetTouches = [], target = this.target;
    // get target touches from touches
    targetTouches = allTouches.filter(function (touch) {
        return hasParent(touch.target, target);
    });
    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }
    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }
        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }
    if (!changedTargetTouches.length) {
        return;
    }
    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}
/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */
function TouchMouseInput() {
    Input.apply(this, arguments);
    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);
}
inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH), isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);
        // when we're in a touch event, so  block all upcoming mouse events
        // most mobile browser also emit mouseevents, right after touchstart
        if (isTouch) {
            this.mouse.allow = false;
        }
        else if (isMouse && !this.mouse.allow) {
            return;
        }
        // reset the allowMouse when we're done
        if (inputEvent & (INPUT_END | INPUT_CANCEL)) {
            this.mouse.allow = true;
        }
        this.callback(manager, inputEvent, inputData);
    },
    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});
var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;
// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}
TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function (value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }
        if (NATIVE_TOUCH_ACTION && this.manager.element.style) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },
    /**
     * just re-set the touchAction value
     */
    update: function () {
        this.set(this.manager.options.touchAction);
    },
    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function () {
        var actions = [];
        each(this.manager.recognizers, function (recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },
    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function (input) {
        // not needed with native support for the touchAction property
        if (NATIVE_TOUCH_ACTION) {
            return;
        }
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;
        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }
        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE);
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
        if (hasNone) {
            //do not prevent defaults if this is a tap gesture
            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;
            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }
        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }
        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },
    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function (srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};
/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }
    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);
    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }
    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }
    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }
    return TOUCH_ACTION_AUTO;
}
/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;
/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = Object.assign({}, this.defaults, options || {});
    this.id = uniqueId();
    this.manager = null;
    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);
    this.state = STATE_POSSIBLE;
    this.simultaneous = {};
    this.requireFail = [];
}
Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},
    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function (options) {
        Object.assign(this.options, options);
        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },
    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function (otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }
        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },
    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function (otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },
    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function (otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }
        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },
    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function (otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },
    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function () {
        return this.requireFail.length > 0;
    },
    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function (otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },
    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function (input) {
        var self = this;
        var state = this.state;
        function emit(event) {
            self.manager.emit(event, input);
        }
        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
        emit(self.options.event); // simple 'eventName' events
        if (input.additionalEvent) {
            emit(input.additionalEvent);
        }
        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },
    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function (input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },
    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function () {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },
    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function (inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = Object.assign({}, inputData);
        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }
        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }
        this.state = this.process(inputDataClone);
        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },
    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function (_inputData) { },
    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function () { },
    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function () { }
};
/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    }
    else if (state & STATE_ENDED) {
        return 'end';
    }
    else if (state & STATE_CHANGED) {
        return 'move';
    }
    else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}
/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    }
    else if (direction == DIRECTION_UP) {
        return 'up';
    }
    else if (direction == DIRECTION_LEFT) {
        return 'left';
    }
    else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}
/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}
/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}
inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },
    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function (input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },
    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function (input) {
        var state = this.state;
        var eventType = input.eventType;
        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);
        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        }
        else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            }
            else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});
/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);
    this.pX = null;
    this.pY = null;
}
inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },
    getTouchAction: function () {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },
    directionTest: function (input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;
        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            }
            else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },
    attrTest: function (input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },
    emit: function (input) {
        this.pX = input.deltaX;
        this.pY = input.deltaY;
        var direction = directionStr(input.direction);
        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});
/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}
inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },
    getTouchAction: function () {
        return [TOUCH_ACTION_NONE];
    },
    attrTest: function (input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },
    emit: function (input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});
/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);
    this._timer = null;
    this._input = null;
}
inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251,
        threshold: 9 // a minimal movement is ok, but keep it low
    },
    getTouchAction: function () {
        return [TOUCH_ACTION_AUTO];
    },
    process: function (input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;
        this._input = input;
        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        }
        else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function () {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        }
        else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },
    reset: function () {
        clearTimeout(this._timer);
    },
    emit: function (input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }
        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        }
        else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});
/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}
inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },
    getTouchAction: function () {
        return [TOUCH_ACTION_NONE];
    },
    attrTest: function (input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});
/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}
inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },
    getTouchAction: function () {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },
    attrTest: function (input) {
        var direction = this.options.direction;
        var velocity;
        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        }
        else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        }
        else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }
        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },
    emit: function (input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }
        this.manager.emit(this.options.event, input);
    }
});
/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);
    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;
    this._timer = null;
    this._input = null;
    this.count = 0;
}
inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300,
        time: 250,
        threshold: 9,
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },
    getTouchAction: function () {
        return [TOUCH_ACTION_MANIPULATION];
    },
    process: function (input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;
        this.reset();
        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }
        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }
            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;
            this.pTime = input.timeStamp;
            this.pCenter = input.center;
            if (!validMultiTap || !validInterval) {
                this.count = 1;
            }
            else {
                this.count += 1;
            }
            this._input = input;
            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                }
                else {
                    this._timer = setTimeoutContext(function () {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },
    failTimeout: function () {
        this._timer = setTimeoutContext(function () {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },
    reset: function () {
        clearTimeout(this._timer);
    },
    emit: function () {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});
/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, _defaults.preset);
    return new Manager(element, options);
}
/**
 * default settings
 * @namespace
 */
var _defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,
    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,
    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,
    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,
    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,
    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, { enable: false }],
        [PinchRecognizer, { enable: false }, ['rotate']],
        [SwipeRecognizer, { direction: DIRECTION_HORIZONTAL }],
        [PanRecognizer, { direction: DIRECTION_HORIZONTAL }, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, { event: 'doubletap', taps: 2 }, ['tap']],
        [PressRecognizer]
    ],
    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',
        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',
        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',
        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',
        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',
        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};
var STOP = 1;
var FORCED_STOP = 2;
/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = Object.assign({}, _defaults, options || {});
    this.options.inputTarget = this.options.inputTarget || element;
    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);
    toggleCssProps(this, true);
    each(this.options.recognizers, function (item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}
Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function (options) {
        Object.assign(this.options, options);
        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },
    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function (force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },
    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function (inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }
        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);
        var recognizer;
        var recognizers = this.recognizers;
        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;
        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }
        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];
            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && (!curRecognizer || recognizer == curRecognizer ||
                recognizer.canRecognizeWith(curRecognizer))) {
                recognizer.recognize(inputData);
            }
            else {
                recognizer.reset();
            }
            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },
    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function (recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }
        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },
    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function (recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }
        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }
        this.recognizers.push(recognizer);
        recognizer.manager = this;
        this.touchAction.update();
        return recognizer;
    },
    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function (recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }
        recognizer = this.get(recognizer);
        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);
            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }
        return this;
    },
    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function (events, handler) {
        var handlers = this.handlers;
        each(splitStr(events), function (event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },
    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function (events, handler) {
        var handlers = this.handlers;
        each(splitStr(events), function (event) {
            if (!handler) {
                delete handlers[event];
            }
            else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },
    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function (event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }
        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }
        data.type = event;
        data.preventDefault = function () {
            data.srcEvent.preventDefault();
        };
        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },
    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function () {
        this.element && toggleCssProps(this, false);
        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};
/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    each(manager.options.cssProps, function (value, name) {
        element.style[prefixed(element.style, name)] = add ? value : '';
    });
}
/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = doc.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}
Object.assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,
    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,
    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,
    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,
    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,
    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,
    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});
win.Hammer = Hammer;

//# sourceMappingURL=hammer.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/gestures/pan-gesture.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PanGesture; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__recognizers__ = __webpack_require__("./node_modules/ionic-angular/gestures/recognizers.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_dom__ = __webpack_require__("./node_modules/ionic-angular/util/dom.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_event_manager__ = __webpack_require__("./node_modules/ionic-angular/gestures/ui-event-manager.js");




/**
 * @hidden
 */
var PanGesture = (function () {
    function PanGesture(plt, element, opts) {
        if (opts === void 0) { opts = {}; }
        this.plt = plt;
        this.element = element;
        Object(__WEBPACK_IMPORTED_MODULE_0__util_util__["d" /* defaults */])(opts, {
            threshold: 20,
            maxAngle: 40,
            direction: 'x',
            zone: true,
            capture: false,
            passive: false,
        });
        this.events = new __WEBPACK_IMPORTED_MODULE_3__ui_event_manager__["a" /* UIEventManager */](plt);
        if (opts.domController) {
            this.debouncer = opts.domController.debouncer();
        }
        this.gestute = opts.gesture;
        this.direction = opts.direction;
        this.eventsConfig = {
            element: this.element,
            pointerDown: this.pointerDown.bind(this),
            pointerMove: this.pointerMove.bind(this),
            pointerUp: this.pointerUp.bind(this),
            zone: opts.zone,
            capture: opts.capture,
            passive: opts.passive
        };
        if (opts.threshold > 0) {
            this.detector = new __WEBPACK_IMPORTED_MODULE_1__recognizers__["a" /* PanRecognizer */](opts.direction, opts.threshold, opts.maxAngle);
        }
    }
    PanGesture.prototype.listen = function () {
        if (!this.isListening) {
            this.pointerEvents = this.events.pointerEvents(this.eventsConfig);
            this.isListening = true;
        }
    };
    PanGesture.prototype.unlisten = function () {
        if (this.isListening) {
            this.gestute && this.gestute.release();
            this.events.unlistenAll();
            this.isListening = false;
        }
    };
    PanGesture.prototype.destroy = function () {
        this.gestute && this.gestute.destroy();
        this.gestute = null;
        this.unlisten();
        this.events.destroy();
        this.events = this.element = this.gestute = null;
    };
    PanGesture.prototype.pointerDown = function (ev) {
        if (this.started) {
            return;
        }
        if (!this.canStart(ev)) {
            return false;
        }
        if (this.gestute) {
            // Release fallback
            this.gestute.release();
            // Start gesture
            if (!this.gestute.start()) {
                return false;
            }
        }
        this.started = true;
        this.captured = false;
        var coord = Object(__WEBPACK_IMPORTED_MODULE_2__util_dom__["f" /* pointerCoord */])(ev);
        if (this.detector) {
            this.detector.start(coord);
        }
        else {
            if (!this.tryToCapture(ev)) {
                this.started = false;
                this.captured = false;
                this.gestute.release();
                return false;
            }
        }
        return true;
    };
    PanGesture.prototype.pointerMove = function (ev) {
        var _this = this;
        (void 0) /* assert */;
        if (this.captured) {
            this.debouncer.write(function () {
                _this.onDragMove(ev);
            });
            return;
        }
        (void 0) /* assert */;
        var coord = Object(__WEBPACK_IMPORTED_MODULE_2__util_dom__["f" /* pointerCoord */])(ev);
        if (this.detector.detect(coord)) {
            if (this.detector.pan() !== 0) {
                if (!this.tryToCapture(ev)) {
                    this.abort(ev);
                }
            }
        }
    };
    PanGesture.prototype.pointerUp = function (ev) {
        (void 0) /* assert */;
        this.debouncer.cancel();
        this.gestute && this.gestute.release();
        if (this.captured) {
            this.onDragEnd(ev);
        }
        else {
            this.notCaptured(ev);
        }
        this.captured = false;
        this.started = false;
    };
    PanGesture.prototype.tryToCapture = function (ev) {
        (void 0) /* assert */;
        (void 0) /* assert */;
        if (this.gestute && !this.gestute.capture()) {
            return false;
        }
        this.onDragStart(ev);
        this.captured = true;
        return true;
    };
    PanGesture.prototype.abort = function (ev) {
        this.started = false;
        this.captured = false;
        this.gestute.release();
        this.pointerEvents.stop();
        this.notCaptured(ev);
    };
    PanGesture.prototype.getNativeElement = function () {
        return this.element;
    };
    // Implemented in a subclass
    PanGesture.prototype.canStart = function (_ev) { return true; };
    PanGesture.prototype.onDragStart = function (_ev) { };
    PanGesture.prototype.onDragMove = function (_ev) { };
    PanGesture.prototype.onDragEnd = function (_ev) { };
    PanGesture.prototype.notCaptured = function (_ev) { };
    return PanGesture;
}());

//# sourceMappingURL=pan-gesture.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/gestures/pointer-events.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PointerEvents; });
/* unused harmony export POINTER_EVENT_TYPE_MOUSE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return POINTER_EVENT_TYPE_TOUCH; });
/**
 * @hidden
 */
var PointerEvents = (function () {
    function PointerEvents(plt, ele, pointerDown, pointerMove, pointerUp, option) {
        this.plt = plt;
        this.ele = ele;
        this.pointerDown = pointerDown;
        this.pointerMove = pointerMove;
        this.pointerUp = pointerUp;
        this.option = option;
        this.rmTouchStart = null;
        this.rmTouchMove = null;
        this.rmTouchEnd = null;
        this.rmTouchCancel = null;
        this.rmMouseStart = null;
        this.rmMouseMove = null;
        this.rmMouseUp = null;
        this.lastTouchEvent = 0;
        this.mouseWait = 2 * 1000;
        (void 0) /* assert */;
        (void 0) /* assert */;
        this.bindTouchEnd = this.handleTouchEnd.bind(this);
        this.bindMouseUp = this.handleMouseUp.bind(this);
        this.rmTouchStart = this.plt.registerListener(ele, 'touchstart', this.handleTouchStart.bind(this), option);
        this.rmMouseStart = this.plt.registerListener(ele, 'mousedown', this.handleMouseDown.bind(this), option);
    }
    PointerEvents.prototype.handleTouchStart = function (ev) {
        (void 0) /* assert */;
        (void 0) /* assert */;
        this.lastTouchEvent = Date.now() + this.mouseWait;
        this.lastEventType = POINTER_EVENT_TYPE_TOUCH;
        if (!this.pointerDown(ev, POINTER_EVENT_TYPE_TOUCH)) {
            return;
        }
        if (!this.rmTouchMove && this.pointerMove) {
            this.rmTouchMove = this.plt.registerListener(this.ele, 'touchmove', this.pointerMove, this.option);
        }
        if (!this.rmTouchEnd) {
            this.rmTouchEnd = this.plt.registerListener(this.ele, 'touchend', this.bindTouchEnd, this.option);
        }
        if (!this.rmTouchCancel) {
            this.rmTouchCancel = this.plt.registerListener(this.ele, 'touchcancel', this.bindTouchEnd, this.option);
        }
    };
    PointerEvents.prototype.handleMouseDown = function (ev) {
        (void 0) /* assert */;
        (void 0) /* assert */;
        if (this.lastTouchEvent > Date.now()) {
            (void 0) /* console.debug */;
            return;
        }
        this.lastEventType = POINTER_EVENT_TYPE_MOUSE;
        if (!this.pointerDown(ev, POINTER_EVENT_TYPE_MOUSE)) {
            return;
        }
        if (!this.rmMouseMove && this.pointerMove) {
            this.rmMouseMove = this.plt.registerListener(this.plt.doc(), 'mousemove', this.pointerMove, this.option);
        }
        if (!this.rmMouseUp) {
            this.rmMouseUp = this.plt.registerListener(this.plt.doc(), 'mouseup', this.bindMouseUp, this.option);
        }
    };
    PointerEvents.prototype.handleTouchEnd = function (ev) {
        this.stopTouch();
        this.pointerUp && this.pointerUp(ev, POINTER_EVENT_TYPE_TOUCH);
    };
    PointerEvents.prototype.handleMouseUp = function (ev) {
        this.stopMouse();
        this.pointerUp && this.pointerUp(ev, POINTER_EVENT_TYPE_MOUSE);
    };
    PointerEvents.prototype.stopTouch = function () {
        this.rmTouchMove && this.rmTouchMove();
        this.rmTouchEnd && this.rmTouchEnd();
        this.rmTouchCancel && this.rmTouchCancel();
        this.rmTouchMove = this.rmTouchEnd = this.rmTouchCancel = null;
    };
    PointerEvents.prototype.stopMouse = function () {
        this.rmMouseMove && this.rmMouseMove();
        this.rmMouseUp && this.rmMouseUp();
        this.rmMouseMove = this.rmMouseUp = null;
    };
    PointerEvents.prototype.stop = function () {
        this.stopTouch();
        this.stopMouse();
    };
    PointerEvents.prototype.destroy = function () {
        this.rmTouchStart && this.rmTouchStart();
        this.rmMouseStart && this.rmMouseStart();
        this.stop();
        this.ele = this.pointerUp = this.pointerMove = this.pointerDown = this.rmTouchStart = this.rmMouseStart = null;
    };
    return PointerEvents;
}());

var POINTER_EVENT_TYPE_MOUSE = 1;
var POINTER_EVENT_TYPE_TOUCH = 2;
//# sourceMappingURL=pointer-events.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/gestures/recognizers.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PanRecognizer; });
var PanRecognizer = (function () {
    function PanRecognizer(direction, threshold, maxAngle) {
        this.direction = direction;
        this.dirty = false;
        this._angle = 0;
        this._isPan = 0;
        var radians = maxAngle * (Math.PI / 180);
        this.maxCosine = Math.cos(radians);
        this.threshold = threshold * threshold;
    }
    PanRecognizer.prototype.start = function (coord) {
        this.startCoord = coord;
        this._angle = 0;
        this._isPan = 0;
        this.dirty = true;
    };
    PanRecognizer.prototype.detect = function (coord) {
        if (!this.dirty) {
            return false;
        }
        var deltaX = (coord.x - this.startCoord.x);
        var deltaY = (coord.y - this.startCoord.y);
        var distance = deltaX * deltaX + deltaY * deltaY;
        if (distance >= this.threshold) {
            var angle = Math.atan2(deltaY, deltaX);
            var cosine = (this.direction === 'y')
                ? Math.sin(angle)
                : Math.cos(angle);
            this._angle = angle;
            if (cosine > this.maxCosine) {
                this._isPan = 1;
            }
            else if (cosine < -this.maxCosine) {
                this._isPan = -1;
            }
            else {
                this._isPan = 0;
            }
            this.dirty = false;
            return true;
        }
        return false;
    };
    PanRecognizer.prototype.angle = function () {
        return this._angle;
    };
    PanRecognizer.prototype.pan = function () {
        return this._isPan;
    };
    return PanRecognizer;
}());

//# sourceMappingURL=recognizers.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/gestures/slide-edge-gesture.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SlideEdgeGesture; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__slide_gesture__ = __webpack_require__("./node_modules/ionic-angular/gestures/slide-gesture.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_dom__ = __webpack_require__("./node_modules/ionic-angular/util/dom.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



/**
 * @hidden
 */
var SlideEdgeGesture = (function (_super) {
    __extends(SlideEdgeGesture, _super);
    function SlideEdgeGesture(plt, element, opts) {
        if (opts === void 0) { opts = {}; }
        var _this = this;
        Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["d" /* defaults */])(opts, {
            edge: 'start',
            maxEdgeStart: 50
        });
        _this = _super.call(this, plt, element, opts) || this;
        // Can check corners through use of eg 'left top'
        _this.setEdges(opts.edge);
        _this.maxEdgeStart = opts.maxEdgeStart;
        return _this;
    }
    SlideEdgeGesture.prototype.setEdges = function (edges) {
        var isRTL = this.plt.isRTL;
        this.edges = edges.split(' ').map(function (value) {
            switch (value) {
                case 'start': return isRTL ? 'right' : 'left';
                case 'end': return isRTL ? 'left' : 'right';
                default: return value;
            }
        });
    };
    SlideEdgeGesture.prototype.canStart = function (ev) {
        var _this = this;
        var coord = Object(__WEBPACK_IMPORTED_MODULE_2__util_dom__["f" /* pointerCoord */])(ev);
        this._d = this.getContainerDimensions();
        return this.edges.every(function (edge) { return _this._checkEdge(edge, coord); });
    };
    SlideEdgeGesture.prototype.getContainerDimensions = function () {
        var plt = this.plt;
        return {
            left: 0,
            top: 0,
            width: plt.width(),
            height: plt.height()
        };
    };
    SlideEdgeGesture.prototype._checkEdge = function (edge, pos) {
        var data = this._d;
        var maxEdgeStart = this.maxEdgeStart;
        switch (edge) {
            case 'left': return pos.x <= data.left + maxEdgeStart;
            case 'right': return pos.x >= data.width - maxEdgeStart;
            case 'top': return pos.y <= data.top + maxEdgeStart;
            case 'bottom': return pos.y >= data.height - maxEdgeStart;
        }
        return false;
    };
    return SlideEdgeGesture;
}(__WEBPACK_IMPORTED_MODULE_0__slide_gesture__["a" /* SlideGesture */]));

//# sourceMappingURL=slide-edge-gesture.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/gestures/slide-gesture.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SlideGesture; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pan_gesture__ = __webpack_require__("./node_modules/ionic-angular/gestures/pan-gesture.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_dom__ = __webpack_require__("./node_modules/ionic-angular/util/dom.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



/**
 * @hidden
 */
var SlideGesture = (function (_super) {
    __extends(SlideGesture, _super);
    function SlideGesture(plt, element, opts) {
        if (opts === void 0) { opts = {}; }
        var _this = _super.call(this, plt, element, opts) || this;
        _this.slide = null;
        return _this;
    }
    /*
     * Get the min and max for the slide. pageX/pageY.
     * Only called on dragstart.
     */
    SlideGesture.prototype.getSlideBoundaries = function (_slide, _ev) {
        return {
            min: 0,
            max: this.getNativeElement().offsetWidth
        };
    };
    /*
     * Get the element's pos when the drag starts.
     * For example, an open side menu starts at 100% and a closed
     * sidemenu starts at 0%.
     */
    SlideGesture.prototype.getElementStartPos = function (_slide, _ev) {
        return 0;
    };
    SlideGesture.prototype.onDragStart = function (ev) {
        this.onSlideBeforeStart(ev);
        var coord = Object(__WEBPACK_IMPORTED_MODULE_2__util_dom__["f" /* pointerCoord */])(ev);
        var pos = coord[this.direction];
        this.slide = {
            min: 0,
            max: 0,
            pointerStartPos: pos,
            pos: pos,
            timestamp: Date.now(),
            elementStartPos: 0,
            started: true,
            delta: 0,
            distance: 0,
            velocity: 0,
        };
        // TODO: we should run this in the next frame
        var _a = this.getSlideBoundaries(this.slide, ev), min = _a.min, max = _a.max;
        this.slide.min = min;
        this.slide.max = max;
        this.slide.elementStartPos = this.getElementStartPos(this.slide, ev);
        this.onSlideStart(this.slide, ev);
    };
    SlideGesture.prototype.onDragMove = function (ev) {
        var slide = this.slide;
        (void 0) /* assert */;
        var coord = Object(__WEBPACK_IMPORTED_MODULE_2__util_dom__["f" /* pointerCoord */])(ev);
        var newPos = coord[this.direction];
        var newTimestamp = Date.now();
        var velocity = (this.plt.isRTL ? (slide.pos - newPos) : (newPos - slide.pos)) / (newTimestamp - slide.timestamp);
        slide.pos = newPos;
        slide.timestamp = newTimestamp;
        slide.distance = Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["a" /* clamp */])(slide.min, (this.plt.isRTL ? slide.pointerStartPos - newPos : newPos - slide.pointerStartPos) + slide.elementStartPos, slide.max);
        slide.velocity = velocity;
        slide.delta = (this.plt.isRTL ? slide.pointerStartPos - newPos : newPos - slide.pointerStartPos);
        this.onSlide(slide, ev);
    };
    SlideGesture.prototype.onDragEnd = function (ev) {
        this.onSlideEnd(this.slide, ev);
        this.slide = null;
    };
    SlideGesture.prototype.onSlideBeforeStart = function (_ev) { };
    SlideGesture.prototype.onSlideStart = function (_slide, _ev) { };
    SlideGesture.prototype.onSlide = function (_slide, _ev) { };
    SlideGesture.prototype.onSlideEnd = function (_slide, _ev) { };
    return SlideGesture;
}(__WEBPACK_IMPORTED_MODULE_0__pan_gesture__["a" /* PanGesture */]));

//# sourceMappingURL=slide-gesture.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/gestures/ui-event-manager.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UIEventManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pointer_events__ = __webpack_require__("./node_modules/ionic-angular/gestures/pointer-events.js");

/**
 * @hidden
 */
var UIEventManager = (function () {
    function UIEventManager(plt) {
        this.plt = plt;
        this.evts = [];
    }
    UIEventManager.prototype.pointerEvents = function (config) {
        if (!config.element || !config.pointerDown) {
            console.error('PointerEvents config is invalid');
            return;
        }
        var eventListnerOpts = {
            capture: config.capture,
            passive: config.passive,
            zone: config.zone
        };
        var pointerEvents = new __WEBPACK_IMPORTED_MODULE_0__pointer_events__["b" /* PointerEvents */](this.plt, config.element, config.pointerDown, config.pointerMove, config.pointerUp, eventListnerOpts);
        var removeFunc = function () { return pointerEvents.destroy(); };
        this.evts.push(removeFunc);
        return pointerEvents;
    };
    UIEventManager.prototype.listen = function (ele, eventName, callback, opts) {
        if (ele) {
            var removeFunc = this.plt.registerListener(ele, eventName, callback, opts);
            this.evts.push(removeFunc);
            return removeFunc;
        }
    };
    UIEventManager.prototype.unlistenAll = function () {
        this.evts.forEach(function (unRegEvent) {
            unRegEvent();
        });
        this.evts.length = 0;
    };
    UIEventManager.prototype.destroy = function () {
        this.unlistenAll();
        this.evts = null;
    };
    return UIEventManager;
}());

//# sourceMappingURL=ui-event-manager.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_app_app_root__ = __webpack_require__("./node_modules/ionic-angular/components/app/app-root.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "IonicApp", function() { return __WEBPACK_IMPORTED_MODULE_0__components_app_app_root__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_app_menu_controller__ = __webpack_require__("./node_modules/ionic-angular/components/app/menu-controller.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MenuController", function() { return __WEBPACK_IMPORTED_MODULE_1__components_app_menu_controller__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_action_sheet_action_sheet__ = __webpack_require__("./node_modules/ionic-angular/components/action-sheet/action-sheet.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ActionSheet", function() { return __WEBPACK_IMPORTED_MODULE_2__components_action_sheet_action_sheet__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_action_sheet_action_sheet_controller__ = __webpack_require__("./node_modules/ionic-angular/components/action-sheet/action-sheet-controller.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ActionSheetController", function() { return __WEBPACK_IMPORTED_MODULE_3__components_action_sheet_action_sheet_controller__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_action_sheet_action_sheet_component__ = __webpack_require__("./node_modules/ionic-angular/components/action-sheet/action-sheet-component.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ActionSheetCmp", function() { return __WEBPACK_IMPORTED_MODULE_4__components_action_sheet_action_sheet_component__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_alert_alert__ = __webpack_require__("./node_modules/ionic-angular/components/alert/alert.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Alert", function() { return __WEBPACK_IMPORTED_MODULE_5__components_alert_alert__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_alert_alert_controller__ = __webpack_require__("./node_modules/ionic-angular/components/alert/alert-controller.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AlertController", function() { return __WEBPACK_IMPORTED_MODULE_6__components_alert_alert_controller__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_alert_alert_component__ = __webpack_require__("./node_modules/ionic-angular/components/alert/alert-component.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AlertCmp", function() { return __WEBPACK_IMPORTED_MODULE_7__components_alert_alert_component__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_app_app__ = __webpack_require__("./node_modules/ionic-angular/components/app/app.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "App", function() { return __WEBPACK_IMPORTED_MODULE_8__components_app_app__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_avatar_avatar__ = __webpack_require__("./node_modules/ionic-angular/components/avatar/avatar.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Avatar", function() { return __WEBPACK_IMPORTED_MODULE_9__components_avatar_avatar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_backdrop_backdrop__ = __webpack_require__("./node_modules/ionic-angular/components/backdrop/backdrop.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Backdrop", function() { return __WEBPACK_IMPORTED_MODULE_10__components_backdrop_backdrop__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_badge_badge__ = __webpack_require__("./node_modules/ionic-angular/components/badge/badge.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return __WEBPACK_IMPORTED_MODULE_11__components_badge_badge__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_button_button__ = __webpack_require__("./node_modules/ionic-angular/components/button/button.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Button", function() { return __WEBPACK_IMPORTED_MODULE_12__components_button_button__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_card_card__ = __webpack_require__("./node_modules/ionic-angular/components/card/card.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Card", function() { return __WEBPACK_IMPORTED_MODULE_13__components_card_card__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_card_card_content__ = __webpack_require__("./node_modules/ionic-angular/components/card/card-content.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CardContent", function() { return __WEBPACK_IMPORTED_MODULE_14__components_card_card_content__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_card_card_header__ = __webpack_require__("./node_modules/ionic-angular/components/card/card-header.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CardHeader", function() { return __WEBPACK_IMPORTED_MODULE_15__components_card_card_header__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_card_card_title__ = __webpack_require__("./node_modules/ionic-angular/components/card/card-title.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CardTitle", function() { return __WEBPACK_IMPORTED_MODULE_16__components_card_card_title__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_checkbox_checkbox__ = __webpack_require__("./node_modules/ionic-angular/components/checkbox/checkbox.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Checkbox", function() { return __WEBPACK_IMPORTED_MODULE_17__components_checkbox_checkbox__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_chip_chip__ = __webpack_require__("./node_modules/ionic-angular/components/chip/chip.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Chip", function() { return __WEBPACK_IMPORTED_MODULE_18__components_chip_chip__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_content_content__ = __webpack_require__("./node_modules/ionic-angular/components/content/content.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Content", function() { return __WEBPACK_IMPORTED_MODULE_19__components_content_content__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_datetime_datetime__ = __webpack_require__("./node_modules/ionic-angular/components/datetime/datetime.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DateTime", function() { return __WEBPACK_IMPORTED_MODULE_20__components_datetime_datetime__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_fab_fab__ = __webpack_require__("./node_modules/ionic-angular/components/fab/fab.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FabButton", function() { return __WEBPACK_IMPORTED_MODULE_21__components_fab_fab__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_fab_fab_container__ = __webpack_require__("./node_modules/ionic-angular/components/fab/fab-container.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FabContainer", function() { return __WEBPACK_IMPORTED_MODULE_22__components_fab_fab_container__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_fab_fab_list__ = __webpack_require__("./node_modules/ionic-angular/components/fab/fab-list.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FabList", function() { return __WEBPACK_IMPORTED_MODULE_23__components_fab_fab_list__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_grid_col__ = __webpack_require__("./node_modules/ionic-angular/components/grid/col.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Col", function() { return __WEBPACK_IMPORTED_MODULE_24__components_grid_col__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_grid_grid__ = __webpack_require__("./node_modules/ionic-angular/components/grid/grid.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Grid", function() { return __WEBPACK_IMPORTED_MODULE_25__components_grid_grid__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_grid_row__ = __webpack_require__("./node_modules/ionic-angular/components/grid/row.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Row", function() { return __WEBPACK_IMPORTED_MODULE_26__components_grid_row__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_ion__ = __webpack_require__("./node_modules/ionic-angular/components/ion.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Ion", function() { return __WEBPACK_IMPORTED_MODULE_27__components_ion__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_icon_icon__ = __webpack_require__("./node_modules/ionic-angular/components/icon/icon.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Icon", function() { return __WEBPACK_IMPORTED_MODULE_28__components_icon_icon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_img_img__ = __webpack_require__("./node_modules/ionic-angular/components/img/img.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Img", function() { return __WEBPACK_IMPORTED_MODULE_29__components_img_img__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_infinite_scroll_infinite_scroll__ = __webpack_require__("./node_modules/ionic-angular/components/infinite-scroll/infinite-scroll.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "InfiniteScroll", function() { return __WEBPACK_IMPORTED_MODULE_30__components_infinite_scroll_infinite_scroll__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_infinite_scroll_infinite_scroll_content__ = __webpack_require__("./node_modules/ionic-angular/components/infinite-scroll/infinite-scroll-content.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "InfiniteScrollContent", function() { return __WEBPACK_IMPORTED_MODULE_31__components_infinite_scroll_infinite_scroll_content__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_input_input__ = __webpack_require__("./node_modules/ionic-angular/components/input/input.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TextInput", function() { return __WEBPACK_IMPORTED_MODULE_32__components_input_input__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_item_item__ = __webpack_require__("./node_modules/ionic-angular/components/item/item.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Item", function() { return __WEBPACK_IMPORTED_MODULE_33__components_item_item__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_item_item_content__ = __webpack_require__("./node_modules/ionic-angular/components/item/item-content.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ItemContent", function() { return __WEBPACK_IMPORTED_MODULE_34__components_item_item_content__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_item_item_divider__ = __webpack_require__("./node_modules/ionic-angular/components/item/item-divider.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ItemDivider", function() { return __WEBPACK_IMPORTED_MODULE_35__components_item_item_divider__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_item_item_group__ = __webpack_require__("./node_modules/ionic-angular/components/item/item-group.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ItemGroup", function() { return __WEBPACK_IMPORTED_MODULE_36__components_item_item_group__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_item_item_options__ = __webpack_require__("./node_modules/ionic-angular/components/item/item-options.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ItemOptions", function() { return __WEBPACK_IMPORTED_MODULE_37__components_item_item_options__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_item_item_reorder__ = __webpack_require__("./node_modules/ionic-angular/components/item/item-reorder.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ItemReorder", function() { return __WEBPACK_IMPORTED_MODULE_38__components_item_item_reorder__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_item_item_sliding__ = __webpack_require__("./node_modules/ionic-angular/components/item/item-sliding.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ItemSliding", function() { return __WEBPACK_IMPORTED_MODULE_39__components_item_item_sliding__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_item_reorder__ = __webpack_require__("./node_modules/ionic-angular/components/item/reorder.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Reorder", function() { return __WEBPACK_IMPORTED_MODULE_40__components_item_reorder__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_label_label__ = __webpack_require__("./node_modules/ionic-angular/components/label/label.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Label", function() { return __WEBPACK_IMPORTED_MODULE_41__components_label_label__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_list_list__ = __webpack_require__("./node_modules/ionic-angular/components/list/list.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "List", function() { return __WEBPACK_IMPORTED_MODULE_42__components_list_list__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_list_list_header__ = __webpack_require__("./node_modules/ionic-angular/components/list/list-header.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ListHeader", function() { return __WEBPACK_IMPORTED_MODULE_43__components_list_list_header__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_loading_loading__ = __webpack_require__("./node_modules/ionic-angular/components/loading/loading.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Loading", function() { return __WEBPACK_IMPORTED_MODULE_44__components_loading_loading__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_loading_loading_controller__ = __webpack_require__("./node_modules/ionic-angular/components/loading/loading-controller.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "LoadingController", function() { return __WEBPACK_IMPORTED_MODULE_45__components_loading_loading_controller__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_loading_loading_component__ = __webpack_require__("./node_modules/ionic-angular/components/loading/loading-component.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "LoadingCmp", function() { return __WEBPACK_IMPORTED_MODULE_46__components_loading_loading_component__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_menu_menu__ = __webpack_require__("./node_modules/ionic-angular/components/menu/menu.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Menu", function() { return __WEBPACK_IMPORTED_MODULE_47__components_menu_menu__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_menu_menu_close__ = __webpack_require__("./node_modules/ionic-angular/components/menu/menu-close.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MenuClose", function() { return __WEBPACK_IMPORTED_MODULE_48__components_menu_menu_close__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_menu_menu_toggle__ = __webpack_require__("./node_modules/ionic-angular/components/menu/menu-toggle.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MenuToggle", function() { return __WEBPACK_IMPORTED_MODULE_49__components_menu_menu_toggle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_menu_menu_types__ = __webpack_require__("./node_modules/ionic-angular/components/menu/menu-types.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MenuType", function() { return __WEBPACK_IMPORTED_MODULE_50__components_menu_menu_types__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_modal_modal__ = __webpack_require__("./node_modules/ionic-angular/components/modal/modal.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Modal", function() { return __WEBPACK_IMPORTED_MODULE_51__components_modal_modal__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_modal_modal_component__ = __webpack_require__("./node_modules/ionic-angular/components/modal/modal-component.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ModalCmp", function() { return __WEBPACK_IMPORTED_MODULE_52__components_modal_modal_component__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_modal_modal_controller__ = __webpack_require__("./node_modules/ionic-angular/components/modal/modal-controller.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ModalController", function() { return __WEBPACK_IMPORTED_MODULE_53__components_modal_modal_controller__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_nav_nav__ = __webpack_require__("./node_modules/ionic-angular/components/nav/nav.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Nav", function() { return __WEBPACK_IMPORTED_MODULE_54__components_nav_nav__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_nav_nav_pop__ = __webpack_require__("./node_modules/ionic-angular/components/nav/nav-pop.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NavPop", function() { return __WEBPACK_IMPORTED_MODULE_55__components_nav_nav_pop__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_nav_nav_pop_anchor__ = __webpack_require__("./node_modules/ionic-angular/components/nav/nav-pop-anchor.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NavPopAnchor", function() { return __WEBPACK_IMPORTED_MODULE_56__components_nav_nav_pop_anchor__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__components_nav_nav_push__ = __webpack_require__("./node_modules/ionic-angular/components/nav/nav-push.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NavPush", function() { return __WEBPACK_IMPORTED_MODULE_57__components_nav_nav_push__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__components_nav_nav_push_anchor__ = __webpack_require__("./node_modules/ionic-angular/components/nav/nav-push-anchor.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NavPushAnchor", function() { return __WEBPACK_IMPORTED_MODULE_58__components_nav_nav_push_anchor__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__components_note_note__ = __webpack_require__("./node_modules/ionic-angular/components/note/note.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Note", function() { return __WEBPACK_IMPORTED_MODULE_59__components_note_note__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__components_option_option__ = __webpack_require__("./node_modules/ionic-angular/components/option/option.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Option", function() { return __WEBPACK_IMPORTED_MODULE_60__components_option_option__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__components_picker_picker__ = __webpack_require__("./node_modules/ionic-angular/components/picker/picker.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Picker", function() { return __WEBPACK_IMPORTED_MODULE_61__components_picker_picker__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__components_picker_picker_component__ = __webpack_require__("./node_modules/ionic-angular/components/picker/picker-component.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PickerCmp", function() { return __WEBPACK_IMPORTED_MODULE_62__components_picker_picker_component__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__components_picker_picker_column__ = __webpack_require__("./node_modules/ionic-angular/components/picker/picker-column.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PickerColumnCmp", function() { return __WEBPACK_IMPORTED_MODULE_63__components_picker_picker_column__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__components_picker_picker_controller__ = __webpack_require__("./node_modules/ionic-angular/components/picker/picker-controller.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PickerController", function() { return __WEBPACK_IMPORTED_MODULE_64__components_picker_picker_controller__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__components_popover_popover__ = __webpack_require__("./node_modules/ionic-angular/components/popover/popover.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Popover", function() { return __WEBPACK_IMPORTED_MODULE_65__components_popover_popover__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__components_popover_popover_component__ = __webpack_require__("./node_modules/ionic-angular/components/popover/popover-component.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PopoverCmp", function() { return __WEBPACK_IMPORTED_MODULE_66__components_popover_popover_component__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__components_popover_popover_controller__ = __webpack_require__("./node_modules/ionic-angular/components/popover/popover-controller.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PopoverController", function() { return __WEBPACK_IMPORTED_MODULE_67__components_popover_popover_controller__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__components_radio_radio_button__ = __webpack_require__("./node_modules/ionic-angular/components/radio/radio-button.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "RadioButton", function() { return __WEBPACK_IMPORTED_MODULE_68__components_radio_radio_button__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__components_radio_radio_group__ = __webpack_require__("./node_modules/ionic-angular/components/radio/radio-group.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "RadioGroup", function() { return __WEBPACK_IMPORTED_MODULE_69__components_radio_radio_group__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__components_range_range__ = __webpack_require__("./node_modules/ionic-angular/components/range/range.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Range", function() { return __WEBPACK_IMPORTED_MODULE_70__components_range_range__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__components_range_range_knob__ = __webpack_require__("./node_modules/ionic-angular/components/range/range-knob.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "RangeKnob", function() { return __WEBPACK_IMPORTED_MODULE_71__components_range_range_knob__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__components_refresher_refresher__ = __webpack_require__("./node_modules/ionic-angular/components/refresher/refresher.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Refresher", function() { return __WEBPACK_IMPORTED_MODULE_72__components_refresher_refresher__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__components_refresher_refresher_content__ = __webpack_require__("./node_modules/ionic-angular/components/refresher/refresher-content.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "RefresherContent", function() { return __WEBPACK_IMPORTED_MODULE_73__components_refresher_refresher_content__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__components_scroll_scroll__ = __webpack_require__("./node_modules/ionic-angular/components/scroll/scroll.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Scroll", function() { return __WEBPACK_IMPORTED_MODULE_74__components_scroll_scroll__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__components_searchbar_searchbar__ = __webpack_require__("./node_modules/ionic-angular/components/searchbar/searchbar.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Searchbar", function() { return __WEBPACK_IMPORTED_MODULE_75__components_searchbar_searchbar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__components_segment_segment__ = __webpack_require__("./node_modules/ionic-angular/components/segment/segment.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Segment", function() { return __WEBPACK_IMPORTED_MODULE_76__components_segment_segment__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__components_segment_segment_button__ = __webpack_require__("./node_modules/ionic-angular/components/segment/segment-button.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SegmentButton", function() { return __WEBPACK_IMPORTED_MODULE_77__components_segment_segment_button__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__components_select_select__ = __webpack_require__("./node_modules/ionic-angular/components/select/select.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Select", function() { return __WEBPACK_IMPORTED_MODULE_78__components_select_select__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__components_select_select_popover_component__ = __webpack_require__("./node_modules/ionic-angular/components/select/select-popover-component.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SelectPopover", function() { return __WEBPACK_IMPORTED_MODULE_79__components_select_select_popover_component__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__components_show_hide_when_show_when__ = __webpack_require__("./node_modules/ionic-angular/components/show-hide-when/show-when.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ShowWhen", function() { return __WEBPACK_IMPORTED_MODULE_80__components_show_hide_when_show_when__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__components_show_hide_when_display_when__ = __webpack_require__("./node_modules/ionic-angular/components/show-hide-when/display-when.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DisplayWhen", function() { return __WEBPACK_IMPORTED_MODULE_81__components_show_hide_when_display_when__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__components_show_hide_when_hide_when__ = __webpack_require__("./node_modules/ionic-angular/components/show-hide-when/hide-when.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "HideWhen", function() { return __WEBPACK_IMPORTED_MODULE_82__components_show_hide_when_hide_when__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__components_slides_slide__ = __webpack_require__("./node_modules/ionic-angular/components/slides/slide.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Slide", function() { return __WEBPACK_IMPORTED_MODULE_83__components_slides_slide__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__components_slides_slides__ = __webpack_require__("./node_modules/ionic-angular/components/slides/slides.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Slides", function() { return __WEBPACK_IMPORTED_MODULE_84__components_slides_slides__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__components_spinner_spinner__ = __webpack_require__("./node_modules/ionic-angular/components/spinner/spinner.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Spinner", function() { return __WEBPACK_IMPORTED_MODULE_85__components_spinner_spinner__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__components_split_pane_split_pane__ = __webpack_require__("./node_modules/ionic-angular/components/split-pane/split-pane.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SplitPane", function() { return __WEBPACK_IMPORTED_MODULE_86__components_split_pane_split_pane__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "RootNode", function() { return __WEBPACK_IMPORTED_MODULE_86__components_split_pane_split_pane__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__components_tabs_tab__ = __webpack_require__("./node_modules/ionic-angular/components/tabs/tab.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tab", function() { return __WEBPACK_IMPORTED_MODULE_87__components_tabs_tab__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__components_tabs_tab_button__ = __webpack_require__("./node_modules/ionic-angular/components/tabs/tab-button.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TabButton", function() { return __WEBPACK_IMPORTED_MODULE_88__components_tabs_tab_button__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__components_tabs_tab_highlight__ = __webpack_require__("./node_modules/ionic-angular/components/tabs/tab-highlight.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TabHighlight", function() { return __WEBPACK_IMPORTED_MODULE_89__components_tabs_tab_highlight__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__components_tabs_tabs__ = __webpack_require__("./node_modules/ionic-angular/components/tabs/tabs.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tabs", function() { return __WEBPACK_IMPORTED_MODULE_90__components_tabs_tabs__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__components_toast_toast__ = __webpack_require__("./node_modules/ionic-angular/components/toast/toast.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Toast", function() { return __WEBPACK_IMPORTED_MODULE_91__components_toast_toast__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__components_toast_toast_component__ = __webpack_require__("./node_modules/ionic-angular/components/toast/toast-component.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ToastCmp", function() { return __WEBPACK_IMPORTED_MODULE_92__components_toast_toast_component__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__components_toast_toast_controller__ = __webpack_require__("./node_modules/ionic-angular/components/toast/toast-controller.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ToastController", function() { return __WEBPACK_IMPORTED_MODULE_93__components_toast_toast_controller__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__components_toggle_toggle__ = __webpack_require__("./node_modules/ionic-angular/components/toggle/toggle.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Toggle", function() { return __WEBPACK_IMPORTED_MODULE_94__components_toggle_toggle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__components_toolbar_toolbar_footer__ = __webpack_require__("./node_modules/ionic-angular/components/toolbar/toolbar-footer.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Footer", function() { return __WEBPACK_IMPORTED_MODULE_95__components_toolbar_toolbar_footer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__components_toolbar_toolbar_header__ = __webpack_require__("./node_modules/ionic-angular/components/toolbar/toolbar-header.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Header", function() { return __WEBPACK_IMPORTED_MODULE_96__components_toolbar_toolbar_header__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__components_toolbar_toolbar__ = __webpack_require__("./node_modules/ionic-angular/components/toolbar/toolbar.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Toolbar", function() { return __WEBPACK_IMPORTED_MODULE_97__components_toolbar_toolbar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__components_toolbar_toolbar_item__ = __webpack_require__("./node_modules/ionic-angular/components/toolbar/toolbar-item.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ToolbarItem", function() { return __WEBPACK_IMPORTED_MODULE_98__components_toolbar_toolbar_item__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__components_toolbar_toolbar_title__ = __webpack_require__("./node_modules/ionic-angular/components/toolbar/toolbar-title.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ToolbarTitle", function() { return __WEBPACK_IMPORTED_MODULE_99__components_toolbar_toolbar_title__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__components_toolbar_navbar__ = __webpack_require__("./node_modules/ionic-angular/components/toolbar/navbar.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Navbar", function() { return __WEBPACK_IMPORTED_MODULE_100__components_toolbar_navbar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__components_thumbnail_thumbnail__ = __webpack_require__("./node_modules/ionic-angular/components/thumbnail/thumbnail.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Thumbnail", function() { return __WEBPACK_IMPORTED_MODULE_101__components_thumbnail_thumbnail__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__components_typography_typography__ = __webpack_require__("./node_modules/ionic-angular/components/typography/typography.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Typography", function() { return __WEBPACK_IMPORTED_MODULE_102__components_typography_typography__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__components_virtual_scroll_virtual_footer__ = __webpack_require__("./node_modules/ionic-angular/components/virtual-scroll/virtual-footer.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VirtualFooter", function() { return __WEBPACK_IMPORTED_MODULE_103__components_virtual_scroll_virtual_footer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__components_virtual_scroll_virtual_header__ = __webpack_require__("./node_modules/ionic-angular/components/virtual-scroll/virtual-header.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VirtualHeader", function() { return __WEBPACK_IMPORTED_MODULE_104__components_virtual_scroll_virtual_header__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__components_virtual_scroll_virtual_item__ = __webpack_require__("./node_modules/ionic-angular/components/virtual-scroll/virtual-item.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VirtualItem", function() { return __WEBPACK_IMPORTED_MODULE_105__components_virtual_scroll_virtual_item__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__components_virtual_scroll_virtual_scroll__ = __webpack_require__("./node_modules/ionic-angular/components/virtual-scroll/virtual-scroll.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VirtualScroll", function() { return __WEBPACK_IMPORTED_MODULE_106__components_virtual_scroll_virtual_scroll__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Config", function() { return __WEBPACK_IMPORTED_MODULE_107__config_config__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "setupConfig", function() { return __WEBPACK_IMPORTED_MODULE_107__config_config__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ConfigToken", function() { return __WEBPACK_IMPORTED_MODULE_107__config_config__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__platform_dom_controller__ = __webpack_require__("./node_modules/ionic-angular/platform/dom-controller.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DomController", function() { return __WEBPACK_IMPORTED_MODULE_108__platform_dom_controller__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__platform_platform__ = __webpack_require__("./node_modules/ionic-angular/platform/platform.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Platform", function() { return __WEBPACK_IMPORTED_MODULE_109__platform_platform__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "setupPlatform", function() { return __WEBPACK_IMPORTED_MODULE_109__platform_platform__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__tap_click_haptic__ = __webpack_require__("./node_modules/ionic-angular/tap-click/haptic.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Haptic", function() { return __WEBPACK_IMPORTED_MODULE_110__tap_click_haptic__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__navigation_deep_linker__ = __webpack_require__("./node_modules/ionic-angular/navigation/deep-linker.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DeepLinker", function() { return __WEBPACK_IMPORTED_MODULE_111__navigation_deep_linker__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__navigation_ionic_page__ = __webpack_require__("./node_modules/ionic-angular/navigation/ionic-page.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "IonicPage", function() { return __WEBPACK_IMPORTED_MODULE_112__navigation_ionic_page__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__navigation_nav_controller__ = __webpack_require__("./node_modules/ionic-angular/navigation/nav-controller.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NavController", function() { return __WEBPACK_IMPORTED_MODULE_113__navigation_nav_controller__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__navigation_nav_controller_base__ = __webpack_require__("./node_modules/ionic-angular/navigation/nav-controller-base.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NavControllerBase", function() { return __WEBPACK_IMPORTED_MODULE_114__navigation_nav_controller_base__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__navigation_nav_params__ = __webpack_require__("./node_modules/ionic-angular/navigation/nav-params.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NavParams", function() { return __WEBPACK_IMPORTED_MODULE_115__navigation_nav_params__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__navigation_nav_util__ = __webpack_require__("./node_modules/ionic-angular/navigation/nav-util.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DeepLinkMetadata", function() { return __WEBPACK_IMPORTED_MODULE_116__navigation_nav_util__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DeepLinkMetadataFactory", function() { return __WEBPACK_IMPORTED_MODULE_116__navigation_nav_util__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__tap_click_tap_click__ = __webpack_require__("./node_modules/ionic-angular/tap-click/tap-click.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TapClick", function() { return __WEBPACK_IMPORTED_MODULE_117__tap_click_tap_click__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "setupTapClick", function() { return __WEBPACK_IMPORTED_MODULE_117__tap_click_tap_click__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isActivatable", function() { return __WEBPACK_IMPORTED_MODULE_117__tap_click_tap_click__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__navigation_url_serializer__ = __webpack_require__("./node_modules/ionic-angular/navigation/url-serializer.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "UrlSerializer", function() { return __WEBPACK_IMPORTED_MODULE_118__navigation_url_serializer__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DeepLinkConfigToken", function() { return __WEBPACK_IMPORTED_MODULE_118__navigation_url_serializer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__navigation_view_controller__ = __webpack_require__("./node_modules/ionic-angular/navigation/view-controller.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ViewController", function() { return __WEBPACK_IMPORTED_MODULE_119__navigation_view_controller__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120__gestures_pan_gesture__ = __webpack_require__("./node_modules/ionic-angular/gestures/pan-gesture.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PanGesture", function() { return __WEBPACK_IMPORTED_MODULE_120__gestures_pan_gesture__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121__gestures_gesture__ = __webpack_require__("./node_modules/ionic-angular/gestures/gesture.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Gesture", function() { return __WEBPACK_IMPORTED_MODULE_121__gestures_gesture__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122__gestures_slide_edge_gesture__ = __webpack_require__("./node_modules/ionic-angular/gestures/slide-edge-gesture.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SlideEdgeGesture", function() { return __WEBPACK_IMPORTED_MODULE_122__gestures_slide_edge_gesture__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123__gestures_slide_gesture__ = __webpack_require__("./node_modules/ionic-angular/gestures/slide-gesture.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SlideGesture", function() { return __WEBPACK_IMPORTED_MODULE_123__gestures_slide_gesture__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124__gestures_gesture_controller__ = __webpack_require__("./node_modules/ionic-angular/gestures/gesture-controller.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BLOCK_ALL", function() { return __WEBPACK_IMPORTED_MODULE_124__gestures_gesture_controller__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "GESTURE_GO_BACK_SWIPE", function() { return __WEBPACK_IMPORTED_MODULE_124__gestures_gesture_controller__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "GESTURE_MENU_SWIPE", function() { return __WEBPACK_IMPORTED_MODULE_124__gestures_gesture_controller__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "GESTURE_ITEM_SWIPE", function() { return __WEBPACK_IMPORTED_MODULE_124__gestures_gesture_controller__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "GESTURE_REFRESHER", function() { return __WEBPACK_IMPORTED_MODULE_124__gestures_gesture_controller__["k"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "GESTURE_TOGGLE", function() { return __WEBPACK_IMPORTED_MODULE_124__gestures_gesture_controller__["l"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "GestureController", function() { return __WEBPACK_IMPORTED_MODULE_124__gestures_gesture_controller__["m"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "GestureDelegate", function() { return __WEBPACK_IMPORTED_MODULE_124__gestures_gesture_controller__["n"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BlockerDelegate", function() { return __WEBPACK_IMPORTED_MODULE_124__gestures_gesture_controller__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125__util_events__ = __webpack_require__("./node_modules/ionic-angular/util/events.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Events", function() { return __WEBPACK_IMPORTED_MODULE_125__util_events__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "setupEvents", function() { return __WEBPACK_IMPORTED_MODULE_125__util_events__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "setupProvideEvents", function() { return __WEBPACK_IMPORTED_MODULE_125__util_events__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126__util_ionic_error_handler__ = __webpack_require__("./node_modules/ionic-angular/util/ionic-error-handler.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "IonicErrorHandler", function() { return __WEBPACK_IMPORTED_MODULE_126__util_ionic_error_handler__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_127__platform_keyboard__ = __webpack_require__("./node_modules/ionic-angular/platform/keyboard.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Keyboard", function() { return __WEBPACK_IMPORTED_MODULE_127__platform_keyboard__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_128__util_form__ = __webpack_require__("./node_modules/ionic-angular/util/form.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Form", function() { return __WEBPACK_IMPORTED_MODULE_128__util_form__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "IonicFormInput", function() { return __WEBPACK_IMPORTED_MODULE_128__util_form__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "IonicTapInput", function() { return __WEBPACK_IMPORTED_MODULE_128__util_form__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_129__util_util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "reorderArray", function() { return __WEBPACK_IMPORTED_MODULE_129__util_util__["s"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "normalizeURL", function() { return __WEBPACK_IMPORTED_MODULE_129__util_util__["q"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_130__animations_animation__ = __webpack_require__("./node_modules/ionic-angular/animations/animation.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Animation", function() { return __WEBPACK_IMPORTED_MODULE_130__animations_animation__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_131__transitions_page_transition__ = __webpack_require__("./node_modules/ionic-angular/transitions/page-transition.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PageTransition", function() { return __WEBPACK_IMPORTED_MODULE_131__transitions_page_transition__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_132__transitions_transition__ = __webpack_require__("./node_modules/ionic-angular/transitions/transition.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Transition", function() { return __WEBPACK_IMPORTED_MODULE_132__transitions_transition__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_133__platform_platform_registry__ = __webpack_require__("./node_modules/ionic-angular/platform/platform-registry.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PlatformConfigToken", function() { return __WEBPACK_IMPORTED_MODULE_133__platform_platform_registry__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_134__config_mode_registry__ = __webpack_require__("./node_modules/ionic-angular/config/mode-registry.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "registerModeConfigs", function() { return __WEBPACK_IMPORTED_MODULE_134__config_mode_registry__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_135__gestures_gesture_config__ = __webpack_require__("./node_modules/ionic-angular/gestures/gesture-config.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "IonicGestureConfig", function() { return __WEBPACK_IMPORTED_MODULE_135__gestures_gesture_config__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_136__module__ = __webpack_require__("./node_modules/ionic-angular/module.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "IonicModule", function() { return __WEBPACK_IMPORTED_MODULE_136__module__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "IonicPageModule", function() { return __WEBPACK_IMPORTED_MODULE_136__module__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "provideLocationStrategy", function() { return __WEBPACK_IMPORTED_MODULE_136__module__["c"]; });











































































































/**
 * Global Providers
 */













/**
 * Export Utils
 */

















//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/module.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IonicModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IonicPageModule; });
/* harmony export (immutable) */ __webpack_exports__["c"] = provideLocationStrategy;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_common__ = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_platform_browser__ = __webpack_require__("./node_modules/@angular/platform-browser/esm5/platform-browser.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_forms__ = __webpack_require__("./node_modules/@angular/forms/esm5/forms.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_app_app__ = __webpack_require__("./node_modules/ionic-angular/components/app/app.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_app_app_root__ = __webpack_require__("./node_modules/ionic-angular/components/app/app-root.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__navigation_deep_linker__ = __webpack_require__("./node_modules/ionic-angular/navigation/deep-linker.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__platform_dom_controller__ = __webpack_require__("./node_modules/ionic-angular/platform/dom-controller.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_events__ = __webpack_require__("./node_modules/ionic-angular/util/events.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_form__ = __webpack_require__("./node_modules/ionic-angular/util/form.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__gestures_gesture_controller__ = __webpack_require__("./node_modules/ionic-angular/gestures/gesture-controller.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__gestures_gesture_config__ = __webpack_require__("./node_modules/ionic-angular/gestures/gesture-config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__tap_click_haptic__ = __webpack_require__("./node_modules/ionic-angular/tap-click/haptic.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__platform_keyboard__ = __webpack_require__("./node_modules/ionic-angular/platform/keyboard.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util_module_loader__ = __webpack_require__("./node_modules/ionic-angular/util/module-loader.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__util_ng_module_loader__ = __webpack_require__("./node_modules/ionic-angular/util/ng-module-loader.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__platform_platform__ = __webpack_require__("./node_modules/ionic-angular/platform/platform.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__platform_platform_registry__ = __webpack_require__("./node_modules/ionic-angular/platform/platform-registry.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__tap_click_tap_click__ = __webpack_require__("./node_modules/ionic-angular/tap-click/tap-click.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__config_mode_registry__ = __webpack_require__("./node_modules/ionic-angular/config/mode-registry.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__transitions_transition_controller__ = __webpack_require__("./node_modules/ionic-angular/transitions/transition-controller.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__navigation_url_serializer__ = __webpack_require__("./node_modules/ionic-angular/navigation/url-serializer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_action_sheet_action_sheet_component__ = __webpack_require__("./node_modules/ionic-angular/components/action-sheet/action-sheet-component.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_action_sheet_action_sheet_controller__ = __webpack_require__("./node_modules/ionic-angular/components/action-sheet/action-sheet-controller.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_alert_alert_component__ = __webpack_require__("./node_modules/ionic-angular/components/alert/alert-component.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_alert_alert_controller__ = __webpack_require__("./node_modules/ionic-angular/components/alert/alert-controller.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_app_click_block__ = __webpack_require__("./node_modules/ionic-angular/components/app/click-block.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_app_overlay_portal__ = __webpack_require__("./node_modules/ionic-angular/components/app/overlay-portal.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_avatar_avatar__ = __webpack_require__("./node_modules/ionic-angular/components/avatar/avatar.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_backdrop_backdrop__ = __webpack_require__("./node_modules/ionic-angular/components/backdrop/backdrop.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_badge_badge__ = __webpack_require__("./node_modules/ionic-angular/components/badge/badge.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_button_button__ = __webpack_require__("./node_modules/ionic-angular/components/button/button.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_card_card__ = __webpack_require__("./node_modules/ionic-angular/components/card/card.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_card_card_content__ = __webpack_require__("./node_modules/ionic-angular/components/card/card-content.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_card_card_header__ = __webpack_require__("./node_modules/ionic-angular/components/card/card-header.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_card_card_title__ = __webpack_require__("./node_modules/ionic-angular/components/card/card-title.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_checkbox_checkbox__ = __webpack_require__("./node_modules/ionic-angular/components/checkbox/checkbox.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_chip_chip__ = __webpack_require__("./node_modules/ionic-angular/components/chip/chip.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_content_content__ = __webpack_require__("./node_modules/ionic-angular/components/content/content.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_datetime_datetime__ = __webpack_require__("./node_modules/ionic-angular/components/datetime/datetime.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_fab_fab__ = __webpack_require__("./node_modules/ionic-angular/components/fab/fab.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_fab_fab_container__ = __webpack_require__("./node_modules/ionic-angular/components/fab/fab-container.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_fab_fab_list__ = __webpack_require__("./node_modules/ionic-angular/components/fab/fab-list.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_grid_col__ = __webpack_require__("./node_modules/ionic-angular/components/grid/col.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_grid_grid__ = __webpack_require__("./node_modules/ionic-angular/components/grid/grid.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_grid_row__ = __webpack_require__("./node_modules/ionic-angular/components/grid/row.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_icon_icon__ = __webpack_require__("./node_modules/ionic-angular/components/icon/icon.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_img_img__ = __webpack_require__("./node_modules/ionic-angular/components/img/img.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_infinite_scroll_infinite_scroll__ = __webpack_require__("./node_modules/ionic-angular/components/infinite-scroll/infinite-scroll.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_infinite_scroll_infinite_scroll_content__ = __webpack_require__("./node_modules/ionic-angular/components/infinite-scroll/infinite-scroll-content.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_input_input__ = __webpack_require__("./node_modules/ionic-angular/components/input/input.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_item_item__ = __webpack_require__("./node_modules/ionic-angular/components/item/item.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_item_item_content__ = __webpack_require__("./node_modules/ionic-angular/components/item/item-content.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_item_item_divider__ = __webpack_require__("./node_modules/ionic-angular/components/item/item-divider.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_item_item_group__ = __webpack_require__("./node_modules/ionic-angular/components/item/item-group.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_item_item_options__ = __webpack_require__("./node_modules/ionic-angular/components/item/item-options.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__components_item_item_reorder__ = __webpack_require__("./node_modules/ionic-angular/components/item/item-reorder.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__components_item_item_sliding__ = __webpack_require__("./node_modules/ionic-angular/components/item/item-sliding.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__components_item_reorder__ = __webpack_require__("./node_modules/ionic-angular/components/item/reorder.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__components_label_label__ = __webpack_require__("./node_modules/ionic-angular/components/label/label.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__components_list_list__ = __webpack_require__("./node_modules/ionic-angular/components/list/list.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__components_list_list_header__ = __webpack_require__("./node_modules/ionic-angular/components/list/list-header.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__components_loading_loading_component__ = __webpack_require__("./node_modules/ionic-angular/components/loading/loading-component.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__components_loading_loading_controller__ = __webpack_require__("./node_modules/ionic-angular/components/loading/loading-controller.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__components_menu_menu__ = __webpack_require__("./node_modules/ionic-angular/components/menu/menu.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__components_menu_menu_close__ = __webpack_require__("./node_modules/ionic-angular/components/menu/menu-close.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__components_app_menu_controller__ = __webpack_require__("./node_modules/ionic-angular/components/app/menu-controller.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__components_menu_menu_toggle__ = __webpack_require__("./node_modules/ionic-angular/components/menu/menu-toggle.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__components_modal_modal_component__ = __webpack_require__("./node_modules/ionic-angular/components/modal/modal-component.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__components_modal_modal_controller__ = __webpack_require__("./node_modules/ionic-angular/components/modal/modal-controller.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__components_nav_nav__ = __webpack_require__("./node_modules/ionic-angular/components/nav/nav.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__components_nav_nav_pop__ = __webpack_require__("./node_modules/ionic-angular/components/nav/nav-pop.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__components_nav_nav_pop_anchor__ = __webpack_require__("./node_modules/ionic-angular/components/nav/nav-pop-anchor.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__components_nav_nav_push__ = __webpack_require__("./node_modules/ionic-angular/components/nav/nav-push.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__components_nav_nav_push_anchor__ = __webpack_require__("./node_modules/ionic-angular/components/nav/nav-push-anchor.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__components_note_note__ = __webpack_require__("./node_modules/ionic-angular/components/note/note.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__components_option_option__ = __webpack_require__("./node_modules/ionic-angular/components/option/option.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__components_picker_picker_component__ = __webpack_require__("./node_modules/ionic-angular/components/picker/picker-component.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__components_picker_picker_column__ = __webpack_require__("./node_modules/ionic-angular/components/picker/picker-column.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__components_picker_picker_controller__ = __webpack_require__("./node_modules/ionic-angular/components/picker/picker-controller.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__components_popover_popover_component__ = __webpack_require__("./node_modules/ionic-angular/components/popover/popover-component.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__components_popover_popover_controller__ = __webpack_require__("./node_modules/ionic-angular/components/popover/popover-controller.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__components_radio_radio_button__ = __webpack_require__("./node_modules/ionic-angular/components/radio/radio-button.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__components_radio_radio_group__ = __webpack_require__("./node_modules/ionic-angular/components/radio/radio-group.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__components_range_range__ = __webpack_require__("./node_modules/ionic-angular/components/range/range.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__components_range_range_knob__ = __webpack_require__("./node_modules/ionic-angular/components/range/range-knob.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__components_refresher_refresher__ = __webpack_require__("./node_modules/ionic-angular/components/refresher/refresher.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__components_refresher_refresher_content__ = __webpack_require__("./node_modules/ionic-angular/components/refresher/refresher-content.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__components_scroll_scroll__ = __webpack_require__("./node_modules/ionic-angular/components/scroll/scroll.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__components_searchbar_searchbar__ = __webpack_require__("./node_modules/ionic-angular/components/searchbar/searchbar.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__components_segment_segment__ = __webpack_require__("./node_modules/ionic-angular/components/segment/segment.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__components_select_select__ = __webpack_require__("./node_modules/ionic-angular/components/select/select.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__components_select_select_popover_component__ = __webpack_require__("./node_modules/ionic-angular/components/select/select-popover-component.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__components_segment_segment_button__ = __webpack_require__("./node_modules/ionic-angular/components/segment/segment-button.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__components_show_hide_when_show_when__ = __webpack_require__("./node_modules/ionic-angular/components/show-hide-when/show-when.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__components_show_hide_when_hide_when__ = __webpack_require__("./node_modules/ionic-angular/components/show-hide-when/hide-when.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__components_slides_slide__ = __webpack_require__("./node_modules/ionic-angular/components/slides/slide.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__components_slides_slides__ = __webpack_require__("./node_modules/ionic-angular/components/slides/slides.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__components_spinner_spinner__ = __webpack_require__("./node_modules/ionic-angular/components/spinner/spinner.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__components_split_pane_split_pane__ = __webpack_require__("./node_modules/ionic-angular/components/split-pane/split-pane.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__components_tabs_tab__ = __webpack_require__("./node_modules/ionic-angular/components/tabs/tab.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__components_tabs_tab_button__ = __webpack_require__("./node_modules/ionic-angular/components/tabs/tab-button.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__components_tabs_tab_highlight__ = __webpack_require__("./node_modules/ionic-angular/components/tabs/tab-highlight.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__components_tabs_tabs__ = __webpack_require__("./node_modules/ionic-angular/components/tabs/tabs.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__components_thumbnail_thumbnail__ = __webpack_require__("./node_modules/ionic-angular/components/thumbnail/thumbnail.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__components_toast_toast_component__ = __webpack_require__("./node_modules/ionic-angular/components/toast/toast-component.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__components_toast_toast_controller__ = __webpack_require__("./node_modules/ionic-angular/components/toast/toast-controller.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__components_toggle_toggle__ = __webpack_require__("./node_modules/ionic-angular/components/toggle/toggle.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__components_toolbar_toolbar_footer__ = __webpack_require__("./node_modules/ionic-angular/components/toolbar/toolbar-footer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__components_toolbar_toolbar_header__ = __webpack_require__("./node_modules/ionic-angular/components/toolbar/toolbar-header.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__components_toolbar_toolbar__ = __webpack_require__("./node_modules/ionic-angular/components/toolbar/toolbar.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__components_toolbar_toolbar_item__ = __webpack_require__("./node_modules/ionic-angular/components/toolbar/toolbar-item.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__components_toolbar_toolbar_title__ = __webpack_require__("./node_modules/ionic-angular/components/toolbar/toolbar-title.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__components_toolbar_navbar__ = __webpack_require__("./node_modules/ionic-angular/components/toolbar/navbar.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__components_typography_typography__ = __webpack_require__("./node_modules/ionic-angular/components/typography/typography.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__components_virtual_scroll_virtual_footer__ = __webpack_require__("./node_modules/ionic-angular/components/virtual-scroll/virtual-footer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__components_virtual_scroll_virtual_header__ = __webpack_require__("./node_modules/ionic-angular/components/virtual-scroll/virtual-header.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__components_virtual_scroll_virtual_item__ = __webpack_require__("./node_modules/ionic-angular/components/virtual-scroll/virtual-item.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__components_virtual_scroll_virtual_scroll__ = __webpack_require__("./node_modules/ionic-angular/components/virtual-scroll/virtual-scroll.js");
/**
 * Import Angular
 */





/**
 * Global Providers
 */



















/**
 * Import Components/Directives/Etc
 */


































































































/**
 * @name IonicModule
 * @description
 * IonicModule is an [NgModule](https://angular.io/docs/ts/latest/guide/ngmodule.html) that bootstraps
 * an Ionic App. By passing a root component, IonicModule will make sure that all of the components,
 * directives, and providers from the framework are imported.
 *
 * Any configuration for the app can be passed as the second argument to `forRoot`. This can be any
 * valid property from the [Config](/docs/api/config/Config/).
 *
 * @usage
 * ```ts
 * import { NgModule } from '@angular/core';
 *
 * import { IonicApp, IonicModule } from 'ionic-angular';
 *
 * import { MyApp } from './app.component';
 * import { HomePage } from '../pages/home/home';
 *
 * @NgModule({
 *   declarations: [
 *     MyApp,
 *     HomePage
 *   ],
 *   imports: [
 *     BrowserModule,
 *     IonicModule.forRoot(MyApp, {
 *
 *     })
 *   ],
 *   bootstrap: [IonicApp],
 *   entryComponents: [
 *     MyApp,
 *     HomePage
 *   ],
 *   providers: []
 * })
 * export class AppModule {}
 * ```
 */
var IonicModule = (function () {
    function IonicModule() {
    }
    /**
     * Set the root app component for you IonicModule
     * @param {any} appRoot The root AppComponent for this app.
     * @param {any} config Config Options for the app. Accepts any config property.
     * @param {any} deepLinkConfig Any configuration needed for the Ionic Deeplinker.
     */
    IonicModule.forRoot = function (appRoot, config, deepLinkConfig) {
        if (config === void 0) { config = null; }
        if (deepLinkConfig === void 0) { deepLinkConfig = null; }
        return {
            ngModule: IonicModule,
            providers: [
                // useValue: bootstrap values
                { provide: __WEBPACK_IMPORTED_MODULE_5__components_app_app_root__["a" /* AppRootToken */], useValue: appRoot },
                { provide: __WEBPACK_IMPORTED_MODULE_6__config_config__["b" /* ConfigToken */], useValue: config },
                { provide: __WEBPACK_IMPORTED_MODULE_22__navigation_url_serializer__["a" /* DeepLinkConfigToken */], useValue: deepLinkConfig },
                { provide: __WEBPACK_IMPORTED_MODULE_1__angular_common__["APP_BASE_HREF"], useValue: '/' },
                // useFactory: user values
                { provide: __WEBPACK_IMPORTED_MODULE_18__platform_platform_registry__["a" /* PlatformConfigToken */], useFactory: __WEBPACK_IMPORTED_MODULE_18__platform_platform_registry__["b" /* providePlatformConfigs */] },
                // useFactory: ionic core providers
                { provide: __WEBPACK_IMPORTED_MODULE_17__platform_platform__["a" /* Platform */], useFactory: __WEBPACK_IMPORTED_MODULE_17__platform_platform__["b" /* setupPlatform */], deps: [__WEBPACK_IMPORTED_MODULE_2__angular_platform_browser__["DOCUMENT"], __WEBPACK_IMPORTED_MODULE_18__platform_platform_registry__["a" /* PlatformConfigToken */], __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"]] },
                { provide: __WEBPACK_IMPORTED_MODULE_6__config_config__["a" /* Config */], useFactory: __WEBPACK_IMPORTED_MODULE_6__config_config__["c" /* setupConfig */], deps: [__WEBPACK_IMPORTED_MODULE_6__config_config__["b" /* ConfigToken */], __WEBPACK_IMPORTED_MODULE_17__platform_platform__["a" /* Platform */]] },
                // useFactory: ionic app initializers
                { provide: __WEBPACK_IMPORTED_MODULE_0__angular_core__["APP_INITIALIZER"], useFactory: __WEBPACK_IMPORTED_MODULE_20__config_mode_registry__["a" /* registerModeConfigs */], deps: [__WEBPACK_IMPORTED_MODULE_6__config_config__["a" /* Config */]], multi: true },
                { provide: __WEBPACK_IMPORTED_MODULE_0__angular_core__["APP_INITIALIZER"], useFactory: __WEBPACK_IMPORTED_MODULE_9__util_events__["c" /* setupProvideEvents */], deps: [__WEBPACK_IMPORTED_MODULE_17__platform_platform__["a" /* Platform */], __WEBPACK_IMPORTED_MODULE_8__platform_dom_controller__["a" /* DomController */]], multi: true },
                { provide: __WEBPACK_IMPORTED_MODULE_0__angular_core__["APP_INITIALIZER"], useFactory: __WEBPACK_IMPORTED_MODULE_19__tap_click_tap_click__["c" /* setupTapClick */], deps: [__WEBPACK_IMPORTED_MODULE_6__config_config__["a" /* Config */], __WEBPACK_IMPORTED_MODULE_17__platform_platform__["a" /* Platform */], __WEBPACK_IMPORTED_MODULE_8__platform_dom_controller__["a" /* DomController */], __WEBPACK_IMPORTED_MODULE_4__components_app_app__["a" /* App */], __WEBPACK_IMPORTED_MODULE_11__gestures_gesture_controller__["m" /* GestureController */]], multi: true },
                { provide: __WEBPACK_IMPORTED_MODULE_0__angular_core__["APP_INITIALIZER"], useFactory: __WEBPACK_IMPORTED_MODULE_15__util_module_loader__["d" /* setupPreloading */], deps: [__WEBPACK_IMPORTED_MODULE_6__config_config__["a" /* Config */], __WEBPACK_IMPORTED_MODULE_22__navigation_url_serializer__["a" /* DeepLinkConfigToken */], __WEBPACK_IMPORTED_MODULE_15__util_module_loader__["b" /* ModuleLoader */], __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"]], multi: true },
                // useClass
                { provide: __WEBPACK_IMPORTED_MODULE_2__angular_platform_browser__["HAMMER_GESTURE_CONFIG"], useClass: __WEBPACK_IMPORTED_MODULE_12__gestures_gesture_config__["a" /* IonicGestureConfig */] },
                // useValue
                { provide: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ANALYZE_FOR_ENTRY_COMPONENTS"], useValue: appRoot, multi: true },
                // ionic providers
                __WEBPACK_IMPORTED_MODULE_24__components_action_sheet_action_sheet_controller__["a" /* ActionSheetController */],
                __WEBPACK_IMPORTED_MODULE_26__components_alert_alert_controller__["a" /* AlertController */],
                __WEBPACK_IMPORTED_MODULE_4__components_app_app__["a" /* App */],
                __WEBPACK_IMPORTED_MODULE_8__platform_dom_controller__["a" /* DomController */],
                __WEBPACK_IMPORTED_MODULE_9__util_events__["a" /* Events */],
                __WEBPACK_IMPORTED_MODULE_10__util_form__["a" /* Form */],
                __WEBPACK_IMPORTED_MODULE_11__gestures_gesture_controller__["m" /* GestureController */],
                __WEBPACK_IMPORTED_MODULE_13__tap_click_haptic__["a" /* Haptic */],
                __WEBPACK_IMPORTED_MODULE_14__platform_keyboard__["a" /* Keyboard */],
                __WEBPACK_IMPORTED_MODULE_64__components_loading_loading_controller__["a" /* LoadingController */],
                __WEBPACK_IMPORTED_MODULE_1__angular_common__["Location"],
                __WEBPACK_IMPORTED_MODULE_67__components_app_menu_controller__["a" /* MenuController */],
                __WEBPACK_IMPORTED_MODULE_70__components_modal_modal_controller__["a" /* ModalController */],
                __WEBPACK_IMPORTED_MODULE_16__util_ng_module_loader__["a" /* NgModuleLoader */],
                __WEBPACK_IMPORTED_MODULE_80__components_picker_picker_controller__["a" /* PickerController */],
                __WEBPACK_IMPORTED_MODULE_82__components_popover_popover_controller__["a" /* PopoverController */],
                __WEBPACK_IMPORTED_MODULE_19__tap_click_tap_click__["a" /* TapClick */],
                __WEBPACK_IMPORTED_MODULE_107__components_toast_toast_controller__["a" /* ToastController */],
                __WEBPACK_IMPORTED_MODULE_21__transitions_transition_controller__["a" /* TransitionController */],
                { provide: __WEBPACK_IMPORTED_MODULE_15__util_module_loader__["b" /* ModuleLoader */], useFactory: __WEBPACK_IMPORTED_MODULE_15__util_module_loader__["c" /* provideModuleLoader */], deps: [__WEBPACK_IMPORTED_MODULE_16__util_ng_module_loader__["a" /* NgModuleLoader */], __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injector"]] },
                { provide: __WEBPACK_IMPORTED_MODULE_1__angular_common__["LocationStrategy"], useFactory: provideLocationStrategy, deps: [__WEBPACK_IMPORTED_MODULE_1__angular_common__["PlatformLocation"], [new __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"](__WEBPACK_IMPORTED_MODULE_1__angular_common__["APP_BASE_HREF"]), new __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"]()], __WEBPACK_IMPORTED_MODULE_6__config_config__["a" /* Config */]] },
                { provide: __WEBPACK_IMPORTED_MODULE_22__navigation_url_serializer__["b" /* UrlSerializer */], useFactory: __WEBPACK_IMPORTED_MODULE_22__navigation_url_serializer__["d" /* setupUrlSerializer */], deps: [__WEBPACK_IMPORTED_MODULE_4__components_app_app__["a" /* App */], __WEBPACK_IMPORTED_MODULE_22__navigation_url_serializer__["a" /* DeepLinkConfigToken */]] },
                { provide: __WEBPACK_IMPORTED_MODULE_7__navigation_deep_linker__["a" /* DeepLinker */], useFactory: __WEBPACK_IMPORTED_MODULE_7__navigation_deep_linker__["b" /* setupDeepLinker */], deps: [__WEBPACK_IMPORTED_MODULE_4__components_app_app__["a" /* App */], __WEBPACK_IMPORTED_MODULE_22__navigation_url_serializer__["b" /* UrlSerializer */], __WEBPACK_IMPORTED_MODULE_1__angular_common__["Location"], __WEBPACK_IMPORTED_MODULE_15__util_module_loader__["b" /* ModuleLoader */], __WEBPACK_IMPORTED_MODULE_0__angular_core__["ComponentFactoryResolver"]] },
            ]
        };
    };
    IonicModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                    declarations: [
                        __WEBPACK_IMPORTED_MODULE_23__components_action_sheet_action_sheet_component__["a" /* ActionSheetCmp */],
                        __WEBPACK_IMPORTED_MODULE_25__components_alert_alert_component__["a" /* AlertCmp */],
                        __WEBPACK_IMPORTED_MODULE_27__components_app_click_block__["a" /* ClickBlock */],
                        __WEBPACK_IMPORTED_MODULE_5__components_app_app_root__["b" /* IonicApp */],
                        __WEBPACK_IMPORTED_MODULE_28__components_app_overlay_portal__["a" /* OverlayPortal */],
                        __WEBPACK_IMPORTED_MODULE_29__components_avatar_avatar__["a" /* Avatar */],
                        __WEBPACK_IMPORTED_MODULE_30__components_backdrop_backdrop__["a" /* Backdrop */],
                        __WEBPACK_IMPORTED_MODULE_31__components_badge_badge__["a" /* Badge */],
                        __WEBPACK_IMPORTED_MODULE_32__components_button_button__["a" /* Button */],
                        __WEBPACK_IMPORTED_MODULE_33__components_card_card__["a" /* Card */],
                        __WEBPACK_IMPORTED_MODULE_34__components_card_card_content__["a" /* CardContent */],
                        __WEBPACK_IMPORTED_MODULE_35__components_card_card_header__["a" /* CardHeader */],
                        __WEBPACK_IMPORTED_MODULE_36__components_card_card_title__["a" /* CardTitle */],
                        __WEBPACK_IMPORTED_MODULE_37__components_checkbox_checkbox__["a" /* Checkbox */],
                        __WEBPACK_IMPORTED_MODULE_38__components_chip_chip__["a" /* Chip */],
                        __WEBPACK_IMPORTED_MODULE_44__components_grid_col__["a" /* Col */],
                        __WEBPACK_IMPORTED_MODULE_39__components_content_content__["a" /* Content */],
                        __WEBPACK_IMPORTED_MODULE_40__components_datetime_datetime__["a" /* DateTime */],
                        __WEBPACK_IMPORTED_MODULE_41__components_fab_fab__["a" /* FabButton */],
                        __WEBPACK_IMPORTED_MODULE_42__components_fab_fab_container__["a" /* FabContainer */],
                        __WEBPACK_IMPORTED_MODULE_43__components_fab_fab_list__["a" /* FabList */],
                        __WEBPACK_IMPORTED_MODULE_45__components_grid_grid__["a" /* Grid */],
                        __WEBPACK_IMPORTED_MODULE_48__components_img_img__["a" /* Img */],
                        __WEBPACK_IMPORTED_MODULE_47__components_icon_icon__["a" /* Icon */],
                        __WEBPACK_IMPORTED_MODULE_49__components_infinite_scroll_infinite_scroll__["a" /* InfiniteScroll */],
                        __WEBPACK_IMPORTED_MODULE_50__components_infinite_scroll_infinite_scroll_content__["a" /* InfiniteScrollContent */],
                        __WEBPACK_IMPORTED_MODULE_52__components_item_item__["a" /* Item */],
                        __WEBPACK_IMPORTED_MODULE_53__components_item_item_content__["a" /* ItemContent */],
                        __WEBPACK_IMPORTED_MODULE_54__components_item_item_divider__["a" /* ItemDivider */],
                        __WEBPACK_IMPORTED_MODULE_55__components_item_item_group__["a" /* ItemGroup */],
                        __WEBPACK_IMPORTED_MODULE_56__components_item_item_options__["a" /* ItemOptions */],
                        __WEBPACK_IMPORTED_MODULE_57__components_item_item_reorder__["a" /* ItemReorder */],
                        __WEBPACK_IMPORTED_MODULE_58__components_item_item_sliding__["a" /* ItemSliding */],
                        __WEBPACK_IMPORTED_MODULE_60__components_label_label__["a" /* Label */],
                        __WEBPACK_IMPORTED_MODULE_61__components_list_list__["a" /* List */],
                        __WEBPACK_IMPORTED_MODULE_62__components_list_list_header__["a" /* ListHeader */],
                        __WEBPACK_IMPORTED_MODULE_59__components_item_reorder__["a" /* Reorder */],
                        __WEBPACK_IMPORTED_MODULE_63__components_loading_loading_component__["a" /* LoadingCmp */],
                        __WEBPACK_IMPORTED_MODULE_65__components_menu_menu__["a" /* Menu */],
                        __WEBPACK_IMPORTED_MODULE_66__components_menu_menu_close__["a" /* MenuClose */],
                        __WEBPACK_IMPORTED_MODULE_68__components_menu_menu_toggle__["a" /* MenuToggle */],
                        __WEBPACK_IMPORTED_MODULE_69__components_modal_modal_component__["a" /* ModalCmp */],
                        __WEBPACK_IMPORTED_MODULE_71__components_nav_nav__["a" /* Nav */],
                        __WEBPACK_IMPORTED_MODULE_72__components_nav_nav_pop__["a" /* NavPop */],
                        __WEBPACK_IMPORTED_MODULE_73__components_nav_nav_pop_anchor__["a" /* NavPopAnchor */],
                        __WEBPACK_IMPORTED_MODULE_74__components_nav_nav_push__["a" /* NavPush */],
                        __WEBPACK_IMPORTED_MODULE_75__components_nav_nav_push_anchor__["a" /* NavPushAnchor */],
                        __WEBPACK_IMPORTED_MODULE_76__components_note_note__["a" /* Note */],
                        __WEBPACK_IMPORTED_MODULE_77__components_option_option__["a" /* Option */],
                        __WEBPACK_IMPORTED_MODULE_78__components_picker_picker_component__["a" /* PickerCmp */],
                        __WEBPACK_IMPORTED_MODULE_79__components_picker_picker_column__["a" /* PickerColumnCmp */],
                        __WEBPACK_IMPORTED_MODULE_81__components_popover_popover_component__["a" /* PopoverCmp */],
                        __WEBPACK_IMPORTED_MODULE_83__components_radio_radio_button__["a" /* RadioButton */],
                        __WEBPACK_IMPORTED_MODULE_84__components_radio_radio_group__["a" /* RadioGroup */],
                        __WEBPACK_IMPORTED_MODULE_85__components_range_range__["a" /* Range */],
                        __WEBPACK_IMPORTED_MODULE_86__components_range_range_knob__["a" /* RangeKnob */],
                        __WEBPACK_IMPORTED_MODULE_87__components_refresher_refresher__["a" /* Refresher */],
                        __WEBPACK_IMPORTED_MODULE_88__components_refresher_refresher_content__["a" /* RefresherContent */],
                        __WEBPACK_IMPORTED_MODULE_46__components_grid_row__["a" /* Row */],
                        __WEBPACK_IMPORTED_MODULE_89__components_scroll_scroll__["a" /* Scroll */],
                        __WEBPACK_IMPORTED_MODULE_90__components_searchbar_searchbar__["a" /* Searchbar */],
                        __WEBPACK_IMPORTED_MODULE_91__components_segment_segment__["a" /* Segment */],
                        __WEBPACK_IMPORTED_MODULE_94__components_segment_segment_button__["a" /* SegmentButton */],
                        __WEBPACK_IMPORTED_MODULE_92__components_select_select__["a" /* Select */],
                        __WEBPACK_IMPORTED_MODULE_93__components_select_select_popover_component__["a" /* SelectPopover */],
                        __WEBPACK_IMPORTED_MODULE_95__components_show_hide_when_show_when__["a" /* ShowWhen */],
                        __WEBPACK_IMPORTED_MODULE_96__components_show_hide_when_hide_when__["a" /* HideWhen */],
                        __WEBPACK_IMPORTED_MODULE_97__components_slides_slide__["a" /* Slide */],
                        __WEBPACK_IMPORTED_MODULE_98__components_slides_slides__["a" /* Slides */],
                        __WEBPACK_IMPORTED_MODULE_99__components_spinner_spinner__["a" /* Spinner */],
                        __WEBPACK_IMPORTED_MODULE_100__components_split_pane_split_pane__["b" /* SplitPane */],
                        __WEBPACK_IMPORTED_MODULE_101__components_tabs_tab__["a" /* Tab */],
                        __WEBPACK_IMPORTED_MODULE_102__components_tabs_tab_button__["a" /* TabButton */],
                        __WEBPACK_IMPORTED_MODULE_103__components_tabs_tab_highlight__["a" /* TabHighlight */],
                        __WEBPACK_IMPORTED_MODULE_104__components_tabs_tabs__["a" /* Tabs */],
                        __WEBPACK_IMPORTED_MODULE_51__components_input_input__["a" /* TextInput */],
                        __WEBPACK_IMPORTED_MODULE_105__components_thumbnail_thumbnail__["a" /* Thumbnail */],
                        __WEBPACK_IMPORTED_MODULE_106__components_toast_toast_component__["a" /* ToastCmp */],
                        __WEBPACK_IMPORTED_MODULE_108__components_toggle_toggle__["a" /* Toggle */],
                        __WEBPACK_IMPORTED_MODULE_109__components_toolbar_toolbar_footer__["a" /* Footer */],
                        __WEBPACK_IMPORTED_MODULE_110__components_toolbar_toolbar_header__["a" /* Header */],
                        __WEBPACK_IMPORTED_MODULE_111__components_toolbar_toolbar__["a" /* Toolbar */],
                        __WEBPACK_IMPORTED_MODULE_112__components_toolbar_toolbar_item__["a" /* ToolbarItem */],
                        __WEBPACK_IMPORTED_MODULE_113__components_toolbar_toolbar_title__["a" /* ToolbarTitle */],
                        __WEBPACK_IMPORTED_MODULE_114__components_toolbar_navbar__["a" /* Navbar */],
                        __WEBPACK_IMPORTED_MODULE_115__components_typography_typography__["a" /* Typography */],
                        __WEBPACK_IMPORTED_MODULE_116__components_virtual_scroll_virtual_footer__["a" /* VirtualFooter */],
                        __WEBPACK_IMPORTED_MODULE_117__components_virtual_scroll_virtual_header__["a" /* VirtualHeader */],
                        __WEBPACK_IMPORTED_MODULE_118__components_virtual_scroll_virtual_item__["a" /* VirtualItem */],
                        __WEBPACK_IMPORTED_MODULE_119__components_virtual_scroll_virtual_scroll__["a" /* VirtualScroll */]
                    ],
                    imports: [
                        __WEBPACK_IMPORTED_MODULE_1__angular_common__["CommonModule"],
                        __WEBPACK_IMPORTED_MODULE_3__angular_forms__["FormsModule"],
                        __WEBPACK_IMPORTED_MODULE_3__angular_forms__["ReactiveFormsModule"],
                    ],
                    exports: [
                        __WEBPACK_IMPORTED_MODULE_1__angular_common__["CommonModule"],
                        __WEBPACK_IMPORTED_MODULE_3__angular_forms__["FormsModule"],
                        __WEBPACK_IMPORTED_MODULE_3__angular_forms__["ReactiveFormsModule"],
                        __WEBPACK_IMPORTED_MODULE_23__components_action_sheet_action_sheet_component__["a" /* ActionSheetCmp */],
                        __WEBPACK_IMPORTED_MODULE_25__components_alert_alert_component__["a" /* AlertCmp */],
                        __WEBPACK_IMPORTED_MODULE_27__components_app_click_block__["a" /* ClickBlock */],
                        __WEBPACK_IMPORTED_MODULE_5__components_app_app_root__["b" /* IonicApp */],
                        __WEBPACK_IMPORTED_MODULE_28__components_app_overlay_portal__["a" /* OverlayPortal */],
                        __WEBPACK_IMPORTED_MODULE_29__components_avatar_avatar__["a" /* Avatar */],
                        __WEBPACK_IMPORTED_MODULE_30__components_backdrop_backdrop__["a" /* Backdrop */],
                        __WEBPACK_IMPORTED_MODULE_31__components_badge_badge__["a" /* Badge */],
                        __WEBPACK_IMPORTED_MODULE_32__components_button_button__["a" /* Button */],
                        __WEBPACK_IMPORTED_MODULE_33__components_card_card__["a" /* Card */],
                        __WEBPACK_IMPORTED_MODULE_34__components_card_card_content__["a" /* CardContent */],
                        __WEBPACK_IMPORTED_MODULE_35__components_card_card_header__["a" /* CardHeader */],
                        __WEBPACK_IMPORTED_MODULE_36__components_card_card_title__["a" /* CardTitle */],
                        __WEBPACK_IMPORTED_MODULE_37__components_checkbox_checkbox__["a" /* Checkbox */],
                        __WEBPACK_IMPORTED_MODULE_38__components_chip_chip__["a" /* Chip */],
                        __WEBPACK_IMPORTED_MODULE_44__components_grid_col__["a" /* Col */],
                        __WEBPACK_IMPORTED_MODULE_39__components_content_content__["a" /* Content */],
                        __WEBPACK_IMPORTED_MODULE_40__components_datetime_datetime__["a" /* DateTime */],
                        __WEBPACK_IMPORTED_MODULE_41__components_fab_fab__["a" /* FabButton */],
                        __WEBPACK_IMPORTED_MODULE_42__components_fab_fab_container__["a" /* FabContainer */],
                        __WEBPACK_IMPORTED_MODULE_43__components_fab_fab_list__["a" /* FabList */],
                        __WEBPACK_IMPORTED_MODULE_45__components_grid_grid__["a" /* Grid */],
                        __WEBPACK_IMPORTED_MODULE_48__components_img_img__["a" /* Img */],
                        __WEBPACK_IMPORTED_MODULE_47__components_icon_icon__["a" /* Icon */],
                        __WEBPACK_IMPORTED_MODULE_49__components_infinite_scroll_infinite_scroll__["a" /* InfiniteScroll */],
                        __WEBPACK_IMPORTED_MODULE_50__components_infinite_scroll_infinite_scroll_content__["a" /* InfiniteScrollContent */],
                        __WEBPACK_IMPORTED_MODULE_52__components_item_item__["a" /* Item */],
                        __WEBPACK_IMPORTED_MODULE_53__components_item_item_content__["a" /* ItemContent */],
                        __WEBPACK_IMPORTED_MODULE_54__components_item_item_divider__["a" /* ItemDivider */],
                        __WEBPACK_IMPORTED_MODULE_55__components_item_item_group__["a" /* ItemGroup */],
                        __WEBPACK_IMPORTED_MODULE_56__components_item_item_options__["a" /* ItemOptions */],
                        __WEBPACK_IMPORTED_MODULE_57__components_item_item_reorder__["a" /* ItemReorder */],
                        __WEBPACK_IMPORTED_MODULE_58__components_item_item_sliding__["a" /* ItemSliding */],
                        __WEBPACK_IMPORTED_MODULE_60__components_label_label__["a" /* Label */],
                        __WEBPACK_IMPORTED_MODULE_61__components_list_list__["a" /* List */],
                        __WEBPACK_IMPORTED_MODULE_62__components_list_list_header__["a" /* ListHeader */],
                        __WEBPACK_IMPORTED_MODULE_59__components_item_reorder__["a" /* Reorder */],
                        __WEBPACK_IMPORTED_MODULE_63__components_loading_loading_component__["a" /* LoadingCmp */],
                        __WEBPACK_IMPORTED_MODULE_65__components_menu_menu__["a" /* Menu */],
                        __WEBPACK_IMPORTED_MODULE_66__components_menu_menu_close__["a" /* MenuClose */],
                        __WEBPACK_IMPORTED_MODULE_68__components_menu_menu_toggle__["a" /* MenuToggle */],
                        __WEBPACK_IMPORTED_MODULE_69__components_modal_modal_component__["a" /* ModalCmp */],
                        __WEBPACK_IMPORTED_MODULE_71__components_nav_nav__["a" /* Nav */],
                        __WEBPACK_IMPORTED_MODULE_72__components_nav_nav_pop__["a" /* NavPop */],
                        __WEBPACK_IMPORTED_MODULE_73__components_nav_nav_pop_anchor__["a" /* NavPopAnchor */],
                        __WEBPACK_IMPORTED_MODULE_74__components_nav_nav_push__["a" /* NavPush */],
                        __WEBPACK_IMPORTED_MODULE_75__components_nav_nav_push_anchor__["a" /* NavPushAnchor */],
                        __WEBPACK_IMPORTED_MODULE_76__components_note_note__["a" /* Note */],
                        __WEBPACK_IMPORTED_MODULE_77__components_option_option__["a" /* Option */],
                        __WEBPACK_IMPORTED_MODULE_78__components_picker_picker_component__["a" /* PickerCmp */],
                        __WEBPACK_IMPORTED_MODULE_79__components_picker_picker_column__["a" /* PickerColumnCmp */],
                        __WEBPACK_IMPORTED_MODULE_81__components_popover_popover_component__["a" /* PopoverCmp */],
                        __WEBPACK_IMPORTED_MODULE_83__components_radio_radio_button__["a" /* RadioButton */],
                        __WEBPACK_IMPORTED_MODULE_84__components_radio_radio_group__["a" /* RadioGroup */],
                        __WEBPACK_IMPORTED_MODULE_85__components_range_range__["a" /* Range */],
                        __WEBPACK_IMPORTED_MODULE_86__components_range_range_knob__["a" /* RangeKnob */],
                        __WEBPACK_IMPORTED_MODULE_87__components_refresher_refresher__["a" /* Refresher */],
                        __WEBPACK_IMPORTED_MODULE_88__components_refresher_refresher_content__["a" /* RefresherContent */],
                        __WEBPACK_IMPORTED_MODULE_46__components_grid_row__["a" /* Row */],
                        __WEBPACK_IMPORTED_MODULE_89__components_scroll_scroll__["a" /* Scroll */],
                        __WEBPACK_IMPORTED_MODULE_90__components_searchbar_searchbar__["a" /* Searchbar */],
                        __WEBPACK_IMPORTED_MODULE_91__components_segment_segment__["a" /* Segment */],
                        __WEBPACK_IMPORTED_MODULE_94__components_segment_segment_button__["a" /* SegmentButton */],
                        __WEBPACK_IMPORTED_MODULE_92__components_select_select__["a" /* Select */],
                        __WEBPACK_IMPORTED_MODULE_93__components_select_select_popover_component__["a" /* SelectPopover */],
                        __WEBPACK_IMPORTED_MODULE_95__components_show_hide_when_show_when__["a" /* ShowWhen */],
                        __WEBPACK_IMPORTED_MODULE_96__components_show_hide_when_hide_when__["a" /* HideWhen */],
                        __WEBPACK_IMPORTED_MODULE_97__components_slides_slide__["a" /* Slide */],
                        __WEBPACK_IMPORTED_MODULE_98__components_slides_slides__["a" /* Slides */],
                        __WEBPACK_IMPORTED_MODULE_99__components_spinner_spinner__["a" /* Spinner */],
                        __WEBPACK_IMPORTED_MODULE_100__components_split_pane_split_pane__["b" /* SplitPane */],
                        __WEBPACK_IMPORTED_MODULE_101__components_tabs_tab__["a" /* Tab */],
                        __WEBPACK_IMPORTED_MODULE_102__components_tabs_tab_button__["a" /* TabButton */],
                        __WEBPACK_IMPORTED_MODULE_103__components_tabs_tab_highlight__["a" /* TabHighlight */],
                        __WEBPACK_IMPORTED_MODULE_104__components_tabs_tabs__["a" /* Tabs */],
                        __WEBPACK_IMPORTED_MODULE_51__components_input_input__["a" /* TextInput */],
                        __WEBPACK_IMPORTED_MODULE_105__components_thumbnail_thumbnail__["a" /* Thumbnail */],
                        __WEBPACK_IMPORTED_MODULE_106__components_toast_toast_component__["a" /* ToastCmp */],
                        __WEBPACK_IMPORTED_MODULE_108__components_toggle_toggle__["a" /* Toggle */],
                        __WEBPACK_IMPORTED_MODULE_109__components_toolbar_toolbar_footer__["a" /* Footer */],
                        __WEBPACK_IMPORTED_MODULE_110__components_toolbar_toolbar_header__["a" /* Header */],
                        __WEBPACK_IMPORTED_MODULE_111__components_toolbar_toolbar__["a" /* Toolbar */],
                        __WEBPACK_IMPORTED_MODULE_112__components_toolbar_toolbar_item__["a" /* ToolbarItem */],
                        __WEBPACK_IMPORTED_MODULE_113__components_toolbar_toolbar_title__["a" /* ToolbarTitle */],
                        __WEBPACK_IMPORTED_MODULE_114__components_toolbar_navbar__["a" /* Navbar */],
                        __WEBPACK_IMPORTED_MODULE_115__components_typography_typography__["a" /* Typography */],
                        __WEBPACK_IMPORTED_MODULE_116__components_virtual_scroll_virtual_footer__["a" /* VirtualFooter */],
                        __WEBPACK_IMPORTED_MODULE_117__components_virtual_scroll_virtual_header__["a" /* VirtualHeader */],
                        __WEBPACK_IMPORTED_MODULE_118__components_virtual_scroll_virtual_item__["a" /* VirtualItem */],
                        __WEBPACK_IMPORTED_MODULE_119__components_virtual_scroll_virtual_scroll__["a" /* VirtualScroll */]
                    ],
                    entryComponents: [
                        __WEBPACK_IMPORTED_MODULE_23__components_action_sheet_action_sheet_component__["a" /* ActionSheetCmp */],
                        __WEBPACK_IMPORTED_MODULE_25__components_alert_alert_component__["a" /* AlertCmp */],
                        __WEBPACK_IMPORTED_MODULE_5__components_app_app_root__["b" /* IonicApp */],
                        __WEBPACK_IMPORTED_MODULE_63__components_loading_loading_component__["a" /* LoadingCmp */],
                        __WEBPACK_IMPORTED_MODULE_69__components_modal_modal_component__["a" /* ModalCmp */],
                        __WEBPACK_IMPORTED_MODULE_78__components_picker_picker_component__["a" /* PickerCmp */],
                        __WEBPACK_IMPORTED_MODULE_81__components_popover_popover_component__["a" /* PopoverCmp */],
                        __WEBPACK_IMPORTED_MODULE_93__components_select_select_popover_component__["a" /* SelectPopover */],
                        __WEBPACK_IMPORTED_MODULE_106__components_toast_toast_component__["a" /* ToastCmp */]
                    ]
                },] },
    ];
    /** @nocollapse */
    IonicModule.ctorParameters = function () { return []; };
    return IonicModule;
}());

/**
 * @name IonicPageModule
 * @description
 * IonicPageModule is an [NgModule](https://angular.io/docs/ts/latest/guide/ngmodule.html) that
 * bootstraps a child [IonicPage](../navigation/IonicPage/) in order to set up routing.
 *
 * @usage
 * ```ts
 * import { NgModule } from '@angular/core';
 *
 * import { IonicPageModule } from 'ionic-angular';
 *
 * import { HomePage } from './home';
 *
 * @NgModule({
 * 	declarations: [
 * 		HomePage
 * 	],
 * 	imports: [
 * 		IonicPageModule.forChild(HomePage)
 * 	],
 * 	entryComponents: [
 * 		HomePage
 * 	]
 * })
 * export class HomePageModule { }
 * ```
 */
var IonicPageModule = (function () {
    function IonicPageModule() {
    }
    IonicPageModule.forChild = function (page) {
        return {
            ngModule: IonicPageModule,
            providers: [
                { provide: __WEBPACK_IMPORTED_MODULE_15__util_module_loader__["a" /* LAZY_LOADED_TOKEN */], useValue: page },
                { provide: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ANALYZE_FOR_ENTRY_COMPONENTS"], useValue: page, multi: true },
            ]
        };
    };
    IonicPageModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                    imports: [IonicModule],
                    exports: [IonicModule]
                },] },
    ];
    /** @nocollapse */
    IonicPageModule.ctorParameters = function () { return []; };
    return IonicPageModule;
}());

/**
 * @hidden
 */
function provideLocationStrategy(platformLocationStrategy, baseHref, config) {
    return config.get('locationStrategy') === 'path' ?
        new __WEBPACK_IMPORTED_MODULE_1__angular_common__["PathLocationStrategy"](platformLocationStrategy, baseHref) :
        new __WEBPACK_IMPORTED_MODULE_1__angular_common__["HashLocationStrategy"](platformLocationStrategy, baseHref);
}
//# sourceMappingURL=module.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/navigation/deep-linker.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DeepLinker; });
/* harmony export (immutable) */ __webpack_exports__["b"] = setupDeepLinker;
/* unused harmony export normalizeUrl */
/* unused harmony export getNavFromTree */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nav_util__ = __webpack_require__("./node_modules/ionic-angular/navigation/nav-util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__url_serializer__ = __webpack_require__("./node_modules/ionic-angular/navigation/url-serializer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__view_controller__ = __webpack_require__("./node_modules/ionic-angular/navigation/view-controller.js");




/**
 * @hidden
 */
var DeepLinker = (function () {
    function DeepLinker(_app, _serializer, _location, _moduleLoader, _baseCfr) {
        this._app = _app;
        this._serializer = _serializer;
        this._location = _location;
        this._moduleLoader = _moduleLoader;
        this._baseCfr = _baseCfr;
        /** @internal */
        this._history = [];
    }
    /**
     * @internal
     */
    DeepLinker.prototype.init = function () {
        var _this = this;
        // scenario 1: Initial load of all navs from the initial browser URL
        var browserUrl = normalizeUrl(this._location.path());
        (void 0) /* console.debug */;
        // remember this URL in our internal history stack
        this._historyPush(browserUrl);
        // listen for browser URL changes
        this._location.subscribe(function (locationChg) {
            _this._urlChange(normalizeUrl(locationChg.url));
        });
    };
    /**
     * The browser's location has been updated somehow.
     * @internal
     */
    DeepLinker.prototype._urlChange = function (browserUrl) {
        var _this = this;
        // do nothing if this url is the same as the current one
        if (!this._isCurrentUrl(browserUrl)) {
            var isGoingBack = true;
            if (this._isBackUrl(browserUrl)) {
                // scenario 2: user clicked the browser back button
                // scenario 4: user changed the browser URL to what was the back url was
                // scenario 5: user clicked a link href that was the back url
                (void 0) /* console.debug */;
                this._historyPop();
            }
            else {
                // scenario 3: user click forward button
                // scenario 4: user changed browser URL that wasn't the back url
                // scenario 5: user clicked a link href that wasn't the back url
                isGoingBack = false;
                (void 0) /* console.debug */;
                this._historyPush(browserUrl);
            }
            // get the app's root nav container
            var activeNavContainers_1 = this._app.getActiveNavContainers();
            if (activeNavContainers_1 && activeNavContainers_1.length) {
                if (browserUrl === '/') {
                    // a url change to the index url
                    if (Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["l" /* isPresent */])(this._indexAliasUrl)) {
                        // we already know the indexAliasUrl
                        // update the url to use the know alias
                        browserUrl = this._indexAliasUrl;
                    }
                    else {
                        // the url change is to the root but we don't
                        // already know the url used. So let's just
                        // reset the root nav to its root page
                        activeNavContainers_1.forEach(function (navContainer) {
                            navContainer.goToRoot({
                                updateUrl: false,
                                isNavRoot: true
                            });
                        });
                        return;
                    }
                }
                // normal url
                var segments = this.getCurrentSegments(browserUrl);
                segments
                    .map(function (segment) {
                    // find the matching nav container
                    for (var _i = 0, activeNavContainers_2 = activeNavContainers_1; _i < activeNavContainers_2.length; _i++) {
                        var navContainer = activeNavContainers_2[_i];
                        var nav = getNavFromTree(navContainer, segment.navId);
                        if (nav) {
                            return {
                                segment: segment,
                                navContainer: nav
                            };
                        }
                    }
                })
                    .filter(function (pair) { return !!pair; })
                    .forEach(function (pair) {
                    _this._loadViewForSegment(pair.navContainer, pair.segment, function () { });
                });
            }
        }
    };
    DeepLinker.prototype.getCurrentSegments = function (browserUrl) {
        if (!browserUrl) {
            browserUrl = normalizeUrl(this._location.path());
        }
        return this._serializer.parse(browserUrl);
    };
    /**
     * Update the deep linker using the NavController's current active view.
     * @internal
     */
    DeepLinker.prototype.navChange = function (direction) {
        if (direction) {
            var activeNavContainers = this._app.getActiveNavContainers();
            // the only time you'll ever get a TABS here is when loading directly from a URL
            // this method will be called again when the TAB is loaded
            // so just don't worry about the TABS for now
            // if you encounter a TABS, just return
            for (var _i = 0, activeNavContainers_3 = activeNavContainers; _i < activeNavContainers_3.length; _i++) {
                var activeNavContainer = activeNavContainers_3[_i];
                if (Object(__WEBPACK_IMPORTED_MODULE_0__nav_util__["o" /* isTabs */])(activeNavContainer) || activeNavContainer.isTransitioning()) {
                    return;
                }
            }
            // okay, get the root navs and build the segments up
            var segments = [];
            var navContainers = this._app.getRootNavs();
            for (var _a = 0, navContainers_1 = navContainers; _a < navContainers_1.length; _a++) {
                var navContainer = navContainers_1[_a];
                var segmentsForNav = this.getSegmentsFromNav(navContainer);
                segments = segments.concat(segmentsForNav);
            }
            segments = segments.filter(function (segment) { return !!segment; });
            if (segments.length) {
                var browserUrl = this._serializer.serialize(segments);
                this._updateLocation(browserUrl, direction);
            }
        }
    };
    DeepLinker.prototype.getSegmentsFromNav = function (nav) {
        var _this = this;
        var segments = [];
        if (Object(__WEBPACK_IMPORTED_MODULE_0__nav_util__["m" /* isNav */])(nav)) {
            segments.push(this.getSegmentFromNav(nav));
        }
        else if (Object(__WEBPACK_IMPORTED_MODULE_0__nav_util__["n" /* isTab */])(nav)) {
            segments.push(this.getSegmentFromTab(nav));
        }
        nav.getActiveChildNavs().forEach(function (child) {
            segments = segments.concat(_this.getSegmentsFromNav(child));
        });
        return segments;
    };
    DeepLinker.prototype.getSegmentFromNav = function (nav, component, data) {
        if (!component) {
            var viewController = nav.getActive(true);
            if (viewController) {
                component = viewController.component;
                data = viewController.data;
            }
        }
        return this._serializer.serializeComponent(nav, component, data);
    };
    DeepLinker.prototype.getSegmentFromTab = function (navContainer, component, data) {
        if (navContainer && navContainer.parent) {
            var tabsNavContainer = navContainer.parent;
            var activeChildNavs = tabsNavContainer.getActiveChildNavs();
            if (activeChildNavs && activeChildNavs.length) {
                var activeChildNav = activeChildNavs[0];
                var viewController = activeChildNav.getActive(true);
                if (viewController) {
                    component = viewController.component;
                    data = viewController.data;
                }
                return this._serializer.serializeComponent(tabsNavContainer, component, data);
            }
        }
    };
    /**
     * @internal
     */
    DeepLinker.prototype._updateLocation = function (browserUrl, direction) {
        if (this._indexAliasUrl === browserUrl) {
            browserUrl = '/';
        }
        if (direction === __WEBPACK_IMPORTED_MODULE_0__nav_util__["a" /* DIRECTION_BACK */] && this._isBackUrl(browserUrl)) {
            // this URL is exactly the same as the back URL
            // it's safe to use the browser's location.back()
            (void 0) /* console.debug */;
            this._historyPop();
            this._location.back();
        }
        else if (!this._isCurrentUrl(browserUrl)) {
            // probably navigating forward
            (void 0) /* console.debug */;
            this._historyPush(browserUrl);
            this._location.go(browserUrl);
        }
    };
    DeepLinker.prototype.getComponentFromName = function (componentName) {
        var link = this._serializer.getLinkFromName(componentName);
        if (link) {
            // cool, we found the right link for this component name
            return this.getNavLinkComponent(link);
        }
        // umm, idk
        return Promise.reject("invalid link: " + componentName);
    };
    DeepLinker.prototype.getNavLinkComponent = function (link) {
        if (link.component) {
            // sweet, we're already got a component loaded for this link
            return Promise.resolve(link.component);
        }
        if (link.loadChildren) {
            // awesome, looks like we'll lazy load this component
            // using loadChildren as the URL to request
            return this._moduleLoader.load(link.loadChildren).then(function (response) {
                link.component = response.component;
                return response.component;
            });
        }
        return Promise.reject("invalid link component: " + link.name);
    };
    /**
     * @internal
     */
    DeepLinker.prototype.resolveComponent = function (component) {
        var cfr = this._moduleLoader.getComponentFactoryResolver(component);
        if (!cfr) {
            cfr = this._baseCfr;
        }
        return cfr.resolveComponentFactory(component);
    };
    /**
     * @internal
     */
    DeepLinker.prototype.createUrl = function (navContainer, nameOrComponent, _data, prepareExternalUrl) {
        if (prepareExternalUrl === void 0) { prepareExternalUrl = true; }
        // create a segment out of just the passed in name
        var segment = this._serializer.createSegmentFromName(navContainer, nameOrComponent);
        var allSegments = this.getCurrentSegments();
        if (segment) {
            for (var i = 0; i < allSegments.length; i++) {
                if (allSegments[i].navId === navContainer.name || allSegments[i].navId === navContainer.id) {
                    allSegments[i] = segment;
                    var url = this._serializer.serialize(allSegments);
                    return prepareExternalUrl ? this._location.prepareExternalUrl(url) : url;
                }
            }
        }
        return '';
    };
    /**
     * Each NavController will call this method when it initializes for
     * the first time. This allows each NavController to figure out
     * where it lives in the path and load up the correct component.
     * @internal
     */
    DeepLinker.prototype.getSegmentByNavIdOrName = function (navId, name) {
        var browserUrl = normalizeUrl(this._location.path());
        var segments = this._serializer.parse(browserUrl);
        for (var _i = 0, segments_1 = segments; _i < segments_1.length; _i++) {
            var segment = segments_1[_i];
            if (segment.navId === navId || segment.navId === name) {
                return segment;
            }
        }
        return null;
    };
    /**
     * @internal
     */
    DeepLinker.prototype.initViews = function (segment) {
        var _this = this;
        var link = this._serializer.getLinkFromName(segment.name);
        return this.getNavLinkComponent(link).then(function (component) {
            segment.component = component;
            var view = new __WEBPACK_IMPORTED_MODULE_3__view_controller__["a" /* ViewController */](component, segment.data);
            view.id = segment.id;
            if (Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["e" /* isArray */])(segment.defaultHistory)) {
                return Object(__WEBPACK_IMPORTED_MODULE_0__nav_util__["k" /* convertToViews */])(_this, segment.defaultHistory).then(function (views) {
                    views.push(view);
                    return views;
                });
            }
            return [view];
        });
    };
    /**
     * @internal
     */
    DeepLinker.prototype._isBackUrl = function (browserUrl) {
        return (browserUrl === this._history[this._history.length - 2]);
    };
    /**
     * @internal
     */
    DeepLinker.prototype._isCurrentUrl = function (browserUrl) {
        return (browserUrl === this._history[this._history.length - 1]);
    };
    /**
     * @internal
     */
    DeepLinker.prototype._historyPush = function (browserUrl) {
        if (!this._isCurrentUrl(browserUrl)) {
            this._history.push(browserUrl);
            if (this._history.length > 30) {
                this._history.shift();
            }
        }
    };
    /**
     * @internal
     */
    DeepLinker.prototype._historyPop = function () {
        this._history.pop();
        if (!this._history.length) {
            this._historyPush(this._location.path());
        }
    };
    /**
     * @internal
     */
    DeepLinker.prototype._getTabSelector = function (tab) {
        if (Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["l" /* isPresent */])(tab.tabUrlPath)) {
            return tab.tabUrlPath;
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["l" /* isPresent */])(tab.tabTitle)) {
            return Object(__WEBPACK_IMPORTED_MODULE_2__url_serializer__["c" /* formatUrlPart */])(tab.tabTitle);
        }
        return "tab-" + tab.index;
    };
    /**
     * Using the known Path of Segments, walk down all descendents
     * from the root NavController and load each NavController according
     * to each Segment. This is usually called after a browser URL and
     * Path changes and needs to update all NavControllers to match
     * the new browser URL. Because the URL is already known, it will
     * not update the browser's URL when transitions have completed.
     *
     * @internal
     */
    DeepLinker.prototype._loadViewForSegment = function (navContainer, segment, done) {
        if (!segment) {
            return done(false, false);
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_0__nav_util__["o" /* isTabs */])(navContainer) || (Object(__WEBPACK_IMPORTED_MODULE_0__nav_util__["n" /* isTab */])(navContainer) && navContainer.parent)) {
            var tabs = (Object(__WEBPACK_IMPORTED_MODULE_0__nav_util__["o" /* isTabs */])(navContainer) ? navContainer : navContainer.parent);
            var selectedIndex = tabs._getSelectedTabIndex(segment.secondaryId);
            var tab = tabs.getByIndex(selectedIndex);
            tab._segment = segment;
            tabs.select(tab, {
                updateUrl: false,
                animate: false
            }, true);
            return done(false, false);
        }
        var navController = navContainer;
        var numViews = navController.length() - 1;
        // walk backwards to see if the exact view we want to show here
        // is already in the stack that we can just pop back to
        for (var i = numViews; i >= 0; i--) {
            var viewController = navController.getByIndex(i);
            if (viewController && (viewController.id === segment.id || viewController.id === segment.name)) {
                // hooray! we've already got a view loaded in the stack
                // matching the view they wanted to show
                if (i === numViews) {
                    // this is the last view in the stack and it's the same
                    // as the segment so there's no change needed
                    return done(false, false);
                }
                else {
                    // it's not the exact view as the end
                    // let's have this nav go back to this exact view
                    return navController.popTo(viewController, {
                        animate: false,
                        updateUrl: false,
                    }, done);
                }
            }
        }
        // ok, so we don't know about a view that they're navigating to
        // so we might as well just call setRoot and make tthe view the first view
        // this seems like the least bad option
        return navController.setRoot(segment.component || segment.name, segment.data, {
            id: segment.id, animate: false, updateUrl: false
        }, done);
    };
    return DeepLinker;
}());

function setupDeepLinker(app, serializer, location, moduleLoader, cfr) {
    var deepLinker = new DeepLinker(app, serializer, location, moduleLoader, cfr);
    deepLinker.init();
    return deepLinker;
}
function normalizeUrl(browserUrl) {
    browserUrl = browserUrl.trim();
    if (browserUrl.charAt(0) !== '/') {
        // ensure first char is a /
        browserUrl = '/' + browserUrl;
    }
    if (browserUrl.length > 1 && browserUrl.charAt(browserUrl.length - 1) === '/') {
        // ensure last char is not a /
        browserUrl = browserUrl.substr(0, browserUrl.length - 1);
    }
    return browserUrl;
}
function getNavFromTree(nav, id) {
    while (nav) {
        if (nav.id === id || nav.name === id) {
            return nav;
        }
        nav = nav.parent;
    }
    return null;
}
//# sourceMappingURL=deep-linker.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/navigation/ionic-page.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IonicPage;
/**
 * @name IonicPage
 * @description
 * The Ionic Page handles registering and displaying specific pages based on URLs. It's used
 * underneath `NavController` so it will never have to be interacted with directly. When a new
 * page is pushed with `NavController`, the URL is updated to match the path to this page.
 *
 * Unlike traditional web apps, URLs don't dictate navigation in Ionic apps.
 * Instead, URLs help us link to specific pieces of content as a breadcrumb.
 * The current URL gets updated as we navigate, but we use the `NavController`
 * push and pop, or `NavPush` and `NavPop` to move around. This makes it much easier
 * to handle complicated nested navigation.
 *
 * We refer to our URL system as a deep link system instead of a router to encourage
 * Ionic developers to think of URLs as a breadcrumb rather than as the source of
 * truth in navigation. This encourages flexible navigation design and happy apps all
 * over the world.
 *
 *
 * @usage
 *
 * The first step to setting up deep links is to add the page that should be
 * a deep link in the `IonicPageModule.forChild` import of the page's module.
 * For our examples, this will be `MyPage`:
 *
 * ```ts
 * @NgModule({
 *   declarations: [
 *     MyPage
 *   ],
 *   imports: [
 *     IonicPageModule.forChild(MyPage)
 *   ],
 *   entryComponents: [
 *     MyPage
 *   ]
 * })
 * export class MyPageModule {}
 * ```
 *
 * Then, add the `@IonicPage` decorator to the component. The most simple usage is adding an
 * empty decorator:
 *
 * ```ts
 * @IonicPage()
 * @Component({
 *   templateUrl: 'main.html'
 * })
 * export class MyPage {}
 * ```
 *
 * This will automatically create a link to the `MyPage` component using the same name as the class,
 * `name`: `'MyPage'`. The page can now be navigated to by using this name. For example:
 *
 * ```ts
 * @Component({
 *   templateUrl: 'another-page.html'
 * })
 * export class AnotherPage {
 *   constructor(public navCtrl: NavController) {}
 *
 *   goToMyPage() {
 *     // go to the MyPage component
 *     this.navCtrl.push('MyPage');
 *   }
 * }
 * ```
 *
 * The `@IonicPage` decorator accepts a `DeepLinkMetadataType` object. This object accepts
 * the following properties: `name`, `segment`, `defaultHistory`, and `priority`. All of them
 * are optional but can be used to create complex navigation links. The `name` and `segment`
 * values must be unique.
 *
 *
 * ### Changing Name
 *
 * As mentioned previously, the `name` property will be set to the class name if it isn't provided.
 * Changing the name of the link is extremely simple. To change the name used to link to the
 * component, simply pass it in the decorator like so:
 *
 * ```ts
 * @IonicPage({
 *   name: 'my-page'
 * })
 * ```
 *
 * This will create a link to the `MyPage` component using the name `'my-page'`. Similar to the previous
 * example, the page can be navigated to by using the name:
 *
 * ```ts
 * goToMyPage() {
 *   // go to the MyPage component
 *   this.navCtrl.push('my-page');
 * }
 * ```
 *
 *
 * ### Setting URL Path
 *
 * The `segment` property is used to set the URL to the page. If this property isn't provided, the
 * `segment` will use the value of source file name without the extension (`'my-page.ts'` results
 * in segment name `'my-page'`). Since components can be loaded anywhere in the app, the `segment`
 * doesn't require a full URL path. When a page becomes the active page, the `segment` is appended
 * to the URL.
 *
 * The `segment` can be changed to anything and doesn't have to match the `name`. For example, passing
 * a value for `name` and `segment`:
 *
 * ```ts
 * @IonicPage({
 *   name: 'my-page',
 *   segment: 'some-path'
 * })
 * ```
 *
 * When navigating to this page as the first page in the app, the URL will look something like:
 *
 * ```
 * http://localhost:8101/#/some-path
 * ```
 *
 * However, navigating to the page will still use the `name` like the previous examples do.
 *
 *
 * ### Dynamic Links
 *
 * The `segment` property is useful for creating dynamic links. Sometimes the URL isn't known ahead
 * of time, so it can be passed as a variable.
 *
 * Since passing data around is common practice in an app, it can be reflected in the app's URL by
 * using the `:param` syntax. For example, set the `segment` in the `@IonicPage` decorator:
 *
 * ```ts
 * @IonicPage({
 *   name: 'detail-page',
 *   segment: 'detail/:id'
 * })
 * ```
 *
 * In this case, when we `push` to a new instance of `'detail-page'`, the value of `id` will
 * in the `detailInfo` data being passed to `push` will replace `:id` in the URL.
 *
 * Important: The property needs to be something that can be converted into a string, objects
 * are not supported.
 *
 * For example, to push the `'detail-page'` in the `ListPage` component, the following code could
 * be used:
 *
 * ```ts
 * @IonicPage({
 *   name: 'list'
 * })
 * export class ListPage {
 *   constructor(public navCtrl: NavController) {}
 *
 *   pushPage(detailInfo) {
 *     // Push an `id` to the `'detail-page'`
 *     this.navCtrl.push('detail-page', {
 *       'id': detailInfo.id
 *     })
 *   }
 * }
 * ```
 *
 * If the value of `detailInfo.id` is `12`, for example, the URL would end up looking like this:
 *
 * ```
 * http://localhost:8101/#/list/detail/12
 * ```
 *
 * Since this `id` will be used to pull in the data of the specific detail page, it's Important
 * that the `id` is unique.
 *
 * Note: Even though the `name` is `detail-page`, the `segment` uses `detail/:id`, and the URL
 * will use the `segment`.
 *
 *
 * ### Default History
 *
 * Pages can be navigated to using deep links from anywhere in the app, but sometimes the app is
 * launched from a URL and the page needs to have the same history as if it were navigated to from
 * inside of the app.
 *
 * By default, the page would be navigated to as the first page in the stack with no prior history.
 * A good example is the App Store on iOS. Clicking on a URL to an application in the App Store will
 * load the details of the application with no back button, as if it were the first page ever viewed.
 *
 * The default history of any page can be set in the `defaultHistory` property. This history will only
 * be used if the history doesn't already exist, meaning if you navigate to the page the history will
 * be the pages that were navigated from.
 *
 * The `defaultHistory` property takes an array of page names. The page names are specified as statically
 * analyzable strings (which means you must use strings and not variables or delared constants). If the
 * parent page does not have a `name` specified in its `IonicPage` decorator its name is its class name.
 *
 * For example, setting the history of the detail page to the list page where the `name` is `list`:
 *
 * ```ts
 * @IonicPage({
 *   name: 'detail-page',
 *   segment: 'detail/:id',
 *   defaultHistory: ['list']
 * })
 * ```
 *
 * In this example, if the app is launched at `http://localhost:8101/#/detail/my-detail` the displayed page
 * will be the `'detail-page'` with an id of `my-detail` and it will show a back button that goes back to
 * the `'list'` page.
 *
 * For a deeper example:
 *
 * ```ts
 * @IonicPage({
 *   segment: 'contact-more-info',
 *   defaultHistory: ['ContactDetailPage', 'Contact']
 * })
 * ...
 * export class ContactMoreInfoPage {
 *   ...
 * }
 * ```
 *
 * In this example, if the app is launched at `http://localhost:8101/#/contact/contact-more-info` the displayed page
 * will be the `'ContactMoreInfoPage'`. It will show a back button that will go to the `'ContactDetailPage'` which
 * will also show a back button which will go to the `'Contact'` page.
 *
 * An example of an application with a set history stack is the Instagram application. Opening a link
 * to an image on Instagram will show the details for that image with a back button to the user's profile
 * page. There is no "right" way of setting the history for a page, it is up to the application.
 *
 * ### Priority
 *
 * The `priority` property is only used during preloading. By default, preloading is turned off so setting
 * this property would do nothing. Preloading eagerly loads all deep links after the application boots
 * instead of on demand as needed. To enable preloading, set `preloadModules` in the main application module
 * config to `true`:
 *
 * ```ts
 * @NgModule({
 *   declarations: [
 *     MyApp
 *   ],
 *   imports: [
 *     BrowserModule,
 *     IonicModule.forRoot(MyApp, {
 *       preloadModules: true
 *     })
 *   ],
 *   bootstrap: [IonicApp],
 *   entryComponents: [
 *     MyApp
 *   ]
 * })
 * export class AppModule { }
 * ```
 *
 * If preloading is turned on, it will load the modules based on the value of `priority`. The following
 * values are possible for `priority`: `"high"`, `"low"`, and `"off"`. When there is no `priority`, it
 * will be set to `"low"`.
 *
 * All deep links with their priority set to `"high"` will be loaded first. Upon completion of loading the
 * `"high"` priority modules, all deep links with a priority of `"low"` (or no priority) will be loaded. If
 * the priority is set to `"off"` the link will not be preloaded. Setting the `priority` is as simple as
 * passing it to the `@IonicPage` decorator:
 *
 * ```ts
 * @IonicPage({
 *   name: 'my-page',
 *   priority: 'high'
 * })
 * ```
 *
 * We recommend setting the `priority` to `"high"` on the pages that will be viewed first when launching
 * the application.
 *
 */
function IonicPage(_config) {
    return function (clazz) {
        return clazz;
    };
}
//# sourceMappingURL=ionic-page.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/navigation/nav-controller-base.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NavControllerBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nav_util__ = __webpack_require__("./node_modules/ionic-angular/navigation/nav-util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__view_controller__ = __webpack_require__("./node_modules/ionic-angular/navigation/view-controller.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ion__ = __webpack_require__("./node_modules/ionic-angular/components/ion.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__nav_controller__ = __webpack_require__("./node_modules/ionic-angular/navigation/nav-controller.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__nav_params__ = __webpack_require__("./node_modules/ionic-angular/navigation/nav-params.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__swipe_back__ = __webpack_require__("./node_modules/ionic-angular/navigation/swipe-back.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();









/**
 * @hidden
 * This class is for internal use only. It is not exported publicly.
 */
var NavControllerBase = (function (_super) {
    __extends(NavControllerBase, _super);
    function NavControllerBase(parent, _app, config, plt, elementRef, _zone, renderer, _cfr, _gestureCtrl, _trnsCtrl, _linker, _domCtrl, _errHandler) {
        var _this = _super.call(this, config, elementRef, renderer) || this;
        _this.parent = parent;
        _this._app = _app;
        _this.config = config;
        _this.plt = plt;
        _this._zone = _zone;
        _this._cfr = _cfr;
        _this._gestureCtrl = _gestureCtrl;
        _this._trnsCtrl = _trnsCtrl;
        _this._linker = _linker;
        _this._domCtrl = _domCtrl;
        _this._errHandler = _errHandler;
        _this._ids = -1;
        _this._init = false;
        _this._queue = [];
        _this._trnsId = null;
        _this._trnsTm = false;
        _this._views = [];
        _this._zIndexOffset = 0;
        _this.viewDidLoad = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        _this.viewWillEnter = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        _this.viewDidEnter = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        _this.viewWillLeave = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        _this.viewDidLeave = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        _this.viewWillUnload = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        _this._sbEnabled = config.getBoolean('swipeBackEnabled');
        _this._children = [];
        _this.id = 'n' + (++ctrlIds);
        _this._destroyed = false;
        return _this;
    }
    Object.defineProperty(NavControllerBase.prototype, "swipeBackEnabled", {
        get: function () {
            return this._sbEnabled;
        },
        set: function (val) {
            this._sbEnabled = Object(__WEBPACK_IMPORTED_MODULE_2__util_util__["o" /* isTrueProperty */])(val);
            this._swipeBackCheck();
        },
        enumerable: true,
        configurable: true
    });
    NavControllerBase.prototype.push = function (page, params, opts, done) {
        return this._queueTrns({
            insertStart: -1,
            insertViews: [{ page: page, params: params }],
            opts: opts,
        }, done);
    };
    NavControllerBase.prototype.insert = function (insertIndex, page, params, opts, done) {
        return this._queueTrns({
            insertStart: insertIndex,
            insertViews: [{ page: page, params: params }],
            opts: opts,
        }, done);
    };
    NavControllerBase.prototype.insertPages = function (insertIndex, insertPages, opts, done) {
        return this._queueTrns({
            insertStart: insertIndex,
            insertViews: insertPages,
            opts: opts,
        }, done);
    };
    NavControllerBase.prototype.pop = function (opts, done) {
        return this._queueTrns({
            removeStart: -1,
            removeCount: 1,
            opts: opts,
        }, done);
    };
    NavControllerBase.prototype.popTo = function (indexOrViewCtrl, opts, done) {
        var config = {
            removeStart: -1,
            removeCount: -1,
            opts: opts
        };
        if (Object(__WEBPACK_IMPORTED_MODULE_3__view_controller__["b" /* isViewController */])(indexOrViewCtrl)) {
            config.removeView = indexOrViewCtrl;
            config.removeStart = 1;
        }
        else if (Object(__WEBPACK_IMPORTED_MODULE_2__util_util__["j" /* isNumber */])(indexOrViewCtrl)) {
            config.removeStart = indexOrViewCtrl + 1;
        }
        return this._queueTrns(config, done);
    };
    NavControllerBase.prototype.popToRoot = function (opts, done) {
        return this._queueTrns({
            removeStart: 1,
            removeCount: -1,
            opts: opts,
        }, done);
    };
    NavControllerBase.prototype.popAll = function () {
        var promises = [];
        for (var i = this._views.length - 1; i >= 0; i--) {
            promises.push(this.pop(null));
        }
        return Promise.all(promises);
    };
    NavControllerBase.prototype.remove = function (startIndex, removeCount, opts, done) {
        if (removeCount === void 0) { removeCount = 1; }
        return this._queueTrns({
            removeStart: startIndex,
            removeCount: removeCount,
            opts: opts,
        }, done);
    };
    NavControllerBase.prototype.removeView = function (viewController, opts, done) {
        return this._queueTrns({
            removeView: viewController,
            removeStart: 0,
            removeCount: 1,
            opts: opts,
        }, done);
    };
    NavControllerBase.prototype.setRoot = function (pageOrViewCtrl, params, opts, done) {
        return this.setPages([{ page: pageOrViewCtrl, params: params }], opts, done);
    };
    NavControllerBase.prototype.setPages = function (viewControllers, opts, done) {
        if (Object(__WEBPACK_IMPORTED_MODULE_2__util_util__["f" /* isBlank */])(opts)) {
            opts = {};
        }
        // if animation wasn't set to true then default it to NOT animate
        if (opts.animate !== true) {
            opts.animate = false;
        }
        return this._queueTrns({
            insertStart: 0,
            insertViews: viewControllers,
            removeStart: 0,
            removeCount: -1,
            opts: opts
        }, done);
    };
    // _queueTrns() adds a navigation stack change to the queue and schedules it to run:
    // 1. _nextTrns(): consumes the next transition in the queue
    // 2. _viewInit(): initializes enteringView if required
    // 3. _viewTest(): ensures canLeave/canEnter returns true, so the operation can continue
    // 4. _postViewInit(): add/remove the views from the navigation stack
    // 5. _transitionInit(): initializes the visual transition if required and schedules it to run
    // 6. _viewAttachToDOM(): attaches the enteringView to the DOM
    // 7. _transitionStart(): called once the transition actually starts, it initializes the Animation underneath.
    // 8. _transitionFinish(): called once the transition finishes
    // 9. _cleanup(): syncs the navigation internal state with the DOM. For example it removes the pages from the DOM or hides/show them.
    NavControllerBase.prototype._queueTrns = function (ti, done) {
        var promise = new Promise(function (resolve, reject) {
            ti.resolve = resolve;
            ti.reject = reject;
        });
        ti.done = done;
        // Normalize empty
        if (ti.insertViews && ti.insertViews.length === 0) {
            ti.insertViews = undefined;
        }
        // Enqueue transition instruction
        this._queue.push(ti);
        // if there isn't a transition already happening
        // then this will kick off this transition
        this._nextTrns();
        return promise;
    };
    NavControllerBase.prototype._success = function (result, ti) {
        if (this._queue === null) {
            this._fireError('nav controller was destroyed', ti);
            return;
        }
        this._init = true;
        this._trnsId = null;
        // ensure we're not transitioning here
        this.setTransitioning(false);
        this._swipeBackCheck();
        // let's see if there's another to kick off
        this._nextTrns();
        if (ti.done) {
            ti.done(result.hasCompleted, result.requiresTransition, result.enteringName, result.leavingName, result.direction);
        }
        ti.resolve(result.hasCompleted);
    };
    NavControllerBase.prototype._failed = function (rejectReason, ti) {
        if (this._queue === null) {
            this._fireError('nav controller was destroyed', ti);
            return;
        }
        this._trnsId = null;
        this._queue.length = 0;
        // let's see if there's another to kick off
        this.setTransitioning(false);
        this._swipeBackCheck();
        this._nextTrns();
        this._fireError(rejectReason, ti);
    };
    NavControllerBase.prototype._fireError = function (rejectReason, ti) {
        if (ti.done) {
            ti.done(false, false, rejectReason);
        }
        if (ti.reject && !this._destroyed) {
            ti.reject(rejectReason);
        }
        else {
            ti.resolve(false);
        }
    };
    NavControllerBase.prototype._nextTrns = function () {
        var _this = this;
        // this is the framework's bread 'n butta function
        // only one transition is allowed at any given time
        if (this.isTransitioning()) {
            return false;
        }
        // there is no transition happening right now
        // get the next instruction
        var ti = this._queue.shift();
        if (!ti) {
            return false;
        }
        // set that this nav is actively transitioning
        var enteringView;
        var leavingView;
        this._startTI(ti)
            .then(function () { return _this._loadLazyLoading(ti); })
            .then(function () {
            leavingView = _this.getActive();
            enteringView = _this._getEnteringView(ti, leavingView);
            if (!leavingView && !enteringView) {
                throw 'no views in the stack to be removed';
            }
            if (enteringView && enteringView._state === __WEBPACK_IMPORTED_MODULE_1__nav_util__["j" /* STATE_NEW */]) {
                _this._viewInit(enteringView);
            }
            // Needs transition?
            ti.requiresTransition = (ti.enteringRequiresTransition || ti.leavingRequiresTransition) && enteringView !== leavingView;
        })
            .then(function () { return _this._viewTest(enteringView, leavingView, ti); })
            .then(function () { return _this._postViewInit(enteringView, leavingView, ti); })
            .then(function () { return _this._transition(enteringView, leavingView, ti); })
            .then(function (result) { return _this._success(result, ti); })
            .catch(function (rejectReason) { return _this._failed(rejectReason, ti); });
        return true;
    };
    NavControllerBase.prototype._startTI = function (ti) {
        var viewsLength = this._views.length;
        if (Object(__WEBPACK_IMPORTED_MODULE_2__util_util__["l" /* isPresent */])(ti.removeView)) {
            (void 0) /* assert */;
            (void 0) /* assert */;
            var index = this.indexOf(ti.removeView);
            if (index < 0) {
                return Promise.reject('removeView was not found');
            }
            ti.removeStart += index;
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_2__util_util__["l" /* isPresent */])(ti.removeStart)) {
            if (ti.removeStart < 0) {
                ti.removeStart = (viewsLength - 1);
            }
            if (ti.removeCount < 0) {
                ti.removeCount = (viewsLength - ti.removeStart);
            }
            ti.leavingRequiresTransition = (ti.removeCount > 0) && ((ti.removeStart + ti.removeCount) === viewsLength);
        }
        if (ti.insertViews) {
            // allow -1 to be passed in to auto push it on the end
            // and clean up the index if it's larger then the size of the stack
            if (ti.insertStart < 0 || ti.insertStart > viewsLength) {
                ti.insertStart = viewsLength;
            }
            ti.enteringRequiresTransition = (ti.insertStart === viewsLength);
        }
        this.setTransitioning(true);
        return Promise.resolve();
    };
    NavControllerBase.prototype._loadLazyLoading = function (ti) {
        var _this = this;
        var insertViews = ti.insertViews;
        if (insertViews) {
            (void 0) /* assert */;
            return Object(__WEBPACK_IMPORTED_MODULE_1__nav_util__["k" /* convertToViews */])(this._linker, insertViews).then(function (viewControllers) {
                (void 0) /* assert */;
                viewControllers = viewControllers.filter(function (v) { return v !== null; });
                if (viewControllers.length === 0) {
                    throw 'invalid views to insert';
                }
                // Check all the inserted view are correct
                for (var i = 0; i < viewControllers.length; i++) {
                    var view = viewControllers[i];
                    var nav = view._nav;
                    if (nav && nav !== _this) {
                        throw 'inserted view was already inserted';
                    }
                    if (view._state === __WEBPACK_IMPORTED_MODULE_1__nav_util__["h" /* STATE_DESTROYED */]) {
                        throw 'inserted view was already destroyed';
                    }
                }
                ti.insertViews = viewControllers;
            });
        }
        return Promise.resolve();
    };
    NavControllerBase.prototype._getEnteringView = function (ti, leavingView) {
        var insertViews = ti.insertViews;
        if (insertViews) {
            // grab the very last view of the views to be inserted
            // and initialize it as the new entering view
            return insertViews[insertViews.length - 1];
        }
        var removeStart = ti.removeStart;
        if (Object(__WEBPACK_IMPORTED_MODULE_2__util_util__["l" /* isPresent */])(removeStart)) {
            var views = this._views;
            var removeEnd = removeStart + ti.removeCount;
            var i;
            var view;
            for (i = views.length - 1; i >= 0; i--) {
                view = views[i];
                if ((i < removeStart || i >= removeEnd) && view !== leavingView) {
                    return view;
                }
            }
        }
        return null;
    };
    NavControllerBase.prototype._postViewInit = function (enteringView, leavingView, ti) {
        var _this = this;
        (void 0) /* assert */;
        (void 0) /* assert */;
        (void 0) /* assert */;
        var opts = ti.opts || {};
        var insertViews = ti.insertViews;
        var removeStart = ti.removeStart;
        var removeCount = ti.removeCount;
        var view;
        var i;
        var destroyQueue;
        // there are views to remove
        if (Object(__WEBPACK_IMPORTED_MODULE_2__util_util__["l" /* isPresent */])(removeStart)) {
            (void 0) /* assert */;
            (void 0) /* assert */;
            destroyQueue = [];
            for (i = 0; i < removeCount; i++) {
                view = this._views[i + removeStart];
                if (view && view !== enteringView && view !== leavingView) {
                    destroyQueue.push(view);
                }
            }
            // default the direction to "back"
            opts.direction = opts.direction || __WEBPACK_IMPORTED_MODULE_1__nav_util__["a" /* DIRECTION_BACK */];
        }
        var finalBalance = this._views.length + (insertViews ? insertViews.length : 0) - (removeCount ? removeCount : 0);
        (void 0) /* assert */;
        if (finalBalance === 0 && !this._isPortal) {
            console.warn("You can't remove all the pages in the navigation stack. nav.pop() is probably called too many times.", this, this.getNativeElement());
            throw 'navigation stack needs at least one root page';
        }
        // At this point the transition can not be rejected, any throw should be an error
        // there are views to insert
        if (insertViews) {
            // manually set the new view's id if an id was passed in the options
            if (Object(__WEBPACK_IMPORTED_MODULE_2__util_util__["l" /* isPresent */])(opts.id)) {
                enteringView.id = opts.id;
            }
            // add the views to the
            for (i = 0; i < insertViews.length; i++) {
                view = insertViews[i];
                this._insertViewAt(view, ti.insertStart + i);
            }
            if (ti.enteringRequiresTransition) {
                // default to forward if not already set
                opts.direction = opts.direction || __WEBPACK_IMPORTED_MODULE_1__nav_util__["b" /* DIRECTION_FORWARD */];
            }
        }
        // if the views to be removed are in the beginning or middle
        // and there is not a view that needs to visually transition out
        // then just destroy them and don't transition anything
        // batch all of lifecycles together
        // let's make sure, callbacks are zoned
        if (destroyQueue && destroyQueue.length > 0) {
            this._zone.run(function () {
                for (i = 0; i < destroyQueue.length; i++) {
                    view = destroyQueue[i];
                    _this._willLeave(view, true);
                    _this._didLeave(view);
                    _this._willUnload(view);
                }
            });
            // once all lifecycle events has been delivered, we can safely detroy the views
            for (i = 0; i < destroyQueue.length; i++) {
                this._destroyView(destroyQueue[i]);
            }
        }
        // set which animation it should use if it wasn't set yet
        if (ti.requiresTransition && !opts.animation) {
            if (Object(__WEBPACK_IMPORTED_MODULE_2__util_util__["l" /* isPresent */])(ti.removeStart)) {
                opts.animation = (leavingView || enteringView).getTransitionName(opts.direction);
            }
            else {
                opts.animation = (enteringView || leavingView).getTransitionName(opts.direction);
            }
        }
        ti.opts = opts;
    };
    /**
     * DOM WRITE
     */
    NavControllerBase.prototype._viewInit = function (enteringView) {
        (void 0) /* assert */;
        (void 0) /* assert */;
        // render the entering view, and all child navs and views
        // entering view has not been initialized yet
        var componentProviders = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ReflectiveInjector"].resolve([
            { provide: __WEBPACK_IMPORTED_MODULE_5__nav_controller__["a" /* NavController */], useValue: this },
            { provide: __WEBPACK_IMPORTED_MODULE_3__view_controller__["a" /* ViewController */], useValue: enteringView },
            { provide: __WEBPACK_IMPORTED_MODULE_6__nav_params__["a" /* NavParams */], useValue: enteringView.getNavParams() }
        ]);
        var componentFactory = this._linker.resolveComponent(enteringView.component);
        var childInjector = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ReflectiveInjector"].fromResolvedProviders(componentProviders, this._viewport.parentInjector);
        // create ComponentRef and set it to the entering view
        enteringView.init(componentFactory.create(childInjector, []));
        enteringView._state = __WEBPACK_IMPORTED_MODULE_1__nav_util__["i" /* STATE_INITIALIZED */];
        this._preLoad(enteringView);
    };
    NavControllerBase.prototype._viewAttachToDOM = function (view, componentRef, viewport) {
        (void 0) /* assert */;
        (void 0) /* assert */;
        // fire willLoad before change detection runs
        this._willLoad(view);
        // render the component ref instance to the DOM
        // ******** DOM WRITE ****************
        viewport.insert(componentRef.hostView, viewport.length);
        view._state = __WEBPACK_IMPORTED_MODULE_1__nav_util__["g" /* STATE_ATTACHED */];
        if (view._cssClass) {
            // the ElementRef of the actual ion-page created
            var pageElement = componentRef.location.nativeElement;
            // ******** DOM WRITE ****************
            this._renderer.setElementClass(pageElement, view._cssClass, true);
        }
        componentRef.changeDetectorRef.detectChanges();
        // successfully finished loading the entering view
        // fire off the "didLoad" lifecycle events
        this._zone.run(this._didLoad.bind(this, view));
    };
    NavControllerBase.prototype._viewTest = function (enteringView, leavingView, ti) {
        // Only test canLeave/canEnter if there is transition
        if (!ti.requiresTransition) {
            return Promise.resolve();
        }
        var promises = [];
        if (leavingView) {
            promises.push(leavingView._lifecycleTest('Leave'));
        }
        if (enteringView) {
            promises.push(enteringView._lifecycleTest('Enter'));
        }
        if (promises.length === 0) {
            return Promise.resolve();
        }
        // darn, async promises, gotta wait for them to resolve
        return Promise.all(promises).then(function (values) {
            if (values.some(function (result) { return result === false; })) {
                throw 'canEnter/Leave returned false';
            }
        }).catch(function (reason) {
            // Do not
            ti.reject = null;
            throw reason;
        });
    };
    NavControllerBase.prototype._transition = function (enteringView, leavingView, ti) {
        var _this = this;
        if (!ti.requiresTransition) {
            // transition is not required, so we are already done!
            // they're inserting/removing the views somewhere in the middle or
            // beginning, so visually nothing needs to animate/transition
            // resolve immediately because there's no animation that's happening
            return Promise.resolve({
                hasCompleted: true,
                requiresTransition: false
            });
        }
        var opts = ti.opts;
        // figure out if this transition is the root one or a
        // child of a parent nav that has the root transition
        this._trnsId = this._trnsCtrl.getRootTrnsId(this);
        if (this._trnsId === null) {
            // this is the root transition, meaning all child navs and their views
            // should be added as a child transition to this one
            this._trnsId = this._trnsCtrl.nextId();
        }
        // create the transition options
        var animationOpts = {
            animation: opts.animation,
            direction: opts.direction,
            duration: (opts.animate === false ? 0 : opts.duration),
            easing: opts.easing,
            isRTL: this._config.plt.isRTL,
            ev: opts.ev,
        };
        // create the transition animation from the TransitionController
        // this will either create the root transition, or add it as a child transition
        var transition = this._trnsCtrl.get(this._trnsId, enteringView, leavingView, animationOpts);
        // ensure any swipeback transitions are cleared out
        this._sbTrns && this._sbTrns.destroy();
        this._sbTrns = null;
        // swipe to go back root transition
        if (transition.isRoot() && opts.progressAnimation) {
            this._sbTrns = transition;
        }
        // transition start has to be registered before attaching the view to the DOM!
        var promise = new Promise(function (resolve) { return transition.registerStart(resolve); }).then(function () {
            return _this._transitionStart(transition, enteringView, leavingView, opts);
        });
        if (enteringView && (enteringView._state === __WEBPACK_IMPORTED_MODULE_1__nav_util__["i" /* STATE_INITIALIZED */])) {
            // render the entering component in the DOM
            // this would also render new child navs/views
            // which may have their very own async canEnter/Leave tests
            // ******** DOM WRITE ****************
            this._viewAttachToDOM(enteringView, enteringView._cmp, this._viewport);
        }
        if (!transition.hasChildren) {
            // lowest level transition, so kick it off and let it bubble up to start all of them
            transition.start();
        }
        return promise;
    };
    NavControllerBase.prototype._transitionStart = function (transition, enteringView, leavingView, opts) {
        var _this = this;
        (void 0) /* assert */;
        this._trnsId = null;
        // set the correct zIndex for the entering and leaving views
        // ******** DOM WRITE ****************
        Object(__WEBPACK_IMPORTED_MODULE_1__nav_util__["p" /* setZIndex */])(this, enteringView, leavingView, opts.direction, this._renderer);
        // always ensure the entering view is viewable
        // ******** DOM WRITE ****************
        enteringView && enteringView._domShow(true, this._renderer);
        // always ensure the leaving view is viewable
        // ******** DOM WRITE ****************
        leavingView && leavingView._domShow(true, this._renderer);
        // initialize the transition
        transition.init();
        // we should animate (duration > 0) if the pushed page is not the first one (startup)
        // or if it is a portal (modal, actionsheet, etc.)
        var isFirstPage = !this._init && this._views.length === 1;
        var shouldNotAnimate = isFirstPage && !this._isPortal;
        var canNotAnimate = this._config.get('animate') === false;
        if (shouldNotAnimate || canNotAnimate) {
            opts.animate = false;
        }
        if (opts.animate === false) {
            // if it was somehow set to not animation, then make the duration zero
            transition.duration(0);
        }
        // create a callback that needs to run within zone
        // that will fire off the willEnter/Leave lifecycle events at the right time
        transition.beforeAddRead(this._viewsWillLifecycles.bind(this, enteringView, leavingView));
        // get the set duration of this transition
        var duration = transition.getDuration();
        // create a callback for when the animation is done
        var promise = new Promise(function (resolve) {
            transition.onFinish(resolve);
        });
        if (transition.isRoot()) {
            // this is the top most, or only active transition, so disable the app
            // add XXms to the duration the app is disabled when the keyboard is open
            if (duration > DISABLE_APP_MINIMUM_DURATION && opts.disableApp !== false) {
                // if this transition has a duration and this is the root transition
                // then set that the app is actively disabled
                this._app.setEnabled(false, duration + ACTIVE_TRANSITION_OFFSET, opts.minClickBlockDuration);
            }
            else {
                (void 0) /* console.debug */;
            }
            // cool, let's do this, start the transition
            if (opts.progressAnimation) {
                // this is a swipe to go back, just get the transition progress ready
                // kick off the swipe animation start
                transition.progressStart();
            }
            else {
                // only the top level transition should actually start "play"
                // kick it off and let it play through
                // ******** DOM WRITE ****************
                transition.play();
            }
        }
        return promise.then(function () { return _this._zone.run(function () {
            return _this._transitionFinish(transition, opts);
        }); });
    };
    NavControllerBase.prototype._transitionFinish = function (transition, opts) {
        var hasCompleted = transition.hasCompleted;
        var enteringView = transition.enteringView;
        var leavingView = transition.leavingView;
        // mainly for testing
        var enteringName;
        var leavingName;
        if (hasCompleted) {
            // transition has completed (went from 0 to 1)
            if (enteringView) {
                enteringName = enteringView.name;
                this._didEnter(enteringView);
            }
            if (leavingView) {
                leavingName = leavingView.name;
                this._didLeave(leavingView);
            }
            this._cleanup(enteringView);
            /**
             * On iOS 12.2 there is a bug that
             * causes scrolling to not
             * be re-enabled unless there
             * is some kind of CSS reflow triggered
             */
            var platform_1 = this.plt;
            if (enteringView &&
                enteringView.getIONContentRef &&
                enteringView.getIONContentRef() &&
                platform_1.is('ios')) {
                platform_1.timeout(function () {
                    platform_1.raf(function () {
                        var content = enteringView.getIONContentRef().nativeElement;
                        content.style.zIndex = '1';
                        platform_1.raf(function () {
                            content.style.zIndex = '';
                        });
                    });
                }, 500);
            }
        }
        else {
            // If transition does not complete, we have to cleanup anyway, because
            // previous pages in the stack are not hidden probably.
            this._cleanup(leavingView);
        }
        if (transition.isRoot()) {
            // this is the root transition
            // it's safe to destroy this transition
            this._trnsCtrl.destroy(transition.trnsId);
            // it's safe to enable the app again
            this._app.setEnabled(true);
            // mark ourselves as not transitioning - `deepLinker navchange` requires this
            // TODO - probably could be resolved in a better way
            this.setTransitioning(false);
            if (!this.hasChildren() && opts.updateUrl !== false) {
                // notify deep linker of the nav change
                // if a direction was provided and should update url
                this._linker.navChange(opts.direction);
            }
            if (opts.keyboardClose !== false) {
                // the keyboard is still open!
                // no problem, let's just close for them
                this.plt.focusOutActiveElement();
            }
        }
        return {
            hasCompleted: hasCompleted,
            requiresTransition: true,
            enteringName: enteringName,
            leavingName: leavingName,
            direction: opts.direction
        };
    };
    NavControllerBase.prototype._viewsWillLifecycles = function (enteringView, leavingView) {
        var _this = this;
        if (enteringView || leavingView) {
            this._zone.run(function () {
                // Here, the order is important. WillLeave must be called before WillEnter.
                if (leavingView) {
                    var willUnload = enteringView ? leavingView.index > enteringView.index : true;
                    _this._willLeave(leavingView, willUnload);
                }
                enteringView && _this._willEnter(enteringView);
            });
        }
    };
    NavControllerBase.prototype._insertViewAt = function (view, index) {
        var existingIndex = this._views.indexOf(view);
        if (existingIndex > -1) {
            // this view is already in the stack!!
            // move it to its new location
            (void 0) /* assert */;
            this._views.splice(index, 0, this._views.splice(existingIndex, 1)[0]);
        }
        else {
            (void 0) /* assert */;
            // this is a new view to add to the stack
            // create the new entering view
            view._setNav(this);
            // give this inserted view an ID
            this._ids++;
            if (!view.id) {
                view.id = this.id + "-" + this._ids;
            }
            // insert the entering view into the correct index in the stack
            this._views.splice(index, 0, view);
        }
    };
    NavControllerBase.prototype._removeView = function (view) {
        (void 0) /* assert */;
        var views = this._views;
        var index = views.indexOf(view);
        (void 0) /* assert */;
        if (index >= 0) {
            views.splice(index, 1);
        }
    };
    NavControllerBase.prototype._destroyView = function (view) {
        view._destroy(this._renderer);
        this._removeView(view);
    };
    /**
     * DOM WRITE
     */
    NavControllerBase.prototype._cleanup = function (activeView) {
        // ok, cleanup time!! Destroy all of the views that are
        // INACTIVE and come after the active view
        // only do this if the views exist, though
        if (!this._destroyed) {
            var activeViewIndex = this._views.indexOf(activeView);
            var views = this._views;
            var reorderZIndexes = false;
            var view = void 0;
            var i = void 0;
            for (i = views.length - 1; i >= 0; i--) {
                view = views[i];
                if (i > activeViewIndex) {
                    // this view comes after the active view
                    // let's unload it
                    this._willUnload(view);
                    this._destroyView(view);
                }
                else if (i < activeViewIndex && !this._isPortal) {
                    // this view comes before the active view
                    // and it is not a portal then ensure it is hidden
                    view._domShow(false, this._renderer);
                }
                if (view._zIndex <= 0) {
                    reorderZIndexes = true;
                }
            }
            if (!this._isPortal && reorderZIndexes) {
                for (i = 0; i < views.length; i++) {
                    view = views[i];
                    // ******** DOM WRITE ****************
                    view._setZIndex(view._zIndex + __WEBPACK_IMPORTED_MODULE_1__nav_util__["f" /* INIT_ZINDEX */] + 1, this._renderer);
                }
            }
        }
    };
    NavControllerBase.prototype._preLoad = function (view) {
        (void 0) /* assert */;
        view._preLoad();
    };
    NavControllerBase.prototype._willLoad = function (view) {
        (void 0) /* assert */;
        try {
            view._willLoad();
        }
        catch (e) {
            this._errHandler && this._errHandler.handleError(e);
        }
    };
    NavControllerBase.prototype._didLoad = function (view) {
        (void 0) /* assert */;
        (void 0) /* assert */;
        try {
            view._didLoad();
            this.viewDidLoad.emit(view);
            this._app.viewDidLoad.emit(view);
        }
        catch (e) {
            this._errHandler && this._errHandler.handleError(e);
        }
    };
    NavControllerBase.prototype._willEnter = function (view) {
        (void 0) /* assert */;
        (void 0) /* assert */;
        try {
            view._willEnter();
            this.viewWillEnter.emit(view);
            this._app.viewWillEnter.emit(view);
        }
        catch (e) {
            this._errHandler && this._errHandler.handleError(e);
        }
    };
    NavControllerBase.prototype._didEnter = function (view) {
        (void 0) /* assert */;
        (void 0) /* assert */;
        try {
            view._didEnter();
            this.viewDidEnter.emit(view);
            this._app.viewDidEnter.emit(view);
        }
        catch (e) {
            this._errHandler && this._errHandler.handleError(e);
        }
    };
    NavControllerBase.prototype._willLeave = function (view, willUnload) {
        (void 0) /* assert */;
        (void 0) /* assert */;
        try {
            view._willLeave(willUnload);
            this.viewWillLeave.emit(view);
            this._app.viewWillLeave.emit(view);
        }
        catch (e) {
            this._errHandler && this._errHandler.handleError(e);
        }
    };
    NavControllerBase.prototype._didLeave = function (view) {
        (void 0) /* assert */;
        (void 0) /* assert */;
        try {
            view._didLeave();
            this.viewDidLeave.emit(view);
            this._app.viewDidLeave.emit(view);
        }
        catch (e) {
            this._errHandler && this._errHandler.handleError(e);
        }
    };
    NavControllerBase.prototype._willUnload = function (view) {
        (void 0) /* assert */;
        (void 0) /* assert */;
        try {
            view._willUnload();
            this.viewWillUnload.emit(view);
            this._app.viewWillUnload.emit(view);
        }
        catch (e) {
            this._errHandler && this._errHandler.handleError(e);
        }
    };
    NavControllerBase.prototype.hasChildren = function () {
        return this._children && this._children.length > 0;
    };
    NavControllerBase.prototype.getActiveChildNavs = function () {
        return this._children;
    };
    NavControllerBase.prototype.getAllChildNavs = function () {
        return this._children;
    };
    NavControllerBase.prototype.registerChildNav = function (container) {
        this._children.push(container);
    };
    NavControllerBase.prototype.unregisterChildNav = function (nav) {
        this._children = this._children.filter(function (child) { return child !== nav; });
    };
    NavControllerBase.prototype.destroy = function () {
        var views = this._views;
        var view;
        for (var i = 0; i < views.length; i++) {
            view = views[i];
            view._willUnload();
            view._destroy(this._renderer);
        }
        // release swipe back gesture and transition
        this._sbGesture && this._sbGesture.destroy();
        this._sbTrns && this._sbTrns.destroy();
        this._queue = this._views = this._sbGesture = this._sbTrns = null;
        // Unregister navcontroller
        if (this.parent && this.parent.unregisterChildNav) {
            this.parent.unregisterChildNav(this);
        }
        else if (this._app) {
            this._app.unregisterRootNav(this);
        }
        this._destroyed = true;
    };
    NavControllerBase.prototype.swipeBackStart = function () {
        if (this.isTransitioning() || this._queue.length > 0) {
            return;
        }
        // default the direction to "back";
        var opts = {
            direction: __WEBPACK_IMPORTED_MODULE_1__nav_util__["a" /* DIRECTION_BACK */],
            progressAnimation: true
        };
        this._queueTrns({
            removeStart: -1,
            removeCount: 1,
            opts: opts,
        }, null);
    };
    NavControllerBase.prototype.swipeBackProgress = function (stepValue) {
        if (this._sbTrns && this._sbGesture) {
            // continue to disable the app while actively dragging
            this._app.setEnabled(false, ACTIVE_TRANSITION_DEFAULT);
            this.setTransitioning(true);
            // set the transition animation's progress
            this._sbTrns.progressStep(stepValue);
        }
    };
    NavControllerBase.prototype.swipeBackEnd = function (shouldComplete, currentStepValue, velocity) {
        if (this._sbTrns && this._sbGesture) {
            // the swipe back gesture has ended
            var dur = this._sbTrns.getDuration() / (Math.abs(velocity) + 1);
            this._sbTrns.progressEnd(shouldComplete, currentStepValue, dur);
        }
    };
    NavControllerBase.prototype._swipeBackCheck = function () {
        if (this.canSwipeBack()) {
            if (!this._sbGesture) {
                this._sbGesture = new __WEBPACK_IMPORTED_MODULE_7__swipe_back__["a" /* SwipeBackGesture */](this.plt, this, this._gestureCtrl, this._domCtrl);
            }
            this._sbGesture.listen();
        }
        else if (this._sbGesture) {
            this._sbGesture.unlisten();
        }
    };
    NavControllerBase.prototype.canSwipeBack = function () {
        return (this._sbEnabled &&
            !this._isPortal &&
            !this._children.length &&
            !this.isTransitioning() &&
            this._app.isEnabled() &&
            this.canGoBack());
    };
    NavControllerBase.prototype.canGoBack = function () {
        var activeView = this.getActive();
        return !!(activeView && activeView.enableBack());
    };
    NavControllerBase.prototype.isTransitioning = function () {
        return this._trnsTm;
    };
    NavControllerBase.prototype.setTransitioning = function (isTransitioning) {
        this._trnsTm = isTransitioning;
    };
    NavControllerBase.prototype.getActive = function () {
        return this._views[this._views.length - 1];
    };
    NavControllerBase.prototype.isActive = function (view) {
        return (view === this.getActive());
    };
    NavControllerBase.prototype.getByIndex = function (index) {
        return this._views[index];
    };
    NavControllerBase.prototype.getPrevious = function (view) {
        // returns the view controller which is before the given view controller.
        if (!view) {
            view = this.getActive();
        }
        var views = this._views;
        var index = views.indexOf(view);
        return (index > 0) ? views[index - 1] : null;
    };
    NavControllerBase.prototype.first = function () {
        // returns the first view controller in this nav controller's stack.
        return this._views[0];
    };
    NavControllerBase.prototype.last = function () {
        // returns the last page in this nav controller's stack.
        var views = this._views;
        return views[views.length - 1];
    };
    NavControllerBase.prototype.indexOf = function (view) {
        // returns the index number of the given view controller.
        return this._views.indexOf(view);
    };
    NavControllerBase.prototype.length = function () {
        return this._views.length;
    };
    NavControllerBase.prototype.getViews = function () {
        return this._views;
    };
    /**
     * Return a view controller
     */
    NavControllerBase.prototype.getViewById = function (id) {
        for (var _i = 0, _a = this._views; _i < _a.length; _i++) {
            var vc = _a[_i];
            if (vc && vc.id === id) {
                return vc;
            }
        }
        return null;
    };
    NavControllerBase.prototype.isSwipeBackEnabled = function () {
        return this._sbEnabled;
    };
    NavControllerBase.prototype.dismissPageChangeViews = function () {
        for (var _i = 0, _a = this._views; _i < _a.length; _i++) {
            var view = _a[_i];
            if (view.data && view.data.dismissOnPageChange) {
                view.dismiss().catch(function () { });
            }
        }
    };
    NavControllerBase.prototype.setViewport = function (val) {
        this._viewport = val;
    };
    NavControllerBase.prototype.resize = function () {
        var active = this.getActive();
        if (!active) {
            return;
        }
        var content = active.getIONContent();
        content && content.resize();
    };
    NavControllerBase.prototype.goToRoot = function (_opts) {
        return Promise.reject(new Error('goToRoot needs to be implemented by child class'));
    };
    /*
     * @private
     */
    NavControllerBase.prototype.getType = function () {
        return 'nav';
    };
    /*
     * @private
     */
    NavControllerBase.prototype.getSecondaryIdentifier = function () {
        return null;
    };
    /**
     * Returns the active child navigation.
     */
    NavControllerBase.prototype.getActiveChildNav = function () {
        console.warn('(getActiveChildNav) is deprecated and will be removed in the next major release. Use getActiveChildNavs instead.');
        return this._children[this._children.length - 1];
    };
    NavControllerBase.propDecorators = {
        'swipeBackEnabled': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return NavControllerBase;
}(__WEBPACK_IMPORTED_MODULE_4__components_ion__["a" /* Ion */]));

var ctrlIds = -1;
var DISABLE_APP_MINIMUM_DURATION = 64;
var ACTIVE_TRANSITION_DEFAULT = 5000;
var ACTIVE_TRANSITION_OFFSET = 2000;
//# sourceMappingURL=nav-controller-base.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/navigation/nav-controller.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NavController; });
/**
 * @name NavController
 * @description
 *
 * NavController is the base class for navigation controller components like
 * [`Nav`](../../components/nav/Nav/) and [`Tab`](../../components/tabs/Tab/). You use navigation controllers
 * to navigate to [pages](#view-creation) in your app. At a basic level, a
 * navigation controller is an array of pages representing a particular history
 * (of a Tab for example). This array can be manipulated to navigate throughout
 * an app by pushing and popping pages or inserting and removing them at
 * arbitrary locations in history.
 *
 * The current page is the last one in the array, or the top of the stack if we
 * think of it that way. [Pushing](#push) a new page onto the top of the
 * navigation stack causes the new page to be animated in, while [popping](#pop)
 * the current page will navigate to the previous page in the stack.
 *
 * Unless you are using a directive like [NavPush](../../components/nav/NavPush/), or need a
 * specific NavController, most times you will inject and use a reference to the
 * nearest NavController to manipulate the navigation stack.
 *
 * ## Basic usage
 * The simplest way to navigate through an app is to create and initialize a new
 * nav controller using the `<ion-nav>` component.  `ion-nav` extends the `NavController`
 * class.
 *
 * ```typescript
 * import { Component } from `@angular/core`;
 * import { StartPage } from './start-page';
 *
 * @Component(
 *   template: `<ion-nav [root]="rootPage"></ion-nav>`
 * })
 * class MyApp {
 *   // set the rootPage to the first page we want displayed
 *   public rootPage: any = StartPage;
 *
 *   constructor(){
 *   }
 * }
 *
 * ```
 *
 * ### Injecting NavController
 * Injecting NavController will always get you an instance of the nearest
 * NavController, regardless of whether it is a Tab or a Nav.
 *
 * Behind the scenes, when Ionic instantiates a new NavController, it creates an
 * injector with NavController bound to that instance (usually either a Nav or
 * Tab) and adds the injector to its own providers.  For more information on
 * providers and dependency injection, see [Dependency Injection](https://angular.io/docs/ts/latest/guide/dependency-injection.html).
 *
 * Instead, you can inject NavController and know that it is the correct
 * navigation controller for most situations (for more advanced situations, see
 * [Menu](../../menu/Menu/) and [Tab](../../tab/Tab/)).
 *
 * ```ts
 *  import { NavController } from 'ionic-angular';
 *
 *  class MyComponent {
 *    constructor(public navCtrl: NavController) {
 *
 *    }
 *  }
 * ```
 *
 * ### Navigating from the Root component
 * What if you want to control navigation from your root app component?
 * You can't inject `NavController` because any components that are navigation
 * controllers are _children_ of the root component so they aren't available
 * to be injected.
 *
 * By adding a reference variable to the `ion-nav`, you can use `@ViewChild` to
 * get an instance of the `Nav` component, which is a navigation controller
 * (it extends `NavController`):
 *
 * ```typescript
 *
 * import { Component, ViewChild } from '@angular/core';
 * import { NavController } from 'ionic-angular';
 *
 * @Component({
 *    template: '<ion-nav #myNav [root]="rootPage"></ion-nav>'
 * })
 * export class MyApp {
 *    @ViewChild('myNav') nav: NavController
 *    public rootPage: any = TabsPage;
 *
 *    // Wait for the components in MyApp's template to be initialized
 *    // In this case, we are waiting for the Nav with reference variable of "#myNav"
 *    ngOnInit() {
 *       // Let's navigate from TabsPage to Page1
 *       this.nav.push(Page1);
 *    }
 * }
 * ```
 *
 * ### Navigating from an Overlay Component
 * What if you wanted to navigate from an overlay component (popover, modal, alert, etc)?
 * In this example, we've displayed a popover in our app. From the popover, we'll get a
 * reference of the root `NavController` in our app, using the `getRootNav()` method.
 *
 *
 * ```typescript
 * import { Component } from '@angular/core';
 * import { App, ViewController } from 'ionic-angular';
 *
 * @Component({
 *     template: `
 *     <ion-content>
 *       <h1>My PopoverPage</h1>
 *       <button ion-button (click)="pushPage()">Call pushPage</button>
 *      </ion-content>
 *     `
 *   })
 *   class PopoverPage {
 *     constructor(
 *       public viewCtrl: ViewController
 *       public appCtrl: App
 *     ) {}
 *
 *     pushPage() {
 *       this.viewCtrl.dismiss();
 *       this.appCtrl.getRootNav().push(SecondPage);
 *     }
 *   }
 *```
 *
 *
 * ## View creation
 * Views are created when they are added to the navigation stack.  For methods
 * like [push()](#push), the NavController takes any component class that is
 * decorated with `@Component` as its first argument.  The NavController then
 * compiles that component, adds it to the app and animates it into view.
 *
 * By default, pages are cached and left in the DOM if they are navigated away
 * from but still in the navigation stack (the exiting page on a `push()` for
 * example).  They are destroyed when removed from the navigation stack (on
 * [pop()](#pop) or [setRoot()](#setRoot)).
 *
 * ## Pushing a View
 * To push a new view onto the navigation stack, use the `push` method.
 * If the page has an [`<ion-navbar>`](../../components/toolbar/Navbar/),
 * a back button will automatically be added to the pushed view.
 *
 * Data can also be passed to a view by passing an object to the `push` method.
 * The pushed view can then receive the data by accessing it via the `NavParams`
 * class.
 *
 * ```typescript
 * import { Component } from '@angular/core';
 * import { NavController } from 'ionic-angular';
 * import { OtherPage } from './other-page';
 * @Component({
 *    template: `
 *    <ion-header>
 *      <ion-navbar>
 *        <ion-title>Login</ion-title>
 *      </ion-navbar>
 *    </ion-header>
 *
 *    <ion-content>
 *      <button ion-button (click)="pushPage()">
 *        Go to OtherPage
 *      </button>
 *    </ion-content>
 *    `
 * })
 * export class StartPage {
 *   constructor(public navCtrl: NavController) {
 *   }
 *
 *   pushPage(){
 *     // push another page onto the navigation stack
 *     // causing the nav controller to transition to the new page
 *     // optional data can also be passed to the pushed page.
 *     this.navCtrl.push(OtherPage, {
 *       id: "123",
 *       name: "Carl"
 *     });
 *   }
 * }
 *
 * import { NavParams } from 'ionic-angular';
 *
 * @Component({
 *   template: `
 *   <ion-header>
 *     <ion-navbar>
 *       <ion-title>Other Page</ion-title>
 *     </ion-navbar>
 *   </ion-header>
 *   <ion-content>I'm the other page!</ion-content>`
 * })
 * class OtherPage {
 *   constructor(private navParams: NavParams) {
 *      let id = navParams.get('id');
 *      let name = navParams.get('name');
 *   }
 * }
 * ```
 *
 * ## Removing a view
 * To remove a view from the stack, use the `pop` method.
 * Popping a view will transition to the previous view.
 *
 * ```ts
 * import { Component } from '@angular/core';
 * import { NavController } from 'ionic-angular';
 *
 * @Component({
 *   template: `
 *   <ion-header>
 *     <ion-navbar>
 *       <ion-title>Other Page</ion-title>
 *     </ion-navbar>
 *   </ion-header>
 *   <ion-content>I'm the other page!</ion-content>`
 * })
 * class OtherPage {
 *    constructor(public navCtrl: NavController ){
 *    }
 *
 *    popView(){
 *      this.navCtrl.pop();
 *    }
 * }
 * ```
 *
 * ## Lifecycle events
 * Lifecycle events are fired during various stages of navigation.  They can be
 * defined in any component type which is pushed/popped from a `NavController`.
 *
 * ```ts
 * import { Component } from '@angular/core';
 *
 * @Component({
 *   template: 'Hello World'
 * })
 * class HelloWorld {
 *   ionViewDidLoad() {
 *     console.log("I'm alive!");
 *   }
 *   ionViewWillLeave() {
 *     console.log("Looks like I'm about to leave :(");
 *   }
 * }
 * ```
 *
 *  | Page Event          | Returns                     | Description                                                                                                                                                                                                                                                    |
 *  |---------------------|-----------------------------|----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------|
 *  | `ionViewDidLoad`    | void                        | Runs when the page has loaded. This event only happens once per page being created. If a page leaves but is cached, then this event will not fire again on a subsequent viewing. The `ionViewDidLoad` event is good place to put your setup code for the page. |
 *  | `ionViewWillEnter`  | void                        | Runs when the page is about to enter and become the active page.                                                                                                                                                                                               |
 *  | `ionViewDidEnter`   | void                        | Runs when the page has fully entered and is now the active page. This event will fire, whether it was the first load or a cached page.                                                                                                                         |
 *  | `ionViewWillLeave`  | void                        | Runs when the page is about to leave and no longer be the active page.                                                                                                                                                                                         |
 *  | `ionViewDidLeave`   | void                        | Runs when the page has finished leaving and is no longer the active page.                                                                                                                                                                                      |
 *  | `ionViewWillUnload` | void                        | Runs when the page is about to be destroyed and have its elements removed.                                                                                                                                                                                     |
 *  | `ionViewCanEnter`   | boolean/Promise&lt;void&gt; | Runs before the view can enter. This can be used as a sort of "guard" in authenticated views where you need to check permissions before the view can enter                                                                                                     |
 *  | `ionViewCanLeave`   | boolean/Promise&lt;void&gt; | Runs before the view can leave. This can be used as a sort of "guard" in authenticated views where you need to check permissions before the view can leave                                                                                                     |
 *
 * Those events are only fired on IonicPage, for classic Angular Component, use [Angular Lifecycle Hooks](https://angular.io/guide/lifecycle-hooks).
 *
 * ## Nav Guards
 *
 * In some cases, a developer should be able to control views leaving and entering. To allow for this, NavController has the `ionViewCanEnter` and `ionViewCanLeave` methods.
 * Similar to Angular route guards, but are more integrated with NavController. For example, if you wanted to prevent a user from leaving a view:
 *
 * ```ts
 * export class MyClass{
 *  constructor(
 *    public navCtrl: NavController
 *   ){}
 *
 *   pushPage(){
 *     this.navCtrl.push(DetailPage);
 *   }
 *
 *   ionViewCanLeave(): boolean{
 *    // here we can either return true or false
 *    // depending on if we want to leave this view
 *    if(isValid(randomValue)){
 *       return true;
 *     } else {
 *       return false;
 *     }
 *   }
 * }
 * ```
 *
 * We need to make sure that our `navCtrl.push` has a catch in order to catch the and handle the error.
 * If you need to prevent a view from entering, you can do the same thing
 *
 * ```ts
 * export class MyClass{
 *  constructor(
 *    public navCtrl: NavController
 *   ){}
 *
 *   pushPage(){
 *     this.navCtrl.push(DetailPage);
 *   }
 *
 * }
 *
 * export class DetailPage(){
 *   constructor(
 *     public navCtrl: NavController
 *   ){}
 *   ionViewCanEnter(): boolean{
 *    // here we can either return true or false
 *    // depending on if we want to enter this view
 *    if(isValid(randomValue)){
 *       return true;
 *     } else {
 *       return false;
 *     }
 *   }
 * }
 * ```
 *
 * Similar to `ionViewCanLeave` we still need a catch on the original `navCtrl.push` in order to handle it properly.
 * When handling the back button in the `ion-navbar`, the catch is already taken care of for you by the framework.
 *
 * ## NavOptions
 *
 * Some methods on `NavController` allow for customizing the current transition.
 * To do this, we can pass an object with the modified properites.
 *
 *
 * | Property  | Value     | Description                                                                                                |
 * |-----------|-----------|------------------------------------------------------------------------------------------------------------|
 * | animate   | `boolean` | Whether or not the transition should animate.                                                              |
 * | animation | `string`  | What kind of animation should be used.                                                                     |
 * | direction | `string`  | The conceptual direction the user is navigating. For example, is the user navigating `forward`, or `back`? |
 * | duration  | `number`  | The length in milliseconds the animation should take.                                                      |
 * | easing    | `string`  | The easing for the animation.                                                                              |
 *
 * The property 'animation' understands the following values: `md-transition`, `ios-transition` and `wp-transition`.
 *
 * @see {@link /docs/components#navigation Navigation Component Docs}
 */
var NavController = (function () {
    function NavController() {
    }
    return NavController;
}());

//# sourceMappingURL=nav-controller.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/navigation/nav-params.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NavParams; });
/**
 * @name NavParams
 * @description
 * NavParams are an object that exists on a page and can contain data for that particular view.
 * Similar to how data was pass to a view in V1 with `$stateParams`, NavParams offer a much more flexible
 * option with a simple `get` method.
 *
 * @usage
 * ```ts
 * import { NavParams } from 'ionic-angular';
 *
 * export class MyClass{
 *
 *  constructor(navParams: NavParams){
 *    // userParams is an object we have in our nav-parameters
 *    navParams.get('userParams');
 *  }
 *
 * }
 * ```
 * @demo /docs/demos/src/nav-params/
 * @see {@link /docs/components#navigation Navigation Component Docs}
 * @see {@link ../NavController/ NavController API Docs}
 * @see {@link /docs/api/components/nav/Nav/ Nav API Docs}
 * @see {@link /docs/api/components/nav/NavPush/ NavPush API Docs}
 */
var NavParams = (function () {
    /**
     * @hidden
     * @param {TODO} data  TODO
     */
    function NavParams(data) {
        if (data === void 0) { data = {}; }
        this.data = data;
    }
    /**
     * Get the value of a nav-parameter for the current view
     *
     * ```ts
     * import { NavParams } from 'ionic-angular';
     *
     * export class MyClass{
     *  constructor(public navParams: NavParams){
     *    // userParams is an object we have in our nav-parameters
     *    this.navParams.get('userParams');
     *  }
     * }
     * ```
     *
     *
     * @param {string} param Which param you want to look up
     */
    NavParams.prototype.get = function (param) {
        return this.data[param];
    };
    return NavParams;
}());

//# sourceMappingURL=nav-params.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/navigation/nav-util.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["l"] = getComponent;
/* unused harmony export convertToView */
/* harmony export (immutable) */ __webpack_exports__["k"] = convertToViews;
/* harmony export (immutable) */ __webpack_exports__["p"] = setZIndex;
/* harmony export (immutable) */ __webpack_exports__["o"] = isTabs;
/* harmony export (immutable) */ __webpack_exports__["n"] = isTab;
/* harmony export (immutable) */ __webpack_exports__["m"] = isNav;
/* unused harmony export linkToSegment */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DeepLinkMetadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DeepLinkMetadataFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return STATE_NEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return STATE_INITIALIZED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return STATE_ATTACHED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return STATE_DESTROYED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return INIT_ZINDEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DIRECTION_BACK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DIRECTION_FORWARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DIRECTION_SWITCH; });
/* unused harmony export NAV */
/* unused harmony export TABS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__view_controller__ = __webpack_require__("./node_modules/ionic-angular/navigation/view-controller.js");


function getComponent(linker, nameOrPageOrView, params) {
    if (typeof nameOrPageOrView === 'function') {
        return Promise.resolve(new __WEBPACK_IMPORTED_MODULE_1__view_controller__["a" /* ViewController */](nameOrPageOrView, params));
    }
    if (typeof nameOrPageOrView === 'string') {
        return linker.getComponentFromName(nameOrPageOrView).then(function (component) {
            var vc = new __WEBPACK_IMPORTED_MODULE_1__view_controller__["a" /* ViewController */](component, params);
            vc.id = nameOrPageOrView;
            return vc;
        });
    }
    return Promise.resolve(null);
}
function convertToView(linker, nameOrPageOrView, params) {
    if (nameOrPageOrView) {
        if (Object(__WEBPACK_IMPORTED_MODULE_1__view_controller__["b" /* isViewController */])(nameOrPageOrView)) {
            // is already a ViewController
            return Promise.resolve(nameOrPageOrView);
        }
        return getComponent(linker, nameOrPageOrView, params);
    }
    return Promise.resolve(null);
}
function convertToViews(linker, pages) {
    var views = [];
    if (Object(__WEBPACK_IMPORTED_MODULE_0__util_util__["e" /* isArray */])(pages)) {
        for (var i = 0; i < pages.length; i++) {
            var page = pages[i];
            if (page) {
                if (Object(__WEBPACK_IMPORTED_MODULE_1__view_controller__["b" /* isViewController */])(page)) {
                    views.push(page);
                }
                else if (page.page) {
                    views.push(convertToView(linker, page.page, page.params));
                }
                else {
                    views.push(convertToView(linker, page, null));
                }
            }
        }
    }
    return Promise.all(views);
}
var portalZindex = 9999;
function setZIndex(nav, enteringView, leavingView, direction, renderer) {
    if (enteringView) {
        if (nav._isPortal) {
            if (direction === DIRECTION_FORWARD) {
                enteringView._setZIndex(nav._zIndexOffset + portalZindex, renderer);
            }
            portalZindex++;
            return;
        }
        leavingView = leavingView || nav.getPrevious(enteringView);
        if (leavingView && Object(__WEBPACK_IMPORTED_MODULE_0__util_util__["l" /* isPresent */])(leavingView._zIndex)) {
            if (direction === DIRECTION_BACK) {
                enteringView._setZIndex(leavingView._zIndex - 1, renderer);
            }
            else {
                enteringView._setZIndex(leavingView._zIndex + 1, renderer);
            }
        }
        else {
            enteringView._setZIndex(INIT_ZINDEX + nav._zIndexOffset, renderer);
        }
    }
}
function isTabs(nav) {
    // Tabs (ion-tabs)
    return !!nav && !!nav.getSelected;
}
function isTab(nav) {
    // Tab (ion-tab)
    return !!nav && Object(__WEBPACK_IMPORTED_MODULE_0__util_util__["l" /* isPresent */])(nav._tabId);
}
function isNav(nav) {
    // Nav (ion-nav), Tab (ion-tab), Portal (ion-portal)
    return !!nav && !!nav.push && nav.getType() === 'nav';
}
function linkToSegment(navId, type, secondaryId, link) {
    var segment = Object.assign({}, link);
    segment.navId = navId;
    segment.type = type;
    segment.secondaryId = secondaryId;
    return segment;
}
/**
 * @hidden
 */
var DeepLinkMetadata = (function () {
    function DeepLinkMetadata() {
    }
    return DeepLinkMetadata;
}());

/**
 * @hidden
 */
var DeepLinkMetadataFactory;
var STATE_NEW = 1;
var STATE_INITIALIZED = 2;
var STATE_ATTACHED = 3;
var STATE_DESTROYED = 4;
var INIT_ZINDEX = 100;
var DIRECTION_BACK = 'back';
var DIRECTION_FORWARD = 'forward';
var DIRECTION_SWITCH = 'switch';
var NAV = 'nav';
var TABS = 'tabs';
//# sourceMappingURL=nav-util.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/navigation/overlay-proxy.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OverlayProxy; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");

var OverlayProxy = (function () {
    function OverlayProxy(_app, _component, _config, _deepLinker) {
        this._app = _app;
        this._component = _component;
        this._config = _config;
        this._deepLinker = _deepLinker;
    }
    OverlayProxy.prototype.getImplementation = function () {
        throw new Error('Child class must implement "getImplementation" method');
    };
    /**
     * Present the modal instance.
     *
     * @param {NavOptions} [navOptions={}] Nav options to go with this transition.
     * @returns {Promise} Returns a promise which is resolved when the transition has completed.
     */
    OverlayProxy.prototype.present = function (navOptions) {
        var _this = this;
        if (navOptions === void 0) { navOptions = {}; }
        // check if it's a lazy loaded component, or not
        var isLazyLoaded = Object(__WEBPACK_IMPORTED_MODULE_0__util_util__["n" /* isString */])(this._component);
        if (isLazyLoaded) {
            return this._deepLinker.getComponentFromName(this._component).then(function (loadedComponent) {
                _this._component = loadedComponent;
                return _this.createAndPresentOverlay(navOptions);
            });
        }
        else {
            return this.createAndPresentOverlay(navOptions);
        }
    };
    OverlayProxy.prototype.dismiss = function (data, role, navOptions) {
        if (this.overlay) {
            return this.overlay.dismiss(data, role, navOptions);
        }
    };
    /**
     * Called when the current viewController has be successfully dismissed
     */
    OverlayProxy.prototype.onDidDismiss = function (callback) {
        this._onDidDismiss = callback;
        if (this.overlay) {
            this.overlay.onDidDismiss(this._onDidDismiss);
        }
    };
    OverlayProxy.prototype.createAndPresentOverlay = function (navOptions) {
        this.overlay = this.getImplementation();
        this.overlay.onWillDismiss(this._onWillDismiss);
        this.overlay.onDidDismiss(this._onDidDismiss);
        return this.overlay.present(navOptions);
    };
    /**
     * Called when the current viewController will be dismissed
     */
    OverlayProxy.prototype.onWillDismiss = function (callback) {
        this._onWillDismiss = callback;
        if (this.overlay) {
            this.overlay.onWillDismiss(this._onWillDismiss);
        }
    };
    return OverlayProxy;
}());

//# sourceMappingURL=overlay-proxy.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/navigation/swipe-back.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SwipeBackGesture; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gestures_gesture_controller__ = __webpack_require__("./node_modules/ionic-angular/gestures/gesture-controller.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gestures_slide_edge_gesture__ = __webpack_require__("./node_modules/ionic-angular/gestures/slide-edge-gesture.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



/**
 * @hidden
 */
var SwipeBackGesture = (function (_super) {
    __extends(SwipeBackGesture, _super);
    function SwipeBackGesture(plt, _nav, gestureCtlr, domCtrl) {
        var _this = _super.call(this, plt, plt.doc().body, {
            direction: 'x',
            edge: 'start',
            maxEdgeStart: 75,
            threshold: 5,
            zone: false,
            domController: domCtrl,
            gesture: gestureCtlr.createGesture({
                name: __WEBPACK_IMPORTED_MODULE_1__gestures_gesture_controller__["c" /* GESTURE_GO_BACK_SWIPE */],
                priority: __WEBPACK_IMPORTED_MODULE_1__gestures_gesture_controller__["f" /* GESTURE_PRIORITY_GO_BACK_SWIPE */],
                disableScroll: true
            })
        }) || this;
        _this._nav = _nav;
        return _this;
    }
    SwipeBackGesture.prototype.canStart = function (ev) {
        // the gesture swipe angle must be mainly horizontal and the
        // gesture distance would be relatively short for a swipe back
        // and swipe back must be possible on this nav controller
        return (this._nav.canSwipeBack() &&
            _super.prototype.canStart.call(this, ev));
    };
    SwipeBackGesture.prototype.onSlideBeforeStart = function (_ev) {
        this._nav.swipeBackStart();
    };
    SwipeBackGesture.prototype.onSlide = function (slide, ev) {
        ev.preventDefault();
        ev.stopPropagation();
        var stepValue = (slide.distance / slide.max);
        this._nav.swipeBackProgress(stepValue);
    };
    SwipeBackGesture.prototype.onSlideEnd = function (slide, _ev) {
        var velocity = slide.velocity;
        var currentStepValue = (slide.distance / slide.max);
        var isResetDirecction = velocity < 0;
        var isMovingFast = Math.abs(slide.velocity) > 0.4;
        var isInResetZone = Math.abs(slide.delta) < Math.abs(slide.max) * 0.5;
        var shouldComplete = !Object(__WEBPACK_IMPORTED_MODULE_0__util_util__["u" /* swipeShouldReset */])(isResetDirecction, isMovingFast, isInResetZone);
        this._nav.swipeBackEnd(shouldComplete, currentStepValue, velocity);
    };
    return SwipeBackGesture;
}(__WEBPACK_IMPORTED_MODULE_2__gestures_slide_edge_gesture__["a" /* SlideEdgeGesture */]));

//# sourceMappingURL=swipe-back.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/navigation/url-serializer.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UrlSerializer; });
/* harmony export (immutable) */ __webpack_exports__["c"] = formatUrlPart;
/* unused harmony export isPartMatch */
/* unused harmony export createMatchedData */
/* unused harmony export findLinkByComponentData */
/* unused harmony export normalizeLinks */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DeepLinkConfigToken; });
/* harmony export (immutable) */ __webpack_exports__["d"] = setupUrlSerializer;
/* unused harmony export navGroupStringtoObjects */
/* unused harmony export urlToNavGroupStrings */
/* unused harmony export convertUrlToSegments */
/* unused harmony export convertUrlToDehydratedSegments */
/* unused harmony export hydrateSegmentsWithNav */
/* unused harmony export getNavFromNavGroup */
/* unused harmony export getSegmentsFromNavGroups */
/* unused harmony export getSegmentsFromUrlPieces */
/* unused harmony export hydrateSegment */
/* unused harmony export getNonHydratedSegmentIfLinkAndUrlMatch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");


/**
 * @hidden
 */
var UrlSerializer = (function () {
    function UrlSerializer(_app, config) {
        this._app = _app;
        if (config && Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["e" /* isArray */])(config.links)) {
            this.links = normalizeLinks(config.links);
        }
        else {
            this.links = [];
        }
    }
    /**
     * Parse the URL into a Path, which is made up of multiple NavSegments.
     * Match which components belong to each segment.
     */
    UrlSerializer.prototype.parse = function (browserUrl) {
        if (browserUrl.charAt(0) === '/') {
            browserUrl = browserUrl.substr(1);
        }
        // trim off data after ? and #
        browserUrl = browserUrl.split('?')[0].split('#')[0];
        return convertUrlToSegments(this._app, browserUrl, this.links);
    };
    UrlSerializer.prototype.createSegmentFromName = function (navContainer, nameOrComponent) {
        var configLink = this.getLinkFromName(nameOrComponent);
        if (configLink) {
            return this._createSegment(this._app, navContainer, configLink, null);
        }
        return null;
    };
    UrlSerializer.prototype.getLinkFromName = function (nameOrComponent) {
        return this.links.find(function (link) {
            return (link.component === nameOrComponent) ||
                (link.name === nameOrComponent);
        });
    };
    /**
     * Serialize a path, which is made up of multiple NavSegments,
     * into a URL string. Turn each segment into a string and concat them to a URL.
     */
    UrlSerializer.prototype.serialize = function (segments) {
        if (!segments || !segments.length) {
            return '/';
        }
        var sections = segments.map(function (segment) {
            if (segment.type === 'tabs') {
                if (segment.requiresExplicitNavPrefix) {
                    return "/" + segment.type + "/" + segment.navId + "/" + segment.secondaryId + "/" + segment.id;
                }
                return "/" + segment.secondaryId + "/" + segment.id;
            }
            // it's a nav
            if (segment.requiresExplicitNavPrefix) {
                return "/" + segment.type + "/" + segment.navId + "/" + segment.id;
            }
            return "/" + segment.id;
        });
        return sections.join('');
    };
    /**
     * Serializes a component and its data into a NavSegment.
     */
    UrlSerializer.prototype.serializeComponent = function (navContainer, component, data) {
        if (component) {
            var link = findLinkByComponentData(this.links, component, data);
            if (link) {
                return this._createSegment(this._app, navContainer, link, data);
            }
        }
        return null;
    };
    /**
   * @internal
   */
    UrlSerializer.prototype._createSegment = function (app, navContainer, configLink, data) {
        var urlParts = configLink.segmentParts;
        if (Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["l" /* isPresent */])(data)) {
            // create a copy of the original parts in the link config
            urlParts = urlParts.slice();
            // loop through all the data and convert it to a string
            var keys = Object.keys(data);
            var keysLength = keys.length;
            if (keysLength) {
                for (var i = 0; i < urlParts.length; i++) {
                    if (urlParts[i].charAt(0) === ':') {
                        for (var j = 0; j < keysLength; j++) {
                            if (urlParts[i] === ":" + keys[j]) {
                                // this data goes into the URL part (between slashes)
                                urlParts[i] = encodeURIComponent(data[keys[j]]);
                                break;
                            }
                        }
                    }
                }
            }
        }
        var requiresExplicitPrefix = true;
        if (navContainer.parent) {
            requiresExplicitPrefix = navContainer.parent && navContainer.parent.getAllChildNavs().length > 1;
        }
        else {
            // if it's a root nav, and there are multiple root navs, we need an explicit prefix
            requiresExplicitPrefix = app.getRootNavById(navContainer.id) && app.getRootNavs().length > 1;
        }
        return {
            id: urlParts.join('/'),
            name: configLink.name,
            component: configLink.component,
            loadChildren: configLink.loadChildren,
            data: data,
            defaultHistory: configLink.defaultHistory,
            navId: navContainer.name || navContainer.id,
            type: navContainer.getType(),
            secondaryId: navContainer.getSecondaryIdentifier(),
            requiresExplicitNavPrefix: requiresExplicitPrefix
        };
    };
    return UrlSerializer;
}());

function formatUrlPart(name) {
    name = name.replace(URL_REPLACE_REG, '-');
    name = name.charAt(0).toLowerCase() + name.substring(1).replace(/[A-Z]/g, function (match) {
        return '-' + match.toLowerCase();
    });
    while (name.indexOf('--') > -1) {
        name = name.replace('--', '-');
    }
    if (name.charAt(0) === '-') {
        name = name.substring(1);
    }
    if (name.substring(name.length - 1) === '-') {
        name = name.substring(0, name.length - 1);
    }
    return encodeURIComponent(name);
}
var isPartMatch = function (urlPart, configLinkPart) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["l" /* isPresent */])(urlPart) && Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["l" /* isPresent */])(configLinkPart)) {
        if (configLinkPart.charAt(0) === ':') {
            return true;
        }
        return (urlPart === configLinkPart);
    }
    return false;
};
var createMatchedData = function (matchedUrlParts, link) {
    var data = null;
    for (var i = 0; i < link.segmentPartsLen; i++) {
        if (link.segmentParts[i].charAt(0) === ':') {
            data = data || {};
            data[link.segmentParts[i].substring(1)] = decodeURIComponent(matchedUrlParts[i]);
        }
    }
    return data;
};
var findLinkByComponentData = function (links, component, instanceData) {
    var foundLink = null;
    var foundLinkDataMatches = -1;
    for (var i = 0; i < links.length; i++) {
        var link = links[i];
        if (link.component === component) {
            // ok, so the component matched, but multiple links can point
            // to the same component, so let's make sure this is the right link
            var dataMatches = 0;
            if (instanceData) {
                var instanceDataKeys = Object.keys(instanceData);
                // this link has data
                for (var j = 0; j < instanceDataKeys.length; j++) {
                    if (Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["l" /* isPresent */])(link.dataKeys[instanceDataKeys[j]])) {
                        dataMatches++;
                    }
                }
            }
            else if (link.dataLen) {
                // this component does not have data but the link does
                continue;
            }
            if (dataMatches >= foundLinkDataMatches) {
                foundLink = link;
                foundLinkDataMatches = dataMatches;
            }
        }
    }
    return foundLink;
};
var normalizeLinks = function (links) {
    for (var i = 0, ilen = links.length; i < ilen; i++) {
        var link = links[i];
        if (Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["f" /* isBlank */])(link.segment)) {
            link.segment = link.name;
        }
        link.dataKeys = {};
        link.segmentParts = link.segment.split('/');
        link.segmentPartsLen = link.segmentParts.length;
        // used for sorting
        link.staticLen = link.dataLen = 0;
        var stillCountingStatic = true;
        for (var j = 0; j < link.segmentPartsLen; j++) {
            if (link.segmentParts[j].charAt(0) === ':') {
                link.dataLen++;
                stillCountingStatic = false;
                link.dataKeys[link.segmentParts[j].substring(1)] = true;
            }
            else if (stillCountingStatic) {
                link.staticLen++;
            }
        }
    }
    // sort by the number of parts, with the links
    // with the most parts first
    return links.sort(sortConfigLinks);
};
function sortConfigLinks(a, b) {
    // sort by the number of parts
    if (a.segmentPartsLen > b.segmentPartsLen) {
        return -1;
    }
    if (a.segmentPartsLen < b.segmentPartsLen) {
        return 1;
    }
    // sort by the number of static parts in a row
    if (a.staticLen > b.staticLen) {
        return -1;
    }
    if (a.staticLen < b.staticLen) {
        return 1;
    }
    // sort by the number of total data parts
    if (a.dataLen < b.dataLen) {
        return -1;
    }
    if (a.dataLen > b.dataLen) {
        return 1;
    }
    return 0;
}
var URL_REPLACE_REG = /\s+|\?|\!|\$|\,|\.|\+|\"|\'|\*|\^|\||\/|\\|\[|\]|#|%|`|>|<|;|:|@|&|=/g;
/**
 * @hidden
 */
var DeepLinkConfigToken = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["InjectionToken"]('USERLINKS');
function setupUrlSerializer(app, userDeepLinkConfig) {
    return new UrlSerializer(app, userDeepLinkConfig);
}
function navGroupStringtoObjects(navGroupStrings) {
    // each string has a known format-ish, convert it to it
    return navGroupStrings.map(function (navGroupString) {
        var sections = navGroupString.split('/');
        if (sections[0] === 'nav') {
            return {
                type: 'nav',
                navId: sections[1],
                niceId: sections[1],
                secondaryId: null,
                segmentPieces: sections.splice(2)
            };
        }
        else if (sections[0] === 'tabs') {
            return {
                type: 'tabs',
                navId: sections[1],
                niceId: sections[1],
                secondaryId: sections[2],
                segmentPieces: sections.splice(3)
            };
        }
        return {
            type: null,
            navId: null,
            niceId: null,
            secondaryId: null,
            segmentPieces: sections
        };
    });
}
function urlToNavGroupStrings(url) {
    var tokens = url.split('/');
    var keywordIndexes = [];
    for (var i = 0; i < tokens.length; i++) {
        if (i !== 0 && (tokens[i] === 'nav' || tokens[i] === 'tabs')) {
            keywordIndexes.push(i);
        }
    }
    // append the last index + 1 to the list no matter what
    keywordIndexes.push(tokens.length);
    var groupings = [];
    var activeKeywordIndex = 0;
    var tmpArray = [];
    for (var i = 0; i < tokens.length; i++) {
        if (i >= keywordIndexes[activeKeywordIndex]) {
            groupings.push(tmpArray.join('/'));
            tmpArray = [];
            activeKeywordIndex++;
        }
        tmpArray.push(tokens[i]);
    }
    // okay, after the loop we've gotta push one more time just to be safe
    groupings.push(tmpArray.join('/'));
    return groupings;
}
function convertUrlToSegments(app, url, navLinks) {
    var pairs = convertUrlToDehydratedSegments(url, navLinks);
    return hydrateSegmentsWithNav(app, pairs);
}
function convertUrlToDehydratedSegments(url, navLinks) {
    var navGroupStrings = urlToNavGroupStrings(url);
    var navGroups = navGroupStringtoObjects(navGroupStrings);
    return getSegmentsFromNavGroups(navGroups, navLinks);
}
function hydrateSegmentsWithNav(app, dehydratedSegmentPairs) {
    var segments = [];
    for (var i = 0; i < dehydratedSegmentPairs.length; i++) {
        var navs = getNavFromNavGroup(dehydratedSegmentPairs[i].navGroup, app);
        // okay, cool, let's walk through the segments and hydrate them
        for (var _i = 0, _a = dehydratedSegmentPairs[i].segments; _i < _a.length; _i++) {
            var dehydratedSegment = _a[_i];
            if (navs.length === 1) {
                segments.push(hydrateSegment(dehydratedSegment, navs[0]));
                navs = navs[0].getActiveChildNavs();
            }
            else if (navs.length > 1) {
                // this is almost certainly an async race condition bug in userland
                // if you're in this state, it would be nice to just bail here
                // but alas we must perservere and handle the issue
                // the simple solution is to just use the last child
                // because that is probably what the user wants anyway
                // remember, do not harm, even if it makes our shizzle ugly
                segments.push(hydrateSegment(dehydratedSegment, navs[navs.length - 1]));
                navs = navs[navs.length - 1].getActiveChildNavs();
            }
            else {
                break;
            }
        }
    }
    return segments;
}
function getNavFromNavGroup(navGroup, app) {
    if (navGroup.navId) {
        var rootNav = app.getNavByIdOrName(navGroup.navId);
        if (rootNav) {
            return [rootNav];
        }
        return [];
    }
    // we don't know what nav to use, so just use the root nav.
    // if there is more than one root nav, throw an error
    return app.getRootNavs();
}
/*
 * Let's face the facts: Getting a dehydrated segment from the url is really hard
 * because we need to do a ton of crazy looping
 * the are chunks of a url that are totally irrelevant at this stage, such as the secondary identifier
 * stating which tab is selected, etc.
 * but is necessary.
 * We look at segment pieces in reverse order to try to build segments
 * as in, if you had an array like this
 * ['my', 'super', 'cool', 'url']
 * we want to look at the pieces in reverse order:
 * url
 * cool url
 * super cool url
 * my super cool url
 * cool
 * super cool
 * my super cool
 * super
 * my super
 * my
 **/
function getSegmentsFromNavGroups(navGroups, navLinks) {
    var pairs = [];
    var usedNavLinks = new Set();
    for (var _i = 0, navGroups_1 = navGroups; _i < navGroups_1.length; _i++) {
        var navGroup = navGroups_1[_i];
        var segments = [];
        var segmentPieces = navGroup.segmentPieces.concat([]);
        for (var i = segmentPieces.length; i >= 0; i--) {
            var created = false;
            for (var j = 0; j < i; j++) {
                var startIndex = i - j - 1;
                var endIndex = i;
                var subsetOfUrl = segmentPieces.slice(startIndex, endIndex);
                for (var _a = 0, navLinks_1 = navLinks; _a < navLinks_1.length; _a++) {
                    var navLink = navLinks_1[_a];
                    if (!usedNavLinks.has(navLink.name)) {
                        var segment = getSegmentsFromUrlPieces(subsetOfUrl, navLink);
                        if (segment) {
                            i = startIndex + 1;
                            usedNavLinks.add(navLink.name);
                            created = true;
                            // sweet, we found a segment
                            segments.push(segment);
                            // now we want to null out the url subsection in the segmentPieces
                            for (var k = startIndex; k < endIndex; k++) {
                                segmentPieces[k] = null;
                            }
                            break;
                        }
                    }
                }
                if (created) {
                    break;
                }
            }
            if (!created && segmentPieces[i - 1]) {
                // this is very likely a tab's secondary identifier
                segments.push({
                    id: null,
                    name: null,
                    secondaryId: segmentPieces[i - 1],
                    component: null,
                    loadChildren: null,
                    data: null,
                    defaultHistory: null
                });
            }
        }
        // since we're getting segments in from right-to-left in the url, reverse them
        // so they're in the correct order. Also filter out and bogus segments
        var orderedSegments = segments.reverse();
        // okay, this is the lazy persons approach here.
        // so here's the deal! Right now if section of the url is not a part of a segment
        // it is almost certainly the secondaryId for a tabs component
        // basically, knowing the segment for the `tab` itself is good, but we also need to know
        // which tab is selected, so we have an identifer in the url that is associated with the tabs component
        // telling us which tab is selected. With that in mind, we are going to go through and find the segments with only secondary identifiers,
        // and simply add the secondaryId to the next segment, and then remove the empty segment from the list
        for (var i = 0; i < orderedSegments.length; i++) {
            if (orderedSegments[i].secondaryId && !orderedSegments[i].id && ((i + 1) <= orderedSegments.length - 1)) {
                orderedSegments[i + 1].secondaryId = orderedSegments[i].secondaryId;
                orderedSegments[i] = null;
            }
        }
        var cleanedSegments = segments.filter(function (segment) { return !!segment; });
        // if the nav group has a secondary id, make sure the first segment also has it set
        if (navGroup.secondaryId && segments.length) {
            cleanedSegments[0].secondaryId = navGroup.secondaryId;
        }
        pairs.push({
            navGroup: navGroup,
            segments: cleanedSegments
        });
    }
    return pairs;
}
function getSegmentsFromUrlPieces(urlSections, navLink) {
    if (navLink.segmentPartsLen !== urlSections.length) {
        return null;
    }
    for (var i = 0; i < urlSections.length; i++) {
        if (!isPartMatch(urlSections[i], navLink.segmentParts[i])) {
            // just return an empty array if the part doesn't match
            return null;
        }
    }
    return {
        id: urlSections.join('/'),
        name: navLink.name,
        component: navLink.component,
        loadChildren: navLink.loadChildren,
        data: createMatchedData(urlSections, navLink),
        defaultHistory: navLink.defaultHistory
    };
}
function hydrateSegment(segment, nav) {
    var hydratedSegment = Object.assign({}, segment);
    hydratedSegment.type = nav.getType();
    hydratedSegment.navId = nav.name || nav.id;
    // secondaryId is set on an empty dehydrated segment in the case of tabs to identify which tab is selected
    hydratedSegment.secondaryId = segment.secondaryId;
    return hydratedSegment;
}
function getNonHydratedSegmentIfLinkAndUrlMatch(urlChunks, navLink) {
    var allSegmentsMatch = true;
    for (var i = 0; i < urlChunks.length; i++) {
        if (!isPartMatch(urlChunks[i], navLink.segmentParts[i])) {
            allSegmentsMatch = false;
            break;
        }
    }
    if (allSegmentsMatch) {
        return {
            id: navLink.segmentParts.join('/'),
            name: navLink.name,
            component: navLink.component,
            loadChildren: navLink.loadChildren,
            data: createMatchedData(urlChunks, navLink),
            defaultHistory: navLink.defaultHistory
        };
    }
    return null;
}
//# sourceMappingURL=url-serializer.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/navigation/view-controller.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ViewController; });
/* harmony export (immutable) */ __webpack_exports__["b"] = isViewController;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nav_util__ = __webpack_require__("./node_modules/ionic-angular/navigation/nav-util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nav_params__ = __webpack_require__("./node_modules/ionic-angular/navigation/nav-params.js");




/**
 * @name ViewController
 * @description
 * Access various features and information about the current view.
 * @usage
 *  ```ts
 * import { Component } from '@angular/core';
 * import { ViewController } from 'ionic-angular';
 *
 * @Component({...})
 * export class MyPage{
 *
 *   constructor(public viewCtrl: ViewController) {}
 *
 * }
 * ```
 */
var ViewController = (function () {
    function ViewController(component, data, rootCssClass) {
        if (rootCssClass === void 0) { rootCssClass = DEFAULT_CSS_CLASS; }
        this.component = component;
        this._isHidden = false;
        this._state = __WEBPACK_IMPORTED_MODULE_2__nav_util__["j" /* STATE_NEW */];
        /**
         * Observable to be subscribed to when the current component will become active
         * @returns {Observable} Returns an observable
         */
        this.willEnter = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
         * Observable to be subscribed to when the current component has become active
         * @returns {Observable} Returns an observable
         */
        this.didEnter = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
         * Observable to be subscribed to when the current component will no longer be active
         * @returns {Observable} Returns an observable
         */
        this.willLeave = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
         * Observable to be subscribed to when the current component is no long active
         * @returns {Observable} Returns an observable
         */
        this.didLeave = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
         * Observable to be subscribed to when the current component has been destroyed
         * @returns {Observable} Returns an observable
         */
        this.willUnload = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
         * @hidden
         */
        this.readReady = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
         * @hidden
         */
        this.writeReady = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /** @hidden */
        this.isOverlay = false;
        /** @hidden */
        this._emitter = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        // passed in data could be NavParams, but all we care about is its data object
        this.data = (data instanceof __WEBPACK_IMPORTED_MODULE_3__nav_params__["a" /* NavParams */] ? data.data : (Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["l" /* isPresent */])(data) ? data : {}));
        this._cssClass = rootCssClass;
        this._ts = Date.now();
        this._bindHandler = this.handleOrientationChange.bind(this);
        window.addEventListener('orientationchange', this._bindHandler);
    }
    ViewController.prototype.handleOrientationChange = function () {
        if (this.getContent()) {
            this.getContent().resize();
        }
    };
    /**
     * @hidden
     */
    ViewController.prototype.init = function (componentRef) {
        (void 0) /* assert */;
        this._ts = Date.now();
        this._cmp = componentRef;
        this.instance = this.instance || componentRef.instance;
        this._detached = false;
    };
    ViewController.prototype._setNav = function (navCtrl) {
        this._nav = navCtrl;
    };
    ViewController.prototype._setInstance = function (instance) {
        this.instance = instance;
    };
    /**
     * @hidden
     */
    ViewController.prototype.subscribe = function (generatorOrNext) {
        return this._emitter.subscribe(generatorOrNext);
    };
    /**
     * @hidden
     */
    ViewController.prototype.emit = function (data) {
        this._emitter.emit(data);
    };
    /**
     * Called when the current viewController has be successfully dismissed
     */
    ViewController.prototype.onDidDismiss = function (callback) {
        this._onDidDismiss = callback;
    };
    /**
     * Called when the current viewController will be dismissed
     */
    ViewController.prototype.onWillDismiss = function (callback) {
        this._onWillDismiss = callback;
    };
    /**
     * Dismiss the current viewController
     * @param {any} [data] Data that you want to return when the viewController is dismissed.
     * @param {any} [role ]
     * @param {NavOptions} navOptions Options for the dismiss navigation.
     * @returns {any} data Returns the data passed in, if any.
     */
    ViewController.prototype.dismiss = function (data, role, navOptions) {
        if (navOptions === void 0) { navOptions = {}; }
        if (!this._nav) {
            (void 0) /* assert */;
            return Promise.resolve(false);
        }
        if (this.isOverlay && !navOptions.minClickBlockDuration) {
            // This is a Modal being dismissed so we need
            // to add the minClickBlockDuration option
            // for UIWebView
            navOptions.minClickBlockDuration = 400;
        }
        this._dismissData = data;
        this._dismissRole = role;
        var options = Object.assign({}, this._leavingOpts, navOptions);
        return this._nav.removeView(this, options).then(function () { return data; });
    };
    /**
     * @hidden
     */
    ViewController.prototype.getNav = function () {
        return this._nav;
    };
    /**
     * @hidden
     */
    ViewController.prototype.getTransitionName = function (_direction) {
        return this._nav && this._nav.config.get('pageTransition');
    };
    /**
     * @hidden
     */
    ViewController.prototype.getNavParams = function () {
        return new __WEBPACK_IMPORTED_MODULE_3__nav_params__["a" /* NavParams */](this.data);
    };
    /**
     * @hidden
     */
    ViewController.prototype.setLeavingOpts = function (opts) {
        this._leavingOpts = opts;
    };
    /**
     * Check to see if you can go back in the navigation stack.
     * @returns {boolean} Returns if it's possible to go back from this Page.
     */
    ViewController.prototype.enableBack = function () {
        // update if it's possible to go back from this nav item
        if (!this._nav) {
            return false;
        }
        // the previous view may exist, but if it's about to be destroyed
        // it shouldn't be able to go back to
        var previousItem = this._nav.getPrevious(this);
        return !!(previousItem);
    };
    Object.defineProperty(ViewController.prototype, "name", {
        /**
         * @hidden
         */
        get: function () {
            return (this.component ? this.component.name : '');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewController.prototype, "index", {
        /**
         * Get the index of the current component in the current navigation stack.
         * @returns {number} Returns the index of this page within its `NavController`.
         */
        get: function () {
            return (this._nav ? this._nav.indexOf(this) : -1);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @returns {boolean} Returns if this Page is the first in the stack of pages within its NavController.
     */
    ViewController.prototype.isFirst = function () {
        return (this._nav ? this._nav.first() === this : false);
    };
    /**
     * @returns {boolean} Returns if this Page is the last in the stack of pages within its NavController.
     */
    ViewController.prototype.isLast = function () {
        return (this._nav ? this._nav.last() === this : false);
    };
    /**
     * @hidden
     * DOM WRITE
     */
    ViewController.prototype._domShow = function (shouldShow, renderer) {
        // using hidden element attribute to display:none and not render views
        // _hidden value of '' means the hidden attribute will be added
        // _hidden value of null means the hidden attribute will be removed
        // doing checks to make sure we only update the DOM when actually needed
        // if it should render, then the hidden attribute should not be on the element
        if (this._cmp && shouldShow === this._isHidden) {
            this._isHidden = !shouldShow;
            var value = (shouldShow ? null : '');
            // ******** DOM WRITE ****************
            renderer.setElementAttribute(this.pageRef().nativeElement, 'hidden', value);
        }
    };
    /**
     * @hidden
     */
    ViewController.prototype.getZIndex = function () {
        return this._zIndex;
    };
    /**
     * @hidden
     * DOM WRITE
     */
    ViewController.prototype._setZIndex = function (zIndex, renderer) {
        if (zIndex !== this._zIndex) {
            this._zIndex = zIndex;
            var pageRef = this.pageRef();
            if (pageRef) {
                // ******** DOM WRITE ****************
                renderer.setElementStyle(pageRef.nativeElement, 'z-index', zIndex);
            }
        }
    };
    /**
     * @returns {ElementRef} Returns the Page's ElementRef.
     */
    ViewController.prototype.pageRef = function () {
        return this._cmp && this._cmp.location;
    };
    ViewController.prototype._setContent = function (directive) {
        this._cntDir = directive;
    };
    /**
     * @returns {component} Returns the Page's Content component reference.
     */
    ViewController.prototype.getContent = function () {
        return this._cntDir;
    };
    ViewController.prototype._setContentRef = function (elementRef) {
        this._cntRef = elementRef;
    };
    /**
     * @returns {ElementRef} Returns the Content's ElementRef.
     */
    ViewController.prototype.contentRef = function () {
        return this._cntRef;
    };
    ViewController.prototype._setIONContent = function (content) {
        this._setContent(content);
        this._ionCntDir = content;
    };
    /**
     * @hidden
     */
    ViewController.prototype.getIONContent = function () {
        return this._ionCntDir;
    };
    ViewController.prototype._setIONContentRef = function (elementRef) {
        this._setContentRef(elementRef);
        this._ionCntRef = elementRef;
    };
    /**
     * @hidden
     */
    ViewController.prototype.getIONContentRef = function () {
        return this._ionCntRef;
    };
    ViewController.prototype._setHeader = function (directive) {
        this._hdrDir = directive;
    };
    /**
     * @hidden
     */
    ViewController.prototype.getHeader = function () {
        return this._hdrDir;
    };
    ViewController.prototype._setFooter = function (directive) {
        this._ftrDir = directive;
    };
    /**
     * @hidden
     */
    ViewController.prototype.getFooter = function () {
        return this._ftrDir;
    };
    ViewController.prototype._setNavbar = function (directive) {
        this._nb = directive;
    };
    /**
     * @hidden
     */
    ViewController.prototype.getNavbar = function () {
        return this._nb;
    };
    /**
     * Find out if the current component has a NavBar or not. Be sure
     * to wrap this in an `ionViewWillEnter` method in order to make sure
     * the view has rendered fully.
     * @returns {boolean} Returns a boolean if this Page has a navbar or not.
     */
    ViewController.prototype.hasNavbar = function () {
        return !!this._nb;
    };
    /**
     * Change the title of the back-button. Be sure to call this
     * after `ionViewWillEnter` to make sure the  DOM has been rendered.
     * @param {string} val Set the back button text.
     */
    ViewController.prototype.setBackButtonText = function (val) {
        this._nb && this._nb.setBackButtonText(val);
    };
    /**
     * Set if the back button for the current view is visible or not. Be sure to call this
     * after `ionViewWillEnter` to make sure the  DOM has been rendered.
     * @param {boolean} Set if this Page's back button should show or not.
     */
    ViewController.prototype.showBackButton = function (shouldShow) {
        if (this._nb) {
            this._nb.hideBackButton = !shouldShow;
        }
    };
    ViewController.prototype._preLoad = function () {
        (void 0) /* assert */;
        this._lifecycle('PreLoad');
    };
    /**
     * @hidden
     * The view has loaded. This event only happens once per view will be created.
     * This event is fired before the component and his children have been initialized.
     */
    ViewController.prototype._willLoad = function () {
        (void 0) /* assert */;
        this._lifecycle('WillLoad');
    };
    /**
     * @hidden
     * The view has loaded. This event only happens once per view being
     * created. If a view leaves but is cached, then this will not
     * fire again on a subsequent viewing. This method is a good place
     * to put your setup code for the view; however, it is not the
     * recommended method to use when a view becomes active.
     */
    ViewController.prototype._didLoad = function () {
        (void 0) /* assert */;
        this._lifecycle('DidLoad');
    };
    /**
     * @hidden
     * The view is about to enter and become the active view.
     */
    ViewController.prototype._willEnter = function () {
        this.handleOrientationChange();
        (void 0) /* assert */;
        if (this._detached && this._cmp) {
            // ensure this has been re-attached to the change detector
            this._cmp.changeDetectorRef.reattach();
            this._detached = false;
        }
        this.willEnter.emit(null);
        this._lifecycle('WillEnter');
    };
    /**
     * @hidden
     * The view has fully entered and is now the active view. This
     * will fire, whether it was the first load or loaded from the cache.
     */
    ViewController.prototype._didEnter = function () {
        (void 0) /* assert */;
        this._nb && this._nb.didEnter();
        this.didEnter.emit(null);
        this._lifecycle('DidEnter');
    };
    /**
     * @hidden
     * The view is about to leave and no longer be the active view.
     */
    ViewController.prototype._willLeave = function (willUnload) {
        this.willLeave.emit(null);
        this._lifecycle('WillLeave');
        if (willUnload && this._onWillDismiss) {
            this._onWillDismiss(this._dismissData, this._dismissRole);
            this._onWillDismiss = null;
        }
    };
    /**
     * @hidden
     * The view has finished leaving and is no longer the active view. This
     * will fire, whether it is cached or unloaded.
     */
    ViewController.prototype._didLeave = function () {
        this.didLeave.emit(null);
        this._lifecycle('DidLeave');
        // when this is not the active page
        // we no longer need to detect changes
        if (!this._detached && this._cmp) {
            this._cmp.changeDetectorRef.detach();
            this._detached = true;
        }
    };
    /**
     * @hidden
     */
    ViewController.prototype._willUnload = function () {
        this.willUnload.emit(null);
        this._lifecycle('WillUnload');
        this._onDidDismiss && this._onDidDismiss(this._dismissData, this._dismissRole);
        this._onDidDismiss = null;
        this._dismissData = null;
        this._dismissRole = null;
    };
    /**
     * @hidden
     * DOM WRITE
     */
    ViewController.prototype._destroy = function (renderer) {
        (void 0) /* assert */;
        if (this._cmp) {
            if (renderer) {
                // ensure the element is cleaned up for when the view pool reuses this element
                // ******** DOM WRITE ****************
                var cmpEle = this._cmp.location.nativeElement;
                renderer.setElementAttribute(cmpEle, 'class', null);
                renderer.setElementAttribute(cmpEle, 'style', null);
            }
            window.removeEventListener('orientationchange', this._bindHandler);
            // completely destroy this component. boom.
            this._cmp.destroy();
        }
        this._nav = this._cmp = this.instance = this._cntDir = this._cntRef = this._leavingOpts = this._hdrDir = this._ftrDir = this._nb = this._onDidDismiss = this._onWillDismiss = null;
        this._state = __WEBPACK_IMPORTED_MODULE_2__nav_util__["h" /* STATE_DESTROYED */];
    };
    /**
     * @hidden
     */
    ViewController.prototype._lifecycleTest = function (lifecycle) {
        var instance = this.instance;
        var methodName = 'ionViewCan' + lifecycle;
        if (instance && instance[methodName]) {
            try {
                var result = instance[methodName]();
                if (result instanceof Promise) {
                    return result;
                }
                else {
                    // Any value but explitic false, should be true
                    return Promise.resolve(result !== false);
                }
            }
            catch (e) {
                return Promise.reject(this.name + " " + methodName + " error: " + e.message);
            }
        }
        return Promise.resolve(true);
    };
    /**
     * @hidden
     */
    ViewController.prototype._lifecycle = function (lifecycle) {
        var instance = this.instance;
        var methodName = 'ionView' + lifecycle;
        if (instance && instance[methodName]) {
            instance[methodName]();
        }
    };
    ViewController.propDecorators = {
        '_emitter': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    };
    return ViewController;
}());

function isViewController(viewCtrl) {
    return !!(viewCtrl && viewCtrl._didLoad && viewCtrl._willUnload);
}
var DEFAULT_CSS_CLASS = 'ion-page';
//# sourceMappingURL=view-controller.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/platform/dom-controller.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DomDebouncer */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DomController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__platform__ = __webpack_require__("./node_modules/ionic-angular/platform/platform.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");
/**
 * Adopted from FastDom
 * https://github.com/wilsonpage/fastdom
 * MIT License
 */



/**
 * @hidden
 */
var DomDebouncer = (function () {
    function DomDebouncer(dom) {
        this.dom = dom;
        this.writeTask = null;
        this.readTask = null;
    }
    DomDebouncer.prototype.read = function (fn) {
        var _this = this;
        if (this.readTask) {
            return;
        }
        return this.readTask = this.dom.read(function (t) {
            _this.readTask = null;
            fn(t);
        });
    };
    DomDebouncer.prototype.write = function (fn) {
        var _this = this;
        if (this.writeTask) {
            return;
        }
        return this.writeTask = this.dom.write(function (t) {
            _this.writeTask = null;
            fn(t);
        });
    };
    DomDebouncer.prototype.cancel = function () {
        var writeTask = this.writeTask;
        writeTask && this.dom.cancel(writeTask);
        var readTask = this.readTask;
        readTask && this.dom.cancel(readTask);
        this.readTask = this.writeTask = null;
    };
    return DomDebouncer;
}());

/**
 * @hidden
 */
var DomController = (function () {
    function DomController(plt) {
        this.plt = plt;
        this.r = [];
        this.w = [];
    }
    DomController.prototype.debouncer = function () {
        return new DomDebouncer(this);
    };
    DomController.prototype.read = function (fn, timeout) {
        var _this = this;
        if (timeout) {
            fn.timeoutId = this.plt.timeout(function () {
                _this.r.push(fn);
                _this._queue();
            }, timeout);
        }
        else {
            this.r.push(fn);
            this._queue();
        }
        return fn;
    };
    DomController.prototype.write = function (fn, timeout) {
        var _this = this;
        if (timeout) {
            fn.timeoutId = this.plt.timeout(function () {
                _this.w.push(fn);
                _this._queue();
            }, timeout);
        }
        else {
            this.w.push(fn);
            this._queue();
        }
        return fn;
    };
    DomController.prototype.cancel = function (fn) {
        if (fn) {
            if (fn.timeoutId) {
                this.plt.cancelTimeout(fn.timeoutId);
            }
            Object(__WEBPACK_IMPORTED_MODULE_2__util_util__["r" /* removeArrayItem */])(this.r, fn) || Object(__WEBPACK_IMPORTED_MODULE_2__util_util__["r" /* removeArrayItem */])(this.w, fn);
        }
    };
    DomController.prototype._queue = function () {
        var self = this;
        if (!self.q) {
            self.q = true;
            self.plt.raf(function rafCallback(timeStamp) {
                self._flush(timeStamp);
            });
        }
    };
    DomController.prototype._flush = function (timeStamp) {
        var err;
        try {
            dispatch(timeStamp, this.r, this.w);
        }
        catch (e) {
            err = e;
        }
        this.q = false;
        if (this.r.length || this.w.length) {
            this._queue();
        }
        if (err) {
            throw err;
        }
    };
    DomController.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    DomController.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__platform__["a" /* Platform */], },
    ]; };
    return DomController;
}());

function dispatch(timeStamp, r, w) {
    var fn;
    // ******** DOM READS ****************
    while (fn = r.shift()) {
        fn(timeStamp);
    }
    // ******** DOM WRITES ****************
    while (fn = w.shift()) {
        fn(timeStamp);
    }
}
//# sourceMappingURL=dom-controller.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/platform/key.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return KEY_LEFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return KEY_UP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return KEY_RIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KEY_DOWN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return KEY_ENTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return KEY_ESCAPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return KEY_SPACE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return KEY_TAB; });
var KEY_LEFT = 37;
var KEY_UP = 38;
var KEY_RIGHT = 39;
var KEY_DOWN = 40;
var KEY_ENTER = 13;
var KEY_ESCAPE = 27;
var KEY_SPACE = 32;
var KEY_TAB = 9;
//# sourceMappingURL=key.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/platform/keyboard.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Keyboard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dom_controller__ = __webpack_require__("./node_modules/ionic-angular/platform/dom-controller.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_dom__ = __webpack_require__("./node_modules/ionic-angular/util/dom.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__key__ = __webpack_require__("./node_modules/ionic-angular/platform/key.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__platform__ = __webpack_require__("./node_modules/ionic-angular/platform/platform.js");






/**
 * @name Keyboard
 * @description
 * The `Keyboard` class allows you to work with the keyboard events provided
 * by the Ionic keyboard plugin.
 *
 * @usage
 * ```ts
 * export class MyClass {
 *
 *   constructor(public keyboard: Keyboard) { }
 *
 * }
 * ```
 */
var Keyboard = (function () {
    function Keyboard(config, _plt, _zone, _dom) {
        this._plt = _plt;
        this._zone = _zone;
        this._dom = _dom;
        this.willShow = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.willHide = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.didShow = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.didHide = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.eventsAvailable = false;
        this.focusOutline(config.get('focusOutline'));
        var win = _plt.win();
        if (win.Ionic && win.Ionic.keyboardPlugin) {
            this.listenV2(win);
        }
        else {
            this.listenV1(win);
        }
    }
    Keyboard.prototype.listenV2 = function (win) {
        var _this = this;
        var platform = this._plt;
        platform.registerListener(win, 'keyboardWillShow', function (ev) {
            _this._zone.run(function () {
                _this.willShow.emit(ev.keyboardHeight);
            });
        }, { zone: false, passive: true });
        platform.registerListener(win, 'keyboardWillHide', function () {
            _this._zone.run(function () {
                _this.willHide.emit();
            });
        }, { zone: false, passive: true });
        platform.registerListener(win, 'keyboardDidShow', function (ev) {
            _this._zone.run(function () {
                _this.didShow.emit(ev.keyboardHeight);
            });
        }, { zone: false, passive: true });
        platform.registerListener(win, 'keyboardDidHide', function () {
            _this._zone.run(function () {
                _this.didHide.emit();
            });
        }, { zone: false, passive: true });
        this.eventsAvailable = true;
    };
    Keyboard.prototype.listenV1 = function (win) {
        var _this = this;
        var platform = this._plt;
        platform.registerListener(win, 'native.keyboardhide', function () {
            _this.blurActiveInput(true);
        }, { zone: false, passive: true });
        platform.registerListener(win, 'native.keyboardshow', function () {
            _this.blurActiveInput(false);
        }, { zone: false, passive: true });
    };
    Keyboard.prototype.blurActiveInput = function (shouldBlur) {
        var _this = this;
        var platform = this._plt;
        platform.cancelTimeout(this._tmr);
        if (shouldBlur) {
            this._tmr = platform.timeout(function () {
                // this custom cordova plugin event fires when the keyboard will hide
                // useful when the virtual keyboard is closed natively
                // https://github.com/ionic-team/ionic-plugin-keyboard
                if (_this.isOpen()) {
                    platform.focusOutActiveElement();
                }
            }, 80);
        }
    };
    /**
     * Check to see if the keyboard is open or not.
     *
     * ```ts
     * export class MyClass {
     *   constructor(public keyboard: Keyboard) {
     *
     *   }
     *
     *   keyboardCheck() {
     *     console.log('The keyboard is open:', this.keyboard.isOpen());
     *   }
     * }
     * ```
     *
     * @return {boolean} returns a true or false value if the keyboard is open or not.
     */
    Keyboard.prototype.isOpen = function () {
        return this.hasFocusedTextInput();
    };
    /**
     * When the keyboard is closed, call any methods you want.
     *
     * ```ts
     * export class MyClass {
     *   constructor(public keyboard: Keyboard) {
     *     this.keyboard.onClose(this.closeCallback);
     *   }
     *   closeCallback() {
     *     // call what ever functionality you want on keyboard close
     *     console.log('Closing time');
     *   }
     * }
     * ```
     *
     * @param {function} callback method you want to call when the keyboard has been closed.
     * @return {function} returns a callback that gets fired when the keyboard is closed.
     */
    Keyboard.prototype.onClose = function (callback, pollingInternval, pollingChecksMax) {
        if (pollingInternval === void 0) { pollingInternval = KEYBOARD_CLOSE_POLLING; }
        if (pollingChecksMax === void 0) { pollingChecksMax = KEYBOARD_POLLING_CHECKS_MAX; }
        (void 0) /* console.debug */;
        var self = this;
        var checks = 0;
        var promise = null;
        if (!callback) {
            // a callback wasn't provided, so let's return a promise instead
            promise = new Promise(function (resolve) { callback = resolve; });
        }
        function checkKeyboard() {
            (void 0) /* console.debug */;
            if (!self.isOpen() || checks > pollingChecksMax) {
                self._plt.timeout(function () {
                    self._zone.run(function () {
                        (void 0) /* console.debug */;
                        callback();
                    });
                }, 400);
            }
            else {
                self._plt.timeout(checkKeyboard, pollingInternval);
            }
            checks++;
        }
        self._plt.timeout(checkKeyboard, pollingInternval);
        return promise;
    };
    /**
     * Programmatically close the keyboard.
     */
    Keyboard.prototype.close = function () {
        var _this = this;
        this._dom.read(function () {
            if (_this.isOpen()) {
                // only focus out when a text input has focus
                (void 0) /* console.debug */;
                _this._dom.write(function () {
                    _this._plt.focusOutActiveElement();
                });
            }
        });
    };
    /**
     * @hidden
     */
    Keyboard.prototype.focusOutline = function (setting) {
        /* Focus Outline
         * --------------------------------------------------
         * By default, when a keydown event happens from a tab key, then
         * the 'focus-outline' css class is added to the body element
         * so focusable elements have an outline. On a mousedown or
         * touchstart event, then the 'focus-outline' css class is removed.
         *
         * Config default overrides:
         * focusOutline: true     - Always add the focus-outline
         * focusOutline: false    - Do not add the focus-outline
         */
        var self = this;
        var platform = self._plt;
        var doc = platform.doc();
        var isKeyInputEnabled = false;
        var unRegMouse;
        var unRegTouch;
        var evOpts = { passive: true, zone: false };
        function cssClass() {
            self._dom.write(function () {
                platform.doc().body.classList[isKeyInputEnabled ? 'add' : 'remove']('focus-outline');
            });
        }
        if (setting === true) {
            isKeyInputEnabled = true;
            return cssClass();
        }
        else if (setting === false) {
            return;
        }
        // default is to add the focus-outline when the tab key is used
        function keyDown(ev) {
            if (!isKeyInputEnabled && ev.keyCode === __WEBPACK_IMPORTED_MODULE_4__key__["g" /* KEY_TAB */]) {
                isKeyInputEnabled = true;
                enableKeyInput();
            }
        }
        function pointerDown() {
            isKeyInputEnabled = false;
            enableKeyInput();
        }
        function enableKeyInput() {
            cssClass();
            unRegMouse && unRegMouse();
            unRegTouch && unRegTouch();
            if (isKeyInputEnabled) {
                // listen for when a mousedown or touchstart event happens
                unRegMouse = platform.registerListener(doc, 'mousedown', pointerDown, evOpts);
                unRegTouch = platform.registerListener(doc, 'touchstart', pointerDown, evOpts);
            }
        }
        // always listen for tab keydown events
        platform.registerListener(platform.doc(), 'keydown', keyDown, evOpts);
    };
    Keyboard.prototype.hasFocusedTextInput = function () {
        var activeEle = this._plt.getActiveElement();
        if (Object(__WEBPACK_IMPORTED_MODULE_3__util_dom__["e" /* isTextInput */])(activeEle)) {
            return (activeEle.parentElement.querySelector(':focus') === activeEle);
        }
        return false;
    };
    /**
     * Set to true to hide the additional toolbar that is on top of the keyboard.
     * This toolbar features the Prev, Next, and Done buttons.
     * @param hidden
     */
    Keyboard.prototype.hideFormAccessoryBar = function (hidden) {
        var win = this._plt.win();
        if (win && win.Keyboard && win.Keyboard.hideFormAccessoryBar) {
            win.Keyboard.hideFormAccessoryBar(hidden);
        }
    };
    Keyboard.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    Keyboard.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__config_config__["a" /* Config */], },
        { type: __WEBPACK_IMPORTED_MODULE_5__platform__["a" /* Platform */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"], },
        { type: __WEBPACK_IMPORTED_MODULE_2__dom_controller__["a" /* DomController */], },
    ]; };
    return Keyboard;
}());

var KEYBOARD_CLOSE_POLLING = 150;
var KEYBOARD_POLLING_CHECKS_MAX = 100;
//# sourceMappingURL=keyboard.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/platform/platform-registry.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLATFORM_CONFIGS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PlatformConfigToken; });
/* harmony export (immutable) */ __webpack_exports__["b"] = providePlatformConfigs;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__platform_utils__ = __webpack_require__("./node_modules/ionic-angular/platform/platform-utils.js");


var PLATFORM_CONFIGS = {
    /**
     * core
     */
    'core': {
        settings: {
            mode: 'md',
            keyboardHeight: 290
        }
    },
    /**
     * mobile
     */
    'mobile': {},
    /**
     * phablet
     */
    'phablet': {
        isMatch: function (plt) {
            var smallest = Math.min(plt.width(), plt.height());
            var largest = Math.max(plt.width(), plt.height());
            return (smallest > 390 && smallest < 520) &&
                (largest > 620 && largest < 800);
        }
    },
    /**
     * tablet
     */
    'tablet': {
        isMatch: function (plt) {
            var smallest = Math.min(plt.width(), plt.height());
            var largest = Math.max(plt.width(), plt.height());
            return (smallest > 460 && smallest < 820) &&
                (largest > 780 && largest < 1400);
        }
    },
    /**
     * android
     */
    'android': {
        superset: 'mobile',
        subsets: [
            'phablet',
            'tablet'
        ],
        settings: {
            activator: function (plt) {
                // md mode defaults to use ripple activator
                // however, under-powered devices shouldn't use ripple
                // if this a linux device, and is using Android Chrome v36 (Android 5.0)
                // or above then use ripple, otherwise do not use a ripple effect
                if (plt.testNavigatorPlatform('linux')) {
                    var chromeVersion = plt.matchUserAgentVersion(/Chrome\/(\d+).(\d+)?/);
                    if (chromeVersion) {
                        // linux android device using modern android chrome browser gets ripple
                        if (parseInt(chromeVersion.major, 10) < 36 || plt.version().major < 5) {
                            return 'none';
                        }
                        else {
                            return 'ripple';
                        }
                    }
                    // linux android device not using chrome browser checks just android's version
                    if (plt.version().major < 5) {
                        return 'none';
                    }
                }
                // fallback to always use ripple
                return 'ripple';
            },
            autoFocusAssist: 'immediate',
            inputCloning: true,
            scrollAssist: true,
            hoverCSS: false,
            keyboardHeight: 300,
            mode: 'md',
        },
        isMatch: function (plt) {
            return plt.isPlatformMatch('android', ['android', 'silk'], ['windows phone']);
        },
        versionParser: function (plt) {
            return plt.matchUserAgentVersion(/Android (\d+).(\d+)?/);
        }
    },
    /**
     * ios
     */
    'ios': {
        superset: 'mobile',
        subsets: [
            'ipad',
            'iphone'
        ],
        settings: {
            autoFocusAssist: 'delay',
            hideCaretOnScroll: true,
            hoverCSS: false,
            inputBlurring: __WEBPACK_IMPORTED_MODULE_1__platform_utils__["c" /* isIos */],
            inputCloning: __WEBPACK_IMPORTED_MODULE_1__platform_utils__["c" /* isIos */],
            keyboardHeight: 250,
            mode: 'ios',
            statusbarPadding: __WEBPACK_IMPORTED_MODULE_1__platform_utils__["a" /* isCordova */],
            swipeBackEnabled: __WEBPACK_IMPORTED_MODULE_1__platform_utils__["c" /* isIos */],
            tapPolyfill: __WEBPACK_IMPORTED_MODULE_1__platform_utils__["d" /* isIosUIWebView */],
            virtualScrollEventAssist: __WEBPACK_IMPORTED_MODULE_1__platform_utils__["d" /* isIosUIWebView */],
            disableScrollAssist: __WEBPACK_IMPORTED_MODULE_1__platform_utils__["c" /* isIos */],
            scrollAssist: __WEBPACK_IMPORTED_MODULE_1__platform_utils__["c" /* isIos */],
            keyboardResizes: keyboardResizes,
        },
        isMatch: function (plt) {
            return plt.isPlatformMatch('ios', ['iphone', 'ipad', 'ipod'], ['windows phone']);
        },
        versionParser: function (plt) {
            return plt.matchUserAgentVersion(/OS (\d+)_(\d+)?/);
        }
    },
    /**
     * ipad
     */
    'ipad': {
        superset: 'tablet',
        settings: {
            keyboardHeight: 500,
        },
        isMatch: function (plt) {
            return plt.isPlatformMatch('ipad');
        }
    },
    /**
     * iphone
     */
    'iphone': {
        subsets: [
            'phablet'
        ],
        isMatch: function (plt) {
            return plt.isPlatformMatch('iphone');
        }
    },
    /**
     * Windows
     */
    'windows': {
        superset: 'mobile',
        subsets: [
            'phablet',
            'tablet'
        ],
        settings: {
            mode: 'wp',
            autoFocusAssist: 'immediate',
            hoverCSS: false
        },
        isMatch: function (plt) {
            return plt.isPlatformMatch('windows', ['windows phone']);
        },
        versionParser: function (plt) {
            return plt.matchUserAgentVersion(/Windows Phone (\d+).(\d+)?/);
        }
    },
    /**
     * cordova
     */
    'cordova': {
        isEngine: true,
        initialize: function (plt) {
            // prepare a custom "ready" for cordova "deviceready"
            plt.prepareReady = function () {
                // 1) ionic bootstrapped
                plt.windowLoad(function (win, doc) {
                    // 2) window onload triggered or completed
                    doc.addEventListener('deviceready', function () {
                        // 3) cordova deviceready event triggered
                        // add cordova listeners to emit platform events
                        doc.addEventListener('backbutton', function (ev) {
                            plt.zone.run(function () {
                                plt.backButton.emit(ev);
                            });
                        });
                        doc.addEventListener('pause', function (ev) {
                            plt.zone.run(function () {
                                plt.pause.emit(ev);
                            });
                        });
                        doc.addEventListener('resume', function (ev) {
                            plt.zone.run(function () {
                                plt.resume.emit(ev);
                            });
                        });
                        // cordova has its own exitApp method
                        plt.exitApp = function () {
                            win['navigator']['app'].exitApp();
                        };
                        // cordova has fully loaded and we've added listeners
                        plt.triggerReady('cordova');
                    });
                });
            };
        },
        isMatch: function (plt) {
            return Object(__WEBPACK_IMPORTED_MODULE_1__platform_utils__["a" /* isCordova */])(plt);
        }
    },
    /**
     * electron
     */
    'electron': {
        superset: 'core',
        initialize: function (plt) {
            plt.prepareReady = function () {
                // 1) ionic bootstrapped
                plt.windowLoad(function () {
                    plt.triggerReady('electron');
                });
            };
        },
        isMatch: function (plt) {
            return Object(__WEBPACK_IMPORTED_MODULE_1__platform_utils__["b" /* isElectron */])(plt);
        }
    }
};
function keyboardResizes(plt) {
    var win = plt.win();
    if (win.Ionic && win.Ionic.keyboardResizes === true) {
        return true;
    }
    return false;
}
var PlatformConfigToken = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["InjectionToken"]('PLTCONFIG');
function providePlatformConfigs() {
    return PLATFORM_CONFIGS;
}
//# sourceMappingURL=platform-registry.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/platform/platform-utils.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isCordova;
/* harmony export (immutable) */ __webpack_exports__["b"] = isElectron;
/* harmony export (immutable) */ __webpack_exports__["c"] = isIos;
/* harmony export (immutable) */ __webpack_exports__["e"] = isSafari;
/* unused harmony export isWKWebView */
/* harmony export (immutable) */ __webpack_exports__["d"] = isIosUIWebView;
function isCordova(plt) {
    var win = plt.win();
    return !!(win['cordova'] || win['PhoneGap'] || win['phonegap']);
}
function isElectron(plt) {
    return plt.testUserAgent('Electron');
}
function isIos(plt) {
    // shortcut function to be reused internally
    // checks navigator.platform to see if it's an actual iOS device
    // this does not use the user-agent string because it is often spoofed
    // an actual iPad will return true, a chrome dev tools iPad will return false
    return plt.testNavigatorPlatform('iphone|ipad|ipod');
}
function isSafari(plt) {
    return plt.testUserAgent('Safari');
}
function isWKWebView(plt) {
    return isIos(plt) && !!plt.win()['webkit'];
}
function isIosUIWebView(plt) {
    return isIos(plt) && !isWKWebView(plt) && !isSafari(plt);
}
//# sourceMappingURL=platform-utils.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/platform/platform.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Platform; });
/* harmony export (immutable) */ __webpack_exports__["b"] = setupPlatform;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_dom__ = __webpack_require__("./node_modules/ionic-angular/util/dom.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__query_params__ = __webpack_require__("./node_modules/ionic-angular/platform/query-params.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");




/**
 * @name Platform
 * @description
 * The Platform service can be used to get information about your current device.
 * You can get all of the platforms associated with the device using the [platforms](#platforms)
 * method, including whether the app is being viewed from a tablet, if it's
 * on a mobile device or browser, and the exact platform (iOS, Android, etc).
 * You can also get the orientation of the device, if it uses right-to-left
 * language direction, and much much more. With this information you can completely
 * customize your app to fit any device.
 *
 * @usage
 * ```ts
 * import { Platform } from 'ionic-angular';
 *
 * @Component({...})
 * export MyPage {
 *   constructor(public platform: Platform) {
 *
 *   }
 * }
 * ```
 * @demo /docs/demos/src/platform/
 */
var Platform = (function () {
    function Platform() {
        var _this = this;
        this._versions = {};
        this._qp = new __WEBPACK_IMPORTED_MODULE_2__query_params__["a" /* QueryParams */]();
        this._bbActions = [];
        this._pW = 0;
        this._pH = 0;
        this._lW = 0;
        this._lH = 0;
        this._isPortrait = null;
        this._uiEvtOpts = false;
        /** @internal */
        this._platforms = [];
        // Events meant to be triggered by the engine
        // **********************************************
        /**
         * @hidden
         */
        this.backButton = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
         * The pause event emits when the native platform puts the application
         * into the background, typically when the user switches to a different
         * application. This event would emit when a Cordova app is put into
         * the background, however, it would not fire on a standard web browser.
         */
        this.pause = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
         * The resume event emits when the native platform pulls the application
         * out from the background. This event would emit when a Cordova app comes
         * out from the background, however, it would not fire on a standard web browser.
         */
        this.resume = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
         * The resize event emits when the browser window has changed dimensions. This
         * could be from a browser window being physically resized, or from a device
         * changing orientation.
         */
        this.resize = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this._readyPromise = new Promise(function (res) { _this._readyResolve = res; });
        this.backButton.subscribe(function () {
            // the hardware back button event has been fired
            (void 0) /* console.debug */;
            // decide which backbutton action should run
            _this.runBackButtonAction();
        });
    }
    /**
     * @hidden
     */
    Platform.prototype.setWindow = function (win) {
        this._win = win;
    };
    /**
     * @hidden
     */
    Platform.prototype.win = function () {
        return this._win;
    };
    /**
     * @hidden
     */
    Platform.prototype.setDocument = function (doc) {
        this._doc = doc;
    };
    /**
     * @hidden
     */
    Platform.prototype.doc = function () {
        return this._doc;
    };
    /**
     * @hidden
     */
    Platform.prototype.setZone = function (zone) {
        this.zone = zone;
    };
    /**
     * @hidden
     */
    Platform.prototype.setCssProps = function (docElement) {
        this.Css = Object(__WEBPACK_IMPORTED_MODULE_1__util_dom__["c" /* getCss */])(docElement);
    };
    // Methods
    // **********************************************
    /**
     * @returns {boolean} returns true/false based on platform.
     * @description
     * Depending on the platform the user is on, `is(platformName)` will
     * return `true` or `false`. Note that the same app can return `true`
     * for more than one platform name. For example, an app running from
     * an iPad would return `true` for the platform names: `mobile`,
     * `ios`, `ipad`, and `tablet`. Additionally, if the app was running
     * from Cordova then `cordova` would be true, and if it was running
     * from a web browser on the iPad then `mobileweb` would be `true`.
     *
     * ```
     * import { Platform } from 'ionic-angular';
     *
     * @Component({...})
     * export MyPage {
     *   constructor(public platform: Platform) {
     *     if (this.platform.is('ios')) {
     *       // This will only print when on iOS
     *       console.log('I am an iOS device!');
     *     }
     *   }
     * }
     * ```
     *
     * | Platform Name   | Description                        |
     * |-----------------|------------------------------------|
     * | android         | on a device running Android.       |
     * | cordova         | on a device running Cordova.       |
     * | core            | on a desktop device.               |
     * | ios             | on a device running iOS.           |
     * | ipad            | on an iPad device.                 |
     * | iphone          | on an iPhone device.               |
     * | mobile          | on a mobile device.                |
     * | mobileweb       | in a browser on a mobile device.   |
     * | phablet         | on a phablet device.               |
     * | tablet          | on a tablet device.                |
     * | windows         | on a device running Windows.       |
     * | electron        | in Electron on a desktop device.   |
     *
     * @param {string} platformName
     */
    Platform.prototype.is = function (platformName) {
        return (this._platforms.indexOf(platformName) > -1);
    };
    /**
     * @returns {array} the array of platforms
     * @description
     * Depending on what device you are on, `platforms` can return multiple values.
     * Each possible value is a hierarchy of platforms. For example, on an iPhone,
     * it would return `mobile`, `ios`, and `iphone`.
     *
     * ```
     * import { Platform } from 'ionic-angular';
     *
     * @Component({...})
     * export MyPage {
     *   constructor(public platform: Platform) {
     *     // This will print an array of the current platforms
     *     console.log(this.platform.platforms());
     *   }
     * }
     * ```
     */
    Platform.prototype.platforms = function () {
        // get the array of active platforms, which also knows the hierarchy,
        // with the last one the most important
        return this._platforms;
    };
    /**
     * Returns an object containing version information about all of the platforms.
     *
     * ```
     * import { Platform } from 'ionic-angular';
     *
     * @Component({...})
     * export MyPage {
     *   constructor(public platform: Platform) {
     *     // This will print an object containing
     *     // all of the platforms and their versions
     *     console.log(platform.versions());
     *   }
     * }
     * ```
     *
     * @returns {object} An object containing all of the platforms and their versions.
     */
    Platform.prototype.versions = function () {
        // get all the platforms that have a valid parsed version
        return this._versions;
    };
    /**
     * @hidden
     */
    Platform.prototype.version = function () {
        for (var platformName in this._versions) {
            if (this._versions[platformName]) {
                return this._versions[platformName];
            }
        }
        return {};
    };
    /**
     * Returns a promise when the platform is ready and native functionality
     * can be called. If the app is running from within a web browser, then
     * the promise will resolve when the DOM is ready. When the app is running
     * from an application engine such as Cordova, then the promise will
     * resolve when Cordova triggers the `deviceready` event.
     *
     * The resolved value is the `readySource`, which states which platform
     * ready was used. For example, when Cordova is ready, the resolved ready
     * source is `cordova`. The default ready source value will be `dom`. The
     * `readySource` is useful if different logic should run depending on the
     * platform the app is running from. For example, only Cordova can execute
     * the status bar plugin, so the web should not run status bar plugin logic.
     *
     * ```
     * import { Component } from '@angular/core';
     * import { Platform } from 'ionic-angular';
     *
     * @Component({...})
     * export MyApp {
     *   constructor(public platform: Platform) {
     *     this.platform.ready().then((readySource) => {
     *       console.log('Platform ready from', readySource);
     *       // Platform now ready, execute any required native code
     *     });
     *   }
     * }
     * ```
     * @returns {promise}
     */
    Platform.prototype.ready = function () {
        return this._readyPromise;
    };
    /**
     * @hidden
     * This should be triggered by the engine when the platform is
     * ready. If there was no custom prepareReady method from the engine,
     * such as Cordova or Electron, then it uses the default DOM ready.
     */
    Platform.prototype.triggerReady = function (readySource) {
        var _this = this;
        this.zone.run(function () {
            _this._readyResolve(readySource);
        });
    };
    /**
     * @hidden
     * This is the default prepareReady if it's not replaced by an engine,
     * such as Cordova or Electron. If there was no custom prepareReady
     * method from an engine then it uses the method below, which triggers
     * the platform ready on the DOM ready event, and the default resolved
     * value is `dom`.
     */
    Platform.prototype.prepareReady = function () {
        var self = this;
        if (self._doc.readyState === 'complete' || self._doc.readyState === 'interactive') {
            self.triggerReady('dom');
        }
        else {
            self._doc.addEventListener('DOMContentLoaded', completed, false);
            self._win.addEventListener('load', completed, false);
        }
        function completed() {
            self._doc.removeEventListener('DOMContentLoaded', completed, false);
            self._win.removeEventListener('load', completed, false);
            self.triggerReady('dom');
        }
    };
    /**
     * Set the app's language direction, which will update the `dir` attribute
     * on the app's root `<html>` element. We recommend the app's `index.html`
     * file already has the correct `dir` attribute value set, such as
     * `<html dir="ltr">` or `<html dir="rtl">`. This method is useful if the
     * direction needs to be dynamically changed per user/session.
     * [W3C: Structural markup and right-to-left text in HTML](http://www.w3.org/International/questions/qa-html-dir)
     * @param {DocumentDirection} dir  Examples: `rtl`, `ltr`
     * @param {boolean} updateDocument
     */
    Platform.prototype.setDir = function (dir, updateDocument) {
        this._dir = dir;
        this.isRTL = (dir === 'rtl');
        if (updateDocument !== false) {
            this._doc['documentElement'].setAttribute('dir', dir);
        }
    };
    /**
     * Returns app's language direction.
     * We recommend the app's `index.html` file already has the correct `dir`
     * attribute value set, such as `<html dir="ltr">` or `<html dir="rtl">`.
     * [W3C: Structural markup and right-to-left text in HTML](http://www.w3.org/International/questions/qa-html-dir)
     * @returns {DocumentDirection}
     */
    Platform.prototype.dir = function () {
        return this._dir;
    };
    /**
     * Set the app's language and optionally the country code, which will update
     * the `lang` attribute on the app's root `<html>` element.
     * We recommend the app's `index.html` file already has the correct `lang`
     * attribute value set, such as `<html lang="en">`. This method is useful if
     * the language needs to be dynamically changed per user/session.
     * [W3C: Declaring language in HTML](http://www.w3.org/International/questions/qa-html-language-declarations)
     * @param {string} language  Examples: `en-US`, `en-GB`, `ar`, `de`, `zh`, `es-MX`
     * @param {boolean} updateDocument  Specifies whether the `lang` attribute of `<html>` should be updated
     */
    Platform.prototype.setLang = function (language, updateDocument) {
        this._lang = language;
        if (updateDocument !== false) {
            this._doc['documentElement'].setAttribute('lang', language);
        }
    };
    /**
     * Returns app's language and optional country code.
     * We recommend the app's `index.html` file already has the correct `lang`
     * attribute value set, such as `<html lang="en">`.
     * [W3C: Declaring language in HTML](http://www.w3.org/International/questions/qa-html-language-declarations)
     * @returns {string}
     */
    Platform.prototype.lang = function () {
        return this._lang;
    };
    // Methods meant to be overridden by the engine
    // **********************************************
    // Provided NOOP methods so they do not error when
    // called by engines (the browser)that do not provide them
    /**
     * @hidden
     */
    Platform.prototype.exitApp = function () { };
    /**
     * The back button event is triggered when the user presses the native
     * platform's back button, also referred to as the "hardware" back button.
     * This event is only used within Cordova apps running on Android and
     * Windows platforms. This event is not fired on iOS since iOS doesn't come
     * with a hardware back button in the same sense an Android or Windows device
     * does.
     *
     * Registering a hardware back button action and setting a priority allows
     * apps to control which action should be called when the hardware back
     * button is pressed. This method decides which of the registered back button
     * actions has the highest priority and should be called.
     *
     * @param {Function} fn Called when the back button is pressed,
     * if this registered action has the highest priority.
     * @param {number} priority Set the priority for this action. Only the highest priority will execute. Defaults to `0`.
     * @returns {Function} A function that, when called, will unregister
     * the back button action.
     */
    Platform.prototype.registerBackButtonAction = function (fn, priority) {
        var _this = this;
        if (priority === void 0) { priority = 0; }
        var action = { fn: fn, priority: priority };
        this._bbActions.push(action);
        // return a function to unregister this back button action
        return function () {
            Object(__WEBPACK_IMPORTED_MODULE_3__util_util__["r" /* removeArrayItem */])(_this._bbActions, action);
        };
    };
    /**
     * @hidden
     */
    Platform.prototype.runBackButtonAction = function () {
        // decide which one back button action should run
        var winner = null;
        this._bbActions.forEach(function (action) {
            if (!winner || action.priority >= winner.priority) {
                winner = action;
            }
        });
        // run the winning action if there is one
        winner && winner.fn && winner.fn();
    };
    // Getter/Setter Methods
    // **********************************************
    /**
     * @hidden
     */
    Platform.prototype.setUserAgent = function (userAgent) {
        this._ua = userAgent;
    };
    /**
     * @hidden
     */
    Platform.prototype.setQueryParams = function (url) {
        this._qp.parseUrl(url);
    };
    /**
     * Get the query string parameter
     */
    Platform.prototype.getQueryParam = function (key) {
        return this._qp.get(key);
    };
    /**
     * Get the current url.
     */
    Platform.prototype.url = function () {
        return this._win['location']['href'];
    };
    /**
     * @hidden
     */
    Platform.prototype.userAgent = function () {
        return this._ua || '';
    };
    /**
     * @hidden
     */
    Platform.prototype.setNavigatorPlatform = function (navigatorPlt) {
        this._nPlt = navigatorPlt;
    };
    /**
     * @hidden
     */
    Platform.prototype.navigatorPlatform = function () {
        return this._nPlt || '';
    };
    /**
     * Gets the width of the platform's viewport using `window.innerWidth`.
     * Using this method is preferred since the dimension is a cached value,
     * which reduces the chance of multiple and expensive DOM reads.
     */
    Platform.prototype.width = function () {
        this._calcDim();
        return this._isPortrait ? this._pW : this._lW;
    };
    /**
     * Gets the height of the platform's viewport using `window.innerHeight`.
     * Using this method is preferred since the dimension is a cached value,
     * which reduces the chance of multiple and expensive DOM reads.
     */
    Platform.prototype.height = function () {
        this._calcDim();
        return this._isPortrait ? this._pH : this._lH;
    };
    /**
     * @hidden
     */
    Platform.prototype.getElementComputedStyle = function (ele, pseudoEle) {
        return this._win['getComputedStyle'](ele, pseudoEle);
    };
    /**
     * @hidden
     */
    Platform.prototype.getElementFromPoint = function (x, y) {
        return this._doc['elementFromPoint'](x, y);
    };
    /**
     * @hidden
     */
    Platform.prototype.getElementBoundingClientRect = function (ele) {
        return ele['getBoundingClientRect']();
    };
    /**
     * Returns `true` if the app is in portait mode.
     */
    Platform.prototype.isPortrait = function () {
        this._calcDim();
        return this._isPortrait;
    };
    /**
     * Returns `true` if the app is in landscape mode.
     */
    Platform.prototype.isLandscape = function () {
        return !this.isPortrait();
    };
    Platform.prototype._calcDim = function () {
        // we're caching window dimensions so that
        // we're not forcing many layouts
        // if _isPortrait is null then that means
        // the dimensions needs to be looked up again
        // this also has to cover an edge case that only
        // happens on iOS 10 (not other versions of iOS)
        // where window.innerWidth is always bigger than
        // window.innerHeight when it is first measured,
        // even when the device is in portrait but
        // the second time it is measured it is correct.
        // Hopefully this check will not be needed in the future
        if (this._isPortrait === null || this._isPortrait === false && this._win['innerWidth'] < this._win['innerHeight']) {
            var win = this._win;
            var innerWidth = win['innerWidth'];
            var innerHeight = win['innerHeight'];
            // we're keeping track of portrait and landscape dimensions
            // separately because the virtual keyboard can really mess
            // up accurate values when the keyboard is up
            if (win.screen.width > 0 && win.screen.height > 0) {
                if (innerWidth < innerHeight) {
                    // the device is in portrait
                    // we have to do fancier checking here
                    // because of the virtual keyboard resizing
                    // the window
                    if (this._pW <= innerWidth) {
                        (void 0) /* console.debug */;
                        this._isPortrait = true;
                        this._pW = innerWidth;
                    }
                    if (this._pH <= innerHeight) {
                        (void 0) /* console.debug */;
                        this._isPortrait = true;
                        this._pH = innerHeight;
                    }
                }
                else {
                    // the device is in landscape
                    if (this._lW !== innerWidth) {
                        (void 0) /* console.debug */;
                        this._isPortrait = false;
                        this._lW = innerWidth;
                    }
                    if (this._lH !== innerHeight) {
                        (void 0) /* console.debug */;
                        this._isPortrait = false;
                        this._lH = innerHeight;
                    }
                }
            }
        }
    };
    /**
     * @hidden
     * This requestAnimationFrame will NOT be wrapped by zone.
     */
    Platform.prototype.raf = function (callback) {
        var win = this._win;
        return win['__zone_symbol__requestAnimationFrame'](callback);
    };
    /**
     * @hidden
     */
    Platform.prototype.cancelRaf = function (rafId) {
        var win = this._win;
        return win['__zone_symbol__cancelAnimationFrame'](rafId);
    };
    /**
     * @hidden
     * This setTimeout will NOT be wrapped by zone.
     */
    Platform.prototype.timeout = function (callback, timeout) {
        var win = this._win;
        return win['__zone_symbol__setTimeout'](callback, timeout);
    };
    /**
     * @hidden
     * This setTimeout will NOT be wrapped by zone.
     */
    Platform.prototype.cancelTimeout = function (timeoutId) {
        var win = this._win;
        win['__zone_symbol__clearTimeout'](timeoutId);
    };
    /**
     * @hidden
     * Built to use modern event listener options, like "passive".
     * If options are not supported, then just return a boolean which
     * represents "capture". Returns a method to remove the listener.
     */
    Platform.prototype.registerListener = function (ele, eventName, callback, opts, unregisterListenersCollection) {
        // use event listener options when supported
        // otherwise it's just a boolean for the "capture" arg
        var listenerOpts = this._uiEvtOpts ? {
            'capture': !!opts.capture,
            'passive': !!opts.passive,
        } : !!opts.capture;
        var unReg;
        if (!opts.zone && ele['__zone_symbol__addEventListener']) {
            // do not wrap this event in zone and we've verified we can use the raw addEventListener
            ele['__zone_symbol__addEventListener'](eventName, callback, listenerOpts);
            unReg = function unregisterListener() {
                ele['__zone_symbol__removeEventListener'](eventName, callback, listenerOpts);
            };
        }
        else {
            // use the native addEventListener, which is wrapped with zone
            ele['addEventListener'](eventName, callback, listenerOpts);
            unReg = function unregisterListener() {
                ele['removeEventListener'](eventName, callback, listenerOpts);
            };
        }
        if (unregisterListenersCollection) {
            unregisterListenersCollection.push(unReg);
        }
        return unReg;
    };
    /**
     * @hidden
     */
    Platform.prototype.transitionEnd = function (el, callback, zone) {
        if (zone === void 0) { zone = true; }
        var unRegs = [];
        function unregister() {
            unRegs.forEach(function (unReg) {
                unReg();
            });
        }
        function onTransitionEnd(ev) {
            if (el === ev.target) {
                unregister();
                callback(ev);
            }
        }
        if (el) {
            this.registerListener(el, 'webkitTransitionEnd', onTransitionEnd, { zone: zone }, unRegs);
            this.registerListener(el, 'transitionend', onTransitionEnd, { zone: zone }, unRegs);
        }
        return unregister;
    };
    /**
     * @hidden
     */
    Platform.prototype.windowLoad = function (callback) {
        var win = this._win;
        var doc = this._doc;
        var unreg;
        if (doc.readyState === 'complete') {
            callback(win, doc);
        }
        else {
            unreg = this.registerListener(win, 'load', function () {
                unreg && unreg();
                callback(win, doc);
            }, { zone: false });
        }
    };
    /**
     * @hidden
     */
    Platform.prototype.isActiveElement = function (ele) {
        return !!(ele && (this.getActiveElement() === ele));
    };
    /**
     * @hidden
     */
    Platform.prototype.getActiveElement = function () {
        return this._doc['activeElement'];
    };
    /**
     * @hidden
     */
    Platform.prototype.hasFocus = function (ele) {
        return !!((ele && (this.getActiveElement() === ele)) && (ele.parentElement.querySelector(':focus') === ele));
    };
    /**
     * @hidden
     */
    Platform.prototype.hasFocusedTextInput = function () {
        var ele = this.getActiveElement();
        if (Object(__WEBPACK_IMPORTED_MODULE_1__util_dom__["e" /* isTextInput */])(ele)) {
            return (ele.parentElement.querySelector(':focus') === ele);
        }
        return false;
    };
    /**
     * @hidden
     */
    Platform.prototype.focusOutActiveElement = function () {
        var activeElement = this.getActiveElement();
        activeElement && activeElement.blur && activeElement.blur();
    };
    Platform.prototype._initEvents = function () {
        var _this = this;
        // Test via a getter in the options object to see if the passive property is accessed
        try {
            var opts = Object.defineProperty({}, 'passive', {
                get: function () {
                    _this._uiEvtOpts = true;
                }
            });
            this._win.addEventListener('optsTest', null, opts);
        }
        catch (e) { }
        // add the window resize event listener XXms after
        this.timeout(function () {
            var timerId;
            _this.registerListener(_this._win, 'resize', function () {
                clearTimeout(timerId);
                timerId = setTimeout(function () {
                    // setting _isPortrait to null means the
                    // dimensions will need to be looked up again
                    if (_this.hasFocusedTextInput() === false) {
                        _this._isPortrait = null;
                    }
                    _this.zone.run(function () { return _this.resize.emit(); });
                }, 200);
            }, { passive: true, zone: false });
        }, 2000);
    };
    // Platform Registry
    // **********************************************
    /**
     * @hidden
     */
    Platform.prototype.setPlatformConfigs = function (platformConfigs) {
        this._registry = platformConfigs || {};
    };
    /**
     * @hidden
     */
    Platform.prototype.getPlatformConfig = function (platformName) {
        return this._registry[platformName] || {};
    };
    /**
     * @hidden
     */
    Platform.prototype.registry = function () {
        return this._registry;
    };
    /**
     * @hidden
     */
    Platform.prototype.setDefault = function (platformName) {
        this._default = platformName;
    };
    /**
     * @hidden
     */
    Platform.prototype.testQuery = function (queryValue, queryTestValue) {
        var valueSplit = queryValue.toLowerCase().split(';');
        return valueSplit.indexOf(queryTestValue) > -1;
    };
    /**
     * @hidden
     */
    Platform.prototype.testNavigatorPlatform = function (navigatorPlatformExpression) {
        var rgx = new RegExp(navigatorPlatformExpression, 'i');
        return rgx.test(this._nPlt);
    };
    /**
     * @hidden
     */
    Platform.prototype.matchUserAgentVersion = function (userAgentExpression) {
        if (this._ua && userAgentExpression) {
            var val = this._ua.match(userAgentExpression);
            if (val) {
                return {
                    major: val[1],
                    minor: val[2]
                };
            }
        }
    };
    Platform.prototype.testUserAgent = function (expression) {
        if (this._ua) {
            return this._ua.indexOf(expression) >= 0;
        }
        return false;
    };
    /**
     * @hidden
     */
    Platform.prototype.isPlatformMatch = function (queryStringName, userAgentAtLeastHas, userAgentMustNotHave) {
        if (userAgentMustNotHave === void 0) { userAgentMustNotHave = []; }
        var queryValue = this._qp.get('ionicplatform');
        if (queryValue) {
            return this.testQuery(queryValue, queryStringName);
        }
        userAgentAtLeastHas = userAgentAtLeastHas || [queryStringName];
        var userAgent = this._ua.toLowerCase();
        for (var i = 0; i < userAgentAtLeastHas.length; i++) {
            if (userAgent.indexOf(userAgentAtLeastHas[i]) > -1) {
                for (var j = 0; j < userAgentMustNotHave.length; j++) {
                    if (userAgent.indexOf(userAgentMustNotHave[j]) > -1) {
                        return false;
                    }
                }
                return true;
            }
        }
        return false;
    };
    /** @hidden */
    Platform.prototype.init = function () {
        this._initEvents();
        var rootPlatformNode;
        var enginePlatformNode;
        // figure out the most specific platform and active engine
        var tmpPlt;
        for (var platformName in this._registry) {
            tmpPlt = this.matchPlatform(platformName);
            if (tmpPlt) {
                // we found a platform match!
                // check if its more specific than the one we already have
                if (tmpPlt.isEngine) {
                    // because it matched then this should be the active engine
                    // you cannot have more than one active engine
                    enginePlatformNode = tmpPlt;
                }
                else if (!rootPlatformNode || tmpPlt.depth > rootPlatformNode.depth) {
                    // only find the root node for platforms that are not engines
                    // set this node as the root since we either don't already
                    // have one, or this one is more specific that the current one
                    rootPlatformNode = tmpPlt;
                }
            }
        }
        if (!rootPlatformNode) {
            rootPlatformNode = new PlatformNode(this._registry, this._default);
        }
        // build a Platform instance filled with the
        // hierarchy of active platforms and settings
        if (rootPlatformNode) {
            // check if we found an engine node (cordova/node-webkit/etc)
            if (enginePlatformNode) {
                // add the engine to the first in the platform hierarchy
                // the original rootPlatformNode now becomes a child
                // of the engineNode, which is not the new root
                enginePlatformNode.child = rootPlatformNode;
                rootPlatformNode.parent = enginePlatformNode;
                rootPlatformNode = enginePlatformNode;
            }
            var platformNode = rootPlatformNode;
            while (platformNode) {
                insertSuperset(this._registry, platformNode);
                platformNode = platformNode.child;
            }
            // make sure the root noot is actually the root
            // incase a node was inserted before the root
            platformNode = rootPlatformNode.parent;
            while (platformNode) {
                rootPlatformNode = platformNode;
                platformNode = platformNode.parent;
            }
            platformNode = rootPlatformNode;
            while (platformNode) {
                platformNode.initialize(this);
                // extra check for ipad pro issue
                // https://forums.developer.apple.com/thread/25948
                if (platformNode.name === 'iphone' && this.navigatorPlatform() === 'iPad') {
                    // this is an ipad pro so push ipad and tablet to platforms
                    // and then return as we are done
                    this._platforms.push('tablet');
                    this._platforms.push('ipad');
                    return;
                }
                // set the array of active platforms with
                // the last one in the array the most important
                this._platforms.push(platformNode.name);
                // get the platforms version if a version parser was provided
                this._versions[platformNode.name] = platformNode.version(this);
                // go to the next platform child
                platformNode = platformNode.child;
            }
        }
        if (this._platforms.indexOf('mobile') > -1 && this._platforms.indexOf('cordova') === -1) {
            this._platforms.push('mobileweb');
        }
    };
    /**
     * @hidden
     */
    Platform.prototype.matchPlatform = function (platformName) {
        // build a PlatformNode and assign config data to it
        // use it's getRoot method to build up its hierarchy
        // depending on which platforms match
        var platformNode = new PlatformNode(this._registry, platformName);
        var rootNode = platformNode.getRoot(this);
        if (rootNode) {
            rootNode.depth = 0;
            var childPlatform = rootNode.child;
            while (childPlatform) {
                rootNode.depth++;
                childPlatform = childPlatform.child;
            }
        }
        return rootNode;
    };
    return Platform;
}());

function insertSuperset(registry, platformNode) {
    var supersetPlaformName = platformNode.superset();
    if (supersetPlaformName) {
        // add a platform in between two exist platforms
        // so we can build the correct hierarchy of active platforms
        var supersetPlatform = new PlatformNode(registry, supersetPlaformName);
        supersetPlatform.parent = platformNode.parent;
        supersetPlatform.child = platformNode;
        if (supersetPlatform.parent) {
            supersetPlatform.parent.child = supersetPlatform;
        }
        platformNode.parent = supersetPlatform;
    }
}
/**
 * @hidden
 */
var PlatformNode = (function () {
    function PlatformNode(registry, platformName) {
        this.registry = registry;
        this.c = registry[platformName];
        this.name = platformName;
        this.isEngine = this.c.isEngine;
    }
    PlatformNode.prototype.settings = function () {
        return this.c.settings || {};
    };
    PlatformNode.prototype.superset = function () {
        return this.c.superset;
    };
    PlatformNode.prototype.isMatch = function (p) {
        return this.c.isMatch && this.c.isMatch(p) || false;
    };
    PlatformNode.prototype.initialize = function (plt) {
        this.c.initialize && this.c.initialize(plt);
    };
    PlatformNode.prototype.version = function (plt) {
        if (this.c.versionParser) {
            var v = this.c.versionParser(plt);
            if (v) {
                var str = v.major + '.' + v.minor;
                return {
                    str: str,
                    num: parseFloat(str),
                    major: parseInt(v.major, 10),
                    minor: parseInt(v.minor, 10)
                };
            }
        }
    };
    PlatformNode.prototype.getRoot = function (plt) {
        if (this.isMatch(plt)) {
            var parents = this.getSubsetParents(this.name);
            if (!parents.length) {
                return this;
            }
            var platformNode = null;
            var rootPlatformNode = null;
            for (var i = 0; i < parents.length; i++) {
                platformNode = new PlatformNode(this.registry, parents[i]);
                platformNode.child = this;
                rootPlatformNode = platformNode.getRoot(plt);
                if (rootPlatformNode) {
                    this.parent = platformNode;
                    return rootPlatformNode;
                }
            }
        }
        return null;
    };
    PlatformNode.prototype.getSubsetParents = function (subsetPlatformName) {
        var parentPlatformNames = [];
        var pltConfig = null;
        for (var platformName in this.registry) {
            pltConfig = this.registry[platformName];
            if (pltConfig.subsets && pltConfig.subsets.indexOf(subsetPlatformName) > -1) {
                parentPlatformNames.push(platformName);
            }
        }
        return parentPlatformNames;
    };
    return PlatformNode;
}());
/**
 * @hidden
 */
function setupPlatform(doc, platformConfigs, zone) {
    var plt = new Platform();
    plt.setDefault('core');
    plt.setPlatformConfigs(platformConfigs);
    plt.setZone(zone);
    // set values from "document"
    var docElement = doc.documentElement;
    plt.setDocument(doc);
    var dir = docElement.dir;
    plt.setDir(dir === 'rtl' ? 'rtl' : 'ltr', !dir);
    plt.setLang(docElement.lang, false);
    // set css properties
    plt.setCssProps(docElement);
    // set values from "window"
    var win = doc.defaultView;
    plt.setWindow(win);
    plt.setNavigatorPlatform(win.navigator.platform);
    plt.setUserAgent(win.navigator.userAgent);
    // set location values
    plt.setQueryParams(win.location.href);
    plt.init();
    // add the platform obj to the window
    win['Ionic'] = win['Ionic'] || {};
    win['Ionic']['platform'] = plt;
    return plt;
}
//# sourceMappingURL=platform.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/platform/query-params.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QueryParams; });
/**
 * @hidden
 */
var QueryParams = (function () {
    function QueryParams() {
        this.data = {};
    }
    QueryParams.prototype.parseUrl = function (url) {
        if (url) {
            var startIndex = url.indexOf('?');
            if (startIndex > -1) {
                var queries = url.slice(startIndex + 1).split('&');
                for (var i = 0; i < queries.length; i++) {
                    if (queries[i].indexOf('=') > 0) {
                        var split = queries[i].split('=');
                        if (split.length > 1) {
                            this.data[split[0].toLowerCase()] = split[1].split('#')[0];
                        }
                    }
                }
            }
        }
    };
    QueryParams.prototype.get = function (key) {
        return this.data[key.toLowerCase()];
    };
    return QueryParams;
}());

//# sourceMappingURL=query-params.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/tap-click/activator-base.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ActivatorBase */
/* harmony export (immutable) */ __webpack_exports__["a"] = isActivatedDisabled;
var ActivatorBase = (function () {
    function ActivatorBase() {
    }
    return ActivatorBase;
}());

function isActivatedDisabled(ev, activatableEle) {
    if (!activatableEle || !activatableEle.parentNode) {
        return true;
    }
    if (!ev) {
        return false;
    }
    if (ev.defaultPrevented) {
        return true;
    }
    var targetEle = ev.target;
    for (var i = 0; i < 4; i++) {
        if (!targetEle) {
            break;
        }
        if (targetEle.hasAttribute('disable-activated')) {
            return true;
        }
        targetEle = targetEle.parentElement;
    }
    return false;
}
//# sourceMappingURL=activator-base.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/tap-click/activator.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Activator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__activator_base__ = __webpack_require__("./node_modules/ionic-angular/tap-click/activator-base.js");

var Activator = (function () {
    function Activator(app, config, dom) {
        this.app = app;
        this.dom = dom;
        this._queue = [];
        this._active = [];
        this.activatedDelay = ADD_ACTIVATED_DEFERS;
        this.clearDelay = CLEAR_STATE_DEFERS;
        this._css = config.get('activatedClass', 'activated');
    }
    Activator.prototype.clickAction = function (ev, activatableEle, _startCoord) {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__activator_base__["a" /* isActivatedDisabled */])(ev, activatableEle)) {
            return;
        }
        // a click happened, so immediately deactive all activated elements
        this._scheduleClear();
        this._queue.length = 0;
        for (var i = 0; i < this._active.length; i++) {
            this._active[i].classList.remove(this._css);
        }
        this._active.length = 0;
        // then immediately activate this element
        if (activatableEle && activatableEle.parentNode) {
            this._active.push(activatableEle);
            activatableEle.classList.add(this._css);
        }
    };
    Activator.prototype.downAction = function (ev, activatableEle, _startCoord) {
        var _this = this;
        // the user just pressed down
        if (Object(__WEBPACK_IMPORTED_MODULE_0__activator_base__["a" /* isActivatedDisabled */])(ev, activatableEle)) {
            return;
        }
        this.unscheduleClear();
        this.deactivate(true);
        // queue to have this element activated
        this._queue.push(activatableEle);
        this._activeDefer = this.dom.write(function () {
            _this._activeDefer = null;
            var activatableEle;
            for (var i = 0; i < _this._queue.length; i++) {
                activatableEle = _this._queue[i];
                _this._active.push(activatableEle);
                activatableEle.classList.add(_this._css);
            }
            _this._queue.length = 0;
        }, this.activatedDelay);
    };
    // the user was pressing down, then just let up
    Activator.prototype.upAction = function (_ev, _activatableEle, _startCoord) {
        this._scheduleClear();
    };
    Activator.prototype._scheduleClear = function () {
        var _this = this;
        if (this._clearDefer) {
            return;
        }
        this._clearDefer = this.dom.write(function () {
            _this.clearState(true);
            _this._clearDefer = null;
        }, this.clearDelay);
    };
    Activator.prototype.unscheduleClear = function () {
        if (this._clearDefer) {
            this._clearDefer();
            this._clearDefer = null;
        }
    };
    // all states should return to normal
    Activator.prototype.clearState = function (animated) {
        var _this = this;
        if (!this.app.isEnabled()) {
            // the app is actively disabled, so don't bother deactivating anything.
            // this makes it easier on the GPU so it doesn't have to redraw any
            // buttons during a transition. This will retry in XX milliseconds.
            this.dom.write(function () {
                _this.clearState(animated);
            }, 600);
        }
        else {
            // not actively transitioning, good to deactivate any elements
            this.deactivate(animated);
        }
    };
    // remove the active class from all active elements
    Activator.prototype.deactivate = function (animated) {
        this._clearDeferred();
        this._queue.length = 0;
        var ele;
        for (var i = 0; i < this._active.length; i++) {
            ele = this._active[i];
            ele.style[this.dom.plt.Css.transition] = animated ? '' : 'none';
            ele.classList.remove(this._css);
        }
        this._active.length = 0;
    };
    Activator.prototype._clearDeferred = function () {
        // Clear any active deferral
        if (this._activeDefer) {
            this._activeDefer();
            this._activeDefer = null;
        }
    };
    return Activator;
}());

var ADD_ACTIVATED_DEFERS = 80;
var CLEAR_STATE_DEFERS = 80;
//# sourceMappingURL=activator.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/tap-click/haptic.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Haptic; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__platform_platform__ = __webpack_require__("./node_modules/ionic-angular/platform/platform.js");


/**
 * @name Haptic
 * @description
 * The `Haptic` class interacts with a haptic engine on the device, if
 * available. Generally, Ionic components use this under the hood, but you're
 * welcome to get a bit crazy with it if you fancy.
 *
 * Currently, this uses the Taptic engine on iOS.
 *
 * @usage
 * ```ts
 * export class MyClass {
 *
 *  constructor(haptic: Haptic) {
 *    haptic.selection();
 *  }
 * }
 *
 * ```
 */
var Haptic = (function () {
    function Haptic(plt) {
        var _this = this;
        if (plt) {
            plt.ready().then(function () {
                _this._p = plt.win().TapticEngine;
            });
        }
    }
    /**
     * Check to see if the Haptic Plugin is available
     * @return {boolean} Returns true or false if the plugin is available
     *
     */
    Haptic.prototype.available = function () {
        return !!this._p;
    };
    /**
     * Trigger a selection changed haptic event. Good for one-time events
     * (not for gestures)
     */
    Haptic.prototype.selection = function () {
        this._p && this._p.selection();
    };
    /**
     * Tell the haptic engine that a gesture for a selection change is starting.
     */
    Haptic.prototype.gestureSelectionStart = function () {
        this._p && this._p.gestureSelectionStart();
    };
    /**
     * Tell the haptic engine that a selection changed during a gesture.
     */
    Haptic.prototype.gestureSelectionChanged = function () {
        this._p && this._p.gestureSelectionChanged();
    };
    /**
     * Tell the haptic engine we are done with a gesture. This needs to be
     * called lest resources are not properly recycled.
     */
    Haptic.prototype.gestureSelectionEnd = function () {
        this._p && this._p.gestureSelectionEnd();
    };
    /**
     * Use this to indicate success/failure/warning to the user.
     * options should be of the type `{ type: 'success' }` (or `warning`/`error`)
     */
    Haptic.prototype.notification = function (options) {
        this._p && this._p.notification(options);
    };
    /**
     * Use this to indicate success/failure/warning to the user.
     * options should be of the type `{ style: 'light' }` (or `medium`/`heavy`)
     */
    Haptic.prototype.impact = function (options) {
        this._p && this._p.impact(options);
    };
    Haptic.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    Haptic.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__platform_platform__["a" /* Platform */], },
    ]; };
    return Haptic;
}());

//# sourceMappingURL=haptic.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/tap-click/ripple.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RippleActivator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__activator_base__ = __webpack_require__("./node_modules/ionic-angular/tap-click/activator-base.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__activator__ = __webpack_require__("./node_modules/ionic-angular/tap-click/activator.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_dom__ = __webpack_require__("./node_modules/ionic-angular/util/dom.js");



/**
 * @hidden
 */
var RippleActivator = (function () {
    function RippleActivator(app, config, dom) {
        this.dom = dom;
        this.highlight = new __WEBPACK_IMPORTED_MODULE_1__activator__["a" /* Activator */](app, config, dom);
    }
    RippleActivator.prototype.clickAction = function (ev, activatableEle, startCoord) {
        // Highlight
        this.highlight && this.highlight.clickAction(ev, activatableEle, startCoord);
        // Ripple
        this._clickAction(ev, activatableEle, startCoord);
    };
    RippleActivator.prototype.downAction = function (ev, activatableEle, startCoord) {
        // Highlight
        this.highlight && this.highlight.downAction(ev, activatableEle, startCoord);
        // Ripple
        this._downAction(ev, activatableEle, startCoord);
    };
    RippleActivator.prototype.upAction = function (ev, activatableEle, startCoord) {
        // Highlight
        this.highlight && this.highlight.upAction(ev, activatableEle, startCoord);
        // Ripple
        this._upAction(ev, activatableEle, startCoord);
    };
    RippleActivator.prototype.clearState = function (animated) {
        // Highlight
        this.highlight && this.highlight.clearState(animated);
    };
    RippleActivator.prototype._downAction = function (ev, activatableEle, _startCoord) {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__activator_base__["a" /* isActivatedDisabled */])(ev, activatableEle)) {
            return;
        }
        var j = activatableEle.childElementCount;
        while (j--) {
            var rippleEle = activatableEle.children[j];
            if (rippleEle.classList.contains('button-effect')) {
                // DOM READ
                var clientRect = activatableEle.getBoundingClientRect();
                rippleEle.$top = clientRect.top;
                rippleEle.$left = clientRect.left;
                rippleEle.$width = clientRect.width;
                rippleEle.$height = clientRect.height;
                break;
            }
        }
    };
    RippleActivator.prototype._upAction = function (ev, activatableEle, startCoord) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_2__util_dom__["d" /* hasPointerMoved */])(6, startCoord, Object(__WEBPACK_IMPORTED_MODULE_2__util_dom__["f" /* pointerCoord */])(ev))) {
            var i = activatableEle.childElementCount;
            while (i--) {
                var rippleEle = activatableEle.children[i];
                if (rippleEle.classList.contains('button-effect')) {
                    // DOM WRITE
                    this.startRippleEffect(rippleEle, activatableEle, startCoord);
                    break;
                }
            }
        }
    };
    RippleActivator.prototype._clickAction = function (_ev, _activatableEle, _startCoord) {
        // NOTHING
    };
    RippleActivator.prototype.startRippleEffect = function (rippleEle, activatableEle, startCoord) {
        if (!startCoord) {
            return;
        }
        var clientPointerX = (startCoord.x - rippleEle.$left);
        var clientPointerY = (startCoord.y - rippleEle.$top);
        var x = Math.max(Math.abs(rippleEle.$width - clientPointerX), clientPointerX) * 2;
        var y = Math.max(Math.abs(rippleEle.$height - clientPointerY), clientPointerY) * 2;
        var diameter = Math.min(Math.max(Math.hypot(x, y), 64), 240);
        if (activatableEle.hasAttribute('ion-item')) {
            diameter = Math.min(diameter, 140);
        }
        clientPointerX -= diameter / 2;
        clientPointerY -= diameter / 2;
        clientPointerX = Math.round(clientPointerX);
        clientPointerY = Math.round(clientPointerY);
        diameter = Math.round(diameter);
        // Reset ripple
        // DOM WRITE
        var Css = this.dom.plt.Css;
        rippleEle.style.opacity = '';
        rippleEle.style[Css.transform] = "translate3d(" + clientPointerX + "px, " + clientPointerY + "px, 0px) scale(0.001)";
        rippleEle.style[Css.transition] = '';
        // Start ripple animation
        var radius = Math.sqrt(rippleEle.$width + rippleEle.$height);
        var scaleTransitionDuration = Math.max(1600 * Math.sqrt(radius / TOUCH_DOWN_ACCEL) + 0.5, 260);
        var opacityTransitionDuration = Math.round(scaleTransitionDuration * 0.7);
        var opacityTransitionDelay = Math.round(scaleTransitionDuration - opacityTransitionDuration);
        scaleTransitionDuration = Math.round(scaleTransitionDuration);
        var transform = "translate3d(" + clientPointerX + "px, " + clientPointerY + "px, 0px) scale(1)";
        var transition = "transform " + scaleTransitionDuration + "ms,opacity " + opacityTransitionDuration + "ms " + opacityTransitionDelay + "ms";
        this.dom.write(function () {
            // DOM WRITE
            rippleEle.style.width = rippleEle.style.height = diameter + 'px';
            rippleEle.style.opacity = '0';
            rippleEle.style[Css.transform] = transform;
            rippleEle.style[Css.transition] = transition;
        }, 16);
    };
    return RippleActivator;
}());

var TOUCH_DOWN_ACCEL = 300;
//# sourceMappingURL=ripple.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/tap-click/tap-click.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TapClick; });
/* harmony export (immutable) */ __webpack_exports__["b"] = isActivatable;
/* harmony export (immutable) */ __webpack_exports__["c"] = setupTapClick;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__activator__ = __webpack_require__("./node_modules/ionic-angular/tap-click/activator.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_app__ = __webpack_require__("./node_modules/ionic-angular/components/app/app.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__platform_dom_controller__ = __webpack_require__("./node_modules/ionic-angular/platform/dom-controller.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__gestures_gesture_controller__ = __webpack_require__("./node_modules/ionic-angular/gestures/gesture-controller.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__platform_platform__ = __webpack_require__("./node_modules/ionic-angular/platform/platform.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_dom__ = __webpack_require__("./node_modules/ionic-angular/util/dom.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__gestures_pointer_events__ = __webpack_require__("./node_modules/ionic-angular/gestures/pointer-events.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ripple__ = __webpack_require__("./node_modules/ionic-angular/tap-click/ripple.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__gestures_ui_event_manager__ = __webpack_require__("./node_modules/ionic-angular/gestures/ui-event-manager.js");











/**
 * @hidden
 */
var TapClick = (function () {
    function TapClick(config, plt, dom, app, gestureCtrl) {
        this.plt = plt;
        this.app = app;
        this.gestureCtrl = gestureCtrl;
        this.disableClick = 0;
        this.events = new __WEBPACK_IMPORTED_MODULE_10__gestures_ui_event_manager__["a" /* UIEventManager */](plt);
        var activator = config.get('activator');
        if (activator === 'ripple') {
            this.activator = new __WEBPACK_IMPORTED_MODULE_9__ripple__["a" /* RippleActivator */](app, config, dom);
        }
        else if (activator === 'highlight') {
            this.activator = new __WEBPACK_IMPORTED_MODULE_1__activator__["a" /* Activator */](app, config, dom);
        }
        this.usePolyfill = config.getBoolean('tapPolyfill');
        (void 0) /* console.debug */;
        var doc = plt.doc();
        this.events.listen(doc, 'click', this.click.bind(this), { passive: false, capture: true });
        this.pointerEvents = this.events.pointerEvents({
            element: doc,
            pointerDown: this.pointerStart.bind(this),
            pointerMove: this.pointerMove.bind(this),
            pointerUp: this.pointerEnd.bind(this),
            passive: true
        });
        this.pointerEvents.mouseWait = DISABLE_NATIVE_CLICK_AMOUNT;
    }
    TapClick.prototype.pointerStart = function (ev) {
        if (this.startCoord) {
            return false;
        }
        if (!this.app.isEnabled()) {
            return false;
        }
        this.lastTouchEnd = 0;
        this.dispatchClick = true;
        if (this.plt.doc() === ev.target) {
            this.startCoord = Object(__WEBPACK_IMPORTED_MODULE_7__util_dom__["f" /* pointerCoord */])(ev);
            return true;
        }
        this.activatableEle = getActivatableTarget(ev.target);
        if (!this.activatableEle) {
            this.startCoord = null;
            return false;
        }
        this.startCoord = Object(__WEBPACK_IMPORTED_MODULE_7__util_dom__["f" /* pointerCoord */])(ev);
        this.activator && this.activator.downAction(ev, this.activatableEle, this.startCoord);
        return true;
    };
    TapClick.prototype.pointerMove = function (ev) {
        if (this.startCoord && this.shouldCancelEvent(ev)) {
            this.pointerCancel(ev);
        }
    };
    TapClick.prototype.pointerEnd = function (ev, pointerEventType) {
        if (!this.dispatchClick)
            return;
        (void 0) /* runInDev */;
        if (!this.startCoord) {
            return;
        }
        if (this.activator && ev.target !== this.plt.doc()) {
            var activatableEle = getActivatableTarget(ev.target) || this.activatableEle;
            if (activatableEle) {
                this.activator.upAction(ev, activatableEle, this.startCoord);
            }
        }
        if (this.usePolyfill && pointerEventType === __WEBPACK_IMPORTED_MODULE_8__gestures_pointer_events__["a" /* POINTER_EVENT_TYPE_TOUCH */] && this.app.isEnabled()) {
            this.handleTapPolyfill(ev);
        }
        this.startCoord = null;
        this.activatableEle = null;
    };
    TapClick.prototype.pointerCancel = function (ev) {
        (void 0) /* console.debug */;
        this.startCoord = null;
        this.activatableEle = null;
        this.dispatchClick = false;
        this.activator && this.activator.clearState(false);
        this.pointerEvents.stop();
    };
    TapClick.prototype.shouldCancelEvent = function (ev) {
        return (this.app.isScrolling() ||
            this.gestureCtrl.isCaptured() ||
            Object(__WEBPACK_IMPORTED_MODULE_7__util_dom__["d" /* hasPointerMoved */])(POINTER_TOLERANCE, this.startCoord, Object(__WEBPACK_IMPORTED_MODULE_7__util_dom__["f" /* pointerCoord */])(ev)));
    };
    TapClick.prototype.click = function (ev) {
        if (this.shouldCancelClick(ev)) {
            ev.preventDefault();
            ev.stopPropagation();
            return;
        }
        if (this.activator && this.plt.doc() !== ev.target) {
            // cool, a click is gonna happen, let's tell the activator
            // so the element can get the given "active" style
            var activatableEle = getActivatableTarget(ev.target);
            if (activatableEle) {
                this.activator.clickAction(ev, activatableEle, this.startCoord);
            }
        }
        (void 0) /* runInDev */;
    };
    TapClick.prototype.shouldCancelClick = function (ev) {
        if (this.usePolyfill) {
            if (!ev.isIonicTap && this.isDisabledNativeClick()) {
                (void 0) /* console.debug */;
                return true;
            }
        }
        else if (!this.dispatchClick) {
            (void 0) /* console.debug */;
            return true;
        }
        if (!this.app.isEnabled()) {
            (void 0) /* console.debug */;
            return true;
        }
        if (this.gestureCtrl.isCaptured()) {
            (void 0) /* console.debug */;
            return true;
        }
        return false;
    };
    TapClick.prototype.profileClickDelay = function (ev) {
        if (this.lastTouchEnd) {
            var diff = Date.now() - this.lastTouchEnd;
            if (diff < 100) {
                (void 0) /* console.debug */;
            }
            else {
                console.warn("SLOW click dispatched. Delay(ms):", diff, ev);
            }
            this.lastTouchEnd = null;
        }
        else {
            (void 0) /* console.debug */;
        }
    };
    TapClick.prototype.handleTapPolyfill = function (ev) {
        (void 0) /* assert */;
        // only dispatch mouse click events from a touchend event
        // when tapPolyfill config is true, and the startCoordand endCoord
        // are not too far off from each other
        var endCoord = Object(__WEBPACK_IMPORTED_MODULE_7__util_dom__["f" /* pointerCoord */])(ev);
        if (Object(__WEBPACK_IMPORTED_MODULE_7__util_dom__["d" /* hasPointerMoved */])(POINTER_TOLERANCE, this.startCoord, endCoord)) {
            (void 0) /* console.debug */;
            return;
        }
        // prevent native mouse click events for XX amount of time
        this.disableClick = Date.now() + DISABLE_NATIVE_CLICK_AMOUNT;
        if (this.app.isScrolling()) {
            // do not fire off a click event while the app was scrolling
            (void 0) /* console.debug */;
        }
        else {
            // dispatch a mouse click event
            (void 0) /* console.debug */;
            var clickEvent = this.plt.doc().createEvent('MouseEvents');
            clickEvent.initMouseEvent('click', true, true, this.plt.win(), 1, 0, 0, endCoord.x, endCoord.y, false, false, false, false, 0, null);
            clickEvent.isIonicTap = true;
            ev.target.dispatchEvent(clickEvent);
        }
    };
    TapClick.prototype.isDisabledNativeClick = function () {
        return this.disableClick > Date.now();
    };
    TapClick.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    TapClick.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_3__config_config__["a" /* Config */], },
        { type: __WEBPACK_IMPORTED_MODULE_6__platform_platform__["a" /* Platform */], },
        { type: __WEBPACK_IMPORTED_MODULE_4__platform_dom_controller__["a" /* DomController */], },
        { type: __WEBPACK_IMPORTED_MODULE_2__components_app_app__["a" /* App */], },
        { type: __WEBPACK_IMPORTED_MODULE_5__gestures_gesture_controller__["m" /* GestureController */], },
    ]; };
    return TapClick;
}());

function getActivatableTarget(ele) {
    var targetEle = ele;
    for (var x = 0; x < 10; x++) {
        if (!targetEle)
            break;
        if (isActivatable(targetEle)) {
            return targetEle;
        }
        targetEle = targetEle.parentElement;
    }
    return null;
}
/**
 * @hidden
 */
function isActivatable(ele) {
    if (ACTIVATABLE_ELEMENTS.indexOf(ele.tagName) > -1) {
        return true;
    }
    for (var i = 0, l = ACTIVATABLE_ATTRIBUTES.length; i < l; i++) {
        if (ele.hasAttribute && ele.hasAttribute(ACTIVATABLE_ATTRIBUTES[i])) {
            return true;
        }
    }
    return false;
}
var ACTIVATABLE_ELEMENTS = ['A', 'BUTTON'];
var ACTIVATABLE_ATTRIBUTES = ['tappable', 'ion-button'];
var POINTER_TOLERANCE = 100;
var DISABLE_NATIVE_CLICK_AMOUNT = 2500;
/**
 * @hidden
 */
function setupTapClick(config, plt, dom, app, gestureCtrl) {
    return function () {
        return new TapClick(config, plt, dom, app, gestureCtrl);
    };
}
//# sourceMappingURL=tap-click.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/transitions/page-transition.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageTransition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__animations_animation__ = __webpack_require__("./node_modules/ionic-angular/animations/animation.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__transition__ = __webpack_require__("./node_modules/ionic-angular/transitions/transition.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


/**
 * @hidden
 */
var PageTransition = (function (_super) {
    __extends(PageTransition, _super);
    function PageTransition() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PageTransition.prototype.init = function () {
        var _this = this;
        if (this.enteringView) {
            this.enteringPage = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](this.plt, this.enteringView.pageRef());
            this.add(this.enteringPage.beforeAddClass('show-page'));
            // Resize content before transition starts
            this.beforeAddRead(function () {
                _this.enteringView.readReady.emit();
            });
            this.beforeAddWrite(function () {
                _this.enteringView.writeReady.emit();
            });
        }
    };
    PageTransition.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
        this.enteringPage && this.enteringPage.destroy();
        this.enteringPage = null;
    };
    return PageTransition;
}(__WEBPACK_IMPORTED_MODULE_1__transition__["a" /* Transition */]));

//# sourceMappingURL=page-transition.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/transitions/transition-controller.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TransitionController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_config__ = __webpack_require__("./node_modules/ionic-angular/config/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__platform_platform__ = __webpack_require__("./node_modules/ionic-angular/platform/platform.js");




/**
 * @hidden
 */
var TransitionController = (function () {
    function TransitionController(plt, _config) {
        this.plt = plt;
        this._config = _config;
        this._ids = 0;
        this._trns = {};
    }
    TransitionController.prototype.getRootTrnsId = function (nav) {
        nav = nav.parent;
        while (nav) {
            if (Object(__WEBPACK_IMPORTED_MODULE_2__util_util__["l" /* isPresent */])(nav._trnsId)) {
                return nav._trnsId;
            }
            nav = nav.parent;
        }
        return null;
    };
    TransitionController.prototype.nextId = function () {
        return this._ids++;
    };
    TransitionController.prototype.get = function (trnsId, enteringView, leavingView, opts) {
        var TransitionClass = this._config.getTransition(opts.animation);
        if (!TransitionClass) {
            // didn't find a transition animation, default to ios-transition
            TransitionClass = this._config.getTransition('ios-transition');
        }
        var trns = new TransitionClass(this.plt, enteringView, leavingView, opts);
        trns.trnsId = trnsId;
        if (!this._trns[trnsId]) {
            // we haven't created the root transition yet
            this._trns[trnsId] = trns;
        }
        else {
            // we already have a root transition created
            // add this new transition as a child to the root
            this._trns[trnsId].add(trns);
        }
        return trns;
    };
    TransitionController.prototype.destroy = function (trnsId) {
        var trans = this._trns[trnsId];
        if (trans) {
            trans.destroy();
            delete this._trns[trnsId];
        }
    };
    TransitionController.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    TransitionController.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_3__platform_platform__["a" /* Platform */], },
        { type: __WEBPACK_IMPORTED_MODULE_1__config_config__["a" /* Config */], },
    ]; };
    return TransitionController;
}());

//# sourceMappingURL=transition-controller.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/transitions/transition-ios.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IOSTransition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__animations_animation__ = __webpack_require__("./node_modules/ionic-angular/animations/animation.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__page_transition__ = __webpack_require__("./node_modules/ionic-angular/transitions/page-transition.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var DURATION = 500;
var EASING = 'cubic-bezier(0.36,0.66,0.04,1)';
var OPACITY = 'opacity';
var TRANSFORM = 'transform';
var TRANSLATEX = 'translateX';
var CENTER = '0%';
var OFF_OPACITY = 0.8;
var SHOW_BACK_BTN_CSS = 'show-back-button';
var IOSTransition = (function (_super) {
    __extends(IOSTransition, _super);
    function IOSTransition() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IOSTransition.prototype.init = function () {
        _super.prototype.init.call(this);
        var plt = this.plt;
        var OFF_RIGHT = plt.isRTL ? '-99.5%' : '99.5%';
        var OFF_LEFT = plt.isRTL ? '33%' : '-33%';
        var enteringView = this.enteringView;
        var leavingView = this.leavingView;
        var opts = this.opts;
        this.duration(Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["l" /* isPresent */])(opts.duration) ? opts.duration : DURATION);
        this.easing(Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["l" /* isPresent */])(opts.easing) ? opts.easing : EASING);
        var backDirection = (opts.direction === 'back');
        var enteringHasNavbar = (enteringView && enteringView.hasNavbar());
        var leavingHasNavbar = (leavingView && leavingView.hasNavbar());
        if (enteringView) {
            // get the native element for the entering page
            var enteringPageEle = enteringView.pageRef().nativeElement;
            // entering content
            var enteringContent = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](plt, enteringView.contentRef());
            enteringContent.element(enteringPageEle.querySelectorAll('ion-header > *:not(ion-navbar),ion-footer > *'));
            this.add(enteringContent);
            if (backDirection) {
                // entering content, back direction
                enteringContent
                    .fromTo(TRANSLATEX, OFF_LEFT, CENTER, true)
                    .fromTo(OPACITY, OFF_OPACITY, 1, true);
            }
            else {
                // entering content, forward direction
                enteringContent
                    .beforeClearStyles([OPACITY])
                    .fromTo(TRANSLATEX, OFF_RIGHT, CENTER, true);
            }
            if (enteringHasNavbar) {
                // entering page has a navbar
                var enteringNavbarEle = enteringPageEle.querySelector('ion-navbar');
                var enteringNavBar = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](plt, enteringNavbarEle);
                this.add(enteringNavBar);
                var enteringTitle = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](plt, enteringNavbarEle.querySelector('ion-title'));
                var enteringNavbarItems = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](plt, enteringNavbarEle.querySelectorAll('ion-buttons,[menuToggle]'));
                var enteringNavbarBg = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](plt, enteringNavbarEle.querySelector('.toolbar-background'));
                var enteringBackButton = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](plt, enteringNavbarEle.querySelector('.back-button'));
                enteringNavBar
                    .add(enteringTitle)
                    .add(enteringNavbarItems)
                    .add(enteringNavbarBg)
                    .add(enteringBackButton);
                enteringTitle.fromTo(OPACITY, 0.01, 1, true);
                enteringNavbarItems.fromTo(OPACITY, 0.01, 1, true);
                // set properties depending on direction
                if (backDirection) {
                    // entering navbar, back direction
                    enteringTitle.fromTo(TRANSLATEX, OFF_LEFT, CENTER, true);
                    if (enteringView.enableBack()) {
                        // back direction, entering page has a back button
                        enteringBackButton
                            .beforeAddClass(SHOW_BACK_BTN_CSS)
                            .fromTo(OPACITY, 0.01, 1, true);
                    }
                }
                else {
                    // entering navbar, forward direction
                    enteringTitle.fromTo(TRANSLATEX, OFF_RIGHT, CENTER, true);
                    enteringNavbarBg
                        .beforeClearStyles([OPACITY])
                        .fromTo(TRANSLATEX, OFF_RIGHT, CENTER, true);
                    if (enteringView.enableBack()) {
                        // forward direction, entering page has a back button
                        enteringBackButton
                            .beforeAddClass(SHOW_BACK_BTN_CSS)
                            .fromTo(OPACITY, 0.01, 1, true);
                        var enteringBackBtnText = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](plt, enteringNavbarEle.querySelector('.back-button-text'));
                        enteringBackBtnText.fromTo(TRANSLATEX, (plt.isRTL ? '-100px' : '100px'), '0px');
                        enteringNavBar.add(enteringBackBtnText);
                    }
                    else {
                        enteringBackButton.beforeRemoveClass(SHOW_BACK_BTN_CSS);
                    }
                }
            }
        }
        // setup leaving view
        if (leavingView && leavingView.pageRef()) {
            // leaving content
            var leavingPageEle = leavingView.pageRef().nativeElement;
            var leavingContent = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](plt, leavingView.contentRef());
            leavingContent.element(leavingPageEle.querySelectorAll('ion-header > *:not(ion-navbar),ion-footer > *'));
            this.add(leavingContent);
            if (backDirection) {
                // leaving content, back direction
                leavingContent
                    .beforeClearStyles([OPACITY])
                    .fromTo(TRANSLATEX, CENTER, (plt.isRTL ? '-100%' : '100%'));
            }
            else {
                // leaving content, forward direction
                leavingContent
                    .fromTo(TRANSLATEX, CENTER, OFF_LEFT)
                    .fromTo(OPACITY, 1, OFF_OPACITY)
                    .afterClearStyles([TRANSFORM, OPACITY]);
            }
            if (leavingHasNavbar) {
                // leaving page has a navbar
                var leavingNavbarEle = leavingPageEle.querySelector('ion-navbar');
                var leavingNavBar = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](plt, leavingNavbarEle);
                var leavingTitle = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](plt, leavingNavbarEle.querySelector('ion-title'));
                var leavingNavbarItems = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](plt, leavingNavbarEle.querySelectorAll('ion-buttons,[menuToggle]'));
                var leavingNavbarBg = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](plt, leavingNavbarEle.querySelector('.toolbar-background'));
                var leavingBackButton = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](plt, leavingNavbarEle.querySelector('.back-button'));
                leavingNavBar
                    .add(leavingTitle)
                    .add(leavingNavbarItems)
                    .add(leavingBackButton)
                    .add(leavingNavbarBg);
                this.add(leavingNavBar);
                // fade out leaving navbar items
                leavingBackButton.fromTo(OPACITY, 0.99, 0);
                leavingTitle.fromTo(OPACITY, 0.99, 0);
                leavingNavbarItems.fromTo(OPACITY, 0.99, 0);
                if (backDirection) {
                    // leaving navbar, back direction
                    leavingTitle.fromTo(TRANSLATEX, CENTER, (plt.isRTL ? '-100%' : '100%'));
                    // leaving navbar, back direction, and there's no entering navbar
                    // should just slide out, no fading out
                    leavingNavbarBg
                        .beforeClearStyles([OPACITY])
                        .fromTo(TRANSLATEX, CENTER, (plt.isRTL ? '-100%' : '100%'));
                    var leavingBackBtnText = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](plt, leavingNavbarEle.querySelector('.back-button-text'));
                    leavingBackBtnText.fromTo(TRANSLATEX, CENTER, (plt.isRTL ? -300 : 300) + 'px');
                    leavingNavBar.add(leavingBackBtnText);
                }
                else {
                    // leaving navbar, forward direction
                    leavingTitle
                        .fromTo(TRANSLATEX, CENTER, OFF_LEFT)
                        .afterClearStyles([TRANSFORM]);
                    leavingBackButton.afterClearStyles([OPACITY]);
                    leavingTitle.afterClearStyles([OPACITY]);
                    leavingNavbarItems.afterClearStyles([OPACITY]);
                }
            }
        }
    };
    return IOSTransition;
}(__WEBPACK_IMPORTED_MODULE_2__page_transition__["a" /* PageTransition */]));

//# sourceMappingURL=transition-ios.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/transitions/transition-md.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MDTransition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__animations_animation__ = __webpack_require__("./node_modules/ionic-angular/animations/animation.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__page_transition__ = __webpack_require__("./node_modules/ionic-angular/transitions/page-transition.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var TRANSLATEY = 'translateY';
var OFF_BOTTOM = '40px';
var CENTER = '0px';
var SHOW_BACK_BTN_CSS = 'show-back-button';
var MDTransition = (function (_super) {
    __extends(MDTransition, _super);
    function MDTransition() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MDTransition.prototype.init = function () {
        _super.prototype.init.call(this);
        var plt = this.plt;
        var enteringView = this.enteringView;
        var leavingView = this.leavingView;
        var opts = this.opts;
        // what direction is the transition going
        var backDirection = (opts.direction === 'back');
        if (enteringView) {
            if (backDirection) {
                this.duration(Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["l" /* isPresent */])(opts.duration) ? opts.duration : 200).easing('cubic-bezier(0.47,0,0.745,0.715)');
            }
            else {
                this.duration(Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["l" /* isPresent */])(opts.duration) ? opts.duration : 280).easing('cubic-bezier(0.36,0.66,0.04,1)');
                this.enteringPage
                    .fromTo(TRANSLATEY, OFF_BOTTOM, CENTER, true)
                    .fromTo('opacity', 0.01, 1, true);
            }
            if (enteringView.hasNavbar()) {
                var enteringPageEle = enteringView.pageRef().nativeElement;
                var enteringNavbarEle = enteringPageEle.querySelector('ion-navbar');
                var enteringNavBar = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](plt, enteringNavbarEle);
                this.add(enteringNavBar);
                var enteringBackButton = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](plt, enteringNavbarEle.querySelector('.back-button'));
                this.add(enteringBackButton);
                if (enteringView.enableBack()) {
                    enteringBackButton.beforeAddClass(SHOW_BACK_BTN_CSS);
                }
                else {
                    enteringBackButton.beforeRemoveClass(SHOW_BACK_BTN_CSS);
                }
            }
        }
        // setup leaving view
        if (leavingView && backDirection) {
            // leaving content
            this.duration(opts.duration || 200).easing('cubic-bezier(0.47,0,0.745,0.715)');
            var leavingPage = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](plt, leavingView.pageRef());
            this.add(leavingPage.fromTo(TRANSLATEY, CENTER, OFF_BOTTOM).fromTo('opacity', 1, 0));
        }
    };
    return MDTransition;
}(__WEBPACK_IMPORTED_MODULE_2__page_transition__["a" /* PageTransition */]));

//# sourceMappingURL=transition-md.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/transitions/transition-wp.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WPTransition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__animations_animation__ = __webpack_require__("./node_modules/ionic-angular/animations/animation.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__page_transition__ = __webpack_require__("./node_modules/ionic-angular/transitions/page-transition.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var SHOW_BACK_BTN_CSS = 'show-back-button';
var SCALE_SMALL = .95;
var WPTransition = (function (_super) {
    __extends(WPTransition, _super);
    function WPTransition() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WPTransition.prototype.init = function () {
        _super.prototype.init.call(this);
        var plt = this.plt;
        var enteringView = this.enteringView;
        var leavingView = this.leavingView;
        var opts = this.opts;
        // what direction is the transition going
        var backDirection = (opts.direction === 'back');
        if (enteringView) {
            if (backDirection) {
                this.duration(Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["l" /* isPresent */])(opts.duration) ? opts.duration : 120).easing('cubic-bezier(0.47,0,0.745,0.715)');
                this.enteringPage.beforeClearStyles(['scale']);
            }
            else {
                this.duration(Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["l" /* isPresent */])(opts.duration) ? opts.duration : 280).easing('cubic-bezier(0,0,0.05,1)');
                this.enteringPage
                    .fromTo('scale', SCALE_SMALL, 1, true)
                    .fromTo('opacity', 0.01, 1, true);
            }
            if (enteringView.hasNavbar()) {
                var enteringPageEle = enteringView.pageRef().nativeElement;
                var enteringNavbarEle = enteringPageEle.querySelector('ion-navbar');
                var enteringNavBar = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](plt, enteringNavbarEle);
                this.add(enteringNavBar);
                var enteringBackButton = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](plt, enteringNavbarEle.querySelector('.back-button'));
                this.add(enteringBackButton);
                if (enteringView.enableBack()) {
                    enteringBackButton.beforeAddClass(SHOW_BACK_BTN_CSS);
                }
                else {
                    enteringBackButton.beforeRemoveClass(SHOW_BACK_BTN_CSS);
                }
            }
        }
        // setup leaving view
        if (leavingView && backDirection) {
            // leaving content
            this.duration(opts.duration || 200).easing('cubic-bezier(0.47,0,0.745,0.715)');
            var leavingPage = new __WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */](plt, leavingView.pageRef());
            this.add(leavingPage.fromTo('scale', 1, SCALE_SMALL).fromTo('opacity', 0.99, 0));
        }
    };
    return WPTransition;
}(__WEBPACK_IMPORTED_MODULE_2__page_transition__["a" /* PageTransition */]));

//# sourceMappingURL=transition-wp.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/transitions/transition.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Transition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__animations_animation__ = __webpack_require__("./node_modules/ionic-angular/animations/animation.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

/**
 * @hidden
 *
 * - play
 * - Add before classes - DOM WRITE
 * - Remove before classes - DOM WRITE
 * - Add before inline styles - DOM WRITE
 * - set inline FROM styles - DOM WRITE
 * - RAF
 * - read toolbar dimensions - DOM READ
 * - write content top/bottom padding - DOM WRITE
 * - set css transition duration/easing - DOM WRITE
 * - RAF
 * - set inline TO styles - DOM WRITE
 */
var Transition = (function (_super) {
    __extends(Transition, _super);
    function Transition(plt, enteringView, leavingView, opts) {
        var _this = _super.call(this, plt, null, opts) || this;
        _this.enteringView = enteringView;
        _this.leavingView = leavingView;
        return _this;
    }
    Transition.prototype.init = function () { };
    Transition.prototype.registerStart = function (trnsStart) {
        this._trnsStart = trnsStart;
    };
    Transition.prototype.start = function () {
        this._trnsStart && this._trnsStart();
        this._trnsStart = null;
        // bubble up start
        this.parent && this.parent.start();
    };
    Transition.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
        this.parent = this.enteringView = this.leavingView = this._trnsStart = null;
    };
    return Transition;
}(__WEBPACK_IMPORTED_MODULE_0__animations_animation__["a" /* Animation */]));

//# sourceMappingURL=transition.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/util/base-input.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseInput; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ion__ = __webpack_require__("./node_modules/ionic-angular/components/ion.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__debouncer__ = __webpack_require__("./node_modules/ionic-angular/util/debouncer.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var BaseInput = (function (_super) {
    __extends(BaseInput, _super);
    function BaseInput(config, elementRef, renderer, name, _defaultValue, _form, _item, _ngControl) {
        var _this = _super.call(this, config, elementRef, renderer, name) || this;
        _this._defaultValue = _defaultValue;
        _this._form = _form;
        _this._item = _item;
        _this._ngControl = _ngControl;
        _this._isFocus = false;
        _this._disabled = false;
        _this._debouncer = new __WEBPACK_IMPORTED_MODULE_3__debouncer__["a" /* TimeoutDebouncer */](0);
        _this._init = false;
        _this._initModel = false;
        /**
         * @output {Range} Emitted when the range selector drag starts.
         */
        _this.ionFocus = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
         * @output {Range} Emitted when the range value changes.
         */
        _this.ionChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
         * @output {Range} Emitted when the range selector drag ends.
         */
        _this.ionBlur = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        _form && _form.register(_this);
        _this._value = Object(__WEBPACK_IMPORTED_MODULE_1__util__["b" /* deepCopy */])(_this._defaultValue);
        if (_item) {
            (void 0) /* assert */;
            _this.id = name + '-' + _item.registerInput(name);
            _this._labelId = _item.labelId;
            _this._item.setElementClass('item-' + name, true);
        }
        // If the user passed a ngControl we need to set the valueAccessor
        if (_ngControl) {
            _ngControl.valueAccessor = _this;
        }
        return _this;
    }
    Object.defineProperty(BaseInput.prototype, "disabled", {
        /**
         * @input {boolean} If true, the user cannot interact with this element.
         */
        get: function () {
            return this._disabled;
        },
        set: function (val) {
            this.setDisabledState(val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BaseInput.prototype, "value", {
        get: function () {
            return this._value;
        },
        set: function (val) {
            if (this._writeValue(val)) {
                this.onChange();
                this._fireIonChange();
            }
        },
        enumerable: true,
        configurable: true
    });
    // 1. Updates the value
    // 2. Calls _inputUpdated()
    // 3. Dispatch onChange events
    BaseInput.prototype.setValue = function (val) {
        this.value = val;
    };
    /**
     * @hidden
     */
    BaseInput.prototype.setDisabledState = function (isDisabled) {
        this._disabled = isDisabled = Object(__WEBPACK_IMPORTED_MODULE_1__util__["o" /* isTrueProperty */])(isDisabled);
        this._item && this._item.setElementClass("item-" + this._componentName + "-disabled", isDisabled);
    };
    /**
     * @hidden
     */
    BaseInput.prototype.writeValue = function (val) {
        if (this._writeValue(val)) {
            if (this._initModel) {
                this._fireIonChange();
            }
            else if (this._init) {
                // ngModel fires the first time too late, we need to skip the first ngModel update
                this._initModel = true;
            }
        }
    };
    /**
     * @hidden
     */
    BaseInput.prototype._writeValue = function (val) {
        (void 0) /* assert */;
        if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["p" /* isUndefined */])(val)) {
            return false;
        }
        var normalized = (val === null)
            ? Object(__WEBPACK_IMPORTED_MODULE_1__util__["b" /* deepCopy */])(this._defaultValue)
            : this._inputNormalize(val);
        var notUpdate = Object(__WEBPACK_IMPORTED_MODULE_1__util__["p" /* isUndefined */])(normalized) || !this._inputShouldChange(normalized);
        if (notUpdate) {
            return false;
        }
        (void 0) /* console.debug */;
        this._value = normalized;
        if (this._init) {
            this._inputUpdated();
        }
        return true;
    };
    /**
     * @hidden
     */
    BaseInput.prototype._fireIonChange = function () {
        var _this = this;
        if (this._init) {
            this._debouncer.debounce(function () {
                (void 0) /* assert */;
                _this.ionChange.emit(_this._inputChangeEvent());
                _this._initModel = true;
            });
        }
    };
    /**
     * @hidden
     */
    BaseInput.prototype.registerOnChange = function (fn) {
        this._onChanged = fn;
    };
    /**
     * @hidden
     */
    BaseInput.prototype.registerOnTouched = function (fn) {
        this._onTouched = fn;
    };
    /**
     * @hidden
     */
    BaseInput.prototype._initialize = function () {
        if (this._init) {
            (void 0) /* assert */;
            return;
        }
        this._init = true;
        if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["l" /* isPresent */])(this._value)) {
            this._inputUpdated();
        }
    };
    /**
     * @hidden
     */
    BaseInput.prototype._fireFocus = function () {
        if (this._isFocus) {
            return;
        }
        (void 0) /* console.debug */;
        this._form && this._form.setAsFocused(this);
        this._setFocus(true);
        this.ionFocus.emit(this);
    };
    /**
     * @hidden
     */
    BaseInput.prototype._fireBlur = function () {
        if (!this._isFocus) {
            return;
        }
        (void 0) /* console.debug */;
        this._form && this._form.unsetAsFocused(this);
        this._setFocus(false);
        this._fireTouched();
        this.ionBlur.emit(this);
    };
    /**
     * @hidden
     */
    BaseInput.prototype._fireTouched = function () {
        this._onTouched && this._onTouched();
    };
    /**
     * @hidden
     */
    BaseInput.prototype._setFocus = function (isFocused) {
        (void 0) /* assert */;
        (void 0) /* assert */;
        (void 0) /* assert */;
        this._isFocus = isFocused;
        var item = this._item;
        if (item) {
            item.setElementClass('input-has-focus', isFocused);
            item.setElementClass('item-input-has-focus', isFocused);
        }
        this._inputUpdated();
    };
    /**
     * @hidden
     */
    BaseInput.prototype.onChange = function () {
        this._onChanged && this._onChanged(this._inputNgModelEvent());
    };
    /**
     * @hidden
     */
    BaseInput.prototype.isFocus = function () {
        return this._isFocus;
    };
    /**
     * @hidden
     */
    BaseInput.prototype.hasValue = function () {
        var val = this._value;
        if (!Object(__WEBPACK_IMPORTED_MODULE_1__util__["l" /* isPresent */])(val)) {
            return false;
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isArray */])(val) || Object(__WEBPACK_IMPORTED_MODULE_1__util__["n" /* isString */])(val)) {
            return val.length > 0;
        }
        return true;
    };
    /**
     * @hidden
     */
    BaseInput.prototype.focusNext = function () {
        this._form && this._form.tabFocus(this);
    };
    /**
     * @hidden
     */
    BaseInput.prototype.ngOnDestroy = function () {
        (void 0) /* assert */;
        var form = this._form;
        form && form.deregister(this);
        this._init = false;
    };
    /**
     * @hidden
     */
    BaseInput.prototype.ngAfterContentInit = function () {
        this._initialize();
    };
    /**
     * @hidden
     */
    BaseInput.prototype.initFocus = function () {
        var ele = this._elementRef.nativeElement.querySelector('button');
        ele && ele.focus();
    };
    /**
     * @hidden
     */
    BaseInput.prototype._inputNormalize = function (val) {
        return val;
    };
    /**
     * @hidden
     */
    BaseInput.prototype._inputShouldChange = function (val) {
        return this._value !== val;
    };
    /**
     * @hidden
     */
    BaseInput.prototype._inputChangeEvent = function () {
        return this;
    };
    /**
     * @hidden
     */
    BaseInput.prototype._inputNgModelEvent = function () {
        return this._value;
    };
    /**
     * @hidden
     */
    BaseInput.prototype._inputUpdated = function () {
        (void 0) /* assert */;
        var item = this._item;
        if (item) {
            setControlCss(item, this._ngControl);
            // TODO remove all uses of input-has-value in v4
            var hasValue = this.hasValue();
            item.setElementClass('input-has-value', hasValue);
            item.setElementClass('item-input-has-value', hasValue);
        }
    };
    BaseInput.propDecorators = {
        'ionFocus': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        'ionChange': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        'ionBlur': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        'disabled': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return BaseInput;
}(__WEBPACK_IMPORTED_MODULE_2__components_ion__["a" /* Ion */]));

function setControlCss(element, control) {
    if (!control) {
        return;
    }
    element.setElementClass('ng-untouched', control.untouched);
    element.setElementClass('ng-touched', control.touched);
    element.setElementClass('ng-pristine', control.pristine);
    element.setElementClass('ng-dirty', control.dirty);
    element.setElementClass('ng-valid', control.valid);
    element.setElementClass('ng-invalid', !control.valid);
}
//# sourceMappingURL=base-input.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/util/datetime-util.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["k"] = renderDateTime;
/* harmony export (immutable) */ __webpack_exports__["l"] = renderTextFormat;
/* harmony export (immutable) */ __webpack_exports__["f"] = dateValueRange;
/* harmony export (immutable) */ __webpack_exports__["e"] = dateSortValue;
/* harmony export (immutable) */ __webpack_exports__["d"] = dateDataSortValue;
/* harmony export (immutable) */ __webpack_exports__["g"] = daysInMonth;
/* unused harmony export isLeapYear */
/* harmony export (immutable) */ __webpack_exports__["i"] = parseDate;
/* harmony export (immutable) */ __webpack_exports__["a"] = compareDates;
/* harmony export (immutable) */ __webpack_exports__["m"] = updateDate;
/* harmony export (immutable) */ __webpack_exports__["j"] = parseTemplate;
/* harmony export (immutable) */ __webpack_exports__["h"] = getValueFromFormat;
/* harmony export (immutable) */ __webpack_exports__["c"] = convertFormatToKey;
/* harmony export (immutable) */ __webpack_exports__["b"] = convertDataToISO;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");

function renderDateTime(template, value, locale) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["f" /* isBlank */])(value)) {
        return '';
    }
    var tokens = [];
    var hasText = false;
    FORMAT_KEYS.forEach(function (format, index) {
        if (template.indexOf(format.f) > -1) {
            var token = '{' + index + '}';
            var text = renderTextFormat(format.f, value[format.k], value, locale);
            if (!hasText && text && Object(__WEBPACK_IMPORTED_MODULE_0__util__["l" /* isPresent */])(value[format.k])) {
                hasText = true;
            }
            tokens.push(token, text);
            template = template.replace(format.f, token);
        }
    });
    if (!hasText) {
        return '';
    }
    for (var i = 0; i < tokens.length; i += 2) {
        template = template.replace(tokens[i], tokens[i + 1]);
    }
    return template;
}
function renderTextFormat(format, value, date, locale) {
    if (format === FORMAT_DDDD || format === FORMAT_DDD) {
        try {
            value = (new Date(date.year, date.month - 1, date.day)).getDay();
            if (format === FORMAT_DDDD) {
                return (Object(__WEBPACK_IMPORTED_MODULE_0__util__["l" /* isPresent */])(locale.dayNames) ? locale.dayNames : DAY_NAMES)[value];
            }
            return (Object(__WEBPACK_IMPORTED_MODULE_0__util__["l" /* isPresent */])(locale.dayShortNames) ? locale.dayShortNames : DAY_SHORT_NAMES)[value];
        }
        catch (e) { }
        return '';
    }
    if (format === FORMAT_A) {
        return date ? date.hour < 12 ? 'AM' : 'PM' : Object(__WEBPACK_IMPORTED_MODULE_0__util__["l" /* isPresent */])(value) ? value.toUpperCase() : '';
    }
    if (format === FORMAT_a) {
        return date ? date.hour < 12 ? 'am' : 'pm' : Object(__WEBPACK_IMPORTED_MODULE_0__util__["l" /* isPresent */])(value) ? value : '';
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["f" /* isBlank */])(value)) {
        return '';
    }
    if (format === FORMAT_YY || format === FORMAT_MM ||
        format === FORMAT_DD || format === FORMAT_HH ||
        format === FORMAT_mm || format === FORMAT_ss) {
        return twoDigit(value);
    }
    if (format === FORMAT_YYYY) {
        return fourDigit(value);
    }
    if (format === FORMAT_MMMM) {
        return (Object(__WEBPACK_IMPORTED_MODULE_0__util__["l" /* isPresent */])(locale.monthNames) ? locale.monthNames : MONTH_NAMES)[value - 1];
    }
    if (format === FORMAT_MMM) {
        return (Object(__WEBPACK_IMPORTED_MODULE_0__util__["l" /* isPresent */])(locale.monthShortNames) ? locale.monthShortNames : MONTH_SHORT_NAMES)[value - 1];
    }
    if (format === FORMAT_hh || format === FORMAT_h) {
        if (value === 0) {
            return '12';
        }
        if (value > 12) {
            value -= 12;
        }
        if (format === FORMAT_hh && value < 10) {
            return ('0' + value);
        }
    }
    return value.toString();
}
function dateValueRange(format, min, max) {
    var opts = [];
    var i;
    if (format === FORMAT_YYYY || format === FORMAT_YY) {
        // year
        i = max.year;
        while (i >= min.year) {
            opts.push(i--);
        }
    }
    else if (format === FORMAT_MMMM || format === FORMAT_MMM ||
        format === FORMAT_MM || format === FORMAT_M ||
        format === FORMAT_hh || format === FORMAT_h) {
        // month or 12-hour
        for (i = 1; i < 13; i++) {
            opts.push(i);
        }
    }
    else if (format === FORMAT_DDDD || format === FORMAT_DDD ||
        format === FORMAT_DD || format === FORMAT_D) {
        // day
        for (i = 1; i < 32; i++) {
            opts.push(i);
        }
    }
    else if (format === FORMAT_HH || format === FORMAT_H) {
        // 24-hour
        for (i = 0; i < 24; i++) {
            opts.push(i);
        }
    }
    else if (format === FORMAT_mm || format === FORMAT_m) {
        // minutes
        for (i = 0; i < 60; i++) {
            opts.push(i);
        }
    }
    else if (format === FORMAT_ss || format === FORMAT_s) {
        // seconds
        for (i = 0; i < 60; i++) {
            opts.push(i);
        }
    }
    else if (format === FORMAT_A || format === FORMAT_a) {
        // AM/PM
        opts.push('am', 'pm');
    }
    return opts;
}
function dateSortValue(year, month, day, hour, minute) {
    if (hour === void 0) { hour = 0; }
    if (minute === void 0) { minute = 0; }
    return parseInt("1" + fourDigit(year) + twoDigit(month) + twoDigit(day) + twoDigit(hour) + twoDigit(minute), 10);
}
function dateDataSortValue(data) {
    if (data) {
        return dateSortValue(data.year, data.month, data.day, data.hour, data.minute);
    }
    return -1;
}
function daysInMonth(month, year) {
    return (month === 4 || month === 6 || month === 9 || month === 11) ? 30 : (month === 2) ? isLeapYear(year) ? 29 : 28 : 31;
}
function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
}
var ISO_8601_REGEXP = /^(\d{4}|[+\-]\d{6})(?:-(\d{2})(?:-(\d{2}))?)?(?:T(\d{2}):(\d{2})(?::(\d{2})(?:\.(\d{3}))?)?(?:(Z)|([+\-])(\d{2})(?::(\d{2}))?)?)?$/;
var TIME_REGEXP = /^((\d{2}):(\d{2})(?::(\d{2})(?:\.(\d{3}))?)?(?:(Z)|([+\-])(\d{2})(?::(\d{2}))?)?)?$/;
function parseDate(val) {
    // manually parse IS0 cuz Date.parse cannot be trusted
    // ISO 8601 format: 1994-12-15T13:47:20Z
    var parse;
    if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["l" /* isPresent */])(val) && val !== '') {
        // try parsing for just time first, HH:MM
        parse = TIME_REGEXP.exec(val);
        if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["l" /* isPresent */])(parse)) {
            // adjust the array so it fits nicely with the datetime parse
            parse.unshift(undefined, undefined);
            parse[2] = parse[3] = undefined;
        }
        else {
            // try parsing for full ISO datetime
            parse = ISO_8601_REGEXP.exec(val);
        }
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["f" /* isBlank */])(parse)) {
        // wasn't able to parse the ISO datetime
        return null;
    }
    // ensure all the parse values exist with at least 0
    for (var i = 1; i < 8; i++) {
        parse[i] = (parse[i] !== undefined ? parseInt(parse[i], 10) : null);
    }
    var tzOffset = 0;
    if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["l" /* isPresent */])(parse[9]) && Object(__WEBPACK_IMPORTED_MODULE_0__util__["l" /* isPresent */])(parse[10])) {
        // hours
        tzOffset = parseInt(parse[10], 10) * 60;
        if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["l" /* isPresent */])(parse[11])) {
            // minutes
            tzOffset += parseInt(parse[11], 10);
        }
        if (parse[9] === '-') {
            // + or -
            tzOffset *= -1;
        }
    }
    return {
        year: parse[1],
        month: parse[2],
        day: parse[3],
        hour: parse[4],
        minute: parse[5],
        second: parse[6],
        millisecond: parse[7],
        tzOffset: tzOffset,
    };
}
function compareDates(d1, d2) {
    var date1 = new Date(d1.year, d1.month, d1.day, d1.hour, d1.minute, d1.second);
    var date2 = new Date(d2.year, d2.month, d2.day, d2.hour, d2.minute, d2.second);
    return date1.getTime() - date2.getTime();
}
function updateDate(existingData, newData) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["l" /* isPresent */])(newData) && newData !== '') {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["n" /* isString */])(newData)) {
            // new date is a string, and hopefully in the ISO format
            // convert it to our DateTimeData if a valid ISO
            newData = parseDate(newData);
            if (newData) {
                // successfully parsed the ISO string to our DateTimeData
                Object.assign(existingData, newData);
                return true;
            }
        }
        else if ((Object(__WEBPACK_IMPORTED_MODULE_0__util__["l" /* isPresent */])(newData.year) || Object(__WEBPACK_IMPORTED_MODULE_0__util__["l" /* isPresent */])(newData.hour) || Object(__WEBPACK_IMPORTED_MODULE_0__util__["l" /* isPresent */])(newData.month) || Object(__WEBPACK_IMPORTED_MODULE_0__util__["l" /* isPresent */])(newData.day) || Object(__WEBPACK_IMPORTED_MODULE_0__util__["l" /* isPresent */])(newData.minute) || Object(__WEBPACK_IMPORTED_MODULE_0__util__["l" /* isPresent */])(newData.second))) {
            // newData is from of a datetime picker's selected values
            // update the existing DateTimeData data with the new values
            // do some magic for 12-hour values
            if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["l" /* isPresent */])(newData.ampm) && Object(__WEBPACK_IMPORTED_MODULE_0__util__["l" /* isPresent */])(newData.hour)) {
                if (newData.ampm.value === 'pm') {
                    newData.hour.value = (newData.hour.value === 12 ? 12 : newData.hour.value + 12);
                }
                else {
                    newData.hour.value = (newData.hour.value === 12 ? 0 : newData.hour.value);
                }
            }
            // merge new values from the picker's selection
            // to the existing DateTimeData values
            for (var k in newData) {
                existingData[k] = newData[k].value;
            }
            return true;
        }
        // eww, invalid data
        console.warn("Error parsing date: \"" + newData + "\". Please provide a valid ISO 8601 datetime format: https://www.w3.org/TR/NOTE-datetime");
    }
    else {
        // blank data, clear everything out
        for (var k in existingData) {
            delete existingData[k];
        }
    }
    return false;
}
function parseTemplate(template) {
    var formats = [];
    template = template.replace(/[^\w\s]/gi, ' ');
    FORMAT_KEYS.forEach(function (format) {
        if (format.f.length > 1 && template.indexOf(format.f) > -1 && template.indexOf(format.f + format.f.charAt(0)) < 0) {
            template = template.replace(format.f, ' ' + format.f + ' ');
        }
    });
    var words = template.split(' ').filter(function (w) { return w.length > 0; });
    words.forEach(function (word, i) {
        FORMAT_KEYS.forEach(function (format) {
            if (word === format.f) {
                if (word === FORMAT_A || word === FORMAT_a) {
                    // this format is an am/pm format, so it's an "a" or "A"
                    if ((formats.indexOf(FORMAT_h) < 0 && formats.indexOf(FORMAT_hh) < 0) ||
                        VALID_AMPM_PREFIX.indexOf(words[i - 1]) === -1) {
                        // template does not already have a 12-hour format
                        // or this am/pm format doesn't have a hour, minute, or second format immediately before it
                        // so do not treat this word "a" or "A" as the am/pm format
                        return;
                    }
                }
                formats.push(word);
            }
        });
    });
    return formats;
}
function getValueFromFormat(date, format) {
    if (format === FORMAT_A || format === FORMAT_a) {
        return (date.hour < 12 ? 'am' : 'pm');
    }
    if (format === FORMAT_hh || format === FORMAT_h) {
        return (date.hour > 12 ? date.hour - 12 : date.hour);
    }
    return date[convertFormatToKey(format)];
}
function convertFormatToKey(format) {
    for (var k in FORMAT_KEYS) {
        if (FORMAT_KEYS[k].f === format) {
            return FORMAT_KEYS[k].k;
        }
    }
    return null;
}
function convertDataToISO(data) {
    // https://www.w3.org/TR/NOTE-datetime
    var rtn = '';
    if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["l" /* isPresent */])(data)) {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["l" /* isPresent */])(data.year)) {
            // YYYY
            rtn = fourDigit(data.year);
            if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["l" /* isPresent */])(data.month)) {
                // YYYY-MM
                rtn += '-' + twoDigit(data.month);
                if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["l" /* isPresent */])(data.day)) {
                    // YYYY-MM-DD
                    rtn += '-' + twoDigit(data.day);
                    if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["l" /* isPresent */])(data.hour)) {
                        // YYYY-MM-DDTHH:mm:SS
                        rtn += "T" + twoDigit(data.hour) + ":" + twoDigit(data.minute) + ":" + twoDigit(data.second);
                        if (data.millisecond > 0) {
                            // YYYY-MM-DDTHH:mm:SS.SSS
                            rtn += '.' + threeDigit(data.millisecond);
                        }
                        if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["f" /* isBlank */])(data.tzOffset) || data.tzOffset === 0) {
                            // YYYY-MM-DDTHH:mm:SSZ
                            rtn += 'Z';
                        }
                        else {
                            // YYYY-MM-DDTHH:mm:SS+/-HH:mm
                            rtn += (data.tzOffset > 0 ? '+' : '-') + twoDigit(Math.floor(data.tzOffset / 60)) + ':' + twoDigit(data.tzOffset % 60);
                        }
                    }
                }
            }
        }
        else if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["l" /* isPresent */])(data.hour)) {
            // HH:mm
            rtn = twoDigit(data.hour) + ':' + twoDigit(data.minute);
            if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["l" /* isPresent */])(data.second)) {
                // HH:mm:SS
                rtn += ':' + twoDigit(data.second);
                if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["l" /* isPresent */])(data.millisecond)) {
                    // HH:mm:SS.SSS
                    rtn += '.' + threeDigit(data.millisecond);
                }
            }
        }
    }
    return rtn;
}
function twoDigit(val) {
    return ('0' + (Object(__WEBPACK_IMPORTED_MODULE_0__util__["l" /* isPresent */])(val) ? Math.abs(val) : '0')).slice(-2);
}
function threeDigit(val) {
    return ('00' + (Object(__WEBPACK_IMPORTED_MODULE_0__util__["l" /* isPresent */])(val) ? Math.abs(val) : '0')).slice(-3);
}
function fourDigit(val) {
    return ('000' + (Object(__WEBPACK_IMPORTED_MODULE_0__util__["l" /* isPresent */])(val) ? Math.abs(val) : '0')).slice(-4);
}
var FORMAT_YYYY = 'YYYY';
var FORMAT_YY = 'YY';
var FORMAT_MMMM = 'MMMM';
var FORMAT_MMM = 'MMM';
var FORMAT_MM = 'MM';
var FORMAT_M = 'M';
var FORMAT_DDDD = 'DDDD';
var FORMAT_DDD = 'DDD';
var FORMAT_DD = 'DD';
var FORMAT_D = 'D';
var FORMAT_HH = 'HH';
var FORMAT_H = 'H';
var FORMAT_hh = 'hh';
var FORMAT_h = 'h';
var FORMAT_mm = 'mm';
var FORMAT_m = 'm';
var FORMAT_ss = 'ss';
var FORMAT_s = 's';
var FORMAT_A = 'A';
var FORMAT_a = 'a';
var FORMAT_KEYS = [
    { f: FORMAT_YYYY, k: 'year' },
    { f: FORMAT_MMMM, k: 'month' },
    { f: FORMAT_DDDD, k: 'day' },
    { f: FORMAT_MMM, k: 'month' },
    { f: FORMAT_DDD, k: 'day' },
    { f: FORMAT_YY, k: 'year' },
    { f: FORMAT_MM, k: 'month' },
    { f: FORMAT_DD, k: 'day' },
    { f: FORMAT_HH, k: 'hour' },
    { f: FORMAT_hh, k: 'hour' },
    { f: FORMAT_mm, k: 'minute' },
    { f: FORMAT_ss, k: 'second' },
    { f: FORMAT_M, k: 'month' },
    { f: FORMAT_D, k: 'day' },
    { f: FORMAT_H, k: 'hour' },
    { f: FORMAT_h, k: 'hour' },
    { f: FORMAT_m, k: 'minute' },
    { f: FORMAT_s, k: 'second' },
    { f: FORMAT_A, k: 'ampm' },
    { f: FORMAT_a, k: 'ampm' },
];
var DAY_NAMES = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
];
var DAY_SHORT_NAMES = [
    'Sun',
    'Mon',
    'Tue',
    'Wed',
    'Thu',
    'Fri',
    'Sat',
];
var MONTH_NAMES = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];
var MONTH_SHORT_NAMES = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
];
var VALID_AMPM_PREFIX = [
    FORMAT_hh, FORMAT_h, FORMAT_mm, FORMAT_m, FORMAT_ss, FORMAT_s
];
//# sourceMappingURL=datetime-util.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/util/debouncer.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TimeoutDebouncer; });
var TimeoutDebouncer = (function () {
    function TimeoutDebouncer(wait) {
        this.wait = wait;
        this.timer = null;
    }
    TimeoutDebouncer.prototype.debounce = function (callback) {
        this.callback = callback;
        this.schedule();
    };
    TimeoutDebouncer.prototype.schedule = function () {
        this.cancel();
        if (this.wait <= 0) {
            this.callback();
        }
        else {
            this.timer = setTimeout(this.callback, this.wait);
        }
    };
    TimeoutDebouncer.prototype.cancel = function () {
        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
        }
    };
    return TimeoutDebouncer;
}());

//# sourceMappingURL=debouncer.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/util/dom.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = getCss;
/* harmony export (immutable) */ __webpack_exports__["f"] = pointerCoord;
/* harmony export (immutable) */ __webpack_exports__["d"] = hasPointerMoved;
/* harmony export (immutable) */ __webpack_exports__["e"] = isTextInput;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NON_TEXT_INPUT_REGEX; });
/* harmony export (immutable) */ __webpack_exports__["b"] = copyInputAttributes;
function getCss(docEle) {
    var css = {};
    // transform
    var i;
    var keys = ['webkitTransform', '-webkit-transform', 'webkit-transform', 'transform'];
    for (i = 0; i < keys.length; i++) {
        if (docEle.style[keys[i]] !== undefined) {
            css.transform = keys[i];
            break;
        }
    }
    // transition
    keys = ['webkitTransition', 'transition'];
    for (i = 0; i < keys.length; i++) {
        if (docEle.style[keys[i]] !== undefined) {
            css.transition = keys[i];
            break;
        }
    }
    // The only prefix we care about is webkit for transitions.
    var isWebkit = css.transition.indexOf('webkit') > -1;
    // transition duration
    css.transitionDuration = (isWebkit ? '-webkit-' : '') + 'transition-duration';
    // transition timing function
    css.transitionTimingFn = (isWebkit ? '-webkit-' : '') + 'transition-timing-function';
    // transition delay
    css.transitionDelay = (isWebkit ? '-webkit-' : '') + 'transition-delay';
    // To be sure transitionend works everywhere, include *both* the webkit and non-webkit events
    css.transitionEnd = (isWebkit ? 'webkitTransitionEnd ' : '') + 'transitionend';
    // transform origin
    css.transformOrigin = (isWebkit ? '-webkit-' : '') + 'transform-origin';
    // animation delay
    css.animationDelay = (isWebkit ? 'webkitAnimationDelay' : 'animationDelay');
    return css;
}
function pointerCoord(ev) {
    // get coordinates for either a mouse click
    // or a touch depending on the given event
    if (ev) {
        var changedTouches = ev.changedTouches;
        if (changedTouches && changedTouches.length > 0) {
            var touch = changedTouches[0];
            return { x: touch.clientX, y: touch.clientY };
        }
        var pageX = ev.pageX;
        if (pageX !== undefined) {
            return { x: pageX, y: ev.pageY };
        }
    }
    return { x: 0, y: 0 };
}
function hasPointerMoved(threshold, startCoord, endCoord) {
    if (startCoord && endCoord) {
        var deltaX = (startCoord.x - endCoord.x);
        var deltaY = (startCoord.y - endCoord.y);
        var distance = deltaX * deltaX + deltaY * deltaY;
        return distance > (threshold * threshold);
    }
    return false;
}
function isTextInput(ele) {
    return !!ele &&
        (ele.tagName === 'TEXTAREA' ||
            ele.contentEditable === 'true' ||
            (ele.tagName === 'INPUT' && !(NON_TEXT_INPUT_REGEX.test(ele.type))));
}
var NON_TEXT_INPUT_REGEX = /^(radio|checkbox|range|file|submit|reset|color|image|button)$/i;
var SKIP_INPUT_ATTR = ['value', 'checked', 'disabled', 'readonly', 'placeholder', 'type', 'class', 'style', 'id', 'autofocus', 'autocomplete', 'autocorrect'];
function copyInputAttributes(srcElement, destElement) {
    // copy attributes from one element to another
    // however, skip over a few of them as they're already
    // handled in the angular world
    var attrs = srcElement.attributes;
    for (var i = 0; i < attrs.length; i++) {
        var attr = attrs[i];
        if (SKIP_INPUT_ATTR.indexOf(attr.name) === -1) {
            destElement.setAttribute(attr.name, attr.value);
        }
    }
}
//# sourceMappingURL=dom.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/util/events.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Events; });
/* harmony export (immutable) */ __webpack_exports__["b"] = setupEvents;
/* harmony export (immutable) */ __webpack_exports__["c"] = setupProvideEvents;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scroll_view__ = __webpack_require__("./node_modules/ionic-angular/util/scroll-view.js");

/**
 * @name Events
 * @description
 * Events is a publish-subscribe style event system for sending and responding to application-level
 * events across your app.
 *
 * @usage
 * ```ts
 * import { Events } from 'ionic-angular';
 *
 * // first page (publish an event when a user is created)
 * constructor(public events: Events) { }
 *
 * createUser(user) {
 *   console.log('User created!')
 *   this.events.publish('user:created', user, Date.now());
 * }
 *
 *
 * // second page (listen for the user created event after function is called)
 * constructor(public events: Events) {
 *   events.subscribe('user:created', (user, time) => {
 *     // user and time are the same arguments passed in `events.publish(user, time)`
 *     console.log('Welcome', user, 'at', time);
 *   });
 * }
 *
 * ```
 * @demo /docs/demos/src/events/
 */
var Events = (function () {
    function Events() {
        this._channels = [];
    }
    /**
     * Subscribe to an event topic. Events that get posted to that topic will trigger the provided handler.
     *
     * @param {string} topic the topic to subscribe to
     * @param {function} handler the event handler
     */
    Events.prototype.subscribe = function (topic) {
        var _this = this;
        var handlers = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            handlers[_i - 1] = arguments[_i];
        }
        if (!this._channels[topic]) {
            this._channels[topic] = [];
        }
        handlers.forEach(function (handler) {
            _this._channels[topic].push(handler);
        });
    };
    /**
     * Unsubscribe from the given topic. Your handler will no longer receive events published to this topic.
     *
     * @param {string} topic the topic to unsubscribe from
     * @param {function} handler the event handler
     *
     * @return true if a handler was removed
     */
    Events.prototype.unsubscribe = function (topic, handler) {
        if (handler === void 0) { handler = null; }
        var t = this._channels[topic];
        if (!t) {
            // Wasn't found, wasn't removed
            return false;
        }
        if (!handler) {
            // Remove all handlers for this topic
            delete this._channels[topic];
            return true;
        }
        // We need to find and remove a specific handler
        var i = t.indexOf(handler);
        if (i < 0) {
            // Wasn't found, wasn't removed
            return false;
        }
        t.splice(i, 1);
        // If the channel is empty now, remove it from the channel map
        if (!t.length) {
            delete this._channels[topic];
        }
        return true;
    };
    /**
     * Publish an event to the given topic.
     *
     * @param {string} topic the topic to publish to
     * @param {any} eventData the data to send as the event
     */
    Events.prototype.publish = function (topic) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var t = this._channels[topic];
        if (!t) {
            return null;
        }
        var responses = [];
        t.forEach(function (handler) {
            responses.push(handler.apply(void 0, args));
        });
        return responses;
    };
    return Events;
}());

/**
 * @hidden
 */
function setupEvents(plt, dom) {
    var events = new Events();
    var win = plt.win();
    var doc = plt.doc();
    // start listening for resizes XXms after the app starts
    plt.timeout(function () {
        win.addEventListener('online', function (ev) {
            events.publish('app:online', ev);
        }, false);
        win.addEventListener('offline', function (ev) {
            events.publish('app:offline', ev);
        }, false);
        win.addEventListener('orientationchange', function (ev) {
            events.publish('app:rotated', ev);
        });
        // When that status taps, we respond
        win.addEventListener('statusTap', function () {
            // TODO: Make this more better
            var el = doc.elementFromPoint(plt.width() / 2, plt.height() / 2);
            if (!el) {
                return;
            }
            var contentEle = el.closest('.scroll-content');
            if (contentEle) {
                var style = contentEle.style;
                var scroll = new __WEBPACK_IMPORTED_MODULE_0__scroll_view__["a" /* ScrollView */](null, plt, dom);
                scroll._el = contentEle;
                // We need to stop scrolling if it's happening and scroll up
                style['WebkitBackfaceVisibility'] = 'hidden';
                style['WebkitTransform'] = 'translate3d(0,0,0)';
                dom.write(function () {
                    style.overflow = 'hidden';
                    function finish() {
                        style.overflow = '';
                        style['WebkitBackfaceVisibility'] = '';
                        style['WebkitTransform'] = '';
                    }
                    var didScrollTimeout = plt.timeout(function () {
                        finish();
                    }, 400);
                    scroll.scrollTo(0, 0, 300).then(function () {
                        plt.cancelTimeout(didScrollTimeout);
                        finish();
                    });
                });
            }
        });
    }, 2000);
    return events;
}
/**
 * @hidden
 */
function setupProvideEvents(plt, dom) {
    return function () {
        return setupEvents(plt, dom);
    };
}
//# sourceMappingURL=events.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/util/form.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Form; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return IonicTapInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IonicFormInput; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");


/**
 * @hidden
 */
var Form = (function () {
    function Form() {
        this._focused = null;
        this._ids = -1;
        this._inputs = [];
    }
    Form.prototype.register = function (input) {
        this._inputs.push(input);
    };
    Form.prototype.deregister = function (input) {
        Object(__WEBPACK_IMPORTED_MODULE_1__util__["r" /* removeArrayItem */])(this._inputs, input);
        this.unsetAsFocused(input);
    };
    Form.prototype.setAsFocused = function (input) {
        this._focused = input;
    };
    Form.prototype.unsetAsFocused = function (input) {
        if (input === this._focused) {
            this._focused = null;
        }
    };
    /**
     * Focuses the next input element, if it exists.
     */
    Form.prototype.tabFocus = function (currentInput) {
        var inputs = this._inputs;
        var index = inputs.indexOf(currentInput) + 1;
        if (index > 0 && index < inputs.length) {
            var nextInput = inputs[index];
            if (nextInput !== this._focused) {
                (void 0) /* console.debug */;
                return nextInput.initFocus();
            }
        }
        index = inputs.indexOf(this._focused);
        if (index > 0) {
            var previousInput = inputs[index - 1];
            if (previousInput) {
                (void 0) /* console.debug */;
                previousInput.initFocus();
            }
        }
    };
    Form.prototype.nextId = function () {
        return ++this._ids;
    };
    Form.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    Form.ctorParameters = function () { return []; };
    return Form;
}());

/**
 * @hidden
 */
var IonicTapInput = (function () {
    function IonicTapInput() {
    }
    return IonicTapInput;
}());

/**
 * @hidden
 */
var IonicFormInput = (function () {
    function IonicFormInput() {
    }
    return IonicFormInput;
}());

//# sourceMappingURL=form.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/util/ionic-error-handler.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IonicErrorHandler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

/**
 * @name IonicErrorHandler
 * @description
 * The `IonicErrorHandler` intercepts the default `Console` error handling
 * and displays runtime errors as an overlay when using Ionic's Dev Build Server.
 *
 *
 * ### IonicErrorHandler Example
 *
 * ```typescript
 * import { ErrorHandler, NgModule } from '@angular/core';
 * import { IonicErrorHandler } from 'ionic-angular';
 *
 * @NgModule({
 *   providers: [{ provide: ErrorHandler, useClass: IonicErrorHandler }]
 * })
 * class AppModule { }
 * ```
 *
 *
 * ### Custom Error Handlers
 *
 * Custom error handlers can be built to replace the default, or extend Ionic's
 * error handler.
 *
 * ```typescript
 * class MyErrorHandler implements ErrorHandler {
 *   handleError(err: any): void {
 *     // do something with the error
 *   }
 * }
 *
 * @NgModule({
 *   providers: [{ provide: ErrorHandler, useClass: MyErrorHandler }]
 * })
 * class AppModule { }
 * ```
 *
 * More information about Angular's [`ErrorHandler`](https://angular.io/docs/ts/latest/api/core/index/ErrorHandler-class.html).
 */
var IonicErrorHandler = (function (_super) {
    __extends(IonicErrorHandler, _super);
    function IonicErrorHandler() {
        return _super.call(this) || this;
    }
    /**
     * @internal
     */
    IonicErrorHandler.prototype.handleError = function (err) {
        _super.prototype.handleError.call(this, err);
        try {
            var win = window;
            var monitor = void 0;
            monitor = win['IonicDevServer'];
            monitor && monitor.handleError && monitor.handleError(err);
            monitor = (win['Ionic'] = win['Ionic'] || {}).Monitor;
            monitor && monitor.handleError && monitor.handleError(err);
        }
        catch (e) { }
    };
    return IonicErrorHandler;
}(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ErrorHandler"]));

//# sourceMappingURL=ionic-error-handler.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/util/module-loader.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LAZY_LOADED_TOKEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ModuleLoader; });
/* harmony export (immutable) */ __webpack_exports__["c"] = provideModuleLoader;
/* unused harmony export setupPreloadingImplementation */
/* harmony export (immutable) */ __webpack_exports__["d"] = setupPreloading;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ng_module_loader__ = __webpack_require__("./node_modules/ionic-angular/util/ng-module-loader.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__("./node_modules/ionic-angular/util/util.js");



var LAZY_LOADED_TOKEN = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["InjectionToken"]('LZYCMP');
/**
 * @hidden
 */
var ModuleLoader = (function () {
    function ModuleLoader(_ngModuleLoader, _injector) {
        this._ngModuleLoader = _ngModuleLoader;
        this._injector = _injector;
        /** @internal */
        this._cfrMap = new Map();
        this._promiseMap = new Map();
    }
    ModuleLoader.prototype.load = function (modulePath) {
        var _this = this;
        (void 0) /* console.time */;
        var splitString = modulePath.split(SPLITTER);
        var promise = this._promiseMap.get(modulePath);
        if (!promise) {
            promise = this._ngModuleLoader.load(splitString[0], splitString[1]);
            this._promiseMap.set(modulePath, promise);
        }
        return promise.then(function (loadedModule) {
            (void 0) /* console.timeEnd */;
            var ref = loadedModule.create(_this._injector);
            var component = ref.injector.get(LAZY_LOADED_TOKEN);
            _this._cfrMap.set(component, ref.componentFactoryResolver);
            return {
                componentFactoryResolver: ref.componentFactoryResolver,
                component: component
            };
        });
    };
    ModuleLoader.prototype.getComponentFactoryResolver = function (component) {
        return this._cfrMap.get(component);
    };
    ModuleLoader.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    ModuleLoader.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__ng_module_loader__["a" /* NgModuleLoader */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injector"], },
    ]; };
    return ModuleLoader;
}());

var SPLITTER = '#';
/**
 * @hidden
 */
function provideModuleLoader(ngModuleLoader, injector) {
    return new ModuleLoader(ngModuleLoader, injector);
}
/**
 * @hidden
 */
function setupPreloadingImplementation(config, deepLinkConfig, moduleLoader) {
    if (!deepLinkConfig || !deepLinkConfig.links || !config.getBoolean('preloadModules')) {
        return Promise.resolve();
    }
    var linksToLoad = deepLinkConfig.links.filter(function (link) { return !!link.loadChildren && link.priority !== 'off'; });
    // Load the high priority modules first
    var highPriorityPromises = linksToLoad
        .filter(function (link) { return link.priority === 'high'; })
        .map(function (link) { return moduleLoader.load(link.loadChildren); });
    return Promise.all(highPriorityPromises).then(function () {
        // Load the low priority modules after the high priority are done
        var lowPriorityPromises = linksToLoad
            .filter(function (link) { return link.priority === 'low'; })
            .map(function (link) { return moduleLoader.load(link.loadChildren); });
        return Promise.all(lowPriorityPromises);
    }).catch(function (err) {
        console.error(err.message);
    });
}
/**
 * @hidden
 */
function setupPreloading(config, deepLinkConfig, moduleLoader, ngZone) {
    return function () {
        Object(__WEBPACK_IMPORTED_MODULE_2__util__["t" /* requestIonicCallback */])(function () {
            ngZone.runOutsideAngular(function () {
                setupPreloadingImplementation(config, deepLinkConfig, moduleLoader);
            });
        });
    };
}
//# sourceMappingURL=module-loader.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/util/ng-module-loader.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NgModuleLoader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");

/**
 * NgModuleFactoryLoader that uses SystemJS to load NgModuleFactory
 */
var NgModuleLoader = (function () {
    function NgModuleLoader(_compiler) {
        this._compiler = _compiler;
    }
    NgModuleLoader.prototype.load = function (modulePath, ngModuleExport) {
        var offlineMode = this._compiler instanceof __WEBPACK_IMPORTED_MODULE_0__angular_core__["Compiler"];
        return offlineMode ? loadPrecompiledFactory(modulePath, ngModuleExport) : loadAndCompile(this._compiler, modulePath, ngModuleExport);
    };
    NgModuleLoader.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    NgModuleLoader.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Compiler"], },
    ]; };
    return NgModuleLoader;
}());

function loadAndCompile(compiler, modulePath, ngModuleExport) {
    if (!ngModuleExport) {
        ngModuleExport = 'default';
    }
    return __webpack_require__("./web lazy recursive")(modulePath)
        .then(function (rawModule) {
        var module = rawModule[ngModuleExport];
        if (!module) {
            throw new Error("Module " + modulePath + " does not export " + ngModuleExport);
        }
        return compiler.compileModuleAsync(module);
    });
}
function loadPrecompiledFactory(modulePath, ngModuleExport) {
    return __webpack_require__("./web lazy recursive")(modulePath)
        .then(function (rawModule) {
        var ngModuleFactory = rawModule[ngModuleExport];
        if (!ngModuleFactory) {
            throw new Error("Module " + modulePath + " does not export " + ngModuleExport);
        }
        return ngModuleFactory;
    });
}
//# sourceMappingURL=ng-module-loader.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/util/scroll-view.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ScrollView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dom__ = __webpack_require__("./node_modules/ionic-angular/util/dom.js");

var ScrollView = (function () {
    function ScrollView(_app, _plt, _dom) {
        this._app = _app;
        this._plt = _plt;
        this._dom = _dom;
        this.isScrolling = false;
        this.initialized = false;
        this._eventsEnabled = false;
        this._t = 0;
        this._l = 0;
        this.ev = {
            timeStamp: 0,
            scrollTop: 0,
            scrollLeft: 0,
            scrollHeight: 0,
            scrollWidth: 0,
            contentHeight: 0,
            contentWidth: 0,
            contentTop: 0,
            contentBottom: 0,
            startY: 0,
            startX: 0,
            deltaY: 0,
            deltaX: 0,
            velocityY: 0,
            velocityX: 0,
            directionY: 'down',
            directionX: null,
            domWrite: _dom.write.bind(_dom)
        };
    }
    ScrollView.prototype.init = function (ele, contentTop, contentBottom) {
        (void 0) /* assert */;
        this._el = ele;
        if (!this.initialized) {
            this.initialized = true;
            if (this._js) {
                this.enableJsScroll(contentTop, contentBottom);
            }
            else {
                this.enableNativeScrolling();
            }
        }
    };
    ScrollView.prototype.enableEvents = function () {
        this._eventsEnabled = true;
    };
    ScrollView.prototype.setScrolling = function (isScrolling, ev) {
        if (this.isScrolling) {
            if (isScrolling) {
                this.onScroll && this.onScroll(ev);
            }
            else {
                this.isScrolling = false;
                this.onScrollEnd && this.onScrollEnd(ev);
            }
        }
        else if (isScrolling) {
            this.isScrolling = true;
            this.onScrollStart && this.onScrollStart(ev);
        }
    };
    ScrollView.prototype.enableNativeScrolling = function () {
        (void 0) /* assert */;
        (void 0) /* assert */;
        (void 0) /* assert */;
        this._js = false;
        if (!this._el) {
            return;
        }
        (void 0) /* console.debug */;
        var self = this;
        var ev = self.ev;
        var positions = [];
        function scrollCallback(scrollEvent) {
            // remind the app that it's currently scrolling
            self._app.setScrolling();
            // if events are disabled, we do nothing
            if (!self._eventsEnabled) {
                return;
            }
            ev.timeStamp = scrollEvent.timeStamp;
            // Event.timeStamp is 0 in firefox
            if (!ev.timeStamp) {
                ev.timeStamp = Date.now();
            }
            // get the current scrollTop
            // ******** DOM READ ****************
            ev.scrollTop = self.getTop();
            // get the current scrollLeft
            // ******** DOM READ ****************
            ev.scrollLeft = self.getLeft();
            if (!self.isScrolling) {
                // remember the start positions
                ev.startY = ev.scrollTop;
                ev.startX = ev.scrollLeft;
                // new scroll, so do some resets
                ev.velocityY = ev.velocityX = 0;
                ev.deltaY = ev.deltaX = 0;
                positions.length = 0;
            }
            // actively scrolling
            positions.push(ev.scrollTop, ev.scrollLeft, ev.timeStamp);
            if (positions.length > 3) {
                // we've gotten at least 2 scroll events so far
                ev.deltaY = (ev.scrollTop - ev.startY);
                ev.deltaX = (ev.scrollLeft - ev.startX);
                var endPos = (positions.length - 1);
                var startPos = endPos;
                var timeRange = (ev.timeStamp - 100);
                // move pointer to position measured 100ms ago
                for (var i = endPos; i > 0 && positions[i] > timeRange; i -= 3) {
                    startPos = i;
                }
                if (startPos !== endPos) {
                    // compute relative movement between these two points
                    var movedTop = (positions[startPos - 2] - positions[endPos - 2]);
                    var movedLeft = (positions[startPos - 1] - positions[endPos - 1]);
                    var factor = FRAME_MS / (positions[endPos] - positions[startPos]);
                    // based on XXms compute the movement to apply for each render step
                    ev.velocityY = movedTop * factor;
                    ev.velocityX = movedLeft * factor;
                    // figure out which direction we're scrolling
                    ev.directionY = (movedTop > 0 ? 'up' : 'down');
                    ev.directionX = (movedLeft > 0 ? 'left' : 'right');
                }
            }
            function scrollEnd() {
                // reset velocity, do not reset the directions or deltas
                ev.velocityY = ev.velocityX = 0;
                // emit that the scroll has ended
                self.setScrolling(false, ev);
                self._endTmr = null;
            }
            // emit on each scroll event
            self.setScrolling(true, ev);
            // debounce for a moment after the last scroll event
            self._dom.cancel(self._endTmr);
            self._endTmr = self._dom.read(scrollEnd, SCROLL_END_DEBOUNCE_MS);
        }
        // clear out any existing listeners (just to be safe)
        self._lsn && self._lsn();
        // assign the raw scroll listener
        // note that it does not have a wrapping requestAnimationFrame on purpose
        // a scroll event callback will always be right before the raf callback
        // so there's little to no value of using raf here since it'll all ways immediately
        // call the raf if it was set within the scroll event, so this will save us some time
        self._lsn = self._plt.registerListener(self._el, 'scroll', scrollCallback, EVENT_OPTS);
    };
    /**
     * @hidden
     * JS Scrolling has been provided only as a temporary solution
     * until iOS apps can take advantage of scroll events at all times.
     * The goal is to eventually remove JS scrolling entirely. When we
     * no longer have to worry about iOS not firing scroll events during
     * inertia then this can be burned to the ground. iOS's more modern
     * WKWebView does not have this issue, only UIWebView does.
     */
    ScrollView.prototype.enableJsScroll = function (contentTop, contentBottom) {
        var self = this;
        self._js = true;
        var ele = self._el;
        if (!ele) {
            return;
        }
        (void 0) /* console.debug */;
        var ev = self.ev;
        var positions = [];
        var rafCancel;
        var max;
        function setMax() {
            if (!max) {
                // ******** DOM READ ****************
                max = ele.scrollHeight - ele.parentElement.offsetHeight + contentTop + contentBottom;
            }
        }
        function jsScrollDecelerate(timeStamp) {
            ev.timeStamp = timeStamp;
            (void 0) /* console.debug */;
            if (ev.velocityY) {
                ev.velocityY *= DECELERATION_FRICTION;
                // update top with updated velocity
                // clamp top within scroll limits
                // ******** DOM READ ****************
                setMax();
                self._t = Math.min(Math.max(self._t + ev.velocityY, 0), max);
                ev.scrollTop = self._t;
                // emit on each scroll event
                self.onScroll(ev);
                self._dom.write(function () {
                    // ******** DOM WRITE ****************
                    self.setTop(self._t);
                    if (self._t > 0 && self._t < max && Math.abs(ev.velocityY) > MIN_VELOCITY_CONTINUE_DECELERATION) {
                        rafCancel = self._dom.read(function (rafTimeStamp) {
                            jsScrollDecelerate(rafTimeStamp);
                        });
                    }
                    else {
                        // haven't scrolled in a while, so it's a scrollend
                        self.isScrolling = false;
                        // reset velocity, do not reset the directions or deltas
                        ev.velocityY = ev.velocityX = 0;
                        // emit that the scroll has ended
                        self.onScrollEnd(ev);
                    }
                });
            }
        }
        function jsScrollTouchStart(touchEvent) {
            positions.length = 0;
            max = null;
            self._dom.cancel(rafCancel);
            positions.push(Object(__WEBPACK_IMPORTED_MODULE_0__dom__["f" /* pointerCoord */])(touchEvent).y, touchEvent.timeStamp);
        }
        function jsScrollTouchMove(touchEvent) {
            if (!positions.length) {
                return;
            }
            ev.timeStamp = touchEvent.timeStamp;
            var y = Object(__WEBPACK_IMPORTED_MODULE_0__dom__["f" /* pointerCoord */])(touchEvent).y;
            // ******** DOM READ ****************
            setMax();
            self._t -= (y - positions[positions.length - 2]);
            self._t = Math.min(Math.max(self._t, 0), max);
            positions.push(y, ev.timeStamp);
            if (!self.isScrolling) {
                // remember the start position
                ev.startY = self._t;
                // new scroll, so do some resets
                ev.velocityY = ev.deltaY = 0;
                self.isScrolling = true;
                // emit only on the first scroll event
                self.onScrollStart(ev);
            }
            self._dom.write(function () {
                // ******** DOM WRITE ****************
                self.setTop(self._t);
            });
        }
        function jsScrollTouchEnd(touchEvent) {
            // figure out what the scroll position was about 100ms ago
            self._dom.cancel(rafCancel);
            if (!positions.length && self.isScrolling) {
                self.isScrolling = false;
                ev.velocityY = ev.velocityX = 0;
                self.onScrollEnd(ev);
                return;
            }
            var y = Object(__WEBPACK_IMPORTED_MODULE_0__dom__["f" /* pointerCoord */])(touchEvent).y;
            positions.push(y, touchEvent.timeStamp);
            var endPos = (positions.length - 1);
            var startPos = endPos;
            var timeRange = (touchEvent.timeStamp - 100);
            // move pointer to position measured 100ms ago
            for (var i = endPos; i > 0 && positions[i] > timeRange; i -= 2) {
                startPos = i;
            }
            if (startPos !== endPos) {
                // compute relative movement between these two points
                var timeOffset = (positions[endPos] - positions[startPos]);
                var movedTop = (positions[startPos - 1] - positions[endPos - 1]);
                // based on XXms compute the movement to apply for each render step
                ev.velocityY = ((movedTop / timeOffset) * FRAME_MS);
                // verify that we have enough velocity to start deceleration
                if (Math.abs(ev.velocityY) > MIN_VELOCITY_START_DECELERATION) {
                    // ******** DOM READ ****************
                    setMax();
                    rafCancel = self._dom.read(function (rafTimeStamp) {
                        jsScrollDecelerate(rafTimeStamp);
                    });
                }
            }
            else {
                self.isScrolling = false;
                ev.velocityY = 0;
                self.onScrollEnd(ev);
            }
            positions.length = 0;
        }
        var plt = self._plt;
        var unRegStart = plt.registerListener(ele, 'touchstart', jsScrollTouchStart, EVENT_OPTS);
        var unRegMove = plt.registerListener(ele, 'touchmove', jsScrollTouchMove, EVENT_OPTS);
        var unRegEnd = plt.registerListener(ele, 'touchend', jsScrollTouchEnd, EVENT_OPTS);
        ele.parentElement.classList.add('js-scroll');
        // stop listening for actual scroll events
        self._lsn && self._lsn();
        // create an unregister for all of these events
        self._lsn = function () {
            unRegStart();
            unRegMove();
            unRegEnd();
            ele.parentElement.classList.remove('js-scroll');
        };
    };
    /**
     * DOM READ
     */
    ScrollView.prototype.getTop = function () {
        if (this._js) {
            return this._t;
        }
        return this._t = this._el.scrollTop;
    };
    /**
     * DOM READ
     */
    ScrollView.prototype.getLeft = function () {
        if (this._js) {
            return 0;
        }
        return this._l = this._el.scrollLeft;
    };
    /**
     * DOM WRITE
     */
    ScrollView.prototype.setTop = function (top) {
        this._t = top;
        if (this._js) {
            this._el.style[this._plt.Css.transform] = "translate3d(" + this._l * -1 + "px," + top * -1 + "px,0px)";
        }
        else {
            this._el.scrollTop = top;
        }
    };
    /**
     * DOM WRITE
     */
    ScrollView.prototype.setLeft = function (left) {
        this._l = left;
        if (this._js) {
            this._el.style[this._plt.Css.transform] = "translate3d(" + left * -1 + "px," + this._t * -1 + "px,0px)";
        }
        else {
            this._el.scrollLeft = left;
        }
    };
    ScrollView.prototype.scrollTo = function (x, y, duration, done) {
        // scroll animation loop w/ easing
        // credit https://gist.github.com/dezinezync/5487119
        var promise;
        if (done === undefined) {
            // only create a promise if a done callback wasn't provided
            // done can be a null, which avoids any functions
            promise = new Promise(function (resolve) {
                done = resolve;
            });
        }
        var self = this;
        var el = self._el;
        if (!el) {
            // invalid element
            done();
            return promise;
        }
        if (duration < 32) {
            self.setTop(y);
            self.setLeft(x);
            done();
            return promise;
        }
        var fromY = el.scrollTop;
        var fromX = el.scrollLeft;
        var maxAttempts = (duration / 16) + 100;
        var transform = self._plt.Css.transform;
        var startTime;
        var attempts = 0;
        var stopScroll = false;
        // scroll loop
        function step(timeStamp) {
            attempts++;
            if (!self._el || stopScroll || attempts > maxAttempts) {
                self.setScrolling(false, null);
                el.style[transform] = '';
                done();
                return;
            }
            var time = Math.min(1, ((timeStamp - startTime) / duration));
            // where .5 would be 50% of time on a linear scale easedT gives a
            // fraction based on the easing method
            var easedT = (--time) * time * time + 1;
            if (fromY !== y) {
                self.setTop((easedT * (y - fromY)) + fromY);
            }
            if (fromX !== x) {
                self.setLeft(Math.floor((easedT * (x - fromX)) + fromX));
            }
            if (easedT < 1) {
                // do not use DomController here
                // must use nativeRaf in order to fire in the next frame
                self._plt.raf(step);
            }
            else {
                stopScroll = true;
                self.setScrolling(false, null);
                el.style[transform] = '';
                done();
            }
        }
        // start scroll loop
        self.setScrolling(true, null);
        self.isScrolling = true;
        // chill out for a frame first
        self._dom.write(function (timeStamp) {
            startTime = timeStamp;
            step(timeStamp);
        }, 16);
        return promise;
    };
    ScrollView.prototype.scrollToTop = function (duration) {
        return this.scrollTo(0, 0, duration);
    };
    ScrollView.prototype.scrollToBottom = function (duration) {
        var y = 0;
        if (this._el) {
            y = this._el.scrollHeight - this._el.clientHeight;
        }
        return this.scrollTo(0, y, duration);
    };
    ScrollView.prototype.stop = function () {
        this.setScrolling(false, null);
    };
    /**
     * @hidden
     */
    ScrollView.prototype.destroy = function () {
        this.stop();
        this._endTmr && this._dom.cancel(this._endTmr);
        this._lsn && this._lsn();
        var ev = this.ev;
        ev.domWrite = ev.contentElement = ev.fixedElement = ev.scrollElement = ev.headerElement = null;
        this._lsn = this._el = this._dom = this.ev = ev = null;
        this.onScrollStart = this.onScroll = this.onScrollEnd = null;
    };
    return ScrollView;
}());

var SCROLL_END_DEBOUNCE_MS = 80;
var MIN_VELOCITY_START_DECELERATION = 4;
var MIN_VELOCITY_CONTINUE_DECELERATION = 0.12;
var DECELERATION_FRICTION = 0.97;
var FRAME_MS = (1000 / 60);
var EVENT_OPTS = {
    passive: true,
    zone: false
};
//# sourceMappingURL=scroll-view.js.map

/***/ }),

/***/ "./node_modules/ionic-angular/util/util.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = clamp;
/* harmony export (immutable) */ __webpack_exports__["b"] = deepCopy;
/* harmony export (immutable) */ __webpack_exports__["c"] = deepEqual;
/* unused harmony export debounce */
/* harmony export (immutable) */ __webpack_exports__["q"] = normalizeURL;
/* harmony export (immutable) */ __webpack_exports__["d"] = defaults;
/* unused harmony export isBoolean */
/* harmony export (immutable) */ __webpack_exports__["n"] = isString;
/* harmony export (immutable) */ __webpack_exports__["j"] = isNumber;
/* harmony export (immutable) */ __webpack_exports__["i"] = isFunction;
/* harmony export (immutable) */ __webpack_exports__["h"] = isDefined;
/* harmony export (immutable) */ __webpack_exports__["p"] = isUndefined;
/* harmony export (immutable) */ __webpack_exports__["l"] = isPresent;
/* harmony export (immutable) */ __webpack_exports__["f"] = isBlank;
/* harmony export (immutable) */ __webpack_exports__["k"] = isObject;
/* harmony export (immutable) */ __webpack_exports__["e"] = isArray;
/* unused harmony export isPrimitive */
/* harmony export (immutable) */ __webpack_exports__["o"] = isTrueProperty;
/* harmony export (immutable) */ __webpack_exports__["g"] = isCheckedProperty;
/* harmony export (immutable) */ __webpack_exports__["m"] = isRightSide;
/* harmony export (immutable) */ __webpack_exports__["s"] = reorderArray;
/* harmony export (immutable) */ __webpack_exports__["r"] = removeArrayItem;
/* harmony export (immutable) */ __webpack_exports__["u"] = swipeShouldReset;
/* harmony export (immutable) */ __webpack_exports__["t"] = requestIonicCallback;
/* unused harmony export assert */
/* unused harmony export runInDev */
/**
 * @hidden
 * Given a min and max, restrict the given number
 * to the range.
 * @param min the minimum
 * @param n the value
 * @param max the maximum
 */
function clamp(min, n, max) {
    return Math.max(min, Math.min(n, max));
}
/** @hidden */
function deepCopy(obj) {
    return JSON.parse(JSON.stringify(obj));
}
/** @hidden */
function deepEqual(a, b) {
    if (a === b) {
        return true;
    }
    return JSON.stringify(a) === JSON.stringify(b);
}
/** @hidden */
function debounce(fn, wait, immediate) {
    if (immediate === void 0) { immediate = false; }
    var timeout, args, context, timestamp, result;
    return function () {
        context = this;
        args = arguments;
        timestamp = Date.now();
        var later = function () {
            var last = Date.now() - timestamp;
            if (last < wait) {
                timeout = setTimeout(later, wait - last);
            }
            else {
                timeout = null;
                if (!immediate)
                    result = fn.apply(context, args);
            }
        };
        var callNow = immediate && !timeout;
        if (!timeout) {
            timeout = setTimeout(later, wait);
        }
        if (callNow)
            result = fn.apply(context, args);
        return result;
    };
}
/**
 * @hidden
 * Rewrites an absolute URL so it works across file and http based engines
 */
function normalizeURL(url) {
    var ionic = window['Ionic'];
    if (ionic && ionic.normalizeURL) {
        return ionic.normalizeURL(url);
    }
    return url;
}
/**
 * @hidden
 * Apply default arguments if they don't exist in
 * the first object.
 * @param {any} dest the destination to apply defaults to.
 */
function defaults(dest) {
    var _args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        _args[_i - 1] = arguments[_i];
    }
    for (var i = arguments.length - 1; i >= 1; i--) {
        var source = arguments[i];
        if (source) {
            for (var key in source) {
                if (source.hasOwnProperty(key) && !dest.hasOwnProperty(key)) {
                    dest[key] = source[key];
                }
            }
        }
    }
    return dest;
}
/** @hidden */
function isBoolean(val) { return typeof val === 'boolean'; }
/** @hidden */
function isString(val) { return typeof val === 'string'; }
/** @hidden */
function isNumber(val) { return typeof val === 'number'; }
/** @hidden */
function isFunction(val) { return typeof val === 'function'; }
/** @hidden */
function isDefined(val) { return typeof val !== 'undefined'; }
/** @hidden */
function isUndefined(val) { return typeof val === 'undefined'; }
/** @hidden */
function isPresent(val) { return val !== undefined && val !== null; }
/** @hidden */
function isBlank(val) { return val === undefined || val === null; }
/** @hidden */
function isObject(val) { return typeof val === 'object'; }
/** @hidden */
function isArray(val) { return Array.isArray(val); }
/** @hidden */
function isPrimitive(val) {
    return isString(val) || isBoolean(val) || (isNumber(val) && !isNaN(val));
}
/** @hidden */
function isTrueProperty(val) {
    if (typeof val === 'string') {
        val = val.toLowerCase().trim();
        return (val === 'true' || val === 'on' || val === '');
    }
    return !!val;
}
/** @hidden */
function isCheckedProperty(a, b) {
    if (a === undefined || a === null || a === '') {
        return (b === undefined || b === null || b === '');
    }
    else if (a === true || a === 'true') {
        return (b === true || b === 'true');
    }
    else if (a === false || a === 'false') {
        return (b === false || b === 'false');
    }
    else if (a === 0 || a === '0') {
        return (b === 0 || b === '0');
    }
    // not using strict comparison on purpose
    return (a == b); // tslint:disable-line
}
/**
 * @hidden
 * Given a side, return if it should be on the right
 * based on the value of dir
 * @param side the side
 * @param isRTL whether the application dir is rtl
 * @param defaultRight whether the default side is right
 */
function isRightSide(side, isRTL, defaultRight) {
    if (defaultRight === void 0) { defaultRight = false; }
    switch (side) {
        case 'right': return true;
        case 'left': return false;
        case 'end': return !isRTL;
        case 'start': return isRTL;
        default: return defaultRight ? !isRTL : isRTL;
    }
}
/** @hidden */
function reorderArray(array, indexes) {
    var element = array[indexes.from];
    array.splice(indexes.from, 1);
    array.splice(indexes.to, 0, element);
    return array;
}
/** @hidden */
function removeArrayItem(array, item) {
    var index = array.indexOf(item);
    return !!~index && !!array.splice(index, 1);
}
/** @hidden */
function swipeShouldReset(isResetDirection, isMovingFast, isOnResetZone) {
    // The logic required to know when the sliding item should close (openAmount=0)
    // depends on three booleans (isCloseDirection, isMovingFast, isOnCloseZone)
    // and it ended up being too complicated to be written manually without errors
    // so the truth table is attached below: (0=false, 1=true)
    // isCloseDirection | isMovingFast | isOnCloseZone || shouldClose
    //         0        |       0      |       0       ||    0
    //         0        |       0      |       1       ||    1
    //         0        |       1      |       0       ||    0
    //         0        |       1      |       1       ||    0
    //         1        |       0      |       0       ||    0
    //         1        |       0      |       1       ||    1
    //         1        |       1      |       0       ||    1
    //         1        |       1      |       1       ||    1
    // The resulting expression was generated by resolving the K-map (Karnaugh map):
    var shouldClose = (!isMovingFast && isOnResetZone) || (isResetDirection && isMovingFast);
    return shouldClose;
}
/** @hidden */
var ASSERT_ENABLED = true;
/** @hidden */
function _runInDev(fn) {
    if (ASSERT_ENABLED === true) {
        return fn();
    }
}
/** @hidden */
function _assert(actual, reason) {
    if (!actual && ASSERT_ENABLED === true) {
        var message = 'IONIC ASSERT: ' + reason;
        console.error(message);
        debugger; // tslint:disable-line
        throw new Error(message);
    }
}
/** @hidden */
function requestIonicCallback(functionToLazy) {
    if ('requestIdleCallback' in window) {
        return window.requestIdleCallback(functionToLazy);
    }
    else {
        return setTimeout(functionToLazy, 500);
    }
}
/** @hidden */

/** @hidden */

//# sourceMappingURL=util.js.map

/***/ }),

/***/ "./node_modules/isarray/index.js":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),

/***/ "./node_modules/mydatepicker/dist/directives/my-date-picker.focus.directive.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FocusDirective; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");

var FocusDirective = (function () {
    function FocusDirective(el, renderer) {
        this.el = el;
        this.renderer = renderer;
    }
    FocusDirective.prototype.ngAfterViewInit = function () {
        if (this.value === "0") {
            return;
        }
        this.renderer.invokeElementMethod(this.el.nativeElement, "focus", []);
    };
    FocusDirective.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: "[mydpfocus]"
                },] },
    ];
    FocusDirective.ctorParameters = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    ];
    FocusDirective.propDecorators = {
        'value': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ["mydpfocus",] },],
    };
    return FocusDirective;
}());
//# sourceMappingURL=my-date-picker.focus.directive.js.map

/***/ }),

/***/ "./node_modules/mydatepicker/dist/interfaces/my-calendar-view-changed.interface.js":
/***/ (function(module, exports) {

//# sourceMappingURL=my-calendar-view-changed.interface.js.map

/***/ }),

/***/ "./node_modules/mydatepicker/dist/interfaces/my-date-model.interface.js":
/***/ (function(module, exports) {

//# sourceMappingURL=my-date-model.interface.js.map

/***/ }),

/***/ "./node_modules/mydatepicker/dist/interfaces/my-date-range.interface.js":
/***/ (function(module, exports) {

//# sourceMappingURL=my-date-range.interface.js.map

/***/ }),

/***/ "./node_modules/mydatepicker/dist/interfaces/my-date.interface.js":
/***/ (function(module, exports) {

//# sourceMappingURL=my-date.interface.js.map

/***/ }),

/***/ "./node_modules/mydatepicker/dist/interfaces/my-day-labels.interface.js":
/***/ (function(module, exports) {

//# sourceMappingURL=my-day-labels.interface.js.map

/***/ }),

/***/ "./node_modules/mydatepicker/dist/interfaces/my-default-month.interface.js":
/***/ (function(module, exports) {

//# sourceMappingURL=my-default-month.interface.js.map

/***/ }),

/***/ "./node_modules/mydatepicker/dist/interfaces/my-input-field-changed.interface.js":
/***/ (function(module, exports) {

//# sourceMappingURL=my-input-field-changed.interface.js.map

/***/ }),

/***/ "./node_modules/mydatepicker/dist/interfaces/my-input-focus-blur.interface.js":
/***/ (function(module, exports) {

//# sourceMappingURL=my-input-focus-blur.interface.js.map

/***/ }),

/***/ "./node_modules/mydatepicker/dist/interfaces/my-marked-date.interface.js":
/***/ (function(module, exports) {

//# sourceMappingURL=my-marked-date.interface.js.map

/***/ }),

/***/ "./node_modules/mydatepicker/dist/interfaces/my-marked-dates.interface.js":
/***/ (function(module, exports) {

//# sourceMappingURL=my-marked-dates.interface.js.map

/***/ }),

/***/ "./node_modules/mydatepicker/dist/interfaces/my-month-labels.interface.js":
/***/ (function(module, exports) {

//# sourceMappingURL=my-month-labels.interface.js.map

/***/ }),

/***/ "./node_modules/mydatepicker/dist/interfaces/my-options.interface.js":
/***/ (function(module, exports) {

//# sourceMappingURL=my-options.interface.js.map

/***/ }),

/***/ "./node_modules/mydatepicker/dist/interfaces/my-selector.interface.js":
/***/ (function(module, exports) {

//# sourceMappingURL=my-selector.interface.js.map

/***/ }),

/***/ "./node_modules/mydatepicker/dist/interfaces/my-weekday.interface.js":
/***/ (function(module, exports) {

//# sourceMappingURL=my-weekday.interface.js.map

/***/ }),

/***/ "./node_modules/mydatepicker/dist/my-date-picker.component.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MYDP_VALUE_ACCESSOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MyDatePicker; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__("./node_modules/@angular/forms/esm5/forms.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_my_date_picker_locale_service__ = __webpack_require__("./node_modules/mydatepicker/dist/services/my-date-picker.locale.service.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_my_date_picker_util_service__ = __webpack_require__("./node_modules/mydatepicker/dist/services/my-date-picker.util.service.js");




var MYDP_VALUE_ACCESSOR = {
    provide: __WEBPACK_IMPORTED_MODULE_1__angular_forms__["NG_VALUE_ACCESSOR"],
    useExisting: Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return MyDatePicker; }),
    multi: true
};
var CalToggle;
(function (CalToggle) {
    CalToggle[CalToggle["Open"] = 1] = "Open";
    CalToggle[CalToggle["CloseByDateSel"] = 2] = "CloseByDateSel";
    CalToggle[CalToggle["CloseByCalBtn"] = 3] = "CloseByCalBtn";
    CalToggle[CalToggle["CloseByOutClick"] = 4] = "CloseByOutClick";
    CalToggle[CalToggle["CloseByEsc"] = 5] = "CloseByEsc";
    CalToggle[CalToggle["CloseByApi"] = 6] = "CloseByApi";
})(CalToggle || (CalToggle = {}));
var Year;
(function (Year) {
    Year[Year["min"] = 1000] = "min";
    Year[Year["max"] = 9999] = "max";
})(Year || (Year = {}));
var InputFocusBlur;
(function (InputFocusBlur) {
    InputFocusBlur[InputFocusBlur["focus"] = 1] = "focus";
    InputFocusBlur[InputFocusBlur["blur"] = 2] = "blur";
})(InputFocusBlur || (InputFocusBlur = {}));
var KeyCode;
(function (KeyCode) {
    KeyCode[KeyCode["enter"] = 13] = "enter";
    KeyCode[KeyCode["esc"] = 27] = "esc";
    KeyCode[KeyCode["space"] = 32] = "space";
})(KeyCode || (KeyCode = {}));
var MonthId;
(function (MonthId) {
    MonthId[MonthId["prev"] = 1] = "prev";
    MonthId[MonthId["curr"] = 2] = "curr";
    MonthId[MonthId["next"] = 3] = "next";
})(MonthId || (MonthId = {}));
var MMM = "mmm";
var MyDatePicker = (function () {
    function MyDatePicker(elem, renderer, cdr, localeService, utilService) {
        var _this = this;
        this.elem = elem;
        this.renderer = renderer;
        this.cdr = cdr;
        this.localeService = localeService;
        this.utilService = utilService;
        this.dateChanged = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.inputFieldChanged = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.calendarViewChanged = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.calendarToggle = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.inputFocusBlur = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.onChangeCb = function () { };
        this.onTouchedCb = function () { };
        this.showSelector = false;
        this.visibleMonth = { monthTxt: "", monthNbr: 0, year: 0 };
        this.selectedMonth = { monthTxt: "", monthNbr: 0, year: 0 };
        this.selectedDate = { year: 0, month: 0, day: 0 };
        this.weekDays = [];
        this.dates = [];
        this.months = [];
        this.years = [];
        this.selectionDayTxt = "";
        this.invalidDate = false;
        this.disableTodayBtn = false;
        this.dayIdx = 0;
        this.selectMonth = false;
        this.selectYear = false;
        this.prevMonthDisabled = false;
        this.nextMonthDisabled = false;
        this.prevYearDisabled = false;
        this.nextYearDisabled = false;
        this.prevYearsDisabled = false;
        this.nextYearsDisabled = false;
        this.prevMonthId = MonthId.prev;
        this.currMonthId = MonthId.curr;
        this.nextMonthId = MonthId.next;
        this.opts = {
            dayLabels: {},
            monthLabels: {},
            dateFormat: "",
            showTodayBtn: true,
            todayBtnTxt: "",
            firstDayOfWeek: "",
            satHighlight: false,
            sunHighlight: true,
            highlightDates: [],
            markCurrentDay: true,
            markCurrentMonth: true,
            markCurrentYear: true,
            disableUntil: { year: 0, month: 0, day: 0 },
            disableSince: { year: 0, month: 0, day: 0 },
            disableDays: [],
            enableDays: [],
            markDates: [],
            markWeekends: {},
            disableDateRanges: [],
            disableWeekends: false,
            disableWeekdays: [],
            showWeekNumbers: false,
            height: "34px",
            width: "100%",
            selectionTxtFontSize: "14px",
            selectorHeight: "232px",
            selectorWidth: "252px",
            allowDeselectDate: false,
            inline: false,
            showClearDateBtn: true,
            showDecreaseDateBtn: false,
            showIncreaseDateBtn: false,
            alignSelectorRight: false,
            openSelectorTopOfInput: false,
            indicateInvalidDate: true,
            editableDateField: true,
            monthSelector: true,
            yearSelector: true,
            disableHeaderButtons: true,
            minYear: Year.min,
            maxYear: Year.max,
            componentDisabled: false,
            showSelectorArrow: true,
            showInputField: true,
            openSelectorOnInputClick: false,
            allowSelectionOnlyInCurrentMonth: true,
            ariaLabelInputField: "Date input field",
            ariaLabelClearDate: "Clear Date",
            ariaLabelDecreaseDate: "Decrease Date",
            ariaLabelIncreaseDate: "Increase Date",
            ariaLabelOpenCalendar: "Open Calendar",
            ariaLabelPrevMonth: "Previous Month",
            ariaLabelNextMonth: "Next Month",
            ariaLabelPrevYear: "Previous Year",
            ariaLabelNextYear: "Next Year"
        };
        this.setLocaleOptions();
        this.globalListener = renderer.listenGlobal("document", "click", function (event) {
            if (_this.showSelector && event.target && _this.elem.nativeElement !== event.target && !_this.elem.nativeElement.contains(event.target)) {
                _this.showSelector = false;
                _this.calendarToggle.emit(CalToggle.CloseByOutClick);
            }
            if (_this.opts.monthSelector || _this.opts.yearSelector) {
                _this.resetMonthYearSelect();
            }
        });
    }
    MyDatePicker.prototype.setLocaleOptions = function () {
        var _this = this;
        var opts = this.localeService.getLocaleOptions(this.locale);
        Object.keys(opts).forEach(function (k) {
            _this.opts[k] = opts[k];
        });
    };
    MyDatePicker.prototype.setOptions = function () {
        var _this = this;
        if (this.options !== undefined) {
            Object.keys(this.options).forEach(function (k) {
                _this.opts[k] = _this.options[k];
            });
        }
        if (this.opts.minYear < Year.min) {
            this.opts.minYear = Year.min;
        }
        if (this.opts.maxYear > Year.max) {
            this.opts.maxYear = Year.max;
        }
        if (this.disabled !== undefined) {
            this.opts.componentDisabled = this.disabled;
        }
    };
    MyDatePicker.prototype.getSelectorTopPosition = function () {
        if (this.opts.openSelectorTopOfInput) {
            return this.elem.nativeElement.children[0].offsetHeight + "px";
        }
    };
    MyDatePicker.prototype.resetMonthYearSelect = function () {
        this.selectMonth = false;
        this.selectYear = false;
    };
    MyDatePicker.prototype.onSelectMonthClicked = function (event) {
        event.stopPropagation();
        this.selectMonth = !this.selectMonth;
        this.selectYear = false;
        this.cdr.detectChanges();
        if (this.selectMonth) {
            var today = this.getToday();
            this.months.length = 0;
            for (var i = 1; i <= 12; i += 3) {
                var row = [];
                for (var j = i; j < i + 3; j++) {
                    var disabled = this.utilService.isMonthDisabledByDisableUntil({ year: this.visibleMonth.year, month: j, day: this.daysInMonth(j, this.visibleMonth.year) }, this.opts.disableUntil)
                        || this.utilService.isMonthDisabledByDisableSince({ year: this.visibleMonth.year, month: j, day: 1 }, this.opts.disableSince);
                    row.push({ nbr: j, name: this.opts.monthLabels[j], currMonth: j === today.month && this.visibleMonth.year === today.year, selected: j === this.visibleMonth.monthNbr, disabled: disabled });
                }
                this.months.push(row);
            }
        }
    };
    MyDatePicker.prototype.onMonthCellClicked = function (cell) {
        var mc = cell.nbr !== this.visibleMonth.monthNbr;
        this.visibleMonth = { monthTxt: this.monthText(cell.nbr), monthNbr: cell.nbr, year: this.visibleMonth.year };
        this.generateCalendar(cell.nbr, this.visibleMonth.year, mc);
        this.selectMonth = false;
        this.selectorEl.nativeElement.focus();
    };
    MyDatePicker.prototype.onMonthCellKeyDown = function (event, cell) {
        if ((event.keyCode === KeyCode.enter || event.keyCode === KeyCode.space) && !cell.disabled) {
            event.preventDefault();
            this.onMonthCellClicked(cell);
        }
    };
    MyDatePicker.prototype.onSelectYearClicked = function (event) {
        event.stopPropagation();
        this.selectYear = !this.selectYear;
        this.selectMonth = false;
        this.cdr.detectChanges();
        if (this.selectYear) {
            this.generateYears(Number(this.visibleMonth.year));
        }
    };
    MyDatePicker.prototype.onYearCellClicked = function (cell) {
        var yc = cell.year !== this.visibleMonth.year;
        this.visibleMonth = { monthTxt: this.visibleMonth.monthTxt, monthNbr: this.visibleMonth.monthNbr, year: cell.year };
        this.generateCalendar(this.visibleMonth.monthNbr, cell.year, yc);
        this.selectYear = false;
        this.selectorEl.nativeElement.focus();
    };
    MyDatePicker.prototype.onYearCellKeyDown = function (event, cell) {
        if ((event.keyCode === KeyCode.enter || event.keyCode === KeyCode.space) && !cell.disabled) {
            event.preventDefault();
            this.onYearCellClicked(cell);
        }
    };
    MyDatePicker.prototype.onPrevYears = function (event, year) {
        event.stopPropagation();
        this.generateYears(Number(year) - 25);
    };
    MyDatePicker.prototype.onNextYears = function (event, year) {
        event.stopPropagation();
        this.generateYears(Number(year) + 25);
    };
    MyDatePicker.prototype.generateYears = function (year) {
        this.years.length = 0;
        var today = this.getToday();
        for (var i = year; i <= 20 + year; i += 5) {
            var row = [];
            for (var j = i; j < i + 5; j++) {
                var disabled = this.utilService.isMonthDisabledByDisableUntil({ year: j, month: this.visibleMonth.monthNbr, day: this.daysInMonth(this.visibleMonth.monthNbr, j) }, this.opts.disableUntil)
                    || this.utilService.isMonthDisabledByDisableSince({ year: j, month: this.visibleMonth.monthNbr, day: 1 }, this.opts.disableSince);
                var minMax = j < this.opts.minYear || j > this.opts.maxYear;
                row.push({ year: j, currYear: j === today.year, selected: j === this.visibleMonth.year, disabled: disabled || minMax });
            }
            this.years.push(row);
        }
        this.prevYearsDisabled = this.years[0][0].year <= this.opts.minYear || this.utilService.isMonthDisabledByDisableUntil({ year: this.years[0][0].year - 1, month: this.visibleMonth.monthNbr, day: this.daysInMonth(this.visibleMonth.monthNbr, this.years[0][0].year - 1) }, this.opts.disableUntil);
        this.nextYearsDisabled = this.years[4][4].year >= this.opts.maxYear || this.utilService.isMonthDisabledByDisableSince({ year: this.years[4][4].year + 1, month: this.visibleMonth.monthNbr, day: 1 }, this.opts.disableSince);
    };
    MyDatePicker.prototype.onUserDateInput = function (value) {
        if (value.length === 0) {
            if (this.utilService.isInitializedDate(this.selectedDate)) {
                this.clearDate();
            }
            else {
                this.invalidInputFieldChanged(value);
            }
        }
        else {
            var date = this.utilService.isDateValid(value, this.opts.dateFormat, this.opts.minYear, this.opts.maxYear, this.opts.disableUntil, this.opts.disableSince, this.opts.disableWeekends, this.opts.disableWeekdays, this.opts.disableDays, this.opts.disableDateRanges, this.opts.monthLabels, this.opts.enableDays);
            if (this.utilService.isInitializedDate(date)) {
                if (!this.utilService.isSameDate(date, this.selectedDate)) {
                    this.selectDate(date, CalToggle.CloseByDateSel);
                }
                else {
                    this.updateDateValue(date);
                }
            }
            else {
                this.invalidInputFieldChanged(value);
            }
        }
    };
    MyDatePicker.prototype.onFocusInput = function (event) {
        this.inputFocusBlur.emit({ reason: InputFocusBlur.focus, value: event.target.value });
    };
    MyDatePicker.prototype.onBlurInput = function (event) {
        this.selectionDayTxt = event.target.value;
        this.onTouchedCb();
        this.inputFocusBlur.emit({ reason: InputFocusBlur.blur, value: event.target.value });
    };
    MyDatePicker.prototype.onCloseSelector = function (event) {
        if (event.keyCode === KeyCode.esc && this.showSelector && !this.opts.inline) {
            this.calendarToggle.emit(CalToggle.CloseByEsc);
            this.showSelector = false;
        }
    };
    MyDatePicker.prototype.invalidInputFieldChanged = function (value) {
        this.invalidDate = value.length > 0;
        this.inputFieldChanged.emit({ value: value, dateFormat: this.opts.dateFormat, valid: false });
        this.onChangeCb(null);
        this.onTouchedCb();
    };
    MyDatePicker.prototype.isTodayDisabled = function () {
        this.disableTodayBtn = this.utilService.isDisabledDay(this.getToday(), this.opts.minYear, this.opts.maxYear, this.opts.disableUntil, this.opts.disableSince, this.opts.disableWeekends, this.opts.disableWeekdays, this.opts.disableDays, this.opts.disableDateRanges, this.opts.enableDays);
    };
    MyDatePicker.prototype.parseOptions = function () {
        if (this.locale) {
            this.setLocaleOptions();
        }
        this.setOptions();
        var weekDays = this.utilService.getWeekDays();
        this.isTodayDisabled();
        this.dayIdx = weekDays.indexOf(this.opts.firstDayOfWeek);
        if (this.dayIdx !== -1) {
            var idx = this.dayIdx;
            for (var i = 0; i < weekDays.length; i++) {
                this.weekDays.push(this.opts.dayLabels[weekDays[idx]]);
                idx = weekDays[idx] === "sa" ? 0 : idx + 1;
            }
        }
    };
    MyDatePicker.prototype.writeValue = function (value) {
        if (value && (value["date"] || value["jsdate"] || value["formatted"])) {
            this.selectedDate = value["date"] ? this.parseSelectedDate(value["date"]) : value["jsdate"] ? this.parseSelectedDate(this.jsDateToMyDate(value["jsdate"])) : this.parseSelectedDate(value["formatted"]);
            var cvc = this.visibleMonth.year !== this.selectedDate.year || this.visibleMonth.monthNbr !== this.selectedDate.month;
            if (cvc) {
                this.visibleMonth = { monthTxt: this.opts.monthLabels[this.selectedDate.month], monthNbr: this.selectedDate.month, year: this.selectedDate.year };
                this.generateCalendar(this.selectedDate.month, this.selectedDate.year, cvc);
            }
            this.selectionDayTxt = this.utilService.formatDate(this.selectedDate, this.opts.dateFormat, this.opts.monthLabels);
        }
        else if (value === null || value === "") {
            this.selectedDate = { year: 0, month: 0, day: 0 };
            this.selectionDayTxt = "";
        }
        this.inputFieldChanged.emit({ value: this.selectionDayTxt, dateFormat: this.opts.dateFormat, valid: this.selectionDayTxt.length > 0 });
        this.invalidDate = false;
    };
    MyDatePicker.prototype.setDisabledState = function (disabled) {
        this.opts.componentDisabled = disabled;
    };
    MyDatePicker.prototype.registerOnChange = function (fn) {
        this.onChangeCb = fn;
    };
    MyDatePicker.prototype.registerOnTouched = function (fn) {
        this.onTouchedCb = fn;
    };
    MyDatePicker.prototype.ngOnChanges = function (changes) {
        var _this = this;
        if (changes.hasOwnProperty("selector")) {
            var s = changes["selector"].currentValue;
            if (typeof s === "object") {
                if (s.open) {
                    this.showSelector = true;
                    this.openSelector(CalToggle.Open);
                }
                else {
                    this.showSelector = false;
                    this.closeSelector(CalToggle.CloseByApi);
                }
            }
            else if (s > 0) {
                this.openBtnClicked();
            }
        }
        if (changes.hasOwnProperty("placeholder")) {
            this.placeholder = changes["placeholder"].currentValue;
        }
        if (changes.hasOwnProperty("locale")) {
            this.locale = changes["locale"].currentValue;
        }
        if (changes.hasOwnProperty("disabled")) {
            this.disabled = changes["disabled"].currentValue;
        }
        if (changes.hasOwnProperty("options")) {
            this.options = changes["options"].currentValue;
        }
        this.weekDays.length = 0;
        this.parseOptions();
        var dmChange = false;
        if (changes.hasOwnProperty("defaultMonth")) {
            var dm = changes["defaultMonth"].currentValue;
            if (typeof dm === "object") {
                dm = dm.defMonth;
            }
            if (dm !== null && dm !== undefined && dm !== "") {
                this.selectedMonth = this.parseSelectedMonth(dm);
            }
            else {
                this.selectedMonth = { monthTxt: "", monthNbr: 0, year: 0 };
            }
            dmChange = true;
        }
        if (changes.hasOwnProperty("selDate")) {
            var sd = changes["selDate"];
            if (sd.currentValue !== null && sd.currentValue !== undefined && sd.currentValue !== "" && Object.keys(sd.currentValue).length !== 0) {
                this.selectedDate = this.parseSelectedDate(sd.currentValue);
                setTimeout(function () {
                    _this.onChangeCb(_this.getDateModel(_this.selectedDate));
                });
            }
            else {
                if (!sd.isFirstChange()) {
                    this.clearDate();
                }
            }
        }
        if (this.visibleMonth.year === 0 && this.visibleMonth.monthNbr === 0 || dmChange) {
            this.setVisibleMonth();
        }
        else {
            this.visibleMonth.monthTxt = this.opts.monthLabels[this.visibleMonth.monthNbr];
            this.generateCalendar(this.visibleMonth.monthNbr, this.visibleMonth.year, false);
        }
    };
    MyDatePicker.prototype.removeBtnClicked = function () {
        this.clearDate();
        if (this.showSelector) {
            this.calendarToggle.emit(CalToggle.CloseByCalBtn);
        }
        this.showSelector = false;
    };
    MyDatePicker.prototype.onDecreaseBtnClicked = function () {
        this.decreaseIncreaseDate(true);
    };
    MyDatePicker.prototype.onIncreaseBtnClicked = function () {
        this.decreaseIncreaseDate(false);
    };
    MyDatePicker.prototype.openBtnClicked = function () {
        this.showSelector = !this.showSelector;
        this.cdr.detectChanges();
        if (this.showSelector) {
            this.openSelector(CalToggle.Open);
        }
        else {
            this.closeSelector(CalToggle.CloseByCalBtn);
        }
    };
    MyDatePicker.prototype.openSelector = function (reason) {
        this.setVisibleMonth();
        this.calendarToggle.emit(reason);
    };
    MyDatePicker.prototype.closeSelector = function (reason) {
        this.calendarToggle.emit(reason);
    };
    MyDatePicker.prototype.setVisibleMonth = function () {
        var y = 0, m = 0;
        if (!this.utilService.isInitializedDate(this.selectedDate)) {
            if (this.selectedMonth.year === 0 && this.selectedMonth.monthNbr === 0) {
                var today = this.getToday();
                y = today.year;
                m = today.month;
            }
            else {
                y = this.selectedMonth.year;
                m = this.selectedMonth.monthNbr;
            }
        }
        else {
            y = this.selectedDate.year;
            m = this.selectedDate.month;
        }
        this.visibleMonth = { monthTxt: this.opts.monthLabels[m], monthNbr: m, year: y };
        this.generateCalendar(m, y, true);
    };
    MyDatePicker.prototype.onPrevMonth = function () {
        var d = this.getDate(this.visibleMonth.year, this.visibleMonth.monthNbr, 1);
        d.setMonth(d.getMonth() - 1);
        var y = d.getFullYear();
        var m = d.getMonth() + 1;
        this.visibleMonth = { monthTxt: this.monthText(m), monthNbr: m, year: y };
        this.generateCalendar(m, y, true);
    };
    MyDatePicker.prototype.onNextMonth = function () {
        var d = this.getDate(this.visibleMonth.year, this.visibleMonth.monthNbr, 1);
        d.setMonth(d.getMonth() + 1);
        var y = d.getFullYear();
        var m = d.getMonth() + 1;
        this.visibleMonth = { monthTxt: this.monthText(m), monthNbr: m, year: y };
        this.generateCalendar(m, y, true);
    };
    MyDatePicker.prototype.onPrevYear = function () {
        this.visibleMonth.year--;
        this.generateCalendar(this.visibleMonth.monthNbr, this.visibleMonth.year, true);
    };
    MyDatePicker.prototype.onNextYear = function () {
        this.visibleMonth.year++;
        this.generateCalendar(this.visibleMonth.monthNbr, this.visibleMonth.year, true);
    };
    MyDatePicker.prototype.onTodayClicked = function () {
        var today = this.getToday();
        this.selectDate(today, CalToggle.CloseByDateSel);
        if (this.opts.inline && today.year !== this.visibleMonth.year || today.month !== this.visibleMonth.monthNbr) {
            this.visibleMonth = { monthTxt: this.opts.monthLabels[today.month], monthNbr: today.month, year: today.year };
            this.generateCalendar(today.month, today.year, true);
        }
    };
    MyDatePicker.prototype.onCellClicked = function (cell) {
        if (cell.cmo === this.prevMonthId) {
            this.onPrevMonth();
            if (!this.opts.allowSelectionOnlyInCurrentMonth) {
                this.selectDate(cell.dateObj, CalToggle.CloseByDateSel);
            }
        }
        else if (cell.cmo === this.currMonthId) {
            if (this.opts.allowDeselectDate && this.utilService.isSameDate(cell.dateObj, this.selectedDate)) {
                this.clearDate();
            }
            else {
                this.selectDate(cell.dateObj, CalToggle.CloseByDateSel);
            }
        }
        else if (cell.cmo === this.nextMonthId) {
            this.onNextMonth();
            if (!this.opts.allowSelectionOnlyInCurrentMonth) {
                this.selectDate(cell.dateObj, CalToggle.CloseByDateSel);
            }
        }
        this.resetMonthYearSelect();
    };
    MyDatePicker.prototype.onCellKeyDown = function (event, cell) {
        if ((event.keyCode === KeyCode.enter || event.keyCode === KeyCode.space) && !cell.disabled) {
            event.preventDefault();
            this.onCellClicked(cell);
        }
    };
    MyDatePicker.prototype.clearDate = function () {
        this.updateDateValue({ year: 0, month: 0, day: 0 });
        this.setFocusToInputBox();
    };
    MyDatePicker.prototype.decreaseIncreaseDate = function (decrease) {
        var date = this.selectedDate;
        if (this.utilService.isInitializedDate(date)) {
            var d = this.getDate(date.year, date.month, date.day);
            d.setDate(decrease ? d.getDate() - 1 : d.getDate() + 1);
            date = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
        }
        else {
            date = this.getToday();
        }
        this.selectDate(date, CalToggle.CloseByCalBtn);
    };
    MyDatePicker.prototype.selectDate = function (date, closeReason) {
        this.updateDateValue(date);
        if (this.showSelector) {
            this.calendarToggle.emit(closeReason);
        }
        this.showSelector = false;
        this.setFocusToInputBox();
    };
    MyDatePicker.prototype.setFocusToInputBox = function () {
        var _this = this;
        if (!this.opts.inline && this.opts.showInputField) {
            setTimeout(function () {
                _this.inputBoxEl.nativeElement.focus();
            }, 100);
        }
    };
    MyDatePicker.prototype.updateDateValue = function (date) {
        var clear = !this.utilService.isInitializedDate(date);
        this.selectedDate = date;
        this.emitDateChanged(date);
        if (!this.opts.inline) {
            this.selectionDayTxt = clear ? "" : this.utilService.formatDate(date, this.opts.dateFormat, this.opts.monthLabels);
            this.inputFieldChanged.emit({ value: this.selectionDayTxt, dateFormat: this.opts.dateFormat, valid: !clear });
            this.invalidDate = false;
        }
    };
    MyDatePicker.prototype.emitDateChanged = function (date) {
        if (this.utilService.isInitializedDate(date)) {
            var dateModel = this.getDateModel(date);
            this.dateChanged.emit(dateModel);
            this.onChangeCb(dateModel);
            this.onTouchedCb();
        }
        else {
            this.dateChanged.emit({ date: date, jsdate: null, formatted: "", epoc: 0 });
            this.onChangeCb(null);
            this.onTouchedCb();
        }
    };
    MyDatePicker.prototype.getDateModel = function (date) {
        return { date: date, jsdate: this.getDate(date.year, date.month, date.day), formatted: this.utilService.formatDate(date, this.opts.dateFormat, this.opts.monthLabels), epoc: Math.round(this.getTimeInMilliseconds(date) / 1000.0) };
    };
    MyDatePicker.prototype.monthText = function (m) {
        return this.opts.monthLabels[m];
    };
    MyDatePicker.prototype.monthStartIdx = function (y, m) {
        var d = new Date();
        d.setDate(1);
        d.setMonth(m - 1);
        d.setFullYear(y);
        var idx = d.getDay() + this.sundayIdx();
        return idx >= 7 ? idx - 7 : idx;
    };
    MyDatePicker.prototype.daysInMonth = function (m, y) {
        return new Date(y, m, 0).getDate();
    };
    MyDatePicker.prototype.daysInPrevMonth = function (m, y) {
        var d = this.getDate(y, m, 1);
        d.setMonth(d.getMonth() - 1);
        return this.daysInMonth(d.getMonth() + 1, d.getFullYear());
    };
    MyDatePicker.prototype.isCurrDay = function (d, m, y, cmo, today) {
        return d === today.day && m === today.month && y === today.year && cmo === this.currMonthId;
    };
    MyDatePicker.prototype.getToday = function () {
        var date = new Date();
        return { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() };
    };
    MyDatePicker.prototype.getTimeInMilliseconds = function (date) {
        return this.getDate(date.year, date.month, date.day).getTime();
    };
    MyDatePicker.prototype.getWeekday = function (date) {
        var weekDays = this.utilService.getWeekDays();
        return weekDays[this.utilService.getDayNumber(date)];
    };
    MyDatePicker.prototype.getDate = function (year, month, day) {
        return new Date(year, month - 1, day, 0, 0, 0, 0);
    };
    MyDatePicker.prototype.sundayIdx = function () {
        return this.dayIdx > 0 ? 7 - this.dayIdx : 0;
    };
    MyDatePicker.prototype.generateCalendar = function (m, y, notifyChange) {
        this.dates.length = 0;
        var today = this.getToday();
        var monthStart = this.monthStartIdx(y, m);
        var dInThisM = this.daysInMonth(m, y);
        var dInPrevM = this.daysInPrevMonth(m, y);
        var dayNbr = 1;
        var cmo = this.prevMonthId;
        for (var i = 1; i < 7; i++) {
            var week = [];
            if (i === 1) {
                var pm = dInPrevM - monthStart + 1;
                for (var j = pm; j <= dInPrevM; j++) {
                    var date = { year: m === 1 ? y - 1 : y, month: m === 1 ? 12 : m - 1, day: j };
                    week.push({ dateObj: date, cmo: cmo, currDay: this.isCurrDay(j, m, y, cmo, today),
                        disabled: this.utilService.isDisabledDay(date, this.opts.minYear, this.opts.maxYear, this.opts.disableUntil, this.opts.disableSince, this.opts.disableWeekends, this.opts.disableWeekdays, this.opts.disableDays, this.opts.disableDateRanges, this.opts.enableDays),
                        markedDate: this.utilService.isMarkedDate(date, this.opts.markDates, this.opts.markWeekends),
                        highlight: this.utilService.isHighlightedDate(date, this.opts.sunHighlight, this.opts.satHighlight, this.opts.highlightDates) });
                }
                cmo = this.currMonthId;
                var daysLeft = 7 - week.length;
                for (var j = 0; j < daysLeft; j++) {
                    var date = { year: y, month: m, day: dayNbr };
                    week.push({ dateObj: date, cmo: cmo, currDay: this.isCurrDay(dayNbr, m, y, cmo, today),
                        disabled: this.utilService.isDisabledDay(date, this.opts.minYear, this.opts.maxYear, this.opts.disableUntil, this.opts.disableSince, this.opts.disableWeekends, this.opts.disableWeekdays, this.opts.disableDays, this.opts.disableDateRanges, this.opts.enableDays),
                        markedDate: this.utilService.isMarkedDate(date, this.opts.markDates, this.opts.markWeekends),
                        highlight: this.utilService.isHighlightedDate(date, this.opts.sunHighlight, this.opts.satHighlight, this.opts.highlightDates) });
                    dayNbr++;
                }
            }
            else {
                for (var j = 1; j < 8; j++) {
                    if (dayNbr > dInThisM) {
                        dayNbr = 1;
                        cmo = this.nextMonthId;
                    }
                    var date = { year: cmo === this.nextMonthId && m === 12 ? y + 1 : y, month: cmo === this.currMonthId ? m : cmo === this.nextMonthId && m < 12 ? m + 1 : 1, day: dayNbr };
                    week.push({ dateObj: date, cmo: cmo, currDay: this.isCurrDay(dayNbr, m, y, cmo, today),
                        disabled: this.utilService.isDisabledDay(date, this.opts.minYear, this.opts.maxYear, this.opts.disableUntil, this.opts.disableSince, this.opts.disableWeekends, this.opts.disableWeekdays, this.opts.disableDays, this.opts.disableDateRanges, this.opts.enableDays),
                        markedDate: this.utilService.isMarkedDate(date, this.opts.markDates, this.opts.markWeekends),
                        highlight: this.utilService.isHighlightedDate(date, this.opts.sunHighlight, this.opts.satHighlight, this.opts.highlightDates) });
                    dayNbr++;
                }
            }
            var weekNbr = this.opts.showWeekNumbers && this.opts.firstDayOfWeek === "mo" ? this.utilService.getWeekNumber(week[0].dateObj) : 0;
            this.dates.push({ week: week, weekNbr: weekNbr });
        }
        this.setHeaderBtnDisabledState(m, y);
        if (notifyChange) {
            this.calendarViewChanged.emit({ year: y, month: m, first: { number: 1, weekday: this.getWeekday({ year: y, month: m, day: 1 }) }, last: { number: dInThisM, weekday: this.getWeekday({ year: y, month: m, day: dInThisM }) } });
        }
    };
    MyDatePicker.prototype.parseSelectedDate = function (selDate) {
        var date = { day: 0, month: 0, year: 0 };
        if (typeof selDate === "string") {
            var sd = selDate;
            var df = this.opts.dateFormat;
            var delimeters = this.utilService.getDateFormatDelimeters(df);
            var dateValue = this.utilService.getDateValue(sd, df, delimeters);
            date.year = this.utilService.getNumberByValue(dateValue[0]);
            date.month = df.indexOf(MMM) !== -1 ? this.utilService.getMonthNumberByMonthName(dateValue[1], this.opts.monthLabels) : this.utilService.getNumberByValue(dateValue[1]);
            date.day = this.utilService.getNumberByValue(dateValue[2]);
        }
        else if (typeof selDate === "object") {
            date = selDate;
        }
        this.selectionDayTxt = this.utilService.formatDate(date, this.opts.dateFormat, this.opts.monthLabels);
        return date;
    };
    MyDatePicker.prototype.jsDateToMyDate = function (date) {
        return { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() };
    };
    MyDatePicker.prototype.parseSelectedMonth = function (ms) {
        return this.utilService.parseDefaultMonth(ms);
    };
    MyDatePicker.prototype.setHeaderBtnDisabledState = function (m, y) {
        var dpm = false;
        var dpy = false;
        var dnm = false;
        var dny = false;
        if (this.opts.disableHeaderButtons) {
            dpm = this.utilService.isMonthDisabledByDisableUntil({ year: m === 1 ? y - 1 : y, month: m === 1 ? 12 : m - 1, day: this.daysInMonth(m === 1 ? 12 : m - 1, m === 1 ? y - 1 : y) }, this.opts.disableUntil);
            dpy = this.utilService.isMonthDisabledByDisableUntil({ year: y - 1, month: m, day: this.daysInMonth(m, y - 1) }, this.opts.disableUntil);
            dnm = this.utilService.isMonthDisabledByDisableSince({ year: m === 12 ? y + 1 : y, month: m === 12 ? 1 : m + 1, day: 1 }, this.opts.disableSince);
            dny = this.utilService.isMonthDisabledByDisableSince({ year: y + 1, month: m, day: 1 }, this.opts.disableSince);
        }
        this.prevMonthDisabled = m === 1 && y === this.opts.minYear || dpm;
        this.prevYearDisabled = y - 1 < this.opts.minYear || dpy;
        this.nextMonthDisabled = m === 12 && y === this.opts.maxYear || dnm;
        this.nextYearDisabled = y + 1 > this.opts.maxYear || dny;
    };
    MyDatePicker.prototype.ngOnDestroy = function () {
        this.globalListener();
    };
    MyDatePicker.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: "my-date-picker",
                    exportAs: "mydatepicker",
                    styles: [".mydp .headertodaybtn,.mydp .monthcell,.mydp .selection,.mydp .weekdaytitle{overflow:hidden;white-space:nowrap}.mydp{line-height:1.1;display:inline-block;position:relative}.mydp *{-moz-box-sizing:border-box;-webkit-box-sizing:border-box;box-sizing:border-box;font-family:Arial,Helvetica,sans-serif;padding:0;margin:0}.mydp,.mydp .headertodaybtn,.mydp .selection,.mydp .selectiongroup,.mydp .selector{border-radius:4px}.mydp .header{border-radius:4px 4px 0 0}.mydp .caltable,.mydp .monthtable,.mydp .yeartable{border-radius:0 0 4px 4px}.mydp .caltable tbody tr:nth-child(6) td:first-child,.mydp .monthtable tbody tr:nth-child(4) td:first-child,.mydp .yeartable tbody tr:nth-child(7) td:first-child{border-bottom-left-radius:4px}.mydp .caltable tbody tr:nth-child(6) td:last-child,.mydp .monthtable tbody tr:nth-child(4) td:last-child,.mydp .yeartable tbody tr:nth-child(7) td:last-child{border-bottom-right-radius:4px}.mydp .btnpicker{border-radius:0 4px 4px 0}.mydp .btnleftborderradius{border-top-left-radius:4px;border-bottom-left-radius:4px}.mydp .selector{margin-top:2px;margin-left:-1px;position:absolute;padding:0;border:1px solid #CCC;z-index:100;animation:selectorfadein .1s}.mydp .selector:focus{border:1px solid #ADD8E6;outline:0}@keyframes selectorfadein{from{opacity:0}to{opacity:1}}.mydp .selectorarrow{background:#FAFAFA;margin-top:12px;padding:0}.mydp .selectorarrow:after,.mydp .selectorarrow:before{bottom:100%;border:solid transparent;content:\" \";height:0;width:0;position:absolute}.mydp .selectorarrow:after{border-color:rgba(250,250,250,0);border-bottom-color:#FAFAFA;border-width:10px;margin-left:-10px}.mydp .selectorarrow:before{border-color:rgba(204,204,204,0);border-bottom-color:#CCC;border-width:11px;margin-left:-11px}.mydp .selectorarrow:focus:before{border-bottom-color:#ADD8E6}.mydp .selectorarrowleft:after,.mydp .selectorarrowleft:before{left:24px}.mydp .selectorarrowright:after,.mydp .selectorarrowright:before{left:86%}.mydp .alignselectorright{right:-1px}.mydp .selectiongroup{position:relative;display:table;border:none;border-spacing:0;background-color:#FFF}.mydp .selection{width:100%;outline:0;background-color:#FFF;display:table-cell;position:absolute;text-overflow:ellipsis;padding-left:6px;border:none;color:#555}.mydp .invaliddate{background-color:#F1DEDE}.mydp ::-ms-clear{display:none}.mydp .headerbtncell,.mydp .selbtngroup{display:table-cell;vertical-align:middle}.mydp .selbtngroup{position:relative;white-space:nowrap;width:1%;font-size:0}.mydp .btnclear,.mydp .btndecrease,.mydp .btnincrease,.mydp .btnpicker{height:100%;width:26px;border:none;padding:0;outline:0;font:inherit;-moz-user-select:none}.mydp .btnleftborder{border-left:1px solid #CCC}.mydp .btnclearenabled,.mydp .btndecreaseenabled,.mydp .btnincreaseenabled,.mydp .btnpickerenabled,.mydp .headerbtnenabled,.mydp .headertodaybtnenabled,.mydp .yearchangebtnenabled{cursor:pointer}.mydp .btncleardisabled,.mydp .btndecreasedisabled,.mydp .btnincreasedisabled,.mydp .btnpickerdisabled,.mydp .headerbtndisabled,.mydp .headertodaybtndisabled,.mydp .selectiondisabled,.mydp .yearchangebtndisabled{cursor:not-allowed;opacity:.65}.mydp .selectiondisabled{background-color:#EEE}.mydp .btnclear,.mydp .btndecrease,.mydp .btnincrease,.mydp .btnpicker,.mydp .headertodaybtn{background:#FFF}.mydp .header{width:100%;height:30px;background-color:#FAFAFA}.mydp .header td{vertical-align:middle;border:none;line-height:0}.mydp .header td:nth-child(1){padding-left:4px}.mydp .header td:nth-child(2){text-align:center}.mydp .header td:nth-child(3){padding-right:4px}.mydp .caltable,.mydp .monthtable,.mydp .yeartable{table-layout:fixed;width:100%;height:calc(100% - 30px);background-color:#FFF;font-size:14px}.mydp .caltable,.mydp .daycell,.mydp .monthcell,.mydp .monthtable,.mydp .weekdaytitle,.mydp .yearcell,.mydp .yeartable{border-collapse:collapse;color:#036;line-height:1.1}.mydp .daycell,.mydp .monthcell,.mydp .weekdaytitle,.mydp .yearcell{padding:4px;text-align:center}.mydp .weekdaytitle{background-color:#DDD;font-size:11px;font-weight:400;vertical-align:middle;max-width:36px}.mydp .weekdaytitleweeknbr{width:20px;border-right:1px solid #BBB}.mydp .monthcell{background-color:#FAFAFA}.mydp .yearcell{background-color:#FAFAFA;width:20%}.mydp .daycell .datevalue{background-color:inherit;vertical-align:middle}.mydp .daycell .datevalue span{vertical-align:middle}.mydp .daycellweeknbr{font-size:10px;border-right:1px solid #CCC;cursor:default;color:#000}.mydp .inlinedp{position:relative;margin-top:-1px}.mydp .nextmonth,.mydp .prevmonth{color:#999}.mydp .disabled{cursor:default!important;color:#CCC;background:#FBEFEF}.mydp .highlight{color:#C30000}.mydp .dimday{opacity:.5}.mydp .currmonth{background-color:#F6F6F6;font-weight:400}.mydp .markdate{position:absolute;width:4px;height:4px;border-radius:4px}.mydp .markcurrday,.mydp .markcurrmonth,.mydp .markcurryear{text-decoration:underline}.mydp .selectedday .datevalue,.mydp .selectedmonth .monthvalue,.mydp .selectedyear .yearvalue{border:none;background-color:#8EBFFF;border-radius:2px}.mydp .headerbtncell{background-color:#FAFAFA}.mydp .yearchangebtncell{text-align:center;background-color:#FAFAFA}.mydp .headerbtn,.mydp .headerlabelbtn,.mydp .yearchangebtn{background:#FAFAFA;border:none;height:22px}.mydp .headerbtn{width:16px}.mydp .headerlabelbtn{font-size:14px;outline:0;cursor:default}.mydp,.mydp .headertodaybtn{border:1px solid #CCC}.mydp .btnclear,.mydp .btndecrease,.mydp .btnincrease,.mydp .btnpicker,.mydp .headerbtn,.mydp .headermonthtxt,.mydp .headertodaybtn,.mydp .headeryeartxt,.mydp .yearchangebtn{color:#000}.mydp .headertodaybtn{padding:0 4px;font-size:11px;height:22px;min-width:60px;max-width:84px}.mydp button::-moz-focus-inner{border:0}.mydp .headermonthtxt,.mydp .headeryeartxt{text-align:center;display:table-cell;vertical-align:middle;font-size:14px;height:26px;width:40px;max-width:40px;overflow:hidden;white-space:nowrap}.mydp .btnclear:focus,.mydp .btndecrease:focus,.mydp .btnincrease:focus,.mydp .btnpicker:focus,.mydp .headertodaybtn:focus{background:#ADD8E6}.mydp .headerbtn:focus,.mydp .monthlabel:focus,.mydp .yearchangebtn:focus,.mydp .yearlabel:focus{color:#ADD8E6;outline:0}.mydp .daycell:focus,.mydp .monthcell:focus,.mydp .yearcell:focus{outline:#CCC solid 1px}.mydp .icon-mydpcalendar,.mydp .icon-mydpremove{font-size:16px}.mydp .icon-mydpdown,.mydp .icon-mydpleft,.mydp .icon-mydpright,.mydp .icon-mydpup{color:#222;font-size:20px}.mydp .btndecrease .icon-mydpleft,.mydp .btnincrease .icon-mydpright{font-size:16px}.mydp .icon-mydptoday{color:#222;font-size:11px}.mydp table{display:table;border-spacing:0}.mydp table td{padding:0}.mydp table,.mydp td,.mydp th{border:none}.mydp .btnclearenabled:hover,.mydp .btndecreaseenabled:hover,.mydp .btnincreaseenabled:hover,.mydp .btnpickerenabled:hover,.mydp .headertodaybtnenabled:hover{background-color:#E6E6E6}.mydp .tablesingleday:hover,.mydp .tablesinglemonth:hover,.mydp .tablesingleyear:hover{background-color:#DDD}.mydp .daycell,.mydp .inputnoteditable,.mydp .monthcell,.mydp .monthlabel,.mydp .yearcell,.mydp .yearlabel{cursor:pointer}.mydp .headerbtnenabled:hover,.mydp .monthlabel:hover,.mydp .yearchangebtnenabled:hover,.mydp .yearlabel:hover{color:#777}@font-face{font-family:mydatepicker;src:url(data:application/octet-stream;base64,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) format('truetype');font-weight:400;font-style:normal}.mydp .mydpicon{font-family:mydatepicker;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.mydp .icon-mydpright:before{content:\"\\e800\"}.mydp .icon-mydpleft:before{content:\"\\e801\"}.mydp .icon-mydptoday:before{content:\"\\e802\"}.mydp .icon-mydpcalendar:before{content:\"\\e803\"}.mydp .icon-mydpup:before{content:\"\\e804\"}.mydp .icon-mydpdown:before{content:\"\\e805\"}.mydp .icon-mydpremove:before{content:\"\\e806\"}"],
                    template: "<div class=\"mydp\" [ngStyle]=\"{'width': opts.showInputField ? opts.width : null, 'border': opts.inline ? 'none' : null}\"><div class=\"selectiongroup\" *ngIf=\"!opts.inline\"><input *ngIf=\"opts.showInputField\" #inputBoxEl ngtype=\"text\" class=\"selection\" [attr.aria-label]=\"opts.ariaLabelInputField\" (click)=\"opts.openSelectorOnInputClick&&!opts.editableDateField&&openBtnClicked()\" [ngClass]=\"{'invaliddate': invalidDate&&opts.indicateInvalidDate, 'inputnoteditable': opts.openSelectorOnInputClick&&!opts.editableDateField, 'selectiondisabled': opts.componentDisabled}\" placeholder=\"{{placeholder}}\" [ngStyle]=\"{'height': opts.height, 'font-size': opts.selectionTxtFontSize}\" [ngModel]=\"selectionDayTxt\" (ngModelChange)=\"onUserDateInput($event)\" [value]=\"selectionDayTxt\" (keyup)=\"onCloseSelector($event)\" (focus)=\"opts.editableDateField&&onFocusInput($event)\" (blur)=\"opts.editableDateField&&onBlurInput($event)\" [disabled]=\"opts.componentDisabled\" [readonly]=\"!opts.editableDateField\" autocomplete=\"off\" spellcheck=\"false\" autocorrect=\"off\"><div class=\"selbtngroup\" [style.height]=\"opts.height\"><button type=\"button\" [attr.aria-label]=\"opts.ariaLabelDecreaseDate\" class=\"btndecrease\" *ngIf=\"opts.showDecreaseDateBtn\" (click)=\"onDecreaseBtnClicked()\" [ngClass]=\"{'btndecreaseenabled': !opts.componentDisabled, 'btndecreasedisabled': opts.componentDisabled, 'btnleftborderradius': !opts.showInputField}\" [disabled]=\"opts.componentDisabled\"><span class=\"mydpicon icon-mydpleft\"></span></button> <button type=\"button\" [attr.aria-label]=\"opts.ariaLabelIncreaseDate\" class=\"btnincrease\" *ngIf=\"opts.showIncreaseDateBtn\" (click)=\"onIncreaseBtnClicked()\" [ngClass]=\"{'btnincreaseenabled': !opts.componentDisabled, 'btnincreasedisabled': opts.componentDisabled, 'btnleftborderradius': !opts.showDecreaseDateBtn&&!opts.showInputField}\" [disabled]=\"opts.componentDisabled\"><span class=\"mydpicon icon-mydpright\"></span></button> <button type=\"button\" [attr.aria-label]=\"opts.ariaLabelClearDate\" class=\"btnclear\" *ngIf=\"selectionDayTxt.length>0&&opts.showClearDateBtn\" (click)=\"removeBtnClicked()\" [ngClass]=\"{'btnclearenabled': !opts.componentDisabled, 'btncleardisabled': opts.componentDisabled, 'btnleftborderradius': !opts.showIncreaseDateBtn&&!opts.showDecreaseDateBtn&&!opts.showInputField}\" [disabled]=\"opts.componentDisabled\"><span class=\"mydpicon icon-mydpremove\"></span></button> <button type=\"button\" [attr.aria-label]=\"opts.ariaLabelOpenCalendar\" class=\"btnpicker\" (click)=\"openBtnClicked()\" [ngClass]=\"{'btnpickerenabled': !opts.componentDisabled, 'btnpickerdisabled': opts.componentDisabled, 'btnleftborderradius': !opts.showClearDateBtn&&!opts.showIncreaseDateBtn&&!opts.showDecreaseDateBtn&&!opts.showInputField||selectionDayTxt.length===0&&!opts.showInputField}\" [disabled]=\"opts.componentDisabled\"><span class=\"mydpicon icon-mydpcalendar\"></span></button></div></div><div class=\"selector\" #selectorEl [ngStyle]=\"{'width': opts.selectorWidth, 'height' : opts.selectorHeight, 'bottom': getSelectorTopPosition()}\" *ngIf=\"showSelector||opts.inline\" [mydpfocus]=\"opts.inline?'0':'1'\" [ngClass]=\"{'inlinedp': opts.inline, 'alignselectorright': opts.alignSelectorRight, 'selectorarrow': opts.showSelectorArrow&&!opts.inline, 'selectorarrowleft': opts.showSelectorArrow&&!opts.alignSelectorRight&&!opts.inline, 'selectorarrowright': opts.showSelectorArrow&&opts.alignSelectorRight&&!opts.inline}\" (keyup)=\"onCloseSelector($event)\" tabindex=\"0\"><table class=\"header\"><tr><td><div style=\"float:left\"><div class=\"headerbtncell\"><button type=\"button\" [attr.aria-label]=\"opts.ariaLabelPrevMonth\" class=\"headerbtn mydpicon icon-mydpleft\" (click)=\"onPrevMonth()\" [disabled]=\"prevMonthDisabled\" [ngClass]=\"{'headerbtnenabled': !prevMonthDisabled, 'headerbtndisabled': prevMonthDisabled}\"></button></div><div class=\"headermonthtxt\"><button class=\"headerlabelbtn\" type=\"button\" [ngClass]=\"{'monthlabel': opts.monthSelector}\" (click)=\"opts.monthSelector&&onSelectMonthClicked($event)\" tabindex=\"{{opts.monthSelector?'0':'-1'}}\">{{visibleMonth.monthTxt}}</button></div><div class=\"headerbtncell\"><button type=\"button\" [attr.aria-label]=\"opts.ariaLabelNextMonth\" class=\"headerbtn mydpicon icon-mydpright\" (click)=\"onNextMonth()\" [disabled]=\"nextMonthDisabled\" [ngClass]=\"{'headerbtnenabled': !nextMonthDisabled, 'headerbtndisabled': nextMonthDisabled}\"></button></div></div></td><td><button *ngIf=\"opts.showTodayBtn\" type=\"button\" class=\"headertodaybtn\" (click)=\"onTodayClicked()\" [disabled]=\"disableTodayBtn\" [ngClass]=\"{'headertodaybtnenabled': !disableTodayBtn, 'headertodaybtndisabled': disableTodayBtn}\"><span class=\"mydpicon icon-mydptoday\"></span> <span>{{opts.todayBtnTxt}}</span></button></td><td><div style=\"float:right\"><div class=\"headerbtncell\"><button type=\"button\" [attr.aria-label]=\"opts.ariaLabelPrevYear\" class=\"headerbtn mydpicon icon-mydpleft\" (click)=\"onPrevYear()\" [disabled]=\"prevYearDisabled\" [ngClass]=\"{'headerbtnenabled': !prevYearDisabled, 'headerbtndisabled': prevYearDisabled}\"></button></div><div class=\"headeryeartxt\"><button class=\"headerlabelbtn\" type=\"button\" [ngClass]=\"{'yearlabel': opts.yearSelector}\" (click)=\"opts.yearSelector&&onSelectYearClicked($event)\" tabindex=\"{{opts.yearSelector?'0':'-1'}}\">{{visibleMonth.year}}</button></div><div class=\"headerbtncell\"><button type=\"button\" [attr.aria-label]=\"opts.ariaLabelNextYear\" class=\"headerbtn mydpicon icon-mydpright\" (click)=\"onNextYear()\" [disabled]=\"nextYearDisabled\" [ngClass]=\"{'headerbtnenabled': !nextYearDisabled, 'headerbtndisabled': nextYearDisabled}\"></button></div></div></td></tr></table><table class=\"caltable\" *ngIf=\"!selectMonth&&!selectYear\"><thead><tr><th class=\"weekdaytitle weekdaytitleweeknbr\" *ngIf=\"opts.showWeekNumbers&&opts.firstDayOfWeek==='mo'\">#</th><th class=\"weekdaytitle\" scope=\"col\" *ngFor=\"let d of weekDays\">{{d}}</th></tr></thead><tbody><tr *ngFor=\"let w of dates\"><td class=\"daycell daycellweeknbr\" *ngIf=\"opts.showWeekNumbers&&opts.firstDayOfWeek==='mo'\">{{w.weekNbr}}</td><td class=\"daycell\" *ngFor=\"let d of w.week\" [ngClass]=\"{'currmonth':d.cmo===currMonthId&&!d.disabled, 'selectedday':selectedDate.day===d.dateObj.day && selectedDate.month===d.dateObj.month && selectedDate.year===d.dateObj.year && d.cmo===currMonthId, 'disabled': d.disabled, 'tablesingleday':(!opts.allowSelectionOnlyInCurrentMonth||d.cmo===currMonthId&&opts.allowSelectionOnlyInCurrentMonth)&&!d.disabled}\" (click)=\"!d.disabled&&onCellClicked(d);$event.stopPropagation()\" (keydown)=\"onCellKeyDown($event, d)\" tabindex=\"0\"><div *ngIf=\"d.markedDate.marked\" class=\"markdate\" [ngStyle]=\"{'background-color': d.markedDate.color}\"></div><div class=\"datevalue\" [ngClass]=\"{'prevmonth':d.cmo===prevMonthId,'currmonth':d.cmo===currMonthId,'nextmonth':d.cmo===nextMonthId,'highlight':d.highlight}\"><span [ngClass]=\"{'markcurrday':d.currDay&&opts.markCurrentDay, 'dimday': d.highlight && (d.cmo===prevMonthId || d.cmo===nextMonthId || d.disabled)}\">{{d.dateObj.day}}</span></div></td></tr></tbody></table><table class=\"monthtable\" *ngIf=\"selectMonth\"><tbody><tr *ngFor=\"let mr of months\"><td class=\"monthcell tablesinglemonth\" [ngClass]=\"{'selectedmonth': m.selected, 'disabled': m.disabled}\" *ngFor=\"let m of mr\" (click)=\"!m.disabled&&onMonthCellClicked(m);$event.stopPropagation()\" (keydown)=\"onMonthCellKeyDown($event, m)\" tabindex=\"0\"><div class=\"monthvalue\" [ngClass]=\"{'markcurrmonth':m.currMonth&&opts.markCurrentMonth}\">{{m.name}}</div></td></tr></tbody></table><table class=\"yeartable\" *ngIf=\"selectYear\"><tbody><tr><td colspan=\"5\" class=\"yearchangebtncell\" (click)=\"$event.stopPropagation()\"><button type=\"button\" class=\"yearchangebtn mydpicon icon-mydpup\" (click)=\"onPrevYears($event, years[0][0].year)\" [disabled]=\"prevYearsDisabled\" [ngClass]=\"{'yearchangebtnenabled': !prevYearsDisabled, 'yearchangebtndisabled': prevYearsDisabled}\"></button></td></tr><tr *ngFor=\"let yr of years\"><td class=\"yearcell tablesingleyear\" [ngClass]=\"{'selectedyear': y.selected, 'disabled': y.disabled}\" *ngFor=\"let y of yr\" (click)=\"!y.disabled&&onYearCellClicked(y);$event.stopPropagation()\" (keydown)=\"onYearCellKeyDown($event, y)\" tabindex=\"0\"><div class=\"yearvalue\" [ngClass]=\"{'markcurryear':y.currYear&&opts.markCurrentYear}\">{{y.year}}</div></td></tr><tr><td colspan=\"5\" class=\"yearchangebtncell\" (click)=\"$event.stopPropagation()\"><button type=\"button\" class=\"yearchangebtn mydpicon icon-mydpdown\" (click)=\"onNextYears($event, years[0][0].year)\" [disabled]=\"nextYearsDisabled\" [ngClass]=\"{'yearchangebtnenabled': !nextYearsDisabled, 'yearchangebtndisabled': nextYearsDisabled}\"></button></td></tr></tbody></table></div></div>",
                    providers: [__WEBPACK_IMPORTED_MODULE_2__services_my_date_picker_locale_service__["LocaleService"], __WEBPACK_IMPORTED_MODULE_3__services_my_date_picker_util_service__["UtilService"], MYDP_VALUE_ACCESSOR],
                    encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None
                },] },
    ];
    MyDatePicker.ctorParameters = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_2__services_my_date_picker_locale_service__["LocaleService"], },
        { type: __WEBPACK_IMPORTED_MODULE_3__services_my_date_picker_util_service__["UtilService"], },
    ];
    MyDatePicker.propDecorators = {
        'options': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'locale': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'defaultMonth': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'selDate': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'placeholder': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'selector': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'disabled': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'dateChanged': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        'inputFieldChanged': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        'calendarViewChanged': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        'calendarToggle': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        'inputFocusBlur': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        'selectorEl': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"], args: ["selectorEl",] },],
        'inputBoxEl': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"], args: ["inputBoxEl",] },],
    };
    return MyDatePicker;
}());
//# sourceMappingURL=my-date-picker.component.js.map

/***/ }),

/***/ "./node_modules/mydatepicker/dist/my-date-picker.module.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MyDatePickerModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_common__ = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__("./node_modules/@angular/forms/esm5/forms.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__my_date_picker_component__ = __webpack_require__("./node_modules/mydatepicker/dist/my-date-picker.component.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__directives_my_date_picker_focus_directive__ = __webpack_require__("./node_modules/mydatepicker/dist/directives/my-date-picker.focus.directive.js");





var MyDatePickerModule = (function () {
    function MyDatePickerModule() {
    }
    MyDatePickerModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["NgModule"], args: [{
                    imports: [__WEBPACK_IMPORTED_MODULE_0__angular_common__["CommonModule"], __WEBPACK_IMPORTED_MODULE_1__angular_forms__["FormsModule"]],
                    declarations: [__WEBPACK_IMPORTED_MODULE_3__my_date_picker_component__["b" /* MyDatePicker */], __WEBPACK_IMPORTED_MODULE_4__directives_my_date_picker_focus_directive__["a" /* FocusDirective */]],
                    exports: [__WEBPACK_IMPORTED_MODULE_3__my_date_picker_component__["b" /* MyDatePicker */], __WEBPACK_IMPORTED_MODULE_4__directives_my_date_picker_focus_directive__["a" /* FocusDirective */]]
                },] },
    ];
    MyDatePickerModule.ctorParameters = [];
    return MyDatePickerModule;
}());
//# sourceMappingURL=my-date-picker.module.js.map

/***/ }),

/***/ "./node_modules/mydatepicker/dist/services/my-date-picker.locale.service.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LocaleService", function() { return LocaleService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");

var LocaleService = (function () {
    function LocaleService() {
        this.locales = {
            "en": {
                dayLabels: { su: "Sun", mo: "Mon", tu: "Tue", we: "Wed", th: "Thu", fr: "Fri", sa: "Sat" },
                monthLabels: { 1: "Jan", 2: "Feb", 3: "Mar", 4: "Apr", 5: "May", 6: "Jun", 7: "Jul", 8: "Aug", 9: "Sep", 10: "Oct", 11: "Nov", 12: "Dec" },
                dateFormat: "mm/dd/yyyy",
                todayBtnTxt: "Today",
                firstDayOfWeek: "mo",
                sunHighlight: true,
            },
            "he": {
                dayLabels: { su: "רא", mo: "שנ", tu: "של", we: "רב", th: "חמ", fr: "שי", sa: "שב" },
                monthLabels: { 1: "ינו", 2: "פבר", 3: "מרץ", 4: "אפר", 5: "מאי", 6: "יונ", 7: "יול", 8: "אוג", 9: "ספט", 10: "אוק", 11: "נוב", 12: "דצמ" },
                dateFormat: "dd/mm/yyyy",
                todayBtnTxt: "היום",
                firstDayOfWeek: "su",
                sunHighlight: false
            },
            "ja": {
                dayLabels: { su: "日", mo: "月", tu: "火", we: "水", th: "木", fr: "金", sa: "土" },
                monthLabels: { 1: "１月", 2: "２月", 3: "３月", 4: "４月", 5: "５月", 6: "６月", 7: "７月", 8: "８月", 9: "９月", 10: "１０月", 11: "１１月", 12: "１２月" },
                dateFormat: "yyyy.mm.dd",
                todayBtnTxt: "今日",
                sunHighlight: false
            },
            "fr": {
                dayLabels: { su: "Dim", mo: "Lun", tu: "Mar", we: "Mer", th: "Jeu", fr: "Ven", sa: "Sam" },
                monthLabels: { 1: "Jan", 2: "Fév", 3: "Mar", 4: "Avr", 5: "Mai", 6: "Juin", 7: "Juil", 8: "Aoû", 9: "Sep", 10: "Oct", 11: "Nov", 12: "Déc" },
                dateFormat: "dd/mm/yyyy",
                todayBtnTxt: "Aujourd'hui",
                firstDayOfWeek: "mo",
                sunHighlight: true,
            },
            "fr-ch": {
                dayLabels: { su: "Dim", mo: "Lun", tu: "Mar", we: "Mer", th: "Jeu", fr: "Ven", sa: "Sam" },
                monthLabels: { 1: "Jan", 2: "Fév", 3: "Mar", 4: "Avr", 5: "Mai", 6: "Juin", 7: "Juil", 8: "Aoû", 9: "Sep", 10: "Oct", 11: "Nov", 12: "Déc" },
                dateFormat: "dd.mm.yyyy",
                todayBtnTxt: "Aujourd'hui",
                firstDayOfWeek: "mo",
                sunHighlight: true,
            },
            "fi": {
                dayLabels: { su: "Su", mo: "Ma", tu: "Ti", we: "Ke", th: "To", fr: "Pe", sa: "La" },
                monthLabels: { 1: "Tam", 2: "Hel", 3: "Maa", 4: "Huh", 5: "Tou", 6: "Kes", 7: "Hei", 8: "Elo", 9: "Syy", 10: "Lok", 11: "Mar", 12: "Jou" },
                dateFormat: "dd.mm.yyyy",
                todayBtnTxt: "Tänään",
                firstDayOfWeek: "mo",
                sunHighlight: true,
            },
            "es": {
                dayLabels: { su: "Do", mo: "Lu", tu: "Ma", we: "Mi", th: "Ju", fr: "Vi", sa: "Sa" },
                monthLabels: { 1: "Ene", 2: "Feb", 3: "Mar", 4: "Abr", 5: "May", 6: "Jun", 7: "Jul", 8: "Ago", 9: "Sep", 10: "Oct", 11: "Nov", 12: "Dic" },
                dateFormat: "dd.mm.yyyy",
                todayBtnTxt: "Hoy",
                firstDayOfWeek: "mo",
                sunHighlight: true,
            },
            "hu": {
                dayLabels: { su: "Vas", mo: "Hét", tu: "Kedd", we: "Sze", th: "Csü", fr: "Pén", sa: "Szo" },
                monthLabels: { 1: "Jan", 2: "Feb", 3: "Már", 4: "Ápr", 5: "Máj", 6: "Jún", 7: "Júl", 8: "Aug", 9: "Szep", 10: "Okt", 11: "Nov", 12: "Dec" },
                dateFormat: "yyyy-mm-dd",
                todayBtnTxt: "Ma",
                firstDayOfWeek: "mo",
                sunHighlight: true
            },
            "sv": {
                dayLabels: { su: "Sön", mo: "Mån", tu: "Tis", we: "Ons", th: "Tor", fr: "Fre", sa: "Lör" },
                monthLabels: { 1: "Jan", 2: "Feb", 3: "Mar", 4: "Apr", 5: "Maj", 6: "Jun", 7: "Jul", 8: "Aug", 9: "Sep", 10: "Okt", 11: "Nov", 12: "Dec" },
                dateFormat: "yyyy-mm-dd",
                todayBtnTxt: "Idag",
                firstDayOfWeek: "mo",
                sunHighlight: false
            },
            "nl": {
                dayLabels: { su: "Zon", mo: "Maa", tu: "Din", we: "Woe", th: "Don", fr: "Vri", sa: "Zat" },
                monthLabels: { 1: "Jan", 2: "Feb", 3: "Mar", 4: "Apr", 5: "Mei", 6: "Jun", 7: "Jul", 8: "Aug", 9: "Sep", 10: "Okt", 11: "Nov", 12: "Dec" },
                dateFormat: "dd-mm-yyyy",
                todayBtnTxt: "Vandaag",
                firstDayOfWeek: "mo",
                sunHighlight: false
            },
            "ru": {
                dayLabels: { su: "Вс", mo: "Пн", tu: "Вт", we: "Ср", th: "Чт", fr: "Пт", sa: "Сб" },
                monthLabels: { 1: "Янв", 2: "Фев", 3: "Март", 4: "Апр", 5: "Май", 6: "Июнь", 7: "Июль", 8: "Авг", 9: "Сент", 10: "Окт", 11: "Ноя", 12: "Дек" },
                dateFormat: "dd.mm.yyyy",
                todayBtnTxt: "Сегодня",
                firstDayOfWeek: "mo",
                sunHighlight: true
            },
            "uk": {
                dayLabels: { su: "Нд", mo: "Пн", tu: "Вт", we: "Ср", th: "Чт", fr: "Пт", sa: "Сб" },
                monthLabels: { 1: "Січ", 2: "Лют", 3: "Бер", 4: "Кві", 5: "Тра", 6: "Чер", 7: "Лип", 8: "Сер", 9: "Вер", 10: "Жов", 11: "Лис", 12: "Гру" },
                dateFormat: "dd.mm.yyyy",
                todayBtnTxt: "Сьогодні",
                firstDayOfWeek: "mo",
                sunHighlight: true
            },
            "no": {
                dayLabels: { su: "Søn", mo: "Man", tu: "Tir", we: "Ons", th: "Tor", fr: "Fre", sa: "Lør" },
                monthLabels: { 1: "Jan", 2: "Feb", 3: "Mar", 4: "Apr", 5: "Mai", 6: "Jun", 7: "Jul", 8: "Aug", 9: "Sep", 10: "Okt", 11: "Nov", 12: "Des" },
                dateFormat: "dd.mm.yyyy",
                todayBtnTxt: "I dag",
                firstDayOfWeek: "mo",
                sunHighlight: false
            },
            "tr": {
                dayLabels: { su: "Paz", mo: "Pzt", tu: "Sal", we: "Çar", th: "Per", fr: "Cum", sa: "Cmt" },
                monthLabels: { 1: "Oca", 2: "Şub", 3: "Mar", 4: "Nis", 5: "May", 6: "Haz", 7: "Tem", 8: "Ağu", 9: "Eyl", 10: "Eki", 11: "Kas", 12: "Ara" },
                dateFormat: "dd.mm.yyyy",
                todayBtnTxt: "Bugün",
                firstDayOfWeek: "mo",
                sunHighlight: false
            },
            "pt-br": {
                dayLabels: { su: "Dom", mo: "Seg", tu: "Ter", we: "Qua", th: "Qui", fr: "Sex", sa: "Sab" },
                monthLabels: { 1: "Jan", 2: "Fev", 3: "Mar", 4: "Abr", 5: "Mai", 6: "Jun", 7: "Jul", 8: "Ago", 9: "Set", 10: "Out", 11: "Nov", 12: "Dez" },
                dateFormat: "dd/mm/yyyy",
                todayBtnTxt: "Hoje",
                firstDayOfWeek: "su",
                sunHighlight: true
            },
            "de": {
                dayLabels: { su: "So", mo: "Mo", tu: "Di", we: "Mi", th: "Do", fr: "Fr", sa: "Sa" },
                monthLabels: { 1: "Jan", 2: "Feb", 3: "Mär", 4: "Apr", 5: "Mai", 6: "Jun", 7: "Jul", 8: "Aug", 9: "Sep", 10: "Okt", 11: "Nov", 12: "Dez" },
                dateFormat: "dd.mm.yyyy",
                todayBtnTxt: "Heute",
                firstDayOfWeek: "mo",
                sunHighlight: true
            },
            "de-ch": {
                dayLabels: { su: "So", mo: "Mo", tu: "Di", we: "Mi", th: "Do", fr: "Fr", sa: "Sa" },
                monthLabels: { 1: "Jan", 2: "Feb", 3: "Mär", 4: "Apr", 5: "Mai", 6: "Jun", 7: "Jul", 8: "Aug", 9: "Sep", 10: "Okt", 11: "Nov", 12: "Dez" },
                dateFormat: "dd.mm.yyyy",
                todayBtnTxt: "Heute",
                firstDayOfWeek: "mo",
                sunHighlight: true
            },
            "it": {
                dayLabels: { su: "Dom", mo: "Lun", tu: "Mar", we: "Mer", th: "Gio", fr: "Ven", sa: "Sab" },
                monthLabels: { 1: "Gen", 2: "Feb", 3: "Mar", 4: "Apr", 5: "Mag", 6: "Giu", 7: "Lug", 8: "Ago", 9: "Set", 10: "Ott", 11: "Nov", 12: "Dic" },
                dateFormat: "dd/mm/yyyy",
                todayBtnTxt: "Oggi",
                firstDayOfWeek: "mo",
                sunHighlight: true
            },
            "it-ch": {
                dayLabels: { su: "Dom", mo: "Lun", tu: "Mar", we: "Mer", th: "Gio", fr: "Ven", sa: "Sab" },
                monthLabels: { 1: "Gen", 2: "Feb", 3: "Mar", 4: "Apr", 5: "Mag", 6: "Giu", 7: "Lug", 8: "Ago", 9: "Set", 10: "Ott", 11: "Nov", 12: "Dic" },
                dateFormat: "dd.mm.yyyy",
                todayBtnTxt: "Oggi",
                firstDayOfWeek: "mo",
                sunHighlight: true
            },
            "pl": {
                dayLabels: { su: "Nie", mo: "Pon", tu: "Wto", we: "Śro", th: "Czw", fr: "Pią", sa: "Sob" },
                monthLabels: { 1: "Sty", 2: "Lut", 3: "Mar", 4: "Kwi", 5: "Maj", 6: "Cze", 7: "Lip", 8: "Sie", 9: "Wrz", 10: "Paź", 11: "Lis", 12: "Gru" },
                dateFormat: "yyyy-mm-dd",
                todayBtnTxt: "Dzisiaj",
                firstDayOfWeek: "mo",
                sunHighlight: true,
            },
            "my": {
                dayLabels: { su: "တနင်္ဂနွေ", mo: "တနင်္လာ", tu: "အင်္ဂါ", we: "ဗုဒ္ဓဟူး", th: "ကြသပတေး", fr: "သောကြာ", sa: "စနေ" },
                monthLabels: { 1: "ဇန်နဝါရီ", 2: "ဖေဖော်ဝါရီ", 3: "မတ်", 4: "ဧပြီ", 5: "မေ", 6: "ဇွန်", 7: "ဇူလိုင်", 8: "ဩဂုတ်", 9: "စက်တင်ဘာ", 10: "အောက်တိုဘာ", 11: "နိုဝင်ဘာ", 12: "ဒီဇင်ဘာ" },
                dateFormat: "yyyy-mm-dd",
                todayBtnTxt: "ယနေ့",
                firstDayOfWeek: "mo",
                sunHighlight: true,
            },
            "sk": {
                dayLabels: { su: "Ne", mo: "Po", tu: "Ut", we: "St", th: "Št", fr: "Pi", sa: "So" },
                monthLabels: { 1: "Jan", 2: "Feb", 3: "Mar", 4: "Apr", 5: "Máj", 6: "Jún", 7: "Júl", 8: "Aug", 9: "Sep", 10: "Okt", 11: "Nov", 12: "Dec" },
                dateFormat: "dd.mm.yyyy",
                todayBtnTxt: "Dnes",
                firstDayOfWeek: "mo",
                sunHighlight: true,
            },
            "sl": {
                dayLabels: { su: "Ned", mo: "Pon", tu: "Tor", we: "Sre", th: "Čet", fr: "Pet", sa: "Sob" },
                monthLabels: { 1: "Jan", 2: "Feb", 3: "Mar", 4: "Apr", 5: "Maj", 6: "Jun", 7: "Jul", 8: "Avg", 9: "Sep", 10: "Okt", 11: "Nov", 12: "Dec" },
                dateFormat: "dd. mm. yyyy",
                todayBtnTxt: "Danes",
                firstDayOfWeek: "mo",
                sunHighlight: true,
            },
            "zh-cn": {
                dayLabels: { su: "日", mo: "一", tu: "二", we: "三", th: "四", fr: "五", sa: "六" },
                monthLabels: { 1: "1月", 2: "2月", 3: "3月", 4: "4月", 5: "5月", 6: "6月", 7: "7月", 8: "8月", 9: "9月", 10: "10月", 11: "11月", 12: "12月" },
                dateFormat: "yyyy-mm-dd",
                todayBtnTxt: "今天",
                firstDayOfWeek: "mo",
                sunHighlight: true,
            },
            "ro": {
                dayLabels: { su: "du", mo: "lu", tu: "ma", we: "mi", th: "jo", fr: "vi", sa: "sa" },
                monthLabels: { 1: "ian", 2: "feb", 3: "mart", 4: "apr", 5: "mai", 6: "iun", 7: "iul", 8: "aug", 9: "sept", 10: "oct", 11: "nov", 12: "dec" },
                dateFormat: "dd.mm.yyyy",
                todayBtnTxt: "Astăzi",
                firstDayOfWeek: "mo",
                sunHighlight: true,
            },
            "ca": {
                dayLabels: { su: "dg", mo: "dl", tu: "dt", we: "dc", th: "dj", fr: "dv", sa: "ds" },
                monthLabels: { 1: "Gen", 2: "Febr", 3: "Març", 4: "Abr", 5: "Maig", 6: "Juny", 7: "Jul", 8: "Ag", 9: "Set", 10: "Oct", 11: "Nov", 12: "Des" },
                dateFormat: "dd.mm.yyyy",
                todayBtnTxt: "Avui",
                firstDayOfWeek: "mo",
                sunHighlight: true,
            },
            "id": {
                dayLabels: { su: "Min", mo: "Sen", tu: "Sel", we: "Rab", th: "Kam", fr: "Jum", sa: "Sab" },
                monthLabels: { 1: "Jan", 2: "Feb", 3: "Mar", 4: "Apr", 5: "Mei", 6: "Jun", 7: "Jul", 8: "Ags", 9: "Sep", 10: "Okt", 11: "Nov", 12: "Des" },
                dateFormat: "dd-mm-yyyy",
                todayBtnTxt: "Hari ini",
                firstDayOfWeek: "su",
                sunHighlight: true
            },
            "en-au": {
                dayLabels: { su: "Sun", mo: "Mon", tu: "Tue", we: "Wed", th: "Thu", fr: "Fri", sa: "Sat" },
                monthLabels: { 1: "Jan", 2: "Feb", 3: "Mar", 4: "Apr", 5: "May", 6: "Jun", 7: "Jul", 8: "Aug", 9: "Sep", 10: "Oct", 11: "Nov", 12: "Dec" },
                dateFormat: "dd/mm/yyyy",
                todayBtnTxt: "Today",
                firstDayOfWeek: "mo",
                sunHighlight: true
            },
            "am-et": {
                dayLabels: { su: "እሑድ", mo: "ሰኞ", tu: "ማክሰኞ", we: "ረቡዕ", th: "ሐሙስ", fr: "ዓርብ", sa: "ቅዳሜ" },
                monthLabels: { 1: "ጃንዩ", 2: "ፌብሩ", 3: "ማርች", 4: "ኤፕረ", 5: "ሜይ", 6: "ጁን", 7: "ጁላይ", 8: "ኦገስ", 9: "ሴፕቴ", 10: "ኦክተ", 11: "ኖቬም", 12: "ዲሴም" },
                dateFormat: "yyyy-mm-dd",
                todayBtnTxt: "ዛሬ",
                firstDayOfWeek: "mo",
                sunHighlight: true
            },
            "cs": {
                dayLabels: { su: "Ne", mo: "Po", tu: "Út", we: "St", th: "Čt", fr: "Pá", sa: "So" },
                monthLabels: { 1: "Led", 2: "Úno", 3: "Bře", 4: "Dub", 5: "Kvě", 6: "Čvn", 7: "Čvc", 8: "Srp", 9: "Zář", 10: "Říj", 11: "Lis", 12: "Pro" },
                dateFormat: "dd.mm.yyyy",
                todayBtnTxt: "Dnes",
                firstDayOfWeek: "mo",
                sunHighlight: true
            },
            "el": {
                dayLabels: { su: "Κυρ", mo: "Δευ", tu: "Τρι", we: "Τετ", th: "Πεμ", fr: "Παρ", sa: "Σαβ" },
                monthLabels: { 1: "Ιαν", 2: "Φεβ", 3: "Μαρ", 4: "Απρ", 5: "Μαι", 6: "Ιουν", 7: "Ιουλ", 8: "Αυγ", 9: "Σεπ", 10: "Οκτ", 11: "Νοε", 12: "Δεκ" },
                dateFormat: "dd/mm/yyyy",
                todayBtnTxt: "Σήμερα",
                firstDayOfWeek: "mo",
                sunHighlight: true
            },
            "kk": {
                dayLabels: { su: "Жк", mo: "Дс", tu: "Сс", we: "Ср", th: "Бс", fr: "Жм", sa: "Сб" },
                monthLabels: { 1: "Қаң", 2: "Ақп", 3: "Нау", 4: "Сәу", 5: "Мам", 6: "Мау", 7: "Шіл", 8: "Там", 9: "Қырк", 10: "Қаз", 11: "Қар", 12: "Желт" },
                dateFormat: "dd-mmm-yyyy",
                todayBtnTxt: "Бүгін",
                firstDayOfWeek: "mo",
                sunHighlight: true
            },
            "th": {
                dayLabels: { su: "อา", mo: "จ", tu: "อ", we: "พ", th: "พฤ", fr: "ศ", sa: "ส" },
                monthLabels: { 1: "ม.ค", 2: "ก.พ.", 3: "มี.ค.", 4: "เม.ย.", 5: "พ.ค.", 6: "มิ.ย.", 7: "ก.ค.", 8: "ส.ค.", 9: "ก.ย.", 10: "ต.ค.", 11: "พ.ย.", 12: "ธ.ค." },
                dateFormat: "dd-mm-yyyy",
                todayBtnTxt: "วันนี้",
                firstDayOfWeek: "su",
                sunHighlight: true
            },
            "ko-kr": {
                dayLabels: { su: "일", mo: "월", tu: "화", we: "수", th: "목", fr: "금", sa: "토" },
                monthLabels: { 1: "1월", 2: "2월", 3: "3월", 4: "4월", 5: "5월", 6: "6월", 7: "7월", 8: "8월", 9: "9월", 10: "10월", 11: "11월", 12: "12월" },
                dateFormat: "yyyy mm dd",
                todayBtnTxt: "오늘",
                firstDayOfWeek: "su",
                sunHighlight: true
            },
            "da": {
                dayLabels: { su: "Søn", mo: "Man", tu: "Tir", we: "Ons", th: "Tor", fr: "Fre", sa: "Lør" },
                monthLabels: { 1: "Jan", 2: "Feb", 3: "Mar", 4: "Apr", 5: "Maj", 6: "Jun", 7: "Jul", 8: "Aug", 9: "Sep", 10: "Okt", 11: "Nov", 12: "Dec" },
                dateFormat: "dd-mm-yyyy",
                todayBtnTxt: "I dag",
                firstDayOfWeek: "mo",
                sunHighlight: true
            },
            "lt": {
                dayLabels: { su: "Sk", mo: "Pr", tu: "An", we: "Tr", th: "Kt", fr: "Pn", sa: "Št" },
                monthLabels: { 1: "Saus.", 2: "Vas.", 3: "Kov.", 4: "Bal.", 5: "Geg.", 6: "Birž.", 7: "Liep.", 8: "Rugp.", 9: "Rugs.", 10: "Sapl.", 11: "Lapkr.", 12: "Gruod." },
                dateFormat: "yyyy-mm-dd",
                todayBtnTxt: "Šianien",
                firstDayOfWeek: "mo",
                sunHighlight: true
            },
            "vi": {
                dayLabels: { su: "CN", mo: "T2", tu: "T3", we: "T4", th: "T5", fr: "T6", sa: "T7" },
                monthLabels: { 1: "THG 1", 2: "THG 2", 3: "THG 3", 4: "THG 4", 5: "THG 5", 6: "THG 6", 7: "THG 7", 8: "THG 8", 9: "THG 9", 10: "THG 10", 11: "THG 11", 12: "THG 12" },
                dateFormat: "dd/mm/yyyy",
                todayBtnTxt: "Hôm nay",
                firstDayOfWeek: "mo",
                sunHighlight: true,
            },
            "bn": {
                dayLabels: { su: "রবি", mo: "সোম", tu: "মঙ্গল", we: "বুধ", th: "বৃহঃ", fr: "শুক্র", sa: "শনি" },
                monthLabels: { 1: "জানু", 2: "ফেব্রু", 3: "মার্চ", 4: "এপ্রিল", 5: "মে", 6: "জুন", 7: "জুলাই", 8: "আগস্ট", 9: "সেপ্টে", 10: "অক্টো", 11: "নভে", 12: "ডিসে" },
                dateFormat: "dd-mm-yyyy",
                todayBtnTxt: "আজ",
                firstDayOfWeek: "su",
                sunHighlight: true
            },
            "bg": {
                dayLabels: { su: "нд", mo: "пн", tu: "вт", we: "ср", th: "чт", fr: "пт", sa: "сб" },
                monthLabels: { 1: "яну.", 2: "фев.", 3: "март", 4: "апр.", 5: "май", 6: "юни", 7: "юли", 8: "авг.", 9: "сеп.", 10: "окт.", 11: "ное.", 12: "дек." },
                dateFormat: "dd.mm.yyyy",
                todayBtnTxt: "днес",
                firstDayOfWeek: "mo",
                sunHighlight: true
            },
            "hr": {
                dayLabels: { su: "Ne", mo: "Po", tu: "Ul", we: "Sr", th: "Če", fr: "Pe", sa: "Su" },
                monthLabels: { 1: "Sij", 2: "Vel", 3: "Ožu", 4: "Tra", 5: "Svi", 6: "Lip", 7: "Srp", 8: "Kol", 9: "Ruj", 10: "Lis", 11: "Stu", 12: "Pro" },
                dateFormat: "dd.mm.yyyy.",
                todayBtnTxt: "danas",
                firstDayOfWeek: "su",
                sunHighlight: true
            },
            "ar": {
                dayLabels: { su: "الأحد", mo: "الاثنين", tu: "الثلاثاء", we: "الاربعاء", th: "الخميس", fr: "الجمعة", sa: "السبت" },
                monthLabels: { 1: "يناير", 2: "فبراير", 3: "مارس", 4: "ابريل", 5: "مايو", 6: "يونيو", 7: "يوليو", 8: "أغسطس", 9: "سبتمبر", 10: "أكتوبر", 11: "نوفمبر", 12: "ديسمبر" },
                dateFormat: "yyyy-mm-dd",
                todayBtnTxt: "اليوم",
                firstDayOfWeek: "sa",
                sunHighlight: true
            },
            "is": {
                dayLabels: { su: "sun", mo: "mán", tu: "þri", we: "mið", th: "fim", fr: "fös", sa: "lau" },
                monthLabels: { 1: "jan", 2: "feb", 3: "mar", 4: "apr", 5: "maí", 6: "jún", 7: "júl", 8: "ágú", 9: "sep", 10: "okt", 11: "nóv", 12: "des" },
                dateFormat: "dd.mm.yyyy",
                todayBtnTxt: "Í dag",
                firstDayOfWeek: "su",
                sunHighlight: true
            }
        };
    }
    LocaleService.prototype.getLocaleOptions = function (locale) {
        if (locale && this.locales.hasOwnProperty(locale)) {
            return this.locales[locale];
        }
        return this.locales["en"];
    };
    LocaleService.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    LocaleService.ctorParameters = [];
    return LocaleService;
}());
//# sourceMappingURL=my-date-picker.locale.service.js.map

/***/ }),

/***/ "./node_modules/mydatepicker/dist/services/my-date-picker.util.service.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UtilService", function() { return UtilService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");

var M = "m";
var MM = "mm";
var MMM = "mmm";
var D = "d";
var DD = "dd";
var YYYY = "yyyy";
var UtilService = (function () {
    function UtilService() {
        this.weekDays = ["su", "mo", "tu", "we", "th", "fr", "sa"];
    }
    UtilService.prototype.isDateValid = function (dateStr, dateFormat, minYear, maxYear, disableUntil, disableSince, disableWeekends, disableWeekDays, disableDays, disableDateRanges, monthLabels, enableDays) {
        var returnDate = { day: 0, month: 0, year: 0 };
        var daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        var isMonthStr = dateFormat.indexOf(MMM) !== -1;
        var delimeters = this.getDateFormatDelimeters(dateFormat);
        var dateValue = this.getDateValue(dateStr, dateFormat, delimeters);
        var year = this.getNumberByValue(dateValue[0]);
        var month = isMonthStr ? this.getMonthNumberByMonthName(dateValue[1], monthLabels) : this.getNumberByValue(dateValue[1]);
        var day = this.getNumberByValue(dateValue[2]);
        if (month !== -1 && day !== -1 && year !== -1) {
            if (year < minYear || year > maxYear || month < 1 || month > 12) {
                return returnDate;
            }
            var date = { year: year, month: month, day: day };
            if (this.isDisabledDay(date, minYear, maxYear, disableUntil, disableSince, disableWeekends, disableWeekDays, disableDays, disableDateRanges, enableDays)) {
                return returnDate;
            }
            if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) {
                daysInMonth[1] = 29;
            }
            if (day < 1 || day > daysInMonth[month - 1]) {
                return returnDate;
            }
            return date;
        }
        return returnDate;
    };
    UtilService.prototype.getDateValue = function (dateStr, dateFormat, delimeters) {
        var del = delimeters[0];
        if (delimeters[0] !== delimeters[1]) {
            del = delimeters[0] + delimeters[1];
        }
        var re = new RegExp("[" + del + "]");
        var ds = dateStr.split(re);
        var df = dateFormat.split(re);
        var da = [];
        for (var i = 0; i < df.length; i++) {
            if (df[i].indexOf(YYYY) !== -1) {
                da[0] = { value: ds[i], format: df[i] };
            }
            if (df[i].indexOf(M) !== -1) {
                da[1] = { value: ds[i], format: df[i] };
            }
            if (df[i].indexOf(D) !== -1) {
                da[2] = { value: ds[i], format: df[i] };
            }
        }
        return da;
    };
    UtilService.prototype.getMonthNumberByMonthName = function (df, monthLabels) {
        if (df.value) {
            for (var key = 1; key <= 12; key++) {
                if (df.value.toLowerCase() === monthLabels[key].toLowerCase()) {
                    return key;
                }
            }
        }
        return -1;
    };
    UtilService.prototype.getNumberByValue = function (df) {
        if (!/^\d+$/.test(df.value)) {
            return -1;
        }
        var nbr = Number(df.value);
        if (df.format.length === 1 && df.value.length !== 1 && nbr < 10 || df.format.length === 1 && df.value.length !== 2 && nbr >= 10) {
            nbr = -1;
        }
        else if (df.format.length === 2 && df.value.length > 2) {
            nbr = -1;
        }
        return nbr;
    };
    UtilService.prototype.getDateFormatDelimeters = function (dateFormat) {
        return dateFormat.match(/[^(dmy)]{1,}/g);
    };
    UtilService.prototype.parseDefaultMonth = function (monthString) {
        var month = { monthTxt: "", monthNbr: 0, year: 0 };
        if (monthString !== "") {
            var split = monthString.split(monthString.match(/[^0-9]/)[0]);
            month.monthNbr = split[0].length === 2 ? parseInt(split[0]) : parseInt(split[1]);
            month.year = split[0].length === 2 ? parseInt(split[1]) : parseInt(split[0]);
        }
        return month;
    };
    UtilService.prototype.formatDate = function (date, dateFormat, monthLabels) {
        var formatted = dateFormat.replace(YYYY, String(date.year));
        if (dateFormat.indexOf(MMM) !== -1) {
            formatted = formatted.replace(MMM, monthLabels[date.month]);
        }
        else if (dateFormat.indexOf(MM) !== -1) {
            formatted = formatted.replace(MM, this.preZero(date.month));
        }
        else {
            formatted = formatted.replace(M, String(date.month));
        }
        if (dateFormat.indexOf(DD) !== -1) {
            formatted = formatted.replace(DD, this.preZero(date.day));
        }
        else {
            formatted = formatted.replace(D, String(date.day));
        }
        return formatted;
    };
    UtilService.prototype.preZero = function (val) {
        return val < 10 ? "0" + val : String(val);
    };
    UtilService.prototype.isDisabledDay = function (date, minYear, maxYear, disableUntil, disableSince, disableWeekends, disableWeekDays, disableDays, disableDateRanges, enableDays) {
        for (var _i = 0, enableDays_1 = enableDays; _i < enableDays_1.length; _i++) {
            var e = enableDays_1[_i];
            if (e.year === date.year && e.month === date.month && e.day === date.day) {
                return false;
            }
        }
        var dn = this.getDayNumber(date);
        if (date.year < minYear && date.month === 12 || date.year > maxYear && date.month === 1) {
            return true;
        }
        var dateMs = this.getTimeInMilliseconds(date);
        if (this.isInitializedDate(disableUntil) && dateMs <= this.getTimeInMilliseconds(disableUntil)) {
            return true;
        }
        if (this.isInitializedDate(disableSince) && dateMs >= this.getTimeInMilliseconds(disableSince)) {
            return true;
        }
        if (disableWeekends) {
            if (dn === 0 || dn === 6) {
                return true;
            }
        }
        if (disableWeekDays.length > 0) {
            for (var _a = 0, disableWeekDays_1 = disableWeekDays; _a < disableWeekDays_1.length; _a++) {
                var wd = disableWeekDays_1[_a];
                if (dn === this.getWeekdayIndex(wd)) {
                    return true;
                }
            }
        }
        for (var _b = 0, disableDays_1 = disableDays; _b < disableDays_1.length; _b++) {
            var d = disableDays_1[_b];
            if (d.year === date.year && d.month === date.month && d.day === date.day) {
                return true;
            }
        }
        for (var _c = 0, disableDateRanges_1 = disableDateRanges; _c < disableDateRanges_1.length; _c++) {
            var d = disableDateRanges_1[_c];
            if (this.isInitializedDate(d.begin) && this.isInitializedDate(d.end) && dateMs >= this.getTimeInMilliseconds(d.begin) && dateMs <= this.getTimeInMilliseconds(d.end)) {
                return true;
            }
        }
        return false;
    };
    UtilService.prototype.isMarkedDate = function (date, markedDates, markWeekends) {
        for (var _i = 0, markedDates_1 = markedDates; _i < markedDates_1.length; _i++) {
            var md = markedDates_1[_i];
            for (var _a = 0, _b = md.dates; _a < _b.length; _a++) {
                var d = _b[_a];
                if (d.year === date.year && d.month === date.month && d.day === date.day) {
                    return { marked: true, color: md.color };
                }
            }
        }
        if (markWeekends && markWeekends.marked) {
            var dayNbr = this.getDayNumber(date);
            if (dayNbr === 0 || dayNbr === 6) {
                return { marked: true, color: markWeekends.color };
            }
        }
        return { marked: false, color: "" };
    };
    UtilService.prototype.isHighlightedDate = function (date, sunHighlight, satHighlight, highlightDates) {
        var dayNbr = this.getDayNumber(date);
        if (sunHighlight && dayNbr === 0 || satHighlight && dayNbr === 6) {
            return true;
        }
        for (var _i = 0, highlightDates_1 = highlightDates; _i < highlightDates_1.length; _i++) {
            var d = highlightDates_1[_i];
            if (d.year === date.year && d.month === date.month && d.day === date.day) {
                return true;
            }
        }
        return false;
    };
    UtilService.prototype.getWeekNumber = function (date) {
        var d = new Date(date.year, date.month - 1, date.day, 0, 0, 0, 0);
        d.setDate(d.getDate() + (d.getDay() === 0 ? -3 : 4 - d.getDay()));
        return Math.round(((d.getTime() - new Date(d.getFullYear(), 0, 4).getTime()) / 86400000) / 7) + 1;
    };
    UtilService.prototype.isMonthDisabledByDisableUntil = function (date, disableUntil) {
        return this.isInitializedDate(disableUntil) && this.getTimeInMilliseconds(date) <= this.getTimeInMilliseconds(disableUntil);
    };
    UtilService.prototype.isMonthDisabledByDisableSince = function (date, disableSince) {
        return this.isInitializedDate(disableSince) && this.getTimeInMilliseconds(date) >= this.getTimeInMilliseconds(disableSince);
    };
    UtilService.prototype.isInitializedDate = function (date) {
        return date.year !== 0 && date.month !== 0 && date.day !== 0;
    };
    UtilService.prototype.isSameDate = function (d1, d2) {
        return d1.year === d2.year && d1.month === d2.month && d1.day === d2.day;
    };
    UtilService.prototype.getTimeInMilliseconds = function (date) {
        return new Date(date.year, date.month - 1, date.day, 0, 0, 0, 0).getTime();
    };
    UtilService.prototype.getDayNumber = function (date) {
        return new Date(date.year, date.month - 1, date.day, 0, 0, 0, 0).getDay();
    };
    UtilService.prototype.getWeekDays = function () {
        return this.weekDays;
    };
    UtilService.prototype.getWeekdayIndex = function (wd) {
        return this.weekDays.indexOf(wd);
    };
    UtilService.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    UtilService.ctorParameters = [];
    return UtilService;
}());
//# sourceMappingURL=my-date-picker.util.service.js.map

/***/ }),

/***/ "./node_modules/mydatepicker/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dist_my_date_picker_module__ = __webpack_require__("./node_modules/mydatepicker/dist/my-date-picker.module.js");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "MyDatePickerModule", function() { return __WEBPACK_IMPORTED_MODULE_0__dist_my_date_picker_module__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dist_my_date_picker_component__ = __webpack_require__("./node_modules/mydatepicker/dist/my-date-picker.component.js");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "MYDP_VALUE_ACCESSOR", function() { return __WEBPACK_IMPORTED_MODULE_1__dist_my_date_picker_component__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "MyDatePicker", function() { return __WEBPACK_IMPORTED_MODULE_1__dist_my_date_picker_component__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dist_interfaces_my_date_interface__ = __webpack_require__("./node_modules/mydatepicker/dist/interfaces/my-date.interface.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dist_interfaces_my_date_interface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__dist_interfaces_my_date_interface__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_2__dist_interfaces_my_date_interface__) if(["MyDatePickerModule","MYDP_VALUE_ACCESSOR","MyDatePicker","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_2__dist_interfaces_my_date_interface__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dist_interfaces_my_date_model_interface__ = __webpack_require__("./node_modules/mydatepicker/dist/interfaces/my-date-model.interface.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dist_interfaces_my_date_model_interface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__dist_interfaces_my_date_model_interface__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_3__dist_interfaces_my_date_model_interface__) if(["MyDatePickerModule","MYDP_VALUE_ACCESSOR","MyDatePicker","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_3__dist_interfaces_my_date_model_interface__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dist_interfaces_my_input_field_changed_interface__ = __webpack_require__("./node_modules/mydatepicker/dist/interfaces/my-input-field-changed.interface.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dist_interfaces_my_input_field_changed_interface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__dist_interfaces_my_input_field_changed_interface__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_4__dist_interfaces_my_input_field_changed_interface__) if(["MyDatePickerModule","MYDP_VALUE_ACCESSOR","MyDatePicker","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_4__dist_interfaces_my_input_field_changed_interface__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dist_interfaces_my_calendar_view_changed_interface__ = __webpack_require__("./node_modules/mydatepicker/dist/interfaces/my-calendar-view-changed.interface.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dist_interfaces_my_calendar_view_changed_interface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__dist_interfaces_my_calendar_view_changed_interface__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_5__dist_interfaces_my_calendar_view_changed_interface__) if(["MyDatePickerModule","MYDP_VALUE_ACCESSOR","MyDatePicker","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_5__dist_interfaces_my_calendar_view_changed_interface__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dist_interfaces_my_input_focus_blur_interface__ = __webpack_require__("./node_modules/mydatepicker/dist/interfaces/my-input-focus-blur.interface.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dist_interfaces_my_input_focus_blur_interface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__dist_interfaces_my_input_focus_blur_interface__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_6__dist_interfaces_my_input_focus_blur_interface__) if(["MyDatePickerModule","MYDP_VALUE_ACCESSOR","MyDatePicker","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_6__dist_interfaces_my_input_focus_blur_interface__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dist_interfaces_my_date_range_interface__ = __webpack_require__("./node_modules/mydatepicker/dist/interfaces/my-date-range.interface.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dist_interfaces_my_date_range_interface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__dist_interfaces_my_date_range_interface__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_7__dist_interfaces_my_date_range_interface__) if(["MyDatePickerModule","MYDP_VALUE_ACCESSOR","MyDatePicker","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_7__dist_interfaces_my_date_range_interface__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__dist_interfaces_my_day_labels_interface__ = __webpack_require__("./node_modules/mydatepicker/dist/interfaces/my-day-labels.interface.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__dist_interfaces_my_day_labels_interface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__dist_interfaces_my_day_labels_interface__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_8__dist_interfaces_my_day_labels_interface__) if(["MyDatePickerModule","MYDP_VALUE_ACCESSOR","MyDatePicker","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_8__dist_interfaces_my_day_labels_interface__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__dist_interfaces_my_month_labels_interface__ = __webpack_require__("./node_modules/mydatepicker/dist/interfaces/my-month-labels.interface.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__dist_interfaces_my_month_labels_interface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__dist_interfaces_my_month_labels_interface__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_9__dist_interfaces_my_month_labels_interface__) if(["MyDatePickerModule","MYDP_VALUE_ACCESSOR","MyDatePicker","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_9__dist_interfaces_my_month_labels_interface__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dist_interfaces_my_options_interface__ = __webpack_require__("./node_modules/mydatepicker/dist/interfaces/my-options.interface.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dist_interfaces_my_options_interface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__dist_interfaces_my_options_interface__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_10__dist_interfaces_my_options_interface__) if(["MyDatePickerModule","MYDP_VALUE_ACCESSOR","MyDatePicker","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_10__dist_interfaces_my_options_interface__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dist_interfaces_my_weekday_interface__ = __webpack_require__("./node_modules/mydatepicker/dist/interfaces/my-weekday.interface.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dist_interfaces_my_weekday_interface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__dist_interfaces_my_weekday_interface__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_11__dist_interfaces_my_weekday_interface__) if(["MyDatePickerModule","MYDP_VALUE_ACCESSOR","MyDatePicker","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_11__dist_interfaces_my_weekday_interface__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__dist_interfaces_my_marked_date_interface__ = __webpack_require__("./node_modules/mydatepicker/dist/interfaces/my-marked-date.interface.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__dist_interfaces_my_marked_date_interface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__dist_interfaces_my_marked_date_interface__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_12__dist_interfaces_my_marked_date_interface__) if(["MyDatePickerModule","MYDP_VALUE_ACCESSOR","MyDatePicker","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_12__dist_interfaces_my_marked_date_interface__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__dist_interfaces_my_marked_dates_interface__ = __webpack_require__("./node_modules/mydatepicker/dist/interfaces/my-marked-dates.interface.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__dist_interfaces_my_marked_dates_interface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__dist_interfaces_my_marked_dates_interface__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_13__dist_interfaces_my_marked_dates_interface__) if(["MyDatePickerModule","MYDP_VALUE_ACCESSOR","MyDatePicker","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_13__dist_interfaces_my_marked_dates_interface__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__dist_interfaces_my_default_month_interface__ = __webpack_require__("./node_modules/mydatepicker/dist/interfaces/my-default-month.interface.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__dist_interfaces_my_default_month_interface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__dist_interfaces_my_default_month_interface__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_14__dist_interfaces_my_default_month_interface__) if(["MyDatePickerModule","MYDP_VALUE_ACCESSOR","MyDatePicker","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_14__dist_interfaces_my_default_month_interface__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__dist_interfaces_my_selector_interface__ = __webpack_require__("./node_modules/mydatepicker/dist/interfaces/my-selector.interface.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__dist_interfaces_my_selector_interface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__dist_interfaces_my_selector_interface__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_15__dist_interfaces_my_selector_interface__) if(["MyDatePickerModule","MYDP_VALUE_ACCESSOR","MyDatePicker","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_15__dist_interfaces_my_selector_interface__[key]; }) }(__WEBPACK_IMPORT_KEY__));

















/***/ }),

/***/ "./node_modules/ng2-dragula/components/dragula.class.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dragulaExpt = __webpack_require__("./node_modules/dragula/dragula.js");
exports.dragula = dragulaExpt.default || dragulaExpt;


/***/ }),

/***/ "./node_modules/ng2-dragula/components/dragula.directive.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var dragula_provider_1 = __webpack_require__("./node_modules/ng2-dragula/components/dragula.provider.js");
var dragula_class_1 = __webpack_require__("./node_modules/ng2-dragula/components/dragula.class.js");
var DragulaDirective = (function () {
    function DragulaDirective(el, dragulaService) {
        this.el = el;
        this.dragulaService = dragulaService;
        this.container = el.nativeElement;
    }
    DragulaDirective.prototype.ngOnInit = function () {
        var _this = this;
        // console.log(this.bag);
        var bag = this.dragulaService.find(this.dragula);
        var checkModel = function () {
            if (_this.dragulaModel) {
                if (_this.drake.models) {
                    _this.drake.models.push(_this.dragulaModel);
                }
                else {
                    _this.drake.models = [_this.dragulaModel];
                }
            }
        };
        if (bag) {
            this.drake = bag.drake;
            checkModel();
            this.drake.containers.push(this.container);
        }
        else {
            this.drake = dragula_class_1.dragula([this.container], Object.assign({}, this.dragulaOptions));
            checkModel();
            this.dragulaService.add(this.dragula, this.drake);
        }
    };
    DragulaDirective.prototype.ngOnChanges = function (changes) {
        // console.log('dragula.directive: ngOnChanges');
        // console.log(changes);
        if (changes && changes.dragulaModel) {
            if (this.drake) {
                if (this.drake.models) {
                    var modelIndex = this.drake.models.indexOf(changes.dragulaModel.previousValue);
                    this.drake.models.splice(modelIndex, 1, changes.dragulaModel.currentValue);
                }
                else {
                    this.drake.models = [changes.dragulaModel.currentValue];
                }
            }
        }
    };
    return DragulaDirective;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], DragulaDirective.prototype, "dragula", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], DragulaDirective.prototype, "dragulaModel", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], DragulaDirective.prototype, "dragulaOptions", void 0);
DragulaDirective = __decorate([
    core_1.Directive({ selector: '[dragula]' }),
    __metadata("design:paramtypes", [core_1.ElementRef, dragula_provider_1.DragulaService])
], DragulaDirective);
exports.DragulaDirective = DragulaDirective;


/***/ }),

/***/ "./node_modules/ng2-dragula/components/dragula.provider.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var dragula_class_1 = __webpack_require__("./node_modules/ng2-dragula/components/dragula.class.js");
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var DragulaService = (function () {
    function DragulaService() {
        this.cancel = new core_1.EventEmitter();
        this.cloned = new core_1.EventEmitter();
        this.drag = new core_1.EventEmitter();
        this.dragend = new core_1.EventEmitter();
        this.drop = new core_1.EventEmitter();
        this.out = new core_1.EventEmitter();
        this.over = new core_1.EventEmitter();
        this.remove = new core_1.EventEmitter();
        this.shadow = new core_1.EventEmitter();
        this.dropModel = new core_1.EventEmitter();
        this.removeModel = new core_1.EventEmitter();
        this.events = [
            'cancel', 'cloned', 'drag', 'dragend', 'drop', 'out', 'over',
            'remove', 'shadow', 'dropModel', 'removeModel'
        ];
        this.bags = [];
    }
    DragulaService.prototype.add = function (name, drake) {
        var bag = this.find(name);
        if (bag) {
            throw new Error('Bag named: "' + name + '" already exists.');
        }
        bag = { name: name, drake: drake };
        this.bags.push(bag);
        if (drake.models) {
            this.handleModels(name, drake);
        }
        if (!bag.initEvents) {
            this.setupEvents(bag);
        }
        return bag;
    };
    DragulaService.prototype.find = function (name) {
        for (var _i = 0, _a = this.bags; _i < _a.length; _i++) {
            var bag = _a[_i];
            if (bag.name === name) {
                return bag;
            }
        }
    };
    DragulaService.prototype.destroy = function (name) {
        var bag = this.find(name);
        var i = this.bags.indexOf(bag);
        this.bags.splice(i, 1);
        bag.drake.destroy();
    };
    DragulaService.prototype.setOptions = function (name, options) {
        var bag = this.add(name, dragula_class_1.dragula(options));
        this.handleModels(name, bag.drake);
    };
    DragulaService.prototype.handleModels = function (name, drake) {
        var _this = this;
        var dragElm;
        var dragIndex;
        var dropIndex;
        var sourceModel;
        drake.on('remove', function (el, source) {
            if (!drake.models) {
                return;
            }
            sourceModel = drake.models[drake.containers.indexOf(source)];
            sourceModel.splice(dragIndex, 1);
            // console.log('REMOVE');
            // console.log(sourceModel);
            _this.removeModel.emit([name, el, source]);
        });
        drake.on('drag', function (el, source) {
            dragElm = el;
            dragIndex = _this.domIndexOf(el, source);
        });
        drake.on('drop', function (dropElm, target, source) {
            if (!drake.models || !target) {
                return;
            }
            dropIndex = _this.domIndexOf(dropElm, target);
            sourceModel = drake.models[drake.containers.indexOf(source)];
            // console.log('DROP');
            // console.log(sourceModel);
            if (target === source) {
                sourceModel.splice(dropIndex, 0, sourceModel.splice(dragIndex, 1)[0]);
            }
            else {
                var notCopy = dragElm === dropElm;
                var targetModel = drake.models[drake.containers.indexOf(target)];
                var dropElmModel = notCopy ? sourceModel[dragIndex] : JSON.parse(JSON.stringify(sourceModel[dragIndex]));
                if (notCopy) {
                    sourceModel.splice(dragIndex, 1);
                }
                targetModel.splice(dropIndex, 0, dropElmModel);
                target.removeChild(dropElm); // element must be removed for ngFor to apply correctly
            }
            _this.dropModel.emit([name, dropElm, target, source]);
        });
    };
    DragulaService.prototype.setupEvents = function (bag) {
        bag.initEvents = true;
        var that = this;
        var emitter = function (type) {
            function replicate() {
                var args = Array.prototype.slice.call(arguments);
                that[type].emit([bag.name].concat(args));
            }
            bag.drake.on(type, replicate);
        };
        this.events.forEach(emitter);
    };
    DragulaService.prototype.domIndexOf = function (child, parent) {
        return Array.prototype.indexOf.call(parent.children, child);
    };
    return DragulaService;
}());
DragulaService = __decorate([
    core_1.Injectable()
], DragulaService);
exports.DragulaService = DragulaService;


/***/ }),

/***/ "./node_modules/ng2-dragula/components/dragular.module.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var dragula_directive_1 = __webpack_require__("./node_modules/ng2-dragula/components/dragula.directive.js");
var dragula_provider_1 = __webpack_require__("./node_modules/ng2-dragula/components/dragula.provider.js");
var DragulaModule = (function () {
    function DragulaModule() {
    }
    return DragulaModule;
}());
DragulaModule = __decorate([
    core_1.NgModule({
        exports: [dragula_directive_1.DragulaDirective],
        declarations: [dragula_directive_1.DragulaDirective],
        providers: [dragula_provider_1.DragulaService]
    })
], DragulaModule);
exports.DragulaModule = DragulaModule;


/***/ }),

/***/ "./node_modules/ng2-dragula/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dragula_class_1 = __webpack_require__("./node_modules/ng2-dragula/components/dragula.class.js");
exports.dragula = dragula_class_1.dragula;
var dragula_directive_1 = __webpack_require__("./node_modules/ng2-dragula/components/dragula.directive.js");
exports.DragulaDirective = dragula_directive_1.DragulaDirective;
var dragula_provider_1 = __webpack_require__("./node_modules/ng2-dragula/components/dragula.provider.js");
exports.DragulaService = dragula_provider_1.DragulaService;
var dragular_module_1 = __webpack_require__("./node_modules/ng2-dragula/components/dragular.module.js");
exports.DragulaModule = dragular_module_1.DragulaModule;


/***/ }),

/***/ "./node_modules/ngx-bootstrap/carousel/fesm5/ngx-bootstrap-carousel.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CarouselComponent", function() { return CarouselComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CarouselModule", function() { return CarouselModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SlideComponent", function() { return SlideComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CarouselConfig", function() { return CarouselConfig; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ngx_bootstrap_utils__ = __webpack_require__("./node_modules/ngx-bootstrap/utils/fesm5/ngx-bootstrap-utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_common__ = __webpack_require__("./node_modules/@angular/common/esm5/common.js");




/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var CarouselConfig = /** @class */ (function () {
    function CarouselConfig() {
        /**
         * Default interval of auto changing of slides
         */
        this.interval = 5000;
        /**
         * Is loop of auto changing of slides can be paused
         */
        this.noPause = false;
        /**
         * Is slides can wrap from the last to the first slide
         */
        this.noWrap = false;
        /**
         * Show carousel-indicators
         */
        this.showIndicators = true;
    }
    CarouselConfig.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] }
    ];
    return CarouselConfig;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {number} */
var Direction = {
    UNKNOWN: 0,
    NEXT: 1,
    PREV: 2,
};
Direction[Direction.UNKNOWN] = "UNKNOWN";
Direction[Direction.NEXT] = "NEXT";
Direction[Direction.PREV] = "PREV";
/**
 * Base element to create carousel
 */
var CarouselComponent = /** @class */ (function () {
    function CarouselComponent(config, ngZone) {
        this.ngZone = ngZone;
        /**
         * Will be emitted when active slide has been changed. Part of two-way-bindable [(activeSlide)] property
         */
        this.activeSlideChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"](false);
        this._slides = new __WEBPACK_IMPORTED_MODULE_1_ngx_bootstrap_utils__["a" /* LinkedList */]();
        this.destroyed = false;
        Object.assign(this, config);
    }
    Object.defineProperty(CarouselComponent.prototype, "activeSlide", {
        get: /**
         * @return {?}
         */
        function () {
            return this._currentActiveSlide;
        },
        set: /**
         * Index of currently displayed slide(started for 0)
         * @param {?} index
         * @return {?}
         */
        function (index) {
            if (this._slides.length && index !== this._currentActiveSlide) {
                this._select(index);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CarouselComponent.prototype, "interval", {
        get: /**
         * Delay of item cycling in milliseconds. If false, carousel won't cycle
         * automatically.
         * @return {?}
         */
        function () {
            return this._interval;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._interval = value;
            this.restartTimer();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CarouselComponent.prototype, "slides", {
        get: /**
         * @return {?}
         */
        function () {
            return this._slides.toArray();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CarouselComponent.prototype, "isBs4", {
        get: /**
         * @return {?}
         */
        function () {
            return !Object(__WEBPACK_IMPORTED_MODULE_1_ngx_bootstrap_utils__["b" /* isBs3 */])();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    CarouselComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.destroyed = true;
    };
    /**
     * Adds new slide. If this slide is first in collection - set it as active
     * and starts auto changing
     * @param slide
     */
    /**
     * Adds new slide. If this slide is first in collection - set it as active
     * and starts auto changing
     * @param {?} slide
     * @return {?}
     */
    CarouselComponent.prototype.addSlide = /**
     * Adds new slide. If this slide is first in collection - set it as active
     * and starts auto changing
     * @param {?} slide
     * @return {?}
     */
    function (slide) {
        this._slides.add(slide);
        if (this._slides.length === 1) {
            this._currentActiveSlide = void 0;
            this.activeSlide = 0;
            this.play();
        }
    };
    /**
     * Removes specified slide. If this slide is active - will roll to another
     * slide
     * @param slide
     */
    /**
     * Removes specified slide. If this slide is active - will roll to another
     * slide
     * @param {?} slide
     * @return {?}
     */
    CarouselComponent.prototype.removeSlide = /**
     * Removes specified slide. If this slide is active - will roll to another
     * slide
     * @param {?} slide
     * @return {?}
     */
    function (slide) {
        var _this = this;
        var /** @type {?} */ remIndex = this._slides.indexOf(slide);
        if (this._currentActiveSlide === remIndex) {
            // removing of active slide
            var /** @type {?} */ nextSlideIndex_1 = void 0;
            if (this._slides.length > 1) {
                // if this slide last - will roll to first slide, if noWrap flag is
                // FALSE or to previous, if noWrap is TRUE in case, if this slide in
                // middle of collection, index of next slide is same to removed
                // if this slide last - will roll to first slide, if noWrap flag is
                // FALSE or to previous, if noWrap is TRUE in case, if this slide in
                // middle of collection, index of next slide is same to removed
                nextSlideIndex_1 = !this.isLast(remIndex)
                    ? remIndex
                    : this.noWrap ? remIndex - 1 : 0;
            }
            this._slides.remove(remIndex);
            // prevents exception with changing some value after checking
            setTimeout(function () {
                _this._select(nextSlideIndex_1);
            }, 0);
        }
        else {
            this._slides.remove(remIndex);
            var /** @type {?} */ currentSlideIndex_1 = this.getCurrentSlideIndex();
            setTimeout(function () {
                // after removing, need to actualize index of current active slide
                // after removing, need to actualize index of current active slide
                _this._currentActiveSlide = currentSlideIndex_1;
                _this.activeSlideChange.emit(_this._currentActiveSlide);
            }, 0);
        }
    };
    /**
     * Rolling to next slide
     * @param force: {boolean} if true - will ignore noWrap flag
     */
    /**
     * Rolling to next slide
     * @param {?=} force
     * @return {?}
     */
    CarouselComponent.prototype.nextSlide = /**
     * Rolling to next slide
     * @param {?=} force
     * @return {?}
     */
    function (force) {
        if (force === void 0) { force = false; }
        this.activeSlide = this.findNextSlideIndex(Direction.NEXT, force);
    };
    /**
     * Rolling to previous slide
     * @param force: {boolean} if true - will ignore noWrap flag
     */
    /**
     * Rolling to previous slide
     * @param {?=} force
     * @return {?}
     */
    CarouselComponent.prototype.previousSlide = /**
     * Rolling to previous slide
     * @param {?=} force
     * @return {?}
     */
    function (force) {
        if (force === void 0) { force = false; }
        this.activeSlide = this.findNextSlideIndex(Direction.PREV, force);
    };
    /**
     * Rolling to specified slide
     * @param index: {number} index of slide, which must be shown
     */
    /**
     * Rolling to specified slide
     * @param {?} index
     * @return {?}
     */
    CarouselComponent.prototype.selectSlide = /**
     * Rolling to specified slide
     * @param {?} index
     * @return {?}
     */
    function (index) {
        this.activeSlide = index;
    };
    /**
     * Starts a auto changing of slides
     */
    /**
     * Starts a auto changing of slides
     * @return {?}
     */
    CarouselComponent.prototype.play = /**
     * Starts a auto changing of slides
     * @return {?}
     */
    function () {
        if (!this.isPlaying) {
            this.isPlaying = true;
            this.restartTimer();
        }
    };
    /**
     * Stops a auto changing of slides
     */
    /**
     * Stops a auto changing of slides
     * @return {?}
     */
    CarouselComponent.prototype.pause = /**
     * Stops a auto changing of slides
     * @return {?}
     */
    function () {
        if (!this.noPause) {
            this.isPlaying = false;
            this.resetTimer();
        }
    };
    /**
     * Finds and returns index of currently displayed slide
     */
    /**
     * Finds and returns index of currently displayed slide
     * @return {?}
     */
    CarouselComponent.prototype.getCurrentSlideIndex = /**
     * Finds and returns index of currently displayed slide
     * @return {?}
     */
    function () {
        return this._slides.findIndex(function (slide) { return slide.active; });
    };
    /**
     * Defines, whether the specified index is last in collection
     * @param index
     */
    /**
     * Defines, whether the specified index is last in collection
     * @param {?} index
     * @return {?}
     */
    CarouselComponent.prototype.isLast = /**
     * Defines, whether the specified index is last in collection
     * @param {?} index
     * @return {?}
     */
    function (index) {
        return index + 1 >= this._slides.length;
    };
    /**
     * Defines next slide index, depending of direction
     * @param {?} direction
     * @param {?} force
     * @return {?}
     */
    CarouselComponent.prototype.findNextSlideIndex = /**
     * Defines next slide index, depending of direction
     * @param {?} direction
     * @param {?} force
     * @return {?}
     */
    function (direction, force) {
        var /** @type {?} */ nextSlideIndex = 0;
        if (!force &&
            (this.isLast(this.activeSlide) &&
                direction !== Direction.PREV &&
                this.noWrap)) {
            return void 0;
        }
        switch (direction) {
            case Direction.NEXT:
                // if this is last slide, not force, looping is disabled
                // and need to going forward - select current slide, as a next
                nextSlideIndex = !this.isLast(this._currentActiveSlide)
                    ? this._currentActiveSlide + 1
                    : !force && this.noWrap ? this._currentActiveSlide : 0;
                break;
            case Direction.PREV:
                // if this is first slide, not force, looping is disabled
                // and need to going backward - select current slide, as a next
                nextSlideIndex =
                    this._currentActiveSlide > 0
                        ? this._currentActiveSlide - 1
                        : !force && this.noWrap
                            ? this._currentActiveSlide
                            : this._slides.length - 1;
                break;
            default:
                throw new Error('Unknown direction');
        }
        return nextSlideIndex;
    };
    /**
     * Sets a slide, which specified through index, as active
     * @param {?} index
     * @return {?}
     */
    CarouselComponent.prototype._select = /**
     * Sets a slide, which specified through index, as active
     * @param {?} index
     * @return {?}
     */
    function (index) {
        if (isNaN(index)) {
            this.pause();
            return;
        }
        var /** @type {?} */ currentSlide = this._slides.get(this._currentActiveSlide);
        if (currentSlide) {
            currentSlide.active = false;
        }
        var /** @type {?} */ nextSlide = this._slides.get(index);
        if (nextSlide) {
            this._currentActiveSlide = index;
            nextSlide.active = true;
            this.activeSlide = index;
            this.activeSlideChange.emit(index);
        }
    };
    /**
     * Starts loop of auto changing of slides
     * @return {?}
     */
    CarouselComponent.prototype.restartTimer = /**
     * Starts loop of auto changing of slides
     * @return {?}
     */
    function () {
        var _this = this;
        this.resetTimer();
        var /** @type {?} */ interval = +this.interval;
        if (!isNaN(interval) && interval > 0) {
            this.currentInterval = this.ngZone.runOutsideAngular(function () {
                return setInterval(function () {
                    var /** @type {?} */ nInterval = +_this.interval;
                    _this.ngZone.run(function () {
                        if (_this.isPlaying &&
                            !isNaN(_this.interval) &&
                            nInterval > 0 &&
                            _this.slides.length) {
                            _this.nextSlide();
                        }
                        else {
                            _this.pause();
                        }
                    });
                }, interval);
            });
        }
    };
    /**
     * Stops loop of auto changing of slides
     * @return {?}
     */
    CarouselComponent.prototype.resetTimer = /**
     * Stops loop of auto changing of slides
     * @return {?}
     */
    function () {
        if (this.currentInterval) {
            clearInterval(this.currentInterval);
            this.currentInterval = void 0;
        }
    };
    CarouselComponent.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'carousel',
                    template: "<div (mouseenter)=\"pause()\" (mouseleave)=\"play()\" (mouseup)=\"play()\" class=\"carousel slide\">\n  <ol class=\"carousel-indicators\" *ngIf=\"showIndicators && slides.length > 1\">\n    <li *ngFor=\"let slidez of slides; let i = index;\" [class.active]=\"slidez.active === true\" (click)=\"selectSlide(i)\"></li>\n  </ol>\n  <div class=\"carousel-inner\"><ng-content></ng-content></div>\n  <a class=\"left carousel-control carousel-control-prev\" [class.disabled]=\"activeSlide === 0 && noWrap\" (click)=\"previousSlide()\" *ngIf=\"slides.length > 1\">\n    <span class=\"icon-prev carousel-control-prev-icon\" aria-hidden=\"true\"></span>\n    <span *ngIf=\"isBs4\" class=\"sr-only\">Previous</span>\n  </a>\n  <a class=\"right carousel-control carousel-control-next\" (click)=\"nextSlide()\"  [class.disabled]=\"isLast(activeSlide) && noWrap\" *ngIf=\"slides.length > 1\">\n    <span class=\"icon-next carousel-control-next-icon\" aria-hidden=\"true\"></span>\n    <span class=\"sr-only\">Next</span>\n  </a>\n</div>\n"
                }] }
    ];
    /** @nocollapse */
    CarouselComponent.ctorParameters = function () { return [
        { type: CarouselConfig, },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"], },
    ]; };
    CarouselComponent.propDecorators = {
        "noWrap": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "noPause": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "showIndicators": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "activeSlideChange": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "activeSlide": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "interval": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return CarouselComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var SlideComponent = /** @class */ (function () {
    function SlideComponent(carousel) {
        /**
         * Wraps element by appropriate CSS classes
         */
        this.addClass = true;
        this.carousel = carousel;
    }
    /** Fires changes in container collection after adding a new slide instance */
    /**
     * Fires changes in container collection after adding a new slide instance
     * @return {?}
     */
    SlideComponent.prototype.ngOnInit = /**
     * Fires changes in container collection after adding a new slide instance
     * @return {?}
     */
    function () {
        this.carousel.addSlide(this);
    };
    /** Fires changes in container collection after removing of this slide instance */
    /**
     * Fires changes in container collection after removing of this slide instance
     * @return {?}
     */
    SlideComponent.prototype.ngOnDestroy = /**
     * Fires changes in container collection after removing of this slide instance
     * @return {?}
     */
    function () {
        this.carousel.removeSlide(this);
    };
    SlideComponent.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'slide',
                    template: "\n    <div [class.active]=\"active\" class=\"item\">\n      <ng-content></ng-content>\n    </div>\n  ",
                    host: {
                        '[attr.aria-hidden]': '!active'
                    }
                }] }
    ];
    /** @nocollapse */
    SlideComponent.ctorParameters = function () { return [
        { type: CarouselComponent, },
    ]; };
    SlideComponent.propDecorators = {
        "active": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostBinding"], args: ['class.active',] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "addClass": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostBinding"], args: ['class.item',] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostBinding"], args: ['class.carousel-item',] },],
    };
    return SlideComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var CarouselModule = /** @class */ (function () {
    function CarouselModule() {
    }
    /**
     * @return {?}
     */
    CarouselModule.forRoot = /**
     * @return {?}
     */
    function () {
        return { ngModule: CarouselModule, providers: [] };
    };
    CarouselModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                    imports: [__WEBPACK_IMPORTED_MODULE_2__angular_common__["CommonModule"]],
                    declarations: [SlideComponent, CarouselComponent],
                    exports: [SlideComponent, CarouselComponent],
                    providers: [CarouselConfig]
                },] }
    ];
    return CarouselModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */



//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ "./node_modules/ngx-bootstrap/component-loader/fesm5/ngx-bootstrap-component-loader.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BsComponentRef */
/* unused harmony export ComponentLoader */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ComponentLoaderFactory; });
/* unused harmony export ContentRef */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ngx_bootstrap_utils__ = __webpack_require__("./node_modules/ngx-bootstrap/utils/fesm5/ngx-bootstrap-utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ngx_bootstrap_positioning__ = __webpack_require__("./node_modules/ngx-bootstrap/positioning/fesm5/ngx-bootstrap-positioning.js");




/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @template T
 */
var  /**
 * @template T
 */
BsComponentRef = /** @class */ (function () {
    function BsComponentRef() {
    }
    return BsComponentRef;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @copyright Valor Software
 * @copyright Angular ng-bootstrap team
 */
var ContentRef = /** @class */ (function () {
    function ContentRef(/* tslint:disable-next-line: no-any */
    /* tslint:disable-next-line: no-any */
    nodes, viewRef, /* tslint:disable-next-line: no-any */
    /* tslint:disable-next-line: no-any */
    componentRef) {
        this.nodes = nodes;
        this.viewRef = viewRef;
        this.componentRef = componentRef;
    }
    return ContentRef;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @template T
 */
var  /**
 * @template T
 */
ComponentLoader = /** @class */ (function () {
    function ComponentLoader(_viewContainerRef, _renderer, _elementRef, _injector, _componentFactoryResolver, _ngZone, _applicationRef, _posService) {
        this._viewContainerRef = _viewContainerRef;
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this._injector = _injector;
        this._componentFactoryResolver = _componentFactoryResolver;
        this._ngZone = _ngZone;
        this._applicationRef = _applicationRef;
        this._posService = _posService;
        this.onBeforeShow = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /* tslint:disable-next-line: no-any*/
        this.onShown = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /* tslint:disable-next-line: no-any*/
        this.onBeforeHide = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.onHidden = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this._providers = [];
        this._isHiding = false;
        this._listenOpts = {};
        this._globalListener = Function.prototype;
    }
    Object.defineProperty(ComponentLoader.prototype, "isShown", {
        get: /**
         * @return {?}
         */
        function () {
            if (this._isHiding) {
                return false;
            }
            return !!this._componentRef;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} compType
     * @return {?}
     */
    ComponentLoader.prototype.attach = /**
     * @param {?} compType
     * @return {?}
     */
    function (compType) {
        this._componentFactory = this._componentFactoryResolver
            .resolveComponentFactory(compType);
        return this;
    };
    // todo: add behaviour: to target element, `body`, custom element
    /**
     * @param {?=} container
     * @return {?}
     */
    ComponentLoader.prototype.to = /**
     * @param {?=} container
     * @return {?}
     */
    function (container) {
        this.container = container || this.container;
        return this;
    };
    /**
     * @param {?=} opts
     * @return {?}
     */
    ComponentLoader.prototype.position = /**
     * @param {?=} opts
     * @return {?}
     */
    function (opts) {
        this.attachment = opts.attachment || this.attachment;
        this._elementRef = (/** @type {?} */ (opts.target)) || this._elementRef;
        return this;
    };
    /**
     * @param {?} provider
     * @return {?}
     */
    ComponentLoader.prototype.provide = /**
     * @param {?} provider
     * @return {?}
     */
    function (provider) {
        this._providers.push(provider);
        return this;
    };
    // todo: appendChild to element or document.querySelector(this.container)
    /**
     * @param {?=} opts
     * @return {?}
     */
    ComponentLoader.prototype.show = /**
     * @param {?=} opts
     * @return {?}
     */
    function (opts) {
        if (opts === void 0) { opts = {}; }
        this._subscribePositioning();
        this._innerComponent = null;
        if (!this._componentRef) {
            this.onBeforeShow.emit();
            this._contentRef = this._getContentRef(opts.content, opts.context, opts.initialState);
            var /** @type {?} */ injector = __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injector"].create({
                providers: this._providers,
                parent: this._injector
            });
            this._componentRef = this._componentFactory.create(injector, this._contentRef.nodes);
            this._applicationRef.attachView(this._componentRef.hostView);
            // this._componentRef = this._viewContainerRef
            //   .createComponent(this._componentFactory, 0, injector, this._contentRef.nodes);
            this.instance = this._componentRef.instance;
            Object.assign(this._componentRef.instance, opts);
            if (this.container instanceof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"]) {
                this.container.nativeElement.appendChild(this._componentRef.location.nativeElement);
            }
            if (this.container === 'body' && typeof document !== 'undefined') {
                document
                    .querySelector(/** @type {?} */ (this.container))
                    .appendChild(this._componentRef.location.nativeElement);
            }
            if (!this.container &&
                this._elementRef &&
                this._elementRef.nativeElement.parentElement) {
                this._elementRef.nativeElement.parentElement.appendChild(this._componentRef.location.nativeElement);
            }
            // we need to manually invoke change detection since events registered
            // via
            // Renderer::listen() are not picked up by change detection with the
            // OnPush strategy
            if (this._contentRef.componentRef) {
                this._innerComponent = this._contentRef.componentRef.instance;
                this._contentRef.componentRef.changeDetectorRef.markForCheck();
                this._contentRef.componentRef.changeDetectorRef.detectChanges();
            }
            this._componentRef.changeDetectorRef.markForCheck();
            this._componentRef.changeDetectorRef.detectChanges();
            this.onShown.emit(this._componentRef.instance);
        }
        this._registerOutsideClick();
        return this._componentRef;
    };
    /**
     * @return {?}
     */
    ComponentLoader.prototype.hide = /**
     * @return {?}
     */
    function () {
        if (!this._componentRef) {
            return this;
        }
        this.onBeforeHide.emit(this._componentRef.instance);
        var /** @type {?} */ componentEl = this._componentRef.location.nativeElement;
        componentEl.parentNode.removeChild(componentEl);
        if (this._contentRef.componentRef) {
            this._contentRef.componentRef.destroy();
        }
        this._componentRef.destroy();
        if (this._viewContainerRef && this._contentRef.viewRef) {
            this._viewContainerRef.remove(this._viewContainerRef.indexOf(this._contentRef.viewRef));
        }
        if (this._contentRef.viewRef) {
            this._contentRef.viewRef.destroy();
        }
        this._contentRef = null;
        this._componentRef = null;
        this._removeGlobalListener();
        this.onHidden.emit();
        return this;
    };
    /**
     * @return {?}
     */
    ComponentLoader.prototype.toggle = /**
     * @return {?}
     */
    function () {
        if (this.isShown) {
            this.hide();
            return;
        }
        this.show();
    };
    /**
     * @return {?}
     */
    ComponentLoader.prototype.dispose = /**
     * @return {?}
     */
    function () {
        if (this.isShown) {
            this.hide();
        }
        this._unsubscribePositioning();
        if (this._unregisterListenersFn) {
            this._unregisterListenersFn();
        }
    };
    /**
     * @param {?} listenOpts
     * @return {?}
     */
    ComponentLoader.prototype.listen = /**
     * @param {?} listenOpts
     * @return {?}
     */
    function (listenOpts) {
        var _this = this;
        this.triggers = listenOpts.triggers || this.triggers;
        this._listenOpts.outsideClick = listenOpts.outsideClick;
        this._listenOpts.outsideEsc = listenOpts.outsideEsc;
        listenOpts.target = listenOpts.target || this._elementRef.nativeElement;
        var /** @type {?} */ hide = (this._listenOpts.hide = function () {
            return listenOpts.hide ? listenOpts.hide() : void _this.hide();
        });
        var /** @type {?} */ show = (this._listenOpts.show = function (registerHide) {
            listenOpts.show ? listenOpts.show(registerHide) : _this.show(registerHide);
            registerHide();
        });
        var /** @type {?} */ toggle = function (registerHide) {
            _this.isShown ? hide() : show(registerHide);
        };
        this._unregisterListenersFn = Object(__WEBPACK_IMPORTED_MODULE_1_ngx_bootstrap_utils__["c" /* listenToTriggersV2 */])(this._renderer, {
            target: listenOpts.target,
            triggers: listenOpts.triggers,
            show: show,
            hide: hide,
            toggle: toggle
        });
        return this;
    };
    /**
     * @return {?}
     */
    ComponentLoader.prototype._removeGlobalListener = /**
     * @return {?}
     */
    function () {
        if (this._globalListener) {
            this._globalListener();
            this._globalListener = null;
        }
    };
    /**
     * @param {?} vRef
     * @param {?} template
     * @return {?}
     */
    ComponentLoader.prototype.attachInline = /**
     * @param {?} vRef
     * @param {?} template
     * @return {?}
     */
    function (vRef, /* tslint:disable-next-line: no-any*/
    /* tslint:disable-next-line: no-any*/
    template) {
        this._inlineViewRef = vRef.createEmbeddedView(template);
        return this;
    };
    /**
     * @return {?}
     */
    ComponentLoader.prototype._registerOutsideClick = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (!this._componentRef || !this._componentRef.location) {
            return;
        }
        // why: should run after first event bubble
        if (this._listenOpts.outsideClick) {
            var /** @type {?} */ target_1 = this._componentRef.location.nativeElement;
            setTimeout(function () {
                _this._globalListener = Object(__WEBPACK_IMPORTED_MODULE_1_ngx_bootstrap_utils__["e" /* registerOutsideClick */])(_this._renderer, {
                    targets: [target_1, _this._elementRef.nativeElement],
                    outsideClick: _this._listenOpts.outsideClick,
                    hide: function () { return _this._listenOpts.hide(); }
                });
            });
        }
        if (this._listenOpts.outsideEsc) {
            var /** @type {?} */ target = this._componentRef.location.nativeElement;
            this._globalListener = Object(__WEBPACK_IMPORTED_MODULE_1_ngx_bootstrap_utils__["d" /* registerEscClick */])(this._renderer, {
                targets: [target, this._elementRef.nativeElement],
                outsideEsc: this._listenOpts.outsideEsc,
                hide: function () { return _this._listenOpts.hide(); }
            });
        }
    };
    /**
     * @return {?}
     */
    ComponentLoader.prototype.getInnerComponent = /**
     * @return {?}
     */
    function () {
        return this._innerComponent;
    };
    /**
     * @return {?}
     */
    ComponentLoader.prototype._subscribePositioning = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this._zoneSubscription || !this.attachment) {
            return;
        }
        this._zoneSubscription = this._ngZone.onStable.subscribe(function () {
            if (!_this._componentRef) {
                return;
            }
            _this._posService.position({
                element: _this._componentRef.location,
                target: _this._elementRef,
                attachment: _this.attachment,
                appendToBody: _this.container === 'body'
            });
        });
    };
    /**
     * @return {?}
     */
    ComponentLoader.prototype._unsubscribePositioning = /**
     * @return {?}
     */
    function () {
        if (!this._zoneSubscription) {
            return;
        }
        this._zoneSubscription.unsubscribe();
        this._zoneSubscription = null;
    };
    /**
     * @param {?} content
     * @param {?=} context
     * @param {?=} initialState
     * @return {?}
     */
    ComponentLoader.prototype._getContentRef = /**
     * @param {?} content
     * @param {?=} context
     * @param {?=} initialState
     * @return {?}
     */
    function (/* tslint:disable-next-line: no-any*/
    /* tslint:disable-next-line: no-any*/
    content, /* tslint:disable-next-line: no-any*/
    /* tslint:disable-next-line: no-any*/
    context, /* tslint:disable-next-line: no-any*/
    /* tslint:disable-next-line: no-any*/
    initialState) {
        if (!content) {
            return new ContentRef([]);
        }
        if (content instanceof __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"]) {
            if (this._viewContainerRef) {
                var /** @type {?} */ _viewRef = this._viewContainerRef
                    .createEmbeddedView(content, context);
                _viewRef.markForCheck();
                return new ContentRef([_viewRef.rootNodes], _viewRef);
            }
            var /** @type {?} */ viewRef = content.createEmbeddedView({});
            this._applicationRef.attachView(viewRef);
            return new ContentRef([viewRef.rootNodes], viewRef);
        }
        if (typeof content === 'function') {
            var /** @type {?} */ contentCmptFactory = this._componentFactoryResolver.resolveComponentFactory(content);
            var /** @type {?} */ modalContentInjector = __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injector"].create({
                providers: this._providers,
                parent: this._injector
            });
            var /** @type {?} */ componentRef = contentCmptFactory.create(modalContentInjector);
            Object.assign(componentRef.instance, initialState);
            this._applicationRef.attachView(componentRef.hostView);
            return new ContentRef([[componentRef.location.nativeElement]], componentRef.hostView, componentRef);
        }
        return new ContentRef([[this._renderer.createText("" + content)]]);
    };
    return ComponentLoader;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var ComponentLoaderFactory = /** @class */ (function () {
    function ComponentLoaderFactory(_componentFactoryResolver, _ngZone, _injector, _posService, _applicationRef) {
        this._componentFactoryResolver = _componentFactoryResolver;
        this._ngZone = _ngZone;
        this._injector = _injector;
        this._posService = _posService;
        this._applicationRef = _applicationRef;
    }
    /**
     *
     * @param _elementRef
     * @param _viewContainerRef
     * @param _renderer
     */
    /**
     *
     * @template T
     * @param {?} _elementRef
     * @param {?} _viewContainerRef
     * @param {?} _renderer
     * @return {?}
     */
    ComponentLoaderFactory.prototype.createLoader = /**
     *
     * @template T
     * @param {?} _elementRef
     * @param {?} _viewContainerRef
     * @param {?} _renderer
     * @return {?}
     */
    function (_elementRef, _viewContainerRef, _renderer) {
        return new ComponentLoader(_viewContainerRef, _renderer, _elementRef, this._injector, this._componentFactoryResolver, this._ngZone, this._applicationRef, this._posService);
    };
    ComponentLoaderFactory.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] }
    ];
    /** @nocollapse */
    ComponentLoaderFactory.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ComponentFactoryResolver"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injector"], },
        { type: __WEBPACK_IMPORTED_MODULE_2_ngx_bootstrap_positioning__["a" /* PositioningService */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ApplicationRef"], },
    ]; };
    return ComponentLoaderFactory;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */



//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ "./node_modules/ngx-bootstrap/dropdown/fesm5/ngx-bootstrap-dropdown.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BsDropdownDirective", function() { return BsDropdownDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BsDropdownMenuDirective", function() { return BsDropdownMenuDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BsDropdownToggleDirective", function() { return BsDropdownToggleDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BsDropdownContainerComponent", function() { return BsDropdownContainerComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BsDropdownState", function() { return BsDropdownState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BsDropdownConfig", function() { return BsDropdownConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BsDropdownModule", function() { return BsDropdownModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ngx_bootstrap_utils__ = __webpack_require__("./node_modules/ngx-bootstrap/utils/fesm5/ngx-bootstrap-utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_operators__ = __webpack_require__("./node_modules/rxjs/operators.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_operators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ngx_bootstrap_component_loader__ = __webpack_require__("./node_modules/ngx-bootstrap/component-loader/fesm5/ngx-bootstrap-component-loader.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ngx_bootstrap_positioning__ = __webpack_require__("./node_modules/ngx-bootstrap/positioning/fesm5/ngx-bootstrap-positioning.js");







/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Default dropdown configuration
 */
var BsDropdownConfig = /** @class */ (function () {
    function BsDropdownConfig() {
        /**
         * default dropdown auto closing behavior
         */
        this.autoClose = true;
        /**
         * default dropdown auto closing behavior
         */
        this.insideClick = false;
    }
    BsDropdownConfig.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] }
    ];
    return BsDropdownConfig;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var BsDropdownState = /** @class */ (function () {
    function BsDropdownState() {
        var _this = this;
        this.direction = 'down';
        this.isOpenChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.isDisabledChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.toggleClick = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.dropdownMenu = new Promise(function (resolve) {
            _this.resolveDropdownMenu = resolve;
        });
    }
    BsDropdownState.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] }
    ];
    /** @nocollapse */
    BsDropdownState.ctorParameters = function () { return []; };
    return BsDropdownState;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var BsDropdownContainerComponent = /** @class */ (function () {
    function BsDropdownContainerComponent(_state, cd, _renderer, _element) {
        var _this = this;
        this._state = _state;
        this.cd = cd;
        this._renderer = _renderer;
        this._element = _element;
        this.isOpen = false;
        this._subscription = _state.isOpenChange.subscribe(function (value) {
            _this.isOpen = value;
            var /** @type {?} */ dropdown = _this._element.nativeElement.querySelector('.dropdown-menu');
            if (dropdown && !Object(__WEBPACK_IMPORTED_MODULE_1_ngx_bootstrap_utils__["b" /* isBs3 */])()) {
                _this._renderer.addClass(dropdown, 'show');
                if (dropdown.classList.contains('dropdown-menu-right')) {
                    _this._renderer.setStyle(dropdown, 'left', 'auto');
                    _this._renderer.setStyle(dropdown, 'right', '0');
                }
                if (_this.direction === 'up') {
                    _this._renderer.setStyle(dropdown, 'top', 'auto');
                    _this._renderer.setStyle(dropdown, 'transform', 'translateY(-101%)');
                }
            }
            _this.cd.markForCheck();
            _this.cd.detectChanges();
        });
    }
    Object.defineProperty(BsDropdownContainerComponent.prototype, "direction", {
        get: /**
         * @return {?}
         */
        function () {
            return this._state.direction;
        },
        enumerable: true,
        configurable: true
    });
    /** @internal */
    /**
     * \@internal
     * @param {?} el
     * @return {?}
     */
    BsDropdownContainerComponent.prototype._contains = /**
     * \@internal
     * @param {?} el
     * @return {?}
     */
    function (el) {
        return this._element.nativeElement.contains(el);
    };
    /**
     * @return {?}
     */
    BsDropdownContainerComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this._subscription.unsubscribe();
    };
    BsDropdownContainerComponent.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'bs-dropdown-container',
                    changeDetection: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectionStrategy"].OnPush,
                    host: {
                        style: 'display:block;position: absolute;'
                    },
                    template: "\n    <div [class.dropup]=\"direction === 'up'\"\n         [class.dropdown]=\"direction === 'down'\"\n         [class.show]=\"isOpen\"\n         [class.open]=\"isOpen\"><ng-content></ng-content></div>\n  "
                }] }
    ];
    /** @nocollapse */
    BsDropdownContainerComponent.ctorParameters = function () { return [
        { type: BsDropdownState, },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    ]; };
    return BsDropdownContainerComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var BsDropdownDirective = /** @class */ (function () {
    function BsDropdownDirective(_elementRef, _renderer, _viewContainerRef, _cis, _config, _state) {
        this._elementRef = _elementRef;
        this._renderer = _renderer;
        this._viewContainerRef = _viewContainerRef;
        this._cis = _cis;
        this._config = _config;
        this._state = _state;
        this._isInlineOpen = false;
        this._subscriptions = [];
        this._isInited = false;
        // set initial dropdown state from config
        this._state.autoClose = this._config.autoClose;
        this._state.insideClick = this._config.insideClick;
        // create dropdown component loader
        this._dropdown = this._cis
            .createLoader(this._elementRef, this._viewContainerRef, this._renderer)
            .provide({ provide: BsDropdownState, useValue: this._state });
        this.onShown = this._dropdown.onShown;
        this.onHidden = this._dropdown.onHidden;
        this.isOpenChange = this._state.isOpenChange;
    }
    Object.defineProperty(BsDropdownDirective.prototype, "autoClose", {
        get: /**
         * @return {?}
         */
        function () {
            return this._state.autoClose;
        },
        set: /**
         * Indicates that dropdown will be closed on item or document click,
         * and after pressing ESC
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._state.autoClose = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BsDropdownDirective.prototype, "insideClick", {
        get: /**
         * @return {?}
         */
        function () {
            return this._state.insideClick;
        },
        set: /**
         * This attribute indicates that the dropdown shouldn't close on inside click when autoClose is set to true
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._state.insideClick = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BsDropdownDirective.prototype, "isDisabled", {
        get: /**
         * @return {?}
         */
        function () {
            return this._isDisabled;
        },
        set: /**
         * Disables dropdown toggle and hides dropdown menu if opened
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._isDisabled = value;
            this._state.isDisabledChange.emit(value);
            if (value) {
                this.hide();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BsDropdownDirective.prototype, "isOpen", {
        get: /**
         * Returns whether or not the popover is currently being shown
         * @return {?}
         */
        function () {
            if (this._showInline) {
                return this._isInlineOpen;
            }
            return this._dropdown.isShown;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value) {
                this.show();
            }
            else {
                this.hide();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BsDropdownDirective.prototype, "isBs4", {
        get: /**
         * @return {?}
         */
        function () {
            return !Object(__WEBPACK_IMPORTED_MODULE_1_ngx_bootstrap_utils__["b" /* isBs3 */])();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BsDropdownDirective.prototype, "_showInline", {
        get: /**
         * @return {?}
         */
        function () {
            return !this.container;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    BsDropdownDirective.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        // fix: seems there are an issue with `routerLinkActive`
        // which result in duplicated call ngOnInit without call to ngOnDestroy
        // read more: https://github.com/valor-software/ngx-bootstrap/issues/1885
        if (this._isInited) {
            return;
        }
        this._isInited = true;
        // attach DOM listeners
        this._dropdown.listen({
            // because of dropdown inline mode
            outsideClick: false,
            triggers: this.triggers,
            show: function () { return _this.show(); }
        });
        // toggle visibility on toggle element click
        this._subscriptions.push(this._state.toggleClick.subscribe(function (value) { return _this.toggle(value); }));
        // hide dropdown if set disabled while opened
        this._subscriptions.push(this._state.isDisabledChange
            .pipe(Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["filter"])(function (value) { return value; }))
            .subscribe(function (value) { return _this.hide(); }));
    };
    /**
     * Opens an element’s popover. This is considered a “manual” triggering of
     * the popover.
     */
    /**
     * Opens an element’s popover. This is considered a “manual” triggering of
     * the popover.
     * @return {?}
     */
    BsDropdownDirective.prototype.show = /**
     * Opens an element’s popover. This is considered a “manual” triggering of
     * the popover.
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.isOpen || this.isDisabled) {
            return;
        }
        if (this._showInline) {
            if (!this._inlinedMenu) {
                this._state.dropdownMenu.then(function (dropdownMenu) {
                    _this._dropdown.attachInline(dropdownMenu.viewContainer, dropdownMenu.templateRef);
                    _this._inlinedMenu = _this._dropdown._inlineViewRef;
                    _this.addBs4Polyfills();
                })
                    .catch();
            }
            this.addBs4Polyfills();
            this._isInlineOpen = true;
            this.onShown.emit(true);
            this._state.isOpenChange.emit(true);
            return;
        }
        this._state.dropdownMenu.then(function (dropdownMenu) {
            // check direction in which dropdown should be opened
            var /** @type {?} */ _dropup = _this.dropup ||
                (typeof _this.dropup !== 'undefined' && _this.dropup);
            _this._state.direction = _dropup ? 'up' : 'down';
            var /** @type {?} */ _placement = _this.placement || (_dropup ? 'top left' : 'bottom left');
            // show dropdown
            // show dropdown
            _this._dropdown
                .attach(BsDropdownContainerComponent)
                .to(_this.container)
                .position({ attachment: _placement })
                .show({
                content: dropdownMenu.templateRef,
                placement: _placement
            });
            _this._state.isOpenChange.emit(true);
        })
            .catch();
    };
    /**
     * Closes an element’s popover. This is considered a “manual” triggering of
     * the popover.
     */
    /**
     * Closes an element’s popover. This is considered a “manual” triggering of
     * the popover.
     * @return {?}
     */
    BsDropdownDirective.prototype.hide = /**
     * Closes an element’s popover. This is considered a “manual” triggering of
     * the popover.
     * @return {?}
     */
    function () {
        if (!this.isOpen) {
            return;
        }
        if (this._showInline) {
            this.removeShowClass();
            this.removeDropupStyles();
            this._isInlineOpen = false;
            this.onHidden.emit(true);
        }
        else {
            this._dropdown.hide();
        }
        this._state.isOpenChange.emit(false);
    };
    /**
     * Toggles an element’s popover. This is considered a “manual” triggering of
     * the popover. With parameter <code>true</code> allows toggling, with parameter <code>false</code>
     * only hides opened dropdown. Parameter usage will be removed in ngx-bootstrap v3
     */
    /**
     * Toggles an element’s popover. This is considered a “manual” triggering of
     * the popover. With parameter <code>true</code> allows toggling, with parameter <code>false</code>
     * only hides opened dropdown. Parameter usage will be removed in ngx-bootstrap v3
     * @param {?=} value
     * @return {?}
     */
    BsDropdownDirective.prototype.toggle = /**
     * Toggles an element’s popover. This is considered a “manual” triggering of
     * the popover. With parameter <code>true</code> allows toggling, with parameter <code>false</code>
     * only hides opened dropdown. Parameter usage will be removed in ngx-bootstrap v3
     * @param {?=} value
     * @return {?}
     */
    function (value) {
        if (this.isOpen || !value) {
            return this.hide();
        }
        return this.show();
    };
    /** @internal */
    /**
     * \@internal
     * @param {?} event
     * @return {?}
     */
    BsDropdownDirective.prototype._contains = /**
     * \@internal
     * @param {?} event
     * @return {?}
     */
    function (event) {
        return this._elementRef.nativeElement.contains(event.target) ||
            (this._dropdown.instance && this._dropdown.instance._contains(event.target));
    };
    /**
     * @return {?}
     */
    BsDropdownDirective.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        try {
            // clean up subscriptions and destroy dropdown
            for (var _a = Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["h" /* __values */])(this._subscriptions), _b = _a.next(); !_b.done; _b = _a.next()) {
                var sub = _b.value;
                sub.unsubscribe();
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
            }
            finally { if (e_1) throw e_1.error; }
        }
        this._dropdown.dispose();
        var e_1, _c;
    };
    /**
     * @return {?}
     */
    BsDropdownDirective.prototype.addBs4Polyfills = /**
     * @return {?}
     */
    function () {
        if (!Object(__WEBPACK_IMPORTED_MODULE_1_ngx_bootstrap_utils__["b" /* isBs3 */])()) {
            this.addShowClass();
            this.checkRightAlignment();
            this.addDropupStyles();
        }
    };
    /**
     * @return {?}
     */
    BsDropdownDirective.prototype.addShowClass = /**
     * @return {?}
     */
    function () {
        if (this._inlinedMenu && this._inlinedMenu.rootNodes[0]) {
            this._renderer.addClass(this._inlinedMenu.rootNodes[0], 'show');
        }
    };
    /**
     * @return {?}
     */
    BsDropdownDirective.prototype.removeShowClass = /**
     * @return {?}
     */
    function () {
        if (this._inlinedMenu && this._inlinedMenu.rootNodes[0]) {
            this._renderer.removeClass(this._inlinedMenu.rootNodes[0], 'show');
        }
    };
    /**
     * @return {?}
     */
    BsDropdownDirective.prototype.checkRightAlignment = /**
     * @return {?}
     */
    function () {
        if (this._inlinedMenu && this._inlinedMenu.rootNodes[0]) {
            var /** @type {?} */ isRightAligned = this._inlinedMenu.rootNodes[0].classList.contains('dropdown-menu-right');
            this._renderer.setStyle(this._inlinedMenu.rootNodes[0], 'left', isRightAligned ? 'auto' : '0');
            this._renderer.setStyle(this._inlinedMenu.rootNodes[0], 'right', isRightAligned ? '0' : 'auto');
        }
    };
    /**
     * @return {?}
     */
    BsDropdownDirective.prototype.addDropupStyles = /**
     * @return {?}
     */
    function () {
        if (this._inlinedMenu && this._inlinedMenu.rootNodes[0]) {
            // a little hack to not break support of bootstrap 4 beta
            this._renderer.setStyle(this._inlinedMenu.rootNodes[0], 'top', this.dropup ? 'auto' : '100%');
            this._renderer.setStyle(this._inlinedMenu.rootNodes[0], 'transform', this.dropup ? 'translateY(-101%)' : 'translateY(0)');
            this._renderer.setStyle(this._inlinedMenu.rootNodes[0], 'bottom', 'auto');
        }
    };
    /**
     * @return {?}
     */
    BsDropdownDirective.prototype.removeDropupStyles = /**
     * @return {?}
     */
    function () {
        if (this._inlinedMenu && this._inlinedMenu.rootNodes[0]) {
            this._renderer.removeStyle(this._inlinedMenu.rootNodes[0], 'top');
            this._renderer.removeStyle(this._inlinedMenu.rootNodes[0], 'transform');
            this._renderer.removeStyle(this._inlinedMenu.rootNodes[0], 'bottom');
        }
    };
    BsDropdownDirective.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: '[bsDropdown],[dropdown]',
                    exportAs: 'bs-dropdown',
                    providers: [BsDropdownState],
                    host: {
                        '[class.dropup]': 'dropup',
                        '[class.open]': 'isOpen',
                        '[class.show]': 'isOpen && isBs4'
                    }
                },] }
    ];
    /** @nocollapse */
    BsDropdownDirective.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_4_ngx_bootstrap_component_loader__["a" /* ComponentLoaderFactory */], },
        { type: BsDropdownConfig, },
        { type: BsDropdownState, },
    ]; };
    BsDropdownDirective.propDecorators = {
        "placement": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "triggers": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "container": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "dropup": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "autoClose": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "insideClick": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "isDisabled": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "isOpen": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "isOpenChange": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "onShown": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "onHidden": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    };
    return BsDropdownDirective;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var BsDropdownMenuDirective = /** @class */ (function () {
    // tslint:disable:no-any
    function BsDropdownMenuDirective(_state, _viewContainer, _templateRef) {
        _state.resolveDropdownMenu({
            templateRef: _templateRef,
            viewContainer: _viewContainer
        });
    }
    BsDropdownMenuDirective.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: '[bsDropdownMenu],[dropdownMenu]',
                    exportAs: 'bs-dropdown-menu'
                },] }
    ];
    /** @nocollapse */
    BsDropdownMenuDirective.ctorParameters = function () { return [
        { type: BsDropdownState, },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"], },
    ]; };
    return BsDropdownMenuDirective;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var BsDropdownToggleDirective = /** @class */ (function () {
    function BsDropdownToggleDirective(_state, _element, dropdown) {
        var _this = this;
        this._state = _state;
        this._element = _element;
        this.dropdown = dropdown;
        this.isDisabled = null;
        this._subscriptions = [];
        // sync is open value with state
        this._subscriptions.push(this._state.isOpenChange.subscribe(function (value) { return (_this.isOpen = value); }));
        // populate disabled state
        this._subscriptions.push(this._state.isDisabledChange.subscribe(function (value) { return (_this.isDisabled = value || null); }));
    }
    /**
     * @return {?}
     */
    BsDropdownToggleDirective.prototype.onClick = /**
     * @return {?}
     */
    function () {
        if (this.isDisabled) {
            return;
        }
        this._state.toggleClick.emit(true);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    BsDropdownToggleDirective.prototype.onDocumentClick = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (this._state.autoClose &&
            event.button !== 2 &&
            !this._element.nativeElement.contains(event.target) &&
            !(this._state.insideClick && this.dropdown._contains(event))) {
            this._state.toggleClick.emit(false);
        }
    };
    /**
     * @return {?}
     */
    BsDropdownToggleDirective.prototype.onEsc = /**
     * @return {?}
     */
    function () {
        if (this._state.autoClose) {
            this._state.toggleClick.emit(false);
        }
    };
    /**
     * @return {?}
     */
    BsDropdownToggleDirective.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        try {
            for (var _a = Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["h" /* __values */])(this._subscriptions), _b = _a.next(); !_b.done; _b = _a.next()) {
                var sub = _b.value;
                sub.unsubscribe();
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
            }
            finally { if (e_1) throw e_1.error; }
        }
        var e_1, _c;
    };
    BsDropdownToggleDirective.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: '[bsDropdownToggle],[dropdownToggle]',
                    exportAs: 'bs-dropdown-toggle',
                    host: {
                        '[attr.aria-haspopup]': 'true'
                    }
                },] }
    ];
    /** @nocollapse */
    BsDropdownToggleDirective.ctorParameters = function () { return [
        { type: BsDropdownState, },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: BsDropdownDirective, },
    ]; };
    BsDropdownToggleDirective.propDecorators = {
        "isDisabled": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostBinding"], args: ['attr.disabled',] },],
        "isOpen": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostBinding"], args: ['attr.aria-expanded',] },],
        "onClick": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"], args: ['click', [],] },],
        "onDocumentClick": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"], args: ['document:click', ['$event'],] },],
        "onEsc": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"], args: ['keyup.esc',] },],
    };
    return BsDropdownToggleDirective;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var BsDropdownModule = /** @class */ (function () {
    function BsDropdownModule() {
    }
    // tslint:disable-next-line:no-any
    /**
     * @param {?=} config
     * @return {?}
     */
    BsDropdownModule.forRoot = /**
     * @param {?=} config
     * @return {?}
     */
    function (config) {
        return {
            ngModule: BsDropdownModule,
            providers: [
                __WEBPACK_IMPORTED_MODULE_4_ngx_bootstrap_component_loader__["a" /* ComponentLoaderFactory */],
                __WEBPACK_IMPORTED_MODULE_5_ngx_bootstrap_positioning__["a" /* PositioningService */],
                BsDropdownState,
                {
                    provide: BsDropdownConfig,
                    useValue: config ? config : { autoClose: true, insideClick: false }
                }
            ]
        };
    };
    BsDropdownModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                    declarations: [
                        BsDropdownMenuDirective,
                        BsDropdownToggleDirective,
                        BsDropdownContainerComponent,
                        BsDropdownDirective
                    ],
                    exports: [
                        BsDropdownMenuDirective,
                        BsDropdownToggleDirective,
                        BsDropdownDirective
                    ],
                    entryComponents: [BsDropdownContainerComponent]
                },] }
    ];
    return BsDropdownModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */



//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ "./node_modules/ngx-bootstrap/positioning/fesm5/ngx-bootstrap-positioning.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export positionElements */
/* unused harmony export Positioning */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PositioningService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");


/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @copyright Valor Software
 * @copyright Angular ng-bootstrap team
 */
var Positioning = /** @class */ (function () {
    function Positioning() {
    }
    /**
     * @param {?} element
     * @param {?=} round
     * @return {?}
     */
    Positioning.prototype.position = /**
     * @param {?} element
     * @param {?=} round
     * @return {?}
     */
    function (element, round) {
        if (round === void 0) { round = true; }
        var /** @type {?} */ elPosition;
        var /** @type {?} */ parentOffset = {
            width: 0,
            height: 0,
            top: 0,
            bottom: 0,
            left: 0,
            right: 0
        };
        if (this.getStyle(element, 'position') === 'fixed') {
            var /** @type {?} */ bcRect = element.getBoundingClientRect();
            elPosition = {
                width: bcRect.width,
                height: bcRect.height,
                top: bcRect.top,
                bottom: bcRect.bottom,
                left: bcRect.left,
                right: bcRect.right
            };
        }
        else {
            var /** @type {?} */ offsetParentEl = this.offsetParent(element);
            elPosition = this.offset(element, false);
            if (offsetParentEl !== document.documentElement) {
                parentOffset = this.offset(offsetParentEl, false);
            }
            parentOffset.top += offsetParentEl.clientTop;
            parentOffset.left += offsetParentEl.clientLeft;
        }
        elPosition.top -= parentOffset.top;
        elPosition.bottom -= parentOffset.top;
        elPosition.left -= parentOffset.left;
        elPosition.right -= parentOffset.left;
        if (round) {
            elPosition.top = Math.round(elPosition.top);
            elPosition.bottom = Math.round(elPosition.bottom);
            elPosition.left = Math.round(elPosition.left);
            elPosition.right = Math.round(elPosition.right);
        }
        return elPosition;
    };
    /**
     * @param {?} element
     * @param {?=} round
     * @return {?}
     */
    Positioning.prototype.offset = /**
     * @param {?} element
     * @param {?=} round
     * @return {?}
     */
    function (element, round) {
        if (round === void 0) { round = true; }
        var /** @type {?} */ elBcr = element.getBoundingClientRect();
        var /** @type {?} */ viewportOffset = {
            top: window.pageYOffset - document.documentElement.clientTop,
            left: window.pageXOffset - document.documentElement.clientLeft
        };
        var /** @type {?} */ elOffset = {
            height: elBcr.height || element.offsetHeight,
            width: elBcr.width || element.offsetWidth,
            top: elBcr.top + viewportOffset.top,
            bottom: elBcr.bottom + viewportOffset.top,
            left: elBcr.left + viewportOffset.left,
            right: elBcr.right + viewportOffset.left
        };
        if (round) {
            elOffset.height = Math.round(elOffset.height);
            elOffset.width = Math.round(elOffset.width);
            elOffset.top = Math.round(elOffset.top);
            elOffset.bottom = Math.round(elOffset.bottom);
            elOffset.left = Math.round(elOffset.left);
            elOffset.right = Math.round(elOffset.right);
        }
        return elOffset;
    };
    /**
     * @param {?} hostElement
     * @param {?} targetElement
     * @param {?} placement
     * @param {?=} appendToBody
     * @return {?}
     */
    Positioning.prototype.positionElements = /**
     * @param {?} hostElement
     * @param {?} targetElement
     * @param {?} placement
     * @param {?=} appendToBody
     * @return {?}
     */
    function (hostElement, targetElement, placement, appendToBody) {
        var /** @type {?} */ hostElPosition = appendToBody
            ? this.offset(hostElement, false)
            : this.position(hostElement, false);
        var /** @type {?} */ targetElStyles = this.getAllStyles(targetElement);
        var /** @type {?} */ targetElBCR = targetElement.getBoundingClientRect();
        var /** @type {?} */ placementPrimary = placement.split(' ')[0] || 'top';
        var /** @type {?} */ placementSecondary = placement.split(' ')[1] || 'center';
        var /** @type {?} */ targetElPosition = {
            height: targetElBCR.height || targetElement.offsetHeight,
            width: targetElBCR.width || targetElement.offsetWidth,
            top: 0,
            bottom: targetElBCR.height || targetElement.offsetHeight,
            left: 0,
            right: targetElBCR.width || targetElement.offsetWidth
        };
        var /** @type {?} */ shiftHeight = {
            top: hostElPosition.top,
            center: hostElPosition.top +
                hostElPosition.height / 2 -
                targetElPosition.height / 2,
            bottom: hostElPosition.top + hostElPosition.height
        };
        var /** @type {?} */ shiftWidth = {
            left: hostElPosition.left,
            center: hostElPosition.left +
                hostElPosition.width / 2 -
                targetElPosition.width / 2,
            right: hostElPosition.left + hostElPosition.width
        };
        if (placementPrimary === 'auto') {
            var /** @type {?} */ newPlacementPrimary = this.autoPosition(targetElPosition, hostElPosition, targetElement, placementSecondary);
            if (!newPlacementPrimary)
                newPlacementPrimary = this.autoPosition(targetElPosition, hostElPosition, targetElement);
            if (newPlacementPrimary)
                placementPrimary = newPlacementPrimary;
            targetElement.classList.add(placementPrimary);
        }
        switch (placementPrimary) {
            case 'top':
                targetElPosition.top =
                    hostElPosition.top -
                        (targetElPosition.height +
                            parseFloat(targetElStyles.marginBottom));
                targetElPosition.bottom +=
                    hostElPosition.top - targetElPosition.height;
                targetElPosition.left = shiftWidth[placementSecondary];
                targetElPosition.right += shiftWidth[placementSecondary];
                break;
            case 'bottom':
                targetElPosition.top = shiftHeight[placementPrimary];
                targetElPosition.bottom += shiftHeight[placementPrimary];
                targetElPosition.left = shiftWidth[placementSecondary];
                targetElPosition.right += shiftWidth[placementSecondary];
                break;
            case 'left':
                targetElPosition.top = shiftHeight[placementSecondary];
                targetElPosition.bottom += shiftHeight[placementSecondary];
                targetElPosition.left =
                    hostElPosition.left -
                        (targetElPosition.width + parseFloat(targetElStyles.marginRight));
                targetElPosition.right +=
                    hostElPosition.left - targetElPosition.width;
                break;
            case 'right':
                targetElPosition.top = shiftHeight[placementSecondary];
                targetElPosition.bottom += shiftHeight[placementSecondary];
                targetElPosition.left = shiftWidth[placementPrimary];
                targetElPosition.right += shiftWidth[placementPrimary];
                break;
        }
        targetElPosition.top = Math.round(targetElPosition.top);
        targetElPosition.bottom = Math.round(targetElPosition.bottom);
        targetElPosition.left = Math.round(targetElPosition.left);
        targetElPosition.right = Math.round(targetElPosition.right);
        return targetElPosition;
    };
    /**
     * @param {?} targetElPosition
     * @param {?} hostElPosition
     * @param {?} targetElement
     * @param {?=} preferredPosition
     * @return {?}
     */
    Positioning.prototype.autoPosition = /**
     * @param {?} targetElPosition
     * @param {?} hostElPosition
     * @param {?} targetElement
     * @param {?=} preferredPosition
     * @return {?}
     */
    function (targetElPosition, hostElPosition, targetElement, preferredPosition) {
        if ((!preferredPosition || preferredPosition === 'right') &&
            targetElPosition.left + hostElPosition.left - targetElPosition.width <
                0) {
            return 'right';
        }
        else if ((!preferredPosition || preferredPosition === 'top') &&
            targetElPosition.bottom +
                hostElPosition.bottom +
                targetElPosition.height >
                window.innerHeight) {
            return 'top';
        }
        else if ((!preferredPosition || preferredPosition === 'bottom') &&
            targetElPosition.top + hostElPosition.top - targetElPosition.height < 0) {
            return 'bottom';
        }
        else if ((!preferredPosition || preferredPosition === 'left') &&
            targetElPosition.right +
                hostElPosition.right +
                targetElPosition.width >
                window.innerWidth) {
            return 'left';
        }
        return null;
    };
    /**
     * @param {?} element
     * @return {?}
     */
    Positioning.prototype.getAllStyles = /**
     * @param {?} element
     * @return {?}
     */
    function (element) {
        return window.getComputedStyle(element);
    };
    /**
     * @param {?} element
     * @param {?} prop
     * @return {?}
     */
    Positioning.prototype.getStyle = /**
     * @param {?} element
     * @param {?} prop
     * @return {?}
     */
    function (element, prop) {
        return (/** @type {?} */ (this.getAllStyles(element)))[prop];
    };
    /**
     * @param {?} element
     * @return {?}
     */
    Positioning.prototype.isStaticPositioned = /**
     * @param {?} element
     * @return {?}
     */
    function (element) {
        return (this.getStyle(element, 'position') || 'static') === 'static';
    };
    /**
     * @param {?} element
     * @return {?}
     */
    Positioning.prototype.offsetParent = /**
     * @param {?} element
     * @return {?}
     */
    function (element) {
        var /** @type {?} */ offsetParentEl = /** @type {?} */ (element.offsetParent) || document.documentElement;
        while (offsetParentEl &&
            offsetParentEl !== document.documentElement &&
            this.isStaticPositioned(offsetParentEl)) {
            offsetParentEl = /** @type {?} */ (offsetParentEl.offsetParent);
        }
        return offsetParentEl || document.documentElement;
    };
    return Positioning;
}());
var /** @type {?} */ positionService = new Positioning();
/**
 * @param {?} hostElement
 * @param {?} targetElement
 * @param {?} placement
 * @param {?=} appendToBody
 * @return {?}
 */
function positionElements(hostElement, targetElement, placement, appendToBody) {
    var /** @type {?} */ pos = positionService.positionElements(hostElement, targetElement, placement, appendToBody);
    targetElement.style.top = pos.top + "px";
    targetElement.style.left = pos.left + "px";
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var PositioningService = /** @class */ (function () {
    function PositioningService() {
    }
    /**
     * @param {?} options
     * @return {?}
     */
    PositioningService.prototype.position = /**
     * @param {?} options
     * @return {?}
     */
    function (options) {
        var element = options.element, target = options.target, attachment = options.attachment, appendToBody = options.appendToBody;
        positionElements(_getHtmlElement(target), _getHtmlElement(element), attachment, appendToBody);
    };
    PositioningService.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] }
    ];
    return PositioningService;
}());
/**
 * @param {?} element
 * @return {?}
 */
function _getHtmlElement(element) {
    // it means that we got a selector
    if (typeof element === 'string') {
        return document.querySelector(element);
    }
    if (element instanceof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"]) {
        return element.nativeElement;
    }
    return element;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */



//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ "./node_modules/ngx-bootstrap/utils/fesm5/ngx-bootstrap-utils.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isBs3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LinkedList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return listenToTriggersV2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return registerOutsideClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return registerEscClick; });
/* unused harmony export OnChange */
/* unused harmony export setTheme */
/* unused harmony export Trigger */
/* unused harmony export Utils */
/* unused harmony export window */
/* unused harmony export document */
/* unused harmony export warnOnce */
/* unused harmony export parseTriggers */
/* unused harmony export listenToTriggers */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");


/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @copyright Valor Software
 * @copyright Angular ng-bootstrap team
 */
var Trigger = /** @class */ (function () {
    function Trigger(open, close) {
        this.open = open;
        this.close = close || open;
    }
    /**
     * @return {?}
     */
    Trigger.prototype.isManual = /**
     * @return {?}
     */
    function () {
        return this.open === 'manual' || this.close === 'manual';
    };
    return Trigger;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var /** @type {?} */ DEFAULT_ALIASES = {
    hover: ['mouseover', 'mouseout'],
    focus: ['focusin', 'focusout']
};
/**
 * @param {?} triggers
 * @param {?=} aliases
 * @return {?}
 */
function parseTriggers(triggers, aliases) {
    if (aliases === void 0) { aliases = DEFAULT_ALIASES; }
    var /** @type {?} */ trimmedTriggers = (triggers || '').trim();
    if (trimmedTriggers.length === 0) {
        return [];
    }
    var /** @type {?} */ parsedTriggers = trimmedTriggers
        .split(/\s+/)
        .map(function (trigger) { return trigger.split(':'); })
        .map(function (triggerPair) {
        var /** @type {?} */ alias = aliases[triggerPair[0]] || triggerPair;
        return new Trigger(alias[0], alias[1]);
    });
    var /** @type {?} */ manualTriggers = parsedTriggers.filter(function (triggerPair) {
        return triggerPair.isManual();
    });
    if (manualTriggers.length > 1) {
        throw new Error('Triggers parse error: only one manual trigger is allowed');
    }
    if (manualTriggers.length === 1 && parsedTriggers.length > 1) {
        throw new Error('Triggers parse error: manual trigger can\'t be mixed with other triggers');
    }
    return parsedTriggers;
}
/**
 * @param {?} renderer
 * @param {?} target
 * @param {?} triggers
 * @param {?} showFn
 * @param {?} hideFn
 * @param {?} toggleFn
 * @return {?}
 */
function listenToTriggers(renderer, /* tslint:disable-next-line: no-any */
/* tslint:disable-next-line: no-any */
target, triggers, showFn, hideFn, toggleFn) {
    var /** @type {?} */ parsedTriggers = parseTriggers(triggers);
    /* tslint:disable-next-line: no-any */
    var /** @type {?} */ listeners = [];
    if (parsedTriggers.length === 1 && parsedTriggers[0].isManual()) {
        return Function.prototype;
    }
    parsedTriggers.forEach(function (trigger) {
        if (trigger.open === trigger.close) {
            listeners.push(renderer.listen(target, trigger.open, toggleFn));
            return;
        }
        listeners.push(renderer.listen(target, trigger.open, showFn), renderer.listen(target, trigger.close, hideFn));
    });
    return function () {
        listeners.forEach(function (unsubscribeFn) { return unsubscribeFn(); });
    };
}
/**
 * @param {?} renderer
 * @param {?} options
 * @return {?}
 */
function listenToTriggersV2(renderer, options) {
    var /** @type {?} */ parsedTriggers = parseTriggers(options.triggers);
    var /** @type {?} */ target = options.target;
    // do nothing
    if (parsedTriggers.length === 1 && parsedTriggers[0].isManual()) {
        return Function.prototype;
    }
    // all listeners
    /* tslint:disable-next-line: no-any */
    var /** @type {?} */ listeners = [];
    // lazy listeners registration
    var /** @type {?} */ _registerHide = [];
    var /** @type {?} */ registerHide = function () {
        // add hide listeners to unregister array
        _registerHide.forEach(function (fn) { return listeners.push(fn()); });
        // register hide events only once
        _registerHide.length = 0;
    };
    // register open\close\toggle listeners
    parsedTriggers.forEach(function (trigger) {
        var /** @type {?} */ useToggle = trigger.open === trigger.close;
        var /** @type {?} */ showFn = useToggle ? options.toggle : options.show;
        if (!useToggle) {
            _registerHide.push(function () {
                return renderer.listen(target, trigger.close, options.hide);
            });
        }
        listeners.push(renderer.listen(target, trigger.open, function () { return showFn(registerHide); }));
    });
    return function () {
        listeners.forEach(function (unsubscribeFn) { return unsubscribeFn(); });
    };
}
/**
 * @param {?} renderer
 * @param {?} options
 * @return {?}
 */
function registerOutsideClick(renderer, options) {
    if (!options.outsideClick) {
        return Function.prototype;
    }
    /* tslint:disable-next-line: no-any */
    return renderer.listen('document', 'click', function (event) {
        if (options.target && options.target.contains(event.target)) {
            return undefined;
        }
        if (options.targets &&
            options.targets.some(function (target) { return target.contains(event.target); })) {
            return undefined;
        }
        options.hide();
    });
}
/**
 * @param {?} renderer
 * @param {?} options
 * @return {?}
 */
function registerEscClick(renderer, options) {
    if (!options.outsideEsc) {
        return Function.prototype;
    }
    return renderer.listen('document', 'keyup.esc', function (event) {
        if (options.target && options.target.contains(event.target)) {
            return undefined;
        }
        if (options.targets &&
            options.targets.some(function (target) { return target.contains(event.target); })) {
            return undefined;
        }
        options.hide();
    });
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * JS version of browser APIs. This library can only run in the browser.
 */
var /** @type {?} */ win = (typeof window !== 'undefined' && window) || /** @type {?} */ ({});
var /** @type {?} */ document$1 = win.document;
var /** @type {?} */ location = win.location;
var /** @type {?} */ gc = win.gc ? function () { return win.gc(); } : function () { return null; };
var /** @type {?} */ performance = win.performance ? win.performance : null;
var /** @type {?} */ Event = win.Event;
var /** @type {?} */ MouseEvent = win.MouseEvent;
var /** @type {?} */ KeyboardEvent = win.KeyboardEvent;
var /** @type {?} */ EventTarget = win.EventTarget;
var /** @type {?} */ History = win.History;
var /** @type {?} */ Location = win.Location;
var /** @type {?} */ EventListener = win.EventListener;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var /** @type {?} */ guessedVersion;
/**
 * @return {?}
 */
function _guessBsVersion() {
    if (typeof document === 'undefined') {
        return null;
    }
    var /** @type {?} */ spanEl = document.createElement('span');
    spanEl.innerText = 'test bs version';
    document.body.appendChild(spanEl);
    spanEl.classList.add('d-none');
    var /** @type {?} */ rect = spanEl.getBoundingClientRect();
    document.body.removeChild(spanEl);
    if (!rect) {
        return 'bs3';
    }
    return rect.top === 0 ? 'bs4' : 'bs3';
}
/**
 * @param {?} theme
 * @return {?}
 */
function setTheme(theme) {
    guessedVersion = theme;
}
/**
 * @return {?}
 */
function isBs3() {
    if (typeof win === 'undefined') {
        return true;
    }
    if (typeof win.__theme === 'undefined') {
        if (guessedVersion) {
            return guessedVersion === 'bs3';
        }
        guessedVersion = _guessBsVersion();
        return guessedVersion === 'bs3';
    }
    return win.__theme !== 'bs4';
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @template T
 */
var  /**
 * @template T
 */
LinkedList = /** @class */ (function () {
    function LinkedList() {
        this.length = 0;
        this.asArray = [];
    }
    /**
     * @param {?} position
     * @return {?}
     */
    LinkedList.prototype.get = /**
     * @param {?} position
     * @return {?}
     */
    function (position) {
        if (this.length === 0 || position < 0 || position >= this.length) {
            return void 0;
        }
        var /** @type {?} */ current = this.head;
        for (var /** @type {?} */ index = 0; index < position; index++) {
            current = current.next;
        }
        return current.value;
    };
    /**
     * @param {?} value
     * @param {?=} position
     * @return {?}
     */
    LinkedList.prototype.add = /**
     * @param {?} value
     * @param {?=} position
     * @return {?}
     */
    function (value, position) {
        if (position === void 0) { position = this.length; }
        if (position < 0 || position > this.length) {
            throw new Error('Position is out of the list');
        }
        /* tslint:disable-next-line: no-any*/
        var /** @type {?} */ node = {
            value: value,
            next: undefined,
            previous: undefined
        };
        if (this.length === 0) {
            this.head = node;
            this.tail = node;
            this.current = node;
        }
        else {
            if (position === 0) {
                // first node
                node.next = this.head;
                this.head.previous = node;
                this.head = node;
            }
            else if (position === this.length) {
                // last node
                this.tail.next = node;
                node.previous = this.tail;
                this.tail = node;
            }
            else {
                // node in middle
                var /** @type {?} */ currentPreviousNode = this.getNode(position - 1);
                var /** @type {?} */ currentNextNode = currentPreviousNode.next;
                currentPreviousNode.next = node;
                currentNextNode.previous = node;
                node.previous = currentPreviousNode;
                node.next = currentNextNode;
            }
        }
        this.length++;
        this.createInternalArrayRepresentation();
    };
    /**
     * @param {?=} position
     * @return {?}
     */
    LinkedList.prototype.remove = /**
     * @param {?=} position
     * @return {?}
     */
    function (position) {
        if (position === void 0) { position = 0; }
        if (this.length === 0 || position < 0 || position >= this.length) {
            throw new Error('Position is out of the list');
        }
        if (position === 0) {
            // first node
            this.head = this.head.next;
            if (this.head) {
                // there is no second node
                this.head.previous = undefined;
            }
            else {
                // there is no second node
                this.tail = undefined;
            }
        }
        else if (position === this.length - 1) {
            // last node
            this.tail = this.tail.previous;
            this.tail.next = undefined;
        }
        else {
            // middle node
            var /** @type {?} */ removedNode = this.getNode(position);
            removedNode.next.previous = removedNode.previous;
            removedNode.previous.next = removedNode.next;
        }
        this.length--;
        this.createInternalArrayRepresentation();
    };
    /**
     * @param {?} position
     * @param {?} value
     * @return {?}
     */
    LinkedList.prototype.set = /**
     * @param {?} position
     * @param {?} value
     * @return {?}
     */
    function (position, value) {
        if (this.length === 0 || position < 0 || position >= this.length) {
            throw new Error('Position is out of the list');
        }
        var /** @type {?} */ node = this.getNode(position);
        node.value = value;
        this.createInternalArrayRepresentation();
    };
    /**
     * @return {?}
     */
    LinkedList.prototype.toArray = /**
     * @return {?}
     */
    function () {
        return this.asArray;
    };
    /* tslint:disable-next-line: no-any*/
    /**
     * @param {?} fn
     * @return {?}
     */
    LinkedList.prototype.findAll = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        var /** @type {?} */ current = this.head;
        /* tslint:disable-next-line: no-any*/
        var /** @type {?} */ result = [];
        for (var /** @type {?} */ index = 0; index < this.length; index++) {
            if (fn(current.value, index)) {
                result.push({ index: index, value: current.value });
            }
            current = current.next;
        }
        return result;
    };
    // Array methods overriding start
    /**
     * @param {...?} args
     * @return {?}
     */
    LinkedList.prototype.push = /**
     * @param {...?} args
     * @return {?}
     */
    function () {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        /* tslint:disable-next-line: no-any*/
        args.forEach(function (arg) {
            _this.add(arg);
        });
        return this.length;
    };
    /**
     * @return {?}
     */
    LinkedList.prototype.pop = /**
     * @return {?}
     */
    function () {
        if (this.length === 0) {
            return undefined;
        }
        var /** @type {?} */ last = this.tail;
        this.remove(this.length - 1);
        return last.value;
    };
    /**
     * @param {...?} args
     * @return {?}
     */
    LinkedList.prototype.unshift = /**
     * @param {...?} args
     * @return {?}
     */
    function () {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        args.reverse();
        /* tslint:disable-next-line: no-any*/
        args.forEach(function (arg) {
            _this.add(arg, 0);
        });
        return this.length;
    };
    /**
     * @return {?}
     */
    LinkedList.prototype.shift = /**
     * @return {?}
     */
    function () {
        if (this.length === 0) {
            return undefined;
        }
        var /** @type {?} */ lastItem = this.head.value;
        this.remove();
        return lastItem;
    };
    /* tslint:disable-next-line: no-any*/
    /**
     * @param {?} fn
     * @return {?}
     */
    LinkedList.prototype.forEach = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        var /** @type {?} */ current = this.head;
        for (var /** @type {?} */ index = 0; index < this.length; index++) {
            fn(current.value, index);
            current = current.next;
        }
    };
    /**
     * @param {?} value
     * @return {?}
     */
    LinkedList.prototype.indexOf = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        var /** @type {?} */ current = this.head;
        var /** @type {?} */ position = 0;
        for (var /** @type {?} */ index = 0; index < this.length; index++) {
            if (current.value === value) {
                position = index;
                break;
            }
            current = current.next;
        }
        return position;
    };
    /* tslint:disable-next-line: no-any*/
    /**
     * @param {?} fn
     * @return {?}
     */
    LinkedList.prototype.some = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        var /** @type {?} */ current = this.head;
        var /** @type {?} */ result = false;
        while (current && !result) {
            if (fn(current.value)) {
                result = true;
                break;
            }
            current = current.next;
        }
        return result;
    };
    /* tslint:disable-next-line: no-any*/
    /**
     * @param {?} fn
     * @return {?}
     */
    LinkedList.prototype.every = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        var /** @type {?} */ current = this.head;
        var /** @type {?} */ result = true;
        while (current && result) {
            if (!fn(current.value)) {
                result = false;
            }
            current = current.next;
        }
        return result;
    };
    /**
     * @return {?}
     */
    LinkedList.prototype.toString = /**
     * @return {?}
     */
    function () {
        return '[Linked List]';
    };
    /* tslint:disable-next-line: no-any*/
    /**
     * @param {?} fn
     * @return {?}
     */
    LinkedList.prototype.find = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        var /** @type {?} */ current = this.head;
        var /** @type {?} */ result;
        for (var /** @type {?} */ index = 0; index < this.length; index++) {
            if (fn(current.value, index)) {
                result = current.value;
                break;
            }
            current = current.next;
        }
        return result;
    };
    /* tslint:disable-next-line: no-any*/
    /**
     * @param {?} fn
     * @return {?}
     */
    LinkedList.prototype.findIndex = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        var /** @type {?} */ current = this.head;
        var /** @type {?} */ result;
        for (var /** @type {?} */ index = 0; index < this.length; index++) {
            if (fn(current.value, index)) {
                result = index;
                break;
            }
            current = current.next;
        }
        return result;
    };
    /* tslint:disable-next-line: no-any*/
    /**
     * @param {?} position
     * @return {?}
     */
    LinkedList.prototype.getNode = /**
     * @param {?} position
     * @return {?}
     */
    function (position) {
        if (this.length === 0 || position < 0 || position >= this.length) {
            throw new Error('Position is out of the list');
        }
        var /** @type {?} */ current = this.head;
        for (var /** @type {?} */ index = 0; index < position; index++) {
            current = current.next;
        }
        return current;
    };
    /**
     * @return {?}
     */
    LinkedList.prototype.createInternalArrayRepresentation = /**
     * @return {?}
     */
    function () {
        /* tslint:disable-next-line: no-any*/
        var /** @type {?} */ outArray = [];
        var /** @type {?} */ current = this.head;
        while (current) {
            outArray.push(current.value);
            current = current.next;
        }
        this.asArray = outArray;
    };
    return LinkedList;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @param {?=} defaultValue
 * @return {?}
 */
function OnChange(defaultValue) {
    var /** @type {?} */ sufix = 'Change';
    /* tslint:disable-next-line: no-any */
    return function OnChangeHandler(target, propertyKey) {
        var /** @type {?} */ _key = " __" + propertyKey + "Value";
        Object.defineProperty(target, propertyKey, {
            /* tslint:disable-next-line: no-any */
            get: /**
             * @return {?}
             */
            function () {
                return this[_key];
            },
            /* tslint:disable-next-line: no-any */
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                var /** @type {?} */ prevValue = this[_key];
                this[_key] = value;
                if (prevValue !== value && this[propertyKey + sufix]) {
                    this[propertyKey + sufix].emit(value);
                }
            }
        });
    };
}
/* tslint:enable */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var Utils = /** @class */ (function () {
    function Utils() {
    }
    /* tslint:disable-next-line: no-any */
    /**
     * @param {?} element
     * @return {?}
     */
    Utils.reflow = /**
     * @param {?} element
     * @return {?}
     */
    function (element) {
        /* tslint:disable-next-line: no-any */
        (function (bs) { return bs; })(element.offsetHeight);
    };
    // source: https://github.com/jquery/jquery/blob/master/src/css/var/getStyles.js
    /* tslint:disable-next-line: no-any */
    /**
     * @param {?} elem
     * @return {?}
     */
    Utils.getStyles = /**
     * @param {?} elem
     * @return {?}
     */
    function (elem) {
        // Support: IE <=11 only, Firefox <=30 (#15098, #14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var /** @type {?} */ view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) {
            view = win;
        }
        return view.getComputedStyle(elem);
    };
    return Utils;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var /** @type {?} */ _messagesHash = {};
var /** @type {?} */ _hideMsg = typeof console === 'undefined' || !('warn' in console);
/**
 * @param {?} msg
 * @return {?}
 */
function warnOnce(msg) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["isDevMode"])() || _hideMsg || msg in _messagesHash) {
        return;
    }
    _messagesHash[msg] = true;
    /*tslint:disable-next-line*/
    console.warn(msg);
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */



//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ "./node_modules/ngx-clipboard/dist/ngx-clipboard.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_ngx_clipboard__ = __webpack_require__("./node_modules/ngx-clipboard/dist/src/ngx-clipboard.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ClipboardModule", function() { return __WEBPACK_IMPORTED_MODULE_0__src_ngx_clipboard__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ClipboardDirective", function() { return __WEBPACK_IMPORTED_MODULE_0__src_ngx_clipboard__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ClipboardService", function() { return __WEBPACK_IMPORTED_MODULE_0__src_ngx_clipboard__["c"]; });
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

//# sourceMappingURL=ngx-clipboard.js.map

/***/ }),

/***/ "./node_modules/ngx-clipboard/dist/src/clipboard.directive.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClipboardDirective; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__clipboard_service__ = __webpack_require__("./node_modules/ngx-clipboard/dist/src/clipboard.service.js");
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */


var ClipboardDirective = (function () {
    function ClipboardDirective(clipboardSrv) {
        this.clipboardSrv = clipboardSrv;
        this.cbOnSuccess = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.cbOnError = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
    }
    /**
     * @return {?}
     */
    ClipboardDirective.prototype.ngOnInit = /**
     * @return {?}
     */
    function () { };
    /**
     * @return {?}
     */
    ClipboardDirective.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.clipboardSrv.destroy();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    ClipboardDirective.prototype.onClick = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (!this.clipboardSrv.isSupported) {
            this.handleResult(false, undefined);
        }
        else if (this.targetElm && this.clipboardSrv.isTargetValid(this.targetElm)) {
            this.handleResult(this.clipboardSrv.copyFromInputElement(this.targetElm), this.targetElm.value);
        }
        else if (this.cbContent) {
            this.handleResult(this.clipboardSrv.copyFromContent(this.cbContent), this.cbContent);
        }
    };
    /**
     * Fires an event based on the copy operation result.
     * @param {?} succeeded
     * @param {?} copiedContent
     * @return {?}
     */
    ClipboardDirective.prototype.handleResult = /**
     * Fires an event based on the copy operation result.
     * @param {?} succeeded
     * @param {?} copiedContent
     * @return {?}
     */
    function (succeeded, copiedContent) {
        if (succeeded) {
            this.cbOnSuccess.emit({ isSuccess: true, content: copiedContent });
        }
        else {
            this.cbOnError.emit({ isSuccess: false });
        }
    };
    ClipboardDirective.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    // tslint:disable-next-line:directive-selector
                    selector: '[ngxClipboard]'
                },] },
    ];
    /** @nocollapse */
    ClipboardDirective.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__clipboard_service__["b" /* ClipboardService */], },
    ]; };
    ClipboardDirective.propDecorators = {
        "targetElm": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngxClipboard',] },],
        "cbContent": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "cbOnSuccess": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "cbOnError": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "onClick": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"], args: ['click', ['$event.target'],] },],
    };
    return ClipboardDirective;
}());

function ClipboardDirective_tsickle_Closure_declarations() {
    /** @type {!Array<{type: !Function, args: (undefined|!Array<?>)}>} */
    ClipboardDirective.decorators;
    /**
     * @nocollapse
     * @type {function(): !Array<(null|{type: ?, decorators: (undefined|!Array<{type: !Function, args: (undefined|!Array<?>)}>)})>}
     */
    ClipboardDirective.ctorParameters;
    /** @type {!Object<string,!Array<{type: !Function, args: (undefined|!Array<?>)}>>} */
    ClipboardDirective.propDecorators;
    /** @type {?} */
    ClipboardDirective.prototype.targetElm;
    /** @type {?} */
    ClipboardDirective.prototype.cbContent;
    /** @type {?} */
    ClipboardDirective.prototype.cbOnSuccess;
    /** @type {?} */
    ClipboardDirective.prototype.cbOnError;
    /** @type {?} */
    ClipboardDirective.prototype.clipboardSrv;
}
//# sourceMappingURL=clipboard.directive.js.map

/***/ }),

/***/ "./node_modules/ngx-clipboard/dist/src/clipboard.service.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ClipboardService; });
/* unused harmony export CLIPBOARD_SERVICE_PROVIDER_FACTORY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLIPBOARD_SERVICE_PROVIDER; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_platform_browser__ = __webpack_require__("./node_modules/@angular/platform-browser/esm5/platform-browser.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ngx_window_token__ = __webpack_require__("./node_modules/ngx-window-token/dist/ngx-window-token.js");
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */



var ClipboardService = (function () {
    function ClipboardService(document, window) {
        this.document = document;
        this.window = window;
    }
    Object.defineProperty(ClipboardService.prototype, "isSupported", {
        get: /**
         * @return {?}
         */
        function () {
            return !!this.document.queryCommandSupported && !!this.document.queryCommandSupported('copy');
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} element
     * @return {?}
     */
    ClipboardService.prototype.isTargetValid = /**
     * @param {?} element
     * @return {?}
     */
    function (element) {
        if (element instanceof HTMLInputElement || element instanceof HTMLTextAreaElement) {
            if (element.hasAttribute('disabled')) {
                // tslint:disable-next-line:max-line-length
                throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
            }
            return true;
        }
        throw new Error('Target should be input or textarea');
    };
    /**
     * copyFromInputElement
     * @param {?} targetElm
     * @return {?}
     */
    ClipboardService.prototype.copyFromInputElement = /**
     * copyFromInputElement
     * @param {?} targetElm
     * @return {?}
     */
    function (targetElm) {
        try {
            this.selectTarget(targetElm);
            var /** @type {?} */ re = this.copyText();
            this.clearSelection(targetElm, this.window);
            return re;
        }
        catch (/** @type {?} */ error) {
            return false;
        }
    };
    /**
     * Creates a fake textarea element, sets its value from `text` property,
     * and makes a selection on it.
     * @param {?} content
     * @return {?}
     */
    ClipboardService.prototype.copyFromContent = /**
     * Creates a fake textarea element, sets its value from `text` property,
     * and makes a selection on it.
     * @param {?} content
     * @return {?}
     */
    function (content) {
        if (!this.tempTextArea) {
            this.tempTextArea = this.createTempTextArea(this.document, this.window);
            this.document.body.appendChild(this.tempTextArea);
        }
        this.tempTextArea.value = content;
        return this.copyFromInputElement(this.tempTextArea);
    };
    /**
     * @return {?}
     */
    ClipboardService.prototype.destroy = /**
     * @return {?}
     */
    function () {
        if (this.tempTextArea) {
            this.document.body.removeChild(this.tempTextArea);
            this.tempTextArea = undefined;
        }
    };
    /**
     * @param {?} inputElement
     * @return {?}
     */
    ClipboardService.prototype.selectTarget = /**
     * @param {?} inputElement
     * @return {?}
     */
    function (inputElement) {
        inputElement.select();
        inputElement.setSelectionRange(0, inputElement.value.length);
        return inputElement.value.length;
    };
    /**
     * @return {?}
     */
    ClipboardService.prototype.copyText = /**
     * @return {?}
     */
    function () {
        return this.document.execCommand('copy');
    };
    /**
     * @param {?} inputElement
     * @param {?} window
     * @return {?}
     */
    ClipboardService.prototype.clearSelection = /**
     * @param {?} inputElement
     * @param {?} window
     * @return {?}
     */
    function (inputElement, window) {
        // tslint:disable-next-line:no-unused-expression
        inputElement && inputElement.blur();
        window.getSelection().removeAllRanges();
    };
    /**
     * @param {?} doc
     * @param {?} window
     * @return {?}
     */
    ClipboardService.prototype.createTempTextArea = /**
     * @param {?} doc
     * @param {?} window
     * @return {?}
     */
    function (doc, window) {
        var /** @type {?} */ isRTL = doc.documentElement.getAttribute('dir') === 'rtl';
        var /** @type {?} */ ta;
        ta = doc.createElement('textarea');
        // Prevent zooming on iOS
        ta.style.fontSize = '12pt';
        // Reset box model
        ta.style.border = '0';
        ta.style.padding = '0';
        ta.style.margin = '0';
        // Move element out of screen horizontally
        ta.style.position = 'absolute';
        ta.style[isRTL ? 'right' : 'left'] = '-9999px';
        // Move element to the same position vertically
        var /** @type {?} */ yPosition = window.pageYOffset || doc.documentElement.scrollTop;
        ta.style.top = yPosition + 'px';
        ta.setAttribute('readonly', '');
        return ta;
    };
    ClipboardService.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    ClipboardService.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_1__angular_platform_browser__["DOCUMENT"],] },] },
        { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_2_ngx_window_token__["a" /* WINDOW */],] },] },
    ]; };
    return ClipboardService;
}());

function ClipboardService_tsickle_Closure_declarations() {
    /** @type {!Array<{type: !Function, args: (undefined|!Array<?>)}>} */
    ClipboardService.decorators;
    /**
     * @nocollapse
     * @type {function(): !Array<(null|{type: ?, decorators: (undefined|!Array<{type: !Function, args: (undefined|!Array<?>)}>)})>}
     */
    ClipboardService.ctorParameters;
    /** @type {?} */
    ClipboardService.prototype.tempTextArea;
    /** @type {?} */
    ClipboardService.prototype.document;
    /** @type {?} */
    ClipboardService.prototype.window;
}
/**
 * @param {?} doc
 * @param {?} win
 * @param {?} parentDispatcher
 * @return {?}
 */
function CLIPBOARD_SERVICE_PROVIDER_FACTORY(doc, win, parentDispatcher) {
    return parentDispatcher || new ClipboardService(doc, win);
}
var /** @type {?} */ CLIPBOARD_SERVICE_PROVIDER = {
    deps: [/** @type {?} */ (__WEBPACK_IMPORTED_MODULE_1__angular_platform_browser__["DOCUMENT"]), /** @type {?} */ (__WEBPACK_IMPORTED_MODULE_2_ngx_window_token__["a" /* WINDOW */]), [new __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"](), new __WEBPACK_IMPORTED_MODULE_0__angular_core__["SkipSelf"](), ClipboardService]
    ],
    provide: ClipboardService,
    useFactory: CLIPBOARD_SERVICE_PROVIDER_FACTORY
};
//# sourceMappingURL=clipboard.service.js.map

/***/ }),

/***/ "./node_modules/ngx-clipboard/dist/src/ngx-clipboard.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ClipboardModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__clipboard_directive__ = __webpack_require__("./node_modules/ngx-clipboard/dist/src/clipboard.directive.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__clipboard_service__ = __webpack_require__("./node_modules/ngx-clipboard/dist/src/clipboard.service.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_common__ = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ngx_window_token__ = __webpack_require__("./node_modules/ngx-window-token/dist/ngx-window-token.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__clipboard_directive__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__clipboard_service__["b"]; });
/* unused harmony reexport CLIPBOARD_SERVICE_PROVIDER_FACTORY */
/* unused harmony reexport CLIPBOARD_SERVICE_PROVIDER */
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */







var ClipboardModule = (function () {
    function ClipboardModule() {
    }
    ClipboardModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_3__angular_core__["NgModule"], args: [{
                    imports: [__WEBPACK_IMPORTED_MODULE_2__angular_common__["CommonModule"], __WEBPACK_IMPORTED_MODULE_4_ngx_window_token__["b" /* WindowTokenModule */]],
                    // tslint:disable-next-line:object-literal-sort-keys
                    declarations: [__WEBPACK_IMPORTED_MODULE_0__clipboard_directive__["a" /* ClipboardDirective */]],
                    exports: [__WEBPACK_IMPORTED_MODULE_0__clipboard_directive__["a" /* ClipboardDirective */]],
                    providers: [__WEBPACK_IMPORTED_MODULE_1__clipboard_service__["a" /* CLIPBOARD_SERVICE_PROVIDER */]]
                },] },
    ];
    /** @nocollapse */
    ClipboardModule.ctorParameters = function () { return []; };
    return ClipboardModule;
}());

function ClipboardModule_tsickle_Closure_declarations() {
    /** @type {!Array<{type: !Function, args: (undefined|!Array<?>)}>} */
    ClipboardModule.decorators;
    /**
     * @nocollapse
     * @type {function(): !Array<(null|{type: ?, decorators: (undefined|!Array<{type: !Function, args: (undefined|!Array<?>)}>)})>}
     */
    ClipboardModule.ctorParameters;
}
//# sourceMappingURL=ngx-clipboard.js.map

/***/ }),

/***/ "./node_modules/ngx-daterangepicker-material/esm5/ngx-daterangepicker-material.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgxDaterangepickerMd", function() { return NgxDaterangepickerMd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DaterangepickerComponent", function() { return DaterangepickerComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DaterangepickerDirective", function() { return DaterangepickerDirective; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__("./node_modules/@angular/forms/esm5/forms.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("./node_modules/moment/moment.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_common__ = __webpack_require__("./node_modules/@angular/common/esm5/common.js");





var moment = __WEBPACK_IMPORTED_MODULE_2_moment__;
var SideEnum = {
    left: 'left',
    right: 'right',
};
var DaterangepickerComponent = (function () {
    function DaterangepickerComponent(el, _ref) {
        this.el = el;
        this._ref = _ref;
        this._old = { start: null, end: null };
        this.calendarVariables = { left: {}, right: {} };
        this.timepickerVariables = { left: {}, right: {} };
        this.daterangepicker = { start: new __WEBPACK_IMPORTED_MODULE_1__angular_forms__["FormControl"](), end: new __WEBPACK_IMPORTED_MODULE_1__angular_forms__["FormControl"]() };
        this.applyBtn = { disabled: false };
        this.startDate = moment().startOf('day');
        this.endDate = moment().endOf('day');
        this.dateLimit = null;
        this.sideEnum = SideEnum;
        this.minDate = null;
        this.maxDate = null;
        this.autoApply = false;
        this.singleDatePicker = false;
        this.showDropdowns = false;
        this.showWeekNumbers = false;
        this.showISOWeekNumbers = false;
        this.linkedCalendars = false;
        this.autoUpdateInput = true;
        this.alwaysShowCalendars = false;
        this.maxSpan = false;
        this.timePicker = false;
        this.timePicker24Hour = false;
        this.timePickerIncrement = 1;
        this.timePickerSeconds = false;
        this.showClearButton = false;
        this.firstMonthDayClass = null;
        this.lastMonthDayClass = null;
        this.emptyWeekRowClass = null;
        this.firstDayOfNextMonthClass = null;
        this.lastDayOfPreviousMonthClass = null;
        this.locale = {
            direction: 'ltr',
            separator: ' - ',
            weekLabel: 'W',
            applyLabel: 'Apply',
            cancelLabel: 'Cancel',
            customRangeLabel: 'Custom range',
            daysOfWeek: moment.weekdaysMin(),
            monthNames: moment.monthsShort(),
            firstDay: moment.localeData().firstDayOfWeek()
        };
        this.ranges = {};
        this.showCancel = false;
        this.keepCalendarOpeningWithRange = false;
        this.showRangeLabelOnInput = false;
        this.rangesArray = [];
        this.isShown = false;
        this.inline = true;
        this.leftCalendar = {};
        this.rightCalendar = {};
        this.showCalInRanges = false;
        this.options = {};
        this.choosedDate = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.rangeClicked = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.datesUpdated = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.updateMonthsInView();
    }
    DaterangepickerComponent.prototype.ngOnInit = function () {
        if (this.locale.firstDay != 0) {
            var iterator = this.locale.firstDay;
            while (iterator > 0) {
                this.locale.daysOfWeek.push(this.locale.daysOfWeek.shift());
                iterator--;
            }
        }
        if (this.inline) {
            this._old.start = this.startDate.clone();
            this._old.end = this.endDate.clone();
        }
        if (!this.locale.format) {
            if (this.timePicker) {
                this.locale.format = moment.localeData().longDateFormat('lll');
            }
            else {
                this.locale.format = moment.localeData().longDateFormat('L');
            }
        }
        this.renderCalendar(SideEnum.left);
        this.renderCalendar(SideEnum.right);
        this.renderRanges();
    };
    DaterangepickerComponent.prototype.renderRanges = function () {
        var start, end;
        if (typeof this.ranges === 'object') {
            for (var range in this.ranges) {
                if (typeof this.ranges[range][0] === 'string') {
                    start = moment(this.ranges[range][0], this.locale.format);
                }
                else {
                    start = moment(this.ranges[range][0]);
                }
                if (typeof this.ranges[range][1] === 'string') {
                    end = moment(this.ranges[range][1], this.locale.format);
                }
                else {
                    end = moment(this.ranges[range][1]);
                }
                if (this.minDate && start.isBefore(this.minDate)) {
                    start = this.minDate.clone();
                }
                var maxDate = this.maxDate;
                if (this.maxSpan && maxDate && start.clone().add(this.maxSpan).isAfter(maxDate)) {
                    maxDate = start.clone().add(this.maxSpan);
                }
                if (maxDate && end.isAfter(maxDate)) {
                    end = maxDate.clone();
                }
                if ((this.minDate && end.isBefore(this.minDate, this.timePicker ? 'minute' : 'day'))
                    || (maxDate && start.isAfter(maxDate, this.timePicker ? 'minute' : 'day'))) {
                    continue;
                }
                var elem = document.createElement('textarea');
                elem.innerHTML = range;
                var rangeHtml = elem.value;
                this.ranges[rangeHtml] = [start, end];
            }
            for (var range in this.ranges) {
                this.rangesArray.push(range);
            }
            if (this.showCustomRangeLabel) {
                this.rangesArray.push(this.locale.customRangeLabel);
            }
            this.showCalInRanges = (!this.rangesArray.length) || this.alwaysShowCalendars;
            if (!this.timePicker) {
                this.startDate = this.startDate.startOf('day');
                this.endDate = this.endDate.endOf('day');
            }
            if (this.timePicker && this.autoApply) {
                this.autoApply = false;
            }
        }
    };
    DaterangepickerComponent.prototype.renderTimePicker = function (side) {
        if (side == SideEnum.right && !this.endDate) {
            return;
        }
        var selected, minDate;
        var maxDate = this.maxDate;
        if (side === SideEnum.left) {
            selected = this.startDate.clone(), minDate = this.minDate;
        }
        else if (side === SideEnum.right) {
            selected = this.endDate.clone(), minDate = this.startDate;
        }
        var start = this.timePicker24Hour ? 0 : 1;
        var end = this.timePicker24Hour ? 23 : 12;
        this.timepickerVariables[side] = {
            hours: [],
            minutes: [],
            minutesLabel: [],
            seconds: [],
            secondsLabel: [],
            disabledHours: [],
            disabledMinutes: [],
            disabledSeconds: [],
            selectedHour: 0,
            selectedMinute: 0,
            selectedSecond: 0,
        };
        for (var i_1 = start; i_1 <= end; i_1++) {
            var i_in_24 = i_1;
            if (!this.timePicker24Hour) {
                i_in_24 = selected.hour() >= 12 ? (i_1 == 12 ? 12 : i_1 + 12) : (i_1 == 12 ? 0 : i_1);
            }
            var time_1 = selected.clone().hour(i_in_24);
            var disabled_1 = false;
            if (minDate && time_1.minute(59).isBefore(minDate)) {
                disabled_1 = true;
            }
            if (maxDate && time_1.minute(0).isAfter(maxDate)) {
                disabled_1 = true;
            }
            this.timepickerVariables[side].hours.push(i_1);
            if (i_in_24 == selected.hour() && !disabled_1) {
                this.timepickerVariables[side].selectedHour = i_1;
            }
            else if (disabled_1) {
                this.timepickerVariables[side].disabledHours.push(i_1);
            }
        }
        for (var i = 0; i < 60; i += this.timePickerIncrement) {
            var padded = i < 10 ? '0' + i : i;
            var time = selected.clone().minute(i);
            var disabled = false;
            if (minDate && time.second(59).isBefore(minDate)) {
                disabled = true;
            }
            if (maxDate && time.second(0).isAfter(maxDate)) {
                disabled = true;
            }
            this.timepickerVariables[side].minutes.push(i);
            this.timepickerVariables[side].minutesLabel.push(padded);
            if (selected.minute() == i && !disabled) {
                this.timepickerVariables[side].selectedMinute = i;
            }
            else if (disabled) {
                this.timepickerVariables[side].disabledMinutes.push(i);
            }
        }
        if (this.timePickerSeconds) {
            for (var i = 0; i < 60; i++) {
                var padded = i < 10 ? '0' + i : i;
                var time = selected.clone().second(i);
                var disabled = false;
                if (minDate && time.isBefore(minDate)) {
                    disabled = true;
                }
                if (maxDate && time.isAfter(maxDate)) {
                    disabled = true;
                }
                this.timepickerVariables[side].seconds.push(i);
                this.timepickerVariables[side].secondsLabel.push(padded);
                if (selected.second() == i && !disabled) {
                    this.timepickerVariables[side].selectedSecond = i;
                }
                else if (disabled) {
                    this.timepickerVariables[side].disabledSeconds.push(i);
                }
            }
        }
        if (!this.timePicker24Hour) {
            if (minDate && selected.clone().hour(12).minute(0).second(0).isBefore(minDate)) {
                this.timepickerVariables[side].amDisabled = true;
            }
            if (maxDate && selected.clone().hour(0).minute(0).second(0).isAfter(maxDate)) {
                this.timepickerVariables[side].pmDisabled = true;
            }
            if (selected.hour() >= 12) {
                this.timepickerVariables[side].ampmModel = 'PM';
            }
            else {
                this.timepickerVariables[side].ampmModel = 'AM';
            }
        }
        this.timepickerVariables[side].selected = selected;
    };
    DaterangepickerComponent.prototype.renderCalendar = function (side) {
        var mainCalendar = (side === SideEnum.left) ? this.leftCalendar : this.rightCalendar;
        var month = mainCalendar.month.month();
        var year = mainCalendar.month.year();
        var hour = mainCalendar.month.hour();
        var minute = mainCalendar.month.minute();
        var second = mainCalendar.month.second();
        var daysInMonth = moment([year, month]).daysInMonth();
        var firstDay = moment([year, month, 1]);
        var lastDay = moment([year, month, daysInMonth]);
        var lastMonth = moment(firstDay).subtract(1, 'month').month();
        var lastYear = moment(firstDay).subtract(1, 'month').year();
        var daysInLastMonth = moment([lastYear, lastMonth]).daysInMonth();
        var dayOfWeek = firstDay.day();
        var calendar = [];
        calendar.firstDay = firstDay;
        calendar.lastDay = lastDay;
        for (var i = 0; i < 6; i++) {
            calendar[i] = [];
        }
        var startDay = daysInLastMonth - dayOfWeek + this.locale.firstDay + 1;
        if (startDay > daysInLastMonth) {
            startDay -= 7;
        }
        if (dayOfWeek === this.locale.firstDay) {
            startDay = daysInLastMonth - 6;
        }
        var curDate = moment([lastYear, lastMonth, startDay, 12, minute, second]);
        for (var i = 0, col = 0, row = 0; i < 42; i++, col++, curDate = moment(curDate).add(24, 'hour')) {
            if (i > 0 && col % 7 === 0) {
                col = 0;
                row++;
            }
            calendar[row][col] = curDate.clone().hour(hour).minute(minute).second(second);
            curDate.hour(12);
            if (this.minDate && calendar[row][col].format('YYYY-MM-DD') === this.minDate.format('YYYY-MM-DD') &&
                calendar[row][col].isBefore(this.minDate) && side === 'left') {
                calendar[row][col] = this.minDate.clone();
            }
            if (this.maxDate && calendar[row][col].format('YYYY-MM-DD') === this.maxDate.format('YYYY-MM-DD') &&
                calendar[row][col].isAfter(this.maxDate) && side === 'right') {
                calendar[row][col] = this.maxDate.clone();
            }
        }
        if (side === SideEnum.left) {
            this.leftCalendar.calendar = calendar;
        }
        else {
            this.rightCalendar.calendar = calendar;
        }
        var minDate = side === 'left' ? this.minDate : this.startDate;
        var maxDate = this.maxDate;
        var selected = side === 'left' ? this.startDate : this.endDate;
        this.calendarVariables[side] = {
            month: month,
            year: year,
            hour: hour,
            minute: minute,
            second: second,
            daysInMonth: daysInMonth,
            firstDay: firstDay,
            lastDay: lastDay,
            lastMonth: lastMonth,
            lastYear: lastYear,
            daysInLastMonth: daysInLastMonth,
            dayOfWeek: dayOfWeek,
            calRows: Array.from(Array(6).keys()),
            calCols: Array.from(Array(7).keys()),
            classes: {},
            minDate: minDate,
            maxDate: maxDate,
            calendar: calendar
        };
        if (this.showDropdowns) {
            var currentMonth = calendar[1][1].month();
            var currentYear = calendar[1][1].year();
            var maxYear = (maxDate && maxDate.year()) || (currentYear + 5);
            var minYear = (minDate && minDate.year()) || (currentYear - 50);
            var inMinYear = currentYear === minYear;
            var inMaxYear = currentYear === maxYear;
            var years = [];
            for (var y = minYear; y <= maxYear; y++) {
                years.push(y);
            }
            this.calendarVariables[side].dropdowns = {
                currentMonth: currentMonth,
                currentYear: currentYear,
                maxYear: maxYear,
                minYear: minYear,
                inMinYear: inMinYear,
                inMaxYear: inMaxYear,
                monthArrays: Array.from(Array(12).keys()),
                yearArrays: years
            };
        }
        if (this.endDate === null && this.dateLimit) {
            var maxLimit = this.startDate.clone().add(this.dateLimit).endOf('day');
            if (!maxDate || maxLimit.isBefore(maxDate)) {
                maxDate = maxLimit;
            }
        }
        for (var row = 0; row < 6; row++) {
            this.calendarVariables[side].classes[row] = {};
            var rowClasses = [];
            if (this.emptyWeekRowClass && !this.hasCurrentMonthDays(month, calendar[row])) {
                rowClasses.push(this.emptyWeekRowClass);
            }
            for (var col = 0; col < 7; col++) {
                var classes = [];
                if (calendar[row][col].isSame(new Date(), 'day')) {
                    classes.push('today');
                }
                if (calendar[row][col].isoWeekday() > 5) {
                    classes.push('weekend');
                }
                if (calendar[row][col].month() !== calendar[1][1].month()) {
                    classes.push('off');
                    if (this.lastDayOfPreviousMonthClass && (calendar[row][col].month() < calendar[1][1].month() || calendar[1][1].month() === 0) && calendar[row][col].date() === daysInLastMonth) {
                        classes.push(this.lastDayOfPreviousMonthClass);
                    }
                    if (this.firstDayOfNextMonthClass && (calendar[row][col].month() > calendar[1][1].month() || calendar[row][col].month() === 0) && calendar[row][col].date() === 1) {
                        classes.push(this.firstDayOfNextMonthClass);
                    }
                }
                if (this.firstMonthDayClass && calendar[row][col].month() === calendar[1][1].month() && calendar[row][col].date() === calendar.firstDay.date()) {
                    classes.push(this.firstMonthDayClass);
                }
                if (this.lastMonthDayClass && calendar[row][col].month() === calendar[1][1].month() && calendar[row][col].date() === calendar.lastDay.date()) {
                    classes.push(this.lastMonthDayClass);
                }
                if (this.minDate && calendar[row][col].isBefore(this.minDate, 'day')) {
                    classes.push('off', 'disabled');
                }
                if (maxDate && calendar[row][col].isAfter(maxDate, 'day')) {
                    classes.push('off', 'disabled');
                }
                if (this.isInvalidDate(calendar[row][col])) {
                    classes.push('off', 'disabled');
                }
                if (this.startDate && calendar[row][col].format('YYYY-MM-DD') === this.startDate.format('YYYY-MM-DD')) {
                    classes.push('active', 'start-date');
                }
                if (this.endDate != null && calendar[row][col].format('YYYY-MM-DD') === this.endDate.format('YYYY-MM-DD')) {
                    classes.push('active', 'end-date');
                }
                if (this.endDate != null && calendar[row][col] > this.startDate && calendar[row][col] < this.endDate) {
                    classes.push('in-range');
                }
                var isCustom = this.isCustomDate(calendar[row][col]);
                if (isCustom !== false) {
                    if (typeof isCustom === 'string') {
                        classes.push(isCustom);
                    }
                    else {
                        Array.prototype.push.apply(classes, isCustom);
                    }
                }
                var cname = '', disabled = false;
                for (var i = 0; i < classes.length; i++) {
                    cname += classes[i] + ' ';
                    if (classes[i] === 'disabled') {
                        disabled = true;
                    }
                }
                if (!disabled) {
                    cname += 'available';
                }
                this.calendarVariables[side].classes[row][col] = cname.replace(/^\s+|\s+$/g, '');
            }
            this.calendarVariables[side].classes[row].classList = rowClasses.join(' ');
        }
    };
    DaterangepickerComponent.prototype.setStartDate = function (startDate) {
        if (typeof startDate === 'string') {
            this.startDate = moment(startDate, this.locale.format);
        }
        if (typeof startDate === 'object') {
            this.startDate = moment(startDate);
        }
        if (!this.timePicker) {
            this.startDate = this.startDate.startOf('day');
        }
        if (this.timePicker && this.timePickerIncrement) {
            this.startDate.minute(Math.round(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
        }
        if (this.minDate && this.startDate.isBefore(this.minDate)) {
            this.startDate = this.minDate.clone();
            if (this.timePicker && this.timePickerIncrement) {
                this.startDate.minute(Math.round(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
            }
        }
        if (this.maxDate && this.startDate.isAfter(this.maxDate)) {
            this.startDate = this.maxDate.clone();
            if (this.timePicker && this.timePickerIncrement) {
                this.startDate.minute(Math.floor(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
            }
        }
        if (!this.isShown) {
            this.updateElement();
        }
        this.updateMonthsInView();
    };
    DaterangepickerComponent.prototype.setEndDate = function (endDate) {
        if (typeof endDate === 'string') {
            this.endDate = moment(endDate, this.locale.format);
        }
        if (typeof endDate === 'object') {
            this.endDate = moment(endDate);
        }
        if (!this.timePicker) {
            this.endDate = this.endDate.add(1, 'd').startOf('day').subtract(1, 'second');
        }
        if (this.timePicker && this.timePickerIncrement) {
            this.endDate.minute(Math.round(this.endDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
        }
        if (this.endDate.isBefore(this.startDate)) {
            this.endDate = this.startDate.clone();
        }
        if (this.maxDate && this.endDate.isAfter(this.maxDate)) {
            this.endDate = this.maxDate.clone();
        }
        if (this.dateLimit && this.startDate.clone().add(this.dateLimit).isBefore(this.endDate)) {
            this.endDate = this.startDate.clone().add(this.dateLimit);
        }
        if (!this.isShown) {
        }
        this.updateMonthsInView();
        if (this.autoApply) {
            this.datesUpdated.emit({ startDate: this.startDate, endDate: this.endDate });
        }
    };
    DaterangepickerComponent.prototype.isInvalidDate = function (date) {
        return false;
    };
    DaterangepickerComponent.prototype.isCustomDate = function (date) {
        return false;
    };
    DaterangepickerComponent.prototype.updateView = function () {
        if (this.timePicker) {
            this.renderTimePicker(SideEnum.left);
            this.renderTimePicker(SideEnum.right);
        }
        this.updateMonthsInView();
        this.updateCalendars();
    };
    DaterangepickerComponent.prototype.updateMonthsInView = function () {
        if (this.endDate) {
            if (!this.singleDatePicker && this.leftCalendar.month && this.rightCalendar.month &&
                ((this.startDate && this.leftCalendar && this.startDate.format('YYYY-MM') === this.leftCalendar.month.format('YYYY-MM')) ||
                    (this.startDate && this.rightCalendar && this.startDate.format('YYYY-MM') === this.rightCalendar.month.format('YYYY-MM')))
                &&
                    (this.endDate.format('YYYY-MM') === this.leftCalendar.month.format('YYYY-MM') ||
                        this.endDate.format('YYYY-MM') === this.rightCalendar.month.format('YYYY-MM'))) {
                return;
            }
            if (this.startDate) {
                this.leftCalendar.month = this.startDate.clone().date(2);
                if (!this.linkedCalendars && (this.endDate.month() !== this.startDate.month() ||
                    this.endDate.year() !== this.startDate.year())) {
                    this.rightCalendar.month = this.endDate.clone().date(2);
                }
                else {
                    this.rightCalendar.month = this.startDate.clone().date(2).add(1, 'month');
                }
            }
        }
        else {
            if (this.leftCalendar.month.format('YYYY-MM') !== this.startDate.format('YYYY-MM') &&
                this.rightCalendar.month.format('YYYY-MM') !== this.startDate.format('YYYY-MM')) {
                this.leftCalendar.month = this.startDate.clone().date(2);
                this.rightCalendar.month = this.startDate.clone().date(2).add(1, 'month');
            }
        }
        if (this.maxDate && this.linkedCalendars && !this.singleDatePicker && this.rightCalendar.month > this.maxDate) {
            this.rightCalendar.month = this.maxDate.clone().date(2);
            this.leftCalendar.month = this.maxDate.clone().date(2).subtract(1, 'month');
        }
    };
    DaterangepickerComponent.prototype.updateCalendars = function () {
        this.renderCalendar(SideEnum.left);
        this.renderCalendar(SideEnum.right);
        if (this.endDate === null) {
            return;
        }
        this.calculateChosenLabel();
    };
    DaterangepickerComponent.prototype.updateElement = function () {
        if (!this.singleDatePicker && this.autoUpdateInput) {
            if (this.startDate && this.endDate) {
                if (this.rangesArray.length && this.showRangeLabelOnInput === true && this.chosenRange &&
                    this.locale.customRangeLabel !== this.chosenRange) {
                    this.chosenLabel = this.chosenRange;
                }
                else {
                    this.chosenLabel = this.startDate.format(this.locale.format) +
                        this.locale.separator + this.endDate.format(this.locale.format);
                }
            }
        }
        else if (this.autoUpdateInput) {
            this.chosenLabel = this.startDate.format(this.locale.format);
        }
    };
    DaterangepickerComponent.prototype.remove = function () {
        this.isShown = false;
    };
    DaterangepickerComponent.prototype.calculateChosenLabel = function () {
        var customRange = true;
        var i = 0;
        if (this.rangesArray.length > 0) {
            for (var range in this.ranges) {
                if (this.timePicker) {
                    var format = this.timePickerSeconds ? "YYYY-MM-DD HH:mm:ss" : "YYYY-MM-DD HH:mm";
                    if (this.startDate.format(format) == this.ranges[range][0].format(format) && this.endDate.format(format) == this.ranges[range][1].format(format)) {
                        customRange = false;
                        this.chosenRange = this.rangesArray[i];
                        break;
                    }
                }
                else {
                    if (this.startDate.format('YYYY-MM-DD') == this.ranges[range][0].format('YYYY-MM-DD') && this.endDate.format('YYYY-MM-DD') == this.ranges[range][1].format('YYYY-MM-DD')) {
                        customRange = false;
                        this.chosenRange = this.rangesArray[i];
                        break;
                    }
                }
                i++;
            }
            if (customRange) {
                if (this.showCustomRangeLabel) {
                    this.chosenRange = this.locale.customRangeLabel;
                }
                else {
                    this.chosenRange = null;
                }
                this.showCalInRanges = true;
            }
        }
        this.updateElement();
    };
    DaterangepickerComponent.prototype.clickApply = function (e) {
        if (!this.singleDatePicker && this.startDate && !this.endDate) {
            this.endDate = this.startDate.clone();
            this.calculateChosenLabel();
        }
        if (this.isInvalidDate && this.startDate && this.endDate) {
            var d = this.startDate.clone();
            while (d.isBefore(this.endDate)) {
                if (this.isInvalidDate(d)) {
                    this.endDate = d.subtract(1, 'days');
                    this.calculateChosenLabel();
                    break;
                }
                d.add(1, 'days');
            }
        }
        if (this.chosenLabel) {
            this.choosedDate.emit({ chosenLabel: this.chosenLabel, startDate: this.startDate, endDate: this.endDate });
        }
        this.datesUpdated.emit({ startDate: this.startDate, endDate: this.endDate });
        this.hide();
    };
    DaterangepickerComponent.prototype.clickCancel = function (e) {
        this.startDate = this._old.start;
        this.endDate = this._old.end;
        if (this.inline) {
            this.updateView();
        }
        this.hide();
    };
    DaterangepickerComponent.prototype.monthChanged = function (monthEvent, side) {
        var year = this.calendarVariables[side].dropdowns.currentYear;
        var month = parseInt(monthEvent.target.value, 10);
        this.monthOrYearChanged(month, year, side);
    };
    DaterangepickerComponent.prototype.yearChanged = function (yearEvent, side) {
        var month = this.calendarVariables[side].dropdowns.currentMonth;
        var year = parseInt(yearEvent.target.value, 10);
        this.monthOrYearChanged(month, year, side);
    };
    DaterangepickerComponent.prototype.timeChanged = function (timeEvent, side) {
        var hour = parseInt(this.timepickerVariables[side].selectedHour, 10);
        var minute = parseInt(this.timepickerVariables[side].selectedMinute, 10);
        var second = this.timePickerSeconds ? parseInt(this.timepickerVariables[side].selectedSecond, 10) : 0;
        if (!this.timePicker24Hour) {
            var ampm = this.timepickerVariables[side].ampmModel;
            if (ampm === 'PM' && hour < 12)
                hour += 12;
            if (ampm === 'AM' && hour === 12)
                hour = 0;
        }
        if (side === SideEnum.left) {
            var start = this.startDate.clone();
            start.hour(hour);
            start.minute(minute);
            start.second(second);
            this.setStartDate(start);
            if (this.singleDatePicker) {
                this.endDate = this.startDate.clone();
            }
            else if (this.endDate && this.endDate.format('YYYY-MM-DD') == start.format('YYYY-MM-DD') && this.endDate.isBefore(start)) {
                this.setEndDate(start.clone());
            }
        }
        else if (this.endDate) {
            var end = this.endDate.clone();
            end.hour(hour);
            end.minute(minute);
            end.second(second);
            this.setEndDate(end);
        }
        this.updateCalendars();
        this.renderTimePicker(SideEnum.left);
        this.renderTimePicker(SideEnum.right);
    };
    DaterangepickerComponent.prototype.monthOrYearChanged = function (month, year, side) {
        var isLeft = side === SideEnum.left;
        if (!isLeft) {
            if (year < this.startDate.year() || (year === this.startDate.year() && month < this.startDate.month())) {
                month = this.startDate.month();
                year = this.startDate.year();
            }
        }
        if (this.minDate) {
            if (year < this.minDate.year() || (year === this.minDate.year() && month < this.minDate.month())) {
                month = this.minDate.month();
                year = this.minDate.year();
            }
        }
        if (this.maxDate) {
            if (year > this.maxDate.year() || (year === this.maxDate.year() && month > this.maxDate.month())) {
                month = this.maxDate.month();
                year = this.maxDate.year();
            }
        }
        this.calendarVariables[side].dropdowns.currentYear = year;
        this.calendarVariables[side].dropdowns.currentMonth = month;
        if (isLeft) {
            this.leftCalendar.month.month(month).year(year);
            if (this.linkedCalendars) {
                this.rightCalendar.month = this.leftCalendar.month.clone().add(1, 'month');
            }
        }
        else {
            this.rightCalendar.month.month(month).year(year);
            if (this.linkedCalendars) {
                this.leftCalendar.month = this.rightCalendar.month.clone().subtract(1, 'month');
            }
        }
        this.updateCalendars();
    };
    DaterangepickerComponent.prototype.clickPrev = function (side) {
        if (side === SideEnum.left) {
            this.leftCalendar.month.subtract(1, 'month');
            if (this.linkedCalendars) {
                this.rightCalendar.month.subtract(1, 'month');
            }
        }
        else {
            this.rightCalendar.month.subtract(1, 'month');
        }
        this.updateCalendars();
    };
    DaterangepickerComponent.prototype.clickNext = function (side) {
        if (side === SideEnum.left) {
            this.leftCalendar.month.add(1, 'month');
        }
        else {
            this.rightCalendar.month.add(1, 'month');
            if (this.linkedCalendars) {
                this.leftCalendar.month.add(1, 'month');
            }
        }
        this.updateCalendars();
    };
    DaterangepickerComponent.prototype.clickDate = function (e, side, row, col) {
        if (e.target.tagName === 'TD') {
            if (!e.target.classList.contains('available')) {
                return;
            }
        }
        else if (e.target.tagName === 'SPAN') {
            if (!e.target.parentElement.classList.contains('available')) {
                return;
            }
        }
        if (this.rangesArray.length) {
            this.chosenRange = this.locale.customRangeLabel;
        }
        var date = side === SideEnum.left ? this.leftCalendar.calendar[row][col] : this.rightCalendar.calendar[row][col];
        if (this.endDate || date.isBefore(this.startDate, 'day')) {
            if (this.timePicker) {
                var hour_1 = parseInt(this.timepickerVariables['left'].selectedHour, 10);
                if (!this.timePicker24Hour) {
                    var ampm = this.timepickerVariables['left'].ampmModel;
                    if (ampm === 'PM' && hour_1 < 12)
                        hour_1 += 12;
                    if (ampm === 'AM' && hour_1 === 12)
                        hour_1 = 0;
                }
                var minute = parseInt(this.timepickerVariables['left'].selectedMinute, 10);
                var second = this.timePickerSeconds ? parseInt(this.timepickerVariables['left'].selectedSecond, 10) : 0;
                date = date.clone().hour(hour_1).minute(minute).second(second);
            }
            this.endDate = null;
            this.setStartDate(date.clone());
        }
        else if (!this.endDate && date.isBefore(this.startDate)) {
            this.setEndDate(this.startDate.clone());
        }
        else {
            if (this.timePicker) {
                var hour = parseInt(this.timepickerVariables['right'].selectedHour, 10);
                if (!this.timePicker24Hour) {
                    var ampm = this.timepickerVariables['right'].ampmModel;
                    if (ampm === 'PM' && hour < 12)
                        hour += 12;
                    if (ampm === 'AM' && hour === 12)
                        hour = 0;
                }
                var minute = parseInt(this.timepickerVariables['right'].selectedMinute, 10);
                var second = this.timePickerSeconds ? parseInt(this.timepickerVariables['right'].selectedSecond, 10) : 0;
                date = date.clone().hour(hour).minute(minute).second(second);
            }
            this.setEndDate(date.clone());
            if (this.autoApply) {
                this.calculateChosenLabel();
                this.clickApply();
            }
        }
        if (this.singleDatePicker) {
            this.setEndDate(this.startDate);
            this.updateElement();
            if (this.autoApply) {
                this.clickApply();
            }
        }
        this.updateView();
        e.stopPropagation();
    };
    DaterangepickerComponent.prototype.clickRange = function (e, label) {
        this.chosenRange = label;
        if (label == this.locale.customRangeLabel) {
            this.isShown = true;
            this.showCalInRanges = true;
        }
        else {
            var dates = this.ranges[label];
            this.startDate = dates[0].clone();
            this.endDate = dates[1].clone();
            if (this.showRangeLabelOnInput && label !== this.locale.customRangeLabel) {
                this.chosenLabel = label;
            }
            else {
                this.calculateChosenLabel();
            }
            this.showCalInRanges = (!this.rangesArray.length) || this.alwaysShowCalendars;
            if (!this.timePicker) {
                this.startDate.startOf('day');
                this.endDate.endOf('day');
            }
            if (!this.alwaysShowCalendars) {
                this.isShown = false;
            }
            this.rangeClicked.emit({ label: label, dates: dates });
            if (!this.keepCalendarOpeningWithRange) {
                this.clickApply();
            }
            else {
                this.renderCalendar(SideEnum.left);
                this.renderCalendar(SideEnum.right);
            }
        }
    };
    
    DaterangepickerComponent.prototype.show = function (e) {
        if (this.isShown) {
            return;
        }
        this._old.start = this.startDate.clone();
        this._old.end = this.endDate.clone();
        this.isShown = true;
        this.updateView();
    };
    DaterangepickerComponent.prototype.hide = function (e) {
        if (!this.isShown) {
            return;
        }
        if (!this.endDate) {
            if (this._old.start) {
                this.startDate = this._old.start.clone();
            }
            if (this._old.end) {
                this.endDate = this._old.end.clone();
            }
        }
        if (!this.startDate.isSame(this._old.start) || !this.endDate.isSame(this._old.end)) {
        }
        this.updateElement();
        this.isShown = false;
        this._ref.detectChanges();
    };
    DaterangepickerComponent.prototype.handleInternalClick = function (e) {
        e.stopPropagation();
    };
    DaterangepickerComponent.prototype.updateLocale = function (locale) {
        for (var key in locale) {
            if (locale.hasOwnProperty(key)) {
                this.locale[key] = locale[key];
            }
        }
    };
    DaterangepickerComponent.prototype.clear = function () {
        this.startDate = moment().startOf('day');
        this.endDate = moment().endOf('day');
        this.choosedDate.emit({ chosenLabel: '', startDate: null, endDate: null });
        this.datesUpdated.emit({ startDate: null, endDate: null });
        this.hide();
    };
    DaterangepickerComponent.prototype.disableRange = function (range) {
        var _this = this;
        if (range === this.locale.customRangeLabel) {
            return false;
        }
        var rangeMarkers = this.ranges[range];
        var areBothBefore = rangeMarkers.every(function (date) {
            if (!_this.minDate) {
                return false;
            }
            return date.isBefore(_this.minDate);
        });
        var areBothAfter = rangeMarkers.every(function (date) {
            if (!_this.maxDate) {
                return false;
            }
            return date.isAfter(_this.maxDate);
        });
        return (areBothBefore || areBothAfter);
    };
    DaterangepickerComponent.prototype.hasCurrentMonthDays = function (currentMonth, row) {
        for (var day = 0; day < 7; day++) {
            if (row[day].month() === currentMonth) {
                return true;
            }
        }
        return false;
    };
    return DaterangepickerComponent;
}());
DaterangepickerComponent.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                selector: 'ngx-daterangepicker-material',
                styles: [".md-drppicker{position:absolute;font-family:Roboto,sans-serif;color:inherit;border-radius:4px;width:278px;padding:4px;margin-top:-10px;overflow:hidden;z-index:1000;font-size:14px;background-color:#fff;-webkit-box-shadow:0 2px 4px 0 rgba(0,0,0,.16),0 2px 8px 0 rgba(0,0,0,.12);box-shadow:0 2px 4px 0 rgba(0,0,0,.16),0 2px 8px 0 rgba(0,0,0,.12)}.md-drppicker.double{width:auto}.md-drppicker.inline{position:relative;display:inline-block}.md-drppicker:after,.md-drppicker:before{position:absolute;display:inline-block;border-bottom-color:rgba(0,0,0,.2);content:''}.md-drppicker.openscenter:after,.md-drppicker.openscenter:before{left:0;right:0;width:0;margin-left:auto;margin-right:auto}.md-drppicker.single .calendar,.md-drppicker.single .ranges{float:none}.md-drppicker.shown{-webkit-transform:scale(1);transform:scale(1);-webkit-transition:.1s ease-in-out;transition:.1s ease-in-out;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.md-drppicker.shown.drops-up-left{-webkit-transform-origin:100% 100%;transform-origin:100% 100%}.md-drppicker.shown.drops-up-right{-webkit-transform-origin:0 100%;transform-origin:0 100%}.md-drppicker.shown.drops-down-left{-webkit-transform-origin:100% 0;transform-origin:100% 0}.md-drppicker.shown.drops-down-right{-webkit-transform-origin:0 0;transform-origin:0 0}.md-drppicker.shown.drops-down-center{-webkit-transform-origin:NaN;transform-origin:NaN}.md-drppicker.shown.drops-up-center{-webkit-transform-origin:50%;transform-origin:50%}.md-drppicker.shown .calendar{display:block}.md-drppicker.hidden{-webkit-transition:.1s;transition:.1s;-webkit-transform:scale(0);transform:scale(0);-webkit-transform-origin:0 0;transform-origin:0 0;cursor:default;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.md-drppicker.hidden.drops-up-left{-webkit-transform-origin:100% 100%;transform-origin:100% 100%}.md-drppicker.hidden.drops-up-right{-webkit-transform-origin:0 100%;transform-origin:0 100%}.md-drppicker.hidden.drops-down-left{-webkit-transform-origin:100% 0;transform-origin:100% 0}.md-drppicker.hidden.drops-down-right{-webkit-transform-origin:0 0;transform-origin:0 0}.md-drppicker.hidden.drops-down-center{-webkit-transform-origin:NaN;transform-origin:NaN}.md-drppicker.hidden.drops-up-center{-webkit-transform-origin:50%;transform-origin:50%}.md-drppicker.hidden .calendar{display:none}.md-drppicker .calendar{max-width:270px;margin:4px}.md-drppicker .calendar.single .calendar-table{border:none}.md-drppicker .calendar td,.md-drppicker .calendar th{padding:0;white-space:nowrap;text-align:center;min-width:32px}.md-drppicker .calendar td span,.md-drppicker .calendar th span{pointer-events:none}.md-drppicker .calendar-table{border:1px solid #fff;padding:4px;border-radius:4px;background-color:#fff}.md-drppicker table{width:100%;margin:0}.md-drppicker th{color:#988c8c}.md-drppicker td,.md-drppicker th{text-align:center;border-radius:4px;border:1px solid transparent;white-space:nowrap;cursor:pointer;height:2em;width:2em}.md-drppicker td.available.prev,.md-drppicker th.available.prev{display:block;background-image:url(data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4Ig0KCSB2aWV3Qm94PSIwIDAgMy43IDYiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDMuNyA2IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxnPg0KCTxwYXRoIGQ9Ik0zLjcsMC43TDEuNCwzbDIuMywyLjNMMyw2TDAsM2wzLTNMMy43LDAuN3oiLz4NCjwvZz4NCjwvc3ZnPg0K);background-repeat:no-repeat;background-size:.5em;background-position:center;opacity:.8;-webkit-transition:background-color .2s;transition:background-color .2s;border-radius:2em}.md-drppicker td.available.prev:hover,.md-drppicker th.available.prev:hover{margin:0}.md-drppicker td.available.next,.md-drppicker th.available.next{-webkit-transform:rotate(180deg);transform:rotate(180deg);display:block;background-image:url(data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4Ig0KCSB2aWV3Qm94PSIwIDAgMy43IDYiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDMuNyA2IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxnPg0KCTxwYXRoIGQ9Ik0zLjcsMC43TDEuNCwzbDIuMywyLjNMMyw2TDAsM2wzLTNMMy43LDAuN3oiLz4NCjwvZz4NCjwvc3ZnPg0K);background-repeat:no-repeat;background-size:.5em;background-position:center;opacity:.8;-webkit-transition:background-color .2s;transition:background-color .2s;border-radius:2em}.md-drppicker td.available.next:hover,.md-drppicker th.available.next:hover{margin:0;-webkit-transform:rotate(180deg);transform:rotate(180deg)}.md-drppicker td.available:hover,.md-drppicker th.available:hover{background-color:#eee;border-color:transparent;color:inherit;background-repeat:no-repeat;background-size:.5em;background-position:center;margin:.25em 0;opacity:.8;border-radius:2em;-webkit-transform:scale(1);transform:scale(1);-webkit-transition:450ms cubic-bezier(.23,1,.32,1);transition:450ms cubic-bezier(.23,1,.32,1)}.md-drppicker td.week,.md-drppicker th.week{font-size:80%;color:#ccc}.md-drppicker td{margin:.25em 0;opacity:.8;-webkit-transition:450ms cubic-bezier(.23,1,.32,1);transition:450ms cubic-bezier(.23,1,.32,1);border-radius:2em;-webkit-transform:scale(1);transform:scale(1)}.md-drppicker td.off,.md-drppicker td.off.end-date,.md-drppicker td.off.in-range,.md-drppicker td.off.start-date{background-color:#fff;border-color:transparent;color:#999}.md-drppicker td.in-range{background-color:#dde2e4;border-color:transparent;color:#000;border-radius:0}.md-drppicker td.start-date{border-radius:2em 0 0 2em}.md-drppicker td.end-date{border-radius:0 2em 2em 0}.md-drppicker td.start-date.end-date{border-radius:4px}.md-drppicker td.active{-webkit-transition:background .3s ease-out;transition:background .3s ease-out;background:rgba(0,0,0,.1)}.md-drppicker td.active,.md-drppicker td.active:hover{background-color:#3f51b5;border-color:transparent;color:#fff}.md-drppicker th.month{width:auto}.md-drppicker option.disabled,.md-drppicker td.disabled{color:#999;cursor:not-allowed;text-decoration:line-through}.md-drppicker select{display:inline-block;background-color:rgba(255,255,255,.9);width:100%;padding:5px;border:1px solid #f2f2f2;border-radius:2px;height:3rem}.md-drppicker select.ampmselect,.md-drppicker select.hourselect,.md-drppicker select.minuteselect,.md-drppicker select.secondselect{width:50px;margin:0 auto;background:#eee;border:1px solid #eee;padding:2px;outline:0;font-size:12px}.md-drppicker select.monthselect,.md-drppicker select.yearselect{font-size:12px;height:auto;cursor:pointer;opacity:0;position:absolute;top:0;left:0;margin:0;padding:0}.md-drppicker th.month>div{position:relative;display:inline-block}.md-drppicker .calendar-time{text-align:center;margin:4px auto 0;line-height:30px;position:relative}.md-drppicker .calendar-time select.disabled{color:#ccc;cursor:not-allowed}.md-drppicker .label-input{border:1px solid #ccc;border-radius:4px;color:#555;height:30px;line-height:30px;display:block;vertical-align:middle;margin:0 auto 5px;padding:0 0 0 28px;width:100%}.md-drppicker .label-input.active{border:1px solid #08c;border-radius:4px}.md-drppicker .md-drppicker_input{position:relative;padding:0 30px 0 0}.md-drppicker .md-drppicker_input i,.md-drppicker .md-drppicker_input svg{position:absolute;left:8px;top:8px}.md-drppicker.rtl .label-input{padding-right:28px;padding-left:6px}.md-drppicker.rtl .md-drppicker_input i,.md-drppicker.rtl .md-drppicker_input svg{left:auto;right:8px}.md-drppicker .show-ranges .drp-calendar.left{border-left:1px solid #ddd}.md-drppicker .ranges{float:none;text-align:left;margin:0}.md-drppicker .ranges ul{list-style:none;margin:0 auto;padding:0;width:100%}.md-drppicker .ranges ul li{font-size:12px}.md-drppicker .ranges ul li button{padding:8px 12px;width:100%;background:0 0;border:none;text-align:left;cursor:pointer}.md-drppicker .ranges ul li button.active{background-color:#3f51b5;color:#fff}.md-drppicker .ranges ul li button[disabled]{opacity:.3}.md-drppicker .ranges ul li button:active{background:0 0}.md-drppicker .ranges ul li:hover{background-color:#eee}.md-drppicker .show-calendar .ranges{margin-top:8px}.md-drppicker [hidden]{display:none}.md-drppicker .buttons{text-align:right;margin:0 5px 5px 0}.md-drppicker .btn{position:relative;overflow:hidden;border-width:0;outline:0;padding:0 6px;cursor:pointer;border-radius:2px;-webkit-box-shadow:0 1px 4px rgba(0,0,0,.6);box-shadow:0 1px 4px rgba(0,0,0,.6);background-color:#3f51b5;color:#ecf0f1;-webkit-transition:background-color .4s;transition:background-color .4s;height:auto;text-transform:uppercase;line-height:36px;border:none}.md-drppicker .btn:focus,.md-drppicker .btn:hover{background-color:#3f51b5}.md-drppicker .btn>*{position:relative}.md-drppicker .btn span{display:block;padding:12px 24px}.md-drppicker .btn:before{content:\"\";position:absolute;top:50%;left:50%;display:block;width:0;padding-top:0;border-radius:100%;background-color:rgba(236,240,241,.3);-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.md-drppicker .btn:active:before{width:120%;padding-top:120%;-webkit-transition:width .2s ease-out,padding-top .2s ease-out;transition:width .2s ease-out,padding-top .2s ease-out}.md-drppicker .btn:disabled{opacity:.5}.md-drppicker .btn.btn-default{color:#000;background-color:#dcdcdc}.md-drppicker .clear{-webkit-box-shadow:none;box-shadow:none;background-color:#fff!important}.md-drppicker .clear svg{color:#eb3232;fill:currentColor}@media (min-width:564px){.md-drppicker{width:auto}.md-drppicker.single .calendar.left{clear:none}.md-drppicker.ltr{direction:ltr;text-align:left}.md-drppicker.ltr .calendar.left{clear:left}.md-drppicker.ltr .calendar.left .calendar-table{border-right:none;border-top-right-radius:0;border-bottom-right-radius:0;padding-right:12px}.md-drppicker.ltr .calendar.right{margin-left:0}.md-drppicker.ltr .calendar.right .calendar-table{border-left:none;border-top-left-radius:0;border-bottom-left-radius:0}.md-drppicker.ltr .left .md-drppicker_input,.md-drppicker.ltr .right .md-drppicker_input{padding-right:35px}.md-drppicker.ltr .calendar,.md-drppicker.ltr .ranges{float:left}.md-drppicker.rtl{direction:rtl;text-align:right}.md-drppicker.rtl .calendar.left{clear:right;margin-left:0}.md-drppicker.rtl .calendar.left .calendar-table{border-left:none;border-top-left-radius:0;border-bottom-left-radius:0}.md-drppicker.rtl .calendar.right{margin-right:0}.md-drppicker.rtl .calendar.right .calendar-table{border-right:none;border-top-right-radius:0;border-bottom-right-radius:0}.md-drppicker.rtl .calendar.left .calendar-table,.md-drppicker.rtl .left .md-drppicker_input{padding-left:12px}.md-drppicker.rtl .calendar,.md-drppicker.rtl .ranges{text-align:right;float:right}.drp-animate{-webkit-transform:translate(0);transform:translate(0);-webkit-transition:opacity .2s,-webkit-transform .2s;transition:transform .2s,opacity .2s,-webkit-transform .2s}.drp-animate.drp-picker-site-this{-webkit-transition-timing-function:linear;transition-timing-function:linear}.drp-animate.drp-animate-right{-webkit-transform:translateX(10%);transform:translateX(10%);opacity:0}.drp-animate.drp-animate-left{-webkit-transform:translateX(-10%);transform:translateX(-10%);opacity:0}}@media (min-width:730px){.md-drppicker .ranges{width:auto}.md-drppicker.ltr .ranges{float:left}.md-drppicker.rtl .ranges{float:right}.md-drppicker .calendar.left{clear:none!important}}"],
                template: "<div class=\"md-drppicker\" #pickerContainer\n[ngClass]=\"{\n    ltr: locale.direction === 'ltr',\n    rtl: this.locale.direction === 'rtl',\n    'shown': isShown || inline,\n    'hidden': !isShown && !inline,\n    'inline': inline,\n    'double': !singleDatePicker && showCalInRanges,\n    'show-ranges': rangesArray.length\n}\" [class]=\"'drops-' + drops + '-' + opens\">\n    <div class=\"ranges\">\n        <ul>\n          <li *ngFor=\"let range of rangesArray\">\n            <button type=\"button\"\n                    (click)=\"clickRange($event, range)\"\n                    [disabled]=\"disableRange(range)\"\n                    [ngClass]=\"{'active': range === chosenRange}\">{{range}}</button>\n          </li>\n        </ul>\n    </div>\n    <div class=\"calendar\" [ngClass]=\"{right: singleDatePicker, left: !singleDatePicker}\"\n        *ngIf=\"showCalInRanges\">\n        <div class=\"calendar-table\">\n            <table class=\"table-condensed\" *ngIf=\"calendarVariables\">\n                <thead>\n                    <tr>\n                        <th *ngIf=\"showWeekNumbers || showISOWeekNumbers\"></th>\n                        <ng-container *ngIf=\"!calendarVariables.left.minDate || calendarVariables.left.minDate.isBefore(calendarVariables.left.calendar.firstDay) && (!this.linkedCalendars || true)\">\n                            <th (click)=\"clickPrev(sideEnum.left)\" class=\"prev available\" >\n                            </th>\n                        </ng-container>\n                        <ng-container *ngIf=\"!(!calendarVariables.left.minDate || calendarVariables.left.minDate.isBefore(calendarVariables.left.calendar.firstDay) && (!this.linkedCalendars || true))\">\n                            <th></th>\n                        </ng-container>\n                        <th colspan=\"5\" class=\"month drp-animate\">\n                            <ng-container *ngIf=\"showDropdowns && calendarVariables.left.dropdowns\">\n                                <div>\n                                        {{this.locale.monthNames[calendarVariables?.left?.calendar[1][1].month()]}}\n                                        <select class=\"monthselect\" (change)=\"monthChanged($event, sideEnum.left)\">\n                                                <option\n                                                [disabled]=\"(calendarVariables.left.dropdowns.inMinYear && m < calendarVariables.left.minDate.month()) || (calendarVariables.left.dropdowns.inMaxYear && m > calendarVariables.left.maxDate.month())\"\n                                                *ngFor=\"let m of calendarVariables.left.dropdowns.monthArrays\" [value]=\"m\" [selected]=\"calendarVariables.left.dropdowns.currentMonth == m\">\n                                                    {{locale.monthNames[m]}}\n                                                </option>\n                                        </select>\n                                </div>\n                                <div>\n                                    {{ calendarVariables?.left?.calendar[1][1].format(\" YYYY\")}}\n                                    <select class=\"yearselect\"  (change)=\"yearChanged($event, sideEnum.left)\">\n                                        <option *ngFor=\"let y of calendarVariables.left.dropdowns.yearArrays\" [selected]=\"y === calendarVariables.left.dropdowns.currentYear\">\n                                            {{y}}\n                                        </option>\n                                    </select>\n                                </div>\n                            </ng-container>\n                            <ng-container *ngIf=\"!showDropdowns || !calendarVariables.left.dropdowns\">\n                                    {{this.locale.monthNames[calendarVariables?.left?.calendar[1][1].month()]}}  {{ calendarVariables?.left?.calendar[1][1].format(\" YYYY\")}}\n                            </ng-container>\n                        </th>\n                        <ng-container *ngIf=\"(!calendarVariables.left.maxDate || calendarVariables.left.maxDate.isAfter(calendarVariables.left.calendar.lastDay)) && (!linkedCalendars || singleDatePicker )\">\n                            <th class=\"next available\" (click)=\"clickNext(sideEnum.left)\">\n                            </th>\n                        </ng-container>\n                        <ng-container *ngIf=\"!((!calendarVariables.left.maxDate || calendarVariables.left.maxDate.isAfter(calendarVariables.left.calendar.lastDay)) && (!linkedCalendars || singleDatePicker ))\">\n                            <th></th>\n                        </ng-container>\n                    </tr>\n                    <tr>\n                        <th *ngIf=\"showWeekNumbers || showISOWeekNumbers\" class=\"week\"><span>{{this.locale.weekLabel}}</span></th>\n                        <th *ngFor=\"let dayofweek of locale.daysOfWeek\"><span>{{dayofweek}}</span></th>\n                    </tr>\n                </thead>\n                <tbody class=\"drp-animate\">\n                    <tr *ngFor=\"let row of calendarVariables.left.calRows\" [class]=\"calendarVariables.left.classes[row].classList\">\n                        <!-- add week number -->\n                        <td  class=\"week\" *ngIf=\"showWeekNumbers\">\n                            <span>{{calendarVariables.left.calendar[row][0].week()}}</span>\n                        </td>\n                        <td class=\"week\" *ngIf=\"showISOWeekNumbers\">\n                            <span>{{calendarVariables.left.calendar[row][0].isoWeek()}}</span>\n                        </td>\n                        <!-- cal -->\n                        <td *ngFor=\"let col of calendarVariables.left.calCols\" [class]=\"calendarVariables.left.classes[row][col]\" (click)=\"clickDate($event, sideEnum.left, row, col)\">\n                            <span>{{calendarVariables.left.calendar[row][col].date()}}</span>\n                        </td>\n                    </tr>\n                </tbody>\n            </table>\n        </div>\n        <div class=\"calendar-time\" *ngIf=\"timePicker\">\n            <select class=\"hourselect\" [disabled]=\"!endDate\" [(ngModel)]=\"timepickerVariables.left.selectedHour\" (ngModelChange)=\"timeChanged($event, sideEnum.left)\">\n                <option *ngFor=\"let i of timepickerVariables.left.hours\"\n                [value]=\"i\"\n                [disabled]=\"timepickerVariables.left.disabledHours.indexOf(i) > -1\">{{i}}</option>\n            </select>\n            <select class=\"minuteselect\" [disabled]=\"!endDate\" [(ngModel)]=\"timepickerVariables.left.selectedMinute\" (ngModelChange)=\"timeChanged($event, sideEnum.left)\">\n                <option *ngFor=\"let i of timepickerVariables.left.minutes; let index = index;\"\n                [value]=\"i\"\n                [disabled]=\"timepickerVariables.left.disabledMinutes.indexOf(i) > -1\">{{timepickerVariables.left.minutesLabel[index]}}</option>\n            </select>\n            <select  *ngIf=\"timePickerSeconds\" class=\"secondselect\" [disabled]=\"!endDate\" [(ngModel)]=\"timepickerVariables.left.selectedSecond\" (ngModelChange)=\"timeChanged($event, sideEnum.left)\">\n                <option *ngFor=\"let i of timepickerVariables.left.seconds; let index = index;\"\n                [value]=\"i\"\n                [disabled]=\"timepickerVariables.left.disabledSeconds.indexOf(i) > -1\">{{timepickerVariables.left.secondsLabel[index]}}</option>\n            </select>\n            <select *ngIf=\"!timePicker24Hour\" class=\"ampmselect\" [(ngModel)]=\"timepickerVariables.left.ampmModel\" (ngModelChange)=\"timeChanged($event, sideEnum.left)\">\n                <option value=\"AM\" [disabled]=\"timepickerVariables.left.amDisabled\">AM</option>\n                <option value=\"PM\"  [disabled]=\"timepickerVariables.left.pmDisabled\">PM</option>\n            </select>\n        </div>\n    </div>\n    <div class=\"calendar right\"\n        *ngIf=\"showCalInRanges && !singleDatePicker\"\n        >\n        <div class=\"calendar-table\">\n            <table class=\"table-condensed\" *ngIf=\"calendarVariables\">\n                <thead>\n                    <tr>\n                        <th *ngIf=\"showWeekNumbers || showISOWeekNumbers\"></th>\n                        <ng-container *ngIf=\"(!calendarVariables.right.minDate || calendarVariables.right.minDate.isBefore(calendarVariables.right.calendar.firstDay)) && (!this.linkedCalendars)\">\n                            <th (click)=\"clickPrev(sideEnum.right)\" class=\"prev available\" >\n                            </th>\n                        </ng-container>\n                        <ng-container *ngIf=\"!((!calendarVariables.right.minDate || calendarVariables.right.minDate.isBefore(calendarVariables.right.calendar.firstDay)) && (!this.linkedCalendars))\">\n                            <th></th>\n                        </ng-container>\n                        <th colspan=\"5\" class=\"month\">\n                            <ng-container *ngIf=\"showDropdowns && calendarVariables.right.dropdowns\">\n                                <div>\n                                    {{this.locale.monthNames[calendarVariables?.right?.calendar[1][1].month()]}}\n                                    <select class=\"monthselect\" (change)=\"monthChanged($event, sideEnum.right)\">\n                                            <option\n                                            [disabled]=\"(calendarVariables.right.dropdowns.inMinYear && m < calendarVariables.right.minDate.month()) || (calendarVariables.right.dropdowns.inMaxYear && m > calendarVariables.right.maxDate.month())\"\n                                            *ngFor=\"let m of calendarVariables.right.dropdowns.monthArrays\" [value]=\"m\" [selected]=\"calendarVariables.right.dropdowns.currentMonth == m\">\n                                                {{locale.monthNames[m]}}\n                                            </option>\n                                    </select>\n                                </div>\n                                <div>\n                                        {{ calendarVariables?.right?.calendar[1][1].format(\" YYYY\")}}\n                                        <select class=\"yearselect\" (change)=\"yearChanged($event, sideEnum.right)\">\n                                        <option *ngFor=\"let y of calendarVariables.right.dropdowns.yearArrays\" [selected]=\"y === calendarVariables.right.dropdowns.currentYear\">\n                                            {{y}}\n                                        </option>\n                                    </select>\n                                </div>\n                            </ng-container>\n                            <ng-container *ngIf=\"!showDropdowns || !calendarVariables.right.dropdowns\">\n                                    {{this.locale.monthNames[calendarVariables?.right?.calendar[1][1].month()]}}  {{ calendarVariables?.right?.calendar[1][1].format(\" YYYY\")}}\n                            </ng-container>\n                        </th>\n                            <ng-container *ngIf=\"!calendarVariables.right.maxDate || calendarVariables.right.maxDate.isAfter(calendarVariables.right.calendar.lastDay) && (!linkedCalendars || singleDatePicker || true)\">\n                                <th class=\"next available\" (click)=\"clickNext(sideEnum.right)\">\n                                </th>\n                            </ng-container>\n                            <ng-container *ngIf=\"!(!calendarVariables.right.maxDate || calendarVariables.right.maxDate.isAfter(calendarVariables.right.calendar.lastDay) && (!linkedCalendars || singleDatePicker || true))\">\n                                <th></th>\n                            </ng-container>\n                    </tr>\n\n                    <tr>\n                        <th *ngIf=\"showWeekNumbers || showISOWeekNumbers\" class=\"week\"><span>{{this.locale.weekLabel}}</span></th>\n                        <th *ngFor=\"let dayofweek of locale.daysOfWeek\"><span>{{dayofweek}}</span></th>\n                    </tr>\n                </thead>\n                <tbody>\n                    <tr *ngFor=\"let row of calendarVariables.right.calRows\" [class]=\"calendarVariables.right.classes[row].classList\">\n                        <td class=\"week\" *ngIf=\"showWeekNumbers\">\n                            <span>{{calendarVariables.right.calendar[row][0].week()}}</span>\n                        </td>\n                        <td class=\"week\" *ngIf=\"showISOWeekNumbers\">\n                            <span>{{calendarVariables.right.calendar[row][0].isoWeek()}}</span>\n                        </td>\n                        <td *ngFor=\"let col of calendarVariables.right.calCols\" [class]=\"calendarVariables.right.classes[row][col]\" (click)=\"clickDate($event, sideEnum.right, row, col)\">\n                            <span>{{calendarVariables.right.calendar[row][col].date()}}</span>\n                        </td>\n                    </tr>\n                </tbody>\n            </table>\n        </div>\n        <div class=\"calendar-time\" *ngIf=\"timePicker\">\n            <select class=\"hourselect\" [disabled]=\"!endDate\" [(ngModel)]=\"timepickerVariables.right.selectedHour\" (ngModelChange)=\"timeChanged($event, sideEnum.right)\">\n                <option *ngFor=\"let i of timepickerVariables.right.hours\"\n                [value]=\"i\"\n                [disabled]=\"timepickerVariables.right.disabledHours.indexOf(i) > -1\">{{i}}</option>\n            </select>\n            <select class=\"minuteselect\" [disabled]=\"!endDate\" [(ngModel)]=\"timepickerVariables.right.selectedMinute\" (ngModelChange)=\"timeChanged($event, sideEnum.right)\">\n                <option *ngFor=\"let i of timepickerVariables.right.minutes; let index = index;\"\n                [value]=\"i\"\n                [disabled]=\"timepickerVariables.right.disabledMinutes.indexOf(i) > -1\">{{timepickerVariables.right.minutesLabel[index]}}</option>\n            </select>\n            <select *ngIf=\"timePickerSeconds\" class=\"secondselect\" [disabled]=\"!endDate\" [(ngModel)]=\"timepickerVariables.right.selectedSecond\" (ngModelChange)=\"timeChanged($event, sideEnum.right)\">\n                <option *ngFor=\"let i of timepickerVariables.right.seconds; let index = index;\"\n                [value]=\"i\"\n                [disabled]=\"timepickerVariables.right.disabledSeconds.indexOf(i) > -1\">{{timepickerVariables.right.secondsLabel[index]}}</option>\n            </select>\n            <select *ngIf=\"!timePicker24Hour\" class=\"ampmselect\" [(ngModel)]=\"timepickerVariables.right.ampmModel\" (ngModelChange)=\"timeChanged($event, sideEnum.right)\">\n                <option value=\"AM\" [disabled]=\"timepickerVariables.right.amDisabled\">AM</option>\n                <option value=\"PM\"  [disabled]=\"timepickerVariables.right.pmDisabled\">PM</option>\n            </select>\n        </div>\n    </div>\n    <div class=\"buttons\" *ngIf=\"!autoApply && ( !rangesArray.length || (showCalInRanges && !singleDatePicker))\">\n        <div class=\"buttons_input\">\n            <button  *ngIf=\"showClearButton\" class=\"btn btn-default clear\" type=\"button\" (click)=\"clear()\" title=\"clear the date\">\n                <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"30\" height=\"30\" viewBox=\"0 -5 24 24\"><path d=\"M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z\"/></svg>\n            </button>\n            <button class=\"btn btn-default\" *ngIf=\"showCancel\" type=\"button\" (click)=\"clickCancel($event)\">{{locale.cancelLabel}}</button>\n            <button class=\"btn\"  [disabled]=\"applyBtn.disabled\" type=\"button\" (click)=\"clickApply($event)\">{{locale.applyLabel}}</button>\n        </div>\n    </div>\n</div>\n",
                host: {
                    '(click)': 'handleInternalClick($event)',
                },
                encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None,
                providers: [{
                        provide: __WEBPACK_IMPORTED_MODULE_1__angular_forms__["NG_VALUE_ACCESSOR"],
                        useExisting: Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return DaterangepickerComponent; }),
                        multi: true
                    }]
            },] },
];
DaterangepickerComponent.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"], },
]; };
DaterangepickerComponent.propDecorators = {
    "minDate": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    "maxDate": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    "autoApply": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    "singleDatePicker": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    "showDropdowns": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    "showWeekNumbers": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    "showISOWeekNumbers": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    "linkedCalendars": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    "autoUpdateInput": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    "alwaysShowCalendars": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    "maxSpan": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    "timePicker": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    "timePicker24Hour": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    "timePickerIncrement": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    "timePickerSeconds": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    "showClearButton": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    "firstMonthDayClass": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    "lastMonthDayClass": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    "emptyWeekRowClass": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    "firstDayOfNextMonthClass": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    "lastDayOfPreviousMonthClass": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    "locale": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    "ranges": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    "showCustomRangeLabel": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    "showCancel": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    "keepCalendarOpeningWithRange": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    "showRangeLabelOnInput": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    "drops": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    "opens": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    "choosedDate": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"], args: ['choosedDate',] },],
    "rangeClicked": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"], args: ['rangeClicked',] },],
    "datesUpdated": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"], args: ['datesUpdated',] },],
    "pickerContainer": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"], args: ['pickerContainer',] },],
    "isInvalidDate": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
};
var DaterangepickerDirective = (function () {
    function DaterangepickerDirective(viewContainerRef, _changeDetectorRef, _componentFactoryResolver, _el, _renderer, differs) {
        this.viewContainerRef = viewContainerRef;
        this._changeDetectorRef = _changeDetectorRef;
        this._componentFactoryResolver = _componentFactoryResolver;
        this._el = _el;
        this._renderer = _renderer;
        this.differs = differs;
        this._onChange = Function.prototype;
        this._onTouched = Function.prototype;
        this._validatorChange = Function.prototype;
        this.showCancel = false;
        this.timePicker = false;
        this.timePicker24Hour = false;
        this.timePickerIncrement = 1;
        this.timePickerSeconds = false;
        this._locale = {};
        this._endKey = 'endDate';
        this._startKey = 'startDate';
        this.notForChangesProperty = [
            'locale',
            'endKey',
            'startKey'
        ];
        this.onChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.rangeClicked = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.datesUpdated = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.drops = 'down';
        this.opens = 'right';
        var componentFactory = this._componentFactoryResolver.resolveComponentFactory(DaterangepickerComponent);
        viewContainerRef.clear();
        var componentRef = viewContainerRef.createComponent(componentFactory);
        this.picker = ((componentRef.instance));
        this.picker.inline = false;
    }
    Object.defineProperty(DaterangepickerDirective.prototype, "locale", {
        get: function () {
            return this._locale;
        },
        set: function (value) {
            if (value !== null) {
                this._locale = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DaterangepickerDirective.prototype, "startKey", {
        set: function (value) {
            if (value !== null) {
                this._startKey = value;
            }
            else {
                this._startKey = 'startDate';
            }
        },
        enumerable: true,
        configurable: true
    });
    
    Object.defineProperty(DaterangepickerDirective.prototype, "endKey", {
        set: function (value) {
            if (value !== null) {
                this._endKey = value;
            }
            else {
                this._endKey = 'endDate';
            }
        },
        enumerable: true,
        configurable: true
    });
    
    Object.defineProperty(DaterangepickerDirective.prototype, "value", {
        get: function () {
            return this._value || null;
        },
        set: function (val) {
            this._value = val;
            this._onChange(val);
            this._changeDetectorRef.markForCheck();
        },
        enumerable: true,
        configurable: true
    });
    DaterangepickerDirective.prototype.ngOnInit = function () {
        var _this = this;
        this.picker.rangeClicked.asObservable().subscribe(function (range) {
            _this.rangeClicked.emit(range);
        });
        this.picker.datesUpdated.asObservable().subscribe(function (range) {
            _this.datesUpdated.emit(range);
        });
        this.picker.choosedDate.asObservable().subscribe(function (change) {
            if (change) {
                var value = {};
                value[_this._startKey] = change.startDate;
                value[_this._endKey] = change.endDate;
                _this.value = value;
                _this.onChange.emit(value);
                if (typeof change.chosenLabel === 'string') {
                    _this._el.nativeElement.value = change.chosenLabel;
                }
            }
        });
        this.picker.firstMonthDayClass = this.firstMonthDayClass;
        this.picker.lastMonthDayClass = this.lastMonthDayClass;
        this.picker.emptyWeekRowClass = this.emptyWeekRowClass;
        this.picker.firstDayOfNextMonthClass = this.firstDayOfNextMonthClass;
        this.picker.lastDayOfPreviousMonthClass = this.lastDayOfPreviousMonthClass;
        this.picker.drops = this.drops;
        this.picker.opens = this.opens;
        this.localeDiffer = this.differs.find(this.locale).create();
    };
    DaterangepickerDirective.prototype.ngOnChanges = function (changes) {
        for (var change in changes) {
            if (changes.hasOwnProperty(change)) {
                if (this.notForChangesProperty.indexOf(change) === -1) {
                    this.picker[change] = changes[change].currentValue;
                }
            }
        }
    };
    DaterangepickerDirective.prototype.ngDoCheck = function () {
        if (this.localeDiffer) {
            var changes = this.localeDiffer.diff(this.locale);
            if (changes) {
                this.picker.updateLocale(this.locale);
            }
        }
    };
    DaterangepickerDirective.prototype.onBlur = function () {
        this._onTouched();
    };
    DaterangepickerDirective.prototype.open = function (event) {
        var _this = this;
        this.picker.show(event);
        setTimeout(function () {
            _this.setPosition();
        });
    };
    DaterangepickerDirective.prototype.hide = function (e) {
        this.picker.hide(e);
    };
    DaterangepickerDirective.prototype.toggle = function (e) {
        if (this.picker.isShown) {
            this.hide(e);
        }
        else {
            this.open(e);
        }
    };
    DaterangepickerDirective.prototype.clear = function () {
        this.picker.clear();
    };
    DaterangepickerDirective.prototype.writeValue = function (value) {
        this.value = value;
        this.setValue(value);
    };
    DaterangepickerDirective.prototype.registerOnChange = function (fn) {
        this._onChange = fn;
    };
    DaterangepickerDirective.prototype.registerOnTouched = function (fn) {
        this._onTouched = fn;
    };
    DaterangepickerDirective.prototype.setValue = function (val) {
        if (val) {
            if (val[this._startKey]) {
                this.picker.setStartDate(val[this._startKey]);
            }
            if (val[this._endKey]) {
                this.picker.setEndDate(val[this._endKey]);
            }
            this.picker.calculateChosenLabel();
            if (this.picker.chosenLabel) {
                this._el.nativeElement.value = this.picker.chosenLabel;
            }
        }
        else {
            this.picker.clear();
        }
    };
    DaterangepickerDirective.prototype.setPosition = function () {
        var style;
        var containerTop;
        var container = this.picker.pickerContainer.nativeElement;
        var element = this._el.nativeElement;
        if (this.drops && this.drops == 'up') {
            containerTop = (element.offsetTop - container.clientHeight) + 'px';
        }
        else {
            containerTop = 'auto';
        }
        if (this.opens == 'left') {
            style = {
                top: containerTop,
                left: (element.offsetLeft - container.clientWidth + element.clientWidth) + 'px',
                right: 'auto'
            };
        }
        else if (this.opens == 'center') {
            style = {
                top: containerTop,
                left: (element.offsetLeft + element.clientWidth / 2
                    - container.clientWidth / 2) + 'px',
                right: 'auto'
            };
        }
        else {
            style = {
                top: containerTop,
                left: element.offsetLeft + 'px',
                right: 'auto'
            };
        }
        if (style) {
            this._renderer.setStyle(container, 'top', style.top);
            this._renderer.setStyle(container, 'left', style.left);
            this._renderer.setStyle(container, 'right', style.right);
        }
    };
    DaterangepickerDirective.prototype.outsideClick = function (event, targetElement) {
        if (!targetElement) {
            return;
        }
        if (targetElement.classList.contains('ngx-daterangepicker-action')) {
            return;
        }
        var clickedInside = this._el.nativeElement.contains(targetElement);
        if (!clickedInside) {
            this.hide();
        }
    };
    return DaterangepickerDirective;
}());
DaterangepickerDirective.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: 'input[ngxDaterangepickerMd]',
                host: {
                    '(keyup.esc)': 'hide()',
                    '(blur)': 'onBlur()',
                    '(click)': 'open()'
                },
                providers: [
                    {
                        provide: __WEBPACK_IMPORTED_MODULE_1__angular_forms__["NG_VALUE_ACCESSOR"],
                        useExisting: Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return DaterangepickerDirective; }), multi: true
                    }
                ]
            },] },
];
DaterangepickerDirective.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ComponentFactoryResolver"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["KeyValueDiffers"], },
]; };
DaterangepickerDirective.propDecorators = {
    "minDate": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    "maxDate": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    "autoApply": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    "alwaysShowCalendars": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    "showCustomRangeLabel": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    "linkedCalendars": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    "singleDatePicker": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    "showWeekNumbers": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    "showISOWeekNumbers": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    "showDropdowns": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    "isInvalidDate": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    "isCustomDate": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    "showClearButton": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    "ranges": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    "opens": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    "drops": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    "lastMonthDayClass": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    "emptyWeekRowClass": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    "firstDayOfNextMonthClass": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    "lastDayOfPreviousMonthClass": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    "keepCalendarOpeningWithRange": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    "showRangeLabelOnInput": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    "showCancel": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    "timePicker": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    "timePicker24Hour": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    "timePickerIncrement": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    "timePickerSeconds": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    "locale": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    "_endKey": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    "startKey": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    "endKey": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    "onChange": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"], args: ['change',] },],
    "rangeClicked": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"], args: ['rangeClicked',] },],
    "datesUpdated": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"], args: ['datesUpdated',] },],
    "outsideClick": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"], args: ['document:click', ['$event', '$event.target'],] },],
};
var NgxDaterangepickerMd = (function () {
    function NgxDaterangepickerMd() {
    }
    return NgxDaterangepickerMd;
}());
NgxDaterangepickerMd.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                declarations: [
                    DaterangepickerComponent,
                    DaterangepickerDirective
                ],
                imports: [
                    __WEBPACK_IMPORTED_MODULE_3__angular_common__["CommonModule"],
                    __WEBPACK_IMPORTED_MODULE_1__angular_forms__["FormsModule"],
                    __WEBPACK_IMPORTED_MODULE_1__angular_forms__["ReactiveFormsModule"]
                ],
                providers: [],
                exports: [
                    DaterangepickerComponent,
                    DaterangepickerDirective
                ],
                entryComponents: [
                    DaterangepickerComponent
                ]
            },] },
];


//# sourceMappingURL=ngx-daterangepicker-material.js.map


/***/ }),

/***/ "./node_modules/ngx-dropzone/fesm5/ngx-dropzone.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgxDropzoneModule", function() { return NgxDropzoneModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgxDropzoneComponent", function() { return NgxDropzoneComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgxDropzonePreviewComponent", function() { return NgxDropzonePreviewComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgxDropzoneImagePreviewComponent", function() { return NgxDropzoneImagePreviewComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgxDropzoneVideoPreviewComponent", function() { return NgxDropzoneVideoPreviewComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgxDropzoneRemoveBadgeComponent", function() { return NgxDropzoneRemoveBadgeComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵb", function() { return NgxDropzoneLabelDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵa", function() { return NgxDropzoneService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_platform_browser__ = __webpack_require__("./node_modules/@angular/platform-browser/esm5/platform-browser.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_common__ = __webpack_require__("./node_modules/@angular/common/esm5/common.js");





/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NgxDropzoneLabelDirective = /** @class */ (function () {
    function NgxDropzoneLabelDirective() {
    }
    NgxDropzoneLabelDirective.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'ngx-dropzone-label'
                },] },
    ];
    return NgxDropzoneLabelDirective;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Coerces a data-bound value (typically a string) to a boolean.
 * Taken from https://github.com/angular/components/blob/master/src/cdk/coercion/boolean-property.ts
 * @param {?} value
 * @return {?}
 */
function coerceBooleanProperty(value) {
    return value != null && "" + value !== 'false';
}
/**
 * Whether the provided value is considered a number.
 * Taken from https://github.com/angular/components/blob/master/src/cdk/coercion/number-property.ts
 * @param {?} value
 * @return {?}
 */
function coerceNumberProperty(value) {
    // parseFloat(value) handles most of the cases we're interested in (it treats null, empty string,
    // and other non-number values as NaN, where Number just uses 0) but it considers the string
    // '123hello' to be a valid number. Therefore we also check if Number(value) is NaN.
    return (!isNaN(parseFloat((/** @type {?} */ (value)))) && !isNaN(Number(value))) ? Number(value) : null;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
var KEY_CODE = {
    BACKSPACE: 8,
    DELETE: 46,
};
KEY_CODE[KEY_CODE.BACKSPACE] = 'BACKSPACE';
KEY_CODE[KEY_CODE.DELETE] = 'DELETE';
var NgxDropzonePreviewComponent = /** @class */ (function () {
    function NgxDropzonePreviewComponent(sanitizer) {
        this.sanitizer = sanitizer;
        this._removable = false;
        /**
         * Emitted when the element should be removed.
         */
        this.removed = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
         * Make the preview item focusable using the tab key.
         */
        this.tabIndex = 0;
    }
    Object.defineProperty(NgxDropzonePreviewComponent.prototype, "removable", {
        /** Allow the user to remove files. */
        get: /**
         * Allow the user to remove files.
         * @return {?}
         */
        function () {
            return this._removable;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._removable = coerceBooleanProperty(value);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} event
     * @return {?}
     */
    NgxDropzonePreviewComponent.prototype.keyEvent = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        switch (event.keyCode) {
            case KEY_CODE.BACKSPACE:
            case KEY_CODE.DELETE:
                this.remove();
                break;
            default:
                break;
        }
    };
    Object.defineProperty(NgxDropzonePreviewComponent.prototype, "hostStyle", {
        /** We use the HostBinding to pass these common styles to child components. */
        get: /**
         * We use the HostBinding to pass these common styles to child components.
         * @return {?}
         */
        function () {
            /** @type {?} */
            var styles = "\n\t\t\tdisplay: flex;\n\t\t\theight: 140px;\n\t\t\tmin-height: 140px;\n\t\t\tmin-width: 180px;\n\t\t\tmax-width: 180px;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\t\t\tpadding: 0 20px;\n\t\t\tmargin: 10px;\n\t\t\tborder-radius: 5px;\n\t\t\tposition: relative;\n\t\t";
            return this.sanitizer.bypassSecurityTrustStyle(styles);
        },
        enumerable: true,
        configurable: true
    });
    /** Remove method to be used from the template. */
    /**
     * Remove method to be used from the template.
     * @param {?} event
     * @return {?}
     */
    NgxDropzonePreviewComponent.prototype._remove = /**
     * Remove method to be used from the template.
     * @param {?} event
     * @return {?}
     */
    function (event) {
        event.stopPropagation();
        this.remove();
    };
    /** Remove the preview item (use from component code). */
    /**
     * Remove the preview item (use from component code).
     * @return {?}
     */
    NgxDropzonePreviewComponent.prototype.remove = /**
     * Remove the preview item (use from component code).
     * @return {?}
     */
    function () {
        if (this._removable) {
            this.removed.next(this.file);
        }
    };
    /**
     * @protected
     * @return {?}
     */
    NgxDropzonePreviewComponent.prototype.readFile = /**
     * @protected
     * @return {?}
     */
    function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var _this = this;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["e" /* __generator */])(this, function (_a) {
                return [2 /*return*/, new Promise((/**
                     * @param {?} resolve
                     * @param {?} reject
                     * @return {?}
                     */
                    function (resolve, reject) {
                        /** @type {?} */
                        var reader = new FileReader();
                        reader.onload = (/**
                         * @param {?} e
                         * @return {?}
                         */
                        function (e) {
                            resolve(((/** @type {?} */ (e.target))).result);
                        });
                        reader.onerror = (/**
                         * @param {?} e
                         * @return {?}
                         */
                        function (e) {
                            console.error("FileReader failed on file " + _this.file.name + ".");
                            reject(e);
                        });
                        if (!_this.file) {
                            return reject('No file to read. Please provide a file using the [file] Input property.');
                        }
                        reader.readAsDataURL(_this.file);
                    }))];
            });
        });
    };
    NgxDropzonePreviewComponent.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'ngx-dropzone-preview',
                    template: "\n\t\t<ng-content select=\"ngx-dropzone-label\"></ng-content>\n\t\t<ngx-dropzone-remove-badge *ngIf=\"removable\" (click)=\"_remove($event)\">\n\t\t</ngx-dropzone-remove-badge>\n\t",
                    styles: [":host(){background-image:linear-gradient(to top,#ededed,#efefef,#f1f1f1,#f4f4f4,#f6f6f6)}:host():focus,:host():hover{background-image:linear-gradient(to top,#e3e3e3,#ebeaea,#e8e7e7,#ebeaea,#f4f4f4);outline:0}:host():focus ngx-dropzone-remove-badge,:host():hover ngx-dropzone-remove-badge{opacity:1}:host() ngx-dropzone-remove-badge{opacity:0}:host() ::ng-deep ngx-dropzone-label{overflow-wrap:break-word}"]
                },] },
    ];
    /** @nocollapse */
    NgxDropzonePreviewComponent.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_2__angular_platform_browser__["DomSanitizer"] }
    ]; };
    NgxDropzonePreviewComponent.propDecorators = {
        file: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] }],
        removable: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] }],
        removed: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] }],
        keyEvent: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"], args: ['keyup', ['$event'],] }],
        hostStyle: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostBinding"], args: ['style',] }],
        tabIndex: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostBinding"], args: ['tabindex',] }]
    };
    return NgxDropzonePreviewComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * This service contains the filtering logic to be applied to
 * any dropped or selected file. If a file matches all criteria
 * like maximum size or accept type, it will be emitted in the
 * addedFiles array, otherwise in the rejectedFiles array.
 */
var NgxDropzoneService = /** @class */ (function () {
    function NgxDropzoneService() {
    }
    /**
     * @param {?} files
     * @param {?} accept
     * @param {?} maxFileSize
     * @param {?} multiple
     * @return {?}
     */
    NgxDropzoneService.prototype.parseFileList = /**
     * @param {?} files
     * @param {?} accept
     * @param {?} maxFileSize
     * @param {?} multiple
     * @return {?}
     */
    function (files, accept, maxFileSize, multiple) {
        /** @type {?} */
        var addedFiles = [];
        /** @type {?} */
        var rejectedFiles = [];
        for (var i = 0; i < files.length; i++) {
            /** @type {?} */
            var file = files.item(i);
            if (!this.isAccepted(file, accept)) {
                this.rejectFile(rejectedFiles, file, 'type');
                continue;
            }
            if (maxFileSize && file.size > maxFileSize) {
                this.rejectFile(rejectedFiles, file, 'size');
                continue;
            }
            if (!multiple && addedFiles.length >= 1) {
                this.rejectFile(rejectedFiles, file, 'no_multiple');
                continue;
            }
            addedFiles.push(file);
        }
        /** @type {?} */
        var result = {
            addedFiles: addedFiles,
            rejectedFiles: rejectedFiles
        };
        return result;
    };
    /**
     * @private
     * @param {?} file
     * @param {?} accept
     * @return {?}
     */
    NgxDropzoneService.prototype.isAccepted = /**
     * @private
     * @param {?} file
     * @param {?} accept
     * @return {?}
     */
    function (file, accept) {
        if (accept === '*') {
            return true;
        }
        /** @type {?} */
        var acceptFiletypes = accept.split(',').map((/**
         * @param {?} it
         * @return {?}
         */
        function (it) { return it.toLowerCase().trim(); }));
        /** @type {?} */
        var filetype = file.type.toLowerCase();
        /** @type {?} */
        var filename = file.name.toLowerCase();
        /** @type {?} */
        var matchedFileType = acceptFiletypes.find((/**
         * @param {?} acceptFiletype
         * @return {?}
         */
        function (acceptFiletype) {
            // check for wildcard mimetype (e.g. image/*)
            if (acceptFiletype.endsWith('/*')) {
                return filetype.split('/')[0] === acceptFiletype.split('/')[0];
            }
            // check for file extension (e.g. .csv)
            if (acceptFiletype.startsWith(".")) {
                return filename.endsWith(acceptFiletype);
            }
            // check for exact mimetype match (e.g. image/jpeg)
            return acceptFiletype == filetype;
        }));
        return !!matchedFileType;
    };
    /**
     * @private
     * @param {?} rejectedFiles
     * @param {?} file
     * @param {?} reason
     * @return {?}
     */
    NgxDropzoneService.prototype.rejectFile = /**
     * @private
     * @param {?} rejectedFiles
     * @param {?} file
     * @param {?} reason
     * @return {?}
     */
    function (rejectedFiles, file, reason) {
        /** @type {?} */
        var rejectedFile = (/** @type {?} */ (file));
        rejectedFile.reason = reason;
        rejectedFiles.push(rejectedFile);
    };
    NgxDropzoneService.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    return NgxDropzoneService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NgxDropzoneComponent = /** @class */ (function () {
    function NgxDropzoneComponent(service) {
        this.service = service;
        /**
         * Emitted when any files were added or rejected.
         */
        this.change = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
         * Set the accepted file types. Defaults to '*'.
         */
        this.accept = '*';
        this._disabled = false;
        this._multiple = true;
        this._maxFileSize = undefined;
        this._expandable = false;
        this._disableClick = false;
        this._isHovered = false;
    }
    Object.defineProperty(NgxDropzoneComponent.prototype, "_hasPreviews", {
        get: /**
         * @return {?}
         */
        function () {
            return !!this._previewChildren.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgxDropzoneComponent.prototype, "disabled", {
        /** Disable any user interaction with the component. */
        get: /**
         * Disable any user interaction with the component.
         * @return {?}
         */
        function () {
            return this._disabled;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._disabled = coerceBooleanProperty(value);
            if (this._isHovered) {
                this._isHovered = false;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgxDropzoneComponent.prototype, "multiple", {
        /** Allow the selection of multiple files. */
        get: /**
         * Allow the selection of multiple files.
         * @return {?}
         */
        function () {
            return this._multiple;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._multiple = coerceBooleanProperty(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgxDropzoneComponent.prototype, "maxFileSize", {
        /** Set the maximum size a single file may have. */
        get: /**
         * Set the maximum size a single file may have.
         * @return {?}
         */
        function () {
            return this._maxFileSize;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._maxFileSize = coerceNumberProperty(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgxDropzoneComponent.prototype, "expandable", {
        /** Allow the dropzone container to expand vertically. */
        get: /**
         * Allow the dropzone container to expand vertically.
         * @return {?}
         */
        function () {
            return this._expandable;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._expandable = coerceBooleanProperty(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgxDropzoneComponent.prototype, "disableClick", {
        /** Open the file selector on click. */
        get: /**
         * Open the file selector on click.
         * @return {?}
         */
        function () {
            return this._disableClick;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._disableClick = coerceBooleanProperty(value);
        },
        enumerable: true,
        configurable: true
    });
    /** Show the native OS file explorer to select files. */
    /**
     * Show the native OS file explorer to select files.
     * @return {?}
     */
    NgxDropzoneComponent.prototype._onClick = /**
     * Show the native OS file explorer to select files.
     * @return {?}
     */
    function () {
        if (!this.disableClick) {
            this.showFileSelector();
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    NgxDropzoneComponent.prototype._onDragOver = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (this.disabled) {
            return;
        }
        this.preventDefault(event);
        this._isHovered = true;
    };
    /**
     * @return {?}
     */
    NgxDropzoneComponent.prototype._onDragLeave = /**
     * @return {?}
     */
    function () {
        this._isHovered = false;
    };
    /**
     * @param {?} event
     * @return {?}
     */
    NgxDropzoneComponent.prototype._onDrop = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (this.disabled) {
            return;
        }
        this.preventDefault(event);
        this._isHovered = false;
        this.handleFileDrop(event.dataTransfer.files);
    };
    /**
     * @return {?}
     */
    NgxDropzoneComponent.prototype.showFileSelector = /**
     * @return {?}
     */
    function () {
        if (!this.disabled) {
            ((/** @type {?} */ (this._fileInput.nativeElement))).click();
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    NgxDropzoneComponent.prototype._onFilesSelected = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var files = event.target.files;
        this.handleFileDrop(files);
        // Reset the native file input element to allow selecting the same file again
        this._fileInput.nativeElement.value = '';
        // fix(#32): Prevent the default event behaviour which caused the change event to emit twice.
        this.preventDefault(event);
    };
    /**
     * @private
     * @param {?} files
     * @return {?}
     */
    NgxDropzoneComponent.prototype.handleFileDrop = /**
     * @private
     * @param {?} files
     * @return {?}
     */
    function (files) {
        /** @type {?} */
        var result = this.service.parseFileList(files, this.accept, this.maxFileSize, this.multiple);
        this.change.next({
            addedFiles: result.addedFiles,
            rejectedFiles: result.rejectedFiles,
            source: this
        });
    };
    /**
     * @private
     * @param {?} event
     * @return {?}
     */
    NgxDropzoneComponent.prototype.preventDefault = /**
     * @private
     * @param {?} event
     * @return {?}
     */
    function (event) {
        event.preventDefault();
        event.stopPropagation();
    };
    NgxDropzoneComponent.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'ngx-dropzone, [ngx-dropzone]',
                    template: "<input #fileInput type=\"file\" [id]=\"id\" [multiple]=\"multiple\" [accept]=\"accept\" [disabled]=\"disabled\"\n  (change)=\"_onFilesSelected($event)\" [attr.aria-label]=\"ariaLabel\" [attr.aria-labelledby]=\"ariaLabelledby\"\n  [attr.aria-describedby]=\"ariaDescribedBy\">\n<ng-content select=\"ngx-dropzone-label\" *ngIf=\"!_hasPreviews\"></ng-content>\n<ng-content select=\"ngx-dropzone-preview\"></ng-content>\n<ng-content></ng-content>\n",
                    styles: [":host(){display:flex;align-items:center;height:180px;background:#fff;cursor:pointer;color:#717386;border:2px dashed #717386;border-radius:5px;font-size:16px;overflow-x:auto}:host().ngx-dz-hovered{border-style:solid}:host().ngx-dz-disabled{opacity:.5;cursor:no-drop;pointer-events:none}:host().expandable{overflow:hidden;height:unset;min-height:180px;flex-wrap:wrap}:host().unclickable{cursor:default}:host() ::ng-deep ngx-dropzone-label{text-align:center;z-index:10;margin:10px auto}:host() input{width:.1px;height:.1px;opacity:0;overflow:hidden;position:absolute;z-index:-1}:host() input:focus+::ng-deep ngx-dropzone-label{outline:#000 dotted 1px;outline:-webkit-focus-ring-color auto 5px}"],
                    providers: [NgxDropzoneService]
                },] },
    ];
    /** @nocollapse */
    NgxDropzoneComponent.ctorParameters = function () { return [
        { type: NgxDropzoneService, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }] }
    ]; };
    NgxDropzoneComponent.propDecorators = {
        _previewChildren: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChildren"], args: [NgxDropzonePreviewComponent, { descendants: true },] }],
        _fileInput: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"], args: ['fileInput',] }],
        change: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] }],
        accept: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] }],
        disabled: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostBinding"], args: ['class.ngx-dz-disabled',] }],
        multiple: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] }],
        maxFileSize: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] }],
        expandable: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostBinding"], args: ['class.expandable',] }],
        disableClick: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostBinding"], args: ['class.unclickable',] }],
        id: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] }],
        ariaLabel: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['aria-label',] }],
        ariaLabelledby: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['aria-labelledby',] }],
        ariaDescribedBy: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['aria-describedby',] }],
        _isHovered: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostBinding"], args: ['class.ngx-dz-hovered',] }],
        _onClick: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"], args: ['click',] }],
        _onDragOver: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"], args: ['dragover', ['$event'],] }],
        _onDragLeave: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"], args: ['dragleave',] }],
        _onDrop: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"], args: ['drop', ['$event'],] }]
    };
    return NgxDropzoneComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NgxDropzoneImagePreviewComponent = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["d" /* __extends */])(NgxDropzoneImagePreviewComponent, _super);
    function NgxDropzoneImagePreviewComponent(sanitizer) {
        var _this = _super.call(this, sanitizer) || this;
        /**
         * The image data source.
         */
        _this.imageSrc = '';
        return _this;
    }
    /**
     * @return {?}
     */
    NgxDropzoneImagePreviewComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.readFile()
            .then((/**
         * @param {?} img
         * @return {?}
         */
        function (img) { return setTimeout((/**
         * @return {?}
         */
        function () { return _this.imageSrc = img; })); }))
            .catch((/**
         * @param {?} err
         * @return {?}
         */
        function (err) { return console.error(err); }));
    };
    NgxDropzoneImagePreviewComponent.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'ngx-dropzone-image-preview',
                    template: "\n    <img [src]=\"imageSrc\" />\n\t\t<ng-content select=\"ngx-dropzone-label\"></ng-content>\n    <ngx-dropzone-remove-badge *ngIf=\"removable\" (click)=\"_remove($event)\">\n    </ngx-dropzone-remove-badge>\n\t",
                    styles: [":host(){min-width:unset!important;max-width:unset!important;padding:0!important}:host():focus img,:host():hover img{opacity:.7}:host():focus ngx-dropzone-remove-badge,:host():hover ngx-dropzone-remove-badge{opacity:1}:host() ngx-dropzone-remove-badge{opacity:0}:host() img{max-height:100%;border-radius:5px;opacity:.8}:host() ::ng-deep ngx-dropzone-label{position:absolute;overflow-wrap:break-word}"],
                    providers: [
                        {
                            provide: NgxDropzonePreviewComponent,
                            useExisting: NgxDropzoneImagePreviewComponent
                        }
                    ]
                },] },
    ];
    /** @nocollapse */
    NgxDropzoneImagePreviewComponent.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_2__angular_platform_browser__["DomSanitizer"] }
    ]; };
    return NgxDropzoneImagePreviewComponent;
}(NgxDropzonePreviewComponent));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NgxDropzoneRemoveBadgeComponent = /** @class */ (function () {
    function NgxDropzoneRemoveBadgeComponent() {
    }
    NgxDropzoneRemoveBadgeComponent.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'ngx-dropzone-remove-badge',
                    template: "\n    <svg>\n      <line x1=\"0\" y1=\"0\" x2=\"10\" y2=\"10\" />\n      <line x1=\"0\" y1=\"10\" x2=\"10\" y2=\"0\" />\n    </svg>\n  ",
                    styles: [":host(){display:flex;justify-content:center;align-items:center;height:22px;width:22px;position:absolute;top:5px;right:5px;border-radius:50%;background:#bbb;color:#333;cursor:pointer}:host():hover{background:#aeaeae}:host()>svg{height:10px;width:10px}:host()>svg>line{stroke-width:2px;stroke:#fff}"]
                },] },
    ];
    return NgxDropzoneRemoveBadgeComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NgxDropzoneVideoPreviewComponent = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["d" /* __extends */])(NgxDropzoneVideoPreviewComponent, _super);
    function NgxDropzoneVideoPreviewComponent(sanitizer) {
        return _super.call(this, sanitizer) || this;
    }
    /**
     * @return {?}
     */
    NgxDropzoneVideoPreviewComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        if (!this.file) {
            console.error('No file to read. Please provide a file using the [file] Input property.');
            return;
        }
        /**
         * We sanitize the URL here to enable the preview.
         * Please note that this could cause security issues!
         **/
        this.videoSrc = URL.createObjectURL(this.file);
        this.sanitizedVideoSrc = this.sanitizer.bypassSecurityTrustUrl(this.videoSrc);
    };
    /**
     * @return {?}
     */
    NgxDropzoneVideoPreviewComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        URL.revokeObjectURL(this.videoSrc);
    };
    NgxDropzoneVideoPreviewComponent.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'ngx-dropzone-video-preview',
                    template: "\n    <video *ngIf=\"sanitizedVideoSrc\" controls (click)=\"$event.stopPropagation()\">\n      <source [src]=\"sanitizedVideoSrc\" />\n    </video>\n    <ng-content select=\"ngx-dropzone-label\"></ng-content>\n    <ngx-dropzone-remove-badge *ngIf=\"removable\" (click)=\"_remove($event)\">\n    </ngx-dropzone-remove-badge>\n\t",
                    styles: [":host(){min-width:unset!important;max-width:unset!important;padding:0!important}:host():focus video,:host():hover video{opacity:.7}:host():focus ngx-dropzone-remove-badge,:host():hover ngx-dropzone-remove-badge{opacity:1}:host() ngx-dropzone-remove-badge{opacity:0}:host() video{max-height:100%;border-radius:5px}:host() ::ng-deep ngx-dropzone-label{position:absolute;overflow-wrap:break-word}"],
                    providers: [
                        {
                            provide: NgxDropzonePreviewComponent,
                            useExisting: NgxDropzoneVideoPreviewComponent
                        }
                    ]
                },] },
    ];
    /** @nocollapse */
    NgxDropzoneVideoPreviewComponent.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_2__angular_platform_browser__["DomSanitizer"] }
    ]; };
    return NgxDropzoneVideoPreviewComponent;
}(NgxDropzonePreviewComponent));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NgxDropzoneModule = /** @class */ (function () {
    function NgxDropzoneModule() {
    }
    NgxDropzoneModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                    imports: [
                        __WEBPACK_IMPORTED_MODULE_3__angular_common__["CommonModule"]
                    ],
                    declarations: [
                        NgxDropzoneComponent,
                        NgxDropzoneLabelDirective,
                        NgxDropzonePreviewComponent,
                        NgxDropzoneImagePreviewComponent,
                        NgxDropzoneRemoveBadgeComponent,
                        NgxDropzoneVideoPreviewComponent,
                    ],
                    exports: [
                        NgxDropzoneComponent,
                        NgxDropzoneLabelDirective,
                        NgxDropzonePreviewComponent,
                        NgxDropzoneImagePreviewComponent,
                        NgxDropzoneRemoveBadgeComponent,
                        NgxDropzoneVideoPreviewComponent,
                    ]
                },] },
    ];
    return NgxDropzoneModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */



//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ "./node_modules/ngx-img-cropper/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_imageCropperModule__ = __webpack_require__("./node_modules/ngx-img-cropper/src/imageCropperModule.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ImageCropperModule", function() { return __WEBPACK_IMPORTED_MODULE_0__src_imageCropperModule__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_imageCropperComponent__ = __webpack_require__("./node_modules/ngx-img-cropper/src/imageCropperComponent.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ImageCropperComponent", function() { return __WEBPACK_IMPORTED_MODULE_1__src_imageCropperComponent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_imageCropper__ = __webpack_require__("./node_modules/ngx-img-cropper/src/imageCropper.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ImageCropper", function() { return __WEBPACK_IMPORTED_MODULE_2__src_imageCropper__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_cropperSettings__ = __webpack_require__("./node_modules/ngx-img-cropper/src/cropperSettings.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CropperSettings", function() { return __WEBPACK_IMPORTED_MODULE_3__src_cropperSettings__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_cropperDrawSettings__ = __webpack_require__("./node_modules/ngx-img-cropper/src/cropperDrawSettings.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CropperDrawSettings", function() { return __WEBPACK_IMPORTED_MODULE_4__src_cropperDrawSettings__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_model_bounds__ = __webpack_require__("./node_modules/ngx-img-cropper/src/model/bounds.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Bounds", function() { return __WEBPACK_IMPORTED_MODULE_5__src_model_bounds__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_model_cropPosition__ = __webpack_require__("./node_modules/ngx-img-cropper/src/model/cropPosition.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CropPosition", function() { return __WEBPACK_IMPORTED_MODULE_6__src_model_cropPosition__["a"]; });







//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./node_modules/ngx-img-cropper/src/cropperDrawSettings.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CropperDrawSettings; });
var CropperDrawSettings = /** @class */ (function () {
    function CropperDrawSettings(settings) {
        this.lineDash = false;
        this.strokeWidth = 1;
        this.strokeColor = "rgba(255,255,255,1)";
        this.dragIconStrokeWidth = 1;
        this.dragIconStrokeColor = "rgba(0,0,0,1)";
        this.dragIconFillColor = "rgba(255,255,255,1)";
        if (typeof settings === "object") {
            this.lineDash = settings.lineDash || this.lineDash;
            this.strokeWidth = settings.strokeWidth || this.strokeWidth;
            this.strokeColor = settings.strokeColor || this.strokeColor;
            this.dragIconStrokeWidth =
                settings.dragIconStrokeWidth || this.dragIconStrokeWidth;
            this.dragIconStrokeColor =
                settings.dragIconStrokeColor || this.dragIconStrokeColor;
            this.dragIconFillColor =
                settings.dragIconFillColor || this.dragIconFillColor;
        }
    }
    return CropperDrawSettings;
}());

//# sourceMappingURL=cropperDrawSettings.js.map

/***/ }),

/***/ "./node_modules/ngx-img-cropper/src/cropperSettings.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CropperSettings; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cropperDrawSettings__ = __webpack_require__("./node_modules/ngx-img-cropper/src/cropperDrawSettings.js");

var CropperSettings = /** @class */ (function () {
    function CropperSettings(settings) {
        this.canvasWidth = 300;
        this.canvasHeight = 300;
        this.dynamicSizing = false;
        this.width = 200;
        this.height = 200;
        this.minWidth = 50;
        this.minHeight = 50;
        this.minWithRelativeToResolution = true;
        this.croppedWidth = 100;
        this.croppedHeight = 100;
        this.cropperDrawSettings = new __WEBPACK_IMPORTED_MODULE_0__cropperDrawSettings__["a" /* CropperDrawSettings */]();
        this.touchRadius = 20;
        this.noFileInput = false;
        this.markerSizeMultiplier = 1;
        this.centerTouchRadius = 20;
        this.showCenterMarker = true;
        this.allowedFilesRegex = /\.(jpe?g|png|gif|bmp)$/i;
        this.cropOnResize = true;
        this.preserveSize = false;
        this.compressRatio = 1.0;
        this._rounded = false;
        this._keepAspect = true;
        if (typeof settings === "object") {
            Object.assign(this, settings);
        }
    }
    Object.defineProperty(CropperSettings.prototype, "rounded", {
        get: function () {
            return this._rounded;
        },
        set: function (val) {
            this._rounded = val;
            if (val) {
                this._keepAspect = true;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CropperSettings.prototype, "keepAspect", {
        get: function () {
            return this._keepAspect;
        },
        set: function (val) {
            this._keepAspect = val;
            if (this._rounded === true && this._keepAspect === false) {
                console.error("Cannot set keep aspect to false on rounded cropper. Ellipsis not supported");
                this._keepAspect = true;
            }
        },
        enumerable: true,
        configurable: true
    });
    return CropperSettings;
}());

//# sourceMappingURL=cropperSettings.js.map

/***/ }),

/***/ "./node_modules/ngx-img-cropper/src/exif.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Fraction */
/* unused harmony export Debug */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Exif; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Fraction = /** @class */ (function (_super) {
    __extends(Fraction, _super);
    function Fraction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Fraction;
}(Number));

// Console debug wrapper that makes code looks a little bit cleaner
var 
// Console debug wrapper that makes code looks a little bit cleaner
Debug = /** @class */ (function () {
    function Debug() {
    }
    Debug.log = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (Exif.debug) {
            console.log(args);
        }
    };
    return Debug;
}());
// Console debug wrapper that makes code looks a little bit cleaner

var Exif = /** @class */ (function () {
    function Exif() {
    }
    Exif.addEvent = function (element, event, handler) {
        if (element.addEventListener) {
            element.addEventListener(event, handler, false);
        }
        else {
            // Hello, IE!
            if (element.attachEvent) {
                element.attachEvent("on" + event, handler);
            }
        }
    };
    Exif.imageHasData = function (img) {
        return !!img.exifdata;
    };
    Exif.base64ToArrayBuffer = function (base64) {
        base64 = base64.replace(/^data:([^;]+);base64,/gim, "");
        var binary = atob(base64);
        var len = binary.length;
        var buffer = new ArrayBuffer(len);
        var view = new Uint8Array(buffer);
        for (var i = 0; i < len; i++) {
            view[i] = binary.charCodeAt(i);
        }
        return buffer;
    };
    Exif.objectURLToBlob = function (url, callback) {
        var http = new XMLHttpRequest();
        http.open("GET", url, true);
        http.responseType = "blob";
        http.onload = function () {
            if (http.status === 200 || http.status === 0) {
                callback(http.response);
            }
        };
        http.send();
    };
    Exif.getImageData = function (img, callback) {
        function handleBinaryFile(binFile) {
            var data = Exif.findEXIFinJPEG(binFile);
            var iptcdata = Exif.findIPTCinJPEG(binFile);
            img.exifdata = data || {};
            img.iptcdata = iptcdata || {};
            if (callback) {
                callback.call(img);
            }
        }
        if ("src" in img && img.src) {
            if (/^data:/i.test(img.src)) {
                // Data URI
                var arrayBuffer = Exif.base64ToArrayBuffer(img.src);
                handleBinaryFile(arrayBuffer);
            }
            else {
                if (/^blob:/i.test(img.src)) {
                    // Object URL
                    var fileReader_1 = new FileReader();
                    fileReader_1.onload = function (e) {
                        handleBinaryFile(e.target.result);
                    };
                    Exif.objectURLToBlob(img.src, function (blob) {
                        fileReader_1.readAsArrayBuffer(blob);
                    });
                }
                else {
                    var http_1 = new XMLHttpRequest();
                    http_1.onload = function () {
                        if (http_1.status === 200 || http_1.status === 0) {
                            handleBinaryFile(http_1.response);
                        }
                        else {
                            throw "Could not load image";
                        }
                    };
                    http_1.open("GET", img.src, true);
                    http_1.responseType = "arraybuffer";
                    http_1.send(null);
                }
            }
        }
        else {
            if (FileReader && (img instanceof Blob || img instanceof File)) {
                var fileReader = new FileReader();
                fileReader.onload = function (e) {
                    Debug.log("Got file of length " + e.target.result.byteLength);
                    handleBinaryFile(e.target.result);
                };
                fileReader.readAsArrayBuffer(img);
            }
        }
    };
    Exif.findEXIFinJPEG = function (file) {
        var dataView = new DataView(file);
        Debug.log("Got file of length " + file.byteLength);
        if (dataView.getUint8(0) !== 0xff || dataView.getUint8(1) !== 0xd8) {
            Debug.log("Not a valid JPEG");
            return false; // not a valid jpeg
        }
        var offset = 2;
        var length = file.byteLength;
        var marker;
        while (offset < length) {
            if (dataView.getUint8(offset) !== 0xff) {
                Debug.log("Not a valid marker at offset " +
                    offset +
                    ", found: " +
                    dataView.getUint8(offset));
                return false; // not a valid marker, something is wrong
            }
            marker = dataView.getUint8(offset + 1);
            Debug.log(marker);
            // we could implement handling for other markers here,
            // but we're only looking for 0xFFE1 for EXIF data
            if (marker === 225) {
                Debug.log("Found 0xFFE1 marker");
                return Exif.readEXIFData(dataView, offset + 4); // , dataView.getUint16(offset + 2) - 2);
                // offset += 2 + file.getShortAt(offset+2, true);
            }
            else {
                offset += 2 + dataView.getUint16(offset + 2);
            }
        }
    };
    Exif.findIPTCinJPEG = function (file) {
        var dataView = new DataView(file);
        Debug.log("Got file of length " + file.byteLength);
        if (dataView.getUint8(0) !== 0xff || dataView.getUint8(1) !== 0xd8) {
            Debug.log("Not a valid JPEG");
            return false; // not a valid jpeg
        }
        var offset = 2;
        var length = file.byteLength;
        var isFieldSegmentStart = function (_dataView, _offset) {
            return (_dataView.getUint8(_offset) === 0x38 &&
                _dataView.getUint8(_offset + 1) === 0x42 &&
                _dataView.getUint8(_offset + 2) === 0x49 &&
                _dataView.getUint8(_offset + 3) === 0x4d &&
                _dataView.getUint8(_offset + 4) === 0x04 &&
                _dataView.getUint8(_offset + 5) === 0x04);
        };
        while (offset < length) {
            if (isFieldSegmentStart(dataView, offset)) {
                // Get the length of the name header (which is padded to an even number of bytes)
                var nameHeaderLength = dataView.getUint8(offset + 7);
                if (nameHeaderLength % 2 !== 0) {
                    nameHeaderLength += 1;
                }
                // Check for pre photoshop 6 format
                if (nameHeaderLength === 0) {
                    // Always 4
                    nameHeaderLength = 4;
                }
                var startOffset = offset + 8 + nameHeaderLength;
                var sectionLength = dataView.getUint16(offset + 6 + nameHeaderLength);
                return Exif.readIPTCData(file, startOffset, sectionLength);
            }
            // Not the marker, continue searching
            offset++;
        }
    };
    Exif.readIPTCData = function (file, startOffset, sectionLength) {
        var dataView = new DataView(file);
        var data = {};
        var fieldValue, fieldName, dataSize, segmentType, segmentSize;
        var segmentStartPos = startOffset;
        while (segmentStartPos < startOffset + sectionLength) {
            if (dataView.getUint8(segmentStartPos) === 0x1c &&
                dataView.getUint8(segmentStartPos + 1) === 0x02) {
                segmentType = dataView.getUint8(segmentStartPos + 2);
                if (segmentType in Exif.IptcFieldMap) {
                    dataSize = dataView.getInt16(segmentStartPos + 3);
                    segmentSize = dataSize + 5;
                    fieldName = Exif.IptcFieldMap[segmentType];
                    fieldValue = Exif.getStringFromDB(dataView, segmentStartPos + 5, dataSize);
                    // Check if we already stored a value with this name
                    if (data.hasOwnProperty(fieldName)) {
                        // Value already stored with this name, create multivalue field
                        if (data[fieldName] instanceof Array) {
                            data[fieldName].push(fieldValue);
                        }
                        else {
                            data[fieldName] = [data[fieldName], fieldValue];
                        }
                    }
                    else {
                        data[fieldName] = fieldValue;
                    }
                }
            }
            segmentStartPos++;
        }
        return data;
    };
    Exif.readTags = function (file, tiffStart, dirStart, strings, bigEnd) {
        var entries = file.getUint16(dirStart, !bigEnd);
        var tags = {};
        var entryOffset;
        var tag;
        for (var i = 0; i < entries; i++) {
            entryOffset = dirStart + i * 12 + 2;
            tag = strings[file.getUint16(entryOffset, !bigEnd)];
            if (!tag) {
                Debug.log("Unknown tag: " + file.getUint16(entryOffset, !bigEnd));
            }
            tags[tag] = Exif.readTagValue(file, entryOffset, tiffStart, dirStart, bigEnd);
        }
        return tags;
    };
    Exif.readTagValue = function (file, entryOffset, tiffStart, dirStart, bigEnd) {
        var type = file.getUint16(entryOffset + 2, !bigEnd);
        var numValues = file.getUint32(entryOffset + 4, !bigEnd);
        var valueOffset = file.getUint32(entryOffset + 8, !bigEnd) + tiffStart;
        var offset;
        var vals, val, n;
        var numerator;
        var denominator;
        switch (type) {
            case 1: // byte, 8-bit unsigned int
            case 7:
                // undefined, 8-bit byte, value depending on field
                if (numValues === 1) {
                    return file.getUint8(entryOffset + 8, !bigEnd);
                }
                else {
                    offset = numValues > 4 ? valueOffset : entryOffset + 8;
                    vals = [];
                    for (n = 0; n < numValues; n++) {
                        vals[n] = file.getUint8(offset + n);
                    }
                    return vals;
                }
            case 2:
                // ascii, 8-bit byte
                offset = numValues > 4 ? valueOffset : entryOffset + 8;
                return Exif.getStringFromDB(file, offset, numValues - 1);
            case 3:
                // short, 16 bit int
                if (numValues === 1) {
                    return file.getUint16(entryOffset + 8, !bigEnd);
                }
                else {
                    offset = numValues > 2 ? valueOffset : entryOffset + 8;
                    vals = [];
                    for (n = 0; n < numValues; n++) {
                        vals[n] = file.getUint16(offset + 2 * n, !bigEnd);
                    }
                    return vals;
                }
            case 4:
                // long, 32 bit int
                if (numValues === 1) {
                    return file.getUint32(entryOffset + 8, !bigEnd);
                }
                else {
                    vals = [];
                    for (n = 0; n < numValues; n++) {
                        vals[n] = file.getUint32(valueOffset + 4 * n, !bigEnd);
                    }
                    return vals;
                }
            case 5:
                // rational = two long values, first is numerator, second is denominator
                if (numValues === 1) {
                    numerator = file.getUint32(valueOffset, !bigEnd);
                    denominator = file.getUint32(valueOffset + 4, !bigEnd);
                    val = new Fraction(numerator / denominator);
                    val.numerator = numerator;
                    val.denominator = denominator;
                    return val;
                }
                else {
                    vals = [];
                    for (n = 0; n < numValues; n++) {
                        numerator = file.getUint32(valueOffset + 8 * n, !bigEnd);
                        denominator = file.getUint32(valueOffset + 4 + 8 * n, !bigEnd);
                        vals[n] = new Fraction(numerator / denominator);
                        vals[n].numerator = numerator;
                        vals[n].denominator = denominator;
                    }
                    return vals;
                }
            case 9:
                // slong, 32 bit signed int
                if (numValues === 1) {
                    return file.getInt32(entryOffset + 8, !bigEnd);
                }
                else {
                    vals = [];
                    for (n = 0; n < numValues; n++) {
                        vals[n] = file.getInt32(valueOffset + 4 * n, !bigEnd);
                    }
                    return vals;
                }
            case 10:
                // signed rational, two slongs, first is numerator, second is denominator
                if (numValues === 1) {
                    return (file.getInt32(valueOffset, !bigEnd) /
                        file.getInt32(valueOffset + 4, !bigEnd));
                }
                else {
                    vals = [];
                    for (n = 0; n < numValues; n++) {
                        vals[n] =
                            file.getInt32(valueOffset + 8 * n, !bigEnd) /
                                file.getInt32(valueOffset + 4 + 8 * n, !bigEnd);
                    }
                    return vals;
                }
            default:
                break;
        }
    };
    Exif.getStringFromDB = function (buffer, start, length) {
        var outstr = "";
        for (var n = start; n < start + length; n++) {
            outstr += String.fromCharCode(buffer.getUint8(n));
        }
        return outstr;
    };
    Exif.readEXIFData = function (file, start) {
        if (Exif.getStringFromDB(file, start, 4) !== "Exif") {
            Debug.log("Not valid EXIF data! " + Exif.getStringFromDB(file, start, 4));
            return false;
        }
        var bigEnd, tags, tag, exifData, gpsData, tiffOffset = start + 6;
        // test for TIFF validity and endianness
        if (file.getUint16(tiffOffset) === 0x4949) {
            bigEnd = false;
        }
        else {
            if (file.getUint16(tiffOffset) === 0x4d4d) {
                bigEnd = true;
            }
            else {
                Debug.log("Not valid TIFF data! (no 0x4949 or 0x4D4D)");
                return false;
            }
        }
        if (file.getUint16(tiffOffset + 2, !bigEnd) !== 0x002a) {
            Debug.log("Not valid TIFF data! (no 0x002A)");
            return false;
        }
        var firstIFDOffset = file.getUint32(tiffOffset + 4, !bigEnd);
        if (firstIFDOffset < 0x00000008) {
            Debug.log("Not valid TIFF data! (First offset less than 8)", file.getUint32(tiffOffset + 4, !bigEnd));
            return false;
        }
        tags = Exif.readTags(file, tiffOffset, tiffOffset + firstIFDOffset, Exif.TiffTags, bigEnd);
        if (tags.ExifIFDPointer) {
            exifData = Exif.readTags(file, tiffOffset, tiffOffset + tags.ExifIFDPointer, Exif.Tags, bigEnd);
            for (tag in exifData) {
                if ({}.hasOwnProperty.call(exifData, tag)) {
                    switch (tag) {
                        case "LightSource":
                        case "Flash":
                        case "MeteringMode":
                        case "ExposureProgram":
                        case "SensingMethod":
                        case "SceneCaptureType":
                        case "SceneType":
                        case "CustomRendered":
                        case "WhiteBalance":
                        case "GainControl":
                        case "Contrast":
                        case "Saturation":
                        case "Sharpness":
                        case "SubjectDistanceRange":
                        case "FileSource":
                            exifData[tag] = Exif.StringValues[tag][exifData[tag]];
                            break;
                        case "ExifVersion":
                        case "FlashpixVersion":
                            exifData[tag] = String.fromCharCode(exifData[tag][0], exifData[tag][1], exifData[tag][2], exifData[tag][3]);
                            break;
                        case "ComponentsConfiguration":
                            var compopents = "Components";
                            exifData[tag] =
                                Exif.StringValues[compopents][exifData[tag][0]] +
                                    Exif.StringValues[compopents][exifData[tag][1]] +
                                    Exif.StringValues[compopents][exifData[tag][2]] +
                                    Exif.StringValues[compopents][exifData[tag][3]];
                            break;
                        default:
                            break;
                    }
                    tags[tag] = exifData[tag];
                }
            }
        }
        if (tags.GPSInfoIFDPointer) {
            gpsData = Exif.readTags(file, tiffOffset, tiffOffset + tags.GPSInfoIFDPointer, Exif.GPSTags, bigEnd);
            for (tag in gpsData) {
                if ({}.hasOwnProperty.call(gpsData, tag)) {
                    switch (tag) {
                        case "GPSVersionID":
                            gpsData[tag] =
                                gpsData[tag][0] +
                                    "." +
                                    gpsData[tag][1] +
                                    "." +
                                    gpsData[tag][2] +
                                    "." +
                                    gpsData[tag][3];
                            break;
                        default:
                            break;
                    }
                    tags[tag] = gpsData[tag];
                }
            }
        }
        return tags;
    };
    //   get rid of this silly issue
    //   get rid of this silly issue
    Exif.checkImageType = 
    //   get rid of this silly issue
    function (img) {
        return img instanceof Image || img instanceof HTMLImageElement;
    };
    Exif.getData = function (img, callback) {
        if (this.checkImageType(img) && !img.complete) {
            return false;
        }
        if (!Exif.imageHasData(img)) {
            Exif.getImageData(img, callback);
        }
        else {
            if (callback) {
                callback.call(img);
            }
        }
        return true;
    };
    Exif.getTag = function (img, tag) {
        if (!Exif.imageHasData(img)) {
            return;
        }
        return img.exifdata[tag];
    };
    Exif.getAllTags = function (img) {
        if (!Exif.imageHasData(img)) {
            return {};
        }
        var a, data = img.exifdata, tags = {};
        for (a in data) {
            if (data.hasOwnProperty(a)) {
                tags[a] = data[a];
            }
        }
        return tags;
    };
    Exif.pretty = function (img) {
        if (!Exif.imageHasData(img)) {
            return "";
        }
        var a, data = img.exifdata, strPretty = "";
        for (a in data) {
            if (data.hasOwnProperty(a)) {
                if (typeof data[a] === "object") {
                    if (data[a] instanceof Number) {
                        strPretty += a + " : " + data[a] + " [" + data[a].numerator + "/" + data[a].denominator + "]\r\n";
                    }
                    else {
                        strPretty += a + " : [" + data[a].length + " values]\r\n";
                    }
                }
                else {
                    strPretty += a + " : " + data[a] + "\r\n";
                }
            }
        }
        return strPretty;
    };
    Exif.readFromBinaryFile = function (file) {
        return Exif.findEXIFinJPEG(file);
    };
    Exif.debug = false;
    Exif.IptcFieldMap = {
        0x78: "caption",
        0x6e: "credit",
        0x19: "keywords",
        0x37: "dateCreated",
        0x50: "byline",
        0x55: "bylineTitle",
        0x7a: "captionWriter",
        0x69: "headline",
        0x74: "copyright",
        0x0f: "category"
    };
    Exif.Tags = {
        // version tags
        0x9000: "ExifVersion",
        // EXIF version
        0xa000: "FlashpixVersion",
        // Flashpix format version
        // colorspace tags
        0xa001: "ColorSpace",
        // Color space information tag
        // image configuration
        0xa002: "PixelXDimension",
        // Valid width of meaningful image
        0xa003: "PixelYDimension",
        // Valid height of meaningful image
        0x9101: "ComponentsConfiguration",
        // Information about channels
        0x9102: "CompressedBitsPerPixel",
        // Compressed bits per pixel
        // user information
        0x927c: "MakerNote",
        // Any desired information written by the manufacturer
        0x9286: "UserComment",
        // Comments by user
        // related file
        0xa004: "RelatedSoundFile",
        // Name of related sound file
        // date and time
        0x9003: "DateTimeOriginal",
        // Date and time when the original image was generated
        0x9004: "DateTimeDigitized",
        // Date and time when the image was stored digitally
        0x9290: "SubsecTime",
        // Fractions of seconds for DateTime
        0x9291: "SubsecTimeOriginal",
        // Fractions of seconds for DateTimeOriginal
        0x9292: "SubsecTimeDigitized",
        // Fractions of seconds for DateTimeDigitized
        // picture-taking conditions
        0x829a: "ExposureTime",
        // Exposure time (in seconds)
        0x829d: "FNumber",
        // F number
        0x8822: "ExposureProgram",
        // Exposure program
        0x8824: "SpectralSensitivity",
        // Spectral sensitivity
        0x8827: "ISOSpeedRatings",
        // ISO speed rating
        0x8828: "OECF",
        // Optoelectric conversion factor
        0x9201: "ShutterSpeedValue",
        // Shutter speed
        0x9202: "ApertureValue",
        // Lens aperture
        0x9203: "BrightnessValue",
        // Value of brightness
        0x9204: "ExposureBias",
        // Exposure bias
        0x9205: "MaxApertureValue",
        // Smallest F number of lens
        0x9206: "SubjectDistance",
        // Distance to subject in meters
        0x9207: "MeteringMode",
        // Metering mode
        0x9208: "LightSource",
        // Kind of light source
        0x9209: "Flash",
        // Flash status
        0x9214: "SubjectArea",
        // Location and area of main subject
        0x920a: "FocalLength",
        // Focal length of the lens in mm
        0xa20b: "FlashEnergy",
        // Strobe energy in BCPS
        0xa20c: "SpatialFrequencyResponse",
        //
        0xa20e: "FocalPlaneXResolution",
        // Number of pixels in width direction per FocalPlaneResolutionUnit
        0xa20f: "FocalPlaneYResolution",
        // Number of pixels in height direction per FocalPlaneResolutionUnit
        0xa210: "FocalPlaneResolutionUnit",
        // Unit for measuring FocalPlaneXResolution and FocalPlaneYResolution
        0xa214: "SubjectLocation",
        // Location of subject in image
        0xa215: "ExposureIndex",
        // Exposure index selected on camera
        0xa217: "SensingMethod",
        // Image sensor type
        0xa300: "FileSource",
        // Image source (3 == DSC)
        0xa301: "SceneType",
        // Scene type (1 == directly photographed)
        0xa302: "CFAPattern",
        // Color filter array geometric pattern
        0xa401: "CustomRendered",
        // Special processing
        0xa402: "ExposureMode",
        // Exposure mode
        0xa403: "WhiteBalance",
        // 1 = auto white balance, 2 = manual
        0xa404: "DigitalZoomRation",
        // Digital zoom ratio
        0xa405: "FocalLengthIn35mmFilm",
        // Equivalent foacl length assuming 35mm film camera (in mm)
        0xa406: "SceneCaptureType",
        // Type of scene
        0xa407: "GainControl",
        // Degree of overall image gain adjustment
        0xa408: "Contrast",
        // Direction of contrast processing applied by camera
        0xa409: "Saturation",
        // Direction of saturation processing applied by camera
        0xa40a: "Sharpness",
        // Direction of sharpness processing applied by camera
        0xa40b: "DeviceSettingDescription",
        //
        0xa40c: "SubjectDistanceRange",
        // Distance to subject
        // other tags
        0xa005: "InteroperabilityIFDPointer",
        0xa420: "ImageUniqueID" // Identifier assigned uniquely to each image
    };
    Exif.TiffTags = {
        0x0100: "ImageWidth",
        0x0101: "ImageHeight",
        0x8769: "ExifIFDPointer",
        0x8825: "GPSInfoIFDPointer",
        0xa005: "InteroperabilityIFDPointer",
        0x0102: "BitsPerSample",
        0x0103: "Compression",
        0x0106: "PhotometricInterpretation",
        0x0112: "Orientation",
        0x0115: "SamplesPerPixel",
        0x011c: "PlanarConfiguration",
        0x0212: "YCbCrSubSampling",
        0x0213: "YCbCrPositioning",
        0x011a: "XResolution",
        0x011b: "YResolution",
        0x0128: "ResolutionUnit",
        0x0111: "StripOffsets",
        0x0116: "RowsPerStrip",
        0x0117: "StripByteCounts",
        0x0201: "JPEGInterchangeFormat",
        0x0202: "JPEGInterchangeFormatLength",
        0x012d: "TransferFunction",
        0x013e: "WhitePoint",
        0x013f: "PrimaryChromaticities",
        0x0211: "YCbCrCoefficients",
        0x0214: "ReferenceBlackWhite",
        0x0132: "DateTime",
        0x010e: "ImageDescription",
        0x010f: "Make",
        0x0110: "Model",
        0x0131: "Software",
        0x013b: "Artist",
        0x8298: "Copyright"
    };
    Exif.GPSTags = {
        0x0000: "GPSVersionID",
        0x0001: "GPSLatitudeRef",
        0x0002: "GPSLatitude",
        0x0003: "GPSLongitudeRef",
        0x0004: "GPSLongitude",
        0x0005: "GPSAltitudeRef",
        0x0006: "GPSAltitude",
        0x0007: "GPSTimeStamp",
        0x0008: "GPSSatellites",
        0x0009: "GPSStatus",
        0x000a: "GPSMeasureMode",
        0x000b: "GPSDOP",
        0x000c: "GPSSpeedRef",
        0x000d: "GPSSpeed",
        0x000e: "GPSTrackRef",
        0x000f: "GPSTrack",
        0x0010: "GPSImgDirectionRef",
        0x0011: "GPSImgDirection",
        0x0012: "GPSMapDatum",
        0x0013: "GPSDestLatitudeRef",
        0x0014: "GPSDestLatitude",
        0x0015: "GPSDestLongitudeRef",
        0x0016: "GPSDestLongitude",
        0x0017: "GPSDestBearingRef",
        0x0018: "GPSDestBearing",
        0x0019: "GPSDestDistanceRef",
        0x001a: "GPSDestDistance",
        0x001b: "GPSProcessingMethod",
        0x001c: "GPSAreaInformation",
        0x001d: "GPSDateStamp",
        0x001e: "GPSDifferential"
    };
    Exif.StringValues = {
        ExposureProgram: {
            0: "Not defined",
            1: "Manual",
            2: "Normal program",
            3: "Aperture priority",
            4: "Shutter priority",
            5: "Creative program",
            6: "Action program",
            7: "Portrait mode",
            8: "Landscape mode"
        },
        MeteringMode: {
            0: "Unknown",
            1: "Average",
            2: "CenterWeightedAverage",
            3: "Spot",
            4: "MultiSpot",
            5: "Pattern",
            6: "Partial",
            255: "Other"
        },
        LightSource: {
            0: "Unknown",
            1: "Daylight",
            2: "Fluorescent",
            3: "Tungsten (incandescent light)",
            4: "Flash",
            9: "Fine weather",
            10: "Cloudy weather",
            11: "Shade",
            12: "Daylight fluorescent (D 5700 - 7100K)",
            13: "Day white fluorescent (N 4600 - 5400K)",
            14: "Cool white fluorescent (W 3900 - 4500K)",
            15: "White fluorescent (WW 3200 - 3700K)",
            17: "Standard light A",
            18: "Standard light B",
            19: "Standard light C",
            20: "D55",
            21: "D65",
            22: "D75",
            23: "D50",
            24: "ISO studio tungsten",
            255: "Other"
        },
        Flash: {
            0x0000: "Flash did not fire",
            0x0001: "Flash fired",
            0x0005: "Strobe return light not detected",
            0x0007: "Strobe return light detected",
            0x0009: "Flash fired, compulsory flash mode",
            0x000d: "Flash fired, compulsory flash mode, return light not detected",
            0x000f: "Flash fired, compulsory flash mode, return light detected",
            0x0010: "Flash did not fire, compulsory flash mode",
            0x0018: "Flash did not fire, auto mode",
            0x0019: "Flash fired, auto mode",
            0x001d: "Flash fired, auto mode, return light not detected",
            0x001f: "Flash fired, auto mode, return light detected",
            0x0020: "No flash function",
            0x0041: "Flash fired, red-eye reduction mode",
            0x0045: "Flash fired, red-eye reduction mode, return light not detected",
            0x0047: "Flash fired, red-eye reduction mode, return light detected",
            0x0049: "Flash fired, compulsory flash mode, red-eye reduction mode",
            0x004d: "Flash fired, compulsory flash mode, red-eye reduction mode, return light not detected",
            0x004f: "Flash fired, compulsory flash mode, red-eye reduction mode, return light detected",
            0x0059: "Flash fired, auto mode, red-eye reduction mode",
            0x005d: "Flash fired, auto mode, return light not detected, red-eye reduction mode",
            0x005f: "Flash fired, auto mode, return light detected, red-eye reduction mode"
        },
        SensingMethod: {
            1: "Not defined",
            2: "One-chip color area sensor",
            3: "Two-chip color area sensor",
            4: "Three-chip color area sensor",
            5: "Color sequential area sensor",
            7: "Trilinear sensor",
            8: "Color sequential linear sensor"
        },
        SceneCaptureType: {
            0: "Standard",
            1: "Landscape",
            2: "Portrait",
            3: "Night scene"
        },
        SceneType: {
            1: "Directly photographed"
        },
        CustomRendered: {
            0: "Normal process",
            1: "Custom process"
        },
        WhiteBalance: {
            0: "Auto white balance",
            1: "Manual white balance"
        },
        GainControl: {
            0: "None",
            1: "Low gain up",
            2: "High gain up",
            3: "Low gain down",
            4: "High gain down"
        },
        Contrast: {
            0: "Normal",
            1: "Soft",
            2: "Hard"
        },
        Saturation: {
            0: "Normal",
            1: "Low saturation",
            2: "High saturation"
        },
        Sharpness: {
            0: "Normal",
            1: "Soft",
            2: "Hard"
        },
        SubjectDistanceRange: {
            0: "Unknown",
            1: "Macro",
            2: "Close view",
            3: "Distant view"
        },
        FileSource: {
            3: "DSC"
        },
        Components: {
            0: "",
            1: "Y",
            2: "Cb",
            3: "Cr",
            4: "R",
            5: "G",
            6: "B"
        }
    };
    return Exif;
}());

//# sourceMappingURL=exif.js.map

/***/ }),

/***/ "./node_modules/ngx-img-cropper/src/imageCropper.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ImageCropper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model_bounds__ = __webpack_require__("./node_modules/ngx-img-cropper/src/model/bounds.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_cornerMarker__ = __webpack_require__("./node_modules/ngx-img-cropper/src/model/cornerMarker.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_cropTouch__ = __webpack_require__("./node_modules/ngx-img-cropper/src/model/cropTouch.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_dragMarker__ = __webpack_require__("./node_modules/ngx-img-cropper/src/model/dragMarker.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_imageCropperModel__ = __webpack_require__("./node_modules/ngx-img-cropper/src/model/imageCropperModel.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__imageCropperDataShare__ = __webpack_require__("./node_modules/ngx-img-cropper/src/imageCropperDataShare.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__model_pointPool__ = __webpack_require__("./node_modules/ngx-img-cropper/src/model/pointPool.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();







var ImageCropper = /** @class */ (function (_super) {
    __extends(ImageCropper, _super);
    function ImageCropper(cropperSettings) {
        var _this = _super.call(this) || this;
        var x = 0;
        var y = 0;
        var width = cropperSettings.width;
        var height = cropperSettings.height;
        var keepAspect = cropperSettings.keepAspect;
        var touchRadius = cropperSettings.touchRadius;
        var centerTouchRadius = cropperSettings.centerTouchRadius;
        var minWidth = cropperSettings.minWidth;
        var minHeight = cropperSettings.minHeight;
        var croppedWidth = cropperSettings.croppedWidth;
        var croppedHeight = cropperSettings.croppedHeight;
        _this.cropperSettings = cropperSettings;
        _this.crop = _this;
        _this.x = x;
        _this.y = y;
        _this.canvasHeight = cropperSettings.canvasHeight;
        _this.canvasWidth = cropperSettings.canvasWidth;
        _this.width = width;
        if (width === void 0) {
            _this.width = 100;
        }
        _this.height = height;
        if (height === void 0) {
            _this.height = 50;
        }
        _this.keepAspect = keepAspect;
        if (keepAspect === void 0) {
            _this.keepAspect = true;
        }
        _this.touchRadius = touchRadius;
        if (touchRadius === void 0) {
            _this.touchRadius = 20;
        }
        _this.minWidth = minWidth;
        _this.minHeight = minHeight;
        _this.aspectRatio = 0;
        _this.currentDragTouches = [];
        _this.isMouseDown = false;
        _this.ratioW = 1;
        _this.ratioH = 1;
        _this.fileType = cropperSettings.fileType;
        _this.imageSet = false;
        _this.pointPool = new __WEBPACK_IMPORTED_MODULE_6__model_pointPool__["a" /* PointPool */](200);
        _this.tl = new __WEBPACK_IMPORTED_MODULE_1__model_cornerMarker__["a" /* CornerMarker */](x, y, touchRadius, _this.cropperSettings);
        _this.tr = new __WEBPACK_IMPORTED_MODULE_1__model_cornerMarker__["a" /* CornerMarker */](x + width, y, touchRadius, _this.cropperSettings);
        _this.bl = new __WEBPACK_IMPORTED_MODULE_1__model_cornerMarker__["a" /* CornerMarker */](x, y + height, touchRadius, _this.cropperSettings);
        _this.br = new __WEBPACK_IMPORTED_MODULE_1__model_cornerMarker__["a" /* CornerMarker */](x + width, y + height, touchRadius, _this.cropperSettings);
        _this.tl.addHorizontalNeighbour(_this.tr);
        _this.tl.addVerticalNeighbour(_this.bl);
        _this.tr.addHorizontalNeighbour(_this.tl);
        _this.tr.addVerticalNeighbour(_this.br);
        _this.bl.addHorizontalNeighbour(_this.br);
        _this.bl.addVerticalNeighbour(_this.tl);
        _this.br.addHorizontalNeighbour(_this.bl);
        _this.br.addVerticalNeighbour(_this.tr);
        _this.markers = [_this.tl, _this.tr, _this.bl, _this.br];
        _this.center = new __WEBPACK_IMPORTED_MODULE_3__model_dragMarker__["a" /* DragMarker */](x + (width / 2), y + (height / 2), centerTouchRadius, _this.cropperSettings);
        _this.aspectRatio = height / width;
        _this.croppedImage = new Image();
        _this.currentlyInteracting = false;
        _this.cropWidth = croppedWidth;
        _this.cropHeight = croppedHeight;
        return _this;
    }
    ImageCropper.sign = function (x) {
        if (+x === x) {
            return (x === 0) ? x : (x > 0) ? 1 : -1;
        }
        return NaN;
    };
    ImageCropper.getMousePos = function (canvas, evt) {
        var rect = canvas.getBoundingClientRect();
        return __WEBPACK_IMPORTED_MODULE_6__model_pointPool__["a" /* PointPool */].instance.borrow(evt.clientX - rect.left, evt.clientY - rect.top);
    };
    ImageCropper.getTouchPos = function (canvas, touch) {
        var rect = canvas.getBoundingClientRect();
        return __WEBPACK_IMPORTED_MODULE_6__model_pointPool__["a" /* PointPool */].instance.borrow(touch.clientX - rect.left, touch.clientY - rect.top);
    };
    ImageCropper.detectVerticalSquash = function (img) {
        var ih = img.height;
        var canvas = document.createElement('canvas');
        canvas.width = 1;
        canvas.height = ih;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
        var imageData = ctx.getImageData(0, 0, 1, ih);
        if (imageData) {
            var data = imageData.data;
            // search image edge pixel position in case it is squashed vertically.
            var sy = 0;
            var ey = ih;
            var py = ih;
            while (py > sy) {
                var alpha = data[(py - 1) * 4 + 3];
                if (alpha === 0) {
                    ey = py;
                }
                else {
                    sy = py;
                }
                py = (ey + sy) >> 1;
            }
            var ratio = (py / ih);
            return (ratio === 0) ? 1 : ratio;
        }
        else {
            return 1;
        }
    };
    ImageCropper.prototype.getDataUriMimeType = function (dataUri) {
        // Get a substring because the regex does not perform well on very large strings. Cater for optional charset. Length 50 shoould be enough.
        var dataUriSubstring = dataUri.substring(0, 50);
        var mimeType = 'image/png';
        // data-uri scheme
        // data:[<media type>][;charset=<character set>][;base64],<data>
        var regEx = RegExp(/^(data:)([\w\/\+]+);(charset=[\w-]+|base64).*,(.*)/gi);
        var matches = regEx.exec(dataUriSubstring);
        if (matches && matches[2]) {
            mimeType = matches[2];
            if (mimeType == 'image/jpg') {
                mimeType = 'image/jpeg';
            }
        }
        return mimeType;
    };
    ImageCropper.prototype.prepare = function (canvas) {
        this.buffer = document.createElement('canvas');
        this.cropCanvas = document.createElement('canvas');
        // todo get more reliable parent width value.
        var responsiveWidth = canvas.parentElement ? canvas.parentElement.clientWidth : 0;
        if (responsiveWidth > 0 && this.cropperSettings.dynamicSizing) {
            this.cropCanvas.width = responsiveWidth;
            this.buffer.width = responsiveWidth;
            canvas.width = responsiveWidth;
        }
        else {
            this.cropCanvas.width = this.cropWidth;
            this.buffer.width = canvas.width;
        }
        this.cropCanvas.height = this.cropHeight;
        this.buffer.height = canvas.height;
        this.canvas = canvas;
        this.ctx = this.canvas.getContext('2d');
        this.draw(this.ctx);
    };
    ImageCropper.prototype.updateSettings = function (cropperSettings) {
        this.cropperSettings = cropperSettings;
    };
    ImageCropper.prototype.resizeCanvas = function (width, height, setImage) {
        if (setImage === void 0) { setImage = false; }
        this.canvas.width = this.cropCanvas.width = this.width = this.canvasWidth = this.buffer.width = width;
        this.canvas.height = this.cropCanvas.height = this.height = this.canvasHeight = this.buffer.height = height;
        if (setImage) {
            this.setImage(this.srcImage);
        }
    };
    ImageCropper.prototype.reset = function () {
        this.setImage(undefined);
    };
    ImageCropper.prototype.draw = function (ctx) {
        var bounds = this.getBounds();
        if (this.srcImage) {
            ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight);
            var sourceAspect = this.srcImage.height / this.srcImage.width;
            var canvasAspect = this.canvasHeight / this.canvasWidth;
            var w = this.canvasWidth;
            var h = this.canvasHeight;
            if (canvasAspect > sourceAspect) {
                w = this.canvasWidth;
                h = this.canvasWidth * sourceAspect;
            }
            else {
                h = this.canvasHeight;
                w = this.canvasHeight / sourceAspect;
            }
            this.ratioW = w / this.srcImage.width;
            this.ratioH = h / this.srcImage.height;
            if (canvasAspect < sourceAspect) {
                this.drawImageIOSFix(ctx, this.srcImage, 0, 0, this.srcImage.width, this.srcImage.height, this.buffer.width / 2 - w / 2, 0, w, h);
            }
            else {
                this.drawImageIOSFix(ctx, this.srcImage, 0, 0, this.srcImage.width, this.srcImage.height, 0, this.buffer.height / 2 - h / 2, w, h);
            }
            this.buffer.getContext('2d')
                .drawImage(this.canvas, 0, 0, this.canvasWidth, this.canvasHeight);
            ctx.lineWidth = this.cropperSettings.cropperDrawSettings.strokeWidth;
            ctx.strokeStyle = this.cropperSettings.cropperDrawSettings.strokeColor; // 'rgba(255,228,0,1)';
            ctx.fillStyle = 'rgba(0, 0, 0, 0.6)';
            if (!this.cropperSettings.rounded) {
                ctx.fillRect(0, 0, this.canvasWidth, this.canvasHeight);
                ctx.drawImage(this.buffer, bounds.left, bounds.top, Math.max(bounds.width, 1), Math.max(bounds.height, 1), bounds.left, bounds.top, bounds.width, bounds.height);
                ctx.strokeRect(bounds.left, bounds.top, bounds.width, bounds.height);
            }
            else {
                ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
                ctx.save();
                ctx.beginPath();
                ctx.arc(bounds.left + bounds.width / 2, bounds.top + bounds.height / 2, bounds.width / 2, 0, 2 * Math.PI);
                ctx.clip();
                if (canvasAspect < sourceAspect) {
                    this.drawImageIOSFix(ctx, this.srcImage, 0, 0, this.srcImage.width, this.srcImage.height, this.buffer.width / 2 - w / 2, 0, w, h);
                }
                else {
                    this.drawImageIOSFix(ctx, this.srcImage, 0, 0, this.srcImage.width, this.srcImage.height, 0, this.buffer.height / 2 - h / 2, w, h);
                }
                ctx.restore();
            }
            var marker = void 0;
            for (var i = 0; i < this.markers.length; i++) {
                marker = this.markers[i];
                marker.draw(ctx);
            }
            this.center.draw(ctx);
        }
        else {
            ctx.fillStyle = 'rgba(192,192,192,1)';
            ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
        }
    };
    ImageCropper.prototype.dragCenter = function (x, y, marker) {
        var bounds = this.getBounds();
        var left = x - (bounds.width / 2);
        var right = x + (bounds.width / 2);
        var top = y - (bounds.height / 2);
        var bottom = y + (bounds.height / 2);
        if (right >= this.maxXClamp) {
            x = this.maxXClamp - bounds.width / 2;
        }
        if (left <= this.minXClamp) {
            x = bounds.width / 2 + this.minXClamp;
        }
        if (top < this.minYClamp) {
            y = bounds.height / 2 + this.minYClamp;
        }
        if (bottom >= this.maxYClamp) {
            y = this.maxYClamp - bounds.height / 2;
        }
        this.tl.moveX(x - (bounds.width / 2));
        this.tl.moveY(y - (bounds.height / 2));
        this.tr.moveX(x + (bounds.width / 2));
        this.tr.moveY(y - (bounds.height / 2));
        this.bl.moveX(x - (bounds.width / 2));
        this.bl.moveY(y + (bounds.height / 2));
        this.br.moveX(x + (bounds.width / 2));
        this.br.moveY(y + (bounds.height / 2));
        marker.setPosition(x, y);
    };
    ImageCropper.prototype.enforceMinSize = function (x, y, marker) {
        var xLength = x - marker.getHorizontalNeighbour().position.x;
        var yLength = y - marker.getVerticalNeighbour().position.y;
        var xOver = this.minWidth - Math.abs(xLength);
        var yOver = this.minHeight - Math.abs(yLength);
        if (xLength === 0 || yLength === 0) {
            x = marker.position.x;
            y = marker.position.y;
            return __WEBPACK_IMPORTED_MODULE_6__model_pointPool__["a" /* PointPool */].instance.borrow(x, y);
        }
        if (this.keepAspect) {
            if (xOver > 0 && (yOver / this.aspectRatio) > 0) {
                if (xOver > (yOver / this.aspectRatio)) {
                    if (xLength < 0) {
                        x -= xOver;
                        if (yLength < 0) {
                            y -= xOver * this.aspectRatio;
                        }
                        else {
                            y += xOver * this.aspectRatio;
                        }
                    }
                    else {
                        x += xOver;
                        if (yLength < 0) {
                            y -= xOver * this.aspectRatio;
                        }
                        else {
                            y += xOver * this.aspectRatio;
                        }
                    }
                }
                else {
                    if (yLength < 0) {
                        y -= yOver;
                        if (xLength < 0) {
                            x -= yOver / this.aspectRatio;
                        }
                        else {
                            x += yOver / this.aspectRatio;
                        }
                    }
                    else {
                        y += yOver;
                        if (xLength < 0) {
                            x -= yOver / this.aspectRatio;
                        }
                        else {
                            x += yOver / this.aspectRatio;
                        }
                    }
                }
            }
            else {
                if (xOver > 0) {
                    if (xLength < 0) {
                        x -= xOver;
                        if (yLength < 0) {
                            y -= xOver * this.aspectRatio;
                        }
                        else {
                            y += xOver * this.aspectRatio;
                        }
                    }
                    else {
                        x += xOver;
                        if (yLength < 0) {
                            y -= xOver * this.aspectRatio;
                        }
                        else {
                            y += xOver * this.aspectRatio;
                        }
                    }
                }
                else {
                    if (yOver > 0) {
                        if (yLength < 0) {
                            y -= yOver;
                            if (xLength < 0) {
                                x -= yOver / this.aspectRatio;
                            }
                            else {
                                x += yOver / this.aspectRatio;
                            }
                        }
                        else {
                            y += yOver;
                            if (xLength < 0) {
                                x -= yOver / this.aspectRatio;
                            }
                            else {
                                x += yOver / this.aspectRatio;
                            }
                        }
                    }
                }
            }
        }
        else {
            if (xOver > 0) {
                if (xLength < 0) {
                    x -= xOver;
                }
                else {
                    x += xOver;
                }
            }
            if (yOver > 0) {
                if (yLength < 0) {
                    y -= yOver;
                }
                else {
                    y += yOver;
                }
            }
        }
        if (x < this.minXClamp || x > this.maxXClamp || y < this.minYClamp || y > this.maxYClamp) {
            x = marker.position.x;
            y = marker.position.y;
        }
        return __WEBPACK_IMPORTED_MODULE_6__model_pointPool__["a" /* PointPool */].instance.borrow(x, y);
    };
    ImageCropper.prototype.dragCorner = function (x, y, marker) {
        var iX = 0;
        var iY = 0;
        var ax = 0;
        var ay = 0;
        var newHeight = 0;
        var newWidth = 0;
        var newY = 0;
        var newX = 0;
        var anchorMarker;
        var fold = 0;
        if (this.keepAspect) {
            anchorMarker = marker.getHorizontalNeighbour().getVerticalNeighbour();
            ax = anchorMarker.position.x;
            ay = anchorMarker.position.y;
            if (x <= anchorMarker.position.x) {
                if (y <= anchorMarker.position.y) {
                    iX = ax - (100 / this.aspectRatio);
                    iY = ay - (100 / this.aspectRatio * this.aspectRatio);
                    fold = this.getSide(__WEBPACK_IMPORTED_MODULE_6__model_pointPool__["a" /* PointPool */].instance.borrow(iX, iY), anchorMarker.position, __WEBPACK_IMPORTED_MODULE_6__model_pointPool__["a" /* PointPool */].instance.borrow(x, y));
                    if (fold > 0) {
                        newHeight = Math.abs(anchorMarker.position.y - y);
                        newWidth = newHeight / this.aspectRatio;
                        newY = anchorMarker.position.y - newHeight;
                        newX = anchorMarker.position.x - newWidth;
                        var min = this.enforceMinSize(newX, newY, marker);
                        marker.move(min.x, min.y);
                        __WEBPACK_IMPORTED_MODULE_6__model_pointPool__["a" /* PointPool */].instance.returnPoint(min);
                    }
                    else {
                        if (fold < 0) {
                            newWidth = Math.abs(anchorMarker.position.x - x);
                            newHeight = newWidth * this.aspectRatio;
                            newY = anchorMarker.position.y - newHeight;
                            newX = anchorMarker.position.x - newWidth;
                            var min = this.enforceMinSize(newX, newY, marker);
                            marker.move(min.x, min.y);
                            __WEBPACK_IMPORTED_MODULE_6__model_pointPool__["a" /* PointPool */].instance.returnPoint(min);
                        }
                    }
                }
                else {
                    iX = ax - (100 / this.aspectRatio);
                    iY = ay + (100 / this.aspectRatio * this.aspectRatio);
                    fold = this.getSide(__WEBPACK_IMPORTED_MODULE_6__model_pointPool__["a" /* PointPool */].instance.borrow(iX, iY), anchorMarker.position, __WEBPACK_IMPORTED_MODULE_6__model_pointPool__["a" /* PointPool */].instance.borrow(x, y));
                    if (fold > 0) {
                        newWidth = Math.abs(anchorMarker.position.x - x);
                        newHeight = newWidth * this.aspectRatio;
                        newY = anchorMarker.position.y + newHeight;
                        newX = anchorMarker.position.x - newWidth;
                        var min = this.enforceMinSize(newX, newY, marker);
                        marker.move(min.x, min.y);
                        __WEBPACK_IMPORTED_MODULE_6__model_pointPool__["a" /* PointPool */].instance.returnPoint(min);
                    }
                    else {
                        if (fold < 0) {
                            newHeight = Math.abs(anchorMarker.position.y - y);
                            newWidth = newHeight / this.aspectRatio;
                            newY = anchorMarker.position.y + newHeight;
                            newX = anchorMarker.position.x - newWidth;
                            var min = this.enforceMinSize(newX, newY, marker);
                            marker.move(min.x, min.y);
                            __WEBPACK_IMPORTED_MODULE_6__model_pointPool__["a" /* PointPool */].instance.returnPoint(min);
                        }
                    }
                }
            }
            else {
                if (y <= anchorMarker.position.y) {
                    iX = ax + (100 / this.aspectRatio);
                    iY = ay - (100 / this.aspectRatio * this.aspectRatio);
                    fold = this.getSide(__WEBPACK_IMPORTED_MODULE_6__model_pointPool__["a" /* PointPool */].instance.borrow(iX, iY), anchorMarker.position, __WEBPACK_IMPORTED_MODULE_6__model_pointPool__["a" /* PointPool */].instance.borrow(x, y));
                    if (fold < 0) {
                        newHeight = Math.abs(anchorMarker.position.y - y);
                        newWidth = newHeight / this.aspectRatio;
                        newY = anchorMarker.position.y - newHeight;
                        newX = anchorMarker.position.x + newWidth;
                        var min = this.enforceMinSize(newX, newY, marker);
                        marker.move(min.x, min.y);
                        __WEBPACK_IMPORTED_MODULE_6__model_pointPool__["a" /* PointPool */].instance.returnPoint(min);
                    }
                    else {
                        if (fold > 0) {
                            newWidth = Math.abs(anchorMarker.position.x - x);
                            newHeight = newWidth * this.aspectRatio;
                            newY = anchorMarker.position.y - newHeight;
                            newX = anchorMarker.position.x + newWidth;
                            var min = this.enforceMinSize(newX, newY, marker);
                            marker.move(min.x, min.y);
                            __WEBPACK_IMPORTED_MODULE_6__model_pointPool__["a" /* PointPool */].instance.returnPoint(min);
                        }
                    }
                }
                else {
                    iX = ax + (100 / this.aspectRatio);
                    iY = ay + (100 / this.aspectRatio * this.aspectRatio);
                    fold = this.getSide(__WEBPACK_IMPORTED_MODULE_6__model_pointPool__["a" /* PointPool */].instance.borrow(iX, iY), anchorMarker.position, __WEBPACK_IMPORTED_MODULE_6__model_pointPool__["a" /* PointPool */].instance.borrow(x, y));
                    if (fold < 0) {
                        newWidth = Math.abs(anchorMarker.position.x - x);
                        newHeight = newWidth * this.aspectRatio;
                        newY = anchorMarker.position.y + newHeight;
                        newX = anchorMarker.position.x + newWidth;
                        var min = this.enforceMinSize(newX, newY, marker);
                        marker.move(min.x, min.y);
                        __WEBPACK_IMPORTED_MODULE_6__model_pointPool__["a" /* PointPool */].instance.returnPoint(min);
                    }
                    else {
                        if (fold > 0) {
                            newHeight = Math.abs(anchorMarker.position.y - y);
                            newWidth = newHeight / this.aspectRatio;
                            newY = anchorMarker.position.y + newHeight;
                            newX = anchorMarker.position.x + newWidth;
                            var min = this.enforceMinSize(newX, newY, marker);
                            marker.move(min.x, min.y);
                            __WEBPACK_IMPORTED_MODULE_6__model_pointPool__["a" /* PointPool */].instance.returnPoint(min);
                        }
                    }
                }
            }
        }
        else {
            var min = this.enforceMinSize(x, y, marker);
            marker.move(min.x, min.y);
            __WEBPACK_IMPORTED_MODULE_6__model_pointPool__["a" /* PointPool */].instance.returnPoint(min);
        }
        this.center.recalculatePosition(this.getBounds());
    };
    ImageCropper.prototype.getSide = function (a, b, c) {
        var n = ImageCropper.sign((b.x - a.x) * (c.y - a.y) - (b.y - a.y) * (c.x - a.x));
        // TODO move the return of the pools to outside of this function
        __WEBPACK_IMPORTED_MODULE_6__model_pointPool__["a" /* PointPool */].instance.returnPoint(a);
        __WEBPACK_IMPORTED_MODULE_6__model_pointPool__["a" /* PointPool */].instance.returnPoint(c);
        return n;
    };
    ImageCropper.prototype.handleRelease = function (newCropTouch) {
        if (newCropTouch == null) {
            return;
        }
        var index = 0;
        for (var k = 0; k < this.currentDragTouches.length; k++) {
            if (newCropTouch.id === this.currentDragTouches[k].id) {
                this.currentDragTouches[k].dragHandle.setDrag(false);
                index = k;
            }
        }
        this.currentDragTouches.splice(index, 1);
        this.draw(this.ctx);
    };
    ImageCropper.prototype.handleMove = function (newCropTouch) {
        var matched = false;
        for (var k = 0; k < this.currentDragTouches.length; k++) {
            if (newCropTouch.id === this.currentDragTouches[k].id && this.currentDragTouches[k].dragHandle != null) {
                var dragTouch = this.currentDragTouches[k];
                var clampedPositions = this.clampPosition(newCropTouch.x - dragTouch.dragHandle.offset.x, newCropTouch.y - dragTouch.dragHandle.offset.y);
                newCropTouch.x = clampedPositions.x;
                newCropTouch.y = clampedPositions.y;
                __WEBPACK_IMPORTED_MODULE_6__model_pointPool__["a" /* PointPool */].instance.returnPoint(clampedPositions);
                if (dragTouch.dragHandle instanceof __WEBPACK_IMPORTED_MODULE_1__model_cornerMarker__["a" /* CornerMarker */]) {
                    this.dragCorner(newCropTouch.x, newCropTouch.y, dragTouch.dragHandle);
                }
                else {
                    this.dragCenter(newCropTouch.x, newCropTouch.y, dragTouch.dragHandle);
                }
                this.currentlyInteracting = true;
                matched = true;
                __WEBPACK_IMPORTED_MODULE_5__imageCropperDataShare__["a" /* ImageCropperDataShare */].setPressed(this.canvas);
                break;
            }
        }
        if (!matched) {
            for (var i = 0; i < this.markers.length; i++) {
                var marker = this.markers[i];
                if (marker.touchInBounds(newCropTouch.x, newCropTouch.y)) {
                    newCropTouch.dragHandle = marker;
                    this.currentDragTouches.push(newCropTouch);
                    marker.setDrag(true);
                    newCropTouch.dragHandle.offset.x = newCropTouch.x - newCropTouch.dragHandle.position.x;
                    newCropTouch.dragHandle.offset.y = newCropTouch.y - newCropTouch.dragHandle.position.y;
                    this.dragCorner(newCropTouch.x - newCropTouch.dragHandle.offset.x, newCropTouch.y - newCropTouch.dragHandle.offset.y, newCropTouch.dragHandle);
                    break;
                }
            }
            if (newCropTouch.dragHandle === null || typeof newCropTouch.dragHandle === 'undefined') {
                if (this.center.touchInBounds(newCropTouch.x, newCropTouch.y)) {
                    newCropTouch.dragHandle = this.center;
                    this.currentDragTouches.push(newCropTouch);
                    newCropTouch.dragHandle.setDrag(true);
                    newCropTouch.dragHandle.offset.x = newCropTouch.x - newCropTouch.dragHandle.position.x;
                    newCropTouch.dragHandle.offset.y = newCropTouch.y - newCropTouch.dragHandle.position.y;
                    this.dragCenter(newCropTouch.x - newCropTouch.dragHandle.offset.x, newCropTouch.y - newCropTouch.dragHandle.offset.y, newCropTouch.dragHandle);
                }
            }
        }
    };
    ImageCropper.prototype.updateClampBounds = function () {
        var sourceAspect = this.srcImage.height / this.srcImage.width;
        var canvasAspect = this.canvas.height / this.canvas.width;
        var w = this.canvas.width;
        var h = this.canvas.height;
        if (canvasAspect > sourceAspect) {
            w = this.canvas.width;
            h = this.canvas.width * sourceAspect;
        }
        else {
            h = this.canvas.height;
            w = this.canvas.height / sourceAspect;
        }
        this.minXClamp = this.canvas.width / 2 - w / 2;
        this.minYClamp = this.canvas.height / 2 - h / 2;
        this.maxXClamp = this.canvas.width / 2 + w / 2;
        this.maxYClamp = this.canvas.height / 2 + h / 2;
    };
    ImageCropper.prototype.getCropBounds = function () {
        var bounds = this.getBounds();
        bounds.top = Math.round((bounds.top - this.minYClamp) / this.ratioH);
        bounds.bottom = Math.round((bounds.bottom - this.minYClamp) / this.ratioH);
        bounds.left = Math.round((bounds.left - this.minXClamp) / this.ratioW);
        bounds.right = Math.round((bounds.right - this.minXClamp) / this.ratioW);
        return bounds;
    };
    ImageCropper.prototype.clampPosition = function (x, y) {
        if (x < this.minXClamp) {
            x = this.minXClamp;
        }
        if (x > this.maxXClamp) {
            x = this.maxXClamp;
        }
        if (y < this.minYClamp) {
            y = this.minYClamp;
        }
        if (y > this.maxYClamp) {
            y = this.maxYClamp;
        }
        return __WEBPACK_IMPORTED_MODULE_6__model_pointPool__["a" /* PointPool */].instance.borrow(x, y);
    };
    ImageCropper.prototype.isImageSet = function () {
        return this.imageSet;
    };
    ImageCropper.prototype.setImage = function (img) {
        this.srcImage = img;
        if (!img) {
            this.imageSet = false;
            this.draw(this.ctx);
        }
        else {
            this.imageSet = true;
            this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
            var bufferContext = this.buffer.getContext('2d');
            bufferContext.clearRect(0, 0, this.buffer.width, this.buffer.height);
            if (!this.cropperSettings.fileType)
                this.fileType = this.getDataUriMimeType(img.src);
            if (this.cropperSettings.minWithRelativeToResolution) {
                this.minWidth = (this.canvas.width * this.cropperSettings.minWidth / this.srcImage.width);
                this.minHeight = (this.canvas.height * this.cropperSettings.minHeight / this.srcImage.height);
            }
            this.updateClampBounds();
            this.canvasWidth = this.canvas.width;
            this.canvasHeight = this.canvas.height;
            var cropPosition = this.getCropPositionFromMarkers();
            this.setCropPosition(cropPosition);
        }
    };
    ImageCropper.prototype.updateCropPosition = function (cropBounds) {
        var cropPosition = this.getCropPositionFromBounds(cropBounds);
        this.setCropPosition(cropPosition);
    };
    ImageCropper.prototype.setCropPosition = function (cropPosition) {
        this.tl.setPosition(cropPosition[0].x, cropPosition[0].y);
        this.tr.setPosition(cropPosition[1].x, cropPosition[1].y);
        this.bl.setPosition(cropPosition[2].x, cropPosition[2].y);
        this.br.setPosition(cropPosition[3].x, cropPosition[3].y);
        this.center.setPosition(cropPosition[4].x, cropPosition[4].y);
        for (var _i = 0, cropPosition_1 = cropPosition; _i < cropPosition_1.length; _i++) {
            var position = cropPosition_1[_i];
            __WEBPACK_IMPORTED_MODULE_6__model_pointPool__["a" /* PointPool */].instance.returnPoint(position);
        }
        this.vertSquashRatio = ImageCropper.detectVerticalSquash(this.srcImage);
        this.draw(this.ctx);
        this.croppedImage = this.getCroppedImageHelper(false, this.cropWidth, this.cropHeight);
    };
    ImageCropper.prototype.getCropPositionFromMarkers = function () {
        var w = this.canvas.width;
        var h = this.canvas.height;
        var tlPos, trPos, blPos, brPos, center;
        var sourceAspect = this.srcImage.height / this.srcImage.width;
        var cropBounds = this.getBounds();
        var cropAspect = cropBounds.height / cropBounds.width;
        var cX = this.canvas.width / 2;
        var cY = this.canvas.height / 2;
        if (cropAspect > sourceAspect) {
            var imageH = Math.min(w * sourceAspect, h);
            var cropW = imageH / cropAspect;
            tlPos = __WEBPACK_IMPORTED_MODULE_6__model_pointPool__["a" /* PointPool */].instance.borrow(cX - cropW / 2, cY + imageH / 2);
            trPos = __WEBPACK_IMPORTED_MODULE_6__model_pointPool__["a" /* PointPool */].instance.borrow(cX + cropW / 2, cY + imageH / 2);
            blPos = __WEBPACK_IMPORTED_MODULE_6__model_pointPool__["a" /* PointPool */].instance.borrow(cX - cropW / 2, cY - imageH / 2);
            brPos = __WEBPACK_IMPORTED_MODULE_6__model_pointPool__["a" /* PointPool */].instance.borrow(cX + cropW / 2, cY - imageH / 2);
        }
        else {
            var imageW = Math.min(h / sourceAspect, w);
            var cropH = imageW * cropAspect;
            tlPos = __WEBPACK_IMPORTED_MODULE_6__model_pointPool__["a" /* PointPool */].instance.borrow(cX - imageW / 2, cY + cropH / 2);
            trPos = __WEBPACK_IMPORTED_MODULE_6__model_pointPool__["a" /* PointPool */].instance.borrow(cX + imageW / 2, cY + cropH / 2);
            blPos = __WEBPACK_IMPORTED_MODULE_6__model_pointPool__["a" /* PointPool */].instance.borrow(cX - imageW / 2, cY - cropH / 2);
            brPos = __WEBPACK_IMPORTED_MODULE_6__model_pointPool__["a" /* PointPool */].instance.borrow(cX + imageW / 2, cY - cropH / 2);
        }
        center = __WEBPACK_IMPORTED_MODULE_6__model_pointPool__["a" /* PointPool */].instance.borrow(cX, cY);
        var positions = [tlPos, trPos, blPos, brPos, center];
        return positions;
    };
    ImageCropper.prototype.getCropPositionFromBounds = function (cropPosition) {
        var marginTop = 0;
        var marginLeft = 0;
        var canvasAspect = this.canvasHeight / this.canvasWidth;
        var sourceAspect = this.srcImage.height / this.srcImage.width;
        if (canvasAspect > sourceAspect) {
            marginTop = this.buffer.height / 2 - (this.canvasWidth * sourceAspect) / 2;
        }
        else {
            marginLeft = this.buffer.width / 2 - (this.canvasHeight / sourceAspect) / 2;
        }
        var ratioW = (this.canvasWidth - marginLeft * 2) / this.srcImage.width;
        var ratioH = (this.canvasHeight - marginTop * 2) / this.srcImage.height;
        var actualH = cropPosition.height * ratioH;
        var actualW = cropPosition.width * ratioW;
        var actualX = cropPosition.left * ratioW + marginLeft;
        var actualY = cropPosition.top * ratioH + marginTop;
        if (this.keepAspect) {
            var scaledW = actualH / this.aspectRatio;
            var scaledH = actualW * this.aspectRatio;
            if (this.getCropBounds().height === cropPosition.height) {
                // only width changed
                actualH = scaledH;
            }
            else if (this.getCropBounds().width === cropPosition.width) {
                // only height changed
                actualW = scaledW;
            }
            else {
                // height and width changed
                if (Math.abs(scaledH - actualH) < Math.abs(scaledW - actualW)) {
                    actualW = scaledW;
                }
                else {
                    actualH = scaledH;
                }
            }
        }
        var tlPos = __WEBPACK_IMPORTED_MODULE_6__model_pointPool__["a" /* PointPool */].instance.borrow(actualX, actualY + actualH);
        var trPos = __WEBPACK_IMPORTED_MODULE_6__model_pointPool__["a" /* PointPool */].instance.borrow(actualX + actualW, actualY + actualH);
        var blPos = __WEBPACK_IMPORTED_MODULE_6__model_pointPool__["a" /* PointPool */].instance.borrow(actualX, actualY);
        var brPos = __WEBPACK_IMPORTED_MODULE_6__model_pointPool__["a" /* PointPool */].instance.borrow(actualX + actualW, actualY);
        var center = __WEBPACK_IMPORTED_MODULE_6__model_pointPool__["a" /* PointPool */].instance.borrow(actualX + actualW / 2, actualY + actualH / 2);
        var positions = [tlPos, trPos, blPos, brPos, center];
        return positions;
    };
    ImageCropper.prototype.getCroppedImageHelper = function (preserveSize, fillWidth, fillHeight) {
        if (this.cropperSettings.cropOnResize) {
            return this.getCroppedImage(preserveSize, fillWidth, fillHeight);
        }
        return this.croppedImage ? this.croppedImage : document.createElement('img');
    };
    // todo: Unused parameters?
    // todo: Unused parameters?
    ImageCropper.prototype.getCroppedImage = 
    // todo: Unused parameters?
    function (preserveSize, fillWidth, fillHeight) {
        var bounds = this.getBounds();
        if (!this.srcImage) {
            return document.createElement('img');
        }
        else {
            var sourceAspect = this.srcImage.height / this.srcImage.width;
            var canvasAspect = this.canvas.height / this.canvas.width;
            var w = this.canvas.width;
            var h = this.canvas.height;
            if (canvasAspect > sourceAspect) {
                w = this.canvas.width;
                h = this.canvas.width * sourceAspect;
            }
            else {
                if (canvasAspect < sourceAspect) {
                    h = this.canvas.height;
                    w = this.canvas.height / sourceAspect;
                }
                else {
                    h = this.canvas.height;
                    w = this.canvas.width;
                }
            }
            this.ratioW = w / this.srcImage.width;
            this.ratioH = h / this.srcImage.height;
            var offsetH = (this.buffer.height - h) / 2 / this.ratioH;
            var offsetW = (this.buffer.width - w) / 2 / this.ratioW;
            var ctx = this.cropCanvas.getContext('2d');
            if (this.cropperSettings.preserveSize || preserveSize) {
                var width = Math.round(bounds.right / this.ratioW - bounds.left / this.ratioW);
                var height = Math.round(bounds.bottom / this.ratioH - bounds.top / this.ratioH);
                this.cropCanvas.width = width;
                this.cropCanvas.height = height;
                this.cropperSettings.croppedWidth = this.cropCanvas.width;
                this.cropperSettings.croppedHeight = this.cropCanvas.height;
            }
            else {
                this.cropCanvas.width = this.cropWidth;
                this.cropCanvas.height = this.cropHeight;
            }
            ctx.clearRect(0, 0, this.cropCanvas.width, this.cropCanvas.height);
            this.drawImageIOSFix(ctx, this.srcImage, Math.max(Math.round((bounds.left) / this.ratioW - offsetW), 0), Math.max(Math.round(bounds.top / this.ratioH - offsetH), 0), Math.max(Math.round(bounds.width / this.ratioW), 1), Math.max(Math.round(bounds.height / this.ratioH), 1), 0, 0, this.cropCanvas.width, this.cropCanvas.height);
            if (this.cropperSettings.resampleFn) {
                this.cropperSettings.resampleFn(this.cropCanvas);
            }
            this.croppedImage.width = this.cropCanvas.width;
            this.croppedImage.height = this.cropCanvas.height;
            this.croppedImage.src = this.cropCanvas.toDataURL(this.fileType, this.cropperSettings.compressRatio);
            return this.croppedImage;
        }
    };
    ImageCropper.prototype.getBounds = function () {
        var minX = Number.MAX_VALUE;
        var minY = Number.MAX_VALUE;
        var maxX = -Number.MAX_VALUE;
        var maxY = -Number.MAX_VALUE;
        for (var i = 0; i < this.markers.length; i++) {
            var marker = this.markers[i];
            if (marker.position.x < minX) {
                minX = marker.position.x;
            }
            if (marker.position.x > maxX) {
                maxX = marker.position.x;
            }
            if (marker.position.y < minY) {
                minY = marker.position.y;
            }
            if (marker.position.y > maxY) {
                maxY = marker.position.y;
            }
        }
        var bounds = new __WEBPACK_IMPORTED_MODULE_0__model_bounds__["a" /* Bounds */]();
        bounds.left = minX;
        bounds.right = maxX;
        bounds.top = minY;
        bounds.bottom = maxY;
        return bounds;
    };
    ImageCropper.prototype.setBounds = function (bounds) {
        var topLeft;
        var topRight;
        var bottomLeft;
        var bottomRight;
        var currentBounds = this.getBounds();
        for (var i = 0; i < this.markers.length; i++) {
            var marker = this.markers[i];
            if (marker.position.x === currentBounds.left) {
                if (marker.position.y === currentBounds.top) {
                    marker.setPosition(bounds.left, bounds.top);
                }
                else {
                    marker.setPosition(bounds.left, bounds.bottom);
                }
            }
            else {
                if (marker.position.y === currentBounds.top) {
                    marker.setPosition(bounds.right, bounds.top);
                }
                else {
                    marker.setPosition(bounds.right, bounds.bottom);
                }
            }
        }
        this.center.recalculatePosition(bounds);
        this.center.draw(this.ctx);
        this.draw(this.ctx); // we need to redraw all canvas if we have changed bounds
    };
    ImageCropper.prototype.onTouchMove = function (event) {
        if (this.crop.isImageSet()) {
            if (event.touches.length === 1) {
                if (this.isMouseDown) {
                    event.preventDefault();
                    for (var i = 0; i < event.touches.length; i++) {
                        var touch = event.touches[i];
                        var touchPosition = ImageCropper.getTouchPos(this.canvas, touch);
                        var cropTouch = new __WEBPACK_IMPORTED_MODULE_2__model_cropTouch__["a" /* CropTouch */](touchPosition.x, touchPosition.y, touch.identifier);
                        __WEBPACK_IMPORTED_MODULE_6__model_pointPool__["a" /* PointPool */].instance.returnPoint(touchPosition);
                        this.move(cropTouch);
                    }
                }
            }
            else {
                if (event.touches.length === 2) {
                    event.preventDefault();
                    var distance = ((event.touches[0].clientX - event.touches[1].clientX) * (event.touches[0].clientX - event.touches[1].clientX)) + ((event.touches[0].clientY - event.touches[1].clientY) * (event.touches[0].clientY - event.touches[1].clientY));
                    if (this.previousDistance && this.previousDistance !== distance) {
                        var bounds = this.getBounds();
                        if (distance < this.previousDistance) {
                            bounds.top += 1;
                            bounds.left += 1;
                            bounds.right -= 1;
                            bounds.bottom -= 1;
                        }
                        if (distance > this.previousDistance) {
                            if (bounds.top !== this.minYClamp && bounds.bottom !== this.maxYClamp && bounds.left !== this.minXClamp && bounds.right !== this.maxXClamp) {
                                // none
                                bounds.top -= 1;
                                bounds.left -= 1;
                                bounds.right += 1;
                                bounds.bottom += 1;
                            }
                            else if (bounds.top !== this.minYClamp && bounds.bottom !== this.maxYClamp && bounds.left === this.minXClamp && bounds.right !== this.maxXClamp) {
                                // left
                                bounds.top -= 1;
                                bounds.right += 2;
                                bounds.bottom += 1;
                            }
                            else if (bounds.top !== this.minYClamp && bounds.bottom !== this.maxYClamp && bounds.left !== this.minXClamp && bounds.right === this.maxXClamp) {
                                // right
                                bounds.top -= 1;
                                bounds.left -= 2;
                                bounds.bottom += 1;
                            }
                            else if (bounds.top === this.minYClamp && bounds.bottom !== this.maxYClamp && bounds.left !== this.minXClamp && bounds.right !== this.maxXClamp) {
                                // top
                                bounds.left -= 1;
                                bounds.right += 1;
                                bounds.bottom += 2;
                            }
                            else if (bounds.top !== this.minYClamp && bounds.bottom === this.maxYClamp && bounds.left !== this.minXClamp && bounds.right !== this.maxXClamp) {
                                // bottom
                                bounds.top -= 2;
                                bounds.left -= 1;
                                bounds.right += 1;
                            }
                            else if (bounds.top === this.minYClamp && bounds.bottom !== this.maxYClamp && bounds.left === this.minXClamp && bounds.right !== this.maxXClamp) {
                                // top left
                                bounds.right += 2;
                                bounds.bottom += 2;
                            }
                            else if (bounds.top === this.minYClamp && bounds.bottom !== this.maxYClamp && bounds.left !== this.minXClamp && bounds.right === this.maxXClamp) {
                                // top right
                                bounds.left -= 2;
                                bounds.bottom += 2;
                            }
                            else if (bounds.top !== this.minYClamp && bounds.bottom === this.maxYClamp && bounds.left === this.minXClamp && bounds.right !== this.maxXClamp) {
                                // bottom left
                                bounds.top -= 2;
                                bounds.right += 2;
                            }
                            else if (bounds.top !== this.minYClamp && bounds.bottom === this.maxYClamp && bounds.left !== this.minXClamp && bounds.right === this.maxXClamp) {
                                // bottom right
                                bounds.top -= 2;
                                bounds.left -= 2;
                            }
                        }
                        if (bounds.top < this.minYClamp)
                            bounds.top = this.minYClamp;
                        if (bounds.bottom > this.maxYClamp)
                            bounds.bottom = this.maxYClamp;
                        if (bounds.left < this.minXClamp)
                            bounds.left = this.minXClamp;
                        if (bounds.right > this.maxXClamp)
                            bounds.right = this.maxXClamp;
                        this.setBounds(bounds);
                    }
                    this.previousDistance = distance;
                }
            }
            this.draw(this.ctx);
        }
    };
    ImageCropper.prototype.onMouseMove = function (e) {
        if (this.crop.isImageSet() && this.isMouseDown) {
            var mousePosition = ImageCropper.getMousePos(this.canvas, e);
            this.move(new __WEBPACK_IMPORTED_MODULE_2__model_cropTouch__["a" /* CropTouch */](mousePosition.x, mousePosition.y, 0));
            var dragTouch = this.getDragTouchForID(0);
            if (dragTouch) {
                dragTouch.x = mousePosition.x;
                dragTouch.y = mousePosition.y;
            }
            else {
                dragTouch = new __WEBPACK_IMPORTED_MODULE_2__model_cropTouch__["a" /* CropTouch */](mousePosition.x, mousePosition.y, 0);
            }
            __WEBPACK_IMPORTED_MODULE_6__model_pointPool__["a" /* PointPool */].instance.returnPoint(mousePosition);
            this.drawCursors(dragTouch);
            this.draw(this.ctx);
        }
    };
    ImageCropper.prototype.move = function (cropTouch) {
        if (this.isMouseDown) {
            this.handleMove(cropTouch);
        }
    };
    ImageCropper.prototype.getDragTouchForID = function (id) {
        for (var i = 0; i < this.currentDragTouches.length; i++) {
            if (id === this.currentDragTouches[i].id) {
                return this.currentDragTouches[i];
            }
        }
        return undefined;
    };
    ImageCropper.prototype.drawCursors = function (cropTouch) {
        var cursorDrawn = false;
        if (cropTouch != null) {
            if (cropTouch.dragHandle === this.center) {
                __WEBPACK_IMPORTED_MODULE_5__imageCropperDataShare__["a" /* ImageCropperDataShare */].setStyle(this.canvas, 'move');
                cursorDrawn = true;
            }
            if (cropTouch.dragHandle !== null && cropTouch.dragHandle instanceof __WEBPACK_IMPORTED_MODULE_1__model_cornerMarker__["a" /* CornerMarker */]) {
                this.drawCornerCursor(cropTouch.dragHandle, cropTouch.dragHandle.position.x, cropTouch.dragHandle.position.y);
                cursorDrawn = true;
            }
        }
        var didDraw = false;
        if (!cursorDrawn) {
            for (var i = 0; i < this.markers.length; i++) {
                didDraw = didDraw || this.drawCornerCursor(this.markers[i], cropTouch.x, cropTouch.y);
            }
            if (!didDraw) {
                __WEBPACK_IMPORTED_MODULE_5__imageCropperDataShare__["a" /* ImageCropperDataShare */].setStyle(this.canvas, 'initial');
            }
        }
        if (!didDraw && !cursorDrawn && this.center.touchInBounds(cropTouch.x, cropTouch.y)) {
            this.center.setOver(true);
            __WEBPACK_IMPORTED_MODULE_5__imageCropperDataShare__["a" /* ImageCropperDataShare */].setOver(this.canvas);
            __WEBPACK_IMPORTED_MODULE_5__imageCropperDataShare__["a" /* ImageCropperDataShare */].setStyle(this.canvas, 'move');
        }
        else {
            this.center.setOver(false);
        }
    };
    ImageCropper.prototype.drawCornerCursor = function (marker, x, y) {
        if (marker.touchInBounds(x, y)) {
            marker.setOver(true);
            if (marker.getHorizontalNeighbour().position.x > marker.position.x) {
                if (marker.getVerticalNeighbour().position.y > marker.position.y) {
                    __WEBPACK_IMPORTED_MODULE_5__imageCropperDataShare__["a" /* ImageCropperDataShare */].setOver(this.canvas);
                    __WEBPACK_IMPORTED_MODULE_5__imageCropperDataShare__["a" /* ImageCropperDataShare */].setStyle(this.canvas, 'nwse-resize');
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_5__imageCropperDataShare__["a" /* ImageCropperDataShare */].setOver(this.canvas);
                    __WEBPACK_IMPORTED_MODULE_5__imageCropperDataShare__["a" /* ImageCropperDataShare */].setStyle(this.canvas, 'nesw-resize');
                }
            }
            else {
                if (marker.getVerticalNeighbour().position.y > marker.position.y) {
                    __WEBPACK_IMPORTED_MODULE_5__imageCropperDataShare__["a" /* ImageCropperDataShare */].setOver(this.canvas);
                    __WEBPACK_IMPORTED_MODULE_5__imageCropperDataShare__["a" /* ImageCropperDataShare */].setStyle(this.canvas, 'nesw-resize');
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_5__imageCropperDataShare__["a" /* ImageCropperDataShare */].setOver(this.canvas);
                    __WEBPACK_IMPORTED_MODULE_5__imageCropperDataShare__["a" /* ImageCropperDataShare */].setStyle(this.canvas, 'nwse-resize');
                }
            }
            return true;
        }
        marker.setOver(false);
        return false;
    };
    ImageCropper.prototype.onTouchStart = function (event) {
        if (this.crop.isImageSet()) {
            var touch = event.touches[0];
            var touchPosition = ImageCropper.getTouchPos(this.canvas, touch);
            var cropTouch = new __WEBPACK_IMPORTED_MODULE_2__model_cropTouch__["a" /* CropTouch */](touchPosition.x, touchPosition.y, touch.identifier);
            __WEBPACK_IMPORTED_MODULE_6__model_pointPool__["a" /* PointPool */].instance.returnPoint(touchPosition);
            this.isMouseDown = false;
            for (var i = 0; i < this.markers.length; i++) {
                var marker = this.markers[i];
                if (marker.touchInBounds(cropTouch.x, cropTouch.y)) {
                    this.isMouseDown = true;
                }
            }
            if (this.center.touchInBounds(cropTouch.x, cropTouch.y)) {
                this.isMouseDown = true;
            }
        }
    };
    ImageCropper.prototype.onTouchEnd = function (event) {
        if (this.crop.isImageSet()) {
            for (var i = 0; i < event.changedTouches.length; i++) {
                var touch = event.changedTouches[i];
                var dragTouch = this.getDragTouchForID(touch.identifier);
                if (dragTouch && dragTouch !== undefined) {
                    if (dragTouch.dragHandle instanceof __WEBPACK_IMPORTED_MODULE_1__model_cornerMarker__["a" /* CornerMarker */] || dragTouch.dragHandle instanceof __WEBPACK_IMPORTED_MODULE_3__model_dragMarker__["a" /* DragMarker */]) {
                        dragTouch.dragHandle.setOver(false);
                    }
                    this.handleRelease(dragTouch);
                }
            }
            if (this.currentDragTouches.length === 0) {
                this.isMouseDown = false;
                this.currentlyInteracting = false;
            }
        }
    };
    // http://stackoverflow.com/questions/11929099/html5-canvas-drawimage-ratio-bug-ios
    // http://stackoverflow.com/questions/11929099/html5-canvas-drawimage-ratio-bug-ios
    ImageCropper.prototype.drawImageIOSFix = 
    // http://stackoverflow.com/questions/11929099/html5-canvas-drawimage-ratio-bug-ios
    function (ctx, img, sx, sy, sw, sh, dx, dy, dw, dh) {
        // Works only if whole image is displayed:
        // ctx.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh / vertSquashRatio);
        // The following works correct also when only a part of the image is displayed:
        // ctx.drawImage(img, sx * this.vertSquashRatio, sy * this.vertSquashRatio, sw * this.vertSquashRatio, sh *
        // this.vertSquashRatio, dx, dy, dw, dh);
        ctx.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);
    };
    ImageCropper.prototype.onMouseDown = function (event) {
        if (this.crop.isImageSet()) {
            this.isMouseDown = true;
        }
    };
    ImageCropper.prototype.onMouseUp = function (event) {
        if (this.crop.isImageSet()) {
            __WEBPACK_IMPORTED_MODULE_5__imageCropperDataShare__["a" /* ImageCropperDataShare */].setReleased(this.canvas);
            this.isMouseDown = false;
            this.handleRelease(new __WEBPACK_IMPORTED_MODULE_2__model_cropTouch__["a" /* CropTouch */](0, 0, 0));
        }
    };
    return ImageCropper;
}(__WEBPACK_IMPORTED_MODULE_4__model_imageCropperModel__["a" /* ImageCropperModel */]));

//# sourceMappingURL=imageCropper.js.map

/***/ }),

/***/ "./node_modules/ngx-img-cropper/src/imageCropperComponent.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ImageCropperComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__imageCropper__ = __webpack_require__("./node_modules/ngx-img-cropper/src/imageCropper.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cropperSettings__ = __webpack_require__("./node_modules/ngx-img-cropper/src/cropperSettings.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__exif__ = __webpack_require__("./node_modules/ngx-img-cropper/src/exif.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_cropPosition__ = __webpack_require__("./node_modules/ngx-img-cropper/src/model/cropPosition.js");





var ImageCropperComponent = /** @class */ (function () {
    function ImageCropperComponent(renderer) {
        this.cropPositionChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.onCrop = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.imageSet = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.renderer = renderer;
    }
    ImageCropperComponent.prototype.ngAfterViewInit = function () {
        var canvas = this.cropcanvas.nativeElement;
        if (!this.settings) {
            this.settings = new __WEBPACK_IMPORTED_MODULE_2__cropperSettings__["a" /* CropperSettings */]();
        }
        if (this.settings.cropperClass) {
            this.renderer.setAttribute(canvas, "class", this.settings.cropperClass);
        }
        if (!this.settings.dynamicSizing) {
            this.renderer.setAttribute(canvas, "width", this.settings.canvasWidth.toString());
            this.renderer.setAttribute(canvas, "height", this.settings.canvasHeight.toString());
        }
        else {
            this.windowListener = this.resize.bind(this);
            window.addEventListener("resize", this.windowListener);
        }
        if (!this.cropper) {
            this.cropper = new __WEBPACK_IMPORTED_MODULE_1__imageCropper__["a" /* ImageCropper */](this.settings);
        }
        this.cropper.prepare(canvas);
    };
    ImageCropperComponent.prototype.ngOnChanges = function (changes) {
        if (this.isCropPositionChanged(changes)) {
            this.cropper.updateCropPosition(this.cropPosition.toBounds());
            if (this.cropper.isImageSet()) {
                var bounds = this.cropper.getCropBounds();
                this.image.image = this.cropper.getCroppedImageHelper().src;
                this.onCrop.emit(bounds);
            }
            this.updateCropBounds();
        }
        if (changes.inputImage) {
            this.setImage(changes.inputImage.currentValue);
        }
        if (changes.settings && this.cropper && this.cropper.isImageSet()) {
            this.cropper.updateSettings(this.settings);
            this.image.image = this.cropper.getCroppedImageHelper().src;
            this.onCrop.emit(this.cropper.getCropBounds());
        }
    };
    ImageCropperComponent.prototype.ngOnDestroy = function () {
        if (this.settings.dynamicSizing && this.windowListener) {
            window.removeEventListener("resize", this.windowListener);
        }
    };
    ImageCropperComponent.prototype.onTouchMove = function (event) {
        this.cropper.onTouchMove(event);
    };
    ImageCropperComponent.prototype.onTouchStart = function (event) {
        this.cropper.onTouchStart(event);
    };
    ImageCropperComponent.prototype.onTouchEnd = function (event) {
        this.cropper.onTouchEnd(event);
        if (this.cropper.isImageSet()) {
            this.image.image = this.cropper.getCroppedImageHelper().src;
            this.onCrop.emit(this.cropper.getCropBounds());
            this.updateCropBounds();
        }
    };
    ImageCropperComponent.prototype.onMouseDown = function (event) {
        this.cropper.onMouseDown(event);
        // if (!this.cropper.isImageSet() && !this.settings.noFileInput) {
        //   // load img
        //   this.fileInput.nativeElement.click();
        // }
    };
    ImageCropperComponent.prototype.onMouseUp = function (event) {
        if (this.cropper.isImageSet()) {
            this.cropper.onMouseUp(event);
            this.image.image = this.cropper.getCroppedImageHelper().src;
            this.onCrop.emit(this.cropper.getCropBounds());
            this.updateCropBounds();
        }
    };
    ImageCropperComponent.prototype.onMouseMove = function (event) {
        this.cropper.onMouseMove(event);
    };
    ImageCropperComponent.prototype.fileChangeListener = function ($event) {
        var _this = this;
        if ($event.target.files.length === 0)
            return;
        var file = $event.target.files[0];
        if (this.settings.allowedFilesRegex.test(file.name)) {
            var image_1 = new Image();
            var fileReader = new FileReader();
            fileReader.addEventListener("loadend", function (loadEvent) {
                image_1.addEventListener("load", function () {
                    _this.setImage(image_1);
                });
                image_1.src = loadEvent.target.result;
            });
            fileReader.readAsDataURL(file);
        }
    };
    ImageCropperComponent.prototype.resize = function () {
        var canvas = this.cropcanvas.nativeElement;
        this.settings.canvasWidth = canvas.offsetWidth;
        this.settings.canvasHeight = canvas.offsetHeight;
        this.cropper.resizeCanvas(canvas.offsetWidth, canvas.offsetHeight, true);
    };
    ImageCropperComponent.prototype.reset = function () {
        this.cropper.reset();
        this.renderer.setAttribute(this.cropcanvas.nativeElement, "class", this.settings.cropperClass);
        this.image.image = this.cropper.getCroppedImageHelper().src;
    };
    ImageCropperComponent.prototype.setImage = function (image, newBounds) {
        var _this = this;
        if (newBounds === void 0) { newBounds = null; }
        this.imageSet.emit(true);
        this.renderer.setAttribute(this.cropcanvas.nativeElement, "class", this.settings.cropperClass + " " + this.settings.croppingClass);
        this.raf = window.requestAnimationFrame(function () {
            if (_this.raf) {
                window.cancelAnimationFrame(_this.raf);
            }
            if (image.naturalHeight > 0 && image.naturalWidth > 0) {
                image.height = image.naturalHeight;
                image.width = image.naturalWidth;
                window.cancelAnimationFrame(_this.raf);
                _this.getOrientedImage(image, function (img) {
                    if (_this.settings.dynamicSizing) {
                        var canvas = _this.cropcanvas.nativeElement;
                        _this.settings.canvasWidth = canvas.offsetWidth;
                        _this.settings.canvasHeight = canvas.offsetHeight;
                        _this.cropper.resizeCanvas(canvas.offsetWidth, canvas.offsetHeight, false);
                    }
                    _this.cropper.setImage(img);
                    if (_this.cropPosition && _this.cropPosition.isInitialized()) {
                        _this.cropper.updateCropPosition(_this.cropPosition.toBounds());
                    }
                    _this.image.original = img;
                    var bounds = _this.cropper.getCropBounds();
                    _this.image.image = _this.cropper.getCroppedImageHelper().src;
                    if (!_this.image) {
                        _this.image = image;
                    }
                    if (newBounds != null) {
                        bounds = newBounds;
                        _this.cropper.setBounds(bounds);
                        _this.cropper.updateCropPosition(bounds);
                    }
                    _this.onCrop.emit(bounds);
                });
            }
        });
    };
    ImageCropperComponent.prototype.isCropPositionChanged = function (changes) {
        if (this.cropper &&
            changes["cropPosition"] &&
            this.isCropPositionUpdateNeeded) {
            return true;
        }
        else {
            this.isCropPositionUpdateNeeded = true;
            return false;
        }
    };
    ImageCropperComponent.prototype.updateCropBounds = function () {
        var cropBound = this.cropper.getCropBounds();
        this.cropPositionChange.emit(new __WEBPACK_IMPORTED_MODULE_4__model_cropPosition__["a" /* CropPosition */](cropBound.left, cropBound.top, cropBound.width, cropBound.height));
        this.isCropPositionUpdateNeeded = false;
    };
    ImageCropperComponent.prototype.getOrientedImage = function (image, callback) {
        var img;
        __WEBPACK_IMPORTED_MODULE_3__exif__["a" /* Exif */].getData(image, function () {
            var orientation = __WEBPACK_IMPORTED_MODULE_3__exif__["a" /* Exif */].getTag(image, "Orientation");
            if ([3, 6, 8].indexOf(orientation) > -1) {
                var canvas = document.createElement("canvas"), ctx = canvas.getContext("2d"), cw = image.width, ch = image.height, cx = 0, cy = 0, deg = 0;
                switch (orientation) {
                    case 3:
                        cx = -image.width;
                        cy = -image.height;
                        deg = 180;
                        break;
                    case 6:
                        cw = image.height;
                        ch = image.width;
                        cy = -image.height;
                        deg = 90;
                        break;
                    case 8:
                        cw = image.height;
                        ch = image.width;
                        cx = -image.width;
                        deg = 270;
                        break;
                    default:
                        break;
                }
                canvas.width = cw;
                canvas.height = ch;
                ctx.rotate(deg * Math.PI / 180);
                ctx.drawImage(image, cx, cy);
                img = document.createElement("img");
                img.width = cw;
                img.height = ch;
                img.addEventListener("load", function () {
                    callback(img);
                });
                img.src = canvas.toDataURL("image/png");
            }
            else {
                img = image;
                callback(img);
            }
        });
    };
    ImageCropperComponent.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: "img-cropper",
                    template: "\n        <span class=\"ng2-imgcrop\">\n          <input *ngIf=\"!settings.noFileInput\" #fileInput type=\"file\" accept=\"image/*\" (change)=\"fileChangeListener($event)\">\n          <canvas #cropcanvas\n                  (mousedown)=\"onMouseDown($event)\"\n                  (mouseup)=\"onMouseUp($event)\"\n                  (mousemove)=\"onMouseMove($event)\"\n                  (mouseleave)=\"onMouseUp($event)\"\n                  (touchmove)=\"onTouchMove($event)\"\n                  (touchend)=\"onTouchEnd($event)\"\n                  (touchstart)=\"onTouchStart($event)\">\n          </canvas>\n        </span>\n      "
                },] },
    ];
    /** @nocollapse */
    ImageCropperComponent.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"], },
    ]; };
    ImageCropperComponent.propDecorators = {
        "cropcanvas": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"], args: ["cropcanvas", undefined,] },],
        "fileInput": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"], args: ["fileInput",] },],
        "settings": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ["settings",] },],
        "image": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ["image",] },],
        "inputImage": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ["inputImage",] },],
        "cropper": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "cropPosition": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "cropPositionChange": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "onCrop": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "imageSet": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    };
    return ImageCropperComponent;
}());

//# sourceMappingURL=imageCropperComponent.js.map

/***/ }),

/***/ "./node_modules/ngx-img-cropper/src/imageCropperDataShare.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ImageCropperDataShare; });
var ImageCropperDataShare = /** @class */ (function () {
    function ImageCropperDataShare() {
    }
    ImageCropperDataShare.setPressed = function (canvas) {
        this.pressed = canvas;
    };
    ImageCropperDataShare.setReleased = function (canvas) {
        if (canvas === this.pressed) {
            //  this.pressed = undefined;
        }
    };
    ImageCropperDataShare.setOver = function (canvas) {
        this.over = canvas;
    };
    ImageCropperDataShare.setStyle = function (canvas, style) {
        if (this.pressed !== undefined) {
            if (this.pressed === canvas) {
                // TODO: check this
                // angular.element(document.documentElement).css('cursor', style);
            }
        }
        else {
            if (canvas === this.over) {
                // TODO: check this
                // angular.element(document.documentElement).css('cursor', style);
            }
        }
    };
    ImageCropperDataShare.share = {};
    return ImageCropperDataShare;
}());

//# sourceMappingURL=imageCropperDataShare.js.map

/***/ }),

/***/ "./node_modules/ngx-img-cropper/src/imageCropperModule.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ImageCropperModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_common__ = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__imageCropperComponent__ = __webpack_require__("./node_modules/ngx-img-cropper/src/imageCropperComponent.js");



var ImageCropperModule = /** @class */ (function () {
    function ImageCropperModule() {
    }
    ImageCropperModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModule"], args: [{
                    imports: [__WEBPACK_IMPORTED_MODULE_0__angular_common__["CommonModule"]],
                    declarations: [__WEBPACK_IMPORTED_MODULE_2__imageCropperComponent__["a" /* ImageCropperComponent */]],
                    exports: [__WEBPACK_IMPORTED_MODULE_2__imageCropperComponent__["a" /* ImageCropperComponent */]]
                },] },
    ];
    /** @nocollapse */
    ImageCropperModule.ctorParameters = function () { return []; };
    return ImageCropperModule;
}());

//# sourceMappingURL=imageCropperModule.js.map

/***/ }),

/***/ "./node_modules/ngx-img-cropper/src/model/bounds.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Bounds; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pointPool__ = __webpack_require__("./node_modules/ngx-img-cropper/src/model/pointPool.js");

var Bounds = /** @class */ (function () {
    function Bounds(x, y, width, height) {
        if (x === void 0) {
            x = 0;
        }
        if (y === void 0) {
            y = 0;
        }
        if (width === void 0) {
            width = 0;
        }
        if (height === void 0) {
            height = 0;
        }
        this.left = x;
        this.right = x + width;
        this.top = y;
        this.bottom = y + height;
    }
    Object.defineProperty(Bounds.prototype, "width", {
        get: function () {
            return this.right - this.left;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Bounds.prototype, "height", {
        get: function () {
            return this.bottom - this.top;
        },
        enumerable: true,
        configurable: true
    });
    Bounds.prototype.getCentre = function () {
        var w = this.width;
        var h = this.height;
        return __WEBPACK_IMPORTED_MODULE_0__pointPool__["a" /* PointPool */].instance.borrow(this.left + w / 2, this.top + h / 2);
    };
    return Bounds;
}());

//# sourceMappingURL=bounds.js.map

/***/ }),

/***/ "./node_modules/ngx-img-cropper/src/model/cornerMarker.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CornerMarker; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__handle__ = __webpack_require__("./node_modules/ngx-img-cropper/src/model/handle.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var CornerMarker = /** @class */ (function (_super) {
    __extends(CornerMarker, _super);
    function CornerMarker(x, y, radius, cropperSettings) {
        return _super.call(this, x, y, radius, cropperSettings) || this;
    }
    CornerMarker.prototype.drawCornerBorder = function (ctx) {
        var sideLength = 10;
        if (this.over || this.drag) {
            sideLength = 12;
        }
        var hDirection = this.cropperSettings.markerSizeMultiplier;
        var vDirection = this.cropperSettings.markerSizeMultiplier;
        if (this.horizontalNeighbour.position.x < this.position.x) {
            hDirection = -this.cropperSettings.markerSizeMultiplier;
        }
        if (this.verticalNeighbour.position.y < this.position.y) {
            vDirection = -this.cropperSettings.markerSizeMultiplier;
        }
        if (this.cropperSettings.rounded) {
            var width = this.position.x - this.horizontalNeighbour.position.x;
            var height = this.position.y - this.verticalNeighbour.position.y;
            var offX = Math.round(Math.sin(Math.PI / 2) * Math.abs(width / 2)) / 4;
            var offY = Math.round(Math.sin(Math.PI / 2) * Math.abs(height / 2)) / 4;
            this.offset.x = hDirection > 0 ? offX : -offX;
            this.offset.y = vDirection > 0 ? offY : -offY;
        }
        else {
            this.offset.x = 0;
            this.offset.y = 0;
        }
        ctx.beginPath();
        if (this.cropperSettings.cropperDrawSettings.lineDash) {
            ctx.setLineDash([1, 3]);
        }
        ctx.lineJoin = "miter";
        ctx.moveTo(this.position.x + this.offset.x, this.position.y + this.offset.y);
        ctx.lineTo(this.position.x + this.offset.x + sideLength * hDirection, this.position.y + this.offset.y);
        ctx.lineTo(this.position.x + this.offset.x + sideLength * hDirection, this.position.y + this.offset.y + sideLength * vDirection);
        ctx.lineTo(this.position.x + this.offset.x, this.position.y + this.offset.y + sideLength * vDirection);
        ctx.lineTo(this.position.x + this.offset.x, this.position.y + this.offset.y);
        ctx.closePath();
        ctx.lineWidth = this.cropperSettings.cropperDrawSettings.strokeWidth;
        ctx.strokeStyle =
            this.cropperSettings.cropperDrawSettings.strokeColor ||
                "rgba(255,255,255,.7)";
        ctx.stroke();
    };
    CornerMarker.prototype.drawCornerFill = function (ctx) {
        var sideLength = 10;
        if (this.over || this.drag) {
            sideLength = 12;
        }
        var hDirection = this.cropperSettings.markerSizeMultiplier;
        var vDirection = this.cropperSettings.markerSizeMultiplier;
        if (this.horizontalNeighbour.position.x < this.position.x) {
            hDirection = -this.cropperSettings.markerSizeMultiplier;
        }
        if (this.verticalNeighbour.position.y < this.position.y) {
            vDirection = -this.cropperSettings.markerSizeMultiplier;
        }
        ctx.beginPath();
        if (this.cropperSettings.cropperDrawSettings.lineDash) {
            ctx.setLineDash([1, 3]);
        }
        ctx.moveTo(this.position.x + this.offset.x, this.position.y + this.offset.y);
        ctx.lineTo(this.position.x + this.offset.x + sideLength * hDirection, this.position.y + this.offset.y);
        ctx.lineTo(this.position.x + this.offset.x + sideLength * hDirection, this.position.y + this.offset.y + sideLength * vDirection);
        ctx.lineTo(this.position.x + this.offset.x, this.position.y + this.offset.y + sideLength * vDirection);
        ctx.lineTo(this.position.x + this.offset.x, this.position.y + this.offset.y);
        ctx.closePath();
        ctx.fillStyle =
            this.cropperSettings.cropperDrawSettings.strokeColor ||
                "rgba(255,255,255,.7)";
        ctx.fill();
    };
    CornerMarker.prototype.moveX = function (x) {
        this.setPosition(x, this.position.y);
    };
    CornerMarker.prototype.moveY = function (y) {
        this.setPosition(this.position.x, y);
    };
    CornerMarker.prototype.move = function (x, y) {
        this.setPosition(x, y);
        this.verticalNeighbour.moveX(x);
        this.horizontalNeighbour.moveY(y);
    };
    CornerMarker.prototype.addHorizontalNeighbour = function (neighbour) {
        this.horizontalNeighbour = neighbour;
    };
    CornerMarker.prototype.addVerticalNeighbour = function (neighbour) {
        this.verticalNeighbour = neighbour;
    };
    CornerMarker.prototype.getHorizontalNeighbour = function () {
        return this.horizontalNeighbour;
    };
    CornerMarker.prototype.getVerticalNeighbour = function () {
        return this.verticalNeighbour;
    };
    CornerMarker.prototype.draw = function (ctx) {
        this.drawCornerFill(ctx);
        this.drawCornerBorder(ctx);
    };
    return CornerMarker;
}(__WEBPACK_IMPORTED_MODULE_0__handle__["a" /* Handle */]));

//# sourceMappingURL=cornerMarker.js.map

/***/ }),

/***/ "./node_modules/ngx-img-cropper/src/model/cropPosition.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CropPosition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bounds__ = __webpack_require__("./node_modules/ngx-img-cropper/src/model/bounds.js");

var CropPosition = /** @class */ (function () {
    function CropPosition(x, y, w, h) {
        if (x === void 0) { x = 0; }
        if (y === void 0) { y = 0; }
        if (w === void 0) { w = 0; }
        if (h === void 0) { h = 0; }
        this.x = +x;
        this.y = +y;
        this.w = +w;
        this.h = +h;
    }
    CropPosition.prototype.toBounds = function () {
        return new __WEBPACK_IMPORTED_MODULE_0__bounds__["a" /* Bounds */](this.x, this.y, this.w, this.h);
    };
    CropPosition.prototype.isInitialized = function () {
        return this.x !== 0 && this.y !== 0 && this.w !== 0 && this.h !== 0;
    };
    return CropPosition;
}());

//# sourceMappingURL=cropPosition.js.map

/***/ }),

/***/ "./node_modules/ngx-img-cropper/src/model/cropTouch.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CropTouch; });
var CropTouch = /** @class */ (function () {
    function CropTouch(x, y, id) {
        if (x === void 0) { x = 0; }
        if (y === void 0) { y = 0; }
        if (id === void 0) { id = 0; }
        this.id = id;
        this.x = x;
        this.y = y;
    }
    return CropTouch;
}());

//# sourceMappingURL=cropTouch.js.map

/***/ }),

/***/ "./node_modules/ngx-img-cropper/src/model/dragMarker.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DragMarker; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__handle__ = __webpack_require__("./node_modules/ngx-img-cropper/src/model/handle.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pointPool__ = __webpack_require__("./node_modules/ngx-img-cropper/src/model/pointPool.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var DragMarker = /** @class */ (function (_super) {
    __extends(DragMarker, _super);
    function DragMarker(x, y, radius, cropperSettings) {
        var _this = _super.call(this, x, y, radius, cropperSettings) || this;
        _this.iconPoints = [];
        _this.scaledIconPoints = [];
        _this.getDragIconPoints(_this.iconPoints, 1);
        _this.getDragIconPoints(_this.scaledIconPoints, 1.2);
        return _this;
    }
    DragMarker.prototype.draw = function (ctx) {
        if (this.over || this.drag) {
            this.drawIcon(ctx, this.scaledIconPoints);
        }
        else {
            this.drawIcon(ctx, this.iconPoints);
        }
    };
    DragMarker.prototype.getDragIconPoints = function (arr, scale) {
        var maxLength = 17 * scale;
        var arrowWidth = 14 * scale;
        var arrowLength = 8 * scale;
        var connectorThroat = 4 * scale;
        arr.push(__WEBPACK_IMPORTED_MODULE_1__pointPool__["a" /* PointPool */].instance.borrow(-connectorThroat / 2, maxLength - arrowLength));
        arr.push(__WEBPACK_IMPORTED_MODULE_1__pointPool__["a" /* PointPool */].instance.borrow(-arrowWidth / 2, maxLength - arrowLength));
        arr.push(__WEBPACK_IMPORTED_MODULE_1__pointPool__["a" /* PointPool */].instance.borrow(0, maxLength));
        arr.push(__WEBPACK_IMPORTED_MODULE_1__pointPool__["a" /* PointPool */].instance.borrow(arrowWidth / 2, maxLength - arrowLength));
        arr.push(__WEBPACK_IMPORTED_MODULE_1__pointPool__["a" /* PointPool */].instance.borrow(connectorThroat / 2, maxLength - arrowLength));
        arr.push(__WEBPACK_IMPORTED_MODULE_1__pointPool__["a" /* PointPool */].instance.borrow(connectorThroat / 2, connectorThroat / 2));
        arr.push(__WEBPACK_IMPORTED_MODULE_1__pointPool__["a" /* PointPool */].instance.borrow(maxLength - arrowLength, connectorThroat / 2));
        arr.push(__WEBPACK_IMPORTED_MODULE_1__pointPool__["a" /* PointPool */].instance.borrow(maxLength - arrowLength, arrowWidth / 2));
        arr.push(__WEBPACK_IMPORTED_MODULE_1__pointPool__["a" /* PointPool */].instance.borrow(maxLength, 0));
        arr.push(__WEBPACK_IMPORTED_MODULE_1__pointPool__["a" /* PointPool */].instance.borrow(maxLength - arrowLength, -arrowWidth / 2));
        arr.push(__WEBPACK_IMPORTED_MODULE_1__pointPool__["a" /* PointPool */].instance.borrow(maxLength - arrowLength, -connectorThroat / 2));
        arr.push(__WEBPACK_IMPORTED_MODULE_1__pointPool__["a" /* PointPool */].instance.borrow(connectorThroat / 2, -connectorThroat / 2));
        arr.push(__WEBPACK_IMPORTED_MODULE_1__pointPool__["a" /* PointPool */].instance.borrow(connectorThroat / 2, -maxLength + arrowLength));
        arr.push(__WEBPACK_IMPORTED_MODULE_1__pointPool__["a" /* PointPool */].instance.borrow(arrowWidth / 2, -maxLength + arrowLength));
        arr.push(__WEBPACK_IMPORTED_MODULE_1__pointPool__["a" /* PointPool */].instance.borrow(0, -maxLength));
        arr.push(__WEBPACK_IMPORTED_MODULE_1__pointPool__["a" /* PointPool */].instance.borrow(-arrowWidth / 2, -maxLength + arrowLength));
        arr.push(__WEBPACK_IMPORTED_MODULE_1__pointPool__["a" /* PointPool */].instance.borrow(-connectorThroat / 2, -maxLength + arrowLength));
        arr.push(__WEBPACK_IMPORTED_MODULE_1__pointPool__["a" /* PointPool */].instance.borrow(-connectorThroat / 2, -connectorThroat / 2));
        arr.push(__WEBPACK_IMPORTED_MODULE_1__pointPool__["a" /* PointPool */].instance.borrow(-maxLength + arrowLength, -connectorThroat / 2));
        arr.push(__WEBPACK_IMPORTED_MODULE_1__pointPool__["a" /* PointPool */].instance.borrow(-maxLength + arrowLength, -arrowWidth / 2));
        arr.push(__WEBPACK_IMPORTED_MODULE_1__pointPool__["a" /* PointPool */].instance.borrow(-maxLength, 0));
        arr.push(__WEBPACK_IMPORTED_MODULE_1__pointPool__["a" /* PointPool */].instance.borrow(-maxLength + arrowLength, arrowWidth / 2));
        arr.push(__WEBPACK_IMPORTED_MODULE_1__pointPool__["a" /* PointPool */].instance.borrow(-maxLength + arrowLength, connectorThroat / 2));
        arr.push(__WEBPACK_IMPORTED_MODULE_1__pointPool__["a" /* PointPool */].instance.borrow(-connectorThroat / 2, connectorThroat / 2));
    };
    DragMarker.prototype.drawIcon = function (ctx, points) {
        if (this.cropperSettings.showCenterMarker) {
            ctx.beginPath();
            ctx.moveTo(points[0].x + this.position.x, points[0].y + this.position.y);
            for (var k = 0; k < points.length; k++) {
                var p = points[k];
                ctx.lineTo(p.x + this.position.x, p.y + this.position.y);
            }
            ctx.closePath();
            ctx.fillStyle = this.cropperSettings.cropperDrawSettings.dragIconFillColor;
            ctx.fill();
            ctx.lineWidth = this.cropperSettings.cropperDrawSettings.dragIconStrokeWidth;
            ctx.strokeStyle = this.cropperSettings.cropperDrawSettings.dragIconStrokeColor;
            ctx.stroke();
        }
    };
    DragMarker.prototype.recalculatePosition = function (bounds) {
        var c = bounds.getCentre();
        this.setPosition(c.x, c.y);
        __WEBPACK_IMPORTED_MODULE_1__pointPool__["a" /* PointPool */].instance.returnPoint(c);
    };
    return DragMarker;
}(__WEBPACK_IMPORTED_MODULE_0__handle__["a" /* Handle */]));

//# sourceMappingURL=dragMarker.js.map

/***/ }),

/***/ "./node_modules/ngx-img-cropper/src/model/handle.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Handle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__point__ = __webpack_require__("./node_modules/ngx-img-cropper/src/model/point.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cropperSettings__ = __webpack_require__("./node_modules/ngx-img-cropper/src/cropperSettings.js");


var Handle = /** @class */ (function () {
    function Handle(x, y, radius, settings) {
        this.cropperSettings = new __WEBPACK_IMPORTED_MODULE_1__cropperSettings__["a" /* CropperSettings */]();
        this.over = false;
        this.drag = false;
        this._position = new __WEBPACK_IMPORTED_MODULE_0__point__["a" /* Point */](x, y);
        this.offset = new __WEBPACK_IMPORTED_MODULE_0__point__["a" /* Point */](0, 0);
        this.radius = radius;
        this.cropperSettings = settings;
    }
    Handle.prototype.setDrag = function (value) {
        this.drag = value;
        this.setOver(value);
    };
    Handle.prototype.draw = function (ctx) {
        // this should't be empty
    };
    Handle.prototype.setOver = function (over) {
        this.over = over;
    };
    Handle.prototype.touchInBounds = function (x, y) {
        return (x > this.position.x - this.radius + this.offset.x &&
            x < this.position.x + this.radius + this.offset.x &&
            y > this.position.y - this.radius + this.offset.y &&
            y < this.position.y + this.radius + this.offset.y);
    };
    Object.defineProperty(Handle.prototype, "position", {
        get: function () {
            return this._position;
        },
        enumerable: true,
        configurable: true
    });
    Handle.prototype.setPosition = function (x, y) {
        this._position.x = x;
        this._position.y = y;
    };
    return Handle;
}());

//# sourceMappingURL=handle.js.map

/***/ }),

/***/ "./node_modules/ngx-img-cropper/src/model/imageCropperModel.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ImageCropperModel; });
var ImageCropperModel = /** @class */ (function () {
    function ImageCropperModel() {
    }
    return ImageCropperModel;
}());

//# sourceMappingURL=imageCropperModel.js.map

/***/ }),

/***/ "./node_modules/ngx-img-cropper/src/model/point.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Point; });
var Point = /** @class */ (function () {
    function Point(x, y) {
        if (x === void 0) { x = 0; }
        if (y === void 0) { y = 0; }
        this.x = x;
        this.y = y;
    }
    Object.defineProperty(Point.prototype, "next", {
        get: function () {
            return this._next;
        },
        set: function (p) {
            this._next = p;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Point.prototype, "prev", {
        get: function () {
            return this._prev;
        },
        set: function (p) {
            this._prev = p;
        },
        enumerable: true,
        configurable: true
    });
    return Point;
}());

//# sourceMappingURL=point.js.map

/***/ }),

/***/ "./node_modules/ngx-img-cropper/src/model/pointPool.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PointPool; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__point__ = __webpack_require__("./node_modules/ngx-img-cropper/src/model/point.js");

var PointPool = /** @class */ (function () {
    function PointPool(initialSize) {
        PointPool._instance = this;
        var prev = (this.firstAvailable = new __WEBPACK_IMPORTED_MODULE_0__point__["a" /* Point */]());
        for (var i = 1; i < initialSize; i++) {
            var p = new __WEBPACK_IMPORTED_MODULE_0__point__["a" /* Point */]();
            prev.next = p;
            prev = p;
        }
    }
    Object.defineProperty(PointPool, "instance", {
        get: function () {
            return PointPool._instance;
        },
        enumerable: true,
        configurable: true
    });
    PointPool.prototype.borrow = function (x, y) {
        if (this.firstAvailable == null) {
            throw "Pool exhausted";
        }
        this.borrowed++;
        var p = this.firstAvailable;
        this.firstAvailable = p.next;
        p.x = x;
        p.y = y;
        return p;
    };
    PointPool.prototype.returnPoint = function (p) {
        this.borrowed--;
        p.x = 0;
        p.y = 0;
        p.next = this.firstAvailable;
        this.firstAvailable = p;
    };
    return PointPool;
}());

//# sourceMappingURL=pointPool.js.map

/***/ }),

/***/ "./node_modules/ngx-pagination/dist/ngx-pagination.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵb", function() { return DEFAULT_STYLES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵa", function() { return DEFAULT_TEMPLATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgxPaginationModule", function() { return NgxPaginationModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PaginationService", function() { return PaginationService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PaginationControlsComponent", function() { return PaginationControlsComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PaginationControlsDirective", function() { return PaginationControlsDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PaginatePipe", function() { return PaginatePipe; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_common__ = __webpack_require__("./node_modules/@angular/common/esm5/common.js");



var PaginationService = /** @class */ (function () {
    function PaginationService() {
        this.change = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.instances = {};
        this.DEFAULT_ID = 'DEFAULT_PAGINATION_ID';
    }
    PaginationService.prototype.defaultId = function () { return this.DEFAULT_ID; };
    /**
     * Register a PaginationInstance with this service. Returns a
     * boolean value signifying whether the instance is new or
     * updated (true = new or updated, false = unchanged).
     */
    PaginationService.prototype.register = function (instance) {
        if (instance.id == null) {
            instance.id = this.DEFAULT_ID;
        }
        if (!this.instances[instance.id]) {
            this.instances[instance.id] = instance;
            return true;
        }
        else {
            return this.updateInstance(instance);
        }
    };
    /**
     * Check each property of the instance and update any that have changed. Return
     * true if any changes were made, else return false.
     */
    PaginationService.prototype.updateInstance = function (instance) {
        var changed = false;
        for (var prop in this.instances[instance.id]) {
            if (instance[prop] !== this.instances[instance.id][prop]) {
                this.instances[instance.id][prop] = instance[prop];
                changed = true;
            }
        }
        return changed;
    };
    /**
     * Returns the current page number.
     */
    PaginationService.prototype.getCurrentPage = function (id) {
        if (this.instances[id]) {
            return this.instances[id].currentPage;
        }
    };
    /**
     * Sets the current page number.
     */
    PaginationService.prototype.setCurrentPage = function (id, page) {
        if (this.instances[id]) {
            var instance = this.instances[id];
            var maxPage = Math.ceil(instance.totalItems / instance.itemsPerPage);
            if (page <= maxPage && 1 <= page) {
                this.instances[id].currentPage = page;
                this.change.emit(id);
            }
        }
    };
    /**
     * Sets the value of instance.totalItems
     */
    PaginationService.prototype.setTotalItems = function (id, totalItems) {
        if (this.instances[id] && 0 <= totalItems) {
            this.instances[id].totalItems = totalItems;
            this.change.emit(id);
        }
    };
    /**
     * Sets the value of instance.itemsPerPage.
     */
    PaginationService.prototype.setItemsPerPage = function (id, itemsPerPage) {
        if (this.instances[id]) {
            this.instances[id].itemsPerPage = itemsPerPage;
            this.change.emit(id);
        }
    };
    /**
     * Returns a clone of the pagination instance object matching the id. If no
     * id specified, returns the instance corresponding to the default id.
     */
    PaginationService.prototype.getInstance = function (id) {
        if (id === void 0) { id = this.DEFAULT_ID; }
        if (this.instances[id]) {
            return this.clone(this.instances[id]);
        }
        return {};
    };
    /**
     * Perform a shallow clone of an object.
     */
    PaginationService.prototype.clone = function (obj) {
        var target = {};
        for (var i in obj) {
            if (obj.hasOwnProperty(i)) {
                target[i] = obj[i];
            }
        }
        return target;
    };
    return PaginationService;
}());

var __decorate$1 = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var LARGE_NUMBER = Number.MAX_SAFE_INTEGER;
var PaginatePipe = /** @class */ (function () {
    function PaginatePipe(service) {
        this.service = service;
        // store the values from the last time the pipe was invoked
        this.state = {};
    }
    PaginatePipe.prototype.transform = function (collection, args) {
        // When an observable is passed through the AsyncPipe, it will output
        // `null` until the subscription resolves. In this case, we want to
        // use the cached data from the `state` object to prevent the NgFor
        // from flashing empty until the real values arrive.
        if (!(collection instanceof Array)) {
            var _id = args.id || this.service.defaultId();
            if (this.state[_id]) {
                return this.state[_id].slice;
            }
            else {
                return collection;
            }
        }
        var serverSideMode = args.totalItems && args.totalItems !== collection.length;
        var instance = this.createInstance(collection, args);
        var id = instance.id;
        var start, end;
        var perPage = instance.itemsPerPage;
        var emitChange = this.service.register(instance);
        if (!serverSideMode && collection instanceof Array) {
            perPage = +perPage || LARGE_NUMBER;
            start = (instance.currentPage - 1) * perPage;
            end = start + perPage;
            var isIdentical = this.stateIsIdentical(id, collection, start, end);
            if (isIdentical) {
                return this.state[id].slice;
            }
            else {
                var slice = collection.slice(start, end);
                this.saveState(id, collection, slice, start, end);
                this.service.change.emit(id);
                return slice;
            }
        }
        else {
            if (emitChange) {
                this.service.change.emit(id);
            }
            // save the state for server-side collection to avoid null
            // flash as new data loads.
            this.saveState(id, collection, collection, start, end);
            return collection;
        }
    };
    /**
     * Create an PaginationInstance object, using defaults for any optional properties not supplied.
     */
    PaginatePipe.prototype.createInstance = function (collection, config) {
        this.checkConfig(config);
        return {
            id: config.id != null ? config.id : this.service.defaultId(),
            itemsPerPage: +config.itemsPerPage || 0,
            currentPage: +config.currentPage || 1,
            totalItems: +config.totalItems || collection.length
        };
    };
    /**
     * Ensure the argument passed to the filter contains the required properties.
     */
    PaginatePipe.prototype.checkConfig = function (config) {
        var required = ['itemsPerPage', 'currentPage'];
        var missing = required.filter(function (prop) { return !(prop in config); });
        if (0 < missing.length) {
            throw new Error("PaginatePipe: Argument is missing the following required properties: " + missing.join(', '));
        }
    };
    /**
     * To avoid returning a brand new array each time the pipe is run, we store the state of the sliced
     * array for a given id. This means that the next time the pipe is run on this collection & id, we just
     * need to check that the collection, start and end points are all identical, and if so, return the
     * last sliced array.
     */
    PaginatePipe.prototype.saveState = function (id, collection, slice, start, end) {
        this.state[id] = {
            collection: collection,
            size: collection.length,
            slice: slice,
            start: start,
            end: end
        };
    };
    /**
     * For a given id, returns true if the collection, size, start and end values are identical.
     */
    PaginatePipe.prototype.stateIsIdentical = function (id, collection, start, end) {
        var state = this.state[id];
        if (!state) {
            return false;
        }
        var isMetaDataIdentical = state.size === collection.length &&
            state.start === start &&
            state.end === end;
        if (!isMetaDataIdentical) {
            return false;
        }
        return state.slice.every(function (element, index) { return element === collection[start + index]; });
    };
    PaginatePipe = __decorate$1([
        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Pipe"])({
            name: 'paginate',
            pure: false
        }),
        __metadata("design:paramtypes", [PaginationService])
    ], PaginatePipe);
    return PaginatePipe;
}());

/**
 * The default template and styles for the pagination links are borrowed directly
 * from Zurb Foundation 6: http://foundation.zurb.com/sites/docs/pagination.html
 */
var DEFAULT_TEMPLATE = "\n    <pagination-template  #p=\"paginationApi\"\n                         [id]=\"id\"\n                         [maxSize]=\"maxSize\"\n                         (pageChange)=\"pageChange.emit($event)\"\n                         (pageBoundsCorrection)=\"pageBoundsCorrection.emit($event)\">\n    <ul class=\"ngx-pagination\" \n        role=\"navigation\" \n        [attr.aria-label]=\"screenReaderPaginationLabel\" \n        [class.responsive]=\"responsive\"\n        *ngIf=\"!(autoHide && p.pages.length <= 1)\">\n\n        <li class=\"pagination-previous\" [class.disabled]=\"p.isFirstPage()\" *ngIf=\"directionLinks\"> \n            <a tabindex=\"0\" *ngIf=\"1 < p.getCurrent()\" (keyup.enter)=\"p.previous()\" (click)=\"p.previous()\" [attr.aria-label]=\"previousLabel + ' ' + screenReaderPageLabel\">\n                {{ previousLabel }} <span class=\"show-for-sr\">{{ screenReaderPageLabel }}</span>\n            </a>\n            <span *ngIf=\"p.isFirstPage()\">\n                {{ previousLabel }} <span class=\"show-for-sr\">{{ screenReaderPageLabel }}</span>\n            </span>\n        </li> \n\n        <li class=\"small-screen\">\n            {{ p.getCurrent() }} / {{ p.getLastPage() }}\n        </li>\n\n        <li [class.current]=\"p.getCurrent() === page.value\" \n            [class.ellipsis]=\"page.label === '...'\"\n            *ngFor=\"let page of p.pages\">\n            <a tabindex=\"0\" (keyup.enter)=\"p.setCurrent(page.value)\" (click)=\"p.setCurrent(page.value)\" *ngIf=\"p.getCurrent() !== page.value\">\n                <span class=\"show-for-sr\">{{ screenReaderPageLabel }} </span>\n                <span>{{ (page.label === '...') ? page.label : (page.label | number:'') }}</span>\n            </a>\n            <ng-container *ngIf=\"p.getCurrent() === page.value\">\n                <span class=\"show-for-sr\">{{ screenReaderCurrentLabel }} </span>\n                <span>{{ (page.label === '...') ? page.label : (page.label | number:'') }}</span> \n            </ng-container>\n        </li>\n\n        <li class=\"pagination-next\" [class.disabled]=\"p.isLastPage()\" *ngIf=\"directionLinks\">\n            <a tabindex=\"0\" *ngIf=\"!p.isLastPage()\" (keyup.enter)=\"p.next()\" (click)=\"p.next()\" [attr.aria-label]=\"nextLabel + ' ' + screenReaderPageLabel\">\n                 {{ nextLabel }} <span class=\"show-for-sr\">{{ screenReaderPageLabel }}</span>\n            </a>\n            <span *ngIf=\"p.isLastPage()\">\n                 {{ nextLabel }} <span class=\"show-for-sr\">{{ screenReaderPageLabel }}</span>\n            </span>\n        </li>\n\n    </ul>\n    </pagination-template>\n    ";
var DEFAULT_STYLES = "\n.ngx-pagination {\n  margin-left: 0;\n  margin-bottom: 1rem; }\n  .ngx-pagination::before, .ngx-pagination::after {\n    content: ' ';\n    display: table; }\n  .ngx-pagination::after {\n    clear: both; }\n  .ngx-pagination li {\n    -moz-user-select: none;\n    -webkit-user-select: none;\n    -ms-user-select: none;\n    margin-right: 0.0625rem;\n    border-radius: 0; }\n  .ngx-pagination li {\n    display: inline-block; }\n  .ngx-pagination a,\n  .ngx-pagination button {\n    color: #0a0a0a; \n    display: block;\n    padding: 0.1875rem 0.625rem;\n    border-radius: 0; }\n    .ngx-pagination a:hover,\n    .ngx-pagination button:hover {\n      background: #e6e6e6; }\n  .ngx-pagination .current {\n    padding: 0.1875rem 0.625rem;\n    background: #2199e8;\n    color: #fefefe;\n    cursor: default; }\n  .ngx-pagination .disabled {\n    padding: 0.1875rem 0.625rem;\n    color: #cacaca;\n    cursor: default; } \n    .ngx-pagination .disabled:hover {\n      background: transparent; }\n  .ngx-pagination a, .ngx-pagination button {\n    cursor: pointer; }\n\n.ngx-pagination .pagination-previous a::before,\n.ngx-pagination .pagination-previous.disabled::before { \n  content: '\u00AB';\n  display: inline-block;\n  margin-right: 0.5rem; }\n\n.ngx-pagination .pagination-next a::after,\n.ngx-pagination .pagination-next.disabled::after {\n  content: '\u00BB';\n  display: inline-block;\n  margin-left: 0.5rem; }\n\n.ngx-pagination .show-for-sr {\n  position: absolute !important;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0); }\n.ngx-pagination .small-screen {\n  display: none; }\n@media screen and (max-width: 601px) {\n  .ngx-pagination.responsive .small-screen {\n    display: inline-block; } \n  .ngx-pagination.responsive li:not(.small-screen):not(.pagination-previous):not(.pagination-next) {\n    display: none; }\n}\n  ";

var __decorate$2 = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1 = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
function coerceToBoolean(input) {
    return !!input && input !== 'false';
}
/**
 * The default pagination controls component. Actually just a default implementation of a custom template.
 */
var PaginationControlsComponent = /** @class */ (function () {
    function PaginationControlsComponent() {
        this.maxSize = 7;
        this.previousLabel = 'Previous';
        this.nextLabel = 'Next';
        this.screenReaderPaginationLabel = 'Pagination';
        this.screenReaderPageLabel = 'page';
        this.screenReaderCurrentLabel = "You're on page";
        this.pageChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.pageBoundsCorrection = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this._directionLinks = true;
        this._autoHide = false;
        this._responsive = false;
    }
    Object.defineProperty(PaginationControlsComponent.prototype, "directionLinks", {
        get: function () {
            return this._directionLinks;
        },
        set: function (value) {
            this._directionLinks = coerceToBoolean(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PaginationControlsComponent.prototype, "autoHide", {
        get: function () {
            return this._autoHide;
        },
        set: function (value) {
            this._autoHide = coerceToBoolean(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PaginationControlsComponent.prototype, "responsive", {
        get: function () {
            return this._responsive;
        },
        set: function (value) {
            this._responsive = coerceToBoolean(value);
        },
        enumerable: true,
        configurable: true
    });
    __decorate$2([
        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
        __metadata$1("design:type", String)
    ], PaginationControlsComponent.prototype, "id", void 0);
    __decorate$2([
        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
        __metadata$1("design:type", Number)
    ], PaginationControlsComponent.prototype, "maxSize", void 0);
    __decorate$2([
        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
        __metadata$1("design:type", Boolean),
        __metadata$1("design:paramtypes", [Boolean])
    ], PaginationControlsComponent.prototype, "directionLinks", null);
    __decorate$2([
        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
        __metadata$1("design:type", Boolean),
        __metadata$1("design:paramtypes", [Boolean])
    ], PaginationControlsComponent.prototype, "autoHide", null);
    __decorate$2([
        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
        __metadata$1("design:type", Boolean),
        __metadata$1("design:paramtypes", [Boolean])
    ], PaginationControlsComponent.prototype, "responsive", null);
    __decorate$2([
        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
        __metadata$1("design:type", String)
    ], PaginationControlsComponent.prototype, "previousLabel", void 0);
    __decorate$2([
        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
        __metadata$1("design:type", String)
    ], PaginationControlsComponent.prototype, "nextLabel", void 0);
    __decorate$2([
        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
        __metadata$1("design:type", String)
    ], PaginationControlsComponent.prototype, "screenReaderPaginationLabel", void 0);
    __decorate$2([
        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
        __metadata$1("design:type", String)
    ], PaginationControlsComponent.prototype, "screenReaderPageLabel", void 0);
    __decorate$2([
        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
        __metadata$1("design:type", String)
    ], PaginationControlsComponent.prototype, "screenReaderCurrentLabel", void 0);
    __decorate$2([
        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
        __metadata$1("design:type", __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"])
    ], PaginationControlsComponent.prototype, "pageChange", void 0);
    __decorate$2([
        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
        __metadata$1("design:type", __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"])
    ], PaginationControlsComponent.prototype, "pageBoundsCorrection", void 0);
    PaginationControlsComponent = __decorate$2([
        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            selector: 'pagination-controls',
            template: DEFAULT_TEMPLATE,
            styles: [DEFAULT_STYLES],
            changeDetection: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectionStrategy"].OnPush,
            encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None
        })
    ], PaginationControlsComponent);
    return PaginationControlsComponent;
}());

var __decorate$3 = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$2 = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/**
 * This directive is what powers all pagination controls components, including the default one.
 * It exposes an API which is hooked up to the PaginationService to keep the PaginatePipe in sync
 * with the pagination controls.
 */
var PaginationControlsDirective = /** @class */ (function () {
    function PaginationControlsDirective(service, changeDetectorRef) {
        var _this = this;
        this.service = service;
        this.changeDetectorRef = changeDetectorRef;
        this.maxSize = 7;
        this.pageChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.pageBoundsCorrection = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.pages = [];
        this.changeSub = this.service.change
            .subscribe(function (id) {
            if (_this.id === id) {
                _this.updatePageLinks();
                _this.changeDetectorRef.markForCheck();
                _this.changeDetectorRef.detectChanges();
            }
        });
    }
    PaginationControlsDirective.prototype.ngOnInit = function () {
        if (this.id === undefined) {
            this.id = this.service.defaultId();
        }
        this.updatePageLinks();
    };
    PaginationControlsDirective.prototype.ngOnChanges = function (changes) {
        this.updatePageLinks();
    };
    PaginationControlsDirective.prototype.ngOnDestroy = function () {
        this.changeSub.unsubscribe();
    };
    /**
     * Go to the previous page
     */
    PaginationControlsDirective.prototype.previous = function () {
        this.checkValidId();
        this.setCurrent(this.getCurrent() - 1);
    };
    /**
     * Go to the next page
     */
    PaginationControlsDirective.prototype.next = function () {
        this.checkValidId();
        this.setCurrent(this.getCurrent() + 1);
    };
    /**
     * Returns true if current page is first page
     */
    PaginationControlsDirective.prototype.isFirstPage = function () {
        return this.getCurrent() === 1;
    };
    /**
     * Returns true if current page is last page
     */
    PaginationControlsDirective.prototype.isLastPage = function () {
        return this.getLastPage() === this.getCurrent();
    };
    /**
     * Set the current page number.
     */
    PaginationControlsDirective.prototype.setCurrent = function (page) {
        this.pageChange.emit(page);
    };
    /**
     * Get the current page number.
     */
    PaginationControlsDirective.prototype.getCurrent = function () {
        return this.service.getCurrentPage(this.id);
    };
    /**
     * Returns the last page number
     */
    PaginationControlsDirective.prototype.getLastPage = function () {
        var inst = this.service.getInstance(this.id);
        if (inst.totalItems < 1) {
            // when there are 0 or fewer (an error case) items, there are no "pages" as such,
            // but it makes sense to consider a single, empty page as the last page.
            return 1;
        }
        return Math.ceil(inst.totalItems / inst.itemsPerPage);
    };
    PaginationControlsDirective.prototype.getTotalItems = function () {
        return this.service.getInstance(this.id).totalItems;
    };
    PaginationControlsDirective.prototype.checkValidId = function () {
        if (this.service.getInstance(this.id).id == null) {
            console.warn("PaginationControlsDirective: the specified id \"" + this.id + "\" does not match any registered PaginationInstance");
        }
    };
    /**
     * Updates the page links and checks that the current page is valid. Should run whenever the
     * PaginationService.change stream emits a value matching the current ID, or when any of the
     * input values changes.
     */
    PaginationControlsDirective.prototype.updatePageLinks = function () {
        var _this = this;
        var inst = this.service.getInstance(this.id);
        var correctedCurrentPage = this.outOfBoundCorrection(inst);
        if (correctedCurrentPage !== inst.currentPage) {
            setTimeout(function () {
                _this.pageBoundsCorrection.emit(correctedCurrentPage);
                _this.pages = _this.createPageArray(inst.currentPage, inst.itemsPerPage, inst.totalItems, _this.maxSize);
            });
        }
        else {
            this.pages = this.createPageArray(inst.currentPage, inst.itemsPerPage, inst.totalItems, this.maxSize);
        }
    };
    /**
     * Checks that the instance.currentPage property is within bounds for the current page range.
     * If not, return a correct value for currentPage, or the current value if OK.
     */
    PaginationControlsDirective.prototype.outOfBoundCorrection = function (instance) {
        var totalPages = Math.ceil(instance.totalItems / instance.itemsPerPage);
        if (totalPages < instance.currentPage && 0 < totalPages) {
            return totalPages;
        }
        else if (instance.currentPage < 1) {
            return 1;
        }
        return instance.currentPage;
    };
    /**
     * Returns an array of Page objects to use in the pagination controls.
     */
    PaginationControlsDirective.prototype.createPageArray = function (currentPage, itemsPerPage, totalItems, paginationRange) {
        // paginationRange could be a string if passed from attribute, so cast to number.
        paginationRange = +paginationRange;
        var pages = [];
        var totalPages = Math.ceil(totalItems / itemsPerPage);
        var halfWay = Math.ceil(paginationRange / 2);
        var isStart = currentPage <= halfWay;
        var isEnd = totalPages - halfWay < currentPage;
        var isMiddle = !isStart && !isEnd;
        var ellipsesNeeded = paginationRange < totalPages;
        var i = 1;
        while (i <= totalPages && i <= paginationRange) {
            var label = void 0;
            var pageNumber = this.calculatePageNumber(i, currentPage, paginationRange, totalPages);
            var openingEllipsesNeeded = (i === 2 && (isMiddle || isEnd));
            var closingEllipsesNeeded = (i === paginationRange - 1 && (isMiddle || isStart));
            if (ellipsesNeeded && (openingEllipsesNeeded || closingEllipsesNeeded)) {
                label = '...';
            }
            else {
                label = pageNumber;
            }
            pages.push({
                label: label,
                value: pageNumber
            });
            i++;
        }
        return pages;
    };
    /**
     * Given the position in the sequence of pagination links [i],
     * figure out what page number corresponds to that position.
     */
    PaginationControlsDirective.prototype.calculatePageNumber = function (i, currentPage, paginationRange, totalPages) {
        var halfWay = Math.ceil(paginationRange / 2);
        if (i === paginationRange) {
            return totalPages;
        }
        else if (i === 1) {
            return i;
        }
        else if (paginationRange < totalPages) {
            if (totalPages - halfWay < currentPage) {
                return totalPages - paginationRange + i;
            }
            else if (halfWay < currentPage) {
                return currentPage - halfWay + i;
            }
            else {
                return i;
            }
        }
        else {
            return i;
        }
    };
    __decorate$3([
        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
        __metadata$2("design:type", String)
    ], PaginationControlsDirective.prototype, "id", void 0);
    __decorate$3([
        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
        __metadata$2("design:type", Number)
    ], PaginationControlsDirective.prototype, "maxSize", void 0);
    __decorate$3([
        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
        __metadata$2("design:type", __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"])
    ], PaginationControlsDirective.prototype, "pageChange", void 0);
    __decorate$3([
        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
        __metadata$2("design:type", __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"])
    ], PaginationControlsDirective.prototype, "pageBoundsCorrection", void 0);
    PaginationControlsDirective = __decorate$3([
        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"])({
            selector: 'pagination-template,[pagination-template]',
            exportAs: 'paginationApi'
        }),
        __metadata$2("design:paramtypes", [PaginationService,
            __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"]])
    ], PaginationControlsDirective);
    return PaginationControlsDirective;
}());

var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var NgxPaginationModule = /** @class */ (function () {
    function NgxPaginationModule() {
    }
    NgxPaginationModule = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"])({
            imports: [__WEBPACK_IMPORTED_MODULE_1__angular_common__["CommonModule"]],
            declarations: [
                PaginatePipe,
                PaginationControlsComponent,
                PaginationControlsDirective
            ],
            providers: [PaginationService],
            exports: [PaginatePipe, PaginationControlsComponent, PaginationControlsDirective]
        })
    ], NgxPaginationModule);
    return NgxPaginationModule;
}());

/**
 * Generated bundle index. Do not edit.
 */




/***/ }),

/***/ "./node_modules/ngx-quill/fesm5/ngx-quill.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QUILL_CONFIG_TOKEN", function() { return QUILL_CONFIG_TOKEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QuillEditorComponent", function() { return QuillEditorComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QuillModule", function() { return QuillModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultModules", function() { return defaultModules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵ0", function() { return ɵ0; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("./node_modules/tslib/tslib.es6.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_common__ = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_platform_browser__ = __webpack_require__("./node_modules/@angular/platform-browser/esm5/platform-browser.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_forms__ = __webpack_require__("./node_modules/@angular/forms/esm5/forms.js");






var defaultModules = {
    toolbar: [
        ['bold', 'italic', 'underline', 'strike'],
        ['blockquote', 'code-block'],
        [{ header: 1 }, { header: 2 }],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ script: 'sub' }, { script: 'super' }],
        [{ indent: '-1' }, { indent: '+1' }],
        [{ direction: 'rtl' }],
        [{ size: ['small', false, 'large', 'huge'] }],
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        [
            { color: [] },
            { background: [] }
        ],
        [{ font: [] }],
        [{ align: [] }],
        ['clean'],
        ['link', 'image', 'video'] // link and image, video
    ]
};

var QUILL_CONFIG_TOKEN = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["InjectionToken"]('config');

// tslint:disable-next-line:variable-name
var Quill = null;
var QuillEditorComponent = /** @class */ (function () {
    function QuillEditorComponent(elementRef, domSanitizer, doc, 
    // tslint:disable-next-line:ban-types
    platformId, renderer, zone, config) {
        var _this = this;
        this.elementRef = elementRef;
        this.domSanitizer = domSanitizer;
        this.doc = doc;
        this.platformId = platformId;
        this.renderer = renderer;
        this.zone = zone;
        this.config = config;
        this.format = 'html';
        this.required = false;
        this.customToolbarPosition = 'top';
        this.sanitize = false;
        this.style = null;
        this.strict = true;
        this.customOptions = [];
        this.preserveWhitespace = false;
        this.onEditorCreated = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
        this.onContentChanged = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
        this.onSelectionChanged = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
        this.onFocus = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
        this.onBlur = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
        this.disabled = false; // used to store initial value before ViewInit
        this.valueGetter = function (quillEditor, editorElement) {
            var html = editorElement.querySelector('.ql-editor').innerHTML;
            if (html === '<p><br></p>' || html === '<div><br><div>') {
                html = null;
            }
            var modelValue = html;
            if (_this.format === 'text') {
                modelValue = quillEditor.getText();
            }
            else if (_this.format === 'object') {
                modelValue = quillEditor.getContents();
            }
            else if (_this.format === 'json') {
                try {
                    modelValue = JSON.stringify(quillEditor.getContents());
                }
                catch (e) {
                    modelValue = quillEditor.getText();
                }
            }
            return modelValue;
        };
        this.valueSetter = function (quillEditor, value) {
            if (_this.format === 'html') {
                if (_this.sanitize) {
                    value = _this.domSanitizer.sanitize(__WEBPACK_IMPORTED_MODULE_1__angular_core__["SecurityContext"].HTML, value);
                }
                return quillEditor.clipboard.convert(value);
            }
            else if (_this.format === 'json') {
                try {
                    return JSON.parse(value);
                }
                catch (e) {
                    return [{ insert: value }];
                }
            }
            return value;
        };
        this.selectionChangeHandler = function (range, oldRange, source) {
            _this.zone.run(function () {
                if (range === null) {
                    _this.onBlur.emit({
                        editor: _this.quillEditor,
                        source: source
                    });
                }
                else if (oldRange === null) {
                    _this.onFocus.emit({
                        editor: _this.quillEditor,
                        source: source
                    });
                }
                _this.onSelectionChanged.emit({
                    editor: _this.quillEditor,
                    oldRange: oldRange,
                    range: range,
                    source: source
                });
                if (!range && _this.onModelTouched) {
                    _this.onModelTouched();
                }
            });
        };
        this.textChangeHandler = function (delta, oldDelta, source) {
            // only emit changes emitted by user interactions
            var text = _this.quillEditor.getText();
            var content = _this.quillEditor.getContents();
            var html = _this.editorElem.querySelector('.ql-editor').innerHTML;
            if (html === '<p><br></p>' || html === '<div><br><div>') {
                html = null;
            }
            _this.zone.run(function () {
                var trackChanges = _this.trackChanges || _this.config.trackChanges;
                if ((source === Quill.sources.USER || trackChanges && trackChanges === 'all') && _this.onModelChange) {
                    _this.onModelChange(_this.valueGetter(_this.quillEditor, _this.editorElem));
                }
                _this.onContentChanged.emit({
                    content: content,
                    delta: delta,
                    editor: _this.quillEditor,
                    html: html,
                    oldDelta: oldDelta,
                    source: source,
                    text: text
                });
            });
        };
    }
    QuillEditorComponent_1 = QuillEditorComponent;
    // tslint:disable-next-line:no-empty
    QuillEditorComponent.prototype.onModelChange = function (_modelValue) { };
    // tslint:disable-next-line:no-empty
    QuillEditorComponent.prototype.onModelTouched = function () { };
    QuillEditorComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        if (Object(__WEBPACK_IMPORTED_MODULE_2__angular_common__["isPlatformServer"])(this.platformId)) {
            return;
        }
        if (!Quill) {
            Quill = __webpack_require__("./node_modules/quill/dist/quill.js");
        }
        this.elementRef.nativeElement.insertAdjacentHTML(this.customToolbarPosition === 'top' ? 'beforeend' : 'afterbegin', this.preserveWhitespace ? '<pre quill-editor-element></pre>' : '<div quill-editor-element></div>');
        this.editorElem = this.elementRef.nativeElement.querySelector('[quill-editor-element]');
        var toolbarElem = this.elementRef.nativeElement.querySelector('[quill-editor-toolbar]');
        var modules = this.modules || (this.config.modules || defaultModules);
        if (modules.toolbar === undefined) {
            modules.toolbar = defaultModules.toolbar;
        }
        var placeholder = this.placeholder !== undefined ? this.placeholder : this.config.placeholder;
        if (placeholder === undefined) {
            placeholder = 'Insert text here ...';
        }
        if (toolbarElem) {
            // tslint:disable-next-line:no-string-literal
            modules['toolbar'] = toolbarElem;
        }
        if (this.style) {
            Object.keys(this.style).forEach(function (key) {
                _this.renderer.setStyle(_this.editorElem, key, _this.style[key]);
            });
        }
        this.customOptions.forEach(function (customOption) {
            var newCustomOption = Quill.import(customOption.import);
            newCustomOption.whitelist = customOption.whitelist;
            Quill.register(newCustomOption, true);
        });
        var bounds = this.bounds && this.bounds === 'self' ? this.editorElem : this.bounds;
        if (!bounds) {
            bounds = this.config.bounds ? this.config.bounds : this.doc.body;
        }
        var debug = this.debug;
        if (!debug && debug !== false && this.config.debug) {
            debug = this.config.debug;
        }
        var readOnly = this.readOnly;
        if (!readOnly && this.readOnly !== false) {
            readOnly = this.config.readOnly !== undefined ? this.config.readOnly : false;
        }
        var scrollingContainer = this.scrollingContainer;
        if (!scrollingContainer && this.scrollingContainer !== null) {
            scrollingContainer = this.config.scrollingContainer === null || this.config.scrollingContainer ? this.config.scrollingContainer : null;
        }
        var formats = this.formats;
        if (!formats && formats === undefined) {
            formats = this.config.formats || this.config.formats === null ? this.config.formats : undefined;
        }
        this.quillEditor = new Quill(this.editorElem, {
            bounds: bounds,
            debug: debug,
            formats: formats,
            modules: modules,
            placeholder: placeholder,
            readOnly: readOnly,
            scrollingContainer: scrollingContainer,
            strict: this.strict,
            theme: this.theme || (this.config.theme ? this.config.theme : 'snow')
        });
        if (this.content) {
            if (this.format === 'object') {
                this.quillEditor.setContents(this.content, 'silent');
            }
            else if (this.format === 'text') {
                this.quillEditor.setText(this.content, 'silent');
            }
            else if (this.format === 'json') {
                try {
                    this.quillEditor.setContents(JSON.parse(this.content), 'silent');
                }
                catch (e) {
                    this.quillEditor.setText(this.content, 'silent');
                }
            }
            else {
                if (this.sanitize) {
                    this.content = this.domSanitizer.sanitize(__WEBPACK_IMPORTED_MODULE_1__angular_core__["SecurityContext"].HTML, this.content);
                }
                var contents = this.quillEditor.clipboard.convert(this.content);
                this.quillEditor.setContents(contents, 'silent');
            }
            this.quillEditor.history.clear();
        }
        // initialize disabled status based on this.disabled as default value
        this.setDisabledState();
        this.onEditorCreated.emit(this.quillEditor);
        // mark model as touched if editor lost focus
        this.quillEditor.on('selection-change', this.selectionChangeHandler);
        // update model if text changes
        this.quillEditor.on('text-change', this.textChangeHandler);
    };
    QuillEditorComponent.prototype.ngOnDestroy = function () {
        if (this.quillEditor) {
            this.quillEditor.off('selection-change', this.selectionChangeHandler);
            this.quillEditor.off('text-change', this.textChangeHandler);
        }
    };
    QuillEditorComponent.prototype.ngOnChanges = function (changes) {
        var _this = this;
        if (!this.quillEditor) {
            return;
        }
        // tslint:disable:no-string-literal
        if (changes['readOnly']) {
            this.quillEditor.enable(!changes['readOnly'].currentValue);
        }
        if (changes['placeholder']) {
            this.quillEditor.root.dataset.placeholder =
                changes['placeholder'].currentValue;
        }
        if (changes['style']) {
            var currentStyling = changes['style'].currentValue;
            var previousStyling = changes['style'].previousValue;
            if (previousStyling) {
                Object.keys(previousStyling).forEach(function (key) {
                    _this.renderer.removeStyle(_this.editorElem, key);
                });
            }
            if (currentStyling) {
                Object.keys(currentStyling).forEach(function (key) {
                    _this.renderer.setStyle(_this.editorElem, key, _this.style[key]);
                });
            }
        }
        // tslint:enable:no-string-literal
    };
    QuillEditorComponent.prototype.writeValue = function (currentValue) {
        this.content = currentValue;
        if (this.quillEditor) {
            if (currentValue) {
                if (this.format === 'text') {
                    this.quillEditor.setText(currentValue);
                }
                else {
                    this.quillEditor.setContents(this.valueSetter(this.quillEditor, this.content));
                }
                return;
            }
            this.quillEditor.setText('');
        }
    };
    QuillEditorComponent.prototype.setDisabledState = function (isDisabled) {
        if (isDisabled === void 0) { isDisabled = this.disabled; }
        // store initial value to set appropriate disabled status after ViewInit
        this.disabled = isDisabled;
        if (this.quillEditor) {
            if (isDisabled) {
                this.quillEditor.disable();
                this.renderer.setAttribute(this.elementRef.nativeElement, 'disabled', 'disabled');
            }
            else {
                if (!this.readOnly) {
                    this.quillEditor.enable();
                }
                this.renderer.removeAttribute(this.elementRef.nativeElement, 'disabled');
            }
        }
    };
    QuillEditorComponent.prototype.registerOnChange = function (fn) {
        this.onModelChange = fn;
    };
    QuillEditorComponent.prototype.registerOnTouched = function (fn) {
        this.onModelTouched = fn;
    };
    QuillEditorComponent.prototype.validate = function () {
        if (!this.quillEditor) {
            return null;
        }
        var err = {};
        var valid = true;
        var textLength = this.quillEditor.getText().trim().length;
        if (this.minLength && textLength && textLength < this.minLength) {
            err.minLengthError = {
                given: textLength,
                minLength: this.minLength
            };
            valid = false;
        }
        if (this.maxLength && textLength > this.maxLength) {
            err.maxLengthError = {
                given: textLength,
                maxLength: this.maxLength
            };
            valid = false;
        }
        if (this.required && !textLength) {
            err.requiredError = {
                empty: true
            };
            valid = false;
        }
        return valid ? null : err;
    };
    var QuillEditorComponent_1;
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */])([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __metadata */])("design:type", String)
    ], QuillEditorComponent.prototype, "format", void 0);
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */])([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __metadata */])("design:type", String)
    ], QuillEditorComponent.prototype, "theme", void 0);
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */])([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __metadata */])("design:type", Object)
    ], QuillEditorComponent.prototype, "modules", void 0);
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */])([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __metadata */])("design:type", Object)
    ], QuillEditorComponent.prototype, "debug", void 0);
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */])([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __metadata */])("design:type", Boolean)
    ], QuillEditorComponent.prototype, "readOnly", void 0);
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */])([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __metadata */])("design:type", String)
    ], QuillEditorComponent.prototype, "placeholder", void 0);
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */])([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __metadata */])("design:type", Number)
    ], QuillEditorComponent.prototype, "maxLength", void 0);
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */])([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __metadata */])("design:type", Number)
    ], QuillEditorComponent.prototype, "minLength", void 0);
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */])([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __metadata */])("design:type", Boolean)
    ], QuillEditorComponent.prototype, "required", void 0);
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */])([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __metadata */])("design:type", Array)
    ], QuillEditorComponent.prototype, "formats", void 0);
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */])([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __metadata */])("design:type", String)
    ], QuillEditorComponent.prototype, "customToolbarPosition", void 0);
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */])([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __metadata */])("design:type", Boolean)
    ], QuillEditorComponent.prototype, "sanitize", void 0);
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */])([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __metadata */])("design:type", Object)
    ], QuillEditorComponent.prototype, "style", void 0);
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */])([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __metadata */])("design:type", Boolean)
    ], QuillEditorComponent.prototype, "strict", void 0);
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */])([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __metadata */])("design:type", Object)
    ], QuillEditorComponent.prototype, "scrollingContainer", void 0);
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */])([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __metadata */])("design:type", Object)
    ], QuillEditorComponent.prototype, "bounds", void 0);
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */])([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __metadata */])("design:type", Array)
    ], QuillEditorComponent.prototype, "customOptions", void 0);
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */])([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __metadata */])("design:type", String)
    ], QuillEditorComponent.prototype, "trackChanges", void 0);
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */])([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __metadata */])("design:type", Boolean)
    ], QuillEditorComponent.prototype, "preserveWhitespace", void 0);
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */])([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Output"])(),
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __metadata */])("design:type", __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"])
    ], QuillEditorComponent.prototype, "onEditorCreated", void 0);
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */])([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Output"])(),
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __metadata */])("design:type", __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"])
    ], QuillEditorComponent.prototype, "onContentChanged", void 0);
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */])([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Output"])(),
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __metadata */])("design:type", __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"])
    ], QuillEditorComponent.prototype, "onSelectionChanged", void 0);
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */])([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Output"])(),
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __metadata */])("design:type", __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"])
    ], QuillEditorComponent.prototype, "onFocus", void 0);
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */])([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Output"])(),
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __metadata */])("design:type", __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"])
    ], QuillEditorComponent.prototype, "onBlur", void 0);
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */])([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __metadata */])("design:type", Object)
    ], QuillEditorComponent.prototype, "valueGetter", void 0);
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */])([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __metadata */])("design:type", Object)
    ], QuillEditorComponent.prototype, "valueSetter", void 0);
    QuillEditorComponent = QuillEditorComponent_1 = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */])([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            encapsulation: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ViewEncapsulation"].None,
            providers: [
                {
                    multi: true,
                    provide: __WEBPACK_IMPORTED_MODULE_4__angular_forms__["NG_VALUE_ACCESSOR"],
                    useExisting: Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return QuillEditorComponent_1; })
                },
                {
                    multi: true,
                    provide: __WEBPACK_IMPORTED_MODULE_4__angular_forms__["NG_VALIDATORS"],
                    useExisting: Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return QuillEditorComponent_1; })
                }
            ],
            selector: 'quill-editor',
            template: "\n  <ng-content select=\"[quill-editor-toolbar]\"></ng-content>\n"
        }),
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __param */])(2, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_2__angular_common__["DOCUMENT"])),
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __param */])(3, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_1__angular_core__["PLATFORM_ID"])),
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __param */])(6, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"])(QUILL_CONFIG_TOKEN)),
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __metadata */])("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"],
            __WEBPACK_IMPORTED_MODULE_3__angular_platform_browser__["DomSanitizer"], Object, Object,
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["Renderer2"],
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["NgZone"], Object])
    ], QuillEditorComponent);
    return QuillEditorComponent;
}());

var ɵ0 = { modules: defaultModules };
var QuillModule = /** @class */ (function () {
    function QuillModule() {
    }
    QuillModule_1 = QuillModule;
    QuillModule.forRoot = function (config) {
        return {
            ngModule: QuillModule_1,
            providers: [
                {
                    provide: QUILL_CONFIG_TOKEN,
                    // tslint:disable-next-line:only-arrow-functions
                    useValue: config || { modules: defaultModules }
                }
            ]
        };
    };
    var QuillModule_1;
    QuillModule = QuillModule_1 = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */])([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModule"])({
            declarations: [
                QuillEditorComponent
            ],
            exports: [QuillEditorComponent],
            imports: [],
            providers: [
                {
                    provide: QUILL_CONFIG_TOKEN,
                    useValue: ɵ0
                }
            ]
        })
    ], QuillModule);
    return QuillModule;
}());

/**
 * Generated bundle index. Do not edit.
 */


//# sourceMappingURL=ngx-quill.js.map


/***/ }),

/***/ "./node_modules/ngx-window-token/dist/ngx-window-token.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_ngx_window_token__ = __webpack_require__("./node_modules/ngx-window-token/dist/src/ngx-window-token.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__src_ngx_window_token__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_ngx_window_token__["a"]; });

//# sourceMappingURL=ngx-window-token.js.map

/***/ }),

/***/ "./node_modules/ngx-window-token/dist/src/ngx-window-token.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WINDOW; });
/* unused harmony export _window */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return WindowTokenModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");


var /** @type {?} */ WINDOW = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["InjectionToken"]('WindowToken');
/**
 * @return {?}
 */
function _window() {
    return window;
}
var WindowTokenModule = (function () {
    function WindowTokenModule() {
    }
    return WindowTokenModule;
}());

WindowTokenModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                providers: [{
                        provide: WINDOW,
                        useFactory: _window
                    }]
            },] },
];
/**
 * @nocollapse
 */
WindowTokenModule.ctorParameters = function () { return []; };
function WindowTokenModule_tsickle_Closure_declarations() {
    /** @type {?} */
    WindowTokenModule.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    WindowTokenModule.ctorParameters;
}
//# sourceMappingURL=ngx-window-token.js.map

/***/ }),

/***/ "./node_modules/pace-js/pace.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function() {
  var AjaxMonitor, Bar, DocumentMonitor, ElementMonitor, ElementTracker, EventLagMonitor, Evented, Events, NoTargetError, Pace, RequestIntercept, SOURCE_KEYS, Scaler, SocketRequestTracker, XHRRequestTracker, animation, avgAmplitude, bar, cancelAnimation, cancelAnimationFrame, defaultOptions, extend, extendNative, getFromDOM, getIntercept, handlePushState, ignoreStack, init, now, options, requestAnimationFrame, result, runAnimation, scalers, shouldIgnoreURL, shouldTrack, source, sources, uniScaler, _WebSocket, _XDomainRequest, _XMLHttpRequest, _i, _intercept, _len, _pushState, _ref, _ref1, _replaceState,
    __slice = [].slice,
    __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  defaultOptions = {
    catchupTime: 100,
    initialRate: .03,
    minTime: 250,
    ghostTime: 100,
    maxProgressPerFrame: 20,
    easeFactor: 1.25,
    startOnPageLoad: true,
    restartOnPushState: true,
    restartOnRequestAfter: 500,
    target: 'body',
    elements: {
      checkInterval: 100,
      selectors: ['body']
    },
    eventLag: {
      minSamples: 10,
      sampleCount: 3,
      lagThreshold: 3
    },
    ajax: {
      trackMethods: ['GET'],
      trackWebSockets: true,
      ignoreURLs: []
    }
  };

  now = function() {
    var _ref;
    return (_ref = typeof performance !== "undefined" && performance !== null ? typeof performance.now === "function" ? performance.now() : void 0 : void 0) != null ? _ref : +(new Date);
  };

  requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;

  cancelAnimationFrame = window.cancelAnimationFrame || window.mozCancelAnimationFrame;

  if (requestAnimationFrame == null) {
    requestAnimationFrame = function(fn) {
      return setTimeout(fn, 50);
    };
    cancelAnimationFrame = function(id) {
      return clearTimeout(id);
    };
  }

  runAnimation = function(fn) {
    var last, tick;
    last = now();
    tick = function() {
      var diff;
      diff = now() - last;
      if (diff >= 33) {
        last = now();
        return fn(diff, function() {
          return requestAnimationFrame(tick);
        });
      } else {
        return setTimeout(tick, 33 - diff);
      }
    };
    return tick();
  };

  result = function() {
    var args, key, obj;
    obj = arguments[0], key = arguments[1], args = 3 <= arguments.length ? __slice.call(arguments, 2) : [];
    if (typeof obj[key] === 'function') {
      return obj[key].apply(obj, args);
    } else {
      return obj[key];
    }
  };

  extend = function() {
    var key, out, source, sources, val, _i, _len;
    out = arguments[0], sources = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
    for (_i = 0, _len = sources.length; _i < _len; _i++) {
      source = sources[_i];
      if (source) {
        for (key in source) {
          if (!__hasProp.call(source, key)) continue;
          val = source[key];
          if ((out[key] != null) && typeof out[key] === 'object' && (val != null) && typeof val === 'object') {
            extend(out[key], val);
          } else {
            out[key] = val;
          }
        }
      }
    }
    return out;
  };

  avgAmplitude = function(arr) {
    var count, sum, v, _i, _len;
    sum = count = 0;
    for (_i = 0, _len = arr.length; _i < _len; _i++) {
      v = arr[_i];
      sum += Math.abs(v);
      count++;
    }
    return sum / count;
  };

  getFromDOM = function(key, json) {
    var data, e, el;
    if (key == null) {
      key = 'options';
    }
    if (json == null) {
      json = true;
    }
    el = document.querySelector("[data-pace-" + key + "]");
    if (!el) {
      return;
    }
    data = el.getAttribute("data-pace-" + key);
    if (!json) {
      return data;
    }
    try {
      return JSON.parse(data);
    } catch (_error) {
      e = _error;
      return typeof console !== "undefined" && console !== null ? console.error("Error parsing inline pace options", e) : void 0;
    }
  };

  Evented = (function() {
    function Evented() {}

    Evented.prototype.on = function(event, handler, ctx, once) {
      var _base;
      if (once == null) {
        once = false;
      }
      if (this.bindings == null) {
        this.bindings = {};
      }
      if ((_base = this.bindings)[event] == null) {
        _base[event] = [];
      }
      return this.bindings[event].push({
        handler: handler,
        ctx: ctx,
        once: once
      });
    };

    Evented.prototype.once = function(event, handler, ctx) {
      return this.on(event, handler, ctx, true);
    };

    Evented.prototype.off = function(event, handler) {
      var i, _ref, _results;
      if (((_ref = this.bindings) != null ? _ref[event] : void 0) == null) {
        return;
      }
      if (handler == null) {
        return delete this.bindings[event];
      } else {
        i = 0;
        _results = [];
        while (i < this.bindings[event].length) {
          if (this.bindings[event][i].handler === handler) {
            _results.push(this.bindings[event].splice(i, 1));
          } else {
            _results.push(i++);
          }
        }
        return _results;
      }
    };

    Evented.prototype.trigger = function() {
      var args, ctx, event, handler, i, once, _ref, _ref1, _results;
      event = arguments[0], args = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
      if ((_ref = this.bindings) != null ? _ref[event] : void 0) {
        i = 0;
        _results = [];
        while (i < this.bindings[event].length) {
          _ref1 = this.bindings[event][i], handler = _ref1.handler, ctx = _ref1.ctx, once = _ref1.once;
          handler.apply(ctx != null ? ctx : this, args);
          if (once) {
            _results.push(this.bindings[event].splice(i, 1));
          } else {
            _results.push(i++);
          }
        }
        return _results;
      }
    };

    return Evented;

  })();

  Pace = window.Pace || {};

  window.Pace = Pace;

  extend(Pace, Evented.prototype);

  options = Pace.options = extend({}, defaultOptions, window.paceOptions, getFromDOM());

  _ref = ['ajax', 'document', 'eventLag', 'elements'];
  for (_i = 0, _len = _ref.length; _i < _len; _i++) {
    source = _ref[_i];
    if (options[source] === true) {
      options[source] = defaultOptions[source];
    }
  }

  NoTargetError = (function(_super) {
    __extends(NoTargetError, _super);

    function NoTargetError() {
      _ref1 = NoTargetError.__super__.constructor.apply(this, arguments);
      return _ref1;
    }

    return NoTargetError;

  })(Error);

  Bar = (function() {
    function Bar() {
      this.progress = 0;
    }

    Bar.prototype.getElement = function() {
      var targetElement;
      if (this.el == null) {
        targetElement = document.querySelector(options.target);
        if (!targetElement) {
          throw new NoTargetError;
        }
        this.el = document.createElement('div');
        this.el.className = "pace pace-active";
        document.body.className = document.body.className.replace(/pace-done/g, '');
        document.body.className += ' pace-running';
        this.el.innerHTML = '<div class="pace-progress">\n  <div class="pace-progress-inner"></div>\n</div>\n<div class="pace-activity"></div>';
        if (targetElement.firstChild != null) {
          targetElement.insertBefore(this.el, targetElement.firstChild);
        } else {
          targetElement.appendChild(this.el);
        }
      }
      return this.el;
    };

    Bar.prototype.finish = function() {
      var el;
      el = this.getElement();
      el.className = el.className.replace('pace-active', '');
      el.className += ' pace-inactive';
      document.body.className = document.body.className.replace('pace-running', '');
      return document.body.className += ' pace-done';
    };

    Bar.prototype.update = function(prog) {
      this.progress = prog;
      return this.render();
    };

    Bar.prototype.destroy = function() {
      try {
        this.getElement().parentNode.removeChild(this.getElement());
      } catch (_error) {
        NoTargetError = _error;
      }
      return this.el = void 0;
    };

    Bar.prototype.render = function() {
      var el, key, progressStr, transform, _j, _len1, _ref2;
      if (document.querySelector(options.target) == null) {
        return false;
      }
      el = this.getElement();
      transform = "translate3d(" + this.progress + "%, 0, 0)";
      _ref2 = ['webkitTransform', 'msTransform', 'transform'];
      for (_j = 0, _len1 = _ref2.length; _j < _len1; _j++) {
        key = _ref2[_j];
        el.children[0].style[key] = transform;
      }
      if (!this.lastRenderedProgress || this.lastRenderedProgress | 0 !== this.progress | 0) {
        el.children[0].setAttribute('data-progress-text', "" + (this.progress | 0) + "%");
        if (this.progress >= 100) {
          progressStr = '99';
        } else {
          progressStr = this.progress < 10 ? "0" : "";
          progressStr += this.progress | 0;
        }
        el.children[0].setAttribute('data-progress', "" + progressStr);
      }
      return this.lastRenderedProgress = this.progress;
    };

    Bar.prototype.done = function() {
      return this.progress >= 100;
    };

    return Bar;

  })();

  Events = (function() {
    function Events() {
      this.bindings = {};
    }

    Events.prototype.trigger = function(name, val) {
      var binding, _j, _len1, _ref2, _results;
      if (this.bindings[name] != null) {
        _ref2 = this.bindings[name];
        _results = [];
        for (_j = 0, _len1 = _ref2.length; _j < _len1; _j++) {
          binding = _ref2[_j];
          _results.push(binding.call(this, val));
        }
        return _results;
      }
    };

    Events.prototype.on = function(name, fn) {
      var _base;
      if ((_base = this.bindings)[name] == null) {
        _base[name] = [];
      }
      return this.bindings[name].push(fn);
    };

    return Events;

  })();

  _XMLHttpRequest = window.XMLHttpRequest;

  _XDomainRequest = window.XDomainRequest;

  _WebSocket = window.WebSocket;

  extendNative = function(to, from) {
    var e, key, _results;
    _results = [];
    for (key in from.prototype) {
      try {
        if ((to[key] == null) && typeof from[key] !== 'function') {
          if (typeof Object.defineProperty === 'function') {
            _results.push(Object.defineProperty(to, key, {
              get: function() {
                return from.prototype[key];
              },
              configurable: true,
              enumerable: true
            }));
          } else {
            _results.push(to[key] = from.prototype[key]);
          }
        } else {
          _results.push(void 0);
        }
      } catch (_error) {
        e = _error;
      }
    }
    return _results;
  };

  ignoreStack = [];

  Pace.ignore = function() {
    var args, fn, ret;
    fn = arguments[0], args = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
    ignoreStack.unshift('ignore');
    ret = fn.apply(null, args);
    ignoreStack.shift();
    return ret;
  };

  Pace.track = function() {
    var args, fn, ret;
    fn = arguments[0], args = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
    ignoreStack.unshift('track');
    ret = fn.apply(null, args);
    ignoreStack.shift();
    return ret;
  };

  shouldTrack = function(method) {
    var _ref2;
    if (method == null) {
      method = 'GET';
    }
    if (ignoreStack[0] === 'track') {
      return 'force';
    }
    if (!ignoreStack.length && options.ajax) {
      if (method === 'socket' && options.ajax.trackWebSockets) {
        return true;
      } else if (_ref2 = method.toUpperCase(), __indexOf.call(options.ajax.trackMethods, _ref2) >= 0) {
        return true;
      }
    }
    return false;
  };

  RequestIntercept = (function(_super) {
    __extends(RequestIntercept, _super);

    function RequestIntercept() {
      var monitorXHR,
        _this = this;
      RequestIntercept.__super__.constructor.apply(this, arguments);
      monitorXHR = function(req) {
        var _open;
        _open = req.open;
        return req.open = function(type, url, async) {
          if (shouldTrack(type)) {
            _this.trigger('request', {
              type: type,
              url: url,
              request: req
            });
          }
          return _open.apply(req, arguments);
        };
      };
      window.XMLHttpRequest = function(flags) {
        var req;
        req = new _XMLHttpRequest(flags);
        monitorXHR(req);
        return req;
      };
      try {
        extendNative(window.XMLHttpRequest, _XMLHttpRequest);
      } catch (_error) {}
      if (_XDomainRequest != null) {
        window.XDomainRequest = function() {
          var req;
          req = new _XDomainRequest;
          monitorXHR(req);
          return req;
        };
        try {
          extendNative(window.XDomainRequest, _XDomainRequest);
        } catch (_error) {}
      }
      if ((_WebSocket != null) && options.ajax.trackWebSockets) {
        window.WebSocket = function(url, protocols) {
          var req;
          if (protocols != null) {
            req = new _WebSocket(url, protocols);
          } else {
            req = new _WebSocket(url);
          }
          if (shouldTrack('socket')) {
            _this.trigger('request', {
              type: 'socket',
              url: url,
              protocols: protocols,
              request: req
            });
          }
          return req;
        };
        try {
          extendNative(window.WebSocket, _WebSocket);
        } catch (_error) {}
      }
    }

    return RequestIntercept;

  })(Events);

  _intercept = null;

  getIntercept = function() {
    if (_intercept == null) {
      _intercept = new RequestIntercept;
    }
    return _intercept;
  };

  shouldIgnoreURL = function(url) {
    var pattern, _j, _len1, _ref2;
    _ref2 = options.ajax.ignoreURLs;
    for (_j = 0, _len1 = _ref2.length; _j < _len1; _j++) {
      pattern = _ref2[_j];
      if (typeof pattern === 'string') {
        if (url.indexOf(pattern) !== -1) {
          return true;
        }
      } else {
        if (pattern.test(url)) {
          return true;
        }
      }
    }
    return false;
  };

  getIntercept().on('request', function(_arg) {
    var after, args, request, type, url;
    type = _arg.type, request = _arg.request, url = _arg.url;
    if (shouldIgnoreURL(url)) {
      return;
    }
    if (!Pace.running && (options.restartOnRequestAfter !== false || shouldTrack(type) === 'force')) {
      args = arguments;
      after = options.restartOnRequestAfter || 0;
      if (typeof after === 'boolean') {
        after = 0;
      }
      return setTimeout(function() {
        var stillActive, _j, _len1, _ref2, _ref3, _results;
        if (type === 'socket') {
          stillActive = request.readyState < 2;
        } else {
          stillActive = (0 < (_ref2 = request.readyState) && _ref2 < 4);
        }
        if (stillActive) {
          Pace.restart();
          _ref3 = Pace.sources;
          _results = [];
          for (_j = 0, _len1 = _ref3.length; _j < _len1; _j++) {
            source = _ref3[_j];
            if (source instanceof AjaxMonitor) {
              source.watch.apply(source, args);
              break;
            } else {
              _results.push(void 0);
            }
          }
          return _results;
        }
      }, after);
    }
  });

  AjaxMonitor = (function() {
    function AjaxMonitor() {
      var _this = this;
      this.elements = [];
      getIntercept().on('request', function() {
        return _this.watch.apply(_this, arguments);
      });
    }

    AjaxMonitor.prototype.watch = function(_arg) {
      var request, tracker, type, url;
      type = _arg.type, request = _arg.request, url = _arg.url;
      if (shouldIgnoreURL(url)) {
        return;
      }
      if (type === 'socket') {
        tracker = new SocketRequestTracker(request);
      } else {
        tracker = new XHRRequestTracker(request);
      }
      return this.elements.push(tracker);
    };

    return AjaxMonitor;

  })();

  XHRRequestTracker = (function() {
    function XHRRequestTracker(request) {
      var event, size, _j, _len1, _onreadystatechange, _ref2,
        _this = this;
      this.progress = 0;
      if (window.ProgressEvent != null) {
        size = null;
        request.addEventListener('progress', function(evt) {
          if (evt.lengthComputable) {
            return _this.progress = 100 * evt.loaded / evt.total;
          } else {
            return _this.progress = _this.progress + (100 - _this.progress) / 2;
          }
        }, false);
        _ref2 = ['load', 'abort', 'timeout', 'error'];
        for (_j = 0, _len1 = _ref2.length; _j < _len1; _j++) {
          event = _ref2[_j];
          request.addEventListener(event, function() {
            return _this.progress = 100;
          }, false);
        }
      } else {
        _onreadystatechange = request.onreadystatechange;
        request.onreadystatechange = function() {
          var _ref3;
          if ((_ref3 = request.readyState) === 0 || _ref3 === 4) {
            _this.progress = 100;
          } else if (request.readyState === 3) {
            _this.progress = 50;
          }
          return typeof _onreadystatechange === "function" ? _onreadystatechange.apply(null, arguments) : void 0;
        };
      }
    }

    return XHRRequestTracker;

  })();

  SocketRequestTracker = (function() {
    function SocketRequestTracker(request) {
      var event, _j, _len1, _ref2,
        _this = this;
      this.progress = 0;
      _ref2 = ['error', 'open'];
      for (_j = 0, _len1 = _ref2.length; _j < _len1; _j++) {
        event = _ref2[_j];
        request.addEventListener(event, function() {
          return _this.progress = 100;
        }, false);
      }
    }

    return SocketRequestTracker;

  })();

  ElementMonitor = (function() {
    function ElementMonitor(options) {
      var selector, _j, _len1, _ref2;
      if (options == null) {
        options = {};
      }
      this.elements = [];
      if (options.selectors == null) {
        options.selectors = [];
      }
      _ref2 = options.selectors;
      for (_j = 0, _len1 = _ref2.length; _j < _len1; _j++) {
        selector = _ref2[_j];
        this.elements.push(new ElementTracker(selector));
      }
    }

    return ElementMonitor;

  })();

  ElementTracker = (function() {
    function ElementTracker(selector) {
      this.selector = selector;
      this.progress = 0;
      this.check();
    }

    ElementTracker.prototype.check = function() {
      var _this = this;
      if (document.querySelector(this.selector)) {
        return this.done();
      } else {
        return setTimeout((function() {
          return _this.check();
        }), options.elements.checkInterval);
      }
    };

    ElementTracker.prototype.done = function() {
      return this.progress = 100;
    };

    return ElementTracker;

  })();

  DocumentMonitor = (function() {
    DocumentMonitor.prototype.states = {
      loading: 0,
      interactive: 50,
      complete: 100
    };

    function DocumentMonitor() {
      var _onreadystatechange, _ref2,
        _this = this;
      this.progress = (_ref2 = this.states[document.readyState]) != null ? _ref2 : 100;
      _onreadystatechange = document.onreadystatechange;
      document.onreadystatechange = function() {
        if (_this.states[document.readyState] != null) {
          _this.progress = _this.states[document.readyState];
        }
        return typeof _onreadystatechange === "function" ? _onreadystatechange.apply(null, arguments) : void 0;
      };
    }

    return DocumentMonitor;

  })();

  EventLagMonitor = (function() {
    function EventLagMonitor() {
      var avg, interval, last, points, samples,
        _this = this;
      this.progress = 0;
      avg = 0;
      samples = [];
      points = 0;
      last = now();
      interval = setInterval(function() {
        var diff;
        diff = now() - last - 50;
        last = now();
        samples.push(diff);
        if (samples.length > options.eventLag.sampleCount) {
          samples.shift();
        }
        avg = avgAmplitude(samples);
        if (++points >= options.eventLag.minSamples && avg < options.eventLag.lagThreshold) {
          _this.progress = 100;
          return clearInterval(interval);
        } else {
          return _this.progress = 100 * (3 / (avg + 3));
        }
      }, 50);
    }

    return EventLagMonitor;

  })();

  Scaler = (function() {
    function Scaler(source) {
      this.source = source;
      this.last = this.sinceLastUpdate = 0;
      this.rate = options.initialRate;
      this.catchup = 0;
      this.progress = this.lastProgress = 0;
      if (this.source != null) {
        this.progress = result(this.source, 'progress');
      }
    }

    Scaler.prototype.tick = function(frameTime, val) {
      var scaling;
      if (val == null) {
        val = result(this.source, 'progress');
      }
      if (val >= 100) {
        this.done = true;
      }
      if (val === this.last) {
        this.sinceLastUpdate += frameTime;
      } else {
        if (this.sinceLastUpdate) {
          this.rate = (val - this.last) / this.sinceLastUpdate;
        }
        this.catchup = (val - this.progress) / options.catchupTime;
        this.sinceLastUpdate = 0;
        this.last = val;
      }
      if (val > this.progress) {
        this.progress += this.catchup * frameTime;
      }
      scaling = 1 - Math.pow(this.progress / 100, options.easeFactor);
      this.progress += scaling * this.rate * frameTime;
      this.progress = Math.min(this.lastProgress + options.maxProgressPerFrame, this.progress);
      this.progress = Math.max(0, this.progress);
      this.progress = Math.min(100, this.progress);
      this.lastProgress = this.progress;
      return this.progress;
    };

    return Scaler;

  })();

  sources = null;

  scalers = null;

  bar = null;

  uniScaler = null;

  animation = null;

  cancelAnimation = null;

  Pace.running = false;

  handlePushState = function() {
    if (options.restartOnPushState) {
      return Pace.restart();
    }
  };

  if (window.history.pushState != null) {
    _pushState = window.history.pushState;
    window.history.pushState = function() {
      handlePushState();
      return _pushState.apply(window.history, arguments);
    };
  }

  if (window.history.replaceState != null) {
    _replaceState = window.history.replaceState;
    window.history.replaceState = function() {
      handlePushState();
      return _replaceState.apply(window.history, arguments);
    };
  }

  SOURCE_KEYS = {
    ajax: AjaxMonitor,
    elements: ElementMonitor,
    document: DocumentMonitor,
    eventLag: EventLagMonitor
  };

  (init = function() {
    var type, _j, _k, _len1, _len2, _ref2, _ref3, _ref4;
    Pace.sources = sources = [];
    _ref2 = ['ajax', 'elements', 'document', 'eventLag'];
    for (_j = 0, _len1 = _ref2.length; _j < _len1; _j++) {
      type = _ref2[_j];
      if (options[type] !== false) {
        sources.push(new SOURCE_KEYS[type](options[type]));
      }
    }
    _ref4 = (_ref3 = options.extraSources) != null ? _ref3 : [];
    for (_k = 0, _len2 = _ref4.length; _k < _len2; _k++) {
      source = _ref4[_k];
      sources.push(new source(options));
    }
    Pace.bar = bar = new Bar;
    scalers = [];
    return uniScaler = new Scaler;
  })();

  Pace.stop = function() {
    Pace.trigger('stop');
    Pace.running = false;
    bar.destroy();
    cancelAnimation = true;
    if (animation != null) {
      if (typeof cancelAnimationFrame === "function") {
        cancelAnimationFrame(animation);
      }
      animation = null;
    }
    return init();
  };

  Pace.restart = function() {
    Pace.trigger('restart');
    Pace.stop();
    return Pace.start();
  };

  Pace.go = function() {
    var start;
    Pace.running = true;
    bar.render();
    start = now();
    cancelAnimation = false;
    return animation = runAnimation(function(frameTime, enqueueNextFrame) {
      var avg, count, done, element, elements, i, j, remaining, scaler, scalerList, sum, _j, _k, _len1, _len2, _ref2;
      remaining = 100 - bar.progress;
      count = sum = 0;
      done = true;
      for (i = _j = 0, _len1 = sources.length; _j < _len1; i = ++_j) {
        source = sources[i];
        scalerList = scalers[i] != null ? scalers[i] : scalers[i] = [];
        elements = (_ref2 = source.elements) != null ? _ref2 : [source];
        for (j = _k = 0, _len2 = elements.length; _k < _len2; j = ++_k) {
          element = elements[j];
          scaler = scalerList[j] != null ? scalerList[j] : scalerList[j] = new Scaler(element);
          done &= scaler.done;
          if (scaler.done) {
            continue;
          }
          count++;
          sum += scaler.tick(frameTime);
        }
      }
      avg = sum / count;
      bar.update(uniScaler.tick(frameTime, avg));
      if (bar.done() || done || cancelAnimation) {
        bar.update(100);
        Pace.trigger('done');
        return setTimeout(function() {
          bar.finish();
          Pace.running = false;
          return Pace.trigger('hide');
        }, Math.max(options.ghostTime, Math.max(options.minTime - (now() - start), 0)));
      } else {
        return enqueueNextFrame();
      }
    });
  };

  Pace.start = function(_options) {
    extend(options, _options);
    Pace.running = true;
    try {
      bar.render();
    } catch (_error) {
      NoTargetError = _error;
    }
    if (!document.querySelector('.pace')) {
      return setTimeout(Pace.start, 50);
    } else {
      Pace.trigger('start');
      return Pace.go();
    }
  };

  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./node_modules/pace/pace.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return Pace;
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === 'object') {
    module.exports = Pace;
  } else {
    if (options.startOnPageLoad) {
      Pace.start();
    }
  }

}).call(this);


/***/ }),

/***/ "./node_modules/pace/pace.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * Pace
 *
 * A progress bar for the command-line.
 *
 * Example usage:
 *
 *     var total = 50000,
 *         count = 0,
 *         pace = require('pace')(total);
 *
 *     while (count++ < total) {
 *       pace.op();
 *
 *       // Cause some work to be done.
 *       for (var i = 0; i < 1000000; i++) {
 *         count = count;
 *       }
 *     }
 */

// Module dependencies.
var charm = __webpack_require__("./node_modules/charm/index.js");

/**
 * Pace 'class'.
 */
function Pace(options) {
  options = options || {};

  // Total number of items to process.
  if (!options.total) {
    throw new Error('You MUST specify the total number of operations that will be processed.');
  }
  this.total = options.total;

  // Current item number.
  this.current = 0;

  // Maximum percent of total time the progressbar is allowed to take during processing.
  // Defaults to 0.5%
  this.max_burden = options.maxBurden || 0.5;

  // Whether to show current burden %.
  this.show_burden = options.showBurden || false;

  // Internal time tracking properties.
  this.started = false;
  this.size = 50;
  this.inner_time = 0;
  this.outer_time = 0;
  this.elapsed = 0;
  this.time_start = 0;
  this.time_end = 0;
  this.time_left = 0;
  this.time_burden = 0;
  this.skip_steps = 0;
  this.skipped = 0;
  this.aborted = false;

  // Setup charm.
  this.charm = charm();
  this.charm.pipe(process.stdout);

  // Prepare the output.
  this.charm.write("\n\n\n");
}

/**
 * Export a factory function for new pace instances.
 */
module.exports = function(options) {
  if (typeof options === 'number') {
    options = {
      total: options
    };
  }
  return new Pace(options);
};

/**
 * An operation has been emitted.
 */
Pace.prototype.op = function op(count) {
  if (count) {
    this.current = count;
  }
  else {
    this.current++;
  }

  if (this.burdenReached()) {
    return;
  }

  // Record the start time of the whole task.
  if (!this.started) {
    this.started = new Date().getTime();
  }

  // Record start time.
  this.time_start = new Date().getTime();

  this.updateTimes();
  this.clear();
  this.outputProgress();
  this.outputStats();
  this.outputTimes();

  // The task is complete.
  if (this.current >= this.total) {
    this.finished();
  }

  // Record end time.
  this.time_end = new Date().getTime();
  this.inner_time = this.time_end - this.time_start;
};

/**
 * Update times.
 */
Pace.prototype.updateTimes = function updateTimes() {
  this.elapsed = this.time_start - this.started;
  if (this.time_end > 0) {
    this.outer_time = this.time_start - this.time_end;
  }
  if (this.inner_time > 0 && this.outer_time > 0) {
    // Set Current Burden
    this.time_burden = (this.inner_time / (this.inner_time + this.outer_time)) * 100;

    // Estimate time left.
    this.time_left = (this.elapsed / this.current) * (this.total - this.current);

    if (this.time_left < 0) this.time_left = 0;
  }
  // If our "burden" is too high, increase the skip steps.
  if (this.time_burden > this.max_burden && (this.skip_steps < (this.total / this.size))) {
    this.skip_steps = Math.floor(++this.skip_steps * 1.3);
  }
};

/**
 * Move the cursor back to the beginning and clear old output.
 */
Pace.prototype.clear = function clear() {
  this.charm.erase('line').up(1).erase('line').up(1).erase('line').write("\r");
};

/**
 * Output the progress bar.
 */
Pace.prototype.outputProgress = function outputProgress() {
  this.charm.write('Processing: ');
  this.charm.foreground('green').background('green');
  for (var i = 0; i < ((this.current / this.total) * this.size) - 1 ; i++) {
     this.charm.write(' ');
  }
  this.charm.foreground('white').background('white');
  while (i < this.size - 1) {
    this.charm.write(' ');
    i++;
  }
  this.charm.display('reset').down(1).left(100);
};

/**
 * Output numerical progress stats.
 */
Pace.prototype.outputStats = function outputStats() {
  this.perc = (this.current/this.total)*100;
  this.perc = padLeft(this.perc.toFixed(2), 2);
  this.charm.write('            ').display('bright').write(this.perc + '%').display('reset');
  this.total_len = formatNumber(this.total).length;
  this.charm.write('   ').display('bright').write(padLeft(formatNumber(this.current), this.total_len)).display('reset');
  this.charm.write('/' + formatNumber(this.total));

  // Output burden.
  if (this.show_burden) {
    this.charm.write('    ').display('bright').write('Burden: ').display('reset');
    this.charm.write(this.time_burden.toFixed(2) + '% / ' + this.skip_steps);
  }

  this.charm.display('reset').down(1).left(100);
};

/**
 * Output times.
 */
Pace.prototype.outputTimes = function outputTimes() {
  // Output times.
  var hours = Math.floor(this.elapsed / (1000 * 60 * 60));
  var min = Math.floor(((this.elapsed / 1000) % (60 * 60)) / 60);
  var sec = Math.floor((this.elapsed / 1000) % 60);

  this.charm.write('            ').display('bright').write('Elapsed: ').display('reset');
  this.charm.write(hours + 'h ' + min + 'm ' + sec + 's');

  if (this.time_left){
    hours = Math.floor(this.time_left / (1000 * 60 * 60));
    min = Math.floor(((this.time_left / 1000) % (60 * 60)) / 60);
    sec = Math.ceil((this.time_left / 1000) % 60);

    this.charm.write('   ').display('bright').write('Remaining: ').display('reset');
    this.charm.write(hours + 'h ' + min + 'm ' + sec + 's');
  }
};

/**
 * The progress has finished.
 */
Pace.prototype.finished = function finished() {
  this.charm.write("\n\n");
  this.charm.write('Finished!');
  this.charm.write("\n\n");
};

/**
 * Check if the burden threshold has been reached.
 */
Pace.prototype.burdenReached = function burdenReached() {
  // Skip this cycle if the burden has determined we should.
  if ((this.skip_steps > 0) && (this.current < this.total)) {
    if (this.skipped < this.skip_steps) {
      this.skipped++;
      return true;
    }
    else {
      this.skipped = 0;
    }
  }
  return false;
};


/**
 * Utility functions.
 */

// Left-pad a string.
function padLeft(str, length, pad) {
  pad = pad || ' ';
  while (str.length < length)
    str = pad + str;
  return str;
}

// Ported from php.js. Same has php's number_format().
function formatNumber(number, decimals, dec_point, thousands_sep) {
  number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
  var n = !isFinite(+number) ? 0 : +number,
    prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
    sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
    dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
    s = '',
    toFixedFix = function (n, prec) {
      var k = Math.pow(10, prec);
      return '' + Math.round(n * k) / k;
    };
  // Fix for IE parseFloat(0.55).toFixed(0) = 0;
  s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
  if (s[0].length > 3) {
    s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
  }
  if ((s[1] || '').length < prec) {
    s[1] = s[1] || '';
    s[1] += new Array(prec - s[1].length + 1).join('0');
  }
  return s.join(dec);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/process-nextick-args/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

if (!process.version ||
    process.version.indexOf('v0.') === 0 ||
    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
  module.exports = { nextTick: nextTick };
} else {
  module.exports = process
}

function nextTick(fn, arg1, arg2, arg3) {
  if (typeof fn !== 'function') {
    throw new TypeError('"callback" argument must be a function');
  }
  var len = arguments.length;
  var args, i;
  switch (len) {
  case 0:
  case 1:
    return process.nextTick(fn);
  case 2:
    return process.nextTick(function afterTickOne() {
      fn.call(null, arg1);
    });
  case 3:
    return process.nextTick(function afterTickTwo() {
      fn.call(null, arg1, arg2);
    });
  case 4:
    return process.nextTick(function afterTickThree() {
      fn.call(null, arg1, arg2, arg3);
    });
  default:
    args = new Array(len - 1);
    i = 0;
    while (i < args.length) {
      args[i++] = arguments[i];
    }
    return process.nextTick(function afterTick() {
      fn.apply(null, args);
    });
  }
}


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/quill-image-resize/image-resize.min.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Quill) {!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.ImageResize=e():t.ImageResize=e()}(this,function(){return function(t){function e(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return t[r].call(o.exports,o,o.exports,e),o.l=!0,o.exports}var n={};return e.m=t,e.c=n,e.i=function(t){return t},e.d=function(t,n,r){e.o(t,n)||Object.defineProperty(t,n,{configurable:!1,enumerable:!0,get:r})},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="",e(e.s=41)}([function(t,e){function n(t){var e=typeof t;return null!=t&&("object"==e||"function"==e)}t.exports=n},function(t,e,n){var r=n(23),o="object"==typeof self&&self&&self.Object===Object&&self,i=r||o||Function("return this")();t.exports=i},function(t,e){function n(t){return null!=t&&"object"==typeof t}t.exports=n},function(t,e,n){function r(t){var e=-1,n=null==t?0:t.length;for(this.clear();++e<n;){var r=t[e];this.set(r[0],r[1])}}var o=n(82),i=n(83),l=n(84),a=n(85),s=n(86);r.prototype.clear=o,r.prototype.delete=i,r.prototype.get=l,r.prototype.has=a,r.prototype.set=s,t.exports=r},function(t,e,n){function r(t,e){for(var n=t.length;n--;)if(o(t[n][0],e))return n;return-1}var o=n(8);t.exports=r},function(t,e,n){function r(t){return null==t?void 0===t?s:a:u&&u in Object(t)?i(t):l(t)}var o=n(17),i=n(71),l=n(94),a="[object Null]",s="[object Undefined]",u=o?o.toStringTag:void 0;t.exports=r},function(t,e,n){function r(t,e){var n=t.__data__;return o(e)?n["string"==typeof e?"string":"hash"]:n.map}var o=n(80);t.exports=r},function(t,e,n){var r=n(11),o=r(Object,"create");t.exports=o},function(t,e){function n(t,e){return t===e||t!==t&&e!==e}t.exports=n},function(t,e,n){"use strict";function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}n.d(e,"a",function(){return o});var o=function t(e){r(this,t),this.onCreate=function(){},this.onDestroy=function(){},this.onUpdate=function(){},this.overlay=e.overlay,this.img=e.img,this.options=e.options,this.requestUpdate=e.onUpdate}},function(t,e,n){function r(t,e,n){"__proto__"==e&&o?o(t,e,{configurable:!0,enumerable:!0,value:n,writable:!0}):t[e]=n}var o=n(22);t.exports=r},function(t,e,n){function r(t,e){var n=i(t,e);return o(n)?n:void 0}var o=n(55),i=n(72);t.exports=r},function(t,e,n){function r(t){return null!=t&&i(t.length)&&!o(t)}var o=n(13),i=n(32);t.exports=r},function(t,e,n){function r(t){if(!i(t))return!1;var e=o(t);return e==a||e==s||e==l||e==u}var o=n(5),i=n(0),l="[object AsyncFunction]",a="[object Function]",s="[object GeneratorFunction]",u="[object Proxy]";t.exports=r},function(t,e){t.exports=function(t){return t.webpackPolyfill||(t.deprecate=function(){},t.paths=[],t.children||(t.children=[]),Object.defineProperty(t,"loaded",{enumerable:!0,get:function(){return t.l}}),Object.defineProperty(t,"id",{enumerable:!0,get:function(){return t.i}}),t.webpackPolyfill=1),t}},function(t,e,n){(function(e){/*!
 * Quill Editor v1.3.6
 * https://quilljs.com/
 * Copyright (c) 2014, Jason Chen
 * Copyright (c) 2013, salesforce.com
 */
!function(e,n){t.exports=n()}("undefined"!=typeof self&&self,function(){return function(t){function e(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return t[r].call(o.exports,o,o.exports,e),o.l=!0,o.exports}var n={};return e.m=t,e.c=n,e.d=function(t,n,r){e.o(t,n)||Object.defineProperty(t,n,{configurable:!1,enumerable:!0,get:r})},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="",e(e.s=109)}([function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(17),o=n(18),i=n(19),l=n(45),a=n(46),s=n(47),u=n(48),c=n(49),f=n(12),h=n(32),p=n(33),d=n(31),y=n(1),v={Scope:y.Scope,create:y.create,find:y.find,query:y.query,register:y.register,Container:r.default,Format:o.default,Leaf:i.default,Embed:u.default,Scroll:l.default,Block:s.default,Inline:a.default,Text:c.default,Attributor:{Attribute:f.default,Class:h.default,Style:p.default,Store:d.default}};e.default=v},function(t,e,n){"use strict";function r(t,e){var n=i(t);if(null==n)throw new s("Unable to create "+t+" blot");var r=n;return new r(t instanceof Node||t.nodeType===Node.TEXT_NODE?t:r.create(e),e)}function o(t,n){return void 0===n&&(n=!1),null==t?null:null!=t[e.DATA_KEY]?t[e.DATA_KEY].blot:n?o(t.parentNode,n):null}function i(t,e){void 0===e&&(e=p.ANY);var n;if("string"==typeof t)n=h[t]||u[t];else if(t instanceof Text||t.nodeType===Node.TEXT_NODE)n=h.text;else if("number"==typeof t)t&p.LEVEL&p.BLOCK?n=h.block:t&p.LEVEL&p.INLINE&&(n=h.inline);else if(t instanceof HTMLElement){var r=(t.getAttribute("class")||"").split(/\s+/);for(var o in r)if(n=c[r[o]])break;n=n||f[t.tagName]}return null==n?null:e&p.LEVEL&n.scope&&e&p.TYPE&n.scope?n:null}function l(){for(var t=[],e=0;e<arguments.length;e++)t[e]=arguments[e];if(t.length>1)return t.map(function(t){return l(t)});var n=t[0];if("string"!=typeof n.blotName&&"string"!=typeof n.attrName)throw new s("Invalid definition");if("abstract"===n.blotName)throw new s("Cannot register abstract class");if(h[n.blotName||n.attrName]=n,"string"==typeof n.keyName)u[n.keyName]=n;else if(null!=n.className&&(c[n.className]=n),null!=n.tagName){Array.isArray(n.tagName)?n.tagName=n.tagName.map(function(t){return t.toUpperCase()}):n.tagName=n.tagName.toUpperCase();var r=Array.isArray(n.tagName)?n.tagName:[n.tagName];r.forEach(function(t){null!=f[t]&&null!=n.className||(f[t]=n)})}return n}var a=this&&this.__extends||function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])};return function(e,n){function r(){this.constructor=e}t(e,n),e.prototype=null===n?Object.create(n):(r.prototype=n.prototype,new r)}}();Object.defineProperty(e,"__esModule",{value:!0});var s=function(t){function e(e){var n=this;return e="[Parchment] "+e,n=t.call(this,e)||this,n.message=e,n.name=n.constructor.name,n}return a(e,t),e}(Error);e.ParchmentError=s;var u={},c={},f={},h={};e.DATA_KEY="__blot";var p;!function(t){t[t.TYPE=3]="TYPE",t[t.LEVEL=12]="LEVEL",t[t.ATTRIBUTE=13]="ATTRIBUTE",t[t.BLOT=14]="BLOT",t[t.INLINE=7]="INLINE",t[t.BLOCK=11]="BLOCK",t[t.BLOCK_BLOT=10]="BLOCK_BLOT",t[t.INLINE_BLOT=6]="INLINE_BLOT",t[t.BLOCK_ATTRIBUTE=9]="BLOCK_ATTRIBUTE",t[t.INLINE_ATTRIBUTE=5]="INLINE_ATTRIBUTE",t[t.ANY=15]="ANY"}(p=e.Scope||(e.Scope={})),e.create=r,e.find=o,e.query=i,e.register=l},function(t,e,n){var r=n(51),o=n(11),i=n(3),l=n(20),a=String.fromCharCode(0),s=function(t){Array.isArray(t)?this.ops=t:null!=t&&Array.isArray(t.ops)?this.ops=t.ops:this.ops=[]};s.prototype.insert=function(t,e){var n={};return 0===t.length?this:(n.insert=t,null!=e&&"object"==typeof e&&Object.keys(e).length>0&&(n.attributes=e),this.push(n))},s.prototype.delete=function(t){return t<=0?this:this.push({delete:t})},s.prototype.retain=function(t,e){if(t<=0)return this;var n={retain:t};return null!=e&&"object"==typeof e&&Object.keys(e).length>0&&(n.attributes=e),this.push(n)},s.prototype.push=function(t){var e=this.ops.length,n=this.ops[e-1];if(t=i(!0,{},t),"object"==typeof n){if("number"==typeof t.delete&&"number"==typeof n.delete)return this.ops[e-1]={delete:n.delete+t.delete},this;if("number"==typeof n.delete&&null!=t.insert&&(e-=1,"object"!=typeof(n=this.ops[e-1])))return this.ops.unshift(t),this;if(o(t.attributes,n.attributes)){if("string"==typeof t.insert&&"string"==typeof n.insert)return this.ops[e-1]={insert:n.insert+t.insert},"object"==typeof t.attributes&&(this.ops[e-1].attributes=t.attributes),this;if("number"==typeof t.retain&&"number"==typeof n.retain)return this.ops[e-1]={retain:n.retain+t.retain},"object"==typeof t.attributes&&(this.ops[e-1].attributes=t.attributes),this}}return e===this.ops.length?this.ops.push(t):this.ops.splice(e,0,t),this},s.prototype.chop=function(){var t=this.ops[this.ops.length-1];return t&&t.retain&&!t.attributes&&this.ops.pop(),this},s.prototype.filter=function(t){return this.ops.filter(t)},s.prototype.forEach=function(t){this.ops.forEach(t)},s.prototype.map=function(t){return this.ops.map(t)},s.prototype.partition=function(t){var e=[],n=[];return this.forEach(function(r){(t(r)?e:n).push(r)}),[e,n]},s.prototype.reduce=function(t,e){return this.ops.reduce(t,e)},s.prototype.changeLength=function(){return this.reduce(function(t,e){return e.insert?t+l.length(e):e.delete?t-e.delete:t},0)},s.prototype.length=function(){return this.reduce(function(t,e){return t+l.length(e)},0)},s.prototype.slice=function(t,e){t=t||0,"number"!=typeof e&&(e=1/0);for(var n=[],r=l.iterator(this.ops),o=0;o<e&&r.hasNext();){var i;o<t?i=r.next(t-o):(i=r.next(e-o),n.push(i)),o+=l.length(i)}return new s(n)},s.prototype.compose=function(t){for(var e=l.iterator(this.ops),n=l.iterator(t.ops),r=new s;e.hasNext()||n.hasNext();)if("insert"===n.peekType())r.push(n.next());else if("delete"===e.peekType())r.push(e.next());else{var o=Math.min(e.peekLength(),n.peekLength()),i=e.next(o),a=n.next(o);if("number"==typeof a.retain){var u={};"number"==typeof i.retain?u.retain=o:u.insert=i.insert;var c=l.attributes.compose(i.attributes,a.attributes,"number"==typeof i.retain);c&&(u.attributes=c),r.push(u)}else"number"==typeof a.delete&&"number"==typeof i.retain&&r.push(a)}return r.chop()},s.prototype.concat=function(t){var e=new s(this.ops.slice());return t.ops.length>0&&(e.push(t.ops[0]),e.ops=e.ops.concat(t.ops.slice(1))),e},s.prototype.diff=function(t,e){if(this.ops===t.ops)return new s;var n=[this,t].map(function(e){return e.map(function(n){if(null!=n.insert)return"string"==typeof n.insert?n.insert:a;var r=e===t?"on":"with";throw new Error("diff() called "+r+" non-document")}).join("")}),i=new s,u=r(n[0],n[1],e),c=l.iterator(this.ops),f=l.iterator(t.ops);return u.forEach(function(t){for(var e=t[1].length;e>0;){var n=0;switch(t[0]){case r.INSERT:n=Math.min(f.peekLength(),e),i.push(f.next(n));break;case r.DELETE:n=Math.min(e,c.peekLength()),c.next(n),i.delete(n);break;case r.EQUAL:n=Math.min(c.peekLength(),f.peekLength(),e);var a=c.next(n),s=f.next(n);o(a.insert,s.insert)?i.retain(n,l.attributes.diff(a.attributes,s.attributes)):i.push(s).delete(n)}e-=n}}),i.chop()},s.prototype.eachLine=function(t,e){e=e||"\n";for(var n=l.iterator(this.ops),r=new s,o=0;n.hasNext();){if("insert"!==n.peekType())return;var i=n.peek(),a=l.length(i)-n.peekLength(),u="string"==typeof i.insert?i.insert.indexOf(e,a)-a:-1;if(u<0)r.push(n.next());else if(u>0)r.push(n.next(u));else{if(!1===t(r,n.next(1).attributes||{},o))return;o+=1,r=new s}}r.length()>0&&t(r,{},o)},s.prototype.transform=function(t,e){if(e=!!e,"number"==typeof t)return this.transformPosition(t,e);for(var n=l.iterator(this.ops),r=l.iterator(t.ops),o=new s;n.hasNext()||r.hasNext();)if("insert"!==n.peekType()||!e&&"insert"===r.peekType())if("insert"===r.peekType())o.push(r.next());else{var i=Math.min(n.peekLength(),r.peekLength()),a=n.next(i),u=r.next(i);if(a.delete)continue;u.delete?o.push(u):o.retain(i,l.attributes.transform(a.attributes,u.attributes,e))}else o.retain(l.length(n.next()));return o.chop()},s.prototype.transformPosition=function(t,e){e=!!e;for(var n=l.iterator(this.ops),r=0;n.hasNext()&&r<=t;){var o=n.peekLength(),i=n.peekType();n.next(),"delete"!==i?("insert"===i&&(r<t||!e)&&(t+=o),r+=o):t-=Math.min(o,t-r)}return t},t.exports=s},function(t,e){"use strict";var n=Object.prototype.hasOwnProperty,r=Object.prototype.toString,o=function(t){return"function"==typeof Array.isArray?Array.isArray(t):"[object Array]"===r.call(t)},i=function(t){if(!t||"[object Object]"!==r.call(t))return!1;var e=n.call(t,"constructor"),o=t.constructor&&t.constructor.prototype&&n.call(t.constructor.prototype,"isPrototypeOf");if(t.constructor&&!e&&!o)return!1;var i;for(i in t);return void 0===i||n.call(t,i)};t.exports=function t(){var e,n,r,l,a,s,u=arguments[0],c=1,f=arguments.length,h=!1;for("boolean"==typeof u&&(h=u,u=arguments[1]||{},c=2),(null==u||"object"!=typeof u&&"function"!=typeof u)&&(u={});c<f;++c)if(null!=(e=arguments[c]))for(n in e)r=u[n],l=e[n],u!==l&&(h&&l&&(i(l)||(a=o(l)))?(a?(a=!1,s=r&&o(r)?r:[]):s=r&&i(r)?r:{},u[n]=t(h,s,l)):void 0!==l&&(u[n]=l));return u}},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function l(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}function a(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return null==t?e:("function"==typeof t.formats&&(e=(0,f.default)(e,t.formats())),null==t.parent||"scroll"==t.parent.blotName||t.parent.statics.scope!==t.statics.scope?e:a(t.parent,e))}Object.defineProperty(e,"__esModule",{value:!0}),e.default=e.BlockEmbed=e.bubbleFormats=void 0;var s=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),u=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},c=n(3),f=r(c),h=n(2),p=r(h),d=n(0),y=r(d),v=n(16),b=r(v),g=n(6),m=r(g),_=n(7),O=r(_),w=function(t){function e(){return o(this,e),i(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return l(e,t),s(e,[{key:"attach",value:function(){u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"attach",this).call(this),this.attributes=new y.default.Attributor.Store(this.domNode)}},{key:"delta",value:function(){return(new p.default).insert(this.value(),(0,f.default)(this.formats(),this.attributes.values()))}},{key:"format",value:function(t,e){var n=y.default.query(t,y.default.Scope.BLOCK_ATTRIBUTE);null!=n&&this.attributes.attribute(n,e)}},{key:"formatAt",value:function(t,e,n,r){this.format(n,r)}},{key:"insertAt",value:function(t,n,r){if("string"==typeof n&&n.endsWith("\n")){var o=y.default.create(x.blotName);this.parent.insertBefore(o,0===t?this:this.next),o.insertAt(0,n.slice(0,-1))}else u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"insertAt",this).call(this,t,n,r)}}]),e}(y.default.Embed);w.scope=y.default.Scope.BLOCK_BLOT;var x=function(t){function e(t){o(this,e);var n=i(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t));return n.cache={},n}return l(e,t),s(e,[{key:"delta",value:function(){return null==this.cache.delta&&(this.cache.delta=this.descendants(y.default.Leaf).reduce(function(t,e){return 0===e.length()?t:t.insert(e.value(),a(e))},new p.default).insert("\n",a(this))),this.cache.delta}},{key:"deleteAt",value:function(t,n){u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"deleteAt",this).call(this,t,n),this.cache={}}},{key:"formatAt",value:function(t,n,r,o){n<=0||(y.default.query(r,y.default.Scope.BLOCK)?t+n===this.length()&&this.format(r,o):u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"formatAt",this).call(this,t,Math.min(n,this.length()-t-1),r,o),this.cache={})}},{key:"insertAt",value:function(t,n,r){if(null!=r)return u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"insertAt",this).call(this,t,n,r);if(0!==n.length){var o=n.split("\n"),i=o.shift();i.length>0&&(t<this.length()-1||null==this.children.tail?u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"insertAt",this).call(this,Math.min(t,this.length()-1),i):this.children.tail.insertAt(this.children.tail.length(),i),this.cache={});var l=this;o.reduce(function(t,e){return l=l.split(t,!0),l.insertAt(0,e),e.length},t+i.length)}}},{key:"insertBefore",value:function(t,n){var r=this.children.head;u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"insertBefore",this).call(this,t,n),r instanceof b.default&&r.remove(),this.cache={}}},{key:"length",value:function(){return null==this.cache.length&&(this.cache.length=u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"length",this).call(this)+1),this.cache.length}},{key:"moveChildren",value:function(t,n){u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"moveChildren",this).call(this,t,n),this.cache={}}},{key:"optimize",value:function(t){u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"optimize",this).call(this,t),this.cache={}}},{key:"path",value:function(t){return u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"path",this).call(this,t,!0)}},{key:"removeChild",value:function(t){u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"removeChild",this).call(this,t),this.cache={}}},{key:"split",value:function(t){var n=arguments.length>1&&void 0!==arguments[1]&&arguments[1];if(n&&(0===t||t>=this.length()-1)){var r=this.clone();return 0===t?(this.parent.insertBefore(r,this),this):(this.parent.insertBefore(r,this.next),r)}var o=u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"split",this).call(this,t,n);return this.cache={},o}}]),e}(y.default.Block);x.blotName="block",x.tagName="P",x.defaultChild="break",x.allowedChildren=[m.default,y.default.Embed,O.default],e.bubbleFormats=a,e.BlockEmbed=w,e.default=x},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function l(t,e){if(e=(0,A.default)(!0,{container:t,modules:{clipboard:!0,keyboard:!0,history:!0}},e),e.theme&&e.theme!==q.DEFAULTS.theme){if(e.theme=q.import("themes/"+e.theme),null==e.theme)throw new Error("Invalid theme "+e.theme+". Did you register it?")}else e.theme=S.default;var n=(0,A.default)(!0,{},e.theme.DEFAULTS);[n,e].forEach(function(t){t.modules=t.modules||{},Object.keys(t.modules).forEach(function(e){!0===t.modules[e]&&(t.modules[e]={})})});var r=Object.keys(n.modules).concat(Object.keys(e.modules)),o=r.reduce(function(t,e){var n=q.import("modules/"+e);return null==n?P.error("Cannot load "+e+" module. Are you sure you registered it?"):t[e]=n.DEFAULTS||{},t},{});return null!=e.modules&&e.modules.toolbar&&e.modules.toolbar.constructor!==Object&&(e.modules.toolbar={container:e.modules.toolbar}),e=(0,A.default)(!0,{},q.DEFAULTS,{modules:o},n,e),["bounds","container","scrollingContainer"].forEach(function(t){"string"==typeof e[t]&&(e[t]=document.querySelector(e[t]))}),e.modules=Object.keys(e.modules).reduce(function(t,n){return e.modules[n]&&(t[n]=e.modules[n]),t},{}),e}function a(t,e,n,r){if(this.options.strict&&!this.isEnabled()&&e===g.default.sources.USER)return new d.default;var o=null==n?null:this.getSelection(),i=this.editor.delta,l=t();if(null!=o&&(!0===n&&(n=o.index),null==r?o=u(o,l,e):0!==r&&(o=u(o,n,r,e)),this.setSelection(o,g.default.sources.SILENT)),l.length()>0){var a,s=[g.default.events.TEXT_CHANGE,l,i,e];if((a=this.emitter).emit.apply(a,[g.default.events.EDITOR_CHANGE].concat(s)),e!==g.default.sources.SILENT){var c;(c=this.emitter).emit.apply(c,s)}}return l}function s(t,e,n,r,o){var i={};return"number"==typeof t.index&&"number"==typeof t.length?"number"!=typeof e?(o=r,r=n,n=e,e=t.length,t=t.index):(e=t.length,t=t.index):"number"!=typeof e&&(o=r,r=n,n=e,e=0),"object"===(void 0===n?"undefined":c(n))?(i=n,o=r):"string"==typeof n&&(null!=r?i[n]=r:o=n),o=o||g.default.sources.API,[t,e,i,o]}function u(t,e,n,r){if(null==t)return null;var o=void 0,i=void 0;if(e instanceof d.default){var l=[t.index,t.index+t.length].map(function(t){return e.transformPosition(t,r!==g.default.sources.USER)}),a=f(l,2);o=a[0],i=a[1]}else{var s=[t.index,t.index+t.length].map(function(t){return t<e||t===e&&r===g.default.sources.USER?t:n>=0?t+n:Math.max(e,t+n)}),u=f(s,2);o=u[0],i=u[1]}return new x.Range(o,i-o)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=e.overload=e.expandConfig=void 0;var c="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},f=function(){function t(t,e){var n=[],r=!0,o=!1,i=void 0;try{for(var l,a=t[Symbol.iterator]();!(r=(l=a.next()).done)&&(n.push(l.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t}finally{try{!r&&a.return&&a.return()}finally{if(o)throw i}}return n}return function(e,n){if(Array.isArray(e))return e;if(Symbol.iterator in Object(e))return t(e,n);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),h=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}();n(50);var p=n(2),d=r(p),y=n(14),v=r(y),b=n(8),g=r(b),m=n(9),_=r(m),O=n(0),w=r(O),x=n(15),E=r(x),k=n(3),A=r(k),j=n(10),N=r(j),T=n(34),S=r(T),P=(0,N.default)("quill"),q=function(){function t(e){var n=this,r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};if(i(this,t),this.options=l(e,r),this.container=this.options.container,null==this.container)return P.error("Invalid Quill container",e);this.options.debug&&t.debug(this.options.debug);var o=this.container.innerHTML.trim();this.container.classList.add("ql-container"),this.container.innerHTML="",this.container.__quill=this,this.root=this.addContainer("ql-editor"),this.root.classList.add("ql-blank"),this.root.setAttribute("data-gramm",!1),this.scrollingContainer=this.options.scrollingContainer||this.root,this.emitter=new g.default,this.scroll=w.default.create(this.root,{emitter:this.emitter,whitelist:this.options.formats}),this.editor=new v.default(this.scroll),this.selection=new E.default(this.scroll,this.emitter),this.theme=new this.options.theme(this,this.options),this.keyboard=this.theme.addModule("keyboard"),this.clipboard=this.theme.addModule("clipboard"),this.history=this.theme.addModule("history"),this.theme.init(),this.emitter.on(g.default.events.EDITOR_CHANGE,function(t){t===g.default.events.TEXT_CHANGE&&n.root.classList.toggle("ql-blank",n.editor.isBlank())}),this.emitter.on(g.default.events.SCROLL_UPDATE,function(t,e){var r=n.selection.lastRange,o=r&&0===r.length?r.index:void 0;a.call(n,function(){return n.editor.update(null,e,o)},t)});var s=this.clipboard.convert("<div class='ql-editor' style=\"white-space: normal;\">"+o+"<p><br></p></div>");this.setContents(s),this.history.clear(),this.options.placeholder&&this.root.setAttribute("data-placeholder",this.options.placeholder),this.options.readOnly&&this.disable()}return h(t,null,[{key:"debug",value:function(t){!0===t&&(t="log"),N.default.level(t)}},{key:"find",value:function(t){return t.__quill||w.default.find(t)}},{key:"import",value:function(t){return null==this.imports[t]&&P.error("Cannot import "+t+". Are you sure it was registered?"),this.imports[t]}},{key:"register",value:function(t,e){var n=this,r=arguments.length>2&&void 0!==arguments[2]&&arguments[2];if("string"!=typeof t){var o=t.attrName||t.blotName;"string"==typeof o?this.register("formats/"+o,t,e):Object.keys(t).forEach(function(r){n.register(r,t[r],e)})}else null==this.imports[t]||r||P.warn("Overwriting "+t+" with",e),this.imports[t]=e,(t.startsWith("blots/")||t.startsWith("formats/"))&&"abstract"!==e.blotName?w.default.register(e):t.startsWith("modules")&&"function"==typeof e.register&&e.register()}}]),h(t,[{key:"addContainer",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null;if("string"==typeof t){var n=t;t=document.createElement("div"),t.classList.add(n)}return this.container.insertBefore(t,e),t}},{key:"blur",value:function(){this.selection.setRange(null)}},{key:"deleteText",value:function(t,e,n){var r=this,o=s(t,e,n),i=f(o,4);return t=i[0],e=i[1],n=i[3],a.call(this,function(){return r.editor.deleteText(t,e)},n,t,-1*e)}},{key:"disable",value:function(){this.enable(!1)}},{key:"enable",value:function(){var t=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];this.scroll.enable(t),this.container.classList.toggle("ql-disabled",!t)}},{key:"focus",value:function(){var t=this.scrollingContainer.scrollTop;this.selection.focus(),this.scrollingContainer.scrollTop=t,this.scrollIntoView()}},{key:"format",value:function(t,e){var n=this,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:g.default.sources.API;return a.call(this,function(){var r=n.getSelection(!0),i=new d.default;if(null==r)return i;if(w.default.query(t,w.default.Scope.BLOCK))i=n.editor.formatLine(r.index,r.length,o({},t,e));else{if(0===r.length)return n.selection.format(t,e),i;i=n.editor.formatText(r.index,r.length,o({},t,e))}return n.setSelection(r,g.default.sources.SILENT),i},r)}},{key:"formatLine",value:function(t,e,n,r,o){var i=this,l=void 0,u=s(t,e,n,r,o),c=f(u,4);return t=c[0],e=c[1],l=c[2],o=c[3],a.call(this,function(){return i.editor.formatLine(t,e,l)},o,t,0)}},{key:"formatText",value:function(t,e,n,r,o){var i=this,l=void 0,u=s(t,e,n,r,o),c=f(u,4);return t=c[0],e=c[1],l=c[2],o=c[3],a.call(this,function(){return i.editor.formatText(t,e,l)},o,t,0)}},{key:"getBounds",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,n=void 0;n="number"==typeof t?this.selection.getBounds(t,e):this.selection.getBounds(t.index,t.length);var r=this.container.getBoundingClientRect();return{bottom:n.bottom-r.top,height:n.height,left:n.left-r.left,right:n.right-r.left,top:n.top-r.top,width:n.width}}},{key:"getContents",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:this.getLength()-t,n=s(t,e),r=f(n,2);return t=r[0],e=r[1],this.editor.getContents(t,e)}},{key:"getFormat",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:this.getSelection(!0),e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;return"number"==typeof t?this.editor.getFormat(t,e):this.editor.getFormat(t.index,t.length)}},{key:"getIndex",value:function(t){return t.offset(this.scroll)}},{key:"getLength",value:function(){return this.scroll.length()}},{key:"getLeaf",value:function(t){return this.scroll.leaf(t)}},{key:"getLine",value:function(t){return this.scroll.line(t)}},{key:"getLines",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:Number.MAX_VALUE;return"number"!=typeof t?this.scroll.lines(t.index,t.length):this.scroll.lines(t,e)}},{key:"getModule",value:function(t){return this.theme.modules[t]}},{key:"getSelection",value:function(){return arguments.length>0&&void 0!==arguments[0]&&arguments[0]&&this.focus(),this.update(),this.selection.getRange()[0]}},{key:"getText",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:this.getLength()-t,n=s(t,e),r=f(n,2);return t=r[0],e=r[1],this.editor.getText(t,e)}},{key:"hasFocus",value:function(){return this.selection.hasFocus()}},{key:"insertEmbed",value:function(e,n,r){var o=this,i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:t.sources.API;return a.call(this,function(){return o.editor.insertEmbed(e,n,r)},i,e)}},{key:"insertText",value:function(t,e,n,r,o){var i=this,l=void 0,u=s(t,0,n,r,o),c=f(u,4);return t=c[0],l=c[2],o=c[3],a.call(this,function(){return i.editor.insertText(t,e,l)},o,t,e.length)}},{key:"isEnabled",value:function(){return!this.container.classList.contains("ql-disabled")}},{key:"off",value:function(){return this.emitter.off.apply(this.emitter,arguments)}},{key:"on",value:function(){return this.emitter.on.apply(this.emitter,arguments)}},{key:"once",value:function(){return this.emitter.once.apply(this.emitter,arguments)}},{key:"pasteHTML",value:function(t,e,n){this.clipboard.dangerouslyPasteHTML(t,e,n)}},{key:"removeFormat",value:function(t,e,n){var r=this,o=s(t,e,n),i=f(o,4);return t=i[0],e=i[1],n=i[3],a.call(this,function(){return r.editor.removeFormat(t,e)},n,t)}},{key:"scrollIntoView",value:function(){this.selection.scrollIntoView(this.scrollingContainer)}},{key:"setContents",value:function(t){var e=this,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:g.default.sources.API;return a.call(this,function(){t=new d.default(t);var n=e.getLength(),r=e.editor.deleteText(0,n),o=e.editor.applyDelta(t),i=o.ops[o.ops.length-1];return null!=i&&"string"==typeof i.insert&&"\n"===i.insert[i.insert.length-1]&&(e.editor.deleteText(e.getLength()-1,1),o.delete(1)),r.compose(o)},n)}},{key:"setSelection",value:function(e,n,r){if(null==e)this.selection.setRange(null,n||t.sources.API);else{var o=s(e,n,r),i=f(o,4);e=i[0],n=i[1],r=i[3],this.selection.setRange(new x.Range(e,n),r),r!==g.default.sources.SILENT&&this.selection.scrollIntoView(this.scrollingContainer)}}},{key:"setText",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:g.default.sources.API,n=(new d.default).insert(t);return this.setContents(n,e)}},{key:"update",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:g.default.sources.USER,e=this.scroll.update(t);return this.selection.update(t),e}},{key:"updateContents",value:function(t){var e=this,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:g.default.sources.API;return a.call(this,function(){return t=new d.default(t),e.editor.applyDelta(t,n)},n,!0)}}]),t}();q.DEFAULTS={bounds:null,formats:null,modules:{},placeholder:"",readOnly:!1,scrollingContainer:null,strict:!0,theme:"default"},q.events=g.default.events,q.sources=g.default.sources,q.version="1.3.6",q.imports={delta:d.default,parchment:w.default,"core/module":_.default,"core/theme":S.default},e.expandConfig=l,e.overload=s,e.default=q},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function l(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var a=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),s=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},u=n(7),c=r(u),f=n(0),h=r(f),p=function(t){function e(){return o(this,e),i(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return l(e,t),a(e,[{key:"formatAt",value:function(t,n,r,o){if(e.compare(this.statics.blotName,r)<0&&h.default.query(r,h.default.Scope.BLOT)){var i=this.isolate(t,n);o&&i.wrap(r,o)}else s(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"formatAt",this).call(this,t,n,r,o)}},{key:"optimize",value:function(t){if(s(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"optimize",this).call(this,t),this.parent instanceof e&&e.compare(this.statics.blotName,this.parent.statics.blotName)>0){var n=this.parent.isolate(this.offset(),this.length());this.moveChildren(n),n.wrap(this)}}}],[{key:"compare",value:function(t,n){var r=e.order.indexOf(t),o=e.order.indexOf(n);return r>=0||o>=0?r-o:t===n?0:t<n?-1:1}}]),e}(h.default.Inline);p.allowedChildren=[p,h.default.Embed,c.default],p.order=["cursor","inline","underline","strike","italic","bold","script","link","code"],e.default=p},function(t,e,n){"use strict";function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function i(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var l=n(0),a=function(t){return t&&t.__esModule?t:{default:t}}(l),s=function(t){function e(){return r(this,e),o(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return i(e,t),e}(a.default.Text);e.default=s},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function l(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var a=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),s=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},u=n(54),c=r(u),f=n(10),h=r(f),p=(0,h.default)("quill:events");["selectionchange","mousedown","mouseup","click"].forEach(function(t){document.addEventListener(t,function(){for(var t=arguments.length,e=Array(t),n=0;n<t;n++)e[n]=arguments[n];[].slice.call(document.querySelectorAll(".ql-container")).forEach(function(t){if(t.__quill&&t.__quill.emitter){var n;(n=t.__quill.emitter).handleDOM.apply(n,e)}})})});var d=function(t){function e(){o(this,e);var t=i(this,(e.__proto__||Object.getPrototypeOf(e)).call(this));return t.listeners={},t.on("error",p.error),t}return l(e,t),a(e,[{key:"emit",value:function(){p.log.apply(p,arguments),s(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"emit",this).apply(this,arguments)}},{key:"handleDOM",value:function(t){for(var e=arguments.length,n=Array(e>1?e-1:0),r=1;r<e;r++)n[r-1]=arguments[r];(this.listeners[t.type]||[]).forEach(function(e){var r=e.node,o=e.handler;(t.target===r||r.contains(t.target))&&o.apply(void 0,[t].concat(n))})}},{key:"listenDOM",value:function(t,e,n){this.listeners[t]||(this.listeners[t]=[]),this.listeners[t].push({node:e,handler:n})}}]),e}(c.default);d.events={EDITOR_CHANGE:"editor-change",SCROLL_BEFORE_UPDATE:"scroll-before-update",SCROLL_OPTIMIZE:"scroll-optimize",SCROLL_UPDATE:"scroll-update",SELECTION_CHANGE:"selection-change",TEXT_CHANGE:"text-change"},d.sources={API:"api",SILENT:"silent",USER:"user"},e.default=d},function(t,e,n){"use strict";function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var o=function t(e){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};r(this,t),this.quill=e,this.options=n};o.DEFAULTS={},e.default=o},function(t,e,n){"use strict";function r(t){if(i.indexOf(t)<=i.indexOf(l)){for(var e,n=arguments.length,r=Array(n>1?n-1:0),o=1;o<n;o++)r[o-1]=arguments[o];(e=console)[t].apply(e,r)}}function o(t){return i.reduce(function(e,n){return e[n]=r.bind(console,n,t),e},{})}Object.defineProperty(e,"__esModule",{value:!0});var i=["error","warn","log","info"],l="warn";r.level=o.level=function(t){l=t},e.default=o},function(t,e,n){function r(t){return null===t||void 0===t}function o(t){return!(!t||"object"!=typeof t||"number"!=typeof t.length)&&("function"==typeof t.copy&&"function"==typeof t.slice&&!(t.length>0&&"number"!=typeof t[0]))}function i(t,e,n){var i,c;if(r(t)||r(e))return!1;if(t.prototype!==e.prototype)return!1;if(s(t))return!!s(e)&&(t=l.call(t),e=l.call(e),u(t,e,n));if(o(t)){if(!o(e))return!1;if(t.length!==e.length)return!1;for(i=0;i<t.length;i++)if(t[i]!==e[i])return!1;return!0}try{var f=a(t),h=a(e)}catch(t){return!1}if(f.length!=h.length)return!1;for(f.sort(),h.sort(),i=f.length-1;i>=0;i--)if(f[i]!=h[i])return!1;for(i=f.length-1;i>=0;i--)if(c=f[i],!u(t[c],e[c],n))return!1;return typeof t==typeof e}var l=Array.prototype.slice,a=n(52),s=n(53),u=t.exports=function(t,e,n){return n||(n={}),t===e||(t instanceof Date&&e instanceof Date?t.getTime()===e.getTime():!t||!e||"object"!=typeof t&&"object"!=typeof e?n.strict?t===e:t==e:i(t,e,n))}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(1),o=function(){function t(t,e,n){void 0===n&&(n={}),this.attrName=t,this.keyName=e;var o=r.Scope.TYPE&r.Scope.ATTRIBUTE;null!=n.scope?this.scope=n.scope&r.Scope.LEVEL|o:this.scope=r.Scope.ATTRIBUTE,null!=n.whitelist&&(this.whitelist=n.whitelist)}return t.keys=function(t){return[].map.call(t.attributes,function(t){return t.name})},t.prototype.add=function(t,e){return!!this.canAdd(t,e)&&(t.setAttribute(this.keyName,e),!0)},t.prototype.canAdd=function(t,e){return null!=r.query(t,r.Scope.BLOT&(this.scope|r.Scope.TYPE))&&(null==this.whitelist||("string"==typeof e?this.whitelist.indexOf(e.replace(/["']/g,""))>-1:this.whitelist.indexOf(e)>-1))},t.prototype.remove=function(t){t.removeAttribute(this.keyName)},t.prototype.value=function(t){var e=t.getAttribute(this.keyName);return this.canAdd(t,e)&&e?e:""},t}();e.default=o},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function l(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=e.Code=void 0;var a=function(){function t(t,e){var n=[],r=!0,o=!1,i=void 0;try{for(var l,a=t[Symbol.iterator]();!(r=(l=a.next()).done)&&(n.push(l.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t}finally{try{!r&&a.return&&a.return()}finally{if(o)throw i}}return n}return function(e,n){if(Array.isArray(e))return e;if(Symbol.iterator in Object(e))return t(e,n);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),s=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),u=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},c=n(2),f=r(c),h=n(0),p=r(h),d=n(4),y=r(d),v=n(6),b=r(v),g=n(7),m=r(g),_=function(t){function e(){return o(this,e),i(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return l(e,t),e}(b.default);_.blotName="code",_.tagName="CODE";var O=function(t){function e(){return o(this,e),i(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return l(e,t),s(e,[{key:"delta",value:function(){var t=this,e=this.domNode.textContent;return e.endsWith("\n")&&(e=e.slice(0,-1)),e.split("\n").reduce(function(e,n){return e.insert(n).insert("\n",t.formats())},new f.default)}},{key:"format",value:function(t,n){if(t!==this.statics.blotName||!n){var r=this.descendant(m.default,this.length()-1),o=a(r,1),i=o[0];null!=i&&i.deleteAt(i.length()-1,1),u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"format",this).call(this,t,n)}}},{key:"formatAt",value:function(t,n,r,o){if(0!==n&&null!=p.default.query(r,p.default.Scope.BLOCK)&&(r!==this.statics.blotName||o!==this.statics.formats(this.domNode))){var i=this.newlineIndex(t);if(!(i<0||i>=t+n)){var l=this.newlineIndex(t,!0)+1,a=i-l+1,s=this.isolate(l,a),u=s.next;s.format(r,o),u instanceof e&&u.formatAt(0,t-l+n-a,r,o)}}}},{key:"insertAt",value:function(t,e,n){if(null==n){var r=this.descendant(m.default,t),o=a(r,2),i=o[0],l=o[1];i.insertAt(l,e)}}},{key:"length",value:function(){var t=this.domNode.textContent.length;return this.domNode.textContent.endsWith("\n")?t:t+1}},{key:"newlineIndex",value:function(t){if(arguments.length>1&&void 0!==arguments[1]&&arguments[1])return this.domNode.textContent.slice(0,t).lastIndexOf("\n");var e=this.domNode.textContent.slice(t).indexOf("\n");return e>-1?t+e:-1}},{key:"optimize",value:function(t){this.domNode.textContent.endsWith("\n")||this.appendChild(p.default.create("text","\n")),u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"optimize",this).call(this,t);var n=this.next;null!=n&&n.prev===this&&n.statics.blotName===this.statics.blotName&&this.statics.formats(this.domNode)===n.statics.formats(n.domNode)&&(n.optimize(t),n.moveChildren(this),n.remove())}},{key:"replace",value:function(t){u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"replace",this).call(this,t),[].slice.call(this.domNode.querySelectorAll("*")).forEach(function(t){var e=p.default.find(t);null==e?t.parentNode.removeChild(t):e instanceof p.default.Embed?e.remove():e.unwrap()})}}],[{key:"create",value:function(t){var n=u(e.__proto__||Object.getPrototypeOf(e),"create",this).call(this,t);return n.setAttribute("spellcheck",!1),n}},{key:"formats",value:function(){return!0}}]),e}(y.default);O.blotName="code-block",O.tagName="PRE",O.TAB="  ",e.Code=_,e.default=O},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function l(t,e){return Object.keys(e).reduce(function(n,r){return null==t[r]?n:(e[r]===t[r]?n[r]=e[r]:Array.isArray(e[r])?e[r].indexOf(t[r])<0&&(n[r]=e[r].concat([t[r]])):n[r]=[e[r],t[r]],n)},{})}function a(t){return t.reduce(function(t,e){if(1===e.insert){var n=(0,A.default)(e.attributes);return delete n.image,t.insert({image:e.attributes.image},n)}if(null==e.attributes||!0!==e.attributes.list&&!0!==e.attributes.bullet||(e=(0,A.default)(e),e.attributes.list?e.attributes.list="ordered":(e.attributes.list="bullet",delete e.attributes.bullet)),"string"==typeof e.insert){var r=e.insert.replace(/\r\n/g,"\n").replace(/\r/g,"\n");return t.insert(r,e.attributes)}return t.push(e)},new h.default)}Object.defineProperty(e,"__esModule",{value:!0});var s="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},u=function(){function t(t,e){var n=[],r=!0,o=!1,i=void 0;try{for(var l,a=t[Symbol.iterator]();!(r=(l=a.next()).done)&&(n.push(l.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t}finally{try{!r&&a.return&&a.return()}finally{if(o)throw i}}return n}return function(e,n){if(Array.isArray(e))return e;if(Symbol.iterator in Object(e))return t(e,n);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),c=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),f=n(2),h=r(f),p=n(20),d=r(p),y=n(0),v=r(y),b=n(13),g=r(b),m=n(24),_=r(m),O=n(4),w=r(O),x=n(16),E=r(x),k=n(21),A=r(k),j=n(11),N=r(j),T=n(3),S=r(T),P=/^[ -~]*$/,q=function(){function t(e){i(this,t),this.scroll=e,this.delta=this.getDelta()}return c(t,[{key:"applyDelta",value:function(t){var e=this,n=!1;this.scroll.update();var r=this.scroll.length();return this.scroll.batchStart(),t=a(t),t.reduce(function(t,o){var i=o.retain||o.delete||o.insert.length||1,l=o.attributes||{};if(null!=o.insert){if("string"==typeof o.insert){var a=o.insert;a.endsWith("\n")&&n&&(n=!1,a=a.slice(0,-1)),t>=r&&!a.endsWith("\n")&&(n=!0),e.scroll.insertAt(t,a);var c=e.scroll.line(t),f=u(c,2),h=f[0],p=f[1],y=(0,S.default)({},(0,O.bubbleFormats)(h));if(h instanceof w.default){var b=h.descendant(v.default.Leaf,p),g=u(b,1),m=g[0];y=(0,S.default)(y,(0,O.bubbleFormats)(m))}l=d.default.attributes.diff(y,l)||{}}else if("object"===s(o.insert)){var _=Object.keys(o.insert)[0];if(null==_)return t;e.scroll.insertAt(t,_,o.insert[_])}r+=i}return Object.keys(l).forEach(function(n){e.scroll.formatAt(t,i,n,l[n])}),t+i},0),t.reduce(function(t,n){return"number"==typeof n.delete?(e.scroll.deleteAt(t,n.delete),t):t+(n.retain||n.insert.length||1)},0),this.scroll.batchEnd(),this.update(t)}},{key:"deleteText",value:function(t,e){return this.scroll.deleteAt(t,e),this.update((new h.default).retain(t).delete(e))}},{key:"formatLine",value:function(t,e){var n=this,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};return this.scroll.update(),Object.keys(r).forEach(function(o){if(null==n.scroll.whitelist||n.scroll.whitelist[o]){var i=n.scroll.lines(t,Math.max(e,1)),l=e;i.forEach(function(e){var i=e.length();if(e instanceof g.default){var a=t-e.offset(n.scroll),s=e.newlineIndex(a+l)-a+1;e.formatAt(a,s,o,r[o])}else e.format(o,r[o]);l-=i})}}),this.scroll.optimize(),this.update((new h.default).retain(t).retain(e,(0,A.default)(r)))}},{key:"formatText",value:function(t,e){var n=this,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};return Object.keys(r).forEach(function(o){n.scroll.formatAt(t,e,o,r[o])}),this.update((new h.default).retain(t).retain(e,(0,A.default)(r)))}},{key:"getContents",value:function(t,e){return this.delta.slice(t,t+e)}},{key:"getDelta",value:function(){return this.scroll.lines().reduce(function(t,e){return t.concat(e.delta())},new h.default)}},{key:"getFormat",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,n=[],r=[];0===e?this.scroll.path(t).forEach(function(t){var e=u(t,1),o=e[0];o instanceof w.default?n.push(o):o instanceof v.default.Leaf&&r.push(o)}):(n=this.scroll.lines(t,e),r=this.scroll.descendants(v.default.Leaf,t,e));var o=[n,r].map(function(t){if(0===t.length)return{};for(var e=(0,O.bubbleFormats)(t.shift());Object.keys(e).length>0;){var n=t.shift();if(null==n)return e;e=l((0,O.bubbleFormats)(n),e)}return e});return S.default.apply(S.default,o)}},{key:"getText",value:function(t,e){return this.getContents(t,e).filter(function(t){return"string"==typeof t.insert}).map(function(t){return t.insert}).join("")}},{key:"insertEmbed",value:function(t,e,n){return this.scroll.insertAt(t,e,n),this.update((new h.default).retain(t).insert(o({},e,n)))}},{key:"insertText",value:function(t,e){var n=this,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};return e=e.replace(/\r\n/g,"\n").replace(/\r/g,"\n"),this.scroll.insertAt(t,e),Object.keys(r).forEach(function(o){n.scroll.formatAt(t,e.length,o,r[o])}),this.update((new h.default).retain(t).insert(e,(0,A.default)(r)))}},{key:"isBlank",value:function(){if(0==this.scroll.children.length)return!0;if(this.scroll.children.length>1)return!1;var t=this.scroll.children.head;return t.statics.blotName===w.default.blotName&&(!(t.children.length>1)&&t.children.head instanceof E.default)}},{key:"removeFormat",value:function(t,e){var n=this.getText(t,e),r=this.scroll.line(t+e),o=u(r,2),i=o[0],l=o[1],a=0,s=new h.default;null!=i&&(a=i instanceof g.default?i.newlineIndex(l)-l+1:i.length()-l,s=i.delta().slice(l,l+a-1).insert("\n"));var c=this.getContents(t,e+a),f=c.diff((new h.default).insert(n).concat(s)),p=(new h.default).retain(t).concat(f);return this.applyDelta(p)}},{key:"update",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:[],n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:void 0,r=this.delta;if(1===e.length&&"characterData"===e[0].type&&e[0].target.data.match(P)&&v.default.find(e[0].target)){var o=v.default.find(e[0].target),i=(0,O.bubbleFormats)(o),l=o.offset(this.scroll),a=e[0].oldValue.replace(_.default.CONTENTS,""),s=(new h.default).insert(a),u=(new h.default).insert(o.value());t=(new h.default).retain(l).concat(s.diff(u,n)).reduce(function(t,e){return e.insert?t.insert(e.insert,i):t.push(e)},new h.default),this.delta=r.compose(t)}else this.delta=this.getDelta(),t&&(0,N.default)(r.compose(t),this.delta)||(t=r.diff(this.delta,n));return t}}]),t}();e.default=q},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t){if(Array.isArray(t)){for(var e=0,n=Array(t.length);e<t.length;e++)n[e]=t[e];return n}return Array.from(t)}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function l(t,e){try{e.parentNode}catch(t){return!1}return e instanceof Text&&(e=e.parentNode),t.contains(e)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=e.Range=void 0;var a=function(){function t(t,e){var n=[],r=!0,o=!1,i=void 0;try{for(var l,a=t[Symbol.iterator]();!(r=(l=a.next()).done)&&(n.push(l.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t}finally{try{!r&&a.return&&a.return()}finally{if(o)throw i}}return n}return function(e,n){if(Array.isArray(e))return e;if(Symbol.iterator in Object(e))return t(e,n);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),s=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),u=n(0),c=r(u),f=n(21),h=r(f),p=n(11),d=r(p),y=n(8),v=r(y),b=n(10),g=r(b),m=(0,g.default)("quill:selection"),_=function t(e){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;i(this,t),this.index=e,this.length=n},O=function(){function t(e,n){var r=this;i(this,t),this.emitter=n,this.scroll=e,this.composing=!1,this.mouseDown=!1,this.root=this.scroll.domNode,this.cursor=c.default.create("cursor",this),this.lastRange=this.savedRange=new _(0,0),this.handleComposition(),this.handleDragging(),this.emitter.listenDOM("selectionchange",document,function(){r.mouseDown||setTimeout(r.update.bind(r,v.default.sources.USER),1)}),this.emitter.on(v.default.events.EDITOR_CHANGE,function(t,e){t===v.default.events.TEXT_CHANGE&&e.length()>0&&r.update(v.default.sources.SILENT)}),this.emitter.on(v.default.events.SCROLL_BEFORE_UPDATE,function(){if(r.hasFocus()){var t=r.getNativeRange();null!=t&&t.start.node!==r.cursor.textNode&&r.emitter.once(v.default.events.SCROLL_UPDATE,function(){try{r.setNativeRange(t.start.node,t.start.offset,t.end.node,t.end.offset)}catch(t){}})}}),this.emitter.on(v.default.events.SCROLL_OPTIMIZE,function(t,e){if(e.range){var n=e.range,o=n.startNode,i=n.startOffset,l=n.endNode,a=n.endOffset;r.setNativeRange(o,i,l,a)}}),this.update(v.default.sources.SILENT)}return s(t,[{key:"handleComposition",value:function(){var t=this;this.root.addEventListener("compositionstart",function(){t.composing=!0}),this.root.addEventListener("compositionend",function(){if(t.composing=!1,t.cursor.parent){var e=t.cursor.restore();if(!e)return;setTimeout(function(){t.setNativeRange(e.startNode,e.startOffset,e.endNode,e.endOffset)},1)}})}},{key:"handleDragging",value:function(){var t=this;this.emitter.listenDOM("mousedown",document.body,function(){t.mouseDown=!0}),this.emitter.listenDOM("mouseup",document.body,function(){t.mouseDown=!1,t.update(v.default.sources.USER)})}},{key:"focus",value:function(){this.hasFocus()||(this.root.focus(),this.setRange(this.savedRange))}},{key:"format",value:function(t,e){if(null==this.scroll.whitelist||this.scroll.whitelist[t]){this.scroll.update();var n=this.getNativeRange();if(null!=n&&n.native.collapsed&&!c.default.query(t,c.default.Scope.BLOCK)){if(n.start.node!==this.cursor.textNode){var r=c.default.find(n.start.node,!1);if(null==r)return;if(r instanceof c.default.Leaf){var o=r.split(n.start.offset);r.parent.insertBefore(this.cursor,o)}else r.insertBefore(this.cursor,n.start.node);this.cursor.attach()}this.cursor.format(t,e),this.scroll.optimize(),this.setNativeRange(this.cursor.textNode,this.cursor.textNode.data.length),this.update()}}}},{key:"getBounds",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,n=this.scroll.length();t=Math.min(t,n-1),e=Math.min(t+e,n-1)-t;var r=void 0,o=this.scroll.leaf(t),i=a(o,2),l=i[0],s=i[1];if(null==l)return null;var u=l.position(s,!0),c=a(u,2);r=c[0],s=c[1];var f=document.createRange();if(e>0){f.setStart(r,s);var h=this.scroll.leaf(t+e),p=a(h,2);if(l=p[0],s=p[1],null==l)return null;var d=l.position(s,!0),y=a(d,2);return r=y[0],s=y[1],f.setEnd(r,s),f.getBoundingClientRect()}var v="left",b=void 0;return r instanceof Text?(s<r.data.length?(f.setStart(r,s),f.setEnd(r,s+1)):(f.setStart(r,s-1),f.setEnd(r,s),v="right"),b=f.getBoundingClientRect()):(b=l.domNode.getBoundingClientRect(),s>0&&(v="right")),{bottom:b.top+b.height,height:b.height,left:b[v],right:b[v],top:b.top,width:0}}},{key:"getNativeRange",value:function(){var t=document.getSelection();if(null==t||t.rangeCount<=0)return null;var e=t.getRangeAt(0);if(null==e)return null;var n=this.normalizeNative(e);return m.info("getNativeRange",n),n}},{key:"getRange",value:function(){var t=this.getNativeRange();return null==t?[null,null]:[this.normalizedToRange(t),t]}},{key:"hasFocus",value:function(){return document.activeElement===this.root}},{key:"normalizedToRange",value:function(t){var e=this,n=[[t.start.node,t.start.offset]];t.native.collapsed||n.push([t.end.node,t.end.offset]);var r=n.map(function(t){var n=a(t,2),r=n[0],o=n[1],i=c.default.find(r,!0),l=i.offset(e.scroll);return 0===o?l:i instanceof c.default.Container?l+i.length():l+i.index(r,o)}),i=Math.min(Math.max.apply(Math,o(r)),this.scroll.length()-1),l=Math.min.apply(Math,[i].concat(o(r)));return new _(l,i-l)}},{key:"normalizeNative",value:function(t){if(!l(this.root,t.startContainer)||!t.collapsed&&!l(this.root,t.endContainer))return null;var e={start:{node:t.startContainer,offset:t.startOffset},end:{node:t.endContainer,offset:t.endOffset},native:t};return[e.start,e.end].forEach(function(t){for(var e=t.node,n=t.offset;!(e instanceof Text)&&e.childNodes.length>0;)if(e.childNodes.length>n)e=e.childNodes[n],n=0;else{if(e.childNodes.length!==n)break;e=e.lastChild,n=e instanceof Text?e.data.length:e.childNodes.length+1}t.node=e,t.offset=n}),e}},{key:"rangeToNative",value:function(t){var e=this,n=t.collapsed?[t.index]:[t.index,t.index+t.length],r=[],o=this.scroll.length();return n.forEach(function(t,n){t=Math.min(o-1,t);var i=void 0,l=e.scroll.leaf(t),s=a(l,2),u=s[0],c=s[1],f=u.position(c,0!==n),h=a(f,2);i=h[0],c=h[1],r.push(i,c)}),r.length<2&&(r=r.concat(r)),r}},{key:"scrollIntoView",value:function(t){var e=this.lastRange;if(null!=e){var n=this.getBounds(e.index,e.length);if(null!=n){var r=this.scroll.length()-1,o=this.scroll.line(Math.min(e.index,r)),i=a(o,1),l=i[0],s=l;if(e.length>0){var u=this.scroll.line(Math.min(e.index+e.length,r));s=a(u,1)[0]}if(null!=l&&null!=s){var c=t.getBoundingClientRect();n.top<c.top?t.scrollTop-=c.top-n.top:n.bottom>c.bottom&&(t.scrollTop+=n.bottom-c.bottom)}}}}},{key:"setNativeRange",value:function(t,e){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:t,r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:e,o=arguments.length>4&&void 0!==arguments[4]&&arguments[4];if(m.info("setNativeRange",t,e,n,r),null==t||null!=this.root.parentNode&&null!=t.parentNode&&null!=n.parentNode){var i=document.getSelection();if(null!=i)if(null!=t){this.hasFocus()||this.root.focus();var l=(this.getNativeRange()||{}).native;if(null==l||o||t!==l.startContainer||e!==l.startOffset||n!==l.endContainer||r!==l.endOffset){"BR"==t.tagName&&(e=[].indexOf.call(t.parentNode.childNodes,t),t=t.parentNode),"BR"==n.tagName&&(r=[].indexOf.call(n.parentNode.childNodes,n),n=n.parentNode);var a=document.createRange();a.setStart(t,e),a.setEnd(n,r),i.removeAllRanges(),i.addRange(a)}}else i.removeAllRanges(),this.root.blur(),document.body.focus()}}},{key:"setRange",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:v.default.sources.API;if("string"==typeof e&&(n=e,e=!1),m.info("setRange",t),null!=t){var r=this.rangeToNative(t);this.setNativeRange.apply(this,o(r).concat([e]))}else this.setNativeRange(null);this.update(n)}},{key:"update",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:v.default.sources.USER,e=this.lastRange,n=this.getRange(),r=a(n,2),o=r[0],i=r[1];if(this.lastRange=o,null!=this.lastRange&&(this.savedRange=this.lastRange),!(0,d.default)(e,this.lastRange)){var l;!this.composing&&null!=i&&i.native.collapsed&&i.start.node!==this.cursor.textNode&&this.cursor.restore();var s=[v.default.events.SELECTION_CHANGE,(0,h.default)(this.lastRange),(0,h.default)(e),t];if((l=this.emitter).emit.apply(l,[v.default.events.EDITOR_CHANGE].concat(s)),t!==v.default.sources.SILENT){var u;(u=this.emitter).emit.apply(u,s)}}}}]),t}();e.Range=_,e.default=O},function(t,e,n){"use strict";function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function i(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var l=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),a=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},s=n(0),u=function(t){return t&&t.__esModule?t:{default:t}}(s),c=function(t){function e(){return r(this,e),o(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return i(e,t),l(e,[{key:"insertInto",value:function(t,n){0===t.children.length?a(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"insertInto",this).call(this,t,n):this.remove()}},{key:"length",value:function(){return 0}},{key:"value",value:function(){return""}}],[{key:"value",value:function(){}}]),e}(u.default.Embed);c.blotName="break",c.tagName="BR",e.default=c},function(t,e,n){"use strict";function r(t){var e=a.find(t);if(null==e)try{e=a.create(t)}catch(n){e=a.create(a.Scope.INLINE),[].slice.call(t.childNodes).forEach(function(t){e.domNode.appendChild(t)}),t.parentNode&&t.parentNode.replaceChild(e.domNode,t),e.attach()}return e}var o=this&&this.__extends||function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])};return function(e,n){function r(){this.constructor=e}t(e,n),e.prototype=null===n?Object.create(n):(r.prototype=n.prototype,new r)}}();Object.defineProperty(e,"__esModule",{value:!0});var i=n(44),l=n(30),a=n(1),s=function(t){function e(e){var n=t.call(this,e)||this;return n.build(),n}return o(e,t),e.prototype.appendChild=function(t){this.insertBefore(t)},e.prototype.attach=function(){t.prototype.attach.call(this),this.children.forEach(function(t){t.attach()})},e.prototype.build=function(){var t=this;this.children=new i.default,[].slice.call(this.domNode.childNodes).reverse().forEach(function(e){try{var n=r(e);t.insertBefore(n,t.children.head||void 0)}catch(t){if(t instanceof a.ParchmentError)return;throw t}})},e.prototype.deleteAt=function(t,e){if(0===t&&e===this.length())return this.remove();this.children.forEachAt(t,e,function(t,e,n){t.deleteAt(e,n)})},e.prototype.descendant=function(t,n){var r=this.children.find(n),o=r[0],i=r[1];return null==t.blotName&&t(o)||null!=t.blotName&&o instanceof t?[o,i]:o instanceof e?o.descendant(t,i):[null,-1]},e.prototype.descendants=function(t,n,r){void 0===n&&(n=0),void 0===r&&(r=Number.MAX_VALUE);var o=[],i=r;return this.children.forEachAt(n,r,function(n,r,l){(null==t.blotName&&t(n)||null!=t.blotName&&n instanceof t)&&o.push(n),n instanceof e&&(o=o.concat(n.descendants(t,r,i))),i-=l}),o},e.prototype.detach=function(){this.children.forEach(function(t){t.detach()}),t.prototype.detach.call(this)},e.prototype.formatAt=function(t,e,n,r){this.children.forEachAt(t,e,function(t,e,o){t.formatAt(e,o,n,r)})},e.prototype.insertAt=function(t,e,n){var r=this.children.find(t),o=r[0],i=r[1];if(o)o.insertAt(i,e,n);else{var l=null==n?a.create("text",e):a.create(e,n);this.appendChild(l)}},e.prototype.insertBefore=function(t,e){if(null!=this.statics.allowedChildren&&!this.statics.allowedChildren.some(function(e){return t instanceof e}))throw new a.ParchmentError("Cannot insert "+t.statics.blotName+" into "+this.statics.blotName);t.insertInto(this,e)},e.prototype.length=function(){return this.children.reduce(function(t,e){return t+e.length()},0)},e.prototype.moveChildren=function(t,e){this.children.forEach(function(n){t.insertBefore(n,e)})},e.prototype.optimize=function(e){if(t.prototype.optimize.call(this,e),0===this.children.length)if(null!=this.statics.defaultChild){var n=a.create(this.statics.defaultChild);this.appendChild(n),n.optimize(e)}else this.remove()},e.prototype.path=function(t,n){void 0===n&&(n=!1);var r=this.children.find(t,n),o=r[0],i=r[1],l=[[this,t]];return o instanceof e?l.concat(o.path(i,n)):(null!=o&&l.push([o,i]),l)},e.prototype.removeChild=function(t){this.children.remove(t)},e.prototype.replace=function(n){n instanceof e&&n.moveChildren(this),t.prototype.replace.call(this,n)},e.prototype.split=function(t,e){if(void 0===e&&(e=!1),!e){if(0===t)return this;if(t===this.length())return this.next}var n=this.clone();return this.parent.insertBefore(n,this.next),this.children.forEachAt(t,this.length(),function(t,r,o){t=t.split(r,e),n.appendChild(t)}),n},e.prototype.unwrap=function(){this.moveChildren(this.parent,this.next),this.remove()},e.prototype.update=function(t,e){var n=this,o=[],i=[];t.forEach(function(t){t.target===n.domNode&&"childList"===t.type&&(o.push.apply(o,t.addedNodes),i.push.apply(i,t.removedNodes))}),i.forEach(function(t){if(!(null!=t.parentNode&&"IFRAME"!==t.tagName&&document.body.compareDocumentPosition(t)&Node.DOCUMENT_POSITION_CONTAINED_BY)){var e=a.find(t);null!=e&&(null!=e.domNode.parentNode&&e.domNode.parentNode!==n.domNode||e.detach())}}),o.filter(function(t){return t.parentNode==n.domNode}).sort(function(t,e){return t===e?0:t.compareDocumentPosition(e)&Node.DOCUMENT_POSITION_FOLLOWING?1:-1}).forEach(function(t){var e=null;null!=t.nextSibling&&(e=a.find(t.nextSibling));var o=r(t);o.next==e&&null!=o.next||(null!=o.parent&&o.parent.removeChild(n),n.insertBefore(o,e||void 0))})},e}(l.default);e.default=s},function(t,e,n){"use strict";var r=this&&this.__extends||function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])};return function(e,n){function r(){this.constructor=e}t(e,n),e.prototype=null===n?Object.create(n):(r.prototype=n.prototype,new r)}}();Object.defineProperty(e,"__esModule",{value:!0});var o=n(12),i=n(31),l=n(17),a=n(1),s=function(t){function e(e){var n=t.call(this,e)||this;return n.attributes=new i.default(n.domNode),n}return r(e,t),e.formats=function(t){return"string"==typeof this.tagName||(Array.isArray(this.tagName)?t.tagName.toLowerCase():void 0)},e.prototype.format=function(t,e){var n=a.query(t);n instanceof o.default?this.attributes.attribute(n,e):e&&(null==n||t===this.statics.blotName&&this.formats()[t]===e||this.replaceWith(t,e))},e.prototype.formats=function(){var t=this.attributes.values(),e=this.statics.formats(this.domNode);return null!=e&&(t[this.statics.blotName]=e),t},e.prototype.replaceWith=function(e,n){var r=t.prototype.replaceWith.call(this,e,n);return this.attributes.copy(r),r},e.prototype.update=function(e,n){var r=this;t.prototype.update.call(this,e,n),e.some(function(t){return t.target===r.domNode&&"attributes"===t.type})&&this.attributes.build()},e.prototype.wrap=function(n,r){var o=t.prototype.wrap.call(this,n,r);return o instanceof e&&o.statics.scope===this.statics.scope&&this.attributes.move(o),o},e}(l.default);e.default=s},function(t,e,n){"use strict";var r=this&&this.__extends||function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])};return function(e,n){function r(){this.constructor=e}t(e,n),e.prototype=null===n?Object.create(n):(r.prototype=n.prototype,new r)}}();Object.defineProperty(e,"__esModule",{value:!0});var o=n(30),i=n(1),l=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return r(e,t),e.value=function(t){return!0},e.prototype.index=function(t,e){return this.domNode===t||this.domNode.compareDocumentPosition(t)&Node.DOCUMENT_POSITION_CONTAINED_BY?Math.min(e,1):-1},e.prototype.position=function(t,e){var n=[].indexOf.call(this.parent.domNode.childNodes,this.domNode);return t>0&&(n+=1),[this.parent.domNode,n]},e.prototype.value=function(){return t={},t[this.statics.blotName]=this.statics.value(this.domNode)||!0,t;var t},e.scope=i.Scope.INLINE_BLOT,e}(o.default);e.default=l},function(t,e,n){function r(t){this.ops=t,this.index=0,this.offset=0}var o=n(11),i=n(3),l={attributes:{compose:function(t,e,n){"object"!=typeof t&&(t={}),"object"!=typeof e&&(e={});var r=i(!0,{},e);n||(r=Object.keys(r).reduce(function(t,e){return null!=r[e]&&(t[e]=r[e]),t},{}));for(var o in t)void 0!==t[o]&&void 0===e[o]&&(r[o]=t[o]);return Object.keys(r).length>0?r:void 0},diff:function(t,e){"object"!=typeof t&&(t={}),"object"!=typeof e&&(e={});var n=Object.keys(t).concat(Object.keys(e)).reduce(function(n,r){return o(t[r],e[r])||(n[r]=void 0===e[r]?null:e[r]),n},{});return Object.keys(n).length>0?n:void 0},transform:function(t,e,n){if("object"!=typeof t)return e;if("object"==typeof e){if(!n)return e;var r=Object.keys(e).reduce(function(n,r){return void 0===t[r]&&(n[r]=e[r]),n},{});return Object.keys(r).length>0?r:void 0}}},iterator:function(t){return new r(t)},length:function(t){return"number"==typeof t.delete?t.delete:"number"==typeof t.retain?t.retain:"string"==typeof t.insert?t.insert.length:1}};r.prototype.hasNext=function(){return this.peekLength()<1/0},r.prototype.next=function(t){t||(t=1/0);var e=this.ops[this.index];if(e){var n=this.offset,r=l.length(e);if(t>=r-n?(t=r-n,this.index+=1,this.offset=0):this.offset+=t,"number"==typeof e.delete)return{delete:t};var o={};return e.attributes&&(o.attributes=e.attributes),"number"==typeof e.retain?o.retain=t:"string"==typeof e.insert?o.insert=e.insert.substr(n,t):o.insert=e.insert,o}return{retain:1/0}},r.prototype.peek=function(){return this.ops[this.index]},r.prototype.peekLength=function(){return this.ops[this.index]?l.length(this.ops[this.index])-this.offset:1/0},r.prototype.peekType=function(){return this.ops[this.index]?"number"==typeof this.ops[this.index].delete?"delete":"number"==typeof this.ops[this.index].retain?"retain":"insert":"retain"},t.exports=l},function(t,n){var r=function(){"use strict";function t(t,e){return null!=e&&t instanceof e}function n(r,o,i,l,f){function h(r,i){if(null===r)return null;if(0===i)return r;var v,b;if("object"!=typeof r)return r;if(t(r,s))v=new s;else if(t(r,u))v=new u;else if(t(r,c))v=new c(function(t,e){r.then(function(e){t(h(e,i-1))},function(t){e(h(t,i-1))})});else if(n.__isArray(r))v=[];else if(n.__isRegExp(r))v=new RegExp(r.source,a(r)),r.lastIndex&&(v.lastIndex=r.lastIndex);else if(n.__isDate(r))v=new Date(r.getTime());else{if(y&&e.isBuffer(r))return v=new e(r.length),r.copy(v),v;t(r,Error)?v=Object.create(r):void 0===l?(b=Object.getPrototypeOf(r),v=Object.create(b)):(v=Object.create(l),b=l)}if(o){var g=p.indexOf(r);if(-1!=g)return d[g];p.push(r),d.push(v)}t(r,s)&&r.forEach(function(t,e){var n=h(e,i-1),r=h(t,i-1);v.set(n,r)}),t(r,u)&&r.forEach(function(t){var e=h(t,i-1);v.add(e)});for(var m in r){var _;b&&(_=Object.getOwnPropertyDescriptor(b,m)),_&&null==_.set||(v[m]=h(r[m],i-1))}if(Object.getOwnPropertySymbols)for(var O=Object.getOwnPropertySymbols(r),m=0;m<O.length;m++){var w=O[m],x=Object.getOwnPropertyDescriptor(r,w);(!x||x.enumerable||f)&&(v[w]=h(r[w],i-1),x.enumerable||Object.defineProperty(v,w,{enumerable:!1}))}if(f)for(var E=Object.getOwnPropertyNames(r),m=0;m<E.length;m++){var k=E[m],x=Object.getOwnPropertyDescriptor(r,k);x&&x.enumerable||(v[k]=h(r[k],i-1),Object.defineProperty(v,k,{enumerable:!1}))}return v}"object"==typeof o&&(i=o.depth,l=o.prototype,f=o.includeNonEnumerable,o=o.circular);var p=[],d=[],y=void 0!==e;return void 0===o&&(o=!0),void 0===i&&(i=1/0),h(r,i)}function r(t){return Object.prototype.toString.call(t)}function o(t){return"object"==typeof t&&"[object Date]"===r(t)}function i(t){return"object"==typeof t&&"[object Array]"===r(t)}function l(t){return"object"==typeof t&&"[object RegExp]"===r(t)}function a(t){var e="";return t.global&&(e+="g"),t.ignoreCase&&(e+="i"),t.multiline&&(e+="m"),e}var s;try{s=Map}catch(t){s=function(){}}var u;try{u=Set}catch(t){u=function(){}}var c;try{c=Promise}catch(t){c=function(){}}return n.clonePrototype=function(t){if(null===t)return null;var e=function(){};return e.prototype=t,new e},n.__objToStr=r,n.__isDate=o,n.__isArray=i,n.__isRegExp=l,n.__getRegExpFlags=a,n}();"object"==typeof t&&t.exports&&(t.exports=r)},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function l(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}function a(t){return t instanceof v.default||t instanceof y.BlockEmbed}Object.defineProperty(e,"__esModule",{value:!0});var s=function(){function t(t,e){var n=[],r=!0,o=!1,i=void 0;try{for(var l,a=t[Symbol.iterator]();!(r=(l=a.next()).done)&&(n.push(l.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t}finally{try{!r&&a.return&&a.return()}finally{if(o)throw i}}return n}return function(e,n){if(Array.isArray(e))return e;if(Symbol.iterator in Object(e))return t(e,n);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),u=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),c=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},f=n(0),h=r(f),p=n(8),d=r(p),y=n(4),v=r(y),b=n(16),g=r(b),m=n(13),_=r(m),O=n(25),w=r(O),x=function(t){function e(t,n){o(this,e);var r=i(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t));return r.emitter=n.emitter,Array.isArray(n.whitelist)&&(r.whitelist=n.whitelist.reduce(function(t,e){return t[e]=!0,t},{})),r.domNode.addEventListener("DOMNodeInserted",function(){}),r.optimize(),r.enable(),r}return l(e,t),u(e,[{key:"batchStart",value:function(){this.batch=!0}},{key:"batchEnd",value:function(){this.batch=!1,this.optimize()}},{key:"deleteAt",value:function(t,n){var r=this.line(t),o=s(r,2),i=o[0],l=o[1],a=this.line(t+n),u=s(a,1),f=u[0];if(c(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"deleteAt",this).call(this,t,n),null!=f&&i!==f&&l>0){if(i instanceof y.BlockEmbed||f instanceof y.BlockEmbed)return void this.optimize();if(i instanceof _.default){var h=i.newlineIndex(i.length(),!0);if(h>-1&&(i=i.split(h+1))===f)return void this.optimize()}else if(f instanceof _.default){var p=f.newlineIndex(0);p>-1&&f.split(p+1)}var d=f.children.head instanceof g.default?null:f.children.head;i.moveChildren(f,d),i.remove()}this.optimize()}},{key:"enable",value:function(){var t=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];this.domNode.setAttribute("contenteditable",t)}},{key:"formatAt",value:function(t,n,r,o){(null==this.whitelist||this.whitelist[r])&&(c(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"formatAt",this).call(this,t,n,r,o),this.optimize())}},{key:"insertAt",value:function(t,n,r){if(null==r||null==this.whitelist||this.whitelist[n]){if(t>=this.length())if(null==r||null==h.default.query(n,h.default.Scope.BLOCK)){var o=h.default.create(this.statics.defaultChild);this.appendChild(o),null==r&&n.endsWith("\n")&&(n=n.slice(0,-1)),o.insertAt(0,n,r)}else{var i=h.default.create(n,r);this.appendChild(i)}else c(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"insertAt",this).call(this,t,n,r);this.optimize()}}},{key:"insertBefore",value:function(t,n){if(t.statics.scope===h.default.Scope.INLINE_BLOT){var r=h.default.create(this.statics.defaultChild);r.appendChild(t),t=r}c(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"insertBefore",this).call(this,t,n)}},{key:"leaf",value:function(t){return this.path(t).pop()||[null,-1]}},{key:"line",value:function(t){return t===this.length()?this.line(t-1):this.descendant(a,t)}},{key:"lines",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:Number.MAX_VALUE;return function t(e,n,r){var o=[],i=r;return e.children.forEachAt(n,r,function(e,n,r){a(e)?o.push(e):e instanceof h.default.Container&&(o=o.concat(t(e,n,i))),i-=r}),o}(this,t,e)}},{key:"optimize",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};!0!==this.batch&&(c(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"optimize",this).call(this,t,n),t.length>0&&this.emitter.emit(d.default.events.SCROLL_OPTIMIZE,t,n))}},{key:"path",value:function(t){return c(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"path",this).call(this,t).slice(1)}},{key:"update",value:function(t){if(!0!==this.batch){var n=d.default.sources.USER;"string"==typeof t&&(n=t),Array.isArray(t)||(t=this.observer.takeRecords()),t.length>0&&this.emitter.emit(d.default.events.SCROLL_BEFORE_UPDATE,n,t),c(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"update",this).call(this,t.concat([])),t.length>0&&this.emitter.emit(d.default.events.SCROLL_UPDATE,n,t)}}}]),e}(h.default.Scroll);x.blotName="scroll",x.className="ql-editor",x.tagName="DIV",x.defaultChild="block",x.allowedChildren=[v.default,y.BlockEmbed,w.default],e.default=x},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function l(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function a(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}function s(t,e){var n,r=t===D.keys.LEFT?"prefix":"suffix";return n={key:t,shiftKey:e,altKey:null},o(n,r,/^$/),o(n,"handler",function(n){var r=n.index;t===D.keys.RIGHT&&(r+=n.length+1);var o=this.quill.getLeaf(r);return!(b(o,1)[0]instanceof S.default.Embed)||(t===D.keys.LEFT?e?this.quill.setSelection(n.index-1,n.length+1,q.default.sources.USER):this.quill.setSelection(n.index-1,q.default.sources.USER):e?this.quill.setSelection(n.index,n.length+1,q.default.sources.USER):this.quill.setSelection(n.index+n.length+1,q.default.sources.USER),!1)}),n}function u(t,e){if(!(0===t.index||this.quill.getLength()<=1)){var n=this.quill.getLine(t.index),r=b(n,1),o=r[0],i={};if(0===e.offset){var l=this.quill.getLine(t.index-1),a=b(l,1),s=a[0];if(null!=s&&s.length()>1){var u=o.formats(),c=this.quill.getFormat(t.index-1,1);i=N.default.attributes.diff(u,c)||{}}}var f=/[\uD800-\uDBFF][\uDC00-\uDFFF]$/.test(e.prefix)?2:1;this.quill.deleteText(t.index-f,f,q.default.sources.USER),Object.keys(i).length>0&&this.quill.formatLine(t.index-f,f,i,q.default.sources.USER),this.quill.focus()}}function c(t,e){var n=/^[\uD800-\uDBFF][\uDC00-\uDFFF]/.test(e.suffix)?2:1;if(!(t.index>=this.quill.getLength()-n)){var r={},o=0,i=this.quill.getLine(t.index),l=b(i,1),a=l[0];if(e.offset>=a.length()-1){var s=this.quill.getLine(t.index+1),u=b(s,1),c=u[0];if(c){var f=a.formats(),h=this.quill.getFormat(t.index,1);r=N.default.attributes.diff(f,h)||{},o=c.length()}}this.quill.deleteText(t.index,n,q.default.sources.USER),Object.keys(r).length>0&&this.quill.formatLine(t.index+o-1,n,r,q.default.sources.USER)}}function f(t){var e=this.quill.getLines(t),n={};if(e.length>1){var r=e[0].formats(),o=e[e.length-1].formats();n=N.default.attributes.diff(o,r)||{}}this.quill.deleteText(t,q.default.sources.USER),Object.keys(n).length>0&&this.quill.formatLine(t.index,1,n,q.default.sources.USER),this.quill.setSelection(t.index,q.default.sources.SILENT),this.quill.focus()}function h(t,e){var n=this;t.length>0&&this.quill.scroll.deleteAt(t.index,t.length);var r=Object.keys(e.format).reduce(function(t,n){return S.default.query(n,S.default.Scope.BLOCK)&&!Array.isArray(e.format[n])&&(t[n]=e.format[n]),t},{});this.quill.insertText(t.index,"\n",r,q.default.sources.USER),this.quill.setSelection(t.index+1,q.default.sources.SILENT),this.quill.focus(),Object.keys(e.format).forEach(function(t){null==r[t]&&(Array.isArray(e.format[t])||"link"!==t&&n.quill.format(t,e.format[t],q.default.sources.USER))})}function p(t){return{key:D.keys.TAB,shiftKey:!t,format:{"code-block":!0},handler:function(e){var n=S.default.query("code-block"),r=e.index,o=e.length,i=this.quill.scroll.descendant(n,r),l=b(i,2),a=l[0],s=l[1];if(null!=a){var u=this.quill.getIndex(a),c=a.newlineIndex(s,!0)+1,f=a.newlineIndex(u+s+o),h=a.domNode.textContent.slice(c,f).split("\n");s=0,h.forEach(function(e,i){t?(a.insertAt(c+s,n.TAB),s+=n.TAB.length,0===i?r+=n.TAB.length:o+=n.TAB.length):e.startsWith(n.TAB)&&(a.deleteAt(c+s,n.TAB.length),s-=n.TAB.length,0===i?r-=n.TAB.length:o-=n.TAB.length),s+=e.length+1}),this.quill.update(q.default.sources.USER),this.quill.setSelection(r,o,q.default.sources.SILENT)}}}}function d(t){return{key:t[0].toUpperCase(),shortKey:!0,handler:function(e,n){this.quill.format(t,!n.format[t],q.default.sources.USER)}}}function y(t){if("string"==typeof t||"number"==typeof t)return y({key:t});if("object"===(void 0===t?"undefined":v(t))&&(t=(0,_.default)(t,!1)),"string"==typeof t.key)if(null!=D.keys[t.key.toUpperCase()])t.key=D.keys[t.key.toUpperCase()];else{if(1!==t.key.length)return null;t.key=t.key.toUpperCase().charCodeAt(0)}return t.shortKey&&(t[I]=t.shortKey,delete t.shortKey),t}Object.defineProperty(e,"__esModule",{value:!0}),e.SHORTKEY=e.default=void 0;var v="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},b=function(){function t(t,e){var n=[],r=!0,o=!1,i=void 0;try{for(var l,a=t[Symbol.iterator]();!(r=(l=a.next()).done)&&(n.push(l.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t}finally{try{!r&&a.return&&a.return()}finally{if(o)throw i}}return n}return function(e,n){if(Array.isArray(e))return e;if(Symbol.iterator in Object(e))return t(e,n);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),g=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),m=n(21),_=r(m),O=n(11),w=r(O),x=n(3),E=r(x),k=n(2),A=r(k),j=n(20),N=r(j),T=n(0),S=r(T),P=n(5),q=r(P),C=n(10),L=r(C),R=n(9),M=r(R),B=(0,L.default)("quill:keyboard"),I=/Mac/i.test(navigator.platform)?"metaKey":"ctrlKey",D=function(t){function e(t,n){i(this,e);var r=l(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));return r.bindings={},Object.keys(r.options.bindings).forEach(function(e){("list autofill"!==e||null==t.scroll.whitelist||t.scroll.whitelist.list)&&r.options.bindings[e]&&r.addBinding(r.options.bindings[e])}),r.addBinding({key:e.keys.ENTER,shiftKey:null},h),r.addBinding({key:e.keys.ENTER,metaKey:null,ctrlKey:null,altKey:null},function(){}),/Firefox/i.test(navigator.userAgent)?(r.addBinding({key:e.keys.BACKSPACE},{collapsed:!0},u),r.addBinding({key:e.keys.DELETE},{collapsed:!0},c)):(r.addBinding({key:e.keys.BACKSPACE},{collapsed:!0,prefix:/^.?$/},u),r.addBinding({key:e.keys.DELETE},{collapsed:!0,suffix:/^.?$/},c)),r.addBinding({key:e.keys.BACKSPACE},{collapsed:!1},f),r.addBinding({key:e.keys.DELETE},{collapsed:!1},f),r.addBinding({key:e.keys.BACKSPACE,altKey:null,ctrlKey:null,metaKey:null,shiftKey:null},{collapsed:!0,offset:0},u),r.listen(),r}return a(e,t),g(e,null,[{key:"match",value:function(t,e){return e=y(e),!["altKey","ctrlKey","metaKey","shiftKey"].some(function(n){return!!e[n]!==t[n]&&null!==e[n]})&&e.key===(t.which||t.keyCode)}}]),g(e,[{key:"addBinding",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},r=y(t);if(null==r||null==r.key)return B.warn("Attempted to add invalid keyboard binding",r);"function"==typeof e&&(e={handler:e}),"function"==typeof n&&(n={handler:n}),r=(0,E.default)(r,e,n),this.bindings[r.key]=this.bindings[r.key]||[],this.bindings[r.key].push(r)}},{key:"listen",value:function(){var t=this;this.quill.root.addEventListener("keydown",function(n){if(!n.defaultPrevented){var r=n.which||n.keyCode,o=(t.bindings[r]||[]).filter(function(t){return e.match(n,t)});if(0!==o.length){var i=t.quill.getSelection();if(null!=i&&t.quill.hasFocus()){var l=t.quill.getLine(i.index),a=b(l,2),s=a[0],u=a[1],c=t.quill.getLeaf(i.index),f=b(c,2),h=f[0],p=f[1],d=0===i.length?[h,p]:t.quill.getLeaf(i.index+i.length),y=b(d,2),g=y[0],m=y[1],_=h instanceof S.default.Text?h.value().slice(0,p):"",O=g instanceof S.default.Text?g.value().slice(m):"",x={collapsed:0===i.length,empty:0===i.length&&s.length()<=1,format:t.quill.getFormat(i),offset:u,prefix:_,suffix:O};o.some(function(e){if(null!=e.collapsed&&e.collapsed!==x.collapsed)return!1;if(null!=e.empty&&e.empty!==x.empty)return!1;if(null!=e.offset&&e.offset!==x.offset)return!1;if(Array.isArray(e.format)){if(e.format.every(function(t){return null==x.format[t]}))return!1}else if("object"===v(e.format)&&!Object.keys(e.format).every(function(t){return!0===e.format[t]?null!=x.format[t]:!1===e.format[t]?null==x.format[t]:(0,w.default)(e.format[t],x.format[t])}))return!1;return!(null!=e.prefix&&!e.prefix.test(x.prefix))&&(!(null!=e.suffix&&!e.suffix.test(x.suffix))&&!0!==e.handler.call(t,i,x))})&&n.preventDefault()}}}})}}]),e}(M.default);D.keys={BACKSPACE:8,TAB:9,ENTER:13,ESCAPE:27,LEFT:37,UP:38,RIGHT:39,DOWN:40,DELETE:46},D.DEFAULTS={bindings:{bold:d("bold"),italic:d("italic"),underline:d("underline"),indent:{key:D.keys.TAB,format:["blockquote","indent","list"],handler:function(t,e){if(e.collapsed&&0!==e.offset)return!0;this.quill.format("indent","+1",q.default.sources.USER)}},outdent:{key:D.keys.TAB,shiftKey:!0,format:["blockquote","indent","list"],handler:function(t,e){if(e.collapsed&&0!==e.offset)return!0;this.quill.format("indent","-1",q.default.sources.USER)}},"outdent backspace":{key:D.keys.BACKSPACE,collapsed:!0,shiftKey:null,metaKey:null,ctrlKey:null,altKey:null,format:["indent","list"],offset:0,handler:function(t,e){null!=e.format.indent?this.quill.format("indent","-1",q.default.sources.USER):null!=e.format.list&&this.quill.format("list",!1,q.default.sources.USER)}},"indent code-block":p(!0),"outdent code-block":p(!1),"remove tab":{key:D.keys.TAB,shiftKey:!0,collapsed:!0,prefix:/\t$/,handler:function(t){this.quill.deleteText(t.index-1,1,q.default.sources.USER)}},tab:{key:D.keys.TAB,handler:function(t){this.quill.history.cutoff();var e=(new A.default).retain(t.index).delete(t.length).insert("\t");this.quill.updateContents(e,q.default.sources.USER),this.quill.history.cutoff(),this.quill.setSelection(t.index+1,q.default.sources.SILENT)}},"list empty enter":{key:D.keys.ENTER,collapsed:!0,format:["list"],empty:!0,handler:function(t,e){this.quill.format("list",!1,q.default.sources.USER),e.format.indent&&this.quill.format("indent",!1,q.default.sources.USER)}},"checklist enter":{key:D.keys.ENTER,collapsed:!0,format:{list:"checked"},handler:function(t){var e=this.quill.getLine(t.index),n=b(e,2),r=n[0],o=n[1],i=(0,E.default)({},r.formats(),{list:"checked"}),l=(new A.default).retain(t.index).insert("\n",i).retain(r.length()-o-1).retain(1,{list:"unchecked"});this.quill.updateContents(l,q.default.sources.USER),this.quill.setSelection(t.index+1,q.default.sources.SILENT),this.quill.scrollIntoView()}},"header enter":{key:D.keys.ENTER,collapsed:!0,format:["header"],suffix:/^$/,handler:function(t,e){var n=this.quill.getLine(t.index),r=b(n,2),o=r[0],i=r[1],l=(new A.default).retain(t.index).insert("\n",e.format).retain(o.length()-i-1).retain(1,{header:null});this.quill.updateContents(l,q.default.sources.USER),this.quill.setSelection(t.index+1,q.default.sources.SILENT),this.quill.scrollIntoView()}},"list autofill":{key:" ",collapsed:!0,format:{list:!1},prefix:/^\s*?(\d+\.|-|\*|\[ ?\]|\[x\])$/,handler:function(t,e){var n=e.prefix.length,r=this.quill.getLine(t.index),o=b(r,2),i=o[0],l=o[1];if(l>n)return!0;var a=void 0;switch(e.prefix.trim()){case"[]":case"[ ]":a="unchecked";break;case"[x]":a="checked";break;case"-":case"*":a="bullet";break;default:a="ordered"}this.quill.insertText(t.index," ",q.default.sources.USER),this.quill.history.cutoff();var s=(new A.default).retain(t.index-l).delete(n+1).retain(i.length()-2-l).retain(1,{list:a});this.quill.updateContents(s,q.default.sources.USER),this.quill.history.cutoff(),this.quill.setSelection(t.index-n,q.default.sources.SILENT)}},"code exit":{key:D.keys.ENTER,collapsed:!0,format:["code-block"],prefix:/\n\n$/,suffix:/^\s+$/,handler:function(t){var e=this.quill.getLine(t.index),n=b(e,2),r=n[0],o=n[1],i=(new A.default).retain(t.index+r.length()-o-2).retain(1,{"code-block":null}).delete(1);this.quill.updateContents(i,q.default.sources.USER)}},"embed left":s(D.keys.LEFT,!1),"embed left shift":s(D.keys.LEFT,!0),"embed right":s(D.keys.RIGHT,!1),"embed right shift":s(D.keys.RIGHT,!0)}},e.default=D,e.SHORTKEY=I},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function l(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var a=function(){function t(t,e){var n=[],r=!0,o=!1,i=void 0;try{for(var l,a=t[Symbol.iterator]();!(r=(l=a.next()).done)&&(n.push(l.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t}finally{try{!r&&a.return&&a.return()}finally{if(o)throw i}}return n}return function(e,n){if(Array.isArray(e))return e;if(Symbol.iterator in Object(e))return t(e,n);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),s=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},u=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),c=n(0),f=r(c),h=n(7),p=r(h),d=function(t){function e(t,n){o(this,e);var r=i(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t));return r.selection=n,r.textNode=document.createTextNode(e.CONTENTS),r.domNode.appendChild(r.textNode),r._length=0,r}return l(e,t),u(e,null,[{key:"value",value:function(){}}]),u(e,[{key:"detach",value:function(){null!=this.parent&&this.parent.removeChild(this)}},{key:"format",value:function(t,n){if(0!==this._length)return s(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"format",this).call(this,t,n);for(var r=this,o=0;null!=r&&r.statics.scope!==f.default.Scope.BLOCK_BLOT;)o+=r.offset(r.parent),r=r.parent;null!=r&&(this._length=e.CONTENTS.length,r.optimize(),r.formatAt(o,e.CONTENTS.length,t,n),this._length=0)}},{key:"index",value:function(t,n){return t===this.textNode?0:s(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"index",this).call(this,t,n)}},{key:"length",value:function(){return this._length}},{key:"position",value:function(){return[this.textNode,this.textNode.data.length]}},{key:"remove",value:function(){s(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"remove",this).call(this),this.parent=null}},{key:"restore",value:function(){if(!this.selection.composing&&null!=this.parent){var t=this.textNode,n=this.selection.getNativeRange(),r=void 0,o=void 0,i=void 0;if(null!=n&&n.start.node===t&&n.end.node===t){var l=[t,n.start.offset,n.end.offset];r=l[0],o=l[1],i=l[2]}for(;null!=this.domNode.lastChild&&this.domNode.lastChild!==this.textNode;)this.domNode.parentNode.insertBefore(this.domNode.lastChild,this.domNode);if(this.textNode.data!==e.CONTENTS){var s=this.textNode.data.split(e.CONTENTS).join("");this.next instanceof p.default?(r=this.next.domNode,this.next.insertAt(0,s),this.textNode.data=e.CONTENTS):(this.textNode.data=s,this.parent.insertBefore(f.default.create(this.textNode),this),this.textNode=document.createTextNode(e.CONTENTS),this.domNode.appendChild(this.textNode))}if(this.remove(),null!=o){var u=[o,i].map(function(t){return Math.max(0,Math.min(r.data.length,t-1))}),c=a(u,2);return o=c[0],i=c[1],{startNode:r,startOffset:o,endNode:r,endOffset:i}}}}},{key:"update",value:function(t,e){var n=this;if(t.some(function(t){return"characterData"===t.type&&t.target===n.textNode})){var r=this.restore();r&&(e.range=r)}}},{key:"value",value:function(){return""}}]),e}(f.default.Embed);d.blotName="cursor",d.className="ql-cursor",d.tagName="span",d.CONTENTS="\ufeff",e.default=d},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function l(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var a=n(0),s=r(a),u=n(4),c=r(u),f=function(t){function e(){return o(this,e),i(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return l(e,t),e}(s.default.Container);f.allowedChildren=[c.default,u.BlockEmbed,f],e.default=f},function(t,e,n){"use strict";function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function i(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0}),e.ColorStyle=e.ColorClass=e.ColorAttributor=void 0;var l=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),a=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},s=n(0),u=function(t){return t&&t.__esModule?t:{default:t}}(s),c=function(t){function e(){return r(this,e),o(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return i(e,t),l(e,[{key:"value",value:function(t){var n=a(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"value",this).call(this,t);return n.startsWith("rgb(")?(n=n.replace(/^[^\d]+/,"").replace(/[^\d]+$/,""),"#"+n.split(",").map(function(t){return("00"+parseInt(t).toString(16)).slice(-2)}).join("")):n}}]),e}(u.default.Attributor.Style),f=new u.default.Attributor.Class("color","ql-color",{scope:u.default.Scope.INLINE}),h=new c("color","color",{scope:u.default.Scope.INLINE});e.ColorAttributor=c,e.ColorClass=f,e.ColorStyle=h},function(t,e,n){"use strict";function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function i(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}function l(t,e){var n=document.createElement("a");n.href=t;var r=n.href.slice(0,n.href.indexOf(":"));return e.indexOf(r)>-1}Object.defineProperty(e,"__esModule",{value:!0}),e.sanitize=e.default=void 0;var a=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),s=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},u=n(6),c=function(t){return t&&t.__esModule?t:{default:t}}(u),f=function(t){function e(){return r(this,e),o(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return i(e,t),a(e,[{key:"format",value:function(t,n){if(t!==this.statics.blotName||!n)return s(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"format",this).call(this,t,n);n=this.constructor.sanitize(n),this.domNode.setAttribute("href",n)}}],[{key:"create",value:function(t){var n=s(e.__proto__||Object.getPrototypeOf(e),"create",this).call(this,t);return t=this.sanitize(t),n.setAttribute("href",t),n.setAttribute("target","_blank"),n}},{key:"formats",value:function(t){return t.getAttribute("href")}},{key:"sanitize",value:function(t){return l(t,this.PROTOCOL_WHITELIST)?t:this.SANITIZED_URL}}]),e}(c.default);f.blotName="link",f.tagName="A",f.SANITIZED_URL="about:blank",f.PROTOCOL_WHITELIST=["http","https","mailto","tel"],e.default=f,e.sanitize=l},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){t.setAttribute(e,!("true"===t.getAttribute(e)))}Object.defineProperty(e,"__esModule",{value:!0});var l="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},a=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),s=n(23),u=r(s),c=n(107),f=r(c),h=0,p=function(){function t(e){var n=this;o(this,t),this.select=e,this.container=document.createElement("span"),this.buildPicker(),this.select.style.display="none",this.select.parentNode.insertBefore(this.container,this.select),this.label.addEventListener("mousedown",function(){n.togglePicker()}),this.label.addEventListener("keydown",function(t){switch(t.keyCode){case u.default.keys.ENTER:n.togglePicker();break;case u.default.keys.ESCAPE:n.escape(),t.preventDefault()}}),this.select.addEventListener("change",this.update.bind(this))}return a(t,[{key:"togglePicker",value:function(){this.container.classList.toggle("ql-expanded"),i(this.label,"aria-expanded"),i(this.options,"aria-hidden")}},{key:"buildItem",value:function(t){var e=this,n=document.createElement("span");return n.tabIndex="0",n.setAttribute("role","button"),n.classList.add("ql-picker-item"),t.hasAttribute("value")&&n.setAttribute("data-value",t.getAttribute("value")),t.textContent&&n.setAttribute("data-label",t.textContent),n.addEventListener("click",function(){e.selectItem(n,!0)}),n.addEventListener("keydown",function(t){switch(t.keyCode){case u.default.keys.ENTER:e.selectItem(n,!0),t.preventDefault();break;case u.default.keys.ESCAPE:e.escape(),t.preventDefault()}}),n}},{key:"buildLabel",value:function(){var t=document.createElement("span");return t.classList.add("ql-picker-label"),t.innerHTML=f.default,t.tabIndex="0",t.setAttribute("role","button"),t.setAttribute("aria-expanded","false"),this.container.appendChild(t),t}},{key:"buildOptions",value:function(){var t=this,e=document.createElement("span");e.classList.add("ql-picker-options"),e.setAttribute("aria-hidden","true"),e.tabIndex="-1",e.id="ql-picker-options-"+h,h+=1,this.label.setAttribute("aria-controls",e.id),this.options=e,[].slice.call(this.select.options).forEach(function(n){var r=t.buildItem(n);e.appendChild(r),!0===n.selected&&t.selectItem(r)}),this.container.appendChild(e)}},{key:"buildPicker",value:function(){var t=this;[].slice.call(this.select.attributes).forEach(function(e){t.container.setAttribute(e.name,e.value)}),this.container.classList.add("ql-picker"),this.label=this.buildLabel(),this.buildOptions()}},{key:"escape",value:function(){var t=this;this.close(),setTimeout(function(){return t.label.focus()},1)}},{key:"close",value:function(){this.container.classList.remove("ql-expanded"),this.label.setAttribute("aria-expanded","false"),this.options.setAttribute("aria-hidden","true")}},{key:"selectItem",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=this.container.querySelector(".ql-selected");if(t!==n&&(null!=n&&n.classList.remove("ql-selected"),null!=t&&(t.classList.add("ql-selected"),this.select.selectedIndex=[].indexOf.call(t.parentNode.children,t),t.hasAttribute("data-value")?this.label.setAttribute("data-value",t.getAttribute("data-value")):this.label.removeAttribute("data-value"),t.hasAttribute("data-label")?this.label.setAttribute("data-label",t.getAttribute("data-label")):this.label.removeAttribute("data-label"),e))){if("function"==typeof Event)this.select.dispatchEvent(new Event("change"));else if("object"===("undefined"==typeof Event?"undefined":l(Event))){var r=document.createEvent("Event");r.initEvent("change",!0,!0),this.select.dispatchEvent(r)}this.close()}}},{key:"update",value:function(){var t=void 0;if(this.select.selectedIndex>-1){var e=this.container.querySelector(".ql-picker-options").children[this.select.selectedIndex];t=this.select.options[this.select.selectedIndex],this.selectItem(e)}else this.selectItem(null);var n=null!=t&&t!==this.select.querySelector("option[selected]");this.label.classList.toggle("ql-active",n)}}]),t}();e.default=p},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0});var o=n(0),i=r(o),l=n(5),a=r(l),s=n(4),u=r(s),c=n(16),f=r(c),h=n(25),p=r(h),d=n(24),y=r(d),v=n(35),b=r(v),g=n(6),m=r(g),_=n(22),O=r(_),w=n(7),x=r(w),E=n(55),k=r(E),A=n(42),j=r(A),N=n(23),T=r(N);a.default.register({"blots/block":u.default,"blots/block/embed":s.BlockEmbed,"blots/break":f.default,"blots/container":p.default,"blots/cursor":y.default,"blots/embed":b.default,"blots/inline":m.default,"blots/scroll":O.default,"blots/text":x.default,"modules/clipboard":k.default,"modules/history":j.default,"modules/keyboard":T.default}),i.default.register(u.default,f.default,y.default,m.default,O.default,x.default),e.default=a.default},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(1),o=function(){function t(t){this.domNode=t,this.domNode[r.DATA_KEY]={blot:this}}return Object.defineProperty(t.prototype,"statics",{get:function(){return this.constructor},enumerable:!0,configurable:!0}),t.create=function(t){if(null==this.tagName)throw new r.ParchmentError("Blot definition missing tagName");var e;return Array.isArray(this.tagName)?("string"==typeof t&&(t=t.toUpperCase(),parseInt(t).toString()===t&&(t=parseInt(t))),e="number"==typeof t?document.createElement(this.tagName[t-1]):this.tagName.indexOf(t)>-1?document.createElement(t):document.createElement(this.tagName[0])):e=document.createElement(this.tagName),this.className&&e.classList.add(this.className),e},t.prototype.attach=function(){null!=this.parent&&(this.scroll=this.parent.scroll)},t.prototype.clone=function(){var t=this.domNode.cloneNode(!1);return r.create(t)},t.prototype.detach=function(){null!=this.parent&&this.parent.removeChild(this),delete this.domNode[r.DATA_KEY]},t.prototype.deleteAt=function(t,e){this.isolate(t,e).remove()},t.prototype.formatAt=function(t,e,n,o){var i=this.isolate(t,e);if(null!=r.query(n,r.Scope.BLOT)&&o)i.wrap(n,o);else if(null!=r.query(n,r.Scope.ATTRIBUTE)){var l=r.create(this.statics.scope);i.wrap(l),l.format(n,o)}},t.prototype.insertAt=function(t,e,n){var o=null==n?r.create("text",e):r.create(e,n),i=this.split(t);this.parent.insertBefore(o,i)},t.prototype.insertInto=function(t,e){void 0===e&&(e=null),null!=this.parent&&this.parent.children.remove(this);var n=null;t.children.insertBefore(this,e),null!=e&&(n=e.domNode),this.domNode.parentNode==t.domNode&&this.domNode.nextSibling==n||t.domNode.insertBefore(this.domNode,n),this.parent=t,this.attach()},t.prototype.isolate=function(t,e){var n=this.split(t);return n.split(e),n},t.prototype.length=function(){return 1},t.prototype.offset=function(t){return void 0===t&&(t=this.parent),null==this.parent||this==t?0:this.parent.children.offset(this)+this.parent.offset(t)},t.prototype.optimize=function(t){null!=this.domNode[r.DATA_KEY]&&delete this.domNode[r.DATA_KEY].mutations},t.prototype.remove=function(){null!=this.domNode.parentNode&&this.domNode.parentNode.removeChild(this.domNode),this.detach()},t.prototype.replace=function(t){null!=t.parent&&(t.parent.insertBefore(this,t.next),t.remove())},t.prototype.replaceWith=function(t,e){var n="string"==typeof t?r.create(t,e):t;return n.replace(this),n},t.prototype.split=function(t,e){return 0===t?this:this.next},t.prototype.update=function(t,e){},t.prototype.wrap=function(t,e){var n="string"==typeof t?r.create(t,e):t;return null!=this.parent&&this.parent.insertBefore(n,this.next),n.appendChild(this),n},t.blotName="abstract",t}();e.default=o},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(12),o=n(32),i=n(33),l=n(1),a=function(){function t(t){this.attributes={},this.domNode=t,this.build()}return t.prototype.attribute=function(t,e){e?t.add(this.domNode,e)&&(null!=t.value(this.domNode)?this.attributes[t.attrName]=t:delete this.attributes[t.attrName]):(t.remove(this.domNode),delete this.attributes[t.attrName])},t.prototype.build=function(){var t=this;this.attributes={};var e=r.default.keys(this.domNode),n=o.default.keys(this.domNode),a=i.default.keys(this.domNode);e.concat(n).concat(a).forEach(function(e){var n=l.query(e,l.Scope.ATTRIBUTE);n instanceof r.default&&(t.attributes[n.attrName]=n)})},t.prototype.copy=function(t){var e=this;Object.keys(this.attributes).forEach(function(n){var r=e.attributes[n].value(e.domNode);t.format(n,r)})},t.prototype.move=function(t){var e=this;this.copy(t),Object.keys(this.attributes).forEach(function(t){e.attributes[t].remove(e.domNode)}),this.attributes={}},t.prototype.values=function(){var t=this;return Object.keys(this.attributes).reduce(function(e,n){return e[n]=t.attributes[n].value(t.domNode),e},{})},t}();e.default=a},function(t,e,n){"use strict";function r(t,e){return(t.getAttribute("class")||"").split(/\s+/).filter(function(t){return 0===t.indexOf(e+"-")})}var o=this&&this.__extends||function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])};return function(e,n){function r(){this.constructor=e}t(e,n),e.prototype=null===n?Object.create(n):(r.prototype=n.prototype,new r)}}();Object.defineProperty(e,"__esModule",{value:!0});var i=n(12),l=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return o(e,t),e.keys=function(t){return(t.getAttribute("class")||"").split(/\s+/).map(function(t){return t.split("-").slice(0,-1).join("-")})},e.prototype.add=function(t,e){return!!this.canAdd(t,e)&&(this.remove(t),t.classList.add(this.keyName+"-"+e),!0)},e.prototype.remove=function(t){r(t,this.keyName).forEach(function(e){t.classList.remove(e)}),0===t.classList.length&&t.removeAttribute("class")},e.prototype.value=function(t){var e=r(t,this.keyName)[0]||"",n=e.slice(this.keyName.length+1);return this.canAdd(t,n)?n:""},e}(i.default);e.default=l},function(t,e,n){"use strict";function r(t){var e=t.split("-"),n=e.slice(1).map(function(t){return t[0].toUpperCase()+t.slice(1)}).join("");return e[0]+n}var o=this&&this.__extends||function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])};return function(e,n){function r(){this.constructor=e}t(e,n),e.prototype=null===n?Object.create(n):(r.prototype=n.prototype,new r)}}();Object.defineProperty(e,"__esModule",{value:!0});var i=n(12),l=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return o(e,t),e.keys=function(t){return(t.getAttribute("style")||"").split(";").map(function(t){return t.split(":")[0].trim()})},e.prototype.add=function(t,e){return!!this.canAdd(t,e)&&(t.style[r(this.keyName)]=e,!0)},e.prototype.remove=function(t){t.style[r(this.keyName)]="",t.getAttribute("style")||t.removeAttribute("style")},e.prototype.value=function(t){var e=t.style[r(this.keyName)];return this.canAdd(t,e)?e:""},e}(i.default);e.default=l},function(t,e,n){"use strict";function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var o=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),i=function(){function t(e,n){r(this,t),this.quill=e,this.options=n,this.modules={}}return o(t,[{key:"init",value:function(){var t=this;Object.keys(this.options.modules).forEach(function(e){null==t.modules[e]&&t.addModule(e)})}},{key:"addModule",value:function(t){var e=this.quill.constructor.import("modules/"+t);return this.modules[t]=new e(this.quill,this.options.modules[t]||{}),this.modules[t]}}]),t}();i.DEFAULTS={modules:{}},i.themes={default:i},e.default=i},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function l(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var a=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),s=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},u=n(0),c=r(u),f=n(7),h=r(f),p="\ufeff",d=function(t){function e(t){o(this,e);var n=i(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t));return n.contentNode=document.createElement("span"),n.contentNode.setAttribute("contenteditable",!1),[].slice.call(n.domNode.childNodes).forEach(function(t){n.contentNode.appendChild(t)}),n.leftGuard=document.createTextNode(p),n.rightGuard=document.createTextNode(p),n.domNode.appendChild(n.leftGuard),n.domNode.appendChild(n.contentNode),n.domNode.appendChild(n.rightGuard),n}return l(e,t),a(e,[{key:"index",value:function(t,n){return t===this.leftGuard?0:t===this.rightGuard?1:s(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"index",this).call(this,t,n)}},{key:"restore",value:function(t){var e=void 0,n=void 0,r=t.data.split(p).join("");if(t===this.leftGuard)if(this.prev instanceof h.default){var o=this.prev.length();this.prev.insertAt(o,r),e={startNode:this.prev.domNode,startOffset:o+r.length}}else n=document.createTextNode(r),this.parent.insertBefore(c.default.create(n),this),e={startNode:n,startOffset:r.length};else t===this.rightGuard&&(this.next instanceof h.default?(this.next.insertAt(0,r),e={startNode:this.next.domNode,startOffset:r.length}):(n=document.createTextNode(r),this.parent.insertBefore(c.default.create(n),this.next),e={startNode:n,startOffset:r.length}));return t.data=p,e}},{key:"update",value:function(t,e){var n=this;t.forEach(function(t){if("characterData"===t.type&&(t.target===n.leftGuard||t.target===n.rightGuard)){var r=n.restore(t.target);r&&(e.range=r)}})}}]),e}(c.default.Embed);e.default=d},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.AlignStyle=e.AlignClass=e.AlignAttribute=void 0;var r=n(0),o=function(t){return t&&t.__esModule?t:{default:t}}(r),i={scope:o.default.Scope.BLOCK,whitelist:["right","center","justify"]},l=new o.default.Attributor.Attribute("align","align",i),a=new o.default.Attributor.Class("align","ql-align",i),s=new o.default.Attributor.Style("align","text-align",i);e.AlignAttribute=l,e.AlignClass=a,e.AlignStyle=s},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.BackgroundStyle=e.BackgroundClass=void 0;var r=n(0),o=function(t){return t&&t.__esModule?t:{default:t}}(r),i=n(26),l=new o.default.Attributor.Class("background","ql-bg",{scope:o.default.Scope.INLINE}),a=new i.ColorAttributor("background","background-color",{scope:o.default.Scope.INLINE});e.BackgroundClass=l,e.BackgroundStyle=a},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.DirectionStyle=e.DirectionClass=e.DirectionAttribute=void 0;var r=n(0),o=function(t){return t&&t.__esModule?t:{default:t}}(r),i={scope:o.default.Scope.BLOCK,whitelist:["rtl"]},l=new o.default.Attributor.Attribute("direction","dir",i),a=new o.default.Attributor.Class("direction","ql-direction",i),s=new o.default.Attributor.Style("direction","direction",i);e.DirectionAttribute=l,e.DirectionClass=a,e.DirectionStyle=s},function(t,e,n){"use strict";function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function i(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0}),e.FontClass=e.FontStyle=void 0;var l=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),a=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},s=n(0),u=function(t){return t&&t.__esModule?t:{default:t}}(s),c={scope:u.default.Scope.INLINE,whitelist:["serif","monospace"]},f=new u.default.Attributor.Class("font","ql-font",c),h=function(t){function e(){return r(this,e),o(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return i(e,t),l(e,[{key:"value",value:function(t){return a(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"value",this).call(this,t).replace(/["']/g,"")}}]),e}(u.default.Attributor.Style),p=new h("font","font-family",c);e.FontStyle=p,e.FontClass=f},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.SizeStyle=e.SizeClass=void 0;var r=n(0),o=function(t){return t&&t.__esModule?t:{default:t}}(r),i=new o.default.Attributor.Class("size","ql-size",{scope:o.default.Scope.INLINE,whitelist:["small","large","huge"]}),l=new o.default.Attributor.Style("size","font-size",{scope:o.default.Scope.INLINE,whitelist:["10px","18px","32px"]});e.SizeClass=i,e.SizeStyle=l},function(t,e,n){"use strict";t.exports={align:{"":n(76),center:n(77),right:n(78),justify:n(79)},background:n(80),blockquote:n(81),bold:n(82),clean:n(83),code:n(58),"code-block":n(58),color:n(84),direction:{"":n(85),rtl:n(86)},float:{center:n(87),full:n(88),left:n(89),right:n(90)},formula:n(91),header:{1:n(92),2:n(93)},italic:n(94),image:n(95),indent:{"+1":n(96),"-1":n(97)},link:n(98),list:{ordered:n(99),bullet:n(100),check:n(101)},script:{sub:n(102),super:n(103)},strike:n(104),underline:n(105),video:n(106)}},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function l(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}function a(t){var e=t.ops[t.ops.length-1];return null!=e&&(null!=e.insert?"string"==typeof e.insert&&e.insert.endsWith("\n"):null!=e.attributes&&Object.keys(e.attributes).some(function(t){return null!=f.default.query(t,f.default.Scope.BLOCK)}))}function s(t){var e=t.reduce(function(t,e){return t+=e.delete||0},0),n=t.length()-e;return a(t)&&(n-=1),n}Object.defineProperty(e,"__esModule",{value:!0}),e.getLastChangeIndex=e.default=void 0;var u=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),c=n(0),f=r(c),h=n(5),p=r(h),d=n(9),y=r(d),v=function(t){function e(t,n){o(this,e);var r=i(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));return r.lastRecorded=0,r.ignoreChange=!1,r.clear(),r.quill.on(p.default.events.EDITOR_CHANGE,function(t,e,n,o){t!==p.default.events.TEXT_CHANGE||r.ignoreChange||(r.options.userOnly&&o!==p.default.sources.USER?r.transform(e):r.record(e,n))}),r.quill.keyboard.addBinding({key:"Z",shortKey:!0},r.undo.bind(r)),r.quill.keyboard.addBinding({key:"Z",shortKey:!0,shiftKey:!0},r.redo.bind(r)),/Win/i.test(navigator.platform)&&r.quill.keyboard.addBinding({key:"Y",shortKey:!0},r.redo.bind(r)),r}return l(e,t),u(e,[{key:"change",value:function(t,e){if(0!==this.stack[t].length){var n=this.stack[t].pop();this.stack[e].push(n),this.lastRecorded=0,this.ignoreChange=!0,this.quill.updateContents(n[t],p.default.sources.USER),this.ignoreChange=!1;var r=s(n[t]);this.quill.setSelection(r)}}},{key:"clear",value:function(){this.stack={undo:[],redo:[]}}},{key:"cutoff",value:function(){this.lastRecorded=0}},{key:"record",value:function(t,e){if(0!==t.ops.length){this.stack.redo=[];var n=this.quill.getContents().diff(e),r=Date.now();if(this.lastRecorded+this.options.delay>r&&this.stack.undo.length>0){var o=this.stack.undo.pop();n=n.compose(o.undo),t=o.redo.compose(t)}else this.lastRecorded=r;this.stack.undo.push({redo:t,undo:n}),this.stack.undo.length>this.options.maxStack&&this.stack.undo.shift()}}},{key:"redo",value:function(){this.change("redo","undo")}},{key:"transform",value:function(t){this.stack.undo.forEach(function(e){e.undo=t.transform(e.undo,!0),e.redo=t.transform(e.redo,!0)}),this.stack.redo.forEach(function(e){e.undo=t.transform(e.undo,!0),e.redo=t.transform(e.redo,!0)})}},{key:"undo",value:function(){this.change("undo","redo")}}]),e}(y.default);v.DEFAULTS={delay:1e3,maxStack:100,userOnly:!1},e.default=v,e.getLastChangeIndex=s},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function l(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}function a(t){var e=t.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtube\.com\/watch.*v=([a-zA-Z0-9_-]+)/)||t.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtu\.be\/([a-zA-Z0-9_-]+)/);return e?(e[1]||"https")+"://www.youtube.com/embed/"+e[2]+"?showinfo=0":(e=t.match(/^(?:(https?):\/\/)?(?:www\.)?vimeo\.com\/(\d+)/))?(e[1]||"https")+"://player.vimeo.com/video/"+e[2]+"/":t}function s(t,e){var n=arguments.length>2&&void 0!==arguments[2]&&arguments[2];e.forEach(function(e){var r=document.createElement("option");e===n?r.setAttribute("selected","selected"):r.setAttribute("value",e),t.appendChild(r)})}Object.defineProperty(e,"__esModule",{value:!0}),e.default=e.BaseTooltip=void 0;var u=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),c=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},f=n(3),h=r(f),p=n(2),d=r(p),y=n(8),v=r(y),b=n(23),g=r(b),m=n(34),_=r(m),O=n(59),w=r(O),x=n(60),E=r(x),k=n(28),A=r(k),j=n(61),N=r(j),T=[!1,"center","right","justify"],S=["#000000","#e60000","#ff9900","#ffff00","#008a00","#0066cc","#9933ff","#ffffff","#facccc","#ffebcc","#ffffcc","#cce8cc","#cce0f5","#ebd6ff","#bbbbbb","#f06666","#ffc266","#ffff66","#66b966","#66a3e0","#c285ff","#888888","#a10000","#b26b00","#b2b200","#006100","#0047b2","#6b24b2","#444444","#5c0000","#663d00","#666600","#003700","#002966","#3d1466"],P=[!1,"serif","monospace"],q=["1","2","3",!1],C=["small",!1,"large","huge"],L=function(t){function e(t,n){o(this,e);var r=i(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n)),l=function e(n){if(!document.body.contains(t.root))return document.body.removeEventListener("click",e);null==r.tooltip||r.tooltip.root.contains(n.target)||document.activeElement===r.tooltip.textbox||r.quill.hasFocus()||r.tooltip.hide(),null!=r.pickers&&r.pickers.forEach(function(t){t.container.contains(n.target)||t.close()})};return t.emitter.listenDOM("click",document.body,l),r}return l(e,t),u(e,[{key:"addModule",value:function(t){var n=c(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"addModule",this).call(this,t);return"toolbar"===t&&this.extendToolbar(n),n}},{key:"buildButtons",value:function(t,e){t.forEach(function(t){(t.getAttribute("class")||"").split(/\s+/).forEach(function(n){if(n.startsWith("ql-")&&(n=n.slice("ql-".length),null!=e[n]))if("direction"===n)t.innerHTML=e[n][""]+e[n].rtl;else if("string"==typeof e[n])t.innerHTML=e[n];else{var r=t.value||"";null!=r&&e[n][r]&&(t.innerHTML=e[n][r])}})})}},{key:"buildPickers",value:function(t,e){var n=this;this.pickers=t.map(function(t){if(t.classList.contains("ql-align"))return null==t.querySelector("option")&&s(t,T),new E.default(t,e.align);if(t.classList.contains("ql-background")||t.classList.contains("ql-color")){var n=t.classList.contains("ql-background")?"background":"color";return null==t.querySelector("option")&&s(t,S,"background"===n?"#ffffff":"#000000"),new w.default(t,e[n])}return null==t.querySelector("option")&&(t.classList.contains("ql-font")?s(t,P):t.classList.contains("ql-header")?s(t,q):t.classList.contains("ql-size")&&s(t,C)),new A.default(t)});var r=function(){n.pickers.forEach(function(t){t.update()})};this.quill.on(v.default.events.EDITOR_CHANGE,r)}}]),e}(_.default);L.DEFAULTS=(0,h.default)(!0,{},_.default.DEFAULTS,{modules:{toolbar:{handlers:{formula:function(){this.quill.theme.tooltip.edit("formula")},image:function(){var t=this,e=this.container.querySelector("input.ql-image[type=file]");null==e&&(e=document.createElement("input"),e.setAttribute("type","file"),e.setAttribute("accept","image/png, image/gif, image/jpeg, image/bmp, image/x-icon"),e.classList.add("ql-image"),e.addEventListener("change",function(){if(null!=e.files&&null!=e.files[0]){var n=new FileReader;n.onload=function(n){var r=t.quill.getSelection(!0);t.quill.updateContents((new d.default).retain(r.index).delete(r.length).insert({image:n.target.result}),v.default.sources.USER),t.quill.setSelection(r.index+1,v.default.sources.SILENT),e.value=""},n.readAsDataURL(e.files[0])}}),this.container.appendChild(e)),e.click()},video:function(){this.quill.theme.tooltip.edit("video")}}}}});var R=function(t){function e(t,n){o(this,e);var r=i(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));return r.textbox=r.root.querySelector('input[type="text"]'),r.listen(),r}return l(e,t),u(e,[{key:"listen",value:function(){var t=this;this.textbox.addEventListener("keydown",function(e){g.default.match(e,"enter")?(t.save(),e.preventDefault()):g.default.match(e,"escape")&&(t.cancel(),e.preventDefault())})}},{key:"cancel",value:function(){this.hide()}},{key:"edit",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"link",e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null;this.root.classList.remove("ql-hidden"),this.root.classList.add("ql-editing"),null!=e?this.textbox.value=e:t!==this.root.getAttribute("data-mode")&&(this.textbox.value=""),this.position(this.quill.getBounds(this.quill.selection.savedRange)),this.textbox.select(),this.textbox.setAttribute("placeholder",this.textbox.getAttribute("data-"+t)||""),this.root.setAttribute("data-mode",t)}},{key:"restoreFocus",value:function(){var t=this.quill.scrollingContainer.scrollTop;this.quill.focus(),this.quill.scrollingContainer.scrollTop=t}},{key:"save",value:function(){var t=this.textbox.value;switch(this.root.getAttribute("data-mode")){case"link":var e=this.quill.root.scrollTop;this.linkRange?(this.quill.formatText(this.linkRange,"link",t,v.default.sources.USER),delete this.linkRange):(this.restoreFocus(),this.quill.format("link",t,v.default.sources.USER)),this.quill.root.scrollTop=e;break;case"video":t=a(t);case"formula":if(!t)break;var n=this.quill.getSelection(!0);if(null!=n){var r=n.index+n.length;this.quill.insertEmbed(r,this.root.getAttribute("data-mode"),t,v.default.sources.USER),"formula"===this.root.getAttribute("data-mode")&&this.quill.insertText(r+1," ",v.default.sources.USER),this.quill.setSelection(r+2,v.default.sources.USER)}}this.textbox.value="",this.hide()}}]),e}(N.default);e.BaseTooltip=R,e.default=L},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=function(){function t(){this.head=this.tail=null,this.length=0}return t.prototype.append=function(){for(var t=[],e=0;e<arguments.length;e++)t[e]=arguments[e];this.insertBefore(t[0],null),t.length>1&&this.append.apply(this,t.slice(1))},t.prototype.contains=function(t){for(var e,n=this.iterator();e=n();)if(e===t)return!0;return!1},t.prototype.insertBefore=function(t,e){t&&(t.next=e,null!=e?(t.prev=e.prev,null!=e.prev&&(e.prev.next=t),e.prev=t,e===this.head&&(this.head=t)):null!=this.tail?(this.tail.next=t,t.prev=this.tail,this.tail=t):(t.prev=null,this.head=this.tail=t),this.length+=1)},t.prototype.offset=function(t){for(var e=0,n=this.head;null!=n;){if(n===t)return e;e+=n.length(),n=n.next}return-1},t.prototype.remove=function(t){this.contains(t)&&(null!=t.prev&&(t.prev.next=t.next),null!=t.next&&(t.next.prev=t.prev),t===this.head&&(this.head=t.next),t===this.tail&&(this.tail=t.prev),this.length-=1)},t.prototype.iterator=function(t){return void 0===t&&(t=this.head),function(){var e=t;return null!=t&&(t=t.next),e}},t.prototype.find=function(t,e){void 0===e&&(e=!1);for(var n,r=this.iterator();n=r();){var o=n.length();if(t<o||e&&t===o&&(null==n.next||0!==n.next.length()))return[n,t];t-=o}return[null,0]},t.prototype.forEach=function(t){for(var e,n=this.iterator();e=n();)t(e)},t.prototype.forEachAt=function(t,e,n){if(!(e<=0))for(var r,o=this.find(t),i=o[0],l=o[1],a=t-l,s=this.iterator(i);(r=s())&&a<t+e;){var u=r.length();t>a?n(r,t-a,Math.min(e,a+u-t)):n(r,0,Math.min(u,t+e-a)),a+=u}},t.prototype.map=function(t){return this.reduce(function(e,n){return e.push(t(n)),e},[])},t.prototype.reduce=function(t,e){for(var n,r=this.iterator();n=r();)e=t(e,n);return e},t}();e.default=r},function(t,e,n){"use strict";var r=this&&this.__extends||function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])};return function(e,n){function r(){this.constructor=e}t(e,n),e.prototype=null===n?Object.create(n):(r.prototype=n.prototype,new r)}}();Object.defineProperty(e,"__esModule",{value:!0});var o=n(17),i=n(1),l={attributes:!0,characterData:!0,characterDataOldValue:!0,childList:!0,subtree:!0},a=function(t){function e(e){var n=t.call(this,e)||this;return n.scroll=n,n.observer=new MutationObserver(function(t){n.update(t)}),n.observer.observe(n.domNode,l),n.attach(),n}return r(e,t),e.prototype.detach=function(){t.prototype.detach.call(this),this.observer.disconnect()},e.prototype.deleteAt=function(e,n){this.update(),0===e&&n===this.length()?this.children.forEach(function(t){t.remove()}):t.prototype.deleteAt.call(this,e,n)},e.prototype.formatAt=function(e,n,r,o){this.update(),t.prototype.formatAt.call(this,e,n,r,o)},e.prototype.insertAt=function(e,n,r){this.update(),t.prototype.insertAt.call(this,e,n,r)},e.prototype.optimize=function(e,n){var r=this;void 0===e&&(e=[]),void 0===n&&(n={}),t.prototype.optimize.call(this,n);for(var l=[].slice.call(this.observer.takeRecords());l.length>0;)e.push(l.pop());for(var a=function(t,e){void 0===e&&(e=!0),null!=t&&t!==r&&null!=t.domNode.parentNode&&(null==t.domNode[i.DATA_KEY].mutations&&(t.domNode[i.DATA_KEY].mutations=[]),e&&a(t.parent))},s=function(t){null!=t.domNode[i.DATA_KEY]&&null!=t.domNode[i.DATA_KEY].mutations&&(t instanceof o.default&&t.children.forEach(s),t.optimize(n))},u=e,c=0;u.length>0;c+=1){if(c>=100)throw new Error("[Parchment] Maximum optimize iterations reached");for(u.forEach(function(t){var e=i.find(t.target,!0);null!=e&&(e.domNode===t.target&&("childList"===t.type?(a(i.find(t.previousSibling,!1)),[].forEach.call(t.addedNodes,function(t){var e=i.find(t,!1);a(e,!1),e instanceof o.default&&e.children.forEach(function(t){a(t,!1)})})):"attributes"===t.type&&a(e.prev)),a(e))}),this.children.forEach(s),u=[].slice.call(this.observer.takeRecords()),l=u.slice();l.length>0;)e.push(l.pop())}},e.prototype.update=function(e,n){var r=this;void 0===n&&(n={}),e=e||this.observer.takeRecords(),e.map(function(t){var e=i.find(t.target,!0);return null==e?null:null==e.domNode[i.DATA_KEY].mutations?(e.domNode[i.DATA_KEY].mutations=[t],e):(e.domNode[i.DATA_KEY].mutations.push(t),null)}).forEach(function(t){null!=t&&t!==r&&null!=t.domNode[i.DATA_KEY]&&t.update(t.domNode[i.DATA_KEY].mutations||[],n)}),null!=this.domNode[i.DATA_KEY].mutations&&t.prototype.update.call(this,this.domNode[i.DATA_KEY].mutations,n),this.optimize(e,n)},e.blotName="scroll",e.defaultChild="block",e.scope=i.Scope.BLOCK_BLOT,e.tagName="DIV",e}(o.default);e.default=a},function(t,e,n){"use strict";function r(t,e){if(Object.keys(t).length!==Object.keys(e).length)return!1;for(var n in t)if(t[n]!==e[n])return!1;return!0}var o=this&&this.__extends||function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])};return function(e,n){function r(){this.constructor=e}t(e,n),e.prototype=null===n?Object.create(n):(r.prototype=n.prototype,new r)}}();Object.defineProperty(e,"__esModule",{value:!0});var i=n(18),l=n(1),a=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return o(e,t),e.formats=function(n){if(n.tagName!==e.tagName)return t.formats.call(this,n)},e.prototype.format=function(n,r){var o=this;n!==this.statics.blotName||r?t.prototype.format.call(this,n,r):(this.children.forEach(function(t){t instanceof i.default||(t=t.wrap(e.blotName,!0)),o.attributes.copy(t)}),this.unwrap())},e.prototype.formatAt=function(e,n,r,o){if(null!=this.formats()[r]||l.query(r,l.Scope.ATTRIBUTE)){this.isolate(e,n).format(r,o)}else t.prototype.formatAt.call(this,e,n,r,o)},e.prototype.optimize=function(n){t.prototype.optimize.call(this,n);var o=this.formats();if(0===Object.keys(o).length)return this.unwrap();var i=this.next;i instanceof e&&i.prev===this&&r(o,i.formats())&&(i.moveChildren(this),i.remove())},e.blotName="inline",e.scope=l.Scope.INLINE_BLOT,e.tagName="SPAN",e}(i.default);e.default=a},function(t,e,n){"use strict";var r=this&&this.__extends||function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])};return function(e,n){function r(){this.constructor=e}t(e,n),e.prototype=null===n?Object.create(n):(r.prototype=n.prototype,new r)}}();Object.defineProperty(e,"__esModule",{value:!0});var o=n(18),i=n(1),l=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return r(e,t),e.formats=function(n){var r=i.query(e.blotName).tagName;if(n.tagName!==r)return t.formats.call(this,n)},e.prototype.format=function(n,r){null!=i.query(n,i.Scope.BLOCK)&&(n!==this.statics.blotName||r?t.prototype.format.call(this,n,r):this.replaceWith(e.blotName))},e.prototype.formatAt=function(e,n,r,o){null!=i.query(r,i.Scope.BLOCK)?this.format(r,o):t.prototype.formatAt.call(this,e,n,r,o)},e.prototype.insertAt=function(e,n,r){if(null==r||null!=i.query(n,i.Scope.INLINE))t.prototype.insertAt.call(this,e,n,r);else{var o=this.split(e),l=i.create(n,r);o.parent.insertBefore(l,o)}},e.prototype.update=function(e,n){navigator.userAgent.match(/Trident/)?this.build():t.prototype.update.call(this,e,n)},e.blotName="block",e.scope=i.Scope.BLOCK_BLOT,e.tagName="P",e}(o.default);e.default=l},function(t,e,n){"use strict";var r=this&&this.__extends||function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])};return function(e,n){function r(){this.constructor=e}t(e,n),e.prototype=null===n?Object.create(n):(r.prototype=n.prototype,new r)}}();Object.defineProperty(e,"__esModule",{value:!0});var o=n(19),i=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return r(e,t),e.formats=function(t){},e.prototype.format=function(e,n){t.prototype.formatAt.call(this,0,this.length(),e,n)},e.prototype.formatAt=function(e,n,r,o){0===e&&n===this.length()?this.format(r,o):t.prototype.formatAt.call(this,e,n,r,o)},e.prototype.formats=function(){return this.statics.formats(this.domNode)},e}(o.default);e.default=i},function(t,e,n){"use strict";var r=this&&this.__extends||function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])};return function(e,n){function r(){this.constructor=e}t(e,n),e.prototype=null===n?Object.create(n):(r.prototype=n.prototype,new r)}}();Object.defineProperty(e,"__esModule",{value:!0});var o=n(19),i=n(1),l=function(t){function e(e){var n=t.call(this,e)||this;return n.text=n.statics.value(n.domNode),n}return r(e,t),e.create=function(t){return document.createTextNode(t)},e.value=function(t){var e=t.data;return e.normalize&&(e=e.normalize()),e},e.prototype.deleteAt=function(t,e){this.domNode.data=this.text=this.text.slice(0,t)+this.text.slice(t+e)},e.prototype.index=function(t,e){return this.domNode===t?e:-1},e.prototype.insertAt=function(e,n,r){null==r?(this.text=this.text.slice(0,e)+n+this.text.slice(e),this.domNode.data=this.text):t.prototype.insertAt.call(this,e,n,r)},e.prototype.length=function(){return this.text.length},e.prototype.optimize=function(n){t.prototype.optimize.call(this,n),this.text=this.statics.value(this.domNode),0===this.text.length?this.remove():this.next instanceof e&&this.next.prev===this&&(this.insertAt(this.length(),this.next.value()),this.next.remove())},e.prototype.position=function(t,e){return void 0===e&&(e=!1),[this.domNode,t]},e.prototype.split=function(t,e){if(void 0===e&&(e=!1),!e){if(0===t)return this;if(t===this.length())return this.next}var n=i.create(this.domNode.splitText(t));return this.parent.insertBefore(n,this.next),this.text=this.statics.value(this.domNode),n},e.prototype.update=function(t,e){var n=this;t.some(function(t){return"characterData"===t.type&&t.target===n.domNode})&&(this.text=this.statics.value(this.domNode))},e.prototype.value=function(){return this.text},e.blotName="text",e.scope=i.Scope.INLINE_BLOT,e}(o.default);e.default=l},function(t,e,n){"use strict";var r=document.createElement("div");if(r.classList.toggle("test-class",!1),r.classList.contains("test-class")){var o=DOMTokenList.prototype.toggle;DOMTokenList.prototype.toggle=function(t,e){return arguments.length>1&&!this.contains(t)==!e?e:o.call(this,t)}}String.prototype.startsWith||(String.prototype.startsWith=function(t,e){return e=e||0,this.substr(e,t.length)===t}),String.prototype.endsWith||(String.prototype.endsWith=function(t,e){var n=this.toString();("number"!=typeof e||!isFinite(e)||Math.floor(e)!==e||e>n.length)&&(e=n.length),e-=t.length;var r=n.indexOf(t,e);return-1!==r&&r===e}),Array.prototype.find||Object.defineProperty(Array.prototype,"find",{value:function(t){if(null===this)throw new TypeError("Array.prototype.find called on null or undefined");if("function"!=typeof t)throw new TypeError("predicate must be a function");for(var e,n=Object(this),r=n.length>>>0,o=arguments[1],i=0;i<r;i++)if(e=n[i],t.call(o,e,i,n))return e}}),document.addEventListener("DOMContentLoaded",function(){document.execCommand("enableObjectResizing",!1,!1),document.execCommand("autoUrlDetect",!1,!1)})},function(t,e){function n(t,e,n){if(t==e)return t?[[v,t]]:[];(n<0||t.length<n)&&(n=null);var o=l(t,e),i=t.substring(0,o);t=t.substring(o),e=e.substring(o),o=a(t,e);var s=t.substring(t.length-o);t=t.substring(0,t.length-o),e=e.substring(0,e.length-o);var c=r(t,e);return i&&c.unshift([v,i]),s&&c.push([v,s]),u(c),null!=n&&(c=f(c,n)),c=h(c)}function r(t,e){var r;if(!t)return[[y,e]];if(!e)return[[d,t]];var i=t.length>e.length?t:e,l=t.length>e.length?e:t,a=i.indexOf(l);if(-1!=a)return r=[[y,i.substring(0,a)],[v,l],[y,i.substring(a+l.length)]],t.length>e.length&&(r[0][0]=r[2][0]=d),r;if(1==l.length)return[[d,t],[y,e]];var u=s(t,e);if(u){var c=u[0],f=u[1],h=u[2],p=u[3],b=u[4],g=n(c,h),m=n(f,p);return g.concat([[v,b]],m)}return o(t,e)}function o(t,e){for(var n=t.length,r=e.length,o=Math.ceil((n+r)/2),l=o,a=2*o,s=new Array(a),u=new Array(a),c=0;c<a;c++)s[c]=-1,u[c]=-1;s[l+1]=0,u[l+1]=0;for(var f=n-r,h=f%2!=0,p=0,v=0,b=0,g=0,m=0;m<o;m++){for(var _=-m+p;_<=m-v;_+=2){var O,w=l+_;O=_==-m||_!=m&&s[w-1]<s[w+1]?s[w+1]:s[w-1]+1;for(var x=O-_;O<n&&x<r&&t.charAt(O)==e.charAt(x);)O++,x++;if(s[w]=O,O>n)v+=2;else if(x>r)p+=2;else if(h){var E=l+f-_;if(E>=0&&E<a&&-1!=u[E]){var k=n-u[E];if(O>=k)return i(t,e,O,x)}}}for(var A=-m+b;A<=m-g;A+=2){var k,E=l+A;k=A==-m||A!=m&&u[E-1]<u[E+1]?u[E+1]:u[E-1]+1;for(var j=k-A;k<n&&j<r&&t.charAt(n-k-1)==e.charAt(r-j-1);)k++,j++;if(u[E]=k,k>n)g+=2;else if(j>r)b+=2;else if(!h){var w=l+f-A;if(w>=0&&w<a&&-1!=s[w]){var O=s[w],x=l+O-w;if(k=n-k,O>=k)return i(t,e,O,x)}}}}return[[d,t],[y,e]]}function i(t,e,r,o){var i=t.substring(0,r),l=e.substring(0,o),a=t.substring(r),s=e.substring(o),u=n(i,l),c=n(a,s);return u.concat(c)}function l(t,e){if(!t||!e||t.charAt(0)!=e.charAt(0))return 0;for(var n=0,r=Math.min(t.length,e.length),o=r,i=0;n<o;)t.substring(i,o)==e.substring(i,o)?(n=o,i=n):r=o,o=Math.floor((r-n)/2+n);return o}function a(t,e){if(!t||!e||t.charAt(t.length-1)!=e.charAt(e.length-1))return 0;for(var n=0,r=Math.min(t.length,e.length),o=r,i=0;n<o;)t.substring(t.length-o,t.length-i)==e.substring(e.length-o,e.length-i)?(n=o,i=n):r=o,o=Math.floor((r-n)/2+n);return o}function s(t,e){function n(t,e,n){for(var r,o,i,s,u=t.substring(n,n+Math.floor(t.length/4)),c=-1,f="";-1!=(c=e.indexOf(u,c+1));){var h=l(t.substring(n),e.substring(c)),p=a(t.substring(0,n),e.substring(0,c));f.length<p+h&&(f=e.substring(c-p,c)+e.substring(c,c+h),r=t.substring(0,n-p),o=t.substring(n+h),i=e.substring(0,c-p),s=e.substring(c+h))}return 2*f.length>=t.length?[r,o,i,s,f]:null}var r=t.length>e.length?t:e,o=t.length>e.length?e:t;if(r.length<4||2*o.length<r.length)return null;var i,s=n(r,o,Math.ceil(r.length/4)),u=n(r,o,Math.ceil(r.length/2));if(!s&&!u)return null;i=u?s&&s[4].length>u[4].length?s:u:s;var c,f,h,p;return t.length>e.length?(c=i[0],f=i[1],h=i[2],p=i[3]):(h=i[0],p=i[1],c=i[2],f=i[3]),[c,f,h,p,i[4]]}function u(t){t.push([v,""]);for(var e,n=0,r=0,o=0,i="",s="";n<t.length;)switch(t[n][0]){case y:o++,s+=t[n][1],n++;break;case d:r++,i+=t[n][1],n++;break;case v:r+o>1?(0!==r&&0!==o&&(e=l(s,i),0!==e&&(n-r-o>0&&t[n-r-o-1][0]==v?t[n-r-o-1][1]+=s.substring(0,e):(t.splice(0,0,[v,s.substring(0,e)]),n++),s=s.substring(e),i=i.substring(e)),0!==(e=a(s,i))&&(t[n][1]=s.substring(s.length-e)+t[n][1],s=s.substring(0,s.length-e),i=i.substring(0,i.length-e))),0===r?t.splice(n-o,r+o,[y,s]):0===o?t.splice(n-r,r+o,[d,i]):t.splice(n-r-o,r+o,[d,i],[y,s]),n=n-r-o+(r?1:0)+(o?1:0)+1):0!==n&&t[n-1][0]==v?(t[n-1][1]+=t[n][1],t.splice(n,1)):n++,o=0,r=0,i="",s=""}""===t[t.length-1][1]&&t.pop();var c=!1;for(n=1;n<t.length-1;)t[n-1][0]==v&&t[n+1][0]==v&&(t[n][1].substring(t[n][1].length-t[n-1][1].length)==t[n-1][1]?(t[n][1]=t[n-1][1]+t[n][1].substring(0,t[n][1].length-t[n-1][1].length),t[n+1][1]=t[n-1][1]+t[n+1][1],t.splice(n-1,1),c=!0):t[n][1].substring(0,t[n+1][1].length)==t[n+1][1]&&(t[n-1][1]+=t[n+1][1],t[n][1]=t[n][1].substring(t[n+1][1].length)+t[n+1][1],t.splice(n+1,1),c=!0)),n++;c&&u(t)}function c(t,e){if(0===e)return[v,t];for(var n=0,r=0;r<t.length;r++){var o=t[r];if(o[0]===d||o[0]===v){var i=n+o[1].length;if(e===i)return[r+1,t];if(e<i){t=t.slice();var l=e-n,a=[o[0],o[1].slice(0,l)],s=[o[0],o[1].slice(l)];return t.splice(r,1,a,s),[r+1,t]}n=i}}throw new Error("cursor_pos is out of bounds!")}function f(t,e){var n=c(t,e),r=n[1],o=n[0],i=r[o],l=r[o+1];if(null==i)return t;if(i[0]!==v)return t;if(null!=l&&i[1]+l[1]===l[1]+i[1])return r.splice(o,2,l,i),p(r,o,2);if(null!=l&&0===l[1].indexOf(i[1])){r.splice(o,2,[l[0],i[1]],[0,i[1]]);var a=l[1].slice(i[1].length);return a.length>0&&r.splice(o+2,0,[l[0],a]),p(r,o,3)}return t}function h(t){for(var e=!1,n=function(t){return t.charCodeAt(0)>=56320&&t.charCodeAt(0)<=57343},r=2;r<t.length;r+=1)t[r-2][0]===v&&function(t){return t.charCodeAt(t.length-1)>=55296&&t.charCodeAt(t.length-1)<=56319}(t[r-2][1])&&t[r-1][0]===d&&n(t[r-1][1])&&t[r][0]===y&&n(t[r][1])&&(e=!0,t[r-1][1]=t[r-2][1].slice(-1)+t[r-1][1],t[r][1]=t[r-2][1].slice(-1)+t[r][1],t[r-2][1]=t[r-2][1].slice(0,-1));if(!e)return t;for(var o=[],r=0;r<t.length;r+=1)t[r][1].length>0&&o.push(t[r]);return o}function p(t,e,n){for(var r=e+n-1;r>=0&&r>=e-1;r--)if(r+1<t.length){var o=t[r],i=t[r+1];o[0]===i[1]&&t.splice(r,2,[o[0],o[1]+i[1]])}return t}var d=-1,y=1,v=0,b=n;b.INSERT=y,b.DELETE=d,b.EQUAL=v,t.exports=b},function(t,e){function n(t){var e=[];for(var n in t)e.push(n);return e}e=t.exports="function"==typeof Object.keys?Object.keys:n,e.shim=n},function(t,e){function n(t){return"[object Arguments]"==Object.prototype.toString.call(t)}function r(t){return t&&"object"==typeof t&&"number"==typeof t.length&&Object.prototype.hasOwnProperty.call(t,"callee")&&!Object.prototype.propertyIsEnumerable.call(t,"callee")||!1}var o="[object Arguments]"==function(){return Object.prototype.toString.call(arguments)}();e=t.exports=o?n:r,e.supported=n,e.unsupported=r},function(t,e){"use strict";function n(){}function r(t,e,n){this.fn=t,this.context=e,this.once=n||!1}function o(){this._events=new n,this._eventsCount=0}var i=Object.prototype.hasOwnProperty,l="~";Object.create&&(n.prototype=Object.create(null),(new n).__proto__||(l=!1)),o.prototype.eventNames=function(){var t,e,n=[];if(0===this._eventsCount)return n;for(e in t=this._events)i.call(t,e)&&n.push(l?e.slice(1):e);return Object.getOwnPropertySymbols?n.concat(Object.getOwnPropertySymbols(t)):n},o.prototype.listeners=function(t,e){var n=l?l+t:t,r=this._events[n];if(e)return!!r;if(!r)return[];if(r.fn)return[r.fn];for(var o=0,i=r.length,a=new Array(i);o<i;o++)a[o]=r[o].fn;return a},o.prototype.emit=function(t,e,n,r,o,i){var a=l?l+t:t;if(!this._events[a])return!1;var s,u,c=this._events[a],f=arguments.length;if(c.fn){switch(c.once&&this.removeListener(t,c.fn,void 0,!0),f){case 1:return c.fn.call(c.context),!0;case 2:return c.fn.call(c.context,e),!0;case 3:return c.fn.call(c.context,e,n),!0;case 4:return c.fn.call(c.context,e,n,r),!0;case 5:return c.fn.call(c.context,e,n,r,o),!0;case 6:return c.fn.call(c.context,e,n,r,o,i),!0}for(u=1,s=new Array(f-1);u<f;u++)s[u-1]=arguments[u];c.fn.apply(c.context,s)}else{var h,p=c.length;for(u=0;u<p;u++)switch(c[u].once&&this.removeListener(t,c[u].fn,void 0,!0),f){case 1:c[u].fn.call(c[u].context);break;case 2:c[u].fn.call(c[u].context,e);break;case 3:c[u].fn.call(c[u].context,e,n);break;case 4:c[u].fn.call(c[u].context,e,n,r);break;default:if(!s)for(h=1,s=new Array(f-1);h<f;h++)s[h-1]=arguments[h];c[u].fn.apply(c[u].context,s)}}return!0},o.prototype.on=function(t,e,n){var o=new r(e,n||this),i=l?l+t:t;return this._events[i]?this._events[i].fn?this._events[i]=[this._events[i],o]:this._events[i].push(o):(this._events[i]=o,this._eventsCount++),this},o.prototype.once=function(t,e,n){var o=new r(e,n||this,!0),i=l?l+t:t;return this._events[i]?this._events[i].fn?this._events[i]=[this._events[i],o]:this._events[i].push(o):(this._events[i]=o,this._eventsCount++),this},o.prototype.removeListener=function(t,e,r,o){var i=l?l+t:t;if(!this._events[i])return this;if(!e)return 0==--this._eventsCount?this._events=new n:delete this._events[i],this;var a=this._events[i];if(a.fn)a.fn!==e||o&&!a.once||r&&a.context!==r||(0==--this._eventsCount?this._events=new n:delete this._events[i]);else{for(var s=0,u=[],c=a.length;s<c;s++)(a[s].fn!==e||o&&!a[s].once||r&&a[s].context!==r)&&u.push(a[s]);u.length?this._events[i]=1===u.length?u[0]:u:0==--this._eventsCount?this._events=new n:delete this._events[i]}return this},o.prototype.removeAllListeners=function(t){var e;return t?(e=l?l+t:t,this._events[e]&&(0==--this._eventsCount?this._events=new n:delete this._events[e])):(this._events=new n,this._eventsCount=0),this},o.prototype.off=o.prototype.removeListener,o.prototype.addListener=o.prototype.on,o.prototype.setMaxListeners=function(){return this},o.prefixed=l,o.EventEmitter=o,void 0!==t&&(t.exports=o)},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function l(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function a(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}function s(t,e,n){return"object"===(void 0===e?"undefined":x(e))?Object.keys(e).reduce(function(t,n){return s(t,n,e[n])},t):t.reduce(function(t,r){return r.attributes&&r.attributes[e]?t.push(r):t.insert(r.insert,(0,j.default)({},o({},e,n),r.attributes))},new T.default)}function u(t){if(t.nodeType!==Node.ELEMENT_NODE)return{};return t["__ql-computed-style"]||(t["__ql-computed-style"]=window.getComputedStyle(t))}function c(t,e){for(var n="",r=t.ops.length-1;r>=0&&n.length<e.length;--r){var o=t.ops[r];if("string"!=typeof o.insert)break;n=o.insert+n}return n.slice(-1*e.length)===e}function f(t){return 0!==t.childNodes.length&&["block","list-item"].indexOf(u(t).display)>-1}function h(t,e,n){return t.nodeType===t.TEXT_NODE?n.reduce(function(e,n){return n(t,e)},new T.default):t.nodeType===t.ELEMENT_NODE?[].reduce.call(t.childNodes||[],function(r,o){var i=h(o,e,n);return o.nodeType===t.ELEMENT_NODE&&(i=e.reduce(function(t,e){return e(o,t)},i),i=(o[W]||[]).reduce(function(t,e){return e(o,t)},i)),r.concat(i)},new T.default):new T.default}function p(t,e,n){return s(n,t,!0)}function d(t,e){var n=P.default.Attributor.Attribute.keys(t),r=P.default.Attributor.Class.keys(t),o=P.default.Attributor.Style.keys(t),i={};return n.concat(r).concat(o).forEach(function(e){var n=P.default.query(e,P.default.Scope.ATTRIBUTE);null!=n&&(i[n.attrName]=n.value(t),i[n.attrName])||(n=G[e],null==n||n.attrName!==e&&n.keyName!==e||(i[n.attrName]=n.value(t)||void 0),null==(n=X[e])||n.attrName!==e&&n.keyName!==e||(n=X[e],i[n.attrName]=n.value(t)||void 0))}),Object.keys(i).length>0&&(e=s(e,i)),e}function y(t,e){var n=P.default.query(t);if(null==n)return e;if(n.prototype instanceof P.default.Embed){var r={},o=n.value(t);null!=o&&(r[n.blotName]=o,e=(new T.default).insert(r,n.formats(t)))}else"function"==typeof n.formats&&(e=s(e,n.blotName,n.formats(t)));return e}function v(t,e){return c(e,"\n")||e.insert("\n"),e}function b(){return new T.default}function g(t,e){var n=P.default.query(t);if(null==n||"list-item"!==n.blotName||!c(e,"\n"))return e;for(var r=-1,o=t.parentNode;!o.classList.contains("ql-clipboard");)"list"===(P.default.query(o)||{}).blotName&&(r+=1),o=o.parentNode;return r<=0?e:e.compose((new T.default).retain(e.length()-1).retain(1,{indent:r}))}function m(t,e){return c(e,"\n")||(f(t)||e.length()>0&&t.nextSibling&&f(t.nextSibling))&&e.insert("\n"),e}function _(t,e){if(f(t)&&null!=t.nextElementSibling&&!c(e,"\n\n")){var n=t.offsetHeight+parseFloat(u(t).marginTop)+parseFloat(u(t).marginBottom);t.nextElementSibling.offsetTop>t.offsetTop+1.5*n&&e.insert("\n")}return e}function O(t,e){var n={},r=t.style||{};return r.fontStyle&&"italic"===u(t).fontStyle&&(n.italic=!0),r.fontWeight&&(u(t).fontWeight.startsWith("bold")||parseInt(u(t).fontWeight)>=700)&&(n.bold=!0),Object.keys(n).length>0&&(e=s(e,n)),parseFloat(r.textIndent||0)>0&&(e=(new T.default).insert("\t").concat(e)),e}function w(t,e){var n=t.data;if("O:P"===t.parentNode.tagName)return e.insert(n.trim());if(0===n.trim().length&&t.parentNode.classList.contains("ql-clipboard"))return e;if(!u(t.parentNode).whiteSpace.startsWith("pre")){var r=function(t,e){return e=e.replace(/[^\u00a0]/g,""),e.length<1&&t?" ":e};n=n.replace(/\r\n/g," ").replace(/\n/g," "),n=n.replace(/\s\s+/g,r.bind(r,!0)),(null==t.previousSibling&&f(t.parentNode)||null!=t.previousSibling&&f(t.previousSibling))&&(n=n.replace(/^\s+/,r.bind(r,!1))),(null==t.nextSibling&&f(t.parentNode)||null!=t.nextSibling&&f(t.nextSibling))&&(n=n.replace(/\s+$/,r.bind(r,!1)))}return e.insert(n)}Object.defineProperty(e,"__esModule",{value:!0}),e.matchText=e.matchSpacing=e.matchNewline=e.matchBlot=e.matchAttributor=e.default=void 0;var x="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},E=function(){function t(t,e){var n=[],r=!0,o=!1,i=void 0;try{for(var l,a=t[Symbol.iterator]();!(r=(l=a.next()).done)&&(n.push(l.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t}finally{try{!r&&a.return&&a.return()}finally{if(o)throw i}}return n}return function(e,n){if(Array.isArray(e))return e;if(Symbol.iterator in Object(e))return t(e,n);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),k=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),A=n(3),j=r(A),N=n(2),T=r(N),S=n(0),P=r(S),q=n(5),C=r(q),L=n(10),R=r(L),M=n(9),B=r(M),I=n(36),D=n(37),U=n(13),F=r(U),z=n(26),H=n(38),K=n(39),Y=n(40),V=(0,R.default)("quill:clipboard"),W="__ql-matcher",Z=[[Node.TEXT_NODE,w],[Node.TEXT_NODE,m],["br",v],[Node.ELEMENT_NODE,m],[Node.ELEMENT_NODE,y],[Node.ELEMENT_NODE,_],[Node.ELEMENT_NODE,d],[Node.ELEMENT_NODE,O],["li",g],["b",p.bind(p,"bold")],["i",p.bind(p,"italic")],["style",b]],G=[I.AlignAttribute,H.DirectionAttribute].reduce(function(t,e){return t[e.keyName]=e,t},{}),X=[I.AlignStyle,D.BackgroundStyle,z.ColorStyle,H.DirectionStyle,K.FontStyle,Y.SizeStyle].reduce(function(t,e){return t[e.keyName]=e,t},{}),$=function(t){function e(t,n){i(this,e);var r=l(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));return r.quill.root.addEventListener("paste",r.onPaste.bind(r)),r.container=r.quill.addContainer("ql-clipboard"),r.container.setAttribute("contenteditable",!0),r.container.setAttribute("tabindex",-1),r.matchers=[],Z.concat(r.options.matchers).forEach(function(t){var e=E(t,2),o=e[0],i=e[1];(n.matchVisual||i!==_)&&r.addMatcher(o,i)}),r}return a(e,t),k(e,[{key:"addMatcher",value:function(t,e){this.matchers.push([t,e])}},{key:"convert",value:function(t){if("string"==typeof t)return this.container.innerHTML=t.replace(/\>\r?\n +\</g,"><"),this.convert();var e=this.quill.getFormat(this.quill.selection.savedRange.index);if(e[F.default.blotName]){var n=this.container.innerText;return this.container.innerHTML="",(new T.default).insert(n,o({},F.default.blotName,e[F.default.blotName]))}var r=this.prepareMatching(),i=E(r,2),l=i[0],a=i[1],s=h(this.container,l,a);return c(s,"\n")&&null==s.ops[s.ops.length-1].attributes&&(s=s.compose((new T.default).retain(s.length()-1).delete(1))),V.log("convert",this.container.innerHTML,s),this.container.innerHTML="",s}},{key:"dangerouslyPasteHTML",value:function(t,e){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:C.default.sources.API;if("string"==typeof t)this.quill.setContents(this.convert(t),e),this.quill.setSelection(0,C.default.sources.SILENT);else{var r=this.convert(e);this.quill.updateContents((new T.default).retain(t).concat(r),n),this.quill.setSelection(t+r.length(),C.default.sources.SILENT)}}},{key:"onPaste",value:function(t){var e=this;if(!t.defaultPrevented&&this.quill.isEnabled()){var n=this.quill.getSelection(),r=(new T.default).retain(n.index),o=this.quill.scrollingContainer.scrollTop;this.container.focus(),this.quill.selection.update(C.default.sources.SILENT),setTimeout(function(){r=r.concat(e.convert()).delete(n.length),e.quill.updateContents(r,C.default.sources.USER),e.quill.setSelection(r.length()-n.length,C.default.sources.SILENT),e.quill.scrollingContainer.scrollTop=o,e.quill.focus()},1)}}},{key:"prepareMatching",value:function(){var t=this,e=[],n=[];return this.matchers.forEach(function(r){var o=E(r,2),i=o[0],l=o[1];switch(i){case Node.TEXT_NODE:n.push(l);break;case Node.ELEMENT_NODE:e.push(l);break;default:[].forEach.call(t.container.querySelectorAll(i),function(t){t[W]=t[W]||[],t[W].push(l)})}}),[e,n]}}]),e}(B.default);$.DEFAULTS={matchers:[],matchVisual:!0},e.default=$,e.matchAttributor=d,e.matchBlot=y,e.matchNewline=m,e.matchSpacing=_,e.matchText=w},function(t,e,n){"use strict";function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function i(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var l=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),a=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},s=n(6),u=function(t){return t&&t.__esModule?t:{default:t}}(s),c=function(t){function e(){return r(this,e),o(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return i(e,t),l(e,[{key:"optimize",value:function(t){a(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"optimize",this).call(this,t),this.domNode.tagName!==this.statics.tagName[0]&&this.replaceWith(this.statics.blotName)}}],[{key:"create",value:function(){return a(e.__proto__||Object.getPrototypeOf(e),"create",this).call(this)}},{key:"formats",value:function(){return!0}}]),e}(u.default);c.blotName="bold",c.tagName=["STRONG","B"],e.default=c},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function l(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function a(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}function s(t,e,n){var r=document.createElement("button");r.setAttribute("type","button"),r.classList.add("ql-"+e),null!=n&&(r.value=n),t.appendChild(r)}function u(t,e){Array.isArray(e[0])||(e=[e]),e.forEach(function(e){var n=document.createElement("span");n.classList.add("ql-formats"),e.forEach(function(t){if("string"==typeof t)s(n,t);else{var e=Object.keys(t)[0],r=t[e];Array.isArray(r)?c(n,e,r):s(n,e,r)}}),t.appendChild(n)})}function c(t,e,n){var r=document.createElement("select");r.classList.add("ql-"+e),n.forEach(function(t){var e=document.createElement("option");!1!==t?e.setAttribute("value",t):e.setAttribute("selected","selected"),r.appendChild(e)}),t.appendChild(r)}Object.defineProperty(e,"__esModule",{value:!0}),e.addControls=e.default=void 0;var f=function(){function t(t,e){var n=[],r=!0,o=!1,i=void 0;try{for(var l,a=t[Symbol.iterator]();!(r=(l=a.next()).done)&&(n.push(l.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t}finally{try{!r&&a.return&&a.return()}finally{if(o)throw i}}return n}return function(e,n){if(Array.isArray(e))return e;if(Symbol.iterator in Object(e))return t(e,n);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),h=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),p=n(2),d=r(p),y=n(0),v=r(y),b=n(5),g=r(b),m=n(10),_=r(m),O=n(9),w=r(O),x=(0,_.default)("quill:toolbar"),E=function(t){function e(t,n){i(this,e);var r=l(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));if(Array.isArray(r.options.container)){var o=document.createElement("div");u(o,r.options.container),t.container.parentNode.insertBefore(o,t.container),r.container=o}else"string"==typeof r.options.container?r.container=document.querySelector(r.options.container):r.container=r.options.container;if(!(r.container instanceof HTMLElement)){var a;return a=x.error("Container required for toolbar",r.options),l(r,a)}return r.container.classList.add("ql-toolbar"),r.controls=[],r.handlers={},Object.keys(r.options.handlers).forEach(function(t){r.addHandler(t,r.options.handlers[t])}),[].forEach.call(r.container.querySelectorAll("button, select"),function(t){r.attach(t)}),r.quill.on(g.default.events.EDITOR_CHANGE,function(t,e){t===g.default.events.SELECTION_CHANGE&&r.update(e)}),r.quill.on(g.default.events.SCROLL_OPTIMIZE,function(){var t=r.quill.selection.getRange(),e=f(t,1),n=e[0];r.update(n)}),r}return a(e,t),h(e,[{key:"addHandler",value:function(t,e){this.handlers[t]=e}},{key:"attach",value:function(t){var e=this,n=[].find.call(t.classList,function(t){return 0===t.indexOf("ql-")});if(n){if(n=n.slice("ql-".length),"BUTTON"===t.tagName&&t.setAttribute("type","button"),null==this.handlers[n]){if(null!=this.quill.scroll.whitelist&&null==this.quill.scroll.whitelist[n])return void x.warn("ignoring attaching to disabled format",n,t);if(null==v.default.query(n))return void x.warn("ignoring attaching to nonexistent format",n,t)}var r="SELECT"===t.tagName?"change":"click";t.addEventListener(r,function(r){var i=void 0;if("SELECT"===t.tagName){if(t.selectedIndex<0)return;var l=t.options[t.selectedIndex];i=!l.hasAttribute("selected")&&(l.value||!1)}else i=!t.classList.contains("ql-active")&&(t.value||!t.hasAttribute("value")),r.preventDefault();e.quill.focus();var a=e.quill.selection.getRange(),s=f(a,1),u=s[0];if(null!=e.handlers[n])e.handlers[n].call(e,i);else if(v.default.query(n).prototype instanceof v.default.Embed){if(!(i=prompt("Enter "+n)))return;e.quill.updateContents((new d.default).retain(u.index).delete(u.length).insert(o({},n,i)),g.default.sources.USER)}else e.quill.format(n,i,g.default.sources.USER);e.update(u)}),this.controls.push([n,t])}}},{key:"update",value:function(t){var e=null==t?{}:this.quill.getFormat(t);this.controls.forEach(function(n){var r=f(n,2),o=r[0],i=r[1];if("SELECT"===i.tagName){var l=void 0;if(null==t)l=null;else if(null==e[o])l=i.querySelector("option[selected]");else if(!Array.isArray(e[o])){var a=e[o];"string"==typeof a&&(a=a.replace(/\"/g,'\\"')),l=i.querySelector('option[value="'+a+'"]')}null==l?(i.value="",i.selectedIndex=-1):l.selected=!0}else if(null==t)i.classList.remove("ql-active");else if(i.hasAttribute("value")){var s=e[o]===i.getAttribute("value")||null!=e[o]&&e[o].toString()===i.getAttribute("value")||null==e[o]&&!i.getAttribute("value");i.classList.toggle("ql-active",s)}else i.classList.toggle("ql-active",null!=e[o])})}}]),e}(w.default);E.DEFAULTS={},E.DEFAULTS={container:null,handlers:{clean:function(){var t=this,e=this.quill.getSelection();if(null!=e)if(0==e.length){var n=this.quill.getFormat();Object.keys(n).forEach(function(e){null!=v.default.query(e,v.default.Scope.INLINE)&&t.quill.format(e,!1)})}else this.quill.removeFormat(e,g.default.sources.USER)},direction:function(t){var e=this.quill.getFormat().align;"rtl"===t&&null==e?this.quill.format("align","right",g.default.sources.USER):t||"right"!==e||this.quill.format("align",!1,g.default.sources.USER),this.quill.format("direction",t,g.default.sources.USER)},indent:function(t){var e=this.quill.getSelection(),n=this.quill.getFormat(e),r=parseInt(n.indent||0);if("+1"===t||"-1"===t){var o="+1"===t?1:-1;"rtl"===n.direction&&(o*=-1),this.quill.format("indent",r+o,g.default.sources.USER)}},link:function(t){!0===t&&(t=prompt("Enter link URL:")),this.quill.format("link",t,g.default.sources.USER)},list:function(t){var e=this.quill.getSelection(),n=this.quill.getFormat(e);"check"===t?"checked"===n.list||"unchecked"===n.list?this.quill.format("list",!1,g.default.sources.USER):this.quill.format("list","unchecked",g.default.sources.USER):this.quill.format("list",t,g.default.sources.USER)}}},e.default=E,e.addControls=u},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <polyline class="ql-even ql-stroke" points="5 7 3 9 5 11"></polyline> <polyline class="ql-even ql-stroke" points="13 7 15 9 13 11"></polyline> <line class=ql-stroke x1=10 x2=8 y1=5 y2=13></line> </svg>'},function(t,e,n){"use strict";function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function i(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var l=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),a=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},s=n(28),u=function(t){return t&&t.__esModule?t:{default:t}}(s),c=function(t){function e(t,n){r(this,e);var i=o(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t));return i.label.innerHTML=n,i.container.classList.add("ql-color-picker"),[].slice.call(i.container.querySelectorAll(".ql-picker-item"),0,7).forEach(function(t){t.classList.add("ql-primary")}),i}return i(e,t),l(e,[{key:"buildItem",value:function(t){var n=a(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"buildItem",this).call(this,t);return n.style.backgroundColor=t.getAttribute("value")||"",n}},{key:"selectItem",value:function(t,n){a(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"selectItem",this).call(this,t,n);var r=this.label.querySelector(".ql-color-label"),o=t?t.getAttribute("data-value")||"":"";r&&("line"===r.tagName?r.style.stroke=o:r.style.fill=o)}}]),e}(u.default);e.default=c},function(t,e,n){"use strict";function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function i(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var l=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),a=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},s=n(28),u=function(t){return t&&t.__esModule?t:{default:t}}(s),c=function(t){function e(t,n){r(this,e);var i=o(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t));return i.container.classList.add("ql-icon-picker"),[].forEach.call(i.container.querySelectorAll(".ql-picker-item"),function(t){t.innerHTML=n[t.getAttribute("data-value")||""]}),i.defaultItem=i.container.querySelector(".ql-selected"),i.selectItem(i.defaultItem),i}return i(e,t),l(e,[{key:"selectItem",value:function(t,n){a(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"selectItem",this).call(this,t,n),t=t||this.defaultItem,this.label.innerHTML=t.innerHTML}}]),e}(u.default);e.default=c},function(t,e,n){"use strict";function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var o=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),i=function(){function t(e,n){var o=this;r(this,t),this.quill=e,this.boundsContainer=n||document.body,this.root=e.addContainer("ql-tooltip"),this.root.innerHTML=this.constructor.TEMPLATE,this.quill.root===this.quill.scrollingContainer&&this.quill.root.addEventListener("scroll",function(){o.root.style.marginTop=-1*o.quill.root.scrollTop+"px"}),this.hide()}return o(t,[{key:"hide",value:function(){this.root.classList.add("ql-hidden")}},{key:"position",value:function(t){var e=t.left+t.width/2-this.root.offsetWidth/2,n=t.bottom+this.quill.root.scrollTop;this.root.style.left=e+"px",this.root.style.top=n+"px",this.root.classList.remove("ql-flip");var r=this.boundsContainer.getBoundingClientRect(),o=this.root.getBoundingClientRect(),i=0;if(o.right>r.right&&(i=r.right-o.right,this.root.style.left=e+i+"px"),o.left<r.left&&(i=r.left-o.left,this.root.style.left=e+i+"px"),o.bottom>r.bottom){var l=o.bottom-o.top,a=t.bottom-t.top+l;this.root.style.top=n-a+"px",this.root.classList.add("ql-flip")}return i}},{key:"show",value:function(){this.root.classList.remove("ql-editing"),this.root.classList.remove("ql-hidden")}}]),t}();e.default=i},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function l(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var a=function(){function t(t,e){var n=[],r=!0,o=!1,i=void 0;try{for(var l,a=t[Symbol.iterator]();!(r=(l=a.next()).done)&&(n.push(l.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t}finally{try{!r&&a.return&&a.return()}finally{if(o)throw i}}return n}return function(e,n){if(Array.isArray(e))return e;if(Symbol.iterator in Object(e))return t(e,n);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),s=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},u=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),c=n(3),f=r(c),h=n(8),p=r(h),d=n(43),y=r(d),v=n(27),b=r(v),g=n(15),m=n(41),_=r(m),O=[[{header:["1","2","3",!1]}],["bold","italic","underline","link"],[{list:"ordered"},{list:"bullet"}],["clean"]],w=function(t){function e(t,n){o(this,e),null!=n.modules.toolbar&&null==n.modules.toolbar.container&&(n.modules.toolbar.container=O);var r=i(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));return r.quill.container.classList.add("ql-snow"),r}return l(e,t),u(e,[{key:"extendToolbar",value:function(t){t.container.classList.add("ql-snow"),this.buildButtons([].slice.call(t.container.querySelectorAll("button")),_.default),this.buildPickers([].slice.call(t.container.querySelectorAll("select")),_.default),this.tooltip=new x(this.quill,this.options.bounds),t.container.querySelector(".ql-link")&&this.quill.keyboard.addBinding({key:"K",shortKey:!0},function(e,n){t.handlers.link.call(t,!n.format.link)})}}]),e}(y.default);w.DEFAULTS=(0,f.default)(!0,{},y.default.DEFAULTS,{modules:{toolbar:{handlers:{link:function(t){if(t){var e=this.quill.getSelection();if(null==e||0==e.length)return;var n=this.quill.getText(e);/^\S+@\S+\.\S+$/.test(n)&&0!==n.indexOf("mailto:")&&(n="mailto:"+n);this.quill.theme.tooltip.edit("link",n)}else this.quill.format("link",!1)}}}}});var x=function(t){function e(t,n){o(this,e);var r=i(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));return r.preview=r.root.querySelector("a.ql-preview"),r}return l(e,t),u(e,[{key:"listen",value:function(){var t=this;s(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"listen",this).call(this),this.root.querySelector("a.ql-action").addEventListener("click",function(e){t.root.classList.contains("ql-editing")?t.save():t.edit("link",t.preview.textContent),e.preventDefault()}),this.root.querySelector("a.ql-remove").addEventListener("click",function(e){if(null!=t.linkRange){var n=t.linkRange;t.restoreFocus(),t.quill.formatText(n,"link",!1,p.default.sources.USER),delete t.linkRange}e.preventDefault(),t.hide()}),this.quill.on(p.default.events.SELECTION_CHANGE,function(e,n,r){if(null!=e){if(0===e.length&&r===p.default.sources.USER){var o=t.quill.scroll.descendant(b.default,e.index),i=a(o,2),l=i[0],s=i[1];if(null!=l){t.linkRange=new g.Range(e.index-s,l.length());var u=b.default.formats(l.domNode);return t.preview.textContent=u,t.preview.setAttribute("href",u),t.show(),void t.position(t.quill.getBounds(t.linkRange))}}else delete t.linkRange;t.hide()}})}},{key:"show",value:function(){s(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"show",this).call(this),this.root.removeAttribute("data-mode")}}]),e}(d.BaseTooltip);x.TEMPLATE=['<a class="ql-preview" target="_blank" href="about:blank"></a>','<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">','<a class="ql-action"></a>','<a class="ql-remove"></a>'].join(""),e.default=w},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0});var o=n(29),i=r(o),l=n(36),a=n(38),s=n(64),u=n(65),c=r(u),f=n(66),h=r(f),p=n(67),d=r(p),y=n(37),v=n(26),b=n(39),g=n(40),m=n(56),_=r(m),O=n(68),w=r(O),x=n(27),E=r(x),k=n(69),A=r(k),j=n(70),N=r(j),T=n(71),S=r(T),P=n(72),q=r(P),C=n(73),L=r(C),R=n(13),M=r(R),B=n(74),I=r(B),D=n(75),U=r(D),F=n(57),z=r(F),H=n(41),K=r(H),Y=n(28),V=r(Y),W=n(59),Z=r(W),G=n(60),X=r(G),$=n(61),Q=r($),J=n(108),tt=r(J),et=n(62),nt=r(et);i.default.register({"attributors/attribute/direction":a.DirectionAttribute,"attributors/class/align":l.AlignClass,"attributors/class/background":y.BackgroundClass,"attributors/class/color":v.ColorClass,"attributors/class/direction":a.DirectionClass,"attributors/class/font":b.FontClass,"attributors/class/size":g.SizeClass,"attributors/style/align":l.AlignStyle,"attributors/style/background":y.BackgroundStyle,"attributors/style/color":v.ColorStyle,"attributors/style/direction":a.DirectionStyle,"attributors/style/font":b.FontStyle,"attributors/style/size":g.SizeStyle},!0),i.default.register({"formats/align":l.AlignClass,"formats/direction":a.DirectionClass,"formats/indent":s.IndentClass,"formats/background":y.BackgroundStyle,"formats/color":v.ColorStyle,"formats/font":b.FontClass,"formats/size":g.SizeClass,"formats/blockquote":c.default,"formats/code-block":M.default,"formats/header":h.default,"formats/list":d.default,"formats/bold":_.default,"formats/code":R.Code,"formats/italic":w.default,"formats/link":E.default,"formats/script":A.default,"formats/strike":N.default,"formats/underline":S.default,"formats/image":q.default,"formats/video":L.default,"formats/list/item":p.ListItem,"modules/formula":I.default,"modules/syntax":U.default,"modules/toolbar":z.default,"themes/bubble":tt.default,"themes/snow":nt.default,"ui/icons":K.default,"ui/picker":V.default,"ui/icon-picker":X.default,"ui/color-picker":Z.default,"ui/tooltip":Q.default},!0),e.default=i.default},function(t,e,n){"use strict";function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function i(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0}),e.IndentClass=void 0;var l=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),a=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},s=n(0),u=function(t){return t&&t.__esModule?t:{default:t}}(s),c=function(t){function e(){return r(this,e),o(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return i(e,t),l(e,[{key:"add",value:function(t,n){if("+1"===n||"-1"===n){var r=this.value(t)||0;n="+1"===n?r+1:r-1}return 0===n?(this.remove(t),!0):a(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"add",this).call(this,t,n)}},{key:"canAdd",value:function(t,n){return a(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"canAdd",this).call(this,t,n)||a(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"canAdd",this).call(this,t,parseInt(n))}},{key:"value",value:function(t){return parseInt(a(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"value",this).call(this,t))||void 0}}]),e}(u.default.Attributor.Class),f=new c("indent","ql-indent",{scope:u.default.Scope.BLOCK,whitelist:[1,2,3,4,5,6,7,8]});e.IndentClass=f},function(t,e,n){"use strict";function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function i(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var l=n(4),a=function(t){return t&&t.__esModule?t:{default:t}}(l),s=function(t){function e(){return r(this,e),o(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return i(e,t),e}(a.default);s.blotName="blockquote",s.tagName="blockquote",e.default=s},function(t,e,n){"use strict";function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function i(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var l=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),a=n(4),s=function(t){return t&&t.__esModule?t:{default:t}}(a),u=function(t){function e(){return r(this,e),o(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return i(e,t),l(e,null,[{key:"formats",value:function(t){return this.tagName.indexOf(t.tagName)+1}}]),e}(s.default);u.blotName="header",u.tagName=["H1","H2","H3","H4","H5","H6"],e.default=u},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function l(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function a(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=e.ListItem=void 0;var s=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),u=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},c=n(0),f=r(c),h=n(4),p=r(h),d=n(25),y=r(d),v=function(t){function e(){return i(this,e),l(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return a(e,t),s(e,[{key:"format",value:function(t,n){t!==b.blotName||n?u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"format",this).call(this,t,n):this.replaceWith(f.default.create(this.statics.scope))}},{key:"remove",value:function(){null==this.prev&&null==this.next?this.parent.remove():u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"remove",this).call(this)}},{key:"replaceWith",value:function(t,n){return this.parent.isolate(this.offset(this.parent),this.length()),t===this.parent.statics.blotName?(this.parent.replaceWith(t,n),this):(this.parent.unwrap(),u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"replaceWith",this).call(this,t,n))}}],[{key:"formats",value:function(t){return t.tagName===this.tagName?void 0:u(e.__proto__||Object.getPrototypeOf(e),"formats",this).call(this,t)}}]),e}(p.default);v.blotName="list-item",v.tagName="LI";var b=function(t){function e(t){i(this,e);var n=l(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t)),r=function(e){if(e.target.parentNode===t){var r=n.statics.formats(t),o=f.default.find(e.target);"checked"===r?o.format("list","unchecked"):"unchecked"===r&&o.format("list","checked")}};return t.addEventListener("touchstart",r),t.addEventListener("mousedown",r),n}return a(e,t),s(e,null,[{key:"create",value:function(t){var n="ordered"===t?"OL":"UL",r=u(e.__proto__||Object.getPrototypeOf(e),"create",this).call(this,n);return"checked"!==t&&"unchecked"!==t||r.setAttribute("data-checked","checked"===t),r}},{key:"formats",value:function(t){return"OL"===t.tagName?"ordered":"UL"===t.tagName?t.hasAttribute("data-checked")?"true"===t.getAttribute("data-checked")?"checked":"unchecked":"bullet":void 0}}]),s(e,[{key:"format",value:function(t,e){this.children.length>0&&this.children.tail.format(t,e)}},{key:"formats",value:function(){return o({},this.statics.blotName,this.statics.formats(this.domNode))}},{key:"insertBefore",value:function(t,n){if(t instanceof v)u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"insertBefore",this).call(this,t,n);else{var r=null==n?this.length():n.offset(this),o=this.split(r);o.parent.insertBefore(t,o)}}},{key:"optimize",value:function(t){u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"optimize",this).call(this,t);var n=this.next;null!=n&&n.prev===this&&n.statics.blotName===this.statics.blotName&&n.domNode.tagName===this.domNode.tagName&&n.domNode.getAttribute("data-checked")===this.domNode.getAttribute("data-checked")&&(n.moveChildren(this),n.remove())}},{key:"replace",value:function(t){if(t.statics.blotName!==this.statics.blotName){var n=f.default.create(this.statics.defaultChild);t.moveChildren(n),this.appendChild(n)}u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"replace",this).call(this,t)}}]),e}(y.default);b.blotName="list",b.scope=f.default.Scope.BLOCK_BLOT,b.tagName=["OL","UL"],b.defaultChild="list-item",b.allowedChildren=[v],e.ListItem=v,e.default=b},function(t,e,n){"use strict";function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function i(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var l=n(56),a=function(t){return t&&t.__esModule?t:{default:t}}(l),s=function(t){function e(){return r(this,e),o(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return i(e,t),e}(a.default);s.blotName="italic",s.tagName=["EM","I"],e.default=s},function(t,e,n){"use strict";function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function i(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var l=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),a=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},s=n(6),u=function(t){return t&&t.__esModule?t:{default:t}}(s),c=function(t){function e(){return r(this,e),o(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return i(e,t),l(e,null,[{key:"create",value:function(t){return"super"===t?document.createElement("sup"):"sub"===t?document.createElement("sub"):a(e.__proto__||Object.getPrototypeOf(e),"create",this).call(this,t)}},{key:"formats",value:function(t){return"SUB"===t.tagName?"sub":"SUP"===t.tagName?"super":void 0}}]),e}(u.default);c.blotName="script",c.tagName=["SUB","SUP"],e.default=c},function(t,e,n){"use strict";function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function i(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var l=n(6),a=function(t){return t&&t.__esModule?t:{default:t}}(l),s=function(t){function e(){return r(this,e),o(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return i(e,t),e}(a.default);s.blotName="strike",s.tagName="S",e.default=s},function(t,e,n){"use strict";function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function i(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var l=n(6),a=function(t){return t&&t.__esModule?t:{default:t}}(l),s=function(t){function e(){return r(this,e),o(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return i(e,t),e}(a.default);s.blotName="underline",s.tagName="U",e.default=s},function(t,e,n){"use strict";function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function i(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var l=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),a=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},s=n(0),u=function(t){return t&&t.__esModule?t:{default:t}}(s),c=n(27),f=["alt","height","width"],h=function(t){function e(){return r(this,e),o(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return i(e,t),l(e,[{key:"format",value:function(t,n){f.indexOf(t)>-1?n?this.domNode.setAttribute(t,n):this.domNode.removeAttribute(t):a(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"format",this).call(this,t,n)}}],[{key:"create",value:function(t){var n=a(e.__proto__||Object.getPrototypeOf(e),"create",this).call(this,t);return"string"==typeof t&&n.setAttribute("src",this.sanitize(t)),n}},{key:"formats",value:function(t){return f.reduce(function(e,n){return t.hasAttribute(n)&&(e[n]=t.getAttribute(n)),e},{})}},{key:"match",value:function(t){return/\.(jpe?g|gif|png)$/.test(t)||/^data:image\/.+;base64/.test(t)}},{key:"sanitize",value:function(t){return(0,c.sanitize)(t,["http","https","data"])?t:"//:0"}},{key:"value",value:function(t){return t.getAttribute("src")}}]),e}(u.default.Embed);h.blotName="image",h.tagName="IMG",e.default=h},function(t,e,n){"use strict";function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function i(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var l=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),a=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},s=n(4),u=n(27),c=function(t){return t&&t.__esModule?t:{default:t}}(u),f=["height","width"],h=function(t){function e(){return r(this,e),o(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return i(e,t),l(e,[{key:"format",value:function(t,n){f.indexOf(t)>-1?n?this.domNode.setAttribute(t,n):this.domNode.removeAttribute(t):a(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"format",this).call(this,t,n)}}],[{key:"create",value:function(t){var n=a(e.__proto__||Object.getPrototypeOf(e),"create",this).call(this,t);return n.setAttribute("frameborder","0"),n.setAttribute("allowfullscreen",!0),n.setAttribute("src",this.sanitize(t)),n}},{key:"formats",value:function(t){return f.reduce(function(e,n){return t.hasAttribute(n)&&(e[n]=t.getAttribute(n)),e},{})}},{key:"sanitize",value:function(t){return c.default.sanitize(t)}},{key:"value",value:function(t){return t.getAttribute("src")}}]),e}(s.BlockEmbed);h.blotName="video",h.className="ql-video",h.tagName="IFRAME",e.default=h},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function l(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=e.FormulaBlot=void 0;var a=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),s=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},u=n(35),c=r(u),f=n(5),h=r(f),p=n(9),d=r(p),y=function(t){function e(){return o(this,e),i(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return l(e,t),a(e,null,[{key:"create",value:function(t){var n=s(e.__proto__||Object.getPrototypeOf(e),"create",this).call(this,t);return"string"==typeof t&&(window.katex.render(t,n,{throwOnError:!1,errorColor:"#f00"}),n.setAttribute("data-value",t)),n}},{key:"value",value:function(t){return t.getAttribute("data-value")}}]),e}(c.default);y.blotName="formula",y.className="ql-formula",y.tagName="SPAN";var v=function(t){function e(){o(this,e);var t=i(this,(e.__proto__||Object.getPrototypeOf(e)).call(this));if(null==window.katex)throw new Error("Formula module requires KaTeX.");return t}return l(e,t),a(e,null,[{key:"register",value:function(){h.default.register(y,!0)}}]),e}(d.default);e.FormulaBlot=y,e.default=v},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function l(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=e.CodeToken=e.CodeBlock=void 0;var a=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),s=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},u=n(0),c=r(u),f=n(5),h=r(f),p=n(9),d=r(p),y=n(13),v=r(y),b=function(t){function e(){return o(this,e),i(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return l(e,t),a(e,[{key:"replaceWith",value:function(t){this.domNode.textContent=this.domNode.textContent,this.attach(),s(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"replaceWith",this).call(this,t)}},{key:"highlight",value:function(t){var e=this.domNode.textContent;this.cachedText!==e&&((e.trim().length>0||null==this.cachedText)&&(this.domNode.innerHTML=t(e),this.domNode.normalize(),this.attach()),this.cachedText=e)}}]),e}(v.default);b.className="ql-syntax";var g=new c.default.Attributor.Class("token","hljs",{scope:c.default.Scope.INLINE}),m=function(t){function e(t,n){o(this,e);var r=i(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));if("function"!=typeof r.options.highlight)throw new Error("Syntax module requires highlight.js. Please include the library on the page before Quill.");var l=null;return r.quill.on(h.default.events.SCROLL_OPTIMIZE,function(){clearTimeout(l),l=setTimeout(function(){r.highlight(),l=null},r.options.interval)}),r.highlight(),r}return l(e,t),a(e,null,[{key:"register",value:function(){h.default.register(g,!0),h.default.register(b,!0)}}]),a(e,[{key:"highlight",value:function(){var t=this;if(!this.quill.selection.composing){this.quill.update(h.default.sources.USER);var e=this.quill.getSelection();this.quill.scroll.descendants(b).forEach(function(e){e.highlight(t.options.highlight)}),this.quill.update(h.default.sources.SILENT),null!=e&&this.quill.setSelection(e,h.default.sources.SILENT)}}}]),e}(d.default);m.DEFAULTS={highlight:function(){return null==window.hljs?null:function(t){return window.hljs.highlightAuto(t).value}}(),interval:1e3},e.CodeBlock=b,e.CodeToken=g,e.default=m},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=3 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=13 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=9 y1=4 y2=4></line> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=14 x2=4 y1=14 y2=14></line> <line class=ql-stroke x1=12 x2=6 y1=4 y2=4></line> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=5 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=9 y1=4 y2=4></line> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=3 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=3 y1=4 y2=4></line> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <g class="ql-fill ql-color-label"> <polygon points="6 6.868 6 6 5 6 5 7 5.942 7 6 6.868"></polygon> <rect height=1 width=1 x=4 y=4></rect> <polygon points="6.817 5 6 5 6 6 6.38 6 6.817 5"></polygon> <rect height=1 width=1 x=2 y=6></rect> <rect height=1 width=1 x=3 y=5></rect> <rect height=1 width=1 x=4 y=7></rect> <polygon points="4 11.439 4 11 3 11 3 12 3.755 12 4 11.439"></polygon> <rect height=1 width=1 x=2 y=12></rect> <rect height=1 width=1 x=2 y=9></rect> <rect height=1 width=1 x=2 y=15></rect> <polygon points="4.63 10 4 10 4 11 4.192 11 4.63 10"></polygon> <rect height=1 width=1 x=3 y=8></rect> <path d=M10.832,4.2L11,4.582V4H10.708A1.948,1.948,0,0,1,10.832,4.2Z></path> <path d=M7,4.582L7.168,4.2A1.929,1.929,0,0,1,7.292,4H7V4.582Z></path> <path d=M8,13H7.683l-0.351.8a1.933,1.933,0,0,1-.124.2H8V13Z></path> <rect height=1 width=1 x=12 y=2></rect> <rect height=1 width=1 x=11 y=3></rect> <path d=M9,3H8V3.282A1.985,1.985,0,0,1,9,3Z></path> <rect height=1 width=1 x=2 y=3></rect> <rect height=1 width=1 x=6 y=2></rect> <rect height=1 width=1 x=3 y=2></rect> <rect height=1 width=1 x=5 y=3></rect> <rect height=1 width=1 x=9 y=2></rect> <rect height=1 width=1 x=15 y=14></rect> <polygon points="13.447 10.174 13.469 10.225 13.472 10.232 13.808 11 14 11 14 10 13.37 10 13.447 10.174"></polygon> <rect height=1 width=1 x=13 y=7></rect> <rect height=1 width=1 x=15 y=5></rect> <rect height=1 width=1 x=14 y=6></rect> <rect height=1 width=1 x=15 y=8></rect> <rect height=1 width=1 x=14 y=9></rect> <path d=M3.775,14H3v1H4V14.314A1.97,1.97,0,0,1,3.775,14Z></path> <rect height=1 width=1 x=14 y=3></rect> <polygon points="12 6.868 12 6 11.62 6 12 6.868"></polygon> <rect height=1 width=1 x=15 y=2></rect> <rect height=1 width=1 x=12 y=5></rect> <rect height=1 width=1 x=13 y=4></rect> <polygon points="12.933 9 13 9 13 8 12.495 8 12.933 9"></polygon> <rect height=1 width=1 x=9 y=14></rect> <rect height=1 width=1 x=8 y=15></rect> <path d=M6,14.926V15H7V14.316A1.993,1.993,0,0,1,6,14.926Z></path> <rect height=1 width=1 x=5 y=15></rect> <path d=M10.668,13.8L10.317,13H10v1h0.792A1.947,1.947,0,0,1,10.668,13.8Z></path> <rect height=1 width=1 x=11 y=15></rect> <path d=M14.332,12.2a1.99,1.99,0,0,1,.166.8H15V12H14.245Z></path> <rect height=1 width=1 x=14 y=15></rect> <rect height=1 width=1 x=15 y=11></rect> </g> <polyline class=ql-stroke points="5.5 13 9 5 12.5 13"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=11 y2=11></line> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <rect class="ql-fill ql-stroke" height=3 width=3 x=4 y=5></rect> <rect class="ql-fill ql-stroke" height=3 width=3 x=11 y=5></rect> <path class="ql-even ql-fill ql-stroke" d=M7,8c0,4.031-3,5-3,5></path> <path class="ql-even ql-fill ql-stroke" d=M14,8c0,4.031-3,5-3,5></path> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <path class=ql-stroke d=M5,4H9.5A2.5,2.5,0,0,1,12,6.5v0A2.5,2.5,0,0,1,9.5,9H5A0,0,0,0,1,5,9V4A0,0,0,0,1,5,4Z></path> <path class=ql-stroke d=M5,9h5.5A2.5,2.5,0,0,1,13,11.5v0A2.5,2.5,0,0,1,10.5,14H5a0,0,0,0,1,0,0V9A0,0,0,0,1,5,9Z></path> </svg>'},function(t,e){t.exports='<svg class="" viewbox="0 0 18 18"> <line class=ql-stroke x1=5 x2=13 y1=3 y2=3></line> <line class=ql-stroke x1=6 x2=9.35 y1=12 y2=3></line> <line class=ql-stroke x1=11 x2=15 y1=11 y2=15></line> <line class=ql-stroke x1=15 x2=11 y1=11 y2=15></line> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=7 x=2 y=14></rect> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <line class="ql-color-label ql-stroke ql-transparent" x1=3 x2=15 y1=15 y2=15></line> <polyline class=ql-stroke points="5.5 11 9 3 12.5 11"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=9 y2=9></line> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <polygon class="ql-stroke ql-fill" points="3 11 5 9 3 7 3 11"></polygon> <line class="ql-stroke ql-fill" x1=15 x2=11 y1=4 y2=4></line> <path class=ql-fill d=M11,3a3,3,0,0,0,0,6h1V3H11Z></path> <rect class=ql-fill height=11 width=1 x=11 y=4></rect> <rect class=ql-fill height=11 width=1 x=13 y=4></rect> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <polygon class="ql-stroke ql-fill" points="15 12 13 10 15 8 15 12"></polygon> <line class="ql-stroke ql-fill" x1=9 x2=5 y1=4 y2=4></line> <path class=ql-fill d=M5,3A3,3,0,0,0,5,9H6V3H5Z></path> <rect class=ql-fill height=11 width=1 x=5 y=4></rect> <rect class=ql-fill height=11 width=1 x=7 y=4></rect> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <path class=ql-fill d=M14,16H4a1,1,0,0,1,0-2H14A1,1,0,0,1,14,16Z /> <path class=ql-fill d=M14,4H4A1,1,0,0,1,4,2H14A1,1,0,0,1,14,4Z /> <rect class=ql-fill x=3 y=6 width=12 height=6 rx=1 ry=1 /> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <path class=ql-fill d=M13,16H5a1,1,0,0,1,0-2h8A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H5A1,1,0,0,1,5,2h8A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=2 y=6 width=14 height=6 rx=1 ry=1 /> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <path class=ql-fill d=M15,8H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,8Z /> <path class=ql-fill d=M15,12H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,12Z /> <path class=ql-fill d=M15,16H5a1,1,0,0,1,0-2H15A1,1,0,0,1,15,16Z /> <path class=ql-fill d=M15,4H5A1,1,0,0,1,5,2H15A1,1,0,0,1,15,4Z /> <rect class=ql-fill x=2 y=6 width=8 height=6 rx=1 ry=1 /> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <path class=ql-fill d=M5,8H3A1,1,0,0,1,3,6H5A1,1,0,0,1,5,8Z /> <path class=ql-fill d=M5,12H3a1,1,0,0,1,0-2H5A1,1,0,0,1,5,12Z /> <path class=ql-fill d=M13,16H3a1,1,0,0,1,0-2H13A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H3A1,1,0,0,1,3,2H13A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=8 y=6 width=8 height=6 rx=1 ry=1 transform="translate(24 18) rotate(-180)"/> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <path class=ql-fill d=M11.759,2.482a2.561,2.561,0,0,0-3.53.607A7.656,7.656,0,0,0,6.8,6.2C6.109,9.188,5.275,14.677,4.15,14.927a1.545,1.545,0,0,0-1.3-.933A0.922,0.922,0,0,0,2,15.036S1.954,16,4.119,16s3.091-2.691,3.7-5.553c0.177-.826.36-1.726,0.554-2.6L8.775,6.2c0.381-1.421.807-2.521,1.306-2.676a1.014,1.014,0,0,0,1.02.56A0.966,0.966,0,0,0,11.759,2.482Z></path> <rect class=ql-fill height=1.6 rx=0.8 ry=0.8 width=5 x=5.15 y=6.2></rect> <path class=ql-fill d=M13.663,12.027a1.662,1.662,0,0,1,.266-0.276q0.193,0.069.456,0.138a2.1,2.1,0,0,0,.535.069,1.075,1.075,0,0,0,.767-0.3,1.044,1.044,0,0,0,.314-0.8,0.84,0.84,0,0,0-.238-0.619,0.8,0.8,0,0,0-.594-0.239,1.154,1.154,0,0,0-.781.3,4.607,4.607,0,0,0-.781,1q-0.091.15-.218,0.346l-0.246.38c-0.068-.288-0.137-0.582-0.212-0.885-0.459-1.847-2.494-.984-2.941-0.8-0.482.2-.353,0.647-0.094,0.529a0.869,0.869,0,0,1,1.281.585c0.217,0.751.377,1.436,0.527,2.038a5.688,5.688,0,0,1-.362.467,2.69,2.69,0,0,1-.264.271q-0.221-.08-0.471-0.147a2.029,2.029,0,0,0-.522-0.066,1.079,1.079,0,0,0-.768.3A1.058,1.058,0,0,0,9,15.131a0.82,0.82,0,0,0,.832.852,1.134,1.134,0,0,0,.787-0.3,5.11,5.11,0,0,0,.776-0.993q0.141-.219.215-0.34c0.046-.076.122-0.194,0.223-0.346a2.786,2.786,0,0,0,.918,1.726,2.582,2.582,0,0,0,2.376-.185c0.317-.181.212-0.565,0-0.494A0.807,0.807,0,0,1,14.176,15a5.159,5.159,0,0,1-.913-2.446l0,0Q13.487,12.24,13.663,12.027Z></path> </svg>'},function(t,e){t.exports='<svg viewBox="0 0 18 18"> <path class=ql-fill d=M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm6.06787,9.209H14.98975V7.59863a.54085.54085,0,0,0-.605-.60547h-.62744a1.01119,1.01119,0,0,0-.748.29688L11.645,8.56641a.5435.5435,0,0,0-.022.8584l.28613.30762a.53861.53861,0,0,0,.84717.0332l.09912-.08789a1.2137,1.2137,0,0,0,.2417-.35254h.02246s-.01123.30859-.01123.60547V13.209H12.041a.54085.54085,0,0,0-.605.60547v.43945a.54085.54085,0,0,0,.605.60547h4.02686a.54085.54085,0,0,0,.605-.60547v-.43945A.54085.54085,0,0,0,16.06787,13.209Z /> </svg>'},function(t,e){t.exports='<svg viewBox="0 0 18 18"> <path class=ql-fill d=M16.73975,13.81445v.43945a.54085.54085,0,0,1-.605.60547H11.855a.58392.58392,0,0,1-.64893-.60547V14.0127c0-2.90527,3.39941-3.42187,3.39941-4.55469a.77675.77675,0,0,0-.84717-.78125,1.17684,1.17684,0,0,0-.83594.38477c-.2749.26367-.561.374-.85791.13184l-.4292-.34082c-.30811-.24219-.38525-.51758-.1543-.81445a2.97155,2.97155,0,0,1,2.45361-1.17676,2.45393,2.45393,0,0,1,2.68408,2.40918c0,2.45312-3.1792,2.92676-3.27832,3.93848h2.79443A.54085.54085,0,0,1,16.73975,13.81445ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z /> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=7 x2=13 y1=4 y2=4></line> <line class=ql-stroke x1=5 x2=11 y1=14 y2=14></line> <line class=ql-stroke x1=8 x2=10 y1=14 y2=4></line> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <rect class=ql-stroke height=10 width=12 x=3 y=4></rect> <circle class=ql-fill cx=6 cy=7 r=1></circle> <polyline class="ql-even ql-fill" points="5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12"></polyline> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class="ql-fill ql-stroke" points="3 7 3 11 5 9 3 7"></polyline> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points="5 7 5 11 3 9 5 7"></polyline> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=7 x2=11 y1=7 y2=11></line> <path class="ql-even ql-stroke" d=M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z></path> <path class="ql-even ql-stroke" d=M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z></path> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=7 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=7 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=7 x2=15 y1=14 y2=14></line> <line class="ql-stroke ql-thin" x1=2.5 x2=4.5 y1=5.5 y2=5.5></line> <path class=ql-fill d=M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z></path> <path class="ql-stroke ql-thin" d=M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156></path> <path class="ql-stroke ql-thin" d=M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109></path> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=6 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=6 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=6 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=3 y1=4 y2=4></line> <line class=ql-stroke x1=3 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=3 y1=14 y2=14></line> </svg>'},function(t,e){t.exports='<svg class="" viewbox="0 0 18 18"> <line class=ql-stroke x1=9 x2=15 y1=4 y2=4></line> <polyline class=ql-stroke points="3 4 4 5 6 3"></polyline> <line class=ql-stroke x1=9 x2=15 y1=14 y2=14></line> <polyline class=ql-stroke points="3 14 4 15 6 13"></polyline> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points="3 9 4 10 6 8"></polyline> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <path class=ql-fill d=M15.5,15H13.861a3.858,3.858,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.921,1.921,0,0,0,12.021,11.7a0.50013,0.50013,0,1,0,.957.291h0a0.914,0.914,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.076-1.16971,1.86982-1.93971,2.43082A1.45639,1.45639,0,0,0,12,15.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,15Z /> <path class=ql-fill d=M9.65,5.241a1,1,0,0,0-1.409.108L6,7.964,3.759,5.349A1,1,0,0,0,2.192,6.59178Q2.21541,6.6213,2.241,6.649L4.684,9.5,2.241,12.35A1,1,0,0,0,3.71,13.70722q0.02557-.02768.049-0.05722L6,11.036,8.241,13.65a1,1,0,1,0,1.567-1.24277Q9.78459,12.3777,9.759,12.35L7.316,9.5,9.759,6.651A1,1,0,0,0,9.65,5.241Z /> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <path class=ql-fill d=M15.5,7H13.861a4.015,4.015,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.922,1.922,0,0,0,12.021,3.7a0.5,0.5,0,1,0,.957.291,0.917,0.917,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.077-1.164,1.925-1.934,2.486A1.423,1.423,0,0,0,12,7.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,7Z /> <path class=ql-fill d=M9.651,5.241a1,1,0,0,0-1.41.108L6,7.964,3.759,5.349a1,1,0,1,0-1.519,1.3L4.683,9.5,2.241,12.35a1,1,0,1,0,1.519,1.3L6,11.036,8.241,13.65a1,1,0,0,0,1.519-1.3L7.317,9.5,9.759,6.651A1,1,0,0,0,9.651,5.241Z /> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <line class="ql-stroke ql-thin" x1=15.5 x2=2.5 y1=8.5 y2=9.5></line> <path class=ql-fill d=M9.007,8C6.542,7.791,6,7.519,6,6.5,6,5.792,7.283,5,9,5c1.571,0,2.765.679,2.969,1.309a1,1,0,0,0,1.9-.617C13.356,4.106,11.354,3,9,3,6.2,3,4,4.538,4,6.5a3.2,3.2,0,0,0,.5,1.843Z></path> <path class=ql-fill d=M8.984,10C11.457,10.208,12,10.479,12,11.5c0,0.708-1.283,1.5-3,1.5-1.571,0-2.765-.679-2.969-1.309a1,1,0,1,0-1.9.617C4.644,13.894,6.646,15,9,15c2.8,0,5-1.538,5-3.5a3.2,3.2,0,0,0-.5-1.843Z></path> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <path class=ql-stroke d=M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3></path> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=12 x=3 y=15></rect> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <rect class=ql-stroke height=12 width=12 x=3 y=3></rect> <rect class=ql-fill height=12 width=1 x=5 y=3></rect> <rect class=ql-fill height=12 width=1 x=12 y=3></rect> <rect class=ql-fill height=2 width=8 x=5 y=8></rect> <rect class=ql-fill height=1 width=3 x=3 y=5></rect> <rect class=ql-fill height=1 width=3 x=3 y=7></rect> <rect class=ql-fill height=1 width=3 x=3 y=10></rect> <rect class=ql-fill height=1 width=3 x=3 y=12></rect> <rect class=ql-fill height=1 width=3 x=12 y=5></rect> <rect class=ql-fill height=1 width=3 x=12 y=7></rect> <rect class=ql-fill height=1 width=3 x=12 y=10></rect> <rect class=ql-fill height=1 width=3 x=12 y=12></rect> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <polygon class=ql-stroke points="7 11 9 13 11 11 7 11"></polygon> <polygon class=ql-stroke points="7 7 9 5 11 7 7 7"></polygon> </svg>'},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function l(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=e.BubbleTooltip=void 0;var a=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},s=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),u=n(3),c=r(u),f=n(8),h=r(f),p=n(43),d=r(p),y=n(15),v=n(41),b=r(v),g=[["bold","italic","link"],[{header:1},{header:2},"blockquote"]],m=function(t){function e(t,n){o(this,e),null!=n.modules.toolbar&&null==n.modules.toolbar.container&&(n.modules.toolbar.container=g);var r=i(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));return r.quill.container.classList.add("ql-bubble"),r}return l(e,t),s(e,[{key:"extendToolbar",value:function(t){this.tooltip=new _(this.quill,this.options.bounds),this.tooltip.root.appendChild(t.container),this.buildButtons([].slice.call(t.container.querySelectorAll("button")),b.default),this.buildPickers([].slice.call(t.container.querySelectorAll("select")),b.default)}}]),e}(d.default);m.DEFAULTS=(0,c.default)(!0,{},d.default.DEFAULTS,{modules:{toolbar:{handlers:{link:function(t){t?this.quill.theme.tooltip.edit():this.quill.format("link",!1)}}}}});var _=function(t){function e(t,n){o(this,e);var r=i(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));return r.quill.on(h.default.events.EDITOR_CHANGE,function(t,e,n,o){if(t===h.default.events.SELECTION_CHANGE)if(null!=e&&e.length>0&&o===h.default.sources.USER){r.show(),r.root.style.left="0px",r.root.style.width="",r.root.style.width=r.root.offsetWidth+"px";var i=r.quill.getLines(e.index,e.length);if(1===i.length)r.position(r.quill.getBounds(e));else{var l=i[i.length-1],a=r.quill.getIndex(l),s=Math.min(l.length()-1,e.index+e.length-a),u=r.quill.getBounds(new y.Range(a,s));r.position(u)}}else document.activeElement!==r.textbox&&r.quill.hasFocus()&&r.hide()}),r}return l(e,t),s(e,[{key:"listen",value:function(){var t=this;a(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"listen",this).call(this),this.root.querySelector(".ql-close").addEventListener("click",function(){t.root.classList.remove("ql-editing")}),this.quill.on(h.default.events.SCROLL_OPTIMIZE,function(){setTimeout(function(){if(!t.root.classList.contains("ql-hidden")){var e=t.quill.getSelection();null!=e&&t.position(t.quill.getBounds(e))}},1)})}},{key:"cancel",value:function(){this.show()}},{key:"position",value:function(t){var n=a(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"position",this).call(this,t),r=this.root.querySelector(".ql-tooltip-arrow");if(r.style.marginLeft="",0===n)return n;r.style.marginLeft=-1*n-r.offsetWidth/2+"px"}}]),e}(p.BaseTooltip);_.TEMPLATE=['<span class="ql-tooltip-arrow"></span>','<div class="ql-tooltip-editor">','<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">','<a class="ql-close"></a>',"</div>"].join(""),e.BubbleTooltip=_,e.default=m},function(t,e,n){t.exports=n(63)}]).default})}).call(e,n(43).Buffer)},function(t,e,n){var r=n(11),o=n(1),i=r(o,"Map");t.exports=i},function(t,e,n){var r=n(1),o=r.Symbol;t.exports=o},function(t,e){function n(t,e,n){switch(n.length){case 0:return t.call(e);case 1:return t.call(e,n[0]);case 2:return t.call(e,n[0],n[1]);case 3:return t.call(e,n[0],n[1],n[2])}return t.apply(e,n)}t.exports=n},function(t,e,n){function r(t,e,n){(void 0===n||i(t[e],n))&&(void 0!==n||e in t)||o(t,e,n)}var o=n(10),i=n(8);t.exports=r},function(t,e,n){function r(t,e,n,f,h){t!==e&&l(e,function(l,u){if(s(l))h||(h=new o),a(t,e,u,n,r,f,h);else{var p=f?f(c(t,u),l,u+"",t,e,h):void 0;void 0===p&&(p=l),i(t,u,p)}},u)}var o=n(48),i=n(19),l=n(53),a=n(58),s=n(0),u=n(34),c=n(27);t.exports=r},function(t,e,n){function r(t,e){return l(i(t,e,o),t+"")}var o=n(28),i=n(96),l=n(97);t.exports=r},function(t,e,n){var r=n(11),o=function(){try{var t=r(Object,"defineProperty");return t({},"",{}),t}catch(t){}}();t.exports=o},function(t,e,n){(function(e){var n="object"==typeof e&&e&&e.Object===Object&&e;t.exports=n}).call(e,n(35))},function(t,e,n){var r=n(95),o=r(Object.getPrototypeOf,Object);t.exports=o},function(t,e){function n(t,e){var n=typeof t;return!!(e=null==e?r:e)&&("number"==n||"symbol"!=n&&o.test(t))&&t>-1&&t%1==0&&t<e}var r=9007199254740991,o=/^(?:0|[1-9]\d*)$/;t.exports=n},function(t,e){function n(t){var e=t&&t.constructor;return t===("function"==typeof e&&e.prototype||r)}var r=Object.prototype;t.exports=n},function(t,e){function n(t,e){return"__proto__"==e?void 0:t[e]}t.exports=n},function(t,e){function n(t){return t}t.exports=n},function(t,e,n){var r=n(54),o=n(2),i=Object.prototype,l=i.hasOwnProperty,a=i.propertyIsEnumerable,s=r(function(){return arguments}())?r:function(t){return o(t)&&l.call(t,"callee")&&!a.call(t,"callee")};t.exports=s},function(t,e){var n=Array.isArray;t.exports=n},function(t,e,n){(function(t){var r=n(1),o=n(109),i="object"==typeof e&&e&&!e.nodeType&&e,l=i&&"object"==typeof t&&t&&!t.nodeType&&t,a=l&&l.exports===i,s=a?r.Buffer:void 0,u=s?s.isBuffer:void 0,c=u||o;t.exports=c}).call(e,n(14)(t))},function(t,e){function n(t){return"number"==typeof t&&t>-1&&t%1==0&&t<=r}var r=9007199254740991;t.exports=n},function(t,e,n){var r=n(56),o=n(61),i=n(93),l=i&&i.isTypedArray,a=l?o(l):r;t.exports=a},function(t,e,n){function r(t){return l(t)?o(t,!0):i(t)}var o=n(50),i=n(57),l=n(12);t.exports=r},function(t,e){var n;n=function(){return this}();try{n=n||Function("return this")()||(0,eval)("this")}catch(t){"object"==typeof window&&(n=window)}t.exports=n},function(t,e,n){"use strict";e.a={modules:["DisplaySize","Toolbar","Resize"],overlayStyles:{position:"absolute",boxSizing:"border-box",border:"1px dashed #444"},handleStyles:{position:"absolute",height:"12px",width:"12px",backgroundColor:"white",border:"1px solid #777",boxSizing:"border-box",opacity:"0.80"},displayStyles:{position:"absolute",font:"12px/1.0 Arial, Helvetica, sans-serif",padding:"4px 8px",textAlign:"center",backgroundColor:"white",color:"#333",border:"1px solid #777",boxSizing:"border-box",opacity:"0.80",cursor:"default"},toolbarStyles:{position:"absolute",top:"-12px",right:"0",left:"0",height:"0",minWidth:"100px",font:"12px/1.0 Arial, Helvetica, sans-serif",textAlign:"center",color:"#333",boxSizing:"border-box",cursor:"default"},toolbarButtonStyles:{display:"inline-block",width:"24px",height:"24px",background:"white",border:"1px solid #999",verticalAlign:"middle"},toolbarButtonSvgStyles:{fill:"#444",stroke:"#444",strokeWidth:"2"}}},function(t,e,n){"use strict";function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function i(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}n.d(e,"a",function(){return a});var l=n(9),a=function(t){function e(){var t,n,i,l;r(this,e);for(var a=arguments.length,s=Array(a),u=0;u<a;u++)s[u]=arguments[u];return n=i=o(this,(t=e.__proto__||Object.getPrototypeOf(e)).call.apply(t,[this].concat(s))),i.onCreate=function(){i.display=document.createElement("div"),Object.assign(i.display.style,i.options.displayStyles),i.overlay.appendChild(i.display)},i.onDestroy=function(){},i.onUpdate=function(){if(i.display&&i.img){var t=i.getCurrentSize();if(i.display.innerHTML=t.join(" &times; "),t[0]>120&&t[1]>30)Object.assign(i.display.style,{right:"4px",bottom:"4px",left:"auto"});else if("right"==i.img.style.float){var e=i.display.getBoundingClientRect();Object.assign(i.display.style,{right:"auto",bottom:"-"+(e.height+4)+"px",left:"-"+(e.width+4)+"px"})}else{var n=i.display.getBoundingClientRect();Object.assign(i.display.style,{right:"-"+(n.width+4)+"px",bottom:"-"+(n.height+4)+"px",left:"auto"})}}},i.getCurrentSize=function(){return[i.img.width,Math.round(i.img.width/i.img.naturalWidth*i.img.naturalHeight)]},l=n,o(i,l)}return i(e,t),e}(l.a)},function(t,e,n){"use strict";function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function i(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}n.d(e,"a",function(){return a});var l=n(9),a=function(t){function e(){var t,n,i,l;r(this,e);for(var a=arguments.length,s=Array(a),u=0;u<a;u++)s[u]=arguments[u];return n=i=o(this,(t=e.__proto__||Object.getPrototypeOf(e)).call.apply(t,[this].concat(s))),i.onCreate=function(){i.boxes=[],i.addBox("nwse-resize"),i.addBox("nesw-resize"),i.addBox("nwse-resize"),i.addBox("nesw-resize"),i.positionBoxes()},i.onDestroy=function(){i.setCursor("")},i.positionBoxes=function(){var t=-parseFloat(i.options.handleStyles.width)/2+"px",e=-parseFloat(i.options.handleStyles.height)/2+"px";[{left:t,top:e},{right:t,top:e},{right:t,bottom:e},{left:t,bottom:e}].forEach(function(t,e){Object.assign(i.boxes[e].style,t)})},i.addBox=function(t){var e=document.createElement("div");Object.assign(e.style,i.options.handleStyles),e.style.cursor=t,e.style.width=i.options.handleStyles.width+"px",e.style.height=i.options.handleStyles.height+"px",e.addEventListener("mousedown",i.handleMousedown,!1),i.overlay.appendChild(e),i.boxes.push(e)},i.handleMousedown=function(t){i.dragBox=t.target,i.dragStartX=t.clientX,i.preDragWidth=i.img.width||i.img.naturalWidth,i.setCursor(i.dragBox.style.cursor),document.addEventListener("mousemove",i.handleDrag,!1),document.addEventListener("mouseup",i.handleMouseup,!1)},i.handleMouseup=function(){i.setCursor(""),document.removeEventListener("mousemove",i.handleDrag),document.removeEventListener("mouseup",i.handleMouseup)},i.handleDrag=function(t){if(i.img){var e=t.clientX-i.dragStartX;i.dragBox===i.boxes[0]||i.dragBox===i.boxes[3]?i.img.width=Math.round(i.preDragWidth-e):i.img.width=Math.round(i.preDragWidth+e),i.requestUpdate()}},i.setCursor=function(t){[document.body,i.img].forEach(function(e){e.style.cursor=t})},l=n,o(i,l)}return i(e,t),e}(l.a)},function(t,e,n){"use strict";function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function i(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}n.d(e,"a",function(){return _});var l=n(15),a=n.n(l),s=n(112),u=n.n(s),c=n(111),f=n.n(c),h=n(113),p=n.n(h),d=n(9),y=a.a.imports.parchment,v=new y.Attributor.Style("float","float"),b=new y.Attributor.Style("margin","margin"),g=new y.Attributor.Style("display","display"),m=new y.Attributor.Attribute("nameClass","class",{scope:y.Scope.INLINE});a.a.register(m);var _=function(t){function e(){var t,n,i,l;r(this,e);for(var a=arguments.length,s=Array(a),c=0;c<a;c++)s[c]=arguments[c];return n=i=o(this,(t=e.__proto__||Object.getPrototypeOf(e)).call.apply(t,[this].concat(s))),i.onCreate=function(){i.toolbar=document.createElement("div"),Object.assign(i.toolbar.style,i.options.toolbarStyles),i.overlay.appendChild(i.toolbar),i._defineAlignments(),i._addToolbarButtons()},i.onDestroy=function(){},i.onUpdate=function(){},i._defineAlignments=function(){i.alignments=[{icon:u.a,apply:function(){g.add(i.img,"inline"),v.add(i.img,"left"),b.add(i.img,"0 1em 1em 0"),i.img.align="left"},isApplied:function(){return"left"==v.value(i.img)}},{icon:f.a,apply:function(){g.add(i.img,"block"),v.remove(i.img),b.add(i.img,"auto"),i.img.align="center"},isApplied:function(){return"auto"==b.value(i.img)}},{icon:p.a,apply:function(){g.add(i.img,"inline"),v.add(i.img,"right"),b.add(i.img,"0 0 1em 1em"),i.img.align="right"},isApplied:function(){return"right"==v.value(i.img)}}]},i._addToolbarButtons=function(){var t=[];i.alignments.forEach(function(e,n){var r=document.createElement("span");t.push(r),r.innerHTML=e.icon,r.addEventListener("click",function(){t.forEach(function(t){return t.style.filter=""}),e.isApplied()?(v.remove(i.img),b.remove(i.img),g.remove(i.img)):(i._selectButton(r),e.apply()),i.requestUpdate()}),Object.assign(r.style,i.options.toolbarButtonStyles),n>0&&(r.style.borderLeftWidth="0"),Object.assign(r.children[0].style,i.options.toolbarButtonSvgStyles),e.isApplied()&&i._selectButton(r),i.toolbar.appendChild(r)})},i._selectButton=function(t){t.style.filter="invert(20%)"},l=n,o(i,l)}return i(e,t),e}(d.a)},function(t,e,n){var r=n(18),o=n(21),i=n(70),l=n(108),a=o(function(t){return t.push(void 0,i),r(l,void 0,t)});t.exports=a},function(t,e,n){"use strict";function r(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function o(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var l=n(15),a=n.n(l),s=n(40),u=n.n(s),c=n(36),f=n(37),h=n(39),p=n(38),d=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),y=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},v={DisplaySize:f.a,Toolbar:h.a,Resize:p.a},b=function t(e){var n=this,r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};i(this,t),this.initializeModules=function(){n.removeModules(),n.modules=n.moduleClasses.map(function(t){return new(v[t]||t)(n)}),n.modules.forEach(function(t){t.onCreate()}),n.onUpdate()},this.onUpdate=function(){n.repositionElements(),n.modules.forEach(function(t){t.onUpdate()})},this.removeModules=function(){n.modules.forEach(function(t){t.onDestroy()}),n.modules=[]},this.handleClick=function(t){if(t.target&&t.target.tagName&&"IMG"===t.target.tagName.toUpperCase()){if(n.img===t.target)return;n.img&&n.hide(),n.show(t.target),t.preventDefault()}else n.img&&n.hide()},this.handleScroll=function(t){n.hide()},this.show=function(t){n.img=t,n.showOverlay(),n.initializeModules()},this.showOverlay=function(){n.overlay&&n.hideOverlay(),n.quill.setSelection(null),n.setUserSelect("none"),document.addEventListener("keyup",n.checkImage,!0),n.quill.root.addEventListener("input",n.checkImage,!0),n.overlay=document.createElement("div"),Object.assign(n.overlay.style,n.options.overlayStyles),n.quill.root.parentNode.appendChild(n.overlay),n.repositionElements()},this.hideOverlay=function(){n.overlay&&(n.quill.root.parentNode.removeChild(n.overlay),n.overlay=void 0,document.removeEventListener("keyup",n.checkImage),n.quill.root.removeEventListener("input",n.checkImage),n.setUserSelect(""))},this.repositionElements=function(){if(n.overlay&&n.img){var t=n.quill.root.parentNode,e=n.img.getBoundingClientRect(),r=t.getBoundingClientRect();Object.assign(n.overlay.style,{left:e.left-r.left-1+t.scrollLeft+"px",top:e.top-r.top+t.scrollTop+"px",width:e.width+"px",height:e.height+"px"})}},this.hide=function(){n.hideOverlay(),n.removeModules(),n.img=void 0},this.setUserSelect=function(t){["userSelect","mozUserSelect","webkitUserSelect","msUserSelect"].forEach(function(e){n.quill.root.style[e]=t,document.documentElement.style[e]=t})},this.checkImage=function(t){n.img&&(46!=t.keyCode&&8!=t.keyCode||(__webpack_provided_window_dot_Quill||a.a).find(n.img).deleteAt(0),n.hide())},this.quill=e;var o=!1;r.modules&&(o=r.modules.slice()),this.options=u()({},r,c.a),!1!==o&&(this.options.modules=o),document.execCommand("enableObjectResizing",!1,"false"),this.quill.root.addEventListener("click",this.handleClick,!1),this.quill.root.addEventListener("mscontrolselect",this.handleClick,!1),this.quill.root.addEventListener("scroll",this.handleScroll,!1),this.quill.root.parentNode.style.position=this.quill.root.parentNode.style.position||"relative",this.moduleClasses=this.options.modules,this.modules=[]};if(e.default=b,__webpack_provided_window_dot_Quill){var g=["alt","height","width","style"],m=__webpack_provided_window_dot_Quill.import("formats/image"),_=function(t){function e(){return i(this,e),r(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return o(e,t),d(e,[{key:"format",value:function(t,n){g.indexOf(t)>-1?n?this.domNode.setAttribute(t,n):this.domNode.removeAttribute(t):y(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"format",this).call(this,t,n)}}],[{key:"formats",value:function(t){return g.reduce(function(e,n){return t.hasAttribute(n)&&(e[n]=t.getAttribute(n)),e},{})}}]),e}(m);__webpack_provided_window_dot_Quill.register(_,!0),"function"!=typeof Object.assign&&(Object.assign=function(t){if(null==t)throw new TypeError("Cannot convert undefined or null to object");t=Object(t);for(var e=1;e<arguments.length;e++){var n=arguments[e];if(null!=n)for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(t[r]=n[r])}return t}),__webpack_provided_window_dot_Quill.register("modules/imageResize",b)}},function(t,e,n){"use strict";function r(t){var e=t.length;if(e%4>0)throw new Error("Invalid string. Length must be a multiple of 4");var n=t.indexOf("=");return-1===n&&(n=e),[n,n===e?0:4-n%4]}function o(t){var e=r(t),n=e[0],o=e[1];return 3*(n+o)/4-o}function i(t,e,n){return 3*(e+n)/4-n}function l(t){for(var e,n=r(t),o=n[0],l=n[1],a=new h(i(t,o,l)),s=0,u=l>0?o-4:o,c=0;c<u;c+=4)e=f[t.charCodeAt(c)]<<18|f[t.charCodeAt(c+1)]<<12|f[t.charCodeAt(c+2)]<<6|f[t.charCodeAt(c+3)],a[s++]=e>>16&255,a[s++]=e>>8&255,a[s++]=255&e;return 2===l&&(e=f[t.charCodeAt(c)]<<2|f[t.charCodeAt(c+1)]>>4,a[s++]=255&e),1===l&&(e=f[t.charCodeAt(c)]<<10|f[t.charCodeAt(c+1)]<<4|f[t.charCodeAt(c+2)]>>2,a[s++]=e>>8&255,a[s++]=255&e),a}function a(t){return c[t>>18&63]+c[t>>12&63]+c[t>>6&63]+c[63&t]}function s(t,e,n){for(var r,o=[],i=e;i<n;i+=3)r=(t[i]<<16&16711680)+(t[i+1]<<8&65280)+(255&t[i+2]),o.push(a(r));return o.join("")}function u(t){for(var e,n=t.length,r=n%3,o=[],i=0,l=n-r;i<l;i+=16383)o.push(s(t,i,i+16383>l?l:i+16383));return 1===r?(e=t[n-1],o.push(c[e>>2]+c[e<<4&63]+"==")):2===r&&(e=(t[n-2]<<8)+t[n-1],o.push(c[e>>10]+c[e>>4&63]+c[e<<2&63]+"=")),o.join("")}e.byteLength=o,e.toByteArray=l,e.fromByteArray=u;for(var c=[],f=[],h="undefined"!=typeof Uint8Array?Uint8Array:Array,p="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",d=0,y=p.length;d<y;++d)c[d]=p[d],f[p.charCodeAt(d)]=d;f["-".charCodeAt(0)]=62,f["_".charCodeAt(0)]=63},function(t,e,n){"use strict";(function(t){function r(){return i.TYPED_ARRAY_SUPPORT?2147483647:1073741823}function o(t,e){if(r()<e)throw new RangeError("Invalid typed array length");return i.TYPED_ARRAY_SUPPORT?(t=new Uint8Array(e),t.__proto__=i.prototype):(null===t&&(t=new i(e)),t.length=e),t}function i(t,e,n){if(!(i.TYPED_ARRAY_SUPPORT||this instanceof i))return new i(t,e,n);if("number"==typeof t){if("string"==typeof e)throw new Error("If encoding is specified then the first argument must be a string");return u(this,t)}return l(this,t,e,n)}function l(t,e,n,r){if("number"==typeof e)throw new TypeError('"value" argument must not be a number');return"undefined"!=typeof ArrayBuffer&&e instanceof ArrayBuffer?h(t,e,n,r):"string"==typeof e?c(t,e,n):p(t,e)}function a(t){if("number"!=typeof t)throw new TypeError('"size" argument must be a number');if(t<0)throw new RangeError('"size" argument must not be negative')}function s(t,e,n,r){return a(e),e<=0?o(t,e):void 0!==n?"string"==typeof r?o(t,e).fill(n,r):o(t,e).fill(n):o(t,e)}function u(t,e){if(a(e),t=o(t,e<0?0:0|d(e)),!i.TYPED_ARRAY_SUPPORT)for(var n=0;n<e;++n)t[n]=0;return t}function c(t,e,n){if("string"==typeof n&&""!==n||(n="utf8"),!i.isEncoding(n))throw new TypeError('"encoding" must be a valid string encoding');var r=0|v(e,n);t=o(t,r);var l=t.write(e,n);return l!==r&&(t=t.slice(0,l)),t}function f(t,e){var n=e.length<0?0:0|d(e.length);t=o(t,n);for(var r=0;r<n;r+=1)t[r]=255&e[r];return t}function h(t,e,n,r){if(e.byteLength,n<0||e.byteLength<n)throw new RangeError("'offset' is out of bounds");if(e.byteLength<n+(r||0))throw new RangeError("'length' is out of bounds");return e=void 0===n&&void 0===r?new Uint8Array(e):void 0===r?new Uint8Array(e,n):new Uint8Array(e,n,r),i.TYPED_ARRAY_SUPPORT?(t=e,t.__proto__=i.prototype):t=f(t,e),t}function p(t,e){if(i.isBuffer(e)){var n=0|d(e.length);return t=o(t,n),0===t.length?t:(e.copy(t,0,0,n),t)}if(e){if("undefined"!=typeof ArrayBuffer&&e.buffer instanceof ArrayBuffer||"length"in e)return"number"!=typeof e.length||G(e.length)?o(t,0):f(t,e);if("Buffer"===e.type&&Q(e.data))return f(t,e.data)}throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.")}function d(t){if(t>=r())throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x"+r().toString(16)+" bytes");return 0|t}function y(t){return+t!=t&&(t=0),i.alloc(+t)}function v(t,e){if(i.isBuffer(t))return t.length;if("undefined"!=typeof ArrayBuffer&&"function"==typeof ArrayBuffer.isView&&(ArrayBuffer.isView(t)||t instanceof ArrayBuffer))return t.byteLength;"string"!=typeof t&&(t=""+t);var n=t.length;if(0===n)return 0;for(var r=!1;;)switch(e){case"ascii":case"latin1":case"binary":return n;case"utf8":case"utf-8":case void 0:return K(t).length;case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return 2*n;case"hex":return n>>>1;case"base64":return W(t).length;default:if(r)return K(t).length;e=(""+e).toLowerCase(),r=!0}}function b(t,e,n){var r=!1;if((void 0===e||e<0)&&(e=0),e>this.length)return"";if((void 0===n||n>this.length)&&(n=this.length),n<=0)return"";if(n>>>=0,e>>>=0,n<=e)return"";for(t||(t="utf8");;)switch(t){case"hex":return q(this,e,n);case"utf8":case"utf-8":return N(this,e,n);case"ascii":return S(this,e,n);case"latin1":case"binary":return P(this,e,n);case"base64":return j(this,e,n);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return C(this,e,n);default:if(r)throw new TypeError("Unknown encoding: "+t);t=(t+"").toLowerCase(),r=!0}}function g(t,e,n){var r=t[e];t[e]=t[n],t[n]=r}function m(t,e,n,r,o){if(0===t.length)return-1;if("string"==typeof n?(r=n,n=0):n>2147483647?n=2147483647:n<-2147483648&&(n=-2147483648),n=+n,isNaN(n)&&(n=o?0:t.length-1),n<0&&(n=t.length+n),n>=t.length){if(o)return-1;n=t.length-1}else if(n<0){if(!o)return-1;n=0}if("string"==typeof e&&(e=i.from(e,r)),i.isBuffer(e))return 0===e.length?-1:_(t,e,n,r,o);if("number"==typeof e)return e&=255,i.TYPED_ARRAY_SUPPORT&&"function"==typeof Uint8Array.prototype.indexOf?o?Uint8Array.prototype.indexOf.call(t,e,n):Uint8Array.prototype.lastIndexOf.call(t,e,n):_(t,[e],n,r,o);throw new TypeError("val must be string, number or Buffer")}function _(t,e,n,r,o){function i(t,e){return 1===l?t[e]:t.readUInt16BE(e*l)}var l=1,a=t.length,s=e.length;if(void 0!==r&&("ucs2"===(r=String(r).toLowerCase())||"ucs-2"===r||"utf16le"===r||"utf-16le"===r)){if(t.length<2||e.length<2)return-1;l=2,a/=2,s/=2,n/=2}var u;if(o){var c=-1;for(u=n;u<a;u++)if(i(t,u)===i(e,-1===c?0:u-c)){if(-1===c&&(c=u),u-c+1===s)return c*l}else-1!==c&&(u-=u-c),c=-1}else for(n+s>a&&(n=a-s),u=n;u>=0;u--){for(var f=!0,h=0;h<s;h++)if(i(t,u+h)!==i(e,h)){f=!1;break}if(f)return u}return-1}function O(t,e,n,r){n=Number(n)||0;var o=t.length-n;r?(r=Number(r))>o&&(r=o):r=o;var i=e.length;if(i%2!=0)throw new TypeError("Invalid hex string");r>i/2&&(r=i/2);for(var l=0;l<r;++l){var a=parseInt(e.substr(2*l,2),16);if(isNaN(a))return l;t[n+l]=a}return l}function w(t,e,n,r){return Z(K(e,t.length-n),t,n,r)}function x(t,e,n,r){return Z(Y(e),t,n,r)}function E(t,e,n,r){return x(t,e,n,r)}function k(t,e,n,r){return Z(W(e),t,n,r)}function A(t,e,n,r){return Z(V(e,t.length-n),t,n,r)}function j(t,e,n){return 0===e&&n===t.length?X.fromByteArray(t):X.fromByteArray(t.slice(e,n))}function N(t,e,n){n=Math.min(t.length,n);for(var r=[],o=e;o<n;){var i=t[o],l=null,a=i>239?4:i>223?3:i>191?2:1;if(o+a<=n){var s,u,c,f;switch(a){case 1:i<128&&(l=i);break;case 2:s=t[o+1],128==(192&s)&&(f=(31&i)<<6|63&s)>127&&(l=f);break;case 3:s=t[o+1],u=t[o+2],128==(192&s)&&128==(192&u)&&(f=(15&i)<<12|(63&s)<<6|63&u)>2047&&(f<55296||f>57343)&&(l=f);break;case 4:s=t[o+1],u=t[o+2],c=t[o+3],128==(192&s)&&128==(192&u)&&128==(192&c)&&(f=(15&i)<<18|(63&s)<<12|(63&u)<<6|63&c)>65535&&f<1114112&&(l=f)}}null===l?(l=65533,a=1):l>65535&&(l-=65536,r.push(l>>>10&1023|55296),l=56320|1023&l),r.push(l),o+=a}return T(r)}function T(t){var e=t.length;if(e<=J)return String.fromCharCode.apply(String,t);for(var n="",r=0;r<e;)n+=String.fromCharCode.apply(String,t.slice(r,r+=J));return n}function S(t,e,n){var r="";n=Math.min(t.length,n);for(var o=e;o<n;++o)r+=String.fromCharCode(127&t[o]);return r}function P(t,e,n){var r="";n=Math.min(t.length,n);for(var o=e;o<n;++o)r+=String.fromCharCode(t[o]);return r}function q(t,e,n){var r=t.length;(!e||e<0)&&(e=0),(!n||n<0||n>r)&&(n=r);for(var o="",i=e;i<n;++i)o+=H(t[i]);return o}function C(t,e,n){for(var r=t.slice(e,n),o="",i=0;i<r.length;i+=2)o+=String.fromCharCode(r[i]+256*r[i+1]);return o}function L(t,e,n){if(t%1!=0||t<0)throw new RangeError("offset is not uint");if(t+e>n)throw new RangeError("Trying to access beyond buffer length")}function R(t,e,n,r,o,l){if(!i.isBuffer(t))throw new TypeError('"buffer" argument must be a Buffer instance');if(e>o||e<l)throw new RangeError('"value" argument is out of bounds');if(n+r>t.length)throw new RangeError("Index out of range")}function M(t,e,n,r){e<0&&(e=65535+e+1);for(var o=0,i=Math.min(t.length-n,2);o<i;++o)t[n+o]=(e&255<<8*(r?o:1-o))>>>8*(r?o:1-o)}function B(t,e,n,r){e<0&&(e=4294967295+e+1);for(var o=0,i=Math.min(t.length-n,4);o<i;++o)t[n+o]=e>>>8*(r?o:3-o)&255}function I(t,e,n,r,o,i){if(n+r>t.length)throw new RangeError("Index out of range");if(n<0)throw new RangeError("Index out of range")}function D(t,e,n,r,o){return o||I(t,e,n,4,3.4028234663852886e38,-3.4028234663852886e38),$.write(t,e,n,r,23,4),n+4}function U(t,e,n,r,o){return o||I(t,e,n,8,1.7976931348623157e308,-1.7976931348623157e308),$.write(t,e,n,r,52,8),n+8}function F(t){if(t=z(t).replace(tt,""),t.length<2)return"";for(;t.length%4!=0;)t+="=";return t}function z(t){return t.trim?t.trim():t.replace(/^\s+|\s+$/g,"")}function H(t){return t<16?"0"+t.toString(16):t.toString(16)}function K(t,e){e=e||1/0;for(var n,r=t.length,o=null,i=[],l=0;l<r;++l){if((n=t.charCodeAt(l))>55295&&n<57344){if(!o){if(n>56319){(e-=3)>-1&&i.push(239,191,189);continue}if(l+1===r){(e-=3)>-1&&i.push(239,191,189);continue}o=n;continue}if(n<56320){(e-=3)>-1&&i.push(239,191,189),o=n;continue}n=65536+(o-55296<<10|n-56320)}else o&&(e-=3)>-1&&i.push(239,191,189);if(o=null,n<128){if((e-=1)<0)break;i.push(n)}else if(n<2048){if((e-=2)<0)break;i.push(n>>6|192,63&n|128)}else if(n<65536){if((e-=3)<0)break;i.push(n>>12|224,n>>6&63|128,63&n|128)}else{if(!(n<1114112))throw new Error("Invalid code point");if((e-=4)<0)break;i.push(n>>18|240,n>>12&63|128,n>>6&63|128,63&n|128)}}return i}function Y(t){for(var e=[],n=0;n<t.length;++n)e.push(255&t.charCodeAt(n));return e}function V(t,e){for(var n,r,o,i=[],l=0;l<t.length&&!((e-=2)<0);++l)n=t.charCodeAt(l),r=n>>8,o=n%256,i.push(o),i.push(r);return i}function W(t){return X.toByteArray(F(t))}function Z(t,e,n,r){for(var o=0;o<r&&!(o+n>=e.length||o>=t.length);++o)e[o+n]=t[o];return o}function G(t){return t!==t}/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
var X=n(42),$=n(44),Q=n(45);e.Buffer=i,e.SlowBuffer=y,e.INSPECT_MAX_BYTES=50,i.TYPED_ARRAY_SUPPORT=void 0!==t.TYPED_ARRAY_SUPPORT?t.TYPED_ARRAY_SUPPORT:function(){try{var t=new Uint8Array(1);return t.__proto__={__proto__:Uint8Array.prototype,foo:function(){return 42}},42===t.foo()&&"function"==typeof t.subarray&&0===t.subarray(1,1).byteLength}catch(t){return!1}}(),e.kMaxLength=r(),i.poolSize=8192,i._augment=function(t){return t.__proto__=i.prototype,t},i.from=function(t,e,n){return l(null,t,e,n)},i.TYPED_ARRAY_SUPPORT&&(i.prototype.__proto__=Uint8Array.prototype,i.__proto__=Uint8Array,"undefined"!=typeof Symbol&&Symbol.species&&i[Symbol.species]===i&&Object.defineProperty(i,Symbol.species,{value:null,configurable:!0})),i.alloc=function(t,e,n){return s(null,t,e,n)},i.allocUnsafe=function(t){return u(null,t)},i.allocUnsafeSlow=function(t){return u(null,t)},i.isBuffer=function(t){return!(null==t||!t._isBuffer)},i.compare=function(t,e){if(!i.isBuffer(t)||!i.isBuffer(e))throw new TypeError("Arguments must be Buffers");if(t===e)return 0;for(var n=t.length,r=e.length,o=0,l=Math.min(n,r);o<l;++o)if(t[o]!==e[o]){n=t[o],r=e[o];break}return n<r?-1:r<n?1:0},i.isEncoding=function(t){switch(String(t).toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"latin1":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return!0;default:return!1}},i.concat=function(t,e){if(!Q(t))throw new TypeError('"list" argument must be an Array of Buffers');if(0===t.length)return i.alloc(0);var n;if(void 0===e)for(e=0,n=0;n<t.length;++n)e+=t[n].length;var r=i.allocUnsafe(e),o=0;for(n=0;n<t.length;++n){var l=t[n];if(!i.isBuffer(l))throw new TypeError('"list" argument must be an Array of Buffers');l.copy(r,o),o+=l.length}return r},i.byteLength=v,i.prototype._isBuffer=!0,i.prototype.swap16=function(){var t=this.length;if(t%2!=0)throw new RangeError("Buffer size must be a multiple of 16-bits");for(var e=0;e<t;e+=2)g(this,e,e+1);return this},i.prototype.swap32=function(){var t=this.length;if(t%4!=0)throw new RangeError("Buffer size must be a multiple of 32-bits");for(var e=0;e<t;e+=4)g(this,e,e+3),g(this,e+1,e+2);return this},i.prototype.swap64=function(){var t=this.length;if(t%8!=0)throw new RangeError("Buffer size must be a multiple of 64-bits");for(var e=0;e<t;e+=8)g(this,e,e+7),g(this,e+1,e+6),g(this,e+2,e+5),g(this,e+3,e+4);return this},i.prototype.toString=function(){var t=0|this.length;return 0===t?"":0===arguments.length?N(this,0,t):b.apply(this,arguments)},i.prototype.equals=function(t){if(!i.isBuffer(t))throw new TypeError("Argument must be a Buffer");return this===t||0===i.compare(this,t)},i.prototype.inspect=function(){var t="",n=e.INSPECT_MAX_BYTES;return this.length>0&&(t=this.toString("hex",0,n).match(/.{2}/g).join(" "),this.length>n&&(t+=" ... ")),"<Buffer "+t+">"},i.prototype.compare=function(t,e,n,r,o){if(!i.isBuffer(t))throw new TypeError("Argument must be a Buffer");if(void 0===e&&(e=0),void 0===n&&(n=t?t.length:0),void 0===r&&(r=0),void 0===o&&(o=this.length),e<0||n>t.length||r<0||o>this.length)throw new RangeError("out of range index");if(r>=o&&e>=n)return 0;if(r>=o)return-1;if(e>=n)return 1;if(e>>>=0,n>>>=0,r>>>=0,o>>>=0,this===t)return 0;for(var l=o-r,a=n-e,s=Math.min(l,a),u=this.slice(r,o),c=t.slice(e,n),f=0;f<s;++f)if(u[f]!==c[f]){l=u[f],a=c[f];break}return l<a?-1:a<l?1:0},i.prototype.includes=function(t,e,n){return-1!==this.indexOf(t,e,n)},i.prototype.indexOf=function(t,e,n){return m(this,t,e,n,!0)},i.prototype.lastIndexOf=function(t,e,n){return m(this,t,e,n,!1)},i.prototype.write=function(t,e,n,r){if(void 0===e)r="utf8",n=this.length,e=0;else if(void 0===n&&"string"==typeof e)r=e,n=this.length,e=0;else{if(!isFinite(e))throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");e|=0,isFinite(n)?(n|=0,void 0===r&&(r="utf8")):(r=n,n=void 0)}var o=this.length-e;if((void 0===n||n>o)&&(n=o),t.length>0&&(n<0||e<0)||e>this.length)throw new RangeError("Attempt to write outside buffer bounds");r||(r="utf8");for(var i=!1;;)switch(r){case"hex":return O(this,t,e,n);case"utf8":case"utf-8":return w(this,t,e,n);case"ascii":return x(this,t,e,n);case"latin1":case"binary":return E(this,t,e,n);case"base64":return k(this,t,e,n);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return A(this,t,e,n);default:if(i)throw new TypeError("Unknown encoding: "+r);r=(""+r).toLowerCase(),i=!0}},i.prototype.toJSON=function(){return{type:"Buffer",data:Array.prototype.slice.call(this._arr||this,0)}};var J=4096;i.prototype.slice=function(t,e){var n=this.length;t=~~t,e=void 0===e?n:~~e,t<0?(t+=n)<0&&(t=0):t>n&&(t=n),e<0?(e+=n)<0&&(e=0):e>n&&(e=n),e<t&&(e=t);var r;if(i.TYPED_ARRAY_SUPPORT)r=this.subarray(t,e),r.__proto__=i.prototype;else{var o=e-t;r=new i(o,void 0);for(var l=0;l<o;++l)r[l]=this[l+t]}return r},i.prototype.readUIntLE=function(t,e,n){t|=0,e|=0,n||L(t,e,this.length);for(var r=this[t],o=1,i=0;++i<e&&(o*=256);)r+=this[t+i]*o;return r},i.prototype.readUIntBE=function(t,e,n){t|=0,e|=0,n||L(t,e,this.length);for(var r=this[t+--e],o=1;e>0&&(o*=256);)r+=this[t+--e]*o;return r},i.prototype.readUInt8=function(t,e){return e||L(t,1,this.length),this[t]},i.prototype.readUInt16LE=function(t,e){return e||L(t,2,this.length),this[t]|this[t+1]<<8},i.prototype.readUInt16BE=function(t,e){return e||L(t,2,this.length),this[t]<<8|this[t+1]},i.prototype.readUInt32LE=function(t,e){return e||L(t,4,this.length),(this[t]|this[t+1]<<8|this[t+2]<<16)+16777216*this[t+3]},i.prototype.readUInt32BE=function(t,e){return e||L(t,4,this.length),16777216*this[t]+(this[t+1]<<16|this[t+2]<<8|this[t+3])},i.prototype.readIntLE=function(t,e,n){t|=0,e|=0,n||L(t,e,this.length);for(var r=this[t],o=1,i=0;++i<e&&(o*=256);)r+=this[t+i]*o;return o*=128,r>=o&&(r-=Math.pow(2,8*e)),r},i.prototype.readIntBE=function(t,e,n){t|=0,e|=0,n||L(t,e,this.length);for(var r=e,o=1,i=this[t+--r];r>0&&(o*=256);)i+=this[t+--r]*o;return o*=128,i>=o&&(i-=Math.pow(2,8*e)),i},i.prototype.readInt8=function(t,e){return e||L(t,1,this.length),128&this[t]?-1*(255-this[t]+1):this[t]},i.prototype.readInt16LE=function(t,e){e||L(t,2,this.length);var n=this[t]|this[t+1]<<8;return 32768&n?4294901760|n:n},i.prototype.readInt16BE=function(t,e){e||L(t,2,this.length);var n=this[t+1]|this[t]<<8;return 32768&n?4294901760|n:n},i.prototype.readInt32LE=function(t,e){return e||L(t,4,this.length),this[t]|this[t+1]<<8|this[t+2]<<16|this[t+3]<<24},i.prototype.readInt32BE=function(t,e){return e||L(t,4,this.length),this[t]<<24|this[t+1]<<16|this[t+2]<<8|this[t+3]},i.prototype.readFloatLE=function(t,e){return e||L(t,4,this.length),$.read(this,t,!0,23,4)},i.prototype.readFloatBE=function(t,e){return e||L(t,4,this.length),$.read(this,t,!1,23,4)},i.prototype.readDoubleLE=function(t,e){return e||L(t,8,this.length),$.read(this,t,!0,52,8)},i.prototype.readDoubleBE=function(t,e){return e||L(t,8,this.length),$.read(this,t,!1,52,8)},i.prototype.writeUIntLE=function(t,e,n,r){if(t=+t,e|=0,n|=0,!r){R(this,t,e,n,Math.pow(2,8*n)-1,0)}var o=1,i=0;for(this[e]=255&t;++i<n&&(o*=256);)this[e+i]=t/o&255;return e+n},i.prototype.writeUIntBE=function(t,e,n,r){if(t=+t,e|=0,n|=0,!r){R(this,t,e,n,Math.pow(2,8*n)-1,0)}var o=n-1,i=1;for(this[e+o]=255&t;--o>=0&&(i*=256);)this[e+o]=t/i&255;return e+n},i.prototype.writeUInt8=function(t,e,n){return t=+t,e|=0,n||R(this,t,e,1,255,0),i.TYPED_ARRAY_SUPPORT||(t=Math.floor(t)),this[e]=255&t,e+1},i.prototype.writeUInt16LE=function(t,e,n){return t=+t,e|=0,n||R(this,t,e,2,65535,0),i.TYPED_ARRAY_SUPPORT?(this[e]=255&t,this[e+1]=t>>>8):M(this,t,e,!0),e+2},i.prototype.writeUInt16BE=function(t,e,n){return t=+t,e|=0,n||R(this,t,e,2,65535,0),i.TYPED_ARRAY_SUPPORT?(this[e]=t>>>8,this[e+1]=255&t):M(this,t,e,!1),e+2},i.prototype.writeUInt32LE=function(t,e,n){return t=+t,e|=0,n||R(this,t,e,4,4294967295,0),i.TYPED_ARRAY_SUPPORT?(this[e+3]=t>>>24,this[e+2]=t>>>16,this[e+1]=t>>>8,this[e]=255&t):B(this,t,e,!0),e+4},i.prototype.writeUInt32BE=function(t,e,n){return t=+t,e|=0,n||R(this,t,e,4,4294967295,0),i.TYPED_ARRAY_SUPPORT?(this[e]=t>>>24,this[e+1]=t>>>16,this[e+2]=t>>>8,this[e+3]=255&t):B(this,t,e,!1),e+4},i.prototype.writeIntLE=function(t,e,n,r){if(t=+t,e|=0,!r){var o=Math.pow(2,8*n-1);R(this,t,e,n,o-1,-o)}var i=0,l=1,a=0;for(this[e]=255&t;++i<n&&(l*=256);)t<0&&0===a&&0!==this[e+i-1]&&(a=1),this[e+i]=(t/l>>0)-a&255;return e+n},i.prototype.writeIntBE=function(t,e,n,r){if(t=+t,e|=0,!r){var o=Math.pow(2,8*n-1);R(this,t,e,n,o-1,-o)}var i=n-1,l=1,a=0;for(this[e+i]=255&t;--i>=0&&(l*=256);)t<0&&0===a&&0!==this[e+i+1]&&(a=1),this[e+i]=(t/l>>0)-a&255;return e+n},i.prototype.writeInt8=function(t,e,n){return t=+t,e|=0,n||R(this,t,e,1,127,-128),i.TYPED_ARRAY_SUPPORT||(t=Math.floor(t)),t<0&&(t=255+t+1),this[e]=255&t,e+1},i.prototype.writeInt16LE=function(t,e,n){return t=+t,e|=0,n||R(this,t,e,2,32767,-32768),i.TYPED_ARRAY_SUPPORT?(this[e]=255&t,this[e+1]=t>>>8):M(this,t,e,!0),e+2},i.prototype.writeInt16BE=function(t,e,n){return t=+t,e|=0,n||R(this,t,e,2,32767,-32768),i.TYPED_ARRAY_SUPPORT?(this[e]=t>>>8,this[e+1]=255&t):M(this,t,e,!1),e+2},i.prototype.writeInt32LE=function(t,e,n){return t=+t,e|=0,n||R(this,t,e,4,2147483647,-2147483648),i.TYPED_ARRAY_SUPPORT?(this[e]=255&t,this[e+1]=t>>>8,this[e+2]=t>>>16,this[e+3]=t>>>24):B(this,t,e,!0),e+4},i.prototype.writeInt32BE=function(t,e,n){return t=+t,e|=0,n||R(this,t,e,4,2147483647,-2147483648),t<0&&(t=4294967295+t+1),i.TYPED_ARRAY_SUPPORT?(this[e]=t>>>24,this[e+1]=t>>>16,this[e+2]=t>>>8,this[e+3]=255&t):B(this,t,e,!1),e+4},i.prototype.writeFloatLE=function(t,e,n){return D(this,t,e,!0,n)},i.prototype.writeFloatBE=function(t,e,n){return D(this,t,e,!1,n)},i.prototype.writeDoubleLE=function(t,e,n){return U(this,t,e,!0,n)},i.prototype.writeDoubleBE=function(t,e,n){return U(this,t,e,!1,n)},i.prototype.copy=function(t,e,n,r){if(n||(n=0),r||0===r||(r=this.length),e>=t.length&&(e=t.length),e||(e=0),r>0&&r<n&&(r=n),r===n)return 0;if(0===t.length||0===this.length)return 0;if(e<0)throw new RangeError("targetStart out of bounds");if(n<0||n>=this.length)throw new RangeError("sourceStart out of bounds");if(r<0)throw new RangeError("sourceEnd out of bounds");r>this.length&&(r=this.length),t.length-e<r-n&&(r=t.length-e+n);var o,l=r-n;if(this===t&&n<e&&e<r)for(o=l-1;o>=0;--o)t[o+e]=this[o+n];else if(l<1e3||!i.TYPED_ARRAY_SUPPORT)for(o=0;o<l;++o)t[o+e]=this[o+n];else Uint8Array.prototype.set.call(t,this.subarray(n,n+l),e);return l},i.prototype.fill=function(t,e,n,r){if("string"==typeof t){if("string"==typeof e?(r=e,e=0,n=this.length):"string"==typeof n&&(r=n,n=this.length),1===t.length){var o=t.charCodeAt(0);o<256&&(t=o)}if(void 0!==r&&"string"!=typeof r)throw new TypeError("encoding must be a string");if("string"==typeof r&&!i.isEncoding(r))throw new TypeError("Unknown encoding: "+r)}else"number"==typeof t&&(t&=255);if(e<0||this.length<e||this.length<n)throw new RangeError("Out of range index");if(n<=e)return this;e>>>=0,n=void 0===n?this.length:n>>>0,t||(t=0);var l;if("number"==typeof t)for(l=e;l<n;++l)this[l]=t;else{var a=i.isBuffer(t)?t:K(new i(t,r).toString()),s=a.length;for(l=0;l<n-e;++l)this[l+e]=a[l%s]}return this};var tt=/[^+\/0-9A-Za-z-_]/g}).call(e,n(35))},function(t,e){e.read=function(t,e,n,r,o){var i,l,a=8*o-r-1,s=(1<<a)-1,u=s>>1,c=-7,f=n?o-1:0,h=n?-1:1,p=t[e+f];for(f+=h,i=p&(1<<-c)-1,p>>=-c,c+=a;c>0;i=256*i+t[e+f],f+=h,c-=8);for(l=i&(1<<-c)-1,i>>=-c,c+=r;c>0;l=256*l+t[e+f],f+=h,c-=8);if(0===i)i=1-u;else{if(i===s)return l?NaN:1/0*(p?-1:1);l+=Math.pow(2,r),i-=u}return(p?-1:1)*l*Math.pow(2,i-r)},e.write=function(t,e,n,r,o,i){var l,a,s,u=8*i-o-1,c=(1<<u)-1,f=c>>1,h=23===o?Math.pow(2,-24)-Math.pow(2,-77):0,p=r?0:i-1,d=r?1:-1,y=e<0||0===e&&1/e<0?1:0;for(e=Math.abs(e),isNaN(e)||e===1/0?(a=isNaN(e)?1:0,l=c):(l=Math.floor(Math.log(e)/Math.LN2),e*(s=Math.pow(2,-l))<1&&(l--,s*=2),e+=l+f>=1?h/s:h*Math.pow(2,1-f),e*s>=2&&(l++,s/=2),l+f>=c?(a=0,l=c):l+f>=1?(a=(e*s-1)*Math.pow(2,o),l+=f):(a=e*Math.pow(2,f-1)*Math.pow(2,o),l=0));o>=8;t[n+p]=255&a,p+=d,a/=256,o-=8);for(l=l<<o|a,u+=o;u>0;t[n+p]=255&l,p+=d,l/=256,u-=8);t[n+p-d]|=128*y}},function(t,e){var n={}.toString;t.exports=Array.isArray||function(t){return"[object Array]"==n.call(t)}},function(t,e,n){function r(t){var e=-1,n=null==t?0:t.length;for(this.clear();++e<n;){var r=t[e];this.set(r[0],r[1])}}var o=n(73),i=n(74),l=n(75),a=n(76),s=n(77);r.prototype.clear=o,r.prototype.delete=i,r.prototype.get=l,r.prototype.has=a,r.prototype.set=s,t.exports=r},function(t,e,n){function r(t){var e=-1,n=null==t?0:t.length;for(this.clear();++e<n;){var r=t[e];this.set(r[0],r[1])}}var o=n(87),i=n(88),l=n(89),a=n(90),s=n(91);r.prototype.clear=o,r.prototype.delete=i,r.prototype.get=l,r.prototype.has=a,r.prototype.set=s,t.exports=r},function(t,e,n){function r(t){var e=this.__data__=new o(t);this.size=e.size}var o=n(3),i=n(99),l=n(100),a=n(101),s=n(102),u=n(103);r.prototype.clear=i,r.prototype.delete=l,r.prototype.get=a,r.prototype.has=s,r.prototype.set=u,t.exports=r},function(t,e,n){var r=n(1),o=r.Uint8Array;t.exports=o},function(t,e,n){function r(t,e){var n=l(t),r=!n&&i(t),c=!n&&!r&&a(t),h=!n&&!r&&!c&&u(t),p=n||r||c||h,d=p?o(t.length,String):[],y=d.length;for(var v in t)!e&&!f.call(t,v)||p&&("length"==v||c&&("offset"==v||"parent"==v)||h&&("buffer"==v||"byteLength"==v||"byteOffset"==v)||s(v,y))||d.push(v);return d}var o=n(60),i=n(29),l=n(30),a=n(31),s=n(25),u=n(33),c=Object.prototype,f=c.hasOwnProperty;t.exports=r},function(t,e,n){function r(t,e,n){var r=t[e];a.call(t,e)&&i(r,n)&&(void 0!==n||e in t)||o(t,e,n)}var o=n(10),i=n(8),l=Object.prototype,a=l.hasOwnProperty;t.exports=r},function(t,e,n){var r=n(0),o=Object.create,i=function(){function t(){}return function(e){if(!r(e))return{};if(o)return o(e);t.prototype=e;var n=new t;return t.prototype=void 0,n}}();t.exports=i},function(t,e,n){var r=n(69),o=r();t.exports=o},function(t,e,n){function r(t){return i(t)&&o(t)==l}var o=n(5),i=n(2),l="[object Arguments]";t.exports=r},function(t,e,n){function r(t){return!(!l(t)||i(t))&&(o(t)?d:u).test(a(t))}var o=n(13),i=n(81),l=n(0),a=n(104),s=/[\\^$.*+?()[\]{}|]/g,u=/^\[object .+?Constructor\]$/,c=Function.prototype,f=Object.prototype,h=c.toString,p=f.hasOwnProperty,d=RegExp("^"+h.call(p).replace(s,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$");t.exports=r},function(t,e,n){function r(t){return l(t)&&i(t.length)&&!!a[o(t)]}var o=n(5),i=n(32),l=n(2),a={};a["[object Float32Array]"]=a["[object Float64Array]"]=a["[object Int8Array]"]=a["[object Int16Array]"]=a["[object Int32Array]"]=a["[object Uint8Array]"]=a["[object Uint8ClampedArray]"]=a["[object Uint16Array]"]=a["[object Uint32Array]"]=!0,a["[object Arguments]"]=a["[object Array]"]=a["[object ArrayBuffer]"]=a["[object Boolean]"]=a["[object DataView]"]=a["[object Date]"]=a["[object Error]"]=a["[object Function]"]=a["[object Map]"]=a["[object Number]"]=a["[object Object]"]=a["[object RegExp]"]=a["[object Set]"]=a["[object String]"]=a["[object WeakMap]"]=!1,t.exports=r},function(t,e,n){function r(t){if(!o(t))return l(t);var e=i(t),n=[];for(var r in t)("constructor"!=r||!e&&s.call(t,r))&&n.push(r);return n}var o=n(0),i=n(26),l=n(92),a=Object.prototype,s=a.hasOwnProperty;t.exports=r},function(t,e,n){function r(t,e,n,r,m,_,O){var w=b(t,n),x=b(e,n),E=O.get(x);if(E)return void o(t,n,E);var k=_?_(w,x,n+"",t,e,O):void 0,A=void 0===k;if(A){var j=c(x),N=!j&&h(x),T=!j&&!N&&v(x);k=x,j||N||T?c(w)?k=w:f(w)?k=a(w):N?(A=!1,k=i(x,!0)):T?(A=!1,k=l(x,!0)):k=[]:y(x)||u(x)?(k=w,u(w)?k=g(w):(!d(w)||r&&p(w))&&(k=s(x))):A=!1}A&&(O.set(x,k),m(k,x,r,_,O),O.delete(x)),o(t,n,k)}var o=n(19),i=n(63),l=n(64),a=n(65),s=n(78),u=n(29),c=n(30),f=n(106),h=n(31),p=n(13),d=n(0),y=n(107),v=n(33),b=n(27),g=n(110);t.exports=r},function(t,e,n){var r=n(105),o=n(22),i=n(28),l=o?function(t,e){return o(t,"toString",{configurable:!0,enumerable:!1,value:r(e),writable:!0})}:i;t.exports=l},function(t,e){function n(t,e){for(var n=-1,r=Array(t);++n<t;)r[n]=e(n);return r}t.exports=n},function(t,e){function n(t){return function(e){return t(e)}}t.exports=n},function(t,e,n){function r(t){var e=new t.constructor(t.byteLength);return new o(e).set(new o(t)),e}var o=n(49);t.exports=r},function(t,e,n){(function(t){function r(t,e){if(e)return t.slice();var n=t.length,r=u?u(n):new t.constructor(n);return t.copy(r),r}var o=n(1),i="object"==typeof e&&e&&!e.nodeType&&e,l=i&&"object"==typeof t&&t&&!t.nodeType&&t,a=l&&l.exports===i,s=a?o.Buffer:void 0,u=s?s.allocUnsafe:void 0;t.exports=r}).call(e,n(14)(t))},function(t,e,n){function r(t,e){var n=e?o(t.buffer):t.buffer;return new t.constructor(n,t.byteOffset,t.length)}var o=n(62);t.exports=r},function(t,e){function n(t,e){var n=-1,r=t.length;for(e||(e=Array(r));++n<r;)e[n]=t[n];return e}t.exports=n},function(t,e,n){function r(t,e,n,r){var l=!n;n||(n={});for(var a=-1,s=e.length;++a<s;){var u=e[a],c=r?r(n[u],t[u],u,n,t):void 0;void 0===c&&(c=t[u]),l?i(n,u,c):o(n,u,c)}return n}var o=n(51),i=n(10);t.exports=r},function(t,e,n){var r=n(1),o=r["__core-js_shared__"];t.exports=o},function(t,e,n){function r(t){return o(function(e,n){var r=-1,o=n.length,l=o>1?n[o-1]:void 0,a=o>2?n[2]:void 0;for(l=t.length>3&&"function"==typeof l?(o--,l):void 0,a&&i(n[0],n[1],a)&&(l=o<3?void 0:l,o=1),e=Object(e);++r<o;){var s=n[r];s&&t(e,s,r,l)}return e})}var o=n(21),i=n(79);t.exports=r},function(t,e){function n(t){return function(e,n,r){for(var o=-1,i=Object(e),l=r(e),a=l.length;a--;){var s=l[t?a:++o];if(!1===n(i[s],s,i))break}return e}}t.exports=n},function(t,e,n){function r(t,e,n,l,a,s){return i(t)&&i(e)&&(s.set(e,t),o(t,e,void 0,r,s),s.delete(e)),t}var o=n(20),i=n(0);t.exports=r},function(t,e,n){function r(t){var e=l.call(t,s),n=t[s];try{t[s]=void 0;var r=!0}catch(t){}var o=a.call(t);return r&&(e?t[s]=n:delete t[s]),o}var o=n(17),i=Object.prototype,l=i.hasOwnProperty,a=i.toString,s=o?o.toStringTag:void 0;t.exports=r},function(t,e){function n(t,e){return null==t?void 0:t[e]}t.exports=n},function(t,e,n){function r(){this.__data__=o?o(null):{},this.size=0}var o=n(7);t.exports=r},function(t,e){function n(t){var e=this.has(t)&&delete this.__data__[t];return this.size-=e?1:0,e}t.exports=n},function(t,e,n){function r(t){var e=this.__data__;if(o){var n=e[t];return n===i?void 0:n}return a.call(e,t)?e[t]:void 0}var o=n(7),i="__lodash_hash_undefined__",l=Object.prototype,a=l.hasOwnProperty;t.exports=r},function(t,e,n){function r(t){var e=this.__data__;return o?void 0!==e[t]:l.call(e,t)}var o=n(7),i=Object.prototype,l=i.hasOwnProperty;t.exports=r},function(t,e,n){function r(t,e){var n=this.__data__;return this.size+=this.has(t)?0:1,n[t]=o&&void 0===e?i:e,this}var o=n(7),i="__lodash_hash_undefined__";t.exports=r},function(t,e,n){function r(t){return"function"!=typeof t.constructor||l(t)?{}:o(i(t))}var o=n(52),i=n(24),l=n(26);t.exports=r},function(t,e,n){function r(t,e,n){if(!a(n))return!1;var r=typeof e;return!!("number"==r?i(n)&&l(e,n.length):"string"==r&&e in n)&&o(n[e],t)}var o=n(8),i=n(12),l=n(25),a=n(0);t.exports=r},function(t,e){function n(t){var e=typeof t;return"string"==e||"number"==e||"symbol"==e||"boolean"==e?"__proto__"!==t:null===t}t.exports=n},function(t,e,n){function r(t){return!!i&&i in t}var o=n(67),i=function(){var t=/[^.]+$/.exec(o&&o.keys&&o.keys.IE_PROTO||"");return t?"Symbol(src)_1."+t:""}();t.exports=r},function(t,e){function n(){this.__data__=[],this.size=0}t.exports=n},function(t,e,n){function r(t){var e=this.__data__,n=o(e,t);return!(n<0)&&(n==e.length-1?e.pop():l.call(e,n,1),--this.size,!0)}var o=n(4),i=Array.prototype,l=i.splice;t.exports=r},function(t,e,n){function r(t){var e=this.__data__,n=o(e,t);return n<0?void 0:e[n][1]}var o=n(4);t.exports=r},function(t,e,n){function r(t){return o(this.__data__,t)>-1}var o=n(4);t.exports=r},function(t,e,n){function r(t,e){var n=this.__data__,r=o(n,t);return r<0?(++this.size,n.push([t,e])):n[r][1]=e,this}var o=n(4);t.exports=r},function(t,e,n){function r(){this.size=0,this.__data__={hash:new o,map:new(l||i),string:new o}}var o=n(46),i=n(3),l=n(16);t.exports=r},function(t,e,n){function r(t){var e=o(this,t).delete(t);return this.size-=e?1:0,e}var o=n(6);t.exports=r},function(t,e,n){function r(t){return o(this,t).get(t)}var o=n(6);t.exports=r},function(t,e,n){function r(t){return o(this,t).has(t)}var o=n(6);t.exports=r},function(t,e,n){function r(t,e){var n=o(this,t),r=n.size;return n.set(t,e),this.size+=n.size==r?0:1,this}var o=n(6);t.exports=r},function(t,e){function n(t){var e=[];if(null!=t)for(var n in Object(t))e.push(n);return e}t.exports=n},function(t,e,n){(function(t){var r=n(23),o="object"==typeof e&&e&&!e.nodeType&&e,i=o&&"object"==typeof t&&t&&!t.nodeType&&t,l=i&&i.exports===o,a=l&&r.process,s=function(){try{var t=i&&i.require&&i.require("util").types;return t||a&&a.binding&&a.binding("util")}catch(t){}}();t.exports=s}).call(e,n(14)(t))},function(t,e){function n(t){return o.call(t)}var r=Object.prototype,o=r.toString;t.exports=n},function(t,e){function n(t,e){return function(n){return t(e(n))}}t.exports=n},function(t,e,n){function r(t,e,n){return e=i(void 0===e?t.length-1:e,0),function(){for(var r=arguments,l=-1,a=i(r.length-e,0),s=Array(a);++l<a;)s[l]=r[e+l];l=-1;for(var u=Array(e+1);++l<e;)u[l]=r[l];return u[e]=n(s),o(t,this,u)}}var o=n(18),i=Math.max;t.exports=r},function(t,e,n){var r=n(59),o=n(98),i=o(r);t.exports=i},function(t,e){function n(t){var e=0,n=0;return function(){var l=i(),a=o-(l-n);if(n=l,a>0){if(++e>=r)return arguments[0]}else e=0;return t.apply(void 0,arguments)}}var r=800,o=16,i=Date.now;t.exports=n},function(t,e,n){function r(){this.__data__=new o,this.size=0}var o=n(3);t.exports=r},function(t,e){function n(t){var e=this.__data__,n=e.delete(t);return this.size=e.size,n}t.exports=n},function(t,e){function n(t){return this.__data__.get(t)}t.exports=n},function(t,e){function n(t){return this.__data__.has(t)}t.exports=n},function(t,e,n){function r(t,e){var n=this.__data__;if(n instanceof o){var r=n.__data__;if(!i||r.length<a-1)return r.push([t,e]),this.size=++n.size,this;n=this.__data__=new l(r)}return n.set(t,e),this.size=n.size,this}var o=n(3),i=n(16),l=n(47),a=200;t.exports=r},function(t,e){function n(t){if(null!=t){try{return o.call(t)}catch(t){}try{return t+""}catch(t){}}return""}var r=Function.prototype,o=r.toString;t.exports=n},function(t,e){function n(t){return function(){return t}}t.exports=n},function(t,e,n){function r(t){return i(t)&&o(t)}var o=n(12),i=n(2);t.exports=r},function(t,e,n){function r(t){if(!l(t)||o(t)!=a)return!1;var e=i(t);if(null===e)return!0;var n=f.call(e,"constructor")&&e.constructor;return"function"==typeof n&&n instanceof n&&c.call(n)==h}var o=n(5),i=n(24),l=n(2),a="[object Object]",s=Function.prototype,u=Object.prototype,c=s.toString,f=u.hasOwnProperty,h=c.call(Object);t.exports=r},function(t,e,n){var r=n(20),o=n(68),i=o(function(t,e,n,o){r(t,e,n,o)});t.exports=i},function(t,e){function n(){return!1}t.exports=n},function(t,e,n){function r(t){return o(t,i(t))}var o=n(66),i=n(34);t.exports=r},function(t,e){t.exports='<svg viewbox="0 0 18 18">\n  <line class="ql-stroke" x1="15" x2="3" y1="9" y2="9"></line>\n  <line class="ql-stroke" x1="14" x2="4" y1="14" y2="14"></line>\n  <line class="ql-stroke" x1="12" x2="6" y1="4" y2="4"></line>\n</svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18">\n  <line class="ql-stroke" x1="3" x2="15" y1="9" y2="9"></line>\n  <line class="ql-stroke" x1="3" x2="13" y1="14" y2="14"></line>\n  <line class="ql-stroke" x1="3" x2="9" y1="4" y2="4"></line>\n</svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18">\n  <line class="ql-stroke" x1="15" x2="3" y1="9" y2="9"></line>\n  <line class="ql-stroke" x1="15" x2="5" y1="14" y2="14"></line>\n  <line class="ql-stroke" x1="15" x2="9" y1="4" y2="4"></line>\n</svg>'}])});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/quill/dist/quill.js")))

/***/ }),

/***/ "./node_modules/quill/dist/quill.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {/*!
 * Quill Editor v1.3.6
 * https://quilljs.com/
 * Copyright (c) 2014, Jason Chen
 * Copyright (c) 2013, salesforce.com
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Quill"] = factory();
	else
		root["Quill"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 109);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var container_1 = __webpack_require__(17);
var format_1 = __webpack_require__(18);
var leaf_1 = __webpack_require__(19);
var scroll_1 = __webpack_require__(45);
var inline_1 = __webpack_require__(46);
var block_1 = __webpack_require__(47);
var embed_1 = __webpack_require__(48);
var text_1 = __webpack_require__(49);
var attributor_1 = __webpack_require__(12);
var class_1 = __webpack_require__(32);
var style_1 = __webpack_require__(33);
var store_1 = __webpack_require__(31);
var Registry = __webpack_require__(1);
var Parchment = {
    Scope: Registry.Scope,
    create: Registry.create,
    find: Registry.find,
    query: Registry.query,
    register: Registry.register,
    Container: container_1.default,
    Format: format_1.default,
    Leaf: leaf_1.default,
    Embed: embed_1.default,
    Scroll: scroll_1.default,
    Block: block_1.default,
    Inline: inline_1.default,
    Text: text_1.default,
    Attributor: {
        Attribute: attributor_1.default,
        Class: class_1.default,
        Style: style_1.default,
        Store: store_1.default,
    },
};
exports.default = Parchment;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ParchmentError = /** @class */ (function (_super) {
    __extends(ParchmentError, _super);
    function ParchmentError(message) {
        var _this = this;
        message = '[Parchment] ' + message;
        _this = _super.call(this, message) || this;
        _this.message = message;
        _this.name = _this.constructor.name;
        return _this;
    }
    return ParchmentError;
}(Error));
exports.ParchmentError = ParchmentError;
var attributes = {};
var classes = {};
var tags = {};
var types = {};
exports.DATA_KEY = '__blot';
var Scope;
(function (Scope) {
    Scope[Scope["TYPE"] = 3] = "TYPE";
    Scope[Scope["LEVEL"] = 12] = "LEVEL";
    Scope[Scope["ATTRIBUTE"] = 13] = "ATTRIBUTE";
    Scope[Scope["BLOT"] = 14] = "BLOT";
    Scope[Scope["INLINE"] = 7] = "INLINE";
    Scope[Scope["BLOCK"] = 11] = "BLOCK";
    Scope[Scope["BLOCK_BLOT"] = 10] = "BLOCK_BLOT";
    Scope[Scope["INLINE_BLOT"] = 6] = "INLINE_BLOT";
    Scope[Scope["BLOCK_ATTRIBUTE"] = 9] = "BLOCK_ATTRIBUTE";
    Scope[Scope["INLINE_ATTRIBUTE"] = 5] = "INLINE_ATTRIBUTE";
    Scope[Scope["ANY"] = 15] = "ANY";
})(Scope = exports.Scope || (exports.Scope = {}));
function create(input, value) {
    var match = query(input);
    if (match == null) {
        throw new ParchmentError("Unable to create " + input + " blot");
    }
    var BlotClass = match;
    var node = 
    // @ts-ignore
    input instanceof Node || input['nodeType'] === Node.TEXT_NODE ? input : BlotClass.create(value);
    return new BlotClass(node, value);
}
exports.create = create;
function find(node, bubble) {
    if (bubble === void 0) { bubble = false; }
    if (node == null)
        return null;
    // @ts-ignore
    if (node[exports.DATA_KEY] != null)
        return node[exports.DATA_KEY].blot;
    if (bubble)
        return find(node.parentNode, bubble);
    return null;
}
exports.find = find;
function query(query, scope) {
    if (scope === void 0) { scope = Scope.ANY; }
    var match;
    if (typeof query === 'string') {
        match = types[query] || attributes[query];
        // @ts-ignore
    }
    else if (query instanceof Text || query['nodeType'] === Node.TEXT_NODE) {
        match = types['text'];
    }
    else if (typeof query === 'number') {
        if (query & Scope.LEVEL & Scope.BLOCK) {
            match = types['block'];
        }
        else if (query & Scope.LEVEL & Scope.INLINE) {
            match = types['inline'];
        }
    }
    else if (query instanceof HTMLElement) {
        var names = (query.getAttribute('class') || '').split(/\s+/);
        for (var i in names) {
            match = classes[names[i]];
            if (match)
                break;
        }
        match = match || tags[query.tagName];
    }
    if (match == null)
        return null;
    // @ts-ignore
    if (scope & Scope.LEVEL & match.scope && scope & Scope.TYPE & match.scope)
        return match;
    return null;
}
exports.query = query;
function register() {
    var Definitions = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        Definitions[_i] = arguments[_i];
    }
    if (Definitions.length > 1) {
        return Definitions.map(function (d) {
            return register(d);
        });
    }
    var Definition = Definitions[0];
    if (typeof Definition.blotName !== 'string' && typeof Definition.attrName !== 'string') {
        throw new ParchmentError('Invalid definition');
    }
    else if (Definition.blotName === 'abstract') {
        throw new ParchmentError('Cannot register abstract class');
    }
    types[Definition.blotName || Definition.attrName] = Definition;
    if (typeof Definition.keyName === 'string') {
        attributes[Definition.keyName] = Definition;
    }
    else {
        if (Definition.className != null) {
            classes[Definition.className] = Definition;
        }
        if (Definition.tagName != null) {
            if (Array.isArray(Definition.tagName)) {
                Definition.tagName = Definition.tagName.map(function (tagName) {
                    return tagName.toUpperCase();
                });
            }
            else {
                Definition.tagName = Definition.tagName.toUpperCase();
            }
            var tagNames = Array.isArray(Definition.tagName) ? Definition.tagName : [Definition.tagName];
            tagNames.forEach(function (tag) {
                if (tags[tag] == null || Definition.className == null) {
                    tags[tag] = Definition;
                }
            });
        }
    }
    return Definition;
}
exports.register = register;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var diff = __webpack_require__(51);
var equal = __webpack_require__(11);
var extend = __webpack_require__(3);
var op = __webpack_require__(20);


var NULL_CHARACTER = String.fromCharCode(0);  // Placeholder char for embed in diff()


var Delta = function (ops) {
  // Assume we are given a well formed ops
  if (Array.isArray(ops)) {
    this.ops = ops;
  } else if (ops != null && Array.isArray(ops.ops)) {
    this.ops = ops.ops;
  } else {
    this.ops = [];
  }
};


Delta.prototype.insert = function (text, attributes) {
  var newOp = {};
  if (text.length === 0) return this;
  newOp.insert = text;
  if (attributes != null && typeof attributes === 'object' && Object.keys(attributes).length > 0) {
    newOp.attributes = attributes;
  }
  return this.push(newOp);
};

Delta.prototype['delete'] = function (length) {
  if (length <= 0) return this;
  return this.push({ 'delete': length });
};

Delta.prototype.retain = function (length, attributes) {
  if (length <= 0) return this;
  var newOp = { retain: length };
  if (attributes != null && typeof attributes === 'object' && Object.keys(attributes).length > 0) {
    newOp.attributes = attributes;
  }
  return this.push(newOp);
};

Delta.prototype.push = function (newOp) {
  var index = this.ops.length;
  var lastOp = this.ops[index - 1];
  newOp = extend(true, {}, newOp);
  if (typeof lastOp === 'object') {
    if (typeof newOp['delete'] === 'number' && typeof lastOp['delete'] === 'number') {
      this.ops[index - 1] = { 'delete': lastOp['delete'] + newOp['delete'] };
      return this;
    }
    // Since it does not matter if we insert before or after deleting at the same index,
    // always prefer to insert first
    if (typeof lastOp['delete'] === 'number' && newOp.insert != null) {
      index -= 1;
      lastOp = this.ops[index - 1];
      if (typeof lastOp !== 'object') {
        this.ops.unshift(newOp);
        return this;
      }
    }
    if (equal(newOp.attributes, lastOp.attributes)) {
      if (typeof newOp.insert === 'string' && typeof lastOp.insert === 'string') {
        this.ops[index - 1] = { insert: lastOp.insert + newOp.insert };
        if (typeof newOp.attributes === 'object') this.ops[index - 1].attributes = newOp.attributes
        return this;
      } else if (typeof newOp.retain === 'number' && typeof lastOp.retain === 'number') {
        this.ops[index - 1] = { retain: lastOp.retain + newOp.retain };
        if (typeof newOp.attributes === 'object') this.ops[index - 1].attributes = newOp.attributes
        return this;
      }
    }
  }
  if (index === this.ops.length) {
    this.ops.push(newOp);
  } else {
    this.ops.splice(index, 0, newOp);
  }
  return this;
};

Delta.prototype.chop = function () {
  var lastOp = this.ops[this.ops.length - 1];
  if (lastOp && lastOp.retain && !lastOp.attributes) {
    this.ops.pop();
  }
  return this;
};

Delta.prototype.filter = function (predicate) {
  return this.ops.filter(predicate);
};

Delta.prototype.forEach = function (predicate) {
  this.ops.forEach(predicate);
};

Delta.prototype.map = function (predicate) {
  return this.ops.map(predicate);
};

Delta.prototype.partition = function (predicate) {
  var passed = [], failed = [];
  this.forEach(function(op) {
    var target = predicate(op) ? passed : failed;
    target.push(op);
  });
  return [passed, failed];
};

Delta.prototype.reduce = function (predicate, initial) {
  return this.ops.reduce(predicate, initial);
};

Delta.prototype.changeLength = function () {
  return this.reduce(function (length, elem) {
    if (elem.insert) {
      return length + op.length(elem);
    } else if (elem.delete) {
      return length - elem.delete;
    }
    return length;
  }, 0);
};

Delta.prototype.length = function () {
  return this.reduce(function (length, elem) {
    return length + op.length(elem);
  }, 0);
};

Delta.prototype.slice = function (start, end) {
  start = start || 0;
  if (typeof end !== 'number') end = Infinity;
  var ops = [];
  var iter = op.iterator(this.ops);
  var index = 0;
  while (index < end && iter.hasNext()) {
    var nextOp;
    if (index < start) {
      nextOp = iter.next(start - index);
    } else {
      nextOp = iter.next(end - index);
      ops.push(nextOp);
    }
    index += op.length(nextOp);
  }
  return new Delta(ops);
};


Delta.prototype.compose = function (other) {
  var thisIter = op.iterator(this.ops);
  var otherIter = op.iterator(other.ops);
  var delta = new Delta();
  while (thisIter.hasNext() || otherIter.hasNext()) {
    if (otherIter.peekType() === 'insert') {
      delta.push(otherIter.next());
    } else if (thisIter.peekType() === 'delete') {
      delta.push(thisIter.next());
    } else {
      var length = Math.min(thisIter.peekLength(), otherIter.peekLength());
      var thisOp = thisIter.next(length);
      var otherOp = otherIter.next(length);
      if (typeof otherOp.retain === 'number') {
        var newOp = {};
        if (typeof thisOp.retain === 'number') {
          newOp.retain = length;
        } else {
          newOp.insert = thisOp.insert;
        }
        // Preserve null when composing with a retain, otherwise remove it for inserts
        var attributes = op.attributes.compose(thisOp.attributes, otherOp.attributes, typeof thisOp.retain === 'number');
        if (attributes) newOp.attributes = attributes;
        delta.push(newOp);
      // Other op should be delete, we could be an insert or retain
      // Insert + delete cancels out
      } else if (typeof otherOp['delete'] === 'number' && typeof thisOp.retain === 'number') {
        delta.push(otherOp);
      }
    }
  }
  return delta.chop();
};

Delta.prototype.concat = function (other) {
  var delta = new Delta(this.ops.slice());
  if (other.ops.length > 0) {
    delta.push(other.ops[0]);
    delta.ops = delta.ops.concat(other.ops.slice(1));
  }
  return delta;
};

Delta.prototype.diff = function (other, index) {
  if (this.ops === other.ops) {
    return new Delta();
  }
  var strings = [this, other].map(function (delta) {
    return delta.map(function (op) {
      if (op.insert != null) {
        return typeof op.insert === 'string' ? op.insert : NULL_CHARACTER;
      }
      var prep = (delta === other) ? 'on' : 'with';
      throw new Error('diff() called ' + prep + ' non-document');
    }).join('');
  });
  var delta = new Delta();
  var diffResult = diff(strings[0], strings[1], index);
  var thisIter = op.iterator(this.ops);
  var otherIter = op.iterator(other.ops);
  diffResult.forEach(function (component) {
    var length = component[1].length;
    while (length > 0) {
      var opLength = 0;
      switch (component[0]) {
        case diff.INSERT:
          opLength = Math.min(otherIter.peekLength(), length);
          delta.push(otherIter.next(opLength));
          break;
        case diff.DELETE:
          opLength = Math.min(length, thisIter.peekLength());
          thisIter.next(opLength);
          delta['delete'](opLength);
          break;
        case diff.EQUAL:
          opLength = Math.min(thisIter.peekLength(), otherIter.peekLength(), length);
          var thisOp = thisIter.next(opLength);
          var otherOp = otherIter.next(opLength);
          if (equal(thisOp.insert, otherOp.insert)) {
            delta.retain(opLength, op.attributes.diff(thisOp.attributes, otherOp.attributes));
          } else {
            delta.push(otherOp)['delete'](opLength);
          }
          break;
      }
      length -= opLength;
    }
  });
  return delta.chop();
};

Delta.prototype.eachLine = function (predicate, newline) {
  newline = newline || '\n';
  var iter = op.iterator(this.ops);
  var line = new Delta();
  var i = 0;
  while (iter.hasNext()) {
    if (iter.peekType() !== 'insert') return;
    var thisOp = iter.peek();
    var start = op.length(thisOp) - iter.peekLength();
    var index = typeof thisOp.insert === 'string' ?
      thisOp.insert.indexOf(newline, start) - start : -1;
    if (index < 0) {
      line.push(iter.next());
    } else if (index > 0) {
      line.push(iter.next(index));
    } else {
      if (predicate(line, iter.next(1).attributes || {}, i) === false) {
        return;
      }
      i += 1;
      line = new Delta();
    }
  }
  if (line.length() > 0) {
    predicate(line, {}, i);
  }
};

Delta.prototype.transform = function (other, priority) {
  priority = !!priority;
  if (typeof other === 'number') {
    return this.transformPosition(other, priority);
  }
  var thisIter = op.iterator(this.ops);
  var otherIter = op.iterator(other.ops);
  var delta = new Delta();
  while (thisIter.hasNext() || otherIter.hasNext()) {
    if (thisIter.peekType() === 'insert' && (priority || otherIter.peekType() !== 'insert')) {
      delta.retain(op.length(thisIter.next()));
    } else if (otherIter.peekType() === 'insert') {
      delta.push(otherIter.next());
    } else {
      var length = Math.min(thisIter.peekLength(), otherIter.peekLength());
      var thisOp = thisIter.next(length);
      var otherOp = otherIter.next(length);
      if (thisOp['delete']) {
        // Our delete either makes their delete redundant or removes their retain
        continue;
      } else if (otherOp['delete']) {
        delta.push(otherOp);
      } else {
        // We retain either their retain or insert
        delta.retain(length, op.attributes.transform(thisOp.attributes, otherOp.attributes, priority));
      }
    }
  }
  return delta.chop();
};

Delta.prototype.transformPosition = function (index, priority) {
  priority = !!priority;
  var thisIter = op.iterator(this.ops);
  var offset = 0;
  while (thisIter.hasNext() && offset <= index) {
    var length = thisIter.peekLength();
    var nextType = thisIter.peekType();
    thisIter.next();
    if (nextType === 'delete') {
      index -= Math.min(length, index - offset);
      continue;
    } else if (nextType === 'insert' && (offset < index || !priority)) {
      index += length;
    }
    offset += length;
  }
  return index;
};


module.exports = Delta;


/***/ }),
/* 3 */
/***/ (function(module, exports) {

'use strict';

var hasOwn = Object.prototype.hasOwnProperty;
var toStr = Object.prototype.toString;

var isArray = function isArray(arr) {
	if (typeof Array.isArray === 'function') {
		return Array.isArray(arr);
	}

	return toStr.call(arr) === '[object Array]';
};

var isPlainObject = function isPlainObject(obj) {
	if (!obj || toStr.call(obj) !== '[object Object]') {
		return false;
	}

	var hasOwnConstructor = hasOwn.call(obj, 'constructor');
	var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
	// Not own constructor property must be Object
	if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
		return false;
	}

	// Own properties are enumerated firstly, so to speed up,
	// if last one is own, then all properties are own.
	var key;
	for (key in obj) { /**/ }

	return typeof key === 'undefined' || hasOwn.call(obj, key);
};

module.exports = function extend() {
	var options, name, src, copy, copyIsArray, clone;
	var target = arguments[0];
	var i = 1;
	var length = arguments.length;
	var deep = false;

	// Handle a deep copy situation
	if (typeof target === 'boolean') {
		deep = target;
		target = arguments[1] || {};
		// skip the boolean and the target
		i = 2;
	}
	if (target == null || (typeof target !== 'object' && typeof target !== 'function')) {
		target = {};
	}

	for (; i < length; ++i) {
		options = arguments[i];
		// Only deal with non-null/undefined values
		if (options != null) {
			// Extend the base object
			for (name in options) {
				src = target[name];
				copy = options[name];

				// Prevent never-ending loop
				if (target !== copy) {
					// Recurse if we're merging plain objects or arrays
					if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
						if (copyIsArray) {
							copyIsArray = false;
							clone = src && isArray(src) ? src : [];
						} else {
							clone = src && isPlainObject(src) ? src : {};
						}

						// Never move original objects, clone them
						target[name] = extend(deep, clone, copy);

					// Don't bring in undefined values
					} else if (typeof copy !== 'undefined') {
						target[name] = copy;
					}
				}
			}
		}
	}

	// Return the modified object
	return target;
};


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BlockEmbed = exports.bubbleFormats = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _extend = __webpack_require__(3);

var _extend2 = _interopRequireDefault(_extend);

var _quillDelta = __webpack_require__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _break = __webpack_require__(16);

var _break2 = _interopRequireDefault(_break);

var _inline = __webpack_require__(6);

var _inline2 = _interopRequireDefault(_inline);

var _text = __webpack_require__(7);

var _text2 = _interopRequireDefault(_text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NEWLINE_LENGTH = 1;

var BlockEmbed = function (_Parchment$Embed) {
  _inherits(BlockEmbed, _Parchment$Embed);

  function BlockEmbed() {
    _classCallCheck(this, BlockEmbed);

    return _possibleConstructorReturn(this, (BlockEmbed.__proto__ || Object.getPrototypeOf(BlockEmbed)).apply(this, arguments));
  }

  _createClass(BlockEmbed, [{
    key: 'attach',
    value: function attach() {
      _get(BlockEmbed.prototype.__proto__ || Object.getPrototypeOf(BlockEmbed.prototype), 'attach', this).call(this);
      this.attributes = new _parchment2.default.Attributor.Store(this.domNode);
    }
  }, {
    key: 'delta',
    value: function delta() {
      return new _quillDelta2.default().insert(this.value(), (0, _extend2.default)(this.formats(), this.attributes.values()));
    }
  }, {
    key: 'format',
    value: function format(name, value) {
      var attribute = _parchment2.default.query(name, _parchment2.default.Scope.BLOCK_ATTRIBUTE);
      if (attribute != null) {
        this.attributes.attribute(attribute, value);
      }
    }
  }, {
    key: 'formatAt',
    value: function formatAt(index, length, name, value) {
      this.format(name, value);
    }
  }, {
    key: 'insertAt',
    value: function insertAt(index, value, def) {
      if (typeof value === 'string' && value.endsWith('\n')) {
        var block = _parchment2.default.create(Block.blotName);
        this.parent.insertBefore(block, index === 0 ? this : this.next);
        block.insertAt(0, value.slice(0, -1));
      } else {
        _get(BlockEmbed.prototype.__proto__ || Object.getPrototypeOf(BlockEmbed.prototype), 'insertAt', this).call(this, index, value, def);
      }
    }
  }]);

  return BlockEmbed;
}(_parchment2.default.Embed);

BlockEmbed.scope = _parchment2.default.Scope.BLOCK_BLOT;
// It is important for cursor behavior BlockEmbeds use tags that are block level elements


var Block = function (_Parchment$Block) {
  _inherits(Block, _Parchment$Block);

  function Block(domNode) {
    _classCallCheck(this, Block);

    var _this2 = _possibleConstructorReturn(this, (Block.__proto__ || Object.getPrototypeOf(Block)).call(this, domNode));

    _this2.cache = {};
    return _this2;
  }

  _createClass(Block, [{
    key: 'delta',
    value: function delta() {
      if (this.cache.delta == null) {
        this.cache.delta = this.descendants(_parchment2.default.Leaf).reduce(function (delta, leaf) {
          if (leaf.length() === 0) {
            return delta;
          } else {
            return delta.insert(leaf.value(), bubbleFormats(leaf));
          }
        }, new _quillDelta2.default()).insert('\n', bubbleFormats(this));
      }
      return this.cache.delta;
    }
  }, {
    key: 'deleteAt',
    value: function deleteAt(index, length) {
      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'deleteAt', this).call(this, index, length);
      this.cache = {};
    }
  }, {
    key: 'formatAt',
    value: function formatAt(index, length, name, value) {
      if (length <= 0) return;
      if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK)) {
        if (index + length === this.length()) {
          this.format(name, value);
        }
      } else {
        _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'formatAt', this).call(this, index, Math.min(length, this.length() - index - 1), name, value);
      }
      this.cache = {};
    }
  }, {
    key: 'insertAt',
    value: function insertAt(index, value, def) {
      if (def != null) return _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertAt', this).call(this, index, value, def);
      if (value.length === 0) return;
      var lines = value.split('\n');
      var text = lines.shift();
      if (text.length > 0) {
        if (index < this.length() - 1 || this.children.tail == null) {
          _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertAt', this).call(this, Math.min(index, this.length() - 1), text);
        } else {
          this.children.tail.insertAt(this.children.tail.length(), text);
        }
        this.cache = {};
      }
      var block = this;
      lines.reduce(function (index, line) {
        block = block.split(index, true);
        block.insertAt(0, line);
        return line.length;
      }, index + text.length);
    }
  }, {
    key: 'insertBefore',
    value: function insertBefore(blot, ref) {
      var head = this.children.head;
      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertBefore', this).call(this, blot, ref);
      if (head instanceof _break2.default) {
        head.remove();
      }
      this.cache = {};
    }
  }, {
    key: 'length',
    value: function length() {
      if (this.cache.length == null) {
        this.cache.length = _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'length', this).call(this) + NEWLINE_LENGTH;
      }
      return this.cache.length;
    }
  }, {
    key: 'moveChildren',
    value: function moveChildren(target, ref) {
      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'moveChildren', this).call(this, target, ref);
      this.cache = {};
    }
  }, {
    key: 'optimize',
    value: function optimize(context) {
      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'optimize', this).call(this, context);
      this.cache = {};
    }
  }, {
    key: 'path',
    value: function path(index) {
      return _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'path', this).call(this, index, true);
    }
  }, {
    key: 'removeChild',
    value: function removeChild(child) {
      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'removeChild', this).call(this, child);
      this.cache = {};
    }
  }, {
    key: 'split',
    value: function split(index) {
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (force && (index === 0 || index >= this.length() - NEWLINE_LENGTH)) {
        var clone = this.clone();
        if (index === 0) {
          this.parent.insertBefore(clone, this);
          return this;
        } else {
          this.parent.insertBefore(clone, this.next);
          return clone;
        }
      } else {
        var next = _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'split', this).call(this, index, force);
        this.cache = {};
        return next;
      }
    }
  }]);

  return Block;
}(_parchment2.default.Block);

Block.blotName = 'block';
Block.tagName = 'P';
Block.defaultChild = 'break';
Block.allowedChildren = [_inline2.default, _parchment2.default.Embed, _text2.default];

function bubbleFormats(blot) {
  var formats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (blot == null) return formats;
  if (typeof blot.formats === 'function') {
    formats = (0, _extend2.default)(formats, blot.formats());
  }
  if (blot.parent == null || blot.parent.blotName == 'scroll' || blot.parent.statics.scope !== blot.statics.scope) {
    return formats;
  }
  return bubbleFormats(blot.parent, formats);
}

exports.bubbleFormats = bubbleFormats;
exports.BlockEmbed = BlockEmbed;
exports.default = Block;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.overload = exports.expandConfig = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(50);

var _quillDelta = __webpack_require__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _editor = __webpack_require__(14);

var _editor2 = _interopRequireDefault(_editor);

var _emitter3 = __webpack_require__(8);

var _emitter4 = _interopRequireDefault(_emitter3);

var _module = __webpack_require__(9);

var _module2 = _interopRequireDefault(_module);

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _selection = __webpack_require__(15);

var _selection2 = _interopRequireDefault(_selection);

var _extend = __webpack_require__(3);

var _extend2 = _interopRequireDefault(_extend);

var _logger = __webpack_require__(10);

var _logger2 = _interopRequireDefault(_logger);

var _theme = __webpack_require__(34);

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var debug = (0, _logger2.default)('quill');

var Quill = function () {
  _createClass(Quill, null, [{
    key: 'debug',
    value: function debug(limit) {
      if (limit === true) {
        limit = 'log';
      }
      _logger2.default.level(limit);
    }
  }, {
    key: 'find',
    value: function find(node) {
      return node.__quill || _parchment2.default.find(node);
    }
  }, {
    key: 'import',
    value: function _import(name) {
      if (this.imports[name] == null) {
        debug.error('Cannot import ' + name + '. Are you sure it was registered?');
      }
      return this.imports[name];
    }
  }, {
    key: 'register',
    value: function register(path, target) {
      var _this = this;

      var overwrite = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (typeof path !== 'string') {
        var name = path.attrName || path.blotName;
        if (typeof name === 'string') {
          // register(Blot | Attributor, overwrite)
          this.register('formats/' + name, path, target);
        } else {
          Object.keys(path).forEach(function (key) {
            _this.register(key, path[key], target);
          });
        }
      } else {
        if (this.imports[path] != null && !overwrite) {
          debug.warn('Overwriting ' + path + ' with', target);
        }
        this.imports[path] = target;
        if ((path.startsWith('blots/') || path.startsWith('formats/')) && target.blotName !== 'abstract') {
          _parchment2.default.register(target);
        } else if (path.startsWith('modules') && typeof target.register === 'function') {
          target.register();
        }
      }
    }
  }]);

  function Quill(container) {
    var _this2 = this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Quill);

    this.options = expandConfig(container, options);
    this.container = this.options.container;
    if (this.container == null) {
      return debug.error('Invalid Quill container', container);
    }
    if (this.options.debug) {
      Quill.debug(this.options.debug);
    }
    var html = this.container.innerHTML.trim();
    this.container.classList.add('ql-container');
    this.container.innerHTML = '';
    this.container.__quill = this;
    this.root = this.addContainer('ql-editor');
    this.root.classList.add('ql-blank');
    this.root.setAttribute('data-gramm', false);
    this.scrollingContainer = this.options.scrollingContainer || this.root;
    this.emitter = new _emitter4.default();
    this.scroll = _parchment2.default.create(this.root, {
      emitter: this.emitter,
      whitelist: this.options.formats
    });
    this.editor = new _editor2.default(this.scroll);
    this.selection = new _selection2.default(this.scroll, this.emitter);
    this.theme = new this.options.theme(this, this.options);
    this.keyboard = this.theme.addModule('keyboard');
    this.clipboard = this.theme.addModule('clipboard');
    this.history = this.theme.addModule('history');
    this.theme.init();
    this.emitter.on(_emitter4.default.events.EDITOR_CHANGE, function (type) {
      if (type === _emitter4.default.events.TEXT_CHANGE) {
        _this2.root.classList.toggle('ql-blank', _this2.editor.isBlank());
      }
    });
    this.emitter.on(_emitter4.default.events.SCROLL_UPDATE, function (source, mutations) {
      var range = _this2.selection.lastRange;
      var index = range && range.length === 0 ? range.index : undefined;
      modify.call(_this2, function () {
        return _this2.editor.update(null, mutations, index);
      }, source);
    });
    var contents = this.clipboard.convert('<div class=\'ql-editor\' style="white-space: normal;">' + html + '<p><br></p></div>');
    this.setContents(contents);
    this.history.clear();
    if (this.options.placeholder) {
      this.root.setAttribute('data-placeholder', this.options.placeholder);
    }
    if (this.options.readOnly) {
      this.disable();
    }
  }

  _createClass(Quill, [{
    key: 'addContainer',
    value: function addContainer(container) {
      var refNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (typeof container === 'string') {
        var className = container;
        container = document.createElement('div');
        container.classList.add(className);
      }
      this.container.insertBefore(container, refNode);
      return container;
    }
  }, {
    key: 'blur',
    value: function blur() {
      this.selection.setRange(null);
    }
  }, {
    key: 'deleteText',
    value: function deleteText(index, length, source) {
      var _this3 = this;

      var _overload = overload(index, length, source);

      var _overload2 = _slicedToArray(_overload, 4);

      index = _overload2[0];
      length = _overload2[1];
      source = _overload2[3];

      return modify.call(this, function () {
        return _this3.editor.deleteText(index, length);
      }, source, index, -1 * length);
    }
  }, {
    key: 'disable',
    value: function disable() {
      this.enable(false);
    }
  }, {
    key: 'enable',
    value: function enable() {
      var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      this.scroll.enable(enabled);
      this.container.classList.toggle('ql-disabled', !enabled);
    }
  }, {
    key: 'focus',
    value: function focus() {
      var scrollTop = this.scrollingContainer.scrollTop;
      this.selection.focus();
      this.scrollingContainer.scrollTop = scrollTop;
      this.scrollIntoView();
    }
  }, {
    key: 'format',
    value: function format(name, value) {
      var _this4 = this;

      var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _emitter4.default.sources.API;

      return modify.call(this, function () {
        var range = _this4.getSelection(true);
        var change = new _quillDelta2.default();
        if (range == null) {
          return change;
        } else if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK)) {
          change = _this4.editor.formatLine(range.index, range.length, _defineProperty({}, name, value));
        } else if (range.length === 0) {
          _this4.selection.format(name, value);
          return change;
        } else {
          change = _this4.editor.formatText(range.index, range.length, _defineProperty({}, name, value));
        }
        _this4.setSelection(range, _emitter4.default.sources.SILENT);
        return change;
      }, source);
    }
  }, {
    key: 'formatLine',
    value: function formatLine(index, length, name, value, source) {
      var _this5 = this;

      var formats = void 0;

      var _overload3 = overload(index, length, name, value, source);

      var _overload4 = _slicedToArray(_overload3, 4);

      index = _overload4[0];
      length = _overload4[1];
      formats = _overload4[2];
      source = _overload4[3];

      return modify.call(this, function () {
        return _this5.editor.formatLine(index, length, formats);
      }, source, index, 0);
    }
  }, {
    key: 'formatText',
    value: function formatText(index, length, name, value, source) {
      var _this6 = this;

      var formats = void 0;

      var _overload5 = overload(index, length, name, value, source);

      var _overload6 = _slicedToArray(_overload5, 4);

      index = _overload6[0];
      length = _overload6[1];
      formats = _overload6[2];
      source = _overload6[3];

      return modify.call(this, function () {
        return _this6.editor.formatText(index, length, formats);
      }, source, index, 0);
    }
  }, {
    key: 'getBounds',
    value: function getBounds(index) {
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var bounds = void 0;
      if (typeof index === 'number') {
        bounds = this.selection.getBounds(index, length);
      } else {
        bounds = this.selection.getBounds(index.index, index.length);
      }
      var containerBounds = this.container.getBoundingClientRect();
      return {
        bottom: bounds.bottom - containerBounds.top,
        height: bounds.height,
        left: bounds.left - containerBounds.left,
        right: bounds.right - containerBounds.left,
        top: bounds.top - containerBounds.top,
        width: bounds.width
      };
    }
  }, {
    key: 'getContents',
    value: function getContents() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;

      var _overload7 = overload(index, length);

      var _overload8 = _slicedToArray(_overload7, 2);

      index = _overload8[0];
      length = _overload8[1];

      return this.editor.getContents(index, length);
    }
  }, {
    key: 'getFormat',
    value: function getFormat() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getSelection(true);
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (typeof index === 'number') {
        return this.editor.getFormat(index, length);
      } else {
        return this.editor.getFormat(index.index, index.length);
      }
    }
  }, {
    key: 'getIndex',
    value: function getIndex(blot) {
      return blot.offset(this.scroll);
    }
  }, {
    key: 'getLength',
    value: function getLength() {
      return this.scroll.length();
    }
  }, {
    key: 'getLeaf',
    value: function getLeaf(index) {
      return this.scroll.leaf(index);
    }
  }, {
    key: 'getLine',
    value: function getLine(index) {
      return this.scroll.line(index);
    }
  }, {
    key: 'getLines',
    value: function getLines() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;

      if (typeof index !== 'number') {
        return this.scroll.lines(index.index, index.length);
      } else {
        return this.scroll.lines(index, length);
      }
    }
  }, {
    key: 'getModule',
    value: function getModule(name) {
      return this.theme.modules[name];
    }
  }, {
    key: 'getSelection',
    value: function getSelection() {
      var focus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (focus) this.focus();
      this.update(); // Make sure we access getRange with editor in consistent state
      return this.selection.getRange()[0];
    }
  }, {
    key: 'getText',
    value: function getText() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;

      var _overload9 = overload(index, length);

      var _overload10 = _slicedToArray(_overload9, 2);

      index = _overload10[0];
      length = _overload10[1];

      return this.editor.getText(index, length);
    }
  }, {
    key: 'hasFocus',
    value: function hasFocus() {
      return this.selection.hasFocus();
    }
  }, {
    key: 'insertEmbed',
    value: function insertEmbed(index, embed, value) {
      var _this7 = this;

      var source = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Quill.sources.API;

      return modify.call(this, function () {
        return _this7.editor.insertEmbed(index, embed, value);
      }, source, index);
    }
  }, {
    key: 'insertText',
    value: function insertText(index, text, name, value, source) {
      var _this8 = this;

      var formats = void 0;

      var _overload11 = overload(index, 0, name, value, source);

      var _overload12 = _slicedToArray(_overload11, 4);

      index = _overload12[0];
      formats = _overload12[2];
      source = _overload12[3];

      return modify.call(this, function () {
        return _this8.editor.insertText(index, text, formats);
      }, source, index, text.length);
    }
  }, {
    key: 'isEnabled',
    value: function isEnabled() {
      return !this.container.classList.contains('ql-disabled');
    }
  }, {
    key: 'off',
    value: function off() {
      return this.emitter.off.apply(this.emitter, arguments);
    }
  }, {
    key: 'on',
    value: function on() {
      return this.emitter.on.apply(this.emitter, arguments);
    }
  }, {
    key: 'once',
    value: function once() {
      return this.emitter.once.apply(this.emitter, arguments);
    }
  }, {
    key: 'pasteHTML',
    value: function pasteHTML(index, html, source) {
      this.clipboard.dangerouslyPasteHTML(index, html, source);
    }
  }, {
    key: 'removeFormat',
    value: function removeFormat(index, length, source) {
      var _this9 = this;

      var _overload13 = overload(index, length, source);

      var _overload14 = _slicedToArray(_overload13, 4);

      index = _overload14[0];
      length = _overload14[1];
      source = _overload14[3];

      return modify.call(this, function () {
        return _this9.editor.removeFormat(index, length);
      }, source, index);
    }
  }, {
    key: 'scrollIntoView',
    value: function scrollIntoView() {
      this.selection.scrollIntoView(this.scrollingContainer);
    }
  }, {
    key: 'setContents',
    value: function setContents(delta) {
      var _this10 = this;

      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;

      return modify.call(this, function () {
        delta = new _quillDelta2.default(delta);
        var length = _this10.getLength();
        var deleted = _this10.editor.deleteText(0, length);
        var applied = _this10.editor.applyDelta(delta);
        var lastOp = applied.ops[applied.ops.length - 1];
        if (lastOp != null && typeof lastOp.insert === 'string' && lastOp.insert[lastOp.insert.length - 1] === '\n') {
          _this10.editor.deleteText(_this10.getLength() - 1, 1);
          applied.delete(1);
        }
        var ret = deleted.compose(applied);
        return ret;
      }, source);
    }
  }, {
    key: 'setSelection',
    value: function setSelection(index, length, source) {
      if (index == null) {
        this.selection.setRange(null, length || Quill.sources.API);
      } else {
        var _overload15 = overload(index, length, source);

        var _overload16 = _slicedToArray(_overload15, 4);

        index = _overload16[0];
        length = _overload16[1];
        source = _overload16[3];

        this.selection.setRange(new _selection.Range(index, length), source);
        if (source !== _emitter4.default.sources.SILENT) {
          this.selection.scrollIntoView(this.scrollingContainer);
        }
      }
    }
  }, {
    key: 'setText',
    value: function setText(text) {
      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;

      var delta = new _quillDelta2.default().insert(text);
      return this.setContents(delta, source);
    }
  }, {
    key: 'update',
    value: function update() {
      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _emitter4.default.sources.USER;

      var change = this.scroll.update(source); // Will update selection before selection.update() does if text changes
      this.selection.update(source);
      return change;
    }
  }, {
    key: 'updateContents',
    value: function updateContents(delta) {
      var _this11 = this;

      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;

      return modify.call(this, function () {
        delta = new _quillDelta2.default(delta);
        return _this11.editor.applyDelta(delta, source);
      }, source, true);
    }
  }]);

  return Quill;
}();

Quill.DEFAULTS = {
  bounds: null,
  formats: null,
  modules: {},
  placeholder: '',
  readOnly: false,
  scrollingContainer: null,
  strict: true,
  theme: 'default'
};
Quill.events = _emitter4.default.events;
Quill.sources = _emitter4.default.sources;
// eslint-disable-next-line no-undef
Quill.version =  false ? 'dev' : "1.3.6";

Quill.imports = {
  'delta': _quillDelta2.default,
  'parchment': _parchment2.default,
  'core/module': _module2.default,
  'core/theme': _theme2.default
};

function expandConfig(container, userConfig) {
  userConfig = (0, _extend2.default)(true, {
    container: container,
    modules: {
      clipboard: true,
      keyboard: true,
      history: true
    }
  }, userConfig);
  if (!userConfig.theme || userConfig.theme === Quill.DEFAULTS.theme) {
    userConfig.theme = _theme2.default;
  } else {
    userConfig.theme = Quill.import('themes/' + userConfig.theme);
    if (userConfig.theme == null) {
      throw new Error('Invalid theme ' + userConfig.theme + '. Did you register it?');
    }
  }
  var themeConfig = (0, _extend2.default)(true, {}, userConfig.theme.DEFAULTS);
  [themeConfig, userConfig].forEach(function (config) {
    config.modules = config.modules || {};
    Object.keys(config.modules).forEach(function (module) {
      if (config.modules[module] === true) {
        config.modules[module] = {};
      }
    });
  });
  var moduleNames = Object.keys(themeConfig.modules).concat(Object.keys(userConfig.modules));
  var moduleConfig = moduleNames.reduce(function (config, name) {
    var moduleClass = Quill.import('modules/' + name);
    if (moduleClass == null) {
      debug.error('Cannot load ' + name + ' module. Are you sure you registered it?');
    } else {
      config[name] = moduleClass.DEFAULTS || {};
    }
    return config;
  }, {});
  // Special case toolbar shorthand
  if (userConfig.modules != null && userConfig.modules.toolbar && userConfig.modules.toolbar.constructor !== Object) {
    userConfig.modules.toolbar = {
      container: userConfig.modules.toolbar
    };
  }
  userConfig = (0, _extend2.default)(true, {}, Quill.DEFAULTS, { modules: moduleConfig }, themeConfig, userConfig);
  ['bounds', 'container', 'scrollingContainer'].forEach(function (key) {
    if (typeof userConfig[key] === 'string') {
      userConfig[key] = document.querySelector(userConfig[key]);
    }
  });
  userConfig.modules = Object.keys(userConfig.modules).reduce(function (config, name) {
    if (userConfig.modules[name]) {
      config[name] = userConfig.modules[name];
    }
    return config;
  }, {});
  return userConfig;
}

// Handle selection preservation and TEXT_CHANGE emission
// common to modification APIs
function modify(modifier, source, index, shift) {
  if (this.options.strict && !this.isEnabled() && source === _emitter4.default.sources.USER) {
    return new _quillDelta2.default();
  }
  var range = index == null ? null : this.getSelection();
  var oldDelta = this.editor.delta;
  var change = modifier();
  if (range != null) {
    if (index === true) index = range.index;
    if (shift == null) {
      range = shiftRange(range, change, source);
    } else if (shift !== 0) {
      range = shiftRange(range, index, shift, source);
    }
    this.setSelection(range, _emitter4.default.sources.SILENT);
  }
  if (change.length() > 0) {
    var _emitter;

    var args = [_emitter4.default.events.TEXT_CHANGE, change, oldDelta, source];
    (_emitter = this.emitter).emit.apply(_emitter, [_emitter4.default.events.EDITOR_CHANGE].concat(args));
    if (source !== _emitter4.default.sources.SILENT) {
      var _emitter2;

      (_emitter2 = this.emitter).emit.apply(_emitter2, args);
    }
  }
  return change;
}

function overload(index, length, name, value, source) {
  var formats = {};
  if (typeof index.index === 'number' && typeof index.length === 'number') {
    // Allow for throwaway end (used by insertText/insertEmbed)
    if (typeof length !== 'number') {
      source = value, value = name, name = length, length = index.length, index = index.index;
    } else {
      length = index.length, index = index.index;
    }
  } else if (typeof length !== 'number') {
    source = value, value = name, name = length, length = 0;
  }
  // Handle format being object, two format name/value strings or excluded
  if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
    formats = name;
    source = value;
  } else if (typeof name === 'string') {
    if (value != null) {
      formats[name] = value;
    } else {
      source = name;
    }
  }
  // Handle optional source
  source = source || _emitter4.default.sources.API;
  return [index, length, formats, source];
}

function shiftRange(range, index, length, source) {
  if (range == null) return null;
  var start = void 0,
      end = void 0;
  if (index instanceof _quillDelta2.default) {
    var _map = [range.index, range.index + range.length].map(function (pos) {
      return index.transformPosition(pos, source !== _emitter4.default.sources.USER);
    });

    var _map2 = _slicedToArray(_map, 2);

    start = _map2[0];
    end = _map2[1];
  } else {
    var _map3 = [range.index, range.index + range.length].map(function (pos) {
      if (pos < index || pos === index && source === _emitter4.default.sources.USER) return pos;
      if (length >= 0) {
        return pos + length;
      } else {
        return Math.max(index, pos + length);
      }
    });

    var _map4 = _slicedToArray(_map3, 2);

    start = _map4[0];
    end = _map4[1];
  }
  return new _selection.Range(start, end - start);
}

exports.expandConfig = expandConfig;
exports.overload = overload;
exports.default = Quill;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _text = __webpack_require__(7);

var _text2 = _interopRequireDefault(_text);

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Inline = function (_Parchment$Inline) {
  _inherits(Inline, _Parchment$Inline);

  function Inline() {
    _classCallCheck(this, Inline);

    return _possibleConstructorReturn(this, (Inline.__proto__ || Object.getPrototypeOf(Inline)).apply(this, arguments));
  }

  _createClass(Inline, [{
    key: 'formatAt',
    value: function formatAt(index, length, name, value) {
      if (Inline.compare(this.statics.blotName, name) < 0 && _parchment2.default.query(name, _parchment2.default.Scope.BLOT)) {
        var blot = this.isolate(index, length);
        if (value) {
          blot.wrap(name, value);
        }
      } else {
        _get(Inline.prototype.__proto__ || Object.getPrototypeOf(Inline.prototype), 'formatAt', this).call(this, index, length, name, value);
      }
    }
  }, {
    key: 'optimize',
    value: function optimize(context) {
      _get(Inline.prototype.__proto__ || Object.getPrototypeOf(Inline.prototype), 'optimize', this).call(this, context);
      if (this.parent instanceof Inline && Inline.compare(this.statics.blotName, this.parent.statics.blotName) > 0) {
        var parent = this.parent.isolate(this.offset(), this.length());
        this.moveChildren(parent);
        parent.wrap(this);
      }
    }
  }], [{
    key: 'compare',
    value: function compare(self, other) {
      var selfIndex = Inline.order.indexOf(self);
      var otherIndex = Inline.order.indexOf(other);
      if (selfIndex >= 0 || otherIndex >= 0) {
        return selfIndex - otherIndex;
      } else if (self === other) {
        return 0;
      } else if (self < other) {
        return -1;
      } else {
        return 1;
      }
    }
  }]);

  return Inline;
}(_parchment2.default.Inline);

Inline.allowedChildren = [Inline, _parchment2.default.Embed, _text2.default];
// Lower index means deeper in the DOM tree, since not found (-1) is for embeds
Inline.order = ['cursor', 'inline', // Must be lower
'underline', 'strike', 'italic', 'bold', 'script', 'link', 'code' // Must be higher
];

exports.default = Inline;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextBlot = function (_Parchment$Text) {
  _inherits(TextBlot, _Parchment$Text);

  function TextBlot() {
    _classCallCheck(this, TextBlot);

    return _possibleConstructorReturn(this, (TextBlot.__proto__ || Object.getPrototypeOf(TextBlot)).apply(this, arguments));
  }

  return TextBlot;
}(_parchment2.default.Text);

exports.default = TextBlot;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _eventemitter = __webpack_require__(54);

var _eventemitter2 = _interopRequireDefault(_eventemitter);

var _logger = __webpack_require__(10);

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var debug = (0, _logger2.default)('quill:events');

var EVENTS = ['selectionchange', 'mousedown', 'mouseup', 'click'];

EVENTS.forEach(function (eventName) {
  document.addEventListener(eventName, function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    [].slice.call(document.querySelectorAll('.ql-container')).forEach(function (node) {
      // TODO use WeakMap
      if (node.__quill && node.__quill.emitter) {
        var _node$__quill$emitter;

        (_node$__quill$emitter = node.__quill.emitter).handleDOM.apply(_node$__quill$emitter, args);
      }
    });
  });
});

var Emitter = function (_EventEmitter) {
  _inherits(Emitter, _EventEmitter);

  function Emitter() {
    _classCallCheck(this, Emitter);

    var _this = _possibleConstructorReturn(this, (Emitter.__proto__ || Object.getPrototypeOf(Emitter)).call(this));

    _this.listeners = {};
    _this.on('error', debug.error);
    return _this;
  }

  _createClass(Emitter, [{
    key: 'emit',
    value: function emit() {
      debug.log.apply(debug, arguments);
      _get(Emitter.prototype.__proto__ || Object.getPrototypeOf(Emitter.prototype), 'emit', this).apply(this, arguments);
    }
  }, {
    key: 'handleDOM',
    value: function handleDOM(event) {
      for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      (this.listeners[event.type] || []).forEach(function (_ref) {
        var node = _ref.node,
            handler = _ref.handler;

        if (event.target === node || node.contains(event.target)) {
          handler.apply(undefined, [event].concat(args));
        }
      });
    }
  }, {
    key: 'listenDOM',
    value: function listenDOM(eventName, node, handler) {
      if (!this.listeners[eventName]) {
        this.listeners[eventName] = [];
      }
      this.listeners[eventName].push({ node: node, handler: handler });
    }
  }]);

  return Emitter;
}(_eventemitter2.default);

Emitter.events = {
  EDITOR_CHANGE: 'editor-change',
  SCROLL_BEFORE_UPDATE: 'scroll-before-update',
  SCROLL_OPTIMIZE: 'scroll-optimize',
  SCROLL_UPDATE: 'scroll-update',
  SELECTION_CHANGE: 'selection-change',
  TEXT_CHANGE: 'text-change'
};
Emitter.sources = {
  API: 'api',
  SILENT: 'silent',
  USER: 'user'
};

exports.default = Emitter;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Module = function Module(quill) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  _classCallCheck(this, Module);

  this.quill = quill;
  this.options = options;
};

Module.DEFAULTS = {};

exports.default = Module;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var levels = ['error', 'warn', 'log', 'info'];
var level = 'warn';

function debug(method) {
  if (levels.indexOf(method) <= levels.indexOf(level)) {
    var _console;

    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    (_console = console)[method].apply(_console, args); // eslint-disable-line no-console
  }
}

function namespace(ns) {
  return levels.reduce(function (logger, method) {
    logger[method] = debug.bind(console, method, ns);
    return logger;
  }, {});
}

debug.level = namespace.level = function (newLevel) {
  level = newLevel;
};

exports.default = namespace;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var pSlice = Array.prototype.slice;
var objectKeys = __webpack_require__(52);
var isArguments = __webpack_require__(53);

var deepEqual = module.exports = function (actual, expected, opts) {
  if (!opts) opts = {};
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;

  } else if (actual instanceof Date && expected instanceof Date) {
    return actual.getTime() === expected.getTime();

  // 7.3. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
    return opts.strict ? actual === expected : actual == expected;

  // 7.4. For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else {
    return objEquiv(actual, expected, opts);
  }
}

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer (x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') return false;
  return true;
}

function objEquiv(a, b, opts) {
  var i, key;
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
    return false;
  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) return false;
  //~~~I've managed to break Object.keys through screwy arguments passing.
  //   Converting to array solves the problem.
  if (isArguments(a)) {
    if (!isArguments(b)) {
      return false;
    }
    a = pSlice.call(a);
    b = pSlice.call(b);
    return deepEqual(a, b, opts);
  }
  if (isBuffer(a)) {
    if (!isBuffer(b)) {
      return false;
    }
    if (a.length !== b.length) return false;
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }
  try {
    var ka = objectKeys(a),
        kb = objectKeys(b);
  } catch (e) {//happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length != kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) return false;
  }
  return typeof a === typeof b;
}


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Registry = __webpack_require__(1);
var Attributor = /** @class */ (function () {
    function Attributor(attrName, keyName, options) {
        if (options === void 0) { options = {}; }
        this.attrName = attrName;
        this.keyName = keyName;
        var attributeBit = Registry.Scope.TYPE & Registry.Scope.ATTRIBUTE;
        if (options.scope != null) {
            // Ignore type bits, force attribute bit
            this.scope = (options.scope & Registry.Scope.LEVEL) | attributeBit;
        }
        else {
            this.scope = Registry.Scope.ATTRIBUTE;
        }
        if (options.whitelist != null)
            this.whitelist = options.whitelist;
    }
    Attributor.keys = function (node) {
        return [].map.call(node.attributes, function (item) {
            return item.name;
        });
    };
    Attributor.prototype.add = function (node, value) {
        if (!this.canAdd(node, value))
            return false;
        node.setAttribute(this.keyName, value);
        return true;
    };
    Attributor.prototype.canAdd = function (node, value) {
        var match = Registry.query(node, Registry.Scope.BLOT & (this.scope | Registry.Scope.TYPE));
        if (match == null)
            return false;
        if (this.whitelist == null)
            return true;
        if (typeof value === 'string') {
            return this.whitelist.indexOf(value.replace(/["']/g, '')) > -1;
        }
        else {
            return this.whitelist.indexOf(value) > -1;
        }
    };
    Attributor.prototype.remove = function (node) {
        node.removeAttribute(this.keyName);
    };
    Attributor.prototype.value = function (node) {
        var value = node.getAttribute(this.keyName);
        if (this.canAdd(node, value) && value) {
            return value;
        }
        return '';
    };
    return Attributor;
}());
exports.default = Attributor;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Code = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _quillDelta = __webpack_require__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _block = __webpack_require__(4);

var _block2 = _interopRequireDefault(_block);

var _inline = __webpack_require__(6);

var _inline2 = _interopRequireDefault(_inline);

var _text = __webpack_require__(7);

var _text2 = _interopRequireDefault(_text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Code = function (_Inline) {
  _inherits(Code, _Inline);

  function Code() {
    _classCallCheck(this, Code);

    return _possibleConstructorReturn(this, (Code.__proto__ || Object.getPrototypeOf(Code)).apply(this, arguments));
  }

  return Code;
}(_inline2.default);

Code.blotName = 'code';
Code.tagName = 'CODE';

var CodeBlock = function (_Block) {
  _inherits(CodeBlock, _Block);

  function CodeBlock() {
    _classCallCheck(this, CodeBlock);

    return _possibleConstructorReturn(this, (CodeBlock.__proto__ || Object.getPrototypeOf(CodeBlock)).apply(this, arguments));
  }

  _createClass(CodeBlock, [{
    key: 'delta',
    value: function delta() {
      var _this3 = this;

      var text = this.domNode.textContent;
      if (text.endsWith('\n')) {
        // Should always be true
        text = text.slice(0, -1);
      }
      return text.split('\n').reduce(function (delta, frag) {
        return delta.insert(frag).insert('\n', _this3.formats());
      }, new _quillDelta2.default());
    }
  }, {
    key: 'format',
    value: function format(name, value) {
      if (name === this.statics.blotName && value) return;

      var _descendant = this.descendant(_text2.default, this.length() - 1),
          _descendant2 = _slicedToArray(_descendant, 1),
          text = _descendant2[0];

      if (text != null) {
        text.deleteAt(text.length() - 1, 1);
      }
      _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'format', this).call(this, name, value);
    }
  }, {
    key: 'formatAt',
    value: function formatAt(index, length, name, value) {
      if (length === 0) return;
      if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK) == null || name === this.statics.blotName && value === this.statics.formats(this.domNode)) {
        return;
      }
      var nextNewline = this.newlineIndex(index);
      if (nextNewline < 0 || nextNewline >= index + length) return;
      var prevNewline = this.newlineIndex(index, true) + 1;
      var isolateLength = nextNewline - prevNewline + 1;
      var blot = this.isolate(prevNewline, isolateLength);
      var next = blot.next;
      blot.format(name, value);
      if (next instanceof CodeBlock) {
        next.formatAt(0, index - prevNewline + length - isolateLength, name, value);
      }
    }
  }, {
    key: 'insertAt',
    value: function insertAt(index, value, def) {
      if (def != null) return;

      var _descendant3 = this.descendant(_text2.default, index),
          _descendant4 = _slicedToArray(_descendant3, 2),
          text = _descendant4[0],
          offset = _descendant4[1];

      text.insertAt(offset, value);
    }
  }, {
    key: 'length',
    value: function length() {
      var length = this.domNode.textContent.length;
      if (!this.domNode.textContent.endsWith('\n')) {
        return length + 1;
      }
      return length;
    }
  }, {
    key: 'newlineIndex',
    value: function newlineIndex(searchIndex) {
      var reverse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!reverse) {
        var offset = this.domNode.textContent.slice(searchIndex).indexOf('\n');
        return offset > -1 ? searchIndex + offset : -1;
      } else {
        return this.domNode.textContent.slice(0, searchIndex).lastIndexOf('\n');
      }
    }
  }, {
    key: 'optimize',
    value: function optimize(context) {
      if (!this.domNode.textContent.endsWith('\n')) {
        this.appendChild(_parchment2.default.create('text', '\n'));
      }
      _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'optimize', this).call(this, context);
      var next = this.next;
      if (next != null && next.prev === this && next.statics.blotName === this.statics.blotName && this.statics.formats(this.domNode) === next.statics.formats(next.domNode)) {
        next.optimize(context);
        next.moveChildren(this);
        next.remove();
      }
    }
  }, {
    key: 'replace',
    value: function replace(target) {
      _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'replace', this).call(this, target);
      [].slice.call(this.domNode.querySelectorAll('*')).forEach(function (node) {
        var blot = _parchment2.default.find(node);
        if (blot == null) {
          node.parentNode.removeChild(node);
        } else if (blot instanceof _parchment2.default.Embed) {
          blot.remove();
        } else {
          blot.unwrap();
        }
      });
    }
  }], [{
    key: 'create',
    value: function create(value) {
      var domNode = _get(CodeBlock.__proto__ || Object.getPrototypeOf(CodeBlock), 'create', this).call(this, value);
      domNode.setAttribute('spellcheck', false);
      return domNode;
    }
  }, {
    key: 'formats',
    value: function formats() {
      return true;
    }
  }]);

  return CodeBlock;
}(_block2.default);

CodeBlock.blotName = 'code-block';
CodeBlock.tagName = 'PRE';
CodeBlock.TAB = '  ';

exports.Code = Code;
exports.default = CodeBlock;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _quillDelta = __webpack_require__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _op = __webpack_require__(20);

var _op2 = _interopRequireDefault(_op);

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _code = __webpack_require__(13);

var _code2 = _interopRequireDefault(_code);

var _cursor = __webpack_require__(24);

var _cursor2 = _interopRequireDefault(_cursor);

var _block = __webpack_require__(4);

var _block2 = _interopRequireDefault(_block);

var _break = __webpack_require__(16);

var _break2 = _interopRequireDefault(_break);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _deepEqual = __webpack_require__(11);

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _extend = __webpack_require__(3);

var _extend2 = _interopRequireDefault(_extend);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ASCII = /^[ -~]*$/;

var Editor = function () {
  function Editor(scroll) {
    _classCallCheck(this, Editor);

    this.scroll = scroll;
    this.delta = this.getDelta();
  }

  _createClass(Editor, [{
    key: 'applyDelta',
    value: function applyDelta(delta) {
      var _this = this;

      var consumeNextNewline = false;
      this.scroll.update();
      var scrollLength = this.scroll.length();
      this.scroll.batchStart();
      delta = normalizeDelta(delta);
      delta.reduce(function (index, op) {
        var length = op.retain || op.delete || op.insert.length || 1;
        var attributes = op.attributes || {};
        if (op.insert != null) {
          if (typeof op.insert === 'string') {
            var text = op.insert;
            if (text.endsWith('\n') && consumeNextNewline) {
              consumeNextNewline = false;
              text = text.slice(0, -1);
            }
            if (index >= scrollLength && !text.endsWith('\n')) {
              consumeNextNewline = true;
            }
            _this.scroll.insertAt(index, text);

            var _scroll$line = _this.scroll.line(index),
                _scroll$line2 = _slicedToArray(_scroll$line, 2),
                line = _scroll$line2[0],
                offset = _scroll$line2[1];

            var formats = (0, _extend2.default)({}, (0, _block.bubbleFormats)(line));
            if (line instanceof _block2.default) {
              var _line$descendant = line.descendant(_parchment2.default.Leaf, offset),
                  _line$descendant2 = _slicedToArray(_line$descendant, 1),
                  leaf = _line$descendant2[0];

              formats = (0, _extend2.default)(formats, (0, _block.bubbleFormats)(leaf));
            }
            attributes = _op2.default.attributes.diff(formats, attributes) || {};
          } else if (_typeof(op.insert) === 'object') {
            var key = Object.keys(op.insert)[0]; // There should only be one key
            if (key == null) return index;
            _this.scroll.insertAt(index, key, op.insert[key]);
          }
          scrollLength += length;
        }
        Object.keys(attributes).forEach(function (name) {
          _this.scroll.formatAt(index, length, name, attributes[name]);
        });
        return index + length;
      }, 0);
      delta.reduce(function (index, op) {
        if (typeof op.delete === 'number') {
          _this.scroll.deleteAt(index, op.delete);
          return index;
        }
        return index + (op.retain || op.insert.length || 1);
      }, 0);
      this.scroll.batchEnd();
      return this.update(delta);
    }
  }, {
    key: 'deleteText',
    value: function deleteText(index, length) {
      this.scroll.deleteAt(index, length);
      return this.update(new _quillDelta2.default().retain(index).delete(length));
    }
  }, {
    key: 'formatLine',
    value: function formatLine(index, length) {
      var _this2 = this;

      var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      this.scroll.update();
      Object.keys(formats).forEach(function (format) {
        if (_this2.scroll.whitelist != null && !_this2.scroll.whitelist[format]) return;
        var lines = _this2.scroll.lines(index, Math.max(length, 1));
        var lengthRemaining = length;
        lines.forEach(function (line) {
          var lineLength = line.length();
          if (!(line instanceof _code2.default)) {
            line.format(format, formats[format]);
          } else {
            var codeIndex = index - line.offset(_this2.scroll);
            var codeLength = line.newlineIndex(codeIndex + lengthRemaining) - codeIndex + 1;
            line.formatAt(codeIndex, codeLength, format, formats[format]);
          }
          lengthRemaining -= lineLength;
        });
      });
      this.scroll.optimize();
      return this.update(new _quillDelta2.default().retain(index).retain(length, (0, _clone2.default)(formats)));
    }
  }, {
    key: 'formatText',
    value: function formatText(index, length) {
      var _this3 = this;

      var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      Object.keys(formats).forEach(function (format) {
        _this3.scroll.formatAt(index, length, format, formats[format]);
      });
      return this.update(new _quillDelta2.default().retain(index).retain(length, (0, _clone2.default)(formats)));
    }
  }, {
    key: 'getContents',
    value: function getContents(index, length) {
      return this.delta.slice(index, index + length);
    }
  }, {
    key: 'getDelta',
    value: function getDelta() {
      return this.scroll.lines().reduce(function (delta, line) {
        return delta.concat(line.delta());
      }, new _quillDelta2.default());
    }
  }, {
    key: 'getFormat',
    value: function getFormat(index) {
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var lines = [],
          leaves = [];
      if (length === 0) {
        this.scroll.path(index).forEach(function (path) {
          var _path = _slicedToArray(path, 1),
              blot = _path[0];

          if (blot instanceof _block2.default) {
            lines.push(blot);
          } else if (blot instanceof _parchment2.default.Leaf) {
            leaves.push(blot);
          }
        });
      } else {
        lines = this.scroll.lines(index, length);
        leaves = this.scroll.descendants(_parchment2.default.Leaf, index, length);
      }
      var formatsArr = [lines, leaves].map(function (blots) {
        if (blots.length === 0) return {};
        var formats = (0, _block.bubbleFormats)(blots.shift());
        while (Object.keys(formats).length > 0) {
          var blot = blots.shift();
          if (blot == null) return formats;
          formats = combineFormats((0, _block.bubbleFormats)(blot), formats);
        }
        return formats;
      });
      return _extend2.default.apply(_extend2.default, formatsArr);
    }
  }, {
    key: 'getText',
    value: function getText(index, length) {
      return this.getContents(index, length).filter(function (op) {
        return typeof op.insert === 'string';
      }).map(function (op) {
        return op.insert;
      }).join('');
    }
  }, {
    key: 'insertEmbed',
    value: function insertEmbed(index, embed, value) {
      this.scroll.insertAt(index, embed, value);
      return this.update(new _quillDelta2.default().retain(index).insert(_defineProperty({}, embed, value)));
    }
  }, {
    key: 'insertText',
    value: function insertText(index, text) {
      var _this4 = this;

      var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      text = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
      this.scroll.insertAt(index, text);
      Object.keys(formats).forEach(function (format) {
        _this4.scroll.formatAt(index, text.length, format, formats[format]);
      });
      return this.update(new _quillDelta2.default().retain(index).insert(text, (0, _clone2.default)(formats)));
    }
  }, {
    key: 'isBlank',
    value: function isBlank() {
      if (this.scroll.children.length == 0) return true;
      if (this.scroll.children.length > 1) return false;
      var block = this.scroll.children.head;
      if (block.statics.blotName !== _block2.default.blotName) return false;
      if (block.children.length > 1) return false;
      return block.children.head instanceof _break2.default;
    }
  }, {
    key: 'removeFormat',
    value: function removeFormat(index, length) {
      var text = this.getText(index, length);

      var _scroll$line3 = this.scroll.line(index + length),
          _scroll$line4 = _slicedToArray(_scroll$line3, 2),
          line = _scroll$line4[0],
          offset = _scroll$line4[1];

      var suffixLength = 0,
          suffix = new _quillDelta2.default();
      if (line != null) {
        if (!(line instanceof _code2.default)) {
          suffixLength = line.length() - offset;
        } else {
          suffixLength = line.newlineIndex(offset) - offset + 1;
        }
        suffix = line.delta().slice(offset, offset + suffixLength - 1).insert('\n');
      }
      var contents = this.getContents(index, length + suffixLength);
      var diff = contents.diff(new _quillDelta2.default().insert(text).concat(suffix));
      var delta = new _quillDelta2.default().retain(index).concat(diff);
      return this.applyDelta(delta);
    }
  }, {
    key: 'update',
    value: function update(change) {
      var mutations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var cursorIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

      var oldDelta = this.delta;
      if (mutations.length === 1 && mutations[0].type === 'characterData' && mutations[0].target.data.match(ASCII) && _parchment2.default.find(mutations[0].target)) {
        // Optimization for character changes
        var textBlot = _parchment2.default.find(mutations[0].target);
        var formats = (0, _block.bubbleFormats)(textBlot);
        var index = textBlot.offset(this.scroll);
        var oldValue = mutations[0].oldValue.replace(_cursor2.default.CONTENTS, '');
        var oldText = new _quillDelta2.default().insert(oldValue);
        var newText = new _quillDelta2.default().insert(textBlot.value());
        var diffDelta = new _quillDelta2.default().retain(index).concat(oldText.diff(newText, cursorIndex));
        change = diffDelta.reduce(function (delta, op) {
          if (op.insert) {
            return delta.insert(op.insert, formats);
          } else {
            return delta.push(op);
          }
        }, new _quillDelta2.default());
        this.delta = oldDelta.compose(change);
      } else {
        this.delta = this.getDelta();
        if (!change || !(0, _deepEqual2.default)(oldDelta.compose(change), this.delta)) {
          change = oldDelta.diff(this.delta, cursorIndex);
        }
      }
      return change;
    }
  }]);

  return Editor;
}();

function combineFormats(formats, combined) {
  return Object.keys(combined).reduce(function (merged, name) {
    if (formats[name] == null) return merged;
    if (combined[name] === formats[name]) {
      merged[name] = combined[name];
    } else if (Array.isArray(combined[name])) {
      if (combined[name].indexOf(formats[name]) < 0) {
        merged[name] = combined[name].concat([formats[name]]);
      }
    } else {
      merged[name] = [combined[name], formats[name]];
    }
    return merged;
  }, {});
}

function normalizeDelta(delta) {
  return delta.reduce(function (delta, op) {
    if (op.insert === 1) {
      var attributes = (0, _clone2.default)(op.attributes);
      delete attributes['image'];
      return delta.insert({ image: op.attributes.image }, attributes);
    }
    if (op.attributes != null && (op.attributes.list === true || op.attributes.bullet === true)) {
      op = (0, _clone2.default)(op);
      if (op.attributes.list) {
        op.attributes.list = 'ordered';
      } else {
        op.attributes.list = 'bullet';
        delete op.attributes.bullet;
      }
    }
    if (typeof op.insert === 'string') {
      var text = op.insert.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
      return delta.insert(text, op.attributes);
    }
    return delta.push(op);
  }, new _quillDelta2.default());
}

exports.default = Editor;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Range = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _deepEqual = __webpack_require__(11);

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _emitter3 = __webpack_require__(8);

var _emitter4 = _interopRequireDefault(_emitter3);

var _logger = __webpack_require__(10);

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var debug = (0, _logger2.default)('quill:selection');

var Range = function Range(index) {
  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  _classCallCheck(this, Range);

  this.index = index;
  this.length = length;
};

var Selection = function () {
  function Selection(scroll, emitter) {
    var _this = this;

    _classCallCheck(this, Selection);

    this.emitter = emitter;
    this.scroll = scroll;
    this.composing = false;
    this.mouseDown = false;
    this.root = this.scroll.domNode;
    this.cursor = _parchment2.default.create('cursor', this);
    // savedRange is last non-null range
    this.lastRange = this.savedRange = new Range(0, 0);
    this.handleComposition();
    this.handleDragging();
    this.emitter.listenDOM('selectionchange', document, function () {
      if (!_this.mouseDown) {
        setTimeout(_this.update.bind(_this, _emitter4.default.sources.USER), 1);
      }
    });
    this.emitter.on(_emitter4.default.events.EDITOR_CHANGE, function (type, delta) {
      if (type === _emitter4.default.events.TEXT_CHANGE && delta.length() > 0) {
        _this.update(_emitter4.default.sources.SILENT);
      }
    });
    this.emitter.on(_emitter4.default.events.SCROLL_BEFORE_UPDATE, function () {
      if (!_this.hasFocus()) return;
      var native = _this.getNativeRange();
      if (native == null) return;
      if (native.start.node === _this.cursor.textNode) return; // cursor.restore() will handle
      // TODO unclear if this has negative side effects
      _this.emitter.once(_emitter4.default.events.SCROLL_UPDATE, function () {
        try {
          _this.setNativeRange(native.start.node, native.start.offset, native.end.node, native.end.offset);
        } catch (ignored) {}
      });
    });
    this.emitter.on(_emitter4.default.events.SCROLL_OPTIMIZE, function (mutations, context) {
      if (context.range) {
        var _context$range = context.range,
            startNode = _context$range.startNode,
            startOffset = _context$range.startOffset,
            endNode = _context$range.endNode,
            endOffset = _context$range.endOffset;

        _this.setNativeRange(startNode, startOffset, endNode, endOffset);
      }
    });
    this.update(_emitter4.default.sources.SILENT);
  }

  _createClass(Selection, [{
    key: 'handleComposition',
    value: function handleComposition() {
      var _this2 = this;

      this.root.addEventListener('compositionstart', function () {
        _this2.composing = true;
      });
      this.root.addEventListener('compositionend', function () {
        _this2.composing = false;
        if (_this2.cursor.parent) {
          var range = _this2.cursor.restore();
          if (!range) return;
          setTimeout(function () {
            _this2.setNativeRange(range.startNode, range.startOffset, range.endNode, range.endOffset);
          }, 1);
        }
      });
    }
  }, {
    key: 'handleDragging',
    value: function handleDragging() {
      var _this3 = this;

      this.emitter.listenDOM('mousedown', document.body, function () {
        _this3.mouseDown = true;
      });
      this.emitter.listenDOM('mouseup', document.body, function () {
        _this3.mouseDown = false;
        _this3.update(_emitter4.default.sources.USER);
      });
    }
  }, {
    key: 'focus',
    value: function focus() {
      if (this.hasFocus()) return;
      this.root.focus();
      this.setRange(this.savedRange);
    }
  }, {
    key: 'format',
    value: function format(_format, value) {
      if (this.scroll.whitelist != null && !this.scroll.whitelist[_format]) return;
      this.scroll.update();
      var nativeRange = this.getNativeRange();
      if (nativeRange == null || !nativeRange.native.collapsed || _parchment2.default.query(_format, _parchment2.default.Scope.BLOCK)) return;
      if (nativeRange.start.node !== this.cursor.textNode) {
        var blot = _parchment2.default.find(nativeRange.start.node, false);
        if (blot == null) return;
        // TODO Give blot ability to not split
        if (blot instanceof _parchment2.default.Leaf) {
          var after = blot.split(nativeRange.start.offset);
          blot.parent.insertBefore(this.cursor, after);
        } else {
          blot.insertBefore(this.cursor, nativeRange.start.node); // Should never happen
        }
        this.cursor.attach();
      }
      this.cursor.format(_format, value);
      this.scroll.optimize();
      this.setNativeRange(this.cursor.textNode, this.cursor.textNode.data.length);
      this.update();
    }
  }, {
    key: 'getBounds',
    value: function getBounds(index) {
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var scrollLength = this.scroll.length();
      index = Math.min(index, scrollLength - 1);
      length = Math.min(index + length, scrollLength - 1) - index;
      var node = void 0,
          _scroll$leaf = this.scroll.leaf(index),
          _scroll$leaf2 = _slicedToArray(_scroll$leaf, 2),
          leaf = _scroll$leaf2[0],
          offset = _scroll$leaf2[1];
      if (leaf == null) return null;

      var _leaf$position = leaf.position(offset, true);

      var _leaf$position2 = _slicedToArray(_leaf$position, 2);

      node = _leaf$position2[0];
      offset = _leaf$position2[1];

      var range = document.createRange();
      if (length > 0) {
        range.setStart(node, offset);

        var _scroll$leaf3 = this.scroll.leaf(index + length);

        var _scroll$leaf4 = _slicedToArray(_scroll$leaf3, 2);

        leaf = _scroll$leaf4[0];
        offset = _scroll$leaf4[1];

        if (leaf == null) return null;

        var _leaf$position3 = leaf.position(offset, true);

        var _leaf$position4 = _slicedToArray(_leaf$position3, 2);

        node = _leaf$position4[0];
        offset = _leaf$position4[1];

        range.setEnd(node, offset);
        return range.getBoundingClientRect();
      } else {
        var side = 'left';
        var rect = void 0;
        if (node instanceof Text) {
          if (offset < node.data.length) {
            range.setStart(node, offset);
            range.setEnd(node, offset + 1);
          } else {
            range.setStart(node, offset - 1);
            range.setEnd(node, offset);
            side = 'right';
          }
          rect = range.getBoundingClientRect();
        } else {
          rect = leaf.domNode.getBoundingClientRect();
          if (offset > 0) side = 'right';
        }
        return {
          bottom: rect.top + rect.height,
          height: rect.height,
          left: rect[side],
          right: rect[side],
          top: rect.top,
          width: 0
        };
      }
    }
  }, {
    key: 'getNativeRange',
    value: function getNativeRange() {
      var selection = document.getSelection();
      if (selection == null || selection.rangeCount <= 0) return null;
      var nativeRange = selection.getRangeAt(0);
      if (nativeRange == null) return null;
      var range = this.normalizeNative(nativeRange);
      debug.info('getNativeRange', range);
      return range;
    }
  }, {
    key: 'getRange',
    value: function getRange() {
      var normalized = this.getNativeRange();
      if (normalized == null) return [null, null];
      var range = this.normalizedToRange(normalized);
      return [range, normalized];
    }
  }, {
    key: 'hasFocus',
    value: function hasFocus() {
      return document.activeElement === this.root;
    }
  }, {
    key: 'normalizedToRange',
    value: function normalizedToRange(range) {
      var _this4 = this;

      var positions = [[range.start.node, range.start.offset]];
      if (!range.native.collapsed) {
        positions.push([range.end.node, range.end.offset]);
      }
      var indexes = positions.map(function (position) {
        var _position = _slicedToArray(position, 2),
            node = _position[0],
            offset = _position[1];

        var blot = _parchment2.default.find(node, true);
        var index = blot.offset(_this4.scroll);
        if (offset === 0) {
          return index;
        } else if (blot instanceof _parchment2.default.Container) {
          return index + blot.length();
        } else {
          return index + blot.index(node, offset);
        }
      });
      var end = Math.min(Math.max.apply(Math, _toConsumableArray(indexes)), this.scroll.length() - 1);
      var start = Math.min.apply(Math, [end].concat(_toConsumableArray(indexes)));
      return new Range(start, end - start);
    }
  }, {
    key: 'normalizeNative',
    value: function normalizeNative(nativeRange) {
      if (!contains(this.root, nativeRange.startContainer) || !nativeRange.collapsed && !contains(this.root, nativeRange.endContainer)) {
        return null;
      }
      var range = {
        start: { node: nativeRange.startContainer, offset: nativeRange.startOffset },
        end: { node: nativeRange.endContainer, offset: nativeRange.endOffset },
        native: nativeRange
      };
      [range.start, range.end].forEach(function (position) {
        var node = position.node,
            offset = position.offset;
        while (!(node instanceof Text) && node.childNodes.length > 0) {
          if (node.childNodes.length > offset) {
            node = node.childNodes[offset];
            offset = 0;
          } else if (node.childNodes.length === offset) {
            node = node.lastChild;
            offset = node instanceof Text ? node.data.length : node.childNodes.length + 1;
          } else {
            break;
          }
        }
        position.node = node, position.offset = offset;
      });
      return range;
    }
  }, {
    key: 'rangeToNative',
    value: function rangeToNative(range) {
      var _this5 = this;

      var indexes = range.collapsed ? [range.index] : [range.index, range.index + range.length];
      var args = [];
      var scrollLength = this.scroll.length();
      indexes.forEach(function (index, i) {
        index = Math.min(scrollLength - 1, index);
        var node = void 0,
            _scroll$leaf5 = _this5.scroll.leaf(index),
            _scroll$leaf6 = _slicedToArray(_scroll$leaf5, 2),
            leaf = _scroll$leaf6[0],
            offset = _scroll$leaf6[1];
        var _leaf$position5 = leaf.position(offset, i !== 0);

        var _leaf$position6 = _slicedToArray(_leaf$position5, 2);

        node = _leaf$position6[0];
        offset = _leaf$position6[1];

        args.push(node, offset);
      });
      if (args.length < 2) {
        args = args.concat(args);
      }
      return args;
    }
  }, {
    key: 'scrollIntoView',
    value: function scrollIntoView(scrollingContainer) {
      var range = this.lastRange;
      if (range == null) return;
      var bounds = this.getBounds(range.index, range.length);
      if (bounds == null) return;
      var limit = this.scroll.length() - 1;

      var _scroll$line = this.scroll.line(Math.min(range.index, limit)),
          _scroll$line2 = _slicedToArray(_scroll$line, 1),
          first = _scroll$line2[0];

      var last = first;
      if (range.length > 0) {
        var _scroll$line3 = this.scroll.line(Math.min(range.index + range.length, limit));

        var _scroll$line4 = _slicedToArray(_scroll$line3, 1);

        last = _scroll$line4[0];
      }
      if (first == null || last == null) return;
      var scrollBounds = scrollingContainer.getBoundingClientRect();
      if (bounds.top < scrollBounds.top) {
        scrollingContainer.scrollTop -= scrollBounds.top - bounds.top;
      } else if (bounds.bottom > scrollBounds.bottom) {
        scrollingContainer.scrollTop += bounds.bottom - scrollBounds.bottom;
      }
    }
  }, {
    key: 'setNativeRange',
    value: function setNativeRange(startNode, startOffset) {
      var endNode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : startNode;
      var endOffset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : startOffset;
      var force = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

      debug.info('setNativeRange', startNode, startOffset, endNode, endOffset);
      if (startNode != null && (this.root.parentNode == null || startNode.parentNode == null || endNode.parentNode == null)) {
        return;
      }
      var selection = document.getSelection();
      if (selection == null) return;
      if (startNode != null) {
        if (!this.hasFocus()) this.root.focus();
        var native = (this.getNativeRange() || {}).native;
        if (native == null || force || startNode !== native.startContainer || startOffset !== native.startOffset || endNode !== native.endContainer || endOffset !== native.endOffset) {

          if (startNode.tagName == "BR") {
            startOffset = [].indexOf.call(startNode.parentNode.childNodes, startNode);
            startNode = startNode.parentNode;
          }
          if (endNode.tagName == "BR") {
            endOffset = [].indexOf.call(endNode.parentNode.childNodes, endNode);
            endNode = endNode.parentNode;
          }
          var range = document.createRange();
          range.setStart(startNode, startOffset);
          range.setEnd(endNode, endOffset);
          selection.removeAllRanges();
          selection.addRange(range);
        }
      } else {
        selection.removeAllRanges();
        this.root.blur();
        document.body.focus(); // root.blur() not enough on IE11+Travis+SauceLabs (but not local VMs)
      }
    }
  }, {
    key: 'setRange',
    value: function setRange(range) {
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _emitter4.default.sources.API;

      if (typeof force === 'string') {
        source = force;
        force = false;
      }
      debug.info('setRange', range);
      if (range != null) {
        var args = this.rangeToNative(range);
        this.setNativeRange.apply(this, _toConsumableArray(args).concat([force]));
      } else {
        this.setNativeRange(null);
      }
      this.update(source);
    }
  }, {
    key: 'update',
    value: function update() {
      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _emitter4.default.sources.USER;

      var oldRange = this.lastRange;

      var _getRange = this.getRange(),
          _getRange2 = _slicedToArray(_getRange, 2),
          lastRange = _getRange2[0],
          nativeRange = _getRange2[1];

      this.lastRange = lastRange;
      if (this.lastRange != null) {
        this.savedRange = this.lastRange;
      }
      if (!(0, _deepEqual2.default)(oldRange, this.lastRange)) {
        var _emitter;

        if (!this.composing && nativeRange != null && nativeRange.native.collapsed && nativeRange.start.node !== this.cursor.textNode) {
          this.cursor.restore();
        }
        var args = [_emitter4.default.events.SELECTION_CHANGE, (0, _clone2.default)(this.lastRange), (0, _clone2.default)(oldRange), source];
        (_emitter = this.emitter).emit.apply(_emitter, [_emitter4.default.events.EDITOR_CHANGE].concat(args));
        if (source !== _emitter4.default.sources.SILENT) {
          var _emitter2;

          (_emitter2 = this.emitter).emit.apply(_emitter2, args);
        }
      }
    }
  }]);

  return Selection;
}();

function contains(parent, descendant) {
  try {
    // Firefox inserts inaccessible nodes around video elements
    descendant.parentNode;
  } catch (e) {
    return false;
  }
  // IE11 has bug with Text nodes
  // https://connect.microsoft.com/IE/feedback/details/780874/node-contains-is-incorrect
  if (descendant instanceof Text) {
    descendant = descendant.parentNode;
  }
  return parent.contains(descendant);
}

exports.Range = Range;
exports.default = Selection;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Break = function (_Parchment$Embed) {
  _inherits(Break, _Parchment$Embed);

  function Break() {
    _classCallCheck(this, Break);

    return _possibleConstructorReturn(this, (Break.__proto__ || Object.getPrototypeOf(Break)).apply(this, arguments));
  }

  _createClass(Break, [{
    key: 'insertInto',
    value: function insertInto(parent, ref) {
      if (parent.children.length === 0) {
        _get(Break.prototype.__proto__ || Object.getPrototypeOf(Break.prototype), 'insertInto', this).call(this, parent, ref);
      } else {
        this.remove();
      }
    }
  }, {
    key: 'length',
    value: function length() {
      return 0;
    }
  }, {
    key: 'value',
    value: function value() {
      return '';
    }
  }], [{
    key: 'value',
    value: function value() {
      return undefined;
    }
  }]);

  return Break;
}(_parchment2.default.Embed);

Break.blotName = 'break';
Break.tagName = 'BR';

exports.default = Break;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var linked_list_1 = __webpack_require__(44);
var shadow_1 = __webpack_require__(30);
var Registry = __webpack_require__(1);
var ContainerBlot = /** @class */ (function (_super) {
    __extends(ContainerBlot, _super);
    function ContainerBlot(domNode) {
        var _this = _super.call(this, domNode) || this;
        _this.build();
        return _this;
    }
    ContainerBlot.prototype.appendChild = function (other) {
        this.insertBefore(other);
    };
    ContainerBlot.prototype.attach = function () {
        _super.prototype.attach.call(this);
        this.children.forEach(function (child) {
            child.attach();
        });
    };
    ContainerBlot.prototype.build = function () {
        var _this = this;
        this.children = new linked_list_1.default();
        // Need to be reversed for if DOM nodes already in order
        [].slice
            .call(this.domNode.childNodes)
            .reverse()
            .forEach(function (node) {
            try {
                var child = makeBlot(node);
                _this.insertBefore(child, _this.children.head || undefined);
            }
            catch (err) {
                if (err instanceof Registry.ParchmentError)
                    return;
                else
                    throw err;
            }
        });
    };
    ContainerBlot.prototype.deleteAt = function (index, length) {
        if (index === 0 && length === this.length()) {
            return this.remove();
        }
        this.children.forEachAt(index, length, function (child, offset, length) {
            child.deleteAt(offset, length);
        });
    };
    ContainerBlot.prototype.descendant = function (criteria, index) {
        var _a = this.children.find(index), child = _a[0], offset = _a[1];
        if ((criteria.blotName == null && criteria(child)) ||
            (criteria.blotName != null && child instanceof criteria)) {
            return [child, offset];
        }
        else if (child instanceof ContainerBlot) {
            return child.descendant(criteria, offset);
        }
        else {
            return [null, -1];
        }
    };
    ContainerBlot.prototype.descendants = function (criteria, index, length) {
        if (index === void 0) { index = 0; }
        if (length === void 0) { length = Number.MAX_VALUE; }
        var descendants = [];
        var lengthLeft = length;
        this.children.forEachAt(index, length, function (child, index, length) {
            if ((criteria.blotName == null && criteria(child)) ||
                (criteria.blotName != null && child instanceof criteria)) {
                descendants.push(child);
            }
            if (child instanceof ContainerBlot) {
                descendants = descendants.concat(child.descendants(criteria, index, lengthLeft));
            }
            lengthLeft -= length;
        });
        return descendants;
    };
    ContainerBlot.prototype.detach = function () {
        this.children.forEach(function (child) {
            child.detach();
        });
        _super.prototype.detach.call(this);
    };
    ContainerBlot.prototype.formatAt = function (index, length, name, value) {
        this.children.forEachAt(index, length, function (child, offset, length) {
            child.formatAt(offset, length, name, value);
        });
    };
    ContainerBlot.prototype.insertAt = function (index, value, def) {
        var _a = this.children.find(index), child = _a[0], offset = _a[1];
        if (child) {
            child.insertAt(offset, value, def);
        }
        else {
            var blot = def == null ? Registry.create('text', value) : Registry.create(value, def);
            this.appendChild(blot);
        }
    };
    ContainerBlot.prototype.insertBefore = function (childBlot, refBlot) {
        if (this.statics.allowedChildren != null &&
            !this.statics.allowedChildren.some(function (child) {
                return childBlot instanceof child;
            })) {
            throw new Registry.ParchmentError("Cannot insert " + childBlot.statics.blotName + " into " + this.statics.blotName);
        }
        childBlot.insertInto(this, refBlot);
    };
    ContainerBlot.prototype.length = function () {
        return this.children.reduce(function (memo, child) {
            return memo + child.length();
        }, 0);
    };
    ContainerBlot.prototype.moveChildren = function (targetParent, refNode) {
        this.children.forEach(function (child) {
            targetParent.insertBefore(child, refNode);
        });
    };
    ContainerBlot.prototype.optimize = function (context) {
        _super.prototype.optimize.call(this, context);
        if (this.children.length === 0) {
            if (this.statics.defaultChild != null) {
                var child = Registry.create(this.statics.defaultChild);
                this.appendChild(child);
                child.optimize(context);
            }
            else {
                this.remove();
            }
        }
    };
    ContainerBlot.prototype.path = function (index, inclusive) {
        if (inclusive === void 0) { inclusive = false; }
        var _a = this.children.find(index, inclusive), child = _a[0], offset = _a[1];
        var position = [[this, index]];
        if (child instanceof ContainerBlot) {
            return position.concat(child.path(offset, inclusive));
        }
        else if (child != null) {
            position.push([child, offset]);
        }
        return position;
    };
    ContainerBlot.prototype.removeChild = function (child) {
        this.children.remove(child);
    };
    ContainerBlot.prototype.replace = function (target) {
        if (target instanceof ContainerBlot) {
            target.moveChildren(this);
        }
        _super.prototype.replace.call(this, target);
    };
    ContainerBlot.prototype.split = function (index, force) {
        if (force === void 0) { force = false; }
        if (!force) {
            if (index === 0)
                return this;
            if (index === this.length())
                return this.next;
        }
        var after = this.clone();
        this.parent.insertBefore(after, this.next);
        this.children.forEachAt(index, this.length(), function (child, offset, length) {
            child = child.split(offset, force);
            after.appendChild(child);
        });
        return after;
    };
    ContainerBlot.prototype.unwrap = function () {
        this.moveChildren(this.parent, this.next);
        this.remove();
    };
    ContainerBlot.prototype.update = function (mutations, context) {
        var _this = this;
        var addedNodes = [];
        var removedNodes = [];
        mutations.forEach(function (mutation) {
            if (mutation.target === _this.domNode && mutation.type === 'childList') {
                addedNodes.push.apply(addedNodes, mutation.addedNodes);
                removedNodes.push.apply(removedNodes, mutation.removedNodes);
            }
        });
        removedNodes.forEach(function (node) {
            // Check node has actually been removed
            // One exception is Chrome does not immediately remove IFRAMEs
            // from DOM but MutationRecord is correct in its reported removal
            if (node.parentNode != null &&
                // @ts-ignore
                node.tagName !== 'IFRAME' &&
                document.body.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) {
                return;
            }
            var blot = Registry.find(node);
            if (blot == null)
                return;
            if (blot.domNode.parentNode == null || blot.domNode.parentNode === _this.domNode) {
                blot.detach();
            }
        });
        addedNodes
            .filter(function (node) {
            return node.parentNode == _this.domNode;
        })
            .sort(function (a, b) {
            if (a === b)
                return 0;
            if (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING) {
                return 1;
            }
            return -1;
        })
            .forEach(function (node) {
            var refBlot = null;
            if (node.nextSibling != null) {
                refBlot = Registry.find(node.nextSibling);
            }
            var blot = makeBlot(node);
            if (blot.next != refBlot || blot.next == null) {
                if (blot.parent != null) {
                    blot.parent.removeChild(_this);
                }
                _this.insertBefore(blot, refBlot || undefined);
            }
        });
    };
    return ContainerBlot;
}(shadow_1.default));
function makeBlot(node) {
    var blot = Registry.find(node);
    if (blot == null) {
        try {
            blot = Registry.create(node);
        }
        catch (e) {
            blot = Registry.create(Registry.Scope.INLINE);
            [].slice.call(node.childNodes).forEach(function (child) {
                // @ts-ignore
                blot.domNode.appendChild(child);
            });
            if (node.parentNode) {
                node.parentNode.replaceChild(blot.domNode, node);
            }
            blot.attach();
        }
    }
    return blot;
}
exports.default = ContainerBlot;


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var attributor_1 = __webpack_require__(12);
var store_1 = __webpack_require__(31);
var container_1 = __webpack_require__(17);
var Registry = __webpack_require__(1);
var FormatBlot = /** @class */ (function (_super) {
    __extends(FormatBlot, _super);
    function FormatBlot(domNode) {
        var _this = _super.call(this, domNode) || this;
        _this.attributes = new store_1.default(_this.domNode);
        return _this;
    }
    FormatBlot.formats = function (domNode) {
        if (typeof this.tagName === 'string') {
            return true;
        }
        else if (Array.isArray(this.tagName)) {
            return domNode.tagName.toLowerCase();
        }
        return undefined;
    };
    FormatBlot.prototype.format = function (name, value) {
        var format = Registry.query(name);
        if (format instanceof attributor_1.default) {
            this.attributes.attribute(format, value);
        }
        else if (value) {
            if (format != null && (name !== this.statics.blotName || this.formats()[name] !== value)) {
                this.replaceWith(name, value);
            }
        }
    };
    FormatBlot.prototype.formats = function () {
        var formats = this.attributes.values();
        var format = this.statics.formats(this.domNode);
        if (format != null) {
            formats[this.statics.blotName] = format;
        }
        return formats;
    };
    FormatBlot.prototype.replaceWith = function (name, value) {
        var replacement = _super.prototype.replaceWith.call(this, name, value);
        this.attributes.copy(replacement);
        return replacement;
    };
    FormatBlot.prototype.update = function (mutations, context) {
        var _this = this;
        _super.prototype.update.call(this, mutations, context);
        if (mutations.some(function (mutation) {
            return mutation.target === _this.domNode && mutation.type === 'attributes';
        })) {
            this.attributes.build();
        }
    };
    FormatBlot.prototype.wrap = function (name, value) {
        var wrapper = _super.prototype.wrap.call(this, name, value);
        if (wrapper instanceof FormatBlot && wrapper.statics.scope === this.statics.scope) {
            this.attributes.move(wrapper);
        }
        return wrapper;
    };
    return FormatBlot;
}(container_1.default));
exports.default = FormatBlot;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var shadow_1 = __webpack_require__(30);
var Registry = __webpack_require__(1);
var LeafBlot = /** @class */ (function (_super) {
    __extends(LeafBlot, _super);
    function LeafBlot() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LeafBlot.value = function (domNode) {
        return true;
    };
    LeafBlot.prototype.index = function (node, offset) {
        if (this.domNode === node ||
            this.domNode.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) {
            return Math.min(offset, 1);
        }
        return -1;
    };
    LeafBlot.prototype.position = function (index, inclusive) {
        var offset = [].indexOf.call(this.parent.domNode.childNodes, this.domNode);
        if (index > 0)
            offset += 1;
        return [this.parent.domNode, offset];
    };
    LeafBlot.prototype.value = function () {
        return _a = {}, _a[this.statics.blotName] = this.statics.value(this.domNode) || true, _a;
        var _a;
    };
    LeafBlot.scope = Registry.Scope.INLINE_BLOT;
    return LeafBlot;
}(shadow_1.default));
exports.default = LeafBlot;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var equal = __webpack_require__(11);
var extend = __webpack_require__(3);


var lib = {
  attributes: {
    compose: function (a, b, keepNull) {
      if (typeof a !== 'object') a = {};
      if (typeof b !== 'object') b = {};
      var attributes = extend(true, {}, b);
      if (!keepNull) {
        attributes = Object.keys(attributes).reduce(function (copy, key) {
          if (attributes[key] != null) {
            copy[key] = attributes[key];
          }
          return copy;
        }, {});
      }
      for (var key in a) {
        if (a[key] !== undefined && b[key] === undefined) {
          attributes[key] = a[key];
        }
      }
      return Object.keys(attributes).length > 0 ? attributes : undefined;
    },

    diff: function(a, b) {
      if (typeof a !== 'object') a = {};
      if (typeof b !== 'object') b = {};
      var attributes = Object.keys(a).concat(Object.keys(b)).reduce(function (attributes, key) {
        if (!equal(a[key], b[key])) {
          attributes[key] = b[key] === undefined ? null : b[key];
        }
        return attributes;
      }, {});
      return Object.keys(attributes).length > 0 ? attributes : undefined;
    },

    transform: function (a, b, priority) {
      if (typeof a !== 'object') return b;
      if (typeof b !== 'object') return undefined;
      if (!priority) return b;  // b simply overwrites us without priority
      var attributes = Object.keys(b).reduce(function (attributes, key) {
        if (a[key] === undefined) attributes[key] = b[key];  // null is a valid value
        return attributes;
      }, {});
      return Object.keys(attributes).length > 0 ? attributes : undefined;
    }
  },

  iterator: function (ops) {
    return new Iterator(ops);
  },

  length: function (op) {
    if (typeof op['delete'] === 'number') {
      return op['delete'];
    } else if (typeof op.retain === 'number') {
      return op.retain;
    } else {
      return typeof op.insert === 'string' ? op.insert.length : 1;
    }
  }
};


function Iterator(ops) {
  this.ops = ops;
  this.index = 0;
  this.offset = 0;
};

Iterator.prototype.hasNext = function () {
  return this.peekLength() < Infinity;
};

Iterator.prototype.next = function (length) {
  if (!length) length = Infinity;
  var nextOp = this.ops[this.index];
  if (nextOp) {
    var offset = this.offset;
    var opLength = lib.length(nextOp)
    if (length >= opLength - offset) {
      length = opLength - offset;
      this.index += 1;
      this.offset = 0;
    } else {
      this.offset += length;
    }
    if (typeof nextOp['delete'] === 'number') {
      return { 'delete': length };
    } else {
      var retOp = {};
      if (nextOp.attributes) {
        retOp.attributes = nextOp.attributes;
      }
      if (typeof nextOp.retain === 'number') {
        retOp.retain = length;
      } else if (typeof nextOp.insert === 'string') {
        retOp.insert = nextOp.insert.substr(offset, length);
      } else {
        // offset should === 0, length should === 1
        retOp.insert = nextOp.insert;
      }
      return retOp;
    }
  } else {
    return { retain: Infinity };
  }
};

Iterator.prototype.peek = function () {
  return this.ops[this.index];
};

Iterator.prototype.peekLength = function () {
  if (this.ops[this.index]) {
    // Should never return 0 if our index is being managed correctly
    return lib.length(this.ops[this.index]) - this.offset;
  } else {
    return Infinity;
  }
};

Iterator.prototype.peekType = function () {
  if (this.ops[this.index]) {
    if (typeof this.ops[this.index]['delete'] === 'number') {
      return 'delete';
    } else if (typeof this.ops[this.index].retain === 'number') {
      return 'retain';
    } else {
      return 'insert';
    }
  }
  return 'retain';
};


module.exports = lib;


/***/ }),
/* 21 */
/***/ (function(module, exports) {

var clone = (function() {
'use strict';

function _instanceof(obj, type) {
  return type != null && obj instanceof type;
}

var nativeMap;
try {
  nativeMap = Map;
} catch(_) {
  // maybe a reference error because no `Map`. Give it a dummy value that no
  // value will ever be an instanceof.
  nativeMap = function() {};
}

var nativeSet;
try {
  nativeSet = Set;
} catch(_) {
  nativeSet = function() {};
}

var nativePromise;
try {
  nativePromise = Promise;
} catch(_) {
  nativePromise = function() {};
}

/**
 * Clones (copies) an Object using deep copying.
 *
 * This function supports circular references by default, but if you are certain
 * there are no circular references in your object, you can save some CPU time
 * by calling clone(obj, false).
 *
 * Caution: if `circular` is false and `parent` contains circular references,
 * your program may enter an infinite loop and crash.
 *
 * @param `parent` - the object to be cloned
 * @param `circular` - set to true if the object to be cloned may contain
 *    circular references. (optional - true by default)
 * @param `depth` - set to a number if the object is only to be cloned to
 *    a particular depth. (optional - defaults to Infinity)
 * @param `prototype` - sets the prototype to be used when cloning an object.
 *    (optional - defaults to parent prototype).
 * @param `includeNonEnumerable` - set to true if the non-enumerable properties
 *    should be cloned as well. Non-enumerable properties on the prototype
 *    chain will be ignored. (optional - false by default)
*/
function clone(parent, circular, depth, prototype, includeNonEnumerable) {
  if (typeof circular === 'object') {
    depth = circular.depth;
    prototype = circular.prototype;
    includeNonEnumerable = circular.includeNonEnumerable;
    circular = circular.circular;
  }
  // maintain two arrays for circular references, where corresponding parents
  // and children have the same index
  var allParents = [];
  var allChildren = [];

  var useBuffer = typeof Buffer != 'undefined';

  if (typeof circular == 'undefined')
    circular = true;

  if (typeof depth == 'undefined')
    depth = Infinity;

  // recurse this function so we don't reset allParents and allChildren
  function _clone(parent, depth) {
    // cloning null always returns null
    if (parent === null)
      return null;

    if (depth === 0)
      return parent;

    var child;
    var proto;
    if (typeof parent != 'object') {
      return parent;
    }

    if (_instanceof(parent, nativeMap)) {
      child = new nativeMap();
    } else if (_instanceof(parent, nativeSet)) {
      child = new nativeSet();
    } else if (_instanceof(parent, nativePromise)) {
      child = new nativePromise(function (resolve, reject) {
        parent.then(function(value) {
          resolve(_clone(value, depth - 1));
        }, function(err) {
          reject(_clone(err, depth - 1));
        });
      });
    } else if (clone.__isArray(parent)) {
      child = [];
    } else if (clone.__isRegExp(parent)) {
      child = new RegExp(parent.source, __getRegExpFlags(parent));
      if (parent.lastIndex) child.lastIndex = parent.lastIndex;
    } else if (clone.__isDate(parent)) {
      child = new Date(parent.getTime());
    } else if (useBuffer && Buffer.isBuffer(parent)) {
      child = new Buffer(parent.length);
      parent.copy(child);
      return child;
    } else if (_instanceof(parent, Error)) {
      child = Object.create(parent);
    } else {
      if (typeof prototype == 'undefined') {
        proto = Object.getPrototypeOf(parent);
        child = Object.create(proto);
      }
      else {
        child = Object.create(prototype);
        proto = prototype;
      }
    }

    if (circular) {
      var index = allParents.indexOf(parent);

      if (index != -1) {
        return allChildren[index];
      }
      allParents.push(parent);
      allChildren.push(child);
    }

    if (_instanceof(parent, nativeMap)) {
      parent.forEach(function(value, key) {
        var keyChild = _clone(key, depth - 1);
        var valueChild = _clone(value, depth - 1);
        child.set(keyChild, valueChild);
      });
    }
    if (_instanceof(parent, nativeSet)) {
      parent.forEach(function(value) {
        var entryChild = _clone(value, depth - 1);
        child.add(entryChild);
      });
    }

    for (var i in parent) {
      var attrs;
      if (proto) {
        attrs = Object.getOwnPropertyDescriptor(proto, i);
      }

      if (attrs && attrs.set == null) {
        continue;
      }
      child[i] = _clone(parent[i], depth - 1);
    }

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(parent);
      for (var i = 0; i < symbols.length; i++) {
        // Don't need to worry about cloning a symbol because it is a primitive,
        // like a number or string.
        var symbol = symbols[i];
        var descriptor = Object.getOwnPropertyDescriptor(parent, symbol);
        if (descriptor && !descriptor.enumerable && !includeNonEnumerable) {
          continue;
        }
        child[symbol] = _clone(parent[symbol], depth - 1);
        if (!descriptor.enumerable) {
          Object.defineProperty(child, symbol, {
            enumerable: false
          });
        }
      }
    }

    if (includeNonEnumerable) {
      var allPropertyNames = Object.getOwnPropertyNames(parent);
      for (var i = 0; i < allPropertyNames.length; i++) {
        var propertyName = allPropertyNames[i];
        var descriptor = Object.getOwnPropertyDescriptor(parent, propertyName);
        if (descriptor && descriptor.enumerable) {
          continue;
        }
        child[propertyName] = _clone(parent[propertyName], depth - 1);
        Object.defineProperty(child, propertyName, {
          enumerable: false
        });
      }
    }

    return child;
  }

  return _clone(parent, depth);
}

/**
 * Simple flat clone using prototype, accepts only objects, usefull for property
 * override on FLAT configuration object (no nested props).
 *
 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
 * works.
 */
clone.clonePrototype = function clonePrototype(parent) {
  if (parent === null)
    return null;

  var c = function () {};
  c.prototype = parent;
  return new c();
};

// private utility functions

function __objToStr(o) {
  return Object.prototype.toString.call(o);
}
clone.__objToStr = __objToStr;

function __isDate(o) {
  return typeof o === 'object' && __objToStr(o) === '[object Date]';
}
clone.__isDate = __isDate;

function __isArray(o) {
  return typeof o === 'object' && __objToStr(o) === '[object Array]';
}
clone.__isArray = __isArray;

function __isRegExp(o) {
  return typeof o === 'object' && __objToStr(o) === '[object RegExp]';
}
clone.__isRegExp = __isRegExp;

function __getRegExpFlags(re) {
  var flags = '';
  if (re.global) flags += 'g';
  if (re.ignoreCase) flags += 'i';
  if (re.multiline) flags += 'm';
  return flags;
}
clone.__getRegExpFlags = __getRegExpFlags;

return clone;
})();

if (typeof module === 'object' && module.exports) {
  module.exports = clone;
}


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _emitter = __webpack_require__(8);

var _emitter2 = _interopRequireDefault(_emitter);

var _block = __webpack_require__(4);

var _block2 = _interopRequireDefault(_block);

var _break = __webpack_require__(16);

var _break2 = _interopRequireDefault(_break);

var _code = __webpack_require__(13);

var _code2 = _interopRequireDefault(_code);

var _container = __webpack_require__(25);

var _container2 = _interopRequireDefault(_container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function isLine(blot) {
  return blot instanceof _block2.default || blot instanceof _block.BlockEmbed;
}

var Scroll = function (_Parchment$Scroll) {
  _inherits(Scroll, _Parchment$Scroll);

  function Scroll(domNode, config) {
    _classCallCheck(this, Scroll);

    var _this = _possibleConstructorReturn(this, (Scroll.__proto__ || Object.getPrototypeOf(Scroll)).call(this, domNode));

    _this.emitter = config.emitter;
    if (Array.isArray(config.whitelist)) {
      _this.whitelist = config.whitelist.reduce(function (whitelist, format) {
        whitelist[format] = true;
        return whitelist;
      }, {});
    }
    // Some reason fixes composition issues with character languages in Windows/Chrome, Safari
    _this.domNode.addEventListener('DOMNodeInserted', function () {});
    _this.optimize();
    _this.enable();
    return _this;
  }

  _createClass(Scroll, [{
    key: 'batchStart',
    value: function batchStart() {
      this.batch = true;
    }
  }, {
    key: 'batchEnd',
    value: function batchEnd() {
      this.batch = false;
      this.optimize();
    }
  }, {
    key: 'deleteAt',
    value: function deleteAt(index, length) {
      var _line = this.line(index),
          _line2 = _slicedToArray(_line, 2),
          first = _line2[0],
          offset = _line2[1];

      var _line3 = this.line(index + length),
          _line4 = _slicedToArray(_line3, 1),
          last = _line4[0];

      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'deleteAt', this).call(this, index, length);
      if (last != null && first !== last && offset > 0) {
        if (first instanceof _block.BlockEmbed || last instanceof _block.BlockEmbed) {
          this.optimize();
          return;
        }
        if (first instanceof _code2.default) {
          var newlineIndex = first.newlineIndex(first.length(), true);
          if (newlineIndex > -1) {
            first = first.split(newlineIndex + 1);
            if (first === last) {
              this.optimize();
              return;
            }
          }
        } else if (last instanceof _code2.default) {
          var _newlineIndex = last.newlineIndex(0);
          if (_newlineIndex > -1) {
            last.split(_newlineIndex + 1);
          }
        }
        var ref = last.children.head instanceof _break2.default ? null : last.children.head;
        first.moveChildren(last, ref);
        first.remove();
      }
      this.optimize();
    }
  }, {
    key: 'enable',
    value: function enable() {
      var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      this.domNode.setAttribute('contenteditable', enabled);
    }
  }, {
    key: 'formatAt',
    value: function formatAt(index, length, format, value) {
      if (this.whitelist != null && !this.whitelist[format]) return;
      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'formatAt', this).call(this, index, length, format, value);
      this.optimize();
    }
  }, {
    key: 'insertAt',
    value: function insertAt(index, value, def) {
      if (def != null && this.whitelist != null && !this.whitelist[value]) return;
      if (index >= this.length()) {
        if (def == null || _parchment2.default.query(value, _parchment2.default.Scope.BLOCK) == null) {
          var blot = _parchment2.default.create(this.statics.defaultChild);
          this.appendChild(blot);
          if (def == null && value.endsWith('\n')) {
            value = value.slice(0, -1);
          }
          blot.insertAt(0, value, def);
        } else {
          var embed = _parchment2.default.create(value, def);
          this.appendChild(embed);
        }
      } else {
        _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'insertAt', this).call(this, index, value, def);
      }
      this.optimize();
    }
  }, {
    key: 'insertBefore',
    value: function insertBefore(blot, ref) {
      if (blot.statics.scope === _parchment2.default.Scope.INLINE_BLOT) {
        var wrapper = _parchment2.default.create(this.statics.defaultChild);
        wrapper.appendChild(blot);
        blot = wrapper;
      }
      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'insertBefore', this).call(this, blot, ref);
    }
  }, {
    key: 'leaf',
    value: function leaf(index) {
      return this.path(index).pop() || [null, -1];
    }
  }, {
    key: 'line',
    value: function line(index) {
      if (index === this.length()) {
        return this.line(index - 1);
      }
      return this.descendant(isLine, index);
    }
  }, {
    key: 'lines',
    value: function lines() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;

      var getLines = function getLines(blot, index, length) {
        var lines = [],
            lengthLeft = length;
        blot.children.forEachAt(index, length, function (child, index, length) {
          if (isLine(child)) {
            lines.push(child);
          } else if (child instanceof _parchment2.default.Container) {
            lines = lines.concat(getLines(child, index, lengthLeft));
          }
          lengthLeft -= length;
        });
        return lines;
      };
      return getLines(this, index, length);
    }
  }, {
    key: 'optimize',
    value: function optimize() {
      var mutations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (this.batch === true) return;
      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'optimize', this).call(this, mutations, context);
      if (mutations.length > 0) {
        this.emitter.emit(_emitter2.default.events.SCROLL_OPTIMIZE, mutations, context);
      }
    }
  }, {
    key: 'path',
    value: function path(index) {
      return _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'path', this).call(this, index).slice(1); // Exclude self
    }
  }, {
    key: 'update',
    value: function update(mutations) {
      if (this.batch === true) return;
      var source = _emitter2.default.sources.USER;
      if (typeof mutations === 'string') {
        source = mutations;
      }
      if (!Array.isArray(mutations)) {
        mutations = this.observer.takeRecords();
      }
      if (mutations.length > 0) {
        this.emitter.emit(_emitter2.default.events.SCROLL_BEFORE_UPDATE, source, mutations);
      }
      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'update', this).call(this, mutations.concat([])); // pass copy
      if (mutations.length > 0) {
        this.emitter.emit(_emitter2.default.events.SCROLL_UPDATE, source, mutations);
      }
    }
  }]);

  return Scroll;
}(_parchment2.default.Scroll);

Scroll.blotName = 'scroll';
Scroll.className = 'ql-editor';
Scroll.tagName = 'DIV';
Scroll.defaultChild = 'block';
Scroll.allowedChildren = [_block2.default, _block.BlockEmbed, _container2.default];

exports.default = Scroll;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SHORTKEY = exports.default = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _deepEqual = __webpack_require__(11);

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _extend = __webpack_require__(3);

var _extend2 = _interopRequireDefault(_extend);

var _quillDelta = __webpack_require__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _op = __webpack_require__(20);

var _op2 = _interopRequireDefault(_op);

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _quill = __webpack_require__(5);

var _quill2 = _interopRequireDefault(_quill);

var _logger = __webpack_require__(10);

var _logger2 = _interopRequireDefault(_logger);

var _module = __webpack_require__(9);

var _module2 = _interopRequireDefault(_module);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var debug = (0, _logger2.default)('quill:keyboard');

var SHORTKEY = /Mac/i.test(navigator.platform) ? 'metaKey' : 'ctrlKey';

var Keyboard = function (_Module) {
  _inherits(Keyboard, _Module);

  _createClass(Keyboard, null, [{
    key: 'match',
    value: function match(evt, binding) {
      binding = normalize(binding);
      if (['altKey', 'ctrlKey', 'metaKey', 'shiftKey'].some(function (key) {
        return !!binding[key] !== evt[key] && binding[key] !== null;
      })) {
        return false;
      }
      return binding.key === (evt.which || evt.keyCode);
    }
  }]);

  function Keyboard(quill, options) {
    _classCallCheck(this, Keyboard);

    var _this = _possibleConstructorReturn(this, (Keyboard.__proto__ || Object.getPrototypeOf(Keyboard)).call(this, quill, options));

    _this.bindings = {};
    Object.keys(_this.options.bindings).forEach(function (name) {
      if (name === 'list autofill' && quill.scroll.whitelist != null && !quill.scroll.whitelist['list']) {
        return;
      }
      if (_this.options.bindings[name]) {
        _this.addBinding(_this.options.bindings[name]);
      }
    });
    _this.addBinding({ key: Keyboard.keys.ENTER, shiftKey: null }, handleEnter);
    _this.addBinding({ key: Keyboard.keys.ENTER, metaKey: null, ctrlKey: null, altKey: null }, function () {});
    if (/Firefox/i.test(navigator.userAgent)) {
      // Need to handle delete and backspace for Firefox in the general case #1171
      _this.addBinding({ key: Keyboard.keys.BACKSPACE }, { collapsed: true }, handleBackspace);
      _this.addBinding({ key: Keyboard.keys.DELETE }, { collapsed: true }, handleDelete);
    } else {
      _this.addBinding({ key: Keyboard.keys.BACKSPACE }, { collapsed: true, prefix: /^.?$/ }, handleBackspace);
      _this.addBinding({ key: Keyboard.keys.DELETE }, { collapsed: true, suffix: /^.?$/ }, handleDelete);
    }
    _this.addBinding({ key: Keyboard.keys.BACKSPACE }, { collapsed: false }, handleDeleteRange);
    _this.addBinding({ key: Keyboard.keys.DELETE }, { collapsed: false }, handleDeleteRange);
    _this.addBinding({ key: Keyboard.keys.BACKSPACE, altKey: null, ctrlKey: null, metaKey: null, shiftKey: null }, { collapsed: true, offset: 0 }, handleBackspace);
    _this.listen();
    return _this;
  }

  _createClass(Keyboard, [{
    key: 'addBinding',
    value: function addBinding(key) {
      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var handler = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var binding = normalize(key);
      if (binding == null || binding.key == null) {
        return debug.warn('Attempted to add invalid keyboard binding', binding);
      }
      if (typeof context === 'function') {
        context = { handler: context };
      }
      if (typeof handler === 'function') {
        handler = { handler: handler };
      }
      binding = (0, _extend2.default)(binding, context, handler);
      this.bindings[binding.key] = this.bindings[binding.key] || [];
      this.bindings[binding.key].push(binding);
    }
  }, {
    key: 'listen',
    value: function listen() {
      var _this2 = this;

      this.quill.root.addEventListener('keydown', function (evt) {
        if (evt.defaultPrevented) return;
        var which = evt.which || evt.keyCode;
        var bindings = (_this2.bindings[which] || []).filter(function (binding) {
          return Keyboard.match(evt, binding);
        });
        if (bindings.length === 0) return;
        var range = _this2.quill.getSelection();
        if (range == null || !_this2.quill.hasFocus()) return;

        var _quill$getLine = _this2.quill.getLine(range.index),
            _quill$getLine2 = _slicedToArray(_quill$getLine, 2),
            line = _quill$getLine2[0],
            offset = _quill$getLine2[1];

        var _quill$getLeaf = _this2.quill.getLeaf(range.index),
            _quill$getLeaf2 = _slicedToArray(_quill$getLeaf, 2),
            leafStart = _quill$getLeaf2[0],
            offsetStart = _quill$getLeaf2[1];

        var _ref = range.length === 0 ? [leafStart, offsetStart] : _this2.quill.getLeaf(range.index + range.length),
            _ref2 = _slicedToArray(_ref, 2),
            leafEnd = _ref2[0],
            offsetEnd = _ref2[1];

        var prefixText = leafStart instanceof _parchment2.default.Text ? leafStart.value().slice(0, offsetStart) : '';
        var suffixText = leafEnd instanceof _parchment2.default.Text ? leafEnd.value().slice(offsetEnd) : '';
        var curContext = {
          collapsed: range.length === 0,
          empty: range.length === 0 && line.length() <= 1,
          format: _this2.quill.getFormat(range),
          offset: offset,
          prefix: prefixText,
          suffix: suffixText
        };
        var prevented = bindings.some(function (binding) {
          if (binding.collapsed != null && binding.collapsed !== curContext.collapsed) return false;
          if (binding.empty != null && binding.empty !== curContext.empty) return false;
          if (binding.offset != null && binding.offset !== curContext.offset) return false;
          if (Array.isArray(binding.format)) {
            // any format is present
            if (binding.format.every(function (name) {
              return curContext.format[name] == null;
            })) {
              return false;
            }
          } else if (_typeof(binding.format) === 'object') {
            // all formats must match
            if (!Object.keys(binding.format).every(function (name) {
              if (binding.format[name] === true) return curContext.format[name] != null;
              if (binding.format[name] === false) return curContext.format[name] == null;
              return (0, _deepEqual2.default)(binding.format[name], curContext.format[name]);
            })) {
              return false;
            }
          }
          if (binding.prefix != null && !binding.prefix.test(curContext.prefix)) return false;
          if (binding.suffix != null && !binding.suffix.test(curContext.suffix)) return false;
          return binding.handler.call(_this2, range, curContext) !== true;
        });
        if (prevented) {
          evt.preventDefault();
        }
      });
    }
  }]);

  return Keyboard;
}(_module2.default);

Keyboard.keys = {
  BACKSPACE: 8,
  TAB: 9,
  ENTER: 13,
  ESCAPE: 27,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  DELETE: 46
};

Keyboard.DEFAULTS = {
  bindings: {
    'bold': makeFormatHandler('bold'),
    'italic': makeFormatHandler('italic'),
    'underline': makeFormatHandler('underline'),
    'indent': {
      // highlight tab or tab at beginning of list, indent or blockquote
      key: Keyboard.keys.TAB,
      format: ['blockquote', 'indent', 'list'],
      handler: function handler(range, context) {
        if (context.collapsed && context.offset !== 0) return true;
        this.quill.format('indent', '+1', _quill2.default.sources.USER);
      }
    },
    'outdent': {
      key: Keyboard.keys.TAB,
      shiftKey: true,
      format: ['blockquote', 'indent', 'list'],
      // highlight tab or tab at beginning of list, indent or blockquote
      handler: function handler(range, context) {
        if (context.collapsed && context.offset !== 0) return true;
        this.quill.format('indent', '-1', _quill2.default.sources.USER);
      }
    },
    'outdent backspace': {
      key: Keyboard.keys.BACKSPACE,
      collapsed: true,
      shiftKey: null,
      metaKey: null,
      ctrlKey: null,
      altKey: null,
      format: ['indent', 'list'],
      offset: 0,
      handler: function handler(range, context) {
        if (context.format.indent != null) {
          this.quill.format('indent', '-1', _quill2.default.sources.USER);
        } else if (context.format.list != null) {
          this.quill.format('list', false, _quill2.default.sources.USER);
        }
      }
    },
    'indent code-block': makeCodeBlockHandler(true),
    'outdent code-block': makeCodeBlockHandler(false),
    'remove tab': {
      key: Keyboard.keys.TAB,
      shiftKey: true,
      collapsed: true,
      prefix: /\t$/,
      handler: function handler(range) {
        this.quill.deleteText(range.index - 1, 1, _quill2.default.sources.USER);
      }
    },
    'tab': {
      key: Keyboard.keys.TAB,
      handler: function handler(range) {
        this.quill.history.cutoff();
        var delta = new _quillDelta2.default().retain(range.index).delete(range.length).insert('\t');
        this.quill.updateContents(delta, _quill2.default.sources.USER);
        this.quill.history.cutoff();
        this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
      }
    },
    'list empty enter': {
      key: Keyboard.keys.ENTER,
      collapsed: true,
      format: ['list'],
      empty: true,
      handler: function handler(range, context) {
        this.quill.format('list', false, _quill2.default.sources.USER);
        if (context.format.indent) {
          this.quill.format('indent', false, _quill2.default.sources.USER);
        }
      }
    },
    'checklist enter': {
      key: Keyboard.keys.ENTER,
      collapsed: true,
      format: { list: 'checked' },
      handler: function handler(range) {
        var _quill$getLine3 = this.quill.getLine(range.index),
            _quill$getLine4 = _slicedToArray(_quill$getLine3, 2),
            line = _quill$getLine4[0],
            offset = _quill$getLine4[1];

        var formats = (0, _extend2.default)({}, line.formats(), { list: 'checked' });
        var delta = new _quillDelta2.default().retain(range.index).insert('\n', formats).retain(line.length() - offset - 1).retain(1, { list: 'unchecked' });
        this.quill.updateContents(delta, _quill2.default.sources.USER);
        this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
        this.quill.scrollIntoView();
      }
    },
    'header enter': {
      key: Keyboard.keys.ENTER,
      collapsed: true,
      format: ['header'],
      suffix: /^$/,
      handler: function handler(range, context) {
        var _quill$getLine5 = this.quill.getLine(range.index),
            _quill$getLine6 = _slicedToArray(_quill$getLine5, 2),
            line = _quill$getLine6[0],
            offset = _quill$getLine6[1];

        var delta = new _quillDelta2.default().retain(range.index).insert('\n', context.format).retain(line.length() - offset - 1).retain(1, { header: null });
        this.quill.updateContents(delta, _quill2.default.sources.USER);
        this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
        this.quill.scrollIntoView();
      }
    },
    'list autofill': {
      key: ' ',
      collapsed: true,
      format: { list: false },
      prefix: /^\s*?(\d+\.|-|\*|\[ ?\]|\[x\])$/,
      handler: function handler(range, context) {
        var length = context.prefix.length;

        var _quill$getLine7 = this.quill.getLine(range.index),
            _quill$getLine8 = _slicedToArray(_quill$getLine7, 2),
            line = _quill$getLine8[0],
            offset = _quill$getLine8[1];

        if (offset > length) return true;
        var value = void 0;
        switch (context.prefix.trim()) {
          case '[]':case '[ ]':
            value = 'unchecked';
            break;
          case '[x]':
            value = 'checked';
            break;
          case '-':case '*':
            value = 'bullet';
            break;
          default:
            value = 'ordered';
        }
        this.quill.insertText(range.index, ' ', _quill2.default.sources.USER);
        this.quill.history.cutoff();
        var delta = new _quillDelta2.default().retain(range.index - offset).delete(length + 1).retain(line.length() - 2 - offset).retain(1, { list: value });
        this.quill.updateContents(delta, _quill2.default.sources.USER);
        this.quill.history.cutoff();
        this.quill.setSelection(range.index - length, _quill2.default.sources.SILENT);
      }
    },
    'code exit': {
      key: Keyboard.keys.ENTER,
      collapsed: true,
      format: ['code-block'],
      prefix: /\n\n$/,
      suffix: /^\s+$/,
      handler: function handler(range) {
        var _quill$getLine9 = this.quill.getLine(range.index),
            _quill$getLine10 = _slicedToArray(_quill$getLine9, 2),
            line = _quill$getLine10[0],
            offset = _quill$getLine10[1];

        var delta = new _quillDelta2.default().retain(range.index + line.length() - offset - 2).retain(1, { 'code-block': null }).delete(1);
        this.quill.updateContents(delta, _quill2.default.sources.USER);
      }
    },
    'embed left': makeEmbedArrowHandler(Keyboard.keys.LEFT, false),
    'embed left shift': makeEmbedArrowHandler(Keyboard.keys.LEFT, true),
    'embed right': makeEmbedArrowHandler(Keyboard.keys.RIGHT, false),
    'embed right shift': makeEmbedArrowHandler(Keyboard.keys.RIGHT, true)
  }
};

function makeEmbedArrowHandler(key, shiftKey) {
  var _ref3;

  var where = key === Keyboard.keys.LEFT ? 'prefix' : 'suffix';
  return _ref3 = {
    key: key,
    shiftKey: shiftKey,
    altKey: null
  }, _defineProperty(_ref3, where, /^$/), _defineProperty(_ref3, 'handler', function handler(range) {
    var index = range.index;
    if (key === Keyboard.keys.RIGHT) {
      index += range.length + 1;
    }

    var _quill$getLeaf3 = this.quill.getLeaf(index),
        _quill$getLeaf4 = _slicedToArray(_quill$getLeaf3, 1),
        leaf = _quill$getLeaf4[0];

    if (!(leaf instanceof _parchment2.default.Embed)) return true;
    if (key === Keyboard.keys.LEFT) {
      if (shiftKey) {
        this.quill.setSelection(range.index - 1, range.length + 1, _quill2.default.sources.USER);
      } else {
        this.quill.setSelection(range.index - 1, _quill2.default.sources.USER);
      }
    } else {
      if (shiftKey) {
        this.quill.setSelection(range.index, range.length + 1, _quill2.default.sources.USER);
      } else {
        this.quill.setSelection(range.index + range.length + 1, _quill2.default.sources.USER);
      }
    }
    return false;
  }), _ref3;
}

function handleBackspace(range, context) {
  if (range.index === 0 || this.quill.getLength() <= 1) return;

  var _quill$getLine11 = this.quill.getLine(range.index),
      _quill$getLine12 = _slicedToArray(_quill$getLine11, 1),
      line = _quill$getLine12[0];

  var formats = {};
  if (context.offset === 0) {
    var _quill$getLine13 = this.quill.getLine(range.index - 1),
        _quill$getLine14 = _slicedToArray(_quill$getLine13, 1),
        prev = _quill$getLine14[0];

    if (prev != null && prev.length() > 1) {
      var curFormats = line.formats();
      var prevFormats = this.quill.getFormat(range.index - 1, 1);
      formats = _op2.default.attributes.diff(curFormats, prevFormats) || {};
    }
  }
  // Check for astral symbols
  var length = /[\uD800-\uDBFF][\uDC00-\uDFFF]$/.test(context.prefix) ? 2 : 1;
  this.quill.deleteText(range.index - length, length, _quill2.default.sources.USER);
  if (Object.keys(formats).length > 0) {
    this.quill.formatLine(range.index - length, length, formats, _quill2.default.sources.USER);
  }
  this.quill.focus();
}

function handleDelete(range, context) {
  // Check for astral symbols
  var length = /^[\uD800-\uDBFF][\uDC00-\uDFFF]/.test(context.suffix) ? 2 : 1;
  if (range.index >= this.quill.getLength() - length) return;
  var formats = {},
      nextLength = 0;

  var _quill$getLine15 = this.quill.getLine(range.index),
      _quill$getLine16 = _slicedToArray(_quill$getLine15, 1),
      line = _quill$getLine16[0];

  if (context.offset >= line.length() - 1) {
    var _quill$getLine17 = this.quill.getLine(range.index + 1),
        _quill$getLine18 = _slicedToArray(_quill$getLine17, 1),
        next = _quill$getLine18[0];

    if (next) {
      var curFormats = line.formats();
      var nextFormats = this.quill.getFormat(range.index, 1);
      formats = _op2.default.attributes.diff(curFormats, nextFormats) || {};
      nextLength = next.length();
    }
  }
  this.quill.deleteText(range.index, length, _quill2.default.sources.USER);
  if (Object.keys(formats).length > 0) {
    this.quill.formatLine(range.index + nextLength - 1, length, formats, _quill2.default.sources.USER);
  }
}

function handleDeleteRange(range) {
  var lines = this.quill.getLines(range);
  var formats = {};
  if (lines.length > 1) {
    var firstFormats = lines[0].formats();
    var lastFormats = lines[lines.length - 1].formats();
    formats = _op2.default.attributes.diff(lastFormats, firstFormats) || {};
  }
  this.quill.deleteText(range, _quill2.default.sources.USER);
  if (Object.keys(formats).length > 0) {
    this.quill.formatLine(range.index, 1, formats, _quill2.default.sources.USER);
  }
  this.quill.setSelection(range.index, _quill2.default.sources.SILENT);
  this.quill.focus();
}

function handleEnter(range, context) {
  var _this3 = this;

  if (range.length > 0) {
    this.quill.scroll.deleteAt(range.index, range.length); // So we do not trigger text-change
  }
  var lineFormats = Object.keys(context.format).reduce(function (lineFormats, format) {
    if (_parchment2.default.query(format, _parchment2.default.Scope.BLOCK) && !Array.isArray(context.format[format])) {
      lineFormats[format] = context.format[format];
    }
    return lineFormats;
  }, {});
  this.quill.insertText(range.index, '\n', lineFormats, _quill2.default.sources.USER);
  // Earlier scroll.deleteAt might have messed up our selection,
  // so insertText's built in selection preservation is not reliable
  this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
  this.quill.focus();
  Object.keys(context.format).forEach(function (name) {
    if (lineFormats[name] != null) return;
    if (Array.isArray(context.format[name])) return;
    if (name === 'link') return;
    _this3.quill.format(name, context.format[name], _quill2.default.sources.USER);
  });
}

function makeCodeBlockHandler(indent) {
  return {
    key: Keyboard.keys.TAB,
    shiftKey: !indent,
    format: { 'code-block': true },
    handler: function handler(range) {
      var CodeBlock = _parchment2.default.query('code-block');
      var index = range.index,
          length = range.length;

      var _quill$scroll$descend = this.quill.scroll.descendant(CodeBlock, index),
          _quill$scroll$descend2 = _slicedToArray(_quill$scroll$descend, 2),
          block = _quill$scroll$descend2[0],
          offset = _quill$scroll$descend2[1];

      if (block == null) return;
      var scrollIndex = this.quill.getIndex(block);
      var start = block.newlineIndex(offset, true) + 1;
      var end = block.newlineIndex(scrollIndex + offset + length);
      var lines = block.domNode.textContent.slice(start, end).split('\n');
      offset = 0;
      lines.forEach(function (line, i) {
        if (indent) {
          block.insertAt(start + offset, CodeBlock.TAB);
          offset += CodeBlock.TAB.length;
          if (i === 0) {
            index += CodeBlock.TAB.length;
          } else {
            length += CodeBlock.TAB.length;
          }
        } else if (line.startsWith(CodeBlock.TAB)) {
          block.deleteAt(start + offset, CodeBlock.TAB.length);
          offset -= CodeBlock.TAB.length;
          if (i === 0) {
            index -= CodeBlock.TAB.length;
          } else {
            length -= CodeBlock.TAB.length;
          }
        }
        offset += line.length + 1;
      });
      this.quill.update(_quill2.default.sources.USER);
      this.quill.setSelection(index, length, _quill2.default.sources.SILENT);
    }
  };
}

function makeFormatHandler(format) {
  return {
    key: format[0].toUpperCase(),
    shortKey: true,
    handler: function handler(range, context) {
      this.quill.format(format, !context.format[format], _quill2.default.sources.USER);
    }
  };
}

function normalize(binding) {
  if (typeof binding === 'string' || typeof binding === 'number') {
    return normalize({ key: binding });
  }
  if ((typeof binding === 'undefined' ? 'undefined' : _typeof(binding)) === 'object') {
    binding = (0, _clone2.default)(binding, false);
  }
  if (typeof binding.key === 'string') {
    if (Keyboard.keys[binding.key.toUpperCase()] != null) {
      binding.key = Keyboard.keys[binding.key.toUpperCase()];
    } else if (binding.key.length === 1) {
      binding.key = binding.key.toUpperCase().charCodeAt(0);
    } else {
      return null;
    }
  }
  if (binding.shortKey) {
    binding[SHORTKEY] = binding.shortKey;
    delete binding.shortKey;
  }
  return binding;
}

exports.default = Keyboard;
exports.SHORTKEY = SHORTKEY;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _text = __webpack_require__(7);

var _text2 = _interopRequireDefault(_text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Cursor = function (_Parchment$Embed) {
  _inherits(Cursor, _Parchment$Embed);

  _createClass(Cursor, null, [{
    key: 'value',
    value: function value() {
      return undefined;
    }
  }]);

  function Cursor(domNode, selection) {
    _classCallCheck(this, Cursor);

    var _this = _possibleConstructorReturn(this, (Cursor.__proto__ || Object.getPrototypeOf(Cursor)).call(this, domNode));

    _this.selection = selection;
    _this.textNode = document.createTextNode(Cursor.CONTENTS);
    _this.domNode.appendChild(_this.textNode);
    _this._length = 0;
    return _this;
  }

  _createClass(Cursor, [{
    key: 'detach',
    value: function detach() {
      // super.detach() will also clear domNode.__blot
      if (this.parent != null) this.parent.removeChild(this);
    }
  }, {
    key: 'format',
    value: function format(name, value) {
      if (this._length !== 0) {
        return _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'format', this).call(this, name, value);
      }
      var target = this,
          index = 0;
      while (target != null && target.statics.scope !== _parchment2.default.Scope.BLOCK_BLOT) {
        index += target.offset(target.parent);
        target = target.parent;
      }
      if (target != null) {
        this._length = Cursor.CONTENTS.length;
        target.optimize();
        target.formatAt(index, Cursor.CONTENTS.length, name, value);
        this._length = 0;
      }
    }
  }, {
    key: 'index',
    value: function index(node, offset) {
      if (node === this.textNode) return 0;
      return _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'index', this).call(this, node, offset);
    }
  }, {
    key: 'length',
    value: function length() {
      return this._length;
    }
  }, {
    key: 'position',
    value: function position() {
      return [this.textNode, this.textNode.data.length];
    }
  }, {
    key: 'remove',
    value: function remove() {
      _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'remove', this).call(this);
      this.parent = null;
    }
  }, {
    key: 'restore',
    value: function restore() {
      if (this.selection.composing || this.parent == null) return;
      var textNode = this.textNode;
      var range = this.selection.getNativeRange();
      var restoreText = void 0,
          start = void 0,
          end = void 0;
      if (range != null && range.start.node === textNode && range.end.node === textNode) {
        var _ref = [textNode, range.start.offset, range.end.offset];
        restoreText = _ref[0];
        start = _ref[1];
        end = _ref[2];
      }
      // Link format will insert text outside of anchor tag
      while (this.domNode.lastChild != null && this.domNode.lastChild !== this.textNode) {
        this.domNode.parentNode.insertBefore(this.domNode.lastChild, this.domNode);
      }
      if (this.textNode.data !== Cursor.CONTENTS) {
        var text = this.textNode.data.split(Cursor.CONTENTS).join('');
        if (this.next instanceof _text2.default) {
          restoreText = this.next.domNode;
          this.next.insertAt(0, text);
          this.textNode.data = Cursor.CONTENTS;
        } else {
          this.textNode.data = text;
          this.parent.insertBefore(_parchment2.default.create(this.textNode), this);
          this.textNode = document.createTextNode(Cursor.CONTENTS);
          this.domNode.appendChild(this.textNode);
        }
      }
      this.remove();
      if (start != null) {
        var _map = [start, end].map(function (offset) {
          return Math.max(0, Math.min(restoreText.data.length, offset - 1));
        });

        var _map2 = _slicedToArray(_map, 2);

        start = _map2[0];
        end = _map2[1];

        return {
          startNode: restoreText,
          startOffset: start,
          endNode: restoreText,
          endOffset: end
        };
      }
    }
  }, {
    key: 'update',
    value: function update(mutations, context) {
      var _this2 = this;

      if (mutations.some(function (mutation) {
        return mutation.type === 'characterData' && mutation.target === _this2.textNode;
      })) {
        var range = this.restore();
        if (range) context.range = range;
      }
    }
  }, {
    key: 'value',
    value: function value() {
      return '';
    }
  }]);

  return Cursor;
}(_parchment2.default.Embed);

Cursor.blotName = 'cursor';
Cursor.className = 'ql-cursor';
Cursor.tagName = 'span';
Cursor.CONTENTS = '\uFEFF'; // Zero width no break space


exports.default = Cursor;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _block = __webpack_require__(4);

var _block2 = _interopRequireDefault(_block);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Container = function (_Parchment$Container) {
  _inherits(Container, _Parchment$Container);

  function Container() {
    _classCallCheck(this, Container);

    return _possibleConstructorReturn(this, (Container.__proto__ || Object.getPrototypeOf(Container)).apply(this, arguments));
  }

  return Container;
}(_parchment2.default.Container);

Container.allowedChildren = [_block2.default, _block.BlockEmbed, Container];

exports.default = Container;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColorStyle = exports.ColorClass = exports.ColorAttributor = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ColorAttributor = function (_Parchment$Attributor) {
  _inherits(ColorAttributor, _Parchment$Attributor);

  function ColorAttributor() {
    _classCallCheck(this, ColorAttributor);

    return _possibleConstructorReturn(this, (ColorAttributor.__proto__ || Object.getPrototypeOf(ColorAttributor)).apply(this, arguments));
  }

  _createClass(ColorAttributor, [{
    key: 'value',
    value: function value(domNode) {
      var value = _get(ColorAttributor.prototype.__proto__ || Object.getPrototypeOf(ColorAttributor.prototype), 'value', this).call(this, domNode);
      if (!value.startsWith('rgb(')) return value;
      value = value.replace(/^[^\d]+/, '').replace(/[^\d]+$/, '');
      return '#' + value.split(',').map(function (component) {
        return ('00' + parseInt(component).toString(16)).slice(-2);
      }).join('');
    }
  }]);

  return ColorAttributor;
}(_parchment2.default.Attributor.Style);

var ColorClass = new _parchment2.default.Attributor.Class('color', 'ql-color', {
  scope: _parchment2.default.Scope.INLINE
});
var ColorStyle = new ColorAttributor('color', 'color', {
  scope: _parchment2.default.Scope.INLINE
});

exports.ColorAttributor = ColorAttributor;
exports.ColorClass = ColorClass;
exports.ColorStyle = ColorStyle;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sanitize = exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _inline = __webpack_require__(6);

var _inline2 = _interopRequireDefault(_inline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Link = function (_Inline) {
  _inherits(Link, _Inline);

  function Link() {
    _classCallCheck(this, Link);

    return _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).apply(this, arguments));
  }

  _createClass(Link, [{
    key: 'format',
    value: function format(name, value) {
      if (name !== this.statics.blotName || !value) return _get(Link.prototype.__proto__ || Object.getPrototypeOf(Link.prototype), 'format', this).call(this, name, value);
      value = this.constructor.sanitize(value);
      this.domNode.setAttribute('href', value);
    }
  }], [{
    key: 'create',
    value: function create(value) {
      var node = _get(Link.__proto__ || Object.getPrototypeOf(Link), 'create', this).call(this, value);
      value = this.sanitize(value);
      node.setAttribute('href', value);
      node.setAttribute('target', '_blank');
      return node;
    }
  }, {
    key: 'formats',
    value: function formats(domNode) {
      return domNode.getAttribute('href');
    }
  }, {
    key: 'sanitize',
    value: function sanitize(url) {
      return _sanitize(url, this.PROTOCOL_WHITELIST) ? url : this.SANITIZED_URL;
    }
  }]);

  return Link;
}(_inline2.default);

Link.blotName = 'link';
Link.tagName = 'A';
Link.SANITIZED_URL = 'about:blank';
Link.PROTOCOL_WHITELIST = ['http', 'https', 'mailto', 'tel'];

function _sanitize(url, protocols) {
  var anchor = document.createElement('a');
  anchor.href = url;
  var protocol = anchor.href.slice(0, anchor.href.indexOf(':'));
  return protocols.indexOf(protocol) > -1;
}

exports.default = Link;
exports.sanitize = _sanitize;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _keyboard = __webpack_require__(23);

var _keyboard2 = _interopRequireDefault(_keyboard);

var _dropdown = __webpack_require__(107);

var _dropdown2 = _interopRequireDefault(_dropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var optionsCounter = 0;

function toggleAriaAttribute(element, attribute) {
  element.setAttribute(attribute, !(element.getAttribute(attribute) === 'true'));
}

var Picker = function () {
  function Picker(select) {
    var _this = this;

    _classCallCheck(this, Picker);

    this.select = select;
    this.container = document.createElement('span');
    this.buildPicker();
    this.select.style.display = 'none';
    this.select.parentNode.insertBefore(this.container, this.select);

    this.label.addEventListener('mousedown', function () {
      _this.togglePicker();
    });
    this.label.addEventListener('keydown', function (event) {
      switch (event.keyCode) {
        // Allows the "Enter" key to open the picker
        case _keyboard2.default.keys.ENTER:
          _this.togglePicker();
          break;

        // Allows the "Escape" key to close the picker
        case _keyboard2.default.keys.ESCAPE:
          _this.escape();
          event.preventDefault();
          break;
        default:
      }
    });
    this.select.addEventListener('change', this.update.bind(this));
  }

  _createClass(Picker, [{
    key: 'togglePicker',
    value: function togglePicker() {
      this.container.classList.toggle('ql-expanded');
      // Toggle aria-expanded and aria-hidden to make the picker accessible
      toggleAriaAttribute(this.label, 'aria-expanded');
      toggleAriaAttribute(this.options, 'aria-hidden');
    }
  }, {
    key: 'buildItem',
    value: function buildItem(option) {
      var _this2 = this;

      var item = document.createElement('span');
      item.tabIndex = '0';
      item.setAttribute('role', 'button');

      item.classList.add('ql-picker-item');
      if (option.hasAttribute('value')) {
        item.setAttribute('data-value', option.getAttribute('value'));
      }
      if (option.textContent) {
        item.setAttribute('data-label', option.textContent);
      }
      item.addEventListener('click', function () {
        _this2.selectItem(item, true);
      });
      item.addEventListener('keydown', function (event) {
        switch (event.keyCode) {
          // Allows the "Enter" key to select an item
          case _keyboard2.default.keys.ENTER:
            _this2.selectItem(item, true);
            event.preventDefault();
            break;

          // Allows the "Escape" key to close the picker
          case _keyboard2.default.keys.ESCAPE:
            _this2.escape();
            event.preventDefault();
            break;
          default:
        }
      });

      return item;
    }
  }, {
    key: 'buildLabel',
    value: function buildLabel() {
      var label = document.createElement('span');
      label.classList.add('ql-picker-label');
      label.innerHTML = _dropdown2.default;
      label.tabIndex = '0';
      label.setAttribute('role', 'button');
      label.setAttribute('aria-expanded', 'false');
      this.container.appendChild(label);
      return label;
    }
  }, {
    key: 'buildOptions',
    value: function buildOptions() {
      var _this3 = this;

      var options = document.createElement('span');
      options.classList.add('ql-picker-options');

      // Don't want screen readers to read this until options are visible
      options.setAttribute('aria-hidden', 'true');
      options.tabIndex = '-1';

      // Need a unique id for aria-controls
      options.id = 'ql-picker-options-' + optionsCounter;
      optionsCounter += 1;
      this.label.setAttribute('aria-controls', options.id);

      this.options = options;

      [].slice.call(this.select.options).forEach(function (option) {
        var item = _this3.buildItem(option);
        options.appendChild(item);
        if (option.selected === true) {
          _this3.selectItem(item);
        }
      });
      this.container.appendChild(options);
    }
  }, {
    key: 'buildPicker',
    value: function buildPicker() {
      var _this4 = this;

      [].slice.call(this.select.attributes).forEach(function (item) {
        _this4.container.setAttribute(item.name, item.value);
      });
      this.container.classList.add('ql-picker');
      this.label = this.buildLabel();
      this.buildOptions();
    }
  }, {
    key: 'escape',
    value: function escape() {
      var _this5 = this;

      // Close menu and return focus to trigger label
      this.close();
      // Need setTimeout for accessibility to ensure that the browser executes
      // focus on the next process thread and after any DOM content changes
      setTimeout(function () {
        return _this5.label.focus();
      }, 1);
    }
  }, {
    key: 'close',
    value: function close() {
      this.container.classList.remove('ql-expanded');
      this.label.setAttribute('aria-expanded', 'false');
      this.options.setAttribute('aria-hidden', 'true');
    }
  }, {
    key: 'selectItem',
    value: function selectItem(item) {
      var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var selected = this.container.querySelector('.ql-selected');
      if (item === selected) return;
      if (selected != null) {
        selected.classList.remove('ql-selected');
      }
      if (item == null) return;
      item.classList.add('ql-selected');
      this.select.selectedIndex = [].indexOf.call(item.parentNode.children, item);
      if (item.hasAttribute('data-value')) {
        this.label.setAttribute('data-value', item.getAttribute('data-value'));
      } else {
        this.label.removeAttribute('data-value');
      }
      if (item.hasAttribute('data-label')) {
        this.label.setAttribute('data-label', item.getAttribute('data-label'));
      } else {
        this.label.removeAttribute('data-label');
      }
      if (trigger) {
        if (typeof Event === 'function') {
          this.select.dispatchEvent(new Event('change'));
        } else if ((typeof Event === 'undefined' ? 'undefined' : _typeof(Event)) === 'object') {
          // IE11
          var event = document.createEvent('Event');
          event.initEvent('change', true, true);
          this.select.dispatchEvent(event);
        }
        this.close();
      }
    }
  }, {
    key: 'update',
    value: function update() {
      var option = void 0;
      if (this.select.selectedIndex > -1) {
        var item = this.container.querySelector('.ql-picker-options').children[this.select.selectedIndex];
        option = this.select.options[this.select.selectedIndex];
        this.selectItem(item);
      } else {
        this.selectItem(null);
      }
      var isActive = option != null && option !== this.select.querySelector('option[selected]');
      this.label.classList.toggle('ql-active', isActive);
    }
  }]);

  return Picker;
}();

exports.default = Picker;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _quill = __webpack_require__(5);

var _quill2 = _interopRequireDefault(_quill);

var _block = __webpack_require__(4);

var _block2 = _interopRequireDefault(_block);

var _break = __webpack_require__(16);

var _break2 = _interopRequireDefault(_break);

var _container = __webpack_require__(25);

var _container2 = _interopRequireDefault(_container);

var _cursor = __webpack_require__(24);

var _cursor2 = _interopRequireDefault(_cursor);

var _embed = __webpack_require__(35);

var _embed2 = _interopRequireDefault(_embed);

var _inline = __webpack_require__(6);

var _inline2 = _interopRequireDefault(_inline);

var _scroll = __webpack_require__(22);

var _scroll2 = _interopRequireDefault(_scroll);

var _text = __webpack_require__(7);

var _text2 = _interopRequireDefault(_text);

var _clipboard = __webpack_require__(55);

var _clipboard2 = _interopRequireDefault(_clipboard);

var _history = __webpack_require__(42);

var _history2 = _interopRequireDefault(_history);

var _keyboard = __webpack_require__(23);

var _keyboard2 = _interopRequireDefault(_keyboard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_quill2.default.register({
  'blots/block': _block2.default,
  'blots/block/embed': _block.BlockEmbed,
  'blots/break': _break2.default,
  'blots/container': _container2.default,
  'blots/cursor': _cursor2.default,
  'blots/embed': _embed2.default,
  'blots/inline': _inline2.default,
  'blots/scroll': _scroll2.default,
  'blots/text': _text2.default,

  'modules/clipboard': _clipboard2.default,
  'modules/history': _history2.default,
  'modules/keyboard': _keyboard2.default
});

_parchment2.default.register(_block2.default, _break2.default, _cursor2.default, _inline2.default, _scroll2.default, _text2.default);

exports.default = _quill2.default;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Registry = __webpack_require__(1);
var ShadowBlot = /** @class */ (function () {
    function ShadowBlot(domNode) {
        this.domNode = domNode;
        // @ts-ignore
        this.domNode[Registry.DATA_KEY] = { blot: this };
    }
    Object.defineProperty(ShadowBlot.prototype, "statics", {
        // Hack for accessing inherited static methods
        get: function () {
            return this.constructor;
        },
        enumerable: true,
        configurable: true
    });
    ShadowBlot.create = function (value) {
        if (this.tagName == null) {
            throw new Registry.ParchmentError('Blot definition missing tagName');
        }
        var node;
        if (Array.isArray(this.tagName)) {
            if (typeof value === 'string') {
                value = value.toUpperCase();
                if (parseInt(value).toString() === value) {
                    value = parseInt(value);
                }
            }
            if (typeof value === 'number') {
                node = document.createElement(this.tagName[value - 1]);
            }
            else if (this.tagName.indexOf(value) > -1) {
                node = document.createElement(value);
            }
            else {
                node = document.createElement(this.tagName[0]);
            }
        }
        else {
            node = document.createElement(this.tagName);
        }
        if (this.className) {
            node.classList.add(this.className);
        }
        return node;
    };
    ShadowBlot.prototype.attach = function () {
        if (this.parent != null) {
            this.scroll = this.parent.scroll;
        }
    };
    ShadowBlot.prototype.clone = function () {
        var domNode = this.domNode.cloneNode(false);
        return Registry.create(domNode);
    };
    ShadowBlot.prototype.detach = function () {
        if (this.parent != null)
            this.parent.removeChild(this);
        // @ts-ignore
        delete this.domNode[Registry.DATA_KEY];
    };
    ShadowBlot.prototype.deleteAt = function (index, length) {
        var blot = this.isolate(index, length);
        blot.remove();
    };
    ShadowBlot.prototype.formatAt = function (index, length, name, value) {
        var blot = this.isolate(index, length);
        if (Registry.query(name, Registry.Scope.BLOT) != null && value) {
            blot.wrap(name, value);
        }
        else if (Registry.query(name, Registry.Scope.ATTRIBUTE) != null) {
            var parent = Registry.create(this.statics.scope);
            blot.wrap(parent);
            parent.format(name, value);
        }
    };
    ShadowBlot.prototype.insertAt = function (index, value, def) {
        var blot = def == null ? Registry.create('text', value) : Registry.create(value, def);
        var ref = this.split(index);
        this.parent.insertBefore(blot, ref);
    };
    ShadowBlot.prototype.insertInto = function (parentBlot, refBlot) {
        if (refBlot === void 0) { refBlot = null; }
        if (this.parent != null) {
            this.parent.children.remove(this);
        }
        var refDomNode = null;
        parentBlot.children.insertBefore(this, refBlot);
        if (refBlot != null) {
            refDomNode = refBlot.domNode;
        }
        if (this.domNode.parentNode != parentBlot.domNode ||
            this.domNode.nextSibling != refDomNode) {
            parentBlot.domNode.insertBefore(this.domNode, refDomNode);
        }
        this.parent = parentBlot;
        this.attach();
    };
    ShadowBlot.prototype.isolate = function (index, length) {
        var target = this.split(index);
        target.split(length);
        return target;
    };
    ShadowBlot.prototype.length = function () {
        return 1;
    };
    ShadowBlot.prototype.offset = function (root) {
        if (root === void 0) { root = this.parent; }
        if (this.parent == null || this == root)
            return 0;
        return this.parent.children.offset(this) + this.parent.offset(root);
    };
    ShadowBlot.prototype.optimize = function (context) {
        // TODO clean up once we use WeakMap
        // @ts-ignore
        if (this.domNode[Registry.DATA_KEY] != null) {
            // @ts-ignore
            delete this.domNode[Registry.DATA_KEY].mutations;
        }
    };
    ShadowBlot.prototype.remove = function () {
        if (this.domNode.parentNode != null) {
            this.domNode.parentNode.removeChild(this.domNode);
        }
        this.detach();
    };
    ShadowBlot.prototype.replace = function (target) {
        if (target.parent == null)
            return;
        target.parent.insertBefore(this, target.next);
        target.remove();
    };
    ShadowBlot.prototype.replaceWith = function (name, value) {
        var replacement = typeof name === 'string' ? Registry.create(name, value) : name;
        replacement.replace(this);
        return replacement;
    };
    ShadowBlot.prototype.split = function (index, force) {
        return index === 0 ? this : this.next;
    };
    ShadowBlot.prototype.update = function (mutations, context) {
        // Nothing to do by default
    };
    ShadowBlot.prototype.wrap = function (name, value) {
        var wrapper = typeof name === 'string' ? Registry.create(name, value) : name;
        if (this.parent != null) {
            this.parent.insertBefore(wrapper, this.next);
        }
        wrapper.appendChild(this);
        return wrapper;
    };
    ShadowBlot.blotName = 'abstract';
    return ShadowBlot;
}());
exports.default = ShadowBlot;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var attributor_1 = __webpack_require__(12);
var class_1 = __webpack_require__(32);
var style_1 = __webpack_require__(33);
var Registry = __webpack_require__(1);
var AttributorStore = /** @class */ (function () {
    function AttributorStore(domNode) {
        this.attributes = {};
        this.domNode = domNode;
        this.build();
    }
    AttributorStore.prototype.attribute = function (attribute, value) {
        // verb
        if (value) {
            if (attribute.add(this.domNode, value)) {
                if (attribute.value(this.domNode) != null) {
                    this.attributes[attribute.attrName] = attribute;
                }
                else {
                    delete this.attributes[attribute.attrName];
                }
            }
        }
        else {
            attribute.remove(this.domNode);
            delete this.attributes[attribute.attrName];
        }
    };
    AttributorStore.prototype.build = function () {
        var _this = this;
        this.attributes = {};
        var attributes = attributor_1.default.keys(this.domNode);
        var classes = class_1.default.keys(this.domNode);
        var styles = style_1.default.keys(this.domNode);
        attributes
            .concat(classes)
            .concat(styles)
            .forEach(function (name) {
            var attr = Registry.query(name, Registry.Scope.ATTRIBUTE);
            if (attr instanceof attributor_1.default) {
                _this.attributes[attr.attrName] = attr;
            }
        });
    };
    AttributorStore.prototype.copy = function (target) {
        var _this = this;
        Object.keys(this.attributes).forEach(function (key) {
            var value = _this.attributes[key].value(_this.domNode);
            target.format(key, value);
        });
    };
    AttributorStore.prototype.move = function (target) {
        var _this = this;
        this.copy(target);
        Object.keys(this.attributes).forEach(function (key) {
            _this.attributes[key].remove(_this.domNode);
        });
        this.attributes = {};
    };
    AttributorStore.prototype.values = function () {
        var _this = this;
        return Object.keys(this.attributes).reduce(function (attributes, name) {
            attributes[name] = _this.attributes[name].value(_this.domNode);
            return attributes;
        }, {});
    };
    return AttributorStore;
}());
exports.default = AttributorStore;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var attributor_1 = __webpack_require__(12);
function match(node, prefix) {
    var className = node.getAttribute('class') || '';
    return className.split(/\s+/).filter(function (name) {
        return name.indexOf(prefix + "-") === 0;
    });
}
var ClassAttributor = /** @class */ (function (_super) {
    __extends(ClassAttributor, _super);
    function ClassAttributor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ClassAttributor.keys = function (node) {
        return (node.getAttribute('class') || '').split(/\s+/).map(function (name) {
            return name
                .split('-')
                .slice(0, -1)
                .join('-');
        });
    };
    ClassAttributor.prototype.add = function (node, value) {
        if (!this.canAdd(node, value))
            return false;
        this.remove(node);
        node.classList.add(this.keyName + "-" + value);
        return true;
    };
    ClassAttributor.prototype.remove = function (node) {
        var matches = match(node, this.keyName);
        matches.forEach(function (name) {
            node.classList.remove(name);
        });
        if (node.classList.length === 0) {
            node.removeAttribute('class');
        }
    };
    ClassAttributor.prototype.value = function (node) {
        var result = match(node, this.keyName)[0] || '';
        var value = result.slice(this.keyName.length + 1); // +1 for hyphen
        return this.canAdd(node, value) ? value : '';
    };
    return ClassAttributor;
}(attributor_1.default));
exports.default = ClassAttributor;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var attributor_1 = __webpack_require__(12);
function camelize(name) {
    var parts = name.split('-');
    var rest = parts
        .slice(1)
        .map(function (part) {
        return part[0].toUpperCase() + part.slice(1);
    })
        .join('');
    return parts[0] + rest;
}
var StyleAttributor = /** @class */ (function (_super) {
    __extends(StyleAttributor, _super);
    function StyleAttributor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StyleAttributor.keys = function (node) {
        return (node.getAttribute('style') || '').split(';').map(function (value) {
            var arr = value.split(':');
            return arr[0].trim();
        });
    };
    StyleAttributor.prototype.add = function (node, value) {
        if (!this.canAdd(node, value))
            return false;
        // @ts-ignore
        node.style[camelize(this.keyName)] = value;
        return true;
    };
    StyleAttributor.prototype.remove = function (node) {
        // @ts-ignore
        node.style[camelize(this.keyName)] = '';
        if (!node.getAttribute('style')) {
            node.removeAttribute('style');
        }
    };
    StyleAttributor.prototype.value = function (node) {
        // @ts-ignore
        var value = node.style[camelize(this.keyName)];
        return this.canAdd(node, value) ? value : '';
    };
    return StyleAttributor;
}(attributor_1.default));
exports.default = StyleAttributor;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Theme = function () {
  function Theme(quill, options) {
    _classCallCheck(this, Theme);

    this.quill = quill;
    this.options = options;
    this.modules = {};
  }

  _createClass(Theme, [{
    key: 'init',
    value: function init() {
      var _this = this;

      Object.keys(this.options.modules).forEach(function (name) {
        if (_this.modules[name] == null) {
          _this.addModule(name);
        }
      });
    }
  }, {
    key: 'addModule',
    value: function addModule(name) {
      var moduleClass = this.quill.constructor.import('modules/' + name);
      this.modules[name] = new moduleClass(this.quill, this.options.modules[name] || {});
      return this.modules[name];
    }
  }]);

  return Theme;
}();

Theme.DEFAULTS = {
  modules: {}
};
Theme.themes = {
  'default': Theme
};

exports.default = Theme;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _text = __webpack_require__(7);

var _text2 = _interopRequireDefault(_text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GUARD_TEXT = '\uFEFF';

var Embed = function (_Parchment$Embed) {
  _inherits(Embed, _Parchment$Embed);

  function Embed(node) {
    _classCallCheck(this, Embed);

    var _this = _possibleConstructorReturn(this, (Embed.__proto__ || Object.getPrototypeOf(Embed)).call(this, node));

    _this.contentNode = document.createElement('span');
    _this.contentNode.setAttribute('contenteditable', false);
    [].slice.call(_this.domNode.childNodes).forEach(function (childNode) {
      _this.contentNode.appendChild(childNode);
    });
    _this.leftGuard = document.createTextNode(GUARD_TEXT);
    _this.rightGuard = document.createTextNode(GUARD_TEXT);
    _this.domNode.appendChild(_this.leftGuard);
    _this.domNode.appendChild(_this.contentNode);
    _this.domNode.appendChild(_this.rightGuard);
    return _this;
  }

  _createClass(Embed, [{
    key: 'index',
    value: function index(node, offset) {
      if (node === this.leftGuard) return 0;
      if (node === this.rightGuard) return 1;
      return _get(Embed.prototype.__proto__ || Object.getPrototypeOf(Embed.prototype), 'index', this).call(this, node, offset);
    }
  }, {
    key: 'restore',
    value: function restore(node) {
      var range = void 0,
          textNode = void 0;
      var text = node.data.split(GUARD_TEXT).join('');
      if (node === this.leftGuard) {
        if (this.prev instanceof _text2.default) {
          var prevLength = this.prev.length();
          this.prev.insertAt(prevLength, text);
          range = {
            startNode: this.prev.domNode,
            startOffset: prevLength + text.length
          };
        } else {
          textNode = document.createTextNode(text);
          this.parent.insertBefore(_parchment2.default.create(textNode), this);
          range = {
            startNode: textNode,
            startOffset: text.length
          };
        }
      } else if (node === this.rightGuard) {
        if (this.next instanceof _text2.default) {
          this.next.insertAt(0, text);
          range = {
            startNode: this.next.domNode,
            startOffset: text.length
          };
        } else {
          textNode = document.createTextNode(text);
          this.parent.insertBefore(_parchment2.default.create(textNode), this.next);
          range = {
            startNode: textNode,
            startOffset: text.length
          };
        }
      }
      node.data = GUARD_TEXT;
      return range;
    }
  }, {
    key: 'update',
    value: function update(mutations, context) {
      var _this2 = this;

      mutations.forEach(function (mutation) {
        if (mutation.type === 'characterData' && (mutation.target === _this2.leftGuard || mutation.target === _this2.rightGuard)) {
          var range = _this2.restore(mutation.target);
          if (range) context.range = range;
        }
      });
    }
  }]);

  return Embed;
}(_parchment2.default.Embed);

exports.default = Embed;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlignStyle = exports.AlignClass = exports.AlignAttribute = undefined;

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var config = {
  scope: _parchment2.default.Scope.BLOCK,
  whitelist: ['right', 'center', 'justify']
};

var AlignAttribute = new _parchment2.default.Attributor.Attribute('align', 'align', config);
var AlignClass = new _parchment2.default.Attributor.Class('align', 'ql-align', config);
var AlignStyle = new _parchment2.default.Attributor.Style('align', 'text-align', config);

exports.AlignAttribute = AlignAttribute;
exports.AlignClass = AlignClass;
exports.AlignStyle = AlignStyle;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BackgroundStyle = exports.BackgroundClass = undefined;

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _color = __webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BackgroundClass = new _parchment2.default.Attributor.Class('background', 'ql-bg', {
  scope: _parchment2.default.Scope.INLINE
});
var BackgroundStyle = new _color.ColorAttributor('background', 'background-color', {
  scope: _parchment2.default.Scope.INLINE
});

exports.BackgroundClass = BackgroundClass;
exports.BackgroundStyle = BackgroundStyle;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DirectionStyle = exports.DirectionClass = exports.DirectionAttribute = undefined;

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var config = {
  scope: _parchment2.default.Scope.BLOCK,
  whitelist: ['rtl']
};

var DirectionAttribute = new _parchment2.default.Attributor.Attribute('direction', 'dir', config);
var DirectionClass = new _parchment2.default.Attributor.Class('direction', 'ql-direction', config);
var DirectionStyle = new _parchment2.default.Attributor.Style('direction', 'direction', config);

exports.DirectionAttribute = DirectionAttribute;
exports.DirectionClass = DirectionClass;
exports.DirectionStyle = DirectionStyle;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FontClass = exports.FontStyle = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var config = {
  scope: _parchment2.default.Scope.INLINE,
  whitelist: ['serif', 'monospace']
};

var FontClass = new _parchment2.default.Attributor.Class('font', 'ql-font', config);

var FontStyleAttributor = function (_Parchment$Attributor) {
  _inherits(FontStyleAttributor, _Parchment$Attributor);

  function FontStyleAttributor() {
    _classCallCheck(this, FontStyleAttributor);

    return _possibleConstructorReturn(this, (FontStyleAttributor.__proto__ || Object.getPrototypeOf(FontStyleAttributor)).apply(this, arguments));
  }

  _createClass(FontStyleAttributor, [{
    key: 'value',
    value: function value(node) {
      return _get(FontStyleAttributor.prototype.__proto__ || Object.getPrototypeOf(FontStyleAttributor.prototype), 'value', this).call(this, node).replace(/["']/g, '');
    }
  }]);

  return FontStyleAttributor;
}(_parchment2.default.Attributor.Style);

var FontStyle = new FontStyleAttributor('font', 'font-family', config);

exports.FontStyle = FontStyle;
exports.FontClass = FontClass;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SizeStyle = exports.SizeClass = undefined;

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SizeClass = new _parchment2.default.Attributor.Class('size', 'ql-size', {
  scope: _parchment2.default.Scope.INLINE,
  whitelist: ['small', 'large', 'huge']
});
var SizeStyle = new _parchment2.default.Attributor.Style('size', 'font-size', {
  scope: _parchment2.default.Scope.INLINE,
  whitelist: ['10px', '18px', '32px']
});

exports.SizeClass = SizeClass;
exports.SizeStyle = SizeStyle;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  'align': {
    '': __webpack_require__(76),
    'center': __webpack_require__(77),
    'right': __webpack_require__(78),
    'justify': __webpack_require__(79)
  },
  'background': __webpack_require__(80),
  'blockquote': __webpack_require__(81),
  'bold': __webpack_require__(82),
  'clean': __webpack_require__(83),
  'code': __webpack_require__(58),
  'code-block': __webpack_require__(58),
  'color': __webpack_require__(84),
  'direction': {
    '': __webpack_require__(85),
    'rtl': __webpack_require__(86)
  },
  'float': {
    'center': __webpack_require__(87),
    'full': __webpack_require__(88),
    'left': __webpack_require__(89),
    'right': __webpack_require__(90)
  },
  'formula': __webpack_require__(91),
  'header': {
    '1': __webpack_require__(92),
    '2': __webpack_require__(93)
  },
  'italic': __webpack_require__(94),
  'image': __webpack_require__(95),
  'indent': {
    '+1': __webpack_require__(96),
    '-1': __webpack_require__(97)
  },
  'link': __webpack_require__(98),
  'list': {
    'ordered': __webpack_require__(99),
    'bullet': __webpack_require__(100),
    'check': __webpack_require__(101)
  },
  'script': {
    'sub': __webpack_require__(102),
    'super': __webpack_require__(103)
  },
  'strike': __webpack_require__(104),
  'underline': __webpack_require__(105),
  'video': __webpack_require__(106)
};

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLastChangeIndex = exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _quill = __webpack_require__(5);

var _quill2 = _interopRequireDefault(_quill);

var _module = __webpack_require__(9);

var _module2 = _interopRequireDefault(_module);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var History = function (_Module) {
  _inherits(History, _Module);

  function History(quill, options) {
    _classCallCheck(this, History);

    var _this = _possibleConstructorReturn(this, (History.__proto__ || Object.getPrototypeOf(History)).call(this, quill, options));

    _this.lastRecorded = 0;
    _this.ignoreChange = false;
    _this.clear();
    _this.quill.on(_quill2.default.events.EDITOR_CHANGE, function (eventName, delta, oldDelta, source) {
      if (eventName !== _quill2.default.events.TEXT_CHANGE || _this.ignoreChange) return;
      if (!_this.options.userOnly || source === _quill2.default.sources.USER) {
        _this.record(delta, oldDelta);
      } else {
        _this.transform(delta);
      }
    });
    _this.quill.keyboard.addBinding({ key: 'Z', shortKey: true }, _this.undo.bind(_this));
    _this.quill.keyboard.addBinding({ key: 'Z', shortKey: true, shiftKey: true }, _this.redo.bind(_this));
    if (/Win/i.test(navigator.platform)) {
      _this.quill.keyboard.addBinding({ key: 'Y', shortKey: true }, _this.redo.bind(_this));
    }
    return _this;
  }

  _createClass(History, [{
    key: 'change',
    value: function change(source, dest) {
      if (this.stack[source].length === 0) return;
      var delta = this.stack[source].pop();
      this.stack[dest].push(delta);
      this.lastRecorded = 0;
      this.ignoreChange = true;
      this.quill.updateContents(delta[source], _quill2.default.sources.USER);
      this.ignoreChange = false;
      var index = getLastChangeIndex(delta[source]);
      this.quill.setSelection(index);
    }
  }, {
    key: 'clear',
    value: function clear() {
      this.stack = { undo: [], redo: [] };
    }
  }, {
    key: 'cutoff',
    value: function cutoff() {
      this.lastRecorded = 0;
    }
  }, {
    key: 'record',
    value: function record(changeDelta, oldDelta) {
      if (changeDelta.ops.length === 0) return;
      this.stack.redo = [];
      var undoDelta = this.quill.getContents().diff(oldDelta);
      var timestamp = Date.now();
      if (this.lastRecorded + this.options.delay > timestamp && this.stack.undo.length > 0) {
        var delta = this.stack.undo.pop();
        undoDelta = undoDelta.compose(delta.undo);
        changeDelta = delta.redo.compose(changeDelta);
      } else {
        this.lastRecorded = timestamp;
      }
      this.stack.undo.push({
        redo: changeDelta,
        undo: undoDelta
      });
      if (this.stack.undo.length > this.options.maxStack) {
        this.stack.undo.shift();
      }
    }
  }, {
    key: 'redo',
    value: function redo() {
      this.change('redo', 'undo');
    }
  }, {
    key: 'transform',
    value: function transform(delta) {
      this.stack.undo.forEach(function (change) {
        change.undo = delta.transform(change.undo, true);
        change.redo = delta.transform(change.redo, true);
      });
      this.stack.redo.forEach(function (change) {
        change.undo = delta.transform(change.undo, true);
        change.redo = delta.transform(change.redo, true);
      });
    }
  }, {
    key: 'undo',
    value: function undo() {
      this.change('undo', 'redo');
    }
  }]);

  return History;
}(_module2.default);

History.DEFAULTS = {
  delay: 1000,
  maxStack: 100,
  userOnly: false
};

function endsWithNewlineChange(delta) {
  var lastOp = delta.ops[delta.ops.length - 1];
  if (lastOp == null) return false;
  if (lastOp.insert != null) {
    return typeof lastOp.insert === 'string' && lastOp.insert.endsWith('\n');
  }
  if (lastOp.attributes != null) {
    return Object.keys(lastOp.attributes).some(function (attr) {
      return _parchment2.default.query(attr, _parchment2.default.Scope.BLOCK) != null;
    });
  }
  return false;
}

function getLastChangeIndex(delta) {
  var deleteLength = delta.reduce(function (length, op) {
    length += op.delete || 0;
    return length;
  }, 0);
  var changeIndex = delta.length() - deleteLength;
  if (endsWithNewlineChange(delta)) {
    changeIndex -= 1;
  }
  return changeIndex;
}

exports.default = History;
exports.getLastChangeIndex = getLastChangeIndex;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BaseTooltip = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _extend = __webpack_require__(3);

var _extend2 = _interopRequireDefault(_extend);

var _quillDelta = __webpack_require__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _emitter = __webpack_require__(8);

var _emitter2 = _interopRequireDefault(_emitter);

var _keyboard = __webpack_require__(23);

var _keyboard2 = _interopRequireDefault(_keyboard);

var _theme = __webpack_require__(34);

var _theme2 = _interopRequireDefault(_theme);

var _colorPicker = __webpack_require__(59);

var _colorPicker2 = _interopRequireDefault(_colorPicker);

var _iconPicker = __webpack_require__(60);

var _iconPicker2 = _interopRequireDefault(_iconPicker);

var _picker = __webpack_require__(28);

var _picker2 = _interopRequireDefault(_picker);

var _tooltip = __webpack_require__(61);

var _tooltip2 = _interopRequireDefault(_tooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ALIGNS = [false, 'center', 'right', 'justify'];

var COLORS = ["#000000", "#e60000", "#ff9900", "#ffff00", "#008a00", "#0066cc", "#9933ff", "#ffffff", "#facccc", "#ffebcc", "#ffffcc", "#cce8cc", "#cce0f5", "#ebd6ff", "#bbbbbb", "#f06666", "#ffc266", "#ffff66", "#66b966", "#66a3e0", "#c285ff", "#888888", "#a10000", "#b26b00", "#b2b200", "#006100", "#0047b2", "#6b24b2", "#444444", "#5c0000", "#663d00", "#666600", "#003700", "#002966", "#3d1466"];

var FONTS = [false, 'serif', 'monospace'];

var HEADERS = ['1', '2', '3', false];

var SIZES = ['small', false, 'large', 'huge'];

var BaseTheme = function (_Theme) {
  _inherits(BaseTheme, _Theme);

  function BaseTheme(quill, options) {
    _classCallCheck(this, BaseTheme);

    var _this = _possibleConstructorReturn(this, (BaseTheme.__proto__ || Object.getPrototypeOf(BaseTheme)).call(this, quill, options));

    var listener = function listener(e) {
      if (!document.body.contains(quill.root)) {
        return document.body.removeEventListener('click', listener);
      }
      if (_this.tooltip != null && !_this.tooltip.root.contains(e.target) && document.activeElement !== _this.tooltip.textbox && !_this.quill.hasFocus()) {
        _this.tooltip.hide();
      }
      if (_this.pickers != null) {
        _this.pickers.forEach(function (picker) {
          if (!picker.container.contains(e.target)) {
            picker.close();
          }
        });
      }
    };
    quill.emitter.listenDOM('click', document.body, listener);
    return _this;
  }

  _createClass(BaseTheme, [{
    key: 'addModule',
    value: function addModule(name) {
      var module = _get(BaseTheme.prototype.__proto__ || Object.getPrototypeOf(BaseTheme.prototype), 'addModule', this).call(this, name);
      if (name === 'toolbar') {
        this.extendToolbar(module);
      }
      return module;
    }
  }, {
    key: 'buildButtons',
    value: function buildButtons(buttons, icons) {
      buttons.forEach(function (button) {
        var className = button.getAttribute('class') || '';
        className.split(/\s+/).forEach(function (name) {
          if (!name.startsWith('ql-')) return;
          name = name.slice('ql-'.length);
          if (icons[name] == null) return;
          if (name === 'direction') {
            button.innerHTML = icons[name][''] + icons[name]['rtl'];
          } else if (typeof icons[name] === 'string') {
            button.innerHTML = icons[name];
          } else {
            var value = button.value || '';
            if (value != null && icons[name][value]) {
              button.innerHTML = icons[name][value];
            }
          }
        });
      });
    }
  }, {
    key: 'buildPickers',
    value: function buildPickers(selects, icons) {
      var _this2 = this;

      this.pickers = selects.map(function (select) {
        if (select.classList.contains('ql-align')) {
          if (select.querySelector('option') == null) {
            fillSelect(select, ALIGNS);
          }
          return new _iconPicker2.default(select, icons.align);
        } else if (select.classList.contains('ql-background') || select.classList.contains('ql-color')) {
          var format = select.classList.contains('ql-background') ? 'background' : 'color';
          if (select.querySelector('option') == null) {
            fillSelect(select, COLORS, format === 'background' ? '#ffffff' : '#000000');
          }
          return new _colorPicker2.default(select, icons[format]);
        } else {
          if (select.querySelector('option') == null) {
            if (select.classList.contains('ql-font')) {
              fillSelect(select, FONTS);
            } else if (select.classList.contains('ql-header')) {
              fillSelect(select, HEADERS);
            } else if (select.classList.contains('ql-size')) {
              fillSelect(select, SIZES);
            }
          }
          return new _picker2.default(select);
        }
      });
      var update = function update() {
        _this2.pickers.forEach(function (picker) {
          picker.update();
        });
      };
      this.quill.on(_emitter2.default.events.EDITOR_CHANGE, update);
    }
  }]);

  return BaseTheme;
}(_theme2.default);

BaseTheme.DEFAULTS = (0, _extend2.default)(true, {}, _theme2.default.DEFAULTS, {
  modules: {
    toolbar: {
      handlers: {
        formula: function formula() {
          this.quill.theme.tooltip.edit('formula');
        },
        image: function image() {
          var _this3 = this;

          var fileInput = this.container.querySelector('input.ql-image[type=file]');
          if (fileInput == null) {
            fileInput = document.createElement('input');
            fileInput.setAttribute('type', 'file');
            fileInput.setAttribute('accept', 'image/png, image/gif, image/jpeg, image/bmp, image/x-icon');
            fileInput.classList.add('ql-image');
            fileInput.addEventListener('change', function () {
              if (fileInput.files != null && fileInput.files[0] != null) {
                var reader = new FileReader();
                reader.onload = function (e) {
                  var range = _this3.quill.getSelection(true);
                  _this3.quill.updateContents(new _quillDelta2.default().retain(range.index).delete(range.length).insert({ image: e.target.result }), _emitter2.default.sources.USER);
                  _this3.quill.setSelection(range.index + 1, _emitter2.default.sources.SILENT);
                  fileInput.value = "";
                };
                reader.readAsDataURL(fileInput.files[0]);
              }
            });
            this.container.appendChild(fileInput);
          }
          fileInput.click();
        },
        video: function video() {
          this.quill.theme.tooltip.edit('video');
        }
      }
    }
  }
});

var BaseTooltip = function (_Tooltip) {
  _inherits(BaseTooltip, _Tooltip);

  function BaseTooltip(quill, boundsContainer) {
    _classCallCheck(this, BaseTooltip);

    var _this4 = _possibleConstructorReturn(this, (BaseTooltip.__proto__ || Object.getPrototypeOf(BaseTooltip)).call(this, quill, boundsContainer));

    _this4.textbox = _this4.root.querySelector('input[type="text"]');
    _this4.listen();
    return _this4;
  }

  _createClass(BaseTooltip, [{
    key: 'listen',
    value: function listen() {
      var _this5 = this;

      this.textbox.addEventListener('keydown', function (event) {
        if (_keyboard2.default.match(event, 'enter')) {
          _this5.save();
          event.preventDefault();
        } else if (_keyboard2.default.match(event, 'escape')) {
          _this5.cancel();
          event.preventDefault();
        }
      });
    }
  }, {
    key: 'cancel',
    value: function cancel() {
      this.hide();
    }
  }, {
    key: 'edit',
    value: function edit() {
      var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'link';
      var preview = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      this.root.classList.remove('ql-hidden');
      this.root.classList.add('ql-editing');
      if (preview != null) {
        this.textbox.value = preview;
      } else if (mode !== this.root.getAttribute('data-mode')) {
        this.textbox.value = '';
      }
      this.position(this.quill.getBounds(this.quill.selection.savedRange));
      this.textbox.select();
      this.textbox.setAttribute('placeholder', this.textbox.getAttribute('data-' + mode) || '');
      this.root.setAttribute('data-mode', mode);
    }
  }, {
    key: 'restoreFocus',
    value: function restoreFocus() {
      var scrollTop = this.quill.scrollingContainer.scrollTop;
      this.quill.focus();
      this.quill.scrollingContainer.scrollTop = scrollTop;
    }
  }, {
    key: 'save',
    value: function save() {
      var value = this.textbox.value;
      switch (this.root.getAttribute('data-mode')) {
        case 'link':
          {
            var scrollTop = this.quill.root.scrollTop;
            if (this.linkRange) {
              this.quill.formatText(this.linkRange, 'link', value, _emitter2.default.sources.USER);
              delete this.linkRange;
            } else {
              this.restoreFocus();
              this.quill.format('link', value, _emitter2.default.sources.USER);
            }
            this.quill.root.scrollTop = scrollTop;
            break;
          }
        case 'video':
          {
            value = extractVideoUrl(value);
          } // eslint-disable-next-line no-fallthrough
        case 'formula':
          {
            if (!value) break;
            var range = this.quill.getSelection(true);
            if (range != null) {
              var index = range.index + range.length;
              this.quill.insertEmbed(index, this.root.getAttribute('data-mode'), value, _emitter2.default.sources.USER);
              if (this.root.getAttribute('data-mode') === 'formula') {
                this.quill.insertText(index + 1, ' ', _emitter2.default.sources.USER);
              }
              this.quill.setSelection(index + 2, _emitter2.default.sources.USER);
            }
            break;
          }
        default:
      }
      this.textbox.value = '';
      this.hide();
    }
  }]);

  return BaseTooltip;
}(_tooltip2.default);

function extractVideoUrl(url) {
  var match = url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtube\.com\/watch.*v=([a-zA-Z0-9_-]+)/) || url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtu\.be\/([a-zA-Z0-9_-]+)/);
  if (match) {
    return (match[1] || 'https') + '://www.youtube.com/embed/' + match[2] + '?showinfo=0';
  }
  if (match = url.match(/^(?:(https?):\/\/)?(?:www\.)?vimeo\.com\/(\d+)/)) {
    // eslint-disable-line no-cond-assign
    return (match[1] || 'https') + '://player.vimeo.com/video/' + match[2] + '/';
  }
  return url;
}

function fillSelect(select, values) {
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  values.forEach(function (value) {
    var option = document.createElement('option');
    if (value === defaultValue) {
      option.setAttribute('selected', 'selected');
    } else {
      option.setAttribute('value', value);
    }
    select.appendChild(option);
  });
}

exports.BaseTooltip = BaseTooltip;
exports.default = BaseTheme;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var LinkedList = /** @class */ (function () {
    function LinkedList() {
        this.head = this.tail = null;
        this.length = 0;
    }
    LinkedList.prototype.append = function () {
        var nodes = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            nodes[_i] = arguments[_i];
        }
        this.insertBefore(nodes[0], null);
        if (nodes.length > 1) {
            this.append.apply(this, nodes.slice(1));
        }
    };
    LinkedList.prototype.contains = function (node) {
        var cur, next = this.iterator();
        while ((cur = next())) {
            if (cur === node)
                return true;
        }
        return false;
    };
    LinkedList.prototype.insertBefore = function (node, refNode) {
        if (!node)
            return;
        node.next = refNode;
        if (refNode != null) {
            node.prev = refNode.prev;
            if (refNode.prev != null) {
                refNode.prev.next = node;
            }
            refNode.prev = node;
            if (refNode === this.head) {
                this.head = node;
            }
        }
        else if (this.tail != null) {
            this.tail.next = node;
            node.prev = this.tail;
            this.tail = node;
        }
        else {
            node.prev = null;
            this.head = this.tail = node;
        }
        this.length += 1;
    };
    LinkedList.prototype.offset = function (target) {
        var index = 0, cur = this.head;
        while (cur != null) {
            if (cur === target)
                return index;
            index += cur.length();
            cur = cur.next;
        }
        return -1;
    };
    LinkedList.prototype.remove = function (node) {
        if (!this.contains(node))
            return;
        if (node.prev != null)
            node.prev.next = node.next;
        if (node.next != null)
            node.next.prev = node.prev;
        if (node === this.head)
            this.head = node.next;
        if (node === this.tail)
            this.tail = node.prev;
        this.length -= 1;
    };
    LinkedList.prototype.iterator = function (curNode) {
        if (curNode === void 0) { curNode = this.head; }
        // TODO use yield when we can
        return function () {
            var ret = curNode;
            if (curNode != null)
                curNode = curNode.next;
            return ret;
        };
    };
    LinkedList.prototype.find = function (index, inclusive) {
        if (inclusive === void 0) { inclusive = false; }
        var cur, next = this.iterator();
        while ((cur = next())) {
            var length = cur.length();
            if (index < length ||
                (inclusive && index === length && (cur.next == null || cur.next.length() !== 0))) {
                return [cur, index];
            }
            index -= length;
        }
        return [null, 0];
    };
    LinkedList.prototype.forEach = function (callback) {
        var cur, next = this.iterator();
        while ((cur = next())) {
            callback(cur);
        }
    };
    LinkedList.prototype.forEachAt = function (index, length, callback) {
        if (length <= 0)
            return;
        var _a = this.find(index), startNode = _a[0], offset = _a[1];
        var cur, curIndex = index - offset, next = this.iterator(startNode);
        while ((cur = next()) && curIndex < index + length) {
            var curLength = cur.length();
            if (index > curIndex) {
                callback(cur, index - curIndex, Math.min(length, curIndex + curLength - index));
            }
            else {
                callback(cur, 0, Math.min(curLength, index + length - curIndex));
            }
            curIndex += curLength;
        }
    };
    LinkedList.prototype.map = function (callback) {
        return this.reduce(function (memo, cur) {
            memo.push(callback(cur));
            return memo;
        }, []);
    };
    LinkedList.prototype.reduce = function (callback, memo) {
        var cur, next = this.iterator();
        while ((cur = next())) {
            memo = callback(memo, cur);
        }
        return memo;
    };
    return LinkedList;
}());
exports.default = LinkedList;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var container_1 = __webpack_require__(17);
var Registry = __webpack_require__(1);
var OBSERVER_CONFIG = {
    attributes: true,
    characterData: true,
    characterDataOldValue: true,
    childList: true,
    subtree: true,
};
var MAX_OPTIMIZE_ITERATIONS = 100;
var ScrollBlot = /** @class */ (function (_super) {
    __extends(ScrollBlot, _super);
    function ScrollBlot(node) {
        var _this = _super.call(this, node) || this;
        _this.scroll = _this;
        _this.observer = new MutationObserver(function (mutations) {
            _this.update(mutations);
        });
        _this.observer.observe(_this.domNode, OBSERVER_CONFIG);
        _this.attach();
        return _this;
    }
    ScrollBlot.prototype.detach = function () {
        _super.prototype.detach.call(this);
        this.observer.disconnect();
    };
    ScrollBlot.prototype.deleteAt = function (index, length) {
        this.update();
        if (index === 0 && length === this.length()) {
            this.children.forEach(function (child) {
                child.remove();
            });
        }
        else {
            _super.prototype.deleteAt.call(this, index, length);
        }
    };
    ScrollBlot.prototype.formatAt = function (index, length, name, value) {
        this.update();
        _super.prototype.formatAt.call(this, index, length, name, value);
    };
    ScrollBlot.prototype.insertAt = function (index, value, def) {
        this.update();
        _super.prototype.insertAt.call(this, index, value, def);
    };
    ScrollBlot.prototype.optimize = function (mutations, context) {
        var _this = this;
        if (mutations === void 0) { mutations = []; }
        if (context === void 0) { context = {}; }
        _super.prototype.optimize.call(this, context);
        // We must modify mutations directly, cannot make copy and then modify
        var records = [].slice.call(this.observer.takeRecords());
        // Array.push currently seems to be implemented by a non-tail recursive function
        // so we cannot just mutations.push.apply(mutations, this.observer.takeRecords());
        while (records.length > 0)
            mutations.push(records.pop());
        // TODO use WeakMap
        var mark = function (blot, markParent) {
            if (markParent === void 0) { markParent = true; }
            if (blot == null || blot === _this)
                return;
            if (blot.domNode.parentNode == null)
                return;
            // @ts-ignore
            if (blot.domNode[Registry.DATA_KEY].mutations == null) {
                // @ts-ignore
                blot.domNode[Registry.DATA_KEY].mutations = [];
            }
            if (markParent)
                mark(blot.parent);
        };
        var optimize = function (blot) {
            // Post-order traversal
            if (
            // @ts-ignore
            blot.domNode[Registry.DATA_KEY] == null ||
                // @ts-ignore
                blot.domNode[Registry.DATA_KEY].mutations == null) {
                return;
            }
            if (blot instanceof container_1.default) {
                blot.children.forEach(optimize);
            }
            blot.optimize(context);
        };
        var remaining = mutations;
        for (var i = 0; remaining.length > 0; i += 1) {
            if (i >= MAX_OPTIMIZE_ITERATIONS) {
                throw new Error('[Parchment] Maximum optimize iterations reached');
            }
            remaining.forEach(function (mutation) {
                var blot = Registry.find(mutation.target, true);
                if (blot == null)
                    return;
                if (blot.domNode === mutation.target) {
                    if (mutation.type === 'childList') {
                        mark(Registry.find(mutation.previousSibling, false));
                        [].forEach.call(mutation.addedNodes, function (node) {
                            var child = Registry.find(node, false);
                            mark(child, false);
                            if (child instanceof container_1.default) {
                                child.children.forEach(function (grandChild) {
                                    mark(grandChild, false);
                                });
                            }
                        });
                    }
                    else if (mutation.type === 'attributes') {
                        mark(blot.prev);
                    }
                }
                mark(blot);
            });
            this.children.forEach(optimize);
            remaining = [].slice.call(this.observer.takeRecords());
            records = remaining.slice();
            while (records.length > 0)
                mutations.push(records.pop());
        }
    };
    ScrollBlot.prototype.update = function (mutations, context) {
        var _this = this;
        if (context === void 0) { context = {}; }
        mutations = mutations || this.observer.takeRecords();
        // TODO use WeakMap
        mutations
            .map(function (mutation) {
            var blot = Registry.find(mutation.target, true);
            if (blot == null)
                return null;
            // @ts-ignore
            if (blot.domNode[Registry.DATA_KEY].mutations == null) {
                // @ts-ignore
                blot.domNode[Registry.DATA_KEY].mutations = [mutation];
                return blot;
            }
            else {
                // @ts-ignore
                blot.domNode[Registry.DATA_KEY].mutations.push(mutation);
                return null;
            }
        })
            .forEach(function (blot) {
            if (blot == null ||
                blot === _this ||
                //@ts-ignore
                blot.domNode[Registry.DATA_KEY] == null)
                return;
            // @ts-ignore
            blot.update(blot.domNode[Registry.DATA_KEY].mutations || [], context);
        });
        // @ts-ignore
        if (this.domNode[Registry.DATA_KEY].mutations != null) {
            // @ts-ignore
            _super.prototype.update.call(this, this.domNode[Registry.DATA_KEY].mutations, context);
        }
        this.optimize(mutations, context);
    };
    ScrollBlot.blotName = 'scroll';
    ScrollBlot.defaultChild = 'block';
    ScrollBlot.scope = Registry.Scope.BLOCK_BLOT;
    ScrollBlot.tagName = 'DIV';
    return ScrollBlot;
}(container_1.default));
exports.default = ScrollBlot;


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var format_1 = __webpack_require__(18);
var Registry = __webpack_require__(1);
// Shallow object comparison
function isEqual(obj1, obj2) {
    if (Object.keys(obj1).length !== Object.keys(obj2).length)
        return false;
    // @ts-ignore
    for (var prop in obj1) {
        // @ts-ignore
        if (obj1[prop] !== obj2[prop])
            return false;
    }
    return true;
}
var InlineBlot = /** @class */ (function (_super) {
    __extends(InlineBlot, _super);
    function InlineBlot() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InlineBlot.formats = function (domNode) {
        if (domNode.tagName === InlineBlot.tagName)
            return undefined;
        return _super.formats.call(this, domNode);
    };
    InlineBlot.prototype.format = function (name, value) {
        var _this = this;
        if (name === this.statics.blotName && !value) {
            this.children.forEach(function (child) {
                if (!(child instanceof format_1.default)) {
                    child = child.wrap(InlineBlot.blotName, true);
                }
                _this.attributes.copy(child);
            });
            this.unwrap();
        }
        else {
            _super.prototype.format.call(this, name, value);
        }
    };
    InlineBlot.prototype.formatAt = function (index, length, name, value) {
        if (this.formats()[name] != null || Registry.query(name, Registry.Scope.ATTRIBUTE)) {
            var blot = this.isolate(index, length);
            blot.format(name, value);
        }
        else {
            _super.prototype.formatAt.call(this, index, length, name, value);
        }
    };
    InlineBlot.prototype.optimize = function (context) {
        _super.prototype.optimize.call(this, context);
        var formats = this.formats();
        if (Object.keys(formats).length === 0) {
            return this.unwrap(); // unformatted span
        }
        var next = this.next;
        if (next instanceof InlineBlot && next.prev === this && isEqual(formats, next.formats())) {
            next.moveChildren(this);
            next.remove();
        }
    };
    InlineBlot.blotName = 'inline';
    InlineBlot.scope = Registry.Scope.INLINE_BLOT;
    InlineBlot.tagName = 'SPAN';
    return InlineBlot;
}(format_1.default));
exports.default = InlineBlot;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var format_1 = __webpack_require__(18);
var Registry = __webpack_require__(1);
var BlockBlot = /** @class */ (function (_super) {
    __extends(BlockBlot, _super);
    function BlockBlot() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BlockBlot.formats = function (domNode) {
        var tagName = Registry.query(BlockBlot.blotName).tagName;
        if (domNode.tagName === tagName)
            return undefined;
        return _super.formats.call(this, domNode);
    };
    BlockBlot.prototype.format = function (name, value) {
        if (Registry.query(name, Registry.Scope.BLOCK) == null) {
            return;
        }
        else if (name === this.statics.blotName && !value) {
            this.replaceWith(BlockBlot.blotName);
        }
        else {
            _super.prototype.format.call(this, name, value);
        }
    };
    BlockBlot.prototype.formatAt = function (index, length, name, value) {
        if (Registry.query(name, Registry.Scope.BLOCK) != null) {
            this.format(name, value);
        }
        else {
            _super.prototype.formatAt.call(this, index, length, name, value);
        }
    };
    BlockBlot.prototype.insertAt = function (index, value, def) {
        if (def == null || Registry.query(value, Registry.Scope.INLINE) != null) {
            // Insert text or inline
            _super.prototype.insertAt.call(this, index, value, def);
        }
        else {
            var after = this.split(index);
            var blot = Registry.create(value, def);
            after.parent.insertBefore(blot, after);
        }
    };
    BlockBlot.prototype.update = function (mutations, context) {
        if (navigator.userAgent.match(/Trident/)) {
            this.build();
        }
        else {
            _super.prototype.update.call(this, mutations, context);
        }
    };
    BlockBlot.blotName = 'block';
    BlockBlot.scope = Registry.Scope.BLOCK_BLOT;
    BlockBlot.tagName = 'P';
    return BlockBlot;
}(format_1.default));
exports.default = BlockBlot;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var leaf_1 = __webpack_require__(19);
var EmbedBlot = /** @class */ (function (_super) {
    __extends(EmbedBlot, _super);
    function EmbedBlot() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EmbedBlot.formats = function (domNode) {
        return undefined;
    };
    EmbedBlot.prototype.format = function (name, value) {
        // super.formatAt wraps, which is what we want in general,
        // but this allows subclasses to overwrite for formats
        // that just apply to particular embeds
        _super.prototype.formatAt.call(this, 0, this.length(), name, value);
    };
    EmbedBlot.prototype.formatAt = function (index, length, name, value) {
        if (index === 0 && length === this.length()) {
            this.format(name, value);
        }
        else {
            _super.prototype.formatAt.call(this, index, length, name, value);
        }
    };
    EmbedBlot.prototype.formats = function () {
        return this.statics.formats(this.domNode);
    };
    return EmbedBlot;
}(leaf_1.default));
exports.default = EmbedBlot;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var leaf_1 = __webpack_require__(19);
var Registry = __webpack_require__(1);
var TextBlot = /** @class */ (function (_super) {
    __extends(TextBlot, _super);
    function TextBlot(node) {
        var _this = _super.call(this, node) || this;
        _this.text = _this.statics.value(_this.domNode);
        return _this;
    }
    TextBlot.create = function (value) {
        return document.createTextNode(value);
    };
    TextBlot.value = function (domNode) {
        var text = domNode.data;
        // @ts-ignore
        if (text['normalize'])
            text = text['normalize']();
        return text;
    };
    TextBlot.prototype.deleteAt = function (index, length) {
        this.domNode.data = this.text = this.text.slice(0, index) + this.text.slice(index + length);
    };
    TextBlot.prototype.index = function (node, offset) {
        if (this.domNode === node) {
            return offset;
        }
        return -1;
    };
    TextBlot.prototype.insertAt = function (index, value, def) {
        if (def == null) {
            this.text = this.text.slice(0, index) + value + this.text.slice(index);
            this.domNode.data = this.text;
        }
        else {
            _super.prototype.insertAt.call(this, index, value, def);
        }
    };
    TextBlot.prototype.length = function () {
        return this.text.length;
    };
    TextBlot.prototype.optimize = function (context) {
        _super.prototype.optimize.call(this, context);
        this.text = this.statics.value(this.domNode);
        if (this.text.length === 0) {
            this.remove();
        }
        else if (this.next instanceof TextBlot && this.next.prev === this) {
            this.insertAt(this.length(), this.next.value());
            this.next.remove();
        }
    };
    TextBlot.prototype.position = function (index, inclusive) {
        if (inclusive === void 0) { inclusive = false; }
        return [this.domNode, index];
    };
    TextBlot.prototype.split = function (index, force) {
        if (force === void 0) { force = false; }
        if (!force) {
            if (index === 0)
                return this;
            if (index === this.length())
                return this.next;
        }
        var after = Registry.create(this.domNode.splitText(index));
        this.parent.insertBefore(after, this.next);
        this.text = this.statics.value(this.domNode);
        return after;
    };
    TextBlot.prototype.update = function (mutations, context) {
        var _this = this;
        if (mutations.some(function (mutation) {
            return mutation.type === 'characterData' && mutation.target === _this.domNode;
        })) {
            this.text = this.statics.value(this.domNode);
        }
    };
    TextBlot.prototype.value = function () {
        return this.text;
    };
    TextBlot.blotName = 'text';
    TextBlot.scope = Registry.Scope.INLINE_BLOT;
    return TextBlot;
}(leaf_1.default));
exports.default = TextBlot;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var elem = document.createElement('div');
elem.classList.toggle('test-class', false);
if (elem.classList.contains('test-class')) {
  var _toggle = DOMTokenList.prototype.toggle;
  DOMTokenList.prototype.toggle = function (token, force) {
    if (arguments.length > 1 && !this.contains(token) === !force) {
      return force;
    } else {
      return _toggle.call(this, token);
    }
  };
}

if (!String.prototype.startsWith) {
  String.prototype.startsWith = function (searchString, position) {
    position = position || 0;
    return this.substr(position, searchString.length) === searchString;
  };
}

if (!String.prototype.endsWith) {
  String.prototype.endsWith = function (searchString, position) {
    var subjectString = this.toString();
    if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) {
      position = subjectString.length;
    }
    position -= searchString.length;
    var lastIndex = subjectString.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
  };
}

if (!Array.prototype.find) {
  Object.defineProperty(Array.prototype, "find", {
    value: function value(predicate) {
      if (this === null) {
        throw new TypeError('Array.prototype.find called on null or undefined');
      }
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      }
      var list = Object(this);
      var length = list.length >>> 0;
      var thisArg = arguments[1];
      var value;

      for (var i = 0; i < length; i++) {
        value = list[i];
        if (predicate.call(thisArg, value, i, list)) {
          return value;
        }
      }
      return undefined;
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  // Disable resizing in Firefox
  document.execCommand("enableObjectResizing", false, false);
  // Disable automatic linkifying in IE11
  document.execCommand("autoUrlDetect", false, false);
});

/***/ }),
/* 51 */
/***/ (function(module, exports) {

/**
 * This library modifies the diff-patch-match library by Neil Fraser
 * by removing the patch and match functionality and certain advanced
 * options in the diff function. The original license is as follows:
 *
 * ===
 *
 * Diff Match and Patch
 *
 * Copyright 2006 Google Inc.
 * http://code.google.com/p/google-diff-match-patch/
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


/**
 * The data structure representing a diff is an array of tuples:
 * [[DIFF_DELETE, 'Hello'], [DIFF_INSERT, 'Goodbye'], [DIFF_EQUAL, ' world.']]
 * which means: delete 'Hello', add 'Goodbye' and keep ' world.'
 */
var DIFF_DELETE = -1;
var DIFF_INSERT = 1;
var DIFF_EQUAL = 0;


/**
 * Find the differences between two texts.  Simplifies the problem by stripping
 * any common prefix or suffix off the texts before diffing.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {Int} cursor_pos Expected edit position in text1 (optional)
 * @return {Array} Array of diff tuples.
 */
function diff_main(text1, text2, cursor_pos) {
  // Check for equality (speedup).
  if (text1 == text2) {
    if (text1) {
      return [[DIFF_EQUAL, text1]];
    }
    return [];
  }

  // Check cursor_pos within bounds
  if (cursor_pos < 0 || text1.length < cursor_pos) {
    cursor_pos = null;
  }

  // Trim off common prefix (speedup).
  var commonlength = diff_commonPrefix(text1, text2);
  var commonprefix = text1.substring(0, commonlength);
  text1 = text1.substring(commonlength);
  text2 = text2.substring(commonlength);

  // Trim off common suffix (speedup).
  commonlength = diff_commonSuffix(text1, text2);
  var commonsuffix = text1.substring(text1.length - commonlength);
  text1 = text1.substring(0, text1.length - commonlength);
  text2 = text2.substring(0, text2.length - commonlength);

  // Compute the diff on the middle block.
  var diffs = diff_compute_(text1, text2);

  // Restore the prefix and suffix.
  if (commonprefix) {
    diffs.unshift([DIFF_EQUAL, commonprefix]);
  }
  if (commonsuffix) {
    diffs.push([DIFF_EQUAL, commonsuffix]);
  }
  diff_cleanupMerge(diffs);
  if (cursor_pos != null) {
    diffs = fix_cursor(diffs, cursor_pos);
  }
  diffs = fix_emoji(diffs);
  return diffs;
};


/**
 * Find the differences between two texts.  Assumes that the texts do not
 * have any common prefix or suffix.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @return {Array} Array of diff tuples.
 */
function diff_compute_(text1, text2) {
  var diffs;

  if (!text1) {
    // Just add some text (speedup).
    return [[DIFF_INSERT, text2]];
  }

  if (!text2) {
    // Just delete some text (speedup).
    return [[DIFF_DELETE, text1]];
  }

  var longtext = text1.length > text2.length ? text1 : text2;
  var shorttext = text1.length > text2.length ? text2 : text1;
  var i = longtext.indexOf(shorttext);
  if (i != -1) {
    // Shorter text is inside the longer text (speedup).
    diffs = [[DIFF_INSERT, longtext.substring(0, i)],
             [DIFF_EQUAL, shorttext],
             [DIFF_INSERT, longtext.substring(i + shorttext.length)]];
    // Swap insertions for deletions if diff is reversed.
    if (text1.length > text2.length) {
      diffs[0][0] = diffs[2][0] = DIFF_DELETE;
    }
    return diffs;
  }

  if (shorttext.length == 1) {
    // Single character string.
    // After the previous speedup, the character can't be an equality.
    return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
  }

  // Check to see if the problem can be split in two.
  var hm = diff_halfMatch_(text1, text2);
  if (hm) {
    // A half-match was found, sort out the return data.
    var text1_a = hm[0];
    var text1_b = hm[1];
    var text2_a = hm[2];
    var text2_b = hm[3];
    var mid_common = hm[4];
    // Send both pairs off for separate processing.
    var diffs_a = diff_main(text1_a, text2_a);
    var diffs_b = diff_main(text1_b, text2_b);
    // Merge the results.
    return diffs_a.concat([[DIFF_EQUAL, mid_common]], diffs_b);
  }

  return diff_bisect_(text1, text2);
};


/**
 * Find the 'middle snake' of a diff, split the problem in two
 * and return the recursively constructed diff.
 * See Myers 1986 paper: An O(ND) Difference Algorithm and Its Variations.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @return {Array} Array of diff tuples.
 * @private
 */
function diff_bisect_(text1, text2) {
  // Cache the text lengths to prevent multiple calls.
  var text1_length = text1.length;
  var text2_length = text2.length;
  var max_d = Math.ceil((text1_length + text2_length) / 2);
  var v_offset = max_d;
  var v_length = 2 * max_d;
  var v1 = new Array(v_length);
  var v2 = new Array(v_length);
  // Setting all elements to -1 is faster in Chrome & Firefox than mixing
  // integers and undefined.
  for (var x = 0; x < v_length; x++) {
    v1[x] = -1;
    v2[x] = -1;
  }
  v1[v_offset + 1] = 0;
  v2[v_offset + 1] = 0;
  var delta = text1_length - text2_length;
  // If the total number of characters is odd, then the front path will collide
  // with the reverse path.
  var front = (delta % 2 != 0);
  // Offsets for start and end of k loop.
  // Prevents mapping of space beyond the grid.
  var k1start = 0;
  var k1end = 0;
  var k2start = 0;
  var k2end = 0;
  for (var d = 0; d < max_d; d++) {
    // Walk the front path one step.
    for (var k1 = -d + k1start; k1 <= d - k1end; k1 += 2) {
      var k1_offset = v_offset + k1;
      var x1;
      if (k1 == -d || (k1 != d && v1[k1_offset - 1] < v1[k1_offset + 1])) {
        x1 = v1[k1_offset + 1];
      } else {
        x1 = v1[k1_offset - 1] + 1;
      }
      var y1 = x1 - k1;
      while (x1 < text1_length && y1 < text2_length &&
             text1.charAt(x1) == text2.charAt(y1)) {
        x1++;
        y1++;
      }
      v1[k1_offset] = x1;
      if (x1 > text1_length) {
        // Ran off the right of the graph.
        k1end += 2;
      } else if (y1 > text2_length) {
        // Ran off the bottom of the graph.
        k1start += 2;
      } else if (front) {
        var k2_offset = v_offset + delta - k1;
        if (k2_offset >= 0 && k2_offset < v_length && v2[k2_offset] != -1) {
          // Mirror x2 onto top-left coordinate system.
          var x2 = text1_length - v2[k2_offset];
          if (x1 >= x2) {
            // Overlap detected.
            return diff_bisectSplit_(text1, text2, x1, y1);
          }
        }
      }
    }

    // Walk the reverse path one step.
    for (var k2 = -d + k2start; k2 <= d - k2end; k2 += 2) {
      var k2_offset = v_offset + k2;
      var x2;
      if (k2 == -d || (k2 != d && v2[k2_offset - 1] < v2[k2_offset + 1])) {
        x2 = v2[k2_offset + 1];
      } else {
        x2 = v2[k2_offset - 1] + 1;
      }
      var y2 = x2 - k2;
      while (x2 < text1_length && y2 < text2_length &&
             text1.charAt(text1_length - x2 - 1) ==
             text2.charAt(text2_length - y2 - 1)) {
        x2++;
        y2++;
      }
      v2[k2_offset] = x2;
      if (x2 > text1_length) {
        // Ran off the left of the graph.
        k2end += 2;
      } else if (y2 > text2_length) {
        // Ran off the top of the graph.
        k2start += 2;
      } else if (!front) {
        var k1_offset = v_offset + delta - k2;
        if (k1_offset >= 0 && k1_offset < v_length && v1[k1_offset] != -1) {
          var x1 = v1[k1_offset];
          var y1 = v_offset + x1 - k1_offset;
          // Mirror x2 onto top-left coordinate system.
          x2 = text1_length - x2;
          if (x1 >= x2) {
            // Overlap detected.
            return diff_bisectSplit_(text1, text2, x1, y1);
          }
        }
      }
    }
  }
  // Diff took too long and hit the deadline or
  // number of diffs equals number of characters, no commonality at all.
  return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
};


/**
 * Given the location of the 'middle snake', split the diff in two parts
 * and recurse.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {number} x Index of split point in text1.
 * @param {number} y Index of split point in text2.
 * @return {Array} Array of diff tuples.
 */
function diff_bisectSplit_(text1, text2, x, y) {
  var text1a = text1.substring(0, x);
  var text2a = text2.substring(0, y);
  var text1b = text1.substring(x);
  var text2b = text2.substring(y);

  // Compute both diffs serially.
  var diffs = diff_main(text1a, text2a);
  var diffsb = diff_main(text1b, text2b);

  return diffs.concat(diffsb);
};


/**
 * Determine the common prefix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the start of each
 *     string.
 */
function diff_commonPrefix(text1, text2) {
  // Quick check for common null cases.
  if (!text1 || !text2 || text1.charAt(0) != text2.charAt(0)) {
    return 0;
  }
  // Binary search.
  // Performance analysis: http://neil.fraser.name/news/2007/10/09/
  var pointermin = 0;
  var pointermax = Math.min(text1.length, text2.length);
  var pointermid = pointermax;
  var pointerstart = 0;
  while (pointermin < pointermid) {
    if (text1.substring(pointerstart, pointermid) ==
        text2.substring(pointerstart, pointermid)) {
      pointermin = pointermid;
      pointerstart = pointermin;
    } else {
      pointermax = pointermid;
    }
    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
  }
  return pointermid;
};


/**
 * Determine the common suffix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the end of each string.
 */
function diff_commonSuffix(text1, text2) {
  // Quick check for common null cases.
  if (!text1 || !text2 ||
      text1.charAt(text1.length - 1) != text2.charAt(text2.length - 1)) {
    return 0;
  }
  // Binary search.
  // Performance analysis: http://neil.fraser.name/news/2007/10/09/
  var pointermin = 0;
  var pointermax = Math.min(text1.length, text2.length);
  var pointermid = pointermax;
  var pointerend = 0;
  while (pointermin < pointermid) {
    if (text1.substring(text1.length - pointermid, text1.length - pointerend) ==
        text2.substring(text2.length - pointermid, text2.length - pointerend)) {
      pointermin = pointermid;
      pointerend = pointermin;
    } else {
      pointermax = pointermid;
    }
    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
  }
  return pointermid;
};


/**
 * Do the two texts share a substring which is at least half the length of the
 * longer text?
 * This speedup can produce non-minimal diffs.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {Array.<string>} Five element Array, containing the prefix of
 *     text1, the suffix of text1, the prefix of text2, the suffix of
 *     text2 and the common middle.  Or null if there was no match.
 */
function diff_halfMatch_(text1, text2) {
  var longtext = text1.length > text2.length ? text1 : text2;
  var shorttext = text1.length > text2.length ? text2 : text1;
  if (longtext.length < 4 || shorttext.length * 2 < longtext.length) {
    return null;  // Pointless.
  }

  /**
   * Does a substring of shorttext exist within longtext such that the substring
   * is at least half the length of longtext?
   * Closure, but does not reference any external variables.
   * @param {string} longtext Longer string.
   * @param {string} shorttext Shorter string.
   * @param {number} i Start index of quarter length substring within longtext.
   * @return {Array.<string>} Five element Array, containing the prefix of
   *     longtext, the suffix of longtext, the prefix of shorttext, the suffix
   *     of shorttext and the common middle.  Or null if there was no match.
   * @private
   */
  function diff_halfMatchI_(longtext, shorttext, i) {
    // Start with a 1/4 length substring at position i as a seed.
    var seed = longtext.substring(i, i + Math.floor(longtext.length / 4));
    var j = -1;
    var best_common = '';
    var best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b;
    while ((j = shorttext.indexOf(seed, j + 1)) != -1) {
      var prefixLength = diff_commonPrefix(longtext.substring(i),
                                           shorttext.substring(j));
      var suffixLength = diff_commonSuffix(longtext.substring(0, i),
                                           shorttext.substring(0, j));
      if (best_common.length < suffixLength + prefixLength) {
        best_common = shorttext.substring(j - suffixLength, j) +
            shorttext.substring(j, j + prefixLength);
        best_longtext_a = longtext.substring(0, i - suffixLength);
        best_longtext_b = longtext.substring(i + prefixLength);
        best_shorttext_a = shorttext.substring(0, j - suffixLength);
        best_shorttext_b = shorttext.substring(j + prefixLength);
      }
    }
    if (best_common.length * 2 >= longtext.length) {
      return [best_longtext_a, best_longtext_b,
              best_shorttext_a, best_shorttext_b, best_common];
    } else {
      return null;
    }
  }

  // First check if the second quarter is the seed for a half-match.
  var hm1 = diff_halfMatchI_(longtext, shorttext,
                             Math.ceil(longtext.length / 4));
  // Check again based on the third quarter.
  var hm2 = diff_halfMatchI_(longtext, shorttext,
                             Math.ceil(longtext.length / 2));
  var hm;
  if (!hm1 && !hm2) {
    return null;
  } else if (!hm2) {
    hm = hm1;
  } else if (!hm1) {
    hm = hm2;
  } else {
    // Both matched.  Select the longest.
    hm = hm1[4].length > hm2[4].length ? hm1 : hm2;
  }

  // A half-match was found, sort out the return data.
  var text1_a, text1_b, text2_a, text2_b;
  if (text1.length > text2.length) {
    text1_a = hm[0];
    text1_b = hm[1];
    text2_a = hm[2];
    text2_b = hm[3];
  } else {
    text2_a = hm[0];
    text2_b = hm[1];
    text1_a = hm[2];
    text1_b = hm[3];
  }
  var mid_common = hm[4];
  return [text1_a, text1_b, text2_a, text2_b, mid_common];
};


/**
 * Reorder and merge like edit sections.  Merge equalities.
 * Any edit section can move as long as it doesn't cross an equality.
 * @param {Array} diffs Array of diff tuples.
 */
function diff_cleanupMerge(diffs) {
  diffs.push([DIFF_EQUAL, '']);  // Add a dummy entry at the end.
  var pointer = 0;
  var count_delete = 0;
  var count_insert = 0;
  var text_delete = '';
  var text_insert = '';
  var commonlength;
  while (pointer < diffs.length) {
    switch (diffs[pointer][0]) {
      case DIFF_INSERT:
        count_insert++;
        text_insert += diffs[pointer][1];
        pointer++;
        break;
      case DIFF_DELETE:
        count_delete++;
        text_delete += diffs[pointer][1];
        pointer++;
        break;
      case DIFF_EQUAL:
        // Upon reaching an equality, check for prior redundancies.
        if (count_delete + count_insert > 1) {
          if (count_delete !== 0 && count_insert !== 0) {
            // Factor out any common prefixies.
            commonlength = diff_commonPrefix(text_insert, text_delete);
            if (commonlength !== 0) {
              if ((pointer - count_delete - count_insert) > 0 &&
                  diffs[pointer - count_delete - count_insert - 1][0] ==
                  DIFF_EQUAL) {
                diffs[pointer - count_delete - count_insert - 1][1] +=
                    text_insert.substring(0, commonlength);
              } else {
                diffs.splice(0, 0, [DIFF_EQUAL,
                                    text_insert.substring(0, commonlength)]);
                pointer++;
              }
              text_insert = text_insert.substring(commonlength);
              text_delete = text_delete.substring(commonlength);
            }
            // Factor out any common suffixies.
            commonlength = diff_commonSuffix(text_insert, text_delete);
            if (commonlength !== 0) {
              diffs[pointer][1] = text_insert.substring(text_insert.length -
                  commonlength) + diffs[pointer][1];
              text_insert = text_insert.substring(0, text_insert.length -
                  commonlength);
              text_delete = text_delete.substring(0, text_delete.length -
                  commonlength);
            }
          }
          // Delete the offending records and add the merged ones.
          if (count_delete === 0) {
            diffs.splice(pointer - count_insert,
                count_delete + count_insert, [DIFF_INSERT, text_insert]);
          } else if (count_insert === 0) {
            diffs.splice(pointer - count_delete,
                count_delete + count_insert, [DIFF_DELETE, text_delete]);
          } else {
            diffs.splice(pointer - count_delete - count_insert,
                count_delete + count_insert, [DIFF_DELETE, text_delete],
                [DIFF_INSERT, text_insert]);
          }
          pointer = pointer - count_delete - count_insert +
                    (count_delete ? 1 : 0) + (count_insert ? 1 : 0) + 1;
        } else if (pointer !== 0 && diffs[pointer - 1][0] == DIFF_EQUAL) {
          // Merge this equality with the previous one.
          diffs[pointer - 1][1] += diffs[pointer][1];
          diffs.splice(pointer, 1);
        } else {
          pointer++;
        }
        count_insert = 0;
        count_delete = 0;
        text_delete = '';
        text_insert = '';
        break;
    }
  }
  if (diffs[diffs.length - 1][1] === '') {
    diffs.pop();  // Remove the dummy entry at the end.
  }

  // Second pass: look for single edits surrounded on both sides by equalities
  // which can be shifted sideways to eliminate an equality.
  // e.g: A<ins>BA</ins>C -> <ins>AB</ins>AC
  var changes = false;
  pointer = 1;
  // Intentionally ignore the first and last element (don't need checking).
  while (pointer < diffs.length - 1) {
    if (diffs[pointer - 1][0] == DIFF_EQUAL &&
        diffs[pointer + 1][0] == DIFF_EQUAL) {
      // This is a single edit surrounded by equalities.
      if (diffs[pointer][1].substring(diffs[pointer][1].length -
          diffs[pointer - 1][1].length) == diffs[pointer - 1][1]) {
        // Shift the edit over the previous equality.
        diffs[pointer][1] = diffs[pointer - 1][1] +
            diffs[pointer][1].substring(0, diffs[pointer][1].length -
                                        diffs[pointer - 1][1].length);
        diffs[pointer + 1][1] = diffs[pointer - 1][1] + diffs[pointer + 1][1];
        diffs.splice(pointer - 1, 1);
        changes = true;
      } else if (diffs[pointer][1].substring(0, diffs[pointer + 1][1].length) ==
          diffs[pointer + 1][1]) {
        // Shift the edit over the next equality.
        diffs[pointer - 1][1] += diffs[pointer + 1][1];
        diffs[pointer][1] =
            diffs[pointer][1].substring(diffs[pointer + 1][1].length) +
            diffs[pointer + 1][1];
        diffs.splice(pointer + 1, 1);
        changes = true;
      }
    }
    pointer++;
  }
  // If shifts were made, the diff needs reordering and another shift sweep.
  if (changes) {
    diff_cleanupMerge(diffs);
  }
};


var diff = diff_main;
diff.INSERT = DIFF_INSERT;
diff.DELETE = DIFF_DELETE;
diff.EQUAL = DIFF_EQUAL;

module.exports = diff;

/*
 * Modify a diff such that the cursor position points to the start of a change:
 * E.g.
 *   cursor_normalize_diff([[DIFF_EQUAL, 'abc']], 1)
 *     => [1, [[DIFF_EQUAL, 'a'], [DIFF_EQUAL, 'bc']]]
 *   cursor_normalize_diff([[DIFF_INSERT, 'new'], [DIFF_DELETE, 'xyz']], 2)
 *     => [2, [[DIFF_INSERT, 'new'], [DIFF_DELETE, 'xy'], [DIFF_DELETE, 'z']]]
 *
 * @param {Array} diffs Array of diff tuples
 * @param {Int} cursor_pos Suggested edit position. Must not be out of bounds!
 * @return {Array} A tuple [cursor location in the modified diff, modified diff]
 */
function cursor_normalize_diff (diffs, cursor_pos) {
  if (cursor_pos === 0) {
    return [DIFF_EQUAL, diffs];
  }
  for (var current_pos = 0, i = 0; i < diffs.length; i++) {
    var d = diffs[i];
    if (d[0] === DIFF_DELETE || d[0] === DIFF_EQUAL) {
      var next_pos = current_pos + d[1].length;
      if (cursor_pos === next_pos) {
        return [i + 1, diffs];
      } else if (cursor_pos < next_pos) {
        // copy to prevent side effects
        diffs = diffs.slice();
        // split d into two diff changes
        var split_pos = cursor_pos - current_pos;
        var d_left = [d[0], d[1].slice(0, split_pos)];
        var d_right = [d[0], d[1].slice(split_pos)];
        diffs.splice(i, 1, d_left, d_right);
        return [i + 1, diffs];
      } else {
        current_pos = next_pos;
      }
    }
  }
  throw new Error('cursor_pos is out of bounds!')
}

/*
 * Modify a diff such that the edit position is "shifted" to the proposed edit location (cursor_position).
 *
 * Case 1)
 *   Check if a naive shift is possible:
 *     [0, X], [ 1, Y] -> [ 1, Y], [0, X]    (if X + Y === Y + X)
 *     [0, X], [-1, Y] -> [-1, Y], [0, X]    (if X + Y === Y + X) - holds same result
 * Case 2)
 *   Check if the following shifts are possible:
 *     [0, 'pre'], [ 1, 'prefix'] -> [ 1, 'pre'], [0, 'pre'], [ 1, 'fix']
 *     [0, 'pre'], [-1, 'prefix'] -> [-1, 'pre'], [0, 'pre'], [-1, 'fix']
 *         ^            ^
 *         d          d_next
 *
 * @param {Array} diffs Array of diff tuples
 * @param {Int} cursor_pos Suggested edit position. Must not be out of bounds!
 * @return {Array} Array of diff tuples
 */
function fix_cursor (diffs, cursor_pos) {
  var norm = cursor_normalize_diff(diffs, cursor_pos);
  var ndiffs = norm[1];
  var cursor_pointer = norm[0];
  var d = ndiffs[cursor_pointer];
  var d_next = ndiffs[cursor_pointer + 1];

  if (d == null) {
    // Text was deleted from end of original string,
    // cursor is now out of bounds in new string
    return diffs;
  } else if (d[0] !== DIFF_EQUAL) {
    // A modification happened at the cursor location.
    // This is the expected outcome, so we can return the original diff.
    return diffs;
  } else {
    if (d_next != null && d[1] + d_next[1] === d_next[1] + d[1]) {
      // Case 1)
      // It is possible to perform a naive shift
      ndiffs.splice(cursor_pointer, 2, d_next, d)
      return merge_tuples(ndiffs, cursor_pointer, 2)
    } else if (d_next != null && d_next[1].indexOf(d[1]) === 0) {
      // Case 2)
      // d[1] is a prefix of d_next[1]
      // We can assume that d_next[0] !== 0, since d[0] === 0
      // Shift edit locations..
      ndiffs.splice(cursor_pointer, 2, [d_next[0], d[1]], [0, d[1]]);
      var suffix = d_next[1].slice(d[1].length);
      if (suffix.length > 0) {
        ndiffs.splice(cursor_pointer + 2, 0, [d_next[0], suffix]);
      }
      return merge_tuples(ndiffs, cursor_pointer, 3)
    } else {
      // Not possible to perform any modification
      return diffs;
    }
  }
}

/*
 * Check diff did not split surrogate pairs.
 * Ex. [0, '\uD83D'], [-1, '\uDC36'], [1, '\uDC2F'] -> [-1, '\uD83D\uDC36'], [1, '\uD83D\uDC2F']
 *     '\uD83D\uDC36' === '🐶', '\uD83D\uDC2F' === '🐯'
 *
 * @param {Array} diffs Array of diff tuples
 * @return {Array} Array of diff tuples
 */
function fix_emoji (diffs) {
  var compact = false;
  var starts_with_pair_end = function(str) {
    return str.charCodeAt(0) >= 0xDC00 && str.charCodeAt(0) <= 0xDFFF;
  }
  var ends_with_pair_start = function(str) {
    return str.charCodeAt(str.length-1) >= 0xD800 && str.charCodeAt(str.length-1) <= 0xDBFF;
  }
  for (var i = 2; i < diffs.length; i += 1) {
    if (diffs[i-2][0] === DIFF_EQUAL && ends_with_pair_start(diffs[i-2][1]) &&
        diffs[i-1][0] === DIFF_DELETE && starts_with_pair_end(diffs[i-1][1]) &&
        diffs[i][0] === DIFF_INSERT && starts_with_pair_end(diffs[i][1])) {
      compact = true;

      diffs[i-1][1] = diffs[i-2][1].slice(-1) + diffs[i-1][1];
      diffs[i][1] = diffs[i-2][1].slice(-1) + diffs[i][1];

      diffs[i-2][1] = diffs[i-2][1].slice(0, -1);
    }
  }
  if (!compact) {
    return diffs;
  }
  var fixed_diffs = [];
  for (var i = 0; i < diffs.length; i += 1) {
    if (diffs[i][1].length > 0) {
      fixed_diffs.push(diffs[i]);
    }
  }
  return fixed_diffs;
}

/*
 * Try to merge tuples with their neigbors in a given range.
 * E.g. [0, 'a'], [0, 'b'] -> [0, 'ab']
 *
 * @param {Array} diffs Array of diff tuples.
 * @param {Int} start Position of the first element to merge (diffs[start] is also merged with diffs[start - 1]).
 * @param {Int} length Number of consecutive elements to check.
 * @return {Array} Array of merged diff tuples.
 */
function merge_tuples (diffs, start, length) {
  // Check from (start-1) to (start+length).
  for (var i = start + length - 1; i >= 0 && i >= start - 1; i--) {
    if (i + 1 < diffs.length) {
      var left_d = diffs[i];
      var right_d = diffs[i+1];
      if (left_d[0] === right_d[1]) {
        diffs.splice(i, 2, [left_d[0], left_d[1] + right_d[1]]);
      }
    }
  }
  return diffs;
}


/***/ }),
/* 52 */
/***/ (function(module, exports) {

exports = module.exports = typeof Object.keys === 'function'
  ? Object.keys : shim;

exports.shim = shim;
function shim (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
}


/***/ }),
/* 53 */
/***/ (function(module, exports) {

var supportsArgumentsClass = (function(){
  return Object.prototype.toString.call(arguments)
})() == '[object Arguments]';

exports = module.exports = supportsArgumentsClass ? supported : unsupported;

exports.supported = supported;
function supported(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
};

exports.unsupported = unsupported;
function unsupported(object){
  return object &&
    typeof object == 'object' &&
    typeof object.length == 'number' &&
    Object.prototype.hasOwnProperty.call(object, 'callee') &&
    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
    false;
};


/***/ }),
/* 54 */
/***/ (function(module, exports) {

'use strict';

var has = Object.prototype.hasOwnProperty
  , prefix = '~';

/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @api private
 */
function Events() {}

//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
  Events.prototype = Object.create(null);

  //
  // This hack is needed because the `__proto__` property is still inherited in
  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
  //
  if (!new Events().__proto__) prefix = false;
}

/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {Mixed} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @api private
 */
function EE(fn, context, once) {
  this.fn = fn;
  this.context = context;
  this.once = once || false;
}

/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @api public
 */
function EventEmitter() {
  this._events = new Events();
  this._eventsCount = 0;
}

/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @api public
 */
EventEmitter.prototype.eventNames = function eventNames() {
  var names = []
    , events
    , name;

  if (this._eventsCount === 0) return names;

  for (name in (events = this._events)) {
    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
  }

  if (Object.getOwnPropertySymbols) {
    return names.concat(Object.getOwnPropertySymbols(events));
  }

  return names;
};

/**
 * Return the listeners registered for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Boolean} exists Only check if there are listeners.
 * @returns {Array|Boolean}
 * @api public
 */
EventEmitter.prototype.listeners = function listeners(event, exists) {
  var evt = prefix ? prefix + event : event
    , available = this._events[evt];

  if (exists) return !!available;
  if (!available) return [];
  if (available.fn) return [available.fn];

  for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
    ee[i] = available[i].fn;
  }

  return ee;
};

/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @api public
 */
EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return false;

  var listeners = this._events[evt]
    , len = arguments.length
    , args
    , i;

  if (listeners.fn) {
    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

    switch (len) {
      case 1: return listeners.fn.call(listeners.context), true;
      case 2: return listeners.fn.call(listeners.context, a1), true;
      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
    }

    for (i = 1, args = new Array(len -1); i < len; i++) {
      args[i - 1] = arguments[i];
    }

    listeners.fn.apply(listeners.context, args);
  } else {
    var length = listeners.length
      , j;

    for (i = 0; i < length; i++) {
      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

      switch (len) {
        case 1: listeners[i].fn.call(listeners[i].context); break;
        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
        default:
          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
            args[j - 1] = arguments[j];
          }

          listeners[i].fn.apply(listeners[i].context, args);
      }
    }
  }

  return true;
};

/**
 * Add a listener for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn The listener function.
 * @param {Mixed} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.on = function on(event, fn, context) {
  var listener = new EE(fn, context || this)
    , evt = prefix ? prefix + event : event;

  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
  else if (!this._events[evt].fn) this._events[evt].push(listener);
  else this._events[evt] = [this._events[evt], listener];

  return this;
};

/**
 * Add a one-time listener for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn The listener function.
 * @param {Mixed} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.once = function once(event, fn, context) {
  var listener = new EE(fn, context || this, true)
    , evt = prefix ? prefix + event : event;

  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
  else if (!this._events[evt].fn) this._events[evt].push(listener);
  else this._events[evt] = [this._events[evt], listener];

  return this;
};

/**
 * Remove the listeners of a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {Mixed} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return this;
  if (!fn) {
    if (--this._eventsCount === 0) this._events = new Events();
    else delete this._events[evt];
    return this;
  }

  var listeners = this._events[evt];

  if (listeners.fn) {
    if (
         listeners.fn === fn
      && (!once || listeners.once)
      && (!context || listeners.context === context)
    ) {
      if (--this._eventsCount === 0) this._events = new Events();
      else delete this._events[evt];
    }
  } else {
    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
      if (
           listeners[i].fn !== fn
        || (once && !listeners[i].once)
        || (context && listeners[i].context !== context)
      ) {
        events.push(listeners[i]);
      }
    }

    //
    // Reset the array, or remove it completely if we have no more listeners.
    //
    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
    else if (--this._eventsCount === 0) this._events = new Events();
    else delete this._events[evt];
  }

  return this;
};

/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {String|Symbol} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
  var evt;

  if (event) {
    evt = prefix ? prefix + event : event;
    if (this._events[evt]) {
      if (--this._eventsCount === 0) this._events = new Events();
      else delete this._events[evt];
    }
  } else {
    this._events = new Events();
    this._eventsCount = 0;
  }

  return this;
};

//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;

//
// This function doesn't apply anymore.
//
EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
  return this;
};

//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;

//
// Allow `EventEmitter` to be imported as module namespace.
//
EventEmitter.EventEmitter = EventEmitter;

//
// Expose the module.
//
if ('undefined' !== typeof module) {
  module.exports = EventEmitter;
}


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.matchText = exports.matchSpacing = exports.matchNewline = exports.matchBlot = exports.matchAttributor = exports.default = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extend2 = __webpack_require__(3);

var _extend3 = _interopRequireDefault(_extend2);

var _quillDelta = __webpack_require__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _quill = __webpack_require__(5);

var _quill2 = _interopRequireDefault(_quill);

var _logger = __webpack_require__(10);

var _logger2 = _interopRequireDefault(_logger);

var _module = __webpack_require__(9);

var _module2 = _interopRequireDefault(_module);

var _align = __webpack_require__(36);

var _background = __webpack_require__(37);

var _code = __webpack_require__(13);

var _code2 = _interopRequireDefault(_code);

var _color = __webpack_require__(26);

var _direction = __webpack_require__(38);

var _font = __webpack_require__(39);

var _size = __webpack_require__(40);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var debug = (0, _logger2.default)('quill:clipboard');

var DOM_KEY = '__ql-matcher';

var CLIPBOARD_CONFIG = [[Node.TEXT_NODE, matchText], [Node.TEXT_NODE, matchNewline], ['br', matchBreak], [Node.ELEMENT_NODE, matchNewline], [Node.ELEMENT_NODE, matchBlot], [Node.ELEMENT_NODE, matchSpacing], [Node.ELEMENT_NODE, matchAttributor], [Node.ELEMENT_NODE, matchStyles], ['li', matchIndent], ['b', matchAlias.bind(matchAlias, 'bold')], ['i', matchAlias.bind(matchAlias, 'italic')], ['style', matchIgnore]];

var ATTRIBUTE_ATTRIBUTORS = [_align.AlignAttribute, _direction.DirectionAttribute].reduce(function (memo, attr) {
  memo[attr.keyName] = attr;
  return memo;
}, {});

var STYLE_ATTRIBUTORS = [_align.AlignStyle, _background.BackgroundStyle, _color.ColorStyle, _direction.DirectionStyle, _font.FontStyle, _size.SizeStyle].reduce(function (memo, attr) {
  memo[attr.keyName] = attr;
  return memo;
}, {});

var Clipboard = function (_Module) {
  _inherits(Clipboard, _Module);

  function Clipboard(quill, options) {
    _classCallCheck(this, Clipboard);

    var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this, quill, options));

    _this.quill.root.addEventListener('paste', _this.onPaste.bind(_this));
    _this.container = _this.quill.addContainer('ql-clipboard');
    _this.container.setAttribute('contenteditable', true);
    _this.container.setAttribute('tabindex', -1);
    _this.matchers = [];
    CLIPBOARD_CONFIG.concat(_this.options.matchers).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          selector = _ref2[0],
          matcher = _ref2[1];

      if (!options.matchVisual && matcher === matchSpacing) return;
      _this.addMatcher(selector, matcher);
    });
    return _this;
  }

  _createClass(Clipboard, [{
    key: 'addMatcher',
    value: function addMatcher(selector, matcher) {
      this.matchers.push([selector, matcher]);
    }
  }, {
    key: 'convert',
    value: function convert(html) {
      if (typeof html === 'string') {
        this.container.innerHTML = html.replace(/\>\r?\n +\</g, '><'); // Remove spaces between tags
        return this.convert();
      }
      var formats = this.quill.getFormat(this.quill.selection.savedRange.index);
      if (formats[_code2.default.blotName]) {
        var text = this.container.innerText;
        this.container.innerHTML = '';
        return new _quillDelta2.default().insert(text, _defineProperty({}, _code2.default.blotName, formats[_code2.default.blotName]));
      }

      var _prepareMatching = this.prepareMatching(),
          _prepareMatching2 = _slicedToArray(_prepareMatching, 2),
          elementMatchers = _prepareMatching2[0],
          textMatchers = _prepareMatching2[1];

      var delta = traverse(this.container, elementMatchers, textMatchers);
      // Remove trailing newline
      if (deltaEndsWith(delta, '\n') && delta.ops[delta.ops.length - 1].attributes == null) {
        delta = delta.compose(new _quillDelta2.default().retain(delta.length() - 1).delete(1));
      }
      debug.log('convert', this.container.innerHTML, delta);
      this.container.innerHTML = '';
      return delta;
    }
  }, {
    key: 'dangerouslyPasteHTML',
    value: function dangerouslyPasteHTML(index, html) {
      var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _quill2.default.sources.API;

      if (typeof index === 'string') {
        this.quill.setContents(this.convert(index), html);
        this.quill.setSelection(0, _quill2.default.sources.SILENT);
      } else {
        var paste = this.convert(html);
        this.quill.updateContents(new _quillDelta2.default().retain(index).concat(paste), source);
        this.quill.setSelection(index + paste.length(), _quill2.default.sources.SILENT);
      }
    }
  }, {
    key: 'onPaste',
    value: function onPaste(e) {
      var _this2 = this;

      if (e.defaultPrevented || !this.quill.isEnabled()) return;
      var range = this.quill.getSelection();
      var delta = new _quillDelta2.default().retain(range.index);
      var scrollTop = this.quill.scrollingContainer.scrollTop;
      this.container.focus();
      this.quill.selection.update(_quill2.default.sources.SILENT);
      setTimeout(function () {
        delta = delta.concat(_this2.convert()).delete(range.length);
        _this2.quill.updateContents(delta, _quill2.default.sources.USER);
        // range.length contributes to delta.length()
        _this2.quill.setSelection(delta.length() - range.length, _quill2.default.sources.SILENT);
        _this2.quill.scrollingContainer.scrollTop = scrollTop;
        _this2.quill.focus();
      }, 1);
    }
  }, {
    key: 'prepareMatching',
    value: function prepareMatching() {
      var _this3 = this;

      var elementMatchers = [],
          textMatchers = [];
      this.matchers.forEach(function (pair) {
        var _pair = _slicedToArray(pair, 2),
            selector = _pair[0],
            matcher = _pair[1];

        switch (selector) {
          case Node.TEXT_NODE:
            textMatchers.push(matcher);
            break;
          case Node.ELEMENT_NODE:
            elementMatchers.push(matcher);
            break;
          default:
            [].forEach.call(_this3.container.querySelectorAll(selector), function (node) {
              // TODO use weakmap
              node[DOM_KEY] = node[DOM_KEY] || [];
              node[DOM_KEY].push(matcher);
            });
            break;
        }
      });
      return [elementMatchers, textMatchers];
    }
  }]);

  return Clipboard;
}(_module2.default);

Clipboard.DEFAULTS = {
  matchers: [],
  matchVisual: true
};

function applyFormat(delta, format, value) {
  if ((typeof format === 'undefined' ? 'undefined' : _typeof(format)) === 'object') {
    return Object.keys(format).reduce(function (delta, key) {
      return applyFormat(delta, key, format[key]);
    }, delta);
  } else {
    return delta.reduce(function (delta, op) {
      if (op.attributes && op.attributes[format]) {
        return delta.push(op);
      } else {
        return delta.insert(op.insert, (0, _extend3.default)({}, _defineProperty({}, format, value), op.attributes));
      }
    }, new _quillDelta2.default());
  }
}

function computeStyle(node) {
  if (node.nodeType !== Node.ELEMENT_NODE) return {};
  var DOM_KEY = '__ql-computed-style';
  return node[DOM_KEY] || (node[DOM_KEY] = window.getComputedStyle(node));
}

function deltaEndsWith(delta, text) {
  var endText = "";
  for (var i = delta.ops.length - 1; i >= 0 && endText.length < text.length; --i) {
    var op = delta.ops[i];
    if (typeof op.insert !== 'string') break;
    endText = op.insert + endText;
  }
  return endText.slice(-1 * text.length) === text;
}

function isLine(node) {
  if (node.childNodes.length === 0) return false; // Exclude embed blocks
  var style = computeStyle(node);
  return ['block', 'list-item'].indexOf(style.display) > -1;
}

function traverse(node, elementMatchers, textMatchers) {
  // Post-order
  if (node.nodeType === node.TEXT_NODE) {
    return textMatchers.reduce(function (delta, matcher) {
      return matcher(node, delta);
    }, new _quillDelta2.default());
  } else if (node.nodeType === node.ELEMENT_NODE) {
    return [].reduce.call(node.childNodes || [], function (delta, childNode) {
      var childrenDelta = traverse(childNode, elementMatchers, textMatchers);
      if (childNode.nodeType === node.ELEMENT_NODE) {
        childrenDelta = elementMatchers.reduce(function (childrenDelta, matcher) {
          return matcher(childNode, childrenDelta);
        }, childrenDelta);
        childrenDelta = (childNode[DOM_KEY] || []).reduce(function (childrenDelta, matcher) {
          return matcher(childNode, childrenDelta);
        }, childrenDelta);
      }
      return delta.concat(childrenDelta);
    }, new _quillDelta2.default());
  } else {
    return new _quillDelta2.default();
  }
}

function matchAlias(format, node, delta) {
  return applyFormat(delta, format, true);
}

function matchAttributor(node, delta) {
  var attributes = _parchment2.default.Attributor.Attribute.keys(node);
  var classes = _parchment2.default.Attributor.Class.keys(node);
  var styles = _parchment2.default.Attributor.Style.keys(node);
  var formats = {};
  attributes.concat(classes).concat(styles).forEach(function (name) {
    var attr = _parchment2.default.query(name, _parchment2.default.Scope.ATTRIBUTE);
    if (attr != null) {
      formats[attr.attrName] = attr.value(node);
      if (formats[attr.attrName]) return;
    }
    attr = ATTRIBUTE_ATTRIBUTORS[name];
    if (attr != null && (attr.attrName === name || attr.keyName === name)) {
      formats[attr.attrName] = attr.value(node) || undefined;
    }
    attr = STYLE_ATTRIBUTORS[name];
    if (attr != null && (attr.attrName === name || attr.keyName === name)) {
      attr = STYLE_ATTRIBUTORS[name];
      formats[attr.attrName] = attr.value(node) || undefined;
    }
  });
  if (Object.keys(formats).length > 0) {
    delta = applyFormat(delta, formats);
  }
  return delta;
}

function matchBlot(node, delta) {
  var match = _parchment2.default.query(node);
  if (match == null) return delta;
  if (match.prototype instanceof _parchment2.default.Embed) {
    var embed = {};
    var value = match.value(node);
    if (value != null) {
      embed[match.blotName] = value;
      delta = new _quillDelta2.default().insert(embed, match.formats(node));
    }
  } else if (typeof match.formats === 'function') {
    delta = applyFormat(delta, match.blotName, match.formats(node));
  }
  return delta;
}

function matchBreak(node, delta) {
  if (!deltaEndsWith(delta, '\n')) {
    delta.insert('\n');
  }
  return delta;
}

function matchIgnore() {
  return new _quillDelta2.default();
}

function matchIndent(node, delta) {
  var match = _parchment2.default.query(node);
  if (match == null || match.blotName !== 'list-item' || !deltaEndsWith(delta, '\n')) {
    return delta;
  }
  var indent = -1,
      parent = node.parentNode;
  while (!parent.classList.contains('ql-clipboard')) {
    if ((_parchment2.default.query(parent) || {}).blotName === 'list') {
      indent += 1;
    }
    parent = parent.parentNode;
  }
  if (indent <= 0) return delta;
  return delta.compose(new _quillDelta2.default().retain(delta.length() - 1).retain(1, { indent: indent }));
}

function matchNewline(node, delta) {
  if (!deltaEndsWith(delta, '\n')) {
    if (isLine(node) || delta.length() > 0 && node.nextSibling && isLine(node.nextSibling)) {
      delta.insert('\n');
    }
  }
  return delta;
}

function matchSpacing(node, delta) {
  if (isLine(node) && node.nextElementSibling != null && !deltaEndsWith(delta, '\n\n')) {
    var nodeHeight = node.offsetHeight + parseFloat(computeStyle(node).marginTop) + parseFloat(computeStyle(node).marginBottom);
    if (node.nextElementSibling.offsetTop > node.offsetTop + nodeHeight * 1.5) {
      delta.insert('\n');
    }
  }
  return delta;
}

function matchStyles(node, delta) {
  var formats = {};
  var style = node.style || {};
  if (style.fontStyle && computeStyle(node).fontStyle === 'italic') {
    formats.italic = true;
  }
  if (style.fontWeight && (computeStyle(node).fontWeight.startsWith('bold') || parseInt(computeStyle(node).fontWeight) >= 700)) {
    formats.bold = true;
  }
  if (Object.keys(formats).length > 0) {
    delta = applyFormat(delta, formats);
  }
  if (parseFloat(style.textIndent || 0) > 0) {
    // Could be 0.5in
    delta = new _quillDelta2.default().insert('\t').concat(delta);
  }
  return delta;
}

function matchText(node, delta) {
  var text = node.data;
  // Word represents empty line with <o:p>&nbsp;</o:p>
  if (node.parentNode.tagName === 'O:P') {
    return delta.insert(text.trim());
  }
  if (text.trim().length === 0 && node.parentNode.classList.contains('ql-clipboard')) {
    return delta;
  }
  if (!computeStyle(node.parentNode).whiteSpace.startsWith('pre')) {
    // eslint-disable-next-line func-style
    var replacer = function replacer(collapse, match) {
      match = match.replace(/[^\u00a0]/g, ''); // \u00a0 is nbsp;
      return match.length < 1 && collapse ? ' ' : match;
    };
    text = text.replace(/\r\n/g, ' ').replace(/\n/g, ' ');
    text = text.replace(/\s\s+/g, replacer.bind(replacer, true)); // collapse whitespace
    if (node.previousSibling == null && isLine(node.parentNode) || node.previousSibling != null && isLine(node.previousSibling)) {
      text = text.replace(/^\s+/, replacer.bind(replacer, false));
    }
    if (node.nextSibling == null && isLine(node.parentNode) || node.nextSibling != null && isLine(node.nextSibling)) {
      text = text.replace(/\s+$/, replacer.bind(replacer, false));
    }
  }
  return delta.insert(text);
}

exports.default = Clipboard;
exports.matchAttributor = matchAttributor;
exports.matchBlot = matchBlot;
exports.matchNewline = matchNewline;
exports.matchSpacing = matchSpacing;
exports.matchText = matchText;

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _inline = __webpack_require__(6);

var _inline2 = _interopRequireDefault(_inline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Bold = function (_Inline) {
  _inherits(Bold, _Inline);

  function Bold() {
    _classCallCheck(this, Bold);

    return _possibleConstructorReturn(this, (Bold.__proto__ || Object.getPrototypeOf(Bold)).apply(this, arguments));
  }

  _createClass(Bold, [{
    key: 'optimize',
    value: function optimize(context) {
      _get(Bold.prototype.__proto__ || Object.getPrototypeOf(Bold.prototype), 'optimize', this).call(this, context);
      if (this.domNode.tagName !== this.statics.tagName[0]) {
        this.replaceWith(this.statics.blotName);
      }
    }
  }], [{
    key: 'create',
    value: function create() {
      return _get(Bold.__proto__ || Object.getPrototypeOf(Bold), 'create', this).call(this);
    }
  }, {
    key: 'formats',
    value: function formats() {
      return true;
    }
  }]);

  return Bold;
}(_inline2.default);

Bold.blotName = 'bold';
Bold.tagName = ['STRONG', 'B'];

exports.default = Bold;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addControls = exports.default = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _quillDelta = __webpack_require__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _quill = __webpack_require__(5);

var _quill2 = _interopRequireDefault(_quill);

var _logger = __webpack_require__(10);

var _logger2 = _interopRequireDefault(_logger);

var _module = __webpack_require__(9);

var _module2 = _interopRequireDefault(_module);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var debug = (0, _logger2.default)('quill:toolbar');

var Toolbar = function (_Module) {
  _inherits(Toolbar, _Module);

  function Toolbar(quill, options) {
    _classCallCheck(this, Toolbar);

    var _this = _possibleConstructorReturn(this, (Toolbar.__proto__ || Object.getPrototypeOf(Toolbar)).call(this, quill, options));

    if (Array.isArray(_this.options.container)) {
      var container = document.createElement('div');
      addControls(container, _this.options.container);
      quill.container.parentNode.insertBefore(container, quill.container);
      _this.container = container;
    } else if (typeof _this.options.container === 'string') {
      _this.container = document.querySelector(_this.options.container);
    } else {
      _this.container = _this.options.container;
    }
    if (!(_this.container instanceof HTMLElement)) {
      var _ret;

      return _ret = debug.error('Container required for toolbar', _this.options), _possibleConstructorReturn(_this, _ret);
    }
    _this.container.classList.add('ql-toolbar');
    _this.controls = [];
    _this.handlers = {};
    Object.keys(_this.options.handlers).forEach(function (format) {
      _this.addHandler(format, _this.options.handlers[format]);
    });
    [].forEach.call(_this.container.querySelectorAll('button, select'), function (input) {
      _this.attach(input);
    });
    _this.quill.on(_quill2.default.events.EDITOR_CHANGE, function (type, range) {
      if (type === _quill2.default.events.SELECTION_CHANGE) {
        _this.update(range);
      }
    });
    _this.quill.on(_quill2.default.events.SCROLL_OPTIMIZE, function () {
      var _this$quill$selection = _this.quill.selection.getRange(),
          _this$quill$selection2 = _slicedToArray(_this$quill$selection, 1),
          range = _this$quill$selection2[0]; // quill.getSelection triggers update


      _this.update(range);
    });
    return _this;
  }

  _createClass(Toolbar, [{
    key: 'addHandler',
    value: function addHandler(format, handler) {
      this.handlers[format] = handler;
    }
  }, {
    key: 'attach',
    value: function attach(input) {
      var _this2 = this;

      var format = [].find.call(input.classList, function (className) {
        return className.indexOf('ql-') === 0;
      });
      if (!format) return;
      format = format.slice('ql-'.length);
      if (input.tagName === 'BUTTON') {
        input.setAttribute('type', 'button');
      }
      if (this.handlers[format] == null) {
        if (this.quill.scroll.whitelist != null && this.quill.scroll.whitelist[format] == null) {
          debug.warn('ignoring attaching to disabled format', format, input);
          return;
        }
        if (_parchment2.default.query(format) == null) {
          debug.warn('ignoring attaching to nonexistent format', format, input);
          return;
        }
      }
      var eventName = input.tagName === 'SELECT' ? 'change' : 'click';
      input.addEventListener(eventName, function (e) {
        var value = void 0;
        if (input.tagName === 'SELECT') {
          if (input.selectedIndex < 0) return;
          var selected = input.options[input.selectedIndex];
          if (selected.hasAttribute('selected')) {
            value = false;
          } else {
            value = selected.value || false;
          }
        } else {
          if (input.classList.contains('ql-active')) {
            value = false;
          } else {
            value = input.value || !input.hasAttribute('value');
          }
          e.preventDefault();
        }
        _this2.quill.focus();

        var _quill$selection$getR = _this2.quill.selection.getRange(),
            _quill$selection$getR2 = _slicedToArray(_quill$selection$getR, 1),
            range = _quill$selection$getR2[0];

        if (_this2.handlers[format] != null) {
          _this2.handlers[format].call(_this2, value);
        } else if (_parchment2.default.query(format).prototype instanceof _parchment2.default.Embed) {
          value = prompt('Enter ' + format);
          if (!value) return;
          _this2.quill.updateContents(new _quillDelta2.default().retain(range.index).delete(range.length).insert(_defineProperty({}, format, value)), _quill2.default.sources.USER);
        } else {
          _this2.quill.format(format, value, _quill2.default.sources.USER);
        }
        _this2.update(range);
      });
      // TODO use weakmap
      this.controls.push([format, input]);
    }
  }, {
    key: 'update',
    value: function update(range) {
      var formats = range == null ? {} : this.quill.getFormat(range);
      this.controls.forEach(function (pair) {
        var _pair = _slicedToArray(pair, 2),
            format = _pair[0],
            input = _pair[1];

        if (input.tagName === 'SELECT') {
          var option = void 0;
          if (range == null) {
            option = null;
          } else if (formats[format] == null) {
            option = input.querySelector('option[selected]');
          } else if (!Array.isArray(formats[format])) {
            var value = formats[format];
            if (typeof value === 'string') {
              value = value.replace(/\"/g, '\\"');
            }
            option = input.querySelector('option[value="' + value + '"]');
          }
          if (option == null) {
            input.value = ''; // TODO make configurable?
            input.selectedIndex = -1;
          } else {
            option.selected = true;
          }
        } else {
          if (range == null) {
            input.classList.remove('ql-active');
          } else if (input.hasAttribute('value')) {
            // both being null should match (default values)
            // '1' should match with 1 (headers)
            var isActive = formats[format] === input.getAttribute('value') || formats[format] != null && formats[format].toString() === input.getAttribute('value') || formats[format] == null && !input.getAttribute('value');
            input.classList.toggle('ql-active', isActive);
          } else {
            input.classList.toggle('ql-active', formats[format] != null);
          }
        }
      });
    }
  }]);

  return Toolbar;
}(_module2.default);

Toolbar.DEFAULTS = {};

function addButton(container, format, value) {
  var input = document.createElement('button');
  input.setAttribute('type', 'button');
  input.classList.add('ql-' + format);
  if (value != null) {
    input.value = value;
  }
  container.appendChild(input);
}

function addControls(container, groups) {
  if (!Array.isArray(groups[0])) {
    groups = [groups];
  }
  groups.forEach(function (controls) {
    var group = document.createElement('span');
    group.classList.add('ql-formats');
    controls.forEach(function (control) {
      if (typeof control === 'string') {
        addButton(group, control);
      } else {
        var format = Object.keys(control)[0];
        var value = control[format];
        if (Array.isArray(value)) {
          addSelect(group, format, value);
        } else {
          addButton(group, format, value);
        }
      }
    });
    container.appendChild(group);
  });
}

function addSelect(container, format, values) {
  var input = document.createElement('select');
  input.classList.add('ql-' + format);
  values.forEach(function (value) {
    var option = document.createElement('option');
    if (value !== false) {
      option.setAttribute('value', value);
    } else {
      option.setAttribute('selected', 'selected');
    }
    input.appendChild(option);
  });
  container.appendChild(input);
}

Toolbar.DEFAULTS = {
  container: null,
  handlers: {
    clean: function clean() {
      var _this3 = this;

      var range = this.quill.getSelection();
      if (range == null) return;
      if (range.length == 0) {
        var formats = this.quill.getFormat();
        Object.keys(formats).forEach(function (name) {
          // Clean functionality in existing apps only clean inline formats
          if (_parchment2.default.query(name, _parchment2.default.Scope.INLINE) != null) {
            _this3.quill.format(name, false);
          }
        });
      } else {
        this.quill.removeFormat(range, _quill2.default.sources.USER);
      }
    },
    direction: function direction(value) {
      var align = this.quill.getFormat()['align'];
      if (value === 'rtl' && align == null) {
        this.quill.format('align', 'right', _quill2.default.sources.USER);
      } else if (!value && align === 'right') {
        this.quill.format('align', false, _quill2.default.sources.USER);
      }
      this.quill.format('direction', value, _quill2.default.sources.USER);
    },
    indent: function indent(value) {
      var range = this.quill.getSelection();
      var formats = this.quill.getFormat(range);
      var indent = parseInt(formats.indent || 0);
      if (value === '+1' || value === '-1') {
        var modifier = value === '+1' ? 1 : -1;
        if (formats.direction === 'rtl') modifier *= -1;
        this.quill.format('indent', indent + modifier, _quill2.default.sources.USER);
      }
    },
    link: function link(value) {
      if (value === true) {
        value = prompt('Enter link URL:');
      }
      this.quill.format('link', value, _quill2.default.sources.USER);
    },
    list: function list(value) {
      var range = this.quill.getSelection();
      var formats = this.quill.getFormat(range);
      if (value === 'check') {
        if (formats['list'] === 'checked' || formats['list'] === 'unchecked') {
          this.quill.format('list', false, _quill2.default.sources.USER);
        } else {
          this.quill.format('list', 'unchecked', _quill2.default.sources.USER);
        }
      } else {
        this.quill.format('list', value, _quill2.default.sources.USER);
      }
    }
  }
};

exports.default = Toolbar;
exports.addControls = addControls;

/***/ }),
/* 58 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <polyline class=\"ql-even ql-stroke\" points=\"5 7 3 9 5 11\"></polyline> <polyline class=\"ql-even ql-stroke\" points=\"13 7 15 9 13 11\"></polyline> <line class=ql-stroke x1=10 x2=8 y1=5 y2=13></line> </svg>";

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _picker = __webpack_require__(28);

var _picker2 = _interopRequireDefault(_picker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ColorPicker = function (_Picker) {
  _inherits(ColorPicker, _Picker);

  function ColorPicker(select, label) {
    _classCallCheck(this, ColorPicker);

    var _this = _possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this, select));

    _this.label.innerHTML = label;
    _this.container.classList.add('ql-color-picker');
    [].slice.call(_this.container.querySelectorAll('.ql-picker-item'), 0, 7).forEach(function (item) {
      item.classList.add('ql-primary');
    });
    return _this;
  }

  _createClass(ColorPicker, [{
    key: 'buildItem',
    value: function buildItem(option) {
      var item = _get(ColorPicker.prototype.__proto__ || Object.getPrototypeOf(ColorPicker.prototype), 'buildItem', this).call(this, option);
      item.style.backgroundColor = option.getAttribute('value') || '';
      return item;
    }
  }, {
    key: 'selectItem',
    value: function selectItem(item, trigger) {
      _get(ColorPicker.prototype.__proto__ || Object.getPrototypeOf(ColorPicker.prototype), 'selectItem', this).call(this, item, trigger);
      var colorLabel = this.label.querySelector('.ql-color-label');
      var value = item ? item.getAttribute('data-value') || '' : '';
      if (colorLabel) {
        if (colorLabel.tagName === 'line') {
          colorLabel.style.stroke = value;
        } else {
          colorLabel.style.fill = value;
        }
      }
    }
  }]);

  return ColorPicker;
}(_picker2.default);

exports.default = ColorPicker;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _picker = __webpack_require__(28);

var _picker2 = _interopRequireDefault(_picker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IconPicker = function (_Picker) {
  _inherits(IconPicker, _Picker);

  function IconPicker(select, icons) {
    _classCallCheck(this, IconPicker);

    var _this = _possibleConstructorReturn(this, (IconPicker.__proto__ || Object.getPrototypeOf(IconPicker)).call(this, select));

    _this.container.classList.add('ql-icon-picker');
    [].forEach.call(_this.container.querySelectorAll('.ql-picker-item'), function (item) {
      item.innerHTML = icons[item.getAttribute('data-value') || ''];
    });
    _this.defaultItem = _this.container.querySelector('.ql-selected');
    _this.selectItem(_this.defaultItem);
    return _this;
  }

  _createClass(IconPicker, [{
    key: 'selectItem',
    value: function selectItem(item, trigger) {
      _get(IconPicker.prototype.__proto__ || Object.getPrototypeOf(IconPicker.prototype), 'selectItem', this).call(this, item, trigger);
      item = item || this.defaultItem;
      this.label.innerHTML = item.innerHTML;
    }
  }]);

  return IconPicker;
}(_picker2.default);

exports.default = IconPicker;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Tooltip = function () {
  function Tooltip(quill, boundsContainer) {
    var _this = this;

    _classCallCheck(this, Tooltip);

    this.quill = quill;
    this.boundsContainer = boundsContainer || document.body;
    this.root = quill.addContainer('ql-tooltip');
    this.root.innerHTML = this.constructor.TEMPLATE;
    if (this.quill.root === this.quill.scrollingContainer) {
      this.quill.root.addEventListener('scroll', function () {
        _this.root.style.marginTop = -1 * _this.quill.root.scrollTop + 'px';
      });
    }
    this.hide();
  }

  _createClass(Tooltip, [{
    key: 'hide',
    value: function hide() {
      this.root.classList.add('ql-hidden');
    }
  }, {
    key: 'position',
    value: function position(reference) {
      var left = reference.left + reference.width / 2 - this.root.offsetWidth / 2;
      // root.scrollTop should be 0 if scrollContainer !== root
      var top = reference.bottom + this.quill.root.scrollTop;
      this.root.style.left = left + 'px';
      this.root.style.top = top + 'px';
      this.root.classList.remove('ql-flip');
      var containerBounds = this.boundsContainer.getBoundingClientRect();
      var rootBounds = this.root.getBoundingClientRect();
      var shift = 0;
      if (rootBounds.right > containerBounds.right) {
        shift = containerBounds.right - rootBounds.right;
        this.root.style.left = left + shift + 'px';
      }
      if (rootBounds.left < containerBounds.left) {
        shift = containerBounds.left - rootBounds.left;
        this.root.style.left = left + shift + 'px';
      }
      if (rootBounds.bottom > containerBounds.bottom) {
        var height = rootBounds.bottom - rootBounds.top;
        var verticalShift = reference.bottom - reference.top + height;
        this.root.style.top = top - verticalShift + 'px';
        this.root.classList.add('ql-flip');
      }
      return shift;
    }
  }, {
    key: 'show',
    value: function show() {
      this.root.classList.remove('ql-editing');
      this.root.classList.remove('ql-hidden');
    }
  }]);

  return Tooltip;
}();

exports.default = Tooltip;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extend = __webpack_require__(3);

var _extend2 = _interopRequireDefault(_extend);

var _emitter = __webpack_require__(8);

var _emitter2 = _interopRequireDefault(_emitter);

var _base = __webpack_require__(43);

var _base2 = _interopRequireDefault(_base);

var _link = __webpack_require__(27);

var _link2 = _interopRequireDefault(_link);

var _selection = __webpack_require__(15);

var _icons = __webpack_require__(41);

var _icons2 = _interopRequireDefault(_icons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TOOLBAR_CONFIG = [[{ header: ['1', '2', '3', false] }], ['bold', 'italic', 'underline', 'link'], [{ list: 'ordered' }, { list: 'bullet' }], ['clean']];

var SnowTheme = function (_BaseTheme) {
  _inherits(SnowTheme, _BaseTheme);

  function SnowTheme(quill, options) {
    _classCallCheck(this, SnowTheme);

    if (options.modules.toolbar != null && options.modules.toolbar.container == null) {
      options.modules.toolbar.container = TOOLBAR_CONFIG;
    }

    var _this = _possibleConstructorReturn(this, (SnowTheme.__proto__ || Object.getPrototypeOf(SnowTheme)).call(this, quill, options));

    _this.quill.container.classList.add('ql-snow');
    return _this;
  }

  _createClass(SnowTheme, [{
    key: 'extendToolbar',
    value: function extendToolbar(toolbar) {
      toolbar.container.classList.add('ql-snow');
      this.buildButtons([].slice.call(toolbar.container.querySelectorAll('button')), _icons2.default);
      this.buildPickers([].slice.call(toolbar.container.querySelectorAll('select')), _icons2.default);
      this.tooltip = new SnowTooltip(this.quill, this.options.bounds);
      if (toolbar.container.querySelector('.ql-link')) {
        this.quill.keyboard.addBinding({ key: 'K', shortKey: true }, function (range, context) {
          toolbar.handlers['link'].call(toolbar, !context.format.link);
        });
      }
    }
  }]);

  return SnowTheme;
}(_base2.default);

SnowTheme.DEFAULTS = (0, _extend2.default)(true, {}, _base2.default.DEFAULTS, {
  modules: {
    toolbar: {
      handlers: {
        link: function link(value) {
          if (value) {
            var range = this.quill.getSelection();
            if (range == null || range.length == 0) return;
            var preview = this.quill.getText(range);
            if (/^\S+@\S+\.\S+$/.test(preview) && preview.indexOf('mailto:') !== 0) {
              preview = 'mailto:' + preview;
            }
            var tooltip = this.quill.theme.tooltip;
            tooltip.edit('link', preview);
          } else {
            this.quill.format('link', false);
          }
        }
      }
    }
  }
});

var SnowTooltip = function (_BaseTooltip) {
  _inherits(SnowTooltip, _BaseTooltip);

  function SnowTooltip(quill, bounds) {
    _classCallCheck(this, SnowTooltip);

    var _this2 = _possibleConstructorReturn(this, (SnowTooltip.__proto__ || Object.getPrototypeOf(SnowTooltip)).call(this, quill, bounds));

    _this2.preview = _this2.root.querySelector('a.ql-preview');
    return _this2;
  }

  _createClass(SnowTooltip, [{
    key: 'listen',
    value: function listen() {
      var _this3 = this;

      _get(SnowTooltip.prototype.__proto__ || Object.getPrototypeOf(SnowTooltip.prototype), 'listen', this).call(this);
      this.root.querySelector('a.ql-action').addEventListener('click', function (event) {
        if (_this3.root.classList.contains('ql-editing')) {
          _this3.save();
        } else {
          _this3.edit('link', _this3.preview.textContent);
        }
        event.preventDefault();
      });
      this.root.querySelector('a.ql-remove').addEventListener('click', function (event) {
        if (_this3.linkRange != null) {
          var range = _this3.linkRange;
          _this3.restoreFocus();
          _this3.quill.formatText(range, 'link', false, _emitter2.default.sources.USER);
          delete _this3.linkRange;
        }
        event.preventDefault();
        _this3.hide();
      });
      this.quill.on(_emitter2.default.events.SELECTION_CHANGE, function (range, oldRange, source) {
        if (range == null) return;
        if (range.length === 0 && source === _emitter2.default.sources.USER) {
          var _quill$scroll$descend = _this3.quill.scroll.descendant(_link2.default, range.index),
              _quill$scroll$descend2 = _slicedToArray(_quill$scroll$descend, 2),
              link = _quill$scroll$descend2[0],
              offset = _quill$scroll$descend2[1];

          if (link != null) {
            _this3.linkRange = new _selection.Range(range.index - offset, link.length());
            var preview = _link2.default.formats(link.domNode);
            _this3.preview.textContent = preview;
            _this3.preview.setAttribute('href', preview);
            _this3.show();
            _this3.position(_this3.quill.getBounds(_this3.linkRange));
            return;
          }
        } else {
          delete _this3.linkRange;
        }
        _this3.hide();
      });
    }
  }, {
    key: 'show',
    value: function show() {
      _get(SnowTooltip.prototype.__proto__ || Object.getPrototypeOf(SnowTooltip.prototype), 'show', this).call(this);
      this.root.removeAttribute('data-mode');
    }
  }]);

  return SnowTooltip;
}(_base.BaseTooltip);

SnowTooltip.TEMPLATE = ['<a class="ql-preview" target="_blank" href="about:blank"></a>', '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">', '<a class="ql-action"></a>', '<a class="ql-remove"></a>'].join('');

exports.default = SnowTheme;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _core = __webpack_require__(29);

var _core2 = _interopRequireDefault(_core);

var _align = __webpack_require__(36);

var _direction = __webpack_require__(38);

var _indent = __webpack_require__(64);

var _blockquote = __webpack_require__(65);

var _blockquote2 = _interopRequireDefault(_blockquote);

var _header = __webpack_require__(66);

var _header2 = _interopRequireDefault(_header);

var _list = __webpack_require__(67);

var _list2 = _interopRequireDefault(_list);

var _background = __webpack_require__(37);

var _color = __webpack_require__(26);

var _font = __webpack_require__(39);

var _size = __webpack_require__(40);

var _bold = __webpack_require__(56);

var _bold2 = _interopRequireDefault(_bold);

var _italic = __webpack_require__(68);

var _italic2 = _interopRequireDefault(_italic);

var _link = __webpack_require__(27);

var _link2 = _interopRequireDefault(_link);

var _script = __webpack_require__(69);

var _script2 = _interopRequireDefault(_script);

var _strike = __webpack_require__(70);

var _strike2 = _interopRequireDefault(_strike);

var _underline = __webpack_require__(71);

var _underline2 = _interopRequireDefault(_underline);

var _image = __webpack_require__(72);

var _image2 = _interopRequireDefault(_image);

var _video = __webpack_require__(73);

var _video2 = _interopRequireDefault(_video);

var _code = __webpack_require__(13);

var _code2 = _interopRequireDefault(_code);

var _formula = __webpack_require__(74);

var _formula2 = _interopRequireDefault(_formula);

var _syntax = __webpack_require__(75);

var _syntax2 = _interopRequireDefault(_syntax);

var _toolbar = __webpack_require__(57);

var _toolbar2 = _interopRequireDefault(_toolbar);

var _icons = __webpack_require__(41);

var _icons2 = _interopRequireDefault(_icons);

var _picker = __webpack_require__(28);

var _picker2 = _interopRequireDefault(_picker);

var _colorPicker = __webpack_require__(59);

var _colorPicker2 = _interopRequireDefault(_colorPicker);

var _iconPicker = __webpack_require__(60);

var _iconPicker2 = _interopRequireDefault(_iconPicker);

var _tooltip = __webpack_require__(61);

var _tooltip2 = _interopRequireDefault(_tooltip);

var _bubble = __webpack_require__(108);

var _bubble2 = _interopRequireDefault(_bubble);

var _snow = __webpack_require__(62);

var _snow2 = _interopRequireDefault(_snow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_core2.default.register({
  'attributors/attribute/direction': _direction.DirectionAttribute,

  'attributors/class/align': _align.AlignClass,
  'attributors/class/background': _background.BackgroundClass,
  'attributors/class/color': _color.ColorClass,
  'attributors/class/direction': _direction.DirectionClass,
  'attributors/class/font': _font.FontClass,
  'attributors/class/size': _size.SizeClass,

  'attributors/style/align': _align.AlignStyle,
  'attributors/style/background': _background.BackgroundStyle,
  'attributors/style/color': _color.ColorStyle,
  'attributors/style/direction': _direction.DirectionStyle,
  'attributors/style/font': _font.FontStyle,
  'attributors/style/size': _size.SizeStyle
}, true);

_core2.default.register({
  'formats/align': _align.AlignClass,
  'formats/direction': _direction.DirectionClass,
  'formats/indent': _indent.IndentClass,

  'formats/background': _background.BackgroundStyle,
  'formats/color': _color.ColorStyle,
  'formats/font': _font.FontClass,
  'formats/size': _size.SizeClass,

  'formats/blockquote': _blockquote2.default,
  'formats/code-block': _code2.default,
  'formats/header': _header2.default,
  'formats/list': _list2.default,

  'formats/bold': _bold2.default,
  'formats/code': _code.Code,
  'formats/italic': _italic2.default,
  'formats/link': _link2.default,
  'formats/script': _script2.default,
  'formats/strike': _strike2.default,
  'formats/underline': _underline2.default,

  'formats/image': _image2.default,
  'formats/video': _video2.default,

  'formats/list/item': _list.ListItem,

  'modules/formula': _formula2.default,
  'modules/syntax': _syntax2.default,
  'modules/toolbar': _toolbar2.default,

  'themes/bubble': _bubble2.default,
  'themes/snow': _snow2.default,

  'ui/icons': _icons2.default,
  'ui/picker': _picker2.default,
  'ui/icon-picker': _iconPicker2.default,
  'ui/color-picker': _colorPicker2.default,
  'ui/tooltip': _tooltip2.default
}, true);

exports.default = _core2.default;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IndentClass = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IdentAttributor = function (_Parchment$Attributor) {
  _inherits(IdentAttributor, _Parchment$Attributor);

  function IdentAttributor() {
    _classCallCheck(this, IdentAttributor);

    return _possibleConstructorReturn(this, (IdentAttributor.__proto__ || Object.getPrototypeOf(IdentAttributor)).apply(this, arguments));
  }

  _createClass(IdentAttributor, [{
    key: 'add',
    value: function add(node, value) {
      if (value === '+1' || value === '-1') {
        var indent = this.value(node) || 0;
        value = value === '+1' ? indent + 1 : indent - 1;
      }
      if (value === 0) {
        this.remove(node);
        return true;
      } else {
        return _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'add', this).call(this, node, value);
      }
    }
  }, {
    key: 'canAdd',
    value: function canAdd(node, value) {
      return _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'canAdd', this).call(this, node, value) || _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'canAdd', this).call(this, node, parseInt(value));
    }
  }, {
    key: 'value',
    value: function value(node) {
      return parseInt(_get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'value', this).call(this, node)) || undefined; // Don't return NaN
    }
  }]);

  return IdentAttributor;
}(_parchment2.default.Attributor.Class);

var IndentClass = new IdentAttributor('indent', 'ql-indent', {
  scope: _parchment2.default.Scope.BLOCK,
  whitelist: [1, 2, 3, 4, 5, 6, 7, 8]
});

exports.IndentClass = IndentClass;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _block = __webpack_require__(4);

var _block2 = _interopRequireDefault(_block);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Blockquote = function (_Block) {
  _inherits(Blockquote, _Block);

  function Blockquote() {
    _classCallCheck(this, Blockquote);

    return _possibleConstructorReturn(this, (Blockquote.__proto__ || Object.getPrototypeOf(Blockquote)).apply(this, arguments));
  }

  return Blockquote;
}(_block2.default);

Blockquote.blotName = 'blockquote';
Blockquote.tagName = 'blockquote';

exports.default = Blockquote;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _block = __webpack_require__(4);

var _block2 = _interopRequireDefault(_block);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Header = function (_Block) {
  _inherits(Header, _Block);

  function Header() {
    _classCallCheck(this, Header);

    return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
  }

  _createClass(Header, null, [{
    key: 'formats',
    value: function formats(domNode) {
      return this.tagName.indexOf(domNode.tagName) + 1;
    }
  }]);

  return Header;
}(_block2.default);

Header.blotName = 'header';
Header.tagName = ['H1', 'H2', 'H3', 'H4', 'H5', 'H6'];

exports.default = Header;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ListItem = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _block = __webpack_require__(4);

var _block2 = _interopRequireDefault(_block);

var _container = __webpack_require__(25);

var _container2 = _interopRequireDefault(_container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListItem = function (_Block) {
  _inherits(ListItem, _Block);

  function ListItem() {
    _classCallCheck(this, ListItem);

    return _possibleConstructorReturn(this, (ListItem.__proto__ || Object.getPrototypeOf(ListItem)).apply(this, arguments));
  }

  _createClass(ListItem, [{
    key: 'format',
    value: function format(name, value) {
      if (name === List.blotName && !value) {
        this.replaceWith(_parchment2.default.create(this.statics.scope));
      } else {
        _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'format', this).call(this, name, value);
      }
    }
  }, {
    key: 'remove',
    value: function remove() {
      if (this.prev == null && this.next == null) {
        this.parent.remove();
      } else {
        _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'remove', this).call(this);
      }
    }
  }, {
    key: 'replaceWith',
    value: function replaceWith(name, value) {
      this.parent.isolate(this.offset(this.parent), this.length());
      if (name === this.parent.statics.blotName) {
        this.parent.replaceWith(name, value);
        return this;
      } else {
        this.parent.unwrap();
        return _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'replaceWith', this).call(this, name, value);
      }
    }
  }], [{
    key: 'formats',
    value: function formats(domNode) {
      return domNode.tagName === this.tagName ? undefined : _get(ListItem.__proto__ || Object.getPrototypeOf(ListItem), 'formats', this).call(this, domNode);
    }
  }]);

  return ListItem;
}(_block2.default);

ListItem.blotName = 'list-item';
ListItem.tagName = 'LI';

var List = function (_Container) {
  _inherits(List, _Container);

  _createClass(List, null, [{
    key: 'create',
    value: function create(value) {
      var tagName = value === 'ordered' ? 'OL' : 'UL';
      var node = _get(List.__proto__ || Object.getPrototypeOf(List), 'create', this).call(this, tagName);
      if (value === 'checked' || value === 'unchecked') {
        node.setAttribute('data-checked', value === 'checked');
      }
      return node;
    }
  }, {
    key: 'formats',
    value: function formats(domNode) {
      if (domNode.tagName === 'OL') return 'ordered';
      if (domNode.tagName === 'UL') {
        if (domNode.hasAttribute('data-checked')) {
          return domNode.getAttribute('data-checked') === 'true' ? 'checked' : 'unchecked';
        } else {
          return 'bullet';
        }
      }
      return undefined;
    }
  }]);

  function List(domNode) {
    _classCallCheck(this, List);

    var _this2 = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, domNode));

    var listEventHandler = function listEventHandler(e) {
      if (e.target.parentNode !== domNode) return;
      var format = _this2.statics.formats(domNode);
      var blot = _parchment2.default.find(e.target);
      if (format === 'checked') {
        blot.format('list', 'unchecked');
      } else if (format === 'unchecked') {
        blot.format('list', 'checked');
      }
    };

    domNode.addEventListener('touchstart', listEventHandler);
    domNode.addEventListener('mousedown', listEventHandler);
    return _this2;
  }

  _createClass(List, [{
    key: 'format',
    value: function format(name, value) {
      if (this.children.length > 0) {
        this.children.tail.format(name, value);
      }
    }
  }, {
    key: 'formats',
    value: function formats() {
      // We don't inherit from FormatBlot
      return _defineProperty({}, this.statics.blotName, this.statics.formats(this.domNode));
    }
  }, {
    key: 'insertBefore',
    value: function insertBefore(blot, ref) {
      if (blot instanceof ListItem) {
        _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'insertBefore', this).call(this, blot, ref);
      } else {
        var index = ref == null ? this.length() : ref.offset(this);
        var after = this.split(index);
        after.parent.insertBefore(blot, after);
      }
    }
  }, {
    key: 'optimize',
    value: function optimize(context) {
      _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'optimize', this).call(this, context);
      var next = this.next;
      if (next != null && next.prev === this && next.statics.blotName === this.statics.blotName && next.domNode.tagName === this.domNode.tagName && next.domNode.getAttribute('data-checked') === this.domNode.getAttribute('data-checked')) {
        next.moveChildren(this);
        next.remove();
      }
    }
  }, {
    key: 'replace',
    value: function replace(target) {
      if (target.statics.blotName !== this.statics.blotName) {
        var item = _parchment2.default.create(this.statics.defaultChild);
        target.moveChildren(item);
        this.appendChild(item);
      }
      _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'replace', this).call(this, target);
    }
  }]);

  return List;
}(_container2.default);

List.blotName = 'list';
List.scope = _parchment2.default.Scope.BLOCK_BLOT;
List.tagName = ['OL', 'UL'];
List.defaultChild = 'list-item';
List.allowedChildren = [ListItem];

exports.ListItem = ListItem;
exports.default = List;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bold = __webpack_require__(56);

var _bold2 = _interopRequireDefault(_bold);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Italic = function (_Bold) {
  _inherits(Italic, _Bold);

  function Italic() {
    _classCallCheck(this, Italic);

    return _possibleConstructorReturn(this, (Italic.__proto__ || Object.getPrototypeOf(Italic)).apply(this, arguments));
  }

  return Italic;
}(_bold2.default);

Italic.blotName = 'italic';
Italic.tagName = ['EM', 'I'];

exports.default = Italic;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _inline = __webpack_require__(6);

var _inline2 = _interopRequireDefault(_inline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Script = function (_Inline) {
  _inherits(Script, _Inline);

  function Script() {
    _classCallCheck(this, Script);

    return _possibleConstructorReturn(this, (Script.__proto__ || Object.getPrototypeOf(Script)).apply(this, arguments));
  }

  _createClass(Script, null, [{
    key: 'create',
    value: function create(value) {
      if (value === 'super') {
        return document.createElement('sup');
      } else if (value === 'sub') {
        return document.createElement('sub');
      } else {
        return _get(Script.__proto__ || Object.getPrototypeOf(Script), 'create', this).call(this, value);
      }
    }
  }, {
    key: 'formats',
    value: function formats(domNode) {
      if (domNode.tagName === 'SUB') return 'sub';
      if (domNode.tagName === 'SUP') return 'super';
      return undefined;
    }
  }]);

  return Script;
}(_inline2.default);

Script.blotName = 'script';
Script.tagName = ['SUB', 'SUP'];

exports.default = Script;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inline = __webpack_require__(6);

var _inline2 = _interopRequireDefault(_inline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Strike = function (_Inline) {
  _inherits(Strike, _Inline);

  function Strike() {
    _classCallCheck(this, Strike);

    return _possibleConstructorReturn(this, (Strike.__proto__ || Object.getPrototypeOf(Strike)).apply(this, arguments));
  }

  return Strike;
}(_inline2.default);

Strike.blotName = 'strike';
Strike.tagName = 'S';

exports.default = Strike;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inline = __webpack_require__(6);

var _inline2 = _interopRequireDefault(_inline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Underline = function (_Inline) {
  _inherits(Underline, _Inline);

  function Underline() {
    _classCallCheck(this, Underline);

    return _possibleConstructorReturn(this, (Underline.__proto__ || Object.getPrototypeOf(Underline)).apply(this, arguments));
  }

  return Underline;
}(_inline2.default);

Underline.blotName = 'underline';
Underline.tagName = 'U';

exports.default = Underline;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _link = __webpack_require__(27);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ATTRIBUTES = ['alt', 'height', 'width'];

var Image = function (_Parchment$Embed) {
  _inherits(Image, _Parchment$Embed);

  function Image() {
    _classCallCheck(this, Image);

    return _possibleConstructorReturn(this, (Image.__proto__ || Object.getPrototypeOf(Image)).apply(this, arguments));
  }

  _createClass(Image, [{
    key: 'format',
    value: function format(name, value) {
      if (ATTRIBUTES.indexOf(name) > -1) {
        if (value) {
          this.domNode.setAttribute(name, value);
        } else {
          this.domNode.removeAttribute(name);
        }
      } else {
        _get(Image.prototype.__proto__ || Object.getPrototypeOf(Image.prototype), 'format', this).call(this, name, value);
      }
    }
  }], [{
    key: 'create',
    value: function create(value) {
      var node = _get(Image.__proto__ || Object.getPrototypeOf(Image), 'create', this).call(this, value);
      if (typeof value === 'string') {
        node.setAttribute('src', this.sanitize(value));
      }
      return node;
    }
  }, {
    key: 'formats',
    value: function formats(domNode) {
      return ATTRIBUTES.reduce(function (formats, attribute) {
        if (domNode.hasAttribute(attribute)) {
          formats[attribute] = domNode.getAttribute(attribute);
        }
        return formats;
      }, {});
    }
  }, {
    key: 'match',
    value: function match(url) {
      return (/\.(jpe?g|gif|png)$/.test(url) || /^data:image\/.+;base64/.test(url)
      );
    }
  }, {
    key: 'sanitize',
    value: function sanitize(url) {
      return (0, _link.sanitize)(url, ['http', 'https', 'data']) ? url : '//:0';
    }
  }, {
    key: 'value',
    value: function value(domNode) {
      return domNode.getAttribute('src');
    }
  }]);

  return Image;
}(_parchment2.default.Embed);

Image.blotName = 'image';
Image.tagName = 'IMG';

exports.default = Image;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _block = __webpack_require__(4);

var _link = __webpack_require__(27);

var _link2 = _interopRequireDefault(_link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ATTRIBUTES = ['height', 'width'];

var Video = function (_BlockEmbed) {
  _inherits(Video, _BlockEmbed);

  function Video() {
    _classCallCheck(this, Video);

    return _possibleConstructorReturn(this, (Video.__proto__ || Object.getPrototypeOf(Video)).apply(this, arguments));
  }

  _createClass(Video, [{
    key: 'format',
    value: function format(name, value) {
      if (ATTRIBUTES.indexOf(name) > -1) {
        if (value) {
          this.domNode.setAttribute(name, value);
        } else {
          this.domNode.removeAttribute(name);
        }
      } else {
        _get(Video.prototype.__proto__ || Object.getPrototypeOf(Video.prototype), 'format', this).call(this, name, value);
      }
    }
  }], [{
    key: 'create',
    value: function create(value) {
      var node = _get(Video.__proto__ || Object.getPrototypeOf(Video), 'create', this).call(this, value);
      node.setAttribute('frameborder', '0');
      node.setAttribute('allowfullscreen', true);
      node.setAttribute('src', this.sanitize(value));
      return node;
    }
  }, {
    key: 'formats',
    value: function formats(domNode) {
      return ATTRIBUTES.reduce(function (formats, attribute) {
        if (domNode.hasAttribute(attribute)) {
          formats[attribute] = domNode.getAttribute(attribute);
        }
        return formats;
      }, {});
    }
  }, {
    key: 'sanitize',
    value: function sanitize(url) {
      return _link2.default.sanitize(url);
    }
  }, {
    key: 'value',
    value: function value(domNode) {
      return domNode.getAttribute('src');
    }
  }]);

  return Video;
}(_block.BlockEmbed);

Video.blotName = 'video';
Video.className = 'ql-video';
Video.tagName = 'IFRAME';

exports.default = Video;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FormulaBlot = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _embed = __webpack_require__(35);

var _embed2 = _interopRequireDefault(_embed);

var _quill = __webpack_require__(5);

var _quill2 = _interopRequireDefault(_quill);

var _module = __webpack_require__(9);

var _module2 = _interopRequireDefault(_module);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FormulaBlot = function (_Embed) {
  _inherits(FormulaBlot, _Embed);

  function FormulaBlot() {
    _classCallCheck(this, FormulaBlot);

    return _possibleConstructorReturn(this, (FormulaBlot.__proto__ || Object.getPrototypeOf(FormulaBlot)).apply(this, arguments));
  }

  _createClass(FormulaBlot, null, [{
    key: 'create',
    value: function create(value) {
      var node = _get(FormulaBlot.__proto__ || Object.getPrototypeOf(FormulaBlot), 'create', this).call(this, value);
      if (typeof value === 'string') {
        window.katex.render(value, node, {
          throwOnError: false,
          errorColor: '#f00'
        });
        node.setAttribute('data-value', value);
      }
      return node;
    }
  }, {
    key: 'value',
    value: function value(domNode) {
      return domNode.getAttribute('data-value');
    }
  }]);

  return FormulaBlot;
}(_embed2.default);

FormulaBlot.blotName = 'formula';
FormulaBlot.className = 'ql-formula';
FormulaBlot.tagName = 'SPAN';

var Formula = function (_Module) {
  _inherits(Formula, _Module);

  _createClass(Formula, null, [{
    key: 'register',
    value: function register() {
      _quill2.default.register(FormulaBlot, true);
    }
  }]);

  function Formula() {
    _classCallCheck(this, Formula);

    var _this2 = _possibleConstructorReturn(this, (Formula.__proto__ || Object.getPrototypeOf(Formula)).call(this));

    if (window.katex == null) {
      throw new Error('Formula module requires KaTeX.');
    }
    return _this2;
  }

  return Formula;
}(_module2.default);

exports.FormulaBlot = FormulaBlot;
exports.default = Formula;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CodeToken = exports.CodeBlock = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _quill = __webpack_require__(5);

var _quill2 = _interopRequireDefault(_quill);

var _module = __webpack_require__(9);

var _module2 = _interopRequireDefault(_module);

var _code = __webpack_require__(13);

var _code2 = _interopRequireDefault(_code);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SyntaxCodeBlock = function (_CodeBlock) {
  _inherits(SyntaxCodeBlock, _CodeBlock);

  function SyntaxCodeBlock() {
    _classCallCheck(this, SyntaxCodeBlock);

    return _possibleConstructorReturn(this, (SyntaxCodeBlock.__proto__ || Object.getPrototypeOf(SyntaxCodeBlock)).apply(this, arguments));
  }

  _createClass(SyntaxCodeBlock, [{
    key: 'replaceWith',
    value: function replaceWith(block) {
      this.domNode.textContent = this.domNode.textContent;
      this.attach();
      _get(SyntaxCodeBlock.prototype.__proto__ || Object.getPrototypeOf(SyntaxCodeBlock.prototype), 'replaceWith', this).call(this, block);
    }
  }, {
    key: 'highlight',
    value: function highlight(_highlight) {
      var text = this.domNode.textContent;
      if (this.cachedText !== text) {
        if (text.trim().length > 0 || this.cachedText == null) {
          this.domNode.innerHTML = _highlight(text);
          this.domNode.normalize();
          this.attach();
        }
        this.cachedText = text;
      }
    }
  }]);

  return SyntaxCodeBlock;
}(_code2.default);

SyntaxCodeBlock.className = 'ql-syntax';

var CodeToken = new _parchment2.default.Attributor.Class('token', 'hljs', {
  scope: _parchment2.default.Scope.INLINE
});

var Syntax = function (_Module) {
  _inherits(Syntax, _Module);

  _createClass(Syntax, null, [{
    key: 'register',
    value: function register() {
      _quill2.default.register(CodeToken, true);
      _quill2.default.register(SyntaxCodeBlock, true);
    }
  }]);

  function Syntax(quill, options) {
    _classCallCheck(this, Syntax);

    var _this2 = _possibleConstructorReturn(this, (Syntax.__proto__ || Object.getPrototypeOf(Syntax)).call(this, quill, options));

    if (typeof _this2.options.highlight !== 'function') {
      throw new Error('Syntax module requires highlight.js. Please include the library on the page before Quill.');
    }
    var timer = null;
    _this2.quill.on(_quill2.default.events.SCROLL_OPTIMIZE, function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        _this2.highlight();
        timer = null;
      }, _this2.options.interval);
    });
    _this2.highlight();
    return _this2;
  }

  _createClass(Syntax, [{
    key: 'highlight',
    value: function highlight() {
      var _this3 = this;

      if (this.quill.selection.composing) return;
      this.quill.update(_quill2.default.sources.USER);
      var range = this.quill.getSelection();
      this.quill.scroll.descendants(SyntaxCodeBlock).forEach(function (code) {
        code.highlight(_this3.options.highlight);
      });
      this.quill.update(_quill2.default.sources.SILENT);
      if (range != null) {
        this.quill.setSelection(range, _quill2.default.sources.SILENT);
      }
    }
  }]);

  return Syntax;
}(_module2.default);

Syntax.DEFAULTS = {
  highlight: function () {
    if (window.hljs == null) return null;
    return function (text) {
      var result = window.hljs.highlightAuto(text);
      return result.value;
    };
  }(),
  interval: 1000
};

exports.CodeBlock = SyntaxCodeBlock;
exports.CodeToken = CodeToken;
exports.default = Syntax;

/***/ }),
/* 76 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=13 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=9 y1=4 y2=4></line> </svg>";

/***/ }),
/* 77 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=14 x2=4 y1=14 y2=14></line> <line class=ql-stroke x1=12 x2=6 y1=4 y2=4></line> </svg>";

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=5 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=9 y1=4 y2=4></line> </svg>";

/***/ }),
/* 79 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=3 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=3 y1=4 y2=4></line> </svg>";

/***/ }),
/* 80 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <g class=\"ql-fill ql-color-label\"> <polygon points=\"6 6.868 6 6 5 6 5 7 5.942 7 6 6.868\"></polygon> <rect height=1 width=1 x=4 y=4></rect> <polygon points=\"6.817 5 6 5 6 6 6.38 6 6.817 5\"></polygon> <rect height=1 width=1 x=2 y=6></rect> <rect height=1 width=1 x=3 y=5></rect> <rect height=1 width=1 x=4 y=7></rect> <polygon points=\"4 11.439 4 11 3 11 3 12 3.755 12 4 11.439\"></polygon> <rect height=1 width=1 x=2 y=12></rect> <rect height=1 width=1 x=2 y=9></rect> <rect height=1 width=1 x=2 y=15></rect> <polygon points=\"4.63 10 4 10 4 11 4.192 11 4.63 10\"></polygon> <rect height=1 width=1 x=3 y=8></rect> <path d=M10.832,4.2L11,4.582V4H10.708A1.948,1.948,0,0,1,10.832,4.2Z></path> <path d=M7,4.582L7.168,4.2A1.929,1.929,0,0,1,7.292,4H7V4.582Z></path> <path d=M8,13H7.683l-0.351.8a1.933,1.933,0,0,1-.124.2H8V13Z></path> <rect height=1 width=1 x=12 y=2></rect> <rect height=1 width=1 x=11 y=3></rect> <path d=M9,3H8V3.282A1.985,1.985,0,0,1,9,3Z></path> <rect height=1 width=1 x=2 y=3></rect> <rect height=1 width=1 x=6 y=2></rect> <rect height=1 width=1 x=3 y=2></rect> <rect height=1 width=1 x=5 y=3></rect> <rect height=1 width=1 x=9 y=2></rect> <rect height=1 width=1 x=15 y=14></rect> <polygon points=\"13.447 10.174 13.469 10.225 13.472 10.232 13.808 11 14 11 14 10 13.37 10 13.447 10.174\"></polygon> <rect height=1 width=1 x=13 y=7></rect> <rect height=1 width=1 x=15 y=5></rect> <rect height=1 width=1 x=14 y=6></rect> <rect height=1 width=1 x=15 y=8></rect> <rect height=1 width=1 x=14 y=9></rect> <path d=M3.775,14H3v1H4V14.314A1.97,1.97,0,0,1,3.775,14Z></path> <rect height=1 width=1 x=14 y=3></rect> <polygon points=\"12 6.868 12 6 11.62 6 12 6.868\"></polygon> <rect height=1 width=1 x=15 y=2></rect> <rect height=1 width=1 x=12 y=5></rect> <rect height=1 width=1 x=13 y=4></rect> <polygon points=\"12.933 9 13 9 13 8 12.495 8 12.933 9\"></polygon> <rect height=1 width=1 x=9 y=14></rect> <rect height=1 width=1 x=8 y=15></rect> <path d=M6,14.926V15H7V14.316A1.993,1.993,0,0,1,6,14.926Z></path> <rect height=1 width=1 x=5 y=15></rect> <path d=M10.668,13.8L10.317,13H10v1h0.792A1.947,1.947,0,0,1,10.668,13.8Z></path> <rect height=1 width=1 x=11 y=15></rect> <path d=M14.332,12.2a1.99,1.99,0,0,1,.166.8H15V12H14.245Z></path> <rect height=1 width=1 x=14 y=15></rect> <rect height=1 width=1 x=15 y=11></rect> </g> <polyline class=ql-stroke points=\"5.5 13 9 5 12.5 13\"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=11 y2=11></line> </svg>";

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=\"ql-fill ql-stroke\" height=3 width=3 x=4 y=5></rect> <rect class=\"ql-fill ql-stroke\" height=3 width=3 x=11 y=5></rect> <path class=\"ql-even ql-fill ql-stroke\" d=M7,8c0,4.031-3,5-3,5></path> <path class=\"ql-even ql-fill ql-stroke\" d=M14,8c0,4.031-3,5-3,5></path> </svg>";

/***/ }),
/* 82 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-stroke d=M5,4H9.5A2.5,2.5,0,0,1,12,6.5v0A2.5,2.5,0,0,1,9.5,9H5A0,0,0,0,1,5,9V4A0,0,0,0,1,5,4Z></path> <path class=ql-stroke d=M5,9h5.5A2.5,2.5,0,0,1,13,11.5v0A2.5,2.5,0,0,1,10.5,14H5a0,0,0,0,1,0,0V9A0,0,0,0,1,5,9Z></path> </svg>";

/***/ }),
/* 83 */
/***/ (function(module, exports) {

module.exports = "<svg class=\"\" viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=5 x2=13 y1=3 y2=3></line> <line class=ql-stroke x1=6 x2=9.35 y1=12 y2=3></line> <line class=ql-stroke x1=11 x2=15 y1=11 y2=15></line> <line class=ql-stroke x1=15 x2=11 y1=11 y2=15></line> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=7 x=2 y=14></rect> </svg>";

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=\"ql-color-label ql-stroke ql-transparent\" x1=3 x2=15 y1=15 y2=15></line> <polyline class=ql-stroke points=\"5.5 11 9 3 12.5 11\"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=9 y2=9></line> </svg>";

/***/ }),
/* 85 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=\"ql-stroke ql-fill\" points=\"3 11 5 9 3 7 3 11\"></polygon> <line class=\"ql-stroke ql-fill\" x1=15 x2=11 y1=4 y2=4></line> <path class=ql-fill d=M11,3a3,3,0,0,0,0,6h1V3H11Z></path> <rect class=ql-fill height=11 width=1 x=11 y=4></rect> <rect class=ql-fill height=11 width=1 x=13 y=4></rect> </svg>";

/***/ }),
/* 86 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=\"ql-stroke ql-fill\" points=\"15 12 13 10 15 8 15 12\"></polygon> <line class=\"ql-stroke ql-fill\" x1=9 x2=5 y1=4 y2=4></line> <path class=ql-fill d=M5,3A3,3,0,0,0,5,9H6V3H5Z></path> <rect class=ql-fill height=11 width=1 x=5 y=4></rect> <rect class=ql-fill height=11 width=1 x=7 y=4></rect> </svg>";

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M14,16H4a1,1,0,0,1,0-2H14A1,1,0,0,1,14,16Z /> <path class=ql-fill d=M14,4H4A1,1,0,0,1,4,2H14A1,1,0,0,1,14,4Z /> <rect class=ql-fill x=3 y=6 width=12 height=6 rx=1 ry=1 /> </svg>";

/***/ }),
/* 88 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M13,16H5a1,1,0,0,1,0-2h8A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H5A1,1,0,0,1,5,2h8A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=2 y=6 width=14 height=6 rx=1 ry=1 /> </svg>";

/***/ }),
/* 89 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15,8H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,8Z /> <path class=ql-fill d=M15,12H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,12Z /> <path class=ql-fill d=M15,16H5a1,1,0,0,1,0-2H15A1,1,0,0,1,15,16Z /> <path class=ql-fill d=M15,4H5A1,1,0,0,1,5,2H15A1,1,0,0,1,15,4Z /> <rect class=ql-fill x=2 y=6 width=8 height=6 rx=1 ry=1 /> </svg>";

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M5,8H3A1,1,0,0,1,3,6H5A1,1,0,0,1,5,8Z /> <path class=ql-fill d=M5,12H3a1,1,0,0,1,0-2H5A1,1,0,0,1,5,12Z /> <path class=ql-fill d=M13,16H3a1,1,0,0,1,0-2H13A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H3A1,1,0,0,1,3,2H13A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=8 y=6 width=8 height=6 rx=1 ry=1 transform=\"translate(24 18) rotate(-180)\"/> </svg>";

/***/ }),
/* 91 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M11.759,2.482a2.561,2.561,0,0,0-3.53.607A7.656,7.656,0,0,0,6.8,6.2C6.109,9.188,5.275,14.677,4.15,14.927a1.545,1.545,0,0,0-1.3-.933A0.922,0.922,0,0,0,2,15.036S1.954,16,4.119,16s3.091-2.691,3.7-5.553c0.177-.826.36-1.726,0.554-2.6L8.775,6.2c0.381-1.421.807-2.521,1.306-2.676a1.014,1.014,0,0,0,1.02.56A0.966,0.966,0,0,0,11.759,2.482Z></path> <rect class=ql-fill height=1.6 rx=0.8 ry=0.8 width=5 x=5.15 y=6.2></rect> <path class=ql-fill d=M13.663,12.027a1.662,1.662,0,0,1,.266-0.276q0.193,0.069.456,0.138a2.1,2.1,0,0,0,.535.069,1.075,1.075,0,0,0,.767-0.3,1.044,1.044,0,0,0,.314-0.8,0.84,0.84,0,0,0-.238-0.619,0.8,0.8,0,0,0-.594-0.239,1.154,1.154,0,0,0-.781.3,4.607,4.607,0,0,0-.781,1q-0.091.15-.218,0.346l-0.246.38c-0.068-.288-0.137-0.582-0.212-0.885-0.459-1.847-2.494-.984-2.941-0.8-0.482.2-.353,0.647-0.094,0.529a0.869,0.869,0,0,1,1.281.585c0.217,0.751.377,1.436,0.527,2.038a5.688,5.688,0,0,1-.362.467,2.69,2.69,0,0,1-.264.271q-0.221-.08-0.471-0.147a2.029,2.029,0,0,0-.522-0.066,1.079,1.079,0,0,0-.768.3A1.058,1.058,0,0,0,9,15.131a0.82,0.82,0,0,0,.832.852,1.134,1.134,0,0,0,.787-0.3,5.11,5.11,0,0,0,.776-0.993q0.141-.219.215-0.34c0.046-.076.122-0.194,0.223-0.346a2.786,2.786,0,0,0,.918,1.726,2.582,2.582,0,0,0,2.376-.185c0.317-.181.212-0.565,0-0.494A0.807,0.807,0,0,1,14.176,15a5.159,5.159,0,0,1-.913-2.446l0,0Q13.487,12.24,13.663,12.027Z></path> </svg>";

/***/ }),
/* 92 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 18 18\"> <path class=ql-fill d=M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm6.06787,9.209H14.98975V7.59863a.54085.54085,0,0,0-.605-.60547h-.62744a1.01119,1.01119,0,0,0-.748.29688L11.645,8.56641a.5435.5435,0,0,0-.022.8584l.28613.30762a.53861.53861,0,0,0,.84717.0332l.09912-.08789a1.2137,1.2137,0,0,0,.2417-.35254h.02246s-.01123.30859-.01123.60547V13.209H12.041a.54085.54085,0,0,0-.605.60547v.43945a.54085.54085,0,0,0,.605.60547h4.02686a.54085.54085,0,0,0,.605-.60547v-.43945A.54085.54085,0,0,0,16.06787,13.209Z /> </svg>";

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 18 18\"> <path class=ql-fill d=M16.73975,13.81445v.43945a.54085.54085,0,0,1-.605.60547H11.855a.58392.58392,0,0,1-.64893-.60547V14.0127c0-2.90527,3.39941-3.42187,3.39941-4.55469a.77675.77675,0,0,0-.84717-.78125,1.17684,1.17684,0,0,0-.83594.38477c-.2749.26367-.561.374-.85791.13184l-.4292-.34082c-.30811-.24219-.38525-.51758-.1543-.81445a2.97155,2.97155,0,0,1,2.45361-1.17676,2.45393,2.45393,0,0,1,2.68408,2.40918c0,2.45312-3.1792,2.92676-3.27832,3.93848h2.79443A.54085.54085,0,0,1,16.73975,13.81445ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z /> </svg>";

/***/ }),
/* 94 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=13 y1=4 y2=4></line> <line class=ql-stroke x1=5 x2=11 y1=14 y2=14></line> <line class=ql-stroke x1=8 x2=10 y1=14 y2=4></line> </svg>";

/***/ }),
/* 95 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=ql-stroke height=10 width=12 x=3 y=4></rect> <circle class=ql-fill cx=6 cy=7 r=1></circle> <polyline class=\"ql-even ql-fill\" points=\"5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12\"></polyline> </svg>";

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=\"ql-fill ql-stroke\" points=\"3 7 3 11 5 9 3 7\"></polyline> </svg>";

/***/ }),
/* 97 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points=\"5 7 5 11 3 9 5 7\"></polyline> </svg>";

/***/ }),
/* 98 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=11 y1=7 y2=11></line> <path class=\"ql-even ql-stroke\" d=M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z></path> <path class=\"ql-even ql-stroke\" d=M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z></path> </svg>";

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=7 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=7 x2=15 y1=14 y2=14></line> <line class=\"ql-stroke ql-thin\" x1=2.5 x2=4.5 y1=5.5 y2=5.5></line> <path class=ql-fill d=M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z></path> <path class=\"ql-stroke ql-thin\" d=M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156></path> <path class=\"ql-stroke ql-thin\" d=M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109></path> </svg>";

/***/ }),
/* 100 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=6 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=6 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=6 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=3 y1=4 y2=4></line> <line class=ql-stroke x1=3 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=3 y1=14 y2=14></line> </svg>";

/***/ }),
/* 101 */
/***/ (function(module, exports) {

module.exports = "<svg class=\"\" viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=9 x2=15 y1=4 y2=4></line> <polyline class=ql-stroke points=\"3 4 4 5 6 3\"></polyline> <line class=ql-stroke x1=9 x2=15 y1=14 y2=14></line> <polyline class=ql-stroke points=\"3 14 4 15 6 13\"></polyline> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points=\"3 9 4 10 6 8\"></polyline> </svg>";

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15.5,15H13.861a3.858,3.858,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.921,1.921,0,0,0,12.021,11.7a0.50013,0.50013,0,1,0,.957.291h0a0.914,0.914,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.076-1.16971,1.86982-1.93971,2.43082A1.45639,1.45639,0,0,0,12,15.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,15Z /> <path class=ql-fill d=M9.65,5.241a1,1,0,0,0-1.409.108L6,7.964,3.759,5.349A1,1,0,0,0,2.192,6.59178Q2.21541,6.6213,2.241,6.649L4.684,9.5,2.241,12.35A1,1,0,0,0,3.71,13.70722q0.02557-.02768.049-0.05722L6,11.036,8.241,13.65a1,1,0,1,0,1.567-1.24277Q9.78459,12.3777,9.759,12.35L7.316,9.5,9.759,6.651A1,1,0,0,0,9.65,5.241Z /> </svg>";

/***/ }),
/* 103 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15.5,7H13.861a4.015,4.015,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.922,1.922,0,0,0,12.021,3.7a0.5,0.5,0,1,0,.957.291,0.917,0.917,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.077-1.164,1.925-1.934,2.486A1.423,1.423,0,0,0,12,7.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,7Z /> <path class=ql-fill d=M9.651,5.241a1,1,0,0,0-1.41.108L6,7.964,3.759,5.349a1,1,0,1,0-1.519,1.3L4.683,9.5,2.241,12.35a1,1,0,1,0,1.519,1.3L6,11.036,8.241,13.65a1,1,0,0,0,1.519-1.3L7.317,9.5,9.759,6.651A1,1,0,0,0,9.651,5.241Z /> </svg>";

/***/ }),
/* 104 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=\"ql-stroke ql-thin\" x1=15.5 x2=2.5 y1=8.5 y2=9.5></line> <path class=ql-fill d=M9.007,8C6.542,7.791,6,7.519,6,6.5,6,5.792,7.283,5,9,5c1.571,0,2.765.679,2.969,1.309a1,1,0,0,0,1.9-.617C13.356,4.106,11.354,3,9,3,6.2,3,4,4.538,4,6.5a3.2,3.2,0,0,0,.5,1.843Z></path> <path class=ql-fill d=M8.984,10C11.457,10.208,12,10.479,12,11.5c0,0.708-1.283,1.5-3,1.5-1.571,0-2.765-.679-2.969-1.309a1,1,0,1,0-1.9.617C4.644,13.894,6.646,15,9,15c2.8,0,5-1.538,5-3.5a3.2,3.2,0,0,0-.5-1.843Z></path> </svg>";

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-stroke d=M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3></path> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=12 x=3 y=15></rect> </svg>";

/***/ }),
/* 106 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=ql-stroke height=12 width=12 x=3 y=3></rect> <rect class=ql-fill height=12 width=1 x=5 y=3></rect> <rect class=ql-fill height=12 width=1 x=12 y=3></rect> <rect class=ql-fill height=2 width=8 x=5 y=8></rect> <rect class=ql-fill height=1 width=3 x=3 y=5></rect> <rect class=ql-fill height=1 width=3 x=3 y=7></rect> <rect class=ql-fill height=1 width=3 x=3 y=10></rect> <rect class=ql-fill height=1 width=3 x=3 y=12></rect> <rect class=ql-fill height=1 width=3 x=12 y=5></rect> <rect class=ql-fill height=1 width=3 x=12 y=7></rect> <rect class=ql-fill height=1 width=3 x=12 y=10></rect> <rect class=ql-fill height=1 width=3 x=12 y=12></rect> </svg>";

/***/ }),
/* 107 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=ql-stroke points=\"7 11 9 13 11 11 7 11\"></polygon> <polygon class=ql-stroke points=\"7 7 9 5 11 7 7 7\"></polygon> </svg>";

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BubbleTooltip = undefined;

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extend = __webpack_require__(3);

var _extend2 = _interopRequireDefault(_extend);

var _emitter = __webpack_require__(8);

var _emitter2 = _interopRequireDefault(_emitter);

var _base = __webpack_require__(43);

var _base2 = _interopRequireDefault(_base);

var _selection = __webpack_require__(15);

var _icons = __webpack_require__(41);

var _icons2 = _interopRequireDefault(_icons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TOOLBAR_CONFIG = [['bold', 'italic', 'link'], [{ header: 1 }, { header: 2 }, 'blockquote']];

var BubbleTheme = function (_BaseTheme) {
  _inherits(BubbleTheme, _BaseTheme);

  function BubbleTheme(quill, options) {
    _classCallCheck(this, BubbleTheme);

    if (options.modules.toolbar != null && options.modules.toolbar.container == null) {
      options.modules.toolbar.container = TOOLBAR_CONFIG;
    }

    var _this = _possibleConstructorReturn(this, (BubbleTheme.__proto__ || Object.getPrototypeOf(BubbleTheme)).call(this, quill, options));

    _this.quill.container.classList.add('ql-bubble');
    return _this;
  }

  _createClass(BubbleTheme, [{
    key: 'extendToolbar',
    value: function extendToolbar(toolbar) {
      this.tooltip = new BubbleTooltip(this.quill, this.options.bounds);
      this.tooltip.root.appendChild(toolbar.container);
      this.buildButtons([].slice.call(toolbar.container.querySelectorAll('button')), _icons2.default);
      this.buildPickers([].slice.call(toolbar.container.querySelectorAll('select')), _icons2.default);
    }
  }]);

  return BubbleTheme;
}(_base2.default);

BubbleTheme.DEFAULTS = (0, _extend2.default)(true, {}, _base2.default.DEFAULTS, {
  modules: {
    toolbar: {
      handlers: {
        link: function link(value) {
          if (!value) {
            this.quill.format('link', false);
          } else {
            this.quill.theme.tooltip.edit();
          }
        }
      }
    }
  }
});

var BubbleTooltip = function (_BaseTooltip) {
  _inherits(BubbleTooltip, _BaseTooltip);

  function BubbleTooltip(quill, bounds) {
    _classCallCheck(this, BubbleTooltip);

    var _this2 = _possibleConstructorReturn(this, (BubbleTooltip.__proto__ || Object.getPrototypeOf(BubbleTooltip)).call(this, quill, bounds));

    _this2.quill.on(_emitter2.default.events.EDITOR_CHANGE, function (type, range, oldRange, source) {
      if (type !== _emitter2.default.events.SELECTION_CHANGE) return;
      if (range != null && range.length > 0 && source === _emitter2.default.sources.USER) {
        _this2.show();
        // Lock our width so we will expand beyond our offsetParent boundaries
        _this2.root.style.left = '0px';
        _this2.root.style.width = '';
        _this2.root.style.width = _this2.root.offsetWidth + 'px';
        var lines = _this2.quill.getLines(range.index, range.length);
        if (lines.length === 1) {
          _this2.position(_this2.quill.getBounds(range));
        } else {
          var lastLine = lines[lines.length - 1];
          var index = _this2.quill.getIndex(lastLine);
          var length = Math.min(lastLine.length() - 1, range.index + range.length - index);
          var _bounds = _this2.quill.getBounds(new _selection.Range(index, length));
          _this2.position(_bounds);
        }
      } else if (document.activeElement !== _this2.textbox && _this2.quill.hasFocus()) {
        _this2.hide();
      }
    });
    return _this2;
  }

  _createClass(BubbleTooltip, [{
    key: 'listen',
    value: function listen() {
      var _this3 = this;

      _get(BubbleTooltip.prototype.__proto__ || Object.getPrototypeOf(BubbleTooltip.prototype), 'listen', this).call(this);
      this.root.querySelector('.ql-close').addEventListener('click', function () {
        _this3.root.classList.remove('ql-editing');
      });
      this.quill.on(_emitter2.default.events.SCROLL_OPTIMIZE, function () {
        // Let selection be restored by toolbar handlers before repositioning
        setTimeout(function () {
          if (_this3.root.classList.contains('ql-hidden')) return;
          var range = _this3.quill.getSelection();
          if (range != null) {
            _this3.position(_this3.quill.getBounds(range));
          }
        }, 1);
      });
    }
  }, {
    key: 'cancel',
    value: function cancel() {
      this.show();
    }
  }, {
    key: 'position',
    value: function position(reference) {
      var shift = _get(BubbleTooltip.prototype.__proto__ || Object.getPrototypeOf(BubbleTooltip.prototype), 'position', this).call(this, reference);
      var arrow = this.root.querySelector('.ql-tooltip-arrow');
      arrow.style.marginLeft = '';
      if (shift === 0) return shift;
      arrow.style.marginLeft = -1 * shift - arrow.offsetWidth / 2 + 'px';
    }
  }]);

  return BubbleTooltip;
}(_base.BaseTooltip);

BubbleTooltip.TEMPLATE = ['<span class="ql-tooltip-arrow"></span>', '<div class="ql-tooltip-editor">', '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">', '<a class="ql-close"></a>', '</div>'].join('');

exports.BubbleTooltip = BubbleTooltip;
exports.default = BubbleTheme;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(63);


/***/ })
/******/ ])["default"];
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/buffer/index.js").Buffer))

/***/ }),

/***/ "./node_modules/readable-stream/duplex-browser.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("./node_modules/readable-stream/lib/_stream_duplex.js");


/***/ }),

/***/ "./node_modules/readable-stream/lib/_stream_duplex.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.



/*<replacement>*/

var pna = __webpack_require__("./node_modules/process-nextick-args/index.js");
/*</replacement>*/

/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    keys.push(key);
  }return keys;
};
/*</replacement>*/

module.exports = Duplex;

/*<replacement>*/
var util = __webpack_require__("./node_modules/core-util-is/lib/util.js");
util.inherits = __webpack_require__("./node_modules/inherits/inherits_browser.js");
/*</replacement>*/

var Readable = __webpack_require__("./node_modules/readable-stream/lib/_stream_readable.js");
var Writable = __webpack_require__("./node_modules/readable-stream/lib/_stream_writable.js");

util.inherits(Duplex, Readable);

{
  // avoid scope creep, the keys array can then be collected
  var keys = objectKeys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}

function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);

  Readable.call(this, options);
  Writable.call(this, options);

  if (options && options.readable === false) this.readable = false;

  if (options && options.writable === false) this.writable = false;

  this.allowHalfOpen = true;
  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

  this.once('end', onend);
}

Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// the no-half-open enforcer
function onend() {
  // if we allow half-open state, or if the writable side ended,
  // then we're ok.
  if (this.allowHalfOpen || this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  pna.nextTick(onEndNT, this);
}

function onEndNT(self) {
  self.end();
}

Object.defineProperty(Duplex.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});

Duplex.prototype._destroy = function (err, cb) {
  this.push(null);
  this.end();

  pna.nextTick(cb, err);
};

/***/ }),

/***/ "./node_modules/readable-stream/lib/_stream_passthrough.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.



module.exports = PassThrough;

var Transform = __webpack_require__("./node_modules/readable-stream/lib/_stream_transform.js");

/*<replacement>*/
var util = __webpack_require__("./node_modules/core-util-is/lib/util.js");
util.inherits = __webpack_require__("./node_modules/inherits/inherits_browser.js");
/*</replacement>*/

util.inherits(PassThrough, Transform);

function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);

  Transform.call(this, options);
}

PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};

/***/ }),

/***/ "./node_modules/readable-stream/lib/_stream_readable.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var pna = __webpack_require__("./node_modules/process-nextick-args/index.js");
/*</replacement>*/

module.exports = Readable;

/*<replacement>*/
var isArray = __webpack_require__("./node_modules/isarray/index.js");
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = __webpack_require__("./node_modules/events/events.js").EventEmitter;

var EElistenerCount = function (emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__("./node_modules/readable-stream/lib/internal/streams/stream-browser.js");
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__("./node_modules/safe-buffer/index.js").Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

/*<replacement>*/
var util = __webpack_require__("./node_modules/core-util-is/lib/util.js");
util.inherits = __webpack_require__("./node_modules/inherits/inherits_browser.js");
/*</replacement>*/

/*<replacement>*/
var debugUtil = __webpack_require__(1);
var debug = void 0;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function () {};
}
/*</replacement>*/

var BufferList = __webpack_require__("./node_modules/readable-stream/lib/internal/streams/BufferList.js");
var destroyImpl = __webpack_require__("./node_modules/readable-stream/lib/internal/streams/destroy.js");
var StringDecoder;

util.inherits(Readable, Stream);

var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}

function ReadableState(options, stream) {
  Duplex = Duplex || __webpack_require__("./node_modules/readable-stream/lib/_stream_duplex.js");

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  var hwm = options.highWaterMark;
  var readableHwm = options.readableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;

  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = __webpack_require__("./node_modules/string_decoder/lib/string_decoder.js").StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

function Readable(options) {
  Duplex = Duplex || __webpack_require__("./node_modules/readable-stream/lib/_stream_duplex.js");

  if (!(this instanceof Readable)) return new Readable(options);

  this._readableState = new ReadableState(options, this);

  // legacy
  this.readable = true;

  if (options) {
    if (typeof options.read === 'function') this._read = options.read;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }

  Stream.call(this);
}

Object.defineProperty(Readable.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});

Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  this.push(null);
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;

  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }

  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};

function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      stream.emit('error', er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }

      if (addToFront) {
        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        stream.emit('error', new Error('stream.push() after EOF'));
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
    }
  }

  return needMoreData(state);
}

function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    stream.emit('data', chunk);
    stream.read(0);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}

function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  return er;
}

// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}

Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = __webpack_require__("./node_modules/string_decoder/lib/string_decoder.js").StringDecoder;
  this._readableState.decoder = new StringDecoder(enc);
  this._readableState.encoding = enc;
  return this;
};

// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;

  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }

  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;

  if (ret === null) {
    state.needReadable = true;
    n = 0;
  } else {
    state.length -= n;
  }

  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }

  if (ret !== null) this.emit('data', ret);

  return ret;
};

function onEofChunk(stream, state) {
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;

  // emit 'readable' now to make sure it gets picked up.
  emitReadable(stream);
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
  }
}

function emitReadable_(stream) {
  debug('emit readable');
  stream.emit('readable');
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    pna.nextTick(maybeReadMore_, stream, state);
  }
}

function maybeReadMore_(stream, state) {
  var len = state.length;
  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;else len = state.length;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  this.emit('error', new Error('_read() is not implemented'));
};

Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;

  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);

  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);

  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);

    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }

  // If the user pushes more data while we're writing to dest then we'll end up
  // in ondata again. However, we only want to increase awaitDrain once because
  // dest will only emit one 'drain' event for the multiple writes.
  // => Introduce a guard on increasing awaitDrain.
  var increasedAwaitDrain = false;
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    increasedAwaitDrain = false;
    var ret = dest.write(chunk);
    if (false === ret && !increasedAwaitDrain) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', src._readableState.awaitDrain);
        src._readableState.awaitDrain++;
        increasedAwaitDrain = true;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function () {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}

Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = { hasUnpiped: false };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;

    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var i = 0; i < len; i++) {
      dests[i].emit('unpipe', this, unpipeInfo);
    }return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;

  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];

  dest.emit('unpipe', this, unpipeInfo);

  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);

  if (ev === 'data') {
    // Start flowing on next tick if stream isn't explicitly paused
    if (this._readableState.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    var state = this._readableState;
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.emittedReadable = false;
      if (!state.reading) {
        pna.nextTick(nReadingNextTick, this);
      } else if (state.length) {
        emitReadable(this);
      }
    }
  }

  return res;
};
Readable.prototype.addListener = Readable.prototype.on;

function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    state.flowing = true;
    resume(this, state);
  }
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    pna.nextTick(resume_, stream, state);
  }
}

function resume_(stream, state) {
  if (!state.reading) {
    debug('resume read 0');
    stream.read(0);
  }

  state.resumeScheduled = false;
  state.awaitDrain = 0;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}

Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (false !== this._readableState.flowing) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null) {}
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;

  var state = this._readableState;
  var paused = false;

  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }

    _this.push(null);
  });

  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function (method) {
        return function () {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return this;
};

Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._readableState.highWaterMark;
  }
});

// exposed for testing purposes only.
Readable._fromList = fromList;

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;

  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = fromListPartial(n, state.buffer, state.decoder);
  }

  return ret;
}

// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromListPartial(n, list, hasStrings) {
  var ret;
  if (n < list.head.data.length) {
    // slice is the same for buffers and strings
    ret = list.head.data.slice(0, n);
    list.head.data = list.head.data.slice(n);
  } else if (n === list.head.data.length) {
    // first chunk is a perfect match
    ret = list.shift();
  } else {
    // result spans more than one buffer
    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
  }
  return ret;
}

// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBufferString(n, list) {
  var p = list.head;
  var c = 1;
  var ret = p.data;
  n -= ret.length;
  while (p = p.next) {
    var str = p.data;
    var nb = n > str.length ? str.length : n;
    if (nb === str.length) ret += str;else ret += str.slice(0, n);
    n -= nb;
    if (n === 0) {
      if (nb === str.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = str.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBuffer(n, list) {
  var ret = Buffer.allocUnsafe(n);
  var p = list.head;
  var c = 1;
  p.data.copy(ret);
  n -= p.data.length;
  while (p = p.next) {
    var buf = p.data;
    var nb = n > buf.length ? buf.length : n;
    buf.copy(ret, ret.length - n, 0, nb);
    n -= nb;
    if (n === 0) {
      if (nb === buf.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = buf.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;

  // If we get here before consuming all the bytes, then that is a
  // bug in node.  Should never happen.
  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

  if (!state.endEmitted) {
    state.ended = true;
    pna.nextTick(endReadableNT, state, stream);
  }
}

function endReadableNT(state, stream) {
  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
  }
}

function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/global.js"), __webpack_require__("./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/readable-stream/lib/_stream_transform.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.



module.exports = Transform;

var Duplex = __webpack_require__("./node_modules/readable-stream/lib/_stream_duplex.js");

/*<replacement>*/
var util = __webpack_require__("./node_modules/core-util-is/lib/util.js");
util.inherits = __webpack_require__("./node_modules/inherits/inherits_browser.js");
/*</replacement>*/

util.inherits(Transform, Duplex);

function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;

  var cb = ts.writecb;

  if (!cb) {
    return this.emit('error', new Error('write callback called multiple times'));
  }

  ts.writechunk = null;
  ts.writecb = null;

  if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);

  cb(er);

  var rs = this._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}

function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);

  Duplex.call(this, options);

  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  };

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;

  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;

    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.on('prefinish', prefinish);
}

function prefinish() {
  var _this = this;

  if (typeof this._flush === 'function') {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}

Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  throw new Error('_transform() is not implemented');
};

Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};

Transform.prototype._destroy = function (err, cb) {
  var _this2 = this;

  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
    _this2.emit('close');
  });
};

function done(stream, er, data) {
  if (er) return stream.emit('error', er);

  if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);

  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');

  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');

  return stream.push(null);
}

/***/ }),

/***/ "./node_modules/readable-stream/lib/_stream_writable.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.



/*<replacement>*/

var pna = __webpack_require__("./node_modules/process-nextick-args/index.js");
/*</replacement>*/

module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;

  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var util = __webpack_require__("./node_modules/core-util-is/lib/util.js");
util.inherits = __webpack_require__("./node_modules/inherits/inherits_browser.js");
/*</replacement>*/

/*<replacement>*/
var internalUtil = {
  deprecate: __webpack_require__("./node_modules/util-deprecate/browser.js")
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__("./node_modules/readable-stream/lib/internal/streams/stream-browser.js");
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__("./node_modules/safe-buffer/index.js").Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

var destroyImpl = __webpack_require__("./node_modules/readable-stream/lib/internal/streams/destroy.js");

util.inherits(Writable, Stream);

function nop() {}

function WritableState(options, stream) {
  Duplex = Duplex || __webpack_require__("./node_modules/readable-stream/lib/_stream_duplex.js");

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  var hwm = options.highWaterMark;
  var writableHwm = options.writableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;

  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}

WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};

(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function () {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function (object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;

      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function (object) {
    return object instanceof this;
  };
}

function Writable(options) {
  Duplex = Duplex || __webpack_require__("./node_modules/readable-stream/lib/_stream_duplex.js");

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.
  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
    return new Writable(options);
  }

  this._writableState = new WritableState(options, this);

  // legacy.
  this.writable = true;

  if (options) {
    if (typeof options.write === 'function') this._write = options.write;

    if (typeof options.writev === 'function') this._writev = options.writev;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;

    if (typeof options.final === 'function') this._final = options.final;
  }

  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  this.emit('error', new Error('Cannot pipe, not readable'));
};

function writeAfterEnd(stream, cb) {
  var er = new Error('write after end');
  // TODO: defer error events consistently everywhere, not just the cb
  stream.emit('error', er);
  pna.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var valid = true;
  var er = false;

  if (chunk === null) {
    er = new TypeError('May not write null values to stream');
  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  if (er) {
    stream.emit('error', er);
    pna.nextTick(cb, er);
    valid = false;
  }
  return valid;
}

Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);

  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

  if (typeof cb !== 'function') cb = nop;

  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }

  return ret;
};

Writable.prototype.cork = function () {
  var state = this._writableState;

  state.corked++;
};

Writable.prototype.uncork = function () {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;

    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}

Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;

  state.length += len;

  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;

  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;

  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    pna.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    pna.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;

  onwriteStateUpdate(state);

  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state);

    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }

    if (sync) {
      /*<replacement>*/
      asyncWrite(afterWrite, stream, state, finished, cb);
      /*</replacement>*/
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;

  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;

    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;

    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;

      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }

    if (entry === null) state.lastBufferedRequest = null;
  }

  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}

Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new Error('_write() is not implemented'));
};

Writable.prototype._writev = null;

Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending && !state.finished) endWritable(this, state, cb);
};

function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      stream.emit('error', err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function') {
      state.pendingcb++;
      state.finalCalled = true;
      pna.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
    }
  }
  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}

function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }
  if (state.corkedRequestsFree) {
    state.corkedRequestsFree.next = corkReq;
  } else {
    state.corkedRequestsFree = corkReq;
  }
}

Object.defineProperty(Writable.prototype, 'destroyed', {
  get: function () {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});

Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  this.end();
  cb(err);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/process/browser.js"), __webpack_require__("./node_modules/timers-browserify/main.js").setImmediate, __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/readable-stream/lib/internal/streams/BufferList.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Buffer = __webpack_require__("./node_modules/safe-buffer/index.js").Buffer;
var util = __webpack_require__(2);

function copyBuffer(src, target, offset) {
  src.copy(target, offset);
}

module.exports = function () {
  function BufferList() {
    _classCallCheck(this, BufferList);

    this.head = null;
    this.tail = null;
    this.length = 0;
  }

  BufferList.prototype.push = function push(v) {
    var entry = { data: v, next: null };
    if (this.length > 0) this.tail.next = entry;else this.head = entry;
    this.tail = entry;
    ++this.length;
  };

  BufferList.prototype.unshift = function unshift(v) {
    var entry = { data: v, next: this.head };
    if (this.length === 0) this.tail = entry;
    this.head = entry;
    ++this.length;
  };

  BufferList.prototype.shift = function shift() {
    if (this.length === 0) return;
    var ret = this.head.data;
    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
    --this.length;
    return ret;
  };

  BufferList.prototype.clear = function clear() {
    this.head = this.tail = null;
    this.length = 0;
  };

  BufferList.prototype.join = function join(s) {
    if (this.length === 0) return '';
    var p = this.head;
    var ret = '' + p.data;
    while (p = p.next) {
      ret += s + p.data;
    }return ret;
  };

  BufferList.prototype.concat = function concat(n) {
    if (this.length === 0) return Buffer.alloc(0);
    if (this.length === 1) return this.head.data;
    var ret = Buffer.allocUnsafe(n >>> 0);
    var p = this.head;
    var i = 0;
    while (p) {
      copyBuffer(p.data, ret, i);
      i += p.data.length;
      p = p.next;
    }
    return ret;
  };

  return BufferList;
}();

if (util && util.inspect && util.inspect.custom) {
  module.exports.prototype[util.inspect.custom] = function () {
    var obj = util.inspect({ length: this.length });
    return this.constructor.name + ' ' + obj;
  };
}

/***/ }),

/***/ "./node_modules/readable-stream/lib/internal/streams/destroy.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*<replacement>*/

var pna = __webpack_require__("./node_modules/process-nextick-args/index.js");
/*</replacement>*/

// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;

  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;

  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
      pna.nextTick(emitErrorNT, this, err);
    }
    return this;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }

  this._destroy(err || null, function (err) {
    if (!cb && err) {
      pna.nextTick(emitErrorNT, _this, err);
      if (_this._writableState) {
        _this._writableState.errorEmitted = true;
      }
    } else if (cb) {
      cb(err);
    }
  });

  return this;
}

function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }

  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}

function emitErrorNT(self, err) {
  self.emit('error', err);
}

module.exports = {
  destroy: destroy,
  undestroy: undestroy
};

/***/ }),

/***/ "./node_modules/readable-stream/lib/internal/streams/stream-browser.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("./node_modules/events/events.js").EventEmitter;


/***/ }),

/***/ "./node_modules/readable-stream/passthrough.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("./node_modules/readable-stream/readable-browser.js").PassThrough


/***/ }),

/***/ "./node_modules/readable-stream/readable-browser.js":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/readable-stream/lib/_stream_readable.js");
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = __webpack_require__("./node_modules/readable-stream/lib/_stream_writable.js");
exports.Duplex = __webpack_require__("./node_modules/readable-stream/lib/_stream_duplex.js");
exports.Transform = __webpack_require__("./node_modules/readable-stream/lib/_stream_transform.js");
exports.PassThrough = __webpack_require__("./node_modules/readable-stream/lib/_stream_passthrough.js");


/***/ }),

/***/ "./node_modules/readable-stream/transform.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("./node_modules/readable-stream/readable-browser.js").Transform


/***/ }),

/***/ "./node_modules/readable-stream/writable-browser.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("./node_modules/readable-stream/lib/_stream_writable.js");


/***/ }),

/***/ "./node_modules/safe-buffer/index.js":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__("./node_modules/buffer/index.js")
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),

/***/ "./node_modules/stream-browserify/index.js":
/***/ (function(module, exports, __webpack_require__) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

module.exports = Stream;

var EE = __webpack_require__("./node_modules/events/events.js").EventEmitter;
var inherits = __webpack_require__("./node_modules/inherits/inherits_browser.js");

inherits(Stream, EE);
Stream.Readable = __webpack_require__("./node_modules/readable-stream/readable-browser.js");
Stream.Writable = __webpack_require__("./node_modules/readable-stream/writable-browser.js");
Stream.Duplex = __webpack_require__("./node_modules/readable-stream/duplex-browser.js");
Stream.Transform = __webpack_require__("./node_modules/readable-stream/transform.js");
Stream.PassThrough = __webpack_require__("./node_modules/readable-stream/passthrough.js");

// Backwards-compat with node 0.4.x
Stream.Stream = Stream;



// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.

function Stream() {
  EE.call(this);
}

Stream.prototype.pipe = function(dest, options) {
  var source = this;

  function ondata(chunk) {
    if (dest.writable) {
      if (false === dest.write(chunk) && source.pause) {
        source.pause();
      }
    }
  }

  source.on('data', ondata);

  function ondrain() {
    if (source.readable && source.resume) {
      source.resume();
    }
  }

  dest.on('drain', ondrain);

  // If the 'end' option is not supplied, dest.end() will be called when
  // source gets the 'end' or 'close' events.  Only dest.end() once.
  if (!dest._isStdio && (!options || options.end !== false)) {
    source.on('end', onend);
    source.on('close', onclose);
  }

  var didOnEnd = false;
  function onend() {
    if (didOnEnd) return;
    didOnEnd = true;

    dest.end();
  }


  function onclose() {
    if (didOnEnd) return;
    didOnEnd = true;

    if (typeof dest.destroy === 'function') dest.destroy();
  }

  // don't leave dangling pipes when there are errors.
  function onerror(er) {
    cleanup();
    if (EE.listenerCount(this, 'error') === 0) {
      throw er; // Unhandled stream error in pipe.
    }
  }

  source.on('error', onerror);
  dest.on('error', onerror);

  // remove all the event listeners that were added.
  function cleanup() {
    source.removeListener('data', ondata);
    dest.removeListener('drain', ondrain);

    source.removeListener('end', onend);
    source.removeListener('close', onclose);

    source.removeListener('error', onerror);
    dest.removeListener('error', onerror);

    source.removeListener('end', cleanup);
    source.removeListener('close', cleanup);

    dest.removeListener('close', cleanup);
  }

  source.on('end', cleanup);
  source.on('close', cleanup);

  dest.on('close', cleanup);

  dest.emit('pipe', source);

  // Allow for unix-like usage: A.pipe(B).pipe(C)
  return dest;
};


/***/ }),

/***/ "./node_modules/string_decoder/lib/string_decoder.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var Buffer = __webpack_require__("./node_modules/safe-buffer/index.js").Buffer;
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}

/***/ }),

/***/ "./node_modules/text-mask-addons/dist/textMaskAddons.js":
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.textMaskAddons=t():e.textMaskAddons=t()}(this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var i=n[r]={exports:{},id:r,loaded:!1};return e[r].call(i.exports,i,i.exports,t),i.loaded=!0,i.exports}var n={};return t.m=e,t.c=n,t.p="",t(0)}([function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(1);Object.defineProperty(t,"createAutoCorrectedDatePipe",{enumerable:!0,get:function(){return r(i).default}});var o=n(2);Object.defineProperty(t,"createNumberMask",{enumerable:!0,get:function(){return r(o).default}});var u=n(3);Object.defineProperty(t,"emailMask",{enumerable:!0,get:function(){return r(u).default}})},function(e,t){"use strict";function n(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"mm dd yyyy",t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=t.minYear,o=void 0===n?1:n,u=t.maxYear,a=void 0===u?9999:u,c=e.split(/[^dmyHMS]+/).sort(function(e,t){return i.indexOf(e)-i.indexOf(t)});return function(t){var n=[],i={dd:31,mm:12,yy:99,yyyy:a,HH:23,MM:59,SS:59},u={dd:1,mm:1,yy:0,yyyy:o,HH:0,MM:0,SS:0},l=t.split("");c.forEach(function(t){var r=e.indexOf(t),o=parseInt(i[t].toString().substr(0,1),10);parseInt(l[r],10)>o&&(l[r+1]=l[r],l[r]=0,n.push(r))});var s=0,d=c.some(function(n){var c=e.indexOf(n),l=n.length,d=t.substr(c,l).replace(/\D/g,""),f=parseInt(d,10);"mm"===n&&(s=f||0);var p="dd"===n?r[s]:i[n];if("yyyy"===n&&(1!==o||9999!==a)){var v=parseInt(i[n].toString().substring(0,d.length),10),y=parseInt(u[n].toString().substring(0,d.length),10);return f<y||f>v}return f>p||d.length===l&&f<u[n]});return!d&&{value:l.join(""),indexesOfPipedChars:n}}}Object.defineProperty(t,"__esModule",{value:!0}),t.default=n;var r=[31,31,29,31,30,31,30,31,31,30,31,30,31],i=["yyyy","yy","mm","dd","HH","MM","SS"]},function(e,t){"use strict";function n(){function e(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:a,t=e.length;if(e===a||e[0]===g[0]&&1===t)return g.split(a).concat([v]).concat(h.split(a));if(e===P&&_)return g.split(a).concat(["0",P,v]).concat(h.split(a));var n=e[0]===s&&D;n&&(e=e.toString().substr(1));var u=e.lastIndexOf(P),c=u!==-1,l=void 0,m=void 0,b=void 0;if(e.slice($*-1)===h&&(e=e.slice(0,$*-1)),c&&(_||I)?(l=e.slice(e.slice(0,N)===g?N:0,u),m=e.slice(u+1,t),m=r(m.replace(f,a))):l=e.slice(0,N)===g?e.slice(N):e,L&&("undefined"==typeof L?"undefined":o(L))===p){var O="."===S?"[.]":""+S,M=(l.match(new RegExp(O,"g"))||[]).length;l=l.slice(0,L+M*V)}return l=l.replace(f,a),R||(l=l.replace(/^0+(0$|[^0])/,"$1")),l=x?i(l,S):l,b=r(l),(c&&_||I===!0)&&(e[u-1]!==P&&b.push(y),b.push(P,y),m&&(("undefined"==typeof C?"undefined":o(C))===p&&(m=m.slice(0,C)),b=b.concat(m)),I===!0&&e[u-1]===P&&b.push(v)),N>0&&(b=g.split(a).concat(b)),n&&(b.length===N&&b.push(v),b=[d].concat(b)),h.length>0&&(b=b.concat(h.split(a))),b}var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},n=t.prefix,g=void 0===n?u:n,m=t.suffix,h=void 0===m?a:m,b=t.includeThousandsSeparator,x=void 0===b||b,O=t.thousandsSeparatorSymbol,S=void 0===O?c:O,M=t.allowDecimal,_=void 0!==M&&M,j=t.decimalSymbol,P=void 0===j?l:j,w=t.decimalLimit,C=void 0===w?2:w,H=t.requireDecimal,I=void 0!==H&&H,k=t.allowNegative,D=void 0!==k&&k,E=t.allowLeadingZeroes,R=void 0!==E&&E,A=t.integerLimit,L=void 0===A?null:A,N=g&&g.length||0,$=h&&h.length||0,V=S&&S.length||0;return e.instanceOf="createNumberMask",e}function r(e){return e.split(a).map(function(e){return v.test(e)?v:e})}function i(e,t){return e.replace(/\B(?=(\d{3})+(?!\d))/g,t)}Object.defineProperty(t,"__esModule",{value:!0});var o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};t.default=n;var u="$",a="",c=",",l=".",s="-",d=/-/,f=/\D+/g,p="number",v=/\d/,y="[]"},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function i(e,t){e=e.replace(O,v);var n=t.placeholderChar,r=t.currentCaretPosition,i=e.indexOf(y),s=e.lastIndexOf(p),d=s<i?-1:s,f=o(e,i+1,y),g=o(e,d-1,p),m=u(e,i,n),h=a(e,i,d,n),b=c(e,d,n,r);m=l(m),h=l(h),b=l(b,!0);var x=m.concat(f).concat(h).concat(g).concat(b);return x}function o(e,t,n){var r=[];return e[t]===n?r.push(n):r.push(g,n),r.push(g),r}function u(e,t){return t===-1?e:e.slice(0,t)}function a(e,t,n,r){var i=v;return t!==-1&&(i=n===-1?e.slice(t+1,e.length):e.slice(t+1,n)),i=i.replace(new RegExp("[\\s"+r+"]",h),v),i===y?f:i.length<1?m:i[i.length-1]===p?i.slice(0,i.length-1):i}function c(e,t,n,r){var i=v;return t!==-1&&(i=e.slice(t+1,e.length)),i=i.replace(new RegExp("[\\s"+n+".]",h),v),0===i.length?e[t-1]===p&&r!==e.length?f:v:i}function l(e,t){return e.split(v).map(function(e){return e===m?e:t?x:b})}Object.defineProperty(t,"__esModule",{value:!0});var s=n(4),d=r(s),f="*",p=".",v="",y="@",g="[]",m=" ",h="g",b=/[^\s]/,x=/[^.\s]/,O=/\s/g;t.default={mask:i,pipe:d.default}},function(e,t){"use strict";function n(e,t){var n=t.currentCaretPosition,o=t.rawValue,f=t.previousConformedValue,p=t.placeholderChar,v=e;v=r(v);var y=v.indexOf(a),g=null===o.match(new RegExp("[^@\\s."+p+"]"));if(g)return u;if(v.indexOf(l)!==-1||y!==-1&&n!==y+1||o.indexOf(i)===-1&&f!==u&&o.indexOf(c)!==-1)return!1;var m=v.indexOf(i),h=v.slice(m+1,v.length);return(h.match(d)||s).length>1&&v.substr(-1)===c&&n!==o.length&&(v=v.slice(0,v.length-1)),v}function r(e){var t=0;return e.replace(o,function(){return t++,1===t?i:u})}Object.defineProperty(t,"__esModule",{value:!0}),t.default=n;var i="@",o=/@/g,u="",a="@.",c=".",l="..",s=[],d=/\./g}])});

/***/ }),

/***/ "./node_modules/text-mask-core/dist/textMaskCore.js":
/***/ (function(module, exports, __webpack_require__) {

!function(e,r){ true?module.exports=r():"function"==typeof define&&define.amd?define([],r):"object"==typeof exports?exports.textMaskCore=r():e.textMaskCore=r()}(this,function(){return function(e){function r(n){if(t[n])return t[n].exports;var o=t[n]={exports:{},id:n,loaded:!1};return e[n].call(o.exports,o,o.exports,r),o.loaded=!0,o.exports}var t={};return r.m=e,r.c=t,r.p="",r(0)}([function(e,r,t){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(r,"__esModule",{value:!0});var o=t(3);Object.defineProperty(r,"conformToMask",{enumerable:!0,get:function(){return n(o).default}});var i=t(2);Object.defineProperty(r,"adjustCaretPosition",{enumerable:!0,get:function(){return n(i).default}});var a=t(5);Object.defineProperty(r,"createTextMaskInputElement",{enumerable:!0,get:function(){return n(a).default}})},function(e,r){"use strict";Object.defineProperty(r,"__esModule",{value:!0}),r.placeholderChar="_",r.strFunction="function"},function(e,r){"use strict";function t(e){var r=e.previousConformedValue,t=void 0===r?o:r,i=e.previousPlaceholder,a=void 0===i?o:i,u=e.currentCaretPosition,l=void 0===u?0:u,s=e.conformedValue,f=e.rawValue,d=e.placeholderChar,c=e.placeholder,p=e.indexesOfPipedChars,v=void 0===p?n:p,h=e.caretTrapIndexes,m=void 0===h?n:h;if(0===l||!f.length)return 0;var y=f.length,g=t.length,b=c.length,C=s.length,P=y-g,k=P>0,x=0===g,O=P>1&&!k&&!x;if(O)return l;var T=k&&(t===s||s===c),w=0,M=void 0,S=void 0;if(T)w=l-P;else{var j=s.toLowerCase(),_=f.toLowerCase(),V=_.substr(0,l).split(o),A=V.filter(function(e){return j.indexOf(e)!==-1});S=A[A.length-1];var N=a.substr(0,A.length).split(o).filter(function(e){return e!==d}).length,E=c.substr(0,A.length).split(o).filter(function(e){return e!==d}).length,F=E!==N,R=void 0!==a[A.length-1]&&void 0!==c[A.length-2]&&a[A.length-1]!==d&&a[A.length-1]!==c[A.length-1]&&a[A.length-1]===c[A.length-2];!k&&(F||R)&&N>0&&c.indexOf(S)>-1&&void 0!==f[l]&&(M=!0,S=f[l]);for(var I=v.map(function(e){return j[e]}),J=I.filter(function(e){return e===S}).length,W=A.filter(function(e){return e===S}).length,q=c.substr(0,c.indexOf(d)).split(o).filter(function(e,r){return e===S&&f[r]!==e}).length,L=q+W+J+(M?1:0),z=0,B=0;B<C;B++){var D=j[B];if(w=B+1,D===S&&z++,z>=L)break}}if(k){for(var G=w,H=w;H<=b;H++)if(c[H]===d&&(G=H),c[H]===d||m.indexOf(H)!==-1||H===b)return G}else if(M){for(var K=w-1;K>=0;K--)if(s[K]===S||m.indexOf(K)!==-1||0===K)return K}else for(var Q=w;Q>=0;Q--)if(c[Q-1]===d||m.indexOf(Q)!==-1||0===Q)return Q}Object.defineProperty(r,"__esModule",{value:!0}),r.default=t;var n=[],o=""},function(e,r,t){"use strict";function n(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:l,r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:u,t=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};if(!(0,i.isArray)(r)){if(("undefined"==typeof r?"undefined":o(r))!==a.strFunction)throw new Error("Text-mask:conformToMask; The mask property must be an array.");r=r(e,t),r=(0,i.processCaretTraps)(r).maskWithoutCaretTraps}var n=t.guide,s=void 0===n||n,f=t.previousConformedValue,d=void 0===f?l:f,c=t.placeholderChar,p=void 0===c?a.placeholderChar:c,v=t.placeholder,h=void 0===v?(0,i.convertMaskToPlaceholder)(r,p):v,m=t.currentCaretPosition,y=t.keepCharPositions,g=s===!1&&void 0!==d,b=e.length,C=d.length,P=h.length,k=r.length,x=b-C,O=x>0,T=m+(O?-x:0),w=T+Math.abs(x);if(y===!0&&!O){for(var M=l,S=T;S<w;S++)h[S]===p&&(M+=p);e=e.slice(0,T)+M+e.slice(T,b)}for(var j=e.split(l).map(function(e,r){return{char:e,isNew:r>=T&&r<w}}),_=b-1;_>=0;_--){var V=j[_].char;if(V!==p){var A=_>=T&&C===k;V===h[A?_-x:_]&&j.splice(_,1)}}var N=l,E=!1;e:for(var F=0;F<P;F++){var R=h[F];if(R===p){if(j.length>0)for(;j.length>0;){var I=j.shift(),J=I.char,W=I.isNew;if(J===p&&g!==!0){N+=p;continue e}if(r[F].test(J)){if(y===!0&&W!==!1&&d!==l&&s!==!1&&O){for(var q=j.length,L=null,z=0;z<q;z++){var B=j[z];if(B.char!==p&&B.isNew===!1)break;if(B.char===p){L=z;break}}null!==L?(N+=J,j.splice(L,1)):F--}else N+=J;continue e}E=!0}g===!1&&(N+=h.substr(F,P));break}N+=R}if(g&&O===!1){for(var D=null,G=0;G<N.length;G++)h[G]===p&&(D=G);N=null!==D?N.substr(0,D+1):l}return{conformedValue:N,meta:{someCharsRejected:E}}}Object.defineProperty(r,"__esModule",{value:!0});var o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};r.default=n;var i=t(4),a=t(1),u=[],l=""},function(e,r,t){"use strict";function n(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:f,r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:s.placeholderChar;if(!o(e))throw new Error("Text-mask:convertMaskToPlaceholder; The mask property must be an array.");if(e.indexOf(r)!==-1)throw new Error("Placeholder character must not be used as part of the mask. Please specify a character that is not present in your mask as your placeholder character.\n\n"+("The placeholder character that was received is: "+JSON.stringify(r)+"\n\n")+("The mask that was received is: "+JSON.stringify(e)));return e.map(function(e){return e instanceof RegExp?r:e}).join("")}function o(e){return Array.isArray&&Array.isArray(e)||e instanceof Array}function i(e){return"string"==typeof e||e instanceof String}function a(e){return"number"==typeof e&&void 0===e.length&&!isNaN(e)}function u(e){return"undefined"==typeof e||null===e}function l(e){for(var r=[],t=void 0;t=e.indexOf(d),t!==-1;)r.push(t),e.splice(t,1);return{maskWithoutCaretTraps:e,indexes:r}}Object.defineProperty(r,"__esModule",{value:!0}),r.convertMaskToPlaceholder=n,r.isArray=o,r.isString=i,r.isNumber=a,r.isNil=u,r.processCaretTraps=l;var s=t(1),f=[],d="[]"},function(e,r,t){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}function o(e){var r={previousConformedValue:void 0,previousPlaceholder:void 0};return{state:r,update:function(t){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:e,o=n.inputElement,s=n.mask,d=n.guide,m=n.pipe,g=n.placeholderChar,b=void 0===g?v.placeholderChar:g,C=n.keepCharPositions,P=void 0!==C&&C,k=n.showMask,x=void 0!==k&&k;if("undefined"==typeof t&&(t=o.value),t!==r.previousConformedValue){("undefined"==typeof s?"undefined":l(s))===y&&void 0!==s.pipe&&void 0!==s.mask&&(m=s.pipe,s=s.mask);var O=void 0,T=void 0;if(s instanceof Array&&(O=(0,p.convertMaskToPlaceholder)(s,b)),s!==!1){var w=a(t),M=o.selectionEnd,S=r.previousConformedValue,j=r.previousPlaceholder,_=void 0;if(("undefined"==typeof s?"undefined":l(s))===v.strFunction){if(T=s(w,{currentCaretPosition:M,previousConformedValue:S,placeholderChar:b}),T===!1)return;var V=(0,p.processCaretTraps)(T),A=V.maskWithoutCaretTraps,N=V.indexes;T=A,_=N,O=(0,p.convertMaskToPlaceholder)(T,b)}else T=s;var E={previousConformedValue:S,guide:d,placeholderChar:b,pipe:m,placeholder:O,currentCaretPosition:M,keepCharPositions:P},F=(0,c.default)(w,T,E),R=F.conformedValue,I=("undefined"==typeof m?"undefined":l(m))===v.strFunction,J={};I&&(J=m(R,u({rawValue:w},E)),J===!1?J={value:S,rejected:!0}:(0,p.isString)(J)&&(J={value:J}));var W=I?J.value:R,q=(0,f.default)({previousConformedValue:S,previousPlaceholder:j,conformedValue:W,placeholder:O,rawValue:w,currentCaretPosition:M,placeholderChar:b,indexesOfPipedChars:J.indexesOfPipedChars,caretTrapIndexes:_}),L=W===O&&0===q,z=x?O:h,B=L?z:W;r.previousConformedValue=B,r.previousPlaceholder=O,o.value!==B&&(o.value=B,i(o,q))}}}}}function i(e,r){document.activeElement===e&&(g?b(function(){return e.setSelectionRange(r,r,m)},0):e.setSelectionRange(r,r,m))}function a(e){if((0,p.isString)(e))return e;if((0,p.isNumber)(e))return String(e);if(void 0===e||null===e)return h;throw new Error("The 'value' provided to Text Mask needs to be a string or a number. The value received was:\n\n "+JSON.stringify(e))}Object.defineProperty(r,"__esModule",{value:!0});var u=Object.assign||function(e){for(var r=1;r<arguments.length;r++){var t=arguments[r];for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n])}return e},l="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};r.default=o;var s=t(2),f=n(s),d=t(3),c=n(d),p=t(4),v=t(1),h="",m="none",y="object",g="undefined"!=typeof navigator&&/Android/i.test(navigator.userAgent),b="undefined"!=typeof requestAnimationFrame?requestAnimationFrame:setTimeout}])});

/***/ }),

/***/ "./node_modules/ticky/ticky-browser.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(setImmediate) {var si = typeof setImmediate === 'function', tick;
if (si) {
  tick = function (fn) { setImmediate(fn); };
} else {
  tick = function (fn) { setTimeout(fn, 0); };
}

module.exports = tick;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/timers-browserify/main.js").setImmediate))

/***/ }),

/***/ "./node_modules/toastr/node_modules/jquery/dist/jquery.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.4.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2019-05-01T21:04Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var document = window.document;

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var concat = arr.concat;

var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

      // Support: Chrome <=57, Firefox <=52
      // In some browsers, typeof returns "function" for HTML <object> elements
      // (i.e., `typeof document.createElement( "object" ) === "function"`).
      // We don't want to classify *any* DOM node as a function.
      return typeof obj === "function" && typeof obj.nodeType !== "number";
  };


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};




	var preservedScriptAttributes = {
		type: true,
		src: true,
		nonce: true,
		noModule: true
	};

	function DOMEval( code, node, doc ) {
		doc = doc || document;

		var i, val,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {

				// Support: Firefox 64+, Edge 18+
				// Some browsers don't support the "nonce" property on scripts.
				// On the other hand, just using `getAttribute` is not enough as
				// the `nonce` attribute is reset to an empty string whenever it
				// becomes browsing-context connected.
				// See https://github.com/whatwg/html/issues/2369
				// See https://html.spec.whatwg.org/#nonce-attributes
				// The `node.getAttribute` check was added for the sake of
				// `jQuery.globalEval` so that it can fake a nonce-containing node
				// via an object.
				val = node[ i ] || node.getAttribute && node.getAttribute( i );
				if ( val ) {
					script.setAttribute( i, val );
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.4.1",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				copy = options[ name ];

				// Prevent Object.prototype pollution
				// Prevent never-ending loop
				if ( name === "__proto__" || target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {
					src = target[ name ];

					// Ensure proper type for the source value
					if ( copyIsArray && !Array.isArray( src ) ) {
						clone = [];
					} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
						clone = {};
					} else {
						clone = src;
					}
					copyIsArray = false;

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a global context
	globalEval: function( code, options ) {
		DOMEval( code, { nonce: options && options.nonce } );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// Support: Android <=4.0 only
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.4
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://js.foundation/
 *
 * Date: 2019-04-08
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	nonnativeSelectorCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
	rdescend = new RegExp( whitespace + "|>" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rhtml = /HTML$/i,
	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	inDisabledFieldset = addCombinator(
		function( elem ) {
			return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {

		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

				// ID selector
				if ( (m = match[1]) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( (elem = context.getElementById( m )) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && (elem = newContext.getElementById( m )) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( (m = match[3]) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!nonnativeSelectorCache[ selector + " " ] &&
				(!rbuggyQSA || !rbuggyQSA.test( selector )) &&

				// Support: IE 8 only
				// Exclude object elements
				(nodeType !== 1 || context.nodeName.toLowerCase() !== "object") ) {

				newSelector = selector;
				newContext = context;

				// qSA considers elements outside a scoping root when evaluating child or
				// descendant combinators, which is not what we want.
				// In such cases, we work around the behavior by prefixing every selector in the
				// list with an ID selector referencing the scope context.
				// Thanks to Andrew Dupont for this technique.
				if ( nodeType === 1 && rdescend.test( selector ) ) {

					// Capture the context ID, setting it first if necessary
					if ( (nid = context.getAttribute( "id" )) ) {
						nid = nid.replace( rcssescape, fcssescape );
					} else {
						context.setAttribute( "id", (nid = expando) );
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[i] = "#" + nid + " " + toSelector( groups[i] );
					}
					newSelector = groups.join( "," );

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;
				}

				try {
					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch ( qsaError ) {
					nonnativeSelectorCache( selector, true );
				} finally {
					if ( nid === expando ) {
						context.removeAttribute( "id" );
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement("fieldset");

	try {
		return !!fn( el );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}
		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
						inDisabledFieldset( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	var namespace = elem.namespaceURI,
		docElem = (elem.ownerDocument || elem).documentElement;

	// Support: IE <=8
	// Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
	// https://bugs.jquery.com/ticket/4833
	return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9-11, Edge
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	if ( preferredDoc !== document &&
		(subWindow = document.defaultView) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( el ) {
		el.className = "i";
		return !el.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( el ) {
		el.appendChild( document.createComment("") );
		return !el.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	});

	// ID filter and find
	if ( support.getById ) {
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode("id");
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( (elem = elems[i++]) ) {
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( el ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement("input");
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll(":enabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll(":disabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( el ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === document ? -1 :
				b === document ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	if ( support.matchesSelector && documentIsHTML &&
		!nonnativeSelectorCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {
			nonnativeSelectorCache( expr, true );
		}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return (sel + "").replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || (node[ expando ] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								(outerCache[ node.uniqueID ] = {});

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {
							// Use previously-cached element index if available
							if ( useCache ) {
								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || (node[ expando ] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] || (node[ expando ] = {});

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												(outerCache[ node.uniqueID ] = {});

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ?
				argument + length :
				argument > length ?
					length :
					argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( (oldCache = uniqueCache[ key ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context === document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					if ( !context && elem.ownerDocument !== document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context || document, xml) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( el ) {
	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( el ) {
	return el.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

};
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		if ( typeof elem.contentDocument !== "undefined" ) {
			return elem.contentDocument;
		}

		// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
		// Treat the template element as a regular one in browsers that
		// don't support it.
		if ( nodeName( elem, "template" ) ) {
			elem = elem.content || elem;
		}

		return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the master Deferred
			master = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						master.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( master.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return master.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
		}

		return master.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
					value :
					value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (#9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var documentElement = document.documentElement;



	var isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem );
		},
		composed = { composed: true };

	// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
	// Check attachment across shadow DOM boundaries when possible (gh-3504)
	// Support: iOS 10.0-10.2 only
	// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
	// leading to errors. We need to check for `getRootNode`.
	if ( documentElement.getRootNode ) {
		isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem ) ||
				elem.getRootNode( composed ) === elem.ownerDocument;
		};
	}
var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			isAttached( elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};

var swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};




function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = elem.nodeType &&
			( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// Support: IE <=9 only
	option: [ 1, "<select multiple='multiple'>", "</select>" ],

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

// Support: IE <=9 only
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, attached, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		attached = isAttached( elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( attached ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
} )();


var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 - 11+
// focus() and blur() are asynchronous, except when they are no-op.
// So expect focus to be synchronous when the element is already active,
// and blur to be synchronous when the element is not already active.
// (focus and blur are always synchronous in other supported browsers,
// this just defines when we can count on it).
function expectSync( elem, type ) {
	return ( elem === safeActiveElement() ) === ( type === "focus" );
}

// Support: IE <=9 only
// Accessing document.activeElement can throw unexpectedly
// https://bugs.jquery.com/ticket/13393
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = {};
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		// Make a writable jQuery.Event from the native event object
		var event = jQuery.event.fix( nativeEvent );

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),
			handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// If the event is namespaced, then each handler is only invoked if it is
				// specially universal or its namespaces are a superset of the event's.
				if ( !event.rnamespace || handleObj.namespace === false ||
					event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
							return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
							return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		click: {

			// Utilize native event to ensure correct state for checkable inputs
			setup: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Claim the first handler
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					// dataPriv.set( el, "click", ... )
					leverageNative( el, "click", returnTrue );
				}

				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Force setup before triggering a click
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					leverageNative( el, "click" );
				}

				// Return non-false to allow normal event-path propagation
				return true;
			},

			// For cross-browser consistency, suppress native .click() on links
			// Also prevent it if we're currently inside a leveraged native-event stack
			_default: function( event ) {
				var target = event.target;
				return rcheckableType.test( target.type ) &&
					target.click && nodeName( target, "input" ) &&
					dataPriv.get( target, "click" ) ||
					nodeName( target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

// Ensure the presence of an event listener that handles manually-triggered
// synthetic events by interrupting progress until reinvoked in response to
// *native* events that it fires directly, ensuring that state changes have
// already occurred before other listeners are invoked.
function leverageNative( el, type, expectSync ) {

	// Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
	if ( !expectSync ) {
		if ( dataPriv.get( el, type ) === undefined ) {
			jQuery.event.add( el, type, returnTrue );
		}
		return;
	}

	// Register the controller as a special universal handler for all event namespaces
	dataPriv.set( el, type, false );
	jQuery.event.add( el, type, {
		namespace: false,
		handler: function( event ) {
			var notAsync, result,
				saved = dataPriv.get( this, type );

			if ( ( event.isTrigger & 1 ) && this[ type ] ) {

				// Interrupt processing of the outer synthetic .trigger()ed event
				// Saved data should be false in such cases, but might be a leftover capture object
				// from an async native handler (gh-4350)
				if ( !saved.length ) {

					// Store arguments for use when handling the inner native event
					// There will always be at least one argument (an event object), so this array
					// will not be confused with a leftover capture object.
					saved = slice.call( arguments );
					dataPriv.set( this, type, saved );

					// Trigger the native event and capture its result
					// Support: IE <=9 - 11+
					// focus() and blur() are asynchronous
					notAsync = expectSync( this, type );
					this[ type ]();
					result = dataPriv.get( this, type );
					if ( saved !== result || notAsync ) {
						dataPriv.set( this, type, false );
					} else {
						result = {};
					}
					if ( saved !== result ) {

						// Cancel the outer synthetic event
						event.stopImmediatePropagation();
						event.preventDefault();
						return result.value;
					}

				// If this is an inner synthetic event for an event with a bubbling surrogate
				// (focus or blur), assume that the surrogate already propagated from triggering the
				// native event and prevent that from happening again here.
				// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
				// bubbling surrogate propagates *after* the non-bubbling base), but that seems
				// less bad than duplication.
				} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
					event.stopPropagation();
				}

			// If this is a native event triggered above, everything is now in order
			// Fire an inner synthetic event with the original arguments
			} else if ( saved.length ) {

				// ...and capture the result
				dataPriv.set( this, type, {
					value: jQuery.event.trigger(

						// Support: IE <=9 - 11+
						// Extend with the prototype to reset the above stopImmediatePropagation()
						jQuery.extend( saved[ 0 ], jQuery.Event.prototype ),
						saved.slice( 1 ),
						this
					)
				} );

				// Abort handling of the native event
				event.stopImmediatePropagation();
			}
		}
	} );
}

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	code: true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,

	which: function( event ) {
		var button = event.button;

		// Add which for key events
		if ( event.which == null && rkeyEvent.test( event.type ) ) {
			return event.charCode != null ? event.charCode : event.keyCode;
		}

		// Add which for click: 1 === left; 2 === middle; 3 === right
		if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
			if ( button & 1 ) {
				return 1;
			}

			if ( button & 2 ) {
				return 3;
			}

			if ( button & 4 ) {
				return 2;
			}

			return 0;
		}

		return event.which;
	}
}, jQuery.event.addProp );

jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
	jQuery.event.special[ type ] = {

		// Utilize native event if possible so blur/focus sequence is correct
		setup: function() {

			// Claim the first handler
			// dataPriv.set( this, "focus", ... )
			// dataPriv.set( this, "blur", ... )
			leverageNative( this, type, expectSync );

			// Return false to allow normal processing in the caller
			return false;
		},
		trigger: function() {

			// Force setup before trigger
			leverageNative( this, type );

			// Return non-false to allow normal event-path propagation
			return true;
		},

		delegateType: delegateType
	};
} );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	/* eslint-disable max-len */

	// See https://github.com/eslint/eslint/issues/3229
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,

	/* eslint-enable */

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.access( src );
		pdataCur = dataPriv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = concat.apply( [], args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl && !node.noModule ) {
								jQuery._evalUrl( node.src, {
									nonce: node.nonce || node.getAttribute( "nonce" )
								} );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && isAttached( node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html.replace( rxhtmlTag, "<$1></$2>" );
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = isAttached( elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		// Support: Chrome <=64
		// Don't get tricked when zoom affects offsetWidth (gh-4029)
		div.style.position = "absolute";
		scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, #12537)
	//   .css('--customProperty) (#3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !isAttached( elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style,
	vendorProps = {};

// Return a vendor-prefixed property or undefined
function vendorPropName( name ) {

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
function finalPropName( name ) {
	var final = jQuery.cssProps[ name ] || vendorProps[ name ];

	if ( final ) {
		return final;
	}
	if ( name in emptyStyle ) {
		return name;
	}
	return vendorProps[ name ] = vendorPropName( name ) || name;
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rcustomProp = /^--/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	};

function setPositiveNumber( elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		if ( box === "margin" ) {
			delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5

		// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
		// Use an explicit zero to avoid NaN (gh-3964)
		) ) || 0;
	}

	return delta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),

		// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
		// Fake content-box until we know it's needed to know the true value.
		boxSizingNeeded = !support.boxSizingReliable() || extra,
		isBorderBox = boxSizingNeeded &&
			jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox,

		val = curCSS( elem, dimension, styles ),
		offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}


	// Fall back to offsetWidth/offsetHeight when value is "auto"
	// This happens for inline elements with no explicit setting (gh-3571)
	// Support: Android <=4.1 - 4.3 only
	// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
	// Support: IE 9-11 only
	// Also use offsetWidth/offsetHeight for when box sizing is unreliable
	// We use getClientRects() to check for hidden/disconnected.
	// In those cases, the computed value can be trusted to be border-box
	if ( ( !support.boxSizingReliable() && isBorderBox ||
		val === "auto" ||
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&
		elem.getClientRects().length ) {

		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

		// Where available, offsetWidth/offsetHeight approximate border box dimensions.
		// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
		// retrieved value as a content box dimension.
		valueIsBorderBox = offsetProp in elem;
		if ( valueIsBorderBox ) {
			val = elem[ offsetProp ];
		}
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"gridArea": true,
		"gridColumn": true,
		"gridColumnEnd": true,
		"gridColumnStart": true,
		"gridRow": true,
		"gridRowEnd": true,
		"gridRowStart": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
			// "px" to a few hardcoded values.
			if ( type === "number" && !isCustomProp ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, dimension, extra );
						} ) :
						getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),

				// Only read styles.position if the test has a chance to fail
				// to avoid forcing a reflow.
				scrollboxSizeBuggy = !support.scrollboxSize() &&
					styles.position === "absolute",

				// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
				boxSizingNeeded = scrollboxSizeBuggy || extra,
				isBorderBox = boxSizingNeeded &&
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra ?
					boxModelAdjustment(
						elem,
						dimension,
						extra,
						isBorderBox,
						styles
					) :
					0;

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && scrollboxSizeBuggy ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
				) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 && (
					jQuery.cssHooks[ tween.prop ] ||
					tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

			/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( isValidValue ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = classesToArray( value );

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
						"" :
						dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


support.focusin = "onfocusin" in window;


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = Date.now();

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	if ( a == null ) {
		return "";
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );
	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
									( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
										.concat( match[ 2 ] );
							}
						}
						match = responseHeaders[ key.toLowerCase() + " " ];
					}
					return match == null ? null : match.join( ", " );
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );


jQuery._evalUrl = function( url, options ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,

		// Only evaluate the response if it is successful (gh-4126)
		// dataFilter is not invoked for failure responses, so using it instead
		// of the default converter is kludgy but it works.
		converters: {
			"text script": function() {}
		},
		dataFilter: function( response ) {
			jQuery.globalEval( response, options );
		}
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain or forced-by-attrs requests
	if ( s.crossDomain || s.scriptAttrs ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" )
					.attr( s.scriptAttrs || {} )
					.prop( { charset: s.scriptCharset, src: s.url } )
					.on( "load error", callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					} );

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
} );

jQuery.fn.extend( {
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	}
} );

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
		return jQuery;
	}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( !noGlobal ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ }),

/***/ "./node_modules/toastr/toastr.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 * Toastr
 * Copyright 2012-2015
 * Authors: John Papa, Hans Fjällemark, and Tim Ferrell.
 * All Rights Reserved.
 * Use, reproduction, distribution, and modification of this code is subject to the terms and
 * conditions of the MIT license, available at http://www.opensource.org/licenses/mit-license.php
 *
 * ARIA Support: Greta Krafsig
 *
 * Project: https://github.com/CodeSeven/toastr
 */
/* global define */
(function (define) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./node_modules/toastr/node_modules/jquery/dist/jquery.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function ($) {
        return (function () {
            var $container;
            var listener;
            var toastId = 0;
            var toastType = {
                error: 'error',
                info: 'info',
                success: 'success',
                warning: 'warning'
            };

            var toastr = {
                clear: clear,
                remove: remove,
                error: error,
                getContainer: getContainer,
                info: info,
                options: {},
                subscribe: subscribe,
                success: success,
                version: '2.1.4',
                warning: warning
            };

            var previousToast;

            return toastr;

            ////////////////

            function error(message, title, optionsOverride) {
                return notify({
                    type: toastType.error,
                    iconClass: getOptions().iconClasses.error,
                    message: message,
                    optionsOverride: optionsOverride,
                    title: title
                });
            }

            function getContainer(options, create) {
                if (!options) { options = getOptions(); }
                $container = $('#' + options.containerId);
                if ($container.length) {
                    return $container;
                }
                if (create) {
                    $container = createContainer(options);
                }
                return $container;
            }

            function info(message, title, optionsOverride) {
                return notify({
                    type: toastType.info,
                    iconClass: getOptions().iconClasses.info,
                    message: message,
                    optionsOverride: optionsOverride,
                    title: title
                });
            }

            function subscribe(callback) {
                listener = callback;
            }

            function success(message, title, optionsOverride) {
                return notify({
                    type: toastType.success,
                    iconClass: getOptions().iconClasses.success,
                    message: message,
                    optionsOverride: optionsOverride,
                    title: title
                });
            }

            function warning(message, title, optionsOverride) {
                return notify({
                    type: toastType.warning,
                    iconClass: getOptions().iconClasses.warning,
                    message: message,
                    optionsOverride: optionsOverride,
                    title: title
                });
            }

            function clear($toastElement, clearOptions) {
                var options = getOptions();
                if (!$container) { getContainer(options); }
                if (!clearToast($toastElement, options, clearOptions)) {
                    clearContainer(options);
                }
            }

            function remove($toastElement) {
                var options = getOptions();
                if (!$container) { getContainer(options); }
                if ($toastElement && $(':focus', $toastElement).length === 0) {
                    removeToast($toastElement);
                    return;
                }
                if ($container.children().length) {
                    $container.remove();
                }
            }

            // internal functions

            function clearContainer (options) {
                var toastsToClear = $container.children();
                for (var i = toastsToClear.length - 1; i >= 0; i--) {
                    clearToast($(toastsToClear[i]), options);
                }
            }

            function clearToast ($toastElement, options, clearOptions) {
                var force = clearOptions && clearOptions.force ? clearOptions.force : false;
                if ($toastElement && (force || $(':focus', $toastElement).length === 0)) {
                    $toastElement[options.hideMethod]({
                        duration: options.hideDuration,
                        easing: options.hideEasing,
                        complete: function () { removeToast($toastElement); }
                    });
                    return true;
                }
                return false;
            }

            function createContainer(options) {
                $container = $('<div/>')
                    .attr('id', options.containerId)
                    .addClass(options.positionClass);

                $container.appendTo($(options.target));
                return $container;
            }

            function getDefaults() {
                return {
                    tapToDismiss: true,
                    toastClass: 'toast',
                    containerId: 'toast-container',
                    debug: false,

                    showMethod: 'fadeIn', //fadeIn, slideDown, and show are built into jQuery
                    showDuration: 300,
                    showEasing: 'swing', //swing and linear are built into jQuery
                    onShown: undefined,
                    hideMethod: 'fadeOut',
                    hideDuration: 1000,
                    hideEasing: 'swing',
                    onHidden: undefined,
                    closeMethod: false,
                    closeDuration: false,
                    closeEasing: false,
                    closeOnHover: true,

                    extendedTimeOut: 1000,
                    iconClasses: {
                        error: 'toast-error',
                        info: 'toast-info',
                        success: 'toast-success',
                        warning: 'toast-warning'
                    },
                    iconClass: 'toast-info',
                    positionClass: 'toast-top-right',
                    timeOut: 5000, // Set timeOut and extendedTimeOut to 0 to make it sticky
                    titleClass: 'toast-title',
                    messageClass: 'toast-message',
                    escapeHtml: false,
                    target: 'body',
                    closeHtml: '<button type="button">&times;</button>',
                    closeClass: 'toast-close-button',
                    newestOnTop: true,
                    preventDuplicates: false,
                    progressBar: false,
                    progressClass: 'toast-progress',
                    rtl: false
                };
            }

            function publish(args) {
                if (!listener) { return; }
                listener(args);
            }

            function notify(map) {
                var options = getOptions();
                var iconClass = map.iconClass || options.iconClass;

                if (typeof (map.optionsOverride) !== 'undefined') {
                    options = $.extend(options, map.optionsOverride);
                    iconClass = map.optionsOverride.iconClass || iconClass;
                }

                if (shouldExit(options, map)) { return; }

                toastId++;

                $container = getContainer(options, true);

                var intervalId = null;
                var $toastElement = $('<div/>');
                var $titleElement = $('<div/>');
                var $messageElement = $('<div/>');
                var $progressElement = $('<div/>');
                var $closeElement = $(options.closeHtml);
                var progressBar = {
                    intervalId: null,
                    hideEta: null,
                    maxHideTime: null
                };
                var response = {
                    toastId: toastId,
                    state: 'visible',
                    startTime: new Date(),
                    options: options,
                    map: map
                };

                personalizeToast();

                displayToast();

                handleEvents();

                publish(response);

                if (options.debug && console) {
                    console.log(response);
                }

                return $toastElement;

                function escapeHtml(source) {
                    if (source == null) {
                        source = '';
                    }

                    return source
                        .replace(/&/g, '&amp;')
                        .replace(/"/g, '&quot;')
                        .replace(/'/g, '&#39;')
                        .replace(/</g, '&lt;')
                        .replace(/>/g, '&gt;');
                }

                function personalizeToast() {
                    setIcon();
                    setTitle();
                    setMessage();
                    setCloseButton();
                    setProgressBar();
                    setRTL();
                    setSequence();
                    setAria();
                }

                function setAria() {
                    var ariaValue = '';
                    switch (map.iconClass) {
                        case 'toast-success':
                        case 'toast-info':
                            ariaValue =  'polite';
                            break;
                        default:
                            ariaValue = 'assertive';
                    }
                    $toastElement.attr('aria-live', ariaValue);
                }

                function handleEvents() {
                    if (options.closeOnHover) {
                        $toastElement.hover(stickAround, delayedHideToast);
                    }

                    if (!options.onclick && options.tapToDismiss) {
                        $toastElement.click(hideToast);
                    }

                    if (options.closeButton && $closeElement) {
                        $closeElement.click(function (event) {
                            if (event.stopPropagation) {
                                event.stopPropagation();
                            } else if (event.cancelBubble !== undefined && event.cancelBubble !== true) {
                                event.cancelBubble = true;
                            }

                            if (options.onCloseClick) {
                                options.onCloseClick(event);
                            }

                            hideToast(true);
                        });
                    }

                    if (options.onclick) {
                        $toastElement.click(function (event) {
                            options.onclick(event);
                            hideToast();
                        });
                    }
                }

                function displayToast() {
                    $toastElement.hide();

                    $toastElement[options.showMethod](
                        {duration: options.showDuration, easing: options.showEasing, complete: options.onShown}
                    );

                    if (options.timeOut > 0) {
                        intervalId = setTimeout(hideToast, options.timeOut);
                        progressBar.maxHideTime = parseFloat(options.timeOut);
                        progressBar.hideEta = new Date().getTime() + progressBar.maxHideTime;
                        if (options.progressBar) {
                            progressBar.intervalId = setInterval(updateProgress, 10);
                        }
                    }
                }

                function setIcon() {
                    if (map.iconClass) {
                        $toastElement.addClass(options.toastClass).addClass(iconClass);
                    }
                }

                function setSequence() {
                    if (options.newestOnTop) {
                        $container.prepend($toastElement);
                    } else {
                        $container.append($toastElement);
                    }
                }

                function setTitle() {
                    if (map.title) {
                        var suffix = map.title;
                        if (options.escapeHtml) {
                            suffix = escapeHtml(map.title);
                        }
                        $titleElement.append(suffix).addClass(options.titleClass);
                        $toastElement.append($titleElement);
                    }
                }

                function setMessage() {
                    if (map.message) {
                        var suffix = map.message;
                        if (options.escapeHtml) {
                            suffix = escapeHtml(map.message);
                        }
                        $messageElement.append(suffix).addClass(options.messageClass);
                        $toastElement.append($messageElement);
                    }
                }

                function setCloseButton() {
                    if (options.closeButton) {
                        $closeElement.addClass(options.closeClass).attr('role', 'button');
                        $toastElement.prepend($closeElement);
                    }
                }

                function setProgressBar() {
                    if (options.progressBar) {
                        $progressElement.addClass(options.progressClass);
                        $toastElement.prepend($progressElement);
                    }
                }

                function setRTL() {
                    if (options.rtl) {
                        $toastElement.addClass('rtl');
                    }
                }

                function shouldExit(options, map) {
                    if (options.preventDuplicates) {
                        if (map.message === previousToast) {
                            return true;
                        } else {
                            previousToast = map.message;
                        }
                    }
                    return false;
                }

                function hideToast(override) {
                    var method = override && options.closeMethod !== false ? options.closeMethod : options.hideMethod;
                    var duration = override && options.closeDuration !== false ?
                        options.closeDuration : options.hideDuration;
                    var easing = override && options.closeEasing !== false ? options.closeEasing : options.hideEasing;
                    if ($(':focus', $toastElement).length && !override) {
                        return;
                    }
                    clearTimeout(progressBar.intervalId);
                    return $toastElement[method]({
                        duration: duration,
                        easing: easing,
                        complete: function () {
                            removeToast($toastElement);
                            clearTimeout(intervalId);
                            if (options.onHidden && response.state !== 'hidden') {
                                options.onHidden();
                            }
                            response.state = 'hidden';
                            response.endTime = new Date();
                            publish(response);
                        }
                    });
                }

                function delayedHideToast() {
                    if (options.timeOut > 0 || options.extendedTimeOut > 0) {
                        intervalId = setTimeout(hideToast, options.extendedTimeOut);
                        progressBar.maxHideTime = parseFloat(options.extendedTimeOut);
                        progressBar.hideEta = new Date().getTime() + progressBar.maxHideTime;
                    }
                }

                function stickAround() {
                    clearTimeout(intervalId);
                    progressBar.hideEta = 0;
                    $toastElement.stop(true, true)[options.showMethod](
                        {duration: options.showDuration, easing: options.showEasing}
                    );
                }

                function updateProgress() {
                    var percentage = ((progressBar.hideEta - (new Date().getTime())) / progressBar.maxHideTime) * 100;
                    $progressElement.width(percentage + '%');
                }
            }

            function getOptions() {
                return $.extend({}, getDefaults(), toastr.options);
            }

            function removeToast($toastElement) {
                if (!$container) { $container = getContainer(); }
                if ($toastElement.is(':visible')) {
                    return;
                }
                $toastElement.remove();
                $toastElement = null;
                if ($container.children().length === 0) {
                    $container.remove();
                    previousToast = undefined;
                }
            }

        })();
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}(__webpack_require__("./node_modules/webpack/buildin/amd-define.js")));


/***/ }),

/***/ "./node_modules/tty-browserify/index.js":
/***/ (function(module, exports) {

exports.isatty = function () { return false; };

function ReadStream() {
  throw new Error('tty.ReadStream is not implemented');
}
exports.ReadStream = ReadStream;

function WriteStream() {
  throw new Error('tty.ReadStream is not implemented');
}
exports.WriteStream = WriteStream;


/***/ }),

/***/ "./node_modules/util-deprecate/browser.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate (fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config (name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!global.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = global.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/uuid/dist/esm-browser/bytesToUuid.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];

for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex; // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4

  return [bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]]].join('');
}

/* harmony default export */ __webpack_exports__["a"] = (bytesToUuid);

/***/ }),

/***/ "./node_modules/uuid/dist/esm-browser/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__v1_js__ = __webpack_require__("./node_modules/uuid/dist/esm-browser/v1.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v1", function() { return __WEBPACK_IMPORTED_MODULE_0__v1_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__v3_js__ = __webpack_require__("./node_modules/uuid/dist/esm-browser/v3.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v3", function() { return __WEBPACK_IMPORTED_MODULE_1__v3_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__v4_js__ = __webpack_require__("./node_modules/uuid/dist/esm-browser/v4.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v4", function() { return __WEBPACK_IMPORTED_MODULE_2__v4_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__v5_js__ = __webpack_require__("./node_modules/uuid/dist/esm-browser/v5.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v5", function() { return __WEBPACK_IMPORTED_MODULE_3__v5_js__["a"]; });





/***/ }),

/***/ "./node_modules/uuid/dist/esm-browser/md5.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
 * Browser-compatible JavaScript MD5
 *
 * Modification of JavaScript MD5
 * https://github.com/blueimp/JavaScript-MD5
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 *
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */
function md5(bytes) {
  if (typeof bytes == 'string') {
    var msg = unescape(encodeURIComponent(bytes)); // UTF8 escape

    bytes = new Array(msg.length);

    for (var i = 0; i < msg.length; i++) {
      bytes[i] = msg.charCodeAt(i);
    }
  }

  return md5ToHexEncodedArray(wordsToMd5(bytesToWords(bytes), bytes.length * 8));
}
/*
 * Convert an array of little-endian words to an array of bytes
 */


function md5ToHexEncodedArray(input) {
  var i;
  var x;
  var output = [];
  var length32 = input.length * 32;
  var hexTab = '0123456789abcdef';
  var hex;

  for (i = 0; i < length32; i += 8) {
    x = input[i >> 5] >>> i % 32 & 0xff;
    hex = parseInt(hexTab.charAt(x >>> 4 & 0x0f) + hexTab.charAt(x & 0x0f), 16);
    output.push(hex);
  }

  return output;
}
/*
 * Calculate the MD5 of an array of little-endian words, and a bit length.
 */


function wordsToMd5(x, len) {
  /* append padding */
  x[len >> 5] |= 0x80 << len % 32;
  x[(len + 64 >>> 9 << 4) + 14] = len;
  var i;
  var olda;
  var oldb;
  var oldc;
  var oldd;
  var a = 1732584193;
  var b = -271733879;
  var c = -1732584194;
  var d = 271733878;

  for (i = 0; i < x.length; i += 16) {
    olda = a;
    oldb = b;
    oldc = c;
    oldd = d;
    a = md5ff(a, b, c, d, x[i], 7, -680876936);
    d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
    c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
    b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
    a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
    d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
    c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
    b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
    a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
    d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
    c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
    b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
    a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
    d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
    c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
    b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
    a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
    d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
    c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
    b = md5gg(b, c, d, a, x[i], 20, -373897302);
    a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
    d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
    c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
    b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
    a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
    d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
    c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
    b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
    a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
    d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
    c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
    b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);
    a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
    d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
    c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
    b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
    a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
    d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
    c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
    b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
    a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
    d = md5hh(d, a, b, c, x[i], 11, -358537222);
    c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
    b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
    a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
    d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
    c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
    b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);
    a = md5ii(a, b, c, d, x[i], 6, -198630844);
    d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
    c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
    b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
    a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
    d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
    c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
    b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
    a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
    d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
    c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
    b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
    a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
    d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
    c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
    b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);
    a = safeAdd(a, olda);
    b = safeAdd(b, oldb);
    c = safeAdd(c, oldc);
    d = safeAdd(d, oldd);
  }

  return [a, b, c, d];
}
/*
 * Convert an array bytes to an array of little-endian words
 * Characters >255 have their high-byte silently ignored.
 */


function bytesToWords(input) {
  var i;
  var output = [];
  output[(input.length >> 2) - 1] = undefined;

  for (i = 0; i < output.length; i += 1) {
    output[i] = 0;
  }

  var length8 = input.length * 8;

  for (i = 0; i < length8; i += 8) {
    output[i >> 5] |= (input[i / 8] & 0xff) << i % 32;
  }

  return output;
}
/*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */


function safeAdd(x, y) {
  var lsw = (x & 0xffff) + (y & 0xffff);
  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return msw << 16 | lsw & 0xffff;
}
/*
 * Bitwise rotate a 32-bit number to the left.
 */


function bitRotateLeft(num, cnt) {
  return num << cnt | num >>> 32 - cnt;
}
/*
 * These functions implement the four basic operations the algorithm uses.
 */


function md5cmn(q, a, b, x, s, t) {
  return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
}

function md5ff(a, b, c, d, x, s, t) {
  return md5cmn(b & c | ~b & d, a, b, x, s, t);
}

function md5gg(a, b, c, d, x, s, t) {
  return md5cmn(b & d | c & ~d, a, b, x, s, t);
}

function md5hh(a, b, c, d, x, s, t) {
  return md5cmn(b ^ c ^ d, a, b, x, s, t);
}

function md5ii(a, b, c, d, x, s, t) {
  return md5cmn(c ^ (b | ~d), a, b, x, s, t);
}

/* harmony default export */ __webpack_exports__["a"] = (md5);

/***/ }),

/***/ "./node_modules/uuid/dist/esm-browser/rng.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = rng;
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
// getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
// find the complete implementation of crypto (msCrypto) on IE11.
var getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

function rng() {
  if (!getRandomValues) {
    throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
  }

  return getRandomValues(rnds8);
}

/***/ }),

/***/ "./node_modules/uuid/dist/esm-browser/sha1.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Adapted from Chris Veness' SHA1 code at
// http://www.movable-type.co.uk/scripts/sha1.html
function f(s, x, y, z) {
  switch (s) {
    case 0:
      return x & y ^ ~x & z;

    case 1:
      return x ^ y ^ z;

    case 2:
      return x & y ^ x & z ^ y & z;

    case 3:
      return x ^ y ^ z;
  }
}

function ROTL(x, n) {
  return x << n | x >>> 32 - n;
}

function sha1(bytes) {
  var K = [0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xca62c1d6];
  var H = [0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0];

  if (typeof bytes == 'string') {
    var msg = unescape(encodeURIComponent(bytes)); // UTF8 escape

    bytes = new Array(msg.length);

    for (var i = 0; i < msg.length; i++) {
      bytes[i] = msg.charCodeAt(i);
    }
  }

  bytes.push(0x80);
  var l = bytes.length / 4 + 2;
  var N = Math.ceil(l / 16);
  var M = new Array(N);

  for (var i = 0; i < N; i++) {
    M[i] = new Array(16);

    for (var j = 0; j < 16; j++) {
      M[i][j] = bytes[i * 64 + j * 4] << 24 | bytes[i * 64 + j * 4 + 1] << 16 | bytes[i * 64 + j * 4 + 2] << 8 | bytes[i * 64 + j * 4 + 3];
    }
  }

  M[N - 1][14] = (bytes.length - 1) * 8 / Math.pow(2, 32);
  M[N - 1][14] = Math.floor(M[N - 1][14]);
  M[N - 1][15] = (bytes.length - 1) * 8 & 0xffffffff;

  for (var i = 0; i < N; i++) {
    var W = new Array(80);

    for (var t = 0; t < 16; t++) {
      W[t] = M[i][t];
    }

    for (var t = 16; t < 80; t++) {
      W[t] = ROTL(W[t - 3] ^ W[t - 8] ^ W[t - 14] ^ W[t - 16], 1);
    }

    var a = H[0];
    var b = H[1];
    var c = H[2];
    var d = H[3];
    var e = H[4];

    for (var t = 0; t < 80; t++) {
      var s = Math.floor(t / 20);
      var T = ROTL(a, 5) + f(s, b, c, d) + e + K[s] + W[t] >>> 0;
      e = d;
      d = c;
      c = ROTL(b, 30) >>> 0;
      b = a;
      a = T;
    }

    H[0] = H[0] + a >>> 0;
    H[1] = H[1] + b >>> 0;
    H[2] = H[2] + c >>> 0;
    H[3] = H[3] + d >>> 0;
    H[4] = H[4] + e >>> 0;
  }

  return [H[0] >> 24 & 0xff, H[0] >> 16 & 0xff, H[0] >> 8 & 0xff, H[0] & 0xff, H[1] >> 24 & 0xff, H[1] >> 16 & 0xff, H[1] >> 8 & 0xff, H[1] & 0xff, H[2] >> 24 & 0xff, H[2] >> 16 & 0xff, H[2] >> 8 & 0xff, H[2] & 0xff, H[3] >> 24 & 0xff, H[3] >> 16 & 0xff, H[3] >> 8 & 0xff, H[3] & 0xff, H[4] >> 24 & 0xff, H[4] >> 16 & 0xff, H[4] >> 8 & 0xff, H[4] & 0xff];
}

/* harmony default export */ __webpack_exports__["a"] = (sha1);

/***/ }),

/***/ "./node_modules/uuid/dist/esm-browser/v1.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rng_js__ = __webpack_require__("./node_modules/uuid/dist/esm-browser/rng.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bytesToUuid_js__ = __webpack_require__("./node_modules/uuid/dist/esm-browser/bytesToUuid.js");

 // **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

var _nodeId;

var _clockseq; // Previous uuid creation time


var _lastMSecs = 0;
var _lastNSecs = 0; // See https://github.com/uuidjs/uuid for API details

function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];
  options = options || {};
  var node = options.node || _nodeId;
  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq; // node and clockseq need to be initialized to random values if they're not
  // specified.  We do this lazily to minimize issues related to insufficient
  // system entropy.  See #189

  if (node == null || clockseq == null) {
    var seedBytes = options.random || (options.rng || __WEBPACK_IMPORTED_MODULE_0__rng_js__["a" /* default */])();

    if (node == null) {
      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
      node = _nodeId = [seedBytes[0] | 0x01, seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]];
    }

    if (clockseq == null) {
      // Per 4.2.2, randomize (14 bit) clockseq
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
  } // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.


  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime(); // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock

  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1; // Time since last uuid creation (in msecs)

  var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000; // Per 4.2.1.2, Bump clockseq on clock regression

  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  } // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval


  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  } // Per 4.2.1.2 Throw error if too many uuids are requested


  if (nsecs >= 10000) {
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq; // Per 4.1.4 - Convert from unix epoch to Gregorian epoch

  msecs += 12219292800000; // `time_low`

  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff; // `time_mid`

  var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff; // `time_high_and_version`

  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version

  b[i++] = tmh >>> 16 & 0xff; // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)

  b[i++] = clockseq >>> 8 | 0x80; // `clock_seq_low`

  b[i++] = clockseq & 0xff; // `node`

  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf ? buf : Object(__WEBPACK_IMPORTED_MODULE_1__bytesToUuid_js__["a" /* default */])(b);
}

/* harmony default export */ __webpack_exports__["a"] = (v1);

/***/ }),

/***/ "./node_modules/uuid/dist/esm-browser/v3.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__v35_js__ = __webpack_require__("./node_modules/uuid/dist/esm-browser/v35.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__md5_js__ = __webpack_require__("./node_modules/uuid/dist/esm-browser/md5.js");


var v3 = Object(__WEBPACK_IMPORTED_MODULE_0__v35_js__["a" /* default */])('v3', 0x30, __WEBPACK_IMPORTED_MODULE_1__md5_js__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (v3);

/***/ }),

/***/ "./node_modules/uuid/dist/esm-browser/v35.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DNS */
/* unused harmony export URL */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bytesToUuid_js__ = __webpack_require__("./node_modules/uuid/dist/esm-browser/bytesToUuid.js");


function uuidToBytes(uuid) {
  // Note: We assume we're being passed a valid uuid string
  var bytes = [];
  uuid.replace(/[a-fA-F0-9]{2}/g, function (hex) {
    bytes.push(parseInt(hex, 16));
  });
  return bytes;
}

function stringToBytes(str) {
  str = unescape(encodeURIComponent(str)); // UTF8 escape

  var bytes = new Array(str.length);

  for (var i = 0; i < str.length; i++) {
    bytes[i] = str.charCodeAt(i);
  }

  return bytes;
}

var DNS = '6ba7b810-9dad-11d1-80b4-00c04fd430c8';
var URL = '6ba7b811-9dad-11d1-80b4-00c04fd430c8';
/* harmony default export */ __webpack_exports__["a"] = (function (name, version, hashfunc) {
  var generateUUID = function generateUUID(value, namespace, buf, offset) {
    var off = buf && offset || 0;
    if (typeof value == 'string') value = stringToBytes(value);
    if (typeof namespace == 'string') namespace = uuidToBytes(namespace);
    if (!Array.isArray(value)) throw TypeError('value must be an array of bytes');
    if (!Array.isArray(namespace) || namespace.length !== 16) throw TypeError('namespace must be uuid string or an Array of 16 byte values'); // Per 4.3

    var bytes = hashfunc(namespace.concat(value));
    bytes[6] = bytes[6] & 0x0f | version;
    bytes[8] = bytes[8] & 0x3f | 0x80;

    if (buf) {
      for (var idx = 0; idx < 16; ++idx) {
        buf[off + idx] = bytes[idx];
      }
    }

    return buf || Object(__WEBPACK_IMPORTED_MODULE_0__bytesToUuid_js__["a" /* default */])(bytes);
  }; // Function#name is not settable on some platforms (#270)


  try {
    generateUUID.name = name;
  } catch (err) {} // For CommonJS default export support


  generateUUID.DNS = DNS;
  generateUUID.URL = URL;
  return generateUUID;
});

/***/ }),

/***/ "./node_modules/uuid/dist/esm-browser/v4.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rng_js__ = __webpack_require__("./node_modules/uuid/dist/esm-browser/rng.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bytesToUuid_js__ = __webpack_require__("./node_modules/uuid/dist/esm-browser/bytesToUuid.js");



function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof options == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }

  options = options || {};
  var rnds = options.random || (options.rng || __WEBPACK_IMPORTED_MODULE_0__rng_js__["a" /* default */])(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || Object(__WEBPACK_IMPORTED_MODULE_1__bytesToUuid_js__["a" /* default */])(rnds);
}

/* harmony default export */ __webpack_exports__["a"] = (v4);

/***/ }),

/***/ "./node_modules/uuid/dist/esm-browser/v5.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__v35_js__ = __webpack_require__("./node_modules/uuid/dist/esm-browser/v35.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sha1_js__ = __webpack_require__("./node_modules/uuid/dist/esm-browser/sha1.js");


var v5 = Object(__WEBPACK_IMPORTED_MODULE_0__v35_js__["a" /* default */])('v5', 0x50, __WEBPACK_IMPORTED_MODULE_1__sha1_js__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (v5);

/***/ }),

/***/ "./node_modules/webpack/buildin/amd-define.js":
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),

/***/ "./shared/components/base/client/client-photo/client-photo.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var file_upload_data_service_1 = __webpack_require__("./shared/services/files/file-upload.data.service.ts");
var file_upload_service_1 = __webpack_require__("./shared/services/files/file-upload-service/file-upload.service.ts");
var ClientPhotoComponent = function () {
    function ClientPhotoComponent(fileUploadDataService, fileUploadService) {
        _classCallCheck(this, ClientPhotoComponent);

        this.fileUploadDataService = fileUploadDataService;
        this.fileUploadService = fileUploadService;
        this.unsubscribe = new Subject_1.Subject();
    }

    _createClass(ClientPhotoComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            var _this = this;

            this.fileUploadDataService.newPhoto$.takeUntil(this.unsubscribe).subscribe(function (clientId) {
                if (clientId !== null && typeof clientId !== 'undefined') {
                    if (_this.clientId === clientId) {
                        _this.isPhoto = true;
                        _this.getClientPhoto(_this.clientId);
                    }
                } else if (_this.clientId === null && _this.hasAvatar) {
                    _this.getUserPhoto();
                }
            });
        }
    }, {
        key: "ngOnChanges",
        value: function ngOnChanges() {
            if (this.isPhoto && this.clientId) {
                this.getClientPhoto(this.clientId);
            } else if (this.isPhoto && this.clientId === null) {
                this.getUserPhoto();
            }
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.fileUploadDataService.emitNewPhoto(null);
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "getFile",
        value: function getFile(event) {
            if (event && event.target.files) {
                var img = new Image();
                var file = event.target.files[0];
                if (!this.fileUploadService.isClientPhotoValid(file)) {
                    this.inputFile.nativeElement.value = '';
                    return;
                }
                this.readFile(img, file);
            }
        }
    }, {
        key: "readFile",
        value: function readFile(img, file) {
            var _this2 = this;

            var fileReader = new FileReader();
            fileReader.onloadend = function (loadEvent) {
                img.src = loadEvent.target.result;
                _this2.fileUploadDataService.emitUploadedPhoto({
                    img: img,
                    clientId: _this2.clientId
                });
                _this2.inputFile.nativeElement.value = '';
                _this2.showModal();
            };
            fileReader.readAsDataURL(file);
        }
    }, {
        key: "showModal",
        value: function showModal() {}
    }, {
        key: "getClientPhoto",
        value: function getClientPhoto(clientId) {
            var _this3 = this;

            this.fileUploadDataService.getClientPhoto(clientId).subscribe(function (data) {
                _this3.clientImg = _this3.fileUploadService.objectToBase64String(data);
            });
        }
    }, {
        key: "getUserPhoto",
        value: function getUserPhoto() {
            var _this4 = this;

            this.fileUploadDataService.getUserPhoto().subscribe(function (data) {
                _this4.isPhoto = true;
                _this4.clientImg = _this4.fileUploadService.objectToBase64String(data);
            });
        }
    }]);

    return ClientPhotoComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Boolean)], ClientPhotoComponent.prototype, "isPhoto", void 0);
__decorate([core_1.Input(), __metadata("design:type", Number)], ClientPhotoComponent.prototype, "clientId", void 0);
__decorate([core_1.Input(), __metadata("design:type", Boolean)], ClientPhotoComponent.prototype, "hasAvatar", void 0);
__decorate([core_1.ViewChild('inputFile'), __metadata("design:type", core_1.ElementRef)], ClientPhotoComponent.prototype, "inputFile", void 0);
ClientPhotoComponent = __decorate([core_1.Component({
    selector: '',
    template: ''
}), __metadata("design:paramtypes", [file_upload_data_service_1.FileUploadDataProvider, file_upload_service_1.FileUploadServiceProvider])], ClientPhotoComponent);
exports.ClientPhotoComponent = ClientPhotoComponent;

/***/ }),

/***/ "./shared/components/base/client/client-subscribe-info/client-subscribe-info.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var ClientSubscribeInfoComponent = function ClientSubscribeInfoComponent() {
    _classCallCheck(this, ClientSubscribeInfoComponent);
};
__decorate([core_1.Input(), __metadata("design:type", Object)], ClientSubscribeInfoComponent.prototype, "client", void 0);
ClientSubscribeInfoComponent = __decorate([core_1.Component({
    selector: '',
    template: ''
}), __metadata("design:paramtypes", [])], ClientSubscribeInfoComponent);
exports.ClientSubscribeInfoComponent = ClientSubscribeInfoComponent;

/***/ }),

/***/ "./shared/components/base/client/consent-list/consent-list.model.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var ConsentMethods;
(function (ConsentMethods) {
    ConsentMethods["BY_USER"] = "BY_USER";
    ConsentMethods["BY_CONTRACT"] = "BY_CONTRACT";
    ConsentMethods["BY_QUESTIONNAIRE"] = "BY_QUESTIONNAIRE";
    ConsentMethods["BY_CONTACT_FORM"] = "BY_CONTACT_FORM";
})(ConsentMethods = exports.ConsentMethods || (exports.ConsentMethods = {}));

/***/ }),

/***/ "./shared/components/base/client/consent-list/consent-list.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var consent_list_model_1 = __webpack_require__("./shared/components/base/client/consent-list/consent-list.model.ts");
var ConsentListComponent = function () {
    function ConsentListComponent() {
        _classCallCheck(this, ConsentListComponent);

        this.deleted = new core_1.EventEmitter();
    }

    _createClass(ConsentListComponent, [{
        key: "ngOnChanges",
        value: function ngOnChanges() {
            if (this.consents !== null && typeof this.consents !== 'undefined') {
                this.consents = this.formatOptInMethod(this.consents);
            }
        }
    }, {
        key: "deleteConsent",
        value: function deleteConsent(event, consentId) {
            event.stopImmediatePropagation();
            this.deleted.emit(consentId);
        }
    }, {
        key: "formatOptInMethod",
        value: function formatOptInMethod(consents) {
            return consents.map(function (consent) {
                switch (consent.method) {
                    case consent_list_model_1.ConsentMethods.BY_USER:
                        consent.methodToShow = 'Added by me';
                        return consent;
                    case consent_list_model_1.ConsentMethods.BY_CONTACT_FORM:
                        consent.methodToShow = 'Added by Client via Contact Form';
                        return consent;
                    case consent_list_model_1.ConsentMethods.BY_CONTRACT:
                        consent.methodToShow = 'Added by Client via Contract';
                        return consent;
                    case consent_list_model_1.ConsentMethods.BY_QUESTIONNAIRE:
                        consent.methodToShow = 'Added by Client via Questionnaire';
                        return consent;
                    default:
                        return consent;
                }
            });
        }
    }]);

    return ConsentListComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Array)], ConsentListComponent.prototype, "consents", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], ConsentListComponent.prototype, "deleted", void 0);
ConsentListComponent = __decorate([core_1.Component({
    selector: '',
    template: ''
}), __metadata("design:paramtypes", [])], ConsentListComponent);
exports.ConsentListComponent = ConsentListComponent;

/***/ }),

/***/ "./shared/components/base/client/modals/save-optin-consent-modal/save-optin-consent-modal.html":
/***/ (function(module, exports) {

module.exports = "<section>\n    <div id=\"main-wrapper\" class=\"container w-max-650\">\n        <div id=\"saveOptinConsentModal\" class=\"modal modal-center modal-save-consent fade\" data-backdrop=\"static\"\n             data-keyboard=\"false\">\n            <div class=\"modal-dialog\">\n                <div class=\"modal-content\">\n                    <form #optinForm=\"ngForm\" (ngSubmit)=\"saveOptIn()\">\n                        <div class=\"modal-header\">\n                            <close-btn></close-btn>\n                            <h3 class=\"modal-title\">Add consent</h3>\n                        </div>\n                        <div class=\"modal-body\">\n                            <p class=\"f-s-13\">\n                                You will not need to seek consent from your clients if you are processing their data in\n                                order to perform a contract e.g. providing your services to them.\n                            </p>\n                            <p class=\"mt-15 f-s-13\">\n                                Consent will be required where there is no other lawful basis to process the data e.g. if\n                                you are sending your client information and marketing materials that is not related to the\n                                services performed to the client.\n                            </p>\n                            <p class=\"mt-15 f-s-13\">\n                                Consent given by your client\n                            </p>\n                            <input type=\"text\"\n                                   class=\"form-control\"\n                                   id=\"consentStatement\"\n                                   name=\"consentStatement\"\n                                   autocomplete=\"off\"\n                                   class=\"form-control\"\n                                   [(ngModel)]=\"optinStatementForSave\"\n                                   required>\n                        </div>\n                        <div class=\"modal-footer modal-foot pb-20 flex-row\">\n                            <button type=\"submit\" class=\"btn btn-success btn-submit f-s-13\"\n                                    [disabled]=\"button_disable\"\n                                    spinning-wheel is-spinning-wheel-active=\"isSubscribeClientSpinningWheelActive\"\n                            >I have obtained the above consent from my client\n                            </button>\n                        </div>\n                    </form>\n                </div>\n            </div>\n        </div>\n    </div>\n</section>"

/***/ }),

/***/ "./shared/components/base/client/modals/save-optin-consent-modal/save-optin-consent-modal.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var clients_data_service_1 = __webpack_require__("./shared/services/client/clients.data.service.ts");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var SaveOptinConsentModalComponent = function () {
    function SaveOptinConsentModalComponent(clientsDataService, messageService) {
        _classCallCheck(this, SaveOptinConsentModalComponent);

        this.clientsDataService = clientsDataService;
        this.messageService = messageService;
        this.onSaveOptIn = new core_1.EventEmitter();
        this.unsubscribe = new Subject_1.Subject();
    }

    _createClass(SaveOptinConsentModalComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.optinStatementForSave = this.optinStatement;
            this.resetStatementOnModalHide();
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "saveOptIn",
        value: function saveOptIn() {
            var _this = this;

            if (!this.optinStatementForSave || this.optinStatementForSave.trim().length === 0) {
                return this.messageService.showToaster('e_0', 'consent');
            }
            this.button_disable = true;
            this.clientsDataService.saveOptIn(this.clientId, this.optinStatementForSave).finally(function () {
                return _this.button_disable = false;
            }).subscribe(function () {
                return _this.successSaveOptIn();
            }, function (error) {
                return _this.messageService.showDefaultErrorMessage(error);
            });
        }
    }, {
        key: "successSaveOptIn",
        value: function successSaveOptIn() {
            this.messageService.showToaster('s_1', 'general');
            this.onSaveOptIn.emit();
            $('#saveOptinConsentModal').modal('hide');
        }
    }, {
        key: "resetStatementOnModalHide",
        value: function resetStatementOnModalHide() {
            var vm = this;
            $('#saveOptinConsentModal').on('hidden.bs.modal', function () {
                vm.optinStatementForSave = vm.optinStatement;
            });
        }
    }]);

    return SaveOptinConsentModalComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", String)], SaveOptinConsentModalComponent.prototype, "optinStatement", void 0);
__decorate([core_1.Input(), __metadata("design:type", Number)], SaveOptinConsentModalComponent.prototype, "clientId", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], SaveOptinConsentModalComponent.prototype, "onSaveOptIn", void 0);
SaveOptinConsentModalComponent = __decorate([core_1.Component({
    selector: 'save-optin-consent-modal',
    template: __webpack_require__("./shared/components/base/client/modals/save-optin-consent-modal/save-optin-consent-modal.html")
}), __metadata("design:paramtypes", [clients_data_service_1.ClientsDataServiceProvider, message_service_1.MessageService])], SaveOptinConsentModalComponent);
exports.SaveOptinConsentModalComponent = SaveOptinConsentModalComponent;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./shared/components/base/client/modals/upload-photo-modal/upload-photo-modal.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var ngx_img_cropper_1 = __webpack_require__("./node_modules/ngx-img-cropper/index.js");
var file_upload_data_service_1 = __webpack_require__("./shared/services/files/file-upload.data.service.ts");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var UploadPhotoModalComponent = function () {
    function UploadPhotoModalComponent(fileUploadDataService, messageService) {
        _classCallCheck(this, UploadPhotoModalComponent);

        this.fileUploadDataService = fileUploadDataService;
        this.messageService = messageService;
        this.unsubscribe = new Subject_1.Subject();
        this.cropperSettings = new ngx_img_cropper_1.CropperSettings();
        this.cropperSettings.noFileInput = true;
        this.cropperSettings.canvasWidth = 300;
        this.cropperSettings.rounded = true;
        this.cropperSettings.showCenterMarker = false;
        this.cropperSettings.markerSizeMultiplier = 0.5;
        this.cropperSettings.centerTouchRadius = 80;
        this.cropperSettings.preserveSize = true;
        this.cropperSettings.croppedWidth = 80;
        this.cropperSettings.croppedHeight = 80;
        this.data = {};
    }

    _createClass(UploadPhotoModalComponent, [{
        key: "ngAfterViewInit",
        value: function ngAfterViewInit() {
            var _this = this;

            this.fileUploadDataService.uploadedPhoto$.takeUntil(this.unsubscribe).subscribe(function (data) {
                if (data !== null && typeof data !== 'undefined') {
                    var img = data.img,
                        clientId = data.clientId;

                    _this.cropper.setImage(img);
                    _this.clientId = clientId;
                }
            });
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "hideModal",
        value: function hideModal() {}
    }, {
        key: "savePhoto",
        value: function savePhoto() {
            var _this2 = this;

            this.button_disable = true;
            if (this.clientId !== null) {
                this.fileUploadDataService.uploadClientPhoto(this.data.image, this.clientId).finally(function () {
                    return _this2.button_disable = false;
                }).subscribe(function () {
                    _this2.fileUploadDataService.emitNewPhoto(_this2.clientId);
                    _this2.messageService.showToaster('s_3', 'profile');
                    _this2.hideModal();
                }, function (err) {
                    return _this2.messageService.showDefaultErrorMessage(err);
                });
            } else if (this.clientId === null) {
                this.fileUploadDataService.uploadUserPhoto(this.data.image).finally(function () {
                    return _this2.button_disable = false;
                }).subscribe(function () {
                    _this2.fileUploadDataService.emitNewPhoto(_this2.clientId);
                    _this2.messageService.showToaster('s_3', 'profile');
                    _this2.hideModal();
                }, function (err) {
                    return _this2.messageService.showDefaultErrorMessage(err);
                });
            }
        }
    }]);

    return UploadPhotoModalComponent;
}();
__decorate([core_1.ViewChild('cropper', undefined), __metadata("design:type", ngx_img_cropper_1.ImageCropperComponent)], UploadPhotoModalComponent.prototype, "cropper", void 0);
UploadPhotoModalComponent = __decorate([core_1.Component({
    selector: 'upload-photo-modal',
    template: ''
}), __metadata("design:paramtypes", [file_upload_data_service_1.FileUploadDataProvider, message_service_1.MessageService])], UploadPhotoModalComponent);
exports.UploadPhotoModalComponent = UploadPhotoModalComponent;

/***/ }),

/***/ "./shared/components/common/buttons/close-btn/close-btn.html":
/***/ (function(module, exports) {

module.exports = "<button class=\"close\"\n        data-dismiss=\"modal\"\n        data-autotest-button=\"close\"\n        (click)=\"onBtnClick()\"\n        type=\"button\"\n>&times;</button>\n"

/***/ }),

/***/ "./shared/components/common/buttons/close-btn/close-btn.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var CloseBtnComponent = function () {
    function CloseBtnComponent() {
        _classCallCheck(this, CloseBtnComponent);

        this.action = new core_1.EventEmitter();
    }

    _createClass(CloseBtnComponent, [{
        key: "onBtnClick",
        value: function onBtnClick() {
            this.action.emit();
        }
    }]);

    return CloseBtnComponent;
}();
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], CloseBtnComponent.prototype, "action", void 0);
CloseBtnComponent = __decorate([core_1.Component({
    selector: 'close-btn',
    template: __webpack_require__("./shared/components/common/buttons/close-btn/close-btn.html")
}), __metadata("design:paramtypes", [])], CloseBtnComponent);
exports.CloseBtnComponent = CloseBtnComponent;

/***/ }),

/***/ "./shared/components/common/buttons/insert-variable/insert-variable.component.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"insert-variable-list\" (clickOutside)=\"toggleList(false)\">\n    <button type=\"button\" class=\"btn-link\" (click)=\"toggleList()\">Insert Subject Variable</button>\n    <ul *ngIf=\"openState\" class=\"dropdown-menu no-overflow\">\n        <li *ngFor=\"let variable of variableList\" (click)=\"chooseVariable(variable.key)\"><a>{{ variable.name }}</a></li>\n    </ul>\n</div>\n"

/***/ }),

/***/ "./shared/components/common/buttons/insert-variable/insert-variable.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var variables_to_insert_1 = __webpack_require__("./shared/models/system-variables/variables-to-insert.ts");
var InsertVariableComponent = function () {
    function InsertVariableComponent() {
        _classCallCheck(this, InsertVariableComponent);

        this.onVariableChoose = new core_1.EventEmitter();
        this.variableList = [];
    }

    _createClass(InsertVariableComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.createVariableList();
        }
    }, {
        key: "ngOnChanges",
        value: function ngOnChanges(changes) {
            if (!changes.variableListType.isFirstChange() && changes.variableListType.currentValue) {
                this.createVariableList();
            }
        }
    }, {
        key: "chooseVariable",
        value: function chooseVariable(variable) {
            this.toggleList(false);
            this.onVariableChoose.emit(variable);
        }
    }, {
        key: "toggleList",
        value: function toggleList(state) {
            if (typeof state === 'boolean') {
                this.openState = state;
                return;
            }
            this.openState = !this.openState;
        }
    }, {
        key: "createVariableList",
        value: function createVariableList() {
            var _this = this;

            this.variableList = Object.keys(variables_to_insert_1.variablesList[this.variableListType]).map(function (key) {
                return {
                    key: variables_to_insert_1.variablesList[_this.variableListType][key],
                    name: key
                };
            });
        }
    }]);

    return InsertVariableComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", String)], InsertVariableComponent.prototype, "variableListType", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], InsertVariableComponent.prototype, "onVariableChoose", void 0);
InsertVariableComponent = __decorate([core_1.Component({
    selector: 'insert-variable',
    template: __webpack_require__("./shared/components/common/buttons/insert-variable/insert-variable.component.html")
}), __metadata("design:paramtypes", [])], InsertVariableComponent);
exports.InsertVariableComponent = InsertVariableComponent;

/***/ }),

/***/ "./shared/components/common/email-multiselect/email-multiselect.component.html":
/***/ (function(module, exports) {

module.exports = "<ng-select class=\"ng-select {{customClass}}\"\n           [items]=\"autocompleteValues\"\n           [addTag]=\"true\"\n           [multiple]=\"true\"\n           [hideSelected]=\"true\"\n           [disabled]=\"disabled\"\n           [loading]=\"loading\"\n           typeToSearchText=\"Please enter 3 or more characters\"\n           [typeahead]=\"autocomplete\"\n           [(ngModel)]=\"selectedValues\"\n           [maxSelectedItems]=\"maxAllowedAmount\"\n           [placeholder]=\"placeholder\"\n           [searchable]=\"selectedValues.length < maxAllowedAmount\"\n           (change)=\"emitSelectChange($event)\">\n\n    <ng-template ng-label-tmp let-item=\"item\" let-clear=\"clear\">\n        <span class=\"ng-value-label\">{{ item.email || item.label || item }}</span>\n        <span class=\"ng-value-icon right\" (click)=\"clear(item)\" aria-hidden=\"true\">×</span>\n    </ng-template>\n\n    <ng-template ng-option-tmp let-item=\"item\" let-search=\"searchTerm\">\n        <div [ngOptionHighlight]=\"search\">{{ item.name }}</div>\n    </ng-template>\n</ng-select>"

/***/ }),

/***/ "./shared/components/common/email-multiselect/email-multiselect.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var rxjs_1 = __webpack_require__("./node_modules/rxjs/Rx.js");
var EmailMultiselectComponent = function () {
    function EmailMultiselectComponent() {
        _classCallCheck(this, EmailMultiselectComponent);

        this.autocompleteValues = [];
        this.value = [];
        this.valueChanges = new core_1.EventEmitter();
        this.peopleLoading = false;
        this.selectedValues = [];
    }

    _createClass(EmailMultiselectComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            if (this.value) {
                this.selectedValues = [].concat(_toConsumableArray(this.value));
            }
        }
    }, {
        key: "ngOnChanges",
        value: function ngOnChanges(changes) {
            if (changes.value && changes.value.currentValue) {
                this.selectedValues = [].concat(_toConsumableArray(this.value));
            }
        }
    }, {
        key: "emitSelectChange",
        value: function emitSelectChange(ev) {
            this.valueChanges.emit(ev);
        }
    }]);

    return EmailMultiselectComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Boolean)], EmailMultiselectComponent.prototype, "disabled", void 0);
__decorate([core_1.Input(), __metadata("design:type", Boolean)], EmailMultiselectComponent.prototype, "loading", void 0);
__decorate([core_1.Input(), __metadata("design:type", rxjs_1.Subject)], EmailMultiselectComponent.prototype, "autocomplete", void 0);
__decorate([core_1.Input(), __metadata("design:type", Array)], EmailMultiselectComponent.prototype, "autocompleteValues", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], EmailMultiselectComponent.prototype, "placeholder", void 0);
__decorate([core_1.Input(), __metadata("design:type", Array)], EmailMultiselectComponent.prototype, "value", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], EmailMultiselectComponent.prototype, "customClass", void 0);
__decorate([core_1.Input(), __metadata("design:type", Number)], EmailMultiselectComponent.prototype, "maxAllowedAmount", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], EmailMultiselectComponent.prototype, "valueChanges", void 0);
EmailMultiselectComponent = __decorate([core_1.Component({
    selector: 'email-multiselect',
    template: __webpack_require__("./shared/components/common/email-multiselect/email-multiselect.component.html")
}), __metadata("design:paramtypes", [])], EmailMultiselectComponent);
exports.EmailMultiselectComponent = EmailMultiselectComponent;

/***/ }),

/***/ "./shared/components/common/lead-source-color/lead-source-color.html":
/***/ (function(module, exports) {

module.exports = "<span class=\"lead-source-colour-sign\" [ngStyle]=\"{'backgroundColor': color, 'border': '1px solid' + borderColor}\"></span>\n"

/***/ }),

/***/ "./shared/components/common/lead-source-color/lead-source-color.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var color_service_1 = __webpack_require__("./shared/services/utils/color.service.ts");
var LeadSourceColorComponent = function () {
    function LeadSourceColorComponent(colorService) {
        _classCallCheck(this, LeadSourceColorComponent);

        this.colorService = colorService;
        // -100 to 0 is darkened
        // 0 to 100 is lighten
        this.borderShadePercentage = -20;
    }

    _createClass(LeadSourceColorComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.changeBorderColor();
        }
    }, {
        key: "ngOnChanges",
        value: function ngOnChanges(changes) {
            if (!changes.color.isFirstChange() && changes.color.currentValue) {
                this.changeBorderColor();
            }
        }
    }, {
        key: "changeBorderColor",
        value: function changeBorderColor() {
            if (this.color) {
                this.borderColor = this.colorService.shadeColor(this.color, this.borderShadePercentage);
            }
        }
    }]);

    return LeadSourceColorComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", String)], LeadSourceColorComponent.prototype, "color", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], LeadSourceColorComponent.prototype, "borderShadePercentage", void 0);
LeadSourceColorComponent = __decorate([core_1.Component({
    selector: 'lead-source-color',
    template: __webpack_require__("./shared/components/common/lead-source-color/lead-source-color.html")
}), __metadata("design:paramtypes", [color_service_1.ColorService])], LeadSourceColorComponent);
exports.LeadSourceColorComponent = LeadSourceColorComponent;

/***/ }),

/***/ "./shared/components/common/main-shoot-date/main-shoot-date.html":
/***/ (function(module, exports) {

module.exports = "<span>\n    <span *ngIf=\"startDate\">\n        {{ startDate | timeFilter: setStartDateFilter() }}\n        <span *ngIf=\"startDate != finishDate\">\n             - <span class=\"text-nowrap\">{{ finishDate | timeFilter: fromQuote ? 'long' : 'medium' }}</span>\n        </span>\n    </span>\n    <span *ngIf=\"!startDate\">No date</span>\n</span>"

/***/ }),

/***/ "./shared/components/common/main-shoot-date/main-shoot-date.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var time_service_1 = __webpack_require__("./shared/services/helpers/time-service/time.service.ts");
var MainShootDateComponent = function () {
    function MainShootDateComponent(timeService) {
        _classCallCheck(this, MainShootDateComponent);

        this.timeService = timeService;
    }

    _createClass(MainShootDateComponent, [{
        key: "setStartDateFilter",
        value: function setStartDateFilter() {
            var isYearsEqual = this.timeService.compareYears(this.startDate, this.finishDate);
            var isDatesDifferent = this.timeService.compareDates(this.startDate, this.finishDate);
            var onlyYearsAreEqual = isYearsEqual && isDatesDifferent;
            if (onlyYearsAreEqual) {
                return this.fromQuote ? 'dayAndLongMonth' : 'dayAndMonth';
            }
            return this.fromQuote ? 'long' : 'medium';
        }
    }]);

    return MainShootDateComponent;
}();
__decorate([core_1.Input('start-date'), __metadata("design:type", Object)], MainShootDateComponent.prototype, "startDate", void 0);
__decorate([core_1.Input('finish-date'), __metadata("design:type", Object)], MainShootDateComponent.prototype, "finishDate", void 0);
__decorate([core_1.Input('fromQuote'), __metadata("design:type", Object)], MainShootDateComponent.prototype, "fromQuote", void 0);
MainShootDateComponent = __decorate([core_1.Component({
    selector: 'main-shoot-date',
    template: __webpack_require__("./shared/components/common/main-shoot-date/main-shoot-date.html")
}), __metadata("design:paramtypes", [time_service_1.TimeServiceProvider])], MainShootDateComponent);
exports.MainShootDateComponent = MainShootDateComponent;

/***/ }),

/***/ "./shared/components/common/opt-in-agreement/opt-in-agreement.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"flex-row mt-30 print-d-inline\" *ngIf=\"data && data.showOptInConsent\">\n    <div class=\"checkbox-squared ml-1\">\n        <input type=\"checkbox\"\n               name=\"optInConsent\"\n               id=\"{{'optInConsent'+data.id}}\"\n               [disabled]=\"isOptInDisabled\"\n               [checked]=\"data.optInConsent\"\n               (change)=\"changeOptInAgreement()\"/>\n        <label for=\"{{'optInConsent'+data.id}}\"></label>\n    </div>\n    <label for=\"{{'optInConsent'+data.id}}\">\n        {{ data.optInConsentStatement }}\n    </label>\n</div>"

/***/ }),

/***/ "./shared/components/common/opt-in-agreement/opt-in-agreement.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var OptInAgreementComponent = function () {
    function OptInAgreementComponent() {
        _classCallCheck(this, OptInAgreementComponent);

        this.onOptInChange = new core_1.EventEmitter();
    }

    _createClass(OptInAgreementComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {}
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {}
    }, {
        key: "changeOptInAgreement",
        value: function changeOptInAgreement() {
            this.data.optInConsent = !this.data.optInConsent;
            this.onOptInChange.emit(this.data.optInConsent);
        }
    }]);

    return OptInAgreementComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], OptInAgreementComponent.prototype, "data", void 0);
__decorate([core_1.Input(), __metadata("design:type", Boolean)], OptInAgreementComponent.prototype, "isOptInDisabled", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], OptInAgreementComponent.prototype, "onOptInChange", void 0);
OptInAgreementComponent = __decorate([core_1.Component({
    selector: 'opt-in-agreement',
    template: __webpack_require__("./shared/components/common/opt-in-agreement/opt-in-agreement.html")
}), __metadata("design:paramtypes", [])], OptInAgreementComponent);
exports.OptInAgreementComponent = OptInAgreementComponent;

/***/ }),

/***/ "./shared/components/common/questionnaire-submitted-statement/questionnaire-submitted-statement.html":
/***/ (function(module, exports) {

module.exports = "<p *ngIf=\"questionnaire && questionnaire.submitDate\" class=\"green-light-label text-semi-bold mb-15\">\n    Answers submitted\n    <span class=\"green-light-label\" *ngIf=\"questionnaire.showOptInConsent\">\n        {{ questionnaire.optInConsent ? 'with' : 'without' }} opt-in consent\n    </span>\n    on {{ questionnaire.submitDate| timeFilter: 'long' }}\n</p>\n"

/***/ }),

/***/ "./shared/components/common/questionnaire-submitted-statement/questionnaire-submitted-statement.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var QuestionnaireSubmittedStatementComponent = function () {
    function QuestionnaireSubmittedStatementComponent() {
        _classCallCheck(this, QuestionnaireSubmittedStatementComponent);
    }

    _createClass(QuestionnaireSubmittedStatementComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {}
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {}
    }]);

    return QuestionnaireSubmittedStatementComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], QuestionnaireSubmittedStatementComponent.prototype, "questionnaire", void 0);
QuestionnaireSubmittedStatementComponent = __decorate([core_1.Component({
    selector: 'questionnaire-submitted-statement',
    template: __webpack_require__("./shared/components/common/questionnaire-submitted-statement/questionnaire-submitted-statement.html"),
    changeDetection: core_1.ChangeDetectionStrategy.OnPush
}), __metadata("design:paramtypes", [])], QuestionnaireSubmittedStatementComponent);
exports.QuestionnaireSubmittedStatementComponent = QuestionnaireSubmittedStatementComponent;

/***/ }),

/***/ "./shared/components/common/sn-label/sn-label.html":
/***/ (function(module, exports) {

module.exports = "<label class=\"label sn-label label-status label-response {{color}}\">\n  <ng-content></ng-content>\n  <span>{{ text }}</span>\n</label>\n"

/***/ }),

/***/ "./shared/components/common/sn-label/sn-label.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var SnLabelComponent = function SnLabelComponent() {
    _classCallCheck(this, SnLabelComponent);
};
__decorate([core_1.Input(), __metadata("design:type", String)], SnLabelComponent.prototype, "text", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], SnLabelComponent.prototype, "color", void 0);
SnLabelComponent = __decorate([core_1.Component({
    selector: 'sn-label',
    template: __webpack_require__("./shared/components/common/sn-label/sn-label.html")
}), __metadata("design:paramtypes", [])], SnLabelComponent);
exports.SnLabelComponent = SnLabelComponent;

/***/ }),

/***/ "./shared/components/common/sn-quill-editor/BaseModule.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BaseModule = exports.BaseModule = function () {
    function BaseModule(resizer) {
        _classCallCheck(this, BaseModule);

        this.overlay = resizer.overlay;
        this.img = resizer.img;
        this.options = resizer.options;
        this.requestUpdate = resizer.onUpdate;

        this.onCreate = this.onCreate.bind(this);
        this.onDestroy = this.onDestroy.bind(this);
        this.onUpdate = this.onUpdate.bind(this);
    }
    /*
        requestUpdate (passed in by the library during construction, above) can be used to let the library know that
        you've changed something about the image that would require re-calculating the overlay (and all of its child
        elements)
         For example, if you add a margin to the element, you'll want to call this or else all the controls will be
        misaligned on-screen.
     */

    /*
        onCreate will be called when the element is clicked on
         If the module has any user controls, it should create any containers that it'll need here.
        The overlay has absolute positioning, and will be automatically repositioned and resized as needed, so you can
        use your own absolute positioning and the 'top', 'right', etc. styles to be positioned relative to the element
        on-screen.
     */


    _createClass(BaseModule, [{
        key: "onCreate",
        value: function onCreate() {}
    }, {
        key: "onDestroy",


        /*
            onDestroy will be called when the element is de-selected, or when this module otherwise needs to tidy up.
             If you created any DOM elements in onCreate, please remove them from the DOM and destroy them here.
         */
        value: function onDestroy() {}
    }, {
        key: "onUpdate",


        /*
            onUpdate will be called any time that the element is changed (e.g. resized, aligned, etc.)
             This frequently happens during resize dragging, so keep computations light while here to ensure a smooth
            user experience.
         */
        value: function onUpdate() {}
    }]);

    return BaseModule;
}();

/***/ }),

/***/ "./shared/components/common/sn-quill-editor/Toolbar.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Toolbar = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _quill = __webpack_require__("./node_modules/quill/dist/quill.js");

var _quill2 = _interopRequireDefault(_quill);

var _BaseModule2 = __webpack_require__("./shared/components/common/sn-quill-editor/BaseModule.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Parchment = _quill2.default.imports.parchment;
var FloatStyle = new Parchment.Attributor.Style('float', 'float');
var MarginStyle = new Parchment.Attributor.Style('margin', 'margin');
var DisplayStyle = new Parchment.Attributor.Style('display', 'display');

var Toolbar = exports.Toolbar = function (_BaseModule) {
	_inherits(Toolbar, _BaseModule);

	function Toolbar(resizer) {
		_classCallCheck(this, Toolbar);

		var _this = _possibleConstructorReturn(this, (Toolbar.__proto__ || Object.getPrototypeOf(Toolbar)).call(this, resizer));

		_this._defineAlignments = _this._defineAlignments.bind(_this);
		_this._addToolbarButtons = _this._addToolbarButtons.bind(_this);
		_this._selectButton = _this._selectButton.bind(_this);
		return _this;
	}

	_createClass(Toolbar, [{
		key: 'onCreate',
		value: function onCreate() {
			// Setup Toolbar
			this.toolbar = document.createElement('div');
			Object.assign(this.toolbar.style, this.options.toolbarStyles);
			this.overlay.appendChild(this.toolbar);

			// Setup Buttons
			this._defineAlignments();
			this._addToolbarButtons();
		}

		// The toolbar and its children will be destroyed when the overlay is removed

	}, {
		key: 'onDestroy',
		value: function onDestroy() {}

		// Nothing to update on drag because we are are positioned relative to the overlay

	}, {
		key: 'onUpdate',
		value: function onUpdate() {}
	}, {
		key: '_defineAlignments',
		value: function _defineAlignments() {
			var _this2 = this;

			this.alignments = [{
				icon: '<svg viewbox="0 0 18 18"><line class="ql-stroke" x1="3" x2="15" y1="9" y2="9"></line><line class="ql-stroke" x1="3" x2="13" y1="14" y2="14"></line><line class="ql-stroke" x1="3" x2="9" y1="4" y2="4"></line></svg>',
				apply: function apply() {
					DisplayStyle.add(_this2.img, 'inline');
					FloatStyle.add(_this2.img, 'left');
					MarginStyle.remove(_this2.img);
					_this2.img.align = 'left';
				},
				isApplied: function isApplied() {
					return FloatStyle.value(_this2.img) == 'left';
				}
			}, {
				icon: '<svg viewbox="0 0 18 18"><line class="ql-stroke" x1="15" x2="3" y1="9" y2="9"></line><line class="ql-stroke" x1="14" x2="4" y1="14" y2="14"></line><line class="ql-stroke" x1="12" x2="6" y1="4" y2="4"></line></svg>',
				apply: function apply() {
					DisplayStyle.add(_this2.img, 'block');
					FloatStyle.remove(_this2.img);
					MarginStyle.add(_this2.img, 'auto');
					_this2.img.align = 'center';
				},
				isApplied: function isApplied() {
					return MarginStyle.value(_this2.img) == 'auto';
				}
			}, {
				icon: '<svg viewbox="0 0 18 18"><line class="ql-stroke" x1="15" x2="3" y1="9" y2="9"></line><line class="ql-stroke" x1="15" x2="5" y1="14" y2="14"></line><line class="ql-stroke" x1="15" x2="9" y1="4" y2="4"></line></svg>',
				apply: function apply() {
					DisplayStyle.add(_this2.img, 'inline');
					FloatStyle.add(_this2.img, 'right');
					MarginStyle.remove(_this2.img);
					_this2.img.align = 'right';
				},
				isApplied: function isApplied() {
					return FloatStyle.value(_this2.img) == 'right';
				}
			}];
		}
	}, {
		key: '_addToolbarButtons',
		value: function _addToolbarButtons() {
			var _this3 = this;

			var buttons = [];
			this.alignments.forEach(function (alignment, idx) {
				var button = document.createElement('span');
				buttons.push(button);
				button.innerHTML = alignment.icon;
				button.addEventListener('click', function () {
					// deselect all buttons
					buttons.forEach(function (button) {
						return button.style.filter = '';
					});
					if (alignment.isApplied()) {
						// If applied, unapply
						FloatStyle.remove(_this3.img);
						MarginStyle.remove(_this3.img);
						DisplayStyle.remove(_this3.img);
					} else {
						// otherwise, select button and apply
						_this3._selectButton(button);
						alignment.apply();
					}
					// image may change position; redraw drag handles
					_this3.requestUpdate();
				});
				Object.assign(button.style, _this3.options.toolbarButtonStyles);
				if (idx > 0) {
					button.style.borderLeftWidth = '0';
				}
				Object.assign(button.children[0].style, _this3.options.toolbarButtonSvgStyles);
				if (alignment.isApplied()) {
					// select button if previously applied
					_this3._selectButton(button);
				}
				_this3.toolbar.appendChild(button);
			});
		}
	}, {
		key: '_selectButton',
		value: function _selectButton(button) {
			button.style.filter = 'invert(20%)';
		}
	}]);

	return Toolbar;
}(_BaseModule2.BaseModule);

/***/ }),

/***/ "./shared/components/common/sn-quill-editor/counter.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__("./node_modules/quill/dist/quill.js");

var Counter = function () {
    function Counter(quill, options) {
        var _this = this;

        _classCallCheck(this, Counter);

        this.quill = quill;
        this.options = options;
        this.currentLength = this.options.currentLength;
        var container = document.getElementById(this.options.container);
        container.innerHTML = "0/" + this.options.maxLength;
        this.quill.on('text-change', function () {
            var length = _this.calculate();
            _this.checkOutOfLimit(length, container);
            _this.currentLength(length);
            container.innerHTML = length + "/" + _this.options.maxLength;
        });
    }

    _createClass(Counter, [{
        key: "calculate",
        value: function calculate() {
            var text = this.quill.getText();
            return text.length;
        }
    }, {
        key: "checkOutOfLimit",
        value: function checkOutOfLimit(length, container) {
            if (length > this.options.maxLength) {
                if (!container.classList.contains('red')) {
                    container.classList.add('red');
                }
            } else if (container.classList.contains('red')) {
                container.classList.remove('red');
            }
        }
    }]);

    return Counter;
}();

exports.default = Counter;

/***/ }),

/***/ "./shared/components/common/sn-quill-editor/image-drop.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__("./node_modules/quill/dist/quill.js");
/**
 * Custom module for quilljs to allow user to drag images from their file system into the editor
 * and paste images from clipboard (Works on Chrome, Firefox, Edge, not on Safari)
 * @see https://quilljs.com/blog/building-a-custom-module/
 */

var ImageDrop = function () {
    /**
     * Instantiate the module given a quill instance and any options
     * @param {Quill} quill
     * @param {Object} options
     */
    function ImageDrop(quill) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        _classCallCheck(this, ImageDrop);

        // save the quill reference
        this.quill = quill;
        this.options = options;
        // bind handlers to this instance
        this.handleDrop = this.handleDrop.bind(this);
        this.handlePaste = this.handlePaste.bind(this);
        // listen for drop and paste events
        this.quill.root.addEventListener('drop', this.handleDrop, false);
        this.quill.root.addEventListener('paste', this.handlePaste, false);
    }
    /**
     * Handler for drop event to read dropped files from evt.dataTransfer
     * @param {Event} evt
     */


    _createClass(ImageDrop, [{
        key: "handleDrop",
        value: function handleDrop(evt) {
            evt.preventDefault();
            if (evt.dataTransfer && evt.dataTransfer.files && evt.dataTransfer.files.length) {
                if (!this.options.images) {
                    return;
                }
                if (this.options.loadImage) {
                    this.loadImages(evt.dataTransfer.files);
                } else if (document.caretRangeFromPoint) {
                    var selection = document.getSelection();
                    var range = document.caretRangeFromPoint(evt.clientX, evt.clientY);
                    if (selection && range) {
                        selection.setBaseAndExtent(range.startContainer, range.startOffset, range.startContainer, range.startOffset);
                    }
                }
                this.readFiles(evt.dataTransfer.files, this.insert.bind(this));
            }
        }
        /**
         * Handler for paste event to read pasted files from evt.clipboardData
         * @param {Event} evt
         */

    }, {
        key: "handlePaste",
        value: function handlePaste(evt) {
            var _this = this;

            if (evt.clipboardData && evt.clipboardData.files && evt.clipboardData.files.length) {
                evt.preventDefault();
                if (!this.options.images) {
                    return;
                }
                if (this.options.loadImage) {
                    this.loadImages(evt.clipboardData.files);
                } else {
                    this.readFiles(evt.clipboardData.files, function (dataUrl) {
                        var selection = _this.quill.getSelection();
                        if (selection) {
                            // we must be in a browser that supports pasting (like Firefox)
                            // so it has already been placed into the editor
                            _this.insert(dataUrl);
                        } else {
                            // otherwise we wait until after the paste when this.quill.getSelection()
                            // will return a valid index
                            setTimeout(function () {
                                return _this.insert(dataUrl);
                            }, 0);
                        }
                    });
                }
            }
        }
    }, {
        key: "loadImages",
        value: function loadImages(files) {
            var maxFileSize = 2 * 1000 * 1000;
            if (files.length > 1) {
                this.sendErrorEvent('MULTIPLE');
                return;
            }
            var file = files[0];
            if (!file.type.match(/^image\/(jpe?g|a?png|bmp\.microsoft\.icon)/i)) {
                // file is not an image
                // Note that some file formats such as psd start with image/* but are not readable
                this.sendErrorEvent('TYPE');
                return;
            }
            if (file.size > maxFileSize) {
                this.sendErrorEvent('SIZE');
                return;
            }
            this.options.loadImage(file);
        }
        /**
         * Insert the image into the document at the current cursor position
         * @param {String} dataUrl  The base64-encoded image URI
         */

    }, {
        key: "insert",
        value: function insert(dataUrl) {
            var index = (this.quill.getSelection() || {}).index || this.quill.getLength();
            this.quill.insertEmbed(index, 'image', dataUrl, 'user');
        }
        /**
         * Extract image URIs a list of files from evt.dataTransfer or evt.clipboardData
         * @param {File[]} files  One or more File objects
         * @param {Function} callback  A function to send each data URI to
         */

    }, {
        key: "readFiles",
        value: function readFiles(files, callback) {
            var _this2 = this;

            var maxFileSize = 2 * 1000 * 1000;
            if (files.length > 1) {
                this.sendErrorEvent('MULTIPLE');
                return;
            }
            [].forEach.call(files, function (file) {
                if (!file.type.match(/^image\/(jpe?g|a?png|bmp\.microsoft\.icon)/i)) {
                    // file is not an image
                    // Note that some file formats such as psd start with image/* but are not readable
                    _this2.sendErrorEvent('TYPE');
                    return;
                }
                if (file.size > maxFileSize) {
                    _this2.sendErrorEvent('SIZE');
                    return;
                }
                // set up file reader
                var reader = new FileReader();
                reader.onload = function (evt) {
                    callback(evt.target.result);
                };
                // read the clipboard item or file
                var blob = file.getAsFile ? file.getAsFile() : file;
                if (blob instanceof Blob) {
                    reader.readAsDataURL(blob);
                }
            });
        }
    }, {
        key: "sendErrorEvent",
        value: function sendErrorEvent(status) {
            var ev = new CustomEvent('ImageDropError', {
                detail: { status: status }
            });
            window.document.dispatchEvent(ev);
        }
    }]);

    return ImageDrop;
}();

exports.ImageDrop = ImageDrop;

/***/ }),

/***/ "./shared/components/common/sn-quill-editor/quill-editor.models.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
function modifyAlignIconsSet() {
    var leftAlignIcon = '<svg viewBox="0 0 18 18"> <line class="ql-stroke" x1="3" x2="15" y1="9" y2="9"></line> <line class="ql-stroke" x1="3" x2="13" y1="14" y2="14"></line> <line class="ql-stroke" x1="3" x2="9" y1="4" y2="4"></line> </svg>';
    var middleAlignIcon = '<svg viewBox="0 0 18 18"> <line class="ql-stroke" x1="15" x2="3" y1="9" y2="9"></line> <line class="ql-stroke" x1="14" x2="4" y1="14" y2="14"></line> <line class="ql-stroke" x1="12" x2="6" y1="4" y2="4"></line> </svg>';
    var justifyAlignIcon = '<svg viewBox="0 0 18 18"> <line class="ql-stroke" x1="15" x2="3" y1="9" y2="9"></line> <line class="ql-stroke" x1="15" x2="3" y1="14" y2="14"></line> <line class="ql-stroke" x1="15" x2="3" y1="4" y2="4"></line> </svg>';
    var rightAlignIcon = '<svg viewBox="0 0 18 18"> <line class="ql-stroke" x1="15" x2="3" y1="9" y2="9"></line> <line class="ql-stroke" x1="15" x2="5" y1="14" y2="14"></line> <line class="ql-stroke" x1="15" x2="9" y1="4" y2="4"></line> </svg>';
    return {
        '': modifyAlignIcon(leftAlignIcon),
        center: modifyAlignIcon(middleAlignIcon),
        justify: modifyAlignIcon(justifyAlignIcon),
        right: modifyAlignIcon(rightAlignIcon)
    };
    function modifyAlignIcon(originalIcon) {
        var caretIcon = '<svg viewBox="0 0 18 18"> <polygon class="ql-stroke" points="7 11 9 13 11 11 7 11"></polygon> <polygon class="ql-stroke" points="7 7 9 5 11 7 7 7"></polygon> </svg>';
        return originalIcon + " " + caretIcon;
    }
}
exports.modifyAlignIconsSet = modifyAlignIconsSet;

/***/ }),

/***/ "./shared/components/common/sn-quill-editor/sn-quill-editor.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var file_upload_service_1 = __webpack_require__("./shared/services/files/file-upload-service/file-upload.service.ts");
var file_upload_data_service_1 = __webpack_require__("./shared/services/files/file-upload.data.service.ts");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var counter_1 = __webpack_require__("./shared/components/common/sn-quill-editor/counter.ts");
var models_1 = __webpack_require__("./shared/models/models.ts");
var image_drop_1 = __webpack_require__("./shared/components/common/sn-quill-editor/image-drop.ts");
var quill_editor_models_1 = __webpack_require__("./shared/components/common/sn-quill-editor/quill-editor.models.ts");
var quill_image_resize_1 = __webpack_require__("./node_modules/quill-image-resize/image-resize.min.js");
var Toolbar_1 = __webpack_require__("./shared/components/common/sn-quill-editor/Toolbar.js");
var QuillNamespace = __webpack_require__("./node_modules/quill/dist/quill.js");
var variables_to_insert_1 = __webpack_require__("./shared/models/system-variables/variables-to-insert.ts");
var Quill = QuillNamespace;
var AlignStyle = Quill.import('attributors/style/align');
var SizeStyle = Quill.import('attributors/style/size');
var FontStyle = Quill.import('attributors/style/font');
Quill.register('modules/counter', counter_1.default);
Quill.register(AlignStyle, true);
Quill.register(FontStyle, true);
var Icons = Quill.import('ui/icons');
Icons.align = quill_editor_models_1.modifyAlignIconsSet();
SizeStyle.whitelist = ['10px', '18px', '28px'];
Quill.register(SizeStyle, true);
Quill.register('modules/imageDrop', image_drop_1.ImageDrop);
Quill.register('modules/imageResize', quill_image_resize_1.default);
Quill.register(Icons, true);
var linkVariables = ['%contract_link%', '%invoice_link%', '%quote_link%', '%questionnaire_link%', '%galleries_link%'];
var SnQuillEditorComponent = function () {
    function SnQuillEditorComponent(filesDataService, filesService, messageService) {
        var _this = this;

        _classCallCheck(this, SnQuillEditorComponent);

        this.filesDataService = filesDataService;
        this.filesService = filesService;
        this.messageService = messageService;
        this.varsList = 'JOB_MENU';
        this.initValue = '';
        this.maxLength = 5000;
        this.placeholder = 'Type text here … ';
        this.editorID = 'default';
        this.styles = { minHeight: '250px' };
        /* Possible values: variables attachments counter color size font image */
        this.toolbarSettings = 'DEFAULT';
        this.onTextChange = new core_1.EventEmitter();
        this.onTextLengthChange = new core_1.EventEmitter();
        this.counterShow = false;
        this.editor = document.querySelector('.ql-editor');
        this.unsubscribe = new Subject_1.Subject();
        /* Attention
         * if font size is will be change also change this in the scss file
         */
        this.fontSizeOption = [{ size: ['10px', false, '18px', '28px'] }];
        this.fontOption = [{ font: [] }];
        this.fontColor = [{ color: models_1.COLOR_PICKER_OPTIONS }];
        this.quillDefaultOptions = {
            toolbar: {
                container: [['bold', 'italic', 'underline'], [], ['link'], [{ list: 'bullet' }, { list: 'ordered' }], [{ align: [] }], [], [], []],
                handlers: {
                    link: function link(value) {
                        return _this.linkHandler(value);
                    }
                }
            },
            clipboard: {
                matchVisual: false
            },
            imageDrop: {},
            imageResize: false
        };
        /* Attachments */
        this.attachFileFromComputer = function () {
            var input = document.querySelector(_this.attachmentSelector);
            input.click();
        };
    }

    _createClass(SnQuillEditorComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.quillEditorOptions = this.setEditorOptions();
        }
    }, {
        key: "setEditorOptions",
        value: function setEditorOptions() {
            var _this2 = this;

            if (this.toolbarSettings === 'DEFAULT') {
                return this.quillDefaultOptions;
            }
            var toolbarOptionsArr = this.toolbarSettings.split(' ');
            toolbarOptionsArr.forEach(function (option) {
                if (option === 'color') {
                    var _quillDefaultOptions$;

                    (_quillDefaultOptions$ = _this2.quillDefaultOptions.toolbar.container[1]).push.apply(_quillDefaultOptions$, _toConsumableArray(_this2.fontColor));
                    _this2.quillDefaultOptions.toolbar.handlers.color = _this2.colorHandler.bind(_this2);
                }
                if (option === 'image') {
                    _this2.quillDefaultOptions.toolbar.container[2].push('image');
                    _this2.quillDefaultOptions.toolbar.handlers.image = _this2.imageHandler.bind(_this2);
                    _this2.quillDefaultOptions.imageDrop = {
                        images: true
                    };
                    _this2.quillDefaultOptions.imageResize = {
                        modules: ['Resize', 'DisplaySize']
                    };
                }
                if (option === 'imageLoad') {
                    _this2.quillDefaultOptions.toolbar.container[2].push('image');
                    _this2.quillDefaultOptions.toolbar.handlers.image = _this2.imageLoadHandle.bind(_this2);
                    _this2.quillDefaultOptions.imageDrop = {
                        loadImage: function loadImage(value) {
                            var formData = new FormData();
                            formData.append('file', value);
                            _this2.imageLoadHandler(formData, _this2.insertImage.bind(_this2));
                        },
                        images: true
                    };
                    _this2.quillDefaultOptions.imageResize = {
                        modules: ['Resize', 'DisplaySize', Toolbar_1.Toolbar]
                    };
                }
                if (option === 'font') {
                    var _quillDefaultOptions$2;

                    (_quillDefaultOptions$2 = _this2.quillDefaultOptions.toolbar.container[5]).push.apply(_quillDefaultOptions$2, _toConsumableArray(_this2.fontOption));
                }
                if (option === 'size') {
                    var _quillDefaultOptions$3;

                    (_quillDefaultOptions$3 = _this2.quillDefaultOptions.toolbar.container[6]).push.apply(_quillDefaultOptions$3, _toConsumableArray(_this2.fontSizeOption));
                    _this2.quillDefaultOptions.toolbar.handlers.size = _this2.sizeHandler.bind(_this2);
                }
                if (option === 'variables') {
                    var _quillDefaultOptions$4;

                    (_quillDefaultOptions$4 = _this2.quillDefaultOptions.toolbar.container[7]).push.apply(_quillDefaultOptions$4, [{ variables: [].concat(_toConsumableArray(_this2.addVariables())) }]);
                    _this2.quillDefaultOptions.toolbar.handlers.variables = _this2.variablesHandler.bind(_this2);
                }
                if (option === 'attachments') {
                    var _quillDefaultOptions$5;

                    // Put option in specific position
                    (_quillDefaultOptions$5 = _this2.quillDefaultOptions.toolbar.container[2]).push.apply(_quillDefaultOptions$5, _toConsumableArray(_this2.attachmentsOption));
                    _this2.quillDefaultOptions.toolbar.handlers.attachments = _this2.attachmentsHandler.bind(_this2);
                }
                if (option === 'counter') {
                    _this2.counterShow = true;
                    _this2.quillDefaultOptions.counter = {
                        container: "counter-" + _this2.editorID,
                        maxLength: _this2.maxLength,
                        currentLength: function currentLength(val) {
                            return _this2.onTextLengthChange.emit(val);
                        }
                    };
                }
            });
            return this.quillDefaultOptions;
        }
    }, {
        key: "onEditorCreated",
        value: function onEditorCreated(ev) {
            this.quill = ev;
            this.editor = this.quill.root;
            this.toolbar = this.editor.parentElement.parentElement.children[0];
            this.getAttachments();
            this.checkJobFiles();
            this.addCustomMatchers();
            this.listenToImageDropErrors();
        }
    }, {
        key: "ngAfterViewInit",
        value: function ngAfterViewInit() {
            this.attachClickForEditLink();
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.filesDataService.setCheckedFiles(null);
            this.unsubscribe.complete();
            this.detachImageDropErrorHandler();
        }
        /* Emiters */
        // emitNewAttachments($event): void {
        // 	this.onAttachmentsChange.emit($event);
        // }

    }, {
        key: "onContentChange",
        value: function onContentChange(value) {
            if (value.source === 'user') {
                this.onTextChange.emit(value.html ? value.html.normalize() : value.html);
            }
        }
    }, {
        key: "onSelectionChanged",
        value: function onSelectionChanged(value) {
            this.currentSelection = value;
        }
        /* Variables */

    }, {
        key: "addVariables",
        value: function addVariables() {
            this.variablesToInsert = variables_to_insert_1.variablesList[this.varsList];
            return Object.keys(variables_to_insert_1.variablesList[this.varsList]).map(function (key) {
                return key;
            });
        }
    }, {
        key: "disabledAttachmentsFromFiles",
        value: function disabledAttachmentsFromFiles() {
            var _this3 = this;

            var openDropDown = false;
            var attachmentsToolbarBtn = this.toolbar.querySelector('.ql-attachments');
            if (attachmentsToolbarBtn === null) {
                return;
            }
            attachmentsToolbarBtn.addEventListener('click', function () {
                openDropDown = !openDropDown;
                if (openDropDown) {
                    var fromFilesOption = _this3.toolbar.querySelector('.ql-picker-item[data-value="From Files"]');
                    if (!fromFilesOption.classList.contains('disableOption')) {
                        fromFilesOption.classList.add('disableOption');
                    }
                }
            });
        }
    }, {
        key: "getAttachments",
        value: function getAttachments() {
            var _this4 = this;

            this.filesDataService.checkedFilesObservable.takeUntil(this.unsubscribe).subscribe(function (chosenFiles) {
                return _this4.succesGetAttachments(chosenFiles);
            }, function () {
                return _this4.messageService.showToaster('e_0', 'general');
            });
        }
    }, {
        key: "succesGetAttachments",
        value: function succesGetAttachments(chosenFiles) {
            var _this5 = this;

            if (this.editor.getBoundingClientRect().width < 40) {
                return;
            }
            if (chosenFiles !== null) {
                if (this.filesObj === undefined) {
                    this.filesObj = {
                        attachments: []
                    };
                }
                var filesToAdd = [];
                chosenFiles.forEach(function (chosenFile) {
                    if (_this5.checkIfFileExist(chosenFile) === -1) {
                        filesToAdd.push(chosenFile);
                    }
                });
                var newAttachmentsSize = this.filesService.getAllAttachmentsSize(this.filesObj.filesSize, filesToAdd);
                var maxSize = this.filesService.maxAttachment;
                if (newAttachmentsSize > maxSize) {
                    this.messageService.showToaster('w_0', 'attachments');
                    return;
                }
                this.filesObj.filesSize = newAttachmentsSize;
                filesToAdd.forEach(function (chosenFile) {
                    _this5.filesObj.attachments.push(chosenFile);
                });
            }
        }
    }, {
        key: "checkIfFileExist",
        value: function checkIfFileExist(chosenFile) {
            return this.filesObj.attachments.findIndex(function (file) {
                return file.id === chosenFile.id;
            });
        }
    }, {
        key: "checkJobFiles",
        value: function checkJobFiles() {
            var _this6 = this;

            this.filesDataService.filesObservable.takeUntil(this.unsubscribe).subscribe(function (storedFiles) {
                _this6.isStoredFiles = !!storedFiles.length;
                if (!_this6.isStoredFiles) {
                    _this6.disabledAttachmentsFromFiles();
                }
            });
        }
        /* Link */

    }, {
        key: "linkHandler",
        value: function linkHandler(isNew) {
            var cursorPosition = this.getCursorPosition();
            var linkData = void 0;
            // Edit or create link
            !isNew ? linkData = this.prepareLinkEdit(cursorPosition) : linkData = this.prepareCreateDataIfNeeded(cursorPosition);
            this.openLinkModal({
                url: linkData.url,
                text: linkData.text
            });
        }
        // next methods are overwritten in child classes
        /* Attachments */

    }, {
        key: "showChooseFileModal",
        value: function showChooseFileModal() {}
    }, {
        key: "openLinkModal",
        value: function openLinkModal(delta) {}
    }, {
        key: "attachmentsHandler",
        value: function attachmentsHandler(type) {}
    }, {
        key: "prepareLinkHtml",
        value: function prepareLinkHtml(linkData) {
            if (linkData.isEmail) {
                linkData.url = "mailto:" + linkData.url;
            }
            return {
                html: "\n      <span>\n        <a href=\"" + linkData.url + "\" >" + linkData.text + "</a>\n      </span>\n     ",
                length: linkData.text.length
            };
        }
    }, {
        key: "insertIntoQuill",
        value: function insertIntoQuill(data) {
            var valueToInsert = data.html;
            var cursorPosition = this.getCursorPosition();
            this.quill.clipboard.dangerouslyPasteHTML(cursorPosition, valueToInsert, 'user');
            this.setCursorPosition(data.length, cursorPosition);
        }
    }, {
        key: "insertImage",
        value: function insertImage(data) {
            var valueToInsert = data.html;
            var cursorPosition = this.getCursorPosition();
            var imageWrap = this.editor.getElementsByTagName('img')[0];
            if (imageWrap) {
                var reduntP = imageWrap.closest('p');
                if (reduntP) {
                    reduntP.remove();
                }
            }
            this.quill.clipboard.dangerouslyPasteHTML(cursorPosition - 1 || 0, valueToInsert, 'user');
            this.setCursorPosition(data.length, cursorPosition);
        }
    }, {
        key: "updateLink",
        value: function updateLink(delta, data) {
            var _this7 = this;

            // If we need to create a link from selected text
            if (!delta.url) {
                var cursorPos = this.getCursorPosition();
                this.quill.updateContents([{ retain: cursorPos }, { delete: data.text.length }, { insert: '', attributes: { link: data.url } }], 'user');
                this.setCursorPosition(0, cursorPos);
            } else {
                var HTMLCollection = this.editor.querySelectorAll('a');
                var links = Array.from(HTMLCollection);
                for (var i = 0; i < links.length; i++) {
                    var href = links[i].getAttribute('href');
                    var text = links[i].innerText;
                    var isEmail = href.includes('mailto:');
                    if (isEmail) {
                        href = href.split(':')[1];
                    }
                    if (href === delta.url && text.includes(delta.text)) {
                        if (isEmail) {
                            data.url = "mailto:" + data.url;
                        }
                        HTMLCollection[i].href = data.url;
                        HTMLCollection[i].innerHTML = data.text;
                    }
                }
                setTimeout(function () {
                    var selectedText = _this7.quill.getContents(_this7.getCursorPosition());
                    _this7.setCursorPosition(selectedText.ops[0].insert.length, _this7.getCursorPosition());
                }, 0);
            }
        }
    }, {
        key: "getFullLinkName",
        value: function getFullLinkName(delta) {
            var links = Array.from(this.editor.querySelectorAll('a'));
            for (var i = 0; i < links.length; i++) {
                var href = links[i].getAttribute('href');
                if (href.includes('mailto:')) {
                    href = href.split(':')[1];
                }
                var text = links[i].innerHTML.replace(/<\/?[^>]+(>|$)/g, '');
                // If we found link with exact text and href attribute
                if (href === delta.attributes.link && text.includes(delta.insert)) {
                    return text;
                }
            }
            return '';
        }
    }, {
        key: "attachClickForEditLink",
        value: function attachClickForEditLink() {
            var _this8 = this;

            var tooltips = this.editor.parentElement.querySelectorAll('.ql-tooltip');
            this.tooltip = tooltips[tooltips.length - 1];
            var element = this.tooltip.querySelector('.ql-action');
            element.addEventListener('click', function (event) {
                _this8.linkHandler(false);
            }, false);
            element.innerHTML = "<span class=\"editLinkTips\">\n         <i class=\"fi fi-edit link-icon\" aria-hidden=\"true\"></i>\n         Edit link\n       </span>";
        }
        /* Handlers */

    }, {
        key: "variablesHandler",
        value: function variablesHandler(variable) {
            if (variable) {
                var valueToInsert = this.variablesToInsert[variable];
                var cursorPosition = this.getCursorPosition();
                this.quill.clipboard.dangerouslyPasteHTML(cursorPosition, valueToInsert + " &nbsp;", 'user');
                this.setCursorPosition(valueToInsert.replace(/<\/?[^>]+(>|$)/g, '').length + 1, cursorPosition);
            }
        }
    }, {
        key: "getCursorPosition",
        value: function getCursorPosition() {
            // Get cursor position
            var cursorPosition = this.quill.getSelection();
            // Get fallback cursor position if we do not have active focus on editor
            if (!cursorPosition) {
                cursorPosition = this.quill.selection.savedRange.index;
            } else {
                cursorPosition = cursorPosition.index;
            }
            return cursorPosition;
        }
    }, {
        key: "setCursorPosition",
        value: function setCursorPosition(length, cursorPosition) {
            var _this9 = this;

            setTimeout(function () {
                return _this9.quill.setSelection(cursorPosition + length);
            }, 0);
        }
    }, {
        key: "prepareCreateDataIfNeeded",
        value: function prepareCreateDataIfNeeded(cursorPosition) {
            var selection = this.quill.getSelection();
            var linkData = this.quill.getContents(cursorPosition).ops[0];
            var url = null;
            var text = null;
            // Track if we have selected text to pass (not link) during creation
            if (selection.length !== 0) {
                text = this.quill.getContents(selection.index, selection.length).ops[0].insert;
            }
            // Important! Some devices did not handle Quill.js edit events correctly, so we need to catch edit while editor want's to create new link
            if (linkData.attributes && linkData.attributes.link) {
                var data = this.prepareLinkEdit(cursorPosition);
                url = data.url;
                text = data.text;
            }
            return {
                url: url,
                text: text
            };
        }
    }, {
        key: "prepareLinkEdit",
        value: function prepareLinkEdit(cursorPosition) {
            var linkData = this.quill.getContents(cursorPosition).ops[0];
            // hide default tooltip
            this.tooltip.classList.add('removeTooltip');
            // Handle case when cursor situated right after the link
            if (!linkData.attributes || linkData.attributes && !linkData.attributes.link) {
                linkData = this.quill.getContents(cursorPosition - 1).ops[0];
            }
            // Remove mail protocol from selected href
            if (linkData.attributes.link.includes('mailto:')) {
                linkData.attributes.link = linkData.attributes.link.split(':')[1];
            }
            // Required separate get name handler, because of incorrect behaviour of quill text selection by cursor index
            var linkText = this.getFullLinkName(linkData);
            return { url: linkData.attributes.link, text: linkText };
        }
    }, {
        key: "colorHandler",
        value: function colorHandler(color) {
            if (this.currentSelection.index) {
                var data = this.quill.getContents(this.currentSelection.index, this.currentSelection.length || 1).ops[0];
                if (data && data.attributes && data.attributes.link) {
                    return;
                }
            }
            this.quill.format('color', color, 'user');
        }
    }, {
        key: "sizeHandler",
        value: function sizeHandler(value) {
            var _this10 = this;

            this.quill.format('size', value, 'user');
            // Setting !important manually to support different email protocols
            setTimeout(function () {
                _this10.setImportantToTextSize();
            }, 0);
        }
    }, {
        key: "setImportantToTextSize",
        value: function setImportantToTextSize() {
            var elementsDOM = this.editor.querySelectorAll('*[style*="font-size"]');
            var elems = Array.from(elementsDOM);
            elems.map(function (el, i) {
                if (!el.style.fontSize.includes('!important')) {
                    var styleStr = '';
                    if (el.style.fontSize) {
                        styleStr += "font-size:" + el.style.fontSize + " !important;";
                    }
                    if (el.style.color) {
                        styleStr += "color: " + el.style.color + ";";
                    }
                    if (el.style.fontFamily) {
                        styleStr += "font-family: " + el.style.fontFamily + ";";
                    }
                    el.setAttribute('style', styleStr);
                }
            });
            this.quill.update('user');
        }
        /* Custom matchers */

    }, {
        key: "addCustomMatchers",
        value: function addCustomMatchers() {
            this.removeBlackTextStyle();
            this.removeImgHeight();
            this.clearLinks();
            this.normalizeUnicode();
        }
    }, {
        key: "removeBlackTextStyle",
        value: function removeBlackTextStyle() {
            var selector = 'span[style*="color: rgb(0, 0, 0)"]';
            this.quill.clipboard.addMatcher(selector, function (node, delta) {
                delta.ops = delta.ops.map(function (op) {
                    return {
                        insert: op.insert
                    };
                });
                return delta;
            });
        }
    }, {
        key: "removeImgHeight",
        value: function removeImgHeight() {
            this.quill.clipboard.addMatcher('IMG', function (node, delta) {
                delta.ops = delta.ops.map(function (op) {
                    return Object.assign({}, op, { attributes: Object.assign({}, op.attributes || {}, { height: null, margin: null }) });
                });
                return delta;
            });
        }
    }, {
        key: "clearLinks",
        value: function clearLinks() {
            this.quill.clipboard.addMatcher('A', function (node, delta) {
                delta.ops = delta.ops.map(function (op) {
                    var link = op.attributes.link;
                    if (!link) return op;
                    linkVariables.forEach(function (linkVar) {
                        var startIndex = link.indexOf(linkVar);
                        if (startIndex !== -1) {
                            link = link.slice(startIndex, startIndex + linkVar.length);
                        }
                    });
                    return Object.assign({}, op, { attributes: Object.assign({}, op.attributes || {}, { link: link }) });
                });
                return delta;
            });
        }
    }, {
        key: "normalizeUnicode",
        value: function normalizeUnicode() {
            var selector = '*';
            this.quill.clipboard.addMatcher(selector, function (node, delta) {
                delta.ops = delta.ops.map(function (op) {
                    return Object.assign({}, op, { insert: typeof op.insert === 'string' ? op.insert.normalize() : op.insert });
                });
                return delta;
            });
        }
    }, {
        key: "imageLoadHandle",
        value: function imageLoadHandle(state) {
            var _this11 = this;

            if (state) {
                var input = document.getElementById("image-input-" + this.editorID);
                input.onchange = function () {
                    var file = input.files[0];
                    // file type is only image.
                    if (file.type.match(/^image\/(jpe?g|png|bmp\.microsoft\.icon)/i)) {
                        var maxFileSize = 2 * 1000 * 1000;
                        if (file.size > maxFileSize) {
                            _this11.messageService.showToaster('e_1', 'companyInformation', '2');
                        } else {
                            var newData = new FormData();
                            newData.append('file', file);
                            _this11.imageLoadHandler(newData, _this11.insertImage.bind(_this11));
                        }
                    } else {
                        _this11.messageService.showToaster('e_0', 'companyInformation');
                    }
                    input.value = null;
                };
                input.click();
            }
        }
    }, {
        key: "imageHandler",
        value: function imageHandler(state) {
            var _this12 = this;

            if (state) {
                var input = document.getElementById("image-input-" + this.editorID);
                input.onchange = function () {
                    var file = input.files[0];
                    // file type is only image.
                    if (file.type.match(/^image\/(jpe?g|png|bmp\.microsoft\.icon)/i)) {
                        var maxFileSize = 2 * 1000 * 1000;
                        if (file.size > maxFileSize) {
                            _this12.messageService.showToaster('e_1', 'companyInformation', '2');
                        } else {
                            var reader = new FileReader();
                            reader.onload = function () {
                                var range = _this12.quill.getSelection();
                                var img = "<img src=\"" + reader.result + "\" alt=\"" + file.name + "\"/>";
                                _this12.quill.clipboard.dangerouslyPasteHTML(range.index, img, 'user');
                            };
                            reader.readAsDataURL(file);
                        }
                    } else {
                        _this12.messageService.showToaster('e_0', 'companyInformation');
                    }
                    input.value = null;
                };
                input.click();
            }
        }
    }, {
        key: "listenToImageDropErrors",
        value: function listenToImageDropErrors() {
            var _this13 = this;

            this.imageDropErrorEvent = document.addEventListener('ImageDropError', function (ev) {
                if (ev.detail.status) {
                    switch (ev.detail.status) {
                        case 'MULTIPLE':
                            _this13.messageService.showToaster('e_4', 'companyInformation');
                            break;
                        case 'TYPE':
                            _this13.messageService.showToaster('e_0', 'companyInformation');
                            break;
                        case 'SIZE':
                            _this13.messageService.showToaster('e_1', 'companyInformation', '2');
                            break;
                        default:
                            break;
                    }
                }
            }, false);
        }
    }, {
        key: "detachImageDropErrorHandler",
        value: function detachImageDropErrorHandler() {
            if (this.imageDropErrorEvent) {
                this.imageDropErrorEvent();
            }
        }
    }]);

    return SnQuillEditorComponent;
}();
__decorate([core_1.Input('varsList'), __metadata("design:type", Object)], SnQuillEditorComponent.prototype, "varsList", void 0);
__decorate([core_1.Input('filesObj'), __metadata("design:type", Object)], SnQuillEditorComponent.prototype, "filesObj", void 0);
__decorate([core_1.Input('initValue'), __metadata("design:type", Object)], SnQuillEditorComponent.prototype, "initValue", void 0);
__decorate([core_1.Input('maxLength'), __metadata("design:type", Object)], SnQuillEditorComponent.prototype, "maxLength", void 0);
__decorate([core_1.Input('placeholder'), __metadata("design:type", Object)], SnQuillEditorComponent.prototype, "placeholder", void 0);
__decorate([core_1.Input('editorID'), __metadata("design:type", Object)], SnQuillEditorComponent.prototype, "editorID", void 0);
__decorate([core_1.Input('styles'), __metadata("design:type", Object)], SnQuillEditorComponent.prototype, "styles", void 0);
__decorate([core_1.Input('toolbarSettings'), __metadata("design:type", Object)], SnQuillEditorComponent.prototype, "toolbarSettings", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], SnQuillEditorComponent.prototype, "imageLoadHandler", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], SnQuillEditorComponent.prototype, "onTextChange", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], SnQuillEditorComponent.prototype, "onTextLengthChange", void 0);
SnQuillEditorComponent = __decorate([core_1.Component({
    selector: '',
    template: '',
    encapsulation: core_1.ViewEncapsulation.None
}), __metadata("design:paramtypes", [file_upload_data_service_1.FileUploadDataProvider, file_upload_service_1.FileUploadServiceProvider, message_service_1.MessageService])], SnQuillEditorComponent);
exports.SnQuillEditorComponent = SnQuillEditorComponent;

/***/ }),

/***/ "./shared/components/common/sn-quill-view/sn-quill-view.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var SnQuillViewComponent = function SnQuillViewComponent() {
    _classCallCheck(this, SnQuillViewComponent);
};
__decorate([core_1.Input(), __metadata("design:type", String)], SnQuillViewComponent.prototype, "content", void 0);
SnQuillViewComponent = __decorate([core_1.Component({
    selector: '',
    template: ''
})], SnQuillViewComponent);
exports.SnQuillViewComponent = SnQuillViewComponent;

/***/ }),

/***/ "./shared/components/common/sn-warning/sn-warning.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"{{warningClass}}\" [attr.data-content]=\"getTooltipMsg()\">\n    <span class=\"text-light text-overflow\">\n        <span class=\"fa fa-ban icon-ban icon-ban-job\"></span>\n    </span>\n</div>"

/***/ }),

/***/ "./shared/components/common/sn-warning/sn-warning.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var settings_1 = __webpack_require__("./shared/services/settings/settings.ts");
var SnWarningComponent = function () {
    function SnWarningComponent(settingsProvider) {
        var _this = this;

        _classCallCheck(this, SnWarningComponent);

        this.settingsProvider = settingsProvider;
        this.settingsProvider.customizeLabelsObservable.subscribe(function (data) {
            _this.mainShootLabel = data.mainShootLabel;
        });
    }

    _createClass(SnWarningComponent, [{
        key: "getTooltipMsg",
        value: function getTooltipMsg() {
            this.concatedString = "Another " + this.preLabelName + " " + this.mainShootLabel + " is at the same time";
            return this.concatedString;
        }
    }]);

    return SnWarningComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", String)], SnWarningComponent.prototype, "warningClass", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], SnWarningComponent.prototype, "preLabelName", void 0);
SnWarningComponent = __decorate([core_1.Component({
    selector: 'sn-warning',
    template: __webpack_require__("./shared/components/common/sn-warning/sn-warning.html")
}), __metadata("design:paramtypes", [settings_1.SettingsProvider])], SnWarningComponent);
exports.SnWarningComponent = SnWarningComponent;

/***/ }),

/***/ "./shared/components/common/spinning-wheel/spinning-wheel.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var SpinningWheelComponent = function () {
    function SpinningWheelComponent(renderer, el) {
        _classCallCheck(this, SpinningWheelComponent);

        this.renderer = renderer;
        this.el = el;
        this.renderer.addClass(this.el.nativeElement, 'wild');
    }

    _createClass(SpinningWheelComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            var el = this.el.nativeElement;
            this.renderer.addClass(el, 'spinning-wheel');
            if (this.isSpinningWheelAfter === 'true') {
                this.renderer.addClass(el, 'spinning-wheel__display-after');
            } else {
                this.renderer.addClass(el, 'spinning-wheel__display-before');
            }
            if (this.isSpinningWheelDark === 'true') {
                this.renderer.addClass(el, 'spinning-wheel__dark');
            }
        }
    }, {
        key: "ngOnChanges",
        value: function ngOnChanges() {
            var el = this.el.nativeElement;
            if (this.isSpinningWheelActive === true) {
                this.renderer.addClass(el, 'spinning-wheel__active');
            } else {
                this.renderer.removeClass(el, 'spinning-wheel__active');
            }
        }
    }]);

    return SpinningWheelComponent;
}();
__decorate([core_1.Input('is-spinning-wheel-active'), __metadata("design:type", Boolean)], SpinningWheelComponent.prototype, "isSpinningWheelActive", void 0);
__decorate([core_1.Input('is-spinning-wheel-after'), __metadata("design:type", String)], SpinningWheelComponent.prototype, "isSpinningWheelAfter", void 0);
__decorate([core_1.Input('is-spinning-wheel-dark'), __metadata("design:type", String)], SpinningWheelComponent.prototype, "isSpinningWheelDark", void 0);
SpinningWheelComponent = __decorate([core_1.Directive({
    selector: '[spinning-wheel]'
}), __metadata("design:paramtypes", [core_1.Renderer2, core_1.ElementRef])], SpinningWheelComponent);
exports.SpinningWheelComponent = SpinningWheelComponent;

/***/ }),

/***/ "./shared/components/common/toggle-password/toggle-password.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var TogglePassword = function () {
    function TogglePassword(el) {
        _classCallCheck(this, TogglePassword);

        this.el = el;
        this._shown = false;
    }

    _createClass(TogglePassword, [{
        key: "ngAfterContentInit",
        value: function ngAfterContentInit() {
            var _this = this;

            var parent = this.el.nativeElement;
            this.toggler = document.createElement('i');
            this.toggler.className = 'fa fa-eye-slash';
            this.toggler.addEventListener('click', function () {
                _this.toggle();
            });
            parent.appendChild(this.toggler);
            this.password = parent.firstElementChild;
        }
    }, {
        key: "toggle",
        value: function toggle() {
            this._shown = !this._shown;
            if (this._shown) {
                this.password.setAttribute('type', 'text');
                this.toggler.className = 'fa fa-eye';
            } else {
                this.password.setAttribute('type', 'password');
                this.toggler.className = 'fa fa-eye-slash';
            }
        }
    }]);

    return TogglePassword;
}();
TogglePassword = __decorate([core_1.Component({
    selector: 'toggle-password',
    template: '<ng-content></ng-content>'
}), __metadata("design:paramtypes", [core_1.ElementRef])], TogglePassword);
exports.TogglePassword = TogglePassword;

/***/ }),

/***/ "./shared/components/common/tooltips/icon-tooltip/icon-tooltip.component.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"tooltip-general tooltip-{{status}}\" [attr.data-content]=\"text\">\n    <i class=\"{{ setCorrectIcon() }} cross-tooltip\"></i>\n</div>"

/***/ }),

/***/ "./shared/components/common/tooltips/icon-tooltip/icon-tooltip.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var IconTooltipComponent = function () {
    function IconTooltipComponent() {
        _classCallCheck(this, IconTooltipComponent);
    }

    _createClass(IconTooltipComponent, [{
        key: "setCorrectIcon",
        value: function setCorrectIcon() {
            if (this.iconClass) {
                return this.iconClass;
            }
            switch (this.status) {
                case 'error':
                case 'warning':
                    return 'fi fi-cross';
                case 'info':
                    return 'fa fa-exclamation';
                default:
                    return 'fi fi-cross';
            }
        }
    }]);

    return IconTooltipComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", String)], IconTooltipComponent.prototype, "status", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], IconTooltipComponent.prototype, "text", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], IconTooltipComponent.prototype, "iconClass", void 0);
IconTooltipComponent = __decorate([core_1.Component({
    selector: 'icon-tooltip',
    template: __webpack_require__("./shared/components/common/tooltips/icon-tooltip/icon-tooltip.component.html")
})], IconTooltipComponent);
exports.IconTooltipComponent = IconTooltipComponent;

/***/ }),

/***/ "./shared/components/common/warning-sign-img/warning-sign-img.html":
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" class=\"warning-message__img\" xmlns=\"http://www.w3.org/2000/svg\"  x=\"0px\" y=\"0px\"\n\t viewBox=\"0 0 30 30\" enable-background=\"new 0 0 30 30\" xml:space=\"preserve\">\n<g>\n\t<circle fill=\"#FFFFFF\" stroke=\"#010101\" stroke-width=\"2\" stroke-miterlimit=\"10\" cx=\"15\" cy=\"15\" r=\"13\"/>\n\t<g>\n\t\t<path fill=\"#010101\" d=\"M13.5,20.5c0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5c0,0.8-0.7,1.5-1.5,1.5S13.5,21.3,13.5,20.5z M13.6,9.3\n\t\t\tC13.6,8.5,14.2,8,15,8c0.8,0,1.4,0.5,1.4,1.3v7.3c0,0.8-0.6,1.3-1.4,1.3c-0.8,0-1.4-0.5-1.4-1.3V9.3z\"/>\n\t</g>\n</g>\n</svg>"

/***/ }),

/***/ "./shared/components/common/warning-sign-img/warning-sign-img.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var WarningSignImgComponent = function WarningSignImgComponent() {
    _classCallCheck(this, WarningSignImgComponent);
};
WarningSignImgComponent = __decorate([core_1.Component({
    selector: 'warning-sign-img',
    template: __webpack_require__("./shared/components/common/warning-sign-img/warning-sign-img.html")
}), __metadata("design:paramtypes", [])], WarningSignImgComponent);
exports.WarningSignImgComponent = WarningSignImgComponent;

/***/ }),

/***/ "./shared/directives/click-outside/click-outside.directive.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var ClickOutsideDirective = function () {
    function ClickOutsideDirective(elementRef) {
        _classCallCheck(this, ClickOutsideDirective);

        this.elementRef = elementRef;
        this.clickOutside = new core_1.EventEmitter();
    }

    _createClass(ClickOutsideDirective, [{
        key: "onClick",
        value: function onClick(event, targetElement) {
            if (!targetElement) {
                return;
            }
            var clickedInside = this.elementRef.nativeElement.contains(targetElement);
            if (!clickedInside) {
                this.clickOutside.emit(event);
            }
        }
    }]);

    return ClickOutsideDirective;
}();
__decorate([core_1.Output(), __metadata("design:type", Object)], ClickOutsideDirective.prototype, "clickOutside", void 0);
__decorate([core_1.HostListener('document:click', ['$event', '$event.target']), __metadata("design:type", Function), __metadata("design:paramtypes", [MouseEvent, HTMLElement]), __metadata("design:returntype", void 0)], ClickOutsideDirective.prototype, "onClick", null);
ClickOutsideDirective = __decorate([core_1.Directive({
    selector: '[clickOutside]'
}), __metadata("design:paramtypes", [core_1.ElementRef])], ClickOutsideDirective);
exports.ClickOutsideDirective = ClickOutsideDirective;

/***/ }),

/***/ "./shared/directives/directives.module.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var click_outside_directive_1 = __webpack_require__("./shared/directives/click-outside/click-outside.directive.ts");
var SharedDirectivesModule = function SharedDirectivesModule() {
    _classCallCheck(this, SharedDirectivesModule);
};
SharedDirectivesModule = __decorate([core_1.NgModule({
    declarations: [click_outside_directive_1.ClickOutsideDirective],
    exports: [click_outside_directive_1.ClickOutsideDirective]
})], SharedDirectivesModule);
exports.SharedDirectivesModule = SharedDirectivesModule;

/***/ }),

/***/ "./shared/interceptors/blobError.interceptor.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = __webpack_require__("./node_modules/@angular/common/esm5/http.js");
var Observable_1 = __webpack_require__("./node_modules/rxjs/Observable.js");
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var BlobErrorInterceptor = function () {
    function BlobErrorInterceptor() {
        _classCallCheck(this, BlobErrorInterceptor);
    }

    _createClass(BlobErrorInterceptor, [{
        key: "intercept",
        value: function intercept(req, next) {
            var _this = this;

            return next.handle(req).catch(function (err) {
                return _this.handleBlobErrors(err);
            });
        }
    }, {
        key: "handleBlobErrors",
        value: function handleBlobErrors(err) {
            if (err instanceof http_1.HttpErrorResponse && err.error instanceof Blob && err.error.type === 'application/json') {
                // https://github.com/angular/angular/issues/19888
                // When request of type Blob, the error is also in Blob instead of object of the json data
                return new Promise(function (resolve, reject) {
                    var reader = new FileReader();
                    reader.onload = function (e) {
                        try {
                            var errmsg = JSON.parse(e.target.result);
                            reject(new http_1.HttpErrorResponse({
                                error: errmsg,
                                headers: err.headers,
                                status: err.status,
                                statusText: err.statusText,
                                url: err.url
                            }));
                        } catch (e) {
                            reject(err);
                        }
                    };
                    reader.onerror = function () {
                        reject(err);
                    };
                    reader.readAsText(err.error);
                });
            }
            return Observable_1.Observable.throw(err);
        }
    }]);

    return BlobErrorInterceptor;
}();
BlobErrorInterceptor = __decorate([core_1.Injectable()], BlobErrorInterceptor);
exports.BlobErrorInterceptor = BlobErrorInterceptor;

/***/ }),

/***/ "./shared/libs/@ng-select/index.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var ng_select_component_1 = __webpack_require__("./shared/libs/@ng-select/ng-select/ng-select.component.ts");
exports.NgSelectComponent = ng_select_component_1.NgSelectComponent;
exports.NG_SELECT_DEFAULT_CONFIG = ng_select_component_1.NG_SELECT_DEFAULT_CONFIG;
var ng_select_module_1 = __webpack_require__("./shared/libs/@ng-select/ng-select/ng-select.module.ts");
exports.NgSelectModule = ng_select_module_1.NgSelectModule;

/***/ }),

/***/ "./shared/libs/@ng-select/ng-select/console.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var ConsoleService = function () {
    function ConsoleService() {
        _classCallCheck(this, ConsoleService);
    }

    _createClass(ConsoleService, [{
        key: "warn",
        value: function warn(message) {
            console.warn(message);
        }
    }]);

    return ConsoleService;
}();
ConsoleService = __decorate([core_1.Injectable()], ConsoleService);
exports.ConsoleService = ConsoleService;

/***/ }),

/***/ "./shared/libs/@ng-select/ng-select/id.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
function newId() {
    // First character is an 'a', it's good practice to tag id to begin with a letter
    return 'axxxxxxxxxxx'.replace(/[x]/g, function (_) {
        // tslint:disable-next-line:no-bitwise
        var val = Math.random() * 16 | 0;
        return val.toString(16);
    });
}
exports.newId = newId;

/***/ }),

/***/ "./shared/libs/@ng-select/ng-select/items-list.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });
var searchHelper = __webpack_require__("./shared/libs/@ng-select/ng-select/search-helper.ts");
var value_utils_1 = __webpack_require__("./shared/libs/@ng-select/ng-select/value-utils.ts");
var id_1 = __webpack_require__("./shared/libs/@ng-select/ng-select/id.ts");

var ItemsList = function () {
    function ItemsList(_ngSelect) {
        _classCallCheck(this, ItemsList);

        this._ngSelect = _ngSelect;
        this._items = [];
        this._filteredItems = [];
        this._markedIndex = -1;
        this._selected = [];
    }

    _createClass(ItemsList, [{
        key: "setItems",
        value: function setItems(items) {
            var _this = this;

            this._items = items.map(function (item, index) {
                return _this.mapItem(item, index);
            });
            if (this._ngSelect.groupBy) {
                this._groups = this._groupBy(this._items, this._ngSelect.groupBy);
                this._items = this._flatten(this._groups);
            } else {
                this._groups = new Map();
                this._groups.set(undefined, this._items);
            }
            this._filteredItems = [].concat(_toConsumableArray(this._items));
        }
    }, {
        key: "select",
        value: function select(item) {
            if (item.selected || this.maxItemsSelected) {
                return;
            }
            if (!this._ngSelect.multiple) {
                this.clearSelected();
            }
            this._selected.push(item);
            item.selected = true;
            if (this._ngSelect.hideSelected) {
                this._filteredItems = this._filteredItems.filter(function (x) {
                    return x !== item;
                });
            }
        }
    }, {
        key: "findItem",
        value: function findItem(value) {
            var _this2 = this;

            if (this._ngSelect.bindValue) {
                return this._items.find(function (item) {
                    return !item.hasChildren && _this2.resolveNested(item.value, _this2._ngSelect.bindValue) === value;
                });
            }
            var option = this._items.find(function (x) {
                return x.value === value;
            });
            var findBy = this._ngSelect.compareWith ? function (item) {
                return _this2._ngSelect.compareWith(item.value, value);
            } : function (item) {
                return !item.hasChildren && item.label && item.label === _this2.resolveNested(value, _this2._ngSelect.bindLabel);
            };
            return option || this._items.find(function (item) {
                return findBy(item);
            });
        }
    }, {
        key: "unselect",
        value: function unselect(item) {
            this._selected = this._selected.filter(function (x) {
                return x !== item;
            });
            item.selected = false;
            if (this._ngSelect.hideSelected) {
                this._filteredItems.splice(item.index, 0, item);
                this._filteredItems = [].concat(_toConsumableArray(this._filteredItems.sort(function (a, b) {
                    return a.index - b.index;
                })));
            }
        }
    }, {
        key: "addItem",
        value: function addItem(item) {
            var option = this.mapItem(item, this._items.length);
            this._items.push(option);
            this._filteredItems.push(option);
            return option;
        }
    }, {
        key: "clearSelected",
        value: function clearSelected() {
            this._selected.forEach(function (item) {
                item.selected = false;
                item.marked = false;
            });
            this._selected = [];
            if (this._ngSelect.hideSelected) {
                this.resetItems();
            }
        }
    }, {
        key: "findByLabel",
        value: function findByLabel(term) {
            term = searchHelper.stripSpecialChars(term).toLocaleLowerCase();
            return this.filteredItems.find(function (item) {
                var label = searchHelper.stripSpecialChars(item.label).toLocaleLowerCase();
                return label.substr(0, term.length) === term;
            });
        }
    }, {
        key: "filter",
        value: function filter(term) {
            var _this3 = this;

            if (!term) {
                this.resetItems();
                return;
            }
            this._filteredItems = [];
            term = this._ngSelect.searchFn ? term : searchHelper.stripSpecialChars(term).toLocaleLowerCase();
            var match = this._ngSelect.searchFn || this._defaultSearchFn;
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = Array.from(this._groups.keys())[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var key = _step.value;

                    var matchedItems = [];
                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                        for (var _iterator2 = this._groups.get(key)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                            var item = _step2.value;

                            if (this._ngSelect.hideSelected && this._selected.indexOf(item) > -1) {
                                continue;
                            }
                            var searchItem = this._ngSelect.searchFn ? item.value : item;
                            if (match(term, searchItem)) {
                                matchedItems.push(item);
                            }
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }
                        } finally {
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }

                    if (matchedItems.length > 0) {
                        (function () {
                            var _filteredItems;

                            var _matchedItems$slice = matchedItems.slice(-1),
                                _matchedItems$slice2 = _slicedToArray(_matchedItems$slice, 1),
                                last = _matchedItems$slice2[0];

                            if (last.parent) {
                                var head = _this3._items.find(function (x) {
                                    return x === last.parent;
                                });
                                _this3._filteredItems.push(head);
                            }
                            (_filteredItems = _this3._filteredItems).push.apply(_filteredItems, matchedItems);
                        })();
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }, {
        key: "resetItems",
        value: function resetItems() {
            var _this4 = this;

            if (this._filteredItems.length === this._items.length) {
                return;
            }
            this._filteredItems = this._ngSelect.hideSelected ? this._items.filter(function (x) {
                return _this4._selected.indexOf(x) === -1;
            }) : this._items;
        }
    }, {
        key: "unmarkItem",
        value: function unmarkItem() {
            this._markedIndex = -1;
        }
    }, {
        key: "markNextItem",
        value: function markNextItem() {
            this._stepToItem(+1);
        }
    }, {
        key: "markPreviousItem",
        value: function markPreviousItem() {
            this._stepToItem(-1);
        }
    }, {
        key: "markItem",
        value: function markItem(item) {
            this._markedIndex = this._filteredItems.indexOf(item);
        }
    }, {
        key: "markSelectedOrDefault",
        value: function markSelectedOrDefault(markDefault) {
            if (this._filteredItems.length === 0) {
                return;
            }
            var indexOfLastSelected = this._ngSelect.hideSelected ? -1 : this._filteredItems.indexOf(this.lastSelectedItem);
            if (this.lastSelectedItem && indexOfLastSelected > -1) {
                this._markedIndex = indexOfLastSelected;
            } else {
                this._markedIndex = markDefault ? this.filteredItems.findIndex(function (x) {
                    return !x.disabled;
                }) : -1;
            }
        }
    }, {
        key: "resolveNested",
        value: function resolveNested(option, key) {
            if (!value_utils_1.isObject(option)) {
                return option;
            }
            if (key.indexOf('.') === -1) {
                return option[key];
            }
            var keys = key.split('.');
            var value = option;
            for (var i = 0, len = keys.length; i < len; ++i) {
                if (value == null) {
                    return null;
                }
                value = value[keys[i]];
            }
            return value;
        }
    }, {
        key: "mapItem",
        value: function mapItem(item, index) {
            var label = '';
            if (value_utils_1.isDefined(item.label)) {
                label = item.label;
            } else {
                label = this.resolveNested(item, this._ngSelect.bindLabel);
                label = value_utils_1.isDefined(label) ? label.toString() : '';
            }
            var value = value_utils_1.isDefined(item.$ngOptionValue) ? item.$ngOptionValue : item;
            return {
                index: index,
                label: label,
                value: value,
                disabled: item.disabled,
                htmlId: id_1.newId()
            };
        }
    }, {
        key: "mapSelectedItems",
        value: function mapSelectedItems() {
            var _this5 = this;

            this._selected.forEach(function (selected, i) {
                var value = _this5._ngSelect.bindValue ? selected.value[_this5._ngSelect.bindValue] : selected.value;
                var item = _this5.findItem(value);
                if (item && selected !== item) {
                    item.selected = true;
                    _this5._selected[i] = item;
                }
            });
            if (this._ngSelect.hideSelected) {
                this._filteredItems = this.filteredItems.filter(function (x) {
                    return _this5._selected.indexOf(x) === -1;
                });
            }
        }
    }, {
        key: "_defaultSearchFn",
        value: function _defaultSearchFn(search, opt) {
            var label = searchHelper.stripSpecialChars(opt.label).toLocaleLowerCase();
            return label.indexOf(search) > -1;
        }
    }, {
        key: "_getNextItemIndex",
        value: function _getNextItemIndex(steps) {
            if (steps > 0) {
                return this._markedIndex === this._filteredItems.length - 1 ? 0 : this._markedIndex + 1;
            }
            return this._markedIndex <= 0 ? this._filteredItems.length - 1 : this._markedIndex - 1;
        }
    }, {
        key: "_stepToItem",
        value: function _stepToItem(steps) {
            if (this._filteredItems.length === 0 || this._filteredItems.every(function (x) {
                return x.disabled;
            })) {
                return;
            }
            this._markedIndex = this._getNextItemIndex(steps);
            if (this.markedItem.disabled) {
                this._stepToItem(steps);
            }
        }
    }, {
        key: "_groupBy",
        value: function _groupBy(items, prop) {
            var _this6 = this;

            var isFn = value_utils_1.isFunction(this._ngSelect.groupBy);
            var groups = items.reduce(function (grouped, item) {
                var key = isFn ? prop.apply(_this6, [item.value]) : item.value[prop];
                key = key || undefined;
                var group = grouped.get(key);
                if (group) {
                    group.push(item);
                } else {
                    grouped.set(key, [item]);
                }
                return grouped;
            }, new Map());
            return groups;
        }
    }, {
        key: "_flatten",
        value: function _flatten(groups) {
            var _this7 = this;

            var isFn = value_utils_1.isFunction(this._ngSelect.groupBy);
            var items = [];
            var withoutGroup = groups.get(undefined) || [];
            items.push.apply(items, _toConsumableArray(withoutGroup));
            var i = withoutGroup.length;

            var _loop = function _loop(key) {
                if (!key) {
                    return "continue";
                }
                var parent = {
                    label: key,
                    hasChildren: true,
                    index: i++,
                    disabled: !_this7._ngSelect.selectableGroup,
                    htmlId: id_1.newId()
                };
                var groupKey = isFn ? _this7._ngSelect.bindLabel : _this7._ngSelect.groupBy;
                parent.value = _defineProperty({}, groupKey, key);
                items.push(parent);
                var children = groups.get(key).map(function (x) {
                    x.parent = parent;
                    x.hasChildren = false;
                    x.index = i++;
                    return x;
                });
                items.push.apply(items, _toConsumableArray(children));
            };

            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = Array.from(groups.keys())[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var key = _step3.value;

                    var _ret2 = _loop(key);

                    if (_ret2 === "continue") continue;
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }

            return items;
        }
    }, {
        key: "items",
        get: function get() {
            return this._items;
        }
    }, {
        key: "filteredItems",
        get: function get() {
            return this._filteredItems;
        }
    }, {
        key: "value",
        get: function get() {
            return this._selected;
        }
    }, {
        key: "markedItem",
        get: function get() {
            return this._filteredItems[this._markedIndex];
        }
    }, {
        key: "markedIndex",
        get: function get() {
            return this._markedIndex;
        }
    }, {
        key: "noItemsToSelect",
        get: function get() {
            return this._ngSelect.hideSelected && this._items.length === this._selected.length;
        }
    }, {
        key: "maxItemsSelected",
        get: function get() {
            return this._ngSelect.multiple && this._ngSelect.maxSelectedItems <= this._selected.length;
        }
    }, {
        key: "lastSelectedItem",
        get: function get() {
            return this._selected[this._selected.length - 1];
        }
    }]);

    return ItemsList;
}();

exports.ItemsList = ItemsList;

/***/ }),

/***/ "./shared/libs/@ng-select/ng-select/ng-dropdown-panel.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = undefined && undefined.__param || function (paramIndex, decorator) {
    return function (target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var ng_select_component_1 = __webpack_require__("./shared/libs/@ng-select/ng-select/ng-select.component.ts");
var window_service_1 = __webpack_require__("./shared/libs/@ng-select/ng-select/window.service.ts");
var virtual_scroll_service_1 = __webpack_require__("./shared/libs/@ng-select/ng-select/virtual-scroll.service.ts");
var fromEventPattern_1 = __webpack_require__("./node_modules/rxjs/observable/fromEventPattern.js");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var TOP_CSS_CLASS = 'ng-select-top';
var BOTTOM_CSS_CLASS = 'ng-select-bottom';
var NgDropdownPanelComponent = function () {
    function NgDropdownPanelComponent(_ngSelect, _renderer, _elementRef, _zone, _virtualScrollService, _window) {
        _classCallCheck(this, NgDropdownPanelComponent);

        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this._zone = _zone;
        this._virtualScrollService = _virtualScrollService;
        this._window = _window;
        this.items = [];
        this.position = 'auto';
        this.bufferAmount = 4;
        this.virtualScroll = false;
        this.update = new core_1.EventEmitter();
        this.scrollToEnd = new core_1.EventEmitter();
        this.outsideClick = new core_1.EventEmitter();
        this._destroy$ = new Subject_1.Subject();
        this._startupLoop = true;
        this._isScrolledToMarked = false;
        this._scrollToEndFired = false;
        this._disposeScrollListener = function () {};
        this._disposeDocumentResizeListener = function () {};
        this._selectElement = _ngSelect.elementRef.nativeElement;
        this._itemsList = _ngSelect.itemsList;
    }

    _createClass(NgDropdownPanelComponent, [{
        key: "handleMousedown",
        value: function handleMousedown($event) {
            var target = $event.target;
            if (target.tagName === 'INPUT') {
                return;
            }
            $event.preventDefault();
            $event.stopPropagation();
        }
    }, {
        key: "ngOnInit",
        value: function ngOnInit() {
            var _this = this;

            this._handleScroll();
            fromEventPattern_1.fromEventPattern(function (handler) {
                return document.addEventListener('mousedown', handler, true);
            }).pipe(operators_1.takeUntil(this._destroy$)).subscribe(function ($event) {
                return _this._handleOutsideClick($event);
            });
        }
    }, {
        key: "ngOnChanges",
        value: function ngOnChanges(changes) {
            if (changes.items) {
                this._isScrolledToMarked = false;
                this._handleItemsChange(changes.items);
            }
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this._disposeDocumentResizeListener();
            this._disposeScrollListener();
            this._destroy$.next();
            this._destroy$.complete();
            if (this.appendTo) {
                this._renderer.removeChild(this._elementRef.nativeElement.parentNode, this._elementRef.nativeElement);
            }
        }
    }, {
        key: "ngAfterContentInit",
        value: function ngAfterContentInit() {
            var _this2 = this;

            this._whenContentReady().then(function () {
                if (_this2.appendTo) {
                    _this2._appendDropdown();
                    _this2._handleDocumentResize();
                }
                _this2.updateDropdownPosition();
            });
        }
    }, {
        key: "refresh",
        value: function refresh() {
            var _this3 = this;

            return new Promise(function (resolve) {
                _this3._zone.runOutsideAngular(function () {
                    _this3._window.requestAnimationFrame(function () {
                        _this3._updateItems().then(resolve);
                    });
                });
            });
        }
    }, {
        key: "scrollInto",
        value: function scrollInto(item) {
            if (!item) {
                return;
            }
            var index = this.items.indexOf(item);
            if (index < 0 || index >= this.items.length) {
                return;
            }
            var d = this._calculateDimensions(this.virtualScroll ? 0 : index);
            var scrollEl = this.scrollElementRef.nativeElement;
            var buffer = Math.floor(d.viewHeight / d.childHeight) - 1;
            if (this.virtualScroll) {
                scrollEl.scrollTop = index * d.childHeight - d.childHeight * Math.min(index, buffer);
            } else {
                var contentEl = this.contentElementRef.nativeElement;
                var childrenHeight = Array.from(contentEl.children).slice(0, index).reduce(function (c, n) {
                    return c + n.clientHeight;
                }, 0);
                scrollEl.scrollTop = childrenHeight - d.childHeight * Math.min(index, buffer);
            }
        }
    }, {
        key: "scrollIntoTag",
        value: function scrollIntoTag() {
            var el = this.scrollElementRef.nativeElement;
            var d = this._calculateDimensions();
            el.scrollTop = d.childHeight * (d.itemsLength + 1);
        }
    }, {
        key: "updateDropdownPosition",
        value: function updateDropdownPosition() {
            var dropdownEl = this._elementRef.nativeElement;
            this._currentPosition = this._calculateCurrentPosition(dropdownEl);
            var selectEl = this._selectElement;
            if (this._currentPosition === 'top') {
                this._renderer.addClass(dropdownEl, TOP_CSS_CLASS);
                this._renderer.removeClass(dropdownEl, BOTTOM_CSS_CLASS);
                this._renderer.addClass(selectEl, TOP_CSS_CLASS);
                this._renderer.removeClass(selectEl, BOTTOM_CSS_CLASS);
            } else {
                this._renderer.addClass(dropdownEl, BOTTOM_CSS_CLASS);
                this._renderer.removeClass(dropdownEl, TOP_CSS_CLASS);
                this._renderer.addClass(selectEl, BOTTOM_CSS_CLASS);
                this._renderer.removeClass(selectEl, TOP_CSS_CLASS);
            }
            if (this.appendTo) {
                this._updateAppendedDropdownPosition();
            }
            dropdownEl.style.opacity = '1';
        }
    }, {
        key: "_handleOutsideClick",
        value: function _handleOutsideClick($event) {
            if (this._selectElement.contains($event.target)) {
                return;
            }
            var dropdown = this._elementRef.nativeElement;
            if (dropdown.contains($event.target)) {
                return;
            }
            this.outsideClick.emit();
        }
    }, {
        key: "_handleScroll",
        value: function _handleScroll() {
            var _this4 = this;

            this._disposeScrollListener = this._renderer.listen(this.scrollElementRef.nativeElement, 'scroll', function () {
                _this4.refresh();
                _this4._fireScrollToEnd();
            });
        }
    }, {
        key: "_handleItemsChange",
        value: function _handleItemsChange(items) {
            var _this5 = this;

            this._scrollToEndFired = false;
            this._previousStart = undefined;
            this._previousEnd = undefined;
            if (items !== undefined && items.previousValue === undefined || items.previousValue !== undefined && items.previousValue.length === 0) {
                this._startupLoop = true;
            }
            this.items = items.currentValue || [];
            this.refresh().then(function () {
                if (_this5.appendTo && _this5._currentPosition === 'top') {
                    _this5._updateAppendedDropdownPosition();
                }
            });
        }
    }, {
        key: "_updateItems",
        value: function _updateItems() {
            var _this6 = this;

            core_1.NgZone.assertNotInAngularZone();
            if (!this.virtualScroll) {
                this._zone.run(function () {
                    _this6.update.emit(_this6.items.slice());
                    _this6._scrollToMarked();
                });
                return Promise.resolve();
            }
            var loop = function loop(resolve) {
                var d = _this6._calculateDimensions();
                var res = _this6._virtualScrollService.calculateItems(d, _this6.scrollElementRef.nativeElement, _this6.bufferAmount || 0);
                _this6.paddingElementRef.nativeElement.style.height = res.scrollHeight + "px";
                var transform = "translateY(" + res.topPadding + "px)";
                _this6.contentElementRef.nativeElement.style.transform = transform;
                if (res.start !== _this6._previousStart || res.end !== _this6._previousEnd) {
                    _this6._zone.run(function () {
                        _this6.update.emit(_this6.items.slice(res.start, res.end));
                    });
                    _this6._previousStart = res.start;
                    _this6._previousEnd = res.end;
                    if (_this6._startupLoop === true) {
                        loop(resolve);
                    }
                } else if (_this6._startupLoop === true) {
                    _this6._startupLoop = false;
                    _this6._scrollToMarked();
                    resolve();
                }
            };
            return new Promise(function (resolve) {
                return loop(resolve);
            });
        }
    }, {
        key: "_fireScrollToEnd",
        value: function _fireScrollToEnd() {
            if (this._scrollToEndFired) {
                return;
            }
            var scroll = this.scrollElementRef.nativeElement;
            var panel = this._elementRef.nativeElement;
            var padding = this.virtualScroll ? this.paddingElementRef.nativeElement : this.contentElementRef.nativeElement;
            if (scroll.scrollTop + panel.clientHeight >= padding.clientHeight) {
                this.scrollToEnd.emit();
                this._scrollToEndFired = true;
            }
        }
    }, {
        key: "_calculateDimensions",
        value: function _calculateDimensions() {
            var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

            return this._virtualScrollService.calculateDimensions(this.items.length, index, this.scrollElementRef.nativeElement, this.contentElementRef.nativeElement);
        }
    }, {
        key: "_handleDocumentResize",
        value: function _handleDocumentResize() {
            var _this7 = this;

            if (!this.appendTo) {
                return;
            }
            this._disposeDocumentResizeListener = this._renderer.listen('window', 'resize', function () {
                _this7._updateAppendedDropdownPosition();
            });
        }
    }, {
        key: "_scrollToMarked",
        value: function _scrollToMarked() {
            if (this._isScrolledToMarked) {
                return;
            }
            this._isScrolledToMarked = true;
            this.scrollInto(this._itemsList.markedItem);
        }
    }, {
        key: "_calculateCurrentPosition",
        value: function _calculateCurrentPosition(dropdownEl) {
            if (this.position !== 'auto') {
                return this.position;
            }
            var selectRect = this._selectElement.getBoundingClientRect();
            var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            var offsetTop = selectRect.top + window.pageYOffset;
            var height = selectRect.height;
            var dropdownHeight = dropdownEl.getBoundingClientRect().height;
            if (offsetTop + height + dropdownHeight > scrollTop + document.documentElement.clientHeight) {
                return 'top';
            }
            return 'bottom';
        }
    }, {
        key: "_appendDropdown",
        value: function _appendDropdown() {
            var parent = document.querySelector(this.appendTo);
            if (!parent) {
                throw new Error("appendTo selector " + this.appendTo + " did not found any parent element");
            }
            parent.appendChild(this._elementRef.nativeElement);
        }
    }, {
        key: "_updateAppendedDropdownPosition",
        value: function _updateAppendedDropdownPosition() {
            var parent = document.querySelector(this.appendTo) || document.body;
            var selectRect = this._selectElement.getBoundingClientRect();
            var dropdownPanel = this._elementRef.nativeElement;
            var boundingRect = parent.getBoundingClientRect();
            var offsetTop = selectRect.top - boundingRect.top;
            var offsetLeft = selectRect.left - boundingRect.left;
            var topDelta = this._currentPosition === 'bottom' ? selectRect.height : -dropdownPanel.clientHeight;
            dropdownPanel.style.top = offsetTop + topDelta + "px";
            dropdownPanel.style.bottom = 'auto';
            dropdownPanel.style.left = offsetLeft + "px";
            dropdownPanel.style.width = selectRect.width + "px";
            dropdownPanel.style.minWidth = selectRect.width + "px";
        }
    }, {
        key: "_whenContentReady",
        value: function _whenContentReady() {
            var _this8 = this;

            if (this.items.length === 0) {
                return Promise.resolve();
            }
            var dropdownEl = this._elementRef.nativeElement;
            var ready = function ready(resolve) {
                var ngOption = dropdownEl.querySelector('.ng-option');
                if (ngOption) {
                    resolve();
                    return;
                }
                _this8._zone.runOutsideAngular(function () {
                    setTimeout(function () {
                        return ready(resolve);
                    }, 5);
                });
            };
            return new Promise(function (resolve) {
                return ready(resolve);
            });
        }
    }]);

    return NgDropdownPanelComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Array)], NgDropdownPanelComponent.prototype, "items", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], NgDropdownPanelComponent.prototype, "position", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], NgDropdownPanelComponent.prototype, "appendTo", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], NgDropdownPanelComponent.prototype, "bufferAmount", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], NgDropdownPanelComponent.prototype, "virtualScroll", void 0);
__decorate([core_1.Input(), __metadata("design:type", core_1.TemplateRef)], NgDropdownPanelComponent.prototype, "headerTemplate", void 0);
__decorate([core_1.Input(), __metadata("design:type", core_1.TemplateRef)], NgDropdownPanelComponent.prototype, "footerTemplate", void 0);
__decorate([core_1.Output(), __metadata("design:type", Object)], NgDropdownPanelComponent.prototype, "update", void 0);
__decorate([core_1.Output(), __metadata("design:type", Object)], NgDropdownPanelComponent.prototype, "scrollToEnd", void 0);
__decorate([core_1.Output(), __metadata("design:type", Object)], NgDropdownPanelComponent.prototype, "outsideClick", void 0);
__decorate([core_1.ViewChild('content', { read: core_1.ElementRef }), __metadata("design:type", core_1.ElementRef)], NgDropdownPanelComponent.prototype, "contentElementRef", void 0);
__decorate([core_1.ViewChild('scroll', { read: core_1.ElementRef }), __metadata("design:type", core_1.ElementRef)], NgDropdownPanelComponent.prototype, "scrollElementRef", void 0);
__decorate([core_1.ViewChild('padding', { read: core_1.ElementRef }), __metadata("design:type", core_1.ElementRef)], NgDropdownPanelComponent.prototype, "paddingElementRef", void 0);
__decorate([core_1.HostListener('mousedown', ['$event']), __metadata("design:type", Function), __metadata("design:paramtypes", [MouseEvent]), __metadata("design:returntype", void 0)], NgDropdownPanelComponent.prototype, "handleMousedown", null);
NgDropdownPanelComponent = __decorate([core_1.Component({
    changeDetection: core_1.ChangeDetectionStrategy.OnPush,
    encapsulation: core_1.ViewEncapsulation.None,
    selector: 'ng-dropdown-panel',
    template: "\n        <div *ngIf=\"headerTemplate\" class=\"ng-dropdown-header\">\n            <ng-container [ngTemplateOutlet]=\"headerTemplate\"></ng-container>\n        </div>\n        <div  #scroll class=\"ng-dropdown-panel-items scroll-host\">\n            <div #padding [class.total-padding]=\"virtualScroll\"></div>\n            <div #content [class.scrollable-content]=\"virtualScroll && items.length > 0\">\n                <ng-content></ng-content>\n            </div>\n        </div>\n        <div *ngIf=\"footerTemplate\" class=\"ng-dropdown-footer\">\n            <ng-container [ngTemplateOutlet]=\"footerTemplate\"></ng-container>\n        </div>\n    "
}), __param(0, core_1.Inject(core_1.forwardRef(function () {
    return ng_select_component_1.NgSelectComponent;
}))), __metadata("design:paramtypes", [ng_select_component_1.NgSelectComponent, core_1.Renderer2, core_1.ElementRef, core_1.NgZone, virtual_scroll_service_1.VirtualScrollService, window_service_1.WindowService])], NgDropdownPanelComponent);
exports.NgDropdownPanelComponent = NgDropdownPanelComponent;

/***/ }),

/***/ "./shared/libs/@ng-select/ng-select/ng-option-highlight.directive.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var searchHelper = __webpack_require__("./shared/libs/@ng-select/ng-select/search-helper.ts");
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var value_utils_1 = __webpack_require__("./shared/libs/@ng-select/ng-select/value-utils.ts");
var NgOptionHighlightDirective = function () {
    function NgOptionHighlightDirective(elementRef, renderer) {
        _classCallCheck(this, NgOptionHighlightDirective);

        this.elementRef = elementRef;
        this.renderer = renderer;
        this.element = this.elementRef.nativeElement;
    }

    _createClass(NgOptionHighlightDirective, [{
        key: "ngOnChanges",
        value: function ngOnChanges() {
            if (this._canHighlight) {
                this._highlightLabel();
            }
        }
    }, {
        key: "ngAfterViewInit",
        value: function ngAfterViewInit() {
            this.label = this.element.innerHTML;
            if (this._canHighlight) {
                this._highlightLabel();
            }
        }
    }, {
        key: "_highlightLabel",
        value: function _highlightLabel() {
            var label = this.label;
            if (!this.term) {
                this._setInnerHtml(label);
                return;
            }
            var indexOfTerm = searchHelper.stripSpecialChars(label).toLowerCase().indexOf(searchHelper.stripSpecialChars(this.term).toLowerCase());
            if (indexOfTerm > -1) {
                this._setInnerHtml(label.substring(0, indexOfTerm) + "<span class=\"highlighted\">" + label.substr(indexOfTerm, this.term.length) + "</span>" + label.substring(indexOfTerm + this.term.length, label.length));
            } else {
                this._setInnerHtml(label);
            }
        }
    }, {
        key: "_setInnerHtml",
        value: function _setInnerHtml(html) {
            this.renderer.setProperty(this.elementRef.nativeElement, 'innerHTML', html);
        }
    }, {
        key: "_canHighlight",
        get: function get() {
            return value_utils_1.isDefined(this.term) && value_utils_1.isDefined(this.label);
        }
    }]);

    return NgOptionHighlightDirective;
}();
__decorate([core_1.Input('ngOptionHighlight'), __metadata("design:type", String)], NgOptionHighlightDirective.prototype, "term", void 0);
NgOptionHighlightDirective = __decorate([core_1.Directive({
    selector: '[ngOptionHighlight]'
}), __metadata("design:paramtypes", [core_1.ElementRef, core_1.Renderer2])], NgOptionHighlightDirective);
exports.NgOptionHighlightDirective = NgOptionHighlightDirective;

/***/ }),

/***/ "./shared/libs/@ng-select/ng-select/ng-option.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var NgOptionComponent = function () {
    function NgOptionComponent(elementRef) {
        _classCallCheck(this, NgOptionComponent);

        this.elementRef = elementRef;
        this.stateChange$ = new Subject_1.Subject();
        this._disabled = false;
    }

    _createClass(NgOptionComponent, [{
        key: "ngOnChanges",
        value: function ngOnChanges(changes) {
            if (changes.disabled) {
                this.stateChange$.next({
                    value: this.value,
                    disabled: this._disabled
                });
            }
        }
    }, {
        key: "_isDisabled",
        value: function _isDisabled(value) {
            return value != null && "" + value !== 'false';
        }
    }, {
        key: "disabled",
        get: function get() {
            return this._disabled;
        },
        set: function set(value) {
            this._disabled = this._isDisabled(value);
        }
    }]);

    return NgOptionComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], NgOptionComponent.prototype, "value", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object), __metadata("design:paramtypes", [Object])], NgOptionComponent.prototype, "disabled", null);
NgOptionComponent = __decorate([core_1.Component({
    selector: 'ng-option',
    changeDetection: core_1.ChangeDetectionStrategy.OnPush,
    template: "<ng-content></ng-content>"
}), __metadata("design:paramtypes", [core_1.ElementRef])], NgOptionComponent);
exports.NgOptionComponent = NgOptionComponent;

/***/ }),

/***/ "./shared/libs/@ng-select/ng-select/ng-select.component.html":
/***/ (function(module, exports) {

module.exports = "<div (mousedown)=\"handleMousedown($event)\" [class.ng-has-value]=\"hasValue\" class=\"ng-select-container\">\n    <div class=\"ng-value-container\">\n        <div class=\"ng-placeholder\">{{placeholder}}</div>\n\n        <ng-container *ngIf=\"!multiLabelTemplate && selectedItems.length > 0\">\n            <div [class.ng-value-disabled]=\"item.disabled\" class=\"ng-value\" *ngFor=\"let item of selectedItems\">\n                <ng-template #defaultLabelTemplate>\n                    <span class=\"ng-value-icon left\" (click)=\"unselect(item);\" aria-hidden=\"true\">×</span>\n                    <span class=\"ng-value-label\">{{item.label}}</span>\n                </ng-template>\n\n                <ng-template\n                    [ngTemplateOutlet]=\"labelTemplate || defaultLabelTemplate\"\n                    [ngTemplateOutletContext]=\"{ item: item.value, clear: clearItem, label: item.label }\">\n                </ng-template>\n            </div>\n        </ng-container>\n\n        <ng-template *ngIf=\"multiLabelTemplate && selectedValues.length > 0\"\n                [ngTemplateOutlet]=\"multiLabelTemplate\"\n                [ngTemplateOutletContext]=\"{ items: selectedValues, clear: clearItem }\">\n        </ng-template>\n\n        <div class=\"ng-input\">\n            <input #filterInput\n                   type=\"text\"\n                   autocomplete=\"{{dropdownId}}\"\n                   [id]=\"labelForId\"\n                   [readOnly]=\"!searchable\"\n                   [disabled]=\"isDisabled\"\n                   [value]=\"filterValue\"\n                   (input)=\"filter(filterInput.value)\"\n                   (focus)=\"onInputFocus()\"\n                   (blur)=\"onInputBlur()\"\n                   (change)=\"$event.stopPropagation()\"\n                   role=\"combobox\"\n                   [attr.aria-expanded]=\"isOpen\"\n                   [attr.aria-owns]=\"isOpen ? dropdownId : null\"\n                   [attr.aria-activedescendant]=\"isOpen ? itemsList?.markedItem?.htmlId : null\">\n        </div>\n    </div>\n\n    <div class=\"ng-spinner-loader\" *ngIf=\"loading\"></div>\n\n    <span *ngIf=\"showClear()\" class=\"ng-clear-wrapper\" title=\"{{clearAllText}}\">\n        <span class=\"ng-clear\" aria-hidden=\"true\">×</span>\n    </span>\n\n    <span class=\"ng-arrow-wrapper\">\n        <span class=\"ng-arrow\"></span>\n    </span>\n</div>\n\n<ng-dropdown-panel *ngIf=\"isOpen\"\n    class=\"ng-dropdown-panel\"\n    [virtualScroll]=\"virtualScroll\"\n    [bufferAmount]=\"bufferAmount\"\n    [appendTo]=\"appendTo\"\n    [position]=\"dropdownPosition\"\n    [headerTemplate]=\"headerTemplate\"\n    [footerTemplate]=\"footerTemplate\"\n    [items]=\"itemsList.filteredItems\"\n    (update)=\"viewPortItems = $event\"\n    (scrollToEnd)=\"scrollToEnd.emit($event)\"\n    (outsideClick)=\"close()\"\n    [class.ng-select-multiple]=\"multiple\"\n    [ngClass]=\"classes\"\n    [id]=\"dropdownId\">\n\n    <ng-container>\n        <div class=\"ng-option\" [attr.role]=\"item.hasChildren ? 'group' : 'option'\" (click)=\"toggleItem(item)\" (mousedown)=\"$event.preventDefault()\" (mouseover)=\"onItemHover(item)\"\n                *ngFor=\"let item of viewPortItems\"\n                [class.ng-option-disabled]=\"item.disabled\"\n                [class.ng-option-selected]=\"item.selected\"\n                [class.ng-optgroup]=\"item.hasChildren\"\n                [class.ng-option]=\"!item.hasChildren\"\n                [class.ng-option-child]=\"!!item.parent\"\n                [class.ng-option-marked]=\"item === itemsList.markedItem\"\n                id=\"{{item?.htmlId || null}}\">\n\n            <ng-template #defaultOptionTemplate>\n                <span class=\"ng-option-label\">{{item.label}}</span>\n            </ng-template>\n\n            <ng-template\n                [ngTemplateOutlet]=\"item.hasChildren ? (optgroupTemplate || defaultOptionTemplate) : (optionTemplate || defaultOptionTemplate)\"\n                [ngTemplateOutletContext]=\"{ item: item.value, index: item.index, searchTerm: filterValue }\">\n            </ng-template>\n        </div>\n\n        <div class=\"ng-option\" [class.ng-option-marked]=\"!itemsList.markedItem\" (mouseover)=\"itemsList.unmarkItem()\" role=\"option\" (click)=\"selectTag()\" *ngIf=\"showAddTag()\">\n            <ng-template #defaultTagTemplate>\n                <span><span class=\"ng-tag-label\">{{addTagText}}</span>\"{{filterValue}}\"</span>\n            </ng-template>\n\n            <ng-template\n                [ngTemplateOutlet]=\"tagTemplate || defaultTagTemplate\"\n                [ngTemplateOutletContext]=\"{ searchTerm: filterValue }\">\n            </ng-template>\n        </div>\n    </ng-container>\n\n    <ng-container *ngIf=\"showNoItemsFound()\">\n        <ng-template #defaultNotFoundTemplate>\n            <div class=\"ng-option ng-option-disabled\">{{notFoundText}}</div>\n        </ng-template>\n\n        <ng-template\n            [ngTemplateOutlet]=\"notFoundTemplate || defaultNotFoundTemplate\"\n            [ngTemplateOutletContext]=\"{ searchTerm: filterValue }\">\n        </ng-template>\n    </ng-container>\n\n    <ng-container *ngIf=\"showTypeToSearch()\">\n        <ng-template #defaultTypeToSearchTemplate>\n            <div class=\"ng-option ng-option-disabled\">{{typeToSearchText}}</div>\n        </ng-template>\n\n        <ng-template\n            [ngTemplateOutlet]=\"typeToSearchTemplate || defaultTypeToSearchTemplate\">\n        </ng-template>\n    </ng-container>\n\n    <ng-container *ngIf=\"loading && itemsList.filteredItems.length === 0\">\n        <ng-template #defaultLoadingTextTemplate>\n            <div class=\"ng-option ng-option-disabled\">{{loadingText}}</div>\n        </ng-template>\n\n        <ng-template\n            [ngTemplateOutlet]=\"loadingTextTemplate || defaultLoadingTextTemplate\"\n            [ngTemplateOutletContext]=\"{ searchTerm: filterValue  }\">\n        </ng-template>\n    </ng-container>\n\n</ng-dropdown-panel>\n"

/***/ }),

/***/ "./shared/libs/@ng-select/ng-select/ng-select.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = undefined && undefined.__param || function (paramIndex, decorator) {
    return function (target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var forms_1 = __webpack_require__("./node_modules/@angular/forms/esm5/forms.js");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var merge_1 = __webpack_require__("./node_modules/rxjs/observable/merge.js");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var ng_templates_directive_1 = __webpack_require__("./shared/libs/@ng-select/ng-select/ng-templates.directive.ts");
var console_service_1 = __webpack_require__("./shared/libs/@ng-select/ng-select/console.service.ts");
var value_utils_1 = __webpack_require__("./shared/libs/@ng-select/ng-select/value-utils.ts");
var items_list_1 = __webpack_require__("./shared/libs/@ng-select/ng-select/items-list.ts");
var ng_select_types_1 = __webpack_require__("./shared/libs/@ng-select/ng-select/ng-select.types.ts");
var id_1 = __webpack_require__("./shared/libs/@ng-select/ng-select/id.ts");
var ng_dropdown_panel_component_1 = __webpack_require__("./shared/libs/@ng-select/ng-select/ng-dropdown-panel.component.ts");
var ng_option_component_1 = __webpack_require__("./shared/libs/@ng-select/ng-select/ng-option.component.ts");
var window_service_1 = __webpack_require__("./shared/libs/@ng-select/ng-select/window.service.ts");
exports.NG_SELECT_DEFAULT_CONFIG = new core_1.InjectionToken('ng-select-default-options');
var NgSelectComponent = NgSelectComponent_1 = function () {
    function NgSelectComponent(config, classes, _cd, _console, _zone, _window, elementRef) {
        var _this = this;

        _classCallCheck(this, NgSelectComponent);

        this.classes = classes;
        this._cd = _cd;
        this._console = _console;
        this._zone = _zone;
        this._window = _window;
        this.elementRef = elementRef;
        // inputs
        this.items = [];
        this.clearable = true;
        this.markFirst = true;
        this.dropdownPosition = 'auto';
        this.loading = false;
        this.closeOnSelect = true;
        this.hideSelected = false;
        this.selectOnTab = false;
        this.bufferAmount = 4;
        this.virtualScroll = false;
        this.selectableGroup = false;
        this.searchFn = null;
        this.clearSearchOnAdd = true;
        this.labelForId = '';
        this.multiple = false;
        this.addTag = false;
        this.searchable = true;
        // output events
        this.blurEvent = new core_1.EventEmitter();
        this.focusEvent = new core_1.EventEmitter();
        this.changeEvent = new core_1.EventEmitter();
        this.openEvent = new core_1.EventEmitter();
        this.closeEvent = new core_1.EventEmitter();
        this.searchEvent = new core_1.EventEmitter();
        this.clearEvent = new core_1.EventEmitter();
        this.addEvent = new core_1.EventEmitter();
        this.removeEvent = new core_1.EventEmitter();
        this.scrollToEnd = new core_1.EventEmitter();
        this.isOpen = false;
        this.isDisabled = false;
        this.itemsList = new items_list_1.ItemsList(this);
        this.viewPortItems = [];
        this.filterValue = null;
        this.dropdownId = id_1.newId();
        this.selectedItemId = 0;
        this._defaultLabel = 'label';
        this._pressedKeys = [];
        this._destroy$ = new Subject_1.Subject();
        this._keyPress$ = new Subject_1.Subject();
        this._onChange = function (_) {};
        this._onTouched = function () {};
        this.clearItem = function (item) {
            var option = _this.selectedItems.find(function (x) {
                return x.value === item;
            });
            _this.unselect(option);
        };
        this._mergeGlobalConfig(config);
    }

    _createClass(NgSelectComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this._handleKeyPresses();
        }
    }, {
        key: "ngOnChanges",
        value: function ngOnChanges(changes) {
            if (changes.multiple) {
                this.itemsList.clearSelected();
            }
            if (changes.items) {
                this._setItems(changes.items.currentValue || []);
            }
        }
    }, {
        key: "ngAfterViewInit",
        value: function ngAfterViewInit() {
            if (this.items && this.items.length === 0) {
                this._setItemsFromNgOptions();
            }
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this._destroy$.next();
            this._destroy$.complete();
        }
    }, {
        key: "handleKeyDown",
        value: function handleKeyDown($event) {
            if (ng_select_types_1.KeyCode[$event.which]) {
                switch ($event.which) {
                    case ng_select_types_1.KeyCode.ArrowDown:
                        this._handleArrowDown($event);
                        break;
                    case ng_select_types_1.KeyCode.ArrowUp:
                        this._handleArrowUp($event);
                        break;
                    case ng_select_types_1.KeyCode.Space:
                        this._handleSpace($event);
                        break;
                    case ng_select_types_1.KeyCode.Enter:
                        this._handleEnter($event);
                        break;
                    case ng_select_types_1.KeyCode.Tab:
                        this._handleTab($event);
                        break;
                    case ng_select_types_1.KeyCode.Esc:
                        this.close();
                        break;
                    case ng_select_types_1.KeyCode.Backspace:
                        this._handleBackspace();
                        break;
                }
            } else if ($event.key && $event.key.length === 1) {
                this._keyPress$.next($event.key.toLocaleLowerCase());
            }
        }
    }, {
        key: "handleMousedown",
        value: function handleMousedown($event) {
            var target = $event.target;
            if (target.tagName !== 'INPUT') {
                $event.preventDefault();
            }
            if (target.className === 'ng-clear') {
                this.handleClearClick();
                return;
            }
            if (target.className === 'ng-arrow') {
                this.handleArrowClick();
                return;
            }
            if (!this._focused) {
                this.focus();
            }
            if (target.className.includes('ng-value-icon')) {
                return;
            }
            if (this.searchable) {
                this.open();
            } else {
                this.toggle();
            }
            $event.stopPropagation();
        }
    }, {
        key: "handleArrowClick",
        value: function handleArrowClick() {
            if (this.isOpen) {
                this.close();
            } else {
                this.open();
            }
        }
    }, {
        key: "handleClearClick",
        value: function handleClearClick() {
            if (this.hasValue) {
                this.clearModel();
            }
            this._clearSearch();
            this.focus();
            if (this._isTypeahead) {
                this.typeahead.next(null);
            }
            this.clearEvent.emit();
        }
    }, {
        key: "clearModel",
        value: function clearModel() {
            if (!this.clearable) {
                return;
            }
            this.itemsList.clearSelected();
            this._updateNgModel();
        }
    }, {
        key: "writeValue",
        value: function writeValue(value) {
            this.itemsList.clearSelected();
            this._handleWriteValue(value);
            this._cd.markForCheck();
        }
    }, {
        key: "registerOnChange",
        value: function registerOnChange(fn) {
            this._onChange = fn;
        }
    }, {
        key: "registerOnTouched",
        value: function registerOnTouched(fn) {
            this._onTouched = fn;
        }
    }, {
        key: "setDisabledState",
        value: function setDisabledState(isDisabled) {
            this.isDisabled = isDisabled;
            this._cd.markForCheck();
        }
    }, {
        key: "toggle",
        value: function toggle() {
            if (!this.isOpen) {
                this.open();
            } else {
                this.close();
            }
        }
    }, {
        key: "open",
        value: function open() {
            if (this.isDisabled || this.isOpen || this.itemsList.maxItemsSelected) {
                return;
            }
            if (!this._isTypeahead && !this.addTag && this.itemsList.noItemsToSelect) {
                return;
            }
            this.isOpen = true;
            this.itemsList.markSelectedOrDefault(this.markFirst);
            this.openEvent.emit();
            if (!this.filterValue) {
                this.focus();
            }
            this.detectChanges();
        }
    }, {
        key: "close",
        value: function close() {
            if (!this.isOpen) {
                return;
            }
            this.isOpen = false;
            this._clearSearch();
            this._onTouched();
            this.closeEvent.emit();
            this._cd.markForCheck();
        }
    }, {
        key: "toggleItem",
        value: function toggleItem(item) {
            if (!item || item.disabled || this.isDisabled) {
                return;
            }
            if (this.multiple && item.selected) {
                this.unselect(item);
            } else {
                this.select(item);
            }
        }
    }, {
        key: "select",
        value: function select(item) {
            if (!item.selected) {
                this.itemsList.select(item);
                if (this.clearSearchOnAdd) {
                    this._clearSearch();
                }
                if (this.multiple) {
                    this.addEvent.emit(item.value);
                }
                this._updateNgModel();
            }
            if (this.closeOnSelect || this.itemsList.noItemsToSelect) {
                this.close();
            }
        }
    }, {
        key: "focus",
        value: function focus() {
            var _this2 = this;

            if (!this.filterInput) {
                return;
            }
            this._zone.runOutsideAngular(function () {
                _this2._window.setTimeout(function () {
                    _this2.filterInput.nativeElement.focus();
                }, 5);
            });
        }
    }, {
        key: "unselect",
        value: function unselect(item) {
            this.itemsList.unselect(item);
            this._updateNgModel();
            this.removeEvent.emit(item);
        }
    }, {
        key: "selectTag",
        value: function selectTag() {
            var _this3 = this;

            var tag = void 0;
            if (value_utils_1.isFunction(this.addTag)) {
                tag = this.addTag(this.filterValue);
            } else {
                tag = this._primitive ? this.filterValue : _defineProperty({}, this.bindLabel, this.filterValue);
            }
            if (value_utils_1.isPromise(tag)) {
                tag.then(function (item) {
                    return _this3.select(_this3.itemsList.addItem(item));
                }).catch(function () {});
            } else if (tag) {
                this.select(this.itemsList.addItem(tag));
            }
        }
    }, {
        key: "showClear",
        value: function showClear() {
            return this.clearable && (this.hasValue || this.filterValue) && !this.isDisabled;
        }
    }, {
        key: "showAddTag",
        value: function showAddTag() {
            var _this4 = this;

            return this.addTag && this.filterValue && !this.selectedItems.some(function (x) {
                return x.label.toLowerCase() === _this4.filterValue.toLowerCase();
            }) && !this.loading;
        }
    }, {
        key: "showNoItemsFound",
        value: function showNoItemsFound() {
            var empty = this.itemsList.filteredItems.length === 0;
            return (empty && !this._isTypeahead && !this.loading || empty && this._isTypeahead && this.filterValue && !this.loading) && !this.showAddTag();
        }
    }, {
        key: "showTypeToSearch",
        value: function showTypeToSearch() {
            var empty = this.itemsList.filteredItems.length === 0;
            return empty && this._isTypeahead && !this.filterValue && !this.loading;
        }
    }, {
        key: "filter",
        value: function filter(term) {
            this.filterValue = term;
            this.open();
            if (this._isTypeahead) {
                this.typeahead.next(this.filterValue);
            } else {
                this.itemsList.filter(this.filterValue);
                this.itemsList.markSelectedOrDefault(this.markFirst);
            }
        }
    }, {
        key: "onInputFocus",
        value: function onInputFocus() {
            this.elementRef.nativeElement.classList.add('ng-select-focused');
            this.focusEvent.emit(null);
            this._focused = true;
        }
    }, {
        key: "onInputBlur",
        value: function onInputBlur() {
            this.elementRef.nativeElement.classList.remove('ng-select-focused');
            this.blurEvent.emit(null);
            if (!this.isOpen && !this.isDisabled) {
                this._onTouched();
            }
            this._focused = false;
        }
    }, {
        key: "onItemHover",
        value: function onItemHover(item) {
            if (item.disabled) {
                return;
            }
            this.itemsList.markItem(item);
        }
    }, {
        key: "detectChanges",
        value: function detectChanges() {
            if (!this._cd.destroyed) {
                this._cd.detectChanges();
            }
        }
    }, {
        key: "updateDropdownPosition",
        value: function updateDropdownPosition() {
            if (this.dropdownPanel) {
                this.dropdownPanel.updateDropdownPosition();
            }
        }
    }, {
        key: "_setItems",
        value: function _setItems(items) {
            var firstItem = items[0];
            this.bindLabel = this.bindLabel || this._defaultLabel;
            this._primitive = !value_utils_1.isObject(firstItem);
            this.itemsList.setItems(items);
            if (items.length > 0 && this.hasValue) {
                this.itemsList.mapSelectedItems();
            }
            if (this._isTypeahead || this.isOpen) {
                this.itemsList.markSelectedOrDefault(this.markFirst);
            }
        }
    }, {
        key: "_setItemsFromNgOptions",
        value: function _setItemsFromNgOptions() {
            var _this5 = this;

            var handleNgOptions = function handleNgOptions(options) {
                _this5.items = options.map(function (option) {
                    return {
                        $ngOptionValue: option.value,
                        label: option.elementRef.nativeElement.innerHTML,
                        disabled: option.disabled
                    };
                });
                _this5.itemsList.setItems(_this5.items);
                if (_this5.hasValue) {
                    _this5.itemsList.mapSelectedItems();
                }
                _this5.detectChanges();
            };
            var handleOptionChange = function handleOptionChange() {
                var changedOrDestroyed = merge_1.merge(_this5.ngOptions.changes, _this5._destroy$);
                merge_1.merge.apply(merge_1, _toConsumableArray(_this5.ngOptions.map(function (option) {
                    return option.stateChange$;
                }))).pipe(operators_1.takeUntil(changedOrDestroyed)).subscribe(function (option) {
                    var item = _this5.itemsList.findItem(option.value);
                    item.disabled = option.disabled;
                    _this5._cd.markForCheck();
                });
            };
            this.ngOptions.changes.pipe(operators_1.startWith(this.ngOptions), operators_1.takeUntil(this._destroy$)).subscribe(function (options) {
                handleNgOptions(options);
                handleOptionChange();
            });
        }
    }, {
        key: "_isValidWriteValue",
        value: function _isValidWriteValue(value) {
            var _this6 = this;

            if (!value_utils_1.isDefined(value) || this.multiple && value === '' || Array.isArray(value) && value.length === 0) {
                return false;
            }
            var validateBinding = function validateBinding(item) {
                if (value_utils_1.isObject(item) && _this6.bindValue) {
                    _this6._console.warn("Binding object(" + JSON.stringify(item) + ") with bindValue is not allowed.");
                    return false;
                }
                return true;
            };
            if (this.multiple) {
                if (!Array.isArray(value)) {
                    this._console.warn('Multiple select ngModel should be array.');
                    return false;
                }
                return value.every(function (item) {
                    return validateBinding(item);
                });
            }
            return validateBinding(value);
        }
    }, {
        key: "_handleWriteValue",
        value: function _handleWriteValue(ngModel) {
            var _this7 = this;

            if (!this._isValidWriteValue(ngModel)) {
                return;
            }
            var select = function select(val) {
                var item = _this7.itemsList.findItem(val);
                if (item) {
                    _this7.itemsList.select(item);
                } else {
                    var isValObject = value_utils_1.isObject(val);
                    var isPrimitive = !isValObject && !_this7.bindValue;
                    if (isValObject || isPrimitive) {
                        _this7.itemsList.select(_this7.itemsList.mapItem(val, null));
                    } else if (_this7.bindValue) {
                        var _item;

                        item = (_item = {}, _defineProperty(_item, _this7.bindLabel, null), _defineProperty(_item, _this7.bindValue, val), _item);
                        _this7.itemsList.select(_this7.itemsList.mapItem(item, null));
                    }
                }
            };
            if (this.multiple) {
                ngModel.forEach(function (item) {
                    return select(item);
                });
            } else {
                select(ngModel);
            }
        }
    }, {
        key: "_handleKeyPresses",
        value: function _handleKeyPresses() {
            var _this8 = this;

            if (this.searchable) {
                return;
            }
            this._keyPress$.pipe(operators_1.takeUntil(this._destroy$), operators_1.tap(function (letter) {
                return _this8._pressedKeys.push(letter);
            }), operators_1.debounceTime(200), operators_1.filter(function () {
                return _this8._pressedKeys.length > 0;
            }), operators_1.map(function () {
                return _this8._pressedKeys.join('');
            })).subscribe(function (term) {
                var item = _this8.itemsList.findByLabel(term);
                if (item) {
                    if (_this8.isOpen) {
                        _this8.itemsList.markItem(item);
                        _this8._cd.markForCheck();
                    } else {
                        _this8.select(item);
                    }
                }
                _this8._pressedKeys = [];
            });
        }
    }, {
        key: "_updateNgModel",
        value: function _updateNgModel() {
            var model = [];
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = this.selectedItems[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var item = _step.value;

                    if (this.bindValue) {
                        var resolvedValue = null;
                        if (item.hasChildren) {
                            resolvedValue = item.value[this.groupBy];
                        } else {
                            resolvedValue = this.itemsList.resolveNested(item.value, this.bindValue);
                        }
                        model.push(resolvedValue);
                    } else {
                        model.push(item.value);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            if (this.multiple) {
                this._onChange(model);
                this.changeEvent.emit(this.selectedItems.map(function (x) {
                    return x.value;
                }));
            } else {
                this._onChange(value_utils_1.isDefined(model[0]) ? model[0] : null);
                this.changeEvent.emit(this.selectedItems[0] && this.selectedItems[0].value);
            }
            this._cd.markForCheck();
        }
    }, {
        key: "_clearSearch",
        value: function _clearSearch() {
            if (!this.filterValue) {
                return;
            }
            this.filterValue = null;
            this.itemsList.resetItems();
        }
    }, {
        key: "_scrollToMarked",
        value: function _scrollToMarked() {
            if (!this.isOpen || !this.dropdownPanel) {
                return;
            }
            this.dropdownPanel.scrollInto(this.itemsList.markedItem);
        }
    }, {
        key: "_scrollToTag",
        value: function _scrollToTag() {
            if (!this.isOpen || !this.dropdownPanel) {
                return;
            }
            this.dropdownPanel.scrollIntoTag();
        }
    }, {
        key: "_handleTab",
        value: function _handleTab($event) {
            if (!this.isOpen) {
                return;
            }
            if (this.selectOnTab) {
                if (this.itemsList.markedItem) {
                    this.toggleItem(this.itemsList.markedItem);
                    $event.preventDefault();
                } else if (this.showAddTag()) {
                    this.selectTag();
                    $event.preventDefault();
                } else {
                    this.close();
                }
            } else {
                this.close();
            }
        }
    }, {
        key: "_handleEnter",
        value: function _handleEnter($event) {
            if (this.isOpen) {
                if (this.itemsList.markedItem) {
                    this.toggleItem(this.itemsList.markedItem);
                } else if (this.addTag) {
                    this.selectTag();
                }
            } else {
                this.open();
            }
            $event.preventDefault();
            $event.stopPropagation();
        }
    }, {
        key: "_handleSpace",
        value: function _handleSpace($event) {
            if (this.isOpen) {
                return;
            }
            this.open();
            $event.preventDefault();
        }
    }, {
        key: "_handleArrowDown",
        value: function _handleArrowDown($event) {
            if (this.nextItemIsTag(+1)) {
                this.itemsList.unmarkItem();
                this._scrollToTag();
            } else {
                this.itemsList.markNextItem();
                this._scrollToMarked();
            }
            this.open();
            $event.preventDefault();
        }
    }, {
        key: "_handleArrowUp",
        value: function _handleArrowUp($event) {
            if (!this.isOpen) {
                return;
            }
            if (this.nextItemIsTag(-1)) {
                this.itemsList.unmarkItem();
                this._scrollToTag();
            } else {
                this.itemsList.markPreviousItem();
                this._scrollToMarked();
            }
            $event.preventDefault();
        }
    }, {
        key: "nextItemIsTag",
        value: function nextItemIsTag(nextStep) {
            var nextIndex = this.itemsList.markedIndex + nextStep;
            return this.addTag && this.filterValue && this.itemsList.markedItem && (nextIndex < 0 || nextIndex === this.itemsList.filteredItems.length);
        }
    }, {
        key: "_handleBackspace",
        value: function _handleBackspace() {
            if (this.filterValue || !this.clearable || !this.hasValue) {
                return;
            }
            if (this.multiple) {
                this.unselect(this.itemsList.lastSelectedItem);
            } else {
                this.clearModel();
            }
        }
    }, {
        key: "_mergeGlobalConfig",
        value: function _mergeGlobalConfig(config) {
            this.notFoundText = this.notFoundText || config.notFoundText;
            this.typeToSearchText = this.typeToSearchText || config.typeToSearchText;
            this.addTagText = this.addTagText || config.addTagText;
            this.loadingText = this.loadingText || config.loadingText;
            this.clearAllText = this.clearAllText || config.clearAllText;
        }
    }, {
        key: "compareWith",
        get: function get() {
            return this._compareWith;
        },
        set: function set(fn) {
            if (!value_utils_1.isFunction(fn)) {
                throw Error('`compareWith` must be a function.');
            }
            this._compareWith = fn;
        }
    }, {
        key: "filtered",
        get: function get() {
            return !!this.filterValue && this.searchable;
        }
    }, {
        key: "selectedItems",
        get: function get() {
            return this.itemsList.value;
        }
    }, {
        key: "selectedValues",
        get: function get() {
            return this.selectedItems.map(function (x) {
                return x.value;
            });
        }
    }, {
        key: "hasValue",
        get: function get() {
            return this.selectedItems.length > 0;
        }
    }, {
        key: "_isTypeahead",
        get: function get() {
            return this.typeahead && this.typeahead.observers.length > 0;
        }
    }]);

    return NgSelectComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Array)], NgSelectComponent.prototype, "items", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], NgSelectComponent.prototype, "bindLabel", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], NgSelectComponent.prototype, "bindValue", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], NgSelectComponent.prototype, "clearable", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], NgSelectComponent.prototype, "markFirst", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], NgSelectComponent.prototype, "placeholder", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], NgSelectComponent.prototype, "notFoundText", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], NgSelectComponent.prototype, "typeToSearchText", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], NgSelectComponent.prototype, "addTagText", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], NgSelectComponent.prototype, "loadingText", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], NgSelectComponent.prototype, "clearAllText", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], NgSelectComponent.prototype, "dropdownPosition", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], NgSelectComponent.prototype, "appendTo", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], NgSelectComponent.prototype, "loading", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], NgSelectComponent.prototype, "closeOnSelect", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], NgSelectComponent.prototype, "hideSelected", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], NgSelectComponent.prototype, "selectOnTab", void 0);
__decorate([core_1.Input(), __metadata("design:type", Number)], NgSelectComponent.prototype, "maxSelectedItems", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], NgSelectComponent.prototype, "groupBy", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], NgSelectComponent.prototype, "bufferAmount", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], NgSelectComponent.prototype, "virtualScroll", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], NgSelectComponent.prototype, "selectableGroup", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], NgSelectComponent.prototype, "searchFn", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], NgSelectComponent.prototype, "clearSearchOnAdd", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], NgSelectComponent.prototype, "labelForId", void 0);
__decorate([core_1.Input(), core_1.HostBinding('class.ng-select-typeahead'), __metadata("design:type", Subject_1.Subject)], NgSelectComponent.prototype, "typeahead", void 0);
__decorate([core_1.Input(), core_1.HostBinding('class.ng-select-multiple'), __metadata("design:type", Object)], NgSelectComponent.prototype, "multiple", void 0);
__decorate([core_1.Input(), core_1.HostBinding('class.ng-select-taggable'), __metadata("design:type", Object)], NgSelectComponent.prototype, "addTag", void 0);
__decorate([core_1.Input(), core_1.HostBinding('class.ng-select-searchable'), __metadata("design:type", Object)], NgSelectComponent.prototype, "searchable", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object), __metadata("design:paramtypes", [Function])], NgSelectComponent.prototype, "compareWith", null);
__decorate([core_1.Output('blur'), __metadata("design:type", Object)], NgSelectComponent.prototype, "blurEvent", void 0);
__decorate([core_1.Output('focus'), __metadata("design:type", Object)], NgSelectComponent.prototype, "focusEvent", void 0);
__decorate([core_1.Output('change'), __metadata("design:type", Object)], NgSelectComponent.prototype, "changeEvent", void 0);
__decorate([core_1.Output('open'), __metadata("design:type", Object)], NgSelectComponent.prototype, "openEvent", void 0);
__decorate([core_1.Output('close'), __metadata("design:type", Object)], NgSelectComponent.prototype, "closeEvent", void 0);
__decorate([core_1.Output('search'), __metadata("design:type", Object)], NgSelectComponent.prototype, "searchEvent", void 0);
__decorate([core_1.Output('clear'), __metadata("design:type", Object)], NgSelectComponent.prototype, "clearEvent", void 0);
__decorate([core_1.Output('add'), __metadata("design:type", Object)], NgSelectComponent.prototype, "addEvent", void 0);
__decorate([core_1.Output('remove'), __metadata("design:type", Object)], NgSelectComponent.prototype, "removeEvent", void 0);
__decorate([core_1.Output('scrollToEnd'), __metadata("design:type", Object)], NgSelectComponent.prototype, "scrollToEnd", void 0);
__decorate([core_1.ContentChild(ng_templates_directive_1.NgOptionTemplateDirective, { read: core_1.TemplateRef }), __metadata("design:type", core_1.TemplateRef)], NgSelectComponent.prototype, "optionTemplate", void 0);
__decorate([core_1.ContentChild(ng_templates_directive_1.NgOptgroupTemplateDirective, { read: core_1.TemplateRef }), __metadata("design:type", core_1.TemplateRef)], NgSelectComponent.prototype, "optgroupTemplate", void 0);
__decorate([core_1.ContentChild(ng_templates_directive_1.NgLabelTemplateDirective, { read: core_1.TemplateRef }), __metadata("design:type", core_1.TemplateRef)], NgSelectComponent.prototype, "labelTemplate", void 0);
__decorate([core_1.ContentChild(ng_templates_directive_1.NgMultiLabelTemplateDirective, { read: core_1.TemplateRef }), __metadata("design:type", core_1.TemplateRef)], NgSelectComponent.prototype, "multiLabelTemplate", void 0);
__decorate([core_1.ContentChild(ng_templates_directive_1.NgHeaderTemplateDirective, { read: core_1.TemplateRef }), __metadata("design:type", core_1.TemplateRef)], NgSelectComponent.prototype, "headerTemplate", void 0);
__decorate([core_1.ContentChild(ng_templates_directive_1.NgFooterTemplateDirective, { read: core_1.TemplateRef }), __metadata("design:type", core_1.TemplateRef)], NgSelectComponent.prototype, "footerTemplate", void 0);
__decorate([core_1.ContentChild(ng_templates_directive_1.NgNotFoundTemplateDirective, { read: core_1.TemplateRef }), __metadata("design:type", core_1.TemplateRef)], NgSelectComponent.prototype, "notFoundTemplate", void 0);
__decorate([core_1.ContentChild(ng_templates_directive_1.NgTypeToSearchTemplateDirective, { read: core_1.TemplateRef }), __metadata("design:type", core_1.TemplateRef)], NgSelectComponent.prototype, "typeToSearchTemplate", void 0);
__decorate([core_1.ContentChild(ng_templates_directive_1.NgLoadingTextTemplateDirective, { read: core_1.TemplateRef }), __metadata("design:type", core_1.TemplateRef)], NgSelectComponent.prototype, "loadingTextTemplate", void 0);
__decorate([core_1.ContentChild(ng_templates_directive_1.NgTagTemplateDirective, { read: core_1.TemplateRef }), __metadata("design:type", core_1.TemplateRef)], NgSelectComponent.prototype, "tagTemplate", void 0);
__decorate([core_1.ViewChild(core_1.forwardRef(function () {
    return ng_dropdown_panel_component_1.NgDropdownPanelComponent;
})), __metadata("design:type", ng_dropdown_panel_component_1.NgDropdownPanelComponent)], NgSelectComponent.prototype, "dropdownPanel", void 0);
__decorate([core_1.ContentChildren(ng_option_component_1.NgOptionComponent, { descendants: true }), __metadata("design:type", core_1.QueryList)], NgSelectComponent.prototype, "ngOptions", void 0);
__decorate([core_1.ViewChild('filterInput'), __metadata("design:type", core_1.ElementRef)], NgSelectComponent.prototype, "filterInput", void 0);
__decorate([core_1.HostBinding('class.ng-select-opened'), __metadata("design:type", Object)], NgSelectComponent.prototype, "isOpen", void 0);
__decorate([core_1.HostBinding('class.ng-select-disabled'), __metadata("design:type", Object)], NgSelectComponent.prototype, "isDisabled", void 0);
__decorate([core_1.HostBinding('class.ng-select-filtered'), __metadata("design:type", Object), __metadata("design:paramtypes", [])], NgSelectComponent.prototype, "filtered", null);
__decorate([core_1.HostListener('keydown', ['$event']), __metadata("design:type", Function), __metadata("design:paramtypes", [KeyboardEvent]), __metadata("design:returntype", void 0)], NgSelectComponent.prototype, "handleKeyDown", null);
NgSelectComponent = NgSelectComponent_1 = __decorate([core_1.Component({
    selector: 'ng-select',
    template: __webpack_require__("./shared/libs/@ng-select/ng-select/ng-select.component.html"),
    providers: [{
        provide: forms_1.NG_VALUE_ACCESSOR,
        useExisting: core_1.forwardRef(function () {
            return NgSelectComponent_1;
        }),
        multi: true
    }],
    encapsulation: core_1.ViewEncapsulation.None,
    changeDetection: core_1.ChangeDetectionStrategy.OnPush,
    host: {
        role: 'listbox',
        class: 'ng-select',
        '[class.ng-select-single]': '!multiple'
    }
}), __param(0, core_1.Inject(exports.NG_SELECT_DEFAULT_CONFIG)), __param(1, core_1.Attribute('class')), __metadata("design:paramtypes", [Object, String, core_1.ChangeDetectorRef, console_service_1.ConsoleService, core_1.NgZone, window_service_1.WindowService, core_1.ElementRef])], NgSelectComponent);
exports.NgSelectComponent = NgSelectComponent;
var NgSelectComponent_1;

/***/ }),

/***/ "./shared/libs/@ng-select/ng-select/ng-select.module.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
                            !IMPORTANT!
    This is the copy of @ng-select/ng-select npm package.
    Version: 1.6.3.
    Link to the original library code: https://github.com/ng-select/ng-select


    Select 1.x have some issues which was resolved in later library version, but we cannot upgrade.
    Studio Ninja could only support library version 1.x. Version >= 2.x are incompatible.
    This is because we have Ionic 3.x which supports only Angular up to 5.x version.

    Here is the links for original revealed issues: https://studioninjacrm.atlassian.net/browse/SN-5512; https://studioninjacrm.atlassian.net/browse/SN-5506;
    So there were a decision made to copy library and fix the issues from the inside.
    Later if Ninja will have Ionic and Angular versions updated, this library could be removed and should be added as npm package from original source.
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var common_1 = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
var ng_select_component_1 = __webpack_require__("./shared/libs/@ng-select/ng-select/ng-select.component.ts");
var ng_templates_directive_1 = __webpack_require__("./shared/libs/@ng-select/ng-select/ng-templates.directive.ts");
var ng_option_component_1 = __webpack_require__("./shared/libs/@ng-select/ng-select/ng-option.component.ts");
var ng_option_highlight_directive_1 = __webpack_require__("./shared/libs/@ng-select/ng-select/ng-option-highlight.directive.ts");
var ng_dropdown_panel_component_1 = __webpack_require__("./shared/libs/@ng-select/ng-select/ng-dropdown-panel.component.ts");
var window_service_1 = __webpack_require__("./shared/libs/@ng-select/ng-select/window.service.ts");
var virtual_scroll_service_1 = __webpack_require__("./shared/libs/@ng-select/ng-select/virtual-scroll.service.ts");
var console_service_1 = __webpack_require__("./shared/libs/@ng-select/ng-select/console.service.ts");
// @ts-ignore
var NgSelectModule = function NgSelectModule() {
    _classCallCheck(this, NgSelectModule);
};
NgSelectModule = __decorate([core_1.NgModule({
    declarations: [ng_dropdown_panel_component_1.NgDropdownPanelComponent, ng_option_component_1.NgOptionComponent, ng_select_component_1.NgSelectComponent, ng_option_highlight_directive_1.NgOptionHighlightDirective, ng_templates_directive_1.NgOptgroupTemplateDirective, ng_templates_directive_1.NgOptionTemplateDirective, ng_templates_directive_1.NgLabelTemplateDirective, ng_templates_directive_1.NgMultiLabelTemplateDirective, ng_templates_directive_1.NgHeaderTemplateDirective, ng_templates_directive_1.NgFooterTemplateDirective, ng_templates_directive_1.NgNotFoundTemplateDirective, ng_templates_directive_1.NgTypeToSearchTemplateDirective, ng_templates_directive_1.NgLoadingTextTemplateDirective, ng_templates_directive_1.NgTagTemplateDirective],
    imports: [common_1.CommonModule],
    exports: [ng_select_component_1.NgSelectComponent, ng_option_component_1.NgOptionComponent, ng_option_highlight_directive_1.NgOptionHighlightDirective, ng_templates_directive_1.NgOptgroupTemplateDirective, ng_templates_directive_1.NgOptionTemplateDirective, ng_templates_directive_1.NgLabelTemplateDirective, ng_templates_directive_1.NgMultiLabelTemplateDirective, ng_templates_directive_1.NgHeaderTemplateDirective, ng_templates_directive_1.NgFooterTemplateDirective, ng_templates_directive_1.NgNotFoundTemplateDirective, ng_templates_directive_1.NgTypeToSearchTemplateDirective, ng_templates_directive_1.NgLoadingTextTemplateDirective, ng_templates_directive_1.NgTagTemplateDirective],
    providers: [console_service_1.ConsoleService, window_service_1.WindowService, virtual_scroll_service_1.VirtualScrollService, {
        provide: ng_select_component_1.NG_SELECT_DEFAULT_CONFIG,
        useValue: {
            notFoundText: 'No items found',
            typeToSearchText: 'Type to search',
            addTagText: 'Add item',
            loadingText: 'Loading...',
            clearAllText: 'Clear all',
            disableVirtualScroll: false
        }
    }]
})], NgSelectModule);
exports.NgSelectModule = NgSelectModule;

/***/ }),

/***/ "./shared/libs/@ng-select/ng-select/ng-select.types.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var KeyCode;
(function (KeyCode) {
    KeyCode[KeyCode["Tab"] = 9] = "Tab";
    KeyCode[KeyCode["Enter"] = 13] = "Enter";
    KeyCode[KeyCode["Esc"] = 27] = "Esc";
    KeyCode[KeyCode["Space"] = 32] = "Space";
    KeyCode[KeyCode["ArrowUp"] = 38] = "ArrowUp";
    KeyCode[KeyCode["ArrowDown"] = 40] = "ArrowDown";
    KeyCode[KeyCode["Backspace"] = 8] = "Backspace";
})(KeyCode = exports.KeyCode || (exports.KeyCode = {}));

/***/ }),

/***/ "./shared/libs/@ng-select/ng-select/ng-templates.directive.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var NgOptionTemplateDirective = function NgOptionTemplateDirective(template) {
    _classCallCheck(this, NgOptionTemplateDirective);

    this.template = template;
};
NgOptionTemplateDirective = __decorate([core_1.Directive({ selector: '[ng-option-tmp]' }), __metadata("design:paramtypes", [core_1.TemplateRef])], NgOptionTemplateDirective);
exports.NgOptionTemplateDirective = NgOptionTemplateDirective;
var NgOptgroupTemplateDirective = function NgOptgroupTemplateDirective(template) {
    _classCallCheck(this, NgOptgroupTemplateDirective);

    this.template = template;
};
NgOptgroupTemplateDirective = __decorate([core_1.Directive({ selector: '[ng-optgroup-tmp]' }), __metadata("design:paramtypes", [core_1.TemplateRef])], NgOptgroupTemplateDirective);
exports.NgOptgroupTemplateDirective = NgOptgroupTemplateDirective;
var NgLabelTemplateDirective = function NgLabelTemplateDirective(template) {
    _classCallCheck(this, NgLabelTemplateDirective);

    this.template = template;
};
NgLabelTemplateDirective = __decorate([core_1.Directive({ selector: '[ng-label-tmp]' }), __metadata("design:paramtypes", [core_1.TemplateRef])], NgLabelTemplateDirective);
exports.NgLabelTemplateDirective = NgLabelTemplateDirective;
var NgMultiLabelTemplateDirective = function NgMultiLabelTemplateDirective(template) {
    _classCallCheck(this, NgMultiLabelTemplateDirective);

    this.template = template;
};
NgMultiLabelTemplateDirective = __decorate([core_1.Directive({ selector: '[ng-multi-label-tmp]' }), __metadata("design:paramtypes", [core_1.TemplateRef])], NgMultiLabelTemplateDirective);
exports.NgMultiLabelTemplateDirective = NgMultiLabelTemplateDirective;
var NgHeaderTemplateDirective = function NgHeaderTemplateDirective(template) {
    _classCallCheck(this, NgHeaderTemplateDirective);

    this.template = template;
};
NgHeaderTemplateDirective = __decorate([core_1.Directive({ selector: '[ng-header-tmp]' }), __metadata("design:paramtypes", [core_1.TemplateRef])], NgHeaderTemplateDirective);
exports.NgHeaderTemplateDirective = NgHeaderTemplateDirective;
var NgFooterTemplateDirective = function NgFooterTemplateDirective(template) {
    _classCallCheck(this, NgFooterTemplateDirective);

    this.template = template;
};
NgFooterTemplateDirective = __decorate([core_1.Directive({ selector: '[ng-footer-tmp]' }), __metadata("design:paramtypes", [core_1.TemplateRef])], NgFooterTemplateDirective);
exports.NgFooterTemplateDirective = NgFooterTemplateDirective;
var NgNotFoundTemplateDirective = function NgNotFoundTemplateDirective(template) {
    _classCallCheck(this, NgNotFoundTemplateDirective);

    this.template = template;
};
NgNotFoundTemplateDirective = __decorate([core_1.Directive({ selector: '[ng-notfound-tmp]' }), __metadata("design:paramtypes", [core_1.TemplateRef])], NgNotFoundTemplateDirective);
exports.NgNotFoundTemplateDirective = NgNotFoundTemplateDirective;
var NgTypeToSearchTemplateDirective = function NgTypeToSearchTemplateDirective(template) {
    _classCallCheck(this, NgTypeToSearchTemplateDirective);

    this.template = template;
};
NgTypeToSearchTemplateDirective = __decorate([core_1.Directive({ selector: '[ng-typetosearch-tmp]' }), __metadata("design:paramtypes", [core_1.TemplateRef])], NgTypeToSearchTemplateDirective);
exports.NgTypeToSearchTemplateDirective = NgTypeToSearchTemplateDirective;
var NgLoadingTextTemplateDirective = function NgLoadingTextTemplateDirective(template) {
    _classCallCheck(this, NgLoadingTextTemplateDirective);

    this.template = template;
};
NgLoadingTextTemplateDirective = __decorate([core_1.Directive({ selector: '[ng-loadingtext-tmp]' }), __metadata("design:paramtypes", [core_1.TemplateRef])], NgLoadingTextTemplateDirective);
exports.NgLoadingTextTemplateDirective = NgLoadingTextTemplateDirective;
var NgTagTemplateDirective = function NgTagTemplateDirective(template) {
    _classCallCheck(this, NgTagTemplateDirective);

    this.template = template;
};
NgTagTemplateDirective = __decorate([core_1.Directive({ selector: '[ng-tag-tmp]' }), __metadata("design:paramtypes", [core_1.TemplateRef])], NgTagTemplateDirective);
exports.NgTagTemplateDirective = NgTagTemplateDirective;

/***/ }),

/***/ "./shared/libs/@ng-select/ng-select/search-helper.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var diacritics = {
    "\u24B6": 'A',
    Ａ: 'A',
    À: 'A',
    Á: 'A',
    Â: 'A',
    Ầ: 'A',
    Ấ: 'A',
    Ẫ: 'A',
    Ẩ: 'A',
    Ã: 'A',
    Ā: 'A',
    Ă: 'A',
    Ằ: 'A',
    Ắ: 'A',
    Ẵ: 'A',
    Ẳ: 'A',
    Ȧ: 'A',
    Ǡ: 'A',
    Ä: 'A',
    Ǟ: 'A',
    Ả: 'A',
    Å: 'A',
    Ǻ: 'A',
    Ǎ: 'A',
    Ȁ: 'A',
    Ȃ: 'A',
    Ạ: 'A',
    Ậ: 'A',
    Ặ: 'A',
    Ḁ: 'A',
    Ą: 'A',
    Ⱥ: 'A',
    Ɐ: 'A',
    Ꜳ: 'AA',
    Æ: 'AE',
    Ǽ: 'AE',
    Ǣ: 'AE',
    Ꜵ: 'AO',
    Ꜷ: 'AU',
    Ꜹ: 'AV',
    Ꜻ: 'AV',
    Ꜽ: 'AY',
    "\u24B7": 'B',
    Ｂ: 'B',
    Ḃ: 'B',
    Ḅ: 'B',
    Ḇ: 'B',
    Ƀ: 'B',
    Ƃ: 'B',
    Ɓ: 'B',
    "\u24B8": 'C',
    Ｃ: 'C',
    Ć: 'C',
    Ĉ: 'C',
    Ċ: 'C',
    Č: 'C',
    Ç: 'C',
    Ḉ: 'C',
    Ƈ: 'C',
    Ȼ: 'C',
    Ꜿ: 'C',
    "\u24B9": 'D',
    Ｄ: 'D',
    Ḋ: 'D',
    Ď: 'D',
    Ḍ: 'D',
    Ḑ: 'D',
    Ḓ: 'D',
    Ḏ: 'D',
    Đ: 'D',
    Ƌ: 'D',
    Ɗ: 'D',
    Ɖ: 'D',
    Ꝺ: 'D',
    Ǳ: 'DZ',
    Ǆ: 'DZ',
    ǲ: 'Dz',
    ǅ: 'Dz',
    "\u24BA": 'E',
    Ｅ: 'E',
    È: 'E',
    É: 'E',
    Ê: 'E',
    Ề: 'E',
    Ế: 'E',
    Ễ: 'E',
    Ể: 'E',
    Ẽ: 'E',
    Ē: 'E',
    Ḕ: 'E',
    Ḗ: 'E',
    Ĕ: 'E',
    Ė: 'E',
    Ë: 'E',
    Ẻ: 'E',
    Ě: 'E',
    Ȅ: 'E',
    Ȇ: 'E',
    Ẹ: 'E',
    Ệ: 'E',
    Ȩ: 'E',
    Ḝ: 'E',
    Ę: 'E',
    Ḙ: 'E',
    Ḛ: 'E',
    Ɛ: 'E',
    Ǝ: 'E',
    "\u24BB": 'F',
    Ｆ: 'F',
    Ḟ: 'F',
    Ƒ: 'F',
    Ꝼ: 'F',
    "\u24BC": 'G',
    Ｇ: 'G',
    Ǵ: 'G',
    Ĝ: 'G',
    Ḡ: 'G',
    Ğ: 'G',
    Ġ: 'G',
    Ǧ: 'G',
    Ģ: 'G',
    Ǥ: 'G',
    Ɠ: 'G',
    Ꞡ: 'G',
    Ᵹ: 'G',
    Ꝿ: 'G',
    "\u24BD": 'H',
    Ｈ: 'H',
    Ĥ: 'H',
    Ḣ: 'H',
    Ḧ: 'H',
    Ȟ: 'H',
    Ḥ: 'H',
    Ḩ: 'H',
    Ḫ: 'H',
    Ħ: 'H',
    Ⱨ: 'H',
    Ⱶ: 'H',
    Ɥ: 'H',
    "\u24BE": 'I',
    Ｉ: 'I',
    Ì: 'I',
    Í: 'I',
    Î: 'I',
    Ĩ: 'I',
    Ī: 'I',
    Ĭ: 'I',
    İ: 'I',
    Ï: 'I',
    Ḯ: 'I',
    Ỉ: 'I',
    Ǐ: 'I',
    Ȉ: 'I',
    Ȋ: 'I',
    Ị: 'I',
    Į: 'I',
    Ḭ: 'I',
    Ɨ: 'I',
    "\u24BF": 'J',
    Ｊ: 'J',
    Ĵ: 'J',
    Ɉ: 'J',
    "\u24C0": 'K',
    Ｋ: 'K',
    Ḱ: 'K',
    Ǩ: 'K',
    Ḳ: 'K',
    Ķ: 'K',
    Ḵ: 'K',
    Ƙ: 'K',
    Ⱪ: 'K',
    Ꝁ: 'K',
    Ꝃ: 'K',
    Ꝅ: 'K',
    Ꞣ: 'K',
    "\u24C1": 'L',
    Ｌ: 'L',
    Ŀ: 'L',
    Ĺ: 'L',
    Ľ: 'L',
    Ḷ: 'L',
    Ḹ: 'L',
    Ļ: 'L',
    Ḽ: 'L',
    Ḻ: 'L',
    Ł: 'L',
    Ƚ: 'L',
    Ɫ: 'L',
    Ⱡ: 'L',
    Ꝉ: 'L',
    Ꝇ: 'L',
    Ꞁ: 'L',
    Ǉ: 'LJ',
    ǈ: 'Lj',
    "\u24C2": 'M',
    Ｍ: 'M',
    Ḿ: 'M',
    Ṁ: 'M',
    Ṃ: 'M',
    Ɱ: 'M',
    Ɯ: 'M',
    "\u24C3": 'N',
    Ｎ: 'N',
    Ǹ: 'N',
    Ń: 'N',
    Ñ: 'N',
    Ṅ: 'N',
    Ň: 'N',
    Ṇ: 'N',
    Ņ: 'N',
    Ṋ: 'N',
    Ṉ: 'N',
    Ƞ: 'N',
    Ɲ: 'N',
    Ꞑ: 'N',
    Ꞥ: 'N',
    Ǌ: 'NJ',
    ǋ: 'Nj',
    "\u24C4": 'O',
    Ｏ: 'O',
    Ò: 'O',
    Ó: 'O',
    Ô: 'O',
    Ồ: 'O',
    Ố: 'O',
    Ỗ: 'O',
    Ổ: 'O',
    Õ: 'O',
    Ṍ: 'O',
    Ȭ: 'O',
    Ṏ: 'O',
    Ō: 'O',
    Ṑ: 'O',
    Ṓ: 'O',
    Ŏ: 'O',
    Ȯ: 'O',
    Ȱ: 'O',
    Ö: 'O',
    Ȫ: 'O',
    Ỏ: 'O',
    Ő: 'O',
    Ǒ: 'O',
    Ȍ: 'O',
    Ȏ: 'O',
    Ơ: 'O',
    Ờ: 'O',
    Ớ: 'O',
    Ỡ: 'O',
    Ở: 'O',
    Ợ: 'O',
    Ọ: 'O',
    Ộ: 'O',
    Ǫ: 'O',
    Ǭ: 'O',
    Ø: 'O',
    Ǿ: 'O',
    Ɔ: 'O',
    Ɵ: 'O',
    Ꝋ: 'O',
    Ꝍ: 'O',
    Ƣ: 'OI',
    Ꝏ: 'OO',
    Ȣ: 'OU',
    "\u24C5": 'P',
    Ｐ: 'P',
    Ṕ: 'P',
    Ṗ: 'P',
    Ƥ: 'P',
    Ᵽ: 'P',
    Ꝑ: 'P',
    Ꝓ: 'P',
    Ꝕ: 'P',
    "\u24C6": 'Q',
    Ｑ: 'Q',
    Ꝗ: 'Q',
    Ꝙ: 'Q',
    Ɋ: 'Q',
    "\u24C7": 'R',
    Ｒ: 'R',
    Ŕ: 'R',
    Ṙ: 'R',
    Ř: 'R',
    Ȑ: 'R',
    Ȓ: 'R',
    Ṛ: 'R',
    Ṝ: 'R',
    Ŗ: 'R',
    Ṟ: 'R',
    Ɍ: 'R',
    Ɽ: 'R',
    Ꝛ: 'R',
    Ꞧ: 'R',
    Ꞃ: 'R',
    "\u24C8": 'S',
    Ｓ: 'S',
    ẞ: 'S',
    Ś: 'S',
    Ṥ: 'S',
    Ŝ: 'S',
    Ṡ: 'S',
    Š: 'S',
    Ṧ: 'S',
    Ṣ: 'S',
    Ṩ: 'S',
    Ș: 'S',
    Ş: 'S',
    Ȿ: 'S',
    Ꞩ: 'S',
    Ꞅ: 'S',
    "\u24C9": 'T',
    Ｔ: 'T',
    Ṫ: 'T',
    Ť: 'T',
    Ṭ: 'T',
    Ț: 'T',
    Ţ: 'T',
    Ṱ: 'T',
    Ṯ: 'T',
    Ŧ: 'T',
    Ƭ: 'T',
    Ʈ: 'T',
    Ⱦ: 'T',
    Ꞇ: 'T',
    Ꜩ: 'TZ',
    "\u24CA": 'U',
    Ｕ: 'U',
    Ù: 'U',
    Ú: 'U',
    Û: 'U',
    Ũ: 'U',
    Ṹ: 'U',
    Ū: 'U',
    Ṻ: 'U',
    Ŭ: 'U',
    Ü: 'U',
    Ǜ: 'U',
    Ǘ: 'U',
    Ǖ: 'U',
    Ǚ: 'U',
    Ủ: 'U',
    Ů: 'U',
    Ű: 'U',
    Ǔ: 'U',
    Ȕ: 'U',
    Ȗ: 'U',
    Ư: 'U',
    Ừ: 'U',
    Ứ: 'U',
    Ữ: 'U',
    Ử: 'U',
    Ự: 'U',
    Ụ: 'U',
    Ṳ: 'U',
    Ų: 'U',
    Ṷ: 'U',
    Ṵ: 'U',
    Ʉ: 'U',
    "\u24CB": 'V',
    Ｖ: 'V',
    Ṽ: 'V',
    Ṿ: 'V',
    Ʋ: 'V',
    Ꝟ: 'V',
    Ʌ: 'V',
    Ꝡ: 'VY',
    "\u24CC": 'W',
    Ｗ: 'W',
    Ẁ: 'W',
    Ẃ: 'W',
    Ŵ: 'W',
    Ẇ: 'W',
    Ẅ: 'W',
    Ẉ: 'W',
    Ⱳ: 'W',
    "\u24CD": 'X',
    Ｘ: 'X',
    Ẋ: 'X',
    Ẍ: 'X',
    "\u24CE": 'Y',
    Ｙ: 'Y',
    Ỳ: 'Y',
    Ý: 'Y',
    Ŷ: 'Y',
    Ỹ: 'Y',
    Ȳ: 'Y',
    Ẏ: 'Y',
    Ÿ: 'Y',
    Ỷ: 'Y',
    Ỵ: 'Y',
    Ƴ: 'Y',
    Ɏ: 'Y',
    Ỿ: 'Y',
    "\u24CF": 'Z',
    Ｚ: 'Z',
    Ź: 'Z',
    Ẑ: 'Z',
    Ż: 'Z',
    Ž: 'Z',
    Ẓ: 'Z',
    Ẕ: 'Z',
    Ƶ: 'Z',
    Ȥ: 'Z',
    Ɀ: 'Z',
    Ⱬ: 'Z',
    Ꝣ: 'Z',
    "\u24D0": 'a',
    ａ: 'a',
    ẚ: 'a',
    à: 'a',
    á: 'a',
    â: 'a',
    ầ: 'a',
    ấ: 'a',
    ẫ: 'a',
    ẩ: 'a',
    ã: 'a',
    ā: 'a',
    ă: 'a',
    ằ: 'a',
    ắ: 'a',
    ẵ: 'a',
    ẳ: 'a',
    ȧ: 'a',
    ǡ: 'a',
    ä: 'a',
    ǟ: 'a',
    ả: 'a',
    å: 'a',
    ǻ: 'a',
    ǎ: 'a',
    ȁ: 'a',
    ȃ: 'a',
    ạ: 'a',
    ậ: 'a',
    ặ: 'a',
    ḁ: 'a',
    ą: 'a',
    ⱥ: 'a',
    ɐ: 'a',
    ꜳ: 'aa',
    æ: 'ae',
    ǽ: 'ae',
    ǣ: 'ae',
    ꜵ: 'ao',
    ꜷ: 'au',
    ꜹ: 'av',
    ꜻ: 'av',
    ꜽ: 'ay',
    "\u24D1": 'b',
    ｂ: 'b',
    ḃ: 'b',
    ḅ: 'b',
    ḇ: 'b',
    ƀ: 'b',
    ƃ: 'b',
    ɓ: 'b',
    "\u24D2": 'c',
    ｃ: 'c',
    ć: 'c',
    ĉ: 'c',
    ċ: 'c',
    č: 'c',
    ç: 'c',
    ḉ: 'c',
    ƈ: 'c',
    ȼ: 'c',
    ꜿ: 'c',
    ↄ: 'c',
    "\u24D3": 'd',
    ｄ: 'd',
    ḋ: 'd',
    ď: 'd',
    ḍ: 'd',
    ḑ: 'd',
    ḓ: 'd',
    ḏ: 'd',
    đ: 'd',
    ƌ: 'd',
    ɖ: 'd',
    ɗ: 'd',
    ꝺ: 'd',
    ǳ: 'dz',
    ǆ: 'dz',
    "\u24D4": 'e',
    ｅ: 'e',
    è: 'e',
    é: 'e',
    ê: 'e',
    ề: 'e',
    ế: 'e',
    ễ: 'e',
    ể: 'e',
    ẽ: 'e',
    ē: 'e',
    ḕ: 'e',
    ḗ: 'e',
    ĕ: 'e',
    ė: 'e',
    ë: 'e',
    ẻ: 'e',
    ě: 'e',
    ȅ: 'e',
    ȇ: 'e',
    ẹ: 'e',
    ệ: 'e',
    ȩ: 'e',
    ḝ: 'e',
    ę: 'e',
    ḙ: 'e',
    ḛ: 'e',
    ɇ: 'e',
    ɛ: 'e',
    ǝ: 'e',
    "\u24D5": 'f',
    ｆ: 'f',
    ḟ: 'f',
    ƒ: 'f',
    ꝼ: 'f',
    "\u24D6": 'g',
    ｇ: 'g',
    ǵ: 'g',
    ĝ: 'g',
    ḡ: 'g',
    ğ: 'g',
    ġ: 'g',
    ǧ: 'g',
    ģ: 'g',
    ǥ: 'g',
    ɠ: 'g',
    ꞡ: 'g',
    ᵹ: 'g',
    ꝿ: 'g',
    "\u24D7": 'h',
    ｈ: 'h',
    ĥ: 'h',
    ḣ: 'h',
    ḧ: 'h',
    ȟ: 'h',
    ḥ: 'h',
    ḩ: 'h',
    ḫ: 'h',
    ẖ: 'h',
    ħ: 'h',
    ⱨ: 'h',
    ⱶ: 'h',
    ɥ: 'h',
    ƕ: 'hv',
    "\u24D8": 'i',
    ｉ: 'i',
    ì: 'i',
    í: 'i',
    î: 'i',
    ĩ: 'i',
    ī: 'i',
    ĭ: 'i',
    ï: 'i',
    ḯ: 'i',
    ỉ: 'i',
    ǐ: 'i',
    ȉ: 'i',
    ȋ: 'i',
    ị: 'i',
    į: 'i',
    ḭ: 'i',
    ɨ: 'i',
    ı: 'i',
    "\u24D9": 'j',
    ｊ: 'j',
    ĵ: 'j',
    ǰ: 'j',
    ɉ: 'j',
    "\u24DA": 'k',
    ｋ: 'k',
    ḱ: 'k',
    ǩ: 'k',
    ḳ: 'k',
    ķ: 'k',
    ḵ: 'k',
    ƙ: 'k',
    ⱪ: 'k',
    ꝁ: 'k',
    ꝃ: 'k',
    ꝅ: 'k',
    ꞣ: 'k',
    "\u24DB": 'l',
    ｌ: 'l',
    ŀ: 'l',
    ĺ: 'l',
    ľ: 'l',
    ḷ: 'l',
    ḹ: 'l',
    ļ: 'l',
    ḽ: 'l',
    ḻ: 'l',
    ſ: 'l',
    ł: 'l',
    ƚ: 'l',
    ɫ: 'l',
    ⱡ: 'l',
    ꝉ: 'l',
    ꞁ: 'l',
    ꝇ: 'l',
    ǉ: 'lj',
    "\u24DC": 'm',
    ｍ: 'm',
    ḿ: 'm',
    ṁ: 'm',
    ṃ: 'm',
    ɱ: 'm',
    ɯ: 'm',
    "\u24DD": 'n',
    ｎ: 'n',
    ǹ: 'n',
    ń: 'n',
    ñ: 'n',
    ṅ: 'n',
    ň: 'n',
    ṇ: 'n',
    ņ: 'n',
    ṋ: 'n',
    ṉ: 'n',
    ƞ: 'n',
    ɲ: 'n',
    ŉ: 'n',
    ꞑ: 'n',
    ꞥ: 'n',
    ǌ: 'nj',
    "\u24DE": 'o',
    ｏ: 'o',
    ò: 'o',
    ó: 'o',
    ô: 'o',
    ồ: 'o',
    ố: 'o',
    ỗ: 'o',
    ổ: 'o',
    õ: 'o',
    ṍ: 'o',
    ȭ: 'o',
    ṏ: 'o',
    ō: 'o',
    ṑ: 'o',
    ṓ: 'o',
    ŏ: 'o',
    ȯ: 'o',
    ȱ: 'o',
    ö: 'o',
    ȫ: 'o',
    ỏ: 'o',
    ő: 'o',
    ǒ: 'o',
    ȍ: 'o',
    ȏ: 'o',
    ơ: 'o',
    ờ: 'o',
    ớ: 'o',
    ỡ: 'o',
    ở: 'o',
    ợ: 'o',
    ọ: 'o',
    ộ: 'o',
    ǫ: 'o',
    ǭ: 'o',
    ø: 'o',
    ǿ: 'o',
    ɔ: 'o',
    ꝋ: 'o',
    ꝍ: 'o',
    ɵ: 'o',
    ƣ: 'oi',
    ȣ: 'ou',
    ꝏ: 'oo',
    "\u24DF": 'p',
    ｐ: 'p',
    ṕ: 'p',
    ṗ: 'p',
    ƥ: 'p',
    ᵽ: 'p',
    ꝑ: 'p',
    ꝓ: 'p',
    ꝕ: 'p',
    "\u24E0": 'q',
    ｑ: 'q',
    ɋ: 'q',
    ꝗ: 'q',
    ꝙ: 'q',
    "\u24E1": 'r',
    ｒ: 'r',
    ŕ: 'r',
    ṙ: 'r',
    ř: 'r',
    ȑ: 'r',
    ȓ: 'r',
    ṛ: 'r',
    ṝ: 'r',
    ŗ: 'r',
    ṟ: 'r',
    ɍ: 'r',
    ɽ: 'r',
    ꝛ: 'r',
    ꞧ: 'r',
    ꞃ: 'r',
    "\u24E2": 's',
    ｓ: 's',
    ß: 's',
    ś: 's',
    ṥ: 's',
    ŝ: 's',
    ṡ: 's',
    š: 's',
    ṧ: 's',
    ṣ: 's',
    ṩ: 's',
    ș: 's',
    ş: 's',
    ȿ: 's',
    ꞩ: 's',
    ꞅ: 's',
    ẛ: 's',
    "\u24E3": 't',
    ｔ: 't',
    ṫ: 't',
    ẗ: 't',
    ť: 't',
    ṭ: 't',
    ț: 't',
    ţ: 't',
    ṱ: 't',
    ṯ: 't',
    ŧ: 't',
    ƭ: 't',
    ʈ: 't',
    ⱦ: 't',
    ꞇ: 't',
    ꜩ: 'tz',
    "\u24E4": 'u',
    ｕ: 'u',
    ù: 'u',
    ú: 'u',
    û: 'u',
    ũ: 'u',
    ṹ: 'u',
    ū: 'u',
    ṻ: 'u',
    ŭ: 'u',
    ü: 'u',
    ǜ: 'u',
    ǘ: 'u',
    ǖ: 'u',
    ǚ: 'u',
    ủ: 'u',
    ů: 'u',
    ű: 'u',
    ǔ: 'u',
    ȕ: 'u',
    ȗ: 'u',
    ư: 'u',
    ừ: 'u',
    ứ: 'u',
    ữ: 'u',
    ử: 'u',
    ự: 'u',
    ụ: 'u',
    ṳ: 'u',
    ų: 'u',
    ṷ: 'u',
    ṵ: 'u',
    ʉ: 'u',
    "\u24E5": 'v',
    ｖ: 'v',
    ṽ: 'v',
    ṿ: 'v',
    ʋ: 'v',
    ꝟ: 'v',
    ʌ: 'v',
    ꝡ: 'vy',
    "\u24E6": 'w',
    ｗ: 'w',
    ẁ: 'w',
    ẃ: 'w',
    ŵ: 'w',
    ẇ: 'w',
    ẅ: 'w',
    ẘ: 'w',
    ẉ: 'w',
    ⱳ: 'w',
    "\u24E7": 'x',
    ｘ: 'x',
    ẋ: 'x',
    ẍ: 'x',
    "\u24E8": 'y',
    ｙ: 'y',
    ỳ: 'y',
    ý: 'y',
    ŷ: 'y',
    ỹ: 'y',
    ȳ: 'y',
    ẏ: 'y',
    ÿ: 'y',
    ỷ: 'y',
    ẙ: 'y',
    ỵ: 'y',
    ƴ: 'y',
    ɏ: 'y',
    ỿ: 'y',
    "\u24E9": 'z',
    ｚ: 'z',
    ź: 'z',
    ẑ: 'z',
    ż: 'z',
    ž: 'z',
    ẓ: 'z',
    ẕ: 'z',
    ƶ: 'z',
    ȥ: 'z',
    ɀ: 'z',
    ⱬ: 'z',
    ꝣ: 'z',
    Ά: "\u0391",
    Έ: "\u0395",
    Ή: "\u0397",
    Ί: "\u0399",
    Ϊ: "\u0399",
    Ό: "\u039F",
    Ύ: "\u03A5",
    Ϋ: "\u03A5",
    Ώ: "\u03A9",
    ά: "\u03B1",
    έ: "\u03B5",
    ή: "\u03B7",
    ί: "\u03B9",
    ϊ: "\u03B9",
    ΐ: "\u03B9",
    ό: "\u03BF",
    ύ: "\u03C5",
    ϋ: "\u03C5",
    ΰ: "\u03C5",
    ω: "\u03C9",
    ς: "\u03C3"
};
function stripSpecialChars(text) {
    var match = function match(a) {
        return diacritics[a] || a;
    };
    return text.replace(/[^\u0000-\u007E]/g, match);
}
exports.stripSpecialChars = stripSpecialChars;

/***/ }),

/***/ "./shared/libs/@ng-select/ng-select/value-utils.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", { value: true });
function isDefined(value) {
    return value !== null && value !== undefined;
}
exports.isDefined = isDefined;
function isObject(value) {
    return isDefined(value) && (typeof value === "undefined" ? "undefined" : _typeof(value)) === 'object';
}
exports.isObject = isObject;
function isPromise(value) {
    return value instanceof Promise;
}
exports.isPromise = isPromise;
function isFunction(value) {
    return value instanceof Function;
}
exports.isFunction = isFunction;

/***/ }),

/***/ "./shared/libs/@ng-select/ng-select/virtual-scroll.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var VirtualScrollService = function () {
    function VirtualScrollService() {
        _classCallCheck(this, VirtualScrollService);
    }

    _createClass(VirtualScrollService, [{
        key: "calculateItems",
        value: function calculateItems(d, dropdownEl, bufferAmount) {
            var scrollHeight = d.childHeight * d.itemsLength;
            if (dropdownEl.scrollTop > scrollHeight) {
                dropdownEl.scrollTop = scrollHeight;
            }
            var scrollTop = Math.max(0, dropdownEl.scrollTop);
            var indexByScrollTop = scrollTop / scrollHeight * d.itemsLength;
            var end = Math.min(d.itemsLength, Math.ceil(indexByScrollTop) + (d.itemsPerCol + 1));
            var maxStartEnd = end;
            var maxStart = Math.max(0, maxStartEnd - d.itemsPerCol - 1);
            var start = Math.min(maxStart, Math.floor(indexByScrollTop));
            var topPadding = d.childHeight * Math.ceil(start) - d.childHeight * Math.min(start, bufferAmount);
            topPadding = !isNaN(topPadding) ? topPadding : 0;
            start = !isNaN(start) ? start : -1;
            end = !isNaN(end) ? end : -1;
            start -= bufferAmount;
            start = Math.max(0, start);
            end += bufferAmount;
            end = Math.min(d.itemsLength, end);
            return {
                topPadding: topPadding,
                scrollHeight: scrollHeight,
                start: start,
                end: end
            };
        }
    }, {
        key: "calculateDimensions",
        value: function calculateDimensions(itemsLength, index, panelEl, contentEl) {
            var panelRect = panelEl.getBoundingClientRect();
            var itemRect = contentEl.children[index] ? contentEl.children[index].getBoundingClientRect() : {
                width: panelRect.width,
                height: panelRect.height,
                top: 0
            };
            var itemsPerCol = Math.max(1, Math.floor(panelRect.height / itemRect.height));
            return {
                itemsLength: itemsLength,
                viewWidth: panelRect.width,
                viewHeight: panelRect.height,
                childWidth: itemRect.width,
                childHeight: itemRect.height,
                itemsPerCol: itemsPerCol
            };
        }
    }]);

    return VirtualScrollService;
}();
VirtualScrollService = __decorate([core_1.Injectable()], VirtualScrollService);
exports.VirtualScrollService = VirtualScrollService;

/***/ }),

/***/ "./shared/libs/@ng-select/ng-select/window.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var WindowService = function () {
    function WindowService() {
        _classCallCheck(this, WindowService);
    }

    _createClass(WindowService, [{
        key: "requestAnimationFrame",
        value: function requestAnimationFrame(fn) {
            return window.requestAnimationFrame(fn);
        }
    }, {
        key: "setTimeout",
        value: function setTimeout(handler, timeout) {
            return window.setTimeout(handler, timeout);
        }
    }]);

    return WindowService;
}();
WindowService = __decorate([core_1.Injectable()], WindowService);
exports.WindowService = WindowService;

/***/ }),

/***/ "./shared/models/appConstants.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });

var AppConstants = function AppConstants() {
    _classCallCheck(this, AppConstants);
};

AppConstants.isBrowser = typeof window.cordova === 'undefined';
AppConstants.apiServer =  false ? webpackGlobalVars.server : '';
AppConstants.APP_HOST_SERVER = AppConstants.isBrowser ? '' : AppConstants.apiServer;
AppConstants.IS_PROD_BUILD =  false ? webpackGlobalVars.env === 'production' : false;
AppConstants.IS_TEST_BUILD =  false ? webpackGlobalVars.env === 'testing' : false;
AppConstants.HOST =  false ? webpackGlobalVars.server : '';
AppConstants.WEB_BUILD_VERSION = window['_web_build_version'];
AppConstants.APP_ID = {
    ANDROID: 'co.studioninja.app',
    IOS: 'id1339777482'
};
exports.AppConstants = AppConstants;

/***/ }),

/***/ "./shared/models/brands.model.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var forms_1 = __webpack_require__("./node_modules/@angular/forms/esm5/forms.js");
var validation_service_1 = __webpack_require__("./shared/services/helpers/validation.service.ts");
exports.BRAND_EDIT_FORM = [{
    name: 'Company Name',
    type: 'text',
    placeholder: 'Enter your business name e.g. Peter Phong Photography',
    formControlName: 'name',
    validators: [forms_1.Validators.required, validation_service_1.ValidationProvider.noWhitespaceValidator]
}, {
    name: 'Business Number',
    type: 'text',
    placeholder: 'Enter your ABN, Rn or CRN',
    formControlName: 'number',
    validators: []
}, {
    name: 'Street Address',
    type: 'text',
    placeholder: 'Enter your street address',
    formControlName: 'address',
    validators: []
}, {
    name: 'City/Suburb',
    type: 'text',
    placeholder: 'Enter your city or suburb',
    formControlName: 'city',
    validators: []
}, {
    name: 'State/County',
    type: 'text',
    placeholder: 'Enter your state or county',
    formControlName: 'state',
    validators: []
}, {
    name: 'Postcode/Zip',
    type: 'text',
    placeholder: 'Enter your postcode or zip code',
    formControlName: 'postcode',
    validators: []
}, {
    name: 'Country',
    type: 'text',
    placeholder: 'Enter your country',
    formControlName: 'country',
    validators: []
}, {
    name: 'Phone Number',
    type: 'text',
    placeholder: 'Enter your contact number e.g. +61 432 567 890',
    formControlName: 'phone',
    validators: []
}, {
    name: 'Company Email',
    type: 'email',
    placeholder: 'Enter your email e.g. info@peterphong.com',
    formControlName: 'email',
    validators: [forms_1.Validators.required, validation_service_1.ValidationProvider.emailValidator, validation_service_1.ValidationProvider.noWhitespaceValidator]
}];

/***/ }),

/***/ "./shared/models/messages.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });

var Messages = function Messages() {
    _classCallCheck(this, Messages);
};

Messages.general = {
    s: {
        0: {
            title: 'Success',
            text: '{value}',
            value: 'message from backend'
        },
        1: {
            title: 'Nice!',
            text: 'The client has given opt-in consent.'
        }
    },
    e: {
        0: {
            title: 'Whoops, something has gone wrong!',
            text: 'Please contact customer support.'
        },
        1: {
            title: 'Whoops!',
            text: 'Please enter a valid email address.'
        },
        2: {
            title: 'Whoops, something has gone wrong!',
            text: '{value}',
            value: 'error from backend'
        },
        3: {
            title: 'Houston, we have a problem!',
            text: 'Only add letters into the {value} field, no spaces or strange symbols allowed.',
            value: "Field's name"
        }
    },
    i: {
        0: {
            title: 'Please wait',
            text: 'It may take a few minutes'
        },
        1: {
            title: '',
            text: '{value}',
            value: 'info from backend'
        }
    },
    w: {
        0: {
            title: "D'oh!",
            text: 'Please choose a date.'
        }
    }
};
Messages.consent = {
    s: {
        0: {
            title: 'Alrighty!',
            text: 'Consent has been successfully removed.'
        }
    },
    e: {
        0: {
            title: "Something's missing here!",
            text: 'Please complete the consent.'
        },
        1: {
            title: 'No-go!',
            text: "This consent doesn't exist anymore. Please refresh your page."
        },
        2: {
            title: 'No-go!',
            text: 'This consent is linked to a signed contract.'
        },
        3: {
            title: "Something's missing here!",
            text: 'You can not add empty consent.'
        }
    }
};
Messages.extrashoot = {
    s: {
        0: {
            title: 'Ready, aim, FIRE!',
            text: 'Your {value} has been deleted.',
            value: 'extrashoot label - extrashoot name'
        },
        1: {
            title: 'Boom!',
            text: 'Your {value} has been saved.',
            value: 'extrashoot label'
        },
        2: {
            title: 'Snap!',
            text: 'Your {value} details have been updated.',
            value: 'extrashoot label'
        }
    },
    e: {
        0: {
            title: "It doesn't exist!",
            text: 'Please choose an active lead or job for this {value}.',
            value: 'extrashoot label'
        }
    },
    i: {},
    w: {}
};
Messages.appointment = {
    s: {
        0: {
            title: 'Locked and loaded!',
            text: 'Your appointment {value} has been created.',
            value: 'appointment name'
        },
        1: {
            title: 'Locked and loaded!',
            text: 'Your appointment {value} has been updated.',
            value: 'appointment name'
        },
        2: {
            title: 'Ready, aim, FIRE!',
            text: 'Your appointment {value} has been deleted.',
            value: 'appointment name'
        }
    },
    e: {
        0: {
            title: "What's going on here!",
            text: "Please enter a start and end time or tick 'all day' if this is an all day job."
        },
        1: {
            title: 'Jetlagged!',
            text: 'Please enter a start and end date.'
        },
        2: {
            title: 'Jetlagged!',
            text: 'The start time must be before the end date.'
        },
        3: {
            title: "It doesn't exist!",
            text: 'Please choose an active lead or job for this appointment.'
        },
        4: {
            title: 'Whoops!',
            text: 'Please choose a client for the appointment reminder.'
        }
    },
    i: {},
    w: {}
};
Messages.job = {
    s: {
        0: {
            title: 'Mission accomplished!',
            text: 'A new job has been created.'
        },
        1: {
            title: 'Mission accomplished!',
            text: 'Your job details have been updated.'
        }
    },
    e: {
        0: {
            title: 'Jetlagged!',
            text: 'The start date must be before the end date.'
        },
        1: {
            title: 'Measure twice, cut once!',
            text: 'Please select or create a primary contact for this job.'
        },
        3: {
            title: "What's going on here!",
            text: "Please enter a start and end time or tick 'all day' if this is an all day job."
        },
        4: {
            title: 'Jetlagged!',
            text: 'The start time must be before the end date.'
        },
        5: {
            title: 'Oops!',
            text: 'The secondary client needs to be different from the primary client.'
        },
        6: {
            title: 'No-go!',
            text: "This job doesn't exist anymore."
        }
    },
    i: {},
    w: {}
};
Messages.productsPackages = {
    s: {
        0: {
            title: "Now we're in business!",
            text: 'Your package {value} has been created.',
            value: 'product/package name'
        },
        1: {
            title: 'Dynamite!',
            text: 'Your package {value} has been deleted.',
            value: 'product/package name'
        },
        2: {
            title: 'Double down!',
            text: 'Your package {value} was successfully duplicated.',
            value: 'product/package name'
        },
        3: {
            title: 'Double down!',
            text: 'Your package {value} was successfully updated.',
            value: 'product/package name'
        },
        4: {
            title: "Now we're in business!",
            text: 'Your product {value} has been created.',
            value: 'product/package name'
        },
        5: {
            title: 'Dynamite!',
            text: 'Your product {value} has been deleted.',
            value: 'product/package name'
        },
        6: {
            title: 'Double down!',
            text: 'Your product {value} was successfully duplicated.',
            value: 'product/package name'
        },
        7: {
            title: 'Double down!',
            text: 'Your product {value} was successfully updated.',
            value: 'product/package name'
        },
        8: {
            title: 'Absolutely!',
            text: 'Your default introduction text for new Quotes have been updated.'
        },
        9: {
            title: 'Nice one Sensei!',
            text: 'Your product {value} has successfully converted into a package.',
            value: 'product/package name'
        },
        10: {
            title: 'Nice one Sensei!',
            text: 'Your package {value} has successfully converted into a product.',
            value: 'product/package name'
        },
        11: {
            title: 'Dynamite!',
            text: 'Your discount {value} has been deleted.',
            value: 'product/package name'
        },
        12: {
            title: "Now we're in business!",
            text: 'Your discount {value} has been created.',
            value: 'product/package name'
        },
        13: {
            title: 'Double down!',
            text: 'Your discount {value} was successfully updated.',
            value: 'product/package name'
        },
        14: {
            title: 'Double down!',
            text: 'Your discount {value} was successfully duplicated.',
            value: 'product/package name'
        }
    },
    e: {
        0: {
            title: 'Information needed Sensei!',
            text: 'Please enter a {value} name.',
            value: 'product or package'
        },
        1: {
            title: 'You can do better than that!',
            text: 'Please complete all fields before saving.'
        },
        2: {
            title: 'Information needed Sensei!',
            text: 'Please enter a {value} price.',
            value: 'product or package'
        },
        3: {
            title: 'Information needed Sensei!',
            text: 'Please enter a {value} description.',
            value: 'product or package'
        },
        4: {
            title: 'Houston, we have a problem!',
            text: 'Only use letters in the default introduction text filed, no spaces or strange symbols allowed.'
        },
        5: {
            title: "Something's not adding up here!",
            text: 'Please make sure {value} value is greater than $0.',
            value: 'product or package'
        },
        6: {
            title: "I've hit my limit!",
            text: 'Please use {value} or less characters in the description field.',
            value: '4000'
        }
    },
    i: {},
    w: {}
};
Messages.googleCalendar = {
    s: {
        0: {
            title: 'Yes!',
            text: 'Your appointment reminder has been saved.'
        },
        1: {
            title: 'Looks like we have a bit of chemistry!',
            text: 'Google Calendar sync complete.'
        },
        2: {
            title: 'Locked and loaded!',
            text: 'Your Google Calendar has successfully been disconnected'
        }
    },
    e: {},
    i: {
        0: {
            title: 'Hold your horses!',
            text: 'Please be patient while we integrate with Google Calendar.'
        }
    },
    w: {}
};
Messages.calendar = {
    s: {
        0: {
            title: 'Tic toc tick!',
            text: 'You have successfully saved your Calendar preferences.'
        }
    },
    e: {},
    i: {},
    w: {}
};
Messages.paymentMethods = {
    s: {
        0: {
            title: 'Accepted!',
            text: 'Your PayPal credentials have been successfully saved.'
        },
        1: {
            title: 'Accepted!',
            text: 'Your Stripe credentials have been successfully saved'
        },
        2: {
            title: 'Happy days!',
            text: 'Your payment methods have been saved.'
        },
        4: {
            title: 'Congratulations!',
            text: 'Your PayPal payment was successful.'
        },
        5: {
            title: 'Congratulations!',
            text: 'Your Stripe payment was successful.'
        }
    },
    e: {
        0: {
            title: 'Almost there!',
            text: 'Please complete instructions for Transfer payment method.'
        },
        1: {
            title: 'Almost there!',
            text: 'Please complete all fields for Other payment method.'
        },
        2: {
            title: "We've hit a road block!",
            text: 'Your Stripe details are not correct. Please double check them and try again.'
        },
        3: {
            title: 'No-go!',
            text: 'Please complete all PayPal fields.'
        },
        4: {
            title: 'No-go!',
            text: 'Please complete all Stripe fields.'
        },
        5: {
            title: "We've hit a road block!",
            text: 'Your PayPal details are not correct. Please double check them and try again.'
        },
        6: {
            title: 'Almost there!',
            text: 'Please complete all fields for {value} method.',
            value: ''
        }
    },
    i: {},
    w: {}
};
Messages.clients = {
    s: {
        0: {
            title: 'Adios amigos!',
            text: 'Your client has been deleted.'
        },
        1: {
            title: 'Mission accomplished!',
            text: 'Your client has been updated.'
        },
        2: {
            title: 'Mission accomplished!',
            text: 'A new client has been created.'
        },
        3: {
            title: 'Scribble, scribble!',
            text: 'Your client notes have been saved.'
        },
        4: {
            title: 'To infinity and beyond!',
            text: 'Your email was sent.'
        }
    },
    e: {
        0: {},
        1: {
            title: 'Give it another go!',
            text: "Please complete the client's name and email address."
        },
        2: {},
        3: {},
        4: {
            title: 'Round 2!',
            text: "Please complete the client's first name."
        },
        5: {
            title: "That's strange!",
            text: 'You have entered too many characters in these fields'
        },
        6: {
            title: "You can't handle the truth!",
            text: 'The email address is already assigned to another client.'
        },
        7: {
            title: 'Sorry!',
            text: 'Job specific variables cannot be used here. For Job specific variables to work, please send this email from within the Job that this client is assigned to. '
        },
        8: {
            title: 'Sorry!',
            text: 'A client with the email {value} already exists in the system. Please enter a different email address.',
            value: 'client email'
        },
        9: {
            title: 'No-go!',
            text: "This client doesn't exist anymore."
        }
    },
    i: {},
    w: {}
};
Messages.csvFiles = {
    s: {
        0: {
            title: 'Cowabunga!',
            text: 'New clients have been successfully imported.'
        }
    },
    e: {
        0: {
            title: 'Double trouble!',
            text: 'You cannot import clients that already exist in the system.'
        },
        1: {
            title: "I don't think so!",
            text: "You're trying to upload the wrong file format. Please choose a CSV file."
        },
        2: {
            title: 'Please double check!',
            text: 'You cannot upload an empty CSV file.'
        },
        3: {
            title: 'Oops!',
            text: "Please add a 'First Name' to every contact in your CSV file. This is a mandatory field."
        },
        4: {
            title: 'Oops!',
            text: 'Please add an email address to every contact in your CSV file. This is a mandatory field.'
        },
        5: {
            title: 'Double trouble!',
            text: 'There are multiple contacts with the same email address in your CSV file. Please make sure each contact has a unique email address.'
        },
        6: {
            title: 'Double trouble!',
            text: 'Contacts in your CSV file already exist in Studio Ninja. Please remove them from your CSV file and try again.'
        },
        7: {
            title: "That's not a Studio Ninja CSV file!",
            text: 'Please make sure you download and use the Studio Ninja CSV file. CSV files exported from other software will not work.'
        },
        8: {
            title: "Don't mess with our file!",
            text: 'Please do not delete or rearrange the spreadsheet columns.'
        },
        9: {
            title: 'Double trouble!',
            text: 'Please upload one CSV file at a time.'
        }
    },
    i: {},
    w: {}
};
Messages.paymentSchedules = {
    s: {
        0: {
            title: 'Affirmative!',
            text: 'Your payment schedule {value} was created.',
            value: 'schedule name'
        },
        1: {
            title: 'Leave it to us!',
            text: 'Your invoice reminder has been updated.'
        },
        2: {
            title: 'See ya!',
            text: 'The payment schedule {value} has been deleted.',
            value: 'schedule name'
        },
        3: {
            title: 'Yipee!',
            text: 'Your payment schedule {value} has been updated.',
            value: 'schedule name'
        },
        4: {
            title: 'Leave it to us!',
            text: 'Your payment receipts have been updated.'
        },
        5: {
            title: 'To infinity and beyond!',
            text: 'Your Invoice ID format has been updated.'
        }
    },
    e: {
        0: {
            title: "You're trying to save an Invoice Reminder email template without an invoice link!",
            text: "Please add the variable 'Invoice Link' to this email template before saving."
        },
        1: {
            title: "That's not going to add up!",
            text: 'You cannot add a percentage of more than 100%.'
        },
        2: {
            title: "You've forgotten something!",
            text: 'Add a number into the days field so we know when to send out your payment reminders.'
        },
        3: {
            title: 'Something is not adding up here!',
            text: 'You cannot create a payment for $0. Payments must be $1 or more. '
        },
        4: {
            title: "Something's missing!",
            text: 'Please enter one or more letters.'
        },
        5: {
            title: 'You shall not pass!',
            text: 'Please enter only letters, numbers or symbols such as dash, underscore or slash.'
        }
    },
    i: {},
    w: {}
};
Messages.companyUsers = {
    s: {
        0: {
            title: 'Sorted!',
            text: 'The user {value} has been updated.',
            value: 'user email'
        },
        1: {
            title: "It's time to part ways!",
            text: 'Your company user {value} has been deleted.',
            value: 'user email'
        }
    },
    e: {
        0: {
            title: "Something's missing here!",
            text: 'Please complete the first name.'
        },
        1: {
            title: 'Things are looking a little empty in here!',
            text: 'Please complete the name and email address.'
        },
        2: {
            title: 'Try again!',
            text: 'Please complete the email address.'
        },
        3: {
            title: 'Think again!',
            text: 'That email address is invalid.'
        },
        4: {
            title: 'Whoops!',
            text: 'The user {value} is already registered in Studio Ninja',
            value: 'user email'
        },
        5: {
            title: 'Hmmm!',
            text: 'Unfortunately you cannot delete yourself.'
        },
        6: {
            title: "Something's missing here!",
            text: 'Please complete the business name.'
        }
    },
    i: {
        0: {
            title: 'You had me at hello!',
            text: 'An invitation has been sent to {value}.',
            value: 'user email'
        }
    },
    w: {}
};
Messages.workflow = {
    s: {
        0: {
            title: "And that's how it's done!",
            text: 'Your workflow {value} has been updated.',
            value: 'workflow name'
        },
        1: {
            title: 'Success!',
            text: 'Your workflow {value} has been created.',
            value: 'workflow name'
        },
        2: {
            title: 'So long, sucker!',
            text: 'The workflow {value} has been deleted.',
            value: 'workflow name'
        },
        3: {
            title: 'Boom!',
            text: 'You have successfully added a new workflow task.'
        },
        4: {
            title: 'Success sensei!',
            text: 'You have successfully edited your workflow task.'
        },
        5: {
            title: 'Adios amigo!',
            text: 'Your workflow task has been deleted.'
        }
    },
    e: {
        0: {
            title: 'Information needed Sensei!',
            text: 'Please enter a workflow name.'
        },
        1: {
            title: 'Taskmaster alert!',
            text: 'Please enter a task name.'
        },
        2: {
            title: "Don't rush!",
            text: '0 Days is not an option. Please choose 1 or more days.'
        },
        3: {
            title: 'You seem to have forgotten something!',
            text: 'Please choose an option before saving.'
        },
        4: {
            title: 'You seem to have forgotten something!',
            text: 'Please choose an existing email template or create a new one before saving this task.'
        },
        5: {
            title: "You've forgotten something!",
            text: 'Please add a subject to this email before saving.'
        },
        6: {
            title: 'Hold your horses!',
            text: 'You cannot delete a Workflow that is linked to a Job Type. Please un-link this Workflow and then try again.'
        },
        7: {
            title: 'Looks like you are trying to upload an empty file',
            text: 'Please, reload the file'
        }
    },
    i: {
        0: {
            title: 'Hold your horses!',
            text: 'Please save your workflow template first and navigate to another page before switching to a different company.'
        }
    },
    w: {}
};
Messages.emailTemplate = {
    s: {
        0: {
            title: 'Boom!',
            text: 'The email template {value} has been deleted.',
            value: 'template name'
        },
        1: {
            title: 'See ya!',
            text: 'email template {value} has been deleted.',
            value: 'template name'
        },
        2: {
            title: 'Snap!',
            text: 'Your email settings have been saved.'
        },
        3: {
            title: 'Whoopee!',
            text: 'Your email template {value} has been updated.',
            value: 'template name'
        },
        4: {
            title: 'Woohoo!',
            text: 'Your email template {value} has been created.',
            value: 'template name'
        },
        5: {
            title: 'Woohoo!',
            text: 'Your email notification settings have been successfully saved.'
        }
    },
    e: {
        0: {
            title: "You're trying to save an Invoice email template without an invoice link!",
            text: "Please add the variable 'Invoice Link' to this email template before saving."
        },
        1: {
            title: "You're trying to save the Quote email template without a quote link!",
            text: "Please add the variable 'Quote Link' to this email template before saving."
        },
        2: {
            title: "You're trying to save the Contract email template without a contract link!",
            text: "Please add the variable 'Contract Link' to this email template before sending."
        },
        3: {
            title: "You're trying to save the Questionnaire email template without a questionnaire link!",
            text: "Please add the variable 'Questionnaire Link' to this email template before saving."
        },
        4: {
            title: "You're trying to save the Receipt of payment email template without a invoice link!",
            text: "Please add the variable 'Invoice Link' to this email template before saving."
        },
        5: {
            title: "Something's missing!",
            text: 'Your email template is missing a contract link. Please add a contract link before saving this workflow task.'
        },
        6: {
            title: "Something's missing!",
            text: 'Your email template is missing a questionnaire link. Please add a questionnaire link before saving this workflow task.'
        },
        7: {
            title: 'No can do, Sensei!',
            text: 'This email template is linked to an active workflow task and cannot be deleted. Please delete the workflow task first.'
        },
        8: {
            title: 'Double trouble!',
            text: 'Please use a different name as that one already exists.'
        },
        9: {
            title: "You've forgotten something!",
            text: 'Please add a {value} to this email template before saving.',
            value: 'field'
        },
        10: {
            title: "Something's not adding up here!",
            text: 'Please add a valid subject line to your email.'
        }
    },
    i: {},
    w: {}
};
Messages.emailSettings = {
    s: {
        0: {
            title: 'Woohoo!',
            text: 'Your Gmail account was successfully disconnected.'
        },
        1: {
            title: 'Woohoo!',
            text: 'Your SMTP server was successfully disconnected.'
        },
        2: {
            title: 'You have mail!',
            text: 'Your {value} settings have been successfully saved.',
            value: 'email server type'
        },
        3: {
            title: 'Bingo!',
            text: 'Your email address has been saved.'
        },
        4: {
            title: 'Image saved!',
            text: 'Image was successfully saved.'
        }
    },
    e: {
        0: {
            title: 'You forgot something!',
            text: "Please add your 'Reply to' email address."
        },
        1: {
            title: 'You forgot something!',
            text: "Please add your 'Sender name'."
        },
        2: {
            title: 'Houston we have a problem!',
            text: 'Please check your SMTP settings and try again.'
        },
        3: {
            title: 'Oops!',
            text: 'You forgot to input your {value}.',
            value: 'input field'
        },
        4: {
            title: 'Oops!',
            text: 'The port number you entered is incorrect.'
        },
        5: {
            title: 'Whoops!',
            text: 'You cannot connect to Gmail because another user is connected to that Gmail account.'
        },
        6: {
            title: 'Too short!',
            text: 'Please enter at least 5 characters.'
        },
        7: {
            title: "Don't be a space cadet!",
            text: 'Please remove any spaces.'
        },
        8: {
            title: 'Computer says no!',
            text: 'Please enter only letters, numbers, period, underscore or dash.'
        },
        9: {
            title: 'Too long!',
            text: 'Please enter a maximum of 64 characters.'
        }
    },
    i: {
        0: {
            title: 'Chill out for a minute!',
            text: "We're just confirming your SMTP settings."
        },
        1: {
            title: 'Get ready to rumble!',
            text: 'Email address has been copied to clipboard.'
        }
    },
    w: {}
};
Messages.email = {
    s: {
        0: {
            title: 'Bravo!',
            text: 'Your mail box sync is complete.'
        }
    },
    e: {
        0: {
            title: 'Whoops!',
            text: 'You cannot copy / paste images into the email message. Please attach the image instead.'
        },
        1: {
            title: 'Whoops!',
            text: "You cannot drag 'n' drop images into the email message. Please attach the image instead."
        },
        2: {
            title: "Something's missing!",
            text: 'Please write a subject for your email.'
        },
        3: {
            title: "Something's missing!",
            text: 'Please enter an email address before sending.'
        },
        4: {
            title: 'Double trouble!',
            text: 'Please remove the duplicate email address {value}.',
            value: ''
        },
        5: {
            title: 'Superfluous!',
            text: 'Your subject has exceeded 255 characters. Please shorten it and try again.'
        },
        6: {
            title: 'Drat!',
            text: 'Seems like {value} is not valid. Please enter a valid email address and try again.',
            value: 'some email address'
        }
    }
};
Messages.contractTemplates = {
    s: {
        0: {
            title: 'Goodbye!',
            text: 'The contract {value} has been deleted.',
            value: 'contract name'
        },
        1: {
            title: 'Woohoo!',
            text: 'The contract template {value} was successfully created.',
            value: 'contract name'
        },
        2: {
            title: 'Woohoo!',
            text: 'The contract {value} has been updated.',
            value: 'contract template name'
        }
    },
    e: {},
    i: {},
    w: {}
};
Messages.jobTypes = {
    s: {
        0: {
            title: 'Bulls-eye!',
            text: 'The job type {value} has been deleted.',
            value: 'type name'
        },
        1: {
            title: 'You deserve a promotion!',
            text: 'Your job type {value} has been updated.',
            value: 'type name'
        },
        2: {
            title: "It's time to conquer!",
            text: 'Your job type {value} has been created.',
            value: 'type name'
        }
    },
    e: {
        0: {
            title: 'Error',
            text: 'Fill type name!',
            old: 'true'
        },
        1: {
            title: 'Hold your horses!',
            text: 'Please choose a Job Type colour before saving.'
        },
        2: {
            title: 'Hold your horses!',
            text: 'Please add a Job Type name before saving.'
        },
        3: {
            title: 'No can do, Sensei!',
            text: 'You cannot delete the default Job Type. Set another Job Type to Default before deleting this one.'
        }
    },
    i: {},
    w: {}
};
Messages.questionnaires = {
    s: {
        0: {
            title: 'Cheerio!',
            text: 'The questionnaire {value} has been deleted.',
            value: 'questionnaire name'
        },
        1: {
            title: 'Slam dunk!',
            text: 'Your questionnaire {value} has been updated.',
            value: 'questionnaire name'
        },
        2: {
            title: "That's brilliant!",
            text: 'Your questionnaire {value} has been created.',
            value: 'questionnaire name'
        }
    },
    e: {
        0: {
            title: "You're trying to send a Questionnaire without a questionnaire link! ",
            text: "Please add the variable 'Questionnaire Link' to this email before sending."
        },
        1: {
            title: 'Whoops!',
            text: 'The template name is too long to duplicate. Please rename and try again.'
        },
        2: {
            title: 'Go straight to the source!',
            text: 'Please delete the workflow task that sent this questionnaire first before trying again.'
        }
    },
    i: {},
    w: {}
};
Messages.companyInformation = {
    s: {
        0: {
            title: 'Hooray!',
            text: 'Your company information has been updated.'
        },
        1: {
            title: 'Be gone!',
            text: 'Your company has been successfully deleted.'
        },
        2: {
            title: 'Yes to more privacy!',
            text: 'GDPR features, such as Consent checkboxes, have been enabled.'
        },
        3: {
            title: 'As you wish!',
            text: 'GDPR features have been disabled.'
        },
        4: {
            title: 'A great brand is a promise kept!',
            text: 'Your logo has been successfully updated.'
        },
        5: {
            title: 'Brand yourself before others do!',
            text: 'Your logo has been removed.'
        },
        6: {
            title: 'A great brand is an experience!',
            text: 'Your Client Portal banner has been successfully updated.'
        },
        7: {
            title: 'Brand yourself before others do!',
            text: 'Your Client Portal banner has been removed.'
        },
        8: {
            title: 'Brand yourself before others do!',
            text: 'Your Client Portal banner has been removed.'
        },
        9: {
            title: 'Top of the world!',
            text: 'Your client portal languages have been updated.'
        }
    },
    e: {
        0: {
            title: "That's the wrong file format!",
            text: 'Please upload a JPG or PNG file.'
        },
        1: {
            title: 'That file is too BIG!',
            text: 'Please upload a file smaller than {value}mb.',
            value: ''
        },
        2: {
            title: 'That file is too BIG!',
            text: 'Please upload a file smaller than {value}mb.',
            value: ''
        },
        3: {
            title: 'Someone got in before you!',
            text: 'The company name you are trying to save is already in use. Please use a different name.'
        },
        4: {
            title: 'Baby steps!',
            text: 'Please upload one file at a time.'
        },
        5: {
            title: 'I have no words!',
            text: 'Please choose at least one language.'
        }
    },
    i: {},
    w: {
        0: {
            title: 'Please wait!',
            text: 'Your company information update is still in progress.'
        }
    }
};
Messages.currencyAndTaxes = {
    s: {
        0: {
            title: 'Victory!',
            text: 'Your currency & taxes have been updated.'
        }
    },
    e: {},
    i: {},
    w: {}
};
Messages.jobView = {
    s: {
        0: {
            title: 'Adios!',
            text: 'Your job has been deleted.'
        },
        1: {
            title: 'Hasta la vista!',
            text: 'Your invoice has been deleted.'
        },
        // 2: {
        //    "title": "Pow!",
        //    "text": "Your contract has been deleted."
        // },
        3: {
            title: 'Scribble, scribble!',
            text: 'Your job notes have been saved.'
        },
        4: {
            title: 'To infinity and beyond!',
            text: 'Your contract was sent.'
        },
        // 5: {
        //    "title": "To infinity and beyond!",
        //    "text": "Your invoice was sent."
        // },
        6: {
            title: 'To infinity and beyond!',
            text: 'Your quote has been sent.'
        },
        // 7: {
        //    "title": "Toodle-oo!",
        //    "text": "Your questionnaire has been deleted."
        // },
        8: {
            title: 'Mission accomplished!',
            text: 'A new job has been created.'
        },
        9: {
            title: 'To identify and beyond!',
            text: 'Your questionnaire was sent.'
        }
    },
    e: {},
    i: {
        0: {
            title: 'Nice work!',
            text: 'Your workflow task has been updated.'
        }
    },
    w: {
        0: {
            title: 'Oops!',
            text: 'Please choose a contract template from the dropdown menu.'
        },
        1: {
            title: 'Oops!',
            text: 'Please choose a questionnaire template from the dropdown menu.'
        },
        2: {
            title: 'Patience, my friend!',
            text: 'You cannot create a new quote while another quote is pending.'
        }
    }
};
Messages.contract = {
    s: {
        0: {
            title: 'Pow!',
            text: 'Your contract has been deleted.'
        }
    },
    e: {
        0: {
            title: "You're trying to send a Contract without a contract link! ",
            text: "Please add the variable 'Contract Link' to this email before sending."
        },
        1: {
            title: 'No can do, Sensei!',
            text: 'This contract is linked to an active workflow task and cannot be deleted. Please delete the workflow task first.'
        },
        2: {
            title: 'No-go!',
            text: "This contract doesn't exist anymore."
        }
    },
    i: {},
    w: {}
};
Messages.questions = {
    s: {
        0: {
            title: 'Toodle-oo!',
            text: 'Your questionnaire has been deleted.'
        },
        1: {
            title: 'Gone baby gone!',
            text: 'Your questionnaire has been successfully removed.'
        }
    },
    e: {
        0: {
            title: 'Go straight to the source!',
            text: 'Please delete the workflow task that sent this questionnaire first before trying again.'
        },
        1: {
            title: 'No-go!',
            text: "This questionnaire doesn't exist anymore."
        }
    },
    i: {},
    w: {}
};
Messages.login = {
    s: {
        0: {
            title: "You've got mail!",
            text: 'Please check your email for confirmation link.'
        },
        1: {
            title: 'Welcome, rockstar!',
            text: 'You can now login and get started.'
        }
    },
    e: {
        0: {
            title: 'Houston, we have a problem!',
            text: 'Incorrect email or password.'
        },
        1: {
            title: 'Something is not adding up here!',
            text: 'The email address you entered does not appear to be registered in the system.'
        },
        2: {
            title: 'It looks like that email address has already been registered!',
            text: 'Please choose a different email address and try again.'
        },
        3: {
            title: 'It looks like that company name has already been registered!',
            text: 'Please choose a different company name and try aqain.'
        },
        4: {
            title: 'Houston, we have a problem!',
            text: 'Only use letters in the sign up form, no spaces or strange symbols allowed.'
        },
        5: {
            title: 'Oops! ',
            text: 'It seems like that activation link has already been used.'
        },
        6: {
            title: 'Slow down!',
            text: 'Please make sure your passwords match.'
        }
    },
    i: {},
    w: {
        0: {
            title: 'Even an apprentice could crack that code!',
            text: 'Your password must be at least 6 characters long.'
        }
    }
};
Messages.forgotPassword = {
    s: {
        0: {
            title: "You've got mail!",
            text: 'Please check your email for password reset link.'
        }
    },
    e: {
        0: {
            title: 'Slow down!',
            text: 'Please make sure your passwords match.'
        },
        1: {
            title: 'Even an apprentice could crack that code!',
            text: 'Your password must be at least 6 characters long.'
        },
        2: {
            title: 'Error',
            text: 'Forgot password link already used!'
        }
    },
    i: {},
    w: {}
};
Messages.refer = {
    s: {
        0: {
            title: 'Victory!',
            text: 'Your Refer a Friend invitation to {value} has been successfully sent.',
            value: "friend's email"
        }
    },
    e: {},
    i: {},
    w: {}
};
Messages.unsubscribe = {
    s: {
        0: {
            title: 'Successfully unsubscribed!',
            text: 'You have been removed from this mailing list.'
        }
    },
    e: {
        0: {
            title: 'Oops!',
            text: 'You have already unsubscribed from this mailing list.'
        },
        1: {
            title: 'Sorry!',
            text: 'You cannot unsubscribe from this mailing list becaue this email does not belong to you.'
        },
        2: {
            title: "We're losing you!",
            text: 'Unable to unsubscribe because the internet connection was lost. '
        },
        3: {
            title: 'We can handle the truth!',
            text: 'Tell us in at least {value} characters why you are leaving so we can learn and improve.',
            value: '20'
        }
    },
    i: {},
    w: {}
};
Messages.payments = {
    s: {
        0: {
            title: 'Maybe next time!',
            text: 'The invoice payment has been successfully reversed.'
        },
        1: {
            title: 'Show me the money!',
            text: 'Your invoice has been saved.'
        },
        2: {
            title: 'Show me the money!',
            text: 'Your quote has been saved.'
        },
        3: {
            title: 'Strike!',
            text: 'Your invoice has been marked as unpaid.'
        },
        4: {
            title: 'Cha-ching!',
            text: 'Your invoice has been saved.'
        },
        5: {
            title: 'Hasta la vista!',
            text: 'Your quote has been deleted.'
        },
        6: {
            title: 'Maybe next time!',
            text: 'Your invoice has been written off.'
        },
        7: {
            title: 'Money, money, moneyyy!',
            text: 'Your invoice has been paid.'
        },
        8: {
            title: 'Hasta la vista!',
            text: 'Your invoice has been deleted.'
        },
        9: {
            title: 'To infinity and beyond!',
            text: 'Your invoice has been sent.'
        },
        10: {
            title: 'To infinity and beyond!',
            text: 'Your quote has been sent.'
        },
        11: {
            title: 'To infinity and beyond!',
            text: 'Your receipt has been sent.'
        }
    },
    e: {
        0: {
            title: "You're good, but not that good!",
            text: 'You cannot delete an invoice that is attached to an accepted quote. Please delete the quote first.'
        },
        3: {
            title: 'Look again!',
            text: 'Please put a number in the quantity field.'
        },
        4: {
            title: 'That discount is not going to work young apprentice!',
            text: 'Please make sure all product/package tax options are identical otherwise the fixed discount will not work. Alternatively, you can use a percentage discount.'
        },
        5: {
            title: "Something's not adding up here!",
            text: 'You cannot decrease the total of this invoice to a smaller amount.'
        },
        6: {
            title: 'Look again!',
            text: 'You cannot save a product for $0. Please add a value in the price field.'
        },
        7: {
            title: 'Bad date, mate!',
            text: 'Please re-enter your dates.'
        },
        8: {
            title: 'Can`t go back in time!',
            text: 'Please fix your date range.'
        },
        9: {
            title: 'Feeling kinda empty!',
            text: 'Please select at least one column.'
        },
        10: {
            title: 'Feeling kinda empty!',
            text: 'Please select at least one file format.'
        }
    },
    i: {},
    w: {}
};
Messages.editQuote = {
    s: {
        0: {
            title: 'Voila!',
            text: 'An invoice has been created from your quote.'
        },
        1: {
            title: 'Ka-ching!',
            text: 'Your quote has been accepted.'
        }
    },
    e: {
        0: {
            title: 'D’oh!',
            text: 'This quote does not exist.'
        },
        1: {
            title: 'Generous, much!',
            text: 'The discount exceeds the quote total.'
        },
        2: {
            title: "Something's not adding up here!",
            text: "You're trying to give a discount more than 100% of the order."
        },
        3: {
            title: "You're trying to send a Quote without a quote link!",
            text: "Please add the variable 'Quote Link' to this email before sending."
        },
        4: {
            title: 'Jeez!',
            text: 'Please add at least one package or product.'
        },
        5: {
            title: "Something's not adding up here!",
            text: 'The total value of your quote cannot be negative. Please add more fees.'
        },
        6: {
            title: "Something's not adding up here!",
            text: 'The negative product must be mandatory.'
        },
        7: {
            title: 'Houston, we have a problem!',
            text: 'Use only Latin letters, numbers and special characters in PO Number field, no spaces or strange symbols allowed.'
        },
        8: {
            title: "Something's not adding up here!",
            text: 'Your product cannot have a quantity of 0. Please enter a quantity.'
        },
        9: {
            title: 'We need more info before saving!',
            text: 'Please add a {value} description.',
            value: 'product type'
        },
        10: {
            title: "Something's not adding up here!",
            text: 'The negative product must have a quantity of 1.'
        },
        11: {
            title: "Something's not adding up here!",
            text: 'Please enter a payment due date.'
        },
        12: {
            title: 'We need more info before saving!',
            text: 'Please add a product/package description.'
        },
        13: {
            title: 'That discount is not going to work young apprentice!',
            text: 'Please make sure all product/package tax options are identical otherwise the fixed discount will not work. Alternatively, you can use a percentage discount.'
        },
        14: {
            title: 'Houston, we have a problem!',
            text: 'Only add letters into the {value} Name field, no spaces or strange symbols allowed.',
            value: 'product type'
        },
        15: {
            title: 'Double trouble!',
            text: 'This quote ID already exists. Please enter another one.'
        },
        16: {
            title: "Something's not adding up here!",
            text: 'Gift must have positive price.'
        },
        17: {
            title: 'Aye yai yai!',
            text: 'The total amount cannot be negative. Please update the price.'
        },
        18: {
            title: "Don't hurry up!",
            text: 'Select payment schedule option.'
        },
        19: {
            title: 'No-go!',
            text: "This quote doesn't exist anymore."
        }
    },
    i: {},
    w: {
        0: {
            title: 'We need more info before saving!',
            text: 'Please add a product/package description.'
        },
        1: {
            title: 'Elementary, my dear Watson!',
            text: 'You cannot create an quote for $0.'
        }
    }
};
Messages.editInvoice = {
    s: {},
    e: {
        0: {
            title: 'D’oh!',
            text: 'This invoice does not exist.'
        },
        1: {
            title: 'Generous, much!',
            text: 'The discount exceeds the invoice total.'
        },
        2: {
            title: "Something's not adding up here!",
            text: "You're trying to give a discount more than 100% of the order."
        },
        3: {
            title: "You're trying to send an Invoice without an invoice link!",
            text: "Please add the variable 'Invoice Link' to this email before sending."
        },
        4: {
            title: "Something's not adding up here!",
            text: 'You cannot change the total of this invoice to a smaller amount than has already been paid. '
        },
        5: {
            title: 'Your invoice has gone missing in action!',
            text: 'It looks like this invoice has been deleted and no longer exists.'
        },
        6: {
            title: "Something's not adding up here!",
            text: 'Please make sure each payment in the payment schedule has a value greater than $0.'
        },
        7: {
            title: "You're trying to send a Receipt without an invoice link!",
            text: "Please add the variable 'Invoice Link' to this email before sending."
        },
        8: {
            title: "Something's not adding up here!",
            text: 'That Invoice ID has already been used. Please choose a different Invoice ID.'
        },
        9: {
            title: "You're forgetting something!",
            text: 'Please make sure all payments have a due date.'
        },
        10: {
            title: 'Hold your horses!',
            text: 'This payment has already been recorded automatically because a credit card payment has been made. Please refresh this page.'
        },
        11: {
            title: 'Houston, we have a Xero problem!',
            text: 'This invoice cannot be saved because you have reached your invoice limit in Xero. Please upgrade your Xero account or UN-integrate from Xero to save this invoice.'
        },
        12: {
            title: 'We need more info before saving!',
            text: 'Please add a product/package description.'
        },
        13: {
            title: 'Double trouble!',
            text: 'This invoice ID already exists. Please enter another one.'
        },
        14: {
            title: "Something's not adding up here!",
            text: 'Please refresh the page so that the sync is complete.'
        },
        17: {
            title: 'Aye yai yai!',
            text: 'The total amount cannot be negative. Please update the price.'
        },
        18: {
            title: "Something's missing!",
            text: 'Please assign a payment schedule first before saving.'
        },
        19: {
            title: 'No-go!',
            text: "This invoice doesn't exist anymore."
        }
    },
    i: {},
    w: {
        0: {
            title: 'We need more info before saving!',
            text: 'Please add a product/package description.'
        },
        1: {
            title: 'Elementary, my dear Watson!',
            text: 'You cannot create an invoice for $0.'
        },
        2: {
            title: 'We need more info before saving!',
            text: 'Please add a product/package.'
        }
    }
};
Messages.forgot = {
    s: {},
    e: {
        0: {
            title: 'Sorry!',
            text: 'The email address you entered does not appear to be registered in the system'
        }
    },
    i: {},
    w: {}
};
Messages.subscription = {
    s: {
        0: {
            title: 'Woohoo!',
            text: 'You have successfully subscribed to the {value}.',
            value: 'plan'
        }
    },
    e: {
        0: {
            title: 'Sorry!',
            text: 'Your credit card number seems to be invalid.'
        },
        1: {
            title: 'Sorry!',
            text: 'The CVV number seems to be invalid.'
        },
        2: {
            title: 'Sorry!',
            text: "You've entered an invalid expiry date."
        }
    },
    i: {
        0: {
            title: 'Woohoo!',
            text: 'You have successfully subscribed to the {value} plan.',
            value: 'plan'
        },
        1: {
            title: 'Success',
            text: 'Credit card details have been updated'
        }
    },
    w: {}
};
Messages.profile = {
    s: {
        0: {
            title: 'Ding!',
            text: 'Your password settings have been saved. Please check your email.'
        },
        1: {
            title: "That's how it's done!",
            text: 'Your details have been updated.'
        },
        2: {
            title: "You've got mail!",
            text: 'Please check your email and confirm your new email address to save these settings.'
        },
        3: {
            title: "You're ready to go!",
            text: 'Your profile image is now updated.'
        }
    },
    e: {
        0: {
            title: 'Slow down!',
            text: 'Please make sure your passwords match.'
        },
        1: {
            title: 'Even an apprentice could crack that code!',
            text: 'Your password must be at least 6 characters long.'
        },
        2: {
            title: 'Sorry!',
            text: 'That email already exists.'
        },
        3: {
            title: 'Sorry!',
            text: "That email doesn't exist."
        }
    },
    i: {
        0: {
            title: 'Is that a trick!',
            text: 'Your name has not changed.'
        },
        1: {
            title: 'Think twice!',
            text: 'The name field is empty.'
        },
        2: {
            title: "It's a trick!",
            text: 'Your email has not changed'
        }
    },
    w: {}
};
Messages.customizeLabels = {
    s: {
        0: {
            title: 'We have new names!',
            text: 'Labels have been updated successfully.'
        }
    },
    e: {
        0: {
            title: "You've forgotten something!",
            text: 'Please fill all labels.'
        },
        1: {
            title: 'Make it shorter!',
            text: 'Please remove any space in the label for "Shoots"'
        }
    }
};
Messages.contactForm = {
    s: {
        0: {
            title: "You've earned your black belt!",
            text: 'Your contact form has been saved.'
        },
        1: {
            title: 'Success!',
            text: 'Your enquiry has been submitted.'
        }
    },
    e: {
        0: {
            title: 'Sorry!',
            text: 'Please complete all the fields and then click Submit.'
        },
        1: {
            title: "We're losing you!",
            text: 'Your contact form has not been saved because the internet connection was lost.'
        }
    },
    i: {
        0: {
            title: 'Get ready to rumble!',
            text: 'The URL code has been copied to clipboard.'
        },
        1: {
            title: 'Get ready to rumble!',
            text: 'The embed code has been copied to clipboard.'
        }
    },
    w: {}
};
Messages.changeLogin = {
    s: {
        0: {
            title: 'Woohoo!',
            text: 'Your email address has been successfully updated.'
        }
    },
    e: {
        0: {
            title: 'Damn!',
            text: 'The link to update your email address has already been used.'
        }
    },
    i: {},
    w: {}
};
Messages.stripe = {
    s: {
        0: {
            title: 'Congratulations!',
            text: 'Your credit card payment was successful.'
        }
    },
    e: {
        0: {
            title: "Oops, your payment hasn't processed!",
            text: 'Please contact your photographer.'
        },
        1: {
            title: 'Whoops!',
            text: "You've entered an invalid security code. Please try again."
        },
        2: {
            title: 'Uh-oh!',
            text: 'Your CVV code was incorrect.'
        },
        3: {
            title: 'Oops!',
            text: 'Attempts to charge your card failed.'
        },
        4: {
            title: 'That’s not going to work!',
            text: 'Your card was declined.'
        },
        5: {
            title: 'Ouch!',
            text: 'Your card has insufficient funds.'
        },
        6: {
            title: 'Dear dear!',
            text: 'Your card has expired.'
        },
        7: {
            title: 'Yikes!',
            text: 'Something’s gone wrong while processing your card. Try again later!'
        },
        8: {
            title: 'Whoops!',
            text: 'We could not process your payment. Please try again later or contact your bank.'
        }
    },
    i: {
        0: {
            title: 'Hold your horses!!',
            text: 'Your details are being processed and more verification is required for added security.'
        }
    },
    w: {}
};
Messages.picTime = {
    s: {
        0: {
            title: 'Let the good times roll!',
            text: 'You have successfully connected to Pic-Time.'
        },
        1: {
            title: "Time's up!",
            text: 'You have disconnected from Pic-Time.'
        },
        2: {
            title: 'Let the good times roll!',
            text: 'This is now linked to an existing Pic-Time gallery.'
        },
        3: {
            title: 'Let the good times roll!',
            text: 'You have created a new gallery in Pic-Time.'
        },
        4: {
            title: 'Be gone!',
            text: 'You have deleted a Pic-Time gallery.'
        },
        5: {
            title: 'Let the good times roll!',
            text: 'You have successfully saved your Pic-Time settings.'
        },
        6: {
            title: 'Let the good times roll!',
            text: 'Your order has been successfully imported.'
        },
        7: {
            title: 'Refreshed!',
            text: 'Galleries are up to date.'
        },
        8: {
            title: 'Refreshed!',
            text: 'Orders available for import are up to date.'
        }
    },
    e: {
        0: {
            title: 'Not so fast!',
            text: 'Please enter a name for your Pic-Time gallery.'
        },
        1: {
            title: 'Not so fast!',
            text: 'Please enter a URL for your Pic-Time gallery.'
        },
        2: {
            title: 'Not so fast!',
            text: 'Please enter your Pic-Time domain name or URL.'
        },
        3: {
            title: 'Unrecognisable!',
            text: 'Please use only letters, numbers or underscore for the URL.'
        },
        4: {
            title: 'Pic-time',
            text: 'The limit for import 10 galleries!'
        },
        5: {
            title: 'Unrecognisable!',
            text: 'Please enter your Pic-Time domain name or URL.'
        },
        6: {
            title: 'Not so fast!',
            text: 'Please select an existing gallery from the dropdown and try again.'
        },
        7: {
            title: 'Hang on!',
            text: 'Please select a brand first.'
        },
        8: {
            title: 'Not so fast!',
            text: 'Please enter a shoot date for your new gallery.'
        }
    },
    i: {
        0: {
            title: 'Hold your horses!',
            text: 'Please wait while we redirect you to Pic-Time.'
        }
    },
    w: {}
};
Messages.shootProof = {
    s: {
        0: {
            title: 'From ShootProof to hero!',
            text: 'Your ShootProof account is now connected.'
        },
        1: {
            title: "That's Shoot-tastic!",
            text: 'You have created a new gallery in ShootProof.'
        },
        2: {
            title: 'From ShootProof to hero!',
            text: 'You have successfully disconnected your account from ShootProof.'
        },
        3: {
            title: "That's Shoot-tastic!",
            text: 'This is now linked to an existing ShootProof gallery.'
        },
        4: {
            title: 'Woohoo, fire away!',
            text: 'You have successfully saved your ShootProof settings.'
        },
        5: {
            title: 'Be gone!',
            text: 'You have deleted a ShootProof gallery.'
        },
        6: {
            title: 'Woohoo, fire away!',
            text: 'You have successfully integrated to ShootProof.'
        },
        7: {
            title: "That's Shoot-tastic!",
            text: 'Your order has been successfully imported.'
        },
        8: {
            title: "That's Shoot-tastic!",
            text: 'You have successfully saved your ShootProof settings.'
        },
        9: {
            title: "That's Shoot-tastic!",
            text: 'You have successfully connected to ShootProof.'
        },
        10: {
            title: 'Affirmative!',
            text: 'You have disconnected from ShootProof.'
        }
    },
    i: {
        0: {
            title: 'Almost there!',
            text: 'Please save your settings to complete the integration.'
        }
    },
    e: {
        0: {
            title: "Stop! Don't Shoot...Proof!",
            text: 'You are no longer integrated with ShootProof. Please integrate again.'
        },
        1: {
            title: "Stop! Don't Shoot...Proof!",
            text: 'Unfortunately you cannot create a new gallery with invalid contact information.'
        },
        2: {
            title: 'Oh Shoot!',
            text: 'Please select an existing gallery from the dropdown and try again.'
        }
    }
};
Messages.lead = {
    s: {
        0: {
            title: 'Mission accomplished!',
            text: 'Your lead has now become a job.'
        },
        1: {
            title: 'Mission accomplished!',
            text: 'Your job has now become a lead.'
        },
        2: {
            title: 'Be gone!',
            text: 'Your lead was successfully deleted.'
        },
        3: {
            title: 'Mission accomplished!',
            text: 'Your lead details have been updated.'
        },
        4: {
            title: 'Mission accomplished!',
            text: 'A new lead has been created.'
        },
        5: {
            title: 'File away!',
            text: 'Your lead has been archived.'
        },
        6: {
            title: 'Shake off the dust!',
            text: 'Your lead has been unarchived'
        }
    },
    e: {
        0: {
            title: 'Measure twice, cut once!',
            text: 'Please select or create a primary contact for this lead.'
        },
        1: {
            title: "You're forgotten something!",
            text: "Please add a name for this lead, for example Jenny & Matt's Wedding."
        },
        2: {
            title: "You've doubled up!",
            text: 'The secondary client needs to be different from the primary client.'
        },
        3: {
            title: 'Your timing is off!',
            text: "Please enter a start and end time or tick 'all day' if this is an all day event."
        },
        4: {
            title: 'Oopsy!',
            text: 'Delete your invoices before you can archive this lead.'
        },
        5: {
            title: 'Computer says no!',
            text: 'Unarchive this lead before you can edit it.'
        },
        6: {
            title: 'Computer says no!',
            text: 'Unarchive this lead before you can delete it.'
        },
        7: {
            title: 'No-go!',
            text: "This lead doesn't exist anymore."
        }
    },
    i: {},
    w: {}
};
Messages.qb = {
    s: {
        0: {
            title: 'Woohoo, that was quick!',
            text: 'This invoice has been successfully copied to Quickbooks.'
        },
        1: {
            title: 'Woohoo, that was quick!',
            text: 'You have successfully disconnected your Quickbooks integration.'
        },
        2: {
            title: 'Woohoo, that was quick!',
            text: 'You have successfully integrated with Quickbooks.'
        }
    },
    e: {
        0: {
            title: 'Slow down, Quickbooks error!',
            text: 'As you are integrated with Quickbooks, please make sure each product/package has the same tax type assigned before saving.'
        },
        1: {
            title: 'Slow down, Quickbooks error!',
            text: 'The invoice ID {value} has already been used in Quickbooks. Please change the invoice ID before saving this invoice.',
            value: 'invoice id'
        },
        2: {
            title: "Something's not adding up here!",
            text: 'Your Quickbooks account does not have any Payment Accounts. Please setup a Payment Account and try again.'
        },
        3: {
            title: 'Slow down, Quickbooks error!',
            text: 'Quickbooks does not allow invoices to have the tax type "Includes Tax". Please change the tax type to "Excludes Tax" and try again.'
        },
        4: {
            title: 'Slow down, Quickbooks error!',
            text: 'This account has been disconnected from Quickbooks. Please go to Settings > Integrations and connect to Quickbooks again.'
        },
        5: {
            title: 'Slow down, Quickbooks error!',
            text: 'Your account is already connected with another accounting platform. Please disconnect and try again.'
        },
        6: {
            title: 'Slow down, Quickbooks error!',
            text: 'A client with the same first name and last name already exists. Please change the name to continue.'
        },
        7: {
            title: 'Slow down, Quickbooks error!',
            text: 'Quickbooks does not allow invoice payments to be written off.'
        },
        8: {
            title: 'Slow down, Quickbooks error!',
            text: 'Quickbooks is not supported in France at the time.'
        },
        9: {
            title: 'Slow down, Quickbooks error!',
            text: 'Your tax rate is set to 0% in Quickbooks. Please make sure the same tax rate is set in Studio Ninja.'
        },
        10: {
            title: 'Slow down, Quickbooks error!',
            text: 'Quickbooks does not support the characters used in this invoice.'
        },
        11: {
            title: 'Slow down, Quickbooks error!',
            text: 'The client attached to this invoice has been marked as inactive in Quickbooks. Please reactivate the client in Quickbooks before making changes to this invoice.'
        },
        12: {
            title: 'Slow down, Quickbooks error!',
            text: 'This payment has already been voided or deleted in Quickbooks. Undo this in Quickbooks and try again.'
        },
        14: {
            title: 'Slow down, Quickbooks error!',
            text: 'This payment has a credit note attached to it in Quickbooks. Studio Ninja does not support this feature. Please remove the credit note first before recording this payment.'
        },
        15: {
            title: 'Slow down, Quickbooks error!',
            text: 'Your Invoice ID has too many characters. '
        },
        16: {
            title: 'Slow down, Quickbooks error!',
            text: 'While integrated with Quickbooks you cannot Write Off payments. This feature is not supported by Quickbooks.'
        },
        17: {
            title: 'Slow down, Quickbooks error!',
            text: 'You cannot copy this invoice to Quickbooks because you have deleted it in Quickbooks.'
        },
        18: {
            title: 'Slow down, Quickbooks error!',
            text: 'You cannot save this invoice because the clients email address is invalid.'
        },
        19: {
            title: 'Slow down, Quickbooks error!',
            text: 'Quickbooks requires that all invoices include tax. Please update your products/packages tax rate and try again.'
        },
        20: {
            title: 'Slow down, Quickbooks error!',
            text: 'The client attached to this job has been marked as inactive in Quickbooks. Please reactivate the client in Quickbooks before creating the invoice.'
        },
        21: {
            title: 'Slow down, Quickbooks error!',
            text: 'QuickBooks company should have at least one Tax Code with sales tax rates'
        },
        22: {
            title: 'Slow down, Quickbooks error!',
            text: 'QuickBooks does not support fixed discounts. Please choose a percentage discount before continuing.'
        },
        23: {
            title: 'Slow down, Quickbooks error!',
            text: 'This client has been marked as inactive in Quickbooks. Please reactivate the client in Quickbooks.'
        },
        24: {
            title: 'Slow down, Quickbooks error!',
            text: 'This invoice cannot be saved because the same product/package name already exists as a category in QuickBooks. Please use a different product/package name to continue.'
        },
        25: {
            title: 'Slow down, Quickbooks error!',
            text: 'This invoice cannot be saved because the same product/package name already exists as a Inventory or Bundle in QuickBooks. Please use a different product/package name to continue.'
        },
        26: {
            title: 'Slow down, Quickbooks error!',
            text: 'Your Product / Package name has too many characters.'
        },
        27: {
            title: 'Slow down, Quickbooks error!',
            text: 'Your invoice ID has too many characters.'
        },
        28: {
            title: 'Slow down, Quickbooks error!',
            text: 'Your Description has too many characters.'
        }
    },
    i: {
        0: {
            title: 'The countdown begins, 10, 9, 8...!',
            text: 'Please wait while we connect your account to Quickbooks.'
        }
    },
    w: {
        0: {
            title: 'Slow down, Quickbooks warning!',
            text: 'Your Description has too many characters.'
        }
    }
};
Messages.xero = {
    s: {
        0: {
            title: 'From Xero to hero!',
            text: 'Your Xero account is now connected.'
        },
        1: {
            title: 'From Xero to hero!',
            text: 'This invoice has been successfully copied to Xero.'
        },
        2: {
            title: 'From Xero to hero!',
            text: 'You have successfully disconnected your account from Xero.'
        }
    },
    i: {
        0: {
            title: 'Hold your horses! It may take a minute.',
            text: "We're loading your Xero integration settings."
        }
    },
    e: {
        0: {
            title: 'Houston, we have a Xero problem!',
            text: 'This payment has already been recorded in Xero. Please remove the payment from Xero first before recording the payment in Studio Ninja.'
        },
        1: {
            title: 'Houston, we have a Xero problem!',
            text: 'Invoices with a fixed discount are not compatible with Xero. Please make sure you apply a percentage discount before saving.'
        },
        2: {
            title: 'Xero no go!',
            text: "Something went wrong while syncing this invoice to Xero. Please click on the 'Copy to Xero' button to try again."
        },
        3: {
            title: 'Houston, we have a Xero problem!',
            text: 'This invoice cannot be copied to Xero because it has been voided in Xero. Please un-void the invoice in Xero to continue.'
        },
        4: {
            title: 'Houston, we have a Xero problem!',
            text: 'Invoices with multiple tax type are not compatible with Xero. Please make sure all the tax types are the same before saving.'
        },
        5: {
            title: 'Houston, we have a Xero problem!',
            text: 'This invoice cannot be copied to Xero because it has already been partially or fully paid in Xero.'
        },
        6: {
            title: 'Houston, we have a Xero problem!',
            text: 'The invoice ID {value} already exists in Xero. Please choose a different invoice ID before saving.',
            value: 'invoice id'
        },
        7: {
            title: 'Houston, we have a Xero problem!',
            text: 'Invoices with written off payments are not compatible with Xero.'
        },
        8: {
            title: 'Houston, we have a Xero problem!',
            text: '$0 payments are not compatible with Xero.'
        },
        9: {
            title: 'Houston, we have a Xero problem!',
            text: 'You cannot record a payment to this invoice because this invoice has been voided in Xero.'
        },
        10: {
            title: 'Houston, we have a Xero problem!',
            text: 'The contact details for this job cannot be modified because there are linked invoices with Xero for this job with the current client details.'
        },
        11: {
            title: 'Houston, we have a Xero problem!',
            text: 'This payment cannot be marked as unpaid because it was overpaid in Xero. Please remove the payment in Xero first to continue.'
        },
        12: {
            title: 'Houston, we have a Xero problem!',
            text: 'Please remove the overpaid amount in Xero before deleting this {value}.',
            value: 'deletedItem'
        },
        13: {
            title: 'Slow down, Xero error!',
            text: 'Your account is already connected with another accounting platform. Please disconnect and try again. '
        },
        14: {
            title: 'Bummer!',
            text: 'Your Xero access token has been revoked. Please reconnect Xero.'
        },
        15: {
            title: 'Bummer!',
            text: "You don't have an active Xero subscription."
        },
        16: {
            title: 'Houston, we have a Xero problem!',
            text: 'The contact details for this job cannot be modified because there are linked invoices with Xero for this job with the current client details.'
        },
        17: {
            title: 'Houston, we have a Xero problem!',
            text: 'The contact details for this lead cannot be modified because there are linked invoices with Xero for this lead with the current client details.'
        },
        18: {
            title: 'Xero no go!',
            text: 'Please choose a Default Revenue Account before saving.'
        },
        19: {
            title: 'Xero no go!',
            text: 'Please choose a Default Payment Account before saving.'
        },
        20: {
            title: 'Xero says no!',
            text: 'Please select a Payment account with a valid account code.'
        },
        21: {
            title: 'Xero says no!',
            text: 'Please select a Revenue account with a valid account code.'
        }
    },
    w: {}
};
Messages.promoCodes = {
    s: {},
    e: {
        0: {
            title: 'Eek!',
            text: 'This promo code has expired.'
        },
        1: {
            title: 'Sorry!',
            text: 'That is not a valid promo code.'
        },
        2: {
            title: "I think you're forgetting something!",
            text: 'Please enter a promo code.'
        }
    },
    i: {
        0: {
            title: 'Copy that!',
            text: 'The text has been successfully copied. Now go share it with the world.'
        }
    },
    w: {}
};
Messages.attachments = {
    s: {
        0: {
            title: 'Success!',
            text: 'The file was downloaded to {value}.'
        },
        1: {
            title: 'I see you baby!',
            text: 'File has been successfully uploaded.'
        },
        2: {
            title: 'Bye bye bye!',
            text: 'File has been deleted.'
        }
    },
    e: {
        0: {
            title: 'Sorry!',
            text: 'The promo code you entered is either invalid or expired.'
        },
        1: {
            title: "You're running out of space!",
            text: 'You can only upload a total of 50mb per job.'
        },
        2: {
            title: 'Already gone!',
            text: 'This file does not exist.'
        },
        3: {
            title: 'Impossible!',
            text: 'Uploaded file has no data.'
        },
        4: {
            title: 'That file is too BIG!',
            text: 'Please upload a file smaller than 20mb.'
        }
    },
    i: {},
    w: {
        0: {
            title: "You're running out of space!",
            text: 'You cannot attach more than 10mb of file(s).'
        }
    }
};
Messages.generalValidation = {
    s: {},
    e: {
        0: {
            title: 'Mayday mayday!',
            text: 'Please enter a valid web address or email address.'
        },
        1: {
            title: 'Sorry!',
            text: 'The email could not be delivered to {value} because it is invalid. Please update this clients email address and try again.',
            value: 'email'
        },
        2: {
            title: 'Mayday mayday!',
            text: "You've forgotten to add a reminder message. Please add a message before saving."
        },
        3: {
            title: 'Mayday mayday!',
            text: "You've forgotten to add days variable. Please add the number of days  before saving."
        },
        4: {
            title: 'Hold your horses!',
            text: 'You have exceeded your limit of sending {value} emails per day. Please contact support or wait until tomorrow to continue sending emails.',
            value: 'limit'
        }
    },
    i: {},
    w: {}
};
Messages.subscribed = {
    s: {
        0: {
            title: 'Hooray!',
            text: 'The client is now subscribed to receive emails.'
        },
        1: {
            title: 'Roger that!',
            text: 'The client has been unsubscribed.'
        }
    }
};
Messages.fundy = {
    s: {
        0: {
            title: 'Yowza!',
            text: 'Fundy invoicing features have been enabled.'
        },
        1: {
            title: "Don't get funky!",
            text: 'Fundy invoicing features have been disabled.'
        },
        2: {
            title: 'Zing!',
            text: 'Your invoice has been imported from Fundy.'
        }
    },
    e: {
        0: {
            title: 'Not happy, Fundy!',
            text: 'Your invoice must contain at least one order.'
        },
        1: {
            title: 'Not happy, Fundy!',
            text: 'Your invoice subtotal must match the line items.'
        },
        2: {
            title: 'Not happy, Fundy!',
            text: 'Your uploaded file must not have a credit value.'
        },
        3: {
            title: 'Not happy, Fundy!',
            text: 'Your invoice tax rate must match your tax settings.'
        },
        4: {
            title: 'Not happy, Fundy!',
            text: 'Your uploaded file must contain a client order.'
        },
        5: {
            title: 'Not happy, Fundy!',
            text: 'Your uploaded file must be in xml file format.'
        },
        6: {
            title: 'Not happy, Fundy!',
            text: 'Your uploaded file must be under 5 mb.'
        },
        7: {
            title: 'Not happy, Fundy!',
            text: 'Your uploaded file must have a valid quantity parameter.'
        },
        8: {
            title: 'Not happy, Fundy!',
            text: 'Your uploaded file must have a valid price parameter.'
        },
        9: {
            title: 'Not happy, Fundy!',
            text: 'Your uploaded file must have a valid discount parameter.'
        },
        10: {
            title: 'Not happy, Fundy!',
            text: 'Discount must be less than subtotal.'
        },
        11: {
            title: 'Not happy, Fundy!',
            text: '{value}',
            value: 'message from backend'
        },
        12: {
            title: 'Not happy, Fundy!',
            text: "You can't upload an empty Xml file."
        }
    }
};
Messages.proSelect = {
    s: {
        0: {
            title: 'More power to you!',
            text: 'ProSelect invoicing features have been enabled.'
        },
        1: {
            title: 'No problem!',
            text: 'ProSelect invoicing features have been disabled.'
        },
        2: {
            title: 'Perfect!',
            text: 'Your invoice has been successfully imported from ProSelect.'
        }
    },
    e: {
        5: {
            title: 'Incorrect, ProSelect!',
            text: 'Your uploaded file must be in xml file format.'
        },
        6: {
            title: 'Incorrect, ProSelect!',
            text: 'Your uploaded file must be under 5 mb.'
        },
        12: {
            title: 'Incorrect, ProSelect!',
            text: 'Your uploaded file is empty. Please check that it has data and try uploading again.'
        }
    }
};
Messages.quoteCP = {
    e: {
        0: {
            title: 'Oops!',
            text: 'For your chosen products, please enter a quantity of more than 0.'
        },
        1: {
            title: 'Sorry!',
            text: 'Please enter a reason for declining the quote.'
        },
        2: {
            title: 'Oops!',
            text: 'Please select a package or product first.'
        }
    }
};
Messages.twoFa = {
    s: {
        0: {
            title: 'Double happiness!',
            text: 'Two-factor authentication has been set up.'
        },
        1: {
            title: 'If you say so!',
            text: 'Two-factor authentication has been disabled.'
        },
        2: {
            title: 'Yessir!',
            text: 'Two-factor authentication is now mandatory for other users.'
        },
        3: {
            title: 'As you please!',
            text: 'Two-factor authentication is now optional for other users.'
        },
        4: {
            title: 'Authenticated!',
            text: 'Your login has been successfully verified.'
        },
        5: {
            title: 'Authentication successfully reset!',
            text: 'You got at least two answers correct.'
        },
        6: {
            title: 'Be gone!',
            text: 'Two-factor authentication was successfully reset for user {value}.',
            value: ''
        }
    },
    i: {
        0: {
            title: 'Get ready to rumble!',
            text: 'The code has been copied to clipboard.'
        }
    },
    e: {
        0: {
            title: 'Your security is at stake!',
            text: 'Please answer all the security questions.'
        },
        1: {
            title: 'Your security is at stake!',
            text: 'Questions cannot share the same answers.'
        },
        2: {
            title: 'Your security is at stake!',
            text: 'Answers must be longer than 2 characters.'
        },
        3: {
            title: 'Your security is at stake!',
            text: 'Please choose three security questions.'
        },
        4: {
            title: 'Mismatch!',
            text: 'The code does not match. Please try again.'
        },
        5: {
            title: 'Mismatch!',
            text: 'The code must be 6 digits.'
        },
        6: {
            title: 'Not so fast!',
            text: 'Please enter a code.'
        },
        7: {
            title: 'Mismatch!',
            text: 'The code must contain numbers only.'
        },
        8: {
            title: 'Uh-oh!',
            text: 'Your answers are incorrect. Please try again.'
        }
    }
};
Messages.leadSources = {
    s: {
        0: {
            title: 'Ooh-la-la!',
            text: 'Lead source successfully added'
        },
        1: {
            title: 'Right-o!',
            text: 'Lead source successfully updated.'
        },
        2: {
            title: 'Packed away!',
            text: 'Lead source successfully archived.'
        },
        3: {
            title: 'Gone baby gone!',
            text: 'Lead source successfully deleted.'
        },
        4: {
            title: 'Reactivated!',
            text: 'Lead source successfully unarchived.'
        },
        5: {
            title: 'Eureka!',
            text: 'Lead sources successfully exported.'
        }
    },
    e: {
        0: {
            title: 'Close but not quite!',
            text: 'Please enter a name for this lead source.'
        },
        1: {
            title: 'Close but not quite!',
            text: 'Please choose a colour for this lead source.'
        },
        2: {
            title: 'Name taken!',
            text: 'Please enter a different name for this lead source.'
        },
        3: {
            title: "That didn't do it!",
            text: 'Please try confirming again.'
        }
    }
};
Messages.admin = {
    s: {
        0: {
            title: 'The best things in life are free!',
            text: '{value} has been given free access.'
        },
        1: {
            title: 'Case closed!',
            text: 'Access to {value} has been closed.'
        },
        2: {
            title: 'Bye Felicia!',
            text: '{value} has been successfully deleted.'
        },
        3: {
            title: 'Super!',
            text: 'Ambassadorship of {value} has been updated.'
        },
        4: {
            title: 'Eureka!',
            text: 'A csv file has been downloaded.'
        },
        5: {
            title: 'Eureka!',
            text: 'Your data has been updated successfully.'
        }
    },
    e: {
        0: {
            title: 'Too negative!',
            text: 'Please enter a positive integer number.'
        }
    }
};
Messages.quoteInvoiceTemplates = {
    s: {
        0: {
            title: 'Aye aye Captain!',
            text: 'Your {value} template was successfully created.'
        },
        1: {
            title: 'Aye aye Captain!',
            text: 'Your {value} template was successfully updated.'
        },
        2: {
            title: 'OK boss!',
            text: 'Your {value} template was successfully duplicated.'
        },
        3: {
            title: 'Hasta la vista baby!',
            text: 'Your {value} template was successfully deleted.'
        },
        4: {
            title: 'Aye aye Captain!',
            text: 'The default introduction was successfully updated.'
        },
        5: {
            title: 'OK boss!',
            text: 'The contract template {value} was successfully created.'
        },
        6: {
            title: 'OK boss!',
            text: 'The invoice template {value} was successfully created.'
        },
        7: {
            title: 'OK boss!',
            text: 'The quote template {value} was successfully created.'
        },
        8: {
            title: 'Sure thing!',
            text: 'Changes have been saved without affecting the linked quote/invoice template.'
        }
    },
    e: {
        0: {
            title: 'Everything has a name!',
            text: 'Please enter a name for your template.'
        },
        1: {
            title: 'Aye yai yai!',
            text: 'Please add a product or package before saving the template.'
        },
        2: {
            title: 'Pick me, choose me, love me!',
            text: 'Please choose a template to overwrite.'
        },
        3: {
            title: 'Everything has a name!',
            text: 'Please enter a name for your contract template.'
        },
        4: {
            title: 'Everything has a name!',
            text: 'Please enter a name for your {value} template.'
        },
        5: {
            title: 'Some links need to be updated!',
            text: 'Please reselect contract template before saving this as a {value} template.'
        },
        6: {
            title: 'Some links need to be updated!',
            text: 'Please reselect questionnaire template before saving this as a {value} template.'
        },
        7: {
            title: 'Some links need to be updated!',
            text: 'Please reselect both contract and questionnaire templates before saving this as a {value} template.'
        },
        8: {
            title: 'Whoops!',
            text: 'The template name is too long to duplicate. Please rename and try again.'
        }
    }
};
exports.Messages = Messages;

/***/ }),

/***/ "./shared/models/models.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
exports.COLOR_PICKER_OPTIONS = ['#000000', '#94999d', '#b9c0c6', '#d9d8de', '#ebeaef', '#f5f4fc', '#ffffff', '#680007', '#910005', '#ce000d', '#c8202d', '#d8505c', '#ec9aa0', '#f5ccd0', '#7d3713', '#b14d19', '#f37936', '#ee8146', '#f19f6f', '#fbc9ae', '#fce4d8', '#7f6a11', '#b59914', '#f4d03e', '#f7da65', '#f8e28c', '#feebb3', '#fdf6d9', '#426d37', '#5c9b4c', '#87d37b', '#92d681', '#ade29e', '#c6eabe', '#e6f4e3', '#175226', '#1f7335', '#26a65b', '#47ac66', '#6ec189', '#9ad4ac', '#d5eddf', '#1d4672', '#2464a2', '#3598db', '#509bdf', '#76b4e7', '#a0ccf1', '#d7eaf9', '#22315c', '#2a4280', '#446cb2', '#5974b9', '#7e95c9', '#a8b6dd', '#d7e3ef', '#2f134d', '#411769', '#663398', '#7245a2', '#926eb8', '#b49cd0', '#f2eff8', '#4f1142', '#681656', '#841d6e', '#9e498a', '#b678a7', '#cda6c5', '#e7d2e3'];
exports.DEFAULT_MEDIA_FILE_CONFIG = {
    multiple: false,
    accept: 'image/jpeg, image/png'
};
var MediaFilesId;
(function (MediaFilesId) {
    MediaFilesId["CompanyLogo"] = "CompanyLogo";
    MediaFilesId["CompanyBanner"] = "CompanyBanner";
})(MediaFilesId = exports.MediaFilesId || (exports.MediaFilesId = {}));
var ActionMethodEnum;
(function (ActionMethodEnum) {
    ActionMethodEnum["ALERT_MODAL"] = "ALERT_MODAL";
    ActionMethodEnum["FRAME"] = "FRAME";
    ActionMethodEnum["MANUAL"] = "MANUAL";
    ActionMethodEnum["POST"] = "POST";
    ActionMethodEnum["NEW_WINDOW"] = "NEW_WINDOW";
})(ActionMethodEnum = exports.ActionMethodEnum || (exports.ActionMethodEnum = {}));

/***/ }),

/***/ "./shared/models/subscription.model.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var CommunicationEvents;
(function (CommunicationEvents) {
    CommunicationEvents["billingUpdateOpen"] = "billingUpdateOpen";
    CommunicationEvents["billingUpdateClose"] = "billingUpdateClose";
    CommunicationEvents["planCheckoutOpen"] = "planCheckoutOpen";
    CommunicationEvents["planCheckoutClose"] = "planCheckoutClose";
    CommunicationEvents["planCheckoutBack"] = "planCheckoutBack";
    CommunicationEvents["confirmPaymentOpen"] = "confirmPaymentOpen";
    CommunicationEvents["confirmPaymentClose"] = "confirmPaymentClose";
    CommunicationEvents["updatePaymentOpen"] = "updatePaymentOpen";
    CommunicationEvents["updatePaymentClose"] = "updatePaymentClose";
    CommunicationEvents["messageReceived"] = "messageReceived";
})(CommunicationEvents = exports.CommunicationEvents || (exports.CommunicationEvents = {}));

/***/ }),

/***/ "./shared/models/system-variables/helpers.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
function exclude(obj) {
    var excludeList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    if (excludeList.length) {
        var newObj = Object.assign({}, obj);
        excludeList.forEach(function (key) {
            return delete newObj[key];
        });
        return newObj;
    }
    return Object.assign({}, obj);
}
exports.exclude = exclude;

/***/ }),

/***/ "./shared/models/system-variables/variable-groups.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var variables_1 = __webpack_require__("./shared/models/system-variables/variables.ts");
var companyVars = {
    'Business Name': variables_1.variables.companyName,
    'Business Phone': variables_1.variables.companyPhone,
    'Business Email': variables_1.variables.companyEmail,
    'Business Address': variables_1.variables.companyAddress
};
exports.companyVars = companyVars;
var paymentVars = {
    'Payment Due Date': variables_1.variables.invoiceDueDate,
    'Payment Amount': variables_1.variables.invoiceAmount
};
exports.paymentVars = paymentVars;
var clientVars = {
    'Client First Name': variables_1.variables.clientName,
    'Client Last Name': variables_1.variables.clientSurname,
    'Client Company Name': variables_1.variables.clientCompanyName,
    'Client Phone': variables_1.variables.clientPhone,
    'Client Email': variables_1.variables.clientEmail,
    'Client Address': variables_1.variables.clientAddress,
    'Client Notes': variables_1.variables.clientNotes
};
exports.clientVars = clientVars;
var secondaryClientVars = {
    'Secondary Client First Name': variables_1.variables.secondaryClientFirstName,
    'Secondary Client Last Name': variables_1.variables.secondaryClientLastName
};
exports.secondaryClientVars = secondaryClientVars;
var jobVars = {
    'Lead/Job Name': variables_1.variables.jobName,
    'Lead/Job Date': variables_1.variables.jobDate,
    'Lead/Job Start Time': variables_1.variables.jobStartTime,
    'Lead/Job End Time': variables_1.variables.jobEndTime,
    'Lead/Job Location': variables_1.variables.jobLocation,
    'Lead/Job Type': variables_1.variables.jobType,
    'Lead/Job Lead Source': variables_1.variables.jobLeadSource,
    'Lead/Job Notes': variables_1.variables.jobNotes
};
exports.jobVars = jobVars;
var appointmentVars = {
    'Upcoming Appointment Date': variables_1.variables.upcomingAppointmentDate,
    'Upcoming Appointment Start Time': variables_1.variables.upcomingAppointmentStartTime,
    'Upcoming Appointment End Time': variables_1.variables.upcomingAppointmentEndTime,
    'Upcoming Appointment Location': variables_1.variables.upcomingAppointmentLocation
};
exports.appointmentVars = appointmentVars;
var extraShootVars = {
    'Upcoming Extra Shoot Date': variables_1.variables.upcomingExtraShootDate,
    'Upcoming Extra Shoot Start Time': variables_1.variables.upcomingExtraShootStartTime,
    'Upcoming Extra Shoot End Time': variables_1.variables.upcomingExtraShootEndTime,
    'Upcoming Extra Shoot Location': variables_1.variables.upcomingExtraShootLocation
};
exports.extraShootVars = extraShootVars;
var invoiceJobVars = {
    'Total Invoice Amount': variables_1.variables.totalInvoiceAmount
};
exports.invoiceJobVars = invoiceJobVars;
var linkVars = {
    'Invoice Link': variables_1.variables.invoiceLink,
    'Quote Link': variables_1.variables.quoteLink,
    'Contract Link': variables_1.variables.contractLink,
    'Questionnaire Link': variables_1.variables.questionnaireLink,
    'Gallery Link': variables_1.variables.galleriesLink
};
exports.linkVars = linkVars;
var invoiceReminderVars = {
    'Appointment Date': variables_1.variables.appointmentDate,
    'Appointment Start Time': variables_1.variables.appointmentStartTime,
    'Appointment End Time': variables_1.variables.appointmentEndTime,
    'Appointment Location': variables_1.variables.appointmentLocation
};
exports.invoiceReminderVars = invoiceReminderVars;

/***/ }),

/***/ "./shared/models/system-variables/variables-to-insert.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var variable_groups_1 = __webpack_require__("./shared/models/system-variables/variable-groups.ts");
var helpers_1 = __webpack_require__("./shared/models/system-variables/helpers.ts");
exports.variablesList = {
    CLIENT_MENU: Object.assign({}, variable_groups_1.companyVars, variable_groups_1.clientVars),
    CLIENT_MENU_SUBJECT: Object.assign({}, variable_groups_1.companyVars, helpers_1.exclude(variable_groups_1.clientVars, ['Client Notes'])),
    JOB_MENU: Object.assign({}, variable_groups_1.companyVars, variable_groups_1.clientVars, variable_groups_1.secondaryClientVars, variable_groups_1.jobVars, variable_groups_1.invoiceJobVars, variable_groups_1.appointmentVars, variable_groups_1.extraShootVars, variable_groups_1.linkVars),
    JOB_MENU_SUBJECT: Object.assign({}, variable_groups_1.companyVars, helpers_1.exclude(variable_groups_1.clientVars, ['Client Notes']), variable_groups_1.secondaryClientVars, helpers_1.exclude(variable_groups_1.jobVars, ['Lead/Job Notes']), variable_groups_1.invoiceJobVars, variable_groups_1.appointmentVars, variable_groups_1.extraShootVars),
    PRODUCT_MENU: Object.assign({}, variable_groups_1.companyVars, variable_groups_1.clientVars, variable_groups_1.secondaryClientVars, variable_groups_1.jobVars, variable_groups_1.paymentVars, variable_groups_1.invoiceJobVars, variable_groups_1.linkVars),
    PICK_AND_CHOOSE_MENU: Object.assign({}, variable_groups_1.companyVars, variable_groups_1.clientVars, variable_groups_1.secondaryClientVars, variable_groups_1.jobVars, variable_groups_1.linkVars),
    CONTRACT_MENU: Object.assign({}, variable_groups_1.companyVars, variable_groups_1.clientVars, variable_groups_1.secondaryClientVars, variable_groups_1.jobVars, variable_groups_1.invoiceJobVars, variable_groups_1.linkVars),
    INVOICE_MENU: Object.assign({}, variable_groups_1.companyVars, variable_groups_1.clientVars, variable_groups_1.secondaryClientVars, variable_groups_1.jobVars, variable_groups_1.paymentVars, variable_groups_1.invoiceJobVars, variable_groups_1.appointmentVars, variable_groups_1.extraShootVars, variable_groups_1.linkVars),
    INVOICE_MENU_SUBJECT: Object.assign({}, variable_groups_1.companyVars, helpers_1.exclude(variable_groups_1.clientVars, ['Client Notes']), variable_groups_1.secondaryClientVars, helpers_1.exclude(variable_groups_1.jobVars, ['Client Notes', 'Lead/Job Notes']), variable_groups_1.paymentVars, variable_groups_1.invoiceJobVars, variable_groups_1.appointmentVars, variable_groups_1.extraShootVars),
    APPOINTMENT_REMINDER_MENU: Object.assign({}, variable_groups_1.companyVars, variable_groups_1.clientVars, variable_groups_1.invoiceReminderVars),
    APPOINTMENT_REMINDER_MENU_SUBJECT: Object.assign({}, variable_groups_1.companyVars, helpers_1.exclude(variable_groups_1.clientVars, ['Client Notes']), variable_groups_1.invoiceReminderVars)
};

/***/ }),

/***/ "./shared/models/system-variables/variables.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
exports.variables = {
    invoiceDueDate: '%payment_due_date%',
    invoiceAmount: '%payment_amount%',
    companyName: '%business_name%',
    companyPhone: '%company_phone%',
    companyEmail: '%company_email%',
    companyAddress: '%business_address%',
    clientName: '%client_name%',
    clientSurname: '%client_surname%',
    clientPhone: '%client_phone%',
    clientAddress: '%client_address%',
    clientEmail: '%client_email%',
    clientNotes: '%client_notes%',
    clientCompanyName: '%client_company%',
    secondaryClientFirstName: '%2nd_client_name%',
    secondaryClientLastName: '%2nd_client_surname%',
    jobName: '$jobName$',
    jobDate: '%job_date%',
    jobStartTime: '%job_start_time%',
    jobEndTime: '%job_end_time%',
    jobLocation: '%job_location%',
    jobNotes: '%job_notes%',
    jobType: '%job_type%',
    jobLeadSource: '%job_leadsource%',
    appointmentDate: '%appointment_date%',
    appointmentStartTime: '%appointment_start_time%',
    appointmentEndTime: '%appointment_end_time%',
    appointmentLocation: '%appointment_location%',
    totalInvoiceAmount: '%total_invoiced%',
    upcomingAppointmentDate: '%next_appointment_date%',
    upcomingAppointmentStartTime: '%next_appointment_start_time%',
    upcomingAppointmentEndTime: '%next_appointment_end_time%',
    upcomingAppointmentLocation: '%next_appointment_location%',
    upcomingExtraShootDate: '%next_extrashoot_date%',
    upcomingExtraShootStartTime: '%next_extrashoot_start_time%',
    upcomingExtraShootEndTime: '%next_extrashoot_end_time%',
    upcomingExtraShootLocation: '%next_extrashoot_location%',
    contractLink: "<span><a href=" + '%contract_link%' + ">Please view and sign your contract online by clicking here</a></span>",
    invoiceLink: "<span><a href=" + '%invoice_link%' + ">Please click here to view and pay your invoice online</a></span>",
    quoteLink: "<span><a href=" + '%quote_link%' + ">Please view your quote online by clicking here</a></span>",
    questionnaireLink: "<span><a href=" + '%questionnaire_link%' + ">Please view the questionnaire online by clicking here</a></span>",
    galleriesLink: "<span><a href=" + '%galleries_link%' + ">Please view the galleries online by clicking here</a></span>"
};

/***/ }),

/***/ "./shared/models/two-fa.models.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
exports.Steps = [{ number: 1, label: 'Download App' }, { number: 2, label: 'Set Questions' }, { number: 3, label: 'Enter Code' }];
exports.SecretQuestions = [{ question: 'What was your childhood nickname?', selected: false }, {
    question: 'In what city did you meet your spouse/significant other?',
    selected: false
}, {
    question: 'What is the name of your favourite childhood friend?',
    selected: false
}, {
    question: 'What street did you live on when you were 10 years old?',
    selected: false
}, {
    question: "What is your oldest cousin's first and last name?",
    selected: false
}, {
    question: 'What is the first name of the boy or girl that you first kissed?',
    selected: false
}, { question: 'In what city or town did your parents meet?', selected: false }, {
    question: 'What was the name of your elementary / primary school?',
    selected: false
}, {
    question: 'What is the name of the company of your first job?',
    selected: false
}, { question: 'In what city or town was your first job?', selected: false }, { question: 'To what city did you go on your honeymoon?', selected: false }, { question: 'What was your dream job as a child?', selected: false }, { question: 'What was the first concert you attended?', selected: false }, { question: "What is your mother's middle name?", selected: false }, {
    question: 'What was the make and model of your first car?',
    selected: false
}];

/***/ }),

/***/ "./shared/pipes/bold/boldPipe.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var BoldPipeFilter = function () {
    function BoldPipeFilter() {
        _classCallCheck(this, BoldPipeFilter);
    }

    _createClass(BoldPipeFilter, [{
        key: "transform",
        value: function transform(value, query) {
            return value.replace(new RegExp(query, 'gi'), function (match) {
                return "<strong>" + match + "</strong>";
            });
        }
    }]);

    return BoldPipeFilter;
}();
BoldPipeFilter = __decorate([core_1.Pipe({
    name: 'boldFilter',
    pure: false
})], BoldPipeFilter);
exports.BoldPipeFilter = BoldPipeFilter;

/***/ }),

/***/ "./shared/pipes/cut-string/cut-string.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var CutStringFilterPipe = function () {
    function CutStringFilterPipe() {
        _classCallCheck(this, CutStringFilterPipe);
    }

    _createClass(CutStringFilterPipe, [{
        key: "transform",
        value: function transform(value, max) {
            if (!value) {
                return '';
            }
            if (value.length <= max) {
                return value;
            }
            value = value.substr(0, max);
            var lastSpace = value.lastIndexOf(' ');
            if (lastSpace !== -1) {
                if (value.charAt(lastSpace - 1) === '.' || value.charAt(lastSpace - 1) === ',' || value.charAt(lastSpace - 1) === '!' || value.charAt(lastSpace - 1) === '?') {
                    lastSpace -= 1;
                }
                value = value.substr(0, lastSpace);
            }
            return value + "...";
        }
    }]);

    return CutStringFilterPipe;
}();
CutStringFilterPipe = __decorate([core_1.Injectable(), core_1.Pipe({
    name: 'cutStringFilter'
}), __metadata("design:paramtypes", [])], CutStringFilterPipe);
exports.CutStringFilterPipe = CutStringFilterPipe;

/***/ }),

/***/ "./shared/pipes/datepicker-filter/datepicker-filter.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var common_1 = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
var settings_1 = __webpack_require__("./shared/services/settings/settings.ts");
var DatepickerFilterPipe = function () {
    function DatepickerFilterPipe(datePipe, settingsService) {
        _classCallCheck(this, DatepickerFilterPipe);

        this.datePipe = datePipe;
        this.settingsService = settingsService;
    }

    _createClass(DatepickerFilterPipe, [{
        key: "transform",
        value: function transform(date) {
            var _this = this;

            this.settingsService.timeFormatSettings.subscribe(function (data) {
                _this.dateFormat = data.dateFormat;
            });
            if (date === 'placeholder') {
                return this.dateFormat === 'DD_MM_YYYY' ? 'dd/mm/yyyy' : 'mm/dd/yyyy';
            }
            return this.dateFormat === 'DD_MM_YYYY' ? this.datePipe.transform(date, 'dd/MM/yyyy') : this.datePipe.transform(date, 'MM/dd/yyyy');
        }
    }]);

    return DatepickerFilterPipe;
}();
DatepickerFilterPipe = __decorate([core_1.Injectable(), core_1.Pipe({
    name: 'datepickerFilter'
}), __metadata("design:paramtypes", [common_1.DatePipe, settings_1.SettingsProvider])], DatepickerFilterPipe);
exports.DatepickerFilterPipe = DatepickerFilterPipe;

/***/ }),

/***/ "./shared/pipes/dnd-autoscroll/dnd-autoscroll.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var ng2_dragula_1 = __webpack_require__("./node_modules/ng2-dragula/index.js");
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
// Use this directive with ng2-dragula library to add autoScroll on drag'n'drop events
var DndAutoScroll = DndAutoScroll_1 = function () {
    function DndAutoScroll(dragulaService) {
        var _this = this;

        _classCallCheck(this, DndAutoScroll);

        this.dragulaService = dragulaService;
        this.scrollable = true;
        this.unsubscribe = new Subject_1.Subject();
        this.removeDefaultScrollOnTouch = function (e) {
            if (!_this.scrollable) {
                e.preventDefault();
            }
        };
    }

    _createClass(DndAutoScroll, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.addDragulaEventsListeners();
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.clear();
        }
    }, {
        key: "addDragulaEventsListeners",
        value: function addDragulaEventsListeners() {
            var _this2 = this;

            document.addEventListener('touchmove', this.removeDefaultScrollOnTouch, {
                passive: false
            });
            this.dragulaService.drag.takeUntil(this.unsubscribe).subscribe(function () {
                _this2.scrollable = false;
                DndAutoScroll_1.addMoveListeners();
            });
            this.dragulaService.dragend.takeUntil(this.unsubscribe).subscribe(function () {
                _this2.scrollable = true;
                DndAutoScroll_1.removeListeners();
                document.onmousemove = null;
            });
        }
    }, {
        key: "clear",
        value: function clear() {
            document.removeEventListener('touchmove', this.removeDefaultScrollOnTouch);
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }], [{
        key: "addMoveListeners",
        value: function addMoveListeners() {
            document.addEventListener('mousemove', DndAutoScroll_1.mouseMoveListener);
            document.addEventListener('touchmove', DndAutoScroll_1.touchMoveListener);
        }
    }, {
        key: "removeListeners",
        value: function removeListeners() {
            document.removeEventListener('mousemove', DndAutoScroll_1.mouseMoveListener);
            document.removeEventListener('touchmove', DndAutoScroll_1.touchMoveListener);
        }
    }, {
        key: "mouseMoveListener",
        value: function mouseMoveListener(e) {
            var pageY = 'pageY';
            var mouseY = e.pageY || window.event[pageY];
            var scrollTop = document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop; // document.documentElement.scrollTop is undefined on the Edge browser
            var scrollBottom = scrollTop + window.innerHeight;
            if (mouseY - 100 < scrollTop) {
                window.scrollBy(0, -15);
            } else if (mouseY + 100 > scrollBottom) {
                window.scrollBy(0, 15);
            }
        }
    }, {
        key: "touchMoveListener",
        value: function touchMoveListener(e) {
            var clientY = e.touches[0].clientY;

            if (clientY - 100 < 0) {
                window.scrollBy(0, -20);
            } else if (clientY + 100 > window.innerHeight) {
                window.scrollBy(0, 20);
            }
        }
    }]);

    return DndAutoScroll;
}();
DndAutoScroll = DndAutoScroll_1 = __decorate([core_1.Directive({
    selector: '[dnd-auto-scroll]'
}), __metadata("design:paramtypes", [ng2_dragula_1.DragulaService])], DndAutoScroll);
exports.DndAutoScroll = DndAutoScroll;
var DndAutoScroll_1;

/***/ }),

/***/ "./shared/pipes/order-by-date/order-by-date.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var OrderByDatePipe = function () {
    function OrderByDatePipe() {
        _classCallCheck(this, OrderByDatePipe);
    }

    _createClass(OrderByDatePipe, [{
        key: "transform",
        value: function transform(value, type) {
            var newVal = value.sort(function (a, b) {
                var date1 = new Date(a[type]).getTime();
                var date2 = new Date(b[type]).getTime();
                if (date1 > date2) {
                    return 1;
                } else if (date1 < date2) {
                    return -1;
                }
                return 0;
            });
            return newVal;
        }
    }]);

    return OrderByDatePipe;
}();
OrderByDatePipe = __decorate([core_1.Pipe({
    name: 'orderByDate'
})], OrderByDatePipe);
exports.OrderByDatePipe = OrderByDatePipe;

/***/ }),

/***/ "./shared/pipes/order-by/order-by-name.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var OrderByNamePipe = function () {
    function OrderByNamePipe() {
        _classCallCheck(this, OrderByNamePipe);
    }

    _createClass(OrderByNamePipe, [{
        key: "transform",
        value: function transform() {
            var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

            array.sort(function (a, b) {
                if (a.name.toUpperCase() < b.name.toUpperCase()) {
                    return -1;
                } else if (a.name.toUpperCase() > b.name.toUpperCase()) {
                    return 1;
                }
                return 0;
            });
            return array;
        }
    }]);

    return OrderByNamePipe;
}();
OrderByNamePipe = __decorate([core_1.Pipe({
    name: 'orderByName'
})], OrderByNamePipe);
exports.OrderByNamePipe = OrderByNamePipe;

/***/ }),

/***/ "./shared/pipes/order-by/order-by.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var OrderByPipe = function () {
    function OrderByPipe() {
        _classCallCheck(this, OrderByPipe);
    }

    _createClass(OrderByPipe, [{
        key: "transform",
        value: function transform(array, field) {
            if (!array) {
                return [];
            }
            array.sort(function (a, b) {
                if (a[field] < b[field]) {
                    return -1;
                } else if (a[field] > b[field]) {
                    return 1;
                }
                return 0;
            });
            return array;
        }
    }]);

    return OrderByPipe;
}();
OrderByPipe = __decorate([core_1.Pipe({
    name: 'orderBy'
})], OrderByPipe);
exports.OrderByPipe = OrderByPipe;

/***/ }),

/***/ "./shared/pipes/pipes.module.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var common_1 = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
var time_filter_1 = __webpack_require__("./shared/pipes/time-filter/time-filter.ts");
var safe_html_1 = __webpack_require__("./shared/pipes/safe-html/safe-html.ts");
var profile_price_filter_1 = __webpack_require__("./shared/pipes/profile-price-filter/profile-price-filter.ts");
var order_by_1 = __webpack_require__("./shared/pipes/order-by/order-by.ts");
var order_by_date_1 = __webpack_require__("./shared/pipes/order-by-date/order-by-date.ts");
var datepicker_filter_1 = __webpack_require__("./shared/pipes/datepicker-filter/datepicker-filter.ts");
var boldPipe_1 = __webpack_require__("./shared/pipes/bold/boldPipe.ts");
var sn_date_picker_config_1 = __webpack_require__("./shared/pipes/sn-date-picker-config/sn-date-picker.config.ts");
var cut_string_1 = __webpack_require__("./shared/pipes/cut-string/cut-string.ts");
var order_by_name_1 = __webpack_require__("./shared/pipes/order-by/order-by-name.ts");
var dnd_autoscroll_1 = __webpack_require__("./shared/pipes/dnd-autoscroll/dnd-autoscroll.ts");
var safe_1 = __webpack_require__("./shared/pipes/safe/safe.ts");
var time_zone_filter_1 = __webpack_require__("./shared/pipes/time-zone-filter/time-zone-filter.ts");
var table_sort_pipe_1 = __webpack_require__("./shared/pipes/table-sort/table-sort.pipe.ts");
var PipesModule = function PipesModule() {
    _classCallCheck(this, PipesModule);
};
PipesModule = __decorate([core_1.NgModule({
    declarations: [time_filter_1.TimeFilterPipe, safe_html_1.SafeHtmlPipe, profile_price_filter_1.ProfilePriceFilterPipe, order_by_1.OrderByPipe, order_by_date_1.OrderByDatePipe, datepicker_filter_1.DatepickerFilterPipe, sn_date_picker_config_1.SnDatePickerConfigPipe, cut_string_1.CutStringFilterPipe, boldPipe_1.BoldPipeFilter, order_by_name_1.OrderByNamePipe, dnd_autoscroll_1.DndAutoScroll, safe_1.SafePipe, time_zone_filter_1.TimeZoneFilter, table_sort_pipe_1.TableSortPipe],
    providers: [common_1.DatePipe, profile_price_filter_1.ProfilePriceFilterPipe, order_by_1.OrderByPipe, order_by_date_1.OrderByDatePipe, datepicker_filter_1.DatepickerFilterPipe, cut_string_1.CutStringFilterPipe, sn_date_picker_config_1.SnDatePickerConfigPipe, boldPipe_1.BoldPipeFilter, order_by_name_1.OrderByNamePipe, dnd_autoscroll_1.DndAutoScroll, safe_1.SafePipe, time_zone_filter_1.TimeZoneFilter],
    exports: [time_filter_1.TimeFilterPipe, safe_html_1.SafeHtmlPipe, profile_price_filter_1.ProfilePriceFilterPipe, order_by_1.OrderByPipe, order_by_date_1.OrderByDatePipe, datepicker_filter_1.DatepickerFilterPipe, cut_string_1.CutStringFilterPipe, sn_date_picker_config_1.SnDatePickerConfigPipe, boldPipe_1.BoldPipeFilter, order_by_name_1.OrderByNamePipe, dnd_autoscroll_1.DndAutoScroll, safe_1.SafePipe, time_zone_filter_1.TimeZoneFilter, table_sort_pipe_1.TableSortPipe]
})], PipesModule);
exports.PipesModule = PipesModule;

/***/ }),

/***/ "./shared/pipes/profile-price-filter/profile-price-filter.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO remove after implementing Stripe v3

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var common_1 = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
// import { UserServiceProvider } from '@services/user/user.service';
var ProfilePriceFilterPipe = function () {
    function ProfilePriceFilterPipe(decimalPipe // private userService: UserServiceProvider
    ) {
        _classCallCheck(this, ProfilePriceFilterPipe);

        this.decimalPipe = decimalPipe; // private userService: UserServiceProvider
    }

    _createClass(ProfilePriceFilterPipe, [{
        key: "transform",
        value: function transform(input, type) {
            var output = void 0;
            if (!input && input !== 0) {
                return '';
            }
            var inputRound = this.decimalPipe.transform(input, '.2-2');
            var money = inputRound.toString().split('.');
            // this.user = this.userService.userData;
            var subscriptionObj = this.user.subscriptionPrice;
            switch (type) {
                case 'bill':
                    var symbol = void 0;
                    symbol = subscriptionObj.currencySymbol || '$';
                    output = symbol + money[0];
                    break;
                case 'coin':
                    output = "." + money[1] || '00';
                    break;
                case 'coin-no-zero':
                    if (money[1] === '00') {
                        output = '';
                    } else {
                        output = "." + money[1];
                    }
                    break;
                case 'label':
                    var label = subscriptionObj.currencyName || 'USD';
                    if (label === 'AUD' || label === 'NZD') {
                        label = 'AUD';
                    }
                    output = label;
                    break;
                case 'full-currency-symbol':
                    var symbolFull = subscriptionObj.currencySymbol || '$';
                    var labelFull = subscriptionObj.currencyName || 'USD';
                    if (labelFull === 'AUD' || labelFull === 'NZD') {
                        labelFull = 'AUD';
                    }
                    output = labelFull + symbolFull + inputRound;
                    break;
                case 'discount':
                    var discountSymbol = subscriptionObj.currencySymbol || '$';
                    if (subscriptionObj.discount.percent) {
                        output = money[0] + "%";
                    } else {
                        output = discountSymbol + money;
                    }
                    break;
                default:
                    output = '';
            }
            return output;
        }
    }]);

    return ProfilePriceFilterPipe;
}();
ProfilePriceFilterPipe = __decorate([core_1.Pipe({
    name: 'profilePriceFilter'
}), __metadata("design:paramtypes", [common_1.DecimalPipe // private userService: UserServiceProvider
])], ProfilePriceFilterPipe);
exports.ProfilePriceFilterPipe = ProfilePriceFilterPipe;

/***/ }),

/***/ "./shared/pipes/safe-html/safe-html.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var platform_browser_1 = __webpack_require__("./node_modules/@angular/platform-browser/esm5/platform-browser.js");
var SafeHtmlPipe = function () {
    function SafeHtmlPipe(sanitized) {
        _classCallCheck(this, SafeHtmlPipe);

        this.sanitized = sanitized;
    }

    _createClass(SafeHtmlPipe, [{
        key: "transform",
        value: function transform(value) {
            return this.sanitized.bypassSecurityTrustHtml(value);
        }
    }]);

    return SafeHtmlPipe;
}();
SafeHtmlPipe = __decorate([core_1.Pipe({
    name: 'safeHtml'
}), __metadata("design:paramtypes", [platform_browser_1.DomSanitizer])], SafeHtmlPipe);
exports.SafeHtmlPipe = SafeHtmlPipe;

/***/ }),

/***/ "./shared/pipes/safe/safe.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var platform_browser_1 = __webpack_require__("./node_modules/@angular/platform-browser/esm5/platform-browser.js");
var SafePipe = function () {
    function SafePipe(sanitizer) {
        _classCallCheck(this, SafePipe);

        this.sanitizer = sanitizer;
    }

    _createClass(SafePipe, [{
        key: "transform",
        value: function transform(value, type) {
            switch (type) {
                case 'html':
                    return this.sanitizer.bypassSecurityTrustHtml(value);
                case 'style':
                    return this.sanitizer.bypassSecurityTrustStyle(value);
                case 'script':
                    return this.sanitizer.bypassSecurityTrustScript(value);
                case 'url':
                    return this.sanitizer.bypassSecurityTrustUrl(value);
                case 'resourceUrl':
                    return this.sanitizer.bypassSecurityTrustResourceUrl(value);
                default:
                    throw new Error("Invalid safe type specified: " + type);
            }
        }
    }]);

    return SafePipe;
}();
SafePipe = __decorate([core_1.Pipe({
    name: 'safe'
}), __metadata("design:paramtypes", [platform_browser_1.DomSanitizer])], SafePipe);
exports.SafePipe = SafePipe;

/***/ }),

/***/ "./shared/pipes/sn-date-picker-config/sn-date-picker.config.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var settings_1 = __webpack_require__("./shared/services/settings/settings.ts");
var SnDatePickerConfigPipe = function () {
    function SnDatePickerConfigPipe(settingsService) {
        _classCallCheck(this, SnDatePickerConfigPipe);

        this.settingsService = settingsService;
    }

    _createClass(SnDatePickerConfigPipe, [{
        key: "transform",
        value: function transform(date) {
            var _this = this;

            this.settingsService.timeFormatSettings.subscribe(function (data) {
                if (data.weekStartsOn !== null) {
                    var dateFormat = data.dateFormat === 'DD_MM_YYYY' ? 'dd/mm/yyyy' : 'mm/dd/yyyy';
                    var weekStartsOn = data.weekStartsOn.substring(0, 2).toLowerCase();
                    _this.snDatePickerOptions = {
                        dateFormat: dateFormat,
                        firstDayOfWeek: weekStartsOn,
                        minYear: 2000,
                        openSelectorOnInputClick: true,
                        openSelectorTopOfInput: date === 'shootproof options',
                        alignSelectorRight: date === 'shootproof options',
                        selectorHeight: '252px',
                        selectorWidth: '252px'
                    };
                }
            });
            return this.snDatePickerOptions;
        }
    }]);

    return SnDatePickerConfigPipe;
}();
SnDatePickerConfigPipe = __decorate([core_1.Injectable(), core_1.Pipe({
    name: 'snDatePickerConfig'
}), __metadata("design:paramtypes", [settings_1.SettingsProvider])], SnDatePickerConfigPipe);
exports.SnDatePickerConfigPipe = SnDatePickerConfigPipe;

/***/ }),

/***/ "./shared/pipes/table-sort/table-sort.pipe.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var TableSortPipe = function () {
    function TableSortPipe() {
        _classCallCheck(this, TableSortPipe);
    }

    _createClass(TableSortPipe, [{
        key: "transform",
        value: function transform(data, order, field) {
            if (!data.length) {
                return data;
            }
            if (data.length <= 1) {
                return data;
            }
            return order ? this.sortAscending(data, field) : this.sortDescending(data, field);
        }
    }, {
        key: "sortAscending",
        value: function sortAscending(data, field) {
            return data.sort(function (a, b) {
                if (typeof a[field] === 'string') {
                    return a[field].localeCompare(b[field]);
                }
                if (typeof a[field] === 'number') {
                    return a[field] - b[field];
                }
                return 0;
            });
        }
    }, {
        key: "sortDescending",
        value: function sortDescending(data, field) {
            return data.sort(function (a, b) {
                if (typeof b[field] === 'string') {
                    return b[field].localeCompare(a[field]);
                }
                if (typeof b[field] === 'number') {
                    return b[field] - a[field];
                }
                return 0;
            });
        }
    }]);

    return TableSortPipe;
}();
TableSortPipe = __decorate([core_1.Pipe({
    name: 'tableSort'
}), __metadata("design:paramtypes", [])], TableSortPipe);
exports.TableSortPipe = TableSortPipe;

/***/ }),

/***/ "./shared/pipes/time-filter/time-filter.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var common_1 = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
var time_converter_1 = __webpack_require__("./shared/services/helpers/time-converter.ts");
var settings_1 = __webpack_require__("./shared/services/settings/settings.ts");
var TimeFilterPipe = function () {
    function TimeFilterPipe(datePipe, timeConverter, settingsService) {
        _classCallCheck(this, TimeFilterPipe);

        this.datePipe = datePipe;
        this.timeConverter = timeConverter;
        this.settingsService = settingsService;
    }

    _createClass(TimeFilterPipe, [{
        key: "transform",
        value: function transform(date, type) {
            var _this = this;

            this.settingsService.timeFormatSettings.subscribe(function (data) {
                _this.dateFormat = data.dateFormat;
                _this.timeFormat = data.timeFormat;
            });
            // check if we need a time or a date value
            if (type.includes('12h') || type === 'hourAndMin') {
                return this.timeFormat === 'T_24' ? this.transformISO(date, type) : this.transformEnglish(date, type);
            }
            return this.dateFormat === 'DD_MM_YYYY' ? this.transformISO(date, type) : this.transformEnglish(date, type);
        }
    }, {
        key: "transformEnglish",
        value: function transformEnglish(date, type) {
            var output = void 0;
            if (!date) {
                return '';
            }
            switch (type) {
                case '12h':
                    output = this.timeConverter.convert24to12(date);
                    break;
                case 'hourAndMin':
                    output = this.datePipe.transform(date, 'hh:mm a');
                    break;
                case '12hL':
                    output = this.timeConverter.convert24to12(date).toLocaleLowerCase();
                    break;
                case '12hLS':
                    output = this.timeConverter.convert24to12(date).toLocaleLowerCase().replace(' ', '');
                    break;
                case 'long':
                    output = this.datePipe.transform(date, 'MMMM dd yyyy');
                    break;
                case 'medium':
                    output = this.datePipe.transform(date, 'MMM dd yyyy');
                    break;
                case 'dayAndMonth':
                    output = this.datePipe.transform(date, 'MMM dd');
                    break;
                case 'dayAndLongMonth':
                    output = this.datePipe.transform(date, 'MMMM dd');
                    break;
                default:
                    output = '';
            }
            return output;
        }
    }, {
        key: "transformISO",
        value: function transformISO(date, type) {
            var output = void 0;
            if (!date) {
                return '';
            }
            switch (type) {
                case '12h':
                    output = date.substring(0, 5);
                    break;
                case 'hourAndMin':
                    output = this.datePipe.transform(date, 'HH:mm');
                    break;
                case '12hL':
                    output = date.substring(0, 5);
                    break;
                case '12hLS':
                    output = date.substring(0, 5);
                    break;
                case 'long':
                    output = this.datePipe.transform(date, 'dd MMMM yyyy');
                    break;
                case 'medium':
                    output = this.datePipe.transform(date, 'dd MMM yyyy');
                    break;
                case 'dayAndMonth':
                    output = this.datePipe.transform(date, 'dd MMM');
                    break;
                case 'dayAndLongMonth':
                    output = this.datePipe.transform(date, 'dd MMMM');
                    break;
                default:
                    output = '';
            }
            return output;
        }
    }]);

    return TimeFilterPipe;
}();
TimeFilterPipe = __decorate([core_1.Injectable(), core_1.Pipe({
    name: 'timeFilter'
}), __metadata("design:paramtypes", [common_1.DatePipe, time_converter_1.TimeConverterProvider, settings_1.SettingsProvider])], TimeFilterPipe);
exports.TimeFilterPipe = TimeFilterPipe;

/***/ }),

/***/ "./shared/pipes/time-zone-filter/time-zone-filter.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var TimeZoneFilter = function () {
    function TimeZoneFilter() {
        _classCallCheck(this, TimeZoneFilter);
    }

    _createClass(TimeZoneFilter, [{
        key: "transform",
        value: function transform(timeZone) {
            var zoneOffset = timeZone.zoneOffset === 'Z' ? '00:00' : timeZone.zoneOffset;
            var name = timeZone.name.replace('/', ' - ');
            return "(" + zoneOffset + ") " + name;
        }
    }]);

    return TimeZoneFilter;
}();
TimeZoneFilter = __decorate([core_1.Injectable(), core_1.Pipe({
    name: 'timeZoneFilter'
})], TimeZoneFilter);
exports.TimeZoneFilter = TimeZoneFilter;

/***/ }),

/***/ "./shared/rxjs-operators.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__("./node_modules/rxjs/add/observable/of.js");
__webpack_require__("./node_modules/rxjs/add/observable/zip.js");
__webpack_require__("./node_modules/rxjs/add/observable/throw.js");
__webpack_require__("./node_modules/rxjs/add/observable/fromEvent.js");
__webpack_require__("./node_modules/rxjs/add/observable/empty.js");
__webpack_require__("./node_modules/rxjs/add/observable/fromPromise.js");
__webpack_require__("./node_modules/rxjs/add/operator/finally.js");
__webpack_require__("./node_modules/rxjs/add/operator/take.js");
__webpack_require__("./node_modules/rxjs/add/operator/catch.js");
__webpack_require__("./node_modules/rxjs/add/operator/first.js");
__webpack_require__("./node_modules/rxjs/add/operator/map.js");
__webpack_require__("./node_modules/rxjs/add/operator/mergeMap.js");
__webpack_require__("./node_modules/rxjs/add/operator/switchMap.js");
__webpack_require__("./node_modules/rxjs/add/operator/zip.js");
__webpack_require__("./node_modules/rxjs/add/operator/debounceTime.js");
__webpack_require__("./node_modules/rxjs/add/operator/distinctUntilChanged.js");
__webpack_require__("./node_modules/rxjs/add/operator/share.js");
__webpack_require__("./node_modules/rxjs/add/operator/filter.js");
__webpack_require__("./node_modules/rxjs/add/operator/takeUntil.js");
__webpack_require__("./node_modules/rxjs/operators/catchError.js");

/***/ }),

/***/ "./shared/services/admin/reports/reports-overview.data.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var http_1 = __webpack_require__("./node_modules/@angular/common/esm5/http.js");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var Observable_1 = __webpack_require__("./node_modules/rxjs/Observable.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var BehaviorSubject_1 = __webpack_require__("./node_modules/rxjs/BehaviorSubject.js");
var ReportsOverviewDataProvider = function () {
    function ReportsOverviewDataProvider(http, messageService) {
        _classCallCheck(this, ReportsOverviewDataProvider);

        this.http = http;
        this.messageService = messageService;
        this.reportsOverviewSubject = new BehaviorSubject_1.BehaviorSubject({
            reports: null
        });
    }

    _createClass(ReportsOverviewDataProvider, [{
        key: "getSettingsOverviewItems",
        value: function getSettingsOverviewItems() {
            var _this = this;

            var url = '/api/admin/rest/reports';
            return this.http.get(url).catch(function (error) {
                _this.messageService.showToaster('e_0', 'general', error.error);
                return Observable_1.Observable.throw(error);
            }).pipe(operators_1.map(function (res) {
                return res.data;
            }), operators_1.map(function (data) {
                var reportsData = JSON.parse(JSON.stringify(data.reports));
                _this.reportsOverviewSubject.next({
                    reports: reportsData
                });
                return data;
            }));
        }
    }, {
        key: "updateData",
        value: function updateData(action, data) {
            var _this2 = this;

            return this.http.post(action.url, data).pipe(operators_1.catchError(function (error) {
                _this2.messageService.catchErrorFromBackend(error);
                return Observable_1.Observable.throw(error);
            }));
        }
    }, {
        key: "reportsOverview",
        value: function reportsOverview() {
            return this.reportsOverviewSubject.asObservable();
        }
    }]);

    return ReportsOverviewDataProvider;
}();
ReportsOverviewDataProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [http_1.HttpClient, message_service_1.MessageService])], ReportsOverviewDataProvider);
exports.ReportsOverviewDataProvider = ReportsOverviewDataProvider;

/***/ }),

/***/ "./shared/services/brands/brands.data.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var rxjs_1 = __webpack_require__("./node_modules/rxjs/Rx.js");
var http_1 = __webpack_require__("./node_modules/@angular/common/esm5/http.js");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var of_1 = __webpack_require__("./node_modules/rxjs/observable/of.js");
var auth_tokens_service_1 = __webpack_require__("./web/modern/auth-tokens.service.ts");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var BrandsDataServiceProvider = function () {
    function BrandsDataServiceProvider(http, tokenService, messageService) {
        _classCallCheck(this, BrandsDataServiceProvider);

        this.http = http;
        this.tokenService = tokenService;
        this.messageService = messageService;
        this.brandsData$ = new rxjs_1.BehaviorSubject(null);
        this.brandsChange$ = new rxjs_1.Subject();
    }

    _createClass(BrandsDataServiceProvider, [{
        key: "setBrandsChange",
        value: function setBrandsChange(change) {
            this.brandsChange$.next(change);
        }
    }, {
        key: "setBrandsData",
        value: function setBrandsData(brands) {
            this.brandsData$.next(brands);
        }
        // Used to process data update due to brand switching

    }, {
        key: "updateBrands",
        value: function updateBrands() {
            return this.getBrands();
        }
        // get initial brand data

    }, {
        key: "getBrandsData",
        value: function getBrandsData() {
            this.getBrands().subscribe();
        }
    }, {
        key: "getBrandsInfo",
        value: function getBrandsInfo() {
            var _this = this;

            var url = '/api/user/brands/management';
            return this.http.get(url).pipe(operators_1.map(function (res) {
                return res.data;
            }), operators_1.catchError(function (error) {
                return _this.messageService.catchErrorFromBackend(error);
            }));
        }
    }, {
        key: "switchBrands",
        value: function switchBrands(companyId) {
            var _this2 = this;

            var token = this.tokenService.getRefreshToken();
            var url = '/oauth/token';
            var params = new http_1.HttpParams().set('grant_type', 'refresh_token').set('refresh_token', token).set('companyId', companyId.toString());
            var headers = new http_1.HttpHeaders().set('Authorization', this.tokenService.getCorrectBasicWebToken());
            return this.http.post(url, {}, { params: params, headers: headers }).pipe(operators_1.switchMap(function (data) {
                if (data.access_token) {
                    _this2.tokenService.removeTokens();
                    _this2.tokenService.emitTokenSubject(_this2.tokenService.successGetRefreshedToken(data));
                    _this2.setActivebrandId(companyId);
                }
                return of_1.of(data);
            }), operators_1.catchError(function (error) {
                return _this2.messageService.catchErrorFromBackend(error);
            }));
        }
    }, {
        key: "saveBrand",
        value: function saveBrand(brand) {
            var _this3 = this;

            var url = '/api/user/brands/management/new';
            return this.http.post(url, brand).pipe(operators_1.map(function (res) {
                return res.data;
            }), operators_1.catchError(function (error) {
                return _this3.messageService.catchErrorFromBackend(error);
            }));
        }
    }, {
        key: "getBrandDetailsInfo",
        value: function getBrandDetailsInfo(id) {
            var _this4 = this;

            var url = "/api/user/brands/" + id + "/preview";
            return this.http.get(url).pipe(operators_1.map(function (res) {
                return res.data;
            }), operators_1.catchError(function (error) {
                return _this4.messageService.catchErrorFromBackend(error);
            }));
        }
    }, {
        key: "getBrandsImportData",
        value: function getBrandsImportData() {
            var _this5 = this;

            var url = '/api/user/v1/brand/import/preview';
            return this.http.get(url).pipe(operators_1.map(function (res) {
                return res.data;
            }), operators_1.catchError(function (error) {
                return _this5.messageService.catchErrorFromBackend(error);
            }));
        }
    }, {
        key: "deleteBrand",
        value: function deleteBrand(url) {
            var _this6 = this;

            return this.http.post(url, {}).pipe(operators_1.catchError(function (error) {
                return _this6.messageService.catchErrorFromBackend(error);
            }));
        }
    }, {
        key: "saveBrandDetailsInfo",
        value: function saveBrandDetailsInfo(url, data) {
            var _this7 = this;

            return this.http.post(url, data).pipe(operators_1.catchError(function (error) {
                return _this7.messageService.catchErrorFromBackend(error);
            }));
        }
    }, {
        key: "changeGdprState",
        value: function changeGdprState(url, data) {
            var _this8 = this;

            return this.http.post(url, data).pipe(operators_1.map(function (data) {
                return data.data;
            }), operators_1.catchError(function (error) {
                return _this8.messageService.catchErrorFromBackend(error);
            }));
        }
    }, {
        key: "updateMedia",
        value: function updateMedia(url, file) {
            return this.http.post(url, file);
        }
    }, {
        key: "deleteMedia",
        value: function deleteMedia(url) {
            var _this9 = this;

            return this.http.post(url, {}).pipe(operators_1.catchError(function (error) {
                return _this9.messageService.catchErrorFromBackend(error);
            }));
        }
    }, {
        key: "getEditMedia",
        value: function getEditMedia(url) {
            var _this10 = this;

            return this.http.get(url).pipe(operators_1.catchError(function (error) {
                return _this10.messageService.catchErrorFromBackend(error);
            }));
        }
    }, {
        key: "getActiveBrandId",
        value: function getActiveBrandId() {
            return localStorage.getItem('activeBrand');
        }
    }, {
        key: "setActivebrandId",
        value: function setActivebrandId(id) {
            localStorage.setItem('activeBrand', id.toString());
        }
    }, {
        key: "getBrands",
        value: function getBrands() {
            var _this11 = this;

            var url = '/api/user/brands/authorization';
            return this.http.get(url).pipe(operators_1.map(function (res) {
                return res.data;
            }), operators_1.map(function (res) {
                return _this11.successGetBrands(res);
            }), operators_1.catchError(function (error) {
                return _this11.messageService.catchErrorFromBackend(error);
            }));
        }
    }, {
        key: "successGetBrands",
        value: function successGetBrands(brands) {
            this.setBrandsData(brands);
            return brands;
        }
    }, {
        key: "brandsData",
        get: function get() {
            return this.brandsData$.asObservable();
        }
    }, {
        key: "brandsChange",
        get: function get() {
            return this.brandsChange$.asObservable();
        }
    }]);

    return BrandsDataServiceProvider;
}();
BrandsDataServiceProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [http_1.HttpClient, auth_tokens_service_1.AuthTokensService, message_service_1.MessageService])], BrandsDataServiceProvider);
exports.BrandsDataServiceProvider = BrandsDataServiceProvider;

/***/ }),

/***/ "./shared/services/brands/brands.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var BrandsServiceProvider = function () {
    function BrandsServiceProvider(messageService) {
        _classCallCheck(this, BrandsServiceProvider);

        this.messageService = messageService;
    }

    _createClass(BrandsServiceProvider, [{
        key: "validateBrandFields",
        value: function validateBrandFields(brandControls) {
            var nameField = brandControls.name.errors;
            var emailField = brandControls.email.errors;
            if (nameField && (nameField.required || nameField.whitespace)) {
                return this.showValidationError('Ahem!', 'Please enter a company name.');
            }
            if (emailField && emailField.required && emailField.whitespace) {
                return this.showValidationError('Ahem!', 'Please enter a company email address.');
            }
            if (emailField && emailField.invalidEmail) {
                this.messageService.showToaster('e_1', 'general');
            }
        }
    }, {
        key: "showValidationError",
        value: function showValidationError(title, text) {
            this.messageService.showErrorFromBackend(title, text);
        }
    }, {
        key: "createActionList",
        value: function createActionList(actions) {
            return Object.keys(actions);
        }
    }, {
        key: "createFormGroup",
        value: function createFormGroup(inputs, data) {
            var fbData = {};
            inputs.forEach(function (e) {
                fbData[e.formControlName] = [data[e.formControlName], e.validators];
            });
            return fbData;
        }
    }, {
        key: "createImportListToSave",
        value: function createImportListToSave(formGroup, checkBoxes) {
            var importList = [];
            Object.keys(formGroup.controls).forEach(function (control, groupIndex) {
                formGroup.controls[control].controls.forEach(function (control, checkboxIndex) {
                    if (control.value) {
                        importList.push(checkBoxes[groupIndex].children[checkboxIndex].controlName);
                    }
                });
            });
            return importList;
        }
    }, {
        key: "mapImportActions",
        value: function mapImportActions(importData) {
            var importActions = Object.keys(importData.availableDataToImport);
            var categories = this.createCheckboxGroups(importData, importActions);
            importActions.forEach(function (e) {
                if (importData.availableDataToImport[e].group === categories[0].title) {
                    categories[0].children.push({
                        title: importData.availableDataToImport[e].label,
                        isChecked: true,
                        controlName: e,
                        children: []
                    });
                }
            });
            return categories;
        }
    }, {
        key: "createCheckboxGroups",
        value: function createCheckboxGroups(importData, importActions) {
            var categories = [];
            var groups = new Set();
            importActions.forEach(function (e) {
                groups.add(importData.availableDataToImport[e].group);
            });
            groups.forEach(function (groupName) {
                categories.push({
                    title: groupName,
                    isChecked: true,
                    controlName: groupName,
                    children: []
                });
            });
            return categories;
        }
    }]);

    return BrandsServiceProvider;
}();
BrandsServiceProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [message_service_1.MessageService])], BrandsServiceProvider);
exports.BrandsServiceProvider = BrandsServiceProvider;

/***/ }),

/***/ "./shared/services/calendar-integration/calendar-integration.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var http_1 = __webpack_require__("./node_modules/@angular/common/esm5/http.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var Observable_1 = __webpack_require__("./node_modules/rxjs/Observable.js");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var throw_1 = __webpack_require__("./node_modules/rxjs/observable/throw.js");
var IntervalObservable_1 = __webpack_require__("./node_modules/rxjs/observable/IntervalObservable.js");
var rxjs_1 = __webpack_require__("./node_modules/rxjs/Rx.js");
var CalendarIntegrationProvider = function () {
    function CalendarIntegrationProvider(http, messageService) {
        _classCallCheck(this, CalendarIntegrationProvider);

        this.http = http;
        this.messageService = messageService;
        this.googleActivationCode$ = new rxjs_1.BehaviorSubject(null);
        this.lookGoogleIntegration$ = new rxjs_1.BehaviorSubject(null);
        this.isIntegrated$ = new rxjs_1.BehaviorSubject(null);
    }

    _createClass(CalendarIntegrationProvider, [{
        key: "setGoogleActivationCode",
        value: function setGoogleActivationCode(code) {
            this.googleActivationCode$.next(code);
        }
    }, {
        key: "setLookGoogleIntegration",
        value: function setLookGoogleIntegration(lookIntegration) {
            this.lookGoogleIntegration$.next(lookIntegration);
        }
    }, {
        key: "setIsIntegrated",
        value: function setIsIntegrated(isIntegrated) {
            this.isIntegrated$.next(isIntegrated);
        }
    }, {
        key: "getActivatedCalendar",
        value: function getActivatedCalendar() {
            var _this = this;

            var url = '/api/user/v1/calendar/check';
            return this.http.get(url).pipe(operators_1.catchError(function (err) {
                return _this.handleError(err);
            }));
        }
    }, {
        key: "synchronizeGoogleCalendar",
        value: function synchronizeGoogleCalendar() {
            var _this2 = this;

            var url = '/api/user/v1/calendar/synchronize';
            return this.http.post(url, {}).pipe(operators_1.catchError(function (err) {
                return _this2.handleError(err);
            }));
        }
    }, {
        key: "updateGoogleCalendarStatus",
        value: function updateGoogleCalendarStatus(data) {
            var _this3 = this;

            var url = '/protected/rest/calendar/update';
            return this.http.post(url, {
                message: data
            }).pipe(operators_1.catchError(function (err) {
                return _this3.handleError(err);
            }));
        }
    }, {
        key: "connectGoogleCalendar",
        value: function connectGoogleCalendar() {
            var _this4 = this;

            var url = '/protected/rest/calendar/';
            return this.http.get(url).pipe(operators_1.catchError(function (err) {
                return _this4.handleError(err);
            }));
        }
    }, {
        key: "disconnectGoogleCalendar",
        value: function disconnectGoogleCalendar() {
            var _this5 = this;

            var url = '/api/user/calendar/disconnect/google';
            return this.http.request('delete', url).pipe(operators_1.catchError(function (err) {
                return _this5.handleError(err);
            }));
        }
    }, {
        key: "calendarInterval",
        value: function calendarInterval() {
            var _this6 = this;

            var url = '/api/user/v1/calendar/check';
            return IntervalObservable_1.IntervalObservable.create(5000).takeWhile(function () {
                return _this6.calendarStatusTimer;
            }).flatMap(function () {
                return _this6.http.get(url);
            }).switchMap(function (value) {
                return Observable_1.Observable.of(value).map(function (result) {
                    if (result.data.state === 'NO_INTEGRATED') {
                        throw new Error('Integration error');
                    }
                    return result;
                });
            }).catch(function (error) {
                return _this6.handleError(error);
            });
        }
    }, {
        key: "stopCalendarInterval",
        value: function stopCalendarInterval() {
            this.calendarStatusTimer = false;
        }
    }, {
        key: "startCalendarinterval",
        value: function startCalendarinterval() {
            this.calendarStatusTimer = true;
        }
    }, {
        key: "handleError",
        value: function handleError(error) {
            this.stopCalendarInterval();
            this.messageService.showDefaultErrorMessage(error);
            return throw_1._throw(error);
        }
    }, {
        key: "getGoogleActivationCode",
        get: function get() {
            return this.googleActivationCode$.asObservable();
        }
    }, {
        key: "getLookGoogleIntegration",
        get: function get() {
            return this.lookGoogleIntegration$.asObservable();
        }
    }, {
        key: "getIsIntegrated",
        get: function get() {
            return this.isIntegrated$.asObservable();
        }
    }]);

    return CalendarIntegrationProvider;
}();
CalendarIntegrationProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [http_1.HttpClient, message_service_1.MessageService])], CalendarIntegrationProvider);
exports.CalendarIntegrationProvider = CalendarIntegrationProvider;

/***/ }),

/***/ "./shared/services/calendar/calendar-events.data.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var common_1 = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
var http_1 = __webpack_require__("./node_modules/@angular/common/esm5/http.js");
var CalendarEventsDataProvider = function () {
    function CalendarEventsDataProvider(http, datePipe) {
        _classCallCheck(this, CalendarEventsDataProvider);

        this.http = http;
        this.datePipe = datePipe;
        this.CALENDAR_EVENTS_URL = '/protected/rest/calendar/event';
    }

    _createClass(CalendarEventsDataProvider, [{
        key: "createEvent",
        value: function createEvent(appointment) {
            var url = this.CALENDAR_EVENTS_URL + "/new";
            return this.http.post(url, appointment);
        }
    }, {
        key: "updateEvent",
        value: function updateEvent(appointment) {
            var url = this.CALENDAR_EVENTS_URL + "/update";
            return this.http.post(url, appointment);
        }
    }, {
        key: "deleteEvent",
        value: function deleteEvent(eventId) {
            var url = this.CALENDAR_EVENTS_URL + "/delete?id=" + eventId;
            return this.http.post(url, null);
        }
    }, {
        key: "getEventsForPage",
        value: function getEventsForPage(start, end, format) {
            var url = '/protected/rest/calendar/events';
            var params = new http_1.HttpParams();
            params = params.append('start', this.datePipe.transform(start, format));
            params = params.append('end', this.datePipe.transform(end, format));
            return this.http.get(url, { params: params });
        }
    }]);

    return CalendarEventsDataProvider;
}();
CalendarEventsDataProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [http_1.HttpClient, common_1.DatePipe])], CalendarEventsDataProvider);
exports.CalendarEventsDataProvider = CalendarEventsDataProvider;

/***/ }),

/***/ "./shared/services/calendar/calendar.models/calendar.models.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
exports.fullDaysOfWeek = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
exports.shortDaysOfWeek = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
exports.oneLetterDaysOfWeek = ['M', 'T', 'W', 'T', 'F', 'S', 'S'];
exports.shortMonthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/***/ }),

/***/ "./shared/services/calendar/calendar.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var time_service_1 = __webpack_require__("./shared/services/helpers/time-service/time.service.ts");
var Observable_1 = __webpack_require__("./node_modules/rxjs/Observable.js");
var BehaviorSubject_1 = __webpack_require__("./node_modules/rxjs/BehaviorSubject.js");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var appointment_service_1 = __webpack_require__("./shared/services/tasks/appointment.service.ts");
var workflow_service_1 = __webpack_require__("./shared/services/workflow/workflow-service/workflow.service.ts");
var extra_shoot_service_1 = __webpack_require__("./shared/services/tasks/extra-shoot.service.ts");
var calendar_models_1 = __webpack_require__("./shared/services/calendar/calendar.models/calendar.models.ts");
var CalendarServiceProvider = function () {
    function CalendarServiceProvider(timeService, appointmentService, workflowService, extraShootService) {
        _classCallCheck(this, CalendarServiceProvider);

        this.timeService = timeService;
        this.appointmentService = appointmentService;
        this.workflowService = workflowService;
        this.extraShootService = extraShootService;
        this.weekFirstSubject = new BehaviorSubject_1.BehaviorSubject(null);
        this.addNewEvent = new BehaviorSubject_1.BehaviorSubject(null);
        this.editEvent = new BehaviorSubject_1.BehaviorSubject(null);
        this.selectedDateTime = new BehaviorSubject_1.BehaviorSubject(null);
        this.updateCalendarView = new Subject_1.Subject();
        this.fullDaysData = new BehaviorSubject_1.BehaviorSubject(null);
        this.shortDaysData = new BehaviorSubject_1.BehaviorSubject(null);
        this.oneLetterDaysData = new BehaviorSubject_1.BehaviorSubject(null);
    }

    _createClass(CalendarServiceProvider, [{
        key: "emitAddNewEvent",
        value: function emitAddNewEvent(eventData) {
            this.addNewEvent.next(eventData);
        }
    }, {
        key: "emitEditEvent",
        value: function emitEditEvent(eventData) {
            this.editEvent.next(eventData);
        }
    }, {
        key: "emitSelectedDateTime",
        value: function emitSelectedDateTime(dateTime) {
            this.selectedDateTime.next(dateTime);
        }
    }, {
        key: "emitUpdateCalendarViewEvent",
        value: function emitUpdateCalendarViewEvent(value) {
            this.updateCalendarView.next(value);
        }
    }, {
        key: "fillCalendarFilter",
        value: function fillCalendarFilter(eventsData) {
            var _this = this;

            var data = JSON.parse(JSON.stringify(eventsData), this.timeService.parseDateFromJSON);
            data.sort(function (prevItem, nextItem) {
                var prevItemVal = prevItem.startTime !== null ? _this.timeService.getHour(prevItem.startTime) : 1000;
                var nexItemVal = nextItem.startTime !== null ? _this.timeService.getHour(nextItem.startTime) : 1000;
                return prevItemVal - nexItemVal;
            });
            return data;
        }
    }, {
        key: "chooseEventModal",
        value: function chooseEventModal(event) {
            var _this2 = this;

            if (!event) {
                return Observable_1.Observable.of('');
            }
            switch (event.calendarEventType) {
                case 'MAIN_SHOOT':
                    return event.inLead ? Observable_1.Observable.of('LEAD') : Observable_1.Observable.of('JOB');
                case 'APPOINTMENT':
                    return this.appointmentService.prepareAppointmentToShow(event).map(function (appointment) {
                        _this2.workflowService.setTaskInfo(appointment);
                        return 'APPOINTMENT';
                    });
                case 'EXTRA_SHOOT':
                    var extraShoot = this.extraShootService.prepareExtraShootToShow(event);
                    this.workflowService.setTaskInfo(extraShoot);
                    return Observable_1.Observable.of('EXTRA_SHOOT');
                default:
                    console.error('Unknown event type');
                    return Observable_1.Observable.of('');
            }
        }
    }, {
        key: "isCorrectDate",
        value: function isCorrectDate(event, day) {
            // check if it's correct start date
            if (this.parseCorrectStartDate(event.startDate, day)) {
                // check if it's correct end date
                return this.parseCorrectEndDate(event.endDate, day);
            }
            return false;
        }
    }, {
        key: "noCurrentDate",
        value: function noCurrentDate(firstDate, secondDate) {
            var tdClass = '';
            if (firstDate.getMonth() !== secondDate.getMonth()) {
                tdClass = 'no-curent-date';
            } else {
                var date = new Date();
                var today = date.toString().slice(0, 15),
                    selectDay = firstDate.toString().slice(0, 15);
                if (today === selectDay) {
                    tdClass = 'curent-date';
                }
            }
            return tdClass;
        }
    }, {
        key: "isCorrectHours",
        value: function isCorrectHours(event, time) {
            var HUNDRED = 100;
            var DEFAULT_TIME = 0;
            var ieStartHour = this.timeService.getHour(event.startTime);
            var ieStartMinutes = this.timeService.getMinutes(event.startTime) / HUNDRED;
            var ieTimeStart = ieStartHour + ieStartMinutes || DEFAULT_TIME;
            var ieEndHour = this.timeService.getHour(event.endTime);
            var ieEndMinutes = this.timeService.getMinutes(event.endTime) / HUNDRED;
            var ieTimeEnd = ieEndHour + ieEndMinutes || DEFAULT_TIME;
            var eventEndDateArr = this.timeService.date2Array(event.endDate);
            var ieEndDay = eventEndDateArr.day,
                ieEndMonth = eventEndDateArr.month;

            var dateTmp = time.getDate();
            var tmpMonth = time.getMonth();
            var hourTmp = time.getHours();
            var isCorrectHourStart = hourTmp >= ieStartHour;
            var _e1 = hourTmp <= ieEndHour && ieTimeEnd > ieTimeStart;
            var _e2 = dateTmp < ieEndDay && hourTmp === ieEndHour && ieTimeStart > ieTimeEnd;
            var _e3 = tmpMonth < ieEndMonth;
            var isCorrectHourEnd = _e1 || _e2 || _e3;
            return isCorrectHourStart && isCorrectHourEnd;
        }
    }, {
        key: "parseCorrectStartDate",
        value: function parseCorrectStartDate(eventStartDate, calendarDate) {
            var eventStartDateArr = this.timeService.date2Array(eventStartDate);
            var startYear = eventStartDateArr.year,
                startMonth = eventStartDateArr.month,
                startDay = eventStartDateArr.day;
            var calendarYear = calendarDate.year,
                calendarMonth = calendarDate.month,
                calendarDay = calendarDate.day;

            var isEventStartInPastMonth = calendarMonth > startMonth;
            var isEventStartInCurrentOrPastYear = calendarYear >= startYear;
            var isEventStartBeforeCurrentDate = isEventStartInPastMonth && isEventStartInCurrentOrPastYear;
            var isEventStartInCurrentMonth = calendarMonth === startMonth;
            var isEventStartOnCurrentDayOrBefore = calendarDay >= startDay;
            var isEventStartOnCurrentDate = isEventStartInCurrentMonth && isEventStartOnCurrentDayOrBefore;
            var isEventStartInPastYear = calendarYear > startYear;
            return isEventStartBeforeCurrentDate || isEventStartOnCurrentDate || isEventStartInPastYear;
        }
    }, {
        key: "parseCorrectEndDate",
        value: function parseCorrectEndDate(eventDate, calendarDate) {
            var eventEndDateArr = this.timeService.date2Array(eventDate);
            var endYear = eventEndDateArr.year,
                endMonth = eventEndDateArr.month,
                endDay = eventEndDateArr.day;
            var calendarYear = calendarDate.year,
                calendarMonth = calendarDate.month,
                calendarDay = calendarDate.day;

            var isEventEndInNextMonth = calendarMonth < endMonth;
            var isEventEndInCurrentOrNextYear = calendarYear <= endYear;
            var isEventEndAfterCurrentDate = isEventEndInNextMonth && isEventEndInCurrentOrNextYear;
            var isEventEndInCurrentMonth = calendarMonth === endMonth;
            var isEventEndOnCurrentDayOrAfter = calendarDay <= endDay;
            var isEventEndOnCurrentDate = isEventEndInCurrentMonth && isEventEndOnCurrentDayOrAfter;
            var isEventEndInNextYear = calendarYear < endYear;
            return isEventEndAfterCurrentDate || isEventEndOnCurrentDate || isEventEndInNextYear;
        }
    }, {
        key: "modifyWeekArrays",
        value: function modifyWeekArrays(quantity) {
            var _fullDays, _shortDays, _oneLetterDays;

            var rightPart = this.fullDays.splice(this.fullDays.length - quantity, this.fullDays.length);
            (_fullDays = this.fullDays).unshift.apply(_fullDays, _toConsumableArray(rightPart));
            rightPart = this.shortDays.splice(this.shortDays.length - quantity, this.shortDays.length);
            (_shortDays = this.shortDays).unshift.apply(_shortDays, _toConsumableArray(rightPart));
            rightPart = this.oneLetterDays.splice(this.oneLetterDays.length - quantity, this.oneLetterDays.length);
            (_oneLetterDays = this.oneLetterDays).unshift.apply(_oneLetterDays, _toConsumableArray(rightPart));
        }
    }, {
        key: "fullDaysOfWeek",
        get: function get() {
            return this.fullDaysData.asObservable();
        }
    }, {
        key: "shortDaysOfWeek",
        get: function get() {
            return this.shortDaysData.asObservable();
        }
    }, {
        key: "oneLetterDaysOfWeek",
        get: function get() {
            return this.oneLetterDaysData.asObservable();
        }
    }, {
        key: "firstDayOfWeek",
        set: function set(weekStartsOn) {
            this.fullDays = JSON.parse(JSON.stringify(calendar_models_1.fullDaysOfWeek));
            this.shortDays = JSON.parse(JSON.stringify(calendar_models_1.shortDaysOfWeek));
            this.oneLetterDays = JSON.parse(JSON.stringify(calendar_models_1.oneLetterDaysOfWeek));
            switch (weekStartsOn) {
                case 'SATURDAY':
                    this.modifyWeekArrays(2);
                    break;
                case 'SUNDAY':
                    this.modifyWeekArrays(1);
                    break;
                default:
                    break;
            }
            this.fullDaysData.next(this.fullDays);
            this.shortDaysData.next(this.shortDays);
            this.oneLetterDaysData.next(this.oneLetterDays);
        }
    }, {
        key: "shortMonthNames",
        get: function get() {
            return calendar_models_1.shortMonthNames;
        }
    }, {
        key: "weekFirstObservable",
        get: function get() {
            return this.weekFirstSubject.asObservable();
        }
    }, {
        key: "weekFirst",
        get: function get() {
            return this.week;
        },
        set: function set(date) {
            this.week = date;
            this.weekFirstSubject.next(date);
        }
    }, {
        key: "newEventObservable",
        get: function get() {
            return this.addNewEvent.asObservable();
        }
    }, {
        key: "editEventObservable",
        get: function get() {
            return this.editEvent.asObservable();
        }
    }, {
        key: "selectedDateTimeObservable",
        get: function get() {
            return this.selectedDateTime.asObservable();
        }
    }, {
        key: "updateCalendarViewObservable",
        get: function get() {
            return this.updateCalendarView.asObservable();
        }
    }]);

    return CalendarServiceProvider;
}();
CalendarServiceProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [time_service_1.TimeServiceProvider, appointment_service_1.AppointmentServiceProvider, workflow_service_1.WorkflowProvider, extra_shoot_service_1.ExtraShootServiceProvider])], CalendarServiceProvider);
exports.CalendarServiceProvider = CalendarServiceProvider;

/***/ }),

/***/ "./shared/services/client/client.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var validation_service_1 = __webpack_require__("./shared/services/helpers/validation.service.ts");
var ClientServiceProvider = function () {
    function ClientServiceProvider(messageService, validationService) {
        _classCallCheck(this, ClientServiceProvider);

        this.messageService = messageService;
        this.validationService = validationService;
    }

    _createClass(ClientServiceProvider, [{
        key: "validateClient",
        value: function validateClient(client) {
            if (this.validationService.isStringEmpty(client.email.trim())) {
                this.messageService.showToaster('e_1', 'clients');
                return false;
            }
            if (this.validationService.isStringEmpty(client.firstName.trim())) {
                this.messageService.showToaster('e_4', 'clients');
                return false;
            }
            if (!client.companyNameChecked) {
                delete client.companyName;
                delete client.businessNumber;
            }
            var clientToSave = Object.assign({}, client);
            var lowercasedEmail = clientToSave.email.toLowerCase();
            clientToSave.email = lowercasedEmail;
            return clientToSave;
        }
    }, {
        key: "errorSaveClient",
        value: function errorSaveClient(error, client) {
            var status = error.status,
                data = error.data;

            var errorMessage = data.errorMessage;
            var errorCode = void 0,
                errorPlace = void 0,
                value = void 0;
            if (status >= 400 && status < 500 && errorMessage) {
                if (errorMessage === 'Job contact cannot be changed because invoice has Xero payment') {
                    errorCode = 'e_10';
                    errorPlace = 'xero';
                } else if (errorMessage.includes('already registered')) {
                    errorCode = 'e_8';
                    errorPlace = 'clients';
                    value = client.email;
                } else if (errorMessage === 'Your QuickBooks company already contains client with such name') {
                    errorCode = 'e_6';
                    errorPlace = 'qb';
                } else {
                    errorCode = 'e_2';
                    errorPlace = 'general';
                    value = errorMessage;
                }
            } else {
                errorCode = 'e_0';
                errorPlace = 'general';
            }
            this.messageService.showToaster(errorCode, errorPlace, value);
        }
    }, {
        key: "fillClientSearchText",
        value: function fillClientSearchText(client) {
            var email = client.email,
                firstName = client.firstName,
                id = client.id,
                _client$lastName = client.lastName,
                lastName = _client$lastName === undefined ? ' ' : _client$lastName;

            lastName = lastName === null ? ' ' : lastName;
            return {
                id: id,
                name: firstName + " " + lastName + " (" + email + ")"
            };
        }
    }]);

    return ClientServiceProvider;
}();
ClientServiceProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [message_service_1.MessageService, validation_service_1.ValidationProvider])], ClientServiceProvider);
exports.ClientServiceProvider = ClientServiceProvider;

/***/ }),

/***/ "./shared/services/client/clients.data.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var http_1 = __webpack_require__("./node_modules/@angular/common/esm5/http.js");
var BehaviorSubject_1 = __webpack_require__("./node_modules/rxjs/BehaviorSubject.js");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var ClientsDataServiceProvider = function () {
    function ClientsDataServiceProvider(http) {
        var _this = this;

        _classCallCheck(this, ClientsDataServiceProvider);

        this.http = http;
        this.CLIENTS_URL = '/protected/rest/clients/v2';
        this.CLIENT_VIEW_URL = '/protected/rest/clients';
        this.newClient = new BehaviorSubject_1.BehaviorSubject(false);
        this.updatedClient = new Subject_1.Subject();
        this.addNewClient = function (client) {
            var url = '/protected/rest/clients/add';
            return _this.http.post(url, client);
        };
        this.updateClient = function (client) {
            var url = '/protected/rest/clients/update';
            return _this.http.post(url, client);
        };
        this.searchClient = function (searchClient) {
            var url = '/protected/rest/job/client/search';
            var params = new http_1.HttpParams();
            params = params.append('search', searchClient);
            return _this.http.get(url, { params: params });
        };
        this.deleteClient = function (clientId) {
            var url = "/api/user/v1/clients/" + clientId + "/delete";
            return _this.http.delete(url);
        };
        this.changeClientSubscription = function (contact) {
            var subscribe = { value: contact.status !== 'SUBSCRIBED' };
            var url = "/api/user/client/" + contact.id + "/subscription";
            return _this.http.post(url, subscribe);
        };
        this.checkBeforeDelete = function (clientId) {
            var url = "/api/user/v1/clients/" + clientId + "/validate-for-delete";
            return _this.http.get(url);
        };
        this.saveOptIn = function (clientId, statement) {
            var url = '/api/user/consent/';
            return _this.http.post(url, {
                contactId: clientId,
                text: statement
            });
        };
        this.deleteConsent = function (contactId, consentId) {
            var url = '/api/user/consent/';
            return _this.http.request('delete', url, {
                body: {
                    contactId: contactId,
                    consentId: consentId
                }
            });
        };
    }

    _createClass(ClientsDataServiceProvider, [{
        key: "emitClient",
        value: function emitClient(client) {
            return this.newClient.next(JSON.parse(JSON.stringify(client)));
        }
    }, {
        key: "emitUpdateClientEvent",
        value: function emitUpdateClientEvent(data) {
            return this.updatedClient.next(data);
        }
    }, {
        key: "getClient",
        value: function getClient(clientId) {
            var url = this.CLIENT_VIEW_URL + "/client";
            var params = new http_1.HttpParams().set('id', clientId);
            return this.http.get(url, { params: params });
        }
    }, {
        key: "getClientsOnPage",
        value: function getClientsOnPage(pageRequest, status) {
            var perPage = pageRequest.perPage,
                page = pageRequest.page,
                _pageRequest$pageOrde = pageRequest.pageOrder,
                predicate = _pageRequest$pageOrde.predicate,
                reverse = _pageRequest$pageOrde.reverse,
                search = pageRequest.search;

            var url = this.CLIENTS_URL;
            var params = new http_1.HttpParams();
            params = params.append('perPage', perPage);
            params = params.append('page', page);
            params = params.append('predicate', predicate);
            params = params.append('reverse', reverse);
            params = params.append('search', search);
            params = params.append('status', status);
            return this.http.get(url, { params: params });
        }
    }, {
        key: "clientObservable",
        get: function get() {
            return this.newClient.asObservable();
        }
    }, {
        key: "updatedClientEvent",
        get: function get() {
            return this.updatedClient.asObservable();
        }
    }]);

    return ClientsDataServiceProvider;
}();
ClientsDataServiceProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [http_1.HttpClient])], ClientsDataServiceProvider);
exports.ClientsDataServiceProvider = ClientsDataServiceProvider;

/***/ }),

/***/ "./shared/services/contract/contracts-service/contracts.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var email_service_1 = __webpack_require__("./shared/services/email/email-service/email.service.ts");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var mails_data_service_1 = __webpack_require__("./shared/services/email/mails.data.service.ts");
var stringModifier_service_1 = __webpack_require__("./shared/services/helpers/string-modifier-service/stringModifier.service.ts");
var ContractsServiceProvider = function () {
    function ContractsServiceProvider(emailService, messageService, mailsDataService, stringModifierService) {
        _classCallCheck(this, ContractsServiceProvider);

        this.emailService = emailService;
        this.messageService = messageService;
        this.mailsDataService = mailsDataService;
        this.stringModifierService = stringModifierService;
    }

    _createClass(ContractsServiceProvider, [{
        key: "setDefaultEmail",
        value: function setDefaultEmail(emails) {
            if (emails !== undefined && emails !== null && emails.length) {
                return emails.find(function (item) {
                    return item.emailTemplateType === 'CONTRACT_EMAIL_TEMPLATE';
                }) || {};
            }
            return null;
        }
    }, {
        key: "errorSendMessage",
        value: function errorSendMessage(result) {
            var error = result.error;
            var errorTitle = error.errorTitle,
                errorMessage = error.errorMessage;

            this.messageService.showErrorFromBackend(errorTitle, errorMessage);
        }
    }, {
        key: "successSendEmail",
        value: function successSendEmail() {
            this.messageService.showToaster('s_4', 'jobView');
            this.mailsDataService.emitMailUpdateEvent(true);
        }
    }, {
        key: "gatherDataToSendContract",
        value: function gatherDataToSendContract(data, isNew) {
            var messageData = data.messageData,
                contract = data.contract,
                jobId = data.jobId,
                mailData = data.mailData;
            var attachmentsData = messageData.attachmentsData;

            var _emailService$prepare = this.emailService.prepareAttachments(attachmentsData),
                storedFiles = _emailService$prepare.storedFiles,
                uploadedFiles = _emailService$prepare.uploadedFiles;

            var sendMessageData = void 0;
            if (isNew) {
                sendMessageData = this.prepareNewContractMailToSend(messageData, jobId, mailData, contract);
            } else {
                sendMessageData = this.prepareExistingContractMailToSend(messageData, contract, jobId, mailData);
            }
            return {
                sendMessageData: sendMessageData,
                storedFiles: storedFiles,
                uploadedFiles: uploadedFiles
            };
        }
    }, {
        key: "prepareContractToSave",
        value: function prepareContractToSave(updatedContract, chosenContract, currentContractId) {
            var contract = void 0;
            if (updatedContract) {
                contract = updatedContract;
                if (currentContractId === updatedContract.id) {
                    updatedContract.contractId = currentContractId;
                }
            } else {
                contract = chosenContract;
            }
            if (contract && contract.name) {
                contract.name = this.stringModifierService.cutSelectedText(contract.name);
            }
            return contract;
        }
    }, {
        key: "checkContractOptIn",
        value: function checkContractOptIn(contractToSave) {
            /* Fix changed field for GDPR */
            if (contractToSave.optInConsentStatement) {
                contractToSave.optInConsent = contractToSave.optInConsentStatement;
                delete contractToSave.optInConsentStatement;
            }
            /*
              Fix backend grammar mistake
              showOTPinconsent => showOPTinconsent
               */
            if (contractToSave.showOtpInConsent) {
                contractToSave.showOptInConsent = contractToSave.showOtpInConsent;
                delete contractToSave.showOtpInConsen;
            }
            return contractToSave;
        }
    }, {
        key: "contractTextValid",
        value: function contractTextValid(html) {
            var text = new DOMParser().parseFromString(html, 'text/html').body.textContent;
            if (!text || text === 'null' || text && !text.trim()) {
                this.messageService.showErrorFromBackend('Whoops, something has gone wrong!', 'Contract should have text');
                return false;
            }
            return true;
        }
    }, {
        key: "prepareExistingContractMailToSend",
        value: function prepareExistingContractMailToSend(messageData, contract, jobId, mailData) {
            var result = {
                emailTo: messageData.emailTo,
                emailText: messageData.emailText || '',
                emailSubject: messageData.emailSubject,
                contractText: contract.text,
                contractId: contract.id,
                jobId: jobId,
                templateId: mailData.chosenEmail.id
            };
            if (messageData.secondaryToEmails && messageData.secondaryToEmails.length) {
                result.secondaryToEmails = messageData.secondaryToEmails;
            }
            if (messageData.ccEmails && messageData.ccEmails.length) {
                result.ccEmails = messageData.ccEmails;
            }
            return result;
        }
    }, {
        key: "prepareNewContractMailToSend",
        value: function prepareNewContractMailToSend(messageData, jobId, mailData, updatedContract) {
            var contract2Save = updatedContract ? updatedContract.text : mailData.chosenContract.text;
            var result = {
                emailTo: messageData.emailTo,
                emailText: messageData.emailText || '',
                emailSubject: messageData.emailSubject,
                contractId: mailData.chosenContract ? mailData.chosenContract.templateId : null,
                jobId: jobId,
                templateId: mailData.chosenEmail.id
            };
            if (contract2Save) {
                result.contractText = contract2Save;
            }
            if (messageData.secondaryToEmails && messageData.secondaryToEmails.length) {
                result.secondaryToEmails = messageData.secondaryToEmails;
            }
            if (messageData.ccEmails && messageData.ccEmails.length) {
                result.ccEmails = messageData.ccEmails;
            }
            return result;
        }
    }]);

    return ContractsServiceProvider;
}();
ContractsServiceProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [email_service_1.EmailServiceProvider, message_service_1.MessageService, mails_data_service_1.MailsDataProvider, stringModifier_service_1.StringModifierServiceProvider])], ContractsServiceProvider);
exports.ContractsServiceProvider = ContractsServiceProvider;

/***/ }),

/***/ "./shared/services/contract/contracts.data.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = __webpack_require__("./node_modules/@angular/common/esm5/http.js");
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var BehaviorSubject_1 = __webpack_require__("./node_modules/rxjs/BehaviorSubject.js");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var ContractsDataProvider = function () {
    function ContractsDataProvider(http) {
        _classCallCheck(this, ContractsDataProvider);

        this.http = http;
        this.editableContract = new BehaviorSubject_1.BehaviorSubject(false);
        this.contractTextUpdate = new Subject_1.Subject();
    }

    _createClass(ContractsDataProvider, [{
        key: "emitContractToEdit",
        value: function emitContractToEdit(contract) {
            this.editableContract.next(contract);
        }
    }, {
        key: "emitContractUpdateEvent",
        value: function emitContractUpdateEvent(value) {
            this.contractTextUpdate.next(value);
        }
    }, {
        key: "getContract",
        value: function getContract(jobId, jobContractId) {
            var url = "/protected/rest/contracts/get/view/" + jobId + "/" + jobContractId;
            return this.http.get(url);
        }
    }, {
        key: "sendContractEmail",
        value: function sendContractEmail(data, isNew) {
            var url = isNew ? '/protected/rest/job/contract/save/' : '/protected/rest/job/contract/send';
            var sendMessageData = data.sendMessageData,
                storedFiles = data.storedFiles,
                uploadedFiles = data.uploadedFiles;

            var formData = new FormData();
            for (var key in sendMessageData) {
                if (key !== 'attachmentsData') {
                    formData.append(key, sendMessageData[key]);
                }
            }
            for (var _key in storedFiles) {
                formData.append("storedAttachments[" + _key + "]", storedFiles[_key].id);
            }
            for (var _key2 in uploadedFiles) {
                formData.append("attachments[" + _key2 + "]", uploadedFiles[_key2]);
            }
            return this.sendContractRequest(url, formData);
        }
    }, {
        key: "sendContractRequest",
        value: function sendContractRequest(url, formData) {
            return this.http.post(url, formData);
        }
    }, {
        key: "deleteContract",
        value: function deleteContract(id) {
            var url = "/protected/rest/contracts/view/delete/" + id;
            return this.http.post(url, {});
        }
    }, {
        key: "addPhotographerSignature",
        value: function addPhotographerSignature(data) {
            var url = '/protected/rest/contract/photographer/signature';
            return this.http.post(url, data);
        }
    }, {
        key: "editContract",
        value: function editContract(url, data) {
            return this.http.put(url, data);
        }
    }, {
        key: "getContractCpLink",
        value: function getContractCpLink(url, method) {
            return this.http[method.toLowerCase()](url);
        }
    }, {
        key: "overwriteContractTemplate",
        value: function overwriteContractTemplate(templateId, data) {
            var url = "/api/user/contract-template/" + templateId;
            return this.http.put(url, { data: data });
        }
    }, {
        key: "saveNewContractTemplate",
        value: function saveNewContractTemplate(data) {
            var url = '/api/user/contract-template';
            return this.http.post(url, { data: data });
        }
    }, {
        key: "editableContractObservable",
        get: function get() {
            return this.editableContract.asObservable();
        }
    }, {
        key: "shouldContractBeUpdatedObservable",
        get: function get() {
            return this.contractTextUpdate.asObservable();
        }
    }]);

    return ContractsDataProvider;
}();
ContractsDataProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [http_1.HttpClient])], ContractsDataProvider);
exports.ContractsDataProvider = ContractsDataProvider;

/***/ }),

/***/ "./shared/services/dashboard/dashboard.data.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = __webpack_require__("./node_modules/@angular/common/esm5/http.js");
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var DashboardDataServiceProvider = function () {
    function DashboardDataServiceProvider(http) {
        _classCallCheck(this, DashboardDataServiceProvider);

        this.http = http;
    }

    _createClass(DashboardDataServiceProvider, [{
        key: "getShootsAppointmentsData",
        value: function getShootsAppointmentsData(paginationRules) {
            var url = '/api/user/v1/events';
            return this.http.post(url, paginationRules);
        }
    }, {
        key: "getUpcomingPaymentsData",
        value: function getUpcomingPaymentsData(paginationRules) {
            var url = '/api/user/v1/payment';
            return this.http.post(url, paginationRules);
        }
    }]);

    return DashboardDataServiceProvider;
}();
DashboardDataServiceProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [http_1.HttpClient])], DashboardDataServiceProvider);
exports.DashboardDataServiceProvider = DashboardDataServiceProvider;

/***/ }),

/***/ "./shared/services/data-services/templates-data-service/templates.data.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var http_1 = __webpack_require__("./node_modules/@angular/common/esm5/http.js");
var TemplatesDataProvider = function () {
    function TemplatesDataProvider(http) {
        _classCallCheck(this, TemplatesDataProvider);

        this.http = http;
        this.templates = {};
    }

    _createClass(TemplatesDataProvider, [{
        key: "getLink",
        value: function getLink(templateType, id) {
            var url = '';
            switch (templateType) {
                case 'all':
                    url = '/protected/rest/email_templates/get';
                    break;
                case 'contract_preview':
                    url = '/protected/rest/job/contract/sources';
                    break;
                case 'questionnaire_preview':
                    url = '/protected/rest/job/questionnaire/sources';
                    break;
                case 'general_preview':
                    url = '/protected/rest/email_templates/get/general';
                    break;
                case 'contract_full':
                    url = "/protected/rest/contracts/get/" + id;
                    break;
                case 'full_template':
                    url = "/protected/rest/settings/email_template/get/" + id + "?forSend=true";
                    break;
                case 'template_without_signature':
                    url = "/protected/rest/settings/email_template/get/" + id + "?forSend=false";
                    break;
                case 'email_signature':
                    url = '/protected/rest/email_templates/signature/get';
                    break;
                default:
                    break;
            }
            return url;
        }
    }, {
        key: "setTemplatesInStorage",
        value: function setTemplatesInStorage(data) {
            this.templates = JSON.parse(JSON.stringify(data));
        }
    }, {
        key: "getTemplatesFromStorage",
        value: function getTemplatesFromStorage() {
            return JSON.parse(JSON.stringify(this.templates));
        }
    }, {
        key: "getTemplates",
        value: function getTemplates(templateType) {
            var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            var url = this.getLink(templateType, id);
            return this.http.get(url);
        }
    }]);

    return TemplatesDataProvider;
}();
TemplatesDataProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [http_1.HttpClient])], TemplatesDataProvider);
exports.TemplatesDataProvider = TemplatesDataProvider;

/***/ }),

/***/ "./shared/services/double-booking/double-booking.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var color_service_1 = __webpack_require__("./shared/services/utils/color.service.ts");
var settings_1 = __webpack_require__("./shared/services/settings/settings.ts");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var double_boooking_data_service_1 = __webpack_require__("./shared/services/double-booking/double-boooking.data.service.ts");
var moment = __webpack_require__("./node_modules/moment/moment.js");
var DoubleBookingService = function () {
    function DoubleBookingService(colorService, settingsService, doubleBookingDataService) {
        _classCallCheck(this, DoubleBookingService);

        this.colorService = colorService;
        this.settingsService = settingsService;
        this.doubleBookingDataService = doubleBookingDataService;
        this.DATE_PATTERN = 'YYYY_MM_DD';
        this.TIME_PATTERN = 'hh:mm:ss';
        this.DATE_PATTERN_SAVE = 'YYYY-MM-DD';
        this.TIME_PATTERN_SAVE = 'HH:mm:ss';
        this.getCalendarPreferences();
    }

    _createClass(DoubleBookingService, [{
        key: "getOverlappingEvents",
        value: function getOverlappingEvents(data, type, id) {
            var _this = this;

            return this.doubleBookingDataService.getOverlappingEvents(data, type, id).pipe(operators_1.map(function (res) {
                return res.data;
            }), operators_1.map(function (db) {
                return _this.mapDbResponse(db);
            }));
        }
    }, {
        key: "gatherDateTimeData",
        value: function gatherDateTimeData(_ref) {
            var startDate = _ref.startDate,
                finishDate = _ref.finishDate,
                startTime = _ref.startTime,
                finishTime = _ref.finishTime,
                allday = _ref.allday;

            var timePattern = this.bootstrapSettings.timeFormat === 'T_12' ? 'h:mm A' : this.TIME_PATTERN_SAVE;
            var parsedData = {
                startDate: moment(startDate).format(this.DATE_PATTERN_SAVE),
                endDate: moment(finishDate).format(this.DATE_PATTERN_SAVE)
            };
            if (!allday) {
                parsedData.startTime = moment(startTime, timePattern).format(this.TIME_PATTERN_SAVE);
                parsedData.endTime = moment(finishTime, timePattern).format(this.TIME_PATTERN_SAVE);
            }
            return parsedData;
        }
    }, {
        key: "sortBrands",
        value: function sortBrands(companiesList, data) {
            if (companiesList.length > 1) {
                return companiesList.sort(function (companyA, companyB) {
                    if (data.events[companyA][0].company.currentBrand) {
                        return -1;
                    }
                    if (data.events[companyB][0].company.currentBrand) {
                        return 1;
                    }
                    return companyA.localeCompare(companyB);
                });
            }
            return companiesList;
        }
    }, {
        key: "sortDoubleBookingEvents",
        value: function sortDoubleBookingEvents(data) {
            var _this2 = this;

            var companies = Object.keys(data.events);
            var sortedData = JSON.parse(JSON.stringify(data));
            companies.forEach(function (company) {
                if (sortedData.events[company].length > 1) {
                    sortedData.events[company] = sortedData.events[company].sort(_this2.sortEvents.bind(_this2));
                }
            });
            return sortedData;
        }
    }, {
        key: "parseEventsToShow",
        value: function parseEventsToShow(events) {
            var _this3 = this;

            var result = {
                titleText: null,
                events: {}
            };

            var _events$filter = events.filter(function (ev) {
                return ev.primaryEvent;
            }),
                _events$filter2 = _slicedToArray(_events$filter, 1),
                primaryEvent = _events$filter2[0];

            var datesSet = this.createNewDateSet(events, primaryEvent);
            var allDatesSet = this.createNewDateSet(events);
            var sortedDateRange = Array.from(datesSet).sort(function (a, b) {
                return moment(a).unix() - moment(b).unix();
            });
            var shouldShowDate = void 0;
            Array.from(allDatesSet).length === 1 ? shouldShowDate = false : shouldShowDate = true;
            result.titleText = this.generateDateRangeText(sortedDateRange);
            var newEvents = events.map(function (event) {
                return _this3.convertEventDataToShow(event, shouldShowDate);
            });
            this.groupEventsByBrand(newEvents, result);
            return result;
        }
    }, {
        key: "generateDateRangeText",
        value: function generateDateRangeText(sortedDateRange) {
            var start = moment(sortedDateRange[0], this.DATE_PATTERN).format(this.dateFormat);
            var end = moment(sortedDateRange[sortedDateRange.length - 1], this.DATE_PATTERN).format(this.dateFormat);
            if (sortedDateRange.length > 1) {
                return "Overlapping Events from " + start + " - " + end;
            } else if (sortedDateRange.length === 1) {
                return "Overlapping Events on " + start;
            }
            return 'Overlapping Events';
        }
    }, {
        key: "convertEventDataToShow",
        value: function convertEventDataToShow(event, shouldShowDate) {
            var _event$timePeriod = event.timePeriod,
                startDate = _event$timePeriod.startDate,
                finishDate = _event$timePeriod.finishDate,
                startTime = _event$timePeriod.startTime,
                finishTime = _event$timePeriod.finishTime;

            var parsedStartDate = '';
            var parsedFinishDate = '';
            var parsedTime = '';
            var daysAmount = '';
            if (startDate) {
                parsedStartDate += moment(startDate, this.DATE_PATTERN).format(this.dateFormat);
            }
            if (!startTime && !finishTime) {
                parsedTime += ' All day ';
            }
            if (startTime && finishTime) {
                parsedTime += " \n\t\t\t\t" + moment(startTime, this.TIME_PATTERN).format(this.timeFormat) + " - \n\t\t\t\t" + moment(finishTime, this.TIME_PATTERN).format(this.timeFormat) + "\n\t\t\t";
            }
            if (startDate !== finishDate) {
                var daysDiff = moment(finishDate, this.DATE_PATTERN).diff(moment(startDate, this.DATE_PATTERN), 'days');
                daysAmount += "(+" + daysDiff + ")";
                parsedFinishDate += moment(finishDate, this.DATE_PATTERN).format(this.dateFormat);
            }
            return Object.assign({}, event, { jobType: Object.assign({}, event.jobType, { shadedColor: this.colorService.shadeColor(event.jobType.hexColor, -20) }), parsedStartDate: parsedStartDate,
                parsedFinishDate: parsedFinishDate,
                parsedTime: parsedTime,
                daysAmount: daysAmount,
                shouldShowDate: shouldShowDate });
        }
    }, {
        key: "groupEventsByBrand",
        value: function groupEventsByBrand(parsedEvents, result) {
            parsedEvents.forEach(function (event) {
                var companyName = event.company.companyName;

                if (!result.events[companyName]) {
                    result.events[companyName] = [];
                }
                result.events[companyName].push(event);
            });
        }
    }, {
        key: "sortEvents",
        value: function sortEvents(prevEvent, nextEvent) {
            var prevTime = prevEvent.timePeriod;
            var nextTime = nextEvent.timePeriod;
            var isSameDays = prevTime.startDate === nextTime.startDate;
            var isAllDayAndTime = !prevTime.startTime && nextTime.startTime;
            var isTimeAndAllDay = prevTime.startTime && !nextTime.startTime;
            var isSameTime = prevTime.startTime === nextTime.startTime;
            var isPriorityEqual = prevEvent.priority === nextEvent.priority;
            if (!isSameDays) {
                return moment(prevTime.startDate, this.DATE_PATTERN).unix() - moment(nextTime.startDate, this.DATE_PATTERN).unix();
            }
            if (isSameDays) {
                if (isAllDayAndTime) {
                    return -1;
                }
                if (isTimeAndAllDay) {
                    return 1;
                }
                if (!isSameTime) {
                    return moment(prevTime.startTime, this.TIME_PATTERN).isBefore(moment(nextTime.startTime, this.TIME_PATTERN)) ? -1 : 1;
                }
                if (isSameTime) {
                    if (!isPriorityEqual) {
                        return prevEvent.priority < nextEvent.priority ? -1 : 1;
                    }
                    if (isPriorityEqual) {
                        return prevEvent.eventName.localeCompare(nextEvent.eventName);
                    }
                }
            }
        }
    }, {
        key: "getCalendarPreferences",
        value: function getCalendarPreferences() {
            var _this4 = this;

            this.settingsService.timeFormatSettings.pipe(operators_1.filter(function (settings) {
                return !!settings.dateFormat && !!settings.timeFormat;
            })).subscribe(function (data) {
                _this4.bootstrapSettings = data;
                _this4.dateFormat = data.dateFormat.replace('MM', 'MMM').replace(/_/g, ' ');
                _this4.timeFormat = data.timeFormat === 'T_12' ? 'h:mma' : 'H:mm';
            });
        }
    }, {
        key: "mapDbResponse",
        value: function mapDbResponse(db) {
            if (!db) {
                return db;
            }

            var _parseEventsToShow = this.parseEventsToShow(db.events),
                events = _parseEventsToShow.events;

            return Object.assign({}, db, { events: events });
        }
    }, {
        key: "createNewDateSet",
        value: function createNewDateSet(events, primaryEvent) {
            var datesSet = new Set();
            if (primaryEvent) {
                var _primaryEvent$timePer = primaryEvent.timePeriod,
                    startDate = _primaryEvent$timePer.startDate,
                    finishDate = _primaryEvent$timePer.finishDate;

                datesSet.add(startDate);
                events.forEach(function (event) {
                    if (startDate && finishDate && !event.primaryEvent) {
                        if (startDate === event.timePeriod.startDate) {
                            datesSet.add(event.timePeriod.startDate);
                        }
                        if (moment(startDate).isBefore(event.timePeriod.startDate)) {
                            datesSet.add(event.timePeriod.startDate);
                        }
                        if (finishDate === event.timePeriod.finishDate) {
                            datesSet.add(event.timePeriod.finishDate);
                        }
                        if (moment(event.timePeriod.finishDate).isBefore(finishDate)) {
                            datesSet.add(event.timePeriod.finishDate);
                        }
                    }
                });
            } else {
                events.forEach(function (event) {
                    datesSet.add(event.timePeriod.startDate);
                    datesSet.add(event.timePeriod.finishDate);
                });
            }
            return datesSet;
        }
    }]);

    return DoubleBookingService;
}();
DoubleBookingService = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [color_service_1.ColorService, settings_1.SettingsProvider, double_boooking_data_service_1.DoubleBookingDataService])], DoubleBookingService);
exports.DoubleBookingService = DoubleBookingService;

/***/ }),

/***/ "./shared/services/double-booking/double-boooking.data.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var http_1 = __webpack_require__("./node_modules/@angular/common/esm5/http.js");
var DoubleBookingDataService = function () {
    function DoubleBookingDataService(http) {
        _classCallCheck(this, DoubleBookingDataService);

        this.http = http;
    }

    _createClass(DoubleBookingDataService, [{
        key: "getOverlappingEvents",
        value: function getOverlappingEvents(timeData, type, id) {
            var url = '/api/user/calendar-events/overlapping';
            if (type === 'EVENT' && id) {
                url = "/api/user/calendar-events/" + id + "/overlapping";
            }
            if (type === 'JOB' && id) {
                url = "/api/user/v1/job/" + id + "/calendar-events/overlapping";
            }
            return this.http.post(url, timeData);
        }
    }]);

    return DoubleBookingDataService;
}();
DoubleBookingDataService = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [http_1.HttpClient])], DoubleBookingDataService);
exports.DoubleBookingDataService = DoubleBookingDataService;

/***/ }),

/***/ "./shared/services/email/email-service/email.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var appConstants_1 = __webpack_require__("./shared/models/appConstants.ts");
var random_string_generator_1 = __webpack_require__("./shared/services/helpers/random-string-generator.ts");
var utils_service_1 = __webpack_require__("./shared/services/utils/utils-service.ts");
var BehaviorSubject_1 = __webpack_require__("./node_modules/rxjs/BehaviorSubject.js");
var common_1 = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
var platform_browser_1 = __webpack_require__("./node_modules/@angular/platform-browser/esm5/platform-browser.js");
var validation_service_1 = __webpack_require__("./shared/services/helpers/validation.service.ts");
var EmailServiceProvider = function () {
    function EmailServiceProvider(messageService, validationService, randomStringGenerator, utilsService, datePipe, sanitizer) {
        _classCallCheck(this, EmailServiceProvider);

        this.messageService = messageService;
        this.validationService = validationService;
        this.randomStringGenerator = randomStringGenerator;
        this.utilsService = utilsService;
        this.datePipe = datePipe;
        this.sanitizer = sanitizer;
        this.emptyAttachmentsData = {
            attachments: [],
            filesSize: 0
        };
        this.emailFn = null;
        this.clientToCheckSubscription = new BehaviorSubject_1.BehaviorSubject(null);
        this.mailStyling = function (id) {
            var styleObj = {
                P: 'margin:0 0 2px;',
                LI: 'list-style-position: inside;',
                SPAN: 'padding:0;',
                DIV: 'margin:0;',
                BLOCKQUOTE: 'margin: 0 0 0 0.8ex; border-left: 1px #ccc solid; padding-left: 1ex;'
            };
            var allTags = document.getElementById(id).querySelectorAll('*');
            var i = 0;
            var max = allTags.length;
            for (; i < max; i += 1) {
                var thisTag = allTags[i];
                var tagInlineStyle = thisTag.getAttribute('style');
                var elementStyle = window.getComputedStyle(thisTag);
                var tagStyle = '';
                var textAlign = elementStyle.getPropertyValue('text-align');
                var color = elementStyle.getPropertyValue('color');
                var fontSize = elementStyle.getPropertyValue('font-size');
                var fontFamily = elementStyle.getPropertyValue('font-family');
                if (textAlign && tagInlineStyle && tagInlineStyle.includes('text-align')) {
                    tagStyle += "text-align:" + textAlign + ";";
                }
                if (color && tagInlineStyle && tagInlineStyle.includes('color')) {
                    tagStyle += "color:" + color + ";";
                }
                if (fontSize && tagInlineStyle && tagInlineStyle.includes('font-size')) {
                    tagStyle += "font-size:" + fontSize + "!important;font-size:" + fontSize + ";";
                } else {
                    tagStyle += 'font-size:14px!important;font-size:14px;';
                }
                if (fontFamily && tagInlineStyle && tagInlineStyle.includes('font-family')) {
                    tagStyle += "font-family:" + fontFamily + ";";
                }
                var thatTag = thisTag.tagName;
                tagStyle += styleObj[thatTag] || '';
                thisTag.setAttribute('style', tagStyle);
            }
        };
    }

    _createClass(EmailServiceProvider, [{
        key: "emitClientToCheckSubscription",
        value: function emitClientToCheckSubscription(client) {
            this.clientToCheckSubscription.next(client);
        }
    }, {
        key: "setMessageData",
        value: function setMessageData(data, client, secondaryClient) {
            var emailSubject = data.emailSubject,
                emailText = data.emailText,
                mailSignature = data.mailSignature;

            if (mailSignature) {
                emailText += "<br><br>" + mailSignature;
            }
            var emailTo = client.email ? [client.email] : [];
            if (secondaryClient) {
                emailTo.push(secondaryClient.email);
            }
            return {
                emailSubject: emailSubject || '',
                emailText: emailText || '',
                emailTo: emailTo,
                ccEmails: [],
                attachmentsData: JSON.parse(JSON.stringify(this.emptyAttachmentsData))
            };
        }
    }, {
        key: "getClientEmail",
        value: function getClientEmail(client) {
            var stringEmail = Object.assign(client.name);
            return stringEmail.substring(stringEmail.indexOf('(') + 1, stringEmail.length - 1);
        }
    }, {
        key: "prepareAttachments",
        value: function prepareAttachments(attachmentsData) {
            return {
                storedFiles: attachmentsData.attachments.filter(function (file) {
                    return file.id;
                }),
                uploadedFiles: attachmentsData.attachments.filter(function (file) {
                    return !file.id;
                })
            };
        }
    }, {
        key: "isAttachmentsValid",
        value: function isAttachmentsValid(attachmentsData) {
            var maxSize = 10; // 10Mb
            if (attachmentsData.filesSize > maxSize) {
                this.messageService.showToaster('w_0', 'attachments');
                return false;
            }
            return true;
        }
    }, {
        key: "prepareSignatureToShow",
        value: function prepareSignatureToShow(value) {
            var imgTag = '<img id="signatureImg';
            if (!value.includes(imgTag)) {
                return value;
            }
            var signatureLink = 'SN/images/signature/';
            var updatedLink = appConstants_1.AppConstants.HOST + "/" + signatureLink;
            if (value.includes(updatedLink)) {
                return value;
            }
            return value.replace(signatureLink, updatedLink);
        }
    }, {
        key: "resetSignatureLink",
        value: function resetSignatureLink(value) {
            var imgTag = '<img id="signatureImg';
            if (!value.includes(imgTag)) {
                return value;
            }
            var imgIndex = value.indexOf(imgTag);
            var closeIndex = value.indexOf('>', imgIndex);
            var addedServerString = /^(https?:\/\/).+\/$/;
            var fullImgTag = value.substring(imgIndex, closeIndex + 1).trim();
            var newImgTag = fullImgTag.replace(addedServerString, '');
            return value.replace(fullImgTag, newImgTag);
        }
    }, {
        key: "addMaiStyling",
        value: function addMaiStyling(emailText) {
            var emptyParagraph = '<p></p>';
            if (!emailText) {
                return emailText || '';
            }
            if (emailText === emptyParagraph) {
                return '';
            }
            var tmpId = "emailText_styling_" + this.randomStringGenerator.getMixedString(9);
            var tempTextEl = document.createElement('div');
            tempTextEl.setAttribute('id', tmpId);
            tempTextEl.className = 'hide';
            document.body.appendChild(tempTextEl);
            tempTextEl.innerHTML = emailText;
            this.mailStyling(tmpId);
            var message = tempTextEl.innerHTML;
            tempTextEl.remove();
            return message;
        }
    }, {
        key: "filterEmailAutocomplete",
        value: function filterEmailAutocomplete(inputData, filterData) {
            if (!filterData.length) {
                return inputData;
            }
            var filterParsedData = filterData.map(function (data) {
                return (data.email || data.label || data).trim();
            });
            return inputData.filter(function (email) {
                return !filterParsedData.includes(email.email);
            });
        }
    }, {
        key: "addSubjectVariable",
        value: function addSubjectVariable(element, variable) {
            var stringStart = "" + element.value.slice(0, element.selectionStart);
            var stringEnd = "" + element.value.slice(element.selectionEnd || element.selectionStart);
            var cursorPos = (stringStart + variable).length + 1;
            element.value = "" + stringStart + variable + " " + stringEnd;
            element.focus();
            element.setSelectionRange(cursorPos, cursorPos);
            return element.value;
        }
    }, {
        key: "prepareEmails",
        value: function prepareEmails(emailData) {
            var resData = {};
            if (emailData.emailTo[0]) {
                var _getEmailFromMailStri = this.getEmailFromMailString(emailData.emailTo);

                var _getEmailFromMailStri2 = _slicedToArray(_getEmailFromMailStri, 1);

                resData.emailTo = _getEmailFromMailStri2[0];
            }
            if (emailData.emailTo.length > 1) {
                resData.secondaryToEmails = this.getEmailFromMailString(emailData.emailTo.slice(1));
            }
            var emailCc = emailData.emailCc || emailData.ccEmails;
            if (emailCc && emailCc.length) {
                resData.ccEmails = this.getEmailFromMailString(emailCc);
            }
            resData.emailSubject = emailData.emailSubject ? emailData.emailSubject.trim() : '';
            return resData;
        }
    }, {
        key: "validateMails",
        value: function validateMails(mailData) {
            var _this = this;

            var emailTo = mailData.emailTo,
                secondaryToEmails = mailData.secondaryToEmails,
                ccEmails = mailData.ccEmails,
                emailSubject = mailData.emailSubject;

            var allEmails = [emailTo];
            if (!emailTo) {
                this.messageService.showToaster('e_3', 'email');
                return false;
            }
            if (!this.validationService.isEmailValid(emailTo)) {
                this.messageService.showToaster('e_6', 'email', emailTo);
                return false;
            }
            if (secondaryToEmails) {
                var _secondaryToEmails$fi = secondaryToEmails.filter(function (email) {
                    return !_this.validationService.isEmailValid(email);
                }),
                    _secondaryToEmails$fi2 = _slicedToArray(_secondaryToEmails$fi, 1),
                    invalidEmail = _secondaryToEmails$fi2[0];

                allEmails.push.apply(allEmails, _toConsumableArray(secondaryToEmails));
                if (invalidEmail) {
                    this.messageService.showToaster('e_6', 'email', invalidEmail);
                    return false;
                }
            }
            if (ccEmails) {
                var _ccEmails$filter = ccEmails.filter(function (email) {
                    return !_this.validationService.isEmailValid(email);
                }),
                    _ccEmails$filter2 = _slicedToArray(_ccEmails$filter, 1),
                    _invalidEmail = _ccEmails$filter2[0];

                allEmails.push.apply(allEmails, _toConsumableArray(ccEmails));
                if (_invalidEmail) {
                    this.messageService.showToaster('e_6', 'email', _invalidEmail);
                    return false;
                }
            }

            var _findEmailDuplicates = this.findEmailDuplicates(allEmails),
                _findEmailDuplicates2 = _slicedToArray(_findEmailDuplicates, 1),
                duplicate = _findEmailDuplicates2[0];

            if (duplicate) {
                this.messageService.showToaster('e_4', 'email', duplicate);
                return false;
            }
            if (!this.isSubjectValid(emailSubject)) {
                return false;
            }
            return true;
        }
    }, {
        key: "isSubjectValid",
        value: function isSubjectValid(subject) {
            if (!subject) {
                this.messageService.showToaster('e_2', 'email');
                return false;
            }
            if (subject && subject.length > 255) {
                this.messageService.showToaster('e_5', 'email');
                return false;
            }
            return true;
        }
    }, {
        key: "findEmailDuplicates",
        value: function findEmailDuplicates(emails) {
            var cache = {};
            var result = [];
            emails.forEach(function (item) {
                if (!cache[item]) {
                    cache[item] = 0;
                }
                cache[item] += 1;
            });
            for (var email in cache) {
                if (cache[email] >= 2) {
                    result.push(email);
                }
            }
            return result;
        }
    }, {
        key: "getEmailFromMailString",
        value: function getEmailFromMailString(emails) {
            return emails.map(function (item) {
                return item.email || item.label || item;
            }).map(function (email) {
                return email.trim();
            });
        }
    }, {
        key: "getEmailTextReply",
        value: function getEmailTextReply(emailText, text) {
            return "<br><br>\n                <div class=\"gmail_quote color-grey\">" + emailText + "\n                    <blockquote class=\"gmail_quote color-grey\">" + text + "</blockquote>\n                </div>";
        }
    }, {
        key: "escapeEmailDetailsHtml",
        value: function escapeEmailDetailsHtml(str) {
            return str.replace(/&/g, '&amp;').replace(/>/g, '&gt;').replace(/</g, '&lt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/`/g, '&#96;');
        }
    }, {
        key: "escapeEmailTextHtml",
        value: function escapeEmailTextHtml(text) {
            var matchedText = text.replace(/[\r\n]+/g, ' ');
            matchedText = /<body.*>(.*?)<\/body>/gim.exec(matchedText);
            return matchedText ? matchedText[0] : text;
        }
    }, {
        key: "trimStyleTagsHtml",
        value: function trimStyleTagsHtml(text) {
            return text.replace(/<style.*?<\/style>/g, '');
        }
    }, {
        key: "escapeEmailBodyDetailsHtml",
        value: function escapeEmailBodyDetailsHtml(str) {
            var emailWithTagRegex = /<\/?([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)>/gi;
            return str.replace(emailWithTagRegex, function (matched) {
                return matched.replace(/>/g, '&gt;').replace(/</g, '&lt;');
            });
        }
    }, {
        key: "getReplyText",
        value: function getReplyText(mailData) {
            return "<br/><br/>\n                 " + mailData.emailTextReply + "\n                 <br/><br/>\n                 " + (mailData.mailSignature || '') + "\n                ";
        }
    }, {
        key: "getReplyDateInFormat",
        value: function getReplyDateInFormat(date) {
            var dateFormatForReply = "EEE, MMM dd, yyyy 'at' HH:mm a";
            return this.datePipe.transform(date, dateFormatForReply);
        }
    }, {
        key: "getFormattedReplyData",
        value: function getFormattedReplyData(data) {
            var subject = data.subject,
                to = data.to,
                cc = data.cc,
                date = data.date,
                allFromName = data.allFromName,
                text = data.text;

            var formattedDate = this.getReplyDateInFormat(date);
            var mailData = JSON.parse(JSON.stringify(data));
            mailData.emailSubject = subject;
            mailData.emailTo = to;
            mailData.emailCc = cc;
            mailData.reply = true;
            mailData.validMsg = true;
            try {
                !!this.sanitizer.bypassSecurityTrustHtml(text);
                var emailDetails = this.escapeEmailDetailsHtml("On " + formattedDate + " " + allFromName + " wrote:");
                var matchedText = this.escapeEmailTextHtml(text);
                mailData.emailTextReply = this.getEmailTextReply(emailDetails, matchedText);
            } catch (err) {
                console.log('error ', err);
                mailData.emailTextReply = 'Oops! This message is unsupported and cannot be displayed in Studio Ninja. Please view this message in your email provider';
                mailData.validMsg = false;
            }
            mailData.emailText = this.getReplyText(mailData);
            return mailData;
        }
    }, {
        key: "checkIfEmailAllowedWeb",
        value: function checkIfEmailAllowedWeb(contact, func, thisRef, argsArr) {
            this.emailFn = this.utilsService.wrapFunction(func, thisRef, argsArr);
            if (contact && contact.status === 'UNSUBSCRIBED') {
                this.utilsService.closeAllModalsAndOpenNew('#resubscribeClientModal');
            } else {
                this.callLastEmailFn();
            }
        }
    }, {
        key: "checkIsCCSubscribedWeb",
        value: function checkIsCCSubscribedWeb(contact, func, thisRef, argsArr) {
            this.emailFn = this.utilsService.wrapFunction(func, thisRef, argsArr);
            if (contact && contact.status === 'UNSUBSCRIBED') {
                $('#resubscribeClientModal').modal('show');
            } else {
                this.callLastEmailFn();
            }
        }
    }, {
        key: "callLastEmailFn",
        value: function callLastEmailFn() {
            this.emailFn();
        }
    }, {
        key: "clientToCheckSubscription$",
        get: function get() {
            return this.clientToCheckSubscription.asObservable();
        }
    }]);

    return EmailServiceProvider;
}();
EmailServiceProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [message_service_1.MessageService, validation_service_1.ValidationProvider, random_string_generator_1.RandomStringGeneratorProvider, utils_service_1.UtilsServiceProvider, common_1.DatePipe, platform_browser_1.DomSanitizer])], EmailServiceProvider);
exports.EmailServiceProvider = EmailServiceProvider;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./shared/services/email/mails.data.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = __webpack_require__("./node_modules/@angular/common/esm5/http.js");
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var BehaviorSubject_1 = __webpack_require__("./node_modules/rxjs/BehaviorSubject.js");
var MailsDataProvider = function () {
    function MailsDataProvider(http) {
        _classCallCheck(this, MailsDataProvider);

        this.http = http;
        this.mailData = new BehaviorSubject_1.BehaviorSubject(false);
        this.mailDetailsView = new BehaviorSubject_1.BehaviorSubject(false);
        this.mailUpdateEvent = new BehaviorSubject_1.BehaviorSubject(false);
    }

    _createClass(MailsDataProvider, [{
        key: "emitMailData",
        value: function emitMailData(mailData) {
            return this.mailData.next(JSON.parse(JSON.stringify(mailData)));
        }
    }, {
        key: "emitMailDetailsView",
        value: function emitMailDetailsView(mailData) {
            return this.mailDetailsView.next(JSON.parse(JSON.stringify(mailData)));
        }
    }, {
        key: "emitMailUpdateEvent",
        value: function emitMailUpdateEvent(value) {
            this.mailUpdateEvent.next(value);
        }
    }, {
        key: "sendEmail",
        value: function sendEmail(data, mailId, jobId, leadId) {
            var url = void 0;
            if (leadId) {
                url = "/api/user/lead/" + leadId + "/send/" + mailId + "/";
            } else {
                url = "/protected/rest/clients/send/" + mailId + "/";
                url += jobId || '';
            }
            var sendMessageData = data.sendMessageData,
                storedFiles = data.storedFiles,
                uploadedFiles = data.uploadedFiles;

            var formData = new FormData();
            for (var key in sendMessageData) {
                if (key !== 'attachmentsData') {
                    formData.append(key, sendMessageData[key]);
                }
            }
            for (var _key in storedFiles) {
                formData.append("storedAttachments[" + _key + "]", storedFiles[_key].id);
            }
            for (var _key2 in uploadedFiles) {
                formData.append("attachments[" + _key2 + "]", uploadedFiles[_key2]);
            }
            return this.sendMailRequest(url, formData);
        }
    }, {
        key: "sendMailRequest",
        value: function sendMailRequest(url, formData) {
            return this.http.post(url, formData);
        }
    }, {
        key: "getMailDetailsView",
        value: function getMailDetailsView(jobMailId) {
            var url = "/protected/rest/jobs/job/mail/?id=" + jobMailId;
            return this.http.get(url);
        }
    }, {
        key: "getJobMails",
        value: function getJobMails(jobId, syncReply) {
            var url = "/api/user/v1/job/" + jobId + "/mail?forceSyncReplies=" + syncReply;
            return this.http.get(url);
        }
    }, {
        key: "getContactMails",
        value: function getContactMails(contactId, syncReply) {
            var url = "/api/user/v1/contact/" + contactId + "/mail?forceSyncReplies=" + syncReply;
            return this.http.get(url);
        }
    }, {
        key: "mailDataObservable",
        get: function get() {
            return this.mailData.asObservable();
        }
    }, {
        key: "mailDetailsViewObservable",
        get: function get() {
            return this.mailDetailsView.asObservable();
        }
    }, {
        key: "shouldMailsBeUpdatedObservable",
        get: function get() {
            return this.mailUpdateEvent.asObservable();
        }
    }]);

    return MailsDataProvider;
}();
MailsDataProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [http_1.HttpClient])], MailsDataProvider);
exports.MailsDataProvider = MailsDataProvider;

/***/ }),

/***/ "./shared/services/files/file-download-service/file-download.data.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var FileSaver_1 = __webpack_require__("./node_modules/file-saver/FileSaver.js");
var http_1 = __webpack_require__("./node_modules/@angular/common/esm5/http.js");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var FileDownloadDataServiceProvider = function () {
    function FileDownloadDataServiceProvider(http) {
        _classCallCheck(this, FileDownloadDataServiceProvider);

        this.http = http;
    }

    _createClass(FileDownloadDataServiceProvider, [{
        key: "downloadFileDynamic",
        value: function downloadFileDynamic(action, body) {
            var _this = this;

            return this.http.post(action.url, body, { responseType: 'blob', observe: 'response' }).pipe(operators_1.tap(function (response) {
                return _this.writeToFileSystem(response);
            }));
        }
    }, {
        key: "saveFileFromJob",
        value: function saveFileFromJob(fileId, jobId) {
            var url = "/rest/user/jobs/" + jobId + "/attachments/" + fileId;
            return this.http.get(url, { responseType: 'blob', observe: 'response' });
        }
    }, {
        key: "saveClients",
        value: function saveClients() {
            var _this2 = this;

            var url = '/protected/rest/clients/export-clients';
            return this.http.get(url, { responseType: 'blob', observe: 'response' }).toPromise().then(function (response) {
                return _this2.saveClientsToFileSystem(response);
            });
        }
    }, {
        key: "saveClientsTemplate",
        value: function saveClientsTemplate() {
            var _this3 = this;

            var url = '/protected/rest/clients/download-csv-template';
            return this.http.get(url, { responseType: 'blob', observe: 'response' }).toPromise().then(function (response) {
                return _this3.saveClientsTemplateToFileSystem(response);
            });
        }
    }, {
        key: "savePaymentsCSV",
        value: function savePaymentsCSV(response) {
            this.savePaymentsToFileSystemCSV(response);
        }
    }, {
        key: "savePaymentsXLS",
        value: function savePaymentsXLS(response) {
            this.savePaymentsToFileSystemXLS(response);
        }
    }, {
        key: "saveAmbassadorReferrals",
        value: function saveAmbassadorReferrals(response, ambassador) {
            this.saveAmbassadorReferralsXLS(response, ambassador);
        }
    }, {
        key: "downloadPdf",
        value: function downloadPdf(linkToken, id, documentType) {
            var _this4 = this;

            var url = void 0;
            switch (documentType) {
                case 'invoice':
                    url = "/api/public/v1/invoice/" + linkToken + "/" + id + "/download-pdf";
                    break;
                case 'quote':
                    url = "/api/public/v1/quotes/" + linkToken + "/" + id + "/download-pdf";
                    break;
                default:
                    url = "/api/public/v1/quotes/" + linkToken + "/" + id + "/download-pdf";
            }
            return this.http.get(url, { responseType: 'blob', observe: 'response' }).toPromise().then(function (response) {
                return _this4.saveToFileSystem(response);
            });
        }
    }, {
        key: "downloadPDF",
        value: function downloadPDF(url, name, id) {
            var _this5 = this;

            return this.http.post(url, {}, { responseType: 'blob', observe: 'response' }).pipe(operators_1.tap(function (response) {
                return _this5.savePdf(response, name, id);
            }));
        }
    }, {
        key: "saveContractPdf",
        value: function saveContractPdf(url, fileName) {
            return this.http.post(url, {}, { responseType: 'blob', observe: 'response' }).toPromise().then(function (response) {
                var blob = new Blob([response.body], { type: response.body.type });
                FileSaver_1.saveAs(blob, fileName);
            });
        }
    }, {
        key: "savePdfFile",
        value: function savePdfFile(url) {
            var _this6 = this;

            return this.http.post(url, {}, { responseType: 'blob', observe: 'response' }).toPromise().then(function (response) {
                _this6.saveToFileSystem(response);
            });
        }
    }, {
        key: "saveToFileSystem",
        value: function saveToFileSystem(response) {
            var contentDispositionHeader = response.headers.get('Content-Disposition');
            var parts = contentDispositionHeader.split(';');
            var filename = parts[1].split('=')[1];
            var blob = new Blob([response.body], { type: response.body.type });
            FileSaver_1.saveAs(blob, filename);
        }
    }, {
        key: "saveFile",
        value: function saveFile(response, name, fileType) {
            var blob = new Blob([response.body], { type: response.body.type });
            FileSaver_1.saveAs(blob, name + "." + fileType);
        }
    }, {
        key: "savePdf",
        value: function savePdf(response, name, id) {
            var blob = new Blob([response.body], { type: response.body.type });
            FileSaver_1.saveAs(blob, name + "-" + id);
        }
    }, {
        key: "saveClientsToFileSystem",
        value: function saveClientsToFileSystem(response) {
            var blob = new Blob([response.body], { type: response.body.type });
            FileSaver_1.saveAs(blob, 'export_clients.csv');
        }
    }, {
        key: "savePaymentsToFileSystemCSV",
        value: function savePaymentsToFileSystemCSV(response) {
            var blob = new Blob([response.body], { type: response.body.type });
            FileSaver_1.saveAs(blob, 'export_payments.csv');
        }
    }, {
        key: "savePaymentsToFileSystemXLS",
        value: function savePaymentsToFileSystemXLS(response) {
            var blob = new Blob([response.body], { type: response.body.type });
            FileSaver_1.saveAs(blob, 'export_payments.xls');
        }
    }, {
        key: "saveAmbassadorReferralsXLS",
        value: function saveAmbassadorReferralsXLS(response, ambassador) {
            var blob = new Blob([response.body], { type: response.body.type });
            FileSaver_1.saveAs(blob, ambassador.firstName.replace(/\s/g, '_') + "_(" + ambassador.email + ")_Referrals.xls");
        }
    }, {
        key: "saveClientsTemplateToFileSystem",
        value: function saveClientsTemplateToFileSystem(response) {
            var blob = new Blob([response.body], { type: response.body.type });
            FileSaver_1.saveAs(blob, 'import_clients_template.csv');
        }
    }, {
        key: "writeToFileSystem",
        value: function writeToFileSystem(response) {
            var blob = new Blob([response.body], { type: response.body.type });
            FileSaver_1.saveAs(blob, this.findFileName(response));
        }
    }, {
        key: "findFileName",
        value: function findFileName(response) {
            var value = response.headers.get('content-disposition');
            return value ? value.slice(value.indexOf('=') + 1) : 'document';
        }
    }]);

    return FileDownloadDataServiceProvider;
}();
FileDownloadDataServiceProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [http_1.HttpClient])], FileDownloadDataServiceProvider);
exports.FileDownloadDataServiceProvider = FileDownloadDataServiceProvider;

/***/ }),

/***/ "./shared/services/files/file-upload-service/file-upload.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var Observable_1 = __webpack_require__("./node_modules/rxjs/Observable.js");
var image_converter_service_1 = __webpack_require__("./shared/services/files/image-converter.service.ts");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var FileUploadServiceProvider = function () {
    function FileUploadServiceProvider(imageConverter, messageService) {
        var _this = this;

        _classCallCheck(this, FileUploadServiceProvider);

        this.imageConverter = imageConverter;
        this.messageService = messageService;
        this.maxMb = 50; // 50 Mb
        this.maxSize = this.maxMb * 1000 * 1024;
        this.maxAllowedUploadFileSize = 20 * 1000 * 1024;
        this.maxAttachment = 10; // 10 Mb
        this.maxClientPhoto = 5; // 5 Mb
        this.isFileExceedLimit = function (file) {
            return file.size >= _this.maxSize;
        };
        this.isOverMaxAllowedUploadFileSize = function (file) {
            return _this.maxSize > file.size && file.size > _this.maxAllowedUploadFileSize;
        };
        this.isPhotoExceedLimit = function (photo) {
            var sizeInMb = _this.getConvertedSize(photo);
            return sizeInMb >= _this.maxClientPhoto;
        };
        this.isValidPhotoFormat = function (photo) {
            return (/\.(gif|jpg|jpeg|png)$/i.test(photo.name)
            );
        };
        this.convertFileToBase64 = function (file) {
            return _this.readFile(file).map(function (result) {
                if (result) {
                    var metaDataEnd = result.indexOf(',') + 1;
                    var convertedFile = result.slice(metaDataEnd).trim();
                    return {
                        name: file.name,
                        contentType: file.type,
                        size: file.size,
                        base64: convertedFile
                    };
                }
                console.error('error in file reader');
                return null;
            });
        };
        this.base64StringToObject = function (img) {
            if (!img || typeof img !== 'string') {
                return;
            }
            var imgStrToArray = img.split(',');
            var base64content = imgStrToArray[1].trim();
            var dataPartLength = 'data:'.length;
            var contentType = imgStrToArray[0].split(';')[0].substr(dataPartLength);
            return {
                base64content: base64content,
                contentType: contentType
            };
        };
        this.readFile = function (blob) {
            return Observable_1.Observable.create(function (obs) {
                if (!(blob instanceof Blob)) {
                    obs.error(new Error('`blob` must be an instance of File or Blob.'));
                    return;
                }
                var reader = new FileReader();
                reader.onerror = function (err) {
                    return obs.error(err);
                };
                reader.onabort = function (err) {
                    return obs.error(err);
                };
                reader.onload = function () {
                    return obs.next(reader.result);
                };
                reader.onloadend = function () {
                    return obs.complete();
                };
                return reader.readAsDataURL(blob);
            });
        };
    }

    _createClass(FileUploadServiceProvider, [{
        key: "addFileConvertedSize",
        value: function addFileConvertedSize(attachment) {
            attachment.convertedType = this.imageConverter.getFileClass(attachment.name);
            attachment.convertedSize = this.getConvertedSize(attachment);
            return attachment;
        }
        // used in web app only

    }, {
        key: "removeDuplicates",
        value: function removeDuplicates(array, keyname) {
            var output = [];
            var keys = [];
            array.forEach(function (item) {
                var key = item[keyname];
                if (!keys.includes(key) || !key) {
                    keys.push(key);
                    output.push(item);
                }
            });
            return output;
        }
    }, {
        key: "getConvertedSize",
        value: function getConvertedSize(attachment) {
            var convertedSize = void 0;
            if (attachment.bytesSize) {
                convertedSize = (parseInt(attachment.bytesSize) / (1024 * 1024)).toFixed(2); // convert from bytes to MB
            } else {
                convertedSize = (parseInt(attachment.size) / (1024 * 1024)).toFixed(2); // convert from bytes to MB
            }
            return Number(convertedSize);
        }
    }, {
        key: "isAllFilesExceedLimit",
        value: function isAllFilesExceedLimit(file, allFiles) {
            if (this.getTotalSize(allFiles) + file.size > this.maxSize) {
                return true;
            }
            return false;
        }
    }, {
        key: "getAllAttachmentsSize",
        value: function getAllAttachmentsSize() {
            var attachmentsSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            var newAttachments = arguments[1];

            return attachmentsSize + this.getTotalSize(newAttachments);
        }
    }, {
        key: "deleteFilesFromTasks",
        value: function deleteFilesFromTasks(tasks, file) {
            return tasks.map(function (task) {
                var hasAttachments = task.taskEmail && task.taskEmail.storedAttachments && task.taskEmail.storedAttachments.length;
                if (hasAttachments) {
                    var storedAttachments = task.taskEmail.storedAttachments;

                    var deletedFileId = file.id;
                    storedAttachments.forEach(function (attachment, index) {
                        if (attachment.id === deletedFileId) {
                            storedAttachments.splice(index, 1);
                        }
                    });
                }
                return task;
            });
        }
    }, {
        key: "getTotalSize",
        value: function getTotalSize(files) {
            var _this2 = this;

            return files.reduce(function (prev, next) {
                var nextSize = _this2.getConvertedSize(next);
                return prev + nextSize;
            }, 0);
        }
    }, {
        key: "isClientPhotoValid",
        value: function isClientPhotoValid(photo) {
            if (!this.isValidPhotoFormat(photo)) {
                this.messageService.showToaster('e_2', 'general', 'Please upload an image');
                return false;
            }
            if (this.isPhotoExceedLimit(photo)) {
                this.messageService.showToaster('e_2', 'companyInformation', '5');
                return false;
            }
            return true;
        }
    }, {
        key: "convertFileToSave",
        value: function convertFileToSave(filesArr) {
            var _this3 = this,
                _Observable_1$Observa;

            var result = filesArr.map(function (file) {
                return _this3.convertFileToBase64(file);
            });
            return (_Observable_1$Observa = Observable_1.Observable).zip.apply(_Observable_1$Observa, _toConsumableArray(result));
        }
    }, {
        key: "convertAttachmentsToShow",
        value: function convertAttachmentsToShow(attachments) {
            var _this4 = this;

            var attachmentsToShow = attachments.slice();
            attachmentsToShow.forEach(function (attachment) {
                attachment.customLastModifiedDate = _this4.getCustomLastModifiedDate(attachment);
                attachment.convertedSize = _this4.getConvertedSize(attachment);
                attachment.convertedType = _this4.imageConverter.getFileClass(attachment.name);
            });
            return attachmentsToShow;
        }
    }, {
        key: "getCustomLastModifiedDate",
        value: function getCustomLastModifiedDate(attachment) {
            var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
            var tmpDate = new Date(attachment.cratedTs);
            return tmpDate.getDate() + " " + monthNames[tmpDate.getMonth()] + " " + tmpDate.getFullYear();
        }
    }, {
        key: "objectToBase64String",
        value: function objectToBase64String(photo) {
            var base64content = photo.base64content,
                contentType = photo.contentType;

            if (!base64content || !contentType) {
                return 'none';
            }
            return "url(data:" + contentType + ";base64," + base64content + ")";
        }
    }]);

    return FileUploadServiceProvider;
}();
FileUploadServiceProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [image_converter_service_1.ImageConverterProvider, message_service_1.MessageService])], FileUploadServiceProvider);
exports.FileUploadServiceProvider = FileUploadServiceProvider;

/***/ }),

/***/ "./shared/services/files/file-upload.data.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var http_1 = __webpack_require__("./node_modules/@angular/common/esm5/http.js");
var BehaviorSubject_1 = __webpack_require__("./node_modules/rxjs/BehaviorSubject.js");
var file_upload_service_1 = __webpack_require__("./shared/services/files/file-upload-service/file-upload.service.ts");
var image_converter_service_1 = __webpack_require__("./shared/services/files/image-converter.service.ts");
var throw_1 = __webpack_require__("./node_modules/rxjs/observable/throw.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var FileUploadDataProvider = function () {
    function FileUploadDataProvider(http, fileUploadService, imageConverter, messageService) {
        _classCallCheck(this, FileUploadDataProvider);

        this.http = http;
        this.fileUploadService = fileUploadService;
        this.imageConverter = imageConverter;
        this.messageService = messageService;
        this.monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        this.filesList = [];
        this.filesChanges = new BehaviorSubject_1.BehaviorSubject([]);
        this.checkedFiles = new BehaviorSubject_1.BehaviorSubject([]);
        this.fileToDelete = new BehaviorSubject_1.BehaviorSubject(false);
        this.uploadedPhoto = new BehaviorSubject_1.BehaviorSubject(null);
        this.newPhoto = new BehaviorSubject_1.BehaviorSubject(null);
        this.headers = new http_1.HttpHeaders({
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            Expires: '0',
            Pragma: 'no-cache'
        });
    }

    _createClass(FileUploadDataProvider, [{
        key: "setFiles",
        value: function setFiles(files, isInitLoading) {
            if (isInitLoading) {
                this.filesList = files;
            } else if (Array.isArray(files)) {
                var _filesList;

                (_filesList = this.filesList).push.apply(_filesList, _toConsumableArray(files));
            } else {
                this.filesList.push(files);
            }
            this.filesChanges.next(this.filesList);
        }
    }, {
        key: "setCheckedFiles",
        value: function setCheckedFiles(files) {
            this.checkedFiles.next(files);
        }
    }, {
        key: "setFileToDelete",
        value: function setFileToDelete(file) {
            this.fileToDelete.next(file);
        }
    }, {
        key: "emitUploadedPhoto",
        value: function emitUploadedPhoto(photo) {
            this.uploadedPhoto.next(photo);
        }
    }, {
        key: "emitNewPhoto",
        value: function emitNewPhoto(clientId) {
            this.newPhoto.next(clientId);
        }
    }, {
        key: "saveFileOnServer",
        value: function saveFileOnServer(dataToSave, jobId) {
            var _this = this;

            if (typeof jobId !== 'undefined') {
                var dataToSend = new FormData();
                dataToSend.append('file', dataToSave);
                var url = "/rest/user/jobs/" + jobId + "/attachments/";
                var headers = this.headers;
                return this.http.post(url, dataToSend, { headers: headers }).map(function (response) {
                    response.convertedSize = (parseInt(response.bytesSize) / (1024 * 1024)).toFixed(2); // convert from bytes to MB
                    var tmpDate = new Date(response.cratedTs);
                    response.customLastModifiedDate = tmpDate.getDate() + " " + _this.monthNames[tmpDate.getMonth()] + " " + tmpDate.getFullYear();
                    response.convertedType = _this.imageConverter.getFileClass(response.name);
                    return response;
                });
            }
        }
    }, {
        key: "sendFundyXmlFile",
        value: function sendFundyXmlFile(dataToSave, jobId) {
            var _this2 = this;

            if (jobId !== 'undefined') {
                var dataToSend = new FormData();
                dataToSend.append('data', dataToSave);
                var url = "/api/user/jobs/" + jobId + "/invoice/import/fundy";
                var headers = this.headers;
                return this.http.post(url, dataToSend, { headers: headers }).catch(function (error) {
                    return _this2.handleXMlError(error.error);
                });
            }
        }
    }, {
        key: "sendProSelectXmlFile",
        value: function sendProSelectXmlFile(dataToSave, jobId) {
            var _this3 = this;

            if (jobId !== 'undefined') {
                var dataToSend = new FormData();
                dataToSend.append('data', dataToSave);
                var url = "/api/user/jobs/" + jobId + "/invoice/import/proselect";
                var headers = this.headers;
                return this.http.post(url, dataToSend, { headers: headers }).catch(function (error) {
                    return _this3.handleProSelectUploadError(error.error);
                });
            }
        }
    }, {
        key: "handleXMlError",
        value: function handleXMlError(error) {
            if (error.errorTitle && error.errorTitle !== null) {
                this.messageService.showErrorFromBackend(error.errorTitle, error.errorMessage);
            } else {
                this.messageService.showErrorFromBackend('Not happy, Fundy!');
            }
            return throw_1._throw(error);
        }
    }, {
        key: "handleProSelectUploadError",
        value: function handleProSelectUploadError(error) {
            if (error.errorTitle && error.errorTitle !== null) {
                this.messageService.showErrorFromBackend(error.errorTitle, error.errorMessage);
            } else {
                this.messageService.showErrorFromBackend('Incorrect, ProSelect!');
            }
            return throw_1._throw(error);
        }
    }, {
        key: "deleteFileFromServer",
        value: function deleteFileFromServer(file, jobId) {
            var _this4 = this;

            var fileID = file.id;
            var url = "/rest/user/jobs/" + jobId + "/attachments/" + fileID;
            var headers = this.headers;
            return this.http.delete(url, { headers: headers }).pipe(operators_1.map(function (data) {
                var index = _this4.filesList.indexOf(file);
                _this4.filesList.splice(index, 1);
                _this4.filesChanges.next(_this4.filesList);
                return data;
            }));
        }
    }, {
        key: "getAttachment",
        value: function getAttachment(id, jobId) {
            var url = "/rest/user/jobs/" + jobId + "/attachments/" + id;
            var headers = this.headers;
            headers.append('Content-Type', 'application/x-www-form-urlencoded');
            return this.http.get(url, { headers: headers });
        }
    }, {
        key: "getAttachments",
        value: function getAttachments(jobId) {
            var url = "/rest/user/jobs/" + jobId + "/attachments";
            var headers = this.headers;
            headers.append('Content-Type', 'application/x-www-form-urlencoded');
            return this.http.get(url, { headers: headers }).map(function (response) {
                response.forEach(function (value) {
                    value.convertedSize = (parseInt(value.bytesSize) / (1024 * 1024)).toFixed(2); // convert from bytes to MB
                });
            });
        }
    }, {
        key: "setAttachmentsFromServer",
        value: function setAttachmentsFromServer(attachments) {
            var attachmentsToShow = Object.assign({}, attachments);
            attachmentsToShow = this.fileUploadService.convertAttachmentsToShow(attachments);
            // $rootScope.uploadedFiles = attachmentsToShow.length;
            this.setFiles(attachmentsToShow, true);
            return attachmentsToShow;
        }
    }, {
        key: "uploadClientPhoto",
        value: function uploadClientPhoto(photo, clientId) {
            var url = "/api/user/clients/" + clientId + "/image";
            var data = this.fileUploadService.base64StringToObject(photo);
            return this.http.put(url, data);
        }
    }, {
        key: "uploadUserPhoto",
        value: function uploadUserPhoto(photo) {
            var url = '/api/user/v1/avatar';
            var data = this.fileUploadService.base64StringToObject(photo);
            return this.http.post(url, data);
        }
    }, {
        key: "getClientPhoto",
        value: function getClientPhoto(clientId) {
            var url = "/api/user/clients/" + clientId + "/image";
            return this.http.get(url);
        }
    }, {
        key: "getUserPhoto",
        value: function getUserPhoto() {
            var url = '/api/user/v1/avatar';
            return this.http.get(url);
        }
    }, {
        key: "currentFileList",
        get: function get() {
            return this.filesList;
        }
    }, {
        key: "fileToDeleteObservable",
        get: function get() {
            return this.fileToDelete.asObservable();
        }
    }, {
        key: "filesObservable",
        get: function get() {
            return this.filesChanges.asObservable();
        }
    }, {
        key: "checkedFilesObservable",
        get: function get() {
            return this.checkedFiles.asObservable();
        }
    }, {
        key: "uploadedPhoto$",
        get: function get() {
            return this.uploadedPhoto.asObservable();
        }
    }, {
        key: "newPhoto$",
        get: function get() {
            return this.newPhoto.asObservable();
        }
    }]);

    return FileUploadDataProvider;
}();
FileUploadDataProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [http_1.HttpClient, file_upload_service_1.FileUploadServiceProvider, image_converter_service_1.ImageConverterProvider, message_service_1.MessageService])], FileUploadDataProvider);
exports.FileUploadDataProvider = FileUploadDataProvider;

/***/ }),

/***/ "./shared/services/files/image-converter.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var ImageConverterProvider = function () {
    function ImageConverterProvider() {
        _classCallCheck(this, ImageConverterProvider);

        this.video = ['webm', 'mkv', 'avi', 'wmv', 'mp4', 'amv', '3gp', 'mpeg', 'mov'];
        this.text = ['doc', 'docx', 'odt', 'rtf', 'dot'];
        this.pdf = ['pdf'];
        this.database = ['db', 'sql', 'accdb', 'accde', 'accdt', 'accdr', 'mdw'];
        this.presentation = ['ppt', 'pptx', 'pps', 'odp'];
        this.excel = ['ods', 'xls', 'xlsx', 'xlw', 'xlt', 'xlsb', 'xlsm', 'ods'];
        this.music = ['midi', 'ogg', 'wav', 'mp3', 'wma'];
        this.archive = ['7z', 'apk', 'jar', 'rar', 'tar', 'gz', 'zip', 'tar'];
        this.image = ['jpeg', 'jpg', 'gif', 'bmp', 'tiff', 'nef', 'png', 'raw', 'svg'];
        this.photoshop = ['psd'];
        this.illustrator = ['ai'];
        this.fileExtensions = {
            video: this.video,
            text: this.text,
            pdf: this.pdf,
            database: this.database,
            presentation: this.presentation,
            excel: this.excel,
            music: this.music,
            archive: this.archive,
            image: this.image,
            photoshop: this.photoshop,
            illustrator: this.illustrator
        };
    }

    _createClass(ImageConverterProvider, [{
        key: "getFileExtension",
        value: function getFileExtension(fileName) {
            return (/[.]/.exec(fileName) ? /[^.]+$/.exec(fileName)[0] : 'undefined'
            );
        }
    }, {
        key: "getFileClass",
        value: function getFileClass(fileName) {
            var DEFAULT_TYPE = 'default-type';
            var extension = this.getFileExtension(fileName);
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = Object.keys(this.fileExtensions)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var key = _step.value;

                    var fileExtensionType = this.fileExtensions[key];
                    var foundExtension = fileExtensionType.find(function (item) {
                        return item.toLowerCase() === extension.toLowerCase();
                    });
                    if (foundExtension) {
                        return key;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return DEFAULT_TYPE;
        }
    }]);

    return ImageConverterProvider;
}();
ImageConverterProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [])], ImageConverterProvider);
exports.ImageConverterProvider = ImageConverterProvider;

/***/ }),

/***/ "./shared/services/helpers/iframe-service/iframe.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var BehaviorSubject_1 = __webpack_require__("./node_modules/rxjs/BehaviorSubject.js");
var IframeService = function () {
    function IframeService() {
        _classCallCheck(this, IframeService);

        this.iframeUrl = new BehaviorSubject_1.BehaviorSubject(null);
    }

    _createClass(IframeService, [{
        key: "setUrlIframe",
        value: function setUrlIframe(url) {
            this.iframeUrl.next(url);
        }
    }, {
        key: "urlIframeUrl",
        get: function get() {
            return this.iframeUrl.asObservable();
        }
    }]);

    return IframeService;
}();
IframeService = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [])], IframeService);
exports.IframeService = IframeService;

/***/ }),

/***/ "./shared/services/helpers/message-service/message.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(toastr) {

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = undefined && undefined.__param || function (paramIndex, decorator) {
    return function (target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var messages_1 = __webpack_require__("./shared/models/messages.ts");
var appConstants_1 = __webpack_require__("./shared/models/appConstants.ts");
var ionic_message_service_1 = __webpack_require__("./mobile/src/providers/ionic-message-service/ionic-message-service.ts");
var of_1 = __webpack_require__("./node_modules/rxjs/observable/of.js");
var MessageService = function () {
    function MessageService(ionMessageService) {
        var _this = this;

        _classCallCheck(this, MessageService);

        this.ionMessageService = ionMessageService;
        this.messageTypes = {
            e: 'error',
            s: 'success',
            i: 'info',
            w: 'warning'
        };
        this.showDefaultErrorMessage = function (_ref) {
            var data = _ref.data,
                status = _ref.status;

            if (data !== undefined && status >= 400 && status < 500 && data.errorMessage) {
                _this.showToaster('e_2', 'general', data.errorMessage);
            } else {
                _this.showToaster('e_0', 'general');
            }
        };
    }
    /*
    messageService.showToaster('e_0', 'general');
    */


    _createClass(MessageService, [{
        key: "showToaster",
        value: function showToaster(messageCode, place, value) {
            var messageObj = this.getMessageToShow(messageCode, place, value);
            appConstants_1.AppConstants.isBrowser ? this.showToasterForBrowser(messageObj) : this.ionMessageService.showToaster(messageObj);
        }
    }, {
        key: "showErrorFromBackend",
        value: function showErrorFromBackend() {
            var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Whoops, something has gone wrong!';
            var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Please contact customer support.';

            if (appConstants_1.AppConstants.isBrowser) {
                toastr.error(value, title);
            } else {
                var messageObj = {
                    messageType: 'e',
                    title: title,
                    text: value
                };
                this.ionMessageService.showToaster(messageObj);
            }
        }
    }, {
        key: "handleError",
        value: function handleError(_ref2) {
            var error = _ref2.error;
            var errorMessage = error.errorMessage,
                errorTitle = error.errorTitle;

            this.showErrorFromBackend(errorTitle, errorMessage);
        }
    }, {
        key: "showMessageFromBackend",
        value: function showMessageFromBackend(messageType, title, text) {
            if (messageType) {
                var messageObj = {
                    messageType: messageType,
                    title: title,
                    text: text
                };
                this.showToasterForBrowser(messageObj);
            }
        }
    }, {
        key: "getCorrectMessageType",
        value: function getCorrectMessageType(status) {
            var messageStatus = void 0;
            switch (status) {
                case 'ok':
                    messageStatus = 's';
                    break;
                case 'warning':
                    messageStatus = 'w';
                    break;
                //  This case is just added for future uses
                case 'info':
                    messageStatus = 'i';
                    break;
                case 'error':
                    messageStatus = 'e';
                    break;
                default:
                    break;
            }
            return messageStatus;
        }
    }, {
        key: "catchErrorFromBackend",
        value: function catchErrorFromBackend(error) {
            this.showErrorFromBackend(error.error.errorTitle, error.error.errorMessage);
            return of_1.of(null);
        }
    }, {
        key: "getMessageToShow",
        value: function getMessageToShow(messageCode, place, value) {
            if (!messageCode || !place) {
                console.error('incorrect initial date');
                return;
            }

            var _messageCode$split = messageCode.split('_'),
                _messageCode$split2 = _slicedToArray(_messageCode$split, 2),
                messageType = _messageCode$split2[0],
                codeNumber = _messageCode$split2[1];

            var messObj = messages_1.Messages[place][messageType][codeNumber];
            if (!messObj) {
                console.error("Message doesn't found!");
            }
            var title = messObj.title;
            var text = messObj.text;
            if (value) {
                text = text.replace('{value}', value);
            }
            return { messageType: messageType, title: title, text: text };
        }
    }, {
        key: "showToasterForBrowser",
        value: function showToasterForBrowser(msgObject) {
            try {
                var messageType = msgObject.messageType,
                    title = msgObject.title,
                    text = msgObject.text;

                toastr[this.messageTypes[messageType]](text, title);
            } catch (err) {
                toastr.error('Client side error.', 'Error');
            }
        }
    }]);

    return MessageService;
}();
MessageService = __decorate([core_1.Injectable(), __param(0, core_1.Optional()), __metadata("design:paramtypes", [ionic_message_service_1.IonicMessageServiceProvider])], MessageService);
exports.MessageService = MessageService;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/toastr/toastr.js")))

/***/ }),

/***/ "./shared/services/helpers/random-string-generator.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var RandomStringGeneratorProvider = function RandomStringGeneratorProvider() {
    _classCallCheck(this, RandomStringGeneratorProvider);

    this.getMixedString = function () {
        var numberOfCharacters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;
        return Math.random().toString(36).substr(2, numberOfCharacters);
    };
};
RandomStringGeneratorProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [])], RandomStringGeneratorProvider);
exports.RandomStringGeneratorProvider = RandomStringGeneratorProvider;

/***/ }),

/***/ "./shared/services/helpers/search.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var SearchService = function () {
    function SearchService() {
        _classCallCheck(this, SearchService);
    }

    _createClass(SearchService, [{
        key: "findMatchingNames",
        value: function findMatchingNames(items, search) {
            var param = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'name';

            return items.filter(function (item) {
                var itemName = item[param].toLowerCase();
                return itemName.includes(search.toLowerCase());
            });
        }
    }]);

    return SearchService;
}();
SearchService = __decorate([core_1.Injectable()], SearchService);
exports.SearchService = SearchService;

/***/ }),

/***/ "./shared/services/helpers/string-modifier-service/stringModifier.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var StringModifierServiceProvider = function () {
    function StringModifierServiceProvider() {
        var _this = this;

        _classCallCheck(this, StringModifierServiceProvider);

        this.selectedText = ' (selected)';
        this.cutSelectedText = function (string) {
            var result = string;
            if (_this.isSelectedText(string)) {
                var selectedPointOffset = _this.getSelectedPointOffset(string);
                result = string.substring(0, selectedPointOffset);
            }
            return result;
        };
        this.addSelectedText = function (string) {
            if (_this.isSelectedText(string)) {
                return string;
            }
            string += _this.selectedText;
            return string;
        };
        this.getUsedWorkflowsString = function (workflowNames) {
            var SEPARATOR = ', ';
            var STRING_START = ' (';
            var STRING_END = ')';
            var workflowsNumber = workflowNames.length;
            var isMultipleWorkflows = workflowsNumber > 1;
            var assignedTo = STRING_START + "Assigned to workflow" + (isMultipleWorkflows ? 's:' : ':');
            var workflowsList = '';
            workflowNames.forEach(function (workflowName, index) {
                var isLastElement = index === workflowsNumber - 1;
                workflowsList += workflowName + (isLastElement ? STRING_END : SEPARATOR);
            });
            return assignedTo + " " + workflowsList;
        };
        this.urlEncodDataTransform = function (obj) {
            var str = [];
            for (var p in obj) {
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            }
            return str.join('&');
        };
    }

    _createClass(StringModifierServiceProvider, [{
        key: "getSelectedPointOffset",
        value: function getSelectedPointOffset(string) {
            var selectedPoint = this.selectedText;
            return string.length - selectedPoint.length;
        }
    }, {
        key: "isSelectedText",
        value: function isSelectedText(string) {
            var selectedPoint = this.selectedText;
            return string.endsWith(selectedPoint);
        }
    }, {
        key: "convertAmountIntoNumber",
        value: function convertAmountIntoNumber(value) {
            if (isNaN(value)) {
                var initalValue = value.replace(/[$,]/g, '');
                return Number(initalValue);
            }
            return +value;
        }
    }]);

    return StringModifierServiceProvider;
}();
StringModifierServiceProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [])], StringModifierServiceProvider);
exports.StringModifierServiceProvider = StringModifierServiceProvider;

/***/ }),

/***/ "./shared/services/helpers/time-converter.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var settings_1 = __webpack_require__("./shared/services/settings/settings.ts");
var TimeConverterProvider = function () {
    function TimeConverterProvider(settingsService) {
        _classCallCheck(this, TimeConverterProvider);

        this.settingsService = settingsService;
        this.getTimeFormat();
    }

    _createClass(TimeConverterProvider, [{
        key: "getTimeFormat",
        value: function getTimeFormat() {
            var _this = this;

            this.settingsService.timeFormatSettings.subscribe(function (data) {
                _this.timeFormat = data.timeFormat;
            });
        }
    }, {
        key: "checkPadTime",
        value: function checkPadTime(n) {
            if (isNaN(n)) {
                return '00';
            }
            if (n > 59) {
                return '59';
            }
            return (n < 10 ? '0' : '') + n;
        }
    }, {
        key: "convert24to12",
        value: function convert24to12(hours, minutes) {
            if (this.timeFormat === 'T_24') {
                var h1 = void 0,
                    m1 = void 0,
                    times = void 0;
                var _arrTmp = hours.split(':');
                h1 = _arrTmp[0];
                m1 = _arrTmp[1];
                m1 = this.checkPadTime(+m1);
                h1 = +h1;
                times = h1 + ":" + m1;
                return times;
            }
            if (typeof hours === 'string' && (hours.toUpperCase().includes('AM') || hours.toUpperCase().includes('PM'))) {
                return hours;
            }
            var time = void 0,
                h = void 0,
                m = void 0;
            switch (arguments.length) {
                case 0:
                    console.log('incorrect data');
                    return '12:00 AM';
                case 1:
                    var _arrTmp2 = hours.split(':');
                    h = _arrTmp2[0];
                    m = _arrTmp2[1];
                    break;
                default:
                    h = hours;
                    m = minutes;
            }
            h = isNaN(h) ? '12' : +h;
            m = this.checkPadTime(+m);
            time = h >= 12 ? h - 12 + ":" + m + " PM" : h + ":" + m + " AM";
            if (time.slice(0, 2) === '0:') {
                time = "12" + time.slice(1);
            }
            return time;
        }
    }, {
        key: "convert12to24",
        value: function convert12to24(time) {
            if (!time) {
                return false;
            }
            if (this.timeFormat === 'T_24') {
                var h1 = void 0,
                    m1 = void 0,
                    times = void 0;
                var _arrTmp = time.split(':').join(' ').split(' ');
                h1 = _arrTmp[0];
                m1 = _arrTmp[1];
                m1 = this.checkPadTime(+m1);
                h1 = this.checkPadTime(+h1);
                times = h1 + ":" + m1;
                return times;
            }
            time = time.toLowerCase().replace(/\s/g, '');
            var hours = parseInt(time.substr(0, 2));
            if (time.indexOf('am') !== -1) {
                if (hours === 12) {
                    time = time.replace('12', '00');
                }
                if (hours < 10) {
                    time = "0" + time;
                }
            }
            if (time.indexOf('pm') !== -1 && hours < 12) {
                time = time.replace(hours, hours + 12);
            }
            time = time.replace(/(am|pm)/, '') + ":00";
            return time;
        }
    }, {
        key: "getTimeStringIn24",
        value: function getTimeStringIn24(date) {
            var hours = ("0" + date.getHours()).slice(-2);
            var minutes = ("0" + date.getMinutes()).slice(-2);
            return hours + ":" + minutes + ":00";
        }
    }]);

    return TimeConverterProvider;
}();
TimeConverterProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [settings_1.SettingsProvider])], TimeConverterProvider);
exports.TimeConverterProvider = TimeConverterProvider;

/***/ }),

/***/ "./shared/services/helpers/time-service/time.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var common_1 = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
var time_converter_1 = __webpack_require__("./shared/services/helpers/time-converter.ts");
var TimeServiceProvider = function () {
    function TimeServiceProvider(datePipe,
    // private timeFilter: TimeFilterPipe,
    timeConverter) {
        _classCallCheck(this, TimeServiceProvider);

        this.datePipe = datePipe;
        this.timeConverter = timeConverter;
        this.calcDateRange = function (dueDateString) {
            var minutesPerDay = 86400000;
            var dueDate = new Date(dueDateString);
            var nowDate = new Date();
            var utcDue = Date.UTC(dueDate.getFullYear(), dueDate.getMonth(), dueDate.getDate());
            var utcNow = Date.UTC(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate());
            return Math.floor((utcDue - utcNow) / minutesPerDay);
        };
    }

    _createClass(TimeServiceProvider, [{
        key: "getDateString",
        value: function getDateString(date) {
            if (typeof date === 'string') {
                return date;
            }
            var month = date.getMonth() + 1;
            month = month.toString().length > 1 ? month : "0" + month;
            var day = parseInt(date.getDate());
            var days = day.toString().length > 1 ? day : "0" + day;
            return date.getFullYear() + "-" + month + "-" + days;
        }
    }, {
        key: "formDateNotDependentOnTimezone",
        value: function formDateNotDependentOnTimezone(date) {
            return new Date(date.getFullYear(), date.getMonth(), date.getDate());
        }
    }, {
        key: "getProperDate",
        value: function getProperDate(dateString) {
            if (typeof dateString !== 'undefined' && dateString != null && dateString.length > 19) {
                dateString = dateString.substring(0, 19);
                dateString = dateString.replace(/T/g, ' ');
                dateString = dateString.replace(/\-/g, '/');
                var tempDate = new Date(dateString);
                tempDate = Date.UTC(tempDate.getFullYear(), tempDate.getMonth(), tempDate.getDate(), tempDate.getHours(), tempDate.getMinutes(), tempDate.getSeconds());
                return new Date(tempDate);
            } else if (Object.prototype.toString.call(dateString) === '[object Date]') {
                return new Date(dateString);
            }
            return null;
        }
    }, {
        key: "parseDateFromJSON",
        value: function parseDateFromJSON(key, value) {
            var dateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z$/;
            if (typeof value === 'string' && dateFormat.test(value)) {
                return new Date(value);
            }
            return value;
        }
    }, {
        key: "getTimeExp",
        value: function getTimeExp(dateExp) {
            var regExp = /(\d{1,2})\:(\d{1,2})/;
            return parseInt(dateExp.replace(regExp, '$1$2'));
        }
    }, {
        key: "getDateInFormat",
        value: function getDateInFormat(date, format) {
            var result = void 0,
                ISOString = void 0,
                dateArr = void 0;
            if (!(date instanceof Date)) {
                date = date ? new Date(date) : new Date();
            }
            ISOString = date.toISOString();
            dateArr = ISOString.split('T');
            switch (format) {
                case 'date':
                    result = this.datePipe.transform(date, 'yyyy-MM-dd');
                    break;
                case 'time':
                    result = dateArr[1].split('.')[0];
                    break;
                case 'full':
                    result = this.datePipe.transform(date, "yyyy-MM-dd'T'HH:mm:ss");
                    break;
                default:
                    result = {
                        date: dateArr[0],
                        time: dateArr[1].split('.')[0],
                        fullDate: ISOString.split('.')[0]
                    };
            }
            return result;
        }
    }, {
        key: "isIn24Format",
        value: function isIn24Format() {
            var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

            if (!time) {
                return false;
            }
            return time.endsWith('00') && time.length === 8;
        }
    }, {
        key: "getHour",
        value: function getHour(time) {
            if (time && typeof time === 'string') {
                var tmpArr = time.split(':');
                return parseInt(tmpArr[0], 10);
            }
            return 0;
        }
    }, {
        key: "getMinutes",
        value: function getMinutes(time) {
            if (time && typeof time === 'string') {
                var tmpArr = time.split(':');
                return parseInt(tmpArr[1], 10);
            }
            return 0;
        }
    }, {
        key: "date2Array",
        value: function date2Array(date) {
            if (date) {
                date = this.checkTypeof(date);
                var tmpArr = date.split('-');
                return {
                    year: parseInt(tmpArr[0], 10),
                    month: parseInt(tmpArr[1], 10) - 1,
                    day: parseInt(tmpArr[2], 10)
                };
            }
            return 0;
        }
    }, {
        key: "compareYears",
        value: function compareYears(first, second) {
            if (!first || !second) {
                return false;
            }
            var SEPARATOR = '-';

            var _first$split = first.split(SEPARATOR),
                _first$split2 = _slicedToArray(_first$split, 1),
                firstYear = _first$split2[0];

            var _second$split = second.split(SEPARATOR),
                _second$split2 = _slicedToArray(_second$split, 1),
                secondYear = _second$split2[0];

            return firstYear === secondYear;
        }
    }, {
        key: "compareDates",
        value: function compareDates(first, second) {
            if (first && second) {
                return new Date(first) < new Date(second);
            }
            return false;
        }
    }, {
        key: "getYear",
        value: function getYear(date) {
            if (date) {
                date = this.checkTypeof(date);
                var tmpArr = date.split('-');
                return parseInt(tmpArr[0], 10);
            }
            return 0;
        }
    }, {
        key: "getMonth",
        value: function getMonth(date) {
            if (date) {
                date = this.checkTypeof(date);
                var tmpArr = date.split('-');
                return parseInt(tmpArr[1], 10) - 1;
            }
            return 0;
        }
    }, {
        key: "getDay",
        value: function getDay(date) {
            if (date) {
                date = this.checkTypeof(date);
                var tmpArr = date.split('-');
                return parseInt(tmpArr[2], 10);
            }
            return 0;
        }
    }, {
        key: "checkTypeof",
        value: function checkTypeof(date) {
            return typeof date === 'string' ? date : this.getDateInFormat(date, 'date');
        }
    }, {
        key: "compareTimes",
        value: function compareTimes(first, second) {
            if (first && second) {
                return this.getTimeExp(first) < this.getTimeExp(second);
            }
            return false;
        }
    }, {
        key: "convertDatesToUTC",
        value: function convertDatesToUTC() {
            var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
            var startDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
            var endDate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

            var _this = this;

            var startTime = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
            var endTime = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';

            return arr.map(function (event) {
                if (startDate) {
                    event[startDate] = _this.createDateAsUTC(event[startDate]);
                }
                if (endDate) {
                    event[endDate] = _this.createDateAsUTC(event[endDate]);
                }
                if (startTime) {
                    // event[startTime] = this.timeFilter.transform(event[startTime], '12h');
                }
                if (endTime) {
                    // event[endTime] = this.timeFilter.transform(event[endTime], '12h');
                }
                return event;
            });
        }
    }, {
        key: "getTimeConvertedTo12",
        value: function getTimeConvertedTo12(time) {
            var hours = this.getHour(time);
            var minutes = this.getMinutes(time);
            var l = hours + ":" + minutes;
            return this.timeConverter.convert24to12(l);
        }
    }, {
        key: "convertDateTo12",
        value: function convertDateTo12(dateExp) {
            var d = new Date(dateExp),
                h = d.getHours(),
                m = this.timeConverter.checkPadTime(d.getMinutes());
            var _time = void 0;
            _time = h >= 12 ? h - 12 + ":" + m + " PM" : h + ":" + m + " AM";
            if (_time.slice(0, 2) === '0:') {
                _time = "12" + _time.slice(1);
            }
            return _time;
        }
    }, {
        key: "convertDateTimeForPicker",
        value: function convertDateTimeForPicker(event) {
            var startDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
            var endDate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
            var startTime = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
            var endTime = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';

            var updatedEvent = Object.assign({}, event);
            if (typeof event[startDate] === 'string') {
                if (startDate && updatedEvent[startDate]) {
                    updatedEvent[startDate] = this.createDateAsUTC(event[startDate]);
                }
            }
            if (typeof event[endDate] === 'string') {
                if (endDate && updatedEvent[endDate]) {
                    updatedEvent[endDate] = this.createDateAsUTC(event[endDate]);
                }
            }
            if (startTime) {
                if (updatedEvent[startTime] && this.isIn24Format(updatedEvent[startTime])) {
                    // updatedEvent[startTime] = this.timeFilter.transform(event[startTime], '12h');
                    updatedEvent[startTime] = this.getTimeConvertedTo12(event[startTime]);
                }
            }
            if (endTime) {
                if (updatedEvent[endTime] && this.isIn24Format(updatedEvent[endTime])) {
                    // updatedEvent[endTime] = this.timeFilter.transform(event[endTime], '12h');
                    updatedEvent[endTime] = this.getTimeConvertedTo12(event[endTime]);
                }
                return updatedEvent;
            }
        }
    }, {
        key: "setEndTime",
        value: function setEndTime(startTime, format) {
            var isIn24Format = this.isIn24Format(startTime);
            var startTime24 = isIn24Format ? startTime : this.timeConverter.convert12to24(startTime);
            var startHour = this.getHour(startTime24);
            var startMin = this.getMinutes(startTime24);
            var finishHour = startHour + 1;
            if (finishHour > 23) {
                finishHour = 0;
            }
            if (format === '24h') {
                finishHour = ("0" + finishHour).slice(-2);
                startMin = ("0" + startMin).slice(-2);
                var _endTime = finishHour + ":" + startMin + ":00";
                return _endTime;
            }
            var endTime = finishHour + ":" + startMin;
            return this.timeConverter.convert24to12(endTime);
        }
    }, {
        key: "createDateAsUTC",
        value: function createDateAsUTC(date) {
            var time = new Date(date).getTime();
            date = new Date(time);
            return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
        }
    }, {
        key: "calcDate",
        value: function calcDate(date1, date2) {
            var days = void 0,
                day = void 0,
                diff = void 0;
            diff = Math.floor(date1.getTime() - date2.getTime());
            day = 1000 * 60 * 60 * 24;
            days = Math.floor(diff / day);
            return days;
        }
    }, {
        key: "getDateAndTime",
        value: function getDateAndTime(date) {
            var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

            var zeroHours = '00:00:00';
            if (!time) {
                time = zeroHours;
            }
            return new Date(date + " " + time);
        }
    }, {
        key: "convertTimeToSeconds",
        value: function convertTimeToSeconds(time) {
            if (time) {
                var timeArr = time.split(':');
                // minutes are worth 60 seconds. Hours are worth 60 minutes.
                return +timeArr[0] * 60 * 60 + +timeArr[1] * 60 + +timeArr[2];
            }
            return 0;
        }
    }]);

    return TimeServiceProvider;
}();
TimeServiceProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [common_1.DatePipe, time_converter_1.TimeConverterProvider])], TimeServiceProvider);
exports.TimeServiceProvider = TimeServiceProvider;

/***/ }),

/***/ "./shared/services/helpers/validation.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var ValidationProvider = function () {
    function ValidationProvider() {
        _classCallCheck(this, ValidationProvider);
    }

    _createClass(ValidationProvider, [{
        key: "isEmailValid",
        value: function isEmailValid(email) {
            var pattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return pattern.test(email);
        }
    }, {
        key: "isStringEmpty",
        value: function isStringEmpty(string) {
            var emptyString = !string || string.trim() === '';
            return emptyString;
        }
    }, {
        key: "isStringCyrillic",
        value: function isStringCyrillic(string) {
            return (/[\w\u0430-\u044f]+/gi.test(string)
            );
        }
    }, {
        key: "isStringEmptySMTP",
        value: function isStringEmptySMTP(string) {
            if (typeof string === 'string') {
                if (string) {
                    var str = string.trim();
                    var emptyString = !str;
                    return emptyString;
                }
            }
            return true;
        }
    }, {
        key: "trimHTML",
        value: function trimHTML(html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            return doc.body.textContent || '';
        }
    }, {
        key: "isModalClosePrevented",
        value: function isModalClosePrevented(input) {
            input.on('keypress', function (e) {
                var keyCode = e.keyCode || e.which;
                if (keyCode === 13) {
                    e.preventDefault();
                }
            });
        }
    }], [{
        key: "emailValidator",
        value: function emailValidator(control) {
            if (control.value && control.value.match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
                return null;
            }
            return { invalidEmail: true };
        }
    }, {
        key: "noWhitespaceValidator",
        value: function noWhitespaceValidator(control) {
            var isWhitespace = (control.value || '').trim().length === 0;
            var isValid = !isWhitespace;
            return isValid ? null : { whitespace: true };
        }
    }, {
        key: "numberMinMax",
        value: function numberMinMax() {
            var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { min: 1, max: 9 };

            return function (control) {
                var val = control.value;
                if (isNaN(val)) {
                    return null;
                }
                if (val < params.min) {
                    return { valid: false };
                } else if (val > params.max) {
                    return { valid: false };
                }
                return { valid: true };
            };
        }
    }, {
        key: "positiveNumberValidator",
        value: function positiveNumberValidator() {
            return function (control) {
                var isNegative = Number(control.value) < 0;
                return isNegative ? { nonPositive: { value: control.value } } : null;
            };
        }
    }, {
        key: "decimalValidator",
        value: function decimalValidator() {
            var numbersAfterPoint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

            return function (control) {
                var value = control.value;

                if (!value) {
                    return null;
                }

                var _value$toString$split = value.toString().split('.'),
                    _value$toString$split2 = _slicedToArray(_value$toString$split, 2),
                    decimalPart = _value$toString$split2[1];

                if (!decimalPart) {
                    return { valid: true };
                }
                if (decimalPart && decimalPart.length > numbersAfterPoint) {
                    return { valid: false };
                }
                return { valid: true };
            };
        }
    }]);

    return ValidationProvider;
}();
ValidationProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [])], ValidationProvider);
exports.ValidationProvider = ValidationProvider;

/***/ }),

/***/ "./shared/services/integrations/integrations.data.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = __webpack_require__("./node_modules/@angular/common/esm5/http.js");
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var settings_1 = __webpack_require__("./shared/services/settings/settings.ts");
var IntegrationsDataProvider = function () {
    function IntegrationsDataProvider(http, settingsProvider) {
        _classCallCheck(this, IntegrationsDataProvider);

        this.http = http;
        this.settingsProvider = settingsProvider;
        this.INTEGRATION_STATUS_URL = '/api/user/integrations';
        this.INTEGRATION_STATUS_URL_V1 = '/api/user/v1/integrations';
        this.XERO_SETTINGS_URL = '/api/user/xero/settings';
        this.XERO_AUTH_URL = '/api/user/xero/authenticate';
        this.XERO_CALLBACK_URL = '/api/user/xero/callback';
        this.XERO_AUTHORIZED_CONNECTIONS = '/api/user/v1/xero/authorised-connections';
        this.QUICKBOOKS_AUTH_URL = '/api/user/qb/connect';
        this.QUICKBOOKS_CALLBACK_URL = '/api/user/qb/callback';
        this.QUICKBOOKS_SETTINGS_URL = '/api/user/qb/settings';
        this.SHOOTPROOF_AUTH_URL = '/api/user/shootproof/authUrl';
        this.SHOOTPROOF_SETTINGS_URL = '/api/user/shootproof/settings';
        this.SHOOTPROOF_EXISTING_SETTINGS_URL = '/api/user/shootproof/settings/existing';
        this.SHOOTPROOF_CREATE_GALLERY_URL = '/api/user/shootproof/galleries/create';
        this.SHOOTPROOF_SELECT_GALLERY_URL = '/api/user/shootproof/galleries/attach';
    }

    _createClass(IntegrationsDataProvider, [{
        key: "getIntegrationsV1",
        value: function getIntegrationsV1() {
            return this.http.get(this.INTEGRATION_STATUS_URL_V1);
        }
    }, {
        key: "getXeroAuthorizedConnections",
        value: function getXeroAuthorizedConnections(url) {
            return this.http.get(url || this.XERO_AUTHORIZED_CONNECTIONS);
        }
    }, {
        key: "connectXeroV2",
        value: function connectXeroV2(url, payload) {
            return this.http.post(url, payload);
        }
    }, {
        key: "disconnectXeroV2",
        value: function disconnectXeroV2(url) {
            return this.http.post(url, {});
        }
        // XERO

    }, {
        key: "getIntegrationOrganization",
        value: function getIntegrationOrganization() {
            return this.http.get(this.INTEGRATION_STATUS_URL);
        }
    }, {
        key: "initXeroIntegration",
        value: function initXeroIntegration() {
            return this.http.get(this.XERO_AUTH_URL);
        }
    }, {
        key: "editXeroSettings",
        value: function editXeroSettings() {
            return this.http.get(this.XERO_SETTINGS_URL);
        }
    }, {
        key: "editXeroSettingsById",
        value: function editXeroSettingsById(data) {
            return this.http.put(this.XERO_SETTINGS_URL, data);
        }
    }, {
        key: "createXeroSettings",
        value: function createXeroSettings(data) {
            return this.http.post(this.XERO_SETTINGS_URL, data);
        }
    }, {
        key: "disconnectXero",
        value: function disconnectXero() {
            return this.http.delete(this.XERO_SETTINGS_URL);
        }
    }, {
        key: "sendXeroToken",
        value: function sendXeroToken(token) {
            var params = new http_1.HttpParams();
            Object.keys(token).forEach(function (key) {
                params = params.append(key, token[key]);
            });
            return this.http.get(this.XERO_CALLBACK_URL, { params: params });
        }
    }, {
        key: "copyInvoiceToXero",
        value: function copyInvoiceToXero(id) {
            var url = "/api/user/xero/invoices/" + id + "/copyToXero";
            return this.http.put(url, {});
        }
        // QUICKBOOKS

    }, {
        key: "initQuickbooksIntegration",
        value: function initQuickbooksIntegration() {
            return this.http.get(this.QUICKBOOKS_AUTH_URL);
        }
    }, {
        key: "disconnectQuickbooks",
        value: function disconnectQuickbooks() {
            return this.http.delete(this.QUICKBOOKS_SETTINGS_URL);
        }
    }, {
        key: "sendQuickbooksToken",
        value: function sendQuickbooksToken(params) {
            var parameters = new http_1.HttpParams().set('code', params.code).set('state', params.state).set('realmId', params.realmId);
            return this.http.get(this.QUICKBOOKS_CALLBACK_URL, { params: parameters });
        }
    }, {
        key: "editQuickBooksSettings",
        value: function editQuickBooksSettings() {
            return this.http.get(this.QUICKBOOKS_SETTINGS_URL);
        }
    }, {
        key: "saveQuickbooksSettings",
        value: function saveQuickbooksSettings(isSettingsToUpdate, data) {
            var method = isSettingsToUpdate ? 'put' : 'post';
            return this.http[method](this.QUICKBOOKS_SETTINGS_URL, data);
        }
    }, {
        key: "copyInvoiceToQuickbooks",
        value: function copyInvoiceToQuickbooks(id) {
            var url = "/api/user/qb/invoices/" + id;
            return this.http.put(url, {});
        }
        //    SHOOTPROOF

    }, {
        key: "initShootProofIntegration",
        value: function initShootProofIntegration() {
            return this.http.get(this.SHOOTPROOF_AUTH_URL);
        }
    }, {
        key: "disconnectShootProof",
        value: function disconnectShootProof() {
            return this.http.delete(this.SHOOTPROOF_SETTINGS_URL);
        }
    }, {
        key: "setShootProofSettings",
        value: function setShootProofSettings(method, text, code) {
            var data = {};
            if (code) {
                data.code = code;
            }
            if (text) {
                data.clientPortalText = text;
            }
            return this.http[method](this.SHOOTPROOF_SETTINGS_URL, data);
        }
    }, {
        key: "getShootProofSettings",
        value: function getShootProofSettings() {
            return this.http.get(this.SHOOTPROOF_SETTINGS_URL);
        }
    }, {
        key: "getExistingSpSettings",
        value: function getExistingSpSettings() {
            return this.http.get(this.SHOOTPROOF_EXISTING_SETTINGS_URL);
        }
    }, {
        key: "createNewSpGallery",
        value: function createNewSpGallery(data) {
            return this.http.post(this.SHOOTPROOF_CREATE_GALLERY_URL, data);
        }
    }, {
        key: "getDefaultsForBrand",
        value: function getDefaultsForBrand(selectedBrand) {
            var url = "/api/user/shootproof/brands/" + selectedBrand.key + "/defaults";
            return this.http.get(url);
        }
    }, {
        key: "getGalleriesForBrand",
        value: function getGalleriesForBrand(selectedBrand) {
            var url = "/api/user/shootproof/galleries/list?brandId=" + selectedBrand.key;
            return this.http.get(url);
        }
    }, {
        key: "selectExistingSpGallery",
        value: function selectExistingSpGallery(data) {
            return this.http.post(this.SHOOTPROOF_SELECT_GALLERY_URL, data);
        }
    }, {
        key: "deleteShootProofGalleryFromSN",
        value: function deleteShootProofGalleryFromSN(id) {
            var url = "/api/user/shootproof/galleries/" + id + "/snonly";
            return this.http.delete(url);
        }
    }, {
        key: "deleteShootProofGalleryFromBoth",
        value: function deleteShootProofGalleryFromBoth(id) {
            var url = "/api/user/shootproof/galleries/" + id + "/includingsp";
            return this.http.delete(url);
        }
        // Fundy

    }, {
        key: "updateFundyIntegrationState",
        value: function updateFundyIntegrationState(state) {
            return this.settingsProvider.updateFundyIntegration(state);
        }
        // ProSelect

    }, {
        key: "updateProSelectIntegrationState",
        value: function updateProSelectIntegrationState(state) {
            return this.settingsProvider.updateProSelectIntegration(state);
        }
    }]);

    return IntegrationsDataProvider;
}();
IntegrationsDataProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [http_1.HttpClient, settings_1.SettingsProvider])], IntegrationsDataProvider);
exports.IntegrationsDataProvider = IntegrationsDataProvider;

/***/ }),

/***/ "./shared/services/integrations/integrations.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var BehaviorSubject_1 = __webpack_require__("./node_modules/rxjs/BehaviorSubject.js");
var IntegrationsServiceProvider = function () {
    function IntegrationsServiceProvider() {
        _classCallCheck(this, IntegrationsServiceProvider);

        this.successSavedGallery = new BehaviorSubject_1.BehaviorSubject(false);
    }

    _createClass(IntegrationsServiceProvider, [{
        key: "emitGalleriesUpdateEvent",
        value: function emitGalleriesUpdateEvent(value) {
            return this.successSavedGallery.next(value);
        }
    }, {
        key: "destroyGalleriesUpdatedObservable",
        value: function destroyGalleriesUpdatedObservable() {
            this.successSavedGallery.next(false);
        }
    }, {
        key: "createTextForApplyConfirm",
        value: function createTextForApplyConfirm(clients) {
            var _clients = _slicedToArray(clients, 2),
                primaryClient = _clients[0],
                secondaryClient = _clients[1];

            if (secondaryClient) {
                return "Copy clients <strong>" + primaryClient.name + " (" + primaryClient.email + ")</strong> and <strong>" + secondaryClient.name + " (" + secondaryClient.email + ")</strong> to this gallery's Pic-Time Share settings? <br>\n \t\t\tYou will need to invite this client from Pic-Time so that they can view the gallery.";
            }
            return "Copy client <strong>" + primaryClient.name + " (" + primaryClient.email + ")</strong> to this gallery's Pic-Time Share settings? <br>\n \t\t\tYou will need to invite this client from Pic-Time so that they can view the gallery.";
        }
    }, {
        key: "getXeroStatusText",
        value: function getXeroStatusText(status) {
            switch (status) {
                case 'COPIED_TO_XERO':
                    return {
                        text: 'COPIED TO XERO',
                        cssClass: 'bg-sky color-white'
                    };
                case 'FAILED_TO_COPY':
                    return {
                        text: 'FAILED TO COPY TO XERO',
                        cssClass: 'bg-orange color-white'
                    };
                case 'DISCONNECTED_XERO_INVOICE_ALTERED':
                    return {
                        text: 'DISCONNECTED - XERO INVOICE ALTERED',
                        cssClass: 'bg-froly-dark color-white'
                    };
                default:
                    return {
                        text: '',
                        cssClass: ''
                    };
            }
        }
    }, {
        key: "getQuickbooksStatusText",
        value: function getQuickbooksStatusText(status) {
            switch (status) {
                case 'COPIED':
                    return {
                        text: 'COPIED TO QUICKBOOKS',
                        cssClass: 'bg-green color-white'
                    };
                case 'FAILED_TO_COPY':
                    return {
                        text: 'FAILED TO COPY TO QUICKBOOKS',
                        cssClass: 'bg-orange color-white'
                    };
                case 'DISCONNECTED_INVOICE_ALTERED':
                    return {
                        text: 'DISCONNECTED - QUICKBOOKS INVOICE ALTERED',
                        cssClass: 'bg-froly-dark color-white'
                    };
                default:
                    return {
                        text: '',
                        cssClass: ''
                    };
            }
        }
    }, {
        key: "shouldGalleriesBeUpdatedObservable",
        get: function get() {
            return this.successSavedGallery.asObservable();
        }
    }]);

    return IntegrationsServiceProvider;
}();
IntegrationsServiceProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [])], IntegrationsServiceProvider);
exports.IntegrationsServiceProvider = IntegrationsServiceProvider;

/***/ }),

/***/ "./shared/services/integrations/pickTime/pickTime.data.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var http_1 = __webpack_require__("./node_modules/@angular/common/esm5/http.js");
var PickTimeDataProvider = function () {
    function PickTimeDataProvider(http) {
        _classCallCheck(this, PickTimeDataProvider);

        this.http = http;
    }

    _createClass(PickTimeDataProvider, [{
        key: "initPickTimeIntegration",
        value: function initPickTimeIntegration() {
            var PICK_TIME_INTEGRATION_URL = '/api/user/pictime/connect';
            return this.http.get(PICK_TIME_INTEGRATION_URL);
        }
    }, {
        key: "savePickTimeIntegration",
        value: function savePickTimeIntegration(authObj) {
            var SAVE_PICK_TIME_INTEGRATION_URL = '/api/user/integrations/pictime/oauth';
            return this.http.post(SAVE_PICK_TIME_INTEGRATION_URL, authObj);
        }
    }, {
        key: "updatePicTimeIntegration",
        value: function updatePicTimeIntegration(data) {
            var UPDATE_PIC_TIME_INTEGRATION_URL = '/api/user/pictime/update';
            return this.http.put(UPDATE_PIC_TIME_INTEGRATION_URL, data);
        }
    }, {
        key: "getPreFillPicTimeSettings",
        value: function getPreFillPicTimeSettings() {
            var url = '/api/user/integrations/pictime';
            return this.http.get(url);
        }
    }, {
        key: "disconnectPickTimeIntegration",
        value: function disconnectPickTimeIntegration(url) {
            return this.http.post(url, null);
        }
    }, {
        key: "getPicTimeActions",
        value: function getPicTimeActions(jobId) {
            var url = "/api/user/pictime/job/" + jobId + "/gallery/overview";
            return this.http.get(url);
        }
    }, {
        key: "getImportPicTimeGalleries",
        value: function getImportPicTimeGalleries() {
            var url = '/api/user/pictime/gallery-for-import/get';
            return this.http.get(url);
        }
    }, {
        key: "getPicTimeGalleries",
        value: function getPicTimeGalleries(jobId) {
            var url = "/api/user/pictime/job/" + jobId + "/galleries/get";
            return this.http.get(url);
        }
    }, {
        key: "syncPicTimeGallery",
        value: function syncPicTimeGallery(url, method) {
            return this.http[method.toLowerCase()](url, {});
        }
    }, {
        key: "importSelectedPicTimeGalleries",
        value: function importSelectedPicTimeGalleries(jobId, selectedPicTimeGalleriesToSend) {
            var url = "/api/user/pictime/job/" + jobId + "/gallery/import";
            return this.http.post(url, selectedPicTimeGalleriesToSend);
        }
    }, {
        key: "createPicTimeGallery",
        value: function createPicTimeGallery(jobId, galleryDetails) {
            var url = "/api/user/pictime/job/" + jobId + "/gallery/create";
            return this.http.post(url, galleryDetails);
        }
    }, {
        key: "deletePicTimeGallery",
        value: function deletePicTimeGallery(url) {
            return this.http.delete(url);
        }
    }, {
        key: "getJobMetadata",
        value: function getJobMetadata(jobId) {
            var url = "/api/user/pictime/job/" + jobId + "/metadata";
            return this.http.get(url);
        }
    }, {
        key: "getPicTimeTemplates",
        value: function getPicTimeTemplates() {
            var url = '/api/user/pictime/project-template-get';
            return this.http.get(url);
        }
    }]);

    return PickTimeDataProvider;
}();
PickTimeDataProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [http_1.HttpClient])], PickTimeDataProvider);
exports.PickTimeDataProvider = PickTimeDataProvider;

/***/ }),

/***/ "./shared/services/integrations/shootProof/shootProof.data.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = __webpack_require__("./node_modules/@angular/common/esm5/http.js");
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var ShootProofDataProvider = function () {
    function ShootProofDataProvider(http) {
        _classCallCheck(this, ShootProofDataProvider);

        this.http = http;
    }

    _createClass(ShootProofDataProvider, [{
        key: "initShootProofIntegrationV1",
        value: function initShootProofIntegrationV1() {
            var url = '/api/user/v1/shootproof/authentication';
            return this.http.get(url);
        }
    }, {
        key: "disconnectShootProofV1",
        value: function disconnectShootProofV1() {
            var url = '/api/user/v1/shootproof/integration';
            return this.http.delete(url);
        }
    }, {
        key: "setShootProofSettingsV1",
        value: function setShootProofSettingsV1(settings) {
            var url = '/api/user/v1/shootproof/integration';
            return this.http.post(url, settings);
        }
    }, {
        key: "updateShootProofSettingsV1",
        value: function updateShootProofSettingsV1(settings) {
            var url = '/api/user/v1/shootproof/integration';
            return this.http.put(url, settings);
        }
    }, {
        key: "getExistingShootProofSettingsV1",
        value: function getExistingShootProofSettingsV1() {
            var url = '/api/user/v1/shootproof/integration';
            return this.http.get(url);
        }
        // SHOOTPROOF GALERIES

    }, {
        key: "getJobGalleriesV1",
        value: function getJobGalleriesV1(jobId) {
            var url = "/api/user/v1/job/" + jobId + "/gallery";
            return this.http.get(url);
        }
    }, {
        key: "removeJobGalleryV1",
        value: function removeJobGalleryV1(galleryId) {
            var removeFromShootProof = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var url = "/api/user/v1/shootproof/gallery/" + galleryId + "?removeFromShootProof=" + removeFromShootProof;
            return this.http.delete(url);
        }
    }, {
        key: "getBrandsForGalleriesV1",
        value: function getBrandsForGalleriesV1() {
            var url = '/api/user/v1/shootproof/brand';
            return this.http.get(url);
        }
    }, {
        key: "getGalleriesToImportV1",
        value: function getGalleriesToImportV1(shootProofBrandId) {
            var url = "/api/user/v1/shootproof/gallery?brandId=" + shootProofBrandId;
            return this.http.get(url);
        }
    }, {
        key: "selectExistingGaleryV1",
        value: function selectExistingGaleryV1(galleryDetails) {
            var url = '/api/user/v1/shootproof/gallery/import';
            return this.http.post(url, galleryDetails);
        }
    }, {
        key: "getGalleryPresetsV1",
        value: function getGalleryPresetsV1(shootProofBrandId) {
            var url = "/api/user/v1/shootproof/gallery-preset?brandId=" + shootProofBrandId;
            return this.http.get(url);
        }
    }, {
        key: "createShootProofNewGalleryFromSNV1",
        value: function createShootProofNewGalleryFromSNV1(galleryDetails) {
            var url = '/api/user/v1/shootproof/gallery/create';
            return this.http.post(url, galleryDetails);
        }
    }]);

    return ShootProofDataProvider;
}();
ShootProofDataProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [http_1.HttpClient])], ShootProofDataProvider);
exports.ShootProofDataProvider = ShootProofDataProvider;

/***/ }),

/***/ "./shared/services/invoice/invoice-service/invoice.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var time_service_1 = __webpack_require__("./shared/services/helpers/time-service/time.service.ts");
var payments_service_1 = __webpack_require__("./shared/services/payments/payments-service/payments.service.ts");
var validation_service_1 = __webpack_require__("./shared/services/helpers/validation.service.ts");
var InvoiceServiceProvider = function () {
    function InvoiceServiceProvider(messageService, timeService, paymentsService, validationService) {
        _classCallCheck(this, InvoiceServiceProvider);

        this.messageService = messageService;
        this.timeService = timeService;
        this.paymentsService = paymentsService;
        this.validationService = validationService;
        this.paymentActions = {
            WRITE_OFF: {
                value: 'writeoff',
                label: 'Write off',
                type: 'radio'
            },
            UNDO_WRITE_OFF: {
                value: 'undoWriteoff',
                label: 'Undo',
                type: 'radio'
            },
            RECORD: {
                value: 'record',
                label: 'Record payment',
                type: 'radio'
            },
            PAY_ONLINE: {
                value: 'pay',
                label: 'Pay online',
                type: 'radio'
            },
            SEND_RECEIPT: {
                value: 'sendReceipt',
                label: 'Send receipt',
                type: 'radio'
            },
            MARK_UNPAID: {
                value: 'unpaid',
                label: 'Mark as unpaid',
                type: 'radio'
            }
        };
    }

    _createClass(InvoiceServiceProvider, [{
        key: "handleErrorGetInvoice",
        value: function handleErrorGetInvoice() {
            var errorMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

            if (errorMessage) {
                this.messageService.showToaster('e_2', 'general', errorMessage);
            } else {
                this.messageService.showToaster('e_0', 'general');
            }
        }
    }, {
        key: "errorGetInvoiceInformation",
        value: function errorGetInvoiceInformation(_ref) {
            var data = _ref.data,
                status = _ref.status;

            var errorMessage = data ? data.errorMessage : null;
            if (status >= 400 && status < 500 && errorMessage) {
                if (errorMessage.includes('not found')) {
                    this.messageService.showToaster('e_5', 'editInvoice');
                    return;
                }
                this.messageService.showToaster('e_2', 'general', errorMessage);
            } else {
                this.messageService.showToaster('e_0', 'general');
            }
        }
    }, {
        key: "setFormattedDaysToDue",
        value: function setFormattedDaysToDue(items) {
            var _this = this;

            items.forEach(function (invoice) {
                var dayMulti = _this.addDayMulti(invoice.daysToDue);
                if (invoice.daysToDue === 0) {
                    invoice.formattedDaysToDue = 'today';
                } else if (invoice.daysToDue > 0) {
                    invoice.formattedDaysToDue = "in " + (invoice.daysToDue + dayMulti);
                } else {
                    invoice.formattedDaysToDue = "" + Math.abs(invoice.daysToDue) + dayMulti + " ago";
                }
            });
            return items;
        }
    }, {
        key: "isInvalidProduct",
        value: function isInvalidProduct(product, pageName) {
            var messagePlace = pageName === 'invoicePage' ? 'editInvoice' : 'editQuote';
            var escapedDescription = product.description ? this.validationService.trimHTML(product.description).trim() : '';
            if (product.type !== 'GIFT' && (!product.description || product.description.length === 0 || !escapedDescription)) {
                this.messageService.showToaster('e_12', messagePlace);
                return true;
            }
            return false;
        }
    }, {
        key: "errorMarkAsPaid",
        value: function errorMarkAsPaid(_ref2) {
            var status = _ref2.status,
                data = _ref2.data;

            var errorMessage = data ? data.errorMessage : null;
            var errorCode = void 0,
                errorPlace = void 0,
                value = void 0;
            if (status >= 400 && status < 500 && errorMessage) {
                if (errorMessage === 'Payment already paid') {
                    errorCode = 'e_10';
                    errorPlace = 'editInvoice';
                } else if (errorMessage === "Xero payments don't match StudioNinja payments") {
                    errorCode = 'e_0';
                    errorPlace = 'xero';
                } else if (errorMessage === 'Invoice not synchronized with Xero') {
                    errorCode = 'e_9';
                    errorPlace = 'xero';
                } else if (errorMessage.includes('Xero access token expired, reconnect Xero please') || errorMessage.includes('Bummer! Xero access token not authorized or revoked, reconnect Xero please') || errorMessage.includes('Bummer! Xero access token revoked, reconnect Xero please')) {
                    errorCode = 'e_14';
                    errorPlace = 'xero';
                } else if (errorMessage.includes("Bummer! You don't have an active Xero subscription.")) {
                    errorCode = 'e_15';
                    errorPlace = 'xero';
                } else {
                    errorCode = 'e_2';
                    errorPlace = 'general';
                    value = errorMessage;
                }
            } else {
                errorCode = 'e_0';
                errorPlace = 'general';
            }
            this.messageService.showToaster(errorCode, errorPlace, value);
        }
    }, {
        key: "errorSetUnpaid",
        value: function errorSetUnpaid(_ref3) {
            var status = _ref3.status,
                data = _ref3.data;

            var errorMessage = data ? data.errorMessage : null;
            var errorCode = void 0,
                errorPlace = void 0,
                value = void 0;
            if (status >= 400 && status < 500 && errorMessage) {
                if (errorMessage.includes('This payment cannot be marked as unpaid because it was overpaid in Xero.')) {
                    errorCode = 'e_11';
                    errorPlace = 'xero';
                } else {
                    errorCode = 'e_2';
                    errorPlace = 'general';
                    value = errorMessage;
                }
            } else {
                errorCode = 'e_0';
                errorPlace = 'general';
            }
            this.messageService.showToaster(errorCode, errorPlace, value);
        }
    }, {
        key: "errorDeleteInvoice",
        value: function errorDeleteInvoice(_ref4) {
            var status = _ref4.status,
                data = _ref4.data;

            var errorMessage = data ? data.errorMessage : null;
            var errorCode = void 0,
                errorPlace = void 0,
                value = void 0;
            if (status >= 400 && status < 500 && errorMessage) {
                if (errorMessage.includes('This payment cannot be marked as unpaid because it was overpaid in Xero.')) {
                    errorCode = 'e_12';
                    errorPlace = 'xero';
                    value = 'invoice';
                } else if (errorMessage.includes('Xero access token expired, reconnect Xero please') || errorMessage.includes('Bummer! Xero access token not authorized or revoked, reconnect Xero please') || errorMessage.includes('Bummer! Xero access token revoked, reconnect Xero please')) {
                    errorCode = 'e_14';
                    errorPlace = 'xero';
                } else if (errorMessage.includes("Bummer! You don't have an active Xero subscription.")) {
                    errorCode = 'e_15';
                    errorPlace = 'xero';
                } else {
                    errorCode = 'e_2';
                    errorPlace = 'general';
                    value = errorMessage;
                }
            } else {
                errorCode = 'e_0';
                errorPlace = 'general';
            }
            this.messageService.showToaster(errorCode, errorPlace, value);
        }
    }, {
        key: "errorSaveInvoice",
        value: function errorSaveInvoice(errorObject, invoiceId) {
            var error = errorObject.error,
                status = errorObject.status;

            var errorMessage = error ? error.errorMessage : null;
            var errorTitle = error ? error.errorTitle : null;
            var errorCode = void 0,
                errorPlace = void 0,
                value = void 0;
            if (errorMessage && status >= 400 && status < 500) {
                if (errorTitle && errorMessage) {
                    this.messageService.showErrorFromBackend(errorTitle, errorMessage);
                } else {
                    if (errorMessage === "Paid or partially paid invoice can't be updated on Xero") {
                        errorCode = 'e_5';
                        errorPlace = 'xero';
                    } else if (errorMessage.includes('already exists/existed')) {
                        errorCode = 'e_8';
                        errorPlace = 'editInvoice';
                        value = invoiceId;
                    } else if (errorMessage === 'You have reached the limit of invoices you can approve') {
                        errorCode = 'e_11';
                        errorPlace = 'editInvoice';
                    } else if (errorMessage === 'Fixed discount is not compatible with Xero') {
                        errorCode = 'e_1';
                        errorPlace = 'xero';
                    } else if (errorMessage === 'Product/Package tax type is not compatible with Xero') {
                        errorCode = 'e_4';
                        errorPlace = 'xero';
                    } else if (errorMessage === 'Invoice with such invoice ID (Invoice Number) exists on Xero') {
                        errorCode = 'e_6';
                        errorPlace = 'xero';
                        value = invoiceId;
                    } else if (errorMessage === 'Invoice should have the same tax type for all products') {
                        errorCode = 'e_0';
                        errorPlace = 'qb';
                    } else if (errorMessage === "QuickBooks doesn't allow Inclusive tax for US users") {
                        errorCode = 'e_3';
                        errorPlace = 'qb';
                    } else if (errorMessage === 'QuickBooks access token has been revoked, connect QuickBooks again') {
                        errorCode = 'e_4';
                        errorPlace = 'qb';
                    } else if (errorMessage === 'Sorry, your invoice data contains characters incompatible with QuickBooks') {
                        errorCode = 'e_10';
                        errorPlace = 'qb';
                    } else if (errorMessage === "We're sorry, QuickBooks encountered an error while calculating tax. Try reselecting the tax rate or reentering the product/service item and saving the form again.") {
                        errorCode = 'e_9';
                        errorPlace = 'qb';
                    } else if (errorMessage.includes('Email Address does not conform to the syntax rules of RFC 822')) {
                        errorCode = 'e_18';
                        errorPlace = 'qb';
                    } else if (errorMessage === 'QuickBooks customer linked to this invoice has been deleted') {
                        errorCode = 'e_20';
                        errorPlace = 'qb';
                    } else if (errorMessage === 'Fixed discounts with exclusive amounts are not allowed') {
                        errorCode = 'e_22';
                        errorPlace = 'qb';
                    } else if (errorMessage.includes('Category with such name already exists on QuickBooks')) {
                        errorCode = 'e_24';
                        errorPlace = 'qb';
                    } else if (errorMessage.startsWith('QB: Impossible to create invoice with Product')) {
                        errorCode = 'e_25';
                        errorPlace = 'qb';
                    } else if (errorMessage.includes('String length specified does not match the supported length. Min:0 Max:100 supported.')) {
                        errorCode = 'e_26';
                        errorPlace = 'qb';
                    } else if (errorMessage.includes('String length specified does not match the supported length. Min:0 Max:21 supported.')) {
                        errorCode = 'e_27';
                        errorPlace = 'qb';
                    } else if (errorMessage.includes('String length specified does not match the supported length. Min:0 Max:4,000 supported.')) {
                        errorCode = 'e_28';
                        errorPlace = 'qb';
                    } else if (errorMessage.includes('Xero access token expired, reconnect Xero please') || errorMessage.includes('Bummer! Xero access token not authorized or revoked, reconnect Xero please') || errorMessage.includes('Bummer! Xero access token revoked, reconnect Xero please')) {
                        errorCode = 'e_14';
                        errorPlace = 'xero';
                    } else if (errorMessage.includes("You don't have an active Xero subscription")) {
                        errorCode = 'e_15';
                        errorPlace = 'xero';
                    } else if (errorMessage.includes('This Invoice ID is already used. Please enter another one')) {
                        errorCode = 'e_13';
                        errorPlace = 'editInvoice';
                    } else if (errorMessage.includes('You cannot change the total of this invoice to a smaller amount than has already been paid.')) {
                        errorCode = 'e_4';
                        errorPlace = 'editInvoice';
                    } else if (errorMessage.includes('Invoice total amount should be more or equals then paid part of this invoice')) {
                        errorCode = 'e_4';
                        errorPlace = 'editInvoice';
                    } else {
                        errorCode = 'e_2';
                        errorPlace = 'general';
                        value = errorMessage;
                    }
                    this.messageService.showToaster(errorCode, errorPlace, value);
                }
            } else {
                errorCode = 'e_0';
                errorPlace = 'general';
                this.messageService.showToaster(errorCode, errorPlace, value);
            }
        }
    }, {
        key: "errorWriteOff",
        value: function errorWriteOff(data) {
            if (data.errorMessage === 'Write off feature disabled for copied to QuickBooks invoices') {
                this.messageService.showToaster('e_16', 'qb');
            } else {
                this.messageService.showDefaultErrorMessage(data);
            }
        }
    }, {
        key: "errorCopyToXero",
        value: function errorCopyToXero(error, invoiceDisplayId) {
            var data = error.data,
                status = error.status;

            var errorMessage = data ? data.errorMessage : null;
            var errorCode = void 0,
                errorPlace = void 0,
                value = void 0;
            if (errorMessage && status >= 400 && status < 500) {
                switch (errorMessage) {
                    case "Paid or partially paid invoice can't be updated on Xero":
                        errorCode = 'e_5';
                        errorPlace = 'xero';
                        break;
                    case 'Invoice with such invoice ID (Invoice Number) exists on Xero':
                        errorCode = 'e_6';
                        errorPlace = 'xero';
                        value = invoiceDisplayId;
                        break;
                    case 'Product/Package tax type is not compatible with Xero':
                        errorCode = 'e_4';
                        errorPlace = 'xero';
                        break;
                    case 'Fixed discount is not compatible with Xero':
                        errorCode = 'e_1';
                        errorPlace = 'xero';
                        break;
                    case 'Invoice is Voided or Deleted on Xero':
                        errorCode = 'e_3';
                        errorPlace = 'xero';
                        break;
                    case 'Invoice with written off payments is not compatible with Xero':
                        errorCode = 'e_7';
                        errorPlace = 'xero';
                        break;
                    case 'Xero access token expired, reconnect Xero please':
                        errorCode = 'e_14';
                        errorPlace = 'xero';
                        break;
                    case 'Bummer! Xero access token not authorized or revoked, reconnect Xero please':
                        errorCode = 'e_14';
                        errorPlace = 'xero';
                        break;
                    case 'Bummer! Xero access token revoked, reconnect Xero please':
                        errorCode = 'e_14';
                        errorPlace = 'xero';
                        break;
                    case "Bummer! You don't have an active Xero subscription.":
                        errorCode = 'e_15';
                        errorPlace = 'xero';
                        break;
                    default:
                        this.messageService.showErrorFromBackend('Houston, we have a Xero problem!!');
                        return;
                }
            } else {
                this.messageService.showErrorFromBackend('Houston, we have a Xero problem!!');
                return;
            }
            this.messageService.showToaster(errorCode, errorPlace, value);
        }
    }, {
        key: "errorCopyToQuickbooks",
        value: function errorCopyToQuickbooks(error, invoiceDisplayId) {
            var data = error.data,
                status = error.status;

            var errorMessage = data ? data.errorMessage : null;
            var errorTitle = error.error.errorTitle;

            var errorCode = void 0,
                errorPlace = void 0,
                value = void 0;
            if (errorMessage && status >= 400 && status < 500) {
                switch (errorMessage) {
                    case "QuickBooks doesn't allow Inclusive tax for US users":
                        errorCode = 'e_3';
                        errorPlace = 'qb';
                        break;
                    case 'Invoice with written off payments is not compatible with QuickBooks':
                        errorCode = 'e_7';
                        errorPlace = 'qb';
                        break;
                    case 'Sorry, FR QuickBooks companies are not supported yet':
                        errorCode = 'e_8';
                        errorPlace = 'qb';
                        break;
                    case 'Invoice with such ID already exists on QuickBooks':
                        errorCode = 'e_1';
                        errorPlace = 'qb';
                        value = invoiceDisplayId;
                        break;
                    case 'Invoice with written off payments is not compatible with Xero':
                        errorCode = 'e_7';
                        errorPlace = 'xero';
                        break;
                    case 'Invoice has been deleted deleted on QuickBooks':
                        errorCode = 'e_17';
                        errorPlace = 'qb';
                        break;
                    case 'Invoice should have the same tax type for all products':
                        errorCode = 'e_0';
                        errorPlace = 'qb';
                        break;
                    case "StudioNinja doesn't support transactions with Credit Notes from QuickBooks":
                        errorCode = 'e_14';
                        errorPlace = 'qb';
                        break;
                    default:
                        if (errorTitle && errorTitle !== null && errorMessage && errorMessage !== null) {
                            this.messageService.showErrorFromBackend(errorTitle, errorMessage);
                        } else {
                            this.messageService.showErrorFromBackend('Slow down, Quickbooks error!');
                        }
                        return;
                }
                if (errorMessage.includes('String length specified does not match the supported length. Min:0 Max:100 supported.')) {
                    errorCode = 'e_26';
                    errorPlace = 'qb';
                } else if (errorMessage.includes('String length specified does not match the supported length. Min:0 Max:21 supported.')) {
                    errorCode = 'e_27';
                    errorPlace = 'qb';
                } else if (errorMessage.includes('String length specified does not match the supported length. Min:0 Max:4,000 supported.')) {
                    errorCode = 'e_28';
                    errorPlace = 'qb';
                } else if (errorMessage.includes('One of the list elements assigned to this transaction has been deleted')) {
                    errorCode = 'e_11';
                    errorPlace = 'qb';
                } else if (errorMessage.includes('Try reselecting the tax rate or reentering the product/service item and saving the form again.')) {
                    errorCode = 'e_19';
                    errorPlace = 'qb';
                }
            } else {
                if (errorTitle && errorTitle !== null && errorMessage && errorMessage !== null) {
                    this.messageService.showErrorFromBackend(errorTitle, errorMessage);
                } else {
                    this.messageService.showErrorFromBackend('Slow down, Quickbooks error!');
                }
                return;
            }
            this.messageService.showToaster(errorCode, errorPlace, value);
        }
    }, {
        key: "chooseActionsMenuToShow",
        value: function chooseActionsMenuToShow(payment) {
            var _this2 = this;

            var paymentButtons = [];
            Object.keys(payment.actions).forEach(function (action) {
                if (_this2.paymentActions[action]) {
                    paymentButtons.push(_this2.paymentActions[action]);
                }
            });
            return paymentButtons;
        }
    }, {
        key: "isPaymentToRecordValid",
        value: function isPaymentToRecordValid(amount, invoice) {
            if (amount <= 0 && invoice.xeroStatus === 'COPIED_TO_XERO') {
                this.messageService.showToaster('e_8', 'xero');
                return false;
            } else if (amount <= 0 && invoice.qbStatus === 'COPIED') {
                this.messageService.showToaster('e_8', 'xero');
                return false;
            }
            return true;
        }
    }, {
        key: "isSetPaidPaymentError",
        value: function isSetPaidPaymentError(payment) {
            if (payment.errorMessage === "StudioNinja doesn't support transactions with Credit Notes from QuickBooks") {
                this.messageService.showToaster('e_14', 'qb');
                return true;
            } else if (payment.errorMessage === '"One of the list elements assigned to this transaction has been deleted') {
                this.messageService.showToaster('e_11', 'qb');
                return true;
            }
            return false;
        }
    }, {
        key: "isSetUnpaidPaymentError",
        value: function isSetUnpaidPaymentError(invoice) {
            if (invoice.qbStatus === 'DISCONNECTED_INVOICE_ALTERED') {
                this.messageService.showToaster('e_14', 'qb');
                return true;
            }
            return false;
        }
    }, {
        key: "isInvoiceValid",
        value: function isInvoiceValid(data) {
            var amount = data.amount,
                packages = data.packages,
                payments = data.payments,
                paymentScheduleTemplateId = data.paymentScheduleTemplateId,
                discount = data.discount,
                discountType = data.discountType,
                totalDue = data.totalDue,
                poNumber = data.poNumber,
                pageName = data.pageName;

            var invalidProductType = void 0;
            var messagePlace = pageName === 'invoicePage' ? 'editInvoice' : 'editQuote';
            if (this.isChosenProductsInvalid(packages, pageName)) {
                return false;
            }
            if (discountType === 'Fixed' && amount - discount < 0) {
                this.messageService.showToaster('e_1', 'editInvoice');
                return false;
            } else if (this.paymentsService.isNegativePayments(payments)) {
                this.messageService.showToaster('e_4', 'editInvoice');
                return false;
            }
            if (paymentScheduleTemplateId == -1 && totalDue !== 0) {
                this.messageService.showToaster('e_18', 'editInvoice');
                return false;
            }
            var isValidDiscountFixed = this.paymentsService.isValidDiscountFixed(packages, discountType);
            if (!isValidDiscountFixed) {
                return false;
            }
            var isValidDiscountPercent = this.paymentsService.isValidDiscountPercent(discount, discountType, pageName);
            if (!isValidDiscountPercent) {
                return false;
            }
            if (this.paymentsService.isPaymentsWithoutDate(payments)) {
                this.messageService.showToaster('e_9', 'editInvoice');
                return false;
            }
            if (typeof totalDue === 'undefined' || totalDue === null) {
                this.messageService.showToaster('e_0', 'general');
                return false;
            }
            if (poNumber && poNumber !== '' && poNumber !== null && !poNumber.match('^[a-zA-Z0-9 *№\'ʼ;:%!?@#$&|>\\<{}()-`.+,/"]*$')) {
                this.messageService.showToaster('e_7', 'editQuote');
                return false;
            }
            if (totalDue < 0) {
                this.messageService.showToaster('e_1', messagePlace);
                return false;
            }
            if (packages.find(function (product) {
                return product.type === 'GIFT' && product.price >= 0;
            }) !== undefined) {
                this.messageService.showToaster('e_16', 'editQuote');
                return false;
            }
            if (packages.find(function (product) {
                if (product.name === '') {
                    invalidProductType = product.type;
                    if (invalidProductType === 'GIFT') {
                        invalidProductType = 'discount';
                    } else if (invalidProductType === 'ADD_ON') {
                        invalidProductType = 'product';
                    }
                    return true;
                }
            })) {
                this.messageService.showToaster('e_0', 'productsPackages', invalidProductType.toLowerCase());
                return false;
            }
            if (packages.find(function (product) {
                if (product.name.trim().length === 0) {
                    if (product.type.toUpperCase() === 'GIFT') {
                        invalidProductType = 'Discount';
                    } else {
                        invalidProductType = product.type.toUpperCase() === 'PACKAGE' ? 'Package' : 'Product';
                    }
                    return true;
                }
            })) {
                this.messageService.showToaster('e_14', 'editQuote', invalidProductType);
                return false;
            }
            // MAGIC DON'T TOUCH
            if (packages.filter(function (addon) {
                return addon.type === 'GIFT';
            }).length > 0 && packages.filter(function (addon) {
                return addon.taxType !== packages[0].taxType;
            }).length > 0) {
                this.messageService.showToaster('e_4', 'payments');
                return false;
            }
            var invalidCounter = document.querySelector('.counter.red');
            if (invalidCounter) {
                this.messageService.showToaster('e_6', 'productsPackages', '4000');
                return false;
            }
            return true;
        }
    }, {
        key: "isChosenProductsInvalid",
        value: function isChosenProductsInvalid(products, pageName) {
            var _this3 = this;

            if (products.length === 0) {
                this.messageService.showToaster('w_2', 'editInvoice');
                return true;
            }
            return products.some(function (product) {
                return _this3.isInvalidProduct(product, pageName);
            });
        }
    }, {
        key: "addDayMulti",
        value: function addDayMulti(day) {
            return " day" + (Math.abs(day) === 1 ? '' : 's');
        }
    }, {
        key: "getInvoiceStampImageSrc",
        value: function getInvoiceStampImageSrc(isSent) {
            return "https://app.studioninja.co/build/release-pipeline-119/resources/dist/assets/images/icons/statuses/" + (isSent ? 'sent.png' : 'notsent.png');
        }
    }, {
        key: "checkProductPackagesCorrectType",
        value: function checkProductPackagesCorrectType(products) {
            var paymentsProductPackage = JSON.parse(JSON.stringify(products));
            paymentsProductPackage.forEach(function (payment) {
                if (!payment.type || payment.type === null) {
                    if (payment.price < 0) {
                        payment.type = 'GIFT';
                    } else {
                        payment.type = 'ADD_ON';
                    }
                } else if (payment.price > 0 && (payment.type !== 'ADD_ON' || payment.type !== 'PACKAGE')) {
                    payment.type = 'ADD_ON';
                }
            });
            return paymentsProductPackage;
        }
    }, {
        key: "successCreateInvoice",
        value: function successCreateInvoice(data) {
            var _this4 = this;

            return new Promise(function (resolve, reject) {
                var errorMessage = data.errorMessage,
                    invoiceDisplayId = data.invoiceDisplayId,
                    id = data.id,
                    xeroResult = data.xeroResult;

                if (errorMessage) {
                    _this4.messageService.showToaster('e_2', 'general', errorMessage);
                    reject();
                } else {
                    _this4.messageService.showToaster('s_1', 'payments');
                    if (xeroResult) {
                        _this4.messageService.showToaster('e_2', 'xero');
                        reject();
                    }
                    var metadata = {
                        invoice_id: invoiceDisplayId
                    };
                    window.Intercom('trackEvent', 'created invoice', metadata);
                    resolve(id);
                }
            });
        }
    }], [{
        key: "getQtBaseTemplateData",
        value: function getQtBaseTemplateData() {
            return {
                contractTemplateId: '-1',
                questionnaireTemplateId: '-1',
                paymentSchedulerTemplateId: '-2',
                data: {
                    notes: '',
                    name: '',
                    products: []
                },
                products: null,
                packages: null,
                discounts: null,
                addons: null,
                contracts: [],
                questionnaires: [],
                paymentScheduleTemplates: [],
                paymentDefaultScheduleTemplates: [],
                currency: null,
                summary: null
            };
        }
    }]);

    return InvoiceServiceProvider;
}();
InvoiceServiceProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [message_service_1.MessageService, time_service_1.TimeServiceProvider, payments_service_1.PaymentsServiceProvider, validation_service_1.ValidationProvider])], InvoiceServiceProvider);
exports.InvoiceServiceProvider = InvoiceServiceProvider;

/***/ }),

/***/ "./shared/services/invoice/invoices-data-service/invoices.data.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = __webpack_require__("./node_modules/@angular/common/esm5/http.js");
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var BehaviorSubject_1 = __webpack_require__("./node_modules/rxjs/BehaviorSubject.js");
var InvoicesDataProvider = function () {
    function InvoicesDataProvider(http) {
        _classCallCheck(this, InvoicesDataProvider);

        this.http = http;
        this.payment = new BehaviorSubject_1.BehaviorSubject(false);
        this.invoiceUpdate = new BehaviorSubject_1.BehaviorSubject(false);
    }

    _createClass(InvoicesDataProvider, [{
        key: "emitPayment",
        value: function emitPayment(payment) {
            return this.payment.next(Object.assign({}, payment));
        }
    }, {
        key: "emitInvoiceUpdateEvent",
        value: function emitInvoiceUpdateEvent(value) {
            return this.invoiceUpdate.next(value);
        }
    }, {
        key: "destroyInvoiceUpdatedObservable",
        value: function destroyInvoiceUpdatedObservable() {
            this.invoiceUpdate.next(false);
        }
    }, {
        key: "sendInvoiceEmail",
        value: function sendInvoiceEmail(data, type, invoiceId) {
            var sendInvoiceUrl = "/protected/rest/invoices/invoice/send/" + invoiceId;
            var sendReceiptUrl = "/protected/rest/payment-receipt/" + invoiceId + "/send";
            var url = type === 'receipt' ? sendReceiptUrl : sendInvoiceUrl;
            var sendMessageData = data.sendMessageData,
                storedFiles = data.storedFiles,
                uploadedFiles = data.uploadedFiles;

            var formData = new FormData();
            for (var key in sendMessageData) {
                if (key !== 'attachmentsData') {
                    formData.append(key, sendMessageData[key]);
                }
            }
            for (var _key in storedFiles) {
                formData.append("storedAttachments[" + _key + "]", storedFiles[_key].id);
            }
            for (var _key2 in uploadedFiles) {
                formData.append("attachments[" + _key2 + "]", uploadedFiles[_key2]);
            }
            return this.sendInvoiceRequest(url, formData);
        }
    }, {
        key: "sendInvoiceRequest",
        value: function sendInvoiceRequest(url, formData) {
            return this.http.post(url, formData);
        }
    }, {
        key: "getInvoice",
        value: function getInvoice(id, path) {
            var paymentsPath = path.includes('payments/payment');
            var url = paymentsPath ? "/protected/rest/jobs/payments/payment/" + id : "/protected/rest/invoices/" + id;
            return this.http.get(url);
        }
    }, {
        key: "getInvoiceV1",
        value: function getInvoiceV1(id) {
            var url = "/api/user/v1/invoice/" + id + "/get";
            return this.http.get(url);
        }
    }, {
        key: "getInvoiceForUpdate",
        value: function getInvoiceForUpdate(id) {
            var url = "/api/user/v1/invoice/" + id + "/get-for-update";
            return this.http.get(url);
        }
    }, {
        key: "getInvoicePreviewURL",
        value: function getInvoicePreviewURL(invoiceId) {
            var url = "/protected/rest/invoices/invoice/payonline/" + invoiceId;
            var body = {};
            return this.http.post(url, body);
        }
    }, {
        key: "undoWriteOff",
        value: function undoWriteOff(paymentId) {
            var url = "/api/user/payments/" + paymentId + "/undowriteoff";
            var body = {};
            return this.http.post(url, body);
        }
    }, {
        key: "writeOff",
        value: function writeOff(paymentId) {
            var url = "/api/user/payments/" + paymentId + "/writeoff";
            var body = {};
            return this.http.post(url, body);
        }
    }, {
        key: "deleteInvoice",
        value: function deleteInvoice(invoiceId) {
            var url = "/protected/rest/jobs/invoices/invoice/delete/" + invoiceId;
            var body = {};
            return this.http.post(url, body);
        }
    }, {
        key: "setUnpaid",
        value: function setUnpaid(paymentId) {
            var url = "/api/user/payments/" + paymentId + "/unpaid";
            var body = {};
            return this.http.post(url, body);
        }
    }, {
        key: "markAsPaid",
        value: function markAsPaid(payment) {
            var url = "/api/user/payments/" + payment.id + "/paid";
            return this.http.post(url, payment);
        }
    }, {
        key: "fetchSchedule",
        value: function fetchSchedule(scheduleId) {
            var url = "/protected/rest/invoice/schedule?id=" + scheduleId;
            return this.http.get(url);
        }
    }, {
        key: "updateInvoiceV1",
        value: function updateInvoiceV1(id, invoice) {
            var url = "/api/user/v1/invoice/" + id + "/update";
            return this.http.put(url, invoice);
        }
    }, {
        key: "saveInvoice",
        value: function saveInvoice(jobId, data) {
            var url = "/protected/rest/job/" + jobId + "/invoice/save";
            return this.http.post(url, data);
        }
        // TODO remove after implementing new API

    }, {
        key: "saveInvoiceNew",
        value: function saveInvoiceNew(data) {
            var url = '/api/user/v1/invoice/create';
            return this.http.post(url, data);
        }
    }, {
        key: "saveInvoiceV1",
        value: function saveInvoiceV1(data, jobId) {
            var url = "/api/user/v1/job/" + jobId + "/invoice";
            return this.http.post(url, data);
        }
    }, {
        key: "saveNewInvoice",
        value: function saveNewInvoice(jobId, data) {
            var url = "/api/user/v1/job/" + jobId + "/invoice";
            return this.http.post(url, data);
        }
    }, {
        key: "updateInvoice",
        value: function updateInvoice(invoiceId, data) {
            var url = "/api/user/v1/invoice/" + invoiceId + "/update";
            return this.http.put(url, data);
        }
    }, {
        key: "getInvoiceToEdit",
        value: function getInvoiceToEdit(jobId, isJob, invoiceId) {
            var url = isJob ? "/protected/rest/invoice/sources?jobId=" + jobId : "/protected/rest/invoice/sources?leadId=" + jobId;
            if (invoiceId) {
                url += "&invoiceId=" + invoiceId;
            }
            return this.http.get(url);
        }
    }, {
        key: "getInvoiceToEditNew",
        value: function getInvoiceToEditNew(jobId, isJob, invoiceId) {
            var url = isJob ? "/api/user/v1/invoice/source?jobId=" + jobId : "/api/user/v1/invoice/source?leadId=" + jobId;
            if (invoiceId) {
                url += "&invoiceId=" + invoiceId;
            }
            return this.http.get(url);
        }
    }, {
        key: "calcInvoiceSummary",
        value: function calcInvoiceSummary(data) {
            var url = '/api/user/uihelper/calcInvoiceSummary';
            return this.http.post(url, data);
        }
    }, {
        key: "calculateInvoiceSummary",
        value: function calculateInvoiceSummary(data) {
            var url = '/api/public/v1/ui/helper/calculate/summary';
            return this.http.post(url, data);
        }
    }, {
        key: "getInvoiceIdAndDate",
        value: function getInvoiceIdAndDate(jobId) {
            var url = "/api/user/v1/job/" + jobId + "/invoice/template";
            return this.http.get(url);
        }
    }, {
        key: "getInvoiceOverviewV1",
        value: function getInvoiceOverviewV1(jobId) {
            var url = "/api/user/v1/job/" + jobId + "/invoices/overview";
            return this.http.get(url);
        }
    }, {
        key: "integrateInvoiceWithQbOrZero",
        value: function integrateInvoiceWithQbOrZero(jobId, _integrateInvoiceWithQbOrZero) {
            var url = "/api/user/v1/job/" + jobId + "/shootproof/invoice/import?syncWithAccountSystem=" + _integrateInvoiceWithQbOrZero;
            return this.http.post(url, null);
        }
    }, {
        key: "getInvoicesPicTime",
        value: function getInvoicesPicTime(url) {
            return this.http.get(url);
        }
    }, {
        key: "importInvoicesPicTime",
        value: function importInvoicesPicTime(jobId, integrateInvoiceWithOtherSystem) {
            var url = "/api/user/job/" + jobId + "/pictime/invoice/import?syncWithAccountSystem=" + integrateInvoiceWithOtherSystem;
            return this.http.post(url, null);
        }
    }, {
        key: "syncPicTimeOrders",
        value: function syncPicTimeOrders(url, method) {
            return this.http[method.toLowerCase()](url, {});
        }
    }, {
        key: "paymentObservable",
        get: function get() {
            return this.payment.asObservable();
        }
    }, {
        key: "shouldInvoiceBeUpdatedObservable",
        get: function get() {
            return this.invoiceUpdate.asObservable();
        }
    }]);

    return InvoicesDataProvider;
}();
InvoicesDataProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [http_1.HttpClient])], InvoicesDataProvider);
exports.InvoicesDataProvider = InvoicesDataProvider;

/***/ }),

/***/ "./shared/services/job/job-types.data.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = __webpack_require__("./node_modules/@angular/common/esm5/http.js");
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var JobTypesDataProvider = function () {
    function JobTypesDataProvider(http) {
        _classCallCheck(this, JobTypesDataProvider);

        this.http = http;
        this.jobTypes = [];
    }

    _createClass(JobTypesDataProvider, [{
        key: "getJobTypes",
        value: function getJobTypes() {
            var _this = this;

            return this.getJobTypesFromServer().map(function (data) {
                if (data !== undefined && data !== null) {
                    _this.setJobTypesInStorage(data);
                    return JSON.parse(JSON.stringify(_this.jobTypes));
                }
                return data;
            });
        }
    }, {
        key: "getJobTypesFromServer",
        value: function getJobTypesFromServer() {
            var url = '/protected/rest/job/types/all';
            return this.http.get(url);
        }
    }, {
        key: "setJobTypesInStorage",
        value: function setJobTypesInStorage(data) {
            this.jobTypes = JSON.parse(JSON.stringify(data));
        }
    }]);

    return JobTypesDataProvider;
}();
JobTypesDataProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [http_1.HttpClient])], JobTypesDataProvider);
exports.JobTypesDataProvider = JobTypesDataProvider;

/***/ }),

/***/ "./shared/services/job/job.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var stringModifier_service_1 = __webpack_require__("./shared/services/helpers/string-modifier-service/stringModifier.service.ts");
var jobs_data_service_1 = __webpack_require__("./shared/services/job/jobs.data.service.ts");
var time_converter_1 = __webpack_require__("./shared/services/helpers/time-converter.ts");
var time_service_1 = __webpack_require__("./shared/services/helpers/time-service/time.service.ts");
var validation_service_1 = __webpack_require__("./shared/services/helpers/validation.service.ts");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var client_service_1 = __webpack_require__("./shared/services/client/client.service.ts");
var email_service_1 = __webpack_require__("./shared/services/email/email-service/email.service.ts");
var JobServiceProvider = function () {
    function JobServiceProvider(stringModifierService, jobDataService, validationService, messageService, timeService, timeConverter, clientService, emailService) {
        _classCallCheck(this, JobServiceProvider);

        this.stringModifierService = stringModifierService;
        this.jobDataService = jobDataService;
        this.validationService = validationService;
        this.messageService = messageService;
        this.timeService = timeService;
        this.timeConverter = timeConverter;
        this.clientService = clientService;
        this.emailService = emailService;
    }

    _createClass(JobServiceProvider, [{
        key: "isContact",
        value: function isContact(contact) {
            var contactExist = contact && contact.id;
            return !!contactExist;
        }
    }, {
        key: "isContactsEqual",
        value: function isContactsEqual(secondaryContact, primaryContact) {
            if (secondaryContact.id === primaryContact.id) {
                this.messageService.showToaster('e_5', 'job');
                return true;
            }
            return false;
        }
    }, {
        key: "prepareJob",
        value: function prepareJob(job, jobTypes) {
            var job2Edit = JSON.parse(JSON.stringify(job));
            var workflow = job2Edit.workflow,
                startDate = job2Edit.startDate,
                finishDate = job2Edit.finishDate;

            job2Edit.oldWorkflow = workflow;
            if (!job2Edit.startDate) {
                job2Edit.hasNoDate = true;
            } else {
                job2Edit.hasNoDate = false;
                job2Edit.startDate = this.timeService.createDateAsUTC(startDate);
                job2Edit.finishDate = this.timeService.createDateAsUTC(finishDate);
            }
            if (job2Edit.workflow && job2Edit.workflow.name) {
                job2Edit.workflow.name = this.stringModifierService.addSelectedText(job2Edit.workflow.name);
            }
            if (job2Edit.startDate && (job2Edit.startTime === null || job2Edit.finishTime === null)) {
                job2Edit.allday = true;
            }
            if (jobTypes) {
                job2Edit.type = jobTypes.find(function (item) {
                    return item.id === job2Edit.type.id;
                });
            }
            return job2Edit;
        }
    }, {
        key: "addClients",
        value: function addClients(job) {
            var primaryContact = job.primaryContact,
                secondaryContact = job.secondaryContact;

            var clients = [];
            if (typeof primaryContact !== 'undefined' && primaryContact !== null) {
                var primaryClientSearchText = this.clientService.fillClientSearchText(primaryContact);
                clients.push(primaryClientSearchText);
            }
            if (typeof secondaryContact !== 'undefined' && secondaryContact !== null) {
                var secondaryClientSearchText = this.clientService.fillClientSearchText(secondaryContact);
                clients.push(secondaryClientSearchText);
            }
            return clients;
        }
    }, {
        key: "checkWorkflowName",
        value: function checkWorkflowName(job, workflowNames) {
            if (typeof workflowNames !== 'undefined' && workflowNames.length) {
                var isWorkflowSaved = workflowNames.find(function (workflow) {
                    return workflow.id === job.workflow.id;
                });
                var workflowNamesCopy = workflowNames.slice();
                if (!isWorkflowSaved) {
                    workflowNamesCopy.push(job.workflow);
                    return workflowNamesCopy;
                }
                return workflowNames;
            }
            return workflowNames;
        }
    }, {
        key: "getTaskList",
        value: function getTaskList(job) {
            if (!job.workflow) {
                return false;
            }
            var taskList = job.workflow.tasks.slice();
            taskList = taskList.sort(function (a, b) {
                return a.number > b.number;
            });
            return taskList;
        }
    }, {
        key: "animateNewTask",
        value: function animateNewTask(taskList, showNewTaskId) {
            setTimeout(function () {
                var newTask = taskList.find(function (task) {
                    return task.id === showNewTaskId;
                });
                var taskToAnimate = ".task-" + newTask.number;
                // $rootScope.$broadcast('animateTask', taskToAnimate);
            }, 0);
        }
    }, {
        key: "validateJob",
        value: function validateJob(job, clients) {
            var dateStart = void 0,
                dateEnd = void 0,
                timeStart = void 0,
                timeEnd = void 0;
            var validJob = JSON.parse(JSON.stringify(job), this.timeService.parseDateFromJSON);
            validJob.leadSourceId = job.leadSource ? job.leadSource.id : null;
            delete validJob.leadSource;
            if (this.validationService.isStringEmpty(validJob.name)) {
                this.messageService.showToaster('e_3', 'general', 'Job Name');
                return false;
            }
            var primaryContact = Object.assign({}, clients[0]);
            var isPrimaryContact = this.isContact(primaryContact);
            if (isPrimaryContact) {
                validJob.primaryContact = primaryContact;
            } else {
                this.messageService.showToaster('e_1', 'job');
                return false;
            }
            var secondaryContact = Object.assign({}, clients[1]);
            var isSecondaryContact = this.isContact(secondaryContact);
            if (isSecondaryContact) {
                if (this.isContactsEqual(secondaryContact, primaryContact)) {
                    return false;
                }
                validJob.secondaryContact = secondaryContact;
            } else {
                delete validJob.secondaryContact;
            }
            if (validJob.id && validJob.workflow && validJob.workflow.id === -1 && validJob.workflow.name === 'Default') {
                validJob.workflow.id = null;
            }
            if (validJob.language) {
                validJob.language = validJob.language.name;
            }
            if (validJob.hasNoDate) {
                validJob.startDate = null;
                validJob.finishDate = null;
                validJob.startTime = null;
                validJob.finishTime = null;
                return validJob;
            }
            if (!validJob.startDate || !validJob.finishDate) {
                this.messageService.showToaster('e_1', 'appointment');
                return false;
            }
            dateStart = this.timeService.getDateInFormat(validJob.startDate, 'date');
            dateEnd = this.timeService.getDateInFormat(validJob.finishDate, 'date');
            var isNotCorrectDate = this.timeService.compareDates(dateEnd, dateStart);
            if (isNotCorrectDate) {
                this.messageService.showToaster('e_0', 'job');
                return false;
            }
            if (!validJob.allday) {
                var isStartIn24Format = this.timeService.isIn24Format(validJob.startTime);
                var isEndIn24Format = this.timeService.isIn24Format(validJob.finishTime);
                timeStart = isStartIn24Format ? validJob.startTime : this.timeConverter.convert12to24(validJob.startTime);
                timeEnd = isEndIn24Format ? validJob.finishTime : this.timeConverter.convert12to24(validJob.finishTime);
                if (!timeStart || !timeEnd) {
                    this.messageService.showToaster('e_3', 'job');
                    return false;
                }
                if (dateStart === dateEnd) {
                    var isCorrectTime = this.timeService.compareTimes(timeStart, timeEnd);
                    if (!isCorrectTime) {
                        this.messageService.showToaster('e_4', 'job');
                        return false;
                    }
                }
            }
            validJob.startDate = dateStart;
            validJob.finishDate = dateEnd;
            validJob.startTime = timeStart;
            validJob.finishTime = timeEnd;
            return validJob;
        }
    }]);

    return JobServiceProvider;
}();
JobServiceProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [stringModifier_service_1.StringModifierServiceProvider, jobs_data_service_1.JobsDataServiceProvider, validation_service_1.ValidationProvider, message_service_1.MessageService, time_service_1.TimeServiceProvider, time_converter_1.TimeConverterProvider, client_service_1.ClientServiceProvider, email_service_1.EmailServiceProvider])], JobServiceProvider);
exports.JobServiceProvider = JobServiceProvider;

/***/ }),

/***/ "./shared/services/job/jobs.data.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var http_1 = __webpack_require__("./node_modules/@angular/common/esm5/http.js");
var BehaviorSubject_1 = __webpack_require__("./node_modules/rxjs/BehaviorSubject.js");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var JobsDataServiceProvider = function () {
    function JobsDataServiceProvider(http) {
        _classCallCheck(this, JobsDataServiceProvider);

        this.http = http;
        this.job2Edit = new BehaviorSubject_1.BehaviorSubject(false);
        this.forceJobUpdate = new BehaviorSubject_1.BehaviorSubject(false);
    }

    _createClass(JobsDataServiceProvider, [{
        key: "emitJob",
        value: function emitJob(job) {
            return this.job2Edit.next(JSON.parse(JSON.stringify(job)));
        }
    }, {
        key: "emitForceJobUpdateEvent",
        value: function emitForceJobUpdateEvent(value) {
            this.forceJobUpdate.next(value);
        }
    }, {
        key: "getJobInfo",
        value: function getJobInfo(id) {
            var showNewTaskId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

            var url = '/protected/rest/jobs/view';
            var params = new http_1.HttpParams();
            params = params.append('id', id);
            params = params.append('showNewTaskId', showNewTaskId);
            return this.http.get(url, { params: params });
        }
    }, {
        key: "editJob",
        value: function editJob(job) {
            var url = '/protected/rest/add_new_job/update';
            return this.http.post(url, job);
        }
    }, {
        key: "getActiveJobs",
        value: function getActiveJobs() {
            var url = '/protected/rest/jobs/active';
            return this.http.get(url);
        }
    }, {
        key: "getJobOnDashboard",
        value: function getJobOnDashboard(pageRequest) {
            var url = '/api/user/v1/job';
            return this.http.post(url, pageRequest);
        }
    }, {
        key: "getJobsOnPage",
        value: function getJobsOnPage(pageRequest) {
            var perPage = pageRequest.perPage,
                page = pageRequest.page,
                _pageRequest$pageOrde = pageRequest.pageOrder,
                predicate = _pageRequest$pageOrde.predicate,
                reverse = _pageRequest$pageOrde.reverse,
                search = pageRequest.search,
                filter = pageRequest.filter;

            var url = '/api/user/jobs';
            var params = new http_1.HttpParams();
            params = params.append('perPage', perPage);
            params = params.append('page', page);
            params = params.append('predicate', predicate);
            params = params.append('reverse', reverse);
            params = params.append('search', search);
            params = params.append('filter', filter);
            return this.http.get(url, { params: params });
        }
    }, {
        key: "changeTaskState",
        value: function changeTaskState(jobId, task) {
            var url = "/protected/rest/jobs/" + jobId + "/tasks/" + task.id;
            var body = JSON.stringify(task.completed);
            var headers = new http_1.HttpHeaders().set('Content-Type', 'application/json;charset=UTF-8');
            return this.http.post(url, body, { headers: headers });
        }
    }, {
        key: "deleteJob",
        value: function deleteJob(jobId) {
            var url = "/api/user/v1/job/" + jobId + "/delete";
            return this.http.delete(url);
        }
    }, {
        key: "acceptJobOrLead",
        value: function acceptJobOrLead(jobId, taskCompleted) {
            var url = "/protected/rest/jobs/" + jobId + "/accept";
            var body = JSON.stringify(taskCompleted);
            var headers = new http_1.HttpHeaders().set('Content-Type', 'application/json;charset=UTF-8');
            return this.http.post(url, body, { headers: headers });
        }
    }, {
        key: "searchClient",
        value: function searchClient(_searchClient) {
            var url = '/protected/rest/job/client/search';
            var params = new http_1.HttpParams();
            params = params.append('search', _searchClient);
            return this.http.get(url, { params: params });
        }
    }, {
        key: "getQuoteInvoiceJob",
        value: function getQuoteInvoiceJob(jobId) {
            var url = "/api/user/v1/job/" + jobId;
            return this.http.get(url);
        }
    }, {
        key: "getJobsExport",
        value: function getJobsExport() {
            var url = '/api/user/v1/job/export/start-process';
            return this.http.get(url).pipe(operators_1.map(function (res) {
                return res.data;
            }));
        }
    }, {
        key: "getCPLink",
        value: function getCPLink(url) {
            return this.http.get(url);
        }
    }, {
        key: "jobObservable",
        get: function get() {
            return this.job2Edit.asObservable();
        }
    }, {
        key: "shouldJobBeUpdatedObservable",
        get: function get() {
            return this.forceJobUpdate.asObservable();
        }
    }]);

    return JobsDataServiceProvider;
}();
JobsDataServiceProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [http_1.HttpClient])], JobsDataServiceProvider);
exports.JobsDataServiceProvider = JobsDataServiceProvider;

/***/ }),

/***/ "./shared/services/language/language.data.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = __webpack_require__("./node_modules/@angular/common/esm5/http.js");
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var LanguageDataProvider = function () {
    function LanguageDataProvider(http) {
        _classCallCheck(this, LanguageDataProvider);

        this.http = http;
    }

    _createClass(LanguageDataProvider, [{
        key: "getLanguages",
        value: function getLanguages() {
            var url = '/api/user/v1/company/language';
            return this.http.get(url);
        }
    }, {
        key: "updateLanguages",
        value: function updateLanguages(data) {
            var url = '/api/user/v1/company/language';
            return this.http.post(url, data);
        }
    }, {
        key: "getLabels",
        value: function getLabels() {
            var url = '/api/user/v1/company/language/label';
            return this.http.get(url);
        }
    }, {
        key: "updateLabels",
        value: function updateLabels(url, data) {
            return this.http.post(url, data);
        }
    }]);

    return LanguageDataProvider;
}();
LanguageDataProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [http_1.HttpClient])], LanguageDataProvider);
exports.LanguageDataProvider = LanguageDataProvider;

/***/ }),

/***/ "./shared/services/lead-sources/lead-sources.data.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var http_1 = __webpack_require__("./node_modules/@angular/common/esm5/http.js");
var rxjs_1 = __webpack_require__("./node_modules/rxjs/Rx.js");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var file_download_data_service_1 = __webpack_require__("./shared/services/files/file-download-service/file-download.data.service.ts");
var LeadSourcesDataService = function () {
    function LeadSourcesDataService(http, fileDownloadService) {
        _classCallCheck(this, LeadSourcesDataService);

        this.http = http;
        this.fileDownloadService = fileDownloadService;
        this.updateLeadSourcesEvent$ = new rxjs_1.BehaviorSubject(false);
    }

    _createClass(LeadSourcesDataService, [{
        key: "getLeadSourcesOverview",
        value: function getLeadSourcesOverview(type, pageRequest) {
            var url = "/api/user/v1/lead-sources/overview/" + type.toLowerCase();
            return this.http.post(url, pageRequest);
        }
    }, {
        key: "getLeadSourcesList",
        value: function getLeadSourcesList() {
            var url = '/api/user/v1/lead-sources/list';
            return this.http.get(url);
        }
    }, {
        key: "getActiveLeadSourcesList",
        value: function getActiveLeadSourcesList() {
            var url = '/api/user/v1/lead-sources/list/active';
            return this.http.get(url);
        }
    }, {
        key: "exportLeadSourceData",
        value: function exportLeadSourceData(filters, fileType, fileName) {
            var _this = this;

            var url = "/api/user/v1/lead-sources/usage-details/export/" + fileType;
            return this.http.post(url, filters, { responseType: 'blob', observe: 'response' }).pipe(operators_1.tap(function (response) {
                return _this.fileDownloadService.saveFile(response, fileName, fileType);
            }));
        }
    }, {
        key: "getLeadSourceGraphData",
        value: function getLeadSourceGraphData(filters) {
            var url = '/api/user/v1/lead-sources/statistic';
            return this.http.post(url, filters);
        }
    }, {
        key: "getAllLeadSourcesStatisticData",
        value: function getAllLeadSourcesStatisticData(filters) {
            var url = '/api/user/v1/lead-sources/usage-details';
            return this.http.post(url, filters);
        }
    }, {
        key: "sendAction",
        value: function sendAction(url, method, payload) {
            return this.http[method.toLowerCase()](url, payload);
        }
    }, {
        key: "updateLeadSourcesEvent",
        value: function updateLeadSourcesEvent(state) {
            this.updateLeadSourcesEvent$.next(state);
        }
    }, {
        key: "leadSourcesEventTrigger",
        get: function get() {
            return this.updateLeadSourcesEvent$.asObservable();
        }
    }]);

    return LeadSourcesDataService;
}();
LeadSourcesDataService = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [http_1.HttpClient, file_download_data_service_1.FileDownloadDataServiceProvider])], LeadSourcesDataService);
exports.LeadSourcesDataService = LeadSourcesDataService;

/***/ }),

/***/ "./shared/services/lead/lead.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var leads_data_service_1 = __webpack_require__("./shared/services/lead/leads.data.service.ts");
var time_converter_1 = __webpack_require__("./shared/services/helpers/time-converter.ts");
var time_service_1 = __webpack_require__("./shared/services/helpers/time-service/time.service.ts");
var validation_service_1 = __webpack_require__("./shared/services/helpers/validation.service.ts");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var client_service_1 = __webpack_require__("./shared/services/client/client.service.ts");
var stringModifier_service_1 = __webpack_require__("./shared/services/helpers/string-modifier-service/stringModifier.service.ts");
var email_service_1 = __webpack_require__("./shared/services/email/email-service/email.service.ts");
var LeadServiceProvider = function () {
    function LeadServiceProvider(stringModifierService, leadDataService, validationService, messageService, timeService, timeConverter, clientService, emailService) {
        _classCallCheck(this, LeadServiceProvider);

        this.stringModifierService = stringModifierService;
        this.leadDataService = leadDataService;
        this.validationService = validationService;
        this.messageService = messageService;
        this.timeService = timeService;
        this.timeConverter = timeConverter;
        this.clientService = clientService;
        this.emailService = emailService;
    }

    _createClass(LeadServiceProvider, [{
        key: "isContact",
        value: function isContact(contact) {
            var contactExist = contact && contact.id;
            return !!contactExist;
        }
    }, {
        key: "isContactsEqual",
        value: function isContactsEqual(secondaryContact, primaryContact) {
            if (secondaryContact.id === primaryContact.id) {
                this.messageService.showToaster('e_5', 'job');
                return true;
            }
            return false;
        }
    }, {
        key: "prepareLead",
        value: function prepareLead(job, jobTypes) {
            var job2Edit = JSON.parse(JSON.stringify(job));
            var workflow = job2Edit.workflow,
                startDate = job2Edit.startDate,
                finishDate = job2Edit.finishDate;

            job2Edit.oldWorkflow = workflow;
            if (!job2Edit.startDate) {
                job2Edit.hasNoDate = true;
            } else {
                job2Edit.hasNoDate = false;
                job2Edit.startDate = this.timeService.createDateAsUTC(startDate);
                job2Edit.finishDate = this.timeService.createDateAsUTC(finishDate);
            }
            if (job2Edit.workflow && job2Edit.workflow.name) {
                job2Edit.workflow.name = this.stringModifierService.addSelectedText(job2Edit.workflow.name);
            }
            if (job2Edit.startDate && (job2Edit.startTime === null || job2Edit.finishTime === null)) {
                job2Edit.allday = true;
            }
            if (jobTypes) {
                job2Edit.type = jobTypes.find(function (item) {
                    return item.id === job2Edit.type.id;
                });
            }
            return job2Edit;
        }
    }, {
        key: "addClients",
        value: function addClients(job) {
            var primaryContact = job.primaryContact,
                secondaryContact = job.secondaryContact;

            var clients = [];
            if (typeof primaryContact !== 'undefined' && primaryContact !== null) {
                var primaryClientSearchText = this.clientService.fillClientSearchText(primaryContact);
                clients.push(primaryClientSearchText);
            }
            if (typeof secondaryContact !== 'undefined' && secondaryContact !== null) {
                var secondaryClientSearchText = this.clientService.fillClientSearchText(secondaryContact);
                clients.push(secondaryClientSearchText);
            }
            return clients;
        }
    }, {
        key: "checkWorkflowName",
        value: function checkWorkflowName(job, workflowNames) {
            if (typeof workflowNames !== 'undefined' && workflowNames.length) {
                var isWorkflowSaved = workflowNames.find(function (workflow) {
                    return workflow.id === job.workflow.id;
                });
                var workflowNamesCopy = workflowNames.slice();
                if (!isWorkflowSaved) {
                    workflowNamesCopy.push(job.workflow);
                    return workflowNamesCopy;
                }
                return workflowNames;
            }
            return workflowNames;
        }
    }, {
        key: "getTaskList",
        value: function getTaskList(job) {
            if (!job.workflow) {
                return false;
            }
            var taskList = job.workflow.tasks.slice();
            taskList = taskList.sort(function (a, b) {
                return a.number > b.number;
            });
            return taskList;
        }
    }, {
        key: "animateNewTask",
        value: function animateNewTask(taskList, showNewTaskId) {
            setTimeout(function () {
                var newTask = taskList.find(function (task) {
                    return task.id === showNewTaskId;
                });
                var taskToAnimate = ".task-" + newTask.number;
                // $rootScope.$broadcast('animateTask', taskToAnimate);
            }, 0);
        }
    }, {
        key: "validateJob",
        value: function validateJob(job, clients, leadId, jobId) {
            var dateStart = void 0,
                dateEnd = void 0,
                timeStart = void 0,
                timeEnd = void 0;
            var validJob = JSON.parse(JSON.stringify(job), this.timeService.parseDateFromJSON);
            validJob.leadSourceId = job.leadSource ? job.leadSource.id : null;
            delete validJob.leadSource;
            if (this.validationService.isStringEmpty(validJob.name)) {
                this.messageService.showToaster('e_3', 'general', 'Lead Name');
                return false;
            }
            var primaryContact = Object.assign({}, clients[0]);
            var isPrimaryContact = this.isContact(primaryContact);
            if (isPrimaryContact) {
                validJob.primaryContact = primaryContact;
            } else {
                this.messageService.showToaster('e_0', 'lead');
                return false;
            }
            var secondaryContact = Object.assign({}, clients[1]);
            var isSecondaryContact = this.isContact(secondaryContact);
            if (isSecondaryContact) {
                if (this.isContactsEqual(secondaryContact, primaryContact)) {
                    return false;
                }
                validJob.secondaryContact = secondaryContact;
            } else {
                delete validJob.secondaryContact;
            }
            if (!validJob.id && validJob.workflow && validJob.workflow.id === -1) {
                validJob.workflow.id = null;
            }
            if (validJob.language) {
                validJob.language = validJob.language.name;
            }
            if (validJob.hasNoDate) {
                validJob.startDate = null;
                validJob.finishDate = null;
                validJob.startTime = null;
                validJob.finishTime = null;
                if (jobId) {
                    validJob.id = jobId;
                    delete validJob.jobId;
                }
                if (leadId) {
                    return {
                        id: leadId,
                        jobDTO: validJob
                    };
                }
                return {
                    id: validJob.id ? validJob.id : null,
                    jobDTO: validJob
                };
            }
            if (!validJob.startDate || !validJob.finishDate) {
                this.messageService.showToaster('e_1', 'appointment');
                return false;
            }
            dateStart = this.timeService.getDateInFormat(validJob.startDate, 'date');
            dateEnd = this.timeService.getDateInFormat(validJob.finishDate, 'date');
            var isCorrectDate = this.timeService.compareDates(dateEnd, dateStart);
            if (isCorrectDate) {
                this.messageService.showToaster('e_0', 'job');
                return false;
            }
            if (!validJob.allday) {
                var isStartIn24Format = this.timeService.isIn24Format(validJob.startTime);
                var isEndIn24Format = this.timeService.isIn24Format(validJob.finishTime);
                timeStart = isStartIn24Format ? validJob.startTime : this.timeConverter.convert12to24(validJob.startTime);
                timeEnd = isEndIn24Format ? validJob.finishTime : this.timeConverter.convert12to24(validJob.finishTime);
                if (!timeStart || !timeEnd) {
                    this.messageService.showToaster('e_3', 'lead');
                    return false;
                }
                if (dateStart === dateEnd) {
                    var isCorrectTime = this.timeService.compareTimes(timeStart, timeEnd);
                    if (!isCorrectTime) {
                        this.messageService.showToaster('e_4', 'job');
                        return false;
                    }
                }
            }
            validJob.startDate = dateStart;
            validJob.finishDate = dateEnd;
            validJob.startTime = timeStart;
            validJob.finishTime = timeEnd;
            if (jobId) {
                validJob.id = jobId;
                delete validJob.jobId;
            }
            if (leadId) {
                return {
                    id: leadId,
                    jobDTO: validJob
                };
            }
            return {
                id: validJob.id ? validJob.id : null,
                jobDTO: validJob
            };
        }
    }]);

    return LeadServiceProvider;
}();
LeadServiceProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [stringModifier_service_1.StringModifierServiceProvider, leads_data_service_1.LeadsDataServiceProvider, validation_service_1.ValidationProvider, message_service_1.MessageService, time_service_1.TimeServiceProvider, time_converter_1.TimeConverterProvider, client_service_1.ClientServiceProvider, email_service_1.EmailServiceProvider])], LeadServiceProvider);
exports.LeadServiceProvider = LeadServiceProvider;

/***/ }),

/***/ "./shared/services/lead/leads.data.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var http_1 = __webpack_require__("./node_modules/@angular/common/esm5/http.js");
var BehaviorSubject_1 = __webpack_require__("./node_modules/rxjs/BehaviorSubject.js");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var LeadsDataServiceProvider = function () {
    function LeadsDataServiceProvider(http) {
        _classCallCheck(this, LeadsDataServiceProvider);

        this.http = http;
        this.job2Edit = new BehaviorSubject_1.BehaviorSubject(false);
        this.forceJobUpdate = new BehaviorSubject_1.BehaviorSubject(false);
    }

    _createClass(LeadsDataServiceProvider, [{
        key: "emitLead",
        value: function emitLead(job) {
            return this.job2Edit.next(JSON.parse(JSON.stringify(job)));
        }
    }, {
        key: "emitForceLeadUpdateEvent",
        value: function emitForceLeadUpdateEvent(value) {
            this.forceJobUpdate.next(value);
        }
    }, {
        key: "getLeadInfo",
        value: function getLeadInfo(id) {
            var showTaskId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

            var url = "/api/user/lead/" + id;
            var params = new http_1.HttpParams();
            params = params.append('showTaskId', showTaskId);
            return this.http.get(url, { params: params });
        }
    }, {
        key: "editLead",
        value: function editLead(lead) {
            var url = '/api/user/lead/create';
            return this.http.post(url, lead);
        }
    }, {
        key: "getActiveJobs",
        value: function getActiveJobs() {
            var url = '/protected/rest/jobs/active';
            return this.http.get(url);
        }
    }, {
        key: "getLeadsOnPageV2",
        value: function getLeadsOnPageV2(pageRequest, perPageChanged) {
            var url = '/api/user/lead/v2';
            var perPage = pageRequest.perPage,
                page = pageRequest.page,
                _pageRequest$pageOrde = pageRequest.pageOrder,
                predicate = _pageRequest$pageOrde.predicate,
                reverse = _pageRequest$pageOrde.reverse,
                search = pageRequest.search,
                searchToken = pageRequest.searchToken,
                filter = pageRequest.filter;

            var params = {
                filter: filter,
                search: search,
                paging: {
                    pageNumber: page,
                    pageSize: perPage,
                    searchToken: searchToken
                },
                sortCriteria: {
                    fieldName: predicate,
                    sortAscending: reverse
                }
            };
            if (perPageChanged) {
                delete params.paging.searchToken;
            }
            return this.http.post(url, params);
        }
    }, {
        key: "getLeadsOnPage",
        value: function getLeadsOnPage(pageRequest, perPageChanged) {
            var url = '/api/user/lead/v2';
            if (perPageChanged) {
                delete pageRequest.paging.searchToken;
            }
            return this.http.post(url, pageRequest);
        }
    }, {
        key: "changeTaskState",
        value: function changeTaskState(leadIdId, task) {
            var url = "/protected/rest/jobs/" + leadIdId + "/tasks/" + task.id;
            var body = JSON.stringify(task.completed);
            var headers = new http_1.HttpHeaders().set('Content-Type', 'application/json;charset=UTF-8');
            return this.http.post(url, body, { headers: headers });
        }
    }, {
        key: "deleteLead",
        value: function deleteLead(leadId) {
            var url = "/api/user/lead/" + leadId;
            return this.http.delete(url);
        }
    }, {
        key: "archiveLead",
        value: function archiveLead(leadId) {
            var url = "/api/user/lead/archive/" + leadId;
            return this.http.post(url, {});
        }
    }, {
        key: "unarchiveLead",
        value: function unarchiveLead(leadId) {
            var url = "/api/user/lead/unarchive/" + leadId;
            return this.http.post(url, {});
        }
    }, {
        key: "getLeadsExport",
        value: function getLeadsExport() {
            var url = '/api/user/v1/lead/export/start-process';
            return this.http.get(url).pipe(operators_1.map(function (res) {
                return res.data;
            }));
        }
    }, {
        key: "leadObservable",
        get: function get() {
            return this.job2Edit.asObservable();
        }
    }, {
        key: "shouldLeadBeUpdatedObservable",
        get: function get() {
            return this.forceJobUpdate.asObservable();
        }
    }]);

    return LeadsDataServiceProvider;
}();
LeadsDataServiceProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [http_1.HttpClient])], LeadsDataServiceProvider);
exports.LeadsDataServiceProvider = LeadsDataServiceProvider;

/***/ }),

/***/ "./shared/services/notes/notes.data.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var http_1 = __webpack_require__("./node_modules/@angular/common/esm5/http.js");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var BehaviorSubject_1 = __webpack_require__("./node_modules/rxjs/BehaviorSubject.js");
var NotesDataServiceProvider = function () {
    function NotesDataServiceProvider(http) {
        var _this = this;

        _classCallCheck(this, NotesDataServiceProvider);

        this.http = http;
        this.notes = new BehaviorSubject_1.BehaviorSubject(false);
        this.notesUpdateEvent = new Subject_1.Subject();
        this.saveNotes = function (notes, isClient) {
            var url = isClient ? '/protected/rest/clients/notes/update' : '/protected/rest/job/notes/update';
            return _this.http.post(url, notes);
        };
    }

    _createClass(NotesDataServiceProvider, [{
        key: "emitNotes",
        value: function emitNotes(notes) {
            this.notes.next(notes);
        }
    }, {
        key: "emitNotesUpdateEvent",
        value: function emitNotesUpdateEvent(value) {
            this.notesUpdateEvent.next(value);
        }
    }, {
        key: "notesObservable",
        get: function get() {
            return this.notes.asObservable();
        }
    }, {
        key: "shouldNotesBeUpdatedObservable",
        get: function get() {
            return this.notesUpdateEvent.asObservable();
        }
    }]);

    return NotesDataServiceProvider;
}();
NotesDataServiceProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [http_1.HttpClient])], NotesDataServiceProvider);
exports.NotesDataServiceProvider = NotesDataServiceProvider;

/***/ }),

/***/ "./shared/services/pagination/pagination.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });

var PaginationService = function () {
    function PaginationService() {
        _classCallCheck(this, PaginationService);
    }

    _createClass(PaginationService, [{
        key: "getResultsPage",
        value: function getResultsPage(currentPageRequest, totalItems) {
            var pageNumber = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
            var perPage = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
            var predicate = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
            var reverse = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;

            var changed = false;
            var pageRequest = JSON.parse(JSON.stringify(currentPageRequest));
            if (predicate) {
                pageRequest.sortCriteria.fieldName = predicate;
                pageRequest.sortCriteria.sortAscending = reverse;
                pageRequest.paging.pageNumber = 0;
                changed = true;
            }
            if (perPage) {
                pageRequest.paging.pageSize = perPage;
                pageRequest.paging.searchToken = null;
                pageRequest.paging.pageNumber = 0;
                changed = true;
            }
            if (pageNumber || pageNumber === 0) {
                pageRequest.paging.pageNumber = pageNumber;
                changed = true;
            }
            if (pageRequest && totalItems !== 0 && totalItems < (pageRequest.paging.pageNumber - 1) * pageRequest.paging.pageSize + 1) {
                console.log('out of page');
                pageRequest.paging.pageNumber = 1;
                changed = true;
            }
            if (changed) {
                return pageRequest;
            }
            return null;
        }
    }, {
        key: "changePage",
        value: function changePage(currentPageRequest, totalItems) {
            var pageNumber = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

            var pageRequest = JSON.parse(JSON.stringify(currentPageRequest));
            var changed = false;
            if (pageNumber || pageNumber === 0) {
                pageRequest.paging.pageNumber = pageNumber;
                changed = true;
            }
            if (!changed) {
                return null;
            }
            return pageRequest;
        }
    }, {
        key: "calculatePageNumbers",
        value: function calculatePageNumbers(totalItems, pageSize) {
            var pagesCount = void 0;
            var pageNumbers = [];
            pagesCount = totalItems / pageSize;
            pagesCount = Math.ceil(pagesCount);
            for (var i = 0; i < pagesCount; i++) {
                pageNumbers[i] = i;
            }
            return pageNumbers;
        }
    }]);

    return PaginationService;
}();

exports.PaginationService = PaginationService;

/***/ }),

/***/ "./shared/services/payments/payments-data-service/payments.data.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var http_1 = __webpack_require__("./node_modules/@angular/common/esm5/http.js");
var BehaviorSubject_1 = __webpack_require__("./node_modules/rxjs/BehaviorSubject.js");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var PaymentsDataServiceProvider = function () {
    function PaymentsDataServiceProvider(http) {
        _classCallCheck(this, PaymentsDataServiceProvider);

        this.http = http;
        this.id = new BehaviorSubject_1.BehaviorSubject(false);
        this.discount = new BehaviorSubject_1.BehaviorSubject(false);
        this.discountType = new BehaviorSubject_1.BehaviorSubject(false);
        this.issueDate = new BehaviorSubject_1.BehaviorSubject(false);
        this.paymentSchedule = new BehaviorSubject_1.BehaviorSubject(false);
        this.invoicePayments = new BehaviorSubject_1.BehaviorSubject(false);
        this.tax = new BehaviorSubject_1.BehaviorSubject(false);
    }

    _createClass(PaymentsDataServiceProvider, [{
        key: "emitId",
        value: function emitId(id) {
            return this.id.next(id);
        }
    }, {
        key: "emitDiscount",
        value: function emitDiscount(id) {
            return this.discount.next(id);
        }
    }, {
        key: "emitIssueDate",
        value: function emitIssueDate(date) {
            return this.issueDate.next(date);
        }
    }, {
        key: "emitDiscountType",
        value: function emitDiscountType(type) {
            return this.discountType.next(type);
        }
    }, {
        key: "emitPaymentSchedule",
        value: function emitPaymentSchedule(id) {
            return this.paymentSchedule.next(id);
        }
    }, {
        key: "emitInvoicePayments",
        value: function emitInvoicePayments(payments) {
            return this.invoicePayments.next(payments);
        }
    }, {
        key: "emitTax",
        value: function emitTax(tax) {
            return this.tax.next(tax);
        }
        // deprecated, use getPaymentsV2

    }, {
        key: "getPaymentsOnPage",
        value: function getPaymentsOnPage(pageRequest, paid) {
            var perPage = pageRequest.perPage,
                page = pageRequest.page,
                _pageRequest$pageOrde = pageRequest.pageOrder,
                predicate = _pageRequest$pageOrde.predicate,
                reverse = _pageRequest$pageOrde.reverse,
                search = pageRequest.search;

            var url = '/protected/rest/invoice/get_invoices';
            var params = new http_1.HttpParams();
            params = params.append('perPage', perPage);
            params = params.append('page', page);
            params = params.append('predicate', predicate);
            params = params.append('reverse', reverse);
            params = params.append('search', search);
            params = params.append('paid', paid);
            return this.http.get(url, { params: params });
        }
    }, {
        key: "getTotalDue",
        value: function getTotalDue(isPaidSelected) {
            var url = "/protected/rest/invoices/total_due" + isPaidSelected;
            return this.http.get(url);
        }
    }, {
        key: "getPayOnlineLink",
        value: function getPayOnlineLink(id) {
            var url = "/protected/rest/invoices/invoice/payonline/" + id;
            return this.http.post(url, {});
        }
    }, {
        key: "getPaymentsV1",
        value: function getPaymentsV1(paginationRules) {
            var url = '/api/user/v1/payments/overview';
            return this.http.post(url, paginationRules);
        }
    }, {
        key: "getTotalDueV1",
        value: function getTotalDueV1(isPaidSelected) {
            var url = "/api/user/payments/" + isPaidSelected + "Amount";
            return this.http.get(url);
        }
    }, {
        key: "writeOff",
        value: function writeOff(id) {
            var url = "/api/user/payments/" + id + "/writeoff";
            return this.http.post(url, {});
        }
    }, {
        key: "calculatePaymentSchedule",
        value: function calculatePaymentSchedule(payments) {
            var url = '/api/public/v1/ui/helper/calculate/payment-schedule';
            return this.http.post(url, payments);
        }
    }, {
        key: "exportPaymentsCSV",
        value: function exportPaymentsCSV(data) {
            var httpOptions = new http_1.HttpHeaders({
                'Content-Type': 'application/json'
            });
            var url = '/api/user/v1/payments/export/csv';
            return this.http.post(url, data, {
                headers: httpOptions,
                observe: 'response',
                responseType: 'blob'
            });
        }
    }, {
        key: "exportPaymentsXLS",
        value: function exportPaymentsXLS(data) {
            var httpOptions = new http_1.HttpHeaders({
                'Content-Type': 'application/json'
            });
            var url = '/api/user/v1/payments/export/xls';
            return this.http.post(url, data, {
                headers: httpOptions,
                observe: 'response',
                responseType: 'blob'
            });
        }
    }, {
        key: "getAllTime",
        value: function getAllTime(data) {
            var url = '/api/user/v1/payments/export-metadata';
            return this.http.post(url, data).pipe(operators_1.map(function (res) {
                return res.data;
            }));
        }
    }, {
        key: "discountObservable",
        get: function get() {
            return this.discount.asObservable();
        }
    }, {
        key: "idObservable",
        get: function get() {
            return this.id.asObservable();
        }
    }, {
        key: "issueDateObservable",
        get: function get() {
            return this.issueDate.asObservable();
        }
    }, {
        key: "discountTypeObservable",
        get: function get() {
            return this.discountType.asObservable();
        }
    }, {
        key: "paymentScheduleObservable",
        get: function get() {
            return this.paymentSchedule.asObservable();
        }
    }, {
        key: "invoicePaymentsObservable",
        get: function get() {
            return this.invoicePayments.asObservable();
        }
    }, {
        key: "taxObservable",
        get: function get() {
            return this.tax.asObservable();
        }
    }]);

    return PaymentsDataServiceProvider;
}();
PaymentsDataServiceProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [http_1.HttpClient])], PaymentsDataServiceProvider);
exports.PaymentsDataServiceProvider = PaymentsDataServiceProvider;

/***/ }),

/***/ "./shared/services/payments/payments-schedules-data-service/payments-schedules.data.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = __webpack_require__("./node_modules/@angular/common/esm5/http.js");
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var auth_tokens_service_1 = __webpack_require__("./web/modern/auth-tokens.service.ts");
var PaymentSchedulesDataProvider = function () {
    function PaymentSchedulesDataProvider(http, tokenService) {
        _classCallCheck(this, PaymentSchedulesDataProvider);

        this.http = http;
        this.tokenService = tokenService;
    }

    _createClass(PaymentSchedulesDataProvider, [{
        key: "getPaymentScheduleOptions",
        value: function getPaymentScheduleOptions() {
            /* headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            } */
            var url = '/protected/rest/payment_schedule_options';
            return this.http.get(url);
        }
    }, {
        key: "getPaymentScheduleSettings",
        value: function getPaymentScheduleSettings() {
            var url = 'api/user/settings/payment-schedule/metadata';
            var token = this.tokenService.getAuthToken();
            var headers = new http_1.HttpHeaders({
                Authorization: "Bearer " + token
            });
            var options = { headers: headers };
            return this.http.get(url, options);
        }
    }, {
        key: "createPaymentSchedule",
        value: function createPaymentSchedule(data) {
            var url = '/api/user/settings/payment-schedules/create';
            return this.http.post(url, data);
        }
    }, {
        key: "updatePaymentSchedule",
        value: function updatePaymentSchedule(data) {
            var url = "/api/user/settings/payment-schedules/" + data.id + "/update";
            return this.http.post(url, data);
        }
    }, {
        key: "deletePaymentSchedule",
        value: function deletePaymentSchedule(data) {
            var url = '/protected/rest/payment_schedule/delete';
            return this.http.post(url, data);
        }
    }, {
        key: "getPaymentsSchedules",
        value: function getPaymentsSchedules(params) {
            var url = '/protected/rest/company_payment_schedules';
            return this.http.get(url, { params: params });
        }
    }, {
        key: "getPaymentSchedule",
        value: function getPaymentSchedule(id) {
            var url = '/protected/rest/payment_schedule';
            var params = new http_1.HttpParams().append('paymentScheduleId', id);
            return this.http.get(url, { params: params });
        }
    }]);

    return PaymentSchedulesDataProvider;
}();
PaymentSchedulesDataProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [http_1.HttpClient, auth_tokens_service_1.AuthTokensService])], PaymentSchedulesDataProvider);
exports.PaymentSchedulesDataProvider = PaymentSchedulesDataProvider;

/***/ }),

/***/ "./shared/services/payments/payments-service/payments.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var time_service_1 = __webpack_require__("./shared/services/helpers/time-service/time.service.ts");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var PaymentsServiceProvider = function () {
    function PaymentsServiceProvider(timeService, messageService) {
        var _this = this;

        _classCallCheck(this, PaymentsServiceProvider);

        this.timeService = timeService;
        this.messageService = messageService;
        this.isNegativePayments = function (payments) {
            return payments.some(function (payment) {
                return payment.amount < 0;
            });
        };
        this.isPaymentsWithoutDate = function (payments) {
            return payments.some(function (payment) {
                return !payment.due;
            });
        };
        this.isInvoicePaid = function (payments) {
            return payments.every(function (payment) {
                return payment.paid === true || payment.writtenOff === true;
            });
        };
        this.isNonEditablePayments = function (payments) {
            return payments.some(function (payment) {
                return payment.editable !== true;
            });
        };
        this.isPaidPayments = function (payments) {
            return payments.some(function (payment) {
                return payment.paid;
            });
        };
        this.isWrittenOffPayments = function (payments) {
            return payments.some(function (payment) {
                return payment.writtenOff;
            });
        };
        this.isValidDiscountPercent = function (discountAmount, discountType, page) {
            if (discountType === 'Percent of order' && discountAmount > 100) {
                var errorCode = void 0,
                    errorPlace = void 0;
                if (page === 'invoicePage') {
                    errorCode = 'e_2';
                    errorPlace = 'editInvoice';
                } else {
                    errorCode = 'e_2';
                    errorPlace = 'editQuote';
                }
                _this.messageService.showToaster(errorCode, errorPlace);
                return false;
            }
            return true;
        };
        this.isXeroError = function (packagesArray, discountType) {
            if (discountType === 'Fixed') {
                _this.messageService.showToaster('e_1', 'xero');
                return true;
            }
            if (_this.isMixedTaxTypes(packagesArray)) {
                _this.messageService.showToaster('e_4', 'xero');
                return true;
            }
            return false;
        };
        this.isQuickbooksError = function (packagesArray, discountType) {
            if (discountType === 'Fixed') {
                // $(document.body).animate({scrollTop: 0}, "slow");
                _this.messageService.showToaster('e_1', 'xero');
                return true;
            }
            if (_this.isMixedTaxTypes(packagesArray)) {
                // $(document.body).animate({scrollTop: 0}, "slow");
                _this.messageService.showToaster('e_4', 'xero');
                return true;
            }
            // toastr.clear();
            return false;
        };
        this.isValidDiscountFixed = function (packagesArray, discountType) {
            if (discountType === 'Fixed') {
                if (_this.isMixedTaxTypes(packagesArray)) {
                    _this.messageService.showToaster('e_4', 'payments');
                    return false;
                }
            }
            return true;
        };
        this.setPaymentsDates = function (payment) {
            var today = new Date();
            var dateProperty = 'due';
            if (payment.hasOwnProperty('paymentDate')) {
                dateProperty = 'paymentDate';
            }
            payment.days = _this.timeService.calcDate(today, _this.timeService.createDateAsUTC(payment[dateProperty]));
            payment[dateProperty] = _this.timeService.createDateAsUTC(payment[dateProperty]);
            payment.late = false;
            var dayMulti = ' days';
            if (payment.days === 1 || payment.days === -1) {
                dayMulti = ' day';
            }
            if (payment.days === 0) {
                payment.days = 'today';
            } else if (payment.days > 0) {
                payment.days = payment.days + dayMulti + " ago";
                payment.red = 'red';
                payment.late = true;
            } else {
                payment.days = "in " + -payment.days + dayMulti;
            }
            return payment;
        };
        this.isMixedTaxTypes = function (packagesArray) {
            var firstPackage = packagesArray[0] || {};
            var firstPackageTaxType = firstPackage.taxType || '';
            return packagesArray.some(function (item) {
                return item.taxType !== firstPackageTaxType;
            });
        };
        this.handlePayment = this.handlePayment.bind(this);
    }

    _createClass(PaymentsServiceProvider, [{
        key: "setSentStatus",
        value: function setSentStatus(isSent) {
            if (document.getElementById('stamp')) {
                document.getElementById('stamp').setAttribute('src', "https://app.studioninja.co/build/release-pipeline-119/resources/dist/assets/images/icons/statuses/" + (isSent ? 'sent.png' : 'notsent.png'));
            }
        }
    }, {
        key: "handlePayment",
        value: function handlePayment(payment) {
            var today = new Date();
            payment.days = this.timeService.calcDate(today, this.timeService.createDateAsUTC(payment.due));
            if (payment.paidOn) {
                payment.paidOn = this.timeService.createDateAsUTC(payment.paidOn);
            }
            payment.late = false;
            var dayMulti = ' days';
            if (payment.days === 1 || payment.days === -1) {
                dayMulti = ' day';
            }
            if (payment.days === 0) {
                payment.days = 'today';
            } else if (payment.days > 0) {
                payment.days = payment.days + dayMulti + " ago";
                if (!payment.paid) {
                    payment.late = true;
                }
            } else {
                payment.days = "in " + -payment.days + dayMulti;
            }
            return payment;
        }
    }, {
        key: "calcPrevFullTotal",
        value: function calcPrevFullTotal(products) {
            var total = 0;
            products.forEach(function (product) {
                total += product.quantity * product.price;
            });
            return total;
        }
    }, {
        key: "createExistingPaymentObj",
        value: function createExistingPaymentObj(payment, isInvoice) {
            var isNonEditable = payment.paid || payment.writtenOff;
            return {
                amount: payment.amount,
                writtenOff: payment.writtenOff,
                paid: payment.paid,
                amountWithCurrency: payment.amountWithCurrency,
                due: payment.paymentDate === null && payment.due === null ? null : this.timeService.createDateAsUTC(payment.paymentDate || payment.due),
                id: payment.id,
                editable: !isNonEditable,
                part: payment.part,
                schedule: isInvoice ? null : this.setPaymentScheduleRule(payment),
                paymentSchedulePart: payment.paymentSchedulePart === null ? { amount: payment.amount } : payment.paymentSchedulePart
            };
        }
    }, {
        key: "setPaymentScheduleRule",
        value: function setPaymentScheduleRule(payment) {
            if (payment.paymentSchedulePart === null) {
                return '100% of order';
            }
            return "" + payment.paymentSchedulePart.amount + this.setAmountType(payment.paymentSchedulePart.type);
        }
    }, {
        key: "setAmountType",
        value: function setAmountType(type) {
            switch (type) {
                case 'Percent of order':
                    return '% of order';
                case 'Percent of remaining balance':
                    return '% of remaining balance';
                default:
                    return '';
            }
        }
    }, {
        key: "getNoneSchedule",
        value: function getNoneSchedule() {
            return {
                name: 'Choose Payment Schedule',
                id: -1
            };
        }
    }]);

    return PaymentsServiceProvider;
}();
PaymentsServiceProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [time_service_1.TimeServiceProvider, message_service_1.MessageService])], PaymentsServiceProvider);
exports.PaymentsServiceProvider = PaymentsServiceProvider;

/***/ }),

/***/ "./shared/services/questionnarie/questionnaires-service/questionnaires.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var mails_data_service_1 = __webpack_require__("./shared/services/email/mails.data.service.ts");
var email_service_1 = __webpack_require__("./shared/services/email/email-service/email.service.ts");
var stringModifier_service_1 = __webpack_require__("./shared/services/helpers/string-modifier-service/stringModifier.service.ts");
var QuestionnairesServiceProvider = function () {
    function QuestionnairesServiceProvider(messageService, mailsDataService, emailService, stringModifierService) {
        _classCallCheck(this, QuestionnairesServiceProvider);

        this.messageService = messageService;
        this.mailsDataService = mailsDataService;
        this.emailService = emailService;
        this.stringModifierService = stringModifierService;
    }

    _createClass(QuestionnairesServiceProvider, [{
        key: "setDefaultEmail",
        value: function setDefaultEmail(emails) {
            if (emails !== undefined && emails !== null && emails.length) {
                return emails.find(function (item) {
                    return item.emailTemplateType === 'QUESTIONNAIRE_EMAIL_TEMPLATE';
                }) || {};
            }
            return null;
        }
    }, {
        key: "successSendEmail",
        value: function successSendEmail() {
            this.messageService.showToaster('s_9', 'jobView');
            this.mailsDataService.emitMailUpdateEvent(true);
        }
    }, {
        key: "errorSendMessage",
        value: function errorSendMessage(result) {
            var data = result.data;
            var errorMessage = data.errorMessage,
                errorTitle = data.errorTitle;

            this.messageService.showErrorFromBackend(errorTitle, errorMessage);
        }
    }, {
        key: "gatherDataToSendQuest",
        value: function gatherDataToSendQuest(data, isNew) {
            var messageData = data.messageData,
                jobId = data.jobId,
                mailData = data.mailData,
                questionnaireId = data.questionnaireId;
            var attachmentsData = messageData.attachmentsData;

            var _emailService$prepare = this.emailService.prepareAttachments(attachmentsData),
                storedFiles = _emailService$prepare.storedFiles,
                uploadedFiles = _emailService$prepare.uploadedFiles;

            var sendMessageData = void 0;
            if (isNew) {
                sendMessageData = this.prepareNewQuestMailToSend(messageData, jobId, mailData);
            } else {
                sendMessageData = this.prepareExistingQuestMailToSend(messageData, jobId, mailData, questionnaireId);
            }
            return {
                sendMessageData: sendMessageData,
                storedFiles: storedFiles,
                uploadedFiles: uploadedFiles
            };
        }
    }, {
        key: "prepareQuestToSave",
        value: function prepareQuestToSave(questionnaire) {
            if (questionnaire && questionnaire.name) {
                questionnaire.name = this.stringModifierService.cutSelectedText(questionnaire.name);
            }
            return questionnaire;
        }
    }, {
        key: "prepareNewQuestMailToSend",
        value: function prepareNewQuestMailToSend(messageData, jobId, mailData) {
            var result = {
                emailTo: messageData.emailTo,
                emailText: messageData.emailText || '',
                emailSubject: messageData.emailSubject,
                questionnaireTemplateId: mailData.chosenQuestionnaire ? mailData.chosenQuestionnaire.id : null,
                jobId: jobId,
                templateId: mailData.chosenEmail.id
            };
            if (messageData.secondaryToEmails && messageData.secondaryToEmails.length) {
                result.secondaryToEmails = messageData.secondaryToEmails;
            }
            if (messageData.ccEmails && messageData.ccEmails.length) {
                result.ccEmails = messageData.ccEmails;
            }
            return result;
        }
    }, {
        key: "prepareExistingQuestMailToSend",
        value: function prepareExistingQuestMailToSend(messageData, jobId, mailData, questionnaireId) {
            var result = {
                emailTo: messageData.emailTo,
                emailText: messageData.emailText || '',
                emailSubject: messageData.emailSubject,
                questionnaireTemplateId: questionnaireId,
                jobId: jobId,
                templateId: mailData.chosenEmail.id
            };
            if (messageData.secondaryToEmails && messageData.secondaryToEmails.length) {
                result.secondaryToEmails = messageData.secondaryToEmails;
            }
            if (messageData.ccEmails && messageData.ccEmails.length) {
                result.ccEmails = messageData.ccEmails;
            }
            return result;
        }
    }]);

    return QuestionnairesServiceProvider;
}();
QuestionnairesServiceProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [message_service_1.MessageService, mails_data_service_1.MailsDataProvider, email_service_1.EmailServiceProvider, stringModifier_service_1.StringModifierServiceProvider])], QuestionnairesServiceProvider);
exports.QuestionnairesServiceProvider = QuestionnairesServiceProvider;

/***/ }),

/***/ "./shared/services/questionnarie/questionnaires.data.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = __webpack_require__("./node_modules/@angular/common/esm5/http.js");
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var QuestionnairesDataProvider = function () {
    function QuestionnairesDataProvider(http) {
        _classCallCheck(this, QuestionnairesDataProvider);

        this.http = http;
    }

    _createClass(QuestionnairesDataProvider, [{
        key: "sendQuestionnaireEmail",
        value: function sendQuestionnaireEmail(data, isNew) {
            var url = isNew ? '/protected/rest/job/questionnaire/save' : '/protected/rest/job/questionnaire/send';
            var sendMessageData = data.sendMessageData,
                storedFiles = data.storedFiles,
                uploadedFiles = data.uploadedFiles;

            var formData = new FormData();
            for (var key in sendMessageData) {
                if (key !== 'attachmentsData') {
                    formData.append(key, sendMessageData[key]);
                }
            }
            for (var _key in storedFiles) {
                formData.append("storedAttachments[" + _key + "]", storedFiles[_key].id);
            }
            for (var _key2 in uploadedFiles) {
                formData.append("attachments[" + _key2 + "]", uploadedFiles[_key2]);
            }
            return this.sendQuestionnaireRequest(url, formData);
        }
    }, {
        key: "sendQuestionnaireRequest",
        value: function sendQuestionnaireRequest(url, formData) {
            return this.http.post(url, formData);
        }
    }, {
        key: "getQuestionnarie",
        value: function getQuestionnarie(jobId, questId) {
            var url = "/protected/rest/jobs/" + jobId + "/questionnaire/" + questId + "/get/";
            return this.http.get(url);
        }
    }, {
        key: "deleteQuestionnarie",
        value: function deleteQuestionnarie(jobId, questId) {
            var url = "/protected/rest/jobs/questionnaires/delete/" + jobId + "/" + questId + "/";
            return this.http.post(url, {});
        }
    }, {
        key: "getQuestionnaireViewData",
        value: function getQuestionnaireViewData(jobId, questionnaireId) {
            var url = "/api/user/v2/job/" + jobId + "/questionnaire/" + questionnaireId + "/view";
            return this.http.get(url).pipe(operators_1.map(function (data) {
                return data.data;
            }));
        }
    }, {
        key: "getQuestionnairePreviewLink",
        value: function getQuestionnairePreviewLink(url) {
            return this.http.get(url).pipe(operators_1.map(function (data) {
                return data.data;
            }));
        }
    }, {
        key: "deleteQuestionnaireV2",
        value: function deleteQuestionnaireV2(url) {
            return this.http.delete(url);
        }
    }]);

    return QuestionnairesDataProvider;
}();
QuestionnairesDataProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [http_1.HttpClient])], QuestionnairesDataProvider);
exports.QuestionnairesDataProvider = QuestionnairesDataProvider;

/***/ }),

/***/ "./shared/services/quote-invoice-templates/quote-invoice-templates.data.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var http_1 = __webpack_require__("./node_modules/@angular/common/esm5/http.js");
var QuoteInvoiceTemplatesDataService = function () {
    function QuoteInvoiceTemplatesDataService(http) {
        _classCallCheck(this, QuoteInvoiceTemplatesDataService);

        this.http = http;
    }
    /*
        Could not be found by reference, because is being called with dynamic name.
        Used in qt-templates.component.ts | quote-update.ts | edit-quote.ts
    */


    _createClass(QuoteInvoiceTemplatesDataService, [{
        key: "getQuoteTemplatesList",
        value: function getQuoteTemplatesList(pageOptions) {
            var url = '/api/user/quote-sample/fixed/preview';
            return this.http.post(url, pageOptions);
        }
        /*
            Could not be found by reference, because is being called with dynamic name.
            Used in qt-templates.component.ts | quote-update.ts | edit-quote.ts
        */

    }, {
        key: "getCustomQuoteTemplatesList",
        value: function getCustomQuoteTemplatesList(pageOptions) {
            var url = '/api/user/quote-sample/preview';
            return this.http.post(url, pageOptions);
        }
        /*
            Could not be found by reference, because is being called with dynamic name.
            Used in qt-templates.component.ts | invoice-update.ts
        */

    }, {
        key: "getInvoiceTemplatesList",
        value: function getInvoiceTemplatesList(pageOptions) {
            var url = '/api/user/invoice-sample/preview';
            return this.http.post(url, pageOptions);
        }
    }, {
        key: "getQuoteIntroduction",
        value: function getQuoteIntroduction() {
            var url = '/api/user/quote-sample/introduction';
            return this.http.get(url);
        }
    }, {
        key: "invokeDynamicRequest",
        value: function invokeDynamicRequest(url, method, data) {
            if (data) {
                return this.http[method.toLowerCase()](url, data);
            }
            return this.http[method.toLowerCase()](url);
        }
    }, {
        key: "loadQtTemplate",
        value: function loadQtTemplate(id, type) {
            var url = "/api/user/" + type.toLowerCase() + "-sample/" + id;
            return this.http.get(url);
        }
    }, {
        key: "saveTemplate",
        value: function saveTemplate(type, data) {
            var url = void 0;
            if (type === 'CUSTOM_QUOTE') {
                url = '/api/user/quote-sample';
            }
            if (type === 'QUOTE') {
                url = '/api/user/quote-sample/fixed';
            }
            if (type === 'INVOICE') {
                url = '/api/user/invoice-sample';
            }
            return this.http.post(url, data);
        }
    }, {
        key: "editTemplate",
        value: function editTemplate(type, id, data) {
            var url = void 0;
            if (type === 'CUSTOM_QUOTE') {
                url = "/api/user/quote-sample/" + id;
            }
            if (type === 'QUOTE') {
                url = "/api/user/quote-sample/fixed/" + id;
            }
            if (type === 'INVOICE') {
                url = "/api/user/invoice-sample/" + id;
            }
            return this.http.put(url, data);
        }
    }]);

    return QuoteInvoiceTemplatesDataService;
}();
QuoteInvoiceTemplatesDataService = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [http_1.HttpClient])], QuoteInvoiceTemplatesDataService);
exports.QuoteInvoiceTemplatesDataService = QuoteInvoiceTemplatesDataService;

/***/ }),

/***/ "./shared/services/quote-invoice-templates/quote-invoice-templates.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var validation_service_1 = __webpack_require__("./shared/services/helpers/validation.service.ts");
var quote_update_service_1 = __webpack_require__("./shared/services/quote/quote-update.service.ts");
var stringModifier_service_1 = __webpack_require__("./shared/services/helpers/string-modifier-service/stringModifier.service.ts");
var invoice_service_1 = __webpack_require__("./shared/services/invoice/invoice-service/invoice.service.ts");
var payments_service_1 = __webpack_require__("./shared/services/payments/payments-service/payments.service.ts");
var order_by_name_1 = __webpack_require__("./shared/pipes/order-by/order-by-name.ts");
var QuoteInvoiceTemplatesService = function () {
    function QuoteInvoiceTemplatesService(messageService, validationService, quoteUpdateService, stringModifierService, invoiceUpdateService, paymentsService, orderByName) {
        _classCallCheck(this, QuoteInvoiceTemplatesService);

        this.messageService = messageService;
        this.validationService = validationService;
        this.quoteUpdateService = quoteUpdateService;
        this.stringModifierService = stringModifierService;
        this.invoiceUpdateService = invoiceUpdateService;
        this.paymentsService = paymentsService;
        this.orderByName = orderByName;
    }

    _createClass(QuoteInvoiceTemplatesService, [{
        key: "createTemplateDataFromQuote",
        value: function createTemplateDataFromQuote(quote, contract, type) {
            return {
                introduction: quote.introduction,
                notes: quote.notes,
                contractTemplate: contract,
                questionnaireTemplate: quote.questionnaire,
                paymentSchedule: quote.paymentSchedule ? {
                    name: quote.paymentSchedule.name,
                    id: 0
                } : null,
                paymentsRule: quote.paymentsRule,
                payments: quote.payments,
                generateInvoiceWhenAccepted: quote.generateInvoiceWhenAccepted,
                summary: quote.summary,
                name: null,
                createdAt: null,
                products: quote.products,
                type: type
            };
        }
    }, {
        key: "createTemplateDataFromInvoice",
        value: function createTemplateDataFromInvoice(invoice, contract, type) {
            return {
                notes: invoice.notes || '',
                contractTemplate: contract,
                questionnaireTemplate: invoice.questionnaire || null,
                paymentSchedule: invoice.paymentSchedule ? {
                    name: invoice.paymentSchedule.name,
                    id: 0
                } : null,
                paymentsRule: invoice.paymentsRule,
                payments: invoice.payments,
                summary: invoice.summary,
                name: null,
                createdAt: null,
                products: invoice.summary ? [].concat(_toConsumableArray(invoice.summary.items)) : [],
                type: type
            };
        }
    }, {
        key: "prepareProductsForDiff",
        value: function prepareProductsForDiff(products) {
            return products.map(function (product) {
                return Object.assign({}, product, { summary: null, order: null, amount: null, quantity: +product.quantity, discount: +product.discount, price: +product.price });
            });
        }
    }, {
        key: "prepareProductsForDiffInvoices",
        value: function prepareProductsForDiffInvoices(products) {
            return products.map(function (product) {
                return Object.assign({}, product, { summary: null, order: null, amount: null, mandatory: null, recommended: null, quantity: +product.quantity, discount: +product.discount, price: +product.price });
            });
        }
    }, {
        key: "prepareQuoteInvoiceDataForDiff",
        value: function prepareQuoteInvoiceDataForDiff(invoice) {
            var newInvoice = JSON.parse(JSON.stringify(invoice));
            newInvoice.products = newInvoice.products.map(function (product) {
                return Object.assign({}, product, { taxType: product.type === 'GIFT' ? null : product.taxType, type: product.type === 'GIFT' ? 'GIFT' : null });
            });
            return newInvoice;
        }
    }, {
        key: "prepareTemplateForSave",
        value: function prepareTemplateForSave(templateData) {
            var paymentSchedulerTemplateId = templateData.paymentSchedulerTemplateId,
                contractTemplateId = templateData.contractTemplateId,
                questionnaireTemplateId = templateData.questionnaireTemplateId,
                data = templateData.data;

            return {
                paymentSchedulerTemplateId: paymentSchedulerTemplateId === '-2' || paymentSchedulerTemplateId === '-3' ? null : paymentSchedulerTemplateId,
                paymentsStrategy: paymentSchedulerTemplateId === '-2' && 'NO_SPLIT_PAYMENTS' || paymentSchedulerTemplateId === '-3' && 'NO_DUE_DATE' || 'BY_PAYMENT_SCHEDULER',
                questionnaireTemplateId: questionnaireTemplateId === '-1' ? null : questionnaireTemplateId,
                contractTemplateId: contractTemplateId === '-1' ? null : contractTemplateId,
                data: data
            };
        }
    }, {
        key: "mapLineItems",
        value: function mapLineItems(products) {
            var _this = this;

            return products.map(function (product, index) {
                return Object.assign({}, product, { productPackageTemplateId: product.id || product.productPackageTemplateId || null, order: index, price: _this.stringModifierService.convertAmountIntoNumber(product.price), mandatory: product.type === 'PACKAGE' ? products.length > 1 ? false : product.mandatory : product.mandatory, taxType: product.type === 'GIFT' ? _this.quoteUpdateService.setTaxTypeForDiscount(products, product.taxType) : product.taxType });
            });
        }
    }, {
        key: "findTemplateItemById",
        value: function findTemplateItemById(list, id) {
            var _list$filter = list.filter(function (item) {
                return item.id === +id;
            }),
                _list$filter2 = _slicedToArray(_list$filter, 1),
                template = _list$filter2[0];

            var name = template.name;
            if (this.stringModifierService.isSelectedText(name)) {
                name = this.stringModifierService.cutSelectedText(name);
            }
            return { name: name, id: template.id };
        }
    }, {
        key: "addSelectedTemplate",
        value: function addSelectedTemplate(list, item) {
            if (item && item.name) {
                item.name = this.stringModifierService.addSelectedText(item.name);
                list.push(item);
            }
        }
    }, {
        key: "assignCorrectTemplateList",
        value: function assignCorrectTemplateList(templates, template) {
            var newTemplates = this.orderByName.transform(templates);
            if (template) {
                newTemplates.push(Object.assign({}, template, { name: this.stringModifierService.addSelectedText(template.name) }));
            }
            return newTemplates;
        }
    }, {
        key: "shouldDiffBeChecked",
        value: function shouldDiffBeChecked(chosenTemplate, selectedTemplate) {
            if (!chosenTemplate && !selectedTemplate) {
                return false;
            }
            if (chosenTemplate && selectedTemplate && chosenTemplate.id === selectedTemplate.id) {
                return false;
            }
            return true;
        }
    }, {
        key: "validateSelectedTemplates",
        value: function validateSelectedTemplates(data, contractTemplates, questionnaireTemplates, type) {
            var selectedContractTemplate = contractTemplates[contractTemplates.length - 1];
            var selectedQuestionnaireTemplate = questionnaireTemplates[questionnaireTemplates.length - 1];
            var contractFlag = this.stringModifierService.isSelectedText(selectedContractTemplate.name) && selectedContractTemplate.id.toString() === data.contractTemplateId;
            var questionnaireFlag = this.stringModifierService.isSelectedText(selectedQuestionnaireTemplate.name) && selectedQuestionnaireTemplate.id.toString() === data.questionnaireTemplateId;
            if (contractFlag && questionnaireFlag) {
                this.messageService.showToaster('e_7', 'quoteInvoiceTemplates', type === 'INVOICE' ? 'invoice' : 'quote');
                return false;
            }
            if (contractFlag) {
                this.messageService.showToaster('e_5', 'quoteInvoiceTemplates', type === 'INVOICE' ? 'invoice' : 'quote');
                return false;
            }
            if (questionnaireFlag) {
                this.messageService.showToaster('e_6', 'quoteInvoiceTemplates', type === 'INVOICE' ? 'invoice' : 'quote');
                return false;
            }
            return true;
        }
    }, {
        key: "isTemplateNameValid",
        value: function isTemplateNameValid(type, template) {
            if (type === 'duplicate' && (template.name + " copy").length > 100) {
                this.messageService.showToaster('e_8', 'quoteInvoiceTemplates');
                return;
            }
            return true;
        }
    }, {
        key: "validateQuoteTemplate",
        value: function validateQuoteTemplate(data) {
            var _this2 = this;

            var _data$data = data.data,
                products = _data$data.products,
                name = _data$data.name;

            if (!name || name && !name.trim()) {
                this.messageService.showToaster('e_0', 'quoteInvoiceTemplates');
                return false;
            }
            var invalidProductType = void 0;
            if (products.find(function (product) {
                return product.type === 'GIFT' && !product.mandatory;
            }) !== undefined) {
                this.messageService.showToaster('e_6', 'editQuote');
                return false;
            }
            if (products.find(function (product) {
                return product.type === 'GIFT' && parseInt(product.quantity) !== 1;
            }) !== undefined) {
                this.messageService.showToaster('e_10', 'editQuote');
                return false;
            }
            if (products.find(function (product) {
                return product.type === 'GIFT' && product.price >= 0;
            }) !== undefined) {
                this.messageService.showToaster('e_16', 'editQuote');
                return false;
            }
            if (products.find(function (product) {
                return product.type === 'GIFT';
            }) !== undefined && products.find(function (product) {
                return product.taxType !== products[0].taxType;
            }) !== undefined) {
                this.messageService.showToaster('e_13', 'editQuote');
                return false;
            }
            if (products.length === 0) {
                this.messageService.showToaster('e_1', 'quoteInvoiceTemplates');
                return false;
            }
            if (products.find(function (product) {
                if (product.name === '') {
                    invalidProductType = product.type;
                    if (invalidProductType === 'GIFT') {
                        invalidProductType = 'discount';
                    } else if (invalidProductType === 'ADD_ON') {
                        invalidProductType = 'product';
                    }
                    return true;
                }
            })) {
                this.messageService.showToaster('e_0', 'productsPackages', invalidProductType.toLowerCase());
                return false;
            }
            if (products.find(function (product) {
                return product.quantity <= 0;
            }) !== undefined) {
                this.messageService.showToaster('e_8', 'editQuote');
                return false;
            }
            if (products.find(function (product) {
                var escapedProduct = product.description ? _this2.validationService.trimHTML(product.description).trim() : '';
                if (product.type !== 'GIFT' && (!product.description || product.description.length === 0 || !escapedProduct)) {
                    invalidProductType = product.type.toUpperCase() === 'PACKAGE' ? 'package' : 'product';
                    return true;
                }
            })) {
                this.messageService.showToaster('e_9', 'editQuote', invalidProductType);
                return false;
            }
            if (products.find(function (product) {
                if (product.name.trim().length === 0) {
                    if (product.type.toUpperCase() === 'GIFT') {
                        invalidProductType = 'Discount';
                    } else {
                        invalidProductType = product.type.toUpperCase() === 'PACKAGE' ? 'Package' : 'Product';
                    }
                    return true;
                }
            })) {
                this.messageService.showToaster('e_14', 'editQuote', invalidProductType);
                return false;
            }
            if (products.find(function (product) {
                return product.discount > 100;
            }) !== undefined) {
                this.messageService.showToaster('e_2', 'editQuote');
                return false;
            }
            var invalidCounter = document.querySelector('.counter.red');
            if (invalidCounter) {
                this.messageService.showToaster('e_6', 'productsPackages', '4000');
                return false;
            }
            if (+data.paymentSchedulerTemplateId == -1) {
                this.messageService.showToaster('e_18', 'editQuote');
                return false;
            }
            return true;
        }
    }, {
        key: "validateInvoiceTemplate",
        value: function validateInvoiceTemplate(data) {
            var _data$data2 = data.data,
                products = _data$data2.products,
                name = _data$data2.name;

            if (products.length === 0) {
                this.messageService.showToaster('e_1', 'quoteInvoiceTemplates');
                return false;
            }
            var amount = data.summary.subTotal;
            var discount = data.summary.discountValue;
            var totalDue = data.summary.total;
            var discountType = null;
            var pageName = 'editInvoice';
            var invalidProductType = void 0;
            var messagePlace = pageName;
            if (!name || name && !name.trim()) {
                this.messageService.showToaster('e_0', 'quoteInvoiceTemplates');
                return false;
            }
            if (this.invoiceUpdateService.isChosenProductsInvalid(products, pageName)) {
                return false;
            }
            if (discountType === 'Fixed' && amount - discount < 0) {
                this.messageService.showToaster('e_1', 'editInvoice');
                return false;
            }
            var isValidDiscountFixed = this.paymentsService.isValidDiscountFixed(products, discountType);
            if (!isValidDiscountFixed) {
                return false;
            }
            var isValidDiscountPercent = this.paymentsService.isValidDiscountPercent(discount, discountType, pageName);
            if (!isValidDiscountPercent) {
                return false;
            }
            if (typeof totalDue === 'undefined' || totalDue === null) {
                this.messageService.showToaster('e_0', 'general');
                return false;
            }
            if (totalDue < 0) {
                this.messageService.showToaster('e_17', messagePlace);
                return false;
            }
            if (products.find(function (product) {
                return product.type === 'GIFT' && product.price >= 0;
            }) !== undefined) {
                this.messageService.showToaster('e_16', 'editQuote');
                return false;
            }
            if (products.find(function (product) {
                if (product.name === '') {
                    invalidProductType = product.type;
                    if (invalidProductType === 'GIFT') {
                        invalidProductType = 'discount';
                    } else if (invalidProductType === 'ADD_ON') {
                        invalidProductType = 'product';
                    }
                    return true;
                }
            })) {
                this.messageService.showToaster('e_0', 'productsPackages', invalidProductType.toLowerCase());
                return false;
            }
            if (products.find(function (product) {
                if (product.name.trim().length === 0) {
                    if (product.type.toUpperCase() === 'GIFT') {
                        invalidProductType = 'Discount';
                    } else {
                        invalidProductType = product.type.toUpperCase() === 'PACKAGE' ? 'Package' : 'Product';
                    }
                    return true;
                }
            })) {
                this.messageService.showToaster('e_14', 'editQuote', invalidProductType);
                return false;
            }
            // MAGIC DON'T TOUCH
            if (products.filter(function (product) {
                return product.type === 'GIFT';
            }).length > 0 && products.filter(function (product) {
                return product.taxType !== products[0].taxType;
            }).length > 0) {
                this.messageService.showToaster('e_4', 'payments');
                return false;
            }
            var invalidCounter = document.querySelector('.counter.red');
            if (invalidCounter) {
                this.messageService.showToaster('e_6', 'productsPackages', '4000');
                return false;
            }
            if (+data.paymentSchedulerTemplateId == -1) {
                this.messageService.showToaster('e_18', 'editQuote');
                return false;
            }
            return true;
        }
    }], [{
        key: "getTemplatesParameters",
        value: function getTemplatesParameters() {
            return {
                paging: {
                    pageSize: 1000,
                    pageNumber: 0
                },
                sortCriterias: [{ fieldName: 'name', sortAscending: true }]
            };
        }
    }, {
        key: "getEmptyQtItem",
        value: function getEmptyQtItem(type, product, introduction) {
            return {
                contractTemplate: null,
                createdAt: null,
                generateInvoiceWhenAccepted: true,
                introduction: introduction || '',
                notes: '',
                name: '',
                paymentSchedule: null,
                paymentsRule: {
                    strategy: 'NO_SPLIT_PAYMENTS',
                    paymentSchedule: null
                },
                products: product ? [product] : [],
                questionnaireTemplate: null,
                summary: null,
                type: type
            };
        }
    }]);

    return QuoteInvoiceTemplatesService;
}();
QuoteInvoiceTemplatesService = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [message_service_1.MessageService, validation_service_1.ValidationProvider, quote_update_service_1.QuoteUpdateService, stringModifier_service_1.StringModifierServiceProvider, invoice_service_1.InvoiceServiceProvider, payments_service_1.PaymentsServiceProvider, order_by_name_1.OrderByNamePipe])], QuoteInvoiceTemplatesService);
exports.QuoteInvoiceTemplatesService = QuoteInvoiceTemplatesService;

/***/ }),

/***/ "./shared/services/quote/quote-update.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var BehaviorSubject_1 = __webpack_require__("./node_modules/rxjs/BehaviorSubject.js");
var time_service_1 = __webpack_require__("./shared/services/helpers/time-service/time.service.ts");
var QuoteUpdateService = function () {
    function QuoteUpdateService(timeService) {
        _classCallCheck(this, QuoteUpdateService);

        this.timeService = timeService;
        this.updatedProduct$ = new BehaviorSubject_1.BehaviorSubject(null);
        this.updatePaymentsScheduleSubject = new BehaviorSubject_1.BehaviorSubject(null);
        this.updatePoNumberSubject = new BehaviorSubject_1.BehaviorSubject(null);
        this.updateIntroductionSubject = new BehaviorSubject_1.BehaviorSubject(null);
        this.updateNotesSubject = new BehaviorSubject_1.BehaviorSubject(null);
    }

    _createClass(QuoteUpdateService, [{
        key: "emitPaymentScheduleChanges",
        value: function emitPaymentScheduleChanges(value) {
            return this.updatePaymentsScheduleSubject.next(value);
        }
    }, {
        key: "emitPoNumberChanges",
        value: function emitPoNumberChanges(value) {
            return this.updatePoNumberSubject.next(value);
        }
    }, {
        key: "emitIntroductionChanges",
        value: function emitIntroductionChanges(value) {
            return this.updateIntroductionSubject.next(value);
        }
    }, {
        key: "emitNotesChanges",
        value: function emitNotesChanges(value) {
            return this.updateNotesSubject.next(value);
        }
    }, {
        key: "getNow",
        value: function getNow() {
            return this.timeService.getDateString(new Date());
        }
    }, {
        key: "getDate",
        value: function getDate(date) {
            return this.timeService.getDateString(date);
        }
    }, {
        key: "getNowTextFormat",
        value: function getNowTextFormat() {
            return this.timeService.getProperDate(new Date());
        }
    }, {
        key: "getProperDate",
        value: function getProperDate(date) {
            return this.timeService.getProperDate(date);
        }
    }, {
        key: "setQuoteIssueDate",
        value: function setQuoteIssueDate(issueDate) {
            return issueDate ? {
                jsdate: this.timeService.createDateAsUTC(issueDate)
            } : null;
        }
    }, {
        key: "setEmptyQuote",
        value: function setEmptyQuote(quoteId) {
            return {
                contract: null,
                introduction: '',
                issueDate: this.getNow(),
                notes: '',
                paymentsSchedule: null,
                payments: [],
                ponumber: null,
                products: null,
                questionnaire: null,
                quoteId: quoteId,
                sentOn: null,
                generateInvoiceWhenAccepted: true,
                status: 'NOT_SENT'
            };
        }
    }, {
        key: "sortPaymentsByDate",
        value: function sortPaymentsByDate(payments) {
            return payments.sort(this.sortByDateFunction());
        }
    }, {
        key: "setTaxTypeForDiscount",
        value: function setTaxTypeForDiscount(productsToSave, previousTax) {
            return productsToSave[0] ? productsToSave[0].taxType : previousTax;
        }
    }, {
        key: "sortByDateFunction",
        value: function sortByDateFunction() {
            return function (a, b) {
                var dateOfA = a.date ? a.date.jsdate : '';
                var dateOfB = b.date ? b.date.jsdate : '';
                if (dateOfA === '') {
                    return 1;
                } else if (dateOfB === '') {
                    return -1;
                } else if (dateOfA === dateOfB) {
                    return 0;
                }
                return dateOfA < dateOfB ? -1 : 1;
            };
        }
    }, {
        key: "validateProductsPropsDefined",
        value: function validateProductsPropsDefined(products) {
            return products.every(function (product) {
                return (
                    // should be non strict comparison to check if props are defined
                    product.price != null && product.quantity != null && product.discount != null
                );
            });
        }
    }, {
        key: "setNextUpdateProduct",
        value: function setNextUpdateProduct(index, product) {
            if (index === null && product === null) {
                this.updatedProduct$.next(null);
            } else {
                this.updatedProduct$.next({ index: index, product: product });
            }
        }
    }, {
        key: "updatePoNumberObservable",
        get: function get() {
            return this.updatePoNumberSubject.asObservable();
        }
    }, {
        key: "updateIntroductionObservable",
        get: function get() {
            return this.updateIntroductionSubject.asObservable();
        }
    }, {
        key: "updateNotesObservable",
        get: function get() {
            return this.updateNotesSubject.asObservable();
        }
    }, {
        key: "updatePaymentScheduleObservable",
        get: function get() {
            return this.updatePaymentsScheduleSubject.asObservable();
        }
    }, {
        key: "updatedProductObservable",
        get: function get() {
            return this.updatedProduct$.asObservable();
        }
    }], [{
        key: "getPageRequest",
        value: function getPageRequest() {
            return {
                filterBy: 'all',
                paging: {
                    pageNumber: 0,
                    pageSize: 1000,
                    searchToken: null
                },
                sortCriterias: [{
                    fieldName: 'id',
                    sortAscending: true
                }]
            };
        }
    }, {
        key: "getQtBaseTemplateData",
        value: function getQtBaseTemplateData() {
            return {
                contractTemplateId: '-1',
                questionnaireTemplateId: '-1',
                paymentSchedulerTemplateId: '-2',
                data: {
                    introduction: '',
                    notes: '',
                    name: '',
                    generateInvoiceWhenAccepted: false,
                    products: []
                },
                products: null,
                packages: null,
                discounts: null,
                addons: null,
                contracts: [],
                questionnaires: [],
                paymentScheduleTemplates: [],
                paymentDefaultScheduleTemplates: [],
                currency: null,
                summary: null
            };
        }
    }, {
        key: "getPaymentSchedulesPageRequest",
        value: function getPaymentSchedulesPageRequest() {
            return {
                perPage: 500,
                page: 1,
                predicate: 'name',
                reverse: false
            };
        }
    }, {
        key: "setPackagesAndAddons",
        value: function setPackagesAndAddons(products) {
            return {
                packages: products.filter(function (product) {
                    return product.type === 'PACKAGE';
                }),
                addons: products.filter(function (product) {
                    return product.type === 'ADD_ON';
                }),
                discounts: products.filter(function (product) {
                    return product.type === 'GIFT';
                })
            };
        }
    }, {
        key: "separateDiscountsAndProducts",
        value: function separateDiscountsAndProducts(products) {
            return {
                addons: products.filter(function (product) {
                    return product.type === 'PACKAGE' || product.type === 'ADD_ON';
                }),
                discounts: products.filter(function (product) {
                    return product.type === 'GIFT';
                })
            };
        }
    }, {
        key: "setFixedQuoteProducts",
        value: function setFixedQuoteProducts(products) {
            return products.map(function (product) {
                if (product.type === 'PACKAGE') {
                    product.type = 'ADD_ON';
                }
                return product;
            });
        }
    }, {
        key: "setDiscount",
        value: function setDiscount() {
            var products = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

            if (products.length > 0 && products.length !== 1) {
                var discount = this.setEmptyProduct('GIFT');
                var sum = 0;
                products.map(function (product) {
                    sum += Math.abs(product.amount);
                });
                return Object.assign(discount, {
                    amount: -sum,
                    taxType: 'NO_TAX',
                    mandatory: true,
                    name: 'Gift Certificate',
                    description: '<p>Fixed fee discount</p>',
                    price: -sum,
                    summary: {
                        subTotal: -sum,
                        total: -sum
                    }
                });
            } else if (products.length === 1) {
                return products[0];
            }
            return null;
        }
    }, {
        key: "setEmptyProduct",
        value: function setEmptyProduct(type) {
            return {
                id: null,
                chosen: false,
                description: '',
                name: '',
                price: 0,
                quantity: 1,
                discount: 0,
                total: 0,
                discountValue: 0,
                summary: {
                    total: 0
                },
                order: 1,
                taxType: 'INCLUDED',
                taxValue: 0,
                recommended: false,
                mandatory: type === 'GIFT',
                type: type
            };
        }
    }, {
        key: "setDiscountTypes",
        value: function setDiscountTypes() {
            return ['Fixed', 'Percent of order'];
        }
    }, {
        key: "getDefaultDiscount",
        value: function getDefaultDiscount(discountAmount) {
            var discount = this.setEmptyProduct('GIFT');
            return Object.assign(discount, {
                amount: discountAmount,
                taxType: 'NO_TAX',
                mandatory: true,
                name: 'Gift Certificate',
                description: '<p>Fixed fee discount</p>',
                price: discountAmount,
                summary: {
                    subTotal: discountAmount,
                    total: discountAmount
                }
            });
        }
    }, {
        key: "sortProducts",
        value: function sortProducts(products) {
            return products.sort(function (a, b) {
                return a.order - b.order;
            });
        }
    }]);

    return QuoteUpdateService;
}();
QuoteUpdateService = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [time_service_1.TimeServiceProvider])], QuoteUpdateService);
exports.QuoteUpdateService = QuoteUpdateService;

/***/ }),

/***/ "./shared/services/quote/quotes-data-service/quotes.data.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = __webpack_require__("./node_modules/@angular/common/esm5/http.js");
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var BehaviorSubject_1 = __webpack_require__("./node_modules/rxjs/BehaviorSubject.js");
var QuotesDataProvider = function () {
    function QuotesDataProvider(http) {
        _classCallCheck(this, QuotesDataProvider);

        this.http = http;
        this.quoteUpdate = new BehaviorSubject_1.BehaviorSubject(false);
    }

    _createClass(QuotesDataProvider, [{
        key: "emitQuoteUpdateEvent",
        value: function emitQuoteUpdateEvent(value) {
            return this.quoteUpdate.next(value);
        }
    }, {
        key: "sendQuoteEmail",
        value: function sendQuoteEmail(data) {
            var formData = new FormData();
            var sendMessageData = data.sendMessageData,
                storedFiles = data.storedFiles,
                uploadedFiles = data.uploadedFiles;

            for (var key in sendMessageData) {
                if (key !== 'attachmentsData') {
                    formData.append(key, sendMessageData[key]);
                }
            }
            for (var _key in storedFiles) {
                formData.append("storedAttachments[" + _key + "]", storedFiles[_key].id);
            }
            for (var _key2 in uploadedFiles) {
                formData.append("attachments[" + _key2 + "]", uploadedFiles[_key2]);
            }
            return this.sendQuoteEmailRequest(formData);
        }
    }, {
        key: "getNewQuote",
        value: function getNewQuote(quoteId) {
            var url = "/api/user/v1/quote/" + quoteId;
            return this.http.get(url);
        }
    }, {
        key: "getQuote",
        value: function getQuote(jobId, quoteId) {
            var url = "/api/user/v1/job/" + jobId + "/quote/" + quoteId;
            return this.http.get(url);
        }
    }, {
        key: "getQuoteWeb",
        value: function getQuoteWeb(jobId, quoteId) {
            var url = "/api/user/v1/job/" + jobId + "/quote/" + quoteId;
            return this.http.get(url);
        }
    }, {
        key: "getQuoteToEdit",
        value: function getQuoteToEdit(jobId, isJob, quoteId) {
            var url = isJob ? "/protected/rest/quote/sources?jobId=" + jobId : "/protected/rest/quote/sources?leadId=" + jobId;
            if (quoteId) {
                url += "&quoteId=" + quoteId;
            }
            return this.http.get(url);
        }
    }, {
        key: "deleteQuote",
        value: function deleteQuote(jobId, quoteId) {
            var url = "/protected/rest/jobs/" + jobId + "/quote/delete/" + quoteId;
            return this.http.post(url, {});
        }
    }, {
        key: "saveQuote",
        value: function saveQuote(jobId, data) {
            var url = "/protected/rest/job/" + jobId + "/quote/save";
            return this.http.post(url, data);
        }
    }, {
        key: "getQuoteToEditV1",
        value: function getQuoteToEditV1(jobId, quoteId) {
            var url = "/api/user/v1/job/" + jobId + "/quote/" + quoteId;
            return this.http.get(url);
        }
    }, {
        key: "getJobId",
        value: function getJobId(leadId) {
            var url = "/api/user/v1/lead/" + leadId + "/jobId";
            return this.http.get(url);
        }
    }, {
        key: "saveQuoteV1",
        value: function saveQuoteV1(jobId, quoteId, data) {
            var url = "/api/user/v1/job/" + jobId + "/quote/" + quoteId;
            return this.http.put(url, data);
        }
    }, {
        key: "saveFixedQuoteV1",
        value: function saveFixedQuoteV1(jobId, quoteId, data) {
            var url = "/api/user/v1/job/" + jobId + "/quote/fixed/" + quoteId;
            return this.http.put(url, data);
        }
    }, {
        key: "createQuoteV1",
        value: function createQuoteV1(jobId, data) {
            var url = "/api/user/v1/job/" + jobId + "/quote";
            return this.http.post(url, data);
        }
    }, {
        key: "createFixedQuoteV1",
        value: function createFixedQuoteV1(jobId, data) {
            var url = "/api/user/v1/job/" + jobId + "/quote/fixed";
            return this.http.post(url, data);
        }
    }, {
        key: "calculateProductsSummary",
        value: function calculateProductsSummary(products, tax, currencySymbol) {
            var url = '/api/public/v1/ui/helper/calculate/summary';
            return this.http.post(url, { products: products, tax: tax, currencySymbol: currencySymbol });
        }
    }, {
        key: "getQuoteIdAndDate",
        value: function getQuoteIdAndDate(id) {
            var url = "/api/user/v1/job/" + id + "/quote/template";
            return this.http.get(url);
        }
    }, {
        key: "generateInvoiceFromQuote",
        value: function generateInvoiceFromQuote(jobId, quoteId) {
            var url = "/api/user/v1/job/" + jobId + "/quote/" + quoteId + "/generate-invoice";
            return this.http.put(url, null);
        }
    }, {
        key: "markQuoteAsAccepted",
        value: function markQuoteAsAccepted(jobId, quoteId) {
            var url = "/api/user/v1/job/" + jobId + "/quote/" + quoteId + "/mark-accepted";
            return this.http.put(url, null);
        }
    }, {
        key: "updateQuoteActions",
        value: function updateQuoteActions(jobId, quoteId) {
            var url = "/api/user/v1/job/" + jobId + "/quote/" + quoteId + "/actions";
            return this.http.get(url);
        }
    }, {
        key: "sendQuoteEmailRequest",
        value: function sendQuoteEmailRequest(formData) {
            var url = '/protected/rest/jobs/quote/send/';
            return this.http.post(url, formData);
        }
    }, {
        key: "shouldQuoteBeUpdatedObservable",
        get: function get() {
            return this.quoteUpdate.asObservable();
        }
    }]);

    return QuotesDataProvider;
}();
QuotesDataProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [http_1.HttpClient])], QuotesDataProvider);
exports.QuotesDataProvider = QuotesDataProvider;

/***/ }),

/***/ "./shared/services/settings/company-settings.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var http_1 = __webpack_require__("./node_modules/@angular/common/esm5/http.js");
var CompanySettingsServiceProvider = function () {
    function CompanySettingsServiceProvider(http) {
        _classCallCheck(this, CompanySettingsServiceProvider);

        this.http = http;
    }

    _createClass(CompanySettingsServiceProvider, [{
        key: "deleteUser",
        value: function deleteUser(userId) {
            var url = "/api/user/v1/company/user/" + userId + "/delete";
            return this.http.post(url, {});
        }
    }, {
        key: "editCompany",
        value: function editCompany(dataToSend) {
            var url = '/api/user/company/settings';
            var headers = new http_1.HttpHeaders({
                'Cache-Control': 'no-cache, no-store, must-revalidate',
                Expires: '0',
                Pragma: 'no-cache'
            });
            return this.http.post(url, dataToSend, { headers: headers });
        }
    }]);

    return CompanySettingsServiceProvider;
}();
CompanySettingsServiceProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [http_1.HttpClient])], CompanySettingsServiceProvider);
exports.CompanySettingsServiceProvider = CompanySettingsServiceProvider;

/***/ }),

/***/ "./shared/services/settings/customize.labels.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var settings_1 = __webpack_require__("./shared/services/settings/settings.ts");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var CustomizeLabelsService = function CustomizeLabelsService(settingsService, messageService) {
    var _this = this;

    _classCallCheck(this, CustomizeLabelsService);

    this.settingsService = settingsService;
    this.messageService = messageService;
    this.settingsService.customizeLabelsObservable.subscribe(function (data) {
        _this.customizeLabels = data;
    }, function (error) {
        return _this.messageService.showDefaultErrorMessage(error);
    });
};
CustomizeLabelsService = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [settings_1.SettingsProvider, message_service_1.MessageService])], CustomizeLabelsService);
exports.CustomizeLabelsService = CustomizeLabelsService;

/***/ }),

/***/ "./shared/services/settings/email-settings.data.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var http_1 = __webpack_require__("./node_modules/@angular/common/esm5/http.js");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var BehaviorSubject_1 = __webpack_require__("./node_modules/rxjs/BehaviorSubject.js");
var EmailSettingsDataService = function () {
    function EmailSettingsDataService(http) {
        _classCallCheck(this, EmailSettingsDataService);

        this.http = http;
        this.GMAIL_URL = '/protected/rest/settings/gmail';
        this.SMTP_URL = '/protected/rest/settings/email/smtp';
        this.GMAIL_REPLY_URL = '/api/user/v1/integration/email/gmail';
        this.SMTP_REPLY_URL = '/api/user/v1/integration/email/smtp';
        this.onLoadImageSuccess$ = new BehaviorSubject_1.BehaviorSubject(false);
    }

    _createClass(EmailSettingsDataService, [{
        key: "setOnLoadImageSuccess",
        value: function setOnLoadImageSuccess(value) {
            this.onLoadImageSuccess$.next(value);
        }
    }, {
        key: "getGmailReplyData",
        value: function getGmailReplyData() {
            var url = this.GMAIL_REPLY_URL;
            return this.http.get(url);
        }
    }, {
        key: "saveGmailReplySettingData",
        value: function saveGmailReplySettingData(accountCredentialId, receiveReplies, senderName, senderEmail) {
            var url = this.GMAIL_REPLY_URL;
            return this.http.put(url, {
                accountCredentialId: accountCredentialId,
                receiveReplies: receiveReplies,
                senderName: senderName,
                senderEmail: senderEmail
            });
        }
    }, {
        key: "getSmtpData",
        value: function getSmtpData() {
            return this.http.get(this.SMTP_REPLY_URL).pipe(operators_1.map(function (data) {
                return data.data;
            }));
        }
    }, {
        key: "activatePromoSubscription",
        value: function activatePromoSubscription(isAccepted) {
            var url = "/api/user/settings/promosubscription/" + isAccepted;
            return this.http.put(url, {});
        }
    }, {
        key: "activateEmailNotification",
        value: function activateEmailNotification(isAccepted) {
            var url = "/protected/rest/company/notification/save/" + isAccepted;
            return this.http.post(url, {});
        }
    }, {
        key: "getEmailSettings",
        value: function getEmailSettings() {
            var url = '/protected/rest/settings/company/get/emailsettings';
            var headers = new http_1.HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
            return this.http.get(url, { headers: headers });
        }
    }, {
        key: "saveEmailSignature",
        value: function saveEmailSignature(signature) {
            var url = '/protected/rest/settings/email/signature';
            return this.http.post(url, { signature: signature });
        }
    }, {
        key: "saveSnServerSettings",
        value: function saveSnServerSettings(settings) {
            var url = '/protected/rest/settings/email/default';
            return this.http.post(url, settings);
        }
    }, {
        key: "connectGmailServer",
        value: function connectGmailServer() {
            return this.http.get(this.GMAIL_URL);
        }
    }, {
        key: "saveGmailConnection",
        value: function saveGmailConnection(code) {
            var accountCredentialId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            var receiveReplies = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
            var senderName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
            var senderEmail = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

            return this.http.post(this.GMAIL_REPLY_URL, {
                code: code,
                accountCredentialId: accountCredentialId,
                receiveReplies: receiveReplies,
                senderName: senderName,
                senderEmail: senderEmail
            });
        }
    }, {
        key: "disconnectGmailServer",
        value: function disconnectGmailServer() {
            return this.http.delete(this.GMAIL_REPLY_URL);
        }
    }, {
        key: "saveSMTPServerSettings",
        value: function saveSMTPServerSettings(settings) {
            return this.http.post(this.SMTP_URL, settings);
        }
    }, {
        key: "disconnectSMTPServer",
        value: function disconnectSMTPServer() {
            return this.http.delete(this.SMTP_URL);
        }
    }, {
        key: "saveEmailTemplate",
        value: function saveEmailTemplate(emailTemplate) {
            var url = '/protected/rest/settings/email_template/create';
            return this.http.post(url, emailTemplate);
        }
    }, {
        key: "updateEmailTemplate",
        value: function updateEmailTemplate(emailTemplate) {
            var url = '/protected/rest/email_template/validate';
            return this.http.post(url, emailTemplate);
        }
    }, {
        key: "confirmEditEmailTemplate",
        value: function confirmEditEmailTemplate(emailTemplate) {
            var url = '/protected/rest/settings/email_template/update';
            return this.http.post(url, emailTemplate);
        }
    }, {
        key: "deleteEmailTemplate",
        value: function deleteEmailTemplate(emailTemplate) {
            var url = '/protected/rest/settings/email_template/delete';
            return this.http.post(url, emailTemplate);
        }
    }, {
        key: "getEmailTemplatesOnPage",
        value: function getEmailTemplatesOnPage(data) {
            var perPage = data.perPage,
                page = data.page,
                _data$pageOrder = data.pageOrder,
                predicate = _data$pageOrder.predicate,
                reverse = _data$pageOrder.reverse;

            var params = new http_1.HttpParams();
            params = params.append('perPage', perPage);
            params = params.append('page', page);
            params = params.append('predicate', predicate);
            params = params.append('reverse', reverse);
            var url = '/protected/rest/settings/email_template/get_all';
            return this.http.get(url, { params: params });
        }
    }, {
        key: "saveReplySNEmaiDomain",
        value: function saveReplySNEmaiDomain(link, username) {
            return this.http.post(link, { username: username }).pipe(operators_1.map(function (data) {
                return data.data;
            }));
        }
    }, {
        key: "saveImage",
        value: function saveImage(dataToSave) {
            var url = '/protected/rest/signature/image/save';
            return this.http.post(url, dataToSave);
        }
    }, {
        key: "getOnLoadImageSuccess",
        get: function get() {
            return this.onLoadImageSuccess$.asObservable();
        }
    }]);

    return EmailSettingsDataService;
}();
EmailSettingsDataService = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [http_1.HttpClient])], EmailSettingsDataService);
exports.EmailSettingsDataService = EmailSettingsDataService;

/***/ }),

/***/ "./shared/services/settings/email-settings.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var validation_service_1 = __webpack_require__("./shared/services/helpers/validation.service.ts");
var EmailSettingsService = function () {
    function EmailSettingsService(messageService, validationService) {
        _classCallCheck(this, EmailSettingsService);

        this.messageService = messageService;
        this.validationService = validationService;
    }

    _createClass(EmailSettingsService, [{
        key: "validateDomain",
        value: function validateDomain(domain) {
            if (domain.length <= 4) {
                this.messageService.showToaster('e_6', 'emailSettings');
                return false;
            }
            if (domain.indexOf(' ') > 0) {
                this.messageService.showToaster('e_7', 'emailSettings');
                return false;
            }
            if (domain.length >= 65) {
                this.messageService.showToaster('e_9', 'emailSettings');
                return false;
            }
            var regex = /[@#а-яА-Я№!$%^&*()+|~=`{}\[\]:";'<>?,\/]/;
            var result = domain.match(regex);
            if (result !== null) {
                this.messageService.showToaster('e_8', 'emailSettings');
                return false;
            }
            return true;
        }
    }, {
        key: "isSMTPSettingsValid",
        value: function isSMTPSettingsValid(data) {
            var from = data.from,
                serverUsername = data.serverUsername,
                password = data.password,
                host = data.host,
                port = data.port;

            if (this.validationService.isStringEmptySMTP(from)) {
                this.messageService.showToaster('e_3', 'emailSettings', 'name');
                return false;
            }
            if (this.validationService.isStringEmptySMTP(serverUsername)) {
                this.messageService.showToaster('e_3', 'emailSettings', 'username');
                return false;
            }
            if (this.validationService.isStringEmptySMTP(password)) {
                this.messageService.showToaster('e_3', 'emailSettings', 'password');
                return false;
            }
            if (this.validationService.isStringEmptySMTP(host)) {
                this.messageService.showToaster('e_3', 'emailSettings', 'SMTP server details');
                return false;
            }
            if (this.validationService.isStringEmptySMTP(port)) {
                this.messageService.showToaster('e_3', 'emailSettings', 'SMTP port number');
                return false;
            }
            return true;
        }
    }]);

    return EmailSettingsService;
}();
EmailSettingsService = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [message_service_1.MessageService, validation_service_1.ValidationProvider])], EmailSettingsService);
exports.EmailSettingsService = EmailSettingsService;

/***/ }),

/***/ "./shared/services/settings/product-packages.data.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var http_1 = __webpack_require__("./node_modules/@angular/common/esm5/http.js");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var ProductPackagesDataServiceProvider = function () {
    function ProductPackagesDataServiceProvider(http, messageService) {
        _classCallCheck(this, ProductPackagesDataServiceProvider);

        this.http = http;
        this.messageService = messageService;
        this.updateProductPackageSubject = new Subject_1.Subject();
    }
    // 	TODO QT - need refactor


    _createClass(ProductPackagesDataServiceProvider, [{
        key: "getDefaultIntroductionText",
        value: function getDefaultIntroductionText() {
            var _this = this;

            var url = '/api/user/v1/quote/template';
            return this.http.get(url).catch(function (error) {
                _this.messageService.showDefaultErrorMessage(error);
                return error;
            });
        }
    }, {
        key: "updateDefaultIntroductionText",
        value: function updateDefaultIntroductionText(id, textToUpdate) {
            var _this2 = this;

            var url = "/api/user/v1/quote/template/" + id;
            return this.http.post(url, textToUpdate).catch(function (error) {
                _this2.messageService.showDefaultErrorMessage(error);
                return error;
            });
        }
    }, {
        key: "getPackagesOrProducts",
        value: function getPackagesOrProducts(pageRequest) {
            var _this3 = this;

            var url = '/api/user/v1/product/template/list';
            return this.http.post(url, pageRequest).catch(function (error) {
                _this3.messageService.showDefaultErrorMessage(error);
                return error;
            });
        }
    }, {
        key: "deletePackagesOrProducts",
        value: function deletePackagesOrProducts(id) {
            var url = "/api/user/v1/product/template/" + id;
            return this.http.delete(url);
        }
    }, {
        key: "createPackagesOrProducts",
        value: function createPackagesOrProducts(productOrPackage) {
            var url = '/api/user/v1/product/template';
            return this.http.post(url, productOrPackage);
        }
    }, {
        key: "updatePackagesOrProducts",
        value: function updatePackagesOrProducts(id, productOrPackage) {
            var url = "/api/user/v1/product/template/" + id + (productOrPackage.updateLinked ? '?updateLinkedProducts=true' : '');
            return this.http.post(url, productOrPackage);
        }
    }, {
        key: "getProductOrPackageTemplate",
        value: function getProductOrPackageTemplate(id) {
            var _this4 = this;

            var url = "/api/user/v1/product/template/" + id;
            return this.http.get(url).catch(function (error) {
                _this4.messageService.showDefaultErrorMessage(error);
                return error;
            });
        }
    }, {
        key: "convertProductPackage",
        value: function convertProductPackage(body) {
            var _this5 = this;

            var url = '/api/user/v1/product/template';
            return this.http.put(url, body).catch(function (error) {
                _this5.messageService.showDefaultErrorMessage(error);
                return error;
            });
        }
    }]);

    return ProductPackagesDataServiceProvider;
}();
ProductPackagesDataServiceProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [http_1.HttpClient, message_service_1.MessageService])], ProductPackagesDataServiceProvider);
exports.ProductPackagesDataServiceProvider = ProductPackagesDataServiceProvider;

/***/ }),

/***/ "./shared/services/settings/settings-overview/settings-overview-item-list.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanySettingsList = [{
    name: 'CURRENCY_AND_TAXES',
    title: 'Currency & Taxes',
    icon: 'fi-currency-texes',
    url: '/settings/currency_and_taxes',
    description: 'Currency, tax name and rate.',
    companySettingsType: 'FUNDAMENTALS'
}, {
    name: 'CALENDAR',
    title: 'Date, Time & Calendar',
    icon: 'fi-calendar-settings',
    url: '/settings/google_cal',
    description: 'Google Calendar integration, data and time format.',
    dataSection: 'calendarSettings',
    companySettingsType: 'FUNDAMENTALS'
}, {
    name: 'EMAIL_SETTINGS',
    title: 'Email Settings',
    icon: 'fi-email-settings',
    url: '/settings/email_settings',
    description: 'Set up your email server.',
    companySettingsType: 'FUNDAMENTALS'
}, {
    name: 'INVOICE_PAYMENT_SETTINGS',
    title: 'Invoice & Payment Settings',
    icon: 'fi-payment-schedule',
    url: '/settings/payment_schedules',
    description: 'Payment schedules, reminders, receipts and ID format.',
    companySettingsType: 'FUNDAMENTALS'
}, {
    name: 'PAYMENT_METHODS',
    title: 'Payment Methods',
    icon: 'fi-payment-methods',
    url: '/settings/payment_methods',
    description: 'Set up how your invoices are paid.',
    companySettingsType: 'FUNDAMENTALS'
}, {
    name: 'CONTACT_FORM',
    title: 'Contact Form',
    icon: 'fi-form',
    url: '/settings/contact_form',
    description: 'Create and embed contact forms.',
    companySettingsType: 'ADVANCED'
}, {
    name: 'LEAD_SOURCES',
    title: 'Lead Sources',
    icon: 'fi-connection fi-connection-settings',
    url: '/settings/lead_sources',
    description: 'Track where your leads come from.',
    companySettingsType: 'ADVANCED'
}, {
    name: 'JOB_TYPES',
    title: 'Job Types',
    icon: 'fi-types',
    url: '/settings/job_types',
    description: 'Set up job types and link them to workflows.',
    companySettingsType: 'ADVANCED'
}, {
    name: 'LABELS',
    title: 'Labels',
    icon: 'fi-tag',
    url: '/settings/labels',
    description: 'Rename "Shoot" and "Business Number"',
    companySettingsType: 'ADVANCED'
}, {
    name: 'INTEGRATIONS',
    title: 'Integrations',
    icon: 'fi-integrate',
    url: '/settings/integrations',
    description: 'Connect with Xero, QuickBooks and more.',
    companySettingsType: 'ADVANCED'
}, {
    name: 'EMAIL_TEMPLATES',
    title: 'Email Templates',
    icon: 'fi-paper-plane',
    url: '/settings/email_templates',
    description: 'Customise your email templates.',
    companySettingsType: 'TEMPLATES'
}, {
    name: 'PRODUCTS_AND_PACKAGES',
    title: 'Products & Packages',
    icon: 'fi-products',
    url: '/settings/products_packages',
    description: 'Create product adn packages that you sell.',
    dataSection: 'productsAndPackages',
    companySettingsType: 'TEMPLATES'
}, {
    name: 'QUOTE_INVOICE_TEMPLATES',
    title: 'Quote & Invoice Templates',
    icon: 'fi-quote-invoice-template',
    url: '/settings/quote_invoice_templates',
    description: 'Customize your quote and invoice templates.',
    companySettingsType: 'TEMPLATES'
}, {
    name: 'CONTRACT_TEMPLATES',
    title: 'Contract Templates',
    icon: 'fi-contract-templates',
    url: '/settings/contracts',
    description: 'Customise your contract templates.',
    companySettingsType: 'TEMPLATES'
}, {
    name: 'QUESTIONNAIRE_TEMPLATES',
    title: 'Questionnaire Templates',
    icon: 'fi-questionnaire-templates',
    url: '/settings/questionnaires',
    description: 'Customise your questionnaire Templates.',
    companySettingsType: 'TEMPLATES'
}, {
    name: 'WORKFLOWS',
    title: 'Workflows',
    icon: 'fi-workflows',
    url: '/settings/workflows',
    description: 'Create Workflows and automation.',
    companySettingsType: 'TEMPLATES'
}];
exports.GlobalSettingsList = [{
    name: 'ACCOUNT_AND_SUBSCRIPTION',
    title: 'Account & Subscription',
    icon: 'fi-account',
    url: '/settings/profile',
    description: 'Login, password and subscription and billing.'
}, {
    name: 'COMPANIES',
    title: 'Companies',
    icon: 'fi-company',
    url: '/settings/companies',
    description: 'Add more companies, edit details, and GDPR'
}, {
    name: 'USERS',
    title: 'Users',
    icon: 'fi-users',
    url: '/settings/users',
    description: 'Add more users to your account'
}, {
    name: 'REFER_A_FRIEND',
    title: 'Refer a Friend',
    icon: 'fi-refer',
    url: '/settings/refer',
    description: 'Referrals and code.'
}];

/***/ }),

/***/ "./shared/services/settings/settings-overview/settings-overview.data.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var http_1 = __webpack_require__("./node_modules/@angular/common/esm5/http.js");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var Observable_1 = __webpack_require__("./node_modules/rxjs/Observable.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var BehaviorSubject_1 = __webpack_require__("./node_modules/rxjs/BehaviorSubject.js");
var settings_overview_item_list_1 = __webpack_require__("./shared/services/settings/settings-overview/settings-overview-item-list.ts");
var SettingsOverviewDataProvider = function () {
    function SettingsOverviewDataProvider(http, messageService) {
        _classCallCheck(this, SettingsOverviewDataProvider);

        this.http = http;
        this.messageService = messageService;
        this.settingsOverviewSubject = new BehaviorSubject_1.BehaviorSubject({
            companySettings: null,
            globalSettings: null,
            actions: {}
        });
    }

    _createClass(SettingsOverviewDataProvider, [{
        key: "getSettingsOverviewItems",
        value: function getSettingsOverviewItems() {
            var _this = this;

            var url = '/api/user/v1/brand/settings';
            return this.http.get(url).catch(function (error) {
                _this.messageService.showToaster('e_0', 'general', error.error);
                return Observable_1.Observable.throw(error);
            }).pipe(operators_1.map(function (res) {
                return res.data;
            }), operators_1.map(function (data) {
                var companySettings = JSON.parse(JSON.stringify(data.brandSettings[0].settings));
                var globalSettings = JSON.parse(JSON.stringify(data.brandSettings[1].settings));
                _this.settingsOverviewSubject.next({
                    companySettings: _this.createSettingsList(settings_overview_item_list_1.CompanySettingsList, companySettings),
                    globalSettings: _this.createSettingsList(settings_overview_item_list_1.GlobalSettingsList, globalSettings),
                    brandName: data.brandSettings[0].brand,
                    actions: data.brandSettings[0].actions,
                    currentCompanyId: data.brandSettings[0].companyId,
                    logoUrl: data.brandSettings[0].logoUrl
                });
                return data;
            }));
        }
    }, {
        key: "createSettingsList",
        value: function createSettingsList(settingsList, settingsListFromRequest) {
            var brandSettingsItems = [];
            settingsList.forEach(function (actionItem) {
                Object.keys(settingsListFromRequest).forEach(function (item) {
                    if (item === actionItem.name) {
                        var settingsItem = JSON.parse(JSON.stringify(actionItem));
                        settingsItem.actionName = settingsListFromRequest[item].actionName;
                        settingsItem.companySettingsType = settingsListFromRequest[item].companySettingsType;
                        settingsItem.actionDescription = settingsListFromRequest[item].actionDescription;
                        brandSettingsItems.push(settingsItem);
                    }
                });
            });
            return brandSettingsItems;
        }
    }, {
        key: "settingsOverview",
        value: function settingsOverview() {
            return this.settingsOverviewSubject.asObservable();
        }
    }]);

    return SettingsOverviewDataProvider;
}();
SettingsOverviewDataProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [http_1.HttpClient, message_service_1.MessageService])], SettingsOverviewDataProvider);
exports.SettingsOverviewDataProvider = SettingsOverviewDataProvider;

/***/ }),

/***/ "./shared/services/settings/settings.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = __webpack_require__("./node_modules/@angular/common/esm5/http.js");
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var Observable_1 = __webpack_require__("./node_modules/rxjs/Observable.js");
var BehaviorSubject_1 = __webpack_require__("./node_modules/rxjs/BehaviorSubject.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var SettingsProvider = function () {
    function SettingsProvider(http, messageService) {
        _classCallCheck(this, SettingsProvider);

        this.http = http;
        this.messageService = messageService;
        this.timeFormatSettingsBS = new BehaviorSubject_1.BehaviorSubject({
            weekStartsOn: null,
            dateFormat: null,
            timeFormat: null,
            fundyIntegration: null,
            proSelectIntegration: null
        });
        this.panelsPosition = new BehaviorSubject_1.BehaviorSubject({
            panelsPosition: null
        });
        this.customizeLabels = new BehaviorSubject_1.BehaviorSubject({
            mainShootLabel: null,
            extraShootLabel: null,
            shootsLabel: null,
            businessNumberLabel: null
        });
    }

    _createClass(SettingsProvider, [{
        key: "getTimezoneList",
        value: function getTimezoneList() {
            var url = '/public/rest/timezones';
            return this.http.get(url);
        }
    }, {
        key: "getCurrencyList",
        value: function getCurrencyList() {
            var url = '/public/rest/currencies';
            return this.http.get(url);
        }
    }, {
        key: "getCurrencyAndTaxes",
        value: function getCurrencyAndTaxes() {
            var url = '/protected/rest/currency_and_taxes';
            return this.http.get(url);
        }
    }, {
        key: "setDefaultTimeFormatSettings",
        value: function setDefaultTimeFormatSettings() {
            var defaultTimeFormatSettings = {
                weekStartsOn: 'MONDAY',
                dateFormat: 'DD_MM_YYYY',
                timeFormat: 'T_12'
            };
            this.timeFormatSettingsBS.next(defaultTimeFormatSettings);
        }
    }, {
        key: "getDateTimeSettingsV1",
        value: function getDateTimeSettingsV1() {
            var url = '/api/user/v1/settings/datetime';
            return this.http.get(url);
        }
    }, {
        key: "updateDateTimeSettings",
        value: function updateDateTimeSettings(url, data) {
            this.timeFormatSettingsForSave = Object.assign({}, this.timeFormatSettingsForSave, { weekStartsOn: data.weekStartsOn, dateFormat: data.dateFormat, timeFormat: data.timeFormat });
            return this.http.post(url, data);
        }
    }, {
        key: "getSettingsRequest",
        value: function getSettingsRequest() {
            var _this = this;

            // this.http
            // 	.post('/api/user/settings/bootstrap/update', {
            // 		name: 'company.settings.xerointegration.version',
            // 		value: 'V2'
            // 	})
            // 	.subscribe();
            var url = '/api/user/settings/bootstrap';
            return this.http.get(url).catch(function (error) {
                _this.messageService.showToaster('e_0', 'general', error.error);
                return Observable_1.Observable.throw(error);
            }).map(function (data) {
                var timeFormatSettings = {
                    weekStartsOn: data.data['user.settings.calendar.weekStartsOn'],
                    dateFormat: data.data['user.settings.calendar.dateFormat'],
                    timeFormat: data.data['user.settings.calendar.timeFormat'],
                    fundyIntegration: data.data['company.settings.integration.fundy.state'],
                    fundyAvailable: data.data['company.settings.integration.fundy.available'],
                    picTimeAvailable: data.data['company.settings.integration.pictime.available'],
                    proSelectIntegration: data.data['company.settings.integration.proSelect.state'],
                    proSelectAvailable: data.data['company.settings.integration.proSelect.available'],
                    contactFormVersion: data.data['company.settings.contactform.version'],
                    paymentExportAvailable: data.data['company.settings.payments.export.available'],
                    leadExportAvailable: data.data['company.settings.leads.export.available'],
                    jobExportAvailable: data.data['company.settings.jobs.export.available'],
                    questionnaireTemplatesVersion: data.data['company.settings.questionnairebuilder'],
                    customisedLabels: data.data['company.settings.customizeLabels'],
                    xeroIntegration: data.data['company.settings.xerointegration.version'],
                    leadSourcesAvailable: data.data['company.settings.leadSource.available'],
                    qtTemplatesAvailable: data.data['company.settings.integration.quoteinvoicesample.available']
                };
                _this.setPanelsPosition(data.data['company.settings.dashboard.panels.position']);
                _this.setCustomizeLabels(data.data['company.settings.customizeLabels']);
                _this.timeFormatSettingsBS.next(timeFormatSettings);
                return timeFormatSettings;
            });
        }
    }, {
        key: "setPanelsPosition",
        value: function setPanelsPosition(panelsPosition) {
            this.panelsPosition.next(panelsPosition);
        }
    }, {
        key: "setCustomizeLabels",
        value: function setCustomizeLabels(labels) {
            this.customizeLabels.next(labels);
        }
    }, {
        key: "savePanelsPosition",
        value: function savePanelsPosition(panelsPosition) {
            var settingsToSend = [{
                name: 'company.settings.dashboard.panels.position',
                jsonValue: {
                    panels: panelsPosition
                }
            }];
            this.setPanelsPosition({ panels: panelsPosition });
            var url = '/api/user/settings/bootstrap/batch-update';
            return this.http.post(url, settingsToSend);
        }
    }, {
        key: "saveCustomizedLabels",
        value: function saveCustomizedLabels(data) {
            var settingsToSend = [{
                name: 'company.settings.customizeLabels',
                jsonValue: data
            }];
            var url = '/api/user/settings/bootstrap/batch-update';
            return this.http.post(url, settingsToSend);
        }
    }, {
        key: "dateFormatPattern",
        value: function dateFormatPattern() {
            var dateFormat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'DD_MM_YYYY';
            var weekStartsOn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'MONDAY';

            var format = {
                dateFormat: dateFormat,
                timeFormat: 'T_12',
                weekStartsOn: weekStartsOn
            };
            this.timeFormatSettingsBS.next(format);
        }
    }, {
        key: "updateFundyIntegration",
        value: function updateFundyIntegration(enableFundy) {
            var _this2 = this;

            var state = enableFundy ? 'ENABLED' : 'DISABLED';
            var url = '/api/user/settings/bootstrap/update ';
            var stateIntegrationToSend = {
                name: 'company.settings.integration.fundy.state',
                value: state
            };
            return this.http.post(url, stateIntegrationToSend).catch(function (error) {
                _this2.messageService.showToaster('e_0', 'general', error);
                return Observable_1.Observable.throw(error);
            }).switchMap(function () {
                return _this2.timeFormatSettings;
            }).first().map(function (settings) {
                settings.fundyIntegration = state;
                _this2.timeFormatSettingsBS.next(settings);
                return settings;
            });
        }
    }, {
        key: "updateProSelectIntegration",
        value: function updateProSelectIntegration(enableFundy) {
            var _this3 = this;

            var state = enableFundy ? 'ENABLED' : 'DISABLED';
            var url = '/api/user/settings/bootstrap/update ';
            var stateIntegrationToSend = {
                name: 'company.settings.integration.proSelect.state',
                value: state
            };
            return this.http.post(url, stateIntegrationToSend).catch(function (error) {
                _this3.messageService.showToaster('e_0', 'general', error);
                return Observable_1.Observable.throw(error);
            }).switchMap(function () {
                return _this3.timeFormatSettings;
            }).first().map(function (settings) {
                // @ts-ignore
                settings.proSelectIntegration = state;
                _this3.timeFormatSettingsBS.next(settings);
                return settings;
            });
        }
    }, {
        key: "timeFormatSettings",
        get: function get() {
            return this.timeFormatSettingsBS.asObservable();
        }
    }, {
        key: "customizeLabelsObservable",
        get: function get() {
            return this.customizeLabels.asObservable();
        }
    }, {
        key: "panelsPositionObservable",
        get: function get() {
            return this.panelsPosition.asObservable();
        }
    }]);

    return SettingsProvider;
}();
SettingsProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [http_1.HttpClient, message_service_1.MessageService])], SettingsProvider);
exports.SettingsProvider = SettingsProvider;

/***/ }),

/***/ "./shared/services/subscription/promo-code.data.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = __webpack_require__("./node_modules/@angular/common/esm5/http.js");
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var PromoCodeDataProvider = function () {
    function PromoCodeDataProvider(http) {
        _classCallCheck(this, PromoCodeDataProvider);

        this.http = http;
    }

    _createClass(PromoCodeDataProvider, [{
        key: "getAllPromoCodes",
        value: function getAllPromoCodes(data) {
            var perPage = data.perPage,
                page = data.page,
                _data$pageOrder = data.pageOrder,
                predicate = _data$pageOrder.predicate,
                reverse = _data$pageOrder.reverse,
                search = data.search;

            var url = '/admin/rest/campaign/all';
            var params = new http_1.HttpParams();
            params = params.append('perPage', perPage);
            params = params.append('page', page);
            params = params.append('predicate', predicate);
            params = params.append('reverse', reverse);
            params = params.append('search', search);
            return this.http.get(url, { params: params });
        }
    }, {
        key: "updatePromoCode",
        value: function updatePromoCode(code) {
            var url = '/admin/rest/campaign';
            return this.http.put(url, code);
        }
    }, {
        key: "createPromoCode",
        value: function createPromoCode(code) {
            var url = '/admin/rest/campaign';
            return this.http.post(url, code);
        }
    }]);

    return PromoCodeDataProvider;
}();
PromoCodeDataProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [http_1.HttpClient])], PromoCodeDataProvider);
exports.PromoCodeDataProvider = PromoCodeDataProvider;

/***/ }),

/***/ "./shared/services/subscription/subscription.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var http_1 = __webpack_require__("./node_modules/@angular/common/esm5/http.js");
var rxjs_1 = __webpack_require__("./node_modules/rxjs/Rx.js");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var stringModifier_service_1 = __webpack_require__("./shared/services/helpers/string-modifier-service/stringModifier.service.ts");
var iframe_service_1 = __webpack_require__("./shared/services/helpers/iframe-service/iframe.service.ts");
var auth_tokens_service_1 = __webpack_require__("./web/modern/auth-tokens.service.ts");
var NewSubscriptionServiceDataProvider = function () {
    function NewSubscriptionServiceDataProvider(http, stringModifierService, iframeService, tokenService) {
        _classCallCheck(this, NewSubscriptionServiceDataProvider);

        this.http = http;
        this.stringModifierService = stringModifierService;
        this.iframeService = iframeService;
        this.tokenService = tokenService;
        this.subscriptionData$ = new rxjs_1.BehaviorSubject(null);
        this.choosePlanModalOpenStatus$ = new rxjs_1.BehaviorSubject({
            state: false,
            payload: null
        });
    }
    // Observables


    _createClass(NewSubscriptionServiceDataProvider, [{
        key: "setSubscriptionData",
        value: function setSubscriptionData(data) {
            this.subscriptionData$.next(data);
        }
    }, {
        key: "setChoosePlanOpenModalStatus",
        value: function setChoosePlanOpenModalStatus(state) {
            this.choosePlanModalOpenStatus$.next(state);
        }
        // API

    }, {
        key: "getSubscriptions",
        value: function getSubscriptions(customUrl, selectedCurrency) {
            var url = customUrl || '/api/basic/v1/subscription/plans';
            if (selectedCurrency) {
                url += "?productsCurrency=" + selectedCurrency;
            }
            if (customUrl) {
                var token = this.tokenService.getAuthToken();
                var headers = new http_1.HttpHeaders({
                    Authorization: "Bearer " + token
                });
                var options = { headers: headers };
                return this.http.get(url, options);
            }
            return this.http.get(url);
        }
    }, {
        key: "getSubscriptionStatus",
        value: function getSubscriptionStatus() {
            var url = '/api/basic/v1/subscription/status';
            return this.http.get(url);
        }
    }, {
        key: "cancelSubscription",
        value: function cancelSubscription() {
            var url = '/api/basic/v1/subscription/cancel';
            var body = {};
            return this.http.post(url, body);
        }
    }, {
        key: "getUnsubscribeTemplateDescription",
        value: function getUnsubscribeTemplateDescription() {
            var url = '/api/basic/v1/subscription/cancel/estimate';
            return this.http.get(url);
        }
    }, {
        key: "sendFeedback",
        value: function sendFeedback(feedback) {
            var url = '/protected/rest/unsubscribe/send';
            var headers = new http_1.HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
            var body = this.stringModifierService.urlEncodDataTransform({ feedback: feedback });
            return this.http.post(url, body, { headers: headers });
        }
        // LOGIC

    }, {
        key: "fetchSubscriptionStatus",
        value: function fetchSubscriptionStatus() {
            return this.getSubscriptionStatus().pipe(operators_1.map(function (data) {
                return data.data;
            }));
        }
    }, {
        key: "onSubscriptionExpired",
        value: function onSubscriptionExpired() {
            this.setChoosePlanOpenModalStatus({ state: true, payload: null });
        }
    }, {
        key: "createActionList",
        value: function createActionList(actions) {
            return Object.keys(actions);
        }
    }, {
        key: "performAfterLoginActions",
        value: function performAfterLoginActions(actions) {
            var _this = this;

            var firstAttemptText = '-firstAttempt';
            var existingPhotographerEmail = localStorage.getItem('PhotographerEmail') + firstAttemptText;
            var one = 1;
            var two = 2;
            if (!localStorage.getItem(existingPhotographerEmail)) {
                localStorage.setItem(existingPhotographerEmail, '0');
            }
            var firstLoginAttempt = localStorage.getItem(existingPhotographerEmail);
            var nextLoginAttempt = +firstLoginAttempt + one;
            localStorage.setItem(existingPhotographerEmail, nextLoginAttempt.toString());
            if (actions.CHOOSE_PLAN) {
                var newAttempt = localStorage.getItem(existingPhotographerEmail);
                if (+newAttempt >= two) {
                    this.setChoosePlanOpenModalStatus({ state: true, payload: null });
                    return;
                }
                return;
            }
            this.createActionList(actions).forEach(function (item) {
                var action = actions[item];
                if (action.method === 'FRAME') {
                    _this.iframeService.setUrlIframe(action.url);
                }
            });
        }
    }, {
        key: "updateStatus",
        value: function updateStatus() {
            var _this2 = this;

            return this.fetchSubscriptionStatus().pipe(operators_1.map(function (data) {
                return _this2.successGetStatusForUpdate(data);
            }));
        }
    }, {
        key: "successGetStatusForUpdate",
        value: function successGetStatusForUpdate(data) {
            this.setSubscriptionData(data);
        }
    }, {
        key: "subscriptionData",
        get: function get() {
            return this.subscriptionData$.asObservable();
        }
    }, {
        key: "choosePlanModalOpenStatus",
        get: function get() {
            return this.choosePlanModalOpenStatus$.asObservable();
        }
    }]);

    return NewSubscriptionServiceDataProvider;
}();
NewSubscriptionServiceDataProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [http_1.HttpClient, stringModifier_service_1.StringModifierServiceProvider, iframe_service_1.IframeService, auth_tokens_service_1.AuthTokensService])], NewSubscriptionServiceDataProvider);
exports.NewSubscriptionServiceDataProvider = NewSubscriptionServiceDataProvider;

/***/ }),

/***/ "./shared/services/system-notifications/system-notifications.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var http_1 = __webpack_require__("./node_modules/@angular/common/esm5/http.js");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var SystemNotificationsServiceDataProvider = function () {
    function SystemNotificationsServiceDataProvider(http) {
        _classCallCheck(this, SystemNotificationsServiceDataProvider);

        this.http = http;
        this.systemNotificationChanged = new core_1.EventEmitter();
    }

    _createClass(SystemNotificationsServiceDataProvider, [{
        key: "getSystemNotification",
        value: function getSystemNotification() {
            var url = '/api/user/v1/system notifications/active';
            return this.http.get(url);
        }
    }, {
        key: "fetchSystemNotificationsData",
        value: function fetchSystemNotificationsData() {
            var _this = this;

            return this.getSystemNotification().pipe(operators_1.map(function (data) {
                _this.systemNotificationChanged.emit(data.data);
                return data.data;
            }));
        }
    }, {
        key: "createActionList",
        value: function createActionList(actions) {
            return Object.keys(actions);
        }
    }, {
        key: "sendSystemNotificationsId",
        value: function sendSystemNotificationsId(id) {
            var url = "/api/user/v1/system notifications/" + id + "}/mark-as-viewed";
            return this.http.get(url);
        }
    }]);

    return SystemNotificationsServiceDataProvider;
}();
SystemNotificationsServiceDataProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [http_1.HttpClient])], SystemNotificationsServiceDataProvider);
exports.SystemNotificationsServiceDataProvider = SystemNotificationsServiceDataProvider;

/***/ }),

/***/ "./shared/services/tasks/appointment.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var Observable_1 = __webpack_require__("./node_modules/rxjs/Observable.js");
var validation_service_1 = __webpack_require__("./shared/services/helpers/validation.service.ts");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var time_service_1 = __webpack_require__("./shared/services/helpers/time-service/time.service.ts");
var clients_data_service_1 = __webpack_require__("./shared/services/client/clients.data.service.ts");
var time_converter_1 = __webpack_require__("./shared/services/helpers/time-converter.ts");
var client_service_1 = __webpack_require__("./shared/services/client/client.service.ts");
var AppointmentServiceProvider = function () {
    function AppointmentServiceProvider(validationService, messageService, timeService, timeConverter, clientsDataService, clientService) {
        _classCallCheck(this, AppointmentServiceProvider);

        this.validationService = validationService;
        this.messageService = messageService;
        this.timeService = timeService;
        this.timeConverter = timeConverter;
        this.clientsDataService = clientsDataService;
        this.clientService = clientService;
        this.appointmentType = 'APPOINTMENT';
    }

    _createClass(AppointmentServiceProvider, [{
        key: "getClientId",
        value: function getClientId(job, clientId) {
            if (job.primaryContact) {
                return job.primaryContact.id;
            }
            return clientId;
        }
    }, {
        key: "isItemChosen",
        value: function isItemChosen(item) {
            var itemChosen = item && item.id;
            return !!itemChosen;
        }
    }, {
        key: "validateAppointment",
        value: function validateAppointment(appointment, isJobView) {
            var dateStart = void 0,
                dateEnd = void 0,
                timeStart = void 0,
                timeEnd = void 0;
            var validAppointment = Object.assign({}, appointment);
            if (this.validationService.isStringEmpty(validAppointment.name)) {
                this.messageService.showToaster('e_3', 'general', 'name');
                return false;
            }
            if (appointment.addToJob && !this.isItemChosen(appointment.jobSearch)) {
                this.messageService.showToaster('e_3', 'appointment');
                return false;
            }
            if (!isJobView && appointment.sendEmails && !appointment.addToJob && !this.isItemChosen(appointment.clientSearch)) {
                this.messageService.showToaster('e_4', 'appointment');
                return false;
            }
            if (!validAppointment.startDate || !validAppointment.endDate) {
                this.messageService.showToaster('e_1', 'appointment');
                return false;
            }
            dateStart = this.timeService.getDateInFormat(validAppointment.startDate, 'date');
            dateEnd = this.timeService.getDateInFormat(validAppointment.endDate, 'date');
            var isCorrectDate = this.timeService.compareDates(dateEnd, dateStart);
            if (isCorrectDate) {
                this.messageService.showToaster('e_2', 'appointment');
                return false;
            }
            if (!validAppointment.allday) {
                var isStartIn24Format = this.timeService.isIn24Format(validAppointment.startTime);
                var isEndIn24Format = this.timeService.isIn24Format(validAppointment.endTime);
                timeStart = isStartIn24Format ? validAppointment.startTime : this.timeConverter.convert12to24(validAppointment.startTime);
                timeEnd = isEndIn24Format ? validAppointment.endTime : this.timeConverter.convert12to24(validAppointment.endTime);
                if (!timeStart || !timeEnd) {
                    this.messageService.showToaster('e_0', 'appointment');
                    return false;
                }
                if (dateStart === dateEnd) {
                    var isCorrectTime = this.timeService.compareTimes(timeStart, timeEnd);
                    if (!isCorrectTime) {
                        this.messageService.showToaster('e_2', 'appointment');
                        return false;
                    }
                }
            }
            validAppointment.startDate = dateStart;
            validAppointment.endDate = dateEnd;
            validAppointment.startTime = timeStart;
            validAppointment.endTime = timeEnd;
            return validAppointment;
        }
    }, {
        key: "prepareAppointmentTask",
        value: function prepareAppointmentTask(appointment) {
            appointment.calendarEvent = {
                id: appointment.calendarEvent ? appointment.calendarEvent.id : null,
                name: appointment.name,
                number: appointment.number,
                startDate: appointment.startDate,
                endDate: appointment.endDate,
                startTime: appointment.startTime,
                endTime: appointment.endTime,
                location: appointment.location,
                clientId: appointment.clientId,
                sendEmails: appointment.sendEmails
            };
            return appointment;
        }
    }, {
        key: "createJobSearchObject",
        value: function createJobSearchObject(appointment) {
            var jobId = appointment.jobId,
                jobName = appointment.jobName;

            return {
                id: jobId,
                name: jobName
            };
        }
    }, {
        key: "prepareAppointmentToShow",
        value: function prepareAppointmentToShow(event) {
            var _this = this;

            var appointment = Object.assign({}, event);
            var clientId = appointment.clientId,
                jobId = appointment.jobId,
                startTime = appointment.startTime,
                sendEmails = appointment.sendEmails;

            appointment.allday = !startTime;
            if (jobId) {
                appointment.jobSearch = this.createJobSearchObject(appointment);
                appointment.addToJob = true;
            }
            if (clientId && sendEmails) {
                return this.clientsDataService.getClient(clientId).mergeMap(function (data) {
                    appointment.clientSearch = _this.clientService.fillClientSearchText(data.contact);
                    return Observable_1.Observable.of(appointment);
                });
            }
            return Observable_1.Observable.of(appointment);
        }
    }, {
        key: "prepareAppointmentToSave",
        value: function prepareAppointmentToSave(appointment, isJobView, location) {
            var dataToSave = this.validateAppointment(appointment, isJobView);
            if (!dataToSave) {
                return false;
            }
            dataToSave.location = location;
            dataToSave.calendarEventType = this.appointmentType;
            var _dataToSave = dataToSave,
                addToJob = _dataToSave.addToJob,
                jobSearch = _dataToSave.jobSearch,
                sendEmails = _dataToSave.sendEmails,
                clientSearch = _dataToSave.clientSearch,
                clientId = _dataToSave.clientId;

            if (sendEmails) {
                // if no job chosen
                if (clientSearch) {
                    dataToSave.clientId = clientSearch.id;
                    delete dataToSave.clientSearch;
                    // get client from job
                } else if (jobSearch) {
                    dataToSave.clientId = this.getClientId(jobSearch, clientId);
                    //  get client when saving from job profile
                } else if (clientId) {
                    dataToSave.clientId = clientId;
                } else {
                    console.error('Can not find client');
                }
            }
            if (addToJob && jobSearch) {
                dataToSave.jobId = jobSearch.id;
            } else {
                delete dataToSave.jobId;
            }
            if (isJobView) {
                dataToSave = this.prepareAppointmentTask(dataToSave);
            }
            delete dataToSave.addToJob;
            delete dataToSave.jobSearch;
            delete dataToSave.jobName;
            return dataToSave;
        }
    }]);

    return AppointmentServiceProvider;
}();
AppointmentServiceProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [validation_service_1.ValidationProvider, message_service_1.MessageService, time_service_1.TimeServiceProvider, time_converter_1.TimeConverterProvider, clients_data_service_1.ClientsDataServiceProvider, client_service_1.ClientServiceProvider])], AppointmentServiceProvider);
exports.AppointmentServiceProvider = AppointmentServiceProvider;

/***/ }),

/***/ "./shared/services/tasks/extra-shoot.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var validation_service_1 = __webpack_require__("./shared/services/helpers/validation.service.ts");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var time_service_1 = __webpack_require__("./shared/services/helpers/time-service/time.service.ts");
var time_converter_1 = __webpack_require__("./shared/services/helpers/time-converter.ts");
var ExtraShootServiceProvider = function () {
    function ExtraShootServiceProvider(validationService, messageService, timeService, timeConverter) {
        _classCallCheck(this, ExtraShootServiceProvider);

        this.validationService = validationService;
        this.messageService = messageService;
        this.timeService = timeService;
        this.timeConverter = timeConverter;
        this.extraShootType = 'EXTRA_SHOOT';
    }

    _createClass(ExtraShootServiceProvider, [{
        key: "isItemChosen",
        value: function isItemChosen(item) {
            var itemChosen = item && item.id;
            return !!itemChosen;
        }
    }, {
        key: "createJobSearchObject",
        value: function createJobSearchObject(appointment) {
            var jobId = appointment.jobId,
                jobName = appointment.jobName;

            return {
                id: jobId,
                name: jobName
            };
        }
    }, {
        key: "prepareExtraShootTask",
        value: function prepareExtraShootTask(extraShoot) {
            extraShoot.calendarEvent = {
                id: extraShoot.calendarEvent ? extraShoot.calendarEvent.id : null,
                name: extraShoot.name,
                number: extraShoot.number,
                startDate: extraShoot.startDate,
                endDate: extraShoot.endDate,
                startTime: extraShoot.startTime,
                endTime: extraShoot.endTime,
                location: extraShoot.location
            };
            return extraShoot;
        }
    }, {
        key: "prepareExtraShootToSave",
        value: function prepareExtraShootToSave(extraShoot, isJobView, location, extraShootLabel) {
            var dataToSave = this.validateExtraShoot(extraShoot, isJobView, extraShootLabel);
            if (!dataToSave) {
                return false;
            }
            dataToSave.location = location;
            dataToSave.calendarEventType = this.extraShootType;
            var jobSearch = extraShoot.jobSearch;

            if (jobSearch) {
                dataToSave.jobId = jobSearch.id;
                delete dataToSave.addToJob;
                delete dataToSave.jobSearch;
            }
            if (isJobView) {
                dataToSave = this.prepareExtraShootTask(dataToSave);
            }
            return dataToSave;
        }
    }, {
        key: "prepareExtraShootToShow",
        value: function prepareExtraShootToShow(event) {
            var extraShoot = Object.assign({}, event);
            var jobId = extraShoot.jobId,
                startTime = extraShoot.startTime;

            extraShoot.allday = !startTime;
            if (jobId) {
                extraShoot.jobSearch = this.createJobSearchObject(extraShoot);
                extraShoot.addToJob = true;
            }
            return extraShoot;
        }
    }, {
        key: "validateExtraShoot",
        value: function validateExtraShoot(extraShoot, isJobView, extraShootLabel) {
            var dateStart = void 0,
                dateEnd = void 0,
                timeStart = void 0,
                timeEnd = void 0;
            var validExtraShoot = Object.assign({}, extraShoot);
            if (this.validationService.isStringEmpty(validExtraShoot.name)) {
                this.messageService.showToaster('e_3', 'general', 'name');
                return false;
            }
            if (!isJobView && !this.isItemChosen(validExtraShoot.jobSearch)) {
                this.messageService.showToaster('e_0', 'extrashoot', extraShootLabel);
                return false;
            }
            if (!validExtraShoot.startDate || !validExtraShoot.endDate) {
                this.messageService.showToaster('e_1', 'appointment');
                return false;
            }
            dateStart = this.timeService.getDateInFormat(validExtraShoot.startDate, 'date');
            dateEnd = this.timeService.getDateInFormat(validExtraShoot.endDate, 'date');
            var isCorrectDate = this.timeService.compareDates(dateEnd, dateStart);
            if (isCorrectDate) {
                this.messageService.showToaster('e_2', 'appointment');
                return false;
            }
            if (!validExtraShoot.allday) {
                var isStartIn24Format = this.timeService.isIn24Format(validExtraShoot.startTime);
                var isEndIn24Format = this.timeService.isIn24Format(validExtraShoot.endTime);
                timeStart = isStartIn24Format ? validExtraShoot.startTime : this.timeConverter.convert12to24(validExtraShoot.startTime);
                timeEnd = isEndIn24Format ? validExtraShoot.endTime : this.timeConverter.convert12to24(validExtraShoot.endTime);
                if (!timeStart || !timeEnd) {
                    this.messageService.showToaster('e_0', 'appointment');
                    return false;
                }
                if (dateStart === dateEnd) {
                    var isCorrectTime = this.timeService.compareTimes(timeStart, timeEnd);
                    if (!isCorrectTime) {
                        this.messageService.showToaster('e_2', 'appointment');
                        return false;
                    }
                }
            }
            validExtraShoot.startDate = dateStart;
            validExtraShoot.endDate = dateEnd;
            validExtraShoot.startTime = timeStart;
            validExtraShoot.endTime = timeEnd;
            return validExtraShoot;
        }
    }]);

    return ExtraShootServiceProvider;
}();
ExtraShootServiceProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [validation_service_1.ValidationProvider, message_service_1.MessageService, time_service_1.TimeServiceProvider, time_converter_1.TimeConverterProvider])], ExtraShootServiceProvider);
exports.ExtraShootServiceProvider = ExtraShootServiceProvider;

/***/ }),

/***/ "./shared/services/user/account.data.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var common_1 = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
var http_1 = __webpack_require__("./node_modules/@angular/common/esm5/http.js");
var stringModifier_service_1 = __webpack_require__("./shared/services/helpers/string-modifier-service/stringModifier.service.ts");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var brands_data_service_1 = __webpack_require__("./shared/services/brands/brands.data.service.ts");
var OauthClient;
(function (OauthClient) {
    OauthClient["SN_MOBILE"] = "Basic U05fTU9CSUxFOnNlY3JldA==";
    OauthClient["WEB"] = "Basic U05fV0VCOndlYlBhc3M=";
    OauthClient["WEB_STLG"] = "Basic U05fV0VCX1NUTEc6d2ViUGFzcw==";
})(OauthClient = exports.OauthClient || (exports.OauthClient = {}));
var AccountDataServiceProvider = function () {
    function AccountDataServiceProvider(http, location, stringModifierService, brandsDataService) {
        _classCallCheck(this, AccountDataServiceProvider);

        this.http = http;
        this.location = location;
        this.stringModifierService = stringModifierService;
        this.brandsDataService = brandsDataService;
        this.headers = new http_1.HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
    }

    _createClass(AccountDataServiceProvider, [{
        key: "logout",
        value: function logout() {
            var url = '/oauth/revoke';
            return this.http.post(url, {});
        }
    }, {
        key: "getUser",
        value: function getUser() {
            var url = '/api/basic/v1/profile';
            return this.http.get(url, { headers: this.headers }).pipe(operators_1.map(function (res) {
                return res.data;
            }));
        }
    }, {
        key: "getCompany",
        value: function getCompany() {
            var url = '/protected/rest/company';
            return this.http.get(url);
        }
    }, {
        key: "getAvatar",
        value: function getAvatar() {
            var url = '/api/user/v1/avatar';
            return this.http.get(url);
        }
    }, {
        key: "authenticateMobile",
        value: function authenticateMobile(email, password, companyId) {
            var url = '/oauth/token';
            var headers = new http_1.HttpHeaders().set('Authorization', OauthClient.SN_MOBILE);
            var formData = new FormData();
            formData.append('username', email);
            formData.append('password', password);
            formData.append('grant_type', 'password');
            if (companyId) {
                formData.append('companyId', companyId.toString());
            }
            return this.http.post(url, formData, { headers: headers });
        }
    }, {
        key: "authenticateWeb",
        value: function authenticateWeb(email, password, stayLogin) {
            var url = '/oauth/token';
            var headers = new http_1.HttpHeaders();
            if (stayLogin) {
                headers = headers.append('Authorization', OauthClient.WEB_STLG);
            } else {
                headers = headers.append('Authorization', OauthClient.WEB);
            }
            var formData = new FormData();
            formData.append('username', email);
            formData.append('password', password);
            formData.append('grant_type', 'password');
            localStorage.setItem('PhotographerEmail', email);
            var companyId = this.brandsDataService.getActiveBrandId();
            if (companyId) {
                formData.append('companyId', companyId);
            }
            return this.http.post(url, formData, { headers: headers });
        }
    }, {
        key: "authenticateWithTwoFa",
        value: function authenticateWithTwoFa(data, authorizationKey) {
            var url = '/oauth/token';
            var formData = new FormData();
            var headers = new http_1.HttpHeaders();
            headers = headers.append('Authorization', authorizationKey);
            Object.keys(data).forEach(function (key) {
                formData.append(key, data[key]);
            });
            return this.http.post(url, formData, { headers: headers });
        }
    }, {
        key: "signUp",
        value: function signUp(signUpData) {
            var url = '/public/rest/user/signup';
            return this.http.post(url, signUpData);
        }
    }, {
        key: "forgotPassword",
        value: function forgotPassword(email) {
            var url = '/public/rest/user/forgotpassword';
            var body = this.stringModifierService.urlEncodDataTransform({ email: email });
            return this.http.post(url, body, { headers: this.headers });
        }
    }, {
        key: "confirmSignUp",
        value: function confirmSignUp(url) {
            var restPathUrl = '/public/rest/signup/confirm/';
            var confirmPathPart = 'confirm/';
            var index = url.indexOf(confirmPathPart);
            if (index && index + confirmPathPart.length < url.length) {
                url = url.substring(confirmPathPart.length + index, url.length);
                url = restPathUrl + url;
            } else {
                url = null;
            }
            if (url !== null) {
                return this.http.get(url);
            }
            return null;
        }
    }, {
        key: "getUserSubscription",
        value: function getUserSubscription() {
            var url = '/protected_base/rest/subscription';
            return this.http.get(url, { headers: this.headers });
        }
    }, {
        key: "resendConfirmEmail",
        value: function resendConfirmEmail(email) {
            var url = "/public/rest/signup/resend/confirm/" + email;
            return this.http.post(url, {});
        }
    }, {
        key: "getInvitationCompany",
        value: function getInvitationCompany(token) {
            var url = "/public/rest/user/signup/" + token;
            return this.http.get(url);
        }
    }, {
        key: "getRefreshedAuthTokenWeb",
        value: function getRefreshedAuthTokenWeb(token) {
            var url = '/oauth/token';
            var params = new http_1.HttpParams().set('grant_type', 'refresh_token').set('refresh_token', token);
            var logIn = localStorage.getItem('isStayLogin');
            if (logIn === null) {
                this.location.go('/login');
            } else if (logIn === 'true') {
                var headers = new http_1.HttpHeaders().set('Authorization', OauthClient.WEB_STLG);
                return this.http.post(url, {}, { params: params, headers: headers });
            } else {
                var _headers = new http_1.HttpHeaders().set('Authorization', OauthClient.WEB);
                return this.http.post(url, {}, { params: params, headers: _headers });
            }
        }
    }, {
        key: "getRefreshedAuthToken",
        value: function getRefreshedAuthToken(token) {
            var url = '/oauth/token';
            var params = new http_1.HttpParams().set('grant_type', 'refresh_token').set('refresh_token', token);
            var headers = new http_1.HttpHeaders().set('Authorization', OauthClient.SN_MOBILE);
            return this.http.post(url, {}, { params: params, headers: headers });
        }
    }, {
        key: "acceptTermsOfUse",
        value: function acceptTermsOfUse() {
            var url = '/api/user/termsofuse/accept';
            return this.http.put(url, {});
        }
    }]);

    return AccountDataServiceProvider;
}();
AccountDataServiceProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [http_1.HttpClient, common_1.Location, stringModifier_service_1.StringModifierServiceProvider, brands_data_service_1.BrandsDataServiceProvider])], AccountDataServiceProvider);
exports.AccountDataServiceProvider = AccountDataServiceProvider;

/***/ }),

/***/ "./shared/services/user/two-fa-authentication.data.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var rxjs_1 = __webpack_require__("./node_modules/rxjs/Rx.js");
var http_1 = __webpack_require__("./node_modules/@angular/common/esm5/http.js");
var TwoFaAuthenticationDataService = function () {
    function TwoFaAuthenticationDataService(http) {
        _classCallCheck(this, TwoFaAuthenticationDataService);

        this.http = http;
        this.twoFaModalControl$ = new rxjs_1.BehaviorSubject(null);
    }

    _createClass(TwoFaAuthenticationDataService, [{
        key: "get2FaMetadataForSetup",
        value: function get2FaMetadataForSetup() {
            var url = '/api/user/profile/2fa/setup-metadata';
            return this.http.get(url);
        }
    }, {
        key: "setup2FaAuthentication",
        value: function setup2FaAuthentication(url, method, data) {
            return this.http[method.toLowerCase()](url, data);
        }
    }, {
        key: "getQRUrl",
        value: function getQRUrl(url) {
            return this.http.get(url, { observe: 'response', responseType: 'blob' });
        }
    }, {
        key: "send2FAAction",
        value: function send2FAAction(url, method) {
            return this.http[method.toLowerCase()](url, {});
        }
    }, {
        key: "reset2FaAuthentication",
        value: function reset2FaAuthentication(url, method, data) {
            return this.http[method.toLowerCase()](url, data);
        }
        // Two Factor Authentication modal triggers

    }, {
        key: "setTwoFaModalControlState",
        value: function setTwoFaModalControlState(state) {
            this.twoFaModalControl$.next(state);
        }
    }, {
        key: "twoFaModalControlState",
        get: function get() {
            return this.twoFaModalControl$.asObservable();
        }
    }]);

    return TwoFaAuthenticationDataService;
}();
TwoFaAuthenticationDataService = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [http_1.HttpClient])], TwoFaAuthenticationDataService);
exports.TwoFaAuthenticationDataService = TwoFaAuthenticationDataService;

/***/ }),

/***/ "./shared/services/user/two-fa-authentication.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var TwoFaAuthenticationService = function () {
    function TwoFaAuthenticationService(messageService) {
        _classCallCheck(this, TwoFaAuthenticationService);

        this.messageService = messageService;
    }

    _createClass(TwoFaAuthenticationService, [{
        key: "isTwoFaSetupValid",
        value: function isTwoFaSetupValid(twoFaData, setStepFunc) {
            var sixDigitVerificationCode = twoFaData.sixDigitVerificationCode,
                secretQuestions = twoFaData.secretQuestions;

            if (this.secretQuestionsValid(secretQuestions, setStepFunc) && this.verificationCodeValid(sixDigitVerificationCode)) {
                return true;
            }
            return false;
        }
    }, {
        key: "isTwoFaLoginInfoValid",
        value: function isTwoFaLoginInfoValid(code) {
            return this.verificationCodeValid(code);
        }
    }, {
        key: "isTwoFaResetDataValid",
        value: function isTwoFaResetDataValid(answers) {
            return this.isAnswersValid(answers);
        }
    }, {
        key: "verificationCodeValid",
        value: function verificationCodeValid(code) {
            if (!code || !code.trim()) {
                this.messageService.showToaster('e_6', 'twoFa');
                return false;
            }
            if (!/^\d+$/.test(code)) {
                this.messageService.showToaster('e_7', 'twoFa');
                return false;
            }
            if (code.length < 6) {
                this.messageService.showToaster('e_5', 'twoFa');
                return false;
            }
            return true;
        }
    }, {
        key: "secretQuestionsValid",
        value: function secretQuestionsValid(questions, setStepFunc) {
            var _this = this;

            var callbackChecker = function callbackChecker(question) {
                if (!question.question) {
                    _this.messageService.showToaster('e_3', 'twoFa');
                    return false;
                }
                if (!question.answer || !question.answer.trim()) {
                    _this.messageService.showToaster('e_0', 'twoFa');
                    return false;
                }
                if (question.answer.length <= 1) {
                    _this.messageService.showToaster('e_2', 'twoFa');
                    return false;
                }
                return true;
            };
            if (!questions.every(callbackChecker)) {
                setStepFunc(1);
                return false;
            }
            var questionsMap = new Set();
            questions.forEach(function (question) {
                return questionsMap.add(question.answer);
            });
            if (questionsMap.size !== questions.length) {
                this.messageService.showToaster('e_1', 'twoFa');
                setStepFunc(1);
                return false;
            }
            return true;
        }
    }, {
        key: "isAnswersValid",
        value: function isAnswersValid(answers) {
            var _this2 = this;

            return answers.every(function (answer) {
                if (!answer.answer) {
                    _this2.messageService.showToaster('e_0', 'twoFa');
                    return false;
                }
                return true;
            });
        }
    }]);

    return TwoFaAuthenticationService;
}();
TwoFaAuthenticationService = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [message_service_1.MessageService])], TwoFaAuthenticationService);
exports.TwoFaAuthenticationService = TwoFaAuthenticationService;

/***/ }),

/***/ "./shared/services/utils/color.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var ColorService = function () {
    function ColorService() {
        _classCallCheck(this, ColorService);
    }

    _createClass(ColorService, [{
        key: "shadeColor",
        value: function shadeColor(color, percent) {
            var R = parseInt(color.substring(1, 3), 16);
            var G = parseInt(color.substring(3, 5), 16);
            var B = parseInt(color.substring(5, 7), 16);
            R = parseInt(String(R * (100 + percent) / 100));
            G = parseInt(String(G * (100 + percent) / 100));
            B = parseInt(String(B * (100 + percent) / 100));
            R = R < 255 ? R : 255;
            G = G < 255 ? G : 255;
            B = B < 255 ? B : 255;
            var RR = R.toString(16).length === 1 ? "0" + R.toString(16) : R.toString(16);
            var GG = G.toString(16).length === 1 ? "0" + R.toString(16) : G.toString(16);
            var BB = B.toString(16).length === 1 ? "0" + R.toString(16) : B.toString(16);
            return "#" + RR + GG + BB;
        }
    }]);

    return ColorService;
}();
ColorService = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [])], ColorService);
exports.ColorService = ColorService;

/***/ }),

/***/ "./shared/services/utils/utils-service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var UtilsServiceProvider = function () {
    function UtilsServiceProvider() {
        _classCallCheck(this, UtilsServiceProvider);
    }

    _createClass(UtilsServiceProvider, [{
        key: "wrapFunction",
        value: function wrapFunction(fn, context, params) {
            return function () {
                fn.apply(context, params);
            };
        }
    }, {
        key: "closeAllModalsAndOpenNew",
        value: function closeAllModalsAndOpenNew(newModal) {
            var $modals = $('.modal.in');
            if ($modals.length) {
                $modals.modal('hide').on('hidden.bs.modal', function () {
                    $(newModal).modal('show');
                    $(this).off('hidden.bs.modal');
                });
            } else {
                $(newModal).modal('show');
            }
        }
    }, {
        key: "showNextModal",
        value: function showNextModal(selectModal, nextModal, e) {
            if (e) {
                e.preventDefault();
            }
            var modal = document.querySelector(selectModal);
            if (modal) {
                var modalIsShown = modal.classList.contains('in');
                if (!modalIsShown) {
                    $(nextModal).modal('show');
                } else {
                    $(selectModal).modal('hide').on('hidden.bs.modal', function () {
                        $(nextModal).modal('show');
                        $(this).off('hidden.bs.modal'); // Remove the 'on' event binding
                    });
                }
            } else {
                $(nextModal).modal('show');
            }
        }
    }]);

    return UtilsServiceProvider;
}();
UtilsServiceProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [])], UtilsServiceProvider);
exports.UtilsServiceProvider = UtilsServiceProvider;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./shared/services/workflow/tasks.model.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
exports.dateItems = ['days', 'months', 'hours'];
exports.taskDateSequence = ['after lead created', 'after job accepted', 'before main shoot', 'after main shoot', 'after previous task'];
exports.automatedActions = [{
    shortName: 'SEND_EMAIL',
    fullName: 'This task sends an email'
}, {
    shortName: 'SEND_QUESTIONNAIRE',
    fullName: 'This task sends a questionnaire'
}, {
    shortName: 'SEND_CONTRACT',
    fullName: 'This task sends a contract'
}];
exports.modalIds = {
    appointment: {
        id: '#appointment',
        component: 'AddAppointmentModalComponent'
    },
    appointmentWithoutSchedule: '#appointmentWithoutScheduleModal',
    automation: {
        id: '#addAutomationModal',
        component: 'AddAutomationModalComponent'
    },
    extraShoot: {
        id: '#extraShootModal',
        component: 'AddExtraShootModalComponent'
    },
    extraShootWithoutSchedule: '#extraShootWithoutScheduleModal',
    todo: {
        id: '#addTodoModal',
        component: 'AddTodoModalComponent'
    }
};
exports.taskTypeNames = {
    lead: 'LEAD',
    production: 'PRODUCTION',
    postProduction: 'POST_PRODUCTION'
};
exports.eventTypes = {
    appointment: 'APPOINTMENT',
    extraShoot: 'EXTRA_SHOOT',
    mainShoot: 'MAIN_SHOOT'
};

/***/ }),

/***/ "./shared/services/workflow/workflow-drag-n-drop.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var workflow_data_service_1 = __webpack_require__("./shared/services/workflow/workflow.data.service.ts");
var WorkflowDragNDropProvider = function () {
    function WorkflowDragNDropProvider(workflowDataService) {
        _classCallCheck(this, WorkflowDragNDropProvider);

        this.workflowDataService = workflowDataService;
    }

    _createClass(WorkflowDragNDropProvider, [{
        key: "replaceFirstWithSecond",
        value: function replaceFirstWithSecond(list) {
            var _list = _toArray(list),
                first = _list[0],
                second = _list[1],
                rest = _list.slice(2);

            return [second, first].concat(_toConsumableArray(rest));
        }
    }, {
        key: "replaceLastWithPrevious",
        value: function replaceLastWithPrevious(list) {
            var modifiedList = list;
            var last = modifiedList.pop();
            modifiedList.splice(modifiedList.length - 1, 0, last);
            return modifiedList;
        }
    }, {
        key: "isDefaultTaskInPlace",
        value: function isDefaultTaskInPlace(list) {
            var isLastSection = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var checkedTask = void 0;
            var firstTask = list[0];
            var lastTask = list[list.length - 1];
            checkedTask = isLastSection ? lastTask : firstTask;
            var eventType = checkedTask.eventType || checkedTask.calendarEventType;
            if (checkedTask.defaultTask && eventType !== 'MAIN_SHOOT') {
                return true;
            }
            return false;
        }
    }, {
        key: "checkForChangeType",
        value: function checkForChangeType(item, taskTypes) {
            var numberOfTasksOfEachType = taskTypes.map(function (item) {
                return item.length;
            });

            var _numberOfTasksOfEachT = _slicedToArray(numberOfTasksOfEachType, 2),
                leadNum = _numberOfTasksOfEachT[0],
                productionNum = _numberOfTasksOfEachT[1];

            var firstNumInLastSection = leadNum + productionNum;
            if (item.number >= firstNumInLastSection) {
                return 'POST_PRODUCTION';
            } else if (item.number >= leadNum) {
                return 'PRODUCTION';
            }
            return 'LEAD';
        }
    }, {
        key: "renewTaskList",
        value: function renewTaskList(taskTypesList) {
            var _this = this;

            var taskTypes = JSON.parse(JSON.stringify(taskTypesList));
            var num = 0;
            taskTypes.forEach(function (taskType) {
                taskType.forEach(function (task) {
                    task.number = num;
                    task.type = _this.checkForChangeType(task, taskTypes);
                    if (task.dateSequence === 'after previous task') {
                        if (num != 0) {
                            task.previousTask = num - 1;
                        }
                    } else if (task.previousTask || task.previousTask === 0) {
                        delete task.previousTask;
                    }
                    num++;
                });
            });
            return taskTypes;
        }
    }, {
        key: "keepDefaultTasksInPlace",
        value: function keepDefaultTasksInPlace(taskTypesArr) {
            var _this2 = this;

            var taskTypes = JSON.parse(JSON.stringify(taskTypesArr));
            var numberOfTaskTypes = taskTypes.length;
            taskTypes.forEach(function (type, index, typesArr) {
                var lastElement = index === numberOfTaskTypes - 1;
                if (lastElement) {
                    var isOrderCorrect = _this2.isDefaultTaskInPlace(type, true);
                    if (!isOrderCorrect) {
                        typesArr[index] = _this2.replaceLastWithPrevious(type);
                    }
                } else {
                    var _isOrderCorrect = _this2.isDefaultTaskInPlace(type);
                    if (!_isOrderCorrect) {
                        typesArr[index] = _this2.replaceFirstWithSecond(type);
                    }
                }
            });
            return taskTypes;
        }
    }, {
        key: "getTaskById",
        value: function getTaskById(task2Search, taskTypes) {
            var task = JSON.parse(JSON.stringify(task2Search));
            var isTaskId = task.id !== null && task.id !== undefined;
            var identificator = isTaskId ? 'id' : 'tmpId';
            if (!task[identificator]) {
                return false;
            }
            for (var i = 0, max = taskTypes.length; i < max; i++) {
                var taskType = taskTypes[i];
                var foundTask = taskType.find(function (taskInList) {
                    return task[identificator] === taskInList[identificator];
                });
                if (foundTask) {
                    return foundTask;
                }
            }
        }
    }, {
        key: "checkForEqualNumbers",
        value: function checkForEqualNumbers(taskTypes) {
            var tasksArray = [].concat.apply([], taskTypes);
            var uniqueNumbers = [].concat(_toConsumableArray(Array.from(new Set(tasksArray.map(function (a) {
                return a.number;
            })))));
            var isAllNumbersUnique = uniqueNumbers.length === tasksArray.length;
            return !isAllNumbersUnique;
        }
    }, {
        key: "prepareTask2Save",
        value: function prepareTask2Save(draggedTask, taskTypes) {
            var newTaskInfo = this.getTaskById(draggedTask, taskTypes); // position in array with new numbers&types
            if (!newTaskInfo) {
                return false;
            }
            var isMainShootInWrongPlace = newTaskInfo.calendarEventType === 'MAIN_SHOOT' && newTaskInfo.type !== 'PRODUCTION';
            if (isMainShootInWrongPlace) {
                return false;
            }
            if (newTaskInfo.overdueDays) {
                newTaskInfo.overdueDays = parseInt(newTaskInfo.overdueDays.match(/\d+/)[0], 10);
            }
            var number = newTaskInfo.number,
                type = newTaskInfo.type,
                id = newTaskInfo.id,
                overdueDays = newTaskInfo.overdueDays;

            return {
                number: number,
                type: type,
                id: id,
                overdueDays: overdueDays
            };
        }
    }, {
        key: "saveNewTasksOrder",
        value: function saveNewTasksOrder(draggedTask, taskTypes) {
            var taskListCopy = JSON.parse(JSON.stringify(taskTypes)); // original array
            taskListCopy = this.renewTaskList(taskListCopy); // array with changed numbers+types
            var task2save = this.prepareTask2Save(draggedTask, taskListCopy);
            if (!task2save) {
                return false;
            }
            var currentNumber = task2save.number,
                currentType = task2save.type,
                id = task2save.id,
                overdueDays = task2save.overdueDays;

            var isPositionChanged = draggedTask.number !== currentNumber || draggedTask.type !== currentType;
            if (!isPositionChanged) {
                return false;
            }
            return this.workflowDataService.saveNewTasksOrder(id, currentNumber, currentType, overdueDays);
        }
    }]);

    return WorkflowDragNDropProvider;
}();
WorkflowDragNDropProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [workflow_data_service_1.WorkflowDataProvider])], WorkflowDragNDropProvider);
exports.WorkflowDragNDropProvider = WorkflowDragNDropProvider;

/***/ }),

/***/ "./shared/services/workflow/workflow-service/workflow.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = undefined && undefined.__param || function (paramIndex, decorator) {
    return function (target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var Observable_1 = __webpack_require__("./node_modules/rxjs/Observable.js");
var validation_service_1 = __webpack_require__("./shared/services/helpers/validation.service.ts");
var workflow_data_service_1 = __webpack_require__("./shared/services/workflow/workflow.data.service.ts");
var random_string_generator_1 = __webpack_require__("./shared/services/helpers/random-string-generator.ts");
var workflow_drag_n_drop_1 = __webpack_require__("./shared/services/workflow/workflow-drag-n-drop.ts");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var time_service_1 = __webpack_require__("./shared/services/helpers/time-service/time.service.ts");
var tasks_model_1 = __webpack_require__("./shared/services/workflow/tasks.model.ts");
var email_service_1 = __webpack_require__("./shared/services/email/email-service/email.service.ts");
var store_1 = __webpack_require__("./node_modules/@ngrx/store/@ngrx/store.es5.js");
var settings_selector_1 = __webpack_require__("./mobile/src/store/selectors/settings.selector.ts");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var WorkflowProvider = function () {
    function WorkflowProvider(validationService, workflowDataService, randomStringGenerator, workflowDragNDropService, messageService, timeService, emailService, store) {
        var _this = this;

        _classCallCheck(this, WorkflowProvider);

        this.validationService = validationService;
        this.workflowDataService = workflowDataService;
        this.randomStringGenerator = randomStringGenerator;
        this.workflowDragNDropService = workflowDragNDropService;
        this.messageService = messageService;
        this.timeService = timeService;
        this.emailService = emailService;
        this.store = store;
        this.taskInfo = {};
        this.taskDateSequence = ['after lead created', 'after job accepted', 'before main shoot', 'after main shoot', 'after previous task'];
        this.isLabelShown = function () {
            var label = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
            var task = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var jobDate = arguments[2];
            var taskList = arguments[3];

            var eventType = task.eventType || task.calendarEventType;
            switch (label) {
                case 'hasDefaultDue':
                    return task.taskDueDefault !== null;
                case 'action-email':
                    return task.action === tasks_model_1.automatedActions[0].shortName && task.taskEmail && !task.due;
                case 'action-autoEmail':
                    return task.action === tasks_model_1.automatedActions[0].shortName && task.taskEmail && task.due;
                case 'action-contract':
                    return task.action === tasks_model_1.automatedActions[2].shortName;
                case 'action-questionnaire':
                    return task.action === tasks_model_1.automatedActions[1].shortName;
                case 'hasDue':
                    return task.taskViewDue !== null;
                case 'hasOverdue':
                    return task.overdueDays !== null && task.overdueDays !== 0 && task.hasDue;
                case 'noDate':
                    return eventType && !jobDate;
                case 'jobAccepted-task':
                    return task.type === tasks_model_1.taskTypeNames.production && task.defaultTask && eventType !== tasks_model_1.eventTypes.mainShoot;
                case 'hasAnyLabel':
                    return eventType || task.action || task.taskViewDue !== null || task.taskDueDefault !== null || task.defaultTask && task.type === tasks_model_1.taskTypeNames.production;
                case 'isInactive':
                    return _this.isInactiveCausedByJobWithoutDate(task, jobDate) || _this.isInactiveCausedByPrevTask(task, taskList);
                case 'main-shoot':
                    return eventType === tasks_model_1.eventTypes.mainShoot;
                case 'extra-shoot':
                    return eventType === tasks_model_1.eventTypes.extraShoot;
                case 'any-shoot':
                    return eventType === tasks_model_1.eventTypes.extraShoot || eventType === tasks_model_1.eventTypes.mainShoot;
                case 'appointment':
                    return eventType === tasks_model_1.eventTypes.appointment;
                case 'hasType':
                    return eventType;
                case 'hasLocation':
                    return task.location;
                default:
                    console.error('No task label of this type');
                    return false;
            }
        };
    }

    _createClass(WorkflowProvider, [{
        key: "addDefaultDue",
        value: function addDefaultDue(task) {
            var taskCopy = Object.assign({}, task);
            taskCopy.due = 1;
            taskCopy.dateItem = tasks_model_1.dateItems[0];
            taskCopy.dateSequence = this.taskDateSequence[0].id;
            return taskCopy;
        }
    }, {
        key: "checkTaskDue",
        value: function checkTaskDue(task) {
            var taskCopy = Object.assign({}, task);
            if (!taskCopy.hasDue || !taskCopy.due) {
                delete taskCopy.due;
                delete taskCopy.dateItem;
                taskCopy.dateSequence = null;
            }
            return taskCopy;
        }
    }, {
        key: "isEmailTemplateChosen",
        value: function isEmailTemplateChosen(email, fromSettings) {
            var isEmail = email !== null && typeof email !== 'undefined' && (typeof email === "undefined" ? "undefined" : _typeof(email)) === 'object';
            if (!isEmail) {
                return false;
            }
            if (!fromSettings || isEmail) {
                return true;
            }
            var invalidEmail = email.hasOwnProperty('text') && !email.hasOwnProperty('subject') && !email.hasOwnProperty('name');
            return !invalidEmail;
        }
    }, {
        key: "isEmailFieldsValid",
        value: function isEmailFieldsValid(email, fromSettings) {
            if (typeof email === 'undefined' || email === null) {
                return false;
            }
            var name = email.name,
                subject = email.subject;

            if (fromSettings && this.validationService.isStringEmpty(name)) {
                this.messageService.showToaster('e_9', 'emailTemplate', 'name');
                return false;
            }
            if (subject !== null && this.validationService.isStringEmpty(subject)) {
                fromSettings ? this.messageService.showToaster('e_9', 'emailTemplate', 'subject') : this.messageService.showToaster('e_5', 'workflow');
                return false;
            }
            return true;
        }
    }, {
        key: "replaceTask",
        value: function replaceTask(oldTask, newTask, taskTypes) {
            var isTaskId = oldTask.id !== null && oldTask.id !== undefined;
            var identificator = isTaskId ? 'id' : 'number';
            var siblingTasks = this.getSiblingTasks(oldTask, taskTypes);
            siblingTasks.some(function (item, index) {
                if (oldTask[identificator] === item[identificator]) {
                    siblingTasks[index] = newTask;
                    return true;
                }
            });
            return taskTypes;
        }
    }, {
        key: "getTaskById",
        value: function getTaskById(task2Search, taskTypes) {
            var task = Object.assign(task2Search);
            var isTaskId = task.id !== null && task.id !== undefined;
            var identificator = isTaskId ? 'id' : 'tmpId';
            if (!task[identificator]) {
                return false;
            }
            for (var i = 0, max = taskTypes.length; i < max; i++) {
                var taskType = taskTypes[i];
                var foundTask = taskType.find(function (taskInList) {
                    return task[identificator] === taskInList[identificator];
                });
                if (foundTask) {
                    return foundTask;
                }
            }
        }
    }, {
        key: "getMainShootIndex",
        value: function getMainShootIndex(tasksArr) {
            for (var i = 0, max = tasksArr.length; i <= max; i++) {
                var event = tasksArr[i].hasOwnProperty('eventType') ? 'eventType' : 'calendarEventType';
                if (tasksArr[i][event] === tasks_model_1.eventTypes.mainShoot) {
                    return i;
                }
            }
        }
    }, {
        key: "getTaskIndex",
        value: function getTaskIndex(task, tasksArr) {
            for (var i = 0, max = tasksArr.length; i <= max; i++) {
                if (tasksArr[i].number === task.number) {
                    return i;
                }
            }
        }
    }, {
        key: "concatTasksArr",
        value: function concatTasksArr(taskTypes) {
            var tasks = [];
            taskTypes.forEach(function (taskType) {
                var _tasks;

                tasks = (_tasks = tasks).concat.apply(_tasks, _toConsumableArray(taskType));
            });
            return tasks;
        }
    }, {
        key: "filterTasksWithDueDate",
        value: function filterTasksWithDueDate(tasks) {
            return tasks.filter(function (task) {
                return task.dueDate || task.startDate;
            });
        }
    }, {
        key: "addTaskDateTime",
        value: function addTaskDateTime(tasks) {
            var _this2 = this;

            return tasks.map(function (task) {
                var date = task.dueDate || task.startDate;
                var time = task.dueTime || task.startTime;
                if (task.type === tasks_model_1.taskTypeNames.lead && task.number === 0) {
                    time = null;
                }
                task.dateTime = _this2.timeService.getDateAndTime(date, time);
                return task;
            });
        }
    }, {
        key: "orderTasksByDate",
        value: function orderTasksByDate(tasks) {
            return tasks.sort(function (a, b) {
                return new Date(a.dateTime).getTime() - new Date(b.dateTime).getTime();
            });
        }
    }, {
        key: "getNextTaskByDate",
        value: function getNextTaskByDate(task, taskTypes) {
            var foundTask = void 0;
            var tasks = this.concatTasksArr(taskTypes);
            var tasksWithDueDate = this.filterTasksWithDueDate(tasks);
            var tasksWithDateTime = this.addTaskDateTime(tasksWithDueDate);
            var orderedTasksByDate = this.orderTasksByDate(tasksWithDateTime);
            var taskDateTime = this.timeService.getDateAndTime(task.startDate, task.startTime);
            var nextTask = orderedTasksByDate.find(function (taskInList) {
                return taskDateTime < taskInList.dateTime;
            });
            if (nextTask) {
                foundTask = nextTask;
            } else {
                var lastTaskWithDate = orderedTasksByDate[orderedTasksByDate.length - 1];
                foundTask = this.getTaskAfterLastWithDate(taskTypes, lastTaskWithDate);
            }
            return foundTask || tasks[tasks.length - 1];
        }
    }, {
        key: "getTaskAfterLastWithDate",
        value: function getTaskAfterLastWithDate(taskTypes, lastTaskWithDate) {
            return this.getTaskByNumber(lastTaskWithDate.number + 1, taskTypes);
        }
    }, {
        key: "getSiblingTasks",
        value: function getSiblingTasks(task, taskTypes) {
            var _taskTypes = _slicedToArray(taskTypes, 3),
                leadCreated = _taskTypes[0],
                jobAccepted = _taskTypes[1],
                jobCompleted = _taskTypes[2];

            switch (task.type) {
                case tasks_model_1.taskTypeNames.lead:
                    return leadCreated;
                case tasks_model_1.taskTypeNames.production:
                    return jobAccepted;
                case tasks_model_1.taskTypeNames.postProduction:
                    return jobCompleted;
                default:
                    break;
            }
        }
    }, {
        key: "getTaskDates",
        value: function getTaskDates() {
            return tasks_model_1.dateItems;
        }
    }, {
        key: "pluralizeDue",
        value: function pluralizeDue(dueAmount, dueItem) {
            var resultDue = void 0;
            var isPluralItem = dueItem.endsWith('s');
            if (dueAmount > 1) {
                resultDue = isPluralItem ? dueItem : dueItem + "s";
            } else {
                resultDue = isPluralItem ? dueItem.slice(0, -1) : dueItem;
            }
            return resultDue;
        }
    }, {
        key: "getTaskDateSequence",
        value: function getTaskDateSequence() {
            return this.taskDateSequence;
        }
    }, {
        key: "setTaskDateSequence",
        value: function setTaskDateSequence(newTaskDateSequence) {
            this.taskDateSequence = JSON.parse(JSON.stringify(newTaskDateSequence));
        }
    }, {
        key: "getAutomatedActions",
        value: function getAutomatedActions() {
            return tasks_model_1.automatedActions;
        }
    }, {
        key: "setNewTaskDateSequence",
        value: function setNewTaskDateSequence() {
            var _this3 = this;

            this.store.select(settings_selector_1.getCustomizedLabels).pipe(operators_1.filter(function (labels) {
                return !!labels.mainShootLabel;
            }), operators_1.take(1)).subscribe(function (labels) {
                return _this3.setTaskDateSequence(_this3.setCorrectNaming(labels.mainShootLabel));
            });
        }
    }, {
        key: "setCorrectNaming",
        value: function setCorrectNaming(mainShooLabel) {
            var originalTaskDateSequence = ['after lead created', 'after job accepted', 'before main shoot', 'after main shoot', 'after previous task'];
            return originalTaskDateSequence.map(function (el) {
                return {
                    id: el,
                    name: el.includes('main shoot') ? el.replace('main shoot', mainShooLabel.toLowerCase()) : el
                };
            });
        }
    }, {
        key: "pasteTaskWithoutDate",
        value: function pasteTaskWithoutDate(task, taskTypes) {
            var _taskTypes2 = taskTypes,
                _taskTypes3 = _slicedToArray(_taskTypes2, 3),
                lead = _taskTypes3[0],
                production = _taskTypes3[1],
                postProduction = _taskTypes3[2];

            var mainShootIndex = this.getMainShootIndex(production);
            switch (task.dateSequence) {
                case this.taskDateSequence[0].id:
                    lead.splice(lead.length, 0, task);
                    break;
                case this.taskDateSequence[1].id:
                case this.taskDateSequence[2].id:
                    production.splice(mainShootIndex, 0, task);
                    break;
                case this.taskDateSequence[3].id:
                    postProduction.splice(0, 0, task);
                    break;
                case this.taskDateSequence[4].id:
                    postProduction.splice(postProduction.length - 1, 0, task);
                    break;
                default:
                    postProduction.splice(postProduction.length - 1, 0, task);
                    break;
            }
            taskTypes = [lead, production, postProduction];
            taskTypes = this.workflowDragNDropService.renewTaskList(taskTypes);
            return taskTypes;
        }
    }, {
        key: "pasteTaskWithDate",
        value: function pasteTaskWithDate(task, taskTypes) {
            var taskToPasteType = void 0,
                nextTaskIndex = void 0;

            var _taskTypes4 = taskTypes,
                _taskTypes5 = _slicedToArray(_taskTypes4, 3),
                lead = _taskTypes5[0],
                production = _taskTypes5[1],
                postProduction = _taskTypes5[2];

            var MIN_INDEX = 1;
            var nextTask = this.getNextTaskByDate(task, taskTypes);
            taskToPasteType = nextTask.type;
            switch (taskToPasteType) {
                case tasks_model_1.taskTypeNames.lead:
                    nextTaskIndex = this.getTaskIndex(nextTask, lead);
                    // not to paste on first position
                    if (nextTaskIndex === 0) {
                        nextTaskIndex = MIN_INDEX;
                    }
                    lead.splice(nextTaskIndex, 0, task);
                    break;
                case tasks_model_1.taskTypeNames.production:
                    nextTaskIndex = this.getTaskIndex(nextTask, production);
                    // not to paste on first position
                    if (nextTaskIndex === 0) {
                        nextTaskIndex = MIN_INDEX;
                    }
                    production.splice(nextTaskIndex, 0, task);
                    break;
                case tasks_model_1.taskTypeNames.postProduction:
                default:
                    nextTaskIndex = this.getTaskIndex(nextTask, postProduction);
                    // prefer pasting calendar events in production stage
                    if (nextTaskIndex === 0) {
                        production.push(task);
                        break;
                    }
                    postProduction.splice(nextTaskIndex, 0, task);
                    break;
            }
            taskTypes = [lead, production, postProduction];
            taskTypes = this.workflowDragNDropService.renewTaskList(taskTypes);
            return taskTypes;
        }
    }, {
        key: "prepareTaskToSave",
        value: function prepareTaskToSave(task, jobId) {
            var task2save = Object.assign({}, task);
            var overdueDays = task2save.overdueDays,
                email = task2save.taskEmail;

            if (overdueDays) {
                task2save.overdueDays = parseInt(overdueDays.match(/\d+/)[0], 10);
            }
            if (email) {
                email.text = this.emailService.addMaiStyling(email.text);
            }
            if (task2save.jobId === null || task2save.jobId === undefined) {
                task2save.jobId = jobId;
            }
            if (task2save.tmpId) {
                delete task2save.tmpId;
            }
            return task2save;
        }
    }, {
        key: "deleteTaskFromList",
        value: function deleteTaskFromList(task, taskTypes) {
            var siblingTasks = this.getSiblingTasks(task, taskTypes);
            var isTaskId = task.id !== null && task.id !== undefined;
            var identificator = isTaskId ? 'id' : 'number';
            siblingTasks.some(function (item, index) {
                if (task[identificator] === item[identificator]) {
                    siblingTasks.splice(index, 1);
                    return true;
                }
            });
        }
    }, {
        key: "setTaskInfo",
        value: function setTaskInfo() {
            var task = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var taskList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
            var isForEdit = arguments[2];

            if (!task.due) {
                task = this.addDefaultDue(task);
            } else {
                task.hasDue = true;
            }
            if (task.startDate && task.endDate) {
                task.startDate = this.timeService.createDateAsUTC(task.startDate);
                task.endDate = this.timeService.createDateAsUTC(task.endDate);
            }
            this.taskInfo = { task: task, taskList: taskList, isForEdit: isForEdit };
            return this.taskInfo;
        }
    }, {
        key: "addEmptyTask",
        value: function addEmptyTask() {
            return {
                id: null,
                defaultTask: false,
                hasDue: false,
                hasMail: false,
                name: ''
            };
        }
    }, {
        key: "getTaskInfo",
        value: function getTaskInfo() {
            var isTaskInfoEmpty = Object.keys(this.taskInfo).length === 0;
            if (isTaskInfoEmpty) {
                this.taskInfo.task = this.addEmptyTask();
            }
            return this.taskInfo;
        }
    }, {
        key: "isTaskValid",
        value: function isTaskValid(task) {
            var fromSettings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var isAutomation = task.hasMail || task.action;
            if (this.validationService.isStringEmpty(task.name)) {
                this.messageService.showToaster('e_1', 'workflow');
                return false;
            }
            if (task.hasDue || task.due) {
                var isDueDaysFilled = task.due || task.due >= 1;
                if (!isDueDaysFilled) {
                    this.messageService.showToaster('e_2', 'workflow');
                    return false;
                }
            }
            if (isAutomation) {
                if (!task.action) {
                    this.messageService.showToaster('e_3', 'workflow');
                    return false;
                }
                if (!this.isEmailTemplateChosen(task.taskEmail, fromSettings)) {
                    this.messageService.showToaster('e_4', 'workflow');
                    return false;
                }
                if (!this.isEmailFieldsValid(task.taskEmail, fromSettings)) {
                    return false;
                }
            }
            return true;
        }
    }, {
        key: "pasteNewTaskInList",
        value: function pasteNewTaskInList(taskTypes, task2Paste) {
            var taskTypesCopy = Object.assign(taskTypes);
            var task = this.checkTaskDue(task2Paste);
            var taskInList = false;
            if (task.number !== null && task.number !== undefined) {
                if (task.id !== null && task.id !== undefined) {
                    taskInList = this.getTaskById(task2Paste, taskTypes);
                } else {
                    taskInList = this.getTaskByNumber(task2Paste.number, taskTypes);
                }
            }
            if (taskInList) {
                var currentDateSequence = task.dateSequence;
                if (!currentDateSequence || !task.hasDue || !task.due) {
                    currentDateSequence = null;
                }
                var isDateSequenceChanged = taskInList.dateSequence !== currentDateSequence;
                var isTaskStartDateChanged = taskInList.startDate !== task.startDate;
                if (isDateSequenceChanged || isTaskStartDateChanged) {
                    this.deleteTaskFromList(taskInList, taskTypesCopy);
                } else {
                    taskTypesCopy = this.replaceTask(taskInList, task, taskTypesCopy);
                    return taskTypesCopy;
                }
            }
            taskTypesCopy = task.startDate ? this.pasteTaskWithDate(task, taskTypesCopy) : this.pasteTaskWithoutDate(task, taskTypesCopy);
            return taskTypesCopy;
        }
    }, {
        key: "getTaskTemplates",
        value: function getTaskTemplates(id, successCallback) {
            var _this4 = this;

            return this.workflowDataService.getTaskTemplates(id).subscribe(function (data) {
                return successCallback(data);
            }, function (error) {
                return _this4.messageService.showDefaultErrorMessage(error);
            });
        }
    }, {
        key: "saveWorkflowTemplate",
        value: function saveWorkflowTemplate(workflow, successCallback) {
            var _this5 = this;

            return this.workflowDataService.saveWorkflow(workflow).map(function (data) {
                return successCallback(data, workflow);
            }, function (result) {
                return _this5.errorSaveTask(result.data);
            });
        }
    }, {
        key: "getJobWorkflow",
        value: function getJobWorkflow(id, successCallback) {
            return this.workflowDataService.getWorkflow(id).map(function (result) {
                return successCallback(result);
            });
        }
    }, {
        key: "deleteTask",
        value: function deleteTask(taskTypes, taskId) {
            return this.workflowDataService.deleteTask(taskId);
        }
    }, {
        key: "validateEmailLinks",
        value: function validateEmailLinks(action, emailTemplateId) {
            return this.workflowDataService.validateEmailLinks(action, emailTemplateId);
        }
    }, {
        key: "validateEmailName",
        value: function validateEmailName(email) {
            if (email.id) {
                return Observable_1.Observable.of();
                // return $q.resolve();
            }
            return this.workflowDataService.validateEmailName(email);
        }
    }, {
        key: "deleteTaskFromSettings",
        value: function deleteTaskFromSettings(workflow, taskTypes, task) {
            var workflowCopy = JSON.parse(JSON.stringify(workflow));
            if (task.id !== null && task.id !== undefined) {
                if (!workflowCopy.taskToDelete) {
                    workflowCopy.taskToDelete = [];
                }
                workflowCopy.taskToDelete.push(task.id);
            }
            this.deleteTaskFromList(task, taskTypes);
            return workflowCopy;
        }
    }, {
        key: "getTaskByNumber",
        value: function getTaskByNumber(number, taskTypes) {
            for (var i = 0, max = taskTypes.length; i < max; i++) {
                var taskType = taskTypes[i];
                var foundTask = taskType.find(function (item) {
                    return number === item.number;
                });
                if (foundTask) {
                    return foundTask;
                }
            }
            return null;
        }
    }, {
        key: "filterTasksBy",
        value: function filterTasksBy(taskList, tasksType) {
            return taskList.filter(function (task) {
                return task.type === tasksType;
            });
        }
    }, {
        key: "calcTaskOverdue",
        value: function calcTaskOverdue(overdueDays) {
            var taskOverdue = void 0;
            if (overdueDays > 0) {
                taskOverdue = isNaN(overdueDays) ? NaN : "! " + overdueDays + " day" + (overdueDays > 1 ? 's' : '') + " overdue";
            }
            return taskOverdue || overdueDays || null;
        }
    }, {
        key: "getTaskViewDue",
        value: function getTaskViewDue(task, taskTypes) {
            var taskViewDue = null;
            var dateItem = task.dateItem,
                due = task.due,
                dateSequence = task.dateSequence,
                prevTaskNumber = task.previousTask;

            var isTaskDue = [dateItem, due !== 'undefined', due != null, dateSequence].every(Boolean);
            if (!isTaskDue) {
                return taskViewDue;
            }
            var dateItemTmp = this.pluralizeDue(due, dateItem.toLowerCase());
            var dateSequenceTmp = dateSequence.replace('_', ' ').toLowerCase();
            taskViewDue = due + " " + dateItemTmp + " ";
            if (dateSequence === 'after previous task') {
                var previousTask = this.getTaskByNumber(prevTaskNumber, taskTypes);
                taskViewDue += previousTask !== null ? "after " + previousTask.name : dateSequenceTmp;
            } else {
                taskViewDue += dateSequenceTmp;
            }
            return taskViewDue;
        }
    }, {
        key: "renewTaskViewDue",
        value: function renewTaskViewDue(taskList) {
            var _this6 = this;

            var renewedList = Object.assign({}, taskList);
            renewedList.forEach(function (taskType) {
                taskType.forEach(function (task) {
                    task.taskViewDue = _this6.getTaskViewDue(task, renewedList);
                });
            });
            return renewedList;
        }
    }, {
        key: "fillWorkflowTasks",
        value: function fillWorkflowTasks() {
            var taskList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

            return [this.filterTasksBy(taskList, 'LEAD'), this.filterTasksBy(taskList, 'PRODUCTION'), this.filterTasksBy(taskList, 'POST_PRODUCTION')];
        }
    }, {
        key: "errorSaveTask",
        value: function errorSaveTask(data) {
            if (!data || data === 'Task is not valid') {
                return;
            }
            var errorTitle = data.errorTitle,
                errorMessage = data.errorMessage;

            this.messageService.showErrorFromBackend(errorTitle, errorMessage);
        }
    }, {
        key: "saveTask",
        value: function saveTask(task, jobId, taskTypes) {
            var task2Save = Object.assign({}, task);
            var isTaskId = task2Save.id !== null && task2Save.id !== undefined;
            if (!isTaskId) {
                task2Save.tmpId = this.randomStringGenerator.getMixedString();
            }
            var taskTypesCopy = taskTypes.slice();
            if (!this.isTaskValid(task2Save)) {
                return Observable_1.Observable.throw('Task is not valid');
            }
            task2Save = this.checkTaskDue(task2Save);
            taskTypesCopy = this.pasteNewTaskInList(taskTypesCopy, task2Save);
            taskTypesCopy = this.workflowDragNDropService.renewTaskList(taskTypesCopy);
            var newTaskPosition = this.getTaskById(task2Save, taskTypesCopy);
            task2Save.number = newTaskPosition.number;
            task2Save.type = newTaskPosition.type;
            task2Save = this.prepareTaskToSave(task2Save, jobId);
            return this.workflowDataService.saveTask(task2Save);
        }
    }, {
        key: "isInactiveCausedByJobWithoutDate",
        value: function isInactiveCausedByJobWithoutDate(task, jobDate) {
            return (task.dateSequence === this.taskDateSequence[2].id || task.dateSequence === this.taskDateSequence[3].id) && task.action && !task.completed && !jobDate;
        }
    }, {
        key: "isInactiveCausedByPrevTask",
        value: function isInactiveCausedByPrevTask(task, taskList) {
            if (!task || !taskList) {
                return false;
            }
            var prevTask = this.getTaskByNumber(task.number - 1, taskList);
            if (!prevTask) {
                return false;
            }
            var isAfterCalendarEventWithoutDue = prevTask.calendarEventType !== null && prevTask.dueDate === null;
            var isAutomationAfterPrev = task.action && task.dateSequence === this.taskDateSequence[4].id;
            return !task.completed && isAutomationAfterPrev && isAfterCalendarEventWithoutDue;
        }
    }, {
        key: "chooseModalToShow",
        value: function chooseModalToShow(task, template) {
            var modal = {};
            var eventType = task.eventType || task.calendarEventType;
            if (task.action || task.hasMail) {
                modal = tasks_model_1.modalIds.automation;
            } else if (eventType === tasks_model_1.eventTypes.appointment && template) {
                modal = tasks_model_1.modalIds.appointmentWithoutSchedule;
            } else if (eventType === tasks_model_1.eventTypes.appointment && !template) {
                modal = tasks_model_1.modalIds.appointment;
            } else if (eventType === tasks_model_1.eventTypes.extraShoot && template) {
                modal = tasks_model_1.modalIds.extraShootWithoutSchedule;
            } else if (eventType === tasks_model_1.eventTypes.extraShoot && !template) {
                modal = tasks_model_1.modalIds.extraShoot;
            } else {
                modal = tasks_model_1.modalIds.todo;
            }
            return modal;
        }
    }, {
        key: "handleTask",
        value: function handleTask(taskToHandle, taskTypes, job) {
            var task = Object.assign({}, taskToHandle);
            if (task.dateItem) {
                task.dateItem = task.dateItem.toLowerCase();
            }
            if (task.due && !task.hasDue) {
                // for old workflows
                task.hasDue = true;
            }
            if (!task.action && task.taskEmail) {
                // for old workflows
                task.action = 'SEND_EMAIL';
            }
            if (task.calendarEventType === 'MAIN_SHOOT') {
                var startDate = job.startDate,
                    finishDate = job.finishDate,
                    startTime = job.startTime,
                    finishTime = job.finishTime,
                    location = job.location;

                task.location = location;
                task.startDate = startDate;
                task.endDate = finishDate;
                task.startTime = startTime;
                task.endTime = finishTime;
            } else if (task.calendarEvent) {
                var _task$calendarEvent = task.calendarEvent,
                    _startDate = _task$calendarEvent.startDate,
                    endDate = _task$calendarEvent.endDate,
                    _startTime = _task$calendarEvent.startTime,
                    endTime = _task$calendarEvent.endTime,
                    _location = _task$calendarEvent.location,
                    clientId = _task$calendarEvent.clientId;

                task.location = _location;
                task.startDate = _startDate;
                task.endDate = endDate;
                task.startTime = _startTime;
                task.endTime = endTime;
                task.sendEmails = clientId ? task.calendarEvent.sendEmails : false;
                if (task.startDate && (task.startTime === null || task.finishTime === null)) {
                    task.allday = true;
                }
            }
            task.overdueDays = this.calcTaskOverdue(task.overdueDays);
            task.taskViewDue = this.getTaskViewDue(task, taskTypes);
            task.taskDueDefault = task.defaultTask && task.dueDate ? task.dueDate : null;
            return task;
        }
    }]);

    return WorkflowProvider;
}();
WorkflowProvider = __decorate([core_1.Injectable(), __param(7, core_1.Optional()), __metadata("design:paramtypes", [validation_service_1.ValidationProvider, workflow_data_service_1.WorkflowDataProvider, random_string_generator_1.RandomStringGeneratorProvider, workflow_drag_n_drop_1.WorkflowDragNDropProvider, message_service_1.MessageService, time_service_1.TimeServiceProvider, email_service_1.EmailServiceProvider, store_1.Store])], WorkflowProvider);
exports.WorkflowProvider = WorkflowProvider;

/***/ }),

/***/ "./shared/services/workflow/workflow.data.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var http_1 = __webpack_require__("./node_modules/@angular/common/esm5/http.js");
var Observable_1 = __webpack_require__("./node_modules/rxjs/Observable.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var WorkflowDataProvider = function () {
    function WorkflowDataProvider(http, messageService) {
        _classCallCheck(this, WorkflowDataProvider);

        this.http = http;
        this.messageService = messageService;
        this.ALL_WORKFLOWS_URL = '/protected/rest/workflows';
        this.JOB_WORKFLOW_URL = '/protected/rest/workflow';
        this.defaultWorkflow = {
            name: 'Default',
            id: null
        };
        this.workflowNames = [];
    }

    _createClass(WorkflowDataProvider, [{
        key: "getWorkflowNames",
        value: function getWorkflowNames() {
            var _this = this;

            return this.getWorkflowNamesFromServer().pipe(operators_1.map(function (data) {
                if (data !== undefined && data !== null && data.data.workflows) {
                    _this.setWorkflowNamesInStorage(data.data.workflows);
                    return JSON.parse(JSON.stringify(_this.workflowNames));
                }
                return data;
            }), operators_1.catchError(function (err) {
                _this.messageService.handleError(err);
                return Observable_1.Observable.throw(err);
            }));
        }
    }, {
        key: "getWorkflowAndLanguageNames",
        value: function getWorkflowAndLanguageNames() {
            var _this2 = this;

            return this.getWorkflowNamesFromServer().pipe(operators_1.map(function (data) {
                if (data && data.data.workflows) {
                    _this2.setWorkflowNamesInStorage(data.data.workflows);
                    return {
                        workflows: JSON.parse(JSON.stringify(_this2.workflowNames)),
                        languages: JSON.parse(JSON.stringify(data.data.languages || null))
                    };
                }
                return data;
            }), operators_1.catchError(function (err) {
                _this2.messageService.handleError(err);
                return Observable_1.Observable.throw(err);
            }));
        }
    }, {
        key: "saveTask",
        value: function saveTask(task) {
            var url = this.JOB_WORKFLOW_URL + "/task/";
            return this.http.post(url, task).map(function (data) {
                data.taskToAnimate = task.number;
                return data;
            });
        }
    }, {
        key: "deleteTask",
        value: function deleteTask(id) {
            var url = this.JOB_WORKFLOW_URL + "/task/" + id;
            return this.http.delete(url);
        }
    }, {
        key: "getTaskTemplates",
        value: function getTaskTemplates(id) {
            var url = this.ALL_WORKFLOWS_URL + "/get";
            var params = new http_1.HttpParams().set('id', id);
            return this.http.get(url, { params: params });
        }
    }, {
        key: "saveWorkflow",
        value: function saveWorkflow(workflow) {
            var url = this.ALL_WORKFLOWS_URL + "/save";
            return this.http.post(url, workflow);
        }
    }, {
        key: "getWorkflow",
        value: function getWorkflow(id) {
            var url = "/protected/rest/jobs/workflow/?jobId=" + id;
            return this.http.get(url);
        }
    }, {
        key: "validateEmailLinks",
        value: function validateEmailLinks(action, emailTemplateId) {
            var url = this.ALL_WORKFLOWS_URL + "/validate";
            var body = { action: action, emailTemplateId: emailTemplateId };
            return this.http.post(url, body);
        }
    }, {
        key: "validateEmailName",
        value: function validateEmailName(email) {
            var url = this.ALL_WORKFLOWS_URL + "/email_template/name";
            return this.http.post(url, email);
        }
    }, {
        key: "saveNewTasksOrder",
        value: function saveNewTasksOrder(taskId, newNumber, type, overdueDays) {
            var url = this.JOB_WORKFLOW_URL + "/dragAndDrop";
            var body = {
                taskId: taskId,
                newNumber: newNumber,
                type: type,
                overdueDays: overdueDays
            };
            return this.http.post(url, body);
        }
    }, {
        key: "getWorkflowsOnPage",
        value: function getWorkflowsOnPage(_ref) {
            var perPage = _ref.perPage,
                page = _ref.page,
                _ref$pageOrder = _ref.pageOrder,
                predicate = _ref$pageOrder.predicate,
                reverse = _ref$pageOrder.reverse;

            var url = this.ALL_WORKFLOWS_URL;
            var params = new http_1.HttpParams();
            params = params.append('perPage', perPage);
            params = params.append('page', page);
            params = params.append('predicate', predicate);
            params = params.append('reverse', reverse);
            return this.http.get(url, { params: params });
        }
    }, {
        key: "deleteWorkflow",
        value: function deleteWorkflow(id) {
            var url = this.ALL_WORKFLOWS_URL + "/delete?id=" + id;
            return this.http.post(url, null);
        }
    }, {
        key: "getWorkflowNamesFromServer",
        value: function getWorkflowNamesFromServer() {
            var url = '/api/user/v1/job/create/metadata';
            return this.http.get(url);
        }
    }, {
        key: "isDefaultWorkflowInList",
        value: function isDefaultWorkflowInList(workflows) {
            var _this3 = this;

            return workflows.some(function (workflow) {
                return workflow.name === _this3.defaultWorkflow.name;
            });
        }
    }, {
        key: "setWorkflowNamesInStorage",
        value: function setWorkflowNamesInStorage(data) {
            this.workflowNames = JSON.parse(JSON.stringify(data));
            if (!this.isDefaultWorkflowInList(this.workflowNames)) {
                this.workflowNames.push(this.defaultWorkflow);
            }
        }
    }]);

    return WorkflowDataProvider;
}();
WorkflowDataProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [http_1.HttpClient, message_service_1.MessageService])], WorkflowDataProvider);
exports.WorkflowDataProvider = WorkflowDataProvider;

/***/ }),

/***/ "./web/app.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var AppComponent = function AppComponent() {
    _classCallCheck(this, AppComponent);
};
AppComponent = __decorate([core_1.Component({
    selector: 'sn-app',
    template: "\n                <div ng-view class=\"main-container sn-header-placeholder bottom-placeholder\"></div>\n                <upload-photo-modal></upload-photo-modal>\n                \n\t\t\t\t<router-outlet class=\"main-container sn-header-placeholder bottom-placeholder\"></router-outlet>\n\t\t\t\t\n\t\t\t\t<sn-iframe></sn-iframe>\n\t\t\t\t<subscription-announcement-banner></subscription-announcement-banner>\n\t\t\t\t<subscription-choose-plan></subscription-choose-plan>\n\t\t\t\t<two-fa-control></two-fa-control>\n           "
})], AppComponent);
exports.AppComponent = AppComponent;

/***/ }),

/***/ "./web/app.module.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var static_1 = __webpack_require__("./node_modules/@angular/upgrade/esm5/static.js");
var common_1 = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
var platform_browser_1 = __webpack_require__("./node_modules/@angular/platform-browser/esm5/platform-browser.js");
var router_1 = __webpack_require__("./node_modules/@angular/router/esm5/router.js");
var http_1 = __webpack_require__("./node_modules/@angular/common/esm5/http.js");
var forms_1 = __webpack_require__("./node_modules/@angular/forms/esm5/forms.js");
var ng2_dragula_1 = __webpack_require__("./node_modules/ng2-dragula/index.js");
var ngx_img_cropper_1 = __webpack_require__("./node_modules/ngx-img-cropper/index.js");
var mydatepicker_1 = __webpack_require__("./node_modules/mydatepicker/index.js");
var dropdown_1 = __webpack_require__("./node_modules/ngx-bootstrap/dropdown/fesm5/ngx-bootstrap-dropdown.js");
var ngx_daterangepicker_material_1 = __webpack_require__("./node_modules/ngx-daterangepicker-material/esm5/ngx-daterangepicker-material.js");
var angular2_text_mask_1 = __webpack_require__("./node_modules/angular2-text-mask/dist/angular2TextMask.js");
var ngx_quill_1 = __webpack_require__("./node_modules/ngx-quill/fesm5/ngx-quill.js");
var ng_bootstrap_1 = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/index.js");
var ngx_clipboard_1 = __webpack_require__("./node_modules/ngx-clipboard/dist/ngx-clipboard.js");
var ngx_dropzone_1 = __webpack_require__("./node_modules/ngx-dropzone/fesm5/ngx-dropzone.js");
var carousel_1 = __webpack_require__("./node_modules/ngx-bootstrap/carousel/fesm5/ngx-bootstrap-carousel.js");
var iframe_resizer_directive_1 = __webpack_require__("./web/modern/directives/iframe-resizer/iframe-resizer.directive.ts");
var time_filter_1 = __webpack_require__("./shared/pipes/time-filter/time-filter.ts");
var cut_string_1 = __webpack_require__("./shared/pipes/cut-string/cut-string.ts");
var boldPipe_1 = __webpack_require__("./shared/pipes/bold/boldPipe.ts");
var amountValidation_directive_1 = __webpack_require__("./web/modern/directives/AmountValidation/amountValidation.directive.ts");
var elemToScroll_directive_1 = __webpack_require__("./web/modern/directives/ElemToScroll/elemToScroll.directive.ts");
var sn_date_picker_validator_directive_1 = __webpack_require__("./web/modern/directives/sn-date-picker-validator/sn-date-picker-validator.directive.ts");
var sn_date_range_picker_directive_1 = __webpack_require__("./web/modern/components/common/sn-date-range-picker/sn-date-range-picker.directive.ts");
var spinning_wheel_1 = __webpack_require__("./shared/components/common/spinning-wheel/spinning-wheel.ts");
var modernComponents_1 = __webpack_require__("./web/modern/components/modernComponents.ts");
var pipes_module_1 = __webpack_require__("./shared/pipes/pipes.module.ts");
var services_module_1 = __webpack_require__("./web/modern/services/services.module.ts");
var appConstants_1 = __webpack_require__("./shared/models/appConstants.ts");
var twoFa_interceptor_1 = __webpack_require__("./web/modern/interceptors/twoFa.interceptor.ts");
var browserSessionToken_interceptor_1 = __webpack_require__("./web/modern/interceptors/browserSessionToken.interceptor.ts");
var webRequestsInterceptor_1 = __webpack_require__("./web/modern/interceptors/webRequestsInterceptor.ts");
var app_component_1 = __webpack_require__("./web/app.component.ts");
__webpack_require__("./shared/rxjs-operators.ts");
var blobError_interceptor_1 = __webpack_require__("./shared/interceptors/blobError.interceptor.ts");
var lead_source_color_1 = __webpack_require__("./shared/components/common/lead-source-color/lead-source-color.ts");
var directives_module_1 = __webpack_require__("./shared/directives/directives.module.ts");
// Please see NgSelectModule file for detailed description of why library is sitting inside the project, and not hosted by npm
var _ng_select_1 = __webpack_require__("./shared/libs/@ng-select/index.ts");
var ngx_pagination_1 = __webpack_require__("./node_modules/ngx-pagination/dist/ngx-pagination.js");
var systemNotification_interceptor_1 = __webpack_require__("./web/modern/interceptors/systemNotification.interceptor.ts");
var angular2_multiselect_dropdown_1 = __webpack_require__("./node_modules/angular2-multiselect-dropdown/index.js");
var pipes = [common_1.DatePipe, common_1.CurrencyPipe, common_1.DecimalPipe, time_filter_1.TimeFilterPipe, boldPipe_1.BoldPipeFilter, cut_string_1.CutStringFilterPipe];
var snDirectives = [amountValidation_directive_1.AmountValidationDirective, sn_date_picker_validator_directive_1.SnDatePickerValidatorDirective, sn_date_range_picker_directive_1.SnDateRangePickerDirective, spinning_wheel_1.SpinningWheelComponent, iframe_resizer_directive_1.IframeResizerDirective, elemToScroll_directive_1.ElemToScrollDirective];

var HybridUrlHandlingStrategy = function () {
    function HybridUrlHandlingStrategy() {
        _classCallCheck(this, HybridUrlHandlingStrategy);
    }

    _createClass(HybridUrlHandlingStrategy, [{
        key: "shouldProcessUrl",

        // use only process the `/bar` url
        value: function shouldProcessUrl(url) {
            return url.toString().startsWith('/bar');
        }
    }, {
        key: "extract",
        value: function extract(url) {
            return url;
        }
    }, {
        key: "merge",
        value: function merge(url, whole) {
            return url;
        }
    }]);

    return HybridUrlHandlingStrategy;
}();

var AppModule = function () {
    function AppModule() {
        _classCallCheck(this, AppModule);
    }

    _createClass(AppModule, [{
        key: "ngDoBootstrap",
        value: function ngDoBootstrap() {}
    }]);

    return AppModule;
}();
AppModule = __decorate([core_1.NgModule({
    imports: [common_1.CommonModule, platform_browser_1.BrowserModule, static_1.UpgradeModule, http_1.HttpClientModule, forms_1.FormsModule, pipes_module_1.PipesModule, directives_module_1.SharedDirectivesModule, mydatepicker_1.MyDatePickerModule, forms_1.ReactiveFormsModule, ng2_dragula_1.DragulaModule, ngx_daterangepicker_material_1.NgxDaterangepickerMd, angular2_text_mask_1.TextMaskModule, ng_bootstrap_1.NgbModalModule.forRoot(), ngx_quill_1.QuillModule.forRoot(), services_module_1.WebServicesModule.forRoot(), dropdown_1.BsDropdownModule.forRoot(), router_1.RouterModule.forRoot([], {}), ngx_clipboard_1.ClipboardModule, ngx_dropzone_1.NgxDropzoneModule, ngx_pagination_1.NgxPaginationModule, carousel_1.CarouselModule.forRoot(), angular2_multiselect_dropdown_1.AngularMultiSelectModule,
    // Please see NgSelectModule file for detailed description of why library is sitting inside the project, and not hosted by npm
    _ng_select_1.NgSelectModule
    // RouterModule.forRoot([], { initialNavigation: false }),
    ],
    providers: [].concat(pipes, [common_1.Location, ng_bootstrap_1.NgbActiveModal, { provide: common_1.LocationStrategy, useClass: common_1.PathLocationStrategy }, { provide: router_1.UrlHandlingStrategy, useClass: HybridUrlHandlingStrategy }, {
        provide: common_1.APP_BASE_HREF,
        useValue: appConstants_1.AppConstants.IS_PROD_BUILD || appConstants_1.AppConstants.IS_TEST_BUILD ? window['_app_base'] : '/'
    }, {
        provide: http_1.HTTP_INTERCEPTORS,
        useClass: webRequestsInterceptor_1.WebRequestsInterceptor,
        multi: true
    }, {
        provide: http_1.HTTP_INTERCEPTORS,
        useClass: browserSessionToken_interceptor_1.BrowserSessionTokenInterceptor,
        multi: true
    }, {
        provide: http_1.HTTP_INTERCEPTORS,
        useClass: systemNotification_interceptor_1.SystemNotificationInterceptor,
        multi: true
    }, {
        provide: http_1.HTTP_INTERCEPTORS,
        useClass: twoFa_interceptor_1.TwoFactorAuthorizationInterceptor,
        multi: true
    }, {
        provide: http_1.HTTP_INTERCEPTORS,
        useClass: blobError_interceptor_1.BlobErrorInterceptor,
        multi: true
    }, {
        provide: '$routeParams',
        useFactory: function useFactory($injector) {
            return $injector.get('$routeParams');
        },
        deps: ['$injector']
    }, {
        provide: '$rootScope',
        useFactory: function useFactory($injector) {
            return $injector.get('$rootScope');
        },
        deps: ['$injector']
    }]),
    declarations: [app_component_1.AppComponent, ngx_img_cropper_1.ImageCropperComponent].concat(snDirectives, _toConsumableArray(modernComponents_1.downgradedComponents)),
    entryComponents: [].concat(_toConsumableArray(modernComponents_1.downgradedComponents)),
    exports: [lead_source_color_1.LeadSourceColorComponent],
    bootstrap: [app_component_1.AppComponent]
})], AppModule);
exports.AppModule = AppModule;

/***/ }),

/***/ "./web/js/app.config.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Rx, __webpack_provided_window_dot_jQuery) {

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.appConfig = appConfig;

var _textAngular = __webpack_require__("./web/js/helper/textAngular.config.js");

var _routes = __webpack_require__("./web/js/helper/routes.ts");

var _rxjs = __webpack_require__("./node_modules/rxjs/Rx.js");

var _utils = __webpack_require__("./web/js/helper/utils.js");

appConfig.$inject = ['$routeProvider', '$httpProvider', '$locationProvider', '$provide', '$analyticsProvider', '$sceDelegateProvider'];

function appConfig($routeProvider, $httpProvider, $locationProvider, $provide, $analyticsProvider, $sceDelegateProvider) {
	$sceDelegateProvider.resourceUrlWhitelist(['self', window.baseURL + '/**']);

	for (var path in _routes.routes) {
		_routes.routes[path].resolve = {
			user: ['routeResolver', function (routeResolver) {
				return routeResolver.resolve();
			}]
		};

		if (_utils.noReloadControllers[_routes.routes[path].controller]) {
			_routes.routes[path].reloadOnSearch = false;
		}

		$routeProvider.when(path, _routes.routes[path]);
	}

	$routeProvider.otherwise({ redirectTo: '/' });
	$locationProvider.html5Mode({ enabled: true, requireBase: false });

	$httpProvider.defaults.withCredentials = true;

	$httpProvider.interceptors.push(['$q', '$location', '$injector', 'authTokensService', 'accountService', 'subscriptionDataService', function ($q, $location, $injector, authTokensService, accountService, subscriptionDataService) {
		return {
			request: function request(req) {
				var token = authTokensService.getAuthToken();
				return addToken(req, token);
			},
			responseError: function responseError(rejection) {
				var defer = $q.defer();

				if (rejection.status === 400) {
					handle400Error(rejection, defer);
				} else if (rejection.status === 401) {
					return handle401Error(rejection, defer);
				} else {
					defer.reject(rejection);
				}
				return defer.promise;
			}
		};

		function handle400Error(err, defer) {
			if (err && err.data && err.data.error_description && err.data.error_description.startsWith('Invalid refresh token')) {
				return logout();
			}
			return defer.reject(err);
		}

		function handle401Error(err, defer) {
			var isInvalidAccessToken = err && err.data && err.data.errorCode === 452;
			var isInvalidRefreshToken = err && err.data && err.data.errorCode === 450;
			var isSubscriptionExpired = err && err.data && err.data.errorCode === 210;
			var hasNoAccessToTheCompany = err && err.data && err.data.errorCode === 453;

			if (isInvalidRefreshToken) {
				return logout();
			}

			if (isInvalidAccessToken) {
				if (!authTokensService.isRefreshingInProcess()) {
					authTokensService.setRefreshingInProcess(true);
					authTokensService.emitTokenSubject(null);

					var refreshToken = authTokensService.getRefreshToken();
					if (!refreshToken) {
						return logout();
					}

					return accountService.getRefreshedAuthTokenWeb(refreshToken).switchMap(function (tokensData) {
						if (!tokensData) {
							return logout();
						}
						var refreshToken = authTokensService.successGetRefreshedToken(tokensData);
						return Rx.Observable.of(refreshToken);
					}).switchMap(function (authToken) {
						if (!authToken) {
							return logout();
						}
						authTokensService.emitTokenSubject(authToken);
						var $http = $injector.get('$http');
						return $http(addToken(err.config, authToken));
					}).toPromise().catch(function (err) {
						return defer.reject(err);
					}).finally(function () {
						authTokensService.setRefreshingInProcess(false);
					});
				}

				return authTokensService.tokenSubject.filter(function (authToken) {
					return authToken !== null;
				}).take(1).switchMap(function (authToken) {
					var $http = $injector.get('$http');
					return $http(addToken(err.config, authToken));
				});
			}

			if (isSubscriptionExpired) {
				return showPlans();
			}

			if (hasNoAccessToTheCompany) {
				$location.go('/');
				return _rxjs.Observable.empty();
			}
		}

		function handle403Error(defer) {
			if (!$location.path().includes('subscription')) {
				$location.path('/subscription');
				return defer.resolve(rejection);
			}
		}

		function addToken(req, token) {
			if (authTokensService.isToken(req.url, token)) {
				req.headers.Authorization = 'Bearer ' + token;
			}
			return req;
		}

		function logout() {
			return accountService.successLogoutWeb();
		}

		function showPlans() {
			subscriptionDataService.onSubscriptionExpired();
			return Rx.Observable.empty();
		}
	}]);

	(function ($) {
		$(document).ready(function () {
			var dropdownMenuClass = '.dropdown-menu',
			    DELAY = 400;

			$(document).on('show.bs.dropdown', '.dropdown.slide', function () {
				$(this).find(dropdownMenuClass).first().stop(true, true).slideDown(DELAY);
			});

			$(document).on('hide.bs.dropdown', '.dropdown.slide', function () {
				$(this).find(dropdownMenuClass).first().stop(true, true).slideUp(DELAY);
			});
		});
	})(__webpack_provided_window_dot_jQuery);

	$provide.decorator('$exceptionHandler', ['$delegate', '$injector', function ($delegate, $injector) {
		return function (exception, cause) {
			$delegate(exception, cause);
			console.error(exception, cause);

			var rScope = $injector.get('$rootScope');
			if (rScope) {
				rScope.crashedTextAngular = true;
			}
		};
	}]);

	$provide.decorator('taOptions', _textAngular.textAngularConfig);

	$analyticsProvider.virtualPageviews(false);
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/rxjs/Rx.js"), __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./web/js/app.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.isModuleMissed = undefined;

__webpack_require__("./web/scss/vendors.scss");

__webpack_require__("./web/scss/main.scss");

var _appConfig = __webpack_require__("./web/js/app.config.js");

var _appRun = __webpack_require__("./web/js/app.run.js");

var modules = ['ngRoute', 'textAngular', 'ui.bootstrap', 'ngCookies', 'dndLists', 'colorpicker.module', 'ngPatternRestrict', 'ngIntercom'];
var analyticsModules = ['angulartics', 'angulartics.google.tagmanager', 'angulartics.google.analytics'];

var requires = [];

var isModuleMissed = exports.isModuleMissed = false;

var isIE = navigator.userAgent.indexOf('MSIE ') > -1 || navigator.userAgent.indexOf('Trident/') > -1;
var safariVersion = getSafariVersion();
var isNotSupportedBrowser = safariVersion < 9 || !Modernizr.flexbox || !Modernizr.sizes;

if (!isNotSupportedBrowser && !isIE) {
	analyticsModules.forEach(checkIfModuleAvaible);

	angular.module('main', getRequiresArray()).config(_appConfig.appConfig).run(_appRun.appRunSettings);
} else {
	showUnsupportedBrowserPage();
}

function showUnsupportedBrowserPage() {
	angular.module('unsupportedBrowser', []).controller('UnsupportedBrowserController', ['$scope', UnsupportedBrowserController]).component('snApp', {
		template: '\n        <section ng-hide="isIE9" class="unsupported-browser bg-white">\n    <div class="container">\n        <div class="row flex-row flex-just-center">\n            <div class="col-xs-12 col-sm-10 col-lg-9 flex-row flex-wrap-xs unsupported-browser__box">\n                <div class="ps-15 unsupported-browser__image">\n                    <img src="https://app.studioninja.co/build/release-pipeline-119/resources/dist/assets/images/non_supported_browser.png">\n                </div>\n                <p class="ps-15">Sorry, your browser is not supported. For a better experience, please view this link in the latest version of <a href="https://www.google.com/chrome/browser/desktop/index.html">Chrome</a>, <a href="https://www.mozilla.org/en-US/firefox/new/"\n                >Firefox</a> or <a href="https://support.apple.com/downloads/safari">Safari</a>.</p>\n            </div>\n        </div>\n    </div>\n</section>\n      ',
		controllerAs: 'vm',
		controller: UnsupportedBrowserController
	});

	angular.element(document).ready(function () {
		angular.bootstrap(document.body, ['unsupportedBrowser']);
	});
}

function getSafariVersion() {
	var ua = navigator.userAgent;
	var tem = ua.match(/version\/(\d+)/i);
	var M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
	if (M[2]) {
		M = [M[1], M[2]];
	} else {
		M = [navigator.appName, navigator.appVersion, '-?'];
	}
	if (tem != null) {
		M.splice(1, 1, tem[1]);
	}
	if (M[0] === 'Safari') {
		return parseInt(M[1]);
	}
	return 1000;
}

function checkIfModuleAvaible(moduleName) {
	try {
		angular.module(moduleName);
		requires.push(moduleName);
	} catch (error) {
		exports.isModuleMissed = isModuleMissed = true;
	}
}

function getRequiresArray() {
	return modules.concat(requires);
}

function UnsupportedBrowserController($scope) {
	$scope.adBlockEnabled = false;

	var msie = navigator.userAgent.indexOf('MSIE ');
	if (msie > 0) {
		$scope.isIE9 = parseInt(navigator.userAgent.substring(msie + 5, navigator.userAgent.indexOf('.', msie))) === 9;
	}
}

/***/ }),

/***/ "./web/js/app.run.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Dropzone, pace, moment, toastr, $) {

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.appRunSettings = appRunSettings;

var _app = __webpack_require__("./web/js/app.js");

appRunSettings.$inject = ['$rootScope', '$location', '$http', '$route', '$cookies', 'accountService', '$timeout', 'randomStringGenerator', '$analytics', 'settingsService', 'workflowService'];

function appRunSettings($rootScope, $location, $http, $route, $cookies, accountService, $timeout, randomStringGenerator, $analytics, settingsService, workflowService) {
	/* supports only latest version of Chrome, FF, Edge and Safari on Mac */
	var isNotSupportedBrowser = !Modernizr.flexbox || !Modernizr.sizes; /* to filter latest browsers */
	var isIE = !!document.documentMode; /* to filter IE 10++ */

	if (isNotSupportedBrowser && isIE) {
		return $location.path('/unsupported_browser');
	} else if (isAdBlockEnabled() && _app.isModuleMissed) {
		$rootScope.adBlockEnabled = true;
	}

	var dateformat = void 0;
	var datetimepickerFormat = void 0;
	var weekStartsOn = void 0;

	Dropzone.autoDiscover = false;
	// enable loading indicator
	pace.start();

	$http.defaults.headers.common.UserTimezone = moment.tz.guess();

	$rootScope.baseApiUrl = window.baseApiHost;

	setupCommunicationAdapter();

	webshims.setOptions('forms-ext', {
		waitReady: false,
		loadStyles: false,
		extendNative: true,
		replaceUI: true,
		number: {
			calculateWidth: false
		},
		widgets: {
			startView: 0,
			minView: 0,
			inlinePicker: false,
			size: 1,
			noChangeDismiss: false,
			openOnFocus: true,
			buttonOnly: false,
			classes: '',
			popover: {
				appendTo: 'element'
			},
			calculateWidth: true,
			animate: true,
			toFixed: 0,
			onlyFixFloat: false
		}
	});

	webshims.formcfg.en.dFormat = '/';
	webshims.formcfg.en.dateSigns = '/';
	webshims.formcfg.en.patterns.t = 'HH:mm a';
	webshims.formcfg.de = angular.copy(webshims.formcfg.en);
	webshims.formcfg.fr = angular.copy(webshims.formcfg.en);

	webshims.formcfg.de.date.dayNamesMin = ['Fr', 'Th', 'We', 'Tu', 'Mo', 'Su', 'Sa'];
	webshims.formcfg.de.date.dayNames = ['Friday', 'Thursday', 'Wednesday', 'Tuesday', 'Monday', 'Sunday', 'Saturday'];

	webshims.formcfg.en.patterns.d = 'dd/mm/yy';
	webshims.formcfg.fr.patterns.d = 'mm/dd/yy';

	settingsService.timeFormatSettings.subscribe(function (data) {
		dateformat = data.dateFormat;
		datetimepickerFormat = dateformat === 'DD_MM_YYYY' ? 'en' : 'fr';

		switch (data.weekStartsOn) {
			case 'SATURDAY':
				weekStartsOn = 6;
				datetimepickerFormat = 'de';
				break;
			case 'SUNDAY':
				weekStartsOn = 0;
				break;
			case 'MONDAY':
				weekStartsOn = 1;
				break;
			default:
				break;
		}

		webshims.formcfg.en.date.firstDay = weekStartsOn;
		webshims.formcfg.fr.date.firstDay = weekStartsOn;
		webshims.formcfg.de.date.firstDay = weekStartsOn;
		webshims.formcfg.de.patterns.d = dateformat === 'DD_MM_YYYY' ? 'dd/mm/yy' : 'mm/dd/yy';

		webshims.activeLang(datetimepickerFormat);
		webshims.polyfill('forms-ext');
	});

	toastr.options = {
		iconClasses: {
			error: 'toast-warning toast-error',
			warning: 'toast-warning toast-warning-custom',
			success: 'toast-success',
			info: 'toast-info'
		},
		closeButton: true,
		debug: false,
		newestOnTop: false,
		progressBar: true,
		positionClass: 'toast-top-right',
		preventDuplicates: true,
		onclick: null,
		showDuration: '3000',
		hideDuration: '1000',
		timeOut: '5000',
		extendedTimeOut: '1000',
		showEasing: 'swing',
		hideEasing: 'linear',
		showMethod: 'fadeIn',
		hideMethod: 'fadeOut',
		escapeHtml: true
	};

	accountService.emitShowHeader(true);
	$rootScope.showLogo = true;
	$rootScope.$back = function () {
		window.history.back();
	};

	accountService.userLoginActionObservable.filter(function (data) {
		return !!data;
	}).subscribe(function () {
		$rootScope.removeBg = 'white-background';
		$location.path('/');
	});

	//  Changing angular-text default styling

	var trimVariablesDomain = function trimVariablesDomain(href) {
		var linkVariables = ['%contract_link%', '%invoice_link%', '%quote_link%', '%questionnaire_link%', '%galleries_link%'];
		var link = href || '';

		linkVariables.forEach(function (linkVar) {
			var startIndex = link.indexOf(linkVar);
			if (startIndex !== -1) {
				link = link.slice(startIndex, startIndex + linkVar.length);
			}
		});

		return link;
	};

	var mailStyling = function mailStyling(id) {
		var allTags = $(id).find('*');
		var styleObj = {
			P: 'margin-top:0; margin-left: 0; margin-right: 0; margin-bottom: 2px;',
			LI: 'list-style-position: inside;',
			SPAN: 'padding:0;',
			DIV: 'margin:0;',
			BLOCKQUOTE: 'margin: 0 0 0 0.8ex; border-left: 1px #ccc solid; padding-left: 1ex;'
		};
		var i = 0,
		    max = allTags.length;
		for (; i < max; i += 1) {
			var thisTag = allTags.eq(i);
			if (thisTag.prop('tagName') === 'IMG') {
				thisTag.removeAttr('height');
				thisTag.attr('alt', '');
				if (thisTag.attr('style') && thisTag.attr('style').includes('float')) {
					thisTag.attr('align', thisTag.css('float'));
				}
				if (thisTag.attr('style')) {
					thisTag.attr('style', thisTag.attr('style') + 'margin: 0;');
				}
				continue;
			}
			if (thisTag.prop('tagName') === 'A') {
				thisTag.attr('href', trimVariablesDomain(thisTag.attr('href')));
			}
			var tagInlineStyle = thisTag.attr('style') || '';
			var tagStyle = '';
			var textAlign = thisTag.css('text-align') || '';
			var color = thisTag.css('color') || '';
			var fontSize = thisTag.css('font-size') || '';
			var fontFamily = thisTag.css('font-family') || '';
			if (textAlign && tagInlineStyle && tagInlineStyle.includes('text-align')) {
				tagStyle += 'text-align:' + textAlign + ';';
			}
			if (color && tagInlineStyle && tagInlineStyle.includes('color')) {
				tagStyle += 'color:' + color + ';';
			}
			if (fontSize && tagInlineStyle && tagInlineStyle.includes('font-size')) {
				tagStyle += 'font-size:' + fontSize + '!important;font-size:' + fontSize + ';';
			} else {
				var tag = thisTag.prop('tagName');
				if (tag !== 'EM' && tag !== 'U') {
					tagStyle += 'font-size:14px!important;font-size:14px;';
				}
			}
			if (fontFamily && tagInlineStyle && tagInlineStyle.includes('font-family')) {
				tagStyle += 'font-family:' + fontFamily + ';';
			}

			var thatTag = thisTag.prop('tagName');
			tagStyle += styleObj[thatTag] || '';

			if (tagStyle) {
				thisTag.attr('style', tagStyle);
			}
			thisTag.contents().filter(function () {
				return this.nodeType == 3;
			}).each(function () {
				this.textContent = this.textContent.replace(/([^;])&nbsp;([^&])/g, function (match, p1, p2) {
					return p1 + ' ' + p2;
				});
				this.textContent = this.textContent.replace(/^( {1,})/g, function (match, p1) {
					return new Array(p1.length + 1).join('\xA0');
				});
				this.textContent = this.textContent.replace(/( {2,})/g, function (match, p1) {
					return new Array(p1.length + 1).join('\xA0');
				});
			});
		}
	};

	$rootScope.addMaiStyling = function (emailText) {
		var emptyParagraph = '<p></p>';

		if (!emailText) {
			return emailText || '';
		}

		if (emailText === emptyParagraph) {
			return '';
		}

		var tmpId = 'emailText_styling_' + randomStringGenerator.getMixedString(9);
		var $tmpId = '#' + tmpId;

		$(document.body).append('<div id="' + tmpId + '" class="hide"></div>');
		$($tmpId).append(emailText);

		mailStyling($tmpId);

		var message = $($tmpId).html();
		$($tmpId).remove();

		return message;
	};

	$rootScope.verifyNotes = function (emailText) {
		var emptyParagraph = '<p></p>';
		if (!emailText) {
			return '';
		}

		if (emailText === emptyParagraph) {
			return '';
		}

		return emailText;
	};

	$rootScope.setTimeZoneInCookie = function () {
		var _myDate = new Date();
		var _offset = _myDate.getTimezoneOffset();

		$cookies.put('TIMEZONE_COOKIE', _offset);
	};

	$rootScope.setTimeZoneInCookie();

	$rootScope.dateLongPattern = 'dd MMMM yyyy';

	var removeViewContentLoadedListener = $rootScope.$on('$viewContentLoaded', function () {
		workflowService.setLabelsToTaskDateSequence();

		var $modals = $('.modal-backdrop.fade.in');

		document.body.classList.remove('modal-open');
		document.body.style.paddingRight = '';

		$modals.hide();
		$modals.removeClass('in');
		delete $rootScope.error;
	});

	var removeRouteChangeSuccessListener = $rootScope.$on('$routeChangeSuccess', function (event, currentRoute) {
		if (currentRoute.title && $rootScope.gotoPage) {
			if (currentRoute.title.includes('Dashboard')) {
				$location.path($rootScope.gotoPage);
			}

			delete $rootScope.gotoPage;
		}

		document.title = currentRoute.title ? 'Studio Ninja ' + currentRoute.title : 'Studio Ninja ';

		// to prevent showing title of previous page
		setTimeout(function () {
			window.scrollTo(0, 0);
			$analytics.pageTrack($location.path());
		}, 0);
		Intercom('update');
	});

	var removeRouteChangeStartListener = $rootScope.$on('$routeChangeStart', function () {
		window.scrollTo(0, 0);
		if (isAdBlockEnabled() && _app.isModuleMissed) {
			$rootScope.adBlockEnabled = true;
		}
	});

	$rootScope.$on('$destroy', function () {
		removeRouteChangeStartListener();
		removeRouteChangeSuccessListener();
		removeViewContentLoadedListener();
	});

	$rootScope.getClass = function (path) {
		var locationPath = $location.path();

		if (locationPath.includes('/invoices')) {
			locationPath = '/payments';
		}

		if (path === '/') {
			if (locationPath.substring(0, location.protocol.length + location.host.length) === path) {
				return 'selected-menu';
			}
			return 'not-selected-menu';
		}
		if (locationPath.includes(path)) {
			return 'selected-menu';
		}
		return 'not-selected-menu';
	};

	$rootScope.sidebarClick = function () {
		$rootScope.showmen = !$rootScope.showmen;
	};

	$rootScope.closeSandwich = function () {
		$rootScope.showmen = !$rootScope.showmen;
	};

	$rootScope.getSettingsClass = function (path) {
		if ($location.path().indexOf(path) > -1) {
			return 'nav-item-active';
		}
		return 'nav-item-nonactive';
	};

	function isAdBlockEnabled() {
		var isAdBlockEnabled = false;

		var test = document.createElement('div');
		test.innerHTML = '&nbsp;';
		test.className = 'adsbox';
		document.body.appendChild(test);

		if (test.offsetHeight === 0) {
			isAdBlockEnabled = true;
		}

		test.remove();

		return isAdBlockEnabled;
	}

	// change path without reloading
	var original = $location.path;
	$location.path = function (path, reload) {
		if (reload === false) {
			var lastRoute = $route.current;
			var un = $rootScope.$on('$locationChangeSuccess', function () {
				$route.current = lastRoute;
				un();
			});
		}
		return original.apply($location, [path]);
	};

	function setupCommunicationAdapter() {
		function CommunicationAdapterBlueprint() {
			this._registry = [];

			this.registerMethod = function (name, method) {
				var index = this._registry.findIndex(function (element) {
					return element.name === name;
				});

				if (index > -1) {
					this._registry[index].method = method;
				} else {
					this._registry.push({ name: name, method: method });
				}
			};

			this.callMethod = function (name) {
				var found = this._registry.find(function (element) {
					return name === element.name;
				});

				if (found) {
					for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
						args[_key - 1] = arguments[_key];
					}

					if (args.length === 0) {
						found.method();
					} else {
						found.method.apply(found, args);
					}
				}
			};
		}

		window.snCommunicationAdapter = new CommunicationAdapterBlueprint();
	}

	$rootScope.drawBuildVersionLabel = function (buildVersionElement) {
		var buildVersionLabel = window.buildVersionLabel;

		if (buildVersionLabel && buildVersionLabel !== '') {
			document.getElementById(buildVersionElement).innerHTML = buildVersionLabel;
		}
	};
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/dropzone/dist/dropzone.js"), __webpack_require__("./node_modules/pace-js/pace.js"), __webpack_require__("./node_modules/moment/moment.js"), __webpack_require__("./node_modules/toastr/toastr.js"), __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./web/js/components/Buttons/btnAddNewJobElement.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
	angular.module('main').directive('btnAddNewJobElement', btnAddNewJobElement);

	function btnAddNewJobElement() {
		return {
			restrict: 'E',
			scope: {
				add: '&',
				icon: '@',
				imgSrc: '@',
				title: '@',
				description: '@',
				disableComponent: '='
			},
			template: '<div class="add-new-item" ng-click="onButtonClicked($event)" ng-class="{\'add-new-item-disabled\': disableComponent }">\n                        <i class="{{icon}} mr-18" ng-if="icon"></i>\n                        <img ng-src="{{imgSrc}}" class="add-new-pic mr-18" ng-if="imgSrc">\n                        <div>\n                            <h2 class="an-item-title">{{title}}</h2>\n                            <div class="an-item-description">{{description}}</div>\n                        </div>\n                    </div>\n',
			replace: true,
			transclude: true,
			link: function link(scope) {
				scope.isDisabled = false;

				scope.onButtonClicked = function (event) {
					if (!scope.isDisabled) {
						scope.add({ event: event });
					}
				};

				scope.$on('spBrandsRequest', function (event, data) {
					scope.isDisabled = data;
				});
			}
		};
	}
})();

/***/ }),

/***/ "./web/js/components/Buttons/btnAddSignature.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
	angular.module('main').directive('btnAddSignature', btnAddSignature);

	function btnAddSignature() {
		return {
			restrict: 'E',
			scope: {
				title: '@'
			},
			template: '\n                <button class="btn-lg btn btn-default add-signature-btn">\n                    <i class="fa fa-plus" aria-hidden="true"></i>{{title}}\n                </button>\n',
			replace: true,
			transclude: true,
			link: function link(scope) {}
		};
	}
})();

/***/ }),

/***/ "./web/js/components/Buttons/btnClose.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('main').directive('btnClose', function () {
	return {
		restrict: 'AE',
		scope: {},
		template: '<button type="button" class="close" data-dismiss="modal" aria-hidden="true" data-autotest-button="close">&times;</button>',
		replace: true,
		transclude: true
	};
});

/***/ }),

/***/ "./web/js/components/Buttons/btnCopyToQuickbooks.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('main').directive('btnCopyToQuickbooks', btnCopyToQuickbooks);
btnCopyToQuickbooks.$inject = ['integrationsDataService', 'messageService', '$route', '$timeout'];

function btnCopyToQuickbooks(integrationsDataService, messageService, $route, $timeout) {
	return {
		restrict: 'E',
		scope: {
			invoiceId: '<',
			invoiceDisplayId: '<',
			successGetInvoiceInformation: '&',
			reloadPage: '&'
		},
		template: '<button ng-disabled="isBtnDisabled" type="button" class="btn btn-default" ng-click="copyToQuickbooks(invoiceId)">\n                            <i class="fi fa fa-files-o"></i>Copy to Quickbooks\n                       </button>',
		replace: true,
		transclude: true,
		link: function link(scope) {
			scope.isBtnDisabled = false;

			scope.copyToQuickbooks = function (id) {
				scope.isBtnDisabled = true;

				integrationsDataService.copyInvoiceToQuickbooks(id).finally(function () {
					return scope.isBtnDisabled = false;
				}).subscribe(function (data) {
					return successCopyToQuickbooks(data);
				}, function (result) {
					return errorCopyToQuickbooks(result);
				});
			};

			function successCopyToQuickbooks(data) {
				var result = { data: data };
				scope.successGetInvoiceInformation({ result: result });
				messageService.showToaster('s_0', 'qb');
				$timeout($route.reload(), 300);
			}

			function errorCopyToQuickbooks(error) {
				var data = error.data,
				    status = error.status;

				var errorMessage = data.errorMessage;
				var errorTitle = error.error.errorTitle;
				var errorCode = void 0,
				    errorPlace = void 0,
				    value = void 0;
				if (errorMessage && status >= 400 && status < 500) {
					switch (errorMessage) {
						case "QuickBooks doesn't allow Inclusive tax for US users":
							errorCode = 'e_3';
							errorPlace = 'qb';
							break;
						case 'Invoice with written off payments is not compatible with QuickBooks':
							errorCode = 'e_7';
							errorPlace = 'qb';
							break;
						case 'Sorry, FR QuickBooks companies are not supported yet':
							errorCode = 'e_8';
							errorPlace = 'qb';
							break;
						case 'Invoice with such ID already exists on QuickBooks':
							errorCode = 'e_1';
							errorPlace = 'qb';
							value = scope.invoiceDisplayId;
							break;
						case 'Invoice with written off payments is not compatible with Xero':
							errorCode = 'e_7';
							errorPlace = 'xero';
							break;
						case 'Invoice has been deleted deleted on QuickBooks':
							errorCode = 'e_17';
							errorPlace = 'qb';
							break;
						case errorMessage.includes('One of the list elements assigned to this transaction has been deleted'):
							errorCode = 'e_11';
							errorPlace = 'qb';
							break;
						case errorMessage.includes('Try reselecting the tax rate or reentering the product/service item and saving the form again.'):
							errorCode = 'e_19';
							errorPlace = 'qb';
							break;
						case 'Invoice should have the same tax type for all products':
							errorCode = 'e_0';
							errorPlace = 'qb';
							break;
						case "StudioNinja doesn't support transactions with Credit Notes from QuickBooks":
							errorCode = 'e_14';
							errorPlace = 'qb';
							break;

						case 'QB: Impossible to create invoice with Product "Bundle", such item exists on QuickBooks':
							errorCode = 'e_25';
							errorPlace = 'qb';
							break;

						case 'Invoice id length is more than 20':
							errorCode = 'e_27';
							errorPlace = 'qb';
							break;
						case 'Invoice name length is more than 100':
							errorCode = 'e_26';
							errorPlace = 'qb';
							break;
						case errorMessage.includes('QuickBooks: Email Address does not conform to the syntax rules of RFC 822.'):
							errorCode = 'e_18';
							errorPlace = 'qb';
							break;
						case 'Invoice description length is more than 4000':
							errorCode = 'e_28';
							errorPlace = 'qb';
							break;
						default:
							if (errorTitle && errorTitle !== null && errorMessage && errorMessage !== null) {
								messageService.showErrorFromBackend(errorTitle, errorMessage);
							} else {
								messageService.showErrorFromBackend('Slow down, Quickbooks error!');
							}
							return;
					}
				} else {
					errorCode = 'e_0';
					errorPlace = 'general';
				}
				messageService.showToaster(errorCode, errorPlace, value);
			}
		}
	};
}

/***/ }),

/***/ "./web/js/components/Buttons/btnCopyToXero.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('main').directive('btnCopyToXero', btnCopyToXero);
btnCopyToXero.$inject = ['integrationsDataService', 'messageService', 'invoiceService', '$route', '$timeout'];

function btnCopyToXero(integrationsDataService, messageService, invoiceService, $route, $timeout) {
	return {
		restrict: 'E',
		scope: {
			invoiceData: '<',
			invoiceId: '<',
			invoiceDisplayId: '<',
			successGetInvoiceInformation: '&'
		},
		template: '<button ng-disabled="isBtnDisabled" type="button" class="btn btn-default" ng-click="copyToXero(invoiceId)">\n                            <i class="fi fa fa-files-o"></i>Copy to Xero\n                       </button>',
		replace: true,
		transclude: true,
		link: function link(scope) {
			scope.isBtnDisabled = false;

			scope.copyToXero = function (id) {
				scope.isBtnDisabled = true;

				if (!isInvoiceValid(scope.invoiceData)) {
					integrationsDataService.copyInvoiceToXero(id).finally(function () {
						return scope.isBtnDisabled = false;
					}).subscribe(function (data) {
						return successCopyToXero(data);
					}, function (error) {
						return errorCopyToXero(error);
					});
				} else {
					scope.isBtnDisabled = false;
				}
			};

			function successCopyToXero(data) {
				var result = { data: data };
				scope.successGetInvoiceInformation({ result: result });
				messageService.showToaster('s_1', 'xero');
				$timeout($route.reload(), 300);
			}

			function errorCopyToXero(_ref) {
				var data = _ref.data,
				    status = _ref.status;

				var errorMessage = data ? data.errorMessage : null;
				var errorCode = void 0,
				    errorPlace = void 0,
				    value = void 0;
				if (errorMessage && status >= 400 && status < 500) {
					switch (errorMessage) {
						case "Paid or partially paid invoice can't be updated on Xero":
							errorCode = 'e_5';
							errorPlace = 'xero';
							break;
						case 'Invoice with such invoice ID (Invoice Number) exists on Xero':
							errorCode = 'e_6';
							errorPlace = 'xero';
							value = scope.invoiceDisplayId;
							break;
						case 'Product/Package tax type is not compatible with Xero':
							errorCode = 'e_4';
							errorPlace = 'xero';
							break;
						case 'Fixed discount is not compatible with Xero':
							errorCode = 'e_1';
							errorPlace = 'xero';
							break;
						case 'Invoice is Voided or Deleted on Xero':
							errorCode = 'e_3';
							errorPlace = 'xero';
							break;
						case 'Invoice with written off payments is not compatible with Xero':
							errorCode = 'e_7';
							errorPlace = 'xero';
							break;
						case 'Xero access token expired, reconnect Xero please':
							errorCode = 'e_14';
							errorPlace = 'xero';
							break;
						case 'Bummer! Xero access token not authorized or revoked, reconnect Xero please':
							errorCode = 'e_14';
							errorPlace = 'xero';
							break;
						case 'Bummer! Xero access token revoked, reconnect Xero please':
							errorCode = 'e_14';
							errorPlace = 'xero';
							break;
						case "Bummer! You don't have an active Xero subscription.":
							errorCode = 'e_15';
							errorPlace = 'xero';
							break;
						default:
							errorCode = 'e_2';
							errorPlace = 'general';
							value = errorMessage;
					}
				} else {
					errorCode = 'e_0';
					errorPlace = 'general';
				}
				messageService.showToaster(errorCode, errorPlace, value);
			}

			function isInvoiceValid(invoice) {
				var dataToValidate = {
					amount: invoice.invoiceSummary.amount,
					packages: invoice.invoiceSummary.productPackageSummaries,
					payments: invoice.payments,
					discount: invoice.discount,
					discountType: invoice.discountType.value,
					xeroStatus: invoice.xeroStatus,
					qbStatus: invoice.qbStatus,
					totalDue: invoice.invoiceSummary.totalDue,
					pageName: 'invoicePage'
				};

				return dataToValidate.packages.some(function (packages) {
					return invoiceService.isInvalidProduct(packages.productPackageDTO, dataToValidate.pageName);
				});
			}
		}
	};
}

/***/ }),

/***/ "./web/js/components/Buttons/btnDelete.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('main').directive('btnDelete', function () {
	return {
		restrict: 'AE',
		scope: {
			text: '@snText',
			snEmpty: '@'
		},
		template: ' <button class="btn btn-default">\n                        <i class="fa fa-trash-o" ng-if="snEmpty"></i>\n                        <i class="fi fa fa-trash-o" ng-if="!snEmpty"></i>\n                        {{text}}\n                    </button>',
		replace: true,
		transclude: true
	};
});

/***/ }),

/***/ "./web/js/components/Buttons/btnDeleteJob.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by sombra.mac5 on 12/5/16.
 */
angular.module('main').directive('btnDeleteJob', function () {
	return {
		restrict: 'AE',
		scope: {
			text: '@snText'
		},
		template: '<button class="btn btn-default"><img src="https://app.studioninja.co/build/release-pipeline-119/resources/dist/assets/images/icons/job-delete.png" class="fi fi-jobDelete"/>{{text}}</button>',
		replace: true,
		transclude: true
	};
});

/***/ }),

/***/ "./web/js/components/Buttons/btnEdit.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('main').directive('btnEdit', function () {
	return {
		restrict: 'AE',
		scope: {
			text: '@snText',
			snEmpty: '@',
			isLink: '@',
			linkHref: '@'
		},
		template: function template(el, attr) {
			var template = '';

			if (attr.isLink === 'true' && attr.linkHref) {
				template = '<a ng-href="{{linkHref}}" class="btn btn-default">\n                                <i class="fi fi-edit pr-0" ng-if="snEmpty"></i>\n                                <i class="fi fi-edit" ng-if="!snEmpty"></i>\n                                 {{text}}\n                            </a>';
			} else {
				template = '<button class="btn btn-default">\n                            <i class="fi fi-edit pr-0" ng-if="snEmpty"></i>\n                            <i class="fi fi-edit" ng-if="!snEmpty"></i>\n                             {{text}}\n                        </button>';
			}

			return template;
		},

		replace: true,
		transclude: true,
		link: function link(scope) {
			scope.text = scope.text || 'Edit';
			if (scope.snEmpty) {
				scope.text = '';
			}
		}
	};
});

/***/ }),

/***/ "./web/js/components/Buttons/btnLgBlock.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('main').directive('btnLgBlock', function () {
	return {
		restrict: 'E',
		scope: {
			text: '@snText',
			color: '@snColor'
		},
		template: ' <button class="btn btn-lg btn-block btn-{{color}}">\n                        {{text}}\n                    </button>',
		replace: true,
		transclude: true
	};
});

/***/ }),

/***/ "./web/js/components/Buttons/btnPrint.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('main').directive('btnPrint', function () {
	return {
		restrict: 'AE',
		scope: {},
		template: '<button type="button" class="btn btn-default" ng-click="print()"><i class="fi fi-print"></i>Print</button>',
		replace: true,
		transclude: true,
		link: function link(scope) {
			var printClass = 'print-page';

			var beforePrint = function beforePrint() {
				if (document.body.classList.contains(printClass)) {
					return false;
				}
				document.body.classList.add(printClass);
			};
			var afterPrint = function afterPrint() {
				document.body.classList.remove(printClass);
			};

			if (window.matchMedia) {
				var mediaQueryList = window.matchMedia('print');
				mediaQueryList.addListener(function (mql) {
					mql.matches ? beforePrint() : afterPrint();
				});
			}

			window.onbeforeprint = beforePrint;
			window.onafterprint = afterPrint;

			scope.print = function () {
				document.body.classList.add(printClass);
				window.print();
			};
		}
	};
});

/***/ }),

/***/ "./web/js/components/Buttons/btnSend.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('main').directive('btnSend', function () {
	return {
		restrict: 'AE',
		scope: {
			text: '@snText'
		},
		template: '<button class="btn btn-default"><i class="fi fi-send"></i>{{text}}</button>',
		replace: true,
		transclude: true,
		link: function link(scope) {
			scope.text = scope.text || 'Send';
		}
	};
});

/***/ }),

/***/ "./web/js/components/Buttons/btnSendEmail.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by sombra.mac5 on 12/5/16.
 */
angular.module('main').directive('btnSendEmail', function () {
	return {
		restrict: 'AE',
		scope: {
			text: '@snText'
		},
		template: '<button class="btn btn-default"><img src="https://app.studioninja.co/build/release-pipeline-119/resources/dist/assets/images/icons/job-email.png" class="fi fi-jobEmail"/>{{text}}</button>',
		replace: true,
		transclude: true,
		link: function link(scope) {
			scope.text = scope.text || 'Send email';
		}
	};
});

/***/ }),

/***/ "./web/js/components/Buttons/btnUrl.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('main').directive('btnUrl', function () {
	return {
		restrict: 'AE',
		scope: {
			text: '@snText'
		},
		template: '<button class="btn btn-default"><i class="fi fa fa-link"></i>{{text}}</button>',
		replace: true,
		transclude: true,
		link: function link(scope) {
			scope.text = scope.text || 'Get URL';
		}
	};
});

/***/ }),

/***/ "./web/js/components/Buttons/btnView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('main').directive('btnView', function () {
	return {
		restrict: 'AE',
		scope: {
			text: '@snText',
			isLink: '@',
			linkHref: '@',
			target: '@',
			classes: '@customClasses'
		},
		template: function template(elem, attr) {
			var template = '';
			window.attr = attr;

			if (attr.isLink === 'true' && attr.linkHref) {
				template = attr.target ? '<a ng-href="{{linkHref}}" target="{{target}}" class="btn btn-default" ng-class="classes"><i class="fi fi-view"></i>{{text}}</a>' : '<a ng-href="{{linkHref}}" class="btn btn-default" ng-class="classes"><i class="fi fi-view"></i>{{text}}</a>';
			} else {
				template = attr.target ? '<a ng-href="{{linkHref}}" target="{{target}}" class="btn btn-default" ng-class="classes"><i class="fi fi-view"></i>{{text}}</a>' : '<a ng-href="{{linkHref}}" class="btn btn-default" ng-class="classes"><i class="fi fi-view"></i>{{text}}</a>';
			}

			return template;
		},

		replace: true,
		transclude: true,
		link: function link(scope) {
			scope.text = scope.text || 'View';
		}
	};
});

/***/ }),

/***/ "./web/js/components/Elements/angularGoogleAutocomplete.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A directive for adding google places autocomplete to a text box
 * google places autocomplete info: https://developers.google.com/maps/documentation/javascript/places
 *
 * Usage:
 *
 * + ng-model - autocomplete textbox value
 *
 * + details - more detailed autocomplete result, includes address parts, latlng, etc. (Optional)
 *
 * + options - configuration for the autocomplete (Optional)
 *
 *       + types: type,        String, values can be 'geocode', 'establishment', '(regions)', or '(cities)'
 *       + bounds: bounds,     Google maps LatLngBounds Object, biases results to bounds, but may return results outside these bounds
 *       + country: country    String, ISO 3166-1 Alpha-2 compatible country code. examples; 'ca', 'us', 'gb'
 *       + watchEnter:         Boolean, true; on Enter select top autocomplete result. false(default); enter ends autocomplete
 *
 * example:
 *
 *    options = {
 *        types: '(cities)',
 *        country: 'ca'
 *    }
 * */

angular.module('main').directive('ngAutocomplete', function () {
	return {
		require: 'ngModel',
		scope: {
			ngModel: '=',
			options: '=?',
			details: '=?'
		},

		link: function link(scope, element, attrs, controller) {
			var opts = void 0;
			var watchEnter = true;
			var foundLocation = '';

			// function to get retrieve the autocompletes first result using the AutocompleteService
			var getPlace = function getPlace(result) {
				var autocompleteService = new google.maps.places.AutocompleteService();
				if (result.name.length > 0) {
					autocompleteService.getPlacePredictions({
						input: result.name,
						offset: result.name.length
					}, function (list, status) {
						if (list === null || list.length === 0) {
							scope.$apply(function () {
								scope.details = null;
							});
						} else {
							var placesService = new google.maps.places.PlacesService(element[0]);

							placesService.getDetails({
								reference: list[0].reference,
								fields: ['formatted_address', 'name']
							}, function (detailsResult, placesServiceStatus) {
								if (placesServiceStatus === google.maps.GeocoderStatus.OK) {
									scope.$apply(function () {
										var formattedAddress = void 0;
										if (detailsResult.formatted_address.includes(detailsResult.name)) {
											formattedAddress = detailsResult.formatted_address;
										} else {
											formattedAddress = detailsResult.name + ', ' + detailsResult.formatted_address;
										}

										controller.$setViewValue(formattedAddress);

										element.val(formattedAddress);

										scope.details = detailsResult;

										// on focusout the value reverts, need to set it again.
										var watchFocusOut = element.on('focusout', function (event) {
											element.val(formattedAddress);
											element.unbind('focusout');
										});
									});
								}
							});
						}
					});
				}
			};

			var initOpts = function initOpts() {
				opts = {};
				if (scope.options) {
					if (scope.options.foundLocation) {
						foundLocation = scope.options.foundLocation;
					} else {
						foundLocation = '';
					}

					watchEnter = scope.options.watchEnter === true;

					if (scope.options.types) {
						opts.types = [];
						opts.types.push(scope.options.types);
						scope.gPlace.setTypes(opts.types);
					} else {
						scope.gPlace.setTypes([]);
					}

					if (scope.options.bounds) {
						opts.bounds = scope.options.bounds;
						scope.gPlace.setBounds(opts.bounds);
					} else {
						scope.gPlace.setBounds(null);
					}

					if (scope.options.country) {
						opts.componentRestrictions = {
							country: scope.options.country
						};
						scope.gPlace.setComponentRestrictions(opts.componentRestrictions);
					} else {
						scope.gPlace.setComponentRestrictions(null);
					}
				}
			};

			if (!google) {
				var newError = new Error("Google didn't loaded!");
				newError();
				return false;
				/*
             	eslint no-new: "error"
             */
			}

			if (typeof scope.gPlace === 'undefined') {
				scope.gPlace = new google.maps.places.Autocomplete(element[0], {
					fields: ['address_components', 'formatted_address', 'name']
				});
			}
			google.maps.event.addListener(scope.gPlace, 'place_changed', function () {
				var result = scope.gPlace.getPlace();

				if (result !== undefined) {
					if (result.address_components !== undefined) {
						scope.$apply(function () {
							scope.details = result;
							controller.$setViewValue(element.val());
						});
					} else if (watchEnter) {
						getPlace(result);
					}
				}
			});

			controller.$render = function () {
				var location = controller.$viewValue;
				element.val(location);
			};

			// watch options provided to directive
			scope.watchOptions = function () {
				return scope.options;
			};
			scope.$watch(scope.watchOptions, function () {
				initOpts();
			}, true);
		}
	};
});

/***/ }),

/***/ "./web/js/components/Elements/fileInput.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
	angular.module('main').directive('fileInput', fileInput);

	fileInput.$inject = ['$parse', 'messageService'];

	function fileInput($parse, messageService) {
		return {
			restrict: 'A',
			link: function link(scope, element, attrs) {
				var model = $parse(attrs.fileInput);
				var isMultiple = attrs.multiple;
				var modelSetter = model.assign;

				element.bind('change', function () {
					var values = [];
					var maxMb = 10; // 10 Mb
					var maxSize = maxMb * 1000 * 1024;

					angular.forEach(element[0].files, function (item) {
						if (item.size <= maxSize) {
							values.push(item);
							element[0].value = null;
						} else {
							messageService.showToaster('w_0', 'attachments');
							element[0].value = null;
						}
					});

					scope.$evalAsync(function () {
						if (isMultiple) {
							modelSetter(scope, values);
						} else {
							modelSetter(scope, values[0]);
						}
					});
				});
			}
		};
	}
})();

/***/ }),

/***/ "./web/js/components/Elements/maxAmountValidator.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

(function () {
	angular.module('main').directive('maxAmountValidator', maxAmountValidator);

	maxAmountValidator.$inject = [];

	function maxAmountValidator() {
		return {
			restrict: 'A',
			scope: {},
			replace: true,
			transclude: true,
			link: function link(scope, element, attrs) {
				$(element).bind('change', function () {
					var validity = element.prop('validity');
					if (validity.rangeOverflow) {
						var max = attrs.max;
						var amountOverflowError = '\n                            You must record an amount that is equal to or less than ' + max + '. \n                            If you have received a larger amount, record this payment and then \n                            add the remaining amount to the next payment.\n                        ';
						$(this).setCustomValidity(amountOverflowError);
					} else {
						$(this).setCustomValidity('');
					}
				});
			}
		};
	}
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./web/js/components/Elements/snAttachFiles.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
	angular.module('main').directive('snAttachFiles', snAttachFiles);

	snAttachFiles.$inject = ['$filter', 'fileUploadService', 'imageConverter'];

	function snAttachFiles($filter, fileUploadService, imageConverter) {
		return {
			restrict: 'AE',
			replace: true,
			transclude: true,
			scope: {
				filesObj: '=snAttachments'
			},
			template: '<div class="attachments__box">\n                        <input class="attachments__input hide" type="file" file-input="files" multiple />\n                        <h4 ng-if="attachmentsView.length > 0">Files attached</h4>\n                        <ul class="attachments__list">\n                            <li ng-repeat="file in attachmentsView track by $index" class="file-type {{file.convertedType}}">\n                                <div class="file-content-wrapper"> <b class="file-name">{{file.name}}</b>\n                                    <p>{{file.convertedSize}}Mb</p>\n                                </div>\n                                <div class="remove-btn-wrapper"> <i class="fa fa-close file-remove" ng-click="removeAttachment($index)"></i> </div>\n                            </li>\n                        </ul>\n                    </div>',
			link: function link(scope) {
				scope.attachmentsView = [];

				scope.$on('attachments', function (e, data) {
					console.log(scope.filesObj, 'attachments old');
					if (scope.attachmentsView === null) {
						scope.attachmentsView = [];
					}
					angular.forEach(data.attachments, function (value) {
						scope.attachmentsView.push(value);
						scope.attachmentsView = fileUploadService.removeDuplicates(scope.attachmentsView, 'id');
						buildFileObj();
					});
				});

				scope.$watchCollection('filesObj', function (newValue) {
					console.log(scope.filesObj, 'attachments old new');

					if (newValue) {
						scope.attachmentsView = newValue.attachments;
					}
				});

				scope.$watch('attachmentsView | json', function (newValue, oldValue) {
					if (newValue && newValue !== '[]' && newValue !== oldValue) {
						buildFileObj();
					}
				});

				scope.$watch('files', function (newValue) {
					if (newValue && newValue.length > 0) {
						var max = newValue.length;
						if (scope.attachmentsView === null) {
							scope.attachmentsView = [];
						}
						for (var i = 0; i < max; i++) {
							scope.attachmentsView.push(newValue[i]);

							angular.forEach(scope.attachmentsView, function (value) {
								value.convertedType = imageConverter.getFileClass(value.name);

								if (value.bytesSize) {
									value.convertedSize = (parseInt(value.bytesSize) / (1024 * 1024)).toFixed(2); // convert from bytes to MB
								} else {
									value.convertedSize = (parseInt(value.size) / (1024 * 1024)).toFixed(2); // convert from bytes to MB
								}
							});
						}
						scope.$evalAsync();
						scope.files = null;
					}
				});

				scope.removeAttachment = function (index) {
					scope.attachmentsView.splice(index, 1);
					scope.$evalAsync();
				};

				function buildFileObj() {
					if (scope.attachmentsView !== undefined || scope.attachmentsView !== null) {
						var max = scope.attachmentsView.length;
						var size = 0;

						for (var i = 0; i < max; i++) {
							var fileSize = scope.attachmentsView[i].size || scope.attachmentsView[i].bytesSize;
							size += fileSize;
						}
						size /= 1024 * 1000;
						size = $filter('number')(size, 2);

						scope.filesObj.filesSize = size;
						angular.forEach(scope.attachmentsView, function (value) {
							value.convertedType = imageConverter.getFileClass(value.name);

							if (value.bytesSize) {
								value.convertedSize = (parseInt(value.bytesSize) / (1024 * 1024)).toFixed(2); // convert from bytes to MB
							} else {
								value.convertedSize = (parseInt(value.size) / (1024 * 1024)).toFixed(2); // convert from bytes to MB
							}
						});

						scope.filesObj.attachments = scope.attachmentsView;
					}
				}
			}
		};
	}
})();

/***/ }),

/***/ "./web/js/components/Elements/snCheckbox.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('main').directive('snCheckbox', function () {
	return {
		restrict: 'AE',
		template: '<div class="checkbox-squared">' + '<input type="checkbox" id="{{id}}" ng-model="drModel"/>' + '<label for="{{id}}"></label>' + '</div>',
		scope: {
			drModel: '=snModel',
			id: '@snId'
		},
		replace: true,
		transclude: true,
		link: function link(scope, elem, attr, ctrl) {}
	};
});

/***/ }),

/***/ "./web/js/components/Elements/snSelect.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('main').directive('snSelect', [function () {
	return {
		restrict: 'AE',
		scope: {
			defaultText: '=',
			allItems: '=',
			labelField: '@'
		},
		template: function template() {
			var html = '';
			html += '<div class="select-style"><span>Inner thing</span>';
			html += 'ХХshowLabel{{showLabel}}';

			// html += "    <div class=\"head\" ng-click=\"active=!active\">";
			// html += "        <span ng-hide=\"showLabel\">{{defaultText}}<\/span>";
			// html += "        <div ng-show=\"showLabel\">";
			// //html += "            <i class=\"jt-{{jobTypeEdit.colour | lowercase}}\"><\/i>";
			// html += "            <span>{{jobTypeEdit.colour}}<\/span>";
			// html += "        <\/div>";
			// html += "    <\/div>";
			//
			// html += "    <ul class=\"options\">";
			// html += "        <li ng-repeat=\"item in items\" class=\"form-control\" ng-click=\"setColor(colour, $event);\">";
			// html += "            <i class=\"jt-{{colour | lowercase}}\"><\/i>";
			// html += "            <span>{{colour}}<\/span>";
			// html += "        <\/li>";
			// html += "    <\/ul>";

			html += '</div>';

			return html;
		},

		replace: true,
		link: function link(scope, element) {
			// console.log('scope');
			// console.dir(scope);
			//
			// element.data('thing', true);
			//
			// scope.itemsOrigin = angular.copy(scope.items);
			// //scope.defaultText = angular.copy(scope.defaultText);
			//
			// angular.element($document[0].body).on('click', function (e) {
			//    //var inThing = angular.element(e.target).inheritedData('thing');
			//    //if (inThing) {
			//        $window.alert('in');
			//    //} else {
			//    //    $window.alert('out');
			//    //}
			// })
		}
	};
}]);

/***/ }),

/***/ "./web/js/components/Elements/webshimPolyfill.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

angular.module('main').directive('input', function () {
	return {
		restrict: 'E',
		priority: -1,
		link: function link(scope, element, attrs) {
			function init() {
				$(element).updatePolyfill();
			}

			switch (attrs.type) {
				case 'number':
					init();
					break;
				case 'date':
					init();
					break;
				default:
					return false;
			}
		}
	};
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./web/js/components/Filelds/contactFullName.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
	angular.module('main').directive('contactFullName', function () {
		return {
			restrict: 'E',
			scope: {
				contact: '='
			},
			template: '<b>{{contact.firstName}} {{contact.lastName}}</b>',
			replace: true,
			transclude: true,
			link: function link(scope, element) {}
		};
	});
})();

/***/ }),

/***/ "./web/js/components/Filelds/convertToNumber.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
	angular.module('main').directive('convertToNumber', convertToNumber);

	function convertToNumber() {
		return {
			restrict: 'A',
			require: 'ngModel',
			link: function link(scope, element, attrs, ngModel) {
				ngModel.$parsers.push(function (val) {
					return parseInt(val, 10);
				});
				ngModel.$formatters.push(function (val) {
					return '' + val;
				});
			}
		};
	}
})();

/***/ }),

/***/ "./web/js/components/Filelds/fullDateTime.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
	angular.module('main').directive('fullDateTime', fullDateTime);

	fullDateTime.$inject = ['timeService', '$http', 'settingsService'];

	function fullDateTime(timeService, $http, settingsService) {
		return {
			restrict: 'E',
			scope: {
				startDate: '<',
				startTime: '<',
				finishDate: '<',
				finishTime: '<'
			},
			template: '<span>\n                          <span ng-if="startDate">\n                               {{startDate | timeFilter: setStartDateFilter()}}\n                            <span ng-show="startDate != finishDate">\n                                - <span class="text-nowrap">{{finishDate | timeFilter:\'long\'}}</span>\n                            </span>\n                            <span ng-if="startTime">from\n                                <span class="text-nowrap">{{convertedStartTime | lowercase}}</span> -\n                            <span class="text-nowrap">{{convertedEndTime | lowercase}}</span></span>\n                          </span>\n                          <span ng-if="!startDate">No date</span>\n                       </span>',
			replace: true,
			transclude: true,
			link: function link(scope) {
				settingsService.timeFormatSettings.subscribe(function (data) {
					scope.dataTimeFormat = data.timeFormat;
					if (scope.dataTimeFormat === 'T_24') {
						if (scope.startTime && scope.finishTime) {
							scope.convertedStartTime = scope.startTime.slice(0, -3);
							scope.convertedEndTime = scope.finishTime.slice(0, -3);
						}
					} else if (scope.startTime && scope.finishTime) {
						scope.convertedStartTime = timeService.getTimeConvertedTo12(scope.startTime);
						scope.convertedEndTime = timeService.getTimeConvertedTo12(scope.finishTime);
					}
				});

				scope.setStartDateFilter = function () {
					var isYearsEqual = timeService.compareYears(scope.startDate, scope.finishDate);
					var isDatesDifferent = timeService.compareDates(scope.startDate, scope.finishDate);

					var onlyYearsAreEqual = isYearsEqual && isDatesDifferent;

					if (onlyYearsAreEqual) {
						return 'dayAndMonth';
					}

					return 'long';
				};
			}
		};
	}
})();

/***/ }),

/***/ "./web/js/components/Filelds/jobCellHead.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/***/ }),

/***/ "./web/js/components/Filelds/mainShootDate.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
	angular.module('main').directive('mainShootDate', mainShootDate);

	mainShootDate.$inject = ['timeService'];

	function mainShootDate(timeService) {
		return {
			restrict: 'E',
			scope: {
				startDate: '=',
				finishDate: '=',
				doubleBooking: '='
			},
			template: '<span style="display: flex; justify-content: flex-start">\n                            <div ng-if="startDate">\n                               {{startDate | timeFilter: setStartDateFilter()}}\n                                <span ng-show="startDate != finishDate">\n                                   - \n                                 <span class="text-nowrap">{{finishDate | timeFilter:\'long\'}}</span>\n                                </span>\n                            </div>\n                            <span style="display: flex; float: right" ng-if="startDate !== finishDate">\n\n                                    <span ng-if="doubleBooking" class="square-content-job" style="align-self:flex-end">\n                                         <double-booking [double-booking]="doubleBooking"></double-booking>\n                                    </span>\n\n                                    </span>\n                            <span ng-if="!startDate">No date</span>\n                       </span>',
			replace: true,
			transclude: true,
			link: function link(scope) {
				scope.setStartDateFilter = function () {
					var isYearsEqual = timeService.compareYears(scope.startDate, scope.finishDate);
					var isDatesDifferent = timeService.compareDates(scope.startDate, scope.finishDate);

					var onlyYearsAreEqual = isYearsEqual && isDatesDifferent;

					if (onlyYearsAreEqual) {
						return 'dayAndMonth';
					}

					return 'long';
				};
			}
		};
	}
})();

/***/ }),

/***/ "./web/js/components/Filelds/snFieldEmail.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
	angular.module('main').directive('snInputEmail', snInputEmail);

	snInputEmail.$inject = ['$rootScope'];

	function snInputEmail($rootScope) {
		return {
			restrict: 'AE',
			scope: {
				title: '@snTitle',
				model: '=snModel',
				snPlaceholder: '@',
				toggleCc: '=snShowCc'
			},
			template: function template(element, attrs) {
				var template = '',
				    toggleBtn = '';

				if (attrs.hasOwnProperty('snShowCc')) {
					toggleBtn = '<button type="button" class="btn btn-link color-cc" ng-if="!toggleCc" ng-click="toggleViewCc()">Add Cc</button>';
					toggleBtn += '<b>toggleCc: {{toggleCc}}</b>';
				}

				template += '<div class="field-info">';
				template += '<h4>{{title}}</h4>';

				template += '<div class="flex-row">';
				template += '<input class="form-control" type="email" placeholder="{{snPlaceholder}}"';
				template += 'ng-model="model" required maxlength="255">';
				template += toggleBtn;

				template += '</div>';
				template += '</div>';

				return template;
			},

			replace: true,
			link: function link(scope, elem, attr, ctrl) {
				scope.toggleViewCc = function () {
					scope.toggleCc = !scope.toggleCc;
				};

				scope.$watch('toggleCc', function (newValue, oldValue) {
					if (newValue !== oldValue) {
						console.log('newValue', newValue);
						$rootScope.showCcField = newValue;
					}
				});
			}
		};
	}
})();

/***/ }),

/***/ "./web/js/components/Filelds/snFieldInfo.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('main').directive('snFieldInfo', function () {
	var template = '';

	template += '<div class="field-info">';
	template += '<h4>{{title}}</h4>';
	template += '<div class="flex-row text-break pre-wrap">{{message}}</div>';
	template += '<div ng-show="html"><sn-quill-view-web [content]="html"></sn-quill-view-web></div> ';
	template += '</div>';

	return {
		restrict: 'AE',
		scope: {
			title: '@snTitle',
			message: '=snText',
			html: '=snHtml'
		},
		template: template,
		replace: true,
		link: function link(scope, elem, attr, ctrl) {}
	};
});

/***/ }),

/***/ "./web/js/components/Filelds/snFieldInput.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('main').directive('snInputText', function () {
	return {
		restrict: 'AE',
		scope: {
			title: '@snTitle',
			model: '=snModel',
			snPlaceholder: '@',
			id: '@snId'
		},
		template: function template(element, attr) {
			var template = '';

			template += '<div class="field-info">';
			template += '<h4>{{title}}</h4>';
			template += '<input id="{{id}}" class="form-control" type="text" placeholder="{{snPlaceholder}}"';
			template += 'ng-model="model" required maxlength="255">';
			template += '</div>';

			return template;
		},

		replace: true,
		link: function link(scope, elem, attr, ctrl) {}
	};
});

/***/ }),

/***/ "./web/js/components/Modals/private/addAppointmentModal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _operators = __webpack_require__("./node_modules/rxjs/operators.js");

(function () {
	angular.module('main').directive('addAppointmentModal', addAppointmentModal);

	addAppointmentModal.$inject = ['$rootScope', '$location', 'appointmentService', 'calendarEventsDataService', 'jobDataService', 'messageService', 'searchService', 'timeService', 'workflowService', 'validationService', 'settingsService', 'timeConverter', 'utilsService', 'doubleBookingService'];

	function addAppointmentModal($rootScope, $location, appointmentService, calendarEventsDataService, jobDataService, messageService, searchService, timeService, workflowService, validationService, settingsService, timeConverter, utilsService, doubleBookingService) {
		return {
			restrict: 'E',
			scope: {
				appointment: '<',
				activeJobs: '<',
				clientId: '<',
				jobId: '<',
				taskList: '=',
				updateView: '&',
				businessNumberLabelName: '='
			},
			template: '<section>\n                            <div id="appointment" class="modal modal-center fade" data-backdrop="static" \n                                 data-keyboard="false" data-autotest-modal="appointment">\n                                <div class="modal-dialog">\n                                    <form ng-submit="saveAppointment()">\n                                        <div class="modal-content">\n                                            <div class="modal-header">\n                                                <btn-close></btn-close>\n                                                <h3 class="modal-title">{{appointment.id ? \'Edit appointment\' : \'Add new appointment\'}}</h3>\n                                            </div>\n                                            <div class="modal-body f-s-14-labels">\n                                                <h3 class="mt-0 mb-25">Appointment details</h3>\n                                                <div class="flex-row flex-wrap-xs">\n                                                    <div class="form-group w-min-100 flex-basis-full-xs">\n                                                        <label class="control-label">Name</label>\n                                                    </div>\n                                                    <div class="form-group w-max-415 flex-with-full">\n                                                        <input type="text" class="form-control" name="appointmentName" maxlength="255" ng-model="appointment.name" autocomplete="off"\n                                                               required>\n                                                    </div>\n                                                </div>\n                        \n                                                <hr class="mt-15">\n                        \n                                                <h3 class="mt-30 mb-25">Appointment schedule</h3>\n                        \n                                                <div class="form-group">\n                                                    <div class="flex-row flex-wrap-xs">\n                                                        <div class="w-min-100 flex-basis-full-xs">\n                                                            <label class="control-label">Date</label>\n                                                        </div>\n                        \n                                                       \n                                                            <div class="flex-row flex-wrap-xs flex-with-full w-max-415">\n                                                                <div class="flex-with-full flex-1 mb-15 box-no-transition-small datepicker-static under-input"  ng-class="{\'overlap-warning\': !!doubleBookingData}">\n                        \n                                                                   <input ng-model="appointment.startDate" class="form-control"\n                                                                           type="date" name="input" \n                                                                           data-placeholder="{{datapickerDateFormat}}" \n                                                                           min="2001-12-31"\n                                                                           max="2999-12-31"\n                                                                           data-date=\'{"startView": 2, "openOnMouseFocus": true}\' required/>\n                                                                </div>\n                        \n                                                                <div class="flex-basis-xs flex-align-self-center ms-10 mb-15">to</div>\n                        \n                                                                <div class="flex-with-full flex-1 mb-15 box-no-transition-small datepicker-static under-input"  ng-class="{\'overlap-warning\': !!doubleBookingData}">\n                                                                    <input ng-model="appointment.endDate" class="form-control w-150 flex-with-full"\n                                                                           type="date" name="input"\n                                                                          \tdata-placeholder="{{datapickerDateFormat}}" \n                                                                           min="{{( appointment.startDate ) ? ( appointment.startDate | date : \'yyyy-MM-dd\') : (now | date : \'yyyy-MM-dd\') }}"\n                                                                           max="2999-12-31"\n                                                                           data-date=\'{"startView": 2, "openOnMouseFocus": true}\' required/>\n                                                                </div>\n                                                                 \n                                                            </div>\n                                                       \n                                                            <div class="mb-15 pt-6 flex-row flex-basis-full-xs" style="padding-left: 20px !important;">\n                                                                        <div class="checkbox-squared">\n                                                                            <input type="checkbox" id="checkbox-squared-all-day-appointment"\n                                                                                   ng-model="appointment.allday"/>\n                                                                            <label for="checkbox-squared-all-day-appointment"></label>\n                                                                        </div>\n                                                                        <label for="checkbox-squared-all-day-appointment">All day</label>\n                                                            </div>\n                        \n                                                      \n                                                    </div>\n                                                    <div class="flex-row flex-wrap-xs">\n                                                        <div class="w-min-100 flex-basis-full-xs">\n                                                            <label class="control-label">Time</label>\n                                                        </div>\n                                                        <div class="job-date flex-with-full w-max-415">\n                                                            <div class="flex-row flex-wrap-xs flex-basis-full-xs">\n                                                                <div class="flex-1 mb-15 flex-with-full"  ng-class="{\'overlap-warning\': !!doubleBookingData}">\n                                                                    <sn-timepicker sn-dr-model="appointment.startTime"\n                                                                                   sn-dr-checked="appointment.allday"\n                                                                    ></sn-timepicker>\n                                                                </div>\n                                                                <div class="flex-basis-xs flex-align-self-center ms-10 mb-15">to</div>\n                                                                <div class="flex-1 mb-15 w-150 flex-with-full"  ng-class="{\'overlap-warning\': !!doubleBookingData}">\n                                                                    <sn-timepicker sn-dr-model="appointment.endTime"\n                                                                                   sn-dr-checked="appointment.allday"\n                                                                    ></sn-timepicker>\n                                                                </div>\n                                                            </div>\n                                                        </div>\n                                                    </div>\n                        \n                                                    <div class="flex-row flex-wrap-xs ">\n                                                        <div class="w-min-100 flex-basis-full-xs">\n                                                            <label class="control-label">Location</label>\n                                                        </div>\n                                                        <input type="text" class="hide hidden form-control" name="appointment.location"\n                                                               ng-model="appointment.location"/>\n                                                        <div class="mb-15 w-max-415 flex-with-full box-no-transition-small"\n                                                             ng-controller="GoogleAutocompleteController">\n                                                            <input type="text" id="AutocompleteAppointment" ng-model="autocomplete" placeholder=""\n                                                                   class="form-control" ng-autocomplete options="options" details="details"/>\n                                                        </div>\n                                                    </div>\n                                                                                                        \n\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="row" ng-show="searchingEvents">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="col-sm-12">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="db-event-loading mt-10 mb-10">Loading...</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="row" ng-show="!searchingEvents && doubleBookingData">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="col-sm-12 mt-10 mb-25" >\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<events-overlapping-info [data]="doubleBookingData"></events-overlapping-info>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div> \n\t\t\t\t\t\t\t\t\t\t\t\t\n                                                </div>\n                                                <section ng-hide="isJobView || isLeadView">\n                        \n                                                    <hr class="mb-30">\n                                                    <div class="flex-row mt-10 pb-10">\n                                                        <div class="checkbox-squared">\n                                                            <input type="checkbox" id="checkbox-squared-add-to-job"\n                                                                   ng-model="appointment.addToJob"/>\n                                                            <label for="checkbox-squared-add-to-job"\n                                                                   data-autotest-checkbox="checkbox"></label>\n                                                        </div>\n                                                        <label for="checkbox-squared-add-to-job">\n                                                            Add this appointment to the workflow of an active lead/job\n                                                        </label>\n                                                    </div>\n                        \n                                                    <div ng-show="appointment.addToJob" \n                                                         class="flex-row grey-group-field mb-0 mt-20 text-xs-center text-sm-left"\n                                                         style="padding:23px">\n                                                        <div class="mr-15">\n                                                            <h4 class="f-normal">Choose active lead/job</h4>\n                                                        </div>\n                                                        <div class="flex-1 appointment-modal-input">\n                                                            <input placeholder="Start entering job name"\n                                                                   class="form-control"\n                                                                   type="text"\n                                                                   autocomplete="off"\n                                                                   typeahead="idName as idName.name for idName in jobNames | filter:$viewValue"\n                                                                   typeahead-on-select="enableViewButton($item)"\n                                                                   typeahead-select-on-exact="true"\n                                                                   ng-model="appointment.jobSearch">\n                                                        </div>\n                                                       \n                                                        <a ng-disabled="viewButtonDisabled"\n                                                        class="btn btn-default ml-10"\n                                                        target="_blank"\n                                                        ng-href="{{viewLeadJobLink}}">\n                                                        \t<i class="fi fi-view"></i>View\n                                                        </a>\n                                                    </div>\n                                                    <hr class="mb-30">\n                                                </section>\n                                                <div class="flex-row mt-10 mb-10">\n                                                    <div class="checkbox-squared">\n                                                        <input type="checkbox" id="checkbox-squared-appointment-reminder"\n                                                               ng-model="appointment.sendEmails"/>\n                                                        <label for="checkbox-squared-appointment-reminder"\n                                                               data-autotest-checkbox="checkbox"></label>\n                                                    </div>\n                                                    <label for="checkbox-squared-appointment-reminder">\n                                                        Send appointment reminder to this client according to\n                                                       <a class="pointer appointment-link" href="/settings/email_templates">Email Templates</a>\n                                                    </label>\n                                                </div>\n                                                \n                                                <div ng-show="!appointment.addToJob && appointment.sendEmails && !isJobView && !isLeadView" \n                                                         class="flex-row grey-group-field mb-0 mt-20 text-xs-center text-sm-left"\n                                                         style="padding:23px">\n                                                        <div class="mr-15">\n                                                            <h4 class="f-normal">Choose client</h4>\n                                                        </div>\n                                                        <div class="flex-1 appointment-modal-input">\n                                                            <input placeholder="Start entering client name"\n                                                                   class="form-control" type="text"\n                                                                   typeahead="idName as idName.name for idName in clientsNames | filter:$viewValue"\n                                                                   ng-model="appointment.clientSearch">\n                                                        </div>\n                                                </div>\n                        \n                                            </div>\n                                            <div class="modal-footer modal-foot">\n                                                <button ng-disabled="button_disable" class="btn btn-success btn-lg" type="submit"\n                                                        spinning-wheel is-spinning-wheel-active="button_disable"\n                                                 >Save appointment</button>\n                                                 \n                                                 <button ng-disabled="button_disable" class="btn btn-lg btn-delete" \n                                                         ng-show="appointment.id && !isJobView && !isLeadView" ng-click="showDeleteAppointment(appointment, $event)" type="button"\n                                                  >Delete</button>\n                                            </div>\n                                        </div>\n                                    </form>\n                                </div>\n                            </div>\n                        \n                            <delete-appointment-modal delete="deleteAppointment(deleteId)"></delete-appointment-modal>\n                        \n                            <create-new-client-modal id="createNewClientModal"\n                                                     company-name-checked="companyNameChecked"\n                                                     client="newClient"\n                                                     save-client="saveClient(event)"\n                                                     on-close="closeAddClient()"\n                                                     is-create-client-modal-spinnning-wheel-active="isAddNewSpinnningWheelActive"\n                                                     business-number-label-name="businessNumberLabelName"\n                            ></create-new-client-modal>\n                        </section>\n',
			replace: true,
			transclude: true,
			link: function link(scope) {
				scope.isJobView = $location.path().includes('/jobs/view/');
				scope.isLeadView = $location.path().includes('/leads/view/');
				scope.job = {};
				var TIME = '12:00 PM';
				var clientsSearchTimer = void 0,
				    jobSearchTimer = void 0;
				var input = $('input');

				$(document).on('show.bs.modal', '#appointment', function () {
					scope.viewButtonDisabled = true;
					scope.viewLeadJobLink = null;
					scope.taskToAnimateNumber = null;
					scope.taskInfo = workflowService.getTaskInfo();
					if (scope.taskInfo && scope.taskInfo.task && scope.taskInfo.task.jobSearch && scope.taskInfo.task.jobSearch.id && scope.taskInfo.task.jobSearch.name) {
						scope.viewButtonDisabled = false;
						createLeadJobLink(scope.taskInfo.task.jobSearch);
					}
					settingsService.timeFormatSettings.subscribe(function (data) {
						if (data.timeFormat !== null) {
							scope.timeFormatIs12HorsFormat = data.timeFormat === 'T_12';
						}
					});
					scope.appointment = angular.copy(scope.taskInfo.task);
					scope.job.location = angular.copy(scope.appointment.location);

					settingsService.timeFormatSettings.subscribe(function (data) {
						scope.dataFormatMonth = data.dateFormat;
					});

					scope.datapickerDateFormat = scope.dataFormatMonth === 'DD_MM_YYYY' ? 'dd/mm/yyyy' : 'mm/dd/yyyy';

					$('#appointment').find('input.ws-date').prop('autocomplete', 'off');

					if (scope.appointment.startDate) {
						convertDateTime();
					} else {
						scope.appointment.startTime = null;
					}
					scope.searchingEvents = false;
					scope.now = new Date();
					scope.now.setHours(0, 0, 0, 0);
					scope.clientsNames = [];
					scope.jobNames = [];
					scope.doubleBookingData = null;
					scope.$evalAsync();
				}).on('shown.bs.modal', '#appointment', function () {
					$(this).find('input').first().focus();
					validationService.isModalClosePrevented(input);
				}).on('hide.bs.modal', '#appointment', function () {
					scope.appointment.startTime = undefined;
				});

				scope.$watch('appointment.startDate', checkAppointmentDate);
				scope.$watch('appointment.startTime', checkAppointmentTime);
				scope.$watch('appointment.endDate', reactToDateTimeChange);
				scope.$watch('appointment.endTime', reactToDateTimeChange);
				scope.$watch('appointment.allday', setTimeAfterAllDay);

				scope.$watch('appointment.location', setLocation);

				function checkAppointmentTime(newValue, oldValue) {
					if (scope.appointment && typeof oldValue !== 'undefined' && newValue && newValue !== oldValue) {
						scope.appointment.endTime = timeService.setEndTime(newValue);
						reactToDateTimeChange(newValue, oldValue);
					}
				}

				function checkAppointmentDate(startDate) {
					if (scope.appointment && startDate) {
						if (!scope.appointment.endDate || startDate > scope.appointment.endDate) {
							scope.appointment.endDate = startDate;
						}
						checkForOverlappingEvents();
					}
				}

				function setLocation(currentLocation) {
					scope.job.location = currentLocation;
				}

				function convertDateTime() {
					scope.appointment = timeService.convertDateTimeForPicker(scope.appointment, 'startDate', 'endDate', 'startTime', 'endTime');
				}

				// client search

				scope.$watch('appointment.clientSearch', function (newValue, oldValue) {
					if (newValue == null) {
						return;
					}
					if (oldValue == newValue) {
						return;
					}
					if (newValue.length > 0) {
						if (clientsSearchTimer != null) {
							clearTimeout(clientsSearchTimer);
						}
						clientsSearchTimer = setTimeout(findAllMatchingClientNames(newValue), 500);
					} else {
						clearTimeout(clientsSearchTimer);
					}
				});

				function findAllMatchingClientNames(search) {
					jobDataService.searchClient(search).then(function (result) {
						return findClientSuccessCallback(result.data);
					}).catch(messageService.showDefaultErrorMessage);
				}

				function findClientSuccessCallback(client) {
					if (client) {
						scope.clientsNames.length = 0;
						client.forEach(function (item) {
							return scope.clientsNames.push(item);
						});
					}
				}

				function setTimeAfterAllDay(newValue, oldValue) {
					if (!newValue && oldValue && !scope.timeFormatIs12HorsFormat) {
						scope.appointment.startTime = timeConverter.convert12to24(TIME);
					} else if (newValue === false && oldValue && scope.timeFormatIs12HorsFormat) {
						scope.appointment.startTime = TIME;
					} else if (newValue === true && oldValue === false) {
						scope.appointment.startTime = null;
						scope.appointment.endTime = null;
					}
					reactToDateTimeChange(newValue, oldValue);
				}

				scope.enableViewButton = function (event) {
					scope.viewLeadId = createLeadJobLink(event);
					scope.viewButtonDisabled = false;
				};

				// job search
				scope.$watch('appointment.jobSearch', function (newValue, oldValue) {
					if (newValue == null) {
						return;
					}
					if (oldValue == newValue) {
						return;
					}
					if (newValue.length > 0) {
						if (jobSearchTimer != null) {
							clearTimeout(jobSearchTimer);
						}
						jobSearchTimer = setTimeout(findAllMatchingJobsNames(newValue), 500);
					} else {
						clearTimeout(jobSearchTimer);
					}
				});

				function findAllMatchingJobsNames(search) {
					if (scope.activeJobs && scope.activeJobs.length) {
						scope.jobNames = searchService.findMatchingNames(scope.activeJobs, search);
					}
				}

				function createLeadJobLink(data) {
					if (data.leadId) {
						scope.viewLeadJobLink = '/leads/view/' + data.leadId;
					} else if (data.id) {
						scope.viewLeadJobLink = '/jobs/view/' + data.id;
					}
				}

				// save appointment

				scope.saveAppointment = function () {
					var dataToSave = angular.copy(scope.appointment);

					scope.button_disable = true;

					dataToSave.clientId = scope.clientId ? scope.clientId : dataToSave.clientId;
					if (scope.isJobView === false) {
						scope.isJobView = scope.isLeadView;
					}
					dataToSave = appointmentService.prepareAppointmentToSave(dataToSave, scope.isJobView, scope.job.location);

					if (!dataToSave) {
						scope.button_disable = false;
						return false;
					}

					if (scope.isJobView || scope.isLeadView) {
						saveAppointmentAsJobTask(dataToSave);
					} else {
						saveAppointmentAsCalendarEvent(dataToSave);
					}
				};

				function saveAppointmentAsJobTask(dataToSave) {
					workflowService.saveTask(dataToSave, scope.jobId, scope.taskList).finally(function () {
						return scope.button_disable = false;
					}).subscribe(function (result) {
						return successSaveAppointmentAsTask(result, scope.appointment.id);
					}, function (error) {
						return messageService.showDefaultErrorMessage(error);
					});
				}

				function saveAppointmentAsCalendarEvent(dataToSave) {
					var action = dataToSave.id ? calendarEventsDataService.updateEvent(dataToSave) : calendarEventsDataService.createEvent(dataToSave);

					action.finally(function () {
						return scope.button_disable = false;
					}).subscribe(function (data) {
						return successSaveAppointment(data, scope.appointment.id, scope.appointment.jobId);
					}, function (error) {
						return messageService.showDefaultErrorMessage(error);
					});
				}

				function successSaveAppointmentAsTask(data, id) {
					if (!data || !data.tasks) {
						return;
					}

					scope.updateView({ tasks: data.tasks });

					for (var i = 0; i < data.tasks.length; i++) {
						if (data && data.taskMetadata && data.taskMetadata.taskId === data.tasks[i].id) {
							scope.taskToAnimateNumber = '.task-' + i;
						}
					}

					var isEdited = id !== null && id !== undefined;

					isEdited ? messageService.showToaster('s_4', 'workflow') : messageService.showToaster('s_3', 'workflow');

					$('#appointment').modal('hide').on('hidden.bs.modal', function () {
						if (!isEdited) {
							$rootScope.$broadcast('animateTask', scope.taskToAnimateNumber);
						}
						$(this).off('hidden.bs.modal');
					});
				}

				function successSaveAppointment(data, appointmentId, oldJobId) {
					scope.button_disable = false;

					$('#appointment').modal('hide');

					var messageCode = appointmentId ? 's_1' : 's_0';
					messageService.showToaster(messageCode, 'appointment', scope.appointment.name);

					var jobId = data.jobId,
					    taskId = data.taskId,
					    leadId = data.leadId;

					if (window.location.pathname !== '/calendar') {
						if (jobId && taskId) {
							redirectToJobLead('job', jobId, taskId);
						}
						if (leadId && taskId) {
							redirectToJobLead('lead', leadId, taskId);
						}
					}
					// if (
					// 	(taskId && !appointmentId) ||
					// 	(appointmentId && jobId !== oldJobId && (jobId || leadId))
					// ) {
					// 	$location.search('task', taskId).replace();
					// }
					scope.updateView({ resetPagination: false });
				}

				// redirect to lead/job

				function redirectToJobLead(pageName, id, taskId) {
					$location.path(pageName + 's/view/' + id).search('task', taskId);
				}

				// delete appointment

				scope.showDeleteAppointment = function (appointment, event) {
					scope.deleteId = appointment.id;
					scope.deleteAppointmentName = appointment.name;
					utilsService.showNextModal('#appointment', '#deleteModal', event);
				};

				scope.deleteAppointment = function (id) {
					$('#deleteModal').modal('hide');

					scope.button_disable = true;

					calendarEventsDataService.deleteEvent(id).finally(function () {
						return scope.button_disable = false;
					}).subscribe(function (data) {
						return successDeleteAppointment(data);
					}, function (error) {
						return messageService.showDefaultErrorMessage(error);
					});
				};

				function successDeleteAppointment(data) {
					if (data && data.errorMessage) {
						messageService.showToaster('e_2', 'general', data.errorMessage);
					} else {
						$('#appointment').modal('hide');

						scope.updateView({ resetPagination: true });
						messageService.showToaster('s_2', 'appointment', scope.deleteAppointmentName);
					}
				}

				function reactToDateTimeChange(newValue, oldValue) {
					if (!newValue) {
						scope.doubleBookingData = null;
					}
					if (scope.appointment && newValue && newValue !== oldValue || newValue === false) {
						checkForOverlappingEvents();
					}
				}

				function checkForOverlappingEvents() {
					var hasDate = scope.appointment.startDate && scope.appointment.endDate;
					var hasTimeOrAllDay = scope.appointment.allday || scope.appointment.startTime && scope.appointment.endTime && !scope.appointment.allday;

					if (hasDate && hasTimeOrAllDay) {
						scope.timeData = {
							startTime: scope.appointment.startTime,
							startDate: scope.appointment.startDate,
							finishTime: scope.appointment.endTime,
							finishDate: scope.appointment.endDate,
							allday: scope.appointment.allday
						};
						scope.button_disable = true;
						scope.searchingEvents = true;
						var id = scope.appointment.calendarEvent ? scope.appointment.calendarEvent.id : scope.appointment.id;

						doubleBookingService.getOverlappingEvents(doubleBookingService.gatherDateTimeData(scope.timeData), 'EVENT', id).pipe((0, _operators.finalize)(function () {
							scope.searchingEvents = false;
							scope.button_disable = false;
						})).subscribe(function (data) {
							return scope.doubleBookingData = data;
						});
					}
				}
			}
		};
	}
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./web/js/components/Modals/private/attachFilesModal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

(function () {
	function attachFilesModal(fileUploadService, $rootScope, imageConverter, randomStringGenerator, messageService) {
		return {
			restrict: 'AE',
			replace: true,
			transclude: true,
			scope: {},
			template: '\n                    <div>\n                        <div id="filesModal" class="modal modal-files-upload modal-center fade" data-backdrop="false" data-keyboard="false">\n                          <div class="modal-dialog">\n                            <form class="modal-content hidden-scroll">\n\n                              <div class="modal-header pt-pb-15">\n                                <button type="button" class=\'close\' ng-click=\'closeModal()\'>&times;</button>\n                                <h3 class="modal-title">From Files</h3>\n                              </div>\n                              \n                              <div class="modal-body flex-row section-data__wrapper" style="padding: 30px!important">\n                                <div class="attachment-wrapper section-data section-data--full-lg-max"\n                                     ng-class="{\'flex-basis-full\': allFiles.length === 1}"\n                                     ng-repeat="file in allFiles | filter:id track by $index">\n                                     \n                                     <div class="file-type {{file.convertedType}} with-checkbox" style="width: 60px; position: absolute">\n                                     <div class="checkbox-squared" style="margin-top: 6px">\n                                                   <input type="checkbox" id="attached-to-mail-{{file.id}}-{{checkboxIndex}}" ng-model="file.checked"/>\n                                                   <label for="attached-to-mail-{{file.id}}-{{checkboxIndex}}"></label>\n                                               </div>\n                                     </div>\n                                                                         \n                                    <table class="table-profile table-full-width">\n                                        <tbody>\n                                          \n                                            <tr>\n                                            <td class="files-wrapper">\n                                                   {{file.name}}\n                                                </td>\n                                            </tr>\n                                            <tr>\n                                            <td class="files-wrapper">\n                                                    Uploaded on {{file.customLastModifiedDate}}\n                                                </td>\n                                            </tr>\n                                         \n                                            <tr>\n                                                <td class="files-wrapper">\n                                                    {{file.convertedSize}} MB\n                                                </td>\n                                            </tr>\n                                        </tbody>\n                                    </table>\n                                </div>\n                              </div>\n\n                              <div class="modal-footer modal-foot">\n                                <button type=\'submit\' ng-click="addAttachment()" class="btn btn-success btn-lg">Attach to Email</button>\n                              </div>\n\n                            </form>\n                          </div>\n                        </div>\n                        <div class=\'modal-link-editor__background\'></div>\n                    </div>\n            ',
			link: function link(scope) {
				$(document).on('shown.bs.modal', '#filesModal', function () {
					$('sendContactEmailModal').find('input').blur().find('textarea').blur();
				});

				scope.checkboxIndex = randomStringGenerator.getMixedString();

				scope.$on('addedFileEvent', function () {
					scope.allFiles = fileUploadService.getFiles();
					$rootScope.uploadedFiles = scope.allFiles.length;
				});

				scope.$on('removedData', function (event) {
					scope.allFiles = fileUploadService.getFiles();
					$rootScope.uploadedFiles = scope.allFiles.length;
				});

				var maxMb = 10; // 10 Mb
				var maxSize = maxMb * 1000 * 1024;
				var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

				angular.forEach(scope.allFiles, function (file) {
					var tmpDate = new Date(file.cratedTs);
					file.customLastModifiedDate = tmpDate.getDate() + ' ' + monthNames[tmpDate.getMonth()] + ' ' + tmpDate.getFullYear();
					file.convertedType = imageConverter.getFileClass(file.name);
					file.convertedSize = (parseInt(file.bytesSize) / Math.pow(1024, 2)).toFixed(2); // convert from bytes to MB
					file.fromJobController = true;
				});
				scope.checkedFiles = [];
				scope.testFiles = [];

				scope.closeModal = function () {
					switchModal();
				};

				scope.addAttachment = function () {
					var checked = true;
					scope.checkedFiles.attachments = scope.allFiles.filter(function (file) {
						return file.checked;
					});

					for (var i = 0; i < scope.checkedFiles.attachments.length; i++) {
						if (scope.checkedFiles.attachments[i].bytesSize >= maxSize) {
							messageService.showToaster('w_0', 'attachments');
							checked = false;
							return false;
						}
					}

					if (checked === true) {
						scope.$emit('checkedFiles', scope.checkedFiles);
						switchModal();
						scope.allFiles.forEach(function (file) {
							return file.checked = '';
						});
					}
				};

				function switchModal() {
					$('.in.modal-files-upload').modal('hide').on('hidden.bs.modal', function () {
						if ($('.in.modal').length > 0) {
							document.body.classList.add('modal-open');
							$('.modal.in:not(.modal-link-editor)').children('.modal-dialog').css({ overflow: '' });
						}

						$(this).off('hidden.bs.modal');
						$('.modal.in:not(.modal-files-upload)').children('.modal-dialog').css({ overflow: '' });
					});
				}
			}
		};
	}

	attachFilesModal.$inject = ['fileUploadService', '$rootScope', 'imageConverter', 'randomStringGenerator', 'messageService'];

	angular.module('main').directive('attachFilesModal', attachFilesModal);
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./web/js/components/Modals/private/changeModal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

(function () {
	angular.module('main').directive('changeModal', changeModal);

	changeModal.$inject = ['$http', '$rootScope', '$location', 'messageService'];

	function changeModal($http, $rootScope, $location, messageService) {
		return {
			restrict: 'AE',
			scope: {
				task: '<',
				jobId: '<',
				leadId: '<'
			},
			template: ' <section>\n                        <div id="main-wrapper" class="container">\n                        <div id="modalChangeLead" class="modal modal-center fade" data-backdrop="static"\n                     data-keyboard="false">\n                    <div class="modal-dialog" ng-show="leadId" style="width: 550px">\n                        <div class="modal-content">\n                            <div class="modal-body fs-16" style="text-align: center; padding-top: 40px!important; font-weight: 500; color:black">\n                             Once "Job accepted" is checked, this lead becomes a job. It will move from the "Leads" page to the "Jobs" page.\n                            </div>\n                            <div class="modal-footer modal-foot" style="display: flex; justify-content: center">\n                                <button type="button" class="btn btn-success btn-submit" style="" ng-click="changeToJob(task, jobId)"\n                                        spinning-wheel is-spinning-wheel-active="isSaveNotesSpinnningWheelActive">\n                                   Yes, check "job accepted"\n                                </button>\n                                <button type="button" class="btn btn-lg btn-default ml-10"\n                                        data-dismiss="modal"\n                                        ng-click="cancelModalChange(task)"\n                                        ng-disabled="button_disabled"\n                                >Cancel\n                                </button>\n                            </div>\n                       \n                    </div>\n                    </div>\n                    <div class="modal-dialog" ng-show="!leadId" style="width: 550px">\n                        <div class="modal-content">\n                            <div class="modal-body fs-16"  style="text-align: center; padding-top: 40px!important; font-weight: 500; color:black">\n                              Once "Job accepted" is unchecked, this job becomes a lead. It will move from the "Jobs" page to the "Leads" page.\n                            </div>\n                            <div class="modal-footer modal-foot" style="display: flex; justify-content: center">\n                                <button type="button" class="btn btn-success btn-submit" ng-click="changeToLead(task, jobId)"\n                                        spinning-wheel is-spinning-wheel-active="isSaveNotesSpinnningWheelActive">\n                                   Yes, uncheck "job accepted"\n                                </button>\n                                <button type="button" class="btn btn-lg btn-default ml-10"\n                                        data-dismiss="modal"\n                                        ng-click="cancelModalChange(task)"\n                                        ng-disabled="button_disabled"\n                                >Cancel\n                                </button>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                </div>\n                </section>\n',
			replace: true,
			transclude: true,
			link: function link(scope) {
				scope.changeToJob = function (task, jobId) {
					$rootScope.dnd.canMove = false;
					$http({
						method: 'POST',
						url: '/protected/rest/jobs/' + jobId + '/accept',
						data: JSON.stringify(task.completed)
					}).then(function (result) {
						$('#modalChangeLead').modal('hide');
						messageService.showToaster('s_0', 'lead');
						if (result.data.name === 'Job') {
							$location.path('/jobs/view/' + result.data.id);
						} else {
							console.log('this is lead');
						}
					});
				};

				scope.changeToLead = function (task, jobId) {
					$rootScope.dnd.canMove = false;
					$http({
						method: 'POST',
						url: '/protected/rest/jobs/' + jobId + '/accept',
						data: JSON.stringify(task.completed)
					}).then(function (result) {
						$('#modalChangeLead').modal('hide');
						messageService.showToaster('s_1', 'lead');
						if (result.data.name === 'Lead') {
							$location.path('/leads/view/' + result.data.id);
						} else {
							console.log('this is job');
						}
					});
				};

				scope.cancelModalChange = function (task) {
					task.completed = !task.completed;
					// task.disabled=true;
				};
			}
		};
	}
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./web/js/components/Modals/private/createNewClientModal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

(function () {
    angular.module('main').directive('createNewClientModal', createNewClientModal);

    createNewClientModal.$inject = ['randomStringGenerator', 'validationService'];

    function createNewClientModal(randomStringGenerator, validationService) {
        return {
            restrict: 'E',
            scope: {
                companyNameChecked: '=',
                client: '=',
                saveClient: '&',
                onClose: '&',
                isCreateClientModalSpinnningWheelActive: '=',
                businessNumberLabelName: '='
            },
            template: '\n                    <div class="modal modal-center fade" data-backdrop="static" data-keyboard="false">\n                        <div class="modal-dialog">\n                            <div class="modal-content">\n                                <form ng-submit="saveClient({id:client.id, event: $event})" class="form-horizontal form-group" role="form">\n                                    <div class="modal-header pt-pb-15">\n                                        <btn-close ng-click="onClose({event:$event})"></btn-close>\n                                        <h3 class="modal-title" ng-show="!client.id">Add A New Client</h3>\n                                        <h3 class="modal-title" ng-show="client.id">Edit Client</h3>\n                                    </div>\n                                    <div class="modal-body" style="padding: 30px!important">\n                                        <div class="flex-row edit-contract-text">\n                                            <div class="checkbox-squared">\n                                                <input type="checkbox" id="{{checkboxId}}" ng-model="companyNameChecked"/>\n                                                <label for="{{checkboxId}}"></label>\n                                            </div>\n                                            <label for="{{checkboxId}}">\n                                                This client is a company and invoices will be addressed to the company.\n                                            </label>\n                                        </div>\n\n                                        <div class="row">\n                                            <div class="col-xs-12" ng-show="companyNameChecked">\n                                                <p class="form-group"></p>\n                                                <label class="edit-contract-text control-label show-grid">Company</label>\n                                                <div class="flex-row">\n                                                    <input name="input" autocomplete="off" class="form-control" ng-model="client.companyName"/>\n                                                </div>\n                                                <label class="edit-contract-text control-label show-grid">{{businessNumberLabelName}}</label>\n                                                <div class="flex-row">\n                                                    <input data-number-input autocomplete="off" class="form-control" ng-model="client.businessNumber"/>\n                                                </div>\n                                            </div>\n                                            <div class="col-xs-12 col-md-6">\n                                                <label class="edit-contract-text control-label show-grid">First Name*</label>\n                                                <input type="text" autocomplete="off" class="form-control" ng-model="client.firstName" required>\n                                            </div>\n                                            <div class="col-xs-12 col-md-6">\n                                                <label class="edit-contract-text control-label show-grid">Last Name</label>\n                                                <input type="text" autocomplete="off" class="form-control" ng-model="client.lastName">\n                                            </div>\n                                            <div class="col-xs-12">\n                                                <label class="edit-contract-text control-label show-grid">Phone</label>\n                                                <input data-number-input autocomplete="off" class="form-control" ng-model="client.phone">\n                                            </div>\n                                            <div class="col-xs-12">\n                                                <label class="edit-contract-text control-label show-grid">Email*</label>\n                                                <input type="email" autocomplete="off" class="form-control" ng-model="client.email" required>\n                                            </div>\n                                            <div class="col-xs-12">\n                                                <label class="edit-contract-text control-label show-grid">Street Address</label>\n                                                <input type="text" autocomplete="off" class="form-control" ng-model="client.address">\n                                            </div>\n\n                                            <div class="col-xs-12 col-md-6">\n                                                <label class="edit-contract-text control-label show-grid">Suburb/Town</label>\n                                                <input type="text" autocomplete="off" class="form-control" ng-model="client.town">\n                                            </div>\n                                            <div class="col-xs-12 col-md-6">\n                                                <label class="edit-contract-text control-label show-grid">Postcode/Zip</label>\n                                                <input type="text" autocomplete="off" class="form-control" ng-model="client.postcode">\n                                            </div>\n\n                                            <div class="col-xs-12">\n                                                <label class="edit-contract-text control-label show-grid">State</label>\n                                                <input type="text" autocomplete="off" class="form-control" ng-model="client.state">\n                                            </div>\n                                            <div class="col-xs-12">\n                                                <label class="edit-contract-text control-label show-grid">Country</label>\n                                                <input type="text" autocomplete="off" class="form-control" ng-model="client.country">\n                                            </div>\n                                            <div class="col-xs-12">\n                                                <label class="edit-contract-text control-label show-grid">Client Notes</label>\n                                                    <sn-quill-editor-web\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t[init-value]="client.notes"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t[toolbar-settings]="\'color size font\'"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t[styles]="{height: \'auto\'}"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t(on-text-change)="client.notes = $event">\n                                \t\t\t\t\t</sn-quill-editor-web>\n                                            </div>\n                                        </div>\n                                    </div>\n                                    <div class="modal-footer left">\n                                        <button class="btn btn-success btn-submit pull-left mb--8"\n                                        \ttype="submit"\n                                            ng-disabled="isCreateClientModalSpinnningWheelActive"\n                                            spinning-wheel is-spinning-wheel-active="isCreateClientModalSpinnningWheelActive">\n                                            Save Client Profile\n                                        </button>\n                                    </div>\n                                </form>\n                            </div>\n                        </div>\n                    </div>\n',
            replace: true,
            transclude: true,
            link: function link(scope) {
                var checkboxIndex = randomStringGenerator.getMixedString();
                var input = $('input');

                scope.checkboxId = 'checkbox-squared-is-company-' + checkboxIndex;

                scope.disableDragDrop = function () {
                    return true;
                };

                $(document).on('shown.bs.modal', '#createNewClientModal', function () {
                    validationService.isModalClosePrevented(input);
                });
            }
        };
    }
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./web/js/components/Modals/private/deleteAppointmentModal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  angular.module('main').directive('deleteAppointmentModal', deleteAppointmentModal);

  deleteAppointmentModal.$inject = [];

  function deleteAppointmentModal() {
    return {
      restrict: 'E',
      scope: {
        delete: '&'
      },
      template: '\n                    <div id="deleteModal" class="modal modal-center fade" data-backdrop="static" data-keyboard="false">\n                        <div class="modal-dialog">\n                            <div class="modal-content">\n                                <div class="modal-header">\n                                   <btn-close></btn-close>\n                                    <h3 class="modal-title">Delete appointment</h3>\n                                </div>\n                                <div class="modal-body">\n                                    <strong>\n                                      Are you sure you would like to delete this appointment and reminders associated with it?\n                                    </strong>\n                                </div>\n                                <div class="modal-footer modal-foot">\n                                    <button class="btn btn-danger btn-lg" ng-click="delete()">Delete appointment</button>\n                                    <button class="btn btn-default btn-lg" data-dismiss="modal">Cancel</button>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n             ',
      replace: true,
      transclude: true,
      link: function link(scope) {}
    };
  }
})();

/***/ }),

/***/ "./web/js/components/Modals/private/deleteAttachmentModal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

(function () {
	angular.module('main').directive('deleteAttachmentModal', deleteAttachmentModal);

	deleteAttachmentModal.$inject = ['fileUploadService', '$rootScope'];

	function deleteAttachmentModal(fileUploadService, $rootScope) {
		return {
			restrict: 'E',
			scope: {
				file: '=',
				files: '=',
				tasks: '<'
			},
			template: '\n                      <div id="deleteAttachmentModal" class="modal modal-center fade" data-backdrop="static" data-keyboard="false">\n                        <div class="modal-dialog">\n                            <div class="modal-content">\n                                <div class="modal-header">\n                                    <button class="close" data-dismiss="modal" aria-hidden="true">&times;</button>\n                                    <h3 class="modal-title">Delete file</h3>\n                                </div>\n                                <div class="modal-body">\n                                        <strong>Are you sure you want to delete this file?</strong>\n                                </div>\n                                <div class="modal-footer modal-foot">\n                                    <button type="button" class="btn btn-md btn-danger" ng-click="deleteFile()">Delete</button>\n                                    <button type="button" class="btn btn-md btn-default" data-dismiss="modal">Cancel</button>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                 ',
			replace: true,
			transclude: true,

			link: function link(scope) {
				var deleteAttachmentFromTasks = function deleteAttachmentFromTasks() {
					scope.tasks.forEach(function (task) {
						var hasAttachments = task.taskEmail && task.taskEmail.storedAttachments && task.taskEmail.storedAttachments.length;
						if (hasAttachments) {
							var storedAttachments = task.taskEmail.storedAttachments;

							var deletedFileId = scope.file.id;
							storedAttachments.forEach(function (attachment, index) {
								if (attachment.id === deletedFileId) {
									storedAttachments.splice(index, 1);
								}
							});
						}
					});
				};

				scope.deleteFile = function () {
					fileUploadService.deleteFileFromServer(scope.file, $rootScope.jobId, function (response) {
						var index = scope.files.indexOf(scope.file);
						scope.files.splice(index, 1);
						deleteAttachmentFromTasks();
						scope.$emit('removedFileEvent');
					}, function (response) {
						return response;
					});

					$('#deleteAttachmentModal').modal('hide');
				};
			}
		};
	}
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./web/js/components/Modals/private/deleteExtrashootModal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  angular.module('main').directive('deleteExtrashootModal', deleteExtrashootModal);

  deleteExtrashootModal.$inject = [];

  function deleteExtrashootModal() {
    return {
      restrict: 'E',
      scope: {
        delete: '&',
        mainShootLabelName: '=',
        extraShootLabelName: '='
      },
      template: '\n                    <div id="deleteExtrashootModal" class="modal modal-center fade" data-backdrop="static" data-keyboard="false">\n                        <div class="modal-dialog">\n                            <div class="modal-content">\n                                <div class="modal-header">\n                                   <btn-close></btn-close>\n                                    <h3 class="modal-title">Delete {{extraShootLabelName | lowercase}}</h3>\n                                </div>\n                                <div class="modal-body">\n                                    <strong>\n                                      Are you sure you would like to delete this {{extraShootLabelName | lowercase}}?\n                                    </strong>\n                                </div>\n                                <div class="modal-footer modal-foot">\n                                    <button class="btn btn-danger btn-lg" ng-click="delete()">Delete {{extraShootLabelName | lowercase}}</button>\n                                    <button class="btn btn-default btn-lg" data-dismiss="modal">Cancel</button>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n             ',
      replace: true,
      transclude: true,
      link: function link(scope) {}
    };
  }
})();

/***/ }),

/***/ "./web/js/components/Modals/private/editContractModal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
    angular.module('main').directive('editContractModal', editContractModal);

    editContractModal.$inject = [];

    function editContractModal() {
        return {
            restrict: 'E',
            scope: {
                closeEditContract: '&',
                editableContract: '=',
                saveEditedContract: '&',
                isEditContractModalSpinnningWheelActive: '='
            },
            template: ' <section class="modal modal-center fade" data-backdrop="static" data-keyboard="false">\n                            <div class="modal-dialog">\n                                <div class="modal-content">\n                                    <form role="form">\n                                        <div class="modal-header">\n                                            <btn-close ng-click="closeEditContract()"></btn-close>\n                                            <h3 class="modal-title">Edit Contract</h3>\n                                        </div>\n\n                                        <div class="modal-body">\n                                            <div class="field-info">\n                                               <h4 class="mt-0">Contract terms and conditions</h4>\n                                                <sn-quill-editor-web\n                                                    [editor-i-d]="\'editable_contract_text\'"\n                                                    [init-value]="editableContract.text"\n                                                    [toolbar-settings]="\'variables color size font\'"\n                                                    [vars-list]="\'CONTRACT_MENU\'"\n                                                    (on-text-change)="editableContract.text = $event">\n                                                </sn-quill-editor-web>\n                                            </div>\n                                        </div>\n                                        <div class="modal-footer modal-foot">\n                                            <button type="submit" ng-click="saveEditedContract()" class="btn btn-success btn-lg" spinning-wheel is-spinning-wheel-active="isEditContractModalSpinnningWheelActive">Save contract</button>\n                                        </div>\n                                    </form>\n                                </div>\n                            </div>\n                        </section>\n',
            replace: true,
            transclude: true,
            link: function link(scope) {}
        };
    }
})();

/***/ }),

/***/ "./web/js/components/Modals/private/helperSubscription/mailInfoModal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

(function () {
	angular.module('main').directive('mailInfoModal', mailInfoModal);
	mailInfoModal.$inject = ['settingsService'];

	function mailInfoModal(settingsService) {
		return {
			restrict: 'E',
			scope: {
				mailData: '=',
				onReplySend: '&',
				isLeadArchived: '='
			},
			template: '\n                <div id="main-wrapper" class="container">\n                    <div id="mailInfoModal" class="modal modal-center fade" data-backdrop="static" data-keyboard="false">\n                        <div class="modal-dialog">\n                            <div class="modal-content">\n                                <div class="modal-header">\n                                    <btn-close></btn-close>\n                                    <h3 class="modal-title">Mail details</h3>\n                                </div>\n                                <div class="modal-body modal-contract-body">\n                                    <sn-field-info sn-title="From" sn-text="mailData.to === \'me\' ? mailData.from : \'me\'"></sn-field-info>\n                                    <sn-field-info sn-title="To" sn-text="mailData.to"></sn-field-info>\n                                    <sn-field-info sn-title="Cc" sn-text="mailData.cc" ng-show="mailData.cc"></sn-field-info>\n                                    <sn-field-info sn-title="Date" sn-text="mailData.date | date:dateFilterJobMail"></sn-field-info>\n                                    <sn-field-info sn-title="Email template" sn-text="mailData.name"></sn-field-info>\n                                    <sn-field-info sn-title="Subject" sn-text="mailData.subject"></sn-field-info>\n                                    <sn-field-info sn-title="Message" ng-if="mailData.status !== null" sn-html="mailData.text"></sn-field-info>\n                                    <sn-field-info sn-title="Message" ng-if="mailData.status === null" sn-html="mailData.emailTextReply"></sn-field-info>\n                               </div>\n\n                               <div class="modal-footer modal-foot" ng-show="mailData.status === null && mailData.validMsg === true && !isLeadArchived">\n                                    <button type="submit" ng-click="replySendMail($event, mailData)" class="btn btn-success btn-lg">Reply</button>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n\n                </div>',

			replace: true,
			transclude: true,
			link: function link(scope) {
				$(document).on('show.bs.modal', '#mailInfoModal', function () {
					settingsService.timeFormatSettings.subscribe(function (data) {
						scope.dataFormatMonth = data.dateFormat;
						scope.dataTimeFormat = data.timeFormat;
						scope.DateFormatFilter = scope.dataFormatMonth === 'DD_MM_YYYY' ? 'dd MMMM yyyy' : 'MMMM dd yyyy';
						scope.timeFormatFilter = scope.dataTimeFormat === 'T_24' ? 'HH:mm' : 'h:mm a';

						scope.dateFilterJobMail = scope.DateFormatFilter + ' \'at\' ' + scope.timeFormatFilter;
					});
				});

				scope.replySendMail = function (event) {
					scope.onReplySend({ event: event });
				};
			}
		};
	}
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./web/js/components/Modals/private/helperSubscription/subscriptionBannerList.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/***/ }),

/***/ "./web/js/components/Modals/private/importClientsModal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
    angular.module('main').directive('importClientsModal', importClientsModal);

    function importClientsModal(fileDownloadDataService, messageService) {
        return {
            restrict: 'E',
            scope: {
                companyNameChecked: '=',
                client: '=',
                saveClient: '&',
                disableDropzone: '='
            },
            template: '\n                    <div id="import-clients-modal" class="modal modal-center fade" data-backdrop="static" data-keyboard="false">\n                        <div class="modal-dialog">\n                            <div class="modal-content import-clients-modal-content">\n                                <div class="modal-header pt-pb-15">\n                                    <btn-close></btn-close>\n                                    <h3 class="modal-title">Import clients</h3>\n                                </div>\n                                <div class="modal-body fs-16" style="padding: 30px!important">\n                                    <p>\n                                        You can bulk import a large number of clients using CSV file. Please download and use our\n                                        CSV file template below.\n                                    </p>\n                                    <a class="btn btn-success btn-lg" ng-click="downloadClientsTemplate()">Download CSV template</a>\n                                    <br><br>\n                \n                                    <p>\n                                        Please make sure you do not reorder, delete or change the column titles within the original CSV\n                                        file before uploading it.\n                                    </p>\n                                    <div ng-hide="disableDropzone" class="dropzone dz-clickable" id="import-clients-dropzone">\n                                        <div class="dz-default dz-message">\n                                            <span><img src="https://app.studioninja.co/build/release-pipeline-119/resources/dist/assets/images/icons/upload.png" alt=""></span>\n                                        </div> \n                                    </div>\n                                    <div ng-hide="!disableDropzone" class="dropzone-spinner-container">\n                                    \t<div class="dropzone-spinner" spinning-wheel is-spinning-wheel-active="disableDropzone" is-spinning-wheel-dark="true"></div>\n\t\t\t\t\t\t\t\t\t</div>       \n                                </div>\n                            </div>\n                        </div>\n                    </div>\n',
            replace: true,
            transclude: true,
            link: function link(scope) {
                scope.downloadClientsTemplate = function () {
                    fileDownloadDataService.saveClientsTemplate().catch(function (_ref) {
                        var error = _ref.error;
                        var errorTitle = error.errorTitle,
                            errorMessage = error.errorMessage;

                        messageService.showErrorFromBackend(errorTitle, errorMessage);
                    });
                };
            }
        };
    }

    importClientsModal.$inject = ['fileDownloadDataService', 'messageService'];
})();

/***/ }),

/***/ "./web/js/components/Modals/private/modalLinkEditor.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

(function () {
	function linkTip() {
		return {
			restrict: 'E',
			replace: true,
			transclude: true,
			scope: {},
			template: '<i class="fi fi-edit"></i>'
		};
	}

	angular.module('main').directive('linkTip', linkTip);
})();

(function () {
	function modalLinkEditor(messageService) {
		return {
			restrict: 'AE',
			replace: true,
			transclude: true,
			scope: {
				linkData: '=snLinkData',
				snModal: '='
			},
			template: '\n                    <div>\n                        <div id="" class="modal modal-link-editor modal-center fade" data-backdrop="false" data-keyboard="false">\n                          <div class="modal-dialog">\n                            <form class="modal-content" ng-submit="saveLink()">\n\n                              <div class="modal-header">\n                                <button type="button" class=\'close\' ng-click=\'closeModal()\'>&times;</button>\n                                <h3 class="modal-title">Insert or edit link</h3>\n                              </div>\n\n                              <div class="modal-body">\n                                <div class="field-info">\n                                  <h4>Link text</h4>\n                                  <textarea class="form-control" type="text" placeholder="Text to display"\n                                  ng-model="linkData.linkTo" required maxlength="255" style="height: 33px; padding-top: 6px !important"></textarea>\n                                </div>\n\n                                <div class="field-info">\n                                  <h4>Link to website or email address</h4>\n                                  <textarea class="form-control transition-0" type="text" placeholder="Type the website url including http:// or email address here"\n                                  ng-model="linkData.url" required maxlength="255" ng-disabled="urlLooked" style="height: 33px; padding-top: 6px !important"></textarea>\n                                </div>\n\n                              </div>\n\n                              <div class="modal-footer modal-foot">\n                                <button type=\'submit\' class="btn btn-success btn-lg">Insert link</button>\n                                <button type=\'button\' class="btn btn-default btn-lg" ng-click="removeLink()">Remove link</button>\n                              </div>\n\n                            </form>\n                          </div>\n                        </div>\n                        <div class=\'modal-link-editor__background\'></div>\n                    </div>\n            ',
			link: function link(scope) {
				var editEl = void 0;
				var lookedLinks = ['%contract_link%', '%invoice_link%', '%quote_link%', '%questionnaire_link%', '%galleries_link%'];

				scope.urlLooked = false;

				scope.saveLink = function () {
					var isEmail = void 0;
					if (isIncorrectUrl(scope.linkData.url)) {
						isEmail = isMail(scope.linkData.url);

						if (isEmail && isIncorrectMail(scope.linkData.url) || !isEmail) {
							messageService.showToaster('e_0', 'generalValidation');
							return false;
						}
					}

					if (isEmail !== undefined) {
						scope.linkData.url = 'mailto:' + scope.linkData.url;
					}
					// fix this code by rules EsLint block-scoped-var
					editEl[0].href = scope.linkData.url;
					editEl.text(scope.linkData.linkTo);
					editEl.removeClass(scope.linkData.select.slice(1));

					updateEditorData();
					clearData();
					switchModal();
				};

				scope.removeLink = function () {
					var boxEditor = editEl.parents('.sn-ta-editor');
					editEl.after('<span> </span><span>' + editEl.text() + ' </span><span> </span>');
					editEl.remove();

					updateEditorData(boxEditor);
					clearData();
					switchModal();
				};

				scope.closeModal = function () {
					if (scope.linkData.url && !isMail(scope.linkData.url) && isIncorrectUrl(scope.linkData.url) || isMail(scope.linkData.url) && isIncorrectMail(scope.linkData.url)) {
						var boxEditor = editEl.parents('.sn-ta-editor');
						editEl.after('<span>' + editEl.text() + '</span>');
						editEl.remove();

						updateEditorData(boxEditor);
					} else {
						editEl.removeClass(scope.linkData.select.slice(1));
						updateEditorData();
					}

					clearData();
					switchModal();
				};

				scope.$watch('linkData.openEditModal', function (newValue, oldValue) {
					if (newValue != oldValue) {
						console.log('newValue', newValue);
					}
				});

				scope.$watchCollection('linkData.select', function (newValue) {
					if (newValue) {
						scope.linkData.url = '';
						scope.linkData.linkTo = '';

						editEl = $(scope.linkData.select);
						var editModal = editEl.parents('.sn-ta-editor').find('.modal-link-editor');

						console.log('>>>>>');
						console.dir(editEl);
						if (editEl[0]) {
							scope.linkData.url = checkLookedLink(editEl[0].href);
							scope.linkData.linkTo = $(editEl[0]).text() || '';
						}

						$('.modal.in:not(.modal-link-editor)').children('.modal-dialog').css({ overflow: 'hidden' });

						editModal.modal('show');
						editModal.find('input').first().focus();
					} else {
						scope.linkData.url = '';
						scope.linkData.linkTo = '';
					}
				}, true);

				function clearData() {
					scope.linkData.select = '';
					scope.linkData.url = '';
					scope.linkData.linkTo = '';
					var linkEditedContainer = $('.linkEdited').parents('.sn-ta-editor');

					linkEditedContainer.removeClass(function (index, css) {
						return (css.match(/(^|\s)link-edited-id-\S+/g) || []).join(' ');
					});

					$('.linkEdited').removeClass('linkEdited');
					$('.editLinkTips').hide();
					scope.urlLooked = false;
					$('.btn-link-edit').prop('disabled', true);
				}

				function switchModal() {
					$('.in.modal-link-editor').modal('hide').on('hidden.bs.modal', function (e) {
						if ($('.in.modal').length > 0) {
							document.body.classList.add('modal-open');
							$('.modal.in:not(.modal-link-editor)').children('.modal-dialog').css({ overflow: '' });
						}

						$('.linkEdited').removeClass('linkEdited');
						$(this).off('hidden.bs.modal');
						$('.modal.in:not(.modal-link-editor)').children('.modal-dialog').css({ overflow: '' });
					});
				}

				function checkLookedLink(tmpUrl) {
					if (!tmpUrl) {
						return '';
					}

					if (tmpUrl.indexOf('mailto:') === 0) {
						return tmpUrl = tmpUrl.replace('mailto:', '');
					}

					for (var i = 0, max = lookedLinks.length; i < max; i++) {
						if (tmpUrl.indexOf(lookedLinks[i]) > -1) {
							tmpUrl = lookedLinks[i];
							scope.urlLooked = true;
							break;
						}
					}

					return tmpUrl;
				}

				function updateEditorData(parent) {
					if (!parent) {
						parent = editEl.parents('.sn-ta-editor');
					}

					var element = angular.element(parent).find('*[id*=taText]');

					element.focus();
					element.blur();

					var input = $('.modal-link-editor').find('input').first();

					input.focus();
					input.blur();
				}

				function isIncorrectUrl(url) {
					if (url.indexOf('http://') === 0 && url.length > 7) {
						return false;
					}

					if (url.indexOf('https://') === 0 && url.length > 8) {
						return false;
					}

					for (var i = 0, max = lookedLinks.length; i < max; i++) {
						if (url.indexOf(lookedLinks[i]) > -1) {
							return false;
						}
					}

					return true;
				}

				function isMail(email) {
					return email.indexOf('@') > -1;
				}

				function isIncorrectMail(email) {
					var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
					return !re.test(email);
				}
			}
		};
	}

	modalLinkEditor.$inject = ['messageService'];

	angular.module('main').directive('modalLinkEditor', modalLinkEditor);
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./web/js/components/Modals/private/modalSendMail.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, toastr, Rx) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function () {
	angular.module('main').directive('modalSendMail', modalSendMail);

	modalSendMail.$inject = ['$http', '$rootScope', '$q', '$route', '$location', 'messageService', 'jobDataService', 'fileUploadService', 'fileUploadDataService', 'validationService', 'templateRequestsService', 'emailService', 'workflowDataService', 'jobTypesDataService', 'newJobsDataService', 'workflowService', 'utilsService', 'stringModifierService', 'mailsDataService'];

	function modalSendMail($http, $rootScope, $q, $route, $location, messageService, jobDataService, fileUploadService, fileUploadDataService, validationService, templateRequestsService, emailService, workflowDataService, jobTypesDataService, newJobsDataService, workflowService, utilsService, stringModifierService, mailsDataService) {
		return {
			restrict: 'E',
			scope: {
				mailData: '<snMailData',
				isClientsOverview: '=snHideLink',
				customToken: '=snCustomToken',
				mailDataClient: '<',
				onCcResubscribe: '&',
				updateParent: '&?',
				mainShootLabelName: '=',
				extraShootLabelName: '=',
				businessNumberLabelName: '='
			},
			template: function template() {
				var templateHtml = '\n                <div id="main-wrapper" class="container">\n                    <div id="sendContactEmailModal" class="modal modal-center fade" data-backdrop="static" data-keyboard="false">\n                        <div class="modal-dialog">\n                            <form class="modal-content form-horizontal" role="form" autocomplete="off"\n                                  ng-submit="mailDataClient.status===undefined ? sendUserEmail() : sendUserEmailReply()">\n                                <div class="modal-header">\n                                    <btn-close ng-click="modalClose()"></btn-close>\n                                    <h3 class="modal-title">Send Email</h3> </div>\n                                <div class="modal-body">\n                                    <p ng-show="isClientsOverview && !isClientProfile" class="send-mail-description">Note: if you would like to send your client a quote, invoice, contract or questionnaire please\n                                        <a class="add-job-link color-java" href="javascript:void(0);" ng-click="addNewJob($event)">add a new job</a>\n                                       for this client first. All quotes, invoices, contracts and questionnaires are managed from within the job profile page.</p>\n                                    <div class="field-info">\n                                       <h4 class="mt-0">To</h4>\n\n                                        <div class="flex-row">\n\t\t\t\t\t\t\t\t\t\t\t<email-field class="w-max-100"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-if="mailDataClient.status === undefined"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t[disabled]="mailData.isDisable"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t[placeholder]="\'myclient@abc.com\'"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t[value]="sendMessageData.emailTo"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t(value-change)="setEmailData($event, \'sendMessageData\', \'emailTo\')">\n\t\t\t\t\t\t\t\t\t\t\t</email-field>\n\n\t\t\t\t\t\t\t\t\t\t\t<email-field class="w-max-100"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-if="mailDataClient.status === null"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t[value]="mailDataClient.from"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t[placeholder]="\'myclient@abc.com\'"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t(value-change)="setEmailData($event, \'mailDataClient\', \'from\')">\n\t\t\t\t\t\t\t\t\t\t\t</email-field>\n\n\t\t\t\t\t\t\t\t\t\t\t<button type="button" class="btn btn-link color-cc" ng-show="!showCcField && !mailData.isDisable" ng-click="toggleViewCc()">Add Cc </button>\n                                        </div>\n                                    </div>\n                                    <div class="field-info" ng-show="showCcField && mailDataClient.status===undefined">\n                                        <h4>Cc</h4>\n                                         <email-field [value]="sendMessageData.emailCc"\n                                         \t\t\t  [placeholder]="\'another@email.com\'"\n                                         \t\t\t  (value-change)="setEmailData($event, \'sendMessageData\', \'emailCc\')">\n\t\t\t\t\t\t\t\t\t\t</email-field>\n                                    </div>\n\n                                    <div class="field-info" ng-show="showCcField && mailDataClient.status===null">\n                                        <h4>Cc</h4>\n                                        <email-field [value]="mailDataClient.emailCc"\n                                        \t\t\t [placeholder]="\'another@email.com\'"\n                                        \t\t\t (value-change)="setEmailData($event, \'mailDataClient\', \'emailCc\')">\n\t\t\t\t\t\t\t\t\t\t</email-field>\n                                    </div>\n                                    <div class="field-info">\n\n                                        <h4>Email template</h4>\n                                        <div class="flex-row" ng-if="mailDataClient.status === undefined">\n                                            <div class="select-style flex-grow-1">\n                                                <select\n                                                 \tng-model="$parent.selectedEmailTemplate"\n                                                 \tng-change="changEmail(selectedEmailTemplate)"\n                                                  \tng-disabled = "!emailTemplates.length || button_disable"\n                                               \t\tng-options="template as template.name for template in emailTemplates | orderBy track by template.name">\n                                                    <option value="">Choose an existing email template</option>\n                                                </select>\n                                            </div>\n                                        </div>\n\n                                        <div class="flex-row" ng-if="mailDataClient.status === null">\n                                            <div class="select-style flex-grow-1">\n                                                <select ng-model="mailDataClient.choosenEmail" ng-change="changEmailClient()" ng-disabled="button_disable" ng-options="item as item.name for item in mailDataClient.emails | orderBy">\n                                                    <option value="">Choose an existing email template</option>\n                                                </select>\n                                            </div>\n                                        </div>\n                                    </div>\n\n                                    <div class="subject-row mt-20">\n                                    \t<insert-variable ng-if="customToken" class="insert-variable" [variable-list-type]="customToken + \'_SUBJECT\'" (on-variable-choose)="addSubjectVariable($event, \'subject-send-mail\')"></insert-variable>\n                                    \t<sn-input-text sn-title="Subject" sn-id="subject-send-mail" sn-model="sendMessageData.emailSubject" sn-placeholder="Write an awesome subject line. Why not?" ng-if="mailDataClient.status===undefined"></sn-input-text>\n                                    \t<sn-input-text sn-title="Subject" sn-id="subject-send-mail" sn-model="mailDataClient.emailSubject" sn-placeholder="Write an awesome subject line. Why not?" ng-if="mailDataClient.status === null"></sn-input-text>\n                                    </div>\n\n                                    <div class="field-info" ng-if="customToken" ng-class="{\'clients-overview-page\': isClientsOverview}">\n                                        <h4>Message</h4>\n                                        <sn-quill-editor-web\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-if="clientToken || isClientsOverview"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t[editor-i-d]="\'send_message_text1\'"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t[init-value]="mailDataClient.status === undefined ? sendMessageData.emailText : mailDataClient.emailText"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t[toolbar-settings]="\'variables attachments color size font\'"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t[vars-list]="customToken"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t[files-obj]="tokenAttachmentsData"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t(on-text-change)="mailDataClient.status === undefined ? (sendMessageData.emailText = $event) : (mailDataClient.emailText = $event)">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</sn-quill-editor-web>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<sn-quill-editor-web\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-if="!clientToken && !isClientsOverview"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t[editor-i-d]="\'send_message_text2\'"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t[init-value]="mailDataClient.status === undefined ? sendMessageData.emailText : mailDataClient.emailText"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t[vars-list]="customToken"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t[toolbar-settings]="\'variables attachments color size font\'"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t[files-obj]="attachmentsData"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t(on-text-change)="mailDataClient.status === undefined ? (sendMessageData.emailText = $event) : (mailDataClient.emailText = $event)">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</sn-quill-editor-web>\n                                     </div>\n                                </div>\n                                <div class="modal-footer modal-foot">\n                                    <button type="submit" class="btn btn-success btn-lg" ng-disabled="disableBtnOnSend" spinning-wheel is-spinning-wheel-active="disableBtnOnSend">Send Email </button>\n                                </div>\n                            </form>\n                        </div>\n                    </div>\n                </div>';

				return templateHtml;
			},
			link: function link(scope, element, attrs) {
				scope.isClientProfile = $location.path().includes('clients/');
				scope.isLeadPage = $location.path().includes('leads/');
				scope.isJobPage = $location.path().includes('jobs/');

				scope.clientEmails = [];
				scope.emailTemplates = [];
				scope.reminderrr = ['JOB_MENU'];
				scope.sendMessageData = {};
				scope.emailDataToSave = {};
				scope.mailDataClient = {};
				scope.emailDataToSaveReply = {};
				scope.uploadedAttachments = [];
				scope.variableSet = 'CLIENT_MENU';

				var isFirstShow = true;
				var EMPTY_ATTACHMENTS_OBJECT = {
					attachments: [],
					filesSize: 0
				};

				var attachmentsObj = JSON.parse(JSON.stringify(EMPTY_ATTACHMENTS_OBJECT));

				delete scope.sendMessage;

				scope.$watch(attrs.snCustomToken, function (token) {
					scope.customToken = token;
				});

				scope.$watch('mailData', function (newValue) {
					if (newValue) {
						setMailData(newValue);
					}
				});

				scope.$watch('showCcField', function () {
					scope.$evalAsync();
				});

				function clearAttachments() {
					scope.attachmentsData = JSON.parse(JSON.stringify(EMPTY_ATTACHMENTS_OBJECT));
				}

				scope.attachmentsData = angular.copy(attachmentsObj);
				scope.tokenAttachmentsData = angular.copy(attachmentsObj);

				function prepareEmailTemplate(mailData) {
					var email = angular.copy(mailData.task.taskEmail);
					if (email.name) {
						email.name = stringModifierService.addSelectedText(email.name);
					}
					scope.emailTemplates.push(email);
					scope.selectedEmailTemplate = email;
				}

				scope.modalClose = function () {
					delete scope.uploadedAttachments;
					delete scope.attachmentsData;
					delete scope.emailTemplates;
					delete scope.selectedEmailTemplate;
					fileUploadDataService.setCheckedFiles(null);
					if (scope.mailData.task !== undefined) {
						if (scope.isLeadPage) {
							$rootScope.updateLeadView();
						} else if (scope.isJobPage) {
							$rootScope.updateJobView();
						}
					}

					scope.showCcField = false;

					isFirstShow = true;
				};

				scope.$watchCollection('attachmentsData', function (newValue, oldValue) {
					if (newValue && newValue !== oldValue && newValue.attachments.length && newValue.attachments.length !== 0 && scope.isUserEmail) {
						addUploadedAttachments(newValue);
					}
				});

				scope.addSubjectVariable = function ($event, id) {
					var el = document.getElementById(id);
					var subject = emailService.addSubjectVariable(el, $event);
					if (scope.mailDataClient.status === undefined) {
						scope.sendMessageData.emailSubject = subject;
					}

					if (scope.mailDataClient.status === null) {
						scope.mailDataClient.emailSubject = subject;
					}
				};

				function addUploadedAttachments(attachmentsData) {
					var attachments = attachmentsData.attachments;

					scope.uploadedAttachments = [];
					angular.forEach(attachments, function (attachment) {
						if (!attachment.id) {
							scope.uploadedAttachments.push(attachment);
						} else if (attachment.hasOwnProperty('checked')) {
							var copiedAttachment = angular.copy(attachment);
							scope.uploadedAttachments.push(copiedAttachment);
						}
					});
				}

				var isUserEmail = function isUserEmail(email) {
					return !email.hasOwnProperty('emailTemplateType') && !email.hasOwnProperty('defaultEmailTemplate');
				};

				// Call this fn for errors
				function setEmptyEmailData() {
					scope.selectedEmailTemplate = null;
					scope.sendMessageData.emailSubject = '';
					scope.sendMessageData.emailText = '';
					if (scope.mailData.mailSignature) {
						scope.sendMessageData.emailText += '<br><br>' + scope.mailData.mailSignature;
					}
					scope.attachmentsData = angular.copy(attachmentsObj);
					scope.tokenAttachmentsData = angular.copy(attachmentsObj);
				}

				scope.changEmail = function (email) {
					if (email === null || email === undefined) {
						setEmptyEmailData();
					} else if (email && (typeof email === 'undefined' ? 'undefined' : _typeof(email)) === 'object') {
						var isUserEmailChosen = isUserEmail(email);
						scope.isUserEmail = isUserEmail(email);

						if (isUserEmailChosen) {
							scope.selectedEmailTemplate = email;
							scope.sendMessageData.emailSubject = email.subject || '';
							scope.sendMessageData.emailText = email.text || '';

							var attachments = angular.copy(email.storedAttachments) || [];
							if (attachments.length || scope.uploadedAttachments && scope.uploadedAttachments.length) {
								var storedAttachments = angular.copy(email.storedAttachments);
								var allAttachments = storedAttachments !== null ? angular.copy(email.storedAttachments) : [];

								if (scope.uploadedAttachments && scope.uploadedAttachments.length) {
									angular.forEach(scope.uploadedAttachments, function (attachment) {
										allAttachments.push(attachment);
									});
								}

								scope.attachmentsData = {
									attachments: allAttachments
								};
							} else {
								clearAttachments();
							}
						} else if (email.id) {
							templateRequestsService.getTemplates('full_template', email.id).subscribe(function (emailTemplate) {
								return successSetEmailTemplate(emailTemplate);
							});
						}
					} else {
						console.error('no chosen email');
					}
				};

				function successSetEmailTemplate(emailTemplate) {
					if (emailTemplate.storedAttachments && emailTemplate.storedAttachments.length) {
						scope.attachmentsData = {
							attachments: fileUploadService.convertAttachmentsToShow(emailTemplate.storedAttachments)
						};
						scope.tokenAttachmentsData = angular.copy(scope.attachmentsData);
						scope.$evalAsync();
					} else {
						scope.attachmentsData = angular.copy(attachmentsObj);
						scope.tokenAttachmentsData = angular.copy(attachmentsObj);
					}
					scope.sendMessageData.emailSubject = emailTemplate.subject || '';
					scope.sendMessageData.emailText = emailTemplate.text || '';
					scope.$evalAsync();
				}

				scope.toggleViewCc = function (state) {
					scope.showCcField = state === undefined ? !scope.showCcField : state;
					if (state === false) {
						attachmentsObj = {
							attachments: [],
							filesSize: 0
						};

						scope.attachmentsData = angular.copy(attachmentsObj);
						scope.tokenAttachmentsData = angular.copy(attachmentsObj);
					}
				};

				scope.changEmailClient = function () {
					if (!scope.mailDataClient.choosenEmail || !scope.mailDataClient.choosenEmail.id) {
						if (scope.mailDataClient.mailSignature) {
							scope.mailDataClient.emailText = '';
							scope.mailDataClient.emailText = '<br/><br/>' + scope.mailDataClient.emailTextReply + '<br/><br/>' + scope.mailDataClient.mailSignature;
						}

						scope.attachmentsData = angular.copy(attachmentsObj);
						scope.tokenAttachmentsData = angular.copy(attachmentsObj);

						return false;
					}

					templateRequestsService.getTemplates('full_template', scope.mailDataClient.choosenEmail.id).subscribe(function (emailTemplate) {
						if (emailTemplate) {
							if (emailTemplate.storedAttachments && emailTemplate.storedAttachments.length) {
								scope.attachmentsData = {
									attachments: fileUploadService.convertAttachmentsToShow(emailTemplate.storedAttachments)
								};
								scope.tokenAttachmentsData = angular.copy(scope.attachmentsData);
							} else {
								scope.attachmentsData = angular.copy(attachmentsObj);
								scope.tokenAttachmentsData = angular.copy(attachmentsObj);
							}
							scope.mailDataClient.emailSubject = emailTemplate.subject || '';
							scope.mailDataClient.emailText = '';
							scope.mailDataClient.emailText = emailTemplate.text;
						}

						scope.$evalAsync();
					});
				};

				scope.toggleViewCc = function (state) {
					scope.showCcField = state === undefined ? !scope.showCcField : state;
					if (state === false) {
						attachmentsObj = {
							attachments: [],
							filesSize: 0
						};

						scope.attachmentsData = angular.copy(attachmentsObj);
						scope.tokenAttachmentsData = angular.copy(attachmentsObj);
					}
				};

				function setMailData(newValue) {
					if (newValue === undefined) {
						return;
					}
					scope.emailTemplates = angular.copy(newValue.emails);
					scope.sendMessageData = {
						emailSubject: newValue.emailSubject || '',
						emailText: newValue.emailText || '',
						emailTo: newValue.email ? [newValue.email] : [],
						emailCc: []
					};
					if (newValue.secondaryEmail && !newValue.task) {
						scope.sendMessageData.emailTo.push(newValue.secondaryEmail);
					}
					if (newValue.mailSignature && newValue.task === undefined) {
						scope.sendMessageData.emailText += '<br><br>' + newValue.mailSignature;
					}

					if (newValue && newValue.from) {
						if (!scope.mailDataClient) {
							scope.mailDataClient = {};
						}
						scope.mailDataClient.from = newValue.from ? [newValue.from] : [];
						scope.mailDataClient.emailCc = [];
					}

					// if (isFirstShow) {
					//     isFirstShow = false;
					if (newValue.hasOwnProperty('task')) {
						var emailData = angular.copy(newValue.task.taskEmail);
						var isUserEmailChosen = isUserEmail(emailData);

						if (isUserEmailChosen) {
							scope.isUserEmail = true;
						}

						prepareEmailTemplate(newValue);
						var attachments = angular.copy(newValue.task.taskEmail.storedAttachments) || [];
						if (attachments.length) {
							scope.attachmentsData = {
								attachments: fileUploadService.convertAttachmentsToShow(attachments)
							};
						} else {
							clearAttachments();
						}
						scope.$evalAsync();
					} else {
						setEmptyEmailData();
					}
					// }
				}

				scope.setEmailData = function (newData, object, property) {
					scope[object][property] = newData;
				};

				scope.sendUserEmail = function () {
					if (scope.mailData.task !== undefined) {
						scope.mailData.task.taskEmail.emailTemplateId = scope.selectedEmailTemplate.id;
						scope.mailData.task.taskEmail.name = scope.selectedEmailTemplate.name;
						saveChangeTask(scope.mailData.task);
					} else {
						var maxSize = 10; // 10Mb
						if (scope.attachmentsData.filesSize > maxSize || scope.tokenAttachmentsData.filesSize > maxSize) {
							messageService.showToaster('w_0', 'attachments');
							return false;
						}

						var _emailText = '';

						if (scope.sendMessageData.emailText) {
							_emailText = scope.sendMessageData.emailText;
						} else if (scope.mailDataClient.emailText) {
							_emailText = scope.mailDataClient.emailText;
						} else {
							_emailText = $('.modal.in .ql-editor').getInnerHTML();
						}

						scope.sendMessageData.emailText = $rootScope.addMaiStyling(_emailText);

						var mailData = emailService.prepareEmails(scope.sendMessageData);

						if (!emailService.validateMails(mailData)) {
							return;
						}

						scope.emailDataToSave = Object.assign({}, scope.sendMessageData, mailData);

						delete scope.emailDataToSave.emailCc;

						scope.disableBtnOnSend = true;
						var url = '';
						if ($route.current.params.leadId) {
							url = '/api/user/lead/' + $route.current.params.leadId + '/send/' + scope.mailData.id + '/';
						} else if (scope.$parent.sendEmailLeadId && scope.$parent.sendEmailLeadId !== null) {
							url = '/api/user/lead/' + scope.$parent.sendEmailLeadId + '/send/' + scope.mailData.id + '/';
						} else {
							url = '/protected/rest/clients/send/' + scope.mailData.id + '/';
							url += $route.current.params.jobId ? $route.current.params.jobId : '';
						}

						scope.sendMessageData.templateId = '';
						if (scope.mailData.choosenEmail && scope.mailData.choosenEmail.id) {
							scope.sendMessageData.templateId = scope.mailData.choosenEmail.id;
						}

						var formData = new FormData();

						angular.forEach(scope.emailDataToSave, function (value, key) {
							console.debug('key: ' + key + '  | value: ' + value);
							formData.append(key, value);
						});
						var storedFiles = void 0,
						    uploadedFiles = void 0;
						var isTokenAttachmentsData = $rootScope.clientToken || scope.isClientsOverview;

						if (isTokenAttachmentsData) {
							storedFiles = scope.tokenAttachmentsData.attachments.filter(function (file) {
								return file.id;
							});
							uploadedFiles = scope.tokenAttachmentsData.attachments.filter(function (file) {
								return !file.id;
							});
						} else {
							storedFiles = scope.attachmentsData.attachments.filter(function (file) {
								return file.id;
							});
							uploadedFiles = scope.attachmentsData.attachments.filter(function (file) {
								return !file.id;
							});
						}

						angular.forEach(uploadedFiles, function (value, key) {
							formData.append('attachments[' + key + ']', value);
						});

						angular.forEach(storedFiles, function (value, key) {
							formData.append('storedAttachments[' + key + ']', value.id);
						});

						mailsDataService.sendMailRequest(url, formData).subscribe(successSendEmail, errorSendEmail);
					}
				};

				scope.sendUserEmailReply = function () {
					var maxSize = 10; // 10Mb
					if (scope.attachmentsData.filesSize > maxSize || scope.tokenAttachmentsData.filesSize > maxSize) {
						messageService.showToaster('w_0', 'attachments');
						return false;
					}

					var _emailText = '';

					if (scope.sendMessageData.emailText) {
						_emailText = scope.sendMessageData.emailText;
					} else if (scope.mailDataClient.emailText) {
						_emailText = scope.mailDataClient.emailText;
					} else {
						_emailText = $('.modal.in .ql-editor').getInnerHTML();
					}

					scope.sendMessageData.emailText = $rootScope.addMaiStyling(_emailText);

					var url = '';
					if ($route.current.params.leadId) {
						url = '/api/user/lead/' + $route.current.params.leadId + '/send/' + scope.mailDataClient.id + '/';
					} else {
						url = '/protected/rest/clients/send/' + scope.mailDataClient.contactId + '/';
						url += $route.current.params.jobId ? $route.current.params.jobId : '';
					}

					scope.mailDataClient.templateId = '';
					if (scope.mailDataClient.choosenEmail && scope.mailDataClient.choosenEmail.id) {
						scope.mailDataClient.templateId = scope.mailDataClient.choosenEmail.id;
					}

					scope.mailDataClient.emailTo = scope.mailDataClient.from;
					if (scope.mailDataClient.emailCc === null) {
						delete scope.mailDataClient.emailCc;
					}

					var mailData = emailService.prepareEmails(scope.mailDataClient);

					if (!emailService.validateMails(mailData)) {
						return;
					}

					scope.emailDataToSaveReply = Object.assign({}, scope.mailDataClient, mailData);

					delete scope.emailDataToSaveReply.emailCc;

					// sendMessageData

					var formData = new FormData();

					angular.forEach(scope.emailDataToSaveReply, function (value, key) {
						console.debug('key: ' + key + '  | value: ' + value);
						formData.append(key, value);
					});
					var storedFiles = void 0,
					    uploadedFiles = void 0;
					var isTokenAttachmentsData = $rootScope.clientToken || scope.isClientsOverview;

					if (isTokenAttachmentsData) {
						storedFiles = scope.tokenAttachmentsData.attachments.filter(function (file) {
							return file.id;
						});
						uploadedFiles = scope.tokenAttachmentsData.attachments.filter(function (file) {
							return !file.id;
						});
					} else {
						storedFiles = scope.attachmentsData.attachments.filter(function (file) {
							return file.id;
						});
						uploadedFiles = scope.attachmentsData.attachments.filter(function (file) {
							return !file.id;
						});
					}

					angular.forEach(uploadedFiles, function (value, key) {
						formData.append('attachments[' + key + ']', value);
					});

					angular.forEach(storedFiles, function (value, key) {
						formData.append('storedAttachments[' + key + ']', value.id);
					});

					scope.disableBtnOnSend = true;
					mailsDataService.sendMailRequest(url, formData).subscribe(successSendEmail, errorSendEmail);
				};

				var handleTask = function handleTask(task, taskTypes) {
					if (task.dateItem) {
						task.dateItem = task.dateItem.toLowerCase();
					}

					if (task.due && !task.hasDue) {
						// for old workflows
						task.hasDue = true;
					}

					if (!task.action && task.taskEmail) {
						// for old workflows
						task.action = 'SEND_EMAIL';
					}

					if (task.calendarEventType === 'MAIN_SHOOT') {
						var _$scope$job = $scope.job,
						    startDate = _$scope$job.startDate,
						    finishDate = _$scope$job.finishDate,
						    startTime = _$scope$job.startTime,
						    finishTime = _$scope$job.finishTime,
						    location = _$scope$job.location;

						task.location = location;
						task.startDate = startDate;
						task.endDate = finishDate;
						task.startTime = startTime;
						task.endTime = finishTime;
					} else if (task.calendarEvent) {
						var _task$calendarEvent = task.calendarEvent,
						    _startDate = _task$calendarEvent.startDate,
						    endDate = _task$calendarEvent.endDate,
						    _startTime = _task$calendarEvent.startTime,
						    endTime = _task$calendarEvent.endTime,
						    _location = _task$calendarEvent.location,
						    clientId = _task$calendarEvent.clientId;

						task.location = _location;
						task.startDate = _startDate;
						task.endDate = endDate;
						task.startTime = _startTime;
						task.endTime = endTime;
						task.sendEmails = clientId ? task.calendarEvent.sendEmails : false;

						if (task.startDate && (task.startTime === null || task.finishTime === null)) {
							task.allday = true;
						}
					}

					task.overdueDays = workflowService.calcTaskOverdue(task.overdueDays);
					task.taskViewDue = workflowService.getTaskViewDue(task, taskTypes);
					task.taskDueDefault = task.defaultTask && task.dueDate ? task.dueDate : null;
				};

				var saveTaskWithAttachments = function saveTaskWithAttachments(task) {
					prepareEmailAttachments(task.taskEmail).then(function (result) {
						task.taskEmail = result;
						saveChangeTask(task);
					}, function (error) {
						scope.button_disabled = false;
					});
				};

				var prepareEmailAttachments = function prepareEmailAttachments(taskEmail) {
					var deferred = $q.defer();
					taskEmail.attachmentsData = scope.attachmentsData;
					var isAttachments = taskEmail.attachmentsData && taskEmail.attachmentsData.attachments.length;

					if (!isAttachments) {
						deferred.resolve(taskEmail);
						return deferred.promise;
					}

					var _taskEmail$attachment = taskEmail.attachmentsData,
					    attachments = _taskEmail$attachment.attachments,
					    filesSize = _taskEmail$attachment.filesSize;

					var maxSize = 10; // 10Mb

					if (filesSize > maxSize) {
						messageService.showToaster('w_0', 'attachments');
						deferred.reject('Attachments size exceeds the limit');
						return deferred.promise;
					}

					var uploadedAttachments = void 0,
					    storedAttachments = void 0;

					if (attachments.length) {
						uploadedAttachments = attachments.filter(function (attachment) {
							return !attachment.id;
						});
						scope.storedAttachmentsForMail = attachments.filter(function (attachment) {
							return attachment.id;
						});
					}

					taskEmail.storedAttachments = storedAttachments && storedAttachments.length ? storedAttachments : null;

					if (uploadedAttachments && uploadedAttachments.length) {
						fileUploadService.convertFileToSave(uploadedAttachments).then(function (convertedFilesArr) {
							scope.base64AttachmentsForMail = convertedFilesArr;
							deferred.resolve(taskEmail);
						}).catch(function (error) {
							return console.log(error);
						});
					} else {
						deferred.resolve(taskEmail);
					}

					delete taskEmail.attachmentsData;
					return deferred.promise;
				};

				function saveChangeTask(task) {
					scope.disableBtnOnSend = true;
					task.jobId = scope.mailData.jobId;
					if (scope.mailData.choosenEmail !== undefined && scope.mailData.choosenEmail !== null) {
						task.taskEmail.emailTemplateId = scope.mailData.choosenEmail.id;
					}
					if (task.overdueDays !== null) {
						if (typeof task.overdueDays === 'string') {
							task.overdueDays = parseInt(task.overdueDays.match(/\d+/)[0], 10);
						}
					}
					task.taskEmail.subject = scope.sendMessageData.emailSubject;
					task.taskEmail.text = scope.sendMessageData.emailText;
					task.taskEmail.storedAttachments = null;
					task.taskEmail.base64Attachments = null;
					scope.uploadedAttachments = null;
					if (scope.attachmentsData.attachments && scope.attachmentsData.attachments.length !== 0) {
						task.taskEmail.storedAttachments = scope.attachmentsData.attachments.filter(function (attachment) {
							return attachment.id;
						});
						scope.uploadedAttachments = scope.attachmentsData.attachments.filter(function (attachment) {
							return !attachment.id;
						});
					}

					if (scope.uploadedAttachments && scope.uploadedAttachments.length) {
						fileUploadService.convertFileToSave(scope.uploadedAttachments).then(function (convertedFilesArr) {
							task.taskEmail.base64Attachments = convertedFilesArr;
							workflowDataService.saveTask(task).subscribe(function (data) {
								return changeTaskState(data.tasks[data.taskToAnimate]);
							}, function (error) {
								return errorSaveTask(error.data);
							});
						}).catch(function (error) {
							return console.log(error);
						});
					} else {
						workflowDataService.saveTask(task).subscribe(function (data) {
							return changeTaskState(data.tasks[data.taskToAnimate]);
						}, function (error) {
							return errorSaveTask(error);
						});
					}
				}

				function errorSaveTask(data) {
					scope.isSentSpinnningWheelActive = false;
					scope.disableBtnOnSend = false;
					workflowService.errorSaveTask(data);
				}

				function changeTaskState(task) {
					task.completed = true;
					newJobsDataService.changeTaskState(scope.mailData.jobId, task).finally(function () {
						$rootScope.dnd.canMove = true;
						scope.disableBtnOnSend = false;
					}).subscribe(function (data) {
						toastr.clear();
						task = Object.assign(task, data);
						handleTask(task, scope.mailData.sortedTasksArr);
						isFirstShow = true;
						messageService.showToaster('s_4', 'clients');
						$('#sendContactEmailModal').modal('hide');
						messageService.showToaster('i_0', 'jobView');
						if (scope.isLeadPage) {
							$rootScope.updateLeadView();
						} else if (scope.isJobPage) {
							$rootScope.updateJobView();
						}
					}, function (result) {
						toastr.clear();
						var error = result.error;

						if (error) {
							var errorMessage = error.errorMessage,
							    errorTitle = error.errorTitle;

							messageService.showErrorFromBackend(errorTitle, errorMessage);
							return;
						}
						messageService.showDefaultErrorMessage(result);
					});
				}

				function successSendEmail() {
					scope.disableBtnOnSend = false;
					scope.$evalAsync();
					isFirstShow = true;
					messageService.showToaster('s_4', 'clients');

					$('#sendContactEmailModal').modal('hide');

					if (scope.updateParent) {
						return scope.updateParent({ resetPagination: false });
					}

					if (scope.isLeadPage && $rootScope.updateLeadView) {
						if (scope.mailData.task !== undefined) {
							// changeTaskState(scope.mailData.task);
						} else {
							$rootScope.updateLeadView();
						}
					}

					if (scope.isJobPage && $rootScope.updateJobView) {
						if (scope.mailData.task !== undefined) {
							// changeTaskState(scope.mailData.task);
						} else {
							$rootScope.updateJobView();
						}
					}
					if ($rootScope.updateClientView && $location.path().includes('/clients/')) {
						$rootScope.updateClientView();
					}
					scope.disableBtnOnSend = false;
					scope.showCcField = false;

					for (var prop in scope.sendMessageData) {
						scope.sendMessageData[prop] = '';
					}

					delete scope.attachmentsData;
					delete scope.uploadedAttachments;
					scope.tokenAttachmentsData.attachments.length = 0;
					scope.$evalAsync();
				}

				function errorSendEmail(_ref) {
					var status = _ref.status,
					    data = _ref.data,
					    error = _ref.error;

					isFirstShow = false;
					scope.disableBtnOnSend = false;
					var errorMessage = error.errorMessage,
					    errorTitle = error.errorTitle;


					var path = $location.path();
					var isClientsOverview = path.includes('clients');
					if (status >= 400 && status < 500 && data.errorMessage) {
						if (status === 423) {
							var limit = $rootScope.isUserTrial ? 50 : 150;
							return messageService.showToaster('e_4', 'generalValidation', limit);
						} else if (data.errorMessage.includes('Email address inactive')) {
							messageService.showToaster('e_1', 'generalValidation', scope.sendMessageData.emailTo);
						} else if (data.errorMessage.includes('Lead is archived')) {
							messageService.showToaster('e_5', 'lead');
						} else if (isClientsOverview && data.errorMessage.includes('job-related variables')) {
							messageService.showToaster('e_7', 'clients');
						} else if (errorTitle) {
							messageService.showErrorFromBackend(errorTitle, errorMessage);
						} else {
							messageService.showToaster('e_2', 'general', errorMessage);
						}
					} else {
						messageService.showToaster('e_0', 'general');
					}
				}

				function getJobTypes() {
					return jobTypesDataService.getJobTypes().map(function (data) {
						return successGetJobTypes(data);
					});
				}

				function successGetJobTypes(data) {
					scope.newJob.jobTypes = angular.copy(data);
				}

				function getWorkflowNames() {
					return workflowDataService.getWorkflowNames().map(function (data) {
						return successGetWorkflowNames(data);
					});
				}

				function successGetWorkflowNames(data) {
					if (!data) {
						return false;
					}
					scope.newJob.workflowNames = angular.copy(data);
				}

				function showNewJobModal(event) {
					var selectModal = '#sendContactEmailModal',
					    nextModal = '#newJob';
					scope.$broadcast('showModalJob', scope.newJob);
					utilsService.showNextModal(selectModal, nextModal, event);
				}

				scope.addNewJob = function (event) {
					scope.newJob = {};
					scope.clients = [];
					var primaryClientSearchText = jobDataService.fillClientSearchText(scope.mailData);
					scope.clients[0] = primaryClientSearchText;
					scope.newJob.primaryContact = scope.clients[0];
					scope.workflowNames = [];

					Rx.Observable.zip(getJobTypes(), getWorkflowNames())
					// .takeUntil($scope.unsubscribe)
					.subscribe(function () {
						return showNewJobModal(event);
					});
				};

				scope.disableDragDrop = function () {
					return true;
				};

				$('#sendContactEmailModal').on('show.bs.modal', function () {
					scope.$broadcast('addedFileEvent');
					$('#sendContactEmailModal').find('input').prop('autocomplete', 'off');

					if (typeof scope.mailDataClient === 'undefined' || scope.mailDataClient === null || !scope.mailDataClient.hasOwnProperty('emailText')) {
						scope.mailDataClient = {};
					} else if (scope.mailDataClient.emailText === '' || scope.mailDataClient.emailText === '<p></p>') {
						scope.mailDataClient.emailText = '<br><br>' + scope.mailDataClient.emailTextReply + '<br>';

						if (scope.mailDataClient.subject.indexOf('RE:') !== -1) {
							scope.mailDataClient.subject = 'RE: ' + scope.mailDataClient.subject;
						}
					}
				}).on('shown.bs.modal', function () {
					var input = $('input');
					var select = $('select');

					validationService.isModalClosePrevented(input);
					validationService.isModalClosePrevented(select);
				});
			}
		};
	}
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js"), __webpack_require__("./node_modules/toastr/toastr.js"), __webpack_require__("./node_modules/rxjs/Rx.js")))

/***/ }),

/***/ "./web/js/components/Modals/private/updateJobModal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, toastr) {

var _operators = __webpack_require__("./node_modules/rxjs/operators.js");

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

(function () {
	angular.module('main').directive('updateJobModal', updateJobModal);

	updateJobModal.$inject = ['$rootScope', '$route', '$location', '$timeout', 'newJobsDataService', 'clientsDataService', 'clientService', 'jobService', 'messageService', 'timeService', 'validationService', 'timeConverter', 'stringModifierService', 'settingsService', 'utilsService', 'leadSourcesDataService', 'languageDataService', 'doubleBookingService'];

	function updateJobModal($rootScope, $route, $location, $timeout, newJobsDataService, clientsDataService, clientService, jobService, messageService, timeService, validationService, timeConverter, stringModifierService, settingsService, utilsService, leadSourcesDataService, languageDataService, doubleBookingService) {
		return {
			restrict: 'E',
			scope: {
				updateParent: '&?',
				mainShootLabelName: '=',
				extraShootLabelName: '=',
				businessNumberLabelName: '='
			},
			template: '<section id="main-wrapper" class="container">\n                         <div id="newJob" class="modal modal-center fade" data-backdrop="static" data-keyboard="false" data-autotest-modal="newEditJob">\n                                <div class="modal-dialog modal-dialog-datepicker">\n                                    <div class="modal-content">\n                                        <form class="form form-horizontal" role="form" ng-submit="addOrUpdateJob()">\n                                            <div class="modal-header pt-pb-15">\n                                                <btn-close ng-click="clearJobInfo()"></btn-close>\n                                                <h3 class="modal-title">{{ job.id || job.id === 0 ? \'Edit Job\' : \'New Job\' }}</h3>\n                                            </div>\n                                            <div class="modal-body" style="padding: 30px!important">\n\n                                                <h3 class="mt-0 mb-30">Primary client contact</h3>\n\n                                                <div class="clearfix grey-group-item mb-0 ps-0 text-xs-center text-sm-left">\n                                                    <div class="col-xs-12 col-sm-2 text-nowrap">\n                                                        <h4>Choose client</h4>\n                                                    </div>\n                                                    <div class="col-xs-12 col-sm-6">\n                                                        <input placeholder="Start entering client name" class="form-control" type="text" autocomplete="off"\n                                                               typeahead="idName as idName.name  for idName in idsNames | filter:$viewValue"\n                                                               ng-model="job.primaryContact">\n                                                    </div>\n                                                    <div class="col-xs-12 col-sm-1 row visible-xs-block">\n                                                        <h4>OR</h4>\n                                                    </div>\n                                                    <div class="col-xs-12 col-sm-4 flex-row">\n                                                        <h4 class="hidden-xs flex-grow-1 ml-n7">OR</h4>\n                                                        <button type="button" ng-disabled="button_disable"\n                                                                ng-click="createNewClient(0, $event)"\n                                                                class="btn btn-info btn-add-new-sm mb-0 fs-14" data-autotest-button="addNewClientFirst">Add new client\n                                                        </button>\n                                                    </div>\n                                                </div>\n\n                                                <div class="clearfix grey-group-item m-30 ps-0 second-client" ng-show="showSecondClient">\n                                                    <div class="col-xs-12 col-sm-2 text-nowrap">\n                                                        <h4>Choose client</h4>\n                                                    </div>\n                                                    <div class="col-xs-12 col-sm-6">\n                                                        <input placeholder="Start entering client name" class="form-control" type="text"\n                                                               typeahead="idName as idName.name for idName in idsNames | filter:$viewValue"\n                                                               ng-model="job.secondaryContact">\n                                                    </div>\n                                                    <div class="col-xs-12 col-sm-1 row visible-xs-block">\n                                                        <h4>OR</h4>\n                                                    </div>\n                                                    <div class="col-xs-12 col-sm-4 flex-row">\n                                                        <h4 class="hidden-xs flex-grow-1 ml-n7">OR</h4>\n                                                        <button type="button" ng-disabled="button_disable"\n                                                                ng-click="createNewClient(1, $event)"\n                                                                class="btn btn-info btn-add-new-sm mb-0 fs-14" data-autotest-button="addNewClientSecond">Add new client\n                                                        </button>\n                                                    </div>\n                                                    <button type="button" class="close" ng-disabled="button_disable"\n                                                            ng-click="remove()" data-autotest-button="close">&times;</button>\n                                                </div>\n\n                                                <button type="button" ng-if="!showSecondClient" ng-disabled="button_disable" ng-click="add()"\n                                                        class="btn btn-info btn-add-new-sm mt-20" data-autotest-button="addSecondaryClient">\n                                                    <span class="hidden-xs fs-14">Add secondary client contact</span>\n                                                    <span class="visible-xs fs-14">Add secondary</span>\n                                                </button>\n\n                                                <hr>\n                                                <h3 class="mt-30 mb-25">Job details</h3>\n                                                <div class="row">\n                                                    <div class="col-sm-2">\n                                                        <label class="control-label">Job name:</label>\n                                                    </div>\n                                                    <div class="col-sm-8 mb-15">\n                                                        <input type="text" id="job-name" autocomplete="off" class="form-control" maxlength="255" placeholder="Jenny & Matt"\n                                                               ng-model="job.name" required>\n                                                    </div>\n                                                </div>\n\n                                                <div class="row">\n\n                                                    <div class="col-sm-2">\n                                                        <label class="control-label">Job type:</label>\n                                                    </div>\n                                                    <div class="col-sm-8 mb-15">\n                                                        <div class="select-style">\n                                                             <select id="job-type"\n                                                                    ng-model="job.type"\n                                                                    ng-change="typeChanged(job.type)"\n                                                                    ng-options="jobType.name for jobType in job.jobTypes | orderBy:\'name\' track by jobType.name"\n                                                             ></select>\n                                                        </div>\n                                                    </div>\n                                                </div>\n\n                                                 <div class="row">\n                                                    <div class="col-sm-2">\n                                                        <label class="control-label">Workflow:</label>\n                                                    </div>\n                                                    <div class="col-sm-8 mb-15">\n                                                        <div class="select-style">\n                                                            <select ng-options="workflow.name for workflow in job.workflowNames | orderBy:\'name\' track by workflow.name"\n                                                                    ng-model="job.workflow"\n                                                                    ng-disabled="disableWorkflow">\n                                                                    <option value="" ng-show="disableWorkflow">Default</option>\n                                                            </select>\n\n                                                        </div>\n                                                    </div>\n                                                    <div class="col-sm-8 col-sm-offset-2 select-style-error" ng-show="disableWorkflow">\n                                                        Custom workflow cannot be applied to past jobs.\n                                                    </div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="col-sm-8 col-sm-offset-2 select-style-error" ng-if="job.workflow.automatedTasks">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tThis workflow contains automated tasks.\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n                                                </div>\n\n                                                <div class="row" ng-if="leadSourcesAvailable">\n                                                    <div class="col-sm-2 pr-0">\n                                                        <label class="control-label">Lead Source:</label>\n                                                    </div>\n                                                    <div class="col-sm-8 mb-15">\n                                                        <div class="select-style">\n                                                            <select id="lead-type"\n                                                                    ng-model="job.leadSource"\n                                                                    ng-options="leadSource.name for leadSource in leadSources | orderBy:\'name\' track by leadSource.name"\n                                                             ><option value="">None</option></select>\n                                                        </div>\n                                                    </div>\n                                                </div>\n\n                                                <div ng-if="languages && languages.length > 1" class="row">\n                                                  <div class="col-sm-2 pr-0">\n                                                      <label class="control-label">Client Portal:</label>\n                                                  </div>\n                                                  <div class="col-sm-8 mb-15">\n                                                      <div class="select-style">\n                                                          <select id="job-language"\n                                                                  ng-model="job.language"\n                                                                  ng-options="language.displayName for language in languages | orderBy:\'displayName\' track by language.name"\n                                                          ></select>\n                                                      </div>\n                                                  </div>\n                                                </div>\n\n                                                <hr>\n                                                <h3 class="mt-30 mb-25">{{mainShootLabelName}}</h3>\n\n                                                <div class="flex-row mb-25">\n                                                    <div class="checkbox-squared">\n                                                        <input type="checkbox" id="noDateJob" ng-model="job.hasNoDate"/>\n                                                        <label for="noDateJob"></label>\n                                                    </div>\n\n                                                    <label for="noDateJob">\n                                                       No date has been confirmed yet\n                                                    </label>\n                                                </div>\n\n                                                <section ng-if="!job.hasNoDate">\n\n                                                    <div class="row">\n\n                                                        <div class="col-sm-2">\n                                                            <label class="control-label">Date:</label>\n                                                        </div>\n\n                                                        <div class="col-sm-8 job-date">\n                                                            <div class="flex-row flex-wrap-xs">\n                                                                <div class="flex-grow-1 mb-15 box-no-transition datepicker-static under-input"  ng-class="{\'overlap-warning\': !!doubleBookingData}">\n\n                                                                    <input ng-model="job.startDate" class="form-control"\n                                                                           ng-change="job.finishDate = job.startDate"\n                                                                           type="date" name="input"\n                                                                           data-placeholder="{{datapickerDateFormat}}"\n                                                                           min="2001-12-31"\n                                                                           max="2999-12-31"\n                                                                           data-date=\'{"startView": 2, "openOnMouseFocus": true}\' required/>\n                                                                </div>\n\n                                                                <div class="flex-basis-xs ms-15 mb-15 fs-16">to</div>\n\n                                                                <div class="flex-grow-1 mb-15 box-no-transition datepicker-static under-input"  ng-class="{\'overlap-warning\': !!doubleBookingData}">\n                                                                    <input ng-model="job.finishDate" class="form-control"\n                                                                           type="date" name="input"\n                                                                           data-placeholder="{{datapickerDateFormat}}"\n                                                                           min="{{( job.startDate ) ? ( job.startDate | date : \'yyyy-MM-dd\') : (now | date : \'yyyy-MM-dd\') }}"\n                                                                           max="2999-12-31"\n                                                                           data-date=\'{"startView": 2, "openOnMouseFocus": true}\' required/>\n                                                                </div>\n                                                            </div>\n                                                        </div>\n\n                                                        <div class="col-sm-2 mb-15 pt-6 flex-row">\n                                                            <div class="checkbox-squared">\n                                                                <input type="checkbox" id="checkbox-squared-all-job-day-event" ng-model="job.allday"/>\n                                                                <label for="checkbox-squared-all-job-day-event"></label>\n                                                            </div>\n                                                            <label for="checkbox-squared-all-job-day-event">All day</label>\n                                                        </div>\n                                                    </div>\n\n\n                                                    <div class="row">\n                                                        <div class="col-sm-2">\n                                                            <label class="control-label">Time:</label>\n                                                        </div>\n                                                        <div class="col-sm-8 job-date">\n                                                             <div class="flex-row flex-wrap-xs">\n                                                                <div class="flex-grow-1 mb-15"  ng-class="{\'overlap-warning\': !!doubleBookingData}">\n                                                                    <sn-timepicker dom-time="job_start_time" sn-dr-model="job.startTime" sn-dr-checked="job.allday"></sn-timepicker>\n                                                                </div>\n                                                                <div class="flex-basis-xs ms-15 mb-15 fs-16">to</div>\n                                                                <div class="flex-grow-1 mb-15"  ng-class="{\'overlap-warning\': !!doubleBookingData}">\n                                                                    <sn-timepicker dom-time="job_finish_time" sn-dr-model="job.finishTime" sn-dr-checked="job.allday"></sn-timepicker>\n                                                                </div>\n                                                            </div>\n                                                        </div>\n                                                    </div>\n\n                                               </section>\n\n                                                <div class="flex-row flex-wrap-xs warning-message m-0 mb-25" ng-if="job.hasNoDate">\n                                                \t<warning-sign-img></warning-sign-img>\n                                                    <div class="warning-message__text">\n                                                        <p>This job has no date:</p>\n                                                        <ul>\n                                                            <li>The {{ mainShootLabelName | lowercase }} will not appear in your Calendar.</li>\n                                                            <li>Automated workflow tasks dependent on {{ mainShootLabelName | lowercase }} date will not trigger.</li>\n                                                            <li>The %job_date% variable will display "No date".</li>\n                                                        </ul>\n                                                    </div>\n                                                </div>\n\n\n\n                                                <div class="row">\n                                                    <div class="col-sm-2">\n                                                        <label class="control-label">Location:</label>\n                                                    </div>\n                                                    <input type="text" class="hide hidden form-control" name="job.location"\n                                                           ng-model="job.location"/>\n                                                    <div class="col-sm-8 mb-15 box-no-transition" ng-controller="GoogleAutocompleteController">\n                                                        <input type="text" id="AutocompleteJobModal" ng-model="autocomplete" placeholder=""\n                                                               class="form-control" ng-autocomplete options="options" details="details"/>\n                                                    </div>\n                                                </div>\n\n                                                 <div class="row" ng-hide="job.hasNoDate" ng-if="searchingEvents">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="col-sm-12">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="db-event-loading mt-10 mb-25">Loading...</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="row" ng-hide="job.hasNoDate" ng-if="!searchingEvents && doubleBookingData">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="col-sm-12 mt-10 mb-25">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<events-overlapping-info [data]="doubleBookingData"></events-overlapping-info>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\n                                             \t<div class="row">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="col-sm-12">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<hr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<h3 class="mt-30 mb-25">Job Notes:</h3>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<sn-quill-editor-web\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t[init-value]="job.notes"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t[toolbar-settings]="\'color size font\'"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t[styles]="{height: \'300px\'}"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t(on-text-change)="job.notes = $event">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</sn-quill-editor-web>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\n                                            </div>\n                                            <div class="modal-footer modal-foot">\n                                                <button type="submit" ng-disabled="button_disable"\n                                                        class="btn btn-success btn-lg"\n                                                        spinning-wheel is-spinning-wheel-active="button_disable"\n                                                >Save Job</button>\n                                            </div>\n                                        </form>\n                                    </div>\n                                </div>\n                            </div>\n                            <create-new-client-modal id="createNewJobClientModal"\n                                                     company-name-checked="companyNameChecked"\n                                                     client="newClient"\n                                                     save-client="saveClient(event)"\n                                                     on-close="closeAddClient(event)"\n                                                     is-create-client-modal-spinnning-wheel-active="isCreateClientModalSpinnningWheelActive"\n                                                     business-number-label-name="businessNumberLabelName"\n                            ></create-new-client-modal>\n                         </section>\n\n',
			replace: true,
			transclude: true,
			link: function link(scope) {
				var clientsSearchTimer = void 0;

				scope.$on('showModalJob', function (event, job) {
					scope.job = angular.copy(job);

					if (scope.job.languageNames) {
						var _scope$job$languageNa = scope.job.languageNames,
						    selected = _scope$job$languageNa.selected,
						    availableList = _scope$job$languageNa.availableList;

						scope.job.language = scope.job.language || selected;
						scope.languages = availableList || [];
						if (scope.job.language.name && !scope.languages.some(function (el) {
							return el.name === scope.job.language.name;
						})) {
							scope.languages = scope.languages.concat(scope.job.language).sort(function (a, b) {
								return a.displayName.localeCompare(b.displayName);
							});
						}
					} else {
						scope.languages = [];
					}

					scope.leadSources = [];
					if (scope.job.leadSource) {
						var leadSource = scope.job.leadSource;

						if (leadSource.status === 'ARCHIVED') {
							leadSource.name += ' (archived)';
						}
						scope.leadSources.push(leadSource);
					}
					scope.searchingEvents = false;
					scope.now = new Date();
					scope.now.setHours(0, 0, 0, 0);
					scope.idsNames = [];
					scope.newClient = {};
					scope.doubleBookingData = null;

					settingsService.timeFormatSettings.subscribe(function (data) {
						scope.dataFormatMonth = data.dateFormat;
						scope.leadSourcesAvailable = data.leadSourcesAvailable;
					});

					leadSourcesDataService.getActiveLeadSourcesList().subscribe(function (data) {
						var leadSource = scope.job.leadSource;

						leadSource && leadSource.status === 'ARCHIVED' ? scope.leadSources = [].concat(_toConsumableArray(scope.leadSources), _toConsumableArray(data.data)) : scope.leadSources = [].concat(_toConsumableArray(data.data));
					});

					scope.datapickerDateFormat = scope.dataFormatMonth === 'DD_MM_YYYY' ? 'dd/mm/yyyy' : 'mm/dd/yyyy';

					if (scope.job.secondaryContact === null || scope.job.secondaryContact === undefined) {
						scope.showSecondClient = false;
					} else {
						scope.showSecondClient = true;
					}

					if (!job.id) {
						var defaultType = scope.job.jobTypes.find(function (type) {
							return type.default === true;
						});
						scope.job.type = defaultType;
						scope.job.workflow = defaultType.workflow;
					}
					if (job.id && job.startTime) {
						scope.job.startTime = timeConverter.convert24to12(scope.job.startTime);
						scope.job.finishTime = timeConverter.convert24to12(scope.job.finishTime);
					}

					checkJobDate(scope.job.startDate);
					$('#newJob').find('input.ws-date').prop('autocomplete', 'off');
				});

				scope.$watch('job.startDate', checkJobDate);
				scope.$watch('job.finishDate', reactToDateTimeChange);
				scope.$watch('job.finishTime', reactToDateTimeChange);
				scope.$watch('job.allday', reactToDateTimeChange);

				scope.$watch('job.startTime', function (newValue, oldValue) {
					if (scope.job && newValue && newValue !== oldValue) {
						var startTime24 = timeConverter.convert12to24(newValue);
						var startHour = timeService.getHour(startTime24);
						var startMin = timeService.getMinutes(startTime24);

						var finishTime24 = timeConverter.convert12to24(scope.job.finishTime);
						var finishHour1 = timeService.getHour(finishTime24);
						if (!scope.job.id || !scope.job.finishTime) {
							var finishHour = startHour + 1;

							if (finishHour > 23) {
								finishHour = 0;
							}

							var finishTime = finishHour + ':' + startMin;

							scope.job.finishTime = timeConverter.convert24to12(finishTime);
						}
						if (startHour === finishHour1 - 1 || startHour === finishHour1) {
							var _finishHour = startHour + 1;

							if (_finishHour > 23) {
								_finishHour = 0;
							}

							var _finishTime = _finishHour + ':' + startMin;

							scope.job.finishTime = timeConverter.convert24to12(_finishTime);
						}

						checkForOverlappingEvents();
					}
				});

				scope.$watch('job.secondaryContact', function (newValue, oldValue) {
					if (newValue === null || newValue === undefined || oldValue === newValue) {
						return false;
					}

					if (newValue.length > 0) {
						if (clientsSearchTimer != null) {
							clearTimeout(clientsSearchTimer);
						}

						clientsSearchTimer = setTimeout(findAllMatchingClientNames(newValue), 500);
					} else {
						clearTimeout(clientsSearchTimer);
					}
				});

				scope.$watch('job.primaryContact', function (newValue, oldValue) {
					if (newValue === null || newValue === undefined || oldValue === newValue) {
						return;
					}
					if (newValue.length > 0) {
						if (clientsSearchTimer != null) {
							clearTimeout(clientsSearchTimer);
						}

						clientsSearchTimer = setTimeout(findAllMatchingClientNames(newValue), 500);
					} else {
						clearTimeout(clientsSearchTimer);
					}
				});

				scope.typeChanged = function (type) {
					if (scope.job.id) {
						return;
					}

					if (!scope.disableWorkflow) {
						scope.job.workflow = type.workflow;
					}
				};

				function setFinishDate(jobStartDate) {
					if (!scope.job.finishDate || jobStartDate > scope.job.finishDate) {
						scope.job.finishDate = jobStartDate;
					}
				}

				function getDefaultWorkflow(workflows) {
					return workflows.find(function (workflow) {
						return workflow.name === 'Default';
					});
				}

				function checkJobDate(jobStartDate) {
					if (scope.job && jobStartDate) {
						if (!scope.job.id) {
							setFinishDate(jobStartDate);
							scope.disableWorkflow = new Date(jobStartDate) < scope.now;

							if (scope.disableWorkflow) {
								scope.job.workflow = getDefaultWorkflow(scope.job.workflowNames);
							}
							checkForOverlappingEvents();
						} else {
							if (scope.job.hasNoDate) {
								setFinishDate(jobStartDate);
							}
							scope.disableWorkflow = new Date(jobStartDate) < scope.now;
							if (scope.disableWorkflow) {
								scope.job.workflow = scope.job.oldWorkflow;
								scope.job.workflow.id = -1;
							}
						}
					}
				}

				function findAllMatchingClientNames(search) {
					clientsDataService.searchClient(search).subscribe(function (data) {
						return findClientSuccessCallback(data);
					}, function (err) {
						return messageService.showDefaultErrorMessage(err);
					});
				}

				function findClientSuccessCallback(client) {
					if (client) {
						scope.idsNames = [];
						client.forEach(function (item) {
							return scope.idsNames.push(item);
						});
					}
				}

				scope.createNewClient = function (clientIndex, event) {
					scope.newClient = {};
					utilsService.showNextModal('#newJob', '#createNewJobClientModal', event);
					scope.clientIndex = clientIndex;
				};

				scope.closeAddClient = function (event) {
					utilsService.showNextModal('#createNewJobClientModal', '#newJob', event);
				};

				scope.saveClient = function (event) {
					scope.isCreateClientModalSpinnningWheelActive = true;
					var lowercasedEmail = scope.newClient.email.toLowerCase();
					scope.newClient.email = lowercasedEmail;

					var client2SaveIndex = scope.clientIndex;
					if (!scope.companyNameChecked) {
						delete scope.newClient.companyName;
					}

					if (!validationService.isEmailValid(scope.newClient.email)) {
						scope.isCreateClientModalSpinnningWheelActive = false;
						return messageService.showToaster('e_3', 'companyUsers');
					}

					var clientFirstName = scope.newClient.firstName || '';

					if (!clientFirstName && !clientFirstName.trim()) {
						return messageService.showToaster('e_4', 'clients');
					}

					if (scope.newClient) {
						scope.newClient.notes = $rootScope.addMaiStyling(scope.newClient.notes);
					}

					clientsDataService.addNewClient(scope.newClient).finally(function () {
						return scope.isCreateClientModalSpinnningWheelActive = false;
					}).subscribe(function (data) {
						return successAddNewClient(data, client2SaveIndex, event);
					}, function () {
						return messageService.showToaster('e_6', 'clients');
					});
				};

				function successAddNewClient(data, client2SaveIndex, event) {
					scope.isCreateClientModalSpinnningWheelActive = false;
					if (data.errorMessage) {
						toastr.error(data.errorMessage, 'Error');
						return false;
					}

					delete scope.client;

					var clientSearchObj = clientService.fillClientSearchText(data);

					switch (client2SaveIndex) {
						case 0:
							var primaryClientSearchText = angular.copy(clientSearchObj);
							scope.job.primaryContact = primaryClientSearchText;
							break;
						case 1:
							var secondaryClientSearchText = angular.copy(clientSearchObj);
							scope.job.secondaryContact = secondaryClientSearchText;
							break;
						default:
							console.error('Unexpected client index');
					}

					messageService.showToaster('s_2', 'clients');
					utilsService.showNextModal('#createNewJobClientModal', '#newJob', event);
				}

				scope.addOrUpdateJob = function () {
					delete $rootScope.error;

					var jobClients = [scope.job.primaryContact, scope.job.secondaryContact];
					var dataToSave = jobService.validateJob(scope.job, jobClients);

					if (dataToSave === false) {
						return false;
					}
					scope.button_disable = true;
					editJobRequest(dataToSave);
				};

				function editJobRequest(job) {
					newJobsDataService.editJob(job).finally(function () {
						scope.button_disable = false;
					}).subscribe(function (data) {
						updateIntercom(job);
						editJobSuccessCallback(data, job.id);
					}, function (err) {
						return editJobErrorCallback(err);
					});
				}

				function updateIntercom(job) {
					var metadata = {
						job_name: job.name,
						job_scheduled: job.startDate
					};
					Intercom('trackEvent', 'created job', metadata);
				}

				function editJobSuccessCallback(data, jobId) {
					if (jobId === undefined) {
						messageService.showToaster('s_0', 'job');
						$('#newJob').modal('hide');
					} else {
						messageService.showToaster('s_1', 'job');
						$('#newJob').modal('hide');
						leadSourcesDataService.updateLeadSourcesEvent(true);
					}

					if (data.id && !jobId) {
						$timeout(function () {
							$location.path('/jobs/view/' + data.id);
						}, 300);
					} else if (scope.updateParent) {
						scope.updateParent({ resetPagination: false });
					} else {
						$timeout(function () {
							$route.reload();
						}, 300);
					}
				}

				function editJobErrorCallback(err) {
					var data = err.data,
					    status = err.status,
					    error = err.error;


					if (error && error.errorCode === 102) {
						var errorTitle = error.errorTitle,
						    errorMessage = error.errorMessage;

						messageService.showErrorFromBackend(errorTitle, errorMessage);
					} else {
						var _errorMessage = data ? data.errorMessage : null;

						var errorCode = void 0,
						    errorPlace = void 0;

						if (_errorMessage && status >= 400 && status < 500) {
							if (status === 422 && _errorMessage.includes('Job contact can not be changed because invoices have Xero payment')) {
								errorCode = 'e_16';
								errorPlace = 'xero';
							} else if (_errorMessage.includes('Xero access token expired, reconnect Xero please') || _errorMessage.includes('Bummer! Xero access token not authorized or revoked, reconnect Xero please') || _errorMessage.includes('Bummer! Xero access token revoked, reconnect Xero please')) {
								errorCode = 'e_14';
								errorPlace = 'xero';
							} else if (_errorMessage.includes("You don't have an active Xero subscription")) {
								errorCode = 'e_15';
								errorPlace = 'xero';
							}
						} else {
							errorCode = 'e_0';
							errorPlace = 'general';
						}
						messageService.showToaster(errorCode, errorPlace);
					}
				}

				scope.remove = function () {
					delete scope.job.secondaryContact;
					scope.showSecondClient = false;
				};

				scope.clearJobInfo = function () {
					delete scope.disableWorkflow;
				};

				scope.add = function () {
					var emptyClient = {
						name: ''
					};
					scope.job.secondaryContact = emptyClient;
					scope.showSecondClient = true;
				};

				function reactToDateTimeChange(newValue, oldValue) {
					if (!newValue) {
						scope.doubleBookingData = null;
					}
					if (scope.job && newValue && newValue !== oldValue || newValue === false) {
						checkForOverlappingEvents();
					}
				}

				function checkForOverlappingEvents() {
					var hasDate = scope.job.startDate && scope.job.finishDate;
					var hasTimeOrAllDay = scope.job.allday || scope.job.startTime && scope.job.finishTime && !scope.job.allday;

					if (hasDate && hasTimeOrAllDay) {
						scope.button_disable = true;
						scope.searchingEvents = true;
						doubleBookingService.getOverlappingEvents(doubleBookingService.gatherDateTimeData(scope.job), 'JOB', scope.job.id).pipe((0, _operators.finalize)(function () {
							scope.searchingEvents = false;
							scope.button_disable = false;
						})).subscribe(function (data) {
							return scope.doubleBookingData = data;
						});
					}
				}
			}
		};
	}
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js"), __webpack_require__("./node_modules/toastr/toastr.js")))

/***/ }),

/***/ "./web/js/components/Modals/private/updateLeadModal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, toastr) {

var _operators = __webpack_require__("./node_modules/rxjs/operators.js");

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

(function () {
	angular.module('main').directive('updateLeadModal', updateLeadModal);

	updateLeadModal.$inject = ['$rootScope', '$route', '$location', '$timeout', 'clientsDataService', 'clientService', 'messageService', 'timeService', 'validationService', 'leadDataService', 'leadService', 'timeConverter', 'stringModifierService', 'settingsService', 'utilsService', 'leadSourcesDataService', 'languageDataService', 'doubleBookingService'];

	function updateLeadModal($rootScope, $route, $location, $timeout, clientsDataService, clientService, messageService, timeService, validationService, leadDataService, leadService, timeConverter, stringModifierService, settingsService, utilsService, leadSourcesDataService, languageDataService, doubleBookingService) {
		return {
			restrict: 'E',
			scope: {
				updateParent: '&?',
				mainShootLabelName: '=',
				extraShootLabelName: '=',
				businessNumberLabelName: '='
			},
			template: '\n                <section id="main-wrapper" class="container">\n                    <div id="newLead" class="modal modal-center fade" data-backdrop="static" data-keyboard="false"\n                         data-autotest-modal="newEditLead">\n                        <div class="modal-dialog modal-dialog-datepicker">\n                            <div class="modal-content">\n                                <form class="form form-horizontal" role="form" ng-submit="addOrUpdateLead(lead.id)">\n                                    <div class="modal-header pt-pb-15">\n                                        <btn-close ng-click="clearLeadInfo()"></btn-close>\n                                        <h3 class="modal-title">{{ lead.id || lead.id === 0 ? \'Edit Lead\' : \'Add new\n                                            lead\' }}</h3>\n                                    </div>\n                                    <div class="modal-body" style="padding: 30px!important">\n\n                                        <h3 class="mt-0 mb-30">Primary client contact</h3>\n\n                                        <div class="clearfix grey-group-item mb-0 ps-0 text-xs-center text-sm-left">\n                                            <div class="col-xs-12 col-sm-2 text-nowrap">\n                                                <h4>Choose client</h4>\n                                            </div>\n                                            <div class="col-xs-12 col-sm-6">\n                                                <input placeholder="Start entering client name" class="form-control"\n                                                       type="text"\n                                                       typeahead="idName as idName.name  for idName in idsNames | filter:$viewValue"\n                                                       ng-model="lead.primaryContact">\n                                            </div>\n                                            <div class="col-xs-12 col-sm-1 row visible-xs-block">\n                                                <h4>OR</h4>\n                                            </div>\n                                            <div class="col-xs-12 col-sm-4 flex-row">\n                                                <h4 class="hidden-xs flex-grow-1 ml-n7">OR</h4>\n                                                <button type="button" ng-disabled="button_disable"\n                                                        ng-click="createNewClient(0, $event)"\n                                                        class="btn btn-info btn-add-new-sm mb-0 fs-14"\n                                                        data-autotest-button="addNewClientFirst">Add new client\n                                                </button>\n                                            </div>\n                                        </div>\n\n                                        <div class="clearfix grey-group-item m-30 ps-0 second-client"\n                                             ng-show="showSecondClient">\n                                            <div class="col-xs-12 col-sm-2 text-nowrap">\n                                                <h4>Choose client</h4>\n                                            </div>\n                                            <div class="col-xs-12 col-sm-6">\n                                                <input placeholder="Start entering client name" class="form-control"\n                                                       type="text"\n                                                       typeahead="idName as idName.name for idName in idsNames | filter:$viewValue"\n                                                       ng-model="lead.secondaryContact">\n                                            </div>\n                                            <div class="col-xs-12 col-sm-1 row visible-xs-block">\n                                                <h4>OR</h4>\n                                            </div>\n                                            <div class="col-xs-12 col-sm-4 flex-row">\n                                                <h4 class="hidden-xs flex-grow-1 ml-n7">OR</h4>\n                                                <button type="button" ng-disabled="button_disable"\n                                                        ng-click="createNewClient(1, $event)"\n                                                        class="btn btn-info btn-add-new-sm mb-0 fs-14"\n                                                        data-autotest-button="addNewClientSecond">Add new client\n                                                </button>\n                                            </div>\n                                            <button type="button" class="close" ng-disabled="button_disable"\n                                                    ng-click="remove()" data-autotest-button="close">&times;\n                                            </button>\n                                        </div>\n\n                                        <button type="button" ng-if="!showSecondClient" ng-disabled="button_disable"\n                                                ng-click="add()"\n                                                class="btn btn-info btn-add-new-sm mt-20"\n                                                data-autotest-button="addSecondaryClient">\n                                            <span class="hidden-xs fs-14">Add secondary client contact</span>\n                                            <span class="visible-xs fs-14">Add secondary</span>\n                                        </button>\n\n                                        <hr>\n                                        <h3 class="mt-30 mb-25">Lead details</h3>\n                                        <div class="row">\n                                            <div class="col-sm-2">\n                                                <label class="control-label">Lead name:</label>\n                                            </div>\n                                            <div class="col-sm-8 mb-15">\n                                                <input type="text" id="lead-name" class="form-control"\n                                                       placeholder="Jenny & Matt"\n                                                       ng-model="lead.name" autocomplete="off" maxlength="60" required>\n                                            </div>\n                                        </div>\n\n                                        <div class="row">\n\n                                            <div class="col-sm-2">\n                                                <label class="control-label">Job type:</label>\n                                            </div>\n                                            <div class="col-sm-8 mb-15">\n                                                <div class="select-style">\n                                                    <select id="job-type" ng-model="lead.type"\n                                                            ng-change="typeChanged(lead.type)"\n                                                            ng-options="jobType.name for jobType in lead.jobTypes | orderBy:\'name\' track by jobType.name">\n                                                    </select>\n                                                </div>\n                                            </div>\n                                        </div>\n\n                                        <div class="row">\n                                            <div class="col-sm-2">\n                                                <label class="control-label">Workflow:</label>\n                                            </div>\n                                            <div class="col-sm-8 mb-15">\n                                                <div class="select-style">\n                                                    <select ng-options="workflow.name for workflow in lead.workflowNames | orderBy:\'name\' track by workflow.name"\n                                                            ng-model="lead.workflow" ng-disabled="disableWorkflow">\n                                                            <option value="" ng-show="disableWorkflow">Default</option>\n                                                   </select>\n\n\n                                                </div>\n                                            </div>\n                                            <div class="col-sm-8 col-sm-offset-2 select-style-error"\n                                                 ng-show="disableWorkflow">\n                                                Custom workflow cannot be applied to past jobs.\n                                            </div>\n                                            <div class="col-sm-8 col-sm-offset-2 select-style-error" ng-if="lead.workflow.automatedTasks">\n\t\t\t\t\t\t\t\t\t\t\t\tThis workflow contains automated tasks.\n\t\t\t\t\t\t\t\t\t\t\t</div>\n                                        </div>\n\n                                        <div class="row" ng-if="leadSourcesAvailable">\n\t\t\t\t\t\t\t\t\t\t\t<div class="col-sm-2 pr-0">\n\t\t\t\t\t\t\t\t\t\t\t\t<label class="control-label">Lead Source:</label>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t<div class="col-sm-8 mb-15">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="select-style">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<select id="lead-type"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-model="lead.leadSource"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-options="leadSource.name for leadSource in leadSources | orderBy:\'name\' track by leadSource.name"\n\t\t\t\t\t\t\t\t\t\t\t\t\t ><option value="">None</option></select>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n                                        </div>\n                                        <div ng-if="languages && languages.length > 1" class="row">\n                                                  <div class="col-sm-2 pr-0">\n                                                      <label class="control-label">Client Portal:</label>\n                                                  </div>\n                                                  <div class="col-sm-8 mb-15">\n                                                      <div class="select-style">\n                                                          <select id="lead-language"\n                                                                  ng-model="lead.language"\n                                                                  ng-options="language.displayName for language in languages | orderBy:\'displayName\' track by language.name"\n                                                          ></select>\n                                                      </div>\n                                                  </div>\n                                                </div>\n\n                                        <hr>\n                                        <h3 class="mt-30 mb-25">{{mainShootLabelName}}</h3>\n\n                                        <div class="flex-row mb-25">\n                                            <div class="checkbox-squared">\n                                                <input type="checkbox" id="noDate" ng-model="lead.hasNoDate"/>\n                                                <label for="noDate"></label>\n                                            </div>\n                                            <label for="noDate">\n                                                No date has been confirmed yet\n                                            </label>\n                                        </div>\n\n\n                                        <section ng-if="!lead.hasNoDate">\n\n                                            <div class="row">\n                                                <div class="col-sm-2">\n                                                    <label class="control-label">Date:</label>\n                                                </div>\n\n                                                <div class="col-sm-8 job-date">\n                                                    <div class="flex-row flex-wrap-xs">\n                                                        <div class="flex-grow-1 mb-15 box-no-transition datepicker-static under-input"  ng-class="{\'overlap-warning\': !!doubleBookingData}">\n                                                            <input ng-model="lead.startDate" class="form-control"\n                                                                   ng-change="lead.finishDate = lead.startDate"\n                                                                   type="date"\n                                                                   name="input"\n                                                                   data-placeholder="{{datapickerDateFormat}}"\n                                                                   min="2001-12-31"\n                                                                   max="2999-12-31"\n                                                                   data-date=\'{"startView": 2, "openOnMouseFocus": true}\'\n                                                                   required/>\n                                                        </div>\n\n                                                        <div class="flex-basis-xs ms-15 mb-15 fs-16">to</div>\n\n                                                        <div class="flex-grow-1 mb-15 box-no-transition datepicker-static under-input"  ng-class="{\'overlap-warning\': !!doubleBookingData}">\n                                                            <input ng-model="lead.finishDate" class="form-control"\n                                                                   type="date"\n                                                               \t   data-placeholder="{{datapickerDateFormat}}"\n                                                                   name="input"\n                                                                   min="{{( lead.startDate ) ? ( lead.startDate | date : \'yyyy-MM-dd\') : (now | date : \'yyyy-MM-dd\') }}"\n                                                                   max="2999-12-31"\n                                                                   data-date=\'{"startView": 2, "openOnMouseFocus": true}\'\n                                                                   required/>\n                                                        </div>\n                                                    </div>\n                                                </div>\n\n                                                <div class="col-sm-2 mb-15 pt-6 flex-row">\n                                                    <div class="checkbox-squared">\n                                                        <input type="checkbox" id="checkbox-squared-all-lead-day-event"\n                                                               ng-model="lead.allday"/>\n                                                        <label for="checkbox-squared-all-lead-day-event"></label>\n                                                    </div>\n                                                    <label for="checkbox-squared-all-lead-day-event">All day</label>\n                                                </div>\n                                            </div>\n\n\n                                            <div class="row">\n                                                <div class="col-sm-2">\n                                                    <label class="control-label">Time:</label>\n                                                </div>\n                                                <div class="col-sm-8 job-date">\n                                                    <div class="flex-row flex-wrap-xs">\n                                                    <div class="flex-grow-1 mb-15" ng-class="{\'overlap-warning\': !!doubleBookingData}">\n                                                        <sn-timepicker dom-time="lead_start_time"\n                                                                       sn-dr-model="lead.startTime"\n                                                                       sn-dr-checked="lead.allday"></sn-timepicker>\n                                                    </div>\n                                                    <div class="flex-basis-xs ms-15 mb-15 fs-16">to</div>\n                                                    <div class="flex-grow-1 mb-15" ng-class="{\'overlap-warning\': !!doubleBookingData}">\n                                                        <sn-timepicker dom-time="lead_finish_time"\n                                                                       sn-dr-model="lead.finishTime"\n                                                                       sn-dr-checked="lead.allday"></sn-timepicker>\n                                                    </div>\n                                                </div>\n                                            </div>\n                                    </div>\n\n                </section>\n\n\n                <div class="flex-row flex-wrap-xs warning-message m-0 mb-25"\n                     ng-if="lead.hasNoDate">\n               \t\t<warning-sign-img></warning-sign-img>\n\n                    <div class="warning-message__text">\n                        <p>This lead has no date:</p>\n                        <ul>\n                            <li>The {{mainShootLabelName|lowercase}} will not appear in your Calendar.</li>\n                            <li>Automated workflow tasks dependent on {{mainShootLabelName|lowercase}} date will not\n                                trigger.\n                            </li>\n                            <li>The %lead_date% variable will display "No date".</li>\n                        </ul>\n                    </div>\n                </div>\n\n                <div class="row">\n                    <div class="col-sm-2">\n                        <label class="control-label">Location:</label>\n                    </div>\n                    <input type="text" class="hide hidden form-control" name="lead.location"\n                           ng-model="lead.location"/>\n                    <div class="col-sm-8 mb-15 box-no-transition"\n                         ng-controller="GoogleAutocompleteController">\n                        <input type="text" id="AutocompleteLeadModel" ng-model="lead.location"\n                               placeholder=""\n                               class="form-control" ng-autocomplete options="options"\n                               details="details"/>\n                    </div>\n                </div>\n\n\t\t\t    <div class="row" ng-hide="lead.hasNoDate" ng-if="searchingEvents">\n\t\t\t\t\t<div class="col-sm-12">\n\t\t\t\t\t\t<div class="db-event-loading mt-10 mb-25">Loading...</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="row" ng-hide="lead.hasNoDate" ng-if="!searchingEvents && doubleBookingData">\n\t\t\t\t\t<div class="col-sm-12 mt-10 mb-25">\n\t\t\t\t\t\t<events-overlapping-info [data]="doubleBookingData"></events-overlapping-info>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\n\t\t\t\t<div class="row">\n\t\t\t\t\t<div class="col-sm-12">\n\t\t\t\t\t\t<hr>\n\t\t\t\t\t\t<h3 class="mt-30 mb-25">Lead Notes:</h3>\n\n\t\t\t\t\t\t<sn-quill-editor-web\n\t\t\t\t\t\t\t\t\t[init-value]="lead.notes"\n\t\t\t\t\t\t\t\t\t[toolbar-settings]="\'color size font\'"\n\t\t\t\t\t\t\t\t\t[styles]="{height: \'300px\'}"\n\t\t\t\t\t\t\t\t\t(on-text-change)="lead.notes = $event">\n\t\t\t   \t\t\t</sn-quill-editor-web>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n                </div>\n                <div class="modal-footer modal-foot">\n                    <button type="submit" ng-disabled="button_disable"\n                            class="btn btn-success btn-lg"\n                            spinning-wheel is-spinning-wheel-active="button_disable"\n                    >Save Lead\n                    </button>\n                    <button type="button" class="btn btn-lg btn-default ml-10"\n                            data-dismiss="modal"\n                            ng-click="clearLeadInfo()"\n                            ng-disabled="button_disabled"\n                    >Cancel\n                    </button>\n                </div>\n\n                </form>\n                </div>\n                </div>\n                </div>\n                <create-new-client-modal id="createNewLeadClientModal"\n                                         company-name-checked="companyNameChecked"\n                                         client="newClient"\n                                         save-client="saveClient(event)"\n                                         on-close="closeAddClient(event)"\n                                      \t is-create-client-modal-spinnning-wheel-active="isCreateClientModalSpinnningWheelActive"\n                                      \t business-number-label-name="businessNumberLabelName"\n                ></create-new-client-modal>\n                </section>\n\n            ',
			replace: true,
			transclude: true,
			link: function link(scope) {
				var defaultWorkflow = {
					id: '',
					name: 'Default'
				};

				var clientsSearchTimer = void 0,
				    leadHasNoDate = void 0;

				var isNotDefaultWorkflow = function isNotDefaultWorkflow(workflow) {
					return workflow.name !== 'Default' && workflow.id;
				};

				var isDefaultWorkflowInList = function isDefaultWorkflowInList(list) {
					return list.some(function (item) {
						return item.name === 'Default' && item.id === -1;
					});
				};

				scope.$on('showModal', function (event, data) {
					var lead = data.lead;
					scope.lead = angular.copy(data.lead);

					scope.leadSources = [];
					if (scope.lead && scope.lead.leadSource) {
						var leadSource = scope.lead.leadSource;

						if (leadSource.status === 'ARCHIVED') {
							leadSource.name += ' (archived)';
						}
						scope.leadSources.push(leadSource);
					}
					scope.jobId = data.jobId;
					scope.isCreateClientModalSpinnningWheelActive = false;
					scope.searchingEvents = false;
					scope.now = new Date();
					scope.now.setHours(0, 0, 0, 0);
					scope.idsNames = [];
					scope.newClient = {};
					scope.doubleBookingData = null;
					scope.leadSourcesAvailable = true;

					settingsService.timeFormatSettings.subscribe(function (data) {
						scope.dataFormatMonth = data.dateFormat;
						scope.leadSourcesAvailable = data.leadSourcesAvailable;
					});

					leadSourcesDataService.getActiveLeadSourcesList().subscribe(function (data) {
						var leadSource = scope.lead.leadSource;

						leadSource && leadSource.status === 'ARCHIVED' ? scope.leadSources = [].concat(_toConsumableArray(scope.leadSources), _toConsumableArray(data.data)) : scope.leadSources = [].concat(_toConsumableArray(data.data));
					});

					scope.datapickerDateFormat = scope.dataFormatMonth === 'DD_MM_YYYY' ? 'dd/mm/yyyy' : 'mm/dd/yyyy';
					if (!scope.lead || scope.lead.secondaryContact === null || scope.lead.secondaryContact === undefined) {
						scope.showSecondClient = false;
					} else {
						scope.showSecondClient = true;
					}

					if (!lead) {
						var defaultType = data.jobTypes.find(function (type) {
							return type.default === true;
						});
						scope.lead = {
							type: defaultType,
							workflow: defaultType.workflow,
							jobTypes: data.jobTypes,
							workflowNames: data.workflowNames,
							leadSource: null,
							languageNames: data.languageNames
						};
					} else if (lead && !data.jobId) {
						var _defaultType = lead.jobTypes.find(function (type) {
							return type.default === true;
						});

						var defaultValues = {
							type: _defaultType,
							workflow: _defaultType.workflow
						};
						scope.lead = Object.assign(scope.lead, defaultValues);
					} else if (lead) {
						scope.lead.workflow.name = stringModifierService.addSelectedText(scope.lead.workflow.name);
						scope.lead.workflowNames.push(scope.lead.workflow);
						leadHasNoDate = scope.lead.hasNoDate;
					}

					if (scope.lead && scope.lead.languageNames) {
						var _scope$lead$languageN = scope.lead.languageNames,
						    selected = _scope$lead$languageN.selected,
						    availableList = _scope$lead$languageN.availableList;

						scope.lead.language = scope.lead.language || selected;
						scope.languages = availableList || [];
						if (scope.lead.language.name && !scope.languages.some(function (el) {
							return el.name === scope.lead.language.name;
						})) {
							scope.languages = scope.languages.concat(scope.lead.language).sort(function (a, b) {
								return a.displayName.localeCompare(b.displayName);
							});
						}
					} else {
						scope.languages = [];
					}

					checkLeadDate(scope.lead.startDate);
					$('#newLead').find('input.ws-date').prop('autocomplete', 'off');
				});

				scope.$watch('lead.startDate', checkLeadDate);
				scope.$watch('lead.finishDate', reactToDateTimeChange);
				scope.$watch('lead.finishTime', reactToDateTimeChange);
				scope.$watch('lead.allday', reactToDateTimeChange);

				scope.$watch('lead.startTime', function (newValue, oldValue) {
					if (scope.lead && newValue && newValue !== oldValue) {
						var startTime24 = timeConverter.convert12to24(newValue);
						var startHour = timeService.getHour(startTime24);
						var startMin = timeService.getMinutes(startTime24);

						var finishTime24 = timeConverter.convert12to24(scope.lead.finishTime);
						var finishHour1 = timeService.getHour(finishTime24);
						if (!scope.lead.id || !scope.lead.finishTime) {
							var finishHour = startHour + 1;

							if (finishHour > 23) {
								finishHour = 0;
							}

							var finishTime = finishHour + ':' + startMin;

							scope.lead.finishTime = timeConverter.convert24to12(finishTime);
						}

						if (startHour === finishHour1 - 1 || startHour === finishHour1) {
							var _finishHour = startHour + 1;

							if (_finishHour > 23) {
								_finishHour = 0;
							}

							var _finishTime = _finishHour + ':' + startMin;

							scope.lead.finishTime = timeConverter.convert24to12(_finishTime);
						}

						checkForOverlappingEvents();
					}
				});

				scope.$watch('lead.secondaryContact', function (newValue, oldValue) {
					if (newValue === null || oldValue === newValue || newValue === undefined) {
						return false;
					}

					if (newValue.length > 0) {
						if (clientsSearchTimer != null) {
							clearTimeout(clientsSearchTimer);
						}

						clientsSearchTimer = setTimeout(findAllMatchingClientNames(newValue), 500);
					} else {
						clearTimeout(clientsSearchTimer);
					}
				});

				scope.$watch('lead.primaryContact', function (newValue, oldValue) {
					if (newValue === null || newValue === undefined || oldValue === newValue) {
						return;
					}
					if (newValue.length > 0) {
						if (clientsSearchTimer != null) {
							clearTimeout(clientsSearchTimer);
						}

						clientsSearchTimer = setTimeout(findAllMatchingClientNames(newValue), 500);
					} else {
						clearTimeout(clientsSearchTimer);
					}
				});

				scope.typeChanged = function (type) {
					if (scope.lead.id) {
						return;
					}

					if (!scope.disableWorkflow) {
						scope.lead.workflow = type.workflow;
						// const isNotDefault = isNotDefaultWorkflow(type.workflow);
						// if (
						// 	isNotDefault &&
						// 	!isDefaultWorkflowInList(scope.lead.workflowNames)
						// ) {
						// 	scope.lead.workflowNames.push(defaultWorkflow);
						// }
					}
				};

				function setFinishDate(leadStartDate) {
					if (!scope.lead.finishDate || leadStartDate > scope.lead.finishDate) {
						scope.lead.finishDate = leadStartDate;
					}
				}

				function getDefaultWorkflow(workflows) {
					return workflows.find(function (workflow) {
						return workflow.name === 'Default';
					});
				}

				function checkLeadDate(leadStartDate) {
					if (scope.lead && leadStartDate) {
						if (!scope.lead.id) {
							setFinishDate(leadStartDate);
							scope.disableWorkflow = new Date(leadStartDate) < scope.now;

							if (scope.disableWorkflow) {
								scope.lead.workflow = getDefaultWorkflow(scope.lead.workflowNames);
							}
							checkForOverlappingEvents();
						} else {
							if (scope.lead.hasNoDate) {
								setFinishDate(leadStartDate);
							}
							scope.disableWorkflow = new Date(leadStartDate) < scope.now;
							if (scope.disableWorkflow) {
								scope.lead.workflow = scope.lead.oldWorkflow;
								scope.lead.workflow.id = -1;
							}
						}
					}
				}

				function findAllMatchingClientNames(search) {
					clientsDataService.searchClient(search).subscribe(function (data) {
						return findClientSuccessCallback(data);
					}, function (err) {
						return messageService.showDefaultErrorMessage(err);
					});
				}

				function findClientSuccessCallback(client) {
					if (client) {
						scope.idsNames = [];
						client.forEach(function (item) {
							return scope.idsNames.push(item);
						});
					}
				}

				scope.createNewClient = function (clientIndex, event) {
					scope.newClient = {};
					utilsService.showNextModal('#newLead', '#createNewLeadClientModal', event);
					scope.clientIndex = clientIndex;
				};

				scope.closeAddClient = function (event) {
					utilsService.showNextModal('#createNewLeadClientModal', '#newLead', event);
				};

				scope.saveClient = function (event) {
					scope.isCreateClientModalSpinnningWheelActive = true;

					var lowercasedEmail = scope.newClient.email.toLowerCase();
					scope.newClient.email = lowercasedEmail;

					var client2SaveIndex = scope.clientIndex;
					if (!scope.companyNameChecked) {
						delete scope.newClient.companyName;
					}

					if (!validationService.isEmailValid(scope.newClient.email)) {
						scope.isCreateClientModalSpinnningWheelActive = false;
						return messageService.showToaster('e_3', 'companyUsers');
					}

					var clientFirstName = scope.newClient.firstName || '';

					if (!clientFirstName && !clientFirstName.trim()) {
						return messageService.showToaster('e_4', 'clients');
					}

					if (scope.newClient) {
						scope.newClient.notes = $rootScope.addMaiStyling(scope.newClient.notes);
					}

					clientsDataService.addNewClient(scope.newClient).finally(function () {
						return scope.isCreateClientModalSpinnningWheelActive = false;
					}).subscribe(function (data) {
						return successAddNewClient(data, client2SaveIndex, event);
					}, function () {
						return messageService.showToaster('e_6', 'clients');
					});
				};

				function successAddNewClient(data, client2SaveIndex, event) {
					if (data.errorMessage) {
						toastr.error(data.errorMessage, 'Error');
						return false;
					}

					scope.isCreateClientModalSpinnningWheelActive = false;

					delete scope.client;

					var clientSearchObj = clientService.fillClientSearchText(data);

					switch (client2SaveIndex) {
						case 0:
							var primaryClientSearchText = angular.copy(clientSearchObj);
							scope.lead.primaryContact = primaryClientSearchText;
							break;
						case 1:
							var secondaryClientSearchText = angular.copy(clientSearchObj);
							scope.lead.secondaryContact = secondaryClientSearchText;
							break;
						default:
							console.error('Unexpected client index');
					}

					messageService.showToaster('s_2', 'clients');
					utilsService.showNextModal('#createNewLeadClientModal', '#newLead', event);
				}

				scope.addOrUpdateLead = function () {
					delete $rootScope.error;

					var leadClients = [scope.lead.primaryContact, scope.lead.secondaryContact];

					var dataToSave = leadService.validateJob(scope.lead, leadClients, scope.lead.id, scope.jobId);

					if (dataToSave === false) {
						return false;
					}
					scope.button_disable = true;
					editLeadRequest(dataToSave);
				};

				function editLeadRequest(lead) {
					leadDataService.editLead(lead).finally(function () {
						scope.button_disable = false;
					}).subscribe(function (data) {
						updateIntercom(lead);
						editLeadSuccessCallback(data, lead.id);
					}, function (err) {
						return editLeadErrorCallback(err);
					});
				}

				function updateIntercom(lead) {
					var metadata = {
						lead_name: lead.name,
						lead_scheduled: lead.startDate
					};
					Intercom('trackEvent', 'created lead', metadata);
				}

				function editLeadSuccessCallback(data, leadId) {
					if (leadId === null || leadId === undefined) {
						messageService.showToaster('s_4', 'lead');
						$('#newLead').modal('hide');
					} else {
						messageService.showToaster('s_3', 'lead');
						$('#newLead').modal('hide');
						leadSourcesDataService.updateLeadSourcesEvent(true);
					}

					if (data.id && !leadId) {
						$timeout(function () {
							$location.path('/leads/view/' + data.id);
						}, 300);
					} else if (scope.updateParent) {
						scope.updateParent({ resetPagination: false });
					} else {
						$timeout(function () {
							$route.reload();
						}, 300);
					}
				}

				function editLeadErrorCallback(err) {
					var data = err.data,
					    status = err.status,
					    error = err.error;


					if (error && error.errorCode === 102) {
						var errorTitle = error.errorTitle,
						    errorMessage = error.errorMessage;

						messageService.showErrorFromBackend(errorTitle, errorMessage);
					} else {
						var _errorMessage = data ? data.errorMessage : null;

						var errorCode = void 0,
						    errorPlace = void 0;

						if (_errorMessage && status >= 400 && status < 500) {

							if (status === 422 && _errorMessage.includes('Job contact can not be changed because invoices have Xero payment')) {
								errorCode = 'e_17';
								errorPlace = 'xero';

								messageService.showToaster(errorCode, errorPlace);
							} else {
								messageService.showDefaultErrorMessage(error);
							}
						} else {
							messageService.showDefaultErrorMessage(error);
						}
					}
				}

				scope.remove = function () {
					delete scope.lead.secondaryContact;
					scope.showSecondClient = false;
				};

				scope.clearLeadInfo = function () {
					delete scope.disableWorkflow;
				};

				scope.add = function () {
					var emptyClient = {
						name: ''
					};
					scope.lead.secondaryContact = emptyClient;
					scope.showSecondClient = true;
				};

				function reactToDateTimeChange(newValue, oldValue) {
					if (!newValue) {
						scope.doubleBookingData = null;
					}
					if (scope.lead && newValue && newValue !== oldValue || newValue === false) {
						checkForOverlappingEvents();
					}
				}

				function checkForOverlappingEvents() {
					var hasDate = scope.lead.startDate && scope.lead.finishDate;
					var hasTimeOrAllDay = scope.lead.allday || scope.lead.startTime && scope.lead.finishTime && !scope.lead.allday;

					if (hasDate && hasTimeOrAllDay) {
						scope.button_disable = true;
						scope.searchingEvents = true;
						doubleBookingService.getOverlappingEvents(doubleBookingService.gatherDateTimeData(scope.lead), 'JOB', scope.jobId || scope.lead.jobId).pipe((0, _operators.finalize)(function () {
							scope.searchingEvents = false;
							scope.button_disable = false;
						})).subscribe(function (data) {
							return scope.doubleBookingData = data;
						});
					}
				}
			}
		};
	}
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js"), __webpack_require__("./node_modules/toastr/toastr.js")))

/***/ }),

/***/ "./web/js/components/Modals/public/modalHello.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('main').directive('modalHello', [function () {
	return {
		restrict: 'E',
		template: function template() {
			var templateHtml = '';
			templateHtml += '<div id="helloModal" class="modal modal-center fade" tabindex="-1" role="dialog" data-keyboard="false" data-autotest-modal="helloModal">';
			templateHtml += '    <div class="modal-dialog modal-welcome modal-confirm">';
			templateHtml += '        <div class="modal-content modal-banner">';
			templateHtml += '            <div class="ninja-logo-wrapper">';
			templateHtml += '                <img src="https://app.studioninja.co/build/release-pipeline-119/resources/dist/assets/images/logo/sign-up-logo.png" alt="ninja">';
			templateHtml += '            </div>';
			templateHtml += '            <h2 class="text-center mb-0 mt-30">Thanks for signing up!</h2>';
			templateHtml += '            <div class="modal-body">';
			templateHtml += '                <p class="mb-30">Please check your email and click on the confirmation link in the message. Check your spam folder as well if you can\'t find it in your inbox.</p>';
			templateHtml += "                <p>Once your account is activated, we'll send you a series of emails to help you get started with Studio Ninja.</p>";
			templateHtml += '            </div>';
			templateHtml += '            <div class="modal-footer modal-foot">';
			templateHtml += '                <button class="btn btn-grey-light btn-lg" type="button" data-dismiss="modal" aria-hidden="true">Close</button>';
			templateHtml += '            </div>';
			templateHtml += '        </div>';
			templateHtml += '    </div>';
			templateHtml += '</div>';

			return templateHtml;
		},

		scope: {},
		replace: true,
		transclude: true
	};
}]);

/***/ }),

/***/ "./web/js/components/Modals/public/modalTerms.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('main').directive('modalTerms', function () {
	return {
		restrict: 'E',
		template: function template() {
			var templateHtml = '';
			templateHtml += '<div id="terms" class="modal modal-center fade">';
			templateHtml += '    <div class="modal-dialog">';
			templateHtml += '        <div class="modal-content">';
			templateHtml += '            <div class="modal-header">';
			templateHtml += '                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>';
			templateHtml += '                <h3 class="modal-title">Terms and Conditions</h3>';
			templateHtml += '            </div>';
			templateHtml += '            <div class="modal-body">';
			templateHtml += '                <p><span>By using Studio Ninja websites, their subdomains, or any website aliasing them ("Service"), and all services of Studio Ninja, you are agreeing to be bound by the following terms and conditions ("Terms of Service" or "Agreement").</span>';
			templateHtml += '                </p><br>';
			templateHtml += '                <p><span>Studio Ninja reserves the right to update and change the Terms of Service from time to time without notice. Any new features that augment or enhance the current Service, including the release of new tools and resources, shall be subject to the Terms of Service. Continued use of the Service after any such changes shall constitute your consent to such changes.</span>';
			templateHtml += '                </p>';
			templateHtml += '                <h3><span>Account Terms</span></h3>';
			templateHtml += '                <ul>';
			templateHtml += '                    <li><p><span';
			templateHtml += '                           >You must be 13 years or older to use this Service.</span>';
			templateHtml += '                    </p></li>';
			templateHtml += '                    <li><p><span';
			templateHtml += '                           >You must be a human. With the exception of published API interfaces, accounts may not be registered, updated, scanned, or otherwise accessed by "bots" or other automated methods.</span>';
			templateHtml += '                    </p></li>';
			templateHtml += '                    <li><p><span';
			templateHtml += '                           >You must provide your legal full name, a valid email address, and any other information requested in order to complete the signup process.</span>';
			templateHtml += '                    </p></li>';
			templateHtml += '                    <li><p><span';
			templateHtml += "                           >Your login may only be used by one person - a single login shared by multiple people is not permitted. You may create separate logins for as many people as you'd like (additional fees may apply).</span>";
			templateHtml += '                    </p></li>';
			templateHtml += '                    <li><p><span';
			templateHtml += '                           >You are responsible for maintaining the security of your account and password. Studio Ninja cannot and will not be liable for any loss or damage from your failure to comply with this security obligation.</span>';
			templateHtml += '                    </p></li>';
			templateHtml += '                    <li><p><span';
			templateHtml += '                           >You are responsible for all Content posted and activity that occurs under your account (even when Content is posted by others who have accounts under your account).</span>';
			templateHtml += '                    </p></li>';
			templateHtml += '                    <li><p><span';
			templateHtml += '                           >You must not misrepresent yourself or take on the identity of someone else while using this service.</span>';
			templateHtml += '                    </p></li>';
			templateHtml += '                    <li><p><span';
			templateHtml += '                           >One person or legal entity may not maintain more than one Free Forever Account.</span>';
			templateHtml += '                    </p></li>';
			templateHtml += '                    <li><p><span';
			templateHtml += '                           >You may not use the Service for any illegal or unauthorized purpose.</span>';
			templateHtml += '                    </p></li>';
			templateHtml += '                    <li><p><span';
			templateHtml += '                           >The Service may be available using a mobile device. Do not use the Service in a way that distracts you and prevents you from obeying traffic or safety laws.</span>';
			templateHtml += '                    </p></li>';
			templateHtml += '                </ul>';
			templateHtml += '                <br>';
			templateHtml += '                <p>';
			templateHtml += '                    <span>Violation of any of these agreements will result in the termination of your Account. While Studio Ninja prohibits such conduct and Content on the Service, you understand and agree that Studio Ninja cannot be responsible for the Content posted on the Service and you nonetheless may be exposed to such materials. You agree to use the Service at your own risk.</span>';
			templateHtml += '                </p>';
			templateHtml += '                <h3>';
			templateHtml += '                    <span>Code of Conduct</span>';
			templateHtml += '                </h3>';
			templateHtml += '                <p>';
			templateHtml += '                    <span>While using the Service, you agree to comply with all applicable laws, rules and regulations.</span>';
			templateHtml += '                </p>';
			templateHtml += '                <p>';
			templateHtml += '                    <span>You also agree to comply with certain additional rules (the "Code of Conduct") that govern your use of the Service and participation at events or in online forums administered or organized by Studio Ninja ("Events", for example, instructional workshops, live webinars, and posts in the </span>';
			templateHtml += '                    <a';
			templateHtml += '                        href="https://www.facebook.com/studioninjacrm">';
			templateHtml += '                        <span';
			templateHtml += '                        style="color: #337ab7;background-color: transparent;">Studio Ninja User Group on Facebook</span>';
			templateHtml += '                    </a>';
			templateHtml += '                    <span';
			templateHtml += '                       >). The Code of Conduct is not meant to be exhaustive, and Studio Ninja reserves the right to modify this Code of Conduct at any time, as well as take appropriate disciplinary measures including account termination and deletion to protect the integrity and spirit of the Service and Events, regardless of whether a specific behavior is listed here as prohibited.</span>';
			templateHtml += '                </p>';
			templateHtml += '                <br>';
			templateHtml += '                <p>';
			templateHtml += '                    <span>The following are examples of behavior that warrant disciplinary measures:</span>';
			templateHtml += '                </p>';
			templateHtml += '                <ul>';
			templateHtml += '                    <li>';
			templateHtml += '                        <p>';
			templateHtml += '                            <span';
			templateHtml += '                           >Harassing, stalking, or threatening any other users;</span>';
			templateHtml += '                    </p>';
			templateHtml += '                    </li>';
			templateHtml += '                    <li>';
			templateHtml += '                        <p>';
			templateHtml += '                            <span';
			templateHtml += '                           >Transmitting or communicating any content which, in the sole and exclusive discretion of Studio Ninja, is deemed offensive, including, but not limited to, language that is unlawful, harmful, threatening, abusive, harassing, defamatory, vulgar, obscene, sexually explicit, or racially, ethnically, or otherwise objectionable;</span>';
			templateHtml += '                    </p>';
			templateHtml += '                    </li>';
			templateHtml += '                    <li>';
			templateHtml += '                        <p>';
			templateHtml += '                            <span';
			templateHtml += '                           >Impersonating any person, business, or entity, including an employee of Studio Ninja, or communicating in any way that makes it appear that the communication originates from Studio Ninja;</span>';
			templateHtml += '                    </p>';
			templateHtml += '                    </li>';
			templateHtml += '                    <li>';
			templateHtml += '                        <p>';
			templateHtml += '                            <span';
			templateHtml += '                           >Posting private or identifying information about any other user or account, to the Service or elsewhere;</span>';
			templateHtml += '                    </p>';
			templateHtml += '                    </li>';
			templateHtml += '                    <li>';
			templateHtml += '                        <p>';
			templateHtml += '                            <span';
			templateHtml += '                           >Transmitting or facilitating the transmission of any content that contains a virus, corrupted data, worm, or other computer programming routines that are intended to and/or actually damage, detrimentally interfere with, surreptitiously intercept or mine, scrape or expropriate any system, data or personal information;</span>';
			templateHtml += '                    </p>';
			templateHtml += '                    </li>';
			templateHtml += '                    <li>';
			templateHtml += '                        <p>';
			templateHtml += '                            <span';
			templateHtml += '                           >Spamming, whether for personal or commercial purposes, by disrupting the flow of conversation with repeated postings of a similar nature;</span>';
			templateHtml += '                    </p>';
			templateHtml += '                    </li>';
			templateHtml += '                    <li>';
			templateHtml += '                        <p>';
			templateHtml += '                            <span';
			templateHtml += '                           >Participating in any action which, in the sole and exclusive judgment of Studio Ninja, "exploits" an undocumented aspect of the Service;</span>';
			templateHtml += '                    </p>';
			templateHtml += '                    </li>';
			templateHtml += '                    <li>';
			templateHtml += '                        <p>';
			templateHtml += '                            <span';
			templateHtml += '                           >Participating in any action which, in the sole and exclusive judgment of Studio Ninja, defrauds any other user of the Service, including, but not limited to, by "scamming" or "social engineering;"</span>';
			templateHtml += '                    </p>';
			templateHtml += '                    </li>';
			templateHtml += '                    <li>';
			templateHtml += '                        <p>';
			templateHtml += '                            <span';
			templateHtml += '                           >Using unauthorized programs or automated processes to interact with the Service;</span>';
			templateHtml += '                    </p>';
			templateHtml += '                    </li>';
			templateHtml += '                    <li>';
			templateHtml += '                        <p>';
			templateHtml += '                            <span';
			templateHtml += '                           >Accessing or attempting to access areas of the Service that have not been made available to the public;</span>';
			templateHtml += '                    </p>';
			templateHtml += '                    </li>';
			templateHtml += '                </ul>';
			templateHtml += '                <h3>';
			templateHtml += '                    <span>Payment, Refunds, Upgrading and Downgrading Terms</span>';
			templateHtml += '                </h3>';
			templateHtml += '                <p>';
			templateHtml += '                    <span>A valid credit card is required for paying accounts. Free Forever accounts are not required to provide a credit card number.</span>';
			templateHtml += '                </p>';
			templateHtml += '                <br>';
			templateHtml += '                <p>';
			templateHtml += '                    <span>The Service is billed in advance on a monthly or yearly basis and is non-refundable. There will be no refunds or credits for partial months of service, upgrade/downgrade refunds, or refunds for months unused with an open account. In order to treat everyone equally, no exceptions will be made.</span>';
			templateHtml += '                </p>';
			templateHtml += '                <br>';
			templateHtml += '                <p>';
			templateHtml += '                    <span>All fees are inclusive of taxes, levies, or duties imposed by taxing authorities.</span>';
			templateHtml += '                </p>';
			templateHtml += '                <p>';
			templateHtml += '                    <span>For any upgrade or downgrade in plan level, your credit card that you provided will automatically be charged the new rate on your next billing cycle.</span>';
			templateHtml += '                </p>';
			templateHtml += '                <p>';
			templateHtml += '                    <span>Any increased plan price upon upgrading will be prorated based on the time remaining in your current billing cycle and immediately charged upon upgrading.</span>';
			templateHtml += '                </p>';
			templateHtml += '                <br>';
			templateHtml += '                <p>';
			templateHtml += '                    <span>Downgrading your Service may cause the loss of Content, features, or capacity of your Account. Studio Ninja does not accept any liability for such loss.</span>';
			templateHtml += '                </p>';
			templateHtml += '                <br>';
			templateHtml += '                <p>';
			templateHtml += '                    <span>All payments are final and are non-refundable.</span>';
			templateHtml += '                </p>';
			templateHtml += '                <h3>';
			templateHtml += '                    <span';
			templateHtml += '                       >Cancellation and Termination</span>';
			templateHtml += '                </h3>';
			templateHtml += '                <p>';
			templateHtml += '                    <span>We may suspend or stop providing our Service to you if you do not comply with this Agreement or our policies or if we are investigating suspected misconduct. Studio Ninja, in its sole discretion, has the right to suspend or terminate your account and refuse any and all current or future use of the Service, or any other Studio Ninja service, for any reason at any time.</span>';
			templateHtml += '                </p>';
			templateHtml += '                <br>';
			templateHtml += '                <p>';
			templateHtml += '                    <span>You are solely responsible for properly cancelling your account. An email, chat request, help desk ticket, or phone request to cancel your account is not considered cancellation. Sign into your account and cancel your subscription in Settings &gt; Account &amp; Subscription.</span>';
			templateHtml += '                </p>';
			templateHtml += '                <br>';
			templateHtml += '                <p>';
			templateHtml += '                    <span>Upon submission of cancellation, your account will be suspended immediately without regard to the original term of your license and you will not be charged again.</span>';
			templateHtml += '                </p>';
			templateHtml += '                <br>';
			templateHtml += '                <p>';
			templateHtml += '                    <span>A Free Forever account is a limited account with no billing information on file. Free Forever accounts may have certain functional limitations, such as restricted number of users and restricted job management and invoicing capabilities. Upon expiration, a Free Forever account will not be accessible without provision of billing information and upgrading your plan level. A Free Forever Account will expire after you add more than one company user, or add more than 10 jobs, or exceed $3000 of invoices in your account.</span>';
			templateHtml += '                </p>';
			templateHtml += '                <br>';
			templateHtml += '                <p>';
			templateHtml += '                    <span>Termination or cancellation of the Service will result in the deactivation or deletion of your account or your access to your account, and the forfeiture and relinquishment of all Content in your account. Studio Ninja reserves the right to refuse service to anyone for any reason at any time.</span>';
			templateHtml += '                </p>';
			templateHtml += '                <br>';
			templateHtml += '                <p>';
			templateHtml += '                    <span>If a payment fails, for example if there are insufficient funds or credit remaining, or if a card is lost or stolen, your account will be suspended until you renew your subscription plan and re-provide valid Credit Card payment details. If your account remains suspended for 90 days after the payment due date it will be considered abandoned and your account closed and scheduled for deletion.</span>';
			templateHtml += '                </p>';
			templateHtml += '                <br>';
			templateHtml += '                <p>';
			templateHtml += '                    <span>If you need additional time or if you need to update your credit card details, please contact us.</span>';
			templateHtml += '                </p>';
			templateHtml += '                <h3>';
			templateHtml += '                    <span>Modifications to the Service and Prices</span>';
			templateHtml += '                </h3>';
			templateHtml += '                <p>';
			templateHtml += '                    <span>Studio Ninja reserves the right at any time and from time to time to modify or discontinue, temporarily or permanently, any part of the Service with or without notice.</span>';
			templateHtml += '                </p>';
			templateHtml += '                <br>';
			templateHtml += '                <p>';
			templateHtml += '                    <span>Prices of all Services, including but not limited to monthly subscription plan fees to the Service, are subject to change upon 30 days notice from us. Such notice may be provided at any time by posting the changes to the Studio Ninja Blog or the Service itself.</span>';
			templateHtml += '                </p>';
			templateHtml += '                <br>';
			templateHtml += '                <p>';
			templateHtml += '                    <span>Studio Ninja shall not be liable to you or to any third party for any modification, price change, suspension or discontinuance of the Service.</span>';
			templateHtml += '                </p>';
			templateHtml += '                <h3>';
			templateHtml += '                    <span>Copyright and Content Ownership</span>';
			templateHtml += '                </h3>';
			templateHtml += '                <p>';
			templateHtml += '                    <span>All content posted on the Service must comply with Australian copyright laws.</span>';
			templateHtml += '                </p>';
			templateHtml += '                <br>';
			templateHtml += '                <p>';
			templateHtml += '                    <span>We claim no intellectual property rights over the material you provide to the Service. Your account data and materials uploaded remain yours. However, if you or anyone else with an account under your account make any Content public, you agree to allow others to view and share your Content. You also understand and agree that Studio Ninja is not required to provide any specific export or archive of your data stored in the Service and that the various user-initiated export tools available in the Service (such as contact list or general ledger exports) are provided "as is" and "as available".</span>';
			templateHtml += '                </p>';
			templateHtml += '                <br>';
			templateHtml += '                <p>';
			templateHtml += '                    <span>Studio Ninja does not pre-screen Content, but Studio Ninja and its designee have the right (but not the obligation) in their sole discretion to refuse or remove any Content that is available via the Service.</span>';
			templateHtml += '                </p>';
			templateHtml += '                <br>';
			templateHtml += '                <p>';
			templateHtml += '                    <span>The look and feel of the Service is copyrighted by </span>';
			templateHtml += '                    <span';
			templateHtml += '                       >Studio Ninja Pty Ltd</span>';
			templateHtml += '                    <span';
			templateHtml += '                       >. All rights reserved. You may not duplicate, copy, or reuse any portion of the HTML/CSS or visual design elements without express written permission from Studio Ninja.</span>';
			templateHtml += '                </p>';
			templateHtml += '                <br>';
			templateHtml += '                <p>';
			templateHtml += '                    <span>A Testimonial is an optional non-compensated review or recommendation that you may provide to Studio Ninja and includes the testimonial text, photo, business name, author, and website URL. By submitting a Testimonial you grant Studio Ninja the irrevocable, perpetual, transferable, and unrestricted right to reproduce, display, use, and publish your Testimonial for promotional purposes in any medium; and to alter the Testimonial photo without restriction. Studio Ninja is under no obligation to publish your Testimonial.</span>';
			templateHtml += '                </p>';
			templateHtml += '                <h3>';
			templateHtml += '                    <span>Privacy</span>';
			templateHtml += '                </h3>';
			templateHtml += '                <p>';
			templateHtml += '                    <span>Our Privacy Policy explains how we treat your personal data and protect your privacy when you use our Service. By using our Service, you agree that Studio Ninja can use such data in accordance with our privacy policies.</span>';
			templateHtml += '                </p>';
			templateHtml += '                <h3>';
			templateHtml += '                    <span>General Conditions</span>';
			templateHtml += '                </h3>';
			templateHtml += '                <p>';
			templateHtml += '                    <span>Technical support is only provided to paying account holders and is only available online or through email.</span>';
			templateHtml += '                </p>';
			templateHtml += '                <br>';
			templateHtml += '                <p>';
			templateHtml += '                    <span>You understand that Studio Ninja uses third party vendors and hosting partners to provide the necessary hardware, software, networking, storage, and related technology required to run the Service.</span>';
			templateHtml += '                </p>';
			templateHtml += '                <br>';
			templateHtml += '                <p>';
			templateHtml += '                    <span>You must not modify, adapt or hack the Service or modify another website so as to falsely imply that it is associated with the Service, Studio Ninja, or any other Studio Ninja service.</span>';
			templateHtml += '                </p>';
			templateHtml += '                <p>';
			templateHtml += '                    <span>You may not reverse engineer or reuse source code that is in public view without express written permission from Studio Ninja. This includes any and all javascript. The code is copyrighted by Studio Ninja Pty Ltd.</span>';
			templateHtml += '                </p>';
			templateHtml += '                <br>';
			templateHtml += '                <p>';
			templateHtml += '                    <span>You agree not to reproduce, duplicate, copy, sell, resell or exploit any portion of the Service, use of the Service, computer code that powers the Service, or access to the Service without the express written permission by Studio Ninja.</span>';
			templateHtml += '                </p>';
			templateHtml += '                <br>';
			templateHtml += '                <p>';
			templateHtml += "                    <span>We may, but have no obligation to, remove Content and Accounts containing Content that we determine in our sole discretion are unlawful, offensive, threatening, libelous, defamatory, pornographic, obscene or otherwise objectionable or violates any party's intellectual property or these Terms of Service.</span>";
			templateHtml += '                </p>';
			templateHtml += '                <br>';
			templateHtml += '                <p>';
			templateHtml += '                    <span>Verbal, physical, written or other abuse (including threats of abuse or retribution) of any Studio Ninja customer, employee, member, or officer will result in immediate account termination.</span>';
			templateHtml += '                </p>';
			templateHtml += '                <p>';
			templateHtml += '                    <span>You understand that the technical processing and transmission of the Service, including your Content, may be transferred unencrypted and involve (a) transmissions over various networks; and (b) changes to conform and adapt to technical requirements of connecting networks or devices.</span>';
			templateHtml += '                </p>';
			templateHtml += '                <br>';
			templateHtml += '                <p>';
			templateHtml += '                    <span>You must not upload, post, host, or transmit unsolicited email, SMSs, or "spam" messages.</span>';
			templateHtml += '                </p>';
			templateHtml += '                <p>';
			templateHtml += '                    <span>You must not transmit any worms or viruses or any code of a destructive nature.</span>';
			templateHtml += '                </p>';
			templateHtml += '                <p>';
			templateHtml += '                    <span>You may not use the provided storage for offsite backups, delivery or transfer of high-resolution images or proofs, or otherwise use excessive storage (as determined solely by Studio Ninja). If you are found to be abusing the provided storage, your account may be disabled until your storage usage is corrected.</span>';
			templateHtml += '                </p>';
			templateHtml += '                <br>';
			templateHtml += '                <p>';
			templateHtml += '                    <span>If your bandwidth usage exceeds 1 GB/month, or significantly exceeds the average bandwidth usage (as determined solely by Studio Ninja) of other Studio Ninja customers, we reserve the right to immediately disable your account or throttle your file hosting until you can reduce your bandwidth consumption.</span>';
			templateHtml += '                </p>';
			templateHtml += '                <br>';
			templateHtml += '                <p>';
			templateHtml += '                    <span>The failure of Studio Ninja to exercise or enforce any right or provision of the Terms of Service shall not constitute a waiver of such right or provision. The Terms of Service constitutes the entire agreement between you and Studio Ninja and govern your use of the Service, superseding any prior agreements between you and Studio Ninja (including, but not limited to, any prior versions of the Terms of Service).</span>';
			templateHtml += '                </p>';
			templateHtml += '                <h3>';
			templateHtml += '                    <span';
			templateHtml += '                       >Our Warranties and Disclaimers</span>';
			templateHtml += '                </h3>';
			templateHtml += '                <p>';
			templateHtml += '                    <span>THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE".</span>';
			templateHtml += '                </p>';
			templateHtml += '                <p>';
			templateHtml += '                    <span>Studio Ninja does not warrant that (i) the service will meet your specific requirements, (ii) the service will be uninterrupted, timely, secure, or error-free, (iii) the results that may be obtained from the use of the service will be accurate or reliable, (iv) the quality of any products, services, information, or other material purchased or obtained by you through the service will meet your expectations, and (v) any errors in the Service will be corrected. To the extent permitted by law, we exclude all warranties.</span>';
			templateHtml += '                </p>';
			templateHtml += '                <br>';
			templateHtml += '                <p>';
			templateHtml += "                    <span>Other than as expressly set out in these Agreement, neither Studio Ninja nor its suppliers or distributors make any specific promises about the Service. For example, we don't make any commitments about the content within the Service, the specific functions of the Service, or their reliability, availability, or ability to meet your needs.</span>";
			templateHtml += '                </p>';
			templateHtml += '                <h3>';
			templateHtml += '                    <span';
			templateHtml += '                       >Liability for our Service</span>';
			templateHtml += '                </h3>';
			templateHtml += '                <p>';
			templateHtml += '                    <span>Your use of the Service is at your sole risk.</span>';
			templateHtml += '                </p>';
			templateHtml += '                <br>';
			templateHtml += '                <p>';
			templateHtml += '                    <span>You expressly understand and agree that Studio Ninja shall not be liable for any direct, indirect, incidental, special, consequential or exemplary damages, including but not limited to, damages for loss of profits, goodwill, use, data or other intangible losses (even if Studio Ninja has been advised of the possibility of such damages), resulting from: (i) the use or the inability to use the service; (ii) the cost of procurement of substitute goods and services resulting from any goods, data, information or services purchased or obtained or messages received or transactions entered into through or from the Service; (iii) unauthorized access to or alteration of your transmissions or data; (iv) statements or conduct of any third party on the service; or (v) any other matter relating to the service.</span>';
			templateHtml += '                </p>';
			templateHtml += '                <h3>';
			templateHtml += '                    <span>Business Use</span>';
			templateHtml += '                </h3>';
			templateHtml += '                <p>';
			templateHtml += "                    <span>If you are using our Service on behalf of a business, that business accepts these terms. It will hold harmless and indemnify Studio Ninja and its affiliates, officers, agents, and employees from any claim, suit or action arising from or related to the use of the Service or violation of these terms, including any liability or expense arising from claims, losses, damages, suits, judgments, litigation costs and attorneys' fees.</span>";
			templateHtml += '                </p>';
			templateHtml += '                <h3>';
			templateHtml += '                    <span>Resolving Complaints</span>';
			templateHtml += '                </h3>';
			templateHtml += '                <p>';
			templateHtml += '                    <span>INFORMAL RESOLUTION: We want to address your concerns without needing a formal legal case. Before filing a claim against Studio Ninja, you agree to make a good faith effort to resolve the dispute informally by sending a dispute notice to </span>';
			templateHtml += '                    <span';
			templateHtml += '                        style="color: #337ab7;background-color: transparent;">support@studioninja.co</span>';
			templateHtml += '                    <span';
			templateHtml += "                       >. Include a thorough description of your dispute in your notice, including a summary of the situation that caused the issue and your desired remedies. We'll try to resolve the dispute informally by contacting you via email. If a dispute is not resolved within 30 days of submission, you or Studio Ninja may bring a formal proceeding.</span>";
			templateHtml += '                </p>';
			templateHtml += '                <br>';
			templateHtml += '                <p>';
			templateHtml += "                    <span>NO CLASS ACTIONS: You may only resolve disputes with us on an individual basis, and may not bring a claim as a plaintiff or a class member in a class, consolidated, or representative action. Class arbitrations, class actions, private attorney general actions, and consolidation with other arbitrations or actions aren't allowed.</span>";
			templateHtml += '                </p>';
			templateHtml += '                <h3>';
			templateHtml += '                    <span>General Provisions</span>';
			templateHtml += '                </h3>';
			templateHtml += '                <p>';
			templateHtml += '                    <span>GOVERNING LAW: This Agreement shall be governed by the laws of Australia, without regard to principles of conflicts of law.</span>';
			templateHtml += '                </p>';
			templateHtml += '                <br>';
			templateHtml += '                <p>';
			templateHtml += "                    <span>INTERPRETATION; SEVERABILITY; WAIVER; REMEDIES: Headings are for convenience only and shall not be used to construe the terms of this Agreement. If any term of this Agreement is found invalid or unenforceable by any court of competent jurisdiction, that term will be severed from this Agreement. No failure or delay by Studio Ninja in exercising any right hereunder will waive any further exercise of that right. Studio Ninja's rights and remedies hereunder are cumulative and not exclusive.</span>";
			templateHtml += '                </p>';
			templateHtml += '                <br>';

			templateHtml += '                <p>';
			templateHtml += "                    <span>SUCCESSORS; ASSIGNMENT; NO THIRD PARTY BENEFICIARIES: This Agreement is binding upon and shall inure to the benefit of both parties and their respective successors, heirs, executors, administrators, personal representatives, and permitted assigns. You may not assign this Agreement without Studio Ninja's prior written consent. No third party shall have any rights hereunder.</span>";
			templateHtml += '                </p>';
			templateHtml += '                <br>';
			templateHtml += '                <span>NOTICES: You consent to receive all communications including notices, agreements, disclosures, or other information from Studio Ninja electronically. Studio Ninja may provide all such communications by email or by posting them on the Service or Studio Ninja Blog. For support-related inquiries, you may send an email to </span>';
			templateHtml += '                <span>support@studioninja.co</span>';
			templateHtml += "                <span>. Nothing herein shall limit Studio Ninja's right to object to subpoenas, claims, or other demands.</span>";
			templateHtml += '            </div>';
			templateHtml += '            <div class="modal-footer modal-foot">';
			templateHtml += '                <button class="btn btn-default btn-lg" type="button" data-dismiss="modal" aria-hidden="true">Close</button>';
			templateHtml += '            </div>';
			templateHtml += '        </div>';
			templateHtml += '    </div>';
			templateHtml += '</div>';

			return templateHtml;
		},

		scope: {},
		replace: true,
		transclude: true
	};
});

/***/ }),

/***/ "./web/js/components/PageCalendar/addCalendarEventModal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  angular.module('main').directive('addCalendarEventModal', addCalendarEventModal);

  addCalendarEventModal.$inject = [];

  function addCalendarEventModal() {
    return {
      restrict: 'E',
      scope: {
        isForClient: '<',
        addJob: '&',
        addLead: '&',
        addExtraShoot: '&',
        addAppointment: '&',
        disableButtons: '<',
        mainShootLabelName: '=',
        extraShootLabelName: '='
      },
      template: '\n                        <div id="addNewModal" class="modal modal-center fade" data-backdrop="static" data-keyboard="false">\n                            <div class="modal-dialog">\n                                <div class="modal-content">\n                                    <div class="modal-header pt-pb-15">\n                                       <btn-close></btn-close>\n                                        <h3 class="modal-title">Add new</h3>\n                                    </div>\n                                    <div class="modal-body add-new-modal add-new-list" style="padding-bottom: 5px!important; padding-top: 30px!important">\n                                        <h2 class="add-new-tip f-s-20">I want to add a new...</h2>\n                                        \n                                         <btn-add-new-job-element add="disableButtons || addLead({event:event})"\n                                             icon="fi fi-leads fi-job mr-20"\n                                             title="lead ({{mainShootLabelName | lowercase}})"\n                                             description="Schedule a date and time for a new lead\u2019s {{mainShootLabelName|lowercase}}."\n                                        ></btn-add-new-job-element>\n                                        \n                                        <btn-add-new-job-element add="disableButtons || addJob({event:event})"\n                                             icon="fi fi-jobs fi-job mr-20"\n                                             title="job ({{mainShootLabelName | lowercase}})"\n                                             description="Schedule a date and time for a new job\u2019s {{mainShootLabelName|lowercase}}."\n                                        ></btn-add-new-job-element>\n\n                                        <btn-add-new-job-element add="disableButtons || addExtraShoot({event:event})"\n                                             icon="fi fi-camera-cross fi-job mr-20"\n                                             title="{{extraShootLabelName | lowercase}}"\n                                             description="Schedule an {{extraShootLabelName|lowercase}} for an existing job."\n                                             ng-if="!isForClient"\n                                        ></btn-add-new-job-element>\n\n                                        <btn-add-new-job-element add="disableButtons || addAppointment({event:event})"\n                                             icon="fi fi-call fi-job mr-20"\n                                             title="appointment"\n                                             description="Schedule a date and time for an appointment."\n                                             ng-if="!isForClient"\n                                        ></btn-add-new-job-element>\n                                      \n                                    </div>\n                                </div>\n                            </div>\n       \n                        </div>\n                 ',
      replace: true,
      transclude: true,
      link: function link(scope) {}
    };
  }
})();

/***/ }),

/***/ "./web/js/components/PageCalendar/eventTypeCell.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
	angular.module('main').directive('eventTypeCell', eventTypeCell);

	eventTypeCell.$inject = ['$location', 'customizeLabelsService'];

	function eventTypeCell($location, customizeLabelsService) {
		return {
			restrict: 'AE',
			scope: {
				eventData: '=snData'
			},
			template: '\n                    <div class="calendar__item__wrap">\n                        <div ng-hide="::isMainShoot(eventData) || (isExt(eventData) && isInLead(eventData)) || (isApp(eventData) && isInLead(eventData))" class="calendar__item">\n                            <i class="calendar__item__icon jt-big jt-{{::eventData.type | lowercase}}"></i>\n                            <div class="calendar__item__body">\n                                <b class="event__time">\n                                    {{::!eventData.startTime ? ("All day") : (eventData.startTime | timeFilter: "12hLS")}}\n                                </b>\n                                <span>{{::setEventName(eventData)}}</span> \n                                <b class="event__type event__type-{{::eventColor | lowercase}}">{{::eventType}}</b>\n                                </br>\n                             \n                            </div>\n                        </div>\n                        \n                        <div ng-if="::isApp(eventData) && isInLead(eventData)" class="calendar__item">\n                            <i class="calendar__item__icon jt-big jt-{{::eventData.type | lowercase}}"></i>\n                            <div class="calendar__item__body">\n                                <b class="event__time">\n                                    {{::!eventData.startTime ? ("All day") : (eventData.startTime | timeFilter: "12hLS")}}\n                                </b>\n                                <span>{{::setEventName(eventData)}}</span> \n                                <b class="event__type event__type-{{::eventColor | lowercase}}">{{::eventType}} (LEAD)</b>\n                                </br>\n                              \n                            </div>\n                        </div>\n                        \n                        <div ng-if="::isExt(eventData) && isInLead(eventData)" class="calendar__item">\n                            <i class="calendar__item__icon jt-big jt-{{::eventData.type | lowercase}}"></i>\n                            <div class="calendar__item__body">\n                                <b class="event__time">\n                                    {{::!eventData.startTime ? ("All day") : (eventData.startTime | timeFilter: "12hLS")}}\n                                </b>\n                                <span>{{::setEventName(eventData)}}</span> \n                                <b class="event__type event__type-{{::eventColor | lowercase}}">{{::eventType}} (LEAD)</b>\n                                </br>\n                              \n                            </div>\n                        </div>\n                        \n                        <a class="calendar__item__link" ng-mousedown="goToEvent($event,eventData)" ng-href="/jobs/view/{{eventData.jobId}}" >\n                        <div ng-if="::isMainShoot(eventData) && isInLead(eventData)===false" class="calendar__item">\n                            <i class="calendar__item__icon jt-big jt-{{::eventData.type | lowercase}}"></i>\n                            <div class="calendar__item__body">\n                                <b class="event__time">\n                                    {{::!eventData.startTime ? ("All day") : (eventData.startTime | timeFilter: "12hLS")}}\n                                </b>\n                                <span>{{::setEventName(eventData)}}</span> \n                                <b class="event__type event__type-{{::eventColor | lowercase}}">{{::eventType}}</b>\n                                </br>\n                                <b ng-if="::eventData.typeColor === \'LEAD\' && eventType === \'MAIN SHOOT\'" class="event__type event__type-{{::eventColor | lowercase}}">UNCONFIRMED</b>\n                            </div>\n                        </div>\n                        </a>\n                        \n                        <a class="calendar__item__link" ng-mousedown="goToEvent($event,eventData)" ng-href="/leads/view/{{eventData.leadId}}">\n                        <div ng-if="::isMainShoot(eventData) && isInLead(eventData)===true" class="calendar__item">\n                            <i class="calendar__item__icon jt-big jt-{{::eventData.type | lowercase}}"></i>\n                            <div class="calendar__item__body">\n                                <b class="event__time">\n                                    {{::!eventData.startTime ? ("All day") : (eventData.startTime | timeFilter: "12hLS")}}\n                                </b>\n                                <span>{{::setEventName(eventData)}}</span> \n                                <b class="event__type event__type-{{::eventColor | lowercase}}">{{::eventType}} (LEAD)</b>\n                                </br>\n                              \n                            </div>\n                        </div>\n                        </a>\n                    </div>  \n        ',
			replace: true,
			transclude: true,
			link: function link(scope) {
				scope.isMainShoot = function (event) {
					return event.calendarEventType === 'MAIN_SHOOT';
				};
				scope.isExt = function (event) {
					return event.calendarEventType === 'EXTRA_SHOOT';
				};
				scope.isApp = function (event) {
					return event.calendarEventType === 'APPOINTMENT';
				};
				scope.isInLead = function (event) {
					return event.inLead;
				};

				if (scope.eventData) {
					setEventType(scope.eventData);
				}

				scope.goToEvent = function (event, eventData) {
					// 0 left mouse btn
					if (event.button === 0) {
						event.preventDefault();
						// clear query parameters in url
						$location.url('/');
						// redirect to lead or jobs
						eventData.inLead ? $location.path('/leads/view/' + eventData.leadId) : $location.path('/jobs/view/' + eventData.jobId);
					}
				};

				scope.setEventName = function (event) {
					if (!event) {
						return '';
					}

					if (event.jobName && !scope.isMainShoot(event)) {
						return event.jobName + ' - ' + event.name;
					}
					return event.name;
				};

				function setEventType(event) {
					if (event.calendarEventType === 'MAIN_SHOOT' && event.inLead === false) {
						scope.eventColor = 'SHOOT';
						scope.eventType = customizeLabelsService.customizeLabels.mainShootLabel.toUpperCase();
					} else if (event.calendarEventType === 'MAIN_SHOOT' && event.inLead === true) {
						scope.eventColor = 'LEAD';
						scope.eventType = customizeLabelsService.customizeLabels.mainShootLabel.toUpperCase();
					} else if (event.calendarEventType === 'EXTRA_SHOOT' && event.inLead === false) {
						scope.eventColor = 'SHOOT';
						scope.eventType = customizeLabelsService.customizeLabels.extraShootLabel.toUpperCase();
					} else if (event.calendarEventType === 'EXTRA_SHOOT' && event.inLead === true) {
						scope.eventColor = 'LEAD';
						scope.eventType = customizeLabelsService.customizeLabels.extraShootLabel.toUpperCase();
					} else {
						scope.eventColor = 'APPOINTMENT';
						scope.eventType = 'APPOINTMENT';
					}
				}
			}
		};
	}
})();

/***/ }),

/***/ "./web/js/components/PageCalendar/thCalendarMonth.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('main').directive('thCalendarMonth', ['$filter', function () {
	return {
		restrict: 'AE',
		template: '<table>' + '<tr>' + '<td class="td-head"><div>{{thisDay}}</div></td>' + '</tr>' + '</table>',
		scope: {
			day: '=snDay'
		},
		replace: true,
		transclude: true,
		link: function link(scope) {
			var _month = scope.day.getMonth();
			scope.thisDay = scope.day.getDate();

			if (scope.thisDay === 1) {
				var monthShortNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
				scope.thisDay += ' ' + monthShortNames[_month];
			}
		}
	};
}]);

/***/ }),

/***/ "./web/js/components/PageCalendar/thCalendarWeek.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('main').directive('thCalendarWeek', function () {
	return {
		restrict: 'AE',
		template: '<tr>' + '<td class="td-empty"></td>' + '<td class="row-day-head" ng-repeat="day in week | orderBy track by $index">' + '{{day.date | date: "EEE dd" }}' + '</td>' + '</tr>',
		scope: {
			week: '=snWeek'
		},
		replace: true,
		transclude: true
	};
});

/***/ }),

/***/ "./web/js/components/PageCalendar/trWeekAllDays.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('main').directive('trWeekAllDays', function () {
	return {
		restrict: 'AE',
		template: '<tr>' + '<td class="td-empty"></td>' + '<td class="row-day-head" ng-repeat="day in week | orderBy track by $index">' + '{{day.date | date: "EEE dd" }}' + '</td>' + '</tr>',
		scope: {
			week: '=snWeek'
		},
		replace: true,
		transclude: true
	};
});

/***/ }),

/***/ "./web/js/components/PageCalendar/weekEventCell.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
	angular.module('main').directive('weekEventCell', weekEventCell);

	weekEventCell.$inject = ['$location', 'timeService', 'customizeLabelsService'];

	function weekEventCell($location, timeService, customizeLabelsService) {
		return {
			restrict: 'AE',
			scope: {
				snData: '=',
				snHour: '=',
				snIndex: '@'
			},
			template: '\n                <div class="calendar__item__wrap">\n                    <div ng-hide="::cellHeight < 1 || isMainShoot(eventData)" class="calendar__item" style="height:{{::cellHeight}};margin-top:{{::cellOffsetTop}};"\n                         ng-class="::{\'calendar__item-last\': endEventCell}"> \n                        <i class="calendar__item__icon jt-big jt-{{::eventData.type | lowercase}}"></i>\n                        <div class="calendar__item__body">\n                            <b class="event__time">\n                                 {{::!eventData.startTime ? ("All day") : (eventData.startTime | timeFilter: "12hLS")}}\n                            </b>\n                            <span>{{::setEventName(eventData)}}</span>\n                             <b class="event__type event__type-{{eventColor | lowercase}}"  ng-show="isInLead(eventData)===true">{{::eventType}} (LEAD)</b>\n                            <b class="event__type event__type-{{eventColor | lowercase}}"  ng-show="isInLead(eventData)===false || isInLead(eventData)===null">{{::eventType}}</b>\n                            </br>\n                       \n                        </div>\n                    </div>\n                    \n                    <div ng-click="showLead(snData.leadId)" ng-hide="cellHeight < 1 || !isMainShoot(eventData) || isInLead(eventData)===false" class="calendar__item" style="height:{{::cellHeight}};margin-top:{{::cellOffsetTop}};"\n                           ng-class="::{\'calendar__item-last\': endEventCell}"> \n                        <i class="calendar__item__icon jt-big jt-{{::eventData.type | lowercase}}"></i>\n                        <div class="calendar__item__body">\n                            <b class="event__time">\n                                 {{::!eventData.startTime ? ("All day") : (eventData.startTime | timeFilter: "12hLS")}}\n                            </b>\n                            <span>{{::setEventName(eventData)}}</span> \n                           <b class="event__type event__type-{{eventColor | lowercase}}"  ng-show="isInLead(eventData)===true">{{::eventType}} (LEAD)</b>\n                            <b class="event__type event__type-{{eventColor | lowercase}}"  ng-show="isInLead(eventData)===false">{{::eventType}}</b>\n                             </br>\n                            \n                        </div>\n                    </div>\n                   \n                    <div ng-click="showJob(snData.jobId)" ng-hide="cellHeight < 1 || !isMainShoot(eventData) || isInLead(eventData)===true" class="calendar__item" style="height:{{::cellHeight}};margin-top:{{::cellOffsetTop}};"\n                           ng-class="::{\'calendar__item-last\': endEventCell}"> \n                        <i class="calendar__item__icon jt-big jt-{{::eventData.type | lowercase}}"></i>\n                        <div class="calendar__item__body">\n                            <b class="event__time">\n                                 {{::!eventData.startTime ? ("All day") : (eventData.startTime | timeFilter: "12hLS")}}\n                            </b>\n                            <span>{{::setEventName(eventData)}}</span> \n                           <b class="event__type event__type-{{eventColor | lowercase}}"  ng-show="isInLead(eventData)===true">{{::eventType}} (LEAD)</b>\n                            <b class="event__type event__type-{{eventColor | lowercase}}"  ng-show="isInLead(eventData)===false">{{::eventType}}</b>\n                             </br>\n                            \n                        </div>\n                    </div>\n                    \n                </div>\n            ',
			replace: true,
			transclude: true,
			link: function link(scope, elem) {
				var event = void 0,
				    rowHeight = void 0,
				    rowOffsetTop = void 0;
				var currentHour = void 0;
				var currentDay = void 0,
				    startDay = void 0,
				    endDay = void 0,
				    startHours = void 0,
				    endHours = void 0,
				    eventStartMinutes = void 0,
				    eventEndMinutes = void 0,
				    eventStartTime = void 0,
				    eventEndTime = void 0;
				var CELLHEIGHT = 80,
				    CELLOFFSETBOTTOM = 10;

				scope.endEventCell = false;
				event = angular.copy(scope.snData);

				currentDay = scope.snHour.time.getDate();
				currentHour = scope.snHour.time.getHours();
				startHours = timeService.getHour(event.startTime);

				if (currentHour === startHours) {
					endDay = timeService.getDay(event.endDate);
					endHours = timeService.getHour(event.endTime);
					eventStartMinutes = timeService.getMinutes(event.startTime);

					eventStartMinutes /= 60;
					eventStartMinutes = parseFloat(eventStartMinutes.toFixed(2));
					eventStartTime = currentHour + eventStartMinutes;

					if (eventStartMinutes) {
						rowOffsetTop = eventStartMinutes;
						rowOffsetTop = rowOffsetTop * CELLHEIGHT + 'px';
					}

					eventEndMinutes = timeService.getMinutes(event.endTime);
					eventEndMinutes /= 60;
					eventEndMinutes = parseFloat(eventEndMinutes.toFixed(2));

					eventEndTime = endHours + eventEndMinutes;

					if (eventStartTime > eventEndTime && currentDay < endDay) {
						eventEndTime = 24;
					}

					rowHeight = eventEndTime - eventStartTime;

					var cellBottomSpace = Number.isInteger(eventEndTime) ? CELLOFFSETBOTTOM : 0;
					rowHeight = rowHeight * CELLHEIGHT - cellBottomSpace + 'px';
				}

				if (eventEndTime == 24) {
					scope.endEventCell = true;
				}

				scope.cellHeight = rowHeight || 0;
				scope.cellOffsetTop = rowOffsetTop || 0;

				if (scope.snIndex > 0) {
					elem.addClass('item-' + scope.snIndex);
				}

				scope.eventData = event;

				if (scope.eventData) {
					setEventType(scope.eventData);
				}

				scope.isMainShoot = function (event) {
					return event.calendarEventType === 'MAIN_SHOOT';
				};

				scope.isInLead = function (event) {
					return event.inLead;
				};

				scope.setEventName = function (event) {
					if (!event) {
						return '';
					}
					if (event.typeColor === 'LEAD') {
						return '' + event.name;
					}
					if (event.jobName && !scope.isMainShoot(event)) {
						return event.jobName + ' - ' + event.name;
					}
					return event.name;
				};

				function setEventType(event) {
					if (event.calendarEventType === 'MAIN_SHOOT' && event.inLead === false) {
						scope.eventColor = 'SHOOT';
						scope.eventType = customizeLabelsService.customizeLabels.mainShootLabel.toUpperCase();
					} else if (event.calendarEventType === 'MAIN_SHOOT' && event.inLead === true) {
						scope.eventColor = 'LEAD';
						scope.eventType = customizeLabelsService.customizeLabels.mainShootLabel.toUpperCase();
					} else if (event.calendarEventType === 'EXTRA_SHOOT' && event.inLead === false) {
						scope.eventColor = 'SHOOT';
						scope.eventType = customizeLabelsService.customizeLabels.extraShootLabel.toUpperCase();
					} else if (event.calendarEventType === 'EXTRA_SHOOT' && event.inLead === true) {
						scope.eventColor = 'LEAD';
						scope.eventType = customizeLabelsService.customizeLabels.extraShootLabel.toUpperCase();
					} else {
						scope.eventColor = 'APPOINTMENT';
						scope.eventType = 'APPOINTMENT';
					}
				}

				scope.showJob = function (jobId) {
					$location.path('jobs/view/' + jobId);
				};

				scope.showLead = function (leadId) {
					$location.path('leads/view/' + leadId);
				};
			}
		};
	}
})();

/***/ }),

/***/ "./web/js/components/PageJobsOverview/isLeadJob.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('main').directive('isLeadJob', function () {
	return {
		restrict: 'EA',
		scope: {
			job: '=snJob'
		},
		template: ' <span ng-show="isLeadJob">(lead)</span>',
		replace: true,
		transclude: true,
		link: function link(scope) {
			scope.isLeadJob = scope.job.jobWorkflow.progressBarType == 'LEAD';
		}
	};
});

/***/ }),

/***/ "./web/js/components/PageJobsOverview/jobProgress.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('main').directive('jobWorkflowProgress', function () {
	return {
		restrict: 'E',
		scope: {
			job: '=snJob'
		},
		template: '<div class="info-box-progress">\n                      <div class="progress progress-xs progress-squared bs-n">\n                        <div class="progress-bar progress-bar-success {{::barTypesClass}}" role="progressbar"\n                          aria-valuenow="10" aria-valuemin="0" aria-valuemax="100" style="width:{{::progressWidth}}">\n                        </div>\n                      </div>\n                    </div>\n                    ',
		replace: true,
		transclude: true,
		link: function link(scope) {
			var workflow = angular.copy(scope.job.jobWorkflow);

			scope.progressWidth = workflow.countOfCompletedTask / workflow.countOfTask * 100 + '%';
			scope.barTypesClass = workflow.progressBarType;
		}
	};
});

/***/ }),

/***/ "./web/js/components/Workflow/Modals/addAppointmentWithoutScheduleModal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

(function () {
	angular.module('main').directive('addAppointmentWithoutScheduleModal', addAppointmentWithoutScheduleModal);

	addAppointmentWithoutScheduleModal.$inject = ['workflowService', 'messageService', 'validationService'];

	function addAppointmentWithoutScheduleModal(workflowService, messageService, validationService) {
		return {
			restrict: 'E',
			scope: {
				appointment: '<',
				taskList: '='
			},
			template: '<section>\n                        <div id="appointmentWithoutScheduleModal" class="modal modal-center fade modal-appointment-lx" data-backdrop="static"\n                             data-keyboard="false">\n                            <div class="modal-dialog modal-dialog-datepicker">\n                                <form ng-submit="saveAppointment(appointment, taskList, appointment.id)">\n                                    <div class="modal-content">\n                                        <div class="modal-header">\n                                            <btn-close></btn-close>\n                                            <h3 class="modal-title">{{appointment.id ? \'Edit appointment\':\'Add appointment\'}}</h3>\n                                        </div>\n                                        <div class="modal-body f-s-14-i" style="padding-bottom: 15px !important">\n                                            <h3 class="mt-0 mb-25">Appointment details</h3>\n                                            <div class="flex-row flex-wrap-xs flex-align-center mb-30">\n                                                <div class="pr-30">\n                                                    <p>Name</p>\n                                                </div>\n                                                <div class="flex-grow-1 flex-with-full mb-10">\n                                                    <input type="text" class="form-control" name="appointmentName" ng-model="appointment.name" autocomplete="off"\n                                                           required>\n                                                </div>\n                                            </div>\n                                            <div class="flex-row">\n                                                <p>\n                                                   Update appointment schedule, including date range, time range and location, from within your job profile, once you have applied this workflow to a job.\n                                                </p>\n                                            </div>\n                                        </div>\n                                        <div class="modal-footer modal-foot">\n                                            <button ng-disabled="button_disable" class="btn btn-success btn-lg" type="submit"\n                                                    spinning-wheel is-spinning-wheel-active="isUpdateSpinnningWheelActive">Save appointment\n                                            </button>\n                                        </div>\n                                    </div>\n                                </form>\n                            </div>\n                        </div>\n                    </section>\n             ',
			replace: true,
			transclude: true,
			link: function link(scope) {
				var appointmentModal = '#appointmentWithoutScheduleModal';

				$(appointmentModal).on('show.bs.modal', function () {
					scope.taskInfo = workflowService.getTaskInfo();
					scope.isForEdit = scope.taskInfo.isForEdit;
					scope.appointment = angular.copy(scope.taskInfo.task);
					scope.$evalAsync();
				}).on('shown.bs.modal', function () {
					$(this).find('input').first().focus();
					var input = $(this).find('input');

					validationService.isModalClosePrevented(input);
				});

				scope.saveAppointment = function (appointment, taskTypes, id) {
					scope.button_disable = true;

					var isEdited = id !== null && id !== undefined;

					if (!workflowService.isTaskValid(appointment)) {
						scope.button_disabled = false;
						return;
					}

					if (!appointment.eventType) {
						appointment.eventType = 'APPOINTMENT';
					}

					scope.taskList = workflowService.pasteNewTaskInList(taskTypes, appointment); // modifies workflow list
					scope.taskList = workflowService.renewTaskViewDue(scope.taskList);

					isEdited ? messageService.showToaster('s_4', 'workflow') : messageService.showToaster('s_3', 'workflow');

					scope.button_disable = false;

					$(appointmentModal).modal('hide');
				};
			}
		};
	}
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./web/js/components/Workflow/Modals/addAutomationModal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

(function () {
	angular.module('main').directive('addAutomationModal', addAutomationModal);

	addAutomationModal.$inject = ['$rootScope', '$q', 'workflowService', 'templateRequestsService', 'messageService', 'stringModifierService', 'fileUploadService', 'validationService', 'utilsService', '$location', 'workflowDataService', 'newJobsDataService', 'contractService', 'emailService'];

	function addAutomationModal($rootScope, $q, workflowService, templateRequestsService, messageService, stringModifierService, fileUploadService, validationService, utilsService, $location, workflowDataService, newJobsDataService, contractService, emailService) {
		return {
			restrict: 'E',
			scope: {
				jobId: '<',
				taskList: '=',
				templates: '<',
				fromSettings: '<',
				getJob: '&',
				renewWorkflow: '&',
				tickTask: '=',
				tickTaskType: '='
			},
			replace: true,
			template: '<div>\n                    <div id="addAutomationModal" class="modal modal-center fade" data-backdrop="static" data-keyboard="false">\n                        <div class="modal-dialog">\n                    \n                             <form role="form" name="addAutomation" ng-submit="fromSettings ? saveTaskFromSettings() : saveTask()">\n                                <div class="modal-content">\n                                    <div class="modal-header">\n                                        <btn-close ng-click="close()"></btn-close>\n                                        <h3 ng-if="!tickTask" class="modal-title">{{isForEdit ? \'Edit automation\' : \'Add a new automation\'}}</h3>\n                                        <h3 ng-if="tickTask" class="modal-title">{{tickTaskType === \'CONTRACT\' ? \'Send Contract\' : \'Send Questionnaire\' }}</h3>\n                                    </div>\n                                    <div class="modal-body f-s-14-i">\n                                        <div class="form-group mb-8">\n                                        \n                                        <div class="field-info mb-25" ng-if="tickTask">\n\t\t\t\t\t\t\t\t\t\t\t<h4>To</h4>\n\t\t\t\t\t\t\t\t\t\t\t<div class="flex-row">\n\t\t\t\t\t\t\t\t\t\t\t\t<email-field class="w-max-100"\n\t\t\t\t\t\t\t\t\t\t\t\t\t [placeholder]="\'myclient@abc.com\'"\n\t\t\t\t\t\t\t\t\t\t\t\t\t [disabled]="true"\n\t\t\t\t\t\t\t\t\t\t\t\t\t [value]="sendMessage.emailTo"\n\t\t\t\t\t\t\t\t\t\t\t\t\t (value-change)="setEmailData($event, \'sendMessage\', \'emailTo\')">\n                                \t\t\t\t</email-field>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n                                    \n                                            <div class="row" ng-if="!tickTask">\n                                                <h4 class="m-l-sm">Task name</h4>\n                                                <div class="col-xs-12">\n                                              \n                                                    <input type="text" autocomplete="off" class="form-control" ng-model="newAutomation.name" required/>\n                                                    \n                                                </div>\n                                            </div>\n                    \n                                            <div class="row mt-20" ng-if="!tickTask">\n                                         \n                                          \n                                                <h4 class="m-l-sm">Action</h4>\n                    \n                                                <div class="col-xs-12">\n                    \n                                                    <div class="select-style">\n                                                        <select ng-model="newAutomation.action"\n                                                                ng-options="action.shortName as action.fullName for action in automatedActions | orderBy"\n                                                                required>\n                                                            <option value="" class="hide">Choose action</option>\n                                                        </select>\n                                                    </div>\n                                                </div>\n                                            </div>\n                    \n                                            <hr ng-if="!tickTask" class="mt-30 mb-30">\n                                            \n                                            <add-questionnaire  ng-if="newAutomation.action === \'SEND_QUESTIONNAIRE\' && sources.questionnaireEmail.name || tickTaskType === \'QUESTIONNAIRE\' && tickTask "\n                                                                chosen-questionnaire = "sources.questionnaire"\n                                                                email = "sources.questionnaireEmail"\n                                                                email-templates = "questionnaireEmailTemplates" \n                                                                from-settings="fromSettings"\n                                                                questionnaires = "questionnaires"\n                                                                tick-task="tickTask"  \n                                            ></add-questionnaire>\n                                            \n                                            <add-contract   ng-if="newAutomation.action === \'SEND_CONTRACT\' && sources.contractEmail.name || tickTaskType === \'CONTRACT\' && tickTask " \n                                                            chosen-contract="sources.contract"\n                                                            contracts = "contracts"\n                                                            edit-contract="editContract(contract)"\n                                                            email = "sources.contractEmail"\n                                                            email-templates = "contractEmailTemplates" \n                                                            from-settings="fromSettings"\n                                                            on-change = "deleteUpdatedContract()"\n                                                           \ttick-task="tickTask"\n                                            ></add-contract>\n                                            \n                                            <add-mail   ng-if="newAutomation.action === \'SEND_EMAIL\' && sources.plainEmail && !fromSettings"\n                                                        email-info="emailInfo"\n                                                        email = "sources.plainEmail"\n                                                        email-templates = "generalEmailTemplates"   \n                                                        from-settings="fromSettings"\n                                            ></add-mail>\n                                            \n                                            <add-mail-or-template  ng-if="newAutomation.action === \'SEND_EMAIL\' && fromSettings"\n                                                        email-info="emailInfo"\n                                                        email-to-save = "sources.plainEmail"\n                                                        email-templates = "generalEmailTemplates" \n                                            ></add-mail-or-template>\n                    \n                                            <div class="checkbox flex-row" ng-if="!tickTask">\n                                                <div class="checkbox-squared wf-label">\n                                                    <input id="checkbox-squared-has-due-date-auto" type="checkbox"\n                                                           ng-model="newAutomation.hasDue">\n                                                    <label for="checkbox-squared-has-due-date-auto"></label>\n                                                </div>\n                                                <label for="checkbox-squared-has-due-date-auto" class="checker f-s-14-i">\n                                                    Send automatically on a due date\n                                                </label>\n                                            </div>\n                    \n                                            <div ng-if="!tickTask" class="row flex-row flex-align-center mt-20 flex-wrap-xs">\n                                                <label class="col-xs-12 col-sm-1 control-label pull-left f-s-14-i mb-xs-10">Due</label>\n                                                <div class="col-xs-12 col-sm-2 numb-style mb-xs-10 numb-no-fixed-width">\n                                                    <input ng-disabled="!newAutomation.hasDue" data-number-input min="1"\n                                                           class="form-control"\n                                                           type="number" ng-model="newAutomation.due" autocomplete="off" required>\n                                                </div>\n                                                <div class="col-xs-12 col-sm-4 mb-xs-10">\n                                                    <div class="select-style">\n                                                        <select ng-disabled="!newAutomation.hasDue" ng-model="newAutomation.dateItem"\n                                                                ng-options="item for item in dateItems | orderBy" required>\n                                                        </select>\n                                                    </div>\n                                                </div>\n                                                <div class="col-xs-12 col-sm-5 mb-xs-10">\n                                                    <div class="select-style">\n                                                        <select ng-disabled="!newAutomation.hasDue" ng-model="newAutomation.dateSequence"\n                                                                ng-options="item.id as item.name for item in taskDateSequence">\n                                                        </select>\n                                                    </div>\n                                                </div>\n                                            </div>\n                                        </div>\n                                    </div>\n                                    <div class="modal-footer modal-foot">\n                                        <button type="submit" class="btn btn-lg btn-success" ng-disabled="button_disabled" \n                                        spinning-wheel is-spinning-wheel-active="button_disabled">\n                                       \t\t <span ng-if="!tickTask">Save workflow task</span>\n                                       \t\t <span ng-if="tickTask">{{tickTaskType === \'QUESTIONNAIRE\' ? \'Send questionnaire\': \'Send contract\'}}</span>\n                                        </button>\n                                    </div>\n                                </div>\n                            </form>\n                        </div>\n                        </div>\n                      \n                        <edit-contract-modal id="editContractFromWorkflowModal"\n                                             close-edit-contract="closeEditContract()"\n                                             editable-contract="editableContract"\n                                             save-edited-contract="saveEditedContract()"\n                        ></edit-contract-modal>\n                        \n                    </div>  \n\n',
			link: function link(scope) {
				var _this = this;

				scope.emailInfo = {};
				scope.showCcField = false;
				scope.sendMessage = {};

				var isFirstShow = true;
				scope.isLeadPage = $location.path().includes('/leads/');
				scope.isJobPage = $location.path().includes('/jobs/');
				scope.taskToAnimateNumber = null;
				var automationModal = '#addAutomationModal';
				var contractModal = '#editContractFromWorkflowModal';
				var emptyTextObj = {
					text: ''
				};

				var DEFAULT_EMAIL_NAME = 'Choose an existing email template';

				var emptyAttachmentsData = {
					attachments: [],
					filesSize: 0
				};

				var emptyEmail = {
					name: DEFAULT_EMAIL_NAME,
					text: '',
					attachmentsData: angular.copy(emptyAttachmentsData)
				};

				var prepareTemplates = function prepareTemplates() {
					if (!scope.templates) {
						console.error('No templates loaded');
						return;
					}
					var templates = angular.copy(scope.templates);

					scope.contractEmailTemplates = templates.contractEmailTemplates;
					scope.contracts = templates.contracts;

					scope.questionnaireEmailTemplates = templates.questionnaireEmailTemplates;
					scope.questionnaires = templates.questionnaires;

					scope.generalEmailTemplates = templates.generalEmailTemplates;
				};

				var showErrorMessage = function showErrorMessage() {
					messageService.showToaster('e_0', 'general');
				};

				var getDueOptions = function getDueOptions() {
					scope.taskDateSequence = workflowService.getTaskDateSequence();
					scope.dateItems = workflowService.getTaskDates();
				};

				var isItemSaved = function isItemSaved(item) {
					return item.hasOwnProperty('id') && item.hasOwnProperty('templateId');
				};

				var prepareQuestionnaire2Save = function prepareQuestionnaire2Save() {
					var questionnaire2Save = scope.sources.questionnaire;
					var isUserQuestionnaire = isItemSaved(questionnaire2Save);

					var questionnaire = {
						id: isUserQuestionnaire ? scope.sources.questionnaire.id : null,
						templateId: isUserQuestionnaire ? null : scope.sources.questionnaire.id
					};

					return questionnaire;
				};

				var prepareContract2Save = function prepareContract2Save() {
					var contract2Save = angular.copy(scope.sources.contract);

					var isUserContractNotEdited = true;

					if (scope.updatedContract) {
						isUserContractNotEdited = angular.equals(contract2Save, scope.updatedContract);
					}

					contract2Save.name = scope.updatedContract && !isUserContractNotEdited ? scope.updatedContract.name : null;
					contract2Save.text = scope.updatedContract && !isUserContractNotEdited ? scope.updatedContract.text : null;
					if (contract2Save.text) {
						contract2Save.text = $rootScope.addMaiStyling(contract2Save.text);
					}

					if (contract2Save.name) {
						contract2Save.name = stringModifierService.cutSelectedText(contract2Save.name);
					}

					return contract2Save;
				};

				var prepareEmailAttachments = function prepareEmailAttachments(taskEmail) {
					var deferred = $q.defer();

					var attachmentsData = taskEmail.attachmentsData;


					var isAttachments = attachmentsData && attachmentsData.attachments.length;

					if (!isAttachments) {
						deferred.resolve(taskEmail);
						return deferred.promise;
					}

					var attachments = attachmentsData.attachments,
					    filesSize = attachmentsData.filesSize;

					var maxSize = 10; // 10Mb

					if (filesSize > maxSize) {
						messageService.showToaster('w_0', 'attachments');
						deferred.reject('Attachments size exceeds the limit');
						return deferred.promise;
					}

					var uploadedAttachments = void 0,
					    storedAttachments = void 0;

					if (attachments.length) {
						uploadedAttachments = attachments.filter(function (attachment) {
							return !attachment.id;
						});
						storedAttachments = attachments.filter(function (attachment) {
							return attachment.id;
						});
					}

					taskEmail.storedAttachments = storedAttachments && storedAttachments.length ? storedAttachments : null;

					if (uploadedAttachments && uploadedAttachments.length) {
						fileUploadService.convertFileToSave(uploadedAttachments).then(function (convertedFilesArr) {
							taskEmail.base64Attachments = convertedFilesArr;
							deferred.resolve(taskEmail);
						}).catch(function (error) {
							return console.log(error);
						});
					} else {
						deferred.resolve(taskEmail);
					}

					delete taskEmail.attachmentsData;
					return deferred.promise;
				};

				var prepareEmail2save = function prepareEmail2save(taskEmail) {
					var id = taskEmail.id,
					    emailTemplateId = taskEmail.emailTemplateId,
					    name = taskEmail.name,
					    subject = taskEmail.subject,
					    text = taskEmail.text,
					    storedAttachments = taskEmail.storedAttachments,
					    attachmentsData = taskEmail.attachmentsData;


					if (name === DEFAULT_EMAIL_NAME) {
						// name will be set on BackEnd
						name = null;
					}

					if (name) {
						name = stringModifierService.cutSelectedText(name);
					}

					return {
						emailTemplateId: emailTemplateId || id,
						name: name,
						subject: subject,
						attachmentsData: attachmentsData,
						storedAttachments: storedAttachments,
						text: text
					};
				};

				var chooseObjectsToSave = function chooseObjectsToSave(task) {
					var task2Save = angular.copy(task);
					var action = task2Save.action;

					if (scope.fromSettings) {
						task2Save.contractId = null;
						task2Save.questionnaireId = null;
					}

					switch (action) {
						case 'SEND_EMAIL':
							task2Save.taskEmail = scope.sources.plainEmail;
							break;

						case 'SEND_QUESTIONNAIRE':
							task2Save.taskEmail = scope.sources.questionnaireEmail;
							if (scope.fromSettings) {
								task2Save.questionnaireId = scope.sources.questionnaire.id;
							} else {
								task2Save.questionnaire = prepareQuestionnaire2Save();
							}
							break;

						case 'SEND_CONTRACT':
							task2Save.taskEmail = scope.sources.contractEmail;

							if (scope.fromSettings) {
								task2Save.contractId = scope.sources.contract.templateId;
							} else {
								task2Save.contract = prepareContract2Save();
							}
							break;
						default:
							break;
					}

					if (!scope.fromSettings) {
						task2Save.taskEmail = prepareEmail2save(task2Save.taskEmail);
					}

					return task2Save;
				};

				scope.editContract = function (contract) {
					var isRealContract = contract.id;

					if (isRealContract && scope.updatedContract) {
						scope.editableContract = angular.copy(scope.updatedContract);
					} else if (isRealContract) {
						scope.editableContract = angular.copy(contract);
					} else if (scope.updatedContract && !isRealContract) {
						scope.editableContract = angular.copy(scope.updatedContract);
					} else if (!scope.updatedContract && !isRealContract) {
						var editContractTemplateCallback = function editContractTemplateCallback(data) {
							scope.editableContract = angular.copy(data);
						};
						templateRequestsService.getTemplates('contract_full', contract.templateId).subscribe(function (data) {
							return editContractTemplateCallback(data);
						}, function (error) {
							return showErrorMessage();
						});
					} else {
						scope.editableContract = angular.copy(emptyTextObj);
						console.error('no selected contract');
					}

					utilsService.showNextModal(automationModal, contractModal);
				};

				scope.deleteUpdatedContract = function () {
					scope.updatedContract = null;
				};

				scope.toggleViewCc = function (state) {
					if (scope.sendMessage && scope.sendMessage.emailCc) {
						scope.sendMessage.emailCc = [];
						scope.$evalAsync();
					}

					scope.showCcField = state !== undefined ? state : !scope.showCcField;
				};

				scope.closeEditContract = function () {
					$(contractModal).modal('hide').on('hidden.bs.modal', function () {
						isFirstShow = false;
						$(automationModal).modal('show');
						$(this).off('hidden.bs.modal');
					});
				};

				$(document).on('show.bs.modal', '#addAutomationModal', function () {
					scope.$broadcast('addedFileEvent');
				});

				scope.saveEditedContract = function () {
					if (!contractService.contractTextValid(scope.editableContract.text)) {
						return;
					}

					var contractName = stringModifierService.cutSelectedText(scope.editableContract.name);
					messageService.showToaster('s_2', 'contractTemplates', contractName);
					$(contractModal).modal('hide').on('hidden.bs.modal', function () {
						scope.updatedContract = scope.editableContract;
						isFirstShow = false;
						$(automationModal).modal('show');
						$(this).off('hidden.bs.modal');
					});
				};

				var addDefaultEmails = function addDefaultEmails() {
					var sources = {};
					sources.contract = null;
					sources.contractEmail = scope.contractEmailTemplates.find(function (item) {
						return item.emailTemplateType === 'CONTRACT_EMAIL_TEMPLATE';
					}) || {};
					sources.contractEmail.attachmentsData = angular.copy(emptyAttachmentsData);

					sources.questionnaire = null;
					sources.questionnaireEmail = scope.questionnaireEmailTemplates.find(function (item) {
						return item.emailTemplateType === 'QUESTIONNAIRE_EMAIL_TEMPLATE';
					}) || {};
					sources.questionnaireEmail.attachmentsData = angular.copy(emptyAttachmentsData);

					sources.plainEmail = null;
					if (!scope.fromSettings) {
						sources.plainEmail = angular.copy(emptyEmail);
						scope.generalEmailTemplates.push(emptyEmail);
					}
					return sources;
				};

				var getContractById = function getContractById(id) {
					return scope.contracts.find(function (contract) {
						return contract.templateId === id;
					});
				};

				var getQuestionnaireById = function getQuestionnaireById(id) {
					return scope.questionnaires.find(function (questionnaire) {
						return questionnaire.id === id;
					});
				};

				var addAttachments = function addAttachments(email) {
					var emailCopy = angular.copy(email);

					if (emailCopy.storedAttachments && emailCopy.storedAttachments.length) {
						emailCopy.attachmentsData = {
							attachments: fileUploadService.convertAttachmentsToShow(emailCopy.storedAttachments)
						};
					} else {
						emailCopy.attachmentsData = angular.copy(emptyAttachmentsData);
					}
					return emailCopy;
				};

				var setEmailTemplate = function setEmailTemplate(email) {
					scope.$broadcast('emailTemplateUpdated', email);
				};

				var prepareTaskToShow = function prepareTaskToShow(task) {
					var sources = addDefaultEmails();
					var action = task.action;

					if (!scope.isForEdit) {
						return sources;
					}

					var email = angular.copy(task.taskEmail);
					if (email.name && !scope.fromSettings) {
						email.name = stringModifierService.addSelectedText(email.name);
					}

					email = addAttachments(email);

					switch (action) {
						case 'SEND_EMAIL':
							sources.plainEmail = email;
							if (scope.fromSettings) {
								setEmailTemplate(sources.plainEmail);
								scope.$evalAsync();
								scope.emailInfo.isEmailShown = !email.id;
							} else {
								scope.generalEmailTemplates.push(email);
							}
							break;

						case 'SEND_QUESTIONNAIRE':
							sources.questionnaireEmail = email;
							if (task.questionnaireId) {
								sources.questionnaire = getQuestionnaireById(task.questionnaireId);
							} else {
								var questionnaire = task.questionnaire;
								questionnaire.name = stringModifierService.addSelectedText(questionnaire.name);
								sources.questionnaire = questionnaire;
								scope.questionnaires.push(questionnaire);
								scope.questionnaireEmailTemplates.push(email);
							}

							break;

						case 'SEND_CONTRACT':
							sources.contractEmail = email;
							if (task.contractId) {
								sources.contract = getContractById(task.contractId);
							} else {
								var contract = angular.copy(task.contract);
								contract.name = stringModifierService.addSelectedText(contract.name);
								sources.contract = contract;
								scope.updatedContract = angular.copy(contract);
								scope.contracts.push(contract);
								scope.contractEmailTemplates.push(email);
							}

							break;
						default:
							break;
					}

					return sources;
				};

				var successTaskSave = function successTaskSave(task, taskTypes, id) {
					var isEdited = id !== null && id !== undefined;

					prepareEmailAttachments(task.taskEmail).then(function (result) {
						task.taskEmail = result;
						scope.taskList = workflowService.pasteNewTaskInList(taskTypes, task); // modifies workflow list
						scope.taskList = workflowService.renewTaskViewDue(scope.taskList);
						isFirstShow = true;
						isEdited ? messageService.showToaster('s_4', 'workflow') : messageService.showToaster('s_3', 'workflow');
						$(automationModal).modal('hide');
					}, function (error) {
						scope.button_disabled = false;
						console.error(error);
					});
				};

				var errorValidateEmailName = function errorValidateEmailName(data) {
					var error = data.errorMessage;
					if (error && error === 'Email template with same name is already exist') {
						messageService.showToaster('e_8', 'emailTemplate');
					} else {
						showErrorMessage();
					}
				};

				scope.saveTaskFromSettings = function () {
					var wasEmailFieldShown = scope.emailInfo.isEmailShown;
					scope.button_disabled = true;
					scope.emailInfo.isEmailShown = false;
					var task2Save = chooseObjectsToSave(scope.newAutomation);

					if (!workflowService.isTaskValid(task2Save, 'fromSettings')) {
						scope.emailInfo.isEmailShown = wasEmailFieldShown;
						scope.button_disabled = false;
						return;
					}

					if (task2Save.action === 'SEND_EMAIL') {
						workflowService.validateEmailName(task2Save.taskEmail).finally(function () {
							return scope.button_disabled = false;
						}).subscribe(function () {
							return successTaskSave(task2Save, scope.taskList);
						}, function (result) {
							return errorValidateEmailName(result.data);
						});
						return;
					}

					var emailTemplateId = task2Save.taskEmail.id;


					workflowService.validateEmailLinks(task2Save.action, emailTemplateId).finally(function () {
						return scope.button_disabled = false;
					}).subscribe(function () {
						return successTaskSave(task2Save, scope.taskList, task2Save.id);
					}, function (result) {
						return workflowService.errorSaveTask(result.data);
					});
				};

				var renewWorkflow = function renewWorkflow(data, id) {
					scope.tickTask = false;
					scope.tickTaskType = '';
					if (!data || !data.tasks) {
						return;
					}

					scope.renewWorkflow({ tasks: data.tasks });

					for (var i = 0; i < data.tasks.length; i++) {
						if (data && data.taskMetadata && data.taskMetadata.taskId === data.tasks[i].id) {
							scope.taskToAnimateNumber = '.task-' + i;
						}
					}

					var isEdited = id !== null && id !== undefined;

					messageService.showToaster('i_0', 'jobView');

					isFirstShow = true;
					if (!scope.tickTask) {
						isEdited ? messageService.showToaster('s_4', 'workflow') : messageService.showToaster('s_3', 'workflow');
					} else {
						scope.tickTaskType === 'QUESTIONNAIRE' ? messageService.showToaster('s_9', 'jobView') : messageService.showToaster('s_4', 'jobView');
					}

					scope.getJob();
					delete scope.sources;

					$(automationModal).modal('hide').on('hidden.bs.modal', function () {
						if (!isEdited) {
							$rootScope.$broadcast('animateTask', scope.taskToAnimateNumber);
						}
						$(this).off('hidden.bs.modal');
					});
				};

				var doSaveTaskRequest = function doSaveTaskRequest(task) {
					if (scope.tickTask) {
						saveCompletedTask(task);
					} else {
						saveTaskRequest(task);
					}
				};

				function saveTaskRequest(task) {
					workflowService.saveTask(task, scope.jobId, scope.taskList).finally(function () {
						return scope.button_disabled = false;
					}).subscribe(function (data) {
						return renewWorkflow(data, task.id);
					}, function (result) {
						return workflowService.errorSaveTask(result);
					}, function () {
						return scope.button_disabled = false;
					});
				}

				function saveCompletedTask(task) {
					scope.taskId = task.id;
					workflowService.saveTask(task, scope.jobId, scope.taskList).subscribe(function (data) {
						var tasks = data;
						var taskToComplete = angular.copy(data.tasks.find(function (task) {
							return task.id === scope.taskId;
						}));
						taskToComplete.jobId = scope.jobId;
						saveEditTask(taskToComplete).subscribe(function (dataTask) {
							renewWorkflow(tasks, dataTask.id);
						}, function (result) {
							scope.button_disabled = false;
							workflowService.errorSaveTask(result);
						}, function () {
							return scope.button_disabled = false;
						});
					}, function (error) {
						scope.button_disabled = false;
						var _error$error = error.error,
						    errorMessage = _error$error.errorMessage,
						    errorTitle = _error$error.errorTitle;


						switch (errorMessage) {
							case 'Email text should contain a questionnaire link':
								messageService.showToaster('e_0', 'questionnaires');
								break;
							case 'Email text should contain a contract link':
								messageService.showToaster('e_0', 'contract');
								break;
							default:
								messageService.showErrorFromBackend(errorTitle, errorMessage);
								break;
						}
					});
				}

				function saveEditTask(task) {
					return workflowDataService.saveTask(task).switchMap(function (data) {
						var taskToComplete = angular.copy(data.tasks.find(function (task) {
							return task.id === scope.taskId;
						}));
						taskToComplete.completed = true;
						taskToComplete.jobId = scope.jobId;
						return changeState(taskToComplete);
					});
				}

				function changeState(taskToComplete) {
					return newJobsDataService.changeTaskState(scope.jobId, taskToComplete);
				}

				var saveTaskWithAttachments = function saveTaskWithAttachments(task) {
					prepareEmailAttachments(task.taskEmail).then(function (result) {
						task.taskEmail = result;
						doSaveTaskRequest(task);
					}, function (error) {
						scope.button_disabled = false;
					});
				};

				scope.saveTask = function () {
					var task2Save = chooseObjectsToSave(scope.newAutomation);

					if (task2Save.taskEmail) {
						if (!emailService.isSubjectValid(task2Save.taskEmail.subject)) {
							return;
						}
					}

					if (task2Save.action === undefined) {
						scope.button_disabled = false;
					} else {
						scope.button_disabled = true;
					}
					var attachmentsData = task2Save.taskEmail.attachmentsData;


					var isAttachments = attachmentsData && attachmentsData.attachments.length;

					if (isAttachments) {
						saveTaskWithAttachments(task2Save);
					} else {
						delete task2Save.taskEmail.attachmentsData;
						delete task2Save.taskEmail.storedAttachments;
						doSaveTaskRequest(task2Save);
					}
				};

				scope.close = function () {
					scope.tickTask = false;
					scope.tickTaskType = '';
					isFirstShow = true;
					scope.emailInfo.isEmailShown = false;
					scope.showCcField = false;
					delete scope.sources;
					if (scope.isLeadPage) {
						$rootScope.updateLeadView();
					} else if (scope.isJobPage) {
						$rootScope.updateJobView();
					}
				};

				$(document).on('show.bs.modal', automationModal, function () {
					if (isFirstShow) {
						isFirstShow = false;
						scope.taskInfo = workflowService.getTaskInfo();
						scope.isForEdit = scope.taskInfo.isForEdit;
						scope.newAutomation = angular.copy(scope.taskInfo.task);
						scope.automatedActions = workflowService.getAutomatedActions();
						if (scope.isLeadPage || scope.isJobPage) {
							scope.sendMessage.emailTo = $rootScope.primaryContact.email ? [$rootScope.primaryContact.email] : [];
							scope.sendMessage.emailCc = [];
						}
						getDueOptions();
						prepareTemplates();

						var _prepareTaskToShow = prepareTaskToShow(scope.newAutomation),
						    _prepareTaskToShow$qu = _prepareTaskToShow.questionnaireEmail,
						    questionnaireEmail = _prepareTaskToShow$qu === undefined ? {} : _prepareTaskToShow$qu,
						    _prepareTaskToShow$co = _prepareTaskToShow.contractEmail,
						    contractEmail = _prepareTaskToShow$co === undefined ? {} : _prepareTaskToShow$co,
						    _prepareTaskToShow$pl = _prepareTaskToShow.plainEmail,
						    plainEmail = _prepareTaskToShow$pl === undefined ? {} : _prepareTaskToShow$pl,
						    _prepareTaskToShow$qu2 = _prepareTaskToShow.questionnaire,
						    questionnaire = _prepareTaskToShow$qu2 === undefined ? {} : _prepareTaskToShow$qu2,
						    _prepareTaskToShow$co2 = _prepareTaskToShow.contract,
						    contract = _prepareTaskToShow$co2 === undefined ? {} : _prepareTaskToShow$co2;

						scope.sources = {
							questionnaireEmail: questionnaireEmail,
							contractEmail: contractEmail,
							plainEmail: plainEmail,
							questionnaire: questionnaire,
							contract: contract
						};
						scope.$evalAsync();
					}
				}).on('shown.bs.modal', automationModal, function () {
					$(_this).find('input').first().focus();
					var input = $(_this).find('input');
					var select = $(_this).find('select');

					validationService.isModalClosePrevented(input);
					validationService.isModalClosePrevented(select);
				});
			}
		};
	}
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./web/js/components/Workflow/Modals/addContract.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function () {
	angular.module('main').directive('addContract', addContract);

	addContract.$inject = ['templateRequestsService', 'messageService', 'fileUploadService', 'emailService'];

	function addContract(templateRequestsService, messageService, fileUploadService, emailService) {
		return {
			restrict: 'E',
			scope: {
				chosenContract: '=',
				contracts: '=',
				email: '=',
				emailTemplates: '=',
				editContract: '&',
				fromSettings: '=',
				onChange: '&',
				tickTask: '='
			},
			template: '\n                      <div>\n                        <div class="field-info" ng-hide="tickTask">\n                            <h4>Choose contract template</h4>\n                            <div class="flex-row flex-wrap-xs">\n\n                                <div class="select-style flex-grow-1 flex-with-full">\n\n                                    <select ng-model="chosenContract" ng-disabled="button_disable" required\n                                            ng-change = "onChange()"\n                                            ng-options="contract as contract.name for contract in contracts | orderBy">\n                                        <option value="" class="hide">Choose an existing contract template</option>\n                                    </select>\n                                </div>\n\n                                <btn-edit ng-disabled="!chosenContract.name || chosenContract.signed" type="button" class="btn-edit-md hidden-xs"\n                                          ng-if="!fromSettings"\n                                          sn-text="Edit contract"\n                                          ng-click="editContract({contract:chosenContract})"></btn-edit>\n                                <btn-edit ng-disabled="!chosenContract.name || chosenContract.signed" type="button" class="btn-edit-sm visible-xs"\n                                          ng-if="!fromSettings"\n                                          sn-text="Edit contract"\n                                          ng-click="editContract({contract:chosenContract})"></btn-edit>\n\n                            </div>\n                        </div>\n\n                        <div class="field-info">\n                            <h4>Choose email template</h4>\n                            <div class="flex-row">\n                                <div class="select-style flex-grow-1">\n                                    <select ng-model="email"\n                                            ng-init="email = email || {}"\n                                            ng-disabled="button_disable"\n                                            ng-change="getEmailTemplate(email)"\n                                            ng-options="template as template.name for template in emailTemplates | orderBy track by template.name">\n                                    </select>\n                                </div>\n                            </div>\n                        </div>\n\n                      <div class="subject-row mt-20" ng-if="!fromSettings">\n                        <insert-variable class="insert-variable" [variable-list-type]="\'JOB_MENU_SUBJECT\'" (on-variable-choose)="addSubjectVariable($event, \'subject-send-contract-automation\')"></insert-variable>\n                            <div class="field-info">\n                                <h4>Subject</h4>\n                                <div class="flex-row">\n                                    <input id="subject-send-contract-automation" ng-disabled="button_disable" type="text" class="form-control"\n                                           placeholder="Your online contract is ready" maxlength="255"\n                                           ng-model="email.subject" required>\n                                </div>\n                            </div>\n                      </div>\n\n                            <div class="field-info" ng-if="!fromSettings">\n                                <h4>Message</h4>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<sn-quill-editor-web\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t[init-value]="email.text"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t[toolbar-settings]="\'variables attachments color size font\'"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t[files-obj]="email.attachmentsData"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t[vars-list]="\'JOB_MENU\'"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t[editor-i-d]="\'wf_contract_email\'"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t(on-text-change)="email.text = $event">\n                        \t\t\t\t</sn-quill-editor-web>\n                            </div>\n\n\n                        <hr ng-if="!tickTask" class="mt-30 mb-30">\n\n                    </div>\n                ',
			replace: true,
			transclude: true,
			link: function link(scope) {
				var emptyAttachmentsData = {
					attachments: [],
					filesSize: 0
				};

				function clearAttachments() {
					scope.email.attachmentsData = angular.copy(emptyAttachmentsData);
				}

				var isUserEmail = function isUserEmail(email) {
					return !email.hasOwnProperty('emailTemplateType') && !email.hasOwnProperty('defaultEmailTemplate');
				};

				scope.$watchCollection('email.attachmentsData', function (newValue, oldValue) {
					if (newValue && newValue !== oldValue && newValue.attachments.length && newValue.attachments.length !== 0 && scope.isUserEmail) {
						addUploadedAttachments(newValue);
					}
				});

				function addUploadedAttachments(attachmentsData) {
					var attachments = attachmentsData.attachments;


					scope.uploadedAttachments = [];
					angular.forEach(attachments, function (attachment) {
						if (!attachment.id) {
							scope.uploadedAttachments.push(attachment);
						} else if (attachment.hasOwnProperty('checked')) {
							var copiedAttachment = angular.copy(attachment);
							scope.uploadedAttachments.push(copiedAttachment);
						}
					});
				}

				var setEmailTemplate = function setEmailTemplate(data) {
					scope.email = angular.copy(data);
					if (data.storedAttachments.length) {
						scope.email.attachmentsData = {
							attachments: fileUploadService.convertAttachmentsToShow(data.storedAttachments)
						};
						scope.$evalAsync();
					} else {
						clearAttachments();
					}
				};

				var showErrorMessage = function showErrorMessage() {
					messageService.showToaster('e_0', 'general');
				};

				scope.addSubjectVariable = function ($event, id) {
					var el = document.getElementById(id);
					scope.email.subject = emailService.addSubjectVariable(el, $event);
				};

				scope.getEmailTemplate = function (email) {
					if (scope.fromSettings) {
						return;
					}

					if (email === null) {
						scope.email = {
							text: '',
							attachmentsData: angular.copy(emptyAttachmentsData)
						};
					} else if (email && (typeof email === 'undefined' ? 'undefined' : _typeof(email)) === 'object') {
						var _isUserEmailChosen = isUserEmail(email);
						scope.isUserEmail = isUserEmail(email);
						if (_isUserEmailChosen) {
							scope.email = email;

							if (email.storedAttachments && email.storedAttachments.length || scope.uploadedAttachments && scope.uploadedAttachments.length) {
								var storedAttachments = angular.copy(email.storedAttachments);
								var allAttachments = storedAttachments !== null ? angular.copy(email.storedAttachments) : [];

								if (scope.uploadedAttachments && scope.uploadedAttachments.length) {
									angular.forEach(scope.uploadedAttachments, function (attachment) {
										allAttachments.push(attachment);
									});
								}
								scope.email.attachmentsData = {
									attachments: allAttachments
								};
							} else {
								clearAttachments();
							}
						} else if (email.id) {
							templateRequestsService.getTemplates('full_template', email.id).subscribe(function (data) {
								return setEmailTemplate(data);
							}, function (error) {
								return showErrorMessage();
							});
						}
					} else {
						console.error('no chosen email');
					}
				};

				scope.disableDragDrop = function () {
					return true;
				};

				scope.uploadedAttachments = [];
				var email = scope.email;
				var isUserEmailChosen = isUserEmail(email);
				if (isUserEmailChosen) {
					scope.isUserEmail = true;
				} else if (email && (typeof email === 'undefined' ? 'undefined' : _typeof(email)) === 'object' && email.id) {
					scope.getEmailTemplate(scope.email);
				} else {
					console.error('no scope.email.id');
				}
			}
		};
	}
})();

/***/ }),

/***/ "./web/js/components/Workflow/Modals/addExtraShootModal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _operators = __webpack_require__("./node_modules/rxjs/operators.js");

(function () {
	angular.module('main').directive('addExtraShootModal', addExtraShootModal);

	addExtraShootModal.$inject = ['$rootScope', '$location', 'calendarEventsDataService', 'extraShootService', 'messageService', 'searchService', 'timeService', 'workflowService', 'validationService', 'settingsService', 'timeConverter', 'utilsService', 'doubleBookingService'];

	function addExtraShootModal($rootScope, $location, calendarEventsDataService, extraShootService, messageService, searchService, timeService, workflowService, validationService, settingsService, timeConverter, utilsService, doubleBookingService) {
		return {
			restrict: 'E',
			scope: {
				activeJobs: '<',
				jobId: '<',
				taskList: '=',
				updateView: '&',
				mainShootLabelName: '=',
				extraShootLabelName: '='
			},
			template: '<section>\n                        <div id="extraShootModal" class="modal modal-center fade" data-backdrop="static" \n                             data-keyboard="false" data-autotest-modal="extraShoot">\n                            <div class="modal-dialog modal-dialog-datepicker">\n                                <form ng-submit="saveExtraShoot()">\n                                    <div class="modal-content">\n                                        <div class="modal-header">\n                                            <btn-close></btn-close>\n                                            <h3 class="modal-title">{{extraShoot.id ? \'Edit\':\'Add\'}} {{extraShootLabelName | lowercase}}</h3>\n                                        </div>\n                                        <div class="modal-body" style="padding-bottom: 7px!important">\n                                            <h3 class="mt-0 mb-25">{{extraShootLabelName}} details</h3>\n                                            <div class="flex-row flex-wrap-xs">\n                                                <div class="form-group  w-min-100 flex-basis-full-xs">\n                                                    <label class="control-label">Name</label>\n                                                </div>\n                                                <div class="form-group w-max-415 flex-with-full">\n                                                    <input type="text" autocomplete="off" class="form-control" name="extraShootName" maxlength="255" ng-model="extraShoot.name"\n                                                           required>\n                                                </div>\n                                            </div>\n                    \n                                            <hr class="mt-15">\n                                            \n                                            <h3 class="mt-30 mb-25">{{extraShootLabelName}} schedule</h3>\n                    \n                                            <div class="form-group">\n                                                 <div class="flex-row flex-wrap-xs">\n                                                    <div class="w-min-100 flex-basis-full-xs">\n                                                        <label class="control-label">Date</label>\n                                                    </div>\n                    \n                                                    <div class="flex-row flex-wrap-xs flex-with-full w-max-415">\n                                                        <div class="flex-with-full flex-1 mb-15 box-no-transition-small datepicker-static under-input"  ng-class="{\'overlap-warning\': !!doubleBookingData}">\n                        \n                                                        <input ng-model="extraShoot.startDate" class="form-control"\n                                                               type="date" name="input" \n                                                               data-placeholder="{{datapickerDateFormat}}" \n                                                               min="2001-12-31"  max="2999-12-31"\n                                                               data-date=\'{"startView": 2, "openOnMouseFocus": true}\' required/>\n                                                        </div>\n                        \n                                                        <div class="flex-basis-xs flex-align-self-center ms-10 mb-15">to</div>\n                        \n                                                        <div class="flex-with-full flex-1 mb-15 box-no-transition-small datepicker-static under-input"  ng-class="{\'overlap-warning\': !!doubleBookingData}">\n                                                            <input ng-model="extraShoot.endDate" class="form-control w-150 flex-with-full"\n                                                                   type="date" name="input" \n                                                                   data-placeholder="{{datapickerDateFormat}}" \n                                                                   min="{{( extraShoot.startDate ) ? ( extraShoot.startDate | date : \'yyyy-MM-dd\') : (now | date : \'yyyy-MM-dd\') }}"\n                                                                   max="2999-12-31"\n                                                                   data-date=\'{"startView": 2, "openOnMouseFocus": true}\' required/>\n                                                        </div>\n                                                                 \n                                                    </div>\n                    \n                                                    <div class="mb-15 pt-6 flex-row flex-basis-full-xs" style="padding-left: 20px !important;">\n                                                        <div class="checkbox-squared">\n                                                            <input type="checkbox" id="checkbox-squared-all-day-shoot"\n                                                                   ng-model="extraShoot.allday"/>\n                                                            <label for="checkbox-squared-all-day-shoot"></label>\n                                                        </div>\n                                                        <label for="checkbox-squared-all-day-shoot">All day</label>\n                                                    </div>\n                                                </div>\n                                                \n                                                <div class="flex-row flex-wrap-xs">\n                                                    <div class="w-min-100 flex-basis-full-xs">\n                                                        <label class="control-label">Time</label>\n                                                    </div>\n                                                    <div class="job-date flex-with-full w-max-415">\n                                                        <div class="flex-row flex-wrap-xs flex-basis-full-xs">\n                                                            <div class="flex-1 mb-15 flex-with-full"  ng-class="{\'overlap-warning\': !!doubleBookingData}">\n                                                                <sn-timepicker sn-dr-model="extraShoot.startTime"\n                                                                               sn-dr-checked="extraShoot.allday"></sn-timepicker>\n                                                            </div>\n                                                            <div class="flex-basis-xs flex-align-self-center ms-10 mb-15">to</div>\n                                                            <div class="flex-1 mb-15 w-150 flex-with-full"  ng-class="{\'overlap-warning\': !!doubleBookingData}">\n                                                                <sn-timepicker sn-dr-model="extraShoot.endTime"\n                                                                               sn-dr-checked="extraShoot.allday"></sn-timepicker>\n                                                            </div>\n                                                        </div>\n                                                    </div>\n                                                </div>\n                    \n                                                <div class="flex-row flex-wrap-xs">\n                                                    <div class="w-min-100 flex-basis-full-xs">\n                                                        <label class="control-label">Location</label>\n                                                    </div>\n                                                    <input type="text" class="hide hidden form-control"\n                                                           ng-model="extraShoot.location"/>\n                                                    <div class="mb-15 w-max-415 flex-with-full box-no-transition-small"\n                                                         ng-controller="GoogleAutocompleteController">\n                                                        <input type="text" id="Autocomplete2" ng-model="autocomplete" placeholder=""\n                                                               class="form-control" ng-autocomplete options="options" details="details"/>\n                                                    </div>\n                                                </div>\n                                                \n                                                <div class="row" ng-show="searchingEvents">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="col-sm-12">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="db-event-loading mt-10 mb-10">Loading...</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="row" ng-show="!searchingEvents && doubleBookingData">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="col-sm-12 mt-10 mb-25">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<events-overlapping-info [data]="doubleBookingData"></events-overlapping-info>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</div> \n\t\t\t\t\t\t\t\t\t\t\t\t\n                                            </div>\n                                            <section ng-hide="isJobView || isLeadView" class="pb-30">\n                                                 \n                                                <hr class="mb-30">\n                                                <h4 class="f-normal">Add this {{extraShootLabelName | lowercase}} to the workflow of an active lead/job</h4>\n                        \n                                                <div class="flex-row grey-group-field mb-0 mt-30 text-xs-center text-sm-left" style="padding:23px">\n                                                <div class="mr-15">\n                                                    <h4 class="f-normal">Choose active lead/job</h4>\n                                                </div>\n                                                <div class="flex-1 appointment-modal-input">\n                                                    <input placeholder="Start entering job name"\n                                                    class="form-control"\n                                                    type="text"\n                                                    autocomplete="off"\n                                                    typeahead="idName as idName.name for idName in jobNames | filter:$viewValue"\n                                                    typeahead-on-select="enableViewButton($item)"\n                                                    typeahead-select-on-exact="true"\n                                                    ng-model="extraShoot.jobSearch">\n                                                </div>\n                                                \n                                                <a  ng-disabled="viewButtonDisabled"\n                                                \tclass="btn btn-default ml-10"\n                                                    target="_blank"\n                                                    ng-href="{{viewLeadJobLink}}">\n                                                    \t<i class="fi fi-view"></i>View\n                                                </a>\n                                                \n                                                </div>\n                                            </section>\n                                          \n                                        </div>\n                                        <div class="modal-footer modal-foot">\n                                           <button ng-disabled="button_disable" class="btn btn-success btn-lg" type="submit"\n                                                        spinning-wheel is-spinning-wheel-active="button_disable"\n                                                 >Save {{extraShootLabelName | lowercase}}</button>\n                                            <button ng-disabled="button_disable" class="btn btn-lg btn-delete" \n                                                   ng-hide="!extraShoot.id || isJobView || isLeadView" ng-click="showDeleteExtraShoot(extraShoot, $event)" type="button">Delete\n                                            </button>\n                                            \n                                        </div>\n                                    </div>\n                                </form>\n                            </div>\n                        </div>\n                        \n                        <delete-extrashoot-modal\n                         \tdelete="deleteExtrashoot(deleteId)"\n                         \tmain-shoot-label-name="mainShootLabelName"\n                    \t \textra-shoot-label-name="extraShootLabelName">\n                         </delete-extrashoot-modal>\n                    </section>\n             ',
			replace: true,
			transclude: true,
			link: function link(scope) {
				scope.isJobView = $location.path().includes('/jobs/view/');
				scope.isLeadView = $location.path().includes('/leads/view/');
				scope.job = {};
				var TIME = '12:00 PM';
				var jobSearchTimer = void 0;
				var input = $('input');
				$(document).on('show.bs.modal', '#extraShootModal', function () {
					scope.viewButtonDisabled = true;
					scope.viewLeadJobLink = null;
					scope.taskToAnimateNumber = null;
					scope.taskInfo = workflowService.getTaskInfo();
					if (scope.taskInfo && scope.taskInfo.task && scope.taskInfo.task.jobSearch && scope.taskInfo.task.jobSearch.id && scope.taskInfo.task.jobSearch.name) {
						scope.viewButtonDisabled = false;
						createLeadJobLink(scope.taskInfo.task.jobSearch);
					}
					settingsService.timeFormatSettings.subscribe(function (data) {
						if (data.timeFormat !== null) {
							scope.timeFormatIs12HorsFormat = data.timeFormat === 'T_12';
						}
					});
					$('#extraShootModal').find('input.ws-date').prop('autocomplete', 'off');

					settingsService.timeFormatSettings.subscribe(function (data) {
						scope.dataFormatMonth = data.dateFormat;
					});

					scope.datapickerDateFormat = scope.dataFormatMonth === 'DD_MM_YYYY' ? 'dd/mm/yyyy' : 'mm/dd/yyyy';

					scope.extraShoot = angular.copy(scope.taskInfo.task);
					scope.job.location = angular.copy(scope.extraShoot.location);

					if (scope.extraShoot.startDate) {
						convertDateTime();
					} else {
						scope.extraShoot.startTime = null;
					}
					scope.searchingEvents = false;
					scope.now = new Date();
					scope.now.setHours(0, 0, 0, 0);
					scope.jobNames = [];
					scope.doubleBookingData = null;
					scope.$evalAsync();
				}).on('shown.bs.modal', '#extraShootModal', function () {
					$(this).find('input').first().focus();

					validationService.isModalClosePrevented(input);
				}).on('hide.bs.modal', '#extraShootModal', function () {
					scope.extraShoot.startTime = undefined;
				});

				scope.$watch('extraShoot.startDate', checkExtraShootDate);
				scope.$watch('extraShoot.startTime', checkExtraShootTime);
				scope.$watch('extraShoot.endDate', reactToDateTimeChange);
				scope.$watch('extraShoot.endTime', reactToDateTimeChange);
				scope.$watch('extraShoot.allday', setTimeAfterAllDay);

				scope.$watch('extraShoot.location', setLocation);

				// delete extraShoot

				scope.showDeleteExtraShoot = function (extraShoot, event) {
					scope.deleteId = extraShoot.id;
					scope.deleteExtraShootName = extraShoot.name;
					utilsService.showNextModal('#extraShootModal', '#deleteExtrashootModal', event);
				};

				scope.deleteExtrashoot = function (id) {
					$('#deleteExtrashootModal').modal('hide');

					scope.button_disable = true;

					calendarEventsDataService.deleteEvent(id).finally(function () {
						return scope.button_disable = false;
					}).subscribe(function (data) {
						return successDeleteExtrashoot(data);
					}, function (error) {
						return messageService.showDefaultErrorMessage(error);
					});
				};

				function successDeleteExtrashoot(data) {
					if (data && data.errorMessage) {
						messageService.showToaster('e_2', 'general', data.errorMessage);
					} else {
						$('#extraShootModal').modal('hide');

						scope.updateView({ resetPagination: true });
						messageService.showToaster('s_0', 'extrashoot', scope.extraShootLabelName + ' ' + scope.deleteExtraShootName);
					}
				}

				function setTimeAfterAllDay(newValue, oldValue) {
					if (!newValue && oldValue && !scope.timeFormatIs12HorsFormat) {
						scope.extraShoot.startTime = timeConverter.convert12to24(TIME);
					} else if (!newValue && oldValue && scope.timeFormatIs12HorsFormat) {
						scope.extraShoot.startTime = TIME;
					} else if (newValue && !oldValue) {
						scope.extraShoot.startTime = null;
						scope.extraShoot.endTime = null;
					}
					reactToDateTimeChange(newValue, oldValue);
				}

				function checkExtraShootTime(newValue, oldValue) {
					if (!newValue) {
						scope.doubleBookingData = null;
					}
					if (scope.extraShoot && typeof oldValue !== 'undefined' && newValue && newValue !== oldValue) {
						scope.extraShoot.endTime = timeService.setEndTime(newValue);
						reactToDateTimeChange(newValue, oldValue);
					}
				}

				function checkExtraShootDate(startDate) {
					if (!startDate) {
						scope.doubleBookingData = null;
					}
					if (scope.extraShoot && startDate) {
						if (!scope.extraShoot.endDate || startDate > scope.extraShoot.endDate) {
							scope.extraShoot.endDate = startDate;
						}
						checkForOverlappingEvents();
					}
				}

				function setLocation(currentLocation) {
					scope.job.location = currentLocation;
				}

				function convertDateTime() {
					scope.extraShoot = timeService.convertDateTimeForPicker(scope.extraShoot, 'startDate', 'endDate', 'startTime', 'endTime');
				}

				scope.enableViewButton = function (event) {
					scope.viewLeadId = createLeadJobLink(event);
					scope.viewButtonDisabled = false;
				};

				// job search

				scope.$watch('extraShoot.jobSearch', function (newValue, oldValue) {
					if (newValue == null) {
						return;
					}
					if (oldValue == newValue) {
						return;
					}
					if (newValue.length > 0) {
						if (jobSearchTimer != null) {
							clearTimeout(jobSearchTimer);
						}
						jobSearchTimer = setTimeout(findAllMatchingJobsNames(newValue), 500);
					} else {
						clearTimeout(jobSearchTimer);
					}
				});

				function findAllMatchingJobsNames(search) {
					if (scope.activeJobs && scope.activeJobs.length) {
						scope.jobNames = searchService.findMatchingNames(scope.activeJobs, search);
					}
				}

				function createLeadJobLink(data) {
					if (data.leadId) {
						scope.viewLeadJobLink = '/leads/view/' + data.leadId;
					} else if (data.id) {
						scope.viewLeadJobLink = '/jobs/view/' + data.id;
					}
				}

				// save extraShoot

				scope.saveExtraShoot = function () {
					var dataToSave = angular.copy(scope.extraShoot);

					scope.button_disable = true;
					if (scope.isJobView === false) {
						scope.isJobView = scope.isLeadView;
					}
					dataToSave = extraShootService.prepareExtraShootToSave(dataToSave, scope.isJobView, scope.job.location, scope.extraShootLabelName);

					if (!dataToSave) {
						scope.button_disable = false;
						return false;
					}
					if (scope.isJobView || scope.isLeadView) {
						saveExtraShootAsJobTask(dataToSave);
					} else {
						saveExtraShootAsCalendarEvent(dataToSave);
					}
				};

				function saveExtraShootAsCalendarEvent(dataToSave) {
					var action = dataToSave.id ? calendarEventsDataService.updateEvent(dataToSave) : calendarEventsDataService.createEvent(dataToSave);

					action.finally(function () {
						return scope.button_disable = false;
					}).subscribe(function (data) {
						return successSaveExtraShoot(data, scope.extraShoot.id, scope.extraShoot.jobId);
					}, function (error) {
						return messageService.showDefaultErrorMessage(error);
					});
				}

				function saveExtraShootAsJobTask(dataToSave) {
					if (scope.isJobView) {
						workflowService.saveTask(dataToSave, scope.jobId, scope.taskList).finally(function () {
							return scope.button_disable = false;
						}).subscribe(function (result) {
							return successSaveExtraShootAsTask(result, scope.extraShoot.id);
						}, function (error) {
							return messageService.showDefaultErrorMessage(error);
						});
					} else {
						workflowService.saveTask(dataToSave, dataToSave.leadId, scope.taskList).finally(function () {
							return scope.button_disable = false;
						}).subscribe(function (result) {
							return successSaveExtraShootAsTask(result, scope.extraShoot.id);
						}, function (error) {
							return messageService.showDefaultErrorMessage(error);
						});
					}
				}

				function successSaveExtraShootAsTask(data, id) {
					if (!data || !data.tasks) {
						return;
					}

					scope.updateView({ tasks: data.tasks });

					for (var i = 0; i < data.tasks.length; i++) {
						if (data && data.taskMetadata && data.taskMetadata.taskId === data.tasks[i].id) {
							scope.taskToAnimateNumber = '.task-' + i;
						}
					}

					var isEdited = id !== null && id !== undefined;

					isEdited ? messageService.showToaster('s_4', 'workflow') : messageService.showToaster('s_3', 'workflow');

					$('#extraShootModal').modal('hide').on('hidden.bs.modal', function () {
						if (!isEdited) {
							$rootScope.$broadcast('animateTask', scope.taskToAnimateNumber);
						}
						$(this).off('hidden.bs.modal');
					});
				}

				function successSaveExtraShoot(data, extraShootId, oldJobId) {
					scope.button_disable = false;
					scope.isUpdateSpinnningWheelActive = false;

					$('#extraShootModal').modal('hide');

					var messageCode = extraShootId ? 's_2' : 's_1';
					messageService.showToaster(messageCode, 'extrashoot', scope.extraShootLabelName);

					var jobId = data.jobId,
					    taskId = data.taskId,
					    inLead = data.inLead,
					    leadId = data.leadId;

					if (window.location.pathname !== '/calendar') {
						if (jobId && taskId) {
							redirectToJobLead('job', jobId, taskId);
						}
						if (leadId && taskId) {
							redirectToJobLead('lead', leadId, taskId);
						}
					}
					// if (
					// 	(taskId && !extraShootId) ||
					// 	(extraShootId && jobId !== oldJobId)
					// ) {
					// 	$location.search('task', taskId).replace();
					// }
					scope.updateView({ resetPagination: false });
				}
				function redirectToJobLead(pageName, id, taskId) {
					$location.path(pageName + 's/view/' + id).search('task', taskId);
				}

				function reactToDateTimeChange(newValue, oldValue) {
					if (!newValue) {
						scope.doubleBookingData = null;
					}
					if (scope.extraShoot && newValue && newValue !== oldValue || newValue === false) {
						checkForOverlappingEvents();
					}
				}

				function checkForOverlappingEvents() {
					var hasDate = scope.extraShoot.startDate && scope.extraShoot.endDate;
					var hasTimeOrAllDay = scope.extraShoot.allday || scope.extraShoot.startTime && scope.extraShoot.endTime && !scope.extraShoot.allday;

					if (hasDate && hasTimeOrAllDay) {
						scope.timeData = {
							startTime: scope.extraShoot.startTime,
							startDate: scope.extraShoot.startDate,
							finishTime: scope.extraShoot.endTime,
							finishDate: scope.extraShoot.endDate,
							allday: scope.extraShoot.allday
						};
						scope.button_disable = true;
						scope.searchingEvents = true;
						var id = scope.extraShoot.calendarEvent ? scope.extraShoot.calendarEvent.id : scope.extraShoot.id;

						doubleBookingService.getOverlappingEvents(doubleBookingService.gatherDateTimeData(scope.timeData), 'EVENT', id).pipe((0, _operators.finalize)(function () {
							scope.searchingEvents = false;
							scope.button_disable = false;
						})).subscribe(function (data) {
							return scope.doubleBookingData = data;
						});
					}
				}
			}
		};
	}
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./web/js/components/Workflow/Modals/addExtraShootWithoutScheduleModal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

(function () {
	angular.module('main').directive('addExtraShootWithoutScheduleModal', addExtraShootWithoutScheduleModal);

	addExtraShootWithoutScheduleModal.$inject = ['workflowService', 'messageService', 'validationService'];

	function addExtraShootWithoutScheduleModal(workflowService, messageService, validationService) {
		return {
			restrict: 'E',
			scope: {
				extraShoot: '<',
				taskList: '=',
				mainShootLabelName: '=',
				extraShootLabelName: '='
			},
			template: '<section>\n                        <div id="extraShootWithoutScheduleModal" class="modal modal-center fade modal-appointment-lx" data-backdrop="static"\n                             data-keyboard="false">\n                            <div class="modal-dialog modal-dialog-datepicker">\n                                <form ng-submit="saveExtraShoot(extraShoot, taskList, extraShoot.id)">\n                                    <div class="modal-content">\n                                        <div class="modal-header">\n                                            <btn-close></btn-close>\n                                            <h3 class="modal-title">{{extraShoot.id ? \'Edit\':\'Add\'}} {{extraShootLabelName | lowercase}}</h3>\n                                        </div>\n                                        <div class="modal-body f-s-14-i" style="padding-bottom: 15px !important">\n                                            <h3 class="mt-0 mb-25">{{extraShootLabelName}} details</h3>\n                                            <div class="flex-row flex-wrap-xs flex-align-center mb-30">\n                                                <div class="pr-30">\n                                                    <p>Name</p>\n                                                </div>\n                                                <div class="flex-grow-1 flex-with-full mb-10">\n                                                    <input type="text" autocomplete="off" class="form-control" name="extraShootName" maxlength="255" ng-model="extraShoot.name"\n                                                           required>\n                                                </div>\n                                            </div>\n                                            <div class="flex-row">\n                                                <p>\n                                                    Update {{extraShootLabelName | lowercase}} schedule, including date range, time range and location, from within your job profile, once you have applied this workflow to a job.\n                                                </p>\n                                            </div>\n                                        </div>\n                                        <div class="modal-footer modal-foot">\n                                            <button ng-disabled="button_disable" class="btn btn-success btn-lg" type="submit"\n                                                    spinning-wheel is-spinning-wheel-active="isUpdateSpinnningWheelActive">Save {{extraShootLabelName | lowercase}}\n                                            </button>\n                                        </div>\n                                    </div>\n                                </form>\n                            </div>\n                        </div>\n                    </section>\n             ',
			replace: true,
			transclude: true,
			link: function link(scope) {
				var extraShootModal = '#extraShootWithoutScheduleModal';

				$(document).on('show.bs.modal', extraShootModal, function () {
					scope.taskInfo = workflowService.getTaskInfo();
					scope.isForEdit = scope.taskInfo.isForEdit;
					scope.extraShoot = angular.copy(scope.taskInfo.task);
					scope.$evalAsync();
				}).on('shown.bs.modal', extraShootModal, function () {
					$(this).find('input').first().focus();
					var input = $(this).find('input');

					validationService.isModalClosePrevented(input);
				});

				scope.saveExtraShoot = function (extraShoot, taskTypes, id) {
					scope.button_disable = true;

					var isEdited = id !== null && id !== undefined;

					if (!workflowService.isTaskValid(extraShoot)) {
						scope.button_disabled = false;
						return;
					}

					if (!extraShoot.eventType) {
						extraShoot.eventType = 'EXTRA_SHOOT';
					}

					scope.taskList = workflowService.pasteNewTaskInList(taskTypes, extraShoot); // modifies workflow list
					scope.taskList = workflowService.renewTaskViewDue(scope.taskList);

					isEdited ? messageService.showToaster('s_4', 'workflow') : messageService.showToaster('s_3', 'workflow');

					scope.button_disable = false;

					$(extraShootModal).modal('hide');
				};
			}
		};
	}
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./web/js/components/Workflow/Modals/addMail.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function () {
	angular.module('main').directive('addMail', addMail);

	addMail.$inject = ['templateRequestsService', 'messageService', 'fileUploadService', 'emailService'];

	function addMail(templateRequestsService, messageService, fileUploadService, emailService) {
		return {
			restrict: 'E',
			scope: {
				email: '=',
				emailInfo: '<',
				emailTemplates: '<'
			},
			template: ' <div>\n                            <div class="field-info">\n                                <h4>Choose email template</h4>\n\n                                <div class="flex-row flex-just-space flex-wrap-md">\n                                    <div class="flex-basis-full">\n                                        <div class="select-style">\n                                            <select ng-model="email"\n                                                    ng-change="getEmailTemplate(email)"\n                                                    ng-disabled = "!emailTemplates.length || emailTemplates.length === 1"\n                                                    ng-options="template as template.name for template in emailTemplates | orderBy track by template.name">\n                                            </select>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n\n                            <div class="subject-row mt-20">\n\t\t\t\t\t\t\t\t<insert-variable class="insert-variable" [variable-list-type]="\'JOB_MENU_SUBJECT\'" (on-variable-choose)="addSubjectVariable($event, \'subject-send-mail-automation\')"></insert-variable>\n\t\t\t\t\t\t\t\t\t<div class="field-info">\n\t\t\t\t\t\t\t\t\t\t<h4>Subject</h4>\n\t\t\t\t\t\t\t\t\t\t<div class="flex-row">\n\t\t\t\t\t\t\t\t\t\t\t<input id="subject-send-mail-automation" ng-disabled="button_disable" type="text" autocomplete="off" class="form-control" required\n\t\t\t\t\t\t\t\t\t\t\t\t   placeholder="Write an awesome subject line. Why not?" maxlength="255"\n\t\t\t\t\t\t\t\t\t\t\t\t   ng-model="email.subject">\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n                            </div>\n\n                            <div class="field-info">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<h4>Message</h4>\n                            \t<sn-quill-editor-web\n                                [init-value]="email.text"\n                                [toolbar-settings]="\'variables attachments color size font\'"\n                                [files-obj]="email.attachmentsData"\n                                [vars-list]="\'JOB_MENU\'"\n                                [editor-i-d]="\'wf_plain_email_or_template\'"\n                                (on-text-change)="email.text = $event">\n                        \t\t\t</sn-quill-editor-web>\n\n                            <hr class="mt-30 mb-30">\n\n                        </div>\n                ',
			replace: true,
			link: function link(scope) {
				var emptyAttachmentsData = {
					attachments: [],
					filesSize: 0
				};

				function clearAttachments() {
					if (scope.email) {
						scope.email.attachmentsData = angular.copy(emptyAttachmentsData);
					}
				}

				var isUserEmail = function isUserEmail(email) {
					return !email.hasOwnProperty('emailTemplateType') && !email.hasOwnProperty('defaultEmailTemplate');
				};

				function setEmailTemplate(data) {
					scope.email = angular.copy(data);
					if (data && data.storedAttachments && data.storedAttachments.length) {
						scope.email.attachmentsData = {
							attachments: fileUploadService.convertAttachmentsToShow(data.storedAttachments)
						};
						scope.$evalAsync();
					} else {
						clearAttachments();
					}
				}

				scope.addSubjectVariable = function ($event, id) {
					var el = document.getElementById(id);
					scope.email.subject = emailService.addSubjectVariable(el, $event);
				};

				scope.$watchCollection('email.attachmentsData', function (newValue, oldValue) {
					if (newValue && newValue !== oldValue && newValue.attachments.length && newValue.attachments.length !== 0 && scope.isUserEmail) {
						addUploadedAttachments(newValue);
					}
				});

				function addUploadedAttachments(attachmentsData) {
					var attachments = attachmentsData.attachments;


					scope.uploadedAttachments = [];
					angular.forEach(attachments, function (attachment) {
						if (!attachment.id) {
							scope.uploadedAttachments.push(attachment);
						} else if (attachment.hasOwnProperty('checked')) {
							var copiedAttachment = angular.copy(attachment);
							scope.uploadedAttachments.push(copiedAttachment);
						}
					});
				}

				var showErrorMessage = function showErrorMessage() {
					messageService.showToaster('e_0', 'general');
				};

				scope.addNewTemplate = function () {
					scope.email = {
						name: '',
						text: '',
						attachmentsData: angular.copy(emptyAttachmentsData)
					};
					scope.emailInfo.isEmailShown = true;
				};

				scope.getEmailTemplate = function (email) {
					if (email === null || email === undefined) {
						scope.email = {
							text: '',
							attachmentsData: angular.copy(emptyAttachmentsData)
						};
					} else if (email && (typeof email === 'undefined' ? 'undefined' : _typeof(email)) === 'object') {
						var _isUserEmailChosen = isUserEmail(email);
						scope.isUserEmail = isUserEmail(email);

						if (_isUserEmailChosen) {
							scope.email = email;
							if (email.storedAttachments && email.storedAttachments.length || scope.uploadedAttachments && scope.uploadedAttachments.length) {
								var storedAttachments = angular.copy(email.storedAttachments);
								var allAttachments = storedAttachments !== null ? angular.copy(email.storedAttachments) : [];

								if (scope.uploadedAttachments && scope.uploadedAttachments.length) {
									angular.forEach(scope.uploadedAttachments, function (attachment) {
										allAttachments.push(attachment);
									});
								}
								scope.email.attachmentsData = {
									attachments: allAttachments
								};
							} else {
								clearAttachments();
							}
						} else if (email.id) {
							templateRequestsService.getTemplates('full_template', email.id).subscribe(function (data) {
								return setEmailTemplate(data);
							}, function (error) {
								return showErrorMessage();
							});
						}
					} else {
						console.error('no chosen email');
					}
				};

				scope.disableDragDrop = function () {
					return true;
				};

				scope.uploadedAttachments = [];
				var email = scope.email;
				var isUserEmailChosen = isUserEmail(email);
				if (isUserEmailChosen) {
					scope.isUserEmail = true;
				} else if (email && (typeof email === 'undefined' ? 'undefined' : _typeof(email)) === 'object' && email.id) {
					scope.getEmailTemplate(scope.email);
				} else {
					console.error('no scope.email.id');
				}
			}
		};
	}
})();

/***/ }),

/***/ "./web/js/components/Workflow/Modals/addMailOrTemplate.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function () {
	angular.module('main').directive('addMailOrTemplate', addMailOrTemplate);

	addMailOrTemplate.$inject = ['templateRequestsService', 'messageService', 'validationService', 'emailService'];

	function addMailOrTemplate(templateRequestsService, messageService, validationService, emailService) {
		return {
			restrict: 'E',
			scope: {
				emailToSave: '=',
				emailInfo: '<',
				emailTemplates: '<'
			},
			template: ' <div>\n                            <div class="field-info">\n                                <h4>Choose email template</h4>\n\n                                <div class="flex-row flex-just-space flex-wrap-md">\n                                    <div class="flex-basis-55-md  flex-basis-full-sm">\n                                        <div class="select-style">\n                                            <select ng-model="selectedEmail"\n                                                    ng-required="!emailInfo.isEmailShown"\n                                                    ng-change="getEmailTemplate(selectedEmail)"\n                                                    ng-disabled = "!emailTemplates.length"\n                                                    ng-options="template.name for template in emailTemplates | orderBy track by template.name">\n                                                    <option value="">Choose an existing email template</option>\n                                            </select>\n                                        </div>\n                                    </div>\n                                    <div class="flex-row just-center-sm flex-basis-full-sm">\n                                        <h4>OR</h4>\n                                        </div>\n                                        <div class="flex-row just-center-sm flex-basis-full-sm">\n                                             <button type="button" ng-disabled="button_disable"\n                                                        ng-click="addNewTemplate()"\n                                                        class="btn btn-info btn-add-new-sm mb-0">Add new email template\n                                            </button>\n                                        </div>\n                                    </div>\n                                </div>\n\n                            <div class="field-info" ng-if="emailInfo.isEmailShown">\n                                <h4>Name</h4>\n                                <div class="flex-row">\n                                    <input ng-disabled="button_disable" type="text" class="form-control" required\n                                           placeholder="Give this email template a name" autocomplete="off"\n                                           ng-model="newEmailTemplate.name">\n                                </div>\n                            </div>\n\n                        \t<div class="subject-row mt-20" ng-if="emailInfo.isEmailShown">\n\t\t\t\t\t\t\t\t<insert-variable class="insert-variable" [variable-list-type]="\'JOB_MENU_SUBJECT\'" (on-variable-choose)="addSubjectVariable($event, \'subject-add-template-automation\')"></insert-variable>\n\t\t\t\t\t\t\t\t<div class="field-info">\n\t\t\t\t\t\t\t\t\t<h4>Subject</h4>\n\t\t\t\t\t\t\t\t\t<div class="flex-row">\n\t\t\t\t\t\t\t\t\t\t<input id="subject-add-template-automation" ng-disabled="button_disable" type="text" class="form-control" required\n\t\t\t\t\t\t\t\t\t\t\t   placeholder="Write an awesome subject line. Why not?" autocomplete="off" maxlength="255"\n\t\t\t\t\t\t\t\t\t\t\t   ng-model="newEmailTemplate.subject">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n                            </div>\n\n                            <div class="field-info" ng-if="emailInfo.isEmailShown">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<h4>Message</h4>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<sn-quill-editor-web\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t[init-value]="newEmailTemplate.text"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t[toolbar-settings]="\'variables attachments color size font\'"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t[files-obj]="newEmailTemplate.attachmentsData"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t[vars-list]="\'JOB_MENU\'"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t[editor-i-d]="\'wf_plain_email\'"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t(on-text-change)="newEmailTemplate.text = $event">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</sn-quill-editor-web>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\n                            <hr class="mt-30 mb-30">\n\n                        </div>\n\n                ',
			replace: true,
			link: function link(scope) {
				var _this = this;

				if (typeof scope.emailToSave !== 'undefined') {
					scope.selectedEmail = angular.copy(scope.emailToSave);
					console.log('template here');
				}

				// TODO: move all logic from scope bindings and broadcasts to service
				scope.$on('emailTemplateUpdated', function (event, email) {
					console.log('update');
					scope.selectedEmail = email.id ? angular.copy(email) : null;
					scope.emailToSave = angular.copy(email);
				});

				var emptyAttachmentsData = {
					attachments: [],
					filesSize: 0
				};

				var isUserEmail = function isUserEmail(email) {
					return !email.hasOwnProperty('emailTemplateType') && !email.hasOwnProperty('defaultEmailTemplate');
				};

				function setEmailTemplate(data) {
					scope.selectedEmail = angular.copy(data);
					scope.emailToSave = angular.copy(scope.selectedEmail);
				}

				var showErrorMessage = function showErrorMessage() {
					messageService.showToaster('e_0', 'general');
				};

				scope.addNewTemplate = function () {
					scope.newEmailTemplate = {
						name: '',
						text: '',
						attachmentsData: angular.copy(emptyAttachmentsData)
					};
					scope.selectedEmail = null;
					scope.emailToSave = scope.newEmailTemplate;
					scope.emailInfo.isEmailShown = true;

					$('#addAutomationModal').on('shown.bs.modal', function () {
						var input = $(_this).find('input');

						validationService.isModalClosePrevented(input);
					});
				};

				scope.addSubjectVariable = function ($event, id) {
					var el = document.getElementById(id);
					scope.newEmailTemplate.subject = emailService.addSubjectVariable(el, $event);
				};

				scope.getEmailTemplate = function (email) {
					scope.emailInfo.isEmailShown = false;

					if (email === null || email === undefined) {
						scope.selectedEmail = null;
						scope.emailToSave = null;
					} else if (email && (typeof email === 'undefined' ? 'undefined' : _typeof(email)) === 'object') {
						var isUserEmailChosen = isUserEmail(email);
						if (isUserEmailChosen) {
							scope.selectedEmail = email;
							scope.emailToSave = email;
						} else if (email.id) {
							templateRequestsService.getTemplates('full_template', email.id).subscribe(function (data) {
								return setEmailTemplate(data);
							}, function (error) {
								return showErrorMessage();
							});
						}
					} else {
						console.error('no chosen email');
					}
				};

				scope.disableDragDrop = function () {
					return true;
				};
			}
		};
	}
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./web/js/components/Workflow/Modals/addQuestionnaire.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function () {
	angular.module('main').directive('addQuestionnaire', addQuestionnaire);

	addQuestionnaire.$inject = ['templateRequestsService', 'messageService', 'fileUploadService', 'emailService'];

	function addQuestionnaire(templateRequestsService, messageService, fileUploadService, emailService) {
		return {
			restrict: 'E',
			scope: {
				chosenQuestionnaire: '=',
				email: '=',
				emailTemplates: '=',
				fromSettings: '=',
				questionnaires: '=',
				tickTask: '='
			},
			template: '\n                      <div>\n                        <div class="field-info" ng-hide="tickTask">\n                            <h4>Choose questionnaire template</h4>\n                            <div class="flex-row">\n                                <div class="select-style flex-grow-1">\n                                    <select ng-model="chosenQuestionnaire" ng-disabled="button_disable" required\n                                            ng-options="questionnaire as questionnaire.name for questionnaire in questionnaires | orderBy">\n                                        <option value="" class="hide">Choose an existing questionnaire template</option>\n                                    </select>\n                                </div>\n                            </div>\n                        </div>\n\n                        <div class="field-info">\n                            <h4>Choose email template</h4>\n                            <div class="flex-row">\n                                <div class="select-style flex-grow-1">\n                                    <select ng-model="email"\n                                            ng-init="email = email || {}"\n                                            ng-disabled="button_disable"\n                                            ng-change="getEmailTemplate(email)"\n                                            ng-options="template as template.name for template in emailTemplates | orderBy track by template.name" required>\n                                    </select>\n                                </div>\n                            </div>\n                        </div>\n\n\t\t\t\t\t\t<div class="subject-row mt-20" ng-if="!fromSettings">\n\t\t\t\t\t\t\t<insert-variable class="insert-variable" [variable-list-type]="\'JOB_MENU_SUBJECT\'" (on-variable-choose)="addSubjectVariable($event, \'subject-send-questionnaire-automation\')"></insert-variable>\n\t\t\t\t\t\t\t<div class="field-info">\n\t\t\t\t\t\t\t\t<h4>Subject</h4>\n\t\t\t\t\t\t\t\t<div class="flex-row">\n\t\t\t\t\t\t\t\t\t<input id="subject-send-questionnaire-automation" ng-disabled="button_disable" type="text" autocomplete="off" class="form-control" required\n\t\t\t\t\t\t\t\t\t\t   placeholder="Please complete my questionnaire" maxlength="255"\n\t\t\t\t\t\t\t\t\t\t   ng-model="email.subject">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n                        </div>\n\n                        <div class="field-info" ng-if="!fromSettings">\n                            <h4>Message</h4>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<sn-quill-editor-web\n                                [init-value]="email.text"\n                                [editor-i-d]="\'wf_questionnaire_email\'"\n                                [files-obj]="email.attachmentsData"\n                                [toolbar-settings]="\'color attachments variables size font\'"\n                                (on-text-change)="email.text = $event">\n                            </sn-quill-editor-web>\n                        </div>\n\n                        <hr ng-if="!tickTask" class="mt-30 mb-30">\n\n                    </div>\n                ',
			replace: true,
			transclude: true,
			link: function link(scope) {
				var emptyAttachmentsData = {
					attachments: [],
					filesSize: 0
				};

				function clearAttachments() {
					scope.email.attachmentsData = angular.copy(emptyAttachmentsData);
				}

				var isUserEmail = function isUserEmail(email) {
					return !email.hasOwnProperty('emailTemplateType') && !email.hasOwnProperty('defaultEmailTemplate');
				};

				var setEmailTemplate = function setEmailTemplate(data) {
					scope.email = angular.copy(data);
					if (data.storedAttachments.length) {
						scope.email.attachmentsData = {
							attachments: fileUploadService.convertAttachmentsToShow(data.storedAttachments)
						};
						scope.$evalAsync();
					} else {
						clearAttachments();
					}
				};

				scope.addSubjectVariable = function ($event, id) {
					var el = document.getElementById(id);
					scope.email.subject = emailService.addSubjectVariable(el, $event);
				};

				scope.$watchCollection('email.attachmentsData', function (newValue, oldValue) {
					if (newValue && newValue !== oldValue && newValue.attachments.length && newValue.attachments.length !== 0 && scope.isUserEmail) {
						addUploadedAttachments(newValue);
					}
				});

				function addUploadedAttachments(attachmentsData) {
					var attachments = attachmentsData.attachments;


					scope.uploadedAttachments = [];
					angular.forEach(attachments, function (attachment) {
						if (!attachment.id) {
							scope.uploadedAttachments.push(attachment);
						} else if (attachment.hasOwnProperty('checked')) {
							var copiedAttachment = angular.copy(attachment);
							scope.uploadedAttachments.push(copiedAttachment);
						}
					});
				}

				var showErrorMessage = function showErrorMessage() {
					messageService.showToaster('e_0', 'general');
				};

				scope.getEmailTemplate = function (email) {
					if (scope.fromSettings) {
						return;
					}

					if (email === null) {
						scope.email = {
							text: '',
							attachmentsData: angular.copy(emptyAttachmentsData)
						};
					} else if (email && (typeof email === 'undefined' ? 'undefined' : _typeof(email)) === 'object') {
						var _isUserEmailChosen = isUserEmail(email);
						scope.isUserEmail = isUserEmail(email);
						if (_isUserEmailChosen) {
							scope.email = email;

							if (email.storedAttachments && email.storedAttachments.length || scope.uploadedAttachments && scope.uploadedAttachments.length) {
								var storedAttachments = angular.copy(email.storedAttachments);
								var allAttachments = storedAttachments !== null ? angular.copy(email.storedAttachments) : [];

								if (scope.uploadedAttachments && scope.uploadedAttachments.length) {
									angular.forEach(scope.uploadedAttachments, function (attachment) {
										allAttachments.push(attachment);
									});
								}
								scope.email.attachmentsData = {
									attachments: allAttachments
								};
							} else {
								clearAttachments();
							}
						} else if (email.id) {
							templateRequestsService.getTemplates('full_template', email.id).subscribe(function (data) {
								return setEmailTemplate(data);
							}, function (error) {
								return showErrorMessage();
							});
						}
					} else {
						console.error('no chosen email');
					}
				};

				scope.disableDragDrop = function () {
					return true;
				};

				scope.uploadedAttachments = [];
				var email = scope.email;
				var isUserEmailChosen = isUserEmail(email);
				if (isUserEmailChosen) {
					scope.isUserEmail = true;
				} else if (email && (typeof email === 'undefined' ? 'undefined' : _typeof(email)) === 'object' && email.id) {
					scope.getEmailTemplate(scope.email);
				} else {
					console.error('no scope.email.id');
				}
			}
		};
	}
})();

/***/ }),

/***/ "./web/js/components/Workflow/Modals/addTodoModal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

(function () {
	angular.module('main').directive('addTodoModal', addTodoModal);

	addTodoModal.$inject = ['workflowService', 'messageService', 'validationService', '$rootScope'];

	function addTodoModal(workflowService, messageService, validationService, $rootScope) {
		return {
			restrict: 'E',
			scope: {
				jobId: '<',
				taskList: '=',
				fromSettings: '<',
				renewWorkflow: '&'
			},
			template: '<div id="addTodoModal" class="modal modal-center fade" data-backdrop="static" data-keyboard="false">\n            <div class="modal-dialog" style="max-width: 670px">\n        \n                <form role="form" ng-submit="fromSettings ? saveTaskFromSettings(task, taskList, task.id) : saveTask()" name="addTodo">\n                    <div class="modal-content">\n                        <div class="modal-header">\n                            <btn-close></btn-close>\n                            <h3 class="modal-title">{{isForEdit ? \'Edit to-do\' : \'Add a new to-do\'}}</h3>\n                        </div>\n                        <div class="modal-body f-s-14-i">\n                            <div class="form-group mb-8">\n                           \n        \n                                <div class="row">\n                                    <p class="col-xs-12">Task name</p>\n                                    <div class="col-xs-12">\n                                        <input type="text" autocomplete="off" class="form-control" ng-model="task.name" required>\n                                    </div>\n                                </div>\n        \n                                <hr class="mt-30 mb-30">\n        \n                                <div class="checkbox flex-row">\n                                    <div class="checkbox-squared wf-label">\n                                        <input id="checkbox-squared-has-due-date" type="checkbox" ng-model="task.hasDue">\n                                        <label for="checkbox-squared-has-due-date"></label>\n                                    </div>\n                                    <label for="checkbox-squared-has-due-date" class="checker f-s-14-i">\n                                        This task has a due date (will be flagged when overdue)\n                                    </label>\n                                </div>\n        \n                                <div class="row flex-row flex-align-center mt-20 flex-wrap-xs">\n                                    <label class="col-xs-12 col-sm-1 control-label pull-left f-s-14-i">Due</label>\n                                    <div class="col-xs-12 col-sm-2 numb-style mb-xs-10">\n                                        <input ng-disabled="!task.hasDue" data-number-input min="1" class="form-control"\n                                               type="number" autocomplete="off" ng-model="task.due" required>\n                                    </div>\n                                    <div class="col-xs-12 col-sm-4 mb-xs-10">\n                                        <div class="select-style">\n                                            <select ng-disabled="!task.hasDue"\n                                                    ng-init="task.dateItem"\n                                                    ng-model="task.dateItem"\n                                                    ng-options="item for item in dateItems | orderBy">\n                                            </select>\n                                        </div>\n                                    </div>\n                                    <div class="col-xs-12 col-sm-5 mb-xs-10">\n                                        <div class="select-style">\n                                            <select ng-disabled="!task.hasDue"\n                                                    ng-init="task.dateSequence"\n                                                    ng-model="task.dateSequence"\n                                                    ng-options="item.id as item.name for item in taskDateSequence">\n                                            </select>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                        <div class="modal-footer modal-foot">\n                            <button type="submit" class="btn btn-lg btn-success" spinning-wheel is-spinning-wheel-active="button_disabled" ng-disabled="button_disabled">Save workflow task</button>\n                        </div>\n                    </div>\n                </form>\n        \n            </div>\n        </div>\n ',
			replace: true,
			transclude: true,
			link: function link(scope) {
				var todoModal = '#addTodoModal';

				$(document).on('show.bs.modal', todoModal, function () {
					scope.taskToAnimateNumber = null;
					scope.taskInfo = workflowService.getTaskInfo();
					scope.isForEdit = scope.taskInfo.isForEdit;
					scope.task = angular.copy(scope.taskInfo.task);
					scope.taskDateSequence = workflowService.getTaskDateSequence();
					scope.dateItems = workflowService.getTaskDates();
					scope.$evalAsync();
				}).on('shown.bs.modal', todoModal, function () {
					$(this).find('input').first().focus();
					var input = $(this).find('input');

					validationService.isModalClosePrevented(input);
				});

				scope.saveTaskFromSettings = function (task, taskTypes, id) {
					scope.button_disable = true;

					var isEdited = id !== null && id !== undefined;

					if (!workflowService.isTaskValid(task)) {
						scope.button_disabled = false;
						return;
					}

					scope.taskList = workflowService.pasteNewTaskInList(taskTypes, task); // modifies workflow list
					scope.taskList = workflowService.renewTaskViewDue(scope.taskList);

					isEdited ? messageService.showToaster('s_4', 'workflow') : messageService.showToaster('s_3', 'workflow');

					scope.button_disable = false;

					$(todoModal).modal('hide');
				};

				scope.successTaskSave = function (data, id) {
					if (!data || !data.tasks) {
						return;
					}

					scope.renewWorkflow({ tasks: data.tasks });

					for (var i = 0; i < data.tasks.length; i++) {
						if (data && data.taskMetadata && data.taskMetadata.taskId === data.tasks[i].id) {
							scope.taskToAnimateNumber = '.task-' + i;
						}
					}

					var isEdited = id !== null && id !== undefined;

					isEdited ? messageService.showToaster('s_4', 'workflow') : messageService.showToaster('s_3', 'workflow');

					$(todoModal).modal('hide').on('hidden.bs.modal', function () {
						if (!isEdited) {
							$rootScope.$broadcast('animateTask', scope.taskToAnimateNumber);
						}
						$(this).off('hidden.bs.modal');
					});
				};

				scope.saveTask = function () {
					scope.button_disabled = true;
					var task2Save = scope.task;
					workflowService.saveTask(scope.task, scope.jobId, scope.taskList).finally(function () {
						scope.button_disabled = false;
					}).subscribe(function (result) {
						return scope.successTaskSave(result, task2Save.id);
					}, function (result) {
						return workflowService.errorSaveTask(result.data);
					});
				};
			}
		};
	}
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./web/js/components/Workflow/Modals/addWorkflowTaskModal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

(function () {
	angular.module('main').directive('addWorkflowTaskModal', addWorkflowTaskModal);

	addWorkflowTaskModal.$inject = ['$location', 'workflowService'];

	function addWorkflowTaskModal($location, workflowService) {
		return {
			restrict: 'E',
			scope: {
				mainShootLabelName: '=',
				extraShootLabelName: '='
			},
			template: '\n                        <div id="addWorkflowTaskModal" class="modal modal-center fade" data-backdrop="static" data-keyboard="false">\n                            <div class="modal-dialog">\n                                <div class="modal-content">\n                                    <div class="modal-header pt-pb-15">\n                                       <btn-close></btn-close>\n                                        <h3 class="modal-title f-s-20">Add new workflow task</h3>\n                                    </div>\n                                    <div class="modal-body add-new-modal add-new-list" style="padding-bottom: 5px!important; padding-top: 30px!important">\n                                        <h2 class="add-new-tip">I want to add a new...</h2>\n                                        \n                                        <btn-add-new-job-element add="showAddTodoModal()"\n                                                                 icon="fi-checkbox fi-job"\n                                                                 title="to-do"\n                                                                 description="Add a to-do task which you check off when you get it done."\n                                        ></btn-add-new-job-element>\n                    \n                                        <btn-add-new-job-element add="showAddAutomationModal()"\n                                                                 icon="fi-automation fi-job"\n                                                                 title="automation"\n                                                                 description="Add a task that automatically sends emails, questionnaires and contracts."\n                                        ></btn-add-new-job-element>\n                                        \n                                        <btn-add-new-job-element add="showAddExtraShootModal()"\n                                                                 icon="fi fi-camera-cross fi-job mr-20"\n                                                                 title="{{extraShootLabelName | lowercase}}"\n                                                                 description="Add an additional shoot which appears in your workflow and calendar."\n                                        ></btn-add-new-job-element>\n                                        \n                                         <btn-add-new-job-element add="showAddAppointmentModal()"\n                                                                 icon="fi fi-call fi-job mr-20"\n                                                                 title="appointment"\n                                                                 description="Add an appointment which appears in your workflow and calendar."\n                                        ></btn-add-new-job-element>\n                                        \n                                    </div>\n                                </div>\n                            </div>\n       \n                        </div>\n                 ',
			replace: true,
			transclude: true,
			link: function link(scope) {
				scope.showAddTodoModal = function () {
					var newTask = workflowService.addEmptyTask();
					workflowService.setTaskInfo(newTask);
					$('#addWorkflowTaskModal').modal('hide').on('hidden.bs.modal', function () {
						$('#addTodoModal').modal('show');
						$(this).off('hidden.bs.modal');
					});
				};
				scope.showAddAutomationModal = function () {
					var newTask = workflowService.addEmptyTask();
					workflowService.setTaskInfo(newTask);
					$('#addWorkflowTaskModal').modal('hide').on('hidden.bs.modal', function () {
						$('#addAutomationModal').modal('show');
						$(this).off('hidden.bs.modal');
					});
				};

				scope.showAddExtraShootModal = function () {
					var newTask = workflowService.addEmptyTask();
					workflowService.setTaskInfo(newTask);
					$('#addWorkflowTaskModal').modal('hide').on('hidden.bs.modal', function () {
						var isSettingsPage = $location.path().includes('settings/workflows/');
						var modalToShow = isSettingsPage ? '#extraShootWithoutScheduleModal' : '#extraShootModal';
						$(modalToShow).modal('show');
						$(this).off('hidden.bs.modal');
					});
				};

				scope.showAddAppointmentModal = function () {
					var newTask = workflowService.addEmptyTask();
					workflowService.setTaskInfo(newTask);
					$('#addWorkflowTaskModal').modal('hide').on('hidden.bs.modal', function () {
						var isSettingsPage = $location.path().includes('settings/workflows/');
						var modalToShow = isSettingsPage ? '#appointmentWithoutScheduleModal' : '#appointment';
						$(modalToShow).modal('show');
						$(this).off('hidden.bs.modal');
					});
				};
			}
		};
	}
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./web/js/components/Workflow/Modals/deleteWorkflowTaskModal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

(function () {
	angular.module('main').directive('deleteWorkflowTaskModal', deleteWorkflowTaskModal);

	deleteWorkflowTaskModal.$inject = ['workflowService', 'messageService'];

	function deleteWorkflowTaskModal(workflowService, messageService) {
		return {
			restrict: 'E',
			scope: {
				fromSettings: '=',
				workflow: '=',
				renewWorkflow: '&'
			},
			template: '\n                      <div id="deleteWorkflowTaskModal" class="modal modal-center fade" data-backdrop="static" data-keyboard="false">\n                        <div class="modal-dialog">\n                            <div class="modal-content">\n                                <div class="modal-header">\n                                    <button class="close" data-dismiss="modal" aria-hidden="true">&times;</button>\n                                    <h3 class="modal-title">Delete workflow task</h3>\n                                </div>\n                                <div class="modal-body">\n                                        <strong>Are you sure you would like to delete this task? This cannot be undone!</strong>\n                                </div>\n                                <div class="modal-footer modal-foot">\n                                    <button type="button" class="btn btn-md btn-danger" ng-click="delete()">Yes</button>\n                                    <button type="button" class="btn btn-md btn-default" data-dismiss="modal">No</button>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                 ',
			replace: true,
			transclude: true,
			link: function link(scope) {
				$(document).on('show.bs.modal', '#deleteWorkflowTaskModal', function () {
					scope.taskInfo = workflowService.getTaskInfo();
					scope.task = scope.taskInfo.task;
					scope.taskList = scope.taskInfo.taskList;
				});

				var renewWorkflow = function renewWorkflow(data) {
					if (!data || !data.tasks) {
						return;
					}
					scope.renewWorkflow({ tasks: data.tasks });

					messageService.showToaster('s_5', 'workflow');
				};

				scope.delete = function () {
					if (scope.fromSettings) {
						scope.workflow = workflowService.deleteTaskFromSettings(scope.workflow, scope.taskList, scope.task);
						messageService.showToaster('s_5', 'workflow');
					} else {
						workflowService.deleteTask(scope.taskList, scope.task).subscribe(function (result) {
							return renewWorkflow(result);
						}, function (err) {
							return messageService.handleError(err);
						});
					}
					$('#deleteWorkflowTaskModal').modal('hide');
				};
			}
		};
	}
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./web/js/components/Workflow/animateNewTask.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

(function () {
	angular.module('main').directive('animateNewTask', animateNewTask);

	animateNewTask.$inject = [];

	function animateNewTask() {
		return {
			restrict: 'A',
			scope: {},
			link: function link(scope) {
				scope.$on('animateTask', animateNewTask);

				var counter = 0;
				var TOP_SPACE = 200;

				function animateNewTask(event, taskToAnimate) {
					if (counter > 30) return;

					var taskOffset = $(taskToAnimate).offset();
					if (!taskOffset) {
						counter += 1;
						setTimeout(function () {
							animateNewTask(event, taskToAnimate);
						}, 100);
					} else {
						$('html, body').animate({
							scrollTop: taskOffset.top - TOP_SPACE
						}, 1500, function () {
							var animationClass = 'animated tada';
							$(taskToAnimate).addClass(animationClass);
						});
					}
				}
			}
		};
	}
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./web/js/components/Workflow/buttons/workflowOptions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

(function () {
	angular.module('main').directive('workflowOptions', workflowOptions);

	workflowOptions.$inject = ['$location', 'workflowService'];

	function workflowOptions($location, workflowService) {
		return {
			restrict: 'E',
			scope: {
				task: '=',
				taskList: '='
			},
			template: ' \n                     <div class="flex-row workflow-options">\n                        <btn-edit class="m-5 pt-5 pb-5 w-40" sn-empty="true" ng-disabled="task.disabled" ng-click="showEditTaskModal(task, taskList)"></btn-edit>\n                        <btn-delete class="m-5 pt-5 pb-5 w-40" sn-empty="true" ng-disabled="task.disabled" ng-click="showDeleteTaskModal(task, taskList)"></btn-delete>\n                     </div>\n                    ',
			replace: true,
			transclude: true,
			link: function link(scope) {
				scope.showDeleteTaskModal = function (task, taskList) {
					workflowService.setTaskInfo(task, taskList);
					$('#deleteWorkflowTaskModal').modal('show');
				};

				scope.showEditTaskModal = function (task, taskList) {
					workflowService.setTaskInfo(task, taskList, true);
					scope.tickTask = false;
					scope.tickTaskType = '';
					var isTemplate = $location.path().includes('/settings');
					var modalId = workflowService.chooseModalToShow(task, isTemplate);
					$(modalId).modal('show');
				};
			}
		};
	}
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./web/js/components/Workflow/workflowList.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

(function () {
	angular.module('main').directive('workflowList', workflowList);

	workflowList.$inject = ['workflowDragNDropService', '$rootScope', 'stringModifierService', 'timeConverter', 'newWorkflowService', 'messageService', 'customizeLabelsService'];

	function workflowList(workflowDragNDropService, $rootScope, stringModifierService, timeConverter, newWorkflowService, messageService, customizeLabelsService) {
		return {
			restrict: 'E',
			scope: {
				now: '<',
				allTasks: '=',
				changeTaskState: '&',
				changeToLeadOrJob: '&',
				correctSortedTasksArray: '<correctOrder',
				items: '=',
				itemId: '@',
				label: '@',
				job: '=',
				leadId: '=',
				jobToEdit: '=',
				workflowClass: '@',
				renewWorkflow: '&',
				showWarning: '&',
				archived: '=',
				showModal: '&',
				mainShootLabelName: '=',
				extraShootLabelName: '='
			},
			template: ' \n                <div class="workflow-list">\n             \n                    <div class="workflow-list-title {{workflowClass}}">\n                        <span ng-show="items.length > 2">{{label}}</span>\n                        <span ng-show="items.length === 2" style="width: 95px">{{label}}</span>\n                    </div>\n                    \n                    <ul class="list list-unstyled list-{{workflowClass}}"  \n                        dnd-list="items"\n                        dnd-dragover="onDragOver(type)">\n                       \n                        <li class="workflow-item task-{{task.number}}"\n                            dnd-draggable="task"   \n                            dnd-dragend="onDragend(task, event)" \n                            dnd-moved="items.splice($index, 1)"\n                            dnd-type="\'{{task.calendarEventType || \'noEvents\'}}\'"\n                            dnd-disable-if="(task.defaultTask && task.calendarEventType !== \'MAIN_SHOOT\') || !$root.dnd.canMove || archived "\n                            dnd-effect-allowed="move"\n                            ng-repeat="task in items"\n                            ng-class="{\'pointer\':!task.defaultTask, \'task-completed\': task.completed || task.disabledAutomation, \'task-inactive\' : task.disabled}">\n                        \n                            <div class="flex-row workflow-item__content" \n                                ng-class="{\'withLabel\': isLabelShown(\'hasAnyLabel\', task), \n                                \'default-task\': (task.defaultTask && task.calendarEventType !== \'MAIN_SHOOT\')}"\n                                dnd-nodrag >\n                              \n                               <div class="checkbox-squared" ng-if="task.name !==\'Job accepted\' || !task.defaultTask">\n                                    <input type="checkbox"\n                                           id="{{itemId}}-{{$index}}"\n                                           name="check"\n                                           ng-model="task.completed" \n                                           ng-click="(task.disabledAutomation && task.completed) ? showWarningModal(task) : showSendModal(task)"\n                                           ng-disabled="!$root.dnd.canMove || task.disabled || archived"/>\n                                    <label for="{{itemId}}-{{$index}}"></label>\n                               </div>\n                               <div class="checkbox-squared" ng-if="task.name ===\'Job accepted\' && task.defaultTask">\n                                    <input type="checkbox"\n                                           id="{{itemId}}-{{$index}}"\n                                           name="check"\n                                           ng-model="task.completed" ng-click="changeToLeadOrJob({task : task})"\n                                           ng-disabled="!$root.dnd.canMove || task.disabled || archived"/>\n                                    <label for="{{itemId}}-{{$index}}"></label>\n                               </div>\n                               \n                                 <div class="flex-row flex-wrap-md flex-just-space flex-align-center flex-grow-1">\n                                \n                                    <div class="workflow-item-description flex-grow-1">\n                                 \n                                        <div class="workflow-item-name text-break" ng-show="task.calendarEventType === \'MAIN_SHOOT\'">{{\' \' + job.name}}</div>\n                                         <div class="workflow-item-name text-break" ng-show="task.calendarEventType !== \'MAIN_SHOOT\'">{{\' \' + task.name}}</div>\n                                        <div class="workflow-item-data flex-row flex-wrap" ng-init="labelColor = task.disabledAutomation ? \'task.type\' : \'label-danger-bright label-danger-bright--always\'">\n                                            <sn-label ng-if="::isLabelShown(\'jobAccepted-task\', task)" class="{{task.completed ? \'job-accepted-check\' : \'job-accepted-info\'}} flex-basis-full" color="{{(task.completed || task.disabled) ? \'label-danger-bright\': \'label-jobAccept\'}}" \n                                            text="This checks automatically when a quote is accepted OR a contract is signed OR an invoice is paid. Once checked this lead becomes a job.">\n                                            </sn-label>\n                                            \n                                            <p ng-if="::isLabelShown(\'hasLocation\', task)" class="job-accepted-info-text flex-basis-full text-break">\n                                                Location: {{task.location}}\n                                            </p>\n                           \n                                            <sn-label ng-if="::isLabelShown(\'main-shoot\', task)" text="{{mainShootLabelName}}" color="label-success"></sn-label>\n                                            <sn-label ng-if="::isLabelShown(\'extra-shoot\', task)" text="{{extraShootLabelName}}" color="label-success"></sn-label>\n                                            <sn-label ng-if="::isLabelShown(\'appointment\', task)" text="Appointment" color="{{task.type}}"></sn-label>\n                                            <sn-label ng-if="::isLabelShown(\'action-email\', task)" text="Send email" color="{{task.type}}"></sn-label>\n                                            <sn-label ng-if="::isLabelShown(\'action-autoEmail\', task)" text="Auto send email" color="{{task.type}}"></sn-label>\n                                            <sn-label ng-if="::isLabelShown(\'action-contract\', task)" text="Auto send contract" color="{{task.type}}"></sn-label>\n                                            <sn-label ng-if="::isLabelShown(\'action-questionnaire\', task)" text="Auto send questionnaire" color="{{task.type}}"></sn-label>\n                                   \n                                            <sn-label ng-if="task.number === 0" color="{{task.startDate ? \'label-success\' : \'label-danger-bright\'}}">\n                                                <i class="fa fa-clock-o"></i>\n                                                <span>{{task.taskDueDefault| timeFilter:\'long\'}}</span> \n                                            </sn-label>   \n                                            <sn-label ng-if="::isLabelShown(\'any-shoot\', task)" color="{{task.startDate ? \'label-success\' : \'label-danger-bright\'}}">\n                                                <i class="fa fa-clock-o" ng-if="task.startDate"></i>\n                                                <span ng-if="::!isLabelShown(\'hasType\', task)">{{task.taskDueDefault| timeFilter:\'long\'}}</span>\n                                                <main-shoot-date start-date="task.startDate" finish-date="task.endDate"></main-shoot-date>\n                                            </sn-label>\n                                            <sn-label ng-if="::isLabelShown(\'appointment\', task)" color="{{task.startDate ? task.type : \'label-danger-bright\'}}">\n                                                <i class="fa fa-clock-o" ng-if="task.startDate"></i>\n                                                <span ng-if="::!isLabelShown(\'hasType\', task)">{{task.taskViewDue}}</span>\n                                                <full-date-time start-date="task.startDate" start-time="task.startTime" finish-date="task.endDate" finish-time="task.endTime"></full-date-time>\n                                            </sn-label>\n                                            <sn-label ng-if="::isLabelShown(\'hasDue\', task) && task.calendarEvent" text="{{task.taskViewDue}}" color="{{task.type}}"\n                                                      ng-class="{labelColor: isLabelShown(\'isInactive\', task, job.startDate, allTasks)}">\n                                                  <i class="fa fa-clock-o"></i> \n                                            </sn-label>\n                                            <sn-label ng-if="isJobActive(task) && !archived" text="{{trueDate | timeFilter: \'long\'}}" \n                                                      color="{{::isLabelShown(\'isInactive\', task, job.startDate, allTasks) ? labelColor : task.type}}">\n                                                  <i class="fa fa-clock-o"></i> \n                                            </sn-label>\n                                            <sn-label ng-if="::isLabelShown(\'hasOverdue\', task) && !archived && task.hasDue !==false" text="{{task.overdueDays}}" color="label-danger-bright"></sn-label>  \n                                            <sn-label ng-if="::isLabelShown(\'isInactive\', task, job.startDate, allTasks) && !archived" text="Will not auto send"\n                                              color="{{labelColor}}"></sn-label>\n                                        </div>\n                                    </div>\n                                \n                                    <workflow-options class="flex-item-width-full-md flex-just-center"\n                                        ng-show="!task.defaultTask" \n                                        task="task"\n                                        task-list="allTasks"\n                                    ></workflow-options>\n                                   \n                                    <div class="flex-row flex-basis-xs flex-just-center">\n                                        <btn-edit sn-text="Edit"\n                                         class="m-5"\n                                              ng-if="task.calendarEventType === \'MAIN_SHOOT\' && leadId"\n                                              ng-click="showEditLeadModal(jobToEdit)"\n                                              ng-disabled="button_disable"\n                                        ></btn-edit>\n                                        \n                                               <btn-edit sn-text="Edit job"\n                                              class="m-5"\n                                              ng-if="task.calendarEventType === \'MAIN_SHOOT\' && !leadId"\n                                              ng-click="showEditJobModal(jobToEdit)"\n                                              ng-disabled="button_disable"\n                                        ></btn-edit>  \n                                       \n                                    </div>\n                           \n                         \n                                 </div>\n                                 \n                                 <div ng-class="{\'dnd-icon\' : (!task.defaultTask || task.calendarEventType === \'MAIN_SHOOT\') , \'noEvents\' : !$root.dnd.canMove}" \n                                      dnd-handle\n                                  ></div>\n                                  \n                            </div>\n                          \n                        </li>\n                    </ul>  \n                   \n                </div>\n            ',

			replace: true,
			transclude: true,
			link: function link(scope) {
				var defaultWorkflow = {
					id: '',
					name: 'Default'
				};

				$rootScope.dnd = {
					canMove: true
				};

				var lastCorrectOrder = void 0,
				    startTasklistLength = void 0,
				    correctTasksOrder = void 0;

				scope.isLabelShown = newWorkflowService.isLabelShown;

				var stopEvent = function stopEvent(event) {
					event.stopImmediatePropagation();
					return false;
				};

				var revertChanges = function revertChanges() {
					lastCorrectOrder = scope.correctSortedTasksArray ? angular.copy(scope.correctSortedTasksArray) : angular.copy(scope.allTasks);
					scope.allTasks = angular.copy(lastCorrectOrder);
					$rootScope.dnd.canMove = true;
				};

				var setCorrectTasksOrder = function setCorrectTasksOrder() {
					var isEqualNumbers = workflowDragNDropService.checkForEqualNumbers(scope.allTasks);
					var isTasksCountChanged = startTasklistLength !== scope.allTasks.length;
					var isWrongTasksOrder = isEqualNumbers || isTasksCountChanged;

					var tasks2Check = isWrongTasksOrder ? lastCorrectOrder : scope.allTasks;

					correctTasksOrder = workflowDragNDropService.keepDefaultTasksInPlace(tasks2Check);
				};

				var dropCallback = function dropCallback(draggedTask) {
					if (scope.archived) {
						messageService.showToaster('e_5', 'lead');
					}

					if ($rootScope.dnd.canMove) {
						return false;
					}

					var renewedList = workflowDragNDropService.saveNewTasksOrder(draggedTask, correctTasksOrder);

					if (renewedList) {
						renewedList.subscribe(function (result) {
							if (result && result.tasks) {
								scope.renewWorkflow({ tasks: result.tasks });
								$rootScope.dnd.canMove = true;
							} else {
								revertChanges();
							}
						}, revertChanges);
					} else {
						revertChanges();
					}
				};
				scope.onDragOver = function (type) {
					if (type && type.toUpperCase() === 'MAIN_SHOOT') {
						$('.dndPlaceholder').addClass('mainShootOver');
					} else {
						$('.dndPlaceholder').removeClass('mainShootOver');
					}
					return true;
				};

				scope.onDragStart = function (task, event) {
					if (!$rootScope.dnd.canMove) {
						return stopEvent(event);
					}

					lastCorrectOrder = scope.correctSortedTasksArray ? angular.copy(scope.correctSortedTasksArray) : angular.copy(scope.allTasks);
					startTasklistLength = lastCorrectOrder.length;
					setCorrectTasksOrder();

					$rootScope.dnd.canMove = false;
					return task;
				};

				scope.onDragend = function (draggedTask, event) {
					event.stopImmediatePropagation();
					$rootScope.dnd.canMove = false;

					lastCorrectOrder = scope.correctSortedTasksArray ? angular.copy(scope.correctSortedTasksArray) : angular.copy(scope.allTasks);
					startTasklistLength = lastCorrectOrder.length;

					setCorrectTasksOrder();
					scope.allTasks = angular.copy(correctTasksOrder);
					dropCallback(draggedTask);
				};

				scope.showWarningModal = function (task) {
					task.disabled = true;
					scope.showWarning({ task: task });
				};

				scope.showSendModal = function (task) {
					task.disabled = true;
					if (!task.completed || task.action === null) {
						scope.changeTaskState({ task: task });
					} else {
						scope.showModal({ task: task });
					}
				};

				scope.showEditJobModal = function (jobToEdit) {
					jobToEdit.workflow.name = stringModifierService.addSelectedText(jobToEdit.workflow.name);
					var isWorkflowSaved = jobToEdit.workflowNames.find(function (workflow) {
						return workflow.id === jobToEdit.workflow.id;
					});
					if (jobToEdit.workflowNames && !isWorkflowSaved) {
						jobToEdit.workflowNames.push(jobToEdit.workflow);
					}
					$('#newJob').modal('show');

					scope.$parent.$broadcast('showModalJob', jobToEdit);
				};

				scope.showEditLeadModal = function (jobToEdit) {
					if (jobToEdit.startTime) {
						jobToEdit.startTime = timeConverter.convert24to12(jobToEdit.startTime);
						jobToEdit.finishTime = timeConverter.convert24to12(jobToEdit.finishTime);
					}

					$('#newLead').modal('show');

					scope.$parent.$broadcast('showModal', {
						lead: jobToEdit,
						jobId: scope.job.id
					});
				};

				scope.trueDate = '';
				scope.changeTaskStateForMainShoot = function (task) {};

				scope.isJobActive = function (task) {
					if (task.calendarEventType === 'MAIN_SHOOT' || task.calendarEventType === 'EXTRA_SHOOT' || task.calendarEventType === 'APPOINTMENT' || task.name === 'Lead created') {
						return false;
					} else if (task.mustDueDate !== null && task.completed === false && task.defaultTask === false && task.calendarEvent === null) {
						scope.trueDate = task.mustDueDate;
						return true;
					} else if (task.completed && task.calendarEventType === 'MAIN_SHOOT') {
						return false;
					} else if (task.completed === true && task.dueDate !== null && task.hasDue === null) {
						scope.trueDate = task.dueDate;
						return true;
					} else if (!task.completed && task.hasDue === false || task.hasDue === null) {
						return false;
					} else if (task.mustDueDate === null && task.completed === false && task.defaultTask === false) {
						if (task.taskViewDue.includes('main shoot')) {
							scope.trueDate = task.taskViewDue.replace('main shoot', scope.mainShootLabelName).toLowerCase();
						} else {
							scope.trueDate = task.taskViewDue;
						}

						return true;
					} else if (task.hasDue === false || task.hasDue === null || task.completed && task.calendarEvent === null) {
						scope.trueDate = task.dueDate;
						return true;
					}
					return false;
				};
			}
		};
	}
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./web/js/components/admin/addAmbassadorCodeModal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
    angular.module('main').directive('addAmbassadorCodeModal', addAmbassadorCodeModal);

    addAmbassadorCodeModal.$inject = [];

    function addAmbassadorCodeModal() {
        return {
            restrict: 'E',
            scope: {
                ambassador: '=',
                submitAmbassadorCode: '&',
                btnDisable: '<'
            },
            template: '\n                    <div id="addAmbassadorCodeModal" class="modal modal-center fade" data-backdrop="static" data-keyboard="false">\n                            <div class="modal-dialog" style="max-width: 620px">\n                              <div class="modal-content">\n                                   <form class="form-horizontal" ng-submit="submitAmbassadorCode({ambassador:ambassador})">\n                                        <div class="modal-header">\n                                           <btn-close></btn-close>\n                                            <h3 class="modal-title">{{ambassador.isAmbassador ? \'Extend ambassador code\' : \'Make ambassador\'}}</h3>\n                                        </div>\n                                        <div class="modal-body">\n                                                <div class="row form-group">\n                                                    <div class="col-sm-3">\n                                                        <label class="control-label">First name</label>\n                                                    </div>\n                                                    <div class="col-sm-9">\n                                                        <input type="text" class="form-control" ng-model="ambassador.firstName" disabled>\n                                                    </div>\n                                                </div>\n                                                <div class="row form-group">\n                                                    <div class="col-sm-3">\n                                                        <label class="control-label">Email</label>\n                                                    </div>\n                                                    <div class="col-sm-9">\n                                                        <input type="email" class="form-control" ng-model="ambassador.email" disabled>\n                                                    </div>\n                                                </div>\n                                                <div class="row form-group">\n                                                    <div class="col-sm-3">\n                                                        <label class="control-label">Ambassador code</label>\n                                                    </div>\n                                                    <div class="col-sm-9">\n                                                        <input type="text" class="form-control" ng-model="ambassador.code" ng-disabled="ambassador.isAmbassador" required>\n                                                    </div>\n                                                </div>\n                                              \n                                                <div class="row form-group">\n                                                        <div class="col-sm-3">\n                                                             <label class="control-label">Duration</label>\n                                                        </div>\n                                                        <div class="col-sm-9 job-date">\n                                                             <div class="flex-row flex-wrap-xs">\n                                                                <div class="flex-grow-1 box-no-transition datepicker-static bottom-0">\n                                                                    <input ng-model="ambassador.startDate" class="form-control"\n                                                                           disabled type="date" name="input" data-placeholder="dd/mm/yyyy"\n                                                                           min="2001-12-31"\n                                                                           max="2999-12-31"\n                                                                           data-date=\'{"startView": 2, "openOnMouseFocus": true}\' required/>\n                                                                </div>\n                                                                <div class="flex-basis-xs ms-15">to</div>\n                                                               <div class="flex-grow-1 box-no-transition datepicker-static bottom-0 left-n-136">\n                                                                    <input ng-model="ambassador.endDate" class="form-control"\n                                                                           type="date" name="input" data-placeholder="dd/mm/yyyy"\n                                                                           min="{{( ambassador.startDate ) ? ( ambassador.startDate | date : \'yyyy-MM-dd\') : (now | date : \'yyyy-MM-dd\') }}"\n                                                                           max="2999-12-31"\n                                                                           data-date=\'{"startView": 2, "openOnMouseFocus": true}\' required/>\n                                                                </div>\n                                                            </div>\n                                                        </div>\n                                                    </div>\n                                      \n                                        </div>\n                                        <div class="modal-footer modal-foot">\n                                            <button type="submit"\n                                                    class="btn btn-success btn-lg"\n                                                    ng-disabled="btnDisable"\n                                                    spinning-wheel is-spinning-wheel-active="btnDisable"\n                                            >Save ambassador code\n                                            </button>\n                                        </div>\n                                    </form>\n                                </div>\n                            </div>\n                        </div>',
            replace: true,
            transclude: true,
            link: function link(scope) {
                scope.ambassador = {};
                scope.now = new Date();
                scope.now.setHours(0, 0, 0, 0);

                scope.$watch('ambassador.startDate', checkCodeDate);

                function checkCodeDate(startDate) {
                    if (scope.ambassador && (!scope.ambassador.endDate || startDate > scope.ambassador.endDate)) {
                        scope.ambassador.endDate = startDate;
                    }
                }
            }
        };
    }
})();

/***/ }),

/***/ "./web/js/components/admin/addPromoCodeModal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
    angular.module('main').directive('addPromoCodeModal', addPromoCodeModal);

    addPromoCodeModal.$inject = [];

    function addPromoCodeModal() {
        return {
            restrict: 'E',
            scope: {
                campaign: '<',
                submitPromoCode: '&',
                btnDisable: '<'
            },
            template: '\n                    <div id="addPromoCode" class="modal modal-center fade" data-backdrop="static" data-keyboard="false">\n                            <div class="modal-dialog" style="max-width: 620px">\n                                <div class="modal-content">\n                                    <form class="form-horizontal" ng-submit="submitPromoCode({campaign:campaign})">\n                                        <div class="modal-header">\n                                           <btn-close></btn-close>\n                                            <h3 class="modal-title">{{campaign.id ? \'Extend promo code\' : \'Add new promo code\'}}</h3>\n                                        </div>\n                                        <div class="modal-body">\n                                                <div class="row form-group">\n                                                    <label class="col-sm-3 control-label text-left">Campaign name</label>\n                                                    <div class="col-sm-9">\n                                                        <input type="text" class="form-control" ng-model="campaign.name" required>\n                                                    </div>\n                                                </div>\n                                                <div class="row form-group">\n                                                    <label class="col-sm-3 control-label text-left">Promo code</label>\n                                                    <div class="col-sm-9">\n                                                        <input type="text" class="form-control" ng-model="campaign.code" ng-disabled="campaign.id" required>\n                                                    </div>\n                                                </div>\n                                                <div class="row form-group">\n                                                    <label class="col-sm-3 control-label text-left">Discount (Year 1)</label>\n                                                    <div class="col-sm-9">\n                                                        <input type="number" class="form-control transition-0" \n                                                                ng-model="campaign.discount" ng-disabled="campaign.id"\n                                                                min="0"\n                                                                max="100"\n                                                                maxlength="3"\n                                                                placeholder="discount"\n                                                                step="1"\n                                                                data-number-to-fixed="0"\n                                                                data-number-stepfactor="1" required>\n                                                    </div>\n                                                </div>\n                                                <div class="row form-group">\n                                                        <div>\n                                                            <label class="col-sm-3 control-label text-left">Duration</label>\n                                                        </div>\n                                                        <div class="col-sm-9 job-date">\n                                                             <div class="flex-row flex-wrap-xs">\n                                                                <div class="flex-grow-1 box-no-transition datepicker-static bottom-0">\n                                                                    <input ng-model="campaign.startDate" class="form-control"\n                                                                           ng-disabled="campaign.id"\n                                                                           type="date" name="input" data-placeholder="dd/mm/yyyy"\n                                                                           min="2001-12-31"\n                                                                           max="2999-12-31"\n                                                                           data-date=\'{"startView": 2, "openOnMouseFocus": true}\' required/>\n                                                                </div>\n                                                                <div class="flex-basis-xs ms-15">to</div>\n                                                                <div class="flex-grow-1 box-no-transition datepicker-static bottom-0 left-n-136">\n                                                                    <input ng-model="campaign.endDate" class="form-control"\n                                                                          type="date" name="input" data-placeholder="dd/mm/yyyy"\n                                                                           min="{{( campaign.startDate ) ? ( campaign.startDate | date : \'yyyy-MM-dd\') : (now | date : \'yyyy-MM-dd\') }}"\n                                                                           max="2999-12-31"\n                                                                           data-date=\'{"startView": 2, "openOnMouseFocus": true}\' required/>\n                                                                </div>\n                                                            </div>\n                                                        </div>\n                                                    </div>\n                                      \n                                        </div>\n                                        <div class="modal-footer modal-foot">\n                                            <button type="submit"\n                                                    class="btn btn-success btn-lg"\n                                                    ng-disabled="btnDisable"\n                                                    spinning-wheel is-spinning-wheel-active="btnDisable"\n                                            >Save promo code\n                                            </button>\n                                        </div>\n                                    </form>\n                                </div>\n                            </div>\n                        </div>',
            replace: true,
            transclude: true,
            link: function link(scope) {
                scope.campaign = {};

                scope.$watch('campaign.startDate', checkCodeDate);

                function checkCodeDate(startDate) {
                    if (scope.campaign && (!scope.campaign.endDate || startDate > scope.campaign.endDate)) {
                        scope.campaign.endDate = startDate;
                    }
                }
            }
        };
    }
})();

/***/ }),

/***/ "./web/js/components/admin/adminSubscriptionModal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

(function () {
	angular.module('main').directive('subscriptionInfoModal', subscriptionInfoModal);

	subscriptionInfoModal.$inject = [];

	function subscriptionInfoModal() {
		return {
			restrict: 'E',
			scope: {
				user: '=',
				currentPlan: '<',
				userLocal: '<',
				btnDisable: '<',
				remainingTime: '<',
				giveFreeMonths: '&'
			},
			template: '<div id="subscriptionModal" class="modal modal-center fade" data-backdrop="static" data-keyboard="false">\n                            <div class="modal-dialog">\n                                <div class="modal-content">\n                                    <div class="modal-header">\n                                        <btn-close></btn-close>\n                                        <h3 class="modal-title">Free Access</h3>\n                                    </div>\n                                    <div class="modal-body clearfix">\n                                    \t<div class="free-access-block">\n\t\t\t\t\t\t\t\t\t\t\t<div class="text-nowrap user-info-block">\n\t\t\t\t\t\t\t\t\t\t\t\t<h4>User: <span>{{user.userInfo.userName}}</span></h4>\n\t\t\t\t\t\t\t\t\t\t\t\t<div ng-show="!user.currentPlan" class="expired btn-danger">EXPIRED</div>\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t<div class="text-nowrap user-info-block">\n\t\t\t\t\t\t\t\t\t\t\t\t<h4>Email: <span>{{user.userInfo.userEmail}}</span></h4>\t\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t</div>     \n\t\t\t\t\t\t\t\t\t\t\t<div class="text-nowrap user-info-block" ng-if="remainingTime"> \n\t\t\t\t\t\t\t\t\t\t\t\t<h4>Remaining Free Period: <span>{{remainingTime}} left unused</span></h4>\t\n\t\t\t\t\t\t\t\t\t\t\t</div>         \n\t\t\t\t\t\t\t\t\t\t\t<div ng-if="currentPlan" class="subscription-container admin-subscription mt-15">                       \n\t\t\t\t\t\t\t\t\t\t\t\t<div class="subscription--plan"> \n\t\t\t\t\t\t\t\t\t\t\t\t\t<table class="subscription--plan__table">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<tr ng-repeat="item in currentPlan track by $index" class="t-row">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="t-cell-title">{{ item }}</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="t-cell-info">{{ user.currentPlan.properties[item].description }}\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div ng-show="subscriptionInfo.customerInfo.properties[item].prompt" class="t-cell-info-label">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i aria-hidden="true" class="fa fa-info-circle"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="label label-general label-status label-response label-warning--triangle label-hover">{{ user.currentPlan.properties[item].prompt }}</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</table>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t</div>  \n                                        </div>\n                                        <hr class="mt-5">\n                                        <div class="flex-row flex-just-space-around mt-15">\n\t\t\t\t\t\t\t\t\t\t\t<div class="styled-input-radio pl-30">\n\t\t\t\t\t\t\t\t\t\t\t\t<input type="radio" id="PRORATABLE" value="PRORATABLE" ng-model="freeAccessMethod">\n\t\t\t\t\t\t\t\t\t\t\t\t<label for="PRORATABLE">Free access for active paid subscribers</label>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t<div class="styled-input-radio pl-30">\n\t\t\t\t\t\t\t\t\t\t\t\t<input type="radio" id="INSTANT" value="INSTANT" ng-model="freeAccessMethod">\n\t\t\t\t\t\t\t\t\t\t\t\t<label for="INSTANT">Free access for ambassadors, trial or expired users</label>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t<div class="flex-row mt-15 free-access-description">\n\t\t\t\t\t\t\t\t\t\t\t<span ng-if="freeAccessMethod === \'PRORATABLE\'">This adds free days to an active paid subscriber\u2019s account in the form of a discount on their next invoice. If their subscription plan changes, any unused free days are kept and applied to the next invoice.</span>\n\t\t\t\t\t\t\t\t\t\t\t<span ng-if="freeAccessMethod === \'INSTANT\'">This adds free days to the account of an ambassador, trial or expired user by assigning or extending their free subscription. Avoid using this for active paid subscribers.</span>\n\t\t\t\t\t\t\t\t\t\t</div>\n                                        \n                                        <div class="mt-20">\n                                            <div class="flex-row">\n                                            \t<div class="flex-1 mr-7">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<input id="unitCount" placeholder="Put number of count" class="form-control" type="number"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t   step="any" ng-keypress="onKeypress($event)" ng-disabled="btnDisable"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t   ng-model="setTimeConfiguration.unitCount">\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t <div class="flex-1">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<select class="form-control"  ng-model="setTimeConfiguration.timeUnit" ng-disabled="btnDisable">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<option value="DAY">Day</option>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<option value="MONTH">Month</option>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n                                            </div>\n                                        </div>\n                                    </div>\n                                    <div>\n                                        <div class="modal-footer modal-foot">\n                                            <button class="btn btn-accept btn-lg" ng-disabled="btnDisable" \n                                            \t\tng-click="giveFreeMonths({setTimeConfiguration, userLocal, freeAccessMethod})"\n                                                    spinning-wheel is-spinning-wheel-active="btnDisable">\n                                                Give free access\n                                            </button>\n                                            <button class="btn btn-default btn-lg" ng-disabled="btn_disable" data-dismiss="modal">Cancel</button>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    ',
			replace: true,
			transclude: true,
			link: function link(scope, element) {
				scope.setTimeConfiguration = {
					timeUnit: 'MONTH',
					unitCount: null
				};
				scope.freeAccessMethod = 'PRORATABLE';

				element.on('keypress', function (event) {
					if (event.key === 'e' || event.key === '+' || event.key === '-' || event.key === '.') {
						event.preventDefault();
					}
				});
				$('#subscriptionModal').on('hidden.bs.modal', function () {
					scope.setTimeConfiguration = {
						timeUnit: 'MONTH',
						unitCount: null
					};
					scope.freeAccessMethod = 'PRORATABLE';
				});
			}
		};
	}
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./web/js/components/contract/sendContract.component.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"main-wrapper\" class=\"container\" ng-controller=\"JobContractController\">\n    <div id=\"sendContractModal\" class=\"modal modal-center fade\"\n         data-backdrop=\"static\" data-keyboard=\"false\">\n        <div class=\"modal-dialog\">\n            <div class=\"modal-content\">\n                <form ng-submit=\"sendContractEmail()\" role=\"form\" autocomplete=\"off\">\n                    <div class=\"modal-header\">\n                        <button ng-click=\"modalClose()\" btn-close ></button>\n                        <h3 class=\"modal-title\">Send Contract</h3>\n                    </div>\n                    <div class=\"modal-body\">\n                        <div class=\"field-info\">\n                            <h4 class=\"mt-0\">To</h4>\n                            <div class=\"flex-row\">\n                                <email-field class=\"w-max-100\"\n                                             [placeholder]=\"'myclient@abc.com'\"\n                                             [value]=\"sendMessage.emailTo\"\n                                             [disabled]=\"sendMessage.isDisable\"\n                                             (value-change)=\"setEmailData($event, 'sendMessage', 'emailTo')\">\n                                </email-field>\n                                <button type=\"button\" class=\"btn btn-link color-cc\" ng-show=\"!showCcField && !sendMessage.isDisable\"\n                                        ng-click=\"toggleViewCc()\">Add Cc\n                                </button>\n                            </div>\n                        </div>\n\n                        <div class=\"field-info\" ng-show=\"showCcField\">\n                            <h4>Cc</h4>\n                            <email-field class=\"w-max-100\"\n                                         [placeholder]=\"'another@email.com'\"\n                                         [value]=\"sendMessage.emailCc\"\n                                         (value-change)=\"setEmailData($event, 'sendMessage', 'emailCc')\">\n                            </email-field>\n                        </div>\n\n                        <div class=\"field-info\">\n                            <h4>Choose Email template</h4>\n                            <div class=\"flex-row flex-wrap-xs\">\n                                <div class=\"select-style flex-grow-1 flex-with-full\">\n                                    <select ng-model=\"chosenContractEmail\"\n                                            ng-change=\"setContractEmailTemplate(chosenContractEmail.id)\"\n                                            ng-options=\" contractEmailTemplate as contractEmailTemplate.name for contractEmailTemplate in contractEmailTemplates | orderBy:'name'\"\n                                            ng-disabled=\"button_disable\">\n                                        <option value=\"\" class=\"hide\">Choose Email Template</option>\n                                    </select>\n                                </div>\n                                <button ng-click=\"showNextModal('#sendContractModal', '#editContractModal', $event)\"\n                                        ng-disabled=\"button_disable\"\n                                        class=\"btn btn-default btn-edit btn-edit-md hidden-xs hidden\">\n                                    Edit contract\n                                </button>\n                                <button\n                                        ng-click=\"showNextModal('#sendContractModal', '#editContractModal', $event)\"\n                                        ng-disabled=\"button_disable\"\n                                        class=\"btn btn-default btn-edit btn-edit-sm visible-xs hidden-sm hidden\">\n                                    Edit contract\n                                </button>\n                            </div>\n                        </div>\n\n                        <div class=\"subject-row mt-20\">\n                            <insert-variable class=\"insert-variable\" [variable-list-type]=\"'JOB_MENU_SUBJECT'\" (on-variable-choose)=\"addSubjectVariable($event, 'subject-send-contract')\"></insert-variable>\n                            <div class=\"field-info\">\n                                <h4>Subject</h4>\n                                <div class=\"flex-row\">\n                                    <input id=\"subject-send-contract\" ng-disabled=\"button_disable\" type=\"text\" class=\"form-control\" required\n                                           placeholder=\"Write an awesome subject line. Why not?\" maxlength=\"255\"\n                                           ng-model=\"contractEmailTemplate.subject\">\n                                </div>\n                            </div>\n                        </div>\n\n                        <div class=\"field-info\">\n                            <h4>Message</h4>\n                            <sn-quill-editor-web\n                                [editor-i-d]=\"'send-contract-modal'\"\n                                [init-value]=\"contractEmailTemplate.text\"\n                                [toolbar-settings]=\"'variables attachments color size font'\"\n                                [files-obj]=\"attachmentsDataContract\"\n                                (on-text-change)=\"contractEmailTemplate.text = $event\">\n                            </sn-quill-editor-web>\n                        </div>\n\n                    </div>\n                    <div class=\"modal-footer modal-foot\">\n                        <button type=\"submit\" class=\"btn btn-success btn-lg\" ng-disabled=\"disableBtnOnSend\"\n                                spinning-wheel is-spinning-wheel-active=\"isSendContractSpinnningWheelActive\">Send contract </button>\n                    </div>\n                </form>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),

/***/ "./web/js/components/contract/sendContract.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
	angular.module('main').directive('sendContractModal', sendContractModal);

	sendContractModal.$inject = [];

	function sendContractModal() {
		return {
			scope: true,
			template: __webpack_require__("./web/js/components/contract/sendContract.component.html")
		};
	}
})();

/***/ }),

/***/ "./web/js/components/downgradedComponents.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _invoiceUpdateDnd = __webpack_require__("./web/modern/components/invoices/invoice-update/invoice-update-dnd/invoice-update-dnd.ts");

var _quoteUpdate = __webpack_require__("./web/modern/components/quotes/quote-update/quote-update.ts");

var _quoteSummaryBlock = __webpack_require__("./web/modern/components/quotes/common/quote-summary-block/quote-summary-block.ts");

var _upgradeHelper = __webpack_require__("./web/upgrade/upgradeHelper.ts");

var _snLabel = __webpack_require__("./shared/components/common/sn-label/sn-label.ts");

var _snWarning = __webpack_require__("./shared/components/common/sn-warning/sn-warning.ts");

var _settingsBtn = __webpack_require__("./web/modern/components/buttons/settings-btn/settings-btn.ts");

var _btnSubscription = __webpack_require__("./web/modern/components/buttons/btn-subscription/btn-subscription.ts");

var _jobClient = __webpack_require__("./web/modern/components/client/job-client/job-client.ts");

var _sendBtn = __webpack_require__("./web/modern/components/buttons/send-btn/send-btn.ts");

var _editBtn = __webpack_require__("./web/modern/components/buttons/edit-btn/edit-btn.ts");

var _enableGdprSection = __webpack_require__("./web/modern/components/settings/gdpr/enable-gdpr-section/enable-gdpr-section.ts");

var _closeBtn = __webpack_require__("./shared/components/common/buttons/close-btn/close-btn.ts");

var _clientCard = __webpack_require__("./web/modern/components/client/client-card/client-card.ts");

var _deleteBtn = __webpack_require__("./web/modern/components/buttons/delete-btn/delete-btn.ts");

var _subscribeClientBtn = __webpack_require__("./web/modern/components/buttons/subscribe-client-btn/subscribe-client-btn.ts");

var _optInAgreement = __webpack_require__("./shared/components/common/opt-in-agreement/opt-in-agreement.ts");

var _collapsePanel = __webpack_require__("./web/modern/components/common/collapse-panel/collapse-panel.component.ts");

var _enableClientsOptIn = __webpack_require__("./web/modern/components/client/enable-clients-opt-in/enable-clients-opt-in.ts");

var _clientPhoto = __webpack_require__("./web/modern/components/client/client-photo/client-photo.ts");

var _resubscribeClientModal = __webpack_require__("./web/modern/components/client/modals/resubscribe-client-modal/resubscribe-client-modal.ts");

var _uploadPhotoModal = __webpack_require__("./web/modern/components/client/modals/upload-photo-modal/upload-photo-modal.ts");

var _contractSignature = __webpack_require__("./web/modern/components/contract/contract-signature/contract-signature.ts");

var _questionnaireSubmittedStatement = __webpack_require__("./shared/components/common/questionnaire-submitted-statement/questionnaire-submitted-statement.ts");

var _saveOptinConsentModal = __webpack_require__("./shared/components/base/client/modals/save-optin-consent-modal/save-optin-consent-modal.ts");

var _termsUpdatedModal = __webpack_require__("./web/modern/components/common/terms-updated-modal/terms-updated-modal.ts");

var _workflowExitModal = __webpack_require__("./web/modern/components/settings/workflow-exit-modal/workflow-exit-modal.ts");

var _warningSignImg = __webpack_require__("./shared/components/common/warning-sign-img/warning-sign-img.ts");

var _searchbar = __webpack_require__("./web/modern/components/common/searchbar/searchbar.ts");

var _snPagination = __webpack_require__("./web/modern/components/common/sn-pagination/sn-pagination.ts");

var _consentList = __webpack_require__("./web/modern/components/client/consent-list/consent-list.ts");

var _archiveBtn = __webpack_require__("./web/modern/components/buttons/archive-btn/archive-btn.ts");

var _cancelBtn = __webpack_require__("./mobile/src/components/buttons/cancel-btn/cancel-btn.ts");

var _errorMessageModal = __webpack_require__("./web/modern/components/common/error-message-modal/error-message-modal.ts");

var _autocompeteEmailInput = __webpack_require__("./web/modern/components/inputs/autocomplete-email-input/autocompete-email-input.ts");

var _attachments = __webpack_require__("./mobile/src/components/files/attachments/attachments.ts");

var _eventTypeRow = __webpack_require__("./web/modern/components/common/event-type-row/event-type-row.ts");

var _addRoundBtn = __webpack_require__("./web/modern/components/buttons/add-round-btn/add-round-btn.ts");

var _simplePagination = __webpack_require__("./web/modern/components/buttons/simple-pagination/simple-pagination.ts");

var _shootsAppointmentsBlock = __webpack_require__("./web/modern/components/dashboard/shoots-appointments-block/shoots-appointments-block.ts");

var _recentLeadsBlock = __webpack_require__("./web/modern/components/dashboard/recent-leads-block/recent-leads-block.ts");

var _deleteLeadModal = __webpack_require__("./web/modern/components/leads/modals/delete-lead-modal/delete-lead-modal.ts");

var _upcomingPaymentsBlock = __webpack_require__("./web/modern/components/dashboard/upcoming-payments-block/upcoming-payments-block.ts");

var _recordPaymentModal = __webpack_require__("./web/modern/components/payments/modals/record-payment-modal/record-payment-modal.ts");

var _writeOffModal = __webpack_require__("./web/modern/components/payments/modals/write-off-modal/write-off-modal.ts");

var _dragAndDropBlock = __webpack_require__("./web/modern/components/dashboard/drag-and-drop-block/drag-and-drop-block.ts");

var _graphsBlock = __webpack_require__("./web/modern/components/dashboard/graphs-block/graphs-block.ts");

var _jobTaskBlock = __webpack_require__("./web/modern/components/dashboard/job-task-block/job-task-block.ts");

var _deleteJobModal = __webpack_require__("./web/modern/components/jobs/modals/delete-job-modal/delete-job-modal.ts");

var _uploadComponent = __webpack_require__("./web/modern/components/common/upload-component/upload-component.ts");

var _proselectUploadComponent = __webpack_require__("./web/modern/components/common/proselect-upload-component/proselect-upload-component.ts");

var _packageInfoPanel = __webpack_require__("./web/modern/components/quotes/package-info-panel/package-info-panel.component.ts");

var _priceTag = __webpack_require__("./web/modern/components/price-tag/price-tag.component.ts");

var _quoteView = __webpack_require__("./web/modern/components/quote/quote-view/quote-view.ts");

var _printBtn = __webpack_require__("./web/modern/components/buttons/print-btn/print-btn.ts");

var _modalDeleteQuote = __webpack_require__("./web/modern/components/quote/modals/modal-delete-quote/modal-delete-quote.ts");

var _modalSendQuote = __webpack_require__("./web/modern/components/quote/modals/modal-send-quote/modal-send-quote.ts");

var _productPackagesBlock = __webpack_require__("./web/modern/components/packages-product/packages-product-block/product-packages-block.component.ts");

var _productDetailsModal = __webpack_require__("./web/modern/components/quotes/modals/product-details-modal/product-details-modal.component.ts");

var _addonsTable = __webpack_require__("./web/modern/components/quotes/addons-table/addons-table.component.ts");

var _productPackageTable = __webpack_require__("./web/modern/components/quotes/product-package-table/product-package-table.ts");

var _addNewElementBtn = __webpack_require__("./web/modern/components/buttons/add-new-element-btn/add-new-element-btn.component.ts");

var _addQuoteTypeModal = __webpack_require__("./web/modern/components/quotes/modals/add-quote-type-modal/add-quote-type-modal.component.ts");

var _reSyncBtn = __webpack_require__("./web/modern/components/buttons/re-sync-btn/re-sync-btn.ts");

var _invoiceView = __webpack_require__("./web/modern/components/invoices/invoice-view/invoice-view.ts");

var _invoiceUpdate = __webpack_require__("./web/modern/components/invoices/invoice-update/invoice-update.ts");

var _galleryViewBlock = __webpack_require__("./web/modern/components/integrations/connect-galleries/gallery-view-block/gallery-view-block.component.ts");

var _profile = __webpack_require__("./web/modern/components/settings/profile/profile.ts");

var _invoicesViewBlock = __webpack_require__("./web/modern/components/invoices/invoices-view-block/invoices-view-block.component.ts");

var _paymentsOverview = __webpack_require__("./web/modern/components/payments/payments-overview/payments-overview.component.ts");

var _subscriptionAnnouncementBanner = __webpack_require__("./web/modern/components/subscription/subscription-announcement-banner/subscription-announcement-banner.ts");

var _subscriptionChoosePlan = __webpack_require__("./web/modern/components/subscription/subscription-choose-plan/subscription-choose-plan.ts");

var _snQuillEditorWeb = __webpack_require__("./web/modern/components/common/sn-quill-editor/sn-quill-editor-web.ts");

var _contactFormSection = __webpack_require__("./web/modern/components/settings/contact-form-section/contact-form-section.ts");

var _questionnaireSection = __webpack_require__("./web/modern/components/settings/questionnaire-section/questionnaire-section.ts");

var _settingSectionHeader = __webpack_require__("./web/modern/components/settings/common/setting-section-header/setting-section-header.ts");

var _settingSectionDescription = __webpack_require__("./web/modern/components/settings/common/setting-section-description/setting-section-description.ts");

var _emailReplyModal = __webpack_require__("./web/modern/components/settings/email-settings-section/modals/email-reply-modal/email-reply-modal.component.ts");

var _settingsOverview = __webpack_require__("./web/modern/components/settings/settings-overview/settings-overview.component.ts");

var _settingsNavigation = __webpack_require__("./web/modern/components/settings/settings-overview/settings-navigation/settings-navigation.component.ts");

var _userNavbar = __webpack_require__("./web/modern/components/navbar/user-navbar/user-navbar.component.ts");

var _editCompanySection = __webpack_require__("./web/modern/components/settings/edit-company-section/edit-company-section.ts");

var _companiesSection = __webpack_require__("./web/modern/components/settings/companies-section/companies-section.component.ts");

var _dateTimeCalendar = __webpack_require__("./web/modern/components/settings/date-time-calendar/date-time-calendar.ts");

var _customizeLabels = __webpack_require__("./web/modern/components/settings/customize-labels/customize-labels.ts");

var _exportJobsModal = __webpack_require__("./web/modern/components/jobs/modals/export-jobs-modal/export-jobs-modal.ts");

var _exportLeadsModal = __webpack_require__("./web/modern/components/leads/modals/export-leads-modal/export-leads-modal.ts");

var _questionnaire = __webpack_require__("./web/modern/components/questionnaire/questionnaire.ts");

var _smtpModal = __webpack_require__("./web/modern/components/settings/email-settings-section/modals/smtp-modal/smtp-modal.component.ts");

var _jobFileSection = __webpack_require__("./web/modern/components/jobs/sections/job-file-section/job-file-section.component.ts");

var _editContractButton = __webpack_require__("./web/modern/components/jobs/modals/edit-contract-button/edit-contract-button.ts");

var _saveContractPdf = __webpack_require__("./web/modern/components/jobs/modals/save-contract-pdf/save-contract-pdf.ts");

var _downloadLog = __webpack_require__("./web/modern/components/jobs/modals/download-log/download-log.ts");

var _snQuillViewWeb = __webpack_require__("./web/modern/components/common/sn-quill-view/sn-quill-view-web.ts");

var _integrateWithXeroV2Modal = __webpack_require__("./web/modern/components/settings/integrations-section/modals/integrate-with-xero-v2/integrate-with-xero-v2-modal.ts");

var _manageUser2faModal = __webpack_require__("./web/modern/components/2fa/modals/manage-user-2fa-modal/manage-user-2fa-modal.ts");

var _integrationsSection = __webpack_require__("./web/modern/components/settings/integrations-section/integrations-section.ts");

var _leadSourcesSection = __webpack_require__("./web/modern/components/settings/lead-sources-section/lead-sources-section.ts");

var _leadSourceColor = __webpack_require__("./shared/components/common/lead-source-color/lead-source-color.ts");

var _invoiceNumbering = __webpack_require__("./web/modern/components/settings/invoice-payments-section/components/invoice-numbering/invoice-numbering.component.ts");

var _insertVariable = __webpack_require__("./shared/components/common/buttons/insert-variable/insert-variable.component.ts");

var _emailField = __webpack_require__("./web/modern/components/common/email-field/email-field.component.ts");

var _togglePassword = __webpack_require__("./shared/components/common/toggle-password/toggle-password.component.ts");

var _subscriptionInfoBtn = __webpack_require__("./web/modern/components/admin/subscription-info/subscription-info-btn.ts");

var _doubleBooking = __webpack_require__("./web/modern/components/common/double-booking/double-booking.ts");

var _eventsOverlappingInfo = __webpack_require__("./web/modern/components/common/double-booking/events-overlapping-info/events-overlapping-info.component.ts");

var _qtTemplatesUpdate = __webpack_require__("./web/modern/components/settings/quote-invoice-templates/qt-templates-update/qt-templates-update.component.ts");

var _qtTemplates = __webpack_require__("./web/modern/components/settings/quote-invoice-templates/qt-templates/qt-templates.component.ts");

var _notificationBar = __webpack_require__("./web/modern/components/notification-bar/notification-bar.ts");

var _reportsOverview = __webpack_require__("./web/modern/components/admin/report/overview/reports-overview.component.ts");

var _signupCheckEmail = __webpack_require__("./web/modern/components/login/signup-check-email/signup-check-email.component.ts");

var _tabsPanel = __webpack_require__("./web/modern/components/common/tabs-panel/tabs-panel.component.ts");

var _tab = __webpack_require__("./web/modern/components/common/tabs-panel/tab.component.ts");

var _paymentMethods = __webpack_require__("./web/modern/components/settings/payment-methods/payment-methods.component.ts");

var _paymentSchedulesModal = __webpack_require__("./web/modern/components/settings/payment-schedules/modals/payment-schedules-modal/payment-schedules-modal.ts");

var moduleName = 'main';

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'autocompleteEmailInput', _autocompeteEmailInput.AutocompleteEmailInputComponent, {
	inputs: ['isRequired', 'isDisabled', 'placeholder', 'defaultValue'],
	outputs: ['actionGetEmail']
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'uploadComponent', _uploadComponent.UploadComponent, {
	inputs: ['classComponent', 'placeHolder', 'disabled', 'fileType', 'componentId'],
	outputs: ['action']
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'togglePassword', _togglePassword.TogglePassword, {
	inputs: []
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'proselectUploadComponent', _proselectUploadComponent.ProselectUploadComponent, {
	inputs: ['classComponent', 'placeHolder', 'disabled', 'fileType', 'componentId'],
	outputs: ['action']
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'snLabel', _snLabel.SnLabelComponent, {
	inputs: ['text', 'color']
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'settingsNavigation', _settingsNavigation.SettingsNavigationComponent, {
	inputs: []
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'settingsOverview', _settingsOverview.SettingsOverviewComponent, {
	inputs: []
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'companiesSection', _companiesSection.CompaniesSectionComponent, {
	inputs: []
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'jobTaskBlock', _jobTaskBlock.JobTaskBlockComponent, {
	outputs: ['editJobModalTrigger']
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'btnSubscription', _btnSubscription.BtnSubscriptionComponent, {
	inputs: ['status']
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'snQuillEditorWeb', _snQuillEditorWeb.SnQuillEditorWebComponent, {
	inputs: ['varsList', 'filesObj', 'initValue', 'maxLength', 'placeholder', 'editorID', 'styles', 'toolbarSettings', 'imageLoadHandler'],
	outputs: ['onAttachmentsChange', 'onTextChange', 'onTextLengthChange']
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'snWarning', _snWarning.SnWarningComponent, {
	inputs: ['warningClass']
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'settingsBtn', _settingsBtn.SettingsBtnComponent, {
	inputs: ['text', 'isDisabled']
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'archiveBtn', _archiveBtn.ArchiveBtnComponent, {
	inputs: ['text'],
	outputs: ['action']
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'paymentsOverview', _paymentsOverview.PaymentsOverviewComponent, {
	inputs: [],
	outputs: ['openSendReceiptModalEvent']
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'resubscribeClientModal', _resubscribeClientModal.ResubscribeClientModalWebComponent, {
	inputs: ['client'],
	outputs: ['successResubscribeClient', 'cancelResubscribeClient']
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'invoicesViewBlock', _invoicesViewBlock.InvoicesViewBlockComponent, {
	inputs: ['jobId', 'leadId', 'isArchived'],
	outputs: ['sendInvoiceEvent', 'createNewInvoiceEvent', 'updateViewEvent']
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'errorMessageModal', _errorMessageModal.ErrorMessageModalWebComponent, {
	inputs: ['title', 'errorMessage'],
	outputs: []
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'galleryViewBlock', _galleryViewBlock.GalleryViewBlockComponent, {
	inputs: ['job'],
	outputs: []
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'jobClient', _jobClient.JobClientComponent, {
	inputs: ['client', 'type'],
	outputs: ['onEdit', 'onSend', 'onClientUpdate']
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'sendBtn', _sendBtn.SendBtnComponent, {
	inputs: ['text'],
	outputs: []
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'editBtn', _editBtn.EditBtnComponent, {
	inputs: ['text', 'isEmpty', 'isLink', 'linkHref', 'isDisabled', 'addClass']
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'clientPhoto', _clientPhoto.ClientPhotoWebComponent, {
	inputs: ['isPhoto', 'clientId']
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'enableGdprSection', _enableGdprSection.EnableGdprSectionComponent, {
	inputs: ['gdprChecked'],
	outputs: ['enableGdbr']
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'uploadPhotoModal', _uploadPhotoModal.UploadPhotoModalWebComponent, {
	inputs: [],
	outputs: []
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'closeBtn', _closeBtn.CloseBtnComponent, {
	inputs: [],
	outputs: ['action']
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'clientCard', _clientCard.ClientCardComponent, {
	inputs: ['client', 'gdprEnabled'],
	outputs: ['onEdit', 'onSubscribe', 'onDelete']
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'deleteBtn', _deleteBtn.DeleteBtnComponent, {
	inputs: ['text', 'isEmpty', 'isDisabled'],
	outputs: []
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'collapsePanel', _collapsePanel.CollapsePanelComponent, {
	inputs: ['title', 'isOpen', 'noCollapsing'],
	outputs: ['toggle']
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'subscribeClientBtn', _subscribeClientBtn.SubscribeClientBtnComponent, {
	inputs: ['status', 'isEmpty', 'isDisabled'],
	outputs: []
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'enableClientsOptIn', _enableClientsOptIn.EnableClientsOptInComponent, {
	inputs: ['showOtpInConsent', 'id'],
	outputs: ['showOptIn']
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'saveOptinConsentModal', _saveOptinConsentModal.SaveOptinConsentModalComponent, {
	inputs: ['optinStatement', 'clientId'],
	outputs: ['onSaveOptIn']
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'optInAgreement', _optInAgreement.OptInAgreementComponent, {
	inputs: ['data', 'isOptInDisabled'],
	outputs: ['onOptInChange']
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'contractSignature', _contractSignature.ContractSignatureComponent, {
	inputs: ['contract'],
	outputs: []
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'questionnaireSubmittedStatement', _questionnaireSubmittedStatement.QuestionnaireSubmittedStatementComponent, {
	inputs: ['questionnaire'],
	outputs: []
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'termsUpdatedModal', _termsUpdatedModal.TermsUpdatedModalComponent, {
	inputs: [],
	outputs: ['onDisagree', 'onAgree']
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'workflowExitModal', _workflowExitModal.WorkflowExitModalComponent, {
	inputs: [],
	outputs: []
});
_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'consentList', _consentList.ConsentListWebComponent, {
	inputs: ['consents'],
	outputs: ['deleted']
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'snSearchbar', _searchbar.SearchbarComponent, {
	inputs: ['placeholder'],
	outputs: ['searchChange']
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'snPagination', _snPagination.SnPaginationComponent, {
	inputs: ['pageRequest', 'totalItems', 'pageNumbers'],
	outputs: ['renew']
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'warningSignImg', _warningSignImg.WarningSignImgComponent, {
	inputs: [],
	outputs: []
});
_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'packagesProductBlock', _productPackagesBlock.PackagesProductBlockComponent, {
	inputs: [],
	outputs: []
});
_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'cancelBtn', _cancelBtn.CancelBtnComponent, {
	inputs: [],
	outputs: []
});
_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'shootsAppointmentsBlock', _shootsAppointmentsBlock.ShootsAppointmentsBlockComponent, {
	inputs: ['buttonDisabled', 'spinningWheelActive'],
	outputs: ['chooseModalTrigger']
});
_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'recentLeadsBlock', _recentLeadsBlock.RecentLeadsBlockComponent, {
	inputs: ['buttonDisabled', 'spinningWheelActive'],
	outputs: ['sendEmailModalTrigger', 'editLeadModalTrigger', 'addNewLeadModalTrigger']
});
_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'upcomingPaymentsBlock', _upcomingPaymentsBlock.UpcomingPaymentsBlockComponent, {
	inputs: ['buttonDisabled', 'spinningWheelActive'],
	outputs: []
});
_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'deleteJobModal', _deleteJobModal.DeleteJobModalComponent, {
	inputs: ['jobIdForDelete'],
	outputs: ['updateParentTrigger']
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'exportJobsModal', _exportJobsModal.ExportJobsModalComponent, {
	inputs: [''],
	outputs: ['']
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'deleteLeadModal', _deleteLeadModal.DeleteLeadModalComponent, {
	inputs: ['leadForDelete'],
	outputs: ['updateParentTrigger']
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'exportLeadsModal', _exportLeadsModal.ExportLeadsModalComponent, {
	inputs: [''],
	outputs: ['']
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'jobFileSection', _jobFileSection.JobFileSectionComponent, {
	inputs: ['files', 'archived', 'jobId'],
	outputs: ['updateFilesState']
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'eventTypeRow', _eventTypeRow.EventTypeRowComponent, {
	inputs: ['snFilter', 'eventData'],
	outputs: []
});
_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'addRoundBtn', _addRoundBtn.AddRoundBtnComponent, {
	inputs: ['isActive', 'linkHref'],
	outputs: []
});
_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'reSyncBtn', _reSyncBtn.ReSyncBtnComponent, {
	inputs: ['isActive', 'lastSyncDate'],
	outputs: ['syncEmails']
});
_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'snQuillViewWeb', _snQuillViewWeb.SnQuillWebViewComponent, {
	inputs: ['content']
});
_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'simplePagination', _simplePagination.SimplePaginationComponent, {
	inputs: ['pageRequest', 'totalPages', 'totalItems'],
	outputs: ['changePageTrigger']
});
_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'attachments', _attachments.AttachmentsComponent, {
	inputs: [],
	outputs: []
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'userNavbar', _userNavbar.UserNavbarComponent, {
	inputs: [],
	outputs: []
});
_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'dragAndDropBlock', _dragAndDropBlock.DragAndDropBlockComponent, {
	inputs: ['buttonDisabled', 'addNewLeadSpinningWheel', 'isAddNewSpinnningWheelActive', 'jobTypes'],
	outputs: ['sendEmailModalTrigger', 'editLeadModalTrigger', 'editJobModalTrigger', 'addNewLeadModalTrigger', 'chooseModalTrigger']
});
_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'graphsBlock', _graphsBlock.GraphsBlockComponent, {
	inputs: ['jobTypes'],
	outputs: []
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'recordPaymentModal', _recordPaymentModal.RecordPaymentModalComponent, {
	inputs: ['selectedPayment'],
	outputs: ['updateParent']
});
_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'writeOffModal', _writeOffModal.WriteOffModalComponent, {
	inputs: [],
	outputs: []
});
_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'packageInfoPanel', _packageInfoPanel.PackageInfoPanelComponent, {
	inputs: ['product', 'tax'],
	outputs: ['showAddonDetails']
});
_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'priceTag', _priceTag.PriceTagComponent, {
	inputs: ['price'],
	outputs: []
});
_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'quoteSummaryBlock', _quoteSummaryBlock.QuoteSummaryBlockComponent, {
	inputs: [],
	outputs: []
});
_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'modalDeleteQuote', _modalDeleteQuote.ModalDeleteQuoteComponent, {
	inputs: ['jobId', 'leadId', 'quoteId', 'isLead']
});
_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'quoteUpdate', _quoteUpdate.QuoteUpdateComponent, {
	inputs: ['idToGetQuote', 'isJob', 'quoteId', 'quoteType'],
	outputs: []
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'quoteView', _quoteView.QuoteViewComponent, {
	inputs: ['quoteId', 'jobId', 'data'],
	outputs: ['showSendModal']
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'invoiceView', _invoiceView.InvoiceViewComponent, {
	inputs: ['invoiceId', 'sendReceiptSpinner'],
	outputs: ['sendMail', 'getContactEmail']
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'printBtn', _printBtn.PrintBtnComponent, {
	inputs: [],
	outputs: []
});
_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'modalSendQuote', _modalSendQuote.ModalSendQuoteComponent, {
	inputs: ['sendMessageData'],
	outputs: []
});
_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'productDetailsModal', _productDetailsModal.ProductDetailsModalComponent, {
	inputs: ['product'],
	outputs: []
});
_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'addonsTable', _addonsTable.AddonsTableComponent, {
	inputs: ['addons'],
	outputs: []
});
_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'addNewElementBtn', _addNewElementBtn.AddNewElementBtnComponent, {
	inputs: ['icon', 'imgSrc', 'title', 'description'],
	outputs: ['onBtnClicked']
});
_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'addQuoteTypeModal', _addQuoteTypeModal.AddQuoteTypeModalComponent, {
	inputs: [],
	outputs: ['onQuoteTypeSelected']
});
_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'invoiceUpdateDnd', _invoiceUpdateDnd.InvoiceUpdateDnd, {
	inputs: ['products', 'companyCurrencyAndTaxes', 'productsNames'],
	outputs: []
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'productPackageTable', _productPackageTable.ProductPackageTableComponent, {
	inputs: ['data', 'currencySymbol', 'summary'],
	outputs: []
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'invoiceUpdate', _invoiceUpdate.InvoiceUpdateComponent, {
	inputs: ['dataToGetInvoice'],
	outputs: []
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'contactFormSection', _contactFormSection.ContactFormSectionComponent);

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'questionnaireSection', _questionnaireSection.QuestionnaireSectionComponent);

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'dateTimeCalendar', _dateTimeCalendar.DateTimeCalendarComponent);

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'customizeLabels', _customizeLabels.CustomizeLabelsComponent);

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'emailReplyModal', _emailReplyModal.EmailReplyModalComponent, {
	inputs: ['emailData', 'disableBtn'],
	outputs: ['onSaveSettings', 'onModalClose']
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'profile', _profile.ProfileComponent, {
	inputs: [],
	outputs: []
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'subscription-announcement-banner', _subscriptionAnnouncementBanner.SubscriptionAnnouncementBannerComponent, {
	inputs: [],
	outputs: []
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'subscription-choose-plan', _subscriptionChoosePlan.SubscriptionChoosePlanComponent, {
	inputs: [],
	outputs: []
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'settingSectionHeader', _settingSectionHeader.SettingSectionHeaderComponent, {
	inputs: ['breadcrumbs'],
	outputs: []
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'settingSectionDescription', _settingSectionDescription.SettingSectionDescriptionComponent, {
	inputs: ['text'],
	outputs: []
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'editCompanySection', _editCompanySection.EditCompanySectionComponent, {
	inputs: ['companyId'],
	outputs: []
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'questionnaire', _questionnaire.QuestionnaireComponent, {
	inputs: ['jobId', 'questionnaireId', 'companyImageSrc'],
	outputs: ['questionnaireSend', 'questionnaireDelete']
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'smtpModal', _smtpModal.SmtpModalComponent, {
	inputs: ['smtpData'],
	outputs: ['onSaveSmtp']
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'integrationsSection', _integrationsSection.IntegrationsSection, {
	inputs: ['routeParams'],
	outputs: ['']
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'editContractButton', _editContractButton.EditContractButton, {
	inputs: ['contract'],
	outputs: ['reInitContract']
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'saveContractPdf', _saveContractPdf.SaveContractPdf, {
	inputs: ['contract'],
	outputs: ['']
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'downloadLog', _downloadLog.DownloadLog, {
	inputs: ['contract'],
	outputs: ['']
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'integrateWithXeroNewModal', _integrateWithXeroV2Modal.IntegrateWithXeroV2Modal, {
	inputs: ['connectionsData'],
	outputs: ['xeroConnectState']
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'manageUserTwoFa', _manageUser2faModal.ManageUser2faModal, {
	inputs: ['twoFaInfo', 'businessAccountId'],
	outputs: ['closeModal']
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'leadSourcesSection', _leadSourcesSection.LeadSourcesSectionComponent, {
	inputs: [],
	outputs: []
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'leadSourceColor', _leadSourceColor.LeadSourceColorComponent, {
	inputs: ['color', 'borderShadePercentage'],
	outputs: []
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'invoiceNumbering', _invoiceNumbering.InvoiceNumberingComponent, {
	inputs: [],
	outputs: []
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'insertVariable', _insertVariable.InsertVariableComponent, {
	inputs: ['variableListType'],
	outputs: ['onVariableChoose']
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'emailField', _emailField.EmailFieldComponent, {
	inputs: ['value', 'disabled', 'placeholder'],
	outputs: ['valueChange']
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'subscriptionInfoBtn', _subscriptionInfoBtn.SubscriptionInfoBtn, {
	inputs: ['user'],
	outputs: ['isDisabled']
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'doubleBooking', _doubleBooking.DoubleBookingComponent, {
	inputs: ['doubleBooking'],
	outputs: []
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'eventsOverlappingInfo', _eventsOverlappingInfo.EventsOverlappingInfoComponent, {
	inputs: ['data'],
	outputs: []
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'qtTemplates', _qtTemplates.QtTemplatesComponent, {
	inputs: [],
	outputs: []
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'qtTemplatesUpdate', _qtTemplatesUpdate.QtTemplatesUpdateComponent, {
	inputs: ['templateId', 'templateType', 'templateAction'],
	outputs: []
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'saveNewTemplateModal', {
	inputs: ['templateTypeName', 'btnDisable', 'breadcrumbsText'],
	outputs: ['closeModal']
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'notificationBar', _notificationBar.NotificationBarComponent, {
	inputs: ['isShowNotificationBar'],
	outputs: ['isShowNotificationBar']
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'reportsOverview', _reportsOverview.ReportsOverviewComponent, {
	inputs: []
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'signupCheckEmail', _signupCheckEmail.SignupCheckEmailComponent, {
	inputs: ['firstName', 'textHtml', 'titleHtml']
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'tabsPanel', _tabsPanel.TabsPanel, {
	inputs: []
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'tabComponent', _tab.TabComponent, {
	inputs: ['tabTitle', 'highlight']
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'paymentMethods', _paymentMethods.PaymentMethods, {
	inputs: []
});

_upgradeHelper.HybridHelper.downgradeComponent(moduleName, 'paymentSchedulesModal', _paymentSchedulesModal.PaymentSchedulesModalComponent, {
	inputs: ['title', 'paymentSchedule'],
	outputs: ['saved', 'error']
});

/***/ }),

/***/ "./web/js/components/fileModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('main').directive('fileModel', ['$parse', function ($parse) {
	return {
		restrict: 'A',
		link: function link(scope, element, attrs) {
			var model = $parse(attrs.fileModel);
			var modelSetter = model.assign;
			element.bind('change', function () {
				scope.file_name = element[0].files[0].name;
				console.log(element[0].files[0].name);
				scope.$apply(function () {
					modelSetter(scope, element[0].files[0]);
				});
			});
		}
	};
}]);

/***/ }),

/***/ "./web/js/components/home/adminHome.component.html":
/***/ (function(module, exports) {

module.exports = "<section id=\"main-wrapper\" class=\"new-container container--full-height bg-white\" ng-class=\"{'disable-buttons': isDisabled}\">\n\n    <div ng-show=\"synchronization\"\n         style=\"display: flex; position: fixed; left: 0; right: 0; top: 0; bottom: 0; z-index: 9999999; background: rgba(0, 0, 0, 0.25);\">\n        <img src=\"https://app.studioninja.co/build/release-pipeline-119/resources/dist/assets/images/preloader/reload.GIF\" alt=\"Loading...\" style=\"margin:auto;\">\n    </div>\n\n    <div class=\"col-xs-12\">\n\n        <div class=\"flex-row flex-wrap-xs flex-just-space btns-full-xm mt-10\">\n            <h2>Members </h2>\n\n            <sn-searchbar [placeholder]=\"Search\" (search-change)=\"searchRequest($event)\"></sn-searchbar>\n\n        </div>\n\n        <div class=\"table-responsive mt-10\">\n            <table class=\"table table-hover table-clients-overview\">\n                <thead>\n                <tr class=\"invoice-thead\">\n                    <th class=\"w-min-120\">\n                        <b ng-click=\"order('firstName')\" class=\"pointer text-nowrap\">First name</b>\n                        <span class=\"fa\" ng-show=\"pageRequest.sortCriteria.fieldName === 'firstName'\"\n                              ng-class=\"pageRequest.sortCriteria.sortAscending ? 'fa-caret-down' : 'fa-caret-up'\">\n                        </span>\n                    </th>\n                    <th class=\"w-min-120\">\n                        <b ng-click=\"order('lastName')\" class=\"pointer text-nowrap\">Last name</b>\n                        <span class=\"fa\" ng-show=\"pageRequest.sortCriteria.fieldName === 'lastName'\"\n                              ng-class=\"pageRequest.sortCriteria.sortAscending ? 'fa-caret-down' : 'fa-caret-up'\">\n                        </span>\n                    </th>\n                    <th class=\"w-min-80\">\n                        <b ng-click=\"order('email')\" class=\"pointer\">Email</b>\n                        <span class=\"fa\" ng-show=\"pageRequest.sortCriteria.fieldName === 'email'\"\n                              ng-class=\"pageRequest.sortCriteria.sortAscending ? 'fa-caret-down' : 'fa-caret-up'\">\n                        </span>\n                    </th>\n                    <th class=\"w-min-160\">\n                        <b>Subscription Type</b>\n                        <span class=\"fa\" ng-show=\"pageRequest.sortCriteria.fieldName === 'subscriptionPlan'\"\n                              ng-class=\"pageRequest.sortCriteria.sortAscending ? 'fa-caret-down' : 'fa-caret-up'\">\n                        </span>\n                    </th>\n                    <th><b ng-click=\"order('phone')\" class=\"pointer\">Phone</b>\n                        <span class=\"fa\" ng-show=\"pageRequest.sortCriteria.fieldName === 'phone'\"\n                              ng-class=\"pageRequest.sortCriteria.sortAscending ? 'fa-caret-up' : 'fa-caret-down'\">\n                        </span>\n                    </th>\n                    <th width=\"10%\">\n                    </th>\n                    <th>\n                    </th>\n                </tr>\n                </thead>\n                <tbody>\n                <tr ng-repeat=\"user in usersData track by $index\">\n                    <td>{{user.firstName}}</td>\n                    <td>{{user.lastName}}</td>\n                    <td>{{user.email}}</td>\n                    <td>{{user.subscriptionPlan != null ? user.subscriptionPlan :\n                        'TRIAL'}}\n                    </td>\n                    <td>{{user.phone}}</td>\n                    <td class=\"text-nowrap text-right\">\n                        <subscription-info-btn [user]=\"user\" (is-disabled)=\"checkDisableButtons($event)\"></subscription-info-btn>\n                    </td>\n                    <td class=\"text-nowrap text-right margin-td\">\n                        <div class=\"dropdown pointer\">\n                            <div class=\" dropdown-toggle\" data-toggle=\"dropdown\" ng-click=\"getElement($index)\" id=\"dotsMenuJob-{{$index}}\">\n                                <div class=\"dots\"></div>\n                                <div class=\"dots\"></div>\n                                <div class=\"dots\"></div>\n                            </div>\n                            <ul class=\"dropdown-menu dropdown-menu-right dropdown-job-{{$index}} dropdown-menu-job\" role=\"menu\" aria-labelledby=\"dropdownMenu\" id=\"menuIdJob-{{$index}}\">\n                                <li ng-click=\"show2FaModal(user)\"><a href=\"#\">Manage 2FA</a></li>\n                                <li class=\"divider\"></li>\n                                <li ng-click=\"showSubscriptionModal(user)\"><a href=\"#\">Free Access</a></li>\n                                <li class=\"divider\"></li>\n                                <li ng-click=\"showMakeAmbassadorModal(user)\"><a href=\"#\">{{user.subscriptionPlan === 'AMBASSADOR' ? 'View Ambassador' : 'Make Ambassador'}}</a></li>\n                                <li class=\"divider\"></li>\n                                <li ng-click=\"closeAccess(user)\"><a href=\"#\">Close Access</a></li>\n                                <li class=\"divider\"></li>\n                                <li ng-click=\"deleteModal(user)\"><a href=\"#\">Delete Account</a></li>\n                            </ul>\n                        </div>\n                    </td>\n                </tr>\n                </tbody>\n            </table>\n        </div>\n            <sn-pagination [page-request]=\"pageRequest\"\n                           [total-items]=\"totalItems\"\n                           [page-numbers]=\"pageNumbers\"\n                           (renew)=\"getAdminTableData($event)\"\n            ></sn-pagination>\n    </div>\n\n    <div id=\"closeAccessModal\" class=\"modal modal-center fade\" data-backdrop=\"static\" data-keyboard=\"false\">\n        <div class=\"modal-dialog\">\n            <div class=\"modal-content\">\n                <div class=\"modal-header\">\n                    <button class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\">&times;</button>\n                    <h3 class=\"modal-title\">Close access to account</h3>\n                </div>\n                <div class=\"modal-body\">\n                    <p>Are you sure, that you want to close access for <strong>{{closeAccessUser.firstName}} {{closeAccessUser.lastName}}</strong> with\n                        email <strong>{{closeAccessUser.email}}</strong>?</p>\n                </div>\n                <div class=\"modal-footer modal-foot\">\n                    <button class=\"btn btn-danger btn-lg\" ng-click=\"closeAccessRequest(closeAccessUser)\" ng-disabled=\"add_btn_disable\"\n                            spinning-wheel is-spinning-wheel-active=\"isAddSpinningWheelActive\">\n                        Close access\n                    </button>\n                    <button class=\"btn btn-default btn-lg\" data-dismiss=\"modal\">Cancel</button>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div id=\"deleteModal\" class=\"modal modal-center fade\" data-backdrop=\"static\" data-keyboard=\"false\">\n        <div class=\"modal-dialog\">\n            <div class=\"modal-content\">\n                <div class=\"modal-header\">\n                    <button class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\">&times;</button>\n                    <h3 class=\"modal-title\">Delete user</h3>\n                </div>\n                <div class=\"modal-body\">\n                    <p>Are you sure, that you want to delete <strong>{{deleteUser.firstName}} {{deleteUser.lastName}}</strong> with\n                        email <strong>{{deleteUser.email}}</strong>?</p>\n                </div>\n                <div class=\"modal-footer modal-foot\">\n                    <button class=\"btn btn-danger btn-lg\" ng-click=\"deleteRequest(deleteUser)\"\n                            ng-disabled=\"add_btn_disable\" spinning-wheel is-spinning-wheel-active=\"isAddSpinningWheelActive\">\n                        Delete user\n                    </button>\n                    <button class=\"btn btn-default btn-lg\" data-dismiss=\"modal\">Cancel</button>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <subscription-info-modal user=\"subscriptionInfo\" current-plan=\"currentPlan\" btn-disable=\"btn_disable\" user-local=\"userInfoLocal\" remaining-time=\"remainingTime\" give-free-months=\"giveFreeMonths(setTimeConfiguration, userLocal, freeAccessMethod)\"></subscription-info-modal>\n\n    <add-ambassador-code-modal ambassador=\"ambassador\" submit-ambassador-code=\"submitAmbassadorCode(ambassador)\" btn-disable=\"btn_disable\"></add-ambassador-code-modal>\n\n    <manage-user-two-fa [two-fa-info]=\"userTwoFaInfo\" [business-account-id]=\"selectedAccountId\" (close-modal)=\"on2FaModalClose()\"></manage-user-two-fa>\n</section>\n"

/***/ }),

/***/ "./web/js/components/home/adminHome.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
	angular.module('main').component('adminHome', adminHome());

	adminHome.$inject = [];

	function adminHome() {
		return {
			template: __webpack_require__("./web/js/components/home/adminHome.component.html"),
			controller: 'AdminController'
		};
	}
})();

/***/ }),

/***/ "./web/js/components/home/anonymousHome.component.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"row\">\n\t<div class=\"col-md-6 center\">\n\t\t<div ng-show=\"!authenticated\">\n\t\t\t<h2>\n\t\t\t\tPlease <a ng-show=\"!authenticated\" href=\"signup\">Sign Up</a> to use StudioNinja\n\t\t\t</h2>\n\t\t</div>\n\t</div>\n</div>\n"

/***/ }),

/***/ "./web/js/components/home/anonymousHome.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
	angular.module('main').directive('anonymousHome', anonymousHome);

	anonymousHome.$inject = [];

	function anonymousHome() {
		return {
			restrict: 'E',
			replace: true,
			scope: true,
			template: __webpack_require__("./web/js/components/home/anonymousHome.component.html"),
			link: function link() {}
		};
	}
})();

/***/ }),

/***/ "./web/js/components/home/userHome.component.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"container dashboard mt-30\" id=\"main-wrapper\" ng-cloak>\n    <!-- probably not needed script -->\n    <!--<script language=\"JavaScript\" src=\"//js.maxmind.com/js/apis/geoip2/v2.1/geoip2.js\"></script>-->\n\n    <drag-and-drop-block\n        [button-disabled]=\"button_disable\"\n        [add-new-lead-spinning-wheel]=\"addNewLeadSpinningWheel\"\n        [job-types]=\"jobTypes\"\n        [is-add-new-spinning-wheel-active]=\"isAddNewSpinnningWheelActive\"\n        (send-email-modal-trigger)=\"sendEmailModalHandler($event)\"\n        (edit-lead-modal-trigger)=\"editLeadModalHandler($event)\"\n        (add-new-lead-modal-trigger)=\"showAddNewLeadModal()\"\n        (choose-modal-trigger)=\"chooseModalHandler($event)\"\n        (edit-job-modal-trigger)=\"editJobModalHandler($event)\">\n    </drag-and-drop-block>\n\n    <add-calendar-event-modal add-job=\"showAddNewJobModal(event)\"\n                              add-lead=\"showAddNewLeadModal(event)\"\n                              add-extra-shoot=\"addExtraShoot(event)\"\n                              add-appointment=\"appointmentModal(event)\"\n                              disable-buttons=\"button_disable\"\n                              main-shoot-label-name=\"mainShootLabelName\"\n                              extra-shoot-label-name=\"extraShootLabelName\"\n    ></add-calendar-event-modal>\n\n    <update-job-modal\n            update-parent=\"updateJobTasksModel(resetPagination); updateShootsModel(true); updateUpcomingPaymentsModel(resetPagination); updateGraphsModel(['shoots'])\"\n            main-shoot-label-name=\"mainShootLabelName\"\n            extra-shoot-label-name=\"extraShootLabelName\"\n            business-number-label-name=\"businessNumberLabelName\">\n    </update-job-modal>\n    <update-lead-modal\n            update-parent=\"updateRecentLeadsModel(resetPagination); updateShootsModel(true); updateGraphsModel(['leads'])\"\n            main-shoot-label-name=\"mainShootLabelName\"\n            extra-shoot-label-name=\"extraShootLabelName\"\n            business-number-label-name=\"businessNumberLabelName\">\n    </update-lead-modal>\n\n    <add-extra-shoot-modal\n            active-jobs=\"activeJobs\"\n            update-view=\"updateShootsModel(true); updateJobTasksModel(true); updateGraphsModel(['shoots'])\"\n            main-shoot-label-name=\"mainShootLabelName\"\n            extra-shoot-label-name=\"extraShootLabelName\">\n    </add-extra-shoot-modal>\n\n    <add-appointment-modal\n            active-jobs=\"activeJobs\"\n            update-view=\"updateShootsModel(true)\"\n            business-number-label-name=\"businessNumberLabelName\"\n    ></add-appointment-modal>\n\n    <modal-send-mail\n            update-parent=\"updateRecentLeadsModel(resetPagination)\"\n            sn-mail-data=\"mailData2Save\"\n            sn-custom-token=\"'JOB_MENU'\"\n            main-shoot-label-name=\"mainShootLabelName\"\n            extra-shoot-label-name=\"extraShootLabelName\"\n            business-number-label-name=\"businessNumberLabelName\">\n    </modal-send-mail>\n</section>\n\n\n\n"

/***/ }),

/***/ "./web/js/components/home/userHome.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
	angular.module('main').component('userHome', userHome());

	userHome.$inject = [];

	function userHome() {
		return {
			template: __webpack_require__("./web/js/components/home/userHome.component.html"),
			controller: 'HomeController'
		};
	}
})();

/***/ }),

/***/ "./web/js/components/invoice/sendInvoice.component.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"main-wrapper\" class=\"container\" ng-controller=\"InvoiceViewController\">\n    <div id=\"sendInvoiceModal\" class=\"modal modal-center fade\" data-backdrop=\"static\" data-keyboard=\"false\">\n        <div class=\"modal-dialog\">\n            <form role=\"form\" ng-submit=\"sendInvoice()\" autocomplete=\"off\"\n                  class=\"modal-content form-horizontal\">\n                <div class=\"modal-header\">\n                    <btn-close ng-click=\"toggleViewCc(false)\"></btn-close>\n                    <h3 class=\"modal-title\">Send Invoice</h3>\n                </div>\n                <div class=\"modal-body\">\n                    <div class=\"field-info\">\n                        <h4 class=\"mt-0\">To</h4>\n                        <div class=\"flex-row\">\n                            <email-field class=\"w-max-100\"\n                                         [placeholder]=\"'myclient@abc.com'\"\n                                         [value]=\"sendMessage.emailTo\"\n                                         (value-change)=\"setEmailData($event, 'sendMessage', 'emailTo')\">\n                            </email-field>\n                            <button type=\"button\" class=\"btn btn-link color-cc\" ng-show=\"!showCcField\"\n                                    ng-click=\"toggleViewCc()\">Add Cc\n                            </button>\n                        </div>\n                    </div>\n\n                    <div class=\"field-info\" ng-show=\"showCcField\">\n                        <h4>Cc</h4>\n                        <email-field class=\"w-max-100\"\n                                     [placeholder]=\"'another@email.com'\"\n                                     [value]=\"sendMessage.emailCc\"\n                                     (value-change)=\"setEmailData($event, 'sendMessage', 'emailCc')\">\n                        </email-field>\n                    </div>\n\n                    <div class=\"field-info\">\n                        <h4>Choose email template</h4>\n                        <div class=\"flex-row\">\n                            <div class=\"select-style flex-grow-1\">\n                                <select ng-model=\"choosenEmail\" required\n                                        ng-options=\"item as item.name for item in emails | orderBy:'name'\">\n                                    <option value=\"\">Choose an existing email template</option>\n                                </select>\n                            </div>\n                        </div>\n                    </div>\n\n                    <div class=\"subject-row mt-20\">\n                        <insert-variable class=\"insert-variable\" [variable-list-type]=\"'INVOICE_MENU_SUBJECT'\" (on-variable-choose)=\"addSubjectVariable($event, 'subject-send-invoice')\"></insert-variable>\n                        <div class=\"field-info\">\n                            <h4>Subject</h4>\n                            <div class=\"flex-row\">\n                                <input id=\"subject-send-invoice\" ng-disabled=\"button_disable\" type=\"text\" class=\"form-control\" required\n                                       placeholder=\"Write an awesome subject line. Why not?\" maxlength=\"255\"\n                                       ng-model=\"sendMessage.emailSubject\">\n                            </div>\n                        </div>\n                    </div>\n\n\n                    <div class=\"field-info\">\n                        <h4>Message</h4>\n                        <sn-quill-editor-web\n                            [editor-i-d]=\"'send-invoice-modal'\"\n                            [init-value]=\"sendMessage.emailText\"\n                            [toolbar-settings]=\"'variables attachments color size font'\"\n                            [vars-list]=\"'INVOICE_MENU'\"\n                            [files-obj]=\"attachmentsData\"\n                            (on-text-change)=\"sendMessage.emailText = $event\">\n                        </sn-quill-editor-web>\n                    </div>\n\n                    <div class=\"mb-15 pt-6 flex-row flex-basis-full-xs\">\n                        <div class=\"checkbox-squared mt-20\">\n                            <input type=\"checkbox\" id=\"checkbox-squared-send-invoice\"\n                                   ng-model=\"sendMessage.addInvoiceAttachment\"/>\n                            <label for=\"checkbox-squared-send-invoice\"></label>\n                        </div>\n                        <label for=\"checkbox-squared-send-invoice\" class=\"mt-20\">Attach a PDF version of the\n                            invoice</label>\n                    </div>\n                </div>\n                <div class=\"modal-footer modal-foot\">\n                    <button type=\"submit\" class=\"btn btn-success btn-lg\" ng-disabled=\"disableBtnOnSend\"\n                            spinning-wheel is-spinning-wheel-active=\"isSendInvoiceSpinnningWheelActive\">Send Invoice\n                    </button>\n                </div>\n            </form>\n        </div>\n    </div>\n</div>"

/***/ }),

/***/ "./web/js/components/invoice/sendInvoice.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
	angular.module('main').directive('sendInvoiceModal', sendInvoiceModal);

	sendInvoiceModal.$inject = [];

	function sendInvoiceModal() {
		return {
			scope: true,
			template: __webpack_require__("./web/js/components/invoice/sendInvoice.component.html")
		};
	}
})();

/***/ }),

/***/ "./web/js/components/mailList.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
	angular.module('main').directive('mailList', ['$http', '$q', 'messageService', '$filter', '$sce', 'emailService', function ($http, $q, messageService, $filter, $sce, emailService) {
		return {
			restrict: 'E',
			scope: {
				mails: '=',
				setClientMail: '&',
				viewIcon: '=',
				viewFunction: '&'
			},
			template: '\n                <section>\n                    <div class="mailList" ng-show="mails.length > 0">\n                        <div class="table-responsive">\n                            <table class="table table-strip table-mail-status">\n                                <thead class="client_overview_head">\n                                    <tr class="invoice-thead">\n                                        <th>\n                                            <b>Date</b>\n                                        </th>\n                                        <th>\n                                            <b>To</b>\n                                        </th>\n                                        <th>\n                                            <b>Subject</b>\n                                        </th>\n                                        <th width="100"></th>\n                                    </tr>\n                                </thead>\n                                <tbody>\n                                    <tr ng-repeat="mailItem in mails | orderBy track by $index">\n                                        <td class="text-nowrap">{{mailItem.date | timeFilter:\'long\'}}</td>\n                                        <td class="text-nowrap">{{mailItem.toWhom | cutString: 15:mailItem.toWhom}}</td>\n                                        <td>\n                                            <div><strong>{{mailItem.from}}</strong></div>\n                                            <div>{{mailItem.subject}}</div>\n                                            <div ng-if="mailItem.status !=null">\n                                            <div ng-show="mailItem.status===\'sent\'">\n                                                    <span class="label label-orange-email">EMAIL SENT ON {{mailItem.statusOn !==null ? mailItem.statusOn : mailItem.date | timeFilter: \'long\'| uppercase}}</span>\n                                                    </div>\n                    \n                                                     <div ng-show="mailItem.status===\'undelivered\'">\n                                                        <span class="mail-status__{{mailItem.status | lowercase}}">EMAIL UNDELIVERED</span>\n                                                    </div>\n                                                    <div ng-show="mailItem.status===\'clicked\'">\n                                                        <span class="label label-primary">LINK CLICKED ON {{mailItem.statusOn | timeFilter: \'long\'| uppercase}}</span>\n                                                    </div>\n                                                    <div ng-show="mailItem.status===\'opened\'">\n                                                        <span class="label label-info">EMAIL OPENED ON {{mailItem.statusOn | timeFilter: \'long\'| uppercase}}</span>\n                                                    </div>\n                                                    </div>\n                                        </td>\n                                        <td>\n                                            <btn-view ng-click="getJobMailInfo(mailItem.id)"></btn-view>\n                                        </td>\n                                    </tr>\n                                </tbody>\n                            </table>\n                        </div>\n                    </div>\n              </section>',
			replace: true,
			transclude: true,
			link: function link(scope) {
				scope.getJobMailInfo = function (jobMailId) {
					$http({
						method: 'GET',
						url: '/protected/rest/jobs/job/mail/?id=' + jobMailId
					}).then(function (email) {
						return setMailData(email);
					}).then(function (mailAssets) {
						return showReply(mailAssets);
					}).catch(function (err) {
						if (err) {
							messageService.showDefaultErrorMessage(err);
						}
					});
				};

				function setMailData(result) {
					var deferred = $q.defer();

					if (!result.data || result.data.errorMessage) {
						deferred.reject(result.data ? result.data.errorMessage : null);
						return deferred.promise;
					}

					scope.jobMailData = result.data;
					scope.jobMailData.validMsg = true;

					// reply has't status, so we just show mail
					if (scope.jobMailData.status) {
						if (scope.jobMailData.to) {
							scope.jobMailData.to = parseEmail(scope.jobMailData.to);
						}
						if (scope.jobMailData.cc) {
							scope.jobMailData.cc = parseEmail(scope.jobMailData.cc);
						}
						scope.setClientMail({
							clientMail: null,
							jobMail: scope.jobMailData
						});
						$('#mailInfoModal').modal('show');
						deferred.resolve();
						return deferred.promise;
					}

					// fetch templates to write reply on client's reply
					return $q.all([$http.get('/protected/rest/email_templates/get/general'), $http.get('/protected/rest/email_templates/signature/get')]);

					function parseEmail(email) {
						return email.split(',').map(function (mail) {
							return mail.trim() + '\n';
						}).join('');
					}
				}

				function showReply(data) {
					if (Array.isArray(data)) {
						var _data = _slicedToArray(data, 2),
						    emailTemplates = _data[0],
						    signature = _data[1];

						var mailDataClient = setReplyData(scope.jobMailData, emailTemplates.data, signature.data);
						scope.jobMailData = angular.copy(mailDataClient);
						scope.setClientMail({
							clientMail: mailDataClient,
							jobMail: scope.jobMailData
						});
						$('#mailInfoModal').modal('show');
					}
				}

				function setReplyData(jobMailData, emailTemplates, signatureData) {
					var subject = jobMailData.subject,
					    to = jobMailData.to,
					    cc = jobMailData.cc,
					    date = jobMailData.date,
					    allFromName = jobMailData.allFromName,
					    text = jobMailData.text;

					var dateFilterSendEmailModal = "EEE, MMM dd, yyyy 'at' HH:mm a";
					var data = $filter('date')(date, dateFilterSendEmailModal);

					var mailDataClient = angular.copy(jobMailData);

					mailDataClient.emailSubject = subject;
					mailDataClient.emailTo = to;
					mailDataClient.emailCc = cc;
					mailDataClient.emails = emailTemplates;
					mailDataClient.mailSignature = signatureData.signature || '';
					mailDataClient.reply = true;
					mailDataClient.validMsg = true;

					try {
						// !!$sce.getTrustedHtml(text);

						var emailDetails = emailService.escapeEmailDetailsHtml('On ' + data + ' ' + allFromName + ' wrote:');
						var matchedText = emailService.trimStyleTagsHtml(emailService.escapeEmailTextHtml(text));
						mailDataClient.emailTextReply = emailService.getEmailTextReply(emailDetails, emailService.escapeEmailBodyDetailsHtml(matchedText));
						mailDataClient.emailText = emailService.getReplyText(mailDataClient);
					} catch (err) {
						console.log('error ', err);
						mailDataClient.emailTextReply = 'Oops! This message is unsupported and cannot be displayed in Studio Ninja. Please view this message in your email provider';
						mailDataClient.validMsg = false;
					}

					return mailDataClient;
				}

				scope.setMinWidth = function (text) {
					if (text.length < 6) {
						return 40;
					} else if (text.length < 10) {
						return 60;
					} else if (text.length < 20) {
						return 100;
					}
					return 190;
				};
			}
		};
	}]);
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./web/js/components/navigation/admin-navbar/adminNavbar.component.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"row\">\n    <div class=\"col-md-3\">\n        <img class=\"logo\" src=\"https://app.studioninja.co/build/release-pipeline-119/resources/dist/assets/images/logo/logo_R.svg\" alt=\"StudioNinja\">\n        <a ng-click=\"sidebarClick()\" class=\"sidebar-btn visible-xs-block visible-sm-block pull-right\"> <i\n                class=\"fa fa-bars\"></i></a>\n\n        <ul ng-show=\"showmen&&showLogo\" class=\"sandwich-menu hidden-md hidden-lg\" ng-click=\"closeSandwich()\">\n            <li class=\"sandwich-elem\" ng-class=\"getClass('/')\">\n                <a href=\"/\">Super Admin</a>\n            </li>\n            <li class=\"sandwich-elem\" ng-class=\"getClass('/ambassadors')\">\n                <a href=\"/ambassadors\">Ambassadors</a>\n            </li>\n            <li class=\"sandwich-elem\" ng-class=\"getClass('/referrals')\">\n                <a href=\"/referrals\">Referrals</a>\n            </li>\n            <li class=\"sandwich-elem\" ng-class=\"getClass('/campaigns')\">\n                <a href=\"/campaigns\">Campaigns</a>\n            </li>\n            <li class=\"sandwich-elem\" ng-class=\"getClass('/reports')\">\n                <a href=\"/reports\">Reports</a>\n            </li>\n            <li class=\"sandwich-elem\" role=\"presentation\">\n                <a href=\"#\" ng-click=\"logout()\" data-link=\"logout\" data-autotest-link=\"logoutMobile\">\n                    <i class=\"pointer fa fa-sign-out\"></i>\n                    Log out\n                </a>\n            </li>\n        </ul>\n    </div>\n\n    <div class=\"col-md-9 hidden-xs hidden-sm\">\n        <div class=\"row\">\n            <div class=\"col-md-8\">\n                <ul class=\"nav sn-header__nav sn-header__nav--admin\">\n                    <li ng-class=\"getClass('/')\">\n                        <a href=\"/dashboard\">Super Admin</a>\n                    </li>\n                    <li ng-class=\"getClass('/ambassadors')\">\n                        <a href=\"/ambassadors\">Ambassadors</a>\n                    </li>\n                    <li ng-class=\"getClass('/referrals')\">\n                        <a href=\"/referrals\">Referrals</a>\n                    </li>\n                    <li ng-class=\"getClass('/campaigns')\">\n                        <a href=\"/campaigns\">Campaigns</a>\n                    </li>\n                    <li ng-class=\"getClass('/reports')\">\n                        <a href=\"/reports\">Reports</a>\n                    </li>\n                </ul>\n            </div>\n            <div class=\"col-md-4\">\n                <ul class=\"nav sn-header__menu text-right\">\n                    <li class=\"sn-header__menu__item item-help item-email\">\n                        <a href=\"#\" class=\"sn-header__menu__item__link\">{{user.email}}</a>\n                    </li>\n                    <li class=\"sn-header__menu__item item-help\">\n                        <a href=\"#\" ng-click=\"logout()\" class=\"sn-header__menu__item__link pointer text-nowrap\">Log\n                            out</a>\n                    </li>\n                </ul>\n            </div>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "./web/js/components/navigation/admin-navbar/adminNavbar.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
	angular.module('main').directive('adminNavbar', adminNavbar);

	adminNavbar.$inject = ['accountService', 'userService'];

	function adminNavbar(accountService, userService) {
		return {
			restrict: 'E',
			replace: true,
			scope: true,
			template: __webpack_require__("./web/js/components/navigation/admin-navbar/adminNavbar.component.html"),
			link: function link(scope) {
				scope.user = userService.userData;
				scope.logout = function () {
					accountService.logoutWeb();
				};
			}
		};
	}
})();

/***/ }),

/***/ "./web/js/components/navigation/anonymous-navbar/anonymousNavbar.component.html":
/***/ (function(module, exports) {

module.exports = "<div>\n    <div class=\"col-md-3\">\n        <a ng-click=\"sidebarClick()\" class=\"sidebar-btn visible-xs-block visible-sm-block pull-right\">\n            <i class=\"fa fa-bars\"></i></a>\n        <ul ng-show=\"showmen&&showLogo\" class=\"sandwich-menu hidden-md hidden-lg\">\n            <li ng-hide=\"navbarSignUp\" class=\"sandwich-elem\">\n                <a ng-click=\"publicNavbarClick($event);closeSandwich();\" href=\"/signup\" class=\"\">\n                    Sign up free today\n                </a>\n            </li>\n            <li ng-show=\"navbarSignUp\" class=\"sandwich-elem\">\n                <a ng-click=\"publicNavbarClick($event);closeSandwich();\" href=\"/login\" class=\"\">\n                    Already a Ninja? Sign in here\n                </a>\n            </li>\n        </ul>\n        <div ng-show=\"showLogo\">\n            <a href=\"/\"><img class=\"logo\" src=\"https://app.studioninja.co/build/release-pipeline-119/resources/dist/assets/images/logo/logo2x.png\" alt=\"StudioNinja\"></a>\n        </div>\n    </div>\n    <div class=\"col-md-9 hidden-xs hidden-sm\">\n        <div class=\"col-md-12\" id=\"bs-example-navbar-collapse-1\">\n            <ul class=\"nav sn-header__menu text-right\" role=\"tablist\">\n                <li ng-hide=\"navbarSignUp\" class=\"sn-header__menu__item\">\n                    <a ng-click=\"publicNavbarClick($event)\" href=\"/signup\"\n                       class=\"sn-header__menu__item__link waves-effect waves-button waves-classic\">Sign up free\n                        today</a>\n                </li>\n                <li ng-show=\"navbarSignUp\" class=\"sn-header__menu__item\">\n                    <a ng-click=\"publicNavbarClick($event)\" href=\"/login\"\n                       class=\"sn-header__menu__item__link waves-effect waves-button waves-classic ng-binding\">Already\n                        a\n                        Ninja? Sign in here</a>\n                </li>\n            </ul>\n        </div>\n    </div>\n</div>"

/***/ }),

/***/ "./web/js/components/navigation/anonymous-navbar/anonymousNavbar.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
	angular.module('main').directive('anonymousNavbar', anonymousNavbar);

	anonymousNavbar.$inject = [];

	function anonymousNavbar() {
		return {
			restrict: 'E',
			replace: true,
			scope: true,
			template: __webpack_require__("./web/js/components/navigation/anonymous-navbar/anonymousNavbar.component.html"),
			controller: 'LoginController',
			link: function link(scope) {}
		};
	}
})();

/***/ }),

/***/ "./web/js/components/navigation/company-navbar/companyNavbar.component.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"company-header client-header\">\n    <div class=\"navbar-header\">\n        <a class=\"navbar-brand\">\n            <img ng-show=\"companyImage\" class=\"company-image\" alt=\"Company image\" ng-src=\"{{companyImage}}\"/>\n        </a>\n    </div>\n</div>"

/***/ }),

/***/ "./web/js/components/navigation/company-navbar/companyNavbar.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
	angular.module('main').directive('companyNavbar', companyNavbar);

	companyNavbar.$inject = [];

	function companyNavbar() {
		return {
			restrict: 'E',
			replace: true,
			scope: true,
			template: __webpack_require__("./web/js/components/navigation/company-navbar/companyNavbar.component.html"),
			link: function link() {}
		};
	}
})();

/***/ }),

/***/ "./web/js/components/navigation/header/header.component.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"sn-header not-print\" ng-show=\"navbar && !$root.isContactForm\" style=\"height: auto\">\n    <notification-bar ng-if=\"navbar === 'authenticatedUser'\"></notification-bar>\n    <div class=\"mobile-banner-styles header-container\">\n        <user-navbar ng-if=\"navbar === 'authenticatedUser'\"></user-navbar>\n        <anonymous-navbar ng-if=\"navbar === 'anonymousUser'\"></anonymous-navbar>\n        <admin-navbar ng-if=\"navbar === 'adminUser'\"></admin-navbar>\n    </div>\n</div>\n"

/***/ }),

/***/ "./web/js/components/navigation/header/header.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
	angular.module('main').directive('snHeader', snHeader);

	snHeader.$inject = ['accountService'];

	function snHeader(accountService) {
		return {
			template: __webpack_require__("./web/js/components/navigation/header/header.component.html"),
			replace: true,
			scope: true,
			link: function link(scope) {
				scope.navbar = null;
				accountService.navDataObservable.subscribe(function (data) {
					scope.navbar = data.menu_path;
					if (data.menu_path === null) {
						scope.navbar = 'companyUser';
					}
				});
			}
		};
	}
})();

/***/ }),

/***/ "./web/js/components/navigation/subscriptionNavbar.component.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"client-header flex-row\">\n    <div class=\"col-sm-12 navbar-header flex-row flex-align-center flex-just-space\">\n        <a class=\"navbar-brand flex-row flex-align-center navbar-center\">\n            <img class=\"company-image\" ng-show=\"companyImage\" alt=\"Company image\" src=\"{{companyImage}}\"/>\n        </a>\n    </div>\n</div>\n"

/***/ }),

/***/ "./web/js/components/navigation/subscriptionNavbar.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
	angular.module('main').directive('subscriptionNavbar', subscriptionNavbar);

	subscriptionNavbar.$inject = [];

	function subscriptionNavbar() {
		return {
			restrict: 'E',
			replace: true,
			scope: true,
			template: __webpack_require__("./web/js/components/navigation/subscriptionNavbar.component.html"),
			controller: 'ClientNavbarControllerS',
			link: function link(scope) {}
		};
	}
})();

/***/ }),

/***/ "./web/js/components/navigation/user-navbar/userNavbar.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// (() => {
// 	// angular.module('main').directive('userNavbar', userNavbar);
//
// 	userNavbar.$inject = ['userService', 'accountService'];
//
// 	function userNavbar(userService, accountService) {
// 		return {
// 			restrict: 'E',
// 			replace: true,
// 			scope: true,
// 			link(scope) {
// 				scope.user = userService.userData;
//
// 				$('.keep-open').on('click', e => {
// 					e.stopPropagation();
// 				});
//
// 				scope.logout = () => {
// 					accountService.logoutWeb();
// 				};
// 			}
// 		};
// 	}
// })();


/***/ }),

/***/ "./web/js/components/onloadlogoComponent.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('main').directive('onloadlogo', function () {
	return {
		restrict: 'AE',
		link: function link(scope, img, attrs) {
			var imgDOM = img[0];

			imgDOM.classList.add('hide');
			img.on('load', function (e) {
				imgDOM.style.maxHeight = imgDOM.naturalHeight / 2 + 'px';
				imgDOM.style.width = imgDOM.naturalWidth / 2 + 'px';
				imgDOM.classList.remove('hide');
			});
		}
	};
});

/***/ }),

/***/ "./web/js/components/pageInvoice/tdPaid.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('main').directive('tdPaid', [function () {
	return {
		restrict: 'AE',
		template: '<td>' + '<p class="invoice-blocks web mb-0 {{paymentStatus | lowercase}}">{{paymentStatus | uppercase}}</p>' + '</td>',
		scope: {
			snPayment: '='
		},
		replace: true,
		transclude: true,
		link: function link(scope) {
			if (scope.snPayment.paid) {
				scope.paymentStatus = 'Paid';
			} else {
				scope.paymentStatus = scope.snPayment.late ? 'Late' : 'Unpaid';
			}
		}
	};
}]);

/***/ }),

/***/ "./web/js/components/pageJob/jobCellHeader.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
	angular.module('main').directive('jobCellHeader', jobCellHeader);

	function jobCellHeader() {
		return {
			restrict: 'E',
			scope: {
				icon: '@',
				imgSrc: '@',
				text: '@',
				isBorderBottom: '@',
				files: '=',
				galleryHeader: '<'
			},
			template: ' \n                  <div class="main-jobs-cell__title" ng-class="{\'main-jobs-cell__title--bordered\' : isBorderBottom}">\n                    <i class="{{icon}}" ng-if="icon"></i>\n                    <img ng-src="{{imgSrc}}" ng-if="imgSrc">\n                    <h2>{{text}}</h2>\n                    <sn-label\n                    ng-if="galleryHeader"\n                        text="Connected to ShootProof">\n                    </sn-label>\n                    <ng-transclude style="margin-left: auto"></ng-transclude>\n                  </div>\n            ',
			replace: true,
			transclude: true
		};
	}
})();

/***/ }),

/***/ "./web/js/components/questionnaire/sendQuestionnaire.component.html":
/***/ (function(module, exports) {

module.exports = "<section id=\"main-wrapper\" class=\"container\" ng-controller=\"JobQuestionnaireController\">\n    <div id=\"sendQuestionnaireModal\" class=\"modal modal-center fade\" data-backdrop=\"static\" data-keyboard=\"false\">\n        <div class=\"modal-dialog\">\n            <div class=\"modal-content\">\n                <form role=\"form\" ng-submit=\"sendQuestionnaireEmail(task)\" autocomplete=\"off\">\n                    <div class=\"modal-header\">\n                        <button ng-click=\"modalClose()\" btn-close ></button>\n                        <h3 class=\"modal-title\">Send Questionnaire</h3>\n                    </div>\n                    <div class=\"modal-body\">\n                        <div class=\"field-info\">\n                            <h4 class=\"mt-0\">To</h4>\n                            <div class=\"flex-row\">\n                                <email-field class=\"w-max-100\"\n                                             [placeholder]=\"'myclient@abc.com'\"\n                                             [value]=\"sendMessage.emailTo\"\n                                             [disabled]=\"isDisable\"\n                                             (value-change)=\"setEmailData($event, 'sendMessage', 'emailTo')\">\n                                </email-field>\n                                <button type=\"button\" class=\"btn btn-link color-cc\" ng-show=\"!showCcField && !isDisable\" autocomplete=\"off\"\n                                        ng-click=\"toggleViewCc()\">Add Cc\n                                </button>\n                            </div>\n                        </div>\n\n                        <div class=\"field-info\" ng-show=\"showCcField\">\n                            <h4>Cc</h4>\n                            <email-field class=\"w-max-100\"\n                                         [placeholder]=\"'another@email.com'\"\n                                         [value]=\"sendMessage.emailCc\"\n                                         (value-change)=\"setEmailData($event, 'sendMessage', 'emailCc')\">\n                            </email-field>\n                        </div>\n\n                        <div class=\"field-info\">\n                            <h4>Choose template</h4>\n                            <div class=\"flex-row flex-wrap-xs\">\n                                <div class=\"select-style flex-grow-1 flex-with-full\">\n                                    <select ng-model=\"choosenQuestionnaireEmail\" ng-disabled=\"button_disable\"\n                                            ng-change=\"setQuestionnaireEmailTemplate(choosenQuestionnaireEmail.id )\"\n                                            ng-options=\"question as question.name for question in questionnaireEmailTemplates | orderBy:'name'\">\n                                        <option value=\"\">Choose Template</option>\n                                    </select>\n                                </div>\n                            </div>\n                        </div>\n\n                        <div class=\"subject-row mt-20\">\n                            <insert-variable class=\"insert-variable\" [variable-list-type]=\"'JOB_MENU_SUBJECT'\" (on-variable-choose)=\"addSubjectVariable($event, 'subject-send-questionnaire', 'QUESTIONNAIRE_VIEW')\"></insert-variable>\n                            <div class=\"field-info\">\n                                <h4>Subject</h4>\n                                <div class=\"flex-row\">\n                                    <input id=\"subject-send-questionnaire\" type=\"text\" class=\"form-control\" ng-model=\"questionnaireEmail.subject\" required\n                                           placeholder=\"Write an awesome subject line. Why not?\" maxlength=\"255\"\n                                           ng-disabled=\"button_disable\">\n                                </div>\n                            </div>\n                        </div>\n\n                        <div class=\"field-info\">\n                            <h4>Message</h4>\n                            <sn-quill-editor-web\n                                [init-value]=\"questionnaireEmail.text\"\n                                [editor-i-d]=\"'questionnaire_email_text'\"\n                                [files-obj]=\"attachmentsData\"\n                                [toolbar-settings]=\"'color attachments variables size font'\"\n                                (on-text-change)=\"questionnaireEmail.text = $event\">\n                            </sn-quill-editor-web>\n                        </div>\n                    </div>\n                    <div class=\"modal-footer modal-foot\">\n                        <button type=\"submit\" class=\"btn btn-success btn-lg\" ng-disabled=\"disableBtnOnSend\"\n                                spinning-wheel is-spinning-wheel-active=\"isSentSpinnningWheelActive\">Send\n                            questionnaire\n                        </button>\n                    </div>\n                </form>\n            </div>\n        </div>\n    </div>\n</section>"

/***/ }),

/***/ "./web/js/components/questionnaire/sendQuestionnaire.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
	angular.module('main').directive('sendQuestionnaireModal', sendQuestionnaireModal);

	sendQuestionnaireModal.$inject = [];

	function sendQuestionnaireModal() {
		return {
			scope: true,
			template: __webpack_require__("./web/js/components/questionnaire/sendQuestionnaire.component.html")
		};
	}
})();

/***/ }),

/***/ "./web/js/components/quote/sendQuote.component.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"main-wrapper\" class=\"container\" ng-controller=\"QuoteViewController\">\n    <div id=\"sendQuoteModal\" class=\"modal modal-center fade\" data-backdrop=\"static\" data-keyboard=\"false\">\n        <div class=\"modal-dialog\">\n            <form role=\"form\" ng-submit=\"sendQuote()\" autocomplete=\"off\" class=\"modal-content form-horizontal\">\n                <div class=\"modal-header\">\n                    <btn-close ng-click=\"toggleViewCc(false)\"></btn-close>\n                    <h3 class=\"modal-title\">Send Quote</h3>\n                </div>\n                <div class=\"modal-body\">\n                    <div class=\"field-info\">\n                        <h4 class=\"mt-0\">To</h4>\n                        <div class=\"flex-row\">\n                            <email-field class=\"w-max-100\"\n                                         [placeholder]=\"'myclient@abc.com'\"\n                                         [value]=\"sendMessage.emailTo\"\n                                         (value-change)=\"setEmailData($event, 'sendMessage', 'emailTo')\">\n                            </email-field>\n                            <button type=\"button\" class=\"btn btn-link color-cc\" ng-show=\"!showCcField\"\n                                    ng-click=\"toggleViewCc()\">Add Cc\n                            </button>\n                        </div>\n                    </div>\n\n                    <div class=\"field-info\" ng-show=\"showCcField\">\n                        <h4>Cc</h4>\n                        <email-field class=\"w-max-100\"\n                                     [placeholder]=\"'another@email.com'\"\n                                     [value]=\"sendMessage.emailCc\"\n                                     (value-change)=\"setEmailData($event, 'sendMessage', 'emailCc')\">\n                        </email-field>\n                    </div>\n\n                    <div class=\"field-info\">\n                        <h4>Choose email template</h4>\n                        <div class=\"flex-row\">\n                            <div class=\"select-style flex-grow-1\">\n                                <select class=\"form-control m-b-sm\" ng-model=\"choosenEmail\" required\n                                        ng-options=\"item as item.name for item in emails | orderBy:'name'\">\n                                    <option value=\"\">Choose an existing email template</option>\n                                </select>\n                            </div>\n                        </div>\n                    </div>\n\n                    <div class=\"subject-row mt-20\">\n                        <insert-variable ng-if=\"customToken\" class=\"insert-variable\" [variable-list-type]=\"customToken + '_SUBJECT'\" (on-variable-choose)=\"addSubjectVariable($event, 'subject-send-quote')\"></insert-variable>\n                        <div class=\"field-info\">\n                            <h4>Subject</h4>\n                            <div class=\"flex-row\">\n                                <input id=\"subject-send-quote\" ng-disabled=\"button_disable\" type=\"text\" class=\"form-control\" required\n                                       placeholder=\"Write an awesome subject line. Why not?\" maxlength=\"255\"\n                                       ng-model=\"sendMessage.emailSubject\">\n                            </div>\n                        </div>\n                    </div>\n\n                    <div class=\"field-info\">\n                        <h4>Message</h4>\n                        <sn-quill-editor-web\n                            ng-if=\"customToken\"\n                            [editor-i-d]=\"'send_quote_email_text'\"\n                            [init-value]=\"sendMessage.emailText\"\n                            [toolbar-settings]=\"'variables attachments color size font'\"\n                            [vars-list]=\"customToken\"\n                            [files-obj]=\"attachmentsData\"\n                            (on-text-change)=\"sendMessage.emailText = $event\">\n                        </sn-quill-editor-web>\n                    </div>\n                </div>\n                <div class=\"modal-footer modal-foot\">\n                    <button class=\"btn btn-success btn-lg\" ng-disabled=\"disableBtnOnSend\" type=\"submit\"\n                            spinning-wheel is-spinning-wheel-active=\"disableBtnOnSend\">Send quote</button>\n                </div>\n            </form>\n        </div>\n    </div>\n</div>"

/***/ }),

/***/ "./web/js/components/quote/sendQuote.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
	angular.module('main').directive('sendQuoteModal', sendQuoteModal);

	sendQuoteModal.$inject = [];

	function sendQuoteModal() {
		return {
			scope: true,
			template: __webpack_require__("./web/js/components/quote/sendQuote.component.html")
		};
	}
})();

/***/ }),

/***/ "./web/js/components/snTextAngular.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

angular.module('main').directive('snTextAngular', ['$timeout', '$rootScope', '$window', 'messageService', function ($timeout, $rootScope, $window, messageService) {
	return {
		restrict: 'AE',
		scope: {
			drModel: '=snModel',
			snFilesModel: '=', // attachments  snFilesModel
			toolbar: '@snTools',
			fieldName: '@snName',
			fileDropHandler: '&snFileDropHandler',
			forbidImgPaste: '=snForbidImgPaste'
		},
		replace: true,
		transclude: true,
		link: function link(scope) {
			scope.cutEl = true;

			scope.linkVariables = ['%contract_link%', '%invoice_link%', '%quote_link%', '%questionnaire_link%', '%galleries_link%'];

			if (!scope.drModel) {
				scope.drModel = '';
			}

			function placeCaretAtEnd(el) {
				if (typeof $window.getSelection !== 'undefined' && typeof document.createRange !== 'undefined') {
					var range = document.createRange();
					range.selectNodeContents(el);
					range.collapse(false);
					var sel = $window.getSelection();
					sel.removeAllRanges();
					sel.addRange(range);
				} else if (typeof document.body.createTextRange !== 'undefined') {
					var textRange = document.body.createTextRange();
					textRange.moveToElementText(el);
					textRange.collapse(false);
					textRange.select();
				}
			}

			function wrapTextInParagraph(inputedText, textContainer) {
				textContainer.html('<p>' + inputedText + '</p>');
				placeCaretAtEnd(textContainer[0].childNodes[0]);
			}

			function deleteSingleBr(inputedText, textContainer, brTag) {
				inputedText = inputedText.replace(brTag, '');
				textContainer.html(inputedText);
			}

			function trimVariablesDomain(href) {
				var link = href;

				scope.linkVariables.forEach(function (linkVar) {
					var startIndex = link.indexOf(linkVar);
					if (startIndex !== -1) {
						link = link.slice(startIndex, startIndex + linkVar.length);
					}
				});

				return link;
			}

			scope.$on('checkedFiles', function (e, data) {
				scope.$broadcast('attachments', data);
			});

			scope.$watch('drModel', function (newValue, oldValue) {
				if (newValue !== oldValue) {
					var textContainer = $('.focussed [id^=taTextElement]');

					if ((scope.fieldName === 'chosen_package' || scope.fieldName === 'updateproduct_description') && textContainer && textContainer[0] && textContainer[0].innerText.length > 4000) {
						textContainer.text(textContainer[0].innerText.slice(0, 4000));
					}

					if (textContainer.length) {
						var TEXT_CODE = 3;
						var inputedText = textContainer.html();
						var firstChildNode = textContainer[0].childNodes[0];
						var brTag = /<br[^>]*>/;
						var hasText = textContainer.text().length !== 0;
						var hasNodeBr = brTag.test(firstChildNode.innerHTML);

						if (inputedText === '<br>') {
							textContainer.html('<p></p>');
						}

						if (firstChildNode.nodeType === TEXT_CODE) {
							wrapTextInParagraph(inputedText, textContainer);
						}

						if (!hasText && hasNodeBr) {
							deleteSingleBr(inputedText, textContainer, brTag);
						}
					}

					var elLength = void 0;

					try {
						elLength = angular.element(newValue).length;
					} catch (e) {
						elLength = angular.element('<div>' + newValue + '</div>').text().length;
					}

					if (!newValue || elLength === 0) {
						if (textContainer.text().length === 0) {
							scope.drModel = '<p></p>';
						}
					}
				}
			});

			$rootScope.$watch('crashedTextAngular', function (newValue, oldValue) {
				if (newValue && newValue !== oldValue) {
					rebuild();
				}
			});

			function rebuild() {
				$timeout(function () {
					console.error('Text Angular was crached');
				}, 0);
			}

			scope.isAttachment = false;

			scope.link2edit = {
				linkTo: '',
				url: '',
				select: ''
			};

			if (scope.snFilesModel) {
				scope.isAttachment = Array.isArray(scope.snFilesModel.attachments);
			}

			if (scope.fieldName) {
				var fields = document.querySelectorAll('div > [name="' + scope.fieldName + '"]');

				if (fields.length > 1) {
					fields = document.querySelectorAll('div > [name^="' + scope.fieldName + '"]');
					scope.fieldName += '_' + fields.length;
				}
			}

			scope.fieldEndName = scope.fieldName;

			function replaceTag(html, array, newTag) {
				var expr1 = void 0,
				    expr2 = void 0,
				    targetTag = void 0;

				array.forEach(function (element) {
					targetTag = element.toLowerCase();
					expr1 = new RegExp('<' + targetTag, 'g');
					expr2 = new RegExp('</' + targetTag + '>', 'g');

					html = html.replace(expr1, '<' + newTag);
					html = html.replace(expr2, '</' + newTag + '>');
				});

				return html;
			}

			function removeStyling(emailText) {
				try {
					if (!emailText) {
						return emailText;
					}

					var startCut = '<!--StartFragment-->';
					var htmlInsertOffset = emailText.indexOf(startCut);

					if (htmlInsertOffset !== -1) {
						var startOffset = startCut.length;
						var endCut = '<!--EndFragment-->';

						var textTmp = emailText.slice(emailText.indexOf(startCut) + startOffset);
						textTmp = textTmp.slice(0, textTmp.indexOf(endCut));

						emailText = textTmp;
					}

					var thisTag = void 0,
					    tagName = void 0,
					    tmpId = void 0,
					    newhtml = void 0,
					    tmpContainer = void 0,
					    allTags = void 0,
					    result = void 0;

					var forbidBoxTags = ['HTML', 'BODY', 'PRE', 'DL', 'DT', 'DD'];
					var forbidBoldTags = ['H1', 'H2', 'H3', 'H4', 'H5', 'H6'];

					tmpId = 'tagCleaner_' + Math.random().toString(36).substr(2, 9);

					newhtml = replaceTag(emailText, forbidBoxTags, 'div');
					newhtml = replaceTag(newhtml, forbidBoldTags, 'b');
					newhtml = newhtml.replace(/style="[^"]*"/g, '');
					newhtml = newhtml.replace(/class="[^"]*"/g, '');

					$(document.body).append('<div id="' + tmpId + '" class="hide">' + newhtml + '</div>');

					tmpContainer = $('#' + tmpId);
					allTags = tmpContainer.find('*');

					var i = 0;
					var max = allTags.length;

					for (; i < max; i++) {
						thisTag = allTags.eq(i);

						tagName = thisTag.prop('tagName');

						if (forbidBoxTags.indexOf(tagName) !== -1) {
							$(thisTag).replaceWith($('<div>' + thisTag[0].innerHTML + '</div>'));
						} else if (forbidBoldTags.indexOf(tagName) !== -1) {
							$(thisTag).replaceWith($('<b>' + thisTag[0].innerHTML + '</b>'));
						} else if (tagName === 'A') {
							thisTag[0].href = trimVariablesDomain(thisTag[0].href);

							var linkBody = thisTag[0].href ? thisTag[0].outerHTML : thisTag[0].innerHTML;

							$(thisTag).replaceWith($('<span>' + linkBody + '</span>'));
						} else if (tagName === 'CODE') {
							$(thisTag).replaceWith($('<span>' + thisTag[0].innerHTML + '</span>'));
						}
					}

					result = tmpContainer.html();
					tmpContainer.remove();
					return result;
				} catch (e) {
					console.warn('wrong past', e);
				}
			}

			scope.pasteHandlerTA = function (html) {
				try {
					var editor = $('.textarea-quad > .focussed').find('input').first();
					editor.focus();
					editor.blur();
				} catch (e) {
					console.warn('wrong past', e);
				}
				var forbidImage = scope.forbidImgPaste && /^<img[^>]*>$/.test(html);
				if (forbidImage) messageService.showToaster('e_0', 'email');
				var text = forbidImage ? '' : removeStyling(html);
				text = '<span>' + text + '</span>';
				return text;
			};

			scope.showModalEditLink = function (e) {
				scope.$evalAsync();
				scope.link2edit.select = '';
				delete scope.link2edit.linkTo;
				delete scope.link2edit.url;

				scope.$evalAsync();
				var tmpId = 'link-edited-id-' + Math.random().toString(36).substr(2, 9);
				var target = $(e.target);
				target.parents('.sn-ta-editor').addClass(tmpId);
				scope.link2edit = { select: '.' + tmpId + ' .linkEdited' };
			};

			scope.$on('ta-drop-event', function () {
				if (scope.forbidImgPaste) messageService.showToaster('e_1', 'email');
			});
		},
		template: function template() {
			var html = '\n                 <div class="sn-ta-editor">\n                        <div class="textarea-quad">\n\n                        <text-angular ng-model="drModel" name="{{fieldEndName}}" ta-file-drop="fileDropHandler" ta-focussed-class="focussed" ta-html-editor-class="form-content" ta-text-editor-class="form-content" ta-paste="pasteHandlerTA($html)" ng-disabled="button_disable" ta-toolbar="{{toolbar}}">\n                        </text-angular>\n                        <span class="editLinkTips" ng-click="showModalEditLink($event)" style="display:none;">\n                        <i class="fi fi-edit"></i>Edit link\n                    </span>\n                    </div>\n\n                    <modal-link-editor sn-link-data="link2edit"></modal-link-editor>\n                    <sn-attach-files ng-if="isAttachment" sn-attachments="snFilesModel"></sn-attach-files>\n                    <attach-files-modal></attach-files-modal>\n                  </div>\n             ';

			return html;
		}
	};
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./web/js/components/snTimepicker.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {

(function () {
	angular.module('main').directive('snTimepicker', snTimepicker);

	snTimepicker.$inject = ['randomStringGenerator', '$location', 'settingsService', 'timeConverter'];

	function snTimepicker(randomStringGenerator, $location, settingsService, timeConverter) {
		var template = '';

		template += '<div class="bootstrap-timepicker timepicker">';

		template += '<input id="{{timepickerId}}" name="{{timepickerId}}" ng-required="!checked" ng-disabled="checked"';
		template += ' type="text" class="form-control"';
		template += ' placeholder="HH:mm"';
		template += ' ng-focus="fillEmptyVal()"';
		template += ' ng-model="snDrModel">';

		template += '<span class="input-group-addon"><i class="fa fa-clock-o"></i></span>';
		template += '</div>';

		return {
			restrict: 'AE',
			scope: {
				snDrModel: '=',
				snRequired: '=',
				checked: '=snDrChecked',
				domTime: '@'
			},

			template: template,
			replace: true,

			link: function link(scope, elem) {
				scope.timepickerId = 'timepicker-sm-' + randomStringGenerator.getMixedString(9);

				var timeFormatIs12HorsFormat = void 0;
				settingsService.timeFormatSettings.subscribe(function (data) {
					if (data.timeFormat !== null) {
						timeFormatIs12HorsFormat = data.timeFormat === 'T_12';

						jQuery(elem[0].firstChild).timepicker({
							defaultTime: scope.snDrModel || false,
							minuteStep: 1,
							showInputs: true,
							showMeridian: timeFormatIs12HorsFormat,
							maxHours: 24,
							appendWidgetTo: elem,
							icons: {
								up: 'fa fa-chevron-up',
								down: 'fa fa-chevron-down'
							}
						});
					}
				});

				var dtStr = scope.snDrModel;
				var isStartDate = typeof dtStr !== 'undefined' && dtStr !== null && dtStr.length > 10;

				if (isStartDate) {
					dtStr = dtStr.substring(0, 19).replace(/T/g, ' ');
					dtStr = dtStr.replace(/\-/g, '/');

					var _dateUTC = new Date(dtStr);

					var _yy = _dateUTC.getFullYear(),
					    _MM = _dateUTC.getMonth(),
					    _dd = _dateUTC.getDate(),
					    _hh = _dateUTC.getHours(),
					    _mm = _dateUTC.getMinutes(),
					    _ss = _dateUTC.getSeconds();

					_dateUTC = Date.UTC(_yy, _MM, _dd, _hh, _mm, _ss);

					var dt = new Date(_dateUTC);
					var h = dt.getHours(),
					    m = dt.getMinutes(),
					    _time = void 0;

					if (m.toString().length === 1) {
						m = '0' + m;
					}

					_time = h > 12 ? h - 12 + ':' + m + ' PM' : h + ':' + m + ' AM';

					scope.snDrModel = _time;
					console.log('time', _time);
				}

				scope.$watch('snDrModel', function (newValue) {
					var jobModal = document.getElementById('newJob');
					var path = $location.path();
					var jobViewPage = path.includes('jobs/view');

					var jobModalShow = void 0;

					if (jobModal) {
						jobModalShow = jobModal.classList.contains('in');
					}
					if (scope.domTime && newValue && !jobModalShow && jobViewPage) {
						var timeInDom = jQuery('#' + scope.domTime).text();
						var timeInInput = jQuery('#' + scope.timepickerId).val();

						if (timeInInput != timeInDom) {
							jQuery('#' + scope.timepickerId).timepicker('setTime', timeInDom);
						}
					}
				});

				jQuery(elem[0]).on('mousedown', function (e) {
					jQuery('#' + scope.timepickerId).timepicker('setTime', scope.snDrModel);
					var timepicker = void 0;
					timepicker = jQuery('#' + scope.timepickerId);
					if (!timeFormatIs12HorsFormat && (scope.snDrModel.toUpperCase().includes('PM') || scope.snDrModel.toUpperCase().includes('AM'))) {
						scope.snDrModel = timeConverter.convert24to12(scope.snDrModel);
					}
					if (!scope.snDrModel && timepicker[0].attributes.disabled === undefined) {
						scope.snDrModel = '12:00 PM';
						scope.snDrModel = timeConverter.convert24to12(scope.snDrModel);
						timepicker.timepicker('setTime', '12:00 PM');
						timepicker.timepicker('showWidget');
						e.preventDefault();
					}
				}).on('show.timepicker', function () {
					if (!scope.snDrModel) {
						jQuery('#' + scope.timepickerId).timepicker('setTime', '12:00 PM');
					}
				}).on('click', function () {
					jQuery('#' + scope.timepickerId).timepicker('showWidget');
				});
			}
		};
	}
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./web/js/components/spinningWheel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
	angular.module('main').directive('spinningWheel', spinningWheel);

	function spinningWheel() {
		return {
			restrict: 'A',
			scope: {
				isSpinningWheelActive: '=',
				isSpinningWheelAfter: '@',
				isSpinningWheelDark: '@'
			},
			replace: true,
			link: spinningWheelLink,
			controller: spinningWheelController
		};
	}

	spinningWheelController.$inject = ['$scope'];

	function spinningWheelLink($scope, element) {
		element.addClass('spinning-wheel');

		if ($scope.isSpinningWheelAfter === 'true') {
			element.addClass('spinning-wheel__display-after');
		} else {
			element.addClass('spinning-wheel__display-before');
		}

		if ($scope.isSpinningWheelDark === 'true') {
			element.addClass('spinning-wheel__dark');
		}

		$scope.$watch(function () {
			return $scope.isSpinningWheelActive;
		}, function (newValue, oldValue) {
			if (newValue === true) {
				element.addClass('spinning-wheel__active');
			} else if (newValue === false) {
				element.removeClass('spinning-wheel__active');
			}
		});
	}

	function spinningWheelController($scope) {}
})();

/***/ }),

/***/ "./web/js/components/tableRowLink.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery, $) {

(function () {
	angular.module('main').directive('tableRowLink', tableRowLink);

	tableRowLink.$inject = ['$interval', '$rootScope', '$timeout'];

	function tableRowLink($interval, $rootScope, $timeout) {
		return {
			restrict: 'A',
			scope: {
				tableRowLinkHref: '@',
				tableRowLinkId: '@',
				itemsList: '='
			},
			link: function link(scope, element) {
				var table = jQuery(element[0]).find('table');
				var tbody = table.find('tbody');

				var intervalRootScopeId = scope.tableRowLinkId ? 'intervalPromise-' + scope.tableRowLinkId : 'intervalPromise';

				scope.$watchCollection('itemsList', function (newVal, oldVal) {
					if ($rootScope[intervalRootScopeId]) {
						element.removeClass('table-row-link');
						$interval.cancel($rootScope[intervalRootScopeId]);
						$('.table-row-link__link').remove();
						startTableRandering();
					} else {
						$('.table-row-link__link').remove();
						startTableRandering();
					}
				});

				function startTableRandering() {
					$rootScope[intervalRootScopeId] = $interval(function () {
						if (table.find('.lastTableRow').length) {
							$interval.cancel($rootScope[intervalRootScopeId]);
							initDirective();
						}
					}, 100);
				}

				function initDirective() {
					initLinks(table);

					jQuery(window).on('resize', function () {
						initLinks(table);
					});

					scope.$on('$destroy', function () {
						jQuery(window).off('resize');
					});
				}

				function updateLinkStyle(linkEl, linkStyle) {
					linkEl.css(linkStyle);
				}

				function getLinkStyles(currentEl, parentEl) {
					var height = currentEl.height();
					var width = currentEl.width();

					var top = currentEl.offset().top - parentEl.offset().top;
					var left = 0;

					return {
						height: height,
						width: width,
						top: top,
						left: left
					};
				}

				function initLinks(table) {
					element.addClass('table-row-link');

					var tableRow = table.find('tbody tr');

					tableRow.each(function (i, el) {
						var dataLinkId = jQuery(el).attr('data-link-id');

						if (jQuery(element[0]).find('.table-row-link__link' + i).length) {
							var link = jQuery(element[0]).find('.table-row-link__link' + i);

							var styles = getLinkStyles(jQuery(el), jQuery(element[0]));

							updateLinkStyle(link, styles);
						} else {
							var _styles = getLinkStyles(jQuery(el), jQuery(element[0]));

							var _link = jQuery('<a data-link-id="' + dataLinkId + '" href="' + scope.tableRowLinkHref + dataLinkId + '" class="table-row-link__link table-row-link__link' + i + '"></a>');

							jQuery(el).on('mousedown', function (e) {
								if (e.which === 3) {
									_link.addClass('active');

									$timeout(function () {
										_link.removeClass('active');
									}, 100);
								}
							});

							jQuery(element[0]).append(_link);

							updateLinkStyle(_link, _styles);
						}
					});
				}
			}
		};
	}
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js"), __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./web/js/components/textAreaElastic.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('main').directive('elastic', ['$timeout', function ($timeout) {
	return {
		restrict: 'A',
		link: function link($scope, element) {
			$scope.initialHeight = $scope.initialHeight || element[0].style.height;

			var resize = function resize() {
				element[0].style.height = $scope.initialHeight;
				element[0].style.height = element[0].scrollHeight + 'px';
			};
			element.on('input change', resize);
			$timeout(resize, 0);
		}
	};
}]);

/***/ }),

/***/ "./web/js/controllers/addWorkflowController.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Rx, $, toastr) {

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
	angular.module('main').controller('AddWorkflowController', AddWorkflowController);

	AddWorkflowController.$inject = ['$scope', '$location', '$routeParams', 'messageService', 'workflowDragNDropService', 'workflowService', 'templateRequestsService', 'randomStringGenerator', 'newWorkflowService', 'settingsService'];

	function AddWorkflowController($scope, $location, $routeParams, messageService, workflowDragNDropService, workflowService, templateRequestsService, randomStringGenerator, newWorkflowService, settingsService) {
		$scope.$on('$viewContentLoaded', function () {
			$scope.templates = {};
			$scope.isExitModalOpen = false;
			subscribeToCustomizeLabelsChange().subscribe(function (customizeLabels) {
				$scope.mainShootLabelName = customizeLabels.mainShootLabel;
				$scope.extraShootLabelName = customizeLabels.extraShootLabel;
				$scope.businessNumberLabelName = customizeLabels.businessNumberLabel;
			});

			Rx.Observable.zip(templateRequestsService.getTemplates('contract_preview'), templateRequestsService.getTemplates('questionnaire_preview'), templateRequestsService.getTemplates('general_preview')).subscribe(function (_ref) {
				var _ref2 = _slicedToArray(_ref, 3),
				    contracts = _ref2[0],
				    questionnaires = _ref2[1],
				    general = _ref2[2];

				setContractsPreview(contracts);
				setQuestionnairesPreview(questionnaires);
				setGeneralEmailsPreview(general);
			}, function (error) {
				return showErrorMessage();
			});

			$scope.isSaveSpinningWheelActive = false;

			if ($routeParams.id) {
				workflowService.getTaskTemplates($routeParams.id, successGetTemplates);
				return;
			}

			$scope.newWorkflow = {
				name: ''
			};

			$scope.lists = createDefaultList();

			$scope.unsubscribe = new Rx.Subject();
		});

		$scope.$on('$destroy', function () {
			$scope.unsubscribe.next();
			$scope.unsubscribe.complete();
		});

		$scope.$on('$routeChangeStart', function (event, next) {
			$scope.currentWorkflowCopy = gatherData();
			if (!$scope.isExitModalOpen && !angular.equals($scope.currentWorkflow, $scope.currentWorkflowCopy)) {
				event.preventDefault();
				$('#workflowExitModal').modal('show');
			} else if (!$scope.isExitModalOpen && angular.equals($scope.currentWorkflow, $scope.currentWorkflowCopy) && $scope.duplicatePath.includes('duplicate')) {
				event.preventDefault();
				$('#workflowExitModal').modal('show');
			}
			$scope.nextPage = next.$$route.originalPath;
		});

		$scope.taskTypes2Show = ['LEAD', 'PRODUCTION', 'POST-PRODUCTION'];

		$scope.isLabelShown = newWorkflowService.isLabelShown;

		$scope.onChangePage = function (isLeavePage) {
			if (typeof $scope.newWorkflow.name !== 'undefined' && $scope.newWorkflow.name !== '' || !isLeavePage) {
				$scope.isExitModalOpen = true;
			}
			if (isLeavePage === true) {
				$scope.save();
			} else {
				$location.path($scope.nextPage);
			}
		};

		$scope.setLabeledViewDue = function (viewDue) {
			return viewDue.includes('main shoot') ? viewDue.replace('main shoot', $scope.mainShootLabelName.toLowerCase()) : viewDue;
		};

		function subscribeToCustomizeLabelsChange() {
			return settingsService.customizeLabelsObservable;
		}

		function showErrorMessage() {
			messageService.showToaster('e_0', 'general');
		}

		function setContractsPreview(data) {
			$scope.templates.contractEmailTemplates = angular.copy(data.emailTemplates);
			$scope.templates.contracts = angular.copy(data.contractTemplates);
		}

		function setQuestionnairesPreview(data) {
			$scope.templates.questionnaireEmailTemplates = angular.copy(data.emailTemplates);
			$scope.templates.questionnaires = angular.copy(data.questionnaireTemplates);
		}

		function setGeneralEmailsPreview(data) {
			$scope.templates.generalEmailTemplates = angular.copy(data);
		}

		function createDefaultList() {
			var list = addDefaultTasks();
			return workflowService.fillWorkflowTasks(list);
		}

		function addDefaultTasks() {
			var defaultTaskNames = ['Lead created', 'Job accepted', $scope.mainShootLabelName, 'Job complete'];

			var defaultTaskTypes = ['LEAD', 'PRODUCTION', 'PRODUCTION', 'POST_PRODUCTION'];
			return Array.from(new Array(4), function (item, index) {
				return {
					name: defaultTaskNames[index],
					type: defaultTaskTypes[index],
					eventType: index === 2 ? 'MAIN_SHOOT' : null,
					defaultTask: true,
					number: index
				};
			});
		}

		function handleTaskTemplates(task, taskTypes) {
			if (task.dateItem) {
				task.dateItem = task.dateItem.toLowerCase();
			}
			if (task.due && !task.hasDue) {
				// for old workflows
				task.hasDue = true;
			}
			if (!task.action && task.emailTemplate) {
				// for old workflows
				task.action = 'SEND_EMAIL';
			}
			if (task.emailTemplate) {
				task.taskEmail = angular.copy(task.emailTemplate);
				delete task.emailTemplate;
			}
			task.taskViewDue = workflowService.getTaskViewDue(task, taskTypes);
		}

		function successGetTemplates(workflow) {
			var workflowCopy = angular.copy(workflow);

			$scope.duplicatePath = $location.path();

			if ($scope.duplicatePath.includes('duplicate')) {
				workflowCopy.id = null;
				workflowCopy.taskTemplates.forEach(function (item) {
					return item.id = null;
				});
			}

			$scope.newWorkflow = workflowCopy;

			var taskList = $scope.newWorkflow.taskTemplates;
			$scope.lists = workflowService.fillWorkflowTasks(taskList);
			taskList.forEach(function (item) {
				return handleTaskTemplates(item, $scope.lists);
			});
			adjustLabelsToWorkflow(taskList);
			$scope.currentWorkflow = gatherData();
		}

		function adjustLabelsToWorkflow(workflowCopy) {
			workflowCopy.forEach(function (item) {
				if (item.eventType === 'MAIN_SHOOT' && item.name && item.name.toLowerCase().includes('main shoot')) {
					item.name = $scope.mainShootLabelName;
				}
			});
		}

		$scope.showAddNewTaskModal = function () {
			$('#addWorkflowTaskModal').modal('show');
		};

		function isWorkflowValid(workflow) {
			var workflowName = workflow.name || '';
			if (!workflowName && !workflowName.trim()) {
				messageService.showToaster('e_0', 'workflow');
				return false;
			}
			return true;
		}

		function clearDueInfo(task2Save) {
			task2Save.due = null;
			task2Save.dateItem = null;
			task2Save.dateSequence = null;
			return task2Save;
		}

		function prepareTaskEmail(taskEmail, task2Save) {
			var emailTemplate = {};
			var id = taskEmail.id,
			    name = taskEmail.name,
			    subject = taskEmail.subject,
			    text = taskEmail.text,
			    base64Attachments = taskEmail.base64Attachments,
			    storedAttachments = taskEmail.storedAttachments;


			if (id || id === 0) {
				emailTemplate = { id: id };
			} else {
				emailTemplate = {
					name: name,
					subject: subject,
					text: text,
					base64Attachments: base64Attachments,
					storedAttachments: storedAttachments
				};
			}

			task2Save.emailTemplate = emailTemplate;
			delete task2Save.taskEmail;

			return task2Save;
		}

		function prepareTasksToSave(task) {
			var task2Save = angular.copy(task);
			var _task2Save = task2Save,
			    hasDue = _task2Save.hasDue,
			    tmpId = _task2Save.tmpId,
			    taskEmail = _task2Save.taskEmail;


			if (!hasDue) {
				task2Save = clearDueInfo(task2Save);
			}

			if (taskEmail) {
				task2Save = prepareTaskEmail(taskEmail, task2Save);
			}

			if (tmpId) {
				delete task2Save.tmpId;
			}

			return task2Save;
		}

		function successSaveWorkflow(data, workflow) {
			var path = $location.path();
			toastr.clear();
			if (path.includes('edit')) {
				messageService.showToaster('s_0', 'workflow', workflow.name);
			} else {
				messageService.showToaster('s_1', 'workflow', workflow.name);
			}

			if ($scope.nextPage) {
				$location.path($scope.nextPage);
			} else {
				$location.path('/settings/workflows');
			}
		}

		$scope.save = function () {
			if (typeof $scope.newWorkflow.name !== 'undefined' && $scope.newWorkflow.name !== '') {
				$scope.isExitModalOpen = true;
			}
			$scope.button_disabled = true;
			$scope.isSaveSpinningWheelActive = true;
			var workflow = $scope.newWorkflow;

			if (!isWorkflowValid(workflow)) {
				$scope.button_disabled = false;
				$scope.isSaveSpinningWheelActive = false;
				return;
			}

			var data2Save = gatherData();
			var tasks2Save = data2Save.taskTemplates.map(prepareTasksToSave);
			data2Save.taskTemplates = tasks2Save;

			workflowService.saveWorkflowTemplate(data2Save, successSaveWorkflow).finally(function () {
				$scope.button_disabled = false;
				$scope.isSaveSpinningWheelActive = false;
			}).subscribe(function () {}, function (error) {
				$scope.isExitModalOpen = false;
				var _error$data = error.data,
				    errorTitle = _error$data.errorTitle,
				    errorMessage = _error$data.errorMessage;

				messageService.showErrorFromBackend(errorTitle, errorMessage);
			});
		};

		function gatherData() {
			delete $scope.newWorkflow.taskTemplates;
			var workflow2Save = angular.copy($scope.lists);
			workflow2Save = workflowDragNDropService.renewTaskList(workflow2Save);
			var taskTemplates = [].concat.apply([], workflow2Save);
			return {
				id: $scope.newWorkflow.id,
				name: $scope.newWorkflow.name,
				taskTemplates: taskTemplates,
				taskToDelete: $scope.newWorkflow.taskToDelete
			};
		}

		// drag'n'drop
		var lastCorrectOrder = void 0;
		$scope.onDragStart = function () {
			lastCorrectOrder = angular.copy($scope.lists);
		};

		$scope.onDragOver = function (type) {
			if (type && type.toUpperCase() === 'MAIN_SHOOT') {
				$('.dndPlaceholder').addClass('mainShootOver');
			} else {
				$('.dndPlaceholder').removeClass('mainShootOver');
			}
			return true;
		};

		$scope.onDragend = function (task) {
			var draggedTask = workflowService.getTaskByNumber(task.number, $scope.lists);

			if (!draggedTask.id) {
				draggedTask.tmpId = randomStringGenerator.getMixedString();
			}

			$scope.lists = workflowDragNDropService.keepDefaultTasksInPlace($scope.lists);

			var renewedList = workflowDragNDropService.renewTaskList($scope.lists);
			var newTaskInfo = workflowDragNDropService.getTaskById(draggedTask, renewedList);
			var isMainShootInWrongPlace = newTaskInfo.eventType === 'MAIN_SHOOT' && newTaskInfo.type !== 'PRODUCTION';

			if (isMainShootInWrongPlace && lastCorrectOrder) {
				$scope.lists = lastCorrectOrder;
			} else {
				$scope.lists = renewedList;
				$scope.lists = workflowService.renewTaskViewDue($scope.lists);
			}
		};
	}
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/rxjs/Rx.js"), __webpack_require__("./node_modules/jquery/dist/jquery.js"), __webpack_require__("./node_modules/toastr/toastr.js")))

/***/ }),

/***/ "./web/js/controllers/admin/adminControllers.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _operators = __webpack_require__("./node_modules/rxjs/operators.js");

(function () {
	angular.module('main').controller('AdminController', AdminController);

	AdminController.$inject = ['$scope', '$q', '$filter', '$rootScope', 'adminReportsDataService', 'adminUsersDataService', 'ambassadorService', 'ambassadorsDataService', 'validationService', 'messageService', 'paginationService'];

	function AdminController($scope, $q, $filter, $rootScope, adminReportsDataService, adminUsersDataService, ambassadorService, ambassadorsDataService, validationService, messageService, paginationService) {
		document.title = 'Studio Ninja | Super Admin';
		$scope.usersData = null;
		$scope.filteredAdminTableData = null;
		$scope.reportTypes = ['New sign ups', 'New paying members', 'Total free members', 'Total paying members', 'Total revenue', 'New cancellations'];
		$scope.selectedReportType = $scope.reportTypes[3];

		$scope.newSignUpsReport = null;
		$scope.newPayingMembersReport = null;
		$scope.newCancellationsReport = null;
		$scope.totalRevenueReport = null;
		$scope.synchronization = false;
		$scope.isDisabled = false;

		$scope.users = [];
		$scope.totalItems = 0;
		$scope.pageRequest = {
			filterBy: null,
			paging: {
				pageSize: $rootScope.paginationPerPage ? $rootScope.paginationPerPage : 25,
				pageNumber: 0,
				searchToken: null
			},
			sortCriteria: {
				fieldName: 'id',
				sortAscending: false
			}
		};
		$scope.userTwoFaSpinner = false;
		$scope.userTwoFaInfo = null;
		$scope.selectedAccountId = null;

		$scope.changeReportType = function () {
			switch ($scope.selectedReportType) {
				case $scope.reportTypes[0]:
					buildNewSignUpsReport();
					break;
				case $scope.reportTypes[1]:
					buildNewPayingMembersReport();
					break;
				case $scope.reportTypes[2]:
					buildTotalFreeMembersReport();
					break;
				case $scope.reportTypes[3]:
					buildTotalPayingMembersReport();
					break;
				case $scope.reportTypes[4]:
					buildTotalRevenueReport();
					break;
				case $scope.reportTypes[5]:
					buildNewCancellationsReport();
					break;
				default:
					break;
			}
		};

		// navigation
		$scope.searchRequest = function (search) {
			$scope.pageRequest.filterBy = search || null;
			$scope.pageRequest.paging.pageNumber = 0;
			getResultsPage($scope.pageRequest.paging.pageNumber, $scope.pageRequest.paging.pageSize);
		};

		$scope.order = function (predicate) {
			$scope.pageRequest.sortCriteria.sortAscending = $scope.pageRequest.sortCriteria.fieldName === predicate ? !$scope.pageRequest.sortCriteria.sortAscending : false;
			getResultsPage(null, null, predicate, $scope.pageRequest.sortCriteria.sortAscending);
		};

		function getResultsPage() {
			var pageNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
			var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
			var predicate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
			var reverse = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

			var newPageRequest = paginationService.getResultsPage($scope.pageRequest, $scope.totalItems, pageNumber, perPage, predicate, reverse);

			if (newPageRequest) {
				$scope.getAdminTableData(newPageRequest);
			}
		}

		$scope.$watch('$viewContentLoaded', function () {
			getResultsPage($scope.pageRequest.paging.pageNumber, $scope.pageRequest.paging.pageSize);
			$rootScope.removeBg = 'white-background';
		});

		$scope.checkDisableButtons = function (event) {
			$scope.isDisabled = event;
		};

		$scope.giveFreeMonths = function (setTimeConfiguration, userLocal, freeAccessMethod) {
			if (!setTimeConfiguration.unitCount || setTimeConfiguration.unitCount && setTimeConfiguration.unitCount < 0) {
				messageService.showToaster('e_0', 'admin');
				return;
			}

			$scope.btn_disable = true;

			adminUsersDataService.giveFreeAccess(setTimeConfiguration, userLocal.businessAccountId, freeAccessMethod).finally(function () {
				setTimeConfiguration = {};
				$scope.btn_disable = false;
			}).subscribe(function () {
				successGiveFreeMonths(userLocal);
			}, function (error) {
				return messageService.handleError(error);
			});
		};

		function successGiveFreeMonths(userLocal) {
			getResultsPage($scope.pageRequest.paging.pageNumber, $scope.pageRequest.paging.pageSize);
			messageService.showToaster('s_0', 'admin', userLocal.email);
			$('#subscriptionModal').modal('hide');
		}

		$scope.getAdminTableData = function (pageRequest) {
			$scope.pageRequest = pageRequest;
			$rootScope.paginationPerPage = pageRequest.paging.pageSize;
			adminUsersDataService.getUsers(pageRequest).subscribe(function (data) {
				return successGetAdminTableData(data);
			}, function (err) {
				$scope.synchronization = false;
				messageService.showDefaultErrorMessage(err);
			});
		};

		function successGetAdminTableData(data) {
			$scope.totalItems = data ? data.totalSize : 0;
			$scope.pageNumbers = paginationService.calculatePageNumbers($scope.totalItems, $scope.pageRequest.paging.pageSize);

			$scope.changeReportType();
			$scope.usersData = data.items;
			$scope.newSignUpsReport = $scope.newSignUpsReport || null;
			$scope.newPayingMembersReport = $scope.newPayingMembersReport || null;
			$scope.newCancellationsReport = $scope.newCancellationsReport || null;
			$scope.totalRevenueReport = $scope.totalRevenueReport || null;
			$scope.synchronization = false;
			$scope.pageRequest.paging.searchToken = data.searchToken;
			parseDate();
		}

		function buildNewSignUpsReport() {
			if (!$scope.newSignUpsReport) {
				adminReportsDataService.getSignUpReport().subscribe(function (data) {
					$scope.newSignUpsReport = data;
				}).catch(messageService.showDefaultErrorMessage);
			}
		}

		function buildNewPayingMembersReport() {
			if (!$scope.newPayingMembersReport) {
				adminReportsDataService.getPayingMembersReport().catch(messageService.showDefaultErrorMessage).subscribe(function (data) {
					$scope.newPayingMembersReport = data;
				});
			}
		}

		function buildTotalFreeMembersReport() {
			if (!$scope.newSignUpsReport || !$scope.newPayingMembersReport || !$scope.newCancellationsReport) {
				adminReportsDataService.getSignUpReport().flatMap(function (data) {
					$scope.newSignUpsReport = data;
					return adminReportsDataService.getPayingMembersReport();
				}).flatMap(function (data) {
					$scope.newPayingMembersReport = data;
					return adminReportsDataService.getCancellationReport();
				}).catch(function (err) {
					return messageService.showDefaultErrorMessage(err);
				}).subscribe(function (data) {
					$scope.newCancellationsReport = data;
				});
			}
		}

		function buildTotalPayingMembersReport() {
			if (!$scope.newPayingMembersReport || !$scope.newCancellationsReport) {
				adminReportsDataService.getPayingMembersReport().catch(messageService.showDefaultErrorMessage).flatMap(function (data) {
					$scope.newPayingMembersReport = data;
					return adminReportsDataService.getCancellationReport();
				}).subscribe(function (data) {
					$scope.newCancellationsReport = data;
				});
			}
		}

		function buildTotalRevenueReport() {
			if (!$scope.totalRevenueReport) {
				adminReportsDataService.getTotalRevenueReport().catch(messageService.showDefaultErrorMessage).subscribe(function (data) {
					$scope.totalRevenueReport = data;
				});
			}
		}

		function buildNewCancellationsReport() {
			if (!$scope.newCancellationsReport) {
				adminReportsDataService.getCancellationReport().catch(messageService.showDefaultErrorMessage).subscribe(function (result) {
					$scope.newCancellationsReport = result.data;
				});
			}
		}

		$scope.deleteModal = function (user) {
			$scope.deleteUser = user;
			$('#deleteModal').modal('show');
		};

		$scope.deleteRequest = function (deleteUser) {
			$scope.add_btn_disable = true;
			$scope.isAddSpinningWheelActive = true;
			adminUsersDataService.deleteUser(deleteUser.email).pipe((0, _operators.finalize)(function () {
				$scope.add_btn_disable = false;
				$scope.isAddSpinningWheelActive = false;
			})).subscribe(function () {
				messageService.showToaster('s_2', 'admin', deleteUser.email);
				$('#deleteModal').modal('hide');
				delete $scope.deleteUser;
				$scope.usersData = deleteItemByEmail($scope.usersData, deleteUser.email);
				getResultsPage($scope.pageRequest.paging.pageNumber, $scope.pageRequest.paging.pageSize);
			}, function (error) {
				return messageService.handleError(error);
			});
		};

		function deleteItemByEmail(array, email) {
			return array.filter(function (item) {
				return item.email && item.email !== email;
			});
		}

		function parseDate() {
			var dateFormat = 'd MMMM yyyy';

			$scope.usersData.forEach(function (item) {
				item.registeredAt = $filter('date')(item.registeredAt, dateFormat);
				item.lastLogin = $filter('date')(item.lastLogin, dateFormat);
			});
		}

		$scope.show2FaModal = function (user) {
			$scope.userTwoFaSpinner = true;
			adminUsersDataService.getUserTwoFaInfo(user.businessAccountId).finally(function () {
				return $scope.userTwoFaSpinner = false;
			}).subscribe(function (_ref) {
				var data = _ref.data;

				if (!data.users.length) {
					messageService.showErrorFromBackend('Whooops', 'Seems like there are no users with 2FA set up on this account');
					return;
				}
				$scope.userTwoFaInfo = data;
				$scope.selectedAccountId = user.businessAccountId;
				$('#manageUserTwoFaModal').modal('show');
			}, function (_ref2) {
				var error = _ref2.error;
				var errorTitle = error.errorTitle,
				    errorMessage = error.errorMessage;

				messageService.showErrorFromBackend(errorTitle, errorMessage);
			});
		};

		$scope.on2FaModalClose = function () {
			$scope.selectedAccountId = null;
			$('#manageUserTwoFaModal').modal('hide');
		};

		$scope.showSubscriptionModal = function (user) {
			adminUsersDataService.getSubscriptionInfoForFreeAccess(user).subscribe(function (data) {
				return successGetUserInfo(data.data, user);
			}, function (error) {
				return messageService.handleError(error);
			});
		};

		function successGetUserInfo(data, user) {
			$scope.userInfoLocal = user;
			$scope.subscriptionInfo = data;
			$scope.currentPlan = data.currentPlan ? Object.keys(data.currentPlan.properties) : null;
			$scope.remainingTime = convertSecondsToDaysAndHoursString(data.userInfo.freeTimeRemainingBalanceInSec);
			$('#subscriptionModal').modal('show');
		}

		$scope.showMakeAmbassadorModal = function (user) {
			$scope.userInfo = user;
			getAmbassadorInfo(user);
		};

		function prepareUser(user) {
			if (!user.startDate) {
				user.startDate = new Date();
				user.startDate.setHours(0, 0, 0, 0);
			}
		}

		function getAmbassadorInfo(user) {
			ambassadorService.getAmbassadorMetadata(user.businessAccountId).subscribe(function (ambassador) {
				return successGetAmbassadorInfo(ambassador.data);
			}, function (error) {
				return messageService.handleError(error);
			});
		}

		function successGetAmbassadorInfo(ambassador) {
			prepareUser(ambassador);
			ambassador.startDate = new Date(ambassador.startDate);
			ambassador.endDate = new Date(ambassador.endDate);
			$scope.ambassador = angular.copy(ambassador);
			$('#addAmbassadorCodeModal').modal('show');
		}

		$scope.submitAmbassadorCode = function (ambassador) {
			$scope.btn_disable = true;
			var isExistedAmbassador = ambassador.isAmbassador;
			var ambassador2save = ambassadorService.validateAmbassador(ambassador);

			if (!ambassador2save) {
				$scope.btn_disable = false;
				return;
			}

			var action = void 0;
			if (isExistedAmbassador) {
				action = ambassadorsDataService.updateAmbassador(ambassador2save);
			} else {
				action = ambassadorsDataService.createAmbassador(ambassador2save);
			}

			action.then(function () {
				messageService.showToaster('s_3', 'admin', ambassador.email);
				$('#addAmbassadorCodeModal').modal('hide');
				getResultsPage($scope.pageRequest.paging.pageNumber, $scope.pageRequest.paging.pageSize);
			}).catch(function (_ref3) {
				var data = _ref3.data;
				var errorMessage = data.errorMessage,
				    errorTitle = data.errorTitle;

				messageService.showErrorFromBackend(errorTitle, errorMessage);
			}).finally(function () {
				$scope.btn_disable = false;
			});
		};

		$scope.closeAccess = function (user) {
			$scope.closeAccessUser = user;
			$('#closeAccessModal').modal('show');
			getResultsPage($scope.pageRequest.paging.pageNumber, $scope.pageRequest.paging.pageSize);
		};

		$scope.closeAccessRequest = function (closeAccessUser) {
			$scope.add_btn_disable = true;
			$scope.isAddSpinningWheelActive = true;
			adminUsersDataService.closeAccess(closeAccessUser.businessAccountId).pipe((0, _operators.finalize)(function () {
				$scope.add_btn_disable = false;
				$scope.isAddSpinningWheelActive = false;
			})).subscribe(function () {
				messageService.showToaster('s_1', 'admin', closeAccessUser.email);
				$('#closeAccessModal').modal('hide');
				getResultsPage($scope.pageRequest.paging.pageNumber, $scope.pageRequest.paging.pageSize);
			}, function (error) {
				messageService.handleError(error);
			});
		};

		function convertSecondsToDaysAndHoursString(seconds) {
			if (!seconds) return null;

			var daysData = Math.floor(seconds / (3600 * 24));
			var hoursData = Math.floor(seconds % (3600 * 24) / 3600);
			var minutesData = Math.floor(seconds % 3600 / 60);
			var result = '';
			result += daysData > 0 ? daysData + (daysData === 1 ? ' day ' : ' days ') : '';
			result += hoursData > 0 ? hoursData + (hoursData === 1 ? ' hour ' : ' hours ') : '';
			result += minutesData > 0 && !hoursData ? minutesData + (minutesData === 1 ? ' minute ' : ' minutes ') : '';

			return result;
		}
	}
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./web/js/controllers/admin/ambassadorsController.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

(function () {
	angular.module('main').controller('AmbassadorsController', AmbassadorsController);

	AmbassadorsController.$inject = ['$scope', '$rootScope', '$filter', 'messageService', 'ambassadorService', 'ambassadorsDataService', 'fileDownloadDataService', 'timeService'];

	function AmbassadorsController($scope, $rootScope, $filter, messageService, ambassadorService, ambassadorsDataService, fileDownloadDataService, timeService) {
		$scope.$on('$viewContentLoaded', function () {
			$scope.ambassador = {};

			$scope.pageRequest = {
				page: 1,
				perPage: $rootScope.paginationPerPage ? $rootScope.paginationPerPage : 25,
				pageOrder: {
					predicate: 'firstName',
					reverse: false
				},
				search: ''
			};

			$scope.ambassadors = [];
			$scope.totalItems = 0;

			getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage).then(successGetResultsPage).catch(messageService.showDefaultErrorMessage);
		});

		$scope.editAmbassador = function (ambassador) {
			$scope.btn_disable = true;
			$scope.ambassador = angular.copy(ambassador);

			$('#addAmbassadorCodeModal').modal('show');
			$scope.btn_disable = false;
		};

		$scope.exportInfo = function (ambassador) {
			ambassadorService.exportAmbassadorData(ambassador).subscribe(function (response) {
				return fileDownloadDataService.saveAmbassadorReferrals(response, ambassador);
			});
		};

		$scope.submitAmbassadorCode = function (ambassador) {
			$scope.btn_disable = true;
			var ambassador2save = ambassadorService.validateAmbassador(ambassador);

			if (!ambassador2save) {
				$scope.btn_disable = false;
				return;
			}

			ambassadorsDataService.updateAmbassador(ambassador2save).then(function () {
				$('#addAmbassadorCodeModal').modal('hide');
				messageService.showToaster('s_3', 'admin', ambassador2save.email);
				return ambassadorsDataService.getAmbassadors($scope.pageRequest);
			}).then(successGetResultsPage).catch(function (_ref) {
				var data = _ref.data;
				var errorMessage = data.errorMessage,
				    errorTitle = data.errorTitle;

				messageService.showErrorFromBackend(errorTitle, errorMessage);
			}).finally(function () {
				$scope.btn_disable = false;
			});
		};

		// get result page

		function getResultsPage() {
			var pageNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
			var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
			var predicate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
			var reverse = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

			var changed = false;

			if (predicate && reverse) {
				$scope.pageRequest.pageOrder.predicate = predicate;
				$scope.pageRequest.pageOrder.reverse = reverse;
				changed = true;
			}

			if (perPage) {
				$scope.pageRequest.perPage = perPage;
				changed = true;
			}

			if (pageNumber) {
				$scope.pageRequest.page = pageNumber;
				changed = true;
			}

			if ($scope.pageRequest && $scope.totalItems != 0 && $scope.totalItems < ($scope.pageRequest.page - 1) * $scope.pageRequest.perPage + 1) {
				console.log('out of page');
				$scope.pageRequest.page = 1;
			}
			if (changed) {
				return ambassadorsDataService.getAmbassadors($scope.pageRequest);
			}
			return false;
		}

		function successGetResultsPage(data) {
			if (data && data.pageRequest) {
				$scope.pageRequest = data.pageRequest;
				$scope.pageRequest.search = $scope.pageRequest.search || '';
			}
			$scope.pageNumbers = [];
			$scope.totalItems = data ? data.total : 0;

			var pagesCount = void 0;
			pagesCount = $scope.totalItems / $scope.pageRequest.perPage;
			pagesCount = Math.ceil(pagesCount);

			for (var i = 1; i <= pagesCount; i++) {
				$scope.pageNumbers[i - 1] = i;
			}

			$scope.ambassadors = angular.copy(data.results);

			if ($scope.ambassadors) {
				$scope.ambassadors = prepareAmbassadors($scope.ambassadors);
			}

			$scope.$evalAsync();
		}

		function prepareAmbassadors(ambassadors) {
			var ambassadors2Show = angular.copy(ambassadors);

			ambassadors2Show = timeService.convertDatesToUTC($scope.ambassadors, 'startDate', 'endDate');
			ambassadors2Show.forEach(function (ambassador) {
				return ambassador.isAmbassador = true;
			});

			return ambassadors2Show;
		}

		// navigation

		$scope.order = function (predicate) {
			if (predicate) {
				$scope.pageRequest.pageOrder.reverse = $scope.pageRequest.pageOrder.predicate === predicate ? !$scope.pageRequest.pageOrder.reverse : false;

				$scope.pageRequest.pageOrder.predicate = predicate;
			}
			$scope.ambassadors = $filter('orderBy')($scope.ambassadors, predicate, $scope.pageRequest.pageOrder.reverse);
		};

		$scope.getCurrentPage = function () {
			return $scope.pageRequest.page;
		};

		$scope.perPageChanged = function (newPerPage) {
			getResultsPage(null, newPerPage).then(successGetResultsPage);

			$rootScope.paginationPerPage = newPerPage;
		};

		$scope.goToPage = function (newPage, disabled) {
			if (!disabled) {
				getResultsPage(newPage, null).then(successGetResultsPage);
			}
		};

		$scope.jumpBack = function (disabled) {
			if (!disabled) {
				if ($scope.pageRequest.page > 1) {
					getResultsPage($scope.pageRequest.page - 1, null).then(successGetResultsPage);
				}
			}
		};

		$scope.jumpAhead = function (disabled) {
			if (!disabled) {
				if ($scope.totalItems >= $scope.pageRequest.page * $scope.pageRequest.perPage + 1) {
					getResultsPage($scope.pageRequest.page + 1, null).then(successGetResultsPage);
				}
			}
		};

		$scope.searchRequest = function (search) {
			$scope.pageRequest.search = search;

			getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage).then(successGetResultsPage);
		};
	}
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./web/js/controllers/admin/campaignsController.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

(function () {
	angular.module('main').controller('CampaignsController', CampaignsController);

	CampaignsController.$inject = ['$scope', '$rootScope', '$filter', 'messageService', 'promoCodesDataService', 'validationService', 'timeService'];

	function CampaignsController($scope, $rootScope, $filter, messageService, promoCodesDataService, validationService, timeService) {
		$scope.$on('$viewContentLoaded', function () {
			$scope.campaign = {};
			$scope.isAddSpinnningWheelActive = false;

			$scope.pageRequest = {
				page: 1,
				perPage: $rootScope.paginationPerPage ? $rootScope.paginationPerPage : 25,
				pageOrder: {
					predicate: 'id',
					reverse: false
				},
				search: ''
			};

			$scope.campaigns = [];
			$scope.totalItems = 0;

			getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage).subscribe(function (data) {
				return successGetResultsPage(data);
			});
		});

		$scope.addOrEditPromoCode = function (campaign) {
			$scope.add_btn_disable = true;
			$scope.isAddSpinnningWheelActive = true;

			$scope.campaign = angular.copy(campaign);
			$('#addPromoCode').modal('show');

			$scope.isAddSpinnningWheelActive = false;
			$scope.add_btn_disable = false;
		};

		$scope.submitPromoCode = function (campaign) {
			$scope.btn_disable = true;
			var isExistedCode = campaign.id;
			var code2save = validateCode(campaign);

			if (!code2save) {
				$scope.btn_disable = false;
				return;
			}

			var action = void 0;
			if (isExistedCode) {
				action = promoCodesDataService.updatePromoCode(code2save);
			} else {
				action = promoCodesDataService.createPromoCode(code2save);
			}

			action.finally(function () {
				return $scope.btn_disable = false;
			}).mergeMap(function () {
				$('#addPromoCode').modal('hide');
				messageService.showToaster('s_0', 'general', 'Promo code saved');
				return promoCodesDataService.getAllPromoCodes($scope.pageRequest);
			}).subscribe(function (data) {
				return successGetResultsPage(data);
			}, function (error) {
				return messageService.showDefaultErrorMessage(error);
			});
		};

		function validateCode(campaign) {
			var dateStart = void 0,
			    dateEnd = void 0;
			var validCampaign = angular.copy(campaign);

			if (validationService.isStringEmpty(campaign.name)) {
				messageService.showToaster('e_2', 'general', 'Campaign name is empty');
				return false;
			} else if (validationService.isStringEmpty(campaign.code)) {
				messageService.showToaster('e_2', 'general', 'Promocode is empty');
				return false;
			} else if (!campaign.discount) {
				messageService.showToaster('e_2', 'general', 'Discount is empty');
				return false;
			} else if (!campaign.startDate || !campaign.endDate) {
				messageService.showToaster('e_2', 'general', 'Duration is empty');
				return false;
			} else if (campaign.discount % 1 !== 0) {
				messageService.showToaster('e_2', 'general', 'Discount percent should be an integer');
				return false;
			}

			dateStart = timeService.getDateInFormat(validCampaign.startDate, 'date');
			dateEnd = timeService.getDateInFormat(validCampaign.endDate, 'date');

			var isCorrectDate = timeService.compareDates(dateEnd, dateStart);

			if (isCorrectDate) {
				messageService.showToaster('e_2', 'general', 'The start date must be before the end date.');
				return false;
			}

			validCampaign.startDate = dateStart;
			validCampaign.endDate = dateEnd;

			return validCampaign;
		}

		// get result page

		function getResultsPage() {
			var pageNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
			var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
			var predicate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
			var reverse = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

			var changed = false;

			if (predicate && reverse) {
				$scope.pageRequest.pageOrder.predicate = predicate;
				$scope.pageRequest.pageOrder.reverse = reverse;
				changed = true;
			}

			if (perPage) {
				$scope.pageRequest.perPage = perPage;
				changed = true;
			}

			if (pageNumber) {
				$scope.pageRequest.page = pageNumber;
				changed = true;
			}

			if ($scope.pageRequest && $scope.totalItems != 0 && $scope.totalItems < ($scope.pageRequest.page - 1) * $scope.pageRequest.perPage + 1) {
				console.log('out of page');
				$scope.pageRequest.page = 1;
			}
			if (changed) {
				return promoCodesDataService.getAllPromoCodes($scope.pageRequest);
			}
			return false;
		}

		function successGetResultsPage(data) {
			if (data && data.pageRequest) {
				$scope.pageRequest = data.pageRequest;
				$scope.pageRequest.search = $scope.pageRequest.search || '';
			}
			$scope.pageNumbers = [];
			$scope.totalItems = data ? data.total : 0;

			var pagesCount = void 0;
			pagesCount = $scope.totalItems / $scope.pageRequest.perPage;
			pagesCount = Math.ceil(pagesCount);

			for (var i = 1; i <= pagesCount; i++) {
				$scope.pageNumbers[i - 1] = i;
			}

			$scope.campaigns = angular.copy(data.results);
			if ($scope.campaigns) {
				$scope.campaigns = timeService.convertDatesToUTC($scope.campaigns, 'startDate', 'endDate');
			}
			$scope.campaign = {};
			$scope.$evalAsync();
		}

		// navigation

		$scope.order = function (predicate) {
			if (predicate) {
				$scope.pageRequest.pageOrder.reverse = $scope.pageRequest.pageOrder.predicate === predicate ? !$scope.pageRequest.pageOrder.reverse : false;

				$scope.pageRequest.pageOrder.predicate = predicate;
			}
			$scope.campaigns = $filter('orderBy')($scope.campaigns, predicate, $scope.pageRequest.pageOrder.reverse);
		};

		$scope.getCurrentPage = function () {
			return $scope.pageRequest.page;
		};

		$scope.perPageChanged = function (newPerPage) {
			getResultsPage(null, newPerPage).subscribe(function (data) {
				return successGetResultsPage(data);
			});

			$rootScope.paginationPerPage = newPerPage;
		};

		$scope.goToPage = function (newPage, disabled) {
			if (!disabled) {
				getResultsPage(newPage, null).subscribe(function (data) {
					return successGetResultsPage(data);
				});
			}
		};

		$scope.jumpBack = function (disabled) {
			if (!disabled) {
				if ($scope.pageRequest.page > 1) {
					getResultsPage($scope.pageRequest.page - 1, null).subscribe(function (data) {
						return successGetResultsPage(data);
					});
				}
			}
		};

		$scope.jumpAhead = function (disabled) {
			if (!disabled) {
				if ($scope.totalItems >= $scope.pageRequest.page * $scope.pageRequest.perPage + 1) {
					getResultsPage($scope.pageRequest.page + 1, null).subscribe(function (data) {
						return successGetResultsPage(data);
					});
				}
			}
		};

		$scope.searchRequest = function (search) {
			$scope.pageRequest.search = search;

			getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage).subscribe(function (data) {
				return successGetResultsPage(data);
			});
		};
	}
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./web/js/controllers/admin/referralsController.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
	angular.module('main').controller('ReferralsController', ReferralsController);

	ReferralsController.$inject = ['$scope', '$rootScope', '$filter', 'referralsDataService'];

	ReferralsController.$inject = ['$scope', '$rootScope', '$filter', 'referralsDataService', 'messageService'];

	function ReferralsController($scope, $rootScope, $filter, referralsDataService, messageService) {
		$scope.$on('$viewContentLoaded', function () {
			$scope.pageRequest = {
				page: 1,
				perPage: $rootScope.paginationPerPage ? $rootScope.paginationPerPage : 25,
				pageOrder: {
					predicate: 'id',
					reverse: false
				},
				search: ''
			};

			$scope.referrals = [];
			$scope.totalItems = 0;

			getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage).then(successGetResultsPage).catch(messageService.showDefaultErrorMessage);
		});

		// get result page

		function getResultsPage() {
			var pageNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
			var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
			var predicate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
			var reverse = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

			var changed = false;

			if (predicate && reverse) {
				$scope.pageRequest.pageOrder.predicate = predicate;
				$scope.pageRequest.pageOrder.reverse = reverse;
				changed = true;
			}

			if (perPage) {
				$scope.pageRequest.perPage = perPage;
				changed = true;
			}

			if (pageNumber) {
				$scope.pageRequest.page = pageNumber;
				changed = true;
			}

			if ($scope.pageRequest && $scope.totalItems != 0 && $scope.totalItems < ($scope.pageRequest.page - 1) * $scope.pageRequest.perPage + 1) {
				console.log('out of page');
				$scope.pageRequest.page = 1;
			}
			if (changed) {
				return referralsDataService.getAllReferrals($scope.pageRequest);
			}
			return false;
		}

		function successGetResultsPage(data) {
			if (data && data.pageRequest) {
				$scope.pageRequest = data.pageRequest;
				$scope.pageRequest.search = $scope.pageRequest.search || '';
			}
			$scope.pageNumbers = [];
			$scope.totalItems = data ? data.total : 0;

			var pagesCount = void 0;
			pagesCount = $scope.totalItems / $scope.pageRequest.perPage;
			pagesCount = Math.ceil(pagesCount);

			for (var i = 1; i <= pagesCount; i++) {
				$scope.pageNumbers[i - 1] = i;
			}

			$scope.referrals = angular.copy(data.results);
			$scope.$evalAsync();
		}

		// navigation

		$scope.order = function (predicate) {
			if (predicate) {
				$scope.pageRequest.pageOrder.reverse = $scope.pageRequest.pageOrder.predicate === predicate ? !$scope.pageRequest.pageOrder.reverse : false;

				$scope.pageRequest.pageOrder.predicate = predicate;
			}
			$scope.referrals = $filter('orderBy')($scope.referrals, predicate, $scope.pageRequest.pageOrder.reverse);
		};

		$scope.getCurrentPage = function () {
			return $scope.pageRequest.page;
		};

		$scope.perPageChanged = function (newPerPage) {
			getResultsPage(null, newPerPage).then(successGetResultsPage);

			$rootScope.paginationPerPage = newPerPage;
		};

		$scope.goToPage = function (newPage, disabled) {
			if (!disabled) {
				getResultsPage(newPage, null).then(successGetResultsPage);
			}
		};

		$scope.jumpBack = function (disabled) {
			if (!disabled) {
				if ($scope.pageRequest.page > 1) {
					getResultsPage($scope.pageRequest.page - 1, null).then(successGetResultsPage);
				}
			}
		};

		$scope.jumpAhead = function (disabled) {
			if (!disabled) {
				if ($scope.totalItems >= $scope.pageRequest.page * $scope.pageRequest.perPage + 1) {
					getResultsPage($scope.pageRequest.page + 1, null).then(successGetResultsPage);
				}
			}
		};

		$scope.searchRequest = function (search) {
			$scope.pageRequest.search = search;

			getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage).then(successGetResultsPage);
		};
	}
})();

/***/ }),

/***/ "./web/js/controllers/basePathController.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
	angular.module('main').controller('BasePathController', BasePathController);

	BasePathController.$inject = ['$scope', 'accountService'];

	function BasePathController($scope, accountService) {
		$scope.$watch('$viewContentLoaded', function () {
			checkHomePathChange();
		});

		$scope.$on('$destroy', function () {
			$scope.navObservable.unsubscribe();
		});

		function checkHomePathChange() {
			$scope.navObservable = accountService.navDataObservable.subscribe(function (data) {
				$scope.home_path = data.home_path;
			});
		}
	}
})();

/***/ }),

/***/ "./web/js/controllers/calendarController.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Rx, $) {

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

(function () {
	angular.module('main').controller('CalendarController', CalendarController);
	CalendarController.$inject = ['$scope', '$rootScope', '$location', '$q', '$filter', '$routeParams', 'appointmentService', 'calendarEventsDataService', 'extraShootService', 'jobDataService', 'messageService', 'timeService', 'workflowService', 'workflowDataService', 'jobTypesDataService', 'calendarService', 'settingsService', 'utilsService'];

	function CalendarController($scope, $rootScope, $location, $q, $filter, $routeParams, appointmentService, calendarEventsDataService, extraShootService, jobDataService, messageService, timeService, workflowService, workflowDataService, jobTypesDataService, calendarService, settingsService, utilsService) {
		$scope.$on('$viewContentLoaded', function () {
			settingsService.timeFormatSettings.subscribe(function (data) {
				if (data.weekStartsOn !== null) {
					$scope.is12TimeFormat = data.timeFormat === 'T_12';
					$scope.weekStartsOn = angular.copy(data.weekStartsOn);
					$scope.timeFormat = $scope.is12TimeFormat ? 'h:mm a' : 'HH:mm';
					bootstrapCalendar();
				}
			});
			$scope.unsubscribe = new Rx.Subject();
			subscribeToCustomizeLabelsChange();
		});

		$scope.$on('$destroy', function () {
			$scope.unsubscribe.next();
			$scope.unsubscribe.complete();
		});

		function subscribeToCustomizeLabelsChange() {
			settingsService.customizeLabelsObservable.takeUntil($scope.unsubscribe).subscribe(function (customizeLabels) {
				$scope.mainShootLabelName = customizeLabels.mainShootLabel;
				$scope.extraShootLabelName = customizeLabels.extraShootLabel;
				$scope.businessNumberLabelName = customizeLabels.businessNumberLabel;
				$scope.businessNumberLabelName = customizeLabels.businessNumberLabel;
			});
		}
		function bootstrapCalendar() {
			setWeekDays();
			$scope.equals = angular.equals;
			$scope.date = new Date().getTime();

			$scope.now = new Date();
			$scope.now.setHours(12, 0, 0, 0);

			$scope.isAddNewSpinnningWheelActive = false;

			if (!$scope.calendarCurrent) {
				$scope.calendarCurrent = new Date($scope.now);
			}

			if ($routeParams.calendarView) {
				$scope.month = $routeParams.calendarView !== 'week';
			} else {
				$scope.month = true;
			}

			if ($routeParams.eventId) {
				$scope.eventIdToOpen = $routeParams.eventId;
			}

			$scope.changeView = $routeParams.calendarView !== 'week' ? 'Month' : 'Week';

			$scope.getCalendarView();

			$scope.hours = [];
			$scope.activeJobs = [];
			$scope.workflowNames = [];
			$scope.jobTypes = [];
			$scope.isDisabled = false;
			var timeSeparatorShow = new Date($scope.now);
			timeSeparatorShow.setHours(6, 0, 0, 0);
			$scope.timeSeparatorShow = timeSeparatorShow;

			for (var i = 0; i <= 23; i++) {
				var time = new Date($scope.now);
				time.setHours(i, 0, 0, 0);
				$scope.hours.push(time);
			}
		}

		function setWeekDays() {
			$scope.fullDaysOfWeek = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
			$scope.daysOfWeek = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
			$scope.helpArray = [1, 2, 3, 4, 5, 6, 0];
			$scope.startDay = 1;
			$scope.endDay = 0;
			$scope.weekOffset = 1;

			switch ($scope.weekStartsOn) {
				case 'SATURDAY':
					modifyWeekArrays(2);
					$scope.helpArray = [6, 0, 1, 2, 3, 4, 5];
					$scope.startDay = 6;
					$scope.endDay = 5;
					$scope.weekOffset = -1;
					break;
				case 'SUNDAY':
					modifyWeekArrays(1);
					$scope.helpArray = [0, 1, 2, 3, 4, 5, 6];
					$scope.startDay = 0;
					$scope.endDay = 6;
					$scope.weekOffset = 0;
					break;
				default:
					break;
			}

			$scope.open = function ($event) {
				$event.preventDefault();
				$scope.opened = true;
			};
			$scope.status = {
				opened: false
			};
		}

		function modifyWeekArrays(quantity) {
			var _$scope$fullDaysOfWee, _$scope$daysOfWeek;

			var rightPart = $scope.fullDaysOfWeek.splice($scope.fullDaysOfWeek.length - quantity, $scope.fullDaysOfWeek.length);
			(_$scope$fullDaysOfWee = $scope.fullDaysOfWeek).unshift.apply(_$scope$fullDaysOfWee, _toConsumableArray(rightPart));

			rightPart = $scope.daysOfWeek.splice($scope.daysOfWeek.length - quantity, $scope.daysOfWeek.length);
			(_$scope$daysOfWeek = $scope.daysOfWeek).unshift.apply(_$scope$daysOfWeek, _toConsumableArray(rightPart));
		}

		var isBlockRequest = false;

		$scope.timeSeparatorShow = true;

		$scope.toggleHidenHours = function () {
			$scope.timeSeparatorShow = !$scope.timeSeparatorShow;
		};

		$scope.jump = function (step) {
			var isToday = !step;
			getView(isToday, step);
		};

		$scope.selectMonth = function () {
			getView();
		};

		$scope.filters = [{
			name: 'leads',
			change: true,
			criteria: {
				column: 'inLead',
				value: true
			}
		}, {
			name: 'jobs',
			change: true,
			criteria: {
				column: 'inLead',
				value: false
			}
		}];

		// filter for appointment who has no jobs and leads
		var defaultFilter = [{
			name: 'Default filter',
			change: true,
			criteria: {
				column: 'inLead',
				value: null
			}
		}];

		$scope.changeCheckboxFilters = function () {
			var events = eventsFilter($scope.allEvents);
			if ($routeParams.calendarView !== 'week') {
				showBlancCalendar();
				fillMonthEvents(events);
			} else {
				showBlancWeekCalendar();
				fillWeekEvents(events);
			}
		};

		function eventsFilter(events) {
			var filters = $scope.filters.concat(defaultFilter);

			var newArr = [];

			events.forEach(function (event) {
				for (var i = 0; i < filters.length; i++) {
					if (!filters[i].change) {
						continue;
					}
					if (event[filters[i].criteria.column] === filters[i].criteria.value) {
						newArr.push(event);
						break;
					}
				}
			});

			return newArr;
		}

		$scope.changeViewSelect = function () {
			$scope.toggleView($scope.changeView);
		};

		$scope.toggleView = function (view) {
			$scope.month = !(view == 'Week');
			view === 'Week' ? getView(false, 0, null, true) : getView(false, 0);
		};

		var fillMonthEvents = function fillMonthEvents(events) {
			events = fillCalendarFilter(events);

			$scope.dates.forEach(function (day) {
				events.forEach(function (event) {
					var iterationEvent = angular.copy(event);
					if (calendarService.isCorrectDate(iterationEvent, day)) {
						day.events.push(iterationEvent);
					}
				});
				if (day.events.length >= 2) {
					day.events = day.events.sort(sortByDateTime);
				}
			});

			checkIfNeedToOpenEvent(events);
		};

		var fillWeekEvents = function fillWeekEvents(events) {
			events = fillCalendarFilter(events);

			$scope.week.forEach(function (day) {
				events.forEach(function (event) {
					var iterationEvent = angular.copy(event);

					if (calendarService.isCorrectDate(iterationEvent, day)) {
						if (!iterationEvent.startTime) {
							day.allDayEvents.push(iterationEvent);
						} else {
							fillWeekHours(iterationEvent, day.hours);
						}
					}
				});
			});

			checkIfNeedToOpenEvent(events);
		};

		function getEvents(start, end, callback) {
			var format = 'yyyy-MM-dd';
			isBlockRequest = true;

			calendarEventsDataService.getEventsForPage(start, end, format).finally(function () {
				return isBlockRequest = false;
			}).subscribe(function (data) {
				$scope.allEvents = data;
				var events = eventsFilter($scope.allEvents);
				callback(events);
			}, function (error) {
				return messageService.showDefaultErrorMessage(error);
			});
		}

		$scope.getCalendarView = function () {
			if ($routeParams.calendarDate && Date.parse($routeParams.calendarDate)) {
				getView(false, 0, $routeParams.calendarDate);
			} else {
				getView(false, 0);
			}
		};

		function showGeneralErrorMessage() {
			messageService.showToaster('e_0', 'general');
		}

		function getView(today, step, calendarDate, resetWeek) {
			if (isBlockRequest) {
				return false;
			}
			if (calendarDate) {
				$scope.calendarCurrent = new Date(calendarDate);
			} else if (!step && today) {
				$scope.calendarCurrent = new Date($scope.now);
			} else if (!step && !today) {
				$scope.calendarCurrent = new Date($scope.calendarCurrent);
			} else if ($scope.month) {
				var y = $scope.calendarCurrent.getFullYear();
				var m = $scope.calendarCurrent.getMonth();

				var firstDay = new Date(y, m, 1, 12);

				$scope.first = firstDay;
				$scope.calendarCurrent = new Date(firstDay);
				$scope.calendarCurrent.setMonth($scope.calendarCurrent.getMonth() + step);
			}

			if ($scope.month) {
				handleMonthView();
			} else {
				handleWeekView(today, step, resetWeek);
			}

			$location.search('calendarView', $scope.month ? 'month' : 'week');
			$location.search('calendarDate', $scope.calendarCurrent.toISOString()).replace();
		}

		function handleMonthView() {
			var y = void 0,
			    m = void 0;

			$scope.first = new Date($scope.calendarCurrent);
			$scope.selected = {};

			y = $scope.calendarCurrent.getFullYear();
			m = $scope.calendarCurrent.getMonth();

			var firstDay = new Date(y, m, 1, 12);
			var lastDay = new Date(y, m + 1, 0, 12);

			$scope.first = firstDay;

			if ($scope.first.getDay() != $scope.startDay) {
				$scope.first.setDate($scope.first.getDate() - $scope.helpArray.findIndex(function (d) {
					return d === $scope.first.getDay();
				}));
			}
			$scope.last = angular.copy(lastDay);

			if ($scope.last.getDay() != $scope.endDay) {
				$scope.last.setDate($scope.last.getDate() + (6 - $scope.helpArray.findIndex(function (d) {
					return d === $scope.last.getDay();
				})));
			}

			showBlancCalendar();
			getEvents($scope.first, $scope.last, fillMonthEvents);
		}

		function handleWeekView(today, direction, resetWeek) {
			if (!$rootScope.weekFirst || resetWeek) {
				$rootScope.weekFirst = angular.copy($scope.calendarCurrent);
			} else if (today) {
				$scope.calendarCurrent = new Date($scope.now);
				$rootScope.weekFirst = angular.copy($scope.calendarCurrent);
			}

			if ($rootScope.weekFirst.getDay() != $scope.startDay) {
				var val = $rootScope.weekFirst.getDate();

				if (direction > 0) {
					val += 7 - $rootScope.weekFirst.getDay();
				} else {
					val -= $rootScope.weekFirst.getDay();
				}

				$rootScope.weekFirst.setDate(val + $scope.weekOffset);
			} else if (direction) {
				var offset = direction > 0 ? 7 : '-7';

				$rootScope.weekFirst.setDate($rootScope.weekFirst.getDate() + +offset);
				$scope.calendarCurrent = angular.copy($rootScope.weekFirst);
			}

			$scope.weekLast = angular.copy($rootScope.weekFirst);
			$scope.weekLast.setDate($scope.weekLast.getDate() + 6);

			showBlancWeekCalendar();
			getEvents($rootScope.weekFirst, $scope.weekLast, fillWeekEvents);
		}

		function showBlancCalendar() {
			$scope.weeks = [];
			$scope.dates = [];

			var iterationDate = angular.copy($scope.first);
			var index = 0;
			var indexY = -1;
			while (iterationDate.getTime() <= $scope.last.getTime()) {
				var dayDate = new Date(iterationDate);
				var day = {
					year: dayDate.getFullYear(),
					month: dayDate.getMonth(),
					day: dayDate.getDate(),
					date: dayDate,
					events: []
				};
				$scope.dates.push(day);

				if (index == 0) {
					indexY++;
					$scope.weeks[indexY] = [];
					$scope.weeks[indexY].push(day);
					index++;
				} else if (index == 6) {
					index = 0;
					$scope.weeks[indexY].push(day);
				} else {
					$scope.weeks[indexY].push(day);
					index++;
				}
				iterationDate.setDate(iterationDate.getDate() + 1);
			}
		}

		function showBlancWeekCalendar() {
			$scope.week = [];
			$scope.weekDates = [];
			var iterationDate = angular.copy($rootScope.weekFirst);
			var index = 0;
			var indexY = -1;
			while (iterationDate.getTime() <= $scope.weekLast.getTime()) {
				var dayDate = new Date(iterationDate);

				var day = {
					year: dayDate.getFullYear(),
					month: dayDate.getMonth(),
					day: dayDate.getDate(),
					date: dayDate,
					hours: [],
					allDayEvents: []
				};

				for (var i = 0; i <= 23; i++) {
					var time = new Date(iterationDate);
					time.setHours(i, 0, 0, 0);

					var hour = {
						time: time,
						events: []
					};
					day.hours.push(hour);
				}
				$scope.week.push(day);
				$scope.weekDates.push(day);
				var event = null;

				iterationDate.setDate(iterationDate.getDate() + 1);
			}
		}

		function fillCalendarFilter(eventsData) {
			var data = angular.copy(eventsData);

			data = $filter('orderBy')(data, function (value) {
				value.startTime != null ? timeService.getHour(value.startTime) : 1000;
			}, false);
			return data;
		}

		// fix this code by ESlint rules (no-confusing-arrow)
		function fillWeekHours(event, hours) {
			hours.forEach(function (hour) {
				if (calendarService.isCorrectHours(event, hour.time)) {
					hour.events.push(event);
				}
			});
		}

		$scope.noCurrentDate = function (firstDate, secondDate) {
			return calendarService.noCurrentDate(firstDate, secondDate);
		};

		// new event

		$scope.addNew = function () {
			$scope.selected = {};
			$('#addNewModal').modal('show');
		};

		$scope.newEvent = function (date, time) {
			var startTime = null;
			var endTime = null;
			var endTimeHours = void 0;

			if (time && time != null) {
				startTime = new Date(time);
				endTime = angular.copy(startTime);

				endTime.setHours(startTime.getHours() + 1);
				endTimeHours = startTime.getHours() + 1;

				if (!$scope.is12TimeFormat && startTime.getHours() === 23) {
					endTimeHours = 0;
				}

				startTime = $scope.is12TimeFormat ? timeService.convertDateTo12(startTime) : startTime.getHours() + ':0' + startTime.getMinutes();
				endTime = $scope.is12TimeFormat ? timeService.convertDateTo12(endTime) : endTimeHours + ':0' + endTime.getMinutes();
			}

			$scope.selected = {
				date: date,
				startTime: startTime,
				endTime: endTime
			};

			$('#addNewModal').modal('show');
		};

		function addEventWithDateTime(dateTime) {
			return {
				id: null,
				name: '',
				startDate: dateTime.date,
				endDate: dateTime.date,
				startTime: dateTime.startTime,
				endTime: dateTime.endTime
			};
		}

		function chooseEventModal(event) {
			if (event && event.calendarEventType === 'APPOINTMENT') {
				appointmentService.prepareAppointmentToShow(event).subscribe(function (appointment) {
					workflowService.setTaskInfo(appointment);
					$('#appointment').modal('show');
				});
			} else if (event && event.calendarEventType === 'EXTRA_SHOOT') {
				var extraShoot = extraShootService.prepareExtraShootToShow(event);
				workflowService.setTaskInfo(extraShoot);
				$('#extraShootModal').modal('show');
			} else {
				workflowService.setTaskInfo({});
				$('#appointment').modal('show');
			}
		}

		$scope.editEventModal = function (event, $event) {
			if ($event && $event.stopPropagation) {
				$event.stopPropagation();
			}
			if (event && event.calendarEventType === 'MAIN_SHOOT') {
				return;
			}
			getActiveJobs().then(function () {
				chooseEventModal(event);
			});
		};

		// add new job
		function getJobTypes() {
			return jobTypesDataService.getJobTypes().map(function (data) {
				return successGetJobTypes(data);
			});
		}

		function successGetJobTypes(data) {
			$scope.newJob.jobTypes = angular.copy(data);
		}

		function getWorkflowAndLanguageNames() {
			return workflowDataService.getWorkflowAndLanguageNames().map(function (data) {
				return successGetWorkflowAndLanguageNames(data);
			});
		}

		function successGetWorkflowAndLanguageNames(data) {
			if (!data) {
				return false;
			}
			$scope.newJob.workflowNames = angular.copy(data.workflows);
			$scope.newJob.languageNames = angular.copy(data.languages);
		}

		function showNewJobModal(event) {
			var selectModal = '#addNewModal',
			    nextModal = '#newJob';
			$scope.button_disable = false;
			utilsService.showNextModal(selectModal, nextModal, event);
			$scope.isCreateJobSpinnningWheelActive = false;
			$scope.$broadcast('showModalJob', $scope.newJob);
		}

		function showNewLeadModal(event) {
			var selectModal = '#addNewModal',
			    nextModal = '#newLead';
			$scope.button_disable = false;
			utilsService.showNextModal(selectModal, nextModal, event);
			$scope.isCreateJobSpinnningWheelActive = false;
			$scope.$broadcast('showModal', {
				lead: $scope.newJob
			});
		}

		$scope.showAddNewJobModal = function (event) {
			$scope.button_disabled = true;
			$scope.isDisabled = true;
			$scope.isAddNewSpinnningWheelActive = true;

			if ($scope.selected && $scope.selected.date) {
				$scope.newJob = addJobWithDateTime($scope.selected);
			} else {
				$scope.newJob = {};
			}

			$scope.clients = [];

			Rx.Observable.zip(getJobTypes(), getWorkflowAndLanguageNames()).takeUntil($scope.unsubscribe).finally(function () {
				$scope.button_disable = false;
				$scope.isDisabled = false;
				$scope.isAddNewSpinnningWheelActive = false;
			}).subscribe(function () {
				$scope.newJob.type = $scope.jobTypes[0];
				showNewJobModal(event);
			});
		};

		$scope.showAddNewLeadModal = function (event) {
			$scope.button_disabled = true;
			$scope.isDisabled = true;
			$scope.isAddNewSpinnningWheelActive = true;

			if ($scope.selected && $scope.selected.date) {
				$scope.newJob = addJobWithDateTime($scope.selected);
			} else {
				$scope.newJob = {};
			}

			$scope.clients = [];

			Rx.Observable.zip(getJobTypes(), getWorkflowAndLanguageNames()).takeUntil($scope.unsubscribe).finally(function () {
				$scope.button_disable = false;
				$scope.isDisabled = false;
				$scope.isAddNewSpinnningWheelActive = false;
			}).subscribe(function () {
				$scope.newJob.type = $scope.jobTypes[0];
				showNewLeadModal(event);
			});
		};

		function addJobWithDateTime(dateTime) {
			return {
				finishDate: dateTime.date || null,
				startDate: dateTime.date || null,
				startTime: dateTime.startTime || null,
				finishTime: dateTime.endTime || null
			};
		}

		// extra shoots

		$scope.showAddExtraShootModal = function (event) {
			$scope.button_disable = true;
			event.preventDefault();

			$('#addNewModal').modal('hide').on('hidden.bs.modal', function () {
				var _this = this;

				getActiveJobs().then(function () {
					addNewExtraShoot();
					$scope.button_disable = false;
					$('#extraShootModal').modal('show');
					$(_this).off('hidden.bs.modal');
				});
			});
		};

		function addNewExtraShoot() {
			if ($scope.selected && $scope.selected.date) {
				var extraShoot = addEventWithDateTime($scope.selected);
				workflowService.setTaskInfo(extraShoot);
				if (!$scope.$$phase) {
					$scope.$apply();
				}
			} else {
				workflowService.setTaskInfo({});
				$scope.$evalAsync();
			}
		}

		// appointments

		$scope.showAppointmentModal = function (event) {
			$scope.button_disable = true;
			event.preventDefault();

			$('#addNewModal').modal('hide').on('hidden.bs.modal', function () {
				var _this2 = this;

				getActiveJobs().then(function () {
					addNewAppointment();
					$scope.button_disable = false;
					$('#appointment').modal('show');
					$(_this2).off('hidden.bs.modal');
				});
			});
		};

		function addNewAppointment() {
			if ($scope.selected && $scope.selected.date) {
				var appointment = addEventWithDateTime($scope.selected);
				workflowService.setTaskInfo(appointment);
				if (!$scope.$$phase) {
					$scope.$apply();
				}
			} else {
				workflowService.setTaskInfo({});
				$scope.$evalAsync();
			}
		}

		function getActiveJobs() {
			var deferred = $q.defer();

			if (!$scope.activeJobs.length) {
				jobDataService.getActiveJobs().then(function (jobs) {
					$scope.activeJobs = jobs;
					deferred.resolve(jobs);
				}).catch(messageService.showDefaultErrorMessage);
			} else {
				deferred.resolve($scope.activeJobs);
			}

			return deferred.promise;
		}

		function sortByDateTime(a, b) {
			if (timeService.convertTimeToSeconds(a.startTime) < timeService.convertTimeToSeconds(b.startTime)) {
				return -1;
			}
			return 1;
		}

		function checkIfNeedToOpenEvent(events) {
			if ($scope.eventIdToOpen) {
				var _events$filter = events.filter(function (e) {
					return e.id.toString() === $scope.eventIdToOpen;
				}),
				    _events$filter2 = _slicedToArray(_events$filter, 1),
				    event = _events$filter2[0];

				if (event) {
					chooseEventModal(event);
				}

				$scope.eventIdToOpen = false;
			}
		}
	}
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/rxjs/Rx.js"), __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./web/js/controllers/clientProfileController.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Rx, $, toastr) {

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
	angular.module('main').controller('ClientProfileController', ClientProfileController);

	ClientProfileController.$inject = ['$scope', '$rootScope', '$routeParams', '$location', '$http', 'messageService', 'jobDataService', 'validationService', 'clientsDataService', 'notesDataService', 'emailService', 'timeService', 'templateRequestsService', 'utilsService', 'jobTypesDataService', 'workflowDataService', 'leadDataService', 'stringModifierService', 'mailsDataService', 'settingsService'];

	function ClientProfileController($scope, $rootScope, $routeParams, $location, $http, messageService, jobDataService, validationService, clientsDataService, notesDataService, emailService, timeService, templateRequestsService, utilsService, jobTypesDataService, workflowDataService, leadDataService, stringModifierService, mailsDataService, settingsService) {
		function removeParameters() {
			var _$location$search = $location.search(),
			    calendarView = _$location$search.calendarView,
			    calendarDate = _$location$search.calendarDate,
			    page = _$location$search.page,
			    search = _$location$search.search;

			if (calendarView || calendarDate || page || search) {
				$location.search({}).replace();
			}
		}

		$scope.$on('$viewContentLoaded', function () {
			removeParameters();
			getContact();

			$scope.isAddNewJobSpinningWheelActive = false;
			$scope.isSaveNotesSpinningWheelActive = false;
			$scope.isCreateClientModalSpinningWheelActive = false;
			$scope.isGetMailsSpinningWheelActive = true;
			$scope.leadSourcesAvailable = true;
			$scope.sendEmailLeadId = null;
			$scope.workflowNames = [];
			$scope.primaryContact = null;
			$scope.unsubscribe = new Rx.Subject();
			$scope.customToken = null;

			subscribeToCustomizeLabelsChange();
			getSettings();
		});

		$scope.$on('$destroy', function () {
			$scope.unsubscribe.next();
			$scope.unsubscribe.complete();
		});

		$scope.notes = '';

		function subscribeToCustomizeLabelsChange() {
			settingsService.customizeLabelsObservable.takeUntil($scope.unsubscribe).subscribe(function (customizeLabels) {
				$scope.mainShootLabelName = customizeLabels.mainShootLabel;
				$scope.extraShootLabelName = customizeLabels.extraShootLabel;
				$scope.businessNumberLabelName = customizeLabels.businessNumberLabel;
			});
		}

		function getSettings() {
			settingsService.timeFormatSettings.takeUntil($scope.unsubscribe).subscribe(function (data) {
				$scope.leadSourcesAvailable = data.leadSourcesAvailable;
			});
		}

		$scope.archivedLead = function (leadId) {
			leadDataService.archiveLead(leadId).subscribe(function () {
				messageService.showToaster('s_5', 'lead');
				getContact();
			}, function (error) {
				var errorMessage = error.error.errorMessage;

				if (errorMessage.includes('Lead contains invoices.')) {
					messageService.showToaster('e_4', 'lead');
				} else {
					messageService.showDefaultErrorMessage(error);
				}
			});
		};

		$scope.unArchivedLead = function (leadId) {
			leadDataService.unarchiveLead(leadId).subscribe(function () {
				messageService.showToaster('s_6', 'lead');
				getContact();
			}, function (error) {
				messageService.showDefaultErrorMessage(error);
			});
		};

		function getContact() {
			clientsDataService.getClient($routeParams.id).map(function (data) {
				return removeClientMails(data);
			}).subscribe(function (data) {
				$scope.data = data;
				$scope.leads = data.leads;
				$scope.jobs = data.jobs;
				$scope.firstName = $scope.data.contact.firstName;
				$scope.lastName = $scope.data.contact.lastName;
				$scope.primaryContact = data.contact;
				$scope.totalInvoiced = data.totalInvoiced;
				$scope.totalPaymentAmountWithCurrency = data.totalPaymentAmount.amountWithCurrency;

				$scope.getMails(false);
			}, function (error) {
				var errorCode = error.error.errorCode;

				if (errorCode === 102 || errorCode === 104) {
					messageService.showToaster('e_9', 'clients');
				} else {
					messageService.showDefaultErrorMessage(error);
				}
				$location.path('/clients');
			});
		}

		$scope.saveNotes = function () {
			var note2Save = void 0;
			$scope.isSaveNotesSpinningWheelActive = true;

			if ($scope.notes) {
				note2Save = $scope.notes;
			} else {
				note2Save = $('.in').find('.textarea-quad').find('[id^="taTextElement"]').last().html() || '';
			}

			var isEmpty = note2Save === '<p></p>' || note2Save === '<p><br></p>';

			var notesTmp = !isEmpty ? $rootScope.addMaiStyling(note2Save) : '';

			var data4Save = {
				id: $scope.data.contact.id,
				notes: notesTmp
			};

			notesDataService.saveNotes(data4Save, true).finally(function () {
				$scope.isSaveNotesSpinningWheelActive = false;
			}).subscribe(function (data) {
				return successSaveNotes(data, notesTmp);
			}, function () {
				return toastr.error('Error save note', 'Error');
			});
		};

		function successSaveNotes(data, notesTemp) {
			$scope.$evalAsync();
			if (data.errorMessage) {
				toastr.error(data.errorMessage, 'Error');
			} else {
				$scope.notes = notesTemp;
				getContact();
				$('#updateModal').modal('hide');
				toastr.success(data.message, 'Success');
			}
		}

		$scope.saveChanges = function () {
			$scope.isCreateClientModalSpinningWheelActive = true;

			if (!validationService.isEmailValid($scope.editClient.email)) {
				$scope.isCreateClientModalSpinningWheelActive = false;

				return messageService.showToaster('e_3', 'companyUsers');
			}

			if (validationService.isStringEmpty($scope.editClient.firstName)) {
				$scope.isCreateClientModalSpinningWheelActive = false;

				return messageService.showToaster('e_4', 'clients');
			}

			if (!$scope.companyNameChecked) {
				delete $scope.editClient.companyName;
				delete $scope.editClient.businessNumber;
			}

			clientsDataService.updateClient($scope.editClient).subscribe(function (data) {
				return successSaveChanges(data);
			}, function (error) {
				return errorSaveChanges(error.data);
			}, function () {
				return $scope.isCreateClientModalSpinningWheelActive = false;
			});
		};

		function successSaveChanges(data) {
			if (data.errorMessage) {
				messageService.showToaster('e_2', 'general', data.errorMessage);
			} else {
				delete $scope.editClient;
				getContact();
				$('#editClient').modal('hide');
				toastr.success(data.message, 'Success');
			}
		}

		function errorSaveChanges(data) {
			if (data.errorMessage === 'Job contact cannot be changed because invoice has Xero payment') {
				messageService.showToaster('e_10', 'clients');
			} else if (data.errorMessage === 'Sorry, this customer has been deleted on QuickBooks') {
				messageService.showToaster('e_23', 'qb');
			} else {
				messageService.showToaster('e_6', 'clients');
			}
			$scope.isCreateClientModalSpinningWheelActive = false;
		}

		$scope.showEdit = function () {
			$scope.editClient = angular.copy($scope.data.contact);
			$scope.companyNameChecked = !!$scope.editClient.companyName || !!$scope.editClient.businessNumber;
			$('#editClient').modal('show').on('shown.bs.modal', function () {
				var input = $(this).find('input');
				validationService.isModalClosePrevented(input);
			});
		};

		function getJobTypes() {
			return jobTypesDataService.getJobTypes().map(function (data) {
				return successGetJobTypes(data);
			});
		}

		function successGetJobTypes(data) {
			if ($scope.newJob !== undefined) {
				$scope.newJob.jobTypes = angular.copy(data);
			} else if ($scope.lead !== undefined) {
				$scope.lead.jobTypes = angular.copy(data);
			} else if ($scope.job !== undefined) {
				$scope.job.jobTypes = angular.copy(data);
			}
		}

		function getWorkflowAndLanguageNames() {
			return workflowDataService.getWorkflowAndLanguageNames().map(function (data) {
				return successGetWorkflowAndLanguageNames(data);
			});
		}

		function successGetWorkflowAndLanguageNames(data) {
			if (!data) {
				return false;
			}
			if ($scope.newJob !== undefined) {
				$scope.newJob.workflowNames = angular.copy(data.workflows);
				$scope.newJob.languageNames = angular.copy(data.languages);
			} else if ($scope.lead !== undefined) {
				$scope.lead.workflowNames = angular.copy(data.workflows);
				$scope.lead.languageNames = angular.copy(data.languages);
			} else if ($scope.job !== undefined) {
				$scope.job.workflowNames = angular.copy(data.workflows);
				$scope.job.languageNames = angular.copy(data.languages);
			}
		}

		function prepareJobToEdit(job, type) {
			if (type !== 'job' && type !== 'lead') {
				console.log('wrong type was provided');
				return;
			}

			$scope[type].id = job.id;
			$scope.clients = [];

			var _$scope$type = $scope[type],
			    workflow = _$scope$type.workflow,
			    startDate = _$scope$type.startDate,
			    startTime = _$scope$type.startTime,
			    finishTime = _$scope$type.finishTime,
			    finishDate = _$scope$type.finishDate,
			    primaryContact = _$scope$type.primaryContact,
			    secondaryContact = _$scope$type.secondaryContact;


			$scope[type].oldWorkflow = workflow;
			if (type === 'job') {
				$scope[type].workflow.name = stringModifierService.addSelectedText($scope[type].workflow.name);
				var isWorkflowSaved = $scope[type].workflowNames.find(function (workflow) {
					return workflow.id === $scope[type].workflow.id;
				});
				if ($scope[type].workflowNames && !isWorkflowSaved) {
					$scope[type].workflowNames.push($scope[type].workflow);
				}
			}

			if (!$scope[type].startDate) {
				$scope[type].hasNoDate = true;
			} else {
				$scope[type].hasNoDate = false;
				$scope[type].startDate = timeService.createDateAsUTC(startDate);
				$scope[type].finishDate = timeService.createDateAsUTC(finishDate);
			}
			if (type === 'lead' && $scope[type].startTime) {
				$scope[type].startTime = timeService.getTimeConvertedTo12(startTime);
				$scope[type].finishTime = timeService.getTimeConvertedTo12(finishTime);
			}
			if (primaryContact) {
				var primaryClientSearchText = jobDataService.fillClientSearchText(primaryContact);
				$scope.clients[0] = primaryClientSearchText;
				$scope[type].primaryContact = $scope.clients[0];
			}

			if (secondaryContact) {
				var secondaryClientSearchText = jobDataService.fillClientSearchText(secondaryContact);
				$scope.clients[1] = secondaryClientSearchText;
				$scope[type].secondaryContact = $scope.clients[1];
			}

			if ($scope[type].startDate && ($scope[type].startTime === null || $scope[type].finishTime === null)) {
				$scope[type].allday = true;
			}
		}

		function showNewLeadModal(event) {
			var selectModal = '#addNewModal',
			    nextModal = '#newLead';
			$scope.button_disable = false;
			$scope.isCreateJobSpinnningWheelActive = false;
			utilsService.showNextModal(selectModal, nextModal, event);
			$scope.$broadcast('showModal', {
				lead: $scope.newJob
			});
			delete $scope.newJob;
		}

		$scope.getMails = function (syncReply) {
			if (syncReply) {
				$rootScope.isMailResyncInProcess = true;
			}
			var subscription = mailsDataService.getContactMails($scope.primaryContact.id, syncReply).subscribe(function (data) {
				return successGetMails(data.data, syncReply, subscription);
			}, function (error) {
				return errorGetMails(error, syncReply, subscription);
			});
		};

		function successGetMails(data, syncReply, subscription) {
			var lastSyncResult = data.lastSyncResult,
			    mails = data.mails;

			$scope.data.mails = mails;

			// check if google gmail service synchronized
			if (lastSyncResult && lastSyncResult != null) {
				// Show time for synchronized block
				$scope.isGoogleMailSynchronized = true;
				$scope.googleMailLastSyncDate = lastSyncResult.replySynchronizedAt;

				if (syncReply) {
					showCorrectMessage(lastSyncResult);
				}
			}

			if (syncReply) {
				$rootScope.isMailResyncInProcess = false;
			}

			subscription.unsubscribe();
		}

		function showCorrectMessage(lastSyncResult) {
			var status = lastSyncResult.status.toLowerCase();
			var messageType = messageService.getCorrectMessageType(status);

			if (status === 'ok') {
				messageService.showToaster('s_0', 'email');
			} else {
				messageService.showMessageFromBackend(messageType, lastSyncResult.messageDetails.title, lastSyncResult.messageDetails.message);
			}
		}

		function errorGetMails(error, syncReply, subscription) {
			if (syncReply) {
				$rootScope.isMailResyncInProcess = false;
			}
			messageService.showDefaultErrorMessage(error);
			subscription.unsubscribe();
		}

		// ATTENTION: Temporary hotfix, to resolve SN-2444.
		function removeClientMails(data) {
			data.mails = [];
			return data;
		}

		$scope.showDeleteModalClient = function (id) {
			$scope.contactForDelete = id;
			$scope.checkForDelete();
		};

		$scope.checkForDelete = function () {
			$scope.button_disable = true;
			clientsDataService.checkBeforeDelete($scope.contactForDelete).finally(function () {
				$scope.button_disable = false;
			}).subscribe(function () {
				return $('#deleteModalClient').modal('show');
			}, function (result) {
				if (result.error && result.error.errorCode) {
					$scope.clientDeleteErrorMessage = result.error.errorMessage;
					$('#errorMessageModal').modal('show');
				} else {
					messageService.showDefaultErrorMessage(result);
				}
			});
		};
		$scope.deleteContact = function () {
			$scope.isDeleteContactSpinnningWheelActive = true;
			clientsDataService.deleteClient($scope.contactForDelete).finally(function () {
				$scope.isDeleteContactSpinnningWheelActive = false;
			}).subscribe(function (data) {
				if (data.errorMessage) {
					$('#deleteModalClient').modal('hide').on('hidden.bs.modal', function () {
						$scope.clientDeleteErrorMessage = data.errorMessage;
						$('#errorMessageModal').modal('show');
						$(this).off('hidden.bs.modal');
					});
				} else {
					messageService.showToaster('s_0', 'clients');

					$('#deleteModalClient').modal('hide');
					$location.path('/clients');
				}
			}, function () {
				toastr.error('Request to server failed!', 'Error');
			});
		};

		$scope.updateCustomToken = function (token) {
			$scope.customToken = null;
			requestAnimationFrame(function () {
				return $scope.customToken = token;
			});
		};

		$scope.openSendMailModal = function (contact, lead) {
			delete $scope.mailData2Save;
			delete $scope.clientMailData;
			$scope.button_disable = true;

			Rx.Observable.zip(templateRequestsService.getTemplates('general_preview'), templateRequestsService.getTemplates('email_signature')).takeUntil($scope.unsubscribe).finally(function () {
				$scope.button_disable = false;
			}).subscribe(function (_ref) {
				var _ref2 = _slicedToArray(_ref, 2),
				    emails = _ref2[0],
				    mailSignature = _ref2[1];

				$scope.mailData2Save = angular.copy(contact);
				$scope.mailData2Save.emails = emails;
				$scope.mailData2Save.mailSignature = mailSignature.signature || '';
				$rootScope.clientToken = false;

				if (lead && lead.secondaryContact) {
					contact.email === lead.primaryContact.email ? $scope.mailData2Save.secondaryEmail = lead.secondaryContact.email : $scope.mailData2Save.secondaryEmail = lead.primaryContact.email;
				}

				if (!$scope.$$phase) {
					$scope.$apply();
				}

				if (lead) {
					$routeParams.leadId = lead.id;
				}

				$scope.sendEmailLeadId = lead ? lead.id : null;

				$('#sendContactEmailModal').modal('show');
			});
		};

		$scope.openSendEmailForReply = function () {
			$scope.updateCustomToken('CLIENT_MENU');
			utilsService.closeAllModalsAndOpenNew('#sendContactEmailModal');
		};

		$scope.showDeleteModal = function (id) {
			$scope.leadForDelete = id;
			$('#deleteModal').modal('show');
		};

		$scope.showDeleteModalJob = function (id) {
			$scope.jobForDelete = id;
			$('#deleteModalJob').modal('show');
		};

		$scope.deleteLead = function () {
			$scope.deleteDisable = true;

			$http({
				method: 'DELETE',
				url: '/api/user/lead/' + $scope.leadForDelete
			}).then(function (result) {
				var _result$data = result.data,
				    _result$data$message = _result$data.message,
				    message = _result$data$message === undefined ? '' : _result$data$message,
				    _result$data$errorMes = _result$data.errorMessage,
				    errorMessage = _result$data$errorMes === undefined ? false : _result$data$errorMes;


				if (errorMessage) {
					toastr.error(errorMessage, 'Error');
				} else {
					messageService.showToaster('s_2', 'lead');
					getContact();
					$('#deleteModal').modal('hide');
				}
			}).catch(errorDeleteJob).finally(function () {
				$scope.deleteDisable = false;
			});
		};

		$scope.deleteJob = function () {
			$scope.deleteDisable = true;

			$http({
				method: 'DELETE',
				url: '/api/user/v1/job/' + $scope.jobForDelete + '/delete'
			}).then(function (result) {
				messageService.showToaster('s_0', 'jobView');
				getContact();
				$('#deleteModalJob').modal('hide');
			}).catch(errorDeleteJob).finally(function () {
				$scope.deleteDisable = false;
			});
		};

		function errorDeleteJob(_ref3) {
			var status = _ref3.status,
			    data = _ref3.data;

			var errorMessage = data.errorMessage;
			var errorCode = void 0,
			    errorPlace = void 0,
			    value = void 0;

			if (status >= 400 && status < 500 && errorMessage) {
				if (errorMessage.includes('This payment cannot be marked as unpaid because it was overpaid in Xero.')) {
					errorCode = 'e_12';
					errorPlace = 'xero';
					value = 'job';
				} else {
					messageService.handleError({ error: data });
					return;
				}
			}
			messageService.showToaster(errorCode, errorPlace, value);
		}

		function prepareClientSearchText() {
			$scope.clients = [];
			var primaryClientSearchText = jobDataService.fillClientSearchText($scope.primaryContact);
			$scope.clients[0] = primaryClientSearchText;
			$scope.newJob.primaryContact = $scope.clients[0];
		}

		$scope.showEditJobModal = function (job) {
			$scope.job = JSON.parse(JSON.stringify(job));
			$scope.isCreateLeadSpinningWheelActive = true;
			$scope.button_disable = true;

			Rx.Observable.zip(getJobTypes(), getWorkflowAndLanguageNames()).takeUntil($scope.unsubscribe).finally(function () {
				$scope.isCreateLeadSpinningWheelActive = false;
				$scope.button_disable = false;
			}).subscribe(function () {
				prepareJobToEdit($scope.job, 'job');
				$('#newJob').modal('show');
				$scope.$broadcast('showModalJob', $scope.job);
				delete $scope.job;
			});
		};

		$scope.showAddNewJobModal = function () {
			$scope.button_disable = true;
			$scope.isAddNewJobSpinningWheelActive = true;
			$scope.newJob = {};
			prepareClientSearchText();
			Rx.Observable.zip(getJobTypes(), getWorkflowAndLanguageNames()).takeUntil($scope.unsubscribe).finally(function () {
				$scope.isAddNewJobSpinningWheelActive = false;
				$scope.button_disable = false;
			}).subscribe(function () {
				showNewJobModal();
			});
		};

		function showNewJobModal(event) {
			var selectModal = '#addNewModal',
			    nextModal = '#newJob';
			utilsService.showNextModal(selectModal, nextModal, event);
			$scope.isCreateJobSpinnningWheelActive = false;
			$scope.$broadcast('showModalJob', $scope.newJob);
			delete $scope.newJob;
		}

		$scope.changeClientSubscription = function (contact) {
			clientsDataService.changeClientSubscription(contact).subscribe(function (result) {
				if (contact.status === 'SUBSCRIBED') {
					messageService.showToaster('s_1', 'subscribed');
				} else {
					messageService.showToaster('s_0', 'subscribed');
				}
				getContact();
			}, function (error) {
				return messageService.showDefaultErrorMessage(error);
			});
		};

		$scope.showAddNewLeadModal = function (event) {
			delete $scope.newJob;
			$scope.button_disable = true;
			$scope.isAddNewLeadSpinningWheelActive = true;
			$scope.isDisabled = true;
			$scope.newJob = {};
			$scope.clients = [];

			prepareClientSearchText();
			Rx.Observable.zip(getJobTypes(), getWorkflowAndLanguageNames()).takeUntil($scope.unsubscribe).finally(function () {
				$scope.isDisabled = true;
				$scope.button_disable = false;
				$scope.isAddNewLeadSpinningWheelActive = false;
			}).subscribe(function () {
				showNewLeadModal(event);
			});
		};

		$scope.showEditLeadModal = function (lead) {
			$scope.lead = angular.copy(lead);
			$scope.button_disable = true;
			Rx.Observable.zip(getJobTypes(), getWorkflowAndLanguageNames()).takeUntil($scope.unsubscribe).finally(function () {
				$scope.button_disable = false;
			}).subscribe(function () {
				prepareJobToEdit($scope.lead, 'lead');
				$('#newLead').modal('show');
				$scope.$broadcast('showModal', {
					lead: $scope.lead,
					jobId: $scope.lead.jobId
				});
				delete $scope.lead;
			});
		};

		$rootScope.updateClientView = function () {
			getContact();
		};

		$scope.goToJob = function (id) {
			$location.path('jobs/view/' + id);
		};

		$scope.openEditNotesModal = function () {
			try {
				var isContact = $scope.data && $scope.data.contact;
				$scope.notes = isContact ? $scope.data.contact.notes || '' : '';
			} catch (e) {
				console.log('catch open', e);
			}
			$('#updateModal').modal('show');
		};

		$scope.showSaveOptInModal = function () {
			$('#saveOptinConsentModal').modal('show');
		};

		$scope.disableDragDrop = function () {
			return true;
		};

		$scope.setClientMail = function (clientMailData, jobMailData) {
			$scope.clientMailData = clientMailData;
			$scope.mailData2Save = jobMailData;
		};

		$scope.retrySendMail = function () {
			getContact();
			emailService.callLastEmailFn();
		};

		$scope.addNew = function () {
			$('#addNewModal').modal('show');
		};

		$scope.onDeleteConsent = function (id) {
			clientsDataService.deleteConsent($scope.primaryContact.id, id).subscribe(function () {
				return getContact();
			}, function (error) {
				return messageService.showDefaultErrorMessage(error);
			});
		};
	}
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/rxjs/Rx.js"), __webpack_require__("./node_modules/jquery/dist/jquery.js"), __webpack_require__("./node_modules/toastr/toastr.js")))

/***/ }),

/***/ "./web/js/controllers/clientsController.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Rx, $, toastr) {

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
	var ClientsController = function ClientsController($window, $scope, $rootScope, $location, $routeParams, authTokensService, clientsDataService, messageService, validationService, templateRequestsService, mailsDataService, emailService, fileDownloadDataService, settingsService) {
		$scope.$on('$viewContentLoaded', function () {
			var searchFromUrl = void 0;
			try {
				searchFromUrl = decodeURIComponent($routeParams.search);
				searchFromUrl = searchFromUrl === 'undefined' ? '' : searchFromUrl;
			} catch (e) {
				searchFromUrl = '';
			}
			$scope.pageRequest = {
				page: +$routeParams.page || 1,
				perPage: $rootScope.paginationPerPage ? $rootScope.paginationPerPage : 25,
				pageOrder: {
					predicate: $rootScope.clientPageRequest && $rootScope.clientPageRequest.pageOrder.predicate || 'id',
					reverse: $rootScope.clientPageRequest && $rootScope.clientPageRequest.pageOrder.reverse || true
				},
				search: searchFromUrl || ''
			};
			$scope.jobs = [];
			$scope.totalItems = 0;
			$scope.searchText = searchFromUrl || '';
			$scope.pageRequest.search = searchFromUrl || '';
			$scope.initImportClientsDropzone();

			$scope.isDeleteContactSpinnningWheelActive = false;
			$scope.isCreateClientModalSpinnningWheelActive = false;
			$scope.isExportingClientsWheelActive = false;
			$scope.lastCalledSendEmailFn = null;
			$scope.clientToSendMail = null;
			$scope.unsubscribe = new Rx.Subject();
			$scope.changeUrl = false;
			$scope.toSearch = true;

			subscribeToCustomizeLabelsChange();
		});

		$window.onpopstate = function () {
			$scope.changeUrl = false;
			var searchFromUrl = void 0;
			if ($routeParams.search) {
				try {
					searchFromUrl = decodeURIComponent($routeParams.search);
					searchFromUrl = searchFromUrl === 'undefined' ? '' : searchFromUrl;
				} catch (e) {
					searchFromUrl = '';
				}
				$scope.pageRequest.search = searchFromUrl || '';
				$scope.searchText = searchFromUrl || '';
			} else {
				$scope.pageRequest.search = '';
				$scope.searchText = '';
				$scope.toSearch = false;
			}
			getResultsPage(+$routeParams.page);
		};

		$scope.$on('$destroy', function () {
			$scope.unsubscribe.next();
			$scope.unsubscribe.complete();
		});

		function subscribeToCustomizeLabelsChange() {
			settingsService.customizeLabelsObservable.takeUntil($scope.unsubscribe).subscribe(function (customizeLabels) {
				$scope.mainShootLabelName = customizeLabels.mainShootLabel;
				$scope.extraShootLabelName = customizeLabels.extraShootLabel;
				$scope.businessNumberLabelName = customizeLabels.businessNumberLabel;
			});
		}

		var csvErrorCases = [{
			errorCode: 'e_2',
			errorMessage: 'Your CSV file is empty'
		}, {
			errorCode: 'e_3',
			errorMessage: 'first name can not be empty.'
		}, {
			errorCode: 'e_3',
			errorMessage: 'FirstName column is empty'
		}, {
			errorCode: 'e_4',
			errorMessage: 'email can not be empty.'
		}, {
			errorCode: 'e_4',
			errorMessage: 'Email column is empty'
		}, {
			errorCode: 'e_5',
			errorMessage: 'Multiple contact with same email in CSV'
		}, {
			errorCode: 'e_6',
			errorMessage: 'already registered!'
		}, {
			errorCode: 'e_8',
			errorMessage: 'column is not exist in CSV'
		}];

		$scope.downloadCSVTemplate = function () {
			var csvTemplateName = 'import_clients_template.csv';
			var csvTemplateContent = 'first name, last name, phone, email, street address, suburb/town, postcode/zip, state, country';
			var element = document.createElement('a');

			element.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(csvTemplateContent));
			element.setAttribute('download', csvTemplateName);
			element.style.display = 'none';
			document.body.appendChild(element);
			element.click();
			document.body.removeChild(element);
		};
		$scope.openImportClientsModal = function () {
			$('#import-clients-modal').modal('show');
		};

		$scope.initImportClientsDropzone = function () {
			$('#import-clients-dropzone').dropzone({
				url: '/protected/rest/clients/import-clients',
				paramName: 'csvFile',
				acceptedFiles: '.csv',
				maxFiles: 1,
				parallelUploads: 1,
				uploadMultiple: false,
				timeout: 0,
				headers: {
					Authorization: 'Bearer ' + authTokensService.getAuthToken()
				},
				init: function init() {
					this.on('maxfilesexceeded', function (file) {
						this.removeAllFiles();
						this.addFile(file);
					});
					this.on('addedfile', function (file) {
						if (file.name.split('.').pop() !== 'csv') {
							this.removeFile(file);
							messageService.showToaster('e_1', 'csvFiles');
						} else {
							this.processQueue();
							this.processFile(file);
						}
					});
					this.on('sending', function () {
						$scope.disableDropzone = true;
					});
					this.on('success', function (file, response) {
						$scope.disableDropzone = false;
						this.removeFile(file);
						this.removeAllFiles();
						if (response.errorMessage) {
							toastr.error(response.errorMessage, 'Error');
						} else {
							$('#import-clients-modal').modal('hide');
							getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
							messageService.showToaster('s_0', 'csvFiles');
						}
					});
					this.on('error', function (file, data) {
						$scope.disableDropzone = false;
						this.removeFile(file);
						this.removeAllFiles();
						if (data.error && data.error === 'invalid_token') {
							messageService.showToaster('e_2', 'general', 'Please refresh page and try again');
						} else if (data.errorMessage) {
							handleCsvErrors(data.errorMessage);
						}
					});
				}
			});
		};
		function handleCsvErrors(receivedError) {
			if (!receivedError) {
				console.info('No error messages');
				return;
			}

			var foundError = csvErrorCases.find(function (error) {
				return receivedError.includes(error.errorMessage);
			});

			// 'e_7' === "That's not a Studio Ninja CSV file!"
			var errorCode = foundError ? foundError.errorCode : 'e_7';

			messageService.showToaster(errorCode, 'csvFiles');
		}

		function searchRequest() {
			$scope.pageRequest.search = $scope.searchText;
			getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
		}

		$scope.showClient = function (id) {
			$location.path('/clients/client' + id);
		};

		$scope.retrySendMail = function () {
			getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
			emailService.callLastEmailFn();
		};

		$scope.openSendMailModal = function (contact) {
			delete $scope.mailData2Save;
			delete $scope.clientMailData;
			$scope.button_disable = true;

			Rx.Observable.zip(templateRequestsService.getTemplates('general_preview'), templateRequestsService.getTemplates('email_signature')).takeUntil($scope.unsubscribe).finally(function () {
				return $scope.button_disable = false;
			}).subscribe(function (_ref) {
				var _ref2 = _slicedToArray(_ref, 2),
				    emails = _ref2[0],
				    mailSignature = _ref2[1];

				$scope.mailData2Save = angular.copy(contact);
				$scope.mailData2Save.emails = emails;
				$scope.mailData2Save.mailSignature = mailSignature.signature || '';
				$rootScope.clientToken = false;

				if (!$scope.$$phase) {
					$scope.$apply();
				}

				$('#sendContactEmailModal').modal('show');
			});
		};
		$scope.sendMail = function () {
			prepareEmailText();
			$scope.disableBtnOnSend = true;

			mailsDataService.sendEmail($rootScope.sendMessage, $scope.contactForSending.id, $routeParams.jobId, $routeParams.jobId).finally(function () {
				$scope.disableBtnOnSend = false;
			}).subscribe(function () {
				return successMailSend();
			});
		};

		function prepareEmailText() {
			var _emailText = '';

			if (!$rootScope.sendMessage.emailText) {
				_emailText = $('.in .textarea-quad textarea')[0].value;
			} else {
				_emailText = $rootScope.sendMessage.emailText;
			}
			$rootScope.sendMessage.emailText = $rootScope.addMaiStyling(_emailText);
		}

		function successMailSend() {
			if ($rootScope.updateJobView) {
				$rootScope.updateJobView();
			} else if ($rootScope.updateLeadView) {
				$rootScope.updateLeadView();
			}
			for (var prop in $rootScope.sendMessage) {
				$rootScope.sendMessage[prop] = '';
			}

			toastr.success('Mail sent!', 'Success');
			$('#sendContactEmailModal').modal('hide');
		}

		var timerId = void 0;

		$scope.$watch('searchText', function (newValue) {
			if (!$scope.toSearch) {
				$scope.toSearch = true;
				return;
			}
			if (newValue != null) {
				if (newValue.length > 0) {
					if (timerId != null) {
						clearTimeout(timerId);
					}
					timerId = setTimeout(searchRequest, 500);
				} else {
					clearTimeout(timerId);
					if (newValue.length == 0) {
						$scope.pageRequest.search = '';
						getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
					}
				}
			}
		});

		$scope.downloadClients = function () {
			$scope.isExportingClientsWheelActive = true;
			fileDownloadDataService.saveClients().then(function () {
				return $scope.isExportingClientsWheelActive = false;
			}).catch(function (_ref3) {
				var error = _ref3.error;
				var errorTitle = error.errorTitle,
				    errorMessage = error.errorMessage;

				messageService.showErrorFromBackend(errorTitle, errorMessage);
				$scope.isExportingClientsWheelActive = false;
			});
		};

		$scope.order = function (predicate) {
			$scope.pageRequest.pageOrder.reverse = $scope.pageRequest.pageOrder.predicate === predicate ? !$scope.pageRequest.pageOrder.reverse : false;
			getResultsPage(null, null, predicate, $scope.pageRequest.pageOrder.reverse);
		};

		$scope.getCurrentPage = function () {
			return $scope.pageRequest.page;
		};

		$scope.perPageChanged = function (newPerPage) {
			getResultsPage(null, newPerPage);
			$rootScope.paginationPerPage = newPerPage;
		};

		$scope.goToPage = function (newPage, disabled) {
			if (!disabled) {
				getResultsPage(newPage, null);
			}
		};

		$scope.jumpBack = function (disabled) {
			if (!disabled) {
				if ($scope.pageRequest.page > 1) {
					getResultsPage($scope.pageRequest.page - 1, null);
				}
			}
		};

		$scope.jumpAhead = function (disabled) {
			if (!disabled) {
				if ($scope.totalItems >= $scope.pageRequest.page * $scope.pageRequest.perPage + 1) {
					getResultsPage($scope.pageRequest.page + 1, null);
				}
			}
		};

		$scope.createNewClient = function () {
			delete $scope.client;
			$('#createNewClientModal').modal('show');
		};

		$scope.editClient = function (index) {
			$scope.button_disable = true;
			$scope.client = angular.copy($scope.contacts[index]);
			$scope.companyNameChecked = !!$scope.client.companyName || !!$scope.client.businessNumber;
			$('#createNewClientModal').modal('show');
			$scope.button_disable = false;
		};

		$scope.save = function (updateId) {
			$scope.isCreateClientModalSpinnningWheelActive = true;
			if (validationService.isStringEmpty($scope.client.firstName)) {
				$scope.isCreateClientModalSpinnningWheelActive = false;
				return messageService.showToaster('e_4', 'clients');
			}

			if (!validationService.isEmailValid($scope.client.email)) {
				$scope.isCreateClientModalSpinnningWheelActive = false;
				return messageService.showToaster('e_3', 'companyUsers');
			}

			if (!$scope.companyNameChecked && $scope.client) {
				delete $scope.client.companyName;
				delete $scope.client.businessNumber;
			}

			if ($scope.client.notes) {
				$scope.client.notes = $rootScope.verifyNotes($scope.client.notes) || null;
			}

			if (updateId) {
				clientsDataService.updateClient($scope.client).subscribe(function (data) {
					return successUpdateClient(data);
				}, function (error) {
					return errorAddClient(error.data);
				}, function () {
					return $scope.isCreateClientModalSpinnningWheelActive = false;
				});
			} else if ($scope.client) {
				clientsDataService.addNewClient($scope.client).subscribe(function (data) {
					return successAddClient(data);
				}, function (error) {
					return errorAddClient(error.data);
				}, function () {
					return $scope.isCreateClientModalSpinnningWheelActive = false;
				});
			} else {
				toastr.error('Please fill at least "Email" and "First Name" fields to save client profile', 'Error');
				$scope.isCreateClientModalSpinnningWheelActive = false;
			}
		};

		function successUpdateClient(data) {
			if (data.errorMessage) {
				messageService.showToaster('e_2', 'general', data.errorMessage);
			} else {
				toastr.success('Client details have been updated!', 'Success');
				$('#createNewClientModal').modal('hide');
				getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
			}
		}

		function successAddClient(data) {
			if (data.errorMessage) {
				messageService.showToaster('e_2', 'general', data.errorMessage);
			} else {
				messageService.showToaster('s_2', 'clients');
				$('#createNewClientModal').modal('hide');
				$scope.client = {};
				getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
			}
		}

		function errorAddClient(data) {
			if (data.errorMessage === 'Sorry, this customer has been deleted on QuickBooks') {
				messageService.showToaster('e_23', 'qb');
			} else {
				messageService.showToaster('e_6', 'clients');
			}
			$scope.isCreateClientModalSpinnningWheelActive = false;
		}

		$scope.showDeleteModal = function (id) {
			$scope.contactForDelete = id;
			$scope.checkForDelete();
		};

		$scope.checkForDelete = function () {
			$scope.button_disable = true;
			clientsDataService.checkBeforeDelete($scope.contactForDelete).finally(function () {
				$scope.button_disable = false;
			}).subscribe(function () {
				return $('#deleteModal').modal('show');
			}, function (result) {
				if (result.error && result.error.errorCode) {
					$scope.clientDeleteErrorMessage = result.error.errorMessage;
					$('#errorMessageModal').modal('show');
				} else {
					messageService.showDefaultErrorMessage(result);
				}
			});
		};
		$scope.getElement = function (index) {
			var tableId = document.getElementById('tableId').getBoundingClientRect();
			var dotsMenu = document.getElementById('dotsMenuClient-' + index).getBoundingClientRect();
			var add = document.getElementsByClassName('dropdown-menu-client-' + index);
			add[0].style.transform = '';
			// 122-height of modal; 30-height of 3 dots menu 149-height of 1 row
			var x = dotsMenu.top - tableId.top;
			var value = tableId.height - x;
			if (tableId.height > 149 && value < 122) {
				value -= 30;
				add[0].style.transform = 'translate(-20%, ' + value + 'px)';
			}
		};
		$scope.deleteContact = function () {
			$scope.isDeleteContactSpinnningWheelActive = true;
			clientsDataService.deleteClient($scope.contactForDelete).finally(function () {
				$scope.isDeleteContactSpinnningWheelActive = false;
			}).subscribe(function (data) {
				if (data.errorMessage) {
					$('#deleteModal').modal('hide').on('hidden.bs.modal', function () {
						$scope.clientDeleteErrorMessage = data.errorMessage;
						$('#errorMessageModal').modal('show');
						$(this).off('hidden.bs.modal');
					});
				} else {
					messageService.showToaster('s_0', 'clients');

					$('#deleteModal').modal('hide');
					getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
				}
			}, function () {
				toastr.error('Request to server failed!', 'Error');
			});
		};

		function getResultsPage() {
			var pageNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
			var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
			var predicate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
			var reverse = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

			var changed = false;

			if (predicate) {
				$scope.pageRequest.pageOrder.predicate = predicate;
				$scope.pageRequest.pageOrder.reverse = !!reverse;
				changed = true;
			}
			if (perPage) {
				$scope.pageRequest.perPage = perPage;
				changed = true;
			}
			if (pageNumber) {
				$scope.pageRequest.page = pageNumber;
				changed = true;
			}
			if ($scope.pageRequest && $scope.totalItems != 0 && $scope.totalItems < ($scope.pageRequest.page - 1) * $scope.pageRequest.perPage + 1) {
				$scope.pageRequest.page = 1;
			}
			'';
			if (changed) {
				clientsDataService.getClientsOnPage($scope.pageRequest, '').subscribe(function (data) {
					return successGetResultsPage(data);
				}, function (error) {
					return messageService.showDefaultErrorMessage(error);
				});
			}
		}

		function successGetResultsPage(data) {
			if (!data) return;

			if (data && data.pageRequest) {
				'';
				$scope.pageRequest = data.pageRequest;
				$scope.pageRequest.search = $scope.searchText;
			}

			$scope.totalItems = data ? data.total : 0;

			var pagesCount = void 0;
			pagesCount = $scope.totalItems / $scope.pageRequest.perPage;
			pagesCount = Math.ceil(pagesCount);

			var temp = [];
			for (var i = 1; i <= pagesCount; i++) {
				temp.push(i);
			}
			$scope.pageNumbers = angular.copy(temp);
			$scope.contacts = angular.copy(data.results);
			$rootScope.clientPageRequest = $scope.pageRequest;
			var newSearch = void 0;
			try {
				newSearch = encodeURIComponent($scope.pageRequest.search);
				newSearch = newSearch === 'undefined' ? null : newSearch;
			} catch (error) {
				newSearch = '';
			}
			if ($scope.changeUrl) {
				$location.search({
					page: $scope.pageRequest.page,
					search: newSearch || null
				});
			}
			$scope.changeUrl = true;
		}
	};

	ClientsController.$inject = ['$window', '$scope', '$rootScope', '$location', '$routeParams', 'authTokensService', 'clientsDataService', 'messageService', 'validationService', 'templateRequestsService', 'mailsDataService', 'emailService', 'fileDownloadDataService', 'settingsService'];

	angular.module('main').controller('ClientsController', ClientsController);
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/rxjs/Rx.js"), __webpack_require__("./node_modules/jquery/dist/jquery.js"), __webpack_require__("./node_modules/toastr/toastr.js")))

/***/ }),

/***/ "./web/js/controllers/clientsPortal/ClientContactFormController.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(toastr) {

(function () {
	angular.module('main').controller('ClientContactFormController', ClientContactFormController);

	ClientContactFormController.$inject = ['$scope', '$rootScope', '$routeParams', '$http', '$window', 'timeService', 'messageService', 'settingsService', 'accountService'];

	function ClientContactFormController($scope, $rootScope, $routeParams, $http, $window, timeService, messageService, settingsService, accountService) {
		Intercom('shutdown');
		accountService.emitShowHeader(false);
		$rootScope.showLogo = false;
		$scope.onLoad = true;
		$scope.isFormSubmitted = false;
		$rootScope.isContactForm = true;
		$scope.jobTypes = [];
		$scope.otherQuestionsIds = [];
		$scope.isSubmitSpinningWheelActive = false;
		$scope.todayDate = new Date().toJSON().split('T')[0];
		$scope.inputPatter = {
			nonEmpty: '[\\s\\S]*\\S[\\s\\S]*',
			email: '[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+.[A-Za-z]{2,9}$',
			phone: '/^[0-9\\s(-)]*$/'
		};
		// console.log('previewContactForm', $rootScope.previewContactForm);

		$scope.isPriviewContactFormPage = $routeParams.id;

		document.title = 'Contact Form';

		$scope.$on('$viewContentLoaded', function () {
			// $('.embedContactForm__input').datepicker({ format: 'dd-mm-yyyy' });

			// document.cookie = "reCAPTCHA_token=true";

			$scope.isTest = document.cookie.includes('reCAPTCHA_token');
			window.scrollTo(0, 0);

			if ($scope.isPriviewContactFormPage == 'preview') {
				if (!$rootScope.previewContactForm) {
					$rootScope.previewContactForm = JSON.parse($routeParams.contactForm);
				}

				var previewData = $rootScope.previewContactForm;

				$http.get('/public/rest/contactform/' + $routeParams.photographyStudio).then(function (result) {
					if (result.data) {
						setDatePickerPlaceholder(result.data.calendarDateFormat);
						setDateFormat(result.data.calendarDateFormat, result.data.weekStartsOn);
						var tmpObj = {
							companyName: result.data.companyName,
							companyBanner: result.data.companyBanner,
							companyLogo: result.data.companyLogo,
							fields: $rootScope.previewContactForm,
							gdprEnabled: result.data.gdprEnabled,
							optInConsent: result.data.optInConsent,
							optInConsentStatement: result.data.optInConsentStatement
						};

						previewData = Object.assign(tmpObj, $rootScope.previewContactForm);
					}
				}, function (result) {
					var tmpError = result.data.errorMessage || 'Error';
					toastr.error(tmpError, 'Wrong link');
				}).then(function () {
					convertFormData(previewData);
					$scope.onLoad = false;
				});
			} else {
				getContactFormInformation();
			}
		});

		var fieldsOptions = {
			FIRST_NAME: { isMultilined: false, name: 'First name' },
			LAST_NAME: { isMultilined: false, name: 'Last name' },
			EMAIL: { isMultilined: false, name: 'Email' },
			PHONE: { isMultilined: false, name: 'Phone' },
			MESSAGE: {
				isMultilined: true,
				name: 'Message (appears in client notes)'
			},
			JOB_TYPE: {
				isMultilined: false,
				name: 'Job type (appears in client notes)'
			},
			JOB_DATE: {
				isMultilined: false,
				name: 'Main shoot date (appears in client notes)'
			},
			JOB_LOCATION: {
				isMultilined: false,
				name: 'Job location (appears in client notes)'
			},
			ENQUIRY_SOURCE: {
				isMultilined: false,
				name: 'Enquiry source (appears in client notes)'
			}
		};

		function validPhone() {
			var re = /^\d[\d\(\)\ -]{4,14}\d$/;
			var phone = document.getElementById('phone').value;
			if (re.test(phone)) {
				return true;
			}
			return false;
		}

		function validEmail() {
			var re = /^[\w-\.]+@[\w-]+\.[a-z]{2,4}$/i;
			var emailValue = document.getElementById('emailId').value;
			if (re.test(emailValue)) {
				return true;
			}
			return false;
		}

		function setDatePickerPlaceholder(dateFormat) {
			var placeholder = void 0;

			if (dateFormat) {
				placeholder = dateFormat === 'DD_MM_YYYY' ? 'dd/mm/yyyy' : 'mm/dd/yyyy';
			}

			$scope.datePickerPlaceholder = placeholder || 'mm/dd/yyyy';
		}

		function setDateFormat(dateFormat, weekStartsDate) {
			settingsService.dateFormatPattern(dateFormat, weekStartsDate);
		}

		function convertFormData(data) {
			document.title = (data.companyName + ' - ' || '') + 'Contact Form';

			$rootScope.companyBanner = data.companyBanner || '';
			$rootScope.companyLogo = data.companyLogo || '';

			$scope.contactFormId = data.id;
			$scope.jobTypes = data.jobTypes;

			$scope.fields = data.fields.map(function (item) {
				return (
					// return item item.fieldType;
					Object.assign(item, fieldsOptions[item.fieldType])
				);
			});

			$scope.introductionMessage = data.introductionMessage;
			$scope.thanksMessage = data.thanksMessage;

			$scope.showOptInConsent = data.optInConsent;
			$scope.optInConsentStatement = data.optInConsentStatement;
			$scope.gdprEnabled = data.gdprEnabled;

			$scope.$evalAsync();
		}

		function getContactFormInformation() {
			$http.get('/public/rest/contactform/' + $routeParams.photographyStudio).then(function (result) {
				if (result.data) {
					setDatePickerPlaceholder(result.data.calendarDateFormat);
					setDateFormat(result.data.calendarDateFormat, result.data.weekStartsOn);
					convertFormData(result.data);
				}
			}, function (result) {
				var tmpError = result.data.errorMessage || 'Error';
				toastr.error(tmpError, 'Wrong link');
				$scope.contactForm = {};
			}).then(function () {
				$scope.onLoad = false;
			});
		}

		$scope.submitForm = function (token) {
			$scope.isSubmitSpinningWheelActive = true;

			if ($scope.isSubmitSpinningWheelActive === true) {
				var data2Save = fillContactFormData4Save();
				data2Save.reCaptchaToken = token;
				if ($scope.gdprEnabled && $scope.showOptInConsent) {
					data2Save.optInConsent = $scope.optInConsent;
				}
				$http({
					method: 'POST',
					url: '/public/rest/contactform/' + $scope.contactFormId,
					data: data2Save
				}).then(function (result) {
					messageService.showToaster('s_1', 'contactForm');
					$scope.isFormSubmitted = true;
				}).then(function () {
					$scope.isSavingData = false;
					$scope.isSubmitSpinningWheelActive = false;
				});
			}
		};
		$window.submitForm = $scope.submitForm;

		$scope.validateForm = function () {
			$scope.isSubmitSpinningWheelActive = true;
			$scope.isFirstName = true;
			$scope.isPhone = true;
			$scope.isLastName = true;
			$scope.isMessage = true;
			$scope.isJobType = true;
			$scope.isJobDate = true;
			$scope.isJobLocation = true;
			$scope.isEniquirySource = true;
			$scope.isOther = {};

			$scope.otherQuestionsIds.forEach(function (id) {
				$scope.isOther[id] = true;
			});

			var isFormValid = checkContactFormData4Save();
			if (!$scope.isTest) {
				grecaptcha.reset($scope.id);
				if (isFormValid) {
					grecaptcha.execute($scope.id);
				} else {
					grecaptcha.reset($scope.id);
				}
			} else {
				$scope.submitForm(null);
			}
		};

		$scope.checkOtherQuestionField = function (id) {
			if ($scope.isOther) return $scope.isOther[id];
			return true;
		};

		$window.validateForm = $scope.validateForm;

		$scope.$watch('wathing', function () {
			if ($scope.wathing !== undefined) {
				$scope.wathing.forEach(function (item, i, arr) {
					if (item.value !== undefined && item.value !== '' && item.fieldType === 'FIRST_NAME') {
						$scope.isFirstName = true;
					} else if (item.value !== undefined && item.value !== '' && item.fieldType === 'LAST_NAME') {
						$scope.isLastName = true;
					} else if (item.value !== undefined && item.value !== '' && item.fieldType === 'PHONE') {
						$scope.isPhone = true;
					} else if (item.value !== undefined && item.value !== '' && item.fieldType === 'EMAIL') {
						$scope.email = true;
					} else if (item.value !== undefined && item.value !== '' && item.fieldType === 'MESSAGE') {
						$scope.isMessage = true;
					} else if (item.value !== undefined && item.value !== '' && item.fieldType === 'JOB_TYPE') {
						$scope.isJobType = true;
					} else if (item.value !== undefined && item.value !== '' && item.fieldType === 'JOB_DATE') {
						$scope.isJobDate = true;
					} else if (item.value !== undefined && item.value !== '' && item.fieldType === 'JOB_LOCATION') {
						$scope.isJobLocation = true;
					} else if (item.value !== undefined && item.value !== '' && item.fieldType === 'ENQUIRY_SOURCE') {
						$scope.isEniquirySource = true;
					} else {
						$scope.otherQuestionsIds.forEach(function (id) {
							if (item.value !== undefined && item.value !== '' && item.fieldType === 'OTHER' && item.id === id) {
								$scope.isOther[id] = true;
							}
						});
					}
				});
			}
		}, true);

		function checkContactFormData4Save() {
			var result = {
				fields: []
			};
			var isFormValid = true;

			$scope.wathing = [];
			$scope.fields.forEach(function (item, i, arr) {
				if ((item.value === undefined || item.value === '') && item.mandatory === true && item.fieldType === 'FIRST_NAME') {
					$scope.isFirstName = false;
					$scope.first = true;
					$scope.isSubmitSpinningWheelActive = false;
					$scope.wathing.push(item);
					// grecaptcha.reset();
					isFormValid = false;
					return false;
				} else if (item.value === undefined && item.mandatory === true && item.fieldType === 'EMAIL') {
					var emailValue = document.getElementById('emailId').value;
					if (emailValue && validEmail() === false) {
						$scope.email = false;
						$scope.emailValid = true;
						$scope.isSubmitSpinningWheelActive = false;
						$scope.wathing.push(item);
						// grecaptcha.reset();
						isFormValid = false;
						return false;
					}
					$scope.email = true;
					$scope.isSubmitSpinningWheelActive = false;
					// grecaptcha.reset();
					isFormValid = false;
					return false;
				} else if ((item.value === undefined || item.value === '') && item.mandatory === true && item.fieldType === 'LAST_NAME') {
					$scope.isLastName = false;
					$scope.last = true;
					$scope.isSubmitSpinningWheelActive = false;
					$scope.wathing.push(item);
					// grecaptcha.reset();
					isFormValid = false;
					return false;
				} else if (item.value === undefined && item.mandatory === true && item.fieldType === 'PHONE') {
					$scope.phone = true;
					$scope.isPhone = false;
					$scope.isSubmitSpinningWheelActive = false;
					$scope.wathing.push(item);
					// grecaptcha.reset();
					isFormValid = false;
					return false;
				}
				// else if (item.value !== undefined && item.fieldType === "PHONE" && validPhone()===false) {
				//     $scope.phoneValid=true;
				//     $scope.isSubmitSpinningWheelActive = false;
				//     $scope.wathing.push(item);
				//     grecaptcha.reset();
				//     return false;
				// }
				else if ((item.value === undefined || item.value === '') && item.mandatory === true && item.fieldType === 'MESSAGE') {
						$scope.isMessage = false;
						$scope.message = true;
						$scope.isSubmitSpinningWheelActive = false;
						$scope.wathing.push(item);
						// grecaptcha.reset();
						isFormValid = false;
						return false;
					} else if (item.value === undefined && item.mandatory === true && item.fieldType === 'JOB_TYPE') {
						$scope.isJobType = false;
						$scope.type = true;
						$scope.isSubmitSpinningWheelActive = false;
						$scope.wathing.push(item);
						// grecaptcha.reset();
						isFormValid = false;
						return false;
					} else if ((item.value === undefined || item.value === '') && item.mandatory === true && item.fieldType === 'JOB_DATE') {
						$scope.isJobDate = false;
						$scope.date = true;
						$scope.isSubmitSpinningWheelActive = false;
						$scope.wathing.push(item);
						// grecaptcha.reset();
						isFormValid = false;
						return false;
					} else if ((item.value === undefined || item.value === '') && item.mandatory === true && item.fieldType === 'JOB_LOCATION') {
						$scope.isJobLocation = false;
						$scope.location = true;
						$scope.isSubmitSpinningWheelActive = false;
						$scope.wathing.push(item);
						// grecaptcha.reset();
						isFormValid = false;
						return false;
					} else if ((item.value === undefined || item.value === '') && item.mandatory === true && item.fieldType === 'ENQUIRY_SOURCE') {
						$scope.isEniquirySource = false;
						$scope.sourseEuquiry = true;
						$scope.isSubmitSpinningWheelActive = false;
						$scope.wathing.push(item);
						// grecaptcha.reset();
						isFormValid = false;
						return false;
					}
				$scope.otherQuestionsIds.forEach(function (id) {
					if ((item.value === undefined || item.value === '') && item.mandatory === true && item.fieldType === 'OTHER' && item.id === id) {
						$scope.isOther[id] = false;
						$scope.isSubmitSpinningWheelActive = false;
						$scope.wathing.push(item);
						// grecaptcha.reset();
						isFormValid = false;
						return false;
					}
				});
			});

			return isFormValid;
		}
		function fillContactFormData4Save() {
			var result = {
				fields: []
			};

			$scope.fields.forEach(function (item, i, arr) {
				if (item.fieldType === 'JOB_TYPE') {
					if (item.value === undefined) {
						result.fields.push({
							data: '',
							contactFormFieldId: item.id
						});
					} else {
						result.fields.push({
							data: item.value.id || '',
							contactFormFieldId: item.id
						});
					}
				} else if (item.fieldType === 'JOB_DATE') {
					item.value = timeService.getDateInFormat(item.value, 'date');
					result.fields.push({
						data: item.value || '',
						contactFormFieldId: item.id
					});
				} else {
					result.fields.push({
						data: item.value || '',
						contactFormFieldId: item.id
					});
				}
			});
			return result;
		}

		$scope.closeWindow = function () {
			$window.close();
		};

		$scope.$on('$destroy', function () {
			$rootScope.isContactForm = false;
		});
	}
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/toastr/toastr.js")))

/***/ }),

/***/ "./web/js/controllers/companyUsersController.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

(function () {
	angular.module('main').controller('CompanyUsersController', CompanyUsersController);

	CompanyUsersController.$inject = ['$scope', '$rootScope', '$http', 'messageService', 'validationService', 'accountService', 'companySettingsService'];

	function CompanyUsersController($scope, $rootScope, $http, messageService, validationService, accountService, companySettingsService) {
		$scope.$on('$viewContentLoaded', function () {
			delete $rootScope.error;
			$scope.getUsers();
			getUser();
			$scope.isSendInviteSpinnningWheelActive = false;
			$scope.isDeleteUserSpinnningWheelActive = false;
			$scope.isEditUserSpinnningWheelActive = false;
		});

		$scope.$on('$destroy', function () {
			$scope.userObservable.unsubscribe();
		});

		$scope.showInvite = function () {
			$('#invite').modal('show').on('shown.bs.modal', function () {
				var input = $(this).find('input');

				validationService.isModalClosePrevented(input);
			});
		};
		$scope.getUsers = function () {
			$http({
				method: 'GET',
				url: '/protected/rest/company/users'
			}).then(function (result) {
				var data = result.data;
				if (data) {
					$scope.company = data;
					$scope.users = data.users;
					$scope.companyName = data.name;
				} else {
					console.error('No company data');
				}
			}).catch(messageService.showDefaultErrorMessage);
		};

		$scope.checkInvite = function () {
			if ($scope.item && ($scope.item.name || $scope.item.email)) {
				if (!$scope.item.name) {
					return messageService.showToaster('e_0', 'companyUsers');
				}
				if (!$scope.item.email) {
					return messageService.showToaster('e_2', 'companyUsers');
				}
				var x = $scope.item.email;
				var atpos = x.indexOf('@');
				var dotpos = x.lastIndexOf('.');
				if (atpos < 1 || dotpos < atpos + 2 || dotpos + 2 >= x.length) {
					return messageService.showToaster('e_3', 'companyUsers');
				}
			} else {
				return messageService.showToaster('e_1', 'companyUsers');
			}

			// if ($scope.user.inTrial) {
			// 	$('#invite')
			// 		.modal('hide')
			// 		.on('hidden.bs.modal', function() {
			// 			// $('#inviteWarning').modal('show');
			// 			$(this).off('hidden.bs.modal');
			// 		});
			//
			// 	$scope.invite();
			// } else {
			$scope.invite();
			// }
		};
		$scope.invite = function () {
			$scope.isSendInviteSpinnningWheelActive = true;
			$scope.button_disable = true;
			$http({
				method: 'POST',
				url: '/protected/rest/users/invite',
				data: $scope.item
			}).then(function (result) {
				return successInviteCompanyUser(result.data);
			}).catch(function (result) {
				return errorInviteCompanyUser(result.data);
			}).finally(function () {
				$scope.button_disable = false;
				$scope.isSendInviteSpinnningWheelActive = false;
			});
		};

		function getUser() {
			$scope.userObservable = accountService.userDataObservable.subscribe(function (user) {
				if (user !== null && typeof user !== 'undefined') {
					$scope.user = JSON.parse(JSON.stringify(user));
				}
			});
		}

		function successInviteCompanyUser(data) {
			var isRegisteredUser = void 0;

			if (data && data.message) {
				isRegisteredUser = data.message.toLowerCase().includes('user already registered');
			}

			if (isRegisteredUser) {
				return messageService.showToaster('e_4', 'companyUsers', $scope.item.email);
			}

			if (!data || !isRegisteredUser) {
				messageService.showToaster('i_0', 'companyUsers', $scope.item.email);
				$scope.userActionResult = data;
				$('#invite').modal('hide');
				$('#inviteWarning').modal('hide');
				delete $scope.item;
			}
		}

		function errorInviteCompanyUser(data) {
			var isRegisteredUser = void 0;

			if (data && data.message) {
				isRegisteredUser = data.message.toLowerCase().includes('user already registered');
			}

			if (isRegisteredUser) {
				return messageService.showToaster('e_4', 'companyUsers', $scope.item.email);
			}

			messageService.showToaster('e_0', 'general');
		}

		$scope.showDeleteModal = function (index) {
			$scope.deletedUser = angular.copy($scope.users[index]);
			$('#deleteModal').modal('show');
		};

		$scope.editUser = function (index) {
			$scope.editedUser = angular.copy($scope.users[index]);
			$('#edit').modal('show').on('shown.bs.modal', function () {
				var input = $(this).find('input');

				validationService.isModalClosePrevented(input);
			});
		};

		$scope.deleteUser = function () {
			$scope.isDeleteUserSpinnningWheelActive = true;
			companySettingsService.deleteUser($scope.deletedUser.id).finally(function () {
				$scope.button_disable = false;
				$scope.isDeleteUserSpinnningWheelActive = false;
			}).subscribe(function (result) {
				return successDeleteUser(result.data);
			}, function (error) {
				return errorDeleteUser(error);
			});
		};

		$scope.breadcrumbs = [{ link: '/', title: 'Dashboard' }, { link: '/settings', title: 'Settings' }, { link: null, title: 'Users' }];

		function successDeleteUser(data) {
			if (!data) {
				messageService.showToaster('s_1', 'companyUsers', $scope.deletedUser.email);
				$('#deleteModal').modal('hide');
				$scope.getUsers();
			} else if (data && data.errorMessage) {
				closeModalAndShowError('#deleteModal', errorMessage);
			} else {
				messageService.showToaster('e_0', 'general');
			}
		}

		function errorDeleteUser(result) {
			var _result$error = result.error,
			    errorCode = _result$error.errorCode,
			    errorMessage = _result$error.errorMessage;


			if (errorCode && errorMessage) {
				closeModalAndShowError('#deleteModal', errorMessage);
			} else {
				messageService.showDefaultErrorMessage(result);
			}
		}

		function closeModalAndShowError(modalToClose, errorMessage) {
			$(modalToClose).modal('hide').on('hidden.bs.modal', function () {
				$scope.clientDeleteErrorMessage = errorMessage;
				$('#errorMessageModal').modal('show');
				$(this).off('hidden.bs.modal');
			});
		}

		$scope.checkEdit = function () {
			if (!$scope.editedUser.firstName) {
				return messageService.showToaster('e_0', 'companyUsers');
			}
			$scope.saveEditChanges();
		};

		$scope.saveEditChanges = function () {
			$scope.button_disable = true;
			$scope.isEditUserSpinnningWheelActive = true;

			$http({
				method: 'POST',
				url: '/protected/rest/company/user/edit',
				data: $scope.editedUser
			}).then(function (result) {
				$scope.button_disable = false;
				if (result.data) {
					messageService.showToaster('s_0', 'companyUsers', $scope.editedUser.email);
					$('#edit').modal('hide');
					$scope.getUsers();
				}
			}, function () {
				messageService.showToaster('e_0', 'general');
			}).finally(function () {
				$scope.button_disable = false;
				$scope.isEditUserSpinnningWheelActive = false;
			});
		};
	}
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./web/js/controllers/contractsController.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, toastr) {

var _operators = __webpack_require__("./node_modules/rxjs/operators.js");

(function () {
	angular.module('main').controller('ContractsController', ContractsController);

	ContractsController.$inject = ['$scope', '$rootScope', '$http', '$filter', 'messageService', 'validationService', 'contractsDataService', 'utilsService'];

	function ContractsController($scope, $rootScope, $http, $filter, messageService, validationService, contractsDataService, utilsService) {
		var _this = this;

		$scope.$on('$viewContentLoaded', function () {
			$scope.isUpdateSpinnningWheelActive = false;
			$scope.isDelateSpinnningWheelActive = false;
			$scope.isEditSpinnningWheelActive = false;
			$scope.isDuplicateSpinnningWheelActive = false;
			$scope.savingContract = false;
			$scope.newContractName = '';
			$scope.contractTextForDiff = null;
		});

		$scope.save = function () {
			if (validationService.isStringEmpty($scope.updatecontract.name)) {
				messageService.showToaster('e_3', 'general', 'Name');
				return;
			}

			if ($scope.updatecontract.showOtpInConsent && validationService.isStringEmpty($scope.updatecontract.optInConsentStatement)) {
				messageService.showToaster('e_3', 'general', 'Opt-in consent');
				return;
			}

			if ($scope.updatecontract.linkedToInvoiceSample || $scope.updatecontract.linkedToQuoteSample || $scope.updatecontract.linkedToWorkflow) {
				if ($scope.contractTextForDiff && validationService.trimHTML($scope.contractTextForDiff) !== validationService.trimHTML($scope.updatecontract.text)) {
					utilsService.showNextModal('#updateModal', '#confirmEditContractModal');
					return;
				}
			}

			$scope.isUpdateSpinnningWheelActive = true;
			var item = $scope.updatecontract;
			item.text = $rootScope.addMaiStyling(item.text);
			$http({
				method: 'POST',
				url: '/protected/rest/contracts/update',
				data: item
			}).then(function (result) {
				if (result.data) {
					if (result.data.message) {
						var successMsgCode = item.id ? 's_2' : 's_1';
						messageService.showToaster(successMsgCode, 'contractTemplates', item.name);
						$('#updateModal').modal('hide');
						$('#confirmEditContractModal').modal('hide');
						getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
					} else if (result.data.errorMessage) {
						toastr.error(result.data.errorMessage);
					}
				}
			}).catch(function (result) {
				messageService.showToaster('e_0', 'general');
			}).finally(function (result) {
				$scope.isUpdateSpinnningWheelActive = false;
			});
		};
		$scope.showOptIn = function (value) {
			$scope.updatecontract.showOtpInConsent = value;
		};

		$scope.deleteContract = function (id) {
			delete $scope.updatecontract;
			var contract = findById(id, $scope.contracts);
			$scope.updatecontract = angular.copy(contract);
			$('#deleteModal').modal();
		};

		$scope.confirmDeleteContract = function (id) {
			$scope.isDelateSpinnningWheelActive = true;
			$('#deleteModal').modal('hide');
			var item = $scope.updatecontract;

			$http({
				method: 'POST',
				url: '/protected/rest/contracts/delete',
				data: item
			}).then(function (result) {
				successDeleteContract();
			}).catch(function (result) {
				return errorDeleteContract(result.data);
			}).finally(function () {
				$scope.isDelateSpinnningWheelActive = false;
				getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
			});
		};

		function successDeleteContract() {
			messageService.showToaster('s_0', 'contract');
		}

		function errorDeleteContract(data) {
			messageService.handleError({ error: data });
		}

		$scope.duplicate = function (id) {
			delete $scope.updatecontract;
			$scope.isDuplicateSpinnningWheelActive = true;

			var contract = findById(id, $scope.contracts);
			$scope.updatecontract = angular.copy(contract);

			if ($scope.updatecontract) {
				$scope.updatecontract.id = null;
				$scope.modal_description = 'Duplicate contract';
				$scope.modal_title = 'Duplicate contract';
			}
			$('#updateModal').modal();
			$scope.isDuplicateSpinnningWheelActive = false;
		};
		$scope.update = function (id) {
			delete $scope.updatecontract;
			$scope.isEditSpinnningWheelActive = true;
			var contract = findById(id, $scope.contracts);
			$scope.updatecontract = angular.copy(contract);
			$scope.contractTextForDiff = null;
			if (contract) {
				$scope.contractTextForDiff = contract.text;
			}

			if ($scope.updatecontract) {
				$scope.modal_description = 'Update contract';
				$scope.modal_title = 'Update contract';
			} else {
				$scope.modal_description = 'Add a new contract';
				$scope.modal_title = 'Add a new contract';
			}
			$scope.isEditSpinnningWheelActive = false;
			$('#updateModal').modal('show').on('shown.bs.modal', function () {
				var input = $(this).find('input');
				validationService.isModalClosePrevented(input);
			});
		};

		$scope.overwriteContract = function () {
			$scope.contractTextForDiff = null;
			$scope.save();
		};

		$scope.saveNewContractModal = function () {
			utilsService.showNextModal('#confirmEditContractModal', '#saveNewTemplateModal');
		};

		$scope.closeConfirmEditContractModal = function () {
			utilsService.showNextModal('#confirmEditContractModal', '#updateModal');
		};

		$scope.saveNewContract = function () {
			if (!$scope.newContractName || $scope.newContractName && !$scope.newContractName.trim()) {
				messageService.showToaster('e_3', 'quoteInvoiceTemplates');
				return;
			}

			var newContract = JSON.parse(JSON.stringify($scope.updatecontract));
			newContract.name = $scope.newContractName;

			$scope.savingContract = true;
			contractsDataService.saveNewContractTemplate(newContract).pipe((0, _operators.finalize)(function () {
				return $scope.savingContract = false;
			})).subscribe(function () {
				$scope.closeModal('saveNewTemplateModal');
				$scope.newContractName = '';
				_this.messageService.showToaster('s_5', 'quoteInvoiceTemplates', newContract.name);
				getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
			}, function (error) {
				return messageService.handleError(error);
			});
		};

		$scope.closeSaveNewModal = function () {
			utilsService.showNextModal('#saveNewTemplateModal', '#confirmEditContractModal');
			$scope.newContractName = '';
		};

		$scope.openModal = function (modalId) {
			$('#' + modalId).modal();
		};

		$scope.closeModal = function (modalId) {
			$('#' + modalId).modal('hide');
		};

		$scope.$on('$viewContentLoaded', function () {
			$('body').updatePolyfill();
			$scope.pageRequest = {
				page: 1,
				perPage: $rootScope.paginationPerPage ? $rootScope.paginationPerPage : 25,
				pageOrder: {
					predicate: 'name',
					reverse: false
				},
				search: null
			};
			$scope.totalItems = 0;
			getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
		});
		$scope.order = function (predicate) {
			$scope.pageRequest.pageOrder.reverse = $scope.pageRequest.pageOrder.predicate === predicate ? !$scope.pageRequest.pageOrder.reverse : false;
			getResultsPage(null, null, predicate, $scope.pageRequest.pageOrder.reverse);
		};

		$scope.getCurrentPage = function () {
			return $scope.pageRequest.page;
		};

		$scope.perPageChanged = function (newPerPage) {
			getResultsPage(null, newPerPage);
			$rootScope.paginationPerPage = newPerPage;
		};

		$scope.goToPage = function (newPage, disabled) {
			if (!disabled) {
				getResultsPage(newPage, null);
			}
		};
		$scope.jumpBack = function (disabled) {
			if (!disabled) {
				if ($scope.pageRequest.page > 1) {
					getResultsPage($scope.pageRequest.page - 1, null);
				}
			}
		};
		$scope.jumpAhead = function (disabled) {
			if (!disabled) {
				if ($scope.totalItems >= $scope.pageRequest.page * $scope.pageRequest.perPage + 1) {
					getResultsPage($scope.pageRequest.page + 1, null);
				}
			}
		};

		$scope.breadcrumbs = [{ link: '/', title: 'Dashboard' }, { link: '/settings', title: 'Settings' }, { link: null, title: 'Contract Templates' }];

		function findById(id, array) {
			if (!id) {
				id = null;
			}
			var found = null;
			found = $filter('filter')(array, {
				id: id
			}, true);
			if (found && found.length) {
				var contract = found[0];
				return contract;
			}
		}

		function getResultsPage(pageNumber, perPage, predicate, reverse) {
			var changed = false;
			if (typeof predicate !== 'undefined' && predicate != null && typeof reverse !== 'undefined' && reverse != null) {
				$scope.pageRequest.pageOrder.predicate = predicate;
				$scope.pageRequest.pageOrder.reverse = reverse;
				changed = true;
			}

			if (typeof perPage !== 'undefined' && perPage != null) {
				$scope.pageRequest.perPage = perPage;
				changed = true;
			}
			if (typeof pageNumber !== 'undefined' && pageNumber != null) {
				$scope.pageRequest.page = pageNumber;
				changed = true;
			}

			if ($scope.pageRequest && $scope.totalItems != 0 && $scope.totalItems < ($scope.pageRequest.page - 1) * $scope.pageRequest.perPage + 1) {
				$scope.pageRequest.page = 1;
			}
			if (changed) {
				$http.get('/protected/rest/contracts?perPage=' + $scope.pageRequest.perPage + '&page=' + $scope.pageRequest.page + '&predicate=' + $scope.pageRequest.pageOrder.predicate + '&reverse=' + $scope.pageRequest.pageOrder.reverse).then(function (result) {
					$scope.gdprEnabled = result.data.gdprEnabled;
					if (result.data && result.data.pageRequest) {
						$scope.pageRequest = result.data.pageRequest;
					}
					$scope.pageNumbers = [];
					$scope.totalItems = result.data.total;
					var pagesCount = $scope.totalItems / $scope.pageRequest.perPage;
					pagesCount = Math.ceil(pagesCount);
					for (var i = 1; i <= pagesCount; i++) {
						$scope.pageNumbers[i - 1] = i;
					}
					$scope.contracts = result.data.results;
				});
			}
		}

		$scope.disableDragDrop = function () {
			return true;
		};
	}
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js"), __webpack_require__("./node_modules/toastr/toastr.js")))

/***/ }),

/***/ "./web/js/controllers/googleAutocompleteController.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
	angular.module('main').controller('GoogleAutocompleteController', GoogleAutocompleteController);

	GoogleAutocompleteController.$inject = ['$scope', '$rootScope'];

	function GoogleAutocompleteController($scope, $rootScope) {
		$scope.result = '';
		$scope.options = {};
		$scope.defaultLocation = 'Lviv';

		$scope.formGeocode = {
			type: 'geocode',
			bounds: {
				SWLat: 49,
				SWLng: -97,
				NELat: 50,
				NELng: -96
			},
			country: 'ca',
			typesEnabled: false,
			boundsEnabled: false,
			componentEnabled: false,
			watchEnter: true,
			foundLocation: $rootScope.jobLocation
		};

		// watch form for changes
		$scope.watchForm = function () {
			return $scope.formGeocode;
		};
		$scope.$watch($scope.watchForm, function () {
			$scope.checkForm();
		}, true);

		// set options from form selections
		$scope.checkForm = function () {
			$scope.options = {};

			$scope.options.watchEnter = $scope.formGeocode.watchEnter;

			$scope.options.foundLocation = $rootScope.jobLocation;

			if ($scope.formGeocode.typesEnabled) {
				$scope.options.types = $scope.formGeocode.type;
			}
			if ($scope.formGeocode.boundsEnabled) {
				var SW = new google.maps.LatLng($scope.formGeocode.bounds.SWLat, $scope.formGeocode.bounds.SWLng);
				var NE = new google.maps.LatLng($scope.formGeocode.bounds.NELat, $scope.formGeocode.bounds.NELng);
				var bounds = new google.maps.LatLngBounds(SW, NE);
				$scope.options.bounds = bounds;
			}
			if ($scope.formGeocode.componentEnabled) {
				$scope.options.country = $scope.formGeocode.country;
			}
		};

		var listenerAutocomplete = function listenerAutocomplete(newValue, oldValue) {
			if (newValue === oldValue) {
				return;
			}
			$scope.$parent.job.location = newValue;
		};

		$scope.$watch('autocomplete', listenerAutocomplete);

		var listenerSetDeaultLocation = function listenerSetDeaultLocation(newValue, oldValue) {
			if (newValue === oldValue) {
				return;
			}
			$scope.autocomplete = newValue;
		};

		$scope.$parent.$watch('job.location', listenerSetDeaultLocation);
	}
})();

/***/ }),

/***/ "./web/js/controllers/homeController.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Rx, $) {

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
	angular.module('main').controller('HomeController', HomeController);

	HomeController.$inject = ['$scope', '$rootScope', '$timeout', '$http', '$q', '$location', 'messageService', 'jobDataService', 'workflowService', 'extraShootService', 'appointmentService', 'timeService', 'accountService', 'jobTypesDataService', 'workflowDataService', 'settingsService', 'utilsService', 'templateRequestsService', 'clientService', 'timeConverter', 'brandsDataService'];

	function HomeController($scope, $rootScope, $timeout, $http, $q, $location, messageService, jobDataService, workflowService, extraShootService, appointmentService, timeService, accountService, jobTypesDataService, workflowDataService, settingsService, utilsService, templateRequestsService, clientService, timeConverter, brandsDataService) {
		$scope.$watch('$viewContentLoaded', function (event) {
			$scope.unsubscribe = new Rx.Subject();
			$scope.now = new Date();
			getCompanyId();
			subscribeToCustomizeLabelsChange();
			subscribeToBrandsChange();
			$scope.now.setHours(12, 0, 0, 0);
			$scope.workflowNames = [];
			$scope.isAddNewSpinnningWheelActive = false;
			$rootScope.removeBg = 'white-background';
		});

		$scope.$on('$destroy', function () {
			$scope.unsubscribe.next();
			$scope.unsubscribe.complete();
			$scope.jobTypesSubscription.unsubscribe();
		});

		$scope.isDisabled = true;
		$scope.activeJobs = [];

		function getCompanyId() {
			accountService.companyIdObservable.takeUntil($scope.unsubscribe).subscribe(function (data) {
				$scope.companyId = data;
				getJobTypes();
			});
		}

		$scope.$watch('totalInvoicedDateItem', function (newValue, oldValue) {
			if (newValue != oldValue && newValue !== undefined) {
				$http.get('/protected/rest/dashboard/get/total/invoiced?dateItem=' + newValue).then(function (result) {
					$rootScope.rootTotalInvoicedDateItem = newValue;
					if (result.data) {
						$rootScope.totalInvoiced = result.data;
						$scope.data.totalInvoiced = result.data;
					} else if (result.data === 0) {
						$rootScope.totalInvoiced = 0;
						$scope.data.totalInvoiced = result.data;
					}
				}, function () {});
			}
		});
		$scope.$watch('jobsLeadDateItem', function (newValue, oldValue) {
			if (newValue != oldValue && newValue !== undefined) {
				$http.get('/protected/rest/dashboard/get/jobs/leads?dateItem=' + newValue).then(function (result) {
					$rootScope.rootJobsLeadDateItem = newValue;
					if (result.data) {
						$rootScope.jobsLead = result.data;
						$scope.data.jobsLead = result.data;
					} else if (result.data === 0) {
						$rootScope.jobsLead = 0;
						$scope.data.jobsLead = result.data;
					}
				});
			}
		});
		$scope.$watch('jobsAcceptedDateItem', function (newValue, oldValue) {
			if (newValue != oldValue && newValue !== undefined) {
				$http.get('/protected/rest/dashboard/get/jobs/accepted?dateItem=' + newValue).then(function (result) {
					$rootScope.rootJobsAcceptedDateItem = newValue;
					if (result.data) {
						$rootScope.jobsAccepted = result.data;
						$scope.data.jobsAccepted = result.data;
					} else if (result.data === 0) {
						$rootScope.jobsAccepted = 0;
						$scope.data.jobsAccepted = result.data;
					}
				});
			}
		});

		$scope.$watch('jobsScheduledDateItem', function (newValue, oldValue) {
			if (newValue != oldValue && newValue !== undefined) {
				$http.get('/protected/rest/dashboard/get/jobs/scheduled?dateItem=' + newValue).then(function (result) {
					$rootScope.rootJobsScheduledDateItem = newValue;
					if (result.data) {
						$rootScope.jobsScheduled = result.data;
						$scope.data.jobsScheduled = result.data;
					} else if (result.data === 0) {
						$rootScope.jobsScheduled = 0;
						$scope.data.jobsScheduled = result.data;
					}
				});
			}
		});

		$scope.showJob = function (jobId) {
			if (jobId !== null) {
				$location.path('jobs/view/' + jobId);
			}
		};

		$scope.chooseModalHandler = function (event) {
			getActiveJobs().then(function () {
				chooseEventModal(event);
			});
		};

		function isAppointment(event) {
			return event.calendarEventType === 'APPOINTMENT';
		}

		function isJob(event) {
			return event.calendarEventType === 'MAIN_SHOOT';
		}

		function isExtraShoot(event) {
			return event.calendarEventType === 'EXTRA_SHOOT';
		}

		function chooseEventModal(event) {
			if (typeof event === 'undefined' || event === null) {
				return;
			}

			if (isJob(event) || isAppointment(event) && event.jobId) {
				$location.path('jobs/view/' + event.jobId);
			} else if (isAppointment(event)) {
				appointmentService.prepareAppointmentToShow(event).subscribe(function (appointment) {
					workflowService.setTaskInfo(appointment);
					$('#appointment').modal('show');
				});
			} else if (isExtraShoot(event)) {
				var extraShoot = extraShootService.prepareExtraShootToShow(event);
				workflowService.setTaskInfo(extraShoot);
				$('#extraShootModal').modal('show');
			} else {
				workflowService.setTaskInfo({});
				$('#appointment').modal('show');
			}
		}

		$scope.showInvoice = function (id) {
			$location.path('invoices/' + id);
		};

		$scope.hideHelp = function (id) {};

		function getJobTypes() {
			$scope.jobTypesSubscription = jobTypesDataService.getJobTypes().subscribe(function (data) {
				return successGetJobTypes(data);
			});
		}

		function successGetJobTypes(data) {
			$scope.jobTypes = angular.copy(data);

			var defaultType = data.find(function (type) {
				return type.default === true;
			});
			if (defaultType) {
				$scope.defaultJobType = defaultType;
			}

			if (!localStorage.getItem('dashboardJobType' + $scope.companyId)) {
				localStorage.setItem('dashboardJobType' + $scope.companyId, (-1).toString());
			}
		}

		function getWorkflowAndLanguageNames() {
			return workflowDataService.getWorkflowAndLanguageNames().map(function (data) {
				return successGetWorkflowAndLanguageNames(data);
			});
		}

		function successGetWorkflowAndLanguageNames(data) {
			if (!data) {
				return false;
			}
			$scope.newJob.workflowNames = angular.copy(data.workflows);
			$scope.newJob.languageNames = angular.copy(data.languages);
		}

		function showNewJobModal(event) {
			var selectModal = '#addNewModal',
			    nextModal = '#newJob';
			$scope.button_disable = false;
			utilsService.showNextModal(selectModal, nextModal, event);
			$scope.isCreateJobSpinnningWheelActive = false;
			$scope.$broadcast('showModalJob', $scope.newJob);
		}

		function showNewLeadModal(event) {
			var selectModal = '#addNewModal',
			    nextModal = '#newLead';
			$scope.button_disable = false;
			utilsService.showNextModal(selectModal, nextModal, event);
			$scope.isCreateJobSpinnningWheelActive = false;
			$scope.$broadcast('showModal', $scope.newJob);
		}

		$scope.showAddNewJobModal = function (event) {
			delete $scope.newJob;
			$scope.button_disable = true;
			$scope.isAddNewSpinnningWheelActive = true;
			$scope.isDisabled = true;
			$scope.newJob = {};
			$scope.newJob.jobTypes = $scope.jobTypes;
			$scope.clients = [];

			if ($scope.defaultJobType) {
				$scope.newJob.type = $scope.defaultJobType;
			}

			getWorkflowAndLanguageNames().takeUntil($scope.unsubscribe).finally(function () {
				$scope.isDisabled = true;
				$scope.button_disable = false;
				$scope.isAddNewSpinnningWheelActive = false;
			}).subscribe(function () {
				showNewJobModal(event);
			});
		};

		$scope.showAddNewLeadModal = function (event) {
			delete $scope.newJob;
			$scope.button_disable = true;
			$scope.addNewLeadSpinningWheel = true;
			$scope.isDisabled = true;
			$scope.newJob = {};
			$scope.newJob.jobTypes = $scope.jobTypes;
			$scope.clients = [];

			if ($scope.defaultJobType) {
				$scope.newJob.type = $scope.defaultJobType;
			}

			getWorkflowAndLanguageNames().takeUntil($scope.unsubscribe).finally(function () {
				$scope.isDisabled = true;
				$scope.button_disable = false;
				$scope.addNewLeadSpinningWheel = false;
			}).subscribe(function () {
				showNewLeadModal(event);
			});
		};

		$scope.addExtraShoot = function (event) {
			$scope.button_disable = true;
			$scope.isAddNewSpinnningWheelActive = true;
			event.preventDefault();

			$('#addNewModal').modal('hide').on('hidden.bs.modal', function () {
				var _this = this;

				getActiveJobs().then(function () {
					addNewEvent();
					$scope.button_disable = false;
					$scope.isAddNewSpinnningWheelActive = false;
					$('#extraShootModal').modal('show');
					$(_this).off('hidden.bs.modal');
				});
			});
		};

		$scope.appointmentModal = function (event) {
			$scope.button_disable = true;
			$scope.isAddNewSpinnningWheelActive = true;

			$('#addNewModal').modal('hide').on('hidden.bs.modal', function () {
				var _this2 = this;

				getActiveJobs().then(function () {
					addNewEvent();
					$scope.button_disable = false;
					$scope.isAddNewSpinnningWheelActive = false;
					$('#appointment').modal('show');
					$(_this2).off('hidden.bs.modal');
				});
			});
		};

		function addNewEvent() {
			workflowService.setTaskInfo({});
			$scope.$evalAsync();
		}

		function getActiveJobs() {
			var deferred = $q.defer();

			if (!$scope.activeJobs.length) {
				jobDataService.getActiveJobs().then(function (jobs) {
					$scope.activeJobs = jobs;
					deferred.resolve(jobs);
				}).catch(messageService.showDefaultErrorMessage);
			} else {
				deferred.resolve($scope.activeJobs);
			}

			return deferred.promise;
		}

		$scope.sendEmailModalHandler = function (_ref) {
			var leadId = _ref.leadId,
			    contact = _ref.contact,
			    secondaryContact = _ref.secondaryContact;

			$scope.showSendEmailModalSpinningWheel = true;

			Rx.Observable.zip(templateRequestsService.getTemplates('general_preview'), templateRequestsService.getTemplates('email_signature')).takeUntil($scope.unsubscribe).finally(function () {
				$scope.showSendEmailModalSpinningWheel = false;
			}).subscribe(function (_ref2) {
				var _ref3 = _slicedToArray(_ref2, 2),
				    emails = _ref3[0],
				    mailSignature = _ref3[1];

				$scope.mailData2Save = angular.copy(contact);
				if (secondaryContact) {
					$scope.mailData2Save.secondaryEmail = secondaryContact.email;
				}
				$scope.mailData2Save.emails = emails;
				$scope.mailData2Save.mailSignature = mailSignature.signature || '';

				$rootScope.clientToken = false;

				if (!$scope.$$phase) {
					$scope.$apply();
				}
				$scope.leadId = leadId;
				$scope.sendEmailLeadId = leadId || null;
				$('#sendContactEmailModal').modal('show');
			});
		};

		$scope.editJobModalHandler = function (job) {
			$scope.button_disable = true;
			$scope.newJob = angular.copy(job);
			prepareJob();
			$scope.$evalAsync();
		};

		function prepareJob() {
			$scope.clients = [];

			var _$scope$newJob = $scope.newJob,
			    workflow = _$scope$newJob.workflow,
			    startDate = _$scope$newJob.startDate,
			    finishDate = _$scope$newJob.finishDate,
			    primaryContact = _$scope$newJob.primaryContact,
			    secondaryContact = _$scope$newJob.secondaryContact;


			$scope.newJob.oldWorkflow = workflow;

			if (!$scope.newJob.startDate) {
				$scope.newJob.hasNoDate = true;
			} else {
				$scope.dateFilterJob = 'dd/MM/yyyy';
				$scope.newJob.hasNoDate = false;
				$scope.newJob.startDate = timeService.createDateAsUTC(startDate);
				$scope.newJob.finishDate = timeService.createDateAsUTC(finishDate);
			}

			if (primaryContact) {
				var primaryClientSearchText = clientService.fillClientSearchText(primaryContact);
				$scope.clients[0] = primaryClientSearchText;
				$scope.newJob.primaryContact = $scope.clients[0];
			}

			if (secondaryContact) {
				var secondaryClientSearchText = clientService.fillClientSearchText(secondaryContact);
				$scope.clients[1] = secondaryClientSearchText;
				$scope.newJob.secondaryContact = $scope.clients[1];
			}

			if ($scope.newJob.startDate && ($scope.newJob.startTime === null || $scope.newJob.finishTime === null)) {
				$scope.newJob.allday = true;
			}
			var type = $scope.newJob.type;
			$scope.newJob.jobTypes = $scope.jobTypes;

			getWorkflowAndLanguageNames().takeUntil($scope.unsubscribe).finally(function () {
				$scope.button_disable = false;
				$scope.isCreateJobSpinnningWheelActive = false;
			}).subscribe(function () {
				$timeout(function () {
					$scope.newJob.type = type;
					$('#newJob').modal('show');
					$scope.isCreateJobSpinnningWheelActive = false;
					$scope.$broadcast('showModalJob', $scope.newJob);
				}, 300);
			});
		}

		$scope.editLeadModalHandler = function (lead) {
			$scope.button_disable = true;
			$scope.newJob = angular.copy(lead);
			prepareLead($scope.newJob);

			if ($scope.newJob.startTime) {
				$scope.newJob.startTime = timeConverter.convert24to12($scope.newJob.startTime);

				$scope.newJob.finishTime = timeConverter.convert24to12($scope.newJob.finishTime);
			}
		};

		$scope.updateRecentLeadsModel = function (resetPagination) {
			snCommunicationAdapter.callMethod('updateRecentLeadsModel', resetPagination);
		};

		$scope.updateShootsModel = function (resetPagination) {
			snCommunicationAdapter.callMethod('updateShootsModel', resetPagination);
		};

		$scope.updateJobTasksModel = function (resetPagination) {
			snCommunicationAdapter.callMethod('updateJobTasksModel', resetPagination);
		};

		$scope.updateGraphsModel = function (tabs) {
			snCommunicationAdapter.callMethod('updateGraphsModel', tabs);
		};

		$scope.updateUpcomingPaymentsModel = function (resetPagination) {
			window.snCommunicationAdapter.callMethod('updateUpcomingPaymentsModel', resetPagination);
		};

		function subscribeToBrandsChange() {
			brandsDataService.brandsChange.takeUntil($scope.unsubscribe).subscribe(function () {
				getJobTypes();
			});
		}

		function subscribeToCustomizeLabelsChange() {
			settingsService.customizeLabelsObservable.takeUntil($scope.unsubscribe).subscribe(function (customizeLabels) {
				$scope.mainShootLabelName = customizeLabels.mainShootLabel;
				$scope.extraShootLabelName = customizeLabels.extraShootLabel;
				$scope.businessNumberLabelName = customizeLabels.businessNumberLabel;
				$scope.businessNumberLabelName = customizeLabels.businessNumberLabel;
			});
		}

		function prepareLead() {
			$scope.clients = [];

			var _$scope$newJob2 = $scope.newJob,
			    startDate = _$scope$newJob2.startDate,
			    finishDate = _$scope$newJob2.finishDate,
			    primaryContact = _$scope$newJob2.primaryContact,
			    secondaryContact = _$scope$newJob2.secondaryContact,
			    workflow = _$scope$newJob2.workflow;


			$scope.newJob.oldWorkflow = workflow;

			if (!startDate && !finishDate) {
				$scope.newJob.hasNoDate = !!$scope.newJob.id;
			} else {
				$scope.newJob.hasNoDate = false;
				if (startDate) {
					$scope.newJob.startDate = timeService.createDateAsUTC(startDate);
				}
				if (finishDate) {
					$scope.newJob.finishDate = timeService.createDateAsUTC(finishDate);
				}
			}

			if (primaryContact) {
				var primaryClientSearchText = clientService.fillClientSearchText(primaryContact);
				$scope.clients[0] = primaryClientSearchText;
				$scope.newJob.primaryContact = $scope.clients[0];
			}

			if (secondaryContact) {
				var secondaryClientSearchText = clientService.fillClientSearchText(secondaryContact);
				$scope.clients[1] = secondaryClientSearchText;
				$scope.newJob.secondaryContact = $scope.clients[1];
			}
			if ($scope.newJob.startDate && ($scope.newJob.startTime === null || $scope.newJob.finishTime === null)) {
				$scope.newJob.allday = true;
			}
			var type = $scope.newJob.type;
			$scope.newJob.jobTypes = $scope.jobTypes;

			getWorkflowAndLanguageNames().takeUntil($scope.unsubscribe).finally(function () {
				$scope.button_disable = false;
				$scope.isCreateJobSpinnningWheelActive = false;
			}).subscribe(function () {
				$timeout(function () {
					$scope.newJob.type = type;
					$('#newLead').modal('show');
					$scope.isCreateJobSpinnningWheelActive = false;
					$scope.$broadcast('showModal', {
						lead: $scope.newJob,
						jobId: $scope.newJob.jobId
					});
				}, 300);
			});
		}
	}
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/rxjs/Rx.js"), __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./web/js/controllers/invoiceViewController.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

(function () {
	angular.module('main').controller('InvoiceViewController', InvoiceViewController);

	InvoiceViewController.$inject = ['$scope', '$rootScope', '$routeParams', '$location', '$http', 'jobDataService', 'messageService', 'fileUploadService', 'validationService', 'emailService', 'invoicesDataService'];

	function InvoiceViewController($scope, $rootScope, $routeParams, $location, $http, jobDataService, messageService, fileUploadService, validationService, emailService, invoicesDataService) {
		$scope.data = {};

		$scope.$on('$viewContentLoaded', function () {
			$scope.invoiceId = $routeParams.id;
		});

		$scope.sendMessage = {};
		$scope.sendMessage.emailTo = [];
		$scope.sendMessage.addInvoiceAttachment = true;
		$scope.attachmentsData = {
			attachments: [],
			filesSize: 0
		};
		var isFirstShow = true;

		$scope.setEmailData = function (newData, object, property) {
			$scope[object][property] = newData;
		};

		$scope.toggleViewCc = function (state) {
			if ($scope.sendMessage && $scope.sendMessage.emailCc) {
				$scope.sendMessage.emailCc = [];
			}

			if ($scope.sendMessage && !$scope.sendMessage.addInvoiceAttachment) {
				$scope.sendMessage.addInvoiceAttachment = true;
			}

			$scope.showCcField = state !== undefined ? state : !$scope.showCcField;

			if (state === false) {
				isFirstShow = false;
				$scope.sendMessage.emailTo = [];
				$scope.attachmentsData = {
					attachments: [],
					filesSize: 0
				};
			}
		};

		$scope.addContactMail = function (contactEmail) {
			$scope.contactEmail = contactEmail;
		};

		$scope.addSubjectVariable = function ($event, id) {
			var el = document.getElementById(id);
			$scope.sendMessage.emailSubject = emailService.addSubjectVariable(el, $event);
		};

		// Email methods
		$scope.retrySendMail = function () {
			getInvoiceInformation($routeParams.id);
			emailService.callLastEmailFn();
		};

		$scope.showSendInvoice = function (_ref) {
			var isReceipt = _ref.isReceipt,
			    data = _ref.data,
			    invoice = _ref.invoice;

			$scope.isSendReceiptSpinnningWheelActive = true;
			$rootScope.backId = $scope.data.id;
			$scope.receiptId = data.id;
			if (invoice.job.secondaryContact) {
				$scope.secondaryContactEmail = invoice.job.secondaryContact.email;
			}
			delete $scope.sendMessage;
			$scope.sendMessage = {};
			$scope.emailDataToSave = {};
			$scope.sendMessage.addInvoiceAttachment = true;
			$scope.sendReceipt = !!isReceipt;

			$http.get('/protected/rest/email_templates/get').then(function (result) {
				if (result.data) {
					$scope.$evalAsync();

					$scope.emails = result.data;

					if ($scope.emails) {
						var template = isReceipt ? 'RECEIPT_OF_PAYMENT_EMAIL_TEMPLATE' : 'INVOICE_EMAIL_TEMPLATE';
						$scope.choosenEmail = $scope.emails.find(function (item) {
							return item.emailTemplateType === template;
						}) || {};
					}
					$('#sendInvoiceModal').modal('show').on('shown.bs.modal', function () {
						var input = $('#sendInvoiceModal').find('input');

						validationService.isModalClosePrevented(input);
					});
				}
				$scope.isSendReceiptSpinnningWheelActive = false;
			}, function () {
				$scope.isSendReceiptSpinnningWheelActive = false;
			});
		};

		$scope.$watch('choosenEmail', function (newValue) {
			if (typeof newValue !== 'undefined' && newValue != null) {
				$http.get('/protected/rest/settings/email_template/get/' + newValue.id + '?forSend=true').then(function (result) {
					return successGetEmailTemplate(result.data);
				});
			}
		});

		function successGetEmailTemplate(email) {
			if (email) {
				$scope.sendMessage.emailSubject = email.subject;
				$scope.sendMessage.emailText = email.text.replace(/class="linkEdited"/g, 'class=""');
				if (email.storedAttachments && email.storedAttachments.length) {
					$scope.attachmentsData = {
						attachments: fileUploadService.convertAttachmentsToShow(email.storedAttachments)
					};
				} else {
					clearAttachments();
				}

				var rootEmail = $rootScope.primaryContact ? $rootScope.primaryContact.email || '' : '';
				$scope.sendMessage.emailTo = $scope.contactEmail ? [$scope.contactEmail] :  true ? [rootEmail] : [];
				if ($scope.secondaryContactEmail) {
					$scope.sendMessage.emailTo.push($scope.secondaryContactEmail);
				}
				$scope.sendMessage.emailCc = [];
			}
		}

		$scope.sendInvoice = function () {
			var maxSize = 10; // 10Mb

			if ($scope.attachmentsData && $scope.attachmentsData.filesSize > maxSize) {
				messageService.showToaster('w_0', 'attachments');
				return false;
			}

			var url = void 0;

			if (typeof $rootScope.backId === 'undefined') {
				$rootScope.backId = $routeParams.id;
			}

			var sendInvoiceFromInvoiceViewUrl = '/protected/rest/invoices/invoice/send/' + $rootScope.backId;
			var sendInvoiceFromJobViewUrl = '/protected/rest/invoices/invoice/send/' + $routeParams.id;
			var sendReceiptUrl = '/protected/rest/payment-receipt/' + $scope.receiptId + '/send';

			$scope.$evalAsync();

			if ($location.path().includes('invoices')) {
				url = $scope.sendReceipt ? sendReceiptUrl : sendInvoiceFromInvoiceViewUrl;
			} else {
				url = sendInvoiceFromJobViewUrl;
			}

			$scope.sendMessage.templateId = $scope.choosenEmail ? $scope.choosenEmail.id : '';
			$scope.sendMessage.emailText = $rootScope.addMaiStyling($scope.sendMessage.emailText);

			var mailData = emailService.prepareEmails($scope.sendMessage);

			if (!emailService.validateMails(mailData)) {
				return;
			}

			$scope.emailDataToSave = Object.assign({}, $scope.sendMessage, mailData);
			delete $scope.emailDataToSave.emailCc;

			$scope.isSendInvoiceSpinnningWheelActive = true;
			$scope.disableBtnOnSend = true;
			var obj2save = angular.copy($scope.emailDataToSave);

			$scope.sendMessage.emailCc = $scope.showCcField ? obj2save.emailCc : '';
			var formData = new FormData();
			angular.forEach($scope.emailDataToSave, function (value, key) {
				formData.append(key, value);
			});
			var storedFiles = $scope.attachmentsData.attachments.filter(function (file) {
				return file.id;
			});
			var uploadedFiles = $scope.attachmentsData.attachments.filter(function (file) {
				return !file.id;
			});

			angular.forEach(uploadedFiles, function (value, key) {
				formData.append('attachments[' + key + ']', value);
			});

			angular.forEach(storedFiles, function (value, key) {
				formData.append('storedAttachments[' + key + ']', value.id);
			});

			invoicesDataService.sendInvoiceRequest(url, formData).finally(function () {
				return $scope.isSendInvoiceSpinnningWheelActive = false;
			}).subscribe(successSendInvoice, errorSendInvoice);
		};

		function successSendInvoice() {
			isFirstShow = false;
			$('#sendInvoiceModal').modal('hide');
			$scope.disableBtnOnSend = false;
			$scope.showCcField = false;

			$scope.$evalAsync();

			clearAttachments();
			$scope.isJobView = $location.path().includes('/jobs/view/');
			$scope.isLeadView = $location.path().includes('/leads/view/');
			if ($scope.isJobView) {
				invoicesDataService.emitInvoiceUpdateEvent('UPDATE_SN_INVOICES');
				$rootScope.updateJobView();
			} else if ($scope.isLeadView) {
				$rootScope.updateLeadView();
				invoicesDataService.emitInvoiceUpdateEvent('UPDATE_SN_INVOICES');
			}

			var messageCode = $scope.sendReceipt ? 's_11' : 's_9';

			messageService.showToaster(messageCode, 'payments');

			var path = $location.path();

			if (path.includes('payments') || path.includes('invoices')) {
				snCommunicationAdapter.callMethod('getInvoice');
			}
		}

		function errorSendInvoice(_ref2) {
			var status = _ref2.status,
			    data = _ref2.data,
			    error = _ref2.error;

			$scope.disableBtnOnSend = false;

			var errorMessage = error.errorMessage,
			    errorTitle = error.errorTitle;

			var errorCode = void 0,
			    errorPlace = void 0,
			    value = void 0;

			if (status >= 400 && status < 500 && data.errorMessage) {
				if (status == 423) {
					var limit = $rootScope.isUserTrial ? 50 : 150;
					return messageService.showToaster('e_4', 'generalValidation', limit);
				} else if (data.errorMessage === 'Email text should contain an invoice link') {
					var path = $location.path();
					var isNotInvoiceTemplate = path.includes('jobs') || path.includes('payments') || path.includes('invoices');

					errorPlace = isNotInvoiceTemplate ? 'editInvoice' : 'emailTemplate';

					if ($scope.sendReceipt) {
						errorCode = 'e_7';
					} else if (!$scope.sendReceipt && isNotInvoiceTemplate) {
						errorCode = 'e_3';
					} else {
						errorCode = 'e_0';
					}
				} else if (data.errorMessage.includes('Email address inactive')) {
					errorCode = 'e_1';
					errorPlace = 'generalValidation';
					value = $scope.sendMessage.emailTo;
				} else if (errorTitle) {
					messageService.showErrorFromBackend(errorTitle, errorMessage);
					return;
				} else {
					errorCode = 'e_2';
					errorPlace = 'general';
					value = errorMessage;
				}
			} else {
				errorCode = 'e_0';
				errorPlace = 'general';
			}
			messageService.showToaster(errorCode, errorPlace, value);
		}

		function clearAttachments() {
			if ($scope.attachmentsData && $scope.attachmentsData.attachments) {
				if ($scope.attachmentsData.attachments.length) {
					$scope.attachmentsData.attachments.length = 0;
				}
			}
		}

		$scope.disableDragDrop = function () {
			return true;
		};

		function setMailData(_ref3) {
			var primaryContact = _ref3.primaryContact,
			    secondaryContact = _ref3.secondaryContact;

			$scope.contactEmail = primaryContact.email;
			if (secondaryContact) {
				$scope.secondaryContactEmail = secondaryContact.email;
			}
		}

		$(document).on('show.bs.modal', '#sendInvoiceModal', function (data) {
			if (isFirstShow) {
				isFirstShow = false;
				if (data.relatedTarget) {
					setMailData(data.relatedTarget);
				}
			}
			$scope.$broadcast('addedFileEvent');
		});
	}
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./web/js/controllers/job/jobContractController.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, toastr) {

(function () {
	angular.module('main').controller('JobContractController', JobContractController);

	JobContractController.$inject = ['$scope', '$rootScope', '$routeParams', '$location', '$http', '$q', 'jobDataService', 'messageService', 'fileUploadService', 'emailService', 'userService', 'newJobsDataService', 'workflowService', 'workflowDataService', 'utilsService', 'contractsDataService'];

	function JobContractController($scope, $rootScope, $routeParams, $location, $http, $q, jobDataService, messageService, fileUploadService, emailService, userService, newJobsDataService, workflowService, workflowDataService, utilsService, contractsDataService) {
		$scope.isJobView = $location.path().includes('/jobs/');
		$scope.isLeadView = $location.path().includes('/leads/');

		$scope.emailDataToSave = {};
		$scope.isMandatoryAgreement = false;
		$scope.agreementDescription = '';
		$scope.checked = false;

		if ($scope.isLeadView) {
			$scope.isArchived = true;
		}
		var isFirstShow = true;
		$scope.$on('$viewContentLoaded', function () {
			$scope.isDeleteContractSpinnningWheelActive = false;
			$scope.isSendContractSpinnningWheelActive = false;
			$scope.isSignSpinningWheelActive = false;
			if ($scope.isLeadView) {
				getLead($routeParams.leadId);
			} else if ($scope.isJobView) {
				getJobInfo($routeParams.jobId);
			}

			$scope.gdprEnabled = userService.userData.isGdprEnabled;
		});

		clearAttachments();
		function getLead(id) {
			var showTaskId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

			$http({
				method: 'GET',
				url: '/api/user/lead/' + id,
				params: {
					showTaskId: showTaskId
				}
			}).then(function (result) {
				$scope.jobId = result.data.job.id;
				$scope.isArchived = result.data.archived;
				if (result.data.job.primaryContact.email) {
					$scope.contactEmail = result.data.job.primaryContact.email;
				}
				if (result.data.job.secondaryContact) {
					$scope.secondaryContactEmail = result.data.job.secondaryContact.email;
				}
				if ($scope.jobId !== undefined) {
					getContactsInformation($scope.jobId);
				}
			}, function (error) {
				var _error$data = error.data,
				    errorCode = _error$data.errorCode,
				    data = _error$data.data;

				if (errorCode === 701) {
					redirectToJobLead(data);
				}
			});
		}

		function getJobInfo(id) {
			var showNewTaskId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

			$http({
				method: 'GET',
				url: '/protected/rest/jobs/view',
				params: {
					id: id,
					showNewTaskId: showNewTaskId
				}
			}).then(function (result) {
				$scope.jobId = result.data.id;

				if (result.data.primaryContact.email) {
					$scope.contactEmail = result.data.primaryContact.email;
				}
				if (result.data.secondaryContact) {
					$scope.secondaryContactEmail = result.data.secondaryContact.email;
				}
				if ($scope.jobId !== undefined) {
					getContactsInformation($scope.jobId);
				}
			}, function (error) {
				var _error$data2 = error.data,
				    errorCode = _error$data2.errorCode,
				    data = _error$data2.data;

				if (errorCode === 702) {
					redirectToJobLead(data);
				}
			});
		}

		function redirectToJobLead(data) {
			$location.path('/' + data.redirectTo + 's/view/' + data.redirectId + '/contracts/' + $routeParams.contractId);
		}

		$scope.$parent.$watch('attachmentsDataContract', function (newValue, oldValue) {
			if (newValue && newValue !== oldValue) {
				$scope.attachmentsData = newValue;
			}
		});

		$scope.reInitContract = function () {
			getContactsInformation($scope.jobId);
		};

		function getContactsInformation(id) {
			$http.get('/protected/rest/contracts/get/view/' + id + '/' + $routeParams.contractId).then(function (result) {
				if (result.data) {
					var _result$data = result.data,
					    contract = _result$data.contract,
					    company = _result$data.company,
					    errorCode = _result$data.errorCode;


					if (errorCode === 102) {
						showError();
					} else {
						$scope.contract = contract;
						getCPLink($scope.contract);
						if (contract.contactEmail) {
							$scope.contactEmail = contract.contactEmail;
						}
						$scope.company = company;

						var signatures = contract.signatures;

						if (signatures) {
							var signContractAgreementSettings = signatures.signContractAgreementSettings;

							if (signContractAgreementSettings) {
								var photographerSignature = signatures.signContractAgreementSettings.photographerSignature;

								if (photographerSignature) {
									$scope.isMandatoryAgreement = photographerSignature.mandatory;
									$scope.agreementDescription = photographerSignature.description;
								}
							}
						}

						if (contract.jobAttachments && contract.jobAttachments.length) {
							fileUploadService.setAttachmentsFromServer(contract.jobAttachments);
						}
					}
				}
			}).catch(function (error) {
				return error.errorCode ? 104 : showError();
			});
		}

		function showError() {
			if ($scope.isLeadView) {
				$location.path('/leads/view/' + $routeParams.leadId);
			} else if ($scope.isJobView) {
				$location.path('/jobs/view/' + $routeParams.jobId);
			}
			messageService.showToaster('e_2', 'contract');
		}

		function getCPLink(contract) {
			if (contract && contract.actions) {
				newJobsDataService.getCPLink(contract.actions.GET_CP_LINK.url).subscribe(function (result) {
					$scope.cpLink = result.data.link;
				});
			}
		}

		$scope.showSign = function () {
			$('#signModal').modal('show');
		};

		$scope.setEmailData = function (newData, object, property) {
			$scope[object][property] = newData;
		};

		$scope.addSubjectVariable = function ($event, id) {
			var el = document.getElementById(id);
			$scope.contractEmailTemplate.subject = emailService.addSubjectVariable(el, $event);
		};

		$scope.submitSign = function (id) {
			if ($('#signModalForm').checkValidity()) {
				$scope.isSignSpinningWheelActive = true;

				var signatureObj = {
					contractId: $scope.contract.id,
					jobId: $scope.contract.jobId,
					textSignature: $scope.textSignature,
					useElectronicSignaturesAgreement: $scope.checked
				};

				$http({
					method: 'POST',
					url: '/protected/rest/contract/photographer/signature',
					data: signatureObj
				}).then(function (data) {
					getContactsInformation($scope.jobId);
					$('#signModal').modal('hide');
					delete $scope.textSignature;
				}, function (_ref) {
					var data = _ref.data;
					var errorMessage = data.errorMessage,
					    errorTitle = data.errorTitle;

					messageService.showErrorFromBackend(errorTitle, errorMessage);
				}).finally(function () {
					$scope.isSignSpinningWheelActive = false;
				});
			} else {
				$('#signModalSubmit').click();
			}
		};

		function clearAttachments() {
			$scope.attachmentsData = {
				attachments: [],
				filesSize: 0
			};
		}

		$scope.modalClose = function () {
			$scope.showCcField = false;
			isFirstShow = true;
		};

		$scope.modalSignatureClose = function () {
			$scope.textSignature = '';
			$scope.checked = false;
		};

		$scope.toggleViewCc = function (state) {
			if ($scope.sendMessage && $scope.sendMessage.emailCc) {
				$scope.sendMessage.emailCc = [];
			}

			if (state === false) {
				$scope.attachmentsData = {
					attachments: [],
					filesSize: 0
				};
			}

			$scope.showCcField = state !== undefined ? state : !$scope.showCcField;
		};

		$scope.deleteModalContract = function () {
			if ($scope.isArchived) {
				messageService.showToaster('e_6', 'lead');
			} else {
				$('#deleteModal').modal();
			}
		};
		$scope.deleteContract = function (id) {
			$scope.isDeleteContractSpinnningWheelActive = true;

			$http({
				method: 'POST',
				url: '/protected/rest/contracts/view/delete/' + id
			}).then(function (result) {
				deleteCallback(result);
			}, function () {
				$scope.isDeleteContractSpinnningWheelActive = false;
			});
		};

		$scope.showNextModal = function (selectModal, nextModal, e) {
			utilsService.showNextModal(selectModal, nextModal, e);
		};

		function deleteCallback(res) {
			var data = res.data;
			var errorCode = data.errorCode,
			    errorMessage = data.errorMessage,
			    errorTitle = data.errorTitle;


			if (errorCode === 102 && errorMessage === 'Contract is assigned for task') {
				$('#deleteModal').modal('hide');
				// We do not have proper message from the backend, so we make a wrapper and get predefined error from service
				messageService.showToaster('e_1', 'contract');
			} else if (errorCode && errorMessage) {
				messageService.showErrorFromBackend(errorTitle, errorMessage);
			} else if (errorMessage) {
				toastr.error(errorMessage, 'Error');
			} else {
				messageService.showToaster('s_0', 'contract');
				if ($scope.contract.inLead === false) {
					$location.path('/jobs/view/' + $routeParams.jobId);
				} else {
					$location.path('/leads/view/' + $scope.contract.leadId);
				}
			}
			$scope.isDeleteContractSpinnningWheelActive = false;
		}

		$scope.showSendContract = function () {
			var contractUrl = '/protected/rest/job/contract/sources';
			$http({
				method: 'GET',
				url: contractUrl
			}).then(function (result) {
				$scope.contractSendSource = result.data;
				$scope.contractEmailTemplates = $scope.contractSendSource.emailTemplates;
				if ($scope.contractEmailTemplates && $scope.contractEmailTemplates.length > 0) {
					var template = $scope.contractEmailTemplates.find(function (item) {
						return item.emailTemplateType === 'CONTRACT_EMAIL_TEMPLATE';
					});

					$scope.chosenContractEmail = template || $scope.contractEmailTemplates[0];
					$scope.setContractEmailTemplate(template.id);
				}

				delete $scope.sendMessage;
				$scope.sendMessage = {};
				// $scope.sendMessage.emailTo = $scope.primaryContactEmail || '';
				var rootEmail = $rootScope.primaryContact ? $rootScope.primaryContact.email || '' : '';

				$scope.sendMessage.emailTo = $scope.contactEmail ? [$scope.contactEmail] :  true ? [rootEmail] : [];
				if ($scope.secondaryContactEmail) {
					$scope.sendMessage.emailTo.push($scope.secondaryContactEmail);
				}
				$scope.sendMessage.emailCc = [];

				$('#sendContractModal').modal('show');
			});
		};

		$scope.setContractEmailTemplate = function (id) {
			var contractSetEmailCallback = function contractSetEmailCallback(data) {
				$scope.contractEmailTemplate = angular.copy(data);
				if (data.storedAttachments && data.storedAttachments.length) {
					$scope.attachmentsData = {
						attachments: fileUploadService.convertAttachmentsToShow(data.storedAttachments)
					};
				} else {
					clearAttachments();
				}
			};
			$scope.getEmailTemplates(id, contractSetEmailCallback);
		};

		// START maybe need delete it
		$scope.getEmailTemplates = function (id, callback) {
			if (id != null) {
				var emailTemplateUrl = '/protected/rest/settings/email_template/get/' + id + '?forSend=' + true;
				$http({
					method: 'GET',
					url: emailTemplateUrl
				}).then(function (result) {
					callback(result.data);
				});
			}
		};
		// END :maybe need delete it

		// Email methods
		$scope.retrySendMail = function () {
			if ($scope.jobId !== undefined) {
				getContactsInformation($scope.jobId);
			}
			emailService.callLastEmailFn();
		};
		function saveChangeTask(task) {
			$scope.isSendContractSpinnningWheelActive = true;
			task.jobId = $scope.sendMessage.jobId;
			if ($scope.chosenContractEmail !== undefined && $scope.chosenContractEmail !== null) {
				task.taskEmail.emailTemplateId = $scope.chosenContractEmail.id;
			}
			if (task.overdueDays !== null) {
				task.overdueDays = parseInt(task.overdueDays.match(/\d+/)[0], 10);
			}
			task.taskEmail.subject = $scope.contractEmailTemplate.subject;
			task.taskEmail.text = $scope.contractEmailTemplate.text;
			task.taskEmail.storedAttachments = null;
			task.taskEmail.base64Attachments = null;
			$scope.uploadedAttachments = null;
			if ($scope.attachmentsData.attachments && $scope.attachmentsData.attachments.length !== 0) {
				task.taskEmail.storedAttachments = $scope.attachmentsData.attachments.filter(function (attachment) {
					return attachment.id;
				});
				$scope.uploadedAttachments = $scope.attachmentsData.attachments.filter(function (attachment) {
					return !attachment.id;
				});
			}

			if ($scope.uploadedAttachments && $scope.uploadedAttachments.length) {
				fileUploadService.convertFileToSave($scope.uploadedAttachments).then(function (convertedFilesArr) {
					task.taskEmail.base64Attachments = convertedFilesArr;
					workflowDataService.saveTask(task).subscribe(function (data) {
						return changeTaskState(data.tasks[data.taskToAnimate]);
					}, function (error) {
						return errorSaveTask(error.data);
					});
				}).catch(function (error) {
					return console.log(error);
				});
			} else {
				workflowDataService.saveTask(task).subscribe(function (data) {
					return changeTaskState(data.tasks[data.taskToAnimate]);
				}, function (error) {
					return errorSaveTask(error.data);
				});
			}
		}
		function errorSaveTask(data) {
			$scope.isSendContractSpinnningWheelActive = false;
			workflowService.errorSaveTask(data);
		}
		var saveTaskWithAttachments = function saveTaskWithAttachments(task) {
			prepareEmailAttachments(task.taskEmail).then(function (result) {
				task.taskEmail = result;
				saveChangeTask(task);
			}, function (error) {
				scope.button_disabled = false;
			});
		};
		var prepareEmailAttachments = function prepareEmailAttachments(taskEmail) {
			var deferred = $q.defer();
			taskEmail.attachmentsData = $scope.attachmentsData;
			var isAttachments = taskEmail.attachmentsData && taskEmail.attachmentsData.attachments.length;

			if (!isAttachments) {
				deferred.resolve(taskEmail);
				return deferred.promise;
			}

			var _taskEmail$attachment = taskEmail.attachmentsData,
			    attachments = _taskEmail$attachment.attachments,
			    filesSize = _taskEmail$attachment.filesSize;

			var maxSize = 10; // 10Mb

			if (filesSize > maxSize) {
				messageService.showToaster('w_0', 'attachments');
				deferred.reject('Attachments size exceeds the limit');
				return deferred.promise;
			}

			var uploadedAttachments = void 0,
			    storedAttachments = void 0;

			if (attachments.length) {
				uploadedAttachments = attachments.filter(function (attachment) {
					return !attachment.id;
				});
				$scope.storedAttachmentsForMail = attachments.filter(function (attachment) {
					return attachment.id;
				});
			}

			taskEmail.storedAttachments = storedAttachments && storedAttachments.length ? storedAttachments : null;

			if (uploadedAttachments && uploadedAttachments.length) {
				fileUploadService.convertFileToSave(uploadedAttachments).then(function (convertedFilesArr) {
					$scope.base64AttachmentsForMail = convertedFilesArr;
					deferred.resolve(taskEmail);
				}).catch(function (error) {
					return console.log(error);
				});
			} else {
				deferred.resolve(taskEmail);
			}

			delete taskEmail.attachmentsData;
			return deferred.promise;
		};

		$scope.sendContractEmail = function () {
			if ($scope.sendMessage.task !== undefined) {
				saveChangeTask($scope.sendMessage.task);
			} else {
				var maxSize = 10; // 10Mb

				if ($scope.attachmentsData && $scope.attachmentsData.filesSize > maxSize) {
					messageService.showToaster('w_0', 'attachments');
					return false;
				}

				$scope.contractEmailTemplate.text = $rootScope.addMaiStyling($scope.contractEmailTemplate.text);
				$scope.sendMessage.emailSubject = $scope.contractEmailTemplate.subject;

				var mailData = emailService.prepareEmails($scope.sendMessage);

				if (!emailService.validateMails(mailData)) {
					return;
				}

				$scope.emailDataToSave = Object.assign({}, $scope.sendMessage, mailData);
				delete $scope.emailDataToSave.emailCc;

				var obj2save = angular.copy($scope.emailDataToSave);
				var emailCC2save = $scope.showCcField ? obj2save.ccEmails : '';

				var forSend = {
					emailTo: $scope.emailDataToSave.emailTo,
					emailText: $scope.contractEmailTemplate.text,
					emailSubject: $scope.contractEmailTemplate.subject,
					contractText: $scope.contract.text,
					contractId: $routeParams.contractId,
					jobId: $scope.contract.jobId,
					templateId: $scope.contractEmailTemplate.id
				};

				if ($scope.emailDataToSave.secondaryToEmails) {
					forSend.secondaryToEmails = $scope.emailDataToSave.secondaryToEmails;
				}

				if (emailCC2save) {
					forSend.ccEmails = emailCC2save;
				}

				var formData = new FormData();
				angular.forEach(forSend, function (value, key) {
					console.debug('key: ' + key + '  | value: ' + value);
					formData.append(key, value);
				});
				if ($scope.attachmentsData.attachments !== undefined) {
					var storedFiles = $scope.attachmentsData.attachments.filter(function (file) {
						return file.id;
					});
					var uploadedFiles = $scope.attachmentsData.attachments.filter(function (file) {
						return !file.id;
					});

					angular.forEach(uploadedFiles, function (value, key) {
						formData.append('attachments[' + key + ']', value);
					});

					angular.forEach(storedFiles, function (value, key) {
						formData.append('storedAttachments[' + key + ']', value.id);
					});
				}

				$scope.disableBtnOnSend = true;
				$scope.isSendContractSpinnningWheelActive = true;

				var url = '/protected/rest/job/contract/send';
				contractsDataService.sendContractRequest(url, formData).finally(function () {
					$scope.disableBtnOnSend = false;
					$scope.isSendContractSpinnningWheelActive = false;
				}).subscribe(successSendContract, errorSendContract);
			}
		};

		function successSendContract(res) {
			if (res) {
				var errorMessage = res.errorMessage,
				    errorTitle = res.errorTitle;

				if (errorMessage) {
					messageService.showErrorFromBackend(errorTitle, errorMessage);
					$scope.disableBtnOnSend = false;
					$scope.isSendContractSpinnningWheelActive = false;
					return;
				}
			}

			$scope.disableBtnOnSend = false;
			$scope.showCcField = false;
			if ($scope.isLeadView && $rootScope.updateLeadView) {
				// changeTaskState($scope.sendMessage.task);
				$rootScope.updateLeadView();
			}

			if ($scope.isJobView && $rootScope.updateJobView) {
				// changeTaskState($scope.sendMessage.task);
				$rootScope.updateJobView();
			}
			isFirstShow = true;
			messageService.showToaster('s_4', 'jobView');

			$('#sendContractModal').modal('hide');

			$scope.$evalAsync();

			for (var prop in $scope.sendMessage) {
				$scope.sendMessage[prop] = '';
			}

			if ($scope.attachmentsData && $scope.attachmentsData.attachments) {
				if ($scope.attachmentsData.attachments.length) {
					$scope.attachmentsData.attachments.length = 0;
				}
			}
			$scope.isSendContractSpinnningWheelActive = false;
		}

		function errorSendContract(err) {
			var status = err.status,
			    data = err.data;

			isFirstShow = false;
			$scope.isSendContractSpinnningWheelActive = false;
			$scope.disableBtnOnSend = false;
			var path = $location.path();
			var errorMessage = data.errorMessage;

			if (status >= 400 && status < 500 && errorMessage) {
				if (status == 423) {
					var limit = $rootScope.isUserTrial ? 50 : 150;
					return messageService.showToaster('e_4', 'generalValidation', limit);
				} else if (errorMessage.includes('Email address inactive')) {
					messageService.showToaster('e_1', 'generalValidation', $scope.sendMessage.emailTo);
				} else if (errorMessage.includes('Email text should contain a contract link')) {
					messageService.showToaster('e_0', 'contract');
				} else if (errorMessage.includes('Lead is archived')) {
					messageService.showToaster('e_5', 'lead');
				} else if (path.includes('jobs')) {
					messageService.showToaster('e_0', 'contract');
				} else {
					messageService.showToaster('e_2', 'general', errorMessage);
				}
			} else {
				messageService.showToaster('e_0', 'general');
			}
		}

		function changeTaskState(task) {
			task.completed = true;
			newJobsDataService.changeTaskState($scope.sendMessage.jobId, task).finally(function () {
				$rootScope.dnd.canMove = true;
			}).subscribe(function (data) {
				toastr.clear();
				$scope.isSendContractSpinnningWheelActive = false;
				messageService.showToaster('i_0', 'jobView');
				task = Object.assign(task, data);
				handleTask(task, $scope.sendMessage.sortedTasksArr);
				isFirstShow = true;
				messageService.showToaster('s_4', 'clients');
				$('#sendContractModal').modal('hide');
			}, function (result) {
				toastr.clear();
				messageService.showDefaultErrorMessage(result);
			});
		}
		var handleTask = function handleTask(task, taskTypes) {
			if (task.dateItem) {
				task.dateItem = task.dateItem.toLowerCase();
			}

			if (task.due && !task.hasDue) {
				// for old workflows
				task.hasDue = true;
			}

			if (!task.action && task.taskEmail) {
				// for old workflows
				task.action = 'SEND_EMAIL';
			}

			if (task.calendarEventType === 'MAIN_SHOOT') {
				var _$scope$job = $scope.job,
				    startDate = _$scope$job.startDate,
				    finishDate = _$scope$job.finishDate,
				    startTime = _$scope$job.startTime,
				    finishTime = _$scope$job.finishTime,
				    location = _$scope$job.location;

				task.location = location;
				task.startDate = startDate;
				task.endDate = finishDate;
				task.startTime = startTime;
				task.endTime = finishTime;
			} else if (task.calendarEvent) {
				var _task$calendarEvent = task.calendarEvent,
				    _startDate = _task$calendarEvent.startDate,
				    endDate = _task$calendarEvent.endDate,
				    _startTime = _task$calendarEvent.startTime,
				    endTime = _task$calendarEvent.endTime,
				    _location = _task$calendarEvent.location,
				    clientId = _task$calendarEvent.clientId;

				task.location = _location;
				task.startDate = _startDate;
				task.endDate = endDate;
				task.startTime = _startTime;
				task.endTime = endTime;
				task.sendEmails = clientId ? task.calendarEvent.sendEmails : false;

				if (task.startDate && (task.startTime === null || task.finishTime === null)) {
					task.allday = true;
				}
			}

			task.overdueDays = workflowService.calcTaskOverdue(task.overdueDays);
			task.taskViewDue = workflowService.getTaskViewDue(task, taskTypes);
			task.taskDueDefault = task.defaultTask && task.dueDate ? task.dueDate : null;
			if ($scope.isLeadView) {
				$rootScope.updateLeadView();
			} else if ($scope.isJobView) {
				$rootScope.updateJobView();
			}
		};
		$scope.disableDragDrop = function () {
			return true;
		};

		$(document).on('show.bs.modal', '#sendContractModal', function () {
			$scope.$broadcast('addedFileEvent');
		});
	}
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js"), __webpack_require__("./node_modules/toastr/toastr.js")))

/***/ }),

/***/ "./web/js/controllers/job/jobController.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, Rx) {

(function () {
	angular.module('main').controller('JobsOverviewController', JobsOverviewController);

	JobsOverviewController.$inject = ['$window', '$scope', '$rootScope', '$location', '$routeParams', '$timeout', 'messageService', 'timeService', 'stringModifierService', 'newJobsDataService', 'clientService', 'jobTypesDataService', 'workflowDataService', 'accountService', 'settingsService'];

	function JobsOverviewController($window, $scope, $rootScope, $location, $routeParams, $timeout, messageService, timeService, stringModifierService, newJobsDataService, clientService, jobTypesDataService, workflowDataService, accountService, settingsService) {
		$scope.$on('$viewContentLoaded', function () {
			$('body').updatePolyfill();
			var searchFromUrl = void 0;
			try {
				searchFromUrl = decodeURIComponent($routeParams.search);
				searchFromUrl = searchFromUrl === 'undefined' ? '' : searchFromUrl;
			} catch (e) {
				searchFromUrl = '';
			}
			$scope.pageRequest = {
				page: +$routeParams.page || 1,
				perPage: $rootScope.paginationPerPage ? $rootScope.paginationPerPage : 25,

				pageOrder: {
					predicate: $rootScope.jobPageRequest && $rootScope.jobPageRequest.pageOrder.predicate || 'startDate',
					reverse: $rootScope.jobPageRequest && $rootScope.jobPageRequest.pageOrder.reverse || false
				},
				search: searchFromUrl || ''
			};
			$scope.items = [{
				email: ''
			}];
			$scope.selectActive = ['Active jobs', 'Active Jobs with Upcoming Shoots', 'Completed jobs'];

			$scope.searchText = searchFromUrl || '';
			$scope.pageRequest.search = searchFromUrl || '';
			$scope.pagindis = true;
			$scope.jobs = [];
			$scope.workflowNames = [];
			$scope.jobTypes = [];
			$scope.totalItems = 0;
			$scope.unsubscribe = new Rx.Subject();
			$scope.isCreateJobSpinnningWheelActive = false;
			$scope.changeUrl = false;
			$scope.toSearch = true;

			subscribeToCustomizeLabelsChange();
			getCompanyId();
		});

		$window.onpopstate = function () {
			$scope.changeUrl = false;
			var searchFromUrl = void 0;
			if ($routeParams.search) {
				try {
					searchFromUrl = decodeURIComponent($routeParams.search);
					searchFromUrl = searchFromUrl === 'undefined' ? '' : searchFromUrl;
				} catch (e) {
					searchFromUrl = '';
				}
				$scope.pageRequest.search = searchFromUrl || '';
				$scope.searchText = searchFromUrl || '';
			} else {
				$scope.pageRequest.search = '';
				$scope.searchText = '';
				$scope.toSearch = false;
			}
			getResultsPage(+$routeParams.page);
		};

		$scope.$on('$destroy', function () {
			$scope.unsubscribe.next();
			$scope.unsubscribe.complete();
		});

		$scope.$watch('selectActiveJobs', function (newValue, oldValue) {
			var initialPageNumber = 1;
			if (!oldValue || oldValue === newValue) {
				return false;
			} else if (newValue === 'Completed jobs') {
				setFilter('completed');
				$scope.pageRequest.pageOrder.reverse = true;
				$scope.pageRequest.pageOrder.predicate = 'startDate';
				$scope.pageRequest.filter = 'completed';
			} else if (newValue === 'Active jobs') {
				setFilter('active');
				$scope.pageRequest.pageOrder.reverse = false;
				$scope.pageRequest.pageOrder.predicate = 'startDate';
				$scope.pageRequest.filter = 'active';
			} else if (newValue === 'Active Jobs with Upcoming Shoots') {
				setFilter('activeWithShoots');
				$scope.pageRequest.pageOrder.reverse = false;
				$scope.pageRequest.pageOrder.predicate = 'startDate';
				$scope.pageRequest.filter = 'activeWithShoots';
			}
			getResultsPage(initialPageNumber, $scope.pageRequest.perPage, null, $scope.pageRequest.pageOrder.reverse);
		});

		var timerId = void 0;
		$scope.$watch('searchText', function (newValue, oldValue) {
			if (newValue == null) {
				return;
			}
			if (oldValue === newValue) {
				return;
			}
			if (!$scope.toSearch) {
				$scope.toSearch = true;
				return;
			}
			if (newValue.length > 0) {
				if (timerId != null) {
					clearTimeout(timerId);
				}
				timerId = setTimeout(searchRequest, 500);
			} else {
				clearTimeout(timerId);
				if (newValue.length === 0) {
					$scope.pageRequest.search = '';
					getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
				}
			}
		});

		function subscribeToCustomizeLabelsChange() {
			settingsService.customizeLabelsObservable.takeUntil($scope.unsubscribe).subscribe(function (customizeLabels) {
				$scope.mainShootLabelName = customizeLabels.mainShootLabel;
				$scope.extraShootLabelName = customizeLabels.extraShootLabel;
				$scope.businessNumberLabelName = customizeLabels.businessNumberLabel;
			});
		}

		function getSelectActiveJobs() {
			var activeFilter = getDefaultFilter();
			var selectActiveOption = void 0;
			switch (activeFilter) {
				case 'active':
					selectActiveOption = $scope.selectActive[0];
					break;
				case 'activeWithShoots':
					selectActiveOption = $scope.selectActive[1];
					break;
				case 'completed':
					selectActiveOption = $scope.selectActive[2];
					break;
				default:
					selectActiveOption = $scope.selectActive[0];
			}

			return selectActiveOption;
		}

		function getCompanyId() {
			accountService.companyIdObservable.takeUntil($scope.unsubscribe).subscribe(function (data) {
				$scope.companyId = data;
				$scope.selectActiveJobs = getSelectActiveJobs();
				$scope.pageRequest.filter = getDefaultFilter();
				getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
			});
		}

		function getDefaultFilter() {
			var filter = $window.localStorage.getItem('jobsOverviewFilter' + $scope.companyId);

			return filter || setFilter();
		}

		function setFilter() {
			var optionFilter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'active';

			$window.localStorage.setItem('jobsOverviewFilter' + $scope.companyId, optionFilter);

			return optionFilter;
		}

		function searchRequest() {
			$scope.pageRequest.search = $scope.searchText;
			getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
		}

		$scope.order = function (predicate) {
			$scope.pageRequest.pageOrder.reverse = $scope.pageRequest.pageOrder.predicate === predicate ? !$scope.pageRequest.pageOrder.reverse : false;
			getResultsPage(null, null, predicate, $scope.pageRequest.pageOrder.reverse);
		};

		$scope.getCurrentPage = function () {
			return $scope.pageRequest.page;
		};

		$scope.perPageChanged = function (newPerPage) {
			getResultsPage(null, newPerPage);
			$rootScope.paginationPerPage = newPerPage;
		};
		$scope.goToPage = function (newPage, disabled) {
			if (!disabled) {
				getResultsPage(newPage, null);
			}
		};
		$scope.jumpBack = function (disabled) {
			if (!disabled) {
				if ($scope.pageRequest.page > 1) {
					getResultsPage($scope.pageRequest.page - 1, null);
				}
			}
		};
		$scope.jumpAhead = function (disabled) {
			if (!disabled) {
				if ($scope.totalItems >= $scope.pageRequest.page * $scope.pageRequest.perPage + 1) {
					getResultsPage($scope.pageRequest.page + 1, null);
				}
			}
		};
		$scope.showJob = function (id) {
			$location.path('jobs/view/' + id);
		};
		$scope.showInvoice = function (id) {
			$location.path('invoices/invoice' + id);
		};

		function getCurrentFilter() {
			return $scope.selectActiveJobs === 'Leads only';
		}

		function getResultsPage() {
			var pageNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
			var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
			var predicate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
			var reverse = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

			var changed = false;

			if (predicate) {
				$scope.pageRequest.pageOrder.predicate = predicate;
				$scope.pageRequest.pageOrder.reverse = !!reverse;
				changed = true;
			}

			if (perPage) {
				$scope.pageRequest.perPage = perPage;
				changed = true;
			}
			if (pageNumber) {
				$scope.pageRequest.page = pageNumber;
				changed = true;
			}
			if ($scope.pageRequest && $scope.totalItems !== 0 && $scope.totalItems < ($scope.pageRequest.page - 1) * $scope.pageRequest.perPage + 1) {
				console.log('out of page');
				$scope.pageRequest.page = 1;
			}

			if (changed) {
				newJobsDataService.getJobsOnPage($scope.pageRequest, getCurrentFilter()).subscribe(function (data) {
					return successGetResultsPage(data);
				}, function (err) {
					return messageService.showDefaultErrorMessage(err);
				});
			}
		}
		function prepareJob(newJob) {
			$scope.clients = [];

			var _$scope$newJob = $scope.newJob,
			    workflow = _$scope$newJob.workflow,
			    startDate = _$scope$newJob.startDate,
			    finishDate = _$scope$newJob.finishDate,
			    primaryContact = _$scope$newJob.primaryContact,
			    secondaryContact = _$scope$newJob.secondaryContact;


			$scope.newJob.oldWorkflow = workflow;

			if (!$scope.newJob.startDate) {
				$scope.newJob.hasNoDate = true;
			} else {
				$scope.dateFilterJob = 'dd/MM/yyyy';
				$scope.newJob.hasNoDate = false;
				$scope.newJob.startDate = timeService.createDateAsUTC(startDate);
				$scope.newJob.finishDate = timeService.createDateAsUTC(finishDate);
			}

			if (primaryContact) {
				var primaryClientSearchText = clientService.fillClientSearchText(primaryContact);
				$scope.clients[0] = primaryClientSearchText;
				$scope.newJob.primaryContact = $scope.clients[0];
			}

			if (secondaryContact) {
				var secondaryClientSearchText = clientService.fillClientSearchText(secondaryContact);
				$scope.clients[1] = secondaryClientSearchText;
				$scope.newJob.secondaryContact = $scope.clients[1];
			}

			if ($scope.newJob.startDate && ($scope.newJob.startTime === null || $scope.newJob.finishTime === null)) {
				$scope.newJob.allday = true;
			}

			Rx.Observable.zip(getJobTypes(), getWorkflowAndLanguageNames()).takeUntil($scope.unsubscribe).finally(function () {
				$scope.button_disable = false;
				$scope.isCreateJobSpinnningWheelActive = false;
			}).subscribe(function () {
				$timeout(function () {
					// $scope.newJob.type = type;
					$('#newJob').modal('show');
					$scope.isCreateJobSpinnningWheelActive = false;
					$scope.$broadcast('showModalJob', $scope.newJob);
				}, 300);
			});
		}

		$scope.editJobModal = function (index) {
			$scope.button_disable = true;
			$scope.newJob = angular.copy($scope.jobs[index]);
			prepareJob($scope.newJob);
			$scope.$evalAsync();
		};

		function successGetResultsPage(data) {
			if (data && data.pageRequest) {
				$scope.pageRequest = data.pageRequest;
				$scope.pageRequest.search = $scope.searchText;
			}
			$scope.pageNumbers = [];
			$scope.totalItems = data ? data.total : 0;

			var pagesCount = void 0;
			pagesCount = $scope.totalItems / $scope.pageRequest.perPage;
			pagesCount = Math.ceil(pagesCount);

			for (var i = 1; i <= pagesCount; i++) {
				$scope.pageNumbers[i - 1] = i;
			}
			$scope.jobs = angular.copy(data.results);
			$rootScope.jobPageRequest = $scope.pageRequest;
			var newSearch = void 0;
			try {
				newSearch = encodeURIComponent($scope.pageRequest.search);
				newSearch = newSearch === 'undefined' ? null : newSearch;
			} catch (error) {
				newSearch = '';
			}
			if ($scope.changeUrl) {
				$location.search({
					page: $scope.pageRequest.page,
					search: newSearch || null
				});
			}
			$scope.changeUrl = true;
			$scope.$evalAsync();
		}
		$scope.showDeleteModal = function (jobId) {
			$scope.jobForDelete = jobId;
			$('#deleteModal').modal('show');
		};

		$scope.deleteJob = function () {
			$scope.deleteDisable = true;

			newJobsDataService.deleteJob($scope.jobForDelete).finally(function () {
				return $scope.deleteDisable = false;
			}).subscribe(function (data) {
				messageService.showToaster('s_0', 'jobView');
				$('#deleteModal').modal('hide');
				getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
			}, function (err) {
				return errorDeleteJob(err);
			});
		};

		function errorDeleteJob(error) {
			$('#deleteModal').modal('hide');
			messageService.handleError(error);
		}

		function getJobTypes() {
			return jobTypesDataService.getJobTypes().map(function (data) {
				return successGetJobTypes(data);
			});
		}

		function successGetJobTypes(data) {
			$scope.newJob.jobTypes = angular.copy(data);
		}

		function getWorkflowAndLanguageNames() {
			return workflowDataService.getWorkflowAndLanguageNames().map(function (data) {
				return successGetWorkflowAndLanguageNames(data);
			});
		}

		function successGetWorkflowAndLanguageNames(data) {
			if (!data) {
				return false;
			}
			$scope.newJob.workflowNames = angular.copy(data.workflows);
			$scope.newJob.languageNames = angular.copy(data.languages);
			if ($scope.newJob.id) {
				$scope.newJob.workflow.name = stringModifierService.addSelectedText($scope.newJob.workflow.name);
				var isWorkflowSaved = $scope.newJob.workflowNames.find(function (workflow) {
					return workflow.id === $scope.newJob.workflow.id;
				});
				if ($scope.newJob.workflowNames && !isWorkflowSaved) {
					$scope.newJob.workflowNames.push($scope.newJob.workflow);
				}
			}
		}

		function showNewJobModal() {
			$timeout(function () {
				$('#newJob').modal('show');
				$scope.isCreateJobSpinnningWheelActive = false;
				$scope.$broadcast('showModalJob', $scope.newJob);
			}, 300);
		}
		$scope.getElement = function (index) {
			var tableId = document.getElementById('tableIdJob').getBoundingClientRect();
			var dotsMenu = document.getElementById('dotsMenuJob-' + index).getBoundingClientRect();
			var add = document.getElementsByClassName('dropdown-job-' + index);
			add[0].style.transform = '';
			// 81-height of modal;
			var x = dotsMenu.top - tableId.top;
			var value = tableId.height - x;
			if (tableId.height > 81 && value < 81) {
				add[0].style.transform = 'translate(-15%, -' + value + 'px)';
			}
		};
		$scope.createJob = function () {
			delete $scope.newJob;
			$scope.isCreateJobSpinnningWheelActive = true;
			$scope.newJob = {};
			$scope.clients = [];

			Rx.Observable.zip(getJobTypes(), getWorkflowAndLanguageNames()).takeUntil($scope.unsubscribe).finally(function () {
				$scope.isCreateJobSpinnningWheelActive = false;
			}).subscribe(function () {
				angular.forEach($scope.jobTypes, function (value, key) {
					if (value.default === true) {
						$scope.newJob.type = $scope.jobTypes[key];
					}
				});
				showNewJobModal();
			});
		};
	}
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js"), __webpack_require__("./node_modules/rxjs/Rx.js")))

/***/ }),

/***/ "./web/js/controllers/job/jobQuestionnaireController.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, toastr) {

(function () {
	var JobQuestionnaireController = function JobQuestionnaireController($scope, $rootScope, $routeParams, $location, $http, $sce, $window, $filter, $q, messageService, fileUploadService, jobDataService, emailService, userService, newJobsDataService, leadDataService, workflowService, workflowDataService, settingsService, mailsDataService, questionnairesDataService) {
		$scope.isJobView = $location.path().includes('/jobs/');
		$scope.isLeadView = $location.path().includes('/leads/');

		$scope.emailDataToSave = {};
		// $scope.sendMessage = {};

		if ($scope.isLeadView) {
			$scope.isArchived = true;
		}
		var isFirstShow = true;
		$scope.$on('$viewContentLoaded', function () {
			$scope.isSentSpinnningWheelActive = false;
			$scope.isDeleteSpinnningWheelActive = false;
			$scope.questionnaireId = $routeParams.questionnaireId;
			$scope.jobId = $routeParams.jobId;
			$scope.leadId = $routeParams.leadId;

			if ($scope.isLeadView) {
				getLead($routeParams.leadId);
			} else if ($scope.isJobView) {
				getJobInfo($routeParams.jobId);
			}
			$scope.gdprEnabled = userService.userData.isGdprEnabled;
		});

		$(document).on('shown.bs.modal', '#sendQuestionnaireModal', function () {
			if (isFirstShow) {
				isFirstShow = false;
				if ($scope.task !== undefined && $scope.isDisable) {
					$scope.attachmentsData.attachments = JSON.parse(JSON.stringify($scope.task.taskEmail.storedAttachments));
				} else {
					$scope.attachmentsData = {
						attachments: [],
						filesSize: 0
					};
				}
			}
		});
		function getLead(id) {
			var showTaskId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

			leadDataService.getLeadInfo(id, showTaskId).subscribe(function (result) {
				$scope.jobId = result.job.id;
				$scope.isArchived = result.archived;
				if (result.job.primaryContact) {
					$scope.contactEmail = result.job.primaryContact.email;
				}
				if (result.job.secondaryContact) {
					$scope.secondaryContactEmail = result.job.secondaryContact.email;
				}
				if ($scope.jobId !== undefined) {
					getQuestionnairesInformation($scope.jobId);
				}
			}, function (error) {
				var _error$error = error.error,
				    errorCode = _error$error.errorCode,
				    data = _error$error.data;

				if (errorCode === 701) {
					redirectToJobLead(data);
				}
			});
		}

		function getJobInfo(id) {
			var showNewTaskId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

			newJobsDataService.getJobInfo(id, showNewTaskId).subscribe(function (result) {
				$scope.jobId = result.id;
				if (result.primaryContact) {
					$scope.contactEmail = result.primaryContact.email;
				}
				if (result.secondaryContact) {
					$scope.secondaryContactEmail = result.secondaryContact.email;
				}
				if ($scope.jobId !== undefined) {
					getQuestionnairesInformation($scope.jobId);
				}
			}, function (error) {
				var errorCode = error.errorCode,
				    data = error.data;

				if (errorCode === 702) {
					redirectToJobLead(data);
				}
			});
		}

		function redirectToJobLead(data) {
			$location.path('/' + data.redirectTo + 's/view/' + data.redirectId + '/questionnaires/' + $routeParams.questionnaireId);
		}

		clearAttachments();

		$scope.$parent.$watch('attachmentsDataQueston', function (newValue, oldValue) {
			if (newValue && newValue !== oldValue) {
				$scope.attachmentsData = newValue;
			}
		});

		$scope.toggleViewCc = function (state) {
			if ($scope.sendMessage && $scope.sendMessage.emailCc) {
				$scope.sendMessage.emailCc = [];
			}

			if (state === false) {
				clearAttachments();
			}

			$scope.showCcField = state !== undefined ? state : !$scope.showCcField;
		};

		$scope.setEmailData = function (newData, object, property) {
			$scope[object][property] = newData;
		};

		$scope.addSubjectVariable = function ($event, id, type) {
			var el = document.getElementById(id);
			$scope.questionnaireEmail.subject = emailService.addSubjectVariable(el, $event);
		};

		function getQuestionnairesInformation(id) {
			$http.get('/protected/rest/jobs/' + id + '/questionnaire/' + $routeParams.questionnaireId + '/get/').then(function (result) {
				if (result.data.errorCode === 102) {
					showError();
				} else {
					successGetQuestionnairesInformation(result.data);
				}
			}).catch(function (result) {
				return errorGetQuestionnairesInformation(result.data);
			});
		}

		function successGetQuestionnairesInformation(data) {
			$scope.$evalAsync();
			$scope.data = data;
			$scope.companyImageSrc = data.company.image;
			settingsService.timeFormatSettings.subscribe(function (res) {
				if (res.questionnaireTemplatesVersion === 'V2') {
					$scope.isNewQuestionnaireAvailable = true;
				} else {
					$scope.isNewQuestionnaireAvailable = false;
					if (data.questionnaires && data.questionnaires.length > 0) {
						$scope.questionnaire = data.questionnaires[0];
						$scope.questionnaire.questions = $filter('orderBy')($scope.questionnaire.questions, 'number', false);
						$scope.contactEmail = data.contactEmail;

						if (data.jobAttachments && data.jobAttachments.length) {
							fileUploadService.setAttachmentsFromServer(data.jobAttachments);
						}

						$scope.$evalAsync();
					}
				}
			});
		}

		function errorGetQuestionnairesInformation(data) {
			if (data.errorCode === 104) {
				showError();
			} else if (data.errorMessage) {
				toastr.error(data.errorMessage);
			} else {
				messageService.showToaster('e_0', 'general');
			}
		}

		function showError() {
			if ($scope.isLeadView) {
				$location.path('/leads/view/' + $routeParams.leadId);
			} else if ($scope.isJobView) {
				$location.path('/jobs/view/' + $routeParams.jobId);
			}
			messageService.showToaster('e_1', 'questions');
		}

		$scope.deleteModalQuestionnaries = function () {
			if ($scope.isArchived) {
				messageService.showToaster('e_6', 'lead');
			} else {
				$('#deleteModal').modal();
			}
		};

		$scope.deleteQuestionnaireV2 = function () {
			messageService.showToaster('s_1', 'questions');
			if ($scope.isJobView) {
				$location.path('/jobs/view/' + $routeParams.jobId);
			} else {
				$location.path('/leads/view/' + $scope.data.leadId);
			}
		};

		$scope.deleteQuestionnaire = function () {
			$scope.isDeleteSpinnningWheelActive = true;

			var jobId = $scope.jobId ? $scope.jobId : $routeParams.jobId;

			$http({
				method: 'POST',
				url: '/protected/rest/jobs/questionnaires/delete/' + jobId + '/' + $routeParams.questionnaireId + '/'
			}).then(function (result) {
				successDeleteCallback(result.data);
			}, function () {
				$scope.isDeleteSpinnningWheelActive = false;
			});
		};

		function successDeleteCallback(data) {
			var errorCode = data.errorCode,
			    errorMessage = data.errorMessage,
			    errorTitle = data.errorTitle;

			if (errorMessage) {
				if (errorMessage.includes('This questionnaire is linked to an active workflow task and cannot be deleted. Please delete the workflow task first.') && errorCode === 102) {
					$('#deleteModal').modal('hide');
					messageService.showToaster('e_0', 'questions');
				} else {
					messageService.showErrorFromBackend('Error', errorMessage);
				}
			} else {
				messageService.showToaster('s_0', 'questions');
				if ($scope.isJobView) {
					$location.path('/jobs/view/' + $routeParams.jobId);
				} else {
					$location.path('/leads/view/' + $scope.data.leadId);
				}
			}
			$scope.isDeleteSpinnningWheelActive = false;
		}

		$scope.initSendQuestionnaire = function () {
			var url = '/protected/rest/job/questionnaire/sources';

			$http({
				method: 'GET',
				url: url
			}).then(function (result) {
				$scope.$evalAsync();
				$scope.questionnaireSendSource = result.data;
				$scope.questionnaireEmailTemplates = result.data.emailTemplates;

				var template = $scope.questionnaireEmailTemplates.find(function (item) {
					return item.emailTemplateType === 'QUESTIONNAIRE_EMAIL_TEMPLATE';
				}) || {};
				$scope.choosenQuestionnaireEmail = template;
				$scope.setQuestionnaireEmailTemplate(template.id);

				$scope.$evalAsync();

				var rootEmail = $rootScope.primaryContact ? [$rootScope.primaryContact.email] || [] : [];
				$scope.sendMessage = {};
				$scope.sendMessage.emailCc = [];
				$scope.sendMessage.emailTo = $scope.contactEmail ? [$scope.contactEmail] : [] || rootEmail;
				if ($scope.secondaryContactEmail) {
					$scope.sendMessage.emailTo.push($scope.secondaryContactEmail);
				}

				$('#sendQuestionnaireModal').modal('show');
				$scope.$evalAsync();
			});
		};

		var questionnaireSetEmailCallback = function questionnaireSetEmailCallback(data) {
			$scope.questionnaireEmail = angular.copy(data);
			if (data.storedAttachments && data.storedAttachments.length) {
				$scope.attachmentsData = {
					attachments: fileUploadService.convertAttachmentsToShow(data.storedAttachments)
				};
			} else {
				clearAttachments();
			}
		};

		// Email methods
		$scope.retrySendMail = function () {
			if ($scope.jobId !== undefined) {
				getQuestionnairesInformation($scope.jobId);
			}
			emailService.callLastEmailFn();
		};

		function clearAttachments() {
			$scope.attachmentsData = {
				attachments: [],
				filesSize: 0
			};
		}

		$scope.setQuestionnaireEmailTemplate = function (id) {
			$scope.getEmailTemplates(id, questionnaireSetEmailCallback);
		};
		$scope.getEmailTemplates = function (id, callback) {
			if (id != null) {
				var emailTemplateUrl = '/protected/rest/settings/email_template/get/' + id + '?forSend=' + true;

				$http({
					method: 'GET',
					url: emailTemplateUrl
				}).then(function (result) {
					$scope.$evalAsync();
					callback(result.data);

					$scope.$evalAsync();
				});
			}
		};
		function saveChangeTask(task) {
			$scope.isSentSpinnningWheelActive = true;
			task.jobId = $scope.jobId;
			if ($scope.choosenQuestionnaireEmail !== undefined && $scope.choosenQuestionnaireEmail !== null) {
				task.taskEmail.emailTemplateId = $scope.choosenQuestionnaireEmail.id;
			}
			task.taskEmail.subject = $scope.questionnaireEmail.subject;
			task.taskEmail.text = $scope.questionnaireEmail.text;
			if (task.overdueDays !== null) {
				task.overdueDays = parseInt(task.overdueDays.match(/\d+/)[0], 10);
			}
			task.taskEmail.storedAttachments = null;
			task.taskEmail.base64Attachments = null;
			$scope.uploadedAttachments = null;
			if ($scope.attachmentsData.attachments && $scope.attachmentsData.attachments.length !== 0) {
				task.taskEmail.storedAttachments = $scope.attachmentsData.attachments.filter(function (attachment) {
					return attachment.id;
				});
				$scope.uploadedAttachments = $scope.attachmentsData.attachments.filter(function (attachment) {
					return !attachment.id;
				});
			}

			if ($scope.uploadedAttachments && $scope.uploadedAttachments.length) {
				fileUploadService.convertFileToSave($scope.uploadedAttachments).then(function (convertedFilesArr) {
					task.taskEmail.base64Attachments = convertedFilesArr;
					workflowDataService.saveTask(task).subscribe(function (data) {
						return changeTaskState(data.tasks[data.taskToAnimate]);
					}, function (error) {
						return errorSaveTask(error.data);
					});
				}).catch(function (error) {
					return console.log(error);
				});
			} else {
				workflowDataService.saveTask(task).subscribe(function (data) {
					return changeTaskState(data.tasks[data.taskToAnimate]);
				}, function (error) {
					return errorSaveTask(error.data);
				});
			}
		}
		function errorSaveTask(data) {
			$scope.isSentSpinnningWheelActive = false;
			workflowService.errorSaveTask(data);
		}
		var saveTaskWithAttachments = function saveTaskWithAttachments(task) {
			prepareEmailAttachments(task.taskEmail).then(function (result) {
				task.taskEmail = result;
				saveChangeTask(task);
			}, function (error) {
				scope.button_disabled = false;
			});
		};
		var prepareEmailAttachments = function prepareEmailAttachments(taskEmail) {
			var deferred = $q.defer();
			taskEmail.attachmentsData = $scope.attachmentsData;
			var isAttachments = taskEmail.attachmentsData && taskEmail.attachmentsData.attachments.length;

			if (!isAttachments) {
				deferred.resolve(taskEmail);
				return deferred.promise;
			}

			var _taskEmail$attachment = taskEmail.attachmentsData,
			    attachments = _taskEmail$attachment.attachments,
			    filesSize = _taskEmail$attachment.filesSize;

			var maxSize = 10; // 10Mb

			if (filesSize > maxSize) {
				messageService.showToaster('w_0', 'attachments');
				deferred.reject('Attachments size exceeds the limit');
				return deferred.promise;
			}

			var uploadedAttachments = void 0,
			    storedAttachments = void 0;

			if (attachments.length) {
				uploadedAttachments = attachments.filter(function (attachment) {
					return !attachment.id;
				});
				$scope.storedAttachmentsForMail = attachments.filter(function (attachment) {
					return attachment.id;
				});
			}

			taskEmail.storedAttachments = storedAttachments && storedAttachments.length ? storedAttachments : null;

			if (uploadedAttachments && uploadedAttachments.length) {
				fileUploadService.convertFileToSave(uploadedAttachments).then(function (convertedFilesArr) {
					$scope.base64AttachmentsForMail = convertedFilesArr;
					deferred.resolve(taskEmail);
				}).catch(function (error) {
					return console.log(error);
				});
			} else {
				deferred.resolve(taskEmail);
			}

			delete taskEmail.attachmentsData;
			return deferred.promise;
		};
		$scope.sendQuestionnaireEmail = function (task) {
			if (task !== undefined) {
				saveChangeTask(task);
			} else {
				var maxSize = 10; // 10Mb
				if ($scope.attachmentsData && $scope.attachmentsData.filesSize > maxSize) {
					messageService.showToaster('w_0', 'attachments');
					return false;
				}
				$scope.sendMessage.emailSubject = $scope.questionnaireEmail.subject;

				var mailData = emailService.prepareEmails($scope.sendMessage);

				if (!emailService.validateMails(mailData)) {
					return;
				}

				$scope.emailDataToSave = Object.assign({}, $scope.sendMessage, mailData);
				delete $scope.emailDataToSave.emailCc;

				var obj2save = angular.copy($scope.emailDataToSave);
				var emailCC2save = $scope.showCcField ? obj2save.ccEmails : '';

				$scope.questionnaireEmail.text = $rootScope.addMaiStyling($scope.questionnaireEmail.text);

				var questionnaireForSend = {
					emailTo: $scope.emailDataToSave.emailTo,
					emailText: $scope.questionnaireEmail.text,
					emailSubject: $scope.questionnaireEmail.subject,
					questionnaireTemplateId: $routeParams.questionnaireId,
					jobId: $scope.jobId,
					templateId: $scope.questionnaireEmail.id
				};

				if ($scope.emailDataToSave.secondaryToEmails) {
					questionnaireForSend.secondaryToEmails = $scope.emailDataToSave.secondaryToEmails;
				}

				if (emailCC2save) {
					questionnaireForSend.ccEmails = emailCC2save;
				}

				var formData = new FormData();
				angular.forEach(questionnaireForSend, function (value, key) {
					console.debug('key: ' + key + '  | value: ' + value);
					formData.append(key, value);
				});
				if ($scope.attachmentsData.attachments !== undefined) {
					var filesFromJob = $scope.attachmentsData.attachments.filter(function (file) {
						return file.id;
					});
					var filesFromComputer = $scope.attachmentsData.attachments.filter(function (file) {
						return !file.id;
					});
					angular.forEach(filesFromComputer, function (value, key) {
						formData.append('attachments[' + key + ']', value);
					});

					angular.forEach(filesFromJob, function (value, key) {
						formData.append('storedAttachments[' + key + ']', value.id);
					});
				}

				$scope.isSentSpinnningWheelActive = true;
				$scope.disableBtnOnSend = true;

				var url = '/protected/rest/job/questionnaire/send';
				questionnairesDataService.sendQuestionnaireRequest(url, formData).finally(function () {
					$scope.isSentSpinnningWheelActive = false;
					$scope.disableBtnOnSend = false;
				}).subscribe(successSendQuestionnaire, errorSendQuestionnaire);
			}
		};

		function successSendQuestionnaire(res) {
			if (res) {
				var errorMessage = res.errorMessage,
				    errorTitle = res.errorTitle;

				if (errorMessage) {
					messageService.showErrorFromBackend(errorTitle, errorMessage);
					$scope.disableBtnOnSend = false;
					$scope.isSentSpinnningWheelActive = false;
					return;
				}
			}

			mailsDataService.emitMailUpdateEvent(true);

			$scope.isSentSpinnningWheelActive = false;
			$scope.$evalAsync();
			isFirstShow = true;
			messageService.showToaster('s_9', 'jobView');

			$scope.disableBtnOnSend = false;
			$('#sendQuestionnaireModal').modal('hide');

			$scope.showCcField = false;
			$('#sendContractModal').modal('hide');

			$scope.$evalAsync();

			for (var prop in $scope.sendMessage) {
				$scope.sendMessage[prop] = '';
			}

			if ($scope.attachmentsData && $scope.attachmentsData.attachments) {
				if ($scope.attachmentsData.attachments.length) {
					$scope.attachmentsData.attachments.length = 0;
				}
			}

			if ($scope.isLeadView) {
				$rootScope.updateLeadView();
			}
			if ($scope.isJobView) {
				$rootScope.updateJobView();
			}
		}

		function errorSendQuestionnaire(_ref) {
			var status = _ref.status,
			    data = _ref.data;

			isFirstShow = false;
			$scope.isSentSpinnningWheelActive = false;
			$scope.disableBtnOnSend = false;
			var path = $location.path();
			var errorMessage = data.errorMessage;

			if (status >= 400 && status < 500 && errorMessage) {
				if (status == 423) {
					var limit = $rootScope.isUserTrial ? 50 : 150;
					messageService.showToaster('e_4', 'generalValidation', limit);
				} else if (errorMessage.includes('Email address inactive')) {
					messageService.showToaster('e_1', 'generalValidation', $scope.sendMessage.emailTo);
				} else if (errorMessage.includes('Email text should contain a questionnaire link')) {
					messageService.showToaster('e_0', 'questionnaires');
				} else if (errorMessage.includes('Lead is archived')) {
					messageService.showToaster('e_5', 'lead');
				} else if (path.includes('jobs')) {
					messageService.showToaster('e_0', 'questionnaires');
				} else {
					messageService.showToaster('e_2', 'general', errorMessage);
				}
			} else {
				messageService.showToaster('e_0', 'general');
			}
		}

		function changeTaskState(task) {
			task.completed = true;
			newJobsDataService.changeTaskState($scope.jobId, task).finally(function () {
				$rootScope.dnd.canMove = true;
			}).subscribe(function (data) {
				$scope.isSentSpinnningWheelActive = false;
				toastr.clear();
				messageService.showToaster('i_0', 'jobView');
				task = Object.assign(task, data);
				handleTask(task, $scope.sortedTasksArrQuestionnarie);
				isFirstShow = true;
				delete $scope.task;
				$('#sendQuestionnaireModal').modal('hide');
				messageService.showToaster('s_9', 'jobView');
				if ($scope.isLeadView) {
					$rootScope.updateLeadView();
				}
				if ($scope.isJobView) {
					$rootScope.updateJobView();
				}
			}, function (result) {
				toastr.clear();
				messageService.showDefaultErrorMessage(result);
			});
		}

		var handleTask = function handleTask(task, taskTypes) {
			if (task.dateItem) {
				task.dateItem = task.dateItem.toLowerCase();
			}

			if (task.due && !task.hasDue) {
				// for old workflows
				task.hasDue = true;
			}

			if (!task.action && task.taskEmail) {
				// for old workflows
				task.action = 'SEND_EMAIL';
			}

			if (task.calendarEventType === 'MAIN_SHOOT') {
				var _$scope$job = $scope.job,
				    startDate = _$scope$job.startDate,
				    finishDate = _$scope$job.finishDate,
				    startTime = _$scope$job.startTime,
				    finishTime = _$scope$job.finishTime,
				    location = _$scope$job.location;

				task.location = location;
				task.startDate = startDate;
				task.endDate = finishDate;
				task.startTime = startTime;
				task.endTime = finishTime;
			} else if (task.calendarEvent) {
				var _task$calendarEvent = task.calendarEvent,
				    _startDate = _task$calendarEvent.startDate,
				    endDate = _task$calendarEvent.endDate,
				    _startTime = _task$calendarEvent.startTime,
				    endTime = _task$calendarEvent.endTime,
				    _location = _task$calendarEvent.location,
				    clientId = _task$calendarEvent.clientId;

				task.location = _location;
				task.startDate = _startDate;
				task.endDate = endDate;
				task.startTime = _startTime;
				task.endTime = endTime;
				task.sendEmails = clientId ? task.calendarEvent.sendEmails : false;

				if (task.startDate && (task.startTime === null || task.finishTime === null)) {
					task.allday = true;
				}
			}

			task.overdueDays = workflowService.calcTaskOverdue(task.overdueDays);
			task.taskViewDue = workflowService.getTaskViewDue(task, taskTypes);
			task.taskDueDefault = task.defaultTask && task.dueDate ? task.dueDate : null;
		};
		$scope.modalClose = function () {
			$scope.showCcField = false;
			$scope.sendMessage.emailTo = [];
			isFirstShow = true;
		};
		$scope.disableDragDrop = function () {
			return true;
		};

		$(document).on('show.bs.modal', '#sendQuestionnaireModal', function () {
			$scope.$broadcast('addedFileEvent');
		});
	};

	angular.module('main').controller('JobQuestionnaireController', JobQuestionnaireController);
	JobQuestionnaireController.$inject = ['$scope', '$rootScope', '$routeParams', '$location', '$http', '$sce', '$window', '$filter', '$q', 'messageService', 'fileUploadService', 'jobDataService', 'emailService', 'userService', 'newJobsDataService', 'leadDataService', 'workflowService', 'workflowDataService', 'settingsService', 'mailsDataService', 'questionnairesDataService'];
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js"), __webpack_require__("./node_modules/toastr/toastr.js")))

/***/ }),

/***/ "./web/js/controllers/job/jobViewController.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Rx, $, toastr) {

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
	angular.module('main').controller('JobViewController', JobViewController);

	JobViewController.$inject = ['$scope', '$rootScope', '$routeParams', '$location', '$http', '$filter', '$timeout', 'timeService', 'messageService', 'templateRequestsService', 'validationService', 'workflowService', 'stringModifierService', 'fileUploadService', 'imageConverter', 'integrationsDataService', 'emailService', 'utilsService', 'userService', 'clientsDataService', 'clientService', 'jobTypesDataService', 'workflowDataService', 'newJobsDataService', 'fileDownloadDataService', 'settingsService', 'fileUploadDataService', 'mailsDataService', 'questionnairesDataService', 'contractsDataService', 'contractService'];

	function JobViewController($scope, $rootScope, $routeParams, $location, $http, $filter, $timeout, timeService, messageService, templateRequestsService, validationService, workflowService, stringModifierService, fileUploadService, imageConverter, integrationsDataService, emailService, utilsService, userService, clientsDataService, clientService, jobTypesDataService, workflowDataService, newJobsDataService, fileDownloadDataService, settingsService, fileUploadDataService, mailsDataService, questionnairesDataService, contractsDataService, contractService) {
		// Requests
		var jobViewRequests = {
			sendNewContractEmail: function sendNewContractEmail(data, successCallback, errorCallback) {
				if (id !== null) {
					var maxSize = 10; // 10Mb

					if ($scope.attachmentsDataContract && $scope.attachmentsDataContract.filesSize > maxSize) {
						messageService.showToaster('w_0', 'attachments');
						$scope.initSendContractSpinningWheel = false;
						return false;
					}

					var formData = new FormData();

					angular.forEach(data, function (value, key) {
						formData.append(key, value);
					});

					var filesFromJob = $scope.attachmentsDataContract.attachments.filter(function (file) {
						return file.id;
					});
					var filesFromComputer = $scope.attachmentsDataContract.attachments.filter(function (file) {
						return !file.id;
					});

					angular.forEach(filesFromComputer, function (value, key) {
						formData.append('attachments[' + key + ']', value);
					});

					angular.forEach(filesFromJob, function (value, key) {
						formData.append('storedAttachments[' + key + ']', value.id);
					});

					var url = '/protected/rest/job/contract/save/';
					contractsDataService.sendContractRequest(url, formData).subscribe(function (result) {
						successCallback(result);
						Intercom('trackEvent', 'sent contract');
					}, errorCallback);
				}
			},
			sendNewQuestionnaireEmail: function sendNewQuestionnaireEmail(data, successCallback, errorCallback) {
				if (id != null) {
					var maxSize = 10; // 10Mb

					if ($scope.attachmentsDataQueston && $scope.attachmentsDataQueston.filesSize > maxSize) {
						messageService.showToaster('w_0', 'attachments');
						return false;
					}

					var formData = new FormData();

					angular.forEach(data, function (value, key) {
						formData.append(key, value);
					});

					var filesFromJob = $scope.attachmentsDataQueston.attachments.filter(function (file) {
						return file.id;
					});
					var filesFromComputer = $scope.attachmentsDataQueston.attachments.filter(function (file) {
						return !file.id;
					});

					angular.forEach(filesFromComputer, function (value, key) {
						formData.append('attachments[' + key + ']', value);
					});

					angular.forEach(filesFromJob, function (value, key) {
						formData.append('storedAttachments[' + key + ']', value.id);
					});

					var url = '/protected/rest/job/questionnaire/save';
					questionnairesDataService.sendQuestionnaireRequest(url, formData).subscribe(function (result) {
						successCallback(result);
						Intercom('trackEvent', 'sent questionnaire');
					}, errorCallback);
				}
			},
			getJob: function getJob() {
				var newTaskId = $routeParams.task;
				return newJobsDataService.getJobInfo(id, newTaskId).map(function (data) {
					return removeJobMails(data);
				}).subscribe(function (data) {
					return successGetJobInfo(data);
				}, function (error) {
					return errorGetJobInfo(error);
				});
			}
		};

		function removeParameters() {
			var _$location$search = $location.search(),
			    calendarView = _$location$search.calendarView,
			    calendarDate = _$location$search.calendarDate,
			    page = _$location$search.page,
			    search = _$location$search.search;

			if (calendarView || calendarDate || page || search) {
				$location.search({}).replace();
			}
		}

		$scope.$on('$viewContentLoaded', function () {
			removeParameters();

			$rootScope.jobViewLoaded = true;
			$scope.isSaveNotesSpinnningWheelActive = false;
			$scope.files = [];
			$scope.newTaskCreate = [];
			$scope.showAddNewTaskModalSpinnigWheel = false;
			$scope.createNewInvoiceSpinningWheel = false;
			$scope.createNewQuoteSpinningWheel = false;
			$scope.initSendContractSpinningWheel = false;
			$scope.initSendQuestionnaireSpinningWheel = false;
			$scope.showSendEmailModalSpinningWheel = false;

			$scope.isCreateClientModalSpinnningWheelActive = false;
			$scope.isEditContractModalSpinnningWheelActive = false;

			$scope.loadFileSpinningWheelActive = false;

			$scope.leadSourcesAvailable = true;

			$scope.userCurrencySymbol = userService.userCurrencySymbol;

			$rootScope.dnd = {
				canMove: true
			};
			var attachmentsObj = {
				attachments: [],
				filesSize: 0
			};
			$scope.attachmentsDataContract = angular.copy(attachmentsObj);
			$scope.tokenAttachmentsData = angular.copy(attachmentsObj);
			window.scrollTo(0, 0);
			$scope.now = new Date();
			$scope.now.setHours(12, 0, 0, 0);
			$scope.workflowNames = [];
			$scope.button_disable = true;
			$scope.primaryContact = null;
			$scope.secondaryContact = null;
			$scope.tickTask = false;
			$scope.tickTaskType = '';

			jobViewRequests.getJob();

			$scope.templates = {};
			$scope.unsubscribe = new Rx.Subject();
			$scope.fundyIntegration = false;
			$scope.integrationInvoiceLoadXml = false;
			$scope.fundyAvailable = false;

			// ProSelect
			$scope.proSelectIntegration = false;
			$scope.proSelectAvailable = false;

			$scope.emailDataToSaveQuestion = {};
			$scope.emailDataToSaveContract = {};

			subscribeToCustomizeLabelsChange();

			settingsService.timeFormatSettings.subscribe(function (data) {
				if (data.fundyAvailable) {
					$scope.fundyAvailable = true;
					if (data.fundyIntegration === 'ENABLED') {
						$scope.fundyIntegration = true;
					}
				}

				if (data.proSelectAvailable) {
					$scope.proSelectAvailable = true;
					if (data.proSelectIntegration === 'ENABLED') {
						$scope.proSelectIntegration = true;
					}
				}

				$scope.leadSourcesAvailable = data.leadSourcesAvailable;
			});

			Rx.Observable.zip(templateRequestsService.getTemplates('contract_preview'), templateRequestsService.getTemplates('questionnaire_preview'), templateRequestsService.getTemplates('general_preview')).takeUntil($scope.unsubscribe).subscribe(function (_ref) {
				var _ref2 = _slicedToArray(_ref, 3),
				    contracts = _ref2[0],
				    questionnaires = _ref2[1],
				    general = _ref2[2];

				setContractsPreview(contracts);
				setQuestionnairesPreview(questionnaires);
				setGeneralEmailsPreview(general);
			}, function (error) {
				return showGeneralErrorMessage(error);
			});
		});

		$scope.$on('$destroy', function () {
			$scope.unsubscribe.next();
			$scope.unsubscribe.complete();
		});

		function subscribeToCustomizeLabelsChange() {
			settingsService.customizeLabelsObservable.takeUntil($scope.unsubscribe).subscribe(function (customizeLabels) {
				$scope.mainShootLabelName = customizeLabels.mainShootLabel;
				$scope.extraShootLabelName = customizeLabels.extraShootLabel;
				$scope.businessNumberLabelName = customizeLabels.businessNumberLabel;
				$scope.businessNumberLabelName = customizeLabels.businessNumberLabel;
			});
		}

		$scope.redirectToNewInvoice = function (jobId) {
			goToNewPayment('/jobs/' + jobId + '/invoice/new');
			$scope.integrationInvoiceLoadXml = true;
		};

		$scope.openFundyFileUploadModal = function (event) {
			event.preventDefault();
			document.getElementById('fundyUpload').click();
		};

		$scope.openProSelectFileUploadModal = function (event) {
			event.preventDefault();
			document.getElementById('proSelectUpload').click();
		};

		$scope.addNewInvoiceFromModal = function (jobId) {
			if ($scope.fundyIntegration || $scope.proSelectIntegration) {
				$scope.createNewInvoiceSpinningWheel = true;
				var selectModal = '#addNewModal';
				var nextModal = '#jobsNewInvoiceModal';
				utilsService.showNextModal(selectModal, nextModal);
				$timeout(function () {
					$scope.createNewInvoiceSpinningWheel = false;
				}, 1000);
			} else {
				goToNewPayment('/jobs/' + jobId + '/invoice/new');
			}
		};

		$scope.importInvoiceFromFundy = function (item) {
			var jobId = $scope.job.id;
			$scope.integrationInvoiceLoadXml = true;

			fileUploadDataService.sendFundyXmlFile(item, jobId).finally(function () {
				$scope.integrationInvoiceLoadXml = false;
			}).subscribe(function (result) {
				$scope.integrationInvoiceLoadXml = false;
				var invoiceId = result.invoiceId;
				messageService.showToaster('s_2', 'fundy');
				$('#jobsNewInvoiceModal').modal('hide');
				goToLocation('/invoices/' + invoiceId);
			});
		};

		$scope.importInvoiceFromProSelect = function (item) {
			var jobId = $scope.job.id;
			$scope.integrationInvoiceLoadXml = true;

			fileUploadDataService.sendProSelectXmlFile(item, jobId).finally(function () {
				$scope.integrationInvoiceLoadXml = false;
			}).subscribe(function (result) {
				$scope.integrationInvoiceLoadXml = false;
				var invoiceId = result.invoiceId;
				messageService.showToaster('s_2', 'proSelect');
				$('#jobsNewInvoiceModal').modal('hide');
				goToLocation('/invoices/' + invoiceId);
			});
		};

		$scope.createNewInvoice = function (jobId) {
			$scope.createNewInvoiceSpinningWheel = true;
			if ($scope.fundyIntegration || $scope.proSelectIntegration) {
				$('#jobsNewInvoiceModal').modal('show').on('shown.bs.modal', function () {
					$scope.createNewInvoiceSpinningWheel = false;
				});
			} else {
				goToNewPayment('/jobs/' + jobId + '/invoice/new');
			}
		};

		var id = $routeParams.jobId;
		$scope.saveFilesOnService = function (item, jobId) {
			$scope.loadFileSpinningWheelActive = true;

			if ($scope.loadFileSpinningWheelActive === true) {
				$('.btn-add-round').css('pointer-events', 'none');
			}

			var maxMb = 20; // 20 Mb
			var maxSize = maxMb * 1000 * 1024;

			var totalFilesSize = getTotalSize($scope.files);

			if (totalFilesSize + item.size > maxSize) {
				messageService.showToaster('w_1', 'attachments');
				$scope.loadFileSpinningWheelActive = false;
				return;
			}

			fileUploadService.saveFileOnServer(item, jobId, function (response) {
				response.convertedType = imageConverter.getFileClass(response.name);
				$scope.files.push(response);
				fileUploadService.setFiles(response);
				$scope.$broadcast('addedFileEvent');
				enableFileAddButton();
			}, function (response) {
				var errorMessage = response.errorMessage,
				    errorTitle = response.errorTitle;

				messageService.showErrorFromBackend(errorTitle, errorMessage);
				enableFileAddButton();
			});
		};

		function enableFileAddButton() {
			$scope.loadFileSpinningWheelActive = false;
			if ($scope.loadFileSpinningWheelActive === false) {
				$('.btn-add-round').css('pointer-events', 'auto');
			}
		}

		// $scope.saveAttachment = function(fileId, jobId) {
		// 	fileDownloadDataService.saveFile(fileId, jobId);
		// };

		function getTotalSize(files) {
			return files.reduce(function (prev, next) {
				return prev + next.bytesSize;
			}, 0);
		}

		$scope.deleteFile = function (file) {
			$scope.file = file;
			$('#deleteAttachmentModal').modal('show');
		};

		$scope.$on('removedFileEvent', function (event) {
			$scope.$broadcast('removedData');
		});

		$scope.disableDragDrop = function () {
			return true;
		};

		// initial setup
		$scope.dateFilterJobMail = "dd MMMM yyyy 'at' HH:mm";

		$scope.mailData2Save = {};
		$scope.contractData2Send = {};
		$scope.job2Edit = {};
		$scope.clientEmails = [];

		var clientsEmailTimer = void 0;

		// attachments
		clearQuestAttachments();
		clearContractAttachments();

		// templates for workflow tasks
		function setContractsPreview(data) {
			$scope.templates.contractEmailTemplates = angular.copy(data.emailTemplates);
			$scope.templates.contracts = angular.copy(data.contractTemplates);
		}

		function setQuestionnairesPreview(data) {
			$scope.templates.questionnaireEmailTemplates = angular.copy(data.emailTemplates);
			$scope.templates.questionnaires = angular.copy(data.questionnaireTemplates);
		}

		function setGeneralEmailsPreview(data) {
			$scope.templates.generalEmailTemplates = angular.copy(data);
		}

		$scope.$watch('primaryContact', function (newValue) {
			if (newValue) {
				$rootScope.primaryContact = $scope.primaryContact;
			}
		});

		// Contract methods
		$scope.initSendContract = function () {
			var addNewModal = $('#addNewModal');
			var DELAY = 500;

			if (addNewModal.hasClass('in')) {
				addNewModal.modal('hide');
			} else {
				DELAY = 0;
			}

			templateRequestsService.getTemplates('contract_preview').subscribe(function (data) {
				successInitSendContract(data);
				$timeout(function () {
					$('#sendNewContractModal').modal('show').on('shown.bs.modal', function () {
						var input = $('#sendNewContractModal').find('input');

						validationService.isModalClosePrevented(input);
					});
				}, DELAY);
			}, function (error) {
				return messageService.showDefaultErrorMessage(error);
			});
		};

		function successGetJobInfo(data) {
			if (data.data === null) {
				$location.path('/jobs');
				messageService.showToaster('e_6', 'job');
			} else {
				$scope.job = JSON.parse(JSON.stringify(data));
				$rootScope.jobId = $scope.job.id;
				prepareJob(data);
				prepareTasks();
				setContacts();
				calculateInvoices();
				setAttachments(data.attachments);
				$scope.getMails(false);
			}
		}

		function errorGetJobInfo(error) {
			var _error$error = error.error,
			    errorCode = _error$error.errorCode,
			    data = _error$error.data;

			if (errorCode === 104) {
				$location.path('/jobs');
				messageService.showToaster('e_6', 'job');
			}

			if (errorCode === 702) {
				$location.path('/' + data.redirectTo + 's/view/' + data.redirectId);
			}
		}

		function successInitSendContract(data) {
			$scope.initSendContractSpinningWheel = true;
			$scope.contractSendSource = data;
			$scope.contracts = $scope.contractSendSource.contractTemplates;
			$scope.contractEmailTemplates = $scope.contractSendSource.emailTemplates;
			if ($scope.contractEmailTemplates) {
				var template = $scope.contractEmailTemplates.find(function (item) {
					return item.emailTemplateType === 'CONTRACT_EMAIL_TEMPLATE';
				}) || {};

				$scope.chosenContractEmail = template;
				$scope.setContractEmailTemplate(template.id);
			}

			delete $scope.sendMessageContract;
			$scope.sendMessageContract = {};
			$scope.sendMessageContract.emailTo = $rootScope.primaryContact.email ? [$rootScope.primaryContact.email] : [];
			if ($scope.secondaryContact) {
				$scope.sendMessageContract.emailTo.push($scope.secondaryContact.email);
			}
			$scope.sendMessageContract.emailCc = [];
			$scope.initSendContractSpinningWheel = false;
		}

		$scope.showSendContract = function (jobId, jobContractId, task) {
			$routeParams.contractId = jobContractId;
			$routeParams.jobId = jobId;

			delete $scope.sendMessage;
			$scope.sendMessage = {};
			$scope.sendMessage.emailTo = $rootScope.primaryContact.email ? [$rootScope.primaryContact.email] : [];
			if ($scope.secondaryContact) {
				$scope.sendMessage.emailTo.push($scope.secondaryContact.email);
			}
			$scope.sendMessage.emailCc = [];
			if (task !== undefined) {
				$scope.sendMessage.task = JSON.parse(JSON.stringify(task));
				$scope.sendMessage.jobId = jobId;
				$scope.sendMessage.sortedTasksArr = $scope.sortedTasksArr;
				$scope.sendMessage.isDisable = true;
			}
			templateRequestsService.getTemplates('contract_preview').subscribe(function (data) {
				return successShowSendContract(data);
			});

			$http({
				method: 'GET',
				url: '/protected/rest/contracts/get/view/' + jobId + '/' + jobContractId
			}).then(function (result) {
				$scope.contract = result.data.contract;
				$scope.$evalAsync();
			}).catch(messageService.showDefaultErrorMessage);
		};

		function successShowSendContract(data) {
			$scope.contractSendSource = data;
			$scope.contractEmailTemplates = $scope.contractSendSource.emailTemplates;
			if ($scope.contractEmailTemplates && $scope.contractEmailTemplates.length > 0) {
				var template = $scope.contractEmailTemplates.find(function (item) {
					return item.emailTemplateType === 'CONTRACT_EMAIL_TEMPLATE';
				}) || {};
				$scope.chosenContractEmail = template;
				$scope.setContractEmailTemplate(template.id);
			}
			$('#sendContractModal').modal('show').on('shown.bs.modal', function () {
				var input = $('#sendContractModal').find('input');

				validationService.isModalClosePrevented(input);
			});
		}

		$scope.getMails = function (syncReply) {
			if (syncReply) {
				$rootScope.isMailResyncInProcess = true;
			}
			var subscription = mailsDataService.getJobMails($scope.jobId, syncReply).subscribe(function (data) {
				return successGetMails(data.data, syncReply, subscription);
			}, function (error) {
				return errorGetMails(error, syncReply, subscription);
			});
		};

		function successGetMails(data, syncReply, subscription) {
			var lastSyncResult = data.lastSyncResult,
			    mails = data.mails;

			$scope.job.mails = mails;

			// check if google gmail service synchronized
			if (lastSyncResult && lastSyncResult != null) {
				// Show time for synchronized block
				$scope.isGoogleMailSynchronized = true;
				$scope.googleMailLastSyncDate = lastSyncResult.replySynchronizedAt;

				if (syncReply) {
					showCorrectMessage(lastSyncResult);
				}
			}
			if (syncReply) {
				$rootScope.isMailResyncInProcess = false;
			}
			subscription.unsubscribe();
		}

		function showCorrectMessage(lastSyncResult) {
			var status = lastSyncResult.status.toLowerCase();
			var messageType = messageService.getCorrectMessageType(status);

			if (status === 'ok') {
				messageService.showToaster('s_0', 'email');
			} else {
				messageService.showMessageFromBackend(messageType, lastSyncResult.messageDetails.title, lastSyncResult.messageDetails.message);
			}
		}

		function errorGetMails(error, syncReply, subscription) {
			if (syncReply) {
				$rootScope.isMailResyncInProcess = false;
			}
			messageService.showDefaultErrorMessage(error);
			subscription.unsubscribe();
		}

		// ATTENTION: Temporary hotfix, to resolve SN-2444.
		function removeJobMails(data) {
			data.mails = [];
			return data;
		}

		$scope.showSendContractModal = function (e) {
			$scope.contractData2Send = undefined;

			var addNewModal = $('#addNewModal');
			var DELAY = 500;

			if (addNewModal.hasClass('in')) {
				$('#addNewModal').modal('hide');
			} else {
				DELAY = 0;
			}

			var url = '/protected/rest/job/contract/sources';

			$http({
				method: 'GET',
				url: url
			}).then(function (result) {
				$scope.contractData2Send = angular.copy(result.data);
				$scope.contractData2Send.contracts = result.data.contractTemplates;
				$scope.contractData2Send.contractEmailTemplates = result.data.emailTemplates;
				$scope.contractData2Send.mailSignature = result.data.signature || '';
				$scope.contractData2Send.emailTo = $rootScope.primaryContact.email;
				$scope.contractData2Send.jobId = $scope.job.id;

				if (!$scope.$$phase) {
					$scope.$apply();
				}

				$timeout(function () {
					$('#sendFirstContractModal').modal('show');
				}, DELAY);
			}).catch(messageService.showDefaultErrorMessage);
		};

		$scope.editContract = function (id, e) {
			if (id && !$scope.updatedContract) {
				var editContractTemplateCallback = function editContractTemplateCallback(data) {
					$scope.editableContract = angular.copy(data);
				};

				templateRequestsService.getTemplates('contract_full', id).subscribe(function (data) {
					return editContractTemplateCallback(data);
				}, function (error) {
					return showGeneralErrorMessage(error);
				});
			} else if ($scope.updatedContract) {
				$scope.editableContract = angular.copy($scope.updatedContract);
			} else if (!$scope.editableContract) {
				$scope.editableContract = {
					text: ''
				};
			}
			utilsService.showNextModal('#sendNewContractModal', '#editContractModal', e);
		};

		$scope.closeEditContract = function () {
			$('#editContractModal').modal('hide').on('hidden.bs.modal', function () {
				$('#sendNewContractModal').modal('show');
				$scope.editableContract = null;
				$(this).off('hidden.bs.modal');
			});
		};

		$scope.saveEditedContract = function () {
			if (!contractService.contractTextValid($scope.editableContract.text)) {
				return;
			}

			$scope.isEditContractModalSpinnningWheelActive = true;
			var contractName = stringModifierService.cutSelectedText($scope.editableContract.name);
			messageService.showToaster('s_2', 'contractTemplates', contractName);
			$('#editContractModal').modal('hide').on('hidden.bs.modal', function () {
				$scope.updatedContract = $scope.editableContract;
				$('#sendNewContractModal').modal('show');
				$(this).off('hidden.bs.modal');
				$scope.isEditContractModalSpinnningWheelActive = false;
			});
		};

		$scope.setContractEmailTemplate = function (id) {
			var contractSetEmailCallback = function contractSetEmailCallback(data) {
				$scope.contractEmailTemplate = angular.copy(data);
				if (data.storedAttachments && data.storedAttachments.length) {
					$scope.attachmentsDataContract = {
						attachments: fileUploadService.convertAttachmentsToShow(data.storedAttachments)
					};
				} else {
					clearContractAttachments();
				}
			};
			templateRequestsService.getTemplates('full_template', id).subscribe(function (data) {
				return contractSetEmailCallback(data);
			}, function (error) {
				return showGeneralErrorMessage(error);
			});
		};

		$scope.sendNewContractEmail = function (chosenContract, updatedContract, contractEmailTemplate) {
			var maxSize = 10; // 10Mb

			if ($scope.attachmentsDataContract && $scope.attachmentsDataContract.filesSize > maxSize) {
				messageService.showToaster('w_0', 'attachments');
				$scope.initSendContractSpinningWheel = false;
				return false;
			}

			var _emailText = '';

			if (validationService.isStringEmpty(contractEmailTemplate.subject)) {
				messageService.showToaster('e_10', 'emailTemplate');
				return;
			}

			if ($scope.sendMessage && $scope.sendMessage.emailText) {
				_emailText = $scope.sendMessage.emailText;
			} else {
				_emailText = $('.in .textarea-quad textarea').val();
			}

			if (!$scope.sendMessage) {
				$scope.sendMessage = {};
			}

			$scope.sendMessage.emailText = $rootScope.addMaiStyling(_emailText);

			if (validateNewContractEmail(contractEmailTemplate, updatedContract, chosenContract)) {
				$scope.sendMessageContract.emailSubject = contractEmailTemplate.subject;

				var mailData = emailService.prepareEmails($scope.sendMessageContract);

				if (!emailService.validateMails(mailData)) {
					return;
				}

				$scope.emailDataToSaveContract = Object.assign({}, $scope.sendMessageContract, mailData);
				delete $scope.emailDataToSaveContract.emailCc;

				var obj2save = angular.copy($scope.emailDataToSaveContract);
				var emailCC2save = $scope.showCcField ? obj2save.ccEmails : '';
				var contract2Save = updatedContract ? updatedContract.text : chosenContract.text;

				var data = {
					emailTo: $scope.emailDataToSaveContract.emailTo,
					emailText: contractEmailTemplate.text,
					emailSubject: contractEmailTemplate.subject,
					contractId: chosenContract ? chosenContract.templateId : null,
					jobId: $scope.job.id,
					templateId: contractEmailTemplate.id
				};

				if ($scope.emailDataToSaveContract.secondaryToEmails) {
					data.secondaryToEmails = $scope.emailDataToSaveContract.secondaryToEmails;
				}

				if (emailCC2save) {
					data.ccEmails = emailCC2save;
				}

				if (contract2Save) {
					data.contractText = contract2Save;
				}

				$scope.button_disable = true;
				jobViewRequests.sendNewContractEmail(data, function (data) {
					if (data) {
						var errorMessage = data.errorMessage,
						    errorTitle = data.errorTitle;

						if (errorMessage) {
							messageService.showErrorFromBackend(errorTitle, errorMessage);
							$scope.button_disable = false;
							return;
						}
					}

					jobViewRequests.getJob();
					$scope.button_disable = false;
					$('#sendNewContractModal').modal('hide');

					$scope.showCcField = false;
					$scope.$evalAsync();
					$('#sendNewQuestionnaireModal').modal('hide');

					for (var prop in $scope.sendMessage) {
						$scope.sendMessage[prop] = '';
					}
					for (var _prop in $scope.sendMessageContract) {
						$scope.sendMessageContract[_prop] = '';
					}

					if ($scope.attachmentsDataContract && $scope.attachmentsDataContract.attachments) {
						if ($scope.attachmentsDataContract.attachments.length) {
							$scope.attachmentsDataContract.attachments.length = 0;
						}
					}

					// toastr.success("Contract successfully sent!")
					messageService.showToaster('s_4', 'jobView');
				}, function (_ref3) {
					var status = _ref3.status,
					    data = _ref3.data;

					$scope.button_disable = false;
					var path = $location.path();
					var errorMessage = data.errorMessage;

					if (status >= 400 && status < 500 && errorMessage) {
						if (status == 423) {
							var limit = $rootScope.isUserTrial ? 50 : 150;
							return messageService.showToaster('e_4', 'generalValidation', limit);
						} else if (errorMessage.includes('Email address inactive')) {
							messageService.showToaster('e_1', 'generalValidation', $scope.sendMessageContract.emailTo);
						} else if (path.includes('jobs')) {
							messageService.showToaster('e_0', 'contract');
						} else {
							messageService.showToaster('e_2', 'general', errorMessage);
						}
					} else {
						messageService.showToaster('e_0', 'general');
					}
				});
			}
		};

		function validateNewContractEmail(emailTemplate, updatedContract, chosenContract) {
			if (!updatedContract && !chosenContract) {
				messageService.showToaster('w_0', 'jobView');
				return false;
			}

			if (!emailTemplate) {
				messageService.showToaster('e_0', 'general');
				return false;
			}

			if (!emailTemplate.subject) {
				messageService.showToaster('e_5', 'workflow');
				return false;
			}

			if (!emailTemplate.text || !emailTemplate.text.includes('%contract_link%')) {
				console.log('fire');
				messageService.showToaster('e_2', 'emailTemplate');
				return false;
			}

			return true;
		}

		// Invoice methods
		$scope.showSendInvoice = function (invoiceId) {
			$routeParams.id = invoiceId;

			delete $scope.sendMessage;
			$scope.sendMessage = {};
			$scope.sendMessage.addInvoiceAttachment = true;

			$http({
				method: 'GET',
				url: '/protected/rest/email_templates/get'
			}).then(function (result) {
				if (result.data) {
					$scope.emails = result.data;
					if ($scope.emails && $scope.emails.length > 1) {
						$scope.choosenEmail = $scope.emails.find(function (item) {
							return item.emailTemplateType === 'INVOICE_EMAIL_TEMPLATE';
						}) || {};
					}

					$scope.sendMessage.emailTo = $rootScope.primaryContact.email;
					$scope.sendMessage.emailCc = '';
					$('#sendInvoiceModal').modal('show', {
						primaryContact: $scope.primaryContact,
						secondaryContact: $scope.secondaryContact
					}).on('shown.bs.modal', function () {
						var input = $(this).find('input');
						var select = $(this).find('select');

						validationService.isModalClosePrevented(input);
						validationService.isModalClosePrevented(select);
					});
				}
			}).catch(messageService.showDefaultErrorMessage);
		};

		function calculateInvoices() {
			$scope.paymentsTotal = 0;
			$scope.paymentsBalanceDue = 0;
			$scope.recentInvoice = null;
			$scope.nextInvoice = null;
			$scope.job.payments = $filter('orderBy')($scope.job.invoices, 'invoiceDue', false);

			if ($scope.job && $scope.job.payments) {
				angular.forEach($scope.job.payments, function (value, key) {
					$scope.paymentsTotal += value.amount;
					if (value.editable) {
						if ($scope.nextInvoice == null) {
							$scope.nextInvoice = value;
						}
						$scope.paymentsBalanceDue += value.amount;
					} else if ($scope.recentInvoice == null) {
						$scope.recentInvoice = value;
					}
				});
				if ($scope.recentInvoice == null) {
					$scope.recentInvoice = $scope.nextInvoice;
				}
			}
		}

		// Quotes methods
		$scope.showNewQuote = function () {
			var selectModal = '#addNewModal';
			var nextModal = '#addNewQuoteTypeModal';
			utilsService.showNextModal(selectModal, nextModal);
		};

		$scope.createNewQuote = function (job, quoteType) {
			var id = job.id;

			goToNewPayment('/jobs/' + id + '/quote/' + quoteType + '/new');
		};

		$scope.showAddNewQuoteModal = function () {
			$('#addNewQuoteTypeModal').modal('show');
		};

		// Questionnaire methods
		$scope.initSendQuestionnaire = function () {
			$('#sendFirstQuestionnaireMessageData_emailCc').val('');

			var addNewModal = $('#addNewModal');
			var DELAY = 500;

			if (addNewModal.hasClass('in')) {
				$('#addNewModal').modal('hide');
			} else {
				DELAY = 0;
			}

			templateRequestsService.getTemplates('questionnaire_preview').subscribe(function (data) {
				successInitSendQuestionnaire(data);
				$timeout(function () {
					$('#sendNewQuestionnaireModal').modal('show').on('shown.bs.modal', function () {
						var input = $('#sendNewQuestionnaireModal').find('input');

						validationService.isModalClosePrevented(input);
					});
				}, DELAY);
			});
		};

		function successInitSendQuestionnaire(data) {
			$scope.initSendQuestionnaireSpinningWheel = true;
			$scope.questionnaireSendSource = data;
			$scope.questionnaires = $scope.questionnaireSendSource.questionnaireTemplates;
			$scope.questionnaireEmailTemplates = $scope.questionnaireSendSource.emailTemplates;

			var template = $scope.questionnaireEmailTemplates.find(function (item) {
				return item.emailTemplateType === 'QUESTIONNAIRE_EMAIL_TEMPLATE';
			}) || {};

			$scope.choosenQuestionnaireEmail = template;

			if ($scope.questionnaireEmailTemplates) {
				$scope.setQuestionnaireEmailTemplate(template.id);
			}

			delete $scope.sendMessageQuestion;
			$scope.sendMessageQuestion = {};
			$scope.sendMessageQuestion.emailTo = $rootScope.primaryContact.email ? [$rootScope.primaryContact.email] : [];
			if ($scope.secondaryContact) {
				$scope.sendMessageQuestion.emailTo.push($scope.secondaryContact.email);
			}
			$scope.sendMessageQuestion.emailCc = [];
			$scope.initSendQuestionnaireSpinningWheel = false;
		}

		$scope.setEmailData = function (newData, object, property) {
			$scope[object][property] = newData;
		};

		$scope.showSendQuestionnaire = function (jobId, questionnaireId, task) {
			$rootScope.showCcField = false;
			$routeParams.questionnaireId = questionnaireId;
			$routeParams.jobId = jobId;

			// delete $scope.sendMessage;
			$scope.sendMessage = {};
			$scope.sendMessage.emailTo = $rootScope.primaryContact.email ? [$rootScope.primaryContact.email] : [];
			if ($scope.secondaryContact) {
				$scope.sendMessage.emailTo.push($scope.secondaryContact.email);
			}
			$scope.sendMessage.emailCc = [];
			if (task !== undefined) {
				$scope.task = JSON.parse(JSON.stringify(task));
				$scope.sortedTasksArrQuestionnarie = $scope.sortedTasksArr;
				$scope.isDisable = true;
			}
			templateRequestsService.getTemplates('questionnaire_preview').subscribe(function (data) {
				return successShowSendQuestionnaire(data);
			});
		};

		function successShowSendQuestionnaire(data) {
			$scope.questionnaireSendSource = data;
			$scope.questionnaireEmailTemplates = data.emailTemplates;

			var template = $scope.questionnaireEmailTemplates.find(function (item) {
				return item.emailTemplateType === 'QUESTIONNAIRE_EMAIL_TEMPLATE';
			}) || {};

			$scope.choosenQuestionnaireEmail = template;
			$scope.setQuestionnaireEmailTemplate(template.id);

			$('#sendQuestionnaireModal').modal('show').on('shown.bs.modal', function () {
				var input = $('#sendQuestionnaireModal').find('input');

				validationService.isModalClosePrevented(input);
			});
		}

		$scope.setQuestionnaireEmailTemplate = function (id) {
			var questionnaireSetEmailCallback = function questionnaireSetEmailCallback(data) {
				$scope.questionnaireEmail = angular.copy(data);
				if (data.storedAttachments && data.storedAttachments.length) {
					$scope.attachmentsDataQueston = {
						attachments: fileUploadService.convertAttachmentsToShow(data.storedAttachments)
					};
				} else {
					clearQuestAttachments();
				}
			};
			templateRequestsService.getTemplates('full_template', id).subscribe(function (data) {
				return questionnaireSetEmailCallback(data);
			}, function (error) {
				return showGeneralErrorMessage(error);
			});
		};

		$scope.sendNewQuestionnaireEmail = function (chosenQuestionnaire, questionnaireEmailTemplate) {
			var maxSize = 10; // 10Mb

			if ($scope.attachmentsDataQueston && $scope.attachmentsDataQueston.filesSize > maxSize) {
				messageService.showToaster('w_0', 'attachments');
				$scope.initSendQuestionnaireSpinningWheel = false;
				$scope.button_disable = false;
				return false;
			}

			if (validationService.isStringEmpty(questionnaireEmailTemplate.subject)) {
				messageService.showToaster('e_10', 'emailTemplate');
				return;
			}

			if ($scope.questionnaireEmail && $scope.questionnaireEmail.text && chosenQuestionnaire) {
				if (questionnaireEmailTemplate && questionnaireEmailTemplate.text && questionnaireEmailTemplate.subject) {
					questionnaireEmailTemplate.text = $rootScope.addMaiStyling(questionnaireEmailTemplate.text);

					$scope.sendMessageQuestion.emailSubject = questionnaireEmailTemplate.subject;

					var mailData = emailService.prepareEmails($scope.sendMessageQuestion);

					if (!emailService.validateMails(mailData)) {
						return;
					}

					$scope.emailDataToSaveQuestion = Object.assign({}, $scope.sendMessageQuestion, mailData);
					delete $scope.emailDataToSaveQuestion.emailCc;

					var obj2save = angular.copy($scope.emailDataToSaveQuestion);
					var emailCC2save = $scope.showCcField ? obj2save.ccEmails : '';

					var data = {
						emailTo: $scope.emailDataToSaveQuestion.emailTo,
						emailText: questionnaireEmailTemplate.text,
						emailSubject: questionnaireEmailTemplate.subject,
						questionnaireTemplateId: chosenQuestionnaire.id || null,
						jobId: $scope.job.id,
						templateId: questionnaireEmailTemplate.id
					};

					if ($scope.emailDataToSaveQuestion.secondaryToEmails) {
						data.secondaryToEmails = $scope.emailDataToSaveQuestion.secondaryToEmails;
					}

					if (emailCC2save) {
						data.ccEmails = emailCC2save;
					}

					$scope.button_disable = true;
					jobViewRequests.sendNewQuestionnaireEmail(data, function (data) {
						if (data) {
							var errorMessage = data.errorMessage,
							    errorTitle = data.errorTitle;

							if (errorMessage) {
								messageService.showErrorFromBackend(errorTitle, errorMessage);
								$scope.button_disable = false;
								return;
							}
						}

						jobViewRequests.getJob();
						$scope.button_disable = false;
						$scope.showCcField = false;
						$scope.$evalAsync();
						$('#sendNewQuestionnaireModal').modal('hide');

						for (var prop in $scope.sendMessageQuestion) {
							$scope.sendMessageQuestion[prop] = '';
						}
						if ($scope.attachmentsDataQueston && $scope.attachmentsDataQueston.attachments) {
							if ($scope.attachmentsDataQueston.attachments.length) {
								$scope.attachmentsDataQueston.attachments.length = 0;
							}
						}
						messageService.showToaster('s_9', 'jobView');
					}, function (_ref4) {
						var status = _ref4.status,
						    data = _ref4.data;

						$scope.button_disable = false;
						var path = $location.path();
						var errorMessage = data.errorMessage;

						if (status >= 400 && status < 500 && errorMessage) {
							if (status === 423) {
								var limit = $rootScope.isUserTrial ? 50 : 150;
								return messageService.showToaster('e_4', 'generalValidation', limit);
							} else if (errorMessage.includes('Email address inactive')) {
								messageService.showToaster('e_1', 'generalValidation', $scope.sendMessageQuestion.emailTo);
							} else if (path.includes('jobs')) {
								messageService.showToaster('e_0', 'questionnaires');
							} else {
								messageService.showToaster('e_2', 'general', errorMessage);
							}
						} else {
							messageService.showToaster('e_0', 'general');
						}
					});
				} else {
					// toastr.warning("Fill data first");
					messageService.showToaster('w_0', 'jobView');
				}
			} else {
				// toastr.warning("Fill data first");
				messageService.showToaster('w_0', 'jobView');
			}
		};

		// Notes methods
		$scope.showEditNotesModal = function () {
			$scope.editNotes = $scope.job.notes || '';
			$('#updateModal').modal('show');
		};

		$scope.saveNotes = function () {
			$scope.isSaveNotesSpinnningWheelActive = true;

			var data4Save = {
				id: $scope.job.id,
				notes: $scope.editNotes
			};

			$http({
				method: 'POST',
				url: '/protected/rest/job/notes/update',
				data: data4Save
			}).then(function (result) {
				var _result$data = result.data,
				    message = _result$data.message,
				    errorMessage = _result$data.errorMessage;


				if (message) {
					messageService.showToaster('s_3', 'jobView');
					$('#updateModal').modal('hide');
					// $rootScope.updateEditJobModalData = true;
					$scope.job.notes = $scope.editNotes;
					$scope.job2Edit.notes = $scope.editNotes;
				} else {
					toastr.error(errorMessage);
				}
			}).catch(messageService.showDefaultErrorMessage).finally(function () {
				$scope.isSaveNotesSpinnningWheelActive = false;
			});
		};

		$scope.setClientMail = function (clientMailData, jobMailData) {
			$scope.clientMailData = clientMailData;
			$scope.mailData2Save = jobMailData;
		};

		// Email methods
		$scope.showSendEmailModal = function (jobId, task, selectedContact) {
			delete $scope.mailData2Save;
			delete $scope.clientMailData;

			Rx.Observable.zip(templateRequestsService.getTemplates('general_preview'), templateRequestsService.getTemplates('email_signature')).takeUntil($scope.unsubscribe).finally(function () {
				return $scope.showSendEmailModalSpinningWheel = false;
			}).subscribe(function (_ref5) {
				var _ref6 = _slicedToArray(_ref5, 2),
				    emails = _ref6[0],
				    mailSignature = _ref6[1];

				selectedContact ? $scope.mailData2Save = angular.copy(selectedContact) : $scope.mailData2Save = angular.copy($scope.primaryContact);

				$scope.mailData2Save.emails = emails;
				$scope.mailData2Save.mailSignature = mailSignature.signature || '';
				if (!selectedContact && $scope.secondaryContact) {
					$scope.mailData2Save.secondaryEmail = $scope.secondaryContact.email;
				}
				if (task !== undefined) {
					$scope.mailData2Save.emailSubject = task.taskEmail.subject;
					$scope.mailData2Save.emailText = task.taskEmail.text;
					$scope.mailData2Save.task = JSON.parse(JSON.stringify(task));
					$scope.mailData2Save.jobId = $scope.job.id;
					$scope.mailData2Save.sortedTasksArr = $scope.sortedTasksArr;
					$scope.mailData2Save.isDisable = true;
				}

				$rootScope.clientToken = false;

				if (!$scope.$$phase) {
					$scope.$apply();
				}

				$routeParams.jobId = jobId;
				$scope.jobId = jobId;
				$('#sendContactEmailModal').modal('show');
			});
		};

		$scope.showSendModal = function (task) {
			if (task.completed === true) {
				switch (task.action) {
					case 'SEND_EMAIL':
						$scope.showSendEmailModal($scope.jobId, task);
						break;
					case 'SEND_QUESTIONNAIRE':
						$scope.tickTask = true;
						$scope.tickTaskType = 'QUESTIONNAIRE';
						openEditAutomationTask(task);
						break;
					case 'SEND_CONTRACT':
						$scope.tickTask = true;
						$scope.tickTaskType = 'CONTRACT';
						openEditAutomationTask(task);
						break;
				}
			}
		};

		function openEditAutomationTask(task) {
			workflowService.setTaskInfo(task, $scope.job.workflow.tasks, true);
			$('#addAutomationModal').modal('show');
		}

		$scope.retrySendMail = function () {
			jobViewRequests.getJob();
			emailService.callLastEmailFn();
		};

		$scope.openSendEmailForReply = function () {
			utilsService.closeAllModalsAndOpenNew('#sendContactEmailModal');
		};

		$scope.updateClientToResubscribe = function (client) {
			$scope.clientToSendMail = client;
		};

		$scope.addSubjectVariable = function ($event, id, type) {
			var el = document.getElementById(id);
			var subject = emailService.addSubjectVariable(el, $event);
			if ($scope.sendMessage) {
				$scope.sendMessage.emailSubject = subject;
			}

			if (type === 'QUESTIONNAIRE') {
				$scope.questionnaireEmail.subject = subject;
			}

			if (type === 'CONTRACT') {
				$scope.contractEmailTemplate.subject = subject;
			}
		};

		$scope.toggleViewCc = function (state) {
			if ($scope.sendMessage && $scope.sendMessage.emailCc) {
				$scope.sendMessage.emailCc = '';
				$scope.$evalAsync();
			}

			$scope.showCcField = state !== undefined ? state : !$scope.showCcField;

			if (state === false) {
				clearQuestAttachments();
				clearContractAttachments();
			}
		};

		// attachments

		function setAttachments(attachments) {
			$scope.files = fileUploadService.setAttachmentsFromServer(attachments);
			fileUploadDataService.setAttachmentsFromServer(attachments);
			$scope.$broadcast('addedFileEvent');
		}

		function clearContractAttachments() {
			$scope.attachmentsDataContract = {
				attachments: [],
				filesSize: 0
			};
		}

		function clearQuestAttachments() {
			$scope.attachmentsDataQueston = {
				attachments: [],
				filesSize: 0
			};
		}

		// Workflow methods
		$scope.getWorkflow = function () {
			if (!$scope.job || $scope.job.id === null || $scope.job.id === undefined) {
				return false;
			}
			workflowService.getJobWorkflow($scope.job.id, successGetWorkflow);
		};

		function successGetWorkflow(workflow) {
			$scope.job.workflow = workflow;
			prepareTasks();
		}

		var fillWorkflowTasks = function fillWorkflowTasks() {
			var taskList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

			var _workflowService$fill = workflowService.fillWorkflowTasks(taskList);

			var _workflowService$fill2 = _slicedToArray(_workflowService$fill, 3);

			$scope.lead = _workflowService$fill2[0];
			$scope.production = _workflowService$fill2[1];
			$scope.postProduction = _workflowService$fill2[2];
		};

		var handleTask = function handleTask(task, taskTypes) {
			if (task.dateItem) {
				task.dateItem = task.dateItem.toLowerCase();
			}

			if (task.due && !task.hasDue) {
				// for old workflows
				task.hasDue = true;
			}

			if (!task.action && task.taskEmail) {
				// for old workflows
				task.action = 'SEND_EMAIL';
			}

			if (task.calendarEventType === 'MAIN_SHOOT') {
				var _$scope$job = $scope.job,
				    startDate = _$scope$job.startDate,
				    finishDate = _$scope$job.finishDate,
				    startTime = _$scope$job.startTime,
				    finishTime = _$scope$job.finishTime,
				    location = _$scope$job.location;

				task.location = location;
				task.startDate = startDate;
				task.endDate = finishDate;
				task.startTime = startTime;
				task.endTime = finishTime;
			} else if (task.calendarEvent) {
				var _task$calendarEvent = task.calendarEvent,
				    _startDate = _task$calendarEvent.startDate,
				    endDate = _task$calendarEvent.endDate,
				    _startTime = _task$calendarEvent.startTime,
				    endTime = _task$calendarEvent.endTime,
				    _location = _task$calendarEvent.location,
				    clientId = _task$calendarEvent.clientId;

				task.location = _location;
				task.startDate = _startDate;
				task.endDate = endDate;
				task.startTime = _startTime;
				task.endTime = endTime;
				task.sendEmails = clientId ? task.calendarEvent.sendEmails : false;

				if (task.startDate && (task.startTime === null || task.finishTime === null)) {
					task.allday = true;
				}
			}

			task.overdueDays = workflowService.calcTaskOverdue(task.overdueDays);
			task.taskViewDue = workflowService.getTaskViewDue(task, taskTypes);
			task.taskDueDefault = task.defaultTask && task.dueDate ? task.dueDate : null;
		};

		var getSortedTasks = function getSortedTasks() {
			return [$scope.lead, $scope.production, $scope.postProduction];
		};

		function prepareTasks() {
			if (!$scope.job.workflow) {
				return false;
			}

			var taskList = angular.copy($scope.job.workflow.tasks);
			taskList = $filter('orderBy')($scope.job.workflow.tasks, 'number', false);
			fillWorkflowTasks(taskList);

			$scope.sortedTasksArr = getSortedTasks();
			$scope.job.workflow.tasks.forEach(function (item) {
				return handleTask(item, $scope.sortedTasksArr);
			});

			if ($scope.job.showNewTaskId) {
				$timeout(function () {
					var newTask = taskList.find(function (task) {
						return task.id === $scope.job.showNewTaskId;
					});
					var taskToAnimate = '.task-' + newTask.number;
					$rootScope.$broadcast('animateTask', taskToAnimate);
					// next line removes parameters from route
					$location.search({}).replace();
				}, 0);
			}
			$scope.correctSortedTasksArray = angular.copy($scope.sortedTasksArr);
		}

		$scope.updateViewAndRenewWorkflow = function (tasks) {
			$scope.updateJobView();
			$scope.renewWorkflow(tasks);
		};

		$scope.renewWorkflow = function (tasks) {
			var taskList = angular.copy(tasks);
			taskList = $filter('orderBy')(tasks, 'number', false);
			fillWorkflowTasks(taskList);
			$scope.sortedTasksArr = getSortedTasks();
			taskList.forEach(function (item) {
				return handleTask(item, $scope.sortedTasksArr);
			});
			$scope.correctSortedTasksArray = angular.copy($scope.sortedTasksArr);
		};

		$scope.showWarningModal = function (task) {
			if (task) {
				emailService.emitClientToCheckSubscription($scope.primaryContact);
				emailService.checkIfEmailAllowedWeb($scope.primaryContact, $scope.changeTaskState, this, [task]);
				$scope.retryTask = task;
			}
		};

		$scope.cancelAutomation = function () {
			if ($scope.retryTask) {
				$scope.retryTask.completed = false;
			}
		};

		$scope.changeTaskState = function (task) {
			$rootScope.dnd.canMove = false;
			$http({
				method: 'POST',
				url: '/protected/rest/jobs/' + $scope.job.id + '/tasks/' + task.id,
				data: JSON.stringify(task.completed)
			}).then(function (result) {
				toastr.clear();
				messageService.showToaster('i_0', 'jobView');
				task = Object.assign(task, result.data);
				handleTask(task, $scope.sortedTasksArr);
				jobViewRequests.getJob();
			}, function (result) {
				toastr.clear();
				if (result.status === 423) {
					var limit = $rootScope.isUserTrial ? 50 : 150;
					messageService.showToaster('e_4', 'generalValidation', limit);
				} else {
					messageService.showDefaultErrorMessage(result);
				}
			}).finally(function () {
				$rootScope.dnd.canMove = true;
			});
		};
		$scope.changeToLeadOrJob = function (task) {
			$('#modalChangeLead').modal('show');
			$scope.newTaskCreate = Object.assign(task);
		};
		// Client methods
		function setContacts() {
			var _$scope$job2 = $scope.job,
			    primaryContact = _$scope$job2.primaryContact,
			    secondaryContact = _$scope$job2.secondaryContact;

			$scope.primaryContact = primaryContact;

			if (secondaryContact) {
				$scope.secondaryContact = secondaryContact;
			}
		}

		$scope.chooseContract = function () {
			$scope.updatedContract = null;
		};

		$scope.editClient = function (client) {
			$scope.clientForEdit = angular.copy(client);
			$scope.companyNameChecked = !!$scope.clientForEdit.companyName || !!$scope.clientForEdit.businessNumber;
			$('#editClientModal').modal('show').on('shown.bs.modal', function () {
				var input = $(this).find('input');

				validationService.isModalClosePrevented(input);
			});
		};

		var successSaveClient = function successSaveClient(data) {
			if (data.errorMessage) {
				toastr.error(data.errorMessage, 'Error');
				$scope.isCreateClientModalSpinnningWheelActive = false;
			} else {
				toastr.success(data.message, 'Success');
				$('#editClientModal').modal('hide');
				delete $scope.clientForEdit;
				jobViewRequests.getJob();
				$scope.isCreateClientModalSpinnningWheelActive = false;
			}
		};

		var errorSaveClient = function errorSaveClient(_ref7) {
			var status = _ref7.status,
			    data = _ref7.data;

			var errorMessage = data.errorMessage;
			var errorCode = void 0,
			    errorPlace = void 0,
			    value = void 0;

			if (status >= 400 && status < 500 && errorMessage) {
				if (errorMessage === 'Job contact cannot be changed because invoice has Xero payment') {
					errorCode = 'e_10';
					errorPlace = 'xero';
				} else if (errorMessage === 'Sorry, this customer has been deleted on QuickBooks') {
					errorCode = 'e_23';
					errorPlace = 'qb';
				} else if (errorMessage.includes('already registered')) {
					errorCode = 'e_8';
					errorPlace = 'clients';
					value = $scope.clientForEdit.email;
				} else if (errorMessage === 'Your QuickBooks company already contains client with such name') {
					errorCode = 'e_6';
					errorPlace = 'qb';
				} else {
					errorCode = 'e_2';
					errorPlace = 'general';
					value = errorMessage;
				}
			} else {
				errorCode = 'e_0';
				errorPlace = 'general';
			}
			messageService.showToaster(errorCode, errorPlace, value);
		};

		$scope.saveClient = function () {
			$scope.isCreateClientModalSpinnningWheelActive = true;
			if (!$scope.clientForEdit.id) {
				console.error('No client id');
				$scope.isCreateClientModalSpinnningWheelActive = false;
				return;
			}
			if (!validationService.isEmailValid($scope.clientForEdit.email)) {
				$scope.isCreateClientModalSpinnningWheelActive = false;
				return messageService.showToaster('e_3', 'companyUsers');
			}

			if (validationService.isStringEmpty($scope.clientForEdit.firstName)) {
				$scope.isCreateClientModalSpinnningWheelActive = false;
				return messageService.showToaster('e_4', 'clients');
			}

			if (!$scope.companyNameChecked) {
				delete $scope.clientForEdit.companyName;
				delete $scope.clientForEdit.businessNumber;
			}

			if ($scope.clientForEdit.notes) {
				$scope.clientForEdit.notes = $rootScope.addMaiStyling($scope.clientForEdit.notes);
			}

			clientsDataService.updateClient($scope.clientForEdit).finally(function () {
				return $scope.isCreateClientModalSpinnningWheelActive = false;
			}).subscribe(function (data) {
				return successSaveClient(data);
			}, function (err) {
				return errorSaveClient(err);
			});
		};

		// Go-to methods
		function goToLocation(url) {
			$location.path(url);
		}

		function goToNewPayment(url) {
			var addNewModal = $('#addNewModal');
			var delay = 0;

			if (addNewModal.hasClass('in')) {
				addNewModal.modal('hide');
				delay = 500;
			}

			$timeout(function () {
				return goToLocation(url);
			}, delay);
		}

		$scope.goToQuotePage = function (jobId, quoteId) {
			return goToLocation('/jobs/' + jobId + '/quote/' + quoteId);
		};

		$scope.goToInvoicePage = function (job, invoice) {
			var hasInvoices = job.hasInvoices;
			var invoiceId = invoice.invoiceId;


			if (hasInvoices) {
				goToLocation('/invoices/' + invoiceId);
			}
		};

		$scope.goToContractsPage = function (jobId, contractId) {
			return goToLocation('/jobs/view/' + jobId + '/contracts/' + contractId);
		};

		$scope.goToQuestionnairesPage = function (jobId, questionnaireId) {
			return goToLocation('/jobs/view/' + jobId + '/questionnaires/' + questionnaireId);
		};

		// Toggle modals
		$scope.showAddNewModal = function () {
			$('#addNewModal').modal('show');
		};

		$scope.showDeleteModal = function (jobId) {
			$scope.jobForDelete = jobId;
			$('#deleteModal').modal('show');
		};

		$scope.showEditJobModal = function (job) {
			$scope.job2Edit.workflow.name = stringModifierService.addSelectedText($scope.job2Edit.workflow.name);
			var isWorkflowSaved = $scope.job2Edit.workflowNames.find(function (workflow) {
				return workflow.id === $scope.job2Edit.workflow.id;
			});
			if ($scope.job2Edit.workflowNames && !isWorkflowSaved) {
				$scope.job2Edit.workflowNames.push($scope.job2Edit.workflow);
			}
			$('#newJob').modal('show');

			$scope.$broadcast('showModalJob', $scope.job2Edit);
		};

		$scope.showAddNewTaskModal = function () {
			$scope.showAddNewTaskModalSpinnigWheel = true;
			var addNewModal = $('#addNewModal');
			var DELAY = 500;

			if (addNewModal.hasClass('in')) {
				$('#addNewModal').modal('hide');
			} else {
				DELAY = 0;
			}

			$timeout(function () {
				$('#addWorkflowTaskModal').modal('show');
				$scope.showAddNewTaskModalSpinnigWheel = false;
			}, DELAY);
		};

		$scope.showQuoteModal = function (jobId, quoteId, type) {
			$routeParams.jobId = jobId;
			$routeParams.quoteId = quoteId;

			$scope.sendMessage = {};
			$scope.sendMessage.emailTo = $rootScope.primaryContact.email;
			$scope.sendMessage.emailCc = '';

			$http.get('/protected/rest/email_templates/get').then(function (result) {
				if (result.data) {
					$scope.emails = result.data;
					if (result.data.length > 0) {
						// $scope.choosenEmail = result.data[0];
						$scope.choosenEmail = $scope.emails.find(function (item) {
							return item.emailTemplateType === 'QUOTE_EMAIL_TEMPLATE';
						}) || {};
					}
					$('#sendQuoteModal').modal('show', {
						primaryContact: $scope.primaryContact,
						secondaryContact: $scope.secondaryContact,
						customToken: type === 'FIXED' ? 'INVOICE_MENU' : 'JOB_MENU'
					});
				}
			});
		};

		// Job methods
		$scope.deleteJob = function () {
			$scope.deleteDisable = true;

			$http({
				method: 'DELETE',
				url: '/api/user/v1/job/' + $scope.jobForDelete + '/delete'
			}).then(function (result) {
				messageService.showToaster('s_0', 'jobView');
				$location.path('/jobs').replace();
			}).catch(errorDeleteJob).finally(function () {
				$scope.deleteDisable = false;
			});
		};

		function errorDeleteJob(_ref8) {
			var data = _ref8.data;

			messageService.handleError({ error: data });
		}

		function prepareJob(job) {
			$scope.job2Edit = angular.copy(job);
			$scope.clients = [];

			var _$scope$job2Edit = $scope.job2Edit,
			    workflow = _$scope$job2Edit.workflow,
			    startDate = _$scope$job2Edit.startDate,
			    finishDate = _$scope$job2Edit.finishDate,
			    primaryContact = _$scope$job2Edit.primaryContact,
			    secondaryContact = _$scope$job2Edit.secondaryContact;


			$scope.job2Edit.oldWorkflow = workflow;

			if (!$scope.job2Edit.startDate) {
				$scope.job2Edit.hasNoDate = true;
			} else {
				$scope.dateFilterJob = 'dd/MM/yyyy';
				$scope.job2Edit.hasNoDate = false;
				$scope.job2Edit.startDate = timeService.createDateAsUTC(startDate);
				$scope.job2Edit.finishDate = timeService.createDateAsUTC(finishDate);
			}

			if (primaryContact) {
				var primaryClientSearchText = clientService.fillClientSearchText(primaryContact);
				$scope.clients[0] = primaryClientSearchText;
				$scope.job2Edit.primaryContact = $scope.clients[0];
			}

			if (secondaryContact) {
				var secondaryClientSearchText = clientService.fillClientSearchText(secondaryContact);
				$scope.clients[1] = secondaryClientSearchText;
				$scope.job2Edit.secondaryContact = $scope.clients[1];
			}

			if ($scope.job2Edit.startDate && ($scope.job2Edit.startTime === null || $scope.job2Edit.finishTime === null)) {
				$scope.job2Edit.allday = true;
			}
			getJobTypes();
			getWorkflowAndLanguageNames();
		}

		function getJobTypes() {
			return jobTypesDataService.getJobTypes().finally(function () {
				return $scope.button_disable = false;
			}).subscribe(function (data) {
				return successGetJobTypes(data);
			});
		}

		function getWorkflowAndLanguageNames() {
			return workflowDataService.getWorkflowAndLanguageNames().finally(function () {
				return $scope.button_disable = false;
			}).subscribe(function (data) {
				return successGetWorkflowAndLanguageNames(data);
			});
		}

		function successGetJobTypes(data) {
			$scope.jobTypes = angular.copy(data);
			if (!$scope.job2Edit.type && $scope.jobTypes && $scope.jobTypes.length > 0) {
				$scope.job2Edit.type = $scope.jobTypes[0];
			}
			$scope.job2Edit.jobTypes = angular.copy(data);
		}

		function successGetWorkflowAndLanguageNames(data) {
			if (!data) {
				return false;
			}
			$scope.job2Edit.workflowNames = angular.copy(data.workflows);
			$scope.job2Edit.languageNames = angular.copy(data.languages);
		}

		// helper functions
		function showGeneralErrorMessage(error) {
			messageService.showToaster('e_0', 'general');
		}

		$scope.setMinWidth = function () {
			var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

			var textLength = text.length;

			if (textLength < 6) {
				return 40;
			} else if (textLength < 10) {
				return 60;
			} else if (textLength < 20) {
				return 100;
			}
			return 190;
		};

		$scope.refreshFileList = function () {
			fileUploadDataService.setFiles($scope.files, true);
		};

		$rootScope.updateJobView = function () {
			jobViewRequests.getJob();
		};
	}
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/rxjs/Rx.js"), __webpack_require__("./node_modules/jquery/dist/jquery.js"), __webpack_require__("./node_modules/toastr/toastr.js")))

/***/ }),

/***/ "./web/js/controllers/lead/leadOverviewController.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, Rx) {

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
	angular.module('main').controller('LeadsOverviewController', LeadsOverviewController).filter('capitalize', function () {
		return function (input) {
			return angular.isString(input) && input.length > 0 ? input.charAt(0).toUpperCase() + input.substr(1).toLowerCase() : input;
		};
	});

	LeadsOverviewController.$inject = ['$scope', '$rootScope', '$location', '$timeout', 'messageService', 'timeService', '$routeParams', 'timeConverter', 'emailService', 'templateRequestsService', 'leadDataService', 'clientService', 'jobTypesDataService', 'workflowDataService', '$window', 'accountService', 'settingsService'];

	function LeadsOverviewController($scope, $rootScope, $location, $timeout, messageService, timeService, $routeParams, timeConverter, emailService, templateRequestsService, leadDataService, clientService, jobTypesDataService, workflowDataService, $window, accountService, settingsService) {
		$scope.$on('$viewContentLoaded', function () {
			$('body').updatePolyfill();
			var searchFromUrl = void 0;
			try {
				searchFromUrl = decodeURIComponent($routeParams.search);
				searchFromUrl = searchFromUrl === 'undefined' ? '' : searchFromUrl;
			} catch (e) {
				searchFromUrl = '';
			}
			$scope.pageRequest = {
				page: +$routeParams.page || 0,
				perPage: $rootScope.paginationPerPage ? $rootScope.paginationPerPage : 25,
				pageOrder: {
					predicate: $rootScope.leadPageRequest && $rootScope.leadPageRequest.pageOrder.predicate || 'createdAt',
					reverse: $rootScope.leadPageRequest && $rootScope.leadPageRequest.pageOrder.reverse || false
				},
				search: searchFromUrl || ''
			};
			$scope.pagindis = true;
			$scope.sendEmailLeadId = null;
			$scope.leads = [];
			$scope.workflowNames = [];
			$scope.jobTypes = [];
			$scope.totalItems = 0;
			$scope.selectActive = ['Open Leads', 'Open Leads waiting for my reply', "Open Leads waiting for the client's reply", 'Archived Leads'];
			$scope.mailData2Save = {};
			$scope.searchText = searchFromUrl || '';
			$scope.pageRequest.search = searchFromUrl || '';
			$scope.unsubscribe = new Rx.Subject();
			$scope.changeUrl = false;
			$scope.toSearch = true;

			subscribeToCustomizeLabelsChange();
			getCompanyId();
		});

		$window.onpopstate = function () {
			$scope.changeUrl = false;
			var searchFromUrl = void 0;
			if ($routeParams.search) {
				try {
					searchFromUrl = decodeURIComponent($routeParams.search);
					searchFromUrl = searchFromUrl === 'undefined' ? '' : searchFromUrl;
				} catch (e) {
					searchFromUrl = '';
				}
				$scope.pageRequest.search = searchFromUrl || '';
				$scope.searchText = searchFromUrl || '';
			} else {
				$scope.pageRequest.search = '';
				$scope.searchText = '';
				$scope.toSearch = false;
			}
			getResultsPage(+$routeParams.page);
		};

		$scope.$on('$destroy', function () {
			$scope.unsubscribe.next();
			$scope.unsubscribe.complete();
		});

		var defaultWorkflow = {
			id: null,
			name: 'Default'
		};

		$scope.isCreateLeadSpinningWheelActive = false;

		function subscribeToCustomizeLabelsChange() {
			settingsService.customizeLabelsObservable.takeUntil($scope.unsubscribe).subscribe(function (customizeLabels) {
				$scope.mainShootLabelName = customizeLabels.mainShootLabel;
				$scope.extraShootLabelName = customizeLabels.extraShootLabel;
				$scope.businessNumberLabelName = customizeLabels.businessNumberLabel;
			});
		}

		$scope.$watch('selectActiveLeads', function (newValue, oldValue) {
			if (!oldValue || oldValue === newValue) {
				return false;
			}
			switch (newValue) {
				case 'Open Leads':
					getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage, null, null, 'open');
					break;
				case 'Open Leads waiting for my reply':
					getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage, null, null, 'open_waiting_user_reply');
					break;
				case "Open Leads waiting for the client's reply":
					getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage, null, null, 'open_waiting_client_reply');
					break;
				case 'Archived Leads':
					getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage, null, null, 'archived');
					break;
				default:
					getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
			}
		});

		var timerId = void 0;

		$scope.$watch('searchText', function (newValue, oldValue) {
			if (newValue == null) {
				return;
			}
			if (oldValue == newValue) {
				return;
			}
			if (!$scope.toSearch) {
				$scope.toSearch = true;
				return;
			}
			if (newValue.length > 0) {
				if (timerId != null) {
					clearTimeout(timerId);
				}
				timerId = setTimeout(searchRequest, 500);
			} else {
				clearTimeout(timerId);
				if (newValue.length == 0) {
					$scope.pageRequest.search = '';
					getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
				}
			}
		});

		function searchRequest() {
			$scope.pageRequest.search = $scope.searchText;
			getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
		}

		$scope.order = function (predicate) {
			$scope.pageRequest.pageOrder.reverse = $scope.pageRequest.pageOrder.predicate === predicate ? !$scope.pageRequest.pageOrder.reverse : false;
			getResultsPage(null, null, predicate, $scope.pageRequest.pageOrder.reverse);
		};
		$scope.getElement = function (index) {
			var tableId = document.getElementById('tableId').getBoundingClientRect();
			var dotsMenu = document.getElementById('dotsMenu-' + index).getBoundingClientRect();
			var add = document.getElementsByClassName('dropdown-menu-' + index);
			add[0].style.transform = '';
			// 165-height of modal; 30-height of 3 dots menu
			var x = dotsMenu.top - tableId.top;
			var value = tableId.height - x;
			if (tableId.height > 165 && value < 165) {
				add[0].style.transform = 'translate(-20%, ' + value + 'px)';
			}
		};
		$scope.isFilterAllowed = function (filter) {
			if (!$scope.allowedFilters) {
				return false;
			}

			return $scope.allowedFilters.includes(filter);
		};

		$scope.getCurrentPage = function () {
			return $scope.pageRequest.page;
		};

		$scope.perPageChanged = function (newPerPage) {
			getResultsPage(null, newPerPage);
			$rootScope.paginationPerPage = newPerPage;
		};

		$scope.goToPage = function (newPage, disabled) {
			if (!disabled) {
				getResultsPage(newPage, null);
			}
		};

		$scope.jumpBack = function (disabled) {
			if (!disabled) {
				if ($scope.pageRequest.page > 0) {
					getResultsPage($scope.pageRequest.page - 1, null);
				}
			}
		};

		$scope.jumpAhead = function (disabled) {
			if (!disabled) {
				if ($scope.totalItems >= ($scope.pageRequest.page + 1) * $scope.pageRequest.perPage + 1) {
					getResultsPage($scope.pageRequest.page + 1, null);
				}
			}
		};

		$scope.showLead = function (id) {
			$location.path('leads/view/' + id);
		};

		$scope.archivedLead = function (leadId) {
			leadDataService.archiveLead(leadId).subscribe(function () {
				messageService.showToaster('s_5', 'lead');
				getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
			}, function (error) {
				var errorMessage = error.error.errorMessage;

				if (errorMessage.includes('Lead contains invoices.')) {
					messageService.showToaster('e_4', 'lead');
				} else {
					messageService.showDefaultErrorMessage(error);
				}
			});
		};

		$scope.unArchivedLead = function (leadId) {
			leadDataService.unarchiveLead(leadId).subscribe(function () {
				messageService.showToaster('s_6', 'lead');
				getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
			}, function (error) {
				messageService.showDefaultErrorMessage(error);
			});
		};

		function getResultsPage() {
			var pageNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
			var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
			var predicate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
			var reverse = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
			var filter = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

			var changed = false;
			var perPageChanged = false;

			if (predicate) {
				$scope.pageRequest.pageOrder.predicate = predicate;
				$scope.pageRequest.pageOrder.reverse = !!reverse;
				changed = true;
			}
			if (perPage) {
				$scope.pageRequest.perPage = perPage;
				$scope.pageRequest.page = 0;
				changed = true;
				perPageChanged = true;
			}
			if (pageNumber !== null) {
				$scope.pageRequest.page = pageNumber;
				changed = true;
			}
			if (filter) {
				$scope.pageRequest.filter = filter;
				$scope.pageRequest.page = 0;
				setFilter(filter);
				changed = true;
			}
			if ($scope.pageRequest && $scope.totalItems != 0 && $scope.totalItems < ($scope.pageRequest.page - 1) * $scope.pageRequest.perPage + 1) {
				console.log('out of page');
				$scope.pageRequest.page = 0;
			}

			if (changed) {
				leadDataService.getLeadsOnPageV2($scope.pageRequest, perPageChanged).subscribe(function (data) {
					return successGetResultsPage(data);
				}, function (err) {
					return messageService.showDefaultErrorMessage(err);
				});
			}
		}

		function successGetResultsPage(data) {
			if (data) {
				$scope.pageRequest.search = $scope.searchText;
			}

			$scope.pageRequest.searchToken = data.searchToken;

			$scope.pageNumbers = [];
			$scope.totalItems = data ? data.totalSize : 0;

			var pagesCount = void 0;
			pagesCount = $scope.totalItems / $scope.pageRequest.perPage;
			pagesCount = Math.ceil(pagesCount);

			for (var i = 1; i <= pagesCount; i++) {
				$scope.pageNumbers[i - 1] = i;
			}
			$scope.leads = JSON.parse(JSON.stringify(data.items));

			$scope.allowedFilters = data.sortingFields;
			$rootScope.leadPageRequest = $scope.pageRequest;
			var newSearch = void 0;
			try {
				newSearch = encodeURIComponent($scope.pageRequest.search);
				newSearch = newSearch === 'undefined' ? null : newSearch;
			} catch (error) {
				newSearch = '';
			}
			if ($scope.changeUrl) {
				$location.search({
					page: $scope.pageRequest.page,
					search: newSearch || null
				});
			}
			$scope.changeUrl = true;

			$scope.$evalAsync();
		}

		// Edit
		function showNewLeadModal() {
			$scope.button_disable = true;
			$scope.isAddNewSpinnningWheelActive = true;
			$scope.isDisabled = true;
			$scope.newJob = {};
			$scope.isCreateJobSpinnningWheelActive = true;
			prepareLead($scope.newJob);
		}

		$scope.createLead = function () {
			$scope.isCreateLeadSpinningWheelActive = true;
			$scope.newLead = {};
			$scope.clients = [];
			$scope.showSecondClient = false;
			showNewLeadModal();
		};

		function prepareLead() {
			$scope.clients = [];

			var _$scope$newLead = $scope.newLead,
			    startDate = _$scope$newLead.startDate,
			    finishDate = _$scope$newLead.finishDate,
			    primaryContact = _$scope$newLead.primaryContact,
			    secondaryContact = _$scope$newLead.secondaryContact,
			    workflow = _$scope$newLead.workflow;


			$scope.newLead.oldWorkflow = workflow;

			if (!startDate && !finishDate) {
				$scope.newLead.hasNoDate = !!$scope.newLead.id;
			} else {
				$scope.newLead.hasNoDate = false;
				if (startDate) {
					$scope.newLead.startDate = timeService.createDateAsUTC(startDate);
				}
				if (finishDate) {
					$scope.newLead.finishDate = timeService.createDateAsUTC(finishDate);
				}
			}

			if (primaryContact) {
				var primaryClientSearchText = clientService.fillClientSearchText(primaryContact);
				$scope.clients[0] = primaryClientSearchText;
				$scope.newLead.primaryContact = $scope.clients[0];
			}

			if (secondaryContact) {
				var secondaryClientSearchText = clientService.fillClientSearchText(secondaryContact);
				$scope.clients[1] = secondaryClientSearchText;
				$scope.newLead.secondaryContact = $scope.clients[1];
			}
			if ($scope.newLead.startDate && ($scope.newLead.startTime === null || $scope.newLead.finishTime === null)) {
				$scope.newLead.allday = true;
			}
			var type = $scope.newLead.type;
			Rx.Observable.zip(getJobTypes(), getWorkflowAndLanguageNames()).takeUntil($scope.unsubscribe).finally(function () {
				$scope.button_disable = false;
				$scope.isCreateJobSpinnningWheelActive = false;
			}).subscribe(function () {
				$timeout(function () {
					$scope.newLead.type = type;
					$('#newLead').modal('show');
					$scope.isCreateJobSpinnningWheelActive = false;
					$scope.$broadcast('showModal', {
						lead: $scope.newLead,
						jobId: $scope.newLead.jobId
					});
				}, 300);
			});
		}
		function getJobTypes() {
			return jobTypesDataService.getJobTypes().map(function (data) {
				return successGetJobTypes(data);
			});
		}

		function successGetJobTypes(data) {
			$scope.newLead.jobTypes = angular.copy(data);
		}

		function getWorkflowAndLanguageNames() {
			return workflowDataService.getWorkflowAndLanguageNames().map(function (data) {
				return successGetWorkflowAndLanguageNames(data);
			});
		}

		function successGetWorkflowAndLanguageNames(data) {
			if (!data) {
				return false;
			}
			$scope.newLead.workflowNames = angular.copy(data.workflows);
			$scope.newLead.languageNames = angular.copy(data.languages);
		}

		$scope.editLeadModal = function (index) {
			$scope.button_disable = true;
			$scope.newLead = angular.copy($scope.leads[index]);
			prepareLead($scope.newLead);

			if ($scope.newLead.startTime) {
				$scope.newLead.startTime = timeConverter.convert24to12($scope.newLead.startTime);

				$scope.newLead.finishTime = timeConverter.convert24to12($scope.newLead.finishTime);
			}
		};

		function getSelectActiveLeads() {
			var activeFilter = getDefaultFilter();
			var selectActiveOption = void 0;
			switch (activeFilter) {
				case 'open':
					selectActiveOption = $scope.selectActive[0];
					break;
				case 'open_waiting_user_reply':
					selectActiveOption = $scope.selectActive[1];
					break;
				case 'open_waiting_client_reply':
					selectActiveOption = $scope.selectActive[2];
					break;
				case 'archived':
					selectActiveOption = $scope.selectActive[3];
					break;
				default:
					selectActiveOption = $scope.selectActive[0];
					break;
			}

			return selectActiveOption;
		}

		function getCompanyId() {
			accountService.companyIdObservable.takeUntil($scope.unsubscribe).subscribe(function (data) {
				$scope.companyId = data;
				$scope.selectActiveLeads = getSelectActiveLeads();
				$scope.pageRequest.filter = getDefaultFilter();
				getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
			});
		}

		function getDefaultFilter() {
			var filter = $window.localStorage.getItem('leadsOverviewFilter' + $scope.companyId);

			return filter || setFilter();
		}

		function setFilter() {
			var optionFilter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'open';

			$window.localStorage.setItem('leadsOverviewFilter' + $scope.companyId, optionFilter);

			return optionFilter;
		}

		// Email methods
		$scope.retrySendMail = function () {
			getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
			emailService.callLastEmailFn();
		};

		$scope.showSendEmailModal = function (leadId, contact, secondaryContact) {
			$scope.showSendEmailModalSpinningWheel = true;

			Rx.Observable.zip(templateRequestsService.getTemplates('general_preview'), templateRequestsService.getTemplates('email_signature')).takeUntil($scope.unsubscribe).finally(function () {
				$scope.showSendEmailModalSpinningWheel = false;
				getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
			}).subscribe(function (_ref) {
				var _ref2 = _slicedToArray(_ref, 2),
				    emails = _ref2[0],
				    mailSignature = _ref2[1];

				$scope.mailData2Save = angular.copy(contact);
				if (secondaryContact) {
					$scope.mailData2Save.secondaryEmail = secondaryContact.email;
				}
				$scope.mailData2Save.emails = emails;
				$scope.mailData2Save.mailSignature = mailSignature.signature || '';

				$rootScope.clientToken = false;

				if (!$scope.$$phase) {
					$scope.$apply();
				}
				$routeParams.leadId = leadId;
				$scope.leadId = leadId;
				$scope.sendEmailLeadId = leadId || null;
				$('#sendContactEmailModal').modal('show');
			});
		};

		$scope.setEmail = function (site, object) {
			var stringEmail = angular.copy(site.name);
			stringEmail = stringEmail.substring(stringEmail.indexOf('(') + 1, stringEmail.length - 1);

			if (!object) {
				$scope.sendMessage.emailCc = stringEmail;
			} else {
				object.emailCc = stringEmail;
			}
		};

		$scope.toggleViewCc = function (state) {
			if ($scope.sendMessage && $scope.sendMessage.emailCc) {
				$scope.sendMessage.emailCc = '';
				$scope.$evalAsync();
			}

			$scope.showCcField = state !== undefined ? state : !$scope.showCcField;

			if (state === false) {
				clearQuestAttachments();
				clearContractAttachments();
			}
		};
		function clearQuestAttachments() {
			$scope.attachmentsDataQueston = {
				attachments: [],
				filesSize: 0
			};
		}

		function clearContractAttachments() {
			$scope.attachmentsDataContract = {
				attachments: [],
				filesSize: 0
			};
		}
		// Delete
		$scope.showDeleteModal = function (leadId) {
			$scope.leadForDelete = leadId;
			$('#deleteModal').modal('show');
		};

		$scope.deleteLead = function () {
			$scope.deleteDisable = true;

			leadDataService.deleteLead($scope.leadForDelete).finally(function () {
				return $scope.deleteDisable = false;
			}).subscribe(function () {
				messageService.showToaster('s_2', 'lead');

				$('#deleteModal').modal('hide');
				getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
			}, function (error) {
				return errorDeleteLead(error);
			});
		};

		function errorDeleteLead(_ref3) {
			var status = _ref3.status,
			    data = _ref3.data;

			var errorMessage = data.errorMessage;
			var errorCode = void 0,
			    errorPlace = void 0,
			    value = void 0;

			if (status >= 400 && status < 500 && errorMessage) {
				if (errorMessage.includes('This payment cannot be marked as unpaid because it was overpaid in Xero.')) {
					errorCode = 'e_12';
					errorPlace = 'xero';
					value = 'job';
				} else {
					errorCode = 'e_2';
					errorPlace = 'general';
					value = errorMessage;
				}
			} else {
				errorCode = 'e_0';
				errorPlace = 'general';
			}
			messageService.showToaster(errorCode, errorPlace, value);
		}
		$rootScope.updateLeadView = function () {
			getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
		};
	}
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js"), __webpack_require__("./node_modules/rxjs/Rx.js")))

/***/ }),

/***/ "./web/js/controllers/lead/leadViewController.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Rx, $, toastr) {

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
	angular.module('main').controller('LeadViewController', LeadViewController);

	LeadViewController.$inject = ['$scope', '$rootScope', '$routeParams', '$location', '$http', '$filter', '$timeout', 'timeService', 'messageService', 'templateRequestsService', 'validationService', 'workflowService', 'fileUploadService', 'imageConverter', 'timeConverter', 'emailService', 'utilsService', 'userService', 'leadDataService', 'contractsDataService', 'notesDataService', 'newJobsDataService', 'clientsDataService', 'clientService', 'jobTypesDataService', 'workflowDataService', 'fileDownloadDataService', 'stringModifierService', 'settingsService', 'fileUploadDataService', 'mailsDataService', 'questionnairesDataService', 'contractService'];

	function LeadViewController($scope, $rootScope, $routeParams, $location, $http, $filter, $timeout, timeService, messageService, templateRequestsService, validationService, workflowService, fileUploadService, imageConverter, timeConverter, emailService, utilsService, userService, leadDataService, contractsDataService, notesDataService, newJobsDataService, clientsDataService, clientService, jobTypesDataService, workflowDataService, fileDownloadDataService, stringModifierService, settingsService, fileUploadDataService, mailsDataService, questionnairesDataService, contractService) {
		// Requests
		var leadViewRequests = {
			sendNewContractEmail: function sendNewContractEmail(data, successCallback, errorCallback) {
				if (id !== null) {
					var maxSize = 10; // 10Mb

					if ($scope.attachmentsDataContract && $scope.attachmentsDataContract.filesSize > maxSize) {
						messageService.showToaster('w_0', 'attachments');
						$scope.initSendContractSpinningWheel = false;
						return false;
					}

					var formData = new FormData();

					angular.forEach(data, function (value, key) {
						formData.append(key, value);
					});

					var filesFromJob = $scope.attachmentsDataContract.attachments.filter(function (file) {
						return file.id;
					});
					var filesFromComputer = $scope.attachmentsDataContract.attachments.filter(function (file) {
						return !file.id;
					});

					angular.forEach(filesFromComputer, function (value, key) {
						formData.append('attachments[' + key + ']', value);
					});

					angular.forEach(filesFromJob, function (value, key) {
						formData.append('storedAttachments[' + key + ']', value.id);
					});

					var url = '/protected/rest/job/contract/save/';
					contractsDataService.sendContractRequest(url, formData).subscribe(function (result) {
						successCallback(result);
						Intercom('trackEvent', 'sent contract');
					}, errorCallback);
				}
			},
			sendNewQuestionnaireEmail: function sendNewQuestionnaireEmail(data, successCallback, errorCallback) {
				if (id !== null) {
					var maxSize = 10; // 10Mb

					if ($scope.attachmentsDataQueston && $scope.attachmentsDataQueston.filesSize > maxSize) {
						messageService.showToaster('w_0', 'attachments');
						return false;
					}

					var formData = new FormData();

					angular.forEach(data, function (value, key) {
						formData.append(key, value);
					});

					var filesFromJob = $scope.attachmentsDataQueston.attachments.filter(function (file) {
						return file.id;
					});
					var filesFromComputer = $scope.attachmentsDataQueston.attachments.filter(function (file) {
						return !file.id;
					});

					angular.forEach(filesFromComputer, function (value, key) {
						formData.append('attachments[' + key + ']', value);
					});

					angular.forEach(filesFromJob, function (value, key) {
						formData.append('storedAttachments[' + key + ']', value.id);
					});

					var url = '/protected/rest/job/questionnaire/save';
					questionnairesDataService.sendQuestionnaireRequest(url, formData).subscribe(function (result) {
						successCallback(result);
						Intercom('trackEvent', 'sent questionnaire');
					}, errorCallback);
				}
			},
			getLead: function getLead() {
				var newTaskId = $routeParams.task;
				return leadDataService.getLeadInfo(id, newTaskId).map(function (data) {
					return removeLeadMails(data);
				}).subscribe(function (data) {
					return successGetLeads(data);
				}, function (error) {
					return errorGetLeads(error);
				});
			}
		};

		function errorGetLeads(error) {
			var _error$error = error.error,
			    errorCode = _error$error.errorCode,
			    data = _error$error.data;

			if (errorCode === 102 || errorCode === 104) {
				$location.path('/leads');
				messageService.showToaster('e_7', 'lead');
			}
			if (errorCode === 701) {
				$location.path('/' + data.redirectTo + 's/view/' + data.redirectId);
			}
		}

		function successGetLeads(data) {
			$scope.archived = data.archived;
			var job = data.job;
			var lead = data;
			$scope.lead = JSON.parse(JSON.stringify(lead));
			$scope.job = JSON.parse(JSON.stringify(job));
			$scope.primaryContact = JSON.parse(JSON.stringify(job.primaryContact));
			$scope.secondaryContact = JSON.parse(JSON.stringify(job.secondaryContact));
			$scope.leadId = data.id;
			$rootScope.jobId = $scope.job.id;
			prepareJob(job);
			prepareTasks();
			setContacts();
			calculateInvoices();
			setAttachments(data.job.attachments);
			$scope.getMails(false);
		}

		function removeParameters() {
			var _$location$search = $location.search(),
			    calendarView = _$location$search.calendarView,
			    calendarDate = _$location$search.calendarDate,
			    page = _$location$search.page,
			    search = _$location$search.search;

			if (calendarView || calendarDate || page) {
				$location.search({}).replace();
			}
		}

		$scope.$on('$viewContentLoaded', function () {
			removeParameters();

			$rootScope.jobViewLoaded = true;
			$scope.isSaveNotesSpinnningWheelActive = false;
			$scope.files = [];
			$scope.showAddNewTaskModalSpinningWheel = false;
			$scope.createNewInvoiceSpinningWheel = false;
			$scope.createNewQuoteSpinningWheel = false;
			$scope.initSendContractSpinningWheel = false;
			$scope.initSendQuestionnaireSpinningWheel = false;
			$scope.showSendEmailModalSpinningWheel = false;
			$scope.newTaskCreate = [];
			$scope.isCreateClientModalSpinnningWheelActive = false;
			$scope.isEditContractModalSpinnningWheelActive = false;
			$scope.loadFileSpinningWheelActive = false;
			$scope.isGetMailsSpinningWheelActive = false;

			$rootScope.dnd = { canMove: true };
			var attachmentsObj = { attachments: [], filesSize: 0 };
			$scope.attachmentsDataContract = angular.copy(attachmentsObj);
			$scope.tokenAttachmentsData = angular.copy(attachmentsObj);
			window.scrollTo(0, 0);
			$scope.now = new Date();
			$scope.now.setHours(12, 0, 0, 0);
			$scope.workflowNames = [];
			$scope.button_disable = true;
			$scope.userCurrencySymbol = userService.userCurrencySymbol;
			leadViewRequests.getLead();
			$scope.templates = {};
			$scope.unsubscribe = new Rx.Subject();
			$scope.primaryContact = null;
			$scope.secondaryContact = null;
			$scope.tickTask = false;
			$scope.tickTaskType = '';
			$scope.fundyIntegration = false;
			$scope.integrationInvoiceLoadXml = false;
			$scope.fundyAvailable = false;

			// ProSelect
			$scope.proSelectIntegration = false;
			$scope.proSelectAvailable = false;

			$scope.emailDataToSaveQuestion = {};
			$scope.emailDataToSaveContract = {};

			subscribeToCustomizeLabelsChange();

			settingsService.timeFormatSettings.subscribe(function (data) {
				if (data.fundyAvailable) {
					$scope.fundyAvailable = true;
					if (data.fundyIntegration === 'ENABLED') {
						$scope.fundyIntegration = true;
					}
				}

				if (data.proSelectAvailable) {
					$scope.proSelectAvailable = true;
					if (data.proSelectIntegration === 'ENABLED') {
						$scope.proSelectIntegration = true;
					}
				}

				$scope.leadSourcesAvailable = data.leadSourcesAvailable;
			});

			Rx.Observable.zip(templateRequestsService.getTemplates('contract_preview'), templateRequestsService.getTemplates('questionnaire_preview'), templateRequestsService.getTemplates('general_preview')).subscribe(function (_ref) {
				var _ref2 = _slicedToArray(_ref, 3),
				    contracts = _ref2[0],
				    questionnaires = _ref2[1],
				    general = _ref2[2];

				setContractsPreview(contracts);
				setQuestionnairesPreview(questionnaires);
				setGeneralEmailsPreview(general);
			}, function (error) {
				return showGeneralErrorMessage(error);
			});
		});

		$scope.$on('$destroy', function () {
			$scope.unsubscribe.next();
			$scope.unsubscribe.complete();
		});

		function subscribeToCustomizeLabelsChange() {
			settingsService.customizeLabelsObservable.takeUntil($scope.unsubscribe).subscribe(function (customizeLabels) {
				$scope.mainShootLabelName = customizeLabels.mainShootLabel;
				$scope.extraShootLabelName = customizeLabels.extraShootLabel;
				$scope.businessNumberLabelName = customizeLabels.businessNumberLabel;
			});
		}

		var defaultWorkflow = {
			id: '',
			name: 'Default'
		};
		var id = $routeParams.leadId;

		$scope.saveFilesOnService = function (item, leadId) {
			$scope.loadFileSpinningWheelActive = true;

			if ($scope.loadFileSpinningWheelActive === true) {
				$('.btn-add-round').css('pointer-events', 'none');
			}

			var maxMb = 20; // 20 Mb
			var maxSize = maxMb * 1000 * 1024;

			var totalFilesSize = getTotalSize($scope.files);

			if (totalFilesSize + item.size > maxSize) {
				messageService.showToaster('w_1', 'attachments');
				$scope.loadFileSpinningWheelActive = false;
				return;
			}

			fileUploadService.saveFileOnServer(item, leadId, function (response) {
				response.convertedType = imageConverter.getFileClass(response.name);
				$scope.files.push(response);
				fileUploadService.setFiles(response);
				$scope.$broadcast('addedFileEvent');
				enableFileAddButton();
			}, function (response) {
				var errorMessage = response.errorMessage,
				    errorTitle = response.errorTitle;

				messageService.showErrorFromBackend(errorTitle, errorMessage);
				enableFileAddButton();
			});
		};

		function enableFileAddButton() {
			$scope.loadFileSpinningWheelActive = false;
			if ($scope.loadFileSpinningWheelActive === false) {
				$('.btn-add-round').css('pointer-events', 'auto');
			}
		}

		function getTotalSize(files) {
			return files.reduce(function (prev, next) {
				return prev + next.bytesSize;
			}, 0);
		}

		// $scope.saveAttachment = function(fileId, jobId) {
		// 	fileDownloadDataService.saveFile(fileId, jobId);
		// };

		$scope.deleteFile = function (file) {
			if ($scope.archived) {
				messageService.showToaster('e_6', 'lead');
			} else {
				$scope.file = file;
				$('#deleteAttachmentModal').modal('show');
			}
		};

		$scope.$on('removedFileEvent', function (event) {
			$scope.$broadcast('removedData');
		});

		// initial setup
		$scope.dateFilterJobMail = "dd MMMM yyyy 'at' HH:mm";

		// $scope.mailData2Save = {};
		$scope.contractData2Send = {};
		$scope.lead2Edit = {};
		$scope.clientEmails = [];

		var clientsEmailTimer = void 0;

		// attachments
		clearQuestAttachments();
		clearContractAttachments();

		// templates for workflow tasks
		function setContractsPreview(data) {
			$scope.templates.contractEmailTemplates = angular.copy(data.emailTemplates);
			$scope.templates.contracts = angular.copy(data.contractTemplates);
		}

		function setQuestionnairesPreview(data) {
			$scope.templates.questionnaireEmailTemplates = angular.copy(data.emailTemplates);
			$scope.templates.questionnaires = angular.copy(data.questionnaireTemplates);
		}

		function setGeneralEmailsPreview(data) {
			$scope.templates.generalEmailTemplates = angular.copy(data);
		}

		$scope.getMails = function (syncReply) {
			if (syncReply) {
				$rootScope.isMailResyncInProcess = true;
			}
			var subscription = mailsDataService.getJobMails($scope.jobId, syncReply).subscribe(function (data) {
				return successGetMails(data.data, syncReply, subscription);
			}, function (error) {
				return errorGetMails(error, syncReply, subscription);
			});
		};

		function successGetMails(data, syncReply, subscription) {
			var lastSyncResult = data.lastSyncResult,
			    mails = data.mails;

			$scope.job.mails = mails;

			// check if google gmail service synchronized
			if (lastSyncResult && lastSyncResult != null) {
				// Show time for synchronized block
				$scope.isGoogleMailSynchronized = true;
				$scope.googleMailLastSyncDate = lastSyncResult.replySynchronizedAt;

				if (syncReply) {
					showCorrectMessage(lastSyncResult);
				}
			}

			if (syncReply) {
				$rootScope.isMailResyncInProcess = false;
			}

			subscription.unsubscribe();
		}

		function showCorrectMessage(lastSyncResult) {
			var status = lastSyncResult.status.toLowerCase();
			var messageType = messageService.getCorrectMessageType(status);

			if (status === 'ok') {
				messageService.showToaster('s_0', 'email');
			} else {
				messageService.showMessageFromBackend(messageType, lastSyncResult.messageDetails.title, lastSyncResult.messageDetails.message);
			}
		}

		function errorGetMails(error, syncReply, subscription) {
			if (syncReply) {
				$rootScope.isMailResyncInProcess = false;
			}
			messageService.showDefaultErrorMessage(error);
			subscription.unsubscribe();
		}

		// ATTENTION: Temporary hotfix, to resolve SN-2444.
		function removeLeadMails(data) {
			data.job.mails = [];
			return data;
		}

		$scope.unArchivedLead = function (leadId) {
			leadDataService.unarchiveLead(leadId).subscribe(function () {
				messageService.showToaster('s_6', 'lead');
				leadViewRequests.getLead();
			}, function (error) {
				messageService.showDefaultErrorMessage(error);
			});
		};
		$scope.archivedLead = function (leadId) {
			leadDataService.archiveLead(leadId).subscribe(function () {
				messageService.showToaster('s_5', 'lead');
				leadViewRequests.getLead();
			}, function (error) {
				var errorMessage = error.error.errorMessage;

				if (errorMessage.includes('Lead contains invoices.')) {
					messageService.showToaster('e_4', 'lead');
				} else {
					messageService.showDefaultErrorMessage(error);
				}
			});
		};

		$scope.$watch('primaryContact', function (newValue) {
			if (newValue) {
				$rootScope.primaryContact = $scope.primaryContact;
			}
		});

		// Contract methods
		$scope.initSendContract = function () {
			var addNewModal = $('#addNewModal');
			var DELAY = 500;

			if (addNewModal.hasClass('in')) {
				$('#addNewModal').modal('hide');
			} else {
				DELAY = 0;
			}

			templateRequestsService.getTemplates('contract_preview').subscribe(function (data) {
				successInitSendContract(data);
				$timeout(function () {
					$('#sendNewContractModal').modal('show').on('shown.bs.modal', function () {
						var input = $('#sendNewContractModal').find('input');

						validationService.isModalClosePrevented(input);
					});
				}, DELAY);
			}, function (error) {
				return messageService.showDefaultErrorMessage(error);
			});
		};

		function successInitSendContract(data) {
			$scope.initSendContractSpinningWheel = true;
			$scope.contractSendSource = data;
			$scope.contracts = $scope.contractSendSource.contractTemplates;
			$scope.contractEmailTemplates = $scope.contractSendSource.emailTemplates;
			if ($scope.contractEmailTemplates) {
				var template = $scope.contractEmailTemplates.find(function (item) {
					return item.emailTemplateType === 'CONTRACT_EMAIL_TEMPLATE';
				}) || {};

				$scope.chosenContractEmail = template;
				$scope.setContractEmailTemplate(template.id);
			}

			delete $scope.sendMessageContract;
			$scope.sendMessageContract = {};
			$scope.sendMessageContract.emailTo = $rootScope.primaryContact.email ? [$rootScope.primaryContact.email] : [];
			if ($scope.secondaryContact) {
				$scope.sendMessageContract.emailTo.push($scope.secondaryContact.email);
			}
			$scope.sendMessageContract.emailCc = [];
			$scope.initSendContractSpinningWheel = false;
		}

		$scope.showSendContract = function (jobId, jobContractId, task) {
			$routeParams.contractId = jobContractId;
			$routeParams.jobId = jobId;

			delete $scope.sendMessage;
			$scope.sendMessage = {};
			$scope.sendMessage.emailTo = $rootScope.primaryContact.email ? [$rootScope.primaryContact.email] : [];
			if ($scope.secondaryContact) {
				$scope.sendMessage.emailTo.push($scope.secondaryContact.email);
			}
			$scope.sendMessage.emailCc = [];
			$scope.sendMessage.isDisable = false;
			if (task !== undefined) {
				$scope.sendMessage.task = JSON.parse(JSON.stringify(task));
				$scope.sendMessage.jobId = jobId;
				$scope.sendMessage.sortedTasksArr = $scope.sortedTasksArr;
				$scope.sendMessage.isDisable = true;
			}

			templateRequestsService.getTemplates('contract_preview').subscribe(function (data) {
				return successShowSendContract(data);
			});

			if (jobContractId) {
				contractsDataService.getContract(jobId, jobContractId).subscribe(function (result) {
					$scope.contract = result.contract;
					$scope.$evalAsync();
				}, function (err) {
					return messageService.showDefaultErrorMessage(err);
				});
			}
		};

		function successShowSendContract(data) {
			$scope.contractSendSource = data;
			$scope.contractEmailTemplates = $scope.contractSendSource.emailTemplates;
			if ($scope.contractEmailTemplates && $scope.contractEmailTemplates.length > 0) {
				var template = $scope.contractEmailTemplates.find(function (item) {
					return item.emailTemplateType === 'CONTRACT_EMAIL_TEMPLATE';
				}) || {};
				$scope.chosenContractEmail = template;
				$scope.setContractEmailTemplate(template.id);
			}
			$('#sendContractModal').modal('show').on('shown.bs.modal', function () {
				var input = $('#sendContractModal').find('input');

				validationService.isModalClosePrevented(input);
			});
		}

		$scope.showSendContractModal = function (e) {
			$scope.contractData2Send = undefined;

			var addNewModal = $('#addNewModal');
			var DELAY = 500;

			if (addNewModal.hasClass('in')) {
				$('#addNewModal').modal('hide');
			} else {
				DELAY = 0;
			}

			templateRequestsService.getTemplates('contract_preview').subscribe(function (data) {
				$scope.contractData2Send = angular.copy(data);
				$scope.contractData2Send.contracts = data.contractTemplates;
				$scope.contractData2Send.contractEmailTemplates = data.emailTemplates;
				$scope.contractData2Send.mailSignature = data.signature || '';
				$scope.contractData2Send.emailTo = $rootScope.primaryContact.email;
				$scope.contractData2Send.jobId = $scope.job.id;

				if (!$scope.$$phase) {
					$scope.$apply();
				}

				$timeout(function () {
					$('#sendFirstContractModal').modal('show');
				}, DELAY);
			}, function (err) {
				return messageService.showDefaultErrorMessage(err);
			});
		};

		$scope.editContract = function (id, e) {
			if (id && !$scope.updatedContract) {
				var editContractTemplateCallback = function editContractTemplateCallback(data) {
					$scope.editableContract = angular.copy(data);
				};

				templateRequestsService.getTemplates('contract_full', id).subscribe(function (data) {
					return editContractTemplateCallback(data);
				}, function (error) {
					return showGeneralErrorMessage(error);
				});
			} else if ($scope.updatedContract) {
				$scope.editableContract = angular.copy($scope.updatedContract);
			} else if (!$scope.editableContract) {
				$scope.editableContract = {
					text: ''
				};
			}
			utilsService.showNextModal('#sendNewContractModal', '#editContractModal', e);
		};

		$scope.closeEditContract = function () {
			$('#editContractModal').modal('hide').on('hidden.bs.modal', function () {
				$('#sendNewContractModal').modal('show');
				$scope.editableContract = null;
				$(this).off('hidden.bs.modal');
			});
		};

		$scope.saveEditedContract = function () {
			if (!contractService.contractTextValid($scope.editableContract.text)) {
				return;
			}

			$scope.isEditContractModalSpinnningWheelActive = true;
			var contractName = stringModifierService.cutSelectedText($scope.editableContract.name);
			messageService.showToaster('s_2', 'contractTemplates', contractName);
			$('#editContractModal').modal('hide').on('hidden.bs.modal', function () {
				$scope.updatedContract = $scope.editableContract;
				$('#sendNewContractModal').modal('show');
				$(this).off('hidden.bs.modal');
				$scope.isEditContractModalSpinnningWheelActive = false;
			});
		};

		$scope.setContractEmailTemplate = function (id) {
			var contractSetEmailCallback = function contractSetEmailCallback(data) {
				$scope.contractEmailTemplate = angular.copy(data);
				if (data.storedAttachments && data.storedAttachments.length) {
					$scope.attachmentsDataContract = {
						attachments: fileUploadService.convertAttachmentsToShow(data.storedAttachments)
					};
				} else {
					clearContractAttachments();
				}
			};
			templateRequestsService.getTemplates('full_template', id).subscribe(function (data) {
				return contractSetEmailCallback(data);
			}, function (error) {
				return showGeneralErrorMessage(error);
			});
		};

		$scope.sendNewContractEmail = function (chosenContract, updatedContract, contractEmailTemplate) {
			var maxSize = 10; // 10Mb

			if ($scope.attachmentsDataContract && $scope.attachmentsDataContract.filesSize > maxSize) {
				messageService.showToaster('w_0', 'attachments');
				$scope.initSendContractSpinningWheel = false;
				return false;
			}

			var _emailText = '';

			if (validationService.isStringEmpty(contractEmailTemplate.subject)) {
				messageService.showToaster('e_10', 'emailTemplate');
				return;
			}

			if ($scope.sendMessage && $scope.sendMessage.emailText) {
				_emailText = $scope.sendMessage.emailText;
			} else {
				_emailText = $('.in .textarea-quad textarea').val();
			}

			if (!$scope.sendMessage) {
				$scope.sendMessage = {};
			}

			$scope.sendMessage.emailText = $rootScope.addMaiStyling(_emailText);

			if (validateNewContractEmail(contractEmailTemplate, updatedContract, chosenContract)) {
				$scope.sendMessageContract.emailSubject = contractEmailTemplate.subject;

				var mailData = emailService.prepareEmails($scope.sendMessageContract);

				if (!emailService.validateMails(mailData)) {
					return;
				}

				$scope.emailDataToSaveContract = Object.assign({}, $scope.sendMessageContract, mailData);
				delete $scope.emailDataToSaveContract.emailCc;

				var obj2save = angular.copy($scope.emailDataToSaveContract);
				var emailCC2save = $scope.showCcField ? obj2save.ccEmails : '';
				var contract2Save = updatedContract ? updatedContract.text : chosenContract.text;

				var data = {
					emailTo: $scope.emailDataToSaveContract.emailTo,
					emailText: contractEmailTemplate.text,
					emailSubject: contractEmailTemplate.subject,
					contractId: chosenContract ? chosenContract.templateId : null,
					jobId: $scope.job.id,
					templateId: contractEmailTemplate.id
				};

				if ($scope.emailDataToSaveContract.secondaryToEmails) {
					data.secondaryToEmails = $scope.emailDataToSaveContract.secondaryToEmails;
				}

				if (emailCC2save) {
					data.ccEmails = emailCC2save;
				}

				if (contract2Save) {
					data.contractText = contract2Save;
				}

				$scope.button_disable = true;
				leadViewRequests.sendNewContractEmail(data, function (data) {
					if (data) {
						var errorMessage = data.errorMessage,
						    errorTitle = data.errorTitle;

						if (errorMessage) {
							messageService.showErrorFromBackend(errorTitle, errorMessage);
							$scope.button_disable = false;
							return;
						}
					}

					leadViewRequests.getLead();
					$scope.button_disable = false;
					$('#sendNewContractModal').modal('hide');

					$scope.showCcField = false;
					$scope.$evalAsync();
					$('#sendNewQuestionnaireModal').modal('hide');

					for (var prop in $scope.sendMessage) {
						$scope.sendMessage[prop] = '';
					}
					for (var _prop in $scope.sendMessageContract) {
						$scope.sendMessageContract[_prop] = '';
					}

					if ($scope.attachmentsDataContract && $scope.attachmentsDataContract.attachments) {
						if ($scope.attachmentsDataContract.attachments.length) {
							$scope.attachmentsDataContract.attachments.length = 0;
						}
					}

					// toastr.success("Contract successfully sent!")
					messageService.showToaster('s_4', 'jobView');
				}, function (_ref3) {
					var status = _ref3.status,
					    data = _ref3.data;

					$scope.button_disable = false;
					var path = $location.path();
					var errorMessage = data.errorMessage;

					if (status >= 400 && status < 500 && errorMessage) {
						if (status == 423) {
							var limit = $rootScope.isUserTrial ? 50 : 150;
							return messageService.showToaster('e_4', 'generalValidation', limit);
						} else if (errorMessage.includes('Email address inactive')) {
							messageService.showToaster('e_1', 'generalValidation', $scope.sendMessageContract.emailTo);
						} else if (path.includes('leads')) {
							messageService.showToaster('e_0', 'contract');
						} else {
							messageService.showToaster('e_2', 'general', errorMessage);
						}
					}
					// else {
					//     messageService.showToaster('e_0', 'general');
					// }
				});
			}
		};

		function validateNewContractEmail(emailTemplate, updatedContract, chosenContract) {
			if (!updatedContract && !chosenContract) {
				messageService.showToaster('w_0', 'jobView');
				return false;
			}

			if (!emailTemplate) {
				messageService.showToaster('e_0', 'general');
				return false;
			}

			if (!emailTemplate.subject) {
				messageService.showToaster('e_5', 'workflow');
				return false;
			}

			if (!emailTemplate.text || !emailTemplate.text.includes('%contract_link%')) {
				messageService.showToaster('e_2', 'emailTemplate');
				return false;
			}

			return true;
		}

		// modal mail
		$scope.setClientMail = function (clientMailData, jobMailData) {
			$scope.clientMailData = clientMailData;
			$scope.mailData2Save = jobMailData;
		};

		$scope.sendNewMailEmail = function (chosenContract, updatedContract, contractEmailTemplate) {
			var maxSize = 10; // 10Mb

			if ($scope.attachmentsDataContract && $scope.attachmentsDataContract.filesSize > maxSize) {
				messageService.showToaster('w_0', 'attachments');
				$scope.initSendContractSpinningWheel = false;
				return false;
			}

			var _emailText = '';

			if ($scope.sendMessage && $scope.sendMessage.emailText) {
				_emailText = $scope.sendMessage.emailText;
			} else {
				_emailText = $('.in .textarea-quad textarea').val();
			}

			if (!$scope.sendMessage) {
				$scope.sendMessage = {};
			}

			$scope.sendMessage.emailText = $rootScope.addMaiStyling(_emailText);

			var obj2save = angular.copy($scope.sendMessageContract);
			var emailCC2save = $scope.showCcField ? obj2save.emailCc : '';

			var data = {
				emailTo: $scope.sendMessage.emailTo,
				emailCc: emailCC2save,
				emailText: contractEmailTemplate.text,
				emailSubject: contractEmailTemplate.subject,
				jobId: $scope.job.id,
				templateId: contractEmailTemplate.id
			};

			$scope.button_disable = true;
			var url = '/api/user/lead/' + id + '/send/5/';

			$http({
				method: 'POST',
				url: url,
				data: data,
				transformRequest: angular.identity,
				headers: {
					'Content-Type': undefined
				}
			});
		};

		// Invoice methods
		$scope.showSendInvoice = function (invoiceId) {
			$routeParams.id = invoiceId;

			delete $scope.sendMessage;
			$scope.sendMessage = {};
			$scope.sendMessage.addInvoiceAttachment = true;

			templateRequestsService.getTemplates('all').subscribe(function (data) {
				if (data) {
					$scope.emails = data;
					if ($scope.emails && $scope.emails.length > 1) {
						$scope.choosenEmail = $scope.emails.find(function (item) {
							return item.emailTemplateType === 'INVOICE_EMAIL_TEMPLATE';
						}) || {};
					}

					$scope.sendMessage.emailTo = $rootScope.primaryContact.email;
					$scope.sendMessage.emailCc = '';
					$('#sendInvoiceModal').modal('show', {
						primaryContact: $scope.primaryContact,
						secondaryContact: $scope.secondaryContact
					}).on('shown.bs.modal', function () {
						var input = $(this).find('input');
						var select = $(this).find('select');

						validationService.isModalClosePrevented(input);
						validationService.isModalClosePrevented(select);
					});
				}
			}, function (err) {
				return messageService.showDefaultErrorMessage(err);
			});
		};

		$scope.createNewInvoice = function (leadId) {
			$scope.createNewInvoiceSpinningWheel = true;
			if ($scope.fundyIntegration || $scope.proSelectIntegration) {
				$('#leadsAddNewInvoiceModal').modal('show').on('shown.bs.modal', function () {
					$scope.createNewInvoiceSpinningWheel = false;
				});
			} else {
				goToNewPayment('/leads/' + leadId + '/invoice/new');
			}
		};

		$scope.redirectToNewInvoice = function (leadId) {
			$scope.integrationInvoiceLoadXml = true;
			goToNewPayment('/leads/' + leadId + '/invoice/new');
		};

		$scope.openFundyFileUploadModal = function (event) {
			event.preventDefault();
			document.getElementById('fundyUpload').click();
		};

		$scope.openProSelectFileUploadModal = function (event) {
			event.preventDefault();
			document.getElementById('proSelectUpload').click();
		};

		$scope.addNewInvoiceFromModal = function (leadId) {
			if ($scope.fundyIntegration || $scope.proSelectIntegration) {
				$scope.createNewInvoiceSpinningWheel = true;
				var selectModal = '#addNewModal';
				var nextModal = '#leadsAddNewInvoiceModal';
				utilsService.showNextModal(selectModal, nextModal);
				$timeout(function () {
					$scope.createNewInvoiceSpinningWheel = false;
				}, 1000);
			} else {
				goToNewPayment('/leads/' + leadId + '/invoice/new');
			}
		};

		$scope.importInvoiceFromFundy = function (item) {
			$scope.integrationInvoiceLoadXml = true;
			var jobid = $scope.job.id;
			fileUploadDataService.sendFundyXmlFile(item, jobid).finally(function () {
				$scope.integrationInvoiceLoadXml = false;
			}).subscribe(function (result) {
				$scope.integrationInvoiceLoadXml = false;
				var invoiceId = result.invoiceId;
				messageService.showToaster('s_2', 'fundy');
				$('#leadsAddNewInvoiceModal').modal('hide');
				goToLocation('/invoices/' + invoiceId);
			});
		};

		$scope.importInvoiceFromProSelect = function (item) {
			$scope.integrationInvoiceLoadXml = true;
			var jobid = $scope.job.id;
			fileUploadDataService.sendProSelectXmlFile(item, jobid).finally(function () {
				$scope.integrationInvoiceLoadXml = false;
			}).subscribe(function (result) {
				$scope.integrationInvoiceLoadXml = false;
				var invoiceId = result.invoiceId;
				messageService.showToaster('s_2', 'proSelect');
				$('#leadsAddNewInvoiceModal').modal('hide');
				goToLocation('/invoices/' + invoiceId);
			});
		};

		function calculateInvoices() {
			$scope.paymentsTotal = 0;
			$scope.paymentsBalanceDue = 0;
			$scope.recentInvoice = null;
			$scope.nextInvoice = null;
			$scope.job.payments = $filter('orderBy')($scope.job.invoices, 'invoiceDue', false);

			if ($scope.job && $scope.job.payments) {
				angular.forEach($scope.job.payments, function (value, key) {
					$scope.paymentsTotal += value.amount;
					if (value.editable) {
						if ($scope.nextInvoice == null) {
							$scope.nextInvoice = value;
						}
						$scope.paymentsBalanceDue += value.amount;
					} else if ($scope.recentInvoice == null) {
						$scope.recentInvoice = value;
					}
				});
				if ($scope.recentInvoice == null) {
					$scope.recentInvoice = $scope.nextInvoice;
				}
			}
		}

		// Quotes methods
		$scope.showNewQuote = function () {
			var selectModal = '#addNewModal';
			var nextModal = '#addNewQuoteTypeModal';
			utilsService.showNextModal(selectModal, nextModal);
		};

		$scope.createNewQuote = function (quoteType) {
			goToNewPayment('/leads/' + $scope.leadId + '/quote/' + quoteType + '/new');
		};

		$scope.showAddNewQuoteModal = function () {
			$('#addNewQuoteTypeModal').modal('show');
		};

		// Questionnaire methods
		$scope.initSendQuestionnaire = function () {
			$('#sendFirstQuestionnaireMessageData_emailCc').val('');

			var addNewModal = $('#addNewModal');
			var DELAY = 500;

			if (addNewModal.hasClass('in')) {
				$('#addNewModal').modal('hide');
			} else {
				DELAY = 0;
			}

			templateRequestsService.getTemplates('questionnaire_preview').subscribe(function (data) {
				successInitSendQuestionnaire(data);
				$timeout(function () {
					$('#sendNewQuestionnaireModal').modal('show').on('shown.bs.modal', function () {
						var input = $('#sendNewQuestionnaireModal').find('input');

						validationService.isModalClosePrevented(input);
					});
				}, DELAY);
			});
		};

		function successInitSendQuestionnaire(data) {
			$scope.initSendQuestionnaireSpinningWheel = true;
			$scope.questionnaireSendSource = data;
			$scope.questionnaires = $scope.questionnaireSendSource.questionnaireTemplates;
			$scope.questionnaireEmailTemplates = $scope.questionnaireSendSource.emailTemplates;

			var template = $scope.questionnaireEmailTemplates.find(function (item) {
				return item.emailTemplateType === 'QUESTIONNAIRE_EMAIL_TEMPLATE';
			}) || {};

			$scope.choosenQuestionnaireEmail = template;

			if ($scope.questionnaireEmailTemplates) {
				$scope.setQuestionnaireEmailTemplate(template.id);
			}

			delete $scope.sendMessageQuestion;
			$scope.sendMessageQuestion = {};
			$scope.sendMessageQuestion.emailTo = $rootScope.primaryContact.email ? [$rootScope.primaryContact.email] : [];
			if ($scope.secondaryContact) {
				$scope.sendMessageQuestion.emailTo.push($scope.secondaryContact.email);
			}
			$scope.sendMessageQuestion.emailCc = [];
			$scope.initSendQuestionnaireSpinningWheel = false;
		}

		$scope.setEmailData = function (newData, object, property) {
			$scope[object][property] = newData;
		};

		$scope.showSendQuestionnaire = function (jobId, questionnaireId, task) {
			$rootScope.showCcField = false;
			$routeParams.questionnaireId = questionnaireId;
			$routeParams.jobId = jobId;
			$scope.sendMessage = {};
			$scope.sendMessage.emailTo = $rootScope.primaryContact.email ? [$rootScope.primaryContact.email] : [];
			if ($scope.secondaryContact) {
				$scope.sendMessage.emailTo.push($scope.secondaryContact.email);
			}
			$scope.sendMessage.emailCc = [];
			$scope.isDisable = false;
			if (task !== undefined) {
				$scope.task = JSON.parse(JSON.stringify(task));
				$scope.sortedTasksArrQuestionnarie = $scope.sortedTasksArr;
				$scope.isDisable = true;
			}
			templateRequestsService.getTemplates('questionnaire_preview').subscribe(function (data) {
				return successShowSendQuestionnaire(data);
			});
		};

		function successShowSendQuestionnaire(data) {
			$scope.questionnaireSendSource = data;
			$scope.questionnaireEmailTemplates = data.emailTemplates;

			var template = $scope.questionnaireEmailTemplates.find(function (item) {
				return item.emailTemplateType === 'QUESTIONNAIRE_EMAIL_TEMPLATE';
			}) || {};

			$scope.choosenQuestionnaireEmail = template;
			$scope.setQuestionnaireEmailTemplate(template.id);

			$('#sendQuestionnaireModal').modal('show').on('shown.bs.modal', function () {
				var input = $('#sendQuestionnaireModal').find('input');

				validationService.isModalClosePrevented(input);
			});
		}

		$scope.setQuestionnaireEmailTemplate = function (id) {
			var questionnaireSetEmailCallback = function questionnaireSetEmailCallback(data) {
				$scope.questionnaireEmail = angular.copy(data);
				if (data.storedAttachments && data.storedAttachments.length) {
					$scope.attachmentsDataQueston = {
						attachments: fileUploadService.convertAttachmentsToShow(data.storedAttachments)
					};
				} else {
					clearQuestAttachments();
				}
			};

			templateRequestsService.getTemplates('full_template', id).subscribe(function (data) {
				return questionnaireSetEmailCallback(data);
			}, function (error) {
				return showGeneralErrorMessage(error);
			});
		};

		$scope.sendNewQuestionnaireEmail = function (chosenQuestionnaire, questionnaireEmailTemplate) {
			var maxSize = 10; // 10Mb

			if ($scope.attachmentsDataQueston && $scope.attachmentsDataQueston.filesSize > maxSize) {
				messageService.showToaster('w_0', 'attachments');
				$scope.initSendQuestionnaireSpinningWheel = false;
				$scope.button_disable = false;
				return false;
			}

			if (validationService.isStringEmpty(questionnaireEmailTemplate.subject)) {
				messageService.showToaster('e_10', 'emailTemplate');
				return;
			}

			if ($scope.questionnaireEmail && $scope.questionnaireEmail.text && chosenQuestionnaire) {
				if (questionnaireEmailTemplate && questionnaireEmailTemplate.text && questionnaireEmailTemplate.subject) {
					questionnaireEmailTemplate.text = $rootScope.addMaiStyling(questionnaireEmailTemplate.text);

					$scope.sendMessageQuestion.emailSubject = questionnaireEmailTemplate.subject;

					var mailData = emailService.prepareEmails($scope.sendMessageQuestion);

					if (!emailService.validateMails(mailData)) {
						return;
					}

					$scope.emailDataToSaveQuestion = Object.assign({}, $scope.sendMessageQuestion, mailData);
					delete $scope.emailDataToSaveQuestion.emailCc;

					var obj2save = angular.copy($scope.emailDataToSaveQuestion);
					var emailCC2save = $scope.showCcField ? obj2save.ccEmails : '';

					var data = {
						emailTo: $scope.emailDataToSaveQuestion.emailTo,
						emailText: questionnaireEmailTemplate.text,
						emailSubject: questionnaireEmailTemplate.subject,
						questionnaireTemplateId: chosenQuestionnaire.id || null,
						jobId: $scope.job.id,
						templateId: questionnaireEmailTemplate.id
					};

					if ($scope.emailDataToSaveQuestion.secondaryToEmails) {
						data.secondaryToEmails = $scope.emailDataToSaveQuestion.secondaryToEmails;
					}

					if (emailCC2save) {
						data.ccEmails = emailCC2save;
					}

					$scope.button_disable = true;
					leadViewRequests.sendNewQuestionnaireEmail(data, function (data) {
						if (data) {
							var errorMessage = data.errorMessage,
							    errorTitle = data.errorTitle;

							if (errorMessage) {
								messageService.showErrorFromBackend(errorTitle, errorMessage);
								$scope.button_disable = false;
								return;
							}
						}

						leadViewRequests.getLead();
						$scope.button_disable = false;
						$scope.showCcField = false;
						$scope.$evalAsync();
						$('#sendNewQuestionnaireModal').modal('hide');

						for (var prop in $scope.sendMessageQuestion) {
							$scope.sendMessageQuestion[prop] = '';
						}
						if ($scope.attachmentsDataQueston && $scope.attachmentsDataQueston.attachments) {
							if ($scope.attachmentsDataQueston.attachments.length) {
								$scope.attachmentsDataQueston.attachments.length = 0;
							}
						}
						messageService.showToaster('s_9', 'jobView');
					}, function (_ref4) {
						var status = _ref4.status,
						    data = _ref4.data;

						$scope.button_disable = false;
						var path = $location.path();
						var errorMessage = data.errorMessage;

						if (status >= 400 && status < 500 && errorMessage) {
							if (status == 423) {
								var limit = $rootScope.isUserTrial ? 50 : 150;
								messageService.showToaster('e_4', 'generalValidation', limit);
							} else if (errorMessage.includes('Email address inactive')) {
								messageService.showToaster('e_1', 'generalValidation', $scope.sendMessageQuestion.emailTo);
							} else if (path.includes('leads')) {
								messageService.showToaster('e_0', 'questionnaires');
							} else {
								messageService.showToaster('e_2', 'general', errorMessage);
							}
						}
						// else {
						//     messageService.showToaster('e_0', 'general');
						// }
					});
				} else {
					// toastr.warning("Fill data first");
					messageService.showToaster('w_0', 'jobView');
				}
			} else {
				// toastr.warning("Fill data first");
				messageService.showToaster('w_0', 'jobView');
			}
		};

		// Notes methods
		$scope.showEditNotesModal = function () {
			$scope.editNotes = $scope.job.notes || '';
			$('#updateModal').modal('show');
		};

		$scope.saveNotes = function () {
			$scope.isSaveNotesSpinnningWheelActive = true;
			var notesTmp = $rootScope.addMaiStyling($scope.editNotes);

			var data4Save = {
				id: $scope.job.id,
				notes: notesTmp
			};

			notesDataService.saveNotes(data4Save, false).finally(function () {
				$scope.isSaveNotesSpinnningWheelActive = false;
			}).subscribe(function (data) {
				var message = data.message,
				    errorMessage = data.errorMessage;


				if (message) {
					messageService.showToaster('s_3', 'jobView');
					$('#updateModal').modal('hide');
					// $rootScope.updateEditJobModalData = true;
					$scope.job.notes = notesTmp;
					$scope.job2Edit.notes = notesTmp;
				} else {
					toastr.error(errorMessage);
				}
			}, function (err) {
				return messageService.showDefaultErrorMessage(err);
			});
		};

		// Email methods
		$scope.openSendEmailForReply = function () {
			utilsService.closeAllModalsAndOpenNew('#sendContactEmailModal');
		};

		$scope.showSendEmailModal = function (leadId, task, selectedContact) {
			delete $scope.mailData2Save;
			delete $scope.clientMailData;

			Rx.Observable.zip(templateRequestsService.getTemplates('general_preview'), templateRequestsService.getTemplates('email_signature')).takeUntil($scope.unsubscribe).finally(function () {
				return $scope.showSendEmailModalSpinningWheel = false;
			}).subscribe(function (_ref5) {
				var _ref6 = _slicedToArray(_ref5, 2),
				    emails = _ref6[0],
				    mailSignature = _ref6[1];

				selectedContact ? $scope.mailData2Save = angular.copy(selectedContact) : $scope.mailData2Save = angular.copy($scope.primaryContact);

				$scope.mailData2Save.emails = emails;
				$scope.mailData2Save.mailSignature = mailSignature.signature || '';
				if (!selectedContact && $scope.secondaryContact) {
					$scope.mailData2Save.secondaryEmail = $scope.secondaryContact.email;
				}
				if (task !== undefined) {
					$scope.mailData2Save.emailSubject = task.taskEmail.subject;
					$scope.mailData2Save.emailText = task.taskEmail.text;
					$scope.mailData2Save.task = JSON.parse(JSON.stringify(task));
					$scope.mailData2Save.jobId = $scope.job.id;
					$scope.mailData2Save.sortedTasksArr = $scope.sortedTasksArr;
					$scope.mailData2Save.isDisable = true;
				}

				$rootScope.clientToken = false;

				if (!$scope.$$phase) {
					$scope.$apply();
				}

				$routeParams.leadId = $scope.leadId;
				$scope.leadId = leadId;
				$('#sendContactEmailModal').modal('show');
			});
		};

		$scope.showSendModal = function (task) {
			if (task.completed === true) {
				switch (task.action) {
					case 'SEND_EMAIL':
						$scope.showSendEmailModal($scope.leadId, task);
						break;
					case 'SEND_QUESTIONNAIRE':
						$scope.tickTask = true;
						$scope.tickTaskType = 'QUESTIONNAIRE';
						openEditAutomationTask(task);
						break;
					case 'SEND_CONTRACT':
						$scope.tickTask = true;
						$scope.tickTaskType = 'CONTRACT';
						openEditAutomationTask(task);
						break;
				}
			}
		};

		function openEditAutomationTask(task) {
			workflowService.setTaskInfo(task, $scope.job.workflow.tasks, true);
			$('#addAutomationModal').modal('show');
		}

		$scope.disableDragDrop = function () {
			return true;
		};

		$scope.retrySendMail = function () {
			leadViewRequests.getLead();
			emailService.callLastEmailFn();
		};

		$scope.addSubjectVariable = function ($event, id, type) {
			var el = document.getElementById(id);
			var subject = emailService.addSubjectVariable(el, $event);
			if ($scope.sendMessage) {
				$scope.sendMessage.emailSubject = subject;
			}

			if (type === 'QUESTIONNAIRE') {
				$scope.questionnaireEmail.subject = subject;
			}

			if (type === 'CONTRACT') {
				$scope.contractEmailTemplate.subject = subject;
			}
		};

		$scope.toggleViewCc = function (state) {
			if ($scope.sendMessage && $scope.sendMessage.emailCc) {
				$scope.sendMessage.emailCc = '';
				$scope.$evalAsync();
			}

			$scope.showCcField = state !== undefined ? state : !$scope.showCcField;

			if (state === false) {
				clearQuestAttachments();
				clearContractAttachments();
			}
		};

		// attachments

		function setAttachments(attachments) {
			$scope.files = fileUploadService.setAttachmentsFromServer(attachments);
			fileUploadDataService.setAttachmentsFromServer(attachments);
			$scope.$broadcast('addedFileEvent');
		}

		function clearContractAttachments() {
			$scope.attachmentsDataContract = {
				attachments: [],
				filesSize: 0
			};
		}

		function clearQuestAttachments() {
			$scope.attachmentsDataQueston = {
				attachments: [],
				filesSize: 0
			};
		}

		// Workflow methods
		$scope.getWorkflow = function () {
			if (!$scope.job || $scope.job.id === null || $scope.job.id === undefined) {
				return false;
			}
			workflowService.getJobWorkflow($scope.job.id, successGetWorkflow);
		};

		function successGetWorkflow(workflow) {
			$scope.job.workflow = workflow;
			prepareTasks();
		}

		var fillWorkflowTasks = function fillWorkflowTasks() {
			var taskList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

			var _workflowService$fill = workflowService.fillWorkflowTasks(taskList);

			var _workflowService$fill2 = _slicedToArray(_workflowService$fill, 3);

			$scope.lead = _workflowService$fill2[0];
			$scope.production = _workflowService$fill2[1];
			$scope.postProduction = _workflowService$fill2[2];
		};

		var handleTask = function handleTask(task, taskTypes) {
			if (task.dateItem) {
				task.dateItem = task.dateItem.toLowerCase();
			}

			if (task.due && !task.hasDue) {
				// for old workflows
				task.hasDue = true;
			}

			if (!task.action && task.taskEmail) {
				// for old workflows
				task.action = 'SEND_EMAIL';
			}

			if (task.calendarEventType === 'MAIN_SHOOT') {
				var _$scope$job = $scope.job,
				    startDate = _$scope$job.startDate,
				    finishDate = _$scope$job.finishDate,
				    startTime = _$scope$job.startTime,
				    finishTime = _$scope$job.finishTime,
				    location = _$scope$job.location;

				task.location = location;
				task.startDate = startDate;
				task.endDate = finishDate;
				task.startTime = startTime;
				task.endTime = finishTime;
			} else if (task.calendarEvent) {
				var _task$calendarEvent = task.calendarEvent,
				    _startDate = _task$calendarEvent.startDate,
				    endDate = _task$calendarEvent.endDate,
				    _startTime = _task$calendarEvent.startTime,
				    endTime = _task$calendarEvent.endTime,
				    _location = _task$calendarEvent.location,
				    clientId = _task$calendarEvent.clientId;

				task.location = _location;
				task.startDate = _startDate;
				task.endDate = endDate;
				task.startTime = _startTime;
				task.endTime = endTime;
				task.sendEmails = clientId ? task.calendarEvent.sendEmails : false;

				if (task.startDate && (task.startTime === null || task.finishTime === null)) {
					task.allday = true;
				}
			}

			task.overdueDays = workflowService.calcTaskOverdue(task.overdueDays);
			task.taskViewDue = workflowService.getTaskViewDue(task, taskTypes);
			task.taskDueDefault = task.defaultTask && task.dueDate ? task.dueDate : null;
		};

		var getSortedTasks = function getSortedTasks() {
			return [$scope.lead, $scope.production, $scope.postProduction];
		};

		function prepareTasks() {
			if (!$scope.job.workflow) {
				return false;
			}

			var taskList = angular.copy($scope.job.workflow.tasks);
			taskList = $filter('orderBy')($scope.job.workflow.tasks, 'number', false);
			fillWorkflowTasks(taskList);

			$scope.sortedTasksArr = getSortedTasks();
			$scope.job.workflow.tasks.forEach(function (item) {
				return handleTask(item, $scope.sortedTasksArr);
			});
			if ($scope.job.showNewTaskId) {
				$timeout(function () {
					var newTask = taskList.find(function (task) {
						return task.id === $scope.job.showNewTaskId;
					});
					var taskToAnimate = '.task-' + newTask.number;
					$rootScope.$broadcast('animateTask', taskToAnimate);
					// next line removes parameters from route
					$location.search({}).replace();
				}, 0);
			}
			$scope.correctSortedTasksArray = angular.copy($scope.sortedTasksArr);
		}

		$scope.updateViewAndRenewWorkflow = function (tasks) {
			$scope.updateLeadView();
			$scope.renewWorkflow(tasks);
		};

		$scope.renewWorkflow = function (tasks) {
			var taskList = angular.copy(tasks);
			taskList = $filter('orderBy')(tasks, 'number', false);
			fillWorkflowTasks(taskList);
			$scope.sortedTasksArr = getSortedTasks();
			taskList.forEach(function (item) {
				return handleTask(item, $scope.sortedTasksArr);
			});
			$scope.correctSortedTasksArray = angular.copy($scope.sortedTasksArr);
		};

		$scope.showWarningModal = function (task) {
			if (task) {
				emailService.emitClientToCheckSubscription($scope.primaryContact);
				emailService.checkIfEmailAllowedWeb($scope.primaryContact, $scope.changeTaskState, this, [task]);
				$scope.retryTask = task;
			}
		};

		$scope.cancelAutomation = function () {
			if ($scope.retryTask) {
				$scope.retryTask.completed = false;
			}
		};

		$scope.changeTaskState = function (task) {
			$rootScope.dnd.canMove = false;

			newJobsDataService.changeTaskState($scope.job.id, task).finally(function () {
				$rootScope.dnd.canMove = true;
				leadViewRequests.getLead();
			}).subscribe(function (data) {
				toastr.clear();
				messageService.showToaster('i_0', 'jobView');
				task = Object.assign(task, data);
				handleTask(task, $scope.sortedTasksArr);
			}, function (result) {
				toastr.clear();
				messageService.showDefaultErrorMessage(result);
			});
		};

		$scope.changeToLeadOrJob = function (task) {
			$('#modalChangeLead').modal('show');
			$scope.newTaskCreate = Object.assign(task);
		};

		// Client methods
		function setContacts() {
			var _$scope$job2 = $scope.job,
			    primaryContact = _$scope$job2.primaryContact,
			    secondaryContact = _$scope$job2.secondaryContact;

			$scope.primaryContact = primaryContact;

			if (secondaryContact) {
				$scope.secondaryContact = secondaryContact;
			}
		}

		$scope.chooseContract = function () {
			$scope.updatedContract = null;
		};

		$scope.editClient = function (client) {
			$scope.clientForEdit = angular.copy(client);
			$scope.companyNameChecked = !!$scope.clientForEdit.companyName || !!$scope.clientForEdit.businessNumber;
			$('#editClientModal').modal('show').on('shown.bs.modal', function () {
				var input = $(this).find('input');

				validationService.isModalClosePrevented(input);
			});
		};

		var successSaveClient = function successSaveClient(data) {
			if (data.errorMessage) {
				toastr.error(data.errorMessage, 'Error');
				$scope.isCreateClientModalSpinnningWheelActive = false;
			} else {
				toastr.success(data.message, 'Success');
				$('#editClientModal').modal('hide');
				delete $scope.clientForEdit;
				leadViewRequests.getLead();
				$scope.isCreateClientModalSpinnningWheelActive = false;
			}
		};

		var errorSaveClient = function errorSaveClient(_ref7) {
			var status = _ref7.status,
			    data = _ref7.data;

			var errorMessage = data.errorMessage;
			var errorCode = void 0,
			    errorPlace = void 0,
			    value = void 0;

			if (status >= 400 && status < 500 && errorMessage) {
				if (errorMessage === 'Job contact cannot be changed because invoice has Xero payment') {
					errorCode = 'e_10';
					errorPlace = 'xero';
				} else if (errorMessage === 'Sorry, this customer has been deleted on QuickBooks') {
					errorCode = 'e_23';
					errorPlace = 'qb';
				} else if (errorMessage.includes('already registered')) {
					errorCode = 'e_8';
					errorPlace = 'clients';
					value = $scope.clientForEdit.email;
				} else {
					errorCode = 'e_2';
					errorPlace = 'general';
					value = errorMessage;
				}
			}

			messageService.showToaster(errorCode, errorPlace, value);
		};

		$scope.saveClient = function () {
			$scope.isCreateClientModalSpinnningWheelActive = true;
			if (!$scope.clientForEdit.id) {
				console.error('No client id');
				$scope.isCreateClientModalSpinnningWheelActive = false;
				return;
			}

			if (!validationService.isEmailValid($scope.clientForEdit.email)) {
				console.log('invalid lead');
				$scope.isCreateClientModalSpinnningWheelActive = false;
				return messageService.showToaster('e_3', 'companyUsers');
			}

			if (validationService.isStringEmpty($scope.clientForEdit.firstName)) {
				$scope.isCreateClientModalSpinnningWheelActive = false;
				return messageService.showToaster('e_4', 'clients');
			}

			if (!$scope.companyNameChecked) {
				delete $scope.clientForEdit.companyName;
				delete $scope.clientForEdit.businessNumber;
			}

			if ($scope.clientForEdit.notes) {
				$scope.clientForEdit.notes = $rootScope.addMaiStyling($scope.clientForEdit.notes);
			}

			clientsDataService.updateClient($scope.clientForEdit).finally(function () {
				return $scope.isCreateClientModalSpinnningWheelActive = false;
			}).subscribe(function (data) {
				return successSaveClient(data);
			}, function (err) {
				return errorSaveClient(err);
			});
		};

		// Go-to methods
		function goToLocation(url) {
			$location.path(url);
		}

		function goToNewPayment(url) {
			var addNewModal = $('#addNewModal');
			var delay = 0;

			if (addNewModal.hasClass('in')) {
				addNewModal.modal('hide');
				delay = 500;
			}

			$timeout(function () {
				return goToLocation(url);
			}, delay);
		}

		$scope.goToQuotePage = function (leadId, quoteId) {
			return goToLocation('/leads/' + leadId + '/quote/' + quoteId);
		};

		$scope.goToInvoicePage = function (job, invoice) {
			var hasInvoices = job.hasInvoices;
			var invoiceId = invoice.invoiceId;


			if (hasInvoices) {
				goToLocation('/invoices/' + invoiceId);
			}
		};

		$scope.goToContractsPage = function (jobId, contractId) {
			return goToLocation('/jobs/view/' + jobId + '/contracts/' + contractId);
		};

		$scope.goToQuestionnairesPage = function (jobId, questionnaireId) {
			return goToLocation('/jobs/view/' + jobId + '/questionnaires/' + questionnaireId);
		};

		// Toggle modals
		$scope.showAddNewModal = function () {
			$('#addNewModal').modal('show');
		};

		$scope.showDeleteModal = function () {
			$scope.leadForDelete = $scope.leadId;
			$('#deleteModal').modal('show');
		};

		$scope.showEditJobModal = function (job) {
			$scope.button_disable = true;
			$scope.isCreateLeadSpinningWheelActive = true;

			if ($scope.job2Edit.startTime) {
				$scope.job2Edit.startTime = timeConverter.convert24to12($scope.job2Edit.startTime);
				$scope.job2Edit.finishTime = timeConverter.convert24to12($scope.job2Edit.finishTime);
			}

			var checkDefault = $scope.job2Edit.workflowNames[$scope.job2Edit.workflowNames.length - 1];
			if (checkDefault && checkDefault.name !== 'Default' && checkDefault.id !== '') {
				$scope.job2Edit.workflowNames[$scope.job2Edit.workflowNames.length] = defaultWorkflow;
			}
			$scope.$broadcast('showModal', { lead: $scope.job2Edit, jobId: job.id });

			$('#newLead').modal('show');

			$scope.isCreateLeadSpinningWheelActive = false;
			$scope.button_disable = false;
		};

		$scope.showAddNewTaskModal = function () {
			$scope.showAddNewTaskModalSpinningWheel = true;
			var addNewModal = $('#addNewModal');
			var DELAY = 500;

			if (addNewModal.hasClass('in')) {
				$('#addNewModal').modal('hide');
			} else {
				DELAY = 0;
			}

			$timeout(function () {
				$('#addWorkflowTaskModal').modal('show');
				$scope.showAddNewTaskModalSpinningWheel = false;
			}, DELAY);
		};

		$scope.showQuoteModal = function (jobId, quoteId, type) {
			$routeParams.jobId = jobId;
			$routeParams.quoteId = quoteId;

			$scope.sendMessage = {};
			$scope.sendMessage.emailTo = $rootScope.primaryContact.email;
			$scope.sendMessage.emailCc = '';

			templateRequestsService.getTemplates('all').subscribe(function (data) {
				if (data) {
					$scope.emails = data;
					if (data.length > 0) {
						$scope.choosenEmail = $scope.emails.find(function (item) {
							return item.emailTemplateType === 'QUOTE_EMAIL_TEMPLATE';
						}) || {};
					}
					$('#sendQuoteModal').modal('show', {
						primaryContact: $scope.primaryContact,
						secondaryContact: $scope.secondaryContact,
						customToken: type === 'FIXED' ? 'INVOICE_MENU' : 'JOB_MENU'
					});
				}
			});
		};

		// Job methods
		$scope.deleteLead = function () {
			$scope.deleteDisable = true;

			leadDataService.deleteLead($scope.leadForDelete).finally(function () {
				$scope.deleteDisable = false;
			}).subscribe(function () {
				messageService.showToaster('s_2', 'lead');
				$location.path('/leads').replace();
			}, function (err) {
				return errorDeleteJob(err);
			});
		};

		function errorDeleteJob(_ref8) {
			var status = _ref8.status,
			    data = _ref8.data;

			var errorMessage = data.errorMessage;
			var errorCode = void 0,
			    errorPlace = void 0,
			    value = void 0;

			if (status >= 400 && status < 500 && errorMessage) {
				if (errorMessage.includes('This payment cannot be marked as unpaid because it was overpaid in Xero.')) {
					errorCode = 'e_12';
					errorPlace = 'xero';
					value = 'job';
				} else {
					errorCode = 'e_2';
					errorPlace = 'general';
					value = errorMessage;
				}
			}
			messageService.showToaster(errorCode, errorPlace, value);
		}

		function prepareJob(job) {
			$scope.job2Edit = angular.copy(job);
			$scope.job2Edit.id = $scope.leadId;
			$scope.clients = [];

			var _$scope$job2Edit = $scope.job2Edit,
			    workflow = _$scope$job2Edit.workflow,
			    startDate = _$scope$job2Edit.startDate,
			    finishDate = _$scope$job2Edit.finishDate,
			    primaryContact = _$scope$job2Edit.primaryContact,
			    secondaryContact = _$scope$job2Edit.secondaryContact;


			$scope.job2Edit.oldWorkflow = workflow;

			if (!$scope.job2Edit.startDate) {
				$scope.job2Edit.hasNoDate = true;
			} else {
				$scope.job2Edit.hasNoDate = false;
				$scope.job2Edit.startDate = timeService.createDateAsUTC(startDate);
				//
				$scope.job2Edit.finishDate = timeService.createDateAsUTC(finishDate);
			}
			if (primaryContact) {
				var primaryClientSearchText = clientService.fillClientSearchText(primaryContact);
				$scope.clients[0] = primaryClientSearchText;
				$scope.job2Edit.primaryContact = $scope.clients[0];
			}

			if (secondaryContact) {
				var secondaryClientSearchText = clientService.fillClientSearchText(secondaryContact);
				$scope.clients[1] = secondaryClientSearchText;
				$scope.job2Edit.secondaryContact = $scope.clients[1];
			}

			if ($scope.job2Edit.startDate && ($scope.job2Edit.startTime === null || $scope.job2Edit.finishTime === null)) {
				$scope.job2Edit.allday = true;
			}

			getJobTypes();
			getWorkflowAndLanguageNames();
			$scope.$evalAsync();
		}

		function getJobTypes() {
			return jobTypesDataService.getJobTypes().finally(function () {
				return $scope.button_disable = false;
			}).subscribe(function (data) {
				return successGetJobTypes(data);
			});
		}

		function getWorkflowAndLanguageNames() {
			return workflowDataService.getWorkflowAndLanguageNames().finally(function () {
				return $scope.button_disable = false;
			}).subscribe(function (data) {
				return successGetWorkflowAndLanguageNames(data);
			});
		}

		function successGetJobTypes(data) {
			$scope.job2Edit.jobTypes = angular.copy(data);
		}

		function successGetWorkflowAndLanguageNames(data) {
			if (!data) {
				return false;
			}
			$scope.job2Edit.workflowNames = angular.copy(data.workflows);
			$scope.job2Edit.languageNames = angular.copy(data.languages);
		}

		// helper functions
		function showGeneralErrorMessage(error) {
			messageService.showToaster('e_0', 'general');
		}

		$scope.setMinWidth = function () {
			var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

			var textLength = text.length;

			if (textLength < 6) {
				return 40;
			} else if (textLength < 10) {
				return 60;
			} else if (textLength < 20) {
				return 100;
			}
			return 190;
		};

		$scope.refreshFileList = function () {
			fileUploadDataService.setFiles($scope.files, true);
		};

		$rootScope.updateLeadView = function () {
			leadViewRequests.getLead();
		};
	}
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/rxjs/Rx.js"), __webpack_require__("./node_modules/jquery/dist/jquery.js"), __webpack_require__("./node_modules/toastr/toastr.js")))

/***/ }),

/***/ "./web/js/controllers/login/changeLoginController.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by sombra-41 on 29.11.16.
 */
(function () {
	angular.module('main').controller('ChangeLoginController', ChangeLoginController);

	ChangeLoginController.$inject = ['$scope', '$rootScope', '$location', '$http', '$timeout', '$routeParams', 'messageService', 'accountService'];

	function ChangeLoginController($scope, $rootScope, $location, $http, $timeout, $routeParams, messageService, accountService) {
		$scope.$on('$viewContentLoaded', function () {
			confirmChange();
		});

		function showSuccessChangeEmail() {
			messageService.showToaster('s_0', 'changeLogin');
		}

		function confirmChange() {
			var url = '/public/rest/user/change/login/confirm/' + $routeParams.token;

			$http.get(url).then(function () {
				showSuccessChangeEmail();

				$timeout(function () {
					try {
						accountService.logoutWeb();
					} catch (e) {
						$location.path('login');
					}
				}, 400);
			}, function (result) {
				if (result.status === 409) {
					messageService.showToaster('e_0', 'changeLogin');
					$rootScope.error = true;
					$rootScope.error_message = 'Damn! The link to update your email address has already been used.';
				} else {
					$location.path('login');
				}
			});
		}
	}
})();

/***/ }),

/***/ "./web/js/controllers/login/changePasswordController.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(toastr) {

(function () {
	angular.module('main').controller('ChangePasswordController', ChangePasswordController);

	ChangePasswordController.$inject = ['$scope', '$rootScope', '$location', '$http', 'accountService'];

	function ChangePasswordController($scope, $rootScope, $location, $http, accountService) {
		var request = {
			confirmChange: function confirmChange($rootScope, $http, $location, $scope) {
				delete $rootScope.error;
				var restPathUrl = '/public/rest/user/change/confirm/';
				var confirmPathPart = 'confirm/';
				var url = $location.path();
				var index = url.indexOf(confirmPathPart);

				if (index && index + confirmPathPart.length < url.length) {
					url = url.substring(confirmPathPart.length + index, url.length);
					url = restPathUrl + url;
				} else {
					url = null;
				}
				if (url) {
					$http.get(url).then(function (result) {
						var data = result.data,
						    status = result.status;

						if (data) {
							if (data.success) {
								delete $rootScope.error;
								accountService.logoutWeb();
								toastr.success('Login with new password!', 'Success');
							} else {
								$rootScope.error = true;
								$rootScope.error_message = data.message;
							}
							$scope.userActionResult = data;
						}
					}).catch(function (result) {
						var status = result.status;

						$rootScope.error = true;
						$rootScope.error_message = 'Failed request to server';
					});
				}
			}
		};

		$scope.$on('$viewContentLoaded', function () {
			if (!$rootScope.password_token) {
				request.confirmChange($rootScope, $http, $location, $scope);
			}
		});
	}
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/toastr/toastr.js")))

/***/ }),

/***/ "./web/js/controllers/login/confirmForgotPasswordController.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(toastr) {

(function () {
	angular.module('main').controller('ConfirmForgotPasswordController', ConfirmForgotPasswordController);

	ConfirmForgotPasswordController.$inject = ['$scope', '$rootScope', '$location', '$http', 'messageService', 'stringModifierService'];

	function ConfirmForgotPasswordController($scope, $rootScope, $location, $http, messageService, stringModifierService) {
		var request = {
			changePasswordWithToken: function changePasswordWithToken(password, password_confirm, token, changePasswordWithTokenSuccessCallback, changePasswordWithTokenErrorCallback) {
				$http({
					method: 'POST',
					url: '/public/rest/user/changepassword',
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded'
					},
					transformRequest: stringModifierService.urlEncodDataTransform,
					data: {
						password: password,
						password_confirm: password_confirm,
						token: token
					}
				}).then(function (result) {
					return changePasswordWithTokenSuccessCallback(result.data);
				}, function () {
					return changePasswordWithTokenErrorCallback();
				});
			},
			confirmForgot: function confirmForgot($rootScope, $location, $scope) {
				delete $rootScope.error;

				var restPathUrl = '/public/rest/user/forgotpassword/';
				var confirmPathPart = 'confirm/';
				var url = $location.path();
				var index = url.indexOf(confirmPathPart);
				var token = null;

				if (index && index + confirmPathPart.length < url.length) {
					token = url.substring(confirmPathPart.length + index, url.length);
					url = restPathUrl + token;
				} else {
					url = null;
				}

				if (url) {
					$http.get(url).then(function (result) {
						if (result.data) {
							if (result.data.success) {
								$rootScope.password_token = token;
							} else {
								$rootScope.error = true;
								$rootScope.error_message = result.data.message;
							}

							$scope.userActionResult = result.data;
						}
					}, function () {
						return messageService.showToaster('e_0', 'general');
					});
				}
			}
		};

		$scope.$on('$viewContentLoaded', function () {
			if (!$rootScope.password_token) {
				request.confirmForgot($rootScope, $location, $scope);
				console.log('validationg token');
			}
		});

		$scope.changePassword = function (password, passwordConfirm) {
			delete $scope.userActionResult;
			if ($rootScope.password_token) {
				if (passwordConfirm !== password) {
					return messageService.showToaster('e_0', 'forgotPassword');
				} else if (password === undefined || passwordConfirm === undefined || password.trim().length === 0) {
					return messageService.showToaster('e_3', 'general', 'password');
				} else if (password.length < 6) {
					return messageService.showToaster('e_1', 'forgotPassword');
				}
				var token = $rootScope.password_token;
				request.changePasswordWithToken(password, passwordConfirm, token, changePasswordWithTokenSuccessCallback, changePasswordWithTokenErrorCallback);
			} else {
				messageService.showToaster('e_2', 'forgotPassword');
				$location.path('/login');
				// toastr["error"]("Forgot password link already used!", 'Error');
			}
		};

		function changePasswordWithTokenSuccessCallback(data) {
			if (data) {
				delete $scope.userActionResult;
				$scope.userActionResult = data;
				if (data.success) {
					toastr.success(data.message);
					$scope.userActionResult = data;
					$location.path('/login');
					delete $rootScope.error;
					delete $rootScope.password_token;
				} else {
					toastr.error(data.message, 'Error');
					$rootScope.error = true;
					$rootScope.error_message = data.message;
				}
			}
		}

		function changePasswordWithTokenErrorCallback() {
			messageService.showToaster('e_0', 'general');
		}
	}
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/toastr/toastr.js")))

/***/ }),

/***/ "./web/js/controllers/login/confirmSignUpController.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('main').controller('ConfirmSignUpController', ConfirmSignUpController);

ConfirmSignUpController.$inject = ['$scope', '$rootScope', '$location', 'accountDataService', 'messageService'];

function ConfirmSignUpController($scope, $rootScope, $location, accountDataService, messageService) {
	$scope.$on('$viewContentLoaded', function () {
		$rootScope.signInPage = false;
		var url = $location.path();

		accountDataService.confirmSignUp(url).subscribe(function (data) {
			return successConfirmSignUp(data);
		}, function (error) {
			return errorConfirmSignUp(error);
		});
	});

	function successConfirmSignUp(data) {
		if (data) {
			if (data.success) {
				delete $rootScope.error;
				messageService.showToaster('s_1', 'login');
				$location.path('/login');
			} else {
				messageService.showToaster('e_5', 'login');
				$rootScope.error = true;
				$rootScope.error_message = data.message;
			}
			$scope.userActionResult = data;
		}
	}

	function errorConfirmSignUp() {
		messageService.showToaster('e_0', 'general');
		$rootScope.authenticated = false;
		$rootScope.error = true;
		$rootScope.error_message = 'Failed request to server';
	}
}

/***/ }),

/***/ "./web/js/controllers/login/forgotPasswordController.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(toastr) {

(function () {
	angular.module('main').controller('ForgotPasswordController', ForgotPasswordController);

	ForgotPasswordController.$inject = ['$scope', '$rootScope', '$location', '$http', 'stringModifierService', 'messageService'];

	function ForgotPasswordController($scope, $rootScope, $location, $http, stringModifierService, messageService) {
		$rootScope.navbarSignUp = false;
		$rootScope.navbarSignIn = false;
		var email = $scope.email;

		var request = {
			forgot: function forgot(email, forgotSuccessCallback, forgotErrorCallback) {
				$http({
					method: 'POST',
					url: '/public/rest/user/forgotpassword',
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded'
					},
					transformRequest: stringModifierService.urlEncodDataTransform,
					data: {
						email: email
					}
				}).then(function (_ref) {
					var data = _ref.data,
					    status = _ref.status;

					console.log('status ' + status);
					forgotSuccessCallback(data);
				}, function () {
					return forgotErrorCallback();
				});
			}
		};

		var forgotSuccessCallback = function forgotSuccessCallback(data) {
			$scope.userActionResult = data;
			$scope.button_disable = false;
			if (data) {
				if (data.success) {
					messageService.showToaster('s_0', 'forgotPassword');
					delete $rootScope.error;
					$location.path('/login');
				} else {
					toastr.error(data.message, 'Error');
					console.log('data failed forgot : ' + data);
				}
				console.log(data);
			}
		};

		function forgotErrorCallback() {
			toastr.error('Failed request to server', 'Error');
			$scope.button_disable = false;
		}

		$scope.forgot = function (email) {
			delete $rootScope.error;
			toastr.clear();
			$scope.button_disable = true;
			console.log('Forgot called + ' + email);
			request.forgot(email, forgotSuccessCallback, forgotErrorCallback);
		};
	}
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/toastr/toastr.js")))

/***/ }),

/***/ "./web/js/controllers/login/loginController.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(toastr, $) {

(function () {
	angular.module('main').controller('LoginController', LoginController);

	LoginController.$inject = ['$scope', '$rootScope', '$location', '$http', 'accountService', 'accountDataService', 'messageService', 'authTokensService', 'subscriptionDataService', 'brandsDataService', 'systemNotificationsService'];

	function LoginController($scope, $rootScope, $location, $http, accountService, accountDataService, messageService, authTokensService, subscriptionDataService, brandsDataService, systemNotificationsService) {
		$scope.$on('$viewContentLoaded', function () {
			$rootScope.signInPage = true;
			$scope.navbarSignIn = true;
			$scope.navbarSignUp = false;
			$scope.stayLogin = false;
			$rootScope.navbarSignUp = $scope.navbarSignUp;
			$rootScope.navbarSignIn = $scope.navbarSignIn;
			$scope.isSignInwSpinnningWheelActive = false;
			$scope.confirmMailTitle = '';
			$scope.confirmMailBody = '';
		});

		$scope.login = function (email, password, stayLogin) {
			$scope.email = email;
			$scope.isSignInwSpinnningWheelActive = true;
			$scope.button_disable = true;
			delete $rootScope.error;
			$rootScope.showTrialModal = true;
			$rootScope.trialModalTitles = ['Happiness is an unlimited Studio Ninja account.', 'One small act can make a huge difference.', "Let's karate-chop across the world together.", 'This is only the beginning. Grow with us!', 'Think big. Dream bigger. Go unlimited.', "The world is your oyster. We'll make you the pearl!"];

			accountService.authenticateWeb(email, password, stayLogin).finally(function () {
				$scope.button_disable = false;
				$scope.isSignInwSpinnningWheelActive = false;
			}).subscribe(function (data) {
				return authenticationSuccessCallback(data);
			}, function (error) {
				return authenticationErrorCallback(error);
			});
			localStorage.setItem('isStayLogin', stayLogin);
		};

		function authenticationErrorCallback(error) {
			var errorMessage = error.errorMessage,
			    errorCode = error.errorCode,
			    errorTitle = error.errorTitle;

			$rootScope.authenticated = false;
			if (errorCode === 211) {
				$scope.confirmMailTitle = errorTitle;
				$scope.confirmMailBody = errorMessage;
				toastr.remove();
				$('#confirm').modal('show');
			}
		}

		$scope.resendConfirm = function () {
			$('#confirm').modal('hide');
			accountDataService.resendConfirmEmail($scope.email).subscribe(function () {
				messageService.showToaster('s_0', 'general', 'Check your mail');
			});
		};

		$scope.publicNavbarClick = function () {
			$scope.navbarSignUp = !$scope.navbarSignUp;
			if ($location.path() === '/subscription') {
				accountService.logoutWeb();
			}
		};

		$scope.acceptTermsOfUse = function () {
			$scope.button_disable = true;
			$scope.isSignInwSpinnningWheelActive = true;

			accountDataService.acceptTermsOfUse().finally(function () {
				return $scope.button_disable = true;
			}).subscribe(function () {
				$('#termsUpdatedModal').modal('hide');
				getUser();
			}, function (error) {
				return messageService.showDefaultErrorMessage(error);
			});
		};

		function getUserSubscription() {
			subscriptionDataService.fetchSubscriptionStatus().subscribe(function (data) {
				if (data.currentPlan) {
					getUser(data);
				} else {
					subscriptionDataService.setChoosePlanOpenModalStatus({
						state: true,
						payload: null
					});
				}
			});
		}

		function getUser(subscription) {
			brandsDataService.getBrandsData();
			accountService.getUserWeb().subscribe(function (user) {
				if (!user) {
					console.log('No authentication data');
					return;
				}

				$location.path('/');

				if (user.termsOfUseAgree !== true && !user.admin) {
					$('#termsUpdatedModal').modal('show');
				}
				subscriptionDataService.setSubscriptionData(subscription);

				if (subscription.loginActions) {
					subscriptionDataService.performAfterLoginActions(subscription.loginActions);
				}
			});
		}

		function authenticationSuccessCallback(data) {
			var access_token = data.access_token,
			    refresh_token = data.refresh_token;

			authTokensService.setAuthToken(access_token);
			authTokensService.setRefreshToken(refresh_token);
			getUserSubscription();
		}
	}
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/toastr/toastr.js"), __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./web/js/controllers/login/signUpController.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Rx, toastr) {

(function () {
	angular.module('main').controller('SignUpController', SignUpController);

	SignUpController.$inject = ['$scope', '$rootScope', '$location', '$http', '$filter', '$window', 'accountService', 'messageService', 'validationService', 'settingsService', '$timeout'];

	function SignUpController($scope, $rootScope, $location, $http, $filter, $window, accountService, messageService, validationService, settingsService, $timeout) {
		$scope.$on('$viewContentLoaded', function () {
			getTimezoneList();
			getCurrencyList();
			// document.cookie = "reCAPTCHA_token=true";
			$scope.navbarSignIn = false;
			$scope.navbarSignUp = true;
			$scope.isRecaptchaInitialized = false;
			$scope.button_disable = false;
			$scope.userToSignup = {};
			$scope.isShowTootlip = false;
			$scope.isTest = document.cookie.includes('reCAPTCHA_token');

			if (!$rootScope.password_token) {
				var invitationCompany = accountService.getInvitationCompany();

				if (invitationCompany instanceof Rx.Observable) {
					invitationCompany.subscribe(function (data) {
						return successGetInvitationCompany(data);
					}, function (error) {
						return messageService.showDefaultErrorMessage(error);
					});
				}

				var restPathUrl = '/public/rest/user/signup/';
				var confirmPathPart = 'register/';
				var url = $location.path();
				var index = url.indexOf(confirmPathPart);
				var token = null;

				if (index !== -1 && index + confirmPathPart.length < url.length) {
					token = url.substring(confirmPathPart.length + index, url.length);
				}

				if (token) {
					url = restPathUrl + token;
					$http.get(url).then(function (result) {
						return successGetInvitationCompany(result.data);
					}).catch(messageService.showDefaultErrorMessage);
				}
			}
		});

		function successGetInvitationCompany(data) {
			if (data) {
				$scope.invite = true;
				$scope.userToSignup.companyName = data.name;
			}
		}

		function getTimezoneList() {
			settingsService.getTimezoneList().subscribe(function (data) {
				if (data) {
					$scope.timezoneList = $filter('timezoneFilter')(data);
				}
			});
		}

		function getCurrencyList() {
			settingsService.getCurrencyList().subscribe(function (data) {
				if (data) {
					$scope.currencyList = data;
				}
			});
		}

		function signUpSuccessCallback(data) {
			// Google Tag Manager event
			dataLayer.push({
				pageCategory: 'signup',
				event: 'signup'
			});

			messageService.showToaster('s_0', 'login');
			$rootScope.firstName = $scope.signUpData.firstName;

			var _data$data$signUpProm = data.data.signUpPromotionInfo,
			    textHTML = _data$data$signUpProm.textHTML,
			    titleHTML = _data$data$signUpProm.titleHTML;


			$rootScope.textHtml = textHTML;
			$rootScope.titleHtml = titleHTML;

			$location.path('/signup/thankyou');

			$scope.button_disable = false;
		}

		function signUpErrorCallback(_ref) {
			var error = _ref.error;

			$scope.isSubmitSpinningWheelActive = false;
			var _error$errorMessage = error.errorMessage,
			    errorMessage = _error$errorMessage === undefined ? '' : _error$errorMessage,
			    errorTitle = error.errorTitle,
			    errorCode = error.errorCode;


			var EMAIL_BUSY = 'User with such email already registered';
			var COMPANY_NAME_BUSY = 'Company name already exists';

			$scope.button_disable = false;
			$rootScope.authenticated = false;
			$rootScope.error = true;

			if (errorCode) {
				messageService.showErrorFromBackend(errorTitle, errorMessage);
				return;
			}

			switch (errorMessage) {
				case EMAIL_BUSY:
					messageService.showToaster('e_2', 'login');
					break;
				case COMPANY_NAME_BUSY:
					messageService.showToaster('e_3', 'login');
					break;
				default:
					getDefaultErrorMessage(errorMessage);
			}

			function getDefaultErrorMessage(message) {
				var POSTMARKUP_ERROR_START = '{ErrorCode:406,Message:';
				var POSTMARKUP_ERROR_END = ' }';

				if (message.includes(POSTMARKUP_ERROR_START)) {
					var postmarkupMessage = message.replace(POSTMARKUP_ERROR_START, '').replace(POSTMARKUP_ERROR_END, '');
					toastr.error(postmarkupMessage);
				} else {
					$rootScope.error_message = 'Failed request to server';
					toastr.error('Failed request to server', 'Error');
				}
			}
		}

		function successCompanyRegister() {
			$scope.button_disable = false;
			$scope.isSubmitSpinningWheelActive = false;
			messageService.showToaster('s_1', 'login');
			$location.path('/login');
		}

		$scope.validateForm = function (userToSignup) {
			var companyName = userToSignup.companyName,
			    firstName = userToSignup.firstName,
			    email = userToSignup.email,
			    password = userToSignup.password,
			    passwordConfirm = userToSignup.passwordConfirm,
			    currency = userToSignup.currency,
			    timezone = userToSignup.timezone,
			    promoSubscription = userToSignup.promoSubscription,
			    termsOfUseAccepted = userToSignup.termsOfUseAccepted;

			userToSignup.promoSubscription = true;
			delete $rootScope.error;
			if (!$scope.isRecaptchaInitialized && !$scope.isTest) {
				$scope.id = grecaptcha.render('recaptcha', {
					sitekey: '6Le_szsUAAAAALL60TzetiuWGDYT_jDUj1rdFwNR',
					callback: 'signUp',
					size: 'invisible'
				});
				$scope.isRecaptchaInitialized = true;
			}

			if (!userToSignup.termsOfUseAccepted) {
				$scope.isShowTootlip = true;
				$timeout(function () {
					$scope.isShowTootlip = false;
				}, 3000);
			} else {
				$scope.isShowTootlip = false;
			}

			var MIN_PASSWORD_LENGTH = 6;

			if (password.length < MIN_PASSWORD_LENGTH) {
				$scope.isSubmitSpinningWheelActive = false;
				$scope.button_disable = false;
				return messageService.showToaster('w_0', 'login');
			}

			if (passwordConfirm !== password) {
				$scope.isSubmitSpinningWheelActive = false;
				$scope.button_disable = false;
				return messageService.showToaster('e_6', 'login');
			}

			if (password.trim().length === 0) {
				$scope.isSubmitSpinningWheelActive = false;
				$scope.button_disable = false;
				return messageService.showToaster('e_3', 'general', 'password');
			}

			if (!userToSignup.termsOfUseAccepted) {
				return false;
			}

			var restPathUrl = void 0,
			    confirmPathPart = void 0,
			    index = void 0,
			    token = void 0;

			restPathUrl = '/public/rest/user/signup/';
			confirmPathPart = 'register/';

			$scope.url = $location.path();
			index = $scope.url.indexOf(confirmPathPart);
			token = null;

			if (index !== -1 && index + confirmPathPart.length < $scope.url.length) {
				token = $scope.url.substring(confirmPathPart.length + index, $scope.url.length);
				$scope.url = restPathUrl + token;
			} else {
				$scope.url = null;
			}

			$scope.button_disable = true;
			$scope.isSubmitSpinningWheelActive = true;

			$scope.signUpData = {
				firstName: firstName,
				email: email,
				password: password,
				passwordConfirm: passwordConfirm,
				promoSubscription: promoSubscription,
				termsOfUseAccepted: termsOfUseAccepted
			};
			$scope.signUpData.promoSubscription = true;
			if ($scope.url) {
				$scope.signUpData.inviteToken = token;

				if (validationService.isStringEmpty($scope.signUpData.firstName)) {
					$scope.button_disable = false;
					$scope.isSubmitSpinningWheelActive = false;
					return messageService.showToaster('e_4', 'login');
				}
				if (!$scope.isTest) {
					grecaptcha.execute($scope.id);
				} else {
					$scope.signUp(null);
				}

				$scope.button_disable = false;
			} else {
				$scope.signUpData.companyName = companyName;
				$scope.signUpData.timezone = timezone.key;
				$scope.signUpData.currency = currency.currencyCode;

				if (validationService.isStringEmpty($scope.signUpData.firstName) || validationService.isStringEmpty($scope.signUpData.companyName)) {
					$scope.button_disable = false;
					$scope.isSubmitSpinningWheelActive = false;
					return messageService.showToaster('e_4', 'login');
				}

				if (!$scope.isTest) {
					grecaptcha.execute($scope.id);
				} else {
					$scope.signUp(null);
				}
				$scope.button_disable = false;
			}
		};

		$scope.signUp = function (token) {
			$scope.button_disable = true;
			$scope.isSubmitSpinningWheelActive = true;

			$scope.signUpData.reCaptchaToken = token;

			if ($scope.url) {
				accountService.companyRegister($scope.signUpData, successCompanyRegister, signUpErrorCallback);
			} else {
				accountService.signUp($scope.signUpData, signUpSuccessCallback, signUpErrorCallback);
			}

			grecaptcha.reset($scope.id);
		};

		$window.signUp = $scope.signUp;
	}
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/rxjs/Rx.js"), __webpack_require__("./node_modules/toastr/toastr.js")))

/***/ }),

/***/ "./web/js/controllers/login/thankYouSignupController.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
	angular.module('main').controller('ThankYouSignupController', ThankYouSignupController);

	ThankYouSignupController.$inject = ['$scope', '$rootScope'];

	function ThankYouSignupController($scope, $rootScope) {
		$scope.$on('$viewContentLoaded', function () {
			$scope.firstName = $rootScope.firstName;
			$scope.textHtml = $rootScope.textHtml;
			$scope.titleHtml = $rootScope.titleHtml;
		});
	}
})();

/***/ }),

/***/ "./web/js/controllers/login/tlcController.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
	angular.module('main').controller('TlcController', TlcController);

	TlcController.$inject = ['$scope', '$rootScope', 'accountService'];

	function TlcController($scope, $rootScope, accountService) {
		$scope.$on('$viewContentLoaded', function () {
			$rootScope.signInPage = false;
		});

		accountService.emitShowHeader(false);
		$rootScope.showLogo = false;
	}
})();

/***/ }),

/***/ "./web/js/controllers/login/unsubscribeEmailsController.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(toastr) {

(function () {
	angular.module('main').controller('UnsubscribeEmailsController', UnsubscribeEmailsController);

	UnsubscribeEmailsController.$inject = ['$scope', '$rootScope', '$routeParams', '$location', '$http'];

	function UnsubscribeEmailsController($scope, $rootScope, $routeParams, $location, $http) {
		var allUrlParams = $routeParams;

		$scope.$on('$viewContentLoaded', function () {
			$rootScope.signInPage = false;
			console.log('::: unsubscribeEmailsController :::');
			delete $rootScope.error;
			var restPathUrl = '/public/rest/unsubscribefromintroemails/';
			var unsubscribePathPart = 'unsubscribefromintroemails/';
			var url = $location.path();
			var index = url.indexOf(unsubscribePathPart);
			console.log('url=$location.path()=' + url);
			console.log('restPathUrl=' + restPathUrl);

			if (index && index + unsubscribePathPart.length < url.length) {
				url = url.substring(unsubscribePathPart.length + index, url.length);
				url = restPathUrl + url;
				console.log('new url=' + url);
			} else {
				url = null;
			}
			if (url) {
				$http.get(url).then(function (result) {
					var data = result.data,
					    status = result.status;

					console.log(status + ' unsubscribe emails status');
					if (data) {
						console.log(data);
						if (data.success) {
							delete $rootScope.error;
							toastr.success('You have been removed from this mailing list.', 'Successfully unsubscribed!');
							$location.path('/login');
						} else {
							toastr.error('You have already unsubscribed from this mailing list.', 'Oops!');
							console.log('data failed forgot : ' + data);
							$rootScope.error = true;
							$rootScope.error_message = data.message;
						}
						console.log(data);
						$scope.userActionResult = data;
					}
				}).catch(function (result) {
					var data = result.data,
					    status = result.status;

					toastr.error('Failed request to server', 'Error');
					console.log(status + ' confirm password status');
					$rootScope.authenticated = false;
					$rootScope.error = true;
					$rootScope.error_message = 'Failed request to server';
				});
			}
		});
	}
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/toastr/toastr.js")))

/***/ }),

/***/ "./web/js/controllers/paymentsOverviewController.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

(function () {
	angular.module('main').controller('PaymentsOverviewController', PaymentsOverviewController);

	PaymentsOverviewController.$inject = ['$scope', '$rootScope', 'jobDataService', 'timeService', 'messageService', 'validationService', 'emailService', 'invoicesDataService', 'templateRequestsService', 'fileUploadService'];

	function PaymentsOverviewController($scope, $rootScope, jobDataService, timeService, messageService, validationService, emailService, invoicesDataService, templateRequestsService, fileUploadService) {
		$scope.emailDataToSave = {};
		clearAttachments();

		function clearAttachments() {
			$scope.attachmentsData = {
				attachments: [],
				filesSize: 0
			};
		}

		// Email methods
		$scope.retrySendMail = function () {
			emailService.callLastEmailFn();
		};

		$scope.showSendPaymentReceipt = function (payment) {
			$scope.paymentReceiptId = payment.id;
			delete $scope.sendMessage;
			$scope.sendMessage = { emailTo: payment.email ? [payment.email] : [] };
			if (payment.secondaryEmail) {
				$scope.sendMessage.emailTo.push(payment.secondaryEmail);
			}

			templateRequestsService.getTemplates('all').subscribe(function (data) {
				if (data) {
					$scope.emails = data;
					if ($scope.emails) {
						$scope.choosenEmail = $scope.emails.find(function (item) {
							return item.emailTemplateType === 'RECEIPT_OF_PAYMENT_EMAIL_TEMPLATE';
						}) || {};
					}
					$('#sendInvoiceModal').modal('show').on('shown.bs.modal', function () {
						var input = $(this).find('input');
						var select = $(this).find('select');

						validationService.isModalClosePrevented(input);
						validationService.isModalClosePrevented(select);
					});
				}
			}, function (err) {
				return messageService.showDefaultErrorMessage(err);
			});
		};

		$scope.toggleViewCc = function (state) {
			if ($scope.sendMessage && $scope.sendMessage.emailCc) {
				$scope.sendMessage.emailCc = [];
			}

			$scope.showCcField = state !== undefined ? state : !$scope.showCcField;
		};

		$scope.addSubjectVariable = function ($event, id) {
			var el = document.getElementById(id);
			$scope.sendMessage.emailSubject = emailService.addSubjectVariable(el, $event);
		};

		$scope.setEmailData = function (newData, object, property) {
			$scope[object][property] = newData;
		};

		$scope.sendPaymentReceipt = function () {
			var maxSize = 10; // 10Mb

			if ($scope.attachmentsData && $scope.attachmentsData.filesSize > maxSize) {
				messageService.showToaster('w_0', 'attachments');
				return false;
			}

			$scope.sendMessage.templateId = $scope.choosenEmail ? $scope.choosenEmail.id : null;
			$scope.sendMessage.emailText = $rootScope.addMaiStyling($scope.sendMessage.emailText);

			var mailData = emailService.prepareEmails($scope.sendMessage);
			if (!emailService.validateMails(mailData)) {
				return;
			}

			$scope.emailDataToSave = Object.assign({}, $scope.sendMessage, mailData);
			delete $scope.emailDataToSave.emailCc;

			var obj2save = angular.copy($scope.emailDataToSave);

			$scope.sendMessage.emailCc = $scope.showCcField ? obj2save.emailCc : '';

			var storedFiles = $scope.attachmentsData.attachments.filter(function (file) {
				return file.id;
			});
			var uploadedFiles = $scope.attachmentsData.attachments.filter(function (file) {
				return !file.id;
			});

			var dataToSend = {
				sendMessageData: $scope.emailDataToSave,
				storedFiles: storedFiles,
				uploadedFiles: uploadedFiles
			};

			$scope.disableBtnOnSend = true;
			invoicesDataService.sendInvoiceEmail(dataToSend, 'receipt', $scope.paymentReceiptId).finally(function () {
				return $scope.disableBtnOnSend = false;
			}).subscribe(function (data) {
				return successSendReceipt(data);
			}, function (err) {
				return errorSendReceipt(err);
			});

			function successSendReceipt(data) {
				$('#sendInvoiceModal').modal('hide');
				$scope.showCcField = false;

				$scope.$evalAsync();

				for (var prop in $scope.sendMessage) {
					$scope.sendMessage[prop] = '';
				}

				if ($scope.attachmentsData && $scope.attachmentsData.attachments) {
					if ($scope.attachmentsData.attachments.length) {
						$scope.attachmentsData.attachments.length = 0;
					}
				}
				messageService.showToaster('s_11', 'payments');
			}

			function errorSendReceipt(_ref) {
				var status = _ref.status,
				    error = _ref.error;

				$scope.disableBtnOnSend = false;
				var errorMessage = error.errorMessage,
				    errorTitle = error.errorTitle;

				var errorCode = void 0,
				    errorPlace = void 0,
				    value = void 0;

				if (status >= 400 && status < 500 && errorMessage) {
					if (errorMessage === 'Email text should contain an invoice link') {
						errorCode = 'e_7';
						errorPlace = 'editInvoice';
					} else if (errorTitle) {
						messageService.showErrorFromBackend(errorTitle, errorMessage);
						return;
					} else {
						errorCode = 'e_2';
						errorPlace = 'general';
						value = errorMessage;
					}
				} else {
					errorCode = 'e_0';
					errorPlace = 'general';
				}
				messageService.showToaster(errorCode, errorPlace, value);
			}
		};

		$scope.$watch('choosenEmail', function (newValue) {
			if (typeof newValue !== 'undefined' && newValue !== null) {
				templateRequestsService.getTemplates('full_template', newValue.id).subscribe(function (data) {
					return successGetEmail(data);
				});
			}
		});

		function successGetEmail(email) {
			if (email) {
				$scope.sendMessage.emailSubject = email.subject;
				$scope.sendMessage.emailText = email.text;
				$scope.sendMessage.emailCc = '';

				if (email.storedAttachments && email.storedAttachments.length) {
					$scope.attachmentsData = {
						attachments: fileUploadService.convertAttachmentsToShow(email.storedAttachments)
					};
				} else {
					clearAttachments();
				}
			}
		}

		$scope.disableDragDrop = function () {
			return true;
		};
	}
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./web/js/controllers/questionnairyController.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, toastr) {

(function () {
	angular.module('main').controller('QuestionnairyController', QuestionnairyController);

	QuestionnairyController.$inject = ['$scope', '$rootScope', '$http', 'messageService', 'validationService', 'settingsService'];

	function QuestionnairyController($scope, $rootScope, $http, messageService, validationService, settingsService) {
		$scope.$on('$viewContentLoaded', function () {
			$scope.isSaveNewSpinnningWheelActive = false;
			$scope.isDeleteSpinnningWheelActive = false;
			$scope.pageRequest = {
				page: 1,
				perPage: $rootScope.paginationPerPage ? $rootScope.paginationPerPage : 25,
				pageOrder: {
					predicate: 'name',
					reverse: false
				},
				search: null
			};

			// feature toggle

			settingsService.timeFormatSettings.subscribe(function (data) {
				if (data.questionnaireTemplatesVersion === 'V2') {
					$scope.isNewQuestionnaireAvailable = true;
				}
				if (data.questionnaireTemplatesVersion === 'V1') {
					$scope.isNewQuestionnaireAvailable = false;
					getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
				}
			});
		});

		$scope.newQuestionnaire = {
			questions: [{
				questionText: '',
				index: 1
			}],
			name: ''
		};
		$scope.bEdit = false;
		$scope.bDuplicate = false;
		$scope.bAdd = false;

		$scope.changeAllIndexes = function () {
			$scope.newQuestionnaire.questions.forEach(function (item, i) {
				item.index = i + 1;
			});
		};

		$scope.getQuestionnaireById = function (id) {
			delete $scope.newQuestionnaire;
			$http.get('/protected/rest/questionnaires/get?id=' + id).then(function (result) {
				if (result) {
					if (result.data) {
						$scope.newQuestionnaire = result.data;
						$('#newQuestionnaires').modal('show').on('shown.bs.modal', function () {
							var input = $(this).find('input');

							validationService.isModalClosePrevented(input);
						});
						if ($scope.bDuplicate) $scope.newQuestionnaire.id = '';
					}
				}
			});
		};

		$scope.duplicate = function (id) {
			$scope.bEdit = false;
			$scope.bAdd = false;
			$scope.bDuplicate = true;
			$scope.getQuestionnaireById(id);
			// $scope.newQuestionnaire.id = '';
		};

		$scope.edit = function (id) {
			$scope.bDuplicate = false;
			$scope.bAdd = false;
			$scope.bEdit = true;
			$scope.getQuestionnaireById(id);
		};

		$scope.deleteQuestionnaire = function (id, name) {
			$scope.deleteQuestionnaireName = name;
			$scope.newQuestionnaire = { id: id };
			$('#deleteModal').modal('show');
		};

		$scope.hideModal = function () {
			delete $scope.newQuestionnaire;
			$scope.bEdit = false;
			$scope.bDuplicate = false;
			$scope.bAdd = false;
			$('#newQuestionnaires').modal('hide');
		};

		$scope.deleteRequest = function (id) {
			$scope.button_disabled = true;
			$scope.isDeleteSpinnningWheelActive = true;
			$http({
				method: 'POST',
				url: '/protected/rest/questionnaires/delete?id=' + id
			}).then(function (result) {
				successDeleteRequest(result.data);
			}).catch(function (result) {
				return errorDeleteRequest(result.data);
			}).finally(function () {
				$scope.isDeleteSpinnningWheelActive = false;
				$scope.button_disabled = false;
			});
		};

		function successDeleteRequest(data) {
			if (data.errorMessage) {
				toastr.error(data.errorMessage, 'Error');
			} else {
				messageService.showToaster('s_0', 'questionnaires', $scope.deleteQuestionnaireName);
				getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
				$('#deleteModal').modal('hide');
			}
		}

		function errorDeleteRequest(data) {
			var errorMessage = data.errorMessage;
			if (errorMessage && errorMessage.includes('is attached to workflow template')) {
				messageService.showToaster('e_0', 'questions');
			} else {
				messageService.showToaster('e_0', 'general');
			}
		}

		$scope.remove = function (index) {
			if ($scope.newQuestionnaire.questions.length != 1) {
				// $scope.newQuestionnaire.questions.splice(index, 1);
				if (!$scope.deleteQuestions) {
					$scope.deleteQuestions = [];
				}
				if ($scope.newQuestionnaire.questions[index].id) {
					$scope.deleteQuestions.push($scope.newQuestionnaire.questions[index].id);
				}
				$scope.newQuestionnaire.questions[index];
				$scope.newQuestionnaire.questions.splice(index, 1);
				$scope.changeAllIndexes();
			}
		};

		$scope.add = function () {
			$scope.newQuestionnaire.questions.push({
				questionText: '',
				index: 1
			});
			$scope.newQuestionnaire.questions[$scope.newQuestionnaire.questions.length - 1].index = $scope.newQuestionnaire.questions.length;

			$scope.$watch('newQuestionnaire.questions', function () {
				var input = $('#newQuestionnaires').find('input');

				validationService.isModalClosePrevented(input);
			});
		};
		$scope.showOptIn = function (value) {
			$scope.newQuestionnaire.showOptInConsentStatement = value;
		};

		$scope.showAddNew = function () {
			delete $scope.newQuestionnaire;
			$scope.newQuestionnaire = {
				questions: [{
					questionText: '',
					index: 1
				}],
				name: '',
				showOptInConsentStatement: ''
			};
			$scope.bEdit = false;
			$scope.bDuplicate = false;
			$scope.bAdd = true;
			$('#newQuestionnaires').modal('show').on('shown.bs.modal', function () {
				var input = $(this).find('input');

				validationService.isModalClosePrevented(input);
			});
		};

		$scope.save = function () {
			$scope.isSaveNewSpinnningWheelActive = true;
			if (validationService.isStringEmpty($scope.newQuestionnaire.name)) {
				messageService.showToaster('e_3', 'general', 'Name');
				$scope.isSaveNewSpinnningWheelActive = false;
				return;
			}
			if ($scope.newQuestionnaire.showOptInConsentStatement && validationService.isStringEmpty($scope.newQuestionnaire.optInConsentStatement)) {
				messageService.showToaster('e_3', 'general', 'Opt-in consent');
				$scope.isSaveNewSpinnningWheelActive = false;
				return;
			}

			if ($scope.deleteQuestions) {
				$http({
					method: 'POST',
					url: '/protected/rest/questionnaires/questions/delete',
					data: $scope.deleteQuestions
				}).then(function () {});
			}

			$http({
				method: 'POST',
				url: '/protected/rest/questionnaires/save',
				data: $scope.newQuestionnaire
			}).then(function (result) {
				if (result.data.errorMessage) {
					toastr.error(result.data.errorMessage, 'Error');
				} else {
					if ($scope.newQuestionnaire.id) {
						messageService.showToaster('s_1', 'questionnaires', $scope.newQuestionnaire.name);
					} else {
						messageService.showToaster('s_2', 'questionnaires', $scope.newQuestionnaire.name);
					}
					$scope.hideModal();
					getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
				}
				$scope.isSaveNewSpinnningWheelActive = false;
			});
		};

		$scope.breadcrumbs = [{ link: '/', title: 'Dashboard' }, { link: '/settings', title: 'Settings' }, { link: null, title: 'Questionnaire Templates' }];

		function getResultsPage(pageNumber, perPage, predicate, reverse) {
			var changed = false;
			if (typeof predicate !== 'undefined' && predicate != null && typeof reverse !== 'undefined' && reverse != null) {
				$scope.pageRequest.pageOrder.predicate = predicate;
				$scope.pageRequest.pageOrder.reverse = reverse;
				changed = true;
			}

			if (typeof perPage !== 'undefined' && perPage != null) {
				$scope.pageRequest.perPage = perPage;
				changed = true;
			}
			if (typeof pageNumber !== 'undefined' && pageNumber != null) {
				$scope.pageRequest.page = pageNumber;
				changed = true;
			}

			if ($scope.pageRequest && $scope.totalItems != 0 && $scope.totalItems < ($scope.pageRequest.page - 1) * $scope.pageRequest.perPage + 1) {
				$scope.pageRequest.page = 1;
			}
			if (changed) {
				$http.get('/protected/rest/questionnaires?perPage=' + $scope.pageRequest.perPage + '&page=' + $scope.pageRequest.page + '&predicate=' + $scope.pageRequest.pageOrder.predicate + '&reverse=' + $scope.pageRequest.pageOrder.reverse).then(function (result) {
					if (result.data && result.data.pageRequest) {
						$scope.pageRequest = result.data.pageRequest;
					}
					$scope.gdprEnabled = result.data.gdprEnabled;
					$scope.pageNumbers = [];
					$scope.totalItems = result.data.total;
					var pagesCount = $scope.totalItems / $scope.pageRequest.perPage;
					pagesCount = Math.ceil(pagesCount);
					for (var i = 1; i <= pagesCount; i++) {
						$scope.pageNumbers[i - 1] = i;
					}
					$scope.questionnaires = result.data.results;
				});
			}
		}

		$scope.order = function (predicate) {
			$scope.pageRequest.pageOrder.reverse = $scope.pageRequest.pageOrder.predicate === predicate ? !$scope.pageRequest.pageOrder.reverse : false;
			getResultsPage(null, null, predicate, $scope.pageRequest.pageOrder.reverse);
		};

		$scope.getCurrentPage = function () {
			return $scope.pageRequest.page;
		};

		$scope.perPageChanged = function (newPerPage) {
			getResultsPage(null, newPerPage);
			$rootScope.paginationPerPage = newPerPage;
		};

		$scope.goToPage = function (newPage, disabled) {
			if (!disabled) {
				getResultsPage(newPage, null);
			}
		};
		$scope.jumpBack = function (disabled) {
			if (!disabled) {
				if ($scope.pageRequest.page > 1) {
					getResultsPage($scope.pageRequest.page - 1, null);
				}
			}
		};
		$scope.jumpAhead = function (disabled) {
			if (!disabled) {
				if ($scope.totalItems >= $scope.pageRequest.page * $scope.pageRequest.perPage + 1) {
					getResultsPage($scope.pageRequest.page + 1, null);
				}
			}
		};

		$scope.disableDragDrop = function () {
			return true;
		};
	}
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js"), __webpack_require__("./node_modules/toastr/toastr.js")))

/***/ }),

/***/ "./web/js/controllers/quoteViewController.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

(function () {
	angular.module('main').controller('QuoteViewController', QuoteViewController);

	QuoteViewController.$inject = ['$scope', '$rootScope', '$routeParams', '$location', '$http', '$sce', '$timeout', '$window', 'messageService', 'fileUploadService', 'jobDataService', 'timeService', 'validationService', 'emailService', 'userService', 'leadDataService', 'newJobsDataService', 'templateRequestsService', 'quotesDataService'];

	function QuoteViewController($scope, $rootScope, $routeParams, $location, $http, $sce, $timeout, $window, messageService, fileUploadService, jobDataService, timeService, validationService, emailService, userService, leadDataService, newJobsDataService, templateRequestsService, quotesDataService) {
		$scope.isJobView = $location.path().includes('/jobs/');
		$scope.isLeadView = $location.path().includes('/leads/');

		$scope.$on('$viewContentLoaded', function () {
			$scope.quoteId = $routeParams.quoteId;
			$scope.jobId = $routeParams.jobId;
			$scope.leadId = $routeParams.leadId;
		});

		$scope.sendMessage = {};
		$scope.emailDataToSave = {};
		var isFirstShow = true;

		clearAttachments();

		$scope.toggleViewCc = function (state) {
			if ($scope.sendMessage && $scope.sendMessage.emailCc) {
				$scope.sendMessage.emailCc = [];
			}

			$scope.showCcField = state !== undefined ? state : !$scope.showCcField;

			if (state === false) {
				isFirstShow = true;
				$scope.sendMessage.emailTo = [];
				clearAttachments();
			}
		};

		$scope.setEmailData = function (newData, object, property) {
			$scope[object][property] = newData;
		};

		// Email methods
		$scope.retrySendMail = function () {
			snCommunicationAdapter.callMethod('updateQuoteViewData');
			emailService.callLastEmailFn();
		};

		$scope.addSubjectVariable = function ($event, id) {
			var el = document.getElementById(id);
			$scope.sendMessage.emailSubject = emailService.addSubjectVariable(el, $event);
		};

		$scope.showSendQuote = function (data) {
			$scope.contactEmail = data.contact.email;
			$scope.jobId = data.jobId;
			setCustomToken(data.isFixed ? 'INVOICE_MENU' : 'JOB_MENU');
			if (data.secondaryContact) {
				$scope.secondaryContactEmail = data.secondaryContact.email;
			}

			$scope.sendMessage = {};

			templateRequestsService.getTemplates('all').subscribe(function (data) {
				if (data) {
					$scope.emails = data;

					if (data.length > 0) {
						$scope.choosenEmail = $scope.emails.find(function (item) {
							return item.emailTemplateType === 'QUOTE_EMAIL_TEMPLATE';
						}) || {};
					}
					$scope.$evalAsync();

					$('#sendQuoteModal').modal('show').on('shown.bs.modal', function () {
						var input = $('#sendQuoteModal').find('input');
						var select = $('#sendQuoteModal').find('select');

						validationService.isModalClosePrevented(input);
						validationService.isModalClosePrevented(select);
					});
				}
			});
		};

		$scope.$watch('choosenEmail', function (newValue) {
			if (typeof newValue !== 'undefined' && newValue !== '') {
				templateRequestsService.getTemplates('full_template', newValue.id).subscribe(function (data) {
					if (data) {
						$scope.sendMessage.emailSubject = data.subject;
						$scope.sendMessage.emailText = data.text;

						if (data.storedAttachments && data.storedAttachments.length) {
							$scope.attachmentsData = {
								attachments: fileUploadService.convertAttachmentsToShow(data.storedAttachments)
							};
						} else {
							clearAttachments();
						}

						var rootEmail = $rootScope.primaryContact ? $rootScope.primaryContact.email || '' : '';

						$scope.sendMessage.emailTo = $scope.contactEmail ? [$scope.contactEmail] :  true ? [rootEmail] : [];
						if ($scope.secondaryContactEmail) {
							$scope.sendMessage.emailTo.push($scope.secondaryContactEmail);
						}
						$scope.sendMessage.emailCc = [];

						$scope.sendMessage.emailCc = angular.element('#sendQuoteMessageData_emailCc').val() || [];
					}
				});
			}
		});

		function clearAttachments() {
			$scope.attachmentsData = {
				attachments: [],
				filesSize: 0
			};
		}

		// TREBA

		$scope.sendQuote = function () {
			var maxSize = 10; // 10Mb

			if ($scope.attachmentsData && $scope.attachmentsData.filesSize > maxSize) {
				messageService.showToaster('w_0', 'attachments');
				return false;
			}

			$scope.sendMessage.templateId = $scope.choosenEmail ? $scope.choosenEmail.id : null;
			$scope.sendMessage.emailText = $rootScope.addMaiStyling($scope.sendMessage.emailText);

			$scope.sendMessage.jobId = $scope.jobId;
			$scope.sendMessage.quoteId = $routeParams.quoteId;

			var mailData = emailService.prepareEmails($scope.sendMessage);
			if (!emailService.validateMails(mailData)) {
				return;
			}

			$scope.emailDataToSave = Object.assign({}, $scope.sendMessage, mailData);
			delete $scope.emailDataToSave.emailCc;

			var obj2save = angular.copy($scope.emailDataToSave);
			$scope.sendMessage.emailCc = $scope.showCcField ? obj2save.emailCc : '';

			var quoteEmail = $scope.emailDataToSave;

			var formData = new FormData();
			angular.forEach(quoteEmail, function (value, key) {
				console.debug('key: ' + key + '  | value: ' + value);
				formData.append(key, value);
			});

			var filesFromJob = $scope.attachmentsData.attachments.filter(function (file) {
				return file.id;
			});
			var filesFromComputer = $scope.attachmentsData.attachments.filter(function (file) {
				return !file.id;
			});

			angular.forEach(filesFromComputer, function (value, key) {
				formData.append('attachments[' + key + ']', value);
			});

			angular.forEach(filesFromJob, function (value, key) {
				formData.append('storedAttachments[' + key + ']', value.id);
			});

			$scope.disableBtnOnSend = true;
			quotesDataService.sendQuoteEmailRequest(formData).finally(function () {
				return $scope.disableBtnOnSend = false;
			}).subscribe(successSendInvoice, errorSendQuote);
		};

		function successSendInvoice() {
			$scope.$evalAsync();
			$('#sendQuoteModal').modal('hide');
			isFirstShow = true;

			$scope.disableBtnOnSend = false;
			$scope.showCcField = false;

			$scope.$evalAsync();

			clearAttachments();

			if ($scope.isJobView && $rootScope.updateJobView) {
				$rootScope.updateJobView();
			}

			if ($scope.isLeadView && $rootScope.updateLeadView) {
				$rootScope.updateLeadView();
			}

			messageService.showToaster('s_10', 'payments');

			snCommunicationAdapter.callMethod('updateQuoteViewData');
		}

		function errorSendQuote(err) {
			var status = err.status,
			    data = err.data,
			    error = err.error;

			$scope.disableBtnOnSend = false;
			var errorMessage = data.errorMessage,
			    errorTitle = data.errorTitle;

			var path = $location.path();

			if (error && error.errorCode) {
				messageService.handleError(err);
				return;
			}

			if (status >= 400 && status < 500 && errorMessage) {
				if (status == 423) {
					var limit = $rootScope.isUserTrial ? 50 : 150;
					return messageService.showToaster('e_4', 'generalValidation', limit);
				} else if (errorMessage.includes('Email address inactive')) {
					messageService.showToaster('e_1', 'generalValidation', $scope.sendMessage.emailTo);
				} else if (errorMessage.includes('Email text should contain a quote link')) {
					messageService.showToaster('e_3', 'editQuote');
				} else if (errorMessage.includes('Lead is archived')) {
					messageService.showToaster('e_5', 'lead');
				} else if (errorTitle) {
					messageService.showErrorFromBackend(errorTitle, errorMessage);
				} else if (path.includes('jobs') || path.includes('leads')) {
					messageService.showToaster('e_3', 'editQuote');
				} else {
					messageService.showToaster('e_2', 'general', errorMessage);
				}
			} else {
				messageService.showToaster('e_0', 'general');
			}
		}

		$scope.disableDragDrop = function () {
			return true;
		};

		function setMailData(_ref) {
			var primaryContact = _ref.primaryContact,
			    secondaryContact = _ref.secondaryContact,
			    customToken = _ref.customToken;

			$scope.contactEmail = primaryContact.email;
			setCustomToken(customToken);
			if (secondaryContact) {
				$scope.secondaryContactEmail = secondaryContact.email;
			}
		}

		function setCustomToken(token) {
			if (token) {
				$scope.customToken = null;
				requestAnimationFrame(function () {
					return $scope.customToken = token;
				});
			}
		}

		$(document).on('show.bs.modal', '#sendQuoteModal', function (data) {
			if (isFirstShow) {
				isFirstShow = false;
				if (data.relatedTarget) {
					setMailData(data.relatedTarget);
				}
			}
			$scope.$broadcast('addedFileEvent');
		});
	}
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./web/js/controllers/settings/calendarSettingsController.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
	angular.module('main').controller('CalendarSettingsController', CalendarSettingsController);

	CalendarSettingsController.$inject = [];

	function CalendarSettingsController() {}
})();

/***/ }),

/***/ "./web/js/controllers/settings/companyInformationController.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
	angular.module('main').controller('CompanyInformationController', CompanyInformationController);

	CompanyInformationController.$inject = ['$scope', '$routeParams'];

	function CompanyInformationController($scope, $routeParams) {
		$scope.$on('$viewContentLoaded', function () {
			$scope.companyId = +$routeParams.companyId;
		});
	}
})();

/***/ }),

/***/ "./web/js/controllers/settings/contactFormController.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
	angular.module('main').controller('ContactFormController', ContactFormController);

	ContactFormController.$inject = ['$scope', '$routeParams', '$location', 'messageService'];

	function ContactFormController($scope, $routeParams, $location, messageService) {
		$scope.$on('$viewContentLoaded', function () {
			if ($routeParams.closedWithError) {
				messageService.showErrorFromBackend($routeParams.title, $routeParams.message);
				$location.search({});
			}
		});
	}
})();

/***/ }),

/***/ "./web/js/controllers/settings/currencyAndTaxesController.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(toastr, $) {

(function () {
	var CurrencyAndTaxesController = function CurrencyAndTaxesController($scope, $rootScope, $http, accountService, messageService, stringModifierService) {
		$scope.$on('$viewContentLoaded', function () {
			$scope.show = false;
			$scope.isSaveSpinnningWheelActive = false;

			request.getAllCurrencies($http, getAllCurrenciesSuccessCallback, getAllCurrenciesErrorCallback);

			request.getEditableCurrencyAndTaxes($http, getEditableCurrencyAndTaxesSuccessCallback, getEditableCurrencyAndTaxesErrorCallback);
		});

		var request = {
			updateCurrencyAndTaxes: function updateCurrencyAndTaxes($http, currencyAndTaxes) {
				$scope.isSaveSpinnningWheelActive = true;
				$http({
					method: 'POST',
					url: '/protected/rest/tax/update',
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded'
					},
					transformRequest: stringModifierService.urlEncodDataTransform,
					data: {
						currency: currencyAndTaxes.currencyDTO.name,
						taxName: currencyAndTaxes.taxName,
						percentage: currencyAndTaxes.percentage
					}
				}).then(function (result) {
					taxUpdatingSuccessCallback(result.data);
					$scope.isSaveSpinnningWheelActive = false;
				}, function (result) {
					$scope.isSaveSpinnningWheelActive = false;
					taxUpdatingErrorCallback(result);
				});
			},
			getEditableCurrencyAndTaxes: function getEditableCurrencyAndTaxes($http, getEditableCurrencyAndTaxesSuccessCallback, getEditableCurrencyAndTaxesErrorCallback) {
				$http({
					method: 'GET',
					url: '/protected/rest/currency_and_taxes/',
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded'
					}
				}).then(function (result) {
					return getEditableCurrencyAndTaxesSuccessCallback(result.data);
				}, function () {
					return getEditableCurrencyAndTaxesErrorCallback();
				});
			},
			getAllCurrencies: function getAllCurrencies($http, getAllCurrenciesSuccessCallback, getAllCurrenciesErrorCallback) {
				$http({
					method: 'GET',
					url: '/public/rest/currencies',
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded'
					}
				}).then(function (result) {
					return getAllCurrenciesSuccessCallback(result.data);
				}, function () {
					return getAllCurrenciesErrorCallback();
				});
			}
		};

		function getAllCurrenciesSuccessCallback(data) {
			if (data) {
				$scope.currencies = data;
			}
		}

		function getAllCurrenciesErrorCallback() {
			toastr.error('No available currencies', 'Error');
		}

		function getEditableCurrencyAndTaxesSuccessCallback(data) {
			if (data) {
				$scope.editedCurrencyAndTaxes = data;
			}
		}

		function getEditableCurrencyAndTaxesErrorCallback() {
			toastr.error('Currency&Taxes not changed', 'Error');
		}

		function taxUpdatingSuccessCallback(data) {
			if (data) {
				if (data.success) {
					accountService.getUserWeb().subscribe(function (data) {
						if (data.enabled) {
							$rootScope.removeBg = 'white-background';
						}
					});
					messageService.showToaster('s_0', 'currencyAndTaxes');
					$scope.editedCurrencyAndTaxes.isChanged = true;
				} else {
					toastr.error(data.message, 'Error');
					$rootScope.error = true;
					$rootScope.error_message = data.message;
				}
			}
			$scope.button_disable = false;
		}

		function taxUpdatingErrorCallback(result) {
			$rootScope.authenticated = false;
			messageService.showDefaultErrorMessage(result);
			$scope.button_disable = false;
		}

		$scope.updateCurrencyAndTaxes = function () {
			$('#saveCurrencyAndTaxesModal').modal('hide');
			delete $rootScope.error;
			$scope.editedCurrencyAndTaxes.percentage = parseFloat($scope.editedCurrencyAndTaxes.percentage);
			if (!$scope.editedCurrencyAndTaxes.taxName) {
				$scope.editedCurrencyAndTaxes.taxName = 'None';
			}
			if (!$scope.editedCurrencyAndTaxes.percentage) {
				$scope.editedCurrencyAndTaxes.percentage = 0;
			}
			if ($scope.editedCurrencyAndTaxes.percentage < 0 || $scope.editedCurrencyAndTaxes.percentage > 100) {
				toastr.error("Percentage cant't be less then 0 or greater then 100", 'Error');
				return;
			}

			request.updateCurrencyAndTaxes($http, $scope.editedCurrencyAndTaxes);
		};
		$scope.openModal = function () {
			if ($scope.editedCurrencyAndTaxes.isChanged) {
				$scope.updateCurrencyAndTaxes();
			} else {
				$('#saveCurrencyAndTaxesModal').modal('show');
			}
		};

		$scope.setCurrency = function (currency) {
			$scope.active = !$scope.active;
			$scope.editedCurrencyAndTaxes.currencyDTO = currency;
		};

		$scope.breadcrumbs = [{ link: '/', title: 'Dashboard' }, { link: '/settings', title: 'Settings' }, { link: null, title: 'Currency & Taxes' }];
	};

	angular.module('main').controller('CurrencyAndTaxesController', CurrencyAndTaxesController);

	CurrencyAndTaxesController.$inject = ['$scope', '$rootScope', '$http', 'accountService', 'messageService', 'stringModifierService'];
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/toastr/toastr.js"), __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./web/js/controllers/settings/emailSettingsController.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(toastr, $) {

(function () {
	function EmailSettingsController($scope, $rootScope, $location, $routeParams, messageService, validationService, emailSettingsDataService, emailService) {
		$scope.$on('$viewContentLoaded', function () {
			$scope.isGmailSpinnningWheelActive = false;
			$scope.isGmailReplySpinningWheelActive = false;
			$scope.isSMTPSpinnningWheelActive = false;
			$scope.isAddSignatureSpinnningWheelActive = false;
			$scope.isSNServerSettingsSpinnningWheelActive = false;
			$scope.isSMTPSettingsSpinnningWheelActive = false;
			$scope.isImageLoadedSuccess = false;

			var code = $routeParams.code;
			$scope.code = code;

			if (code) {
				if ($rootScope.activateCode !== code) {
					$rootScope.activateCode = code;
					saveGmailConnection(code);

					messageService.showToaster('i_0', 'general');
				}
			} else {
				$rootScope.activateCode = '';
			}

			getSettings();
			showSpinnerImageUploading();
		});

		window.changeImg = false;

		$scope.saveEmailSignature = function () {
			$scope.isAddSignatureSpinnningWheelActive = true;
			var signature = $scope.setting.signature;

			signature = $rootScope.addMaiStyling(signature);

			emailSettingsDataService.saveEmailSignature(signature).finally(function () {
				return $scope.isAddSignatureSpinnningWheelActive = false;
			}).subscribe(function () {
				return successSaveSignature();
			}, function () {
				return errorSaveSignature();
			});
		};

		$scope.uploadSignature = function (formData, insertCallback) {
			var companyImageError = function companyImageError() {
				toastr.error('Please make sure you upload a valid .JPG or .PNG file into the email signature.', "Something's not right here!");
			};
			var companyImageSizeError = function companyImageSizeError() {
				toastr.error("The file you're attaching is bigger than the 2 Mb.");
			};
			var serverError = function serverError() {
				toastr.error('Failed request to server');
			};

			function saveNewImgOnServer(formData) {
				emailSettingsDataService.setOnLoadImageSuccess(true);
				emailSettingsDataService.saveImage(formData).subscribe(function (result) {
					if (result.errorMessage === 'Unsupported Image Type!') {
						companyImageError();
						return;
					}
					getSettings();
					emailSettingsDataService.setOnLoadImageSuccess(false);
					messageService.showToaster('s_4', 'emailSettings');
				}, function () {
					return serverError();
				});
			}

			var insertImg = function insertImg(imgSrc) {
				var insertImgUrl = imgSrc + '?' + new Date().getTime();
				var htmlText = '<img src=\'' + insertImgUrl + '\'/>';

				insertCallback({
					html: htmlText,
					length: 1
				});
			};

			function getSettings() {
				emailSettingsDataService.getEmailSettings().subscribe(function (result) {
					insertImg(result.imageUrl);
				}, function () {
					return serverError();
				});
			}

			return saveNewImgOnServer(formData);
		};

		function showSpinnerImageUploading() {
			emailSettingsDataService.getOnLoadImageSuccess.subscribe(function (value) {
				return $scope.isImageLoadedSuccess = value;
			});
		}

		function successSaveSignature() {
			messageService.showToaster('s_2', 'emailTemplate');
		}

		function errorSaveSignature() {
			messageService.showToaster('e_0', 'general');
		}

		$scope.saveSnServerSettings = function () {
			$scope.isSNServerSettingsSpinnningWheelActive = true;

			var settings = $scope.setting.defaultSettings;
			$scope.defaultSettings = JSON.parse(JSON.stringify($scope.setting.defaultSettings));
			var replyTo = settings.replyTo,
			    from = settings.from;


			if (validationService.isStringEmpty(replyTo)) {
				$scope.isSNServerSettingsSpinnningWheelActive = false;
				return messageService.showToaster('e_0', 'emailSettings');
			}

			if (validationService.isStringEmpty(from)) {
				$scope.isSNServerSettingsSpinnningWheelActive = false;
				return messageService.showToaster('e_1', 'emailSettings');
			}

			emailSettingsDataService.saveSnServerSettings(settings).finally(function () {
				return $scope.isSNServerSettingsSpinnningWheelActive = false;
			}).subscribe(function () {
				return successSaveSnServerSettings();
			}, function () {
				return errorSaveSaveSnServerSettings();
			});
		};

		function successSaveSnServerSettings() {
			messageService.showToaster('s_2', 'emailTemplate');
			$('#snServerSettingsModal').modal('hide');
		}

		function errorSaveSaveSnServerSettings() {
			messageService.showToaster('e_0', 'general');
		}

		$scope.onConnectGmail = function () {
			$scope.connectGmail();
		};

		function getEmailData() {
			return emailSettingsDataService.getGmailReplyData();
		}

		function successGetEmailData(data) {
			if (data) {
				if (data.replySettingsMetadata) {
					$scope.replyAccountCredentialId = data.replySettingsMetadata.replyAccountCredentialId;
				}
				$scope.emailReplyData = data;
				$('#emailReplyModal').modal('show');
			}
		}

		$scope.openGmailPreferences = function () {
			$rootScope.lockSettingButtons = true;
			getEmailData().finally(function () {
				$rootScope.lockSettingButtons = false;
			}).subscribe(function (data) {
				successGetEmailData(data.data);
			});
		};

		$scope.onSaveSettings = function (event) {
			$scope.isGmailReplySpinningWheelActive = true;
			var replyAccountCredentialId = void 0;
			var receiveReplies = void 0;
			if (!event.data.replySettingsMetadata) {
				receiveReplies = false;
				replyAccountCredentialId = null;
			} else {
				replyAccountCredentialId = event.data.replySettingsMetadata.replyAccountCredentialId;
				receiveReplies = event.data.replySettingsMetadata.enabled;
			}

			saveGmailSettings(replyAccountCredentialId, receiveReplies, event.data.senderName, event.data.senderEmail);
			$location.url($location.path());
		};
		$scope.connectGmail = function () {
			$scope.isGmailSpinnningWheelActive = true;

			emailSettingsDataService.connectGmailServer().finally(function () {
				return $scope.isGmailSpinnningWheelActive = false;
			}).subscribe(function (data) {
				return successConnectGmail(data.url);
			}, function (error) {
				return errorConnectGmail();
			});
		};

		$scope.onModalClose = function () {
			$location.url($location.path());
		};

		function successConnectGmail(url) {
			window.location.assign(url);
		}

		function errorConnectGmail() {
			messageService.showToaster('e_0', 'general');
		}

		$scope.disconnectGmail = function () {
			emailSettingsDataService.disconnectGmailServer().finally(function () {
				return $scope.isGmailSpinnningWheelActive = false;
			}).subscribe(function () {
				return successDisconnectGmail();
			}, function () {
				return errorDisconnectGmail();
			});
		};

		function successDisconnectGmail() {
			changeServerType('DEFAULT');
			messageService.showToaster('s_0', 'emailSettings');
		}

		function errorDisconnectGmail() {
			messageService.showToaster('e_0', 'general');
		}

		function saveGmailConnection(code, accountCredentialId, receiveReplies, senderName, senderEmail) {
			emailSettingsDataService.saveGmailConnection(code, accountCredentialId, receiveReplies, senderName, senderEmail).switchMap(function () {
				return getEmailData();
			}).finally(function () {
				$rootScope.lockSettingButtons = false;
				$scope.isGmailReplySpinningWheelActive = false;
			}).subscribe(function (data) {
				changeServerType('GMAIL');
				successGetEmailData(data.data);
			}, function () {
				return errorSaveGmailConnection();
			});
		}

		function saveGmailSettings(accountCredentialId, receiveReplies, senderName, senderEmail) {
			emailSettingsDataService.saveGmailReplySettingData(accountCredentialId, receiveReplies, senderName, senderEmail).finally(function () {
				$location.url($location.path());
				$rootScope.lockSettingButtons = false;
				$scope.isGmailReplySpinningWheelActive = false;
			}).subscribe(function () {
				return successSaveGmailConnection();
			}, function (error) {
				return errorSaveGmailConnection(error);
			});
		}

		function successSaveGmailConnection() {
			changeServerType('GMAIL');
			messageService.showToaster('s_2', 'emailSettings', 'Gmail');
			$('#emailReplyModal').modal('hide');
		}

		function errorSaveGmailConnection(error) {
			$location.url($location.path());
			if (!!error.error.errorMessage || !!error.error.errorTitle) {
				var _error$error = error.error,
				    errorMessage = _error$error.errorMessage,
				    errorTitle = _error$error.errorTitle;

				if (errorTitle === '') {
					errorTitle = 'Whoops, something has gone wrong!';
				}
				messageService.showErrorFromBackend(errorTitle, errorMessage);
			} else {
				messageService.showToaster('e_5', 'emailSettings');
			}
		}

		$scope.openSMTPServerSettingsModal = function () {
			$rootScope.lockSettingButtons = true;
			emailSettingsDataService.getSmtpData().finally(function () {
				return $rootScope.lockSettingButtons = false;
			}).subscribe(function (data) {
				$scope.smtpData = JSON.parse(JSON.stringify(data));
				$('#smptServerSettingsModal').modal('show');
			});
		};

		$scope.onSmtpSave = function () {
			changeServerType('SMTP_SERVER');
			$('#smptServerSettingsModal').modal('hide');
		};

		$scope.disconnectSMTP = function () {
			$scope.lockSettingButtons = true;

			emailSettingsDataService.disconnectSMTPServer().finally(function () {
				return $scope.lockSettingButtons = false;
			}).subscribe(function () {
				return successDisconnectSMTP();
			}, function () {
				return errorDisconnectSMTP();
			});
		};

		function successDisconnectSMTP() {
			changeServerType('DEFAULT');
			messageService.showToaster('s_1', 'emailSettings');
		}

		function errorDisconnectSMTP() {
			messageService.showToaster('e_0', 'general');
		}

		function changeServerType(serverType) {
			$scope.isDefaultServer = false;
			$scope.isGmailConnected = false;
			$scope.isSMTPConnected = false;

			switch (serverType) {
				case 'SMTP_SERVER':
					$scope.isSMTPConnected = true;
					break;
				case 'GMAIL':
					$scope.isGmailConnected = true;
					break;
				default:
					/* if it's DEFAULT server type */
					$scope.isDefaultServer = true;
			}
		}

		$scope.sentNewNotification = function () {
			emailSettingsDataService.activateEmailNotification($scope.setting.sendNotification).subscribe(function (data) {
				return successSentNewNotification(data);
			}, function (err) {
				return messageService.showDefaultErrorMessage(err);
			});
		};

		function successSentNewNotification(data) {
			if (data) {
				if (data.errorMessage) {
					toastr.error(data.errorMessage, 'Error');
				} else {
					messageService.showToaster('s_5', 'emailTemplate');
				}
			} else {
				toastr.error('Wrong link');
			}
		}

		$scope.openSnServerSettingsModal = function () {
			$scope.modal_title = 'Studio Ninja server settings (default)';

			if (JSON.stringify($scope.defaultSettings) !== JSON.stringify($scope.setting.defaultSettings)) {
				$scope.setting.defaultSettings = JSON.parse(JSON.stringify($scope.defaultSettings));
			}

			$('#snServerSettingsModal').modal('show');
		};

		$scope.breadcrumbs = [{ link: '/', title: 'Dashboard' }, { link: '/settings', title: 'Settings' }, { link: null, title: 'Email Settings' }];

		function getSettings() {
			// $('#emailReplyModal').modal('show');
			emailSettingsDataService.getEmailSettings().subscribe(function (data) {
				return successGetSettings(data);
			}, function (error) {
				return messageService.showDefaultErrorMessage(error);
			});
		}

		function successGetSettings(data) {
			if (data) {
				$scope.setting = data;
				$scope.defaultSettings = JSON.parse(JSON.stringify($scope.setting.defaultSettings));
				changeServerType($scope.setting.activeServerType);
			} else {
				$scope.setting = {
					sendNotification: true
				};
			}
		}

		$scope.disableDragDrop = function () {
			return true;
		};

		$scope.addSubjectVariable = function ($event, id) {
			var el = document.getElementById(id);
			emailService.addSubjectVariable(el, $event);
		};

		$scope.activatePromoSubscription = function () {
			emailSettingsDataService.activatePromoSubscription($scope.setting.promoSubscription).subscribe(function () {
				messageService.showToaster('s_0', 'general', 'Settings updated');
				getSettings();
			}, function (error) {
				return messageService.showDefaultErrorMessage(error);
			});
		};
	}

	angular.module('main').controller('EmailSettingsController', EmailSettingsController);

	EmailSettingsController.$inject = ['$scope', '$rootScope', '$location', '$routeParams', 'messageService', 'validationService', 'emailSettingsDataService', 'emailService'];
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/toastr/toastr.js"), __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./web/js/controllers/settings/emailTemplatesController.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, toastr) {

(function () {
	function EmailTemplatesController($scope, $rootScope, $location, messageService, validationService, stringModifierService, fileUploadService, emailSettingsDataService, templateRequestsService, $timeout, $http, utilsService, emailService) {
		$scope.$on('$viewContentLoaded', function () {
			$scope.isDeleteTemplateSpinnningWheelActive = false;
			$scope.isSaveSpinnningWheelActive = false;
			$scope.isEditTemplateSpinnningWheelActive = false;
			$scope.isAddTemplateSpinnningWheelActive = false;
			$scope.isConfirmUpdateTemplateModalActive = false;
			$scope.isPaymentEmailTemplate = false;

			$scope.pageRequest = {
				page: 1,
				perPage: $rootScope.paginationPerPage ? $rootScope.paginationPerPage : 25,
				pageOrder: {
					predicate: 'name',
					reverse: false
				},
				search: null
			};

			getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
			initReminder();
		});

		clearEditedAttachments();
		clearNewAttachments();

		function clearEditedAttachments() {
			$scope.editedAttachmentsData = {
				attachments: [],
				filesSize: 0
			};
		}

		function clearNewAttachments() {
			$scope.newAttachmentsData = {
				attachments: [],
				filesSize: 0
			};
		}

		window.changeImg = false;

		$scope.changeTemplateAttachment = function (ev) {
			$scope.editedAttachmentsData = ev;
		};

		$scope.createEmailTemplate = function () {
			$scope.isAddTemplateSpinnningWheelActive = true;

			var emailTemplate = angular.copy($scope.newEmailTemplate);

			var maxSize = 10; // 10Mb

			if ($scope.newAttachmentsData && $scope.newAttachmentsData.filesSize > maxSize) {
				messageService.showToaster('w_0', 'attachments');
				$scope.isAddTemplateSpinnningWheelActive = false;
				return false;
			}

			if (!isEmailFieldsValid(emailTemplate)) {
				$scope.isAddTemplateSpinnningWheelActive = false;
				return;
			}

			if (emailTemplate) {
				emailTemplate.text = $rootScope.addMaiStyling(emailTemplate.text);
			}

			if (emailTemplate.id) {
				delete emailTemplate.id;
			}

			var attachments = $scope.newAttachmentsData.attachments;


			var uploadedAttachments = void 0,
			    storedAttachments = void 0;

			if (attachments.length) {
				uploadedAttachments = attachments.filter(function (attachment) {
					return !attachment.id;
				});

				storedAttachments = attachments.filter(function (attachment) {
					return attachment.id;
				});
			}

			emailTemplate.storedAttachments = storedAttachments && storedAttachments.length ? storedAttachments : null;

			if (uploadedAttachments && uploadedAttachments.length) {
				fileUploadService.convertFileToSave(uploadedAttachments).then(function (convertedFilesArr) {
					emailTemplate.base64Attachments = convertedFilesArr;
					saveEmailTemplate(emailTemplate);
				}).catch(function (error) {
					return console.log(error);
				});
			} else {
				saveEmailTemplate(emailTemplate);
			}
		};

		function saveEmailTemplate(emailTemplate) {
			emailSettingsDataService.saveEmailTemplate(emailTemplate).finally(function () {
				return $scope.isAddTemplateSpinnningWheelActive = false;
			}).subscribe(function (data) {
				return successCreateEmailTemplate(data);
			}, function (err) {
				return errorSaveEmailTemplate(err);
			});
		}

		function successCreateEmailTemplate(data) {
			messageService.showToaster('s_4', 'emailTemplate', $scope.newEmailTemplate.name);
			$('#addNewTemplateModal').modal('hide');
			getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
			delete $scope.newEmailTemplate;
		}

		function errorSaveEmailTemplate(_ref) {
			var error = _ref.error;
			var errorTitle = error.errorTitle,
			    errorMessage = error.errorMessage;


			if (errorMessage === 'Email template with same name is already exist') {
				messageService.showToaster('e_8', 'emailTemplate');
			} else {
				messageService.showErrorFromBackend(errorTitle, errorMessage);
			}
			$scope.isConfirmUpdateTemplateModalActive = false;
		}

		$scope.addSubjectVariable = function ($event, id, type) {
			var el = document.getElementById(id);
			var subject = emailService.addSubjectVariable(el, $event);
			switch (type) {
				case 'REMINDER':
					$scope.reminder.subject = subject;
					break;
				case 'EDIT':
					$scope.editedEmailTemplate.subject = subject;
					break;
				case 'CREATE':
					$scope.newEmailTemplate.subject = subject;
					break;
				default:
					break;
			}
		};

		$scope.openEditModal = function (index) {
			var currentEmailTemplate = $scope.emailTemplates[index];
			var defaultEmailTemplate = currentEmailTemplate.defaultEmailTemplate;


			getEmailTemplate(currentEmailTemplate.id, function (result) {
				var data = angular.copy(result);

				console.log(data);

				data.defaultEmailTemplate = defaultEmailTemplate;
				if (data.storedAttachments.length) {
					$scope.editedAttachmentsData = {
						attachments: data.storedAttachments
					};
					console.log($scope.editedAttachmentsData);
				} else {
					clearEditedAttachments();
				}

				if ($scope.$parent.editedEmailTemplate) {
					$scope.$parent.editedEmailTemplate = data;
				} else {
					$scope.editedEmailTemplate = data;
				}

				checkIfDefaultPaymentTemplate(defaultEmailTemplate);

				$('#editEmailTemplateModal').modal('show').on('shown.bs.modal', function () {
					$(this).find('input').first().focus();

					var input = $(this).find('input');

					validationService.isModalClosePrevented(input);
				});
			});
		};

		function isEmailFieldsValid(email) {
			var name = email.name,
			    subject = email.subject;


			if (validationService.isStringEmpty(name)) {
				messageService.showToaster('e_9', 'emailTemplate', 'name');
				return false;
			}

			if (validationService.isStringEmpty(subject)) {
				messageService.showToaster('e_9', 'emailTemplate', 'subject');
				return false;
			}

			return true;
		}

		$scope.validateEditedTemplate = function (event) {
			$scope.isEditTemplateSpinnningWheelActive = true;

			var maxSize = 10; // 10Mb

			if ($scope.editedAttachmentsData && $scope.editedAttachmentsData.filesSize > maxSize) {
				messageService.showToaster('w_0', 'attachments');
				$scope.isEditTemplateSpinnningWheelActive = false;
				return false;
			}

			if (!isEmailFieldsValid($scope.editedEmailTemplate)) {
				$scope.isEditTemplateSpinnningWheelActive = false;
				return false;
			}

			if ($scope.editedEmailTemplate) {
				$scope.editedEmailTemplate.text = $rootScope.addMaiStyling($scope.editedEmailTemplate.text);
			}

			var attachments = $scope.editedAttachmentsData.attachments;


			var uploadedAttachments = void 0,
			    storedAttachments = void 0;

			if (attachments.length) {
				uploadedAttachments = attachments.filter(function (attachment) {
					return !attachment.id;
				});

				storedAttachments = attachments.filter(function (attachment) {
					return attachment.id;
				});
			}

			$scope.editedEmailTemplate.storedAttachments = storedAttachments && storedAttachments.length ? storedAttachments : null;

			if (uploadedAttachments && uploadedAttachments.length) {
				fileUploadService.convertFileToSave(uploadedAttachments).then(function (convertedFilesArr) {
					$scope.editedEmailTemplate.base64Attachments = convertedFilesArr;
					saveEditedEmailTemplate($scope.editedEmailTemplate, event);
				}).catch(function (error) {
					return console.log(error);
				});
			} else {
				saveEditedEmailTemplate($scope.editedEmailTemplate);
			}
		};

		function saveEditedEmailTemplate(emailTemplate, event) {
			emailSettingsDataService.updateEmailTemplate(emailTemplate).finally(function () {
				return $scope.isEditTemplateSpinnningWheelActive = false;
			}).subscribe(function () {
				return successValidation(event);
			}, function (err) {
				return errorValidation(err);
			});
		}

		function successValidation(event) {
			$scope.isEditTemplateSpinnningWheelActive = true;
			emailSettingsDataService.confirmEditEmailTemplate($scope.editedEmailTemplate).finally(function () {
				return $scope.isEditTemplateSpinnningWheelActive = false;
			}).subscribe(function () {
				return successEditEmailTemplate();
			}, function (err) {
				return errorSaveEmailTemplate(err);
			});
		}

		function errorValidation(result) {
			var data = result.data,
			    status = result.status;


			if (status !== 422) {
				return messageService.showToaster('e_0', 'general');
			}

			var path = $location.path();
			var emailName = $scope.editedEmailTemplate.defaultEmailTemplate;

			if (data.errorMessage) {
				var isEmailNameRepeated = data.errorMessage === 'Email template with same name is already exist';
				if (isEmailNameRepeated) {
					return messageService.showToaster('e_8', 'emailTemplate');
				}
			}

			if (path.includes('settings')) {
				return showMessagesForEmailLinks(emailName);
			}
		}

		function showMessagesForEmailLinks(emailName) {
			var errorCode = void 0;
			switch (emailName) {
				case 'QUOTE_EMAIL_TEMPLATE':
					errorCode = 'e_1';
					break;
				case 'INVOICE_EMAIL_TEMPLATE':
					errorCode = 'e_0';
					break;
				case 'CONTRACT_EMAIL_TEMPLATE':
					errorCode = 'e_2';
					break;
				case 'QUESTIONNAIRE_EMAIL_TEMPLATE':
					errorCode = 'e_3';
					break;
				case 'RECEIPT_OF_PAYMENT_EMAIL_TEMPLATE':
					errorCode = 'e_4';
					break;
				default:
					return messageService.showToaster('e_0', 'general');
			}
			return messageService.showToaster(errorCode, 'emailTemplate');
		}

		function successEditEmailTemplate() {
			messageService.showToaster('s_3', 'emailTemplate', $scope.editedEmailTemplate.name);
			getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
			$('#editEmailTemplateModal').modal('hide');
			$scope.isConfirmUpdateTemplateModalActive = false;
		}

		$scope.duplicateEmailTemplate = function (index) {
			getEmailTemplate($scope.emailTemplates[index].id, function (result) {
				$scope.newEmailTemplate = result;
				if (result.storedAttachments.length) {
					$scope.newAttachmentsData = {
						attachments: fileUploadService.convertAttachmentsToShow(result.storedAttachments)
					};
				} else {
					clearNewAttachments();
				}

				$scope.modal_title = 'Duplicate email template';
				$('#addNewTemplateModal').modal('show').on('shown.bs.modal', function () {
					$(this).find('input').first().focus();

					var input = $(this).find('input');

					validationService.isModalClosePrevented(input);
				});
			});
		};

		$scope.openAddModal = function () {
			delete $scope.newEmailTemplate;
			clearNewAttachments();
			$scope.modal_title = 'Add a new email template';
			$('#addNewTemplateModal').modal('show').on('shown.bs.modal', function () {
				$(this).find('input').first().focus();

				var input = $(this).find('input');

				validationService.isModalClosePrevented(input);
			});
		};

		$scope.openDeleteWindow = function (index) {
			$scope.$parent.deleteableEmailTemplate = $scope.emailTemplates[index];
			$('#deleteEmailTemplateModal').modal('show');
		};

		$scope.deleteEmailTemplate = function () {
			$scope.isDeleteTemplateSpinnningWheelActive = true;

			emailSettingsDataService.deleteEmailTemplate($scope.deleteableEmailTemplate).finally(function () {
				return $scope.isDeleteTemplateSpinnningWheelActive = false;
			}).subscribe(function () {
				return successDeleteEmailTemplate();
			}, function (err) {
				return errorDeleteEmailTemplate(err.data);
			});
		};

		$scope.breadcrumbs = [{ link: '/', title: 'Dashboard' }, { link: '/settings', title: 'Settings' }, { link: null, title: 'Email Templates' }];

		function successDeleteEmailTemplate() {
			messageService.showToaster('s_0', 'emailTemplate', $scope.deleteableEmailTemplate.name);
			getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
			$('#deleteEmailTemplateModal').modal('hide');
		}

		function errorDeleteEmailTemplate(data) {
			var isEmailUsed = data.errorMessage === 'Email template is used in workflow(s)';
			isEmailUsed ? messageService.showToaster('e_7', 'emailTemplate') : messageService.showToaster('e_0', 'general');
		}

		function getEmailTemplate(emailTemplateId, outObject) {
			templateRequestsService.getTemplates('template_without_signature', emailTemplateId).subscribe(function (data) {
				return successGetEmailTemplate(data, outObject);
			}, function (err) {
				return messageService.showDefaultErrorMessage(err);
			});
		}

		function successGetEmailTemplate(data, outObject) {
			if (data) {
				outObject(data);
			} else {
				toastr.error('Failed to load email template');
			}
		}

		function getResultsPage(pageNumber, perPage, predicate, reverse) {
			var changed = false;
			if (typeof predicate !== 'undefined' && predicate !== null && typeof reverse !== 'undefined' && reverse !== null) {
				$scope.pageRequest.pageOrder.predicate = predicate;
				$scope.pageRequest.pageOrder.reverse = reverse;
				changed = true;
			}

			if (typeof perPage !== 'undefined' && perPage !== null) {
				$scope.pageRequest.perPage = perPage;
				changed = true;
			}
			if (typeof pageNumber !== 'undefined' && pageNumber !== null) {
				$scope.pageRequest.page = pageNumber;
				changed = true;
			}

			if ($scope.pageRequest && $scope.totalItems !== 0 && $scope.totalItems < ($scope.pageRequest.page - 1) * $scope.pageRequest.perPage + 1) {
				$scope.pageRequest.page = 1;
			}
			if (changed) {
				emailSettingsDataService.getEmailTemplatesOnPage($scope.pageRequest).subscribe(function (data) {
					return successGetResultPage(data);
				}, function () {
					return console.error("can't get result page");
				});
			}
		}

		function successGetResultPage(data) {
			if (data && data.pageRequest) {
				$scope.pageRequest = data.pageRequest;
			}
			$scope.pageNumbers = [];
			$scope.totalItems = data.total;
			var pagesCount = $scope.totalItems / $scope.pageRequest.perPage;
			pagesCount = Math.ceil(pagesCount);
			for (var i = 1; i <= pagesCount; i++) {
				$scope.pageNumbers[i - 1] = i;
			}
			$scope.emailTemplates = addWorkflowNamesToTemplate(data.results);
		}

		function addWorkflowNamesToTemplate(templates) {
			return templates.map(function (template) {
				var isTemplateUsedInWorkflows = template.usingWorkflows.length > 0;
				template.nameToShow = isTemplateUsedInWorkflows ? template.name + stringModifierService.getUsedWorkflowsString(template.usingWorkflows) : template.name;
				return template;
			});
		}

		function checkIfDefaultPaymentTemplate(defaultEmailTemplate) {
			console.log(defaultEmailTemplate);
			if (defaultEmailTemplate === 'INVOICE_EMAIL_TEMPLATE' || defaultEmailTemplate === 'QUOTE_EMAIL_TEMPLATE') {
				$scope.isPaymentEmailTemplate = true;
			} else {
				$scope.isPaymentEmailTemplate = false;
			}
		}

		$scope.order = function (predicate) {
			$scope.pageRequest.pageOrder.reverse = $scope.pageRequest.pageOrder.predicate === predicate ? !$scope.pageRequest.pageOrder.reverse : false;
			getResultsPage(null, null, predicate, $scope.pageRequest.pageOrder.reverse);
		};

		$scope.getCurrentPage = function () {
			return $scope.pageRequest.page;
		};

		$scope.perPageChanged = function (newPerPage) {
			getResultsPage(null, newPerPage);
			$rootScope.paginationPerPage = newPerPage;
		};

		$scope.goToPage = function (newPage, disabled) {
			if (!disabled) {
				getResultsPage(newPage, null);
			}
		};

		$scope.jumpBack = function (disabled) {
			if (!disabled) {
				if ($scope.pageRequest.page > 1) {
					getResultsPage($scope.pageRequest.page - 1, null);
				}
			}
		};

		$scope.jumpAhead = function (disabled) {
			if (!disabled) {
				if ($scope.totalItems >= $scope.pageRequest.page * $scope.pageRequest.perPage + 1) {
					getResultsPage($scope.pageRequest.page + 1, null);
				}
			}
		};

		$scope.disableDragDrop = function () {
			return true;
		};

		function initReminder() {
			$http.get('/protected/rest/calendar_reminder/get').then(function (result) {
				if (result.data) {
					$scope.reminder = result.data;
				} else {
					messageService.showToaster('e_0', 'general');
				}
			}, function () {
				messageService.showToaster('e_0', 'general');
			});
		}

		$scope.saveReminder = function () {
			$timeout(function () {
				if ($scope.reminder.text == '' || $scope.reminder.text == null) {
					messageService.showToaster('e_2', 'generalValidation');
					return false;
				}
				if (!emailService.isSubjectValid($scope.reminder.subject)) {
					return;
				}

				$scope.reminder.text = $rootScope.addMaiStyling($scope.reminder.text);
				$scope.isSaveSpinnningWheelActive = true;
				$http({
					method: 'POST',
					url: '/protected/rest/calendar_reminder/save',
					data: $scope.reminder
				}).then(function () {
					messageService.showToaster('s_0', 'googleCalendar');
				}, function (_ref2) {
					var data = _ref2.data;
					var errorMessage = data.errorMessage,
					    errorTitle = data.errorTitle;

					if (errorTitle) {
						messageService.showErrorFromBackend(errorTitle, errorMessage);
					} else {
						messageService.showToaster('e_0', 'general');
					}
				}).then(function () {
					$scope.isSaveSpinnningWheelActive = false;
				});
			}, 1000);
		};
	}

	angular.module('main').controller('EmailTemplatesController', EmailTemplatesController);

	EmailTemplatesController.$inject = ['$scope', '$rootScope', '$location', 'messageService', 'validationService', 'stringModifierService', 'fileUploadService', 'emailSettingsDataService', 'templateRequestsService', '$timeout', '$http', 'utilsService', 'emailService'];
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js"), __webpack_require__("./node_modules/toastr/toastr.js")))

/***/ }),

/***/ "./web/js/controllers/settings/integrationsController.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
	angular.module('main').controller('IntegrationsController', IntegrationsController);

	IntegrationsController.$inject = ['$scope', '$routeParams'];

	function IntegrationsController($scope, $routeParams) {
		$scope.$on('$viewContentLoaded', function () {
			$scope.routeParams = $routeParams;
		});
	}
})();

/***/ }),

/***/ "./web/js/controllers/settings/jobTypesController.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, toastr) {

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

(function () {
	function JobTypesController($scope, $rootScope, $http, messageService, $timeout, accountService, workflowDataService) {
		$scope.$on('$viewContentLoaded', function () {
			$scope.isSaveJobSpinnningWheelActive = false;
			$scope.isJobTypeHaveWorkflow = false;
			$scope.isDeleteJobSpinnningWheelActive = false;
			$scope.pageRequest = {
				page: 1,
				perPage: $rootScope.paginationPerPage ? $rootScope.paginationPerPage : 25,
				pageOrder: {
					predicate: 'name',
					reverse: false
				},
				search: ''
			};
			$scope.pagindis = true;
			$scope.jobTypes = [];
			$scope.totalItems = 0;
			$scope.searchText = '';
			$scope.pageRequest.search = '';
			getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
			getCompanyId();
			$http.get('/protected/rest/job/types/colours').then(function (result) {
				if (result) {
					$scope.colours = result.data;
				}
			});
			workflowDataService.getWorkflowNames().subscribe(function (data) {
				if (data) {
					$scope.workflows = {
						workflowNames: [].concat(_toConsumableArray(data))
					};
				}
			});
		});

		function closeColorSelect() {
			$scope.active = !$scope.active;
		}

		$scope.order = function (predicate) {
			$scope.pageRequest.pageOrder.reverse = $scope.pageRequest.pageOrder.predicate === predicate ? !$scope.pageRequest.pageOrder.reverse : false;
			getResultsPage(null, null, predicate, $scope.pageRequest.pageOrder.reverse);
		};

		$scope.getCurrentPage = function () {
			return $scope.pageRequest.page;
		};

		$scope.perPageChanged = function (newPerPage) {
			getResultsPage(null, newPerPage);
			$rootScope.paginationPerPage = newPerPage;
		};
		$scope.goToPage = function (newPage, disabled) {
			if (!disabled) {
				getResultsPage(newPage, null);
			}
		};
		$scope.jumpBack = function (disabled) {
			if (!disabled) {
				if ($scope.pageRequest.page > 1) {
					getResultsPage($scope.pageRequest.page - 1, null);
				}
			}
		};
		$scope.jumpAhead = function (disabled) {
			if (!disabled) {
				if ($scope.totalItems >= $scope.pageRequest.page * $scope.pageRequest.perPage + 1) {
					getResultsPage($scope.pageRequest.page + 1, null);
				}
			}
		};

		function getResultsPage(pageNumber, perPage, predicate, reverse) {
			var changed = false;
			if (typeof predicate !== 'undefined' && predicate != null && typeof reverse !== 'undefined' && reverse != null) {
				$scope.pageRequest.pageOrder.predicate = predicate;
				$scope.pageRequest.pageOrder.reverse = reverse;
				changed = true;
			}

			if (typeof perPage !== 'undefined' && perPage != null) {
				$scope.pageRequest.perPage = perPage;
				changed = true;
			}
			if (typeof pageNumber !== 'undefined' && pageNumber != null) {
				$scope.pageRequest.page = pageNumber;
				changed = true;
			}

			if ($scope.pageRequest && $scope.totalItems != 0 && $scope.totalItems < ($scope.pageRequest.page - 1) * $scope.pageRequest.perPage + 1) {
				$scope.pageRequest.page = 1;
			}
			if (changed) {
				$http.get('/protected/rest/job/types?perPage=' + $scope.pageRequest.perPage + '&page=' + $scope.pageRequest.page + '&predicate=' + $scope.pageRequest.pageOrder.predicate + '&reverse=' + $scope.pageRequest.pageOrder.reverse).then(function (result) {
					if (result.data && result.data.pageRequest) {
						$scope.pageRequest = result.data.pageRequest;
						$scope.pageRequest.search = $scope.searchText;
					}
					$scope.pageNumbers = [];
					$scope.totalItems = result.data.total;
					var pagesCount = $scope.totalItems / $scope.pageRequest.perPage;
					pagesCount = Math.ceil(pagesCount);
					for (var i = 1; i <= pagesCount; i++) {
						$scope.pageNumbers[i - 1] = i;
					}
					$scope.jobTypes = result.data.results;
					// $scope.defaultJobType = $scope.jobTypes.find((type) => type.default);
					$scope.defaultJobType = {};
				});
			}
		}
		function getCompanyId() {
			accountService.companyIdObservable.subscribe(function (data) {
				$scope.companyId = data;
			});
		}
		$scope.editTypeModal = function (jobType) {
			$scope.jobTypeEdit = angular.copy(jobType) || {};
			if ($scope.active) {
				closeColorSelect();
			}
			if ($scope.jobTypeEdit.workflow !== undefined && $scope.jobTypeEdit.workflow.id === null || !$scope.jobTypeEdit.workflow) {
				$scope.isJobTypeHaveWorkflow = true;
				$scope.jobTypeEdit.workflow = $scope.workflows.workflowNames.find(function (el) {
					return el.name === 'Default';
				});
			}

			$('#jobTypeEditModal').modal('show');
		};
		$scope.deleteTypeModal = function (jobType) {
			$scope.jobTypeDelete = angular.copy(jobType);
			$('#jobTypeDeleteModal').modal('show');
		};
		$scope.deleteType = function () {
			$scope.isDeleteJobSpinnningWheelActive = true;
			$http.get('/protected/rest/job/types/delete?id=' + $scope.jobTypeDelete.id).then(function (result) {
				if (result.errorMessage) {
					toastr.error('Try again later.', 'Server error.');
				} else {
					messageService.showToaster('s_0', 'jobTypes', $scope.jobTypeDelete.name);
					$('#jobTypeDeleteModal').modal('hide');
					getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
					if (parseInt(localStorage.getItem('dashboardJobType' + $scope.companyId)) === $scope.jobTypeDelete.id) {
						localStorage.setItem('dashboardJobType' + $scope.companyId, '-1');
					}
				}
				$scope.isDeleteJobSpinnningWheelActive = false;
			}, function () {
				messageService.showToaster('e_3', 'jobTypes');
				$scope.isDeleteJobSpinnningWheelActive = false;
			});
		};

		$scope.setColor = function (colour) {
			closeColorSelect();
			$scope.jobTypeEdit.colour = colour;
		};

		$scope.editType = function () {
			if ($scope.jobTypeEdit.workflow === undefined) {
				delete $scope.jobTypeEdit.workflow;
			}

			$scope.isSaveJobSpinnningWheelActive = true;
			if (!$scope.jobTypeEdit.name) {
				$scope.isSaveJobSpinnningWheelActive = false;
				return messageService.showToaster('e_2', 'jobTypes');
			}

			if (!$scope.jobTypeEdit.colour) {
				$scope.isSaveJobSpinnningWheelActive = false;
				return messageService.showToaster('e_1', 'jobTypes');
			}

			$http.post('/protected/rest/job/types/edit', $scope.jobTypeEdit).then(function () {
				return $scope.successTypeEdit($scope.jobTypeEdit);
			}).catch(messageService.showDefaultErrorMessage);
		};

		$scope.successTypeEdit = function (jobTypeEdit) {
			getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);

			if (jobTypeEdit.id) {
				messageService.showToaster('s_1', 'jobTypes', $scope.jobTypeEdit.name);
			} else {
				messageService.showToaster('s_2', 'jobTypes', $scope.jobTypeEdit.name);
			}

			$('#jobTypeEditModal').modal('hide');

			$scope.isSaveJobSpinnningWheelActive = false;
		};

		$scope.updateSelection = function (position, jobTypes, id) {
			jobTypes.map(function (jobType, index) {
				if (position !== index) {
					jobType.default = false;
				} else {
					jobType.default = true;
					if ($scope.defaultJobType.id !== jobType.id) {
						$http.post('/protected/rest/job/types/default/' + id, $scope.jobTypes);
					}
					$scope.defaultJobType.id = jobType.id;
				}
			});
		};

		$scope.breadcrumbs = [{ link: '/', title: 'Dashboard' }, { link: '/settings', title: 'Settings' }, { link: null, title: 'Job Types' }];
	}

	angular.module('main').controller('JobTypesController', JobTypesController);

	JobTypesController.$inject = ['$scope', '$rootScope', '$http', 'messageService', '$timeout', 'accountService', 'workflowDataService'];
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js"), __webpack_require__("./node_modules/toastr/toastr.js")))

/***/ }),

/***/ "./web/js/controllers/settings/labelsSettingsController.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
	angular.module('main').controller('LabelsSettingsController', LabelsSettingsController);

	LabelsSettingsController.$inject = [];

	function LabelsSettingsController() {}
})();

/***/ }),

/***/ "./web/js/controllers/settings/leadSourcesSettingsController.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
	angular.module('main').controller('LeadSourcesSettingsController', LeadSourcesSettingsController);

	LeadSourcesSettingsController.$inject = ['$scope', '$location', 'settingsService'];

	function LeadSourcesSettingsController($scope, $location, settingsService) {
		$scope.$on('$viewContentLoaded', function () {
			settingsService.timeFormatSettings.subscribe(function (data) {
				if (data.leadSourcesAvailable === false) {
					$location.url('/');
				}
			});
		});
	}
})();

/***/ }),

/***/ "./web/js/controllers/settings/paymentMethodsController.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
	angular.module('main').controller('PaymentMethodsController', PaymentMethodsController);

	PaymentMethodsController.$inject = [];

	function PaymentMethodsController() {}
})();

/***/ }),

/***/ "./web/js/controllers/settings/paymentSchedulesControllers.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(toastr, $) {

(function () {
	var PaymentSchedulesController = function PaymentSchedulesController($scope, $rootScope, $http, $q, $location, messageService, validationService, userService, paymentSchedulesDataService, accountService, settingsService, emailService) {
		$scope.$on('$viewContentLoaded', function () {
			$scope.isSaveReminderSpinnningWheelActive = false;
			$scope.isSavePaymentSpinnningWheelActive = false;
			$scope.button_disable = false;
			$scope.editedPaymentSchedule = null;
			$scope.deletablePaymentSchedule = {};
			$scope.payments = [];
			$scope.delIndex = -1;
			$scope.modalTitle = '';
			$scope.pageRequest = {
				page: 1,
				perPage: $rootScope.paginationPerPage ? $rootScope.paginationPerPage : 25,
				pageOrder: {
					predicate: 'name',
					reverse: false
				},
				search: null
			};
			$scope.reminder = {};
			$scope.customizedLabels = {};
			getUser();
			getInvoiceReminder();
			getPaymentReceipt();

			getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
		});

		function getUser() {
			$scope.userObservable = accountService.getUserWeb().subscribe(function (user) {
				if (user !== null && typeof user !== 'undefined') {
					$scope.currencyCode = user.currency.currencyCode;
					settingsService.customizeLabelsObservable.subscribe(function (data) {
						$scope.customizedLabels = data;
						paymentSchedulesDataService.getPaymentScheduleOptions().subscribe(function (data) {
							return getPaymentScheduleOptionsSuccessCallback(data);
						}, function (err) {
							return getPaymentScheduleOptionsErrorCallback(err);
						});
					});
				}
			});
		}
		function getPaymentScheduleOptionsSuccessCallback(data) {
			if (!data) {
				console.error('No data for payment schedule options');
				return;
			}
			$scope.payments.push({
				amount: '',
				type: ''
			});

			var paymentScheduleTypes = data.paymentScheduleTypes,
			    dateItemsTypes = data.dateItemsTypes,
			    jobDateDependingTypes = data.jobDateDependingTypes,
			    indexOfOnJobDate = data.indexOfOnJobDate,
			    indexOfOnInvoiceDate = data.indexOfOnInvoiceDate;

			$scope.paymentScheduleTypes = configPaymentScheduleTypes(paymentScheduleTypes);
			$scope.payments[0].type = paymentScheduleTypes[0];
			$scope.dateItemsTypes = dateItemsTypes;
			$scope.payments[0].dateItemsType = dateItemsTypes[0];
			$scope.jobDateDependingTypes = configPaymentScheduleJobDependingTypes(jobDateDependingTypes);
			$scope.indexOfOnJobDate = indexOfOnJobDate;
			$scope.indexOfOnInvoiceDate = indexOfOnInvoiceDate;
			$scope.paymentsModel = angular.copy($scope.payments);
		}

		function configPaymentScheduleJobDependingTypes(jobDependingTypes) {
			return jobDependingTypes.map(function (el) {
				return setCorrectNaming(el);
			});
		}

		function setCorrectNaming(el) {
			var res = { id: el, name: '' };
			if (el.includes('main shoot')) {
				res.name = el.replace('main shoot', $scope.customizedLabels.mainShootLabel.toLowerCase());
			} else if (el.includes('invoice date')) {
				res.name = el.replace('invoice date', 'quote or invoice created date');
			} else {
				res.name = el;
			}
			return res;
		}

		function configPaymentScheduleTypes(types) {
			var typesObjArray = [];
			types.forEach(function (type) {
				typesObjArray.push({
					name: type === 'Dollars' ? $scope.currencyCode : type,
					key: type
				});
			});

			return typesObjArray;
		}

		function getPaymentScheduleOptionsErrorCallback() {
			toastr.error('No available payment types', 'Error');
		}

		function getInvoiceReminder() {
			$http.get('/protected/rest/invoice_reminder/get').then(function (result) {
				if (result.data) {
					$scope.reminder = result.data;
				} else {
					$q.reject(result);
				}
			}).catch(messageService.showDefaultErrorMessage);
		}

		function getPaymentReceipt() {
			$http.get('/protected/rest/payment-receipt/settings/get').then(function (result) {
				if (result.data) {
					$scope.paymentReceipt = result.data;
				} else {
					$q.reject(result);
				}
			}).catch(messageService.showDefaultErrorMessage);
		}

		$scope.saveReminder = function () {
			if ($scope.reminder.beforeDueDate && $scope.reminder.daysBeforeDueDate == null) {
				messageService.showToaster('e_3', 'generalValidation');
			} else if ($scope.reminder.afterDueDate && $scope.reminder.daysAfterDueDate == null) {
				messageService.showToaster('e_3', 'generalValidation');
			} else if ($scope.reminder.afterDueDate && $scope.reminder.daysRegularlyAfterDueDate == null) {
				messageService.showToaster('e_3', 'generalValidation');
			} else if (!emailService.isSubjectValid($scope.reminder.emailSubject)) {} else {
				$scope.isSaveReminderSpinnningWheelActive = true;
				$scope.reminder.emailText = $rootScope.addMaiStyling($scope.reminder.emailText);

				$http({
					url: '/protected/rest/invoice_reminder/save',
					method: 'POST',
					data: $scope.reminder
				}).then(function (result) {
					if (result.data.message || result.status === 204) {
						messageService.showToaster('s_1', 'paymentSchedules');
					} else if (result.data.errorMessage) {
						messageService.showToaster('e_2', 'paymentSchedules');
					} else {
						messageService.showToaster('e_0', 'general');
					}
					$scope.isSaveReminderSpinnningWheelActive = false;
				}, function (result) {
					$scope.isSaveReminderSpinnningWheelActive = false;

					var _result$data = result.data,
					    errorTitle = _result$data.errorTitle,
					    errorMessage = _result$data.errorMessage;

					if (errorTitle && errorMessage) {
						return messageService.showErrorFromBackend(errorTitle, errorMessage);
					}
					if (result.status === 422) {
						var path = $location.path();
						if (path.indexOf('payment_schedules') !== -1) {
							return messageService.showToaster('e_0', 'paymentSchedules');
						}

						return messageService.showToaster('e_0', 'general');
					}
					return messageService.showToaster('e_0', 'general');
				});
			}
		};

		$scope.savePaymentReceipt = function () {
			if (!emailService.isSubjectValid($scope.paymentReceipt.emailSubject)) {
				return;
			}

			$scope.paymentReceipt.emailText = $rootScope.addMaiStyling($scope.paymentReceipt.emailText);
			$scope.isSavePaymentSpinnningWheelActive = true;

			$http({
				url: '/protected/rest/payment-receipt/settings/save',
				method: 'POST',
				data: $scope.paymentReceipt
			}).then(successSaveReceipt).catch(errorSaveReceipt).finally(function () {
				$scope.isSavePaymentSpinnningWheelActive = false;
			});

			function successSaveReceipt() {
				messageService.showToaster('s_4', 'paymentSchedules');
			}
		};

		function errorSaveReceipt(_ref) {
			var status = _ref.status,
			    data = _ref.data;
			var errorTitle = data.errorTitle,
			    errorMessage = data.errorMessage;

			var errorCode = void 0,
			    errorPlace = void 0,
			    value = void 0;

			if (status >= 400 && status < 500 && data.errorMessage) {
				if (data.errorMessage.includes("You're trying to save the Receipt of payment email template without a invoice link!")) {
					errorCode = 'e_4';
					errorPlace = 'emailTemplate';
				} else if (errorTitle) {
					messageService.showErrorFromBackend(errorTitle, errorMessage);
					return;
				} else {
					errorCode = 'e_2';
					errorPlace = 'general';
					value = data.errorMessage;
				}
			} else {
				errorCode = 'e_0';
				errorPlace = 'general';
			}
			messageService.showToaster(errorCode, errorPlace, value);
		}

		$scope.addPayment = function () {
			$scope.payments.push({
				jobDateDepending: $scope.jobDateDependingTypes[0].id,
				dateItemsType: $scope.dateItemsTypes[0],
				type: $scope.paymentScheduleTypes[0].key
			});
		};

		$scope.addSubjectVariable = function ($event, id, type) {
			var el = document.getElementById(id);
			var subject = emailService.addSubjectVariable(el, $event);
			if (type === 'RECEIPT') {
				$scope.paymentReceipt.emailSubject = subject;
			}
			if (type === 'REMINDER') {
				$scope.reminder.emailSubject = subject;
			}
		};

		$scope.clearForm = function () {
			$scope.name = '';
			$scope.payments = [{
				amount: null,
				dateItemsType: $scope.dateItemsTypes[0],
				jobDateDepending: $scope.jobDateDependingTypes[0].id,
				type: $scope.paymentScheduleTypes[0].key
			}];
		};

		$scope.addPaymentSchedule = function () {
			$scope.modalTitle = 'New';
			$scope.editedPaymentSchedule = null;
			$('#paymentScheduleModal').modal('show');
		};

		$scope.breadcrumbs = [{ link: '/', title: 'Dashboard' }, { link: '/settings', title: 'Settings' }, { link: null, title: 'Invoice & Payment Settings' }];

		$scope.duplicatePaymentSchedule = function (index) {
			getPaymentSchedule($scope.paymentSchedules[index].id, function (data) {
				$scope.modalTitle = 'New';
				$scope.editedPaymentSchedule = data;
				$('#paymentScheduleModal').modal('show');
			});
		};

		$scope.editPaymentSchedule = function (index) {
			$.blockUI();
			$http.get('/api/user/settings/payment-schedules/' + $scope.paymentSchedules[index].id).then(function (result) {
				$.unblockUI();
				if (result.data.data) {
					$scope.modalTitle = 'Edit';
					// angular.copy(result.data, $scope.editedPaymentSchedule);
					$scope.editedPaymentSchedule = result.data.data;
					$('#paymentScheduleModal').modal('show');
				} else {
					// toastr["error"]("Failed request to server", 'Error');
					messageService.showToaster('e_0', 'general');
				}
			});
		};

		$scope.addPaymentToEdited = function () {
			if (!$scope.editedPaymentSchedule.paymentSchedulePartDTOs) {
				$scope.editedPaymentSchedule.paymentSchedulePartDTOs = [];
			}
			$scope.editedPaymentSchedule.paymentSchedulePartDTOs.push({
				jobDateDepending: $scope.jobDateDependingTypes[0].id,
				dateItemsType: $scope.dateItemsTypes[0],
				type: $scope.paymentScheduleTypes[0].key
			});
		};

		$scope.paymentScheduleSuccessCallback = function (response) {
			if (response) {
				if (response.data) {
					$('#paymentScheduleModal').modal('hide');
					delete $rootScope.error;
					getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
				} else {
					$rootScope.error = true;
					$rootScope.error_message = response.result;
				}
			}
			$scope.button_disable = false;
		};

		$scope.paymentScheduleErrorCallback = function () {
			$rootScope.authenticated = false;
			$rootScope.error = true;
			$rootScope.error_message = 'Failed request to server';
		};

		$scope.showDeleteWindow = function (index) {
			angular.copy($scope.paymentSchedules[index], $scope.deletablePaymentSchedule);
			$scope.delIndex = index;
		};

		$scope.deleteEditedPaymentPart = function (index) {
			if ($scope.editedPaymentSchedule.paymentSchedulePartDTOs[index].id) {
				$scope.editedPaymentSchedule.paymentSchedulePartDTOs[index].isDeleted = true;
				$scope.editedPaymentSchedule.paymentSchedulePartDTOs[index].amount = 0;
				$scope.editedPaymentSchedule.paymentSchedulePartDTOs[index].dateItemsAmount = 0;
			} else {
				$scope.editedPaymentSchedule.paymentSchedulePartDTOs.splice(index, 1);
			}
		};
		$scope.deleteNewPaymentPart = function (index) {
			$scope.payments.splice(index, 1);
		};

		function paymentScheduleDeletingSuccessCallback(data) {
			if (data) {
				if (data.success) {
					delete $rootScope.error;
					// toastr["success"](data.message, 'Success');
					// $scope.deletablePaymentSchedule
					messageService.showToaster('s_2', 'paymentSchedules', $scope.deletablePaymentSchedule.name);
					$scope.paymentSchedules.splice($scope.delIndex, 1);
					$scope.button_disable = false;
					getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
				} else {
					messageService.handleError({ error: data });
					$scope.button_disable = false;
				}
			}
			$scope.button_disable = false;
		}

		function paymentScheduleDeletingErrorCallback() {
			$rootScope.authenticated = false;
			$rootScope.error = true;
			$rootScope.error_message = 'Failed request to server';
			// toastr["error"]("Failed request to server", 'Error');
			messageService.showToaster('e_0', 'general');
			$scope.button_disable = false;
		}

		$scope.deletePaymentSchedule = function () {
			$scope.button_disable = true;
			$('#deletePaymentScheduleModal').modal('hide');

			paymentSchedulesDataService.deletePaymentSchedule($scope.deletablePaymentSchedule).subscribe(function (data) {
				return paymentScheduleDeletingSuccessCallback(data);
			}, function (err) {
				return paymentScheduleDeletingErrorCallback(err);
			});
		};

		function getPaymentSchedule(id, outObject) {
			$http.get('/api/user/settings/payment-schedules/' + id).then(function (result) {
				$.unblockUI();
				if (result.data.data) {
					outObject(result.data.data);
				} else {
					// toastr["error"]("Failed request to server", 'Error');
					messageService.showToaster('e_0', 'general');
				}
			});
		}

		function getResultsPage(pageNumber, perPage, predicate, reverse) {
			var changed = false;
			if (typeof predicate !== 'undefined' && predicate != null && typeof reverse !== 'undefined' && reverse != null) {
				$scope.pageRequest.pageOrder.predicate = predicate;
				$scope.pageRequest.pageOrder.reverse = reverse;
				changed = true;
			}

			if (typeof perPage !== 'undefined' && perPage != null) {
				$scope.pageRequest.perPage = perPage;
				changed = true;
			}
			if (typeof pageNumber !== 'undefined' && pageNumber != null) {
				$scope.pageRequest.page = pageNumber;
				changed = true;
			}

			if ($scope.pageRequest && $scope.totalItems != 0 && $scope.totalItems < ($scope.pageRequest.page - 1) * $scope.pageRequest.perPage + 1) {
				$scope.pageRequest.page = 1;
			}
			if (changed) {
				$http.get('/protected/rest/company_payment_schedules?perPage=' + $scope.pageRequest.perPage + '&page=' + $scope.pageRequest.page + '&predicate=' + $scope.pageRequest.pageOrder.predicate + '&reverse=' + $scope.pageRequest.pageOrder.reverse).then(function (result) {
					if (result.data && result.data.pageRequest) {
						$scope.pageRequest = result.data.pageRequest;
					}
					$scope.pageNumbers = [];
					$scope.totalItems = result.data.total;
					var pagesCount = $scope.totalItems / $scope.pageRequest.perPage;
					pagesCount = Math.ceil(pagesCount);
					for (var i = 1; i <= pagesCount; i++) {
						$scope.pageNumbers[i - 1] = i;
					}
					$scope.paymentSchedules = result.data.results;
				});
			}
		}

		$scope.order = function (predicate) {
			$scope.pageRequest.pageOrder.reverse = $scope.pageRequest.pageOrder.predicate === predicate ? !$scope.pageRequest.pageOrder.reverse : false;
			getResultsPage(null, null, predicate, $scope.pageRequest.pageOrder.reverse);
		};

		$scope.getCurrentPage = function () {
			return $scope.pageRequest.page;
		};
		$scope.perPageChanged = function (newPerPage) {
			getResultsPage(null, newPerPage);
			$rootScope.paginationPerPage = newPerPage;
		};
		$scope.goToPage = function (newPage, disabled) {
			if (!disabled) {
				getResultsPage(newPage, null);
			}
		};
		$scope.jumpBack = function (disabled) {
			if (!disabled) {
				if ($scope.pageRequest.page > 1) {
					getResultsPage($scope.pageRequest.page - 1, null);
				}
			}
		};
		$scope.jumpAhead = function (disabled) {
			if (!disabled) {
				if ($scope.totalItems >= $scope.pageRequest.page * $scope.pageRequest.perPage + 1) {
					getResultsPage($scope.pageRequest.page + 1, null);
				}
			}
		};

		$scope.disableDragDrop = function () {
			return true;
		};
	};

	angular.module('main').controller('PaymentSchedulesController', PaymentSchedulesController);

	PaymentSchedulesController.$inject = ['$scope', '$rootScope', '$http', '$q', '$location', 'messageService', 'validationService', 'userService', 'paymentSchedulesDataService', 'accountService', 'settingsService', 'emailService'];
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/toastr/toastr.js"), __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./web/js/controllers/settings/productsController.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
	angular.module('main').controller('ProductsController', ProductsController);

	ProductsController.$inject = ['$scope'];

	function ProductsController($scope) {
		$scope.$on('$viewContentLoaded', function () {
			$scope.breadcrumbs = [{ link: '/', title: 'Dashboard' }, { link: '/settings', title: 'Settings' }, { link: null, title: 'Products & Packages' }];
		});
	}
})();

/***/ }),

/***/ "./web/js/controllers/settings/profileController.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
	angular.module('main').controller('ProfileController', ProfileController);

	ProfileController.$inject = [];

	function ProfileController() {}
})();

/***/ }),

/***/ "./web/js/controllers/settings/quoteInvoiceTemplatesController.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
	angular.module('main').controller('QuoteInvoiceTemplatesController', QuoteInvoiceTemplatesController);

	QuoteInvoiceTemplatesController.$inject = ['$location', 'settingsService'];

	function QuoteInvoiceTemplatesController($location, settingsService) {
		settingsService.timeFormatSettings.take(1).subscribe(function (settings) {
			if (settings.qtTemplatesAvailable === false) {
				$location.url('/');
			}
		});
	}
})();

/***/ }),

/***/ "./web/js/controllers/settings/quoteInvoiceTemplatesUpdateController.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
	angular.module('main').controller('QuoteInvoiceTemplatesUpdateController', QuoteInvoiceTemplatesUpdateController);

	QuoteInvoiceTemplatesUpdateController.$inject = ['$scope', '$routeParams', '$location', 'settingsService'];

	function QuoteInvoiceTemplatesUpdateController($scope, $routeParams, $location, settingsService) {
		$scope.templateId = $routeParams.templateId;
		$scope.templateType = $routeParams.templateType.toUpperCase();
		$scope.templateAction = $routeParams.templateAction.toUpperCase();

		settingsService.timeFormatSettings.take(1).subscribe(function (settings) {
			if (settings.qtTemplatesAvailable === false) {
				$location.url('/');
			}
		});
	}
})();

/***/ }),

/***/ "./web/js/controllers/settings/referController.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
	angular.module('main').controller('ReferController', ReferController);

	ReferController.$inject = ['$scope', '$http', 'copyToClipboardService', 'messageService'];

	function ReferController($scope, $http, copyToClipboardService, messageService) {
		$scope.$on('$viewContentLoaded', function () {
			$scope.isCopySpinnningWheelActive = false;
			getReferInfo();
		});

		function successGetReferInfo(data) {
			$scope.ambassadorCodeInfo = data.ambassadorCodeInfo;
			if ($scope.ambassadorCodeInfo) {
				$scope.ambassadorCode = $scope.ambassadorCodeInfo.code;
				$scope.ambassadorCodeValid = $scope.ambassadorCodeInfo.codeValid;
				$scope.ambassadorExplanationHTML = $scope.ambassadorCodeInfo.explanationHTML;
				$scope.ambassadorShareMessageText = $scope.ambassadorCodeInfo.shareMessageText;
			}

			$scope.referralCodeInfo = data.referralCodeInfo;
			if ($scope.referralCodeInfo) {
				$scope.referralCode = $scope.referralCodeInfo.code;
				$scope.referrals = $scope.referralCodeInfo.referrals;
				$scope.referralExplanationHTML = $scope.referralCodeInfo.explanationHTML;
				$scope.referralShareMessageText = $scope.referralCodeInfo.shareMessageText;
				$scope.explainDiscountPricing = data.referralCodeInfo.explainDiscountPricing;
			}
		}

		$scope.isSafari = Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0;

		$scope.copy2Clipboard = function (element, successMessage) {
			$scope.isCopySpinnningWheelActive = true;
			copyToClipboardService.copy(element, successMessage);
			$scope.isCopySpinnningWheelActive = false;
		};

		$scope.referUsers = [];

		function getReferInfo() {
			$http({
				method: 'GET',
				url: '/api/user/settings/refer'
			}).then(function (result) {
				return successGetReferInfo(result.data);
			}).catch(messageService.showDefaultErrorMessage);
		}

		$scope.order = function (predicate) {
			if (predicate) {
				$scope.pageRequest.pageOrder.reverse = $scope.pageRequest.pageOrder.predicate === predicate ? !$scope.pageRequest.pageOrder.reverse : false;

				$scope.pageRequest.pageOrder.predicate = predicate;
			}
			$scope.referrals = $filter('orderBy')($scope.referrals, predicate, $scope.pageRequest.pageOrder.reverse);
		};

		$scope.breadcrumbs = [{ link: '/', title: 'Dashboard' }, { link: '/settings', title: 'Settings' }, { link: null, title: 'Refer a Friend' }];
	}
})();

/***/ }),

/***/ "./web/js/controllers/settings/settingsController.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
	angular.module('main').controller('SettingsController', SettingsController);

	SettingsController.$inject = ['$scope', '$location'];

	function SettingsController($scope, $location) {
		var settingList = [{
			title: 'Account & Subscription',
			icon: 'fi-account',
			url: '/settings/profile',
			description: 'Update your profile, password and subscription plan.',
			dataSection: 'accountAndSubscription'
		}, {
			title: 'Company Information',
			icon: 'fi-company',
			url: '/settings/company',
			description: "Tell us your company information and we'll add it to your quotes and invoices.",
			dataSection: 'companyInformation'
		}, {
			title: 'Company Users',
			icon: 'fi-users',
			url: '/settings/users',
			description: 'Invite more users to your company account. The more the merrier!',
			dataSection: 'companyUsers'
		}, {
			title: 'Currency & Taxes',
			icon: 'fi-currency-texes',
			url: '/settings/currency_and_taxes',
			description: 'Tell us the currency that you trade in and your tax rates. These are applied to your quotes and invoices.',
			dataSection: 'currencyAndTaxes'
		}, {
			title: 'Calendar Settings',
			icon: 'fi-calendar-settings',
			url: '/settings/google_cal',
			description: 'Sync your Google Calendar with Studio Ninja so you have all your appointments in one place.',
			dataSection: 'calendarSettings'
		}, {
			title: 'Payment Methods',
			icon: 'fi-payment-methods',
			url: '/settings/payment_methods',
			description: 'How would you like your clients to pay? Set up different payment options here.',
			dataSection: 'paymentMethods'
		}, {
			title: 'Payment Schedules & Reminders',
			icon: 'fi-payment-schedule',
			url: '/settings/payment_schedules',
			description: 'What are your payment terms? Payment Schedules can divide one invoice into several payments.',
			dataSection: 'paymentSchedulesAndReminders'
		}, {
			title: 'Products & Packages',
			icon: 'fi-products',
			url: '/settings/products_packages',
			description: 'Create photography products or packages that can be applied easily to your quotes and invoices.',
			dataSection: 'productsAndPackages'
		}, {
			title: 'Job Types',
			icon: 'fi-types',
			url: '/settings/job_types',
			description: 'Customise job types and assign unique colours to manage the many different types of jobs you have.',
			dataSection: 'jobTypes'
		}, {
			title: 'Email Settings',
			icon: 'fi-email-settings',
			url: '/settings/email_settings',
			description: 'Set up your email server, sender name, reply-to email address and email signature.',
			dataSection: 'emailSettings'
		}, {
			title: 'Email Templates',
			icon: 'fi-paper-plane',
			url: '/settings/email_templates',
			description: 'Create email templates that can be applied easily to any correspondence with your clients.',
			dataSection: 'emailTemplates'
		}, {
			title: 'Contract Templates',
			icon: 'fi-contract-templates',
			url: '/settings/contracts',
			description: 'Create new contract templates and give your clients the ability to sign them electronically.',
			dataSection: 'contractTemplates'
		}, {
			title: 'Questionnaire Templates',
			icon: 'fi-questionnaire-templates',
			url: '/settings/questionnaires',
			description: 'Create new questionnaire templates and let your clients tell you more about who they are and what they want.',
			dataSection: 'questionnareTemplates'
		}, {
			title: 'Contact Form',
			icon: 'fi-form',
			url: '/settings/contact_form',
			description: 'Create a contact form that automatically adds a new client when an enquiry is received.',
			dataSection: 'contractForm'
		}, {
			title: 'Workflows',
			icon: 'fi-workflows',
			url: '/settings/workflows',
			description: 'Think of a workflow as a task list on steroids! Due dates can be assigned to tasks and best of all, you can send automated emails to your clients. Possibly the most important setting in your Ninja account.',
			dataSection: 'workflows'
		}, {
			title: 'Integrations',
			icon: 'fi-integrate',
			url: '/settings/integrations',
			description: 'Make Studio Ninja even better by integrating your favourite applications and tools you use for work.'
		}, {
			title: 'Refer a Friend',
			icon: 'fi-refer',
			url: '/settings/refer',
			description: 'Do you love using Studio Ninja? Refer a friend and we will take $5 off your subscription and $5 off theirs every month!'
		}];

		$scope.$on('$viewContentLoaded', function () {
			$scope.settingList = chunk(settingList, 3);
		});

		$scope.redirect = function (path) {
			$location.path(path);
		};

		function chunk(arr, cols) {
			var newArr = [];
			var max = arr.length;
			for (var i = 0; i < max; i += cols) {
				var row = arr.slice(i, i + cols);

				if (row.length != cols) {
					var emptyCols = cols - row.length;
					for (var j = 0; j < emptyCols; j += 1) {
						row.push({});
					}
				}

				newArr.push(row);
			}

			return newArr;
		}
	}
})();

/***/ }),

/***/ "./web/js/controllers/updateInvoiceController.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
	angular.module('main').controller('UpdateInvoiceController', UpdateInvoiceController);

	UpdateInvoiceController.$inject = ['$scope', '$routeParams'];

	function UpdateInvoiceController($scope, $routeParams) {
		$scope.$on('$viewContentLoaded', function () {
			$scope.idToGetInvoice = $routeParams.jobId ? parseInt($routeParams.jobId) : parseInt($routeParams.leadId);

			$scope.isJob = !!$routeParams.jobId;
			$scope.dataToGetInvoice = {
				id: $scope.idToGetInvoice,
				isJob: $scope.isJob,
				invoiceID: $routeParams.invoiceId
			};
		});
	}
})();

/***/ }),

/***/ "./web/js/controllers/updateQuoteController.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
	angular.module('main').controller('UpdateQuoteController', UpdateQuoteController);

	UpdateQuoteController.$inject = ['$routeParams', '$scope'];

	function UpdateQuoteController($routeParams, $scope) {
		$scope.$on('$viewContentLoaded', function () {
			$scope.idToGetQuote = $routeParams.jobId ? parseInt($routeParams.jobId) : parseInt($routeParams.leadId);
			$scope.isJob = !!$routeParams.jobId;
			$scope.quoteId = $routeParams.quoteId;

			if ($routeParams.quoteType) {
				$scope.quoteType = $routeParams.quoteType;
			}
		});
	}
})();

/***/ }),

/***/ "./web/js/controllers/workflowController.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

(function () {
	angular.module('main').controller('WorkflowController', WorkflowController);

	WorkflowController.$inject = ['$scope', '$rootScope', 'messageService', 'workflowDataService'];

	function WorkflowController($scope, $rootScope, messageService, workflowDataService) {
		$scope.$on('$viewContentLoaded', function () {
			$scope.pageRequest = {
				page: 1,
				perPage: $rootScope.paginationPerPage ? $rootScope.paginationPerPage : 25,
				pageOrder: {
					predicate: 'name',
					reverse: false
				},
				search: null
			};
			$scope.isDeleteSpinnningWheelActive = false;
			getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
		});

		$scope.deleteWorkflow = function (id, name) {
			$scope.deleteWorkflowName = name;
			$scope.newWorkflow = {
				id: id
			};
			$('#deleteModal').modal('show');
		};

		$scope.hideModal = function () {
			delete $scope.newWorkflow;
			$('#newWorkflows').modal('hide');
		};

		$scope.deleteRequest = function (id) {
			$scope.isDeleteSpinnningWheelActive = true;
			workflowDataService.deleteWorkflow(id).finally(function () {
				return $scope.isDeleteSpinnningWheelActive = false;
			}).subscribe(function (data) {
				return successDeleteWorkflow(data);
			}, function () {
				return messageService.showToaster('e_6', 'workflow');
			});
		};

		$scope.breadcrumbs = [{ link: '/', title: 'Dashboard' }, { link: '/settings', title: 'Settings' }, { link: null, title: 'Workflows' }];

		function successDeleteWorkflow(data) {
			if (data.errorMessage) {
				messageService.showToaster('e_2', 'general', data.errorMessage);
			} else {
				messageService.showToaster('s_2', 'workflow', $scope.deleteWorkflowName);
				getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
				$('#deleteModal').modal('hide');
			}
		}

		$scope.remove = function (index) {
			if ($scope.newWorkflow.questions.length != 1) {
				$scope.newWorkflow.questions.splice(idList[index - 1], 1);
			}
		};

		function getResultsPage() {
			var pageNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
			var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
			var predicate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
			var reverse = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

			var changed = false;

			if (predicate && reverse) {
				$scope.pageRequest.pageOrder.predicate = predicate;
				$scope.pageRequest.pageOrder.reverse = reverse;
				changed = true;
			}

			if (perPage) {
				$scope.pageRequest.perPage = perPage;
				changed = true;
			}

			if (pageNumber) {
				$scope.pageRequest.page = pageNumber;
				changed = true;
			}

			if ($scope.pageRequest && $scope.totalItems != 0 && $scope.totalItems < ($scope.pageRequest.page - 1) * $scope.pageRequest.perPage + 1) {
				console.log('out of page');
				$scope.pageRequest.page = 1;
			}

			if (changed) {
				workflowDataService.getWorkflowsOnPage($scope.pageRequest).subscribe(function (data) {
					return successGetResultsPage(data);
				}, function (error) {
					return messageService.showDefaultErrorMessage(error);
				});
			}
		}

		function successGetResultsPage(data) {
			if (data && data.pageRequest) {
				$scope.pageRequest = data.pageRequest;
			}
			$scope.pageNumbers = [];
			$scope.totalItems = data ? data.total : 0;

			var pagesCount = void 0;
			pagesCount = $scope.totalItems / $scope.pageRequest.perPage;
			pagesCount = Math.ceil(pagesCount);

			for (var i = 1; i <= pagesCount; i++) {
				$scope.pageNumbers[i - 1] = i;
			}

			$scope.workflows = angular.copy(data.results);
		}

		$scope.order = function (predicate) {
			$scope.pageRequest.pageOrder.reverse = $scope.pageRequest.pageOrder.predicate === predicate ? !$scope.pageRequest.pageOrder.reverse : false;
			getResultsPage(null, null, predicate, $scope.pageRequest.pageOrder.reverse);
		};

		$scope.getCurrentPage = function () {
			return $scope.pageRequest.page;
		};

		$scope.perPageChanged = function (newPerPage) {
			getResultsPage(null, newPerPage);
			$rootScope.paginationPerPage = newPerPage;
		};

		$scope.goToPage = function (newPage, disabled) {
			if (!disabled) {
				getResultsPage(newPage, null);
			}
		};
		$scope.jumpBack = function (disabled) {
			if (!disabled) {
				if ($scope.pageRequest.page > 1) {
					getResultsPage($scope.pageRequest.page - 1, null);
				}
			}
		};
		$scope.jumpAhead = function (disabled) {
			if (!disabled) {
				if ($scope.totalItems >= $scope.pageRequest.page * $scope.pageRequest.perPage + 1) {
					getResultsPage($scope.pageRequest.page + 1, null);
				}
			}
		};
	}
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./web/js/helper/rich_text_tokens.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.clientOverviewMailMenu = exports.calendarReminderMenu = exports.invoiceMenu = exports.contractMenu = exports.basicMenu = exports.fileUpload = undefined;

var _variablesToInsert = __webpack_require__("./shared/models/system-variables/variables-to-insert.ts");

function insertHtml(qtvar) {
	var template = qtvar ? qtvar + '&nbsp;' : '';
	if (this.$editor()) {
		this.$editor().displayElements.text.trigger('focus');
		this.$editor().wrapSelection('inserthtml', template, true);
	}
}

function variablesAdapter(variableGroup, variableGroupName) {
	return Object.keys(variableGroup[variableGroupName]).reduce(function (accum, key) {
		return accum + ' <li><a ng-click="insertVariable(\'' + variableGroup[variableGroupName][key] + '\')">' + key + '</a></li>';
	}, '');
}

function insertVariable(variable) {
	insertHtml.call(this, variable, true);
}

var fileUploadTemplate = '\n\t<div class="dropdown insert-var-container" unselectable="on" disabled="disabled">\n\t\t<button type="button" class="btn btn-default dropdown-toggle" name="attachment_fiels"\n\t\t\t\ttabindex="-1" on-click="executeAction($event)"\n\t\t\t\tng-class="displayActiveToolClass(active)" data-toggle="dropdown" title="Attachment files"\n\t\t\t\tunselectable="on" disabled="disabled"><i class="fa fa-paperclip"></i>\n\t\t</button>\n\t\t<ul class="dropdown-menu no-overflow">\n\t\t\t<li><a class="showfiles" ng-click="showFilesModal()">From Files</a></li>\n\t\t\t<li><a ng-click="uploadFromComputer()">From Computer</a></li>\t\n\t\t</ul>\n\t</div>\n';

var basicMenuTemplate = '\n\t<div class="dropdown insert-var-container" unselectable="on" disabled="disabled">\n\t\t<button class="btn btn-default dropdown-toggle" unselectable="on" ng-class="displayActiveToolClass(active)" on-click="executeAction($event)" tabindex="-1" data-toggle="dropdown">\n\t\t\tInsert variable<span class="caret"></span>\n\t\t</button>\n\t\t<ul class="dropdown-menu no-overflow">\n\t\t\t' + variablesAdapter(_variablesToInsert.variablesList, 'JOB_MENU') + '\n\t\t</ul> \n\t</div>\n';

var contractMenuTemplate = '\n\t<div class="dropdown insert-var-container" unselectable="on" disabled="disabled">\n\t\t<button class="btn btn-default dropdown-toggle" unselectable="on" ng-class="displayActiveToolClass(active)" on-click="executeAction($event)" tabindex="-1" data-toggle="dropdown">\n\t\t\tInsert variable<span class="caret"></span>\n\t\t</button>\n\t\t<ul class="dropdown-menu no-overflow">\n\t\t\t' + variablesAdapter(_variablesToInsert.variablesList, 'CONTRACT_MENU') + '\n\t\t</ul> \n\t</div>\n';

var invoiceMenuTemplate = '\n\t<div class="dropdown insert-var-container" unselectable="on" disabled="disabled">\n\t\t<button class="btn btn-default dropdown-toggle" unselectable="on" ng-class="displayActiveToolClass(active)" on-click="executeAction($event)" tabindex="-1" data-toggle="dropdown">\n\t\t\tInsert variable<span class="caret"></span>\n\t\t</button>\n\t\t<ul class="dropdown-menu no-overflow">\n\t\t\t' + variablesAdapter(_variablesToInsert.variablesList, 'INVOICE_MENU') + '\n\t\t</ul> \n\t</div>\n';

var calendarReminderMenuTemplate = '\n\t<div class="dropdown insert-var-container p-0" unselectable="on" disabled="disabled">\n\t\t<button class="btn btn-default dropdown-toggle" unselectable="on" ng-class="displayActiveToolClass(active)" data-toggle="dropdown" ng-mouseup="focusHack()">\n\t\t\tInsert variable<span class="caret"></span>\n\t\t</button>\n\t\t<ul class="dropdown-menu no-overflow">\n\t\t\t' + variablesAdapter(_variablesToInsert.variablesList, 'APPOINTMENT_REMINDER_MENU') + '\n\t\t</ul>\n\t</div\n';

var clientOverviewEmailTemplate = '\n\t<div class="dropdown insert-var-container" unselectable="on" disabled="disabled">\n\t\t<button class="btn btn-default dropdown-toggle" unselectable="on" ng-class="displayActiveToolClass(active)" on-click="executeAction($event)" tabindex="-1" data-toggle="dropdown">\n\t\t\tInsert variable<span class="caret"></span>\n\t\t</button>\n\t\t<ul class="dropdown-menu no-overflow">\n\t\t\t' + variablesAdapter(_variablesToInsert.variablesList, 'CLIENT_MENU') + '\n\t\t</ul>\n\t</div>\n';

var fileUpload = exports.fileUpload = {
	menu: fileUploadTemplate,
	methods: insertVariable
};

var basicMenu = exports.basicMenu = {
	menu: basicMenuTemplate,
	methods: insertVariable
};

var contractMenu = exports.contractMenu = {
	menu: contractMenuTemplate,
	methods: insertVariable
};

var invoiceMenu = exports.invoiceMenu = {
	menu: invoiceMenuTemplate,
	methods: insertVariable
};

var calendarReminderMenu = exports.calendarReminderMenu = {
	menu: calendarReminderMenuTemplate,
	methods: insertVariable
};

var clientOverviewMailMenu = exports.clientOverviewMailMenu = {
	menu: clientOverviewEmailTemplate,
	methods: insertVariable
};

/***/ }),

/***/ "./web/js/helper/routes.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var privatePath = 'https://app.studioninja.co/build/release-pipeline-119/resources/dist/pages/private/';
var publicPath = 'https://app.studioninja.co/build/release-pipeline-119/resources/dist/pages/public/';
var clientPath = 'https://app.studioninja.co/build/release-pipeline-119/resources/dist/pages/client/';
var adminPath = 'https://app.studioninja.co/build/release-pipeline-119/resources/dist/pages/admin/';
var modernPath = 'https://app.studioninja.co/build/release-pipeline-119/resources/dist/components/';
exports.routes = {
    '/': {
        templateUrl: publicPath + 'home.html',
        requireLogin: true,
        adminPage: false,
        title: ' - Dashboard',
        controller: 'BasePathController'
    },
    '/unsupported_browser': {
        templateUrl: publicPath + 'non_supported_browser.html',
        requireLogin: false,
        adminPage: false,
        hideHeader: true,
        title: ' - Unsupported browser'
    },
    '/login': {
        templateUrl: publicPath + 'login.html',
        controller: 'LoginController',
        requireLogin: false,
        adminPage: false,
        hideHeader: true,
        title: ' - Login'
    },
    '/signup': {
        templateUrl: publicPath + 'sign_up.html',
        controller: 'SignUpController',
        requireLogin: false,
        adminPage: false,
        hideHeader: true,
        title: ' - Sign up'
    },
    '/signup/referral/:token': {
        templateUrl: publicPath + 'sign_up.html',
        controller: 'SignUpController',
        requireLogin: false,
        adminPage: false,
        hideHeader: true,
        title: ' - Sign up'
    },
    '/signup/confirm/:token': {
        templateUrl: publicPath + 'simple_result.html',
        controller: 'ConfirmSignUpController',
        requireLogin: false,
        hideHeader: true,
        adminPage: false
    },
    '/signup/thankyou': {
        templateUrl: publicPath + 'thank_you_signup.html',
        controller: 'ThankYouSignupController',
        requireLogin: false,
        hideHeader: true,
        adminPage: false
    },
    '/pageNotFound': {
        templateUrl: publicPath + 'sorry_page.html',
        requireLogin: false,
        hideHeader: true,
        adminPage: false
    },
    '/unsubscribefromintroemails/:token': {
        templateUrl: publicPath + 'simple_result.html',
        controller: 'UnsubscribeEmailsController',
        requireLogin: false,
        adminPage: false,
        title: ' - Unsubscribe'
    },
    '/forgot': {
        templateUrl: publicPath + 'forgot_password.html',
        controller: 'ForgotPasswordController',
        requireLogin: false,
        adminPage: false,
        title: ' - Password recovery'
    },
    '/tlc': {
        templateUrl: publicPath + 'tlc.html',
        controller: 'ForgotPasswordController',
        requireLogin: false,
        adminPage: false,
        hideHeader: true,
        title: ' - Maintenance'
    },
    '/new/confirm/:token': {
        templateUrl: publicPath + 'public_change_password.html',
        controller: 'ConfirmForgotPasswordController',
        requireLogin: false,
        adminPage: false
    },
    '/settings': {
        templateUrl: privatePath + 'settings.html',
        controller: 'SettingsController',
        requireLogin: true,
        adminPage: false,
        title: ' - Settings'
    },
    '/settings/company/:companyId/edit': {
        templateUrl: privatePath + 'company_information.html',
        controller: 'CompanyInformationController',
        requireLogin: true,
        adminPage: false,
        title: ' - Edit Company'
    },
    '/settings/companies': {
        templateUrl: privatePath + 'settings_companies.html',
        controller: 'CompanyUsersController',
        requireLogin: true,
        adminPage: false,
        title: ' - Companies'
    },
    '/company/register/:token': {
        templateUrl: publicPath + 'sign_up.html',
        controller: 'SignUpController',
        requireLogin: false,
        adminPage: false
    },
    '/settings/users': {
        templateUrl: privatePath + 'company_users.html',
        controller: 'CompanyUsersController',
        requireLogin: true,
        adminPage: false,
        title: ' - Company Users'
    },
    '/settings/profile': {
        templateUrl: privatePath + 'profile.html',
        controller: 'ProfileController',
        requireLogin: true,
        adminPage: false,
        title: ' - Account & Subscription'
    },
    '/subscribed': {
        templateUrl: privatePath + 'thank-for-subscribing.html',
        requireLogin: true,
        adminPage: false
    },
    '/change/confirm/:token': {
        templateUrl: publicPath + 'simple_result.html',
        controller: 'ChangePasswordController',
        requireLogin: true,
        adminPage: false
    },
    '/change/login/confirm/:token': {
        templateUrl: publicPath + 'simple_result.html',
        controller: 'ChangeLoginController',
        requireLogin: false,
        adminPage: false
    },
    '/ambassadors': {
        templateUrl: adminPath + 'ambassadors.html',
        controller: 'AmbassadorsController',
        requireLogin: true,
        adminPage: true,
        title: ' - Ambassadors'
    },
    '/referrals': {
        templateUrl: adminPath + 'referrals.html',
        controller: 'ReferralsController',
        requireLogin: true,
        adminPage: true,
        title: ' - Referrals'
    },
    '/campaigns': {
        templateUrl: adminPath + 'campaigns.html',
        controller: 'CampaignsController',
        requireLogin: true,
        adminPage: true,
        title: ' - Campaigns'
    },
    '/reports': {
        templateUrl: adminPath + 'reports.html',
        requireLogin: true,
        adminPage: true,
        title: ' - Reports'
    },
    '/settings/currency_and_taxes': {
        templateUrl: privatePath + 'currency_and_taxes.html',
        controller: 'CurrencyAndTaxesController',
        requireLogin: true,
        adminPage: false,
        title: ' - Currency & Taxes'
    },
    '/settings/payment_schedules': {
        templateUrl: privatePath + 'payment_schedules.html',
        controller: 'PaymentSchedulesController',
        requireLogin: true,
        adminPage: false,
        title: ' - Payment Schedules & Reminders'
    },
    '/settings/products_packages': {
        templateUrl: privatePath + 'products.html',
        controller: 'ProductsController',
        requireLogin: true,
        adminPage: false,
        title: ' - Products & Packages'
    },
    '/settings/payment_methods': {
        templateUrl: privatePath + 'payment_methods.html',
        controller: 'PaymentMethodsController',
        requireLogin: true,
        adminPage: false,
        title: ' - Payment Methods'
    },
    '/jobs/view/:jobId': {
        templateUrl: privatePath + 'job_view.html',
        controller: 'JobViewController',
        requireLogin: true,
        adminPage: false,
        title: ' - Job Profile',
        role: 'user'
    },
    '/jobs/:jobId/invoice/:invoiceId/update': {
        templateUrl: privatePath + 'update_invoice.html',
        controller: 'UpdateInvoiceController',
        requireLogin: true,
        adminPage: false,
        title: ' - Update Invoice'
    },
    '/jobs/:jobId/invoice/new': {
        templateUrl: privatePath + 'update_invoice.html',
        controller: 'UpdateInvoiceController',
        requireLogin: true,
        adminPage: false,
        title: ' - New Invoice'
    },
    '/leads/:leadId/invoice/new': {
        templateUrl: privatePath + 'update_invoice.html',
        controller: 'UpdateInvoiceController',
        requireLogin: true,
        adminPage: false,
        title: ' - New Invoice'
    },
    '/leads/:leadId/invoice/:invoiceId/update': {
        templateUrl: privatePath + 'update_invoice.html',
        controller: 'UpdateInvoiceController',
        requireLogin: true,
        adminPage: false,
        title: ' - Update Invoice'
    },
    '/leads/view/:leadId': {
        templateUrl: privatePath + 'lead_view.html',
        controller: 'LeadViewController',
        requireLogin: true,
        adminPage: false,
        title: ' - Lead Profile',
        role: 'user'
    },
    '/payments/:page?/:search?': {
        templateUrl: privatePath + 'payments_overview.html',
        controller: 'PaymentsOverviewController',
        requireLogin: true,
        adminPage: false,
        title: ' - Payments Overview'
    },
    '/payments/payment/:id': {
        templateUrl: privatePath + 'invoice_view.html',
        controller: 'InvoiceViewController',
        requireLogin: true,
        adminPage: false,
        title: ' - Invoice'
    },
    '/invoices/:id': {
        templateUrl: privatePath + 'invoice_view.html',
        controller: 'InvoiceViewController',
        requireLogin: true,
        adminPage: false,
        title: ' - Invoice'
    },
    '/settings/email_settings': {
        templateUrl: privatePath + 'email_settings.html',
        controller: 'EmailSettingsController',
        requireLogin: true,
        adminPage: false,
        title: ' - Email Settings'
    },
    '/settings/email_templates': {
        templateUrl: privatePath + 'email_templates.html',
        controller: 'EmailTemplatesController',
        requireLogin: true,
        adminPage: false,
        title: ' - Email Templates'
    },
    '/settings/email_template': {
        redirectTo: '/settings/email_settings'
    },
    '/clients/client:id': {
        templateUrl: privatePath + 'client_profile.html',
        controller: 'ClientProfileController',
        requireLogin: true,
        adminPage: false,
        title: ' - Client Profile'
    },
    '/clients/:page?/:search?': {
        templateUrl: privatePath + 'clients.html',
        controller: 'ClientsController',
        requireLogin: true,
        adminPage: false,
        title: ' - Clients Overview'
    },
    '/settings/questionnaires': {
        templateUrl: privatePath + 'questionnaires.html',
        controller: 'QuestionnairyController',
        requireLogin: true,
        adminPage: false,
        title: ' - Questionnaire Templates'
    },
    '/settings/contracts': {
        templateUrl: privatePath + 'contracts.html',
        controller: 'ContractsController',
        requireLogin: true,
        adminPage: false,
        title: ' - Contract Templates'
    },
    '/settings/workflows': {
        templateUrl: privatePath + 'workflows.html',
        controller: 'WorkflowController',
        requireLogin: true,
        adminPage: false,
        title: ' - Workflows'
    },
    '/settings/workflows/add': {
        templateUrl: privatePath + 'add_new_workflow.html',
        controller: 'AddWorkflowController',
        requireLogin: true,
        adminPage: false
    },
    '/settings/workflows/edit/:id': {
        templateUrl: privatePath + 'add_new_workflow.html',
        controller: 'AddWorkflowController',
        requireLogin: true,
        adminPage: false,
        title: ' - Add a new workflow'
    },
    '/settings/workflows/duplicate/:id': {
        templateUrl: privatePath + 'add_new_workflow.html',
        controller: 'AddWorkflowController',
        requireLogin: true,
        adminPage: false,
        title: ' - Edit workflow'
    },
    '/jobs/view/:jobId/contracts': {
        templateUrl: privatePath + 'job_contracts.html',
        controller: 'JobContractController',
        requireLogin: true,
        adminPage: false,
        title: ' - Contract'
    },
    '/leads/view/:leadId/contracts': {
        templateUrl: privatePath + 'job_contracts.html',
        controller: 'JobContractController',
        requireLogin: true,
        adminPage: false,
        title: ' - Contract'
    },
    '/jobs/view/:jobId/questionnaires/:questionnaireId': {
        templateUrl: privatePath + 'job_questionnaires.html',
        controller: 'JobQuestionnaireController',
        requireLogin: true,
        adminPage: false,
        title: ' - Questionnaire'
    },
    '/leads/view/:leadId/questionnaires/:questionnaireId': {
        templateUrl: privatePath + 'job_questionnaires.html',
        controller: 'JobQuestionnaireController',
        requireLogin: true,
        adminPage: false,
        title: ' - Questionnaire'
    },
    '/jobs/view/:jobId/contracts/:contractId': {
        templateUrl: privatePath + 'job_contracts.html',
        controller: 'JobContractController',
        requireLogin: true,
        adminPage: false,
        title: ' - Contract'
    },
    '/leads/view/:leadId/contracts/:contractId': {
        templateUrl: privatePath + 'job_contracts.html',
        controller: 'JobContractController',
        requireLogin: true,
        adminPage: false,
        title: ' - Contract'
    },
    '/jobs/:jobId/quote/:quoteId/update': {
        templateUrl: privatePath + 'update_quote.html',
        controller: 'UpdateQuoteController',
        requireLogin: true,
        adminPage: false,
        title: ' - Update Quote'
    },
    '/leads/:leadId/quote/:quoteId/update': {
        templateUrl: privatePath + 'update_quote.html',
        controller: 'UpdateQuoteController',
        requireLogin: true,
        adminPage: false,
        title: ' - Update Quote'
    },
    '/jobs/:jobId/quote/:quoteType/new': {
        templateUrl: privatePath + 'update_quote.html',
        controller: 'UpdateQuoteController',
        requireLogin: true,
        adminPage: false,
        title: ' - New Quote'
    },
    '/leads/:leadId/quote/:quoteType/new': {
        templateUrl: privatePath + 'update_quote.html',
        controller: 'UpdateQuoteController',
        requireLogin: true,
        adminPage: false,
        title: ' - New Quote'
    },
    '/jobs/:jobId/quote/:quoteId': {
        templateUrl: privatePath + 'quote_view.html',
        controller: 'QuoteViewController',
        requireLogin: true,
        adminPage: false,
        title: ' - Quote'
    },
    '/jobs/:page?/:search?': {
        templateUrl: privatePath + 'jobs.html',
        controller: 'JobsOverviewController',
        requireLogin: true,
        adminPage: false,
        title: ' - Jobs Overview'
    },
    '/leads/:leadId/quote/:quoteId': {
        templateUrl: privatePath + 'quote_view.html',
        controller: 'QuoteViewController',
        requireLogin: true,
        adminPage: false,
        title: ' - Quote'
    },
    '/settings/google_cal': {
        templateUrl: privatePath + 'calendar_settings.html',
        controller: 'CalendarSettingsController',
        requireLogin: true,
        adminPage: false,
        title: ' - Calendar Settings'
    },
    '/settings/job_types': {
        templateUrl: privatePath + 'job_types.html',
        controller: 'JobTypesController',
        requireLogin: true,
        adminPage: false,
        title: ' - Job Types'
    },
    '/settings/contact_form': {
        templateUrl: privatePath + 'contact_form.html',
        controller: 'ContactFormController',
        requireLogin: true,
        adminPage: false,
        title: ' - Contact Form'
    },
    '/settings/refer': {
        templateUrl: privatePath + 'refer.html',
        controller: 'ReferController',
        requireLogin: true,
        adminPage: false,
        title: ' - Refer a Friend'
    },
    '/settings/labels': {
        templateUrl: privatePath + 'labels_settings.html',
        controller: 'LabelsSettingsController',
        requireLogin: true,
        adminPage: false,
        title: ' - Labels'
    },
    '/settings/lead_sources': {
        templateUrl: privatePath + 'lead_sources_settings.html',
        controller: 'LeadSourcesSettingsController',
        requireLogin: true,
        adminPage: false,
        title: ' - Lead Sources'
    },
    '/settings/quote_invoice_templates': {
        templateUrl: privatePath + 'quote_invoice_templates.html',
        controller: 'QuoteInvoiceTemplatesController',
        requireLogin: true,
        adminPage: false,
        title: ' - Quote & Invoice Templates'
    },
    '/settings/quote_invoice_templates/:templateType/:templateAction': {
        templateUrl: privatePath + 'quote_invoice_templates_update.html',
        controller: 'QuoteInvoiceTemplatesUpdateController',
        requireLogin: true,
        adminPage: false,
        title: ' - Quote & Invoice Templates'
    },
    '/settings/quote_invoice_templates/:templateType/:templateId/:templateAction': {
        templateUrl: privatePath + 'quote_invoice_templates_update.html',
        controller: 'QuoteInvoiceTemplatesUpdateController',
        requireLogin: true,
        adminPage: false,
        title: ' - Quote & Invoice Templates'
    },
    '/settings/integrations/:xero?': {
        templateUrl: privatePath + 'integrations.html',
        controller: 'IntegrationsController',
        requireLogin: true,
        adminPage: false,
        title: ' - Integrations'
    },
    '/integrations/xero/connect/complete': {
        templateUrl: privatePath + 'integrations.html',
        controller: 'IntegrationsController',
        requireLogin: true,
        adminPage: false,
        title: ' - Integrations'
    },
    '/integrations/pictime/oauth': {
        templateUrl: privatePath + 'integrations.html',
        controller: 'IntegrationsController',
        requireLogin: true,
        adminPage: false,
        title: ' - Integrations'
    },
    '/calendar': {
        templateUrl: privatePath + 'calendar.html',
        controller: 'CalendarController',
        requireLogin: true,
        adminPage: false,
        title: ' - Calendar'
    },
    '/leads/:page?/:search?': {
        templateUrl: privatePath + 'leads.html',
        controller: 'LeadsOverviewController',
        requireLogin: true,
        adminPage: false,
        title: ' - Leads Overview'
    },
    '/:photographyStudio/contact': {
        templateUrl: clientPath + 'client_contact_form.html',
        controller: 'ClientContactFormController',
        requireLogin: false,
        adminPage: false,
        title: 'Contact Form',
        role: 'company'
    },
    '/:photographyStudio/contact/:id': {
        templateUrl: clientPath + 'client_contact_form.html',
        controller: 'ClientContactFormController',
        requireLogin: false,
        adminPage: false,
        title: 'Contact Form',
        role: 'company'
    }
};

/***/ }),

/***/ "./web/js/helper/textAngular.config.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, rangy, toastr) {

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.textAngularConfig = textAngularConfig;

var _rich_text_tokens = __webpack_require__("./web/js/helper/rich_text_tokens.js");

textAngularConfig.$inject = ['emailSettingsDataService', 'taRegisterTool', '$delegate', 'messageService'];

function textAngularConfig(emailSettingsDataService, taRegisterTool, taOptions, messageService) {
	function getOffset(el) {
		var _x = 0;
		var _y = 0;
		while (el && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop)) {
			_x += el.offsetLeft - el.scrollLeft;
			_y += el.offsetTop - el.scrollTop;
			el = el.offsetParent;
		}
		return { top: _y, left: _x };
	}

	function _getTipPosition(elem) {
		var el = void 0,
		    x = void 0,
		    y = void 0,
		    elP = void 0,
		    xP = void 0,
		    yP = void 0,
		    positionStyle = {};

		el = $(elem)[0];
		x = getOffset(el).left;
		y = getOffset(el).top;

		elP = $(elem).parents('.textarea-quad');
		xP = getOffset(elP[0]).left;
		yP = getOffset(elP[0]).top;

		positionStyle.left = x - xP + 'px';
		positionStyle.top = y - yP + 'px';

		return positionStyle;
	}

	taOptions.toolbar = [['bold', 'italics', 'underline'], ['link'], ['ul', 'ol'], ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull']];

	taOptions.keyMappings = [];

	taRegisterTool('link', {
		display: '<button type="button" class="btn btn-default btn-link-edit" name="attachment_fiels" tabindex="-1" on-click="executeAction($event)" ng-class="displayActiveToolClass(active)" title="Insert link" unselectable="on" disabled="disabled"><i class="fa fa-link"></i></button>',
		action: function action() {
			var selectedText = '' + window.getSelection();
			$('.linkEdited').removeClass('linkEdited');

			var glossTag = '<span></span><a class="linkEdited">' + selectedText + '</a><span></span>';
			this.$editor().wrapSelection('insertHTML', glossTag, true);

			delete this.$parent.$parent.link2edit.url;
			delete this.$parent.$parent.link2edit.linkTo;
			this.$parent.$parent.link2edit.select = '';
			this.$parent.$parent.link2edit.select = '.linkEdited';

			return false;
		},
		activeState: function activeState(commonElement) {
			var tipEl = $('.focussed + .editLinkTips');
			tipEl.hide();

			$('.ta-editor .linkEdited').removeClass('linkEdited');

			$('.focussed .btn-link-edit').prop('disabled', false);
			$('.focussed .insert-var-container .dropdown-toggle').prop('disabled', false);

			if (commonElement) {
				this.$parent.$parent.link2edit.url = '';
				this.$parent.$parent.link2edit.linkTo = '';
				if (commonElement[0].tagName === 'A') {
					$('.focussed .btn-link-edit').prop('disabled', true);
					$('.focussed .insert-var-container .dropdown-toggle').prop('disabled', true);

					if (commonElement[0].classList.contains('linkEdited')) {
						tipEl.css(_getTipPosition(commonElement));
						tipEl.show();
					} else {
						commonElement[0].classList.add('linkEdited');
						tipEl.css(_getTipPosition(commonElement));
						tipEl.show();
					}

					return false;
				}
			}
		}
	});

	taRegisterTool('attachFilesFromComputer', {
		display: '<button type="button" class="btn btn-default btn-attach-fiels" name="attachment_fiels" tabindex="-1" on-click="executeAction($event)" ng-class="displayActiveToolClass(active)" title="Attachment files" unselectable="on" disabled="disabled"><i class="fa fa-paperclip"></i></button>',
		action: function action() {
			this.$element.parents('.sn-ta-editor').find('input.attachments__input').click();
		}
	});

	taRegisterTool('attachFiles', {
		display: _rich_text_tokens.fileUpload.menu,
		disabled: function disabled() {
			this.focusHack = function () {
				$('.ta-scroll-window [contenteditable]')[0].focus();
			};
			this.insertVariable = _rich_text_tokens.fileUpload.methods;
			this.showFilesModal = function () {
				this.$element.parents('.sn-ta-editor').find('input').focus(function () {
					this.blur();
				});
				this.$element.parents('.sn-ta-editor').find('#filesModal').modal('show');
				$('.ta-scroll-window [contenteditable]')[0].blur();
			};
			this.uploadFromComputer = function () {
				this.$element.parents('.sn-ta-editor').find('input.attachments__input').click();
			};
			this.show = true;
			this.isDisabled = function () {
				return false;
			};
		},
		action: function action(e) {
			var uploadedFiles = this.$root.uploadedFiles;
			if (typeof uploadedFiles !== 'undefined' && uploadedFiles === 0) {
				$('a.showfiles').attr('disabled', true).css('opacity', '0.5');
			} else {
				$('a.showfiles').attr('disabled', false).css('opacity', '1');
			}
		}
	});

	taRegisterTool('JOB_MENU', {
		display: _rich_text_tokens.basicMenu.menu,
		disabled: function disabled() {
			this.focusHack = function () {
				$('.ta-scroll-window [contenteditable]')[0].focus();
			};
			this.insertVariable = _rich_text_tokens.basicMenu.methods;
			this.show = true;
			this.isDisabled = function () {
				return false;
			};
		},
		action: function action() {}
	});

	taRegisterTool('CONTRACT_MENU', {
		display: _rich_text_tokens.contractMenu.menu,
		disabled: function disabled() {
			this.focusHack = function () {
				$('.ta-scroll-window [contenteditable]')[0].focus();
			};
			this.insertVariable = _rich_text_tokens.basicMenu.methods;
			this.show = true;
			this.isDisabled = function () {
				return false;
			};
		},
		action: function action() {}
	});

	taRegisterTool('INVOICE_MENU', {
		display: _rich_text_tokens.invoiceMenu.menu,
		disabled: function disabled() {
			this.focusHack = function () {
				$('.ta-scroll-window [contenteditable]')[0].focus();
			};
			this.insertVariable = _rich_text_tokens.invoiceMenu.methods;
			this.show = true;
			this.isDisabled = function () {
				return false;
			};
		},
		action: function action() {}
	});

	taRegisterTool('APPOINTMENT_REMINDER_MENU', {
		display: _rich_text_tokens.calendarReminderMenu.menu,
		disabled: function disabled() {
			this.focusHack = function () {
				$('.ta-scroll-window [contenteditable]')[0].focus();
			};
			this.insertVariable = _rich_text_tokens.calendarReminderMenu.methods;
			this.show = true;
			this.isDisabled = function () {
				return false;
			};
		},
		action: function action() {}
	});

	taRegisterTool('CLIENT_MENU', {
		display: _rich_text_tokens.clientOverviewMailMenu.menu,
		disabled: function disabled() {
			this.focusHack = function () {
				$('.ta-scroll-window [contenteditable]')[0].focus();
			};
			this.insertVariable = _rich_text_tokens.clientOverviewMailMenu.methods;
			this.show = true;
			this.isDisabled = function () {
				return false;
			};
		},
		action: function action() {}
	});

	taRegisterTool('loadImage', {
		iconclass: 'fa fa-file-image-o',
		buttontext: 'Upload image',
		action: function action() {
			var cntrlIsPressed = false;

			var initInjector = angular.injector(['ng']);
			var $http = initInjector.get('$http');

			if (!$http.defaults.headers.get) {
				$http.defaults.headers.get = {};
			}

			// disable IE ajax request caching
			$http.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
			$http.defaults.headers.get['Cache-Control'] = 'no-cache';
			$http.defaults.headers.get.Pragma = 'no-cache';

			var textAngular = this;
			var savedSelection = rangy.saveSelection();
			rangy.restoreSelection(savedSelection);

			var removeAllImages = function removeAllImages() {
				return $('.signayureImg').remove();
			};

			var companyImageError = function companyImageError() {
				toastr.error('Please make sure you upload a valid .JPG or .PNG file into the email signature.', "Something's not right here!");
			};
			var companyImageSizeError = function companyImageSizeError() {
				toastr.error("The file you're attaching is bigger than the 2 Mb.");
			};
			var serverError = function serverError() {
				toastr.error('Failed request to server');
			};

			function saveNewImgOnServer(dataToSave) {
				emailSettingsDataService.setOnLoadImageSuccess(true);
				emailSettingsDataService.saveImage(dataToSave).subscribe(function (result) {
					if (result.errorMessage === 'Unsupported Image Type!') {
						companyImageError();
						return;
					}
					getSettings();
					emailSettingsDataService.setOnLoadImageSuccess(false);
					messageService.showToaster('s_4', 'emailSettings');
				}, function () {
					return serverError();
				});
			}

			var insertImg = function insertImg(imgSrc) {
				var insertImgUrl = imgSrc + '?' + new Date().getTime();
				var signatureImgClassId = 'signayureImg__' + Math.random().toString(36).substr(2, 9);

				var myImage = new Image();
				myImage.src = insertImgUrl;
				myImage.onload = function () {
					var signayureImgDOM = document.querySelector('.' + signatureImgClassId);
					signayureImgDOM.height = myImage.naturalHeight;
					signayureImgDOM.width = myImage.naturalWidth;
					signayureImgDOM.style.height = myImage.naturalHeight;
					signayureImgDOM.style.width = myImage.naturalWidth;

					signayureImgDOM.classList.remove('hide');
				};
				var htmlText = '<span><img id=\'signatureImg\' class=\'signayureImg hide ' + signatureImgClassId + '\' src=\'' + insertImgUrl + '\'/></span>';

				return textAngular.$editor().wrapSelection('insertHTML', htmlText, true);
			};

			$(document).keydown(function (event) {
				if (event.which === '17') cntrlIsPressed = true;
			});

			$(document).keyup(function () {
				cntrlIsPressed = false;
			});

			var uploadNewImage = function uploadNewImage() {
				var inputHtml = '<input id="signatureInput" type="file" accept="image/*" style="display:none" />';

				$(document.body).append(inputHtml);

				var element = $('#signatureInput');

				element.on('change', function () {
					var file = this.files[0];

					var MAX_SIZE = 2000; // 2MB MAX file size
					var usingFormat = ['image/png', 'image/jpg', 'image/jpeg'];

					if (file.size > MAX_SIZE * 1024) {
						file = null;
						return companyImageSizeError();
					}

					if (usingFormat.indexOf(file.type) < 0) {
						file = null;
						return companyImageError();
					}

					if (file) {
						var formData = new FormData();
						formData.append('file', file);
						saveNewImgOnServer(formData);
					}
				});

				element.trigger('click');
			};

			function getSettings() {
				emailSettingsDataService.getEmailSettings().subscribe(function (result) {
					removeAllImages();
					insertImg(result.imageUrl);
				}, function () {
					return serverError();
				});
			}

			return uploadNewImage();
		}
	});

	return taOptions;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js"), __webpack_require__("./node_modules/rangy/lib/rangy-core.js"), __webpack_require__("./node_modules/toastr/toastr.js")))

/***/ }),

/***/ "./web/js/helper/utils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.hasSomeParentTheClass = hasSomeParentTheClass;
exports.isInViewport = isInViewport;
var linkVariables = exports.linkVariables = ['%contract_link%', '%invoice_link%', '%quote_link%', '%questionnaire_link%', '%galleries_link%'];

var noReloadControllers = exports.noReloadControllers = {
	CalendarController: true,
	JobsOverviewController: true,
	LeadsOverviewController: true,
	ClientsController: true,
	PaymentsOverviewController: true
};

function hasSomeParentTheClass(element, classname) {
	if (element.className.split(' ').indexOf(classname) >= 0) return true;
	return element.parentElement && hasSomeParentTheClass(element.parentElement, classname);
}

function isInViewport(element) {
	var rect = element.getBoundingClientRect();
	return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
}

/***/ }),

/***/ "./web/js/services/copyToClipboardService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(toastr) {

(function () {
	angular.module('main').factory('copyToClipboardService', copyToClipboardService);

	copyToClipboardService.$inject = ['$compile', '$document', '$rootScope', 'messageService'];

	function copyToClipboardService($compile, $document, $rootScope, messageService) {
		return {
			copy: copy
		};

		function copy(element, successMessage) {
			var copyElement = angular.element('<span id="ngClipboardCopyId"></span>');
			copyElement.text(element);

			var body = $document.find('body').eq(0);
			body.append($compile(copyElement)($rootScope));

			var ngClipboardElement = angular.element(document.getElementById('ngClipboardCopyId'));
			var range = document.createRange();

			range.selectNode(ngClipboardElement[0]);

			window.getSelection().removeAllRanges();
			window.getSelection().addRange(range);

			document.execCommand('copy');

			switch (successMessage) {
				case 'url':
					messageService.showToaster('i_0', 'contactForm');
					break;
				case 'embed':
					messageService.showToaster('i_1', 'contactForm');
					break;
				case 'ambassador':
				case 'referral':
					messageService.showToaster('i_0', 'promoCodes');
					break;
				default:
					toastr.info('', 'Copied');
			}

			window.getSelection().removeAllRanges();

			copyElement.remove();
		}
	}
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/toastr/toastr.js")))

/***/ }),

/***/ "./web/js/services/dataServices/ambassadorsDataService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
	angular.module('main').factory('ambassadorsDataService', ambassadorsDataService);

	ambassadorsDataService.$inject = ['$http', '$q'];

	function ambassadorsDataService($http, $q) {
		var AMBASSADOR_URL = '/admin/rest/ambassador';

		return {
			createAmbassador: createAmbassador,
			getAmbassadors: getAmbassadors,
			getAmbassadorInfo: getAmbassadorInfo,
			updateAmbassador: updateAmbassador
		};

		function getAmbassadors(_ref) {
			var perPage = _ref.perPage,
			    page = _ref.page,
			    _ref$pageOrder = _ref.pageOrder,
			    predicate = _ref$pageOrder.predicate,
			    reverse = _ref$pageOrder.reverse,
			    search = _ref.search;

			var deferred = $q.defer();

			$http({
				method: 'GET',
				url: AMBASSADOR_URL,
				params: {
					perPage: perPage,
					page: page,
					predicate: predicate,
					reverse: reverse,
					search: search
				}
			}).then(function (response) {
				deferred.resolve(response.data);
			}, function (response) {
				deferred.reject(response);
			}).catch(function (response) {
				deferred.reject(response);
			});
			return deferred.promise;
		}

		function getAmbassadorInfo(id) {
			var deferred = $q.defer();

			$http({
				method: 'GET',
				url: AMBASSADOR_URL + '/' + id
			}).then(function (response) {
				deferred.resolve(response.data);
			}, function (response) {
				deferred.reject(response);
			}).catch(function (response) {
				deferred.reject(response);
			});
			return deferred.promise;
		}

		function createAmbassador(ambassador) {
			var deferred = $q.defer();

			$http({
				method: 'POST',
				url: AMBASSADOR_URL,
				data: ambassador
			}).then(function (response) {
				deferred.resolve(response.data);
			}, function (response) {
				deferred.reject(response);
			}).catch(function (response) {
				deferred.reject(response);
			});
			return deferred.promise;
		}

		function updateAmbassador(ambassador) {
			var deferred = $q.defer();

			$http({
				method: 'PUT',
				url: AMBASSADOR_URL,
				data: ambassador
			}).then(function (response) {
				deferred.resolve(response.data);
			}, function (response) {
				deferred.reject(response);
			}).catch(function (response) {
				deferred.reject(response);
			});
			return deferred.promise;
		}
	}
})();

/***/ }),

/***/ "./web/js/services/dataServices/jobDataService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
	angular.module('main').factory('jobDataService', jobDataService);

	jobDataService.$inject = ['$http', '$q'];

	function jobDataService($http, $q) {
		return {
			addNewClient: addNewClient,
			editJob: editJob,
			getActiveJobs: getActiveJobs,
			getJobInfo: getJobInfo,
			getJobTypes: getJobTypes,
			getJobsOnPage: getJobsOnPage,
			fillClientSearchText: fillClientSearchText,
			searchClient: searchClient,
			updateClient: updateClient
		};

		function getJobTypes() {
			var deferred = $q.defer();

			$http({
				method: 'GET',
				url: '/protected/rest/job/types/all'
			}).then(function (response) {
				deferred.resolve(response);
			}, function (response) {
				deferred.reject(response);
			}).catch(function (response) {
				deferred.reject(response);
			});
			return deferred.promise;
		}

		function getJobInfo(id) {
			var showNewTaskId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

			var deferred = $q.defer();

			$http({
				method: 'GET',
				url: '/protected/rest/jobs/view',
				params: {
					id: id,
					showNewTaskId: showNewTaskId
				}
			}).then(function (response) {
				deferred.resolve(response);
			}, function (response) {
				deferred.reject(response);
			}).catch(function (response) {
				deferred.reject(response);
			});
			return deferred.promise;
		}

		function editJob(job) {
			var deferred = $q.defer();

			$http({
				method: 'POST',
				url: '/protected/rest/add_new_job/update',
				data: job
			}).then(function (response) {
				deferred.resolve(response);
			}, function (response) {
				deferred.reject(response);
			}).catch(function (response) {
				deferred.reject(response);
			});
			return deferred.promise;
		}

		function addNewClient(client) {
			var deferred = $q.defer();

			$http({
				method: 'POST',
				url: '/protected/rest/clients/add',
				data: client
			}).then(function (response) {
				deferred.resolve(response);
			}, function (response) {
				deferred.reject(response);
			}).catch(function (response) {
				deferred.reject(response);
			});
			return deferred.promise;
		}

		function updateClient(client) {
			var deferred = $q.defer();

			$http({
				method: 'POST',
				url: '/protected/rest/clients/update',
				data: client
			}).then(function (response) {
				deferred.resolve(response);
			}, function (response) {
				deferred.reject(response);
			}).catch(function (response) {
				deferred.reject(response);
			});

			return deferred.promise;
		}

		function fillClientSearchText(client) {
			var email = client.email,
			    firstName = client.firstName,
			    id = client.id,
			    _client$lastName = client.lastName,
			    lastName = _client$lastName === undefined ? ' ' : _client$lastName;


			lastName = lastName === null ? ' ' : lastName;

			return {
				id: id,
				name: firstName + ' ' + lastName + ' (' + email + ')'
			};
		}

		function searchClient(searchClient) {
			var deferred = $q.defer();

			$http({
				method: 'GET',
				url: '/protected/rest/job/client/search',
				params: {
					search: searchClient
				}
			}).then(function (response) {
				deferred.resolve(response);
			}, function (response) {
				deferred.reject(response);
			}).catch(function (response) {
				deferred.reject(response);
			});

			return deferred.promise;
		}

		function getActiveJobs() {
			var deferred = $q.defer();

			$http({
				method: 'GET',
				url: '/protected/rest/jobs/active'
			}).then(function (response) {
				deferred.resolve(response.data);
			}, function (response) {
				deferred.reject(response);
			}).catch(function (response) {
				deferred.reject(response);
			});

			return deferred.promise;
		}

		function getJobsOnPage(pageRequest, active) {
			var perPage = pageRequest.perPage,
			    page = pageRequest.page,
			    _pageRequest$pageOrde = pageRequest.pageOrder,
			    predicate = _pageRequest$pageOrde.predicate,
			    reverse = _pageRequest$pageOrde.reverse,
			    search = pageRequest.search;

			var deferred = $q.defer();

			$http({
				method: 'GET',
				url: '/api/user/jobs',
				params: {
					perPage: perPage,
					page: page,
					predicate: predicate,
					reverse: reverse,
					search: search,
					active: active
				}
			}).then(function (response) {
				deferred.resolve(response.data);
			}, function (response) {
				deferred.reject(response);
			}).catch(function (response) {
				deferred.reject(response);
			});
			return deferred.promise;
		}
	}
})();

/***/ }),

/***/ "./web/js/services/dataServices/referralsDataService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
	angular.module('main').factory('referralsDataService', referralsDataService);

	referralsDataService.$inject = ['$http', '$q'];

	function referralsDataService($http, $q) {
		return {
			getAllReferrals: getAllReferrals
		};

		function getAllReferrals(_ref) {
			var perPage = _ref.perPage,
			    page = _ref.page,
			    _ref$pageOrder = _ref.pageOrder,
			    predicate = _ref$pageOrder.predicate,
			    reverse = _ref$pageOrder.reverse,
			    search = _ref.search;

			var deferred = $q.defer();

			$http({
				method: 'GET',
				url: '/admin/rest/referrals',
				params: {
					perPage: perPage,
					page: page,
					predicate: predicate,
					reverse: reverse,
					search: search
				}
			}).then(function (response) {
				deferred.resolve(response.data);
			}, function (response) {
				deferred.reject(response);
			}).catch(function (response) {
				deferred.reject(response);
			});
			return deferred.promise;
		}
	}
})();

/***/ }),

/***/ "./web/js/services/downgradedServices.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _search = __webpack_require__("./shared/services/helpers/search.service.ts");

var _message = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");

var _appointment = __webpack_require__("./shared/services/tasks/appointment.service.ts");

var _validation = __webpack_require__("./shared/services/helpers/validation.service.ts");

var _time = __webpack_require__("./shared/services/helpers/time-service/time.service.ts");

var _clientsData = __webpack_require__("./shared/services/client/clients.data.service.ts");

var _timeConverter = __webpack_require__("./shared/services/helpers/time-converter.ts");

var _client = __webpack_require__("./shared/services/client/client.service.ts");

var _extraShoot = __webpack_require__("./shared/services/tasks/extra-shoot.service.ts");

var _imageConverter = __webpack_require__("./shared/services/files/image-converter.service.ts");

var _calendarEventsData = __webpack_require__("./shared/services/calendar/calendar-events.data.service.ts");

var _randomStringGenerator = __webpack_require__("./shared/services/helpers/random-string-generator.ts");

var _integrationsData = __webpack_require__("./shared/services/integrations/integrations.data.service.ts");

var _templatesData = __webpack_require__("./shared/services/data-services/templates-data-service/templates.data.service.ts");

var _payments = __webpack_require__("./shared/services/payments/payments-service/payments.service.ts");

var _invoicesData = __webpack_require__("./shared/services/invoice/invoices-data-service/invoices.data.service.ts");

var _workflowData = __webpack_require__("./shared/services/workflow/workflow.data.service.ts");

var _workflow = __webpack_require__("./shared/services/workflow/workflow-service/workflow.service.ts");

var _workflowDragNDrop = __webpack_require__("./shared/services/workflow/workflow-drag-n-drop.ts");

var _email = __webpack_require__("./shared/services/email/email-service/email.service.ts");

var _mailsData = __webpack_require__("./shared/services/email/mails.data.service.ts");

var _utilsService = __webpack_require__("./shared/services/utils/utils-service.ts");

var _notesData = __webpack_require__("./shared/services/notes/notes.data.service.ts");

var _fileUploadData = __webpack_require__("./shared/services/files/file-upload.data.service.ts");

var _fileUpload = __webpack_require__("./shared/services/files/file-upload-service/file-upload.service.ts");

var _questionnairesData = __webpack_require__("./shared/services/questionnarie/questionnaires.data.service.ts");

var _contractsData = __webpack_require__("./shared/services/contract/contracts.data.service.ts");

var _emailSettingsData = __webpack_require__("./shared/services/settings/email-settings.data.service.ts");

var _accountData = __webpack_require__("./shared/services/user/account.data.service.ts");

var _stringModifier = __webpack_require__("./shared/services/helpers/string-modifier-service/stringModifier.service.ts");

var _account = __webpack_require__("./web/modern/services/user/account.service.ts");

var _user = __webpack_require__("./web/modern/services/user/user.service.ts");

var _promoCodeData = __webpack_require__("./shared/services/subscription/promo-code.data.service.ts");

var _settings = __webpack_require__("./shared/services/settings/settings.ts");

var _leadsData = __webpack_require__("./shared/services/lead/leads.data.service.ts");

var _jobsData = __webpack_require__("./shared/services/job/jobs.data.service.ts");

var _paymentsData = __webpack_require__("./shared/services/payments/payments-data-service/payments.data.service.ts");

var _quotesData = __webpack_require__("./shared/services/quote/quotes-data-service/quotes.data.service.ts");

var _languageData = __webpack_require__("./shared/services/language/language.data.service.ts");

var _jobTypesData = __webpack_require__("./shared/services/job/job-types.data.service.ts");

var _invoice = __webpack_require__("./shared/services/invoice/invoice-service/invoice.service.ts");

var _contracts = __webpack_require__("./shared/services/contract/contracts-service/contracts.service.ts");

var _questionnaires = __webpack_require__("./shared/services/questionnarie/questionnaires-service/questionnaires.service.ts");

var _productPackagesData = __webpack_require__("./mobile/src/providers/product-packages-service/product-packages.data.service.ts");

var _fileDownloadData = __webpack_require__("./shared/services/files/file-download-service/file-download.data.service.ts");

var _paymentsSchedulesData = __webpack_require__("./shared/services/payments/payments-schedules-data-service/payments-schedules.data.service.ts");

var _job = __webpack_require__("./shared/services/job/job.service.ts");

var _lead = __webpack_require__("./shared/services/lead/lead.service.ts");

var _ambassador = __webpack_require__("./web/modern/services/admin/ambassadors/ambassador.service.ts");

var _adminUsersData = __webpack_require__("./web/modern/services/admin/users/admin-users.data.service.ts");

var _adminReportsData = __webpack_require__("./web/modern/services/admin/users/admin-reports.data.service.ts");

var _pagination = __webpack_require__("./shared/services/pagination/pagination.service.ts");

var _calendar = __webpack_require__("./shared/services/calendar/calendar.service.ts");

var _calendarIntegration = __webpack_require__("./shared/services/calendar-integration/calendar-integration.service.ts");

var _companySettings = __webpack_require__("./shared/services/settings/company-settings.ts");

var _dashboardData = __webpack_require__("./shared/services/dashboard/dashboard.data.service.ts");

var _productPackagesData2 = __webpack_require__("./shared/services/settings/product-packages.data.service.ts");

var _paymentMethodsData = __webpack_require__("./web/modern/services/settings/payment-methods/payment-methods.data.service.ts");

var _profileUpdateData = __webpack_require__("./web/modern/services/profile/profile-update.data.service.ts");

var _shootProofData = __webpack_require__("./shared/services/integrations/shootProof/shootProof.data.service.ts");

var _subscription = __webpack_require__("./shared/services/subscription/subscription.service.ts");

var _settingsOverviewData = __webpack_require__("./shared/services/settings/settings-overview/settings-overview.data.service.ts");

var _brandsData = __webpack_require__("./shared/services/brands/brands.data.service.ts");

var _authTokens = __webpack_require__("./web/modern/auth-tokens.service.ts");

var _upgradeHelper = __webpack_require__("./web/upgrade/upgradeHelper.ts");

var _customizeLabels = __webpack_require__("./shared/services/settings/customize.labels.service.ts");

var _pickTimeData = __webpack_require__("./shared/services/integrations/pickTime/pickTime.data.service.ts");

var _leadSourcesData = __webpack_require__("./shared/services/lead-sources/lead-sources.data.service.ts");

var _doubleBooking = __webpack_require__("./shared/services/double-booking/double-booking.service.ts");

var _systemNotifications = __webpack_require__("./shared/services/system-notifications/system-notifications.service.ts");

var _reportsOverviewData = __webpack_require__("./shared/services/admin/reports/reports-overview.data.service.ts");

var moduleName = 'main'; // Angular services


_upgradeHelper.HybridHelper.downgradeProvider(moduleName, 'searchService', _search.SearchService).downgradeProvider(moduleName, 'messageService', _message.MessageService).downgradeProvider(moduleName, 'shootProofDataService', _shootProofData.ShootProofDataProvider).downgradeProvider(moduleName, 'appointmentService', _appointment.AppointmentServiceProvider).downgradeProvider(moduleName, 'validationService', _validation.ValidationProvider).downgradeProvider(moduleName, 'timeService', _time.TimeServiceProvider).downgradeProvider(moduleName, 'calendarService', _calendar.CalendarServiceProvider).downgradeProvider(moduleName, 'clientsDataService', _clientsData.ClientsDataServiceProvider).downgradeProvider(moduleName, 'calendarIntegrationService', _calendarIntegration.CalendarIntegrationProvider).downgradeProvider(moduleName, 'timeConverter', _timeConverter.TimeConverterProvider).downgradeProvider(moduleName, 'calendarService', _calendar.CalendarServiceProvider).downgradeProvider(moduleName, 'clientService', _client.ClientServiceProvider).downgradeProvider(moduleName, 'extraShootService', _extraShoot.ExtraShootServiceProvider).downgradeProvider(moduleName, 'imageConverter', _imageConverter.ImageConverterProvider).downgradeProvider(moduleName, 'calendarEventsDataService', _calendarEventsData.CalendarEventsDataProvider).downgradeProvider(moduleName, 'stringModifierService', _stringModifier.StringModifierServiceProvider).downgradeProvider(moduleName, 'SettingsOverviewDataService', _settingsOverviewData.SettingsOverviewDataProvider).downgradeProvider(moduleName, 'randomStringGenerator', _randomStringGenerator.RandomStringGeneratorProvider).downgradeProvider(moduleName, 'integrationsDataService', _integrationsData.IntegrationsDataProvider).downgradeProvider(moduleName, 'templateRequestsService', _templatesData.TemplatesDataProvider).downgradeProvider(moduleName, 'paymentsService', _payments.PaymentsServiceProvider).downgradeProvider(moduleName, 'invoicesDataService', _invoicesData.InvoicesDataProvider).downgradeProvider(moduleName, 'workflowDataService', _workflowData.WorkflowDataProvider).downgradeProvider(moduleName, 'newWorkflowService', _workflow.WorkflowProvider).downgradeProvider(moduleName, 'newWorkflowDragNDropService', _workflowDragNDrop.WorkflowDragNDropProvider).downgradeProvider(moduleName, 'emailService', _email.EmailServiceProvider).downgradeProvider(moduleName, 'mailsDataService', _mailsData.MailsDataProvider).downgradeProvider(moduleName, 'utilsService', _utilsService.UtilsServiceProvider).downgradeProvider(moduleName, 'notesDataService', _notesData.NotesDataServiceProvider).downgradeProvider(moduleName, 'fileUploadDataService', _fileUploadData.FileUploadDataProvider).downgradeProvider(moduleName, 'newfileUploadService', _fileUpload.FileUploadServiceProvider).downgradeProvider(moduleName, 'questionnairesDataService', _questionnairesData.QuestionnairesDataProvider).downgradeProvider(moduleName, 'contractsDataService', _contractsData.ContractsDataProvider).downgradeProvider(moduleName, 'emailSettingsDataService', _emailSettingsData.EmailSettingsDataService).downgradeProvider(moduleName, 'accountDataService', _accountData.AccountDataServiceProvider).downgradeProvider(moduleName, 'accountService', _account.AccountServiceWebProvider).downgradeProvider(moduleName, 'userService', _user.UserServiceWebProvider).downgradeProvider(moduleName, 'promoCodesDataService', _promoCodeData.PromoCodeDataProvider).downgradeProvider(moduleName, 'settingsService', _settings.SettingsProvider).downgradeProvider(moduleName, 'authTokensService', _authTokens.AuthTokensService).downgradeProvider(moduleName, 'leadDataService', _leadsData.LeadsDataServiceProvider).downgradeProvider(moduleName, 'newJobsDataService', _jobsData.JobsDataServiceProvider).downgradeProvider(moduleName, 'paymentsDataService', _paymentsData.PaymentsDataServiceProvider).downgradeProvider(moduleName, 'quotesDataService', _quotesData.QuotesDataProvider).downgradeProvider(moduleName, 'jobTypesDataService', _jobTypesData.JobTypesDataProvider).downgradeProvider(moduleName, 'languageDataService', _languageData.LanguageDataProvider).downgradeProvider(moduleName, 'invoiceService', _invoice.InvoiceServiceProvider).downgradeProvider(moduleName, 'contractService', _contracts.ContractsServiceProvider).downgradeProvider(moduleName, 'productPackageService', _productPackagesData.ProductPackagesServiceProvider).downgradeProvider(moduleName, 'questionnairesService', _questionnaires.QuestionnairesServiceProvider).downgradeProvider(moduleName, 'fileDownloadDataService', _fileDownloadData.FileDownloadDataServiceProvider).downgradeProvider(moduleName, 'paymentSchedulesDataService', _paymentsSchedulesData.PaymentSchedulesDataProvider).downgradeProvider(moduleName, 'jobService', _job.JobServiceProvider).downgradeProvider(moduleName, 'leadService', _lead.LeadServiceProvider).downgradeProvider(moduleName, 'ambassadorService', _ambassador.AmbassadorService).downgradeProvider(moduleName, 'adminUsersDataService', _adminUsersData.AdminUsersDataService).downgradeProvider(moduleName, 'adminReportsDataService', _adminReportsData.AdminReportsDataService).downgradeProvider(moduleName, 'paginationService', _pagination.PaginationService).downgradeProvider(moduleName, 'companySettingsService', _companySettings.CompanySettingsServiceProvider).downgradeProvider(moduleName, 'customizeLabelsService', _customizeLabels.CustomizeLabelsService).downgradeProvider(moduleName, 'paginationService', _pagination.PaginationService).downgradeProvider(moduleName, 'dashboardDataService', _dashboardData.DashboardDataServiceProvider).downgradeProvider(moduleName, 'productPackagesDataService', _productPackagesData2.ProductPackagesDataServiceProvider).downgradeProvider(moduleName, 'paymentMethodsDataProvider', _paymentMethodsData.PaymentMethodsDataProvider).downgradeProvider(moduleName, 'profileUpdateService', _profileUpdateData.ProfileUpdateDataServiceProvider).downgradeProvider(moduleName, 'subscriptionDataService', _subscription.NewSubscriptionServiceDataProvider).downgradeProvider(moduleName, 'systemNotificationsService', _systemNotifications.SystemNotificationsServiceDataProvider).downgradeProvider(moduleName, 'brandsDataService', _brandsData.BrandsDataServiceProvider).downgradeProvider(moduleName, 'pickTimeDataProvider', _pickTimeData.PickTimeDataProvider).downgradeProvider(moduleName, 'brandsDataService', _brandsData.BrandsDataServiceProvider).downgradeProvider(moduleName, 'leadSourcesDataService', _leadSourcesData.LeadSourcesDataService).downgradeProvider(moduleName, 'doubleBookingService', _doubleBooking.DoubleBookingService).downgradeProvider(moduleName, 'ReportsOverviewDataService', _reportsOverviewData.ReportsOverviewDataProvider);

/***/ }),

/***/ "./web/js/services/fileUploadService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

(function () {
	angular.module('main').factory('fileUploadService', fileUploadService);

	fileUploadService.$inject = ['$http', '$q', '$rootScope', 'imageConverter', 'messageService'];

	function fileUploadService($http, $q, $rootScope, imageConverter, messageService) {
		var filesList = [];

		return {
			saveFileOnServer: saveFileOnServer,
			deleteFileFromServer: deleteFileFromServer,
			convertAttachmentsToShow: convertAttachmentsToShow,
			convertFileToSave: convertFileToSave,
			getAttachment: getAttachment,
			getAttachments: getAttachments,
			getFiles: getFiles,
			setFiles: setFiles,
			setAttachmentsFromServer: setAttachmentsFromServer,
			removeDuplicates: removeDuplicates
		};

		function removeDuplicates(array, keyname) {
			var output = [];
			var keys = [];

			array.forEach(function (item) {
				var key = item[keyname];
				if (!keys.includes(key) || !key) {
					keys.push(key);
					output.push(item);
				}
			});
			return output;
		}

		function setFiles(files, isInitLoading) {
			if (isInitLoading) {
				filesList = files;
				filesList = removeDuplicates(filesList, 'id');
			} else if (Array.isArray(files)) {
				var _filesList;

				(_filesList = filesList).push.apply(_filesList, _toConsumableArray(files));
				filesList = removeDuplicates(filesList, 'id');
			} else {
				filesList.push(files);
				filesList = removeDuplicates(filesList, 'id');
			}
		}

		function getFiles() {
			return filesList;
		}

		function saveFileOnServer(dataToSave, jobId, successCallback, errorCallback) {
			var requestedJobId = jobId;

			if (typeof requestedJobId !== 'undefined') {
				var dataToSend = new FormData();

				dataToSend.append('file', dataToSave);

				$http({
					method: 'POST',
					cache: false,
					url: '/rest/user/jobs/' + requestedJobId + '/attachments/',
					data: dataToSend,
					transformRequest: angular.identity,
					headers: {
						'Content-Type': undefined,
						'Cache-Control': 'no-cache, no-store, must-revalidate'
					}
				}).then(function (result) {
					var response = result.data;
					response.convertedSize = (parseInt(response.bytesSize) / (1024 * 1024)).toFixed(2); // convert from bytes to MB
					var tmpDate = new Date(response.cratedTs);
					var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
					response.customLastModifiedDate = tmpDate.getDate() + ' ' + monthNames[tmpDate.getMonth()] + ' ' + tmpDate.getFullYear();
					successCallback(response);
				}).catch(function (result) {
					errorCallback(result.data);
				});
			}
		}

		function deleteFileFromServer(file, jobId, successCallback, errorCallback) {
			var requestedJobId = jobId;
			var fileID = file.id;

			$http({
				method: 'DELETE',
				cache: false,
				url: '/rest/user/jobs/' + requestedJobId + '/attachments/' + fileID,
				headers: {
					'Content-Type': undefined,
					'Cache-Control': 'no-cache, no-store, must-revalidate'
				}
			}).then(function (result) {
				var index = filesList.indexOf(file);
				filesList.splice(index, 1);
				successCallback(result.data);
			}).catch(function (result) {
				errorCallback(result.data);
			});
		}

		function getAttachment(id, jobId, successCallback) {
			var requestedId = id;
			var requestedJobId = jobId;

			$http({
				method: 'GET',
				cache: false,
				url: '/rest/user/jobs/' + requestedJobId + '/attachments/' + requestedId,
				transformRequest: angular.identity,
				transformResponse: angular.identity,
				headers: {
					'Content-Type': undefined,
					'Cache-Control': 'no-cache, no-store, must-revalidate'
				}
			}).then(function (result) {
				successCallback(result.data);
			}).catch(messageService.showDefaultErrorMessage);
		}

		function getAttachments(jobId, successCallback, errorCallback) {
			var requestedJobId = jobId;

			$http({
				method: 'GET',
				url: '/rest/user/jobs/' + requestedJobId + '/attachments',
				transformRequest: angular.identity,
				headers: {
					'Content-Type': undefined,
					'Cache-Control': 'no-cache, no-store, must-revalidate'
				}
			}).then(function (result) {
				var response = result.data;
				angular.forEach(result, function (value) {
					value.convertedSize = (parseInt(value.bytesSize) / (1024 * 1024)).toFixed(2); // convert from bytes to MB
				});
				successCallback(response);
			}).catch(function (result) {
				errorCallback(result.data);
			});
		}

		function convertFileToBase64(file) {
			var deferred = $q.defer();
			var reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onloadend = function () {
				if (reader.result) {
					var metaDataEnd = reader.result.indexOf(',') + 1;
					var convertedFile = reader.result.slice(metaDataEnd).trim();
					deferred.resolve({
						name: file.name,
						contentType: file.type,
						size: file.size,
						base64: convertedFile
					});
				} else {
					deferred.reject(reader.result);
				}
			};
			return deferred.promise;
		}

		function getConvertedFiles(filesArr) {
			return filesArr.map(function (file) {
				return convertFileToBase64(file);
			});
		}

		function convertFileToSave(filesArr) {
			var convertedFilesPromises = getConvertedFiles(filesArr);
			var deferred = $q.defer();

			$q.all(convertedFilesPromises).then(function (result) {
				deferred.resolve(result);
			}, function (error) {
				return deferred.reject(error);
			});

			return deferred.promise;
		}

		function convertAttachmentsToShow(attachments) {
			var attachmentsToShow = angular.copy(attachments);
			var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

			attachmentsToShow.forEach(function (attachment) {
				var tmpDate = new Date(attachment.cratedTs);
				attachment.convertedSize = (parseInt(attachment.bytesSize) / (1024 * 1024)).toFixed(2); // convert from bytes to MB
				attachment.customLastModifiedDate = tmpDate.getDate() + ' ' + monthNames[tmpDate.getMonth()] + ' ' + tmpDate.getFullYear();
				attachment.convertedType = imageConverter.getFileClass(attachment.name);
			});

			return attachmentsToShow;
		}

		function setAttachmentsFromServer(attachments) {
			var attachmentsToShow = angular.copy(attachments);
			attachmentsToShow = convertAttachmentsToShow(attachments);
			$rootScope.uploadedFiles = attachmentsToShow.length;
			setFiles(attachmentsToShow, true);
			return attachmentsToShow;
		}
	}
})();

/***/ }),

/***/ "./web/js/services/filters/cutEmailFilter.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('main').filter('cutEmail', function () {
	return function (value) {
		if (!value) {
			return '';
		}
		var max = 15;
		if (value.length <= max) {
			return value;
		}
		value = value.substr(0, max);
		return value + '...';
	};
});

/***/ }),

/***/ "./web/js/services/filters/cutStringFilter.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('main').filter('cutString', function () {
	return function (value, max) {
		if (!value) {
			return '';
		}
		if (value.length <= max) {
			return value;
		}
		value = value.substr(0, max);

		var lastSpace = value.lastIndexOf(' ');
		if (lastSpace !== -1) {
			if (value.charAt(lastSpace - 1) === '.' || value.charAt(lastSpace - 1) === ',' || value.charAt(lastSpace - 1) === '!' || value.charAt(lastSpace - 1) === '?') {
				lastSpace -= 1;
			}
			value = value.substr(0, lastSpace);
		}

		return value + '...';
	};
});

/***/ }),

/***/ "./web/js/services/filters/profilePriceFilter.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// (() => {
// 	angular.module('main').filter('profilePrice', [
// 		'$rootScope',
// 		'$filter',
// 		'userService',
// 		function($rootScope, $filter, userService) {
// 			return function(input, type) {
// 				const user = userService.userData;
//
// 				let output;
//
// 				if (!input && input !== 0) {
// 					return '';
// 				}
//
// 				const inputRound = $filter('currency')(input, '');
// 				const money = inputRound.toString().split('.');
//
// 				const subscriptionObj = user.subscriptionPrice;
//
// 				switch (type) {
// 					case 'bill':
// 						let symbol;
//
// 						symbol = subscriptionObj.currencySymbol || '$';
//
// 						output = symbol + money[0];
// 						break;
// 					case 'coin':
// 						output = `.${money[1]}` || '00';
// 						break;
// 					case 'label':
// 						let label = subscriptionObj.currencyName || 'USD';
//
// 						if (label == 'AUD' || label == 'NZD') {
// 							label = 'AUD';
// 						}
//
// 						output = label;
// 						break;
// 					case 'full-currency-symbol':
// 						const symbolFull = subscriptionObj.currencySymbol || '$';
// 						let labelFull = subscriptionObj.currencyName || 'USD';
//
// 						if (labelFull === 'AUD' || labelFull === 'NZD') {
// 							labelFull = 'AUD';
// 						}
//
// 						output = labelFull + symbolFull + inputRound;
// 						break;
// 					case 'discount':
// 						const discountSymbol = subscriptionObj.currencySymbol || '$';
//
// 						if (subscriptionObj.discount.percent) {
// 							output = `${money[0]}%`;
// 						} else {
// 							output = discountSymbol + money;
// 						}
// 						break;
// 					default:
// 						output = '';
// 				}
//
// 				return output;
// 			};
// 		}
// 	]);
// })();


/***/ }),

/***/ "./web/js/services/filters/timeFilter.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('main').filter('timeFilter', ['$filter', 'timeConverter', 'settingsService', function ($filter, timeConverter, settingsService) {
	var calendarSettingsDate = void 0,
	    calendarSettingsHours = void 0;

	settingsService.timeFormatSettings.subscribe(function (data) {
		calendarSettingsDate = data.dateFormat === 'DD_MM_YYYY';
		calendarSettingsHours = data.timeFormat === 'T_12';
	});

	return function (input, type) {
		var output = void 0;

		if (!input) {
			return '';
		}
		switch (type) {
			case '12h':
				if (calendarSettingsHours) {
					output = timeConverter.convert24to12(input);
				} else {
					output = input.substring(0, 5);
				}
				break;
			case '12hL':
				if (calendarSettingsHours) {
					output = timeConverter.convert24to12(input).toLocaleLowerCase();
				} else {
					output = input.substring(0, 5);
				}
				break;
			case '12hLS':
				if (calendarSettingsHours) {
					output = timeConverter.convert24to12(input).toLocaleLowerCase().replace(' ', '');
				} else {
					output = input.substring(0, 5);
				}
				break;
			case 'long':
				if (calendarSettingsDate) {
					output = $filter('date')(input, 'dd MMMM yyyy');
				} else {
					output = $filter('date')(input, 'MMMM dd yyyy');
				}
				break;
			case 'medium':
				if (calendarSettingsDate) {
					output = $filter('date')(input, 'dd MMM yyyy');
				} else {
					output = $filter('date')(input, 'MMM dd yyyy');
				}
				break;
			case 'dayAndMonth':
				if (calendarSettingsDate) {
					output = $filter('date')(input, 'dd MMMM');
				} else {
					output = $filter('date')(input, 'MMMM dd');
				}
				break;
			default:
				output = '';
		}

		return output;
	};
}]);

/***/ }),

/***/ "./web/js/services/filters/timezoneFilter.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// use time-zone-filter from shared directory
// delete this after signUp page upgrading

angular.module('main').filter('timezoneFilter', function () {
	return function (inputArray, type) {
		var output = void 0;

		if (!inputArray) {
			return [];
		}

		output = inputArray.map(function (obj) {
			var rObj = void 0,
			    newValue = void 0,
			    label = void 0;

			newValue = obj.value === 'Z' ? '00:00' : obj.value;
			label = '(' + newValue + ') ' + obj.key.replace('/', ' - ');

			rObj = {
				key: obj.key,
				label: label,
				value: newValue
			};

			return rObj;
		});

		return output;
	};
});

/***/ }),

/***/ "./web/js/services/paymentVariablesService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('main').service('paymentVariablesService', function () {
	var plan = void 0;

	var setPlan = function setPlan(newObj) {
		plan = newObj;
	};
	var getPlan = function getPlan() {
		return plan;
	};

	return {
		setPlan: setPlan,
		getPlan: getPlan
	};
});

/***/ }),

/***/ "./web/js/services/routeResolverService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
	angular.module('main').factory('routeResolver', routeResolver);

	routeResolver.$inject = ['$q', '$rootScope', '$route', '$location', 'accountService', 'subscriptionDataService', 'brandsDataService'];

	function routeResolver($q, $rootScope, $route, $location, accountService, subscriptionDataService, brandsDataService) {
		return {
			resolve: resolve
		};

		function resolve() {
			var route = $route.current;
			var deferred = $q.defer();
			var isClientPortal = route.templateUrl && route.templateUrl.includes('client/');

			checkAuth(route).then(function () {
				changeNavbar(route);
				changeBackground();
				handleFacebookPixel(route, isClientPortal);
				if (!route.requireLogin && accountService.isUserAuthenticated() && !isClientPortal) {
					$location.path('/');
					deferred.reject();
				}

				if (route.adminPage && !accountService.isAdmin()) {
					deferred.reject();
				}

				deferred.resolve(true);
			});

			return deferred.promise;
		}

		function checkAuth(route) {
			var deferred = $q.defer();
			if (!accountService.isUserAuthenticated() && route.requireLogin) {
				subscriptionDataService.fetchSubscriptionStatus().subscribe(function (subscription) {
					if (subscription.currentPlan) {
						brandsDataService.getBrandsData();
						accountService.getUserWeb().subscribe(function (data) {
							if (data && data.enabled) {
								subscriptionDataService.setSubscriptionData(subscription);

								$rootScope.removeBg = route.hideHeader ? 'true' : 'white-background';

								deferred.resolve(true);
							}
						}, function (err) {
							return deferred.reject(err);
						});
					} else {
						$location.path('/login');
						subscriptionDataService.setChoosePlanOpenModalStatus({
							state: true,
							payload: null
						});
					}
				});
			} else {
				deferred.resolve(true);
			}

			return deferred.promise;
		}

		function changeBackground() {
			var publicPaths = ['/login', '/signup', '/forgot'];

			if (publicPaths.includes($location.path())) {
				$rootScope.removeBg = false;
			}
		}

		function handleFacebookPixel(route, isClientPortal) {
			if (accountService.isUserAuthenticated() || route.templateUrl && isClientPortal) {
				var FBPicel1 = document.getElementById('FBPicel');

				if (FBPicel1) {
					var FBPicel2 = document.getElementById('FBPicelImg');
					FBPicel1.remove();
					FBPicel2.remove();
				}
			}
		}

		function changeNavbar(route) {
			if (route.role === 'client') {
				$rootScope.showLogo = false;
				accountService.emitShowHeader(false);
				accountService.setNavigationSettings('clientUser', 'anonymousUser');
			} else if (route.adminPage) {
				$rootScope.showLogo = true;
				accountService.emitShowHeader(true);
				accountService.setNavigationSettings('adminUser');
			} else if (route.role === 'user') {
				$rootScope.showLogo = true;
				accountService.emitShowHeader(true);
				accountService.setNavigationSettings('authenticatedUser');
			} else if (route.role === 'company') {
				$rootScope.showLogo = false;
				accountService.emitShowHeader(false);
				accountService.setNavigationSettings('companyUser', 'authenticatedUser');
			}
		}
	}
})();

/***/ }),

/***/ "./web/js/services/workflowDragNDropService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

(function () {
	angular.module('main').factory('workflowDragNDropService', workflowDragNDropService);

	workflowDragNDropService.$inject = ['workflowDataService'];

	function workflowDragNDropService(workflowDataService) {
		function replaceFirstWithSecond(list) {
			var _list = _toArray(list),
			    first = _list[0],
			    second = _list[1],
			    rest = _list.slice(2);

			return [second, first].concat(_toConsumableArray(rest));
		}

		function replaceLastWithPrevious(list) {
			var modifiedList = list;
			var last = modifiedList.pop();
			modifiedList.splice(modifiedList.length - 1, 0, last);
			return modifiedList;
		}

		function isDefaultTaskInPlace(list) {
			var isLastSection = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

			var checkedTask = void 0;
			var firstTask = list[0];
			var lastTask = list[list.length - 1];

			checkedTask = isLastSection ? lastTask : firstTask;

			var eventType = checkedTask.eventType || checkedTask.calendarEventType;
			if (checkedTask.defaultTask && eventType !== 'MAIN_SHOOT') {
				return true;
			}
			return false;
		}

		function checkForChangeType(item, taskTypes) {
			var numberOfTasksOfEachType = taskTypes.map(function (item) {
				return item.length;
			});

			var _numberOfTasksOfEachT = _slicedToArray(numberOfTasksOfEachType, 2),
			    leadNum = _numberOfTasksOfEachT[0],
			    productionNum = _numberOfTasksOfEachT[1];

			var firstNumInLastSection = leadNum + productionNum;
			if (item.number >= firstNumInLastSection) {
				return 'POST_PRODUCTION';
			} else if (item.number >= leadNum) {
				return 'PRODUCTION';
			}
			return 'LEAD';
		}

		function renewTaskList(taskTypesList) {
			var taskTypes = angular.copy(taskTypesList);
			var num = 0;
			taskTypes.forEach(function (taskType) {
				taskType.forEach(function (task) {
					task.number = num;
					task.type = checkForChangeType(task, taskTypes);

					if (task.dateSequence === 'after previous task') {
						if (num != 0) {
							task.previousTask = num - 1;
						}
					} else if (task.previousTask || task.previousTask === 0) {
						delete task.previousTask;
					}
					num++;
				});
			});

			return taskTypes;
		}

		function keepDefaultTasksInPlace(taskTypesArr) {
			var taskTypes = angular.copy(taskTypesArr);
			var numberOfTaskTypes = taskTypes.length;

			taskTypes.forEach(function (type, index, typesArr) {
				var lastElement = index === numberOfTaskTypes - 1;

				if (lastElement) {
					var isOrderCorrect = isDefaultTaskInPlace(type, true);
					if (!isOrderCorrect) {
						typesArr[index] = replaceLastWithPrevious(type);
					}
				} else {
					var _isOrderCorrect = isDefaultTaskInPlace(type);
					if (!_isOrderCorrect) {
						typesArr[index] = replaceFirstWithSecond(type);
					}
				}
			});

			return taskTypes;
		}

		function getTaskById(task2Search, taskTypes) {
			var task = angular.copy(task2Search);
			var isTaskId = task.id !== null && task.id !== undefined;

			var identificator = isTaskId ? 'id' : 'tmpId';

			if (!task[identificator]) {
				return false;
			}

			for (var i = 0, max = taskTypes.length; i < max; i++) {
				var taskType = taskTypes[i];
				var foundTask = taskType.find(function (taskInList) {
					return task[identificator] === taskInList[identificator];
				});

				if (foundTask) {
					return foundTask;
				}
			}
		}

		function checkForEqualNumbers(taskTypes) {
			var tasksArray = [].concat.apply([], taskTypes);
			var uniqueNumbers = [].concat(_toConsumableArray(new Set(tasksArray.map(function (a) {
				return a.number;
			}))));
			var isAllNumbersUnique = uniqueNumbers.length === tasksArray.length;
			return !isAllNumbersUnique;
		}

		function prepareTask2Save(draggedTask, taskTypes) {
			var newTaskInfo = getTaskById(draggedTask, taskTypes); // position in array with new numbers&types

			if (!newTaskInfo) {
				return false;
			}

			var isMainShootInWrongPlace = newTaskInfo.calendarEventType === 'MAIN_SHOOT' && newTaskInfo.type !== 'PRODUCTION';

			if (isMainShootInWrongPlace) {
				return false;
			}

			if (newTaskInfo.overdueDays) {
				newTaskInfo.overdueDays = parseInt(newTaskInfo.overdueDays.match(/\d+/)[0], 10);
			}

			var number = newTaskInfo.number,
			    type = newTaskInfo.type,
			    id = newTaskInfo.id,
			    overdueDays = newTaskInfo.overdueDays;


			return {
				number: number,
				type: type,
				id: id,
				overdueDays: overdueDays
			};
		}

		function saveNewTasksOrder(draggedTask, taskTypes) {
			var taskListCopy = angular.copy(taskTypes); // original array
			taskListCopy = renewTaskList(taskListCopy); // array with changed numbers+types

			var task2save = prepareTask2Save(draggedTask, taskListCopy);

			if (!task2save) {
				return;
			}

			var currentNumber = task2save.number,
			    currentType = task2save.type,
			    id = task2save.id,
			    overdueDays = task2save.overdueDays;


			var isPositionChanged = draggedTask.number !== currentNumber || draggedTask.type !== currentType;

			if (!isPositionChanged) {
				return false;
			}

			return workflowDataService.saveNewTasksOrder(id, currentNumber, currentType, overdueDays);
		}

		return {
			getTaskById: getTaskById,
			checkForEqualNumbers: checkForEqualNumbers,
			keepDefaultTasksInPlace: keepDefaultTasksInPlace,
			saveNewTasksOrder: saveNewTasksOrder,
			renewTaskList: renewTaskList
		};
	}
})();

/***/ }),

/***/ "./web/js/services/workflowService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Rx, toastr) {

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

(function () {
	angular.module('main').service('workflowService', workflowService);

	workflowService.$inject = ['$rootScope', 'messageService', 'workflowDataService', 'workflowDragNDropService', 'randomStringGenerator', 'validationService', 'timeService', 'settingsService', 'newWorkflowService'];

	function workflowService($rootScope, messageService, workflowDataService, workflowDragNDropService, randomStringGenerator, validationService, timeService, settingsService, newWorkflowService) {
		var taskInfo = {};

		var dateItems = ['days', 'months', 'hours'];

		var taskDateSequence = ['after lead created', 'after job accepted', 'before main shoot', 'after main shoot', 'after previous task'];

		var automatedActions = [{
			shortName: 'SEND_EMAIL',
			fullName: 'This task sends an email'
		}, {
			shortName: 'SEND_QUESTIONNAIRE',
			fullName: 'This task sends a questionnaire'
		}, {
			shortName: 'SEND_CONTRACT',
			fullName: 'This task sends a contract'
		}];

		var modalIds = {
			appointment: '#appointment',
			appointmentWithoutSchedule: '#appointmentWithoutScheduleModal',
			automation: '#addAutomationModal',
			extraShoot: '#extraShootModal',
			extraShootWithoutSchedule: '#extraShootWithoutScheduleModal',
			todo: '#addTodoModal'
		};

		var taskTypeNames = {
			lead: 'LEAD',
			production: 'PRODUCTION',
			postProduction: 'POST_PRODUCTION'
		};

		var eventTypes = {
			appointment: 'APPOINTMENT',
			extraShoot: 'EXTRA_SHOOT',
			mainShoot: 'MAIN_SHOOT'
		};

		function getTaskDates() {
			return dateItems;
		}

		function getTaskDateSequence() {
			return taskDateSequence;
		}

		function setTaskDateSequence(newTaskDateSequence) {
			taskDateSequence = JSON.parse(JSON.stringify(newTaskDateSequence));
		}

		function getAutomatedActions() {
			return automatedActions;
		}

		function setTaskInfo() {
			var task = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
			var taskList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
			var isForEdit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

			if (!task.due) {
				task = addDefaultDue(task);
			} else {
				task.hasDue = true;
			}
			taskInfo = { task: task, taskList: taskList, isForEdit: isForEdit };
		}

		function addEmptyTask() {
			return {
				id: null,
				defaultTask: false,
				hasDue: false,
				hasMail: false,
				name: ''
			};
		}

		function addDefaultDue(task) {
			var taskCopy = angular.copy(task);
			if (!taskCopy.id) {
				taskCopy.id = null;
			}
			taskCopy.due = 1;
			taskCopy.dateItem = dateItems[0];
			taskCopy.dateSequence = taskDateSequence[0].id;
			return taskCopy;
		}

		function getTaskInfo() {
			var isTaskInfoEmpty = angular.equals(taskInfo, {});
			if (isTaskInfoEmpty) {
				taskInfo.task = addEmptyTask();
			}
			return taskInfo;
		}

		function isEmailTemplateChosen(email, fromSettings) {
			var isEmail = email !== null && typeof email !== 'undefined' && (typeof email === 'undefined' ? 'undefined' : _typeof(email)) === 'object';
			if (!isEmail) {
				return false;
			}
			if (!fromSettings || isEmail) {
				return true;
			}
			var invalidEmail = email.hasOwnProperty('text') && !email.hasOwnProperty('subject') && !email.hasOwnProperty('name');
			return !invalidEmail;
		}

		function isEmailFieldsValid(email, fromSettings) {
			if (typeof email === 'undefined' || email === null) {
				return false;
			}
			var name = email.name,
			    subject = email.subject;


			if (fromSettings && validationService.isStringEmpty(name)) {
				messageService.showToaster('e_9', 'emailTemplate', 'name');
				return false;
			}

			if (subject !== null && validationService.isStringEmpty(subject)) {
				fromSettings ? messageService.showToaster('e_9', 'emailTemplate', 'subject') : messageService.showToaster('e_5', 'workflow');
				return false;
			}

			return true;
		}

		function isTaskValid(task) {
			var fromSettings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

			var isAutomation = task.hasMail || task.action;

			if (validationService.isStringEmpty(task.name)) {
				messageService.showToaster('e_1', 'workflow');
				return false;
			}

			if (task.hasDue || task.due) {
				var isDueDaysFilled = task.due || task.due >= 1;
				if (!isDueDaysFilled) {
					messageService.showToaster('e_2', 'workflow');
					return false;
				}
			}

			if (isAutomation) {
				if (!task.action) {
					messageService.showToaster('e_3', 'workflow');
					return false;
				}

				if (!isEmailTemplateChosen(task.taskEmail, fromSettings)) {
					messageService.showToaster('e_4', 'workflow');
					return false;
				}

				if (!isEmailFieldsValid(task.taskEmail, fromSettings)) {
					return false;
				}
			}

			return true;
		}

		function checkTaskDue(task) {
			var taskCopy = angular.copy(task);

			if (!taskCopy.hasDue || !taskCopy.due) {
				delete taskCopy.due;
				delete taskCopy.dateItem;
				taskCopy.dateSequence = null;
			}

			return taskCopy;
		}

		function replaceTask(oldTask, newTask, taskTypes) {
			var isTaskId = oldTask.id !== null && oldTask.id !== undefined;
			var identificator = isTaskId ? 'id' : 'number';

			var siblingTasks = getSiblingTasks(oldTask, taskTypes);
			siblingTasks.some(function (item, index) {
				if (oldTask[identificator] === item[identificator]) {
					siblingTasks[index] = newTask;
					return true;
				}
			});
			return taskTypes;
		}

		function getMainShootIndex(tasksArr) {
			for (var i = 0, max = tasksArr.length; i <= max; i++) {
				var event = tasksArr[i].hasOwnProperty('eventType') ? 'eventType' : 'calendarEventType';
				if (tasksArr[i][event] === eventTypes.mainShoot) {
					return i;
				}
			}
		}

		function getTaskIndex(task, tasksArr) {
			for (var i = 0, max = tasksArr.length; i <= max; i++) {
				if (tasksArr[i].number === task.number) {
					return i;
				}
			}
		}

		function concatTasksArr(taskTypes) {
			var tasks = [];
			taskTypes.forEach(function (taskType) {
				var _tasks;

				tasks = (_tasks = tasks).concat.apply(_tasks, _toConsumableArray(taskType));
			});

			return tasks;
		}

		function filterTasksWithDueDate(tasks) {
			return tasks.filter(function (task) {
				return task.dueDate || task.startDate;
			});
		}

		function addTaskDateTime(tasks) {
			return tasks.map(function (task) {
				var date = task.dueDate || task.startDate;
				var time = task.dueTime || task.startTime;
				if (task.type === taskTypeNames.lead && task.number === 0) {
					time = null;
				}
				task.dateTime = timeService.getDateAndTime(date, time);
				return task;
			});
		}

		function orderTasksByDate(tasks) {
			return tasks.sort(function (a, b) {
				return new Date(a.dateTime) - new Date(b.dateTime);
			});
		}

		function getNextTaskByDate(task, taskTypes) {
			var foundTask = void 0;

			var tasks = concatTasksArr(taskTypes);
			var tasksWithDueDate = filterTasksWithDueDate(tasks);
			var tasksWithDateTime = addTaskDateTime(tasksWithDueDate);
			var orderedTasksByDate = orderTasksByDate(tasksWithDateTime);

			var taskDateTime = timeService.getDateAndTime(task.startDate, task.startTime);

			var nextTask = orderedTasksByDate.find(function (taskInList) {
				return taskDateTime < taskInList.dateTime;
			});

			if (nextTask) {
				foundTask = nextTask;
			} else {
				var lastTaskWithDate = orderedTasksByDate[orderedTasksByDate.length - 1];
				foundTask = getTaskAfterLastWithDate(taskTypes, lastTaskWithDate);
			}

			return foundTask || tasks[tasks.length - 1];
		}

		function getTaskAfterLastWithDate(taskTypes, lastTaskWithDate) {
			return getTaskByNumber(lastTaskWithDate.number + 1, taskTypes);
		}

		function pasteNewTaskInList(taskTypes, task2Paste) {
			var taskTypesCopy = angular.copy(taskTypes);

			var task = checkTaskDue(task2Paste);

			var taskInList = false;

			if (task.number !== null && task.number !== undefined) {
				if (task.id !== null && task.id !== undefined) {
					taskInList = workflowDragNDropService.getTaskById(task2Paste, taskTypes);
				} else {
					taskInList = getTaskByNumber(task2Paste.number, taskTypes);
				}
			}

			if (taskInList) {
				var currentDateSequence = task.dateSequence;
				if (!currentDateSequence || !task.hasDue || !task.due) {
					currentDateSequence = null;
				}
				var isDateSequenceChanged = taskInList.dateSequence !== currentDateSequence;
				var isTaskStartDateChanged = taskInList.startDate && taskInList.startDate !== task.startDate;
				if (isDateSequenceChanged || isTaskStartDateChanged) {
					deleteTaskFromList(taskInList, taskTypesCopy);
				} else {
					taskTypesCopy = replaceTask(taskInList, task, taskTypesCopy);
					return taskTypesCopy;
				}
			}

			taskTypesCopy = task.startDate ? pasteTaskWithDate(task, taskTypesCopy) : pasteTaskWithoutDate(task, taskTypesCopy);

			return taskTypesCopy;
		}

		function pasteTaskWithoutDate(task, taskTypes) {
			var _taskTypes = taskTypes,
			    _taskTypes2 = _slicedToArray(_taskTypes, 3),
			    lead = _taskTypes2[0],
			    production = _taskTypes2[1],
			    postProduction = _taskTypes2[2];

			var mainShootIndex = getMainShootIndex(production);

			switch (task.dateSequence) {
				case taskDateSequence[0].id:
					lead.splice(lead.length, 0, task);
					break;
				case taskDateSequence[1].id:
				case taskDateSequence[2].id:
					production.splice(mainShootIndex, 0, task);
					break;
				case taskDateSequence[3].id:
					postProduction.splice(0, 0, task);
					break;
				case taskDateSequence[4].id:
					postProduction.splice(postProduction.length - 1, 0, task);
					break;
				default:
					postProduction.splice(postProduction.length - 1, 0, task);
					break;
			}

			taskTypes = [lead, production, postProduction];
			taskTypes = workflowDragNDropService.renewTaskList(taskTypes);

			return taskTypes;
		}

		function pasteTaskWithDate(task, taskTypes) {
			var taskToPasteType = void 0,
			    nextTaskIndex = void 0;

			var _taskTypes3 = taskTypes,
			    _taskTypes4 = _slicedToArray(_taskTypes3, 3),
			    lead = _taskTypes4[0],
			    production = _taskTypes4[1],
			    postProduction = _taskTypes4[2];

			var MIN_INDEX = 1;

			var nextTask = getNextTaskByDate(task, taskTypes);
			taskToPasteType = nextTask.type;

			switch (taskToPasteType) {
				case taskTypeNames.lead:
					nextTaskIndex = getTaskIndex(nextTask, lead);

					// not to paste on first position
					if (nextTaskIndex === 0) {
						nextTaskIndex = MIN_INDEX;
					}

					lead.splice(nextTaskIndex, 0, task);
					break;

				case taskTypeNames.production:
					nextTaskIndex = getTaskIndex(nextTask, production);

					// not to paste on first position
					if (nextTaskIndex === 0) {
						nextTaskIndex = MIN_INDEX;
					}

					production.splice(nextTaskIndex, 0, task);
					break;

				case taskTypeNames.postProduction:
				default:
					nextTaskIndex = getTaskIndex(nextTask, postProduction);
					// prefer pasting calendar events in production stage
					if (nextTaskIndex === 0) {
						production.push(task);
						break;
					}
					postProduction.splice(nextTaskIndex, 0, task);
					break;
			}

			taskTypes = [lead, production, postProduction];
			taskTypes = workflowDragNDropService.renewTaskList(taskTypes);

			return taskTypes;
		}

		function getSiblingTasks(task, taskTypes) {
			var _taskTypes5 = _slicedToArray(taskTypes, 3),
			    leadCreated = _taskTypes5[0],
			    jobAccepted = _taskTypes5[1],
			    jobCompleted = _taskTypes5[2];

			switch (task.type) {
				case taskTypeNames.lead:
					return leadCreated;
				case taskTypeNames.production:
					return jobAccepted;
				case taskTypeNames.postProduction:
					return jobCompleted;
				default:
					break;
			}
		}

		function deleteTaskFromList(task, taskTypes) {
			var siblingTasks = getSiblingTasks(task, taskTypes);

			var isTaskId = task.id !== null && task.id !== undefined;
			var identificator = isTaskId ? 'id' : 'number';

			siblingTasks.some(function (item, index) {
				if (task[identificator] === item[identificator]) {
					siblingTasks.splice(index, 1);
					return true;
				}
			});
		}

		function getTaskTemplates(id, successCallback) {
			return workflowDataService.getTaskTemplates(id).subscribe(function (data) {
				return successCallback(data);
			}, function (error) {
				return messageService.showDefaultErrorMessage(error);
			});
		}

		function saveWorkflowTemplate(workflow, successCallback) {
			return workflowDataService.saveWorkflow(workflow).map(function (data) {
				return successCallback(data, workflow);
			}, function (result) {
				return errorSaveTask(result);
			});
		}

		function getJobWorkflow(id, successCallback) {
			return workflowDataService.getWorkflow(id).subscribe(function (data) {
				return successCallback(data);
			}, function (error) {
				return messageService.showDefaultErrorMessage(error);
			});
		}

		function deleteTask(taskTypes, task) {
			return workflowDataService.deleteTask(task.id);
		}

		function validateEmailLinks(action, emailTemplateId) {
			return workflowDataService.validateEmailLinks(action, emailTemplateId);
		}

		function validateEmailName(email) {
			if (email.id) {
				return Rx.Observable.of('');
			}
			return workflowDataService.validateEmailName(email);
		}

		function deleteTaskFromSettings(workflow, taskTypes, task) {
			var workflowCopy = angular.copy(workflow);

			if (task.id !== null && task.id !== undefined) {
				if (!workflowCopy.taskToDelete) {
					workflowCopy.taskToDelete = [];
				}
				workflowCopy.taskToDelete.push(task.id);
			}

			deleteTaskFromList(task, taskTypes);

			return workflowCopy;
		}

		function getTaskByNumber(number, taskTypes) {
			for (var i = 0, max = taskTypes.length; i < max; i++) {
				var taskType = taskTypes[i];
				var foundTask = taskType.find(function (item) {
					return number === item.number;
				});
				if (foundTask) {
					return foundTask;
				}
			}
			return null;
		}

		var filterTasksBy = function filterTasksBy(taskList, tasksType) {
			return taskList.filter(function (task) {
				return task.type === tasksType;
			});
		};

		function calcTaskOverdue(overdueDays) {
			var taskOverdue = void 0;

			if (overdueDays > 0) {
				taskOverdue = isNaN(overdueDays) ? NaN : '! ' + overdueDays + ' day' + (overdueDays > 1 ? 's' : '') + ' overdue';
			}

			return taskOverdue || overdueDays || null;
		}

		function pluralizeDue(dueAmount, dueItem) {
			var resultDue = void 0;
			var isPluralItem = dueItem.endsWith('s');

			if (dueAmount > 1) {
				resultDue = isPluralItem ? dueItem : dueItem + 's';
			} else {
				resultDue = isPluralItem ? dueItem.slice(0, -1) : dueItem;
			}

			return resultDue;
		}

		var getTaskViewDue = function getTaskViewDue(task, taskTypes) {
			var taskViewDue = null;
			var dateItem = task.dateItem,
			    due = task.due,
			    dateSequence = task.dateSequence,
			    prevTaskNumber = task.previousTask;

			var isTaskDue = [dateItem, due != 'undefined', due != null, dateSequence].every(Boolean);
			if (!isTaskDue) {
				return taskViewDue;
			}

			var dateItemTmp = pluralizeDue(due, dateItem.toLowerCase());

			var dateSequenceTmp = dateSequence.replace('_', ' ').toLowerCase();

			taskViewDue = due + ' ' + dateItemTmp + ' ';

			if (dateSequence === 'after previous task') {
				var previousTask = getTaskByNumber(prevTaskNumber, taskTypes);
				taskViewDue += previousTask !== null ? 'after ' + previousTask.name : dateSequenceTmp;
			} else {
				taskViewDue += dateSequenceTmp;
			}
			return taskViewDue;
		};

		function renewTaskViewDue(taskList) {
			var renewedList = angular.copy(taskList);
			renewedList.forEach(function (taskType) {
				taskType.forEach(function (task) {
					task.taskViewDue = getTaskViewDue(task, renewedList);
				});
			});
			return renewedList;
		}

		function fillWorkflowTasks() {
			var taskList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

			return [filterTasksBy(taskList, 'LEAD'), filterTasksBy(taskList, 'PRODUCTION'), filterTasksBy(taskList, 'POST_PRODUCTION')];
		}

		function prepareTaskToSave(task, jobId) {
			var task2save = angular.copy(task);

			var overdueDays = task2save.overdueDays,
			    email = task2save.taskEmail;


			if (overdueDays) {
				task2save.overdueDays = parseInt(overdueDays.match(/\d+/)[0], 10);
			}

			if (email) {
				email.text = $rootScope.addMaiStyling(email.text);
			}

			if (task2save.jobId === null || task2save.jobId === undefined) {
				task2save.jobId = jobId;
			}

			if (task2save.tmpId) {
				delete task2save.tmpId;
			}

			return task2save;
		}

		function errorSaveTask(result) {
			var data = result.data,
			    error = result.error;


			if (error && error.errorCode) {
				toastr.clear();
				messageService.handleError(result);
				return;
			}

			if (result.errorMessage) {
				toastr.clear();
				messageService.showErrorFromBackend('Whoops, something has gone wrong!', result.errorMessage);
			}

			if (data.errorMessage === 'Signed contract cannot be modified') {
				messageService.showErrorFromBackend('Whoops, something has gone wrong!', data.errorMessage);
			} else if (data.errorMessage) {
				var errorCode = void 0,
				    errorPlace = void 0;

				switch (data.errorMessage) {
					case "Tasks can't have due < 1 (if present)":
						errorCode = 'e_2';
						errorPlace = 'workflow';
						break;
					case 'Email text should contain a questionnaire link':
						errorCode = 'e_6';
						errorPlace = 'emailTemplate';
						break;
					case 'Email text should contain a contract link':
						errorCode = 'e_5';
						errorPlace = 'emailTemplate';
						break;
					case 'Please, reload the file':
						errorCode = 'e_7';
						errorPlace = 'workflow';
						break;
					default:
						errorCode = 'e_0';
						errorPlace = 'general';
				}
				toastr.clear();
				messageService.showToaster(errorCode, errorPlace);
			} else {
				toastr.clear();
				messageService.showToaster('e_0', 'general');
			}
		}

		function saveTask(task, jobId, taskTypes) {
			var task2Save = angular.copy(task);

			var isTaskId = task2Save.id !== null && task2Save.id !== undefined;

			if (!isTaskId) {
				task2Save.tmpId = randomStringGenerator.getMixedString();
			}

			var taskTypesCopy = angular.copy(taskTypes);

			if (!isTaskValid(task2Save)) {
				return Rx.Observable.throwError('Not a valid task');
			}

			task2Save = checkTaskDue(task2Save);
			taskTypesCopy = pasteNewTaskInList(taskTypesCopy, task2Save);
			taskTypesCopy = workflowDragNDropService.renewTaskList(taskTypesCopy);

			var newTaskPosition = workflowDragNDropService.getTaskById(task2Save, taskTypesCopy);

			task2Save.number = newTaskPosition.number;
			// if ((task2Save.calendarEventType !== "APPOINTMENT" || task2Save.calendarEventType !== "EXTRA_SHOOT") && task2Save.type !== "LEAD") {
			task2Save.type = newTaskPosition.type;
			// } else {
			//     task2Save.type = "LEAD";
			// }
			task2Save = prepareTaskToSave(task2Save, jobId);

			return workflowDataService.saveTask(task2Save);
		}

		function chooseModalToShow(task, template) {
			var modal = '';

			var eventType = task.eventType || task.calendarEventType;

			if (task.action || task.hasMail) {
				modal = modalIds.automation;
			} else if (eventType === eventTypes.appointment && template) {
				modal = modalIds.appointmentWithoutSchedule;
			} else if (eventType === eventTypes.appointment && !template) {
				modal = modalIds.appointment;
			} else if (eventType === eventTypes.extraShoot && template) {
				modal = modalIds.extraShootWithoutSchedule;
			} else if (eventType === eventTypes.extraShoot && !template) {
				modal = modalIds.extraShoot;
			} else {
				modal = modalIds.todo;
			}

			return modal;
		}

		function setLabelsToTaskDateSequence() {
			settingsService.customizeLabelsObservable.filter(function (labels) {
				return labels.mainShootLabel;
			}).subscribe(function (labels) {
				setTaskDateSequence(setCorrectNaming(labels.mainShootLabel));
				newWorkflowService.setTaskDateSequence(newWorkflowService.setCorrectNaming(labels.mainShootLabel));
			});

			function setCorrectNaming(mainShootLabel) {
				var originalTaskDateSequence = ['after lead created', 'after job accepted', 'before main shoot', 'after main shoot', 'after previous task'];

				return originalTaskDateSequence.map(function (taskName) {
					return {
						id: taskName,
						name: taskName.includes('main shoot') ? taskName.replace('main shoot', mainShootLabel.toLowerCase()) : taskName
					};
				});
			}
		}

		return {
			addEmptyTask: addEmptyTask,
			calcTaskOverdue: calcTaskOverdue,
			chooseModalToShow: chooseModalToShow,
			deleteTask: deleteTask,
			deleteTaskFromSettings: deleteTaskFromSettings,
			getAutomatedActions: getAutomatedActions,
			getTaskTemplates: getTaskTemplates,
			getTaskByNumber: getTaskByNumber,
			getTaskInfo: getTaskInfo,
			getTaskDates: getTaskDates,
			getTaskDateSequence: getTaskDateSequence,
			// isLabelShown,
			getTaskViewDue: getTaskViewDue,
			getJobWorkflow: getJobWorkflow,
			errorSaveTask: errorSaveTask,
			filterTasksBy: filterTasksBy,
			fillWorkflowTasks: fillWorkflowTasks,
			isTaskValid: isTaskValid,
			validateEmailLinks: validateEmailLinks,
			validateEmailName: validateEmailName,
			pasteNewTaskInList: pasteNewTaskInList,
			renewTaskViewDue: renewTaskViewDue,
			saveTask: saveTask,
			setTaskInfo: setTaskInfo,
			saveWorkflowTemplate: saveWorkflowTemplate,
			setLabelsToTaskDateSequence: setLabelsToTaskDateSequence
		};
	}
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/rxjs/Rx.js"), __webpack_require__("./node_modules/toastr/toastr.js")))

/***/ }),

/***/ "./web/main.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var platform_browser_dynamic_1 = __webpack_require__("./node_modules/@angular/platform-browser-dynamic/esm5/platform-browser-dynamic.js");
var static_1 = __webpack_require__("./node_modules/@angular/upgrade/esm5/static.js");
var router_1 = __webpack_require__("./node_modules/@angular/router/esm5/router.js");
var app_module_1 = __webpack_require__("./web/app.module.ts");
function getSafariVersion() {
    var ua = navigator.userAgent;
    var tem = ua.match(/version\/(\d+)/i);
    var M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (M[2]) {
        M = [M[1], M[2]];
    } else {
        M = [navigator.appName, navigator.appVersion, '-?'];
    }
    if (tem != null) {
        M.splice(1, 1, tem[1]);
    }
    if (M[0] === 'Safari') {
        return parseInt(M[1]);
    }
    return 1000;
}
var isIE = navigator.userAgent.indexOf('MSIE ') > -1 || navigator.userAgent.indexOf('Trident/') > -1;
var safariVersion = getSafariVersion();
var isNotSupportedBrowser = safariVersion < 9 || !Modernizr.flexbox || !Modernizr.sizes;
if (!isNotSupportedBrowser && !isIE) {
    platform_browser_dynamic_1.platformBrowserDynamic().bootstrapModule(app_module_1.AppModule).then(function (platformRef) {
        var upgrade = platformRef.injector.get(static_1.UpgradeModule);
        upgrade.bootstrap(document.body, ['main'], {
            strictDi: true
        });
        platformRef.injector.get(router_1.Router).initialNavigation();
    }).catch(function (err) {
        return console.error('Error on bootstrap => ', err);
    });
}

/***/ }),

/***/ "./web/modern/auth-tokens.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });
var BehaviorSubject_1 = __webpack_require__("./node_modules/rxjs/BehaviorSubject.js");
var OauthClient;
(function (OauthClient) {
    OauthClient["WEB"] = "Basic U05fV0VCOndlYlBhc3M=";
    OauthClient["WEB_STLG"] = "Basic U05fV0VCX1NUTEc6d2ViUGFzcw==";
})(OauthClient || (OauthClient = {}));

var AuthTokensService = function () {
    function AuthTokensService() {
        _classCallCheck(this, AuthTokensService);

        this.tokenSubject = new BehaviorSubject_1.BehaviorSubject(null);
    }

    _createClass(AuthTokensService, [{
        key: "isRefreshingInProcess",
        value: function isRefreshingInProcess() {
            return this.isRefreshingToken;
        }
    }, {
        key: "setRefreshingInProcess",
        value: function setRefreshingInProcess(value) {
            this.isRefreshingToken = value;
        }
    }, {
        key: "emitTokenSubject",
        value: function emitTokenSubject(value) {
            return this.tokenSubject.next(value);
        }
    }, {
        key: "setAuthToken",
        value: function setAuthToken(token) {
            localStorage.setItem('authToken', token);
        }
    }, {
        key: "setRefreshToken",
        value: function setRefreshToken(token) {
            localStorage.setItem('refreshToken', token);
        }
    }, {
        key: "getAuthToken",
        value: function getAuthToken() {
            return localStorage.getItem('authToken');
        }
    }, {
        key: "getRefreshToken",
        value: function getRefreshToken() {
            return localStorage.getItem('refreshToken');
        }
    }, {
        key: "removeTokens",
        value: function removeTokens() {
            localStorage.removeItem('authToken');
            localStorage.removeItem('refreshToken');
        }
    }, {
        key: "isToken",
        value: function isToken(url, token) {
            return this.shouldRequestBeAuthorised(url) && typeof token !== 'undefined' && token !== null;
        }
    }, {
        key: "successGetRefreshedToken",
        value: function successGetRefreshedToken(data) {
            var access_token = data.access_token,
                refresh_token = data.refresh_token;

            this.removeTokens();
            this.setAuthToken(access_token);
            this.setRefreshToken(refresh_token);
            return access_token;
        }
    }, {
        key: "getCorrectBasicWebToken",
        value: function getCorrectBasicWebToken() {
            var logIn = localStorage.getItem('isStayLogin');
            var basicToken = OauthClient.WEB;
            if (logIn === null) {
                location.href = '/login';
            } else if (logIn === 'true') {
                basicToken = OauthClient.WEB_STLG;
            }
            return basicToken;
        }
    }, {
        key: "shouldRequestBeAuthorised",
        value: function shouldRequestBeAuthorised(url) {
            var protectedRequestStart = '/protected/rest';
            var protectedBaseStart = '/protected_base/rest';
            var apiRequestsStart = '/api';
            var apiPublicRequestsStart = '/api/public';
            var restRequestStart = '/rest';
            var revokeTokenRequest = '/oauth/revoke';
            var adminRequestsStart = '/admin';
            return url && (url.includes(protectedRequestStart) || url.includes(restRequestStart) || url.includes(protectedBaseStart) || url.includes(apiRequestsStart) && !url.includes(apiPublicRequestsStart) || url.includes(revokeTokenRequest)) || url.startsWith(adminRequestsStart);
        }
    }, {
        key: "tokenSubject$",
        get: function get() {
            return this.tokenSubject.asObservable();
        }
    }]);

    return AuthTokensService;
}();

exports.AuthTokensService = AuthTokensService;

/***/ }),

/***/ "./web/modern/components/2fa/modals/manage-user-2fa-modal/manage-user-2fa-modal.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"manageUserTwoFaModal\" class=\"modal modal-center fade\" data-backdrop=\"static\" data-keyboard=\"false\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <button class=\"close\" (click)=\"onDismiss()\" data-dismiss=\"modal\">&times;</button>\n                <h3 class=\"modal-title\">Two Factor Authentication Information</h3>\n            </div>\n            <div class=\"modal-body clearfix\">\n                <div class=\"table-responsive\">\n                    <table class=\"table table-hover table-clients-overview mb-0\">\n                        <thead>\n                            <tr class=\"invoice-thead\">\n                                <th class=\"w-min-100\">First name</th>\n                                <th class=\"w-min-100\">Last name</th>\n                                <th class=\"w-min-100\">Email</th>\n                                <th class=\"w-min-50\">Verification code</th>\n                                <th>Actions</th>\n                            </tr>\n\n                        </thead>\n                        <tbody *ngIf=\"twoFaInfo?.users?.length\">\n                            <tr *ngFor=\"let user of twoFaInfo.users; let i = index\" height=\"60px\">\n                                <td>{{ user.firstName }}</td>\n                                <td>{{ user.lastName }}</td>\n                                <td>{{ user.email }}</td>\n                                <td>{{ user.sixDigitCode  || '' }}</td>\n                                <td>\n                                    <span class=\"text-nowrap\">\n                                        <button *ngIf=\"user.actions.TURN_OFF_2FA\"\n                                                [disabled]=\"btnDisable\" spinning-wheel [is-spinning-wheel-active]=\"disabledRowIndex === i\"\n                                                class=\"btn btn-md btn-success mb-0\" (click)=\"confirmTwoFaAction(user, i)\">{{ user.actions.TURN_OFF_2FA.actionName }}</button>\n                                    </span>\n                                </td>\n                            </tr>\n                        </tbody>\n                    </table>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),

/***/ "./web/modern/components/2fa/modals/manage-user-2fa-modal/manage-user-2fa-modal.scss":
/***/ (function(module, exports) {

module.exports = ".modal-body {\n  padding: 0 !important; }\n"

/***/ }),

/***/ "./web/modern/components/2fa/modals/manage-user-2fa-modal/manage-user-2fa-modal.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var two_fa_authentication_data_service_1 = __webpack_require__("./shared/services/user/two-fa-authentication.data.service.ts");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var rxjs_1 = __webpack_require__("./node_modules/rxjs/Rx.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var admin_users_data_service_1 = __webpack_require__("./web/modern/services/admin/users/admin-users.data.service.ts");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var confirm_general_modal_component_1 = __webpack_require__("./web/modern/components/common/confirm-general-modal/confirm-general-modal.component.ts");
var ManageUser2faModal = function () {
    function ManageUser2faModal(twoFaAuthenticationDataService, messageService, adminUsersDataService, modalService) {
        _classCallCheck(this, ManageUser2faModal);

        this.twoFaAuthenticationDataService = twoFaAuthenticationDataService;
        this.messageService = messageService;
        this.adminUsersDataService = adminUsersDataService;
        this.modalService = modalService;
        this.closeModal = new core_1.EventEmitter();
        this.unsubscribe = new rxjs_1.Subject();
    }

    _createClass(ManageUser2faModal, [{
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "onDismiss",
        value: function onDismiss() {
            this.closeModal.emit();
        }
    }, {
        key: "confirmTwoFaAction",
        value: function confirmTwoFaAction(user, index) {
            var _this = this;

            var modal = this.modalService.openModal(confirm_general_modal_component_1.ConfirmGeneralModalComponent);
            document.body.classList.remove('modal-open');
            modal.componentInstance.text = "Are you sure you want to turn off two-factor authentication for user " + user.email + "?";
            modal.componentInstance.buttons = [{
                text: 'Yes, turn it off',
                color: 'danger',
                size: 'lg',
                action: 'TURN_OFF_2FA'
            }, {
                text: 'No, keep it on',
                color: 'success',
                size: 'lg',
                action: 'REJECT_ACTION'
            }];
            modal.result.then(function (state) {
                document.body.classList.add('modal-open');
                if (state === 'TURN_OFF_2FA') {
                    _this.switchOff2Fa(user, index);
                }
            });
        }
    }, {
        key: "switchOff2Fa",
        value: function switchOff2Fa(user, index) {
            var _this2 = this;

            this.btnDisable = true;
            this.disabledRowIndex = index;
            var _user$actions$TURN_OF = user.actions.TURN_OFF_2FA,
                url = _user$actions$TURN_OF.url,
                method = _user$actions$TURN_OF.method;

            this.twoFaAuthenticationDataService.send2FAAction(url, method).pipe(operators_1.takeUntil(this.unsubscribe), operators_1.finalize(function () {
                _this2.btnDisable = false;
                _this2.disabledRowIndex = null;
            })).subscribe(function () {
                _this2.messageService.showToaster('s_6', 'twoFa', user.email);
                _this2.updateUserTwoFaInfo();
            }, function (_ref) {
                var error = _ref.error;
                var errorMessage = error.errorMessage,
                    errorTitle = error.errorTitle;

                _this2.messageService.showErrorFromBackend(errorTitle, errorMessage);
            });
        }
    }, {
        key: "updateUserTwoFaInfo",
        value: function updateUserTwoFaInfo() {
            var _this3 = this;

            this.adminUsersDataService.getUserTwoFaInfo(this.businessAccountId).pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (_ref2) {
                var data = _ref2.data;

                if (!data.users.length) {
                    _this3.messageService.showErrorFromBackend('Whooops', 'Seems like there are no users with 2FA set up on this account');
                    _this3.onDismiss();
                    return;
                }
                _this3.twoFaInfo = data;
            }, function (_ref3) {
                var error = _ref3.error;
                var errorTitle = error.errorTitle,
                    errorMessage = error.errorMessage;

                _this3.messageService.showErrorFromBackend(errorTitle, errorMessage);
                _this3.onDismiss();
            });
        }
    }]);

    return ManageUser2faModal;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], ManageUser2faModal.prototype, "twoFaInfo", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], ManageUser2faModal.prototype, "businessAccountId", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], ManageUser2faModal.prototype, "closeModal", void 0);
ManageUser2faModal = __decorate([core_1.Component({
    selector: 'two-fa-setup',
    template: __webpack_require__("./web/modern/components/2fa/modals/manage-user-2fa-modal/manage-user-2fa-modal.html"),
    styles: [__webpack_require__("./web/modern/components/2fa/modals/manage-user-2fa-modal/manage-user-2fa-modal.scss")]
}), __metadata("design:paramtypes", [two_fa_authentication_data_service_1.TwoFaAuthenticationDataService, message_service_1.MessageService, admin_users_data_service_1.AdminUsersDataService, snModal_service_1.SNModalService])], ManageUser2faModal);
exports.ManageUser2faModal = ManageUser2faModal;

/***/ }),

/***/ "./web/modern/components/2fa/modals/two-fa-login-modal/two-fa-login-modal.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-body two-fa-login\">\n    <button class=\"close absolute-close\" (click)=\"onDismiss()\" data-dismiss=\"modal\">&times;</button>\n    <form (ngSubmit)=\"performLogin()\">\n        <h2 class=\"two-fa-login-header mb-0 mt-10\">Complete login with the authenticator app</h2>\n        <div class=\"two-fa-login-body\">\n            <label for=\"login-2fa-code\" class=\"two-fa-login-body-label text-align-center mt-30\">Enter the 6-digit code provided by the authenticator app.</label>\n            <input type=\"text\" id=\"login-2fa-code\" placeholder=\"Authentication code\"\n                   maxlength=\"6\" class=\"form-control mt-20\" [(ngModel)]=\"verificationCode\" [ngModelOptions]=\"{standalone: true}\">\n            <button class=\"btn btn-md btn-success btn-rounded mb-0 two-fa-login-body-button\"\n                    type=\"submit\"\n                    [disabled]=\"buttonDisable\"\n                    spinning-wheel [is-spinning-wheel-active]=\"buttonDisable\">Login</button>\n            <p class=\"link-text text-align-center mt-20 mb-0\" (click)=\"moveToResetModal()\">Don't have the app? Reset your authentication</p>\n        </div>\n    </form>\n</div>"

/***/ }),

/***/ "./web/modern/components/2fa/modals/two-fa-login-modal/two-fa-login-modal.scss":
/***/ (function(module, exports) {

module.exports = ".two-fa-login {\n  padding: 50px; }\n  .two-fa-login .absolute-close {\n    position: absolute;\n    right: 15px;\n    top: 10px; }\n  .two-fa-login-header {\n    text-align: center;\n    font-size: 21px;\n    color: #22baa1; }\n  .two-fa-login-body {\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: column;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-align: center;\n    -webkit-align-items: center;\n        -ms-flex-align: center;\n            align-items: center;\n    padding: 0 60px; }\n    @media screen and (max-width: 420px) {\n      .two-fa-login-body {\n        padding: 0; } }\n    .two-fa-login-body-label {\n      font-size: 13px;\n      font-weight: 500; }\n    .two-fa-login-body-button {\n      font-size: 14px;\n      padding: 11px 60px !important;\n      margin-top: 20px !important; }\n    .two-fa-login-body .link-text {\n      color: #13a2bb;\n      text-decoration: underline; }\n      .two-fa-login-body .link-text:hover {\n        color: #74cae7;\n        cursor: pointer; }\n"

/***/ }),

/***/ "./web/modern/components/2fa/modals/two-fa-login-modal/two-fa-login-modal.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var account_service_1 = __webpack_require__("./web/modern/services/user/account.service.ts");
var ng_bootstrap_1 = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/index.js");
var account_data_service_1 = __webpack_require__("./shared/services/user/account.data.service.ts");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var two_fa_authentication_service_1 = __webpack_require__("./shared/services/user/two-fa-authentication.service.ts");
var auth_tokens_service_1 = __webpack_require__("./web/modern/auth-tokens.service.ts");
var TwoFaLoginModalComponent = function () {
    function TwoFaLoginModalComponent(accountService, accountDataService, authTokenService, activeModal, messageService, twoFaAuthenticationService) {
        _classCallCheck(this, TwoFaLoginModalComponent);

        this.accountService = accountService;
        this.accountDataService = accountDataService;
        this.authTokenService = authTokenService;
        this.activeModal = activeModal;
        this.messageService = messageService;
        this.twoFaAuthenticationService = twoFaAuthenticationService;
        this.unsubscribe = new Subject_1.Subject();
    }

    _createClass(TwoFaLoginModalComponent, [{
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "performLogin",
        value: function performLogin() {
            var _this = this;

            if (this.twoFaAuthenticationService.isTwoFaLoginInfoValid(this.verificationCode)) {
                this.userPayload.userData.sixDigitVerificationCode = this.verificationCode;
                this.buttonDisable = true;
                this.accountDataService.authenticateWithTwoFa(this.userPayload.userData, this.userPayload.authorizationKey).pipe(operators_1.takeUntil(this.unsubscribe), operators_1.finalize(function () {
                    return _this.buttonDisable = false;
                })).subscribe(function (data) {
                    _this.messageService.showToaster('s_4', 'twoFa');
                    _this.authTokenService.successGetRefreshedToken(data);
                    _this.activeModal.close('SUCCESS_LOGIN');
                }, function (_ref) {
                    var error = _ref.error;
                    var errorTitle = error.errorTitle,
                        errorMessage = error.errorMessage;

                    _this.messageService.showErrorFromBackend(errorTitle, errorMessage);
                });
            }
        }
    }, {
        key: "moveToResetModal",
        value: function moveToResetModal() {
            if (!this.buttonDisable) {
                this.activeModal.close('LAUNCH_RESET');
            }
        }
    }, {
        key: "onDismiss",
        value: function onDismiss() {
            if (!this.buttonDisable) {
                this.activeModal.dismiss();
            }
        }
    }]);

    return TwoFaLoginModalComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], TwoFaLoginModalComponent.prototype, "userPayload", void 0);
TwoFaLoginModalComponent = __decorate([core_1.Component({
    selector: 'two-fa-setup',
    template: __webpack_require__("./web/modern/components/2fa/modals/two-fa-login-modal/two-fa-login-modal.html"),
    styles: [__webpack_require__("./web/modern/components/2fa/modals/two-fa-login-modal/two-fa-login-modal.scss")]
}), __metadata("design:paramtypes", [account_service_1.AccountServiceWebProvider, account_data_service_1.AccountDataServiceProvider, auth_tokens_service_1.AuthTokensService, ng_bootstrap_1.NgbActiveModal, message_service_1.MessageService, two_fa_authentication_service_1.TwoFaAuthenticationService])], TwoFaLoginModalComponent);
exports.TwoFaLoginModalComponent = TwoFaLoginModalComponent;

/***/ }),

/***/ "./web/modern/components/2fa/modals/two-fa-reset-modal/two-fa-reset-modal.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-body two-fa-reset\" *ngIf=\"recoverForm\">\n    <button class=\"close absolute-close\" (click)=\"onDismiss()\" data-dismiss=\"modal\">&times;</button>\n    <form (ngSubmit)=\"resetAuthentication()\" [formGroup]=\"recoverForm\">\n        <h2 class=\"two-fa-reset-header mb-0 mt-10\">Answer security questions</h2>\n        <div class=\"two-fa-reset-questions mt-30\">\n            <div class=\"two-fa-reset-questions-item\" *ngFor=\"let question of recoverUser2FA.secretQuestions\">\n                <label class=\"mb-0\" [attr.for]=\"question.id\">{{ question.question }}</label>\n                <input class=\"form-control mt-10\" type=\"text\" maxlength=\"255\" placeholder=\"Answer\"\n                       [id]=\"question.id\" [formControlName]=\"question.id\">\n            </div>\n        </div>\n        <div class=\"text-align-center mt-30\">\n            <button class=\"btn btn-md btn-success mb-0 two-fa-reset-button\"\n                    spinning-wheel [is-spinning-wheel-active]=\"buttonDisable\">Reset two-factor authentication</button>\n            <p class=\"link-text mt-20 mb-0\" (click)=\"moveToLoginModal()\">Complete login with the authenticator app</p>\n        </div>\n\n    </form>\n</div>"

/***/ }),

/***/ "./web/modern/components/2fa/modals/two-fa-reset-modal/two-fa-reset-modal.scss":
/***/ (function(module, exports) {

module.exports = ".two-fa-reset {\n  padding: 30px 60px !important; }\n  .two-fa-reset .absolute-close {\n    position: absolute;\n    right: 15px;\n    top: 10px; }\n  .two-fa-reset-header {\n    text-align: center;\n    font-size: 21px;\n    color: #22baa1; }\n  .two-fa-reset-questions-item {\n    margin-top: 25px;\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: column;\n        -ms-flex-direction: column;\n            flex-direction: column; }\n    .two-fa-reset-questions-item label {\n      font-size: 13px;\n      font-weight: 500; }\n  .two-fa-reset-button {\n    font-size: 14px;\n    white-space: normal; }\n  .two-fa-reset .link-text {\n    color: #13a2bb;\n    text-decoration: underline; }\n    .two-fa-reset .link-text:hover {\n      color: #74cae7;\n      cursor: pointer; }\n"

/***/ }),

/***/ "./web/modern/components/2fa/modals/two-fa-reset-modal/two-fa-reset-modal.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var ng_bootstrap_1 = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/index.js");
var two_fa_authentication_data_service_1 = __webpack_require__("./shared/services/user/two-fa-authentication.data.service.ts");
var forms_1 = __webpack_require__("./node_modules/@angular/forms/esm5/forms.js");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var account_data_service_1 = __webpack_require__("./shared/services/user/account.data.service.ts");
var two_fa_authentication_service_1 = __webpack_require__("./shared/services/user/two-fa-authentication.service.ts");
var auth_tokens_service_1 = __webpack_require__("./web/modern/auth-tokens.service.ts");
var TwoFaResetModalComponent = function () {
    function TwoFaResetModalComponent(activeModal, twoFaAuthenticationDataService, twoFaAuthenticationService, messageService, accountDataService, authTokenService) {
        _classCallCheck(this, TwoFaResetModalComponent);

        this.activeModal = activeModal;
        this.twoFaAuthenticationDataService = twoFaAuthenticationDataService;
        this.twoFaAuthenticationService = twoFaAuthenticationService;
        this.messageService = messageService;
        this.accountDataService = accountDataService;
        this.authTokenService = authTokenService;
        this.unsubscribe = new Subject_1.Subject();
    }

    _createClass(TwoFaResetModalComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.setupReactiveForm();
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "resetAuthentication",
        value: function resetAuthentication() {
            var _this = this;

            var dataToSend = this.prepareDataToSend();
            if (this.twoFaAuthenticationService.isTwoFaResetDataValid(dataToSend.questions)) {
                var _recoverUser2FA$actio = this.recoverUser2FA.actions.RECOVER_2FA,
                    url = _recoverUser2FA$actio.url,
                    method = _recoverUser2FA$actio.method;

                this.buttonDisable = true;
                this.twoFaAuthenticationDataService.reset2FaAuthentication(url, method, dataToSend).pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function () {
                    return _this.performLogin();
                }, function (_ref) {
                    var error = _ref.error;

                    _this.buttonDisable = false;
                    var errorTitle = error.errorTitle,
                        errorMessage = error.errorMessage;

                    _this.messageService.showErrorFromBackend(errorTitle, errorMessage);
                });
            }
        }
    }, {
        key: "moveToLoginModal",
        value: function moveToLoginModal() {
            if (!this.buttonDisable) {
                this.activeModal.close('LAUNCH_LOGIN');
            }
        }
    }, {
        key: "onDismiss",
        value: function onDismiss() {
            if (!this.buttonDisable) {
                this.activeModal.dismiss();
            }
        }
    }, {
        key: "setupReactiveForm",
        value: function setupReactiveForm() {
            var controls = {};
            this.recoverUser2FA.secretQuestions.forEach(function (question) {
                controls[question.id] = new forms_1.FormControl();
            });
            this.recoverForm = new forms_1.FormGroup(controls);
        }
    }, {
        key: "prepareDataToSend",
        value: function prepareDataToSend() {
            var _this2 = this;

            var data = [];
            Object.keys(this.recoverForm.value).forEach(function (questionId) {
                data.push({ questionId: questionId, answer: _this2.recoverForm.value[questionId] });
            });
            return { questions: data };
        }
    }, {
        key: "performLogin",
        value: function performLogin() {
            var _this3 = this;

            this.accountDataService.authenticateWithTwoFa(this.userPayload.userData, this.userPayload.authorizationKey).pipe(operators_1.takeUntil(this.unsubscribe), operators_1.finalize(function () {
                return _this3.buttonDisable = false;
            })).subscribe(function (data) {
                _this3.messageService.showToaster('s_5', 'twoFa');
                _this3.authTokenService.successGetRefreshedToken(data);
                _this3.activeModal.close('SUCCESS_LOGIN');
            }, function (_ref2) {
                var error = _ref2.error;
                var errorTitle = error.errorTitle,
                    errorMessage = error.errorMessage;

                _this3.messageService.showErrorFromBackend(errorTitle, errorMessage);
            });
        }
    }]);

    return TwoFaResetModalComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], TwoFaResetModalComponent.prototype, "recoverUser2FA", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], TwoFaResetModalComponent.prototype, "userPayload", void 0);
TwoFaResetModalComponent = __decorate([core_1.Component({
    selector: 'two-fa-setup',
    template: __webpack_require__("./web/modern/components/2fa/modals/two-fa-reset-modal/two-fa-reset-modal.html"),
    styles: [__webpack_require__("./web/modern/components/2fa/modals/two-fa-reset-modal/two-fa-reset-modal.scss")]
}), __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal, two_fa_authentication_data_service_1.TwoFaAuthenticationDataService, two_fa_authentication_service_1.TwoFaAuthenticationService, message_service_1.MessageService, account_data_service_1.AccountDataServiceProvider, auth_tokens_service_1.AuthTokensService])], TwoFaResetModalComponent);
exports.TwoFaResetModalComponent = TwoFaResetModalComponent;

/***/ }),

/***/ "./web/modern/components/2fa/modals/two-fa-setup-modal/enter-code/enter-code.component.html":
/***/ (function(module, exports) {

module.exports = "<h3 class=\"code-header mt-0 mb-15\">Enter your validation code</h3>\n<input class=\"form-control\"\n       type=\"text\"\n       placeholder=\"Enter the 6-digit code\"\n       maxlength=\"6\"\n       [ngModel]=\"verificationCode\"\n       (blur)=\"onCodeType($event)\">"

/***/ }),

/***/ "./web/modern/components/2fa/modals/two-fa-setup-modal/enter-code/enter-code.component.scss":
/***/ (function(module, exports) {

module.exports = ".code-header {\n  font-size: 14px;\n  font-weight: 700; }\n"

/***/ }),

/***/ "./web/modern/components/2fa/modals/two-fa-setup-modal/enter-code/enter-code.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var EnterCodeComponent = function () {
    function EnterCodeComponent() {
        _classCallCheck(this, EnterCodeComponent);

        this.codeEnter = new core_1.EventEmitter();
    }

    _createClass(EnterCodeComponent, [{
        key: "onCodeType",
        value: function onCodeType(event) {
            this.codeEnter.emit(event.target.value);
        }
    }]);

    return EnterCodeComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", String)], EnterCodeComponent.prototype, "verificationCode", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], EnterCodeComponent.prototype, "codeEnter", void 0);
EnterCodeComponent = __decorate([core_1.Component({
    selector: 'enter-code',
    template: __webpack_require__("./web/modern/components/2fa/modals/two-fa-setup-modal/enter-code/enter-code.component.html"),
    styles: [__webpack_require__("./web/modern/components/2fa/modals/two-fa-setup-modal/enter-code/enter-code.component.scss")]
})], EnterCodeComponent);
exports.EnterCodeComponent = EnterCodeComponent;

/***/ }),

/***/ "./web/modern/components/2fa/modals/two-fa-setup-modal/get-authenticator/get-authenticator.component.html":
/***/ (function(module, exports) {

module.exports = "<h3 class=\"mt-0 mb-30\">Scan this QR image into your authenticator app</h3>\n<div class=\"block-wrapper\">\n    <div class=\"qr-image\">\n        <div *ngIf=\"!QRImage\" class=\"qr-image-spinner\" spinning-wheel [is-spinning-wheel-active]=\"!QRImage\" [is-spinning-wheel-dark]=\"'true'\"></div>\n        <img *ngIf=\"QRImage\" [src]=\"QRImage\" alt=\"QR Code\">\n    </div>\n    <div class=\"right-side-wrapper\">\n        <div class=\"qr-description\">\n            Please use Google Authenticator or an equivalent authenticator app. <a target=\"_blank\" href=\"http://help.studioninja.co/en/articles/4481947-setting-up-two-factor-authentication-via-an-authenticator-app\">Learn how</a>\n        </div>\n        <div class=\"code-input\">\n            <label for=\"code\">If you can't scan the image, enter this code instead:</label>\n            <input class=\"form-control code-input-field\" id=\"code\" [value]=\"code\" type=\"text\" disabled>\n            <div class=\"mt-10 text-align-right\">\n                <button (click)=\"copyToClipboard($event)\" [cbContent]=\"code\" class=\"btn btn-info btn-rounded mb-0\" ngxClipboard>Copy to Clipboard</button>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),

/***/ "./web/modern/components/2fa/modals/two-fa-setup-modal/get-authenticator/get-authenticator.component.scss":
/***/ (function(module, exports) {

module.exports = ".block-wrapper {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex; }\n  .block-wrapper .qr-image-spinner {\n    height: 200px;\n    width: 200px; }\n  .block-wrapper .qr-image img {\n    width: 200px;\n    height: auto; }\n  .block-wrapper .right-side-wrapper {\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: column;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-pack: justify;\n    -webkit-justify-content: space-between;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n    padding-left: 30px; }\n    .block-wrapper .right-side-wrapper .code-input-field {\n      background: #ffffff;\n      -webkit-text-fill-color: #4e5e6a;\n      color: #4e5e6a; }\n  @media screen and (max-width: 700px) {\n    .block-wrapper {\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n      -webkit-flex-direction: column;\n          -ms-flex-direction: column;\n              flex-direction: column;\n      -webkit-box-align: center;\n      -webkit-align-items: center;\n          -ms-flex-align: center;\n              align-items: center; }\n      .block-wrapper .right-side-wrapper {\n        padding-left: 0;\n        margin-top: 30px; } }\n"

/***/ }),

/***/ "./web/modern/components/2fa/modals/two-fa-setup-modal/get-authenticator/get-authenticator.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var GetAuthenticatorComponent = function () {
    function GetAuthenticatorComponent(messageService) {
        _classCallCheck(this, GetAuthenticatorComponent);

        this.messageService = messageService;
    }

    _createClass(GetAuthenticatorComponent, [{
        key: "copyToClipboard",
        value: function copyToClipboard(ev) {
            ev.preventDefault();
            this.messageService.showToaster('i_0', 'twoFa');
        }
    }]);

    return GetAuthenticatorComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", String)], GetAuthenticatorComponent.prototype, "QRImage", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], GetAuthenticatorComponent.prototype, "code", void 0);
GetAuthenticatorComponent = __decorate([core_1.Component({
    selector: 'get-authenticator',
    template: __webpack_require__("./web/modern/components/2fa/modals/two-fa-setup-modal/get-authenticator/get-authenticator.component.html"),
    styles: [__webpack_require__("./web/modern/components/2fa/modals/two-fa-setup-modal/get-authenticator/get-authenticator.component.scss")]
}), __metadata("design:paramtypes", [message_service_1.MessageService])], GetAuthenticatorComponent);
exports.GetAuthenticatorComponent = GetAuthenticatorComponent;

/***/ }),

/***/ "./web/modern/components/2fa/modals/two-fa-setup-modal/set-up-questions/question-item/question-item.component.html":
/***/ (function(module, exports) {

module.exports = "<h3 class=\"question-heading mb-0 mt-20\">Security Question {{ index }}</h3>\n<div class=\"select-style mt-20\">\n    <select (change)=\"changeQuestion($event)\" [ngModel]=\"field.question\">\n        <option value=\"null\">Select a question</option>\n        <option *ngFor=\"let question of availableQuestions\"\n                [value]=\"question.question\"\n                [disabled]=\"question.selected && question.question !== this.field.question\">{{ question.question }}</option>\n    </select>\n</div>\n<p class=\"question-label-text text-align-center f-s-12\" *ngIf=\"selectedAnswer\">{{ selectedAnswer }}</p>\n<div class=\"mt-20\">\n    <input type=\"text\" class=\"form-control\" placeholder=\"Answer\" [(ngModel)]=\"field.answer\" maxlength=\"255\">\n</div>\n"

/***/ }),

/***/ "./web/modern/components/2fa/modals/two-fa-setup-modal/set-up-questions/question-item/question-item.component.scss":
/***/ (function(module, exports) {

module.exports = ".question-heading {\n  font-size: 14px;\n  font-weight: 700; }\n\n.question-label-text {\n  font-style: italic;\n  line-height: 1.5;\n  margin-top: 5px; }\n  @media screen and (min-width: 520px) {\n    .question-label-text {\n      display: none; } }\n"

/***/ }),

/***/ "./web/modern/components/2fa/modals/two-fa-setup-modal/set-up-questions/question-item/question-item.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var QuestionItemComponent = function () {
    function QuestionItemComponent() {
        _classCallCheck(this, QuestionItemComponent);
    }

    _createClass(QuestionItemComponent, [{
        key: "changeQuestion",
        value: function changeQuestion(event) {
            if (this.field.question) {
                this.changeQuestionSelectedState(this.field.question, false);
            }
            if (event.target.value === 'null') {
                this.field.question = null;
                this.field.answer = '';
                this.selectedAnswer = null;
                return;
            }
            this.changeQuestionSelectedState(event.target.value, true);
            this.field.question = event.target.value;
        }
    }, {
        key: "changeQuestionSelectedState",
        value: function changeQuestionSelectedState(question, state) {
            var _this = this;

            this.availableQuestions.forEach(function (questionItem) {
                if (questionItem.question === question) {
                    questionItem.selected = state;
                    _this.selectedAnswer = questionItem.question;
                }
            });
        }
    }]);

    return QuestionItemComponent;
}();
__decorate([core_1.ViewChild('select'), __metadata("design:type", Object)], QuestionItemComponent.prototype, "select", void 0);
__decorate([core_1.Input(), __metadata("design:type", Number)], QuestionItemComponent.prototype, "index", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], QuestionItemComponent.prototype, "field", void 0);
__decorate([core_1.Input(), __metadata("design:type", Array)], QuestionItemComponent.prototype, "availableQuestions", void 0);
QuestionItemComponent = __decorate([core_1.Component({
    selector: 'question-item',
    template: __webpack_require__("./web/modern/components/2fa/modals/two-fa-setup-modal/set-up-questions/question-item/question-item.component.html"),
    styles: [__webpack_require__("./web/modern/components/2fa/modals/two-fa-setup-modal/set-up-questions/question-item/question-item.component.scss")]
})], QuestionItemComponent);
exports.QuestionItemComponent = QuestionItemComponent;

/***/ }),

/***/ "./web/modern/components/2fa/modals/two-fa-setup-modal/set-up-questions/set-up-questions.component.html":
/***/ (function(module, exports) {

module.exports = "<p>We will use security questions as a way to verify your identity, as a backup to the authenticator app.\n    Please choose and answer 3 questions below.</p>\n\n<div class=\"question-wrapper\" *ngFor=\"let question of submittedQuestions; let i = index\">\n    <question-item [field]=\"question\"\n                   [availableQuestions]=\"availableQuestions\"\n                   [index]=\"i+1\">\n    </question-item>\n</div>"

/***/ }),

/***/ "./web/modern/components/2fa/modals/two-fa-setup-modal/set-up-questions/set-up-questions.component.scss":
/***/ (function(module, exports) {

module.exports = ".question-wrapper {\n  margin-top: 23px;\n  border-top: 1px solid #c2c2c2; }\n"

/***/ }),

/***/ "./web/modern/components/2fa/modals/two-fa-setup-modal/set-up-questions/set-up-questions.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var SetUpQuestionsComponent = function SetUpQuestionsComponent() {
    _classCallCheck(this, SetUpQuestionsComponent);
};
__decorate([core_1.Input(), __metadata("design:type", Array)], SetUpQuestionsComponent.prototype, "submittedQuestions", void 0);
__decorate([core_1.Input(), __metadata("design:type", Array)], SetUpQuestionsComponent.prototype, "availableQuestions", void 0);
SetUpQuestionsComponent = __decorate([core_1.Component({
    selector: 'set-up-questions',
    template: __webpack_require__("./web/modern/components/2fa/modals/two-fa-setup-modal/set-up-questions/set-up-questions.component.html"),
    styles: [__webpack_require__("./web/modern/components/2fa/modals/two-fa-setup-modal/set-up-questions/set-up-questions.component.scss")]
})], SetUpQuestionsComponent);
exports.SetUpQuestionsComponent = SetUpQuestionsComponent;

/***/ }),

/***/ "./web/modern/components/2fa/modals/two-fa-setup-modal/two-fa-setup-modal.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n    <button class=\"close\" (click)=\"onDismiss()\" data-dismiss=\"modal\">&times;</button>\n    <h3 class=\"modal-title f-w-n\">Set Up Two-Factor Authentication</h3>\n</div>\n<div class=\"modal-body\">\n    <div class=\"stepper\">\n        <div class=\"stepper-header\">\n            <div class=\"step\" *ngFor=\"let step of steps; let i = index\">\n                <span class=\"step-number\" [class.active]=\"i === activeStep\">{{ step.number }}</span>\n                <label class=\"step-label\">{{ step.label }}</label>\n            </div>\n        </div>\n        <div class=\"stepper-body\" [ngSwitch]=\"activeStep\">\n            <get-authenticator *ngSwitchCase=\"0\" [QRImage]=\"QRImage\"\n                               [code]=\"userTwoFASettings.configure2faMetadata.twoFaSecret\"></get-authenticator>\n            <set-up-questions *ngSwitchCase=\"1\" [submittedQuestions]=\"dataToSave.secretQuestions\" [availableQuestions]=\"questions\"></set-up-questions>\n            <enter-code *ngSwitchCase=\"2\" [verificationCode]=\"dataToSave.sixDigitVerificationCode\" (codeEnter)=\"onCodeEnter($event)\"></enter-code>\n        </div>\n    </div>\n</div>\n<div class=\"flex-box flex-just-space-between pl-30 pr-30 pb-15\">\n    <button class=\"btn btn-md btn-default w-min-120\" *ngIf=\"activeStep === 0\" (click)=\"onDismiss()\">Cancel</button>\n    <button class=\"btn btn-md btn-default w-min-120\" *ngIf=\"activeStep !== 0\" (click)=\"previousStep()\" [disabled]=\"buttonDisable\">Previous</button>\n    <button class=\"btn btn-md btn-success w-min-120\" *ngIf=\"activeStep !== steps.length - 1\" (click)=\"nextStep()\">Next</button>\n    <button class=\"btn btn-md btn-success w-min-120\" *ngIf=\"activeStep === steps.length - 1\" (click)=\"saveAndClose()\"\n            [disabled]=\"buttonDisable\" spinning-wheel [is-spinning-wheel-active]=\"buttonDisable\">Finish</button>\n</div>"

/***/ }),

/***/ "./web/modern/components/2fa/modals/two-fa-setup-modal/two-fa-setup-modal.scss":
/***/ (function(module, exports) {

module.exports = ".stepper-header {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: space-evenly;\n  -webkit-justify-content: space-evenly;\n      -ms-flex-pack: space-evenly;\n          justify-content: space-evenly;\n  position: relative; }\n  .stepper-header::before {\n    content: '';\n    position: absolute;\n    width: 58%;\n    height: 1px;\n    background: #c2c2c2;\n    z-index: 1;\n    top: -webkit-calc(35px / 2);\n    top: calc(35px / 2); }\n  .stepper-header .step {\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: column;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-align: center;\n    -webkit-align-items: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-justify-content: space-around;\n        -ms-flex-pack: distribute;\n            justify-content: space-around;\n    font-size: 13px; }\n    .stepper-header .step-number {\n      width: 35px;\n      height: 35px;\n      border-radius: 50%;\n      display: -webkit-box;\n      display: -webkit-flex;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: center;\n      -webkit-justify-content: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n      -webkit-box-align: center;\n      -webkit-align-items: center;\n          -ms-flex-align: center;\n              align-items: center;\n      color: black;\n      background: white;\n      border: 1px solid #22baa1;\n      z-index: 2; }\n      .stepper-header .step-number.active {\n        background: #22baa1;\n        color: white; }\n    .stepper-header .step-label {\n      margin-top: 10px;\n      margin-bottom: 0;\n      font-weight: 600; }\n\n.stepper-body {\n  margin-top: 30px;\n  padding: 30px;\n  background: #f9f9f9;\n  border: 1px solid #e5e5e5; }\n"

/***/ }),

/***/ "./web/modern/components/2fa/modals/two-fa-setup-modal/two-fa-setup-modal.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var ng_bootstrap_1 = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/index.js");
var two_fa_authentication_data_service_1 = __webpack_require__("./shared/services/user/two-fa-authentication.data.service.ts");
var two_fa_models_1 = __webpack_require__("./shared/models/two-fa.models.ts");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var confirm_general_modal_component_1 = __webpack_require__("./web/modern/components/common/confirm-general-modal/confirm-general-modal.component.ts");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var two_fa_authentication_service_1 = __webpack_require__("./shared/services/user/two-fa-authentication.service.ts");
var TwoFaSetupModalComponent = function () {
    function TwoFaSetupModalComponent(activeModal, twoFaAuthenticationDataService, twoFaAuthenticationService, messageService, modalService) {
        _classCallCheck(this, TwoFaSetupModalComponent);

        this.activeModal = activeModal;
        this.twoFaAuthenticationDataService = twoFaAuthenticationDataService;
        this.twoFaAuthenticationService = twoFaAuthenticationService;
        this.messageService = messageService;
        this.modalService = modalService;
        this.steps = two_fa_models_1.Steps;
        this.questions = JSON.parse(JSON.stringify(two_fa_models_1.SecretQuestions));
        this.activeStep = 0;
        this.dataToSave = {
            sixDigitVerificationCode: '',
            secretQuestions: [{ question: null, answer: '' }, { question: null, answer: '' }, { question: null, answer: '' }],
            enforce2FA: false
        };
        this.unsubscribe = new Subject_1.Subject();
    }

    _createClass(TwoFaSetupModalComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.parseQRImage(this.userTwoFASettings.configure2faMetadata.actions.DOWNLOAD_QR_IMAGE.url);
            if (this.enforce) {
                this.dataToSave.enforce2FA = !!this.enforce;
            }
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.questions = [];
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "saveAndClose",
        value: function saveAndClose() {
            var _this = this;

            if (this.twoFaAuthenticationService.isTwoFaSetupValid(this.dataToSave, this.setStep.bind(this))) {
                this.buttonDisable = true;
                var _userTwoFASettings$ac = this.userTwoFASettings.actions.TURN_ON_2FA,
                    url = _userTwoFASettings$ac.url,
                    method = _userTwoFASettings$ac.method;

                this.twoFaAuthenticationDataService.setup2FaAuthentication(url, method, this.dataToSave).pipe(operators_1.takeUntil(this.unsubscribe), operators_1.finalize(function () {
                    return _this.buttonDisable = false;
                })).subscribe(function () {
                    _this.twoFaAuthenticationDataService.setTwoFaModalControlState({
                        state: true,
                        action: 'SUCCESS_SETUP',
                        payload: { enforce: _this.enforce }
                    });
                    _this.messageService.showToaster('s_0', 'twoFa');
                    _this.activeModal.close(_this.primaryAction);
                    _this.twoFaAuthenticationDataService.setTwoFaModalControlState(null);
                }, function (_ref) {
                    var error = _ref.error;
                    var errorMessage = error.errorMessage,
                        errorTitle = error.errorTitle;

                    _this.messageService.showErrorFromBackend(errorTitle, errorMessage);
                });
            }
        }
    }, {
        key: "onCodeEnter",
        value: function onCodeEnter(code) {
            this.dataToSave.sixDigitVerificationCode = code;
        }
    }, {
        key: "nextStep",
        value: function nextStep() {
            this.activeStep++;
        }
    }, {
        key: "previousStep",
        value: function previousStep() {
            this.activeStep--;
        }
    }, {
        key: "setStep",
        value: function setStep(step) {
            this.activeStep = step;
        }
    }, {
        key: "onDismiss",
        value: function onDismiss() {
            if (!this.buttonDisable) {
                this.confirmModalClose();
            }
        }
    }, {
        key: "parseQRImage",
        value: function parseQRImage(url) {
            var _this2 = this;

            this.twoFaAuthenticationDataService.getQRUrl(url).subscribe(function (data) {
                var reader = new FileReader();
                reader.readAsDataURL(data.body);
                reader.onloadend = function () {
                    _this2.QRImage = reader.result;
                };
            });
        }
    }, {
        key: "confirmModalClose",
        value: function confirmModalClose() {
            var _this3 = this;

            var confirmModal = this.modalService.openModal(confirm_general_modal_component_1.ConfirmGeneralModalComponent, {
                windowClass: 'ng-bootstrap-modal modal-visible modal-narrow'
            });
            confirmModal.componentInstance.text = 'Two-factor authentication setup is not yet complete. Are you sure?';
            confirmModal.componentInstance.buttons = [{
                text: 'Yes, cancel setup',
                color: 'danger',
                size: 'lg',
                action: 'CANCEL_2FA_SETUP'
            }, {
                text: 'No, go back',
                color: 'success',
                size: 'lg',
                action: 'PROCEED_2FA_SETUP'
            }];
            confirmModal.result.then(function (action) {
                if (action === 'CANCEL_2FA_SETUP') {
                    _this3.activeModal.close('DISMISS_SETUP');
                    _this3.twoFaAuthenticationDataService.setTwoFaModalControlState({
                        state: true,
                        action: 'DISMISS_SETUP',
                        payload: { enforce: _this3.enforce }
                    });
                }
            });
        }
    }]);

    return TwoFaSetupModalComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], TwoFaSetupModalComponent.prototype, "userTwoFASettings", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], TwoFaSetupModalComponent.prototype, "primaryAction", void 0);
__decorate([core_1.Input(), __metadata("design:type", Boolean)], TwoFaSetupModalComponent.prototype, "enforce", void 0);
TwoFaSetupModalComponent = __decorate([core_1.Component({
    selector: 'two-fa-setup',
    template: __webpack_require__("./web/modern/components/2fa/modals/two-fa-setup-modal/two-fa-setup-modal.html"),
    styles: [__webpack_require__("./web/modern/components/2fa/modals/two-fa-setup-modal/two-fa-setup-modal.scss")]
}), __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal, two_fa_authentication_data_service_1.TwoFaAuthenticationDataService, two_fa_authentication_service_1.TwoFaAuthenticationService, message_service_1.MessageService, snModal_service_1.SNModalService])], TwoFaSetupModalComponent);
exports.TwoFaSetupModalComponent = TwoFaSetupModalComponent;

/***/ }),

/***/ "./web/modern/components/2fa/two-fa-control/two-fa-control.component.html":
/***/ (function(module, exports) {

module.exports = ""

/***/ }),

/***/ "./web/modern/components/2fa/two-fa-control/two-fa-control.component.scss":
/***/ (function(module, exports) {

module.exports = ""

/***/ }),

/***/ "./web/modern/components/2fa/two-fa-control/two-fa-control.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var account_service_1 = __webpack_require__("./web/modern/services/user/account.service.ts");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var two_fa_setup_modal_1 = __webpack_require__("./web/modern/components/2fa/modals/two-fa-setup-modal/two-fa-setup-modal.ts");
var two_fa_authentication_data_service_1 = __webpack_require__("./shared/services/user/two-fa-authentication.data.service.ts");
var two_fa_login_modal_1 = __webpack_require__("./web/modern/components/2fa/modals/two-fa-login-modal/two-fa-login-modal.ts");
var two_fa_reset_modal_1 = __webpack_require__("./web/modern/components/2fa/modals/two-fa-reset-modal/two-fa-reset-modal.ts");
var subscription_service_1 = __webpack_require__("./shared/services/subscription/subscription.service.ts");
var brands_data_service_1 = __webpack_require__("./shared/services/brands/brands.data.service.ts");
var TwoFaControlComponent = function () {
    function TwoFaControlComponent(accountService, modalService, twoFactorAuthenticationService, subscriptionDataService, brandsDataService) {
        _classCallCheck(this, TwoFaControlComponent);

        this.accountService = accountService;
        this.modalService = modalService;
        this.twoFactorAuthenticationService = twoFactorAuthenticationService;
        this.subscriptionDataService = subscriptionDataService;
        this.brandsDataService = brandsDataService;
        this.unsubscribe = new Subject_1.Subject();
    }

    _createClass(TwoFaControlComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.getUserTwoFASettings();
            this.listenToTwoFaModalControlTrigger();
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "getUserTwoFASettings",
        value: function getUserTwoFASettings() {
            var _this = this;

            this.accountService.userDataObservable.pipe(operators_1.takeUntil(this.unsubscribe), operators_1.filter(function (user) {
                return user !== null && typeof user !== 'undefined';
            }), operators_1.map(function (user) {
                return user.twoFactorAuthorization;
            })).subscribe(function (settings) {
                _this.twoFASettings = JSON.parse(JSON.stringify(settings));
            });
        }
    }, {
        key: "listenToTwoFaModalControlTrigger",
        value: function listenToTwoFaModalControlTrigger() {
            var _this2 = this;

            this.twoFactorAuthenticationService.twoFaModalControlState.pipe(operators_1.takeUntil(this.unsubscribe), operators_1.filter(function (data) {
                return data && data.state;
            })).subscribe(function (data) {
                switch (data.action) {
                    case 'SETUP':
                        _this2.handleSetupModal(data.payload);
                        break;
                    case 'LOGIN':
                        _this2.handleLoginModal(data.payload);
                        break;
                    case 'RESET':
                        _this2.handleResetModal(data.payload);
                        break;
                    default:
                        break;
                }
            });
        }
    }, {
        key: "handleSetupModal",
        value: function handleSetupModal(payload) {
            var _this3 = this;

            this.twoFaSetupModalRef = this.openCorrectModal(two_fa_setup_modal_1.TwoFaSetupModalComponent, {
                windowClass: 'ng-bootstrap-modal modal-visible modal-lowered-index',
                backdropClass: 'ng-bootstrap-backdrop modal-lowered-index'
            });
            if (payload && payload.user2faState) {
                this.twoFaSetupModalRef.componentInstance.userTwoFASettings = payload.user2faState;
                this.twoFaSetupModalRef.componentInstance.primaryAction = 'SETUP_AND_LOGIN';
            } else {
                this.twoFaSetupModalRef.componentInstance.userTwoFASettings = this.twoFASettings.user2faState;
                this.twoFaSetupModalRef.componentInstance.primaryAction = 'SETUP_ONLY';
            }
            if (payload && payload.enforce) {
                this.twoFaSetupModalRef.componentInstance.enforce = payload.enforce;
            }
            this.twoFaSetupModalRef.result.then(function (state) {
                if (state === 'SETUP_AND_LOGIN' && payload && payload.loginActions) {
                    _this3.logUserIn();
                }
                if (state === 'DISMISS_SETUP' && payload && payload.loginActions) {
                    _this3.accountService.logoutWeb();
                }
            });
        }
    }, {
        key: "handleLoginModal",
        value: function handleLoginModal(payload) {
            var _this4 = this;

            this.twoFaLoginModalRef = this.openCorrectModal(two_fa_login_modal_1.TwoFaLoginModalComponent, {
                windowClass: 'ng-bootstrap-modal modal-visible modal-narrow'
            });
            this.twoFaLoginModalRef.componentInstance.userPayload = payload.userPayload;
            this.twoFaLoginModalRef.result.then(function (state) {
                if (state === 'LAUNCH_RESET') {
                    _this4.twoFactorAuthenticationService.setTwoFaModalControlState({
                        state: true,
                        action: 'RESET',
                        payload: payload
                    });
                }
                if (state === 'SUCCESS_LOGIN') {
                    _this4.logUserIn();
                }
            });
        }
    }, {
        key: "handleResetModal",
        value: function handleResetModal(payload) {
            var _this5 = this;

            this.twoFaResetModalRef = this.openCorrectModal(two_fa_reset_modal_1.TwoFaResetModalComponent, {
                windowClass: 'ng-bootstrap-modal modal-visible modal-narrow'
            });
            this.twoFaResetModalRef.componentInstance.recoverUser2FA = payload.recoverUser2FA;
            this.twoFaResetModalRef.componentInstance.userPayload = payload.userPayload;
            this.twoFaResetModalRef.result.then(function (state) {
                if (state === 'LAUNCH_LOGIN') {
                    _this5.twoFactorAuthenticationService.setTwoFaModalControlState({
                        state: true,
                        action: 'LOGIN',
                        payload: payload
                    });
                }
                if (state === 'SUCCESS_LOGIN') {
                    _this5.logUserIn();
                }
            });
        }
    }, {
        key: "openCorrectModal",
        value: function openCorrectModal(modalComponent, options) {
            return this.modalService.openModal(modalComponent, options || null);
        }
    }, {
        key: "logUserIn",
        value: function logUserIn() {
            var _this6 = this;

            this.subscriptionDataService.fetchSubscriptionStatus().subscribe(function (subscription) {
                if (subscription.currentPlan) {
                    _this6.brandsDataService.getBrandsData();
                    _this6.accountService.getUserWeb().subscribe(function () {
                        _this6.subscriptionDataService.setSubscriptionData(subscription);
                        if (subscription.loginActions) {
                            _this6.subscriptionDataService.performAfterLoginActions(subscription.loginActions);
                        }
                        _this6.accountService.emitUserLoginAction(true);
                    });
                } else {
                    _this6.subscriptionDataService.setChoosePlanOpenModalStatus({
                        state: true,
                        payload: null
                    });
                }
            });
        }
    }]);

    return TwoFaControlComponent;
}();
TwoFaControlComponent = __decorate([core_1.Component({
    selector: 'two-fa-control',
    template: __webpack_require__("./web/modern/components/2fa/two-fa-control/two-fa-control.component.html"),
    styles: [__webpack_require__("./web/modern/components/2fa/two-fa-control/two-fa-control.component.scss")]
}), __metadata("design:paramtypes", [account_service_1.AccountServiceWebProvider, snModal_service_1.SNModalService, two_fa_authentication_data_service_1.TwoFaAuthenticationDataService, subscription_service_1.NewSubscriptionServiceDataProvider, brands_data_service_1.BrandsDataServiceProvider])], TwoFaControlComponent);
exports.TwoFaControlComponent = TwoFaControlComponent;

/***/ }),

/***/ "./web/modern/components/admin/report/generate-modal/generate-report.modal.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n    <button class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" (click)=\"onDismiss()\">&times;</button>\n    <h3 class=\"modal-title f-w-n\">{{ reportOverviewItem.title }}</h3>\n</div>\n<div class=\"modal-body\">\n    <h4 class=\"mt-0 mb-25 ng-binding\">Please fill the following fields</h4>\n    <form (ngSubmit)=\"saveCompanyInfo()\" *ngIf=\"generateReportForm\" [formGroup]=\"generateReportForm\" class=\"mt-30\" role=\"form\">\n        <div *ngFor=\"let input of reportsInputFields\">\n            <div class=\"mb-20\">\n                <label [attr.for]=\"input.formControlName\" class=\"f-w-n\">{{ input.displayName }}</label>\n                <input [attr.type]=\"input.type\"  *ngIf=\"input.type === 'text'\"\n                       [formControlName]=\"input.formControlName\"\n                       [id]=\"input.formControlName\"\n                       [maxLength]=\"150\"\n                       [placeholder]=\"input.placeholder\"\n                       class=\"form-control flex-row\">\n\n                <input [attr.type]=\"input.type\"  *ngIf=\"input.type === 'date'\"\n                       [formControlName]=\"input.formControlName\"\n                       [id]=\"input.formControlName\"\n                       [placeholder]=\"input.placeholder\"\n                       class=\"form-control flex-row\">\n                <h6>{{ input.description }}</h6>\n            </div>\n        </div>\n\n        <div class=\"mt-30\">\n            <button [disabled]=\"btnDisable\" [is-spinning-wheel-active]=\"btnDisable\" class=\"btn btn-success btn-lg\" spinning-wheel type=\"submit\">Continue</button>\n        </div>\n    </form>\n</div>"

/***/ }),

/***/ "./web/modern/components/admin/report/generate-modal/generate-report.modal.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var ng_bootstrap_1 = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/index.js");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var rxjs_1 = __webpack_require__("./node_modules/rxjs/Rx.js");
var forms_1 = __webpack_require__("./node_modules/@angular/forms/esm5/forms.js");
var reports_overview_data_service_1 = __webpack_require__("./shared/services/admin/reports/reports-overview.data.service.ts");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var GenerateReportModalComponent = function () {
    function GenerateReportModalComponent(reportsOverviewService, messageService, activeModal, modalService, fb) {
        _classCallCheck(this, GenerateReportModalComponent);

        this.reportsOverviewService = reportsOverviewService;
        this.messageService = messageService;
        this.activeModal = activeModal;
        this.modalService = modalService;
        this.fb = fb;
        this.reportsInputFields = [];
        this.unsubscribe = new rxjs_1.Subject();
    }

    _createClass(GenerateReportModalComponent, [{
        key: "onSubmit",
        value: function onSubmit() {}
    }, {
        key: "ngOnInit",
        value: function ngOnInit() {
            this.generateReportForm = this.fb.group({});
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = this.reportOverviewItem.reportParams[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var reportParam = _step.value;

                    this.inputItem = {
                        displayName: reportParam.displayName,
                        description: reportParam.description,
                        formControlName: reportParam.name,
                        type: reportParam.widgetType,
                        placeholder: '',
                        validators: []
                    };
                    this.reportsInputFields.push(this.inputItem);
                    var control = this.fb.control('', null);
                    this.generateReportForm.addControl(reportParam.name, control);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "onDismiss",
        value: function onDismiss() {
            this.activeModal.close();
        }
    }, {
        key: "saveCompanyInfo",
        value: function saveCompanyInfo() {
            if (this.generateReportForm.valid) {
                this.modalService.setModalData(this.generateReportForm.value);
            }
        }
    }]);

    return GenerateReportModalComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], GenerateReportModalComponent.prototype, "reportOverviewItem", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], GenerateReportModalComponent.prototype, "action", void 0);
GenerateReportModalComponent = __decorate([core_1.Component({
    selector: 'generate-modal',
    template: __webpack_require__("./web/modern/components/admin/report/generate-modal/generate-report.modal.html"),
    changeDetection: core_1.ChangeDetectionStrategy.OnPush
}), __metadata("design:paramtypes", [reports_overview_data_service_1.ReportsOverviewDataProvider, message_service_1.MessageService, ng_bootstrap_1.NgbActiveModal, snModal_service_1.SNModalService, forms_1.FormBuilder])], GenerateReportModalComponent);
exports.GenerateReportModalComponent = GenerateReportModalComponent;

/***/ }),

/***/ "./web/modern/components/admin/report/overview-item/report-overview-item.component.html":
/***/ (function(module, exports) {

module.exports = "\n<div class=\"report-overview-item\">\n    <div class=\"report-overview-item-column-title\">\n        <h3 class=\"m-0 f-s-18 flex-box flex-align-center\">\n\n            {{ reportOverviewItem.title }}\n        </h3>\n    </div>\n    <div class=\"report-overview-item-column-description\">\n        <p class=\"mb-0 flex-70 pl-15 report-overview-item-description\">\n            {{ reportOverviewItem.description }}\n        </p>\n    </div>\n    <div class=\"report-overview-item-column-actions\">\n        <button *ngIf=\"reportOverviewItem.actions.DOWNLOAD\" class=\"btn btn-rounded btn-default report-overview-item-actions\" (click)=\"openModal(reportOverviewItem.actions.DOWNLOAD, 'downloadReportFile')\">\n            {{ reportOverviewItem.actions?.DOWNLOAD.actionName }}\n        </button>\n        <button *ngIf=\"reportOverviewItem.actions.DO_UPDATE\" class=\"btn btn-rounded btn-default report-overview-item-actions\" (click)=\"openModal(reportOverviewItem.actions.DO_UPDATE, 'doUpdateData')\">\n            {{ reportOverviewItem.actions?.DO_UPDATE.actionName }}\n        </button>\n    </div>\n</div>\n"

/***/ }),

/***/ "./web/modern/components/admin/report/overview-item/report-overview-item.component.scss":
/***/ (function(module, exports) {

module.exports = ".report-overview-item {\n  padding: 20px;\n  width: 100%;\n  cursor: pointer;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center; }\n  @media (max-width: 1199px) {\n    .report-overview-item {\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n      -webkit-flex-direction: column;\n          -ms-flex-direction: column;\n              flex-direction: column;\n      -webkit-box-align: start;\n      -webkit-align-items: flex-start;\n          -ms-flex-align: start;\n              align-items: flex-start; }\n      .report-overview-item .report-overview-item-description {\n        padding-top: 5px;\n        padding-left: 37px !important; } }\n  .report-overview-item-actions {\n    float: right; }\n  .report-overview-item-column-title {\n    -webkit-box-flex: 25%;\n    -webkit-flex: 25%;\n        -ms-flex: 25%;\n            flex: 25%; }\n    .report-overview-item-column-title h3 {\n      line-height: 1.25; }\n  .report-overview-item-column-description {\n    -webkit-box-flex: 60%;\n    -webkit-flex: 60%;\n        -ms-flex: 60%;\n            flex: 60%; }\n    .report-overview-item-column-description h3 {\n      line-height: 1.25; }\n  .report-overview-item-column-actions {\n    -webkit-box-flex: 15%;\n    -webkit-flex: 15%;\n        -ms-flex: 15%;\n            flex: 15%; }\n    .report-overview-item-column-actions h3 {\n      line-height: 1.25; }\n"

/***/ }),

/***/ "./web/modern/components/admin/report/overview-item/report-overview-item.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var generate_report_modal_1 = __webpack_require__("./web/modern/components/admin/report/generate-modal/generate-report.modal.ts");
var file_download_data_service_1 = __webpack_require__("./shared/services/files/file-download-service/file-download.data.service.ts");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var reports_overview_data_service_1 = __webpack_require__("./shared/services/admin/reports/reports-overview.data.service.ts");
var ReportOverviewItemComponent = function () {
    function ReportOverviewItemComponent(modalService, fileDownloadService, reportsOverviewService, messageService) {
        _classCallCheck(this, ReportOverviewItemComponent);

        this.modalService = modalService;
        this.fileDownloadService = fileDownloadService;
        this.reportsOverviewService = reportsOverviewService;
        this.messageService = messageService;
    }

    _createClass(ReportOverviewItemComponent, [{
        key: "openModal",
        value: function openModal(action, name) {
            var _this = this;

            this.generateReportModalRef = this.modalService.openModal(generate_report_modal_1.GenerateReportModalComponent, {
                windowClass: 'ng-bootstrap-modal__small'
            });
            this.generateReportModalRef.result.then(function () {
                return _this.modalDataSubscription.unsubscribe();
            });
            this.modalDataSubscription = this.modalService.getModalData().subscribe(function (data) {
                return (
                    // call function
                    _this[name](data)
                );
            });
            this.generateReportModalRef.componentInstance.reportOverviewItem = this.reportOverviewItem;
            this.generateReportModalRef.componentInstance.action = action;
        }
        // don't rename. used in html

    }, {
        key: "downloadReportFile",
        value: function downloadReportFile(data) {
            var _this2 = this;

            this.generateReportModalRef.componentInstance.btnDisabled = true;
            this.fileDownloadService.downloadFileDynamic(this.generateReportModalRef.componentInstance.action, {
                params: data
            }).pipe(operators_1.finalize(function () {
                _this2.generateReportModalRef.componentInstance.btnDisabled = false;
            })).subscribe(function () {
                _this2.messageService.showToaster('s_4', 'admin');
                _this2.modalDataSubscription.unsubscribe();
                _this2.generateReportModalRef.close();
            }, function (_ref) {
                var error = _ref.error;
                var errorMessage = error.errorMessage,
                    errorTitle = error.errorTitle;

                _this2.messageService.showErrorFromBackend(errorTitle, errorMessage);
            });
        }
        // don't rename. used in html

    }, {
        key: "doUpdateData",
        value: function doUpdateData(data) {
            var _this3 = this;

            this.generateReportModalRef.componentInstance.btnDisabled = true;
            this.reportsOverviewService.updateData(this.generateReportModalRef.componentInstance.action, {
                params: data
            }).pipe(operators_1.finalize(function () {
                _this3.generateReportModalRef.componentInstance.btnDisabled = false;
            })).subscribe(function (data) {
                _this3.messageService.showToaster('s_5', 'admin');
                _this3.modalDataSubscription.unsubscribe();
                _this3.generateReportModalRef.close();
            });
        }
    }]);

    return ReportOverviewItemComponent;
}();
__decorate([core_1.Input('item'), __metadata("design:type", Object)], ReportOverviewItemComponent.prototype, "reportOverviewItem", void 0);
ReportOverviewItemComponent = __decorate([core_1.Component({
    selector: 'report-overview-item',
    template: __webpack_require__("./web/modern/components/admin/report/overview-item/report-overview-item.component.html"),
    styles: [__webpack_require__("./web/modern/components/admin/report/overview-item/report-overview-item.component.scss")],
    encapsulation: core_1.ViewEncapsulation.None,
    changeDetection: core_1.ChangeDetectionStrategy.OnPush
}), __metadata("design:paramtypes", [snModal_service_1.SNModalService, file_download_data_service_1.FileDownloadDataServiceProvider, reports_overview_data_service_1.ReportsOverviewDataProvider, message_service_1.MessageService])], ReportOverviewItemComponent);
exports.ReportOverviewItemComponent = ReportOverviewItemComponent;

/***/ }),

/***/ "./web/modern/components/admin/report/overview/reports-overview.component.html":
/***/ (function(module, exports) {

module.exports = "<section id=\"main-wrapper\" class=\"new-container bg-white pb-30\" style=\"background-color: #fff\">\n    <div class=\"flex-row row mb-30\">\n        <div class=\"col-xs-12 col-sm-6\">\n            <h2>Reports</h2>\n            <div class=\"bc-wrap bc-no-line\">\n                <div class=\"clearfix hidden visible-xs\"></div>\n                <ol class=\"bc-list\" style=\"margin: 0;\">\n                    <li><a href=\"/\">Super Admin</a></li>\n                    <li class=\"active\">Reports</li>\n                </ol>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"table-responsive\">\n        <div class=\"reports-list\">\n            <div class=\"panel-group\" id=\"accordion\" role=\"tablist\" aria-multiselectable=\"false\">\n                <div class=\"panel-wrapper\" *ngFor=\"let tab of tabs; let i = index\">\n                    <div class=\"panel panel-default\">\n                        <h4 class=\"panel-title\">\n                            <a type=\"button\" (click)=\"saveExpanded($event, i)\" class=\"{{tab.expandedIn ? '' : 'collapsed'}}\" data-target=\"#{{tab.name}}\" [attr.aria-controls]=\"tab.name\" [attr.aria-expanded]=\"tab.expandedIn\">\n                                <div class=\"panel-heading\">\n                                    {{ tab.name.toLowerCase() | titlecase }}\n                                </div>\n                            </a>\n                        </h4>\n                        <div id=\"{{tab.name}}\" [ngClass]=\"tab.expandedIn === true ? 'show-accordion':'hide-accordion'\" [attr.aria-expanded]=\"tab.expandedIn\">\n                            <div class=\"panel-body p-0\">\n                                <ul>\n                                    <li *ngFor=\"let setting of tab.reportsList\">\n                                        <report-overview-item [item]=\"setting\"></report-overview-item>\n                                    </li>\n                                </ul>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "./web/modern/components/admin/report/overview/reports-overview.component.scss":
/***/ (function(module, exports) {

module.exports = ".reports-list {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  width: 100%; }\n  .reports-list ul {\n    margin: 0;\n    list-style: none;\n    padding: 0;\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: column;\n        -ms-flex-direction: column;\n            flex-direction: column; }\n    .reports-list ul li {\n      border-top: 1px solid #d7d7d7; }\n      .reports-list ul li a {\n        color: #45464c !important; }\n        .reports-list ul li a:hover {\n          text-decoration: none !important; }\n\n.panel-group {\n  margin-bottom: 0; }\n  .panel-group .panel-wrapper {\n    border-top: 1px solid #d7d7d7; }\n    .panel-group .panel-wrapper .panel .panel-title > a {\n      -webkit-appearance: none;\n         -moz-appearance: none;\n              appearance: none;\n      cursor: pointer; }\n    .panel-group .panel-wrapper .panel .panel-title > a .panel-heading:before {\n      float: right !important;\n      font-family: FontAwesome;\n      color: #a9a9a9;\n      content: '\\f068';\n      padding-right: 5px; }\n    .panel-group .panel-wrapper .panel .panel-title > a.collapsed .panel-heading:before {\n      float: right !important;\n      color: #a9a9a9;\n      content: '\\f067'; }\n    .panel-group .panel-wrapper .panel .panel-title > a:hover,\n    .panel-group .panel-wrapper .panel .panel-title > a:active,\n    .panel-group .panel-wrapper .panel .panel-title > a:focus {\n      text-decoration: none; }\n    .panel-group .panel-wrapper .panel .show-accordion {\n      overflow-y: hidden;\n      max-height: 1000px;\n      height: auto;\n      -webkit-transition: all 1s ease-in-out;\n      transition: all 1s ease-in-out; }\n    .panel-group .panel-wrapper .panel .hide-accordion {\n      overflow-y: hidden;\n      height: auto;\n      -webkit-transition: all 1s ease-in-out;\n      transition: all 1s ease-in-out;\n      max-height: 0; }\n    .panel-group .panel-wrapper .panel .panel-body {\n      border-top: 0 !important; }\n"

/***/ }),

/***/ "./web/modern/components/admin/report/overview/reports-overview.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var reports_overview_data_service_1 = __webpack_require__("./shared/services/admin/reports/reports-overview.data.service.ts");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var ReportsOverviewComponent = function () {
    function ReportsOverviewComponent(reportsOverviewService) {
        _classCallCheck(this, ReportsOverviewComponent);

        this.reportsOverviewService = reportsOverviewService;
        this.tabs = [];
        this.unsubscribe = new Subject_1.Subject();
    }

    _createClass(ReportsOverviewComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.getOverviewList();
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "getOverviewList",
        value: function getOverviewList() {
            var _this = this;

            this.reportsOverviewService.getSettingsOverviewItems().pipe(operators_1.filter(function (data) {
                return data !== null;
            })).subscribe(function (data) {
                for (var i = 0; i < data.reports.length; i++) {
                    _this.tab = {
                        expandedIn: false,
                        name: data.reports[i].category,
                        reportsList: data.reports[i].items
                    };
                    _this.tabs.push(_this.tab);
                }
            });
        }
    }, {
        key: "saveExpanded",
        value: function saveExpanded(event, index) {
            this.tabs[index].expandedIn = event.currentTarget.ariaExpanded !== 'true';
            if (!event.currentTarget.ariaExpanded) {
                var expanded = event.currentTarget.getAttribute('aria-expanded') === 'true';
                event.currentTarget.setAttribute('aria-expanded', !expanded);
                this.tabs[index].expandedIn = event.currentTarget.getAttribute('aria-expanded') === 'true';
            }
        }
    }]);

    return ReportsOverviewComponent;
}();
ReportsOverviewComponent = __decorate([core_1.Component({
    selector: 'reports-overview',
    template: __webpack_require__("./web/modern/components/admin/report/overview/reports-overview.component.html"),
    styles: [__webpack_require__("./web/modern/components/admin/report/overview/reports-overview.component.scss")],
    encapsulation: core_1.ViewEncapsulation.None
}), __metadata("design:paramtypes", [reports_overview_data_service_1.ReportsOverviewDataProvider])], ReportsOverviewComponent);
exports.ReportsOverviewComponent = ReportsOverviewComponent;

/***/ }),

/***/ "./web/modern/components/admin/subscription-info/subscription-info-btn.html":
/***/ (function(module, exports) {

module.exports = "<button (click)=\"showSubscriptionInfoModal()\"\n        class=\"btn btn-rounded btn-default\">Subscription Info\n</button>\n"

/***/ }),

/***/ "./web/modern/components/admin/subscription-info/subscription-info-btn.scss":
/***/ (function(module, exports) {

module.exports = "button {\n  margin-bottom: 0; }\n"

/***/ }),

/***/ "./web/modern/components/admin/subscription-info/subscription-info-btn.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var admin_users_data_service_1 = __webpack_require__("./web/modern/services/admin/users/admin-users.data.service.ts");
var subscription_info_modal_1 = __webpack_require__("./web/modern/components/admin/subscription-info/subscription-info-modal/subscription-info-modal.ts");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var SubscriptionInfoBtn = function () {
    function SubscriptionInfoBtn(modalService, adminUsersDataService, messageService) {
        _classCallCheck(this, SubscriptionInfoBtn);

        this.modalService = modalService;
        this.adminUsersDataService = adminUsersDataService;
        this.messageService = messageService;
        this.isDisabled = new core_1.EventEmitter();
        this.unsubscribe = new Subject_1.Subject();
    }

    _createClass(SubscriptionInfoBtn, [{
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "showSubscriptionInfoModal",
        value: function showSubscriptionInfoModal() {
            var _this = this;

            this.isDisabled.emit(true);
            this.adminUsersDataService.getSubscriptionInfo(this.user).pipe(operators_1.takeUntil(this.unsubscribe), operators_1.finalize(function () {
                _this.isDisabled.emit(false);
            })).subscribe(function (_ref) {
                var data = _ref.data;

                _this.successGetSubscriptionInfo(data);
            }, function (error) {
                return _this.messageService.handleError(error);
            });
        }
    }, {
        key: "successGetSubscriptionInfo",
        value: function successGetSubscriptionInfo(data) {
            var currentPlan = Object.keys(data.currentPlan.properties);
            var customerInfo = Object.keys(data.customerInfo.properties);
            var newPlan = data.newPlan ? Object.keys(data.newPlan.properties) : [];
            var modalRef = this.modalService.openModal(subscription_info_modal_1.SubscriptionInfoModal, {
                windowClass: 'ng-bootstrap-modal'
            });
            modalRef.componentInstance.subscriptionInfo = data;
            modalRef.componentInstance.currentPlan = currentPlan;
            modalRef.componentInstance.customerInfo = customerInfo;
            modalRef.componentInstance.newPlan = newPlan;
        }
    }]);

    return SubscriptionInfoBtn;
}();
__decorate([core_1.Input('user'), __metadata("design:type", Object)], SubscriptionInfoBtn.prototype, "user", void 0);
__decorate([core_1.Output('isDisabled'), __metadata("design:type", core_1.EventEmitter)], SubscriptionInfoBtn.prototype, "isDisabled", void 0);
SubscriptionInfoBtn = __decorate([core_1.Component({
    selector: 'subscription-info-btn',
    template: __webpack_require__("./web/modern/components/admin/subscription-info/subscription-info-btn.html"),
    styles: [__webpack_require__("./web/modern/components/admin/subscription-info/subscription-info-btn.scss")]
}), __metadata("design:paramtypes", [snModal_service_1.SNModalService, admin_users_data_service_1.AdminUsersDataService, message_service_1.MessageService])], SubscriptionInfoBtn);
exports.SubscriptionInfoBtn = SubscriptionInfoBtn;

/***/ }),

/***/ "./web/modern/components/admin/subscription-info/subscription-info-modal/subscription-info-modal.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n    <button (click)=\"closeModal()\" aria-hidden=\"true\" class=\"close\" data-dismiss=\"modal\">&times;</button>\n    <h3 class=\"modal-title f-w-n\">Subscription Info</h3>\n</div>\n<div class=\"modal-body\">\n    <div class=\"subscription-info\">\n        <div class=\"stripe-customer-info subscription-container\">\n            <div class=\"status-block\">\n                <h3>Stripe Customer Info</h3>\n                <div [ngClass]=\"(subscriptionInfo.subscriptionType === 'EXPIRED') ? 'btn-danger': 'btn-success'\">{{ subscriptionInfo.subscriptionType }}</div>\n            </div>\n            <div class=\"stripe-customer-info-description subscription--plan\">\n                <table class=\"subscription--plan__table\">\n                    <tr *ngFor=\"let item of customerInfo\" class=\"t-row\">\n                        <td class=\"t-cell-title width-30-percent\">{{ item }}</td>\n                        <td class=\"t-cell-info\">{{ subscriptionInfo?.customerInfo?.properties[item]?.description }}\n                            <div *ngIf=\"subscriptionInfo?.customerInfo?.properties[item]?.prompt\" class=\"t-cell-info-label\">\n                                <i aria-hidden=\"true\" class=\"fa fa-info-circle\"></i>\n                                <span class=\"label label-general label-status label-response label-warning--triangle label-hover\">{{ subscriptionInfo.customerInfo.properties[item].prompt }}</span>\n                            </div>\n                        </td>\n                    </tr>\n                </table>\n            </div>\n        </div>\n        <hr class=\"subscription-divider\">\n        <div class=\"subscription-plan-info subscription-container\">\n            <h3>Subscription Plan Info</h3>\n            <div class=\"subscription-plan-info-description\">\n                <table class=\"subscription--plan__table\">\n                    <tr *ngFor=\"let item of currentPlan\" class=\"t-row\">\n                        <td class=\"t-cell-title\">{{ item }}</td>\n                        <td class=\"t-cell-info\">{{ subscriptionInfo.currentPlan?.properties[item]?.description }}\n                            <div *ngIf=\"subscriptionInfo.currentPlan?.properties[item]?.prompt\" class=\"t-cell-info-label\">\n                                <i aria-hidden=\"true\" class=\"fa fa-info-circle\"></i>\n                                <span class=\"label label-general label-status label-response label-warning--triangle label-hover\">{{ subscriptionInfo.currentPlan.properties[item].prompt }}</span>\n                            </div>\n                        </td>\n                    </tr>\n\n                    <ng-container *ngIf=\"newPlan && newPlan.length\">\n\n                        <tr class=\"t-row-empty\"><td colspan=\"2\"></td></tr>\n                        <tr class=\"t-row-line\"><td colspan=\"2\"></tr>\n                        <tr class=\"t-row-empty\"><td colspan=\"2\"></td></tr>\n\n                        <tr *ngFor=\"let item of newPlan\" class=\"t-row\">\n                            <td class=\"t-cell-title\">{{ item }}</td>\n                            <td class=\"t-cell-info\">{{ subscriptionInfo?.newPlan?.properties[item]?.description }}\n                                <div *ngIf=\"subscriptionInfo?.newPlan?.properties[item]?.prompt\" class=\"t-cell-info-label\">\n                                    <i aria-hidden=\"true\" class=\"fa fa-info-circle\">  <span class=\"label label-general label-status label-response label-warning--triangle label-hover\">{{ subscriptionInfo.newPlan.properties[item].prompt }}</span></i>\n                                </div>\n                            </td>\n                        </tr>\n                    </ng-container>\n                </table>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "./web/modern/components/admin/subscription-info/subscription-info-modal/subscription-info-modal.scss":
/***/ (function(module, exports) {

module.exports = ".subscription-info {\n  border: 1px solid #e5e5e5;\n  padding: 15px; }\n  .subscription-info .subscription-divider {\n    border-color: #e5e5e5;\n    margin-left: -15px;\n    margin-right: -15px; }\n  .subscription-info .stripe-customer-info .status-block {\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: row;\n        -ms-flex-direction: row;\n            flex-direction: row;\n    -webkit-box-pack: justify;\n    -webkit-justify-content: space-between;\n        -ms-flex-pack: justify;\n            justify-content: space-between; }\n    .subscription-info .stripe-customer-info .status-block h3 {\n      margin-top: 5px; }\n    .subscription-info .stripe-customer-info .status-block div {\n      padding: 5px; }\n\n.width-30-percent {\n  width: 30%; }\n"

/***/ }),

/***/ "./web/modern/components/admin/subscription-info/subscription-info-modal/subscription-info-modal.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var ng_bootstrap_1 = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/index.js");
var SubscriptionInfoModal = function () {
    function SubscriptionInfoModal(activeModal) {
        _classCallCheck(this, SubscriptionInfoModal);

        this.activeModal = activeModal;
    }

    _createClass(SubscriptionInfoModal, [{
        key: "closeModal",
        value: function closeModal() {
            this.activeModal.close();
        }
    }]);

    return SubscriptionInfoModal;
}();
__decorate([core_1.Input('subscriptionInfo'), __metadata("design:type", Object)], SubscriptionInfoModal.prototype, "subscriptionInfo", void 0);
__decorate([core_1.Input('currentPlan'), __metadata("design:type", Array)], SubscriptionInfoModal.prototype, "currentPlan", void 0);
__decorate([core_1.Input('customerInfo'), __metadata("design:type", Array)], SubscriptionInfoModal.prototype, "customerInfo", void 0);
__decorate([core_1.Input('newPlan'), __metadata("design:type", Array)], SubscriptionInfoModal.prototype, "newPlan", void 0);
SubscriptionInfoModal = __decorate([core_1.Component({
    selector: 'subscription-info-modal',
    template: __webpack_require__("./web/modern/components/admin/subscription-info/subscription-info-modal/subscription-info-modal.html"),
    styles: [__webpack_require__("./web/modern/components/admin/subscription-info/subscription-info-modal/subscription-info-modal.scss")]
}), __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal])], SubscriptionInfoModal);
exports.SubscriptionInfoModal = SubscriptionInfoModal;

/***/ }),

/***/ "./web/modern/components/brands/modals/brand-create-modal/brand-create-modal.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n    <button (click)=\"closeModal()\" aria-hidden=\"true\" class=\"close\" data-dismiss=\"modal\" [disabled]=\"btnDisable\">&times;</button>\n    <h3 class=\"modal-title f-w-n\">New Company</h3>\n</div>\n\n<form (ngSubmit)=\"saveData()\" [formGroup]=\"brandForm\">\n    <div class=\"modal-body\">\n\n        <div class=\"mb-20\">\n            <h4 class=\"f-w-n\">Company Name</h4>\n            <input [maxLength]=\"150\" class=\"form-control flex-row\"\n                   formControlName=\"name\"\n                   required\n                   type=\"text\">\n        </div>\n        <div class=\"mb-20\">\n            <h4 class=\"f-w-n\">Company Email</h4>\n            <input class=\"form-control flex-row\" formControlName=\"email\"\n                   [maxLength]=\"150\"\n                   required\n                   type=\"email\">\n        </div>\n\n        <div>\n            <article class=\"flex-row bg-concrete-light import-data-section\">\n                <div class=\"checkbox-squared\">\n                    <input [(ngModel)]=\"importData\" [ngModelOptions]=\"{standalone: true}\" id=\"data-import\" type=\"checkbox\"/>\n                    <label for=\"data-import\"></label>\n                </div>\n                <div class=\"description\">\n                    <h4 class=\"mt-2\">Import settings templates from an existing company</h4>\n                    <p class=\"mb-0\">This action cannot be done later!</p>\n                </div>\n            </article>\n        </div>\n\n    </div>\n\n    <div class=\"modal-footer footer-align-left\">\n        <button class=\"btn btn-lg btn-success m-0 mr-10\" type=\"submit\" [disabled]=\"btnDisable\" spinning-wheel [is-spinning-wheel-active]=\"btnDisable\">Add Company</button>\n    </div>\n</form>\n"

/***/ }),

/***/ "./web/modern/components/brands/modals/brand-create-modal/brand-create-modal.scss":
/***/ (function(module, exports) {

module.exports = ".import-data-section {\n  border: 1px solid #d7d7d7;\n  padding: 15px;\n  background: #fdeae4;\n  color: #790000; }\n"

/***/ }),

/***/ "./web/modern/components/brands/modals/brand-create-modal/brand-create-modal.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var rxjs_1 = __webpack_require__("./node_modules/rxjs/Rx.js");
var ng_bootstrap_1 = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/index.js");
var forms_1 = __webpack_require__("./node_modules/@angular/forms/esm5/forms.js");
var brands_data_service_1 = __webpack_require__("./shared/services/brands/brands.data.service.ts");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var brands_service_1 = __webpack_require__("./shared/services/brands/brands.service.ts");
var validation_service_1 = __webpack_require__("./shared/services/helpers/validation.service.ts");
var account_service_1 = __webpack_require__("./web/modern/services/user/account.service.ts");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var BrandCreateModalComponent = function () {
    function BrandCreateModalComponent(activeModal, fb, brandsDataService, brandsService, accountService, messageService) {
        _classCallCheck(this, BrandCreateModalComponent);

        this.activeModal = activeModal;
        this.fb = fb;
        this.brandsDataService = brandsDataService;
        this.brandsService = brandsService;
        this.accountService = accountService;
        this.messageService = messageService;
        this.brandForm = this.fb.group({
            name: ['', [forms_1.Validators.required, validation_service_1.ValidationProvider.noWhitespaceValidator]],
            email: ['', [forms_1.Validators.required, validation_service_1.ValidationProvider.emailValidator, validation_service_1.ValidationProvider.noWhitespaceValidator]]
        });
        this.importData = true;
        this.unsubscribe = new rxjs_1.Subject();
    }

    _createClass(BrandCreateModalComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {}
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "closeModal",
        value: function closeModal() {
            this.activeModal.dismiss();
        }
    }, {
        key: "saveData",
        value: function saveData() {
            if (this.brandForm.valid) {
                this.createBrand();
            } else {
                this.validateForErrors();
            }
        }
    }, {
        key: "createBrand",
        value: function createBrand() {
            var _this = this;

            this.btnDisable = true;
            if (this.importData) {
                this.activeModal.close({ action: 'IMPORT', props: this.brandForm.value });
            } else {
                this.accountService.saveBrand(this.brandForm.value).pipe(operators_1.takeUntil(this.unsubscribe), operators_1.finalize(function () {
                    return _this.btnDisable = false;
                })).subscribe(function (res) {
                    _this.brandsDataService.updateBrands().pipe(operators_1.takeUntil(_this.unsubscribe), operators_1.finalize(function () {
                        return _this.btnDisable = false;
                    })).subscribe(function () {
                        _this.activeModal.close({ action: 'REDIRECT', props: res });
                    });
                });
            }
        }
    }, {
        key: "validateForErrors",
        value: function validateForErrors() {
            this.brandsService.validateBrandFields(this.brandForm.controls);
        }
    }]);

    return BrandCreateModalComponent;
}();
BrandCreateModalComponent = __decorate([core_1.Component({
    selector: 'brand-create-modal',
    template: __webpack_require__("./web/modern/components/brands/modals/brand-create-modal/brand-create-modal.html"),
    styles: [__webpack_require__("./web/modern/components/brands/modals/brand-create-modal/brand-create-modal.scss")]
}), __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal, forms_1.FormBuilder, brands_data_service_1.BrandsDataServiceProvider, brands_service_1.BrandsServiceProvider, account_service_1.AccountServiceWebProvider, message_service_1.MessageService])], BrandCreateModalComponent);
exports.BrandCreateModalComponent = BrandCreateModalComponent;

/***/ }),

/***/ "./web/modern/components/brands/modals/gdpr-disable-modal/gdpr-disable-modal.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-body flex-column flex-align-center\">\n    <h3 class=\"text-align-center modal-text\">\n        Disabling GDPR features will remove the ability to add the GDPR Consent Checkbox to new Contact Forms, Contract or Questionnaire Templates.\n        <br><br>Previously added GDPR Consent Checkboxes will remain. Are you sure?\n    </h3>\n    <div class=\"mt-15\">\n        <button class=\"btn btn-lg btn-danger mr-20\" (click)=\"closeModal(true)\">Disable GDPR features</button>\n        <button class=\"btn btn-lg btn-success\" (click)=\"closeModal(false)\">Keep GDPR features</button>\n    </div>\n</div>\n\n\n\n\n\n\n"

/***/ }),

/***/ "./web/modern/components/brands/modals/gdpr-disable-modal/gdpr-disable-modal.scss":
/***/ (function(module, exports) {

module.exports = ".modal-text {\n  font-size: 1.4em;\n  line-height: 1.3em; }\n"

/***/ }),

/***/ "./web/modern/components/brands/modals/gdpr-disable-modal/gdpr-disable-modal.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var ng_bootstrap_1 = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/index.js");
var GdprDisableModalComponent = function () {
    function GdprDisableModalComponent(activeModal) {
        _classCallCheck(this, GdprDisableModalComponent);

        this.activeModal = activeModal;
    }

    _createClass(GdprDisableModalComponent, [{
        key: "closeModal",
        value: function closeModal(state) {
            this.activeModal.close(state);
        }
    }]);

    return GdprDisableModalComponent;
}();
GdprDisableModalComponent = __decorate([core_1.Component({
    selector: 'gdpr-disable-modal',
    template: __webpack_require__("./web/modern/components/brands/modals/gdpr-disable-modal/gdpr-disable-modal.html"),
    styles: [__webpack_require__("./web/modern/components/brands/modals/gdpr-disable-modal/gdpr-disable-modal.scss")]
}), __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal])], GdprDisableModalComponent);
exports.GdprDisableModalComponent = GdprDisableModalComponent;

/***/ }),

/***/ "./web/modern/components/brands/modals/import-data-modal/import-data-modal.html":
/***/ (function(module, exports) {

module.exports = "<div *ngIf=\"brands\" class=\"modal-header\">\n    <button (click)=\"closeModal()\" aria-hidden=\"true\" class=\"close\" data-dismiss=\"modal\" [disabled]=\"btnDisable\">&times;</button>\n    <h3 class=\"modal-title f-w-n\">Import Data</h3>\n</div>\n\n<form *ngIf=\"brands && importDataForm\" [formGroup]=\"importDataForm\">\n    <div class=\"modal-body\">\n        <div>\n                <h4>Import data from</h4>\n                <div class=\"select-style\">\n                    <select (change)=\"chooseBrandToImport($event)\" class=\"form-control\">\n                        <option *ngFor=\"let brand of brands.brandsDataToImport; let i = index\" [value]=\"brand.companyId\" >{{ brand.name }}</option>\n                    </select>\n                </div>\n\n            <div class=\"mt-20\">\n                <h4>Select the data you wish to import</h4>\n\n                    <div *ngFor=\"let option of checkboxes\">\n                        <div class=\"checkbox-squared mt-15\">\n                            <input (click)=\"controlGroup(option, $event)\" [(ngModel)]=\"option.isChecked\" [id]=\"option.controlName\" [ngModelOptions]=\"{standalone: true}\" type=\"checkbox\"/>\n                            <label [attr.for]=\"option.controlName\"></label>\n                        </div>\n                        <span>{{ option.title }}</span>\n\n                        <ng-container  *ngIf=\"option.children.length\">\n                            <div *ngFor=\"let control of importDataForm.controls[option.controlName].controls; let i = index\" class=\"checkbox-inner mt-15 ml-15\">\n                                <div  class=\"checkbox-squared\">\n                                    <input (click)=\"controlParent(importDataForm.controls[option.controlName], option)\"\n                                           [formControl]=\"control\"\n                                           [id]=\"'option-' + i\"\n                                           type=\"checkbox\"/>\n                                    <label [attr.for]=\"'option-' + i\"></label>\n                                </div>\n                                <span class=\"w-100\">{{ option.children[i].title }}</span>\n                            </div>\n                        </ng-container>\n                    </div>\n            </div>\n\n        </div>\n    </div>\n\n    <div class=\"modal-footer footer-align-left\">\n        <button class=\"btn btn-lg btn-success m-0 mr-10\" type=\"submit\" [disabled]=\"btnDisable\" spinning-wheel [is-spinning-wheel-active]=\"btnDisable\" (click)=\"performImport()\">Import</button>\n    </div>\n</form>\n"

/***/ }),

/***/ "./web/modern/components/brands/modals/import-data-modal/import-data-modal.scss":
/***/ (function(module, exports) {

module.exports = ""

/***/ }),

/***/ "./web/modern/components/brands/modals/import-data-modal/import-data-modal.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var rxjs_1 = __webpack_require__("./node_modules/rxjs/Rx.js");
var ng_bootstrap_1 = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/index.js");
var forms_1 = __webpack_require__("./node_modules/@angular/forms/esm5/forms.js");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var reject_import_modal_1 = __webpack_require__("./web/modern/components/brands/modals/reject-import-modal/reject-import-modal.ts");
var brands_data_service_1 = __webpack_require__("./shared/services/brands/brands.data.service.ts");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var account_service_1 = __webpack_require__("./web/modern/services/user/account.service.ts");
var brands_service_1 = __webpack_require__("./shared/services/brands/brands.service.ts");
var ImportDataModalComponent = function () {
    function ImportDataModalComponent(activeModal, fb, snModalService, accountService, brandsDataService, brandsService) {
        _classCallCheck(this, ImportDataModalComponent);

        this.activeModal = activeModal;
        this.fb = fb;
        this.snModalService = snModalService;
        this.accountService = accountService;
        this.brandsDataService = brandsDataService;
        this.brandsService = brandsService;
        this.checkboxes = [];
        this.unsubscribe = new rxjs_1.Subject();
    }

    _createClass(ImportDataModalComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.loadImportData();
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "closeModal",
        value: function closeModal() {
            var _this = this;

            var rejectImportModal = this.snModalService.openModal(reject_import_modal_1.RejectImportModalComponent, {
                windowClass: 'ng-bootstrap-modal modal-visible modal-short'
            });
            rejectImportModal.componentInstance.newBrandData = this.newBrandData;
            rejectImportModal.result.then(function (res) {
                if (res) {
                    if (res.action === 'CANCEL') {
                        _this.activeModal.close();
                    } else {
                        _this.activeModal.close(res);
                    }
                }
            }).catch();
        }
    }, {
        key: "chooseBrandToImport",
        value: function chooseBrandToImport(ev) {
            this.initModalPage(this.brands, ev.target.options.selectedIndex);
        }
    }, {
        key: "performImport",
        value: function performImport() {
            var _this2 = this;

            this.btnDisable = true;
            this.prepareBrandDataToSave();
            this.accountService.saveBrand(this.newBrandData).pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (res) {
                _this2.brandsDataService.updateBrands().pipe(operators_1.takeUntil(_this2.unsubscribe), operators_1.finalize(function () {
                    return _this2.btnDisable = false;
                })).subscribe(function () {
                    if (res) {
                        _this2.activeModal.close(res);
                    }
                });
            });
        }
    }, {
        key: "controlGroup",
        value: function controlGroup(option, ev) {
            this.selectDeselectGroup(option.controlName, ev.target.checked);
        }
    }, {
        key: "controlParent",
        value: function controlParent(controls, group) {
            // TODO Investigate
            setTimeout(function () {
                group.isChecked = controls.value.indexOf(false) === -1;
            }, 0);
        }
    }, {
        key: "selectDeselectGroup",
        value: function selectDeselectGroup(groupName, state) {
            this.importDataForm.controls[groupName].controls.forEach(function (control) {
                control.setValue(state);
            });
        }
    }, {
        key: "createFormGroup",
        value: function createFormGroup(checkboxes) {
            var _this3 = this;

            var fbData = {};
            checkboxes.forEach(function (e) {
                if (e.children.length) {
                    var innerData = [];
                    e.children.forEach(function (i) {
                        innerData.push(_this3.fb.control(i.isChecked));
                    });
                    fbData[e.controlName] = _this3.fb.array(innerData);
                }
            });
            return this.fb.group(fbData);
        }
    }, {
        key: "loadImportData",
        value: function loadImportData() {
            var _this4 = this;

            this.brandsDataService.getBrandsImportData().pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (data) {
                return _this4.initModalPage(data, 0);
            });
        }
    }, {
        key: "initModalPage",
        value: function initModalPage(data, companyIndex) {
            this.checkboxes = this.brandsService.mapImportActions(data.brandsDataToImport[companyIndex]);
            this.importDataForm = null;
            this.importDataForm = this.createFormGroup(this.checkboxes);
            this.brands = data;
            this.selectedBrand = data.brandsDataToImport[companyIndex];
        }
    }, {
        key: "prepareBrandDataToSave",
        value: function prepareBrandDataToSave() {
            var data = this.brandsService.createImportListToSave(this.importDataForm, this.checkboxes);
            this.newBrandData.toImportData = {
                sourceCompanyId: null,
                types: null
            };
            if (data && data.length) {
                this.newBrandData.toImportData.sourceCompanyId = this.selectedBrand.companyId;
                this.newBrandData.toImportData.types = data;
            } else {
                this.newBrandData.toImportData = null;
            }
        }
    }]);

    return ImportDataModalComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], ImportDataModalComponent.prototype, "newBrandData", void 0);
ImportDataModalComponent = __decorate([core_1.Component({
    selector: 'import-data-modal',
    template: __webpack_require__("./web/modern/components/brands/modals/import-data-modal/import-data-modal.html"),
    styles: [__webpack_require__("./web/modern/components/brands/modals/import-data-modal/import-data-modal.scss")]
}), __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal, forms_1.FormBuilder, snModal_service_1.SNModalService, account_service_1.AccountServiceWebProvider, brands_data_service_1.BrandsDataServiceProvider, brands_service_1.BrandsServiceProvider])], ImportDataModalComponent);
exports.ImportDataModalComponent = ImportDataModalComponent;

/***/ }),

/***/ "./web/modern/components/brands/modals/reject-import-modal/reject-import-modal.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-body flex-column flex-align-center\">\n    <h3 class=\"modal-text text-align-center\">Importing data cannot be done later. Are you sure you want to create a new company without importing?</h3>\n\n    <div class=\"mt-30 flex-column\">\n        <button (click)=\"saveAndClose()\" [is-spinning-wheel-active]=\"btnDisable\" class=\"btn btn-lg btn-danger\" spinning-wheel>Add company without import</button>\n        <button (click)=\"closeModal()\" class=\"btn btn-lg btn-cancel\">Back To Import Data</button>\n        <button (click)=\"cancelCreation()\" class=\"btn btn-lg btn-general\">Cancel Add Company</button>\n    </div>\n</div>\n\n\n\n\n\n\n"

/***/ }),

/***/ "./web/modern/components/brands/modals/reject-import-modal/reject-import-modal.scss":
/***/ (function(module, exports) {

module.exports = ".modal-text {\n  font-size: 1.4em;\n  line-height: 1.3em; }\n"

/***/ }),

/***/ "./web/modern/components/brands/modals/reject-import-modal/reject-import-modal.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var ng_bootstrap_1 = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/index.js");
var brands_data_service_1 = __webpack_require__("./shared/services/brands/brands.data.service.ts");
var rxjs_1 = __webpack_require__("./node_modules/rxjs/Rx.js");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var account_service_1 = __webpack_require__("./web/modern/services/user/account.service.ts");
var RejectImportModalComponent = function () {
    function RejectImportModalComponent(activeModal, accountService, brandsDataService) {
        _classCallCheck(this, RejectImportModalComponent);

        this.activeModal = activeModal;
        this.accountService = accountService;
        this.brandsDataService = brandsDataService;
        this.btnDisable = false;
        this.unsubscribe = new rxjs_1.Subject();
    }

    _createClass(RejectImportModalComponent, [{
        key: "closeModal",
        value: function closeModal() {
            this.activeModal.close();
        }
    }, {
        key: "cancelCreation",
        value: function cancelCreation() {
            this.activeModal.close({ action: 'CANCEL' });
        }
    }, {
        key: "saveAndClose",
        value: function saveAndClose() {
            var _this = this;

            this.btnDisable = true;
            this.accountService.saveBrand(this.newBrandData).pipe(operators_1.takeUntil(this.unsubscribe), operators_1.finalize(function () {
                return _this.btnDisable = false;
            })).subscribe(function (res) {
                _this.brandsDataService.updateBrands().pipe(operators_1.takeUntil(_this.unsubscribe), operators_1.finalize(function () {
                    return _this.btnDisable = false;
                })).subscribe(function () {
                    _this.activeModal.close(res);
                });
            });
        }
    }]);

    return RejectImportModalComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], RejectImportModalComponent.prototype, "newBrandData", void 0);
RejectImportModalComponent = __decorate([core_1.Component({
    selector: 'reject-import-modal',
    template: __webpack_require__("./web/modern/components/brands/modals/reject-import-modal/reject-import-modal.html"),
    styles: [__webpack_require__("./web/modern/components/brands/modals/reject-import-modal/reject-import-modal.scss")]
}), __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal, account_service_1.AccountServiceWebProvider, brands_data_service_1.BrandsDataServiceProvider])], RejectImportModalComponent);
exports.RejectImportModalComponent = RejectImportModalComponent;

/***/ }),

/***/ "./web/modern/components/brands/modals/save-languages-modal/save-languages-modal.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-body flex-column flex-align-center\">\n  <p class=\"text-align-center fs-16\">\n      {{ text }}\n  </p>\n  <div class=\"mt-15\">\n    <button *ngIf=\"redirect\" class=\"btn btn-lg btn-success mr-20\" (click)=\"closeModal(true)\">Go to Payment Methods</button>\n    <button class=\"btn btn-lg btn-default\" (click)=\"closeModal(false)\">{{ redirect ? 'Not Now' : 'Got it' }}</button>\n  </div>\n</div>\n"

/***/ }),

/***/ "./web/modern/components/brands/modals/save-languages-modal/save-languages-modal.scss":
/***/ (function(module, exports) {

module.exports = ""

/***/ }),

/***/ "./web/modern/components/brands/modals/save-languages-modal/save-languages-modal.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var ng_bootstrap_1 = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/index.js");
var SaveLanguagesModalComponent = function () {
    function SaveLanguagesModalComponent(activeModal) {
        _classCallCheck(this, SaveLanguagesModalComponent);

        this.activeModal = activeModal;
        this.text = '';
        this.redirect = false;
    }

    _createClass(SaveLanguagesModalComponent, [{
        key: "closeModal",
        value: function closeModal(state) {
            this.activeModal.close(state);
        }
    }]);

    return SaveLanguagesModalComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], SaveLanguagesModalComponent.prototype, "text", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], SaveLanguagesModalComponent.prototype, "redirect", void 0);
SaveLanguagesModalComponent = __decorate([core_1.Component({
    selector: 'save-languages-modal',
    template: __webpack_require__("./web/modern/components/brands/modals/save-languages-modal/save-languages-modal.html"),
    styles: [__webpack_require__("./web/modern/components/brands/modals/save-languages-modal/save-languages-modal.scss")]
}), __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal])], SaveLanguagesModalComponent);
exports.SaveLanguagesModalComponent = SaveLanguagesModalComponent;

/***/ }),

/***/ "./web/modern/components/buttons/add-new-element-btn/add-new-element-btn.component.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"add-new-item\" (click)=\"onButtonClicked()\" [ngClass]=\"{ 'add-new-item-disabled': false }\">\n    <i class=\"{{icon}} mr-18\" *ngIf=\"icon\"></i>\n    <img [src]=\"imgSrc\" class=\"add-new-pic\" *ngIf=\"imgSrc\">\n    <div>\n        <h2 class=\"an-item-title\">{{ title }}</h2>\n        <div class=\"an-item-description\">{{ description }}</div>\n    </div>\n</div>"

/***/ }),

/***/ "./web/modern/components/buttons/add-new-element-btn/add-new-element-btn.component.scss":
/***/ (function(module, exports) {

module.exports = ":host {\n  display: block; }\n"

/***/ }),

/***/ "./web/modern/components/buttons/add-new-element-btn/add-new-element-btn.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var AddNewElementBtnComponent = function () {
    function AddNewElementBtnComponent() {
        _classCallCheck(this, AddNewElementBtnComponent);

        this.onBtnClicked = new core_1.EventEmitter();
    }

    _createClass(AddNewElementBtnComponent, [{
        key: "onButtonClicked",
        value: function onButtonClicked() {
            this.onBtnClicked.next();
        }
    }]);

    return AddNewElementBtnComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", String)], AddNewElementBtnComponent.prototype, "icon", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], AddNewElementBtnComponent.prototype, "imgSrc", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], AddNewElementBtnComponent.prototype, "title", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], AddNewElementBtnComponent.prototype, "description", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], AddNewElementBtnComponent.prototype, "onBtnClicked", void 0);
AddNewElementBtnComponent = __decorate([core_1.Component({
    selector: 'add-new-element-btn',
    template: __webpack_require__("./web/modern/components/buttons/add-new-element-btn/add-new-element-btn.component.html"),
    styles: [__webpack_require__("./web/modern/components/buttons/add-new-element-btn/add-new-element-btn.component.scss")]
}), __metadata("design:paramtypes", [])], AddNewElementBtnComponent);
exports.AddNewElementBtnComponent = AddNewElementBtnComponent;

/***/ }),

/***/ "./web/modern/components/buttons/add-round-btn/add-round-btn.html":
/***/ (function(module, exports) {

module.exports = "<a *ngIf=\"linkHref\"\n   href=\"{{linkHref}}\"\n   [ngClass]=\"{'spinning-wheel__active' : isActive}\"\n   class=\"btn btn-add-round btn-success\" type=\"button\">\n</a>\n\n<button *ngIf=\"!linkHref\"\n        [ngClass]=\"{'spinning-wheel__active' : isActive}\"\n        class=\"btn btn-add-round btn-success spinning-wheel spinning-wheel__display-after\"\n        type=\"button\">\n</button>"

/***/ }),

/***/ "./web/modern/components/buttons/add-round-btn/add-round-btn.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var AddRoundBtnComponent = function AddRoundBtnComponent() {
    _classCallCheck(this, AddRoundBtnComponent);
};
__decorate([core_1.Input(), __metadata("design:type", Boolean)], AddRoundBtnComponent.prototype, "isActive", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], AddRoundBtnComponent.prototype, "linkHref", void 0);
AddRoundBtnComponent = __decorate([core_1.Component({
    selector: 'add-round-btn',
    template: __webpack_require__("./web/modern/components/buttons/add-round-btn/add-round-btn.html")
}), __metadata("design:paramtypes", [])], AddRoundBtnComponent);
exports.AddRoundBtnComponent = AddRoundBtnComponent;

/***/ }),

/***/ "./web/modern/components/buttons/archive-btn/archive-btn.html":
/***/ (function(module, exports) {

module.exports = "<button class=\"btn btn-default\" (click)=\"onBtnClick($event)\" [disabled]=\"isDisabled\">\n  <i name=\"fi-archive\" class=\"sn-icon fi-archive fi\" color=\"text-light\"></i>\n  <span>{{ text }}</span>\n</button>\n"

/***/ }),

/***/ "./web/modern/components/buttons/archive-btn/archive-btn.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var ArchiveBtnComponent = function () {
    function ArchiveBtnComponent() {
        _classCallCheck(this, ArchiveBtnComponent);

        this.action = new core_1.EventEmitter();
    }

    _createClass(ArchiveBtnComponent, [{
        key: "onBtnClick",
        value: function onBtnClick(event) {
            event.stopPropagation();
            this.action.emit();
            return false;
        }
    }]);

    return ArchiveBtnComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", String)], ArchiveBtnComponent.prototype, "text", void 0);
__decorate([core_1.Input(), __metadata("design:type", Boolean)], ArchiveBtnComponent.prototype, "isDisabled", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], ArchiveBtnComponent.prototype, "action", void 0);
ArchiveBtnComponent = __decorate([core_1.Component({
    selector: 'archive-btn',
    template: __webpack_require__("./web/modern/components/buttons/archive-btn/archive-btn.html")
}), __metadata("design:paramtypes", [])], ArchiveBtnComponent);
exports.ArchiveBtnComponent = ArchiveBtnComponent;

/***/ }),

/***/ "./web/modern/components/buttons/btn-subscription/btn-subscription.html":
/***/ (function(module, exports) {

module.exports = "<button class=\"btn btn-default\" ng-show=\"status==='SUBSCRIBED'\">\n         <i class=\"fa fa-envelope-o\"></i>\n    Unsubscribe\n</button>\n<button class=\"btn btn-default\" ng-show=\"status==='UNSUBSCRIBED'\">\n    <i class=\"fa fa-envelope-o\"></i>\n    Subscribe\n</button>\n\n\n"

/***/ }),

/***/ "./web/modern/components/buttons/btn-subscription/btn-subscription.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var BtnSubscriptionComponent = function BtnSubscriptionComponent() {
    _classCallCheck(this, BtnSubscriptionComponent);

    this.action = new core_1.EventEmitter();
    console.log(status);
};
__decorate([core_1.Input(), __metadata("design:type", Object)], BtnSubscriptionComponent.prototype, "status", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], BtnSubscriptionComponent.prototype, "action", void 0);
BtnSubscriptionComponent = __decorate([core_1.Component({
    selector: 'btn-subscription',
    template: __webpack_require__("./web/modern/components/buttons/btn-subscription/btn-subscription.html")
}), __metadata("design:paramtypes", [])], BtnSubscriptionComponent);
exports.BtnSubscriptionComponent = BtnSubscriptionComponent;

/***/ }),

/***/ "./web/modern/components/buttons/copy-to-qb-btn/copy-to-qb-btn.html":
/***/ (function(module, exports) {

module.exports = "<button [disabled]=\"isBtnDisabled\" type=\"button\" class=\"btn btn-default btn-lg\" (click)=\"copyToQuickbooks(invoiceData.id)\">\n    <i class=\"fi fa fa-files-o\"></i>Copy to Quickbooks\n</button>"

/***/ }),

/***/ "./web/modern/components/buttons/copy-to-qb-btn/copy-to-qb-btn.scss":
/***/ (function(module, exports) {

module.exports = ""

/***/ }),

/***/ "./web/modern/components/buttons/copy-to-qb-btn/copy-to-qb-btn.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var integrations_data_service_1 = __webpack_require__("./shared/services/integrations/integrations.data.service.ts");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var confirm_general_modal_component_1 = __webpack_require__("./web/modern/components/common/confirm-general-modal/confirm-general-modal.component.ts");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var CopyToQbBtnComponent = function () {
    function CopyToQbBtnComponent(integrationsDataService, messageService, modalService) {
        _classCallCheck(this, CopyToQbBtnComponent);

        this.integrationsDataService = integrationsDataService;
        this.messageService = messageService;
        this.modalService = modalService;
        this.successGetInvoiceInformation = new core_1.EventEmitter();
    }

    _createClass(CopyToQbBtnComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.invoiceId = this.invoiceData.id;
            this.invoiceDisplayId = this.invoiceData.invoiceId;
        }
    }, {
        key: "copyToQuickbooks",
        value: function copyToQuickbooks() {
            var _this = this;

            var message = this.invoiceData.actions.COPY_TO_QB.message;

            if (message) {
                this.openAlertModal(message);
                return;
            }
            this.isBtnDisabled = true;
            this.integrationsDataService.copyInvoiceToQuickbooks(this.invoiceId).pipe(operators_1.finalize(function () {
                return _this.isBtnDisabled = false;
            })).subscribe(function (data) {
                return _this.successCopyToQuickbooks(data);
            }, function (error) {
                return _this.errorCopyToQuickbooks(error);
            });
        }
    }, {
        key: "successCopyToQuickbooks",
        value: function successCopyToQuickbooks(data) {
            this.successGetInvoiceInformation.emit(data);
            this.messageService.showToaster('s_0', 'qb');
        }
    }, {
        key: "errorCopyToQuickbooks",
        value: function errorCopyToQuickbooks(error) {
            var data = error.data,
                status = error.status;

            var errorMessage = data.errorMessage;
            var errorTitle = error.error.errorTitle;
            var errorCode = void 0,
                errorPlace = void 0,
                value = void 0;
            if (errorMessage && status >= 400 && status < 500) {
                switch (errorMessage) {
                    case "QuickBooks doesn't allow Inclusive tax for US users":
                        errorCode = 'e_3';
                        errorPlace = 'qb';
                        break;
                    case 'Invoice with written off payments is not compatible with QuickBooks':
                        errorCode = 'e_7';
                        errorPlace = 'qb';
                        break;
                    case 'Sorry, FR QuickBooks companies are not supported yet':
                        errorCode = 'e_8';
                        errorPlace = 'qb';
                        break;
                    case 'Invoice with such ID already exists on QuickBooks':
                        errorCode = 'e_1';
                        errorPlace = 'qb';
                        value = this.invoiceData.invoiceId;
                        break;
                    case 'Invoice with written off payments is not compatible with Xero':
                        errorCode = 'e_7';
                        errorPlace = 'xero';
                        break;
                    case 'Invoice has been deleted deleted on QuickBooks':
                        errorCode = 'e_17';
                        errorPlace = 'qb';
                        break;
                    case errorMessage.includes('One of the list elements assigned to this transaction has been deleted'):
                        errorCode = 'e_11';
                        errorPlace = 'qb';
                        break;
                    case errorMessage.includes('Try reselecting the tax rate or reentering the product/service item and saving the form again.'):
                        errorCode = 'e_19';
                        errorPlace = 'qb';
                        break;
                    case 'Invoice should have the same tax type for all products':
                        errorCode = 'e_0';
                        errorPlace = 'qb';
                        break;
                    case "StudioNinja doesn't support transactions with Credit Notes from QuickBooks":
                        errorCode = 'e_14';
                        errorPlace = 'qb';
                        break;
                    case 'QB: Impossible to create invoice with Product "Bundle", such item exists on QuickBooks':
                        errorCode = 'e_25';
                        errorPlace = 'qb';
                        break;
                    case 'Invoice id length is more than 20':
                        errorCode = 'e_27';
                        errorPlace = 'qb';
                        break;
                    case 'Invoice name length is more than 100':
                        errorCode = 'e_26';
                        errorPlace = 'qb';
                        break;
                    case errorMessage.includes('QuickBooks: Email Address does not conform to the syntax rules of RFC 822.'):
                        errorCode = 'e_18';
                        errorPlace = 'qb';
                        break;
                    case 'Invoice description length is more than 4000':
                        errorCode = 'e_28';
                        errorPlace = 'qb';
                        break;
                    default:
                        if (errorTitle && errorTitle !== null && errorMessage && errorMessage !== null) {
                            this.messageService.showErrorFromBackend(errorTitle, errorMessage);
                        } else {
                            this.messageService.showErrorFromBackend('Slow down, Quickbooks error!');
                        }
                        return;
                }
            } else {
                errorCode = 'e_0';
                errorPlace = 'general';
            }
            this.messageService.showToaster(errorCode, errorPlace, value);
        }
    }, {
        key: "openAlertModal",
        value: function openAlertModal(message) {
            var modal = this.modalService.openModal(confirm_general_modal_component_1.ConfirmGeneralModalComponent, {
                windowClass: 'ng-bootstrap-modal modal-visible modal-narrow'
            });
            modal.componentInstance.text = message;
            modal.componentInstance.buttons = [{
                text: 'Okay',
                action: 'CLOSE',
                color: 'default',
                size: 'lg'
            }];
        }
    }]);

    return CopyToQbBtnComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], CopyToQbBtnComponent.prototype, "invoiceData", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], CopyToQbBtnComponent.prototype, "successGetInvoiceInformation", void 0);
CopyToQbBtnComponent = __decorate([core_1.Component({
    selector: 'copy-to-qb-btn',
    template: __webpack_require__("./web/modern/components/buttons/copy-to-qb-btn/copy-to-qb-btn.html"),
    styles: [__webpack_require__("./web/modern/components/buttons/copy-to-qb-btn/copy-to-qb-btn.scss")]
}), __metadata("design:paramtypes", [integrations_data_service_1.IntegrationsDataProvider, message_service_1.MessageService, snModal_service_1.SNModalService])], CopyToQbBtnComponent);
exports.CopyToQbBtnComponent = CopyToQbBtnComponent;

/***/ }),

/***/ "./web/modern/components/buttons/copy-to-xero-btn/copy-to-xero-btn.html":
/***/ (function(module, exports) {

module.exports = "<button [disabled]=\"isBtnDisabled\" class=\"btn btn-default btn-lg\" (click)=\"copyToXero(invoiceId)\">\n    <i class=\"fi fa fa-files-o\"></i>Copy to Xero\n</button>"

/***/ }),

/***/ "./web/modern/components/buttons/copy-to-xero-btn/copy-to-xero-btn.scss":
/***/ (function(module, exports) {

module.exports = ""

/***/ }),

/***/ "./web/modern/components/buttons/copy-to-xero-btn/copy-to-xero-btn.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var invoice_service_1 = __webpack_require__("./shared/services/invoice/invoice-service/invoice.service.ts");
var integrations_data_service_1 = __webpack_require__("./shared/services/integrations/integrations.data.service.ts");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var confirm_general_modal_component_1 = __webpack_require__("./web/modern/components/common/confirm-general-modal/confirm-general-modal.component.ts");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var CopyToXeroBtnComponent = function () {
    function CopyToXeroBtnComponent(invoiceService, integrationsDataService, messageService, modalService) {
        _classCallCheck(this, CopyToXeroBtnComponent);

        this.invoiceService = invoiceService;
        this.integrationsDataService = integrationsDataService;
        this.messageService = messageService;
        this.modalService = modalService;
        this.successGetInvoiceInformation = new core_1.EventEmitter();
    }

    _createClass(CopyToXeroBtnComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.invoiceId = this.invoiceData.id;
            this.invoiceDisplayId = this.invoiceData.invoiceId;
        }
    }, {
        key: "copyToXero",
        value: function copyToXero() {
            var _this = this;

            var message = this.invoiceData.actions.COPY_TO_XERO.message;

            if (message) {
                this.openAlertModal(message);
                return;
            }
            this.isBtnDisabled = true;
            if (!this.isInvoiceValid(this.invoiceData)) {
                this.integrationsDataService.copyInvoiceToXero(this.invoiceId).pipe(operators_1.finalize(function () {
                    return _this.isBtnDisabled = false;
                })).subscribe(function (data) {
                    return _this.successCopyToXero(data);
                }, function (error) {
                    return _this.errorCopyToXero(error);
                });
            } else {
                this.isBtnDisabled = false;
            }
        }
    }, {
        key: "isInvoiceValid",
        value: function isInvoiceValid(invoice) {
            var _this2 = this;

            var dataToValidate = {
                packages: invoice.summary.items,
                pageName: 'invoicePage'
            };
            return dataToValidate.packages.some(function (packages) {
                return _this2.invoiceService.isInvalidProduct(packages, dataToValidate.pageName);
            });
        }
    }, {
        key: "successCopyToXero",
        value: function successCopyToXero(data) {
            this.successGetInvoiceInformation.emit(data);
            this.messageService.showToaster('s_1', 'xero');
        }
    }, {
        key: "errorCopyToXero",
        value: function errorCopyToXero(_ref) {
            var data = _ref.data,
                status = _ref.status,
                error = _ref.error;

            this.successGetInvoiceInformation.emit(null);
            if (error.errorCode) {
                this.handleModernErrorMessages(error);
                return;
            }
            var errorMessage = data ? data.errorMessage : null;
            var errorCode = void 0,
                errorPlace = void 0,
                value = void 0;
            if (errorMessage && status >= 400 && status < 500) {
                switch (errorMessage) {
                    case "Paid or partially paid invoice can't be updated on Xero":
                        errorCode = 'e_5';
                        errorPlace = 'xero';
                        break;
                    case 'Invoice with such invoice ID (Invoice Number) exists on Xero':
                        errorCode = 'e_6';
                        errorPlace = 'xero';
                        value = this.invoiceDisplayId;
                        break;
                    case 'Product/Package tax type is not compatible with Xero':
                        errorCode = 'e_4';
                        errorPlace = 'xero';
                        break;
                    case 'Fixed discount is not compatible with Xero':
                        errorCode = 'e_1';
                        errorPlace = 'xero';
                        break;
                    case 'Invoice is Voided or Deleted on Xero':
                        errorCode = 'e_3';
                        errorPlace = 'xero';
                        break;
                    case 'Invoice with written off payments is not compatible with Xero':
                        errorCode = 'e_7';
                        errorPlace = 'xero';
                        break;
                    case 'Xero access token expired, reconnect Xero please':
                        errorCode = 'e_14';
                        errorPlace = 'xero';
                        break;
                    case 'Bummer! Xero access token not authorized or revoked, reconnect Xero please':
                        errorCode = 'e_14';
                        errorPlace = 'xero';
                        break;
                    case 'Bummer! Xero access token revoked, reconnect Xero please':
                        errorCode = 'e_14';
                        errorPlace = 'xero';
                        break;
                    case "Bummer! You don't have an active Xero subscription.":
                        errorCode = 'e_15';
                        errorPlace = 'xero';
                        break;
                    default:
                        errorCode = 'e_2';
                        errorPlace = 'general';
                        value = errorMessage;
                }
            } else {
                errorCode = 'e_0';
                errorPlace = 'general';
            }
            this.messageService.showToaster(errorCode, errorPlace, value);
        }
    }, {
        key: "openAlertModal",
        value: function openAlertModal(message) {
            var modal = this.modalService.openModal(confirm_general_modal_component_1.ConfirmGeneralModalComponent, {
                windowClass: 'ng-bootstrap-modal modal-visible modal-narrow'
            });
            modal.componentInstance.text = message;
            modal.componentInstance.buttons = [{
                text: 'Okay',
                action: 'CLOSE',
                color: 'default',
                size: 'lg'
            }];
        }
    }, {
        key: "handleModernErrorMessages",
        value: function handleModernErrorMessages(_ref2) {
            var errorTitle = _ref2.errorTitle,
                errorMessage = _ref2.errorMessage;

            this.messageService.showErrorFromBackend(errorTitle, errorMessage);
        }
    }]);

    return CopyToXeroBtnComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], CopyToXeroBtnComponent.prototype, "invoiceData", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], CopyToXeroBtnComponent.prototype, "successGetInvoiceInformation", void 0);
CopyToXeroBtnComponent = __decorate([core_1.Component({
    selector: 'copy-to-xero-btn',
    template: __webpack_require__("./web/modern/components/buttons/copy-to-xero-btn/copy-to-xero-btn.html"),
    styles: [__webpack_require__("./web/modern/components/buttons/copy-to-xero-btn/copy-to-xero-btn.scss")]
}), __metadata("design:paramtypes", [invoice_service_1.InvoiceServiceProvider, integrations_data_service_1.IntegrationsDataProvider, message_service_1.MessageService, snModal_service_1.SNModalService])], CopyToXeroBtnComponent);
exports.CopyToXeroBtnComponent = CopyToXeroBtnComponent;

/***/ }),

/***/ "./web/modern/components/buttons/delete-btn/delete-btn.html":
/***/ (function(module, exports) {

module.exports = "<button #button class=\"btn btn-default btn-rounded line-n\"\n        [ngClass]=\"addClass\"\n        [disabled]=\"isDisabled\"\n        (click)=\"handleClick($event)\"\n>\n    <i class=\"fa fa-trash-o pr-0\" *ngIf=\"isEmpty\"></i>\n    <i class=\"fi fa fa-trash-o\" *ngIf=\"!isEmpty\"></i>\n    {{ btnText }}\n</button>"

/***/ }),

/***/ "./web/modern/components/buttons/delete-btn/delete-btn.scss":
/***/ (function(module, exports) {

module.exports = ""

/***/ }),

/***/ "./web/modern/components/buttons/delete-btn/delete-btn.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var DeleteBtnComponent = function () {
    function DeleteBtnComponent() {
        _classCallCheck(this, DeleteBtnComponent);

        this.clicked = new core_1.EventEmitter();
    }

    _createClass(DeleteBtnComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.btnText = this.text || 'Delete';
            if (this.isEmpty) {
                this.btnText = '';
            }
        }
    }, {
        key: "handleClick",
        value: function handleClick(event) {
            this.clicked.emit(event);
            try {
                this.button.nativeElement.blur();
            } catch (err) {
                console.log(err);
            }
        }
    }]);

    return DeleteBtnComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", String)], DeleteBtnComponent.prototype, "text", void 0);
__decorate([core_1.Input(), __metadata("design:type", Boolean)], DeleteBtnComponent.prototype, "isEmpty", void 0);
__decorate([core_1.Input(), __metadata("design:type", Boolean)], DeleteBtnComponent.prototype, "isDisabled", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], DeleteBtnComponent.prototype, "addClass", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], DeleteBtnComponent.prototype, "clicked", void 0);
__decorate([core_1.ViewChild('button'), __metadata("design:type", core_1.ElementRef)], DeleteBtnComponent.prototype, "button", void 0);
DeleteBtnComponent = __decorate([core_1.Component({
    selector: 'delete-btn',
    template: __webpack_require__("./web/modern/components/buttons/delete-btn/delete-btn.html"),
    styles: [__webpack_require__("./web/modern/components/buttons/delete-btn/delete-btn.scss")]
}), __metadata("design:paramtypes", [])], DeleteBtnComponent);
exports.DeleteBtnComponent = DeleteBtnComponent;

/***/ }),

/***/ "./web/modern/components/buttons/edit-btn/edit-btn.html":
/***/ (function(module, exports) {

module.exports = "<a *ngIf=\"isLink === true && linkHref; else editBtn\"\n   [href]=\"linkHref\" [ngClass]=\"addClass\" class=\"btn btn-default\">\n    <i class=\"fi fi-edit pr-0\" *ngIf=\"isEmpty\"></i>\n    <i class=\"fi fi-edit\" *ngIf=\"!isEmpty\"></i>\n    {{ btnText }}\n</a>\n<ng-template #editBtn>\n    <button class=\"btn btn-default\" [disabled]=\"isDisabled\">\n        <i class=\"fi fi-edit pr-0\" [class.disabled]=\"isDisabled\" *ngIf=\"isEmpty\"></i>\n        <i class=\"fi fi-edit\" [class.disabled]=\"isDisabled\" *ngIf=\"!isEmpty\"></i>\n        {{ btnText }}\n    </button>\n</ng-template>\n"

/***/ }),

/***/ "./web/modern/components/buttons/edit-btn/edit-btn.scss":
/***/ (function(module, exports) {

module.exports = ".disabled {\n  pointer-events: none; }\n"

/***/ }),

/***/ "./web/modern/components/buttons/edit-btn/edit-btn.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var EditBtnComponent = function () {
    function EditBtnComponent() {
        _classCallCheck(this, EditBtnComponent);
    }

    _createClass(EditBtnComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.btnText = this.text || 'Edit';
            if (this.isEmpty) {
                this.btnText = '';
            }
        }
    }]);

    return EditBtnComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", String)], EditBtnComponent.prototype, "text", void 0);
__decorate([core_1.Input(), __metadata("design:type", Boolean)], EditBtnComponent.prototype, "isEmpty", void 0);
__decorate([core_1.Input(), __metadata("design:type", Boolean)], EditBtnComponent.prototype, "isLink", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], EditBtnComponent.prototype, "linkHref", void 0);
__decorate([core_1.Input(), __metadata("design:type", Boolean)], EditBtnComponent.prototype, "isDisabled", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], EditBtnComponent.prototype, "addClass", void 0);
EditBtnComponent = __decorate([core_1.Component({
    selector: 'edit-btn',
    template: __webpack_require__("./web/modern/components/buttons/edit-btn/edit-btn.html"),
    styles: [__webpack_require__("./web/modern/components/buttons/edit-btn/edit-btn.scss")]
}), __metadata("design:paramtypes", [])], EditBtnComponent);
exports.EditBtnComponent = EditBtnComponent;

/***/ }),

/***/ "./web/modern/components/buttons/preview-btn/preview-btn.html":
/***/ (function(module, exports) {

module.exports = "<a class=\"btn btn-default btn-lg\" target=\"_blank\" href=\"{{previewLink}}\">\n    <i class=\"fi fi-view\"></i>{{ text }}\n</a>"

/***/ }),

/***/ "./web/modern/components/buttons/preview-btn/preview-btn.scss":
/***/ (function(module, exports) {

module.exports = ""

/***/ }),

/***/ "./web/modern/components/buttons/preview-btn/preview-btn.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var PreviewBtnComponent = function PreviewBtnComponent() {
    _classCallCheck(this, PreviewBtnComponent);

    this.text = 'Preview';
};
__decorate([core_1.Input(), __metadata("design:type", Object)], PreviewBtnComponent.prototype, "text", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], PreviewBtnComponent.prototype, "previewLink", void 0);
PreviewBtnComponent = __decorate([core_1.Component({
    selector: 'preview-btn',
    template: __webpack_require__("./web/modern/components/buttons/preview-btn/preview-btn.html"),
    styles: [__webpack_require__("./web/modern/components/buttons/preview-btn/preview-btn.scss")]
}), __metadata("design:paramtypes", [])], PreviewBtnComponent);
exports.PreviewBtnComponent = PreviewBtnComponent;

/***/ }),

/***/ "./web/modern/components/buttons/print-btn/print-btn.html":
/***/ (function(module, exports) {

module.exports = "<button type=\"button\" class=\"btn btn-default btn-lg\" (click)=\"print()\" [disabled]=\"isDisabled\">\n    <i class=\"fi fi-print\"></i>Print\n</button>"

/***/ }),

/***/ "./web/modern/components/buttons/print-btn/print-btn.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var PrintBtnComponent = function () {
    function PrintBtnComponent() {
        _classCallCheck(this, PrintBtnComponent);

        this.isDisabled = false;
    }

    _createClass(PrintBtnComponent, [{
        key: "print",
        value: function print() {
            window.print();
        }
    }]);

    return PrintBtnComponent;
}();
__decorate([core_1.Input('isDisabled'), __metadata("design:type", Object)], PrintBtnComponent.prototype, "isDisabled", void 0);
PrintBtnComponent = __decorate([core_1.Component({
    selector: 'print-btn',
    template: __webpack_require__("./web/modern/components/buttons/print-btn/print-btn.html")
}), __metadata("design:paramtypes", [])], PrintBtnComponent);
exports.PrintBtnComponent = PrintBtnComponent;

/***/ }),

/***/ "./web/modern/components/buttons/re-sync-btn/re-sync-btn.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"re-sync text-right flex flex-align-center\">\n  <span class=\"re-sync--date text-light\" *ngIf=\"lastSyncDate && lastSyncDate !== null \"><span class=\"re-sync--label\">Last synced: </span>{{ lastSyncDate | timeFilter:'medium' }} {{ lastSyncDate | timeFilter:'hourAndMin' }}</span>\n  <button class=\"re-sync--btn btn btn-default btn-rounded\" [disabled]=\"isActive\" (click)=\"triggerEmailSync()\">\n    <i [class.active]=\"isActive\" class=\"re-sync--btn__icon fa fa-repeat\" aria-hidden=\"true\"></i>\n  </button>\n</div>\n\n"

/***/ }),

/***/ "./web/modern/components/buttons/re-sync-btn/re-sync-btn.scss":
/***/ (function(module, exports) {

module.exports = ".re-sync--date {\n  margin-right: 10px;\n  color: #acacaf; }\n"

/***/ }),

/***/ "./web/modern/components/buttons/re-sync-btn/re-sync-btn.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var ReSyncBtnComponent = function () {
    function ReSyncBtnComponent() {
        _classCallCheck(this, ReSyncBtnComponent);

        this.syncEmails = new core_1.EventEmitter();
    }

    _createClass(ReSyncBtnComponent, [{
        key: "triggerEmailSync",
        value: function triggerEmailSync() {
            this.syncEmails.emit();
        }
    }]);

    return ReSyncBtnComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Boolean)], ReSyncBtnComponent.prototype, "isActive", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], ReSyncBtnComponent.prototype, "lastSyncDate", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], ReSyncBtnComponent.prototype, "syncEmails", void 0);
ReSyncBtnComponent = __decorate([core_1.Component({
    selector: 're-sync-btn',
    template: __webpack_require__("./web/modern/components/buttons/re-sync-btn/re-sync-btn.html"),
    styles: [__webpack_require__("./web/modern/components/buttons/re-sync-btn/re-sync-btn.scss")]
}), __metadata("design:paramtypes", [])], ReSyncBtnComponent);
exports.ReSyncBtnComponent = ReSyncBtnComponent;

/***/ }),

/***/ "./web/modern/components/buttons/save-pdf-btn/save-pdf-btn.html":
/***/ (function(module, exports) {

module.exports = "<button class=\"btn btn-default btn-lg\"\n        spinning-wheel [is-spinning-wheel-active]=\"isSpinnerActive\" [is-spinning-wheel-dark]=\"'true'\"\n        (click)=\"saveAsPdf()\">\n    <i class=\"fa fa-file-pdf-o\"></i>Save As PDF\n</button>"

/***/ }),

/***/ "./web/modern/components/buttons/save-pdf-btn/save-pdf-btn.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var file_download_data_service_1 = __webpack_require__("./shared/services/files/file-download-service/file-download.data.service.ts");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var SavePdfBtnComponent = function () {
    function SavePdfBtnComponent(fileDownloadDataService, messageService) {
        _classCallCheck(this, SavePdfBtnComponent);

        this.fileDownloadDataService = fileDownloadDataService;
        this.messageService = messageService;
    }

    _createClass(SavePdfBtnComponent, [{
        key: "saveAsPdf",
        value: function saveAsPdf() {
            var _this = this;

            this.isSpinnerActive = true;
            this.fileDownloadDataService.downloadPdf(this.link, this.id, this.docType).then(function () {
                return _this.isSpinnerActive = false;
            }).catch(function (_ref) {
                var error = _ref.error;
                var errorTitle = error.errorTitle,
                    errorMessage = error.errorMessage;

                _this.messageService.showErrorFromBackend(errorTitle, errorMessage);
                _this.isSpinnerActive = false;
            });
        }
    }]);

    return SavePdfBtnComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", String)], SavePdfBtnComponent.prototype, "link", void 0);
__decorate([core_1.Input(), __metadata("design:type", Number)], SavePdfBtnComponent.prototype, "id", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], SavePdfBtnComponent.prototype, "docType", void 0);
SavePdfBtnComponent = __decorate([core_1.Component({
    selector: 'save-pdf-btn',
    template: __webpack_require__("./web/modern/components/buttons/save-pdf-btn/save-pdf-btn.html")
}), __metadata("design:paramtypes", [file_download_data_service_1.FileDownloadDataServiceProvider, message_service_1.MessageService])], SavePdfBtnComponent);
exports.SavePdfBtnComponent = SavePdfBtnComponent;

/***/ }),

/***/ "./web/modern/components/buttons/send-btn/send-btn.html":
/***/ (function(module, exports) {

module.exports = "<button class=\"btn btn-default {{addClass}}\" [disabled]=\"isDisabled\">\n    <i class=\"fi fi-send\"></i>{{ btnText }}\n</button>"

/***/ }),

/***/ "./web/modern/components/buttons/send-btn/send-btn.scss":
/***/ (function(module, exports) {

module.exports = ""

/***/ }),

/***/ "./web/modern/components/buttons/send-btn/send-btn.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var SendBtnComponent = function () {
    function SendBtnComponent() {
        _classCallCheck(this, SendBtnComponent);
    }

    _createClass(SendBtnComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.btnText = this.text || 'Send';
        }
    }]);

    return SendBtnComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", String)], SendBtnComponent.prototype, "text", void 0);
__decorate([core_1.Input(), __metadata("design:type", Boolean)], SendBtnComponent.prototype, "isDisabled", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], SendBtnComponent.prototype, "addClass", void 0);
SendBtnComponent = __decorate([core_1.Component({
    selector: 'send-btn',
    template: __webpack_require__("./web/modern/components/buttons/send-btn/send-btn.html"),
    styles: [__webpack_require__("./web/modern/components/buttons/send-btn/send-btn.scss")]
}), __metadata("design:paramtypes", [])], SendBtnComponent);
exports.SendBtnComponent = SendBtnComponent;

/***/ }),

/***/ "./web/modern/components/buttons/settings-add-btn/settings-add-btn.html":
/***/ (function(module, exports) {

module.exports = "<button (click)=\"onAddBtnClick()\" [disabled]=\"disable\" class=\"btn btn-success btn-add-new btn-clear\">\n    {{ text }}\n</button>"

/***/ }),

/***/ "./web/modern/components/buttons/settings-add-btn/settings-add-btn.scss":
/***/ (function(module, exports) {

module.exports = ".btn-clear {\n  margin: 0; }\n"

/***/ }),

/***/ "./web/modern/components/buttons/settings-add-btn/settings-add-btn.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var SettingsAddBtnComponent = function () {
    function SettingsAddBtnComponent() {
        _classCallCheck(this, SettingsAddBtnComponent);

        this.onBtnClick = new core_1.EventEmitter();
    }

    _createClass(SettingsAddBtnComponent, [{
        key: "onAddBtnClick",
        value: function onAddBtnClick() {
            this.onBtnClick.emit();
        }
    }]);

    return SettingsAddBtnComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", String)], SettingsAddBtnComponent.prototype, "text", void 0);
__decorate([core_1.Input(), __metadata("design:type", Boolean)], SettingsAddBtnComponent.prototype, "disable", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], SettingsAddBtnComponent.prototype, "onBtnClick", void 0);
SettingsAddBtnComponent = __decorate([core_1.Component({
    selector: 'settings-add-btn',
    template: __webpack_require__("./web/modern/components/buttons/settings-add-btn/settings-add-btn.html"),
    styles: [__webpack_require__("./web/modern/components/buttons/settings-add-btn/settings-add-btn.scss")]
}), __metadata("design:paramtypes", [])], SettingsAddBtnComponent);
exports.SettingsAddBtnComponent = SettingsAddBtnComponent;

/***/ }),

/***/ "./web/modern/components/buttons/settings-btn/settings-btn.html":
/***/ (function(module, exports) {

module.exports = "<button class=\"btn btn-default pr-15\" [disabled]=\"isDisabled\">\n    <i class=\"fa fa-cog pl-5\"></i>\n    <span>{{ text }}</span>\n</button>\n"

/***/ }),

/***/ "./web/modern/components/buttons/settings-btn/settings-btn.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var SettingsBtnComponent = function SettingsBtnComponent() {
    _classCallCheck(this, SettingsBtnComponent);

    this.text = this.text || 'Settings';
};
__decorate([core_1.Input(), __metadata("design:type", String)], SettingsBtnComponent.prototype, "text", void 0);
__decorate([core_1.Input(), __metadata("design:type", Boolean)], SettingsBtnComponent.prototype, "isDisabled", void 0);
SettingsBtnComponent = __decorate([core_1.Component({
    selector: 'settings-btn',
    template: __webpack_require__("./web/modern/components/buttons/settings-btn/settings-btn.html")
}), __metadata("design:paramtypes", [])], SettingsBtnComponent);
exports.SettingsBtnComponent = SettingsBtnComponent;

/***/ }),

/***/ "./web/modern/components/buttons/simple-pagination/simple-pagination.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"simple-pagination-container\">\n    <button [disabled]=\"getCurrentPage() === 0\"\n            (click)=\"changePage(-1)\"\n            class=\"btn btn-default btn-simple-pagination\">\n        < &#160; previous page\n    </button>\n    <button [disabled]=\"getCurrentPage() + 1 >= totalPages\"\n            (click)=\"changePage(1)\"\n            class=\"btn btn-default btn-simple-pagination\">\n        next page &#160; >\n    </button>\n</div>"

/***/ }),

/***/ "./web/modern/components/buttons/simple-pagination/simple-pagination.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var pagination_service_1 = __webpack_require__("./shared/services/pagination/pagination.service.ts");
var SimplePaginationComponent = function () {
    function SimplePaginationComponent(paginationService) {
        _classCallCheck(this, SimplePaginationComponent);

        this.paginationService = paginationService;
        this.changePageTrigger = new core_1.EventEmitter();
    }

    _createClass(SimplePaginationComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {}
    }, {
        key: "getCurrentPage",
        value: function getCurrentPage() {
            return this.pageRequest.paging.pageNumber;
        }
    }, {
        key: "changePage",
        value: function changePage(direction) {
            var newPageNumber = this.pageRequest.paging.pageNumber + direction;
            var newPageRequest = this.paginationService.changePage(this.pageRequest, this.totalItems, newPageNumber);
            if (newPageRequest) {
                this.changePageTrigger.emit(newPageRequest);
            }
        }
    }]);

    return SimplePaginationComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Number)], SimplePaginationComponent.prototype, "totalPages", void 0);
__decorate([core_1.Input(), __metadata("design:type", Number)], SimplePaginationComponent.prototype, "totalItems", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], SimplePaginationComponent.prototype, "pageRequest", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], SimplePaginationComponent.prototype, "changePageTrigger", void 0);
SimplePaginationComponent = __decorate([core_1.Component({
    selector: 'simple-pagination',
    template: __webpack_require__("./web/modern/components/buttons/simple-pagination/simple-pagination.html")
}), __metadata("design:paramtypes", [pagination_service_1.PaginationService])], SimplePaginationComponent);
exports.SimplePaginationComponent = SimplePaginationComponent;

/***/ }),

/***/ "./web/modern/components/buttons/subscribe-client-btn/subscribe-client-btn.html":
/***/ (function(module, exports) {

module.exports = "<button class=\"btn btn-default\" [disabled]=\"isDisabled\">\n    <span *ngIf=\"status==='SUBSCRIBED'\">\n    <i class=\"fa fa-envelope-o color-icon\" style=\"position: relative\">\n        <i class=\"fa fa-ban color-icon icon-ban-unsubscribe\"></i>\n    </i>\n    </span>\n    <i class=\"fa fa-envelope-o color-icon\" *ngIf=\"status==='UNSUBSCRIBED'\"></i>\n       {{ btnText }}\n</button>"

/***/ }),

/***/ "./web/modern/components/buttons/subscribe-client-btn/subscribe-client-btn.scss":
/***/ (function(module, exports) {

module.exports = ""

/***/ }),

/***/ "./web/modern/components/buttons/subscribe-client-btn/subscribe-client-btn.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var SubscribeClientBtnComponent = function () {
    function SubscribeClientBtnComponent() {
        _classCallCheck(this, SubscribeClientBtnComponent);
    }

    _createClass(SubscribeClientBtnComponent, [{
        key: "ngOnChanges",
        value: function ngOnChanges() {
            this.btnText = this.status === 'UNSUBSCRIBED' ? 'Subscribe' : 'Unsubscribe';
            if (this.isEmpty) {
                this.btnText = '';
            }
        }
    }]);

    return SubscribeClientBtnComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", String)], SubscribeClientBtnComponent.prototype, "status", void 0);
__decorate([core_1.Input(), __metadata("design:type", Boolean)], SubscribeClientBtnComponent.prototype, "isEmpty", void 0);
__decorate([core_1.Input(), __metadata("design:type", Boolean)], SubscribeClientBtnComponent.prototype, "isDisabled", void 0);
SubscribeClientBtnComponent = __decorate([core_1.Component({
    selector: 'subscribe-client-btn',
    template: __webpack_require__("./web/modern/components/buttons/subscribe-client-btn/subscribe-client-btn.html"),
    styles: [__webpack_require__("./web/modern/components/buttons/subscribe-client-btn/subscribe-client-btn.scss")]
}), __metadata("design:paramtypes", [])], SubscribeClientBtnComponent);
exports.SubscribeClientBtnComponent = SubscribeClientBtnComponent;

/***/ }),

/***/ "./web/modern/components/client/client-card/client-card.html":
/***/ (function(module, exports) {

module.exports = "<article *ngIf=\"client\">\n    <div class=\"main-jobs-cell__title main-jobs-cell__title--bordered flex-wrap\">\n        <client-photo class=\"mr-5 mb-5\" [isPhoto]=\"client.hasImage\" [clientId]=\"client.id\"></client-photo>\n        <h2 class=\"text-break-word text-break\">{{ client.firstName }} {{ client.lastName }}</h2>\n    </div>\n    <div class=\"section-data\">\n        <div class=\"row\" *ngIf=\"client.companyName\">\n            <label class=\"col-md-xs-12 col-sm-4 control-label show-grid\">Company\n                Name:</label><span class=\"col-xs-12 col-sm-8 show-grid text-break\">\n            {{ client.companyName }}</span>\n        </div>\n        <div class=\"row\" *ngIf=\"client.businessNumber\">\n            <label class=\"col-md-xs-12 col-sm-4 control-label show-grid\">{{ businessNumberLabelName }}:</label><span class=\"col-xs-12 col-sm-8 show-grid text-break\">\n            {{ client.businessNumber }}</span>\n        </div>\n        <div class=\"row\">\n            <label class=\"col-md-xs-12 col-sm-4 control-label show-grid\">Phone:</label>\n            <span class=\"col-xs-12 col-sm-8 show-grid text-break\">\n                {{ client.phone }}</span>\n        </div>\n        <div class=\"row\">\n            <label class=\"col-md-xs-12 col-sm-4 control-label show-grid \">Email:</label>\n            <span class=\"col-xs-12 col-sm-8 show-grid text-break\">\n                {{ client.email }}</span>\n        </div>\n        <div class=\"row\">\n            <label class=\"col-md-xs-12 col-sm-4 control-label show-grid\">Street\n                Address:</label> <span class=\"col-xs-12 col-sm-8 show-grid text-break\">\n            {{ client.address }}</span>\n        </div>\n        <div class=\"row\">\n            <label class=\"col-md-xs-12 col-sm-4 control-label show-grid\">Suburb/Town:</label>\n            <span class=\"col-xs-12 col-sm-8 show-grid text-break\">\n                {{ client.town }}</span>\n        </div>\n        <div class=\"row\">\n            <label class=\"col-md-xs-12 col-sm-4 control-label show-grid\">Postcode/Zip:</label>\n            <span class=\"col-xs-12 col-sm-8 show-grid text-break\">\n                {{ client.postcode }}</span>\n        </div>\n        <div class=\"row\">\n            <label class=\"col-md-xs-12 col-sm-4 control-label show-grid\">State:</label>\n            <span class=\"col-xs-12 col-sm-8 show-grid text-break\">\n                {{ client.state }}</span>\n        </div>\n        <div class=\"row\">\n            <label class=\"col-md-xs-12 col-sm-4 control-label show-grid\">Country:</label>\n            <span class=\"col-xs-12 col-sm-8 show-grid text-break\">\n                {{ client.country }}</span>\n        </div>\n        <div class=\"buttons-container row\">\n            <edit-btn [text]=\"'Edit Client'\"\n                      (click)=\"editClient()\"\n                      [isDisabled]=\"button_disable\"\n                      class=\"mr-7\"\n            ></edit-btn>\n\n            <delete-btn (click)=\"deleteClient()\"\n                        [isDisabled]=\"button_disable\"\n                        [text]=\"'Delete client'\"\n            ></delete-btn>\n        </div>\n    </div>\n</article>\n"

/***/ }),

/***/ "./web/modern/components/client/client-card/client-card.scss":
/***/ (function(module, exports) {

module.exports = ".text-position {\n  padding-left: 0; }\n\n.buttons-container {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-align-content: center;\n      -ms-flex-line-pack: center;\n          align-content: center; }\n"

/***/ }),

/***/ "./web/modern/components/client/client-card/client-card.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var settings_1 = __webpack_require__("./shared/services/settings/settings.ts");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var ClientCardComponent = function () {
    function ClientCardComponent(settingsService) {
        _classCallCheck(this, ClientCardComponent);

        this.settingsService = settingsService;
        this.onEdit = new core_1.EventEmitter();
        this.onSubscribe = new core_1.EventEmitter();
        this.onDelete = new core_1.EventEmitter();
        this.unsubscribe = new Subject_1.Subject();
    }

    _createClass(ClientCardComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.subscribeToCustomizeLabelsChange();
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "editClient",
        value: function editClient() {
            this.onEdit.emit();
        }
    }, {
        key: "deleteClient",
        value: function deleteClient() {
            this.onDelete.emit();
        }
    }, {
        key: "subscribeClient",
        value: function subscribeClient() {
            this.onSubscribe.emit();
        }
    }, {
        key: "showSaveOptInModal",
        value: function showSaveOptInModal() {
            $('#saveOptinConsentModal').modal('show');
        }
    }, {
        key: "subscribeToCustomizeLabelsChange",
        value: function subscribeToCustomizeLabelsChange() {
            var _this = this;

            this.settingsService.customizeLabelsObservable.pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (customizeLabels) {
                return _this.businessNumberLabelName = customizeLabels.businessNumberLabel;
            });
        }
    }]);

    return ClientCardComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], ClientCardComponent.prototype, "client", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], ClientCardComponent.prototype, "type", void 0);
__decorate([core_1.Input(), __metadata("design:type", Boolean)], ClientCardComponent.prototype, "gdprEnabled", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], ClientCardComponent.prototype, "onEdit", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], ClientCardComponent.prototype, "onSubscribe", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], ClientCardComponent.prototype, "onDelete", void 0);
ClientCardComponent = __decorate([core_1.Component({
    selector: 'client-card',
    template: __webpack_require__("./web/modern/components/client/client-card/client-card.html"),
    styles: [__webpack_require__("./web/modern/components/client/client-card/client-card.scss")]
}), __metadata("design:paramtypes", [settings_1.SettingsProvider])], ClientCardComponent);
exports.ClientCardComponent = ClientCardComponent;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./web/modern/components/client/client-photo/client-photo.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"client-photo\"\n     [ngClass]=\"{'fi fi-clients empty': !isPhoto}\"\n     [ngStyle]=\"{'background-image': isPhoto ?  clientImg : 'none'}\">\n    <div class=\"hover\" (click)=\"inputFile.click()\">\n        <div class=\"hover-effect\"></div>\n        <div class=\"hover-text\">\n            <p>UPLOAD PHOTO<p>\n            <p>Max 5mb</p>\n        </div>\n    </div>\n    <input #inputFile\n           class=\"hide\"\n           type=\"file\"\n           (change)=\"getFile($event)\"\n    />\n</div>"

/***/ }),

/***/ "./web/modern/components/client/client-photo/client-photo.scss":
/***/ (function(module, exports) {

module.exports = ""

/***/ }),

/***/ "./web/modern/components/client/client-photo/client-photo.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var client_photo_1 = __webpack_require__("./shared/components/base/client/client-photo/client-photo.ts");
var ClientPhotoWebComponent = function (_client_photo_1$Clien) {
    _inherits(ClientPhotoWebComponent, _client_photo_1$Clien);

    function ClientPhotoWebComponent() {
        _classCallCheck(this, ClientPhotoWebComponent);

        return _possibleConstructorReturn(this, (ClientPhotoWebComponent.__proto__ || Object.getPrototypeOf(ClientPhotoWebComponent)).apply(this, arguments));
    }

    _createClass(ClientPhotoWebComponent, [{
        key: "showModal",
        value: function showModal() {
            $('#uploadPhotoModal').modal('show');
        }
    }]);

    return ClientPhotoWebComponent;
}(client_photo_1.ClientPhotoComponent);
ClientPhotoWebComponent = __decorate([core_1.Component({
    selector: 'client-photo',
    template: __webpack_require__("./web/modern/components/client/client-photo/client-photo.html"),
    styles: [__webpack_require__("./web/modern/components/client/client-photo/client-photo.scss")]
})], ClientPhotoWebComponent);
exports.ClientPhotoWebComponent = ClientPhotoWebComponent;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./web/modern/components/client/client-subscribe-info/client-subscribe-info.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"status-info\">\n    <span class=\"capitalize\">{{ client.status| lowercase }}</span>\n    on {{ client.statusDate | timeFilter: \"long\" }}\n    <span *ngIf=\"client.statusSource === 'BY_USER'\">by you</span>\n    <span *ngIf=\"client.statusSource === 'BY_CLIENT'\">by client</span>\n    <span *ngIf=\"client.statusSource === 'CONTACT_FORM'\">via Contact Form</span>\n</div>"

/***/ }),

/***/ "./web/modern/components/client/client-subscribe-info/client-subscribe-info.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var client_subscribe_info_1 = __webpack_require__("./shared/components/base/client/client-subscribe-info/client-subscribe-info.ts");
var ClientSubscribeInfoWebComponent = function (_client_subscribe_inf) {
    _inherits(ClientSubscribeInfoWebComponent, _client_subscribe_inf);

    function ClientSubscribeInfoWebComponent() {
        _classCallCheck(this, ClientSubscribeInfoWebComponent);

        return _possibleConstructorReturn(this, (ClientSubscribeInfoWebComponent.__proto__ || Object.getPrototypeOf(ClientSubscribeInfoWebComponent)).apply(this, arguments));
    }

    return ClientSubscribeInfoWebComponent;
}(client_subscribe_info_1.ClientSubscribeInfoComponent);
ClientSubscribeInfoWebComponent = __decorate([core_1.Component({
    selector: 'client-subscribe-info',
    template: __webpack_require__("./web/modern/components/client/client-subscribe-info/client-subscribe-info.html")
})], ClientSubscribeInfoWebComponent);
exports.ClientSubscribeInfoWebComponent = ClientSubscribeInfoWebComponent;

/***/ }),

/***/ "./web/modern/components/client/consent-list/consent-list.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"consent-list\">\n    <div class=\"mailList\">\n        <div class=\"table-responsive\">\n            <table class=\"table table-strip table-mail-status bottom-bordered mb-0\">\n                <thead class=\"client_overview_head\">\n                <tr class=\"invoice-thead\">\n                    <th>\n                        <b>Date</b>\n                    </th>\n                    <th>\n                        <b>Consent</b>\n                    </th>\n                    <th>\n                        <b>Method</b>\n                    </th>\n                    <th class=\"w-40\"></th>\n                </tr>\n                </thead>\n                <tbody>\n                <tr *ngFor=\"let consent of consents\" (click)=\"goToSource(consent, $event)\" [class.pointer]=\"consent.method === consentMethods.BY_CONTRACT || consent.method === consentMethods.BY_QUESTIONNAIRE\">\n                    <td class=\"text-nowrap\">{{ consent.createdAt | timeFilter: 'medium' }}</td>\n                    <td><i>{{ consent.text }}</i></td>\n                    <td>\n                        <div>{{ consent.methodToShow }}</div>\n                    </td>\n                    <td>\n                        <delete-btn [isDisabled]=\"consent.method === consentMethods.BY_CONTRACT || consent.method === consentMethods.BY_QUESTIONNAIRE\"\n                                    [isEmpty]=\"true\"\n                                    (clicked)=\"deleteConsent($event, consent.id)\"\n                        ></delete-btn>\n                    </td>\n                </tr>\n                </tbody>\n            </table>\n        </div>\n    </div>\n</section>"

/***/ }),

/***/ "./web/modern/components/client/consent-list/consent-list.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var common_1 = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
var consent_list_1 = __webpack_require__("./shared/components/base/client/consent-list/consent-list.ts");
var consent_list_model_1 = __webpack_require__("./shared/components/base/client/consent-list/consent-list.model.ts");
var ConsentListWebComponent = function (_consent_list_1$Conse) {
    _inherits(ConsentListWebComponent, _consent_list_1$Conse);

    function ConsentListWebComponent(location) {
        _classCallCheck(this, ConsentListWebComponent);

        var _this = _possibleConstructorReturn(this, (ConsentListWebComponent.__proto__ || Object.getPrototypeOf(ConsentListWebComponent)).call(this));

        _this.location = location;
        _this.consentMethods = consent_list_model_1.ConsentMethods;
        return _this;
    }

    _createClass(ConsentListWebComponent, [{
        key: "goToSource",
        value: function goToSource(consent, event) {
            if (event.path[1].className.includes('btn')) {} else {
                var contractId = consent.contractId,
                    jobId = consent.jobId,
                    questionnaireId = consent.questionnaireId,
                    isLead = consent.isLead,
                    leadId = consent.leadId;

                switch (consent.method) {
                    case consent_list_model_1.ConsentMethods.BY_CONTRACT:
                        if (contractId && jobId && !isLead) {
                            this.location.go("/jobs/view/" + jobId + "/contracts/" + contractId);
                        } else if (contractId && jobId && isLead) {
                            this.location.go("/leads/view/" + leadId + "/contracts/" + contractId);
                        }
                        break;
                    case consent_list_model_1.ConsentMethods.BY_QUESTIONNAIRE:
                        if (questionnaireId && jobId && !isLead) {
                            this.location.go("/jobs/view/" + jobId + "/questionnaires/" + questionnaireId);
                        } else if (questionnaireId && jobId && isLead) {
                            this.location.go("/leads/view/" + leadId + "/questionnaires/" + questionnaireId);
                        }
                        break;
                    default:
                }
            }
        }
    }]);

    return ConsentListWebComponent;
}(consent_list_1.ConsentListComponent);
ConsentListWebComponent = __decorate([core_1.Component({
    selector: 'consent-list',
    template: __webpack_require__("./web/modern/components/client/consent-list/consent-list.html")
}), __metadata("design:paramtypes", [common_1.Location])], ConsentListWebComponent);
exports.ConsentListWebComponent = ConsentListWebComponent;

/***/ }),

/***/ "./web/modern/components/client/enable-clients-opt-in/enable-clients-opt-in.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"flex-row mt-25\">\n    <div class=\"checkbox-squared\">\n        <input type=\"checkbox\" id=\"optIn\" [checked]=\"showOtpInConsent\" (change)=\"changeOptStatus(showOtpInConsent)\"/>\n        <label for=\"optIn\"></label>\n    </div>\n    <div class=\"description\">\n        <h4 class=\"mt-2\">Enable clients to opt-in and provide consent*</h4>\n        <p class=\"mb-20\" style=\"font-size: 13px\">*You will not need to seek consent form your clients if you are\n            processing their data in order to perform a contract e.g. providing your services to them.</p>\n    </div>\n</div>\n\n\n\n"

/***/ }),

/***/ "./web/modern/components/client/enable-clients-opt-in/enable-clients-opt-in.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var EnableClientsOptInComponent = function () {
    function EnableClientsOptInComponent() {
        _classCallCheck(this, EnableClientsOptInComponent);

        this.showOptIn = new core_1.EventEmitter();
    }

    _createClass(EnableClientsOptInComponent, [{
        key: "changeOptStatus",
        value: function changeOptStatus() {
            this.showOtpInConsent = !this.showOtpInConsent;
            this.showOptIn.emit(this.showOtpInConsent);
        }
    }]);

    return EnableClientsOptInComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Boolean)], EnableClientsOptInComponent.prototype, "showOtpInConsent", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], EnableClientsOptInComponent.prototype, "id", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], EnableClientsOptInComponent.prototype, "showOptIn", void 0);
EnableClientsOptInComponent = __decorate([core_1.Component({
    selector: 'enable-clients-opt-in',
    template: __webpack_require__("./web/modern/components/client/enable-clients-opt-in/enable-clients-opt-in.html")
}), __metadata("design:paramtypes", [])], EnableClientsOptInComponent);
exports.EnableClientsOptInComponent = EnableClientsOptInComponent;

/***/ }),

/***/ "./web/modern/components/client/job-client/job-client.html":
/***/ (function(module, exports) {

module.exports = "<section *ngIf=\"client\" class=\"client-section\" (click)=\"handleClick($event, client.id)\">\n    <div class=\"flex-row\">\n        <div class=\"mr-15 flex-basis-0\">\n            <h4 class=\"f-s-15 mb-15\" *ngIf=\"client.companyName\">\n                <span class=\"not-clickable\">{{ client.companyName }}</span>\n            </h4>\n            <h4 class=\"f-s-15 mb-0\">\n                <span class=\"not-clickable\">\n                {{ client.firstName + \" \" }}\n                {{ client.lastName ? client.lastName : '' }}\n                </span>\n            </h4>\n            <p class=\"mb-15\"><span class=\"not-clickable\">{{ type === 'primaryContact' ? ' (Primary) ' : ' (Secondary) ' }}</span></p>\n            <p class=\"text-break\"><span class=\"not-clickable\">{{ client.phone }}</span></p>\n            <p class=\"text-break\"><span class=\"not-clickable\">{{ client.email }}</span></p>\n        </div>\n        <client-photo class=\"not-clickable\" [isPhoto]=\"client.hasImage\" [clientId]=\"client.id\"></client-photo>\n    </div>\n    <div class=\"mb-10\">\n                <hr class=\"mt-15 mb-15\">\n                <p class=\"text-break\"><span class=\"not-clickable\">{{ client.address }}</span></p>\n                <p class=\"text-break\"><span class=\"not-clickable\">{{ client.town }}</span></p>\n                <p class=\"text-break\"><span class=\"not-clickable\">{{ client.postcode }}</span></p>\n                <p class=\"text-break\"><span class=\"not-clickable\">{{ client.state }}</span></p>\n                <p class=\"text-break\"><span class=\"not-clickable\">{{ client.country }}</span></p>\n    </div>\n\n    <div class=\"flex-row mt-5\">\n        <edit-btn [text]=\"'Edit Client'\"\n                  (click)=\"editClient()\"\n                  [isDisabled]=\"button_disable\"\n                  class=\"mr-7 not-clickable\"\n        ></edit-btn>\n        <send-btn *ngIf=\"!archived\"\n                  [text]=\"'Send Email'\"\n                  (click)=\"sendEmail()\"\n                  [isDisabled]=\"button_disable\"\n                  class=\"not-clickable\"\n        ></send-btn>\n    </div>\n</section>"

/***/ }),

/***/ "./web/modern/components/client/job-client/job-client.scss":
/***/ (function(module, exports) {

module.exports = ".client-section {\n  cursor: pointer; }\n  .client-section p,\n  .client-section h4,\n  .client-section hr {\n    margin-bottom: 0; }\n  .client-section span {\n    cursor: default; }\n  .client-section h4 > span {\n    word-break: break-word; }\n"

/***/ }),

/***/ "./web/modern/components/client/job-client/job-client.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var common_1 = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
var JobClientComponent = function () {
    function JobClientComponent(location) {
        _classCallCheck(this, JobClientComponent);

        this.location = location;
        this.onEdit = new core_1.EventEmitter();
        this.onSend = new core_1.EventEmitter();
        this.onClientUpdate = new core_1.EventEmitter();
    }

    _createClass(JobClientComponent, [{
        key: "editClient",
        value: function editClient() {
            this.onEdit.emit();
        }
    }, {
        key: "sendEmail",
        value: function sendEmail() {
            this.onSend.emit(this.client);
        }
    }, {
        key: "handleClick",
        value: function handleClick(e, clientId) {
            var clickedEl = e.target;
            while (!clickedEl.className.includes('not-clickable') && !clickedEl.className.includes('client-section')) {
                clickedEl = clickedEl.parentNode;
            }
            if (!clickedEl.className.includes('not-clickable')) {
                this.location.go("/clients/client" + clientId);
                e.stopImmediatePropagation();
            }
        }
    }]);

    return JobClientComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], JobClientComponent.prototype, "client", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], JobClientComponent.prototype, "type", void 0);
__decorate([core_1.Input(), __metadata("design:type", Boolean)], JobClientComponent.prototype, "archived", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], JobClientComponent.prototype, "onEdit", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], JobClientComponent.prototype, "onSend", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], JobClientComponent.prototype, "onClientUpdate", void 0);
JobClientComponent = __decorate([core_1.Component({
    selector: 'job-client',
    template: __webpack_require__("./web/modern/components/client/job-client/job-client.html"),
    styles: [__webpack_require__("./web/modern/components/client/job-client/job-client.scss")]
}), __metadata("design:paramtypes", [common_1.Location])], JobClientComponent);
exports.JobClientComponent = JobClientComponent;

/***/ }),

/***/ "./web/modern/components/client/modals/resubscribe-client-modal/resubscribe-client-modal.html":
/***/ (function(module, exports) {

module.exports = "<section>\n    <div id=\"resubscribeClientModal\" class=\"modal modal-center modal-resubscribe-client fade\" data-backdrop=\"false\"\n         data-keyboard=\"false\">\n        <div class=\"modal-dialog w-max-600\">\n            <div class=\"modal-content\">\n                <div class=\"modal-body fs-16\">\n                    <p class=\"f-s-16 mt-10 mb-5 text-center\">\n                        You are about to contact a client <span *ngIf=\"client\">({{ client.email }})</span>\n                        who has unsubscribed! Please resubscribe this client first before sending an email.\n                    </p>\n                </div>\n                <div class=\"modal-footer modal-foot pb-20 flex-row flex-just-center\">\n                    <button type=\"button\" class=\"btn btn-success btn-submit w-min-150\"\n                            (click)=\"resubscribeClient()\"\n                            [disabled]=\"button_disable\"\n                            spinning-wheel is-spinning-wheel-active=\"isSubscribeClientSpinningWheelActive\"\n                    >Subscribe\n                    </button>\n                    <button type=\"button\" class=\"btn btn-lg btn-default btn-grey-dark ml-10 w-min-140\"\n                            [disabled]=\"button_disable\"\n                            (click)=\"switchModal(false)\"\n                    >Cancel\n                    </button>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class='modal-resubscribe-client__background'></div>\n</section>"

/***/ }),

/***/ "./web/modern/components/client/modals/resubscribe-client-modal/resubscribe-client-modal.scss":
/***/ (function(module, exports) {

module.exports = ".modal-resubscribe-client {\n  z-index: 99999999; }\n  .modal-resubscribe-client__background {\n    display: none;\n    position: fixed;\n    z-index: 99999998;\n    background: rgba(0, 0, 0, 0.5);\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    width: 100vw;\n    height: 100vh;\n    cursor: default; }\n  .modal-resubscribe-client.in + .modal-resubscribe-client__background {\n    display: block; }\n"

/***/ }),

/***/ "./web/modern/components/client/modals/resubscribe-client-modal/resubscribe-client-modal.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var resubscribe_client_modal_1 = __webpack_require__("./web/modern/components/client/modals/resubscribe-client-modal/resubscribe-client-modal/resubscribe-client-modal.ts");
var ResubscribeClientModalWebComponent = function (_resubscribe_client_m) {
    _inherits(ResubscribeClientModalWebComponent, _resubscribe_client_m);

    function ResubscribeClientModalWebComponent() {
        _classCallCheck(this, ResubscribeClientModalWebComponent);

        return _possibleConstructorReturn(this, (ResubscribeClientModalWebComponent.__proto__ || Object.getPrototypeOf(ResubscribeClientModalWebComponent)).apply(this, arguments));
    }

    _createClass(ResubscribeClientModalWebComponent, [{
        key: "switchModal",
        value: function switchModal(isSuccess) {
            var self = this;
            $('#resubscribeClientModal.in').modal('hide').on('hidden.bs.modal', function () {
                var notResubscribeModals = $('.modal.in:not(#resubscribeClientModal)');
                if ($('.in.modal').length > 0) {
                    document.body.classList.add('modal-open');
                    notResubscribeModals.children('.modal-dialog').css({ overflow: '' });
                }
                isSuccess ? self.successResubscribeClient.emit() : self.cancelResubscribeClient.emit();
                $(this).off('hidden.bs.modal');
                notResubscribeModals.children('.modal-dialog').css({ overflow: '' });
            });
        }
    }]);

    return ResubscribeClientModalWebComponent;
}(resubscribe_client_modal_1.ResubscribeClientModalComponent);
ResubscribeClientModalWebComponent = __decorate([core_1.Component({
    selector: 'resubscribe-client-modal',
    template: __webpack_require__("./web/modern/components/client/modals/resubscribe-client-modal/resubscribe-client-modal.html"),
    styles: [__webpack_require__("./web/modern/components/client/modals/resubscribe-client-modal/resubscribe-client-modal.scss")]
})], ResubscribeClientModalWebComponent);
exports.ResubscribeClientModalWebComponent = ResubscribeClientModalWebComponent;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./web/modern/components/client/modals/resubscribe-client-modal/resubscribe-client-modal/resubscribe-client-modal.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var clients_data_service_1 = __webpack_require__("./shared/services/client/clients.data.service.ts");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var email_service_1 = __webpack_require__("./shared/services/email/email-service/email.service.ts");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var ResubscribeClientModalComponent = function () {
    function ResubscribeClientModalComponent(clientsDataService, messageService, emailService) {
        _classCallCheck(this, ResubscribeClientModalComponent);

        this.clientsDataService = clientsDataService;
        this.messageService = messageService;
        this.emailService = emailService;
        this.successResubscribeClient = new core_1.EventEmitter();
        this.cancelResubscribeClient = new core_1.EventEmitter();
        this.unsubscribe = new Subject_1.Subject();
    }

    _createClass(ResubscribeClientModalComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            var _this = this;

            this.emailService.clientToCheckSubscription$.takeUntil(this.unsubscribe).subscribe(function (client) {
                _this.client = client;
            });
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.emailService.emitClientToCheckSubscription(null);
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "resubscribeClient",
        value: function resubscribeClient() {
            var _this2 = this;

            this.button_disable = true;
            this.clientsDataService.changeClientSubscription(this.client).finally(function () {
                return _this2.button_disable = false;
            }).subscribe(function () {
                return _this2.successResubscribeClientCallback();
            }, function (error) {
                return _this2.messageService.showDefaultErrorMessage(error);
            });
        }
    }, {
        key: "successResubscribeClientCallback",
        value: function successResubscribeClientCallback() {
            this.messageService.showToaster('s_0', 'subscribed');
            this.switchModal(true);
        }
    }, {
        key: "switchModal",
        value: function switchModal(isSuccess) {}
    }]);

    return ResubscribeClientModalComponent;
}();
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], ResubscribeClientModalComponent.prototype, "successResubscribeClient", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], ResubscribeClientModalComponent.prototype, "cancelResubscribeClient", void 0);
ResubscribeClientModalComponent = __decorate([core_1.Component({
    selector: 'resubscribe-client-modal',
    template: ''
}), __metadata("design:paramtypes", [clients_data_service_1.ClientsDataServiceProvider, message_service_1.MessageService, email_service_1.EmailServiceProvider])], ResubscribeClientModalComponent);
exports.ResubscribeClientModalComponent = ResubscribeClientModalComponent;

/***/ }),

/***/ "./web/modern/components/client/modals/upload-photo-modal/upload-photo-modal.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"uploadPhotoModal\" class=\"modal modal-center fade\" data-backdrop=\"static\" data-keyboard=\"false\">\n    <div class=\"modal-dialog w-max-470\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h3 class=\"modal-title\">Upload Photo</h3>\n                <close-btn></close-btn>\n            </div>\n            <div class=\"modal-body flex-row\">\n                <img-cropper #cropper\n                             [image]=\"data\"\n                             [settings]=\"cropperSettings\"\n                             class=\"mr-30\"\n                ></img-cropper>\n                <div *ngIf=\"data.image\">\n                    <img [src]=\"data.image\"\n                         [width]=\"cropperSettings.croppedWidth\"\n                         [height]=\"cropperSettings.croppedHeight\"\n                         class=\"circle\">\n                </div>\n            </div>\n            <div class=\"modal-footer modal-foot flex-row flex-just-center\">\n                <button [disabled]=\"button_disable\"\n                        class=\"btn btn-success btn-submit mr-15 mt-0 w-min-150\"\n                        (click)=\"savePhoto()\"\n                        spinning-wheel [is-spinning-wheel-active]=\"button_disable\"\n                >Crop & Save</button>\n                <button class=\"btn btn-grey-light btn-lg w-min-140 mt-0\" data-dismiss=\"modal\">Cancel</button>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "./web/modern/components/client/modals/upload-photo-modal/upload-photo-modal.scss":
/***/ (function(module, exports) {

module.exports = ".circle {\n  width: 80px;\n  height: 80px;\n  border-radius: 50%; }\n"

/***/ }),

/***/ "./web/modern/components/client/modals/upload-photo-modal/upload-photo-modal.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var upload_photo_modal_1 = __webpack_require__("./shared/components/base/client/modals/upload-photo-modal/upload-photo-modal.ts");
var UploadPhotoModalWebComponent = function (_upload_photo_modal_) {
    _inherits(UploadPhotoModalWebComponent, _upload_photo_modal_);

    function UploadPhotoModalWebComponent() {
        _classCallCheck(this, UploadPhotoModalWebComponent);

        return _possibleConstructorReturn(this, (UploadPhotoModalWebComponent.__proto__ || Object.getPrototypeOf(UploadPhotoModalWebComponent)).apply(this, arguments));
    }

    _createClass(UploadPhotoModalWebComponent, [{
        key: "hideModal",
        value: function hideModal() {
            $('#uploadPhotoModal').modal('hide');
        }
    }]);

    return UploadPhotoModalWebComponent;
}(upload_photo_modal_1.UploadPhotoModalComponent);
UploadPhotoModalWebComponent = __decorate([core_1.Component({
    selector: 'upload-photo-modal',
    template: __webpack_require__("./web/modern/components/client/modals/upload-photo-modal/upload-photo-modal.html"),
    styles: [__webpack_require__("./web/modern/components/client/modals/upload-photo-modal/upload-photo-modal.scss")]
})], UploadPhotoModalWebComponent);
exports.UploadPhotoModalWebComponent = UploadPhotoModalWebComponent;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./web/modern/components/common/alert-modal/alert-modal.component.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-body content-centered\">\n    <h3 class=\"title\">{{ title }}</h3>\n    <p>{{ message }}</p>\n\n    <button (click)=\"closeModal()\" class=\"btn btn-default\">Okay</button>\n</div>\n"

/***/ }),

/***/ "./web/modern/components/common/alert-modal/alert-modal.component.scss":
/***/ (function(module, exports) {

module.exports = ".button-set:last-child {\n  margin-right: 0 !important; }\n"

/***/ }),

/***/ "./web/modern/components/common/alert-modal/alert-modal.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var ng_bootstrap_1 = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/index.js");
var AlertModalComponent = function () {
    function AlertModalComponent(ngbActiveModal) {
        _classCallCheck(this, AlertModalComponent);

        this.ngbActiveModal = ngbActiveModal;
    }

    _createClass(AlertModalComponent, [{
        key: "closeModal",
        value: function closeModal() {
            this.ngbActiveModal.close();
        }
    }]);

    return AlertModalComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", String)], AlertModalComponent.prototype, "title", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], AlertModalComponent.prototype, "message", void 0);
AlertModalComponent = __decorate([core_1.Component({
    selector: 'alert-modal',
    template: __webpack_require__("./web/modern/components/common/alert-modal/alert-modal.component.html"),
    styles: [__webpack_require__("./web/modern/components/common/alert-modal/alert-modal.component.scss")]
}), __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal])], AlertModalComponent);
exports.AlertModalComponent = AlertModalComponent;

/***/ }),

/***/ "./web/modern/components/common/buttons-handler/buttons-handler.component.html":
/***/ (function(module, exports) {

module.exports = "<div *ngIf=\"this.actionList.length\" class=\"button-set\">\n    <ng-container *ngFor=\"let action of actionList\">\n        <button (click)=\"performFrameAction(actions[action], action)\"\n                *ngIf=\"actions[action].method === 'FRAME'\"\n                class=\"btn btn-sm btn-success btn-rounded mr-8\">\n            {{ actions[action].actionName }}\n        </button>\n        <button (click)=\"performAlertAction(actions[action], action)\"\n                *ngIf=\"actions[action].method === 'ALERT_MODAL'\"\n                class=\"btn btn-sm btn-success btn-rounded mr-8\">\n            {{ actions[action].actionName }}\n        </button>\n        <button *ngIf=\"!actions[action].method\"\n                [disabled]=\"true\"\n                class=\"btn btn-sm btn-default btn-squared mr-8\">\n            {{ actions[action].actionName }}\n        </button>\n    </ng-container>\n</div>\n"

/***/ }),

/***/ "./web/modern/components/common/buttons-handler/buttons-handler.component.scss":
/***/ (function(module, exports) {

module.exports = ".button-set:last-child {\n  margin-right: 0 !important; }\n"

/***/ }),

/***/ "./web/modern/components/common/buttons-handler/buttons-handler.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var iframe_service_1 = __webpack_require__("./shared/services/helpers/iframe-service/iframe.service.ts");
var alert_modal_component_1 = __webpack_require__("./web/modern/components/common/alert-modal/alert-modal.component.ts");
var ButtonsHandlerComponent = function () {
    function ButtonsHandlerComponent(snModalService, iframeService) {
        _classCallCheck(this, ButtonsHandlerComponent);

        this.snModalService = snModalService;
        this.iframeService = iframeService;
        this.onBtnClick = new core_1.EventEmitter();
        this.onActionResolve = new core_1.EventEmitter();
        this.actionList = [];
    }

    _createClass(ButtonsHandlerComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.createActionList(this.actions);
        }
    }, {
        key: "createActionList",
        value: function createActionList(actions) {
            this.actionList = Object.keys(actions);
        }
    }, {
        key: "performAlertAction",
        value: function performAlertAction(action, type) {
            var _this = this;

            this.onBtnClick.emit({ action: action, type: type });
            this.modalRef = this.snModalService.openModal(alert_modal_component_1.AlertModalComponent, {
                windowClass: 'ng-bootstrap-modal modal-visible modal-narrow'
            });
            this.modalRef.componentInstance.title = action.alertMessage.title;
            this.modalRef.componentInstance.message = action.alertMessage.message;
            this.modalRef.result.then(function (data) {
                return _this.onActionResolve.emit({ action: action, type: type, payload: data });
            }).catch();
        }
    }, {
        key: "performFrameAction",
        value: function performFrameAction(action, type) {
            this.onBtnClick.emit({ action: action, type: type });
            this.iframeService.setUrlIframe(action.url);
        }
    }]);

    return ButtonsHandlerComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], ButtonsHandlerComponent.prototype, "actions", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], ButtonsHandlerComponent.prototype, "onBtnClick", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], ButtonsHandlerComponent.prototype, "onActionResolve", void 0);
ButtonsHandlerComponent = __decorate([core_1.Component({
    selector: 'buttons-handler',
    template: __webpack_require__("./web/modern/components/common/buttons-handler/buttons-handler.component.html"),
    styles: [__webpack_require__("./web/modern/components/common/buttons-handler/buttons-handler.component.scss")]
}), __metadata("design:paramtypes", [snModal_service_1.SNModalService, iframe_service_1.IframeService])], ButtonsHandlerComponent);
exports.ButtonsHandlerComponent = ButtonsHandlerComponent;

/***/ }),

/***/ "./web/modern/components/common/collapse-panel/collapse-panel.component.html":
/***/ (function(module, exports) {

module.exports = "<div *ngIf=\"!noCollapsing; else elseBlock\" class=\"panel-wrapper\">\n  <div class=\"panel panel-default\">\n    <h4 class=\"panel-title\">\n      <a type=\"button\" (click)=\"saveExpanded($event)\" class=\"{{isOpen ? '' : 'collapsed'}}\"\n        data-target=\"#{{title}}\" [attr.aria-controls]=\"title\"\n        [attr.aria-expanded]=\"isOpen\">\n        <div class=\"panel-heading\">\n          {{ title.toLowerCase() | titlecase }}\n        </div>\n      </a>\n    </h4>\n    <div id=\"{{title}}\"\n      [ngClass]=\"isOpen ? 'show-accordion':'hide-accordion'\"\n      [attr.aria-expanded]=\"isOpen\">\n      <div class=\"panel-body p-0\">\n        <ng-container *ngTemplateOutlet=\"insertedContent\"></ng-container>\n      </div>\n    </div>\n  </div>\n</div>\n<ng-container #elseBlock *ngTemplateOutlet=\"insertedContent\"></ng-container>\n\n<ng-template #insertedContent>\n  <ng-content></ng-content>\n</ng-template>"

/***/ }),

/***/ "./web/modern/components/common/collapse-panel/collapse-panel.component.scss":
/***/ (function(module, exports) {

module.exports = ".panel-wrapper {\n  border-top: 1px solid #d7d7d7; }\n  .panel-wrapper .panel {\n    box-shadow: none;\n    margin-bottom: 0; }\n    .panel-wrapper .panel .panel-title {\n      border: 1px solid #d7d7d7;\n      border-top: none; }\n      .panel-wrapper .panel .panel-title > a {\n        -webkit-appearance: none;\n           -moz-appearance: none;\n                appearance: none;\n        cursor: pointer; }\n      .panel-wrapper .panel .panel-title > a .panel-heading:before {\n        float: right !important;\n        font-family: FontAwesome;\n        color: #a9a9a9;\n        content: '\\f068';\n        padding-right: 5px; }\n      .panel-wrapper .panel .panel-title > a.collapsed .panel-heading:before {\n        float: right !important;\n        color: #a9a9a9;\n        content: '\\f067'; }\n      .panel-wrapper .panel .panel-title > a:hover,\n      .panel-wrapper .panel .panel-title > a:active,\n      .panel-wrapper .panel .panel-title > a:focus {\n        text-decoration: none; }\n    .panel-wrapper .panel .show-accordion {\n      overflow-y: hidden;\n      max-height: 1000px;\n      height: auto;\n      -webkit-transition: all 1s ease-in-out;\n      transition: all 1s ease-in-out; }\n    .panel-wrapper .panel .hide-accordion {\n      overflow-y: hidden;\n      height: auto;\n      -webkit-transition: all 1s ease-in-out;\n      transition: all 1s ease-in-out;\n      max-height: 0; }\n    .panel-wrapper .panel .panel-body {\n      border-top: 0 !important; }\n"

/***/ }),

/***/ "./web/modern/components/common/collapse-panel/collapse-panel.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var CollapsePanelComponent = function () {
    function CollapsePanelComponent() {
        _classCallCheck(this, CollapsePanelComponent);

        this.isOpen = true;
        this.toggle = new core_1.EventEmitter();
    }

    _createClass(CollapsePanelComponent, [{
        key: "saveExpanded",
        value: function saveExpanded(event) {
            if (this._isToggle) {
                this.toggle.emit(event);
            } else {
                this.isOpen = !this.isOpen;
            }
        }
    }, {
        key: "_isToggle",
        get: function get() {
            return this.toggle && this.toggle.observers.length > 0;
        }
    }]);

    return CollapsePanelComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], CollapsePanelComponent.prototype, "title", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], CollapsePanelComponent.prototype, "isOpen", void 0);
__decorate([core_1.Input(), __metadata("design:type", Boolean)], CollapsePanelComponent.prototype, "noCollapsing", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], CollapsePanelComponent.prototype, "toggle", void 0);
CollapsePanelComponent = __decorate([core_1.Component({
    selector: 'collapse-panel',
    template: __webpack_require__("./web/modern/components/common/collapse-panel/collapse-panel.component.html"),
    styles: [__webpack_require__("./web/modern/components/common/collapse-panel/collapse-panel.component.scss")]
})], CollapsePanelComponent);
exports.CollapsePanelComponent = CollapsePanelComponent;

/***/ }),

/***/ "./web/modern/components/common/confirm-general-modal/confirm-general-modal.component.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-body flex-column flex-align-center\">\n    <h2 class=\"text-align-center\" *ngIf=\"title\">{{ title }}</h2>\n    <ng-container *ngIf=\"text\">\n        <h3 class=\"text-align-center main-confirm-modal-text mt-10\" *ngIf=\"htmlText\" [innerHTML]=\"text\"></h3>\n        <h3 class=\"text-align-center main-confirm-modal-text mt-10\" *ngIf=\"!htmlText\">{{ text }}</h3>\n    </ng-container>\n\n    <div class=\"flex-box text-align-center mt-10 mb-5\" [ngClass]=\"{'flex-column': columnButtons}\">\n        <button *ngFor=\"let button of buttons; let i = index\"\n                class=\"btn btn-{{button.size}} btn-{{button.color}} btn-space\"\n                (click)=\"closeWithAction(button.action)\">{{ button.text }}\n        </button>\n    </div>\n</div>"

/***/ }),

/***/ "./web/modern/components/common/confirm-general-modal/confirm-general-modal.component.scss":
/***/ (function(module, exports) {

module.exports = ".modal-body {\n  padding: 25px !important; }\n  .modal-body h2 {\n    font-size: 22px; }\n  .modal-body .main-confirm-modal-text {\n    font-weight: 400;\n    line-height: 1.5; }\n  .modal-body .btn-space {\n    margin: 7px 7px; }\n"

/***/ }),

/***/ "./web/modern/components/common/confirm-general-modal/confirm-general-modal.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var ng_bootstrap_1 = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/index.js");
var ConfirmGeneralModalComponent = function () {
    function ConfirmGeneralModalComponent(ngbActiveModal) {
        _classCallCheck(this, ConfirmGeneralModalComponent);

        this.ngbActiveModal = ngbActiveModal;
    }

    _createClass(ConfirmGeneralModalComponent, [{
        key: "closeWithAction",
        value: function closeWithAction(action) {
            this.ngbActiveModal.close(action);
        }
    }]);

    return ConfirmGeneralModalComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", String)], ConfirmGeneralModalComponent.prototype, "title", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], ConfirmGeneralModalComponent.prototype, "htmlText", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], ConfirmGeneralModalComponent.prototype, "text", void 0);
__decorate([core_1.Input(), __metadata("design:type", Array)], ConfirmGeneralModalComponent.prototype, "buttons", void 0);
__decorate([core_1.Input(), __metadata("design:type", Boolean)], ConfirmGeneralModalComponent.prototype, "columnButtons", void 0);
ConfirmGeneralModalComponent = __decorate([core_1.Component({
    selector: 'confirm-general-modal',
    template: __webpack_require__("./web/modern/components/common/confirm-general-modal/confirm-general-modal.component.html"),
    styles: [__webpack_require__("./web/modern/components/common/confirm-general-modal/confirm-general-modal.component.scss")]
}), __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal])], ConfirmGeneralModalComponent);
exports.ConfirmGeneralModalComponent = ConfirmGeneralModalComponent;

/***/ }),

/***/ "./web/modern/components/common/double-booking/double-booking-details/double-booking-details-modal.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n    <button class=\"close\" (click)=\"onDismiss()\">&times;</button>\n    <h3 class=\"modal-title\">{{ doubleBookingInfo.titleText }}</h3>\n</div>\n\n<div class=\"modal-body\">\n    <div *ngFor=\"let company of companiesList; let i = index\" [class.mt-20]=\"i !== 0\">\n        <h3 class=\"mt-0 mb-20\" *ngIf=\"!(companiesList.length === 1 && doubleBookingInfo.events[company][0].company.currentBrand)\">{{ company }}</h3>\n        <div *ngFor=\"let event of doubleBookingInfo.events[company]; let j = index\" [class.mt-20]=\"j !== 0\">\n            <event-item [event]=\"event\" (eventEmit)=\"reactToEventClick($event)\"></event-item>\n        </div>\n    </div>\n</div>"

/***/ }),

/***/ "./web/modern/components/common/double-booking/double-booking-details/double-booking-details-modal.scss":
/***/ (function(module, exports) {

module.exports = ".modal-body {\n  padding: 20px !important; }\n"

/***/ }),

/***/ "./web/modern/components/common/double-booking/double-booking-details/double-booking-details-modal.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var ng_bootstrap_1 = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/index.js");
var double_booking_service_1 = __webpack_require__("./shared/services/double-booking/double-booking.service.ts");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var confirm_general_modal_component_1 = __webpack_require__("./web/modern/components/common/confirm-general-modal/confirm-general-modal.component.ts");
var common_1 = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
var DoubleBookingDetailsModalComponent = function () {
    function DoubleBookingDetailsModalComponent(activeModal, doubleBookingService, modalService, location) {
        var _this = this;

        _classCallCheck(this, DoubleBookingDetailsModalComponent);

        this.activeModal = activeModal;
        this.doubleBookingService = doubleBookingService;
        this.modalService = modalService;
        this.location = location;
        this.companiesList = [];
        location.onPopState(function () {
            return _this.onDismiss();
        });
    }

    _createClass(DoubleBookingDetailsModalComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.companiesList = this.doubleBookingService.sortBrands(Object.keys(this.doubleBookingInfo.events), this.doubleBookingInfo);
        }
    }, {
        key: "reactToEventClick",
        value: function reactToEventClick(event) {
            var OPEN_TAB = event.actions.OPEN_TAB;

            if (OPEN_TAB) {
                var method = OPEN_TAB.method,
                    url = OPEN_TAB.url,
                    alertMessage = OPEN_TAB.alertMessage;

                if (method === 'NEW_WINDOW') {
                    window.open(url, '_blank');
                }
                if (method === 'ALERT_MODAL') {
                    this.openAlertModal(alertMessage);
                }
            }
        }
    }, {
        key: "onDismiss",
        value: function onDismiss() {
            this.activeModal.dismiss();
        }
    }, {
        key: "openAlertModal",
        value: function openAlertModal(alert) {
            var message = alert.message,
                title = alert.title;

            var modal = this.modalService.openModal(confirm_general_modal_component_1.ConfirmGeneralModalComponent, {
                windowClass: 'ng-bootstrap-modal modal-visible modal-narrow'
            });
            if (title) {
                modal.componentInstance.title = title;
            }
            modal.componentInstance.text = message;
            modal.componentInstance.buttons = [{
                text: 'Got it',
                action: 'CLOSE',
                color: 'default',
                size: 'lg'
            }];
        }
    }]);

    return DoubleBookingDetailsModalComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], DoubleBookingDetailsModalComponent.prototype, "doubleBookingInfo", void 0);
DoubleBookingDetailsModalComponent = __decorate([core_1.Component({
    selector: 'double-booking-details',
    template: __webpack_require__("./web/modern/components/common/double-booking/double-booking-details/double-booking-details-modal.html"),
    styles: [__webpack_require__("./web/modern/components/common/double-booking/double-booking-details/double-booking-details-modal.scss")]
}), __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal, double_booking_service_1.DoubleBookingService, snModal_service_1.SNModalService, common_1.PlatformLocation])], DoubleBookingDetailsModalComponent);
exports.DoubleBookingDetailsModalComponent = DoubleBookingDetailsModalComponent;

/***/ }),

/***/ "./web/modern/components/common/double-booking/double-booking.html":
/***/ (function(module, exports) {

module.exports = "<ng-container *ngIf=\"doubleBooking\">\n    <div class=\"double-booking \"\n         [ngStyle]=\"{\n            'border': '2px solid' + doubleBooking.iconShape.hexColor,\n            'background': doubleBooking.iconShape.shapeType === 'fill' ? doubleBooking.iconShape.hexColor : '#ffffff'\n         }\"\n         *ngFor=\"let doubleBooking of doubleBooking.icons\"\n         (click)=\"openDoubleBookingDetails($event, doubleBooking)\">\n        <span class=\"text-light text-overflow\">\n            <span [style.color]=\"doubleBooking.iconShape.shapeType === 'fill' ? '#ffffff' : doubleBooking.iconShape.hexColor\"\n                  class=\"fa fa-ban icon-ban icon-ban-job\">\n            </span>\n        </span>\n        <div class=\"double-booking-tooltip\"\n             [ngStyle]=\"{\n            'border': '2px solid' + doubleBooking.iconShape.hexColor,\n            'background': doubleBooking.iconShape.hexColor\n         }\">\n            {{ doubleBooking.webDescription }}\n        </div>\n    </div>\n\n</ng-container>\n"

/***/ }),

/***/ "./web/modern/components/common/double-booking/double-booking.scss":
/***/ (function(module, exports) {

module.exports = ""

/***/ }),

/***/ "./web/modern/components/common/double-booking/double-booking.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var double_booking_details_modal_1 = __webpack_require__("./web/modern/components/common/double-booking/double-booking-details/double-booking-details-modal.ts");
var double_booking_service_1 = __webpack_require__("./shared/services/double-booking/double-booking.service.ts");
var DoubleBookingComponent = function () {
    function DoubleBookingComponent(modalService, doubleBookingService) {
        _classCallCheck(this, DoubleBookingComponent);

        this.modalService = modalService;
        this.doubleBookingService = doubleBookingService;
    }

    _createClass(DoubleBookingComponent, [{
        key: "openDoubleBookingDetails",
        value: function openDoubleBookingDetails(ev, doubleBooking) {
            ev.preventDefault();
            ev.stopPropagation();
            var _doubleBooking$action = doubleBooking.actions,
                SHOW_OVERLAPPING_EVENTS = _doubleBooking$action.SHOW_OVERLAPPING_EVENTS,
                OPEN_TAB = _doubleBooking$action.OPEN_TAB;

            if (SHOW_OVERLAPPING_EVENTS) {
                var modal = this.modalService.openModal(double_booking_details_modal_1.DoubleBookingDetailsModalComponent);
                var dataToShow = this.doubleBookingService.parseEventsToShow(doubleBooking.events);
                modal.componentInstance.doubleBookingInfo = this.doubleBookingService.sortDoubleBookingEvents(dataToShow);
            }
            if (OPEN_TAB) {
                window.open(OPEN_TAB.url, '_blank');
            }
        }
    }]);

    return DoubleBookingComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], DoubleBookingComponent.prototype, "doubleBooking", void 0);
DoubleBookingComponent = __decorate([core_1.Component({
    selector: 'double-booking',
    template: __webpack_require__("./web/modern/components/common/double-booking/double-booking.html"),
    styles: [__webpack_require__("./web/modern/components/common/double-booking/double-booking.scss")]
}), __metadata("design:paramtypes", [snModal_service_1.SNModalService, double_booking_service_1.DoubleBookingService])], DoubleBookingComponent);
exports.DoubleBookingComponent = DoubleBookingComponent;

/***/ }),

/***/ "./web/modern/components/common/double-booking/events-overlapping-info/events-overlapping-info.component.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"db-info-block\" *ngIf=\"data\">\n    <div class=\"mb-15\">\n        <div class=\"double-booking ml-0\"\n             [ngStyle]=\"{\n            'cursor': 'default',\n            'border': '2px solid' + dataToShow.iconShape.hexColor,\n            'background': dataToShow.iconShape.shapeType === 'fill' ? dataToShow.iconShape.hexColor : '#ffffff'\n        }\">\n            <span class=\"text-light text-overflow\">\n                <span [style.color]=\"dataToShow.iconShape.shapeType === 'fill' ? '#ffffff' : dataToShow.iconShape.hexColor\"\n                      class=\"fa fa-ban icon-ban icon-ban-job\">\n                </span>\n            </span>\n        </div>\n        <span class=\"double-booking-description\">{{ dataToShow.shortDescription }}</span>\n    </div>\n\n    <div *ngFor=\"let company of companiesList; let i = index\" [class.mt-15]=\"i !== 0\">\n        <h3 class=\"mt-20 mb-15\" *ngIf=\"shouldShowCompanyName(company)\">{{ company }}</h3>\n        <div *ngFor=\"let event of dataToShow.events[company]; let j = index\" [class.mt-10]=\"j !== 0\">\n            <event-item [event]=\"event\" (eventEmit)=\"reactToEventClick($event)\"></event-item>\n        </div>\n    </div>\n</div>"

/***/ }),

/***/ "./web/modern/components/common/double-booking/events-overlapping-info/events-overlapping-info.component.scss":
/***/ (function(module, exports) {

module.exports = ".db-info-block {\n  padding: 15px;\n  border: 1px solid #c42136; }\n  .db-info-block .double-booking-description {\n    padding-left: 6px; }\n"

/***/ }),

/***/ "./web/modern/components/common/double-booking/events-overlapping-info/events-overlapping-info.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var double_booking_service_1 = __webpack_require__("./shared/services/double-booking/double-booking.service.ts");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var confirm_general_modal_component_1 = __webpack_require__("./web/modern/components/common/confirm-general-modal/confirm-general-modal.component.ts");
var EventsOverlappingInfoComponent = function () {
    function EventsOverlappingInfoComponent(doubleBookingService, modalService) {
        _classCallCheck(this, EventsOverlappingInfoComponent);

        this.doubleBookingService = doubleBookingService;
        this.modalService = modalService;
    }

    _createClass(EventsOverlappingInfoComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            if (this.data) {
                this.createDoubleBookingDataToShow();
            }
        }
    }, {
        key: "ngOnChanges",
        value: function ngOnChanges(changes) {
            if (!changes.data.isFirstChange() && changes.data.currentValue) {
                this.createDoubleBookingDataToShow();
            }
        }
    }, {
        key: "reactToEventClick",
        value: function reactToEventClick($event) {
            var OPEN_TAB = $event.actions.OPEN_TAB;

            if (OPEN_TAB) {
                var method = OPEN_TAB.method,
                    url = OPEN_TAB.url,
                    alertMessage = OPEN_TAB.alertMessage;

                if (method === 'NEW_WINDOW') {
                    window.open(url, '_blank');
                }
                if (method === 'ALERT_MODAL') {
                    document.body.classList.remove('modal-open');
                    this.openAlertModal(alertMessage).result.then(function () {
                        return document.body.classList.add('modal-open');
                    });
                }
            }
        }
    }, {
        key: "shouldShowCompanyName",
        value: function shouldShowCompanyName(company) {
            return this.companiesList.length > 1 || this.companiesList.length === 1 && this.dataToShow.events[company].length > 1 && !this.dataToShow.events[company][0].company.currentBrand;
        }
    }, {
        key: "createDoubleBookingDataToShow",
        value: function createDoubleBookingDataToShow() {
            var _doubleBookingService = this.doubleBookingService.sortDoubleBookingEvents(this.data),
                events = _doubleBookingService.events;

            this.dataToShow = Object.assign({}, this.data, { events: events });
            this.companiesList = this.doubleBookingService.sortBrands(Object.keys(this.data.events), this.dataToShow);
            this.removeJobTypes();
        }
    }, {
        key: "removeJobTypes",
        value: function removeJobTypes() {
            var _this = this;

            this.companiesList.forEach(function (company) {
                _this.dataToShow.events[company] = _this.dataToShow.events[company].map(function (event) {
                    return Object.assign({}, event, { jobType: null });
                });
            });
        }
    }, {
        key: "openAlertModal",
        value: function openAlertModal(alert) {
            var message = alert.message,
                title = alert.title;

            var modal = this.modalService.openModal(confirm_general_modal_component_1.ConfirmGeneralModalComponent, {
                windowClass: 'ng-bootstrap-modal modal-visible modal-narrow'
            });
            if (title) {
                modal.componentInstance.title = title;
            }
            modal.componentInstance.text = message;
            modal.componentInstance.buttons = [{
                text: 'Got it',
                action: 'CLOSE',
                color: 'default',
                size: 'lg'
            }];
            return modal;
        }
    }]);

    return EventsOverlappingInfoComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], EventsOverlappingInfoComponent.prototype, "data", void 0);
EventsOverlappingInfoComponent = __decorate([core_1.Component({
    selector: 'events-overlapping-info',
    template: __webpack_require__("./web/modern/components/common/double-booking/events-overlapping-info/events-overlapping-info.component.html"),
    styles: [__webpack_require__("./web/modern/components/common/double-booking/events-overlapping-info/events-overlapping-info.component.scss")]
}), __metadata("design:paramtypes", [double_booking_service_1.DoubleBookingService, snModal_service_1.SNModalService])], EventsOverlappingInfoComponent);
exports.EventsOverlappingInfoComponent = EventsOverlappingInfoComponent;

/***/ }),

/***/ "./web/modern/components/common/email-field/email-field.component.html":
/***/ (function(module, exports) {

module.exports = "<email-multiselect [value]=\"value\"\n                   [disabled]=\"disabled\"\n                   [loading]=\"isLoading\"\n                   [autocomplete]=\"autocomplete$\"\n                   [autocompleteValues]=\"autocompleteValues\"\n                   [placeholder]=\"placeholder\"\n                   [customClass]=\"'email-multiselect'\"\n                   [maxAllowedAmount]=\"5\"\n                   (valueChanges)=\"valueChanges($event)\">\n</email-multiselect>"

/***/ }),

/***/ "./web/modern/components/common/email-field/email-field.component.scss":
/***/ (function(module, exports) {

module.exports = ""

/***/ }),

/***/ "./web/modern/components/common/email-field/email-field.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var rxjs_1 = __webpack_require__("./node_modules/rxjs/Rx.js");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var jobs_data_service_1 = __webpack_require__("./shared/services/job/jobs.data.service.ts");
var email_service_1 = __webpack_require__("./shared/services/email/email-service/email.service.ts");
var EmailFieldComponent = function () {
    function EmailFieldComponent(jobDataService, emailService) {
        _classCallCheck(this, EmailFieldComponent);

        this.jobDataService = jobDataService;
        this.emailService = emailService;
        this.valueChange = new core_1.EventEmitter();
        this.autocomplete$ = new rxjs_1.Subject();
        this.autocompleteValues = [];
        this.unsubscribe = new rxjs_1.Subject();
    }

    _createClass(EmailFieldComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.listenToFieldTyping();
        }
    }, {
        key: "ngOnChanges",
        value: function ngOnChanges(changes) {
            if (changes.value && !changes.value.isFirstChange() && changes.value.currentValue) {
                this.clearAutocomplete();
            }
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "valueChanges",
        value: function valueChanges(value) {
            this.valueChange.emit(value);
        }
    }, {
        key: "listenToFieldTyping",
        value: function listenToFieldTyping() {
            var _this = this;

            this.autocomplete$.asObservable().pipe(operators_1.takeUntil(this.unsubscribe), operators_1.tap(function (val) {
                if (val && val.length <= 2) {
                    _this.clearAutocomplete();
                }
            }), operators_1.map(function (val) {
                return val.trim();
            }), operators_1.filter(function (val) {
                return val && val.length > 2;
            }), operators_1.debounceTime(250)).subscribe(function (data) {
                return _this.loadSuggestedData(data);
            });
        }
    }, {
        key: "loadSuggestedData",
        value: function loadSuggestedData(field) {
            var _this2 = this;

            this.isLoading = true;
            this.jobDataService.searchClient(field).pipe(operators_1.takeUntil(this.unsubscribe), operators_1.map(function (data) {
                return _this2.emailService.filterEmailAutocomplete(data, _this2.value);
            }), operators_1.finalize(function () {
                return _this2.isLoading = false;
            })).subscribe(function (data) {
                _this2.autocompleteValues = [].concat(_toConsumableArray(data));
            });
        }
    }, {
        key: "clearAutocomplete",
        value: function clearAutocomplete() {
            this.autocompleteValues = [];
        }
    }]);

    return EmailFieldComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Array)], EmailFieldComponent.prototype, "value", void 0);
__decorate([core_1.Input(), __metadata("design:type", Boolean)], EmailFieldComponent.prototype, "disabled", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], EmailFieldComponent.prototype, "placeholder", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], EmailFieldComponent.prototype, "valueChange", void 0);
EmailFieldComponent = __decorate([core_1.Component({
    selector: 'email-field',
    template: __webpack_require__("./web/modern/components/common/email-field/email-field.component.html"),
    styles: [__webpack_require__("./web/modern/components/common/email-field/email-field.component.scss")]
}), __metadata("design:paramtypes", [jobs_data_service_1.JobsDataServiceProvider, email_service_1.EmailServiceProvider])], EmailFieldComponent);
exports.EmailFieldComponent = EmailFieldComponent;

/***/ }),

/***/ "./web/modern/components/common/error-message-modal/error-message-modal.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"errorMessageModal\" class=\"modal modal-center fade\" data-backdrop=\"static\" data-keyboard=\"false\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <close-btn></close-btn>\n                <h3 class=\"modal-title\">{{ title }}</h3>\n            </div>\n            <div class=\"modal-body\">\n                <strong [innerHTML]=\"errorMessage\">\n                </strong>\n            </div>\n            <div class=\"modal-footer modal-foot\">\n                <button type=\"button\" class=\"btn btn-general\" data-dismiss=\"modal\">Ok</button>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),

/***/ "./web/modern/components/common/error-message-modal/error-message-modal.scss":
/***/ (function(module, exports) {

module.exports = ""

/***/ }),

/***/ "./web/modern/components/common/error-message-modal/error-message-modal.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var ErrorMessageModalWebComponent = function () {
    function ErrorMessageModalWebComponent() {
        _classCallCheck(this, ErrorMessageModalWebComponent);
    }

    _createClass(ErrorMessageModalWebComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {}
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {}
    }]);

    return ErrorMessageModalWebComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", String)], ErrorMessageModalWebComponent.prototype, "title", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], ErrorMessageModalWebComponent.prototype, "errorMessage", void 0);
ErrorMessageModalWebComponent = __decorate([core_1.Component({
    selector: 'error-message-modal',
    template: __webpack_require__("./web/modern/components/common/error-message-modal/error-message-modal.html"),
    styles: [__webpack_require__("./web/modern/components/common/error-message-modal/error-message-modal.scss")]
}), __metadata("design:paramtypes", [])], ErrorMessageModalWebComponent);
exports.ErrorMessageModalWebComponent = ErrorMessageModalWebComponent;

/***/ }),

/***/ "./web/modern/components/common/event-item/event-item.component.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"stats__item__line__wrap\" (click)=\"eventEmit.emit(event)\" [style.border]=\"event.primaryEvent ? '1px solid grey' : null\">\n    <a class=\"stats__item__line\">\n        <div>\n            <i *ngIf=\"event.jobType\" class=\"jt-big\" [ngStyle]=\"{backgroundColor: event.jobType.hexColor, borderColor: event.jobType.shadedColor}\"></i>\n            <b class=\"pl-5 event__time\" *ngIf=\"event.parsedStartDate || event.parsedTime\">\n                {{ event.shouldShowDate ? event.parsedStartDate : ''}} {{ event.parsedTime }} {{ event.daysAmount }}\n            </b>\n        </div>\n        <div class=\"flex-box flex-align-center\">\n            <span class=\"event__name\">{{ event.eventName }}</span>\n            <b *ngFor=\"let label of event.labels\" class=\"event__type\" [style.backgroundColor]=\"label.hexColor\">{{ label.name }}</b>\n        </div>\n    </a>\n</div>"

/***/ }),

/***/ "./web/modern/components/common/event-item/event-item.component.scss":
/***/ (function(module, exports) {

module.exports = ".jt-big {\n  margin-right: 2px; }\n\n.stats__item__line div:first-child {\n  -webkit-flex-wrap: unset;\n      -ms-flex-wrap: unset;\n          flex-wrap: unset;\n  white-space: nowrap;\n  min-width: unset; }\n\n.stats__item__line div:last-child {\n  min-width: 0; }\n\n.event__name {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow-x: hidden; }\n\n.event__type {\n  white-space: nowrap; }\n"

/***/ }),

/***/ "./web/modern/components/common/event-item/event-item.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var EventItemComponent = function EventItemComponent() {
    _classCallCheck(this, EventItemComponent);

    this.eventEmit = new core_1.EventEmitter();
};
__decorate([core_1.Input(), __metadata("design:type", Object)], EventItemComponent.prototype, "event", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], EventItemComponent.prototype, "eventEmit", void 0);
EventItemComponent = __decorate([core_1.Component({
    selector: 'event-item',
    template: __webpack_require__("./web/modern/components/common/event-item/event-item.component.html"),
    styles: [__webpack_require__("./web/modern/components/common/event-item/event-item.component.scss")]
})], EventItemComponent);
exports.EventItemComponent = EventItemComponent;

/***/ }),

/***/ "./web/modern/components/common/event-type-row/event-type-row.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"stats__item__line__wrap\">\n    <div *ngIf=\"!isMainShoot(eventData) && !isApp(eventData) && !isExtraShoot(eventData)\" class=\"stats__item__line\">\n        <div [title]='jobType ? jobType : eventData.name'>\n            <i class=\"jt-big jt-{{eventData.type | lowercase}}\"></i>\n            <b class=\"event__time\">\n                {{ !eventData.startTime ? (\"All day\") : (eventData.startTime | timeFilter: snFilter || \"12h\") }}\n            </b>\n        </div>\n        <div>\n            <span class=\"event__name\">{{ eventData.name }}</span>\n            <b class=\"event__type event__type-{{eventColor | lowercase}}\" *ngIf=\"eventData.inLead===true\">{{ eventType | uppercase}} (LEAD)</b>\n            <b class=\"event__type event__type-{{eventColor | lowercase}}\" *ngIf=\"eventData.inLead!=true\">{{ eventType }}</b>\n            <b *ngIf=\"eventData.typeColor === 'LEAD' && eventType === 'MAIN SHOOT' && eventData.inLead===false\" class=\"event__type event__type-{{eventColor | lowercase}}\">UNCONFIRMED</b>\n        </div>\n    </div>\n\n    <a (click)=\"showLeadJob(eventData.leadId, eventData, 'leads')\" *ngIf=\"eventData.inLead===true && (isMainShoot(eventData) || isApp(eventData) || isExtraShoot(eventData))\" class=\"stats__item__line\">\n        <div [title]='jobType ? jobType : eventData.name'>\n            <i class=\"jt-big jt-{{eventData.type | lowercase}}\"></i>\n            <b class=\"event__time\">\n                {{ !eventData.startTime ? (\"All day\") : (eventData.startTime | timeFilter: snFilter || \"12h\") }}\n            </b>\n        </div>\n        <div>\n            <span class=\"event__name\">{{ eventData.name }}</span>\n            <b class=\"event__type event__type-{{eventColor | lowercase}}\">{{ eventType | uppercase}} (LEAD)</b>\n\n        </div>\n    </a>\n\n    <a (click)=\"showLeadJob(eventData.jobId, eventData, 'jobs')\" *ngIf=\"eventData.inLead===false && (isMainShoot(eventData) || isApp(eventData) || isExtraShoot(eventData))\" class=\"stats__item__line\">\n\n        <div [title]='jobType ? jobType : eventData.name'>\n            <i class=\"jt-big jt-{{eventData.type | lowercase}}\"></i>\n            <b class=\"event__time\">\n                {{ !eventData.startTime ? (\"All day\") : (eventData.startTime | timeFilter: snFilter || \"12h\") }}\n            </b>\n        </div>\n        <div>\n            <span class=\"event__name\">{{ eventData.name }}</span>\n            <b class=\"event__type event__type-{{eventColor | lowercase}}\">{{ eventType | uppercase }}</b>\n            <b *ngIf=\"eventData.typeColor === 'LEAD' && eventType === 'MAIN SHOOT'\" class=\"event__type event__type-{{eventColor | lowercase}}\">UNCONFIRMED</b>\n        </div>\n    </a>\n</div>\n"

/***/ }),

/***/ "./web/modern/components/common/event-type-row/event-type-row.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var common_1 = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
var settings_1 = __webpack_require__("./shared/services/settings/settings.ts");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var EventTypeRowComponent = function () {
    function EventTypeRowComponent(location, settingsService) {
        _classCallCheck(this, EventTypeRowComponent);

        this.location = location;
        this.settingsService = settingsService;
        this.jobTypes = [];
        this.unsubscribe = new Subject_1.Subject();
        this.isMainShoot = function (event) {
            return event.calendarEventType === 'MAIN_SHOOT';
        };
        this.isApp = function (event) {
            if (event.jobId) {
                return event.calendarEventType === 'APPOINTMENT';
            }
        };
    }

    _createClass(EventTypeRowComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.subscribeToCustomizeLabelsChange();
            if (this.eventData) {
                this.setEventType(this.eventData);
                if (this.eventData.type) {
                    this.setJobType(this.jobTypes, this.eventData.type);
                }
            }
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "isExtraShoot",
        value: function isExtraShoot(eventData) {
            return eventData.calendarEventType === 'EXTRA_SHOOT';
        }
    }, {
        key: "showLeadJob",
        value: function showLeadJob(id, eventData, type) {
            var redirectLink = type + "/view/" + id;
            if (eventData.calendarEventType === 'MAIN_SHOOT') {
                this.location.go(redirectLink);
                return;
            }
            if (eventData.taskId) {
                redirectLink = redirectLink + "?task=" + eventData.taskId;
            }
            this.location.go(redirectLink);
        }
    }, {
        key: "subscribeToCustomizeLabelsChange",
        value: function subscribeToCustomizeLabelsChange() {
            var _this = this;

            this.settingsService.customizeLabelsObservable.pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (customizeLabels) {
                _this.mainShootLabelName = customizeLabels.mainShootLabel.toUpperCase();
                _this.extraShootLabelName = customizeLabels.extraShootLabel.toLocaleLowerCase();
            });
        }
    }, {
        key: "setEventType",
        value: function setEventType(event) {
            if (event.calendarEventType === 'MAIN_SHOOT' && event.inLead === false) {
                this.eventColor = 'SHOOT';
                this.eventType = this.mainShootLabelName;
            } else if (event.calendarEventType === 'MAIN_SHOOT' && event.inLead === true) {
                this.eventColor = 'LEAD';
                this.eventType = this.mainShootLabelName;
            } else if (event.calendarEventType === 'EXTRA_SHOOT' && event.inLead === false) {
                this.eventColor = 'SHOOT';
                this.eventType = this.extraShootLabelName;
            } else if (event.calendarEventType === 'EXTRA_SHOOT' && event.inLead === true) {
                this.eventColor = 'LEAD';
                this.eventType = this.extraShootLabelName;
            } else {
                this.eventColor = 'APPOINTMENT';
                this.eventType = 'APPOINTMENT';
            }
        }
    }, {
        key: "setJobType",
        value: function setJobType(jobTypes, type) {
            this.jobType = jobTypes.find(function (jobType) {
                return jobType.colour === type;
            }).name;
        }
    }]);

    return EventTypeRowComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], EventTypeRowComponent.prototype, "eventData", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], EventTypeRowComponent.prototype, "snFilter", void 0);
__decorate([core_1.Input(), __metadata("design:type", Array)], EventTypeRowComponent.prototype, "jobTypes", void 0);
EventTypeRowComponent = __decorate([core_1.Component({
    selector: 'event-type-row',
    template: __webpack_require__("./web/modern/components/common/event-type-row/event-type-row.html")
}), __metadata("design:paramtypes", [common_1.Location, settings_1.SettingsProvider])], EventTypeRowComponent);
exports.EventTypeRowComponent = EventTypeRowComponent;

/***/ }),

/***/ "./web/modern/components/common/iframe/iframe.component.html":
/***/ (function(module, exports) {

module.exports = "<ng-container *ngIf=\"urlToLoad\">\n    <iframe [src]=\"urlToLoad | safe: 'resourceUrl'\" class=\"iframe-full-screen\" frameborder=\"0\" scrolling=\"no\"></iframe>\n    <div class=\"iframe-backdrop\"></div>\n</ng-container>\n"

/***/ }),

/***/ "./web/modern/components/common/iframe/iframe.component.scss":
/***/ (function(module, exports) {

module.exports = ".iframe-full-screen, .iframe-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100vh;\n  width: 100vw;\n  overflow: hidden;\n  z-index: 99999999; }\n\n.iframe-backdrop {\n  background-color: #45464c;\n  opacity: 0.5;\n  z-index: 99999998; }\n"

/***/ }),

/***/ "./web/modern/components/common/iframe/iframe.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var iframe_service_1 = __webpack_require__("./shared/services/helpers/iframe-service/iframe.service.ts");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var IframeComponent = function () {
    function IframeComponent(iframeService) {
        _classCallCheck(this, IframeComponent);

        this.iframeService = iframeService;
        this.urlToLoad = null;
        this.unsubscribe = new Subject_1.Subject();
    }

    _createClass(IframeComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            var _this = this;

            this.body = document.querySelector('body');
            this.iframeService.urlIframeUrl.pipe(operators_1.takeUntil(this.unsubscribe), operators_1.skip(1)).subscribe(function (url) {
                _this.changeBodyClass(url);
                _this.urlToLoad = url;
            });
        }
    }, {
        key: "changeBodyClass",
        value: function changeBodyClass(url) {
            url ? this.body.classList.add('disable-scroll') : this.body.classList.remove('disable-scroll');
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }]);

    return IframeComponent;
}();
IframeComponent = __decorate([core_1.Component({
    selector: 'sn-iframe',
    template: __webpack_require__("./web/modern/components/common/iframe/iframe.component.html"),
    styles: [__webpack_require__("./web/modern/components/common/iframe/iframe.component.scss")]
}), __metadata("design:paramtypes", [iframe_service_1.IframeService])], IframeComponent);
exports.IframeComponent = IframeComponent;

/***/ }),

/***/ "./web/modern/components/common/job-cell-header/job-cell-header.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"main-jobs-cell__title\" [ngClass]=\"{'main-jobs-cell__title--bordered' : isBorderBottom}\">\n    <i class=\"{{icon}}\" *ngIf=\"icon\"></i>\n    <img [src]=\"imgSrc\" *ngIf=\"imgSrc\">\n    <h2>{{text}}</h2>\n    <sn-label\n            *ngIf=\"galleryHeader\"\n            [text]=\"'Connected to ShootProof'\">\n    </sn-label>\n    <ng-content></ng-content>\n</div>\n"

/***/ }),

/***/ "./web/modern/components/common/job-cell-header/job-cell-header.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var JobCellHeader = function JobCellHeader() {
    _classCallCheck(this, JobCellHeader);
};
__decorate([core_1.Input(), __metadata("design:type", String)], JobCellHeader.prototype, "icon", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], JobCellHeader.prototype, "imgSrc", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], JobCellHeader.prototype, "text", void 0);
__decorate([core_1.Input(), __metadata("design:type", Boolean)], JobCellHeader.prototype, "isBorderBottom", void 0);
__decorate([core_1.Input(), __metadata("design:type", Array)], JobCellHeader.prototype, "files", void 0);
__decorate([core_1.Input(), __metadata("design:type", Boolean)], JobCellHeader.prototype, "galleryHeader", void 0);
JobCellHeader = __decorate([core_1.Component({
    selector: 'job-cell-header',
    template: __webpack_require__("./web/modern/components/common/job-cell-header/job-cell-header.html")
}), __metadata("design:paramtypes", [])], JobCellHeader);
exports.JobCellHeader = JobCellHeader;

/***/ }),

/***/ "./web/modern/components/common/media-drop-zone/custom-media-preview/custom-media-preview.component.html":
/***/ (function(module, exports) {

module.exports = "<img *ngIf=\"base64File\" alt=\"Image preview\" class=\"image-preview\"  src=\"{{base64File}}\">\n\n\n"

/***/ }),

/***/ "./web/modern/components/common/media-drop-zone/custom-media-preview/custom-media-preview.component.scss":
/***/ (function(module, exports) {

module.exports = ":host {\n  min-width: unset !important;\n  max-width: 100% !important;\n  padding: 0 !important; }\n  :host:hover ngx-dropzone-remove-badge, :host:focus ngx-dropzone-remove-badge {\n    opacity: 1; }\n  :host ngx-dropzone-remove-badge {\n    opacity: 0; }\n  :host .image-preview {\n    min-width: unset;\n    max-width: 100%;\n    padding: 0;\n    max-height: 100%;\n    -o-object-fit: contain;\n       object-fit: contain; }\n"

/***/ }),

/***/ "./web/modern/components/common/media-drop-zone/custom-media-preview/custom-media-preview.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var ngx_dropzone_1 = __webpack_require__("./node_modules/ngx-dropzone/fesm5/ngx-dropzone.js");
var platform_browser_1 = __webpack_require__("./node_modules/@angular/platform-browser/esm5/platform-browser.js");
var CustomMediaPreviewComponent = CustomMediaPreviewComponent_1 = function (_ngx_dropzone_1$NgxDr) {
    _inherits(CustomMediaPreviewComponent, _ngx_dropzone_1$NgxDr);

    function CustomMediaPreviewComponent(sanitizer) {
        _classCallCheck(this, CustomMediaPreviewComponent);

        return _possibleConstructorReturn(this, (CustomMediaPreviewComponent.__proto__ || Object.getPrototypeOf(CustomMediaPreviewComponent)).call(this, sanitizer));
    }

    _createClass(CustomMediaPreviewComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            if (!this.file) {
                return;
            }
            this.readInputFile();
        }
    }, {
        key: "ngOnChanges",
        value: function ngOnChanges(changes) {
            if (changes.file.currentValue) {
                this.readInputFile();
            }
        }
    }, {
        key: "readInputFile",
        value: function readInputFile() {
            var _this2 = this;

            this.readFile().then(function (data) {
                _this2.base64File = data;
            }).catch();
        }
    }]);

    return CustomMediaPreviewComponent;
}(ngx_dropzone_1.NgxDropzonePreviewComponent);
__decorate([core_1.Input(), __metadata("design:type", File)], CustomMediaPreviewComponent.prototype, "file", void 0);
CustomMediaPreviewComponent = CustomMediaPreviewComponent_1 = __decorate([core_1.Component({
    selector: 'custom-media-preview',
    template: __webpack_require__("./web/modern/components/common/media-drop-zone/custom-media-preview/custom-media-preview.component.html"),
    styles: [__webpack_require__("./web/modern/components/common/media-drop-zone/custom-media-preview/custom-media-preview.component.scss")],
    providers: [{
        provide: ngx_dropzone_1.NgxDropzonePreviewComponent,
        useExisting: CustomMediaPreviewComponent_1
    }]
}), __metadata("design:paramtypes", [platform_browser_1.DomSanitizer])], CustomMediaPreviewComponent);
exports.CustomMediaPreviewComponent = CustomMediaPreviewComponent;
var CustomMediaPreviewComponent_1;

/***/ }),

/***/ "./web/modern/components/common/media-drop-zone/media-drop-zone.component.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"flex-box\">\n    <div class=\"item-text\">\n        <h4>{{ title }}</h4>\n        <p>{{ description }}</p>\n        <div>\n            <button (click)=\"addImage()\" *ngIf=\"!file\" class=\"btn btn-import btn-sm mt-0\" type=\"file\">Upload</button>\n            <ng-container *ngIf=\"file\">\n                <button (click)=\"updateImage()\" class=\"btn btn-info btn-sm mr-8 pull-left\">Update</button>\n                <button (click)=\"removeImage()\" class=\"btn btn-delete btn-grey-light btn-sm pull-left\">Remove</button>\n            </ng-container>\n        </div>\n    </div>\n    <div class=\"item-media\">\n        <ngx-dropzone (change)=\"onMediaSelect($event)\"\n                      [accept]=\"dropzoneConfig.accept\"\n                      [id]=\"dropzoneConfig.id\"\n                      [maxFileSize]=\"convertToBytes(dropzoneConfig.maxFileSize)\"\n                      [multiple]=\"dropzoneConfig.multiple\"\n                      [ngStyle]=\"styles\"\n                      class=\"drop-zone flex-box flex-just-center\">\n            <ngx-dropzone-label style=\"padding: 0 10px\"><img alt=\"upload\" class=\"dropzone-img-preview\" src=\"https://app.studioninja.co/build/release-pipeline-119/resources/dist/assets/images/icons/upload.png\"></ngx-dropzone-label>\n            <custom-media-preview *ngIf=\"file\" [file]=\"file\" ngProjectAs=\"ngx-dropzone-preview\" class=\"focus-outline-none\"></custom-media-preview>\n        </ngx-dropzone>\n    </div>\n</div>\n\n"

/***/ }),

/***/ "./web/modern/components/common/media-drop-zone/media-drop-zone.component.scss":
/***/ (function(module, exports) {

module.exports = ".drop-zone {\n  background: #f9f9f9;\n  border: 1px solid #f3f3f3;\n  overflow: hidden; }\n  .drop-zone .icon-big {\n    font-size: 60px;\n    color: #bfbec3; }\n\n.content-center {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center; }\n\n.item-logo,\n.item-banner {\n  -webkit-align-self: center;\n      -ms-flex-item-align: center;\n          align-self: center; }\n  .item-logo .item-image-responsive,\n  .item-banner .item-image-responsive {\n    height: auto;\n    max-width: 100%; }\n\n.item-text {\n  margin-right: 10px; }\n\n.ngx-dz-hovered img {\n  opacity: 0.6; }\n\n.ngx-dz-disabled {\n  opacity: 1 !important; }\n  .ngx-dz-disabled img {\n    max-width: 100%; }\n\n.dropzone-img-preview {\n  max-width: 100%; }\n\n.focus-outline-none:focus {\n  outline: none; }\n"

/***/ }),

/***/ "./web/modern/components/common/media-drop-zone/media-drop-zone.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var models_1 = __webpack_require__("./shared/models/models.ts");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var MediaDropZoneComponent = function () {
    function MediaDropZoneComponent(messageService) {
        _classCallCheck(this, MediaDropZoneComponent);

        this.messageService = messageService;
        this.onDropEventSuccess = new core_1.EventEmitter();
        this.onRemoveEvent = new core_1.EventEmitter();
    }

    _createClass(MediaDropZoneComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.dropzoneConfig = Object.assign({}, models_1.DEFAULT_MEDIA_FILE_CONFIG, this.mediaConfig);
            if (this.inputFile) {
                this.file = this.inputFile;
            }
        }
    }, {
        key: "ngOnChanges",
        value: function ngOnChanges(changes) {
            if (changes.inputFile && changes.inputFile.currentValue) {
                this.file = changes.inputFile.currentValue;
            }
        }
    }, {
        key: "onMediaSelect",
        value: function onMediaSelect(ev) {
            if (ev.rejectedFiles.length) {
                this.validateOnError(ev.rejectedFiles[0]);
            } else {
                this.convertFileToBase64(ev.addedFiles[0]);
            }
        }
    }, {
        key: "convertFileToBase64",
        value: function convertFileToBase64(file) {
            var _this = this;

            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () {
                _this.onDropEventSuccess.emit({
                    id: _this.mediaConfig.id,
                    data: {
                        name: file.name,
                        contentType: file.type,
                        size: file.size,
                        base64: _this.cutFrom('base64,', reader.result.toString())
                    }
                });
            };
            reader.onerror = function (error) {
                console.log('Error: ', error);
            };
        }
    }, {
        key: "cutFrom",
        value: function cutFrom(searchValue, str) {
            var commaIndex = str.indexOf(searchValue) + 7;
            return str.slice(commaIndex);
        }
    }, {
        key: "convertToBytes",
        value: function convertToBytes(megabyte) {
            return megabyte * 1000 * 1000;
        }
    }, {
        key: "addImage",
        value: function addImage() {
            document.getElementById(this.mediaConfig.id).click();
        }
    }, {
        key: "updateImage",
        value: function updateImage() {
            document.getElementById(this.mediaConfig.id).click();
        }
    }, {
        key: "removeImage",
        value: function removeImage() {
            this.file = null;
            this.onRemoveEvent.emit(this.mediaConfig.id);
        }
    }, {
        key: "validateOnError",
        value: function validateOnError(file) {
            if (file.reason === 'type') {
                this.messageService.showToaster('e_0', 'companyInformation');
            }
            if (file.reason === 'size') {
                this.messageService.showToaster('e_1', 'companyInformation', this.mediaConfig.maxFileSize.toString());
            }
        }
    }]);

    return MediaDropZoneComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", String)], MediaDropZoneComponent.prototype, "title", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], MediaDropZoneComponent.prototype, "description", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], MediaDropZoneComponent.prototype, "styles", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], MediaDropZoneComponent.prototype, "inputFile", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], MediaDropZoneComponent.prototype, "mediaConfig", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], MediaDropZoneComponent.prototype, "actions", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], MediaDropZoneComponent.prototype, "onDropEventSuccess", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], MediaDropZoneComponent.prototype, "onRemoveEvent", void 0);
MediaDropZoneComponent = __decorate([core_1.Component({
    selector: 'media-drop-zone',
    template: __webpack_require__("./web/modern/components/common/media-drop-zone/media-drop-zone.component.html"),
    styles: [__webpack_require__("./web/modern/components/common/media-drop-zone/media-drop-zone.component.scss")]
}), __metadata("design:paramtypes", [message_service_1.MessageService])], MediaDropZoneComponent);
exports.MediaDropZoneComponent = MediaDropZoneComponent;

/***/ }),

/***/ "./web/modern/components/common/proselect-upload-component/proselect-upload-component.html":
/***/ (function(module, exports) {

module.exports = "<input type=\"file\" name=\"file\" [id]=\"componentId\" [ngClass]=\"classComponent\" [placeholder]=\"placeholder\" [disabled]=\"disabled || loading\" [accept]=\"fileType\" (change)=\"onFileChange($event)\">"

/***/ }),

/***/ "./web/modern/components/common/proselect-upload-component/proselect-upload-component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var ProselectUploadComponent = function () {
    function ProselectUploadComponent(messageService) {
        _classCallCheck(this, ProselectUploadComponent);

        this.messageService = messageService;
        this.disabled = false;
        this.action = new core_1.EventEmitter();
    }

    _createClass(ProselectUploadComponent, [{
        key: "onFileChange",
        value: function onFileChange(event) {
            if (event.target.files && event.target.files.length > 0 && event.target.value !== '') {
                var file = event.target.files[0];
                if (this.validationXmlFile(file)) {
                    this.action.emit(file);
                }
                event.target.value = '';
            }
        }
    }, {
        key: "validationXmlFile",
        value: function validationXmlFile(file) {
            var validation = true;
            if (file.size === 0) {
                this.messageService.showToaster('e_12', 'proSelect');
                validation = false;
            } else if (file.size >= 5000000) {
                // 5mb
                this.messageService.showToaster('e_6', 'proSelect');
                validation = false;
            } else if (file.type !== 'text/xml') {
                this.messageService.showToaster('e_5', 'proSelect');
                validation = false;
            }
            return validation;
        }
    }]);

    return ProselectUploadComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", String)], ProselectUploadComponent.prototype, "classComponent", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], ProselectUploadComponent.prototype, "placeholder", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], ProselectUploadComponent.prototype, "disabled", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], ProselectUploadComponent.prototype, "fileType", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], ProselectUploadComponent.prototype, "componentId", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], ProselectUploadComponent.prototype, "action", void 0);
ProselectUploadComponent = __decorate([core_1.Component({
    selector: 'proselect-upload-component',
    template: __webpack_require__("./web/modern/components/common/proselect-upload-component/proselect-upload-component.html")
}), __metadata("design:paramtypes", [message_service_1.MessageService])], ProselectUploadComponent);
exports.ProselectUploadComponent = ProselectUploadComponent;

/***/ }),

/***/ "./web/modern/components/common/searchbar/searchbar.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"mt-10 mb-10 main-input-item input-search\">\n    <input id=\"search-input\"\n           type=\"text\"\n           class=\"form-control input-search-input\"\n           [formControl]=\"queryField\"\n           placeholder=\"{{placeholder}}\">\n    <label for=\"search-input\" class=\"input-search-label\"></label>\n</div>"

/***/ }),

/***/ "./web/modern/components/common/searchbar/searchbar.scss":
/***/ (function(module, exports) {

module.exports = ""

/***/ }),

/***/ "./web/modern/components/common/searchbar/searchbar.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var forms_1 = __webpack_require__("./node_modules/@angular/forms/esm5/forms.js");
var SearchbarComponent = function () {
    function SearchbarComponent() {
        _classCallCheck(this, SearchbarComponent);

        this.searchChange = new core_1.EventEmitter();
        this.queryField = new forms_1.FormControl();
    }

    _createClass(SearchbarComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            var _this = this;

            this.queryField.valueChanges.debounceTime(this.debounce || 500).distinctUntilChanged().map(function (search) {
                return search.trim();
            }).subscribe(function (search) {
                _this.searchChange.emit(search);
            });
        }
    }]);

    return SearchbarComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", String)], SearchbarComponent.prototype, "placeholder", void 0);
__decorate([core_1.Input(), __metadata("design:type", Number)], SearchbarComponent.prototype, "debounce", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], SearchbarComponent.prototype, "searchChange", void 0);
SearchbarComponent = __decorate([core_1.Component({
    selector: 'sn-searchbar',
    template: __webpack_require__("./web/modern/components/common/searchbar/searchbar.html"),
    styles: [__webpack_require__("./web/modern/components/common/searchbar/searchbar.scss")]
})], SearchbarComponent);
exports.SearchbarComponent = SearchbarComponent;

/***/ }),

/***/ "./web/modern/components/common/show-more-content/show-more-content.component.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"show-more-wrap\">\n    <div class=\"content-wrap text-break-word\"\n         [ngClass]=\"{'gradient': addGradient}\"\n    >\n        <div  #description>\n            <sn-quill-view-web  class=\"innerHTML\" [content]=\"content\"></sn-quill-view-web>\n        </div>\n    </div>\n    <div class=\"show-more-label\" *ngIf=\"addGradient\" (click)=\"showMoreHandler()\">\n        {{ label }}\n        <!--<i class=\"fa\" [ngClass]=\"showMoreFlag ? 'fa-angle-up' : 'fa-angle-down'\" ></i>-->\n    </div>\n</div>\n\n<!--{'show-content': showMoreFlag}-->\n"

/***/ }),

/***/ "./web/modern/components/common/show-more-content/show-more-content.component.scss":
/***/ (function(module, exports) {

module.exports = ":host .show-more-wrap {\n  position: relative;\n  z-index: 10; }\n\n:host .content-wrap {\n  display: block;\n  overflow: hidden;\n  min-height: 155px;\n  max-height: 355px;\n  height: 100%; }\n  :host .content-wrap.show-content {\n    max-height: 100% !important;\n    background: none !important; }\n\n:host .show-more-label {\n  background: -webkit-linear-gradient(top, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.8) 40%, rgba(255, 255, 255, 0.9) 50%, rgba(255, 255, 255, 0.95)) !important;\n  background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.8) 40%, rgba(255, 255, 255, 0.9) 50%, rgba(255, 255, 255, 0.95)) !important;\n  text-align: center;\n  color: #6c6d76;\n  cursor: pointer;\n  position: absolute;\n  bottom: -15px;\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n  font-weight: 500;\n  font-size: 13px;\n  -webkit-transition: all 0.5s;\n  transition: all 0.5s;\n  padding-top: 50px; }\n  :host .show-more-label i {\n    font-size: 18px;\n    vertical-align: bottom;\n    margin: 0 5px; }\n  :host .show-more-label .open i:before {\n    -webkit-transform: scale(-1, 1);\n        -ms-transform: scale(-1, 1);\n            transform: scale(-1, 1); }\n\n:host .innerHTML {\n  position: relative;\n  display: block;\n  width: auto; }\n"

/***/ }),

/***/ "./web/modern/components/common/show-more-content/show-more-content.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var ShowMoreContentComponent = function () {
    function ShowMoreContentComponent() {
        _classCallCheck(this, ShowMoreContentComponent);

        this.emitShowMoreModal = new core_1.EventEmitter();
        this.showMoreFlag = false;
        this.maxHeight = 355; // Default value
        this.label = 'SHOW MORE';
    }

    _createClass(ShowMoreContentComponent, [{
        key: "ngAfterViewInit",
        value: function ngAfterViewInit() {
            this.currentHeight = this.description.nativeElement.offsetHeight;
            this.addGradient = this.currentHeight >= this.maxHeight;
        }
    }, {
        key: "showMoreHandler",
        value: function showMoreHandler() {
            this.showMoreFlag = !this.showMoreFlag;
            // this.label = this.showMoreFlag ? 'SHOW LESS' : 'SHOW MORE';
            this.emitShowMoreModal.emit();
        }
    }]);

    return ShowMoreContentComponent;
}();
__decorate([core_1.Input('content'), __metadata("design:type", String)], ShowMoreContentComponent.prototype, "content", void 0);
__decorate([core_1.Output('emitShowMoreModal'), __metadata("design:type", Object)], ShowMoreContentComponent.prototype, "emitShowMoreModal", void 0);
__decorate([core_1.ViewChild('description'), __metadata("design:type", core_1.ElementRef)], ShowMoreContentComponent.prototype, "description", void 0);
ShowMoreContentComponent = __decorate([core_1.Component({
    selector: 'show-more-content',
    template: __webpack_require__("./web/modern/components/common/show-more-content/show-more-content.component.html"),
    styles: [__webpack_require__("./web/modern/components/common/show-more-content/show-more-content.component.scss")]
}), __metadata("design:paramtypes", [])], ShowMoreContentComponent);
exports.ShowMoreContentComponent = ShowMoreContentComponent;

/***/ }),

/***/ "./web/modern/components/common/sn-date-picker/sn-date-picker.component.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"mydp\" [ngStyle]=\"{'width': opts.showInputField ? opts.width : null, 'border': opts.inline ? 'none' : null}\">\n    <div class=\"selectiongroup\" *ngIf=\"!opts.inline\">\n        <input *ngIf=\"opts.showInputField\" #inputBoxEl ngtype=\"text\" class=\"selection\" [attr.aria-label]=\"opts.ariaLabelInputField\" (click)=\"opts.openSelectorOnInputClick&&inputClicked($event)\" [ngClass]=\"{'invaliddate': invalidDate&&opts.indicateInvalidDate, 'inputnoteditable': opts.openSelectorOnInputClick&&!opts.editableDateField, 'selectiondisabled': opts.componentDisabled}\"\n               placeholder=\"{{placeholder}}\" [ngStyle]=\"{'height': opts.height, 'font-size': opts.selectionTxtFontSize}\" [ngModel]=\"selectionDayTxt\" (ngModelChange)=\"onUserDateInput($event)\" [value]=\"selectionDayTxt\" (keyup)=\"onCloseSelector($event)\"\n               (focus)=\"opts.editableDateField&&onFocusInput($event)\" (blur)=\"opts.editableDateField&&onBlurInput($event)\" [disabled]=\"opts.componentDisabled\" [readonly]=\"!opts.editableDateField\" autocomplete=\"off\" spellcheck=\"false\" autocorrect=\"off\">\n        <div class=\"selbtngroup\" [style.height]=\"opts.height\">\n            <button type=\"button\" [attr.aria-label]=\"opts.ariaLabelDecreaseDate\" class=\"btndecrease\" *ngIf=\"opts.showDecreaseDateBtn\" (click)=\"onDecreaseBtnClicked()\" [ngClass]=\"{'btndecreaseenabled': !opts.componentDisabled, 'btndecreasedisabled': opts.componentDisabled, 'btnleftborderradius': !opts.showInputField}\" [disabled]=\"opts.componentDisabled\">\n                <span class=\"mydpicon icon-mydpleft\"></span>\n            </button>\n            <button type=\"button\" [attr.aria-label]=\"opts.ariaLabelIncreaseDate\" class=\"btnincrease\" *ngIf=\"opts.showIncreaseDateBtn\" (click)=\"onIncreaseBtnClicked()\" [ngClass]=\"{'btnincreaseenabled': !opts.componentDisabled, 'btnincreasedisabled': opts.componentDisabled, 'btnleftborderradius': !opts.showDecreaseDateBtn&&!opts.showInputField}\" [disabled]=\"opts.componentDisabled\">\n                <span class=\"mydpicon icon-mydpright\"></span>\n            </button>\n            <button type=\"button\" [attr.aria-label]=\"opts.ariaLabelClearDate\" class=\"btnclear\" *ngIf=\"selectionDayTxt.length>0&&opts.showClearDateBtn\" (click)=\"removeBtnClicked()\" [ngClass]=\"{'btnclearenabled': !opts.componentDisabled, 'btncleardisabled': opts.componentDisabled, 'btnleftborderradius': !opts.showIncreaseDateBtn&&!opts.showDecreaseDateBtn&&!opts.showInputField}\" [disabled]=\"opts.componentDisabled\">\n                <span class=\"mydpicon icon-mydpremove\"></span>\n            </button>\n            <button type=\"button\" [attr.aria-label]=\"opts.ariaLabelOpenCalendar\" class=\"btnpicker\" (click)=\"openBtnClicked()\" [ngClass]=\"{'btnpickerenabled': !opts.componentDisabled, 'btnpickerdisabled': opts.componentDisabled, 'btnleftborderradius': !opts.showClearDateBtn&&!opts.showIncreaseDateBtn&&!opts.showDecreaseDateBtn&&!opts.showInputField||selectionDayTxt.length===0&&!opts.showInputField}\" [disabled]=\"opts.componentDisabled\">\n                <span class=\"mydpicon icon-mydpcalendar\"></span>\n            </button>\n        </div>\n    </div>\n    <div class=\"selector\" #selectorEl [ngStyle]=\"{'width': opts.selectorWidth, 'height' : opts.selectorHeight, 'bottom': getSelectorTopPosition()}\" *ngIf=\"showSelector||opts.inline\" [mydpfocus]=\"opts.inline?'0':'1'\" [ngClass]=\"{'inlinedp': opts.inline, 'alignselectorright': opts.alignSelectorRight, 'selectorarrow': opts.showSelectorArrow&&!opts.inline, 'selectorarrowleft': opts.showSelectorArrow&&!opts.alignSelectorRight&&!opts.inline, 'selectorarrowright': opts.showSelectorArrow&&opts.alignSelectorRight&&!opts.inline}\" (keyup)=\"onCloseSelector($event)\" tabindex=\"0\">\n        <table class=\"header\">\n            <tr>\n                <td>\n                    <div style=\"float:left\">\n                        <div class=\"headerbtncell\"><button type=\"button\" [attr.aria-label]=\"opts.ariaLabelPrevMonth\" class=\"headerbtn mydpicon icon-mydpleft\" (click)=\"onPrevMonth()\" [disabled]=\"prevMonthDisabled\" [ngClass]=\"{'headerbtnenabled': !prevMonthDisabled, 'headerbtndisabled': prevMonthDisabled}\"></button></div>\n                        <div class=\"headermonthtxt\">\n                            <button class=\"headerlabelbtn\" type=\"button\" [ngClass]=\"{'monthlabel': opts.monthSelector}\" (click)=\"opts.monthSelector&&onSelectMonthClicked($event)\" tabindex=\"{{opts.monthSelector?'0':'-1'}}\">{{ visibleMonth.monthTxt }}</button>\n                        </div>\n                        <div class=\"headerbtncell\"><button type=\"button\" [attr.aria-label]=\"opts.ariaLabelNextMonth\" class=\"headerbtn mydpicon icon-mydpright\" (click)=\"onNextMonth()\" [disabled]=\"nextMonthDisabled\" [ngClass]=\"{'headerbtnenabled': !nextMonthDisabled, 'headerbtndisabled': nextMonthDisabled}\"></button></div>\n                    </div>\n                </td>\n                <td>\n                    <button *ngIf=\"opts.showTodayBtn\" type=\"button\" class=\"headertodaybtn\" (click)=\"onTodayClicked()\" [disabled]=\"disableTodayBtn\" [ngClass]=\"{'headertodaybtnenabled': !disableTodayBtn, 'headertodaybtndisabled': disableTodayBtn}\">\n                        <span class=\"mydpicon icon-mydptoday\"></span>\n                        <span>{{ opts.todayBtnTxt }}</span>\n                    </button>\n                </td>\n                <td>\n                    <div style=\"float:right\">\n                        <div class=\"headerbtncell\"><button type=\"button\" [attr.aria-label]=\"opts.ariaLabelPrevYear\" class=\"headerbtn mydpicon icon-mydpleft\" (click)=\"onPrevYear()\" [disabled]=\"prevYearDisabled\" [ngClass]=\"{'headerbtnenabled': !prevYearDisabled, 'headerbtndisabled': prevYearDisabled}\"></button></div>\n                        <div class=\"headeryeartxt\">\n                            <button class=\"headerlabelbtn\" type=\"button\" [ngClass]=\"{'yearlabel': opts.yearSelector}\" (click)=\"opts.yearSelector&&onSelectYearClicked($event)\" tabindex=\"{{opts.yearSelector?'0':'-1'}}\">{{ visibleMonth.year }}</button>\n                        </div>\n                        <div class=\"headerbtncell\"><button type=\"button\" [attr.aria-label]=\"opts.ariaLabelNextYear\" class=\"headerbtn mydpicon icon-mydpright\" (click)=\"onNextYear()\" [disabled]=\"nextYearDisabled\" [ngClass]=\"{'headerbtnenabled': !nextYearDisabled, 'headerbtndisabled': nextYearDisabled}\"></button></div>\n                    </div>\n                </td>\n            </tr>\n        </table>\n        <table class=\"caltable\" *ngIf=\"!selectMonth&&!selectYear\">\n            <thead><tr><th class=\"weekdaytitle weekdaytitleweeknbr\" *ngIf=\"opts.showWeekNumbers&&opts.firstDayOfWeek==='mo'\">#</th><th class=\"weekdaytitle\" scope=\"col\" *ngFor=\"let d of weekDays\">{{ d }}</th></tr></thead>\n            <tbody>\n            <tr *ngFor=\"let w of dates\">\n                <td class=\"daycell daycellweeknbr\" *ngIf=\"opts.showWeekNumbers&&opts.firstDayOfWeek==='mo'\">{{ w.weekNbr }}</td>\n                <td class=\"daycell\" *ngFor=\"let d of w.week\" [ngClass]=\"{'currmonth':d.cmo===currMonthId&&!d.disabled, 'selectedday':selectedDate.day===d.dateObj.day && selectedDate.month===d.dateObj.month && selectedDate.year===d.dateObj.year && d.cmo===currMonthId, 'disabled': d.disabled, 'tablesingleday':(!opts.allowSelectionOnlyInCurrentMonth||d.cmo===currMonthId&&opts.allowSelectionOnlyInCurrentMonth)&&!d.disabled}\" (click)=\"!d.disabled&&onCellClicked(d);$event.stopPropagation()\" (keydown)=\"onCellKeyDown($event, d)\" tabindex=\"0\">\n                    <div *ngIf=\"d.markedDate.marked\" class=\"markdate\" [ngStyle]=\"{'background-color': d.markedDate.color}\"></div>\n                    <div class=\"datevalue\" [ngClass]=\"{'prevmonth':d.cmo===prevMonthId,'currmonth':d.cmo===currMonthId,'nextmonth':d.cmo===nextMonthId,'highlight':d.highlight}\">\n                        <span [ngClass]=\"{'markcurrday':d.currDay&&opts.markCurrentDay, 'dimday': d.highlight && (d.cmo===prevMonthId || d.cmo===nextMonthId || d.disabled)}\">{{ d.dateObj.day }}</span>\n                    </div>\n                </td>\n            </tr>\n            </tbody>\n        </table>\n        <table class=\"monthtable\" *ngIf=\"selectMonth\">\n            <tbody>\n            <tr *ngFor=\"let mr of months\">\n                <td class=\"monthcell tablesinglemonth\" [ngClass]=\"{'selectedmonth': m.selected, 'disabled': m.disabled}\" *ngFor=\"let m of mr\" (click)=\"!m.disabled&&onMonthCellClicked(m);$event.stopPropagation()\" (keydown)=\"onMonthCellKeyDown($event, m)\" tabindex=\"0\">\n                    <div class=\"monthvalue\" [ngClass]=\"{'markcurrmonth':m.currMonth&&opts.markCurrentMonth}\">{{ m.name }}</div>\n                </td>\n            </tr>\n            </tbody>\n        </table>\n        <table class=\"yeartable\" *ngIf=\"selectYear\">\n            <tbody>\n            <tr>\n                <td colspan=\"5\" class=\"yearchangebtncell\" (click)=\"$event.stopPropagation()\">\n                    <button type=\"button\" class=\"yearchangebtn mydpicon icon-mydpup\" (click)=\"onPrevYears($event, years[0][0].year)\" [disabled]=\"prevYearsDisabled\" [ngClass]=\"{'yearchangebtnenabled': !prevYearsDisabled, 'yearchangebtndisabled': prevYearsDisabled}\"></button>\n                </td>\n            </tr>\n            <tr *ngFor=\"let yr of years\">\n                <td class=\"yearcell tablesingleyear\" [ngClass]=\"{'selectedyear': y.selected, 'disabled': y.disabled}\" *ngFor=\"let y of yr\" (click)=\"!y.disabled&&onYearCellClicked(y);$event.stopPropagation()\" (keydown)=\"onYearCellKeyDown($event, y)\" tabindex=\"0\">\n                    <div class=\"yearvalue\" [ngClass]=\"{'markcurryear':y.currYear&&opts.markCurrentYear}\">{{ y.year }}</div>\n                </td>\n            </tr>\n            <tr>\n                <td colspan=\"5\" class=\"yearchangebtncell\" (click)=\"$event.stopPropagation()\">\n                    <button type=\"button\" class=\"yearchangebtn mydpicon icon-mydpdown\" (click)=\"onNextYears($event, years[0][0].year)\" [disabled]=\"nextYearsDisabled\" [ngClass]=\"{'yearchangebtnenabled': !nextYearsDisabled, 'yearchangebtndisabled': nextYearsDisabled}\"></button>\n                </td>\n            </tr>\n            </tbody>\n        </table>\n    </div>\n</div>"

/***/ }),

/***/ "./web/modern/components/common/sn-date-picker/sn-date-picker.component.scss":
/***/ (function(module, exports) {

module.exports = ".mydp {\n  line-height: 1.1;\n  display: inline-block;\n  position: relative; }\n\n.mydp * {\n  box-sizing: border-box;\n  font-family: Arial, Helvetica, sans-serif;\n  padding: 0;\n  margin: 0; }\n\n.mydp,\n.mydp .selectiongroup,\n.mydp .selection,\n.mydp .selector,\n.mydp .headertodaybtn {\n  border-radius: 4px; }\n\n.mydp .header {\n  border-radius: 4px 4px 0 0; }\n\n.mydp .caltable,\n.mydp .monthtable,\n.mydp .yeartable {\n  border-radius: 0 0 4px 4px; }\n\n.mydp .caltable tbody tr:nth-child(6) td:first-child,\n.mydp .monthtable tbody tr:nth-child(4) td:first-child,\n.mydp .yeartable tbody tr:nth-child(7) td:first-child {\n  border-bottom-left-radius: 4px; }\n\n.mydp .caltable tbody tr:nth-child(6) td:last-child,\n.mydp .monthtable tbody tr:nth-child(4) td:last-child,\n.mydp .yeartable tbody tr:nth-child(7) td:last-child {\n  border-bottom-right-radius: 4px; }\n\n.mydp .btnpicker {\n  border-radius: 0 4px 4px 0; }\n\n.mydp .btnleftborderradius {\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px; }\n\n.mydp .selector {\n  margin-top: 2px;\n  margin-left: -1px;\n  position: absolute;\n  padding: 0;\n  border: 1px solid #ccc;\n  z-index: 100;\n  -webkit-animation: selectorfadein 0.1s;\n          animation: selectorfadein 0.1s; }\n\n.mydp .selector:focus {\n  border: 1px solid #add8e6;\n  outline: none; }\n\n@-webkit-keyframes selectorfadein {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@keyframes selectorfadein {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n.mydp .selectorarrow {\n  background: #fafafa;\n  margin-top: 12px;\n  padding: 0; }\n\n.mydp .selectorarrow:after,\n.mydp .selectorarrow:before {\n  bottom: 100%;\n  border: solid transparent;\n  content: ' ';\n  height: 0;\n  width: 0;\n  position: absolute; }\n\n.mydp .selectorarrow:after {\n  border-color: rgba(250, 250, 250, 0);\n  border-bottom-color: #fafafa;\n  border-width: 10px;\n  margin-left: -10px; }\n\n.mydp .selectorarrow:before {\n  border-color: rgba(204, 204, 204, 0);\n  border-bottom-color: #ccc;\n  border-width: 11px;\n  margin-left: -11px; }\n\n.mydp .selectorarrow:focus:before {\n  border-bottom-color: #add8e6; }\n\n.mydp .selectorarrowleft:after,\n.mydp .selectorarrowleft:before {\n  left: 24px; }\n\n.mydp .selectorarrowright:after,\n.mydp .selectorarrowright:before {\n  left: 86%; }\n\n.mydp .alignselectorright {\n  right: -1px; }\n\n.mydp .selectiongroup {\n  position: relative;\n  display: table;\n  border: none;\n  border-spacing: 0;\n  background-color: #fff; }\n\n.mydp .selection {\n  width: 100%;\n  outline: none;\n  background-color: #fff;\n  display: table-cell;\n  position: absolute;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  padding-left: 6px;\n  border: none;\n  color: #555; }\n\n.mydp .invaliddate {\n  background-color: #f1dede; }\n\n.mydp ::-ms-clear {\n  display: none; }\n\n.mydp .selbtngroup {\n  position: relative;\n  vertical-align: middle;\n  white-space: nowrap;\n  width: 1%;\n  display: table-cell;\n  font-size: 0; }\n\n.mydp .btnpicker,\n.mydp .btnclear,\n.mydp .btndecrease,\n.mydp .btnincrease {\n  height: 100%;\n  width: 26px;\n  border: none;\n  padding: 0;\n  outline: 0;\n  font: inherit;\n  -moz-user-select: none; }\n\n.mydp .btnleftborder {\n  border-left: 1px solid #ccc; }\n\n.mydp .btnpickerenabled,\n.mydp .btnclearenabled,\n.mydp .btndecreaseenabled,\n.mydp .btnincreaseenabled,\n.mydp .headertodaybtnenabled,\n.mydp .headerbtnenabled,\n.mydp .yearchangebtnenabled {\n  cursor: pointer; }\n\n.mydp .selectiondisabled,\n.mydp .btnpickerdisabled,\n.mydp .btncleardisabled,\n.mydp .btndecreasedisabled,\n.mydp .btnincreasedisabled,\n.mydp .headertodaybtndisabled,\n.mydp .headerbtndisabled,\n.mydp .yearchangebtndisabled {\n  cursor: not-allowed;\n  opacity: 0.65; }\n\n.mydp .selectiondisabled {\n  background-color: #eee; }\n\n.mydp .btnpicker,\n.mydp .btnclear,\n.mydp .btndecrease,\n.mydp .btnincrease,\n.mydp .headertodaybtn {\n  background: #fff; }\n\n.mydp .header {\n  width: 100%;\n  height: 30px;\n  background-color: #fafafa; }\n\n.mydp .header td {\n  vertical-align: middle;\n  border: none;\n  line-height: 0; }\n\n.mydp .header td:nth-child(1) {\n  padding-left: 4px; }\n\n.mydp .header td:nth-child(2) {\n  text-align: center; }\n\n.mydp .header td:nth-child(3) {\n  padding-right: 4px; }\n\n.mydp .caltable,\n.mydp .monthtable,\n.mydp .yeartable {\n  table-layout: fixed;\n  width: 100%;\n  height: -webkit-calc(100% - 30px);\n  height: calc(100% - 30px);\n  background-color: #fff;\n  font-size: 14px; }\n\n.mydp .caltable,\n.mydp .monthtable,\n.mydp .yeartable,\n.mydp .weekdaytitle,\n.mydp .daycell,\n.mydp .monthcell,\n.mydp .yearcell {\n  border-collapse: collapse;\n  color: #003366;\n  line-height: 1.1; }\n\n.mydp .weekdaytitle,\n.mydp .daycell,\n.mydp .monthcell,\n.mydp .yearcell {\n  padding: 4px;\n  text-align: center; }\n\n.mydp .weekdaytitle {\n  background-color: #ddd;\n  font-size: 11px;\n  font-weight: normal;\n  vertical-align: middle;\n  max-width: 36px;\n  overflow: hidden;\n  white-space: nowrap; }\n\n.mydp .weekdaytitleweeknbr {\n  width: 20px;\n  border-right: 1px solid #bbb; }\n\n.mydp .monthcell {\n  background-color: #fafafa;\n  overflow: hidden;\n  white-space: nowrap;\n  width: 33% !important; }\n\n.mydp .yearcell {\n  background-color: #fafafa;\n  width: 20%; }\n\n.mydp .daycell .datevalue {\n  background-color: inherit;\n  vertical-align: middle; }\n\n.mydp .daycell .datevalue span {\n  vertical-align: middle; }\n\n.mydp .daycellweeknbr {\n  font-size: 10px;\n  border-right: 1px solid #ccc;\n  cursor: default;\n  color: #000; }\n\n.mydp .inlinedp {\n  position: relative;\n  margin-top: -1px; }\n\n.mydp .prevmonth,\n.mydp .nextmonth {\n  color: #999; }\n\n.mydp .disabled {\n  cursor: default !important;\n  color: #ccc;\n  background: #fbefef; }\n\n.mydp .highlight {\n  color: #c30000; }\n\n.mydp .dimday {\n  opacity: 0.5; }\n\n.mydp .currmonth {\n  background-color: #f6f6f6;\n  font-weight: normal; }\n\n.mydp .markdate {\n  position: absolute;\n  width: 4px;\n  height: 4px;\n  border-radius: 4px; }\n\n.mydp .markcurrday,\n.mydp .markcurrmonth,\n.mydp .markcurryear {\n  text-decoration: underline; }\n\n.mydp .selectedday .datevalue,\n.mydp .selectedmonth .monthvalue,\n.mydp .selectedyear .yearvalue {\n  border: none;\n  background-color: #8ebfff;\n  border-radius: 2px; }\n\n.mydp .headerbtncell {\n  background-color: #fafafa;\n  display: table-cell;\n  vertical-align: middle; }\n\n.mydp .yearchangebtncell {\n  text-align: center;\n  background-color: #fafafa; }\n\n.mydp .headerbtn,\n.mydp .headerlabelbtn,\n.mydp .yearchangebtn {\n  background: #fafafa;\n  border: none;\n  height: 22px; }\n\n.mydp .headerbtn {\n  width: 16px; }\n\n.mydp .headerlabelbtn {\n  font-size: 14px;\n  outline: none;\n  cursor: default; }\n\n.mydp,\n.mydp .headertodaybtn {\n  border: 1px solid #ccc; }\n\n.mydp .btnpicker,\n.mydp .btnclear,\n.mydp .btndecrease,\n.mydp .btnincrease,\n.mydp .headerbtn,\n.mydp .headermonthtxt,\n.mydp .headeryeartxt,\n.mydp .headertodaybtn,\n.mydp .yearchangebtn {\n  color: #000; }\n\n.mydp .headertodaybtn {\n  padding: 0 4px;\n  font-size: 11px;\n  height: 22px;\n  min-width: 60px;\n  max-width: 84px;\n  overflow: hidden;\n  white-space: nowrap; }\n\n.mydp button::-moz-focus-inner {\n  border: 0; }\n\n.mydp .headermonthtxt,\n.mydp .headeryeartxt {\n  text-align: center;\n  display: table-cell;\n  vertical-align: middle;\n  font-size: 14px;\n  height: 26px;\n  width: 40px;\n  max-width: 40px;\n  overflow: hidden;\n  white-space: nowrap; }\n\n.mydp .btnclear:focus,\n.mydp .btndecrease:focus,\n.mydp .btnincrease:focus,\n.mydp .btnpicker:focus,\n.mydp .headertodaybtn:focus {\n  background: #add8e6; }\n\n.mydp .headerbtn:focus,\n.mydp .monthlabel:focus,\n.mydp .yearlabel:focus,\n.mydp .yearchangebtn:focus {\n  color: #add8e6;\n  outline: none; }\n\n.mydp .daycell:focus,\n.mydp .monthcell:focus,\n.mydp .yearcell:focus {\n  outline: 1px solid #ccc; }\n\n.mydp .icon-mydpcalendar,\n.mydp .icon-mydpremove {\n  font-size: 16px; }\n\n.mydp .icon-mydpleft,\n.mydp .icon-mydpright,\n.mydp .icon-mydpup,\n.mydp .icon-mydpdown {\n  color: #222;\n  font-size: 20px; }\n\n.mydp .btndecrease .icon-mydpleft,\n.mydp .btnincrease .icon-mydpright {\n  font-size: 16px; }\n\n.mydp .icon-mydptoday {\n  color: #222;\n  font-size: 11px; }\n\n.mydp table {\n  display: table;\n  border-spacing: 0; }\n\n.mydp table td {\n  padding: 0; }\n\n.mydp table,\n.mydp th,\n.mydp td {\n  border: none; }\n\n.mydp .btnpickerenabled:hover,\n.mydp .btnclearenabled:hover,\n.mydp .btndecreaseenabled:hover,\n.mydp .btnincreaseenabled:hover,\n.mydp .headertodaybtnenabled:hover {\n  background-color: #e6e6e6; }\n\n.mydp .tablesingleday:hover,\n.mydp .tablesinglemonth:hover,\n.mydp .tablesingleyear:hover {\n  background-color: #ddd; }\n\n.mydp .monthlabel,\n.mydp .yearlabel,\n.mydp .inputnoteditable,\n.mydp .daycell,\n.mydp .monthcell,\n.mydp .yearcell {\n  cursor: pointer; }\n\n.mydp .headerbtnenabled:hover,\n.mydp .yearchangebtnenabled:hover,\n.mydp .monthlabel:hover,\n.mydp .yearlabel:hover {\n  color: #777; }\n\n@font-face {\n  font-family: 'mydatepicker';\n  src: url(\"data:application/octet-stream;base64,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\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal; }\n\n.mydp .mydpicon {\n  font-family: 'mydatepicker';\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale; }\n\n.mydp .icon-mydpright:before {\n  content: '\\e800'; }\n\n.mydp .icon-mydpleft:before {\n  content: '\\e801'; }\n\n.mydp .icon-mydptoday:before {\n  content: '\\e802'; }\n\n.mydp .icon-mydpcalendar:before {\n  content: '\\e803'; }\n\n.mydp .icon-mydpup:before {\n  content: '\\e804'; }\n\n.mydp .icon-mydpdown:before {\n  content: '\\e805'; }\n\n.mydp .icon-mydpremove:before {\n  content: '\\e806'; }\n"

/***/ }),

/***/ "./web/modern/components/common/sn-date-picker/sn-date-picker.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var forms_1 = __webpack_require__("./node_modules/@angular/forms/esm5/forms.js");
var mydatepicker_1 = __webpack_require__("./node_modules/mydatepicker/index.js");
var my_date_picker_locale_service_1 = __webpack_require__("./node_modules/mydatepicker/dist/services/my-date-picker.locale.service.js");
var my_date_picker_util_service_1 = __webpack_require__("./node_modules/mydatepicker/dist/services/my-date-picker.util.service.js");
exports.MYDP_VALUE_ACCESSOR = {
    provide: forms_1.NG_VALUE_ACCESSOR,
    useExisting: core_1.forwardRef(function () {
        return SnDatePickerComponent;
    }),
    multi: true
};
var SnDatePickerComponent = function (_mydatepicker_1$MyDat) {
    _inherits(SnDatePickerComponent, _mydatepicker_1$MyDat);

    function SnDatePickerComponent(_elem, _renderer, _cdr, _localeService, _utilService) {
        _classCallCheck(this, SnDatePickerComponent);

        var _this = _possibleConstructorReturn(this, (SnDatePickerComponent.__proto__ || Object.getPrototypeOf(SnDatePickerComponent)).call(this, _elem, _renderer, _cdr, _localeService, _utilService));

        _this._elem = _elem;
        _this._renderer = _renderer;
        _this._cdr = _cdr;
        _this._localeService = _localeService;
        _this._utilService = _utilService;
        return _this;
    }

    _createClass(SnDatePickerComponent, [{
        key: "inputClicked",
        value: function inputClicked(e) {
            if (this.snDatePicker) {
                return;
            }
            this.openBtnClicked();
            setTimeout(function () {
                e.target.focus();
            }, 0);
        }
    }, {
        key: "onUserDateInput",
        value: function onUserDateInput(value) {
            if (value.length === 0) {
                if (this._utilService.isInitializedDate(this.selectedDate)) {
                    this.clearDate();
                } else {
                    this.invalidInputFieldChanged(value);
                }
            } else {
                var date = this._utilService.isDateValid(value, this.opts.dateFormat, this.opts.minYear, this.opts.maxYear, this.opts.disableUntil, this.opts.disableSince, this.opts.disableWeekends, this.opts.disableWeekdays, this.opts.disableDays, this.opts.disableDateRanges, this.opts.monthLabels, this.opts.enableDays);
                if (this._utilService.isInitializedDate(date)) {
                    if (!this._utilService.isSameDate(date, this.selectedDate)) {
                        this.selectDate(date);
                    } else {
                        this.updateDateValue(date);
                    }
                } else {
                    this.invalidInputFieldChanged(value);
                }
            }
        }
    }, {
        key: "selectDate",
        value: function selectDate(date, closeReason) {
            this.updateDateValue(date);
            if (this.showSelector && closeReason) {
                this.calendarToggle.emit(closeReason);
                this.showSelector = false;
            } else {
                this.setVisibleMonth();
            }
        }
    }]);

    return SnDatePickerComponent;
}(mydatepicker_1.MyDatePicker);
__decorate([core_1.ViewChild('selectorEl'), __metadata("design:type", core_1.ElementRef)], SnDatePickerComponent.prototype, "snDatePicker", void 0);
SnDatePickerComponent = __decorate([core_1.Component({
    selector: 'sn-date-picker',
    template: __webpack_require__("./web/modern/components/common/sn-date-picker/sn-date-picker.component.html"),
    styles: [__webpack_require__("./web/modern/components/common/sn-date-picker/sn-date-picker.component.scss")],
    providers: [my_date_picker_locale_service_1.LocaleService, my_date_picker_util_service_1.UtilService, exports.MYDP_VALUE_ACCESSOR],
    encapsulation: core_1.ViewEncapsulation.None
}), __metadata("design:paramtypes", [core_1.ElementRef, core_1.Renderer, core_1.ChangeDetectorRef, my_date_picker_locale_service_1.LocaleService, my_date_picker_util_service_1.UtilService])], SnDatePickerComponent);
exports.SnDatePickerComponent = SnDatePickerComponent;

/***/ }),

/***/ "./web/modern/components/common/sn-date-range-picker/sn-date-range-picker.component.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"sn-drppicker\" #pickerContainer\n     [ngClass]=\"{\n    ltr: locale.direction === 'ltr',\n    rtl: this.locale.direction === 'rtl',\n    'shown': isShown || inline,\n    'hidden': !isShown && !inline,\n    'inline': inline,\n    'double': !singleDatePicker && showCalInRanges,\n    'show-ranges': rangesArray.length\n}\" [class]=\"'drops-' + drops + '-' + opens\">\n    <div class=\"ranges\">\n        <ul>\n            <li *ngFor=\"let range of rangesArray\">\n                <button type=\"button\"\n                        (click)=\"clickRange($event, range)\"\n                        [disabled]=\"disableRange(range)\"\n                        [ngClass]=\"{'active': range === chosenRange}\">{{ range }}</button>\n            </li>\n        </ul>\n    </div>\n    <div class=\"calendar\" [ngClass]=\"{right: singleDatePicker, left: !singleDatePicker}\"\n         *ngIf=\"showCalInRanges\">\n        <div class=\"form-group has-feedback has-feedback-left mb-0\">\n            <input type=\"text\" [ngModel]=\"startDate | date: calendarInputsFormat\" (focus)=setCurrentStart($event) (change)=\"changeStart($event)\" id=\"startDateInput\" class=\"form-control\">\n            <span class=\"form-control-feedback sn-daterangeicon\"></span>\n        </div>\n        <div class=\"calendar-table\">\n            <table class=\"table-condensed\" *ngIf=\"calendarVariables\">\n                <thead>\n                <tr>\n                    <th *ngIf=\"showWeekNumbers || showISOWeekNumbers\"></th>\n                    <ng-container *ngIf=\"!calendarVariables.left.minDate || calendarVariables.left.minDate.isBefore(calendarVariables.left.calendar.firstDay) && (!this.linkedCalendars || true)\">\n                        <th (click)=\"clickPrev(sideEnum.left)\" class=\"prev available\" >\n                        </th>\n                    </ng-container>\n                    <ng-container *ngIf=\"!(!calendarVariables.left.minDate || calendarVariables.left.minDate.isBefore(calendarVariables.left.calendar.firstDay) && (!this.linkedCalendars || true))\">\n                        <th></th>\n                    </ng-container>\n                    <th colspan=\"5\" class=\"month drp-animate\">\n                        <ng-container *ngIf=\"showDropdowns && calendarVariables.left.dropdowns\">\n                            <div>\n                                {{ this.locale.monthNames[calendarVariables?.left?.calendar[1][1].month()] }}\n                                <select class=\"monthselect\" (change)=\"monthChanged($event, sideEnum.left)\">\n                                    <option\n                                            [disabled]=\"(calendarVariables.left.dropdowns.inMinYear && m < calendarVariables.left.minDate.month()) || (calendarVariables.left.dropdowns.inMaxYear && m > calendarVariables.left.maxDate.month())\"\n                                            *ngFor=\"let m of calendarVariables.left.dropdowns.monthArrays\" [value]=\"m\" [selected]=\"calendarVariables.left.dropdowns.currentMonth == m\">\n                                        {{ locale.monthNames[m] }}\n                                    </option>\n                                </select>\n                                <div class=\"select-arrow-wrapper\"><div class=\"select-arrow\"></div></div>\n                            </div>\n                            <div>\n                                {{ calendarVariables?.left?.calendar[1][1].format(\" YYYY\") }}\n                                <select class=\"yearselect\"  (change)=\"yearChanged($event, sideEnum.left)\">\n                                    <option *ngFor=\"let y of yearRangeLeft\" [selected]=\"y === calendarVariables.left.dropdowns.currentYear\">\n                                        {{ y }}\n                                    </option>\n                                </select>\n                                <div class=\"select-arrow-wrapper\"><div class=\"select-arrow\"></div></div>\n                            </div>\n                        </ng-container>\n                        <ng-container *ngIf=\"!showDropdowns || !calendarVariables.left.dropdowns\">\n                            {{ this.locale.monthNames[calendarVariables?.left?.calendar[1][1].month()] }}  {{ calendarVariables?.left?.calendar[1][1].format(\" YYYY\") }}\n                        </ng-container>\n                    </th>\n                    <ng-container *ngIf=\"(!calendarVariables.left.maxDate || calendarVariables.left.maxDate.isAfter(calendarVariables.left.calendar.lastDay)) && (!linkedCalendars || singleDatePicker )\">\n                        <th class=\"next available\" (click)=\"clickNext(sideEnum.left)\">\n                        </th>\n                    </ng-container>\n                    <ng-container *ngIf=\"!((!calendarVariables.left.maxDate || calendarVariables.left.maxDate.isAfter(calendarVariables.left.calendar.lastDay)) && (!linkedCalendars || singleDatePicker ))\">\n                        <th></th>\n                    </ng-container>\n                </tr>\n                <tr>\n                    <th *ngIf=\"showWeekNumbers || showISOWeekNumbers\" class=\"week\"><span>{{ this.locale.weekLabel }}</span></th>\n                    <th *ngFor=\"let dayofweek of locale.daysOfWeek\"><span>{{ dayofweek }}</span></th>\n                </tr>\n                </thead>\n                <tbody class=\"drp-animate\">\n                <tr *ngFor=\"let row of calendarVariables.left.calRows\" [class]=\"calendarVariables.left.classes[row].classList\">\n                    <!-- add week number -->\n                    <td  class=\"week\" *ngIf=\"showWeekNumbers\">\n                        <span>{{ calendarVariables.left.calendar[row][0].week() }}</span>\n                    </td>\n                    <td class=\"week\" *ngIf=\"showISOWeekNumbers\">\n                        <span>{{ calendarVariables.left.calendar[row][0].isoWeek() }}</span>\n                    </td>\n                    <!-- cal -->\n                    <td *ngFor=\"let col of calendarVariables.left.calCols\" (click)=\"clickDate($event, sideEnum.left, row, col)\">\n                        <div [class]=\"calendarVariables.left.classes[row][col]\">\n                            <span>{{ calendarVariables.left.calendar[row][col].date() }}</span>\n                        </div>\n                    </td>\n                </tr>\n                </tbody>\n            </table>\n        </div>\n        <div class=\"calendar-time\" *ngIf=\"timePicker\">\n            <select class=\"hourselect\" [disabled]=\"!endDate\" [(ngModel)]=\"timepickerVariables.left.selectedHour\" (ngModelChange)=\"timeChanged($event, sideEnum.left)\">\n                <option *ngFor=\"let i of timepickerVariables.left.hours\"\n                        [value]=\"i\"\n                        [disabled]=\"timepickerVariables.left.disabledHours.indexOf(i) > -1\">{{ i }}</option>\n            </select>\n            <select class=\"minuteselect\" [disabled]=\"!endDate\" [(ngModel)]=\"timepickerVariables.left.selectedMinute\" (ngModelChange)=\"timeChanged($event, sideEnum.left)\">\n                <option *ngFor=\"let i of timepickerVariables.left.minutes; let index = index;\"\n                        [value]=\"i\"\n                        [disabled]=\"timepickerVariables.left.disabledMinutes.indexOf(i) > -1\">{{ timepickerVariables.left.minutesLabel[index] }}</option>\n            </select>\n            <select  *ngIf=\"timePickerSeconds\" class=\"secondselect\" [disabled]=\"!endDate\" [(ngModel)]=\"timepickerVariables.left.selectedSecond\" (ngModelChange)=\"timeChanged($event, sideEnum.left)\">\n                <option *ngFor=\"let i of timepickerVariables.left.seconds; let index = index;\"\n                        [value]=\"i\"\n                        [disabled]=\"timepickerVariables.left.disabledSeconds.indexOf(i) > -1\">{{ timepickerVariables.left.secondsLabel[index] }}</option>\n            </select>\n            <select *ngIf=\"!timePicker24Hour\" class=\"ampmselect\" [(ngModel)]=\"timepickerVariables.left.ampmModel\" (ngModelChange)=\"timeChanged($event, sideEnum.left)\">\n                <option value=\"AM\" [disabled]=\"timepickerVariables.left.amDisabled\">AM</option>\n                <option value=\"PM\"  [disabled]=\"timepickerVariables.left.pmDisabled\">PM</option>\n            </select>\n        </div>\n    </div>\n    <div class=\"calendar right\"\n         *ngIf=\"showCalInRanges && !singleDatePicker\"\n    >\n        <div class=\"form-group has-feedback has-feedback-left mb-0\">\n            <input type=\"text\" [ngModel]=\"endDate | date: calendarInputsFormat\" (focus)=setCurrentEnd($event) (change)=\"changeEnd($event)\" id=\"endDateInput\" class=\"form-control\">\n            <span class=\"form-control-feedback sn-daterangeicon\"></span>\n        </div>\n        <div class=\"calendar-table\">\n            <table class=\"table-condensed\" *ngIf=\"calendarVariables\">\n                <thead>\n                <tr>\n                    <th *ngIf=\"showWeekNumbers || showISOWeekNumbers\"></th>\n                    <ng-container *ngIf=\"(!calendarVariables.right.minDate || calendarVariables.right.minDate.isBefore(calendarVariables.right.calendar.firstDay)) && (!this.linkedCalendars)\">\n                        <th (click)=\"clickPrev(sideEnum.right)\" class=\"prev available\" >\n                        </th>\n                    </ng-container>\n                    <ng-container *ngIf=\"!((!calendarVariables.right.minDate || calendarVariables.right.minDate.isBefore(calendarVariables.right.calendar.firstDay)) && (!this.linkedCalendars))\">\n                        <th></th>\n                    </ng-container>\n                    <th colspan=\"5\" class=\"month\">\n                        <ng-container *ngIf=\"showDropdowns && calendarVariables.right.dropdowns\">\n                            <div>\n                                {{ this.locale.monthNames[calendarVariables?.right?.calendar[1][1].month()] }}\n                                <select class=\"monthselect\" (change)=\"monthChanged($event, sideEnum.right)\">\n                                    <option\n                                            [disabled]=\"(calendarVariables.right.dropdowns.inMinYear && m < calendarVariables.right.minDate.month()) || (calendarVariables.right.dropdowns.inMaxYear && m > calendarVariables.right.maxDate.month())\"\n                                            *ngFor=\"let m of calendarVariables.right.dropdowns.monthArrays\" [value]=\"m\" [selected]=\"calendarVariables.right.dropdowns.currentMonth == m\">\n                                        {{ locale.monthNames[m] }}\n                                    </option>\n                                </select>\n                                <div class=\"select-arrow-wrapper\"><div class=\"select-arrow\"></div></div>\n                            </div>\n                            <div>\n                                {{ calendarVariables?.right?.calendar[1][1].format(\" YYYY\") }}\n                                <select class=\"yearselect\" (change)=\"yearChanged($event, sideEnum.right)\">\n                                    <option *ngFor=\"let y of yearRangeRight\"\n                                            [disabled]=\"(calendarVariables.right.dropdowns.inMinYear && y < calendarVariables.right.minDate.year()) || (calendarVariables.right.dropdowns.inMaxYear && y > calendarVariables.right.maxDate.year())\"\n                                            [selected]=\"y === calendarVariables.right.dropdowns.currentYear\">\n                                        {{ y }}\n                                    </option>\n                                </select>\n                                <div class=\"select-arrow-wrapper\"><div class=\"select-arrow\"></div></div>\n                            </div>\n                        </ng-container>\n                        <ng-container *ngIf=\"!showDropdowns || !calendarVariables.right.dropdowns\">\n                            {{ this.locale.monthNames[calendarVariables?.right?.calendar[1][1].month()] }}  {{ calendarVariables?.right?.calendar[1][1].format(\" YYYY\") }}\n                        </ng-container>\n                    </th>\n                    <ng-container *ngIf=\"!calendarVariables.right.maxDate || calendarVariables.right.maxDate.isAfter(calendarVariables.right.calendar.lastDay) && (!linkedCalendars || singleDatePicker || true)\">\n                        <th class=\"next available\" (click)=\"clickNext(sideEnum.right)\">\n                        </th>\n                    </ng-container>\n                    <ng-container *ngIf=\"!(!calendarVariables.right.maxDate || calendarVariables.right.maxDate.isAfter(calendarVariables.right.calendar.lastDay) && (!linkedCalendars || singleDatePicker || true))\">\n                        <th></th>\n                    </ng-container>\n                </tr>\n\n                <tr>\n                    <th *ngIf=\"showWeekNumbers || showISOWeekNumbers\" class=\"week\"><span>{{ this.locale.weekLabel }}</span></th>\n                    <th *ngFor=\"let dayofweek of locale.daysOfWeek\"><span>{{ dayofweek }}</span></th>\n                </tr>\n                </thead>\n                <tbody>\n                <tr *ngFor=\"let row of calendarVariables.right.calRows\" [class]=\"calendarVariables.right.classes[row].classList\">\n                    <td class=\"week\" *ngIf=\"showWeekNumbers\">\n                        <span>{{ calendarVariables.right.calendar[row][0].week() }}</span>\n                    </td>\n                    <td class=\"week\" *ngIf=\"showISOWeekNumbers\">\n                        <span>{{ calendarVariables.right.calendar[row][0].isoWeek() }}</span>\n                    </td>\n                    <td *ngFor=\"let col of calendarVariables.right.calCols\" (click)=\"clickDate($event, sideEnum.right, row, col)\">\n                        <div [class]=\"calendarVariables.right.classes[row][col]\">\n                            <span>{{ calendarVariables.right.calendar[row][col].date() }}</span>\n                        </div>\n                    </td>\n                </tr>\n                </tbody>\n            </table>\n        </div>\n        <div class=\"calendar-time\" *ngIf=\"timePicker\">\n            <select class=\"hourselect\" [disabled]=\"!endDate\" [(ngModel)]=\"timepickerVariables.right.selectedHour\" (ngModelChange)=\"timeChanged($event, sideEnum.right)\">\n                <option *ngFor=\"let i of timepickerVariables.right.hours\"\n                        [value]=\"i\"\n                        [disabled]=\"timepickerVariables.right.disabledHours.indexOf(i) > -1\">{{ i }}</option>\n            </select>\n            <select class=\"minuteselect\" [disabled]=\"!endDate\" [(ngModel)]=\"timepickerVariables.right.selectedMinute\" (ngModelChange)=\"timeChanged($event, sideEnum.right)\">\n                <option *ngFor=\"let i of timepickerVariables.right.minutes; let index = index;\"\n                        [value]=\"i\"\n                        [disabled]=\"timepickerVariables.right.disabledMinutes.indexOf(i) > -1\">{{ timepickerVariables.right.minutesLabel[index] }}</option>\n            </select>\n            <select *ngIf=\"timePickerSeconds\" class=\"secondselect\" [disabled]=\"!endDate\" [(ngModel)]=\"timepickerVariables.right.selectedSecond\" (ngModelChange)=\"timeChanged($event, sideEnum.right)\">\n                <option *ngFor=\"let i of timepickerVariables.right.seconds; let index = index;\"\n                        [value]=\"i\"\n                        [disabled]=\"timepickerVariables.right.disabledSeconds.indexOf(i) > -1\">{{ timepickerVariables.right.secondsLabel[index] }}</option>\n            </select>\n            <select *ngIf=\"!timePicker24Hour\" class=\"ampmselect\" [(ngModel)]=\"timepickerVariables.right.ampmModel\" (ngModelChange)=\"timeChanged($event, sideEnum.right)\">\n                <option value=\"AM\" [disabled]=\"timepickerVariables.right.amDisabled\">AM</option>\n                <option value=\"PM\"  [disabled]=\"timepickerVariables.right.pmDisabled\">PM</option>\n            </select>\n        </div>\n    </div>\n    <div class=\"buttons\" *ngIf=\"!autoApply && ( !rangesArray.length || (showCalInRanges && !singleDatePicker))\">\n        <div class=\"buttons_input\">\n            <button  *ngIf=\"showClearButton\" class=\"btn btn-default clear\" type=\"button\" (click)=\"clear()\" title=\"clear the date\">\n                <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"30\" height=\"30\" viewBox=\"0 -5 24 24\"><path d=\"M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z\"/></svg>\n            </button>\n            <button class=\"btn btn-default\" *ngIf=\"showCancel\" type=\"button\" (click)=\"clickCancel($event)\">{{ locale.cancelLabel }}</button>\n            <button class=\"btn btn-info mb-0\" [disabled]=\"applyBtn.disabled\" type=\"button\" (click)=\"clickApply($event)\">{{ locale.applyLabel }}</button>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "./web/modern/components/common/sn-date-range-picker/sn-date-range-picker.component.scss":
/***/ (function(module, exports) {

module.exports = "/*\n*  variables\n*/\n/**\n* fonts\n */\n@font-face {\n  font-family: 'sn-daterangepicker';\n  src: url(\"data:application/octet-stream;base64,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\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal; }\n\n/*\n* styles\n*/\n.select-arrow-wrapper {\n  display: inline-block;\n  vertical-align: middle; }\n  .select-arrow-wrapper .select-arrow {\n    width: 0;\n    height: 0;\n    border-left: 5px solid transparent;\n    border-right: 5px solid transparent;\n    border-top: 5px solid;\n    margin: 0 4px; }\n\n.sn-daterangeicon {\n  font-family: 'sn-daterangepicker';\n  font-size: 18px; }\n  .sn-daterangeicon:before {\n    content: '\\e803'; }\n\n.sn-drppicker {\n  position: absolute;\n  font-family: Roboto, sans-serif;\n  color: inherit;\n  background-color: #fff;\n  border-radius: 4px;\n  width: 258px;\n  padding: 0;\n  margin-top: -10px;\n  overflow: hidden;\n  z-index: 1000;\n  font-size: 12px;\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16), 0 2px 8px 0 rgba(0, 0, 0, 0.12);\n  /* ranges */\n  /* button */ }\n  .sn-drppicker.double {\n    width: auto; }\n  .sn-drppicker.inline {\n    position: relative;\n    display: inline-block; }\n  .sn-drppicker:before, .sn-drppicker:after {\n    position: absolute;\n    display: inline-block;\n    border-bottom-color: rgba(0, 0, 0, 0.2);\n    content: ''; }\n  .sn-drppicker.openscenter:before {\n    left: 0;\n    right: 0;\n    width: 0;\n    margin-left: auto;\n    margin-right: auto; }\n  .sn-drppicker.openscenter:after {\n    left: 0;\n    right: 0;\n    width: 0;\n    margin-left: auto;\n    margin-right: auto; }\n  .sn-drppicker.single .ranges,\n  .sn-drppicker.single .calendar {\n    float: none; }\n  .sn-drppicker.shown {\n    -webkit-transform: scale(1);\n        -ms-transform: scale(1);\n            transform: scale(1);\n    -webkit-transition: all 0.1s ease-in-out;\n    transition: all 0.1s ease-in-out;\n    -webkit-transform-origin: 0 0;\n        -ms-transform-origin: 0 0;\n            transform-origin: 0 0;\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none; }\n    .sn-drppicker.shown.drops-up-left {\n      -webkit-transform-origin: 100% 100%;\n          -ms-transform-origin: 100% 100%;\n              transform-origin: 100% 100%; }\n    .sn-drppicker.shown.drops-up-right {\n      -webkit-transform-origin: 0 100%;\n          -ms-transform-origin: 0 100%;\n              transform-origin: 0 100%; }\n    .sn-drppicker.shown.drops-down-left {\n      -webkit-transform-origin: 100% 0;\n          -ms-transform-origin: 100% 0;\n              transform-origin: 100% 0;\n      right: 0 !important;\n      top: 50px !important;\n      left: auto !important; }\n    .sn-drppicker.shown.drops-down-right {\n      -webkit-transform-origin: 0 0;\n          -ms-transform-origin: 0 0;\n              transform-origin: 0 0; }\n    .sn-drppicker.shown.drops-down-center {\n      -webkit-transform-origin: 50% 0;\n          -ms-transform-origin: 50% 0;\n              transform-origin: 50% 0; }\n    .sn-drppicker.shown.drops-up-center {\n      -webkit-transform-origin: 50% 100%;\n          -ms-transform-origin: 50% 100%;\n              transform-origin: 50% 100%; }\n    .sn-drppicker.shown .calendar {\n      display: block; }\n      .sn-drppicker.shown .calendar.left {\n        border-bottom: 1px solid #eee;\n        border-right: 1px solid #eee;\n        margin: 0 0 10px;\n        padding: 10px 10px 0; }\n      .sn-drppicker.shown .calendar.right {\n        border-bottom: 1px solid #eee;\n        margin: 0 0 10px;\n        padding: 10px 10px 0; }\n  .sn-drppicker.hidden {\n    -webkit-transition: all 0.1s ease;\n    transition: all 0.1s ease;\n    -webkit-transform: scale(0);\n        -ms-transform: scale(0);\n            transform: scale(0);\n    -webkit-transform-origin: 0 0;\n        -ms-transform-origin: 0 0;\n            transform-origin: 0 0;\n    cursor: default;\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none; }\n    .sn-drppicker.hidden.drops-up-left {\n      -webkit-transform-origin: 100% 100%;\n          -ms-transform-origin: 100% 100%;\n              transform-origin: 100% 100%; }\n    .sn-drppicker.hidden.drops-up-right {\n      -webkit-transform-origin: 0 100%;\n          -ms-transform-origin: 0 100%;\n              transform-origin: 0 100%; }\n    .sn-drppicker.hidden.drops-down-left {\n      -webkit-transform-origin: 100% 0;\n          -ms-transform-origin: 100% 0;\n              transform-origin: 100% 0;\n      right: 0 !important;\n      top: 50px !important;\n      left: auto !important; }\n    .sn-drppicker.hidden.drops-down-right {\n      -webkit-transform-origin: 0 0;\n          -ms-transform-origin: 0 0;\n              transform-origin: 0 0; }\n    .sn-drppicker.hidden.drops-down-center {\n      -webkit-transform-origin: 50% 0;\n          -ms-transform-origin: 50% 0;\n              transform-origin: 50% 0; }\n    .sn-drppicker.hidden.drops-up-center {\n      -webkit-transform-origin: 50% 100%;\n          -ms-transform-origin: 50% 100%;\n              transform-origin: 50% 100%; }\n    .sn-drppicker.hidden .calendar {\n      display: none; }\n  .sn-drppicker .calendar {\n    /* display: none; */\n    max-width: 250px;\n    margin: 4px; }\n    .sn-drppicker .calendar.single .calendar-table {\n      border: none; }\n    .sn-drppicker .calendar th,\n    .sn-drppicker .calendar td {\n      padding: 0;\n      white-space: nowrap;\n      text-align: center;\n      min-width: 30px;\n      min-height: 30px; }\n      .sn-drppicker .calendar th span,\n      .sn-drppicker .calendar td span {\n        pointer-events: none;\n        display: -webkit-box;\n        display: -webkit-flex;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-pack: center;\n        -webkit-justify-content: center;\n            -ms-flex-pack: center;\n                justify-content: center;\n        -webkit-box-align: center;\n        -webkit-align-items: center;\n            -ms-flex-align: center;\n                align-items: center;\n        height: 100%; }\n  .sn-drppicker .calendar-table {\n    border: 1px solid #fff;\n    border-radius: 4px;\n    background-color: #fff; }\n  .sn-drppicker table {\n    width: 100%;\n    margin: 0; }\n  .sn-drppicker th {\n    color: #4e5e6b; }\n  .sn-drppicker td,\n  .sn-drppicker th {\n    text-align: center;\n    width: 20px;\n    height: 20px;\n    border-radius: 4px;\n    white-space: nowrap;\n    cursor: pointer;\n    height: 2em;\n    width: 2em; }\n    .sn-drppicker td.available,\n    .sn-drppicker th.available {\n      font-size: 16px; }\n      .sn-drppicker td.available.prev,\n      .sn-drppicker th.available.prev {\n        display: block;\n        background-image: url(\"data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4Ig0KCSB2aWV3Qm94PSIwIDAgMy43IDYiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDMuNyA2IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxnPg0KCTxwYXRoIGQ9Ik0zLjcsMC43TDEuNCwzbDIuMywyLjNMMyw2TDAsM2wzLTNMMy43LDAuN3oiLz4NCjwvZz4NCjwvc3ZnPg0K\");\n        background-repeat: no-repeat;\n        background-size: 0.5em;\n        background-position: center;\n        opacity: 0.8;\n        -webkit-transition: background-color 0.2s ease;\n        transition: background-color 0.2s ease;\n        border-radius: 2em; }\n        .sn-drppicker td.available.prev:hover,\n        .sn-drppicker th.available.prev:hover {\n          margin: 0; }\n      .sn-drppicker td.available.next,\n      .sn-drppicker th.available.next {\n        -webkit-transform: rotate(180deg);\n            -ms-transform: rotate(180deg);\n                transform: rotate(180deg);\n        display: block;\n        background-image: url(\"data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4Ig0KCSB2aWV3Qm94PSIwIDAgMy43IDYiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDMuNyA2IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxnPg0KCTxwYXRoIGQ9Ik0zLjcsMC43TDEuNCwzbDIuMywyLjNMMyw2TDAsM2wzLTNMMy43LDAuN3oiLz4NCjwvZz4NCjwvc3ZnPg0K\");\n        background-repeat: no-repeat;\n        background-size: 0.5em;\n        background-position: center;\n        opacity: 0.8;\n        -webkit-transition: background-color 0.2s ease;\n        transition: background-color 0.2s ease;\n        border-radius: 2em; }\n        .sn-drppicker td.available.next:hover,\n        .sn-drppicker th.available.next:hover {\n          margin: 0;\n          -webkit-transform: rotate(180deg);\n              -ms-transform: rotate(180deg);\n                  transform: rotate(180deg); }\n      .sn-drppicker td.available:hover,\n      .sn-drppicker th.available:hover {\n        background-color: #eee;\n        border-color: transparent;\n        color: inherit;\n        background-repeat: no-repeat;\n        background-size: 0.5em;\n        background-position: center;\n        margin: 0.25em 0;\n        opacity: 0.8;\n        /*transition: background-color .2s ease;*/\n        border-radius: 2em;\n        -webkit-transform: scale(1);\n            -ms-transform: scale(1);\n                transform: scale(1);\n        -webkit-transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n        transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms; }\n    .sn-drppicker td.week,\n    .sn-drppicker th.week {\n      font-size: 80%;\n      color: #ccc; }\n  .sn-drppicker td {\n    margin: 0.25em 0;\n    opacity: 0.8;\n    -webkit-transition: background-color 0.2s ease;\n    transition: background-color 0.2s ease;\n    border-radius: 2em;\n    -webkit-transform: scale(1);\n        -ms-transform: scale(1);\n            transform: scale(1);\n    -webkit-transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n    transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n    height: 2.3em; }\n    .sn-drppicker td div {\n      height: 100%;\n      border-radius: 100%; }\n    .sn-drppicker td div.off, .sn-drppicker td div.off.in-range, .sn-drppicker td div.off.start-date,\n    .sn-drppicker td div.off.start-date span, .sn-drppicker td div.off.end-date,\n    .sn-drppicker td div.off.end-date span {\n      background-color: #fff;\n      border-color: transparent;\n      color: #999; }\n    .sn-drppicker td div.in-range {\n      background-color: #d1f0f4;\n      border-color: transparent;\n      color: #000;\n      border-radius: 0; }\n    .sn-drppicker td div.start-date {\n      border-radius: 2em 0 0 2em; }\n    .sn-drppicker td div.end-date {\n      border-radius: 0 2em 2em 0; }\n    .sn-drppicker td div.start-date.end-date {\n      border-radius: 4px;\n      background: #fff;\n      -webkit-transition: background 0ms ease-out;\n      transition: background 0ms ease-out; }\n    .sn-drppicker td div.active {\n      -webkit-transition: background 300ms ease-out;\n      transition: background 300ms ease-out;\n      background: #d1f0f4;\n      font-weight: 300; }\n      .sn-drppicker td div.active span,\n      .sn-drppicker td div.active span:hover {\n        background-color: #12afcb;\n        border-color: transparent;\n        border-radius: 100%;\n        color: #fff; }\n  .sn-drppicker th.month {\n    font-size: 14px;\n    width: auto; }\n  .sn-drppicker td.disabled,\n  .sn-drppicker option.disabled {\n    color: #999;\n    cursor: not-allowed;\n    text-decoration: line-through; }\n  .sn-drppicker select {\n    display: inline-block;\n    background-color: rgba(255, 255, 255, 0.9);\n    width: 100%;\n    padding: 5px;\n    border: 1px solid #f2f2f2;\n    border-radius: 2px;\n    height: 3rem; }\n    .sn-drppicker select.monthselect, .sn-drppicker select.yearselect {\n      font-size: 12px;\n      padding: 1px;\n      height: auto;\n      margin: 0;\n      cursor: default; }\n    .sn-drppicker select.hourselect, .sn-drppicker select.minuteselect, .sn-drppicker select.secondselect, .sn-drppicker select.ampmselect {\n      width: 50px;\n      margin: 0 auto;\n      background: #eee;\n      border: 1px solid #eee;\n      padding: 2px;\n      outline: 0;\n      font-size: 12px; }\n    .sn-drppicker select.monthselect, .sn-drppicker select.yearselect {\n      cursor: pointer;\n      opacity: 0;\n      position: absolute;\n      top: 0;\n      left: 0;\n      margin: 0;\n      padding: 0; }\n  .sn-drppicker th.month > div {\n    position: relative;\n    display: inline-block; }\n  .sn-drppicker .calendar-time {\n    text-align: center;\n    margin: 4px auto 0 auto;\n    line-height: 30px;\n    position: relative; }\n  .sn-drppicker .calendar-time select.disabled {\n    color: #ccc;\n    cursor: not-allowed; }\n  .sn-drppicker .label-input {\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    color: #555;\n    height: 30px;\n    line-height: 30px;\n    display: block;\n    vertical-align: middle;\n    margin: 0 auto 5px auto;\n    padding: 0 0 0 28px;\n    width: 100%; }\n    .sn-drppicker .label-input.active {\n      border: 1px solid #08c;\n      border-radius: 4px; }\n  .sn-drppicker .sn-drppicker_input {\n    position: relative;\n    padding: 0 30px 0 0; }\n    .sn-drppicker .sn-drppicker_input i,\n    .sn-drppicker .sn-drppicker_input svg {\n      position: absolute;\n      left: 8px;\n      top: 8px; }\n  .sn-drppicker.rtl .label-input {\n    padding-right: 28px;\n    padding-left: 6px; }\n  .sn-drppicker.rtl .sn-drppicker_input i,\n  .sn-drppicker.rtl .sn-drppicker_input svg {\n    left: auto;\n    right: 8px; }\n  .sn-drppicker .show-ranges .drp-calendar.left {\n    border-left: 1px solid #ddd; }\n  .sn-drppicker .ranges {\n    float: none;\n    text-align: left;\n    margin: 0; }\n    .sn-drppicker .ranges ul {\n      list-style: none;\n      margin: 0 auto;\n      padding: 0;\n      width: 100%; }\n      .sn-drppicker .ranges ul li {\n        font-size: 12px; }\n        .sn-drppicker .ranges ul li button {\n          padding: 8px 12px;\n          width: 100%;\n          background: none;\n          border: none;\n          text-align: left;\n          cursor: pointer; }\n          .sn-drppicker .ranges ul li button.active {\n            background-color: #3f51b5;\n            color: #fff; }\n          .sn-drppicker .ranges ul li button[disabled] {\n            opacity: 0.3; }\n          .sn-drppicker .ranges ul li button:active {\n            background: transparent; }\n      .sn-drppicker .ranges ul li:hover {\n        background-color: #eee; }\n  .sn-drppicker .show-calendar .ranges {\n    margin-top: 8px; }\n  .sn-drppicker [hidden] {\n    display: none; }\n  .sn-drppicker .buttons {\n    text-align: right;\n    margin: 0 5px 5px 0; }\n\n@media (min-width: 564px) {\n  .sn-drppicker {\n    width: auto;\n    min-width: 472px; }\n    .sn-drppicker.single .calendar.left {\n      clear: none; }\n    .sn-drppicker.ltr {\n      direction: ltr;\n      text-align: left; }\n      .sn-drppicker.ltr .calendar.left {\n        clear: left;\n        /*margin-right: 1.5em;*/ }\n        .sn-drppicker.ltr .calendar.left .calendar-table {\n          border-right: none;\n          border-top-right-radius: 0;\n          border-bottom-right-radius: 0; }\n      .sn-drppicker.ltr .calendar.right {\n        margin-left: 0; }\n        .sn-drppicker.ltr .calendar.right .calendar-table {\n          border-left: none;\n          border-top-left-radius: 0;\n          border-bottom-left-radius: 0; }\n      .sn-drppicker.ltr .left .sn-drppicker_input {\n        padding-right: 35px; }\n      .sn-drppicker.ltr .right .sn-drppicker_input {\n        padding-right: 35px; }\n      .sn-drppicker.ltr .ranges,\n      .sn-drppicker.ltr .calendar {\n        float: left; }\n    .sn-drppicker.rtl {\n      direction: rtl;\n      text-align: right; }\n      .sn-drppicker.rtl .calendar.left {\n        clear: right;\n        margin-left: 0; }\n        .sn-drppicker.rtl .calendar.left .calendar-table {\n          border-left: none;\n          border-top-left-radius: 0;\n          border-bottom-left-radius: 0; }\n      .sn-drppicker.rtl .calendar.right {\n        margin-right: 0; }\n        .sn-drppicker.rtl .calendar.right .calendar-table {\n          border-right: none;\n          border-top-right-radius: 0;\n          border-bottom-right-radius: 0; }\n      .sn-drppicker.rtl .left .sn-drppicker_input {\n        padding-left: 12px; }\n      .sn-drppicker.rtl .ranges,\n      .sn-drppicker.rtl .calendar {\n        text-align: right;\n        float: right; }\n  .drp-animate {\n    -webkit-transform: translate(0);\n        -ms-transform: translate(0);\n            transform: translate(0);\n    -webkit-transition: opacity 0.2s ease, -webkit-transform 0.2s ease;\n    transition: opacity 0.2s ease, -webkit-transform 0.2s ease;\n    transition: transform 0.2s ease, opacity 0.2s ease;\n    transition: transform 0.2s ease, opacity 0.2s ease, -webkit-transform 0.2s ease; }\n    .drp-animate.drp-picker-site-this {\n      -webkit-transition-timing-function: linear;\n              transition-timing-function: linear; }\n    .drp-animate.drp-animate-right {\n      -webkit-transform: translateX(10%);\n          -ms-transform: translateX(10%);\n              transform: translateX(10%);\n      opacity: 0; }\n    .drp-animate.drp-animate-left {\n      -webkit-transform: translateX(-10%);\n          -ms-transform: translateX(-10%);\n              transform: translateX(-10%);\n      opacity: 0; } }\n\n@media (min-width: 730px) {\n  .sn-drppicker .ranges {\n    width: auto; }\n  .sn-drppicker.ltr .ranges {\n    float: left; }\n  .sn-drppicker.rtl .ranges {\n    float: right; }\n  .sn-drppicker .calendar.left {\n    clear: none !important; } }\n"

/***/ }),

/***/ "./web/modern/components/common/sn-date-range-picker/sn-date-range-picker.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var ngx_daterangepicker_material_1 = __webpack_require__("./node_modules/ngx-daterangepicker-material/esm5/ngx-daterangepicker-material.js");
var forms_1 = __webpack_require__("./node_modules/@angular/forms/esm5/forms.js");
var settings_1 = __webpack_require__("./shared/services/settings/settings.ts");
var moment = __webpack_require__("./node_modules/moment/moment.js");
var SnDateRangePickerComponent = function (_ngx_daterangepicker_) {
    _inherits(SnDateRangePickerComponent, _ngx_daterangepicker_);

    function SnDateRangePickerComponent(snEl, _snRef, settingsService) {
        _classCallCheck(this, SnDateRangePickerComponent);

        var _this = _possibleConstructorReturn(this, (SnDateRangePickerComponent.__proto__ || Object.getPrototypeOf(SnDateRangePickerComponent)).call(this, snEl, _snRef));

        _this.snEl = snEl;
        _this._snRef = _snRef;
        _this.settingsService = settingsService;
        _this.yearRangeLeft = [];
        _this.yearRangeRight = [];
        return _this;
    }

    _createClass(SnDateRangePickerComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            _get(SnDateRangePickerComponent.prototype.__proto__ || Object.getPrototypeOf(SnDateRangePickerComponent.prototype), "ngOnInit", this).call(this);
            this.setDateFormatting();
            this.locale.separator = ' ➔ ';
            this.locale.format = 'YYYY-MM-DD';
            this.locale.applyLabel = 'Apply Dates';
            this.getYearsArray();
        }
    }, {
        key: "setCurrentStart",
        value: function setCurrentStart(v) {
            this.currentStart = v.target.value;
        }
    }, {
        key: "setCurrentEnd",
        value: function setCurrentEnd(v) {
            this.currentEnd = v.target.value;
        }
    }, {
        key: "getYearsArray",
        value: function getYearsArray() {
            var firstRangeDate = new Date('01 January 2014').getFullYear();
            var current = new Date();
            var secondRangeDate = current.getFullYear() + 10;
            var arr = [];
            for (var i = firstRangeDate; i <= secondRangeDate; i++) {
                arr.push(i);
            }
            this.yearRangeLeft = arr;
            this.yearRangeRight = arr;
        }
    }, {
        key: "changeStart",
        value: function changeStart(v) {
            var newValue = this.convertToAcceptedFormat(v.target.value);
            var parsed = moment(newValue, this.locale.format, true);
            if (parsed.isValid()) {
                this.endDate = null;
                this.setStartDate(newValue);
                this.updateView();
            } else {
                var startDateInput = document.getElementById('startDateInput');
                startDateInput.value = this.currentStart;
            }
        }
    }, {
        key: "changeEnd",
        value: function changeEnd(v) {
            var newValue = this.convertToAcceptedFormat(v.target.value);
            var parsed = moment(newValue, this.locale.format, true);
            if (parsed.isValid()) {
                this.setEndDate(newValue);
                this.updateView();
            } else {
                var endDateInput = document.getElementById('endDateInput');
                endDateInput.value = this.currentEnd;
            }
        }
    }, {
        key: "convertToAcceptedFormat",
        value: function convertToAcceptedFormat(date) {
            if (this.calendarInputsFormat === 'dd/MM/yyyy') {
                return date.split('/').reverse().join('-');
            }
            return date.replace(/(\d\d)\/(\d\d)\/(\d{4})/, '$3-$1-$2');
        }
    }, {
        key: "updateElement",
        value: function updateElement() {
            if (!this.singleDatePicker && this.autoUpdateInput) {
                if (this.startDate && this.endDate) {
                    // if we use ranges and should show range label on input
                    if (this.rangesArray.length && this.showRangeLabelOnInput === true && this.chosenRange && this.locale.customRangeLabel !== this.chosenRange) {
                        this.chosenLabel = this.chosenRange;
                    } else {
                        this.chosenLabel = this.startDate.format(this.pickerInputFormat) + this.locale.separator + this.endDate.format(this.pickerInputFormat);
                    }
                }
            } else if (this.autoUpdateInput) {
                this.chosenLabel = this.startDate.format(this.pickerInputFormat);
            }
        }
    }, {
        key: "setDateFormatting",
        value: function setDateFormatting() {
            var _this2 = this;

            this.settingsService.timeFormatSettings.subscribe(function (data) {
                _this2.pickerInputFormat = data.dateFormat === 'DD_MM_YYYY' ? 'DD MMM YYYY' : 'MMM DD YYYY';
                _this2.calendarInputsFormat = data.dateFormat === 'DD_MM_YYYY' ? 'dd/MM/yyyy' : 'MM/dd/yyyy';
                switch (data.weekStartsOn) {
                    case 'SATURDAY':
                        _this2.locale.daysOfWeek = ['S', 'S', 'M', 'T', 'W', 'T', 'F'];
                        _this2.locale.firstDay = -1;
                        break;
                    case 'SUNDAY':
                        _this2.locale.daysOfWeek = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
                        _this2.locale.firstDay = 0;
                        break;
                    default:
                        _this2.locale.daysOfWeek = ['M', 'T', 'W', 'T', 'F', 'S', 'S'];
                        _this2.locale.firstDay = 1;
                        break;
                }
            });
        }
    }]);

    return SnDateRangePickerComponent;
}(ngx_daterangepicker_material_1.DaterangepickerComponent);
SnDateRangePickerComponent = __decorate([core_1.Component({
    selector: 'sn-date-range-picker',
    template: __webpack_require__("./web/modern/components/common/sn-date-range-picker/sn-date-range-picker.component.html"),
    styles: [__webpack_require__("./web/modern/components/common/sn-date-range-picker/sn-date-range-picker.component.scss")],
    host: {
        '(click)': 'handleInternalClick($event)'
    },
    providers: [{
        provide: forms_1.NG_VALUE_ACCESSOR,
        useExisting: core_1.forwardRef(function () {
            return ngx_daterangepicker_material_1.DaterangepickerComponent;
        }),
        multi: true
    }]
}), __metadata("design:paramtypes", [core_1.ElementRef, core_1.ChangeDetectorRef, settings_1.SettingsProvider])], SnDateRangePickerComponent);
exports.SnDateRangePickerComponent = SnDateRangePickerComponent;

/***/ }),

/***/ "./web/modern/components/common/sn-date-range-picker/sn-date-range-picker.directive.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var forms_1 = __webpack_require__("./node_modules/@angular/forms/esm5/forms.js");
var ngx_daterangepicker_material_1 = __webpack_require__("./node_modules/ngx-daterangepicker-material/esm5/ngx-daterangepicker-material.js");
var sn_date_range_picker_component_1 = __webpack_require__("./web/modern/components/common/sn-date-range-picker/sn-date-range-picker.component.ts");
var SnDateRangePickerDirective = SnDateRangePickerDirective_1 = function (_ngx_daterangepicker_) {
    _inherits(SnDateRangePickerDirective, _ngx_daterangepicker_);

    function SnDateRangePickerDirective(viewContainerRef, _changeDetectorRef, _componentFactoryResolver, _el, _renderer, differs, cfr) {
        _classCallCheck(this, SnDateRangePickerDirective);

        var _this = _possibleConstructorReturn(this, (SnDateRangePickerDirective.__proto__ || Object.getPrototypeOf(SnDateRangePickerDirective)).call(this, viewContainerRef, _changeDetectorRef, _componentFactoryResolver, _el, _renderer, differs));

        _this.cfr = cfr;
        var componentFactory = _this.cfr.resolveComponentFactory(sn_date_range_picker_component_1.SnDateRangePickerComponent);
        viewContainerRef.clear();
        var componentRef = viewContainerRef.createComponent(componentFactory);
        _this.picker = componentRef.instance;
        _this.picker.inline = false; // set inline to false for all directive usage
        return _this;
    }

    return SnDateRangePickerDirective;
}(ngx_daterangepicker_material_1.DaterangepickerDirective);
SnDateRangePickerDirective = SnDateRangePickerDirective_1 = __decorate([core_1.Directive({
    selector: 'input[snDateRange]',
    host: {
        '(keyup.esc)': 'hide()',
        '(blur)': 'onBlur()',
        '(click)': 'open()'
    },
    providers: [{
        provide: forms_1.NG_VALUE_ACCESSOR,
        useExisting: core_1.forwardRef(function () {
            return SnDateRangePickerDirective_1;
        }),
        multi: true
    }]
}), __metadata("design:paramtypes", [core_1.ViewContainerRef, core_1.ChangeDetectorRef, core_1.ComponentFactoryResolver, core_1.ElementRef, core_1.Renderer2, core_1.KeyValueDiffers, core_1.ComponentFactoryResolver])], SnDateRangePickerDirective);
exports.SnDateRangePickerDirective = SnDateRangePickerDirective;
var SnDateRangePickerDirective_1;

/***/ }),

/***/ "./web/modern/components/common/sn-new-pagination/sn-new-pagination.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"flex-row flex-just-space-between pagination-block\">\n    <div class=\"pagination\">\n        <label>Show\n            <select (change)=\"perPageChanged(pageRequest.paging.pageSize)\"\n                    [(ngModel)]=\"pageRequest.paging.pageSize\">\n                <option *ngFor=\"let option of pageOptions\" [value]=\"option\">{{ option }}</option>\n            </select>\n        </label>\n    </div>\n    <pagination-controls class=\"pagination\"\n                         [id]=\"id\"\n                         [maxSize]=\"maxSize\"\n                         [directionLinks]=\"directionLinks\"\n                         [autoHide]=\"autoHide\"\n                         [responsive]=\"responsive\"\n                         [previousLabel]=\"previousLabel\"\n                         [nextLabel]=\"nextLabel\"\n                         [screenReaderPaginationLabel]=\"screenReaderPaginationLabel\"\n                         [screenReaderPageLabel]=\"screenReaderPageLabel\"\n                         [screenReaderCurrentLabel]=\"screenReaderCurrentLabel\"\n                         (pageChange)=\"onPageChange($event, getCurrentPage() === $event - 1)\"\n                         (pageBoundsCorrection)=\"onPageChange($event, getCurrentPage() === $event - 1)\">\n    </pagination-controls>\n</div>\n"

/***/ }),

/***/ "./web/modern/components/common/sn-new-pagination/sn-new-pagination.scss":
/***/ (function(module, exports) {

module.exports = "@media screen and (max-width: 767px) {\n  .pagination-block {\n    padding: 0 15px; } }\n\n::ng-deep .ngx-pagination li {\n  margin-right: 0; }\n  ::ng-deep .ngx-pagination li:first-child.pagination-previous.disabled {\n    margin-left: 0;\n    border-bottom-left-radius: 4px;\n    border-top-left-radius: 4px;\n    padding: 6px 12px;\n    line-height: 1.42857;\n    text-decoration: none;\n    margin-left: -1px;\n    float: left; }\n    ::ng-deep .ngx-pagination li:first-child.pagination-previous.disabled:before {\n      content: none; }\n  ::ng-deep .ngx-pagination li:first-child.pagination-previous a {\n    margin-left: 0;\n    border-bottom-left-radius: 4px;\n    border-top-left-radius: 4px;\n    padding: 6px 12px;\n    line-height: 1.42857;\n    text-decoration: none;\n    margin-right: -3px;\n    float: left; }\n    ::ng-deep .ngx-pagination li:first-child.pagination-previous a:before {\n      content: none; }\n  ::ng-deep .ngx-pagination li:last-child.pagination-next.disabled {\n    margin-left: 0;\n    border-bottom-right-radius: 4px;\n    border-top-right-radius: 4px;\n    padding: 6px 12px;\n    line-height: 1.42857;\n    text-decoration: none;\n    margin-left: -1px;\n    float: right; }\n    ::ng-deep .ngx-pagination li:last-child.pagination-next.disabled:after {\n      content: none; }\n  ::ng-deep .ngx-pagination li:last-child.pagination-next a {\n    margin-left: 0;\n    border-bottom-right-radius: 4px;\n    border-top-right-radius: 4px;\n    padding: 6px 12px;\n    line-height: 1.42857;\n    text-decoration: none;\n    margin-left: -5px;\n    float: right; }\n    ::ng-deep .ngx-pagination li:last-child.pagination-next a:after {\n      content: none; }\n  ::ng-deep .ngx-pagination li.small-screen {\n    vertical-align: top;\n    padding: 7px 12px;\n    line-height: 1.42857; }\n  ::ng-deep .ngx-pagination li.current {\n    cursor: default !important;\n    padding: 0 !important; }\n    ::ng-deep .ngx-pagination li.current span {\n      position: relative;\n      float: left;\n      padding: 6px 12px;\n      line-height: 1.42857;\n      text-decoration: none;\n      color: #fff !important;\n      background-color: #22baa0;\n      border: 1px solid #22baa0;\n      margin-left: -1px; }\n  ::ng-deep .ngx-pagination li.disabled {\n    border: 1px solid #ddd;\n    cursor: not-allowed;\n    color: #5b5b5b !important; }\n  ::ng-deep .ngx-pagination li a {\n    position: relative;\n    float: left;\n    padding: 6px 12px;\n    line-height: 1.42857;\n    text-decoration: none;\n    color: #5b5b5b !important;\n    background-color: #fff;\n    border: 1px solid #ddd;\n    margin-left: -2px; }\n\n::ng-deep .ngx-pagination li a:hover {\n  z-index: 2;\n  color: #23527c;\n  background-color: #eeeeee;\n  border-color: #ddd; }\n"

/***/ }),

/***/ "./web/modern/components/common/sn-new-pagination/sn-new-pagination.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var ngx_pagination_1 = __webpack_require__("./node_modules/ngx-pagination/dist/ngx-pagination.js");
var pagination_service_1 = __webpack_require__("./shared/services/pagination/pagination.service.ts");
var SnNewPaginationComponent = function (_ngx_pagination_1$Pag) {
    _inherits(SnNewPaginationComponent, _ngx_pagination_1$Pag);

    function SnNewPaginationComponent(paginationService) {
        _classCallCheck(this, SnNewPaginationComponent);

        var _this = _possibleConstructorReturn(this, (SnNewPaginationComponent.__proto__ || Object.getPrototypeOf(SnNewPaginationComponent)).call(this));

        _this.paginationService = paginationService;
        _this.pageChange = new core_1.EventEmitter();
        _this.pageBoundsCorrection = new core_1.EventEmitter();
        _this.pageOptions = [5, 10, 25, 50, 100];
        return _this;
    }

    _createClass(SnNewPaginationComponent, [{
        key: "onPageChange",
        value: function onPageChange(event, isCurrentPage) {
            if (!isCurrentPage) {
                this.getNewPageRequest(event);
            }
        }
    }, {
        key: "onPageBoundsCorrection",
        value: function onPageBoundsCorrection(event) {
            this.pageBoundsCorrection.emit(event);
        }
    }, {
        key: "getCurrentPage",
        value: function getCurrentPage() {
            return this.pageRequest.paging.pageNumber;
        }
    }, {
        key: "perPageChanged",
        value: function perPageChanged(newPerPage) {
            this.getNewPageRequest(1, newPerPage);
        }
    }, {
        key: "getNewPageRequest",
        value: function getNewPageRequest(pageNumber, perPage) {
            var newPageRequest = this.paginationService.getResultsPage(this.pageRequest, this.totalItems, pageNumber, perPage);
            if (newPageRequest) {
                this.pageChange.emit(newPageRequest);
            }
        }
    }]);

    return SnNewPaginationComponent;
}(ngx_pagination_1.PaginationControlsComponent);
__decorate([core_1.Input(), __metadata("design:type", Object)], SnNewPaginationComponent.prototype, "pageRequest", void 0);
__decorate([core_1.Input(), __metadata("design:type", Number)], SnNewPaginationComponent.prototype, "pageNumbers", void 0);
__decorate([core_1.Input(), __metadata("design:type", Number)], SnNewPaginationComponent.prototype, "totalItems", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], SnNewPaginationComponent.prototype, "id", void 0);
__decorate([core_1.Input(), __metadata("design:type", Number)], SnNewPaginationComponent.prototype, "maxSize", void 0);
__decorate([core_1.Input(), __metadata("design:type", Boolean)], SnNewPaginationComponent.prototype, "directionLinks", void 0);
__decorate([core_1.Input(), __metadata("design:type", Boolean)], SnNewPaginationComponent.prototype, "autoHide", void 0);
__decorate([core_1.Input(), __metadata("design:type", Boolean)], SnNewPaginationComponent.prototype, "responsive", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], SnNewPaginationComponent.prototype, "previousLabel", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], SnNewPaginationComponent.prototype, "nextLabel", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], SnNewPaginationComponent.prototype, "screenReaderPaginationLabel", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], SnNewPaginationComponent.prototype, "screenReaderPageLabel", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], SnNewPaginationComponent.prototype, "screenReaderCurrentLabel", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], SnNewPaginationComponent.prototype, "pageChange", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], SnNewPaginationComponent.prototype, "pageBoundsCorrection", void 0);
SnNewPaginationComponent = __decorate([core_1.Component({
    selector: 'sn-new-pagination',
    template: __webpack_require__("./web/modern/components/common/sn-new-pagination/sn-new-pagination.html"),
    styles: [__webpack_require__("./web/modern/components/common/sn-new-pagination/sn-new-pagination.scss")]
}), __metadata("design:paramtypes", [pagination_service_1.PaginationService])], SnNewPaginationComponent);
exports.SnNewPaginationComponent = SnNewPaginationComponent;

/***/ }),

/***/ "./web/modern/components/common/sn-pagination/sn-pagination.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"flex-row flex-just-space {{position}}\">\n<div class=\"pagination\">\n    <div class=\"pagination\">\n        <label>Show\n            <select (change)=\"perPageChanged(pageRequest.paging.pageSize)\"\n                    [(ngModel)]=\"pageRequest.paging.pageSize\">\n            <option value=\"5\">5</option>\n            <option value=\"10\">10</option>\n            <option value=\"25\">25</option>\n            <option value=\"50\">50</option>\n        </select>\n        </label>\n    </div>\n</div>\n<div class=\"pagination\">\n    <ul class=\"pagination\" *ngIf=\"pageNumbers\">\n        <li [class.disabled]=\"getCurrentPage() === 0\">\n            <a (click)=\"goToPage(0, getCurrentPage() === 0)\">First</a>\n        </li>\n\n        <li [class.disabled]=\"getCurrentPage() === 0\">\n            <a (click)=\"jumpBack(getCurrentPage() === 0)\"><i class=\"fa fa-chevron-left\"></i></a>\n        </li>\n\n        <li *ngFor=\"let page of pageNumbers\"\n            [class.active]=\"getCurrentPage() === page\">\n            <a (click)=\"goToPage(page, getCurrentPage() === page)\">{{ page + 1 }}</a>\n        </li>\n\n        <li [class.disabled]=\"getCurrentPage() + 1 >= pageNumbers.length\">\n            <a (click)=\"jumpAhead(getCurrentPage() + 1 >= pageNumbers.length)\"><i class=\"fa fa-chevron-right\"></i></a>\n        </li>\n        <li [class.disabled]=\"getCurrentPage() + 1 >= pageNumbers.length\">\n            <a (click)=\"goToPage(pageNumbers.length - 1, getCurrentPage() + 1 >= pageNumbers.length)\">Last</a>\n        </li>\n    </ul>\n</div>\n</div>\n"

/***/ }),

/***/ "./web/modern/components/common/sn-pagination/sn-pagination.scss":
/***/ (function(module, exports) {

module.exports = ""

/***/ }),

/***/ "./web/modern/components/common/sn-pagination/sn-pagination.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var pagination_service_1 = __webpack_require__("./shared/services/pagination/pagination.service.ts");
var SnPaginationComponent = function () {
    function SnPaginationComponent(paginationService) {
        _classCallCheck(this, SnPaginationComponent);

        this.paginationService = paginationService;
        this.renew = new core_1.EventEmitter();
    }

    _createClass(SnPaginationComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {}
    }, {
        key: "getCurrentPage",
        value: function getCurrentPage() {
            return this.pageRequest.paging.pageNumber;
        }
    }, {
        key: "goToPage",
        value: function goToPage(newPage, disabled) {
            if (!disabled) {
                this.getNewPageRequest(newPage);
            }
        }
    }, {
        key: "jumpBack",
        value: function jumpBack(disabled) {
            if (!disabled) {
                if (this.pageRequest.paging.pageNumber > 0) {
                    this.getNewPageRequest(this.pageRequest.paging.pageNumber - 1);
                }
            }
        }
    }, {
        key: "jumpAhead",
        value: function jumpAhead(disabled) {
            if (!disabled) {
                if (this.totalItems >= this.pageRequest.paging.pageNumber * this.pageRequest.paging.pageSize + 1) {
                    this.getNewPageRequest(this.pageRequest.paging.pageNumber + 1);
                }
            }
        }
    }, {
        key: "perPageChanged",
        value: function perPageChanged(newPerPage) {
            this.getNewPageRequest(null, newPerPage);
        }
    }, {
        key: "getNewPageRequest",
        value: function getNewPageRequest(pageNumber, perPage) {
            var newPageRequest = this.paginationService.getResultsPage(this.pageRequest, this.totalItems, pageNumber, perPage);
            if (newPageRequest) {
                this.renew.emit(newPageRequest);
            }
        }
    }]);

    return SnPaginationComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], SnPaginationComponent.prototype, "pageRequest", void 0);
__decorate([core_1.Input(), __metadata("design:type", Number)], SnPaginationComponent.prototype, "totalItems", void 0);
__decorate([core_1.Input(), __metadata("design:type", Array)], SnPaginationComponent.prototype, "pageNumbers", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], SnPaginationComponent.prototype, "renew", void 0);
SnPaginationComponent = __decorate([core_1.Component({
    selector: 'sn-pagination',
    template: __webpack_require__("./web/modern/components/common/sn-pagination/sn-pagination.html"),
    styles: [__webpack_require__("./web/modern/components/common/sn-pagination/sn-pagination.scss")]
}), __metadata("design:paramtypes", [pagination_service_1.PaginationService])], SnPaginationComponent);
exports.SnPaginationComponent = SnPaginationComponent;

/***/ }),

/***/ "./web/modern/components/common/sn-quill-editor/attachments/attachments.component.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"attachments__box\">\n    <input #inputFile (click)=\"click($event)\" (change)=\"renewFiles($event)\" [id]=\"'attachment-' + attachmentId\" class=\"attachments__input-web hide\" type=\"file\"/>\n    <h4 *ngIf=\"attachmentsView && attachmentsView.length > 0\" class=\"mt-15 mb-8 text-semi-bold\">Files attached</h4>\n    <ul class=\"attachments__list\">\n        <li *ngFor=\"let file of attachmentsView; let i = index\" class=\"file-type {{file.convertedType}}\">\n            <div class=\"file-content-wrapper\"> <b class=\"file-name\">{{ file.name }}</b>\n                <p class=\"mt-5 flex-basis-full f-s-15\">{{ file.convertedSize }}Mb</p>\n            </div>\n            <div class=\"remove-btn-wrapper\">\n                <i class=\"fa fa-close file-remove\" (click)=\"removeAttachment(i)\"></i>\n            </div>\n        </li>\n    </ul>\n</div>\n"

/***/ }),

/***/ "./web/modern/components/common/sn-quill-editor/attachments/attachments.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var file_upload_service_1 = __webpack_require__("./shared/services/files/file-upload-service/file-upload.service.ts");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var image_converter_service_1 = __webpack_require__("./shared/services/files/image-converter.service.ts");
var WebAttachmentsComponent = function () {
    function WebAttachmentsComponent(fileUploadService, messageService, imageConverter) {
        _classCallCheck(this, WebAttachmentsComponent);

        this.fileUploadService = fileUploadService;
        this.messageService = messageService;
        this.imageConverter = imageConverter;
        this.attachmentsChanged = new core_1.EventEmitter();
        this.attachmentsView = [];
        this.unsubscribe = new Subject_1.Subject();
    }

    _createClass(WebAttachmentsComponent, [{
        key: "ngOnChanges",
        value: function ngOnChanges() {
            if (this.filesObj !== undefined) {
                this.attachmentsView = this.filesObj.attachments;
                this.handleAttachmentsView(this.attachmentsView);
            }
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
        }
    }, {
        key: "renewFiles",
        value: function renewFiles(event) {
            if (event && event.target.files) {
                var newFile = event.target.files[0];
                newFile = this.fileUploadService.addFileConvertedSize(newFile);
                this.attachmentsView.push(newFile);
                this.handleAttachmentsView(this.attachmentsView, newFile);
            }
        }
    }, {
        key: "click",
        value: function click(event) {
            if (event && event.target) {
                event.target.value = null;
            }
        }
    }, {
        key: "removeAttachment",
        value: function removeAttachment(index) {
            this.attachmentsView.splice(index, 1);
            this.handleAttachmentsView(this.attachmentsView);
        }
    }, {
        key: "handleAttachmentsView",
        value: function handleAttachmentsView(attachmentsView, newFile) {
            if (attachmentsView && attachmentsView.length > 0) {
                var resultSize = this.fileUploadService.getTotalSize(attachmentsView);
                var maxSize = this.fileUploadService.maxAttachment;
                if (resultSize > maxSize) {
                    this.messageService.showToaster('w_0', 'attachments');
                    if (typeof newFile !== 'undefined') {
                        attachmentsView.pop(newFile);
                        return;
                    }
                }
                if (this.filesObj === undefined) {
                    this.filesObj = {};
                }
                // this.filesObj.filesSize = resultSize;
                // this.filesObj.attachments = attachmentsView;
                this.buildFileObj();
                this.attachmentsChanged.emit(this.filesObj);
            } else {
                this.buildFileObj();
                this.attachmentsChanged.emit(this.filesObj);
            }
        }
    }, {
        key: "buildFileObj",
        value: function buildFileObj() {
            var _this = this;

            if (this.attachmentsView !== undefined || this.attachmentsView !== null) {
                var max = this.attachmentsView.length;
                var size = 0;
                for (var i = 0; i < max; i++) {
                    var fileSize = this.attachmentsView[i].size || this.attachmentsView[i].bytesSize;
                    size += fileSize;
                }
                size /= 1024 * 1000;
                size = Number(size.toFixed(2));
                this.filesObj.filesSize = size;
                this.attachmentsView.forEach(function (value) {
                    value.convertedType = _this.imageConverter.getFileClass(value.name);
                    if (value.bytesSize) {
                        value.convertedSize = (parseInt(value.bytesSize) / (1024 * 1024)).toFixed(2); // convert from bytes to MB
                    } else {
                        value.convertedSize = (parseInt(value.size) / (1024 * 1024)).toFixed(2); // convert from bytes to MB
                    }
                });
                this.filesObj.attachments = this.attachmentsView;
            }
        }
    }]);

    return WebAttachmentsComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", String)], WebAttachmentsComponent.prototype, "attachmentId", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], WebAttachmentsComponent.prototype, "filesObj", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], WebAttachmentsComponent.prototype, "attachmentsChanged", void 0);
WebAttachmentsComponent = __decorate([core_1.Component({
    selector: 'web-attachments',
    template: __webpack_require__("./web/modern/components/common/sn-quill-editor/attachments/attachments.component.html")
}), __metadata("design:paramtypes", [file_upload_service_1.FileUploadServiceProvider, message_service_1.MessageService, image_converter_service_1.ImageConverterProvider])], WebAttachmentsComponent);
exports.WebAttachmentsComponent = WebAttachmentsComponent;

/***/ }),

/***/ "./web/modern/components/common/sn-quill-editor/modals/sn-quill-attachment-modal/sn-quill-attachment.modal.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n    <button class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" (click)=\"onDismiss()\">&times;</button>\n    <h3 class=\"modal-title f-w-n\">From Files</h3>\n</div>\n<div class=\"modal-body flex-row section-data__wrapper modal-files-upload\" style=\"padding: 30px!important;\">\n    <form class=\"form-horizontal\" role=\"form\" style=\"width: 100%\" (ngSubmit)=\"addAttachment()\">\n        <div class=\"flex-row flex-wrap section-data__wrapper\">\n            <div class=\"attachment-wrapper section-data section-data--full-lg-max\"\n                 [ngClass]=\"{'flex-basis-full': files.length === 1}\"\n                 *ngFor=\"let file of files; let checkboxIndex = index\">\n\n                <div class=\"file-type {{file.convertedType}} with-checkbox\" style=\"width: 60px; position: absolute\">\n                    <div class=\"checkbox-squared\" style=\"margin-top: 6px\">\n                        <input type=\"checkbox\" id=\"attached-to-mail-{{file.id}}-{{checkboxIndex}}\" [(ngModel)]=\"file.checked\" name=\"attachedToMail\">\n                        <label for=\"attached-to-mail-{{file.id}}-{{checkboxIndex}}\"></label>\n                    </div>\n                </div>\n\n                <table class=\"table-profile table-full-width\">\n                    <tbody>\n                    <tr>\n                        <td class=\"files-wrapper\">\n                            {{ file.name }}\n                        </td>\n                    </tr>\n                    <tr>\n                        <td class=\"files-wrapper\">\n                            Uploaded on {{ file.customLastModifiedDate }}\n                        </td>\n                    </tr>\n\n                    <tr>\n                        <td class=\"files-wrapper\">\n                            {{ file.convertedSize }} MB\n                        </td>\n                    </tr>\n                    </tbody>\n                </table>\n            </div>\n        </div>\n        <div class=\"pt-25 pl-6\">\n            <button type=\"submit\" class=\"btn btn-lg btn-danger mb-0 mr-10\" spinning-wheel [is-spinning-wheel-active]=\"btnLoading\" [disabled]=\"btnDisabled || btnLoading\">Attach to Email</button>\n            <button type=\"button\" (click)=\"onDismiss()\" class=\"btn btn-lg btn-default mb-0\" data-dismiss=\"modal\">Cancel</button>\n        </div>\n    </form>\n</div>\n"

/***/ }),

/***/ "./web/modern/components/common/sn-quill-editor/modals/sn-quill-attachment-modal/sn-quill-attachment.modal.scss":
/***/ (function(module, exports) {

module.exports = ""

/***/ }),

/***/ "./web/modern/components/common/sn-quill-editor/modals/sn-quill-attachment-modal/sn-quill-attachment.modal.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var ng_bootstrap_1 = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/index.js");
var file_upload_data_service_1 = __webpack_require__("./shared/services/files/file-upload.data.service.ts");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var file_upload_service_1 = __webpack_require__("./shared/services/files/file-upload-service/file-upload.service.ts");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var SnQuillAttachmentModal = function () {
    function SnQuillAttachmentModal(activeModal, modalService, filesDataService, filesService, messageService) {
        _classCallCheck(this, SnQuillAttachmentModal);

        this.activeModal = activeModal;
        this.modalService = modalService;
        this.filesDataService = filesDataService;
        this.filesService = filesService;
        this.messageService = messageService;
        this.btnDisabled = false;
        this.btnLoading = false;
        this.unsubscribe = new Subject_1.Subject();
        this.checkedFiles = {};
        this.maxSize = this.filesService.maxSize;
        this.maxMb = this.filesService.maxAttachment;
    }

    _createClass(SnQuillAttachmentModal, [{
        key: "addAttachment",
        value: function addAttachment() {
            this.btnLoading = true;
            this.checkedFiles = this.files.filter(function (file) {
                return file.checked;
            });
            if (this.checkedFiles && this.checkedFiles.length) {
                var size = this.filesService.getTotalSize(this.checkedFiles);
                if (size > this.maxMb) {
                    this.btnLoading = false;
                    this.messageService.showToaster('w_0', 'attachments');
                    return;
                }
            }
            this.filesDataService.setCheckedFiles(this.checkedFiles);
            this.btnLoading = false;
            this.onDismiss();
        }
    }, {
        key: "ngOnInit",
        value: function ngOnInit() {
            var _this = this;

            this.filesDataService.filesObservable.takeUntil(this.unsubscribe).subscribe(function (value) {
                return _this.files = [].concat(_toConsumableArray(value));
            });
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
        }
    }, {
        key: "onDismiss",
        value: function onDismiss() {
            this.files = this.files.map(function (file) {
                return file.checked = '';
            });
            this.modalService.setModalData(null);
        }
    }]);

    return SnQuillAttachmentModal;
}();
SnQuillAttachmentModal = __decorate([core_1.Component({
    selector: 'sn-quill-attchment-modal',
    template: __webpack_require__("./web/modern/components/common/sn-quill-editor/modals/sn-quill-attachment-modal/sn-quill-attachment.modal.html"),
    styles: [__webpack_require__("./web/modern/components/common/sn-quill-editor/modals/sn-quill-attachment-modal/sn-quill-attachment.modal.scss")]
}), __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal, snModal_service_1.SNModalService, file_upload_data_service_1.FileUploadDataProvider, file_upload_service_1.FileUploadServiceProvider, message_service_1.MessageService])], SnQuillAttachmentModal);
exports.SnQuillAttachmentModal = SnQuillAttachmentModal;

/***/ }),

/***/ "./web/modern/components/common/sn-quill-editor/modals/sn-quill-link-modal/sn-quill-link-modal.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n    <button class=\"close\" (click)=\"onDismiss()\">&times;</button>\n    <h3 class=\"modal-title f-w-n\">Insert or edit link</h3>\n</div>\n<div class=\"modal-body\" style=\"padding: 30px 20px!important;\">\n        <div class=\"field-info\">\n            <label for=\"url\" class=\"text-semi-bold f-s-14 mb-8\">Link to website or email address</label>\n            <input [attr.disabled]=\"disableLink ? '' : null\"\n                   [required]=\"true\"\n                   [(ngModel)]=\"enteredUrl\"\n                   [ngModelOptions]=\"{standalone: true}\"\n                   (ngModelChange)=\"trackUrlInput()\"\n                   id=\"url\" class=\"form-control\"\n                   placeholder=\"Website url including http:// or email address\">\n        </div>\n        <div class=\"field-info\">\n            <label for=\"text\" class=\"text-semi-bold f-s-14 mb-8\">Text to display</label>\n            <input [(ngModel)]=\"textToDisplay\"\n                   [ngModelOptions]=\"{standalone: true}\"\n                   (change)=\"trackTextInput()\"\n                   id=\"text\" class=\"form-control\"\n                   placeholder=\"Text to display\">\n        </div>\n        <div class=\"mt-25\">\n            <button type=\"button\"\n                    (click)=\"insertLink()\"\n                    class=\"btn btn-lg mb-0 btn-success mr-10\">\n                Insert link\n            </button>\n            <button type=\"button\"\n                    (click)=\"onDismiss()\"\n                    class=\"btn btn-default mb-0 btn-lg mr-0\">\n                Cancel\n            </button>\n        </div>\n</div>\n"

/***/ }),

/***/ "./web/modern/components/common/sn-quill-editor/modals/sn-quill-link-modal/sn-quill-link-modal.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var ng_bootstrap_1 = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/index.js");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var SnQuillLinkModal = function () {
    function SnQuillLinkModal(messageService, activeModal, modalService) {
        _classCallCheck(this, SnQuillLinkModal);

        this.messageService = messageService;
        this.activeModal = activeModal;
        this.modalService = modalService;
        this.lookedLinks = ['%contract_link%', '%invoice_link%', '%quote_link%', '%questionnaire_link%', '%galleries_link%'];
        this.isMail = function (email) {
            return email.includes('@');
        };
    }

    _createClass(SnQuillLinkModal, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.successOpenModal(this.delta);
        }
    }, {
        key: "onDismiss",
        value: function onDismiss() {
            this.modalService.setModalData(null);
        }
    }, {
        key: "insertLink",
        value: function insertLink() {
            if (this.checkLinkValidation()) {
                var data = {
                    url: this.enteredUrl,
                    text: this.textToDisplay,
                    isEmail: this.isMail(this.enteredUrl)
                };
                this.modalService.setModalData(data);
            }
        }
    }, {
        key: "trackUrlInput",
        value: function trackUrlInput() {
            if (!this.hasChanged) {
                this.textToDisplay = this.enteredUrl;
            }
        }
    }, {
        key: "trackTextInput",
        value: function trackTextInput() {
            this.textToDisplay.length ? this.hasChanged = true : this.hasChanged = false;
        }
    }, {
        key: "successOpenModal",
        value: function successOpenModal(delta) {
            var data = delta;
            if (data) {
                this.enteredUrl = data.url;
                this.textToDisplay = data.text;
                this.checkIfNotVariableUrl(this.enteredUrl);
            }
            if (data.text) {
                this.hasChanged = true;
            }
        }
    }, {
        key: "checkLinkValidation",
        value: function checkLinkValidation() {
            if (!this.enteredUrl) {
                this.messageService.showToaster('e_0', 'generalValidation');
                return;
            }
            var isEmail = this.isMail(this.enteredUrl);
            if (this.isIncorrectUrl(this.enteredUrl)) {
                if (isEmail && this.isIncorrectMail(this.enteredUrl) || !isEmail) {
                    this.messageService.showToaster('e_0', 'generalValidation');
                    return;
                }
            }
            if (!this.textToDisplay.trim()) {
                this.textToDisplay = this.enteredUrl;
            }
            return true;
        }
    }, {
        key: "isIncorrectUrl",
        value: function isIncorrectUrl(url) {
            if (this.disableLink) {
                return false;
            }
            if (url.startsWith('http://') && url.length > 7) {
                return false;
            }
            if (url.startsWith('https://') && url.length > 8) {
                return false;
            }
            return true;
        }
    }, {
        key: "isIncorrectMail",
        value: function isIncorrectMail(email) {
            var emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return !emailRegex.test(email);
        }
    }, {
        key: "checkIfNotVariableUrl",
        value: function checkIfNotVariableUrl(url) {
            if (url) {
                for (var i = 0, max = this.lookedLinks.length; i < max; i++) {
                    if (url.includes(this.lookedLinks[i])) {
                        this.disableLink = true;
                    }
                }
            }
        }
    }]);

    return SnQuillLinkModal;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], SnQuillLinkModal.prototype, "delta", void 0);
SnQuillLinkModal = __decorate([core_1.Component({
    selector: 'sn-quill-link-modal',
    template: __webpack_require__("./web/modern/components/common/sn-quill-editor/modals/sn-quill-link-modal/sn-quill-link-modal.html")
}), __metadata("design:paramtypes", [message_service_1.MessageService, ng_bootstrap_1.NgbActiveModal, snModal_service_1.SNModalService])], SnQuillLinkModal);
exports.SnQuillLinkModal = SnQuillLinkModal;

/***/ }),

/***/ "./web/modern/components/common/sn-quill-editor/sn-quill-editor-web.html":
/***/ (function(module, exports) {

module.exports = "<quill-editor\n        [ngModel]=\"initValue\"\n        (onContentChanged)=\"onContentChange($event)\"\n        (onEditorCreated)=\"onEditorCreated($event)\"\n        (onSelectionChanged)=\"onSelectionChanged($event)\"\n        [style]=\"styles\"\n        [modules]=\"quillEditorOptions\"\n        [placeholder]=\"placeholder\"\n        [bounds]=\"'self'\"\n>\n</quill-editor>\n<div *ngIf=\"counterShow\" [id]=\"'counter-' + editorID\" class=\"counter\"></div>\n<web-attachments (attachmentsChanged)=\"emitNewAttachments($event)\" [attachmentId]=\"editorID\" [filesObj]=\"filesObj\"></web-attachments>\n<input [id]=\"'image-input-' + editorID\" style=\"display: none\" type=\"file\">\n"

/***/ }),

/***/ "./web/modern/components/common/sn-quill-editor/sn-quill-editor-web.scss":
/***/ (function(module, exports) {

module.exports = "sn-quill-editor-web {\n  display: block; }\n  sn-quill-editor-web .counter {\n    text-align: right;\n    border: 1px solid #ccc;\n    border-top: none;\n    padding: 2px 4px;\n    opacity: 0.4;\n    font-size: 13px !important; }\n  sn-quill-editor-web .ql-editor.ql-blank::before {\n    font-style: normal;\n    color: rgba(0, 0, 0, 0.4); }\n  sn-quill-editor-web .disableOption {\n    pointer-events: none;\n    opacity: 0.4; }\n  sn-quill-editor-web .ql-toolbar.ql-snow {\n    padding: 8px;\n    padding-bottom: 0; }\n    sn-quill-editor-web .ql-toolbar.ql-snow .ql-formats {\n      margin-right: 6px;\n      vertical-align: unset; }\n      sn-quill-editor-web .ql-toolbar.ql-snow .ql-formats button:focus,\n      sn-quill-editor-web .ql-toolbar.ql-snow .ql-formats .ql-color-picker:focus,\n      sn-quill-editor-web .ql-toolbar.ql-snow .ql-formats .ql-size:focus,\n      sn-quill-editor-web .ql-toolbar.ql-snow .ql-formats .ql-font:focus,\n      sn-quill-editor-web .ql-toolbar.ql-snow .ql-formats .ql-variables:focus,\n      sn-quill-editor-web .ql-toolbar.ql-snow .ql-formats .ql-attachments:focus {\n        outline: none !important; }\n      sn-quill-editor-web .ql-toolbar.ql-snow .ql-formats button .ql-picker-label:focus,\n      sn-quill-editor-web .ql-toolbar.ql-snow .ql-formats .ql-color-picker .ql-picker-label:focus,\n      sn-quill-editor-web .ql-toolbar.ql-snow .ql-formats .ql-size .ql-picker-label:focus,\n      sn-quill-editor-web .ql-toolbar.ql-snow .ql-formats .ql-font .ql-picker-label:focus,\n      sn-quill-editor-web .ql-toolbar.ql-snow .ql-formats .ql-variables .ql-picker-label:focus,\n      sn-quill-editor-web .ql-toolbar.ql-snow .ql-formats .ql-attachments .ql-picker-label:focus {\n        outline: none !important; }\n      sn-quill-editor-web .ql-toolbar.ql-snow .ql-formats button .ql-picker-options .ql-picker-item:focus,\n      sn-quill-editor-web .ql-toolbar.ql-snow .ql-formats .ql-color-picker .ql-picker-options .ql-picker-item:focus,\n      sn-quill-editor-web .ql-toolbar.ql-snow .ql-formats .ql-size .ql-picker-options .ql-picker-item:focus,\n      sn-quill-editor-web .ql-toolbar.ql-snow .ql-formats .ql-font .ql-picker-options .ql-picker-item:focus,\n      sn-quill-editor-web .ql-toolbar.ql-snow .ql-formats .ql-variables .ql-picker-options .ql-picker-item:focus,\n      sn-quill-editor-web .ql-toolbar.ql-snow .ql-formats .ql-attachments .ql-picker-options .ql-picker-item:focus {\n        outline: none !important; }\n      sn-quill-editor-web .ql-toolbar.ql-snow .ql-formats button:not(:first-child) {\n        border-left-width: 0;\n        margin-left: 0; }\n  sn-quill-editor-web .ql-snow.ql-toolbar button,\n  sn-quill-editor-web .ql-snow .ql-toolbar button,\n  sn-quill-editor-web .ql-color-picker {\n    width: 34px;\n    height: 32px;\n    padding: 8px;\n    border: 1px solid #e5e5e5;\n    margin-bottom: 4px;\n    margin-left: 4px;\n    position: relative; }\n    sn-quill-editor-web .ql-snow.ql-toolbar button svg,\n    sn-quill-editor-web .ql-snow .ql-toolbar button svg,\n    sn-quill-editor-web .ql-color-picker svg {\n      position: absolute;\n      width: 18px;\n      height: 18px;\n      top: 0;\n      right: 0;\n      left: 0;\n      bottom: 0;\n      margin: auto; }\n  sn-quill-editor-web .ql-align.ql-picker.ql-icon-picker {\n    width: 40px;\n    height: 32px;\n    padding: 6px;\n    border: 1px solid #e5e5e5;\n    margin-bottom: 4px;\n    margin-left: 4px;\n    position: relative; }\n    sn-quill-editor-web .ql-align.ql-picker.ql-icon-picker .ql-picker-label {\n      position: relative;\n      outline: none !important; }\n      sn-quill-editor-web .ql-align.ql-picker.ql-icon-picker .ql-picker-label:hover {\n        color: #444 !important; }\n      sn-quill-editor-web .ql-align.ql-picker.ql-icon-picker .ql-picker-label svg {\n        width: 18px;\n        height: 18px;\n        position: absolute; }\n        sn-quill-editor-web .ql-align.ql-picker.ql-icon-picker .ql-picker-label svg:first-child {\n          top: -1px;\n          left: -1px; }\n        sn-quill-editor-web .ql-align.ql-picker.ql-icon-picker .ql-picker-label svg:last-child {\n          top: 0;\n          bottom: 0;\n          right: -7px;\n          margin: auto 0; }\n    sn-quill-editor-web .ql-align.ql-picker.ql-icon-picker .ql-picker-options {\n      padding-bottom: 0;\n      padding-top: 0; }\n      sn-quill-editor-web .ql-align.ql-picker.ql-icon-picker .ql-picker-options .ql-picker-item {\n        margin: 0 auto;\n        width: 30px;\n        height: 32px;\n        padding: 6px; }\n        sn-quill-editor-web .ql-align.ql-picker.ql-icon-picker .ql-picker-options .ql-picker-item svg {\n          width: 18px;\n          height: 18px; }\n          sn-quill-editor-web .ql-align.ql-picker.ql-icon-picker .ql-picker-options .ql-picker-item svg:nth-child(2) {\n            display: none; }\n  sn-quill-editor-web .ql-variables {\n    border: 1px solid #e5e5e5;\n    width: 90px;\n    height: 32px !important;\n    padding: 4px;\n    margin-bottom: 4px;\n    margin-left: 4px; }\n    sn-quill-editor-web .ql-variables:before {\n      content: 'Variables';\n      font-family: 'Open sans', sans-serif;\n      font-weight: 400;\n      position: absolute;\n      top: 5px;\n      width: 65px;\n      height: 14px;\n      left: 8px;\n      margin: auto; }\n    sn-quill-editor-web .ql-variables > span:first-child {\n      position: absolute;\n      right: 0;\n      top: 0;\n      bottom: 0;\n      height: 32px !important; }\n  sn-quill-editor-web .ql-attachments {\n    width: 42px;\n    height: 32px !important;\n    padding: 8px;\n    border-left: 0 !important;\n    border: 1px solid #e5e5e5; }\n    sn-quill-editor-web .ql-attachments:before {\n      content: '\\f0c6';\n      position: absolute;\n      top: 0;\n      right: 0;\n      left: 0;\n      bottom: 0;\n      font-family: 'FontAwesome';\n      margin: auto;\n      height: 20px;\n      width: 26px;\n      line-height: 22px;\n      font-size: 19px; }\n    sn-quill-editor-web .ql-attachments > span:first-child {\n      position: absolute;\n      right: 0;\n      top: 0;\n      bottom: 0;\n      height: 32px !important; }\n  sn-quill-editor-web .ql-snow .ql-color-picker,\n  sn-quill-editor-web .ql-snow .ql-icon-picker {\n    height: 32px;\n    width: 35px;\n    padding: 6px; }\n  sn-quill-editor-web .ql-font.ql-picker,\n  sn-quill-editor-web .ql-size.ql-picker {\n    margin-left: 4px;\n    margin-bottom: 4px;\n    border: 1px solid #e5e5e5;\n    height: 32px; }\n    sn-quill-editor-web .ql-font.ql-picker .ql-picker-label,\n    sn-quill-editor-web .ql-size.ql-picker .ql-picker-label {\n      line-height: 26px;\n      font-weight: 400; }\n  sn-quill-editor-web .ql-attachments,\n  sn-quill-editor-web .ql-variables {\n    position: relative; }\n    sn-quill-editor-web .ql-attachments .ql-picker-options,\n    sn-quill-editor-web .ql-variables .ql-picker-options {\n      padding-right: 15px;\n      position: absolute;\n      left: 0;\n      min-height: 100%;\n      max-height: 330px;\n      overflow-y: scroll;\n      z-index: 9999; }\n      sn-quill-editor-web .ql-attachments .ql-picker-options .ql-picker-item,\n      sn-quill-editor-web .ql-variables .ql-picker-options .ql-picker-item {\n        padding: 8px 0; }\n        sn-quill-editor-web .ql-attachments .ql-picker-options .ql-picker-item:before,\n        sn-quill-editor-web .ql-variables .ql-picker-options .ql-picker-item:before {\n          content: attr(data-value);\n          font-family: 'Open sans', sans-serif; }\n  sn-quill-editor-web .ql-editor {\n    font-family: 'Open Sans', Sans-Serif;\n    color: #000;\n    font-size: 13px;\n    line-height: 1.3;\n    word-break: keep-all;\n    max-height: 65vh;\n    min-height: 250px; }\n    sn-quill-editor-web .ql-editor strong {\n      font-weight: 700; }\n    sn-quill-editor-web .ql-editor p {\n      margin: 0;\n      font-style: normal;\n      letter-spacing: normal;\n      white-space: pre-wrap; }\n    sn-quill-editor-web .ql-editor ol,\n    sn-quill-editor-web .ql-editor ul {\n      padding: 0.5em;\n      padding-right: 0 !important; }\n      sn-quill-editor-web .ql-editor ol li,\n      sn-quill-editor-web .ql-editor ul li {\n        font-style: normal;\n        letter-spacing: normal;\n        margin-bottom: 4px; }\n    sn-quill-editor-web .ql-editor p,\n    sn-quill-editor-web .ql-editor h1,\n    sn-quill-editor-web .ql-editor h2,\n    sn-quill-editor-web .ql-editor h3,\n    sn-quill-editor-web .ql-editor h4,\n    sn-quill-editor-web .ql-editor h5,\n    sn-quill-editor-web .ql-editor h6,\n    sn-quill-editor-web .ql-editor div,\n    sn-quill-editor-web .ql-editor ul,\n    sn-quill-editor-web .ql-editor ol,\n    sn-quill-editor-web .ql-editor li,\n    sn-quill-editor-web .ql-editor img,\n    sn-quill-editor-web .ql-editor span {\n      line-height: 1.5; }\n  sn-quill-editor-web .ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options {\n    left: 0;\n    z-index: 9999; }\n  sn-quill-editor-web .ql-toolbar.ql-snow .ql-attachments .ql-picker-options {\n    width: 125px; }\n  sn-quill-editor-web .ql-snow.ql-toolbar button.ql-active {\n    box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125); }\n  sn-quill-editor-web .ql-snow .ql-variables.ql-picker.ql-expanded,\n  sn-quill-editor-web .ql-snow .ql-attachments.ql-picker.ql-expanded {\n    color: #ccc;\n    border-left: 1px solid #ccc !important;\n    border-color: #ccc; }\n    sn-quill-editor-web .ql-snow .ql-variables.ql-picker.ql-expanded .ql-picker-options,\n    sn-quill-editor-web .ql-snow .ql-attachments.ql-picker.ql-expanded .ql-picker-options {\n      color: #444; }\n  sn-quill-editor-web .red {\n    color: red !important; }\n  sn-quill-editor-web .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='10px']::before {\n    content: 'Small';\n    font-size: 14px !important; }\n  sn-quill-editor-web .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='18px']::before {\n    content: 'Large';\n    font-size: 16px !important; }\n  sn-quill-editor-web .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='28px']::before {\n    content: 'Huge';\n    font-size: 28px !important; }\n  sn-quill-editor-web .ql-picker-label.ql-active[data-value='28px']::before {\n    content: 'Huge' !important; }\n  sn-quill-editor-web .ql-picker-label.ql-active[data-value='18px']::before {\n    content: 'Large' !important; }\n  sn-quill-editor-web .ql-picker-label.ql-active[data-value='10px']::before {\n    content: 'Small' !important; }\n  sn-quill-editor-web .ql-snow .ql-tooltip {\n    background: none;\n    border: none;\n    box-shadow: none;\n    padding: 0; }\n    sn-quill-editor-web .ql-snow .ql-tooltip span {\n      margin-top: 0; }\n  sn-quill-editor-web .ql-snow .ql-tooltip.ql-editing input[type='text'] {\n    display: none !important; }\n  sn-quill-editor-web .removeTooltip {\n    display: none !important; }\n\n.last-package-item .package-item sn-quill-editor-web .ql-variables .ql-picker-options {\n  max-height: 250px; }\n"

/***/ }),

/***/ "./web/modern/components/common/sn-quill-editor/sn-quill-editor-web.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = undefined && undefined.__param || function (paramIndex, decorator) {
    return function (target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var sn_quill_editor_1 = __webpack_require__("./shared/components/common/sn-quill-editor/sn-quill-editor.ts");
var file_upload_data_service_1 = __webpack_require__("./shared/services/files/file-upload.data.service.ts");
var file_upload_service_1 = __webpack_require__("./shared/services/files/file-upload-service/file-upload.service.ts");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var rxjs_1 = __webpack_require__("./node_modules/rxjs/Rx.js");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var sn_quill_link_modal_1 = __webpack_require__("./web/modern/components/common/sn-quill-editor/modals/sn-quill-link-modal/sn-quill-link-modal.ts");
var sn_quill_attachment_modal_1 = __webpack_require__("./web/modern/components/common/sn-quill-editor/modals/sn-quill-attachment-modal/sn-quill-attachment.modal.ts");
var common_1 = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
var utils_1 = __webpack_require__("./web/js/helper/utils.js");
var SnQuillEditorWebComponent = function (_sn_quill_editor_1$Sn) {
    _inherits(SnQuillEditorWebComponent, _sn_quill_editor_1$Sn);

    function SnQuillEditorWebComponent(fileUploadDataService, fileUploadService, messageService, modalService, document) {
        _classCallCheck(this, SnQuillEditorWebComponent);

        var _this = _possibleConstructorReturn(this, (SnQuillEditorWebComponent.__proto__ || Object.getPrototypeOf(SnQuillEditorWebComponent)).call(this, fileUploadDataService, fileUploadService, messageService));

        _this.fileUploadDataService = fileUploadDataService;
        _this.modalService = modalService;
        _this.document = document;
        _this.onAttachmentsChange = new core_1.EventEmitter();
        _this.unsubscribe = new rxjs_1.Subject();
        _this.attachmentsOption = [{ attachments: ['From Files', 'From Computer'] }];
        return _this;
    }
    /* Emiters */


    _createClass(SnQuillEditorWebComponent, [{
        key: "emitNewAttachments",
        value: function emitNewAttachments($event) {
            this.onAttachmentsChange.emit($event);
        }
    }, {
        key: "attachmentsHandler",
        value: function attachmentsHandler(type) {
            this.attachmentSelector = "#attachment-" + this.editorID;
            if (type === 'From Files' && this.isStoredFiles) {
                this.showChooseFileModal();
            } else if (type === 'From Computer') {
                this.attachFileFromComputer();
            }
        }
        /* Attachments */

    }, {
        key: "showChooseFileModal",
        value: function showChooseFileModal() {
            var _this2 = this;

            var modal = this.modalService.openModal(sn_quill_attachment_modal_1.SnQuillAttachmentModal);
            // Subscribe for data to come on modal close
            this.linkdData$ = this.modalService.getModalData().subscribe(function (modalData) {
                _this2.linkdData$.unsubscribe();
                // WORKAROUND TO WORK WITH AngularJS MODALS
                // @ts-ignore: remove backdrop element
                modal._backdropCmptRef.location.nativeElement.remove();
                // @ts-ignore: remove modal window element
                modal._windowCmptRef.location.nativeElement.remove();
                if (!utils_1.hasSomeParentTheClass(_this2.editor, 'modal')) {
                    try {
                        document.body.classList.remove('modal-open');
                    } catch (e) {
                        console.error(e);
                    }
                }
            });
        }
    }, {
        key: "checkJobFiles",
        value: function checkJobFiles() {
            var _this3 = this;

            this.fileUploadDataService.filesObservable.takeUntil(this.unsubscribe).subscribe(function (storedFiles) {
                _this3.isStoredFiles = !!storedFiles.length;
                if (_this3.isStoredFiles) {
                    _this3.enableAttachments();
                } else {
                    _this3.disabledAttachmentsFromFiles();
                }
            });
        }
        // TODO need refactor

    }, {
        key: "enableAttachments",
        value: function enableAttachments() {
            var _this4 = this;

            var openDropDown = false;
            var attachmentsToolbarBtn = this.toolbar.querySelector('.ql-attachments');
            if (attachmentsToolbarBtn === null) {
                return;
            }
            attachmentsToolbarBtn.addEventListener('click', function () {
                openDropDown = !openDropDown;
                if (openDropDown) {
                    var fromFilesOption = _this4.toolbar.querySelector('.ql-picker-item[data-value="From Files"]');
                    if (fromFilesOption.classList.contains('disableOption')) {
                        fromFilesOption.classList.remove('disableOption');
                    }
                }
            });
        }
    }, {
        key: "openLinkModal",
        value: function openLinkModal(delta) {
            var _this5 = this;

            // Open modal
            var modal = this.modalService.openModal(sn_quill_link_modal_1.SnQuillLinkModal, {
                windowClass: 'ng-bootstrap-modal__small'
            });
            // Pass delta as an input
            modal.componentInstance.delta = delta;
            // Subscribe for data to come on modal close
            this.linkdData$ = this.modalService.getModalData().subscribe(function (modalData) {
                if (modalData) {
                    _this5.successCloseLinkModal(modalData, delta);
                }
                _this5.linkdData$.unsubscribe();
                _this5.tooltip.classList.remove('removeTooltip');
                // WORKAROUND TO WORK WITH AngularJS MODALS
                // @ts-ignore: remove backdrop element
                modal._backdropCmptRef.location.nativeElement.remove();
                // @ts-ignore: remove modal window element
                modal._windowCmptRef.location.nativeElement.remove();
                if (!utils_1.hasSomeParentTheClass(_this5.editor, 'modal')) {
                    try {
                        document.body.classList.remove('modal-open');
                    } catch (e) {
                        console.error(e);
                    }
                }
            });
        }
    }, {
        key: "insertIntoQuill",
        value: function insertIntoQuill(data) {
            if (data) {
                var cursorPosition = this.getCursorPosition();
                this.quill.insertText(cursorPosition, data.text, 'link', data.url, 'user');
                this.setCursorPosition(data.text.length, cursorPosition);
            }
        }
    }, {
        key: "clear",
        value: function clear() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "updateLink",
        value: function updateLink(delta, data) {
            if (!delta.url) {
                var cursorPos = this.getCursorPosition();
                this.quill.updateContents([{ retain: cursorPos || 1 }, { delete: data.text.length }, { insert: data.text, attributes: { link: data.url } }], 'user');
            } else {
                var pos = this.quill.getSelection();
                var leaf = this.quill.getLeaf(pos.index)[0];
                var elem = leaf.domNode.parentElement;
                var isLink = elem && elem.tagName === 'A';
                var isStyledLink = elem && (elem.tagName === 'STRONG' || elem.tagName === 'EM' || elem.tagName === 'U');
                if (!isLink && !isStyledLink) {
                    leaf = this.quill.getLeaf(pos.index + 1)[0];
                    elem = leaf.domNode.parentElement;
                    isLink = elem && elem.tagName === 'A';
                    isStyledLink = elem && (elem.tagName === 'STRONG' || elem.tagName === 'EM' || elem.tagName === 'U');
                }
                if (isLink) {
                    this.updateLeafByLink(data, elem);
                }
                if (isStyledLink) {
                    this.updateLeafByLink(data, elem.parentElement);
                }
            }
        }
    }, {
        key: "successCloseLinkModal",
        value: function successCloseLinkModal(linkModal, delta) {
            this.quill.focus();
            var modalData = linkModal;
            var editExisting = modalData && delta.text && delta.url;
            var createFromExisting = modalData && delta.text && !delta.url;
            var insertNew = modalData && !delta.text && !delta.url;
            this.checkIfEmail(modalData);
            if (insertNew) {
                this.insertIntoQuill(modalData);
            }
            if (editExisting || createFromExisting) {
                this.updateLink(delta, modalData);
            }
        }
    }, {
        key: "checkIfEmail",
        value: function checkIfEmail(linkData) {
            if (linkData.isEmail) {
                linkData.url = "mailto:" + linkData.url;
            }
        }
    }, {
        key: "updateLeafByLink",
        value: function updateLeafByLink(data, elem) {
            elem.setAttribute('href', data.url);
            elem.textContent = data.text;
            this.setCursorPosition(data.text.length, this.quill.getSelection().index);
        }
    }]);

    return SnQuillEditorWebComponent;
}(sn_quill_editor_1.SnQuillEditorComponent);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], SnQuillEditorWebComponent.prototype, "onAttachmentsChange", void 0);
SnQuillEditorWebComponent = __decorate([core_1.Component({
    selector: 'sn-quill-editor-web',
    template: __webpack_require__("./web/modern/components/common/sn-quill-editor/sn-quill-editor-web.html"),
    styles: [__webpack_require__("./web/modern/components/common/sn-quill-editor/sn-quill-editor-web.scss")],
    encapsulation: core_1.ViewEncapsulation.None
}), __param(4, core_1.Inject(common_1.DOCUMENT)), __metadata("design:paramtypes", [file_upload_data_service_1.FileUploadDataProvider, file_upload_service_1.FileUploadServiceProvider, message_service_1.MessageService, snModal_service_1.SNModalService, Document])], SnQuillEditorWebComponent);
exports.SnQuillEditorWebComponent = SnQuillEditorWebComponent;

/***/ }),

/***/ "./web/modern/components/common/sn-quill-view/sn-quill-view-web.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"ql-container ql-snow editor-view\" style=\"border-width: 0; word-break: break-word\">\n  <div class=\"ql-editor editor-view\" [innerHTML]=\"content | safeHtml\" (click)=\"openUrlInNewTab($event)\">\n  </div>\n</div>"

/***/ }),

/***/ "./web/modern/components/common/sn-quill-view/sn-quill-view-web.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var sn_quill_view_1 = __webpack_require__("./shared/components/common/sn-quill-view/sn-quill-view.ts");
var SnQuillWebViewComponent = function (_sn_quill_view_1$SnQu) {
    _inherits(SnQuillWebViewComponent, _sn_quill_view_1$SnQu);

    function SnQuillWebViewComponent() {
        _classCallCheck(this, SnQuillWebViewComponent);

        return _possibleConstructorReturn(this, (SnQuillWebViewComponent.__proto__ || Object.getPrototypeOf(SnQuillWebViewComponent)).apply(this, arguments));
    }

    _createClass(SnQuillWebViewComponent, [{
        key: "openUrlInNewTab",

        // We need to ensure that each and every link that will be clicked, have to be opened in new tab
        // The main reason for this is old client portal that gets loaded during redirection in the same tab.
        value: function openUrlInNewTab(event) {
            var el = event.target;
            if (el.tagName === 'A' && el.target !== '_blank') {
                event.preventDefault();
                window.open(el.href);
            }
        }
    }]);

    return SnQuillWebViewComponent;
}(sn_quill_view_1.SnQuillViewComponent);
__decorate([core_1.Input(), __metadata("design:type", String)], SnQuillWebViewComponent.prototype, "content", void 0);
SnQuillWebViewComponent = __decorate([core_1.Component({
    selector: 'sn-quill-view-web',
    template: __webpack_require__("./web/modern/components/common/sn-quill-view/sn-quill-view-web.html")
})], SnQuillWebViewComponent);
exports.SnQuillWebViewComponent = SnQuillWebViewComponent;

/***/ }),

/***/ "./web/modern/components/common/tabs-panel/tab.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var tabs_panel_component_1 = __webpack_require__("./web/modern/components/common/tabs-panel/tabs-panel.component.ts");
var TabComponent = function TabComponent(tabs) {
    _classCallCheck(this, TabComponent);

    this.active = false;
    tabs.addTab(this);
};
__decorate([core_1.Input(), __metadata("design:type", Object)], TabComponent.prototype, "active", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], TabComponent.prototype, "tabTitle", void 0);
__decorate([core_1.Input(), __metadata("design:type", Boolean)], TabComponent.prototype, "highlight", void 0);
TabComponent = __decorate([core_1.Component({
    selector: 'tab-component',
    template: "\n    <div [hidden]=\"!active\">\n      <ng-content></ng-content>\n    </div>\n  "
}), __metadata("design:paramtypes", [tabs_panel_component_1.TabsPanel])], TabComponent);
exports.TabComponent = TabComponent;

/***/ }),

/***/ "./web/modern/components/common/tabs-panel/tabs-panel.component.html":
/***/ (function(module, exports) {

module.exports = "<div [ngClass]=\"disabled && 'cursor-disabled'\">\n  <div [ngClass]=\"disabled && 'disabled'\">\n    <ul *ngIf=\"tabs.length > 1\">\n      <li *ngFor=\"let tab of tabs\"\n        (click)=\"selectTab(tab)\"\n        [ngClass]=\"{\n          'active': tab.active,\n          'highlight': tab.highlight\n        }\"\n      >\n        {{ tab.tabTitle }}\n        <i class=\"fa fa-exclamation-circle highlight-icon\"></i>\n      </li>\n      <div class=\"tab-placeholder\"></div>\n    </ul>\n    <ng-content></ng-content>\n  </div>\n</div>"

/***/ }),

/***/ "./web/modern/components/common/tabs-panel/tabs-panel.component.scss":
/***/ (function(module, exports) {

module.exports = ".cursor-disabled {\n  cursor: not-allowed; }\n  .cursor-disabled .disabled {\n    pointer-events: none; }\n\nul {\n  list-style: none;\n  padding: 0;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-wrap: wrap;\n      -ms-flex-wrap: wrap;\n          flex-wrap: wrap; }\n  ul li {\n    cursor: pointer;\n    padding: 13px 25px;\n    border: 1px solid transparent;\n    border-bottom: 1px solid #d7d7d7;\n    font-size: 14px;\n    margin-right: -1px;\n    position: relative; }\n    ul li .highlight-icon {\n      display: none;\n      color: #e65100;\n      font-size: 18px;\n      position: absolute;\n      margin-left: 4px;\n      margin-top: 1px; }\n    ul li.active {\n      border: 1px solid #d7d7d7;\n      border-bottom: none; }\n    ul li.highlight .highlight-icon {\n      display: inline-block; }\n  ul .tab-placeholder {\n    -webkit-box-flex: 1;\n    -webkit-flex-grow: 1;\n        -ms-flex-positive: 1;\n            flex-grow: 1;\n    border-bottom: 1px solid #d7d7d7; }\n"

/***/ }),

/***/ "./web/modern/components/common/tabs-panel/tabs-panel.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var TabsPanel = function () {
    function TabsPanel() {
        _classCallCheck(this, TabsPanel);

        this.disabled = false;
        this.onClickTab = new core_1.EventEmitter();
        this.tabs = [];
    }

    _createClass(TabsPanel, [{
        key: "selectTab",
        value: function selectTab(tab) {
            this.tabs.forEach(function (tab) {
                tab.active = false;
            });
            tab.active = true;
            this.onClickTab.emit(tab);
        }
    }, {
        key: "addTab",
        value: function addTab(tab) {
            this.tabs.push(tab);
        }
    }]);

    return TabsPanel;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], TabsPanel.prototype, "disabled", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], TabsPanel.prototype, "onClickTab", void 0);
TabsPanel = __decorate([core_1.Component({
    selector: 'tabs-panel',
    template: __webpack_require__("./web/modern/components/common/tabs-panel/tabs-panel.component.html"),
    styles: [__webpack_require__("./web/modern/components/common/tabs-panel/tabs-panel.component.scss")]
})], TabsPanel);
exports.TabsPanel = TabsPanel;

/***/ }),

/***/ "./web/modern/components/common/terms-updated-modal/terms-updated-modal.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"termsUpdatedModal\" class=\"modal modal-center fade\" tabindex=\"-1\" role=\"dialog\" data-keyboard=\"false\">\n    <div class=\"modal-dialog modal-welcome\">\n        <div class=\"modal-content modal-banner\">\n            <div class=\"ninja-logo-wrapper\">\n                <img src=\"https://app.studioninja.co/build/release-pipeline-119/resources/dist/assets/images/email/logo-funnel-0-x2.png\" alt=\"ninja\" style=\"position: absolute;left: calc(50% - 62px);top: 14px;width: 102px;\">\n            </div>\n\n            <div class=\"modal-body\" style=\"padding: 0!important\">\n                <h2 class=\"color-java mt-35 mb-40 text-center\">We’ve updated our Terms & Conditions</h2>\n                <p class=\"text-center mb-35\">\n                    In line with the recent changes to European Union data protection law, we updated both our Terms & Conditions and Privacy Policy. By clicking ‘Agree’, you agree to be bound by our latest\n                    <a class=\"pointer color-java\" href=\"http://www.studioninja.co/terms-conditions/\" target=\"_blank\">Terms & Conditions</a> and\n                    <a class=\"pointer color-java\" href=\"http://www.studioninja.co/privacy-policy/\" target=\"_blank\">Privacy Policy</a>.\n                </p>\n            </div>\n            <div class=\"modal-footer text-center flex-row flex-just-center pb-0\">\n                <button class=\"btn btn-grey-light btn-lg w-min-110\" (click)=\"logout()\">Disagree</button>\n                <button class=\"btn btn-success btn-lg w-min-110 ml-20\" (click)=\"agree()\">Agree</button>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),

/***/ "./web/modern/components/common/terms-updated-modal/terms-updated-modal.scss":
/***/ (function(module, exports) {

module.exports = "#termsUpdatedModal .modal-dialog {\n  max-width: 560px; }\n  #termsUpdatedModal .modal-dialog .modal-body {\n    padding: 10px 15px; }\n  #termsUpdatedModal .modal-dialog p {\n    line-height: 1.7; }\n  #termsUpdatedModal .modal-dialog a {\n    text-decoration: underline; }\n"

/***/ }),

/***/ "./web/modern/components/common/terms-updated-modal/terms-updated-modal.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var account_service_1 = __webpack_require__("./web/modern/services/user/account.service.ts");
var TermsUpdatedModalComponent = function () {
    function TermsUpdatedModalComponent(accountService) {
        _classCallCheck(this, TermsUpdatedModalComponent);

        this.accountService = accountService;
        this.onDisagree = new core_1.EventEmitter();
        this.onAgree = new core_1.EventEmitter();
        this.unsubscribe = new Subject_1.Subject();
    }

    _createClass(TermsUpdatedModalComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {}
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "logout",
        value: function logout() {
            this.accountService.logoutWeb();
        }
    }, {
        key: "agree",
        value: function agree() {
            this.onAgree.emit();
        }
    }]);

    return TermsUpdatedModalComponent;
}();
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], TermsUpdatedModalComponent.prototype, "onDisagree", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], TermsUpdatedModalComponent.prototype, "onAgree", void 0);
TermsUpdatedModalComponent = __decorate([core_1.Component({
    selector: 'terms-updated-modal',
    template: __webpack_require__("./web/modern/components/common/terms-updated-modal/terms-updated-modal.html"),
    styles: [__webpack_require__("./web/modern/components/common/terms-updated-modal/terms-updated-modal.scss")]
}), __metadata("design:paramtypes", [account_service_1.AccountServiceWebProvider])], TermsUpdatedModalComponent);
exports.TermsUpdatedModalComponent = TermsUpdatedModalComponent;

/***/ }),

/***/ "./web/modern/components/common/toggle/toggle.component.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"toggle\">\n  <span (click)=\"changeToggle(false)\" [class.disabled]=\"disabled\"  class=\"toggle-text toggle-off fs-11\">OFF</span>\n  <div class=\"pl-5 pr-5\">\n    <input [disabled]=\"disabled\"  (click)=\"emitToggleChange($event)\" [checked]=\"enabled\" class='control' id='{{id}}' type=\"checkbox\">\n    <label class=\"switch\" for='{{id}}'>\n      <span [class.disabled]=\"disabled\" [ngClass]=\"{'show-animation': showAnimation, 'span-checked': enabled}\" class=\"slider\"></span>\n    </label>\n  </div>\n  <span (click)=\"changeToggle(true)\" [class.disabled]=\"disabled\" [ngClass]=\"{'toggle-checked': enabled}\" class=\"toggle-text toggle-on fs-11\">ON</span>\n</div>\n\n"

/***/ }),

/***/ "./web/modern/components/common/toggle/toggle.component.scss":
/***/ (function(module, exports) {

module.exports = ".toggle {\n  width: 95px;\n  height: 20px;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex; }\n  .toggle-on {\n    color: #949494; }\n  .toggle-checked {\n    color: #22baa1; }\n  .toggle-text {\n    font-weight: 600;\n    cursor: pointer; }\n  .toggle .switch {\n    position: relative;\n    display: inline-block;\n    width: 40px;\n    height: 20px; }\n  .toggle .control {\n    display: none; }\n  .toggle .slider {\n    position: absolute;\n    width: 40px;\n    height: 20px;\n    border-radius: 27px;\n    box-sizing: border-box;\n    border: 1px solid #dddddd;\n    cursor: pointer; }\n  .toggle .slider::before {\n    content: '';\n    position: absolute;\n    width: 10px;\n    height: 10px;\n    left: 4px;\n    bottom: 4px;\n    border-radius: 50%;\n    background: #949494; }\n  .toggle .span-checked::before {\n    background: #22baa1;\n    -webkit-transform: translateX(19px);\n        -ms-transform: translateX(19px);\n            transform: translateX(19px); }\n  .toggle .show-animation {\n    -webkit-transition: 0.4s;\n    transition: 0.4s; }\n    .toggle .show-animation:before {\n      -webkit-transition: 0.4s;\n      transition: 0.4s; }\n  .toggle .disabled {\n    opacity: 0.7;\n    cursor: not-allowed; }\n"

/***/ }),

/***/ "./web/modern/components/common/toggle/toggle.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var ToggleComponent = function () {
    function ToggleComponent() {
        _classCallCheck(this, ToggleComponent);

        this.disabled = false;
        this.toggleChanged = new core_1.EventEmitter();
        this.showAnimation = false;
    }

    _createClass(ToggleComponent, [{
        key: "changeToggle",
        value: function changeToggle(value) {
            if (value !== this.enabled) {
                this.toggleChanged.emit(value);
            }
        }
    }, {
        key: "emitToggleChange",
        value: function emitToggleChange(e) {
            e.preventDefault();
            this.toggleChanged.emit(!this.enabled);
        }
    }, {
        key: "_enabled",
        set: function set(value) {
            var _this = this;

            this.enabled = value;
            // this setTimeout enables animation after setting default value
            setTimeout(function () {
                _this.showAnimation = true;
            }, 0);
        }
    }]);

    return ToggleComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", String)], ToggleComponent.prototype, "id", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], ToggleComponent.prototype, "disabled", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], ToggleComponent.prototype, "toggleChanged", void 0);
__decorate([core_1.Input('enabled'), __metadata("design:type", Object), __metadata("design:paramtypes", [Object])], ToggleComponent.prototype, "_enabled", null);
ToggleComponent = __decorate([core_1.Component({
    selector: 'sn-toggle',
    template: __webpack_require__("./web/modern/components/common/toggle/toggle.component.html"),
    styles: [__webpack_require__("./web/modern/components/common/toggle/toggle.component.scss")]
}), __metadata("design:paramtypes", [])], ToggleComponent);
exports.ToggleComponent = ToggleComponent;

/***/ }),

/***/ "./web/modern/components/common/upload-component/upload-component.html":
/***/ (function(module, exports) {

module.exports = "<input type=\"file\" name=\"file\" [id]=\"componentId\" [ngClass]=\"classComponent\" [placeholder]=\"placeholder\" [disabled]=\"disabled || loading\" [accept]=\"fileType\" (change)=\"onFileChange($event)\">"

/***/ }),

/***/ "./web/modern/components/common/upload-component/upload-component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var UploadComponent = function () {
    function UploadComponent(messageService) {
        _classCallCheck(this, UploadComponent);

        this.messageService = messageService;
        this.disabled = false;
        this.action = new core_1.EventEmitter();
    }

    _createClass(UploadComponent, [{
        key: "onFileChange",
        value: function onFileChange(event) {
            if (event.target.files && event.target.files.length > 0 && event.target.value !== '') {
                var file = event.target.files[0];
                if (this.validationXmlFile(file)) {
                    this.action.emit(file);
                }
                event.target.value = '';
            }
        }
    }, {
        key: "validationXmlFile",
        value: function validationXmlFile(file) {
            var validation = true;
            if (file.size === 0) {
                this.messageService.showToaster('e_12', 'fundy');
                validation = false;
            } else if (file.size >= 5000000) {
                // 5mb
                this.messageService.showToaster('e_6', 'fundy');
                validation = false;
            } else if (file.type !== 'text/xml') {
                this.messageService.showToaster('e_5', 'fundy');
                validation = false;
            }
            return validation;
        }
    }]);

    return UploadComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", String)], UploadComponent.prototype, "classComponent", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], UploadComponent.prototype, "placeholder", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], UploadComponent.prototype, "disabled", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], UploadComponent.prototype, "fileType", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], UploadComponent.prototype, "componentId", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], UploadComponent.prototype, "action", void 0);
UploadComponent = __decorate([core_1.Component({
    selector: 'upload-component',
    template: __webpack_require__("./web/modern/components/common/upload-component/upload-component.html")
}), __metadata("design:paramtypes", [message_service_1.MessageService])], UploadComponent);
exports.UploadComponent = UploadComponent;

/***/ }),

/***/ "./web/modern/components/contract/contract-signature/contract-signature.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"main-block\">\n    <div class=\" block-signature word-wrap mb-30 mr-30 signature-margin\" *ngIf=\"contract && contract.signatures.photographerSignature\">\n        <div class=\"p-5\">\n            <p class=\"contract-signature\">{{ contract.signatures.photographerSignature.signature }}</p>\n            <br>\n            <div class=\"bold mt-10 mb-5\">{{ contract.signatures.photographerSignature.signature }} <br></div>\n            <div class=\"mb-15\">Signed on\n                {{ contract.signatures.photographerSignature.signedOn | timeFilter: 'long' }}\n                {{ contract.signatures.photographerSignature.signedOn | timeFilter: 'hourAndMin' }}</div>\n            <div class=\"flex-row mb-4 mt-20 checkbox-event\" *ngIf=\"contract.signatures.photographerSignature.agreement\">\n                <div class=\"checkbox-squared\">\n                    <input type=\"checkbox\"\n                           [checked]=\"contract.signatures.photographerSignature.agreement.selected\"\n                           id=\"photographerSignature\"/>\n                    <label for=\"photographerSignature\"></label>\n                </div>\n                <label for=\"photographerSignature\" class=\"checkbox-label\">\n                    {{ contract.signatures.photographerSignature.agreement.description }}\n                </label>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"block-wrapper\">\n        <div [class.block-signature]=\"contract.signatures.primarySignature\" class=\"word-wrap mb-30 mr-30 signature-margin\" *ngIf=\"contract\">\n            <div class=\"word-wrap\">\n                <div class=\"p-top-43 empty-signature\" *ngIf=\"!contract.signatures.primarySignature\">\n                    <div class=\"bold border-client-on-top\">Your Full Name</div>\n                </div>\n                <div class=\"p-5\" *ngIf=\"contract.signatures.primarySignature\">\n                    <p class=\"contract-signature\">{{ contract.signatures.primarySignature.signature }}</p>\n                    <br>\n                    <div class=\"bold mt-10 mb-5\">{{ contract.signatures.primarySignature.signature }} <br></div>\n                    <div class=\"mb-15\">Signed on\n                        {{ contract.signatures.primarySignature.signedOn| timeFilter: 'long' }}\n                        {{ contract.signatures.primarySignature.signedOn | timeFilter: 'hourAndMin' }}\n                    </div>\n                    <div class=\"flex-row mb-4 mt-20 checkbox-event\" *ngIf=\"contract.signatures.primarySignature.agreement\">\n                        <div class=\"checkbox-squared\">\n                            <input type=\"checkbox\"\n                                   [checked]=\"contract.signatures.primarySignature.agreement.selected\"\n                                   id=\"primarySignature\"/>\n                            <label for=\"primarySignature\"></label>\n                        </div>\n                        <label for=\"primarySignature\" class=\"checkbox-label\">\n                            {{ contract.signatures.primarySignature.agreement.description }}\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"block-signature word-wrap mb-30\" *ngIf=\"contract && contract.signatures.secondarySignature\">\n            <div class=\"p-5\">\n                <p class=\"contract-signature\">{{ contract.signatures.secondarySignature.signature }}</p>\n                <br>\n                <div class=\"bold mt-10 mb-5\">{{ contract.signatures.secondarySignature.signature }} <br></div>\n                <div class=\"mb-15\">Signed on\n                    {{ contract.signatures.secondarySignature.signedOn | timeFilter: 'long' }}\n                    {{ contract.signatures.secondarySignature.signedOn | timeFilter: 'hourAndMin' }}\n                </div>\n                <div class=\"flex-row mb-4 mt-20 checkbox-event\" *ngIf=\"contract.signatures.secondarySignature.agreement\">\n                    <div class=\"checkbox-squared\">\n                        <input type=\"checkbox\"\n                               [checked]=\"contract.signatures.secondarySignature.agreement.selected\"\n                               id=\"secondarySignature\"/>\n                        <label for=\"secondarySignature\"></label>\n                    </div>\n                    <label for=\"secondarySignature\" class=\"checkbox-label\">\n                        {{ contract.signatures.secondarySignature.agreement.description }}\n                    </label>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "./web/modern/components/contract/contract-signature/contract-signature.scss":
/***/ (function(module, exports) {

module.exports = ""

/***/ }),

/***/ "./web/modern/components/contract/contract-signature/contract-signature.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var ContractSignatureComponent = function ContractSignatureComponent() {
    _classCallCheck(this, ContractSignatureComponent);
};
__decorate([core_1.Input(), __metadata("design:type", Object)], ContractSignatureComponent.prototype, "contract", void 0);
ContractSignatureComponent = __decorate([core_1.Component({
    selector: 'contract-signature',
    template: __webpack_require__("./web/modern/components/contract/contract-signature/contract-signature.html"),
    styles: [__webpack_require__("./web/modern/components/contract/contract-signature/contract-signature.scss")]
})], ContractSignatureComponent);
exports.ContractSignatureComponent = ContractSignatureComponent;

/***/ }),

/***/ "./web/modern/components/contract/edit-contract-modal/edit-contract-modal.component.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n    <button class=\"close\" (click)=\"onDismiss()\" data-dismiss=\"modal\" aria-hidden=\"true\">&times;</button>\n    <h3 class=\"modal-title\">Edit Contract</h3>\n</div>\n<div class=\"modal-body\" style=\"padding: 20px!important;\">\n    <div class=\"field-info\">\n        <h4 class=\"mt-0\">Contract terms and conditions</h4>\n\n        <sn-quill-editor-web\n                (onTextChange)=\"contractToEdit.text = $event\"\n                [initValue]=\"contractToEdit.text\"\n                [maxLength]=\"4000\"\n                [placeholder]=\"'Type description here … '\"\n                [styles]=\"{'height': '400px'}\"\n                [varsList]=\"isFixed ? 'PRODUCT_MENU': 'CONTRACT_MENU'\"\n                [toolbarSettings]=\"'variables color size font'\"\n        ></sn-quill-editor-web>\n    </div>\n    <div class=\"mt-20\">\n        <button (click)=\"saveEditedContract()\" [disabled]=\"btnDisabled\" [is-spinning-wheel-active]=\"btnDisabled\" class=\"btn btn-lg btn-success mb-0 mr-10\" spinning-wheel type=\"button\">Save Contract</button>\n        <button type=\"button\" [disabled]=\"btnDisabled\" (click)=\"onDismiss()\" class=\"btn btn-lg btn-default mb-0\" data-dismiss=\"modal\">Cancel</button>\n    </div>\n</div>"

/***/ }),

/***/ "./web/modern/components/contract/edit-contract-modal/edit-contract-modal.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var ng_bootstrap_1 = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/index.js");
var common_1 = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
var EditContractModalComponent = function () {
    function EditContractModalComponent(activeModal, modalService, location) {
        var _this = this;

        _classCallCheck(this, EditContractModalComponent);

        this.activeModal = activeModal;
        this.modalService = modalService;
        this.location = location;
        this.btnDisabled = false;
        location.onPopState(function () {
            return _this.onDismiss();
        });
    }

    _createClass(EditContractModalComponent, [{
        key: "onDismiss",
        value: function onDismiss() {
            if (!this.btnDisabled) {
                this.modalService.setModalData({
                    action: 'CLOSE_MODAL',
                    props: null
                });
            }
        }
    }, {
        key: "saveEditedContract",
        value: function saveEditedContract() {
            if (this.contractToEdit && this.contractToEdit.text !== '') {
                this.modalService.setModalData({
                    action: this.action,
                    props: JSON.parse(JSON.stringify(this.contractToEdit))
                });
            }
        }
    }]);

    return EditContractModalComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], EditContractModalComponent.prototype, "btnDisabled", void 0);
__decorate([core_1.Input(), __metadata("design:type", Boolean)], EditContractModalComponent.prototype, "isFixed", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], EditContractModalComponent.prototype, "action", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], EditContractModalComponent.prototype, "contractToEdit", void 0);
EditContractModalComponent = __decorate([core_1.Component({
    selector: 'edit-contract-modal',
    template: __webpack_require__("./web/modern/components/contract/edit-contract-modal/edit-contract-modal.component.html")
}), __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal, snModal_service_1.SNModalService, common_1.PlatformLocation])], EditContractModalComponent);
exports.EditContractModalComponent = EditContractModalComponent;

/***/ }),

/***/ "./web/modern/components/dashboard/drag-and-drop-block/drag-and-drop-block.html":
/***/ (function(module, exports) {

module.exports = "<div dragula=\"draggableBlocks\" dnd-auto-scroll [(dragulaModel)]=\"draggableBlocks\">\n  <div *ngFor=\"let block of draggableBlocks\">\n    <div class=\"row stats justify-content-row wrap\" *ngIf=\"block === 'graphs'\">\n      <div class=\"col-md-12\">\n        <div class=\"handle-block\"></div>\n        <graphs-block [jobTypes]=\"jobTypes\"></graphs-block>\n      </div>\n    </div>\n    <div *ngIf=\"block === 'panels'\">\n      <div #container class=\"row stats justify-content-row wrap nested-panels\" id=\"table-first\" dragula=\"draggablePanels\" [(dragulaModel)]=\"draggablePanels\">\n        <div *ngFor=\"let panel of draggablePanels\"\n             class=\"col-md-6 justify-content-item second-column-jobs draggable-panel\">\n          <div class=\"handlePanel\"></div>\n          <shoots-appointments-block *ngIf=\"panel === 'upcoming_shoot_and_appointment'\"\n                                     [jobTypes]='jobTypes'\n                                     [buttonDisabled]=\"button_disable\"\n                                     [spinningWheelActive]=\"isAddNewSpinnningWheelActive\"\n                                     (chooseModalTrigger)=\"chooseModalHandler($event)\">\n          </shoots-appointments-block>\n          <recent-leads-block *ngIf=\"panel === 'most_recent_leads'\"\n                              [buttonDisabled]=\"buttonDisabled\"\n                              [spinningWheelActive]=\"addNewLeadSpinningWheel\"\n                              (sendEmailModalTrigger)=\"sendEmailModalHandler($event)\"\n                              (editLeadModalTrigger)=\"editLeadModalHandler($event)\"\n                              (addNewLeadModalTrigger)=\"showAddNewLeadModal()\">\n          </recent-leads-block>\n          <upcoming-payments-block *ngIf=\"panel === 'overdue_and_upcoming_payments'\">\n          </upcoming-payments-block>\n          <job-task-block\n              *ngIf=\"panel === 'job_task_with_due_dates'\"\n              (editJobModalTrigger)=\"editJobModalHandler($event)\"\n          ></job-task-block>\n        </div>\n\n      </div>\n    </div>\n  </div>\n\n</div>\n"

/***/ }),

/***/ "./web/modern/components/dashboard/drag-and-drop-block/drag-and-drop-block.scss":
/***/ (function(module, exports) {

module.exports = ":host .draggable-panel {\n  padding-bottom: 10px;\n  -webkit-transition: opacity 0.4s ease-in-out;\n  transition: opacity 0.4s ease-in-out; }\n\n:host .gu-mirror {\n  cursor: -webkit-grabbing !important;\n  cursor: grabbing !important; }\n  @media (min-width: 1620px) {\n    :host .gu-mirror {\n      width: 780px !important;\n      min-width: 780px !important; } }\n  :host .gu-mirror .handlePanel,\n  :host .gu-mirror .handle-block {\n    cursor: -webkit-grabbing !important;\n    cursor: grabbing !important; }\n\n:host .dndPlaceholder {\n  min-height: 701px !important;\n  min-width: 50%;\n  border: none;\n  background-color: inherit;\n  padding: 0 15px 0;\n  margin-top: 10px; }\n  :host .dndPlaceholder:after {\n    content: '';\n    display: block;\n    border: 1px dashed #b6bcbf;\n    background-color: rgba(126, 168, 204, 0.48);\n    height: 100%; }\n\n:host .handlePanel,\n:host .handle-block {\n  position: absolute;\n  top: 15px;\n  left: 15px;\n  width: 90%;\n  height: 80px;\n  opacity: 1;\n  cursor: pointer;\n  /* fallback if grab cursor is unsupported */\n  cursor: -webkit-grab;\n  cursor: grab; }\n"

/***/ }),

/***/ "./web/modern/components/dashboard/drag-and-drop-block/drag-and-drop-block.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var ng2_dragula_1 = __webpack_require__("./node_modules/ng2-dragula/index.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var settings_1 = __webpack_require__("./shared/services/settings/settings.ts");
var DragAndDropBlockComponent = function () {
    function DragAndDropBlockComponent(dragulaService, settingsService, messageService) {
        _classCallCheck(this, DragAndDropBlockComponent);

        this.dragulaService = dragulaService;
        this.settingsService = settingsService;
        this.messageService = messageService;
        this.sendEmailModalTrigger = new core_1.EventEmitter();
        this.editLeadModalTrigger = new core_1.EventEmitter();
        this.addNewLeadModalTrigger = new core_1.EventEmitter();
        this.chooseModalTrigger = new core_1.EventEmitter();
        // job-task-block
        this.editJobModalTrigger = new core_1.EventEmitter();
        this.unsubscribe = new Subject_1.Subject();
        this.oldPanelsPosition = [];
        this.draggablePanels = [];
        this.draggableBlocks = [];
        this.dragulaPanelsOptions = {
            moves: function moves(el, container, handle) {
                return handle.className === 'handlePanel';
            },
            direction: 'horizontal'
        };
        this.dragulaBlocksOptions = {
            moves: function moves(el, container, handle) {
                return handle.className === 'handle-block';
            }
        };
    }

    _createClass(DragAndDropBlockComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.setDragulaOptions();
            this.subscribeToPanelsPosition();
            this.dashboardBackground = document.querySelector('#main-section');
            this.dashboardBackground.classList.add('pale-blueish-grey-background');
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.clear();
            this.dragulaService.destroy('draggablePanels');
            this.dragulaService.destroy('draggableBlocks');
            this.dashboardBackground.classList.remove('pale-blueish-grey-background');
        }
        // recent-leads-block

    }, {
        key: "sendEmailModalHandler",
        value: function sendEmailModalHandler(mailData) {
            this.sendEmailModalTrigger.emit(mailData);
        }
    }, {
        key: "editLeadModalHandler",
        value: function editLeadModalHandler(leadData) {
            this.editLeadModalTrigger.emit(leadData);
        }
    }, {
        key: "showAddNewLeadModal",
        value: function showAddNewLeadModal() {
            this.addNewLeadModalTrigger.emit();
        }
        // shoots-appointment-block

    }, {
        key: "chooseModalHandler",
        value: function chooseModalHandler(event) {
            this.chooseModalTrigger.emit(event);
        }
        // job tasks with due date

    }, {
        key: "editJobModalHandler",
        value: function editJobModalHandler(leadData) {
            this.editJobModalTrigger.emit(leadData);
        }
        // drag-and-drop-block

    }, {
        key: "subscribeToPanelsPosition",
        value: function subscribeToPanelsPosition() {
            var _this = this;

            this.settingsService.panelsPositionObservable.takeUntil(this.unsubscribe).subscribe(function (panelsPosition) {
                if (panelsPosition.panelsPosition !== null) {
                    _this.setPanelsPosition(panelsPosition);
                }
            }, function (error) {
                return _this.messageService.showDefaultErrorMessage(error);
            });
        }
    }, {
        key: "setDragulaOptions",
        value: function setDragulaOptions() {
            var _this2 = this;

            this.dragulaService.setOptions('draggablePanels', this.dragulaPanelsOptions);
            this.dragulaService.setOptions('draggableBlocks', this.dragulaBlocksOptions);
            this.dragulaService.drag.takeUntil(this.unsubscribe).subscribe(function () {
                Object.assign(_this2.dragulaPanelsOptions, {
                    mirrorContainer: _this2.container.nativeElement
                });
            });
            this.dragulaService.dragend.takeUntil(this.unsubscribe).subscribe(function () {
                _this2.savePanelsPosition(_this2.draggablePanels);
            });
        }
    }, {
        key: "setPanelsPosition",
        value: function setPanelsPosition(panelsPosition) {
            this.draggableBlocks = panelsPosition.panels.indexOf('charts_panel') === 0 ? ['graphs', 'panels'] : ['panels', 'graphs'];
            this.draggablePanels = panelsPosition.panels.filter(function (panel) {
                return panel !== 'charts_panel';
            });
            this.oldPanelsPosition = this.draggablePanels.slice();
        }
    }, {
        key: "savePanelsPosition",
        value: function savePanelsPosition(panelsPosition) {
            var _this3 = this;

            this.draggableBlocks.indexOf('graphs') === 0 ? panelsPosition.unshift('charts_panel') : panelsPosition.push('charts_panel');
            this.settingsService.savePanelsPosition(panelsPosition).subscribe(function (result) {
                return console.log(result);
            }, function (error) {
                return _this3.messageService.showDefaultErrorMessage(error);
            });
        }
    }, {
        key: "clear",
        value: function clear() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }]);

    return DragAndDropBlockComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Boolean)], DragAndDropBlockComponent.prototype, "buttonDisabled", void 0);
__decorate([core_1.Input(), __metadata("design:type", Boolean)], DragAndDropBlockComponent.prototype, "addNewLeadSpinningWheel", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], DragAndDropBlockComponent.prototype, "sendEmailModalTrigger", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], DragAndDropBlockComponent.prototype, "editLeadModalTrigger", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], DragAndDropBlockComponent.prototype, "addNewLeadModalTrigger", void 0);
__decorate([core_1.Input(), __metadata("design:type", Boolean)], DragAndDropBlockComponent.prototype, "isAddNewSpinnningWheelActive", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], DragAndDropBlockComponent.prototype, "chooseModalTrigger", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], DragAndDropBlockComponent.prototype, "editJobModalTrigger", void 0);
__decorate([core_1.Input(), __metadata("design:type", Array)], DragAndDropBlockComponent.prototype, "jobTypes", void 0);
__decorate([core_1.ViewChild('container'), __metadata("design:type", core_1.ElementRef)], DragAndDropBlockComponent.prototype, "container", void 0);
DragAndDropBlockComponent = __decorate([core_1.Component({
    selector: 'drag-and-drop-block',
    template: __webpack_require__("./web/modern/components/dashboard/drag-and-drop-block/drag-and-drop-block.html"),
    styles: [__webpack_require__("./web/modern/components/dashboard/drag-and-drop-block/drag-and-drop-block.scss")]
}), __metadata("design:paramtypes", [ng2_dragula_1.DragulaService, settings_1.SettingsProvider, message_service_1.MessageService])], DragAndDropBlockComponent);
exports.DragAndDropBlockComponent = DragAndDropBlockComponent;

/***/ }),

/***/ "./web/modern/components/dashboard/graphs-block/graphs-block.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"stats__panel\">\n    <div class=\"dashboard-filters-row flex-row flex-wrap-xs flex-just-space btns-full-xm\">\n        <div class=\"select-style main-input-item job-types-filter\">\n            <select id=\"job-type\" [ngModel]=\"selectedJobType\" (ngModelChange)=\"onJobTypeChange($event)\" name=\"jobTypeSelect\">\n                <option [attr.selected]=\"selectedJobType === -1 ? 'selected' : null\" [value]=\"-1\">All Job Types</option>\n                <option [attr.selected]=\"selectedJobType === jobType.id ? 'selected' : null\" [value]=\"jobType.id\" *ngFor=\"let jobType of jobTypes\">{{ jobType.name }}</option>\n            </select>\n        </div>\n\n        <div class=\"date-range-filters\">\n            <div class=\"btn-group sn-btn-group date-range-presets\" role=\"group\" aria-label=\"date-range-buttons\">\n            <button type=\"button\"\n                    class=\"btn btn-default\"\n                    [ngClass]=\"{'focus': dateRangePreset === '7'}\"\n                    (click)=\"onDateRangePresetToggle('7')\"\n                    [disabled]=\"activeTab === 'revenue_menu' && this.blockWidth < 992\">\n                7 Days\n            </button>\n            <button type=\"button\"\n                    class=\"btn btn-default\"\n                    [ngClass]=\"{'focus': dateRangePreset === '30'}\"\n                    (click)=\"onDateRangePresetToggle('30')\"\n                    [disabled]=\"activeTab === 'revenue_menu' && this.blockWidth < 992\">\n                30 Days\n            </button>\n            <button type=\"button\"\n                    class=\"btn btn-default\"\n                    [ngClass]=\"{'focus': dateRangePreset === 'm'}\"\n                    (click)=\"onDateRangePresetToggle('m')\"\n                    [disabled]=\"activeTab === 'revenue_menu' && this.blockWidth < 992\">\n                Mtd\n            </button>\n            <button type=\"button\"\n                    class=\"btn btn-default\"\n                    [ngClass]=\"{'focus': dateRangePreset === 'y'}\"\n                    (click)=\"onDateRangePresetToggle('y')\"\n                    [disabled]=\"activeTab === 'revenue_menu' && this.blockWidth < 992\">\n                Ytd\n            </button>\n        </div>\n            <div class=\"daterangepicker-style main-input-item form-group has-feedback has-feedback-left mb-0\">\n            <input type=\"text\"\n                   name=\"daterange\"\n                   [(ngModel)]=\"selectedRange\"\n                   (ngModelChange)=\"setCustomDateRange($event)\"\n                   snDateRange [opens]=\"'left'\"\n                   [showCancel]=\"false\"\n                   [minDate]=\"minDate\"\n                   [maxDate]=\"maxDate\"\n                   [attr.disabled]=\"activeTab === 'revenue_menu' && this.blockWidth < 992 ? '' : null\"\n                   class=\"form-control graphs-block-date\"\n                   onkeypress=\"return false;\"\n                   onpaste=\"return false;\" />\n            <span class=\"form-control-feedback sn-daterangeicon\"></span>\n        </div>\n        </div>\n    </div>\n    <div class=\"graphs\">\n        <div class=\"graphs_block\" [class.graphs_block_extended]=\"leadSourcesAvailable\">\n            <div class=\"graphs_menu\">\n                <div [ngClass]=\"{'graphs_menu_active lead_menu' : activeTab === 'lead_menu'}\"\n                     (click)=\"onChangeActiveTab('lead_menu')\"\n                     id=\"lead_menu\" class=\"graphs-item\">\n                    Leads\n                    <span class=\"total lead_total graphs-item\">\n                    {{ (graphTotal.lead===0 || graphTotal.lead===null) ? 0: graphTotal.lead }}\n                </span>\n                </div>\n                <div [ngClass]=\"{'graphs_menu_active shoot_menu' : activeTab === 'shoot_menu'}\"\n                     (click)=\"onChangeActiveTab('shoot_menu')\"\n                     id=\"shoot_menu\" class=\"graphs-item\">\n                    {{ shootsTabName }}\n                    <span class=\"total shoot_total graphs-item\">\n                    {{ (graphTotal.shoot===0 || graphTotal.shoot===null) ? 0: graphTotal.shoot }}\n                </span>\n                </div>\n                <div [ngClass]=\"{'graphs_menu_active payment_menu' : activeTab === 'payment_menu'}\"\n                     (click)=\"onChangeActiveTab('payment_menu')\"\n                     id=\"payment_menu\" class=\"graphs-item\">\n                    Payments\n                    <span class=\"revenue-total-info graphs-item\">\n                        <span class=\"total payment_total\">\n                            {{ currency }}{{ (graphTotal.payments===0 || graphTotal.payments===null) ? 0: graphTotal.payments | number : '1.0-0' }}\n                        </span>\n                        <span class=\"total paymentDue_total\">\n                            ({{ currency }}{{ (graphTotal.paymentDue===0 || graphTotal.paymentDue===null) ? 0: graphTotal.paymentsDue | number : '1.0-0' }})\n                        </span>\n                    </span>\n\n                </div>\n                <div [ngClass]=\"{'graphs_menu_active revenue_menu' : activeTab === 'revenue_menu'}\"\n                     (click)=\"onChangeActiveTab('revenue_menu')\"\n                     id=\"revenue_menu\" class=\"graphs-item\">\n                    Revenue Comparison\n                </div>\n                <div class=\"graphs_menu_responsive graphs-item\" *ngIf=\"leadSourcesAvailable\"\n                     [ngClass]=\"{'graphs_menu_active lead_sources_menu' : activeTab === 'lead_sources_menu'}\"\n                     (click)=\"onChangeActiveTab('lead_sources_menu')\"\n                     id=\"lead_sources_menu\">\n                    Lead Sources\n                </div>\n            </div>\n\n            <div class=\"chart-container {{activeTab}}-graph\"\n                 [class.pie-chart-active]=\"activeTab === 'lead_sources_menu' && leadSourceData?.columns?.length\">\n\n                <div id=\"chart\" [class.pie-chart-active-blank]=\"activeTab === 'lead_sources_menu' && !leadSourceData?.columns?.length\"></div>\n                <div class=\"pie-chart-active-legend\"></div>\n                <div class=\"tab-chart\" *ngIf=\"activeTab === 'lead_sources_menu'\">\n                    <div *ngIf=\"leadSourceData && !leadSourceData.columns.length\" class=\"tab-chart-pie-container-blank\">\n                        There are no lead sources assigned to leads or jobs based on your search criteria.\n                    </div>\n                    <div *ngIf=\"!leadSourceData\" class=\"tab-chart-pie-container-blank\">\n                        Loading...\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"pie-chart-container\" *ngIf=\"leadSourcesAvailable && blockWidth > 992\">\n            <lead-sources-graph-section [chartData]=\"leadSourceData\" (viewAllEmit)=\"openViewAllModal()\"></lead-sources-graph-section>\n        </div>\n    </div>\n    <div *ngIf=\"activeTab === 'lead_sources_menu' && leadSourceData?.columns?.length\" class=\"tab-chart-footer\">\n        <button class=\"btn btn-default btn-dashboard\" (click)=\"openViewAllModal()\">Show All</button>\n    </div>\n</div>\n\n\n"

/***/ }),

/***/ "./web/modern/components/dashboard/graphs-block/graphs-block.scss":
/***/ (function(module, exports) {

module.exports = ":host {\n  background-color: #fff;\n  width: 100%; }\n  :host .stats__panel {\n    height: 500px; }\n  @media screen and (max-width: 992px) {\n    :host .graphs_block_extended .graphs_menu div {\n      width: 20%; } }\n  :host .graphs {\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    padding-top: 10px; }\n    :host .graphs_block {\n      width: 100%;\n      height: 366px;\n      border: 1px solid #e1e1e1;\n      border-top: none; }\n      :host .graphs_block_extended {\n        width: -webkit-calc(100% - 330px);\n        width: calc(100% - 330px); }\n    :host .graphs_menu {\n      display: -webkit-box;\n      display: -webkit-flex;\n      display: -ms-flexbox;\n      display: flex; }\n      :host .graphs_menu div:nth-child(4) {\n        border-right: none; }\n      :host .graphs_menu div:nth-child(5) {\n        border-left: 1px solid #e1e1e1;\n        border-right: none; }\n      :host .graphs_menu div {\n        color: #4e5e6a;\n        text-align: left;\n        padding: 14px 16px;\n        text-decoration: none;\n        font-size: 18px;\n        font-weight: 400;\n        width: 25%;\n        background-color: #f9f9f9;\n        border-bottom: 1px solid #e1e1e1;\n        border-right: 1px solid #e1e1e1;\n        border-top: 1px solid #e1e1e1; }\n        @media screen and (max-width: 592px) {\n          :host .graphs_menu div {\n            padding: 7px 8px; } }\n        @media screen and (max-width: 992px) {\n          :host .graphs_menu div {\n            width: 25%; } }\n  :host .pie-chart-tab {\n    display: none; }\n  :host .pie-chart-container {\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex; }\n  :host .lead_menu {\n    border-top: 2px solid #f27987 !important; }\n  :host .shoot_menu {\n    border-top: 2px solid #22baa1 !important; }\n  :host .payment_menu {\n    border-top: 2px solid #7d73b5 !important; }\n  :host .revenue_menu {\n    border-top: 2px solid #1bb1cc !important; }\n  :host .lead_sources_menu {\n    border-top: 2px solid #22baa1 !important; }\n    :host .lead_sources_menu-acrive {\n      padding-top: 5px; }\n  :host .total {\n    margin-left: 6px;\n    font-weight: 600; }\n  :host .lead_total {\n    color: #f27987; }\n  :host .shoot_total {\n    color: #22baa1; }\n  :host .shoot_total,\n  :host .lead_total {\n    display: block;\n    margin-left: 0; }\n  :host .payment_total {\n    color: #7d73b5;\n    margin-left: 0; }\n  :host .paymentDue_total {\n    color: #c2c2c2;\n    margin-left: 0; }\n  :host .revenue-total-info {\n    display: block;\n    font-size: 18px; }\n  :host .graphs_menu_active {\n    background-color: #fff !important;\n    border-bottom: none !important; }\n  :host .graphs_menu_responsive {\n    display: none !important; }\n  :host .graphs_menu:hover {\n    cursor: pointer; }\n  :host .dashboard-filters-row select {\n    z-index: 10;\n    position: relative; }\n  :host .dashboard-filters-row .main-input-item {\n    max-width: 210px;\n    -webkit-box-flex: 0;\n    -webkit-flex: 0 0 210px;\n        -ms-flex: 0 0 210px;\n            flex: 0 0 210px; }\n  :host .dashboard-filters-row .date-range-filters {\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    width: 100%;\n    -webkit-box-pack: center;\n    -webkit-justify-content: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-flex-wrap: wrap;\n        -ms-flex-wrap: wrap;\n            flex-wrap: wrap; }\n    :host .dashboard-filters-row .date-range-filters .date-range-presets {\n      margin-right: 10px; }\n  @media screen and (min-width: 992px) {\n    :host .dashboard-filters-row .main-input-item {\n      max-width: 280px;\n      -webkit-box-flex: 0;\n      -webkit-flex: 0 0 280px;\n          -ms-flex: 0 0 280px;\n              flex: 0 0 280px; }\n    :host .dashboard-filters-row .date-range-filters {\n      -webkit-box-pack: end;\n      -webkit-justify-content: flex-end;\n          -ms-flex-pack: end;\n              justify-content: flex-end; }\n      :host .dashboard-filters-row .date-range-filters .date-range-presets {\n        margin-right: 20px; } }\n  @media screen and (max-width: 767px) {\n    :host .dashboard-filters-row .job-types-filter {\n      margin-left: auto;\n      margin-right: auto;\n      margin-bottom: 10px; }\n    :host .dashboard-filters-row .date-range-filters {\n      -webkit-justify-content: space-around;\n          -ms-flex-pack: distribute;\n              justify-content: space-around;\n      width: 100%; } }\n  @media screen and (max-width: 518px) {\n    :host .dashboard-filters-row .main-input-item {\n      max-width: none; } }\n  :host .pie-chart-active {\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n    -webkit-justify-content: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n    -webkit-align-items: center;\n        -ms-flex-align: center;\n            align-items: center; }\n    :host .pie-chart-active .c3 {\n      width: 300px; }\n    :host .pie-chart-active-blank {\n      display: none; }\n  :host .tab-chart {\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n    -webkit-justify-content: center;\n        -ms-flex-pack: center;\n            justify-content: center; }\n    :host .tab-chart-pie-container-blank {\n      width: 240px;\n      height: 240px;\n      display: -webkit-box;\n      display: -webkit-flex;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: center;\n      -webkit-justify-content: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n      -webkit-box-align: center;\n      -webkit-align-items: center;\n          -ms-flex-align: center;\n              align-items: center;\n      text-align: center;\n      padding: 0 20px;\n      border-radius: 50%;\n      background-color: #f3f3f3;\n      color: #949494;\n      margin: 20px 30px 0;\n      -webkit-align-self: center;\n          -ms-flex-item-align: center;\n              align-self: center; }\n      @media screen and (max-width: 767px) {\n        :host .tab-chart-pie-container-blank {\n          margin-top: 27px;\n          width: 220px;\n          height: 220px; } }\n      @media screen and (max-width: 518px) {\n        :host .tab-chart-pie-container-blank {\n          margin-top: 12px;\n          width: 200px;\n          height: 200px; } }\n    :host .tab-chart-footer {\n      text-align: center;\n      margin-top: 10px; }\n      @media screen and (max-width: 767px) {\n        :host .tab-chart-footer {\n          margin-top: 6px; } }\n      @media screen and (max-width: 518px) {\n        :host .tab-chart-footer {\n          height: 4px; } }\n  @media screen and (max-width: 992px) {\n    :host .graphs_block {\n      width: 100%; }\n    :host .pie-chart-container {\n      display: none; }\n    :host .graphs_menu_responsive {\n      display: -webkit-box !important;\n      display: -webkit-flex !important;\n      display: -ms-flexbox !important;\n      display: flex !important; } }\n  @media screen and (max-width: 1199px) {\n    :host .graphs_menu div {\n      display: -webkit-box;\n      display: -webkit-flex;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-flex-wrap: wrap;\n          -ms-flex-wrap: wrap;\n              flex-wrap: wrap;\n      -webkit-box-pack: center;\n      -webkit-justify-content: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n      -webkit-align-content: center;\n          -ms-flex-line-pack: center;\n              align-content: center;\n      text-align: center;\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n      -webkit-flex-direction: column;\n          -ms-flex-direction: column;\n              flex-direction: column; } }\n  @media screen and (max-width: 1199px) {\n    :host .lead_total,\n    :host .shoot_total,\n    :host .revenue-total-info {\n      font-size: 14px; } }\n  @media screen and (max-width: 767px) {\n    :host .graphs_menu div {\n      font-size: 16px; }\n    :host .graphs_block {\n      height: 346px; }\n    :host .graphs_menu div .total {\n      margin-left: 0;\n      width: 100%; }\n    :host .graphs-block-date {\n      font-size: 12.5px; } }\n  @media screen and (max-width: 518px) {\n    :host .graphs_block {\n      height: 314px; }\n      :host .graphs_block .graphs-item {\n        font-size: 11px; } }\n"

/***/ }),

/***/ "./web/modern/components/dashboard/graphs-block/graphs-block.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var http_1 = __webpack_require__("./node_modules/@angular/common/esm5/http.js");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var rxjs_1 = __webpack_require__("./node_modules/rxjs/Rx.js");
var account_service_1 = __webpack_require__("./web/modern/services/user/account.service.ts");
var graphs_data_service_1 = __webpack_require__("./web/modern/components/dashboard/graphs-block/graphs.data.service.ts");
var time_service_1 = __webpack_require__("./shared/services/helpers/time-service/time.service.ts");
var graphs_service_1 = __webpack_require__("./web/modern/services/graph/graphs.service.ts");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var brands_data_service_1 = __webpack_require__("./shared/services/brands/brands.data.service.ts");
var settings_1 = __webpack_require__("./shared/services/settings/settings.ts");
var view_all_lead_sources_modal_1 = __webpack_require__("./web/modern/components/dashboard/modals/view-all-lead-sources/view-all-lead-sources-modal.ts");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var lead_sources_data_service_1 = __webpack_require__("./shared/services/lead-sources/lead-sources.data.service.ts");
var pie_graph_service_1 = __webpack_require__("./web/modern/services/graph/pie-graph.service.ts");
var moment = __webpack_require__("./node_modules/moment/moment.js");
var GraphsBlockComponent = function () {
    function GraphsBlockComponent(http, graphsDataService, timeService, graphsService, pieGraphService, accountService, brandsDataService, settingsService, messageService, modalService, leadSourcesService) {
        _classCallCheck(this, GraphsBlockComponent);

        this.http = http;
        this.graphsDataService = graphsDataService;
        this.timeService = timeService;
        this.graphsService = graphsService;
        this.pieGraphService = pieGraphService;
        this.accountService = accountService;
        this.brandsDataService = brandsDataService;
        this.settingsService = settingsService;
        this.messageService = messageService;
        this.modalService = modalService;
        this.leadSourcesService = leadSourcesService;
        this.graphTotal = {
            lead: null,
            shoot: null,
            payments: null,
            paymentsDue: null
        };
        this.unsubscribe = new Subject_1.Subject();
        this.selectedFilters = {
            fromDate: null,
            toDate: null,
            jobTypeId: null
        };
    }

    _createClass(GraphsBlockComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.subscribeToSettingsChange();
            this.subscribeToCustomizeLabelsChange();
            this.configureCommunicationAdapter();
            this.subscribeToBrandsChange();
            this.getData();
        }
    }, {
        key: "ngAfterViewInit",
        value: function ngAfterViewInit() {
            this.subscribeToLeadSourceUpdate();
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.graphsService.clear();
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "openViewAllModal",
        value: function openViewAllModal() {
            var modal = this.modalService.openModal(view_all_lead_sources_modal_1.ViewAllLeadSourcesModalComponent, { windowClass: 'ng-bootstrap-modal modal-visible modal-wide' });
            modal.componentInstance.modalPayload = {
                jobTypes: this.jobTypes,
                selectedFilters: this.selectedFilters,
                minDate: this.minDate,
                maxDate: this.maxDate,
                selectedRange: this.selectedRange
            };
        }
        // GRAPHS DATA MANIPULATION

    }, {
        key: "applyChosenJobType",
        value: function applyChosenJobType() {
            if (this.selectedJobType === -1) {
                this.selectedFilters.jobTypeId = null;
            } else {
                this.selectedFilters.jobTypeId = this.selectedJobType;
            }
        }
    }, {
        key: "applyChosenDateRange",
        value: function applyChosenDateRange() {
            this.selectedRange = {
                startDate: new Date(this.fromDate).toISOString(),
                endDate: new Date(this.toDate).toISOString()
            };
            this.selectedFilters.fromDate = this.selectedRange.startDate.slice(0, 10);
            this.selectedFilters.toDate = this.selectedRange.endDate.slice(0, 10);
        }
        // VIEW EVENTS HANDLERS

    }, {
        key: "onChangeActiveTab",
        value: function onChangeActiveTab(newActiveTab) {
            if (newActiveTab !== this.activeTab) {
                this.activeTab = newActiveTab;
                localStorage.setItem("dashboardActiveTab" + this.companyId, newActiveTab);
                this.paintGraphsOnTab(this.activeTab);
            }
        }
    }, {
        key: "onJobTypeChange",
        value: function onJobTypeChange(newJobType) {
            this.selectedJobType = parseInt(newJobType);
            localStorage.setItem("dashboardJobType" + this.companyId, newJobType);
            this.applyChosenJobType();
            this.applyFiltersToGraphsOn(['leads', 'shoots', 'payments', 'lead-source']);
        }
    }, {
        key: "onDateRangePresetToggle",
        value: function onDateRangePresetToggle(newRangePreset) {
            if (newRangePreset !== this.dateRangePreset) {
                this.dateRangePreset = newRangePreset;
                localStorage.setItem("presetDashboardDateRange" + this.companyId, this.dateRangePreset);
                localStorage.removeItem("dashboardFromDate" + this.companyId);
                localStorage.removeItem("dashboardToDate" + this.companyId);
                this.setDateRangePreset(this.dateRangePreset);
                this.applyChosenDateRange();
                this.applyFiltersToGraphsOn(['leads', 'shoots', 'payments', 'lead-source']);
            }
        }
    }, {
        key: "setCustomDateRange",
        value: function setCustomDateRange(newDateRange) {
            if (moment.isMoment(newDateRange.startDate)) {
                this.fromDate = this.timeService.getDateString(newDateRange.startDate.toDate());
                this.toDate = this.timeService.getDateString(newDateRange.endDate.toDate());
                this.dateRangePreset = null;
                localStorage.removeItem("presetDashboardDateRange" + this.companyId);
                localStorage.setItem("dashboardFromDate" + this.companyId, this.fromDate);
                localStorage.setItem("dashboardToDate" + this.companyId, this.toDate);
                this.applyChosenDateRange();
                this.applyFiltersToGraphsOn(['leads', 'shoots', 'payments', 'lead-source']);
            }
        }
        // PRESET DATE RANGES

    }, {
        key: "setDateRangePreset",
        value: function setDateRangePreset(dateRangePreset) {
            switch (dateRangePreset) {
                case '7':
                    {
                        this.setRangeToLastDays(7);
                        break;
                    }
                case '30':
                    {
                        this.setRangeToLastDays(30);
                        break;
                    }
                case 'm':
                    {
                        this.setMonthToDateRange();
                        break;
                    }
                case 'y':
                    {
                        this.setYearToDateRange();
                        break;
                    }
                default:
                    {
                        break;
                    }
            }
        }
    }, {
        key: "setRangeToLastDays",
        value: function setRangeToLastDays(daysBefore) {
            var today = new Date();
            var past = new Date();
            var difference = today.getDate() - daysBefore;
            past.setDate(difference);
            this.fromDate = this.timeService.getDateString(past);
            this.toDate = this.timeService.getDateString(today);
        }
    }, {
        key: "setMonthToDateRange",
        value: function setMonthToDateRange() {
            var today = new Date();
            var monthStart = new Date(today.getFullYear(), today.getMonth(), 1);
            this.fromDate = this.timeService.getDateString(monthStart);
            this.toDate = this.timeService.getDateString(today);
        }
    }, {
        key: "setYearToDateRange",
        value: function setYearToDateRange() {
            var today = new Date();
            var yearStart = new Date(today.getFullYear(), 0, 1);
            this.fromDate = this.timeService.getDateString(yearStart);
            this.toDate = this.timeService.getDateString(today);
        }
        /**
         * @method applyFiltersToGraphsOn
         * @desc gets an array of tabs, calculates dynamic number of API calls
         * and success calbacks, then runs them. When all is done, it calls a
         * method to paint graph on active tab
         * @param {string[]} tabs An array of tabs we need fetch new data for
         * */

    }, {
        key: "applyFiltersToGraphsOn",
        value: function applyFiltersToGraphsOn(tabs) {
            var _rxjs_1$Observable,
                _this = this;

            var _getGraphsObservables = this.getGraphsObservablesAndSuccessCallbacks(tabs),
                _getGraphsObservables2 = _slicedToArray(_getGraphsObservables, 2),
                graphsInfoObservables = _getGraphsObservables2[0],
                successCallbacks = _getGraphsObservables2[1];

            (_rxjs_1$Observable = rxjs_1.Observable).zip.apply(_rxjs_1$Observable, _toConsumableArray(graphsInfoObservables)).finally(function () {
                _this.paintGraphsOnTab(_this.activeTab);
            }).subscribe(function (data) {
                successCallbacks.forEach(function (callback, index) {
                    callback(data[index]);
                });
            }, function (error) {
                _this.messageService.showDefaultErrorMessage(error);
            });
        }
        // SUCCESS CALLBACKS

    }, {
        key: "leadsGraphInfoSuccessCallback",
        value: function leadsGraphInfoSuccessCallback(leadData) {
            this.leadsData = JSON.parse(JSON.stringify(leadData.data));
            this.graphTotal.lead = JSON.parse(JSON.stringify(leadData.total));
        }
    }, {
        key: "acceptedLeadGraphInfoSuccessCallback",
        value: function acceptedLeadGraphInfoSuccessCallback(acceptedLeadData) {
            this.acceptedLeadData = JSON.parse(JSON.stringify(acceptedLeadData.data));
        }
    }, {
        key: "shootsGraphInfoSuccessCallback",
        value: function shootsGraphInfoSuccessCallback(shootData) {
            this.shootsData = JSON.parse(JSON.stringify(shootData.data));
            this.graphTotal.shoot = JSON.parse(JSON.stringify(shootData.total));
        }
    }, {
        key: "paymentsGraphInfoSuccessCallback",
        value: function paymentsGraphInfoSuccessCallback(paymentData) {
            this.paymentsData = JSON.parse(JSON.stringify(paymentData.data));
            this.graphTotal.payments = JSON.parse(JSON.stringify(paymentData.total));
        }
    }, {
        key: "paymentsDueGraphInfoSuccessCallback",
        value: function paymentsDueGraphInfoSuccessCallback(paymentDueData) {
            this.paymentsDueData = JSON.parse(JSON.stringify(paymentDueData.data));
            this.graphTotal.paymentsDue = JSON.parse(JSON.stringify(paymentDueData.total));
        }
    }, {
        key: "revenueGraphInfoSuccessCallback",
        value: function revenueGraphInfoSuccessCallback(revenueData) {
            this.revenueData = JSON.parse(JSON.stringify(revenueData));
        }
    }, {
        key: "leadSourcesGraphSuccessCallback",
        value: function leadSourcesGraphSuccessCallback(leadSourceData) {
            this.leadSourceData = this.pieGraphService.preparePieChartData(leadSourceData.data);
        }
        /**
         * @method getGraphsObservablesAndSuccessCallbacks
         * @desc gets an array of tabs and depending on it dynamically populates
         * two arrays with needed observables and success callbacks lists.
         * @param {string[]} tabs An array of tabs we need fetch new data for
         * @returns {[Observable<any>[], Function[]]} [observables, callbacks]
         * an array of two arrays with generated observables and success callbacks
         * */

    }, {
        key: "getGraphsObservablesAndSuccessCallbacks",
        value: function getGraphsObservablesAndSuccessCallbacks(tabs) {
            var _this2 = this;

            var observables = [];
            var callbacks = [];
            tabs.forEach(function (tab) {
                switch (tab) {
                    case 'leads':
                        observables.push(_this2.graphsDataService.getLeadsGraphInfo(_this2.selectedFilters));
                        callbacks.push(_this2.leadsGraphInfoSuccessCallback.bind(_this2));
                        observables.push(_this2.graphsDataService.getAcceptedLeadGraphInfo(_this2.selectedFilters));
                        callbacks.push(_this2.acceptedLeadGraphInfoSuccessCallback.bind(_this2));
                        break;
                    case 'shoots':
                        observables.push(_this2.graphsDataService.getShootsGraphInfo(_this2.selectedFilters));
                        callbacks.push(_this2.shootsGraphInfoSuccessCallback.bind(_this2));
                        break;
                    case 'payments':
                        observables.push(_this2.graphsDataService.getPaymentsGraphInfo(_this2.selectedFilters));
                        callbacks.push(_this2.paymentsGraphInfoSuccessCallback.bind(_this2));
                        observables.push(_this2.graphsDataService.getPaymentsDueGraphInfo(_this2.selectedFilters, 'unpaid'));
                        callbacks.push(_this2.paymentsDueGraphInfoSuccessCallback.bind(_this2));
                        observables.push(_this2.graphsDataService.getAllTimeStatisticsGraphInfo(_this2.selectedFilters));
                        callbacks.push(_this2.revenueGraphInfoSuccessCallback.bind(_this2));
                        break;
                    case 'lead-source':
                        observables.push(_this2.leadSourcesService.getLeadSourceGraphData(_this2.selectedFilters));
                        callbacks.push(_this2.leadSourcesGraphSuccessCallback.bind(_this2));
                        break;
                    default:
                        break;
                }
            });
            return [observables, callbacks];
        }
    }, {
        key: "paintGraphsOnTab",
        value: function paintGraphsOnTab(tab) {
            switch (tab) {
                case 'lead_menu':
                    this.graphsService.createLeadData(this.leadsData, this.acceptedLeadData, this.companyId);
                    break;
                case 'shoot_menu':
                    this.graphsService.createShootData(this.shootsData, this.companyId);
                    break;
                case 'payment_menu':
                    this.graphsService.createPaymentsData(this.paymentsData, this.paymentsDueData, this.currency, this.companyId);
                    break;
                case 'revenue_menu':
                    this.graphsService.createRevenueData(this.revenueData, this.currency, this.companyId);
                    break;
                case 'lead_sources_menu':
                    if (this.leadSourceData) {
                        this.graphsService.clear();
                        this.pieGraphService.drawTabPieChart(this.leadSourceData, 'chart', {
                            legendRowLength: 6,
                            pattern: 'NAME'
                        });
                    } else {
                        graphs_service_1.GraphsService.removeLegend();
                    }
                    break;
                default:
                    break;
            }
        }
        // LOCAL STORAGE

    }, {
        key: "getActiveTabFromLocalStorage",
        value: function getActiveTabFromLocalStorage() {
            var localStorageItem = "dashboardActiveTab" + this.companyId;
            this.blockWidth = window.innerWidth;
            if (!localStorage.getItem(localStorageItem)) {
                localStorage.setItem(localStorageItem, 'lead_menu');
                this.activeTab = 'lead_menu';
            } else if (localStorage.getItem(localStorageItem) === 'lead_sources_menu' && this.blockWidth > 992) {
                localStorage.setItem(localStorageItem, 'revenue_menu');
                this.activeTab = 'revenue_menu';
            } else {
                this.activeTab = localStorage.getItem(localStorageItem);
            }
        }
    }, {
        key: "getDateRangeFromLocalStorage",
        value: function getDateRangeFromLocalStorage() {
            if (localStorage.getItem("presetDashboardDateRange" + this.companyId)) {
                this.dateRangePreset = localStorage.getItem("presetDashboardDateRange" + this.companyId);
                this.setDateRangePreset(this.dateRangePreset);
            } else if (localStorage.getItem("dashboardFromDate" + this.companyId) && localStorage.getItem("dashboardToDate" + this.companyId)) {
                this.fromDate = localStorage.getItem("dashboardFromDate" + this.companyId);
                this.toDate = localStorage.getItem("dashboardToDate" + this.companyId);
            } else {
                this.setRangeToLastDays(7);
                this.dateRangePreset = '7';
                localStorage.setItem("presetDashboardDateRange" + this.companyId, '7');
            }
        }
    }, {
        key: "getActiveJobTypeFromLocalStorage",
        value: function getActiveJobTypeFromLocalStorage() {
            this.selectedJobType = parseInt(localStorage.getItem("dashboardJobType" + this.companyId)) || -1;
        }
        // HELPERS

    }, {
        key: "getCurrencySymbol",
        value: function getCurrencySymbol() {
            var _this3 = this;

            this.accountService.userDataObservable.takeUntil(this.unsubscribe).subscribe(function (data) {
                if (data) {
                    _this3.currency = data.currency.symbol;
                }
            });
        }
    }, {
        key: "getCompanyId",
        value: function getCompanyId() {
            var _this4 = this;

            this.accountService.companyIdObservable.takeUntil(this.unsubscribe).subscribe(function (data) {
                _this4.companyId = data;
                _this4.getActiveTabFromLocalStorage();
                _this4.getDateRangeFromLocalStorage();
                _this4.getActiveJobTypeFromLocalStorage();
            });
        }
    }, {
        key: "setExtremeDates",
        value: function setExtremeDates() {
            var tenYearsForward = new Date();
            var tenYearsBackward = new Date();
            this.minDate = moment(tenYearsBackward.setFullYear(tenYearsBackward.getFullYear() - 10));
            this.maxDate = moment(tenYearsForward.setFullYear(tenYearsForward.getFullYear() + 10));
        }
    }, {
        key: "setDateRangesForRevenueComparison",
        value: function setDateRangesForRevenueComparison() {
            var thisYear = new Date().getFullYear();
            return {
                thisYear: {
                    fromDate: this.timeService.getDateString(new Date(thisYear, 0, 1)),
                    toDate: this.timeService.getDateString(new Date(thisYear, 11, 31)),
                    jobTypeId: this.selectedFilters.jobTypeId
                },
                lastYear: {
                    fromDate: this.timeService.getDateString(new Date(thisYear - 1, 0, 1)),
                    toDate: this.timeService.getDateString(new Date(thisYear - 1, 11, 31)),
                    jobTypeId: this.selectedFilters.jobTypeId
                },
                nextYear: {
                    fromDate: this.timeService.getDateString(new Date(thisYear + 1, 0, 1)),
                    toDate: this.timeService.getDateString(new Date(thisYear + 1, 11, 31)),
                    jobTypeId: this.selectedFilters.jobTypeId
                }
            };
        }
    }, {
        key: "configureCommunicationAdapter",
        value: function configureCommunicationAdapter() {
            window.snCommunicationAdapter.registerMethod('updateGraphsModel', this.applyFiltersToGraphsOn.bind(this));
        }
    }, {
        key: "getData",
        value: function getData() {
            this.setExtremeDates();
            this.getCurrencySymbol();
            this.getCompanyId();
            this.applyChosenJobType();
            this.applyChosenDateRange();
            this.applyFiltersToGraphsOn(['leads', 'shoots', 'payments', 'lead-source']);
        }
    }, {
        key: "subscribeToBrandsChange",
        value: function subscribeToBrandsChange() {
            var _this5 = this;

            this.brandsDataService.brandsChange.pipe(operators_1.takeUntil(this.unsubscribe), operators_1.filter(function (data) {
                return !!data;
            })).subscribe(function () {
                return _this5.getData();
            });
        }
    }, {
        key: "subscribeToSettingsChange",
        value: function subscribeToSettingsChange() {
            var _this6 = this;

            this.settingsService.timeFormatSettings.pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (settings) {
                return _this6.leadSourcesAvailable = settings.leadSourcesAvailable;
            });
        }
    }, {
        key: "subscribeToCustomizeLabelsChange",
        value: function subscribeToCustomizeLabelsChange() {
            var _this7 = this;

            this.settingsService.customizeLabelsObservable.pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (customizeLabels) {
                return _this7.shootsTabName = customizeLabels.shootsLabel;
            });
        }
    }, {
        key: "subscribeToLeadSourceUpdate",
        value: function subscribeToLeadSourceUpdate() {
            var _this8 = this;

            this.leadSourcesService.leadSourcesEventTrigger.pipe(operators_1.takeUntil(this.unsubscribe), operators_1.filter(function (state) {
                return state;
            })).subscribe(function () {
                return _this8.applyFiltersToGraphsOn(['lead-source']);
            });
        }
    }, {
        key: "onResize",
        value: function onResize(event) {
            this.reactToWidthChange(event.target.innerWidth);
        }
    }, {
        key: "reactToWidthChange",
        value: function reactToWidthChange(width) {
            this.blockWidth = width;
            if (width >= 992 && this.activeTab === 'lead_sources_menu') {
                this.onChangeActiveTab('revenue_menu');
                requestAnimationFrame(function () {
                    return pie_graph_service_1.PieGraphService.resizePieChart();
                });
            }
        }
    }]);

    return GraphsBlockComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Array)], GraphsBlockComponent.prototype, "jobTypes", void 0);
__decorate([core_1.HostListener('window:resize', ['$event']), __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", void 0)], GraphsBlockComponent.prototype, "onResize", null);
GraphsBlockComponent = __decorate([core_1.Component({
    selector: 'graphs-block',
    template: __webpack_require__("./web/modern/components/dashboard/graphs-block/graphs-block.html"),
    styles: [__webpack_require__("./web/modern/components/dashboard/graphs-block/graphs-block.scss")]
}), __metadata("design:paramtypes", [http_1.HttpClient, graphs_data_service_1.GraphsDataServiceProvider, time_service_1.TimeServiceProvider, graphs_service_1.GraphsService, pie_graph_service_1.PieGraphService, account_service_1.AccountServiceWebProvider, brands_data_service_1.BrandsDataServiceProvider, settings_1.SettingsProvider, message_service_1.MessageService, snModal_service_1.SNModalService, lead_sources_data_service_1.LeadSourcesDataService])], GraphsBlockComponent);
exports.GraphsBlockComponent = GraphsBlockComponent;

/***/ }),

/***/ "./web/modern/components/dashboard/graphs-block/graphs.data.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var http_1 = __webpack_require__("./node_modules/@angular/common/esm5/http.js");
var GraphsDataServiceProvider = function () {
    function GraphsDataServiceProvider(http) {
        _classCallCheck(this, GraphsDataServiceProvider);

        this.http = http;
    }

    _createClass(GraphsDataServiceProvider, [{
        key: "getLeadsGraphInfo",
        value: function getLeadsGraphInfo(dateRange) {
            var url = '/api/user/v1/lead/statistic/created';
            return this.http.post(url, dateRange);
        }
    }, {
        key: "getShootsGraphInfo",
        value: function getShootsGraphInfo(dateRange) {
            var url = '/api/user/v1/shoot/statistic/due';
            return this.http.post(url, dateRange);
        }
    }, {
        key: "getPaymentsGraphInfo",
        value: function getPaymentsGraphInfo(dateRange) {
            var url = '/api/user/v1/payment/amount/statistic/received';
            return this.http.post(url, dateRange);
        }
    }, {
        key: "getPaymentsDueGraphInfo",
        value: function getPaymentsDueGraphInfo(data, filter) {
            if (filter) {
                data.filterBy = filter;
            }
            var url = '/api/user/v1/payment/amount/statistic/due';
            return this.http.post(url, data);
        }
    }, {
        key: "getAcceptedLeadGraphInfo",
        value: function getAcceptedLeadGraphInfo(dateRange) {
            var url = '/api/user/v1/lead/statistic/accepted';
            return this.http.post(url, dateRange);
        }
    }, {
        key: "getAllTimeStatisticsGraphInfo",
        value: function getAllTimeStatisticsGraphInfo(filters) {
            var url = '/api/user/v1/payment/amount/statistic/all-time';
            return this.http.post(url, { jobTypeId: filters.jobTypeId });
        }
    }]);

    return GraphsDataServiceProvider;
}();
GraphsDataServiceProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [http_1.HttpClient])], GraphsDataServiceProvider);
exports.GraphsDataServiceProvider = GraphsDataServiceProvider;

/***/ }),

/***/ "./web/modern/components/dashboard/graphs-block/lead-sources-graph-section/lead-sources-graph-section.component.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"chart\">\n    <div class=\"chart-header\">\n        <h3 class=\"mt-0 mb-0\">Lead Sources</h3>\n    </div>\n    <div class=\"chart-pie-body\" *ngIf=\"chartData?.columns?.length\">\n        <lead-sources-graph [chartData]=\"chartData\" [customOptions]=\"pieOptions\"></lead-sources-graph>\n    </div>\n    <div *ngIf=\"chartData && !chartData.columns.length\" class=\"chart-pie-container-blank mt-35\">\n        There are no lead sources assigned to leads or jobs based on your search criteria.\n    </div>\n    <div *ngIf=\"!chartData\" class=\"chart-pie-container-blank mt-35\">\n        Loading...\n    </div>\n    <div *ngIf=\"chartData?.columns?.length\" class=\"chart-footer\">\n        <button class=\"btn btn-default btn-dashboard\" (click)=\"viewAll()\">Show All</button>\n    </div>\n</div>\n\n"

/***/ }),

/***/ "./web/modern/components/dashboard/graphs-block/lead-sources-graph-section/lead-sources-graph-section.component.scss":
/***/ (function(module, exports) {

module.exports = ".chart {\n  height: 366px;\n  width: 330px;\n  border: 1px solid #e1e1e1;\n  margin-left: 10px;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n      -ms-flex-direction: column;\n          flex-direction: column; }\n  .chart-header {\n    padding: 14px 16px 0 16px; }\n    .chart-header h3 {\n      font-size: 18px;\n      font-weight: 400; }\n    .chart-header p {\n      color: #949494;\n      font-size: 12px; }\n  .chart-pie-body {\n    height: 292px; }\n  .chart-pie-container-blank {\n    width: 260px;\n    height: 260px;\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n    -webkit-justify-content: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n    -webkit-align-items: center;\n        -ms-flex-align: center;\n            align-items: center;\n    text-align: center;\n    padding: 0 20px;\n    border-radius: 50%;\n    background-color: #f3f3f3;\n    color: #949494;\n    margin: 0 30px;\n    -webkit-align-self: center;\n        -ms-flex-item-align: center;\n            align-self: center; }\n  .chart-footer {\n    text-align: center; }\n"

/***/ }),

/***/ "./web/modern/components/dashboard/graphs-block/lead-sources-graph-section/lead-sources-graph-section.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var LeadSourcesGraphSectionComponent = function () {
    function LeadSourcesGraphSectionComponent() {
        _classCallCheck(this, LeadSourcesGraphSectionComponent);

        this.viewAllEmit = new core_1.EventEmitter();
    }

    _createClass(LeadSourcesGraphSectionComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.setChartOptions();
        }
    }, {
        key: "viewAll",
        value: function viewAll() {
            this.viewAllEmit.emit();
        }
    }, {
        key: "setChartOptions",
        value: function setChartOptions() {
            this.pieOptions = {
                legendRowLength: 3,
                pattern: 'NAME'
            };
        }
    }]);

    return LeadSourcesGraphSectionComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], LeadSourcesGraphSectionComponent.prototype, "chartData", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], LeadSourcesGraphSectionComponent.prototype, "viewAllEmit", void 0);
LeadSourcesGraphSectionComponent = __decorate([core_1.Component({
    selector: 'lead-sources-graph-section',
    template: __webpack_require__("./web/modern/components/dashboard/graphs-block/lead-sources-graph-section/lead-sources-graph-section.component.html"),
    styles: [__webpack_require__("./web/modern/components/dashboard/graphs-block/lead-sources-graph-section/lead-sources-graph-section.component.scss")]
}), __metadata("design:paramtypes", [])], LeadSourcesGraphSectionComponent);
exports.LeadSourcesGraphSectionComponent = LeadSourcesGraphSectionComponent;

/***/ }),

/***/ "./web/modern/components/dashboard/graphs-block/lead-sources-graph/lead-sources-graph.component.html":
/***/ (function(module, exports) {

module.exports = "<div [id]=\"chartID\"></div>\n"

/***/ }),

/***/ "./web/modern/components/dashboard/graphs-block/lead-sources-graph/lead-sources-graph.component.scss":
/***/ (function(module, exports) {

module.exports = ""

/***/ }),

/***/ "./web/modern/components/dashboard/graphs-block/lead-sources-graph/lead-sources-graph.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var pie_graph_service_1 = __webpack_require__("./web/modern/services/graph/pie-graph.service.ts");
var LeadSourcesGraphComponent = function () {
    function LeadSourcesGraphComponent(graphService) {
        _classCallCheck(this, LeadSourcesGraphComponent);

        this.graphService = graphService;
        this.chartID = 'pie-chart';
    }

    _createClass(LeadSourcesGraphComponent, [{
        key: "ngAfterViewInit",
        value: function ngAfterViewInit() {
            this.graphService.drawPieChart(this.chartData, this.chartID, this.customOptions);
        }
    }, {
        key: "ngOnChanges",
        value: function ngOnChanges(changes) {
            if (changes.chartData && !changes.chartData.isFirstChange() && changes.chartData.currentValue) {
                this.graphService.drawPieChart(this.chartData, this.chartID, this.customOptions);
            }
        }
    }]);

    return LeadSourcesGraphComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], LeadSourcesGraphComponent.prototype, "chartData", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], LeadSourcesGraphComponent.prototype, "chartID", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], LeadSourcesGraphComponent.prototype, "customOptions", void 0);
LeadSourcesGraphComponent = __decorate([core_1.Component({
    selector: 'lead-sources-graph',
    template: __webpack_require__("./web/modern/components/dashboard/graphs-block/lead-sources-graph/lead-sources-graph.component.html"),
    styles: [__webpack_require__("./web/modern/components/dashboard/graphs-block/lead-sources-graph/lead-sources-graph.component.scss")]
}), __metadata("design:paramtypes", [pie_graph_service_1.PieGraphService])], LeadSourcesGraphComponent);
exports.LeadSourcesGraphComponent = LeadSourcesGraphComponent;

/***/ }),

/***/ "./web/modern/components/dashboard/job-task-block/job-task-block.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"stats__panel\">\n    <h2>\n        <span class=\"text-reducer\">Job Tasks with Due Dates</span>\n    </h2>\n    <div class=\"stats__panel__content\">\n        <div class=\"stats__placeholder\"\n             *ngIf=\"jobs.length === 0\"\n        >\n            <span>You have no jobs yet. Get off your butt!</span>\n        </div>\n        <div *ngIf=\"jobs.length !== 0\"\n             class=\"table-responsive\"\n             id=\"jobTaskwithDueDates\">\n            <table class=\"table table-job-task table-dashboard table-hover table-with-links\">\n                <thead class=\"invoice-thead\">\n                    <tr class=\"bottom-bordered\">\n                        <th>\n                            <b (click)=\"isFilterAllowed('nexTaskDueDate') && orderByField('nexTaskDueDate')\" class=\"pointer\">\n                                Task Due\n                                <span class=\"fa\"\n                                      [ngClass]=\"pageRequest.sortCriterias[0].sortAscending ? 'fa-caret-up' : 'fa-caret-down'\"\n                                      *ngIf=\"pageRequest.sortCriterias[0].fieldName === 'nexTaskDueDate' && isFilterAllowed('nexTaskDueDate')\"></span>\n                            </b>\n                        </th>\n                        <th>\n                            <b (click)=\"isFilterAllowed('name') && orderByField('name')\" class=\"pointer\">\n                                Job\n                                <span class=\"fa\"\n                                      [ngClass]=\"pageRequest.sortCriterias[0].sortAscending ? 'fa-caret-up' : 'fa-caret-down'\"\n                                      *ngIf=\"pageRequest.sortCriterias[0].fieldName === 'name' && isFilterAllowed('name')\"></span>\n                            </b>\n                        </th>\n                        <th>Next Task</th>\n                        <th></th>\n                    </tr>\n                </thead>\n                <tbody>\n                <tr class=\"bottom-bordered pointer\"\n                    *ngFor=\"let job of jobs | orderBy; let i = index\"\n                    [ngClass]=\"{'lastTableRow':false}\">\n                    <td>\n                        <a class=\"table-link\" href=\"jobs/view/{{job.id}}\"></a>\n                        <span *ngIf=\"job.workflow.nextTask.dueDate\">{{ job.workflow.nextTask.dueDate| timeFilter: 'medium' }}</span>\n                        <span class=\"text-nowrap\" [ngClass]=\"job.workflow.nextTask.late ? 'red': 'gray-label'\">({{ job.workflow.nextTask.nextTaskDueDays }})</span>\n                    </td>\n                    <td>\n                      <a class=\"table-link\" href=\"jobs/view/{{job.id}}\"></a>\n                        <div class=\"flex-box\">\n                            <i class=\"jt-big jt-{{job.type.colour | lowercase}}\"></i>\n                            <span class=\"text-overflow\">{{ job.name }}</span>\n                        </div>\n                    </td>\n                    <td>\n                      <a class=\"table-link\" href=\"jobs/view/{{job.id}}\"></a>\n                        <div class=\"flex-box\">\n                            <span class=\"text-overflow\" [title]=\"job.workflow.nextTask.name\">{{ job.workflow.nextTask.name }}</span>\n                            <span class=\"ml-4\" [ngClass]=\"{'overdue-job': job.workflow.nextTask.late}\"></span>\n                        </div>\n                    </td>\n                    <td class=\"text-nowrap text-right pointer\">\n                        <div class=\"dropup\" dropdown container=\"body\">\n                            <div class=\"dropdown-toggle menu-dots\"\n                                 dropdownToggle\n                                 id=\"dotsMenu-JTB-{{i}}\"\n                                 aria-controls=\"dropdown-container\">\n                                <div class=\"dots\"></div>\n                                <div class=\"dots\"></div>\n                                <div class=\"dots\"></div>\n                            </div>\n                            <ul class=\"dropdown-menu dropdown-menu-right dropdown-menu-jobs dropdown-menu-JTB-{{i}}\"\n                                *dropdownMenu\n                                role=\"menu\"\n                                aria-labelledby=\"button-container\"\n                                id=\"menuId-JTB-{{i}}\">\n                                <li (click)=\"showJob(job.id)\"><a href=\"/jobs/view/{{job.id}}\"><i class=\"fi fi-view color-icon\"></i>View job</a></li>\n                                <li class=\"divider\"></li>\n                                <li (click)=\"showEditJobModal(i)\"><a href=\"#\"> <i class=\"fi fi-edit pr-0 color-icon\"></i>Edit Job</a></li>\n                            </ul>\n                        </div>\n                    </td>\n                </tr>\n                </tbody>\n            </table>\n        </div>\n\n        <simple-pagination *ngIf=\"jobs.length !== 0\" [pageRequest]=\"pageRequest\"\n                           [totalItems]=\"itemsQuantity\"\n                           [totalPages]=\"pagesQuantity\"\n                           (changePageTrigger)=\"updateJobsData($event)\"></simple-pagination>\n\n    </div>\n</div>\n"

/***/ }),

/***/ "./web/modern/components/dashboard/job-task-block/job-task-block.scss":
/***/ (function(module, exports) {

module.exports = ":host {\n  width: 100%;\n  padding-top: 10px; }\n"

/***/ }),

/***/ "./web/modern/components/dashboard/job-task-block/job-task-block.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var jobs_data_service_1 = __webpack_require__("./shared/services/job/jobs.data.service.ts");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var time_service_1 = __webpack_require__("./shared/services/helpers/time-service/time.service.ts");
var common_1 = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
var rxjs_1 = __webpack_require__("./node_modules/rxjs/Rx.js");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var brands_data_service_1 = __webpack_require__("./shared/services/brands/brands.data.service.ts");
var JobTaskBlockComponent = function () {
    function JobTaskBlockComponent(jobsDataService, messageService, timeService, brandsDataService, location) {
        _classCallCheck(this, JobTaskBlockComponent);

        this.jobsDataService = jobsDataService;
        this.messageService = messageService;
        this.timeService = timeService;
        this.brandsDataService = brandsDataService;
        this.location = location;
        this.editJobModalTrigger = new core_1.EventEmitter();
        this.unsubscribe = new rxjs_1.Subject();
        this.jobs = [];
        this.PAGE_REQUEST_DEFAULT = {
            filterBy: 'active_with_next_task_due',
            paging: {
                pageNumber: 0,
                pageSize: 10
            },
            sortCriterias: [{
                fieldName: 'nexTaskDueDate',
                sortAscending: true
            }]
        };
    }

    _createClass(JobTaskBlockComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.configureCommunicationAdapter();
            this.subscribeToBrandsChange();
            this.pageRequest = this.PAGE_REQUEST_DEFAULT;
            this.getJobsData();
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "isFilterAllowed",
        value: function isFilterAllowed(filter) {
            if (!this.allowedFilters) {
                return false;
            }
            return this.allowedFilters.includes(filter);
        }
    }, {
        key: "orderByField",
        value: function orderByField(filter) {
            if (this.pageRequest.sortCriterias[0].fieldName === filter) {
                this.pageRequest.sortCriterias[0].sortAscending = !this.pageRequest.sortCriterias[0].sortAscending;
            } else {
                this.pageRequest.sortCriterias[0].fieldName = filter;
                this.pageRequest.sortCriterias[0].sortAscending = false;
            }
            this.pageRequest.paging.pageNumber = 0;
            this.getJobsData();
        }
    }, {
        key: "showJob",
        value: function showJob(jobId) {
            this.location.go("jobs/view/" + jobId);
        }
    }, {
        key: "showEditJobModal",
        value: function showEditJobModal(index) {
            this.editJobModalTrigger.emit(this.jobs[index]);
        }
    }, {
        key: "paginationToDefaults",
        value: function paginationToDefaults() {
            this.pageRequest = this.PAGE_REQUEST_DEFAULT;
            delete this.pageRequest.paging.searchToken;
            this.getJobsData();
        }
    }, {
        key: "updateModel",
        value: function updateModel(resetPagination) {
            if (resetPagination) {
                this.paginationToDefaults();
            } else {
                this.getJobsData();
            }
        }
    }, {
        key: "updateShootsModel",
        value: function updateShootsModel(resetPagination) {
            window.snCommunicationAdapter.callMethod('updateShootsModel', resetPagination);
        }
    }, {
        key: "updatePaymentsModel",
        value: function updatePaymentsModel(resetPagination) {
            window.snCommunicationAdapter.callMethod('updateUpcomingPaymentsModel', resetPagination);
        }
    }, {
        key: "updateJobsData",
        value: function updateJobsData(pageRequest) {
            this.pageRequest = pageRequest;
            this.getJobsData();
        }
    }, {
        key: "getJobsData",
        value: function getJobsData() {
            var _this = this;

            this.jobsDataService.getJobOnDashboard(this.pageRequest).subscribe(function (data) {
                return _this.successGetDataJobs(data);
            }, function (error) {
                return _this.messageService.showDefaultErrorMessage(error);
            });
        }
    }, {
        key: "successGetDataJobs",
        value: function successGetDataJobs(data) {
            this.pageRequest.paging.searchToken = data.searchToken;
            this.jobs = this.handleJobTask(JSON.parse(JSON.stringify(data.items)));
            this.itemsQuantity = data ? data.totalSize : 0;
            this.pagesQuantity = Math.ceil(this.itemsQuantity / this.pageRequest.paging.pageSize);
            this.allowedFilters = data.sortingFields;
        }
    }, {
        key: "handleJobTask",
        value: function handleJobTask(jobs) {
            var _this2 = this;

            jobs.forEach(function (job) {
                job.workflow.nextTask.late = false;
                var dayMulti = _this2.addDayMulti(job.workflow.nextTask.overdueDays);
                if (job.workflow.nextTask.overdueDays === 0) {
                    job.workflow.nextTask.nextTaskDueDays = 'today';
                } else if (job.workflow.nextTask.overdueDays > 0) {
                    job.workflow.nextTask.nextTaskDueDays = job.workflow.nextTask.overdueDays + dayMulti + " ago";
                    job.workflow.nextTask.late = true;
                } else {
                    job.workflow.nextTask.nextTaskDueDays = "in " + -job.workflow.nextTask.overdueDays + dayMulti;
                }
            });
            return jobs;
        }
    }, {
        key: "addDayMulti",
        value: function addDayMulti(day) {
            var dayMulti = void 0;
            if (day === 1 || day === -1) {
                dayMulti = ' day';
            } else {
                dayMulti = ' days';
            }
            return dayMulti;
        }
    }, {
        key: "calcDate",
        value: function calcDate(date1, date2) {
            var diff = Math.floor(date1.getTime() - date2.getTime());
            var day = 1000 * 60 * 60 * 24;
            var days = Math.floor(diff / day);
            return days;
        }
    }, {
        key: "configureCommunicationAdapter",
        value: function configureCommunicationAdapter() {
            window.snCommunicationAdapter.registerMethod('updateJobTasksModel', this.updateModel.bind(this));
        }
    }, {
        key: "subscribeToBrandsChange",
        value: function subscribeToBrandsChange() {
            var _this3 = this;

            this.brandsDataService.brandsChange.pipe(operators_1.takeUntil(this.unsubscribe), operators_1.filter(function (data) {
                return !!data;
            })).subscribe(function () {
                return _this3.getJobsData();
            });
        }
    }]);

    return JobTaskBlockComponent;
}();
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], JobTaskBlockComponent.prototype, "editJobModalTrigger", void 0);
JobTaskBlockComponent = __decorate([core_1.Component({
    selector: 'job-task-block',
    template: __webpack_require__("./web/modern/components/dashboard/job-task-block/job-task-block.html"),
    styles: [__webpack_require__("./web/modern/components/dashboard/job-task-block/job-task-block.scss")]
}), __metadata("design:paramtypes", [jobs_data_service_1.JobsDataServiceProvider, message_service_1.MessageService, time_service_1.TimeServiceProvider, brands_data_service_1.BrandsDataServiceProvider, common_1.Location])], JobTaskBlockComponent);
exports.JobTaskBlockComponent = JobTaskBlockComponent;

/***/ }),

/***/ "./web/modern/components/dashboard/modals/view-all-lead-sources/view-all-lead-sources-modal.html":
/***/ (function(module, exports) {

module.exports = "<ng-container *ngIf=\"leadSourceTableData\">\n\n<div class=\"modal-header\">\n    <button class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" (click)=\"onDismiss()\">&times;</button>\n    <h3 class=\"modal-title f-w-n\">Show All Lead Sources</h3>\n</div>\n<div class=\"modal-body p-20\">\n    <div class=\"flex-box flex-align-center flex-just-space-between filter-responsive\">\n        <div class=\"flex-box filter-responsive-block\">\n            <div class=\"select-style main-input-item job-types-filter mb-0 mr-10\">\n                <select id=\"job-type-modal\" [ngModel]=\"selectedJobType\" (ngModelChange)=\"onJobTypeChange($event)\" name=\"jobTypeSelectModal\">\n                    <option [attr.selected]=\"selectedJobType === -1 ? 'selected' : null\" [value]=\"-1\">All Job Types</option>\n                    <option [attr.selected]=\"selectedJobType === jobType.id ? 'selected' : null\" [value]=\"jobType.id\" *ngFor=\"let jobType of jobTypes\">{{ jobType.name }}</option>\n                </select>\n            </div>\n            <div class=\"daterangepicker-style main-input-item form-group has-feedback has-feedback-left mb-0\">\n                <input type=\"text\"\n                       name=\"daterange\"\n                       [(ngModel)]=\"selectedRange\"\n                       (ngModelChange)=\"setCustomDateRange($event)\"\n                       snDateRange [opens]=\"'bottom'\"\n                       [showCancel]=\"false\"\n                       [minDate]=\"minDate\"\n                       [maxDate]=\"maxDate\"\n                       class=\"form-control\"\n                       onkeypress=\"return false;\"\n                       onpaste=\"return false;\" />\n                <span class=\"form-control-feedback sn-daterangeicon\"></span>\n            </div>\n        </div>\n        <div class=\"filter-export-button btn-duo\">\n            <button class=\"btn btn-default btn-md btn-short mb-0\"\n                    [disabled]=\"btnDisable\"\n                    spinning-wheel [is-spinning-wheel-active]=\"xlsSpinner\" [is-spinning-wheel-dark]=\"'true'\" (click)=\"exportLeadSourceData('xls')\">\n                <i class=\"fi fi-export\"></i>\n                Export to XLS\n            </button>\n            <button class=\"btn btn-default btn-md btn-short mb-0\"\n                    [disabled]=\"btnDisable\"\n                    spinning-wheel [is-spinning-wheel-active]=\"csvSpinner\" [is-spinning-wheel-dark]=\"'true'\" (click)=\"exportLeadSourceData('csv')\">\n                CSV\n            </button>\n        </div>\n        <div class=\"filter-export-button-responsive\">\n            <button class=\"btn btn-default btn-md btn-short mb-0\"\n                    [disabled]=\"btnDisable\"\n                    spinning-wheel [is-spinning-wheel-active]=\"xlsSpinner\" [is-spinning-wheel-dark]=\"'true'\" (click)=\"exportLeadSourceData('xls')\">\n                <i class=\"fi fi-export\"></i>\n                Export to XLS\n            </button>\n            <button class=\"btn btn-default btn-md btn-short mb-0\"\n                    [disabled]=\"btnDisable\"\n                    spinning-wheel [is-spinning-wheel-active]=\"csvSpinner\" [is-spinning-wheel-dark]=\"'true'\" (click)=\"exportLeadSourceData('csv')\">\n                <i class=\"fi fi-export\"></i>\n                Export to CSV\n            </button>\n        </div>\n    </div>\n\n    <div *ngIf=\"leadSourceTableData?.length\" class=\"table-responsive mt-20\">\n        <table class=\"table table-hover table-clients-overview mb-0\">\n            <thead>\n                <tr class=\"invoice-thead\">\n                    <th *ngFor=\"let headerItem of tableHeader\">\n                        <b (click)=\"orderByField(headerItem.sortingCriteria)\"  [class.pointer]=\"headerItem.isSortable\">\n                            {{ headerItem.text }}\n                            <span [style.visibility]=\"sortField === headerItem.sortingCriteria ? 'visible': 'hidden'\"\n                                  [ngClass]=\"sortAscending ? 'fa-caret-up' : 'fa-caret-down'\"\n                                  class=\"fa\"\n                            >\n                            </span>\n                        </b>\n                    </th>\n                </tr>\n            </thead>\n            <tbody>\n                <tr *ngFor=\"let leadSource of leadSourceTableData | tableSort:sortAscending: sortField\" height=\"49px\">\n                    <td>{{ leadSource.status | titlecase }}</td>\n                    <td>\n                        <div class=\"flex-box\">\n                            <lead-source-color class=\"flex-box flex-align-center\" [color]=\"leadSource.colour.hex\"></lead-source-color>\n                            <span class=\"ml-10\">{{ leadSource.name }}</span>\n                        </div>\n                    </td>\n                    <td>{{ leadSource.leadsCount }}</td>\n                    <td>{{ leadSource.jobsCount }}</td>\n                    <td>{{ leadSource.count }} ({{ leadSource.proportionNumber }}%)</td>\n                    <td>{{ leadSource.conversationRateNumber }}%</td>\n                </tr>\n            </tbody>\n        </table>\n    </div>\n    <div class=\"stats__placeholder\" *ngIf=\"leadSourceTableData && !leadSourceTableData.length\">\n        <span>There are no lead sources assigned to leads or jobs based on your search criteria.</span>\n    </div>\n</div>\n</ng-container>\n"

/***/ }),

/***/ "./web/modern/components/dashboard/modals/view-all-lead-sources/view-all-lead-sources-modal.scss":
/***/ (function(module, exports) {

module.exports = ".filter-responsive-block {\n  margin-right: 20px;\n  width: 100%; }\n\n.filter-responsive .filter-export-button {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex; }\n  .filter-responsive .filter-export-button-responsive {\n    display: none; }\n\n@media screen and (max-width: 950px) {\n  .filter-responsive {\n    -webkit-box-pack: justify;\n    -webkit-justify-content: space-between;\n        -ms-flex-pack: justify;\n            justify-content: space-between; }\n    .filter-responsive .filter-responsive-block {\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n      -webkit-flex-direction: column;\n          -ms-flex-direction: column;\n              flex-direction: column; }\n      .filter-responsive .filter-responsive-block .daterangepicker-style {\n        margin-top: 10px;\n        max-width: 100%; }\n      .filter-responsive .filter-responsive-block .select-style {\n        max-width: 100%;\n        margin-right: 0 !important; }\n    .filter-responsive .filter-export-button {\n      display: none; }\n      .filter-responsive .filter-export-button-responsive {\n        display: -webkit-box;\n        display: -webkit-flex;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-orient: vertical;\n        -webkit-box-direction: normal;\n        -webkit-flex-direction: column;\n            -ms-flex-direction: column;\n                flex-direction: column; }\n        .filter-responsive .filter-export-button-responsive .btn:last-child {\n          margin-top: 10px; } }\n\n@media screen and (max-width: 575px) {\n  .filter-responsive {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: column;\n        -ms-flex-direction: column;\n            flex-direction: column; }\n    .filter-responsive-block {\n      margin-right: 0; }\n    .filter-responsive .filter-export-button-responsive {\n      width: 100%; }\n      .filter-responsive .filter-export-button-responsive .btn:first-child {\n        margin-top: 10px; } }\n\n.invoice-thead th {\n  white-space: nowrap; }\n"

/***/ }),

/***/ "./web/modern/components/dashboard/modals/view-all-lead-sources/view-all-lead-sources-modal.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var ng_bootstrap_1 = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/index.js");
var lead_sources_data_service_1 = __webpack_require__("./shared/services/lead-sources/lead-sources.data.service.ts");
var time_service_1 = __webpack_require__("./shared/services/helpers/time-service/time.service.ts");
var rxjs_1 = __webpack_require__("./node_modules/rxjs/Rx.js");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var moment = __webpack_require__("./node_modules/moment/moment.js");
var ViewAllLeadSourcesModalComponent = function () {
    function ViewAllLeadSourcesModalComponent(activeModal, timeService, leadSourcesService, messageService) {
        _classCallCheck(this, ViewAllLeadSourcesModalComponent);

        this.activeModal = activeModal;
        this.timeService = timeService;
        this.leadSourcesService = leadSourcesService;
        this.messageService = messageService;
        this.sortAscending = false;
        this.tableHeader = [{ text: 'Status', isSortable: true, sortingCriteria: 'status' }, { text: 'Lead Source', isSortable: true, sortingCriteria: 'name' }, { text: 'Leads', isSortable: true, sortingCriteria: 'leadsCount' }, { text: 'Jobs', isSortable: true, sortingCriteria: 'jobsCount' }, { text: 'Total (%)', isSortable: true, sortingCriteria: 'count' }, {
            text: 'Conversion',
            isSortable: true,
            sortingCriteria: 'conversationRateNumber'
        }];
        this.unsubscribe = new rxjs_1.Subject();
    }

    _createClass(ViewAllLeadSourcesModalComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.gatherInitialData();
            this.loadLeadSourceUsageStatistic();
        }
    }, {
        key: "onDismiss",
        value: function onDismiss() {
            this.activeModal.dismiss();
        }
    }, {
        key: "exportLeadSourceData",
        value: function exportLeadSourceData(type) {
            var _this = this;

            this.btnDisable = true;
            this[type + "Spinner"] = true;
            this.leadSourcesService.exportLeadSourceData(this.modalFilters, type, this.generateFileName()).pipe(operators_1.takeUntil(this.unsubscribe), operators_1.finalize(function () {
                _this.btnDisable = false;
                _this[type + "Spinner"] = false;
            })).subscribe(function () {
                return _this.messageService.showToaster('s_5', 'leadSources');
            }, function (_ref) {
                var error = _ref.error;
                var errorTitle = error.errorTitle,
                    errorMessage = error.errorMessage;

                _this.messageService.showErrorFromBackend(errorTitle, errorMessage);
            });
        }
    }, {
        key: "orderByField",
        value: function orderByField(sortingField) {
            if (this.sortField === sortingField) {
                this.sortAscending = !this.sortAscending;
            } else {
                this.sortField = sortingField;
                this.sortAscending = false;
            }
        }
    }, {
        key: "onJobTypeChange",
        value: function onJobTypeChange(newJobType) {
            this.selectedJobType = parseInt(newJobType);
            this.applyChosenJobType();
            this.loadLeadSourceUsageStatistic();
        }
    }, {
        key: "setCustomDateRange",
        value: function setCustomDateRange(newDateRange) {
            if (moment.isMoment(newDateRange.startDate)) {
                var fromDate = this.timeService.getDateString(newDateRange.startDate.toDate());
                var toDate = this.timeService.getDateString(newDateRange.endDate.toDate());
                this.applyChosenDateRange(fromDate, toDate);
                this.loadLeadSourceUsageStatistic();
            }
        }
    }, {
        key: "applyChosenDateRange",
        value: function applyChosenDateRange(fromDate, toDate) {
            this.selectedRange = {
                startDate: new Date(fromDate).toISOString(),
                endDate: new Date(toDate).toISOString()
            };
            this.modalFilters.fromDate = this.selectedRange.startDate.slice(0, 10);
            this.modalFilters.toDate = this.selectedRange.endDate.slice(0, 10);
        }
    }, {
        key: "applyChosenJobType",
        value: function applyChosenJobType() {
            if (this.selectedJobType === -1) {
                this.modalFilters.jobTypeId = null;
            } else {
                this.modalFilters.jobTypeId = this.selectedJobType;
            }
        }
    }, {
        key: "loadLeadSourceUsageStatistic",
        value: function loadLeadSourceUsageStatistic() {
            var _this2 = this;

            this.leadSourcesService.getAllLeadSourcesStatisticData(this.modalFilters).pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (_ref2) {
                var data = _ref2.data;

                _this2.setDefaultSortParameters();
                _this2.leadSourceTableData = data;
            }, function (_ref3) {
                var err = _ref3.err;
                var errorMessage = err.errorMessage,
                    errorTitle = err.errorTitle;

                _this2.messageService.showErrorFromBackend(errorTitle, errorMessage);
                _this2.onDismiss();
            });
        }
    }, {
        key: "gatherInitialData",
        value: function gatherInitialData() {
            this.setDefaultSortParameters();
            this.jobTypes = this.modalPayload.jobTypes;
            this.modalFilters = JSON.parse(JSON.stringify(this.modalPayload.selectedFilters));
            this.selectedJobType = !this.modalFilters.jobTypeId ? -1 : this.modalFilters.jobTypeId;
            this.minDate = this.modalPayload.minDate;
            this.maxDate = this.modalPayload.maxDate;
            this.selectedRange = this.modalPayload.selectedRange;
        }
    }, {
        key: "setDefaultSortParameters",
        value: function setDefaultSortParameters() {
            this.sortField = 'proportionNumber';
            this.sortAscending = false;
        }
    }, {
        key: "generateFileName",
        value: function generateFileName() {
            var startDate = moment(this.modalFilters.fromDate, 'YYYY-MM-DD').format('DD-MMM-YYYY');
            var toDate = moment(this.modalFilters.toDate, 'YYYY-MM-DD').format('DD-MMM-YYYY');
            return "Lead Sources Export " + startDate + " - " + toDate;
        }
    }]);

    return ViewAllLeadSourcesModalComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], ViewAllLeadSourcesModalComponent.prototype, "modalPayload", void 0);
ViewAllLeadSourcesModalComponent = __decorate([core_1.Component({
    selector: 'view-all-lead-sources',
    template: __webpack_require__("./web/modern/components/dashboard/modals/view-all-lead-sources/view-all-lead-sources-modal.html"),
    styles: [__webpack_require__("./web/modern/components/dashboard/modals/view-all-lead-sources/view-all-lead-sources-modal.scss")]
}), __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal, time_service_1.TimeServiceProvider, lead_sources_data_service_1.LeadSourcesDataService, message_service_1.MessageService])], ViewAllLeadSourcesModalComponent);
exports.ViewAllLeadSourcesModalComponent = ViewAllLeadSourcesModalComponent;

/***/ }),

/***/ "./web/modern/components/dashboard/recent-leads-block/recent-leads-block.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"stats__panel\">\n    <h2>\n        <span class=\"text-reducer\">Most Recent Leads</span>\n    </h2>\n    <add-round-btn class=\"header-btn\" [isActive]=\"spinningWheelActive\" (click)=\"addNew()\"></add-round-btn>\n    <div class=\"stats__panel__content\">\n        <div *ngIf=\"leads.length === 0\" class=\"stats__placeholder\">\n            <span>You have no leads yet. Start hustling!</span>\n        </div>\n        <div *ngIf=\"leads.length !== 0\"\n             class=\"table-responsive\"\n             id=\"recentLeadsTable\">\n            <table class=\"table table-dashboard table-recent-leads table-hover table-with-links\">\n                <thead class=\"invoice-thead\">\n                <tr class=\"bottom-bordered\">\n                    <th>\n                        <b (click)=\"isFilterAllowed('createdAt') && orderByField('createdAt')\" class=\"pointer\">\n                        Lead Created\n                        <span class=\"fa\"\n                              [ngClass]=\"pageRequest.sortCriteria.sortAscending ? 'fa-caret-up' : 'fa-caret-down'\"\n                              *ngIf=\"pageRequest.sortCriteria.fieldName === 'createdAt' && isFilterAllowed('createdAt')\"></span>\n                        </b>\n                    </th>\n                    <th>\n                        <b (click)=\"isFilterAllowed('name') && orderByField('name')\" class=\"pointer\">\n                            Lead\n                            <span class=\"fa\"\n                                  [ngClass]=\"pageRequest.sortCriteria.sortAscending ? 'fa-caret-up' : 'fa-caret-down'\"\n                                  *ngIf=\"pageRequest.sortCriteria.fieldName === 'name' && isFilterAllowed('name')\"></span>\n                        </b>\n                    </th>\n                    <th>\n                        Mail Status\n                    </th>\n                    <th>\n                        <b (click)=\"isFilterAllowed('nextTask') && orderByField('nextTask')\" class=\"pointer\">\n                            Next Task\n                            <span class=\"fa\"\n                                  [ngClass]=\"pageRequest.sortCriteria.sortAscending ? 'fa-caret-up' : 'fa-caret-down'\"\n                                  *ngIf=\"pageRequest.sortCriteria.fieldName === 'nextTask' && isFilterAllowed('nextTask')\"></span>\n                        </b>\n                    </th>\n                    <th></th>\n                </tr>\n                </thead>\n                <tbody>\n                <tr class=\"bottom-bordered pointer\"\n                    *ngFor=\"let lead of leads | orderBy; let i = index\">\n                    <td>\n                        <a class=\"table-link\" href=\"leads/view/{{lead.id}}\"></a>\n                        {{ lead.createdAt | timeFilter: 'medium' }}\n                    </td>\n                    <td class=\"text-nowrap\">\n                        <a class=\"table-link\" href=\"leads/view/{{lead.id}}\"></a>\n                        <div style=\"display: flex\">\n                            <span [title]=\"lead.name\">{{ lead.name }}</span>\n                            <span *ngIf=\"lead.doubleBooking\" class=\"square-content-job\">\n                                <double-booking [doubleBooking]=\"lead.doubleBooking\"></double-booking>\n                            </span>\n                        </div>\n                    </td>\n                    <td>\n                        <a class=\"table-link\" href=\"leads/view/{{lead.id}}\"></a>\n                        <div *ngIf=\"lead.status==='SENT_ON'\">\n                            <span class=\"label label-orange-email\">EMAIL SENT ON {{ lead.statusOnDate | timeFilter: 'medium'| uppercase }}</span>\n                        </div>\n                        <div *ngIf=\"lead.status==='REPLY_RECEIVED_ON'\">\n                            <span class=\"label label-grey\">REPLY RECEIVED ON {{ lead.statusOnDate | timeFilter: 'medium'| uppercase }}</span>\n                        </div>\n                        <div *ngIf=\"lead.status==='CLICKED_ON'\">\n                            <span class=\"label label-primary\">LINK CLICKED ON {{ lead.statusOnDate | timeFilter: 'medium'| uppercase }}</span>\n                        </div>\n                        <div *ngIf=\"lead.status==='OPENED_ON'\">\n                            <span class=\"label label-info\">EMAIL OPENED ON {{ lead.statusOnDate | timeFilter: 'medium'| uppercase }}</span>\n                        </div>\n                        <div *ngIf=\"lead.status==='NEW_LEAD' && !lead.name.toLowerCase().includes('enquiry')\">\n                            <span class=\"label label-green-leads\">NEW LEAD</span>\n                        </div>\n                        <div *ngIf=\"lead.status==='NEW_LEAD' && lead.name.toLowerCase().includes('enquiry')\">\n                            <span class=\"label label-green-leads\">NEW ENQUIRY</span>\n                        </div>\n                    </td>\n                    <td class=\"text-nowrap\">\n                        <a class=\"table-link\" href=\"leads/view/{{lead.id}}\"></a>\n                        <div style=\"display: flex\">\n                            <span class=\"mr-7\" [title]=\"lead.nextTask\">{{ lead.nextTask }}</span>\n                            <span *ngIf=\"!lead.archived && lead.nextTaskOverdue\" class=\"overdue-job\"></span>\n                        </div>\n                    </td>\n                    <td class=\"text-nowrap text-right pointer\">\n                        <div class=\"dropup\" dropdown container=\"body\">\n                            <div class=\"dropdown-toggle menu-dots\"\n                                 dropdownToggle\n                                 aria-controls=\"dropdown-container\"\n                                 id=\"dotsMenu-{{i}}\">\n                                <div class=\"dots\"></div>\n                                <div class=\"dots\"></div>\n                                <div class=\"dots\"></div>\n                            </div>\n                            <ul class=\"dropdown-menu dropdown-menu-right dropdown-menu-{{i}}\"\n                                role=\"menu\"\n                                *dropdownMenu\n                                aria-labelledby=\"dropdown-container\"\n                                id=\"menuId-{{i}}\">\n                                <li (click)=\"showLead(lead.id)\"><a href=\"/leads/view/{{lead.id}}\"><i class=\"fi fi-view color-icon\"></i>View Lead</a></li>\n                                <li class=\"divider\"></li>\n                                <li *ngIf=\"!lead.archived\" (click)=\"showSendEmailModal(lead.id, lead.primaryContact, lead.secondaryContact)\"><a href=\"#\"><i class=\"fi fi-send color-icon\"></i>Send Email</a></li>\n                                <li class=\"divider\" *ngIf=\"!lead.archived\"></li>\n                                <li (click)=\"showEditLeadModal(i)\"><a href=\"#\"> <i class=\"fi fi-edit pr-0 color-icon\"></i>Edit Lead</a></li>\n                                <li class=\"divider\"></li>\n                                <li *ngIf=\"!lead.archived\" (click)=\"archiveLead(lead.id)\"><a href=\"#\"><i class=\"fi fi-archive color-icon\"></i>Archive Lead</a></li>\n                                <li class=\"divider\"></li>\n                                <li (click)=\"showDeleteModal(lead.id)\"><a href=\"#\"><i class=\"fa fa-trash-o color-icon\"></i>Delete Lead</a></li>\n                            </ul>\n                        </div>\n                    </td>\n                </tr>\n                </tbody>\n            </table>\n        </div>\n        <simple-pagination *ngIf=\"leads.length !== 0\" [pageRequest]=\"pageRequest\"\n                           [totalItems]=\"itemsQuantity\"\n                           [totalPages]=\"pagesQuantity\"\n                           (changePageTrigger)=\"updateData($event)\"></simple-pagination>\n        <delete-lead-modal [leadForDelete]=\"leadForDelete\"\n                           (updateParentTrigger)=\"updateModel($event); updateShootsModel($event); updatePaymentsModel($event)\"></delete-lead-modal>\n    </div>\n</div>\n"

/***/ }),

/***/ "./web/modern/components/dashboard/recent-leads-block/recent-leads-block.scss":
/***/ (function(module, exports) {

module.exports = ":host {\n  width: 100%;\n  padding-top: 10px; }\n"

/***/ }),

/***/ "./web/modern/components/dashboard/recent-leads-block/recent-leads-block.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var common_1 = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var leads_data_service_1 = __webpack_require__("./shared/services/lead/leads.data.service.ts");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var rxjs_1 = __webpack_require__("./node_modules/rxjs/Rx.js");
var brands_data_service_1 = __webpack_require__("./shared/services/brands/brands.data.service.ts");
var RecentLeadsBlockComponent = function () {
    function RecentLeadsBlockComponent(leadsDataService, messageService, brandsDataService, location) {
        _classCallCheck(this, RecentLeadsBlockComponent);

        this.leadsDataService = leadsDataService;
        this.messageService = messageService;
        this.brandsDataService = brandsDataService;
        this.location = location;
        this.sendEmailModalTrigger = new core_1.EventEmitter();
        this.editLeadModalTrigger = new core_1.EventEmitter();
        this.addNewLeadModalTrigger = new core_1.EventEmitter();
        this.unsubscribe = new rxjs_1.Subject();
        this.leads = [];
        this.PAGE_REQUEST_DEFAULT = {
            paging: {
                pageNumber: 0,
                pageSize: 10
            },
            sortCriteria: {
                fieldName: 'createdAt',
                sortAscending: false
            },
            search: '',
            filter: 'open'
        };
        this.updateGraphsModel = function (tabs) {
            window.snCommunicationAdapter.callMethod('updateGraphsModel', tabs);
        };
    }

    _createClass(RecentLeadsBlockComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.pageRequest = this.PAGE_REQUEST_DEFAULT;
            this.configureCommunicationAdapter();
            this.subscribeToBrandsChange();
            this.getData();
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "addNew",
        value: function addNew() {
            this.addNewLeadModalTrigger.emit();
        }
    }, {
        key: "updateData",
        value: function updateData(pageRequest) {
            var _this = this;

            this.pageRequest = pageRequest;
            this.leadsDataService.getLeadsOnPage(pageRequest, false).subscribe(function (data) {
                return _this.successGetData(data);
            }, function (error) {
                return _this.messageService.showDefaultErrorMessage(error);
            });
        }
    }, {
        key: "paginationToDefaults",
        value: function paginationToDefaults() {
            this.pageRequest = this.PAGE_REQUEST_DEFAULT;
            delete this.pageRequest.paging.searchToken;
            this.getData();
        }
    }, {
        key: "showLead",
        value: function showLead(id) {
            this.location.go("leads/view/" + id);
        }
    }, {
        key: "showSendEmailModal",
        value: function showSendEmailModal(id, primaryContact, secondaryContact) {
            this.sendEmailModalTrigger.emit({
                leadId: id,
                contact: primaryContact,
                secondaryContact: secondaryContact
            });
        }
    }, {
        key: "showEditLeadModal",
        value: function showEditLeadModal(index) {
            this.editLeadModalTrigger.emit(this.leads[index]);
        }
    }, {
        key: "archiveLead",
        value: function archiveLead(id) {
            var _this2 = this;

            this.leadsDataService.archiveLead(id).subscribe(function () {
                _this2.messageService.showToaster('s_5', 'lead');
                _this2.updateModel(true);
                _this2.updateShootsModel(true);
                _this2.updateGraphsModel(['leads', 'shoots', 'payments']);
            }, function (error) {
                var errorMessage = error.error.errorMessage;

                if (errorMessage.includes('Lead contains invoices.')) {
                    _this2.messageService.showToaster('e_4', 'lead');
                } else {
                    _this2.messageService.showDefaultErrorMessage(error);
                }
            });
        }
    }, {
        key: "showDeleteModal",
        value: function showDeleteModal(id) {
            this.leadForDelete = id;
            $('#deleteLeadModal').modal('show');
        }
    }, {
        key: "isFilterAllowed",
        value: function isFilterAllowed(filter) {
            if (!this.allowedFilters) {
                return false;
            }
            return this.allowedFilters.includes(filter);
        }
    }, {
        key: "orderByField",
        value: function orderByField(filter) {
            if (this.pageRequest.sortCriteria.fieldName === filter) {
                this.pageRequest.sortCriteria.sortAscending = !this.pageRequest.sortCriteria.sortAscending;
            } else {
                this.pageRequest.sortCriteria.fieldName = filter;
                this.pageRequest.sortCriteria.sortAscending = false;
            }
            this.pageRequest.paging.pageNumber = 0;
            this.getData();
        }
    }, {
        key: "updateShootsModel",
        value: function updateShootsModel(resetPagination) {
            window.snCommunicationAdapter.callMethod('updateShootsModel', resetPagination);
        }
    }, {
        key: "updatePaymentsModel",
        value: function updatePaymentsModel(resetPagination) {
            window.snCommunicationAdapter.callMethod('updateUpcomingPaymentsModel', resetPagination);
        }
    }, {
        key: "updateModel",
        value: function updateModel(resetPagination) {
            if (resetPagination) {
                this.paginationToDefaults();
            } else {
                this.getData();
            }
        }
    }, {
        key: "getData",
        value: function getData() {
            var _this3 = this;

            this.leadsDataService.getLeadsOnPage(this.pageRequest, false).subscribe(function (data) {
                return _this3.successGetData(data);
            }, function (error) {
                return _this3.messageService.showDefaultErrorMessage(error);
            });
        }
    }, {
        key: "subscribeToBrandsChange",
        value: function subscribeToBrandsChange() {
            var _this4 = this;

            this.brandsDataService.brandsChange.pipe(operators_1.takeUntil(this.unsubscribe), operators_1.filter(function (data) {
                return !!data;
            })).subscribe(function () {
                return _this4.getData();
            });
        }
    }, {
        key: "successGetData",
        value: function successGetData(data) {
            this.pageRequest.paging.searchToken = data.searchToken;
            this.itemsQuantity = data ? data.totalSize : 0;
            this.pagesQuantity = Math.ceil(this.itemsQuantity / this.pageRequest.paging.pageSize);
            this.leads = JSON.parse(JSON.stringify(data.items));
            this.allowedFilters = data.sortingFields;
        }
    }, {
        key: "configureCommunicationAdapter",
        value: function configureCommunicationAdapter() {
            window.snCommunicationAdapter.registerMethod('updateRecentLeadsModel', this.updateModel.bind(this));
        }
    }]);

    return RecentLeadsBlockComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Boolean)], RecentLeadsBlockComponent.prototype, "buttonDisabled", void 0);
__decorate([core_1.Input(), __metadata("design:type", Boolean)], RecentLeadsBlockComponent.prototype, "spinningWheelActive", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], RecentLeadsBlockComponent.prototype, "sendEmailModalTrigger", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], RecentLeadsBlockComponent.prototype, "editLeadModalTrigger", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], RecentLeadsBlockComponent.prototype, "addNewLeadModalTrigger", void 0);
RecentLeadsBlockComponent = __decorate([core_1.Component({
    selector: 'recent-leads-block',
    template: __webpack_require__("./web/modern/components/dashboard/recent-leads-block/recent-leads-block.html"),
    styles: [__webpack_require__("./web/modern/components/dashboard/recent-leads-block/recent-leads-block.scss")]
}), __metadata("design:paramtypes", [leads_data_service_1.LeadsDataServiceProvider, message_service_1.MessageService, brands_data_service_1.BrandsDataServiceProvider, common_1.Location])], RecentLeadsBlockComponent);
exports.RecentLeadsBlockComponent = RecentLeadsBlockComponent;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./web/modern/components/dashboard/shoots-appointments-block/shoots-appointments-block.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"stats__panel\">\n    <h2>\n        <span class=\"text-reducer\">Upcoming {{ shootsLabelName }} & Appointments</span>\n    </h2>\n    <add-round-btn class=\"header-btn\" [isActive]=\"spinningWheelActive\" (click)=\"addNew()\"></add-round-btn>\n    <div class=\"stats__panel__content\">\n        <div *ngIf=\"data.length === 0\" class=\"stats__placeholder\">\n            <span>Time is money. Your calendar is empty.</span>\n        </div>\n        <div class=\"bottom-bordered stats__container\" [ngClass]=\"{'fit-list-container': flatData.length === 12}\"\n             *ngIf=\"data.length !== 0\">\n            <div class=\"top-bordered stats__item\"\n                 [ngClass]=\"{'fit-list-item': flatData.length === 12}\"\n                 *ngFor=\"let eventsByDate of data\">\n                <div class=\"flex-row\">\n                    <div class=\"w-min-120 text-xs-left text-sm-center\">\n                        <span class=\"stats__item__date\">{{ eventsByDate[0]?.startDate| timeFilter: 'medium' }}</span>\n                    </div>\n                    <div class=\"flex-grow-1 flex-basis-xs one-line-event-rows\">\n\n                        <event-type-row class=\"dashboard-event-section\" [jobTypes]='jobTypes' [title]=\"event.name\" [snFilter]=\"'12hLS'\" (click)=\"showEvent(event, $event)\" [eventData]=\"event\" *ngFor=\"let event of eventsByDate\"></event-type-row>\n\n                    </div>\n                </div>\n            </div>\n        </div>\n        <simple-pagination *ngIf=\"data.length !== 0\" [pageRequest]=\"pageRequest\"\n                           [totalItems]=\"itemsQuantity\"\n                           [totalPages]=\"pagesQuantity\"\n                           (changePageTrigger)=\"updateData($event)\">\n        </simple-pagination>\n    </div>\n</div>\n\n"

/***/ }),

/***/ "./web/modern/components/dashboard/shoots-appointments-block/shoots-appointments-block.scss":
/***/ (function(module, exports) {

module.exports = ":host {\n  width: 100%;\n  padding-top: 10px; }\n"

/***/ }),

/***/ "./web/modern/components/dashboard/shoots-appointments-block/shoots-appointments-block.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var http_1 = __webpack_require__("./node_modules/@angular/common/esm5/http.js");
var dashboard_data_service_1 = __webpack_require__("./shared/services/dashboard/dashboard.data.service.ts");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var brands_data_service_1 = __webpack_require__("./shared/services/brands/brands.data.service.ts");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var settings_1 = __webpack_require__("./shared/services/settings/settings.ts");
var ShootsAppointmentsBlockComponent = function () {
    function ShootsAppointmentsBlockComponent(http, dashboardDataService, brandsDataService, messageService, settingsService) {
        _classCallCheck(this, ShootsAppointmentsBlockComponent);

        this.http = http;
        this.dashboardDataService = dashboardDataService;
        this.brandsDataService = brandsDataService;
        this.messageService = messageService;
        this.settingsService = settingsService;
        this.jobTypes = [];
        this.chooseModalTrigger = new core_1.EventEmitter();
        this.unsubscribe = new Subject_1.Subject();
        this.data = [];
        this.flatData = [];
        this.PAGE_REQUEST_DEFAULT = {
            filterBy: 'upcoming',
            paging: {
                pageNumber: 0,
                pageSize: 12,
                searchToken: null
            },
            sortCriterias: [{
                fieldName: 'startDate',
                sortAscending: true
            }, {
                fieldName: 'startTime',
                sortAscending: true
            }]
        };
    }

    _createClass(ShootsAppointmentsBlockComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.pageRequest = this.PAGE_REQUEST_DEFAULT;
            this.subscribeToCustomizeLabelsChange();
            this.configureCommunicationAdapter();
            this.subscribeToBrandsChange();
            this.getData();
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "addNew",
        value: function addNew() {
            $('#addNewModal').modal('show');
        }
    }, {
        key: "showEvent",
        value: function showEvent(event, $event) {
            if ($event && $event.stopPropagation) {
                $event.stopPropagation();
            }
            if (event && (this.isJob(event) || this.isAppointment(event) && event.jobId || this.isExtrashoot(event))) {
                return;
            }
            this.chooseModalTrigger.emit(event);
        }
    }, {
        key: "updateData",
        value: function updateData(pageRequest) {
            var _this = this;

            this.pageRequest = pageRequest;
            this.dashboardDataService.getShootsAppointmentsData(pageRequest).subscribe(function (data) {
                return _this.successGetData(data);
            }, function (error) {
                return _this.messageService.showDefaultErrorMessage(error);
            });
        }
    }, {
        key: "paginationToDefaults",
        value: function paginationToDefaults() {
            this.pageRequest = this.PAGE_REQUEST_DEFAULT;
            delete this.pageRequest.paging.searchToken;
            this.getData();
        }
    }, {
        key: "subscribeToCustomizeLabelsChange",
        value: function subscribeToCustomizeLabelsChange() {
            var _this2 = this;

            this.settingsService.customizeLabelsObservable.pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (customizeLabels) {
                return _this2.shootsLabelName = customizeLabels.shootsLabel;
            });
        }
    }, {
        key: "getData",
        value: function getData() {
            var _this3 = this;

            this.dashboardDataService.getShootsAppointmentsData(this.pageRequest).subscribe(function (data) {
                return _this3.successGetData(data);
            }, function (error) {
                return _this3.messageService.showDefaultErrorMessage(error);
            });
        }
    }, {
        key: "subscribeToBrandsChange",
        value: function subscribeToBrandsChange() {
            var _this4 = this;

            this.brandsDataService.brandsChange.pipe(operators_1.takeUntil(this.unsubscribe), operators_1.filter(function (data) {
                return !!data;
            })).subscribe(function () {
                return _this4.getData();
            });
        }
    }, {
        key: "successGetData",
        value: function successGetData(data) {
            this.pageRequest.paging.searchToken = data.searchToken;
            this.itemsQuantity = data.totalSize;
            this.pagesQuantity = Math.ceil(this.itemsQuantity / this.pageRequest.paging.pageSize);
            this.flatData = data.items;
            this.data = this.reformatData(data);
        }
    }, {
        key: "reformatData",
        value: function reformatData(data) {
            var groups = data.items.reduce(function (groups, item) {
                (groups[item.startDate] = groups[item.startDate] || []).push(item);
                return groups;
            }, {});
            var result = Object.keys(groups).map(function (k) {
                return groups[k];
            });
            return result;
        }
    }, {
        key: "isJob",
        value: function isJob(event) {
            return event.calendarEventType === 'MAIN_SHOOT';
        }
    }, {
        key: "isExtrashoot",
        value: function isExtrashoot(event) {
            return event.calendarEventType === 'EXTRA_SHOOT';
        }
    }, {
        key: "isAppointment",
        value: function isAppointment(event) {
            return event.calendarEventType === 'APPOINTMENT';
        }
    }, {
        key: "updateModel",
        value: function updateModel(resetPagination) {
            if (resetPagination) {
                this.paginationToDefaults();
            } else {
                this.getData();
            }
        }
    }, {
        key: "configureCommunicationAdapter",
        value: function configureCommunicationAdapter() {
            window.snCommunicationAdapter.registerMethod('updateShootsModel', this.updateModel.bind(this));
        }
    }]);

    return ShootsAppointmentsBlockComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Boolean)], ShootsAppointmentsBlockComponent.prototype, "buttonDisabled", void 0);
__decorate([core_1.Input(), __metadata("design:type", Boolean)], ShootsAppointmentsBlockComponent.prototype, "spinningWheelActive", void 0);
__decorate([core_1.Input(), __metadata("design:type", Array)], ShootsAppointmentsBlockComponent.prototype, "jobTypes", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], ShootsAppointmentsBlockComponent.prototype, "chooseModalTrigger", void 0);
ShootsAppointmentsBlockComponent = __decorate([core_1.Component({
    selector: 'shoots-appointments-block',
    template: __webpack_require__("./web/modern/components/dashboard/shoots-appointments-block/shoots-appointments-block.html"),
    styles: [__webpack_require__("./web/modern/components/dashboard/shoots-appointments-block/shoots-appointments-block.scss")]
}), __metadata("design:paramtypes", [http_1.HttpClient, dashboard_data_service_1.DashboardDataServiceProvider, brands_data_service_1.BrandsDataServiceProvider, message_service_1.MessageService, settings_1.SettingsProvider])], ShootsAppointmentsBlockComponent);
exports.ShootsAppointmentsBlockComponent = ShootsAppointmentsBlockComponent;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./web/modern/components/dashboard/upcoming-payments-block/upcoming-payments-block.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"stats__panel\">\n    <h2>\n        <span class=\"text-reducer\">Overdue & Upcoming Payments</span>\n    </h2>\n    <div class=\"stats__panel__content\">\n        <div *ngIf=\"payments.length==0\" class=\"stats__placeholder\">\n            <span>No invoices have been issued.</span>\n        </div>\n        <div *ngIf=\"payments.length!==0\"\n             class=\"table-responsive indexes\"\n             id=\"upcomingPaymentsTable\">\n            <table class=\"table table-dashboard table-upcoming-payments table-hover table-with-links\">\n                <thead class=\"invoice-thead\">\n                <tr class=\"bottom-bordered\">\n                    <th>\n                        <b (click)=\"isFilterAllowed('paymentDate') && orderByField('paymentDate')\" class=\"pointer\">\n                            Due\n                            <span class=\"fa\"\n                                  [ngClass]=\"pageRequest.sortCriterias[0].sortAscending ? 'fa-caret-up' : 'fa-caret-down'\"\n                                  *ngIf=\"pageRequest.sortCriterias[0].fieldName === 'paymentDate' && isFilterAllowed('paymentDate')\"></span>\n                        </b>\n                    </th>\n                    <th>\n                        <b (click)=\"isFilterAllowed('invoiceId') && orderByField('invoiceId')\" class=\"pointer\">\n                            Invoice ID\n                            <span class=\"fa\"\n                                  [ngClass]=\"pageRequest.sortCriterias[0].sortAscending ? 'fa-caret-up' : 'fa-caret-down'\"\n                                  *ngIf=\"pageRequest.sortCriterias[0].fieldName === 'invoiceId' && isFilterAllowed('invoiceId')\"></span>\n                        </b>\n                    </th>\n                    <th>\n                        <b (click)=\"isFilterAllowed('jobName') && orderByField('jobName')\" class=\"pointer\">\n                            Job\n                            <span class=\"fa\"\n                                  [ngClass]=\"pageRequest.sortCriterias[0].sortAscending ? 'fa-caret-up' : 'fa-caret-down'\"\n                                  *ngIf=\"pageRequest.sortCriterias[0].fieldName === 'jobName' && isFilterAllowed('jobName')\"></span>\n                        </b>\n                    </th>\n                    <th>\n                        <b (click)=\"isFilterAllowed('amount') && orderByField('amount')\" class=\"pointer\">\n                            Amount\n                            <span class=\"fa\"\n                                  [ngClass]=\"pageRequest.sortCriterias[0].sortAscending ? 'fa-caret-up' : 'fa-caret-down'\"\n                                  *ngIf=\"pageRequest.sortCriterias[0].fieldName === 'amount' && isFilterAllowed('amount')\"></span>\n                        </b>\n                    </th>\n                    <th></th>\n                </tr>\n                </thead>\n                <tbody>\n                <ng-container *ngFor=\"let payment of payments | orderBy; let i = index\">\n                    <tr class=\"bottom-bordered pointer\"\n                        *ngIf=\"payment.amount!==0\">\n                        <td>\n                            <a class=\"table-link\" href=\"/invoices/{{payment.invoiceId}}\"></a>\n                            {{ payment.due | timeFilter: 'medium' }}\n                            <span class=\"text-nowrap\" [ngClass]=\"payment.isLate ? 'red': 'gray-label'\">({{ payment.days }})</span>\n                        </td>\n                        <td class=\"text-nowrap\">\n                            <a class=\"table-link\" href=\"/invoices/{{payment.invoiceId}}\"></a>\n                            {{ payment.invoiceDisplayId }}\n                        </td>\n                        <td>\n                            <a class=\"table-link\" href=\"/invoices/{{payment.invoiceId}}\"></a>\n                            {{ payment.jobName }}\n                        </td>\n                        <td>\n                            <a class=\"table-link\" href=\"/invoices/{{payment.invoiceId}}\"></a>\n                            {{ payment.amountWithCurrency.amountWithCurrency }}\n                        </td>\n                        <td class=\"text-nowrap text-right pointer\">\n                            <div class=\"dropup\" dropdown container=\"body\">\n                                <div class=\"dropdown-toggle menu-dots\"\n                                     dropdownToggle\n                                     aria-controls=\"dropdown-container\"\n                                     id=\"paymentsDotsMenu-{{i}}\"(click)=\"getPayOnlineLink(payment.invoiceId)\">\n                                    <div class=\"dots\"></div>\n                                    <div class=\"dots\"></div>\n                                    <div class=\"dots\"></div>\n                                </div>\n                                <ul class=\"dropdown-menu dropdown-menu-right payments-dropdown-menu-{{i}}\"\n                                    role=\"menu\"\n                                    *dropdownMenu\n                                    aria-labelledby=\"dropdown-container\"\n                                    id=\"menuId-{{i}}\">\n                                    <li (click)=\"showRecordPaymentModal(payment)\" *ngIf=\"payment.actions.RECORD && payment.actions.RECORD.state ==='active'\">\n                                        <a href=\"#\">\n                                            <i class=\"fi fi-record-payment color-icon\"></i>Record Payment\n                                        </a>\n                                    </li>\n                                    <li *ngIf=\"payment.actions.RECORD && payment.actions.RECORD.state ==='active'\" class=\"divider\"></li>\n                                    <li *ngIf=\"payment.actions.PAY_ONLINE && payment.actions.PAY_ONLINE.state ==='active'\" >\n                                        <a href=\"/clients/invoice/pay/{{clientLink}}/{{payment.invoiceId}}\" target=\"_blank\">\n                                            <i class=\"fi fi-pay-online color-icon\"></i>Pay Online\n                                        </a>\n                                    </li>\n                                    <li *ngIf=\"payment.actions.PAY_ONLINE && payment.actions.PAY_ONLINE.state ==='active'\" class=\"divider\"></li>\n                                    <li (click)=\"showWriteOff(payment)\" *ngIf=\"payment.actions.WRITE_OFF && payment.actions.WRITE_OFF.state ==='active'\">\n                                        <a href=\"#\">\n                                            <i class=\"fi fi-write-off pr-0 color-icon\"></i>Write Off\n                                        </a>\n                                    </li>\n                                    <li *ngIf=\"payment.actions.WRITE_OFF && payment.actions.WRITE_OFF.state ==='active'\" class=\"divider\"></li>\n                                    <li (click)=\"showInvoice(payment.invoiceId)\" *ngIf=\"payment.actions.VIEW_INVOICE && payment.actions.VIEW_INVOICE.state ==='active'\">\n                                        <a href=\"/invoices/{{payment.invoiceId}}\">\n                                            <i class=\"fi fi-view color-icon\"></i>View Invoice\n                                        </a>\n                                    </li>\n                                </ul>\n                            </div>\n                        </td>\n                    </tr>\n                </ng-container>\n                </tbody>\n            </table>\n        </div>\n        <simple-pagination *ngIf=\"payments.length !== 0\" [pageRequest]=\"pageRequest\"\n                           [totalItems]=\"itemsQuantity\"\n                           [totalPages]=\"pagesQuantity\"\n                           (changePageTrigger)=\"updateData($event)\"></simple-pagination>\n        <record-payment-modal [selectedPayment]=\"selectedPayment\"\n                              (updateParent)=\"updateModel($event); updateRecentLeadsModel($event); updateJobTasksModel($event); updateGraphsModel(['leads', 'payments'])\"></record-payment-modal>\n    </div>\n</div>\n"

/***/ }),

/***/ "./web/modern/components/dashboard/upcoming-payments-block/upcoming-payments-block.scss":
/***/ (function(module, exports) {

module.exports = ":host {\n  width: 100%;\n  padding-top: 10px; }\n"

/***/ }),

/***/ "./web/modern/components/dashboard/upcoming-payments-block/upcoming-payments-block.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var common_1 = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var dashboard_data_service_1 = __webpack_require__("./shared/services/dashboard/dashboard.data.service.ts");
var time_service_1 = __webpack_require__("./shared/services/helpers/time-service/time.service.ts");
var payments_data_service_1 = __webpack_require__("./shared/services/payments/payments-data-service/payments.data.service.ts");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var brands_data_service_1 = __webpack_require__("./shared/services/brands/brands.data.service.ts");
var write_off_modal_1 = __webpack_require__("./web/modern/components/payments/modals/write-off-modal/write-off-modal.ts");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var UpcomingPaymentsBlockComponent = function () {
    function UpcomingPaymentsBlockComponent(dashboardDataService, messageService, location, timeService, brandsDataService, paymentsDataService, modalService) {
        _classCallCheck(this, UpcomingPaymentsBlockComponent);

        this.dashboardDataService = dashboardDataService;
        this.messageService = messageService;
        this.location = location;
        this.timeService = timeService;
        this.brandsDataService = brandsDataService;
        this.paymentsDataService = paymentsDataService;
        this.modalService = modalService;
        this.unsubscribe = new Subject_1.Subject();
        this.payments = [];
        this.PAGE_REQUEST_DEFAULT = {
            paging: {
                pageNumber: 0,
                pageSize: 10
            },
            sortCriterias: [{
                fieldName: 'paymentDate',
                sortAscending: true
            }],
            search: '',
            filterBy: 'unpaid'
        };
        this.updateGraphsModel = function (tabs) {
            window.snCommunicationAdapter.callMethod('updateGraphsModel', tabs);
        };
    }

    _createClass(UpcomingPaymentsBlockComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.configureCommunicationAdapter();
            this.subscribeToBrandsChange();
            this.pageRequest = this.PAGE_REQUEST_DEFAULT;
            this.getData();
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "updateData",
        value: function updateData(pageRequest) {
            var _this = this;

            this.pageRequest = pageRequest;
            this.dashboardDataService.getUpcomingPaymentsData(pageRequest).subscribe(function (data) {
                return _this.successGetData(data);
            }, function (error) {
                return _this.messageService.showDefaultErrorMessage(error);
            });
        }
    }, {
        key: "showRecordPaymentModal",
        value: function showRecordPaymentModal(payment) {
            this.selectedPayment = payment;
            $('#markAsPayedModal').modal('show');
        }
    }, {
        key: "getPayOnlineLink",
        value: function getPayOnlineLink(id) {
            var _this2 = this;

            this.paymentsDataService.getPayOnlineLink(id).subscribe(function (result) {
                _this2.clientLink = result.link;
            }, function (error) {
                _this2.messageService.showDefaultErrorMessage(error);
            });
        }
    }, {
        key: "showWriteOff",
        value: function showWriteOff(payment) {
            this.paymentToWriteOffId = payment.id;
            this.prepareWriteOffData(payment);
            this.showWriteOffModal();
        }
    }, {
        key: "showInvoice",
        value: function showInvoice(invoiceId) {
            this.location.go("/invoices/" + invoiceId);
        }
    }, {
        key: "isFilterAllowed",
        value: function isFilterAllowed(filter) {
            if (!this.allowedFilters) {
                return false;
            }
            return this.allowedFilters.includes(filter);
        }
    }, {
        key: "orderByField",
        value: function orderByField(filter) {
            if (this.pageRequest.sortCriterias[0].fieldName === filter) {
                this.pageRequest.sortCriterias[0].sortAscending = !this.pageRequest.sortCriterias[0].sortAscending;
            } else {
                this.pageRequest.sortCriterias[0].fieldName = filter;
                this.pageRequest.sortCriterias[0].sortAscending = false;
            }
            this.pageRequest.paging.pageNumber = 0;
            this.getData();
        }
    }, {
        key: "updateModel",
        value: function updateModel(resetPagination) {
            if (resetPagination) {
                this.paginationToDefaults();
            } else {
                this.getData();
            }
        }
    }, {
        key: "updateRecentLeadsModel",
        value: function updateRecentLeadsModel(resetPagination) {
            window.snCommunicationAdapter.callMethod('updateRecentLeadsModel', resetPagination);
        }
    }, {
        key: "updateJobTasksModel",
        value: function updateJobTasksModel(resetPagination) {
            window.snCommunicationAdapter.callMethod('updateJobTasksModel', resetPagination);
        }
    }, {
        key: "getData",
        value: function getData() {
            var _this3 = this;

            this.dashboardDataService.getUpcomingPaymentsData(this.pageRequest).subscribe(function (data) {
                return _this3.successGetData(data);
            }, function (error) {
                return _this3.messageService.showDefaultErrorMessage(error);
            });
        }
    }, {
        key: "successGetData",
        value: function successGetData(data) {
            this.pageRequest.paging.searchToken = data.searchToken;
            this.itemsQuantity = data ? data.totalSize : 0;
            this.pagesQuantity = Math.ceil(this.itemsQuantity / this.pageRequest.paging.pageSize);
            this.payments = JSON.parse(JSON.stringify(data.items));
            this.allowedFilters = data.sortingFields;
            this.handlePayments();
        }
    }, {
        key: "paginationToDefaults",
        value: function paginationToDefaults() {
            this.pageRequest = this.PAGE_REQUEST_DEFAULT;
            delete this.pageRequest.paging.searchToken;
            this.getData();
        }
    }, {
        key: "handlePayments",
        value: function handlePayments() {
            var _this4 = this;

            if (this.payments) {
                this.payments.forEach(function (payment) {
                    payment.days = _this4.calcDate(new Date(), _this4.timeService.createDateAsUTC(payment.due));
                    var dayMulti = ' days';
                    if (payment.days === 1 || payment.days === -1) {
                        dayMulti = ' day';
                    }
                    if (payment.days === 0) {
                        payment.days = 'today';
                    } else if (payment.days > 0) {
                        payment.days = payment.days + dayMulti + " ago";
                        payment.isLate = true;
                    } else {
                        payment.days = "in " + -payment.days + dayMulti;
                    }
                });
            }
        }
    }, {
        key: "calcDate",
        value: function calcDate(date1, date2) {
            var diff = Math.floor(date1.getTime() - date2.getTime());
            var day = 1000 * 60 * 60 * 24;
            return Math.floor(diff / day);
        }
    }, {
        key: "prepareWriteOffData",
        value: function prepareWriteOffData(payment) {
            this.writeOffModalContent = {
                title: 'Write off',
                description: 'Are you sure?',
                buttons: [{
                    color: 'danger',
                    size: 'lg',
                    text: 'Write off payment',
                    action: 'WRITE_OFF'
                }, {
                    color: 'default',
                    size: 'lg',
                    text: 'Cancel',
                    action: 'DISCARD'
                }]
            };
            if (payment.xeroStatus === 'COPIED_TO_XERO') {
                this.writeOffModalContent.description = 'Writing off this invoice in Studio Ninja will add a credit note to this invoice in Xero. Once written off, you can only undo by removing the credit note in Xero. Are you sure?';
                this.writeOffModalContent.buttons[0].text = 'Yes';
                this.writeOffModalContent.buttons[1].text = 'No';
            }
        }
    }, {
        key: "showWriteOffModal",
        value: function showWriteOffModal() {
            var _this5 = this;

            var modal = this.modalService.openModal(write_off_modal_1.WriteOffModalComponent);
            modal.componentInstance.paymentId = this.paymentToWriteOffId;
            modal.componentInstance.modalContent = this.writeOffModalContent;
            modal.result.then(function () {
                _this5.updateModel(true);
                _this5.updateGraphsModel(['payments']);
            });
        }
    }, {
        key: "configureCommunicationAdapter",
        value: function configureCommunicationAdapter() {
            window.snCommunicationAdapter.registerMethod('updateUpcomingPaymentsModel', this.updateModel.bind(this));
        }
    }, {
        key: "subscribeToBrandsChange",
        value: function subscribeToBrandsChange() {
            var _this6 = this;

            this.brandsDataService.brandsChange.pipe(operators_1.takeUntil(this.unsubscribe), operators_1.filter(function (data) {
                return !!data;
            })).subscribe(function () {
                return _this6.getData();
            });
        }
    }]);

    return UpcomingPaymentsBlockComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Boolean)], UpcomingPaymentsBlockComponent.prototype, "buttonDisabled", void 0);
__decorate([core_1.Input(), __metadata("design:type", Boolean)], UpcomingPaymentsBlockComponent.prototype, "spinningWheelActive", void 0);
UpcomingPaymentsBlockComponent = __decorate([core_1.Component({
    selector: 'upcoming-payments-block',
    template: __webpack_require__("./web/modern/components/dashboard/upcoming-payments-block/upcoming-payments-block.html"),
    styles: [__webpack_require__("./web/modern/components/dashboard/upcoming-payments-block/upcoming-payments-block.scss")]
}), __metadata("design:paramtypes", [dashboard_data_service_1.DashboardDataServiceProvider, message_service_1.MessageService, common_1.Location, time_service_1.TimeServiceProvider, brands_data_service_1.BrandsDataServiceProvider, payments_data_service_1.PaymentsDataServiceProvider, snModal_service_1.SNModalService])], UpcomingPaymentsBlockComponent);
exports.UpcomingPaymentsBlockComponent = UpcomingPaymentsBlockComponent;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./web/modern/components/inputs/autocomplete-email-input/autocompete-email-input.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"autoCompleteEmailInput\">\n    <ul class=\"dropdown-menu {{autocompleteStyle}}\" [ngStyle]=\"{'display' : (searchClients.length !== 0) ? 'block' : 'none'}\">\n        <li *ngFor=\"let item of searchClients; let $i = index \" [ngClass]=\"{active: isActive($i)}\"\n            (mouseenter)=\"setActive($i)\">\n            <a (click)=\"setEmail(item.name)\"><span [innerHTML]=\"item.name | boldFilter:queryField.value\"></span></a>\n        </li>\n    </ul>\n    <input type=\"email\" class=\"form-control\" [formControl]=\"queryField\" (keydown)=\"keyDownEvent($event)\" (blur)=\"emitEmail()\" [required]=\"isRequired\" [placeholder]=\"placeholder\" >\n</div>\n"

/***/ }),

/***/ "./web/modern/components/inputs/autocomplete-email-input/autocompete-email-input.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var jobs_data_service_1 = __webpack_require__("./shared/services/job/jobs.data.service.ts");
var forms_1 = __webpack_require__("./node_modules/@angular/forms/esm5/forms.js");
var AutocompleteEmailInputComponent = function () {
    function AutocompleteEmailInputComponent(jobsDataService, _eref) {
        _classCallCheck(this, AutocompleteEmailInputComponent);

        this.jobsDataService = jobsDataService;
        this._eref = _eref;
        this.isRequired = true;
        this.isDisabled = false;
        this.placeholder = '';
        this.defaultValue = '';
        this.actionGetEmail = new core_1.EventEmitter();
        this.searchClients = [];
        this.setIndex = 0;
    }

    _createClass(AutocompleteEmailInputComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            var _this = this;

            this.initFormControll();
            this.queryField.valueChanges.debounceTime(200).distinctUntilChanged().map(function (query) {
                if (query.length > 0) {
                    return query;
                }
                _this.searchClients = [];
            }).switchMap(function (query) {
                return _this.searchEmails(query);
            }).subscribe(function (res) {
                _this.setIndex = 0;
                _this.searchClients = res;
            });
        }
    }, {
        key: "initFormControll",
        value: function initFormControll() {
            this.queryField = new forms_1.FormControl({}, [forms_1.Validators.email, forms_1.Validators.maxLength(255)]);
            if (this.isDisabled) {
                this.queryField.disable();
            }
            this.queryField.setValue(this.defaultValue, { emitEvent: false });
            this.emitEmail();
        }
    }, {
        key: "closeAutocomplete",
        value: function closeAutocomplete(event) {
            if (!this._eref.nativeElement.contains(event.target)) {
                this.searchClients = [];
            }
        }
    }, {
        key: "searchEmails",
        value: function searchEmails(queryEmail) {
            return this.jobsDataService.searchClient(queryEmail);
        }
    }, {
        key: "setEmail",
        value: function setEmail(item) {
            var stringEmail = item.substring(item.indexOf('(') + 1, item.length - 1);
            this.queryField.setValue(stringEmail, { emitEvent: false });
            this.emitEmail();
            this.searchClients = [];
            this.setIndex = 0;
        }
    }, {
        key: "setActive",
        value: function setActive(index) {
            this.setIndex = index;
        }
    }, {
        key: "isActive",
        value: function isActive(index) {
            return index === this.setIndex;
        }
    }, {
        key: "emitEmail",
        value: function emitEmail() {
            var inputEmail = this.queryField.value;
            if (inputEmail !== undefined && inputEmail.length > 0) {
                this.actionGetEmail.emit(inputEmail);
            }
        }
    }, {
        key: "keyDownEvent",
        value: function keyDownEvent(event) {
            if (this.searchClients.length !== 0) {
                var index = this.setIndex;
                switch (event.key) {
                    case 'ArrowDown':
                        index++;
                        if (index > this.searchClients.length) {
                            index = this.searchClients.length;
                        }
                        if (this.searchClients.length === 1) {
                            index = 0;
                        }
                        this.setIndex = index;
                        break;
                    case 'ArrowUp':
                        index--;
                        if (index < 0) {
                            index = 0;
                        }
                        this.setIndex = index;
                        break;
                    case 'Enter':
                        var items = this.searchClients[this.setIndex];
                        this.setEmail(items.name);
                        break;
                    default:
                        break;
                }
            }
        }
    }]);

    return AutocompleteEmailInputComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], AutocompleteEmailInputComponent.prototype, "isRequired", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], AutocompleteEmailInputComponent.prototype, "isDisabled", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], AutocompleteEmailInputComponent.prototype, "placeholder", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], AutocompleteEmailInputComponent.prototype, "defaultValue", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], AutocompleteEmailInputComponent.prototype, "autocompleteStyle", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], AutocompleteEmailInputComponent.prototype, "actionGetEmail", void 0);
AutocompleteEmailInputComponent = __decorate([core_1.Component({
    selector: 'autocomplete-email-input',
    template: __webpack_require__("./web/modern/components/inputs/autocomplete-email-input/autocompete-email-input.html"),
    host: {
        '(document:click)': 'closeAutocomplete($event)'
    }
}), __metadata("design:paramtypes", [jobs_data_service_1.JobsDataServiceProvider, core_1.ElementRef])], AutocompleteEmailInputComponent);
exports.AutocompleteEmailInputComponent = AutocompleteEmailInputComponent;

/***/ }),

/***/ "./web/modern/components/integrations/connect-galleries/gallery-view-block/gallery-view-block.component.html":
/***/ (function(module, exports) {

module.exports = "<div *ngIf=\"shootProofState === 'enabled' || (picTimeState === 'ENABLED' && picTimeAvailable)\" class=\"flex-row\">\n    <div class=\"col-xs-12 main-jobs-cell flex-basis-full\">\n        <div class=\"main-jobs-cell__title main-jobs-cell__title--bordered\">\n            <i class=\"fi-gallery fi-job\"></i>\n            <h2>Galleries</h2>\n            <span *ngIf=\"checkGalleriesActions()\" class=\"btn-sm bg-galleries-label ml-15 mr-15 color-white f-bold btn-rounded pull-xs-right\">{{ checkGalleriesActions() }}</span>\n            <add-round-btn *ngIf=\"(shootProofActions.length || picTimeActions.length) && resultArrayGalleries.length !== 0\" class=\"round-btn-left\" (click)=\"showAddGalleryModal()\" [isActive]=\"false\"></add-round-btn>\n        </div>\n\n        <div *ngIf=\"resultArrayGalleries.length === 0\"\n             class=\"section-data section-data--empty text-center\">\n            <h3 class=\"text-normal color-grey-dusty\">It's time to show off your work!</h3>\n            <button class=\"btn btn-add-new-sm btn-success\" type=\"button\" (click)=\"showAddGalleryModal()\">\n                Add new gallery\n            </button>\n        </div>\n\n        <div class=\"flex-row section-data__wrapper job-galleries-container\">\n            <ng-container *ngFor=\"let gallery of resultArrayGalleries; let i = index;\">\n                <div class=\"section-data section-data--full\" [ngClass]=\"{'flex-basis-full' : resultArrayGalleries.length === 1}\">\n                    <table class=\"table-profile table-full-width\">\n                        <tbody>\n                            <tr>\n                                <td><h4>{{ gallery.name }}</h4></td>\n                            </tr>\n                            <tr>\n                                <td>\n                                    {{ gallery?.photoCount || gallery?.numAllPhotos || (gallery?.photoCount === 0 || gallery?.numAllPhotos === 0 ? '0' : '') }} photos\n                                </td>\n                            </tr>\n                            <tr *ngIf=\"gallery?.syncStatus === 'NOT_FOUND_ON_SP'\">\n                                <td>\n                                    <sn-label text=\"Not found in ShootProof\"></sn-label>\n                                </td>\n                            </tr>\n                        </tbody>\n                    </table>\n                    <a class=\"btn btn-default ml-0 mr-5\"\n                       target=\"_blank\"\n                       *ngIf=\"gallery?.availableActions?.VIEW_IN_SP?.state === 'active' || gallery?.actions?.PREVIEW_GALLERY\"\n                       href=\"{{gallery?.viewUrl || gallery?.redirectUrl}}\">\n                        <i class=\"fi fi-view\"></i>\n                        {{ gallery?.spGalleryId ? 'View in ShootProof' : gallery?.actions?.PREVIEW_GALLERY?.actionName }}\n                    </a>\n                    <a class=\"btn btn-default ml-0 mr-5\"\n                       target=\"_blank\"\n                       *ngIf=\"gallery?.actions?.EDIT_GALLERY\"\n                       href=\"{{gallery?.editUrl}}\">\n                        <i class=\"fi fi-edit\"></i>\n                        {{ gallery?.actions?.EDIT_GALLERY?.actionName }}\n                    </a>\n                    <button *ngIf=\"gallery?.actions?.SYNCHRONIZE_GALLERY\"\n                            (click)=\"synchronizePicTimeGallery(gallery?.actions?.SYNCHRONIZE_GALLERY, i)\"\n                            [disabled]=\"syncingGallery !== null\"\n                            spinning-wheel [is-spinning-wheel-active]=\"i === syncingGallery\" [is-spinning-wheel-dark]=\"'true'\"\n                            class=\"btn btn-default ml-0 mr-5\">\n                        <i class=\"fa fa-repeat\"></i>\n                        {{ gallery?.actions?.SYNCHRONIZE_GALLERY?.actionName }}\n                    </button>\n                    <delete-btn [text]=\"gallery?.actions?.DELETE_GALLERY?.actionName || 'Delete'\" (click)=\"showDeleteModal(gallery)\"></delete-btn>\n                </div>\n            </ng-container>\n        </div>\n\n    </div>\n</div>\n"

/***/ }),

/***/ "./web/modern/components/integrations/connect-galleries/gallery-view-block/gallery-view-block.component.scss":
/***/ (function(module, exports) {

module.exports = ":host .round-btn-left {\n  margin-left: auto; }\n\n:host .btn-label_opacity {\n  opacity: 0.6; }\n"

/***/ }),

/***/ "./web/modern/components/integrations/connect-galleries/gallery-view-block/gallery-view-block.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var shootProof_data_service_1 = __webpack_require__("./shared/services/integrations/shootProof/shootProof.data.service.ts");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var delete_gallery_modal_1 = __webpack_require__("./web/modern/components/integrations/connect-galleries/modals/delete-gallery-modal/delete-gallery.modal.ts");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var add_gallery_modal_1 = __webpack_require__("./web/modern/components/integrations/connect-galleries/modals/add-gallery-modal/add-gallery.modal.ts");
var pickTime_data_service_1 = __webpack_require__("./shared/services/integrations/pickTime/pickTime.data.service.ts");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var settings_1 = __webpack_require__("./shared/services/settings/settings.ts");
var integrations_service_1 = __webpack_require__("./shared/services/integrations/integrations.service.ts");
var GalleryViewBlockComponent = function () {
    function GalleryViewBlockComponent(shootProofDataService, pickTimeDataProvider, messageService, modalService, settingsService, integrationService) {
        _classCallCheck(this, GalleryViewBlockComponent);

        this.shootProofDataService = shootProofDataService;
        this.pickTimeDataProvider = pickTimeDataProvider;
        this.messageService = messageService;
        this.modalService = modalService;
        this.settingsService = settingsService;
        this.integrationService = integrationService;
        this.resultArrayGalleries = [];
        this.shootProofGalleries = [];
        this.picTimeGalleries = [];
        this.shootProofBrands = [];
        this.availableActionsForGallery = null;
        this.shootProofActions = [];
        this.picTimeActions = [];
        this.syncingGallery = null;
        this.unsubscribe = new Subject_1.Subject();
    }

    _createClass(GalleryViewBlockComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.isPicTimeAvailable();
            this.setVariables();
            this.getShootProofGalleries();
            this.getPicTimeActions();
            this.shouldUpdateGalleriesObservable();
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
            this.integrationService.destroyGalleriesUpdatedObservable();
        }
    }, {
        key: "shouldUpdateGalleriesObservable",
        value: function shouldUpdateGalleriesObservable() {
            var _this = this;

            this.integrationService.shouldGalleriesBeUpdatedObservable.pipe(operators_1.takeUntil(this.unsubscribe), operators_1.filter(function (value) {
                return !!value && value === 'UPDATE_SN_GALLERIES';
            })).subscribe(function () {
                return _this.refreshResultArray();
            });
        }
    }, {
        key: "isPicTimeAvailable",
        value: function isPicTimeAvailable() {
            var _this2 = this;

            this.settingsService.timeFormatSettings.pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (data) {
                if (data.picTimeAvailable) {
                    _this2.picTimeAvailable = true;
                }
            });
        }
    }, {
        key: "getShootProofGalleries",
        value: function getShootProofGalleries() {
            var _this3 = this;

            this.shootProofDataService.getJobGalleriesV1(this.jobId).pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (data) {
                return _this3.successGetShootProofGalleries(data);
            }, function (error) {
                return _this3.messageService.handleError(error);
            });
        }
    }, {
        key: "getPicTimeGalleries",
        value: function getPicTimeGalleries() {
            var _this4 = this;

            this.pickTimeDataProvider.getPicTimeGalleries(this.jobId).pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (data) {
                var _resultArrayGalleries;

                _this4.picTimeGalleries = data.data;
                (_resultArrayGalleries = _this4.resultArrayGalleries).push.apply(_resultArrayGalleries, _toConsumableArray(data.data));
            }, function (error) {
                return _this4.messageService.handleError(error);
            });
        }
    }, {
        key: "refreshResultArray",
        value: function refreshResultArray() {
            this.resultArrayGalleries = [];
            this.getShootProofGalleries();
            this.getPicTimeActions();
        }
    }, {
        key: "getPicTimeActions",
        value: function getPicTimeActions() {
            var _this5 = this;

            this.pickTimeDataProvider.getPicTimeActions(this.jobId).pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (data) {
                return _this5.successGetPicTimeActions(data);
            }, function (error) {
                return _this5.messageService.handleError(error);
            });
        }
    }, {
        key: "synchronizePicTimeGallery",
        value: function synchronizePicTimeGallery(action, index) {
            var _this6 = this;

            if (action) {
                var url = action.url,
                    method = action.method;

                this.syncingGallery = index;
                this.pickTimeDataProvider.syncPicTimeGallery(url, method).pipe(operators_1.takeUntil(this.unsubscribe), operators_1.finalize(function () {
                    return _this6.syncingGallery = null;
                })).subscribe(function () {
                    _this6.messageService.showToaster('s_7', 'picTime');
                    _this6.refreshResultArray();
                }, function (error) {
                    return _this6.messageService.handleError(error);
                });
            }
        }
    }, {
        key: "checkGalleriesActions",
        value: function checkGalleriesActions() {
            if (this.shootProofActions.length && this.picTimeActions.length) {
                return 'CONNECTED TO PIC-TIME & SHOOTPROOF';
            } else if (this.shootProofActions.length) {
                return 'CONNECTED TO SHOOTPROOF';
            } else if (this.picTimeActions.length) {
                return 'CONNECTED TO PIC-TIME';
            }
            return '';
        }
    }, {
        key: "successGetShootProofGalleries",
        value: function successGetShootProofGalleries(data) {
            if (data.data.shootProofGalleryLayout) {
                var _resultArrayGalleries2;

                var _data$data$shootProof = data.data.shootProofGalleryLayout,
                    avalibleActions = _data$data$shootProof.avalibleActions,
                    galleries = _data$data$shootProof.galleries;

                this.shootProofActions = avalibleActions.reverse();
                this.shootProofGalleries = galleries;
                (_resultArrayGalleries2 = this.resultArrayGalleries).push.apply(_resultArrayGalleries2, _toConsumableArray(galleries));
            } else {
                this.shootProofActions = [];
                this.shootProofGalleries = [];
            }
            this.shootProofState = data.data.state;
        }
    }, {
        key: "successGetPicTimeActions",
        value: function successGetPicTimeActions(data) {
            if (data.data.ptGalleryLayout) {
                var availableActions = data.data.ptGalleryLayout.availableActions;

                this.picTimeActions = availableActions.reverse();
            } else {
                this.picTimeActions = [];
            }
            if (data.data.state === 'ENABLED') {
                this.getPicTimeGalleries();
            }
            this.picTimeState = data.data.state;
        }
    }, {
        key: "showDeleteModal",
        value: function showDeleteModal(gallery) {
            this.availableActionsForGallery = gallery.availableActions;
            this.galleryIdForDelete = gallery.id;
            this.deleteGalleryModalRef = this.modalService.openModal(delete_gallery_modal_1.DeleteGalleryModal, {
                windowClass: 'ng-bootstrap-modal__small gallery-delete-modal'
            });
            this.deleteGalleryModalRef.componentInstance.deleteGalleryId = gallery.id;
            this.deleteGalleryModalRef.componentInstance.actions = gallery.availableActions;
            this.deleteGalleryModalRef.componentInstance.picTimeActions = gallery.actions;
        }
    }, {
        key: "showAddGalleryModal",
        value: function showAddGalleryModal() {
            this.addGalleryModalRef = this.modalService.openModal(add_gallery_modal_1.AddGalleryModal, {
                windowClass: 'ng-bootstrap-modal__small'
            });
            this.addGalleryModalRef.componentInstance.shootProofActions = this.shootProofActions;
            this.addGalleryModalRef.componentInstance.picTimeActions = this.picTimeActions;
            this.addGalleryModalRef.componentInstance.shootProofBrands = this.shootProofBrands;
            this.addGalleryModalRef.componentInstance.jobId = this.jobId;
            this.addGalleryModalRef.componentInstance.mainShootDate = this.mainShootDate;
            this.addGalleryModalRef.componentInstance.jobName = this.jobName;
            this.addGalleryModalRef.componentInstance.job = this.job;
        }
    }, {
        key: "setVariables",
        value: function setVariables() {
            var _job = this.job,
                id = _job.id,
                name = _job.name,
                finishDate = _job.finishDate;

            this.jobId = id;
            this.jobName = name;
            this.mainShootDate = finishDate;
        }
    }]);

    return GalleryViewBlockComponent;
}();
__decorate([core_1.Input('job'), __metadata("design:type", Object)], GalleryViewBlockComponent.prototype, "job", void 0);
GalleryViewBlockComponent = __decorate([core_1.Component({
    selector: 'gallery-view-block',
    template: __webpack_require__("./web/modern/components/integrations/connect-galleries/gallery-view-block/gallery-view-block.component.html"),
    styles: [__webpack_require__("./web/modern/components/integrations/connect-galleries/gallery-view-block/gallery-view-block.component.scss")]
}), __metadata("design:paramtypes", [shootProof_data_service_1.ShootProofDataProvider, pickTime_data_service_1.PickTimeDataProvider, message_service_1.MessageService, snModal_service_1.SNModalService, settings_1.SettingsProvider, integrations_service_1.IntegrationsServiceProvider])], GalleryViewBlockComponent);
exports.GalleryViewBlockComponent = GalleryViewBlockComponent;

/***/ }),

/***/ "./web/modern/components/integrations/connect-galleries/modals/add-gallery-modal/add-gallery.modal.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header pt-pb-15\">\n    <button class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" (click)=\"onDismiss()\">&times;</button>\n    <h3 class=\"modal-title\">Add New Gallery</h3>\n</div>\n<div class=\"modal-body add-new-modal add-new-list\" style=\"padding-bottom: 0!important\">\n    <ng-container *ngFor=\"let action of shootProofActions\">\n        <div class=\"add-new-item\" *ngIf=\"action === 'CREATE_NEW'\"  [ngClass]=\"{'add-new-item-disabled': disableShootProofModals }\" (click)=\"showCreateNewShootProofGalleryModal()\">\n            <i class=\"fi fi-shootproof-icon mr-20 mr-20\"></i>\n            <div>\n                <h2 class=\"an-item-title\">Create New ShootProof Gallery</h2>\n                <div class=\"an-item-description\">Create a new ShootProof gallery from scratch.</div>\n            </div>\n        </div>\n        <div class=\"add-new-item\" *ngIf=\"action === 'IMPORT_EXIST'\" [ngClass]=\"{'add-new-item-disabled': disableShootProofModals }\" (click)=\"showSelectExistingShootProofGalleryModal()\" >\n            <i class=\"fi fi-shootproof-icon mr-20 mr-18\"></i>\n            <div>\n                <h2 class=\"an-item-title\">Select Existing ShootProof Gallery</h2>\n                <div class=\"an-item-description\">Select from an existing list of ShootProof galleries.</div>\n            </div>\n        </div>\n    </ng-container>\n    <ng-container *ngFor=\"let action of picTimeActions\">\n        <div class=\"add-new-item\" *ngIf=\"action === 'CREATE_NEW'\"  [ngClass]=\"{'add-new-item-disabled': disablePicTimeModals }\" (click)=\"showCreateNewPicTimeGalleryModal()\">\n            <i class=\"fi fi-pic-time-small mr-20 mr-20\"></i>\n            <div>\n                <h2 class=\"an-item-title\">Create New Pic-Time Gallery</h2>\n                <div class=\"an-item-description\">Create a new Pic-Time gallery from scratch.</div>\n            </div>\n        </div>\n        <div class=\"add-new-item\" *ngIf=\"action === 'IMPORT_EXISTED'\" [ngClass]=\"{'add-new-item-disabled': disablePicTimeModals }\" (click)=\"showSelectExistingPicTimeGalleryModal()\" >\n            <i class=\"fi fi-pic-time-small mr-20 mr-18\"></i>\n            <div>\n                <h2 class=\"an-item-title\">Select Existing Pic-Time Gallery</h2>\n                <div class=\"an-item-description\">Select from an existing list of Pic-Time galleries.</div>\n            </div>\n        </div>\n    </ng-container>\n</div>\n"

/***/ }),

/***/ "./web/modern/components/integrations/connect-galleries/modals/add-gallery-modal/add-gallery.modal.scss":
/***/ (function(module, exports) {

module.exports = ""

/***/ }),

/***/ "./web/modern/components/integrations/connect-galleries/modals/add-gallery-modal/add-gallery.modal.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var shootProof_data_service_1 = __webpack_require__("./shared/services/integrations/shootProof/shootProof.data.service.ts");
var ng_bootstrap_1 = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/index.js");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var select_existing_gallery_modal_1 = __webpack_require__("./web/modern/components/integrations/connect-galleries/modals/select-existing-gallery-modal/select-existing-gallery.modal.ts");
var create_new_gallery_modal_1 = __webpack_require__("./web/modern/components/integrations/connect-galleries/modals/create-new-gallery-modal/create-new-gallery.modal.ts");
var pickTime_data_service_1 = __webpack_require__("./shared/services/integrations/pickTime/pickTime.data.service.ts");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var forkJoin_1 = __webpack_require__("./node_modules/rxjs/observable/forkJoin.js");
var AddGalleryModal = function () {
    function AddGalleryModal(shootProofDataService, pickTimeDataProvider, picTimeDataResponse, messageService, activeModal, modalService) {
        _classCallCheck(this, AddGalleryModal);

        this.shootProofDataService = shootProofDataService;
        this.pickTimeDataProvider = pickTimeDataProvider;
        this.picTimeDataResponse = picTimeDataResponse;
        this.messageService = messageService;
        this.activeModal = activeModal;
        this.modalService = modalService;
        this.shootProofBrands = [];
        this.picTimeGalleries = [];
        this.disableShootProofModals = false;
        this.disablePicTimeModals = false;
        this.unsubscribe = new Subject_1.Subject();
    }

    _createClass(AddGalleryModal, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            if (this.shootProofActions.length) {
                this.getBrandsForGalleries();
            }
            if (this.picTimeActions.length) {
                this.initPicTime();
            }
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "showSelectExistingShootProofGalleryModal",
        value: function showSelectExistingShootProofGalleryModal() {
            this.activeModal.close();
            this.selectGalleryModalRef = this.modalService.openModal(select_existing_gallery_modal_1.SelectExistingGalleryModal, {
                windowClass: 'ng-bootstrap-modal-small'
            });
            this.selectGalleryModalRef.componentInstance.shootProofBrands = this.shootProofBrands;
            this.selectGalleryModalRef.componentInstance.jobId = this.jobId;
        }
    }, {
        key: "showSelectExistingPicTimeGalleryModal",
        value: function showSelectExistingPicTimeGalleryModal() {
            this.activeModal.close();
            this.selectGalleryModalRef = this.modalService.openModal(select_existing_gallery_modal_1.SelectExistingGalleryModal, {
                windowClass: 'ng-bootstrap-modal-small pic-time-select-modal'
            });
            this.selectGalleryModalRef.componentInstance.jobId = this.jobId;
            this.selectGalleryModalRef.componentInstance.picTimeGalleriesMetadata = this.picTimeGalleriesMetadata;
        }
    }, {
        key: "showCreateNewShootProofGalleryModal",
        value: function showCreateNewShootProofGalleryModal() {
            this.activeModal.close();
            this.createGalleryModalRef = this.modalService.openModal(create_new_gallery_modal_1.CreateNewGalleryModal, {
                windowClass: 'ng-bootstrap-modal-small'
            });
            this.createGalleryModalRef.componentInstance.shootProofBrands = this.shootProofBrands;
            this.createGalleryModalRef.componentInstance.jobId = this.jobId;
            this.createGalleryModalRef.componentInstance.mainShootDate = this.mainShootDate;
            this.createGalleryModalRef.componentInstance.jobName = this.jobName;
        }
    }, {
        key: "showCreateNewPicTimeGalleryModal",
        value: function showCreateNewPicTimeGalleryModal() {
            this.activeModal.close();
            this.createGalleryModalRef = this.modalService.openModal(create_new_gallery_modal_1.CreateNewGalleryModal, {
                windowClass: 'ng-bootstrap-modal-small modal-visible'
            });
            this.createGalleryModalRef.componentInstance.jobId = this.jobId;
            this.createGalleryModalRef.componentInstance.mainShootDate = this.mainShootDate;
            this.createGalleryModalRef.componentInstance.jobMetaData = this.jobMetaData;
            this.createGalleryModalRef.componentInstance.picTimeTemplates = this.picTimeTemplates;
            this.createGalleryModalRef.componentInstance.clientList = this.createClientList(this.job);
        }
    }, {
        key: "initPicTime",
        value: function initPicTime() {
            var _this = this;

            this.disablePicTimeModals = true;
            forkJoin_1.forkJoin([this.pickTimeDataProvider.getJobMetadata(this.jobId).pipe(operators_1.takeUntil(this.unsubscribe)), this.pickTimeDataProvider.getPicTimeTemplates().pipe(operators_1.takeUntil(this.unsubscribe)), this.pickTimeDataProvider.getImportPicTimeGalleries().pipe(operators_1.takeUntil(this.unsubscribe))]).subscribe(function (data) {
                _this.jobMetaData = data[0].data;
                _this.picTimeTemplates = data[1].data;
                _this.picTimeGalleriesMetadata = data[2].data;
            }, function (error) {
                return _this.messageService.handleError(error);
            }, function () {
                _this.disablePicTimeModals = false;
            });
        }
    }, {
        key: "getBrandsForGalleries",
        value: function getBrandsForGalleries() {
            var _this2 = this;

            this.disableShootProofModals = true;
            this.shootProofDataService.getBrandsForGalleriesV1().pipe(operators_1.takeUntil(this.unsubscribe), operators_1.finalize(function () {
                return _this2.disableShootProofModals = false;
            })).subscribe(function (data) {
                return _this2.shootProofBrands = data.data;
            }, function (error) {
                _this2.messageService.handleError(error);
                _this2.activeModal.dismiss();
            });
        }
    }, {
        key: "onDismiss",
        value: function onDismiss() {
            this.activeModal.close();
        }
    }, {
        key: "createClientList",
        value: function createClientList(job) {
            var primaryContact = job.primaryContact,
                secondaryContact = job.secondaryContact;

            var list = [];
            var addContractToList = function addContractToList(contact) {
                return {
                    name: contact.firstName + (contact.lastName ? " " + contact.lastName : ''),
                    email: contact.email
                };
            };
            if (primaryContact) {
                list.push(addContractToList(primaryContact));
            }
            if (secondaryContact) {
                list.push(addContractToList(secondaryContact));
            }
            return list;
        }
    }]);

    return AddGalleryModal;
}();
__decorate([core_1.Input('shootProofActions'), __metadata("design:type", Object)], AddGalleryModal.prototype, "shootProofActions", void 0);
__decorate([core_1.Input('picTimeActions'), __metadata("design:type", Object)], AddGalleryModal.prototype, "picTimeActions", void 0);
__decorate([core_1.Input('jobId'), __metadata("design:type", Object)], AddGalleryModal.prototype, "jobId", void 0);
__decorate([core_1.Input('mainShootDate'), __metadata("design:type", Object)], AddGalleryModal.prototype, "mainShootDate", void 0);
__decorate([core_1.Input('jobName'), __metadata("design:type", Object)], AddGalleryModal.prototype, "jobName", void 0);
__decorate([core_1.Input('job'), __metadata("design:type", Object)], AddGalleryModal.prototype, "job", void 0);
AddGalleryModal = __decorate([core_1.Component({
    selector: 'add-gallery-modal',
    template: __webpack_require__("./web/modern/components/integrations/connect-galleries/modals/add-gallery-modal/add-gallery.modal.html"),
    styles: [__webpack_require__("./web/modern/components/integrations/connect-galleries/modals/add-gallery-modal/add-gallery.modal.scss")]
}), __metadata("design:paramtypes", [shootProof_data_service_1.ShootProofDataProvider, pickTime_data_service_1.PickTimeDataProvider, pickTime_data_service_1.PickTimeDataProvider, message_service_1.MessageService, ng_bootstrap_1.NgbActiveModal, snModal_service_1.SNModalService])], AddGalleryModal);
exports.AddGalleryModal = AddGalleryModal;

/***/ }),

/***/ "./web/modern/components/integrations/connect-galleries/modals/create-new-gallery-modal/create-new-gallery.modal.html":
/***/ (function(module, exports) {

module.exports = "<form class=\"form form-horizontal\" role=\"form\">\n    <div class=\"modal-header pt-pb-15\">\n        <button class=\"close\" data-dismiss=\"modal\" (click)=\"dismiss()\" aria-hidden=\"true\">&times;</button>\n        <h3 class=\"modal-title\">Create New {{ shootProofBrands ? 'ShootProof' : 'Pic-Time' }} Gallery</h3>\n    </div>\n    <div class=\"modal-body add-new-modal add-new-list\">\n        <div *ngIf=\"shootProofBrands\">\n            <div class=\"field-info\">\n                <p class=\"mb-6\">Name</p>\n                <input type=\"text\" maxlength=\"100\" class=\"form-control flex-row\" name=\"name\" [(ngModel)]=\"name\" required>\n            </div>\n            <div class=\"field-info\">\n                <p class=\"mb-6\">Brand</p>\n                <div class=\"flex-row\">\n                    <div class=\"select-style flex-grow-1\">\n                        <select class=\"form-control\" [ngModel]=\"selectedBrandId\" (ngModelChange)=\"selectBrand($event)\" required name=\"GalleriesBrands\" >\n                            <option [attr.selected]=\"selectedBrandId == -1 ? 'selected' : null\" [value]=\"-1\">Choose Brand</option>\n                            <option *ngFor=\"let brand of shootProofBrands\" [value]=\"brand.spBrandId\" >{{ brand.name }}</option>\n                        </select>\n                    </div>\n                </div>\n            </div>\n            <div class=\"field-info\">\n                <p class=\"mb-6\">Gallery Preset</p>\n                <div class=\"flex-row\">\n                    <div class=\"select-style flex-grow-1\">\n                        <select class=\"form-control\" [ngModel]=\"selectedPresetId\" (ngModelChange)=\"selectPreset($event)\" name=\"GalleriesPresets\" [disabled]=\"disabledGalleryPresetSelect\">\n                            <option *ngFor=\"let preset of galleryPresets\" [value]=\"preset.id\" [attr.selected]=\"preset.id == -1 ? 'selected' : null\"  >{{ preset.name }}</option>\n                        </select>\n                    </div>\n                </div>\n            </div>\n            <div class=\"field-info field-info-half-with\">\n                <p class=\"mb-6\">Date</p>\n                <div class=\"box-no-transition\">\n                    <sn-date-picker [options]=\"'shootproof options' | snDatePickerConfig\"\n                                    [placeholder]=\"datePlaceHolder\"\n                                    name=\"galleryDate\"\n                                    snDatePickerValidator\n                                    [(ngModel)]=\"eventDate\"\n                    ></sn-date-picker>\n                </div>\n            </div>\n        </div>\n\n        <div *ngIf=\"!shootProofBrands\">\n            <div *ngIf=\"picTimeBrands.length > 1\" class=\"field-info\">\n                <p class=\"mb-6\">Brand</p>\n                <div class=\"flex-row\">\n                    <div class=\"select-style flex-grow-1\">\n                        <select class=\"form-control\" name=\"selectedBrandId\" [(ngModel)]=\"selectedBrandId\" (ngModelChange)=\"selectPicTimeBrand($event)\" required>\n                            <option disabled selected hidden [value]=\"-1\">Choose Brand</option>\n                            <option *ngFor=\"let brand of picTimeBrands\" [value]=\"brand.brandId\" >{{ brand.brandName }}</option>\n                        </select>\n                    </div>\n                </div>\n            </div>\n\n            <div class=\"field-info\">\n                <p class=\"mb-6\">Project Name</p>\n                <input type=\"text\" maxlength=\"100\" class=\"form-control flex-row\" name=\"galleryName\" [(ngModel)]=\"galleryName\" required>\n            </div>\n\n            <div class=\"field-info\">\n                <p class=\"mb-6\">Project URL</p>\n                <div class=\"project-url\">\n                    <div [ngClass]=\"(staticBrandId === -1 && selectedBrandId === -1) ? 'no-brand' : ''\" class=\"form-control flex-row hardcoded-string\">{{ hardcodedString }}</div>\n                    <div class=\"dynamic-string\">\n                        <input type=\"text\" maxlength=\"100\" [value]=\"changeableString\" [disabled]=\"staticBrandId === -1 && selectedBrandId === -1\" [ngClass]=\"(staticBrandId === -1 && selectedBrandId === -1) ? 'no-brand' : ''\" class=\"form-control flex-row changeable-string\" name=\"changeableString\" [(ngModel)]=\"changeableString\" required>\n                    </div>\n                </div>\n            </div>\n\n            <div *ngIf=\"picTimeTemplates.length !== 0\" class=\"field-info\">\n                <p class=\"mb-6\">Project Template</p>\n                <div class=\"flex-row\">\n                    <div class=\"select-style flex-grow-1\">\n                        <select class=\"form-control\" [(ngModel)]=\"selectedTemplateId\" name=\"selectedTemplateId\">\n                            <option [value]=\"-1\">Choose Template</option>\n                            <option *ngFor=\"let template of picTimeTemplates\" [value]=\"template.ptTemplateId\">{{ template.name }}</option>\n                        </select>\n                    </div>\n                </div>\n            </div>\n\n            <div class=\"field-info\">\n                <p class=\"mb-6\">Project Date</p>\n                <div class=\"flex-row datepicker-static\">\n                    <sn-date-picker class=\"w-200\" [options]=\"'options' | snDatePickerConfig\"\n                                    [placeholder]=\"datePlaceHolder\" [(ngModel)]=\"dateTaken\"\n                                    name=\"galleryDate\"\n                                    snDatePickerValidator></sn-date-picker>\n                </div>\n            </div>\n\n        </div>\n    </div>\n    <div class=\"modal-footer left\">\n        <button class=\"btn btn-success btn-submit pull-left mb--8\" type=\"submit\" [disabled]=\"submitDisable\"  spinning-wheel [is-spinning-wheel-active]=\"submitDisable\" (click)=\"onSubmit()\">\n            Save Gallery\n        </button>\n    </div>\n</form>\n"

/***/ }),

/***/ "./web/modern/components/integrations/connect-galleries/modals/create-new-gallery-modal/create-new-gallery.modal.scss":
/***/ (function(module, exports) {

module.exports = ":host .field-info-half-with {\n  width: 50%; }\n\n.project-url {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: row;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-flex-wrap: nowrap;\n      -ms-flex-wrap: nowrap;\n          flex-wrap: nowrap; }\n  .project-url .hardcoded-string {\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -webkit-align-items: center;\n        -ms-flex-align: center;\n            align-items: center;\n    border-right: none;\n    padding-right: 0;\n    width: auto;\n    color: #96979b; }\n  .project-url .dynamic-string {\n    -webkit-box-flex: 1;\n    -webkit-flex: 1 1;\n        -ms-flex: 1 1;\n            flex: 1 1; }\n  .project-url .changeable-string {\n    border-left: none;\n    padding-left: 0; }\n    .project-url .changeable-string:focus {\n      border: 1px solid #dce1e4 !important;\n      border-left: none !important; }\n\n.selected-brand {\n  line-height: 28px; }\n\n.no-brand {\n  background-color: #eee !important;\n  border-color: #d2d7db; }\n\n.select-style select {\n  height: auto; }\n"

/***/ }),

/***/ "./web/modern/components/integrations/connect-galleries/modals/create-new-gallery-modal/create-new-gallery.modal.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var settings_1 = __webpack_require__("./shared/services/settings/settings.ts");
var quote_update_service_1 = __webpack_require__("./shared/services/quote/quote-update.service.ts");
var time_service_1 = __webpack_require__("./shared/services/helpers/time-service/time.service.ts");
var shootProof_data_service_1 = __webpack_require__("./shared/services/integrations/shootProof/shootProof.data.service.ts");
var invoices_data_service_1 = __webpack_require__("./shared/services/invoice/invoices-data-service/invoices.data.service.ts");
var ng_bootstrap_1 = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/index.js");
var pickTime_data_service_1 = __webpack_require__("./shared/services/integrations/pickTime/pickTime.data.service.ts");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var integrations_service_1 = __webpack_require__("./shared/services/integrations/integrations.service.ts");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var confirm_general_modal_component_1 = __webpack_require__("./web/modern/components/common/confirm-general-modal/confirm-general-modal.component.ts");
var common_1 = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
var CreateNewGalleryModal = function () {
    function CreateNewGalleryModal(shootProofDataService, pickTimeDataProvider, messageService, settingsService, quoteUpdateService, timeService, invoiceDataService, activeModal, integrationService, modalService, location) {
        var _this = this;

        _classCallCheck(this, CreateNewGalleryModal);

        this.shootProofDataService = shootProofDataService;
        this.pickTimeDataProvider = pickTimeDataProvider;
        this.messageService = messageService;
        this.settingsService = settingsService;
        this.quoteUpdateService = quoteUpdateService;
        this.timeService = timeService;
        this.invoiceDataService = invoiceDataService;
        this.activeModal = activeModal;
        this.integrationService = integrationService;
        this.modalService = modalService;
        this.location = location;
        this.isBrandPristine = false;
        this.datePlaceHolder = '';
        this.staticBrandId = -1;
        this.selectedBrandId = -1;
        this.selectedPresetId = -1;
        this.submitDisable = false;
        this.spBrandThemeId = null;
        this.selectedTemplateId = -1;
        this.picTimeBrands = [];
        this.DEFAULT_GALLERY_PRESET = [{ id: -1, name: 'Choose Preset' }];
        this.LOADING_GALLERY_PRESET = [{ id: -1, name: 'Loading...' }];
        this.disabledGalleryPresetSelect = false;
        this.galleryPresets = this.DEFAULT_GALLERY_PRESET;
        this.unsubscribe = new Subject_1.Subject();
        location.onPopState(function () {
            return _this.activeModal.close();
        });
    }

    _createClass(CreateNewGalleryModal, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            if (!this.shootProofBrands) {
                this.initPicTimeMetadata();
            }
            this.getTimeSettings();
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "dismiss",
        value: function dismiss() {
            this.disabledGalleryPresetSelect = false;
            this.name = this.jobName;
            this.submitDisable = false;
            this.galleryPresets = this.DEFAULT_GALLERY_PRESET;
            this.shootProofBrands = [];
            this.eventDate = this._mainShootDate;
            this.staticBrandId = -1;
            this.selectedBrandId = -1;
            this.selectedPresetId = -1;
            this.selectedTemplateId = -1;
            this.picTimeTemplates = [];
            this.isBrandPristine = false;
            this.activeModal.close();
        }
    }, {
        key: "initPicTimeMetadata",
        value: function initPicTimeMetadata() {
            this.galleryName = this.jobMetaData.name;
            this.galleryMainShootDate = this.jobMetaData.mainShootDate;
            this.picTimeBrands = this.jobMetaData.brandDomainMetadata;
            this.dateTaken = this.jobMetaData.mainShootDate ? this.quoteUpdateService.setQuoteIssueDate(this.jobMetaData.mainShootDate) : null;
            if (this.picTimeBrands.length === 1) {
                this.staticBrandId = this.picTimeBrands[0].brandId;
                this.hardcodedString = "https://" + this.picTimeBrands[0].domain + "/-";
                this.changeableString = this.jobMetaData.name.toLowerCase();
            }
        }
    }, {
        key: "selectPicTimeBrand",
        value: function selectPicTimeBrand(brandId) {
            if (brandId != -1) {
                this.hardcodedString = "https://" + this.picTimeBrands.find(function (value) {
                    return value.brandId === brandId;
                }).domain + "/-";
                if (!this.isBrandPristine) {
                    this.changeableString = this.jobMetaData.name.toLowerCase();
                    this.isBrandPristine = true;
                }
            } else {
                this.selectedBrandId = -1;
                this.hardcodedString = '';
                this.changeableString = '';
            }
        }
    }, {
        key: "selectBrand",
        value: function selectBrand(brandId) {
            if (brandId != -1) {
                this.selectedBrandId = brandId;
                this.getPresets(brandId);
                this.getSelectedBrandThemeId();
            } else {
                this.selectedBrandId = -1;
                this.selectedPresetId = -1;
                this.galleryPresets = this.DEFAULT_GALLERY_PRESET;
            }
        }
    }, {
        key: "selectPreset",
        value: function selectPreset(presetId) {
            this.selectedPresetId = presetId;
        }
    }, {
        key: "getSelectedBrandThemeId",
        value: function getSelectedBrandThemeId() {
            var _this2 = this;

            this.shootProofBrands.forEach(function (item) {
                if (_this2.selectedBrandId == item.spBrandId) {
                    _this2.spBrandThemeId = item.spHomeBrandThemeId;
                }
            });
        }
    }, {
        key: "getPresets",
        value: function getPresets(BrandId) {
            var _this3 = this;

            this.disabledGalleryPresetSelect = true;
            this.galleryPresets = this.LOADING_GALLERY_PRESET;
            this.shootProofDataService.getGalleryPresetsV1(BrandId).finally(function () {
                return _this3.disabledGalleryPresetSelect = false;
            }).subscribe(function (data) {
                _this3.galleryPresets = _this3.DEFAULT_GALLERY_PRESET.concat(data.data);
            }, function (error) {
                _this3.galleryPresets = _this3.DEFAULT_GALLERY_PRESET;
                _this3.messageService.showDefaultErrorMessage(error);
            });
        }
    }, {
        key: "getTimeSettings",
        value: function getTimeSettings() {
            var _this4 = this;

            this.settingsService.timeFormatSettings.subscribe(function (data) {
                switch (data.dateFormat) {
                    case 'DD_MM_YYYY':
                        _this4.datePlaceHolder = 'dd/mm/yyyy';
                        break;
                    case 'MM_DD_YYYY':
                        _this4.datePlaceHolder = 'mm/dd/yyyy';
                        break;
                    default:
                        _this4.datePlaceHolder = '';
                        break;
                }
            });
        }
    }, {
        key: "validationCreateNewGallery",
        value: function validationCreateNewGallery() {
            var validation = true;
            if (!this.name || this.name.trim() === '') {
                validation = false;
                this.messageService.showErrorFromBackend('Oh Shoot!', 'Please enter a name for your new gallery.');
            } else if (this.selectedBrandId === -1) {
                validation = false;
                this.messageService.showErrorFromBackend('Oh Shoot!', 'Please select a brand for your new gallery.');
            } else if (!this.eventDate || this.eventDate === null) {
                validation = false;
                this.messageService.showErrorFromBackend('Oh Shoot!', 'Please enter a shoot date for your new gallery.');
            }
            return validation;
        }
    }, {
        key: "validatePicTimeGalleryCreation",
        value: function validatePicTimeGalleryCreation() {
            if (this.staticBrandId === -1 && this.selectedBrandId === -1) {
                this.messageService.showToaster('e_7', 'picTime');
                return false;
            } else if (this.galleryName.length === 0) {
                this.messageService.showToaster('e_0', 'picTime');
                return false;
            } else if (this.changeableString.length === 0) {
                this.messageService.showToaster('e_1', 'picTime');
                return false;
            } else if (!this.validateProjectUrl()) {
                this.messageService.showToaster('e_3', 'picTime');
                return false;
            } else if (!this.dateTaken) {
                this.messageService.showToaster('e_8', 'picTime');
                return false;
            }
            return true;
        }
    }, {
        key: "validateProjectUrl",
        value: function validateProjectUrl() {
            var regex = /[a-z0-9\\_\\]+$/;
            if (!this.changeableString.match(regex)) {
                return false;
            }
            return true;
        }
    }, {
        key: "onSubmit",
        value: function onSubmit() {
            var _this5 = this;

            if (this.shootProofBrands) {
                if (!this.validationCreateNewGallery()) {
                    return;
                }
                var settings = {
                    jobId: this.jobId,
                    spBrandId: +this.selectedBrandId,
                    eventDate: this.timeService.getDateInFormat(this.eventDate.jsdate, 'date'),
                    name: this.name,
                    galleryPresetId: this.selectedPresetId !== -1 ? +this.selectedPresetId : null,
                    spBrandThemeId: this.spBrandThemeId
                };
                this.submitDisable = true;
                this.shootProofDataService.createShootProofNewGalleryFromSNV1(settings).pipe(operators_1.finalize(function () {
                    return _this5.submitDisable = false;
                })).subscribe(function () {
                    return _this5.successCreateNewShootProofGallery();
                }, function (error) {
                    return _this5.messageService.handleError(error);
                });
            } else {
                if (!this.validatePicTimeGalleryCreation()) {
                    return;
                }
                this.projectUrl = this.hardcodedString + this.changeableString;
                var createPicTimeGallery = {
                    galleryName: this.galleryName,
                    virtualPath: this.changeableString,
                    templateId: this.selectedTemplateId !== -1 ? this.selectedTemplateId : null,
                    brandId: this.staticBrandId !== -1 ? this.staticBrandId : this.selectedBrandId,
                    dateTaken: this.dateTaken ? this.timeService.getDateInFormat(this.dateTaken.jsdate, 'date') : null
                };
                this.confirmApplyingClientData().then(function () {
                    createPicTimeGallery.clientList = _this5.clientList;
                    _this5.savePicTimeGallery(createPicTimeGallery);
                }).catch(function () {
                    return _this5.savePicTimeGallery(createPicTimeGallery);
                });
            }
        }
    }, {
        key: "savePicTimeGallery",
        value: function savePicTimeGallery(galleryPayload) {
            var _this6 = this;

            this.submitDisable = true;
            this.pickTimeDataProvider.createPicTimeGallery(this.jobId, galleryPayload).pipe(operators_1.takeUntil(this.unsubscribe), operators_1.finalize(function () {
                return _this6.submitDisable = false;
            })).subscribe(function (data) {
                return _this6.successCreateNewPicTimeGallery(data.data);
            }, function (error) {
                return _this6.messageService.handleError(error);
            });
        }
    }, {
        key: "successCreateNewShootProofGallery",
        value: function successCreateNewShootProofGallery() {
            this.messageService.showToaster('s_1', 'shootProof');
            this.invoiceDataService.emitInvoiceUpdateEvent('UPDATE_SP_INVOICES');
            this.dismiss();
            this.integrationService.emitGalleriesUpdateEvent('UPDATE_SN_GALLERIES');
        }
    }, {
        key: "successCreateNewPicTimeGallery",
        value: function successCreateNewPicTimeGallery(data) {
            this.messageService.showToaster('s_3', 'picTime');
            this.invoiceDataService.emitInvoiceUpdateEvent('UPDATE_PT_INVOICES');
            this.dismiss();
            this.integrationService.emitGalleriesUpdateEvent('UPDATE_SN_GALLERIES');
            window.open(data.configureGalleryUrl, '_blank');
        }
    }, {
        key: "confirmApplyingClientData",
        value: function confirmApplyingClientData() {
            var _this7 = this;

            return new Promise(function (resolve, reject) {
                var modal = _this7.modalService.openModal(confirm_general_modal_component_1.ConfirmGeneralModalComponent, {
                    windowClass: 'ng-bootstrap-modal-small modal-visible modal-narrow'
                });
                modal.componentInstance.text = _this7.integrationService.createTextForApplyConfirm(_this7.clientList);
                modal.componentInstance.htmlText = true;
                modal.componentInstance.buttons = [{
                    text: 'Yes',
                    size: 'lg',
                    color: 'success',
                    action: 'APPLY_AND_SAVE'
                }, {
                    text: 'No',
                    size: 'lg',
                    color: 'default',
                    action: 'DISCARD_AND_SAVE'
                }, {
                    text: 'Cancel',
                    size: 'lg',
                    color: 'default',
                    action: 'DISCARD'
                }];
                modal.result.then(function (action) {
                    if (action === 'APPLY_AND_SAVE') {
                        resolve();
                    }
                    if (action === 'DISCARD_AND_SAVE') {
                        reject();
                    }
                    if (action === 'DISCARD') {
                        _this7.modalService.closeActiveModal();
                    }
                });
            });
        }
    }, {
        key: "jobName",
        set: function set(value) {
            this.name = value;
            this._jobName = value;
        },
        get: function get() {
            return this._jobName;
        }
    }, {
        key: "mainShootDate",
        set: function set(value) {
            this.eventDate = value === null ? null : this.quoteUpdateService.setQuoteIssueDate(value);
            this._mainShootDate = value === null ? null : this.quoteUpdateService.setQuoteIssueDate(value);
        },
        get: function get() {
            return this.eventDate;
        }
    }]);

    return CreateNewGalleryModal;
}();
__decorate([core_1.Input('shootProofBrands'), __metadata("design:type", Array)], CreateNewGalleryModal.prototype, "shootProofBrands", void 0);
__decorate([core_1.Input('jobId'), __metadata("design:type", Number)], CreateNewGalleryModal.prototype, "jobId", void 0);
__decorate([core_1.Input('jobMetaData'), __metadata("design:type", Object)], CreateNewGalleryModal.prototype, "jobMetaData", void 0);
__decorate([core_1.Input('picTimeTemplates'), __metadata("design:type", Array)], CreateNewGalleryModal.prototype, "picTimeTemplates", void 0);
__decorate([core_1.Input('clientList'), __metadata("design:type", Array)], CreateNewGalleryModal.prototype, "clientList", void 0);
__decorate([core_1.Input('jobName'), __metadata("design:type", Object), __metadata("design:paramtypes", [Object])], CreateNewGalleryModal.prototype, "jobName", null);
__decorate([core_1.Input('mainShootDate'), __metadata("design:type", Object), __metadata("design:paramtypes", [Object])], CreateNewGalleryModal.prototype, "mainShootDate", null);
CreateNewGalleryModal = __decorate([core_1.Component({
    selector: 'create-new-gallery-modal',
    template: __webpack_require__("./web/modern/components/integrations/connect-galleries/modals/create-new-gallery-modal/create-new-gallery.modal.html"),
    styles: [__webpack_require__("./web/modern/components/integrations/connect-galleries/modals/create-new-gallery-modal/create-new-gallery.modal.scss")]
}), __metadata("design:paramtypes", [shootProof_data_service_1.ShootProofDataProvider, pickTime_data_service_1.PickTimeDataProvider, message_service_1.MessageService, settings_1.SettingsProvider, quote_update_service_1.QuoteUpdateService, time_service_1.TimeServiceProvider, invoices_data_service_1.InvoicesDataProvider, ng_bootstrap_1.NgbActiveModal, integrations_service_1.IntegrationsServiceProvider, snModal_service_1.SNModalService, common_1.PlatformLocation])], CreateNewGalleryModal);
exports.CreateNewGalleryModal = CreateNewGalleryModal;

/***/ }),

/***/ "./web/modern/components/integrations/connect-galleries/modals/delete-confirmation-modal/delete-confirmation.modal.html":
/***/ (function(module, exports) {

module.exports = "<form class=\"form-horizontal\" role=\"form\">\n    <div class=\"modal-body\">\n        <p class=\"modal-description mt-10\">Deleting this gallery from Studio Ninja will also delete the gallery from ShootProof. Are you sure?\n        </p>\n        <div class=\"flex flex-align \">\n            <button type=\"button\" class=\"btn btn-lg btn-danger mb-0 mt-10 mr-15\" (click)=\"deleteGalleryFromShootProofAdnSN()\" spinning-wheel [is-spinning-wheel-active]=\"deleteGalleryFromShootProofAndSNSpinner\" [disabled]=\"deleteGalleryFromShootProofAndSNSpinner\">\n                Delete Gallery\n            </button>\n            <button type=\"button\" class=\"btn btn-lg btn-cancel btn-default mt-10 mb-0\" [disabled]=\"deleteGalleryFromShootProofAndSNSpinner\" (click)=\"onDismiss()\" data-dismiss=\"modal\">\n                Don't Delete\n            </button>\n        </div>\n    </div>\n</form>"

/***/ }),

/***/ "./web/modern/components/integrations/connect-galleries/modals/delete-confirmation-modal/delete-confirmation.modal.scss":
/***/ (function(module, exports) {

module.exports = ""

/***/ }),

/***/ "./web/modern/components/integrations/connect-galleries/modals/delete-confirmation-modal/delete-confirmation.modal.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var shootProof_data_service_1 = __webpack_require__("./shared/services/integrations/shootProof/shootProof.data.service.ts");
var ng_bootstrap_1 = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/index.js");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var DeleteConfirmationModal = function () {
    function DeleteConfirmationModal(shootProofDataService, messageService, activeModal) {
        _classCallCheck(this, DeleteConfirmationModal);

        this.shootProofDataService = shootProofDataService;
        this.messageService = messageService;
        this.activeModal = activeModal;
        this.deleteGalleryFromShootProofAndSNSpinner = false;
    }

    _createClass(DeleteConfirmationModal, [{
        key: "deleteGalleryFromShootProofAdnSN",
        value: function deleteGalleryFromShootProofAdnSN() {
            this.deleteGalleryFromShootProofAndSNSpinner = true;
            this.deleteGallery();
        }
    }, {
        key: "onDismiss",
        value: function onDismiss() {
            this.activeModal.close(false);
        }
    }, {
        key: "deleteGallery",
        value: function deleteGallery() {
            var _this = this;

            this.shootProofDataService.removeJobGalleryV1(this.deleteGalleryId, true).pipe(operators_1.finalize(function () {
                return _this.deleteGalleryFromShootProofAndSNSpinner = false;
            })).subscribe(function () {
                return _this.successDeleteGallery();
            }, function (error) {
                return _this.messageService.handleError(error);
            });
        }
    }, {
        key: "successDeleteGallery",
        value: function successDeleteGallery() {
            this.activeModal.close();
            this.messageService.showToaster('s_5', 'shootProof');
        }
    }, {
        key: "deleteGalleryId",
        set: function set(value) {
            this._deleteGalleryId = value;
        },
        get: function get() {
            return this._deleteGalleryId;
        }
    }]);

    return DeleteConfirmationModal;
}();
__decorate([core_1.Input('deleteGalleryId'), __metadata("design:type", Object), __metadata("design:paramtypes", [Object])], DeleteConfirmationModal.prototype, "deleteGalleryId", null);
DeleteConfirmationModal = __decorate([core_1.Component({
    selector: 'delete-confirmation-modal',
    template: __webpack_require__("./web/modern/components/integrations/connect-galleries/modals/delete-confirmation-modal/delete-confirmation.modal.html"),
    styles: [__webpack_require__("./web/modern/components/integrations/connect-galleries/modals/delete-confirmation-modal/delete-confirmation.modal.scss")]
}), __metadata("design:paramtypes", [shootProof_data_service_1.ShootProofDataProvider, message_service_1.MessageService, ng_bootstrap_1.NgbActiveModal])], DeleteConfirmationModal);
exports.DeleteConfirmationModal = DeleteConfirmationModal;

/***/ }),

/***/ "./web/modern/components/integrations/connect-galleries/modals/delete-gallery-modal/delete-gallery.modal.html":
/***/ (function(module, exports) {

module.exports = "<form class=\"form-horizontal\" role=\"form\">\n    <div class=\"modal-body\">\n        <p class=\"modal-description mt-10\" *ngIf=\"showDeleteFromSNBtn\">How do you want to delete this gallery?</p>\n        <p class=\"modal-description mt-10\" *ngIf=\"picTimeActions\">This will delete the gallery from Studio Ninja only. The gallery still exists in Pic-Time.</p>\n        <div class=\"flex-column\">\n            <button *ngIf=\"showDeleteFromSNBtn\"\n                    type=\"button\" class=\"btn btn-lg btn-danger mb-0 mt-10\" (click)=\"deleteGalleryFromSN()\" spinning-wheel [is-spinning-wheel-active]=\"deleteGalleryFromSNSpinner\" [disabled]=\"buttonsDisable\">\n                Delete from Studio Ninja only\n            </button>\n            <button *ngIf=\"showDeleteFromSPBtn\" type=\"button\" class=\"btn btn-lg btn-danger mb-0 mt-10\" (click)=\"openDeleteConfirmationModal()\" [disabled]=\"buttonsDisable\">\n                Delete from both Studio Ninja and ShootProof\n            </button>\n            <button *ngIf=\"picTimeActions?.DELETE_GALLERY\" type=\"button\" class=\"btn btn-lg btn-danger mb-0 mt-10\" (click)=\"deletePicTimeGallery()\" spinning-wheel [is-spinning-wheel-active]=\"deleteGalleryFromSNSpinner\" [disabled]=\"buttonsDisable\">\n                Disconnect Gallery from Studio Ninja\n            </button>\n            <button type=\"button\" (click)=\"dismiss()\" class=\"btn btn-lg btn-cancel btn-default mt-10 mb-0\" data-dismiss=\"modal\">\n                {{ picTimeActions?.DELETE_GALLERY ? \"Don't Disconnect\" : \"Don't Delete\" }}\n            </button>\n        </div>\n    </div>\n</form>\n"

/***/ }),

/***/ "./web/modern/components/integrations/connect-galleries/modals/delete-gallery-modal/delete-gallery.modal.scss":
/***/ (function(module, exports) {

module.exports = ""

/***/ }),

/***/ "./web/modern/components/integrations/connect-galleries/modals/delete-gallery-modal/delete-gallery.modal.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var shootProof_data_service_1 = __webpack_require__("./shared/services/integrations/shootProof/shootProof.data.service.ts");
var invoices_data_service_1 = __webpack_require__("./shared/services/invoice/invoices-data-service/invoices.data.service.ts");
var utils_service_1 = __webpack_require__("./shared/services/utils/utils-service.ts");
var ng_bootstrap_1 = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/index.js");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var delete_confirmation_modal_1 = __webpack_require__("./web/modern/components/integrations/connect-galleries/modals/delete-confirmation-modal/delete-confirmation.modal.ts");
var pickTime_data_service_1 = __webpack_require__("./shared/services/integrations/pickTime/pickTime.data.service.ts");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var integrations_service_1 = __webpack_require__("./shared/services/integrations/integrations.service.ts");
var DeleteGalleryModal = function () {
    function DeleteGalleryModal(shootProofDataService, pickTimeDataProvider, messageService, invoiceDataService, utilService, activeModal, modalService, integrationService) {
        _classCallCheck(this, DeleteGalleryModal);

        this.shootProofDataService = shootProofDataService;
        this.pickTimeDataProvider = pickTimeDataProvider;
        this.messageService = messageService;
        this.invoiceDataService = invoiceDataService;
        this.utilService = utilService;
        this.activeModal = activeModal;
        this.modalService = modalService;
        this.integrationService = integrationService;
        this.buttonsDisable = false;
        this.deleteGalleryFromSNSpinner = false;
        this.showDeleteFromSNBtn = true;
        this.showDeleteFromSPBtn = true;
        this.unsubscribe = new Subject_1.Subject();
    }

    _createClass(DeleteGalleryModal, [{
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "dismiss",
        value: function dismiss() {
            this.activeModal.close(false);
            this.removeSpinners();
        }
    }, {
        key: "deleteGalleryFromSN",
        value: function deleteGalleryFromSN() {
            this.deleteGalleryFromSNSpinner = true;
            this.deleteGallery();
        }
    }, {
        key: "openDeleteConfirmationModal",
        value: function openDeleteConfirmationModal() {
            var _this = this;

            this.activeModal.close();
            this.deleteConfirmationModalRef = this.modalService.openModal(delete_confirmation_modal_1.DeleteConfirmationModal, {
                windowClass: 'ng-bootstrap-modal__small gallery-delete-modal'
            });
            this.deleteConfirmationModalRef.componentInstance.deleteGalleryId = this.deleteGalleryId;
            this.deleteConfirmationModalRef.result.then(function () {
                _this.updateGalleriesEvent();
            });
        }
    }, {
        key: "deletePicTimeGallery",
        value: function deletePicTimeGallery() {
            var _this2 = this;

            this.buttonsDisable = true;
            this.deleteGalleryFromSNSpinner = true;
            var url = this.picTimeActions.DELETE_GALLERY.url;
            this.pickTimeDataProvider.deletePicTimeGallery(url).pipe(operators_1.takeUntil(this.unsubscribe), operators_1.finalize(function () {
                return _this2.removeSpinners();
            })).subscribe(function () {
                return _this2.successDeletePicTimeGallery();
            }, function (error) {
                return _this2.messageService.handleError(error);
            });
        }
    }, {
        key: "checkAvailableActions",
        value: function checkAvailableActions(actions) {
            if (actions && actions !== null) {
                this.showDeleteFromSNBtn = actions.hasOwnProperty('DELETE_FROM_SN') && actions.DELETE_FROM_SN.state === 'active';
                this.showDeleteFromSPBtn = actions.hasOwnProperty('DELETE_FROM_SP') && actions.DELETE_FROM_SP.state === 'active';
            } else {
                this.showDeleteFromSNBtn = false;
                this.showDeleteFromSPBtn = false;
            }
        }
    }, {
        key: "deleteGallery",
        value: function deleteGallery() {
            var _this3 = this;

            this.buttonsDisable = true;
            this.shootProofDataService.removeJobGalleryV1(this.deleteGalleryId, false).pipe(operators_1.finalize(function () {
                return _this3.removeSpinners();
            })).subscribe(function () {
                return _this3.successDeleteShootProofGallery();
            }, function (error) {
                return _this3.messageService.handleError(error);
            });
        }
    }, {
        key: "removeSpinners",
        value: function removeSpinners() {
            this.buttonsDisable = false;
            this.deleteGalleryFromSNSpinner = false;
        }
    }, {
        key: "successDeleteShootProofGallery",
        value: function successDeleteShootProofGallery() {
            this.updateGalleriesEvent();
            this.messageService.showToaster('s_5', 'shootProof');
            this.dismiss();
        }
    }, {
        key: "successDeletePicTimeGallery",
        value: function successDeletePicTimeGallery() {
            this.invoiceDataService.emitInvoiceUpdateEvent('UPDATE_PT_INVOICES');
            this.integrationService.emitGalleriesUpdateEvent('UPDATE_SN_GALLERIES');
            this.messageService.showToaster('s_4', 'picTime');
            this.dismiss();
        }
    }, {
        key: "updateGalleriesEvent",
        value: function updateGalleriesEvent() {
            this.invoiceDataService.emitInvoiceUpdateEvent('UPDATE_SP_INVOICES');
            this.integrationService.emitGalleriesUpdateEvent('UPDATE_SN_GALLERIES');
        }
    }, {
        key: "actions",
        set: function set(value) {
            this.checkAvailableActions(value);
            this._actions = value;
        },
        get: function get() {
            return this._actions;
        }
    }]);

    return DeleteGalleryModal;
}();
__decorate([core_1.Input('deleteGalleryId'), __metadata("design:type", Number)], DeleteGalleryModal.prototype, "deleteGalleryId", void 0);
__decorate([core_1.Input('picTimeActions'), __metadata("design:type", Object)], DeleteGalleryModal.prototype, "picTimeActions", void 0);
__decorate([core_1.Input('actions'), __metadata("design:type", Object), __metadata("design:paramtypes", [Object])], DeleteGalleryModal.prototype, "actions", null);
DeleteGalleryModal = __decorate([core_1.Component({
    selector: 'delete-gallery-modal',
    template: __webpack_require__("./web/modern/components/integrations/connect-galleries/modals/delete-gallery-modal/delete-gallery.modal.html"),
    styles: [__webpack_require__("./web/modern/components/integrations/connect-galleries/modals/delete-gallery-modal/delete-gallery.modal.scss")]
}), __metadata("design:paramtypes", [shootProof_data_service_1.ShootProofDataProvider, pickTime_data_service_1.PickTimeDataProvider, message_service_1.MessageService, invoices_data_service_1.InvoicesDataProvider, utils_service_1.UtilsServiceProvider, ng_bootstrap_1.NgbActiveModal, snModal_service_1.SNModalService, integrations_service_1.IntegrationsServiceProvider])], DeleteGalleryModal);
exports.DeleteGalleryModal = DeleteGalleryModal;

/***/ }),

/***/ "./web/modern/components/integrations/connect-galleries/modals/select-existing-gallery-modal/select-existing-gallery.modal.html":
/***/ (function(module, exports) {

module.exports = "<form class=\"form form-horizontal\" role=\"form\">\n    <div class=\"modal-header pt-pb-15\">\n        <button class=\"close\" (click)=\"dismiss()\" data-dismiss=\"modal\" aria-hidden=\"true\">&times;</button>\n        <h3 class=\"modal-title\">Select Existing {{ shootProofBrands ? 'ShootProof' : 'Pic-Time' }} Gallery</h3>\n    </div>\n    <div class=\"modal-body add-new-modal add-new-list\">\n        <div *ngIf=\"shootProofBrands\">\n            <div class=\"field-info\">\n                <p class=\"mb-6\">Brand</p>\n                <div class=\"flex-row\">\n                    <div class=\"select-style flex-grow-1\">\n                        <select class=\"form-control\" [ngModel]=\"selectedShootProofBrandId\" (ngModelChange)=\"selectBrand($event)\" required name=\"GalleriesBrands\" >\n                            <option [attr.selected]=\"selectedShootProofBrandId == -1 ? 'selected' : null\" [value]=\"-1\">Choose Brand</option>\n                            <option *ngFor=\"let brand of shootProofBrands\" [value]=\"brand.spBrandId\" >{{ brand.name }}</option>\n                        </select>\n                    </div>\n                </div>\n            </div>\n            <div class=\"field-info\">\n                <p class=\"mb-6\">Gallery</p>\n                <div class=\"flex-row\">\n                    <div class=\"select-style flex-grow-1\">\n                        <select class=\"form-control\" [ngModel]=\"selectedGalleryId\" (ngModelChange)=\"selectGallery($event)\" name=\"Galleries\" required [disabled]=\"galleriesListDisable\" >\n                            <option *ngFor=\"let galerry of galleriesList\" [value]=\"galerry.spGalleryId\" [attr.selected]=\"galerry.spGalleryId == -1 ? 'selected' : null\" >{{ galerry.name }}</option>\n                        </select>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div *ngIf=\"!shootProofBrands\">\n            <div *ngIf=\"picTimeBrands.length > 1\" class=\"field-info\">\n                <p class=\"mb-6\">Brand</p>\n                <div class=\"flex-row\">\n                    <div class=\"select-style flex-grow-1\">\n                        <select class=\"form-control\" [ngModel]=\"selectedPicTimeBrand\" (ngModelChange)=\"selectPicTimeBrand($event)\" required name=\"selectedPicTimeBrand\" >\n                            <option  disabled selected hidden [value]=\"-1\">Choose Brand</option>\n                            <option *ngFor=\"let brand of picTimeBrands\" [value]=\"brand\" >{{ brand }}</option>\n                        </select>\n                    </div>\n                </div>\n            </div>\n            <div class=\"field-info\">\n                <p class=\"mb-6\">Gallery</p>\n                <ng-select class=\"pic-time-multiselect\"\n                           [(ngModel)]=\"selectedGalleries\"\n                           [ngModelOptions]=\"{standalone: true}\"\n                           [items]=\"picTimeGalleries\"\n                           [loading]=\"loadingPicTimeGalleries\"\n                           [disabled]=\"selectedPicTimeBrand === -1\"\n                           notFoundText=\"No galleries\"\n                           [placeholder]=\"'Select Project'\"\n                           bindLabel=\"name\"\n                           bindValue=\"projectId\"\n                           [multiple]=\"true\"\n                           maxSelectedItems=\"10\">\n                    <ng-template ng-multi-label-tmp let-items=\"items\" let-clear=\"clear\">\n                        <div class=\"ng-value\" *ngFor=\"let item of items\">\n                            <span class=\"ng-value-label\">{{ item.name }}</span>\n                            <span class=\"ng-value-icon right\" (click)=\"clear(item)\" aria-hidden=\"true\">×</span>\n                        </div>\n                    </ng-template>\n                </ng-select>\n                <div class=\"limit-galleries-info\" *ngIf=\"selectedGalleries.length === 10\">\n                    <p>Maximum number of galleries reached</p>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"modal-footer left\">\n        <button class=\"btn btn-success btn-submit pull-left mb--8\" type=\"submit\"\n                spinning-wheel [is-spinning-wheel-active]=\"onSubmitSpinner\"\n                [disabled]=\"disableSubmit()\" (click)=\"onSubmit()\">\n            Save Gallery\n        </button>\n    </div>\n</form>\n"

/***/ }),

/***/ "./web/modern/components/integrations/connect-galleries/modals/select-existing-gallery-modal/select-existing-gallery.modal.scss":
/***/ (function(module, exports) {

module.exports = ".limit-galleries-info p {\n  color: #ea1e21; }\n\n.select-style select {\n  height: auto; }\n"

/***/ }),

/***/ "./web/modern/components/integrations/connect-galleries/modals/select-existing-gallery-modal/select-existing-gallery.modal.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var shootProof_data_service_1 = __webpack_require__("./shared/services/integrations/shootProof/shootProof.data.service.ts");
var invoices_data_service_1 = __webpack_require__("./shared/services/invoice/invoices-data-service/invoices.data.service.ts");
var ng_bootstrap_1 = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/index.js");
var pickTime_data_service_1 = __webpack_require__("./shared/services/integrations/pickTime/pickTime.data.service.ts");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var integrations_service_1 = __webpack_require__("./shared/services/integrations/integrations.service.ts");
var SelectExistingGalleryModal = function () {
    function SelectExistingGalleryModal(shootProofDataService, pickTimeDataProvider, messageService, invoiceDataService, activeModal, integrationService) {
        _classCallCheck(this, SelectExistingGalleryModal);

        this.shootProofDataService = shootProofDataService;
        this.pickTimeDataProvider = pickTimeDataProvider;
        this.messageService = messageService;
        this.invoiceDataService = invoiceDataService;
        this.activeModal = activeModal;
        this.integrationService = integrationService;
        this.picTimeBrands = [];
        this.picTimeGalleries = [];
        this.selectedPicTimeBrand = -1;
        this.galleriesListDisable = true;
        this.onSubmitSpinner = false;
        this.selectedGalleries = [];
        this.selectedShootProofBrandId = -1;
        this.selectedGalleryId = -1;
        this.DEFAULT_GALLERY_PRESET = [{ spGalleryId: -1, name: 'Choose Gallery' }];
        this.LOADING_GALLERY_PRESET = [{ spGalleryId: -1, name: 'Loading...' }];
        this.galleriesList = this.DEFAULT_GALLERY_PRESET;
        this.unsubscribe = new Subject_1.Subject();
    }

    _createClass(SelectExistingGalleryModal, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            if (!this.shootProofBrands) {
                this.getSuccessGalleriesMetadata(this.picTimeGalleriesMetadata);
            }
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "getSuccessGalleriesMetadata",
        value: function getSuccessGalleriesMetadata(data) {
            for (var brandName in data.metadata) {
                this.picTimeBrands.push(brandName);
                if (this.picTimeBrands.length === 1) {
                    this.picTimeGalleries = this.picTimeGalleriesMetadata.metadata[brandName];
                }
            }
            if (this.picTimeBrands.length === 1) {
                this.selectedPicTimeBrand = 1;
            }
        }
    }, {
        key: "selectPicTimeBrand",
        value: function selectPicTimeBrand(picTimeBrand) {
            this.selectedGalleries = [];
            this.selectedPicTimeBrand = picTimeBrand;
            if (picTimeBrand != -1) {
                if (this.picTimeGalleriesMetadata.metadata.hasOwnProperty(picTimeBrand)) {
                    this.picTimeGalleries = this.picTimeGalleriesMetadata.metadata[picTimeBrand];
                }
            }
        }
    }, {
        key: "selectBrand",
        value: function selectBrand(shootProofBrandId) {
            var _this = this;

            if (shootProofBrandId != -1) {
                this.selectedShootProofBrandId = shootProofBrandId;
                this.galleriesListDisable = true;
                this.galleriesList = this.LOADING_GALLERY_PRESET;
                this.shootProofDataService.getGalleriesToImportV1(shootProofBrandId).subscribe(function (data) {
                    _this.galleriesListDisable = false;
                    _this.galleriesList = _this.DEFAULT_GALLERY_PRESET.concat(data.data);
                }, function (error) {
                    _this.galleriesList = _this.DEFAULT_GALLERY_PRESET;
                    _this.checkIfShootProofError(error);
                });
            } else {
                this.selectedShootProofBrandId = -1;
                this.selectedGalleryId = -1;
                this.galleriesList = this.DEFAULT_GALLERY_PRESET;
                this.galleriesListDisable = true;
            }
        }
    }, {
        key: "selectGallery",
        value: function selectGallery(galleryId) {
            if (galleryId !== -1) {
                this.selectedGalleryId = galleryId;
            }
        }
    }, {
        key: "dismiss",
        value: function dismiss() {
            this.activeModal.close();
            this.selectedGalleryId = -1;
            this.selectedShootProofBrandId = -1;
            this.galleriesList = this.DEFAULT_GALLERY_PRESET;
            this.shootProofBrands = [];
            this.selectedGalleries = [];
            this.galleriesListDisable = true;
            this.onSubmitSpinner = false;
        }
    }, {
        key: "onSubmit",
        value: function onSubmit() {
            var _this2 = this;

            this.onSubmitSpinner = true;
            if (this.shootProofBrands) {
                if (this.selectedGalleryId === -1) {
                    this.messageService.showToaster('e_2', 'shootProof');
                    this.onSubmitSpinner = false;
                    return;
                }
                var galleryParamsToSend = {
                    jobId: this.jobId,
                    spGalleryId: +this.selectedGalleryId,
                    spBrandId: +this.selectedShootProofBrandId,
                    importOrders: false
                };
                this.shootProofDataService.selectExistingGaleryV1(galleryParamsToSend).pipe(operators_1.takeUntil(this.unsubscribe), operators_1.finalize(function () {
                    return _this2.onSubmitSpinner = false;
                })).subscribe(function () {
                    return _this2.successSelectExistingShootProofGallery();
                }, function (error) {
                    return _this2.checkIfShootProofError(error);
                });
            } else {
                if (this.selectedPicTimeBrand === -1) {
                    this.messageService.showToaster('e_7', 'picTime');
                    this.onSubmitSpinner = false;
                    return;
                }
                if (this.selectedGalleries.length === 0) {
                    this.messageService.showToaster('e_6', 'picTime');
                    this.onSubmitSpinner = false;
                    return;
                }
                var selectedPicTimeGalleriesToSend = {
                    galleryIds: this.selectedGalleries
                };
                this.pickTimeDataProvider.importSelectedPicTimeGalleries(this.jobId, selectedPicTimeGalleriesToSend).pipe(operators_1.takeUntil(this.unsubscribe), operators_1.finalize(function () {
                    return _this2.onSubmitSpinner = false;
                })).subscribe(function () {
                    return _this2.successSelectExistingPicTimeGalleries();
                }, function (error) {
                    return _this2.messageService.handleError(error);
                });
            }
        }
    }, {
        key: "successSelectExistingShootProofGallery",
        value: function successSelectExistingShootProofGallery() {
            this.messageService.showToaster('s_3', 'shootProof');
            this.integrationService.emitGalleriesUpdateEvent('UPDATE_SN_GALLERIES');
            this.invoiceDataService.emitInvoiceUpdateEvent('UPDATE_SP_INVOICES');
            this.dismiss();
        }
    }, {
        key: "successSelectExistingPicTimeGalleries",
        value: function successSelectExistingPicTimeGalleries() {
            this.messageService.showToaster('s_2', 'picTime');
            this.integrationService.emitGalleriesUpdateEvent('UPDATE_SN_GALLERIES');
            this.invoiceDataService.emitInvoiceUpdateEvent('UPDATE_PT_INVOICES');
            this.dismiss();
        }
    }, {
        key: "checkIfShootProofError",
        value: function checkIfShootProofError(error) {
            if (error.status === 500) {
                this.messageService.showToaster('e_1', 'shootProof');
            } else {
                this.messageService.handleError(error);
            }
        }
    }, {
        key: "disableSubmit",
        value: function disableSubmit() {
            var helper = false;
            if (this.shootProofBrands && this.selectedGalleryId === -1 && this.selectedShootProofBrandId === -1) {
                helper = true;
            } else if (!this.shootProofBrands && this.picTimeGalleries.length === 0 && this.selectedGalleries.length === 0) {
                helper = true;
            }
            return helper;
        }
    }]);

    return SelectExistingGalleryModal;
}();
__decorate([core_1.Input('jobId'), __metadata("design:type", Number)], SelectExistingGalleryModal.prototype, "jobId", void 0);
__decorate([core_1.Input('shootProofBrands'), __metadata("design:type", Object)], SelectExistingGalleryModal.prototype, "shootProofBrands", void 0);
__decorate([core_1.Input('picTimeGalleriesMetadata'), __metadata("design:type", Object)], SelectExistingGalleryModal.prototype, "picTimeGalleriesMetadata", void 0);
SelectExistingGalleryModal = __decorate([core_1.Component({
    selector: 'select-existing-gallery-modal',
    template: __webpack_require__("./web/modern/components/integrations/connect-galleries/modals/select-existing-gallery-modal/select-existing-gallery.modal.html"),
    styles: [__webpack_require__("./web/modern/components/integrations/connect-galleries/modals/select-existing-gallery-modal/select-existing-gallery.modal.scss")]
}), __metadata("design:paramtypes", [shootProof_data_service_1.ShootProofDataProvider, pickTime_data_service_1.PickTimeDataProvider, message_service_1.MessageService, invoices_data_service_1.InvoicesDataProvider, ng_bootstrap_1.NgbActiveModal, integrations_service_1.IntegrationsServiceProvider])], SelectExistingGalleryModal);
exports.SelectExistingGalleryModal = SelectExistingGalleryModal;

/***/ }),

/***/ "./web/modern/components/invoices/invoice-update/invoice-client-info/invoice-client-info.html":
/***/ (function(module, exports) {

module.exports = "<div>\n    <h2 class=\"jobs-cell-title\">\n        <span>Client</span>\n        <span class=\"fi-grey fi-clients pull-right\"></span>\n    </h2>\n\n    <div class=\"section-data\">\n        <table class=\"table-profile\">\n            <tbody>\n            <tr>\n                <td>\n                    <b class=\"text-break\">{{ job.primaryContact.firstName }} {{ job.primaryContact.lastName }}</b>\n                </td>\n            </tr>\n            <tr>\n                <td class=\"text-break\">{{ job.primaryContact.addressLine1 }}</td>\n            </tr>\n            <tr *ngIf=\"job.primaryContact.addressLine2\">\n                <td class=\"text-break\">{{ job.primaryContact.addressLine2 }}</td>\n            </tr>\n            <tr>\n                <td class=\"text-break\">{{ job.primaryContact.town }}</td>\n            </tr>\n            <tr>\n                <td class=\"text-break\">\n                    {{ job.primaryContact.state }} {{ job.primaryContact.postcode }}\n                    {{ job.primaryContact.country }}\n                </td>\n            </tr>\n            <tr *ngIf=\"job.primaryContact.phone\">\n                <td class=\"text-break-all\">Phone number: {{ job.primaryContact.phone }}</td>\n            </tr>\n            <tr *ngIf=\"job.primaryContact.email\">\n                <td class=\"text-break-all\">Email: {{ job.primaryContact.email }}</td>\n            </tr>\n            </tbody>\n        </table>\n    </div>\n</div>\n\n\n"

/***/ }),

/***/ "./web/modern/components/invoices/invoice-update/invoice-client-info/invoice-client-info.scss":
/***/ (function(module, exports) {

module.exports = ""

/***/ }),

/***/ "./web/modern/components/invoices/invoice-update/invoice-client-info/invoice-client-info.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var InvoiceClientInfoComponent = function InvoiceClientInfoComponent() {
    _classCallCheck(this, InvoiceClientInfoComponent);
};
__decorate([core_1.Input(), __metadata("design:type", Object)], InvoiceClientInfoComponent.prototype, "job", void 0);
InvoiceClientInfoComponent = __decorate([core_1.Component({
    selector: 'invoice-client-info',
    template: __webpack_require__("./web/modern/components/invoices/invoice-update/invoice-client-info/invoice-client-info.html"),
    styles: [__webpack_require__("./web/modern/components/invoices/invoice-update/invoice-client-info/invoice-client-info.scss")]
}), __metadata("design:paramtypes", [])], InvoiceClientInfoComponent);
exports.InvoiceClientInfoComponent = InvoiceClientInfoComponent;

/***/ }),

/***/ "./web/modern/components/invoices/invoice-update/invoice-contract-question/invoice-contract-question.html":
/***/ (function(module, exports) {

module.exports = "<section>\n    update works\n</section>\n\n"

/***/ }),

/***/ "./web/modern/components/invoices/invoice-update/invoice-contract-question/invoice-contract-question.scss":
/***/ (function(module, exports) {

module.exports = ""

/***/ }),

/***/ "./web/modern/components/invoices/invoice-update/invoice-contract-question/invoice-contract-question.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var InvoiceContractQuestionComponent = function InvoiceContractQuestionComponent() {
    _classCallCheck(this, InvoiceContractQuestionComponent);
};
InvoiceContractQuestionComponent = __decorate([core_1.Component({
    selector: 'invoice-contract-question',
    template: __webpack_require__("./web/modern/components/invoices/invoice-update/invoice-contract-question/invoice-contract-question.html"),
    styles: [__webpack_require__("./web/modern/components/invoices/invoice-update/invoice-contract-question/invoice-contract-question.scss")]
}), __metadata("design:paramtypes", [])], InvoiceContractQuestionComponent);
exports.InvoiceContractQuestionComponent = InvoiceContractQuestionComponent;

/***/ }),

/***/ "./web/modern/components/invoices/invoice-update/invoice-job-info/invoice-job-info.html":
/***/ (function(module, exports) {

module.exports = "<div>\n    <h2 class=\"jobs-cell-title\">\n        <span *ngIf=\"!job.inLead\">Job</span>\n        <span *ngIf=\"job.inLead\">Lead</span>\n        <span class=\"fi-grey fi-jobs pull-right\"></span>\n    </h2>\n\n    <div class=\"section-data\">\n        <table class=\"table-profile\">\n            <tbody>\n            <tr>\n                <td><b class=\"text-break\">{{ job.name }}</b></td>\n            </tr>\n            <tr>\n                <td class=\"text-break\">\n                    {{ shootsLabelName }}:\n                    <div>\n                        <main-shoot-date [start-date]=\"job.startDate\" [finish-date]=\"job.finishDate\"></main-shoot-date>\n                    </div>\n                </td>\n            </tr>\n            <tr *ngIf=\"job.startTime && job.finishTime\">\n                <td>\n                    {{ job.startTime | timeFilter: '12h' }} - {{ job.finishTime | timeFilter: '12h' }}\n                </td>\n            </tr>\n            <tr *ngIf=\"job.shootLocation\">\n                <td class=\"text-break\">\n                    {{ job.shootLocation }}\n                </td>\n            </tr>\n            </tbody>\n        </table>\n    </div>\n</div>\n\n\n"

/***/ }),

/***/ "./web/modern/components/invoices/invoice-update/invoice-job-info/invoice-job-info.scss":
/***/ (function(module, exports) {

module.exports = ""

/***/ }),

/***/ "./web/modern/components/invoices/invoice-update/invoice-job-info/invoice-job-info.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var settings_1 = __webpack_require__("./shared/services/settings/settings.ts");
var rxjs_1 = __webpack_require__("./node_modules/rxjs/Rx.js");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var InvoiceJobInfoComponent = function () {
    function InvoiceJobInfoComponent(settingsService) {
        _classCallCheck(this, InvoiceJobInfoComponent);

        this.settingsService = settingsService;
        this.unsubscribe = new rxjs_1.Subject();
    }

    _createClass(InvoiceJobInfoComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.subscribeToCustomizeLabelsChange();
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "subscribeToCustomizeLabelsChange",
        value: function subscribeToCustomizeLabelsChange() {
            var _this = this;

            this.settingsService.customizeLabelsObservable.pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (customizeLabels) {
                return _this.shootsLabelName = customizeLabels.mainShootLabel;
            });
        }
    }]);

    return InvoiceJobInfoComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], InvoiceJobInfoComponent.prototype, "job", void 0);
InvoiceJobInfoComponent = __decorate([core_1.Component({
    selector: 'invoice-job-info',
    template: __webpack_require__("./web/modern/components/invoices/invoice-update/invoice-job-info/invoice-job-info.html"),
    styles: [__webpack_require__("./web/modern/components/invoices/invoice-update/invoice-job-info/invoice-job-info.scss")]
}), __metadata("design:paramtypes", [settings_1.SettingsProvider])], InvoiceJobInfoComponent);
exports.InvoiceJobInfoComponent = InvoiceJobInfoComponent;

/***/ }),

/***/ "./web/modern/components/invoices/invoice-update/invoice-main-info/invoice-main-info.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"form-group\">\n    <div class=\"col-sm-3 control-label\">Invoice ID</div>\n    <div class=\"col-sm-9\">\n        <input type=\"text\" class=\"form-control\" [(ngModel)]=\"mainInfoData.invoiceId\" maxlength=\"20\">\n    </div>\n</div>\n<div class=\"form-group\">\n    <div class=\"col-sm-3 control-label\">Issue date</div>\n    <div class=\"col-sm-9 box-no-transition\">\n        <sn-date-picker [options]=\"'options' | snDatePickerConfig\"\n                        [placeholder]=\"datePickerHolder\" [(ngModel)]=\"mainInfoData.issueDate\"\n                        snDatePickerValidator>\n        </sn-date-picker>\n    </div>\n</div>\n<div class=\"form-group\">\n    <div class=\"col-sm-3 control-label\">PO Number</div>\n    <div class=\"col-sm-9\">\n        <input type=\"text\" class=\"form-control\" [(ngModel)]=\"mainInfoData.poNumber\" maxlength=\"30\" placeholder=\"-\">\n    </div>\n</div>\n\n"

/***/ }),

/***/ "./web/modern/components/invoices/invoice-update/invoice-main-info/invoice-main-info.scss":
/***/ (function(module, exports) {

module.exports = ""

/***/ }),

/***/ "./web/modern/components/invoices/invoice-update/invoice-main-info/invoice-main-info.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var InvoiceMainInfoComponent = function InvoiceMainInfoComponent() {
    _classCallCheck(this, InvoiceMainInfoComponent);
};
__decorate([core_1.Input(), __metadata("design:type", Object)], InvoiceMainInfoComponent.prototype, "mainInfoData", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], InvoiceMainInfoComponent.prototype, "datePickerHolder", void 0);
InvoiceMainInfoComponent = __decorate([core_1.Component({
    selector: 'invoice-main-info',
    template: __webpack_require__("./web/modern/components/invoices/invoice-update/invoice-main-info/invoice-main-info.html"),
    styles: [__webpack_require__("./web/modern/components/invoices/invoice-update/invoice-main-info/invoice-main-info.scss")]
}), __metadata("design:paramtypes", [])], InvoiceMainInfoComponent);
exports.InvoiceMainInfoComponent = InvoiceMainInfoComponent;

/***/ }),

/***/ "./web/modern/components/invoices/invoice-update/invoice-payment-schedule/invoice-payment-schedule.html":
/***/ (function(module, exports) {

module.exports = "<section>\n    payment schedule works\n</section>\n\n"

/***/ }),

/***/ "./web/modern/components/invoices/invoice-update/invoice-payment-schedule/invoice-payment-schedule.scss":
/***/ (function(module, exports) {

module.exports = ""

/***/ }),

/***/ "./web/modern/components/invoices/invoice-update/invoice-payment-schedule/invoice-payment-schedule.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var InvoicePaymentScheduleComponent = function InvoicePaymentScheduleComponent() {
    _classCallCheck(this, InvoicePaymentScheduleComponent);
};
InvoicePaymentScheduleComponent = __decorate([core_1.Component({
    selector: 'invoice-payment-schedule',
    template: __webpack_require__("./web/modern/components/invoices/invoice-update/invoice-payment-schedule/invoice-payment-schedule.html"),
    styles: [__webpack_require__("./web/modern/components/invoices/invoice-update/invoice-payment-schedule/invoice-payment-schedule.scss")]
}), __metadata("design:paramtypes", [])], InvoicePaymentScheduleComponent);
exports.InvoicePaymentScheduleComponent = InvoicePaymentScheduleComponent;

/***/ }),

/***/ "./web/modern/components/invoices/invoice-update/invoice-summary/invoice-summary.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"col-xs-9 text-right pr-0\">Subtotal :</div>\n<div class=\"col-xs-2 text-left pl-1 no-text-wrap\">{{ summary.subTotalWithCurrency.amountWithCurrency ? summary.subTotalWithCurrency.amountWithCurrency : \"Fill all fields\" }}</div>\n<div class=\"clearfix\"></div>\n\n<div class=\"col-xs-9 text-right pr-0\">{{ companyCurrencyAndTaxes.taxName }} :</div>\n<div class=\"col-xs-2 text-left pl-1 no-text-wrap\">{{ summary.taxValueWithCurrency.amountWithCurrency }}</div>\n<div class=\"clearfix\"></div>\n\n<div class=\"col-xs-9 text-right pr-0\">Discount :</div>\n<div class=\"col-xs-2 text-left pl-1 no-text-wrap\">\n  {{ summary.discountValue ? ' -' + (summary.discountValueWithCurrency.amountWithCurrency) : 'None' }}\n</div>\n\n<div class=\"col-xs-9 text-right pr-0\"><b>Total Due :</b></div>\n<div class=\"col-xs-2 text-left pl-1 no-text-wrap\"><b class=\"ng-binding\">{{ summary.totalWithCurrency.amountWithCurrency ? summary.totalWithCurrency.amountWithCurrency : \"Fill all fields\" }}</b></div>\n\n"

/***/ }),

/***/ "./web/modern/components/invoices/invoice-update/invoice-summary/invoice-summary.scss":
/***/ (function(module, exports) {

module.exports = ""

/***/ }),

/***/ "./web/modern/components/invoices/invoice-update/invoice-summary/invoice-summary.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var InvoiceSummaryComponent = function InvoiceSummaryComponent() {
    _classCallCheck(this, InvoiceSummaryComponent);
};
__decorate([core_1.Input(), __metadata("design:type", Object)], InvoiceSummaryComponent.prototype, "summary", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], InvoiceSummaryComponent.prototype, "companyCurrencyAndTaxes", void 0);
InvoiceSummaryComponent = __decorate([core_1.Component({
    selector: 'invoice-summary',
    template: __webpack_require__("./web/modern/components/invoices/invoice-update/invoice-summary/invoice-summary.html"),
    styles: [__webpack_require__("./web/modern/components/invoices/invoice-update/invoice-summary/invoice-summary.scss")]
}), __metadata("design:paramtypes", [])], InvoiceSummaryComponent);
exports.InvoiceSummaryComponent = InvoiceSummaryComponent;

/***/ }),

/***/ "./web/modern/components/invoices/invoice-update/invoice-update-dnd/invoice-update-dnd.html":
/***/ (function(module, exports) {

module.exports = "<section dnd-auto-scroll class=\"invoice-package-block\">\n  <div>\n\n  <div *ngIf=\"!isDiscounts\" class=\"invoice-package-container\">\n    <div class=\"row products-header\">\n      <div  class=\"col-xs-2\">Product / Package</div>\n      <div class=\"col-xs-4\">Description</div>\n      <div  class=\"col-xs-6 products-inputs\">\n        <div>Price</div>\n        <div>Quantity</div>\n        <div>Discount (%)</div>\n        <div class=\"products-tax\">Tax</div>\n        <div class=\"product__amount\">Amount</div></div>\n    </div>\n\n    <div *ngIf=\"companyCurrencyAndTaxes && products && productsNames\"  dragula=\"products\" class=\"package-container mb-10\" [(dragulaModel)]=\"products\">\n      <div *ngFor=\"let product of products; let productIndex = index\" [class.last-package-item]=\"productIndex === products.length - 1\" class=\"dnd-package mb-20\">\n        <div class=\"dnd-icon-products handle-package\"></div>\n        <quote-create-package-block\n            [product]=\"product\"\n            [productsName]=\"productsNames\"\n            [index]=\"productIndex\"\n            [isFixed]=\"true\"\n            [currencySymbol]=\"companyCurrencyAndTaxes.currency.symbol\"\n            [taxPercentage]=\"companyCurrencyAndTaxes.percentage\"\n            (checkRecommended)=\"setRecommended($event)\"\n            (changeProduct)=\"setNewProduct($event)\"\n            (deletePackage)=\"removeProduct($event)\"></quote-create-package-block>\n      </div>\n    </div>\n  </div>\n\n\n  <div *ngIf=\"isDiscounts && productsNames\" class=\"discounts-container pb-20\">\n    <h2 class=\"quote-section-name\">Add Discount</h2>\n    <p>Add a fixed discount to this invoice.</p>\n    <div dragula=\"discounts\" class=\"package-container mb-10\" [(dragulaModel)]=\"products\">\n      <div class=\"dnd-package mb-20\" *ngFor=\"let discount of products; let discountIndex = index\">\n        <div class=\"dnd-icon-products handle-package\"></div>\n        <discount-create-block\n                [discount]=\"discount\"\n                [index]=\"discountIndex\"\n                [discountsNames]=\"productsNames\"\n                [currencySymbol]=\"companyCurrencyAndTaxes.currency.symbol\"\n                [taxPercentage]=\"companyCurrencyAndTaxes.percentage\"\n                (changeDiscount)=\"setNewProduct($event)\"\n                (deleteDiscount)=\"removeProduct($event)\"\n        ></discount-create-block>\n      </div>\n    </div>\n  </div>\n  </div>\n\n</section>\n"

/***/ }),

/***/ "./web/modern/components/invoices/invoice-update/invoice-update-dnd/invoice-update-dnd.scss":
/***/ (function(module, exports) {

module.exports = ":host .invoice-package-block {\n  overflow-x: auto; }\n  :host .invoice-package-block .invoice-package-container {\n    min-width: 1400px; }\n\n:host .discounts-container .dnd-package {\n  position: relative;\n  min-width: 710px; }\n\n:host .discounts-container .dnd-icon {\n  margin-right: 20px; }\n  :host .discounts-container .dnd-icon:before {\n    content: '\\F0C9';\n    font: normal normal normal 16px/1 FontAwesome;\n    color: #8e8e98; }\n\n:host .discounts-container .handle-package {\n  position: absolute;\n  left: 20px;\n  top: 20px;\n  cursor: pointer;\n  /* fallback if grab cursor is unsupported */\n  cursor: -webkit-grab;\n  cursor: grab; }\n"

/***/ }),

/***/ "./web/modern/components/invoices/invoice-update/invoice-update-dnd/invoice-update-dnd.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var ng2_dragula_1 = __webpack_require__("./node_modules/ng2-dragula/index.js");
var InvoiceUpdateDnd = function () {
    function InvoiceUpdateDnd(dragulaService) {
        _classCallCheck(this, InvoiceUpdateDnd);

        this.dragulaService = dragulaService;
        this.productStateChange = new core_1.EventEmitter();
        this.dragulaProductsOptions = {
            moves: function moves(el, container, handle) {
                return handle.classList.contains('handle-package');
            }
        };
        this.dragulaDiscountsOptions = {
            moves: function moves(el, container, handle) {
                return handle.classList.contains('handle-package');
            }
        };
    }

    _createClass(InvoiceUpdateDnd, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.setDragulaOptions();
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.clear();
        }
    }, {
        key: "clear",
        value: function clear() {
            this.isDiscounts ? this.dragulaService.destroy('discounts') : this.dragulaService.destroy('products');
        }
    }, {
        key: "setDragulaOptions",
        value: function setDragulaOptions() {
            this.isDiscounts ? this.dragulaService.setOptions('discounts', this.dragulaDiscountsOptions) : this.dragulaService.setOptions('products', this.dragulaProductsOptions);
        }
    }, {
        key: "removeProduct",
        value: function removeProduct(itemToDelete) {
            this.isDiscounts ? this.products.splice(itemToDelete, 1) : this.products.splice(itemToDelete.index, 1);
            this.productStateChange.emit();
        }
    }, {
        key: "setNewProduct",
        value: function setNewProduct(product) {
            var _this = this;

            this.products.forEach(function (productItem, index) {
                if (index === product.index) {
                    _this.products[index] = JSON.parse(JSON.stringify(Object.assign({}, product.product)));
                }
            });
        }
    }]);

    return InvoiceUpdateDnd;
}();
__decorate([core_1.Input(), __metadata("design:type", Boolean)], InvoiceUpdateDnd.prototype, "isDiscounts", void 0);
__decorate([core_1.Input('products'), __metadata("design:type", Object)], InvoiceUpdateDnd.prototype, "products", void 0);
__decorate([core_1.Input('companyCurrencyAndTaxes'), __metadata("design:type", Object)], InvoiceUpdateDnd.prototype, "companyCurrencyAndTaxes", void 0);
__decorate([core_1.Input('productsNames'), __metadata("design:type", Object)], InvoiceUpdateDnd.prototype, "productsNames", void 0);
__decorate([core_1.Output('productStateChange'), __metadata("design:type", core_1.EventEmitter)], InvoiceUpdateDnd.prototype, "productStateChange", void 0);
InvoiceUpdateDnd = __decorate([core_1.Component({
    selector: 'invoice-update-dnd',
    template: __webpack_require__("./web/modern/components/invoices/invoice-update/invoice-update-dnd/invoice-update-dnd.html"),
    styles: [__webpack_require__("./web/modern/components/invoices/invoice-update/invoice-update-dnd/invoice-update-dnd.scss")]
}), __metadata("design:paramtypes", [ng2_dragula_1.DragulaService])], InvoiceUpdateDnd);
exports.InvoiceUpdateDnd = InvoiceUpdateDnd;

/***/ }),

/***/ "./web/modern/components/invoices/invoice-update/invoice-update.html":
/***/ (function(module, exports) {

module.exports = "<div *ngIf=\"job\">\n    <div class=\"qt-header mt-20\">\n        <div class=\"qt-header-breadcrumbs\">\n\n            <h2 class=\"mt-0\">{{ editInvoice ? 'Edit Invoice' : 'New Invoice' }}</h2>\n\n            <!--Breadcrumbs-->\n            <div class=\"bc-wrap\">\n                <ol class=\"bc-list mb-0 mt-0\">\n                    <li><a href=\"/\">Dashboard</a></li>\n\n                    <ng-container *ngIf=\"job.inLead\">\n                        <li><a href=\"/leads\">Leads</a></li>\n                        <li><a href=\"/leads/view/{{job.leadId}}\">{{ job.name }}</a></li>\n                    </ng-container>\n\n                    <ng-container *ngIf=\"!job.inLead\">\n                        <li><a href=\"/jobs\">Jobs</a></li>\n                        <li><a href=\"/jobs/view/{{job.id}}\">{{ job.name }}</a></li>\n                    </ng-container>\n\n                    <li class=\"active\">{{ editInvoice ? 'Edit Invoice' : 'New Invoice' }}</li>\n                </ol>\n            </div>\n        </div>\n        <div class=\"qt-header-template-list\" *ngIf=\"invoiceTemplatesAvailable && (!editInvoice || (editInvoice && invoice.source === 'STUDIO_NINJA'))\">\n            <span class=\"text-semi-bold f-s-13 no-text-wrap mr-10\">Apply Template</span>\n            <div class=\"select-style wp-100\">\n                <select #invoiceTemplateSelect\n                        [disabled]=\"loadingTemplate\"\n                        [ngModel]=\"selectedInvoiceTemplateId\" (ngModelChange)=\"confirmApplyInvoiceTemplate($event)\">\n                    <option [value]=\"-1\">Choose Invoice Template</option>\n                    <option [value]=\"template.id\" *ngFor=\"let template of invoiceTemplates\">{{ template.name }}</option>\n                </select>\n            </div>\n        </div>\n    </div>\n\n    <hr class=\"mt-30\">\n\n    <!--Main / client / job info fields-->\n    <div class=\"row show-grid\">\n        <div class=\"col-xs-12 col-md-6 show-grid form-horizontal jobs-text-forms\">\n            <invoice-main-info *ngIf=\"mainInfoDataToSave\" [mainInfoData]=\"mainInfoDataToSave\" [datePickerHolder]=\"datePlaceholder\"></invoice-main-info>\n        </div>\n\n        <div class=\"row show-grid\">\n            <div class=\"col-xs-12 col-md-6\">\n                    <div class=\"flex-row flex-wrap-sm\">\n                        <div class=\"col-xs-12 col-md-6 mt-0 jobs-cell-item\">\n                            <invoice-job-info [job]=\"job\"></invoice-job-info>\n                        </div>\n                        <div class=\"col-xs-12 col-md-6 mt-0 jobs-cell-item\">\n                            <invoice-client-info [job]=\"job\"></invoice-client-info>\n                        </div>\n                    </div>\n            </div>\n        </div>\n    </div>\n\n    <!--Package section-->\n    <invoice-update-dnd *ngIf=\"productsNames\" [isDiscounts]=\"false\" [products]=\"products\" [companyCurrencyAndTaxes]=\"currencyAndTax\" [productsNames]=\"productsNames\" (productStateChange)=\"onProductChange()\"></invoice-update-dnd>\n\n    <!--Add button and summary-->\n    <div class=\"table-responsive invoices-section\">\n        <table class=\"table vertical-top-table edit-payments-table\">\n            <tbody>\n            <tr>\n                <td colspan=\"6\" class=\"pl-0\">\n                    <button type=\"button\" class=\"btn btn-info btn-add-new-sm\" (click)=\"addProduct()\">Add Product / Package\n                    </button>\n                </td>\n                <td colspan=\"2\"></td>\n                <td colspan=\"2\">\n                    <div class=\"row\">\n                        <invoice-summary *ngIf=\"summary\" [summary]=\"summary\" [companyCurrencyAndTaxes]=\"currencyAndTax\"></invoice-summary>\n                    </div>\n                </td>\n            </tr>\n            </tbody>\n        </table>\n    </div>\n\n    <invoice-update-dnd [isDiscounts]=\"true\" [products]=\"discounts\" [companyCurrencyAndTaxes]=\"currencyAndTax\" [productsNames]=\"discountsNames\" (productStateChange)=\"onProductChange()\"></invoice-update-dnd>\n    <div class=\"invoices-section pb-20\">\n        <button type=\"button\" (click)=\"addNewDiscount()\" class=\"btn btn-info btn-add-new-sm\">Add Discount</button>\n    </div>\n\n    <div class=\"mb-30\">\n        <h2>Notes</h2>\n        <textarea type=\"text\"\n                  class=\"form-control invoice-notes\"\n                  maxlength=\"5000\"\n                  [(ngModel)]=\"notesToSave\"\n                  placeholder=\"These are additional notes you wish to add to your invoice.\"></textarea>\n    </div>\n\n    <payment-schedule #paymentScheduleComponent *ngIf=\"paymentScheduleNames && summary\"\n                      [paymentScheduleNames]=\"paymentScheduleNames\"\n                      [defaultPaymentScheduleNames]=\"defaultPaymentScheduleNames\"\n                      [paymentSchedule]=\"paymentSchedule\"\n                      [payments]=\"payments\"\n                      [paymentScheduleTemplateId]=\"paymentScheduleTemplateId\"\n                      [paymentScheduleIdFromServer]=\"paymentScheduleIdFromServer\"\n                      [paymentsFromServer]=\"paymentsFromServer\"\n                      [issueDate]=\"mainInfoDataToSave.issueDate\"\n                      [currencySymbol]=\"currencyAndTax.currency.symbol\"\n                      [job]=\"job\"\n                      [quoteTotal]=\"summary.total\"\n                      [isFixed]=\"true\"\n                      [jobStartDate]=\"job.startDate\"\n                      [datePlaceHolder]=\"datePlaceholder\"\n                      [summary]=\"summary\"\n                      [isInvoice]=\"true\"\n                      (paymentScheduleChange)=\"setPaymentScheduleId($event)\">\n    </payment-schedule>\n\n    <div class=\"mb-30\">\n        <template-apply-list\n                [templateList]=\"contractsTemplates\"\n                [selectedTemplateId]=\"contractToSaveId\"\n                [text]=\"'Do you want to add a contract?'\"\n                [idField]=\"'templateId'\"\n                (onTemplateChange)=\"setContract($event)\">\n            <button class=\"btn btn-sm btn-default\" [disabled]=\"buttonDisable || contractToSaveId === '-1' || isContractSigned()\"\n                    (click)=\"openEditSelectContract()\"><i class=\"fi fi-edit\"></i>Edit Contract\n            </button>\n        </template-apply-list>\n    </div>\n\n    <div class=\"mb-30\">\n        <template-apply-list [templateList]=\"questionnaireTemplates\"\n                             [selectedTemplateId]=\"questionnaireToSaveId\"\n                             [text]=\"'Do you want to add a questionnaire?'\"\n                             (onTemplateChange)=\"setQuestionnaire($event)\">\n        </template-apply-list>\n    </div>\n\n    <div class=\"mb-20\">\n        <button [disabled]=\"buttonDisable\" (click)=\"saveInvoice()\"\n                spinning-wheel [is-spinning-wheel-active]=\"buttonDisable\"\n                class=\"btn btn-rounded btn-success btn-addon btn-lg mr-15\">Save Invoice\n        </button>\n        <button type=\"button\" class=\"btn btn-rounded btn-info btn-lg mr-15\" *ngIf=\"invoiceTemplatesAvailable && (!editInvoice || (editInvoice && invoice.actions.SAVE_AS_TEMPLATE))\"\n                (click)=\"saveAsTemplate()\" [disabled]=\"buttonDisable\">Save As Invoice Template\n        </button>\n        <button type=\"button\" (click)=\"back()\" [disabled]=\"buttonDisable\"\n                class=\"btn btn-rounded btn-default btn-addon btn-lg\">Cancel\n        </button>\n    </div>\n</div>\n\n"

/***/ }),

/***/ "./web/modern/components/invoices/invoice-update/invoice-update.scss":
/***/ (function(module, exports) {

module.exports = ":host .invoices-section {\n  border-bottom: 1px solid #dddddd; }\n  :host .invoices-section .edit-payments-table td:first-child {\n    padding-left: 0 !important; }\n"

/***/ }),

/***/ "./web/modern/components/invoices/invoice-update/invoice-update.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var invoices_data_service_1 = __webpack_require__("./shared/services/invoice/invoices-data-service/invoices.data.service.ts");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var invoice_service_1 = __webpack_require__("./shared/services/invoice/invoice-service/invoice.service.ts");
var quotes_data_service_1 = __webpack_require__("./shared/services/quote/quotes-data-service/quotes.data.service.ts");
var Observable_1 = __webpack_require__("./node_modules/rxjs/Observable.js");
var jobs_data_service_1 = __webpack_require__("./shared/services/job/jobs.data.service.ts");
var settings_1 = __webpack_require__("./shared/services/settings/settings.ts");
var templates_data_service_1 = __webpack_require__("./shared/services/data-services/templates-data-service/templates.data.service.ts");
var contracts_data_service_1 = __webpack_require__("./shared/services/contract/contracts.data.service.ts");
var payments_schedules_data_service_1 = __webpack_require__("./shared/services/payments/payments-schedules-data-service/payments-schedules.data.service.ts");
var quote_update_service_1 = __webpack_require__("./shared/services/quote/quote-update.service.ts");
var product_packages_data_service_1 = __webpack_require__("./shared/services/settings/product-packages.data.service.ts");
var common_1 = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
var payment_schedule_1 = __webpack_require__("./web/modern/components/quotes/common/payment-schedule/payment-schedule.ts");
var time_service_1 = __webpack_require__("./shared/services/helpers/time-service/time.service.ts");
var stringModifier_service_1 = __webpack_require__("./shared/services/helpers/string-modifier-service/stringModifier.service.ts");
var save_as_template_modal_component_1 = __webpack_require__("./web/modern/components/quotes/modals/save-as-template-modal/save-as-template-modal.component.ts");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var save_new_template_modal_component_1 = __webpack_require__("./web/modern/components/quotes/modals/save-new-template-modal/save-new-template-modal.component.ts");
var deep_object_diff_1 = __webpack_require__("./node_modules/deep-object-diff/dist/index.js");
var confirm_general_modal_component_1 = __webpack_require__("./web/modern/components/common/confirm-general-modal/confirm-general-modal.component.ts");
var edit_contract_modal_component_1 = __webpack_require__("./web/modern/components/contract/edit-contract-modal/edit-contract-modal.component.ts");
var validation_service_1 = __webpack_require__("./shared/services/helpers/validation.service.ts");
var quote_invoice_templates_data_service_1 = __webpack_require__("./shared/services/quote-invoice-templates/quote-invoice-templates.data.service.ts");
var quote_invoice_templates_service_1 = __webpack_require__("./shared/services/quote-invoice-templates/quote-invoice-templates.service.ts");
var InvoiceUpdateComponent = function () {
    function InvoiceUpdateComponent(invoicesDataService, messageService, invoiceService, quoteDataService, jobDataService, settingsService, templatesDataService, contractDataService, paymentsSchedulesDataService, productPackagesDataService, quoteUpdateService, stringModifierService, timeService, location, modalService, qtTemplatesDataService, qtTemplatesService, contractsDataService, validationService) {
        _classCallCheck(this, InvoiceUpdateComponent);

        this.invoicesDataService = invoicesDataService;
        this.messageService = messageService;
        this.invoiceService = invoiceService;
        this.quoteDataService = quoteDataService;
        this.jobDataService = jobDataService;
        this.settingsService = settingsService;
        this.templatesDataService = templatesDataService;
        this.contractDataService = contractDataService;
        this.paymentsSchedulesDataService = paymentsSchedulesDataService;
        this.productPackagesDataService = productPackagesDataService;
        this.quoteUpdateService = quoteUpdateService;
        this.stringModifierService = stringModifierService;
        this.timeService = timeService;
        this.location = location;
        this.modalService = modalService;
        this.qtTemplatesDataService = qtTemplatesDataService;
        this.qtTemplatesService = qtTemplatesService;
        this.contractsDataService = contractsDataService;
        this.validationService = validationService;
        this.invoice = {};
        this.chosenPackages = [];
        this.payments = [];
        this.paymentsFromServer = [];
        this.contractsTemplates = [];
        this.questionnaireTemplates = [];
        this.invoiceTemplates = [];
        this.productsNames = [];
        this.discountsNames = [];
        this.products = [];
        this.discounts = [];
        // Data to save
        this.questionnaireToSaveId = '-1';
        this.contractToSaveId = '-1';
        this.contractToSave = null;
        this.notesToSave = null;
        this.paymentsToSave = [];
        this.initialDataAsTemplate = null;
        this.selectedInvoiceTemplateId = '-1';
        this.currencyFlag = false;
        this.contractFlag = false;
        this.unsubscribe = new Subject_1.Subject();
    }

    _createClass(InvoiceUpdateComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            if (this.dataToGetInvoice.invoiceID && this.dataToGetInvoice.isJob) {
                this.jobId = this.dataToGetInvoice.id;
                this.getInvoiceSourceData(this.dataToGetInvoice.invoiceID);
                this.editInvoice = true;
            } else if (this.dataToGetInvoice.invoiceID && !this.dataToGetInvoice.isJob) {
                this.getJobId(true);
                this.editInvoice = true;
            } else if (!this.dataToGetInvoice.invoiceID && this.dataToGetInvoice.isJob) {
                this.jobId = this.dataToGetInvoice.id;
                this.showNewInvoice(this.jobId);
            } else {
                this.getJobId(false);
            }
            this.getProductsTemplates();
            this.getBootstrapSettings();
        }
    }, {
        key: "ngAfterViewInit",
        value: function ngAfterViewInit() {
            this.registerUpdateProductSubscription();
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
            this.quoteUpdateService.setNextUpdateProduct(null, null);
        }
    }, {
        key: "addProduct",
        value: function addProduct() {
            this.products.push(quote_update_service_1.QuoteUpdateService.setEmptyProduct('ADD_ON'));
            this.updateInvoiceSummary(true);
        }
    }, {
        key: "addNewDiscount",
        value: function addNewDiscount() {
            this.discounts.push(quote_update_service_1.QuoteUpdateService.setEmptyProduct('GIFT'));
            this.updateInvoiceSummary(true);
        }
    }, {
        key: "saveInvoice",
        value: function saveInvoice() {
            this.buttonDisable = true;
            if (!this.validateInvoice()) {
                this.buttonDisable = false;
                return;
            }
            var data = this.gatherDataToSaveInvoice();
            if (this.editInvoice) {
                this.updateInvoice(data);
            } else {
                this.createInvoice(data);
            }
        }
    }, {
        key: "back",
        value: function back() {
            this.location.back();
        }
    }, {
        key: "setQuestionnaire",
        value: function setQuestionnaire(questionnaireId) {
            this.questionnaireToSaveId = questionnaireId;
        }
    }, {
        key: "setContract",
        value: function setContract(contractId) {
            this.contractTextSnapshot = null;
            this.contractToSaveId = contractId;
            this.getContractToEdit(contractId);
        }
    }, {
        key: "disableButtons",
        value: function disableButtons(isDisable) {
            this.buttonDisable = isDisable;
        }
    }, {
        key: "setPaymentScheduleId",
        value: function setPaymentScheduleId(payments) {
            this.paymentScheduleTemplateId = +payments.id;
            this.paymentsToSave = payments.payments;
        }
    }, {
        key: "onProductChange",
        value: function onProductChange() {
            this.updateInvoiceSummary(true);
        }
    }, {
        key: "confirmApplyInvoiceTemplate",
        value: function confirmApplyInvoiceTemplate(templateId) {
            var _this = this;

            if (this.isTemplateDataDiff()) {
                this.confirmTemplateChange().then(function () {
                    return _this.applyQuoteTemplate(templateId);
                }).catch(function () {
                    _this.invoiceTemplateSelect.nativeElement.value = _this.selectedInvoiceTemplateId;
                });
            } else {
                this.applyQuoteTemplate(templateId);
            }
        }
    }, {
        key: "applyQuoteTemplate",
        value: function applyQuoteTemplate(templateId) {
            var _this2 = this;

            this.selectedInvoiceTemplateId = templateId;
            if (templateId === '-1') {
                this.resetTemplateData();
                return;
            }
            this.loadingTemplate = true;
            this.qtTemplatesDataService.loadQtTemplate(templateId, 'INVOICE').pipe(operators_1.takeUntil(this.unsubscribe), operators_1.finalize(function () {
                return _this2.loadingTemplate = false;
            })).subscribe(function (_ref) {
                var data = _ref.data;
                return _this2.applyQuoteTemplateData(data);
            }, function (error) {
                _this2.selectedInvoiceTemplateId = '-1';
                _this2.messageService.handleError(error);
            });
        }
    }, {
        key: "applyQuoteTemplateData",
        value: function applyQuoteTemplateData(data) {
            this.selectedInvoiceTemplate = JSON.parse(JSON.stringify(data));
            this.modifyContractBodyForDiff(data.contractTemplate);
            this.modifyProductsForDiff(data.products);
            this.selectedInvoiceTemplate.notes = this.selectedInvoiceTemplate.notes || '';
            this.setProductsAndDiscounts(data.products);
            this.notesToSave = data.notes;
            this.invoice.notes = data.notes;
            this.getTemplatePayments(data);
            if (data.payments) {
                this.payments = this.addMissDateField(data.payments);
            } else {
                this.payments = [];
            }
            this.contractToSaveId = data.contractTemplate ? data.contractTemplate.id.toString() : '-1';
            this.questionnaireToSaveId = data.questionnaireTemplate ? data.questionnaireTemplate.id.toString() : '-1';
            this.contractTextSnapshot = null;
            this.getContractToEdit(this.contractToSaveId);
            this.updateInvoiceSummary(true);
        }
    }, {
        key: "getTemplatePayments",
        value: function getTemplatePayments(data) {
            var rule = data.paymentsRule;
            if (rule) {
                switch (rule.strategy) {
                    case 'NONE':
                        this.paymentScheduleTemplateId = -1;
                        break;
                    case 'NO_SPLIT_PAYMENTS':
                        this.paymentScheduleTemplateId = -2;
                        break;
                    case 'BY_PAYMENT_SCHEDULER':
                        var paymentScdl = rule.paymentSchedule;
                        if (paymentScdl) {
                            var check = this.paymentScheduleNames.some(function (el) {
                                return el.id === paymentScdl.id;
                            });
                            if (!check) {
                                this.paymentScheduleNames.push(Object.assign({}, paymentScdl));
                            }
                            this.paymentScheduleTemplateId = paymentScdl.id.toString();
                        }
                        break;
                    default:
                        this.paymentScheduleTemplateId = -2;
                }
            } else {
                if (data.paymentSchedule) {
                    var _check = this.paymentScheduleNames.some(function (el) {
                        return el.id === data.paymentSchedule.id;
                    });
                    if (!_check) {
                        this.paymentScheduleNames.push(Object.assign({}, data.paymentSchedule));
                    }
                }
                this.paymentScheduleTemplateId = data.paymentSchedule ? data.paymentSchedule.id.toString() : -1;
            }
        }
    }, {
        key: "resetTemplateData",
        value: function resetTemplateData() {
            var emptyTemplateData = null;
            if (this.editInvoice) {
                emptyTemplateData = JSON.parse(JSON.stringify(this.initialDataAsTemplate));
            } else {
                this.selectedPaymentSchedule = null;
                var desiredEmptyProduct = quote_update_service_1.QuoteUpdateService.setEmptyProduct('PACKAGE');
                desiredEmptyProduct.mandatory = true;
                emptyTemplateData = quote_invoice_templates_service_1.QuoteInvoiceTemplatesService.getEmptyQtItem('INVOICE', quote_update_service_1.QuoteUpdateService.setEmptyProduct('ADD_ON'));
            }
            this.applyQuoteTemplateData(emptyTemplateData);
        }
    }, {
        key: "isTemplateDataDiff",
        value: function isTemplateDataDiff() {
            var dataDiff = deep_object_diff_1.diff(this.qtTemplatesService.prepareQuoteInvoiceDataForDiff(this.selectedInvoiceTemplate), this.qtTemplatesService.prepareQuoteInvoiceDataForDiff(this.gatherQtDataForDiff()));
            return !!Object.keys(dataDiff).length;
        }
    }, {
        key: "gatherQtDataForDiff",
        value: function gatherQtDataForDiff() {
            var paymentSchedule = this.paymentScheduleTemplateId === -1 || this.paymentScheduleTemplateId === -2 ? null : this.qtTemplatesService.findTemplateItemById(this.paymentScheduleNames, this.paymentScheduleTemplateId);
            var questionnaireTemplate = this.questionnaireToSaveId === '-1' ? null : this.qtTemplatesService.findTemplateItemById(this.questionnaireTemplates, this.questionnaireToSaveId);
            return Object.assign({}, this.selectedInvoiceTemplate, { products: this.qtTemplatesService.prepareProductsForDiffInvoices([].concat(_toConsumableArray(this.products), _toConsumableArray(this.discounts))), notes: this.notesToSave || '', contractTemplate: this.contractToSave ? {
                    id: this.contractToSave.id,
                    text: this.contractToSave.text
                } : null, paymentSchedule: paymentSchedule,
                questionnaireTemplate: questionnaireTemplate });
        }
    }, {
        key: "modifyContractBodyForDiff",
        value: function modifyContractBodyForDiff(contract) {
            if (contract) {
                this.selectedInvoiceTemplate.contractTemplate = {
                    id: contract.id,
                    text: contract.text
                };
            }
        }
    }, {
        key: "modifyProductsForDiff",
        value: function modifyProductsForDiff(products) {
            if (products.length) {
                this.selectedInvoiceTemplate.products = this.qtTemplatesService.prepareProductsForDiffInvoices(products);
            }
        }
    }, {
        key: "confirmTemplateChange",
        value: function confirmTemplateChange() {
            var _this3 = this;

            return new Promise(function (resolve, reject) {
                var modal = _this3.modalService.openModal(confirm_general_modal_component_1.ConfirmGeneralModalComponent);
                modal.componentInstance.text = 'This invoice has unsaved changes. Are you sure you want to replace it with a template? Some data may be lost.';
                modal.componentInstance.buttons = [{
                    text: 'Yes',
                    color: 'success',
                    size: 'lg',
                    action: 'APPLY_TEMPLATE'
                }, {
                    text: 'No',
                    color: 'default',
                    size: 'lg',
                    action: 'CANCEL'
                }];
                modal.result.then(function (action) {
                    if (action === 'APPLY_TEMPLATE') {
                        resolve();
                    }
                    if (action === 'CANCEL') {
                        reject();
                    }
                });
            });
        }
    }, {
        key: "saveAsTemplate",
        value: function saveAsTemplate() {
            var _this4 = this;

            var payload = this.validateAndGatherTemplate('Test Name');
            if (payload) {
                if (!this.validateContractEditing()) {
                    return;
                }
                var modal = this.modalService.openModal(save_as_template_modal_component_1.SaveAsTemplateModalComponent, {
                    windowClass: 'ng-bootstrap-modal'
                });
                modal.componentInstance.templateList = this.invoiceTemplates;
                modal.componentInstance.templateTypeName = 'Invoice';
                modal.componentInstance.templateNameTitle = 'Invoice';
                modal.componentInstance.breadcrumbsText = 'Invoice Templates will be saved in Settings > Quote & Invoice Templates';
                var modalSubscription$ = this.modalService.modalData.subscribe(function (data) {
                    var closeModal = function closeModal() {
                        _this4.modalService.closeModalByRef(modal, modalSubscription$);
                    };
                    _this4.handleSaveAsTemplateResponse(data, modal, payload, closeModal.bind(_this4));
                });
            }
        }
    }, {
        key: "saveNewTemplate",
        value: function saveNewTemplate(payload) {
            var _this5 = this;

            var modal = this.modalService.openModal(save_new_template_modal_component_1.SaveNewTemplateModalComponent, {
                windowClass: 'ng-bootstrap-modal'
            });
            modal.componentInstance.templateTypeName = 'Invoice';
            modal.componentInstance.templateNameTitle = 'Invoice';
            modal.componentInstance.breadcrumbsText = 'Invoice Templates will be saved in Settings > Quote & Invoice Templates';
            modal.componentInstance.templateNameProp = this.selectedInvoiceTemplate.name;
            var modalSubscription$ = this.modalService.modalData.subscribe(function (data) {
                var closeModal = function closeModal() {
                    _this5.modalService.closeModalByRef(modal, modalSubscription$);
                };
                _this5.handleSaveNewTemplateResponse(data, modal, payload, closeModal.bind(_this5));
            });
        }
    }, {
        key: "handleSaveNewTemplateResponse",
        value: function handleSaveNewTemplateResponse(data, modalRef, payload, closeModal) {
            var _this6 = this;

            if (data.action === 'CLOSE') {
                this.saveAsTemplate();
                closeModal();
            }
            if (data.action === 'SAVE') {
                if (!data.props) {
                    if (!data.props || data.props && !data.props.trim()) {
                        this.messageService.showToaster('e_4', 'quoteInvoiceTemplates', 'invoice');
                        return null;
                    }
                }
                var dataToSave = JSON.parse(JSON.stringify(payload));
                dataToSave.data.name = data.props;
                modalRef.componentInstance.btnDisable = true;
                this.qtTemplatesDataService.saveTemplate('INVOICE', dataToSave).pipe(operators_1.takeUntil(this.unsubscribe), operators_1.finalize(function () {
                    return modalRef.componentInstance.btnDisable = false;
                })).subscribe(function (_ref2) {
                    var data = _ref2.data;

                    closeModal();
                    _this6.loadInvoiceTemplates();
                    _this6.messageService.showToaster('s_6', 'quoteInvoiceTemplates', data.name);
                    _this6.selectedInvoiceTemplateId = data.id;
                    _this6.selectedInvoiceTemplate.name = data.name;
                    localStorage.setItem('keyToScroll', 'invoice');
                    window.open(location.origin + "/settings/quote_invoice_templates");
                }, function (error) {
                    return _this6.messageService.handleError(error);
                });
            }
        }
    }, {
        key: "handleSaveAsTemplateResponse",
        value: function handleSaveAsTemplateResponse(data, modalRef, payload, closeModal) {
            var _this7 = this;

            if (data.action === 'CLOSE') {
                closeModal();
            }
            if (data.action === 'SAVE') {
                closeModal();
                this.saveNewTemplate(payload);
            }
            if (data.action === 'OVERWRITE') {
                if (!data.props) {
                    this.messageService.showToaster('e_2', 'quoteInvoiceTemplates');
                    return;
                }
                var dataToSave = JSON.parse(JSON.stringify(payload));
                dataToSave.data.name = data.props.name;
                modalRef.componentInstance.btnDisable = true;
                this.qtTemplatesDataService.editTemplate('INVOICE', data.props.id.toString(), dataToSave).pipe(operators_1.takeUntil(this.unsubscribe), operators_1.finalize(function () {
                    return modalRef.componentInstance.btnDisable = false;
                })).subscribe(function (_ref3) {
                    var data = _ref3.data;

                    _this7.messageService.showToaster('s_1', 'quoteInvoiceTemplates', 'invoice');
                    _this7.selectedInvoiceTemplateId = data.id;
                    closeModal();
                }, function (error) {
                    return _this7.messageService.handleError(error);
                });
            }
        }
    }, {
        key: "validateContractEditing",
        value: function validateContractEditing() {
            if (this.contractTextSnapshot && this.validationService.trimHTML(this.contractTextSnapshot) !== this.validationService.trimHTML(this.contractToSave.text)) {
                this.confirmEditingContract(this.contractToSave);
                return false;
            }
            return true;
        }
    }, {
        key: "confirmEditingContract",
        value: function confirmEditingContract(contract) {
            var _this8 = this;

            if (contract) {
                var modal = this.modalService.openModal(save_as_template_modal_component_1.SaveAsTemplateModalComponent, {
                    windowClass: 'ng-bootstrap-modal'
                });
                modal.componentInstance.templateList = this.contractsTemplates;
                modal.componentInstance.templateTypeName = 'Contract';
                modal.componentInstance.templateNameTitle = 'Contract';
                modal.componentInstance.breadcrumbsText = 'Contract Templates will be saved in Settings > Contract Templates';
                modal.componentInstance.detailedDescription = 'Your contract has been edited and will need to be saved as a Contract Template.';
                var modalSubscription$ = this.modalService.modalData.subscribe(function (res) {
                    if (res.action === 'CLOSE') {
                        _this8.modalService.closeModalByRef(modal, modalSubscription$);
                    }
                    if (res.action === 'SAVE') {
                        _this8.modalService.closeModalByRef(modal, modalSubscription$);
                        _this8.saveNewContractTemplate(contract);
                    }
                    if (res.action === 'OVERWRITE') {
                        if (!res.props) {
                            _this8.messageService.showToaster('e_2', 'quoteInvoiceTemplates');
                            return;
                        }
                        modal.componentInstance.btnDisable = true;
                        var newContract = Object.assign({}, res.props, { text: _this8.contractToSave.text });
                        _this8.contractsDataService.overwriteContractTemplate(res.props.templateId.toString(), newContract).pipe(operators_1.takeUntil(_this8.unsubscribe), operators_1.finalize(function () {
                            return modal.componentInstance.btnDisable = false;
                        })).subscribe(function (_ref4) {
                            var data = _ref4.data;

                            _this8.messageService.showToaster('s_2', 'contractTemplates', contract.name);
                            _this8.contractToSaveId = data.id.toString();
                            _this8.contractToSave = data;
                            _this8.modalService.closeModalByRef(modal, modalSubscription$);
                            _this8.contractTextSnapshot = null;
                            _this8.saveAsTemplate();
                        }, function (error) {
                            return _this8.messageService.handleError(error);
                        });
                    }
                });
            }
        }
    }, {
        key: "saveNewContractTemplate",
        value: function saveNewContractTemplate(contract) {
            var _this9 = this;

            var modal = this.modalService.openModal(save_new_template_modal_component_1.SaveNewTemplateModalComponent, {
                windowClass: 'ng-bootstrap-modal'
            });
            modal.componentInstance.templateTypeName = 'Contract';
            modal.componentInstance.templateNameTitle = 'Contract';
            modal.componentInstance.breadcrumbsText = 'Contract Templates will be saved in Settings > Contract Templates';
            modal.componentInstance.templateNameProp = contract.name;
            var modalSubscription$ = this.modalService.modalData.subscribe(function (res) {
                if (res.action === 'CLOSE') {
                    _this9.confirmEditingContract(contract);
                    _this9.modalService.closeModalByRef(modal, modalSubscription$);
                }
                if (res.action === 'SAVE') {
                    if (!res.props || res.props && !res.props.trim()) {
                        _this9.messageService.showToaster('e_3', 'quoteInvoiceTemplates');
                        return;
                    }
                    var newContract = JSON.parse(JSON.stringify(contract));
                    newContract.name = res.props;
                    modal.componentInstance.btnDisable = true;
                    _this9.contractsDataService.saveNewContractTemplate(newContract).pipe(operators_1.takeUntil(_this9.unsubscribe), operators_1.finalize(function () {
                        return modal.componentInstance.btnDisable = false;
                    })).subscribe(function (_ref5) {
                        var data = _ref5.data;

                        _this9.modalService.closeModalByRef(modal, modalSubscription$);
                        _this9.messageService.showToaster('s_5', 'quoteInvoiceTemplates', newContract.name);
                        _this9.contractTextSnapshot = null;
                        Observable_1.Observable.zip(_this9.templatesDataService.getTemplates('contract_preview'), _this9.getInitialContract()).subscribe(function (_ref6) {
                            var _ref7 = _slicedToArray(_ref6, 2),
                                contractTemplates = _ref7[0],
                                contractData = _ref7[1];

                            var contract = contractData ? contractData.contract : null;
                            _this9.contractsTemplates = contractTemplates.contractTemplates;
                            if (data) {
                                _this9.setContractSources(data);
                            } else if (contract) {
                                _this9.qtTemplatesService.addSelectedTemplate(_this9.contractsTemplates, Object.assign({}, contract, { templateId: contract.id }));
                                _this9.linkedContract = contract;
                                _this9.setContractSources(contract);
                            }
                            _this9.saveAsTemplate();
                        });
                    }, function (error) {
                        return _this9.messageService.handleError(error);
                    });
                }
            });
        }
    }, {
        key: "validateAndGatherTemplate",
        value: function validateAndGatherTemplate(templateName) {
            var paymentScheduleTemplateId = this.paymentScheduleTemplateId !== 0 ? this.paymentScheduleTemplateId : this.paymentScheduleIdFromServer;
            var data = {
                contractTemplateId: this.contractToSave ? this.contractToSave.id.toString() : null,
                questionnaireTemplateId: this.questionnaireToSaveId ? this.questionnaireToSaveId.toString() : null,
                paymentSchedulerTemplateId: paymentScheduleTemplateId ? paymentScheduleTemplateId.toString() : null,
                data: {
                    products: this.qtTemplatesService.mapLineItems([].concat(_toConsumableArray(this.products), _toConsumableArray(this.discounts))),
                    name: templateName,
                    notes: this.notesToSave
                },
                summary: this.summary
            };
            if (!this.qtTemplatesService.validateSelectedTemplates(data, this.contractsTemplates, this.questionnaireTemplates, 'INVOICE')) {
                return null;
            }
            if (!this.qtTemplatesService.validateInvoiceTemplate(data)) {
                return null;
            }
            return this.qtTemplatesService.prepareTemplateForSave(data);
        }
    }, {
        key: "assignInitialDataAsTemplate",
        value: function assignInitialDataAsTemplate(invoice, contract) {
            this.initialDataAsTemplate = this.qtTemplatesService.createTemplateDataFromInvoice(invoice, contract, 'INVOICE');
            this.selectedInvoiceTemplate = JSON.parse(JSON.stringify(this.initialDataAsTemplate));
            this.modifyContractBodyForDiff(contract);
            this.modifyProductsForDiff(this.editInvoice ? invoice.summary.items : [].concat(_toConsumableArray(this.products)));
        }
    }, {
        key: "registerUpdateProductSubscription",
        value: function registerUpdateProductSubscription() {
            var _this10 = this;

            this.quoteUpdateService.updatedProductObservable.pipe(operators_1.takeUntil(this.unsubscribe), operators_1.filter(function (product) {
                return product !== null;
            })).subscribe(function (updatedProduct) {
                if (_this10.quoteUpdateService.validateProductsPropsDefined(_this10.products)) {
                    _this10.updateInvoiceSummary(true);
                }
            });
        }
    }, {
        key: "updateInvoiceProductProperties",
        value: function updateInvoiceProductProperties(product) {
            var _this11 = this;

            this.products.forEach(function (packageItem, index) {
                if (index === product.index) {
                    _this11.products[index].price = product.product.price;
                    _this11.products[index].quantity = product.product.quantity;
                    _this11.products[index].discount = product.product.discount;
                    _this11.products[index].taxType = product.product.taxType;
                    _this11.products[index].amount = product.product.amount;
                }
            });
        }
    }, {
        key: "showNewInvoice",
        value: function showNewInvoice(jobId) {
            this.paymentScheduleTemplateId = -2;
            this.selectedPaymentSchedule = null;
            this.setInvoiceIdAndDate(jobId);
            this.getNewInvoice();
            this.loadInvoiceTemplates();
            this.getPaymentsSchedules(null);
        }
    }, {
        key: "getJobId",
        value: function getJobId(makeRequest) {
            var _this12 = this;

            this.leadId = this.dataToGetInvoice.id;
            this.quoteDataService.getJobId(this.leadId).pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (data) {
                _this12.jobId = data;
                _this12.dataToGetInvoice.id = _this12.jobId;
                if (makeRequest) {
                    _this12.getInvoiceSourceData(_this12.dataToGetInvoice.invoiceID);
                } else {
                    _this12.showNewInvoice(_this12.jobId);
                }
            });
        }
    }, {
        key: "getInvoiceSourceData",
        value: function getInvoiceSourceData(id) {
            var _this13 = this;

            this.invoicesDataService.getInvoiceForUpdate(id).pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (data) {
                _this13.successGetInvoiceData(data);
                _this13.getPaymentsSchedules(data.paymentsRule);
            }, function (error) {
                return _this13.messageService.showDefaultErrorMessage(error);
            });
        }
    }, {
        key: "successGetInvoiceData",
        value: function successGetInvoiceData(invoice) {
            this.invoice = JSON.parse(JSON.stringify(invoice));
            this.job = this.invoice.job;
            if (invoice.paymentSchedule && invoice.paymentSchedule.id) {
                this.job.paymentScheduleId = invoice.paymentSchedule.id;
            }
            this.setMainInfoData(invoice.invoiceId, this.quoteUpdateService.setQuoteIssueDate(invoice.issueDate), this.invoice.poNumber);
            this.setInvoiceSources(invoice);
            this.loadInvoiceTemplates();
        }
    }, {
        key: "setInvoiceSources",
        value: function setInvoiceSources(invoice) {
            var contract = invoice.contract,
                currencyAndTaxes = invoice.currencyAndTaxes,
                paymentSchedule = invoice.paymentSchedule,
                payments = invoice.payments,
                questionnaire = invoice.questionnaire,
                paymentsRule = invoice.paymentsRule;

            this.currencyAndTax = currencyAndTaxes;
            if (paymentSchedule === null) {
                if (paymentsRule.strategy === 'NO_SPLIT_PAYMENTS') {
                    this.paymentScheduleTemplateId = -2;
                } else if (paymentsRule.strategy === 'NONE') {
                    this.paymentScheduleTemplateId = -1;
                }
            } else {
                this.paymentScheduleIdFromServer = paymentSchedule.id;
            }
            this.payments = this.addMissDateField(payments);
            this.paymentsFromServer = payments;
            this.paymentSchedule = paymentSchedule;
            if (contract !== null) {
                this.contract = contract;
            }
            if (questionnaire !== null) {
                this.questionnaireToSaveId = questionnaire.id;
                this.questionnaire = questionnaire;
            }
            this.setProductsAndDiscounts(invoice.summary.items);
            this.notesToSave = invoice.notes;
            this.summary = invoice.summary;
            this.getContractAndQuestionnaireInfo();
        }
    }, {
        key: "setProductsAndDiscounts",
        value: function setProductsAndDiscounts(items) {
            var _quote_update_service = quote_update_service_1.QuoteUpdateService.separateDiscountsAndProducts([].concat(_toConsumableArray(items))),
                addons = _quote_update_service.addons,
                discounts = _quote_update_service.discounts;

            this.products = addons;
            this.discounts = discounts;
        }
    }, {
        key: "updateInvoiceSummary",
        value: function updateInvoiceSummary(needToUpdatePayments) {
            var _this14 = this;

            var productsToCalculate = this.getProductsToSaveInvoice(false);
            // setTimeout fixes issue on Safari when id of product changes with delay
            setTimeout(function () {
                if (productsToCalculate && _this14.currencyAndTax) {
                    _this14.quoteDataService.calculateProductsSummary(productsToCalculate, _this14.currencyAndTax.percentage, _this14.currencyAndTax.currency.symbol).pipe(operators_1.takeUntil(_this14.unsubscribe)).subscribe(function (data) {
                        return _this14.successUpdatePricesCalculation(data, needToUpdatePayments, productsToCalculate);
                    }, function (error) {
                        return _this14.messageService.showDefaultErrorMessage(error);
                    });
                }
            }, 0);
        }
    }, {
        key: "successUpdatePricesCalculation",
        value: function successUpdatePricesCalculation(data, needToUpdatePayments, productsToCalculate) {
            var _this15 = this;

            this.summary = data;
            if (this.job && this.invoice && this.paymentScheduleNames && needToUpdatePayments && productsToCalculate.length > 0) {
                this.paymentScheduleComponent.getPaymentScheduleNew(this.paymentScheduleTemplateId, true, this.summary.total);
            } else if (this.summary && this.summary.total === 0) {
                setTimeout(function () {
                    _this15.paymentScheduleComponent.hideAndResetPaymentSchedule();
                }, 500);
            }
        }
    }, {
        key: "successGetCurrencyAndTaxes",
        value: function successGetCurrencyAndTaxes(data) {
            this.currencyAndTax = {
                currency: {
                    symbol: data.currencyDTO.symbol
                },
                percentage: data.percentage,
                taxName: data.taxName
            };
            this.updateInvoiceSummary(false);
        }
    }, {
        key: "setMainInfoData",
        value: function setMainInfoData(invoiceId, issueDate, poNumber) {
            this.mainInfoDataToSave = {
                invoiceId: invoiceId,
                issueDate: issueDate,
                poNumber: poNumber
            };
        }
    }, {
        key: "addMissDateField",
        value: function addMissDateField() {
            var payments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

            if (!payments) {
                return [];
            }
            return payments.map(function (payment) {
                return Object.assign(payment, { paymentDate: payment.due });
            });
        }
        /* API section and Service call section */

    }, {
        key: "getNewInvoice",
        value: function getNewInvoice() {
            var _this16 = this;

            this.jobDataService.getQuoteInvoiceJob(this.dataToGetInvoice.id).pipe(operators_1.takeUntil(this.unsubscribe), operators_1.map(function (res) {
                return res.data;
            })).subscribe(function (job) {
                return _this16.job = job;
            });
        }
    }, {
        key: "getCurrencyAndTaxes",
        value: function getCurrencyAndTaxes() {
            var _this17 = this;

            this.settingsService.getCurrencyAndTaxes().pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (data) {
                _this17.successGetCurrencyAndTaxes(data);
                _this17.currencyFlag = true;
            }, function (error) {
                return _this17.messageService.showDefaultErrorMessage(error);
            });
        }
    }, {
        key: "setInvoiceIdAndDate",
        value: function setInvoiceIdAndDate(id) {
            var _this18 = this;

            this.invoicesDataService.getInvoiceIdAndDate(id).pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (data) {
                _this18.setMainInfoData(data.invoiceId, _this18.quoteUpdateService.setQuoteIssueDate(data.issueDate), null);
                _this18.getCurrencyAndTaxes();
                _this18.getContractAndQuestionnaireInfo();
                // TODO - refactor
                var intervalCounter = 0;
                var interval = setInterval(function () {
                    if (_this18.currencyFlag) {
                        if (!_this18.editInvoice) {
                            _this18.addProduct();
                        }
                        _this18.currencyFlag = false;
                        intervalCounter++;
                    }
                    if (_this18.contractFlag && intervalCounter == 1) {
                        _this18.assignInitialDataAsTemplate(_this18.invoice, _this18.linkedContract);
                        _this18.contractFlag = false;
                        intervalCounter++;
                    }
                    if (intervalCounter > 1) {
                        clearInterval(interval);
                    }
                }, 200);
            });
        }
    }, {
        key: "getInitialContract",
        value: function getInitialContract() {
            if (this.contract) {
                this.currentContractId = this.contract.id;
                return this.contractDataService.getContract(this.job.id, this.contract.id);
            }
            return new Observable_1.Observable(function (observer) {
                observer.next(null);
            });
        }
    }, {
        key: "getProductsTemplates",
        value: function getProductsTemplates() {
            var _this19 = this;

            var pageRequest = quote_update_service_1.QuoteUpdateService.getPageRequest();
            this.productPackagesDataService.getPackagesOrProducts(pageRequest).subscribe(function (data) {
                _this19.setProductsAndDiscountsNames(data.items);
            }, function (error) {
                return _this19.messageService.showDefaultErrorMessage(error);
            });
        }
    }, {
        key: "setProductsAndDiscountsNames",
        value: function setProductsAndDiscountsNames(products) {
            var _quote_update_service2 = quote_update_service_1.QuoteUpdateService.setPackagesAndAddons(products),
                packages = _quote_update_service2.packages,
                addons = _quote_update_service2.addons,
                discounts = _quote_update_service2.discounts;

            this.productsNames = packages.concat(addons);
            this.discountsNames = discounts;
        }
    }, {
        key: "loadInvoiceTemplates",
        value: function loadInvoiceTemplates() {
            var _this20 = this;

            this.qtTemplatesDataService.getInvoiceTemplatesList(quote_invoice_templates_service_1.QuoteInvoiceTemplatesService.getTemplatesParameters()).pipe(operators_1.takeUntil(this.unsubscribe), operators_1.map(function (_ref8) {
                var data = _ref8.data;
                return data ? data.samples.items : [];
            })).subscribe(function (templates) {
                return _this20.invoiceTemplates = templates;
            }, function (error) {
                return _this20.messageService.handleError(error);
            });
        }
    }, {
        key: "getBootstrapSettings",
        value: function getBootstrapSettings() {
            var _this21 = this;

            this.settingsService.timeFormatSettings.pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (data) {
                _this21.setCorrectDateFormat(data.dateFormat);
                _this21.invoiceTemplatesAvailable = data.qtTemplatesAvailable;
            });
        }
    }, {
        key: "setCorrectDateFormat",
        value: function setCorrectDateFormat(format) {
            switch (format) {
                case 'DD_MM_YYYY':
                    this.datePlaceholder = 'dd/mm/yyyy';
                    break;
                case 'MM_DD_YYYY':
                    this.datePlaceholder = 'mm/dd/yyyy';
                    break;
                default:
                    this.datePlaceholder = '';
                    break;
            }
        }
    }, {
        key: "getPaymentsSchedules",
        value: function getPaymentsSchedules(paymentsRule) {
            var _this22 = this;

            var params = {
                perPage: 500,
                page: 1,
                predicate: 'name',
                reverse: false
            };
            this.paymentsSchedulesDataService.getPaymentsSchedules(params).subscribe(function (data) {
                if (paymentsRule && paymentsRule.strategy === 'NONE') {
                    _this22.defaultPaymentScheduleNames = [{
                        id: -1,
                        name: 'Choose Payment Schedule',
                        disabled: true
                    }, {
                        id: -2,
                        name: 'No Split Payments',
                        disabled: false
                    }];
                } else {
                    _this22.defaultPaymentScheduleNames = [{
                        id: -2,
                        name: 'No split payments',
                        disabled: false
                    }];
                }
                _this22.paymentScheduleNames = data.results;
            }, function (error) {
                return _this22.messageService.showDefaultErrorMessage(error);
            });
        }
    }, {
        key: "getContractAndQuestionnaireInfo",
        value: function getContractAndQuestionnaireInfo() {
            var _this23 = this;

            Observable_1.Observable.zip(this.templatesDataService.getTemplates('contract_preview'), this.templatesDataService.getTemplates('questionnaire_preview'), this.getInitialContract()).subscribe(function (_ref9) {
                var _ref10 = _slicedToArray(_ref9, 3),
                    contractTemplates = _ref10[0],
                    questionnaireTemplates = _ref10[1],
                    contractData = _ref10[2];

                var contract = contractData ? contractData.contract : null;
                _this23.contractsTemplates = contractTemplates.contractTemplates;
                _this23.questionnaireTemplates = questionnaireTemplates.questionnaireTemplates;
                _this23.qtTemplatesService.addSelectedTemplate(_this23.questionnaireTemplates, _this23.questionnaire);
                if (contract) {
                    _this23.qtTemplatesService.addSelectedTemplate(_this23.contractsTemplates, Object.assign({}, contract, { templateId: contract.id }));
                    _this23.linkedContract = contract;
                    _this23.setContractSources(contract);
                } else {
                    _this23.linkedContract = null;
                }
                _this23.contractFlag = true;
                _this23.assignInitialDataAsTemplate(_this23.invoice, contract);
            }, function (error) {
                return _this23.messageService.showDefaultErrorMessage(error);
            });
        }
    }, {
        key: "setContractSources",
        value: function setContractSources(contract) {
            this.contractToSave = JSON.parse(JSON.stringify(contract));
            this.contractToSaveId = contract.id.toString();
        }
    }, {
        key: "getContractToEdit",
        value: function getContractToEdit(contractId) {
            var _this24 = this;

            if (contractId === '-1') {
                this.contractToSave = null;
                return;
            }
            if (this.linkedContract && contractId === this.linkedContract.id.toString()) {
                this.contractToSave = JSON.parse(JSON.stringify(this.linkedContract));
                return;
            }
            if (this.contractToSaveId) {
                this.buttonDisable = true;
                this.templatesDataService.getTemplates('contract_full', +this.contractToSaveId).pipe(operators_1.takeUntil(this.unsubscribe), operators_1.finalize(function () {
                    return _this24.buttonDisable = false;
                })).subscribe(function (contract) {
                    _this24.contractToSave = JSON.parse(JSON.stringify(contract));
                }, function (error) {
                    return _this24.messageService.showDefaultErrorMessage(error);
                });
            }
        }
    }, {
        key: "openEditSelectContract",
        value: function openEditSelectContract() {
            var selectedModalRef = this.modalService.openModal(edit_contract_modal_component_1.EditContractModalComponent, {
                windowClass: 'ng-bootstrap-modal modal-visible'
            });
            selectedModalRef.componentInstance.isFixed = true;
            selectedModalRef.componentInstance.contractToEdit = JSON.parse(JSON.stringify(this.contractToSave));
            selectedModalRef.componentInstance.action = 'SAVE_CONTRACT';
            this.contractTextSnapshot = this.contractToSave.text;
            this.subscribeToEditContractData(selectedModalRef);
        }
    }, {
        key: "subscribeToEditContractData",
        value: function subscribeToEditContractData(modalRef) {
            var _this25 = this;

            var modalDataSubscription = this.modalService.getModalData().subscribe(function (data) {
                if (data) {
                    var action = data.action,
                        props = data.props;

                    if (action === 'SAVE_CONTRACT') {
                        _this25.saveEditedContract(props);
                        _this25.modalService.closeModalByRef(modalRef, modalDataSubscription);
                    }
                    if (action === 'CLOSE_MODAL') {
                        _this25.modalService.closeModalByRef(modalRef, modalDataSubscription);
                    }
                }
            });
        }
    }, {
        key: "saveEditedContract",
        value: function saveEditedContract(contract) {
            if (contract && contract.name) {
                contract.name = this.stringModifierService.cutSelectedText(contract.name);
                this.messageService.showToaster('s_2', 'contractTemplates', contract.name);
            }
            this.contractToSave = JSON.parse(JSON.stringify(contract));
        }
        /* Invoice validation and saving/updating section */

    }, {
        key: "validateInvoice",
        value: function validateInvoice() {
            var dataToValidate = {
                amount: this.summary.subTotal,
                packages: [],
                payments: this.payments,
                paymentScheduleTemplateId: this.paymentScheduleTemplateId,
                discount: this.summary.discountValue,
                xeroStatus: this.invoice.xeroStatus,
                qbStatus: this.invoice.qbStatus,
                totalDue: this.summary.total,
                poNumber: this.mainInfoDataToSave.poNumber,
                pageName: 'invoicePage'
            };
            dataToValidate.packages = this.invoiceService.checkProductPackagesCorrectType(this.getProductsToSaveInvoice(false));
            if (this.paymentsToSave.find(function (payment) {
                return !payment.date && !payment.paymentDateWithRule.ruleExplanationHTML;
            }) !== undefined) {
                this.messageService.showToaster('e_11', 'editQuote');
                return false;
            }
            return this.invoiceService.isInvoiceValid(dataToValidate);
        }
    }, {
        key: "getPaymentStrategy",
        value: function getPaymentStrategy() {
            switch (this.paymentScheduleTemplateId) {
                case -2:
                    return 'NO_SPLIT_PAYMENTS';
                default:
                    return 'BY_PAYMENT_SCHEDULER';
            }
        }
    }, {
        key: "gatherDataToSaveInvoice",
        value: function gatherDataToSaveInvoice() {
            return {
                invoiceData: {
                    displayId: this.mainInfoDataToSave.invoiceId,
                    issueDate: this.timeService.getDateInFormat(this.mainInfoDataToSave.issueDate.jsdate, 'date'),
                    poNumber: this.mainInfoDataToSave.poNumber,
                    jobId: this.jobId,
                    paymentScheduleId: this.setPaymentScheduleIdForSave(this.summary.total === 0 ? -2 : this.paymentScheduleTemplateId),
                    notes: this.notesToSave,
                    packages: this.getProductsToSaveInvoice(true),
                    payments: this.summary.total === 0 ? [] : this.getPaymentsToSave(),
                    paymentsStrategy: this.getPaymentStrategy()
                },
                removeContract: this.contractToSave === null,
                removeQuestionnaire: this.questionnaireToSaveId === '-1',
                questionnaire: this.getQuestionnaireState() ? {
                    templateId: this.questionnaireToSaveId
                } : null,
                contract: this.contractToSave && this.contractToSave.signed ? null : this.getContractToSave()
            };
        }
    }, {
        key: "getProductsToSaveInvoice",
        value: function getProductsToSaveInvoice(needToRemoveId) {
            var _this26 = this;

            this.products = quote_update_service_1.QuoteUpdateService.setFixedQuoteProducts(this.products);
            var productsToSave = this.products.map(function (productItem, index) {
                return Object.assign(productItem, {
                    id: productItem.fromSettings && needToRemoveId ? null : productItem.id,
                    order: index,
                    price: needToRemoveId ? _this26.stringModifierService.convertAmountIntoNumber(productItem.price) : productItem.price
                });
            });
            this.discounts.forEach(function (discount, index) {
                productsToSave.push(Object.assign(discount, {
                    id: discount.fromSettings && needToRemoveId ? null : discount.id,
                    order: index,
                    price: _this26.stringModifierService.convertAmountIntoNumber(discount.price),
                    taxType: _this26.setTaxTypeForDiscount(productsToSave, discount.taxType)
                }));
            });
            return productsToSave;
        }
    }, {
        key: "setTaxTypeForDiscount",
        value: function setTaxTypeForDiscount(productsToSave, previousTax) {
            return productsToSave[0] ? productsToSave[0].taxType : previousTax;
        }
    }, {
        key: "setPaymentScheduleIdForSave",
        value: function setPaymentScheduleIdForSave(id) {
            switch (+id) {
                case 0:
                    return this.paymentScheduleIdFromServer;
                case -1:
                case -2:
                    return null;
                default:
                    return this.paymentScheduleTemplateId;
            }
        }
    }, {
        key: "getContractToSave",
        value: function getContractToSave() {
            if (this.contractToSave) {
                this.contractToSave.name = this.stringModifierService.cutSelectedText(this.contractToSave.name);
                /* Fix changed field for GDPR */
                if (this.contractToSave.optInConsentStatement) {
                    this.contractToSave.optInConsent = this.contractToSave.optInConsentStatement;
                    delete this.contractToSave.optInConsentStatement;
                }
                /*
                Fix backend grammar mistake
                showOTPinconsent => showOPTinconsent
                */
                if (this.contractToSave.showOtpInConsent) {
                    this.contractToSave.showOptInConsent = this.contractToSave.showOtpInConsent;
                    delete this.contractToSave.showOtpInConsen;
                }
                if (this.currentContractId === this.contractToSave.id) {
                    this.contractToSave.contractId = this.currentContractId;
                } else {
                    this.contractToSave.contractId = null;
                }
            }
            return this.contractToSave;
        }
    }, {
        key: "getPaymentsToSave",
        value: function getPaymentsToSave() {
            var _this27 = this;

            return this.paymentsToSave.map(function (payment) {
                var paymentToSave = void 0;
                if (payment.date) {
                    var date = _this27.quoteUpdateService.getDate(payment.date.jsdate);
                    paymentToSave = Object.assign(payment, {
                        paymentDate: date,
                        due: date
                    });
                } else if (!payment.date && payment.paymentDateWithRule && payment.paymentDateWithRule.ruleExplanationHTML) {
                    paymentToSave = Object.assign(payment, {
                        paymentDate: null
                    });
                } else {
                    paymentToSave = payment;
                }
                return paymentToSave;
            });
        }
    }, {
        key: "getQuestionnaireState",
        value: function getQuestionnaireState() {
            var isQuestionnaireChanged = true;
            // Check if questionnaire wasn't changed during invoice update
            if (this.questionnaire && +this.questionnaireToSaveId === this.questionnaire.id) {
                isQuestionnaireChanged = false;
            }
            // Check if we do not have selected questionnaire on invoice create
            if (!this.questionnaire && !this.questionnaireToSaveId || this.questionnaireToSaveId === '-1') {
                isQuestionnaireChanged = false;
            }
            return isQuestionnaireChanged;
        }
    }, {
        key: "isContractSigned",
        value: function isContractSigned() {
            var _contractToSave = this.contractToSave,
                signed = _contractToSave.signed,
                signatures = _contractToSave.signatures;

            if (signatures) {
                var photographerSignature = signatures.photographerSignature,
                    primarySignature = signatures.primarySignature,
                    secondarySignature = signatures.secondarySignature;

                return signed || photographerSignature || primarySignature || secondarySignature;
            }
            return signed;
        }
    }, {
        key: "updateInvoice",
        value: function updateInvoice(saveData) {
            var _this28 = this;

            this.invoicesDataService.updateInvoice(this.dataToGetInvoice.invoiceID, saveData).pipe(operators_1.takeUntil(this.unsubscribe), operators_1.finalize(function () {
                return _this28.buttonDisable = false;
            })).subscribe(function (data) {
                return _this28.successCreateInvoice(data);
            }, function (error) {
                return _this28.invoiceService.errorSaveInvoice(error, _this28.mainInfoDataToSave.invoiceId);
            });
        }
    }, {
        key: "createInvoice",
        value: function createInvoice(saveData) {
            var _this29 = this;

            this.invoicesDataService.saveNewInvoice(this.jobId, saveData).pipe(operators_1.takeUntil(this.unsubscribe), operators_1.finalize(function () {
                return _this29.buttonDisable = false;
            })).subscribe(function (data) {
                return _this29.successCreateInvoice(data);
            }, function (error) {
                return _this29.invoiceService.errorSaveInvoice(error, _this29.mainInfoDataToSave.invoiceId);
            });
        }
    }, {
        key: "successCreateInvoice",
        value: function successCreateInvoice(data) {
            var _this30 = this;

            this.invoiceService.successCreateInvoice(data).then(function (id) {
                if (id) {
                    _this30.location.go("/invoices/" + id);
                } else {
                    _this30.location.back();
                }
            });
        }
    }]);

    return InvoiceUpdateComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], InvoiceUpdateComponent.prototype, "dataToGetInvoice", void 0);
__decorate([core_1.ViewChild('paymentScheduleComponent'), __metadata("design:type", payment_schedule_1.PaymentScheduleComponent)], InvoiceUpdateComponent.prototype, "paymentScheduleComponent", void 0);
__decorate([core_1.ViewChild('invoiceTemplateSelect'), __metadata("design:type", Object)], InvoiceUpdateComponent.prototype, "invoiceTemplateSelect", void 0);
InvoiceUpdateComponent = __decorate([core_1.Component({
    selector: 'invoice-update',
    template: __webpack_require__("./web/modern/components/invoices/invoice-update/invoice-update.html"),
    styles: [__webpack_require__("./web/modern/components/invoices/invoice-update/invoice-update.scss")]
}), __metadata("design:paramtypes", [invoices_data_service_1.InvoicesDataProvider, message_service_1.MessageService, invoice_service_1.InvoiceServiceProvider, quotes_data_service_1.QuotesDataProvider, jobs_data_service_1.JobsDataServiceProvider, settings_1.SettingsProvider, templates_data_service_1.TemplatesDataProvider, contracts_data_service_1.ContractsDataProvider, payments_schedules_data_service_1.PaymentSchedulesDataProvider, product_packages_data_service_1.ProductPackagesDataServiceProvider, quote_update_service_1.QuoteUpdateService, stringModifier_service_1.StringModifierServiceProvider, time_service_1.TimeServiceProvider, common_1.Location, snModal_service_1.SNModalService, quote_invoice_templates_data_service_1.QuoteInvoiceTemplatesDataService, quote_invoice_templates_service_1.QuoteInvoiceTemplatesService, contracts_data_service_1.ContractsDataProvider, validation_service_1.ValidationProvider])], InvoiceUpdateComponent);
exports.InvoiceUpdateComponent = InvoiceUpdateComponent;

/***/ }),

/***/ "./web/modern/components/invoices/invoice-view/invoice-info-table/invoice-info-table.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"col-xs-12 col-sm-4 print-half print-no-padding-left\">\n    <div class=\"invoice-left-side\">\n        <div>\n            <img class=\"client-company-image client-company-image-max-height\" alt=\"Company logo\" *ngIf=\"data.company.logoUrl\" [src]=\"data.company.logoUrl\">\n            <div *ngIf=\"!data.company.logoUrl\" class=\"default-img\"></div>\n        </div>\n        <div>\n            <table class=\"table-invoice\">\n                <tr>\n                    <td>Invoice ID</td>\n                    <td><b>{{ data.invoiceId }}</b></td>\n                </tr>\n                <tr>\n                    <td>Issue Date</td>\n                    <td>{{ data.issueDate| timeFilter: 'long' }}</td>\n                </tr>\n                <tr *ngIf=\"data.poNumber\">\n                    <td>PO Number</td>\n                    <td>{{ data.poNumber ? data.poNumber : '-' }}</td>\n                </tr>\n                <tr>\n                    <td colspan=\"2\">&nbsp;</td>\n                </tr>\n                <tr>\n                    <td colspan=\"2\">&nbsp;</td>\n                </tr>\n            </table>\n        </div>\n    </div>\n</div>\n<div class=\"col-xs-12 col-sm-8 print-half text-right print-no-padding-right\">\n    <div class=\"invoice-right-side print-no-padding-right\">\n        <img id=\"stamp\" class=\"quote-status-img not-print\"\n             *ngIf=\"data.source.toUpperCase() != 'SHOOT_PROOF'\"\n             [src]=\"imageStatusInvoice\">\n        <table class=\"table-invoice pull-right w-auto\">\n            <tr>\n                <td>From</td>\n                <td><b>{{ data.company.name }}</b></td>\n            </tr>\n            <tr>\n                <td></td>\n                <td>{{ data.company.address }}</td>\n            </tr>\n            <tr>\n                <td></td>\n                <td>{{ data.company.city }}</td>\n            </tr>\n            <tr>\n                <td></td>\n                <td>{{ data.company.state }} {{ data.company.postcode }} {{ data.company.country }}</td>\n            </tr>\n            <tr *ngIf=\"data.company.phone\">\n                <td></td>\n                <td>Phone number: {{ data.company.phone }}</td>\n            </tr>\n            <tr *ngIf=\"data.company.email\">\n                <td></td>\n                <td>Email: {{ data.company.email }}</td>\n            </tr>\n            <tr *ngIf=\"data.company.number\">\n                <td></td>\n                <td>{{ businessNumberLabelName }}: {{ data.company.number }}</td>\n            </tr>\n            <tr>\n                <td colspan=\"2\">&nbsp;</td>\n            </tr>\n            <tr>\n                <td colspan=\"2\">&nbsp;</td>\n            </tr>\n            <tr>\n                <td>Invoice for</td>\n                <td><b>{{ data.job.name }}</b></td>\n            </tr>\n            <tr>\n                <td></td>\n                <td>Scheduled on <br>\n                    <main-shoot-date [fromQuote]=\"true\" [start-date]=\"data.job.startDate\"\n                                     [finish-date]=\"data.job.finishDate\"></main-shoot-date>\n                </td>\n            </tr>\n            <tr>\n                <td></td>\n                <td *ngIf=\"data.job.startTime && data.job.finishTime\">\n                    {{ data.job.startTime | timeFilter: '12h' }} - {{ data.job.finishTime | timeFilter: '12h' }}\n                </td>\n            </tr>\n            <tr>\n            <tr>\n                <td></td>\n                <td *ngIf=\"data.job.shootLocation\">\n                    {{ data.job.shootLocation }}\n                </td>\n            </tr>\n            <tr>\n                <td>&nbsp;</td>\n                <td>&nbsp;</td>\n            </tr>\n            <tr *ngIf=\"data.job.primaryContact.companyName\">\n                <td></td>\n                <td><b>{{ data.job.primaryContact.companyName }}</b>\n                </td>\n            </tr>\n            <tr>\n                <td></td>\n                <td>\n                    <b>{{ data.job.primaryContact.firstName }} {{ data.job.primaryContact.lastName }}</b>\n                </td>\n            </tr>\n            <tr>\n                <td></td>\n                <td><span>{{ data.job.primaryContact.addressLine1 }}</span></td>\n            </tr>\n            <tr *ngIf=\"data.job.primaryContact.addressLine2\">\n                <td></td>\n            <td><span>{{ data.job.primaryContact.addressLine2 }}</span></td>\n            </tr>\n            <tr>\n                <td></td>\n                <td><span>{{ data.job.primaryContact.town }}</span></td>\n            </tr>\n            <tr>\n                <td></td>\n                <td><span>{{ data.job.primaryContact.state }} {{ data.job.primaryContact.postcode }}\n\t\t\t\t\t\t\t\t\t{{ data.job.primaryContact.country }}</span></td>\n            </tr>\n            <tr *ngIf=\"data?.job?.primaryContact?.phoneNumber\">\n                <td></td>\n                <td>\n                    <span>Phone number: {{ data.job.primaryContact.phoneNumber }}</span></td>\n            </tr>\n            <tr *ngIf=\"data?.job?.primaryContact?.email\">\n                <td></td>\n                <td><span>Email: {{ data.job.primaryContact.email }}</span></td>\n            </tr>\n            <tr *ngIf=\"data?.job?.primaryContact?.businessNumber\">\n                <td></td>\n                <td><span>{{ businessNumberLabelName }}: {{ data.job.primaryContact.businessNumber }}</span></td>\n            </tr>\n            <tr>\n                <td colspan=\"2\">&nbsp;</td>\n            </tr>\n            <tr>\n                <td colspan=\"2\">&nbsp;</td>\n            </tr>\n        </table>\n    </div>\n</div>\n"

/***/ }),

/***/ "./web/modern/components/invoices/invoice-view/invoice-info-table/invoice-info-table.scss":
/***/ (function(module, exports) {

module.exports = ":host .default-img {\n  width: 210px;\n  height: 210px;\n  display: inline-block;\n  margin-bottom: 20px; }\n"

/***/ }),

/***/ "./web/modern/components/invoices/invoice-view/invoice-info-table/invoice-info-table.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var invoice_service_1 = __webpack_require__("./shared/services/invoice/invoice-service/invoice.service.ts");
var settings_1 = __webpack_require__("./shared/services/settings/settings.ts");
var rxjs_1 = __webpack_require__("./node_modules/rxjs/Rx.js");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var InvoiceInfoTableComponent = function () {
    function InvoiceInfoTableComponent(invoiceService, settingsService) {
        _classCallCheck(this, InvoiceInfoTableComponent);

        this.invoiceService = invoiceService;
        this.settingsService = settingsService;
        this.imageStatusInvoice = '';
        this.unsubscribe = new rxjs_1.Subject();
    }

    _createClass(InvoiceInfoTableComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.setInvoiceStamp();
            this.subscribeToCustomizeLabelsChange();
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "subscribeToCustomizeLabelsChange",
        value: function subscribeToCustomizeLabelsChange() {
            var _this = this;

            this.settingsService.customizeLabelsObservable.pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (customizeLabels) {
                return _this.businessNumberLabelName = customizeLabels.businessNumberLabel;
            });
        }
    }, {
        key: "setInvoiceStamp",
        value: function setInvoiceStamp() {
            this.imageStatusInvoice = this.invoiceService.getInvoiceStampImageSrc(this.data.sent);
        }
    }, {
        key: "invoice",
        get: function get() {
            return this.invoice;
        }
    }, {
        key: "product",
        set: function set(value) {
            this.data = value;
            this.setInvoiceStamp();
        }
    }]);

    return InvoiceInfoTableComponent;
}();
__decorate([core_1.Input('invoice'), __metadata("design:type", Object), __metadata("design:paramtypes", [Object])], InvoiceInfoTableComponent.prototype, "product", null);
InvoiceInfoTableComponent = __decorate([core_1.Component({
    selector: 'invoice-info-table',
    template: __webpack_require__("./web/modern/components/invoices/invoice-view/invoice-info-table/invoice-info-table.html"),
    styles: [__webpack_require__("./web/modern/components/invoices/invoice-view/invoice-info-table/invoice-info-table.scss")]
}), __metadata("design:paramtypes", [invoice_service_1.InvoiceServiceProvider, settings_1.SettingsProvider])], InvoiceInfoTableComponent);
exports.InvoiceInfoTableComponent = InvoiceInfoTableComponent;

/***/ }),

/***/ "./web/modern/components/invoices/invoice-view/invoice-payments-action-buttons/invoice-payment-action-buttons.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"clearfix group-btn not-print\">\n  <send-btn *ngIf=\"data.actions.SEND\" [text]=\"'Send Invoice'\" (click)=\"sendInvoice(data)\" [addClass]=\"'btn-lg'\"></send-btn>\n\n  <preview-btn *ngIf=\"data.actions.PREVIEW\" [text]=\"'Preview'\" [previewLink]=\"previewUrl\"></preview-btn>\n\n  <edit-btn *ngIf=\"data.actions.EDIT\" [text]=\"'Edit'\" [isLink]=\"true\" [linkHref]=\"editUrl\" [addClass]=\"'btn-lg'\"></edit-btn>\n\n  <copy-to-xero-btn *ngIf=\"data.actions.COPY_TO_XERO\" [invoiceData]=\"data\" (successGetInvoiceInformation)=\"updateInvoice($event)\"></copy-to-xero-btn>\n\n  <copy-to-qb-btn *ngIf=\"data.actions.COPY_TO_QB\" [invoiceData]=\"data\" (successGetInvoiceInformation)=\"updateInvoice($event)\"></copy-to-qb-btn>\n\n  <save-pdf-btn *ngIf=\"data.actions.SAVE_AS_PDF\" [link]=\"data.job.clientPortalLink\" [id]=\"data.id\" [docType]=\"'invoice'\"></save-pdf-btn>\n\n  <print-btn *ngIf=\"data.actions.PRINT\" [isDisabled]=\"false\"></print-btn>\n\n  <delete-btn *ngIf=\"data.actions.DELETE\" [isDisabled]=\"data.actions.DELETE.state === 'disabled'\" [addClass]=\"'btn-lg'\" (clicked)=\"showDeleteModal()\"></delete-btn>\n\n\n  <i *ngIf=\"data.xeroStatus !== null || data.copied2Rounded\" class=\"visible-xs-block mb--8\"></i>\n  <i *ngIf=\"data.qbStatus !== null || data.copied2Rounded\" class=\"visible-xs-block mb--8\"></i>\n  <div class=\"pull-xs-left pull-right mt-20 pt-6\">\n    <span *ngFor=\"let label of data.labels\" class=\"btn-sm color-white f-bold btn-rounded pull-xs-right ml-5\" [style.background-color]=\"label?.hex\">{{label?.name}}</span>\n  </div>\n</div>\n\n<delete-invoice-modal [invoice]=\"data\" (updateParent)=\"successDeleteInvoiceModal($event)\"></delete-invoice-modal>"

/***/ }),

/***/ "./web/modern/components/invoices/invoice-view/invoice-payments-action-buttons/invoice-payment-action-buttons.scss":
/***/ (function(module, exports) {

module.exports = ""

/***/ }),

/***/ "./web/modern/components/invoices/invoice-view/invoice-payments-action-buttons/invoice-payment-action-buttons.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var common_1 = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
var invoices_data_service_1 = __webpack_require__("./shared/services/invoice/invoices-data-service/invoices.data.service.ts");
var payments_service_1 = __webpack_require__("./shared/services/payments/payments-service/payments.service.ts");
var integrations_data_service_1 = __webpack_require__("./shared/services/integrations/integrations.data.service.ts");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var confirm_general_modal_component_1 = __webpack_require__("./web/modern/components/common/confirm-general-modal/confirm-general-modal.component.ts");
var InvoicePaymentActionButtons = function () {
    function InvoicePaymentActionButtons(invoicesDataService, paymentsService, integrationsDataService, messageService, location, modalService) {
        _classCallCheck(this, InvoicePaymentActionButtons);

        this.invoicesDataService = invoicesDataService;
        this.paymentsService = paymentsService;
        this.integrationsDataService = integrationsDataService;
        this.messageService = messageService;
        this.location = location;
        this.modalService = modalService;
        this.getInvoiceUpdated = new core_1.EventEmitter();
        this.sendInvoiceEmitter = new core_1.EventEmitter();
        this.unsubscribe = new Subject_1.Subject();
    }

    _createClass(InvoicePaymentActionButtons, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.loadPreviewUrl();
            this.getIntegrationStatus();
        }
    }, {
        key: "ngAfterViewInit",
        value: function ngAfterViewInit() {
            this.prepareEditLink();
        }
    }, {
        key: "updateInvoice",
        value: function updateInvoice(invoice) {
            this.getInvoiceUpdated.emit(invoice);
        }
    }, {
        key: "sendInvoice",
        value: function sendInvoice(invoice) {
            var message = this.data.actions.SEND.message;

            if (message) {
                this.openAlertModal(message);
                return;
            }
            this.sendInvoiceEmitter.emit({
                isReceipt: false,
                data: invoice,
                invoice: invoice
            });
        }
    }, {
        key: "showDeleteModal",
        value: function showDeleteModal() {
            var message = this.data.actions.DELETE.message;

            if (message) {
                this.openAlertModal(message);
                return;
            }
            this.isDeleteModalOpen = true;
            $('#deleteModal').modal();
        }
    }, {
        key: "successDeleteInvoiceModal",
        value: function successDeleteInvoiceModal(state) {
            if (state) {
                this.isDeleteModalOpen = false;
                this.location.go('/payments');
            }
        }
    }, {
        key: "loadPreviewUrl",
        value: function loadPreviewUrl() {
            var _this = this;

            this.invoicesDataService.getInvoicePreviewURL(this.data.id).pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (data) {
                _this.previewUrl = "/clients/invoice/pay/" + data.link + "/" + _this.data.id;
            });
        }
    }, {
        key: "prepareEditLink",
        value: function prepareEditLink() {
            this.data.job.inLead ? this.editUrl = "/leads/" + this.data.job.leadId + "/invoice/" + this.data.id + "/update" : this.editUrl = "/jobs/" + this.data.job.id + "/invoice/" + this.data.id + "/update";
        }
    }, {
        key: "getIntegrationStatus",
        value: function getIntegrationStatus() {
            var _this2 = this;

            this.integrationsDataService.getIntegrationOrganization().subscribe(function (data) {
                return _this2.successGetIntegrationStatus(data);
            }, function (err) {
                return _this2.messageService.showDefaultErrorMessage(err);
            });
        }
    }, {
        key: "successGetIntegrationStatus",
        value: function successGetIntegrationStatus(data) {
            if (data.integration && data.integration === 'XERO') {
                this.xeroEnabled = true;
                this.qbEnabled = false;
            } else if (data.integration && data.integration === 'QUICKBOOKS') {
                this.qbEnabled = true;
                this.xeroEnabled = false;
            }
        }
    }, {
        key: "openAlertModal",
        value: function openAlertModal(message) {
            var modal = this.modalService.openModal(confirm_general_modal_component_1.ConfirmGeneralModalComponent, {
                windowClass: 'ng-bootstrap-modal modal-visible modal-narrow'
            });
            modal.componentInstance.text = message;
            modal.componentInstance.buttons = [{
                text: 'Got it!',
                action: 'CLOSE',
                color: 'default',
                size: 'lg'
            }];
        }
    }]);

    return InvoicePaymentActionButtons;
}();
__decorate([core_1.Input('data'), __metadata("design:type", Object)], InvoicePaymentActionButtons.prototype, "data", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], InvoicePaymentActionButtons.prototype, "getInvoiceUpdated", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], InvoicePaymentActionButtons.prototype, "sendInvoiceEmitter", void 0);
InvoicePaymentActionButtons = __decorate([core_1.Component({
    selector: 'invoice-payment-action-buttons',
    template: __webpack_require__("./web/modern/components/invoices/invoice-view/invoice-payments-action-buttons/invoice-payment-action-buttons.html"),
    styles: [__webpack_require__("./web/modern/components/invoices/invoice-view/invoice-payments-action-buttons/invoice-payment-action-buttons.scss")]
}), __metadata("design:paramtypes", [invoices_data_service_1.InvoicesDataProvider, payments_service_1.PaymentsServiceProvider, integrations_data_service_1.IntegrationsDataProvider, message_service_1.MessageService, common_1.Location, snModal_service_1.SNModalService])], InvoicePaymentActionButtons);
exports.InvoicePaymentActionButtons = InvoicePaymentActionButtons;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./web/modern/components/invoices/invoice-view/invoice-payments-schedule-table/invoice-payments-schedule-table.html":
/***/ (function(module, exports) {

module.exports = "<div *ngIf=\"invoice.summary.total !== 0\" class=\"table-responsive mt-35 invoice-payments-schedule-table\">\n  <table class=\"table no-border-bottom\">\n    <thead *ngIf=\"showHeader\" class=\"invoice-thead\">\n    <tr>\n      <th>Status</th>\n      <th>Due</th>\n      <th>Paid on</th>\n      <th class=\"text-right\">Amount</th>\n      <th class=\"text-left\" *ngIf=\"shouldHaveActions\">Actions</th>\n    </tr>\n    </thead>\n    <tbody>\n    <tr *ngFor=\"let payment of payments | orderBy:'due'\">\n      <td class=\"width-10\"><p class=\"invoice-blocks web mb-0 {{payment.paymentState | lowercase}}\">{{ payment.paymentState | uppercase }}</p></td>\n      <td class=\"width-20\">\n        <span class=\"text-nowrap\">{{ payment.due|  timeFilter: 'long' }}</span>\n        <span [ngClass]=\"getDueDateCorrectColor(payment)\" class=\"text-nowrap not-print\">{{ calculateDaysToPay(payment) }}</span>\n      </td>\n      <td class=\"width-30\" *ngIf=\"payment.paidOn\">{{ payment.paidOn| timeFilter:'long' }}</td>\n      <td class=\"width-30\" *ngIf=\"!payment.paidOn\">-</td>\n      <td class=\"text-right width-10\">{{ payment.amountWithCurrency.amountWithCurrency }}</td>\n      <td *ngIf=\"shouldHaveActions\" class=\"text-left td-btn-group text-nowrap width-30 not-print\">\n        <button *ngIf=\"payment.actions.RECORD\" type=\"button\" class=\"btn btn-default btn-sm\"\n                [disabled]=\"spinners[payment.id]\"\n                (click)=\"setPaid(payment)\">Record payment\n        </button>\n        <button *ngIf=\"payment.actions.PAY_ONLINE\" type=\"button\" class=\"btn btn-default btn-sm\"\n                [disabled]=\"spinners[payment.id]\"\n                (click)=\"payOnline()\">Pay online\n        </button>\n        <button *ngIf=\"payment.actions.WRITE_OFF\"\n                type=\"button\" class=\"btn btn-default btn-sm\"\n                [disabled]=\"spinners[payment.id]\"\n                (click)=\"showWriteOff(payment)\">Write off\n        </button>\n        <button *ngIf=\"payment.actions.MARK_UNPAID\" type=\"button\" class=\"btn btn-default btn-sm\"\n                spinning-wheel [is-spinning-wheel-active]=\"spinners.markUnpaidSpinner[payment.id]\"\n                [is-spinning-wheel-dark]=\"'true'\"\n                [disabled]=\"spinners.markUnpaidSpinner[payment.id]\"\n                (click)=\"setUnpaid(payment)\">Mark as unpaid\n        </button>\n        <button *ngIf=\"payment.actions.SEND_RECEIPT\" type=\"button\" class=\"btn btn-default btn-sm\"\n                spinning-wheel [is-spinning-wheel-active]=\"spinners.sendReceiptSpinner[payment.id]\"\n                [is-spinning-wheel-dark]=\"'true'\"\n                [disabled]=\"spinners.sendReceiptSpinner[payment.id]\"\n                (click)=\"showSendInvoice(payment)\">Send receipt\n        </button>\n      </td>\n    </tr>\n    <tr *ngFor=\"let payment of writtenOffPayments | orderBy:'writeOffDate'\">\n      <td></td>\n      <td></td>\n      <td colspan=\"2\" class=\"text-right text-gray\"><i>{{ payment.amountWithCurrency.amountWithCurrency }} was\n        written off on {{ payment.writeOffDate | timeFilter: 'long' }}</i></td>\n      <td  *ngIf=\"shouldHaveActions\" class=\"text-left td-btn-group text-nowrap width-30\">\n        <button type=\"button\" class=\"btn btn-default btn-sm\"\n                *ngIf=\"payment.actions.UNDO_WRITE_OFF\"\n                spinning-wheel [is-spinning-wheel-active]=\"spinners.undoWriteOffSpinner[payment.id]\"\n                [is-spinning-wheel-dark]=\"'true'\"\n                [disabled]=\"spinners.undoWriteOffSpinner[payment.id]\"\n                (click)=\"undoOff(payment)\">Undo\n        </button>\n      </td>\n    </tr>\n    <tr>\n      <td></td>\n      <td colspan=\"3\" class=\"text-right\">\n        <div class=\"inline-block mr-20 text-gray\"><span>Balance due </span></div>\n        <span>{{ invoice.balanceDueWithCurrency.amountWithCurrency }}</span></td>\n      <td *ngIf=\"shouldHaveActions\"></td>\n    </tr>\n    </tbody>\n  </table>\n</div>\n"

/***/ }),

/***/ "./web/modern/components/invoices/invoice-view/invoice-payments-schedule-table/invoice-payments-schedule-table.scss":
/***/ (function(module, exports) {

module.exports = ".table .width-10 {\n  width: 10%;\n  max-width: 10%; }\n\n.table .width-20 {\n  width: 20%;\n  max-width: 20%; }\n\n.table .width-30 {\n  width: 30%;\n  max-width: 30%; }\n"

/***/ }),

/***/ "./web/modern/components/invoices/invoice-view/invoice-payments-schedule-table/invoice-payments-schedule-table.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var InvoicePaymentsScheduleTable = function () {
    function InvoicePaymentsScheduleTable() {
        _classCallCheck(this, InvoicePaymentsScheduleTable);

        this.showHeader = true;
        this.setPaidEmitter = new core_1.EventEmitter();
        this.payOnlineEmitter = new core_1.EventEmitter();
        this.setUnpaidEmitter = new core_1.EventEmitter();
        this.writeOffEmitter = new core_1.EventEmitter();
        this.undoWriteOffEmitter = new core_1.EventEmitter();
        this.sendReceiptEmitter = new core_1.EventEmitter();
        this.payments = [];
        this.writtenOffPayments = [];
    }

    _createClass(InvoicePaymentsScheduleTable, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.mapPayments(this.invoice.payments);
        }
    }, {
        key: "ngOnChanges",
        value: function ngOnChanges(change) {
            this.mapPayments(change.invoice.currentValue.payments);
        }
    }, {
        key: "setPaid",
        value: function setPaid(payment) {
            this.setPaidEmitter.emit(payment);
        }
    }, {
        key: "payOnline",
        value: function payOnline() {
            this.payOnlineEmitter.emit();
        }
    }, {
        key: "showWriteOff",
        value: function showWriteOff(payment) {
            this.writeOffEmitter.emit(payment);
        }
    }, {
        key: "undoOff",
        value: function undoOff(payment) {
            this.undoWriteOffEmitter.emit(payment);
        }
    }, {
        key: "setUnpaid",
        value: function setUnpaid(payment) {
            this.setUnpaidEmitter.emit(payment);
        }
    }, {
        key: "showSendInvoice",
        value: function showSendInvoice(payment) {
            this.sendReceiptEmitter.emit({
                isReceipt: true,
                data: payment,
                invoice: this.invoice
            });
        }
    }, {
        key: "calculateDaysToPay",
        value: function calculateDaysToPay(payment) {
            var result = '';
            if (!payment.paid) {
                // Check If we have negative number to decide how to show status
                var isPast = payment.daysLeftForPayment.toString().charCodeAt(0) === 45;
                var isToday = payment.daysLeftForPayment === 0;
                var days = payment.daysLeftForPayment === 1 || payment.daysLeftForPayment === -1 ? ' day' : 'days';
                if (isToday) {
                    result = '(today)';
                } else if (isPast) {
                    result = "(" + payment.daysLeftForPayment.toString().slice(1) + " " + days + " ago)";
                } else {
                    result = "(in " + payment.daysLeftForPayment + " " + days + ")";
                }
            }
            return result;
        }
    }, {
        key: "getDueDateCorrectColor",
        value: function getDueDateCorrectColor(payment) {
            // Check If we have negative number to decide how to show status
            var isPast = payment.daysLeftForPayment.toString().charCodeAt(0) === 45;
            if (isPast) {
                return 'color-froly-dark';
            }
        }
    }, {
        key: "mapPayments",
        value: function mapPayments(payments) {
            var _this = this;

            this.payments = [];
            this.writtenOffPayments = [];
            payments.map(function (e) {
                e.writtenOff ? _this.writtenOffPayments.push(e) : _this.payments.push(e);
            });
        }
    }]);

    return InvoicePaymentsScheduleTable;
}();
__decorate([core_1.Input('data'), __metadata("design:type", Object)], InvoicePaymentsScheduleTable.prototype, "invoice", void 0);
__decorate([core_1.Input(), __metadata("design:type", Boolean)], InvoicePaymentsScheduleTable.prototype, "shouldHaveActions", void 0);
__decorate([core_1.Input(), __metadata("design:type", Boolean)], InvoicePaymentsScheduleTable.prototype, "currencySymbol", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], InvoicePaymentsScheduleTable.prototype, "spinners", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], InvoicePaymentsScheduleTable.prototype, "showHeader", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], InvoicePaymentsScheduleTable.prototype, "setPaidEmitter", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], InvoicePaymentsScheduleTable.prototype, "payOnlineEmitter", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], InvoicePaymentsScheduleTable.prototype, "setUnpaidEmitter", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], InvoicePaymentsScheduleTable.prototype, "writeOffEmitter", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], InvoicePaymentsScheduleTable.prototype, "undoWriteOffEmitter", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], InvoicePaymentsScheduleTable.prototype, "sendReceiptEmitter", void 0);
InvoicePaymentsScheduleTable = __decorate([core_1.Component({
    selector: 'invoice-payments-schedule-table',
    template: __webpack_require__("./web/modern/components/invoices/invoice-view/invoice-payments-schedule-table/invoice-payments-schedule-table.html"),
    styles: [__webpack_require__("./web/modern/components/invoices/invoice-view/invoice-payments-schedule-table/invoice-payments-schedule-table.scss")]
}), __metadata("design:paramtypes", [])], InvoicePaymentsScheduleTable);
exports.InvoicePaymentsScheduleTable = InvoicePaymentsScheduleTable;

/***/ }),

/***/ "./web/modern/components/invoices/invoice-view/invoice-view.html":
/***/ (function(module, exports) {

module.exports = "<div *ngIf=\"invoice && invoice.job\">\n\n    <div class=\"row not-print btn-layout pb-20 \">\n        <div class=\"col-xs-9 breadcrumb-payments\">\n            <h2>Invoice {{ invoice.invoiceId }}</h2>\n            <div class=\"bc-wrap bc-wrap-no-border\">\n                <ol class=\"bc-list mt-0 mb-0\">\n                    <li><a href=\"/\">Dashboard</a></li>\n                    <li *ngIf=\"!isLeadView\"><a href=\"/jobs\">Jobs</a></li>\n                    <li *ngIf=\"isLeadView\"><a href=\"/leads\">Leads</a></li>\n                    <li *ngIf=\"!isLeadView\"><a href=\"/jobs/view/{{invoice.job.id}}\">{{ invoice.job.name }}</a></li>\n                    <li *ngIf=\"isLeadView\"><a href=\"/leads/view/{{invoice.job.leadId}}\">{{ invoice.job.name }}</a></li>\n                    <li><a href=\"/payments\">Payments</a></li>\n                    <li class=\"active\">Invoice {{ invoice.invoiceId }}</li>\n                </ol>\n            </div>\n        </div>\n        <!-- Total -->\n        <div class=\"col-12 col-xs-3 text-align-right mb-5 quote-invoice-view-total\">\n            <div class=\"clearfix hidden\"></div>\n            <div class=\"color-java\">\n                <h2 class=\"mt-17\">{{ invoice.summary.totalWithCurrency.amountWithCurrency }}</h2>\n                <div class=\"color-grey\">Total</div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"not-print\" [ngClass]=\"{'bc-wrap-border' : invoice?.summary?.total !== 0}\">\n        <invoice-payments-schedule-table\n                [data]=\"invoice\" [shouldHaveActions]=\"true\" [currencySymbol]=\"userCurrencySymbol\" [spinners]=\"spinners\"\n                (setPaidEmitter)=\"setPaid($event)\" (setUnpaidEmitter)=\"setUnpaid($event)\"\n                (payOnlineEmitter)=\"payOnline()\" (writeOffEmitter)=\"showWriteOff($event)\"\n                (sendReceiptEmitter)=\"sendReceipt($event)\" (undoWriteOffEmitter)=\"undoOff($event)\">\n        </invoice-payments-schedule-table>\n    </div>\n    <div [ngClass]=\"{'bc-wrap-border' : !invoice?.summary?.total}\">\n    <invoice-payment-action-buttons [data]=\"invoice\" (sendInvoiceEmitter)=\"sendReceipt($event)\" (getInvoiceUpdated)=\"getInvoice()\"></invoice-payment-action-buttons>\n    </div>\n        <!-- btn group -->\n    <div class=\"box-shadow print\">\n        <div class=\"invoice-view-container\">\n            <div class=\"col-xs-12\" >\n                <invoice-info-table [invoice]=\"invoice\" ></invoice-info-table>\n            </div>\n            <div class=\"col-xs-12\">\n                <h2 class=\"mt-10 mb-25\">{{ invoice.invoiceHeader }}</h2>\n                <product-package-table\n                        [currencySymbol]=\"userCurrencySymbol\"\n                        [invoice]=\"invoice\"\n                        [summary]=\"invoice.summary\"\n                        [data]=\"invoice.summary.items\">\n                </product-package-table>\n            </div>\n\n\n            <div *ngIf=\"invoice.notes\" class=\"divider-notes-pseudo quote-notes-container quote-text mb-30 pl-15 pr-15\">\n                <h2 class=\"mt-30 f-s-24\">Notes</h2>\n                <p class=\"ws-pl\">{{ invoice.notes }}</p>\n            </div>\n\n            <!--Payment schedule table-->\n            <div class=\"col-xs-12\">\n                <invoice-payments-schedule-table\n                        [data]=\"invoice\" [shouldHaveActions]=\"false\" [currencySymbol]=\"userCurrencySymbol\" [spinners]=\"spinners\">\n                </invoice-payments-schedule-table>\n            </div>\n\n        </div>\n    </div>\n    <div class=\"mt-35\">\n        <!-- remove notes form this component -->\n        <quote-assignment-panel *ngIf=\"invoice.source !== 'SHOOT_PROOF'\" [data]=\"invoice\" [isQuote]=\"false\"></quote-assignment-panel>\n    </div>\n</div>\n\n<record-payment-modal [selectedPayment]=\"selectedPayment\" (updateParent)=\"onRecordPaymentClose($event)\"></record-payment-modal>\n"

/***/ }),

/***/ "./web/modern/components/invoices/invoice-view/invoice-view.scss":
/***/ (function(module, exports) {

module.exports = ""

/***/ }),

/***/ "./web/modern/components/invoices/invoice-view/invoice-view.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var invoices_data_service_1 = __webpack_require__("./shared/services/invoice/invoices-data-service/invoices.data.service.ts");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var validation_service_1 = __webpack_require__("./shared/services/helpers/validation.service.ts");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var write_off_modal_1 = __webpack_require__("./web/modern/components/payments/modals/write-off-modal/write-off-modal.ts");
var common_1 = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
var InvoiceViewComponent = function () {
    function InvoiceViewComponent(invoiceDataService, messageService, validationService, modalService, location) {
        _classCallCheck(this, InvoiceViewComponent);

        this.invoiceDataService = invoiceDataService;
        this.messageService = messageService;
        this.validationService = validationService;
        this.modalService = modalService;
        this.location = location;
        this.sendMail = new core_1.EventEmitter();
        this.getContactEmail = new core_1.EventEmitter();
        this.unsubscribe = new Subject_1.Subject();
    }

    _createClass(InvoiceViewComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.configureCommunicationAdapter();
            this.getInvoice();
        }
    }, {
        key: "ngOnChanges",
        value: function ngOnChanges(change) {
            // We need to track infinite spinner variable from old Angular. Could be removed after upgrading SendReceipt modal.
            if (!change.sendReceiptSpinner.isFirstChange() && this.selectedPayment && this.spinners.sendReceiptSpinner[this.selectedPayment.id]) {
                this.spinners.sendReceiptSpinner[this.selectedPayment.id] = change.sendReceiptSpinner.currentValue;
            }
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "showWriteOff",
        value: function showWriteOff(payment) {
            this.selectPayment(payment);
            this.prepareWriteOffData(payment);
            this.showWriteOffModal();
        }
    }, {
        key: "writeOff",
        value: function writeOff() {
            this.getInvoice();
        }
    }, {
        key: "undoOff",
        value: function undoOff(payment) {
            var _this = this;

            this.selectPayment(payment);
            this.spinners.undoWriteOffSpinner[payment.id] = true;
            this.invoiceDataService.undoWriteOff(payment.id).pipe(operators_1.takeUntil(this.unsubscribe), operators_1.finalize(function () {
                return _this.discardSpinners();
            })).subscribe(function () {
                return _this.getInvoice();
            }, function (_ref) {
                var error = _ref.error;
                var errorMessage = error.errorMessage,
                    errorTitle = error.errorTitle;

                _this.messageService.showErrorFromBackend(errorTitle, errorMessage);
            });
        }
    }, {
        key: "payOnline",
        value: function payOnline() {
            var _this2 = this;

            var newWindow = window.open('', '_blank');
            this.invoiceDataService.getInvoicePreviewURL(this.invoiceId).pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (result) {
                var clientLink = result.link;
                var base = window.location.origin;
                newWindow.location.href = base + "/clients/invoice/pay/" + clientLink + "/" + _this2.invoiceId;
            });
        }
    }, {
        key: "sendReceipt",
        value: function sendReceipt(sendData) {
            if (sendData.isReceipt) {
                this.spinners.sendReceiptSpinner[sendData.data.id] = true;
                this.selectPayment(sendData.data);
            }
            this.sendMail.emit(sendData);
        }
    }, {
        key: "setPaid",
        value: function setPaid(payment) {
            var _this3 = this;

            this.selectPayment(payment);
            if (payment.errorMessage === "StudioNinja doesn't support transactions with Credit Notes from QuickBooks") {
                this.messageService.showToaster('e_14', 'qb');
            } else if (payment.errorMessage === 'One of the list elements assigned to this transaction has been deleted') {
                this.messageService.showToaster('e_11', 'qb');
            } else {
                this.selectedPayment = payment;
                var setPaidModal = $('#markAsPayedModal');
                setPaidModal.modal('show').on('shown.bs.modal', function () {
                    _this3.configurePreventCloseModal(setPaidModal);
                });
            }
        }
    }, {
        key: "onRecordPaymentClose",
        value: function onRecordPaymentClose(ev) {
            if (ev) {
                this.getInvoice();
            }
        }
    }, {
        key: "setUnpaid",
        value: function setUnpaid(payment) {
            var _this4 = this;

            this.selectPayment(payment);
            this.spinners.markUnpaidSpinner[payment.id] = true;
            this.invoiceDataService.setUnpaid(payment.id).pipe(operators_1.takeUntil(this.unsubscribe), operators_1.finalize(function () {
                return _this4.discardSpinners();
            })).subscribe(function (result) {
                return _this4.successSetUnpaid(result);
            }, function (error) {
                return _this4.errorSetUnpaid(error);
            });
        }
    }, {
        key: "getInvoice",
        value: function getInvoice() {
            var _this5 = this;

            this.invoiceDataService.getInvoiceV1(this.invoiceId).pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (data) {
                return _this5.successGetInvoice(data);
            }, function (error) {
                var _error$error = error.error,
                    errorMessage = _error$error.errorMessage,
                    errorTitle = _error$error.errorTitle,
                    errorCode = _error$error.errorCode;

                if (errorCode === 102 || errorCode === 104) {
                    _this5.location.go('/payments');
                    _this5.messageService.showToaster('e_19', 'editInvoice');
                } else if (errorMessage) {
                    _this5.messageService.showErrorFromBackend(errorTitle, errorMessage);
                } else {
                    _this5.messageService.showDefaultErrorMessage(error);
                }
            });
        }
    }, {
        key: "configurePreventCloseModal",
        value: function configurePreventCloseModal(modal) {
            var input = modal.find('input');
            modal.find('input.ws-number').prop('autocomplete', 'off');
            this.validationService.isModalClosePrevented(input);
        }
    }, {
        key: "successGetInvoice",
        value: function successGetInvoice(invoice) {
            this.invoice = invoice;
            this.isLeadView = invoice.job.inLead;
            this.userCurrencySymbol = invoice.summary.totalWithCurrency.currencySymbol;
            this.getContactEmail.emit(invoice.job.primaryContact.email);
            this.prepareSpinners();
        }
    }, {
        key: "successSetUnpaid",
        value: function successSetUnpaid(resp) {
            if (resp && resp.data && resp.data.errorMessage) {
                this.messageService.showDefaultErrorMessage(resp);
            } else {
                this.messageService.showToaster('s_3', 'payments');
            }
            this.getInvoice();
        }
    }, {
        key: "errorSetUnpaid",
        value: function errorSetUnpaid(_ref2) {
            var status = _ref2.status,
                data = _ref2.data,
                error = _ref2.error;

            if (error) {
                var _errorCode = error.errorCode,
                    errorTitle = error.errorTitle,
                    _errorMessage = error.errorMessage;

                if (_errorCode && _errorMessage) {
                    this.messageService.showErrorFromBackend(errorTitle, _errorMessage);
                    return;
                }
            }
            if (data.errorCode) {
                this.handleModernErrorMessages(data);
                return;
            }
            var errorMessage = data.errorMessage;
            var errorCode = void 0,
                errorPlace = void 0,
                value = void 0;
            if (status >= 400 && status < 500 && errorMessage) {
                if (errorMessage.includes('This payment cannot be marked as unpaid because it was overpaid in Xero.')) {
                    errorCode = 'e_11';
                    errorPlace = 'xero';
                } else {
                    errorCode = 'e_2';
                    errorPlace = 'general';
                    value = errorMessage;
                }
            } else {
                errorCode = 'e_0';
                errorPlace = 'general';
            }
            this.messageService.showToaster(errorCode, errorPlace, value);
        }
    }, {
        key: "prepareSpinners",
        value: function prepareSpinners() {
            var _this6 = this;

            this.spinners = {
                sendReceiptSpinner: {},
                markUnpaidSpinner: {},
                undoWriteOffSpinner: {}
            };
            this.invoice.payments.map(function (e) {
                _this6.spinners.sendReceiptSpinner[e.id] = _this6.spinners.markUnpaidSpinner[e.id] = _this6.spinners.undoWriteOffSpinner[e.id] = false;
            });
        }
    }, {
        key: "selectPayment",
        value: function selectPayment(payment) {
            this.selectedPayment = payment;
        }
    }, {
        key: "discardSpinners",
        value: function discardSpinners() {
            this.spinners.sendReceiptSpinner[this.selectedPayment.id] = this.spinners.markUnpaidSpinner[this.selectedPayment.id] = this.spinners.undoWriteOffSpinner[this.selectedPayment.id] = false;
        }
    }, {
        key: "prepareWriteOffData",
        value: function prepareWriteOffData(payment) {
            this.writeOffModalContent = {
                title: 'Write off',
                description: 'Are you sure?',
                buttons: [{
                    color: 'danger',
                    size: 'lg',
                    text: 'Write off payment',
                    action: 'WRITE_OFF'
                }, {
                    color: 'default',
                    size: 'lg',
                    text: 'Cancel',
                    action: 'DISCARD'
                }]
            };
            if (payment.xeroStatus === 'COPIED_TO_XERO') {
                this.writeOffModalContent.description = 'Writing off this invoice in Studio Ninja will add a credit note to this invoice in Xero. Once written off, you can only undo by removing the credit note in Xero. Are you sure?';
                this.writeOffModalContent.buttons[0].text = 'Yes';
                this.writeOffModalContent.buttons[1].text = 'No';
            }
        }
    }, {
        key: "showWriteOffModal",
        value: function showWriteOffModal() {
            var _this7 = this;

            var modal = this.modalService.openModal(write_off_modal_1.WriteOffModalComponent);
            modal.componentInstance.paymentId = this.selectedPayment.id;
            modal.componentInstance.modalContent = this.writeOffModalContent;
            modal.result.then(function () {
                return _this7.writeOff();
            });
        }
    }, {
        key: "handleModernErrorMessages",
        value: function handleModernErrorMessages(_ref3) {
            var errorTitle = _ref3.errorTitle,
                errorMessage = _ref3.errorMessage;

            this.messageService.showErrorFromBackend(errorTitle, errorMessage);
        }
    }, {
        key: "configureCommunicationAdapter",
        value: function configureCommunicationAdapter() {
            window.snCommunicationAdapter.registerMethod('getInvoice', this.getInvoice.bind(this));
        }
    }]);

    return InvoiceViewComponent;
}();
__decorate([core_1.Input('invoiceId'), __metadata("design:type", Number)], InvoiceViewComponent.prototype, "invoiceId", void 0);
__decorate([core_1.Input(), __metadata("design:type", Boolean)], InvoiceViewComponent.prototype, "sendReceiptSpinner", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], InvoiceViewComponent.prototype, "sendMail", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], InvoiceViewComponent.prototype, "getContactEmail", void 0);
InvoiceViewComponent = __decorate([core_1.Component({
    selector: 'invoice-view',
    template: __webpack_require__("./web/modern/components/invoices/invoice-view/invoice-view.html"),
    styles: [__webpack_require__("./web/modern/components/invoices/invoice-view/invoice-view.scss")]
}), __metadata("design:paramtypes", [invoices_data_service_1.InvoicesDataProvider, message_service_1.MessageService, validation_service_1.ValidationProvider, snModal_service_1.SNModalService, common_1.Location])], InvoiceViewComponent);
exports.InvoiceViewComponent = InvoiceViewComponent;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./web/modern/components/invoices/invoices-view-block/invoices-view-block.component.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"flex-row\">\n    <div class=\"col-xs-12 main-jobs-cell flex-basis-full\">\n        <div class=\"main-jobs-cell__title main-jobs-cell__title--bordered\">\n            <i class=\"fi-total-invoiced fi-job\"></i>\n            <h2>Invoices</h2>\n            <add-round-btn (click)=\"createNewInvoice()\" *ngIf=\"!showLoadingBlock && invoicesSN.length\" class=\"round-btn-left\" ></add-round-btn>\n        </div>\n\n        <div *ngIf=\"showLoadingBlock\" class=\"invoice-info-block\">\n            <div class=\"invoice-info-flex-block\">\n            <span class=\"invoice-info-text\">\n                Loading invoices...\n            </span>\n                <span>\n                <button class=\"btn btn-add-round invoice-info-btn btn-success spinning-wheel spinning-wheel__active spinning-wheel__display-after\"\n                        type=\"button\">\n                </button>\n            </span>\n            </div>\n        </div>\n\n        <div *ngIf=\"!showLoadingBlock && invoicesSN.length === 0\" class=\"section-data section-data--empty text-center\">\n            <h3 class=\"text-normal color-grey-dusty\">Get excited cuz it's invoicing time!</h3>\n            <button *ngIf=\"!isArchived\" (click)=\"createNewInvoice()\" class=\"btn btn-add-new-sm btn-success\" type=\"button\">\n                Add New Invoice\n            </button>\n        </div>\n\n        <div *ngIf=\"invoicesSN.length !== 0 \" class=\"flex-row section-data__wrapper\">\n            <ng-container *ngFor=\"let invoice of invoicesSN\">\n                <div class=\"section-data section-data--full flex-basis-full\">\n                    <table class=\"table-profile table-full-width\">\n                        <tbody>\n                            <tr>\n                                <td><h4>Invoice {{ invoice.invoiceId }}</h4></td>\n                                <td></td>\n                                <td class=\"text-right\">\n                                    Total: {{ invoice.totalWithCurrency.amountWithCurrency }}\n                                </td>\n                            </tr>\n                            <tr>\n                                <td *ngIf=\"!invoice.writeOffOn\">\n                                    <p *ngIf=\"invoice.sentAt\" class=\"m-0\" >Sent on {{ invoice.sentAt | timeFilter:'long' }}</p>\n\n                                    <span *ngIf=\"invoice.balanceDueWithCurrency.amount !== 0 || !invoice.paidOn \" class=\"grey-span\">\n                                        Next payment due  {{ invoice.nextPaymentDate | timeFilter: 'long' }}\n                                        <span *ngIf=\"!invoice.paidOn \" [ngClass]=\"invoice.daysToDue < 0 ? 'red': 'gray-label'\" class=\"text-nowrap\">\n                                            ({{ invoice.formattedDaysToDue }})\n                                        </span>\n                                    </span>\n\n                                    <span *ngIf=\"invoice.paidOn\" class=\"green-light-label\">Paid on {{ invoice.paidOn | timeFilter:'long' }}</span>\n                                </td>\n                                <td >\n                                    <span *ngIf=\"invoice.writeOffOn\">\n                                        Written off on {{ invoice.writeOffOn | timeFilter: 'long' }}\n                                    </span>\n                                </td>\n                                <td *ngIf=\"!invoice.writeOffOn && invoice.balanceDueWithCurrency.amount !== 0\" class=\"text-right\">\n                                    Balance Due: {{ invoice.balanceDueWithCurrency.amountWithCurrency }}\n                                </td>\n                            </tr>\n                        </tbody>\n                    </table>\n                    <a\n                       class=\"btn btn-default\" href=\"/invoices/{{invoice.id}}\">\n                        <i class=\"fi fi-view\"></i>\n                        View\n                    </a>\n                    <button (click)=\"sendInvoice(invoice.id)\" *ngIf=\"invoice.availableActions.SEND.state === 'active'\" class=\"btn btn-default\"><i class=\"fi fi-send\"></i>Send</button>\n                </div>\n            </ng-container>\n        </div>\n        <shootproof-invoices-block *ngIf=\"shootProofInvoiceLayout && shootProofInvoiceLayout !== null\" [jobId]=\"jobId\" [shootProofInvoiceLayout]=\"shootProofInvoiceLayout\"></shootproof-invoices-block>\n        <pic-time-invoices-block *ngIf=\"picTimeInvoiceLayout &&  picTimeInvoiceLayout !== null\" [jobId]=\"jobId\" [picTimeInvoiceLayout]=\"picTimeInvoiceLayout\" (updateJob)=\"updateView()\"></pic-time-invoices-block>\n    </div>\n</div>\n"

/***/ }),

/***/ "./web/modern/components/invoices/invoices-view-block/invoices-view-block.component.scss":
/***/ (function(module, exports) {

module.exports = ":host .round-btn-left {\n  margin-left: auto; }\n\n:host .invoice-info-block {\n  background-color: white;\n  border: 1px solid #ececec;\n  padding: 15px;\n  width: 100%;\n  margin-top: 20px; }\n\n:host .invoice-info-flex-block {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n  -webkit-justify-content: space-between;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center; }\n\n:host .invoice-info-text {\n  color: #959597; }\n  :host .invoice-info-text > strong {\n    color: #000;\n    font-weight: 600; }\n\n:host .invoice-info-btn {\n  pointer-events: none; }\n"

/***/ }),

/***/ "./web/modern/components/invoices/invoices-view-block/invoices-view-block.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var invoices_data_service_1 = __webpack_require__("./shared/services/invoice/invoices-data-service/invoices.data.service.ts");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var invoice_service_1 = __webpack_require__("./shared/services/invoice/invoice-service/invoice.service.ts");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var InvoicesViewBlockComponent = function () {
    function InvoicesViewBlockComponent(invoiceDataService, messageService, invoiceService) {
        _classCallCheck(this, InvoicesViewBlockComponent);

        this.invoiceDataService = invoiceDataService;
        this.messageService = messageService;
        this.invoiceService = invoiceService;
        this.leadId = null;
        this.sendInvoiceEvent = new core_1.EventEmitter();
        this.createNewInvoiceEvent = new core_1.EventEmitter();
        this.updateViewEvent = new core_1.EventEmitter();
        this.showLoadingBlock = true;
        this.invoicesSN = [];
        this.unsubscribe = new Subject_1.Subject();
    }

    _createClass(InvoicesViewBlockComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.shouldUpdateInvoiceObservable();
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
            this.invoiceDataService.destroyInvoiceUpdatedObservable();
        }
    }, {
        key: "getInvoicesOverview",
        value: function getInvoicesOverview() {
            var _this = this;

            this.invoiceDataService.getInvoiceOverviewV1(this.jobId).pipe(operators_1.takeUntil(this.unsubscribe), operators_1.finalize(function () {
                return _this.showLoadingBlock = false;
            })).subscribe(function (data) {
                return _this.successGetInvoicesOverview(data);
            }, function (error) {
                return _this.messageService.showDefaultErrorMessage(error);
            });
        }
    }, {
        key: "sendInvoice",
        value: function sendInvoice(invoiceId) {
            this.sendInvoiceEvent.emit(invoiceId);
        }
    }, {
        key: "createNewInvoice",
        value: function createNewInvoice() {
            this.leadId !== null ? this.createNewInvoiceEvent.emit(this.leadId) : this.createNewInvoiceEvent.emit(this.jobId);
        }
    }, {
        key: "updateView",
        value: function updateView() {
            this.updateViewEvent.emit();
        }
    }, {
        key: "shouldUpdateInvoiceObservable",
        value: function shouldUpdateInvoiceObservable() {
            var _this2 = this;

            this.invoiceDataService.shouldInvoiceBeUpdatedObservable.pipe(operators_1.takeUntil(this.unsubscribe), operators_1.filter(function (value) {
                return !!value && (value === 'UPDATE_PT_INVOICES' || value === 'UPDATE_SP_INVOICES');
            })).subscribe(function () {
                return _this2.getInvoicesOverview();
            });
        }
    }, {
        key: "successGetInvoicesOverview",
        value: function successGetInvoicesOverview(data) {
            var _data$data = data.data,
                shootProofInvoiceLayout = _data$data.shootProofInvoiceLayout,
                snInvoiceLayout = _data$data.snInvoiceLayout,
                fundyInvoiceLayout = _data$data.fundyInvoiceLayout,
                picTimeInvoiceLayout = _data$data.picTimeInvoiceLayout;

            this.shootProofInvoiceLayout = shootProofInvoiceLayout;
            this.picTimeInvoiceLayout = picTimeInvoiceLayout;
            if (fundyInvoiceLayout !== null && fundyInvoiceLayout.invoices.length !== 0) {
                var mergedInvoices = snInvoiceLayout.invoices.concat(fundyInvoiceLayout.invoices);
                snInvoiceLayout.invoices = mergedInvoices;
            }
            this.invoicesSN = this.invoiceService.setFormattedDaysToDue(JSON.parse(JSON.stringify(snInvoiceLayout.invoices)));
        }
    }, {
        key: "jobId",
        get: function get() {
            return this._jobId;
        },
        set: function set(value) {
            if (value) {
                this._jobId = value;
                this.getInvoicesOverview();
            }
        }
    }]);

    return InvoicesViewBlockComponent;
}();
__decorate([core_1.Input('leadId'), __metadata("design:type", Number)], InvoicesViewBlockComponent.prototype, "leadId", void 0);
__decorate([core_1.Input('isArchived'), __metadata("design:type", Boolean)], InvoicesViewBlockComponent.prototype, "isArchived", void 0);
__decorate([core_1.Output('sendInvoiceEvent'), __metadata("design:type", core_1.EventEmitter)], InvoicesViewBlockComponent.prototype, "sendInvoiceEvent", void 0);
__decorate([core_1.Output('createNewInvoiceEvent'), __metadata("design:type", core_1.EventEmitter)], InvoicesViewBlockComponent.prototype, "createNewInvoiceEvent", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], InvoicesViewBlockComponent.prototype, "updateViewEvent", void 0);
__decorate([core_1.Input('jobId'), __metadata("design:type", Object), __metadata("design:paramtypes", [Object])], InvoicesViewBlockComponent.prototype, "jobId", null);
InvoicesViewBlockComponent = __decorate([core_1.Component({
    selector: 'invoices-view-block',
    template: __webpack_require__("./web/modern/components/invoices/invoices-view-block/invoices-view-block.component.html"),
    styles: [__webpack_require__("./web/modern/components/invoices/invoices-view-block/invoices-view-block.component.scss")]
}), __metadata("design:paramtypes", [invoices_data_service_1.InvoicesDataProvider, message_service_1.MessageService, invoice_service_1.InvoiceServiceProvider])], InvoicesViewBlockComponent);
exports.InvoicesViewBlockComponent = InvoicesViewBlockComponent;

/***/ }),

/***/ "./web/modern/components/invoices/modals/copy-invoice-to-qb-or-xero/copy-invoice-to-qb-or-xero.modal.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-body\">\n    <form class=\"form-horizontal\" role=\"form\">\n        <p class=\"modal-description mt-10 mb-15 text-center copy-to-accounting-label\">Copy invoice(s) to {{ integrationSystemName }}?\n        </p>\n        <div class=\"flex flex-align\">\n            <button (click)=\"integrateInvoiceWithOtherSystem(true)\" [disabled]=\"btnDisabled\"  [is-spinning-wheel-active]=\"copyInvoiceToOtherSystemSpinner\" class=\"btn btn-lg btn-success mb-0 mt-10 mr-10\" spinning-wheel type=\"button\">\n                Import and copy\n            </button>\n            <button (click)=\"integrateInvoiceWithOtherSystem(false)\" [disabled]=\"btnDisabled\" [is-spinning-wheel-active]=\"importInvoicesSpinner\" class=\"btn btn-lg btn-cancel btn-default mt-10 mb-0 mr-10\" spinning-wheel type=\"button\">\n                Import but don't copy\n            </button>\n            <button (click)=\"onDismiss()\" [disabled]=\"btnDisabled\" class=\"btn btn-lg btn-default mt-10 mb-0\" data-dismiss=\"modal\" type=\"button\">\n                Cancel import\n            </button>\n        </div>\n    </form>\n</div>"

/***/ }),

/***/ "./web/modern/components/invoices/modals/copy-invoice-to-qb-or-xero/copy-invoice-to-qb-or-xero.modal.scss":
/***/ (function(module, exports) {

module.exports = ""

/***/ }),

/***/ "./web/modern/components/invoices/modals/copy-invoice-to-qb-or-xero/copy-invoice-to-qb-or-xero.modal.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var invoices_data_service_1 = __webpack_require__("./shared/services/invoice/invoices-data-service/invoices.data.service.ts");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var ng_bootstrap_1 = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/index.js");
var CopyInvoiceToQuickBooksOrXeroModal = function () {
    function CopyInvoiceToQuickBooksOrXeroModal(invoiceDataService, messageService, activeModal) {
        _classCallCheck(this, CopyInvoiceToQuickBooksOrXeroModal);

        this.invoiceDataService = invoiceDataService;
        this.messageService = messageService;
        this.activeModal = activeModal;
        this.updateInvoices = new core_1.EventEmitter();
        this.btnDisabled = false;
        this.copyInvoiceToOtherSystemSpinner = false;
        this.importInvoicesSpinner = false;
        this.unsubscribe = new Subject_1.Subject();
    }

    _createClass(CopyInvoiceToQuickBooksOrXeroModal, [{
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "integrateInvoiceWithOtherSystem",
        value: function integrateInvoiceWithOtherSystem(_integrateInvoiceWithOtherSystem) {
            var _this = this;

            this.btnDisabled = true;
            _integrateInvoiceWithOtherSystem ? this.copyInvoiceToOtherSystemSpinner = true : this.importInvoicesSpinner = true;
            this.invoiceDataService.importInvoicesPicTime(this.jobId, _integrateInvoiceWithOtherSystem).pipe(operators_1.takeUntil(this.unsubscribe), operators_1.finalize(function () {
                return _this.removeSpinnersAndDisabled();
            })).subscribe(function (_ref) {
                var data = _ref.data;

                if (data) {
                    var type = data.type,
                        title = data.title,
                        message = data.message;

                    _this.messageService.showMessageFromBackend(type.toLowerCase().slice(0, 1), title, message);
                }
                _this.updateInvoices.emit(true);
                _this.activeModal.close();
            }, function (error) {
                return _this.messageService.handleError(error);
            });
        }
    }, {
        key: "removeSpinnersAndDisabled",
        value: function removeSpinnersAndDisabled() {
            this.btnDisabled = false;
            this.copyInvoiceToOtherSystemSpinner = false;
            this.importInvoicesSpinner = false;
        }
    }, {
        key: "onDismiss",
        value: function onDismiss() {
            this.activeModal.dismiss();
        }
    }]);

    return CopyInvoiceToQuickBooksOrXeroModal;
}();
__decorate([core_1.Input('jobId'), __metadata("design:type", Number)], CopyInvoiceToQuickBooksOrXeroModal.prototype, "jobId", void 0);
__decorate([core_1.Input('integrationSystemName'), __metadata("design:type", String)], CopyInvoiceToQuickBooksOrXeroModal.prototype, "integrationSystemName", void 0);
__decorate([core_1.Input('invoiceName'), __metadata("design:type", String)], CopyInvoiceToQuickBooksOrXeroModal.prototype, "invoiceName", void 0);
__decorate([core_1.Output('updateInvoices'), __metadata("design:type", core_1.EventEmitter)], CopyInvoiceToQuickBooksOrXeroModal.prototype, "updateInvoices", void 0);
CopyInvoiceToQuickBooksOrXeroModal = __decorate([core_1.Component({
    selector: 'copy-invoice-to-qb-or-xero',
    template: __webpack_require__("./web/modern/components/invoices/modals/copy-invoice-to-qb-or-xero/copy-invoice-to-qb-or-xero.modal.html"),
    styles: [__webpack_require__("./web/modern/components/invoices/modals/copy-invoice-to-qb-or-xero/copy-invoice-to-qb-or-xero.modal.scss")]
}), __metadata("design:paramtypes", [invoices_data_service_1.InvoicesDataProvider, message_service_1.MessageService, ng_bootstrap_1.NgbActiveModal])], CopyInvoiceToQuickBooksOrXeroModal);
exports.CopyInvoiceToQuickBooksOrXeroModal = CopyInvoiceToQuickBooksOrXeroModal;

/***/ }),

/***/ "./web/modern/components/invoices/modals/copy-invoice-to-quickBooks/copy-invoice-to-quickBooks.modal.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal modal-center fade\" data-backdrop=\"static\" data-keyboard=\"false\" id=\"copyInvoiceToQBConfirmationModal\">\n    <div class=\"modal-dialog\" style=\"max-width: 600px\">\n        <div class=\"modal-content\">\n            <div class=\"modal-body\">\n                <form class=\"form-horizontal\" role=\"form\">\n                    <p class=\"modal-description mt-10 mb-15 text-center copy-to-accounting-label\">Copy invoice(s) to {{ integrationSystemName }}?\n                    </p>\n                    <div class=\"flex flex-align\">\n                        <button (click)=\"integrateInvoiceWithOtherSystem(true)\" [disabled]=\"btnDisabled\"  [is-spinning-wheel-active]=\"copyInvoiceToOtherSystemSpinner\" class=\"btn btn-lg btn-success mb-0 mt-10 mr-10\" spinning-wheel type=\"button\">\n                            Import and copy\n                        </button>\n                        <button (click)=\"integrateInvoiceWithOtherSystem(false)\" [disabled]=\"btnDisabled\" [is-spinning-wheel-active]=\"importInvoicesSpinner\" class=\"btn btn-lg btn-cancel btn-default mt-10 mb-0 mr-10\" spinning-wheel type=\"button\">\n                            Import but don't copy\n                        </button>\n                        <button [disabled]=\"btnDisabled\" class=\"btn btn-lg btn-default mt-10 mb-0\" data-dismiss=\"modal\" type=\"button\">\n                            Cancel import\n                        </button>\n                    </div>\n                </form>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),

/***/ "./web/modern/components/invoices/modals/copy-invoice-to-quickBooks/copy-invoice-to-quickBooks.modal.scss":
/***/ (function(module, exports) {

module.exports = ""

/***/ }),

/***/ "./web/modern/components/invoices/modals/copy-invoice-to-quickBooks/copy-invoice-to-quickBooks.modal.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var invoices_data_service_1 = __webpack_require__("./shared/services/invoice/invoices-data-service/invoices.data.service.ts");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var CopyInvoiceToQuickBooksModal = function () {
    function CopyInvoiceToQuickBooksModal(invoiceDataService, messageService) {
        _classCallCheck(this, CopyInvoiceToQuickBooksModal);

        this.invoiceDataService = invoiceDataService;
        this.messageService = messageService;
        this.updateInvoices = new core_1.EventEmitter();
        this.btnDisabled = false;
        this.copyInvoiceToOtherSystemSpinner = false;
        this.importInvoicesSpinner = false;
        this.unsubscribe = new Subject_1.Subject();
    }

    _createClass(CopyInvoiceToQuickBooksModal, [{
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "integrateInvoiceWithOtherSystem",
        value: function integrateInvoiceWithOtherSystem(_integrateInvoiceWithOtherSystem) {
            var _this = this;

            this.btnDisabled = true;
            _integrateInvoiceWithOtherSystem ? this.copyInvoiceToOtherSystemSpinner = true : this.importInvoicesSpinner = true;
            this.invoiceDataService.integrateInvoiceWithQbOrZero(this.jobId, _integrateInvoiceWithOtherSystem).finally(function () {
                return _this.removeSpinnersAndDisabled();
            }).subscribe(function (data) {
                return _this.successIntegrateInvoiceWithOtherSystem(data);
            }, function (error) {
                return _this.messageService.showDefaultErrorMessage(error);
            });
        }
    }, {
        key: "successIntegrateInvoiceWithOtherSystem",
        value: function successIntegrateInvoiceWithOtherSystem(data) {
            this.messageService.showToaster('s_7', 'shootProof');
            this.updateInvoices.emit(data);
            this.dismiss();
        }
    }, {
        key: "removeSpinnersAndDisabled",
        value: function removeSpinnersAndDisabled() {
            this.btnDisabled = false;
            this.copyInvoiceToOtherSystemSpinner = false;
            this.importInvoicesSpinner = false;
        }
    }, {
        key: "dismiss",
        value: function dismiss() {
            $('#copyInvoiceToQBConfirmationModal').modal('hide');
        }
    }]);

    return CopyInvoiceToQuickBooksModal;
}();
__decorate([core_1.Input('jobId'), __metadata("design:type", Number)], CopyInvoiceToQuickBooksModal.prototype, "jobId", void 0);
__decorate([core_1.Input('integrationSystemName'), __metadata("design:type", String)], CopyInvoiceToQuickBooksModal.prototype, "integrationSystemName", void 0);
__decorate([core_1.Input('invoiceName'), __metadata("design:type", String)], CopyInvoiceToQuickBooksModal.prototype, "invoiceName", void 0);
__decorate([core_1.Output('updateInvoices'), __metadata("design:type", core_1.EventEmitter)], CopyInvoiceToQuickBooksModal.prototype, "updateInvoices", void 0);
CopyInvoiceToQuickBooksModal = __decorate([core_1.Component({
    selector: 'copy-invoice-to-quickBooks',
    template: __webpack_require__("./web/modern/components/invoices/modals/copy-invoice-to-quickBooks/copy-invoice-to-quickBooks.modal.html"),
    styles: [__webpack_require__("./web/modern/components/invoices/modals/copy-invoice-to-quickBooks/copy-invoice-to-quickBooks.modal.scss")]
}), __metadata("design:paramtypes", [invoices_data_service_1.InvoicesDataProvider, message_service_1.MessageService])], CopyInvoiceToQuickBooksModal);
exports.CopyInvoiceToQuickBooksModal = CopyInvoiceToQuickBooksModal;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./web/modern/components/invoices/modals/delete-invoice-modal/delete-invoice-modal.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"deleteModal\" class=\"modal modal-center fade\" data-backdrop=\"static\" data-keyboard=\"false\">\n  <div class=\"modal-dialog\">\n    <div class=\"modal-content\">\n      <div class=\"modal-header\">\n        <button class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\">&times;</button>\n        <h3 class=\"modal-title\">Delete invoice</h3>\n      </div>\n      <div class=\"modal-body\">\n        <strong>\n          Are you sure?\n          <br>All payments will be deleted!\n        </strong>\n      </div>\n      <div class=\"modal-footer\">\n        <button [disabled]=\"buttonDisabled\" class=\"btn btn-danger btn-lg pull-left\" (click)=\"deleteInvoice(invoice.id)\"\n                spinning-wheel [is-spinning-wheel-active]=\"isDeleteInvoiceSpinnningWheelActive\">Delete invoice\n        </button>\n        <button class=\"btn btn-default btn-lg pull-left\" data-dismiss=\"modal\">Cancel</button>\n      </div>\n    </div>\n  </div>\n</div>"

/***/ }),

/***/ "./web/modern/components/invoices/modals/delete-invoice-modal/delete-invoice-modal.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var invoices_data_service_1 = __webpack_require__("./shared/services/invoice/invoices-data-service/invoices.data.service.ts");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var DeleteInvoiceModalComponent = function () {
    function DeleteInvoiceModalComponent(invoicesDataService, messageService) {
        _classCallCheck(this, DeleteInvoiceModalComponent);

        this.invoicesDataService = invoicesDataService;
        this.messageService = messageService;
        this.updateParent = new core_1.EventEmitter();
    }

    _createClass(DeleteInvoiceModalComponent, [{
        key: "deleteInvoice",
        value: function deleteInvoice(invoiceId) {
            var _this = this;

            this.isDeleteInvoiceSpinnningWheelActive = true;
            this.buttonDisabled = true;
            invoiceId = invoiceId || null;
            this.invoicesDataService.deleteInvoice(invoiceId).pipe(operators_1.finalize(function () {
                return _this.isDeleteInvoiceSpinnningWheelActive = false;
            })).finally(function () {
                return _this.buttonDisabled = false;
            }).subscribe(function (data) {
                return _this.successDeleteInvoice(data);
            }, function (error) {
                _this.errorDeleteInvoice(error);
            });
        }
    }, {
        key: "successDeleteInvoice",
        value: function successDeleteInvoice(data) {
            if (data) {
                if (data.errorCode) {
                    this.handleModernErrorMessages(data);
                    $('#deleteModal').modal('hide');
                    return;
                }
                if (data.errorMessage) {
                    this.messageService.showToaster('e_0', 'payments');
                    $('#deleteModal').modal('hide');
                    return;
                }
                this.messageService.showToaster('s_8', 'payments');
                $('#deleteModal').modal('hide');
            }
            this.updateParent.emit(true);
        }
    }, {
        key: "errorDeleteInvoice",
        value: function errorDeleteInvoice(_ref) {
            var status = _ref.status,
                data = _ref.data;

            if (data.errorCode) {
                this.handleModernErrorMessages(data);
                return;
            }
            var errorMessage = data.errorMessage;
            var errorCode = void 0,
                errorPlace = void 0,
                value = void 0;
            if (status >= 400 && status < 500 && errorMessage) {
                if (errorMessage.includes('This payment cannot be marked as unpaid because it was overpaid in Xero.')) {
                    errorCode = 'e_12';
                    errorPlace = 'xero';
                    value = 'invoice';
                } else if (errorMessage.includes('Xero access token expired, reconnect Xero please') || errorMessage.includes('Bummer! Xero access token not authorized or revoked, reconnect Xero please') || errorMessage.includes('Bummer! Xero access token revoked, reconnect Xero please')) {
                    errorCode = 'e_14';
                    errorPlace = 'xero';
                } else if (errorMessage.includes("Bummer! You don't have an active Xero subscription.")) {
                    errorCode = 'e_15';
                    errorPlace = 'xero';
                } else {
                    errorCode = 'e_2';
                    errorPlace = 'general';
                    value = errorMessage;
                }
            } else {
                errorCode = 'e_0';
                errorPlace = 'general';
            }
            this.messageService.showToaster(errorCode, errorPlace, value);
        }
    }, {
        key: "handleModernErrorMessages",
        value: function handleModernErrorMessages(_ref2) {
            var errorTitle = _ref2.errorTitle,
                errorMessage = _ref2.errorMessage;

            this.messageService.showErrorFromBackend(errorTitle, errorMessage);
        }
    }]);

    return DeleteInvoiceModalComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], DeleteInvoiceModalComponent.prototype, "invoice", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], DeleteInvoiceModalComponent.prototype, "updateParent", void 0);
DeleteInvoiceModalComponent = __decorate([core_1.Component({
    selector: 'delete-invoice-modal',
    template: __webpack_require__("./web/modern/components/invoices/modals/delete-invoice-modal/delete-invoice-modal.html")
}), __metadata("design:paramtypes", [invoices_data_service_1.InvoicesDataProvider, message_service_1.MessageService])], DeleteInvoiceModalComponent);
exports.DeleteInvoiceModalComponent = DeleteInvoiceModalComponent;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./web/modern/components/invoices/pic-time-invoices-block/pic-time-invoices-block.component.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"pic-time-invoices-block\" *ngIf=\"picTimeAvailable\">\n    <div class=\"main-jobs-cell__title--bordered flex-box flex-just-space-between\">\n        <h4>Pic-Time</h4>\n        <div class=\"re-sync\" *ngIf=\"picTimeInvoiceLayout?.actions?.SYNCHRONIZE_PIC_TIME_INVOICES_FOR_JOB\">\n            <button [disabled]=\"syncState\" class=\"re-sync--btn btn btn-default btn-rounded mr-0 mb-0\"\n                    (click)=\"syncPicTimeOrders(picTimeInvoiceLayout?.actions?.SYNCHRONIZE_PIC_TIME_INVOICES_FOR_JOB)\">\n                <i [class.active]=\"syncState\" class=\"re-sync--btn__icon fa fa-repeat\" aria-hidden=\"true\"></i>\n            </button>\n        </div>\n    </div>\n\n    <div *ngIf=\"picTimeInvoicesDataResponse?.invoices && picTimeInvoicesDataResponse?.invoices.length !== 0\" class=\"flex-row section-data__wrapper\">\n        <ng-container *ngFor=\"let invoice of picTimeInvoicesDataResponse?.invoices\">\n            <div class=\"section-data section-data--full flex-basis-full\">\n                <table class=\"table-profile table-full-width\">\n                    <tbody>\n                    <tr>\n                        <td><h4>Invoice {{ invoice.invoiceId }}</h4></td>\n                        <td></td>\n                        <td class=\"text-right\">\n                            Total: {{ invoice.totalWithCurrency.amountWithCurrency }}\n                        </td>\n                    </tr>\n                    <tr>\n                        <td *ngIf=\"!invoice.writeOffOn\">\n                            <p *ngIf=\"invoice.sentAt\" class=\"m-0\" >Sent on {{ invoice.sentAt | timeFilter:'long' }}</p>\n\n                            <p class=\"m-0\">Imported from Pic-Time on {{ invoice.createdAt | timeFilter:'long' }}</p>\n                            <p *ngIf=\"invoice.poNumber\" class=\"m-0\">{{ invoice.poNumber  }}</p>\n\n                            <span *ngIf=\"invoice.balanceDueWithCurrency.amount !== 0 || !invoice.paidOn\" class=\"grey-span\">\n                                Next payment due  {{ invoice.nextPaymentDate | timeFilter: 'long' }}\n                                <span *ngIf=\"!invoice.paidOn \" [ngClass]=\"invoice.daysToDue < 0 ? 'red': 'gray-label'\" class=\"text-nowrap\">\n                                    ({{ invoice.formattedDaysToDue }})\n                                </span>\n                             </span>\n\n                            <span *ngIf=\"invoice.paidOn\" class=\"green-light-label\">Paid on {{ invoice.paidOn | timeFilter:'long' }}</span>\n                        </td>\n                        <td >\n                            <span *ngIf=\"invoice.writeOffOn\">\n                                Written off on {{ invoice.writeOffOn | timeFilter: 'long' }}\n                            </span>\n                        </td>\n                        <td *ngIf=\"!invoice.writeOffOn && invoice.totalWithCurrency.total !== 0 && invoice.balanceDueWithCurrency.amount !== 0\" class=\"text-right\">\n                            Balance Due: {{ invoice.balanceDueWithCurrency.amountWithCurrency }}\n                        </td>\n                    </tr>\n                    </tbody>\n                </table>\n                <a\n                   class=\"btn btn-default\" href=\"/invoices/{{invoice.id}}\">\n                    <i class=\"fi fi-view\"></i>\n                    View\n                </a>\n            </div>\n        </ng-container>\n    </div>\n\n    <div *ngIf=\"picTimeInvoicesDataResponse?.invoicesToImport && picTimeInvoicesDataResponse?.invoicesToImport.length !== 0\" [hidden]=\"showLoadingBlock\" class=\"invoice-info-block\">\n        <div class=\"invoice-info-flex-block\">\n            <span class=\"invoice-info-text\">\n                You have <strong>{{ picTimeInvoicesDataResponse?.invoicesToImport.length }} <span>{{ picTimeInvoicesDataResponse?.invoicesToImport.length === 1 ? 'Order' : 'Orders' }}</span></strong> waiting to be imported.\n            </span>\n            <span>\n                 <button [disabled]=\"importOrdersDisable\"  spinning-wheel [is-spinning-wheel-dark]=\"'true'\" [is-spinning-wheel-active]=\"importOrdersDisable\" (click)=\"approveCopyToAccountingModal()\" class=\"btn btn-default mb-0\"><i class=\"fa fa-cloud-upload\"></i>Import</button>\n            </span>\n        </div>\n    </div>\n\n    <div *ngIf=\"showLoadingBlock\" class=\"invoice-info-block\">\n        <div class=\"invoice-info-flex-block\">\n            <span class=\"invoice-info-text\">\n                Loading invoices...\n            </span>\n            <span>\n                <button class=\"btn btn-add-round invoice-info-btn btn-success spinning-wheel spinning-wheel__active spinning-wheel__display-after\"\n                        type=\"button\">\n                </button>\n            </span>\n        </div>\n    </div>\n\n    <div *ngIf=\"availableActions.includes('showFeatureUnsupportedMessage') && messagesFromPicTime !== null\" class=\"invoice-info-block\">\n        <div class=\"invoice-info-flex-block\">\n            <span class=\"invoice-info-text\">\n               {{ messagesFromPicTime }}\n            </span>\n        </div>\n    </div>\n\n    <div *ngIf=\"messagesFromPicTime === null && picTimeInvoicesDataResponse?.invoices.length === 0 && picTimeInvoicesDataResponse?.invoicesToImport.length === 0\" [hidden]=\"showLoadingBlock\" class=\"invoice-info-block\">\n        <div class=\"invoice-info-flex-block\">\n            <span class=\"invoice-info-text\">\n              There are no Orders to import from Pic-Time.\n            </span>\n        </div>\n    </div>\n\n</div>\n"

/***/ }),

/***/ "./web/modern/components/invoices/pic-time-invoices-block/pic-time-invoices-block.component.scss":
/***/ (function(module, exports) {

module.exports = ":host .pic-time-invoices-block {\n  width: 100%;\n  margin-top: 20px;\n  font-size: 13px;\n  line-height: 20px;\n  color: #45464c; }\n\n:host h4 {\n  font-weight: 700;\n  line-height: 20px; }\n\n:host .invoice-info-block {\n  background-color: white;\n  border: 1px solid #ececec;\n  padding: 15px;\n  width: 100%;\n  margin-top: 20px; }\n\n:host .invoice-info-flex-block {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n  -webkit-justify-content: space-between;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center; }\n\n:host .invoice-info-text {\n  color: #959597; }\n  :host .invoice-info-text > strong {\n    color: #000;\n    font-weight: 600; }\n\n:host .invoice-info-btn {\n  pointer-events: none; }\n"

/***/ }),

/***/ "./web/modern/components/invoices/pic-time-invoices-block/pic-time-invoices-block.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var invoices_data_service_1 = __webpack_require__("./shared/services/invoice/invoices-data-service/invoices.data.service.ts");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var invoice_service_1 = __webpack_require__("./shared/services/invoice/invoice-service/invoice.service.ts");
var settings_1 = __webpack_require__("./shared/services/settings/settings.ts");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var copy_invoice_to_qb_or_xero_modal_1 = __webpack_require__("./web/modern/components/invoices/modals/copy-invoice-to-qb-or-xero/copy-invoice-to-qb-or-xero.modal.ts");
var PicTimeInvoicesBlockComponent = function () {
    function PicTimeInvoicesBlockComponent(invoiceDataService, invoiceServiceProvider, messageService, settingsService, modalService) {
        _classCallCheck(this, PicTimeInvoicesBlockComponent);

        this.invoiceDataService = invoiceDataService;
        this.invoiceServiceProvider = invoiceServiceProvider;
        this.messageService = messageService;
        this.settingsService = settingsService;
        this.modalService = modalService;
        this.updateJob = new core_1.EventEmitter();
        this.showLoadingBlock = false;
        this.integrationSystemName = null;
        this.integrateInvoiceWithOtherSystem = false;
        this.messagesFromPicTime = null;
        this.availableActions = [];
        this.importOrdersDisable = false;
        this.unsubscribe = new Subject_1.Subject();
    }

    _createClass(PicTimeInvoicesBlockComponent, [{
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "ngOnInit",
        value: function ngOnInit() {
            this.isPicTimeAvailable();
        }
    }, {
        key: "ngOnChanges",
        value: function ngOnChanges(changes) {
            if (!changes.picTimeInvoiceLayout.firstChange) {
                this.isPicTimeAvailable();
            }
        }
    }, {
        key: "isPicTimeAvailable",
        value: function isPicTimeAvailable() {
            var _this = this;

            this.settingsService.timeFormatSettings.pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (data) {
                if (data.picTimeAvailable) {
                    _this.getInvoicesPicTime();
                }
            });
        }
    }, {
        key: "getInvoicesPicTime",
        value: function getInvoicesPicTime() {
            var _this2 = this;

            if (this.picTimeInvoiceLayout.actions.FETCH_PIC_TIME_INVOICES_FOR_JOB) {
                this.picTimeAvailable = true;
                var url = this.picTimeInvoiceLayout.actions.FETCH_PIC_TIME_INVOICES_FOR_JOB.url;

                this.invoiceDataService.getInvoicesPicTime(url).pipe(operators_1.takeUntil(this.unsubscribe), operators_1.finalize(function () {
                    return _this2.showLoadingBlock = false;
                })).subscribe(function (data) {
                    _this2.picTimeInvoicesDataResponse = data.data;
                    _this2.picTimeInvoicesDataResponse.invoices = _this2.invoiceServiceProvider.setFormattedDaysToDue(JSON.parse(JSON.stringify(data.data.invoices)));
                }, function (error) {
                    return _this2.messageService.handleError(error);
                });
            } else {
                this.picTimeAvailable = false;
            }
        }
    }, {
        key: "importPicTimeOrders",
        value: function importPicTimeOrders() {
            var _this3 = this;

            this.importOrdersDisable = true;
            this.invoiceDataService.importInvoicesPicTime(this.jobId, this.integrateInvoiceWithOtherSystem).pipe(operators_1.takeUntil(this.unsubscribe), operators_1.finalize(function () {
                return _this3.importOrdersDisable = false;
            })).subscribe(function (_ref) {
                var data = _ref.data;

                if (data) {
                    var type = data.type,
                        title = data.title,
                        message = data.message;

                    _this3.messageService.showMessageFromBackend(type.toLowerCase().slice(0, 1), title, message);
                }
                _this3.updateJob.emit();
                _this3.getInvoicesPicTime();
            }, function (error) {
                return _this3.messageService.handleError(error);
            });
        }
    }, {
        key: "syncPicTimeOrders",
        value: function syncPicTimeOrders(action) {
            var _this4 = this;

            if (action) {
                this.syncState = true;
                var url = action.url,
                    method = action.method;

                this.invoiceDataService.syncPicTimeOrders(url, method).pipe(operators_1.takeUntil(this.unsubscribe), operators_1.finalize(function () {
                    return _this4.syncState = false;
                })).subscribe(function (_ref2) {
                    var data = _ref2.data;

                    _this4.messageService.showToaster('s_8', 'picTime');
                    _this4.picTimeInvoicesDataResponse = data;
                }, function (error) {
                    return _this4.messageService.handleError(error);
                });
            }
        }
    }, {
        key: "approveCopyToAccountingModal",
        value: function approveCopyToAccountingModal() {
            if (this.picTimeInvoicesDataResponse.ordersFeatureDetails.availableActions.includes('showCopyToXeroModal')) {
                this.integrationSystemName = 'Xero';
                this.openCopyToQuickBooksOrXeroModal();
            } else if (this.picTimeInvoicesDataResponse.ordersFeatureDetails.availableActions.includes('showCopyToQbModal')) {
                this.integrationSystemName = 'QuickBooks';
                this.openCopyToQuickBooksOrXeroModal();
            } else {
                this.importPicTimeOrders();
            }
        }
    }, {
        key: "openCopyToQuickBooksOrXeroModal",
        value: function openCopyToQuickBooksOrXeroModal() {
            var _this5 = this;

            this.copyToAccountingModalRef = this.modalService.openModal(copy_invoice_to_qb_or_xero_modal_1.CopyInvoiceToQuickBooksOrXeroModal, {
                windowClass: 'ng-bootstrap-modal-small'
            });
            this.copyToAccountingModalRef.componentInstance.jobId = this.jobId;
            this.copyToAccountingModalRef.componentInstance.integrationSystemName = this.integrationSystemName;
            this.copyToAccountingModalRef.componentInstance.invoiceName = 'picTime';
            this.copyToAccountingModalRef.result.then(function () {
                _this5.updateJob.emit();
                _this5.getInvoicesPicTime();
            });
        }
    }]);

    return PicTimeInvoicesBlockComponent;
}();
__decorate([core_1.Input('jobId'), __metadata("design:type", Number)], PicTimeInvoicesBlockComponent.prototype, "jobId", void 0);
__decorate([core_1.Input('picTimeInvoiceLayout'), __metadata("design:type", Object)], PicTimeInvoicesBlockComponent.prototype, "picTimeInvoiceLayout", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], PicTimeInvoicesBlockComponent.prototype, "updateJob", void 0);
PicTimeInvoicesBlockComponent = __decorate([core_1.Component({
    selector: 'pic-time-invoices-block',
    template: __webpack_require__("./web/modern/components/invoices/pic-time-invoices-block/pic-time-invoices-block.component.html"),
    styles: [__webpack_require__("./web/modern/components/invoices/pic-time-invoices-block/pic-time-invoices-block.component.scss")]
}), __metadata("design:paramtypes", [invoices_data_service_1.InvoicesDataProvider, invoice_service_1.InvoiceServiceProvider, message_service_1.MessageService, settings_1.SettingsProvider, snModal_service_1.SNModalService])], PicTimeInvoicesBlockComponent);
exports.PicTimeInvoicesBlockComponent = PicTimeInvoicesBlockComponent;

/***/ }),

/***/ "./web/modern/components/invoices/shootproof-invoices-block/shootproof-invoices-block.component.html":
/***/ (function(module, exports) {

module.exports = "<div *ngIf=\"isShootProofAvailable\" class=\"shootProof-invoices-block\">\n    <div class=\"main-jobs-cell__title--bordered\">\n        <h4>ShootProof</h4>\n    </div>\n\n    <div *ngIf=\"shootProofInvoices && shootProofInvoices.length !== 0\" class=\"flex-row section-data__wrapper\">\n        <ng-container *ngFor=\"let invoice of shootProofInvoices\">\n            <div class=\"section-data section-data--full flex-basis-full\">\n                <table class=\"table-profile table-full-width\">\n                    <tbody>\n                    <tr>\n                        <td><h4>Invoice {{ invoice.invoiceId }}</h4></td>\n                        <td></td>\n                        <td class=\"text-right\">\n                            Total: {{ invoice.totalWithCurrency.amountWithCurrency }}\n                        </td>\n                    </tr>\n                    <tr>\n                        <td *ngIf=\"!invoice.writeOffOn\">\n                            <p *ngIf=\"invoice.sentAt\" class=\"m-0\" >Sent on {{ invoice.sentAt | timeFilter:'long' }}</p>\n\n                            <p class=\"m-0\">Imported from ShootProof on {{ invoice.createdAt | timeFilter:'long' }}</p>\n\n                            <span *ngIf=\"invoice.balanceDueWithCurrency.amount !== 0 || !invoice.paidOn\" class=\"grey-span\">\n                                Next payment due  {{ invoice.nextPaymentDate | timeFilter: 'long' }}\n                                <span *ngIf=\"!invoice.paidOn \" [ngClass]=\"invoice.daysToDue < 0 ? 'red': 'gray-label'\" class=\"text-nowrap\">\n                                    ({{ invoice.formattedDaysToDue }})\n                                </span>\n                             </span>\n\n                            <span *ngIf=\"invoice.paidOn\" class=\"green-light-label\">Paid on {{ invoice.paidOn | timeFilter:'long' }}</span>\n                        </td>\n                        <td >\n                            <span *ngIf=\"invoice.writeOffOn\">\n                                Written off on {{ invoice.writeOffOn | timeFilter: 'long' }}\n                            </span>\n                        </td>\n                        <td *ngIf=\"!invoice.writeOffOn && invoice.totalWithCurrency.total !== 0 && invoice.balanceDueWithCurrency.amount !== 0\" class=\"text-right\">\n                            Balance Due: {{ invoice.balanceDueWithCurrency.amountWithCurrency }}\n                        </td>\n                    </tr>\n                    </tbody>\n                </table>\n                <a\n                   class=\"btn btn-default\" href=\"/invoices/{{invoice.id}}\">\n                    <i class=\"fi fi-view\"></i>\n                    View\n                </a>\n            </div>\n        </ng-container>\n    </div>\n\n    <div *ngIf=\"ordersToImport && ordersToImport.length !== 0 && availableActions.includes('importNewOrders')\" [hidden]=\"showLoadingBlock\" class=\"invoice-info-block\">\n        <div class=\"invoice-info-flex-block\">\n            <span class=\"invoice-info-text\">\n                You have <strong>{{ ordersToImport.length }} <span>{{ ordersToImport.length === 1 ? 'Order' : 'Orders' }}</span></strong> waiting to be imported.\n            </span>\n            <span>\n                 <button (click)=\"importShootProofOrders()\" class=\"btn btn-default mb-0\"><i class=\"fa fa-cloud-upload\"></i>Import</button>\n            </span>\n        </div>\n    </div>\n\n    <div *ngIf=\"showLoadingBlock\" class=\"invoice-info-block\">\n        <div class=\"invoice-info-flex-block\">\n            <span class=\"invoice-info-text\">\n                Loading invoices...\n            </span>\n            <span>\n                <button class=\"btn btn-add-round invoice-info-btn btn-success spinning-wheel spinning-wheel__active spinning-wheel__display-after\"\n                        type=\"button\">\n                </button>\n            </span>\n        </div>\n    </div>\n\n    <div *ngIf=\"availableActions.includes('showFeatureUnsupportedMessage') && messagesFromShootProof !== null\" class=\"invoice-info-block\">\n        <div class=\"invoice-info-flex-block\">\n            <span class=\"invoice-info-text\">\n               {{ messagesFromShootProof }}\n            </span>\n        </div>\n    </div>\n\n    <div *ngIf=\"messagesFromShootProof === null && shootProofInvoices.length === 0 && ordersToImport.length === 0\" [hidden]=\"showLoadingBlock\" class=\"invoice-info-block\">\n        <div class=\"invoice-info-flex-block\">\n            <span class=\"invoice-info-text\">\n              There are no Orders to import from ShootProof.\n            </span>\n        </div>\n    </div>\n\n</div>\n\n<copy-invoice-to-quickBooks (updateInvoices)=\"successGetInvoices($event)\" [integrationSystemName]=\"integrationSystemName\" [jobId]=\"jobId\" ></copy-invoice-to-quickBooks>\n"

/***/ }),

/***/ "./web/modern/components/invoices/shootproof-invoices-block/shootproof-invoices-block.component.scss":
/***/ (function(module, exports) {

module.exports = ":host .shootProof-invoices-block {\n  width: 100%;\n  margin-top: 20px;\n  font-size: 13px;\n  line-height: 20px;\n  color: #45464c; }\n\n:host h4 {\n  font-weight: 700;\n  line-height: 20px; }\n\n:host .invoice-info-block {\n  background-color: white;\n  border: 1px solid #ececec;\n  padding: 15px;\n  width: 100%;\n  margin-top: 20px; }\n\n:host .invoice-info-flex-block {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n  -webkit-justify-content: space-between;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center; }\n\n:host .invoice-info-text {\n  color: #959597; }\n  :host .invoice-info-text > strong {\n    color: #000;\n    font-weight: 600; }\n\n:host .invoice-info-btn {\n  pointer-events: none; }\n"

/***/ }),

/***/ "./web/modern/components/invoices/shootproof-invoices-block/shootproof-invoices-block.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var http_1 = __webpack_require__("./node_modules/@angular/common/esm5/http.js");
var time_service_1 = __webpack_require__("./shared/services/helpers/time-service/time.service.ts");
var auth_tokens_service_1 = __webpack_require__("./web/modern/auth-tokens.service.ts");
var invoices_data_service_1 = __webpack_require__("./shared/services/invoice/invoices-data-service/invoices.data.service.ts");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var invoice_service_1 = __webpack_require__("./shared/services/invoice/invoice-service/invoice.service.ts");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var ShootproofInvoicesBlockComponent = function () {
    function ShootproofInvoicesBlockComponent(http, timeService, authTokensService, invoiceDataService, invoiceService, messageService) {
        _classCallCheck(this, ShootproofInvoicesBlockComponent);

        this.http = http;
        this.timeService = timeService;
        this.authTokensService = authTokensService;
        this.invoiceDataService = invoiceDataService;
        this.invoiceService = invoiceService;
        this.messageService = messageService;
        this.showLoadingBlock = true;
        this.showShootProofInvoices = true;
        this.integrationSystemName = null;
        this.shootProofInvoices = [];
        this.ordersToImport = [];
        this.messagesFromShootProof = null;
        this.availableActions = [];
        this.unsubscribe = new Subject_1.Subject();
    }

    _createClass(ShootproofInvoicesBlockComponent, [{
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
            this.invoiceDataService.destroyInvoiceUpdatedObservable();
        }
    }, {
        key: "ngOnInit",
        value: function ngOnInit() {
            this.getInvoices();
        }
    }, {
        key: "ngOnChanges",
        value: function ngOnChanges(changes) {
            if (!changes.shootProofInvoiceLayout.firstChange) {
                this.getInvoices();
            }
        }
    }, {
        key: "successGetInvoices",
        value: function successGetInvoices(data) {
            var _data$data = data.data,
                ordersImportingDetails = _data$data.ordersImportingDetails,
                invoices = _data$data.invoices;
            var importNewOrders = ordersImportingDetails.importNewOrders,
                availableActions = ordersImportingDetails.availableActions,
                showMessage = ordersImportingDetails.showMessage;

            this.shootProofInvoices = this.invoiceService.setFormattedDaysToDue(JSON.parse(JSON.stringify(invoices)));
            if (importNewOrders && importNewOrders !== null) {
                this.ordersToImport = importNewOrders.ordersToImport;
                this.ordersToImportUrl = importNewOrders.url;
            }
            this.availableActions = availableActions;
            this.messagesFromShootProof = showMessage;
        }
    }, {
        key: "importShootProofOrders",
        value: function importShootProofOrders() {
            if (this.availableActions.includes('copyToXero')) {
                this.integrationSystemName = 'Xero';
                this.openCopyInvoiceToQBModal();
            } else if (this.availableActions.includes('copyToQb')) {
                this.integrationSystemName = 'QuickBooks';
                this.openCopyInvoiceToQBModal();
            } else {
                this.importShootProofOrdersWithotSync();
            }
        }
    }, {
        key: "importShootProofOrdersWithotSync",
        value: function importShootProofOrdersWithotSync() {
            var _this = this;

            var link = this.ordersToImportUrl;
            this.showLoadingBlock = true;
            var headers = this.getHeadersForRequest();
            this.http.post(link, null, { headers: headers }).takeUntil(this.unsubscribe).finally(function () {
                return _this.showLoadingBlock = false;
            }).subscribe(function (data) {
                _this.messageService.showToaster('s_7', 'shootProof');
                _this.successGetInvoices(data);
            }, function () {
                return _this.resetShootProofInvoices();
            });
        }
    }, {
        key: "openCopyInvoiceToQBModal",
        value: function openCopyInvoiceToQBModal() {
            $('#copyInvoiceToQBConfirmationModal').modal('show');
        }
    }, {
        key: "getInvoices",
        value: function getInvoices() {
            var _this2 = this;

            if (this.shootProofInvoiceLayout.actions.GET_SP_INVOICES) {
                this.isShootProofAvailable = true;
                this.getShootProofInvoicesLink = this.shootProofInvoiceLayout.actions.GET_SP_INVOICES.url;
                var headers = this.getHeadersForRequest();
                this.showLoadingBlock = true;
                this.http.get(this.getShootProofInvoicesLink, { headers: headers }).takeUntil(this.unsubscribe).finally(function () {
                    return _this2.showLoadingBlock = false;
                }).subscribe(function (data) {
                    return _this2.successGetInvoices(data);
                }, function () {
                    return _this2.resetShootProofInvoices();
                });
            } else {
                this.isShootProofAvailable = false;
            }
        }
    }, {
        key: "resetShootProofInvoices",
        value: function resetShootProofInvoices() {
            this.shootProofInvoices = [];
            this.ordersToImport = [];
            this.ordersToImportUrl = null;
            this.messagesFromShootProof = null;
            this.showShootProofInvoices = false;
        }
    }, {
        key: "getHeadersForRequest",
        value: function getHeadersForRequest() {
            var token = this.authTokensService.getAuthToken();
            return new http_1.HttpHeaders().set('Authorization', "Bearer " + token);
        }
    }]);

    return ShootproofInvoicesBlockComponent;
}();
__decorate([core_1.Input('shootProofInvoiceLayout'), __metadata("design:type", Object)], ShootproofInvoicesBlockComponent.prototype, "shootProofInvoiceLayout", void 0);
__decorate([core_1.Input('jobId'), __metadata("design:type", Number)], ShootproofInvoicesBlockComponent.prototype, "jobId", void 0);
ShootproofInvoicesBlockComponent = __decorate([core_1.Component({
    selector: 'shootproof-invoices-block',
    template: __webpack_require__("./web/modern/components/invoices/shootproof-invoices-block/shootproof-invoices-block.component.html"),
    styles: [__webpack_require__("./web/modern/components/invoices/shootproof-invoices-block/shootproof-invoices-block.component.scss")]
}), __metadata("design:paramtypes", [http_1.HttpClient, time_service_1.TimeServiceProvider, auth_tokens_service_1.AuthTokensService, invoices_data_service_1.InvoicesDataProvider, invoice_service_1.InvoiceServiceProvider, message_service_1.MessageService])], ShootproofInvoicesBlockComponent);
exports.ShootproofInvoicesBlockComponent = ShootproofInvoicesBlockComponent;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./web/modern/components/jobs/common/btn-add-file/btn-add-file.html":
/***/ (function(module, exports) {

module.exports = "<div *ngIf=\"files.length === 0\" class=\"add-file-wrapper {{imageClass}}\" [ngClass]=\"{'disable-btn': isActiveSpinner}\" (change)=\"onSaveFiles($event)\">\n    <div class=\"spinning-wheel spinning-wheel__display-before\" spinning-wheel [is-spinning-wheel-active]=\"isActiveSpinner\">\n        <input type=\"file\" name=\"file\" id=\"file-upload\" class=\"input-file\" />\n        <label class=\"btn btn-add-round\" for=\"file-upload\"></label>\n    </div>\n</div>\n\n<div  *ngIf=\"files.length > 0\"  class=\"add-file-wrapper {{imageClass}} spinning-wheel spinning-wheel__display-before\" [ngClass]=\"{'disable-btn': isActiveSpinner}\" spinning-wheel [is-spinning-wheel-active]=\"isActiveSpinner\">\n    <input type=\"file\" name=\"file\" id=\"file-upload1\" class=\"input-file\" (change)=\"onSaveFiles($event)\" />\n    <label class=\"btn btn-add-round\" for=\"file-upload1\"></label>\n</div>\n"

/***/ }),

/***/ "./web/modern/components/jobs/common/btn-add-file/btn-add-file.scss":
/***/ (function(module, exports) {

module.exports = ".disable-btn {\n  pointer-events: none; }\n\n.add-file-wrapper.disable-btn label:hover:before {\n  color: transparent; }\n"

/***/ }),

/***/ "./web/modern/components/jobs/common/btn-add-file/btn-add-file.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var BtnAddFile = function () {
    function BtnAddFile(messageService) {
        _classCallCheck(this, BtnAddFile);

        this.messageService = messageService;
        this.saveFiles = new core_1.EventEmitter();
    }

    _createClass(BtnAddFile, [{
        key: "onSaveFiles",
        value: function onSaveFiles(event) {
            var _this = this;

            var values = [];
            var maxMb = 50; // 50 Mb
            var maxSize = maxMb * 1000 * 1024;
            var maxAllowedUploadFileSize = 20 * 1000 * 1024;
            Object.values(event.target.files).forEach(function (item) {
                if (item.size <= maxAllowedUploadFileSize) {
                    values.push(item);
                    var tmpDate = new Date(item.lastModifiedDate);
                    var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
                    item.customLastModifiedDate = tmpDate.getDate() + " " + monthNames[tmpDate.getMonth()] + " " + tmpDate.getFullYear();
                    item.convertedSize = (parseInt(item.size) / (1024 * 1024)).toFixed(2); // convert from bytes to MB
                    _this.saveFiles.emit({ item: item, jobId: _this.jobId });
                } else if (maxSize > item.size && item.size > maxAllowedUploadFileSize) {
                    _this.messageService.showToaster('e_4', 'attachments');
                } else {
                    _this.messageService.showToaster('e_1', 'attachments');
                }
                event.target.value = '';
            });
        }
    }]);

    return BtnAddFile;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], BtnAddFile.prototype, "isActiveSpinner", void 0);
__decorate([core_1.Input(), __metadata("design:type", Array)], BtnAddFile.prototype, "files", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], BtnAddFile.prototype, "imageClass", void 0);
__decorate([core_1.Input(), __metadata("design:type", Number)], BtnAddFile.prototype, "jobId", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], BtnAddFile.prototype, "saveFiles", void 0);
BtnAddFile = __decorate([core_1.Component({
    selector: 'btn-add-file',
    template: __webpack_require__("./web/modern/components/jobs/common/btn-add-file/btn-add-file.html"),
    styles: [__webpack_require__("./web/modern/components/jobs/common/btn-add-file/btn-add-file.scss")]
}), __metadata("design:paramtypes", [message_service_1.MessageService])], BtnAddFile);
exports.BtnAddFile = BtnAddFile;

/***/ }),

/***/ "./web/modern/components/jobs/common/btn-delete-file/btn-delete-file.html":
/***/ (function(module, exports) {

module.exports = "<button class=\"btn btn-default\" (click)=\"onDeleteFile(file)\">\n    <i class=\"fa fa-trash-o\" *ngIf=\"snEmpty\"></i>\n    <i class=\"fi fa fa-trash-o\" *ngIf=\"!snEmpty\"></i>\n    {{ text }}\n</button>\n"

/***/ }),

/***/ "./web/modern/components/jobs/common/btn-delete-file/btn-delete-file.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var BtnDeleteFile = function () {
    function BtnDeleteFile() {
        _classCallCheck(this, BtnDeleteFile);

        this.deleteFile = new core_1.EventEmitter();
    }

    _createClass(BtnDeleteFile, [{
        key: "onDeleteFile",
        value: function onDeleteFile(file) {
            this.deleteFile.emit(file);
        }
    }]);

    return BtnDeleteFile;
}();
__decorate([core_1.Input(), __metadata("design:type", File)], BtnDeleteFile.prototype, "file", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], BtnDeleteFile.prototype, "text", void 0);
__decorate([core_1.Input(), __metadata("design:type", Boolean)], BtnDeleteFile.prototype, "snEmpty", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], BtnDeleteFile.prototype, "deleteFile", void 0);
BtnDeleteFile = __decorate([core_1.Component({
    selector: 'btn-delete-file',
    template: __webpack_require__("./web/modern/components/jobs/common/btn-delete-file/btn-delete-file.html")
}), __metadata("design:paramtypes", [])], BtnDeleteFile);
exports.BtnDeleteFile = BtnDeleteFile;

/***/ }),

/***/ "./web/modern/components/jobs/common/delete-atachment-modal/delete-attachment-modal.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n    <button class=\"close\" data-dismiss=\"modal\" (click)=\"onDismiss()\" aria-hidden=\"true\">&times;</button>\n    <h3 class=\"modal-title\">Delete file</h3>\n</div>\n<div class=\"modal-body\">\n    <strong>Are you sure you want to delete this file?</strong>\n</div>\n<div class=\"modal-footer modal-foot delete-attachment-footer\">\n    <button type=\"button\" class=\"btn btn-md btn-danger\" (click)=\"deleteFile()\">Delete</button>\n    <button type=\"button\" class=\"btn btn-md btn-default\" (click)=\"onDismiss()\" data-dismiss=\"modal\">Cancel</button>\n</div>\n\n"

/***/ }),

/***/ "./web/modern/components/jobs/common/delete-atachment-modal/delete-attachment-modal.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var file_upload_data_service_1 = __webpack_require__("./shared/services/files/file-upload.data.service.ts");
var ng_bootstrap_1 = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/index.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var DeleteAttachmentModal = function () {
    function DeleteAttachmentModal(fileUploadService, messageService, activeModal) {
        _classCallCheck(this, DeleteAttachmentModal);

        this.fileUploadService = fileUploadService;
        this.messageService = messageService;
        this.activeModal = activeModal;
    }

    _createClass(DeleteAttachmentModal, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.fileUploadService.filesList = this.files;
        }
    }, {
        key: "deleteFile",
        value: function deleteFile() {
            var _this = this;

            this.fileUploadService.deleteFileFromServer(this.file, this.jobId).subscribe(function () {
                _this.messageService.showToaster('s_2', 'attachments');
                _this.activeModal.close();
            }, function (error) {
                var _error$error = error.error,
                    errorTitle = _error$error.errorTitle,
                    errorMessage = _error$error.errorMessage;

                _this.messageService.showErrorFromBackend(errorTitle, errorMessage);
                _this.activeModal.dismiss();
            });
        }
    }, {
        key: "onDismiss",
        value: function onDismiss() {
            this.activeModal.dismiss();
        }
    }]);

    return DeleteAttachmentModal;
}();
__decorate([core_1.Input(), __metadata("design:type", File)], DeleteAttachmentModal.prototype, "file", void 0);
__decorate([core_1.Input(), __metadata("design:type", Number)], DeleteAttachmentModal.prototype, "jobId", void 0);
__decorate([core_1.Input(), __metadata("design:type", Array)], DeleteAttachmentModal.prototype, "files", void 0);
DeleteAttachmentModal = __decorate([core_1.Component({
    selector: 'delete-attachment-modal',
    template: __webpack_require__("./web/modern/components/jobs/common/delete-atachment-modal/delete-attachment-modal.html")
}), __metadata("design:paramtypes", [file_upload_data_service_1.FileUploadDataProvider, message_service_1.MessageService, ng_bootstrap_1.NgbActiveModal])], DeleteAttachmentModal);
exports.DeleteAttachmentModal = DeleteAttachmentModal;

/***/ }),

/***/ "./web/modern/components/jobs/modals/delete-job-modal/delete-job-modal.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"deleteJobModal\" class=\"modal modal-center fade\" data-backdrop=\"static\" data-keyboard=\"false\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <close-btn></close-btn>\n                <h3 class=\"modal-title\">Delete job</h3>\n            </div>\n            <div class=\"modal-body\">\n                <strong>\n                    All quotes, invoices, contracts and questionnaires attached to this\n                    job will be removed from the system. Are you sure you would like to delete this job?\n                </strong>\n            </div>\n            <div class=\"modal-footer modal-foot\">\n                <button [disabled]=\"disableButtons\"\n                        class=\"btn btn-danger btn-lg spinning-wheel spinning-wheel__display-after\"\n                        (click)=\"deleteJob()\"\n                        [ngClass]=\"{'spinning-wheel__active' : disableButtons}\">Delete Job\n                </button>\n                <button [disabled]=\"disableButtons\" class=\"btn btn-default btn-lg\" data-dismiss=\"modal\">Cancel\n                </button>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "./web/modern/components/jobs/modals/delete-job-modal/delete-job-modal.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var jobs_data_service_1 = __webpack_require__("./shared/services/job/jobs.data.service.ts");
var DeleteJobModalComponent = function () {
    function DeleteJobModalComponent(messageService, jobsDataService) {
        _classCallCheck(this, DeleteJobModalComponent);

        this.messageService = messageService;
        this.jobsDataService = jobsDataService;
        this.updateParentTrigger = new core_1.EventEmitter();
        this.unsubscribe = new Subject_1.Subject();
        this.updateGraphsModel = function (tabs) {
            window.snCommunicationAdapter.callMethod('updateGraphsModel', tabs);
        };
    }

    _createClass(DeleteJobModalComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {}
    }, {
        key: "deleteJob",
        value: function deleteJob() {
            var _this = this;

            this.disableButtons = true;
            this.jobsDataService.deleteJob(this.jobIdForDelete).finally(function () {
                return _this.disableButtons = false;
            }).subscribe(function () {
                _this.messageService.showToaster('s_0', 'jobView');
                $('#deleteJobModal').modal('hide');
                _this.updateParentTrigger.emit(true);
                _this.updateGraphsModel(['shoots', 'payments']);
            }, function (error) {
                return _this.errorDeleteJob(error);
            });
        }
    }, {
        key: "errorDeleteJob",
        value: function errorDeleteJob(_ref) {
            var status = _ref.status,
                data = _ref.data;

            var errorMessage = data.errorMessage;
            var errorCode = void 0,
                errorPlace = void 0,
                value = void 0;
            if (status >= 400 && status < 500 && errorMessage) {
                if (errorMessage.includes('This payment cannot be marked as unpaid because it was overpaid in Xero.')) {
                    errorCode = 'e_12';
                    errorPlace = 'xero';
                    value = 'job';
                } else {
                    this.messageService.handleError({ error: data });
                    return;
                }
            } else {
                errorCode = 'e_0';
                errorPlace = 'general';
            }
            this.messageService.showToaster(errorCode, errorPlace, value);
        }
    }]);

    return DeleteJobModalComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Number)], DeleteJobModalComponent.prototype, "jobIdForDelete", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], DeleteJobModalComponent.prototype, "updateParentTrigger", void 0);
DeleteJobModalComponent = __decorate([core_1.Component({
    selector: 'delete-job-modal',
    template: __webpack_require__("./web/modern/components/jobs/modals/delete-job-modal/delete-job-modal.html")
}), __metadata("design:paramtypes", [message_service_1.MessageService, jobs_data_service_1.JobsDataServiceProvider])], DeleteJobModalComponent);
exports.DeleteJobModalComponent = DeleteJobModalComponent;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./web/modern/components/jobs/modals/download-log/download-log.html":
/***/ (function(module, exports) {

module.exports = "<button class=\"btn btn-default btn-lg\"\n        spinning-wheel [is-spinning-wheel-active]=\"isSpinnerActive\" [is-spinning-wheel-dark]=\"'true'\"\n        (click)=\"downloadLog()\">\n    <i class=\"fi fi-download-icon\"></i>Download Log\n</button>\n"

/***/ }),

/***/ "./web/modern/components/jobs/modals/download-log/download-log.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var file_download_data_service_1 = __webpack_require__("./shared/services/files/file-download-service/file-download.data.service.ts");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var DownloadLog = function () {
    function DownloadLog(fileDownloadDataService, messageService) {
        _classCallCheck(this, DownloadLog);

        this.fileDownloadDataService = fileDownloadDataService;
        this.messageService = messageService;
    }

    _createClass(DownloadLog, [{
        key: "downloadLog",
        value: function downloadLog() {
            var _this = this;

            this.isSpinnerActive = true;
            this.fileDownloadDataService.savePdfFile(this.contract.actions.DOWNLOAD_AUDIT_LOGS.url).then(function () {
                return _this.isSpinnerActive = false;
            }).catch(function (_ref) {
                var error = _ref.error;
                var errorTitle = error.errorTitle,
                    errorMessage = error.errorMessage;

                _this.messageService.showErrorFromBackend(errorTitle, errorMessage);
                _this.isSpinnerActive = false;
            });
        }
    }]);

    return DownloadLog;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], DownloadLog.prototype, "contract", void 0);
DownloadLog = __decorate([core_1.Component({
    selector: 'download-log',
    template: __webpack_require__("./web/modern/components/jobs/modals/download-log/download-log.html")
}), __metadata("design:paramtypes", [file_download_data_service_1.FileDownloadDataServiceProvider, message_service_1.MessageService])], DownloadLog);
exports.DownloadLog = DownloadLog;

/***/ }),

/***/ "./web/modern/components/jobs/modals/edit-contract-button/edit-contract-button.html":
/***/ (function(module, exports) {

module.exports = "<button class=\"btn btn-lg btn-default\" (click)=\"openEditSelectContract($event)\">\n    <i class=\"fi fi-edit\"></i>\n    Edit Contract\n</button>\n"

/***/ }),

/***/ "./web/modern/components/jobs/modals/edit-contract-button/edit-contract-button.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var edit_contract_modal_component_1 = __webpack_require__("./web/modern/components/contract/edit-contract-modal/edit-contract-modal.component.ts");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var contracts_data_service_1 = __webpack_require__("./shared/services/contract/contracts.data.service.ts");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var EditContractButton = function () {
    function EditContractButton(modalService, messageService, contractsServiceProvider) {
        _classCallCheck(this, EditContractButton);

        this.modalService = modalService;
        this.messageService = messageService;
        this.contractsServiceProvider = contractsServiceProvider;
        this.reInitContract = new core_1.EventEmitter();
        this.unsubscribe = new Subject_1.Subject();
    }

    _createClass(EditContractButton, [{
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "openEditSelectContract",
        value: function openEditSelectContract(event) {
            event.preventDefault();
            var editContractFromView = {
                name: this.contract.name,
                text: this.contract.text,
                optInConsent: this.contract.optInConsentStatement,
                showOptInConsent: this.contract.showOptInConsent
            };
            this.selectedModalRef = this.modalService.openModal(edit_contract_modal_component_1.EditContractModalComponent, {
                windowClass: 'ng-bootstrap-modal modal-visible'
            });
            this.selectedModalRef.componentInstance.isFixed = false;
            this.selectedModalRef.componentInstance.btnDisabled = false;
            this.selectedModalRef.componentInstance.contractToEdit = editContractFromView;
            this.selectedModalRef.componentInstance.action = 'EDIT_CONTRACT';
            this.subscribeToModalData();
        }
    }, {
        key: "subscribeToModalData",
        value: function subscribeToModalData() {
            var _this = this;

            this.selectedContractSubscription = this.modalService.getModalData().subscribe(function (data) {
                if (data) {
                    var action = data.action;

                    if (action === 'EDIT_CONTRACT') {
                        _this.editContract(data);
                    }
                    if (action === 'CLOSE_MODAL') {
                        _this.selectedContractSubscription.unsubscribe();
                        _this.selectedModalRef.dismiss();
                    }
                }
            });
        }
    }, {
        key: "editContract",
        value: function editContract(_ref) {
            var _this2 = this;

            var props = _ref.props;

            this.selectedModalRef.componentInstance.btnDisabled = true;
            this.contractsServiceProvider.editContract(this.contract.actions.EDIT_CONTRACT.url, props).pipe(operators_1.takeUntil(this.unsubscribe), operators_1.finalize(function () {
                return _this2.selectedModalRef.componentInstance.btnDisabled = false;
            })).subscribe(function () {
                _this2.reInitContract.emit(true);
                _this2.messageService.showToaster('s_2', 'contractTemplates', "" + props.name);
                _this2.selectedModalRef.close();
                _this2.selectedContractSubscription.unsubscribe();
            }, function (error) {
                _this2.messageService.handleError(error);
            });
        }
    }]);

    return EditContractButton;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], EditContractButton.prototype, "contract", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], EditContractButton.prototype, "reInitContract", void 0);
EditContractButton = __decorate([core_1.Component({
    selector: 'edit-contract-button',
    template: __webpack_require__("./web/modern/components/jobs/modals/edit-contract-button/edit-contract-button.html")
}), __metadata("design:paramtypes", [snModal_service_1.SNModalService, message_service_1.MessageService, contracts_data_service_1.ContractsDataProvider])], EditContractButton);
exports.EditContractButton = EditContractButton;

/***/ }),

/***/ "./web/modern/components/jobs/modals/export-jobs-modal/export-jobs-modal.html":
/***/ (function(module, exports) {

module.exports = "<button *ngIf=\"exportAvailable\" (click)=\"exportJobs(content)\" class=\"btn btn-export btn-lg mr-20 mb-10\">\n    <i class=\"fi fi-export\"></i>\n    <span>Export</span><span class=\"btn-hide-text\"> Jobs</span>\n</button>\n\n<ng-template #content let-modal>\n    <div class=\"modal-body\" style=\"padding: 30px!important;\">\n        <p class=\"text-center mb-0\">\n           {{ statusDescription }}\n        </p>\n        <br>\n        <p class=\"text-center mb-0\">You will receive an email notification with the download link once it's been completed.</p>\n        <div class=\"pt-25 text-center\">\n            <button type=\"button\" (click)=\"onDismiss()\" class=\"btn btn-lg btn-success mb-0 mr-10\">Got it</button>\n        </div>\n    </div>\n</ng-template>\n"

/***/ }),

/***/ "./web/modern/components/jobs/modals/export-jobs-modal/export-jobs-modal.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var jobs_data_service_1 = __webpack_require__("./shared/services/job/jobs.data.service.ts");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var rxjs_1 = __webpack_require__("./node_modules/rxjs/Rx.js");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var settings_1 = __webpack_require__("./shared/services/settings/settings.ts");
var ExportJobsModalComponent = function () {
    function ExportJobsModalComponent(jobsDataServiceProvider, modalService, messageService, settingsService) {
        _classCallCheck(this, ExportJobsModalComponent);

        this.jobsDataServiceProvider = jobsDataServiceProvider;
        this.modalService = modalService;
        this.messageService = messageService;
        this.settingsService = settingsService;
        this.unsubscribe = new rxjs_1.Subject();
    }

    _createClass(ExportJobsModalComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.getPaymentExportState();
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "exportJobs",
        value: function exportJobs(content) {
            var _this = this;

            this.jobsDataServiceProvider.getJobsExport().pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (data) {
                if (data.exportState === 'EXPORTING_HAS_BEEN_STARTED') {
                    _this.statusDescription = 'Preparing to start your export! This may take up to an hour.';
                    _this.openModal(content);
                } else if (data.exportState === 'EXPORTING_IN_PROGRESS') {
                    _this.statusDescription = "Exporting in progress (" + data.percentageComplete + "% complete)...";
                    _this.openModal(content);
                } else if (data.exportState === 'EXPORTING_IN_QUEUE') {
                    _this.statusDescription = "We're moving heaven and earth to make sure your export is next.";
                    _this.openModal(content);
                }
            }, function (error) {
                var _error$error = error.error,
                    errorTitle = _error$error.errorTitle,
                    errorMessage = _error$error.errorMessage;

                _this.messageService.showErrorFromBackend(errorTitle, errorMessage);
            });
        }
    }, {
        key: "openModal",
        value: function openModal(content) {
            this.exportJobsModalRef = this.modalService.openModal(content, {
                windowClass: 'ng-bootstrap-modal__small leads-jobs-width'
            });
        }
    }, {
        key: "getPaymentExportState",
        value: function getPaymentExportState() {
            var _this2 = this;

            this.settingsService.timeFormatSettings.pipe(operators_1.takeUntil(this.unsubscribe), operators_1.filter(function (data) {
                return !!data;
            }), operators_1.map(function (data) {
                return data.jobExportAvailable;
            })).subscribe(function (exportState) {
                return _this2.exportAvailable = exportState;
            });
        }
    }, {
        key: "onDismiss",
        value: function onDismiss() {
            this.exportJobsModalRef.close();
        }
    }]);

    return ExportJobsModalComponent;
}();
ExportJobsModalComponent = __decorate([core_1.Component({
    selector: 'export-jobs-modal',
    template: __webpack_require__("./web/modern/components/jobs/modals/export-jobs-modal/export-jobs-modal.html")
}), __metadata("design:paramtypes", [jobs_data_service_1.JobsDataServiceProvider, snModal_service_1.SNModalService, message_service_1.MessageService, settings_1.SettingsProvider])], ExportJobsModalComponent);
exports.ExportJobsModalComponent = ExportJobsModalComponent;

/***/ }),

/***/ "./web/modern/components/jobs/modals/save-contract-pdf/save-contract-pdf.html":
/***/ (function(module, exports) {

module.exports = "<button class=\"btn btn-default btn-lg\"\n        spinning-wheel [is-spinning-wheel-active]=\"isSpinnerActive\" [is-spinning-wheel-dark]=\"'true'\"\n        (click)=\"saveAsPdf()\">\n    <i class=\"fa fa-file-pdf-o\"></i>Save As PDF\n</button>\n"

/***/ }),

/***/ "./web/modern/components/jobs/modals/save-contract-pdf/save-contract-pdf.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var file_download_data_service_1 = __webpack_require__("./shared/services/files/file-download-service/file-download.data.service.ts");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var SaveContractPdf = function () {
    function SaveContractPdf(fileDownloadDataService, messageService) {
        _classCallCheck(this, SaveContractPdf);

        this.fileDownloadDataService = fileDownloadDataService;
        this.messageService = messageService;
    }

    _createClass(SaveContractPdf, [{
        key: "saveAsPdf",
        value: function saveAsPdf() {
            var _this = this;

            this.isSpinnerActive = true;
            this.fileDownloadDataService.savePdfFile(this.contract.actions.SAVE_AS_PDF.url).then(function () {
                return _this.isSpinnerActive = false;
            }).catch(function (_ref) {
                var error = _ref.error;
                var errorTitle = error.errorTitle,
                    errorMessage = error.errorMessage;

                _this.messageService.showErrorFromBackend(errorTitle, errorMessage);
                _this.isSpinnerActive = false;
            });
        }
    }]);

    return SaveContractPdf;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], SaveContractPdf.prototype, "contract", void 0);
SaveContractPdf = __decorate([core_1.Component({
    selector: 'save-contract-pdf',
    template: __webpack_require__("./web/modern/components/jobs/modals/save-contract-pdf/save-contract-pdf.html")
}), __metadata("design:paramtypes", [file_download_data_service_1.FileDownloadDataServiceProvider, message_service_1.MessageService])], SaveContractPdf);
exports.SaveContractPdf = SaveContractPdf;

/***/ }),

/***/ "./web/modern/components/jobs/sections/job-file-section/job-file-section.component.html":
/***/ (function(module, exports) {

module.exports = "<job-cell-header [icon]=\"'fi-job fi-folder'\" [isBorderBottom]=\"true\" [text]=\"'Files (up to 50MB)'\" [files]=\"files\">\n    <btn-add-file\n            [isActiveSpinner]=\"isActiveSpinner\"\n            [files]=\"files\"\n            [jobId]=\"jobId\"\n            (saveFiles)=\"saveFilesOnService($event)\"\n            *ngIf=\"files.length && !archived\"\n            [imageClass]=\"'header-section'\"\n    ></btn-add-file>\n</job-cell-header>\n\n<div class=\"section-data text-center section-data--empty\" *ngIf=\"!files.length\">\n    <h3 class=\"text-normal color-grey-dusty\">Never forget to attach the files again.</h3>\n\n    <btn-add-file\n            *ngIf=\"!files.length && !archived\"\n            [isActiveSpinner]=\"isActiveSpinner\"\n            [files]=\"files\"\n            [jobId]=\"jobId\"\n            (saveFiles)=\"saveFilesOnService($event)\"\n            [imageClass]=\"'btn btn-add-new-sm btn-success upload-section'\">\n    </btn-add-file>\n</div>\n\n<div class=\"flex-row section-data__wrapper\">\n    <div class=\"section-data section-data--full-lg-max files-section-modern\"\n         [ngClass]=\"{'flex-basis-full': files.length === 1}\"\n         *ngFor=\"let file of files\">\n        <div class=\"file-section-left-block\">\n            <a class=\"file-type {{file.convertedType}}\"></a>\n            <h4>{{ file.name }}</h4>\n            <p class=\"files-wrapper\">Uploaded on {{ file.cratedTs | timeFilter:'long' }}</p>\n            <p>{{ file.convertedSize }} MB</p>\n            <div class=\"file-label\" *ngIf=\"file?.attachmentMetadata?.linkedObjectName && file?.attachmentMetadata?.attachmentType\">\n                <span>\n                    {{ file?.attachmentMetadata?.linkedObjectName.toUpperCase() }}\n                </span>\n            </div>\n        </div>\n        <div class=\"file-section-right-block\">\n            <button class=\"btn btn-default\" (click)=\"saveAttachment(file.id, jobId)\">\n                <i class=\"fi fi-download\"></i>\n                Download\n            </button>\n            <btn-delete-file [text]=\"'Delete'\" [snEmpty]=\"files.length > 0\" [file]=\"file\" (deleteFile)=\"deleteFile(file)\"></btn-delete-file>\n        </div>\n    </div>\n</div>\n\n"

/***/ }),

/***/ "./web/modern/components/jobs/sections/job-file-section/job-file-section.component.scss":
/***/ (function(module, exports) {

module.exports = "btn-add-file {\n  margin-left: auto; }\n\n.file-label {\n  display: inline-block;\n  word-break: break-word;\n  border-radius: 0.25em;\n  background-color: #acacaf;\n  color: #fff;\n  padding: 0 5px;\n  font-weight: 600; }\n"

/***/ }),

/***/ "./web/modern/components/jobs/sections/job-file-section/job-file-section.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var rxjs_1 = __webpack_require__("./node_modules/rxjs/Rx.js");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var delete_attachment_modal_1 = __webpack_require__("./web/modern/components/jobs/common/delete-atachment-modal/delete-attachment-modal.ts");
var file_download_data_service_1 = __webpack_require__("./shared/services/files/file-download-service/file-download.data.service.ts");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var file_upload_data_service_1 = __webpack_require__("./shared/services/files/file-upload.data.service.ts");
var image_converter_service_1 = __webpack_require__("./shared/services/files/image-converter.service.ts");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var JobFileSectionComponent = function () {
    function JobFileSectionComponent(modalService, fileDownloadDataService, messageService, fileUploadService, imageConverter) {
        _classCallCheck(this, JobFileSectionComponent);

        this.modalService = modalService;
        this.fileDownloadDataService = fileDownloadDataService;
        this.messageService = messageService;
        this.fileUploadService = fileUploadService;
        this.imageConverter = imageConverter;
        this.updateFilesState = new core_1.EventEmitter();
        this.isActiveSpinner = false;
        this.unsubscribe = new rxjs_1.Subject();
    }

    _createClass(JobFileSectionComponent, [{
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "saveFilesOnService",
        value: function saveFilesOnService(_ref) {
            var _this = this;

            var item = _ref.item,
                jobId = _ref.jobId;

            this.isActiveSpinner = true;
            var maxMb = 50; // 50 Mb
            var maxSize = maxMb * 1000 * 1024;
            var totalFilesSize = this.getTotalSize(this.files);
            if (totalFilesSize + item.size > maxSize) {
                this.messageService.showToaster('e_1', 'attachments');
                this.isActiveSpinner = false;
                return;
            }
            this.fileUploadService.saveFileOnServer(item, jobId).pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (response) {
                response.convertedType = _this.imageConverter.getFileClass(response.name);
                _this.files.push(response);
                _this.messageService.showToaster('s_1', 'attachments');
                _this.updateFilesState.emit();
                _this.isActiveSpinner = false;
            }, function (_ref2) {
                var error = _ref2.error;
                var errorMessage = error.errorMessage,
                    errorTitle = error.errorTitle;

                _this.messageService.showErrorFromBackend(errorTitle, errorMessage);
                _this.isActiveSpinner = false;
            });
        }
    }, {
        key: "getTotalSize",
        value: function getTotalSize(files) {
            return files.reduce(function (prev, next) {
                return prev + next.bytesSize;
            }, 0);
        }
    }, {
        key: "saveAttachment",
        value: function saveAttachment(id, jobId) {
            var _this2 = this;

            this.fileDownloadDataService.saveFileFromJob(id, jobId).subscribe(function (response) {
                return _this2.fileDownloadDataService.saveToFileSystem(response);
            }, function (_ref3) {
                var error = _ref3.error;
                var errorMessage = error.errorMessage,
                    errorTitle = error.errorTitle;

                _this2.messageService.showErrorFromBackend(errorTitle, errorMessage);
            });
        }
    }, {
        key: "deleteFile",
        value: function deleteFile(file) {
            var _this3 = this;

            this.selectedPackageModalRef = this.modalService.openModal(delete_attachment_modal_1.DeleteAttachmentModal, { windowClass: 'ng-bootstrap-modal' });
            this.selectedPackageModalRef.componentInstance.file = file;
            this.selectedPackageModalRef.componentInstance.jobId = this.jobId;
            this.selectedPackageModalRef.componentInstance.files = this.files;
            this.selectedPackageModalRef.result.then(function () {
                _this3.updateFilesState.emit();
            }).catch(function () {});
        }
    }]);

    return JobFileSectionComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Array)], JobFileSectionComponent.prototype, "files", void 0);
__decorate([core_1.Input(), __metadata("design:type", Boolean)], JobFileSectionComponent.prototype, "archived", void 0);
__decorate([core_1.Input(), __metadata("design:type", Number)], JobFileSectionComponent.prototype, "jobId", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], JobFileSectionComponent.prototype, "updateFilesState", void 0);
JobFileSectionComponent = __decorate([core_1.Component({
    selector: 'job-file-section',
    template: __webpack_require__("./web/modern/components/jobs/sections/job-file-section/job-file-section.component.html"),
    styles: [__webpack_require__("./web/modern/components/jobs/sections/job-file-section/job-file-section.component.scss")]
}), __metadata("design:paramtypes", [snModal_service_1.SNModalService, file_download_data_service_1.FileDownloadDataServiceProvider, message_service_1.MessageService, file_upload_data_service_1.FileUploadDataProvider, image_converter_service_1.ImageConverterProvider])], JobFileSectionComponent);
exports.JobFileSectionComponent = JobFileSectionComponent;

/***/ }),

/***/ "./web/modern/components/leads/modals/delete-lead-modal/delete-lead-modal.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"deleteLeadModal\" class=\"modal modal-center fade\" data-backdrop=\"static\" data-keyboard=\"false\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <close-btn></close-btn>\n                <h3 class=\"modal-title\">Delete Lead</h3>\n            </div>\n            <div class=\"modal-body\">\n                <strong>\n                    Are you sure you would like to delete this lead?\n                </strong>\n            </div>\n            <div class=\"modal-footer modal-foot\">\n                <button [disabled]=\"disableButtons\"\n                        class=\"btn btn-danger btn-lg spinning-wheel spinning-wheel__display-after\"\n                        (click)=\"deleteLead()\"\n                        [ngClass]=\"{'spinning-wheel__active' : disableButtons}\">Delete Lead\n                </button>\n                <button [disabled]=\"disableButtons\" class=\"btn btn-default btn-lg\" data-dismiss=\"modal\">Cancel\n                </button>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),

/***/ "./web/modern/components/leads/modals/delete-lead-modal/delete-lead-modal.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var leads_data_service_1 = __webpack_require__("./shared/services/lead/leads.data.service.ts");
var DeleteLeadModalComponent = function () {
    function DeleteLeadModalComponent(messageService, leadDataService) {
        _classCallCheck(this, DeleteLeadModalComponent);

        this.messageService = messageService;
        this.leadDataService = leadDataService;
        this.updateParentTrigger = new core_1.EventEmitter();
        this.unsubscribe = new Subject_1.Subject();
        this.updateGraphsModel = function (tabs) {
            window.snCommunicationAdapter.callMethod('updateGraphsModel', tabs);
        };
    }

    _createClass(DeleteLeadModalComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {}
    }, {
        key: "deleteLead",
        value: function deleteLead() {
            var _this = this;

            this.disableButtons = true;
            this.leadDataService.deleteLead(this.leadForDelete).finally(function () {
                return _this.disableButtons = false;
            }).subscribe(function () {
                _this.messageService.showToaster('s_2', 'lead');
                $('#deleteLeadModal').modal('hide');
                _this.updateParentTrigger.emit(true);
                _this.updateGraphsModel(['leads', 'shoots', 'payments']);
            }, function (error) {
                return _this.errorDeleteLead(error);
            });
        }
    }, {
        key: "errorDeleteLead",
        value: function errorDeleteLead(_ref) {
            var status = _ref.status,
                data = _ref.data;

            var errorMessage = data.errorMessage;
            var errorCode = void 0,
                errorPlace = void 0,
                value = void 0;
            if (status >= 400 && status < 500 && errorMessage) {
                if (errorMessage.includes('This payment cannot be marked as unpaid because it was overpaid in Xero.')) {
                    errorCode = 'e_12';
                    errorPlace = 'xero';
                    value = 'job';
                } else {
                    errorCode = 'e_2';
                    errorPlace = 'general';
                    value = errorMessage;
                }
            } else {
                errorCode = 'e_0';
                errorPlace = 'general';
            }
            this.messageService.showToaster(errorCode, errorPlace, value);
        }
    }]);

    return DeleteLeadModalComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Number)], DeleteLeadModalComponent.prototype, "leadForDelete", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], DeleteLeadModalComponent.prototype, "updateParentTrigger", void 0);
DeleteLeadModalComponent = __decorate([core_1.Component({
    selector: 'delete-lead-modal',
    template: __webpack_require__("./web/modern/components/leads/modals/delete-lead-modal/delete-lead-modal.html")
}), __metadata("design:paramtypes", [message_service_1.MessageService, leads_data_service_1.LeadsDataServiceProvider])], DeleteLeadModalComponent);
exports.DeleteLeadModalComponent = DeleteLeadModalComponent;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./web/modern/components/leads/modals/export-leads-modal/export-leads-modal.html":
/***/ (function(module, exports) {

module.exports = "<button *ngIf=\"exportAvailable\" (click)=\"exportLeads(content)\" class=\"btn btn-export btn-lg mr-20 mb-10\">\n    <i class=\"fi fi-export\"></i>\n    <span>Export</span><span class=\"btn-hide-text\"> Leads</span>\n</button>\n\n<ng-template #content let-modal>\n    <div class=\"modal-body\" style=\"padding: 30px!important;\">\n        <p class=\"text-center mb-0\">\n            {{ statusDescription }}\n        </p>\n        <br>\n        <p class=\"text-center mb-0\">You will receive an email notification with the download link once it's been completed.</p>\n        <div class=\"pt-25 text-center\">\n            <button type=\"button\" (click)=\"onDismiss()\" class=\"btn btn-lg btn-success mb-0 mr-10\">Got it</button>\n        </div>\n    </div>\n</ng-template>\n"

/***/ }),

/***/ "./web/modern/components/leads/modals/export-leads-modal/export-leads-modal.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var rxjs_1 = __webpack_require__("./node_modules/rxjs/Rx.js");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var leads_data_service_1 = __webpack_require__("./shared/services/lead/leads.data.service.ts");
var settings_1 = __webpack_require__("./shared/services/settings/settings.ts");
var ExportLeadsModalComponent = function () {
    function ExportLeadsModalComponent(leadsDataServiceProvider, modalService, messageService, settingsService) {
        _classCallCheck(this, ExportLeadsModalComponent);

        this.leadsDataServiceProvider = leadsDataServiceProvider;
        this.modalService = modalService;
        this.messageService = messageService;
        this.settingsService = settingsService;
        this.unsubscribe = new rxjs_1.Subject();
    }

    _createClass(ExportLeadsModalComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.getPaymentExportState();
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "exportLeads",
        value: function exportLeads(content) {
            var _this = this;

            this.leadsDataServiceProvider.getLeadsExport().pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (data) {
                if (data.exportState === 'EXPORTING_HAS_BEEN_STARTED') {
                    _this.statusDescription = 'Preparing to start your export! This may take up to an hour.';
                    _this.openModal(content);
                } else if (data.exportState === 'EXPORTING_IN_PROGRESS') {
                    _this.statusDescription = "Exporting in progress (" + data.percentageComplete + "% complete)...";
                    _this.openModal(content);
                } else if (data.exportState === 'EXPORTING_IN_QUEUE') {
                    _this.statusDescription = "We're moving heaven and earth to make sure your export is next.";
                    _this.openModal(content);
                }
            }, function (error) {
                var _error$error = error.error,
                    errorTitle = _error$error.errorTitle,
                    errorMessage = _error$error.errorMessage;

                _this.messageService.showErrorFromBackend(errorTitle, errorMessage);
            });
        }
    }, {
        key: "openModal",
        value: function openModal(content) {
            this.exportLeadsModalRef = this.modalService.openModal(content, {
                windowClass: 'ng-bootstrap-modal__small leads-jobs-width'
            });
        }
    }, {
        key: "getPaymentExportState",
        value: function getPaymentExportState() {
            var _this2 = this;

            this.settingsService.timeFormatSettings.pipe(operators_1.takeUntil(this.unsubscribe), operators_1.filter(function (data) {
                return !!data;
            }), operators_1.map(function (data) {
                return data.leadExportAvailable;
            })).subscribe(function (exportState) {
                return _this2.exportAvailable = exportState;
            });
        }
    }, {
        key: "onDismiss",
        value: function onDismiss() {
            this.exportLeadsModalRef.close();
        }
    }]);

    return ExportLeadsModalComponent;
}();
ExportLeadsModalComponent = __decorate([core_1.Component({
    selector: 'export-leads-modal',
    template: __webpack_require__("./web/modern/components/leads/modals/export-leads-modal/export-leads-modal.html")
}), __metadata("design:paramtypes", [leads_data_service_1.LeadsDataServiceProvider, snModal_service_1.SNModalService, message_service_1.MessageService, settings_1.SettingsProvider])], ExportLeadsModalComponent);
exports.ExportLeadsModalComponent = ExportLeadsModalComponent;

/***/ }),

/***/ "./web/modern/components/login/signup-check-email/signup-check-email.component.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"check-email-main-block\">\n    <div class=\"col-xs-12 mb-0\"></div>\n\n    <div class=\"col-xs-12 col-sm-8 check-email-container\">\n        <div class=\"ninja-logo-wrapper\"> <img class=\"ninja-logo\" src=\"https://app.studioninja.co/build/release-pipeline-119/resources/dist/assets/images/logo/ninja-circle-logo.svg\"> </div>\n        <div>\n            <h2 *ngIf=\"firstName\" class=\"title-modal\">Padawan {{ firstName }}, we're almost there!</h2>\n            <h2 *ngIf=\"!firstName\" class=\"title-modal\">We're almost there!</h2>\n\n            <div class=\"text-block\">\n            <p class=\"p-text mb-25\">\n                Please check your email and click on the confirmation link to\n                complete your sign up. Check your spam folder as well if you\n                can't find it in your inbox.\n            </p>\n\n            <p class=\"p-text mb-35\">\n                Once your account is activated, we'll send you a series of\n                emails to help you get started with Studio Ninja.\n            </p>\n            </div>\n            <div *ngIf=\"textHtml || titleHtml\" class=\"subscribe-info\">\n                <img class=\"star-img\" src=\"https://app.studioninja.co/build/release-pipeline-119/resources/dist/assets/images/icons/statuses/star.svg\">\n                <div class=\"text-block\">\n                <div class=\"title\"[innerHTML]=\"titleHtml\"></div>\n                <div class=\"description\" [innerHTML]=\"textHtml\"></div>\n                </div>\n            </div>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "./web/modern/components/login/signup-check-email/signup-check-email.component.scss":
/***/ (function(module, exports) {

module.exports = ".bg-white {\n  background-color: white; }\n\n.bg-gallery {\n  background-color: #ececec; }\n\n.bg-java {\n  background-color: #22baa1; }\n\n.bg-sky {\n  background-color: #00bff3; }\n\n.bg-fundy-blue {\n  background-color: #3f4d68; }\n\n.bg-light-blue {\n  background-color: #f1f4f9; }\n\n.bg-green {\n  background-color: #009f26; }\n\n.bg-orange {\n  background-color: #f7941d; }\n\n.bg-froly-dark {\n  background-color: #f25656; }\n\n.bg-gallery-dark {\n  background-color: #e1e1e1; }\n\n.bg-violet-light {\n  background-color: #f0e9f2 !important; }\n\n.bg-stone {\n  background-color: #acacac; }\n\n.bg-concrete {\n  background-color: #f3f3f3; }\n\n.bg-concrete-light {\n  background-color: #f9f9f9; }\n\n.bg-info-blue {\n  background-color: #74cae7; }\n\n.bg-cancel-blue {\n  background-color: #2b5969; }\n\n.bg-galleries-label {\n  background-color: #455a64; }\n\n.LEAD {\n  background: #f27987 !important; }\n\n.PRODUCTION {\n  background: #f7941d !important; }\n\n.POST_PRODUCTION {\n  background: #1bb1cc !important; }\n\n.color-white {\n  color: white; }\n\n.color-blue {\n  color: #1bb1cc; }\n\n.color-java {\n  color: #22baa1 !important; }\n\n.color-lime {\n  color: #7ab800 !important; }\n\n.color-grey {\n  color: #8e8e98 !important; }\n\n.color-grey-dusty {\n  color: #949494; }\n\n.color-grey-light {\n  color: #aeaeae; }\n\n.color-dark {\n  color: #45464c !important; }\n\n.color-froly {\n  color: #f27987 !important; }\n\n.color-froly-dark {\n  color: #f25656 !important; }\n\n.color-light {\n  color: #8e9099; }\n\n.color-discount {\n  color: #f89e4b !important; }\n\n.color-cc {\n  color: #009688 !important; }\n\n.border-stone {\n  border-color: #acacac; }\n\n.border-alto {\n  border-color: #dddddd; }\n\n.border-alto-light {\n  border-color: #d7d7d7; }\n\n.border-violet {\n  border-color: #dfcfe6 !important; }\n\n.check-email-main-block {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-wrap: wrap;\n      -ms-flex-wrap: wrap;\n          flex-wrap: wrap;\n  -webkit-box-align: start;\n  -webkit-align-items: flex-start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  position: fixed;\n  text-align: center;\n  padding-top: 65px;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 0;\n  overflow: auto;\n  -webkit-transition: background-color 0.2s ease-out;\n  transition: background-color 0.2s ease-out; }\n  .check-email-main-block .check-email-container {\n    box-shadow: 0 2px 1px rgba(0, 0, 0, 0.25);\n    border-radius: 8px;\n    padding: 40px 35px 30px;\n    max-width: 540px;\n    background-color: #fff;\n    margin-left: 10px;\n    margin-right: 10px;\n    margin-bottom: 10px; }\n    .check-email-main-block .check-email-container .ninja-logo-wrapper {\n      height: 100px;\n      width: 100px; }\n      .check-email-main-block .check-email-container .ninja-logo-wrapper .ninja-logo {\n        position: absolute;\n        left: -webkit-calc(50% - 50px);\n        left: calc(50% - 50px);\n        top: 0; }\n    .check-email-main-block .check-email-container .text-block {\n      width: 100%;\n      padding: 0 10px; }\n      .check-email-main-block .check-email-container .text-block .p-text {\n        font-size: 14px;\n        line-height: 25px;\n        color: #43444c;\n        font-weight: 400; }\n    .check-email-main-block .check-email-container .title-modal {\n      margin: 25px 20px;\n      color: #22baa0;\n      font-size: 24px; }\n    .check-email-main-block .check-email-container .subscribe-info {\n      min-height: 90px;\n      width: 100%;\n      background: #00897b;\n      border-radius: 8px;\n      padding: 18px 20px;\n      font-size: 14px;\n      position: relative; }\n      .check-email-main-block .check-email-container .subscribe-info .star-img {\n        position: absolute;\n        left: 0;\n        top: 0; }\n      .check-email-main-block .check-email-container .subscribe-info .title {\n        color: #ffdb54;\n        padding: 0 15px; }\n      .check-email-main-block .check-email-container .subscribe-info .description {\n        padding-top: 8px;\n        color: white; }\n"

/***/ }),

/***/ "./web/modern/components/login/signup-check-email/signup-check-email.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var SignupCheckEmailComponent = function SignupCheckEmailComponent() {
    _classCallCheck(this, SignupCheckEmailComponent);
};
__decorate([core_1.Input(), __metadata("design:type", String)], SignupCheckEmailComponent.prototype, "firstName", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], SignupCheckEmailComponent.prototype, "textHtml", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], SignupCheckEmailComponent.prototype, "titleHtml", void 0);
SignupCheckEmailComponent = __decorate([core_1.Component({
    selector: 'signup-check-email',
    template: __webpack_require__("./web/modern/components/login/signup-check-email/signup-check-email.component.html"),
    styles: [__webpack_require__("./web/modern/components/login/signup-check-email/signup-check-email.component.scss")]
}), __metadata("design:paramtypes", [])], SignupCheckEmailComponent);
exports.SignupCheckEmailComponent = SignupCheckEmailComponent;

/***/ }),

/***/ "./web/modern/components/modernComponents.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var send_btn_1 = __webpack_require__("./web/modern/components/buttons/send-btn/send-btn.ts");
var edit_btn_1 = __webpack_require__("./web/modern/components/buttons/edit-btn/edit-btn.ts");
var settings_btn_1 = __webpack_require__("./web/modern/components/buttons/settings-btn/settings-btn.ts");
var sn_warning_1 = __webpack_require__("./shared/components/common/sn-warning/sn-warning.ts");
var delete_btn_1 = __webpack_require__("./web/modern/components/buttons/delete-btn/delete-btn.ts");
var client_card_1 = __webpack_require__("./web/modern/components/client/client-card/client-card.ts");
var enable_clients_opt_in_1 = __webpack_require__("./web/modern/components/client/enable-clients-opt-in/enable-clients-opt-in.ts");
var job_client_1 = __webpack_require__("./web/modern/components/client/job-client/job-client.ts");
var save_optin_consent_modal_1 = __webpack_require__("./shared/components/base/client/modals/save-optin-consent-modal/save-optin-consent-modal.ts");
var invoice_update_dnd_1 = __webpack_require__("./web/modern/components/invoices/invoice-update/invoice-update-dnd/invoice-update-dnd.ts");
var quote_client_info_1 = __webpack_require__("./web/modern/components/quotes/common/quote-client-info/quote-client-info.ts");
var quote_create_package_block_1 = __webpack_require__("./web/modern/components/quotes/common/quote-create-package-block/quote-create-package-block.ts");
var quote_job_info_1 = __webpack_require__("./web/modern/components/quotes/common/quote-job-info/quote-job-info.ts");
var quote_update_1 = __webpack_require__("./web/modern/components/quotes/quote-update/quote-update.ts");
var payment_schedule_1 = __webpack_require__("./web/modern/components/quotes/common/payment-schedule/payment-schedule.ts");
var quote_summary_block_1 = __webpack_require__("./web/modern/components/quotes/common/quote-summary-block/quote-summary-block.ts");
var enable_gdpr_section_1 = __webpack_require__("./web/modern/components/settings/gdpr/enable-gdpr-section/enable-gdpr-section.ts");
var contract_signature_1 = __webpack_require__("./web/modern/components/contract/contract-signature/contract-signature.ts");
var close_btn_1 = __webpack_require__("./shared/components/common/buttons/close-btn/close-btn.ts");
var sn_label_1 = __webpack_require__("./shared/components/common/sn-label/sn-label.ts");
var opt_in_agreement_1 = __webpack_require__("./shared/components/common/opt-in-agreement/opt-in-agreement.ts");
var subscribe_client_btn_1 = __webpack_require__("./web/modern/components/buttons/subscribe-client-btn/subscribe-client-btn.ts");
var client_photo_1 = __webpack_require__("./web/modern/components/client/client-photo/client-photo.ts");
var client_subscribe_info_1 = __webpack_require__("./web/modern/components/client/client-subscribe-info/client-subscribe-info.ts");
var resubscribe_client_modal_1 = __webpack_require__("./web/modern/components/client/modals/resubscribe-client-modal/resubscribe-client-modal.ts");
var upload_photo_modal_1 = __webpack_require__("./web/modern/components/client/modals/upload-photo-modal/upload-photo-modal.ts");
var questionnaire_submitted_statement_1 = __webpack_require__("./shared/components/common/questionnaire-submitted-statement/questionnaire-submitted-statement.ts");
var terms_updated_modal_1 = __webpack_require__("./web/modern/components/common/terms-updated-modal/terms-updated-modal.ts");
var workflow_exit_modal_1 = __webpack_require__("./web/modern/components/settings/workflow-exit-modal/workflow-exit-modal.ts");
var warning_sign_img_1 = __webpack_require__("./shared/components/common/warning-sign-img/warning-sign-img.ts");
var searchbar_1 = __webpack_require__("./web/modern/components/common/searchbar/searchbar.ts");
var sn_pagination_1 = __webpack_require__("./web/modern/components/common/sn-pagination/sn-pagination.ts");
var consent_list_1 = __webpack_require__("./web/modern/components/client/consent-list/consent-list.ts");
var cancel_btn_1 = __webpack_require__("./mobile/src/components/buttons/cancel-btn/cancel-btn.ts");
var error_message_modal_1 = __webpack_require__("./web/modern/components/common/error-message-modal/error-message-modal.ts");
var autocompete_email_input_1 = __webpack_require__("./web/modern/components/inputs/autocomplete-email-input/autocompete-email-input.ts");
var attachments_1 = __webpack_require__("./mobile/src/components/files/attachments/attachments.ts");
var event_type_row_1 = __webpack_require__("./web/modern/components/common/event-type-row/event-type-row.ts");
var add_round_btn_1 = __webpack_require__("./web/modern/components/buttons/add-round-btn/add-round-btn.ts");
var simple_pagination_1 = __webpack_require__("./web/modern/components/buttons/simple-pagination/simple-pagination.ts");
var shoots_appointments_block_1 = __webpack_require__("./web/modern/components/dashboard/shoots-appointments-block/shoots-appointments-block.ts");
var recent_leads_block_1 = __webpack_require__("./web/modern/components/dashboard/recent-leads-block/recent-leads-block.ts");
var delete_lead_modal_1 = __webpack_require__("./web/modern/components/leads/modals/delete-lead-modal/delete-lead-modal.ts");
var user_menu_1 = __webpack_require__("./web/modern/components/navbar/user-navbar/user-menu/user-menu.ts");
var drag_and_drop_block_1 = __webpack_require__("./web/modern/components/dashboard/drag-and-drop-block/drag-and-drop-block.ts");
var graphs_block_1 = __webpack_require__("./web/modern/components/dashboard/graphs-block/graphs-block.ts");
var upcoming_payments_block_1 = __webpack_require__("./web/modern/components/dashboard/upcoming-payments-block/upcoming-payments-block.ts");
var record_payment_modal_1 = __webpack_require__("./web/modern/components/payments/modals/record-payment-modal/record-payment-modal.ts");
var write_off_modal_1 = __webpack_require__("./web/modern/components/payments/modals/write-off-modal/write-off-modal.ts");
var job_task_block_1 = __webpack_require__("./web/modern/components/dashboard/job-task-block/job-task-block.ts");
var delete_job_modal_1 = __webpack_require__("./web/modern/components/jobs/modals/delete-job-modal/delete-job-modal.ts");
var sn_date_range_picker_component_1 = __webpack_require__("./web/modern/components/common/sn-date-range-picker/sn-date-range-picker.component.ts");
var upload_component_1 = __webpack_require__("./web/modern/components/common/upload-component/upload-component.ts");
var proselect_upload_component_1 = __webpack_require__("./web/modern/components/common/proselect-upload-component/proselect-upload-component.ts");
var sn_date_picker_component_1 = __webpack_require__("./web/modern/components/common/sn-date-picker/sn-date-picker.component.ts");
var package_info_panel_component_1 = __webpack_require__("./web/modern/components/quotes/package-info-panel/package-info-panel.component.ts");
var price_tag_component_1 = __webpack_require__("./web/modern/components/price-tag/price-tag.component.ts");
var main_shoot_date_1 = __webpack_require__("./shared/components/common/main-shoot-date/main-shoot-date.ts");
var quote_view_1 = __webpack_require__("./web/modern/components/quote/quote-view/quote-view.ts");
var print_btn_1 = __webpack_require__("./web/modern/components/buttons/print-btn/print-btn.ts");
var modal_delete_quote_1 = __webpack_require__("./web/modern/components/quote/modals/modal-delete-quote/modal-delete-quote.ts");
var quote_info_1 = __webpack_require__("./web/modern/components/quote/common/quote-info/quote-info.ts");
var quote_from_info_1 = __webpack_require__("./web/modern/components/quote/common/quote-from-info/quote-from-info.ts");
var modal_send_quote_1 = __webpack_require__("./web/modern/components/quote/modals/modal-send-quote/modal-send-quote.ts");
var product_packages_block_component_1 = __webpack_require__("./web/modern/components/packages-product/packages-product-block/product-packages-block.component.ts");
var packages_block_component_1 = __webpack_require__("./web/modern/components/packages-product/packages-block/packages-block.component.ts");
var product_block_component_1 = __webpack_require__("./web/modern/components/packages-product/product-block/product-block.component.ts");
var update_package_product_modal_component_1 = __webpack_require__("./web/modern/components/packages-product/modals/update-package-product-modal/update-package-product-modal.component.ts");
var addons_table_component_1 = __webpack_require__("./web/modern/components/quotes/addons-table/addons-table.component.ts");
var product_details_modal_component_1 = __webpack_require__("./web/modern/components/quotes/modals/product-details-modal/product-details-modal.component.ts");
var add_new_element_btn_component_1 = __webpack_require__("./web/modern/components/buttons/add-new-element-btn/add-new-element-btn.component.ts");
var add_quote_type_modal_component_1 = __webpack_require__("./web/modern/components/quotes/modals/add-quote-type-modal/add-quote-type-modal.component.ts");
var quote_view_fixed_1 = __webpack_require__("./web/modern/components/quote/quote-view-fixed/quote-view-fixed.ts");
var product_package_table_1 = __webpack_require__("./web/modern/components/quotes/product-package-table/product-package-table.ts");
var quote_assignment_panel_component_1 = __webpack_require__("./web/modern/components/quote/quote-assignment-panel/quote-assignment-panel.component.ts");
var invoice_view_1 = __webpack_require__("./web/modern/components/invoices/invoice-view/invoice-view.ts");
var invoice_info_table_1 = __webpack_require__("./web/modern/components/invoices/invoice-view/invoice-info-table/invoice-info-table.ts");
var invoice_payments_schedule_table_1 = __webpack_require__("./web/modern/components/invoices/invoice-view/invoice-payments-schedule-table/invoice-payments-schedule-table.ts");
var modal_make_invoice_1 = __webpack_require__("./web/modern/components/quote/modals/modal-make-invoice/modal-make-invoice.ts");
var show_more_content_component_1 = __webpack_require__("./web/modern/components/common/show-more-content/show-more-content.component.ts");
var discount_create_block_component_1 = __webpack_require__("./web/modern/components/quotes/common/discount-create-block/discount-create-block.component.ts");
var discount_view_block_component_1 = __webpack_require__("./web/modern/components/quotes/common/discount-view-block/discount-view-block.component.ts");
var mark_quote_as_accepted_modal_1 = __webpack_require__("./web/modern/components/quote/modals/mark-quote-as-accepted/mark-quote-as-accepted.modal.ts");
var preview_btn_1 = __webpack_require__("./web/modern/components/buttons/preview-btn/preview-btn.ts");
var copy_to_xero_btn_1 = __webpack_require__("./web/modern/components/buttons/copy-to-xero-btn/copy-to-xero-btn.ts");
var copy_to_qb_btn_1 = __webpack_require__("./web/modern/components/buttons/copy-to-qb-btn/copy-to-qb-btn.ts");
var delete_invoice_modal_1 = __webpack_require__("./web/modern/components/invoices/modals/delete-invoice-modal/delete-invoice-modal.ts");
var invoice_payment_action_buttons_1 = __webpack_require__("./web/modern/components/invoices/invoice-view/invoice-payments-action-buttons/invoice-payment-action-buttons.ts");
var save_pdf_btn_1 = __webpack_require__("./web/modern/components/buttons/save-pdf-btn/save-pdf-btn.ts");
var invoice_client_info_1 = __webpack_require__("./web/modern/components/invoices/invoice-update/invoice-client-info/invoice-client-info.ts");
var invoice_contract_question_1 = __webpack_require__("./web/modern/components/invoices/invoice-update/invoice-contract-question/invoice-contract-question.ts");
var invoice_job_info_1 = __webpack_require__("./web/modern/components/invoices/invoice-update/invoice-job-info/invoice-job-info.ts");
var invoice_main_info_1 = __webpack_require__("./web/modern/components/invoices/invoice-update/invoice-main-info/invoice-main-info.ts");
var invoice_payment_schedule_1 = __webpack_require__("./web/modern/components/invoices/invoice-update/invoice-payment-schedule/invoice-payment-schedule.ts");
var invoice_summary_1 = __webpack_require__("./web/modern/components/invoices/invoice-update/invoice-summary/invoice-summary.ts");
var invoice_update_1 = __webpack_require__("./web/modern/components/invoices/invoice-update/invoice-update.ts");
var gallery_view_block_component_1 = __webpack_require__("./web/modern/components/integrations/connect-galleries/gallery-view-block/gallery-view-block.component.ts");
var delete_gallery_modal_1 = __webpack_require__("./web/modern/components/integrations/connect-galleries/modals/delete-gallery-modal/delete-gallery.modal.ts");
var add_gallery_modal_1 = __webpack_require__("./web/modern/components/integrations/connect-galleries/modals/add-gallery-modal/add-gallery.modal.ts");
var create_new_gallery_modal_1 = __webpack_require__("./web/modern/components/integrations/connect-galleries/modals/create-new-gallery-modal/create-new-gallery.modal.ts");
var select_existing_gallery_modal_1 = __webpack_require__("./web/modern/components/integrations/connect-galleries/modals/select-existing-gallery-modal/select-existing-gallery.modal.ts");
var delete_confirmation_modal_1 = __webpack_require__("./web/modern/components/integrations/connect-galleries/modals/delete-confirmation-modal/delete-confirmation.modal.ts");
var subscription_card_1 = __webpack_require__("./web/modern/components/subscription/modals/subscription-modal/subscription-card/subscription-card.ts");
var subscription_modal_1 = __webpack_require__("./web/modern/components/subscription/modals/subscription-modal/subscription-modal.ts");
var invoices_view_block_component_1 = __webpack_require__("./web/modern/components/invoices/invoices-view-block/invoices-view-block.component.ts");
var shootproof_invoices_block_component_1 = __webpack_require__("./web/modern/components/invoices/shootproof-invoices-block/shootproof-invoices-block.component.ts");
var payments_overview_component_1 = __webpack_require__("./web/modern/components/payments/payments-overview/payments-overview.component.ts");
var copy_invoice_to_quickBooks_modal_1 = __webpack_require__("./web/modern/components/invoices/modals/copy-invoice-to-quickBooks/copy-invoice-to-quickBooks.modal.ts");
var profile_1 = __webpack_require__("./web/modern/components/settings/profile/profile.ts");
var account_details_1 = __webpack_require__("./web/modern/components/settings/profile/account-details/account-details.ts");
var login_change_1 = __webpack_require__("./web/modern/components/settings/profile/login-change/login-change.ts");
var password_change_1 = __webpack_require__("./web/modern/components/settings/profile/password-change/password-change.ts");
var subscription_change_1 = __webpack_require__("./web/modern/components/settings/profile/subscription-change/subscription-change.ts");
var subscription_period_change_1 = __webpack_require__("./web/modern/components/subscription/modals/subscription-modal/subscription-period-change/subscription-period-change.ts");
var iframe_component_1 = __webpack_require__("./web/modern/components/common/iframe/iframe.component.ts");
var cancel_subscription_confirm_modal_1 = __webpack_require__("./web/modern/components/settings/profile/subscription-change/modals/cancel-subscription-confirm/cancel-subscription-confirm-modal.ts");
var btn_subscription_1 = __webpack_require__("./web/modern/components/buttons/btn-subscription/btn-subscription.ts");
var sn_quill_editor_web_1 = __webpack_require__("./web/modern/components/common/sn-quill-editor/sn-quill-editor-web.ts");
var sn_quill_link_modal_1 = __webpack_require__("./web/modern/components/common/sn-quill-editor/modals/sn-quill-link-modal/sn-quill-link-modal.ts");
var attachments_component_1 = __webpack_require__("./web/modern/components/common/sn-quill-editor/attachments/attachments.component.ts");
var sn_quill_attachment_modal_1 = __webpack_require__("./web/modern/components/common/sn-quill-editor/modals/sn-quill-attachment-modal/sn-quill-attachment.modal.ts");
var contact_form_section_1 = __webpack_require__("./web/modern/components/settings/contact-form-section/contact-form-section.ts");
var template_list_1 = __webpack_require__("./web/modern/components/settings/common/template-list/template-list.ts");
var setting_section_header_1 = __webpack_require__("./web/modern/components/settings/common/setting-section-header/setting-section-header.ts");
var setting_section_description_1 = __webpack_require__("./web/modern/components/settings/common/setting-section-description/setting-section-description.ts");
var settings_add_btn_1 = __webpack_require__("./web/modern/components/buttons/settings-add-btn/settings-add-btn.ts");
var delete_item_modal_1 = __webpack_require__("./web/modern/components/settings/common/delete-item-modal/delete-item-modal.ts");
var subscription_announcement_banner_1 = __webpack_require__("./web/modern/components/subscription/subscription-announcement-banner/subscription-announcement-banner.ts");
var subscription_choose_plan_1 = __webpack_require__("./web/modern/components/subscription/subscription-choose-plan/subscription-choose-plan.ts");
var discount_block_component_1 = __webpack_require__("./web/modern/components/packages-product/discount-block/discount-block.component.ts");
var update_discount_modal_component_1 = __webpack_require__("./web/modern/components/packages-product/modals/update-discount-modal/update-discount-modal.component.ts");
var edit_contract_modal_component_1 = __webpack_require__("./web/modern/components/contract/edit-contract-modal/edit-contract-modal.component.ts");
var email_reply_modal_component_1 = __webpack_require__("./web/modern/components/settings/email-settings-section/modals/email-reply-modal/email-reply-modal.component.ts");
var companies_section_component_1 = __webpack_require__("./web/modern/components/settings/companies-section/companies-section.component.ts");
var settings_overview_component_1 = __webpack_require__("./web/modern/components/settings/settings-overview/settings-overview.component.ts");
var settings_item_component_1 = __webpack_require__("./web/modern/components/settings/settings-overview/settings-item/settings-item.component.ts");
var settings_navigation_component_1 = __webpack_require__("./web/modern/components/settings/settings-overview/settings-navigation/settings-navigation.component.ts");
var user_navbar_component_1 = __webpack_require__("./web/modern/components/navbar/user-navbar/user-navbar.component.ts");
var brand_create_modal_1 = __webpack_require__("./web/modern/components/brands/modals/brand-create-modal/brand-create-modal.ts");
var import_data_modal_1 = __webpack_require__("./web/modern/components/brands/modals/import-data-modal/import-data-modal.ts");
var reject_import_modal_1 = __webpack_require__("./web/modern/components/brands/modals/reject-import-modal/reject-import-modal.ts");
var edit_company_section_1 = __webpack_require__("./web/modern/components/settings/edit-company-section/edit-company-section.ts");
var toggle_component_1 = __webpack_require__("./web/modern/components/common/toggle/toggle.component.ts");
var collapse_panel_component_1 = __webpack_require__("./web/modern/components/common/collapse-panel/collapse-panel.component.ts");
var media_drop_zone_component_1 = __webpack_require__("./web/modern/components/common/media-drop-zone/media-drop-zone.component.ts");
var gdpr_disable_modal_1 = __webpack_require__("./web/modern/components/brands/modals/gdpr-disable-modal/gdpr-disable-modal.ts");
var buttons_handler_component_1 = __webpack_require__("./web/modern/components/common/buttons-handler/buttons-handler.component.ts");
var alert_modal_component_1 = __webpack_require__("./web/modern/components/common/alert-modal/alert-modal.component.ts");
var delete_company_modal_1 = __webpack_require__("./web/modern/components/settings/companies-section/delete-company-modal/delete-company.modal.ts");
var custom_media_preview_component_1 = __webpack_require__("./web/modern/components/common/media-drop-zone/custom-media-preview/custom-media-preview.component.ts");
var date_time_calendar_1 = __webpack_require__("./web/modern/components/settings/date-time-calendar/date-time-calendar.ts");
var customize_labels_1 = __webpack_require__("./web/modern/components/settings/customize-labels/customize-labels.ts");
var confirm_re_sync_modal_1 = __webpack_require__("./web/modern/components/settings/date-time-calendar/confirm-re-sync-modal/confirm-re-sync-modal.ts");
var company_list_item_component_1 = __webpack_require__("./web/modern/components/settings/companies-section/company-list-item/company-list-item.component.ts");
var export_payments_modal_1 = __webpack_require__("./web/modern/components/payments/modals/export-payments-modal/export-payments-modal.ts");
var export_jobs_modal_1 = __webpack_require__("./web/modern/components/jobs/modals/export-jobs-modal/export-jobs-modal.ts");
var export_leads_modal_1 = __webpack_require__("./web/modern/components/leads/modals/export-leads-modal/export-leads-modal.ts");
var archive_btn_1 = __webpack_require__("./web/modern/components/buttons/archive-btn/archive-btn.ts");
var re_sync_btn_1 = __webpack_require__("./web/modern/components/buttons/re-sync-btn/re-sync-btn.ts");
var questionnaire_section_1 = __webpack_require__("./web/modern/components/settings/questionnaire-section/questionnaire-section.ts");
var questionnaire_template_list_1 = __webpack_require__("./web/modern/components/settings/common/questionnaire-template-list/questionnaire-template-list.ts");
var questionnaire_1 = __webpack_require__("./web/modern/components/questionnaire/questionnaire.ts");
var reply_track_component_1 = __webpack_require__("./web/modern/components/settings/email-settings-section/components/reply-track/reply-track.component.ts");
var smtp_modal_component_1 = __webpack_require__("./web/modern/components/settings/email-settings-section/modals/smtp-modal/smtp-modal.component.ts");
var email_reply_confirm_modal_component_1 = __webpack_require__("./web/modern/components/settings/email-settings-section/modals/email-reply-confirm-modal/email-reply-confirm-modal.component.ts");
var email_alert_modal_component_1 = __webpack_require__("./web/modern/components/settings/email-settings-section/modals/email-alert-modal/email-alert-modal.component.ts");
var job_file_section_component_1 = __webpack_require__("./web/modern/components/jobs/sections/job-file-section/job-file-section.component.ts");
var job_cell_header_1 = __webpack_require__("./web/modern/components/common/job-cell-header/job-cell-header.ts");
var btn_add_file_1 = __webpack_require__("./web/modern/components/jobs/common/btn-add-file/btn-add-file.ts");
var btn_delete_file_1 = __webpack_require__("./web/modern/components/jobs/common/btn-delete-file/btn-delete-file.ts");
var delete_attachment_modal_1 = __webpack_require__("./web/modern/components/jobs/common/delete-atachment-modal/delete-attachment-modal.ts");
var edit_contract_button_1 = __webpack_require__("./web/modern/components/jobs/modals/edit-contract-button/edit-contract-button.ts");
var save_contract_pdf_1 = __webpack_require__("./web/modern/components/jobs/modals/save-contract-pdf/save-contract-pdf.ts");
var download_log_1 = __webpack_require__("./web/modern/components/jobs/modals/download-log/download-log.ts");
var sn_quill_view_web_1 = __webpack_require__("./web/modern/components/common/sn-quill-view/sn-quill-view-web.ts");
var integrate_with_xero_v2_modal_1 = __webpack_require__("./web/modern/components/settings/integrations-section/modals/integrate-with-xero-v2/integrate-with-xero-v2-modal.ts");
var two_fa_settings_1 = __webpack_require__("./web/modern/components/settings/profile/two-fa-settings/two-fa-settings.ts");
var two_fa_setup_modal_1 = __webpack_require__("./web/modern/components/2fa/modals/two-fa-setup-modal/two-fa-setup-modal.ts");
var two_fa_login_modal_1 = __webpack_require__("./web/modern/components/2fa/modals/two-fa-login-modal/two-fa-login-modal.ts");
var two_fa_reset_modal_1 = __webpack_require__("./web/modern/components/2fa/modals/two-fa-reset-modal/two-fa-reset-modal.ts");
var two_fa_control_component_1 = __webpack_require__("./web/modern/components/2fa/two-fa-control/two-fa-control.component.ts");
var enter_code_component_1 = __webpack_require__("./web/modern/components/2fa/modals/two-fa-setup-modal/enter-code/enter-code.component.ts");
var set_up_questions_component_1 = __webpack_require__("./web/modern/components/2fa/modals/two-fa-setup-modal/set-up-questions/set-up-questions.component.ts");
var question_item_component_1 = __webpack_require__("./web/modern/components/2fa/modals/two-fa-setup-modal/set-up-questions/question-item/question-item.component.ts");
var get_authenticator_component_1 = __webpack_require__("./web/modern/components/2fa/modals/two-fa-setup-modal/get-authenticator/get-authenticator.component.ts");
var confirm_general_modal_component_1 = __webpack_require__("./web/modern/components/common/confirm-general-modal/confirm-general-modal.component.ts");
var manage_user_2fa_modal_1 = __webpack_require__("./web/modern/components/2fa/modals/manage-user-2fa-modal/manage-user-2fa-modal.ts");
var icon_tooltip_component_1 = __webpack_require__("./shared/components/common/tooltips/icon-tooltip/icon-tooltip.component.ts");
var lead_sources_section_1 = __webpack_require__("./web/modern/components/settings/lead-sources-section/lead-sources-section.ts");
var manage_lead_source_modal_component_1 = __webpack_require__("./web/modern/components/settings/lead-sources-section/modals/manage-lead-source-modal/manage-lead-source-modal.component.ts");
var delete_lead_source_modal_component_1 = __webpack_require__("./web/modern/components/settings/lead-sources-section/modals/delete-lead-source-modal/delete-lead-source-modal.component.ts");
var dynamic_table_component_1 = __webpack_require__("./web/modern/components/settings/common/dynamic-table/dynamic-table.component.ts");
var lead_source_color_1 = __webpack_require__("./shared/components/common/lead-source-color/lead-source-color.ts");
var lead_sources_graph_section_component_1 = __webpack_require__("./web/modern/components/dashboard/graphs-block/lead-sources-graph-section/lead-sources-graph-section.component.ts");
var view_all_lead_sources_modal_1 = __webpack_require__("./web/modern/components/dashboard/modals/view-all-lead-sources/view-all-lead-sources-modal.ts");
var lead_sources_graph_component_1 = __webpack_require__("./web/modern/components/dashboard/graphs-block/lead-sources-graph/lead-sources-graph.component.ts");
var invoice_numbering_component_1 = __webpack_require__("./web/modern/components/settings/invoice-payments-section/components/invoice-numbering/invoice-numbering.component.ts");
var insert_variable_component_1 = __webpack_require__("./shared/components/common/buttons/insert-variable/insert-variable.component.ts");
var email_multiselect_component_1 = __webpack_require__("./shared/components/common/email-multiselect/email-multiselect.component.ts");
var email_field_component_1 = __webpack_require__("./web/modern/components/common/email-field/email-field.component.ts");
var integrations_section_1 = __webpack_require__("./web/modern/components/settings/integrations-section/integrations-section.ts");
var integrate_xero_modal_1 = __webpack_require__("./web/modern/components/settings/integrations-section/modals/integrate-xero-modal/integrate-xero-modal.ts");
var integrate_shoot_proof_modal_1 = __webpack_require__("./web/modern/components/settings/integrations-section/modals/integrate-shoot-proof-modal/integrate-shoot-proof-modal.ts");
var integrate_quick_books_modal_1 = __webpack_require__("./web/modern/components/settings/integrations-section/modals/integrate-quick-books-modal/integrate-quick-books-modal.ts");
var pre_integrate_pick_time_modal_1 = __webpack_require__("./web/modern/components/settings/integrations-section/modals/pre-integrate-pick-time-modal/pre-integrate-pick-time-modal.ts");
var integrate_pic_time_modal_1 = __webpack_require__("./web/modern/components/settings/integrations-section/modals/integrate-pic-time-modal/integrate-pic-time-modal.ts");
var pic_time_invoices_block_component_1 = __webpack_require__("./web/modern/components/invoices/pic-time-invoices-block/pic-time-invoices-block.component.ts");
var copy_invoice_to_qb_or_xero_modal_1 = __webpack_require__("./web/modern/components/invoices/modals/copy-invoice-to-qb-or-xero/copy-invoice-to-qb-or-xero.modal.ts");
var subscription_info_btn_1 = __webpack_require__("./web/modern/components/admin/subscription-info/subscription-info-btn.ts");
var subscription_info_modal_1 = __webpack_require__("./web/modern/components/admin/subscription-info/subscription-info-modal/subscription-info-modal.ts");
var double_booking_1 = __webpack_require__("./web/modern/components/common/double-booking/double-booking.ts");
var double_booking_details_modal_1 = __webpack_require__("./web/modern/components/common/double-booking/double-booking-details/double-booking-details-modal.ts");
var event_item_component_1 = __webpack_require__("./web/modern/components/common/event-item/event-item.component.ts");
var events_overlapping_info_component_1 = __webpack_require__("./web/modern/components/common/double-booking/events-overlapping-info/events-overlapping-info.component.ts");
var sn_new_pagination_1 = __webpack_require__("./web/modern/components/common/sn-new-pagination/sn-new-pagination.ts");
var qt_templates_list_component_1 = __webpack_require__("./web/modern/components/settings/quote-invoice-templates/qt-templates/qt-templates-list/qt-templates-list.component.ts");
var qt_templates_update_component_1 = __webpack_require__("./web/modern/components/settings/quote-invoice-templates/qt-templates-update/qt-templates-update.component.ts");
var qt_templates_component_1 = __webpack_require__("./web/modern/components/settings/quote-invoice-templates/qt-templates/qt-templates.component.ts");
var qt_custom_template_control_component_1 = __webpack_require__("./web/modern/components/settings/quote-invoice-templates/qt-templates-update/qt-custom-template-control/qt-custom-template-control.component.ts");
var qt_fixed_template_control_component_1 = __webpack_require__("./web/modern/components/settings/quote-invoice-templates/qt-templates-update/qt-fixed-template-control/qt-fixed-template-control.component.ts");
var template_edit_header_component_1 = __webpack_require__("./web/modern/components/settings/common/template-edit-header/template-edit-header.component.ts");
var quote_amount_info_component_1 = __webpack_require__("./web/modern/components/quote/common/quote-amount-info/quote-amount-info.component.ts");
var template_apply_list_component_1 = __webpack_require__("./web/modern/components/quote/common/payment-schedule-template-list/template-apply-list.component.ts");
var save_as_template_modal_component_1 = __webpack_require__("./web/modern/components/quotes/modals/save-as-template-modal/save-as-template-modal.component.ts");
var save_new_template_modal_component_1 = __webpack_require__("./web/modern/components/quotes/modals/save-new-template-modal/save-new-template-modal.component.ts");
var template_apply_group_list_component_1 = __webpack_require__("./web/modern/components/quote/common/payment-shedule-template-group-list/template-apply-group-list.component.ts");
var notification_bar_1 = __webpack_require__("./web/modern/components/notification-bar/notification-bar.ts");
var reports_overview_component_1 = __webpack_require__("./web/modern/components/admin/report/overview/reports-overview.component.ts");
var report_overview_item_component_1 = __webpack_require__("./web/modern/components/admin/report/overview-item/report-overview-item.component.ts");
var generate_report_modal_1 = __webpack_require__("./web/modern/components/admin/report/generate-modal/generate-report.modal.ts");
var toggle_password_component_1 = __webpack_require__("./shared/components/common/toggle-password/toggle-password.component.ts");
var signup_check_email_component_1 = __webpack_require__("./web/modern/components/login/signup-check-email/signup-check-email.component.ts");
var tabs_panel_component_1 = __webpack_require__("./web/modern/components/common/tabs-panel/tabs-panel.component.ts");
var tab_component_1 = __webpack_require__("./web/modern/components/common/tabs-panel/tab.component.ts");
var save_languages_modal_1 = __webpack_require__("./web/modern/components/brands/modals/save-languages-modal/save-languages-modal.ts");
var payment_methods_component_1 = __webpack_require__("./web/modern/components/settings/payment-methods/payment-methods.component.ts");
var payment_schedules_modal_1 = __webpack_require__("./web/modern/components/settings/payment-schedules/modals/payment-schedules-modal/payment-schedules-modal.ts");
exports.downgradedComponents = [sn_label_1.SnLabelComponent, sn_warning_1.SnWarningComponent, settings_btn_1.SettingsBtnComponent, resubscribe_client_modal_1.ResubscribeClientModalWebComponent, terms_updated_modal_1.TermsUpdatedModalComponent, save_optin_consent_modal_1.SaveOptinConsentModalComponent, btn_subscription_1.BtnSubscriptionComponent, job_client_1.JobClientComponent, send_btn_1.SendBtnComponent, edit_btn_1.EditBtnComponent, enable_gdpr_section_1.EnableGdprSectionComponent, upload_photo_modal_1.UploadPhotoModalWebComponent, close_btn_1.CloseBtnComponent, client_card_1.ClientCardComponent, delete_btn_1.DeleteBtnComponent, subscribe_client_btn_1.SubscribeClientBtnComponent, opt_in_agreement_1.OptInAgreementComponent, contract_signature_1.ContractSignatureComponent, questionnaire_submitted_statement_1.QuestionnaireSubmittedStatementComponent, enable_clients_opt_in_1.EnableClientsOptInComponent, client_photo_1.ClientPhotoWebComponent, client_subscribe_info_1.ClientSubscribeInfoWebComponent, workflow_exit_modal_1.WorkflowExitModalComponent, warning_sign_img_1.WarningSignImgComponent, workflow_exit_modal_1.WorkflowExitModalComponent, searchbar_1.SearchbarComponent, sn_pagination_1.SnPaginationComponent, workflow_exit_modal_1.WorkflowExitModalComponent, consent_list_1.ConsentListWebComponent, archive_btn_1.ArchiveBtnComponent, cancel_btn_1.CancelBtnComponent, error_message_modal_1.ErrorMessageModalWebComponent, attachments_1.AttachmentsComponent, shoots_appointments_block_1.ShootsAppointmentsBlockComponent, event_type_row_1.EventTypeRowComponent, add_round_btn_1.AddRoundBtnComponent, simple_pagination_1.SimplePaginationComponent, recent_leads_block_1.RecentLeadsBlockComponent, delete_lead_modal_1.DeleteLeadModalComponent, user_menu_1.UserMenuComponent, delete_lead_modal_1.DeleteLeadModalComponent, drag_and_drop_block_1.DragAndDropBlockComponent, graphs_block_1.GraphsBlockComponent, upcoming_payments_block_1.UpcomingPaymentsBlockComponent, record_payment_modal_1.RecordPaymentModalComponent, write_off_modal_1.WriteOffModalComponent, job_task_block_1.JobTaskBlockComponent, delete_job_modal_1.DeleteJobModalComponent, graphs_block_1.GraphsBlockComponent, sn_date_range_picker_component_1.SnDateRangePickerComponent, sn_date_picker_component_1.SnDatePickerComponent, upload_component_1.UploadComponent, proselect_upload_component_1.ProselectUploadComponent, quote_update_1.QuoteUpdateComponent, main_shoot_date_1.MainShootDateComponent, quote_job_info_1.QuoteJobInfoComponent, quote_client_info_1.QuoteClientInfoComponent, quote_create_package_block_1.QuoteCreatePackageComponent, payment_schedule_1.PaymentScheduleComponent, quote_create_package_block_1.QuoteCreatePackageComponent, quote_view_1.QuoteViewComponent, print_btn_1.PrintBtnComponent, modal_delete_quote_1.ModalDeleteQuoteComponent, quote_info_1.QuoteInfoComponent, quote_from_info_1.QuoteFromInfoComponent, modal_send_quote_1.ModalSendQuoteComponent, package_info_panel_component_1.PackageInfoPanelComponent, price_tag_component_1.PriceTagComponent, quote_summary_block_1.QuoteSummaryBlockComponent, product_packages_block_component_1.PackagesProductBlockComponent, packages_block_component_1.PackagesBlockComponent, product_block_component_1.ProductBlockComponent, update_package_product_modal_component_1.UpdatePackageProductModalComponent, product_details_modal_component_1.ProductDetailsModalComponent, addons_table_component_1.AddonsTableComponent, main_shoot_date_1.MainShootDateComponent, autocompete_email_input_1.AutocompleteEmailInputComponent, add_new_element_btn_component_1.AddNewElementBtnComponent, add_quote_type_modal_component_1.AddQuoteTypeModalComponent, invoice_update_dnd_1.InvoiceUpdateDnd, quote_view_fixed_1.QuoteViewFixedComponent, product_package_table_1.ProductPackageTableComponent, quote_assignment_panel_component_1.QuoteAssignmentPanelComponent, re_sync_btn_1.ReSyncBtnComponent, invoice_view_1.InvoiceViewComponent, invoice_info_table_1.InvoiceInfoTableComponent, invoice_payments_schedule_table_1.InvoicePaymentsScheduleTable, preview_btn_1.PreviewBtnComponent, copy_to_xero_btn_1.CopyToXeroBtnComponent, copy_to_qb_btn_1.CopyToQbBtnComponent, delete_invoice_modal_1.DeleteInvoiceModalComponent, invoice_payment_action_buttons_1.InvoicePaymentActionButtons, save_pdf_btn_1.SavePdfBtnComponent, sn_quill_view_web_1.SnQuillWebViewComponent, show_more_content_component_1.ShowMoreContentComponent, discount_create_block_component_1.DiscountCreateBlockComponent, discount_view_block_component_1.DiscountViewBlockComponent, invoice_client_info_1.InvoiceClientInfoComponent, invoice_contract_question_1.InvoiceContractQuestionComponent, invoice_job_info_1.InvoiceJobInfoComponent, invoice_main_info_1.InvoiceMainInfoComponent, invoice_payment_schedule_1.InvoicePaymentScheduleComponent, invoice_summary_1.InvoiceSummaryComponent, invoice_update_1.InvoiceUpdateComponent, modal_make_invoice_1.ModalMakeInvoiceComponent, mark_quote_as_accepted_modal_1.MarkQuoteAsAcceptedModal, gallery_view_block_component_1.GalleryViewBlockComponent, delete_gallery_modal_1.DeleteGalleryModal, add_gallery_modal_1.AddGalleryModal, create_new_gallery_modal_1.CreateNewGalleryModal, select_existing_gallery_modal_1.SelectExistingGalleryModal, delete_confirmation_modal_1.DeleteConfirmationModal, mark_quote_as_accepted_modal_1.MarkQuoteAsAcceptedModal, invoice_payments_schedule_table_1.InvoicePaymentsScheduleTable, show_more_content_component_1.ShowMoreContentComponent, discount_create_block_component_1.DiscountCreateBlockComponent, discount_view_block_component_1.DiscountViewBlockComponent, companies_section_component_1.CompaniesSectionComponent, subscription_modal_1.SubscriptionModalComponent, subscription_card_1.SubscriptionCardComponent, invoices_view_block_component_1.InvoicesViewBlockComponent, shootproof_invoices_block_component_1.ShootproofInvoicesBlockComponent, copy_invoice_to_quickBooks_modal_1.CopyInvoiceToQuickBooksModal, payments_overview_component_1.PaymentsOverviewComponent, profile_1.ProfileComponent, account_details_1.AccountDetailsComponent, login_change_1.LoginChangeComponent, password_change_1.PasswordChangeComponent, subscription_change_1.SubscriptionChangeComponent, subscription_period_change_1.SubscriptionPeriodChangeComponent, iframe_component_1.IframeComponent, cancel_subscription_confirm_modal_1.CancelSubscriptionConfirmModalComponent, subscription_announcement_banner_1.SubscriptionAnnouncementBannerComponent, subscription_choose_plan_1.SubscriptionChoosePlanComponent, sn_quill_editor_web_1.SnQuillEditorWebComponent, sn_quill_link_modal_1.SnQuillLinkModal, attachments_component_1.WebAttachmentsComponent, sn_quill_attachment_modal_1.SnQuillAttachmentModal, contact_form_section_1.ContactFormSectionComponent, template_list_1.TemplateListComponent, questionnaire_template_list_1.QuestionnaireTemplateListComponent, setting_section_header_1.SettingSectionHeaderComponent, setting_section_description_1.SettingSectionDescriptionComponent, settings_add_btn_1.SettingsAddBtnComponent, delete_item_modal_1.DeleteItemModalComponent, discount_block_component_1.DiscountBlockComponent, update_discount_modal_component_1.UpdateDiscountModal, delete_item_modal_1.DeleteItemModalComponent, edit_contract_modal_component_1.EditContractModalComponent, email_reply_modal_component_1.EmailReplyModalComponent, settings_overview_component_1.SettingsOverviewComponent, delete_item_modal_1.DeleteItemModalComponent, settings_item_component_1.SettingsItemComponent, settings_navigation_component_1.SettingsNavigationComponent, settings_item_component_1.SettingsItemComponent, user_navbar_component_1.UserNavbarComponent, brand_create_modal_1.BrandCreateModalComponent, import_data_modal_1.ImportDataModalComponent, reject_import_modal_1.RejectImportModalComponent, edit_company_section_1.EditCompanySectionComponent, toggle_component_1.ToggleComponent, collapse_panel_component_1.CollapsePanelComponent, media_drop_zone_component_1.MediaDropZoneComponent, gdpr_disable_modal_1.GdprDisableModalComponent, buttons_handler_component_1.ButtonsHandlerComponent, alert_modal_component_1.AlertModalComponent, custom_media_preview_component_1.CustomMediaPreviewComponent, date_time_calendar_1.DateTimeCalendarComponent, customize_labels_1.CustomizeLabelsComponent, delete_company_modal_1.DeleteCompanyModalComponent, confirm_re_sync_modal_1.ConfirmReSyncModal, company_list_item_component_1.CompanyListItemComponent, email_reply_confirm_modal_component_1.EmailReplyConfirmModalComponent, email_alert_modal_component_1.EmailAlertModalComponent, export_payments_modal_1.ExportPaymentsModalComponent, export_jobs_modal_1.ExportJobsModalComponent, export_leads_modal_1.ExportLeadsModalComponent, questionnaire_section_1.QuestionnaireSectionComponent, questionnaire_1.QuestionnaireComponent, reply_track_component_1.ReplyTrackComponent, smtp_modal_component_1.SmtpModalComponent, export_leads_modal_1.ExportLeadsModalComponent, job_file_section_component_1.JobFileSectionComponent, job_cell_header_1.JobCellHeader, btn_add_file_1.BtnAddFile, btn_delete_file_1.BtnDeleteFile, delete_attachment_modal_1.DeleteAttachmentModal, edit_contract_button_1.EditContractButton, save_contract_pdf_1.SaveContractPdf, download_log_1.DownloadLog, integrate_with_xero_v2_modal_1.IntegrateWithXeroV2Modal, two_fa_settings_1.TwoFaSettingsComponent, two_fa_setup_modal_1.TwoFaSetupModalComponent, two_fa_login_modal_1.TwoFaLoginModalComponent, two_fa_reset_modal_1.TwoFaResetModalComponent, two_fa_control_component_1.TwoFaControlComponent, get_authenticator_component_1.GetAuthenticatorComponent, set_up_questions_component_1.SetUpQuestionsComponent, question_item_component_1.QuestionItemComponent, enter_code_component_1.EnterCodeComponent, confirm_general_modal_component_1.ConfirmGeneralModalComponent, manage_user_2fa_modal_1.ManageUser2faModal, icon_tooltip_component_1.IconTooltipComponent, lead_sources_section_1.LeadSourcesSectionComponent, manage_lead_source_modal_component_1.ManageLeadSourceModalComponent, delete_lead_source_modal_component_1.DeleteLeadSourceModalComponent, dynamic_table_component_1.DynamicTableComponent, lead_source_color_1.LeadSourceColorComponent, lead_sources_graph_section_component_1.LeadSourcesGraphSectionComponent, lead_sources_graph_component_1.LeadSourcesGraphComponent, view_all_lead_sources_modal_1.ViewAllLeadSourcesModalComponent, invoice_numbering_component_1.InvoiceNumberingComponent, insert_variable_component_1.InsertVariableComponent, email_field_component_1.EmailFieldComponent, email_multiselect_component_1.EmailMultiselectComponent, save_contract_pdf_1.SaveContractPdf, download_log_1.DownloadLog, smtp_modal_component_1.SmtpModalComponent, integrations_section_1.IntegrationsSection, integrate_xero_modal_1.IntegrateXeroModal, integrate_shoot_proof_modal_1.IntegrateShootProofModal, integrate_quick_books_modal_1.IntegrateQuickBooksModal, pre_integrate_pick_time_modal_1.PreIntegratePickTimeModal, integrate_pic_time_modal_1.IntegratePicTimeModal, pic_time_invoices_block_component_1.PicTimeInvoicesBlockComponent, copy_invoice_to_qb_or_xero_modal_1.CopyInvoiceToQuickBooksOrXeroModal, subscription_info_btn_1.SubscriptionInfoBtn, subscription_info_modal_1.SubscriptionInfoModal, double_booking_1.DoubleBookingComponent, double_booking_details_modal_1.DoubleBookingDetailsModalComponent, event_item_component_1.EventItemComponent, events_overlapping_info_component_1.EventsOverlappingInfoComponent, sn_new_pagination_1.SnNewPaginationComponent, qt_templates_component_1.QtTemplatesComponent, qt_templates_list_component_1.QtTemplatesListComponent, qt_templates_update_component_1.QtTemplatesUpdateComponent, qt_custom_template_control_component_1.QtCustomTemplateControlComponent, qt_fixed_template_control_component_1.QtFixedTemplateControlComponent, template_edit_header_component_1.TemplateEditHeaderComponent, quote_amount_info_component_1.QuoteAmountInfoComponent, template_apply_list_component_1.TemplateApplyListComponent, save_as_template_modal_component_1.SaveAsTemplateModalComponent, save_new_template_modal_component_1.SaveNewTemplateModalComponent, notification_bar_1.NotificationBarComponent, template_apply_group_list_component_1.TemplateApplyGroupListComponent, reports_overview_component_1.ReportsOverviewComponent, report_overview_item_component_1.ReportOverviewItemComponent, generate_report_modal_1.GenerateReportModalComponent, toggle_password_component_1.TogglePassword, signup_check_email_component_1.SignupCheckEmailComponent, tabs_panel_component_1.TabsPanel, tab_component_1.TabComponent, save_languages_modal_1.SaveLanguagesModalComponent, payment_methods_component_1.PaymentMethods, payment_schedules_modal_1.PaymentSchedulesModalComponent];

/***/ }),

/***/ "./web/modern/components/navbar/user-navbar/user-menu/user-menu.html":
/***/ (function(module, exports) {

module.exports = "<!--mobile-->\n\n<div class=\"pb-0 sandwich-menu hidden-md hidden-lg menu-mobile-box\">\n    <a (click)=\"toggleMobileNav()\" class=\"sidebar-btn visible-xs-block visible-sm-block pull-right\">\n        <i class=\"fa fa-bars\"></i>\n    </a>\n    <div [ngStyle]=\"{display: isMobileMenuOpen? 'block' : 'none'}\">\n        <section  #mobileMenu class=\"mobile-banner-styles user-menu-mobile-holder\">\n            <div class=\"company-info\">\n                <client-photo [clientId]=\"null\" [hasAvatar]=\"user.hasAvatar\"></client-photo>\n                <div class=\"display-inline text-overflow\">\n                    <div class=\"pl-20 bold f-s-15 text-overflow\"><span>{{ user.firstName }}</span> <span> {{ user.lastName }}</span></div>\n                    <div class=\"pl-20 pt-4 text-overflow\"><span>{{ user.email }}</span></div>\n                </div>\n            </div>\n\n            <ng-container *ngFor=\"let brand of brands.brands\">\n                <div (click)=\"onMenuItemClick(brand.selected, brand)\" class=\"brands-box\" [ngClass]=\"{'active-brand': brand.selected}\">\n                    <div class=\"brand-item\">\n                        {{ brand.companyName }}\n                    </div>\n                    <div class=\"arrow\" *ngIf=\"brand.selected\">\n                        <i class=\"fa fa-angle-down f-s-18 text-bold\" [ngClass]=\"{'rotate-arrow': isRoutesMenuOpen}\" aria-hidden=\"true\"></i>\n                    </div>\n                </div>\n                <div (click)=\"closeMobileNav()\" class=\"mobile-routes-holder\" *ngIf=\"isRoutesMenuOpen && brand.selected\">\n                    <a  class=\"mobile-menu-route-item\"\n                        href=\"/\"\n                        data-autotest-section=\"dashboardComputer\">\n\n                        <div [ngClass]=\"getClass('/')\"\n                             class=\"mobile-nav-item-name-box\">Dashboard\n                        </div>\n                    </a>\n                    <a class=\"mobile-menu-route-item\"\n                       href=\"/clients\"\n                       data-autotest-section=\"clientsComputer\">\n\n                        <div [ngClass]=\"getClass('/clients')\"\n                             class=\"mobile-nav-item-name-box\">Clients\n                        </div>\n                    </a>\n                    <a class=\"mobile-menu-route-item\"\n                       href=\"/leads\"\n                       data-autotest-section=\"leadsComputer\">\n\n                        <div [ngClass]=\"getClass('/leads')\"\n                             class=\"mobile-nav-item-name-box\">Leads\n                        </div>\n                    </a>\n                    <a class=\"mobile-menu-route-item\"\n                       href=\"/jobs\"\n                       data-autotest-section=\"jobsComputer\">\n\n                        <div [ngClass]=\"getClass('/jobs')\"\n                             class=\"mobile-nav-item-name-box\">Jobs\n                        </div>\n                    </a>\n                    <a class=\"mobile-menu-route-item\"\n                       href=\"/calendar\"\n                       data-autotest-section=\"calendarComputer\">\n\n                        <div [ngClass]=\"getClass('/calendar')\"\n                             class=\"mobile-nav-item-name-box\">Calendar\n                        </div>\n                    </a>\n                    <a class=\"mobile-menu-route-item\"\n                       href=\"/payments\"\n                       data-autotest-section=\"paymentsComputer\">\n\n                        <div [ngClass]=\"getClass('/payments')\"\n                             class=\"mobile-nav-item-name-box\">Payments\n                        </div>\n                    </a>\n                    <a class=\"mobile-menu-route-item\"\n                       href=\"/settings\"\n                       data-autotest-section=\"settingsComputer\">\n\n                        <div [ngClass]=\"getClass('/settings')\"\n                             class=\"mobile-nav-item-name-box\">Settings\n                        </div>\n                    </a>\n                </div>\n            </ng-container>\n\n\n\n            <div *ngIf=\"actionList.length\" (click)=\"createNewBrand()\" class=\"add-new-company-mobile\">\n                <div class=\"dropdown-plus\">\n                    +\n                </div>\n                <div class=\"ml-15 brand-name-mobile\">\n                    Add New Company\n                </div>\n            </div>\n\n            <div class=\"user-menu-footer-mobile\">\n                <div><a class=\"help-button\" href=\"http://help.studioninja.co\" target=\"_blank\">Help Tutorials</a></div>\n                <div class=\"right\"><button (click)=\"logout()\" class=\"btn btn-export btn-sign-out-mobile\">Sign Out</button></div>\n            </div>\n        </section>\n    </div>\n</div>\n\n<!--full screen-->\n\n<div class=\"user\" id=\"dropdownMenuId\">\n    <button aria-expanded=\"false\" aria-haspopup=\"true\" class=\"user--button hidden-xs hidden-sm\" data-toggle=\"dropdown\" id=\"dropdownMenuButton\" type=\"button\">\n        <span class=\"user--button__text\">{{ activeBrand?.companyName }}</span>\n        <i aria-hidden=\"true\" class=\"fa fa-chevron-down down-icon\"></i>\n        <img alt=\"\" class=\"user--button__icon\" src=\"https://app.studioninja.co/build/release-pipeline-119/resources/dist/assets/images/icons/user.png\">\n    </button>\n\n    <ul class=\"user--menu\">\n        <li>\n            <a class=\"user--menu__item user--menu__avatar\">\n                <div class=\"flex-box keep-open flex-align-center\">\n                    <client-photo [clientId]=\"null\" [hasAvatar]=\"user.hasAvatar\"></client-photo>\n                    <div class=\"display-inline text-overflow\">\n                        <div class=\"pl-20 bold f-s-15 text-overflow\"><span>{{ user.firstName }}</span> <span> {{ user.lastName }}</span></div>\n                        <div class=\"pl-20 pt-4 text-overflow\"><span>{{ user.email }}</span></div>\n                    </div>\n                </div>\n            </a>\n        </li>\n        <li class=\"user--menu__divider\"></li>\n        <li><a class=\"user--menu__item\" href=\"/settings/companies\">Companies</a></li>\n        <li class=\"user--menu__divider\"></li>\n\n        <ng-container *ngFor=\"let brand of brands.brands\">\n            <li (click)=\"activateBrand(brand)\" [class.selected-brand]=\"brand.selected\" class=\"user--menu__brand f-bold\">\n                <div class=\"brand-image\">\n                    <div *ngIf=\"brand.logoUrl\" [style.backgroundImage]=\"'url(' + brand.logoUrl + ')'\" class=\"brand-image--logo\"></div>\n                    <i *ngIf=\"!brand.logoUrl\" class=\"brand-image--icon\" class=\"fi fi-company\"></i>\n                </div>\n                <div class=\"brand-name\">\n                    {{ brand.companyName }}\n                </div>\n            </li>\n            <li class=\"user--menu__divider\"></li>\n        </ng-container>\n\n        <li *ngIf=\"actionList.length\" (click)=\"createNewBrand()\" class=\"user--menu__brand\">\n            <div class=\"add-new-brand\">\n                +\n            </div>\n            <div class=\"brand-name\">\n                Add New Company\n            </div>\n        </li>\n        <li *ngIf=\"actionList.length\" class=\"user--menu__divider\"></li>\n\n        <li><a class=\"user--menu__item\" href=\"http://help.studioninja.co\" target=\"_blank\">Help Tutorials</a></li>\n        <li class=\"user--menu__divider\"></li>\n        <li class=\"right\"><button (click)=\"logout()\" class=\"btn btn-export btn-export-navbar\">Sign Out</button></li>\n    </ul>\n</div>\n"

/***/ }),

/***/ "./web/modern/components/navbar/user-navbar/user-menu/user-menu.scss":
/***/ (function(module, exports) {

module.exports = ".user {\n  position: relative; }\n  .user--button {\n    background: transparent;\n    border-radius: 25px;\n    padding: 0;\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -webkit-align-items: center;\n        -ms-flex-align: center;\n            align-items: center;\n    background: #212a3a;\n    border: 2px solid #aeaeae; }\n    .user--button__text {\n      margin-left: 20px;\n      color: #ffffff;\n      position: relative;\n      display: inline-block;\n      font-size: 12px;\n      max-width: 125px;\n      text-overflow: ellipsis;\n      overflow: hidden;\n      min-width: 70px;\n      white-space: pre; }\n    .user--button__icon {\n      border-left: 2px solid #aeaeae;\n      height: 30px;\n      width: 30px;\n      margin-right: 4px; }\n    .user--button:focus {\n      border: 2px solid #aeaeae !important; }\n    .user--button:hover {\n      background: #2b364a; }\n    .user--button .down-icon {\n      color: white;\n      font-size: 10px;\n      margin: 0 15px 0 10px; }\n  @media screen and (min-width: 320px) and (max-width: 991px) {\n    .user .user--menu {\n      display: none !important; } }\n  @media screen and (min-width: 992px) {\n    .user .user-menu-mobile-holder {\n      display: none !important; } }\n  .user--menu {\n    position: absolute;\n    top: 100%;\n    z-index: 1000;\n    display: none;\n    list-style: none;\n    text-shadow: none;\n    padding: 0;\n    margin: 10px 0 0;\n    background-color: #ffffff;\n    border: 1px solid #d8dee4;\n    border-radius: 0;\n    box-shadow: 0 0 5px -1px rgba(0, 0, 0, 0.4);\n    max-height: 550px;\n    margin-top: 36px !important;\n    width: 360px !important;\n    right: 0; }\n    .user--menu:before {\n      content: '';\n      border-left: 7px solid transparent;\n      border-right: 7px solid transparent;\n      border-bottom: 12px solid #ffffff;\n      position: absolute;\n      right: 12px;\n      top: -12px; }\n    .user--menu__brand {\n      display: -webkit-box;\n      display: -webkit-flex;\n      display: -ms-flexbox;\n      display: flex;\n      padding: 15px 20px;\n      background: #f7f7f7;\n      cursor: pointer; }\n      .user--menu__brand:hover {\n        background: #dedede; }\n      .user--menu__brand .brand-image, .user--menu__brand .add-new-brand {\n        display: -webkit-box;\n        display: -webkit-flex;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-pack: center;\n        -webkit-justify-content: center;\n            -ms-flex-pack: center;\n                justify-content: center;\n        -webkit-box-align: center;\n        -webkit-align-items: center;\n            -ms-flex-align: center;\n                align-items: center;\n        height: 45px;\n        width: 45px;\n        font-weight: 900;\n        font-size: 18px;\n        margin-right: 20px;\n        background: #e5e5e5; }\n        .user--menu__brand .brand-image--logo {\n          height: 45px;\n          width: 45px;\n          background: center no-repeat;\n          background-size: contain; }\n      .user--menu__brand .brand-name {\n        -webkit-align-self: center;\n            -ms-flex-item-align: center;\n                align-self: center;\n        max-width: 250px; }\n      .user--menu__brand .add-new-brand {\n        border-radius: 50%;\n        font-size: 25px; }\n    .user--menu__item {\n      display: block;\n      padding: 15px 20px;\n      font-weight: 400;\n      line-height: 1.42857;\n      white-space: nowrap;\n      color: #5f5f5f;\n      font-size: 14px;\n      text-align: left; }\n      .user--menu__item:hover {\n        background: #f7f7f7;\n        text-decoration: none; }\n    .user--menu__avatar {\n      padding: 20px;\n      font-size: 13px;\n      color: #4e5e6a; }\n      .user--menu__avatar:hover {\n        text-underline: none;\n        background: #ffffff; }\n    .user--menu__divider {\n      height: 1px;\n      overflow: hidden;\n      background-color: #e5e5e5; }\n\n.open .user--menu {\n  display: block; }\n\n.selected-brand {\n  cursor: unset;\n  background: #e6f0fa; }\n  .selected-brand:hover {\n    background: #e6f0fa; }\n\n.user-menu-mobile-holder {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  position: absolute;\n  width: 100%;\n  top: 100px;\n  left: 0;\n  right: 0;\n  box-shadow: 0 0 5px -1px rgba(0, 0, 0, 0.4);\n  background: #34425a;\n  overflow-x: scroll;\n  max-height: -webkit-calc(100vh - 100px);\n  max-height: calc(100vh - 100px); }\n\n.company-info {\n  min-height: 110px;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  padding: 15px 25px;\n  background: #ffffff;\n  color: #4e5e6a; }\n\n.brand-item {\n  padding: 30px 25px;\n  color: #ffffff;\n  font-size: 16px;\n  cursor: pointer; }\n\n.user-menu-footer-mobile {\n  min-height: 49px;\n  height: 52px;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n  -webkit-justify-content: space-between;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  background: #ffffff;\n  border-bottom: 1px solid #dddddd; }\n\n.btn-sign-out-mobile {\n  border-radius: 0;\n  border-top: 0;\n  border-right: 0;\n  border-bottom: 0;\n  margin: 0; }\n\n.add-new-company-mobile {\n  min-height: 80px;\n  padding: 15px 25px;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  background-color: #192b39;\n  cursor: pointer; }\n\n.dropdown-plus {\n  width: 48px;\n  height: 48px;\n  background-color: #34425a;\n  color: #ffffff;\n  font-size: 24px;\n  font-weight: bold;\n  text-align: center;\n  border-radius: 50%;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  cursor: pointer; }\n\n.brand-name-mobile {\n  padding: 15px 25px;\n  color: #ffffff;\n  font-size: 16px; }\n\n.brands-box {\n  margin-bottom: 1px;\n  background: #192b39;\n  min-height: 80px; }\n\n.help-button {\n  padding: 15px 25px;\n  color: #4e5e6a;\n  cursor: pointer;\n  font-size: 16px;\n  text-decoration: none; }\n\n.active-brand {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n  -webkit-justify-content: space-between;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  cursor: pointer; }\n\n.arrow {\n  color: #ffffff;\n  font-size: 16px;\n  padding: 15px 25px; }\n\n.mobile-menu-route-item {\n  color: #92aac4;\n  font-size: 15px;\n  text-decoration: none !important; }\n\n.mobile-nav-item-name-box {\n  padding: 30px 25px;\n  height: 81px; }\n\n.selected-menu {\n  background: #1e3347; }\n\n.rotate-arrow {\n  -webkit-transform: rotateZ(180deg);\n      -ms-transform: rotate(180deg);\n          transform: rotateZ(180deg); }\n"

/***/ }),

/***/ "./web/modern/components/navbar/user-navbar/user-menu/user-menu.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var account_service_1 = __webpack_require__("./web/modern/services/user/account.service.ts");
var subscription_service_1 = __webpack_require__("./shared/services/subscription/subscription.service.ts");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var brands_data_service_1 = __webpack_require__("./shared/services/brands/brands.data.service.ts");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var brand_create_modal_1 = __webpack_require__("./web/modern/components/brands/modals/brand-create-modal/brand-create-modal.ts");
var rxjs_1 = __webpack_require__("./node_modules/rxjs/Rx.js");
var brands_service_1 = __webpack_require__("./shared/services/brands/brands.service.ts");
var common_1 = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
var import_data_modal_1 = __webpack_require__("./web/modern/components/brands/modals/import-data-modal/import-data-modal.ts");
var settings_1 = __webpack_require__("./shared/services/settings/settings.ts");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var UserMenuComponent = function () {
    function UserMenuComponent(accountService, subscriptionService, brandsDataService, brandsService, snModalService, location, settingsService, messageService) {
        _classCallCheck(this, UserMenuComponent);

        this.accountService = accountService;
        this.subscriptionService = subscriptionService;
        this.brandsDataService = brandsDataService;
        this.brandsService = brandsService;
        this.snModalService = snModalService;
        this.location = location;
        this.settingsService = settingsService;
        this.messageService = messageService;
        this.emitSwitchBrand = new core_1.EventEmitter();
        // shows brand routes list from the start
        this.isRoutesMenuOpen = true;
        this.isMobileMenuOpen = false;
        this.actionList = [];
        this.unsubscribe = new Subject_1.Subject();
    }

    _createClass(UserMenuComponent, [{
        key: "onWindowResize",
        value: function onWindowResize() {
            this.isMobileMenuOpen = false;
        }
    }, {
        key: "ngOnInit",
        value: function ngOnInit() {
            this.subscribeToBrandsChange();
        }
    }, {
        key: "ngOnChanges",
        value: function ngOnChanges(change) {
            if (change.brands && change.brands.currentValue) {
                this.actionList = this.brandsService.createActionList(change.brands.currentValue.actions);
                this.setActiveBrand(change.brands.currentValue);
            }
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "onMenuItemClick",
        value: function onMenuItemClick(selected, brand) {
            selected ? this.toggleRoutes() : this.activateBrand(brand);
        }
    }, {
        key: "logout",
        value: function logout() {
            this.accountService.logoutWeb();
        }
    }, {
        key: "toggleMobileNav",
        value: function toggleMobileNav() {
            this.isRoutesMenuOpen = true;
            this.isMobileMenuOpen = !this.isMobileMenuOpen;
            this.scrollUserMenuToTop();
        }
    }, {
        key: "toggleRoutes",
        value: function toggleRoutes() {
            this.isRoutesMenuOpen = !this.isRoutesMenuOpen;
        }
    }, {
        key: "createNewBrand",
        value: function createNewBrand() {
            var _this = this;

            if (this.checkIfWorkflowUrl()) {
                this.messageService.showToaster('i_0', 'workflow');
                return;
            }
            this.isMobileMenuOpen = false;
            this.isRoutesMenuOpen = true;
            if (this.brands.actions.UPGRADE_PLAN) {
                this.subscriptionService.setChoosePlanOpenModalStatus({
                    state: true,
                    payload: { url: this.brands.actions.UPGRADE_PLAN.url }
                });
            }
            if (this.brands.actions.ADD_NEW_BRAND) {
                this.snModalService.openModal(brand_create_modal_1.BrandCreateModalComponent).result.then(function (brandData) {
                    return _this.onCreateModalClosed(brandData);
                }).catch(function () {
                    return rxjs_1.EmptyError;
                });
            }
        }
    }, {
        key: "closeMobileNav",
        value: function closeMobileNav() {
            this.isMobileMenuOpen = false;
        }
    }, {
        key: "getClass",
        value: function getClass(path) {
            var locationPath = location.pathname;
            if (locationPath.includes('/invoices')) {
                locationPath = '/payments';
            }
            if (path === '/') {
                if (locationPath.substring(0, location.protocol.length + location.host.length) === path) {
                    return 'selected-menu';
                }
                return 'not-selected-menu';
            }
            if (locationPath.includes(path)) {
                return 'selected-menu';
            }
            return 'not-selected-menu';
        }
    }, {
        key: "activateBrand",
        value: function activateBrand(brand) {
            var _this2 = this;

            if (!brand.selected) {
                if (this.checkIfWorkflowUrl()) {
                    this.messageService.showToaster('i_0', 'workflow');
                    return;
                }
                this.isMobileMenuOpen = false;
                this.isRoutesMenuOpen = true;
                this.emitSwitchBrand.emit(true);
                this.brandsDataService.switchBrands(brand.companyId).pipe(operators_1.takeUntil(this.unsubscribe), operators_1.switchMap(function () {
                    return _this2.accountService.updateSystemDueToBrandChange().pipe(operators_1.finalize(function () {
                        return _this2.emitSwitchBrand.emit(false);
                    }));
                })).subscribe(function () {
                    _this2.brandsDataService.setBrandsChange(location.pathname === '/');
                });
            }
        }
    }, {
        key: "scrollUserMenuToTop",
        value: function scrollUserMenuToTop() {
            var _this3 = this;

            if (this.isMobileMenuOpen) {
                setTimeout(function () {
                    _this3.mobileMenu.nativeElement.scrollBy(0, -_this3.mobileMenu.nativeElement.scrollTop);
                }, 0);
            }
        }
    }, {
        key: "subscribeToBrandsChange",
        value: function subscribeToBrandsChange() {
            var _this4 = this;

            this.brandsDataService.brandsChange.pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function () {
                return _this4.location.go('/');
            });
        }
    }, {
        key: "onCreateModalClosed",
        value: function onCreateModalClosed(brandData) {
            if (brandData.action === 'IMPORT') {
                this.handleDataImportModal(brandData.props);
            }
            if (brandData.action === 'REDIRECT') {
                this.updateAndRedirect(brandData.props.companyId);
            }
        }
    }, {
        key: "handleDataImportModal",
        value: function handleDataImportModal(brandData) {
            var _this5 = this;

            this.importModalRef = this.snModalService.openModal(import_data_modal_1.ImportDataModalComponent);
            this.importModalRef.componentInstance.newBrandData = brandData;
            this.importModalRef.result.then(function (res) {
                if (res) {
                    _this5.updateAndRedirect(res.companyId);
                }
            }).catch();
        }
    }, {
        key: "setActiveBrand",
        value: function setActiveBrand(brands) {
            var _this6 = this;

            brands.brands.forEach(function (e) {
                if (e.companyId === brands.authCompanyId) {
                    _this6.activeBrand = e;
                }
            });
        }
    }, {
        key: "updateAndRedirect",
        value: function updateAndRedirect(companyId) {
            this.location.go("/settings/company/" + companyId + "/edit");
        }
    }, {
        key: "checkIfWorkflowUrl",
        value: function checkIfWorkflowUrl() {
            return location.pathname.includes('/settings/workflows/edit') || location.pathname.includes('/settings/workflows/add');
        }
    }]);

    return UserMenuComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], UserMenuComponent.prototype, "user", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], UserMenuComponent.prototype, "brands", void 0);
__decorate([core_1.Output(), __metadata("design:type", Object)], UserMenuComponent.prototype, "emitSwitchBrand", void 0);
__decorate([core_1.ViewChild('mobileMenu'), __metadata("design:type", Object)], UserMenuComponent.prototype, "mobileMenu", void 0);
__decorate([core_1.HostListener('window:resize'), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", void 0)], UserMenuComponent.prototype, "onWindowResize", null);
UserMenuComponent = __decorate([core_1.Component({
    selector: 'user-menu',
    template: __webpack_require__("./web/modern/components/navbar/user-navbar/user-menu/user-menu.html"),
    styles: [__webpack_require__("./web/modern/components/navbar/user-navbar/user-menu/user-menu.scss")]
}), __metadata("design:paramtypes", [account_service_1.AccountServiceWebProvider, subscription_service_1.NewSubscriptionServiceDataProvider, brands_data_service_1.BrandsDataServiceProvider, brands_service_1.BrandsServiceProvider, snModal_service_1.SNModalService, common_1.Location, settings_1.SettingsProvider, message_service_1.MessageService])], UserMenuComponent);
exports.UserMenuComponent = UserMenuComponent;

/***/ }),

/***/ "./web/modern/components/navbar/user-navbar/user-navbar.component.html":
/***/ (function(module, exports) {

module.exports = "<section>\n    <div *ngIf=\"showLogo\" class=\"col-md-3 pl-0\">\n        <a href=\"/\"><img class=\"logo\" src=\"https://app.studioninja.co/build/release-pipeline-119/resources/dist/assets/images/logo/logo_R.svg\" alt=\"StudioNinja\"></a>\n    </div>\n\n    <div class=\"row col-md-8 hidden-xs hidden-sm\">\n        <ul *ngIf=\"showLogo\" class=\"nav sn-header__nav\">\n            <li [ngClass]=\"getClass('/')\">\n                <a href=\"/\" data-autotest-section=\"dashboardComputer\">\n                    <span class=\"fi fi-home\"></span>\n                    <span>Dashboard</span>\n                </a>\n            </li>\n            <li [ngClass]=\"getClass('/clients')\">\n                <a href=\"/clients\" data-autotest-section=\"clientsComputer\">\n                    <span class=\"fi fi-clients\"></span>\n                    <span>Clients</span>\n                </a>\n            </li>\n            <li [ngClass]=\"getClass('/leads')\">\n                <a href=\"/leads\" data-autotest-section=\"leadsComputer\">\n                    <span class=\"fi fi-leads\"></span>\n                    <span>Leads</span>\n                </a>\n            </li>\n            <li [ngClass]=\"getClass('/jobs')\">\n                <a href=\"/jobs\" data-autotest-section=\"jobsComputer\">\n                    <span class=\"fi fi-jobs\"></span>\n                    <span>Jobs</span>\n                </a>\n            </li>\n\n            <li [ngClass]=\"getClass('/calendar')\">\n                <a href=\"/calendar\" data-autotest-section=\"calendarComputer\">\n                    <span class=\"fi fi-calendar\"></span>\n                    <span>Calendar</span>\n                </a>\n            </li>\n            <li [ngClass]=\"getClass('/payments')\">\n                <a href=\"/payments\" data-autotest-section=\"paymentsComputer\">\n                    <span class=\"fi fi-total-invoiced\"></span>\n                    <span>Payments</span>\n                </a>\n            </li>\n            <li [ngClass]=\"getClass('/settings')\">\n                <a href=\"/settings\" data-autotest-section=\"settingsComputer\">\n                    <span class=\"fi fi-settings\"></span>\n                    <span>Settings</span>\n                </a>\n            </li>\n        </ul>\n    </div>\n\n    <div class=\"col-md-4 pr-0 position-static\">\n        <div *ngIf=\"showLogo && user && brands\" class=\"nav sn-header__menu position-static web-menu-box\">\n            <div class=\"sn-header__menu__item dropdown position-static\">\n                <user-menu [brands]=\"brands\" (emitSwitchBrand)=\"handleSwitchBrandSpinner($event)\" [user]=\"user\"></user-menu>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"switch-brand-overlay\" *ngIf=\"isSwitchBrandSpinnerActive\">\n        <div class=\"spinner-holder\" spinning-wheel [is-spinning-wheel-active]=\"isSwitchBrandSpinnerActive\" [is-spinning-wheel-dark]=\"'true'\">\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "./web/modern/components/navbar/user-navbar/user-navbar.component.scss":
/***/ (function(module, exports) {

module.exports = "section {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n  -webkit-justify-content: space-between;\n      -ms-flex-pack: justify;\n          justify-content: space-between; }\n\n.position-static {\n  position: static; }\n\n.web-menu-box {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n  -webkit-justify-content: flex-end;\n      -ms-flex-pack: end;\n          justify-content: flex-end; }\n\n.switch-brand-overlay {\n  position: absolute;\n  width: 100%;\n  height: 100vh;\n  top: 0;\n  left: 0;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  background: #000000;\n  opacity: 0.5; }\n\n.spinner-holder {\n  width: 100px;\n  height: 100px; }\n"

/***/ }),

/***/ "./web/modern/components/navbar/user-navbar/user-navbar.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var account_service_1 = __webpack_require__("./web/modern/services/user/account.service.ts");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var rxjs_1 = __webpack_require__("./node_modules/rxjs/Rx.js");
var brands_data_service_1 = __webpack_require__("./shared/services/brands/brands.data.service.ts");
var UserNavbarComponent = function () {
    function UserNavbarComponent(accountService, brandsDataService) {
        _classCallCheck(this, UserNavbarComponent);

        this.accountService = accountService;
        this.brandsDataService = brandsDataService;
        this.showLogo = false;
        this.isSwitchBrandSpinnerActive = false;
        this.unsubscribe = new rxjs_1.Subject();
    }

    _createClass(UserNavbarComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.getUser();
            this.trackLogoState();
            this.getBrandsInfo();
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "logout",
        value: function logout() {
            this.accountService.logoutWeb();
        }
    }, {
        key: "handleSwitchBrandSpinner",
        value: function handleSwitchBrandSpinner(event) {
            this.isSwitchBrandSpinnerActive = event;
            event ? document.body.classList.add('disable-scroll') : document.body.classList.remove('disable-scroll');
        }
    }, {
        key: "getClass",
        value: function getClass(path) {
            var locationPath = location.pathname;
            if (locationPath.includes('/invoices')) {
                locationPath = '/payments';
            }
            if (path === '/') {
                if (locationPath.substring(0, location.protocol.length + location.host.length) === path) {
                    return 'selected-menu';
                }
                return 'not-selected-menu';
            }
            if (locationPath.includes(path)) {
                return 'selected-menu';
            }
            return 'not-selected-menu';
        }
    }, {
        key: "getUser",
        value: function getUser() {
            var _this = this;

            this.accountService.userDataObservable.pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (user) {
                _this.user = user;
            });
        }
    }, {
        key: "trackLogoState",
        value: function trackLogoState() {
            var _this2 = this;

            this.accountService.showHeaderObservable.pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (state) {
                return _this2.showLogo = state;
            });
        }
    }, {
        key: "getBrandsInfo",
        value: function getBrandsInfo() {
            var _this3 = this;

            this.brandsDataService.brandsData.pipe(operators_1.takeUntil(this.unsubscribe), operators_1.filter(function (data) {
                return data !== null;
            })).subscribe(function (data) {
                _this3.brands = data;
            });
        }
    }]);

    return UserNavbarComponent;
}();
UserNavbarComponent = __decorate([core_1.Component({
    selector: 'user-navbar',
    template: __webpack_require__("./web/modern/components/navbar/user-navbar/user-navbar.component.html"),
    styles: [__webpack_require__("./web/modern/components/navbar/user-navbar/user-navbar.component.scss")]
}), __metadata("design:paramtypes", [account_service_1.AccountServiceWebProvider, brands_data_service_1.BrandsDataServiceProvider])], UserNavbarComponent);
exports.UserNavbarComponent = UserNavbarComponent;

/***/ }),

/***/ "./web/modern/components/notification-bar/notification-bar.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"banner\" class=\"main-block\" *ngIf=\"systemNotificationsData\" [ngClass]=\"{'hideBar': !isShowNotificationBar}\">\n    <carousel class=\"not-print\" [ngClass]=\"{'hideBar': !isShowNotificationBar}\">\n        <slide class=\"text-center py-5 text-white\" *ngFor=\"let data of systemNotificationsData; let i = index\" [ngClass]=\"{'hideBar': !isShowNotificationBar}\">\n            <div class=\"slide-div\" *ngIf=\"systemNotificationsData[i]\" [ngStyle]=\"{'background': systemNotificationsData[i].properties?.bgHexColor}\">\n                <div class=\"slide-text\" *ngIf=\"systemNotificationsData[i].messageHTML\" [innerHTML]=\"systemNotificationsData[i].messageHTML | safeHtml\"></div>\n                <div class=\"button-div\" *ngIf=\"systemNotificationsData[i].actionButton\">\n                    <button (click)=\"reactToButtonClick(systemNotificationsData[i].actionButton, systemNotificationsData[i].eventID)\"\n                            [ngStyle]=\"{'background': systemNotificationsData[i].actionButton?.action.buttonProperties?.backgroundHexColor, 'color': systemNotificationsData[i].actionButton?.action?.buttonProperties?.textHexColor}\"\n                            class=\"btn actions-button webView\">\n                        <i *ngIf=\"systemNotificationsData[i].actionButton?.action?.buttonProperties?.buttonIcon\"\n                           class=\"fi {{systemNotificationsData[i].actionButton?.action?.buttonProperties?.buttonIcon}}\">\n                        </i>\n                        <span>{{ systemNotificationsData[i].actionButton?.action?.actionName }}</span>\n                    </button>\n                    <button\n                            (click)=\"reactToButtonClick(systemNotificationsData[i].actionButton, systemNotificationsData[i].eventID)\"\n                            [ngStyle]=\"{'background': systemNotificationsData[i].actionButton?.action.buttonProperties?.backgroundHexColor, 'color': systemNotificationsData[i].actionButton?.action?.buttonProperties?.textHexColor}\"\n                            class=\"btn mobile-actions-button mobileView\">\n                        <i *ngIf=\"systemNotificationsData[i].actionButton?.action?.buttonProperties?.buttonIcon\"\n                           class=\"fi {{systemNotificationsData[i].actionButton?.action?.buttonProperties?.buttonIcon}}\">\n                        </i>\n                    </button>\n                </div>\n            </div>\n        </slide>\n    </carousel>\n</div>\n"

/***/ }),

/***/ "./web/modern/components/notification-bar/notification-bar.scss":
/***/ (function(module, exports) {

module.exports = ".hideBar {\n  opacity: 0 !important;\n  height: 0 !important; }\n\n.main-block {\n  height: 50px;\n  width: 100%;\n  opacity: 1;\n  -webkit-transition: opacity 0.7s ease-in 0.7s, height 0.7s ease;\n  transition: opacity 0.7s ease-in 0.7s, height 0.7s ease; }\n  .main-block carousel {\n    opacity: 1;\n    -webkit-transition: opacity 0.7s ease-in 0.7s, height 0.7s ease;\n    transition: opacity 0.7s ease-in 0.7s, height 0.7s ease;\n    background: #00897b;\n    height: 50px;\n    color: white;\n    width: 100%;\n    text-align: center; }\n    .main-block carousel ::ng-deep .carousel-control-prev {\n      display: none !important; }\n    .main-block carousel ::ng-deep .carousel-control-next {\n      display: none !important; }\n    .main-block carousel slide {\n      height: 50px;\n      opacity: 1;\n      -webkit-transition: opacity 0.7s ease-in 0.7s, height 0.7s ease;\n      transition: opacity 0.7s ease-in 0.7s, height 0.7s ease; }\n      @media screen and (max-width: 599px) {\n        .main-block carousel slide {\n          height: 70px; } }\n      .main-block carousel slide .slide-div {\n        -webkit-box-pack: center;\n        -webkit-justify-content: center;\n            -ms-flex-pack: center;\n                justify-content: center;\n        height: 50px;\n        width: 100%;\n        display: -webkit-box;\n        display: -webkit-flex;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n        -webkit-align-items: center;\n            -ms-flex-align: center;\n                align-items: center;\n        padding-right: 6%;\n        padding-left: 6%; }\n        .main-block carousel slide .slide-div .slide-text {\n          display: -webkit-box;\n          display: -webkit-flex;\n          display: -ms-flexbox;\n          display: flex;\n          -webkit-flex-wrap: wrap;\n              -ms-flex-wrap: wrap;\n                  flex-wrap: wrap;\n          max-width: 90%;\n          font-size: 14px; }\n          @media screen and (max-width: 767px) {\n            .main-block carousel slide .slide-div .slide-text {\n              font-size: 11px; } }\n        .main-block carousel slide .slide-div .button-div {\n          -webkit-flex-wrap: nowrap;\n              -ms-flex-wrap: nowrap;\n                  flex-wrap: nowrap;\n          text-wrap: none; }\n        .main-block carousel slide .slide-div .btn:hover {\n          color: white !important; }\n        .main-block carousel slide .slide-div .actions-button {\n          height: 30px;\n          border: 1px solid #ffffff;\n          border-radius: 15px;\n          margin-left: 10px;\n          margin-bottom: 0;\n          padding: 0 14px 0 14px;\n          font-weight: 600; }\n          .main-block carousel slide .slide-div .actions-button .fi {\n            color: white;\n            font-size: 10px;\n            padding-right: 6px; }\n        .main-block carousel slide .slide-div .mobile-actions-button {\n          text-align: left;\n          height: 20px;\n          margin-bottom: 0;\n          padding-right: 15px;\n          padding-bottom: 50px;\n          font-weight: 600; }\n          .main-block carousel slide .slide-div .mobile-actions-button .fi {\n            color: white;\n            font-size: 10px; }\n        @media screen and (max-width: 599px) {\n          .main-block carousel slide .slide-div {\n            height: 70px;\n            padding: 0 1% 0 1%; }\n            .main-block carousel slide .slide-div .btn {\n              padding: 0 0 50px 5px; }\n            .main-block carousel slide .slide-div .slide-text {\n              max-width: 94%; }\n            .main-block carousel slide .slide-div .button-div {\n              min-width: 6%; }\n            .main-block carousel slide .slide-div .fi-cross {\n              font-size: 12px !important; }\n            .main-block carousel slide .slide-div .fi-spinner {\n              font-size: 14px !important; }\n            .main-block carousel slide .slide-div .mobileView {\n              display: block; }\n            .main-block carousel slide .slide-div .webView {\n              display: none; } }\n        @media screen and (min-width: 600px) {\n          .main-block carousel slide .slide-div .mobileView {\n            display: none; }\n          .main-block carousel slide .slide-div .webView {\n            display: block; } }\n"

/***/ }),

/***/ "./web/modern/components/notification-bar/notification-bar.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var carousel_1 = __webpack_require__("./node_modules/ngx-bootstrap/carousel/fesm5/ngx-bootstrap-carousel.js");
var system_notifications_service_1 = __webpack_require__("./shared/services/system-notifications/system-notifications.service.ts");
var NotificationBarComponent = function () {
    function NotificationBarComponent(systemNotificationsService) {
        var _this = this;

        _classCallCheck(this, NotificationBarComponent);

        this.systemNotificationsService = systemNotificationsService;
        this.systemNotificationsData = null;
        this.actionList = [];
        this.isShowNotificationBar = false;
        this.systemNotificationsService.systemNotificationChanged.subscribe(function (data) {
            _this.updateSystemNotificationData(data);
        });
    }

    _createClass(NotificationBarComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.getSystemNotificationData();
        }
    }, {
        key: "reactToButtonClick",
        value: function reactToButtonClick(action, eventId) {
            if (action.type === 'ONE_TIME') {
                this.isShowNotificationBar = false;
                this.sendSystemNotificationRequest('ONE_TIME', eventId);
            } else if (action.type === 'PAGE_RELOAD') {
                this.sendSystemNotificationRequest('PAGE_RELOAD', eventId);
            }
        }
    }, {
        key: "sendSystemNotificationRequest",
        value: function sendSystemNotificationRequest(actionName, eventId) {
            var _this2 = this;

            this.systemNotificationsService.sendSystemNotificationsId(eventId).subscribe(function () {
                if (actionName === 'ONE_TIME') {
                    _this2.getSystemNotificationData();
                } else if (actionName === 'PAGE_RELOAD') {
                    window.location.reload();
                }
            });
        }
    }, {
        key: "localTimeWithOffset",
        value: function localTimeWithOffset() {
            return Math.round(Date.now() / 1000) + this.timeDifference;
        }
    }, {
        key: "isRelevant",
        value: function isRelevant(fromEpochSeconds, toEpochSeconds, localTime) {
            if (fromEpochSeconds !== null && toEpochSeconds !== null) {
                return fromEpochSeconds <= localTime && localTime < toEpochSeconds;
            }
            if (fromEpochSeconds === null && toEpochSeconds !== null) {
                return localTime < toEpochSeconds;
            }
            if (fromEpochSeconds !== null && toEpochSeconds === null) {
                return fromEpochSeconds <= localTime;
            }
            return true;
        }
    }, {
        key: "maxTime",
        value: function maxTime(minTime, data) {
            var result = null;
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var time = _step.value;

                    if (time !== null && time > minTime && (result === null || result > time)) {
                        result = time;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return result;
        }
    }, {
        key: "renderBannerEvents",
        value: function renderBannerEvents() {
            var _this3 = this;

            if (this.timeoutID !== null) {
                clearTimeout(this.timeoutID);
                this.timeoutID = null;
            }
            this.systemNotificationsData = null;
            if (this.serverEvents && this.serverEvents.length) {
                var localTime = this.localTimeWithOffset();
                var minTime = null;
                this.systemNotificationsData = this.serverEvents.reduce(function (total, next) {
                    minTime = _this3.maxTime(localTime, [next.validFromEpochSeconds, next.validTillEpochSeconds, minTime]);
                    if (_this3.isRelevant(next.validFromEpochSeconds, next.validTillEpochSeconds, localTime)) {
                        if (next.actions === null) {
                            total.push(next);
                        } else {
                            var _iteratorNormalCompletion2 = true;
                            var _didIteratorError2 = false;
                            var _iteratorError2 = undefined;

                            try {
                                for (var _iterator2 = _this3.systemNotificationsService.createActionList(next.actions)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                    var actionName = _step2.value;

                                    var actionMethod = next.actions[actionName].method;
                                    if ((actionName === 'ONE_TIME' || actionName === 'PAGE_RELOAD') && actionMethod === 'MANUAL') {
                                        next.actionButton = {
                                            type: actionName,
                                            action: next.actions[actionName]
                                        };
                                        total.push(next);
                                    }
                                }
                            } catch (err) {
                                _didIteratorError2 = true;
                                _iteratorError2 = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                        _iterator2.return();
                                    }
                                } finally {
                                    if (_didIteratorError2) {
                                        throw _iteratorError2;
                                    }
                                }
                            }
                        }
                    }
                    return total;
                }, []);
                if (minTime !== null) {
                    this.timeoutID = setTimeout(function () {
                        return _this3.renderBannerEvents();
                    }, (minTime - this.localTimeWithOffset()) * 1000 + 100);
                }
            }
            if (this.systemNotificationsData !== null && this.systemNotificationsData.length > 0) {
                this.isShowNotificationBar = true;
                this.headerFantomBlock.classList.add('show-header-fantom-block');
                this.mobileHeaderFantomBlock.classList.add('mobile-banner-indentations');
            } else {
                this.isShowNotificationBar = false;
                this.headerFantomBlock.classList.remove('show-header-fantom-block');
                this.mobileHeaderFantomBlock.classList.remove('mobile-banner-indentations');
            }
        }
    }, {
        key: "updateSystemNotificationData",
        value: function updateSystemNotificationData(data) {
            this.headerFantomBlock = document.querySelector('#header-fantom-block');
            this.mobileHeaderFantomBlock = document.querySelector('.mobile-banner-styles');
            this.systemNotificationsData = null;
            this.timeDifference = 0;
            if (data && data.events && data.events.length) {
                this.timeDifference = data.epochSeconds - Math.round(Date.now() / 1000);
                this.serverEvents = data.events;
                this.renderBannerEvents();
            } else {
                this.serverEvents = null;
                this.renderBannerEvents();
            }
        }
    }, {
        key: "getSystemNotificationData",
        value: function getSystemNotificationData() {
            var _this4 = this;

            this.systemNotificationsService.fetchSystemNotificationsData().subscribe(function (data) {
                _this4.updateSystemNotificationData(data);
            });
        }
    }]);

    return NotificationBarComponent;
}();
NotificationBarComponent = __decorate([core_1.Component({
    selector: 'notification-bar',
    template: __webpack_require__("./web/modern/components/notification-bar/notification-bar.html"),
    styles: [__webpack_require__("./web/modern/components/notification-bar/notification-bar.scss")],
    providers: [{
        provide: carousel_1.CarouselConfig,
        useValue: { interval: 30000, noPause: false, showIndicators: false }
    }]
}), __metadata("design:paramtypes", [system_notifications_service_1.SystemNotificationsServiceDataProvider])], NotificationBarComponent);
exports.NotificationBarComponent = NotificationBarComponent;

/***/ }),

/***/ "./web/modern/components/packages-product/discount-block/discount-block.component.html":
/***/ (function(module, exports) {

module.exports = "<h3 class=\"mb-15 mt-30\">Discounts</h3>\n<div class=\"row\">\n    <div class=\"col-md-8 col-lg-9 col-sm-12\">\n        <p class=\"f-s-14 text-normal mt-5\">\n            Create a list of discounts that you may apply regularly to quotes and invoices, such as gift vouchers.\n        </p>\n    </div>\n    <div class=\"col-md-4 col-lg-3 col-sm-12\">\n        <div class=\"text-md-right text-xs-left\">\n            <button class=\"btn btn-success btn-add-new m-0 pr-15 pl-15 w-200\" (click)=\"openAddNewDiscountModal()\">\n                Add New Discount\n            </button>\n        </div>\n    </div>\n</div>\n\n<div class=\"mt-30\">\n    <div class=\"stats__placeholder mb-30\"\n         *ngIf=\"discounts.length === 0\"\n    >\n        <span>Everyone loves a discount. Let’s get started!</span>\n    </div>\n    <div *ngIf=\"discounts.length !== 0\">\n        <div class=\"table-responsive table-product-package-responsive\">\n            <table class=\"table table-product-package m-0\">\n                <thead class=\"invoice-thead\">\n                <tr>\n                    <th>\n                        <b class=\"pointer\" (click)=\"isFilterAllowed('name') && orderByField('name')\">\n                            Name\n                            <span class=\"fa\"\n                                  [ngClass]=\"pageRequest.sortCriterias[0].sortAscending ? 'fa-caret-up' : 'fa-caret-down'\"\n                                  *ngIf=\"pageRequest.sortCriterias[0].fieldName === 'name' && isFilterAllowed('name')\"\n                            >\n                        </span>\n                        </b>\n                    </th>\n                    <th>\n                        <b class=\"pointer\" (click)=\"isFilterAllowed('price') && orderByField('price')\">Amount\n                            <span class=\"fa\"\n                                  [ngClass]=\"pageRequest.sortCriterias[0].sortAscending ? 'fa-caret-up' : 'fa-caret-down'\"\n                                  *ngIf=\"pageRequest.sortCriterias[0].fieldName === 'price' && isFilterAllowed('price')\"></span>\n                        </b>\n                    </th>\n                    <th></th>\n                </tr>\n                </thead>\n                <tbody>\n                <tr *ngFor=\"let discount of discounts;\">\n                    <td class=\"text-overflow text-nowrap\">{{ discount.name }}</td>\n                    <td class=\"text-overflow text-nowrap\">{{ discount.priceWithCurrency.amountWithCurrency }}</td>\n                    <td class=\"text-right\">\n                        <button (click)=\"openEditDiscountModal(discount)\" class=\"btn btn-default m-0 mr-5\"><i class=\"fi fi-edit\"></i> Edit</button>\n                        <button class=\"btn btn-default m-0 mr-5\" (click)=\"openDuplicateDiscountModal(discount)\"><i class=\"fi fi-duplicate\"></i> Duplicate</button>\n                        <button (click)=\"openDeleteDiscountModal(discount)\" class=\"btn btn-delete btn-delete-empty mb-0\"></button>\n                    </td>\n                </tr>\n                </tbody>\n            </table>\n        </div>\n        <sn-pagination [pageRequest]=\"pageRequest\" [totalItems]=\"itemsQuantity\" [pageNumbers]=\"pageNumbers\" (renew)=\"updateDiscountData($event)\"></sn-pagination>\n    </div>\n</div>\n\n\n\n"

/***/ }),

/***/ "./web/modern/components/packages-product/discount-block/discount-block.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var product_packages_data_service_1 = __webpack_require__("./shared/services/settings/product-packages.data.service.ts");
var pagination_service_1 = __webpack_require__("./shared/services/pagination/pagination.service.ts");
var delete_item_modal_1 = __webpack_require__("./web/modern/components/settings/common/delete-item-modal/delete-item-modal.ts");
var update_discount_modal_component_1 = __webpack_require__("./web/modern/components/packages-product/modals/update-discount-modal/update-discount-modal.component.ts");
var DiscountBlockComponent = function () {
    function DiscountBlockComponent(productPackagesService, messageService, paginationService, modalService) {
        _classCallCheck(this, DiscountBlockComponent);

        this.productPackagesService = productPackagesService;
        this.messageService = messageService;
        this.paginationService = paginationService;
        this.modalService = modalService;
        this.discounts = [];
        this.DISCOUNTS_REQUEST_DEFAULT = {
            filterBy: 'gifts',
            paging: {
                pageNumber: 0,
                pageSize: 50,
                searchToken: null
            },
            sortCriterias: [{
                fieldName: 'name',
                sortAscending: true
            }]
        };
        this.DISCOUNTS_DEFAULT = {
            name: '',
            taxType: 'NO_TAX',
            type: 'GIFT',
            description: '<p>Discount</p>'
        };
        this.MODAL_TITLES = ['Add New', 'Duplicate', 'Edit'];
    }

    _createClass(DiscountBlockComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.applyPageDiscountFromLocalStorage();
            this.getDiscountsData();
        }
    }, {
        key: "updateDiscountData",
        value: function updateDiscountData(pageRequest) {
            this.pageRequest = pageRequest;
            this.getDiscountsData();
        }
    }, {
        key: "isFilterAllowed",
        value: function isFilterAllowed(filterName) {
            if (!this.allowedFilters) {
                return false;
            }
            return this.allowedFilters.includes(filterName);
        }
    }, {
        key: "orderByField",
        value: function orderByField(filter) {
            if (this.pageRequest.sortCriterias[0].fieldName === filter) {
                this.pageRequest.sortCriterias[0].sortAscending = !this.pageRequest.sortCriterias[0].sortAscending;
            } else {
                this.pageRequest.sortCriterias[0].fieldName = filter;
                this.pageRequest.sortCriterias[0].sortAscending = false;
            }
            this.pageRequest.paging.pageNumber = 0;
            this.getDiscountsData();
        }
    }, {
        key: "openAddNewDiscountModal",
        value: function openAddNewDiscountModal() {
            this.selectedDiscountModalRef = this.modalService.openModal(update_discount_modal_component_1.UpdateDiscountModal);
            this.getModalDataForModals();
            this.selectedDiscountModalRef.componentInstance.modalAction = this.MODAL_TITLES[0];
            this.selectedDiscountModalRef.componentInstance.modalData = JSON.parse(JSON.stringify(this.DISCOUNTS_DEFAULT));
            this.selectedDiscountModalRef.componentInstance.btnDisabled = false;
        }
    }, {
        key: "openEditDiscountModal",
        value: function openEditDiscountModal(discountItem) {
            this.selectedDiscountModalRef = this.modalService.openModal(update_discount_modal_component_1.UpdateDiscountModal);
            this.getModalDataForModals();
            this.selectedDiscountModalRef.componentInstance.modalAction = this.MODAL_TITLES[2];
            this.selectedDiscountModalRef.componentInstance.modalData = JSON.parse(JSON.stringify(discountItem));
            this.selectedDiscountModalRef.componentInstance.btnDisabled = false;
        }
    }, {
        key: "openDuplicateDiscountModal",
        value: function openDuplicateDiscountModal(discountItem) {
            this.selectedDiscountModalRef = this.modalService.openModal(update_discount_modal_component_1.UpdateDiscountModal);
            this.getModalDataForModals();
            this.selectedDiscountModalRef.componentInstance.modalAction = this.MODAL_TITLES[1];
            this.selectedDiscountModalRef.componentInstance.modalData = JSON.parse(JSON.stringify(discountItem));
            this.selectedDiscountModalRef.componentInstance.btnDisabled = false;
        }
    }, {
        key: "openDeleteDiscountModal",
        value: function openDeleteDiscountModal(discountItem) {
            this.selectedDiscountModalRef = this.modalService.openModal(delete_item_modal_1.DeleteItemModalComponent);
            this.getModalDataForModals();
            this.selectedDiscountModalRef.componentInstance.modalTitle = 'Discount';
            this.selectedDiscountModalRef.componentInstance.btnDisabled = false;
            this.selectedDiscountModalRef.componentInstance.modalData = JSON.parse(JSON.stringify(discountItem));
            this.selectedDiscountModalRef.componentInstance.itemName = discountItem.name;
        }
    }, {
        key: "getModalDataForModals",
        value: function getModalDataForModals() {
            var _this = this;

            this.selectedDiscountModalRef.result.then(function () {
                return _this.modalDataSubscription.unsubscribe();
            }, function () {
                return _this.modalDataSubscription.unsubscribe();
            });
            this.modalDataSubscription = this.modalService.getModalData().filter(function (data) {
                return data && data.action && data.props;
            }).subscribe(function (data) {
                return _this.discountActions(data);
            });
        }
    }, {
        key: "modalErrorHandle",
        value: function modalErrorHandle(error) {
            this.selectedDiscountModalRef.componentInstance.btnDisabled = false;
            this.messageService.handleError(error);
        }
    }, {
        key: "discountActions",
        value: function discountActions(_ref) {
            var _this2 = this;

            var action = _ref.action,
                props = _ref.props;

            this.selectedDiscountModalRef.componentInstance.btnDisabled = true;
            switch (action) {
                case 'Add New':
                    this.addNewDiscount(props).subscribe(function (data) {
                        return _this2.messageService.showToaster('s_12', 'productsPackages', data.name);
                    }, function (error) {
                        return _this2.modalErrorHandle(error);
                    });
                    break;
                case 'Duplicate':
                    this.addNewDiscount(props).subscribe(function (data) {
                        return _this2.messageService.showToaster('s_14', 'productsPackages', data.name);
                    }, function (error) {
                        return _this2.modalErrorHandle(error);
                    });
                    break;
                case 'Edit':
                    this.updateDiscount(props).subscribe(function (data) {
                        if (props.updateLinked) {
                            _this2.messageService.showToaster('s_13', 'productsPackages', data.name);
                        } else {
                            _this2.messageService.showToaster('s_8', 'quoteInvoiceTemplates');
                        }
                    }, function (error) {
                        return _this2.modalErrorHandle(error);
                    });
                    break;
                case 'Delete':
                    this.deleteDiscount(props).subscribe(function () {
                        _this2.messageService.showToaster('s_11', 'productsPackages', props.name);
                    }, function (error) {
                        return _this2.modalErrorHandle(error);
                    });
                    break;
                default:
                    break;
            }
        }
    }, {
        key: "updateDiscount",
        value: function updateDiscount(dataToSend) {
            var _this3 = this;

            return this.productPackagesService.updatePackagesOrProducts(dataToSend.id, dataToSend).map(function (data) {
                return _this3.resetDiscountDataAfterAction(data);
            });
        }
    }, {
        key: "addNewDiscount",
        value: function addNewDiscount(dataToSend) {
            var _this4 = this;

            return this.productPackagesService.createPackagesOrProducts(dataToSend).map(function (data) {
                return _this4.resetDiscountDataAfterAction(data);
            });
        }
    }, {
        key: "deleteDiscount",
        value: function deleteDiscount(dataToSend) {
            var _this5 = this;

            return this.productPackagesService.deletePackagesOrProducts(dataToSend.id).map(function (data) {
                return _this5.resetDiscountDataAfterAction(data);
            });
        }
    }, {
        key: "resetDiscountDataAfterAction",
        value: function resetDiscountDataAfterAction(data) {
            this.pageRequest.paging.searchToken = null;
            this.pageRequest.paging.pageNumber = 0;
            this.getDiscountsData();
            this.modalDataSubscription.unsubscribe();
            this.selectedDiscountModalRef.componentInstance.btnDisabled = false;
            this.selectedDiscountModalRef.close();
            return data;
        }
    }, {
        key: "getDiscountsData",
        value: function getDiscountsData() {
            var _this6 = this;

            this.productPackagesService.getPackagesOrProducts(this.pageRequest).subscribe(function (data) {
                return _this6.successGetDiscountsData(data);
            });
        }
    }, {
        key: "successGetDiscountsData",
        value: function successGetDiscountsData(data) {
            this.discounts = data.items;
            this.itemsQuantity = data ? data.totalSize : 0;
            this.pageNumbers = this.paginationService.calculatePageNumbers(this.itemsQuantity, this.pageRequest.paging.pageSize);
            this.pageRequest.paging.searchToken = data.searchToken;
            this.allowedFilters = data.sortingFields;
            this.setPageDiscountToLocalStorage(this.pageRequest);
        }
        // LOCAL STORAGE

    }, {
        key: "applyPageDiscountFromLocalStorage",
        value: function applyPageDiscountFromLocalStorage() {
            var pageRequestObject = JSON.parse(localStorage.getItem("settingsDiscountsRequest_" + this.companyId));
            this.pageRequest = this.DISCOUNTS_REQUEST_DEFAULT;
            if (pageRequestObject && pageRequestObject !== '') {
                var pageSize = pageRequestObject.pageSize,
                    fieldName = pageRequestObject.fieldName,
                    sortAscending = pageRequestObject.sortAscending;

                this.pageRequest.paging.pageSize = pageSize;
                this.pageRequest.sortCriterias[0].fieldName = fieldName;
                this.pageRequest.sortCriterias[0].sortAscending = sortAscending;
            }
        }
    }, {
        key: "setPageDiscountToLocalStorage",
        value: function setPageDiscountToLocalStorage(pageRequest) {
            var pageRequestObject = {
                pageSize: pageRequest.paging.pageSize,
                fieldName: pageRequest.sortCriterias[0].fieldName,
                sortAscending: pageRequest.sortCriterias[0].sortAscending
            };
            var pageRequestString = JSON.stringify(pageRequestObject);
            localStorage.removeItem("settingsDiscountsRequest_" + this.companyId);
            localStorage.setItem("settingsDiscountsRequest_" + this.companyId, pageRequestString);
        }
    }]);

    return DiscountBlockComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Number)], DiscountBlockComponent.prototype, "companyId", void 0);
DiscountBlockComponent = __decorate([core_1.Component({
    selector: 'discount-block',
    template: __webpack_require__("./web/modern/components/packages-product/discount-block/discount-block.component.html")
}), __metadata("design:paramtypes", [product_packages_data_service_1.ProductPackagesDataServiceProvider, message_service_1.MessageService, pagination_service_1.PaginationService, snModal_service_1.SNModalService])], DiscountBlockComponent);
exports.DiscountBlockComponent = DiscountBlockComponent;

/***/ }),

/***/ "./web/modern/components/packages-product/modals/update-discount-modal/update-discount-modal.component.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n    <button class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" (click)=\"onDismiss()\">&times;</button>\n    <h3 class=\"modal-title f-w-n\">{{ modalAction }} Discount</h3>\n</div>\n<div class=\"modal-body\" style=\"padding: 30px 20px!important;\">\n    <form class=\"form-horizontal\" role=\"form\" (submit)=\"onSubmit()\">\n        <div class=\"mb-20\">\n            <h4 class=\"f-w-n mt-0\">Name</h4>\n            <input type=\"text\" maxlength=\"100\" class=\"form-control flex-row\" name=\"name\" [(ngModel)]=\"modalData.name\" required>\n        </div>\n        <div>\n            <h4 class=\"f-w-n\">Price</h4>\n            <input type=\"text\" class=\"form-control flex-row\"\n                   [textMask]=\"{mask: numberMask}\"\n                   [(ngModel)]=\"modalData.price\"\n                   placeholder=\"-{{currencySymbol}}\"\n                   name=\"price\"\n                   required>\n        </div>\n        <div class=\"pt-25\">\n            <button type=\"submit\" class=\"btn btn-lg btn-success mb-0 mr-10\" spinning-wheel [is-spinning-wheel-active]=\"btnDisabled\" [disabled]=\"btnDisabled\">Save Discount</button>\n            <button type=\"button\" (click)=\"onDismiss()\" class=\"btn btn-lg btn-default mb-0\" data-dismiss=\"modal\">Cancel</button>\n        </div>\n    </form>\n</div>"

/***/ }),

/***/ "./web/modern/components/packages-product/modals/update-discount-modal/update-discount-modal.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var ng_bootstrap_1 = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/index.js");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var textMaskAddons_1 = __webpack_require__("./node_modules/text-mask-addons/dist/textMaskAddons.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var productPackage_service_1 = __webpack_require__("./web/modern/services/settings/productPackage.service.ts");
var confirm_general_modal_component_1 = __webpack_require__("./web/modern/components/common/confirm-general-modal/confirm-general-modal.component.ts");
var UpdateDiscountModal = function () {
    function UpdateDiscountModal(activeModal, modalService, productPackageService, messageService) {
        _classCallCheck(this, UpdateDiscountModal);

        this.activeModal = activeModal;
        this.modalService = modalService;
        this.productPackageService = productPackageService;
        this.messageService = messageService;
    }

    _createClass(UpdateDiscountModal, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.currencySymbol = this.productPackageService.getCurrensySymbol();
            this.numberMask = textMaskAddons_1.createNumberMask({
                prefix: "-" + this.currencySymbol,
                suffix: '',
                allowDecimal: true,
                allowLeadingZeroes: true,
                allowNegative: false
            });
        }
    }, {
        key: "onSubmit",
        value: function onSubmit() {
            if (this.validateModalValue()) {
                if (this.itemIsLinked()) {
                    return;
                }
                var dataToEmit = this.prepareValueToEmit();
                this.modalService.setModalData(dataToEmit);
            }
        }
    }, {
        key: "validateModalValue",
        value: function validateModalValue() {
            var validated = true;
            var _modalData = this.modalData,
                name = _modalData.name,
                price = _modalData.price;

            name = name.trim();
            if (!name || name === '') {
                validated = false;
                this.messageService.showToaster('e_0', 'productsPackages', 'discount');
            } else if (!price || price === '') {
                validated = false;
                this.messageService.showToaster('e_2', 'productsPackages', 'discount');
            }
            return validated;
        }
    }, {
        key: "prepareValueToEmit",
        value: function prepareValueToEmit() {
            var updateLinked = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            var modalData = JSON.parse(JSON.stringify(this.modalData));
            modalData.price = this.convertAmountIntoNumber(modalData.price);
            modalData.name = modalData.name.trim();
            return {
                action: this.modalAction,
                props: Object.assign({}, modalData, { updateLinked: updateLinked })
            };
        }
    }, {
        key: "convertAmountIntoNumber",
        value: function convertAmountIntoNumber(value) {
            if (isNaN(value)) {
                var regExp = new RegExp("[" + this.currencySymbol + ",]", 'g');
                var a = value.replace(regExp, '');
                return +a;
            }
            return +value;
        }
    }, {
        key: "onDismiss",
        value: function onDismiss() {
            this.activeModal.dismiss();
        }
    }, {
        key: "itemIsLinked",
        value: function itemIsLinked() {
            var _this = this;

            if (this.modalAction.indexOf('Duplicate') > -1) {
                return false;
            }
            if (this.modalData.linkedToInvoiceSampleProduct || this.modalData.linkedToQuoteSampleProduct) {
                this.confirmItemEdit().then(function (updateLinked) {
                    var dataToEmit = _this.prepareValueToEmit(updateLinked);
                    _this.modalService.setModalData(dataToEmit);
                });
                return true;
            }
            return false;
        }
    }, {
        key: "confirmItemEdit",
        value: function confirmItemEdit() {
            var _this2 = this;

            return new Promise(function (resolve) {
                var modal = _this2.modalService.openModal(confirm_general_modal_component_1.ConfirmGeneralModalComponent);
                modal.componentInstance.text = 'This discount is linked to a quote or invoice template. Do you wish to apply saved changes to the linked template?';
                modal.componentInstance.columnButtons = true;
                modal.componentInstance.buttons = [{
                    text: 'Yes, Save Discount & Update Template',
                    color: 'success',
                    size: 'lg',
                    action: 'CONFIRM'
                }, {
                    text: 'No, Save Discount & Don’t Update Template',
                    color: 'default',
                    size: 'lg',
                    action: 'NOT_UPDATE'
                }, {
                    text: 'Cancel & Don’t Save',
                    color: 'default',
                    size: 'lg',
                    action: 'DISCARD'
                }];
                modal.result.then(function (action) {
                    if (action === 'CONFIRM') {
                        resolve(true);
                    } else if (action === 'NOT_UPDATE') {
                        resolve(false);
                    }
                });
            });
        }
    }]);

    return UpdateDiscountModal;
}();
__decorate([core_1.Input(), __metadata("design:type", String)], UpdateDiscountModal.prototype, "modalAction", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], UpdateDiscountModal.prototype, "modalData", void 0);
__decorate([core_1.Input(), __metadata("design:type", Boolean)], UpdateDiscountModal.prototype, "btnDisabled", void 0);
UpdateDiscountModal = __decorate([core_1.Component({
    selector: 'update-discount-modal',
    template: __webpack_require__("./web/modern/components/packages-product/modals/update-discount-modal/update-discount-modal.component.html"),
    changeDetection: core_1.ChangeDetectionStrategy.OnPush
}), __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal, snModal_service_1.SNModalService, productPackage_service_1.ProductPackageService, message_service_1.MessageService])], UpdateDiscountModal);
exports.UpdateDiscountModal = UpdateDiscountModal;

/***/ }),

/***/ "./web/modern/components/packages-product/modals/update-package-product-modal/update-package-product-modal.component.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n    <button class=\"close\" (click)=\"onDismiss()\">&times;</button>\n    <h3 class=\"modal-title f-w-n\">{{ modalTitle }}</h3>\n</div>\n<div class=\"modal-body\" style=\"padding: 20px!important;\" >\n    <form class=\"form-horizontal\" role=\"form\" (submit)=\"onSubmit()\">\n        <div class=\"mb-20\">\n            <h4 class=\"f-w-n\">Name</h4>\n            <input type=\"text\" maxlength=\"100\" class=\"form-control flex-row\" name=\"name\" [(ngModel)]=\"modalData.name\" required>\n        </div>\n        <div class=\"mb-20\">\n            <h4 class=\"f-w-n\">Description</h4>\n            <sn-quill-editor-web #editor\n                    (onTextChange)=\"modalData.description = $event\"\n                    [initValue]=\"modalData.description\"\n                    [maxLength]=\"descriptionMaxLength\"\n                    [placeholder]=\"'Type description here...'\"\n                    [varsList]=\"'PICK_AND_CHOOSE_MENU'\"\n                    [toolbarSettings]=\"'counter color size font variables image'\"\n            ></sn-quill-editor-web>\n        </div>\n        <div class=\"mb-20\">\n            <h4 class=\"f-w-n\">Price</h4>\n            <input type=\"text\" class=\"form-control flex-row\"\n                   [textMask]=\"{mask: numberMask}\"\n                   [(ngModel)]=\"modalData.price\"\n                   placeholder=\"{{currensySymbol}}\"\n                   name=\"price\"\n                   required>\n        </div>\n        <div>\n            <h4 class=\"f-w-n\">Tax</h4>\n            <div class=\"select-style\">\n                <select [(ngModel)]=\"modalData.taxType\" name=\"taxType\" class=\"form-control\" required>\n                    <option [value]=\"'INCLUDED'\">Includes tax</option>\n                    <option [value]=\"'EXCLUDED'\">Excludes tax</option>\n                    <option [value]=\"'NO_TAX'\">No tax</option>\n                </select>\n            </div>\n        </div>\n        <div class=\"pt-30 pb-10\">\n            <button type=\"submit\" class=\"btn btn-lg btn-success btn-success m-0 mr-10\" spinning-wheel [is-spinning-wheel-active]=\"btnDisabled\" [disabled]=\"btnDisabled\">Save {{ name }}</button>\n            <button type=\"button\" class=\"btn btn-lg btn-default m-0\" (click)=\"onDismiss()\" data-dismiss=\"modal\">Cancel</button>\n        </div>\n    </form>\n</div>"

/***/ }),

/***/ "./web/modern/components/packages-product/modals/update-package-product-modal/update-package-product-modal.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var textMaskAddons_1 = __webpack_require__("./node_modules/text-mask-addons/dist/textMaskAddons.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var ng_bootstrap_1 = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/index.js");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var productPackage_service_1 = __webpack_require__("./web/modern/services/settings/productPackage.service.ts");
var validation_service_1 = __webpack_require__("./shared/services/helpers/validation.service.ts");
var confirm_general_modal_component_1 = __webpack_require__("./web/modern/components/common/confirm-general-modal/confirm-general-modal.component.ts");
var UpdatePackageProductModalComponent = function () {
    function UpdatePackageProductModalComponent(productPackageService, messageService, modalService, validationService, activeModal) {
        _classCallCheck(this, UpdatePackageProductModalComponent);

        this.productPackageService = productPackageService;
        this.messageService = messageService;
        this.modalService = modalService;
        this.validationService = validationService;
        this.activeModal = activeModal;
        this.descriptionMaxLength = 4000;
    }

    _createClass(UpdatePackageProductModalComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.currensySymbol = this.productPackageService.getCurrensySymbol();
            this.numberMask = textMaskAddons_1.createNumberMask({
                prefix: this.currensySymbol,
                suffix: '',
                allowDecimal: true,
                allowLeadingZeroes: true,
                allowNegative: false
            });
        }
    }, {
        key: "prepareValueToValidate",
        value: function prepareValueToValidate() {
            var _JSON$parse = JSON.parse(JSON.stringify(this.modalData)),
                name = _JSON$parse.name,
                description = _JSON$parse.description,
                price = _JSON$parse.price,
                taxType = _JSON$parse.taxType,
                type = _JSON$parse.type;

            name = name.trim();
            if (description) {
                var _description = description.replace(/&nbsp;/g, '');
                description = _description.replace(/ /g, '');
            }
            return { name: name, description: description, price: price, taxType: taxType, type: type };
        }
    }, {
        key: "convertAmountIntoNumber",
        value: function convertAmountIntoNumber(value) {
            if (isNaN(value)) {
                var regExp = new RegExp("[" + this.currensySymbol + ",]", 'g');
                var a = value.replace(regExp, '');
                return +a;
            }
            return +value;
        }
    }, {
        key: "validateModalValue",
        value: function validateModalValue() {
            var validated = true;

            var _prepareValueToValida = this.prepareValueToValidate(),
                name = _prepareValueToValida.name,
                description = _prepareValueToValida.description,
                price = _prepareValueToValida.price,
                taxType = _prepareValueToValida.taxType;

            var invalidCounter = document.querySelector('.counter.red');
            var escapedDescription = description ? this.validationService.trimHTML(description).trim() : '';
            if (!name || name === '') {
                validated = false;
                this.messageService.showToaster('e_0', 'productsPackages', this.name.toLowerCase());
            } else if (!description || description.length === 0 || !escapedDescription) {
                validated = false;
                this.messageService.showToaster('e_3', 'productsPackages', this.name.toLowerCase());
            } else if (!price || price === '') {
                validated = false;
                this.messageService.showToaster('e_2', 'productsPackages', this.name.toLowerCase());
            } else if (!taxType || taxType === '') {
                validated = false;
                this.messageService.showToaster('e_1', 'productsPackages');
            } else if (invalidCounter) {
                validated = false;
                this.messageService.showToaster('e_6', 'productsPackages', this.descriptionMaxLength.toString());
            }
            return validated;
        }
    }, {
        key: "prepareValueToEmit",
        value: function prepareValueToEmit() {
            var updateLinked = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            this.modalData.price = this.convertAmountIntoNumber(this.modalData.price);
            this.modalData.name = this.modalData.name.trim();
            return {
                action: this.modalTitle,
                props: Object.assign({}, this.modalData, { updateLinked: updateLinked })
            };
        }
    }, {
        key: "onSubmit",
        value: function onSubmit() {
            if (this.validateModalValue()) {
                if (this.itemIsLinked()) {
                    return;
                }
                var modalDataToSend = this.prepareValueToEmit();
                this.modalService.setModalData(modalDataToSend);
            }
        }
    }, {
        key: "onDismiss",
        value: function onDismiss() {
            this.activeModal.dismiss();
        }
    }, {
        key: "itemIsLinked",
        value: function itemIsLinked() {
            var _this = this;

            if (this.modalTitle.indexOf('Duplicate') > -1) {
                return false;
            }
            if (this.modalData.linkedToInvoiceSampleProduct || this.modalData.linkedToQuoteSampleProduct) {
                this.confirmItemEdit().then(function (updateLinked) {
                    var modalDataToSend = _this.prepareValueToEmit(updateLinked);
                    _this.modalService.setModalData(modalDataToSend);
                });
                return true;
            }
            return false;
        }
    }, {
        key: "confirmItemEdit",
        value: function confirmItemEdit() {
            var _this2 = this;

            return new Promise(function (resolve) {
                var modal = _this2.modalService.openModal(confirm_general_modal_component_1.ConfirmGeneralModalComponent);
                modal.componentInstance.text = "This " + _this2.name.toLowerCase() + " is linked to a quote or invoice template. Do you wish to apply saved changes to the linked template?";
                modal.componentInstance.columnButtons = true;
                modal.componentInstance.buttons = [{
                    text: "Yes, Save " + _this2.name + " & Update Template",
                    color: 'success',
                    size: 'lg',
                    action: 'CONFIRM'
                }, {
                    text: "No, Save " + _this2.name + " & Don\u2019t Update Template",
                    color: 'default',
                    size: 'lg',
                    action: 'NOT_UPDATE'
                }, {
                    text: 'Cancel & Don’t Save',
                    color: 'default',
                    size: 'lg',
                    action: 'DISCARD'
                }];
                modal.result.then(function (action) {
                    if (action === 'CONFIRM') {
                        resolve(true);
                    } else if (action === 'NOT_UPDATE') {
                        resolve(false);
                    }
                });
            });
        }
    }]);

    return UpdatePackageProductModalComponent;
}();
__decorate([core_1.ViewChild('editor'), __metadata("design:type", Object)], UpdatePackageProductModalComponent.prototype, "editor", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], UpdatePackageProductModalComponent.prototype, "modalTitle", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], UpdatePackageProductModalComponent.prototype, "modalData", void 0);
__decorate([core_1.Input(), __metadata("design:type", Boolean)], UpdatePackageProductModalComponent.prototype, "btnDisabled", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], UpdatePackageProductModalComponent.prototype, "name", void 0);
UpdatePackageProductModalComponent = __decorate([core_1.Component({
    selector: 'update-package-product-modal',
    template: __webpack_require__("./web/modern/components/packages-product/modals/update-package-product-modal/update-package-product-modal.component.html")
}), __metadata("design:paramtypes", [productPackage_service_1.ProductPackageService, message_service_1.MessageService, snModal_service_1.SNModalService, validation_service_1.ValidationProvider, ng_bootstrap_1.NgbActiveModal])], UpdatePackageProductModalComponent);
exports.UpdatePackageProductModalComponent = UpdatePackageProductModalComponent;

/***/ }),

/***/ "./web/modern/components/packages-product/packages-block/packages-block.component.html":
/***/ (function(module, exports) {

module.exports = "<h3 class=\"mb-15 mt-30\">Packages</h3>\n<div class=\"row\">\n    <div class=\"col-md-8 col-lg-9 col-sm-12\">\n        <p class=\"f-s-14 text-normal mt-5\">\n            Create a list of different packages which your clients can choose from. When presented with your quote, your client can choose multiple different packages.\n        </p>\n    </div>\n    <div class=\"col-md-4 col-lg-3 col-sm-12\">\n        <div class=\"text-md-right text-xs-left\">\n            <button class=\"btn btn-success btn-add-new m-0 pr-15 pl-15 w-200 \" (click)=\"openAddNewPackageModal()\">\n                Add New Package\n            </button>\n        </div>\n    </div>\n</div>\n\n<div class=\"mt-30 bottom-bordered\">\n    <div class=\"stats__placeholder mb-30\" *ngIf=\"packages.length === 0\">\n        <span>You have no packages yet. Make them irresistible!</span>\n    </div>\n    <div *ngIf=\"packages.length !== 0\">\n        <div class=\"table-responsive table-product-package-responsive\">\n            <table class=\"table table-product-package m-0\">\n                <thead class=\"invoice-thead\">\n                <tr>\n                    <th>\n                        <b class=\"pointer\" (click)=\"isFilterAllowed('name') && orderByField('name')\">\n                            Name\n                            <span class=\"fa\"\n                                  [ngClass]=\"pageRequest.sortCriterias[0].sortAscending ? 'fa-caret-up' : 'fa-caret-down'\"\n                                  *ngIf=\"pageRequest.sortCriterias[0].fieldName === 'name' && isFilterAllowed('name')\"\n                            >\n                        </span>\n                        </b>\n                    </th>\n                    <th>\n                        <b class=\"pointer\" (click)=\"isFilterAllowed('price') && orderByField('price')\">Price\n                            <span class=\"fa\"\n                                  [ngClass]=\"pageRequest.sortCriterias[0].sortAscending ? 'fa-caret-up' : 'fa-caret-down'\"\n                                  *ngIf=\"pageRequest.sortCriterias[0].fieldName === 'price' && isFilterAllowed('price')\"></span>\n                        </b>\n                    </th>\n                    <th>Tax</th>\n                    <th></th>\n                </tr>\n                </thead>\n                <tbody>\n                <tr *ngFor=\"let package of packages;\">\n                    <td class=\"text-overflow text-nowrap\">{{ package.name }}</td>\n                    <td class=\"text-overflow text-nowrap\" >{{ package.priceWithCurrency.amountWithCurrency }}</td>\n                    <td>{{ productPackageService.getTaxLabel(package.taxType) }} tax</td>\n                    <td class=\"text-right\">\n                        <button (click)=\"openEditPackageModal(package)\" class=\"btn btn-default m-0 mr-5\"><i class=\"fi fi-edit\"></i> Edit</button>\n                        <button class=\"btn btn-default m-0 mr-5\" (click)=\"openDuplicatePackageModal(package)\"><i class=\"fi fi-duplicate\"></i> Duplicate</button>\n                        <button class=\"btn btn-default m-0 mr-5\" (click)=\"convertPackageToProduct(package)\">Make Product</button>\n                        <button (click)=\"openDeletePackageModal(package)\" class=\"btn btn-delete btn-delete-empty mb-0\"></button>\n                    </td>\n                </tr>\n                </tbody>\n            </table>\n        </div>\n        <sn-pagination [pageRequest]=\"pageRequest\" [totalItems]=\"itemsQuantity\" [pageNumbers]=\"pageNumbers\" (renew)=\"updatePackageData($event)\"></sn-pagination>\n    </div>\n</div>\n"

/***/ }),

/***/ "./web/modern/components/packages-product/packages-block/packages-block.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var pagination_service_1 = __webpack_require__("./shared/services/pagination/pagination.service.ts");
var product_packages_data_service_1 = __webpack_require__("./shared/services/settings/product-packages.data.service.ts");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var delete_item_modal_1 = __webpack_require__("./web/modern/components/settings/common/delete-item-modal/delete-item-modal.ts");
var update_package_product_modal_component_1 = __webpack_require__("./web/modern/components/packages-product/modals/update-package-product-modal/update-package-product-modal.component.ts");
var productPackage_service_1 = __webpack_require__("./web/modern/services/settings/productPackage.service.ts");
var PackagesBlockComponent = function () {
    function PackagesBlockComponent(productPackagesDataService, productPackageService, messageService, paginationService, modalService) {
        _classCallCheck(this, PackagesBlockComponent);

        this.productPackagesDataService = productPackagesDataService;
        this.productPackageService = productPackageService;
        this.messageService = messageService;
        this.paginationService = paginationService;
        this.modalService = modalService;
        this.packages = [];
        this.MODAL_TITLES = ['Add New Package', 'Duplicate Package', 'Edit Package'];
        this.PACKAGE_REQUEST_DEFAULT = {
            filterBy: 'packages',
            paging: {
                pageNumber: 0,
                pageSize: 10,
                searchToken: null
            },
            sortCriterias: [{
                fieldName: 'name',
                sortAscending: true
            }]
        };
        this.PACKAGE_DEFAULT = {
            name: '',
            taxType: 'INCLUDED',
            type: 'PACKAGE',
            description: ''
        };
    }

    _createClass(PackagesBlockComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            var _this = this;

            this.applyPagePackageFromLocalStorage();
            this.getPackagesData();
            this.productPackagesDataService.updateProductPackageSubject.debounceTime(500).subscribe(function () {
                _this.pageRequest.paging.searchToken = null;
                _this.pageRequest.paging.pageNumber = 0;
                _this.getPackagesData();
            });
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.productPackagesDataService.updateProductPackageSubject.complete();
        }
    }, {
        key: "isFilterAllowed",
        value: function isFilterAllowed(filterName) {
            if (!this.allowedFilters) {
                return false;
            }
            return this.allowedFilters.includes(filterName);
        }
    }, {
        key: "orderByField",
        value: function orderByField(filter) {
            if (this.pageRequest.sortCriterias[0].fieldName === filter) {
                this.pageRequest.sortCriterias[0].sortAscending = !this.pageRequest.sortCriterias[0].sortAscending;
            } else {
                this.pageRequest.sortCriterias[0].fieldName = filter;
                this.pageRequest.sortCriterias[0].sortAscending = false;
            }
            this.pageRequest.paging.pageNumber = 0;
            this.getPackagesData();
        }
    }, {
        key: "openEditPackageModal",
        value: function openEditPackageModal(packageItem) {
            this.selectedPackageModalRef = this.modalService.openModal(update_package_product_modal_component_1.UpdatePackageProductModalComponent);
            this.subscribeToModalData();
            this.selectedPackageModalRef.componentInstance.modalTitle = this.MODAL_TITLES[2];
            this.selectedPackageModalRef.componentInstance.name = 'Package';
            this.selectedPackageModalRef.componentInstance.modalData = JSON.parse(JSON.stringify(packageItem));
            this.selectedPackageModalRef.componentInstance.btnDisabled = false;
        }
    }, {
        key: "openDuplicatePackageModal",
        value: function openDuplicatePackageModal(packageItem) {
            this.selectedPackageModalRef = this.modalService.openModal(update_package_product_modal_component_1.UpdatePackageProductModalComponent);
            this.subscribeToModalData();
            this.selectedPackageModalRef.componentInstance.modalTitle = this.MODAL_TITLES[1];
            this.selectedPackageModalRef.componentInstance.name = 'Package';
            this.selectedPackageModalRef.componentInstance.btnDisabled = false;
            this.selectedPackageModalRef.componentInstance.modalData = JSON.parse(JSON.stringify(packageItem));
        }
    }, {
        key: "openAddNewPackageModal",
        value: function openAddNewPackageModal() {
            this.selectedPackageModalRef = this.modalService.openModal(update_package_product_modal_component_1.UpdatePackageProductModalComponent);
            this.subscribeToModalData();
            this.selectedPackageModalRef.componentInstance.modalTitle = this.MODAL_TITLES[0];
            this.selectedPackageModalRef.componentInstance.name = 'Package';
            this.selectedPackageModalRef.componentInstance.modalData = JSON.parse(JSON.stringify(this.PACKAGE_DEFAULT));
            this.selectedPackageModalRef.componentInstance.btnDisabled = false;
        }
    }, {
        key: "openDeletePackageModal",
        value: function openDeletePackageModal(packageItem) {
            this.selectedPackageModalRef = this.modalService.openModal(delete_item_modal_1.DeleteItemModalComponent);
            this.subscribeToModalData();
            this.selectedPackageModalRef.componentInstance.modalTitle = 'Package';
            this.selectedPackageModalRef.componentInstance.btnDisabled = false;
            this.selectedPackageModalRef.componentInstance.modalData = JSON.parse(JSON.stringify(packageItem));
            this.selectedPackageModalRef.componentInstance.itemName = packageItem.name;
        }
    }, {
        key: "convertPackageToProduct",
        value: function convertPackageToProduct(packageItem) {
            var _this2 = this;

            var body = {
                productTemplateId: packageItem.id,
                requiredProductType: 'ADD_ON'
            };
            this.productPackagesDataService.convertProductPackage(body).subscribe(function () {
                _this2.productPackagesDataService.updateProductPackageSubject.next('updateProducts');
                _this2.messageService.showToaster('s_10', 'productsPackages', packageItem.name);
            });
        }
    }, {
        key: "updatePackageData",
        value: function updatePackageData(pageRequest) {
            this.pageRequest = pageRequest;
            this.getPackagesData();
        }
    }, {
        key: "subscribeToModalData",
        value: function subscribeToModalData() {
            var _this3 = this;

            this.selectedPackageModalRef.result.then(function () {
                return _this3.modalDataSubscription.unsubscribe();
            }, function () {
                return _this3.modalDataSubscription.unsubscribe();
            });
            this.modalDataSubscription = this.modalService.getModalData().filter(function (data) {
                return data && data.action && data.props;
            }).subscribe(function (data) {
                return _this3.packageModalActions(data);
            });
        }
    }, {
        key: "getPackagesData",
        value: function getPackagesData() {
            var _this4 = this;

            this.productPackagesDataService.getPackagesOrProducts(this.pageRequest).subscribe(function (data) {
                return _this4.successGetPackageData(data);
            });
        }
    }, {
        key: "successGetPackageData",
        value: function successGetPackageData(data) {
            this.packages = JSON.parse(JSON.stringify(data.items));
            this.itemsQuantity = data ? data.totalSize : 0;
            this.pageNumbers = this.paginationService.calculatePageNumbers(this.itemsQuantity, this.pageRequest.paging.pageSize);
            this.pageRequest.paging.searchToken = data.searchToken;
            this.allowedFilters = data.sortingFields;
            this.setPagePackageToLocalStorage(this.pageRequest);
        }
    }, {
        key: "modalErrorHandle",
        value: function modalErrorHandle(error) {
            this.selectedPackageModalRef.componentInstance.btnDisabled = false;
            this.messageService.handleError(error);
        }
    }, {
        key: "packageModalActions",
        value: function packageModalActions(_ref) {
            var _this5 = this;

            var action = _ref.action,
                props = _ref.props;

            this.selectedPackageModalRef.componentInstance.btnDisabled = true;
            switch (action) {
                case 'Add New Package':
                    this.addNewPackage(props).subscribe(function (data) {
                        _this5.messageService.showToaster('s_0', 'productsPackages', data.name);
                    }, function (error) {
                        return _this5.modalErrorHandle(error);
                    });
                    break;
                case 'Duplicate Package':
                    this.addNewPackage(props).subscribe(function (data) {
                        _this5.messageService.showToaster('s_2', 'productsPackages', data.name);
                    }, function (error) {
                        return _this5.modalErrorHandle(error);
                    });
                    break;
                case 'Edit Package':
                    this.updatePackage(props).subscribe(function (data) {
                        if (props.updateLinked) {
                            _this5.messageService.showToaster('s_3', 'productsPackages', data.name);
                        } else {
                            _this5.messageService.showToaster('s_8', 'quoteInvoiceTemplates');
                        }
                    }, function (error) {
                        return _this5.modalErrorHandle(error);
                    });
                    break;
                case 'Delete':
                    this.deletePackage(props).subscribe(function () {
                        _this5.messageService.showToaster('s_1', 'productsPackages', props.name);
                    }, function (error) {
                        return _this5.modalErrorHandle(error);
                    });
                    break;
                default:
                    break;
            }
        }
    }, {
        key: "addNewPackage",
        value: function addNewPackage(dataToSend) {
            var _this6 = this;

            return this.productPackagesDataService.createPackagesOrProducts(dataToSend).map(function (data) {
                return _this6.resetPackageDataAfterAction(data);
            });
        }
    }, {
        key: "updatePackage",
        value: function updatePackage(dataToSend) {
            var _this7 = this;

            return this.productPackagesDataService.updatePackagesOrProducts(dataToSend.id, dataToSend).map(function (data) {
                return _this7.resetPackageDataAfterAction(data);
            });
        }
    }, {
        key: "deletePackage",
        value: function deletePackage(props) {
            var _this8 = this;

            return this.productPackagesDataService.deletePackagesOrProducts(props.id).map(function (data) {
                return _this8.resetPackageDataAfterAction(data);
            });
        }
    }, {
        key: "resetPackageDataAfterAction",
        value: function resetPackageDataAfterAction(data) {
            this.pageRequest.paging.searchToken = null;
            this.pageRequest.paging.pageNumber = 0;
            this.getPackagesData();
            this.modalDataSubscription.unsubscribe();
            this.selectedPackageModalRef.componentInstance.btnDisabled = false;
            this.selectedPackageModalRef.close();
            return data;
        }
        // LOCAL STORAGE

    }, {
        key: "applyPagePackageFromLocalStorage",
        value: function applyPagePackageFromLocalStorage() {
            var pageRequestObject = JSON.parse(localStorage.getItem("settingsPackageRequest_" + this.companyId));
            this.pageRequest = this.PACKAGE_REQUEST_DEFAULT;
            if (pageRequestObject !== null && pageRequestObject !== undefined && pageRequestObject !== '') {
                var pageSize = pageRequestObject.pageSize,
                    fieldName = pageRequestObject.fieldName,
                    sortAscending = pageRequestObject.sortAscending;

                this.pageRequest.paging.pageSize = pageSize;
                this.pageRequest.sortCriterias[0].fieldName = fieldName;
                this.pageRequest.sortCriterias[0].sortAscending = sortAscending;
            }
        }
    }, {
        key: "setPagePackageToLocalStorage",
        value: function setPagePackageToLocalStorage(pageRequest) {
            var pageRequestObject = {
                pageSize: pageRequest.paging.pageSize,
                fieldName: pageRequest.sortCriterias[0].fieldName,
                sortAscending: pageRequest.sortCriterias[0].sortAscending
            };
            var pageRequestString = JSON.stringify(pageRequestObject);
            localStorage.removeItem("settingsPackageRequest_" + this.companyId);
            localStorage.setItem("settingsPackageRequest_" + this.companyId, pageRequestString);
        }
    }]);

    return PackagesBlockComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Number)], PackagesBlockComponent.prototype, "companyId", void 0);
PackagesBlockComponent = __decorate([core_1.Component({
    selector: 'packages-block',
    template: __webpack_require__("./web/modern/components/packages-product/packages-block/packages-block.component.html")
}), __metadata("design:paramtypes", [product_packages_data_service_1.ProductPackagesDataServiceProvider, productPackage_service_1.ProductPackageService, message_service_1.MessageService, pagination_service_1.PaginationService, snModal_service_1.SNModalService])], PackagesBlockComponent);
exports.PackagesBlockComponent = PackagesBlockComponent;

/***/ }),

/***/ "./web/modern/components/packages-product/packages-product-block/product-packages-block.component.html":
/***/ (function(module, exports) {

module.exports = "<h3 class=\"text-normal m-30\">\n    Create packages and add-on products that can be applied easily to your quotes and invoices.\n</h3>\n<hr>\n<packages-block [companyId]=\"companyId\"></packages-block>\n<product-block [companyId]=\"companyId\"></product-block>\n<discount-block [companyId]=\"companyId\"></discount-block>\n\n"

/***/ }),

/***/ "./web/modern/components/packages-product/packages-product-block/product-packages-block.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var account_service_1 = __webpack_require__("./web/modern/services/user/account.service.ts");
var PackagesProductBlockComponent = function () {
    function PackagesProductBlockComponent(accountService) {
        _classCallCheck(this, PackagesProductBlockComponent);

        this.accountService = accountService;
    }

    _createClass(PackagesProductBlockComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.getCompanyId();
        }
    }, {
        key: "getCompanyId",
        value: function getCompanyId() {
            var _this = this;

            this.accountService.companyIdObservable.subscribe(function (data) {
                return _this.companyId = data;
            });
        }
    }]);

    return PackagesProductBlockComponent;
}();
PackagesProductBlockComponent = __decorate([core_1.Component({
    selector: 'packages-product-block',
    template: __webpack_require__("./web/modern/components/packages-product/packages-product-block/product-packages-block.component.html")
}), __metadata("design:paramtypes", [account_service_1.AccountServiceWebProvider])], PackagesProductBlockComponent);
exports.PackagesProductBlockComponent = PackagesProductBlockComponent;

/***/ }),

/***/ "./web/modern/components/packages-product/product-block/product-block.component.html":
/***/ (function(module, exports) {

module.exports = "<h3 class=\"mb-15 mt-30\">Products</h3>\n<div class=\"row\">\n    <div class=\"col-md-8 col-lg-9 col-sm-12\">\n        <p class=\"f-s-14 text-normal mt-5\">\n            Create a list of add-on products that your clients can add to their selected package. When presented with your quote, your client can choose multiple add-on products in addition to the package.\n        </p>\n    </div>\n    <div class=\"col-md-4 col-lg-3 col-sm-12\">\n        <div class=\"text-md-right text-xs-left\">\n            <button class=\"btn btn-success btn-add-new m-0 pr-15 pl-15 w-200\" (click)=\"openAddNewProductModal()\">\n                Add New Product\n            </button>\n        </div>\n    </div>\n</div>\n\n<div class=\"mt-30\">\n    <div class=\"stats__placeholder mb-30\"\n         *ngIf=\"products.length === 0\"\n    >\n        <span>You have no products yet. Make it easy to upgrade!</span>\n    </div>\n    <div *ngIf=\"products.length !== 0\">\n        <div class=\"table-responsive table-product-package-responsive\">\n            <table class=\"table table-product-package m-0\">\n                <thead class=\"invoice-thead\">\n                <tr>\n                    <th>\n                        <b class=\"pointer\" (click)=\"isFilterAllowed('name') && orderByField('name')\">\n                            Name\n                            <span class=\"fa\"\n                                  [ngClass]=\"pageRequest.sortCriterias[0].sortAscending ? 'fa-caret-up' : 'fa-caret-down'\"\n                                  *ngIf=\"pageRequest.sortCriterias[0].fieldName === 'name' && isFilterAllowed('name')\"\n                            >\n                        </span>\n                        </b>\n                    </th>\n                    <th>\n                        <b class=\"pointer\" (click)=\"isFilterAllowed('price') && orderByField('price')\">Price\n                            <span class=\"fa\"\n                                  [ngClass]=\"pageRequest.sortCriterias[0].sortAscending ? 'fa-caret-up' : 'fa-caret-down'\"\n                                  *ngIf=\"pageRequest.sortCriterias[0].fieldName === 'price' && isFilterAllowed('price')\"></span>\n                        </b>\n                    </th>\n                    <th>Tax</th>\n                    <th></th>\n                </tr>\n                </thead>\n                <tbody>\n                <tr *ngFor=\"let product of products;\">\n                    <td class=\"text-overflow text-nowrap\">{{ product.name }}</td>\n                    <td class=\"text-overflow text-nowrap\">{{ product.priceWithCurrency.amountWithCurrency }}</td>\n                    <td>{{ productPackageService.getTaxLabel(product.taxType) }} tax</td>\n                    <td class=\"text-right\">\n                        <button (click)=\"openEditProductModal(product)\" class=\"btn btn-default m-0 mr-5\"><i class=\"fi fi-edit\"></i> Edit</button>\n                        <button class=\"btn btn-default m-0 mr-5\" (click)=\"openDuplicateProductModal(product)\"><i class=\"fi fi-duplicate\"></i> Duplicate</button>\n                        <button class=\"btn btn-default m-0 mr-5\" (click)=\"convertProductToPackage(product)\" *ngIf=\"product.type.toUpperCase() !== 'GIFT'\">Make Package</button>\n                        <button (click)=\"openDeleteProductModal(product)\" class=\"btn btn-delete btn-delete-empty mb-0\"></button>\n                    </td>\n                </tr>\n                </tbody>\n            </table>\n        </div>\n        <sn-pagination [pageRequest]=\"pageRequest\" [totalItems]=\"itemsQuantity\" [pageNumbers]=\"pageNumbers\" (renew)=\"updateProductData($event)\"></sn-pagination>\n    </div>\n</div>\n\n\n"

/***/ }),

/***/ "./web/modern/components/packages-product/product-block/product-block.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var pagination_service_1 = __webpack_require__("./shared/services/pagination/pagination.service.ts");
var product_packages_data_service_1 = __webpack_require__("./shared/services/settings/product-packages.data.service.ts");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var delete_item_modal_1 = __webpack_require__("./web/modern/components/settings/common/delete-item-modal/delete-item-modal.ts");
var update_package_product_modal_component_1 = __webpack_require__("./web/modern/components/packages-product/modals/update-package-product-modal/update-package-product-modal.component.ts");
var productPackage_service_1 = __webpack_require__("./web/modern/services/settings/productPackage.service.ts");
var ProductBlockComponent = function () {
    function ProductBlockComponent(productPackagesDataService, productPackageService, messageService, paginationService, modalService) {
        _classCallCheck(this, ProductBlockComponent);

        this.productPackagesDataService = productPackagesDataService;
        this.productPackageService = productPackageService;
        this.messageService = messageService;
        this.paginationService = paginationService;
        this.modalService = modalService;
        this.products = [];
        this.MODAL_TITLES = ['Add New Product', 'Duplicate Product', 'Edit Product'];
        this.PRODUCTS_REQUEST_DEFAULT = {
            filterBy: 'add_ons',
            paging: {
                pageNumber: 0,
                pageSize: 10,
                searchToken: null
            },
            sortCriterias: [{
                fieldName: 'name',
                sortAscending: true
            }]
        };
        this.PRODUCT_DEFAULT = {
            name: '',
            taxType: 'INCLUDED',
            type: 'ADD_ON',
            description: ''
        };
    }

    _createClass(ProductBlockComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            var _this = this;

            this.applyPageProductFromLocalStorage();
            this.getProductsData();
            this.productPackagesDataService.updateProductPackageSubject.debounceTime(500).subscribe(function () {
                _this.pageRequest.paging.searchToken = null;
                _this.pageRequest.paging.pageNumber = 0;
                _this.getProductsData();
            });
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.productPackagesDataService.updateProductPackageSubject.complete();
        }
    }, {
        key: "isFilterAllowed",
        value: function isFilterAllowed(filterName) {
            if (!this.allowedFilters) {
                return false;
            }
            return this.allowedFilters.includes(filterName);
        }
    }, {
        key: "orderByField",
        value: function orderByField(filter) {
            if (this.pageRequest.sortCriterias[0].fieldName === filter) {
                this.pageRequest.sortCriterias[0].sortAscending = !this.pageRequest.sortCriterias[0].sortAscending;
            } else {
                this.pageRequest.sortCriterias[0].fieldName = filter;
                this.pageRequest.sortCriterias[0].sortAscending = false;
            }
            this.pageRequest.paging.pageNumber = 0;
            this.getProductsData();
        }
    }, {
        key: "openEditProductModal",
        value: function openEditProductModal(product) {
            this.selectedPackageModalRef = this.modalService.openModal(update_package_product_modal_component_1.UpdatePackageProductModalComponent);
            this.subscribeToModalData();
            this.selectedPackageModalRef.componentInstance.modalTitle = this.MODAL_TITLES[2];
            this.selectedPackageModalRef.componentInstance.name = 'Product';
            this.selectedPackageModalRef.componentInstance.modalData = JSON.parse(JSON.stringify(product));
            this.selectedPackageModalRef.componentInstance.btnDisabled = false;
        }
    }, {
        key: "openDuplicateProductModal",
        value: function openDuplicateProductModal(product) {
            this.selectedPackageModalRef = this.modalService.openModal(update_package_product_modal_component_1.UpdatePackageProductModalComponent);
            this.subscribeToModalData();
            this.selectedPackageModalRef.componentInstance.modalTitle = this.MODAL_TITLES[1];
            this.selectedPackageModalRef.componentInstance.name = 'Product';
            this.selectedPackageModalRef.componentInstance.btnDisabled = false;
            this.selectedPackageModalRef.componentInstance.modalData = JSON.parse(JSON.stringify(product));
        }
    }, {
        key: "openAddNewProductModal",
        value: function openAddNewProductModal() {
            this.selectedPackageModalRef = this.modalService.openModal(update_package_product_modal_component_1.UpdatePackageProductModalComponent);
            this.subscribeToModalData();
            this.selectedPackageModalRef.componentInstance.modalTitle = this.MODAL_TITLES[0];
            this.selectedPackageModalRef.componentInstance.name = 'Product';
            this.selectedPackageModalRef.componentInstance.modalData = JSON.parse(JSON.stringify(this.PRODUCT_DEFAULT));
            this.selectedPackageModalRef.componentInstance.btnDisabled = false;
        }
    }, {
        key: "openDeleteProductModal",
        value: function openDeleteProductModal(product) {
            this.selectedPackageModalRef = this.modalService.openModal(delete_item_modal_1.DeleteItemModalComponent);
            this.subscribeToModalData();
            this.selectedPackageModalRef.componentInstance.modalTitle = 'Product';
            this.selectedPackageModalRef.componentInstance.btnDisabled = false;
            this.selectedPackageModalRef.componentInstance.modalData = JSON.parse(JSON.stringify(product));
            this.selectedPackageModalRef.componentInstance.itemName = product.name;
        }
    }, {
        key: "updateProductData",
        value: function updateProductData(pageRequest) {
            this.pageRequest = pageRequest;
            this.getProductsData();
        }
    }, {
        key: "convertProductToPackage",
        value: function convertProductToPackage(product) {
            var _this2 = this;

            var body = {
                productTemplateId: product.id,
                requiredProductType: 'PACKAGE'
            };
            this.productPackagesDataService.convertProductPackage(body).subscribe(function () {
                _this2.productPackagesDataService.updateProductPackageSubject.next('updatePackages');
                _this2.messageService.showToaster('s_9', 'productsPackages', product.name);
            });
        }
    }, {
        key: "modalErrorHandle",
        value: function modalErrorHandle(error) {
            this.selectedPackageModalRef.componentInstance.btnDisabled = false;
            this.messageService.handleError(error);
        }
    }, {
        key: "productModalActions",
        value: function productModalActions(_ref) {
            var _this3 = this;

            var action = _ref.action,
                props = _ref.props;

            this.selectedPackageModalRef.componentInstance.btnDisabled = true;
            switch (action) {
                case 'Add New Product':
                    this.addNewProduct(props).subscribe(function (data) {
                        _this3.messageService.showToaster('s_4', 'productsPackages', data.name);
                    }, function (error) {
                        return _this3.modalErrorHandle(error);
                    });
                    break;
                case 'Duplicate Product':
                    this.addNewProduct(props).subscribe(function (data) {
                        _this3.messageService.showToaster('s_6', 'productsPackages', data.name);
                    }, function (error) {
                        return _this3.modalErrorHandle(error);
                    });
                    break;
                case 'Edit Product':
                    this.updateProduct(props).subscribe(function (data) {
                        if (props.updateLinked) {
                            _this3.messageService.showToaster('s_7', 'productsPackages', data.name);
                        } else {
                            _this3.messageService.showToaster('s_8', 'quoteInvoiceTemplates');
                        }
                    }, function (error) {
                        return _this3.modalErrorHandle(error);
                    });
                    break;
                case 'Delete':
                    this.deleteProduct(props).subscribe(function () {
                        _this3.messageService.showToaster('s_5', 'productsPackages', props.name);
                    }, function (error) {
                        return _this3.modalErrorHandle(error);
                    });
                    break;
                default:
                    break;
            }
        }
    }, {
        key: "addNewProduct",
        value: function addNewProduct(dataToSend) {
            var _this4 = this;

            return this.productPackagesDataService.createPackagesOrProducts(dataToSend).map(function (data) {
                return _this4.resetProductDataAfterAction(data);
            });
        }
    }, {
        key: "updateProduct",
        value: function updateProduct(dataToSend) {
            var _this5 = this;

            return this.productPackagesDataService.updatePackagesOrProducts(dataToSend.id, dataToSend).map(function (data) {
                return _this5.resetProductDataAfterAction(data);
            });
        }
    }, {
        key: "deleteProduct",
        value: function deleteProduct(props) {
            var _this6 = this;

            return this.productPackagesDataService.deletePackagesOrProducts(props.id).map(function (data) {
                return _this6.resetProductDataAfterAction(data);
            });
        }
    }, {
        key: "getProductsData",
        value: function getProductsData() {
            var _this7 = this;

            this.productPackagesDataService.getPackagesOrProducts(this.pageRequest).subscribe(function (data) {
                return _this7.successGetProductsData(data);
            });
        }
    }, {
        key: "successGetProductsData",
        value: function successGetProductsData(data) {
            this.products = JSON.parse(JSON.stringify(data.items));
            this.itemsQuantity = data ? data.totalSize : 0;
            this.pageNumbers = this.paginationService.calculatePageNumbers(this.itemsQuantity, this.pageRequest.paging.pageSize);
            this.pageRequest.paging.searchToken = data.searchToken;
            this.allowedFilters = data.sortingFields;
            this.setPageProductToLocalStorage(this.pageRequest);
        }
    }, {
        key: "resetProductDataAfterAction",
        value: function resetProductDataAfterAction(data) {
            this.pageRequest.paging.searchToken = null;
            this.pageRequest.paging.pageNumber = 0;
            this.getProductsData();
            this.modalDataSubscription.unsubscribe();
            this.selectedPackageModalRef.componentInstance.btnDisabled = false;
            this.selectedPackageModalRef.close();
            return data;
        }
    }, {
        key: "subscribeToModalData",
        value: function subscribeToModalData() {
            var _this8 = this;

            this.selectedPackageModalRef.result.then(function () {
                return _this8.modalDataSubscription.unsubscribe();
            }, function () {
                return _this8.modalDataSubscription.unsubscribe();
            });
            this.modalDataSubscription = this.modalService.getModalData().filter(function (data) {
                return data && data.action && data.props;
            }).subscribe(function (data) {
                return _this8.productModalActions(data);
            });
        }
        // LOCAL STORAGE

    }, {
        key: "applyPageProductFromLocalStorage",
        value: function applyPageProductFromLocalStorage() {
            var pageRequestObject = JSON.parse(localStorage.getItem("settingsProductRequest_" + this.companyId));
            this.pageRequest = this.PRODUCTS_REQUEST_DEFAULT;
            if (pageRequestObject && pageRequestObject !== '') {
                var pageSize = pageRequestObject.pageSize,
                    fieldName = pageRequestObject.fieldName,
                    sortAscending = pageRequestObject.sortAscending;

                this.pageRequest.paging.pageSize = pageSize;
                this.pageRequest.sortCriterias[0].fieldName = fieldName;
                this.pageRequest.sortCriterias[0].sortAscending = sortAscending;
            }
        }
    }, {
        key: "setPageProductToLocalStorage",
        value: function setPageProductToLocalStorage(pageRequest) {
            var pageRequestObject = {
                pageSize: pageRequest.paging.pageSize,
                fieldName: pageRequest.sortCriterias[0].fieldName,
                sortAscending: pageRequest.sortCriterias[0].sortAscending
            };
            var pageRequestString = JSON.stringify(pageRequestObject);
            localStorage.removeItem("settingsProductRequest_" + this.companyId);
            localStorage.setItem("settingsProductRequest_" + this.companyId, pageRequestString);
        }
    }]);

    return ProductBlockComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Number)], ProductBlockComponent.prototype, "companyId", void 0);
ProductBlockComponent = __decorate([core_1.Component({
    selector: 'product-block',
    template: __webpack_require__("./web/modern/components/packages-product/product-block/product-block.component.html")
}), __metadata("design:paramtypes", [product_packages_data_service_1.ProductPackagesDataServiceProvider, productPackage_service_1.ProductPackageService, message_service_1.MessageService, pagination_service_1.PaginationService, snModal_service_1.SNModalService])], ProductBlockComponent);
exports.ProductBlockComponent = ProductBlockComponent;

/***/ }),

/***/ "./web/modern/components/payments/modals/export-payments-modal/export-payments-modal.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n    <button class=\"close\" (click)=\"onDismiss()\" data-dismiss=\"modal\">&times;</button>\n    <h3 class=\"modal-title f-w-n\">{{ modalTitle }}</h3>\n</div>\n<div class=\"modal-body\" style=\"padding: 20px!important;\" >\n    <form [formGroup]=\"formGroup\" class=\"form-horizontal\" role=\"form\" (submit)=\"onSubmit()\">\n        <div>\n            <h4>Type of Payments</h4>\n            <div class=\"select-style\">\n                <select (change)=\"onChangePayments($event?.target?.value)\" formControlName=\"paymentState\" class=\"form-control\" required>\n                    <option [value]=\"'all'\">All Payments</option>\n                    <option [value]=\"'paid'\">Paid Payments</option>\n                    <option [value]=\"'unpaid'\">Unpaid Payments</option>\n                </select>\n            </div>\n        </div>\n        <div class=\"mt-20\">\n            <h4>Filter By</h4>\n            <div class=\"select-style\">\n                <select (change)=\"onChangeDateType()\" formControlName=\"dateType\" class=\"form-control\" required>\n                    <option [value]=\"'issue_date'\">Issue Date</option>\n                    <option [value]=\"'due_date'\">Due Date</option>\n                    <option [value]=\"'paid_date'\" [disabled]=\"formGroup.controls['paymentState'].value !== 'paid'\">Paid Date</option>\n                </select>\n            </div>\n        </div>\n        <div class=\"mt-20\">\n            <h4>Date Range</h4>\n            <div class=\"date-range-filters-payments\">\n                <div class=\"btn-group sn-btn-group date-range-presets\" role=\"group\" aria-label=\"date-range-buttons\">\n                    <button type=\"button\"\n                            class=\"btn btn-default mb-0\"\n                            [ngClass]=\"{'focus': dateRangePreset === '30'}\"\n                            (click)=\"onDateRangePresetToggle('30')\"\n                            [disabled]=\"activeTab === 'revenue_menu'\">\n                        30 Days\n                    </button>\n                    <button type=\"button\"\n                            class=\"btn btn-default mb-0\"\n                            [ngClass]=\"{'focus': dateRangePreset === 'm'}\"\n                            (click)=\"onDateRangePresetToggle('m')\"\n                            [disabled]=\"activeTab === 'revenue_menu'\">\n                        Mtd\n                    </button>\n                    <button type=\"button\"\n                            class=\"btn btn-default mb-0\"\n                            [ngClass]=\"{'focus': dateRangePreset === 'y'}\"\n                            (click)=\"onDateRangePresetToggle('y')\"\n                            [disabled]=\"activeTab === 'revenue_menu'\">\n                        Ytd\n                    </button>\n                    <button type=\"button\"\n                            class=\"btn btn-default mb-0\"\n                            [ngClass]=\"{'focus': dateRangePreset === 'all'}\"\n                            (click)=\"onDateRangePresetToggle('all')\"\n                            [disabled]=\"activeTab === 'revenue_menu'\">\n                        All Time\n                    </button>\n                </div>\n                <div class=\"daterangepicker-style main-input-item has-feedback has-feedback-left mb-0\">\n                    <input type=\"text\"\n                           snDateRange\n                           [(ngModel)]=\"selectedRange\"\n                           (ngModelChange)=\"setCustomDateRange($event)\"\n                           [ngModelOptions]=\"{standalone: true}\"\n                           [showDropdowns]=\"true\"\n                           [minDate]=\"minDate\"\n                           [maxDate]=\"maxDate\"\n                           [opens]=\"'left'\"\n                           [showCancel]=\"false\"\n                           [autoApply]=\"true\"\n                           readonly\n                           [attr.disabled]=\"activeTab === 'revenue_menu' ? '' : null\"\n                           class=\"form-control\"/>\n                    <span class=\"form-control-feedback sn-daterangeicon\"></span>\n                </div>\n            </div>\n        </div>\n        <div class=\"mt-20\">\n            <h4>Columns</h4>\n            <div>\n                <div class=\"checkbox-squared\">\n                    <input formControlName=\"selectAllColumns\" id=\"all\" type=\"checkbox\"/>\n                    <label [attr.for]=\"'all'\"></label>\n\n                </div>\n                <span>Select All</span>\n            </div>\n            <div formArrayName=\"columns\" class=\"column-checkbox-block\">\n                <div *ngFor=\"let option of formGroup.controls['columns'].controls; let i = index\" class=\"column-checkbox\">\n                    <div class=\"checkbox-squared ml-25\">\n                        <input [id]=\"'option-' + i\"\n                               [value]=\"option\"\n                               [checked]=\"option\"\n                               [formControlName]=\"i\"\n                               type=\"checkbox\"/>\n                        <label [attr.for]=\"'option-' + i\"></label>\n                    </div>\n                    <span class=\"w-100\">{{ checkboxes[i].name }}</span>\n                </div>\n            </div>\n        </div>\n        <div class=\"mt-20\">\n            <h4>File Format</h4>\n            <div class=\"file-format-group\">\n                <div class=\"file-format-checkbox\">\n                    <div class=\"checkbox-squared\">\n                        <input (change)=\"isXLSFormat = $event.target.checked\" [checked]=\"isXLSFormat\" id=\"xls\" type=\"checkbox\"/>\n                        <label [attr.for]=\"'xls'\"></label>\n                    </div>\n                    <span>XLS</span>\n                </div>\n                <div class=\"file-format-checkbox\">\n                    <div class=\"checkbox-squared\">\n                        <input (change)=\"isCSVFormat = $event.target.checked\" [checked]=\"isCSVFormat\" id=\"csv\" type=\"checkbox\"/>\n                        <label [attr.for]=\"'csv'\"></label>\n                    </div>\n                    <span>CSV</span>\n                </div>\n            </div>\n        </div>\n        <div class=\"pt-30 pb-10\">\n            <button type=\"submit\" class=\"btn btn-lg btn-success btn-success m-0 mr-10\" spinning-wheel [is-spinning-wheel-active]=\"btnDisabled\" [disabled]=\"btnDisabled\">{{ modalTitle }}</button>\n        </div>\n    </form>\n</div>\n"

/***/ }),

/***/ "./web/modern/components/payments/modals/export-payments-modal/export-payments-modal.scss":
/***/ (function(module, exports) {

module.exports = ".date-range-filters-payments {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  -webkit-box-pack: justify;\n  -webkit-justify-content: space-between;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-flex-wrap: wrap;\n      -ms-flex-wrap: wrap;\n          flex-wrap: wrap; }\n  .date-range-filters-payments .date-range-presets {\n    margin-right: 10px; }\n\n.file-format-group {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: start;\n  -webkit-justify-content: start;\n      -ms-flex-pack: start;\n          justify-content: start;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center; }\n  .file-format-group .file-format-checkbox {\n    margin-right: 20px; }\n\n.column-checkbox-block {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  height: 165px;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-flex-wrap: wrap;\n      -ms-flex-wrap: wrap;\n          flex-wrap: wrap; }\n  .column-checkbox-block .column-checkbox {\n    margin-top: 10px; }\n\n.all-time-selected {\n  background-color: #ffffff;\n  border: none;\n  height: 25px;\n  position: absolute;\n  top: 5px;\n  left: 32px;\n  width: 200px; }\n  .all-time-selected:focus {\n    outline: none;\n    border: none; }\n\n.form-control[readonly] {\n  background-color: #ffffff; }\n\n@media (max-width: 524px) {\n  .date-range-filters-payments {\n    -webkit-box-pack: center;\n    -webkit-justify-content: center;\n        -ms-flex-pack: center;\n            justify-content: center; }\n    .date-range-filters-payments .btn {\n      margin-bottom: 20px !important; } }\n"

/***/ }),

/***/ "./web/modern/components/payments/modals/export-payments-modal/export-payments-modal.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var ng_bootstrap_1 = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/index.js");
var time_service_1 = __webpack_require__("./shared/services/helpers/time-service/time.service.ts");
var forms_1 = __webpack_require__("./node_modules/@angular/forms/esm5/forms.js");
var payments_data_service_1 = __webpack_require__("./shared/services/payments/payments-data-service/payments.data.service.ts");
var rxjs_1 = __webpack_require__("./node_modules/rxjs/Rx.js");
var file_download_data_service_1 = __webpack_require__("./shared/services/files/file-download-service/file-download.data.service.ts");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var forkJoin_1 = __webpack_require__("./node_modules/rxjs/observable/forkJoin.js");
var account_service_1 = __webpack_require__("./web/modern/services/user/account.service.ts");
var settings_1 = __webpack_require__("./shared/services/settings/settings.ts");
var moment = __webpack_require__("./node_modules/moment/moment.js");
var ExportPaymentsModalComponent = function () {
    function ExportPaymentsModalComponent(activeModal, timeService, modalService, paymentsService, fileDownloadDataService, fb, messageService, accountService, settingsService) {
        _classCallCheck(this, ExportPaymentsModalComponent);

        this.activeModal = activeModal;
        this.timeService = timeService;
        this.modalService = modalService;
        this.paymentsService = paymentsService;
        this.fileDownloadDataService = fileDownloadDataService;
        this.fb = fb;
        this.messageService = messageService;
        this.accountService = accountService;
        this.settingsService = settingsService;
        this.checkboxes = [{ id: 'STATUS', name: 'Status', isChecked: true }, { id: 'INVOICE_ID', name: 'Invoice ID', isChecked: true }, { id: 'ISSUE_DATE', name: 'Issue Date', isChecked: true }, { id: 'SENT_DATE', name: 'Sent Date', isChecked: true }, { id: 'DUE_DATE', name: 'Due Date', isChecked: true }, { id: 'PAID_DATE', name: 'Paid Date', isChecked: true }, { id: 'CLIENT_NAME', name: 'Client Name', isChecked: true }, { id: 'CLIENT_EMAIL', name: 'Client Email', isChecked: true }, { id: 'JOB_NAME', name: 'Job Name', isChecked: true }, { id: 'JOB_STATUS', name: 'Job Status', isChecked: true }, { id: 'LEAD_SOURCE', name: 'Lead Source', isChecked: true }, { id: 'MAIN_SHOOT_DATE', name: 'Main Shoot Date', isChecked: true }, { id: 'TOTAL_AMOUNT', name: 'Total Amount', isChecked: true }, { id: 'TAX_AMOUNT', name: 'Tax Amount', isChecked: true }, { id: 'CURRENCY', name: 'Currency', isChecked: true }];
        this.isXLSFormat = true;
        this.isCSVFormat = true;
        this.unsubscribe = new rxjs_1.Subject();
    }

    _createClass(ExportPaymentsModalComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.subscribeToCustomizeLabelsChange();
            this.onDateRangePresetToggle('30');
            var formControls = this.checkboxes.map(function () {
                return new forms_1.FormControl(true);
            });
            var selectAllColumns = new forms_1.FormControl(true);
            this.formGroup = this.fb.group({
                paymentState: new forms_1.FormControl('all'),
                dateType: new forms_1.FormControl('issue_date'),
                fromDate: new forms_1.FormControl(null),
                toDate: new forms_1.FormControl(null),
                columns: new forms_1.FormArray(formControls, forms_1.Validators.required),
                selectAllColumns: selectAllColumns
            });
            this.onColumnChanges();
        }
    }, {
        key: "ngOnChanges",
        value: function ngOnChanges() {
            this.onColumnChanges();
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "onColumnChanges",
        value: function onColumnChanges() {
            var _this = this;

            this.formGroup.get('selectAllColumns').valueChanges.pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (bool) {
                _this.formGroup.get('columns').patchValue(Array(_this.checkboxes.length).fill(bool), {
                    emitEvent: false
                });
            });
            this.formGroup.get('columns').valueChanges.pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (val) {
                var allSelected = val.every(function (bool) {
                    return bool;
                });
                if (_this.formGroup.get('selectAllColumns').value !== allSelected) {
                    _this.formGroup.get('selectAllColumns').patchValue(allSelected, { emitEvent: false });
                }
            });
        }
    }, {
        key: "onDateRangePresetToggle",
        value: function onDateRangePresetToggle(newRangePreset) {
            if (newRangePreset !== this.dateRangePreset) {
                this.dateRangePreset = newRangePreset;
                this.setDateRangePreset(this.dateRangePreset);
                this.applyChosenDateRange();
            }
        }
        // PRESET DATE RANGES

    }, {
        key: "setDateRangePreset",
        value: function setDateRangePreset(dateRangePreset) {
            switch (dateRangePreset) {
                case '30':
                    {
                        this.setRangeToLastDays(30);
                        break;
                    }
                case 'm':
                    {
                        this.setMonthToDateRange();
                        break;
                    }
                case 'y':
                    {
                        this.setYearToDateRange();
                        break;
                    }
                case 'all':
                    {
                        this.setAllTimeDateRange();
                        break;
                    }
                default:
                    {
                        break;
                    }
            }
        }
    }, {
        key: "setRangeToLastDays",
        value: function setRangeToLastDays(daysBefore) {
            var today = new Date();
            var past = new Date();
            var difference = today.getDate() - daysBefore;
            past.setDate(difference);
            this.fromDate = this.timeService.getDateString(past);
            this.toDate = this.timeService.getDateString(today);
        }
    }, {
        key: "setMonthToDateRange",
        value: function setMonthToDateRange() {
            var today = new Date();
            var monthStart = new Date(today.getFullYear(), today.getMonth(), 1);
            this.fromDate = this.timeService.getDateString(monthStart);
            this.toDate = this.timeService.getDateString(today);
        }
    }, {
        key: "setYearToDateRange",
        value: function setYearToDateRange() {
            var today = new Date();
            var yearStart = new Date(today.getFullYear(), 0, 1);
            this.fromDate = this.timeService.getDateString(yearStart);
            this.toDate = this.timeService.getDateString(today);
        }
    }, {
        key: "setAllTimeDateRange",
        value: function setAllTimeDateRange() {
            var _this2 = this;

            var data = {
                paymentState: this.formGroup.get('paymentState').value,
                dateType: this.formGroup.get('dateType').value
            };
            var today = new Date();
            var past = new Date();
            var difference = today.getDate() - 365;
            past.setDate(difference);
            this.paymentsService.getAllTime(data).subscribe(function (value) {
                _this2.minDateAll = new Date(value.minDate);
                _this2.maxDateAll = new Date(value.maxDate);
                if ((_this2.maxDateAll && _this2.minDateAll) === null) {
                    _this2.fromDate = _this2.timeService.getDateString(past);
                    _this2.toDate = _this2.timeService.getDateString(today);
                } else {
                    _this2.fromDate = _this2.timeService.getDateString(_this2.minDateAll);
                    _this2.toDate = _this2.timeService.getDateString(_this2.maxDateAll);
                }
                _this2.applyChosenDateRange();
            });
        }
    }, {
        key: "setCustomDateRange",
        value: function setCustomDateRange(newDateRange) {
            if (moment.isMoment(newDateRange.startDate)) {
                this.fromDate = this.timeService.getDateString(newDateRange.startDate.toDate());
                this.toDate = this.timeService.getDateString(newDateRange.endDate.toDate());
                this.dateRangePreset = null;
                this.applyChosenDateRange();
            }
        }
    }, {
        key: "applyChosenDateRange",
        value: function applyChosenDateRange() {
            this.selectedRange = {
                startDate: new Date(this.fromDate).toISOString(),
                endDate: new Date(this.toDate).toISOString()
            };
        }
    }, {
        key: "onDismiss",
        value: function onDismiss() {
            this.activeModal.dismiss();
        }
    }, {
        key: "onChangePayments",
        value: function onChangePayments(value) {
            if (value === 'paid') {
                this.formGroup.controls.dateType.patchValue('paid_date');
            } else if (value === 'unpaid') {
                this.formGroup.controls.dateType.patchValue('due_date');
            } else {
                this.formGroup.controls.dateType.patchValue('issue_date');
            }
            if (this.dateRangePreset === 'all') {
                this.setAllTimeDateRange();
            }
        }
    }, {
        key: "onChangeDateType",
        value: function onChangeDateType() {
            if (this.dateRangePreset === 'all') {
                this.setAllTimeDateRange();
            }
        }
    }, {
        key: "submitExportXLS",
        value: function submitExportXLS() {
            var _this3 = this;

            this.paymentsService.exportPaymentsXLS(this.formGroup.value).pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (response) {
                _this3.fileDownloadDataService.savePaymentsXLS(response);
                _this3.activeModal.close();
            }, function (_ref) {
                var error = _ref.error;
                var errorTitle = error.errorTitle,
                    errorMessage = error.errorMessage;

                _this3.messageService.showErrorFromBackend(errorTitle, errorMessage);
            }, function () {
                _this3.btnDisabled = false;
            });
        }
    }, {
        key: "submitExportCSV",
        value: function submitExportCSV() {
            var _this4 = this;

            this.paymentsService.exportPaymentsCSV(this.formGroup.value).pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (response) {
                _this4.fileDownloadDataService.savePaymentsCSV(response);
                _this4.activeModal.close();
            }, function (_ref2) {
                var error = _ref2.error;
                var errorTitle = error.errorTitle,
                    errorMessage = error.errorMessage;

                _this4.messageService.showErrorFromBackend(errorTitle, errorMessage);
            }, function () {
                _this4.btnDisabled = false;
            });
        }
    }, {
        key: "saveTwoFiles",
        value: function saveTwoFiles() {
            var _this5 = this;

            forkJoin_1.forkJoin([this.paymentsService.exportPaymentsXLS(this.formGroup.value).pipe(operators_1.takeUntil(this.unsubscribe)), this.paymentsService.exportPaymentsCSV(this.formGroup.value).pipe(operators_1.takeUntil(this.unsubscribe))]).subscribe(function (response) {
                var xlsResponse = response[0];
                var csvResponse = response[1];
                _this5.fileDownloadDataService.savePaymentsXLS(xlsResponse);
                _this5.fileDownloadDataService.savePaymentsCSV(csvResponse);
                _this5.activeModal.close();
            }, function (_ref3) {
                var error = _ref3.error;
                var errorTitle = error.errorTitle,
                    errorMessage = error.errorMessage;

                _this5.messageService.showErrorFromBackend(errorTitle, errorMessage);
            }, function () {
                _this5.btnDisabled = false;
            });
        }
    }, {
        key: "onSubmit",
        value: function onSubmit() {
            var validCheckboxes = this.formGroup.value.columns.includes(true);
            if (validCheckboxes) {
                if (this.isXLSFormat && !this.isCSVFormat) {
                    this.preSendForm();
                    this.btnDisabled = true;
                    this.submitExportXLS();
                } else if (this.isCSVFormat && !this.isXLSFormat) {
                    this.preSendForm();
                    this.btnDisabled = true;
                    this.submitExportCSV();
                } else if (this.isXLSFormat && this.isCSVFormat) {
                    this.preSendForm();
                    this.btnDisabled = true;
                    this.saveTwoFiles();
                } else {
                    this.messageService.showToaster('e_10', 'payments');
                }
            } else {
                this.messageService.showToaster('e_9', 'payments');
            }
        }
    }, {
        key: "preSendForm",
        value: function preSendForm() {
            var _this6 = this;

            var selectedPreferences = this.formGroup.value.columns.map(
            // eslint-disable-next-line no-confusing-arrow
            function (checked, index) {
                return checked ? _this6.checkboxes[index].id : null;
            });
            this.formGroup.controls.columns.patchValue(selectedPreferences);
            this.formGroup.value.columns.filter(function (value) {
                return value !== null;
            });
            this.formGroup.controls.fromDate.patchValue(this.fromDate);
            this.formGroup.controls.toDate.patchValue(this.toDate);
            this.formGroup.removeControl('selectAllColumns');
        }
    }, {
        key: "subscribeToCustomizeLabelsChange",
        value: function subscribeToCustomizeLabelsChange() {
            var _this7 = this;

            this.settingsService.customizeLabelsObservable.pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (customizeLabels) {
                return _this7.changeCustomizedNames(customizeLabels);
            });
        }
    }, {
        key: "changeCustomizedNames",
        value: function changeCustomizedNames(labels) {
            this.checkboxes.forEach(function (el) {
                if (el.id === 'MAIN_SHOOT_DATE') {
                    el.name = labels.mainShootLabel + " Date";
                }
            });
        }
    }]);

    return ExportPaymentsModalComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", String)], ExportPaymentsModalComponent.prototype, "modalTitle", void 0);
__decorate([core_1.Input(), __metadata("design:type", Boolean)], ExportPaymentsModalComponent.prototype, "btnDisabled", void 0);
ExportPaymentsModalComponent = __decorate([core_1.Component({
    selector: 'export-payments-modal',
    template: __webpack_require__("./web/modern/components/payments/modals/export-payments-modal/export-payments-modal.html"),
    styles: [__webpack_require__("./web/modern/components/payments/modals/export-payments-modal/export-payments-modal.scss")]
}), __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal, time_service_1.TimeServiceProvider, snModal_service_1.SNModalService, payments_data_service_1.PaymentsDataServiceProvider, file_download_data_service_1.FileDownloadDataServiceProvider, forms_1.FormBuilder, message_service_1.MessageService, account_service_1.AccountServiceWebProvider, settings_1.SettingsProvider])], ExportPaymentsModalComponent);
exports.ExportPaymentsModalComponent = ExportPaymentsModalComponent;

/***/ }),

/***/ "./web/modern/components/payments/modals/record-payment-modal/record-payment-modal.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"markAsPayedModal\" class=\"modal modal-center fade\" data-backdrop=\"static\" data-keyboard=\"false\">\n\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <close-btn (action)=\"closeModal($event)\"></close-btn>\n                <h3 class=\"modal-title\">Record Payment</h3>\n            </div>\n            <form #paymentForm=\"ngForm\" (ngSubmit)=\"markAsPayed(paymentForm)\" ngNativeValidate>\n            <div class=\"modal-body\" style=\"padding: 20px!important;\">\n                <div class=\"form-group\">\n                    <div class=\"field-info\">\n                        <h4>Amount</h4>\n                        <div class=\"row\">\n                            <div class=\"col-xs-12 box-no-transition\">\n                                <input [(ngModel)]=\"amount\"\n                                       [amountValidation]=\"selectedPayment?.amount\"\n                                       [textMask]=\"{mask: numberMask}\"\n                                       class=\"form-control\"\n                                       name=\"_amount\"\n                                       placeholder=\"{{currencySymbol}}0\"\n                                       required\n                                       type=\"text\">\n                            </div>\n                        </div>\n                    </div>\n\n                    <div class=\"field-info\">\n                        <h4>Paid On</h4>\n                        <div class=\"row\">\n                            <div class=\"col-xs-12 box-no-transition datepicker-static\">\n                                <sn-date-picker name=\"_paidOn\"\n                                                [options]=\"'options' | snDatePickerConfig\"\n                                                [placeholder]=\"dateFormat\" [(ngModel)]=\"paidOn\"\n                                                snDatePickerValidator></sn-date-picker>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <button type=\"submit\"\n                        [disabled]=\"disableButtons\"\n                        [ngClass]=\"{'spinning-wheel__active' : recordPaymentSpinningWheel}\"\n                        class=\"btn btn-lg btn-success spinning-wheel mt-10 spinning-wheel__display-after\">\n                    Save payment\n                </button>\n            </div>\n            </form>\n        </div>\n    </div>\n</div>"

/***/ }),

/***/ "./web/modern/components/payments/modals/record-payment-modal/record-payment-modal.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(toastr, $) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var time_service_1 = __webpack_require__("./shared/services/helpers/time-service/time.service.ts");
var invoices_data_service_1 = __webpack_require__("./shared/services/invoice/invoices-data-service/invoices.data.service.ts");
var settings_1 = __webpack_require__("./shared/services/settings/settings.ts");
var textMaskAddons_1 = __webpack_require__("./node_modules/text-mask-addons/dist/textMaskAddons.js");
var stringModifier_service_1 = __webpack_require__("./shared/services/helpers/string-modifier-service/stringModifier.service.ts");
var amountValidation_directive_1 = __webpack_require__("./web/modern/directives/AmountValidation/amountValidation.directive.ts");
var RecordPaymentModalComponent = function () {
    function RecordPaymentModalComponent(messageService, timeService, invoicesDataService, ref, settingsService, stringModifier) {
        _classCallCheck(this, RecordPaymentModalComponent);

        this.messageService = messageService;
        this.timeService = timeService;
        this.invoicesDataService = invoicesDataService;
        this.ref = ref;
        this.settingsService = settingsService;
        this.stringModifier = stringModifier;
        this.updateParent = new core_1.EventEmitter();
        this.currencySymbol = '$';
        this.numberMask = textMaskAddons_1.createNumberMask({
            prefix: '',
            suffix: '',
            allowDecimal: true,
            allowLeadingZeroes: true
        });
    }

    _createClass(RecordPaymentModalComponent, [{
        key: "ngOnChanges",
        value: function ngOnChanges(changes) {
            var selectedPayment = changes.selectedPayment.currentValue;
            if (selectedPayment) {
                this.amount = selectedPayment.amount;
                this.paidOn = { jsdate: new Date() };
                this.currencySymbol = selectedPayment.currencySymbol;
            }
        }
    }, {
        key: "closeModal",
        value: function closeModal() {
            this.amount = this.selectedPayment.amount;
            this.amountValidationDirective.showValidation(this.selectedPayment.amount);
        }
    }, {
        key: "markAsPayed",
        value: function markAsPayed(form) {
            var _this = this;

            this.recordPaymentSpinningWheel = true;
            this.disableButtons = true;
            var paidOnFormatted = this.timeService.getDateInFormat(form.value._paidOn.jsdate, 'date');
            var amountFormatted = this.stringModifier.convertAmountIntoNumber(form.value._amount);
            var data = {
                id: this.selectedPayment.id,
                amount: amountFormatted,
                paidOn: paidOnFormatted
            };
            this.invoicesDataService.markAsPaid(data).finally(function () {
                _this.recordPaymentSpinningWheel = false;
                _this.disableButtons = false;
            }).subscribe(function (data) {
                return _this.successMarkAsPaid(data);
            }, function (err) {
                return _this.errorMarkAsPaid(err);
            });
        }
    }, {
        key: "successMarkAsPaid",
        value: function successMarkAsPaid(data) {
            if (data && data.errorMessage) {
                if (data.errorCode) {
                    this.handleModernErrorMessages(data);
                    return;
                }
                toastr.error(data.errorMessage);
            } else {
                $('#markAsPayedModal').modal('hide');
                this.messageService.showToaster('s_7', 'payments');
                this.updateParent.emit(true);
            }
        }
    }, {
        key: "errorMarkAsPaid",
        value: function errorMarkAsPaid(_ref) {
            var status = _ref.status,
                data = _ref.data,
                error = _ref.error;

            if (error) {
                var _errorCode = error.errorCode,
                    _errorMessage = error.errorMessage,
                    errorTitle = error.errorTitle;

                if (_errorCode && _errorMessage) {
                    this.messageService.showErrorFromBackend(errorTitle, _errorMessage);
                    return;
                }
            }
            if (data.errorCode) {
                this.handleModernErrorMessages(data);
                return;
            }
            var errorMessage = data.errorMessage;
            var errorCode = void 0;
            var errorPlace = void 0;
            var value = void 0;
            if (status >= 400 && status < 500 && errorMessage) {
                switch (errorMessage) {
                    case 'Payment already paid':
                        errorCode = 'e_10';
                        errorPlace = 'editInvoice';
                        break;
                    case "Xero payments don't match StudioNinja payments":
                        errorCode = 'e_0';
                        errorPlace = 'xero';
                        break;
                    case 'Invoice not synchronized with Xero':
                        errorCode = 'e_9';
                        errorPlace = 'xero';
                        break;
                    case "Bummer! You don't have an active Xero subscription.":
                        errorCode = 'e_15';
                        errorPlace = 'xero';
                        break;
                    case 'Xero access token expired, reconnect Xero please':
                    case 'Bummer! Xero access token not authorized or revoked, reconnect Xero please':
                    case 'Bummer! Xero access token revoked, reconnect Xero please':
                        errorCode = 'e_14';
                        errorPlace = 'xero';
                        break;
                    default:
                        errorCode = 'e_2';
                        errorPlace = 'general';
                        value = errorMessage;
                        break;
                }
            } else {
                errorCode = 'e_0';
                errorPlace = 'general';
            }
            this.messageService.showToaster(errorCode, errorPlace, value);
        }
    }, {
        key: "handleModernErrorMessages",
        value: function handleModernErrorMessages(_ref2) {
            var errorTitle = _ref2.errorTitle,
                errorMessage = _ref2.errorMessage;

            this.messageService.showErrorFromBackend(errorTitle, errorMessage);
        }
    }]);

    return RecordPaymentModalComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], RecordPaymentModalComponent.prototype, "selectedPayment", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], RecordPaymentModalComponent.prototype, "updateParent", void 0);
__decorate([core_1.ViewChild(amountValidation_directive_1.AmountValidationDirective), __metadata("design:type", amountValidation_directive_1.AmountValidationDirective)], RecordPaymentModalComponent.prototype, "amountValidationDirective", void 0);
RecordPaymentModalComponent = __decorate([core_1.Component({
    selector: 'record-payment-modal',
    template: __webpack_require__("./web/modern/components/payments/modals/record-payment-modal/record-payment-modal.html")
}), __metadata("design:paramtypes", [message_service_1.MessageService, time_service_1.TimeServiceProvider, invoices_data_service_1.InvoicesDataProvider, core_1.ChangeDetectorRef, settings_1.SettingsProvider, stringModifier_service_1.StringModifierServiceProvider])], RecordPaymentModalComponent);
exports.RecordPaymentModalComponent = RecordPaymentModalComponent;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/toastr/toastr.js"), __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./web/modern/components/payments/modals/write-off-modal/write-off-modal.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n    <button (click)=\"dismissModal()\" aria-hidden=\"true\" class=\"close\" data-dismiss=\"modal\" [disabled]=\"disableButton\">&times;</button>\n    <h3 class=\"modal-title\" *ngIf=\"modalContent?.title\">{{ modalContent.title }}</h3>\n</div>\n<div class=\"modal-body\" style=\"padding: 20px!important;\">\n    <p *ngIf=\"modalContent?.description\" class=\"f-s-16\">\n        <strong>{{ modalContent.description }}</strong>\n    </p>\n    <div class=\"mt-15 display-inline\">\n        <button *ngIf=\"successButton\" (click)=\"writeOff()\"\n                [disabled]=\"disableButton\" spinning-wheel [is-spinning-wheel-active]=\"disableButton\"\n                class=\"btn btn-{{successButton.color}} btn-{{successButton.size}} pull-left mr-15\"\n                >{{ successButton.text }}</button>\n        <button *ngIf=\"cancelButton\" class=\"btn btn-{{cancelButton.color}} btn-{{cancelButton.size}} pull-left\" [disabled]=\"disableButton\" (click)=\"dismissModal()\">{{ cancelButton.text }}</button>\n    </div>\n</div>\n"

/***/ }),

/***/ "./web/modern/components/payments/modals/write-off-modal/write-off-modal.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var payments_data_service_1 = __webpack_require__("./shared/services/payments/payments-data-service/payments.data.service.ts");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var rxjs_1 = __webpack_require__("./node_modules/rxjs/Rx.js");
var ng_bootstrap_1 = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/index.js");
var WriteOffModalComponent = function () {
    function WriteOffModalComponent(paymentsDataService, messageService, activeModal) {
        _classCallCheck(this, WriteOffModalComponent);

        this.paymentsDataService = paymentsDataService;
        this.messageService = messageService;
        this.activeModal = activeModal;
        this.updateParent = new core_1.EventEmitter();
        this.unsubscribe = new rxjs_1.Subject();
    }

    _createClass(WriteOffModalComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            if (this.modalContent && this.modalContent.buttons) {
                var _modalContent$buttons = _slicedToArray(this.modalContent.buttons, 2),
                    successButton = _modalContent$buttons[0],
                    cancelButton = _modalContent$buttons[1];

                this.successButton = successButton;
                this.cancelButton = cancelButton;
            }
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "writeOff",
        value: function writeOff() {
            var _this = this;

            this.disableButton = true;
            this.paymentsDataService.writeOff(this.paymentId).pipe(operators_1.finalize(function () {
                _this.disableButton = false;
                _this.activeModal.close();
            }), operators_1.takeUntil(this.unsubscribe)).subscribe(function () {
                _this.updateParent.emit(true);
                _this.messageService.showToaster('s_6', 'payments');
            }, function (result) {
                return _this.errorWriteOff(result.error);
            });
        }
    }, {
        key: "dismissModal",
        value: function dismissModal() {
            this.activeModal.dismiss();
        }
    }, {
        key: "errorWriteOff",
        value: function errorWriteOff(error) {
            if (error.errorCode) {
                this.handleModernErrorMessages(error);
                return;
            }
            if (error.errorMessage === 'Write off feature disabled for copied to QuickBooks invoices') {
                this.messageService.showToaster('e_16', 'qb');
            } else {
                this.messageService.showDefaultErrorMessage(error);
            }
        }
    }, {
        key: "handleModernErrorMessages",
        value: function handleModernErrorMessages(_ref) {
            var errorTitle = _ref.errorTitle,
                errorMessage = _ref.errorMessage;

            this.messageService.showErrorFromBackend(errorTitle, errorMessage);
        }
    }]);

    return WriteOffModalComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], WriteOffModalComponent.prototype, "modalContent", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], WriteOffModalComponent.prototype, "paymentId", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], WriteOffModalComponent.prototype, "updateParent", void 0);
WriteOffModalComponent = __decorate([core_1.Component({
    selector: 'write-off-modal',
    template: __webpack_require__("./web/modern/components/payments/modals/write-off-modal/write-off-modal.html")
}), __metadata("design:paramtypes", [payments_data_service_1.PaymentsDataServiceProvider, message_service_1.MessageService, ng_bootstrap_1.NgbActiveModal])], WriteOffModalComponent);
exports.WriteOffModalComponent = WriteOffModalComponent;

/***/ }),

/***/ "./web/modern/components/payments/payments-overview/payments-overview.component.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"new-container bg-white btn-layout\">\n    <div class=\"row\">\n        <div class=\"col-12 col-xs-6\">\n            <h2>Payments Overview</h2>\n\n            <div class=\"bc-wrap bc-no-line\">\n                <ol class=\"bc-list mt-0 mb-0\">\n                    <li><a href=\"/\">Dashboard</a></li>\n                    <li class=\"active\">Payments Overview</li>\n                </ol>\n            </div>\n\n        </div>\n        <div class=\"col-12 col-xs-6 text-sm-right not-print align-btn mb-20 payments-right-panel\">\n\n            <div class=\"color-java pull-right\">\n                <h2> {{ totalDue }} </h2>\n                <div class=\"color-grey\">\n                    {{ isPaidSelected === 'paid' ? \"Total Paid\" : \"Total Due\" }}\n                </div>\n            </div>\n\n            <button (click)=\"openExportPaymentModal()\"  class=\"btn btn-export btn-export-payments btn-lg mr-20 pull-lg-right\">\n                <i class=\"fi fi-export\"></i>\n                <span>Export</span><span class=\"btn-hide-text\"> Payments</span>\n            </button>\n        </div>\n    </div>\n    <div class=\"flex-row flex-wrap-xs flex-just-space btns-full-xm\">\n        <div class=\"select-style main-input-item\">\n            <select (ngModelChange)=\"changePaymentsFilter($event)\" [(ngModel)]=\"isPaidSelected\" >\n                <option [value]=\"'unpaid'\">Unpaid</option>\n                <option [value]=\"'paid'\">Paid</option>\n            </select>\n        </div>\n\n        <div class=\"main-input-item input-search\">\n            <input [formControl]=\"paymentSearch\" class=\"form-control input-search-input\" id=\"payments-search-input\" placeholder=\"Search\" type=\"text\">\n            <label class=\"input-search-label\" for=\"payments-search-input\"></label>\n        </div>\n    </div>\n\n    <div class=\"table-responsive table-row-link\">\n        <table class=\"table table-responsive table-with-links table-payments\">\n            <thead class=\"invoice-thead\">\n                <tr>\n                    <th>\n                        <b>Status</b>\n                    </th>\n                    <th>\n                        <b (click)=\"orderByField('paymentDate')\" class=\"pointer\">\n                            Due\n                            <span *ngIf=\"pageRequest.sortCriterias[0].fieldName === 'paymentDate'\"\n                                  [ngClass]=\"pageRequest.sortCriterias[0].sortAscending ? 'fa-caret-up' : 'fa-caret-down'\"\n                                  class=\"fa\"\n                            ></span>\n                        </b>\n                    </th>\n                    <th [hidden]=\"isPaidSelected == 'unpaid'\">\n                        <b (click)=\"orderByField('paidOn')\" class=\"pointer\">\n                            Paid on\n                            <span *ngIf=\"pageRequest.sortCriterias[0].fieldName === 'paidOn'\"\n                                  [ngClass]=\"pageRequest.sortCriterias[0].sortAscending ? 'fa-caret-up' : 'fa-caret-down'\"\n                                  class=\"fa\"\n                            ></span>\n                        </b>\n                    </th>\n                    <th>\n                        <b (click)=\"orderByField('id')\" class=\"pointer\">\n                            Invoice ID\n                            <span *ngIf=\"pageRequest.sortCriterias[0].fieldName === 'id'\"\n                                  [ngClass]=\"pageRequest.sortCriterias[0].sortAscending ? 'fa-caret-up' : 'fa-caret-down'\"\n                                  class=\"fa\"\n                            ></span>\n                        </b>\n                    </th>\n                    <th>\n                        <b (click)=\"orderByField('clientFirstName')\" class=\"pointer\" >\n                            Client\n                            <span *ngIf=\"pageRequest.sortCriterias[0].fieldName === 'clientFirstName'\"\n                                  [ngClass]=\"pageRequest.sortCriterias[0].sortAscending ? 'fa-caret-up' : 'fa-caret-down'\"\n                                  class=\"fa\"\n                            ></span>\n                        </b>\n                    </th>\n                    <th>\n                        <b (click)=\"orderByField('jobName')\" class=\"pointer\" >\n                            Job\n                            <span *ngIf=\"pageRequest.sortCriterias[0].fieldName === 'jobName'\"\n                                  [ngClass]=\"pageRequest.sortCriterias[0].sortAscending ? 'fa-caret-up' : 'fa-caret-down'\"\n                                  class=\"fa\"\n                            ></span>\n                        </b>\n                    </th>\n                    <th class=\"text-right\">\n                        <b (click)=\"orderByField('amount')\" class=\"pointer\" >\n                            Amount\n                            <span *ngIf=\"pageRequest.sortCriterias[0].fieldName === 'amount'\"\n                                  [ngClass]=\"pageRequest.sortCriterias[0].sortAscending ? 'fa-caret-up' : 'fa-caret-down'\"\n                                  class=\"fa\"\n                            ></span>\n                        </b>\n                    </th>\n                    <th class=\"text-right\">\n                        <b class=\"pr-10\">Action</b>\n                    </th>\n                </tr>\n            </thead>\n            <tbody>\n               <tr *ngFor=\"let payment of paymentItems | paginate: { itemsPerPage: pageRequest.paging.pageSize, currentPage: currentPage, totalItems: itemsQuantity }\" class=\"pointer hover-tr\">\n                   <td>\n                       <a class=\"table-link\" href=\"invoices/{{payment.invoiceId}}\"></a>\n                       <p class=\"invoice-blocks payment-{{payment.state.level}}\">{{ payment.state.name }}</p>\n                   </td>\n                   <td class=\"text-nowrap\">\n                       <a class=\"table-link\" href=\"invoices/{{payment.invoiceId}}\"></a>\n                       {{ payment.dueOn | timeFilter: 'long' }} <span [hidden]=\"isPaidSelected == 'paid'\" [ngClass]=\"payment.daysToDue < 0 ? 'red': 'gray-label'\">({{ payment.formattedDaysToDue }})</span>\n                   </td>\n                   <td [hidden]=\"isPaidSelected == 'unpaid'\" class=\"text-nowrap\">\n                       <a class=\"table-link\" href=\"invoices/{{payment.invoiceId}}\"></a>\n                     {{ payment.paidOn }}\n                   </td>\n                   <td class=\"text-nowrap\">\n                       <a class=\"table-link\" href=\"invoices/{{payment.invoiceId}}\"></a>\n                       {{ payment.invoiceDisplayId }}\n\n                       <icon-tooltip *ngIf=\"payment.accountingState\"\n                                     [status]=\"setCorrectTooltip(payment.accountingState)\"\n                                     [text]=\"payment.accountingState.explanationText\">\n                       </icon-tooltip>\n                   </td>\n                   <td class=\"text-nowrap\">\n                       <a class=\"table-link\" href=\"invoices/{{payment.invoiceId}}\"></a>\n                       {{ payment.clientFullName }}\n                   </td>\n                   <td class=\"text-nowrap\">\n                       <a class=\"table-link\" href=\"invoices/{{payment.invoiceId}}\"></a>\n                       {{ payment.jobName }}\n                   </td>\n                   <td class=\"text-right\">\n                       <a class=\"table-link\" href=\"invoices/{{payment.invoiceId}}\"></a>\n                       {{ payment.amountWithCurrency.amountWithCurrency }}\n                   </td>\n                   <td class=\"text-right\">\n                       <button (click)=\"openRecordPaymentModal(payment)\" *ngIf=\"payment.availableActions.RECORD && payment.availableActions.RECORD.state ==='active'\" class=\"mb-0 btn btn-default\" >\n                           Record payment\n                       </button>\n                       <button (click)=\"openSendReciptModal(payment)\" *ngIf=\"payment.availableActions.SEND_RECEIPT && payment.availableActions.SEND_RECEIPT.state === 'active'\" class=\"mb-0 btn btn-default\">\n                           Send receipt\n                       </button>\n                   </td>\n               </tr>\n            </tbody>\n        </table>\n        <sn-new-pagination [previousLabel]=\"'Prev'\"\n                           [nextLabel]=\"'Next'\"\n                           [responsive]=\"true\"\n                           [autoHide]=\"true\"\n                           [pageNumbers]=\"pageNumbers\"\n                           [pageRequest]=\"pageRequest\"\n                           [totalItems]=\"itemsQuantity\"\n                           (pageChange)=\"updatePayments($event)\"\n                           (pageBoundsCorrection)=\"updatePayments($event)\"\n                            >\n        </sn-new-pagination>\n    </div>\n</section>\n\n<record-payment-modal (updateParent)=\"updatePaymentsAfterRecord()\" [selectedPayment]=\"selectedPayment\"></record-payment-modal>\n"

/***/ }),

/***/ "./web/modern/components/payments/payments-overview/payments-overview.component.scss":
/***/ (function(module, exports) {

module.exports = ":host .invoice-blocks {\n  font-size: 11px;\n  padding: 1px 0;\n  margin: 0; }\n\n:host .table-payments.table tbody > tr > td {\n  height: 65px !important; }\n\n:host .payment-warning {\n  background-color: #f35d5d; }\n\n:host .payment-primary {\n  background-color: #999999; }\n\n:host .payment-success {\n  background-color: #91c847; }\n"

/***/ }),

/***/ "./web/modern/components/payments/payments-overview/payments-overview.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var payments_data_service_1 = __webpack_require__("./shared/services/payments/payments-data-service/payments.data.service.ts");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var invoice_service_1 = __webpack_require__("./shared/services/invoice/invoice-service/invoice.service.ts");
var Observable_1 = __webpack_require__("./node_modules/rxjs/Observable.js");
var forms_1 = __webpack_require__("./node_modules/@angular/forms/esm5/forms.js");
var file_download_data_service_1 = __webpack_require__("./shared/services/files/file-download-service/file-download.data.service.ts");
var pagination_service_1 = __webpack_require__("./shared/services/pagination/pagination.service.ts");
var account_service_1 = __webpack_require__("./web/modern/services/user/account.service.ts");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var export_payments_modal_1 = __webpack_require__("./web/modern/components/payments/modals/export-payments-modal/export-payments-modal.ts");
var rxjs_1 = __webpack_require__("./node_modules/rxjs/Rx.js");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var settings_1 = __webpack_require__("./shared/services/settings/settings.ts");
var common_1 = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
var PaymentsOverviewComponent = function () {
    function PaymentsOverviewComponent(paymentsDataService, invoiceService, fileDownloadDataService, paginationService, messageService, modalService, accountService, settingsService, location) {
        _classCallCheck(this, PaymentsOverviewComponent);

        this.paymentsDataService = paymentsDataService;
        this.invoiceService = invoiceService;
        this.fileDownloadDataService = fileDownloadDataService;
        this.paginationService = paginationService;
        this.messageService = messageService;
        this.modalService = modalService;
        this.accountService = accountService;
        this.settingsService = settingsService;
        this.location = location;
        this.openSendReceiptModalEvent = new core_1.EventEmitter();
        this.PAYMENTS_REQUEST_DEFAULT = {
            paging: {
                pageNumber: 0,
                pageSize: 25,
                searchToken: null
            },
            sortCriterias: [{
                fieldName: 'paymentDate',
                sortAscending: true
            }],
            search: '',
            filterBy: 'unpaid'
        };
        this.currentPage = 0;
        this.firstLoad = true;
        this.toUpdateUrl = true;
        this.unsubscribe = new rxjs_1.Subject();
    }

    _createClass(PaymentsOverviewComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.getCompanyId();
            this.applyPageProductFromLocalStorage();
            this.getPaymentsAndTotalDue();
            this.initPaymentSearch();
            this.getCompanyId();
            this.getPaymentExportState();
            this.subscribeToUrl();
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "updatePayments",
        value: function updatePayments() {
            var _this = this;

            var pageRequest = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.pageRequest;

            this.pageRequest = pageRequest;
            this.pageRequest.paging.pageNumber = this.pageRequest.paging.pageNumber === 0 || this.pageRequest.paging.pageNumber === this.currentUpdatedPage ? this.pageRequest.paging.pageNumber : this.pageRequest.paging.pageNumber - 1;
            this.getPayments().subscribe(function (data) {
                return _this.successGetPayments(data);
            }, function (error) {
                return _this.messageService.showDefaultErrorMessage(error);
            });
        }
    }, {
        key: "updatePaymentsAfterRecord",
        value: function updatePaymentsAfterRecord() {
            if (this.paymentItems.length === 1) {
                this.pageRequest.paging.searchToken = null;
            } else {
                this.currentUpdatedPage = this.currentPage - 1;
                this.pageRequest.paging.searchToken = null;
            }
            this.updatePayments();
        }
    }, {
        key: "initPaymentSearch",
        value: function initPaymentSearch() {
            var _this2 = this;

            this.paymentSearch.valueChanges.subscribe(function (res) {
                _this2.pageRequest.search = res;
                _this2.pageRequest.paging.searchToken = null;
                _this2.updatePayments();
            });
        }
    }, {
        key: "getPayments",
        value: function getPayments() {
            return this.paymentsDataService.getPaymentsV1(this.pageRequest);
        }
    }, {
        key: "getTotalDue",
        value: function getTotalDue() {
            return this.paymentsDataService.getTotalDueV1(this.isPaidSelected);
        }
    }, {
        key: "changePaymentsFilter",
        value: function changePaymentsFilter(filter) {
            this.isPaidSelected = filter;
            this.pageRequest.filterBy = filter;
            this.pageRequest.paging.searchToken = null;
            if (filter === 'unpaid') {
                this.pageRequest.sortCriterias[0].sortAscending = true;
                this.pageRequest.sortCriterias[0].fieldName = 'paymentDate';
                this.pageRequest.paging.pageNumber = 0;
            } else {
                this.pageRequest.sortCriterias[0].fieldName = 'paidOn';
                this.pageRequest.sortCriterias[0].sortAscending = false;
                this.pageRequest.paging.pageNumber = 0;
            }
            this.getPaymentsAndTotalDue();
        }
    }, {
        key: "orderByField",
        value: function orderByField(filter) {
            if (this.pageRequest.sortCriterias[0].fieldName === filter) {
                this.pageRequest.sortCriterias[0].sortAscending = !this.pageRequest.sortCriterias[0].sortAscending;
            } else {
                this.pageRequest.sortCriterias[0].fieldName = filter;
                this.pageRequest.sortCriterias[0].sortAscending = false;
            }
            this.pageRequest.paging.searchToken = null;
            this.currentUpdatedPage = this.currentPage - 1;
            this.updatePayments();
        }
    }, {
        key: "openRecordPaymentModal",
        value: function openRecordPaymentModal(payment) {
            this.selectedPayment = JSON.parse(JSON.stringify(payment));
            // RecordPaymentModalComponent use old version api
            // Need prepare payment before open modal
            this.selectedPayment.amount = payment.amountWithCurrency.amount;
            this.selectedPayment.currencySymbol = payment.amountWithCurrency.currencySymbol;
            $('#markAsPayedModal').modal('show');
        }
    }, {
        key: "openSendReciptModal",
        value: function openSendReciptModal(payment) {
            var paymentForEmit = {
                id: payment.id,
                email: payment.clientEmail,
                secondaryEmail: payment.secondaryClientEmail
            };
            this.openSendReceiptModalEvent.emit(paymentForEmit);
        }
    }, {
        key: "openExportPaymentModal",
        value: function openExportPaymentModal() {
            this.selectedPackageModalRef = this.modalService.openModal(export_payments_modal_1.ExportPaymentsModalComponent, { windowClass: 'ng-bootstrap-modal modal-export-payments' });
            this.selectedPackageModalRef.componentInstance.modalTitle = 'Export Payments';
            this.selectedPackageModalRef.componentInstance.btnDisabled = false;
        }
    }, {
        key: "setCorrectTooltip",
        value: function setCorrectTooltip(state) {
            switch (state.status) {
                case 'DISCONNECTED':
                    return 'error';
                case 'FAILED_TO_COPY':
                    return 'warning';
                case 'NOT_COPIED':
                    return 'info';
                default:
                    return 'error';
            }
        }
    }, {
        key: "getCompanyId",
        value: function getCompanyId() {
            var _this3 = this;

            this.accountService.companyIdObservable.subscribe(function (companyId) {
                return _this3.companyId = companyId;
            });
        }
    }, {
        key: "getPaymentsAndTotalDue",
        value: function getPaymentsAndTotalDue() {
            var _this4 = this;

            Observable_1.Observable.zip(this.getPayments(), this.getTotalDue()).subscribe(function (_ref) {
                var _ref2 = _slicedToArray(_ref, 2),
                    payments = _ref2[0],
                    total = _ref2[1];

                _this4.successGetPayments(payments);
                _this4.totalDue = total.data.amountWithCurrency;
            }, function (error) {
                return _this4.messageService.showDefaultErrorMessage(error);
            });
        }
    }, {
        key: "successGetPayments",
        value: function successGetPayments(data) {
            var _JSON$parse = JSON.parse(JSON.stringify(data)),
                items = _JSON$parse.items,
                searchToken = _JSON$parse.searchToken,
                totalSize = _JSON$parse.totalSize;

            this.paymentItems = this.invoiceService.setFormattedDaysToDue(items);
            this.itemsQuantity = data ? totalSize : 0;
            this.currentUpdatedPage = 0;
            this.currentPage = this.pageRequest.paging.pageNumber + 1;
            this.pageRequest.paging.searchToken = searchToken;
            this.pageNumbers = this.paginationService.calculatePageNumbers(this.itemsQuantity, this.pageRequest.paging.pageSize);
            var newUrl = new URL(location.href);
            newUrl.searchParams.set('page', "" + this.pageRequest.paging.pageNumber);
            if (this.pageRequest.search) {
                newUrl.searchParams.set('search', this.pageRequest.search);
            } else {
                newUrl.searchParams.delete('search');
            }
            if (this.firstLoad) {
                window.history.replaceState(null, null, newUrl.toString());
                this.firstLoad = false;
            } else if (this.toUpdateUrl) {
                window.history.pushState(null, null, newUrl.toString());
            }
            this.toUpdateUrl = true;
            this.setPageProductToLocalStorage(this.pageRequest);
        }
        // LOCAL STORAGE

    }, {
        key: "applyPageProductFromLocalStorage",
        value: function applyPageProductFromLocalStorage() {
            this.paymentSearch = new forms_1.FormControl('', [forms_1.Validators.maxLength(255)]);
            var pageRequestObject = JSON.parse(localStorage.getItem("SNPaymentsRequest_" + this.companyId));
            this.pageRequest = this.PAYMENTS_REQUEST_DEFAULT;
            var urlParams = new URL(location.href).searchParams;
            var page = urlParams.get('page');
            var search = urlParams.get('search');
            this.pageRequest.paging.pageNumber = Number(page) || 0;
            if (search) {
                this.pageRequest.search = search;
                this.paymentSearch.setValue(search);
            }
            this.isPaidSelected = 'unpaid';
            if (pageRequestObject && pageRequestObject !== null && pageRequestObject !== '') {
                var pageSize = pageRequestObject.pageSize,
                    filterBy = pageRequestObject.filterBy;

                this.pageRequest.paging.pageSize = pageSize;
                this.pageRequest.filterBy = filterBy;
                this.isPaidSelected = filterBy;
                if (filterBy === 'paid') {
                    this.pageRequest.sortCriterias[0].fieldName = 'paidOn';
                    this.pageRequest.sortCriterias[0].sortAscending = false;
                }
            }
        }
    }, {
        key: "setPageProductToLocalStorage",
        value: function setPageProductToLocalStorage(pageRequest) {
            var pageRequestObject = {
                pageSize: pageRequest.paging.pageSize,
                filterBy: this.isPaidSelected
            };
            var pageRequestString = JSON.stringify(pageRequestObject);
            localStorage.removeItem("SNPaymentsRequest_" + this.companyId);
            localStorage.setItem("SNPaymentsRequest_" + this.companyId, pageRequestString);
        }
    }, {
        key: "getPaymentExportState",
        value: function getPaymentExportState() {
            var _this5 = this;

            this.settingsService.timeFormatSettings.pipe(operators_1.takeUntil(this.unsubscribe), operators_1.filter(function (data) {
                return !!data;
            }), operators_1.map(function (data) {
                return data.paymentExportAvailable;
            })).subscribe(function (exportState) {
                return _this5.exportAvailable = exportState;
            });
        }
    }, {
        key: "subscribeToUrl",
        value: function subscribeToUrl() {
            var _this6 = this;

            this.location.onPopState(function (e) {
                if (_this6.location.pathname === '/payments') {
                    // prevent aupdating history state with back button
                    _this6.toUpdateUrl = false;
                    var urlParams = new URLSearchParams(_this6.location.search);
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = urlParams.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var iterator = _step.value;

                            if (iterator[0] === 'page') {
                                _this6.pageRequest.paging.pageNumber = Number(iterator[1]) + 1;
                            }
                            if (iterator[0] === 'search') {
                                _this6.paymentSearch.setValue(iterator[1]);
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }

                    if (!urlParams.has('search')) {
                        _this6.paymentSearch.setValue('');
                    }
                }
            });
        }
    }]);

    return PaymentsOverviewComponent;
}();
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], PaymentsOverviewComponent.prototype, "openSendReceiptModalEvent", void 0);
PaymentsOverviewComponent = __decorate([core_1.Component({
    selector: 'payments-overview',
    template: __webpack_require__("./web/modern/components/payments/payments-overview/payments-overview.component.html"),
    styles: [__webpack_require__("./web/modern/components/payments/payments-overview/payments-overview.component.scss")]
}), __metadata("design:paramtypes", [payments_data_service_1.PaymentsDataServiceProvider, invoice_service_1.InvoiceServiceProvider, file_download_data_service_1.FileDownloadDataServiceProvider, pagination_service_1.PaginationService, message_service_1.MessageService, snModal_service_1.SNModalService, account_service_1.AccountServiceWebProvider, settings_1.SettingsProvider, common_1.PlatformLocation])], PaymentsOverviewComponent);
exports.PaymentsOverviewComponent = PaymentsOverviewComponent;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./web/modern/components/price-tag/price-tag.component.html":
/***/ (function(module, exports) {

module.exports = "<span class=\"price-tag-label\">{{ price }}</span>"

/***/ }),

/***/ "./web/modern/components/price-tag/price-tag.component.scss":
/***/ (function(module, exports) {

module.exports = ":host .price-tag-label {\n  font-weight: 700;\n  color: #4990e0;\n  font-size: 14px;\n  padding: 5px 10px;\n  background-color: #eaf4fd;\n  display: inline-block;\n  -webkit-box-flex: 1;\n  -webkit-flex: 1 1;\n      -ms-flex: 1 1;\n          flex: 1 1;\n  white-space: nowrap; }\n"

/***/ }),

/***/ "./web/modern/components/price-tag/price-tag.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var PriceTagComponent = function PriceTagComponent() {
    _classCallCheck(this, PriceTagComponent);
};
__decorate([core_1.Input(), __metadata("design:type", String)], PriceTagComponent.prototype, "price", void 0);
PriceTagComponent = __decorate([core_1.Component({
    selector: 'price-tag',
    template: __webpack_require__("./web/modern/components/price-tag/price-tag.component.html"),
    styles: [__webpack_require__("./web/modern/components/price-tag/price-tag.component.scss")]
}), __metadata("design:paramtypes", [])], PriceTagComponent);
exports.PriceTagComponent = PriceTagComponent;

/***/ }),

/***/ "./web/modern/components/questionnaire/questionnaire.html":
/***/ (function(module, exports) {

module.exports = "<div *ngIf=\"questionnaire\">\n    <div class=\"group-btn not-print\">\n        <button (click)=\"emitQuestionnaireSend()\" *ngIf=\"actions.SEND_QUESTIONNAIRE\" class=\"btn btn-default btn-lg\">\n            <i class=\"fi fi-send\"></i>\n            Send Questionnaire\n        </button>\n        <button (click)=\"previewQuestionnaire()\"  *ngIf=\"actions.GET_CLIENT_PORTAL_LINK\"\n                [disabled]=\"btnDisable\" [is-spinning-wheel-active]=\"btnDisable\" [is-spinning-wheel-dark]=\"'true'\"\n                class=\"btn btn-default btn-lg\"\n                spinning-wheel>\n            <i class=\"fi fi-view\"></i>\n            Preview\n        </button>\n        <button (click)=\"saveAsPdf()\" *ngIf=\"actions.SAVE_AS_PDF\" [disabled]=\"pdfSpinner\"\n                [is-spinning-wheel-active]=\"pdfSpinner\" [is-spinning-wheel-dark]=\"'true'\" class=\"btn btn-default btn-lg\"\n                spinning-wheel>\n            <i class=\"fa fa-file-pdf-o\"></i>{{ actions.SAVE_AS_PDF.actionName }}\n        </button>\n        <print-btn *ngIf=\"actions.PRINT_QUESTIONNAIRE && frameLoaded\"></print-btn>\n        <button (click)=\"deleteQuestionnaire()\" *ngIf=\"actions.DELETE_QUESTIONNAIRE\" class=\"btn btn-default btn-lg btn-delete\">Delete</button>\n    </div>\n\n    <div class=\"questionnaire box-shadow mb-30 col-xs-12 flex-box flex-row\">\n        <div *ngIf=\"companyImageSrc && frameLoaded\"  class=\"questionnaire-logo\">\n            <img [src]=\"companyImageSrc\" alt=\"Company image\" class=\"client-company-image-max-height client-company-image\">\n        </div>\n\n        <div class=\"questionnaire-body\">\n            <ng-container *ngIf=\"frameLoaded\">\n                <h2 class=\"ml-10 mb-30 mt-0\">{{ questionnaire.name }}</h2>\n\n\n                <div class=\"questionnaire-status-container ml-10 mb-30 mr-10\">\n                    <p *ngIf=\"questionnaire.sentDate\" class=\"mb-0\">Sent on <span>{{ questionnaire.sentDate | timeFilter: 'long' }}</span></p>\n\n                    <p *ngIf=\"questionnaire.submitDate\" class=\"mb-0\">\n                        Completed on {{ questionnaire.submitDate | timeFilter: 'long' }}\n\n                        <ng-container *ngIf=\"questionnaire.optInConsent\">\n                            <span> {{ questionnaire?.optInConsent?.optInConsent ? 'with' : 'without' }}</span>\n                            opt-in consent\n                        </ng-container>\n\n                    </p>\n\n                    <span class=\"q-status mb-5 mt-5 {{questionnaire.status.toUpperCase() === 'INCOMPLETE' ? 'q-incomplete' : 'q-complete'}}\" >\n                    {{ questionnaire.status }}\n                 </span>\n                </div>\n            </ng-container>\n\n            <iframe [src]=\"questionnaire.parserLink | safe: 'resourceUrl'\" allowfullscreen\n                    #frameRef\n                    data-is-read-only=\"true\"\n                    data-is-submit-button-visible=\"false\"\n                    data-should-trigger-auto-save=\"false\"\n                    [attr.data-should-show-values]=\"questionnaire.submitState === 'COMPLETED'\"\n                    height=\"918\"\n                    id=\"questionnaireIframe\"\n                    snIframeResizer\n                    [hidden]=\"!frameLoaded\"\n                    style=\"min-width: 100%; max-width: 1440px; border: 0;\">\n            </iframe>\n\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "./web/modern/components/questionnaire/questionnaire.scss":
/***/ (function(module, exports) {

module.exports = ".questionnaire-status-container {\n  padding: 10px 15px;\n  color: #4e5e6a !important;\n  min-width: 74px;\n  text-decoration: none;\n  border: 1px solid rgba(0, 0, 0, 0.125);\n  background-color: rgba(0, 0, 0, 0.03) !important;\n  -webkit-print-color-adjust: exact;\n  color-adjust: exact; }\n  .questionnaire-status-container .q-status {\n    display: inline-block;\n    border-radius: 4px;\n    padding: 4px;\n    color: #ffffff !important;\n    font-weight: bold;\n    font-size: 12px; }\n  .questionnaire-status-container .q-incomplete {\n    background: #f29715 !important; }\n  .questionnaire-status-container .q-complete {\n    background: #7ab800 !important; }\n\n.questionnaire-logo {\n  margin: 0 30px 0 40px;\n  text-align: center;\n  max-width: 400px; }\n  .questionnaire-logo img {\n    height: auto; }\n\n.questionnaire-body {\n  width: 100%;\n  max-width: 800px; }\n\n@media print {\n  .questionnaire {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: column;\n        -ms-flex-direction: column;\n            flex-direction: column; }\n    .questionnaire-logo {\n      -webkit-align-self: center;\n          -ms-flex-item-align: center;\n              align-self: center; }\n    .questionnaire-body {\n      max-width: 100%; } }\n\n@media screen and (max-width: 991px) {\n  .questionnaire {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: column;\n        -ms-flex-direction: column;\n            flex-direction: column; }\n    .questionnaire-logo {\n      -webkit-align-self: center;\n          -ms-flex-item-align: center;\n              align-self: center; } }\n"

/***/ }),

/***/ "./web/modern/components/questionnaire/questionnaire.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var questionnaires_data_service_1 = __webpack_require__("./shared/services/questionnarie/questionnaires.data.service.ts");
var rxjs_1 = __webpack_require__("./node_modules/rxjs/Rx.js");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var mails_data_service_1 = __webpack_require__("./shared/services/email/mails.data.service.ts");
var file_download_data_service_1 = __webpack_require__("./shared/services/files/file-download-service/file-download.data.service.ts");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var delete_item_modal_1 = __webpack_require__("./web/modern/components/settings/common/delete-item-modal/delete-item-modal.ts");
var QuestionnaireComponent = function () {
    function QuestionnaireComponent(questionnairesDataService, messageService, mailsDataService, fileDownloadService, modalService, renderer) {
        _classCallCheck(this, QuestionnaireComponent);

        this.questionnairesDataService = questionnairesDataService;
        this.messageService = messageService;
        this.mailsDataService = mailsDataService;
        this.fileDownloadService = fileDownloadService;
        this.modalService = modalService;
        this.renderer = renderer;
        this.questionnaireSend = new core_1.EventEmitter();
        this.questionnaireDelete = new core_1.EventEmitter();
        this.unsubscribe = new rxjs_1.Subject();
    }

    _createClass(QuestionnaireComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.getTemplateData(this.jobId, this.questionnaireId);
            this.listenToMailUpdate();
            this.listenToFrameDataLoad();
            this.listenToQuestionnaireV2Error();
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
            if (this.frameLoadSuccessEvent) {
                this.frameLoadSuccessEvent();
            }
            if (this.qErrorEvent) {
                this.qErrorEvent();
            }
        }
    }, {
        key: "previewQuestionnaire",
        value: function previewQuestionnaire() {
            var _this = this;

            this.btnDisable = true;
            this.questionnairesDataService.getQuestionnairePreviewLink(this.questionnaire.actions.GET_CLIENT_PORTAL_LINK.url).pipe(operators_1.takeUntil(this.unsubscribe), operators_1.finalize(function () {
                return _this.btnDisable = false;
            })).subscribe(function (data) {
                return window.open("clients/questionnaire/" + data.link + "/" + _this.questionnaire.id, '_blank');
            }, function (err) {
                return _this.errorHandleQuestionnaire(err);
            });
        }
    }, {
        key: "emitQuestionnaireSend",
        value: function emitQuestionnaireSend() {
            this.questionnaireSend.emit();
        }
    }, {
        key: "deleteQuestionnaire",
        value: function deleteQuestionnaire() {
            this.deleteModalRef = this.modalService.openModal(delete_item_modal_1.DeleteItemModalComponent);
            this.subscribeToModalData();
            this.deleteModalRef.componentInstance.modalTitle = 'Questionnaire';
            this.deleteModalRef.componentInstance.btnDisabled = false;
            this.deleteModalRef.componentInstance.itemName = this.questionnaire.name;
        }
    }, {
        key: "saveAsPdf",
        value: function saveAsPdf() {
            var _this2 = this;

            this.pdfSpinner = true;
            this.fileDownloadService.downloadPDF(this.actions.SAVE_AS_PDF.url, this.questionnaire.name, this.questionnaire.id).pipe(operators_1.finalize(function () {
                return _this2.pdfSpinner = false;
            })).subscribe(function () {}, function (err) {
                return _this2.errorHandleQuestionnaire(err);
            });
        }
    }, {
        key: "subscribeToModalData",
        value: function subscribeToModalData() {
            var _this3 = this;

            this.modalDataSubscription = this.modalService.getModalData().pipe(operators_1.filter(function (data) {
                return data && data.action;
            })).subscribe(function () {
                return _this3.deleteQuestionnaireAction();
            });
        }
    }, {
        key: "deleteQuestionnaireAction",
        value: function deleteQuestionnaireAction() {
            var _this4 = this;

            this.deleteModalRef.componentInstance.btnDisabled = true;
            this.questionnairesDataService.deleteQuestionnaireV2(this.actions.DELETE_QUESTIONNAIRE.url).pipe(operators_1.takeUntil(this.unsubscribe), operators_1.finalize(function () {
                _this4.deleteModalRef.componentInstance.btnDisabled = false;
                _this4.modalDataSubscription.unsubscribe();
                _this4.deleteModalRef.close();
            })).subscribe(function (data) {
                return _this4.questionnaireDelete.emit(data);
            }, function (err) {
                return _this4.errorHandleQuestionnaire(err);
            });
        }
    }, {
        key: "getTemplateData",
        value: function getTemplateData(jobId, questionnaireId) {
            var _this5 = this;

            this.questionnairesDataService.getQuestionnaireViewData(jobId, questionnaireId).pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (questionnaireData) {
                return _this5.handleTemplateResponse(questionnaireData);
            }, function (err) {
                return _this5.errorHandleQuestionnaire(err);
            });
        }
    }, {
        key: "onBeforePrint",
        value: function onBeforePrint() {
            this.frameRef.nativeElement.style.height = this.frameRef.nativeElement.offsetHeight + 200 + "px";
        }
    }, {
        key: "errorHandleQuestionnaire",
        value: function errorHandleQuestionnaire(_ref) {
            var error = _ref.error;
            var errorMessage = error.errorMessage,
                errorTitle = error.errorTitle;

            if (errorMessage.includes('This questionnaire is linked to an active workflow task and cannot be deleted. Please delete the workflow task first.')) {
                this.messageService.showToaster('e_2', 'questionnaires');
                return;
            }
            this.messageService.showErrorFromBackend(errorTitle, errorMessage);
        }
    }, {
        key: "listenToMailUpdate",
        value: function listenToMailUpdate() {
            var _this6 = this;

            this.mailsDataService.shouldMailsBeUpdatedObservable.pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (state) {
                if (state) {
                    _this6.getTemplateData(_this6.jobId, _this6.questionnaireId);
                }
            });
        }
    }, {
        key: "listenToFrameDataLoad",
        value: function listenToFrameDataLoad() {
            var _this7 = this;

            this.frameLoadSuccessEvent = this.renderer.listen('document', 'QuestionnaireDataLoadSuccess', function () {
                return _this7.frameLoaded = true;
            });
        }
    }, {
        key: "onAfterPrint",
        value: function onAfterPrint() {
            this.frameRef.nativeElement.style.height = this.frameRef.nativeElement.offsetHeight - 200 + "px";
        }
    }, {
        key: "handleTemplateResponse",
        value: function handleTemplateResponse(questionnaireData) {
            this.questionnaire = questionnaireData;
            this.actions = questionnaireData.actions;
        }
    }, {
        key: "listenToQuestionnaireV2Error",
        value: function listenToQuestionnaireV2Error() {
            var _this8 = this;

            this.qErrorEvent = this.renderer.listen('document', 'QuestionnaireValidationError', function (data) {
                var _data$detail = data.detail,
                    errorTitle = _data$detail.errorTitle,
                    errorMessage = _data$detail.errorMessage;

                _this8.messageService.showErrorFromBackend(errorTitle, errorMessage);
            });
        }
    }]);

    return QuestionnaireComponent;
}();
__decorate([core_1.ViewChild('frameRef'), __metadata("design:type", Object)], QuestionnaireComponent.prototype, "frameRef", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], QuestionnaireComponent.prototype, "jobId", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], QuestionnaireComponent.prototype, "questionnaireId", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], QuestionnaireComponent.prototype, "companyImageSrc", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], QuestionnaireComponent.prototype, "questionnaireSend", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], QuestionnaireComponent.prototype, "questionnaireDelete", void 0);
__decorate([core_1.HostListener('window:beforeprint', []), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", void 0)], QuestionnaireComponent.prototype, "onBeforePrint", null);
__decorate([core_1.HostListener('window:afterprint', []), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", void 0)], QuestionnaireComponent.prototype, "onAfterPrint", null);
QuestionnaireComponent = __decorate([core_1.Component({
    selector: 'questionnaire',
    template: __webpack_require__("./web/modern/components/questionnaire/questionnaire.html"),
    styles: [__webpack_require__("./web/modern/components/questionnaire/questionnaire.scss")]
}), __metadata("design:paramtypes", [questionnaires_data_service_1.QuestionnairesDataProvider, message_service_1.MessageService, mails_data_service_1.MailsDataProvider, file_download_data_service_1.FileDownloadDataServiceProvider, snModal_service_1.SNModalService, core_1.Renderer2])], QuestionnaireComponent);
exports.QuestionnaireComponent = QuestionnaireComponent;

/***/ }),

/***/ "./web/modern/components/quote/common/payment-schedule-template-list/template-apply-list.component.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"row show-grid\">\n  <div class=\"col-xs-12\">\n    <div class=\"col-gray\">\n      <div class=\"row \">\n        <div class=\"col-xs-12 col-sm-5\">\n          <h4>{{ text }}</h4>\n        </div>\n        <div class=\"col-xs-12 col-sm-7 col-md-3\">\n          <div class=\"select-style\">\n            <select [ngModel]=\"selectedTemplateId\" (ngModelChange)=\"onChange($event)\" [disabled]=\"disabled\" required>\n              <option [disabled]=\"disablePlaceholder\" [hidden]=\"disablePlaceholder\" [selected]=\"disablePlaceholder\"\n                [value]=-1>{{ defaultOptionName }}</option>\n              <option [value]=\"template[idField]\" *ngFor=\"let template of templateList\">{{ template.name }}</option>\n            </select>\n          </div>\n        </div>\n        <ng-content></ng-content>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),

/***/ "./web/modern/components/quote/common/payment-schedule-template-list/template-apply-list.component.scss":
/***/ (function(module, exports) {

module.exports = ""

/***/ }),

/***/ "./web/modern/components/quote/common/payment-schedule-template-list/template-apply-list.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var TemplateApplyListComponent = function () {
    function TemplateApplyListComponent() {
        _classCallCheck(this, TemplateApplyListComponent);

        this.idField = 'id';
        this.defaultOptionName = 'None';
        this.onTemplateChange = new core_1.EventEmitter();
    }

    _createClass(TemplateApplyListComponent, [{
        key: "onChange",
        value: function onChange(event) {
            this.onTemplateChange.emit(event);
        }
    }]);

    return TemplateApplyListComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", String)], TemplateApplyListComponent.prototype, "text", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], TemplateApplyListComponent.prototype, "idField", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], TemplateApplyListComponent.prototype, "defaultOptionName", void 0);
__decorate([core_1.Input(), __metadata("design:type", Array)], TemplateApplyListComponent.prototype, "templateList", void 0);
__decorate([core_1.Input(), __metadata("design:type", Boolean)], TemplateApplyListComponent.prototype, "disabled", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], TemplateApplyListComponent.prototype, "selectedTemplateId", void 0);
__decorate([core_1.Input(), __metadata("design:type", Boolean)], TemplateApplyListComponent.prototype, "disablePlaceholder", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], TemplateApplyListComponent.prototype, "onTemplateChange", void 0);
TemplateApplyListComponent = __decorate([core_1.Component({
    selector: 'template-apply-list',
    template: __webpack_require__("./web/modern/components/quote/common/payment-schedule-template-list/template-apply-list.component.html"),
    styles: [__webpack_require__("./web/modern/components/quote/common/payment-schedule-template-list/template-apply-list.component.scss")]
})], TemplateApplyListComponent);
exports.TemplateApplyListComponent = TemplateApplyListComponent;

/***/ }),

/***/ "./web/modern/components/quote/common/payment-shedule-template-group-list/template-apply-group-list.component.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"row show-grid\">\n    <div class=\"col-xs-12\">\n        <div class=\"col-gray\">\n            <div class=\"row \">\n                <div class=\"col-xs-12 col-sm-5\">\n                    <h4>{{ text }}</h4>\n                </div>\n                <div class=\"col-xs-12 col-sm-7 col-md-3\">\n                    <div class=\"select-style\">\n                        <select [ngModel]=\"selectedTemplateId\" (ngModelChange)=\"onChange($event)\" [disabled]=\"disabled\" required>\n                            <option [value]=\"template[idField]\" [disabled]=\"template?.disabled\" [hidden]=\"template?.disabled\" *ngFor=\"let template of templateDefaultList\">{{ template.name }}</option>\n                            <optgroup *ngIf=\"templateList?.length > 0\" label=\"{{ label }}\">\n                                <option [value]=\"template[idField]\" *ngFor=\"let template of templateList\">{{ template.name }}</option>\n                            </optgroup>\n                        </select>\n                    </div>\n                </div>\n                <ng-content></ng-content>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "./web/modern/components/quote/common/payment-shedule-template-group-list/template-apply-group-list.component.scss":
/***/ (function(module, exports) {

module.exports = ""

/***/ }),

/***/ "./web/modern/components/quote/common/payment-shedule-template-group-list/template-apply-group-list.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var TemplateApplyGroupListComponent = function () {
    function TemplateApplyGroupListComponent() {
        _classCallCheck(this, TemplateApplyGroupListComponent);

        this.idField = 'id';
        this.defaultOptionName = 'None';
        this.onTemplateChange = new core_1.EventEmitter();
    }

    _createClass(TemplateApplyGroupListComponent, [{
        key: "onChange",
        value: function onChange(event) {
            this.onTemplateChange.emit(event);
        }
    }]);

    return TemplateApplyGroupListComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", String)], TemplateApplyGroupListComponent.prototype, "text", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], TemplateApplyGroupListComponent.prototype, "idField", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], TemplateApplyGroupListComponent.prototype, "defaultOptionName", void 0);
__decorate([core_1.Input(), __metadata("design:type", Array)], TemplateApplyGroupListComponent.prototype, "templateList", void 0);
__decorate([core_1.Input(), __metadata("design:type", Array)], TemplateApplyGroupListComponent.prototype, "templateDefaultList", void 0);
__decorate([core_1.Input(), __metadata("design:type", Boolean)], TemplateApplyGroupListComponent.prototype, "disabled", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], TemplateApplyGroupListComponent.prototype, "selectedTemplateId", void 0);
__decorate([core_1.Input(), __metadata("design:type", Boolean)], TemplateApplyGroupListComponent.prototype, "disablePlaceholder", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], TemplateApplyGroupListComponent.prototype, "label", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], TemplateApplyGroupListComponent.prototype, "onTemplateChange", void 0);
TemplateApplyGroupListComponent = __decorate([core_1.Component({
    selector: 'template-apply-group-list',
    template: __webpack_require__("./web/modern/components/quote/common/payment-shedule-template-group-list/template-apply-group-list.component.html"),
    styles: [__webpack_require__("./web/modern/components/quote/common/payment-shedule-template-group-list/template-apply-group-list.component.scss")]
})], TemplateApplyGroupListComponent);
exports.TemplateApplyGroupListComponent = TemplateApplyGroupListComponent;

/***/ }),

/***/ "./web/modern/components/quote/common/quote-amount-info/quote-amount-info.component.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"row\">\n    <div class=\"col-xs-9 pr-0 text-right\">Subtotal :</div>\n    <div class=\"col-xs-2 pl-1 text-left\">{{ summary?.subTotalWithCurrency?.amountWithCurrency }}</div>\n    <div class=\"clearfix\"></div>\n\n    <div class=\"col-xs-9 pr-0 text-right\">{{ currencyAndTax?.taxName || 'Tax' }} :</div>\n    <div class=\"col-xs-2 pl-1 text-left\">{{ summary?.taxValueWithCurrency?.amountWithCurrency }}</div>\n    <div class=\"clearfix\"></div>\n\n    <div class=\"col-xs-9 pr-0 text-right\">Discount :</div>\n    <div class=\"col-xs-2 pl-1 text-left\">\n        {{ summary?.discountValue ? ' -' + summary?.discountValueWithCurrency?.amountWithCurrency : 'None' }}\n    </div>\n\n    <div class=\"col-xs-9 pr-0 text-right\"><b>Total Due :</b></div>\n    <div class=\"col-xs-2 pl-1 text-left\"><b class=\"ng-binding\">{{ summary?.totalWithCurrency?.amountWithCurrency }}</b></div>\n</div>"

/***/ }),

/***/ "./web/modern/components/quote/common/quote-amount-info/quote-amount-info.component.scss":
/***/ (function(module, exports) {

module.exports = ""

/***/ }),

/***/ "./web/modern/components/quote/common/quote-amount-info/quote-amount-info.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var QuoteAmountInfoComponent = function QuoteAmountInfoComponent() {
    _classCallCheck(this, QuoteAmountInfoComponent);
};
__decorate([core_1.Input(), __metadata("design:type", Object)], QuoteAmountInfoComponent.prototype, "summary", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], QuoteAmountInfoComponent.prototype, "currencyAndTax", void 0);
QuoteAmountInfoComponent = __decorate([core_1.Component({
    selector: 'quote-amount-info',
    template: __webpack_require__("./web/modern/components/quote/common/quote-amount-info/quote-amount-info.component.html"),
    styles: [__webpack_require__("./web/modern/components/quote/common/quote-amount-info/quote-amount-info.component.scss")]
}), __metadata("design:paramtypes", [])], QuoteAmountInfoComponent);
exports.QuoteAmountInfoComponent = QuoteAmountInfoComponent;

/***/ }),

/***/ "./web/modern/components/quote/common/quote-from-info/quote-from-info.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"jobs-cell-item\">\n    <h2 class=\"jobs-cell-title\">\n        <span>From</span>\n        <span class=\"fi-grey fi-person pull-right\"></span>\n    </h2>\n\n    <div class=\"section-data\">\n        <table class=\"table-profile\">\n            <tbody>\n            <tr *ngIf=\"company.name\">\n                <td>\n                    <b class=\"text-break-cell\">{{ company.name }}</b>\n                </td>\n            </tr>\n            <tr *ngIf=\"company.address\">\n                <td class=\"text-break\">{{ company.address }}</td>\n            </tr>\n            <tr *ngIf=\"company.city || company.state || company.postcode || company.country\">\n                <td class=\"text-break\">\n                    {{company.city}} {{ company.state }} {{ company.postcode }} {{ company.country }}\n                </td>\n            </tr>\n            <tr *ngIf=\"company.phone\">\n                <td class=\"text-break\">Phone number: {{ company.phone }}</td>\n            </tr>\n\n            <tr *ngIf=\"company.email\">\n                <td class=\"text-break\">Email: {{ company.email }}</td>\n            </tr>\n            <tr *ngIf=\"company.number\">\n                <td class=\"text-break\">{{ businessNumberLabelName }}: {{ company.number }}</td>\n            </tr>\n            </tbody>\n        </table>\n    </div>\n</div>\n"

/***/ }),

/***/ "./web/modern/components/quote/common/quote-from-info/quote-from-info.scss":
/***/ (function(module, exports) {

module.exports = ":host .jobs-cell-item {\n  margin: 0;\n  height: 100%; }\n"

/***/ }),

/***/ "./web/modern/components/quote/common/quote-from-info/quote-from-info.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var rxjs_1 = __webpack_require__("./node_modules/rxjs/Rx.js");
var settings_1 = __webpack_require__("./shared/services/settings/settings.ts");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var QuoteFromInfoComponent = function () {
    function QuoteFromInfoComponent(settingsService) {
        _classCallCheck(this, QuoteFromInfoComponent);

        this.settingsService = settingsService;
        this.unsubscribe = new rxjs_1.Subject();
    }

    _createClass(QuoteFromInfoComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.subscribeToCustomizeLabelsChange();
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "subscribeToCustomizeLabelsChange",
        value: function subscribeToCustomizeLabelsChange() {
            var _this = this;

            this.settingsService.customizeLabelsObservable.pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (customizeLabels) {
                return _this.businessNumberLabelName = customizeLabels.businessNumberLabel;
            });
        }
    }]);

    return QuoteFromInfoComponent;
}();
__decorate([core_1.Input('company'), __metadata("design:type", Object)], QuoteFromInfoComponent.prototype, "company", void 0);
QuoteFromInfoComponent = __decorate([core_1.Component({
    selector: 'quote-from-info',
    template: __webpack_require__("./web/modern/components/quote/common/quote-from-info/quote-from-info.html"),
    styles: [__webpack_require__("./web/modern/components/quote/common/quote-from-info/quote-from-info.scss")]
}), __metadata("design:paramtypes", [settings_1.SettingsProvider])], QuoteFromInfoComponent);
exports.QuoteFromInfoComponent = QuoteFromInfoComponent;

/***/ }),

/***/ "./web/modern/components/quote/common/quote-info/quote-info.html":
/***/ (function(module, exports) {

module.exports = "<div  class=\"section-quote-info\">\n    <div class=\"text-break section-quote flex-wrap\">\n        <b class=\"mr-5\">Quote ID</b> <span>{{ data.quoteId }}</span>\n    </div>\n    <div class=\"text-break section-quote flex-wrap\">\n        <b>Issue Date</b> <span>{{ data.issueDate | date: dateFormat }}</span>\n    </div>\n    <div class=\"text-break section-quote flex-wrap\" *ngIf=\"data.ponumber\">\n        <span id=\"ponumber-label\">PO Number</span>\n        <span id=\"ponumber-value\" [title]=\"data.ponumber===null ? '-': data.ponumber\">\n            {{ data.ponumber === null ? '-': data.ponumber }}\n        </span>\n    </div>\n</div>\n"

/***/ }),

/***/ "./web/modern/components/quote/common/quote-info/quote-info.scss":
/***/ (function(module, exports) {

module.exports = ":host .jobs-cell-item {\n  margin: 0;\n  height: 100%; }\n\n:host .section-quote {\n  font-size: 13px;\n  line-height: 20px;\n  padding: 18px 0;\n  border-top: 1px solid #d7d7d7;\n  color: #45464c;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n  -webkit-justify-content: space-between;\n      -ms-flex-pack: justify;\n          justify-content: space-between; }\n\n:host .section-quote-info {\n  background: #f9f9f9;\n  padding: 0px 20px;\n  height: 100%; }\n\n:host .section-quote:first-child {\n  border-top: none; }\n\n:host #ponumber-label {\n  font-weight: 700;\n  min-width: 85px; }\n\n:host #ponumber-value {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis; }\n"

/***/ }),

/***/ "./web/modern/components/quote/common/quote-info/quote-info.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var settings_1 = __webpack_require__("./shared/services/settings/settings.ts");
var QuoteInfoComponent = function () {
    function QuoteInfoComponent(settingsService) {
        _classCallCheck(this, QuoteInfoComponent);

        this.settingsService = settingsService;
    }

    _createClass(QuoteInfoComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            var _this = this;

            this.settingsService.timeFormatSettings.subscribe(function (data) {
                _this.dateFormat = data.dateFormat === 'DD_MM_YYYY' ? 'dd/MM/yyyy' : 'MM/dd/yyyy';
            });
        }
    }]);

    return QuoteInfoComponent;
}();
__decorate([core_1.Input('data'), __metadata("design:type", Object)], QuoteInfoComponent.prototype, "data", void 0);
QuoteInfoComponent = __decorate([core_1.Component({
    selector: 'quote-info',
    template: __webpack_require__("./web/modern/components/quote/common/quote-info/quote-info.html"),
    styles: [__webpack_require__("./web/modern/components/quote/common/quote-info/quote-info.scss")]
}), __metadata("design:paramtypes", [settings_1.SettingsProvider])], QuoteInfoComponent);
exports.QuoteInfoComponent = QuoteInfoComponent;

/***/ }),

/***/ "./web/modern/components/quote/modals/mark-quote-as-accepted/mark-quote-as-accepted.modal.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"markQuoteAsAcceptedModal\" class=\"modal modal-center fade\" data-backdrop=\"static\" data-keyboard=\"false\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <close-btn></close-btn>\n                <h3 class=\"modal-title\">Mark as Accepted</h3>\n            </div>\n            <div class=\"modal-body\">\n                <p class=\"mb-30\">Once you mark this quote as accepted, this action cannot be undone.</p>\n                <div class=\"modal-footer p-0\">\n                    <button class=\"btn btn-success btn-lg pull-left mr-10 w-min-90\" (click)=\"markQuoteAsAccepted()\"\n                            [disabled]=\"disableButtons\" spinning-wheel [is-spinning-wheel-active]=\"disableButtons\">Mark as Accepted</button>\n                    <button [disabled]=\"disableButtons\" class=\"btn btn-default btn-lg pull-left w-min-90\" data-dismiss=\"modal\">Cancel</button>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),

/***/ "./web/modern/components/quote/modals/mark-quote-as-accepted/mark-quote-as-accepted.modal.scss":
/***/ (function(module, exports) {

module.exports = ".p-0 {\n  padding: 0 !important; }\n"

/***/ }),

/***/ "./web/modern/components/quote/modals/mark-quote-as-accepted/mark-quote-as-accepted.modal.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var quotes_data_service_1 = __webpack_require__("./shared/services/quote/quotes-data-service/quotes.data.service.ts");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var MarkQuoteAsAcceptedModal = function () {
    function MarkQuoteAsAcceptedModal(quotesDataService, messageService) {
        _classCallCheck(this, MarkQuoteAsAcceptedModal);

        this.quotesDataService = quotesDataService;
        this.messageService = messageService;
        this.updateQuoteEvent = new core_1.EventEmitter();
        this.disableButtons = false;
    }

    _createClass(MarkQuoteAsAcceptedModal, [{
        key: "markQuoteAsAccepted",
        value: function markQuoteAsAccepted() {
            var _this = this;

            this.disableButtons = true;
            this.quotesDataService.markQuoteAsAccepted(this.jobId, this.quoteId).pipe(operators_1.finalize(function () {
                return _this.disableButtons = false;
            })).subscribe(function () {
                return _this.successMarkAsAcceptedInvoice();
            }, function (error) {
                return _this.messageService.handleError(error);
            });
        }
    }, {
        key: "successMarkAsAcceptedInvoice",
        value: function successMarkAsAcceptedInvoice() {
            this.updateQuoteEvent.emit();
            this.messageService.showToaster('s_1', 'editQuote');
            $('#markQuoteAsAcceptedModal').modal('hide');
        }
    }]);

    return MarkQuoteAsAcceptedModal;
}();
__decorate([core_1.Input('jobId'), __metadata("design:type", Number)], MarkQuoteAsAcceptedModal.prototype, "jobId", void 0);
__decorate([core_1.Input('quoteId'), __metadata("design:type", Number)], MarkQuoteAsAcceptedModal.prototype, "quoteId", void 0);
__decorate([core_1.Input('autoGenerateInvoice'), __metadata("design:type", Boolean)], MarkQuoteAsAcceptedModal.prototype, "autoGenerateInvoice", void 0);
__decorate([core_1.Output('updateQuoteEvent'), __metadata("design:type", core_1.EventEmitter)], MarkQuoteAsAcceptedModal.prototype, "updateQuoteEvent", void 0);
MarkQuoteAsAcceptedModal = __decorate([core_1.Component({
    selector: 'mark-quote-as-accepted',
    template: __webpack_require__("./web/modern/components/quote/modals/mark-quote-as-accepted/mark-quote-as-accepted.modal.html"),
    styles: [__webpack_require__("./web/modern/components/quote/modals/mark-quote-as-accepted/mark-quote-as-accepted.modal.scss")]
}), __metadata("design:paramtypes", [quotes_data_service_1.QuotesDataProvider, message_service_1.MessageService])], MarkQuoteAsAcceptedModal);
exports.MarkQuoteAsAcceptedModal = MarkQuoteAsAcceptedModal;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./web/modern/components/quote/modals/modal-delete-quote/modal-delete-quote.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"deleteQuoteModal\" class=\"modal modal-center fade\" data-backdrop=\"static\" data-keyboard=\"false\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <close-btn></close-btn>\n                <h3 class=\"modal-title\">Delete quote</h3>\n            </div>\n            <div class=\"modal-body\">\n                <p><b>Deleting this quote will also delete any linked contracts and questionnaires which are pending or incomplete.</b></p>\n                <p><b>Signed contracts, completed questionnaires and invoices linked to this quote will NOT be deleted.</b></p>\n                <p class=\"mb-30\"><b>Are you sure?</b></p>\n                <div class=\"modal-footer p-0\">\n                    <button class=\"btn btn-danger btn-lg pull-left mr-10 mb-0\" (click)=\"deleteQuote()\"\n                            [disabled]=\"disableButtons\" [ngClass]=\"{'spinning-wheel__active' : disableButtons}\">Delete quote</button>\n                    <button [disabled]=\"disableButtons\" class=\"btn btn-default btn-lg pull-left mb-0\" data-dismiss=\"modal\">Cancel</button>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "./web/modern/components/quote/modals/modal-delete-quote/modal-delete-quote.scss":
/***/ (function(module, exports) {

module.exports = ".p-0 {\n  padding: 0 !important; }\n"

/***/ }),

/***/ "./web/modern/components/quote/modals/modal-delete-quote/modal-delete-quote.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var common_1 = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var quotes_data_service_1 = __webpack_require__("./shared/services/quote/quotes-data-service/quotes.data.service.ts");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var ModalDeleteQuoteComponent = function () {
    function ModalDeleteQuoteComponent(messageService, quotesDataService, location) {
        _classCallCheck(this, ModalDeleteQuoteComponent);

        this.messageService = messageService;
        this.quotesDataService = quotesDataService;
        this.location = location;
    }

    _createClass(ModalDeleteQuoteComponent, [{
        key: "deleteQuote",
        value: function deleteQuote() {
            var _this = this;

            this.disableButtons = true;
            this.quotesDataService.deleteQuote(this.jobId, this.quoteId).pipe(operators_1.finalize(function () {
                return _this.disableButtons = false;
            })).subscribe(function (data) {
                return _this.successDeleteQuote(data);
            }, function (error) {
                return _this.messageService.showDefaultErrorMessage(error);
            });
        }
    }, {
        key: "successDeleteQuote",
        value: function successDeleteQuote(data) {
            var errorMessage = data.errorMessage,
                errorTitle = data.errorTitle;

            if (errorMessage) {
                this.messageService.showErrorFromBackend(errorTitle, errorMessage);
                return;
            }
            this.messageService.showToaster('s_5', 'payments');
            this.redirectOnSuccess();
            $('#deleteQuoteModal').modal('hide');
        }
    }, {
        key: "redirectOnSuccess",
        value: function redirectOnSuccess() {
            if (this.isLead === true) {
                this.location.go("leads/view/" + this.leadId);
            } else {
                this.location.go("jobs/view/" + this.jobId);
            }
        }
    }]);

    return ModalDeleteQuoteComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], ModalDeleteQuoteComponent.prototype, "jobId", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], ModalDeleteQuoteComponent.prototype, "leadId", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], ModalDeleteQuoteComponent.prototype, "quoteId", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], ModalDeleteQuoteComponent.prototype, "isLead", void 0);
ModalDeleteQuoteComponent = __decorate([core_1.Component({
    selector: 'modal-delete-quote',
    template: __webpack_require__("./web/modern/components/quote/modals/modal-delete-quote/modal-delete-quote.html"),
    styles: [__webpack_require__("./web/modern/components/quote/modals/modal-delete-quote/modal-delete-quote.scss")]
}), __metadata("design:paramtypes", [message_service_1.MessageService, quotes_data_service_1.QuotesDataProvider, common_1.Location])], ModalDeleteQuoteComponent);
exports.ModalDeleteQuoteComponent = ModalDeleteQuoteComponent;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./web/modern/components/quote/modals/modal-make-invoice/modal-make-invoice.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"generateInvoiceModal\" class=\"modal modal-center fade\" data-backdrop=\"static\" data-keyboard=\"false\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <close-btn></close-btn>\n                <h3 class=\"modal-title\">Make Invoice</h3>\n            </div>\n            <div class=\"modal-body\">\n                <p class=\"mb-30\">Do you wish to create an invoice from this quote?</p>\n                <div class=\"modal-footer p-0\">\n                    <button class=\"btn btn-success btn-lg pull-left mr-10 w-min-90\" (click)=\"generateInvoice()\"\n                            [disabled]=\"disableButtons\" spinning-wheel [is-spinning-wheel-active]=\"disableButtons\">Yes</button>\n                    <button [disabled]=\"disableButtons\" class=\"btn btn-default btn-lg pull-left w-min-90\" data-dismiss=\"modal\">No</button>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "./web/modern/components/quote/modals/modal-make-invoice/modal-make-invoice.scss":
/***/ (function(module, exports) {

module.exports = ".p-0 {\n  padding: 0 !important; }\n"

/***/ }),

/***/ "./web/modern/components/quote/modals/modal-make-invoice/modal-make-invoice.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var quotes_data_service_1 = __webpack_require__("./shared/services/quote/quotes-data-service/quotes.data.service.ts");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var ModalMakeInvoiceComponent = function () {
    function ModalMakeInvoiceComponent(quotesDataService, messageService) {
        _classCallCheck(this, ModalMakeInvoiceComponent);

        this.quotesDataService = quotesDataService;
        this.messageService = messageService;
        this.url = '';
        this.updateBtnActions = new core_1.EventEmitter();
        this.disableButtons = false;
    }

    _createClass(ModalMakeInvoiceComponent, [{
        key: "generateInvoice",
        value: function generateInvoice() {
            var _this = this;

            this.disableButtons = true;
            if (this.url) {
                localStorage.setItem('GENERATE_INVOICE', 'true');
                location.href = this.url;
            } else {
                this.quotesDataService.generateInvoiceFromQuote(this.jobId, this.quoteId).pipe(operators_1.finalize(function () {
                    return _this.disableButtons = false;
                })).subscribe(function (data) {
                    return _this.successGenerateInvoice(data);
                }, function (error) {
                    return _this.messageService.handleError(error);
                });
            }
        }
    }, {
        key: "successGenerateInvoice",
        value: function successGenerateInvoice(res) {
            this.messageService.showToaster('s_0', 'editQuote');
            $('#generateInvoiceModal').modal('hide');
            this.updateBtnActions.emit(res.data.id);
        }
    }]);

    return ModalMakeInvoiceComponent;
}();
__decorate([core_1.Input('jobId'), __metadata("design:type", Number)], ModalMakeInvoiceComponent.prototype, "jobId", void 0);
__decorate([core_1.Input('quoteId'), __metadata("design:type", Number)], ModalMakeInvoiceComponent.prototype, "quoteId", void 0);
__decorate([core_1.Input('url'), __metadata("design:type", Object)], ModalMakeInvoiceComponent.prototype, "url", void 0);
__decorate([core_1.Output('updateBtnActions'), __metadata("design:type", core_1.EventEmitter)], ModalMakeInvoiceComponent.prototype, "updateBtnActions", void 0);
ModalMakeInvoiceComponent = __decorate([core_1.Component({
    selector: 'modal-make-invoice',
    template: __webpack_require__("./web/modern/components/quote/modals/modal-make-invoice/modal-make-invoice.html"),
    styles: [__webpack_require__("./web/modern/components/quote/modals/modal-make-invoice/modal-make-invoice.scss")]
}), __metadata("design:paramtypes", [quotes_data_service_1.QuotesDataProvider, message_service_1.MessageService])], ModalMakeInvoiceComponent);
exports.ModalMakeInvoiceComponent = ModalMakeInvoiceComponent;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./web/modern/components/quote/modals/modal-send-quote/modal-send-quote.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"main-wrapper\" class=\"container\">\n    <div id=\"sendQuoteModal\" class=\"modal modal-center fade\" data-backdrop=\"static\" data-keyboard=\"false\">\n        <div class=\"modal-dialog\">\n            <form role=\"form\" class=\"modal-content form-horizontal\" autocomplete=\"off\" (submit)=\"sendQuoteEmail()\">\n                <div class=\"modal-header\">\n                    <close-btn (action)=\"closeModal()\"></close-btn>\n                    <h3 class=\"modal-title\">Send Quote</h3>\n                </div>\n                <div class=\"modal-body\">\n                    <div class=\"field-info\">\n                        <h4 class=\"mt-0\">To</h4>\n                        <div class=\"flex-row\">\n                            <input class=\"form-control\" type=\"email\" placeholder=\"myclient@abc.com\" autocomplete=\"off\" [(ngModel)]=\"sendMessageData.emailTo\" name=\"email\"\n                                    required maxlength=\"255\">\n                            <button type=\"button\" class=\"btn btn-link color-cc\" *ngIf=\"!showCcField\"\n                                    (click)=\"toggleViewCc()\">Add Cc\n                            </button>\n                        </div>\n                    </div>\n\n                    <div class=\"field-info\" *ngIf=\"showCcField\">\n                        <h4>Cc</h4>\n                        <autocomplete-email-input [placeholder]=\"'Start entering client name'\" [autocompleteStyle]=\"'dropdown-autocomplete-cc'\"></autocomplete-email-input>\n                    </div>\n                    <div class=\"field-info\">\n                        <h4>Choose email template</h4>\n                        <div class=\"flex-row\">\n                            <div class=\"select-style flex-grow-1\">\n                                <select  name=\"choosenEmail\" class=\"form-control m-b-sm\"\n                                         (ngModelChange)=\"changeEmail($event)\"\n                                         [(ngModel)]=\"mailData.chosenEmail\">\n                                    <option *ngFor='let template of mailData.emails' [ngValue]=\"template\">\n                                        {{ template.name }}\n                                    </option>\n                                </select>\n                            </div>\n                        </div>\n                    </div>\n\n                    <div class=\"field-info\">\n                        <h4>Subject</h4>\n                        <div class=\"flex-row\">\n                            <input ng-disabled=\"button_disable\" type=\"text\" class=\"form-control\" required [(ngModel)]=\"sendMessageData.emailSubject\" name=\"subject\" autocomplete=\"off\"\n                                   placeholder=\"Write an awesome subject line. Why not?\" maxlength=\"255\"\n                                   >\n                        </div>\n                    </div>\n\n                    <div class=\"field-info\">\n                        <h4>Message</h4>\n                        <sn-quill-editor-web\n                            (onTextChange)=\"sendMessageData.emailText = $event\"\n                            [filesObj]=\"sendMessageData.attachmentsData\"\n                            [initValue]=\"sendMessageData.emailText\"\n                            [maxLength]=\"4000\" [toolbarSettings]=\"'variables counter attachments color size font'\">\n                        </sn-quill-editor-web>\n                    </div>\n                </div>\n                <div class=\"modal-footer modal-foot\">\n                    <button class=\"btn btn-success btn-lg\" id=\"sendQuoteBtn\"\n                            spinning-wheel is-spinning-wheel-active=\"disableBtnOnSend\">Send quote</button>\n                </div>\n            </form>\n        </div>\n    </div>\n</div>"

/***/ }),

/***/ "./web/modern/components/quote/modals/modal-send-quote/modal-send-quote.scss":
/***/ (function(module, exports) {

module.exports = ""

/***/ }),

/***/ "./web/modern/components/quote/modals/modal-send-quote/modal-send-quote.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var templates_data_service_1 = __webpack_require__("./shared/services/data-services/templates-data-service/templates.data.service.ts");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var mails_data_service_1 = __webpack_require__("./shared/services/email/mails.data.service.ts");
var email_service_1 = __webpack_require__("./shared/services/email/email-service/email.service.ts");
var file_upload_service_1 = __webpack_require__("./shared/services/files/file-upload-service/file-upload.service.ts");
var clients_data_service_1 = __webpack_require__("./shared/services/client/clients.data.service.ts");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var validation_service_1 = __webpack_require__("./shared/services/helpers/validation.service.ts");
var quotes_data_service_1 = __webpack_require__("./shared/services/quote/quotes-data-service/quotes.data.service.ts");
var ModalSendQuoteComponent = function () {
    function ModalSendQuoteComponent(templateRequestsService, mailsDataService, emailService, fileUploadService, clientsDataService, messageService, validationService, quotesDataService) {
        _classCallCheck(this, ModalSendQuoteComponent);

        this.templateRequestsService = templateRequestsService;
        this.mailsDataService = mailsDataService;
        this.emailService = emailService;
        this.fileUploadService = fileUploadService;
        this.clientsDataService = clientsDataService;
        this.messageService = messageService;
        this.validationService = validationService;
        this.quotesDataService = quotesDataService;
        this.showCcField = false;
        this.disableBtnOnSend = false;
        this.mailData = {};
        this.client = {};
        this.contract = {};
        this.isClientSearch = false;
        this.sendMessageData = {
            emailSubject: '',
            emailText: '',
            emailTo: [],
            ccEmails: []
        };
        this.emptyAttachmentsData = {
            attachments: [],
            filesSize: 0
        };
        this.unsubscribe = new Subject_1.Subject();
    }

    _createClass(ModalSendQuoteComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            var _this = this;

            this.templateRequestsService.getTemplates('all').takeUntil(this.unsubscribe).subscribe(function (data) {
                return _this.setDefaultContractEmail(data);
            });
        }
    }, {
        key: "ngAfterViewInit",
        value: function ngAfterViewInit() {
            this.sendMessageData.emailTo = this.email;
        }
    }, {
        key: "onChange",
        value: function onChange(event) {}
    }, {
        key: "setMailData",
        value: function setMailData(data) {
            var client = data.client,
                invoiceId = data.invoiceId,
                secondaryClient = data.secondaryClient;

            this.client = client;
            this.quoteId = invoiceId;
            this.mailData = JSON.parse(JSON.stringify(data));
            this.mailData.id = client.id;
            this.sendMessageData = this.emailService.setMessageData(data, client, secondaryClient);
            this.clearAttachments();
            if (data.mailSignature) {
                this.sendMessageData.emailText += "<br><br>" + data.mailSignature;
            }
        }
    }, {
        key: "toggleViewCc",
        value: function toggleViewCc() {
            this.showCcField = true;
        }
    }, {
        key: "setDefaultContractEmail",
        value: function setDefaultContractEmail(emails) {
            if (emails !== undefined && emails !== null && emails.length) {
                this.mailData.emails = JSON.parse(JSON.stringify(emails));
                this.mailData.chosenEmail = this.mailData.emails.find(function (item) {
                    return item.emailTemplateType === 'QUOTE_EMAIL_TEMPLATE';
                }) || {};
                // this.mailData.chosenEmail = JSON.parse(JSON.stringify(template));
                this.changeEmail(this.mailData.chosenEmail);
            }
        }
    }, {
        key: "changeEmail",
        value: function changeEmail(newObj) {
            var _this2 = this;

            if (!newObj || !newObj.id) {
                this.resetMailFields();
                return false;
            }
            this.templateRequestsService.getTemplates('full_template', newObj.id).subscribe(function (email) {
                return _this2.updateEmail(email);
            }, function (error) {
                return _this2.messageService.showDefaultErrorMessage(error);
            });
        }
    }, {
        key: "setEmail",
        value: function setEmail(site) {
            var stringEmail = JSON.parse(JSON.stringify(site.name));
            stringEmail = stringEmail.substring(stringEmail.indexOf('(') + 1, stringEmail.length - 1);
            this.sendMessageData.emailCc = stringEmail;
            this.emailCcObj = Object.assign({ email: stringEmail }, site);
        }
    }, {
        key: "findAllMatchingClientNames",
        value: function findAllMatchingClientNames(search) {
            var _this3 = this;

            this.clientsDataService.searchClient(search).subscribe(function (result) {
                return _this3.findClientSuccessCallback(result);
            }, function (error) {
                return _this3.messageService.showDefaultErrorMessage(error);
            });
        }
    }, {
        key: "findClientSuccessCallback",
        value: function findClientSuccessCallback(clients) {
            if (clients && clients.length !== 0) {
                this.clientsNames = clients;
                this.isClientSearch = true;
            }
        }
    }, {
        key: "chooseEmailCC",
        value: function chooseEmailCC(email) {
            this.sendMessageData.emailCc = email;
        }
    }, {
        key: "closeModal",
        value: function closeModal() {
            var _this4 = this;

            this.templateRequestsService.getTemplates('all').takeUntil(this.unsubscribe).subscribe(function (data) {
                return _this4.setDefaultContractEmail(data);
            });
            this.showCcField = false;
        }
    }, {
        key: "resetMailFields",
        value: function resetMailFields() {
            this.sendMessageData.emailSubject = '';
            this.sendMessageData.emailText = '';
            if (this.mailData.mailSignature) {
                this.sendMessageData.emailText += "<br><br>" + this.mailData.mailSignature;
            }
            this.clearAttachments();
        }
    }, {
        key: "updateEmail",
        value: function updateEmail(emailTemplate) {
            if (emailTemplate.storedAttachments && emailTemplate.storedAttachments.length) {
                this.sendMessageData.attachmentsData = {
                    attachments: this.fileUploadService.convertAttachmentsToShow(emailTemplate.storedAttachments)
                };
            } else {
                this.clearAttachments();
            }
            this.sendMessageData.emailSubject = emailTemplate.subject || '';
            this.sendMessageData.emailText = emailTemplate.text || '';
        }
    }, {
        key: "clearAttachments",
        value: function clearAttachments() {
            this.sendMessageData.attachmentsData = JSON.parse(JSON.stringify(this.emptyAttachmentsData));
        }
    }, {
        key: "sendQuoteEmail",
        value: function sendQuoteEmail() {
            this.disableBtnOnSend = true;
            var attachmentsData = this.sendMessageData.attachmentsData;

            if (!this.emailService.isAttachmentsValid(attachmentsData)) {
                this.disableBtnOnSend = false;
                return false;
            }
            if (this.validationService.isStringEmpty(this.sendMessageData.emailSubject)) {
                this.disableBtnOnSend = false;
                this.messageService.showToaster('e_10', 'emailTemplate');
                return false;
            }
            this.sendMessageData.emailText = this.sendMessageData.emailText || '';
            this.sendMessageData.emailText = this.emailService.resetSignatureLink(this.sendMessageData.emailText);
            var storedFiles = attachmentsData.attachments.filter(function (file) {
                return file.id;
            });
            var uploadedFiles = attachmentsData.attachments.filter(function (file) {
                return !file.id;
            });
            var sendMessageData = this.gatherDataToSend();
            var dataToSend = {
                sendMessageData: sendMessageData,
                storedFiles: storedFiles,
                uploadedFiles: uploadedFiles
            };
            this.makeSendEmailRequest(dataToSend);
        }
    }, {
        key: "gatherDataToSend",
        value: function gatherDataToSend() {
            var emailCC2save = this.showCcField ? this.sendMessageData.emailCc : '';
            return {
                emailTo: this.sendMessageData.emailTo,
                emailCc: emailCC2save,
                emailText: this.sendMessageData.emailText,
                emailSubject: this.sendMessageData.emailSubject,
                templateId: this.mailData.chosenEmail ? this.mailData.chosenEmail.id : null,
                quoteId: this.quoteId,
                jobId: this.jobId
            };
        }
    }, {
        key: "makeSendEmailRequest",
        value: function makeSendEmailRequest(data) {
            var _this5 = this;

            this.quotesDataService.sendQuoteEmail(data).finally(function () {
                return _this5.disableBtnOnSend = false;
            }).subscribe(function () {
                return _this5.successSendEmail();
            }, function (result) {
                return _this5.errorSendMessage(result);
            });
        }
    }, {
        key: "successSendEmail",
        value: function successSendEmail() {
            this.disableBtnOnSend = false;
            this.messageService.showToaster('s_10', 'payments');
            $('#sendQuoteModal').modal('hide');
        }
    }, {
        key: "errorSendMessage",
        value: function errorSendMessage(_ref) {
            var error = _ref.error;
            var errorTitle = error.errorTitle,
                errorMessage = error.errorMessage;

            this.messageService.showErrorFromBackend(errorTitle, errorMessage);
        }
    }]);

    return ModalSendQuoteComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], ModalSendQuoteComponent.prototype, "email", void 0);
__decorate([core_1.Input(), __metadata("design:type", Number)], ModalSendQuoteComponent.prototype, "jobId", void 0);
__decorate([core_1.Input(), __metadata("design:type", Number)], ModalSendQuoteComponent.prototype, "quoteId", void 0);
ModalSendQuoteComponent = __decorate([core_1.Component({
    selector: 'modal-send-quote',
    template: __webpack_require__("./web/modern/components/quote/modals/modal-send-quote/modal-send-quote.html"),
    styles: [__webpack_require__("./web/modern/components/quote/modals/modal-send-quote/modal-send-quote.scss")]
}), __metadata("design:paramtypes", [templates_data_service_1.TemplatesDataProvider, mails_data_service_1.MailsDataProvider, email_service_1.EmailServiceProvider, file_upload_service_1.FileUploadServiceProvider, clients_data_service_1.ClientsDataServiceProvider, message_service_1.MessageService, validation_service_1.ValidationProvider, quotes_data_service_1.QuotesDataProvider])], ModalSendQuoteComponent);
exports.ModalSendQuoteComponent = ModalSendQuoteComponent;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./web/modern/components/quote/quote-assignment-panel/quote-assignment-panel.component.html":
/***/ (function(module, exports) {

module.exports = "<div [ngClass]=\"{'assignment-for-fixed-quotes' : isFixed}\" class=\"not-print\" >\n    <div *ngIf=\"data.notes && isQuote\" class=\"divider-notes-pseudo quote-notes-container quote-text mb-30\">\n        <h2 class=\"mt-30 f-s-24\">Notes</h2>\n        <p class=\"ws-pl\">{{ data.notes }}</p>\n    </div>\n    <div class=\"row show-grid mb-30\" *ngIf=\"!hidePaymentsSchedule\">\n        <div class=\"col-xs-12\">\n            <div class=\"col-gray\">\n                <div class=\"row \">\n                    <div class=\"col-xs-12 col-sm-4\">\n                        <h4 class=\"notes-view\">Payment Schedule</h4>\n                    </div>\n                    <div class=\"col-xs-12 col-sm-5\">\n                        <div class=\"note-text\">{{ paymentScheduleName }}</div>\n                    </div>\n                </div>\n            </div>\n        </div>\n\t\t\t\t<div class=\"col-xs-12\" *ngIf=\"isQuote && data?.payments?.length\">\n\t\t\t\t\t<div class=\"payments-item\" *ngFor=\"let payment of data.payments\">\n                        <div *ngIf=\"payment?.paymentDateWithRule?.ruleExplanationHTML && !payment?.paymentDateWithRule?.estimatedDate\" [innerHTML]=\"payment?.paymentDateWithRule?.ruleExplanationHTML | safeHtml\"></div>\n\t\t\t\t\t\t<div *ngIf=\"payment?.paymentDateWithRule?.estimatedDate\">{{ payment.paymentDateWithRule.estimatedDate | date: dateFormat }}\n\t\t\t\t\t\t\t<label class=\"not-print\" [ngClass]=\"{'late-text' : payment.daysLeftForPayment < 0}\">\n\t\t\t\t\t\t\t\t{{ constructStatusDueLabel(payment.daysLeftForPayment) }}\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<span>{{ constructAmountLabel(payment) }}</span>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n    </div>\n    <div class=\"row show-grid mb-30\">\n        <div class=\"col-xs-12\">\n            <div class=\"col-gray\">\n                <div class=\"row \">\n                    <div class=\"col-xs-12 col-sm-4\">\n                        <h4 class=\"notes-view\">Contract</h4>\n                    </div>\n                    <div class=\"col-xs-12 col-sm-5\">\n                        <div class=\"note-text\">{{ contractName }}</div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"row show-grid mb-30\">\n        <div class=\"col-xs-12\">\n            <div class=\"col-gray\">\n                <div class=\"row \">\n                    <div class=\"col-xs-12 col-sm-4\">\n                        <h4 class=\"notes-view\">Questionnaire</h4>\n                    </div>\n                    <div class=\"col-xs-12 col-sm-5\">\n                        <div class=\"note-text\">{{ questionnaireName }}</div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div *ngIf=\"data.declineReason\" class=\"row show-grid mb-30\">\n        <div class=\"col-xs-12\">\n            <div class=\"col-gray\">\n                <div class=\"row \">\n                    <div class=\"col-xs-12 col-sm-4\">\n                        <h4 class=\"notes-view\">Reason for decline</h4>\n                    </div>\n                    <div class=\"col-xs-12 col-sm-5\">\n                        <div class=\"note-text\">{{ data.declineReason }}</div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "./web/modern/components/quote/quote-assignment-panel/quote-assignment-panel.component.scss":
/***/ (function(module, exports) {

module.exports = ".notes-view {\n  font-weight: 400 !important; }\n\n.note-text {\n  background: #fff;\n  border: 1px solid #dce1e4;\n  font-size: 13px;\n  color: #8e8e98;\n  padding: 6px 10px;\n  font-weight: 300; }\n\n.assignment-for-fixed-quotes {\n  box-shadow: 0 0 10px #d7d7d7;\n  padding: 10px 30px 30px;\n  position: relative; }\n  .assignment-for-fixed-quotes:after {\n    content: '';\n    position: absolute;\n    top: 10px;\n    left: 0;\n    right: 0;\n    display: block;\n    height: 10px;\n    width: 100%;\n    z-index: 10;\n    background-color: #fff; }\n  .assignment-for-fixed-quotes > .divider-notes-pseudo {\n    position: relative; }\n    .assignment-for-fixed-quotes > .divider-notes-pseudo:before {\n      content: '';\n      position: absolute;\n      top: -30px;\n      left: 0;\n      right: 0;\n      display: block;\n      height: 1px;\n      z-index: 110;\n      background-color: #ececec; }\n\n.payments-item {\n  padding: 15px 12px;\n  border-bottom: 1px solid #ddd;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n  -webkit-justify-content: space-between;\n      -ms-flex-pack: justify;\n          justify-content: space-between; }\n  .payments-item .late-text {\n    color: #f25656; }\n"

/***/ }),

/***/ "./web/modern/components/quote/quote-assignment-panel/quote-assignment-panel.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var settings_1 = __webpack_require__("./shared/services/settings/settings.ts");
var payments_service_1 = __webpack_require__("./shared/services/payments/payments-service/payments.service.ts");
var QuoteAssignmentPanelComponent = function () {
    function QuoteAssignmentPanelComponent(settingsService, paymentsService) {
        _classCallCheck(this, QuoteAssignmentPanelComponent);

        this.settingsService = settingsService;
        this.paymentsService = paymentsService;
        this.contractName = 'None';
        this.questionnaireName = 'None';
        this.paymentScheduleName = 'No split payments';
    }

    _createClass(QuoteAssignmentPanelComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.setAssignmentNames();
        }
    }, {
        key: "getDateFormat",
        value: function getDateFormat() {
            var _this = this;

            this.settingsService.timeFormatSettings.subscribe(function (data) {
                _this.dateFormat = data.dateFormat === 'DD_MM_YYYY' ? 'DD MMM YYYY' : 'MMM DD YYYY';
            });
        }
    }, {
        key: "setAssignmentNames",
        value: function setAssignmentNames() {
            var _data = this.data,
                contract = _data.contract,
                questionnaire = _data.questionnaire,
                paymentSchedule = _data.paymentSchedule,
                paymentsRule = _data.paymentsRule,
                summary = _data.summary,
                payments = _data.payments;

            if (contract !== null) {
                this.contractName = contract.name;
            }
            if (questionnaire !== null) {
                this.questionnaireName = questionnaire.name;
            }
            if (paymentSchedule !== null) {
                this.paymentScheduleName = paymentSchedule.name;
            } else if (paymentsRule) {
                if (paymentsRule.strategy === 'NO_SPLIT_PAYMENTS') {
                    this.paymentScheduleName = 'No split payments';
                    this.hidePaymentsSchedule = !this.isFixed && this.isQuote ? payments.length === 0 : !summary || summary.total === 0;
                } else if (paymentsRule.strategy === 'NO_DUE_DATE') {
                    this.paymentScheduleName = 'No payment required';
                }
            } else {
                this.paymentScheduleName = 'No split payments';
                this.hidePaymentsSchedule = !this.isFixed && this.isQuote ? payments.length === 0 : !summary || summary.total === 0;
            }
        }
    }, {
        key: "constructStatusDueLabel",
        value: function constructStatusDueLabel(days) {
            if (days <= -1) {
                return days === -1 ? '(1 day ago)' : "(" + -1 * days + " days ago)";
            }
            if (days === 0) {
                return '(today)';
            }
            if (days === 1) {
                return '(in 1 day)';
            }
            return "(in " + days + " days)";
        }
    }, {
        key: "constructAmountLabel",
        value: function constructAmountLabel(payment) {
            if (this.isFixed || this.data.status.toUpperCase() === 'ACCEPTED') {
                return payment.amountWithCurrency.amountWithCurrency;
            } else if (this.data.status.toUpperCase() !== 'ACCEPTED' && !this.isFixed && this.data.paymentsRule.strategy !== 'NO_SPLIT_PAYMENTS') {
                if (payment.paymentSchedulePart.type === 'Dollars') {
                    return "" + payment.amountWithCurrency.currencySymbol + payment.paymentSchedulePart.amount;
                }
                return "" + payment.paymentSchedulePart.amount + this.paymentsService.setAmountType(payment.paymentSchedulePart.type);
            } else if (this.data.status.toUpperCase() !== 'ACCEPTED' && !this.isFixed && this.data.paymentsRule.strategy === 'NO_SPLIT_PAYMENTS') {
                return '100% of order';
            }
            return '';
        }
    }]);

    return QuoteAssignmentPanelComponent;
}();
__decorate([core_1.Input('data'), __metadata("design:type", Object)], QuoteAssignmentPanelComponent.prototype, "data", void 0);
__decorate([core_1.Input(), __metadata("design:type", Boolean)], QuoteAssignmentPanelComponent.prototype, "isQuote", void 0);
__decorate([core_1.Input('isFixed'), __metadata("design:type", Boolean)], QuoteAssignmentPanelComponent.prototype, "isFixed", void 0);
QuoteAssignmentPanelComponent = __decorate([core_1.Component({
    selector: 'quote-assignment-panel',
    template: __webpack_require__("./web/modern/components/quote/quote-assignment-panel/quote-assignment-panel.component.html"),
    styles: [__webpack_require__("./web/modern/components/quote/quote-assignment-panel/quote-assignment-panel.component.scss")]
}), __metadata("design:paramtypes", [settings_1.SettingsProvider, payments_service_1.PaymentsServiceProvider])], QuoteAssignmentPanelComponent);
exports.QuoteAssignmentPanelComponent = QuoteAssignmentPanelComponent;

/***/ }),

/***/ "./web/modern/components/quote/quote-view-fixed/quote-view-fixed.html":
/***/ (function(module, exports) {

module.exports = "<div [ngClass]=\"{'fixed-quote-box-shadow' : !isClientPortal}\" class=\"fixed-quote-box-shadow\">\n    <div [ngClass]=\"{'mb-40' : isClientPortal}\" class=\"invoice-view-container\">\n        <div class=\"col-xs-12 col-sm-5 print-half print-no-padding-left\">\n            <div class=\"invoice-left-side\">\n                <div *ngIf=\"company\">\n                    <img class=\"client-company-image client-company-image-max-height\" alt=\"Company logo\" *ngIf=\"company.image\" [src]=\"company.image\">\n                    <div *ngIf=\"!company.image\" class=\"default-img\"></div>\n                </div>\n                <div>\n                    <table class=\"table-invoice\">\n                        <tr>\n                            <td>Quote ID</td>\n                            <td><b>{{ data.quoteId }}</b></td>\n                        </tr>\n                        <tr>\n                            <td>Issue Date</td>\n                            <td>{{ data.issueDate | timeFilter: 'long' }}</td>\n                        </tr>\n                        <tr *ngIf=data.ponumber>\n                            <td>PO Number</td>\n                            <td>{{ data.ponumber ? data.ponumber : '-' }}</td>\n                        </tr>\n                    </table>\n                    <p *ngIf=\"data.introduction\" class=\"mt-30 ml-5\">{{data.introduction}}</p>\n                </div>\n            </div>\n        </div>\n        <div class=\"col-xs-12 col-sm-7 print-half text-right print-no-padding-right\">\n            <div class=\"invoice-right-side print-no-padding-right\"  >\n                <img id=\"stamp\" class=\"quote-status-img not-print\" [src]=\"imgSrc\" *ngIf=\"!isClientPortal\">\n                <table class=\"table-invoice pull-right w-auto\" *ngIf=\"company\">\n                    <tr>\n                        <td>From</td>\n                        <td><b>{{ company.name }}</b></td>\n                    </tr>\n                    <tr>\n                        <td></td>\n                        <td>{{ company.address }}</td>\n                    </tr>\n                    <tr>\n                        <td></td>\n                        <td>{{ company.city }}</td>\n                    </tr>\n                    <tr>\n                        <td></td>\n                        <td>{{ company.state }} {{ company.postcode }} {{ company.country }}</td>\n                    </tr>\n                    <tr *ngIf=\"company?.phone\">\n                        <td></td>\n                        <td>Phone number: {{ company.phone }}</td>\n                    </tr>\n                    <tr *ngIf=\"company.email\">\n                        <td></td>\n                        <td>Email: {{ company.email }}</td>\n                    </tr>\n                    <tr *ngIf=\"company.number\">\n                        <td></td>\n                        <td>{{ businessNumberLabelName }}: {{ company.number }}</td>\n                    </tr>\n                    <tr>\n                        <td style=\"border: none;\">&nbsp;</td>\n                        <td style=\"border: none;\">&nbsp;</td>\n                    </tr>\n                    <tr>\n                        <td style=\"border: none;\">&nbsp;</td>\n                        <td style=\"border: none;\">&nbsp;</td>\n                    </tr>\n                    <tr>\n                        <td>Quote for</td>\n                        <td><b>{{ data.job.name }}</b></td>\n                    </tr>\n                    <tr>\n                        <td></td>\n                        <td>Scheduled on\n                            <main-shoot-date [start-date]=\"data.job.startDate\" [finish-date]=\"data.job.finishDate\" [fromQuote]=\"true\"></main-shoot-date>\n                        </td>\n                    </tr>\n                    <tr>\n                        <td></td>\n                        <td *ngIf=\"data.job.startTime && data.job.finishTime\">\n                            {{ data.job.startTime | timeFilter: '12h' }} - {{ data.job.finishTime | timeFilter: '12h' }}\n                        </td>\n                    </tr>\n                    <tr>\n                        <td></td>\n                        <td *ngIf=\"data.job.shootLocation\">\n                            {{ data.job.shootLocation }}\n                        </td>\n                    </tr>\n                    <tr>\n                        <td>&nbsp;</td>\n                        <td>&nbsp;</td>\n                    </tr>\n                    <tr *ngIf=\"data.job.primaryContact.companyName\">\n                        <td></td>\n                        <td><b>{{ data.job.primaryContact.companyName }}</b>\n                        </td>\n                    </tr>\n                    <tr>\n                        <td></td>\n                        <td>\n                            <b>{{ data.job.primaryContact.firstName }} {{ data.job.primaryContact.lastName }}</b>\n                        </td>\n                    </tr>\n                    <tr>\n                        <td></td>\n                        <td><span>{{ data.job.primaryContact.addressLine1 }}</span></td>\n                    </tr>\n                    <tr *ngIf=\"data.job.primaryContact.addressLine2\">\n                        <td></td>\n                        <td><span>{{ data.job.primaryContact.addressLine2 }}</span></td>\n                    </tr>\n                    <tr>\n                        <td></td>\n                        <td><span>{{ data.job.primaryContact.town }}</span></td>\n                    </tr>\n                    <tr>\n                        <td></td>\n                        <td><span>{{ data.job.primaryContact.state }} {{ data.job.primaryContact.postcode }}\n\t\t\t\t\t\t\t\t\t{{ data.job.primaryContact.country }}</span></td>\n                    </tr>\n                    <tr *ngIf=\"data.job.primaryContact.phoneNumber\">\n                        <td></td>\n                        <td>\n                            <span>Phone number: {{ data.job.primaryContact.phoneNumber }}</span></td>\n                    </tr>\n                    <tr>\n                        <td></td>\n                        <td><span>Email: {{ data.job.primaryContact.email }}</span></td>\n                    </tr>\n                    <tr *ngIf=\"data?.job?.primaryContact?.businessNumber\">\n                        <td></td>\n                        <td><span>{{ businessNumberLabelName }}: {{ data.job.primaryContact.businessNumber }}</span></td>\n                    </tr>\n                </table>\n            </div>\n        </div>\n    </div>\n\n    <div [ngClass]=\"{'col-xs-12': !isClientPortal}\" class=\"mt-20 print-no-padding\">\n        <h2 class=\"mb-20 f-s-24\">Quote</h2>\n    </div>\n    <product-package-table\n            class=\"print-no-padding\"\n            [ngClass]=\"{'col-xs-12': !isClientPortal}\"\n            [currencySymbol]=\"userCurrencySymbol\"\n            [summary]=\"data.summary\"\n            [data]=\"products\">\n    </product-package-table>\n\n    <!--This notes block show only on print-->\n    <!--This block shoould be remove when new client portal will be release-->\n    <div *ngIf=\"data.notes\" class=\"only-for-print col-xs-12 mt-20 print-no-padding\">\n        <h2 class=\"mt-30 f-s-24\">Notes</h2>\n        <p class=\"ws-pl\">{{ data.notes }}</p>\n    </div>\n</div>\n"

/***/ }),

/***/ "./web/modern/components/quote/quote-view-fixed/quote-view-fixed.scss":
/***/ (function(module, exports) {

module.exports = ".fixed-quote-box-shadow {\n  box-shadow: 0 0 10px #d7d7d7;\n  overflow: hidden;\n  padding: 45px 15px 0;\n  margin-bottom: -10px;\n  position: relative; }\n  .fixed-quote-box-shadow:after {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    display: block;\n    height: 20px;\n    width: 100%;\n    z-index: 10;\n    background-color: #fff; }\n"

/***/ }),

/***/ "./web/modern/components/quote/quote-view-fixed/quote-view-fixed.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var rxjs_1 = __webpack_require__("./node_modules/rxjs/Rx.js");
var settings_1 = __webpack_require__("./shared/services/settings/settings.ts");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var QuoteViewFixedComponent = function () {
    function QuoteViewFixedComponent(settingsService) {
        _classCallCheck(this, QuoteViewFixedComponent);

        this.settingsService = settingsService;
        this.isClientPortal = false;
        this.imgSrc = '';
        this.unsubscribe = new rxjs_1.Subject();
    }

    _createClass(QuoteViewFixedComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.subscribeToCustomizeLabelsChange();
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "subscribeToCustomizeLabelsChange",
        value: function subscribeToCustomizeLabelsChange() {
            var _this = this;

            this.settingsService.customizeLabelsObservable.pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (customizeLabels) {
                return _this.businessNumberLabelName = customizeLabels.businessNumberLabel;
            });
        }
    }]);

    return QuoteViewFixedComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], QuoteViewFixedComponent.prototype, "products", void 0);
__decorate([core_1.Input('company'), __metadata("design:type", Object)], QuoteViewFixedComponent.prototype, "company", void 0);
__decorate([core_1.Input('isClientPortal'), __metadata("design:type", Object)], QuoteViewFixedComponent.prototype, "isClientPortal", void 0);
__decorate([core_1.Input('data'), __metadata("design:type", Object)], QuoteViewFixedComponent.prototype, "data", void 0);
__decorate([core_1.Input('imgSrc'), __metadata("design:type", Object)], QuoteViewFixedComponent.prototype, "imgSrc", void 0);
__decorate([core_1.Input('userCurrencySymbol'), __metadata("design:type", Object)], QuoteViewFixedComponent.prototype, "userCurrencySymbol", void 0);
QuoteViewFixedComponent = __decorate([core_1.Component({
    selector: 'quote-view-fixed',
    template: __webpack_require__("./web/modern/components/quote/quote-view-fixed/quote-view-fixed.html"),
    styles: [__webpack_require__("./web/modern/components/quote/quote-view-fixed/quote-view-fixed.scss")]
}), __metadata("design:paramtypes", [settings_1.SettingsProvider])], QuoteViewFixedComponent);
exports.QuoteViewFixedComponent = QuoteViewFixedComponent;

/***/ }),

/***/ "./web/modern/components/quote/quote-view/quote-view.html":
/***/ (function(module, exports) {

module.exports = "<div *ngIf=\"data && data.job\">\n\n    <div class=\"row not-print btn-layout pb-23 mt--3\">\n        <div class=\"col-xs-9 breadcrumb-payments\">\n            <h2>\n                <span *ngIf=\"isFixed\">\n                    Fixed\n                </span>\n                Quote {{ data.quoteId }}\n            </h2>\n            <!-- BreadCrumbs -->\n            <div class=\"bc-wrap bc-wrap-no-border\">\n                <ol class=\"bc-list mt-0 mb-0\">\n                    <li><a href=\"/\">Dashboard</a></li>\n                    <li *ngIf=\"!isLeadView\"><a href=\"/jobs\">Jobs</a></li>\n                    <li *ngIf=\"isLeadView\"><a href=\"/leads\">Leads</a></li>\n                    <li *ngIf=\"!isLeadView\"><a href=\"/jobs/view/{{data.job.id}}\">{{ data.job.name }}</a></li>\n                    <li *ngIf=\"isLeadView\"><a href=\"/leads/view/{{data.job.leadId}}\">{{ data.job.name }}</a></li>\n                    <li class=\"active\">\n                        <span *ngIf=\"isFixed\">Fixed</span>\n                        Quote {{ data.quoteId }}</li>\n                </ol>\n            </div>\n        </div>\n        <!-- Total -->\n        <div *ngIf=\"data.summary && data.status.toUpperCase() === 'ACCEPTED' || isFixed\" class=\"col-xs-3 text-align-right quote-invoice-view-total\">\n            <div class=\"clearfix hidden\"></div>\n            <div class=\"color-java\">\n                <h2>{{ data.summary.totalWithCurrency.amountWithCurrency }}</h2>\n                <div class=\"color-grey\">Total</div>\n            </div>\n        </div>\n    </div>\n\n    <!-- Buttons start-->\n    <div class=\"clearfix group-btn not-print bc-wrap-border\">\n        <send-btn *ngIf=\"actions.SEND\"\n                  [text]=\"'Send Quote'\"\n                  (click)=\"showSendQuote()\"\n                  [isDisabled]=\"actions.SEND.state === 'disabled'\"\n                  [addClass]=\"'btn-lg'\"\n        ></send-btn>\n\n        <a *ngIf=\"actions.PREVIEW\"\n            [ngClass]=\"{'disabled' : actions.PREVIEW.state === 'disabled'}\"\n            class=\"btn-lg btn btn-default\"\n            target=\"_blank\"\n            [attr.href]=\"'clients/quotes/'+data.job.clientPortalLink+'/'+quoteId\"\n        >\n            <i class=\"fi fi-view\"></i>Preview\n        </a>\n\n        <button *ngIf=\"actions.MARK_AS_ACCEPTED\"\n            [disabled]=\"actions.MARK_AS_ACCEPTED.state === 'disabled'\"\n                class=\"btn btn-default btn-lg\" (click)=\"openMarkQuoteAsAcceptedModal()\">\n            <i class=\"fa fa-check f-s-14-i\" aria-hidden=\"true\"></i>Mark as Accepted\n        </button>\n\n        <button *ngIf=\"actionsV2.GENERATE_INVOICE_FROM_TEMPLATE || actions.GENERATE_INVOICE\"\n                class=\"btn btn-default btn-lg\" (click)=\"openGenerateInvoiceFromQuoteModal()\">\n            <i class=\"fa fa-file-text\"></i>Make Invoice\n        </button>\n\n        <edit-btn *ngIf=\"actions.EDIT\"\n                  [text]=\"'Edit'\"\n                  [isLink]=\"true\"\n                  [isDisabled]=\"actions.EDIT.state === 'disabled'\"\n                  [linkHref]=\"linkHref\"\n                  [addClass]=\"'btn-lg'\">\n        </edit-btn>\n        <button *ngIf=\"actions.SAVE_AS_PDF\"\n                (click)=\"saveAsPdf()\"\n                class=\"btn btn-default btn-lg\"\n                [disabled]=\"actions.SAVE_AS_PDF.state === 'disabled'\">\n            <i class=\"fa fa-file-pdf-o\"></i>\n            Save As PDF\n        </button>\n        <print-btn\n                *ngIf=\"actions.PRINT\"\n                [isDisabled]=\"actions.PRINT.state === 'disabled'\"\n        ></print-btn>\n\n        <delete-btn\n                *ngIf=\"actions.DELETE\"\n                (click)=\"deleteModalQuote()\"\n                [text]=\"'Delete'\"\n                [addClass]=\"'btn-lg'\"\n                [isDisabled]=\"actions.DELETE.state === 'disabled'\"\n        >\n        </delete-btn>\n\n    </div>\n\n    <!--  Fixed Quotes start-->\n    <quote-view-fixed\n            *ngIf=\"isFixed && chosenProducts\"\n            [company]=\"company\"\n            [data]=\"data\"\n            [imgSrc]=\"imgSrc\"\n            [products]=\"chosenProducts\"\n            [userCurrencySymbol]=\"userCurrencySymbol\"\n    ></quote-view-fixed>\n\n    <!--  New Quotes start -->\n    <div *ngIf=\"!isFixed\">\n        <div class=\"flex-box flex-just-space mb-30 \">\n            <div><img class=\"client-company-image client-company-image-max-height\" *ngIf=\"company && company.image\" [src]=\"company.image\"></div>\n            <div><img id=\"stamp\" class=\"quote-status-img not-print\" [src]=\"imgSrc\"></div>\n        </div>\n        <div class=\"flex-box flex-just-space main-block-info flex-wrap\">\n            <div class=\"block-info\">\n                <quote-info [data]=\"data\"></quote-info>\n            </div>\n            <div class=\"block-info\">\n                <quote-job-info [fromQuoteView]=\"true\" [job]=\"data.job\"></quote-job-info>\n            </div>\n            <div class=\"block-info\">\n                <quote-client-info [fromQuoteView]=\"true\" [job]=\"data.job\"></quote-client-info>\n            </div>\n            <div class=\"block-info\">\n                <quote-from-info *ngIf=\"company\" [company]=\"company\"></quote-from-info>\n            </div>\n        </div>\n\n        <p class=\"mt-30 f-s-14 mb-0\">\n            {{ data.introduction }}\n        </p>\n\n        <h2 class=\"mt-30\" *ngIf=\"packages && packages.length > 0\">Choose Package</h2>\n\n        <div class=\"flex-box flex-wrap quote-view-row mb-30\">\n            <package-info-panel  *ngFor='let packageItem of packages'\n                                 [currencySymbol]=\"userCurrencySymbol\"\n                                 [fromQuoteView]=\"true\"\n                                 [product]=\"packageItem\"\n                                 [tax]=\"data.currencyAndTax.percentage\"\n                                 [taxName]=\"data.currencyAndTax.taxName\"\n                                 [quoteStatus]=\"data.status\"\n                                 class=\"col-xs-12 col-sm-6\"\n                                 [ngClass]=\"{'col-lg-4': ![1, 2, 4].includes(packages.length),\n                                                'dimmed': data.status.toUpperCase() === 'ACCEPTED' && !packageItem.chosen}\"\n                                 (showPackageDetails)=\"showDetailsModal($event)\"></package-info-panel>\n        </div>\n        <div *ngIf=\"checkAddProductsPhraseVisibility()\" class=\"quote-notes-container quote-text mt-20\">\n            <h2 class=\"mt-25\">Choose Product</h2>\n        </div>\n        <addons-table *ngIf=\"addons && addons.length !== 0\" [fromQuoteView]=\"true\"\n                      class=\"mt-20\"\n                      [quoteStatus]=\"data.status\"\n                      [addons]=\"addons\">\n        </addons-table>\n        <div class=\"mt-30 mb-30\" *ngIf=\"discount.length\">\n            <h2 >Discount Applied</h2>\n            <discount-view-block [negativeItems]=\"discount\"></discount-view-block>\n        </div>\n        <quote-summary-block *ngIf=\"data.summary || data.summary !== null\" class=\"mt-30 mb-30\"\n                             [addedItems]=\"data.summary.items\"\n                             [quoteSummary]=\"data.summary\"></quote-summary-block>\n    </div>\n    <!-- Payment Schedule Contract Questionnaire blocks  -->\n    <quote-assignment-panel [isFixed]=\"isFixed\" [data]=\"data\" [isQuote]=\"true\"></quote-assignment-panel>\n\n    <div *ngIf=\"!(data.status.toUpperCase() === 'ACCEPTED' || data.status.toUpperCase() === 'DECLINED')\" [ngClass]=\"{'auto-generate-label-for-fixed-quote': isFixed }\" class=\"flex-box flex-align-center not-print\">\n        <span class=\"quote-info-label-icon mr-10\" [ngClass]=\"{'icon-red': !autoGenerateInvoice, 'icon-green': autoGenerateInvoice}\"></span>\n        <span class=\"quote-info-label\" *ngIf=\"autoGenerateInvoice\">An invoice will be automatically generated after the quote is accepted</span>\n        <span class=\"quote-info-label\" *ngIf=\"!autoGenerateInvoice\">This quote will not automatically generate an invoice after acceptance.</span>\n    </div>\n    <!--<modal-send-quote [email]=\"data.job.primaryContact.email\" [jobId]=\"jobId\" [quoteId]=\"quoteId\"></modal-send-quote>-->\n    <modal-delete-quote [jobId]=\"jobId\" [leadId]=\"leadId\" [quoteId]=\"quoteId\" [isLead]=\"isLeadView\"></modal-delete-quote>\n    <modal-make-invoice (updateBtnActions)=\"updateBtnActions($event)\" [url]=\"actionsV2.GENERATE_INVOICE_FROM_TEMPLATE && actionsV2.GENERATE_INVOICE_FROM_TEMPLATE.url\" [jobId]=\"jobId\" [quoteId]=\"quoteId\" ></modal-make-invoice>\n    <mark-quote-as-accepted (updateQuoteEvent)=\"getQuoteSourceData()\" [jobId]=\"jobId\" [quoteId]=\"quoteId\" [autoGenerateInvoice]=\"autoGenerateInvoice\" ></mark-quote-as-accepted>\n    <product-details-modal [product]=\"packageForModal\"></product-details-modal>\n</div>\n"

/***/ }),

/***/ "./web/modern/components/quote/quote-view/quote-view.scss":
/***/ (function(module, exports) {

module.exports = ".main-block-info .block-info {\n  width: 23%; }\n\n@media (max-width: 991px) {\n  .main-block-info .block-info {\n    width: 48%;\n    margin-bottom: 20px; } }\n\n@media (max-width: 767px) {\n  .main-block-info .block-info {\n    width: 100%;\n    margin-bottom: 20px; } }\n\n.quote-status-img {\n  margin-bottom: 0; }\n\n.quote-text {\n  font-size: 19px;\n  font-weight: 300; }\n\n.quote-info-label {\n  opacity: 0.65; }\n\n.quote-info-label-icon {\n  position: relative;\n  display: inline-block;\n  width: 15px;\n  height: 15px;\n  border-radius: 50%; }\n\n.icon-red {\n  border: 2px solid #f35d5d; }\n  .icon-red:before {\n    content: '!';\n    color: #f35d5d;\n    font-size: 11px;\n    font-weight: bold;\n    text-align: center;\n    position: absolute;\n    top: -3px;\n    right: -1px;\n    left: 0;\n    bottom: 0; }\n\n.icon-green {\n  border: 2px solid #22baa1; }\n  .icon-green:before {\n    content: '!';\n    color: #22baa1;\n    font-size: 11px;\n    font-weight: bold;\n    text-align: center;\n    position: absolute;\n    top: -3px;\n    right: -1px;\n    left: 0;\n    bottom: 0; }\n\n.auto-generate-label-for-fixed-quote {\n  box-shadow: 0 0 10px #d7d7d7;\n  padding: 0 30px 30px;\n  margin-top: -30px;\n  background-color: white;\n  position: relative; }\n  .auto-generate-label-for-fixed-quote:before {\n    content: '';\n    width: 100%;\n    height: 10px;\n    background-color: white;\n    position: absolute;\n    top: -10px;\n    left: 0;\n    right: 0;\n    margin: 0 auto; }\n"

/***/ }),

/***/ "./web/modern/components/quote/quote-view/quote-view.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var common_1 = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var stringModifier_service_1 = __webpack_require__("./shared/services/helpers/string-modifier-service/stringModifier.service.ts");
var quotes_data_service_1 = __webpack_require__("./shared/services/quote/quotes-data-service/quotes.data.service.ts");
var invoices_data_service_1 = __webpack_require__("./shared/services/invoice/invoices-data-service/invoices.data.service.ts");
var jobs_data_service_1 = __webpack_require__("./shared/services/job/jobs.data.service.ts");
var user_service_1 = __webpack_require__("./web/modern/services/user/user.service.ts");
var templates_data_service_1 = __webpack_require__("./shared/services/data-services/templates-data-service/templates.data.service.ts");
var account_data_service_1 = __webpack_require__("./shared/services/user/account.data.service.ts");
var quote_update_service_1 = __webpack_require__("./shared/services/quote/quote-update.service.ts");
var file_upload_data_service_1 = __webpack_require__("./shared/services/files/file-upload.data.service.ts");
var file_download_data_service_1 = __webpack_require__("./shared/services/files/file-download-service/file-download.data.service.ts");
var QuoteViewComponent = function () {
    function QuoteViewComponent(quoteDataService, messageService, location, invoicesDataService, jobsDataService, userService, templateRequestsService, accountService, stringModifierService, fileUploadService, fileDownloadService) {
        _classCallCheck(this, QuoteViewComponent);

        this.quoteDataService = quoteDataService;
        this.messageService = messageService;
        this.location = location;
        this.invoicesDataService = invoicesDataService;
        this.jobsDataService = jobsDataService;
        this.userService = userService;
        this.templateRequestsService = templateRequestsService;
        this.accountService = accountService;
        this.stringModifierService = stringModifierService;
        this.fileUploadService = fileUploadService;
        this.fileDownloadService = fileDownloadService;
        this.showSendModal = new core_1.EventEmitter();
        this.discount = [];
        this.isFixed = false;
    }

    _createClass(QuoteViewComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            var _this = this;

            this.configureCommunicationAdapter();
            if (this.quoteId && this.jobId) {
                this.getQuoteSourceData();
            } else if (this.quoteId && this.leadId) {
                this.getJobId();
            }
            this.setQuoteViewLinks();
            this.userCurrencySymbol = this.userService.userCurrencySymbol;
            this.accountService.getCompany().subscribe(function (data) {
                _this.company = data.company;
            }, function (error) {
                _this.messageService.showDefaultErrorMessage(error);
            });
        }
    }, {
        key: "deleteModalQuote",
        value: function deleteModalQuote() {
            if (this.isArchived) {
                this.messageService.showToaster('e_6', 'lead');
            } else {
                $('#deleteQuoteModal').modal();
            }
        }
    }, {
        key: "openGenerateInvoiceFromQuoteModal",
        value: function openGenerateInvoiceFromQuoteModal() {
            $('#generateInvoiceModal').modal('show');
        }
    }, {
        key: "openMarkQuoteAsAcceptedModal",
        value: function openMarkQuoteAsAcceptedModal() {
            $('#markQuoteAsAcceptedModal').modal('show');
        }
    }, {
        key: "updateBtnActions",
        value: function updateBtnActions(id) {
            var _this2 = this;

            this.quoteDataService.updateQuoteActions(this.jobId, this.quoteId).subscribe(function (actions) {
                return _this2.successUpdateBtnActions(actions, id);
            }, function (error) {
                return _this2.messageService.showDefaultErrorMessage(error);
            });
        }
    }, {
        key: "successUpdateBtnActions",
        value: function successUpdateBtnActions(actions, id) {
            this.actions = actions;
            this.redirectToInvoice(id);
        }
    }, {
        key: "redirectToInvoice",
        value: function redirectToInvoice(invoiceId) {
            this.location.go("/invoices/" + invoiceId);
        }
    }, {
        key: "getImgStatusSrc",
        value: function getImgStatusSrc(quoteStatus) {
            this.imgSrc = 'https://app.studioninja.co/build/release-pipeline-119/resources/dist/assets/images/icons/statuses/';
            if (quoteStatus === 'ACCEPTED') {
                this.imgSrc += 'accepted.png';
            } else if (quoteStatus === 'DECLINED') {
                this.imgSrc += 'declined.png';
            } else if (quoteStatus === 'SENT') {
                this.imgSrc += 'sent.png';
            } else if (quoteStatus === 'NOT_SENT') {
                this.imgSrc += 'notsent.png';
            }
            return this.imgSrc;
        }
    }, {
        key: "showSendQuote",
        value: function showSendQuote() {
            this.showSendModal.emit({
                contact: this.data.job.primaryContact,
                secondaryContact: this.data.job.secondaryContact,
                jobId: this.jobId,
                isFixed: this.isFixed
            });
        }
    }, {
        key: "showDetailsModal",
        value: function showDetailsModal(product) {
            this.packageForModal = product;
            $('#productDetailsModal').modal('show');
        }
    }, {
        key: "saveAsPdf",
        value: function saveAsPdf() {
            var _this3 = this;

            this.fileDownloadService.downloadPdf(this.data.job.clientPortalLink, this.quoteId, 'quote').catch(function (_ref) {
                var error = _ref.error;
                var errorTitle = error.errorTitle,
                    errorMessage = error.errorMessage;

                _this3.messageService.showErrorFromBackend(errorTitle, errorMessage);
            });
        }
    }, {
        key: "checkAddProductsPhraseVisibility",
        value: function checkAddProductsPhraseVisibility() {
            // this long check allows to show the phrase if: there are addons AND
            // there are no packages OR there is at least one NOT mandatory addon
            return this.addons && this.addons.length > 0 && (this.packages && this.packages.length > 0 || this.addons.some(function (addon) {
                return !addon.mandatory;
            }));
        }
    }, {
        key: "setQuoteViewLinks",
        value: function setQuoteViewLinks() {
            this.isJobView = this.location.path().includes('/jobs/');
            this.isLeadView = this.location.path().includes('/leads/');
            if (this.isJobView) {
                this.linkHref = "/jobs/" + this.jobId + "/quote/" + this.quoteId + "/update";
                this.linkToJobViewPage = "/jobs/view/" + this.jobId;
            } else if (this.isLeadView) {
                this.linkHref = "leads/" + this.leadId + "/quote/" + this.quoteId + "/update";
                this.linkToLeadViewPage = "/leads/view/" + this.leadId;
            }
        }
    }, {
        key: "getQuoteSourceData",
        value: function getQuoteSourceData() {
            var _this4 = this;

            this.quoteDataService.getQuoteToEditV1(this.jobId, this.quoteId).subscribe(function (data) {
                _this4.successGetQuoteData(data);
            }, function (error) {
                var errorCode = error.error.errorCode;

                if (errorCode === 102 || errorCode === 104) {
                    if (_this4.isJobView) {
                        _this4.location.go("" + _this4.linkToJobViewPage);
                    } else {
                        _this4.location.go("" + _this4.linkToLeadViewPage);
                    }
                    _this4.messageService.showToaster('e_19', 'editQuote');
                } else {
                    _this4.messageService.showDefaultErrorMessage(error);
                }
            });
        }
    }, {
        key: "successGetQuoteData",
        value: function successGetQuoteData(data) {
            var attachments = data.attachments,
                actions = data.actions,
                actionsV2 = data.actionsV2,
                quoteType = data.quoteType,
                generateInvoiceWhenAccepted = data.generateInvoiceWhenAccepted;

            this.actions = actions;
            this.actionsV2 = actionsV2;
            this.data = data;
            this.isFixed = quoteType === 'FIXED';
            this.autoGenerateInvoice = generateInvoiceWhenAccepted;
            if (this.data.summary !== null) {
                this.data.summary = Object.assign(data.summary, {
                    taxesName: data.currencyAndTax.taxName
                });
            }
            this.setPackagesAndAddons(data.products);
            this.getImgStatusSrc(this.data.status);
            if (attachments && attachments.length) {
                this.fileUploadService.setAttachmentsFromServer(attachments);
            }
            this.isArchived = data.job.archived;
        }
    }, {
        key: "getJobId",
        value: function getJobId() {
            var _this5 = this;

            this.quoteDataService.getJobId(this.leadId).subscribe(function (data) {
                _this5.jobId = data;
                _this5.getQuoteSourceData();
            }, function (error) {
                return _this5.messageService.showDefaultErrorMessage(error);
            });
        }
    }, {
        key: "setPackagesAndAddons",
        value: function setPackagesAndAddons(products) {
            var sortedProducts = quote_update_service_1.QuoteUpdateService.sortProducts(products);

            var _quote_update_service = quote_update_service_1.QuoteUpdateService.setPackagesAndAddons(sortedProducts),
                packages = _quote_update_service.packages,
                addons = _quote_update_service.addons,
                discounts = _quote_update_service.discounts;

            this.packages = packages;
            this.addons = addons;
            this.discount = discounts;
            this.checkForSinglePackage();
            if (this.isFixed) {
                this.chosenProducts = this.addons.concat(this.discount);
            } else {
                this.chosenProducts = this.groupChosenProducts();
            }
        }
    }, {
        key: "checkForSinglePackage",
        value: function checkForSinglePackage() {
            if (this.packages.length === 1) {
                this.packages[0].isSingle = true;
            }
        }
    }, {
        key: "groupChosenProducts",
        value: function groupChosenProducts() {
            var chosenProducts = [];
            this.packages.forEach(function (packageItem) {
                if (packageItem.chosen) {
                    chosenProducts.push(packageItem);
                }
            });
            this.addons.forEach(function (addon) {
                if (addon.chosen) {
                    chosenProducts.push(addon);
                }
            });
            return chosenProducts;
        }
    }, {
        key: "configureCommunicationAdapter",
        value: function configureCommunicationAdapter() {
            window.snCommunicationAdapter.registerMethod('updateQuoteViewData', this.getQuoteSourceData.bind(this));
        }
    }]);

    return QuoteViewComponent;
}();
__decorate([core_1.Input('quoteId'), __metadata("design:type", Number)], QuoteViewComponent.prototype, "quoteId", void 0);
__decorate([core_1.Input('jobId'), __metadata("design:type", Number)], QuoteViewComponent.prototype, "jobId", void 0);
__decorate([core_1.Input('leadId'), __metadata("design:type", Number)], QuoteViewComponent.prototype, "leadId", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], QuoteViewComponent.prototype, "showSendModal", void 0);
QuoteViewComponent = __decorate([core_1.Component({
    selector: 'quote-view',
    template: __webpack_require__("./web/modern/components/quote/quote-view/quote-view.html"),
    styles: [__webpack_require__("./web/modern/components/quote/quote-view/quote-view.scss")]
}), __metadata("design:paramtypes", [quotes_data_service_1.QuotesDataProvider, message_service_1.MessageService, common_1.Location, invoices_data_service_1.InvoicesDataProvider, jobs_data_service_1.JobsDataServiceProvider, user_service_1.UserServiceWebProvider, templates_data_service_1.TemplatesDataProvider, account_data_service_1.AccountDataServiceProvider, stringModifier_service_1.StringModifierServiceProvider, file_upload_data_service_1.FileUploadDataProvider, file_download_data_service_1.FileDownloadDataServiceProvider])], QuoteViewComponent);
exports.QuoteViewComponent = QuoteViewComponent;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./web/modern/components/quotes/addons-table/addons-table.component.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"table-responsive\">\n    <table class=\"table addons-table\">\n        <thead class=\"invoice-thead\">\n        <tr>\n            <th class=\"\">Product Name</th>\n            <th class=\"\">Quantity</th>\n            <th class=\"text-right\">Price</th>\n        </tr>\n        </thead>\n        <tbody>\n            <ng-container *ngFor=\"let addon of addons; let i = index;\">\n                <tr [ngClass]=\"{'unselected-addon': quoteStatus?.toUpperCase() === 'ACCEPTED' && !addon.chosen,\n                'selected-addon': addon.chosen }\">\n                    <td>\n                        <div class=\"product-name-cell\">\n                            <div class=\"product-name-text\">\n                                <div *ngIf=\"!addon.mandatory\" class=\"checkbox-squared mr-20\">\n                                    <input type=\"checkbox\"\n                                           name=\"addonCheckbox\"\n                                           [id]=\"'addon'+addon.id\"\n                                           [(ngModel)]=\"addon.chosen\"\n                                           [disabled]=\"quoteStatus?.toUpperCase() === 'ACCEPTED' || fromQuoteView\"\n                                           (ngModelChange)=\"changeAddonSelection()\"/>\n                                    <label [for]=\"'addon'+addon.id\"></label>\n                                </div>\n\n                                <label class=\"f-s-13 mt-0 mb-0 addon-label\" [ngClass]=\"{'hidden-checkbox-label': addon.mandatory}\" [for]=\"'addon'+addon.id\">\n                                    <div *ngIf=\"addon.recommended\" class=\"recommended-label f-s-12 inline-block mr-18\"><i class=\"fa fa-star\"></i> RECOMMENDED</div>\n                                    <h4 class=\"inline-block\">{{ addon.name }}</h4>\n                                </label>\n                            </div>\n                        </div>\n                        <div class=\"addon-details mt-10\">\n                            <sn-quill-view-web [content]=\"addon.description\"></sn-quill-view-web>\n                        </div>\n                    </td>\n                    <td>\n                        <input class=\"form-control disable-webshims\"\n                               type=\"number\"\n                               name=\"_quantity\"\n                               [(ngModel)]=\"addon.quantity\"\n                               (ngModelChange)=\"changeAddonQuantity(addon)\"\n                               (blur)=\"preventNegativeInput($event, i)\"\n                               (keyup)=\"preventDecimalInput($event, i)\"\n                               min=\"1\"\n                               step=\"1\"\n                               [disabled]=\"quoteStatus?.toUpperCase() === 'ACCEPTED' || fromQuoteView || addon.mandatory\"\n                               *ngIf=\"!addon.mandatory && addon.type.toUpperCase() !== 'GIFT'\"\n                               required>\n                        <span *ngIf=\"addon.mandatory && addon.type.toUpperCase() !== 'GIFT'\">{{ addon.quantity }}</span>\n                    </td>\n                    <td class=\"text-right\">\n                        <div>{{ addon.summary.subTotalWithDiscountAndCurrency.amountWithCurrency }}</div>\n                        <div *ngIf=\"addon.summary.total < addon.summary.subTotal && addon.summary.total >= 0\"\n                             class=\"old-price\">(was {{ addon.summary.subTotalWithCurrency.amountWithCurrency }})</div>\n                    </td>\n                </tr>\n            </ng-container>\n        </tbody>\n    </table>\n</div>\n\n"

/***/ }),

/***/ "./web/modern/components/quotes/addons-table/addons-table.component.scss":
/***/ (function(module, exports) {

module.exports = ":host {\n  display: block; }\n  :host .recommended-label {\n    font-size: 10px !important;\n    padding: 3px 6px;\n    letter-spacing: 1px;\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    height: 20px;\n    margin-bottom: 3px; }\n  :host .addons-table > tbody > tr > td:nth-child(1),\n  :host .addons-table > tbody > tr > th:nth-child(1),\n  :host .addons-table > thead > tr > td:nth-child(1),\n  :host .addons-table > thead > tr > th:nth-child(1) {\n    padding-left: 18px; }\n  :host .addons-table > tbody > tr > td:nth-child(3),\n  :host .addons-table > tbody > tr > th:nth-child(3),\n  :host .addons-table > thead > tr > td:nth-child(3),\n  :host .addons-table > thead > tr > th:nth-child(3) {\n    padding-right: 18px; }\n  :host .addons-table thead {\n    border-top: none; }\n    :host .addons-table thead tr th {\n      border-bottom: none; }\n      :host .addons-table thead tr th:nth-child(1) {\n        width: 75%; }\n      :host .addons-table thead tr th:nth-child(2) {\n        width: 10%;\n        min-width: 110px; }\n      :host .addons-table thead tr th:nth-child(3) {\n        width: 15%;\n        min-width: 110px;\n        max-width: 110px; }\n  :host .addons-table thead tr,\n  :host .addons-table tbody tr {\n    border-top: 2px solid #ececec;\n    border-bottom: 2px solid #ececec; }\n    :host .addons-table thead tr.unselected-addon,\n    :host .addons-table tbody tr.unselected-addon {\n      opacity: 0.5; }\n    :host .addons-table thead tr.selected-addon,\n    :host .addons-table tbody tr.selected-addon {\n      background-color: #fcfcfc; }\n    :host .addons-table thead tr.details-shown,\n    :host .addons-table tbody tr.details-shown {\n      border-bottom: none; }\n    :host .addons-table thead tr td,\n    :host .addons-table tbody tr td {\n      vertical-align: top !important; }\n      :host .addons-table thead tr td .product-name-cell .product-name-text,\n      :host .addons-table tbody tr td .product-name-cell .product-name-text {\n        display: -webkit-inline-box;\n        display: -webkit-inline-flex;\n        display: -ms-inline-flexbox;\n        display: inline-flex;\n        -webkit-box-align: start;\n        -webkit-align-items: flex-start;\n            -ms-flex-align: start;\n                align-items: flex-start;\n        padding-right: 5px; }\n      :host .addons-table thead tr td .product-name-cell .product-name-button,\n      :host .addons-table tbody tr td .product-name-cell .product-name-button {\n        display: inline-block; }\n      :host .addons-table thead tr td .old-price,\n      :host .addons-table tbody tr td .old-price {\n        font-size: 11px;\n        color: #aeaeae;\n        font-weight: 100; }\n  :host .addons-table thead .addon-label,\n  :host .addons-table tbody .addon-label {\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex; }\n    :host .addons-table thead .addon-label h4,\n    :host .addons-table tbody .addon-label h4 {\n      line-height: 1.3;\n      margin: 0; }\n  :host .addons-table thead .addon-details,\n  :host .addons-table tbody .addon-details {\n    padding-left: 40px;\n    border-top: none; }\n    :host .addons-table thead .addon-details td,\n    :host .addons-table tbody .addon-details td {\n      border: none;\n      padding: 24px 48px; }\n  :host .addons-table .btn {\n    padding: 6px 25px; }\n  :host .addons-table .checkbox-squared {\n    margin-bottom: 3px;\n    margin-top: 0;\n    width: 20px;\n    min-width: 20px;\n    height: 20px;\n    min-height: 20px; }\n    :host .addons-table .checkbox-squared input[type='checkbox'] + label {\n      width: 18px;\n      height: 18px; }\n    :host .addons-table .checkbox-squared input[type='checkbox']:checked + label {\n      background-color: #8dc73f !important; }\n      :host .addons-table .checkbox-squared input[type='checkbox']:checked + label:after {\n        width: 11px;\n        height: 7px;\n        background: transparent;\n        top: 4px;\n        left: 4px;\n        border: 3px solid #ffffff;\n        border-top: none;\n        border-right: none;\n        box-sizing: border-box; }\n  :host .addons-table .hidden-checkbox-label {\n    margin-left: 41px;\n    margin-right: 10px; }\n  :host .addons-table input[disabled] {\n    background-color: #fff; }\n  :host .addons-table .btn[disabled],\n  :host .addons-table input[disabled] {\n    opacity: 1; }\n"

/***/ }),

/***/ "./web/modern/components/quotes/addons-table/addons-table.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var forms_1 = __webpack_require__("./node_modules/@angular/forms/esm5/forms.js");
var rxjs_1 = __webpack_require__("./node_modules/rxjs/Rx.js");
var AddonsTableComponent = AddonsTableComponent_1 = function () {
    function AddonsTableComponent() {
        _classCallCheck(this, AddonsTableComponent);

        this.updateNotSelectedAddon = new core_1.EventEmitter();
        this.quantityDebouncer = new rxjs_1.Subject();
        this.selectionDebouncer = new rxjs_1.Subject();
        this.propagateChange = Function.prototype;
    }

    _createClass(AddonsTableComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.registerSelectionDebouncer();
            this.registerQuantityDebouncer();
        }
    }, {
        key: "changeAddonQuantity",
        value: function changeAddonQuantity(addon) {
            if (addon.quantity !== null && addon.quantity !== undefined && addon.quantity >= 0) {
                this.quantityDebouncer.next(addon);
            }
        }
    }, {
        key: "preventNegativeInput",
        value: function preventNegativeInput(event, i) {
            var value = this.addons[i].quantity;
            if (value === null || value < 1) {
                event.preventDefault();
                this.addons[i].quantity = 1;
            }
        }
    }, {
        key: "preventDecimalInput",
        value: function preventDecimalInput(event, i) {
            var value = this.addons[i].quantity;
            if (value && value % 1 !== 0) {
                event.preventDefault();
                this.addons[i].quantity = Math.floor(value);
            }
        }
    }, {
        key: "changeAddonSelection",
        value: function changeAddonSelection() {
            this.selectionDebouncer.next();
        }
    }, {
        key: "writeValue",
        value: function writeValue(addons) {
            this.addons = addons;
        }
    }, {
        key: "registerOnChange",
        value: function registerOnChange(fn) {
            this.propagateChange = fn;
        }
    }, {
        key: "registerOnTouched",
        value: function registerOnTouched() {}
    }, {
        key: "registerQuantityDebouncer",
        value: function registerQuantityDebouncer() {
            var _this = this;

            this.quantityDebouncer.debounceTime(500).subscribe(function (addon) {
                if (!addon.chosen) {
                    _this.updateNotSelectedAddon.emit(addon);
                } else {
                    _this.propagateChange(_this.addons);
                }
            });
        }
    }, {
        key: "registerSelectionDebouncer",
        value: function registerSelectionDebouncer() {
            var _this2 = this;

            this.selectionDebouncer.debounceTime(500).subscribe(function () {
                _this2.propagateChange(_this2.addons);
            });
        }
    }]);

    return AddonsTableComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Array)], AddonsTableComponent.prototype, "addons", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], AddonsTableComponent.prototype, "quoteStatus", void 0);
__decorate([core_1.Input(), __metadata("design:type", Boolean)], AddonsTableComponent.prototype, "fromQuoteView", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], AddonsTableComponent.prototype, "updateNotSelectedAddon", void 0);
AddonsTableComponent = AddonsTableComponent_1 = __decorate([core_1.Component({
    selector: 'addons-table',
    template: __webpack_require__("./web/modern/components/quotes/addons-table/addons-table.component.html"),
    styles: [__webpack_require__("./web/modern/components/quotes/addons-table/addons-table.component.scss")],
    providers: [{
        provide: forms_1.NG_VALUE_ACCESSOR,
        useExisting: core_1.forwardRef(function () {
            return AddonsTableComponent_1;
        }),
        multi: true
    }]
}), __metadata("design:paramtypes", [])], AddonsTableComponent);
exports.AddonsTableComponent = AddonsTableComponent;
var AddonsTableComponent_1;

/***/ }),

/***/ "./web/modern/components/quotes/common/discount-create-block/discount-create-block.component.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"discount-item\">\n    <div class=\"row ml-20\">\n        <div class=\"col-xs-3\">\n            <label class=\"control-label\">Product (optional)</label>\n            <div class=\"form-group\">\n                <select class=\"form-control\" [ngModel]=\"discountTemplateId\" (ngModelChange)=\"updateDiscount($event)\" name=\"discountTemplates\" >\n                    <option [attr.selected]=\"discountTemplateId === -1 ? 'selected' : null\"  value=\"-1\">Choose discount</option>\n                    <option *ngFor=\"let discountName of discountsNames | orderByName\" [attr.selected]=\"+discountTemplateId === discountName.id ? 'selected' : null\" [value]=\"discountName.id\">{{ discountName.name }}</option>\n                </select>\n            </div>\n        </div>\n        <div class=\"col-xs-4\">\n            <label class=\"control-label\">Name</label>\n            <input class=\"form-control text-ellipsis\"\n                   autocomplete=\"off\"\n                   type=\"text\"\n                   [(ngModel)]=\"chosenItem.name\"\n                   placeholder=\"E.g Gift Certificate\"\n                   maxlength=\"100\"\n                   required\n            >\n        </div>\n        <div class=\"col-xs-2\">\n            <div class=\"form-group\">\n                <label class=\"control-label no-text-wrap\">Discount amount</label>\n                <div>\n                    <input type=\"number\"\n                           class=\"form-control transition-0\"\n                           data-number-to-fixed=\"2\"\n                           name=\"price\"\n                           placeholder=\"{{currencySymbol}}0\"\n                           step=\"1.00\"\n                           (keydown)=\"checkKey($event)\"\n                           (blur)=\"validateDiscountOnBlur()\"\n                           [formControl]=\"priceField\"\n                           required\n                    >\n                </div>\n            </div>\n        </div>\n        <div class=\"col-xs-3 delete-container\">\n            <button type=\"button\" (click)=\"removeDiscount(index)\" class=\"btn btn-rounded btn-default ml-20 fa fa-trash-o\"></button>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "./web/modern/components/quotes/common/discount-create-block/discount-create-block.component.scss":
/***/ (function(module, exports) {

module.exports = ":host .discount-item {\n  background-color: #f9f9f9;\n  border: 1px solid #dddddd;\n  padding: 17px 15px 20px; }\n\n:host .delete-container {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n  -webkit-justify-content: flex-end;\n      -ms-flex-pack: end;\n          justify-content: flex-end; }\n"

/***/ }),

/***/ "./web/modern/components/quotes/common/discount-create-block/discount-create-block.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var quote_update_service_1 = __webpack_require__("./shared/services/quote/quote-update.service.ts");
var invoices_data_service_1 = __webpack_require__("./shared/services/invoice/invoices-data-service/invoices.data.service.ts");
var forms_1 = __webpack_require__("./node_modules/@angular/forms/esm5/forms.js");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var rxjs_1 = __webpack_require__("./node_modules/rxjs/Rx.js");
var DiscountCreateBlockComponent = function () {
    function DiscountCreateBlockComponent(quoteUpdateService, invoiceDataService) {
        _classCallCheck(this, DiscountCreateBlockComponent);

        this.quoteUpdateService = quoteUpdateService;
        this.invoiceDataService = invoiceDataService;
        this.changeDiscount = new core_1.EventEmitter();
        this.deleteDiscount = new core_1.EventEmitter();
        this.discountTemplateId = -1;
        this.unsubscribe = new rxjs_1.Subject();
        this.amountChanged = new rxjs_1.Subject();
    }

    _createClass(DiscountCreateBlockComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.priceField = new forms_1.FormControl();
            this.chosenItem = this.discount === null ? this.setDefaultDiscount() : this.setChosenDiscount();
            this.subscribeToInputChange();
            this.subscribeToAmountChange();
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "subscribeToInputChange",
        value: function subscribeToInputChange() {
            var _this = this;

            this.priceField.valueChanges.pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (amount) {
                _this.amountChanged.next(!amount ? 0 : -amount);
            });
        }
    }, {
        key: "subscribeToAmountChange",
        value: function subscribeToAmountChange() {
            var _this2 = this;

            this.amountChanged.pipe(operators_1.takeUntil(this.unsubscribe), operators_1.debounceTime(250)).subscribe(function (amount) {
                _this2.chosenItem.price = amount;
                _this2.calculateAmount(_this2.chosenItem);
            });
        }
    }, {
        key: "validateDiscountOnBlur",
        value: function validateDiscountOnBlur() {
            var priceValue = this.priceField.value;
            this.chosenItem.price = -priceValue;
            this.calculateAmount(this.chosenItem, true);
        }
    }, {
        key: "updateDiscount",
        value: function updateDiscount(discountId) {
            this.discountTemplateId = parseInt(discountId);
            if (this.discountTemplateId === -1) {
                this.chosenItem = Object.assign(this.chosenItem, this.setDefaultDiscount());
            } else {
                this.chosenItem = JSON.parse(JSON.stringify(this.discountsNames.filter(function (product) {
                    return product.id === +discountId;
                })[0]));
                this.setDiscountPrice(+this.chosenItem.price);
                this.chosenItem = Object.assign(this.chosenItem, {
                    fromSettings: true,
                    discount: 0,
                    quantity: 1,
                    summary: {
                        total: 0
                    },
                    recommended: false,
                    mandatory: true
                });
            }
            this.calculateAmount(this.chosenItem, true);
        }
    }, {
        key: "removeDiscount",
        value: function removeDiscount(index) {
            this.deleteDiscount.emit(index);
        }
    }, {
        key: "checkKey",
        value: function checkKey(event) {
            if (event.keyCode === 189 || event.keyCode === 109 || event.key === '-' || event.keyCode === 69) {
                event.preventDefault();
            }
        }
    }, {
        key: "calculateAmount",
        value: function calculateAmount(item, needToEmit) {
            var _this3 = this;

            var discoutToSend = JSON.parse(JSON.stringify(item));
            var data = {
                products: [discoutToSend],
                tax: this.taxPercentage
            };
            this.invoiceDataService.calculateInvoiceSummary(data).subscribe(function (calculatedData) {
                _this3.chosenItem.amount = calculatedData.items[0].summary.total;
                _this3.chosenItem.summary = calculatedData.items[0].summary;
                if (needToEmit) {
                    _this3.emitDiscountChange();
                }
                _this3.quoteUpdateService.setNextUpdateProduct(null, _this3.chosenItem);
            }, function (error) {
                return console.log(error);
            });
        }
    }, {
        key: "setChosenDiscount",
        value: function setChosenDiscount() {
            this.setDiscountPrice(this.discount.price);
            this.setDiscountTemplate();
            return Object.assign(this.discount, {
                discount: 0,
                quantity: 1,
                summary: {
                    total: 0
                },
                recommended: false,
                mandatory: true
            });
        }
    }, {
        key: "setDiscountTemplate",
        value: function setDiscountTemplate() {
            var _this4 = this;

            this.discountsNames.forEach(function (product) {
                switch (product.id) {
                    case _this4.discount.id:
                        _this4.discountTemplateId = _this4.discount.id;
                        break;
                    case null:
                        _this4.discountTemplateId = -1;
                        break;
                    default:
                        break;
                }
            });
        }
    }, {
        key: "setDefaultDiscount",
        value: function setDefaultDiscount() {
            this.priceField.setValue(null);
            var chosenItem = quote_update_service_1.QuoteUpdateService.setEmptyProduct('GIFT');
            chosenItem = Object.assign(chosenItem, {
                price: 0,
                discount: 0,
                quantity: 1,
                description: '<p>Fixed fee discount.</p>',
                name: '',
                summary: {
                    total: 0
                },
                taxType: 'NO_TAX',
                recommended: false,
                mandatory: true
            });
            return chosenItem;
        }
    }, {
        key: "setDiscountPrice",
        value: function setDiscountPrice(price) {
            var str = price.toString();
            var correctPrice = Number(str.substring(1, str.length)).toFixed(2);
            this.priceField.setValue(correctPrice);
        }
    }, {
        key: "emitDiscountChange",
        value: function emitDiscountChange() {
            var objToEmit = {
                index: this.index,
                type: 'discount',
                product: this.chosenItem
            };
            this.changeDiscount.emit(objToEmit);
        }
    }]);

    return DiscountCreateBlockComponent;
}();
__decorate([core_1.Input('discount'), __metadata("design:type", Object)], DiscountCreateBlockComponent.prototype, "discount", void 0);
__decorate([core_1.Input('index'), __metadata("design:type", Object)], DiscountCreateBlockComponent.prototype, "index", void 0);
__decorate([core_1.Input('currencySymbol'), __metadata("design:type", Object)], DiscountCreateBlockComponent.prototype, "currencySymbol", void 0);
__decorate([core_1.Input('discountsNames'), __metadata("design:type", Object)], DiscountCreateBlockComponent.prototype, "discountsNames", void 0);
__decorate([core_1.Input('taxPercentage'), __metadata("design:type", Object)], DiscountCreateBlockComponent.prototype, "taxPercentage", void 0);
__decorate([core_1.Output('changeDiscount'), __metadata("design:type", Object)], DiscountCreateBlockComponent.prototype, "changeDiscount", void 0);
__decorate([core_1.Output('deleteDiscount'), __metadata("design:type", Object)], DiscountCreateBlockComponent.prototype, "deleteDiscount", void 0);
DiscountCreateBlockComponent = __decorate([core_1.Component({
    selector: 'discount-create-block',
    template: __webpack_require__("./web/modern/components/quotes/common/discount-create-block/discount-create-block.component.html"),
    styles: [__webpack_require__("./web/modern/components/quotes/common/discount-create-block/discount-create-block.component.scss")]
}), __metadata("design:paramtypes", [quote_update_service_1.QuoteUpdateService, invoices_data_service_1.InvoicesDataProvider])], DiscountCreateBlockComponent);
exports.DiscountCreateBlockComponent = DiscountCreateBlockComponent;

/***/ }),

/***/ "./web/modern/components/quotes/common/discount-view-block/discount-view-block.component.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"discount-block\">\n    <div class=\"discount-block--item\" *ngFor=\"let item of negativeItems\">\n        <span><strong>{{ item.name }}</strong></span>\n        <span>{{ item.summary.priceWithCurrency.amountWithCurrency }}</span>\n    </div>\n\n</div>"

/***/ }),

/***/ "./web/modern/components/quotes/common/discount-view-block/discount-view-block.component.scss":
/***/ (function(module, exports) {

module.exports = ":host .discount-block {\n  margin-top: 20px;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n      -ms-flex-direction: column;\n          flex-direction: column; }\n  :host .discount-block--item {\n    padding: 15px 20px;\n    border: 1px solid #ccc;\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: justify;\n    -webkit-justify-content: space-between;\n        -ms-flex-pack: justify;\n            justify-content: space-between; }\n    :host .discount-block--item:not(:first-child) {\n      margin-top: 10px; }\n\n:host strong {\n  font-weight: 600; }\n"

/***/ }),

/***/ "./web/modern/components/quotes/common/discount-view-block/discount-view-block.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var DiscountViewBlockComponent = function DiscountViewBlockComponent() {
    _classCallCheck(this, DiscountViewBlockComponent);
};
__decorate([core_1.Input('negativeItems'), __metadata("design:type", Array)], DiscountViewBlockComponent.prototype, "negativeItems", void 0);
DiscountViewBlockComponent = __decorate([core_1.Component({
    selector: 'discount-view-block',
    template: __webpack_require__("./web/modern/components/quotes/common/discount-view-block/discount-view-block.component.html"),
    styles: [__webpack_require__("./web/modern/components/quotes/common/discount-view-block/discount-view-block.component.scss")]
}), __metadata("design:paramtypes", [])], DiscountViewBlockComponent);
exports.DiscountViewBlockComponent = DiscountViewBlockComponent;

/***/ }),

/***/ "./web/modern/components/quotes/common/payment-schedule/payment-schedule.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"mb-30\">\n  <template-apply-group-list\n          *ngIf=\"!hidePaymentSchedule && !hidePayments || ((+paymentScheduleTemplateId === -3 || +paymentScheduleTemplateId === -1) && quoteTotal !== 0)\"  [text]=\"paymentScheduleText\"\n          [templateList]=\"paymentScheduleNames\"\n          [templateDefaultList]=\"defaultPaymentScheduleNames\"\n          [selectedTemplateId]=\"paymentScheduleTemplateId\"\n          [disablePlaceholder]=\"true\"\n          [label]=\"'Custom'\"\n          (onTemplateChange)=\"getPaymentScheduleNew($event, false, quoteTotal, true, true)\">\n    <div *ngIf=\"+paymentScheduleTemplateId === -3\" class=\"label-template col-xs-12 col-sm-7 col-md-4\">\n      <div>No invoice will be generated once the quote is accepted.</div>\n    </div>\n  </template-apply-group-list>\n</div>\n\n<div *ngIf=\"isShowInformationBlock\" class=\"information-block\">\n  <span>Based on the due dates, your payments have been reordered from the earliest to the latest.</span>\n</div>\n\n<div class=\"table-responsive payment-schedule-table mb-30 mt-30\" *ngIf=\"!hidePaymentSchedule && !hidePayments\">\n  <table class=\"table table-responsive\" [ngClass]=\"{ 'fixed-quote-table' :  isFixed }\">\n    <thead>\n    <tr class=\"invoice-thead\">\n      <th class=\"payments\">Payments</th>\n      <th>Due</th>\n      <th></th>\n      <th style=\"text-align: right\">Amount</th>\n    </tr>\n    </thead>\n    <tbody>\n    <tr *ngFor=\"let payment of paymentsToShow; let paymentIndex = index\" class=\"border-bottom\">\n      <td>{{ paymentIndex + 1 }}</td>\n      <td>\n        <div class=\"flex-row flex-wrap flex-align-center\">\n          <div *ngIf=\"payment?.paymentDateWithRule?.ruleExplanationHTML && !payment?.paymentDateWithRule?.estimatedDate\" [innerHTML]=\"payment?.paymentDateWithRule?.ruleExplanationHTML | safeHtml\"></div>\n            <sn-date-picker *ngIf=\"payment?.paymentDateWithRule?.estimatedDate || ( !payment?.paymentDateWithRule?.estimatedDate && !payment?.paymentDateWithRule?.ruleExplanationHTML)\" class=\"payment-schedule-date\"\n                            [class.datepicker-invalid-field]=\"payment.date === null && !payment?.paymentDateWithRule?.ruleExplanationHTML\"\n                            [options]=\"'options' | snDatePickerConfig\"\n                            [disabled]=\"payment.writtenOff || payment.paid\"\n                            [placeholder]=\"datePlaceHolder\" [(ngModel)]=\"payment.date\"\n                            (ngModelChange)=\"changePayments(payment.date, paymentIndex)\"\n                            snDatePickerValidator></sn-date-picker>\n            <label class=\"label label-general label-danger-bright label-status label-response label-warning--triangle mb-0\"\n                 *ngIf=\"payment.date === null && !payment?.paymentDateWithRule?.ruleExplanationHTML\">\n                <span>Please enter a payment due date</span>\n            </label>\n        </div>\n      </td>\n      <td *ngIf=\"isFixed && payment.schedule.includes('% of')\" class=\"text-right payment-rule no-text-wrap\">{{ payment.schedule }} {{ isFixed ? ' :' : '' }}</td>\n      <td *ngIf=\"!isFixed || !payment.schedule.includes('% of')\"></td>\n      <td *ngIf=\"!isFixed && payment.schedule.includes('% of')\" style=\"text-align: right\" class=\"no-text-wrap\">{{ payment.schedule }}</td>\n      <td *ngIf=\"isFixed || !payment.schedule.includes('% of')\" style=\"text-align: right\" class=\"no-text-wrap\">{{ isFixed ? payment.amountWithCurrency.amountWithCurrency : (payment.paymentSchedulePart.amount | currency: currencySymbol) }}</td>\n    </tr>\n    <tr *ngIf=\"isInvoice && summary\">\n      <td></td>\n      <td></td>\n      <td class=\"text-right\">Total Due:</td>\n      <td class=\"no-text-wrap\">{{ summary.totalWithCurrency.amountWithCurrency }}</td>\n    </tr>\n    </tbody>\n  </table>\n</div>\n"

/***/ }),

/***/ "./web/modern/components/quotes/common/payment-schedule/payment-schedule.scss":
/***/ (function(module, exports) {

module.exports = ":host .border-bottom {\n  border-bottom: 1px solid #dddddd; }\n\n:host .payment-schedule-date {\n  width: 120px; }\n\n:host .payment-schedule-table {\n  overflow-x: visible; }\n\n.information-block {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  width: 100%;\n  min-height: 50px;\n  padding: 0 15px;\n  margin: -10px 0;\n  background-color: rgba(239, 145, 34, 0.1);\n  border-radius: 4px;\n  font-size: 13px;\n  color: #43444c; }\n"

/***/ }),

/***/ "./web/modern/components/quotes/common/payment-schedule/payment-schedule.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var stringModifier_service_1 = __webpack_require__("./shared/services/helpers/string-modifier-service/stringModifier.service.ts");
var invoices_data_service_1 = __webpack_require__("./shared/services/invoice/invoices-data-service/invoices.data.service.ts");
var payments_service_1 = __webpack_require__("./shared/services/payments/payments-service/payments.service.ts");
var quote_update_service_1 = __webpack_require__("./shared/services/quote/quote-update.service.ts");
var time_service_1 = __webpack_require__("./shared/services/helpers/time-service/time.service.ts");
var payments_data_service_1 = __webpack_require__("./shared/services/payments/payments-data-service/payments.data.service.ts");
var PaymentScheduleComponent = function () {
    function PaymentScheduleComponent(quoteUpdateService, invoicesDataService, paymentService, stringModifierService, timeService, paymentsDataService) {
        _classCallCheck(this, PaymentScheduleComponent);

        this.quoteUpdateService = quoteUpdateService;
        this.invoicesDataService = invoicesDataService;
        this.paymentService = paymentService;
        this.stringModifierService = stringModifierService;
        this.timeService = timeService;
        this.paymentsDataService = paymentsDataService;
        this.paymentScheduleChange = new core_1.EventEmitter();
        this.paymentsToShow = [];
        this.now = this.quoteUpdateService.getNowTextFormat();
        this.hidePaymentSchedule = false;
        this.hidePayments = true;
        this.shouldGetDefaultPayments = true;
        this.isShowInformationBlock = false;
    }

    _createClass(PaymentScheduleComponent, [{
        key: "ngAfterViewInit",
        value: function ngAfterViewInit() {
            switch (this.paymentScheduleTemplateId) {
                case -1:
                case -2:
                    this.getPaymentScheduleNew(this.paymentScheduleTemplateId, true);
                    break;
                case -3:
                    this.getPaymentScheduleNew(this.paymentScheduleTemplateId, false);
                    break;
                default:
                    this.getPaymentScheduleNew(0, false);
                    break;
            }
            if (this.paymentScheduleTemplateId !== -3) {
                this.hidePaymentSchedule = this.quoteTotal === 0;
            }
            this.isPartlyPaid = this.paymentService.isPaidPayments(this.payments) || this.paymentService.isWrittenOffPayments(this.payments);
            this.paymentScheduleText = "Assign a payment schedule to this " + (this.isInvoice ? 'invoice' : 'quote');
        }
    }, {
        key: "addSelectedSchedule",
        value: function addSelectedSchedule(schedule) {
            schedule.name = this.stringModifierService.addSelectedText(schedule.name);
            schedule.id = 0;
            this.paymentScheduleNames.push(schedule);
            this.paymentScheduleTemplateId = schedule.id;
        }
    }, {
        key: "emitPaymentsChanges",
        value: function emitPaymentsChanges() {
            this.payments = this.paymentsToShow;
            this.paymentScheduleChange.emit({
                id: this.paymentScheduleTemplateId,
                payments: this.paymentsToShow
            });
        }
    }, {
        key: "getPaymentScheduleNew",
        value: function getPaymentScheduleNew(paymentScheduleId, needToSendPayments, quoteTotal, refreshAmount, applyTemplate) {
            if (applyTemplate === true) {
                this.isShowInformationBlock = false;
            }
            if (refreshAmount) {
                this.paymentScheduleTemplateId = paymentScheduleId;
            } else if (this.paymentScheduleTemplateId != 0) {
                this.paymentScheduleTemplateId = paymentScheduleId;
            }
            this.hidePayments = false;
            if (quoteTotal != null) {
                this.quoteTotal = quoteTotal;
                if (quoteTotal === 0) {
                    this.hideAndResetPaymentSchedule();
                } else if (this.paymentScheduleTemplateId !== -3 && this.paymentScheduleTemplateId !== -1) {
                    this.hidePaymentSchedule = this.quoteTotal === 0;
                }
            }
            if (needToSendPayments && +paymentScheduleId === 0 && this.shouldGetDefaultPayments || refreshAmount && +paymentScheduleId === 0 && this.shouldGetDefaultPayments) {
                paymentScheduleId = +this.paymentScheduleIdFromServer;
                this.payments = this.formPaymentsToShow(JSON.parse(JSON.stringify(this.paymentsFromServer)));
                needToSendPayments = true;
            }
            if (+paymentScheduleId === 0 && this.shouldGetDefaultPayments) {
                this.paymentsToShow = this.formPaymentsToShow(JSON.parse(JSON.stringify(this.paymentsFromServer)));
                this.emitPaymentsChanges();
            } else if (+paymentScheduleId > 0) {
                var paymentScheduleObject = { id: +paymentScheduleId };
                this.formPaymentsNew(paymentScheduleObject, needToSendPayments);
            } else if (+paymentScheduleId === -2) {
                this.formPaymentsNew({ id: +paymentScheduleId }, needToSendPayments);
            } else {
                this.emitPaymentsChanges();
                this.hidePayments = true;
            }
            if (!this.shouldGetDefaultPayments) {
                this.shouldGetDefaultPayments = true;
            }
        }
    }, {
        key: "hideAndResetPaymentSchedule",
        value: function hideAndResetPaymentSchedule() {
            if (this.paymentScheduleTemplateId !== -3 && this.paymentScheduleTemplateId !== -1) {
                this.hidePaymentSchedule = this.quoteTotal === 0;
            } else {
                this.hidePayments = true;
            }
        }
    }, {
        key: "formPaymentsNew",
        value: function formPaymentsNew(paymentSchedule, needToSendPayments) {
            var _this = this;

            if (paymentSchedule.id === 0 || paymentSchedule.id === this.templateFromServer) {
                this.job.paymentScheduleId = 0;
            } else {
                this.job.paymentScheduleId = this.templateFromServer;
            }
            if (!this.quoteTotal) {
                this.quoteTotal = 0;
            }
            if (this.paymentScheduleTemplateId !== 0 || needToSendPayments) {
                this.payments.map(function (payment) {
                    return delete payment.date;
                });
                var paymentsToCalculate = this.generatePayments(paymentSchedule, needToSendPayments);
                this.paymentsDataService.calculatePaymentSchedule(paymentsToCalculate).subscribe(function (data) {
                    if (data.reordered === true) {
                        _this.isShowInformationBlock = true;
                    }
                    _this.paymentsToShow = [];
                    _this.paymentsToShow = _this.formPaymentsToShow(data.payments);
                    _this.hidePayments = false;
                    _this.emitPaymentsChanges();
                });
            } else {
                this.paymentsToShow = [];
                this.paymentsToShow = this.formPaymentsToShow(this.payments);
                this.emitPaymentsChanges();
            }
        }
    }, {
        key: "getTemplateId",
        value: function getTemplateId() {
            switch (+this.paymentScheduleTemplateId) {
                case 0:
                    return this.templateFromServer;
                case -1:
                case -2:
                    return null;
                default:
                    return this.paymentScheduleTemplateId;
            }
        }
    }, {
        key: "generatePayments",
        value: function generatePayments(paymentSchedule, needToSendPayments) {
            var paymentScheduleToReturn = this.getTemplateId();
            return {
                paymentScheduleId: paymentScheduleToReturn,
                jobDate: this.job.startDate,
                invoiceIssueDate: this.quoteUpdateService.getDate(this.issueDate.jsdate),
                totalAmount: this.quoteTotal,
                currencySymbol: this.currencySymbol,
                payments: needToSendPayments ? this.payments : [],
                invoiceOrQuote: this.isInvoice
            };
        }
    }, {
        key: "formPaymentsToShow",
        value: function formPaymentsToShow(payments) {
            var _this2 = this;

            return payments.map(function (payment) {
                var date = void 0;
                if (payment.paymentDateWithRule && payment.paymentDateWithRule.estimatedDate) {
                    date = _this2.quoteUpdateService.setQuoteIssueDate(payment.paymentDateWithRule.estimatedDate);
                } else if (!payment.paymentDateWithRule && payment.paymentDate) {
                    date = _this2.quoteUpdateService.setQuoteIssueDate(payment.paymentDate);
                } else {
                    date = null;
                }
                return Object.assign(payment, {
                    date: date,
                    schedule: "" + payment.paymentSchedulePart.amount + _this2.setAmountType(payment.paymentSchedulePart.type)
                });
            });
        }
    }, {
        key: "setAmountType",
        value: function setAmountType(type) {
            switch (type) {
                case 'Percent of order':
                    return '% of order';
                case 'Percent of remaining balance':
                    return '% of remaining balance';
                default:
                    return '';
            }
        }
    }, {
        key: "changePayments",
        value: function changePayments(date, index) {
            if (this.payments[index].paymentDateWithRule) {
                this.payments[index].paymentDateWithRule.estimatedDate = date === null ? null : this.quoteUpdateService.getDate(date.jsdate);
            }
            this.payments[index].paymentDate = date === null ? null : this.quoteUpdateService.getDate(date.jsdate);
            this.payments[index].due = date === null ? null : this.quoteUpdateService.getDate(date.jsdate);
            var paymentScheduleIdToGet = this.paymentScheduleTemplateId === 0 ? this.paymentScheduleIdFromServer : this.paymentScheduleTemplateId;
            this.shouldGetDefaultPayments = false;
            this.getPaymentScheduleNew(paymentScheduleIdToGet, true, this.quoteTotal);
        }
    }, {
        key: "paymentSchedule",
        get: function get() {
            return this.chosenPaymentSchedule;
        },
        set: function set(value) {
            this.chosenPaymentSchedule = value;
            if (value) {
                this.templateFromServer = this.job.paymentScheduleId;
                this.addSelectedSchedule(value);
            }
        }
    }]);

    return PaymentScheduleComponent;
}();
__decorate([core_1.Input('paymentScheduleNames'), __metadata("design:type", Object)], PaymentScheduleComponent.prototype, "paymentScheduleNames", void 0);
__decorate([core_1.Input('defaultPaymentScheduleNames'), __metadata("design:type", Object)], PaymentScheduleComponent.prototype, "defaultPaymentScheduleNames", void 0);
__decorate([core_1.Input('paymentScheduleTemplateId'), __metadata("design:type", Object)], PaymentScheduleComponent.prototype, "paymentScheduleTemplateId", void 0);
__decorate([core_1.Input('payments'), __metadata("design:type", Object)], PaymentScheduleComponent.prototype, "payments", void 0);
__decorate([core_1.Input('issueDate'), __metadata("design:type", Object)], PaymentScheduleComponent.prototype, "issueDate", void 0);
__decorate([core_1.Input('jobStartDate'), __metadata("design:type", Object)], PaymentScheduleComponent.prototype, "jobStartDate", void 0);
__decorate([core_1.Input('currencySymbol'), __metadata("design:type", Object)], PaymentScheduleComponent.prototype, "currencySymbol", void 0);
__decorate([core_1.Input('datePlaceHolder'), __metadata("design:type", Object)], PaymentScheduleComponent.prototype, "datePlaceHolder", void 0);
__decorate([core_1.Input('job'), __metadata("design:type", Object)], PaymentScheduleComponent.prototype, "job", void 0);
__decorate([core_1.Input('quoteTotal'), __metadata("design:type", Number)], PaymentScheduleComponent.prototype, "quoteTotal", void 0);
__decorate([core_1.Input('isFixed'), __metadata("design:type", Boolean)], PaymentScheduleComponent.prototype, "isFixed", void 0);
__decorate([core_1.Input('paymentsFromServer'), __metadata("design:type", Object)], PaymentScheduleComponent.prototype, "paymentsFromServer", void 0);
__decorate([core_1.Input('paymentScheduleIdFromServer'), __metadata("design:type", Number)], PaymentScheduleComponent.prototype, "paymentScheduleIdFromServer", void 0);
__decorate([core_1.Input('isInvoice'), __metadata("design:type", Boolean)], PaymentScheduleComponent.prototype, "isInvoice", void 0);
__decorate([core_1.Input('summary'), __metadata("design:type", Object)], PaymentScheduleComponent.prototype, "summary", void 0);
__decorate([core_1.Output(), __metadata("design:type", Object)], PaymentScheduleComponent.prototype, "paymentScheduleChange", void 0);
__decorate([core_1.Input('paymentSchedule'), __metadata("design:type", Object), __metadata("design:paramtypes", [Object])], PaymentScheduleComponent.prototype, "paymentSchedule", null);
PaymentScheduleComponent = __decorate([core_1.Component({
    selector: 'payment-schedule',
    template: __webpack_require__("./web/modern/components/quotes/common/payment-schedule/payment-schedule.html"),
    styles: [__webpack_require__("./web/modern/components/quotes/common/payment-schedule/payment-schedule.scss")]
}), __metadata("design:paramtypes", [quote_update_service_1.QuoteUpdateService, invoices_data_service_1.InvoicesDataProvider, payments_service_1.PaymentsServiceProvider, stringModifier_service_1.StringModifierServiceProvider, time_service_1.TimeServiceProvider, payments_data_service_1.PaymentsDataServiceProvider])], PaymentScheduleComponent);
exports.PaymentScheduleComponent = PaymentScheduleComponent;

/***/ }),

/***/ "./web/modern/components/quotes/common/quote-client-info/quote-client-info.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"jobs-cell-item\">\n  <h2 class=\"jobs-cell-title\">\n    <span>{{ fromQuoteView ? 'Client' : 'For' }}</span>\n    <span class=\"fi-grey fi-clients pull-right\"></span>\n  </h2>\n  <div class=\"section-data\">\n    <table class=\"table-profile\">\n      <tbody>\n      <tr *ngIf=\"job.primaryContact.companyName\">\n        <td>\n          <b class=\"text-break\">{{ job.primaryContact.companyName }}</b>\n        </td>\n      </tr>\n      <tr>\n        <td>\n          <b class=\"text-break-cell\">{{ job.primaryContact.firstName }} {{ job.primaryContact.lastName }}</b>\n        </td>\n      </tr>\n      <tr>\n        <td class=\"text-break\">{{ job.primaryContact.addressLine1 }}</td>\n      </tr>\n      <tr *ngIf=\"job.primaryContact.addressLine2\">\n        <td class=\"text-break\">{{ job.primaryContact.addressLine2 }}</td>\n      </tr>\n      <tr>\n        <td class=\"text-break\">{{ job.primaryContact.town }}</td>\n      </tr>\n      <tr>\n        <td class=\"text-break\">{{ job.primaryContact.state }} {{ job.primaryContact.postcode }} {{ job.primaryContact.country }} </td>\n      </tr>\n      <tr *ngIf=\"job.primaryContact.phone || job.primaryContact.phoneNumber\" >\n        <td class=\"text-break\">Phone number: {{ job.primaryContact.phone || job.primaryContact.phoneNumber }}</td>\n      </tr>\n      <tr>\n        <td class=\"text-break\">Email: {{ job.primaryContact.email }}</td>\n      </tr>\n      <tr *ngIf=\"job?.primaryContact?.businessNumber\">\n        <td class=\"text-break\">{{ businessNumberLabelName }}: {{ job.primaryContact.businessNumber }}</td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n"

/***/ }),

/***/ "./web/modern/components/quotes/common/quote-client-info/quote-client-info.scss":
/***/ (function(module, exports) {

module.exports = ":host .jobs-cell-item {\n  margin: 0;\n  height: 100%; }\n"

/***/ }),

/***/ "./web/modern/components/quotes/common/quote-client-info/quote-client-info.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var rxjs_1 = __webpack_require__("./node_modules/rxjs/Rx.js");
var settings_1 = __webpack_require__("./shared/services/settings/settings.ts");
var QuoteClientInfoComponent = function () {
    function QuoteClientInfoComponent(settingsService) {
        _classCallCheck(this, QuoteClientInfoComponent);

        this.settingsService = settingsService;
        this.unsubscribe = new rxjs_1.Subject();
    }

    _createClass(QuoteClientInfoComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.subscribeToCustomizeLabelsChange();
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "subscribeToCustomizeLabelsChange",
        value: function subscribeToCustomizeLabelsChange() {
            var _this = this;

            this.settingsService.customizeLabelsObservable.pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (customizeLabels) {
                return _this.businessNumberLabelName = customizeLabels.businessNumberLabel;
            });
        }
    }]);

    return QuoteClientInfoComponent;
}();
__decorate([core_1.Input('job'), __metadata("design:type", Object)], QuoteClientInfoComponent.prototype, "job", void 0);
__decorate([core_1.Input(), __metadata("design:type", Boolean)], QuoteClientInfoComponent.prototype, "fromQuoteView", void 0);
QuoteClientInfoComponent = __decorate([core_1.Component({
    selector: 'quote-client-info',
    template: __webpack_require__("./web/modern/components/quotes/common/quote-client-info/quote-client-info.html"),
    styles: [__webpack_require__("./web/modern/components/quotes/common/quote-client-info/quote-client-info.scss")]
}), __metadata("design:paramtypes", [settings_1.SettingsProvider])], QuoteClientInfoComponent);
exports.QuoteClientInfoComponent = QuoteClientInfoComponent;

/***/ }),

/***/ "./web/modern/components/quotes/common/quote-create-package-block/quote-create-package-block.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"package-item\">\n  <div class=\"package-header\" *ngIf=\"!isFixed\">\n    <div class=\"package-header-title\">\n      <h4>{{ product ? 'Product' : 'Package' }}<span>{{ index + 1 }}</span></h4>\n    </div>\n    <div class=\"package-header-delete\">\n      <div *ngIf=\"product\" class=\"recommended-block\">\n        <div class=\"checkbox-squared mr-5\">\n          <input [attr.id]=\"'product' + index + 1\"\n                 type=\"checkbox\"\n                 name=\"mandatory\"\n                 (ngModelChange)=\"setMandatoryPackage($event)\"\n                 [(ngModel)]=\"chosenItem.mandatory\"\n          />\n          <label [attr.for]=\"'product' + index + 1\"></label>\n        </div>\n        <label [ngClass]=\" product && this.chosenItem.recommended ? 'cursor-disabled': 'pointer'\" [for]=\"'product'+index + 1\">Mandatory</label>\n      </div>\n\n      <div class=\"recommended-block ml-15\" *ngIf=\"packagesLength !== 1\">\n        <div class=\"checkbox-squared mr-5\">\n          <input [attr.id]=\"(product ? 'productRecommended' : 'packageRecommended') + index + 1\"\n                 type=\"checkbox\"\n                 name=\"recommended\"\n                 [(ngModel)]=\"chosenItem.recommended\"\n                 (ngModelChange)=\"setRecommendedPackage($event)\"\n                 [disabled]=\"product && chosenItem.price < 0 || product && chosenItem.mandatory\"\n                 />\n          <label [attr.for]=\"(product ? 'productRecommended' : 'packageRecommended') + index + 1\"></label>\n        </div>\n        <label class=\"pointer\" [ngClass]=\"product && chosenItem.price < 0 ? 'cursor-disabled': 'pointer'\" [for]=\"(product ? 'productRecommended' : 'packageRecommended')+index + 1\" >Recommended</label>\n      </div>\n\n      <button type=\"button\" (click)=\"removePackage(index)\" class=\"btn btn-rounded btn-default ml-20 fa fa-trash-o\"></button>\n    </div>\n  </div>\n  <div class=\"row\" [ngClass]=\"isFixed ? 'fixed-form' : 'package-form'\">\n    <div *ngIf=\"isFixed\" class=\"dnd-icon-products handle-package\"></div>\n    <div class=\"col-xs-2\">\n      <div class=\"form-group\">\n        <label *ngIf=\"!isFixed\" class=\"control-label\">{{ product ? 'Product' : 'Package' }}</label>\n        <div class=\"select-style text-ellipsis\">\n          <select *ngIf=\"!isFixed\" class=\"form-control\" [ngModel]=\"packageTemplateId\" (ngModelChange)=\"updatePackage($event)\" name=\"packageTemplate\">\n            <option [attr.selected]=\"packageTemplateId === -1 ? 'selected' : null\" [value]=\"-1\">Choose {{ product ? 'Product' : 'Package' }}</option>\n            <option *ngFor=\"let productName of productsNames| orderByName\" [attr.selected]=\"+packageTemplateId === productName.id ? 'selected' : null\" [value]=\"productName.id\" >{{ productName.name }}</option>\n          </select>\n          <select *ngIf=\"isFixed\" class=\"form-control\" [ngModel]=\"packageTemplateId\" (ngModelChange)=\"updatePackage($event)\" name=\"packageTemplate\">\n            <option [attr.selected]=\"packageTemplateId === -1 ? 'selected' : null\" [value]=\"-1\">Choose Product / Package</option>\n            <optgroup *ngFor=\"let group of selectOptionGroups\" label=\"{{group.nameOfGroup}}\">\n              <ng-container *ngFor=\"let productPackage of productsNames | orderByName\">\n                <option *ngIf=\"group.type.includes(productPackage.type)\" [attr.selected]=\"+packageTemplateId === productPackage.id ? 'selected' : null\"  [value]=\"productPackage.id\" >{{ productPackage.name }}</option>\n              </ng-container>\n            </optgroup>\n          </select>\n        </div>\n      </div>\n      <input class=\"form-control text-ellipsis\" autocomplete=\"off\" type=\"text\" placeholder=\"Type a new Product / Package\"\n             maxlength=\"100\" required\n             [(ngModel)]=\"chosenItem.name\">\n    </div>\n    <div class=\"col-xs-4\" *ngIf=\"chosenItem\">\n      <div class=\"form-group\">\n        <label *ngIf=\"!isFixed\" class=\"control-label\">Description</label>\n        <sn-quill-editor-web\n                [initValue]=\"chosenItemDescription\"\n                (onTextChange)=\"chosenItem.description = $event\"\n                [editorID]=\"chosenItem?.id || (product ? 'product-' + index : 'package-' + index)\"\n                [maxLength]=\"4000\"\n                [styles]=\"{'minHeight': '200px'}\"\n                [varsList]=\"'PICK_AND_CHOOSE_MENU'\"\n                [toolbarSettings]=\"'counter color size font variables image'\"\n                [placeholder]=\"'Type description here … '\"\n        ></sn-quill-editor-web>\n      </div>\n    </div>\n    <div class=\"col-xs-6\">\n      <div class=\"quote-form-inputs row\">\n        <div class=\"form-group\">\n          <label *ngIf=\"!isFixed\" class=\"control-label\">Price</label>\n          <div class=\" text-ellipsis\">\n            <input type=\"number\" class=\"form-control transition-0\"\n                   name=\"price\"\n                   data-number-to-fixed=\"2\"\n                   step=\"1.00\"\n                   (blur)=\"validatePrice()\"\n                   (keydown)=\"checkKey($event)\"\n                   [ngModel]=\"chosenItem.price\"\n                   (ngModelChange)=\"changePriceAmount($event)\">\n          </div>\n        </div>\n        <div class=\"form-group\" *ngIf=\"product\">\n          <label *ngIf=\"!isFixed\" class=\"control-label\">Quantity</label>\n          <div>\n            <input type=\"number\" class=\"form-control\"\n                   [disabled]=\"chosenItem.price < 0\"\n                   data-number-to-fixed=\"2\" data-number-stepfactor=\"100\" min=\"0\" step=\"1.00\"\n                   (blur)=\"validateQiantity()\"\n                   [(ngModel)]=\"chosenItem.quantity\"\n                   (keydown)=\"checkKey($event)\"\n                   (keyup)=\"limitDecimalInput($event)\"\n                   (ngModelChange)=\"setNewChosenItemValues()\">\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <label *ngIf=\"!isFixed\" class=\"control-label\">Discount (%)</label>\n          <div>\n            <input type=\"number\" class=\"form-control\"\n                   [disabled]=\"chosenItem.price < 0\"\n                   max=\"100\"\n                   (blur)=\"validateDiscount()\"\n                   [ngModel]=\"chosenItem.discount\"\n                   (ngModelChange)=\"changeDiscountAmount($event)\"\n                   data-number-to-fixed=\"2\" min=\"0\" step=\"1.00\">\n          </div>\n        </div>\n        <div class=\"form-group product-tax\">\n          <label *ngIf=\"!isFixed\" class=\"control-label\">Tax</label>\n          <div class=\"select-style text-ellipsis\">\n            <select [(ngModel)]=\"chosenItem.taxType\"\n                    (ngModelChange)=\"setNewChosenItemValues()\">\n              <option [attr.selected]=\"chosenItem.taxType === 'INCLUDED' ? 'selected' : null\" value=\"INCLUDED\">Includes tax</option>\n              <option [attr.selected]=\"chosenItem.taxType === 'EXCLUDED' ? 'selected' : null\" value=\"EXCLUDED\">Excludes tax</option>\n              <option [attr.selected]=\"chosenItem.taxType === 'NO_TAX' ? 'selected' : null\" value=\"NO_TAX\">No tax</option>\n            </select>\n          </div>\n        </div>\n        <div class=\"form-group product-amount\">\n          <div *ngIf=\"chosenItem.summary?.totalWithCurrency\" class=\"product-amount-summary\">\n            <p *ngIf=\"!isFixed\">Amount</p>\n            <p class=\"mt-5 no-wrap\">{{ chosenItem.summary.totalWithCurrency.amountWithCurrency }}</p>\n          </div>\n          <div class=\"package-delete\" *ngIf=\"isFixed\">\n            <button type=\"button\" (click)=\"removePackage(index)\" class=\"btn btn-rounded btn-default fa fa-trash-o\"></button>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),

/***/ "./web/modern/components/quotes/common/quote-create-package-block/quote-create-package-block.scss":
/***/ (function(module, exports) {

module.exports = ":host .dnd-icon {\n  margin-right: 20px; }\n  :host .dnd-icon:before {\n    content: '\\F0C9';\n    font: normal normal normal 16px/1 FontAwesome;\n    color: #8e8e98; }\n\n:host .cursor-disabled {\n  cursor: not-allowed; }\n\n:host .handle-package {\n  position: absolute;\n  left: 20px;\n  top: 25px;\n  cursor: pointer;\n  /* fallback if grab cursor is unsupported */\n  cursor: -webkit-grab;\n  cursor: grab; }\n\n:host .package-item {\n  background-color: #f9f9f9;\n  border: 1px solid #dddddd; }\n  :host .package-item .package-header {\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-flex-wrap: nowrap;\n        -ms-flex-wrap: nowrap;\n            flex-wrap: nowrap;\n    -webkit-box-align: center;\n    -webkit-align-items: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: justify;\n    -webkit-justify-content: space-between;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n    padding: 10px 20px 5px; }\n    :host .package-item .package-header .package-header-title {\n      display: -webkit-box;\n      display: -webkit-flex;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n      -webkit-align-items: center;\n          -ms-flex-align: center;\n              align-items: center;\n      margin-left: 30px; }\n      :host .package-item .package-header .package-header-title span {\n        margin-left: 5px; }\n    :host .package-item .package-header .package-header-delete {\n      display: -webkit-box;\n      display: -webkit-flex;\n      display: -ms-flexbox;\n      display: flex; }\n      :host .package-item .package-header .package-header-delete .checkbox-squared + label {\n        font-size: 13px; }\n      :host .package-item .package-header .package-header-delete .recommended-block {\n        display: -webkit-box;\n        display: -webkit-flex;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n        -webkit-align-items: center;\n            -ms-flex-align: center;\n                align-items: center; }\n      :host .package-item .package-header .package-header-delete .mandatory-block {\n        display: -webkit-box;\n        display: -webkit-flex;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n        -webkit-align-items: center;\n            -ms-flex-align: center;\n                align-items: center; }\n      :host .package-item .package-header .package-header-delete .checkbox-squared input[type='checkbox']:disabled + label {\n        background-color: #f9f9f9 !important; }\n      :host .package-item .package-header .package-header-delete .btn {\n        margin-left: 10px;\n        margin-bottom: 0; }\n  :host .package-item .package-form,\n  :host .package-item .fixed-form {\n    background-color: #fff;\n    padding: 20px 5px;\n    margin: 0; }\n    :host .package-item .package-form textarea,\n    :host .package-item .fixed-form textarea {\n      resize: none;\n      height: 80px; }\n    :host .package-item .package-form .quote-form-inputs,\n    :host .package-item .fixed-form .quote-form-inputs {\n      display: -webkit-box;\n      display: -webkit-flex;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-flex-wrap: nowrap;\n          -ms-flex-wrap: nowrap;\n              flex-wrap: nowrap;\n      -webkit-box-pack: justify;\n      -webkit-justify-content: space-between;\n          -ms-flex-pack: justify;\n              justify-content: space-between; }\n      :host .package-item .package-form .quote-form-inputs > div,\n      :host .package-item .fixed-form .quote-form-inputs > div {\n        -webkit-flex-basis: 0;\n            -ms-flex-preferred-size: 0;\n                flex-basis: 0;\n        -webkit-box-flex: 2;\n        -webkit-flex-grow: 2;\n            -ms-flex-positive: 2;\n                flex-grow: 2;\n        margin: 0 10px; }\n      :host .package-item .package-form .quote-form-inputs .product-tax,\n      :host .package-item .fixed-form .quote-form-inputs .product-tax {\n        -webkit-box-flex: 3;\n        -webkit-flex-grow: 3;\n            -ms-flex-positive: 3;\n                flex-grow: 3; }\n    :host .package-item .package-form .product-amount,\n    :host .package-item .fixed-form .product-amount {\n      display: -webkit-box;\n      display: -webkit-flex;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: end;\n      -webkit-justify-content: flex-end;\n          -ms-flex-pack: end;\n              justify-content: flex-end;\n      margin-right: 45px; }\n      :host .package-item .package-form .product-amount-summary,\n      :host .package-item .fixed-form .product-amount-summary {\n        margin-right: 8px; }\n      :host .package-item .package-form .product-amount .package-delete,\n      :host .package-item .fixed-form .product-amount .package-delete {\n        width: 40%;\n        text-align: right; }\n        :host .package-item .package-form .product-amount .package-delete .btn,\n        :host .package-item .fixed-form .product-amount .package-delete .btn {\n          padding: 6px 12px; }\n  :host .package-item .package-form {\n    margin: 0 20px 20px; }\n  :host .package-item .fixed-form {\n    position: relative;\n    padding-left: 40px; }\n\n:host .no-wrap {\n  white-space: nowrap; }\n"

/***/ }),

/***/ "./web/modern/components/quotes/common/quote-create-package-block/quote-create-package-block.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var product_packages_data_service_1 = __webpack_require__("./mobile/src/providers/product-packages-service/product-packages.data.service.ts");
var stringModifier_service_1 = __webpack_require__("./shared/services/helpers/string-modifier-service/stringModifier.service.ts");
var invoices_data_service_1 = __webpack_require__("./shared/services/invoice/invoices-data-service/invoices.data.service.ts");
var quote_update_service_1 = __webpack_require__("./shared/services/quote/quote-update.service.ts");
var QuoteCreatePackageComponent = function () {
    function QuoteCreatePackageComponent(productPackagesService, invoiceDataService, stringModifier, quoteUpdateService) {
        _classCallCheck(this, QuoteCreatePackageComponent);

        this.productPackagesService = productPackagesService;
        this.invoiceDataService = invoiceDataService;
        this.stringModifier = stringModifier;
        this.quoteUpdateService = quoteUpdateService;
        this.chosenItemChanged = new Subject_1.Subject();
        this.unsubscribe = new Subject_1.Subject();
        this.packageTemplateId = -1;
        this.selectOptionGroups = [];
        this.deletePackage = new core_1.EventEmitter();
        this.checkRecommended = new core_1.EventEmitter();
        this.changeProduct = new core_1.EventEmitter();
    }

    _createClass(QuoteCreatePackageComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.validateQiantity();
            this.validateDiscount();
            this.subscribeToProductChanges();
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "setSelectGroups",
        value: function setSelectGroups(products) {
            var packageFilter = {
                type: 'PACKAGE',
                nameOfGroup: 'Packages'
            };
            var productFilter = {
                type: 'ADD_ON',
                nameOfGroup: 'Products'
            };

            var _quote_update_service = quote_update_service_1.QuoteUpdateService.setPackagesAndAddons(products),
                packages = _quote_update_service.packages,
                addons = _quote_update_service.addons,
                discounts = _quote_update_service.discounts;

            if (packages.length > 0) {
                this.selectOptionGroups.push(packageFilter);
            }
            if (this.isFixed) {
                addons.concat(discounts);
            }
            if (addons.length > 0) {
                this.selectOptionGroups.push(productFilter);
            }
        }
    }, {
        key: "removePackage",
        value: function removePackage(index) {
            var objectToEmit = {
                index: index,
                type: this.packageItem ? 'package' : 'product'
            };
            this.deletePackage.emit(objectToEmit);
        }
    }, {
        key: "emitProductChange",
        value: function emitProductChange() {
            var objToEmit = {
                index: this.index,
                type: this.packageItem ? 'package' : 'product',
                product: this.chosenItem
            };
            this.changeProduct.emit(objToEmit);
        }
    }, {
        key: "validatePrice",
        value: function validatePrice() {
            this.chosenItem.price = +this.chosenItem.price;
            this.chosenItem.price = this.chosenItem.price.toFixed(2);
        }
    }, {
        key: "validateQiantity",
        value: function validateQiantity() {
            this.chosenItem.quantity = +this.chosenItem.quantity;
            this.chosenItem.quantity = this.chosenItem.quantity.toFixed(2);
        }
    }, {
        key: "validateDiscount",
        value: function validateDiscount() {
            this.chosenItem.discount = +this.chosenItem.discount;
            this.chosenItem.discount = this.chosenItem.discount.toFixed(2);
        }
    }, {
        key: "changeDiscountAmount",
        value: function changeDiscountAmount(discount) {
            this.chosenItem.discount = discount;
            this.setNewChosenItemValues();
        }
    }, {
        key: "changePriceAmount",
        value: function changePriceAmount(price) {
            this.chosenItem.price = price;
            this.setNewChosenItemValues();
        }
    }, {
        key: "checkKey",
        value: function checkKey(event) {
            if (event.code === 189 || event.code === 109 || event.key === '-' || event.code === 69) {
                event.preventDefault();
            }
        }
    }, {
        key: "validateInputsValues",
        value: function validateInputsValues() {
            if (this.chosenItem.discount < 0) {
                this.chosenItem.discount = 0;
            }
            if (this.chosenItem.discount > 100) {
                this.chosenItem.discount = 100;
            }
            if (this.chosenItem.quantity < 0.1) {
                this.chosenItem.quantity = 1;
            }
            if (this.chosenItem.price < 0) {
                this.chosenItem.price = 0;
            }
        }
    }, {
        key: "setNewChosenItemValues",
        value: function setNewChosenItemValues() {
            this.chosenItemChanged.next(this.chosenItem);
        }
    }, {
        key: "calculateAmount",
        value: function calculateAmount(item, needToEmit) {
            var _this = this;

            this.validateInputsValues();
            var data = {
                products: this.validateProductsValues(item),
                tax: this.taxPercentage,
                currencySymbol: this.currencySymbol
            };
            this.invoiceDataService.calculateInvoiceSummary(data).subscribe(function (calculatedData) {
                _this.chosenItem.amount = calculatedData.items[0].summary.total;
                _this.chosenItem.summary = calculatedData.items[0].summary;
                if (needToEmit) {
                    _this.emitProductChange();
                }
                _this.quoteUpdateService.setNextUpdateProduct(_this.index, _this.chosenItem);
            }, function (error) {
                return console.log(error);
            });
        }
    }, {
        key: "setRecommendedPackage",
        value: function setRecommendedPackage(value) {
            if (value && this.chosenItem.mandatory) {
                this.chosenItem.mandatory = false;
            } else {
                this.chosenItem.recommended = value;
            }
        }
    }, {
        key: "setMandatoryPackage",
        value: function setMandatoryPackage(value) {
            if (value && this.chosenItem.recommended) {
                this.chosenItem.recommended = false;
            } else {
                this.chosenItem.mandatory = value;
            }
        }
    }, {
        key: "updatePackage",
        value: function updatePackage(productId) {
            var propertiesToKeep = {
                recommended: this.chosenItem.recommended,
                mandatory: this.chosenItem.mandatory
            };
            this.packageTemplateId = parseInt(productId);
            if (productId === '-1') {
                this.chosenItem = Object.assign(this.chosenItem, this.getDefaultValue());
            } else {
                this.chosenItem = JSON.parse(JSON.stringify(this.productsNames.filter(function (product) {
                    return product.id === +productId;
                })[0]));
            }
            this.chosenItem = Object.assign(this.chosenItem, {
                fromSettings: true,
                discount: 0,
                quantity: 1,
                summary: {
                    total: 0
                },
                recommended: propertiesToKeep.recommended,
                mandatory: propertiesToKeep.mandatory
            });
            this.chosenItemDescription = this.chosenItem.description;
            this.validatePrice();
            this.calculateAmount(this.chosenItem, true);
        }
    }, {
        key: "limitDecimalInput",
        value: function limitDecimalInput(event) {
            var value = this.chosenItem.quantity;
            if (value !== null && !Number.isNaN(value) && value.toString().split('.')[1] && value.toString().split('.')[1].length > 2) {
                event.preventDefault();
                this.chosenItem.quantity = this.chosenItem.quantity.toFixed(2);
            }
        }
    }, {
        key: "validateProductsValues",
        value: function validateProductsValues(item) {
            var validatedProduct = JSON.parse(JSON.stringify(item));
            return [Object.assign(validatedProduct, {
                discount: this.stringModifier.convertAmountIntoNumber(validatedProduct.discount),
                price: this.stringModifier.convertAmountIntoNumber(validatedProduct.price)
            })];
        }
    }, {
        key: "subscribeToProductChanges",
        value: function subscribeToProductChanges() {
            var _this2 = this;

            this.chosenItemChanged.takeUntil(this.unsubscribe).debounceTime(500).subscribe(function (data) {
                return _this2.calculateAmount(data);
            });
        }
    }, {
        key: "setChosenItem",
        value: function setChosenItem() {
            var _this3 = this;

            this.chosenItem = this.chosenProduct ? this.chosenProduct : this.chosenPackage;
            this.chosenItemDescription = this.chosenItem.description;
            if (this.productsNames) {
                this.productsNames.forEach(function (product) {
                    switch (product.id) {
                        case _this3.chosenItem.id:
                            _this3.packageTemplateId = _this3.chosenItem.id;
                            break;
                        case null:
                            _this3.packageTemplateId = -1;
                            break;
                        default:
                            break;
                    }
                });
            }
            if (this.chosenItem.id === null) {
                this.calculateAmount(this.chosenItem);
            }
            this.validatePrice();
        }
    }, {
        key: "getDefaultValue",
        value: function getDefaultValue() {
            return {
                description: '',
                id: null,
                name: '',
                price: 0,
                quantity: 0,
                discount: 0,
                summary: {
                    total: 0
                },
                taxValue: 0,
                tax: 'NO_TAX',
                recommended: false,
                mandatory: false,
                type: this.product ? 'ADD_ON' : 'PACKAGE'
            };
        }
    }, {
        key: "product",
        get: function get() {
            return this.chosenProduct;
        },
        set: function set(value) {
            this.chosenProduct = value;
            this.setChosenItem();
        }
    }, {
        key: "packageItem",
        get: function get() {
            return this.chosenPackage;
        },
        set: function set(value) {
            this.chosenPackage = value;
            this.setChosenItem();
        }
    }, {
        key: "packagesLength",
        get: function get() {
            return this._paskagesLength;
        }
    }, {
        key: "productsName",
        get: function get() {
            return this.productsNames;
        },
        set: function set(value) {
            this.productsNames = value;
            this.setSelectGroups(value);
        }
    }, {
        key: "packagesLengthValue",
        set: function set(value) {
            if (value <= 1 && this.chosenItem.recommended) {
                this.chosenItem.recommended = false;
            }
            this._paskagesLength = value;
        }
    }]);

    return QuoteCreatePackageComponent;
}();
__decorate([core_1.Input('index'), __metadata("design:type", Object)], QuoteCreatePackageComponent.prototype, "index", void 0);
__decorate([core_1.Input('currencySymbol'), __metadata("design:type", Object)], QuoteCreatePackageComponent.prototype, "currencySymbol", void 0);
__decorate([core_1.Input('taxPercentage'), __metadata("design:type", Object)], QuoteCreatePackageComponent.prototype, "taxPercentage", void 0);
__decorate([core_1.Input('isFixed'), __metadata("design:type", Object)], QuoteCreatePackageComponent.prototype, "isFixed", void 0);
__decorate([core_1.Input('productsName'), __metadata("design:type", Object), __metadata("design:paramtypes", [Object])], QuoteCreatePackageComponent.prototype, "productsName", null);
__decorate([core_1.Input('product'), __metadata("design:type", Boolean), __metadata("design:paramtypes", [Boolean])], QuoteCreatePackageComponent.prototype, "product", null);
__decorate([core_1.Input('package'), __metadata("design:type", Boolean), __metadata("design:paramtypes", [Boolean])], QuoteCreatePackageComponent.prototype, "packageItem", null);
__decorate([core_1.Input('packagesLength'), __metadata("design:type", Number), __metadata("design:paramtypes", [Number])], QuoteCreatePackageComponent.prototype, "packagesLengthValue", null);
__decorate([core_1.Output(), __metadata("design:type", Object)], QuoteCreatePackageComponent.prototype, "deletePackage", void 0);
__decorate([core_1.Output(), __metadata("design:type", Object)], QuoteCreatePackageComponent.prototype, "checkRecommended", void 0);
__decorate([core_1.Output(), __metadata("design:type", Object)], QuoteCreatePackageComponent.prototype, "changeProduct", void 0);
QuoteCreatePackageComponent = __decorate([core_1.Component({
    selector: 'quote-create-package-block',
    template: __webpack_require__("./web/modern/components/quotes/common/quote-create-package-block/quote-create-package-block.html"),
    styles: [__webpack_require__("./web/modern/components/quotes/common/quote-create-package-block/quote-create-package-block.scss")]
}), __metadata("design:paramtypes", [product_packages_data_service_1.ProductPackagesServiceProvider, invoices_data_service_1.InvoicesDataProvider, stringModifier_service_1.StringModifierServiceProvider, quote_update_service_1.QuoteUpdateService])], QuoteCreatePackageComponent);
exports.QuoteCreatePackageComponent = QuoteCreatePackageComponent;

/***/ }),

/***/ "./web/modern/components/quotes/common/quote-job-info/quote-job-info.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"jobs-cell-item\">\n <h2 class=\"jobs-cell-title\">\n    <span>{{ job.inLead ? (fromQuoteView ? 'Lead' : 'Details') : 'Job' }}</span>\n    <span class=\"fi-grey fi-jobs pull-right\"></span>\n  </h2>\n\n  <div class=\"section-data\">\n    <table class=\"table-profile\">\n      <tbody>\n      <tr>\n        <td><b class=\"text-break\">{{ job.name }}</b></td>\n      </tr>\n      <tr>\n        <td class=\"text-break\">{{ shootsLabelName }}: <br>\n          <main-shoot-date [start-date]=\"job.startDate\" [finish-date]=\"job.finishDate\" [fromQuote]=\"true\"></main-shoot-date>\n        </td>\n      </tr>\n      <tr *ngIf=\"job.startTime && job.finishTime\">\n        <td>\n          {{ job.startTime | timeFilter: '12h' }} - {{ job.finishTime | timeFilter: '12h' }}\n        </td>\n      </tr>\n      <tr *ngIf=\"job.shootLocation\">\n          <td class=\"text-break\">\n              {{ job.shootLocation }}\n          </td>\n      </tr>\n      <!-- Fallback for location field, because of fetching whole job/lead DTO on new quote     -->\n      <tr *ngIf=\"!job.shootLocation && job.location\">\n          <td class=\"text-break\">\n              {{ job.location }}\n          </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n"

/***/ }),

/***/ "./web/modern/components/quotes/common/quote-job-info/quote-job-info.scss":
/***/ (function(module, exports) {

module.exports = ":host .jobs-cell-item {\n  margin: 0;\n  height: 100%; }\n"

/***/ }),

/***/ "./web/modern/components/quotes/common/quote-job-info/quote-job-info.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var settings_1 = __webpack_require__("./shared/services/settings/settings.ts");
var rxjs_1 = __webpack_require__("./node_modules/rxjs/Rx.js");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var QuoteJobInfoComponent = function () {
    function QuoteJobInfoComponent(settingsService) {
        _classCallCheck(this, QuoteJobInfoComponent);

        this.settingsService = settingsService;
        this.unsubscribe = new rxjs_1.Subject();
    }

    _createClass(QuoteJobInfoComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.subscribeToCustomizeLabelsChange();
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "subscribeToCustomizeLabelsChange",
        value: function subscribeToCustomizeLabelsChange() {
            var _this = this;

            this.settingsService.customizeLabelsObservable.pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (customizeLabels) {
                return _this.shootsLabelName = customizeLabels.mainShootLabel;
            });
        }
    }]);

    return QuoteJobInfoComponent;
}();
__decorate([core_1.Input('job'), __metadata("design:type", Object)], QuoteJobInfoComponent.prototype, "job", void 0);
__decorate([core_1.Input(), __metadata("design:type", Boolean)], QuoteJobInfoComponent.prototype, "fromQuoteView", void 0);
QuoteJobInfoComponent = __decorate([core_1.Component({
    selector: 'quote-job-info',
    template: __webpack_require__("./web/modern/components/quotes/common/quote-job-info/quote-job-info.html"),
    styles: [__webpack_require__("./web/modern/components/quotes/common/quote-job-info/quote-job-info.scss")]
}), __metadata("design:paramtypes", [settings_1.SettingsProvider])], QuoteJobInfoComponent);
exports.QuoteJobInfoComponent = QuoteJobInfoComponent;

/***/ }),

/***/ "./web/modern/components/quotes/common/quote-summary-block/quote-summary-block.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"quote-summary\">\n  <h2 class=\"mt-0\">Quote Summary</h2>\n  <div class=\"table-responsive mt-30\">\n    <table class=\"table mb-0\">\n      <thead>\n        <tr>\n          <td>\n            Added items\n          </td>\n          <td></td>\n          <td class=\"td-w-92\" >Price</td>\n        </tr>\n      </thead>\n      <tbody>\n      <tr *ngFor=\"let item of addedItems\" class=\"border-top\" [ngClass]=\"{'color-discount': item.summary.total < 0 }\">\n        <td>\n          {{ item?.name }}\n        </td>\n        <td></td>\n        <td>{{ item?.summary.subTotalWithCurrency.amountWithCurrency }}</td>\n      </tr>\n      <tr class=\"tr-min-pd border-top\">\n        <td></td>\n        <td>Subtotal</td>\n        <td class=\"text-nowrap\">{{ quoteSummary?.subTotalWithCurrency?.amountWithCurrency }}</td>\n      </tr>\n      <tr *ngIf=\"quoteSummary?.discountValue && quoteSummary?.discountValue > 0\"\n          class=\"tr-min-pd not-border-top color-discount\">\n        <td></td>\n        <td>Discount</td>\n        <td class=\"text-nowrap\">-{{ quoteSummary?.discountValueWithCurrency?.amountWithCurrency }}</td>\n      </tr>\n      <tr class=\"tr-min-pd not-border-top bold\">\n        <td></td>\n        <td>Total</td>\n        <td class=\"text-nowrap\">{{ quoteSummary?.totalWithCurrency?.amountWithCurrency }}</td>\n      </tr>\n      <tr *ngIf=\"quoteSummary?.taxValue && quoteSummary?.taxValue > 0\"\n          class=\"tr-min-pd not-border-top color-grey-light\">\n        <td></td>\n        <td class=\"text-nowrap\">\n          {{ quoteSummary?.taxesName }} ({{ quoteSummary?.taxPercent }}%)\n        </td>\n        <td class=\"text-nowrap\">\n          {{ quoteSummary?.taxValueWithCurrency?.amountWithCurrency }}\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</section>"

/***/ }),

/***/ "./web/modern/components/quotes/common/quote-summary-block/quote-summary-block.scss":
/***/ (function(module, exports) {

module.exports = ":host {\n  display: block; }\n  :host .quote-summary {\n    background-color: #f9f9f9 !important;\n    border: 1px solid #dddddd;\n    padding: 30px 30px 0; }\n    :host .quote-summary h2 {\n      font-weight: 400; }\n    :host .quote-summary .table td:last-child {\n      text-align: right;\n      padding-left: 0; }\n    :host .quote-summary .table thead {\n      background-color: #ffffff;\n      font-weight: 600;\n      border-top: 2px solid #dddddd; }\n    :host .quote-summary .table tbody .border-top {\n      border-top: 2px solid #dddddd; }\n"

/***/ }),

/***/ "./web/modern/components/quotes/common/quote-summary-block/quote-summary-block.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var QuoteSummaryBlockComponent = function QuoteSummaryBlockComponent() {
    _classCallCheck(this, QuoteSummaryBlockComponent);

    this.submitDeclineReason = new core_1.EventEmitter();
};
__decorate([core_1.Input(), __metadata("design:type", Array)], QuoteSummaryBlockComponent.prototype, "addedItems", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], QuoteSummaryBlockComponent.prototype, "quoteSummary", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], QuoteSummaryBlockComponent.prototype, "submitDeclineReason", void 0);
QuoteSummaryBlockComponent = __decorate([core_1.Component({
    selector: 'quote-summary-block',
    template: __webpack_require__("./web/modern/components/quotes/common/quote-summary-block/quote-summary-block.html"),
    styles: [__webpack_require__("./web/modern/components/quotes/common/quote-summary-block/quote-summary-block.scss")]
}), __metadata("design:paramtypes", [])], QuoteSummaryBlockComponent);
exports.QuoteSummaryBlockComponent = QuoteSummaryBlockComponent;

/***/ }),

/***/ "./web/modern/components/quotes/modals/add-quote-type-modal/add-quote-type-modal.component.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"addNewQuoteTypeModal\" class=\"modal modal-center fade\" data-backdrop=\"static\" data-keyboard=\"false\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <close-btn></close-btn>\n                <h3 class=\"modal-title\">Add New Quote</h3>\n            </div>\n            <div class=\"modal-body add-new-modal add-new-list\">\n                <add-new-element-btn (onBtnClicked)=\"emitQuoteType('custom')\"\n                                     [icon]=\"'fi-quote fi-job'\"\n                                     [title]=\"'Pick & Choose Quote'\"\n                                     [description]=\"'Allow your clients to choose different packages and products.'\">\n                </add-new-element-btn>\n\n                <add-new-element-btn (onBtnClicked)=\"emitQuoteType('fixed')\"\n                                     [icon]=\"'fi-quote fi-job'\"\n                                     [title]=\"'Fixed Quote'\"\n                                     [description]=\"'Present your clients with a fixed list of packages and products.'\"\n                                     class=\"mt-20\">\n                </add-new-element-btn>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),

/***/ "./web/modern/components/quotes/modals/add-quote-type-modal/add-quote-type-modal.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var AddQuoteTypeModalComponent = function () {
    function AddQuoteTypeModalComponent() {
        _classCallCheck(this, AddQuoteTypeModalComponent);

        this.onQuoteTypeSelected = new core_1.EventEmitter();
    }

    _createClass(AddQuoteTypeModalComponent, [{
        key: "emitQuoteType",
        value: function emitQuoteType(quoteType) {
            this.onQuoteTypeSelected.next(quoteType);
        }
    }]);

    return AddQuoteTypeModalComponent;
}();
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], AddQuoteTypeModalComponent.prototype, "onQuoteTypeSelected", void 0);
AddQuoteTypeModalComponent = __decorate([core_1.Component({
    selector: 'add-quote-type-modal',
    template: __webpack_require__("./web/modern/components/quotes/modals/add-quote-type-modal/add-quote-type-modal.component.html")
}), __metadata("design:paramtypes", [])], AddQuoteTypeModalComponent);
exports.AddQuoteTypeModalComponent = AddQuoteTypeModalComponent;

/***/ }),

/***/ "./web/modern/components/quotes/modals/product-details-modal/product-details-modal.component.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"productDetailsModal\" class=\"modal modal-minimalistic modal-center fade\" data-backdrop=\"static\"\n     data-keyboard=\"false\">\n    <div class=\"modal-dialog w-max-600\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <close-btn></close-btn>\n                <h3 class=\"modal-title pr-15\">{{ product?.name }}</h3>\n            </div>\n            <div class=\"modal-body text-break-word\">\n                <price-tag [price]=\"product?.summary.subTotalWithDiscountAndCurrency.amountWithCurrency\"></price-tag>\n                <div class=\"negative-margin-15\">\n                    <sn-quill-view-web  class=\"innerHTML mt-20 mb-5\" [content]=\"product?.description\"></sn-quill-view-web>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),

/***/ "./web/modern/components/quotes/modals/product-details-modal/product-details-modal.component.scss":
/***/ (function(module, exports) {

module.exports = ":host .modal-content {\n  width: 100%; }\n\n:host .negative-margin-15 {\n  margin: 0 -15px !important; }\n"

/***/ }),

/***/ "./web/modern/components/quotes/modals/product-details-modal/product-details-modal.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var ProductDetailsModalComponent = function ProductDetailsModalComponent() {
    _classCallCheck(this, ProductDetailsModalComponent);
};
__decorate([core_1.Input(), __metadata("design:type", Object)], ProductDetailsModalComponent.prototype, "product", void 0);
ProductDetailsModalComponent = __decorate([core_1.Component({
    selector: 'product-details-modal',
    template: __webpack_require__("./web/modern/components/quotes/modals/product-details-modal/product-details-modal.component.html"),
    styles: [__webpack_require__("./web/modern/components/quotes/modals/product-details-modal/product-details-modal.component.scss")]
}), __metadata("design:paramtypes", [])], ProductDetailsModalComponent);
exports.ProductDetailsModalComponent = ProductDetailsModalComponent;

/***/ }),

/***/ "./web/modern/components/quotes/modals/save-as-template-modal/save-as-template-modal.component.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n    <button class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" [disabled]=\"btnDisable\" (click)=\"onDismiss()\">&times;</button>\n    <h3 class=\"modal-title f-w-n\">Save As {{ templateNameTitle }} Template</h3>\n</div>\n\n<div class=\"modal-body\">\n    <form (ngSubmit)=\"overwriteTemplate()\">\n\n        <div *ngIf=\"detailedDescription\" class=\"mb-30 detailedDescription\">\n            <img class=\"description-img\" src=\"https://app.studioninja.co/build/release-pipeline-119/resources/dist/assets/images/icons/exclamation-mark-icon.svg\" alt=\"exclamation-mark\">\n            <p class=\"description-text\">{{ detailedDescription }}</p>\n        </div>\n\n        <h4 class=\"mt-0\">Choose Existing Template</h4>\n        <div class=\"flex-box flex-align-center\">\n            <div class=\"select-style wp-100\">\n                <select [class.select-placeholder]=\"!selectedTemplate\"\n                        [ngModel]=\"selectedTemplate\" (ngModelChange)=\"templateChoose($event)\" [ngModelOptions]=\"{standalone: true}\">\n                    <option [ngValue]=\"null\" selected disabled hidden>Choose {{ templateTypeName }} Template</option>\n                    <option [ngValue]=\"template\" *ngFor=\"let template of templateList\">{{ template.name }}</option>\n                </select>\n            </div>\n\n            <div class=\"flex-box flex-align-center\">\n                <p class=\"mb-0 mr-15 ml-15 text-semi-bold\">OR</p>\n                <button class=\"btn btn-add-new-sm btn-info mb-0\" [disabled]=\"btnDisable\" (click)=\"saveNewTemplate()\">\n                    Add New Template\n                </button>\n            </div>\n        </div>\n\n        <p class=\"mt-30\">{{ breadcrumbsText }}</p>\n\n        <div class=\"mt-30\">\n            <button type=\"submit\" class=\"btn btn-success btn-lg mb-0 mr-10\"\n                    [disabled]=\"btnDisable\" spinning-wheel [is-spinning-wheel-active]=\"btnDisable\">\n                Overwrite Template\n            </button>\n            <button type=\"button\" class=\"btn btn-default btn-lg mb-0\" [disabled]=\"btnDisable\" (click)=\"onDismiss()\">Cancel</button>\n        </div>\n    </form>\n</div>\n"

/***/ }),

/***/ "./web/modern/components/quotes/modals/save-as-template-modal/save-as-template-modal.component.scss":
/***/ (function(module, exports) {

module.exports = ".detailedDescription {\n  width: 100%;\n  height: 60px;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: left;\n  -webkit-justify-content: left;\n      -ms-flex-pack: left;\n          justify-content: left;\n  background-color: #ffecb3; }\n  .detailedDescription .description-img {\n    margin: 0 15px 0 20px; }\n  .detailedDescription .description-text {\n    font-size: 13px;\n    font-weight: 400;\n    color: #4e342e;\n    margin-bottom: 0; }\n"

/***/ }),

/***/ "./web/modern/components/quotes/modals/save-as-template-modal/save-as-template-modal.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var ng_bootstrap_1 = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/index.js");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var confirm_general_modal_component_1 = __webpack_require__("./web/modern/components/common/confirm-general-modal/confirm-general-modal.component.ts");
var common_1 = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
var SaveAsTemplateModalComponent = function () {
    function SaveAsTemplateModalComponent(activeModal, modalService, location) {
        var _this = this;

        _classCallCheck(this, SaveAsTemplateModalComponent);

        this.activeModal = activeModal;
        this.modalService = modalService;
        this.location = location;
        this.selectedTemplate = null;
        location.onPopState(function () {
            return _this.onDismiss();
        });
    }

    _createClass(SaveAsTemplateModalComponent, [{
        key: "onDismiss",
        value: function onDismiss() {
            this.modalService.setModalData({ action: 'CLOSE', props: null });
        }
    }, {
        key: "overwriteTemplate",
        value: function overwriteTemplate() {
            var _this2 = this;

            if (!this.selectedTemplate) {
                this.modalService.setModalData({
                    action: 'OVERWRITE',
                    props: this.selectedTemplate
                });
                return;
            }
            this.confirmTemplateOverwrite().then(function (action) {
                _this2.modalService.setModalData({
                    action: action,
                    props: _this2.selectedTemplate
                });
            });
        }
    }, {
        key: "saveNewTemplate",
        value: function saveNewTemplate() {
            this.modalService.setModalData({
                action: 'SAVE',
                props: null
            });
        }
    }, {
        key: "templateChoose",
        value: function templateChoose(event) {
            this.selectedTemplate = event;
        }
    }, {
        key: "confirmTemplateOverwrite",
        value: function confirmTemplateOverwrite() {
            var _this3 = this;

            return new Promise(function (resolve, reject) {
                var modal = _this3.modalService.openModal(confirm_general_modal_component_1.ConfirmGeneralModalComponent, {
                    windowClass: 'ng-bootstrap-modal-small modal-visible modal-narrow'
                });
                modal.componentInstance.text = "The " + _this3.templateTypeName + " template <b>" + _this3.selectedTemplate.name + "</b> will be overwritten and updated. Are you sure?";
                modal.componentInstance.htmlText = true;
                modal.componentInstance.buttons = [{
                    text: 'Yes',
                    action: 'OVERWRITE',
                    color: 'success',
                    size: 'lg'
                }, {
                    text: 'No',
                    action: 'CLOSE',
                    color: 'default',
                    size: 'lg'
                }];
                modal.result.then(function (action) {
                    if (action === 'OVERWRITE') {
                        resolve(action);
                    }
                }).catch(reject);
            });
        }
    }]);

    return SaveAsTemplateModalComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Array)], SaveAsTemplateModalComponent.prototype, "templateList", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], SaveAsTemplateModalComponent.prototype, "detailedDescription", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], SaveAsTemplateModalComponent.prototype, "templateTypeName", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], SaveAsTemplateModalComponent.prototype, "templateNameTitle", void 0);
__decorate([core_1.Input(), __metadata("design:type", Boolean)], SaveAsTemplateModalComponent.prototype, "btnDisable", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], SaveAsTemplateModalComponent.prototype, "breadcrumbsText", void 0);
SaveAsTemplateModalComponent = __decorate([core_1.Component({
    selector: 'save-as-template',
    template: __webpack_require__("./web/modern/components/quotes/modals/save-as-template-modal/save-as-template-modal.component.html"),
    styles: [__webpack_require__("./web/modern/components/quotes/modals/save-as-template-modal/save-as-template-modal.component.scss")]
}), __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal, snModal_service_1.SNModalService, common_1.PlatformLocation])], SaveAsTemplateModalComponent);
exports.SaveAsTemplateModalComponent = SaveAsTemplateModalComponent;

/***/ }),

/***/ "./web/modern/components/quotes/modals/save-new-template-modal/save-new-template-modal.component.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n    <button class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" [disabled]=\"btnDisable\" (click)=\"onDismiss()\">&times;</button>\n    <h3 class=\"modal-title f-w-n\">Add New {{ templateNameTitle }} Template</h3>\n</div>\n\n<div class=\"modal-body\">\n    <form (ngSubmit)=\"saveNewTemplate()\">\n        <h4 class=\"mt-0\">{{ templateTypeName }} Template Name</h4>\n        <input type=\"text\" class=\"form-control\" placeholder=\"Enter Name\"\n               [ngModel]=\"templateName\"\n               (ngModelChange)=\"changeTemplateName($event)\"\n               [ngModelOptions]=\"{standalone: true}\"\n        >\n        <p class=\"mt-30\">{{ breadcrumbsText }}</p>\n\n        <div class=\"mt-30\">\n            <button type=\"submit\" class=\"btn btn-success btn-lg mr-10 mb-0\"\n                    [disabled]=\"btnDisable\" spinning-wheel [is-spinning-wheel-active]=\"btnDisable\">\n                Save Template\n            </button>\n            <button type=\"button\" class=\"btn btn-default btn-lg mb-0\" [disabled]=\"btnDisable\" (click)=\"onDismiss()\">Cancel</button>\n        </div>\n    </form>\n</div>\n"

/***/ }),

/***/ "./web/modern/components/quotes/modals/save-new-template-modal/save-new-template-modal.component.scss":
/***/ (function(module, exports) {

module.exports = ""

/***/ }),

/***/ "./web/modern/components/quotes/modals/save-new-template-modal/save-new-template-modal.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var ng_bootstrap_1 = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/index.js");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var SaveNewTemplateModalComponent = function () {
    function SaveNewTemplateModalComponent(activeModal, modalService) {
        _classCallCheck(this, SaveNewTemplateModalComponent);

        this.activeModal = activeModal;
        this.modalService = modalService;
    }

    _createClass(SaveNewTemplateModalComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.templateName = this.templateNameProp ? this.templateNameProp + " copy" : '';
        }
    }, {
        key: "onDismiss",
        value: function onDismiss() {
            this.modalService.setModalData({ action: 'CLOSE', props: null });
        }
    }, {
        key: "saveNewTemplate",
        value: function saveNewTemplate() {
            this.modalService.setModalData({
                action: 'SAVE',
                props: this.templateName
            });
        }
    }, {
        key: "changeTemplateName",
        value: function changeTemplateName(name) {
            this.templateName = name;
        }
    }]);

    return SaveNewTemplateModalComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", String)], SaveNewTemplateModalComponent.prototype, "templateTypeName", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], SaveNewTemplateModalComponent.prototype, "templateNameTitle", void 0);
__decorate([core_1.Input(), __metadata("design:type", Boolean)], SaveNewTemplateModalComponent.prototype, "btnDisable", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], SaveNewTemplateModalComponent.prototype, "breadcrumbsText", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], SaveNewTemplateModalComponent.prototype, "templateNameProp", void 0);
SaveNewTemplateModalComponent = __decorate([core_1.Component({
    selector: 'save-new-template',
    template: __webpack_require__("./web/modern/components/quotes/modals/save-new-template-modal/save-new-template-modal.component.html"),
    styles: [__webpack_require__("./web/modern/components/quotes/modals/save-new-template-modal/save-new-template-modal.component.scss")]
}), __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal, snModal_service_1.SNModalService])], SaveNewTemplateModalComponent);
exports.SaveNewTemplateModalComponent = SaveNewTemplateModalComponent;

/***/ }),

/***/ "./web/modern/components/quotes/package-info-panel/package-info-panel.component.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"package-info-panel\"\n     [ngClass]=\"{'package-info-panel--selected': product.chosen}\">\n    <div class=\"recommended-label\" *ngIf=\"product.recommended\"><i class=\"fa fa-star\"></i> RECOMMENDED</div>\n    <div class=\"package-info-panel-header\">\n        <div class=\"checkbox-squared ml-15\" [hidden]=\"product.isSingle\">\n            <input type=\"checkbox\"\n                   name=\"'packageCheckbox'+product.id\"\n                   [id]=\"'package'+product.id\"\n                   [(ngModel)]=\"product.chosen\"\n                   [disabled]=\"quoteStatus?.toUpperCase() === 'ACCEPTED' || fromQuoteView\"\n                   (ngModelChange)=\"onChange()\"/>\n            <label [for]=\"'package'+product.id\"></label>\n        </div>\n        <h3 class=\"mb-0 mt-0 ml-5\">{{ product.name }}</h3>\n        <price-tag class=\"ml-15 mr-15\" [price]=\"product.taxType.toUpperCase() === 'EXCLUDED' ? product.summary.subTotalWithDiscountAndCurrency.amountWithCurrency : product.summary.totalWithCurrency.amountWithCurrency\"></price-tag>\n    </div>\n    <div class=\"package-info-panel-content\">\n        <show-more-content [content]=\"product.description\" (emitShowMoreModal)=\"showDetails($event)\" ></show-more-content>\n    </div>\n    <div class=\"package-info-panel-footer\">\n        <div class=\"footer-price-row\">\n            <span>Price</span>\n            <span>{{ product.summary.subTotalWithCurrency.amountWithCurrency }}</span>\n        </div>\n        <div *ngIf=\"product.summary.discountValue > 0\" class=\"footer-price-row\">\n            <span>Discount ({{ product.discount }}%)</span>\n            <span>-{{ product.summary.discountValueWithCurrency.amountWithCurrency }}</span>\n        </div>\n        <hr class=\"footer-divider\">\n        <div class=\"footer-price-row footer-price-row--bold\">\n            <span>Total</span>\n            <span>{{ product.summary.totalWithCurrency.amountWithCurrency }}</span>\n        </div>\n        <div *ngIf=\"product.summary.taxValue > 0\" class=\"footer-price-row grey-span\">\n            <span>Incl. {{ taxName }} ({{ tax }}%)</span>\n            <span>{{ product.summary.taxValueWithCurrency.amountWithCurrency }}</span>\n        </div>\n    </div>\n</div>"

/***/ }),

/***/ "./web/modern/components/quotes/package-info-panel/package-info-panel.component.scss":
/***/ (function(module, exports) {

module.exports = ":host {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-wrap: wrap;\n      -ms-flex-wrap: wrap;\n          flex-wrap: wrap;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  margin-top: 30px; }\n  :host.dimmed {\n    opacity: 0.7; }\n  :host .package-info-panel {\n    border: 1px solid #ccc;\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: column;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    height: 100%;\n    width: 100%;\n    margin: 0 auto 10px; }\n    :host .package-info-panel--selected {\n      border-color: #8dc73f;\n      box-shadow: 0 1px 3px 0 rgba(141, 199, 63, 0.35); }\n    :host .package-info-panel .recommended-label {\n      position: absolute;\n      -webkit-transform: translate(-1%, -103%);\n          -ms-transform: translate(-1%, -103%);\n              transform: translate(-1%, -103%); }\n    :host .package-info-panel-header {\n      -webkit-box-flex: 0;\n      -webkit-flex: 0 1 90px;\n          -ms-flex: 0 1 90px;\n              flex: 0 1 90px;\n      padding: 20px 0;\n      border-bottom: 2px solid #eee;\n      display: -webkit-box;\n      display: -webkit-flex;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n      -webkit-align-items: center;\n          -ms-flex-align: center;\n              align-items: center;\n      -webkit-box-pack: justify;\n      -webkit-justify-content: space-between;\n          -ms-flex-pack: justify;\n              justify-content: space-between; }\n      :host .package-info-panel-header .styled-input-radio {\n        -webkit-box-flex: 0;\n        -webkit-flex: 0 0 15px;\n            -ms-flex: 0 0 15px;\n                flex: 0 0 15px;\n        margin: 0 15px 0 20px; }\n        :host .package-info-panel-header .styled-input-radio label:after {\n          background: #4990e0;\n          width: 10px;\n          height: 10px;\n          margin: -6px 0; }\n      :host .package-info-panel-header h3 {\n        display: inline-block;\n        -webkit-box-flex: 1;\n        -webkit-flex: 1 1 250px;\n            -ms-flex: 1 1 250px;\n                flex: 1 1 250px;\n        word-break: break-word;\n        line-height: 1.3; }\n      :host .package-info-panel-header .btn {\n        color: #4e5e6a; }\n      :host .package-info-panel-header .checkbox-squared {\n        width: 20px;\n        min-width: 20px;\n        height: 20px;\n        min-height: 20px;\n        margin: 0 10px 0 0; }\n        :host .package-info-panel-header .checkbox-squared input[type='checkbox'] + label {\n          width: 18px;\n          height: 18px; }\n        :host .package-info-panel-header .checkbox-squared input[type='checkbox']:checked + label {\n          background-color: #8dc73f !important; }\n          :host .package-info-panel-header .checkbox-squared input[type='checkbox']:checked + label:after {\n            width: 11px;\n            height: 7px;\n            background: transparent;\n            top: 4px;\n            left: 4px;\n            border: 3px solid #ffffff;\n            border-top: none;\n            border-right: none;\n            box-sizing: border-box; }\n    :host .package-info-panel-content {\n      padding: 20px 15px;\n      -webkit-box-flex: 0;\n      -webkit-flex: 0 1 100%;\n          -ms-flex: 0 1 100%;\n              flex: 0 1 100%;\n      display: -webkit-box;\n      display: -webkit-flex;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n      -webkit-flex-direction: column;\n          -ms-flex-direction: column;\n              flex-direction: column;\n      -webkit-box-pack: justify;\n      -webkit-justify-content: space-between;\n          -ms-flex-pack: justify;\n              justify-content: space-between; }\n      :host .package-info-panel-content p {\n        overflow-y: hidden;\n        max-height: 12em; }\n    :host .package-info-panel-footer {\n      padding: 20px 15px;\n      background-color: #f9f9f9;\n      -webkit-box-flex: 0;\n      -webkit-flex: 0 0 155px;\n          -ms-flex: 0 0 155px;\n              flex: 0 0 155px;\n      display: -webkit-box;\n      display: -webkit-flex;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n      -webkit-flex-direction: column;\n          -ms-flex-direction: column;\n              flex-direction: column;\n      -webkit-justify-content: space-around;\n          -ms-flex-pack: distribute;\n              justify-content: space-around; }\n      :host .package-info-panel-footer .footer-price-row {\n        display: -webkit-box;\n        display: -webkit-flex;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-pack: justify;\n        -webkit-justify-content: space-between;\n            -ms-flex-pack: justify;\n                justify-content: space-between; }\n        :host .package-info-panel-footer .footer-price-row--bold {\n          font-weight: 700; }\n      :host .package-info-panel-footer .footer-divider {\n        margin: 0;\n        border-color: #ddd; }\n"

/***/ }),

/***/ "./web/modern/components/quotes/package-info-panel/package-info-panel.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var forms_1 = __webpack_require__("./node_modules/@angular/forms/esm5/forms.js");
var PackageInfoPanelComponent = PackageInfoPanelComponent_1 = function () {
    function PackageInfoPanelComponent() {
        _classCallCheck(this, PackageInfoPanelComponent);

        this.showPackageDetails = new core_1.EventEmitter();
        this.propagateChange = Function.prototype;
    }

    _createClass(PackageInfoPanelComponent, [{
        key: "showDetails",
        value: function showDetails() {
            this.showPackageDetails.emit(this.product);
        }
    }, {
        key: "writeValue",
        value: function writeValue(id) {
            this.selectedPackageId = id;
        }
    }, {
        key: "registerOnChange",
        value: function registerOnChange(fn) {
            this.propagateChange = fn;
        }
    }, {
        key: "onChange",
        value: function onChange() {
            // this.selectedPackageId = this.product.id;
            this.propagateChange(this.product);
        }
    }, {
        key: "registerOnTouched",
        value: function registerOnTouched() {}
    }]);

    return PackageInfoPanelComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], PackageInfoPanelComponent.prototype, "product", void 0);
__decorate([core_1.Input(), __metadata("design:type", Number)], PackageInfoPanelComponent.prototype, "tax", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], PackageInfoPanelComponent.prototype, "quoteStatus", void 0);
__decorate([core_1.Input(), __metadata("design:type", Boolean)], PackageInfoPanelComponent.prototype, "fromQuoteView", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], PackageInfoPanelComponent.prototype, "currencySymbol", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], PackageInfoPanelComponent.prototype, "taxName", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], PackageInfoPanelComponent.prototype, "showPackageDetails", void 0);
PackageInfoPanelComponent = PackageInfoPanelComponent_1 = __decorate([core_1.Component({
    selector: 'package-info-panel',
    template: __webpack_require__("./web/modern/components/quotes/package-info-panel/package-info-panel.component.html"),
    styles: [__webpack_require__("./web/modern/components/quotes/package-info-panel/package-info-panel.component.scss")],
    providers: [{
        provide: forms_1.NG_VALUE_ACCESSOR,
        useExisting: core_1.forwardRef(function () {
            return PackageInfoPanelComponent_1;
        }),
        multi: true
    }]
}), __metadata("design:paramtypes", [])], PackageInfoPanelComponent);
exports.PackageInfoPanelComponent = PackageInfoPanelComponent;
var PackageInfoPanelComponent_1;

/***/ }),

/***/ "./web/modern/components/quotes/product-package-table/product-package-table.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"table-responsive\">\n    <table class=\"table table-client invoice-product-package-table\">\n        <thead>\n        <tr class=\"invoice-thead\">\n            <th style=\"width: 20%\">Product / Package</th>\n            <th style=\"width: 40%\" >Description</th>\n            <th style=\"width: 10%\" class=\"text-right td-w-92\">Unit Price</th>\n            <th style=\"width: 10%\" class=\"text-right td-w-92\">Quantity</th>\n            <th style=\"width: 10%\" class=\"text-right td-w-92\" *ngIf=\"hasDiscount\">Discount</th>\n            <th style=\"width: 10%\" class=\"text-right td-w-92\">Amount</th>\n        </tr>\n        </thead>\n        <tbody>\n        <ng-container *ngFor=\"let product of data\">\n            <tr [ngClass]=\"{'color-discount': product.summary.total < 0}\">\n                <td>\n                    {{ product.name }}\n                </td>\n                <td class=\"description table-quill\">\n                    <div class=\"table-description\">\n                        <sn-quill-view-web [content]=\"product.description\"></sn-quill-view-web>\n                    </div>\n                </td>\n                <td  class=\"text-right\">\n                    <span *ngIf=\"product.type !== 'GIFT'\">{{ product.summary.priceWithCurrency.amountWithCurrency }}</span>\n                </td>\n                <td  class=\"text-right\">\n                    <span *ngIf=\"product.type !== 'GIFT'\">{{ product.quantity }}</span>\n                </td>\n                <td  class=\"text-right\" *ngIf=\"hasDiscount\">\n                    <span *ngIf=\"product.type !== 'GIFT'\">{{ product.discount !== 0 ? product.discount+'%' : '-' }}</span>\n                </td>\n                <td class=\"text-right\">\n\n                    {{ product.summary.subTotalWithDiscountAndCurrency.amountWithCurrency }}\n                </td>\n            </tr>\n        </ng-container>\n        <tr class=\"tr-min-pd\">\n            <td [attr.colspan]=\"hasDiscount ? 4 : 3\"></td>\n            <td>Subtotal</td>\n            <td>{{ summary.subTotalWithCurrency.amountWithCurrency }}</td>\n        </tr>\n        <tr class=\"tr-min-pd not-border-top color-discount\"\n            *ngIf=\"hasDiscount\">\n            <td [attr.colspan]=\"hasDiscount ? 4 : 3\"></td>\n            <td>Discount</td>\n            <td>-{{ summary.discountValueWithCurrency.amountWithCurrency }}</td>\n        </tr>\n        <tr class=\"tr-min-pd not-border-top bold text-nowrap\">\n            <td [attr.colspan]=\"hasDiscount ? 4 : 3\"></td>\n            <td>Total</td>\n            <td>{{ summary.totalWithCurrency.amountWithCurrency }}</td>\n        </tr>\n        <tr *ngIf=\"summary?.taxValue && summary?.taxValue > 0\"\n            class=\"tr-min-pd not-border-top color-grey-light text-nowrap\">\n            <td [attr.colspan]=\"hasDiscount ? 4 : 3\"></td>\n            <td class=\"text-nowrap\">\n                {{ invoice ? invoice?.currencyAndTaxes?.taxName : summary?.taxesName }} ({{ summary?.taxPercent }}%)\n            </td>\n            <td class=\"text-nowrap\">\n                {{ summary?.taxValueWithCurrency.amountWithCurrency }}\n            </td>\n        </tr>\n        </tbody>\n    </table>\n\n</div>"

/***/ }),

/***/ "./web/modern/components/quotes/product-package-table/product-package-table.scss":
/***/ (function(module, exports) {

module.exports = ":host {\n  display: block; }\n  :host .addons-table thead {\n    border-top: none; }\n    :host .addons-table thead tr th {\n      border-bottom: none; }\n      :host .addons-table thead tr th:nth-child(1) {\n        width: 70%; }\n      :host .addons-table thead tr th:nth-child(2) {\n        width: 8%;\n        min-width: 110px; }\n      :host .addons-table thead tr th:nth-child(3) {\n        width: 22%;\n        min-width: 110px; }\n  :host .addons-table thead tr,\n  :host .addons-table tbody tr {\n    border-top: 2px solid #ececec;\n    border-bottom: 2px solid #ececec; }\n    :host .addons-table thead tr.unselected-addon,\n    :host .addons-table tbody tr.unselected-addon {\n      opacity: 0.5; }\n    :host .addons-table thead tr.details-shown,\n    :host .addons-table tbody tr.details-shown {\n      border-bottom: none; }\n    :host .addons-table thead tr td .product-name-cell .product-name-text,\n    :host .addons-table tbody tr td .product-name-cell .product-name-text {\n      display: inline-block;\n      white-space: nowrap;\n      overflow: hidden;\n      vertical-align: middle;\n      text-overflow: ellipsis;\n      padding-right: 5px;\n      width: 50%; }\n    :host .addons-table thead tr td .product-name-cell .product-name-button,\n    :host .addons-table tbody tr td .product-name-cell .product-name-button {\n      display: inline-block; }\n    :host .addons-table thead tr td .old-price,\n    :host .addons-table tbody tr td .old-price {\n      font-size: 11px;\n      color: #aeaeae;\n      font-weight: 100; }\n  :host .addons-table thead .addon-details,\n  :host .addons-table tbody .addon-details {\n    border-top: none; }\n    :host .addons-table thead .addon-details td,\n    :host .addons-table tbody .addon-details td {\n      border: none;\n      padding: 24px 48px; }\n  :host .addons-table .btn {\n    padding: 6px 25px; }\n  :host .addons-table .checkbox-squared,\n  :host .addons-table .checkbox-squared + label {\n    vertical-align: middle; }\n  :host .addons-table .hidden-checkbox-label {\n    margin-left: 32px;\n    margin-right: 10px; }\n  :host .addons-table input[disabled] {\n    background-color: #fff; }\n  :host .addons-table .btn[disabled],\n  :host .addons-table input[disabled] {\n    opacity: 1; }\n"

/***/ }),

/***/ "./web/modern/components/quotes/product-package-table/product-package-table.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var forms_1 = __webpack_require__("./node_modules/@angular/forms/esm5/forms.js");
var ProductPackageTableComponent = ProductPackageTableComponent_1 = function () {
    function ProductPackageTableComponent() {
        _classCallCheck(this, ProductPackageTableComponent);
    }

    _createClass(ProductPackageTableComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.hasDiscount = this.summary.discountValue && this.summary.discountValue > 0;
        }
    }]);

    return ProductPackageTableComponent;
}();
__decorate([core_1.Input('data'), __metadata("design:type", Array)], ProductPackageTableComponent.prototype, "data", void 0);
__decorate([core_1.Input('summary'), __metadata("design:type", Object)], ProductPackageTableComponent.prototype, "summary", void 0);
__decorate([core_1.Input('invoice'), __metadata("design:type", Object)], ProductPackageTableComponent.prototype, "invoice", void 0);
__decorate([core_1.Input('currencySymbol'), __metadata("design:type", String)], ProductPackageTableComponent.prototype, "currencySymbol", void 0);
ProductPackageTableComponent = ProductPackageTableComponent_1 = __decorate([core_1.Component({
    selector: 'product-package-table',
    template: __webpack_require__("./web/modern/components/quotes/product-package-table/product-package-table.html"),
    styles: [__webpack_require__("./web/modern/components/quotes/product-package-table/product-package-table.scss")],
    providers: [{
        provide: forms_1.NG_VALUE_ACCESSOR,
        useExisting: core_1.forwardRef(function () {
            return ProductPackageTableComponent_1;
        }),
        multi: true
    }]
}), __metadata("design:paramtypes", [])], ProductPackageTableComponent);
exports.ProductPackageTableComponent = ProductPackageTableComponent;
var ProductPackageTableComponent_1;

/***/ }),

/***/ "./web/modern/components/quotes/quote-update/quote-update.html":
/***/ (function(module, exports) {

module.exports = "<section *ngIf=\"job && quote\" dnd-auto-scroll id=\"main-wrapper\" class=\"new-container bg-white\">\n    <div class=\"qt-header mt-20\">\n        <div class=\"qt-header-breadcrumbs\">\n            <h2 class=\"mt-0\">{{ editQuote ? 'Edit Quote':'New Quote' }}</h2>\n\n            <div class=\"bc-wrap\">\n                <ol class=\"bc-list mt-0 mb-0\">\n                    <li><a href=\"/\">Dashboard</a></li>\n                    <li *ngIf=\"isJob\"><a href=\"/jobs\">Jobs</a></li>\n                    <li *ngIf=\"!isJob\"><a href=\"/leads\">Leads</a></li>\n                    <li *ngIf=\"isJob\"><a href=\"/jobs/view/{{job.id}}\">{{ job.name }}</a></li>\n                    <li *ngIf=\"!isJob\"><a href=\"/leads/view/{{ editQuote ? job.leadId : leadId }}\">{{ job.name }}</a></li>\n                    <li class=\"active\">{{ editQuote ? 'Edit Quote':'New Quote' }}</li>\n                </ol>\n            </div>\n        </div>\n        <div class=\"qt-header-template-list\" *ngIf=\"quoteTemplatesAvailable\">\n            <span class=\"text-semi-bold f-s-13 no-text-wrap mr-10\">Apply Template</span>\n            <div class=\"select-style wp-100\">\n                <select #quoteTemplateSelect\n                        [disabled]=\"loadingTemplate\"\n                        [ngModel]=\"selectedQuoteTemplateId\" (ngModelChange)=\"confirmApplyQuoteTemplate($event)\">\n                    <option [value]=-1>Choose Quote Template</option>\n                    <option [value]=\"template.id\" *ngFor=\"let template of quoteTemplates\">{{ template.name }}</option>\n                </select>\n            </div>\n        </div>\n    </div>\n\n    <hr class=\"mt-30\">\n\n    <div class=\"row show-grid\">\n        <div class=\"col-xs-12 col-md-6 show-grid jobs-text-forms quote-form\">\n            <div class=\"row\">\n                <div class=\"col-sm-4\">\n                    <label class=\"control-label\" >Quote ID</label>\n                    <div>\n                        <input type=\"text\" class=\"form-control\" maxlength=\"20\" [(ngModel)]=\"quote.quoteId\">\n                    </div>\n                </div>\n\n                <div class=\"col-sm-4\">\n                    <label class=\"control-label\">Issue date</label>\n                    <div class=\"box-no-transition\">\n                      <sn-date-picker [options]=\"'options' | snDatePickerConfig\"\n                                      [placeholder]=\"datePlaceHolder\" [(ngModel)]=\"issueDate\"\n                                      snDatePickerValidator></sn-date-picker>\n                    </div>\n                </div>\n\n                <div class=\"col-sm-4\">\n                    <label class=\"control-label\">PO Number</label>\n                    <div>\n                        <input type=\"text\" class=\"form-control\" maxlength=\"30\" [(ngModel)]=\"quote.ponumber\" placeholder=\"-\">\n                    </div>\n                </div>\n            </div>\n\n            <br>\n\n            <div class=\"row\">\n                <div class=\"col-sm-12\">\n                    <label class=\"control-label\">Introduction</label>\n                    <div>\n                        <textarea type=\"text\"\n                               class=\"form-control quote-introduction\"\n                                  maxlength=\"2000\"\n                                  [(ngModel)]=\"quote.introduction\"\n                                  placeholder=\"E.g. Thank you for considering me as your photographer! Please choose from the list of packages and products and click Accept. Don't hesitate to contact me if you have any questions.\" ></textarea>\n                    </div>\n                </div>\n            </div>\n\n        </div>\n\n        <div class=\"col-xs-12 col-md-6 show-grid\" *ngIf=\"job\">\n            <div class=\"row\">\n                <div class=\"flex-row flex-wrap-sm\">\n                    <div class=\"col-xs-12 col-md-6 mt-0\">\n                        <quote-job-info [job]=\"job\" [fromQuoteView]=\"true\"></quote-job-info>\n                     </div>\n                     <div class=\"col-xs-12 col-md-6 mt-0\">\n                        <quote-client-info [job]=\"job\" [fromQuoteView]=\"true\"></quote-client-info>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n\n  <div *ngIf=\"quoteType === 'custom' && packagesNames\">\n    <h2 class=\"quote-section-name\"> Add Packages</h2>\n    <p>Create a list of packages which your client can choose between. Multiple packages can be chosen.</p>\n    <div dragula=\"packages\" class=\"package-container mb-10\" [(dragulaModel)]=\"packages\">\n      <div *ngFor=\"let package of packages; let packageIndex = index\"  [class.last-package-item]=\"packageIndex === packages.length - 1\" class=\"dnd-package mb-20\">\n        <div class=\"dnd-icon-products handle-package\"></div>\n        <quote-create-package-block\n            [packagesLength]=\"packages.length\"\n            [package]=\"package\"\n            [productsName]=\"packagesNames\"\n            [isFixed]=\"false\"\n            [index]=\"packageIndex\"\n            [currencySymbol]=\"currencyAndTax.currency.symbol\"\n            [taxPercentage]=\"currencyAndTax.percentage\"\n            (checkRecommended)=\"setRecommended($event)\"\n            (changeProduct)=\"setNewProduct($event)\"\n            (deletePackage)=\"removePackage($event)\">\n        </quote-create-package-block>\n      </div>\n    </div>\n    <button type=\"button\" (click)=\"addNewPackage()\"  class=\"btn btn-info btn-add-new-sm\">Add Package</button>\n  </div>\n  <div *ngIf=\"quoteType === 'custom' && packagesNames\">\n    <h2 class=\"quote-section-name\">Add Products</h2>\n    <p>Create a list of add-on products which your client can add to the selected package. Multiple products can be added.</p>\n    <div dragula=\"products\" class=\"package-container mb-10\" [(dragulaModel)]=\"addons\">\n      <div *ngFor=\"let addon of addons; let addonIndex = index\" [class.last-package-item]=\"addonIndex === addons.length - 1\" class=\"dnd-package mb-20\">\n        <div class=\"dnd-icon-products handle-package\"></div>\n        <quote-create-package-block\n                [packagesLength]=\"addons.length\"\n                [product]=\"addon\"\n                [productsName]=\"addonsNames\"\n                [isFixed]=\"false\"\n                [index]=\"addonIndex\"\n                [currencySymbol]=\"currencyAndTax.currency.symbol\"\n                [taxPercentage]=\"currencyAndTax.percentage\"\n                (checkRecommended)=\"setRecommended($event)\"\n                (changeProduct)=\"setNewProduct($event)\"\n                (deletePackage)=\"removePackage($event)\">\n        </quote-create-package-block>\n      </div>\n    </div>\n    <button type=\"button\" (click)=\"addNewAddon()\" class=\"btn btn-info btn-add-new-sm\">Add Product</button>\n  </div>\n\n    <div class=\"product-container\">\n        <div class=\"row products-header mt-10\" *ngIf=\"quoteType === 'fixed'\">\n            <div class=\"col-xs-2\">Product / Package</div>\n            <div class=\"col-xs-4\">Description</div>\n            <div class=\"col-xs-6 products-inputs\">\n                <div>Price</div>\n                <div>Quantity</div>\n                <div>Discount (%)</div>\n                <div class=\"products-tax\">Tax</div>\n                <div class=\"product__amount\">Amount</div></div>\n        </div>\n        <div *ngIf=\"quoteType === 'fixed' && packagesNames\" [(dragulaModel)]=\"products\" class=\"product-body\" dragula=\"products\">\n            <div *ngFor=\"let product of products; let productIndex = index\" [class.last-package-item]=\"productIndex === products.length - 1\" class=\"dnd-package mb-20\">\n                <div class=\"dnd-icon-products handle-package\"></div>\n                <quote-create-package-block\n                        [product]=\"product\"\n                        [productsName]=\"productsNames\"\n                        [isFixed]=\"true\"\n                        [index]=\"productIndex\"\n                        [currencySymbol]=\"currencyAndTax.currency.symbol\"\n                        [taxPercentage]=\"currencyAndTax.percentage\"\n                        (changeProduct)=\"setNewFixedQuoteProduct($event)\"\n                        (deletePackage)=\"removeFixedQuoteProduct($event)\"></quote-create-package-block>\n            </div>\n        </div>\n    </div>\n\n\n    <div *ngIf=\"quoteType === 'fixed'\" class=\"table-responsive\">\n        <table class=\"table vertical-top-table edit-payments-table fixed-quote-summary-table\">\n            <tbody>\n            <tr>\n                <td colspan=\"6\">\n                    <button type=\"button\" class=\"btn btn-info btn-add-new-sm\" (click)=\"addNewProduct()\">\n                        Add Product / Package\n                    </button>\n                </td>\n                <td colspan=\"2\">\n                <td colspan=\"4\">\n                    <quote-amount-info [summary]=\"quoteSummary\" [currencyAndTax]=\"currencyAndTax\"></quote-amount-info>\n                </td>\n            </tr>\n            </tbody>\n        </table>\n    </div>\n\n    <div class=\"discounts-container pb-20\" *ngIf=\"discountsNames\">\n        <h2 class=\"quote-section-name\">Add Discount</h2>\n        <p>Add a fixed discount to this quote.</p>\n        <div dragula=\"discounts\" class=\"discount-container mb-10\" [(dragulaModel)]=\"discounts\">\n            <div class=\"dnd-package mb-20\" *ngFor=\"let discount of discounts; let discountIndex = index\">\n                <div class=\"dnd-icon-products handle-package\"></div>\n                <discount-create-block\n                        [discount]=\"discount\"\n                        [index]=\"discountIndex\"\n                        [discountsNames]=\"discountsNames\"\n                        [currencySymbol]=\"currencyAndTax.currency.symbol\"\n                        [taxPercentage]=\"currencyAndTax.percentage\"\n                        (changeDiscount)=\"setNewProduct($event)\"\n                        (deleteDiscount)=\"removeDiscount($event)\"\n                ></discount-create-block>\n            </div>\n        </div>\n        <button type=\"button\" (click)=\"addNewDiscount()\" class=\"btn btn-info btn-add-new-sm\">Add Discount</button>\n\n    </div>\n\n  <div class=\"quote-notes-container\">\n    <h2 class=\"fs-20 mt-25\">Notes</h2>\n    <textarea type=\"text\"\n              class=\"form-control quote-notes\"\n              maxlength=\"5000\"\n              [(ngModel)]=\"quote.notes\"\n              placeholder=\"These are additional notes you wish to add to your quote.\"></textarea>\n  </div>\n\n  <payment-schedule #paymentScheduleComponent *ngIf=\"paymentScheduleNames && (!editQuote || quoteSummary)\"\n                    [paymentScheduleNames]=\"paymentScheduleNames\"\n                    [defaultPaymentScheduleNames]=\"defaultPaymentScheduleNames\"\n                    [paymentSchedule]=\"paymentSchedule\"\n                    [payments]=\"payments\"\n                    [paymentScheduleTemplateId]=\"paymentScheduleTemplateId\"\n                    [paymentScheduleIdFromServer]=\"paymentScheduleIdFromServer\"\n                    [paymentsFromServer]=\"paymentsFromServer\"\n                    [issueDate]=\"issueDate\"\n                    [currencySymbol]=\"currencyAndTax?.currency?.symbol\"\n                    [job]=\"job\"\n                    [quoteTotal]=\"quoteSummary?.total\"\n                    [isFixed]=\"quoteType === 'fixed'\"\n                    [jobStartDate]=\"job.startDate\"\n                    [datePlaceHolder]=\"datePlaceHolder\"\n                    (paymentScheduleChange)=\"setPaymentScheduleId($event)\"></payment-schedule>\n\n    <div class=\"mb-30\">\n        <template-apply-list\n                              [templateList]=\"contractsTemplates\"\n                              [selectedTemplateId]=\"contractToSaveId\"\n                              [text]=\"'Do you want to add a contract?'\"\n                              [idField]=\"'templateId'\"\n                              (onTemplateChange)=\"setContract($event)\">\n            <button class=\"btn btn-sm btn-default\" [disabled]=\"buttonDisable || contractToSaveId === '-1' ||  isContractSigned()\"\n                    (click)=\"openEditSelectContract()\"><i class=\"fi fi-edit\"></i>Edit Contract\n            </button>\n        </template-apply-list>\n    </div>\n\n    <div class=\"mb-30\">\n        <template-apply-list [templateList]=\"questionnaireTemplates\"\n                             [selectedTemplateId]=\"questionnaireToSaveId\"\n                             [text]=\"'Do you want to add a questionnaire?'\"\n                             (onTemplateChange)=\"setQuestionnaire($event)\">\n        </template-apply-list>\n    </div>\n\n    <div *ngIf=\"generateInvoiceDisabled && quoteSummary?.total !== 0\" class=\"flex-box flex-align-center mb-35\">\n        <span class=\"quote-label-info-icon mr-10 label-icon-red\"></span>\n        <span class=\"quote-label-info\">This quote will not automatically generate an invoice after acceptance.</span>\n    </div>\n    <div class=\"flex-row mb-35\" *ngIf=\"!generateInvoiceDisabled || quoteSummary?.total === 0\">\n        <div class=\"checkbox-squared\">\n            <input id=\"checkbox-generate-invoice-for-pick-and-choice-quote\"\n                   type=\"checkbox\"\n                   name=\"mandatory\"\n                   [(ngModel)]=\"autoGenerateInvoice\"\n                   (ngModelChange)=\"changeAutoGenerateInvoice($event)\"\n            />\n            <label for=\"checkbox-generate-invoice-for-pick-and-choice-quote\"></label>\n        </div>\n        <label for=\"checkbox-generate-invoice-for-pick-and-choice-quote\">\n            Automatically generate an invoice once the quote is accepted\n        </label>\n    </div>\n\n  <button [disabled]=\"buttonDisable\" (click)=\"saveQuote()\"\n          spinning-wheel [is-spinning-wheel-active]=\"buttonDisable\"\n          class=\"btn btn-rounded btn-success btn-addon btn-lg mr-15\">Save Quote\n  </button>\n  <button type=\"button\" class=\"btn btn-rounded btn-info btn-lg mr-15\" *ngIf=\"quoteTemplatesAvailable && (!editQuote || (editQuote && quote.actions.SAVE_AS_TEMPLATE))\"\n          (click)=\"saveAsTemplate()\" [disabled]=\"buttonDisable\">Save As Quote Template\n  </button>\n  <button type=\"button\" (click)=\"back()\" [disabled]=\"buttonDisable\"\n          class=\"btn btn-rounded btn-default btn-addon btn-lg\">Cancel\n  </button>\n\n</section>\n"

/***/ }),

/***/ "./web/modern/components/quotes/quote-update/quote-update.scss":
/***/ (function(module, exports) {

module.exports = ":host #main-wrapper {\n  padding-bottom: 20px; }\n  :host #main-wrapper .quote-introduction {\n    padding: 10px;\n    line-height: 24px;\n    height: 70px;\n    resize: none; }\n  :host #main-wrapper .fixed-quote-summary-table {\n    border-bottom: 1px solid #dddddd; }\n    :host #main-wrapper .fixed-quote-summary-table td {\n      padding-top: 5px;\n      padding-bottom: 25px; }\n      :host #main-wrapper .fixed-quote-summary-table td:first-child {\n        padding-left: 0 !important; }\n"

/***/ }),

/***/ "./web/modern/components/quotes/quote-update/quote-update.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var common_1 = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
var ng2_dragula_1 = __webpack_require__("./node_modules/ng2-dragula/index.js");
var Observable_1 = __webpack_require__("./node_modules/rxjs/Observable.js");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var contracts_data_service_1 = __webpack_require__("./shared/services/contract/contracts.data.service.ts");
var templates_data_service_1 = __webpack_require__("./shared/services/data-services/templates-data-service/templates.data.service.ts");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var stringModifier_service_1 = __webpack_require__("./shared/services/helpers/string-modifier-service/stringModifier.service.ts");
var time_service_1 = __webpack_require__("./shared/services/helpers/time-service/time.service.ts");
var jobs_data_service_1 = __webpack_require__("./shared/services/job/jobs.data.service.ts");
var leads_data_service_1 = __webpack_require__("./shared/services/lead/leads.data.service.ts");
var payments_schedules_data_service_1 = __webpack_require__("./shared/services/payments/payments-schedules-data-service/payments-schedules.data.service.ts");
var questionnaires_data_service_1 = __webpack_require__("./shared/services/questionnarie/questionnaires.data.service.ts");
var quotes_data_service_1 = __webpack_require__("./shared/services/quote/quotes-data-service/quotes.data.service.ts");
var product_packages_data_service_1 = __webpack_require__("./shared/services/settings/product-packages.data.service.ts");
var settings_1 = __webpack_require__("./shared/services/settings/settings.ts");
var quote_update_service_1 = __webpack_require__("./shared/services/quote/quote-update.service.ts");
var payment_schedule_1 = __webpack_require__("./web/modern/components/quotes/common/payment-schedule/payment-schedule.ts");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var validation_service_1 = __webpack_require__("./shared/services/helpers/validation.service.ts");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var save_as_template_modal_component_1 = __webpack_require__("./web/modern/components/quotes/modals/save-as-template-modal/save-as-template-modal.component.ts");
var save_new_template_modal_component_1 = __webpack_require__("./web/modern/components/quotes/modals/save-new-template-modal/save-new-template-modal.component.ts");
var deep_object_diff_1 = __webpack_require__("./node_modules/deep-object-diff/dist/index.js");
var edit_contract_modal_component_1 = __webpack_require__("./web/modern/components/contract/edit-contract-modal/edit-contract-modal.component.ts");
var confirm_general_modal_component_1 = __webpack_require__("./web/modern/components/common/confirm-general-modal/confirm-general-modal.component.ts");
var quote_invoice_templates_data_service_1 = __webpack_require__("./shared/services/quote-invoice-templates/quote-invoice-templates.data.service.ts");
var quote_invoice_templates_service_1 = __webpack_require__("./shared/services/quote-invoice-templates/quote-invoice-templates.service.ts");
var QuoteUpdateComponent = function () {
    function QuoteUpdateComponent(dragulaService, stringModifierService, quoteDataService, messageService, timeService, templatesDataService, questionnairesDataService, productPackagesDataService, contractDataService, quoteUpdateService, paymentsSchedulesDataService, jobDataService, leadDataService, settingsService, location, quotesDataService, validationService, modalService, qtTemplatesDataService, qtTemplatesService, contractsDataService) {
        _classCallCheck(this, QuoteUpdateComponent);

        this.dragulaService = dragulaService;
        this.stringModifierService = stringModifierService;
        this.quoteDataService = quoteDataService;
        this.messageService = messageService;
        this.timeService = timeService;
        this.templatesDataService = templatesDataService;
        this.questionnairesDataService = questionnairesDataService;
        this.productPackagesDataService = productPackagesDataService;
        this.contractDataService = contractDataService;
        this.quoteUpdateService = quoteUpdateService;
        this.paymentsSchedulesDataService = paymentsSchedulesDataService;
        this.jobDataService = jobDataService;
        this.leadDataService = leadDataService;
        this.settingsService = settingsService;
        this.location = location;
        this.quotesDataService = quotesDataService;
        this.validationService = validationService;
        this.modalService = modalService;
        this.qtTemplatesDataService = qtTemplatesDataService;
        this.qtTemplatesService = qtTemplatesService;
        this.contractsDataService = contractsDataService;
        this.buttonDisable = false;
        this.datePlaceHolder = '';
        this.autoGenerateInvoice = true;
        this.packages = [];
        this.addons = [];
        this.discounts = [];
        this.paymentScheduleTemplateId = 0;
        this.questionnaireToSaveId = '-1';
        this.questionnaireTemplates = [];
        this.contractToSaveId = '-1';
        this.contractToSave = null;
        this.contractsTemplates = [];
        this.paymentsToSave = null;
        this.paymentsFromServer = [];
        this.products = [];
        this.productsNames = [];
        this.payments = [];
        this.quoteTemplates = [];
        this.issueDate = null;
        this.editQuote = false;
        this.initialDataAsTemplate = null;
        this.selectedQuoteTemplateId = '-1';
        this.currencyFlag = false;
        this.contractFlag = false;
        this.generateInvoiceDisabled = false;
        this.unsubscribe = new Subject_1.Subject();
        this.dragulaPackagesOptions = {
            moves: function moves(el, container, handle) {
                return handle.classList.contains('handle-package');
            }
        };
        this.dragulaProductsOptions = {
            moves: function moves(el, container, handle) {
                return handle.classList.contains('handle-package');
            }
        };
        this.dragulaDiscountsOptions = {
            moves: function moves(el, container, handle) {
                return handle.classList.contains('handle-package');
            }
        };
    }

    _createClass(QuoteUpdateComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.now = this.quoteUpdateService.getNow();
            if (this.quoteId && this.isJob) {
                this.getQuoteSourceData();
                this.editQuote = true;
            } else if (this.quoteId && !this.isJob) {
                this.getJobId(true);
                this.editQuote = true;
            } else if (!this.quoteId && this.isJob) {
                this.showNewQuote();
            } else {
                this.getJobId(false);
            }
            this.getProductsTemplates();
            this.getBootstrapSettings();
            this.setDragulaOptions();
        }
    }, {
        key: "ngAfterViewInit",
        value: function ngAfterViewInit() {
            this.registerUpdateProductSubscription();
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.clear();
        }
        // PRODUCT AND PACKAGES SECTION

    }, {
        key: "addNewPackage",
        value: function addNewPackage() {
            var productToAdd = JSON.parse(JSON.stringify(quote_update_service_1.QuoteUpdateService.setEmptyProduct('PACKAGE')));
            this.packages.push(productToAdd);
        }
    }, {
        key: "addNewAddon",
        value: function addNewAddon() {
            var productToAdd = JSON.parse(JSON.stringify(quote_update_service_1.QuoteUpdateService.setEmptyProduct('ADD_ON')));
            this.addons.push(productToAdd);
        }
    }, {
        key: "addNewDiscount",
        value: function addNewDiscount() {
            var productToAdd = JSON.parse(JSON.stringify(quote_update_service_1.QuoteUpdateService.setEmptyProduct('GIFT')));
            this.discounts.push(productToAdd);
            this.updateQuoteSummary(true);
        }
    }, {
        key: "addNewProduct",
        value: function addNewProduct() {
            var productToAdd = JSON.parse(JSON.stringify(quote_update_service_1.QuoteUpdateService.setEmptyProduct('ADD_ON')));
            productToAdd.mandatory = true;
            this.products.push(productToAdd);
            this.updateQuoteSummary(true);
        }
    }, {
        key: "removePackage",
        value: function removePackage(itemToDelete) {
            if (itemToDelete.type === 'package') {
                this.packages.splice(itemToDelete.index, 1);
                if (this.packages.length === 1) {
                    this.packages[0].recommended = false;
                }
            } else if (itemToDelete.type === 'product') {
                this.addons.splice(itemToDelete.index, 1);
            }
        }
    }, {
        key: "removeDiscount",
        value: function removeDiscount(index) {
            this.discounts.splice(index, 1);
            this.updateQuoteSummary(true);
        }
    }, {
        key: "removeFixedQuoteProduct",
        value: function removeFixedQuoteProduct(itemToDelete) {
            this.products.splice(itemToDelete.index, 1);
            this.updateQuoteSummary(true);
        }
        // CHANGE STATE SECTION

    }, {
        key: "setQuestionnaire",
        value: function setQuestionnaire(questionnaireId) {
            this.questionnaireToSaveId = questionnaireId;
        }
    }, {
        key: "setContract",
        value: function setContract(contractId) {
            this.contractTextSnapshot = null;
            this.contractToSaveId = contractId;
            this.getContractToEdit(contractId);
        }
    }, {
        key: "disableButtons",
        value: function disableButtons(isDisable) {
            this.buttonDisable = isDisable;
        }
    }, {
        key: "setRecommended",
        value: function setRecommended(index) {
            this.packages.forEach(function (packageItem, packageIndex) {
                if (packageIndex !== index) {
                    packageItem.recommended = false;
                }
            });
        }
    }, {
        key: "setPaymentScheduleId",
        value: function setPaymentScheduleId(payments) {
            this.paymentScheduleTemplateId = +payments.id;
            this.paymentsToSave = this.paymentScheduleTemplateId === -3 ? [] : payments.payments;
            this.generateInvoiceDisabled = +payments.id === -3;
        }
    }, {
        key: "setNewProduct",
        value: function setNewProduct(product) {
            var _this = this;

            if (product.type === 'package') {
                this.packages.forEach(function (packageItem, index) {
                    if (index === product.index) {
                        _this.packages[index] = JSON.parse(JSON.stringify(Object.assign({}, product.product)));
                    }
                });
            } else if (product.type === 'discount') {
                this.discounts.forEach(function (discount, index) {
                    if (index === product.index) {
                        _this.discounts[index] = JSON.parse(JSON.stringify(Object.assign({}, product.product)));
                    }
                });
            } else {
                this.addons.forEach(function (addon, index) {
                    if (index === product.index) {
                        _this.addons[index] = JSON.parse(JSON.stringify(Object.assign({}, product.product)));
                    }
                });
            }
        }
    }, {
        key: "setNewFixedQuoteProduct",
        value: function setNewFixedQuoteProduct(product) {
            var _this2 = this;

            this.products.forEach(function (packageItem, index) {
                if (index === product.index) {
                    _this2.products[index] = JSON.parse(JSON.stringify(Object.assign({}, product.product)));
                }
            });
        }
    }, {
        key: "updateFixedQuoteProductProperties",
        value: function updateFixedQuoteProductProperties(product) {
            var _this3 = this;

            this.products.forEach(function (packageItem, index) {
                if (index === product.index) {
                    _this3.products[index].price = product.product.price;
                    _this3.products[index].quantity = product.product.quantity;
                    _this3.products[index].discount = product.product.discount;
                    _this3.products[index].taxType = product.product.taxType;
                    _this3.products[index].amount = product.product.amount;
                }
            });
        }
    }, {
        key: "updateQuoteSummary",
        value: function updateQuoteSummary(needToUpdatePayments) {
            var _this4 = this;

            // setTimeout fixes issue on Safari when id of product changes with delay
            setTimeout(function () {
                var productsToCalculate = _this4.quoteType === 'custom' ? _this4.getProductsToSave(false) : _this4.getProductsToSaveFixedQuote(false);
                if (productsToCalculate && _this4.currencyAndTax) {
                    _this4.quotesDataService.calculateProductsSummary(productsToCalculate, _this4.currencyAndTax.percentage, _this4.currencyAndTax.currency.symbol).subscribe(function (data) {
                        return _this4.successUpdatePricesCalculation(data, needToUpdatePayments, productsToCalculate);
                    }, function (error) {
                        return _this4.messageService.showDefaultErrorMessage(error);
                    });
                }
            }, 0);
        }
    }, {
        key: "successUpdatePricesCalculation",
        value: function successUpdatePricesCalculation(data, needToUpdatePayments, productsToCalculate) {
            var _this5 = this;

            this.quoteSummary = data;
            this.quoteSummary.taxName = this.currencyAndTax.taxName;
            if (this.job && this.quote && this.paymentScheduleNames && needToUpdatePayments && productsToCalculate.length > 0) {
                this.paymentScheduleComponent.getPaymentScheduleNew(this.paymentScheduleTemplateId, true, this.quoteSummary.total);
            } else if (this.quoteType && this.quoteSummary && this.quoteSummary.total === 0) {
                setTimeout(function () {
                    _this5.paymentScheduleComponent.hideAndResetPaymentSchedule();
                }, 500);
            }
        }
    }, {
        key: "registerUpdateProductSubscription",
        value: function registerUpdateProductSubscription() {
            var _this6 = this;

            this.quoteUpdateService.updatedProductObservable.pipe(operators_1.takeUntil(this.unsubscribe), operators_1.filter(function (product) {
                return product !== null;
            })).subscribe(function (updatedProduct) {
                if (_this6.quoteType === 'fixed') {
                    _this6.updateFixedQuoteProductProperties(updatedProduct);
                } else {
                    _this6.formProducts();
                }
                if (_this6.quoteUpdateService.validateProductsPropsDefined(_this6.products)) {
                    _this6.updateQuoteSummary(true);
                }
            });
        }
    }, {
        key: "formProducts",
        value: function formProducts() {
            var _this7 = this;

            this.products = [];
            this.packages.forEach(function (packageItem) {
                _this7.products.push(packageItem);
            });
            this.addons.forEach(function (addon) {
                _this7.products.push(addon);
            });
            this.discounts.forEach(function (discount) {
                _this7.products.push(discount);
            });
        }
        // SAVE QUOTE SECTION

    }, {
        key: "saveQuote",
        value: function saveQuote() {
            this.buttonDisable = true;
            if (!this.validateQuote()) {
                this.buttonDisable = false;
                return;
            }
            var data = this.gatherDataToSaveQuote();
            if (this.editQuote) {
                this.updateQuote(data);
            } else {
                this.createQuote(data);
            }
        }
    }, {
        key: "confirmApplyQuoteTemplate",
        value: function confirmApplyQuoteTemplate(templateId) {
            var _this8 = this;

            if (this.isTemplateDataDiff()) {
                this.confirmTemplateChange().then(function () {
                    return _this8.applyQuoteTemplate(templateId);
                }).catch(function () {
                    _this8.quoteTemplateSelect.nativeElement.value = _this8.selectedQuoteTemplateId;
                });
            } else {
                this.applyQuoteTemplate(templateId);
            }
        }
    }, {
        key: "applyQuoteTemplate",
        value: function applyQuoteTemplate(templateId) {
            var _this9 = this;

            this.selectedQuoteTemplateId = templateId;
            if (templateId === '-1') {
                this.resetTemplateData();
                return;
            }
            this.loadingTemplate = true;
            this.qtTemplatesDataService.loadQtTemplate(templateId, 'QUOTE').pipe(operators_1.takeUntil(this.unsubscribe), operators_1.finalize(function () {
                return _this9.loadingTemplate = false;
            })).subscribe(function (_ref) {
                var data = _ref.data;
                return _this9.applyQuoteTemplateData(data);
            }, function (error) {
                _this9.selectedQuoteTemplateId = '-1';
                _this9.messageService.handleError(error);
            });
        }
    }, {
        key: "applyQuoteTemplateData",
        value: function applyQuoteTemplateData(data) {
            this.selectedQuoteTemplate = JSON.parse(JSON.stringify(data));
            this.modifyContractBodyForDiff(data.contractTemplate);
            this.modifyProductsForDiff(data.products);
            this.selectedQuoteTemplate.notes = this.selectedQuoteTemplate.notes || '';
            this.setPackagesAndAddons(data.products);
            this.quote.introduction = data.introduction;
            this.quote.notes = data.notes || '';
            this.autoGenerateInvoice = data.generateInvoiceWhenAccepted;
            this.getTemplatePayments(data);
            if (data.payments) {
                this.payments = data.payments;
            } else {
                this.payments = [];
            }
            this.contractToSaveId = data.contractTemplate ? data.contractTemplate.id.toString() : '-1';
            this.questionnaireToSaveId = data.questionnaireTemplate ? data.questionnaireTemplate.id.toString() : '-1';
            this.getContractToEdit(this.contractToSaveId);
            this.updateQuoteSummary(true);
        }
    }, {
        key: "getTemplatePayments",
        value: function getTemplatePayments(data) {
            var rule = data.paymentsRule;
            if (rule) {
                switch (rule.strategy) {
                    case 'NO_SPLIT_PAYMENTS':
                        this.paymentScheduleTemplateId = -2;
                        break;
                    case 'NO_DUE_DATE':
                        this.paymentScheduleTemplateId = -3;
                        break;
                    case 'BY_PAYMENT_SCHEDULER':
                        var paymentScdl = rule.paymentSchedule;
                        if (paymentScdl) {
                            var check = this.paymentScheduleNames.some(function (el) {
                                return el.id === paymentScdl.id;
                            });
                            if (!check) {
                                this.paymentScheduleNames.push(Object.assign({}, paymentScdl));
                            }
                            this.paymentScheduleTemplateId = paymentScdl.id.toString();
                        }
                        break;
                    default:
                        this.paymentScheduleTemplateId = -2;
                }
            } else {
                if (data.paymentSchedule) {
                    var _check = this.paymentScheduleNames.some(function (el) {
                        return el.id === data.paymentSchedule.id;
                    });
                    if (!_check) {
                        this.paymentScheduleNames.push(Object.assign({}, data.paymentSchedule));
                    }
                }
                this.paymentScheduleTemplateId = data.paymentSchedule ? data.paymentSchedule.id.toString() : -1;
            }
        }
    }, {
        key: "resetTemplateData",
        value: function resetTemplateData() {
            var type = this.quoteType === 'fixed' ? 'FIXED' : 'CHOOSE_AND_PICK';
            var emptyTemplateData = null;
            if (this.editQuote) {
                emptyTemplateData = JSON.parse(JSON.stringify(this.initialDataAsTemplate));
            } else {
                this.selectedPaymentSchedule = null;
                var desiredEmptyProduct = this.quoteType === 'fixed' ? quote_update_service_1.QuoteUpdateService.setEmptyProduct('ADD_ON') : quote_update_service_1.QuoteUpdateService.setEmptyProduct('PACKAGE');
                desiredEmptyProduct.mandatory = true;
                emptyTemplateData = quote_invoice_templates_service_1.QuoteInvoiceTemplatesService.getEmptyQtItem(type, desiredEmptyProduct, this.quoteType === 'fixed' ? this.defaultIntroductions.fixedIntroduction : this.defaultIntroductions.chooseAndPickIntroduction);
            }
            this.applyQuoteTemplateData(emptyTemplateData);
        }
    }, {
        key: "isTemplateDataDiff",
        value: function isTemplateDataDiff() {
            var dataDiff = deep_object_diff_1.diff(this.qtTemplatesService.prepareQuoteInvoiceDataForDiff(this.selectedQuoteTemplate), this.qtTemplatesService.prepareQuoteInvoiceDataForDiff(this.gatherQtDataForDiff()));
            return !!Object.keys(dataDiff).length;
        }
    }, {
        key: "gatherQtDataForDiff",
        value: function gatherQtDataForDiff() {
            var paymentSchedule = this.paymentScheduleTemplateId === -1 || this.paymentScheduleTemplateId === -2 || this.paymentScheduleTemplateId === -3 ? null : this.qtTemplatesService.findTemplateItemById(this.paymentScheduleNames, this.paymentScheduleTemplateId);
            var questionnaireTemplate = this.questionnaireToSaveId === '-1' ? null : this.qtTemplatesService.findTemplateItemById(this.questionnaireTemplates, this.questionnaireToSaveId);
            return Object.assign({}, this.selectedQuoteTemplate, { products: this.quoteType === 'fixed' ? this.qtTemplatesService.prepareProductsForDiff([].concat(_toConsumableArray(this.products), _toConsumableArray(this.discounts))) : this.qtTemplatesService.prepareProductsForDiff([].concat(_toConsumableArray(this.packages), _toConsumableArray(this.addons), _toConsumableArray(this.discounts))), introduction: this.quote.introduction, notes: this.quote.notes, generateInvoiceWhenAccepted: this.autoGenerateInvoice, contractTemplate: this.contractToSave ? {
                    id: this.contractToSave.id,
                    text: this.contractToSave.text
                } : null, paymentSchedule: paymentSchedule,
                questionnaireTemplate: questionnaireTemplate });
        }
    }, {
        key: "modifyContractBodyForDiff",
        value: function modifyContractBodyForDiff(contract) {
            if (contract) {
                this.selectedQuoteTemplate.contractTemplate = {
                    id: contract.id,
                    text: contract.text
                };
            }
        }
    }, {
        key: "modifyProductsForDiff",
        value: function modifyProductsForDiff(products) {
            if (products.length) {
                this.selectedQuoteTemplate.products = this.qtTemplatesService.prepareProductsForDiff(products);
            }
        }
    }, {
        key: "confirmTemplateChange",
        value: function confirmTemplateChange() {
            var _this10 = this;

            return new Promise(function (resolve, reject) {
                var modal = _this10.modalService.openModal(confirm_general_modal_component_1.ConfirmGeneralModalComponent);
                modal.componentInstance.text = 'This quote has unsaved changes. Are you sure you want to replace it with a template? Some data may be lost.';
                modal.componentInstance.buttons = [{
                    text: 'Yes',
                    color: 'success',
                    size: 'lg',
                    action: 'APPLY_TEMPLATE'
                }, {
                    text: 'No',
                    color: 'default',
                    size: 'lg',
                    action: 'CANCEL'
                }];
                modal.result.then(function (action) {
                    if (action === 'APPLY_TEMPLATE') {
                        resolve();
                    }
                    if (action === 'CANCEL') {
                        reject();
                    }
                });
            });
        }
    }, {
        key: "saveAsTemplate",
        value: function saveAsTemplate() {
            var _this11 = this;

            var payload = this.validateAndGatherTemplate('Test Name');
            if (payload) {
                if (!this.validateContractEditing()) {
                    return;
                }
                var modal = this.modalService.openModal(save_as_template_modal_component_1.SaveAsTemplateModalComponent, {
                    windowClass: 'ng-bootstrap-modal'
                });
                modal.componentInstance.templateList = this.quoteTemplates;
                modal.componentInstance.templateTypeName = this.quoteType === 'custom' ? 'Pick & Choose Quote' : 'Fixed Quote';
                modal.componentInstance.templateNameTitle = 'Quote';
                modal.componentInstance.breadcrumbsText = 'Quote Templates will be saved in Settings > Quote & Invoice Templates';
                var modalSubscription$ = this.modalService.modalData.subscribe(function (data) {
                    var closeModal = function closeModal() {
                        _this11.modalService.closeModalByRef(modal, modalSubscription$);
                    };
                    _this11.handleSaveAsTemplateResponse(data, modal, payload, closeModal.bind(_this11));
                });
            }
        }
    }, {
        key: "saveNewTemplate",
        value: function saveNewTemplate(payload) {
            var _this12 = this;

            var modal = this.modalService.openModal(save_new_template_modal_component_1.SaveNewTemplateModalComponent, {
                windowClass: 'ng-bootstrap-modal'
            });
            modal.componentInstance.templateTypeName = this.quoteType === 'custom' ? 'Pick & Choose Quote' : 'Fixed Quote';
            modal.componentInstance.templateNameTitle = 'Quote';
            modal.componentInstance.breadcrumbsText = 'Quote Templates will be saved in Settings > Quote & Invoice Templates';
            modal.componentInstance.templateNameProp = this.selectedQuoteTemplate.name;
            var modalSubscription$ = this.modalService.modalData.subscribe(function (data) {
                var closeModal = function closeModal() {
                    _this12.modalService.closeModalByRef(modal, modalSubscription$);
                };
                _this12.handleSaveNewTemplateResponse(data, modal, payload, closeModal.bind(_this12));
            });
        }
    }, {
        key: "handleSaveNewTemplateResponse",
        value: function handleSaveNewTemplateResponse(data, modalRef, payload, closeModal) {
            var _this13 = this;

            if (data.action === 'CLOSE') {
                this.saveAsTemplate();
                closeModal();
            }
            if (data.action === 'SAVE') {
                if (!data.props) {
                    if (!data.props || data.props && !data.props.trim()) {
                        this.messageService.showToaster('e_4', 'quoteInvoiceTemplates', 'quote');
                        return null;
                    }
                }
                var dataToSave = JSON.parse(JSON.stringify(payload));
                dataToSave.data.name = data.props;
                modalRef.componentInstance.btnDisable = true;
                this.qtTemplatesDataService.saveTemplate(this.quoteType === 'fixed' ? 'QUOTE' : 'CUSTOM_QUOTE', dataToSave).pipe(operators_1.takeUntil(this.unsubscribe), operators_1.finalize(function () {
                    return modalRef.componentInstance.btnDisable = false;
                })).subscribe(function (_ref2) {
                    var data = _ref2.data;

                    closeModal();
                    _this13.loadQuoteTemplates();
                    _this13.selectedQuoteTemplateId = data.id;
                    _this13.selectedQuoteTemplate.name = data.name;
                    _this13.messageService.showToaster('s_7', 'quoteInvoiceTemplates', data.name);
                    localStorage.setItem('keyToScroll', _this13.quoteType === 'fixed' ? 'fixed' : 'pick_and_choose');
                    window.open(location.origin + "/settings/quote_invoice_templates");
                }, function (error) {
                    return _this13.messageService.handleError(error);
                });
            }
        }
    }, {
        key: "handleSaveAsTemplateResponse",
        value: function handleSaveAsTemplateResponse(data, modalRef, payload, closeModal) {
            var _this14 = this;

            if (data.action === 'CLOSE') {
                closeModal();
            }
            if (data.action === 'SAVE') {
                closeModal();
                this.saveNewTemplate(payload);
            }
            if (data.action === 'OVERWRITE') {
                if (!data.props) {
                    this.messageService.showToaster('e_2', 'quoteInvoiceTemplates');
                    return;
                }
                var dataToSave = JSON.parse(JSON.stringify(payload));
                dataToSave.data.name = data.props.name;
                modalRef.componentInstance.btnDisable = true;
                this.qtTemplatesDataService.editTemplate(this.quoteType === 'fixed' ? 'QUOTE' : 'CUSTOM_QUOTE', data.props.id.toString(), dataToSave).pipe(operators_1.takeUntil(this.unsubscribe), operators_1.finalize(function () {
                    return modalRef.componentInstance.btnDisable = false;
                })).subscribe(function (_ref3) {
                    var data = _ref3.data;

                    _this14.messageService.showToaster('s_1', 'quoteInvoiceTemplates', 'quote');
                    _this14.selectedQuoteTemplateId = data.id;
                    closeModal();
                }, function (error) {
                    return _this14.messageService.handleError(error);
                });
            }
        }
    }, {
        key: "validateContractEditing",
        value: function validateContractEditing() {
            if (this.contractTextSnapshot && this.validationService.trimHTML(this.contractTextSnapshot) !== this.validationService.trimHTML(this.contractToSave.text)) {
                this.confirmEditingContract(this.contractToSave);
                return false;
            }
            return true;
        }
    }, {
        key: "confirmEditingContract",
        value: function confirmEditingContract(contract) {
            var _this15 = this;

            if (contract) {
                var modal = this.modalService.openModal(save_as_template_modal_component_1.SaveAsTemplateModalComponent, {
                    windowClass: 'ng-bootstrap-modal'
                });
                modal.componentInstance.templateList = this.contractsTemplates;
                modal.componentInstance.templateTypeName = 'Contract';
                modal.componentInstance.templateNameTitle = 'Contract';
                modal.componentInstance.breadcrumbsText = 'Contract Templates will be saved in Settings > Contract Templates';
                modal.componentInstance.detailedDescription = 'Your contract has been edited and will need to be saved as a Contract Template.';
                var modalSubscription$ = this.modalService.modalData.subscribe(function (res) {
                    if (res.action === 'CLOSE') {
                        _this15.modalService.closeModalByRef(modal, modalSubscription$);
                    }
                    if (res.action === 'SAVE') {
                        _this15.modalService.closeModalByRef(modal, modalSubscription$);
                        _this15.saveNewContractTemplate(contract);
                    }
                    if (res.action === 'OVERWRITE') {
                        if (!res.props) {
                            _this15.messageService.showToaster('e_2', 'quoteInvoiceTemplates');
                            return;
                        }
                        modal.componentInstance.btnDisable = true;
                        var newContract = Object.assign({}, res.props, { text: _this15.contractToSave.text });
                        _this15.contractsDataService.overwriteContractTemplate(res.props.templateId.toString(), newContract).pipe(operators_1.takeUntil(_this15.unsubscribe), operators_1.finalize(function () {
                            return modal.componentInstance.btnDisable = false;
                        })).subscribe(function (_ref4) {
                            var data = _ref4.data;

                            _this15.messageService.showToaster('s_2', 'contractTemplates', contract.name);
                            _this15.contractToSaveId = data.id.toString();
                            _this15.contractToSave = data;
                            _this15.modalService.closeModalByRef(modal, modalSubscription$);
                            _this15.contractTextSnapshot = null;
                            _this15.saveAsTemplate();
                        }, function (error) {
                            return _this15.messageService.handleError(error);
                        });
                    }
                });
            }
        }
    }, {
        key: "saveNewContractTemplate",
        value: function saveNewContractTemplate(contract) {
            var _this16 = this;

            var modal = this.modalService.openModal(save_new_template_modal_component_1.SaveNewTemplateModalComponent, {
                windowClass: 'ng-bootstrap-modal'
            });
            modal.componentInstance.templateTypeName = 'Contract';
            modal.componentInstance.templateNameTitle = 'Contract';
            modal.componentInstance.breadcrumbsText = 'Contract Templates will be saved in Settings > Contract Templates';
            modal.componentInstance.templateNameProp = contract.name;
            var modalSubscription$ = this.modalService.modalData.subscribe(function (res) {
                if (res.action === 'CLOSE') {
                    _this16.confirmEditingContract(contract);
                    _this16.modalService.closeModalByRef(modal, modalSubscription$);
                }
                if (res.action === 'SAVE') {
                    if (!res.props || res.props && !res.props.trim()) {
                        _this16.messageService.showToaster('e_3', 'quoteInvoiceTemplates');
                        return;
                    }
                    var newContract = JSON.parse(JSON.stringify(contract));
                    newContract.name = res.props;
                    modal.componentInstance.btnDisable = true;
                    _this16.contractsDataService.saveNewContractTemplate(newContract).pipe(operators_1.takeUntil(_this16.unsubscribe), operators_1.finalize(function () {
                        return modal.componentInstance.btnDisable = false;
                    })).subscribe(function (_ref5) {
                        var data = _ref5.data;

                        _this16.modalService.closeModalByRef(modal, modalSubscription$);
                        _this16.messageService.showToaster('s_5', 'quoteInvoiceTemplates', newContract.name);
                        _this16.contractTextSnapshot = null;
                        Observable_1.Observable.zip(_this16.templatesDataService.getTemplates('contract_preview'), _this16.getInitialContract()).subscribe(function (_ref6) {
                            var _ref7 = _slicedToArray(_ref6, 2),
                                contractTemplates = _ref7[0],
                                contractData = _ref7[1];

                            var contract = contractData ? contractData.contract : null;
                            _this16.contractsTemplates = contractTemplates.contractTemplates;
                            if (data) {
                                _this16.setContractSources(data);
                            } else if (contract) {
                                _this16.qtTemplatesService.addSelectedTemplate(_this16.contractsTemplates, Object.assign({}, contract, { templateId: contract.id }));
                                _this16.linkedContract = contract;
                                _this16.setContractSources(contract);
                            }
                            _this16.saveAsTemplate();
                        });
                    }, function (error) {
                        return _this16.messageService.handleError(error);
                    });
                }
            });
        }
    }, {
        key: "validateAndGatherTemplate",
        value: function validateAndGatherTemplate(templateName) {
            var gatheredProducts = this.quoteType === 'fixed' ? [].concat(_toConsumableArray(this.products), _toConsumableArray(this.discounts)) : [].concat(_toConsumableArray(this.packages), _toConsumableArray(this.addons), _toConsumableArray(this.discounts));
            var paymentScheduleTemplateId = this.paymentScheduleTemplateId !== 0 ? this.paymentScheduleTemplateId : this.paymentScheduleIdFromServer;
            var data = {
                contractTemplateId: this.contractToSave ? this.contractToSave.id.toString() : null,
                questionnaireTemplateId: this.questionnaireToSaveId ? this.questionnaireToSaveId.toString() : null,
                paymentSchedulerTemplateId: paymentScheduleTemplateId ? paymentScheduleTemplateId.toString() : null,
                data: {
                    products: this.qtTemplatesService.mapLineItems(gatheredProducts),
                    name: templateName,
                    notes: this.quote.notes,
                    introduction: this.quote.introduction,
                    generateInvoiceWhenAccepted: this.autoGenerateInvoice
                }
            };
            if (!this.qtTemplatesService.validateSelectedTemplates(data, this.contractsTemplates, this.questionnaireTemplates, 'QUOTE')) {
                return null;
            }
            if (!this.qtTemplatesService.validateQuoteTemplate(data)) {
                return null;
            }
            return this.qtTemplatesService.prepareTemplateForSave(data);
        }
    }, {
        key: "assignInitialDataAsTemplate",
        value: function assignInitialDataAsTemplate(quote, contract) {
            this.initialDataAsTemplate = this.qtTemplatesService.createTemplateDataFromQuote(quote, contract, this.quoteType === 'fixed' ? 'FIXED' : 'CHOOSE_AND_PICK');
            this.selectedQuoteTemplate = JSON.parse(JSON.stringify(this.initialDataAsTemplate));
            this.modifyContractBodyForDiff(contract);
            this.modifyProductsForDiff(this.editQuote ? quote.products : [].concat(_toConsumableArray(this.packages), _toConsumableArray(this.products)));
        }
    }, {
        key: "validateQuote",
        value: function validateQuote() {
            var _this17 = this;

            var products = this.quoteType === 'custom' ? this.getProductsToSave(false) : this.getProductsToSaveFixedQuote(false);
            var invalidProductType = void 0;
            if (products.find(function (product) {
                return product.type === 'GIFT' && !product.mandatory;
            }) !== undefined) {
                this.messageService.showToaster('e_6', 'editQuote');
                return false;
            }
            if (products.find(function (product) {
                return product.type === 'GIFT' && parseInt(product.quantity) !== 1;
            }) !== undefined) {
                this.messageService.showToaster('e_10', 'editQuote');
                return false;
            }
            if (products.find(function (product) {
                return product.type === 'GIFT' && product.price >= 0;
            }) !== undefined) {
                this.messageService.showToaster('e_16', 'editQuote');
                return false;
            }
            if (products.find(function (product) {
                return product.type === 'GIFT';
            }) !== undefined && products.find(function (product) {
                return product.taxType !== products[0].taxType;
            }) !== undefined) {
                this.messageService.showToaster('e_13', 'editQuote');
                return false;
            }
            if (products.length === 0) {
                this.messageService.showToaster('e_4', 'editQuote');
                return false;
            }
            if (this.quote.ponumber !== null && !this.quote.ponumber.match('^[a-zA-Z0-9 *№\'ʼ;:%!?@#$&|>\\<{}()-`.+,/"]*$')) {
                this.messageService.showToaster('e_7', 'editQuote');
                return false;
            }
            if (products.find(function (product) {
                if (product.name === '') {
                    invalidProductType = product.type;
                    if (invalidProductType === 'GIFT') {
                        invalidProductType = 'discount';
                    } else if (invalidProductType === 'ADD_ON') {
                        invalidProductType = 'product';
                    }
                    return true;
                }
            })) {
                this.messageService.showToaster('e_0', 'productsPackages', invalidProductType.toLowerCase());
                return false;
            }
            if (products.find(function (product) {
                return product.quantity <= 0;
            }) !== undefined) {
                this.messageService.showToaster('e_8', 'editQuote');
                return false;
            }
            if (products.find(function (product) {
                var escapedProduct = product.description ? _this17.validationService.trimHTML(product.description).trim() : '';
                if (product.type !== 'GIFT' && (!product.description || product.description.length === 0 || !escapedProduct)) {
                    invalidProductType = product.type.toUpperCase() === 'PACKAGE' ? 'package' : 'product';
                    return true;
                }
            })) {
                this.messageService.showToaster('e_9', 'editQuote', invalidProductType);
                return false;
            }
            if (products.find(function (product) {
                if (product.name.trim().length === 0) {
                    if (product.type.toUpperCase() === 'GIFT') {
                        invalidProductType = 'Discount';
                    } else {
                        invalidProductType = product.type.toUpperCase() === 'PACKAGE' ? 'Package' : 'Product';
                    }
                    return true;
                }
            })) {
                this.messageService.showToaster('e_14', 'editQuote', invalidProductType);
                return false;
            }
            if (products.find(function (product) {
                return product.discount > 100;
            }) !== undefined) {
                this.messageService.showToaster('e_2', 'editQuote');
                return false;
            }
            if (this.paymentScheduleTemplateId === -1) {
                this.messageService.showToaster('e_18', 'editQuote');
                return false;
            }
            if (this.paymentsToSave.find(function (payment) {
                return !payment.date && !payment.paymentDateWithRule.ruleExplanationHTML;
            }) !== undefined) {
                this.messageService.showToaster('e_11', 'editQuote');
                return false;
            }
            var invalidCounter = document.querySelector('.counter.red');
            if (invalidCounter) {
                this.messageService.showToaster('e_6', 'productsPackages', '4000');
                return false;
            }
            return true;
        }
    }, {
        key: "getBootstrapSettings",
        value: function getBootstrapSettings() {
            var _this18 = this;

            this.settingsService.timeFormatSettings.pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (data) {
                _this18.setCorrectDateFormat(data.dateFormat);
                _this18.quoteTemplatesAvailable = data.qtTemplatesAvailable;
            });
        }
    }, {
        key: "setCorrectDateFormat",
        value: function setCorrectDateFormat(format) {
            switch (format) {
                case 'DD_MM_YYYY':
                    this.datePlaceHolder = 'dd/mm/yyyy';
                    break;
                case 'MM_DD_YYYY':
                    this.datePlaceHolder = 'mm/dd/yyyy';
                    break;
                default:
                    this.datePlaceHolder = '';
                    break;
            }
        }
    }, {
        key: "getJobId",
        value: function getJobId(makeQuoteRequest) {
            var _this19 = this;

            this.leadId = this.idToGetQuote;
            this.quoteDataService.getJobId(this.idToGetQuote).subscribe(function (data) {
                _this19.idToGetQuote = data;
                if (makeQuoteRequest) {
                    _this19.getQuoteSourceData();
                } else {
                    _this19.showNewQuote();
                }
            }, function (error) {
                return _this19.messageService.showDefaultErrorMessage(error);
            });
        }
        // DRAG'N'DROP SECTION

    }, {
        key: "setDragulaOptions",
        value: function setDragulaOptions() {
            this.dragulaService.setOptions('products', this.dragulaProductsOptions);
            this.dragulaService.setOptions('packages', this.dragulaPackagesOptions);
            this.dragulaService.setOptions('discounts', this.dragulaDiscountsOptions);
        }
    }, {
        key: "clear",
        value: function clear() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
            this.quoteUpdateService.setNextUpdateProduct(null, null);
            this.dragulaService.destroy('products');
            this.dragulaService.destroy('packages');
            this.dragulaService.destroy('discounts');
        }
        // GET QUOTE DATA SECTION

    }, {
        key: "getQuoteSourceData",
        value: function getQuoteSourceData() {
            var _this20 = this;

            this.quoteDataService.getQuoteToEditV1(this.idToGetQuote, this.quoteId).subscribe(function (data) {
                _this20.successGetQuoteData(data);
                _this20.getPaymentsSchedules();
            }, function (error) {
                return _this20.messageService.showDefaultErrorMessage(error);
            });
        }
    }, {
        key: "changeAutoGenerateInvoice",
        value: function changeAutoGenerateInvoice(val) {
            this.autoGenerateInvoice = val;
        }
    }, {
        key: "setPackagesAndAddons",
        value: function setPackagesAndAddons(products) {
            var sortedProducts = quote_update_service_1.QuoteUpdateService.sortProducts(products);
            if (this.quoteType === 'custom') {
                var _quote_update_service = quote_update_service_1.QuoteUpdateService.setPackagesAndAddons(sortedProducts),
                    packages = _quote_update_service.packages,
                    addons = _quote_update_service.addons,
                    discounts = _quote_update_service.discounts;

                this.packages = packages;
                this.addons = addons;
                this.products = sortedProducts;
                this.discounts = discounts;
            } else {
                var _quote_update_service2 = quote_update_service_1.QuoteUpdateService.separateDiscountsAndProducts(sortedProducts),
                    _addons = _quote_update_service2.addons,
                    _discounts = _quote_update_service2.discounts;

                this.products = _addons;
                this.discounts = _discounts;
            }
        }
    }, {
        key: "setPackagesAndAddonsNames",
        value: function setPackagesAndAddonsNames(products) {
            var _quote_update_service3 = quote_update_service_1.QuoteUpdateService.setPackagesAndAddons(products),
                packages = _quote_update_service3.packages,
                addons = _quote_update_service3.addons,
                discounts = _quote_update_service3.discounts;

            this.packagesNames = packages;
            this.addonsNames = addons;
            this.discountsNames = discounts;
        }
    }, {
        key: "showNewQuote",
        value: function showNewQuote() {
            this.paymentScheduleTemplateId = -2;
            this.selectedPaymentSchedule = null;
            this.getQuoteIdAndDate(this.idToGetQuote);
            if (this.isJob) {
                this.getJobInfo();
            } else {
                this.getLeadInfo();
            }
            this.loadQuoteTemplates();
            this.getPaymentsSchedules();
        }
    }, {
        key: "getJobInfo",
        value: function getJobInfo() {
            var _this21 = this;

            this.jobDataService.getJobInfo(this.idToGetQuote).subscribe(function (data) {
                return _this21.job = data;
            }, function (error) {
                return _this21.messageService.showDefaultErrorMessage(error);
            });
        }
    }, {
        key: "getLeadInfo",
        value: function getLeadInfo() {
            var _this22 = this;

            this.leadDataService.getLeadInfo(this.leadId).subscribe(function (data) {
                return _this22.successGetLead(data);
            }, function (error) {
                var _error$error = error.error,
                    errorCode = _error$error.errorCode,
                    data = _error$error.data;

                if (errorCode === 701) {
                    _this22.redirectToJobLead(data);
                    return;
                }
                _this22.messageService.showDefaultErrorMessage(error);
            });
        }
    }, {
        key: "redirectToJobLead",
        value: function redirectToJobLead(data) {
            this.location.go("/" + data.redirectTo + "s/view/" + data.redirectId);
        }
    }, {
        key: "successGetLead",
        value: function successGetLead(data) {
            this.job = data.job;
        }
    }, {
        key: "getCurrencyAndTaxes",
        value: function getCurrencyAndTaxes() {
            var _this23 = this;

            this.settingsService.getCurrencyAndTaxes().subscribe(function (data) {
                _this23.successGetCurrencyAndTaxes(data);
            }, function (error) {
                return _this23.messageService.showDefaultErrorMessage(error);
            });
        }
    }, {
        key: "successGetCurrencyAndTaxes",
        value: function successGetCurrencyAndTaxes(data) {
            this.currencyAndTax = {
                currency: {
                    symbol: data.currencyDTO.symbol
                },
                percentage: data.percentage,
                taxName: data.taxName
            };
            this.currencyFlag = true;
        }
    }, {
        key: "getDefaultIntroduction",
        value: function getDefaultIntroduction() {
            var _this24 = this;

            this.qtTemplatesDataService.getQuoteIntroduction().pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (_ref8) {
                var data = _ref8.data;

                if (_this24.quoteType === 'fixed') {
                    _this24.quote.introduction = data.fixedIntroduction && data.fixedIntroduction.introduction || '';
                } else {
                    _this24.quote.introduction = data.chooseAndPickIntroduction && data.chooseAndPickIntroduction.introduction || '';
                }
                _this24.defaultIntroductions = {
                    fixedIntroduction: data.fixedIntroduction && data.fixedIntroduction.introduction || '',
                    chooseAndPickIntroduction: data.chooseAndPickIntroduction && data.chooseAndPickIntroduction.introduction || ''
                };
                // TODO temporary fix, need to refactor
                var interval = setInterval(function () {
                    if (_this24.selectedQuoteTemplate) {
                        _this24.selectedQuoteTemplate.introduction = _this24.quoteType === 'fixed' ? _this24.defaultIntroductions.fixedIntroduction : _this24.defaultIntroductions.chooseAndPickIntroduction;
                        clearInterval(interval);
                    }
                }, 200);
            }, function (error) {
                return _this24.messageService.showDefaultErrorMessage(error);
            });
        }
    }, {
        key: "setQuoteSources",
        value: function setQuoteSources(quote) {
            var contract = quote.contract,
                currencyAndTax = quote.currencyAndTax,
                paymentSchedule = quote.paymentSchedule,
                payments = quote.payments,
                questionnaire = quote.questionnaire,
                paymentsRule = quote.paymentsRule;

            this.currencyAndTax = currencyAndTax;
            if (paymentSchedule === null) {
                if (paymentsRule.strategy === 'NO_SPLIT_PAYMENTS') {
                    this.paymentScheduleTemplateId = -2;
                } else if (paymentsRule.strategy === 'NO_DUE_DATE') {
                    this.paymentScheduleTemplateId = -3;
                }
            } else {
                this.paymentScheduleIdFromServer = paymentSchedule.id;
            }
            this.payments = payments;
            this.paymentsFromServer = payments;
            this.paymentSchedule = paymentSchedule;
            if (contract !== null) {
                this.contract = contract;
            }
            if (questionnaire !== null) {
                this.questionnaireToSaveId = questionnaire.id;
                this.questionnaire = questionnaire;
            }
            this.getContractAndQuestionnaireInfo();
        }
    }, {
        key: "getContractAndQuestionnaireInfo",
        value: function getContractAndQuestionnaireInfo() {
            var _this25 = this;

            Observable_1.Observable.zip(this.templatesDataService.getTemplates('contract_preview'), this.templatesDataService.getTemplates('questionnaire_preview'), this.getInitialContract()).subscribe(function (_ref9) {
                var _ref10 = _slicedToArray(_ref9, 3),
                    contractTemplates = _ref10[0],
                    questionnaireTemplates = _ref10[1],
                    contractData = _ref10[2];

                var contract = contractData ? contractData.contract : null;
                _this25.contractsTemplates = contractTemplates.contractTemplates;
                _this25.questionnaireTemplates = questionnaireTemplates.questionnaireTemplates;
                _this25.qtTemplatesService.addSelectedTemplate(_this25.questionnaireTemplates, _this25.questionnaire);
                if (contract) {
                    _this25.qtTemplatesService.addSelectedTemplate(_this25.contractsTemplates, Object.assign({}, contract, { templateId: contract.id }));
                    _this25.linkedContract = contract;
                    _this25.setContractSources(contract);
                } else {
                    _this25.linkedContract = null;
                }
                _this25.contractFlag = true;
                _this25.assignInitialDataAsTemplate(_this25.quote, contract);
            }, function (error) {
                return _this25.messageService.showDefaultErrorMessage(error);
            });
        }
    }, {
        key: "setContractSources",
        value: function setContractSources(contract) {
            this.contractToSave = JSON.parse(JSON.stringify(contract));
            this.contractToSaveId = contract.id.toString();
        }
    }, {
        key: "getInitialContract",
        value: function getInitialContract() {
            if (this.contract) {
                this.currentContractId = this.contract.id;
                return this.contractDataService.getContract(this.job.id, this.contract.id);
            }
            return new Observable_1.Observable(function (observer) {
                observer.next(null);
            });
        }
    }, {
        key: "getContractToEdit",
        value: function getContractToEdit(contractId) {
            var _this26 = this;

            if (contractId === '-1') {
                this.contractToSave = null;
                return;
            }
            if (this.linkedContract && contractId === this.linkedContract.id.toString()) {
                this.contractToSave = JSON.parse(JSON.stringify(this.linkedContract));
                return;
            }
            if (this.contractToSaveId) {
                this.buttonDisable = true;
                this.templatesDataService.getTemplates('contract_full', +this.contractToSaveId).pipe(operators_1.takeUntil(this.unsubscribe), operators_1.finalize(function () {
                    return _this26.buttonDisable = false;
                })).subscribe(function (contract) {
                    _this26.contractToSave = JSON.parse(JSON.stringify(contract));
                }, function (error) {
                    return _this26.messageService.showDefaultErrorMessage(error);
                });
            }
        }
    }, {
        key: "openEditSelectContract",
        value: function openEditSelectContract() {
            var selectedModalRef = this.modalService.openModal(edit_contract_modal_component_1.EditContractModalComponent, {
                windowClass: 'ng-bootstrap-modal modal-visible'
            });
            selectedModalRef.componentInstance.isFixed = this.quoteType === 'fixed';
            selectedModalRef.componentInstance.contractToEdit = JSON.parse(JSON.stringify(this.contractToSave));
            selectedModalRef.componentInstance.action = 'SAVE_CONTRACT';
            this.contractTextSnapshot = this.contractToSave.text;
            this.subscribeToEditContractData(selectedModalRef);
        }
    }, {
        key: "subscribeToEditContractData",
        value: function subscribeToEditContractData(modalRef) {
            var _this27 = this;

            var modalDataSubscription = this.modalService.getModalData().subscribe(function (data) {
                if (data) {
                    var action = data.action,
                        props = data.props;

                    if (action === 'SAVE_CONTRACT') {
                        _this27.saveEditedContract(props);
                        _this27.modalService.closeModalByRef(modalRef, modalDataSubscription);
                    }
                    if (action === 'CLOSE_MODAL') {
                        _this27.modalService.closeModalByRef(modalRef, modalDataSubscription);
                    }
                }
            });
        }
    }, {
        key: "saveEditedContract",
        value: function saveEditedContract(contract) {
            if (contract && contract.name) {
                contract.name = this.stringModifierService.cutSelectedText(contract.name);
                this.messageService.showToaster('s_2', 'contractTemplates', contract.name);
            }
            this.contractToSave = JSON.parse(JSON.stringify(contract));
        }
    }, {
        key: "back",
        value: function back() {
            this.location.back();
        }
    }, {
        key: "updateQuote",
        value: function updateQuote(data) {
            var _this28 = this;

            this.updateQuoteRequest(data).finally(function () {
                _this28.buttonDisable = false;
            }).subscribe(function (quoteData) {
                if (quoteData.status >= 400 && quoteData.status <= 500) {
                    _this28.errorSaveQuote(quoteData);
                } else {
                    _this28.successSaveQuote(quoteData);
                }
            }, function (error) {
                return _this28.errorSaveQuote(error);
            });
        }
    }, {
        key: "updateQuoteRequest",
        value: function updateQuoteRequest(data) {
            if (this.quoteType === 'custom') {
                return this.quoteDataService.saveQuoteV1(this.idToGetQuote, this.quote.id, data);
            }
            return this.quoteDataService.saveFixedQuoteV1(this.idToGetQuote, this.quote.id, data);
        }
    }, {
        key: "errorSaveQuote",
        value: function errorSaveQuote(error) {
            if (error.error.errorMessage === 'Requested resource not found') {
                this.messageService.showToaster('e_0', 'editQuote');
            } else if (error.error.errorMessage === 'This Quote ID is already used. Please enter another one') {
                this.messageService.showToaster('e_15', 'editQuote');
            } else {
                this.messageService.showErrorFromBackend(error.error.errorTitle, error.error.errorMessage);
            }
        }
    }, {
        key: "successSaveQuote",
        value: function successSaveQuote(data) {
            this.messageService.showToaster('s_2', 'payments');
            if (this.isJob) {
                this.location.go("jobs/" + this.idToGetQuote + "/quote/" + data.id);
            } else {
                this.location.go("leads/" + this.leadId + "/quote/" + data.id);
            }
            window.Intercom('trackEvent', 'created quote');
        }
    }, {
        key: "createQuote",
        value: function createQuote(data) {
            var _this29 = this;

            this.createQuoteRequest(data).finally(function () {
                _this29.buttonDisable = false;
            }).subscribe(function (data) {
                if (data.status >= 400 && data.status <= 500) {
                    _this29.errorSaveQuote(data);
                } else {
                    _this29.successSaveQuote(data);
                }
            }, function (_ref11) {
                var error = _ref11.error;
                return _this29.messageService.showErrorFromBackend(error.errorTitle, error.errorMessage);
            });
        }
    }, {
        key: "createQuoteRequest",
        value: function createQuoteRequest(data) {
            if (this.quoteType === 'custom') {
                return this.quoteDataService.createQuoteV1(this.idToGetQuote, data);
            }
            return this.quoteDataService.createFixedQuoteV1(this.idToGetQuote, data);
        }
    }, {
        key: "successGetQuoteData",
        value: function successGetQuoteData(quote) {
            var job = quote.job,
                products = quote.products;

            this.quote = JSON.parse(JSON.stringify(quote));
            this.job = job;
            if (!this.quoteType) {
                this.quoteType = quote.quoteType === 'CHOOSE_AND_PICK' ? 'custom' : quote.quoteType.toLowerCase();
            }
            if (quote.paymentSchedule && quote.paymentSchedule.id) {
                this.job.paymentScheduleId = quote.paymentSchedule.id;
            }
            this.issueDate = this.quoteUpdateService.setQuoteIssueDate(quote.issueDate);
            this.autoGenerateInvoice = this.quote.generateInvoiceWhenAccepted;
            this.setQuoteSources(quote);
            this.setPackagesAndAddons(products);
            this.loadQuoteTemplates();
            this.updateQuoteSummary(false);
            if (quote.status === 'ACCEPTED') {
                this.back();
            }
        }
    }, {
        key: "setPaymentScheduleIdForSave",
        value: function setPaymentScheduleIdForSave(id) {
            switch (+id) {
                case 0:
                    return this.paymentScheduleIdFromServer;
                case -2:
                case -3:
                    return null;
                default:
                    return this.paymentScheduleTemplateId;
            }
        }
    }, {
        key: "getContractToSave",
        value: function getContractToSave() {
            if (this.contractToSave) {
                this.contractToSave.name = this.stringModifierService.cutSelectedText(this.contractToSave.name);
                /* Fix changed field for GDPR */
                if (this.contractToSave.optInConsentStatement) {
                    this.contractToSave.optInConsent = this.contractToSave.optInConsentStatement;
                    delete this.contractToSave.optInConsentStatement;
                }
                /*
                Fix backend grammar mistake
                showOTPinconsent => showOPTinconsent
                 */
                if (this.contractToSave.showOtpInConsent) {
                    this.contractToSave.showOptInConsent = this.contractToSave.showOtpInConsent;
                    delete this.contractToSave.showOtpInConsen;
                }
                if (this.currentContractId === this.contractToSave.id) {
                    this.contractToSave.contractId = this.currentContractId;
                } else {
                    this.contractToSave.contractId = null;
                }
            }
            return this.contractToSave;
        }
    }, {
        key: "getPaymentsToSave",
        value: function getPaymentsToSave() {
            var _this30 = this;

            return this.paymentsToSave.map(function (payment) {
                var paymentToSave = void 0;
                if (payment.date) {
                    paymentToSave = Object.assign(payment, {
                        paymentDate: _this30.quoteUpdateService.getDate(payment.date.jsdate)
                    });
                } else if (!payment.date && payment.paymentDateWithRule.ruleExplanationHTML) {
                    paymentToSave = Object.assign(payment, {
                        paymentDate: null
                    });
                } else {
                    paymentToSave = payment;
                }
                return paymentToSave;
            });
        }
    }, {
        key: "getProductsToSave",
        value: function getProductsToSave(needToRemoveId) {
            var _this31 = this;

            var productsToSave = this.packages.map(function (packageItem, index) {
                return Object.assign(packageItem, {
                    id: packageItem.fromSettings && needToRemoveId ? null : packageItem.id,
                    order: index,
                    price: needToRemoveId ? _this31.stringModifierService.convertAmountIntoNumber(packageItem.price) : packageItem.price,
                    mandatory: _this31.packages.length > 1 ? false : packageItem.mandatory
                });
            });
            this.addons.forEach(function (product, index) {
                productsToSave.push(Object.assign(product, {
                    id: product.fromSettings && needToRemoveId ? null : product.id,
                    order: index,
                    price: needToRemoveId ? _this31.stringModifierService.convertAmountIntoNumber(product.price) : product.price
                }));
            });
            this.discounts.forEach(function (discount, index) {
                productsToSave.push(Object.assign(discount, {
                    id: discount.fromSettings && needToRemoveId ? null : discount.id,
                    order: index,
                    price: needToRemoveId ? _this31.stringModifierService.convertAmountIntoNumber(discount.price) : discount.price,
                    taxType: _this31.quoteUpdateService.setTaxTypeForDiscount(productsToSave, discount.taxType)
                }));
            });
            return productsToSave;
        }
    }, {
        key: "gatherDataToSaveQuote",
        value: function gatherDataToSaveQuote() {
            var isQuestionnaireChanged = true;
            if (this.questionnaire && +this.questionnaireToSaveId === this.questionnaire.id) {
                isQuestionnaireChanged = false;
            }
            if (this.quoteSummary && this.quoteSummary.total === 0) {
                this.paymentScheduleTemplateId = -2;
            }
            this.paymentsToSave = this.getPaymentsToSave();
            return {
                quote: {
                    quoteId: this.quote.quoteId,
                    ponumber: this.quote.ponumber,
                    issueDate: this.timeService.getDateInFormat(this.issueDate.jsdate, 'date'),
                    notes: this.quote.notes,
                    introduction: this.quote.introduction,
                    paymentSchedulerTemplateId: this.setPaymentScheduleIdForSave(this.paymentScheduleTemplateId),
                    products: this.quoteType === 'custom' ? this.getProductsToSave(true) : this.getProductsToSaveFixedQuote(true),
                    payments: this.quoteSummary.total === 0 ? [] : this.paymentsToSave,
                    generateInvoiceWhenAccepted: this.paymentScheduleTemplateId !== -3 && this.autoGenerateInvoice,
                    paymentsStrategy: this.getPaymentStrategy()
                },
                removeContract: this.contractToSave === null,
                removeQuestionnaire: this.questionnaireToSaveId === '-1',
                contract: this.getContractToSave(),
                questionnaire: isQuestionnaireChanged ? {
                    templateId: this.questionnaireToSaveId === '-1' ? null : this.questionnaireToSaveId
                } : null
            };
        }
    }, {
        key: "getPaymentStrategy",
        value: function getPaymentStrategy() {
            switch (this.paymentScheduleTemplateId) {
                case -2:
                    return 'NO_SPLIT_PAYMENTS';
                case -3:
                    return 'NO_DUE_DATE';
                default:
                    return 'BY_PAYMENT_SCHEDULER';
            }
        }
    }, {
        key: "getProductsToSaveFixedQuote",
        value: function getProductsToSaveFixedQuote(needToRemoveId) {
            var _this32 = this;

            this.products = quote_update_service_1.QuoteUpdateService.setFixedQuoteProducts(this.products);
            var productsToSave = this.products.map(function (productItem, index) {
                return Object.assign(productItem, {
                    id: productItem.fromSettings && needToRemoveId ? null : productItem.id,
                    order: index,
                    price: needToRemoveId ? _this32.stringModifierService.convertAmountIntoNumber(productItem.price) : productItem.price
                });
            });
            this.discounts.forEach(function (discount, index) {
                productsToSave.push(Object.assign(discount, {
                    id: discount.fromSettings && needToRemoveId ? null : discount.id,
                    order: index,
                    price: needToRemoveId ? _this32.stringModifierService.convertAmountIntoNumber(discount.price) : discount.price,
                    taxType: _this32.quoteUpdateService.setTaxTypeForDiscount(productsToSave, discount.taxType)
                }));
            });
            return productsToSave;
        }
    }, {
        key: "getProductsTemplates",
        value: function getProductsTemplates() {
            var _this33 = this;

            var pageRequest = quote_update_service_1.QuoteUpdateService.getPageRequest();
            this.productPackagesDataService.getPackagesOrProducts(pageRequest).subscribe(function (data) {
                _this33.productsNames = data.items;
                _this33.setPackagesAndAddonsNames(data.items);
            }, function (error) {
                return _this33.messageService.showDefaultErrorMessage(error);
            });
        }
    }, {
        key: "getPaymentsSchedules",
        value: function getPaymentsSchedules() {
            var _this34 = this;

            var params = quote_update_service_1.QuoteUpdateService.getPaymentSchedulesPageRequest();
            this.paymentsSchedulesDataService.getPaymentsSchedules(params).subscribe(function (data) {
                _this34.defaultPaymentScheduleNames = [{
                    id: -2,
                    name: 'No split payments',
                    disabled: false
                }, {
                    id: -3,
                    name: 'No payment required',
                    disabled: false
                }];
                _this34.paymentScheduleNames = data.results;
            }, function (error) {
                return _this34.messageService.showDefaultErrorMessage(error);
            });
        }
    }, {
        key: "loadQuoteTemplates",
        value: function loadQuoteTemplates() {
            if (this.quoteType === 'fixed') {
                this.getQuoteTemplates('getQuoteTemplatesList');
            } else {
                this.getQuoteTemplates('getCustomQuoteTemplatesList');
            }
        }
    }, {
        key: "getQuoteTemplates",
        value: function getQuoteTemplates(getMethod) {
            var _this35 = this;

            this.qtTemplatesDataService[getMethod](quote_invoice_templates_service_1.QuoteInvoiceTemplatesService.getTemplatesParameters()).pipe(operators_1.takeUntil(this.unsubscribe), operators_1.map(function (_ref12) {
                var data = _ref12.data;
                return data ? data.samples.items : [];
            })).subscribe(function (templates) {
                return _this35.quoteTemplates = templates;
            }, function (error) {
                return _this35.messageService.handleError(error);
            });
        }
    }, {
        key: "isContractSigned",
        value: function isContractSigned() {
            var _contractToSave = this.contractToSave,
                signed = _contractToSave.signed,
                signatures = _contractToSave.signatures;

            if (signatures) {
                var photographerSignature = signatures.photographerSignature,
                    primarySignature = signatures.primarySignature,
                    secondarySignature = signatures.secondarySignature;

                return signed || photographerSignature || primarySignature || secondarySignature;
            }
            return signed;
        }
    }, {
        key: "getQuoteIdAndDate",
        value: function getQuoteIdAndDate(id) {
            var _this36 = this;

            this.quoteDataService.getQuoteIdAndDate(id).takeUntil(this.unsubscribe).subscribe(function (data) {
                _this36.quoteId = data.quoteId;
                _this36.issueDate = _this36.quoteUpdateService.setQuoteIssueDate(data.issueDate);
                _this36.quote = _this36.quoteUpdateService.setEmptyQuote(_this36.quoteId);
                _this36.getCurrencyAndTaxes();
                _this36.getDefaultIntroduction();
                _this36.getContractAndQuestionnaireInfo();
                // TODO - refactor
                var intervalCounter = 0;
                var interval = setInterval(function () {
                    if (_this36.currencyFlag) {
                        if (_this36.quoteType === 'custom' && !_this36.editQuote) {
                            _this36.addNewPackage();
                        } else if (_this36.quoteType !== 'custom' && !_this36.editQuote) {
                            _this36.addNewProduct();
                        }
                        _this36.currencyFlag = false;
                        intervalCounter++;
                    }
                    if (_this36.contractFlag && intervalCounter == 1) {
                        _this36.assignInitialDataAsTemplate(_this36.quote, _this36.linkedContract);
                        _this36.contractFlag = false;
                        intervalCounter++;
                    }
                    if (intervalCounter > 1) {
                        clearInterval(interval);
                    }
                }, 200);
            });
        }
    }]);

    return QuoteUpdateComponent;
}();
__decorate([core_1.Input('idToGetQuote'), __metadata("design:type", Number)], QuoteUpdateComponent.prototype, "idToGetQuote", void 0);
__decorate([core_1.Input('isJob'), __metadata("design:type", Boolean)], QuoteUpdateComponent.prototype, "isJob", void 0);
__decorate([core_1.Input('quoteId'), __metadata("design:type", Number)], QuoteUpdateComponent.prototype, "quoteId", void 0);
__decorate([core_1.Input('quoteType'), __metadata("design:type", String)], QuoteUpdateComponent.prototype, "quoteType", void 0);
__decorate([core_1.ViewChild('paymentScheduleComponent'), __metadata("design:type", payment_schedule_1.PaymentScheduleComponent)], QuoteUpdateComponent.prototype, "paymentScheduleComponent", void 0);
__decorate([core_1.ViewChild('quoteTemplateSelect'), __metadata("design:type", Object)], QuoteUpdateComponent.prototype, "quoteTemplateSelect", void 0);
QuoteUpdateComponent = __decorate([core_1.Component({
    selector: 'quote-update',
    template: __webpack_require__("./web/modern/components/quotes/quote-update/quote-update.html"),
    styles: [__webpack_require__("./web/modern/components/quotes/quote-update/quote-update.scss")]
}), __metadata("design:paramtypes", [ng2_dragula_1.DragulaService, stringModifier_service_1.StringModifierServiceProvider, quotes_data_service_1.QuotesDataProvider, message_service_1.MessageService, time_service_1.TimeServiceProvider, templates_data_service_1.TemplatesDataProvider, questionnaires_data_service_1.QuestionnairesDataProvider, product_packages_data_service_1.ProductPackagesDataServiceProvider, contracts_data_service_1.ContractsDataProvider, quote_update_service_1.QuoteUpdateService, payments_schedules_data_service_1.PaymentSchedulesDataProvider, jobs_data_service_1.JobsDataServiceProvider, leads_data_service_1.LeadsDataServiceProvider, settings_1.SettingsProvider, common_1.Location, quotes_data_service_1.QuotesDataProvider, validation_service_1.ValidationProvider, snModal_service_1.SNModalService, quote_invoice_templates_data_service_1.QuoteInvoiceTemplatesDataService, quote_invoice_templates_service_1.QuoteInvoiceTemplatesService, contracts_data_service_1.ContractsDataProvider])], QuoteUpdateComponent);
exports.QuoteUpdateComponent = QuoteUpdateComponent;

/***/ }),

/***/ "./web/modern/components/settings/common/delete-item-modal/delete-item-modal.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n    <button class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" (click)=\"onDismiss()\">&times;</button>\n    <h3 class=\"modal-title f-w-n\">Delete {{ modalTitle }}</h3>\n</div>\n<div class=\"modal-body\" style=\"padding: 30px!important;\">\n    <form (ngSubmit)=\"onSubmit()\" class=\"form-horizontal\" role=\"form\">\n        <p class=\"modal-text mb-30\">Delete <b>{{ itemName }}</b> {{ modalTitle.toLowerCase() }}?</p>\n        <div>\n            <button type=\"submit\" class=\"btn btn-lg btn-danger mb-0 mr-10\" spinning-wheel [is-spinning-wheel-active]=\"btnDisabled\" [disabled]=\"btnDisabled\">Delete {{ modalTitle }}</button>\n            <button (click)=\"onDismiss()\" [disabled]=\"btnDisabled\" class=\"btn btn-lg btn-default mb-0 ml-5\" data-dismiss=\"modal\" type=\"button\">Cancel</button>\n        </div>\n    </form>\n</div>\n"

/***/ }),

/***/ "./web/modern/components/settings/common/delete-item-modal/delete-item-modal.scss":
/***/ (function(module, exports) {

module.exports = ".modal-text {\n  font-size: 16px; }\n"

/***/ }),

/***/ "./web/modern/components/settings/common/delete-item-modal/delete-item-modal.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var ng_bootstrap_1 = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/index.js");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var DeleteItemModalComponent = function () {
    function DeleteItemModalComponent(activeModal, modalService) {
        _classCallCheck(this, DeleteItemModalComponent);

        this.activeModal = activeModal;
        this.modalService = modalService;
    }

    _createClass(DeleteItemModalComponent, [{
        key: "onSubmit",
        value: function onSubmit() {
            this.modalService.setModalData({
                action: 'Delete',
                props: this.modalData
            });
        }
    }, {
        key: "onDismiss",
        value: function onDismiss() {
            this.activeModal.dismiss();
        }
    }]);

    return DeleteItemModalComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", String)], DeleteItemModalComponent.prototype, "modalTitle", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], DeleteItemModalComponent.prototype, "modalData", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], DeleteItemModalComponent.prototype, "itemName", void 0);
__decorate([core_1.Input(), __metadata("design:type", Boolean)], DeleteItemModalComponent.prototype, "btnDisabled", void 0);
DeleteItemModalComponent = __decorate([core_1.Component({
    selector: 'delete-item-modal',
    template: __webpack_require__("./web/modern/components/settings/common/delete-item-modal/delete-item-modal.html"),
    styles: [__webpack_require__("./web/modern/components/settings/common/delete-item-modal/delete-item-modal.scss")],
    changeDetection: core_1.ChangeDetectionStrategy.OnPush
}), __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal, snModal_service_1.SNModalService])], DeleteItemModalComponent);
exports.DeleteItemModalComponent = DeleteItemModalComponent;

/***/ }),

/***/ "./web/modern/components/settings/common/dynamic-table/dynamic-table.component.html":
/***/ (function(module, exports) {

module.exports = "    <div class=\"table-responsive\">\n        <table class=\"table\">\n            <thead class=\"invoice-thead\">\n                <tr>\n                    <th *ngFor=\"let headerItem of headerList\">\n                        <b (click)=\"orderByField(headerItem.sortingCriteria, headerItem.isSortable)\"  [class.pointer]=\"headerItem.isSortable\">\n                            {{ headerItem.text }}\n                            <span *ngIf=\"pageRequest.sortCriterias[0].fieldName === headerItem.sortingCriteria && headerItem.isSortable\"\n                                  [ngClass]=\"pageRequest.sortCriterias[0].sortAscending ? 'fa-caret-up' : 'fa-caret-down'\"\n                                  class=\"fa\"\n                            >\n                            </span>\n                        </b>\n                    </th>\n                </tr>\n            </thead>\n\n            <ng-content></ng-content>\n\n        </table>\n    </div>\n\n    <div *ngIf=\"templates?.items?.length\" class=\"row\">\n        <div class=\"col-xs-12\">\n            <sn-pagination (renew)=\"updateTemplate($event)\" [pageNumbers]=\"pageNumbers\" [pageRequest]=\"pageRequest\" [totalItems]=\"totalItems\"></sn-pagination>\n        </div>\n    </div>\n\n"

/***/ }),

/***/ "./web/modern/components/settings/common/dynamic-table/dynamic-table.component.scss":
/***/ (function(module, exports) {

module.exports = "@media screen and (max-width: 991px) {\n  .table {\n    width: 800px;\n    overflow-x: visible; } }\n"

/***/ }),

/***/ "./web/modern/components/settings/common/dynamic-table/dynamic-table.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var rxjs_1 = __webpack_require__("./node_modules/rxjs/Rx.js");
var pagination_service_1 = __webpack_require__("./shared/services/pagination/pagination.service.ts");
var DynamicTableComponent = function () {
    function DynamicTableComponent(paginationService) {
        _classCallCheck(this, DynamicTableComponent);

        this.paginationService = paginationService;
        this.updateTableParams = new core_1.EventEmitter();
        this.pageNumbers = [];
        this.unsubscribe = new rxjs_1.Subject();
    }

    _createClass(DynamicTableComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.updatePageRequestParams();
        }
    }, {
        key: "ngOnChanges",
        value: function ngOnChanges(changes) {
            if (changes.templates && !changes.templates.isFirstChange() && changes.templates.currentValue.items.length) {
                this.updatePageRequestParams();
            }
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "orderByField",
        value: function orderByField(field, isSortable) {
            if (isSortable) {
                this.pageRequest.sortCriterias[0].fieldName = field;
                this.pageRequest.sortCriterias[0].sortAscending = !this.pageRequest.sortCriterias[0].sortAscending;
                this.updateTemplate(this.pageRequest);
            }
        }
    }, {
        key: "updateTemplate",
        value: function updateTemplate(data) {
            this.updateTableParams.emit(data);
        }
    }, {
        key: "updatePageRequestParams",
        value: function updatePageRequestParams() {
            this.totalItems = this.templates.totalSize;
            this.pageNumbers = this.paginationService.calculatePageNumbers(this.totalItems, this.pageRequest.paging.pageSize);
        }
    }]);

    return DynamicTableComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], DynamicTableComponent.prototype, "templates", void 0);
__decorate([core_1.Input(), __metadata("design:type", Array)], DynamicTableComponent.prototype, "headerList", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], DynamicTableComponent.prototype, "pageRequest", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], DynamicTableComponent.prototype, "updateTableParams", void 0);
DynamicTableComponent = __decorate([core_1.Component({
    selector: 'dynamic-table',
    template: __webpack_require__("./web/modern/components/settings/common/dynamic-table/dynamic-table.component.html"),
    styles: [__webpack_require__("./web/modern/components/settings/common/dynamic-table/dynamic-table.component.scss")]
}), __metadata("design:paramtypes", [pagination_service_1.PaginationService])], DynamicTableComponent);
exports.DynamicTableComponent = DynamicTableComponent;

/***/ }),

/***/ "./web/modern/components/settings/common/questionnaire-template-list/questionnaire-template-list.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"table-responsive\">\n    <table class=\"table\">\n        <thead class=\"invoice-thead\">\n        <tr>\n            <th>\n                <b (click)=\"orderByField('name')\" class=\"pointer\">\n                    Name\n                    <span *ngIf=\"pageRequest.sortCriterias[0].fieldName === 'name'\"\n                          [ngClass]=\"pageRequest.sortCriterias[0].sortAscending ? 'fa-caret-up' : 'fa-caret-down'\"\n                          class=\"fa\"\n                    >\n                        </span>\n                </b>\n            </th>\n            <th></th>\n        </tr>\n        </thead>\n        <tbody>\n        <tr *ngFor=\"let template of templates.items\">\n            <td class=\"title_holder\">{{ template.name }}</td>\n            <td class=\"buttons_holder\">\n                <button (click)=\"edit(template)\" *ngIf=\"template.actions.OPEN_IN_EDITOR\" class=\"btn btn-rounded btn-default btn-align\">\n                    <i class=\"fi fi-edit\"></i>\n                    {{ template.actions.OPEN_IN_EDITOR.actionName }}\n                </button>\n                <button (click)=\"duplicate(template)\" *ngIf=\"template.actions.DUPLICATE_TEMPLATE\"\n                        [is-spinning-wheel-active]=\"btnDisable && currentActiveId === template.id\"\n                        [is-spinning-wheel-dark]=\"'true'\"\n                        class=\"btn btn-rounded btn-default btn-align\"\n                        spinning-wheel>\n                    <i class=\"fi fi-duplicate\"></i>\n                    {{ template.actions.DUPLICATE_TEMPLATE?.actionName }}\n                </button>\n                <button (click)=\"deleteItem(template)\" *ngIf=\"template.actions.DELETE_TEMPLATE\" class=\"btn btn-delete btn-delete-empty btn-align\"></button>\n            </td>\n        </tr>\n        </tbody>\n    </table>\n</div>\n\n<div *ngIf=\"templates.items.length\" class=\"row\">\n    <div class=\"col-xs-12\">\n        <sn-pagination (renew)=\"updateTemplate($event)\" [pageNumbers]=\"pageNumbers\" [pageRequest]=\"pageRequest\" [totalItems]=\"totalItems\"></sn-pagination>\n    </div>\n</div>\n"

/***/ }),

/***/ "./web/modern/components/settings/common/questionnaire-template-list/questionnaire-template-list.scss":
/***/ (function(module, exports) {

module.exports = ".table tr {\n  border-top: 1px solid #e1e1e1; }\n\n.table .buttons_holder {\n  text-align: right; }\n  .table .buttons_holder .btn-align {\n    margin-bottom: 0;\n    margin-top: -7px; }\n\n.table .title_holder {\n  word-break: break-word; }\n"

/***/ }),

/***/ "./web/modern/components/settings/common/questionnaire-template-list/questionnaire-template-list.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var pagination_service_1 = __webpack_require__("./shared/services/pagination/pagination.service.ts");
var QuestionnaireTemplateListComponent = function () {
    function QuestionnaireTemplateListComponent(paginationService) {
        _classCallCheck(this, QuestionnaireTemplateListComponent);

        this.paginationService = paginationService;
        this.onEdit = new core_1.EventEmitter();
        this.onDuplicate = new core_1.EventEmitter();
        this.onDelete = new core_1.EventEmitter();
        this.updatePaginationParams = new core_1.EventEmitter();
        this.pageNumbers = [];
    }

    _createClass(QuestionnaireTemplateListComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.updatePageRequestParams();
        }
    }, {
        key: "ngOnChanges",
        value: function ngOnChanges(changes) {
            if (changes.templates && !changes.templates.isFirstChange() && changes.templates.currentValue.items.length) {
                this.updatePageRequestParams();
            }
        }
    }, {
        key: "updateTemplate",
        value: function updateTemplate(data) {
            this.updatePaginationParams.emit(data);
        }
    }, {
        key: "edit",
        value: function edit(template) {
            this.onEdit.emit(template);
        }
    }, {
        key: "duplicate",
        value: function duplicate(template) {
            this.currentActiveId = template.id;
            this.onDuplicate.emit(template);
        }
    }, {
        key: "deleteItem",
        value: function deleteItem(template) {
            this.onDelete.emit(template);
        }
    }, {
        key: "orderByField",
        value: function orderByField(field) {
            this.pageRequest.sortCriterias[0].fieldName = field;
            this.pageRequest.sortCriterias[0].sortAscending = !this.pageRequest.sortCriterias[0].sortAscending;
            this.updateTemplate(this.pageRequest);
        }
    }, {
        key: "updatePageRequestParams",
        value: function updatePageRequestParams() {
            this.totalItems = this.templates.totalSize;
            this.pageNumbers = this.paginationService.calculatePageNumbers(this.totalItems, this.pageRequest.paging.pageSize);
        }
    }]);

    return QuestionnaireTemplateListComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], QuestionnaireTemplateListComponent.prototype, "templates", void 0);
__decorate([core_1.Input(), __metadata("design:type", Boolean)], QuestionnaireTemplateListComponent.prototype, "btnDisable", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], QuestionnaireTemplateListComponent.prototype, "pageRequest", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], QuestionnaireTemplateListComponent.prototype, "onEdit", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], QuestionnaireTemplateListComponent.prototype, "onDuplicate", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], QuestionnaireTemplateListComponent.prototype, "onDelete", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], QuestionnaireTemplateListComponent.prototype, "updatePaginationParams", void 0);
QuestionnaireTemplateListComponent = __decorate([core_1.Component({
    selector: 'questionnaire-template-list',
    template: __webpack_require__("./web/modern/components/settings/common/questionnaire-template-list/questionnaire-template-list.html"),
    styles: [__webpack_require__("./web/modern/components/settings/common/questionnaire-template-list/questionnaire-template-list.scss")]
}), __metadata("design:paramtypes", [pagination_service_1.PaginationService])], QuestionnaireTemplateListComponent);
exports.QuestionnaireTemplateListComponent = QuestionnaireTemplateListComponent;

/***/ }),

/***/ "./web/modern/components/settings/common/setting-section-description/setting-section-description.html":
/***/ (function(module, exports) {

module.exports = "<h3 class=\"text-normal description-text-styles mb-20\">{{ text }}</h3>"

/***/ }),

/***/ "./web/modern/components/settings/common/setting-section-description/setting-section-description.scss":
/***/ (function(module, exports) {

module.exports = ":host .description-text-styles {\n  font-weight: 400 !important;\n  font-size: 16px;\n  line-height: 25px !important; }\n"

/***/ }),

/***/ "./web/modern/components/settings/common/setting-section-description/setting-section-description.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var SettingSectionDescriptionComponent = function SettingSectionDescriptionComponent() {
    _classCallCheck(this, SettingSectionDescriptionComponent);
};
__decorate([core_1.Input(), __metadata("design:type", String)], SettingSectionDescriptionComponent.prototype, "text", void 0);
SettingSectionDescriptionComponent = __decorate([core_1.Component({
    selector: 'setting-section-description',
    template: __webpack_require__("./web/modern/components/settings/common/setting-section-description/setting-section-description.html"),
    styles: [__webpack_require__("./web/modern/components/settings/common/setting-section-description/setting-section-description.scss")]
}), __metadata("design:paramtypes", [])], SettingSectionDescriptionComponent);
exports.SettingSectionDescriptionComponent = SettingSectionDescriptionComponent;

/***/ }),

/***/ "./web/modern/components/settings/common/setting-section-header/setting-section-header.html":
/***/ (function(module, exports) {

module.exports = "<div>\n    <div>\n        <h2 class=\"settings-section-header-title mb-0\">{{ title }}</h2>\n    </div>\n    <ol class=\"bc-list\">\n        <li\n                *ngFor=\"let breadcrumb of breadcrumbs\"\n                [class.active]=\"!breadcrumb.link\">\n            <a\n                    *ngIf=\"breadcrumb.link\"\n                    href=\"{{breadcrumb.link}}\">{{ breadcrumb.title }}\n            </a>\n            {{ !breadcrumb.link ? breadcrumb.title : '' }}\n        </li>\n    </ol>\n</div>\n"

/***/ }),

/***/ "./web/modern/components/settings/common/setting-section-header/setting-section-header.scss":
/***/ (function(module, exports) {

module.exports = ".settings-section-header-title {\n  color: #4e5e6a; }\n"

/***/ }),

/***/ "./web/modern/components/settings/common/setting-section-header/setting-section-header.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var SettingSectionHeaderComponent = function () {
    function SettingSectionHeaderComponent() {
        _classCallCheck(this, SettingSectionHeaderComponent);
    }

    _createClass(SettingSectionHeaderComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.title = this.breadcrumbs[this.breadcrumbs.length - 1].title;
        }
    }]);

    return SettingSectionHeaderComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Array)], SettingSectionHeaderComponent.prototype, "breadcrumbs", void 0);
SettingSectionHeaderComponent = __decorate([core_1.Component({
    selector: 'setting-section-header',
    template: __webpack_require__("./web/modern/components/settings/common/setting-section-header/setting-section-header.html"),
    styles: [__webpack_require__("./web/modern/components/settings/common/setting-section-header/setting-section-header.scss")]
}), __metadata("design:paramtypes", [])], SettingSectionHeaderComponent);
exports.SettingSectionHeaderComponent = SettingSectionHeaderComponent;

/***/ }),

/***/ "./web/modern/components/settings/common/template-edit-header/template-edit-header.component.html":
/***/ (function(module, exports) {

module.exports = "<header class=\"header flex-box flex-just-space-between flex-align-center\">\n    <button class=\"back-to-button\" [disabled]=\"disableButtons\" (click)=\"goBackAction()\">< Back to Quote & Invoice Templates</button>\n    <button class=\"btn btn-lg btn-info mb-0\" [disabled]=\"disableButtons\" spinning-wheel [is-spinning-wheel-active]=\"disableButtons\" (click)=\"saveAction()\">Save Template</button>\n</header>"

/***/ }),

/***/ "./web/modern/components/settings/common/template-edit-header/template-edit-header.component.scss":
/***/ (function(module, exports) {

module.exports = ".header {\n  position: fixed;\n  width: 100%;\n  height: 100px;\n  background-color: #34425a;\n  border-bottom: medium none;\n  z-index: 100001;\n  top: 0;\n  padding: 0 30px; }\n  .header .back-to-button {\n    background-color: transparent;\n    border: none;\n    border-radius: 0;\n    padding: 0 2px;\n    height: 100px;\n    color: #fff;\n    font-size: 14px; }\n    .header .back-to-button:focus {\n      outline: none !important; }\n    .header .back-to-button:active {\n      border-style: none !important; }\n    .header .back-to-button:hover {\n      background-color: #192b39; }\n"

/***/ }),

/***/ "./web/modern/components/settings/common/template-edit-header/template-edit-header.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var TemplateEditHeaderComponent = function () {
    function TemplateEditHeaderComponent() {
        _classCallCheck(this, TemplateEditHeaderComponent);

        this.onGoBack = new core_1.EventEmitter();
        this.onSave = new core_1.EventEmitter();
    }

    _createClass(TemplateEditHeaderComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.hideHeaderBlock = document.querySelector('#header-fantom-block');
            this.hideBanner = document.querySelector('#banner');
            this.hideHeaderBlock.classList.add('is-show-header');
            this.hideBanner && this.hideBanner.classList.add('is-show-header');
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.hideHeaderBlock.classList.remove('is-show-header');
            this.hideBanner && this.hideBanner.classList.remove('is-show-header');
        }
    }, {
        key: "goBackAction",
        value: function goBackAction() {
            this.onGoBack.emit();
        }
    }, {
        key: "saveAction",
        value: function saveAction() {
            this.onSave.emit();
        }
    }]);

    return TemplateEditHeaderComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Boolean)], TemplateEditHeaderComponent.prototype, "disableButtons", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], TemplateEditHeaderComponent.prototype, "onGoBack", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], TemplateEditHeaderComponent.prototype, "onSave", void 0);
TemplateEditHeaderComponent = __decorate([core_1.Component({
    selector: 'template-edit-header',
    template: __webpack_require__("./web/modern/components/settings/common/template-edit-header/template-edit-header.component.html"),
    styles: [__webpack_require__("./web/modern/components/settings/common/template-edit-header/template-edit-header.component.scss")]
})], TemplateEditHeaderComponent);
exports.TemplateEditHeaderComponent = TemplateEditHeaderComponent;

/***/ }),

/***/ "./web/modern/components/settings/common/template-list/template-list.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"table-responsive\">\n    <table class=\"table\">\n        <thead class=\"invoice-thead\">\n        <tr>\n            <th>\n                <b (click)=\"orderByField('name')\" class=\"pointer\">\n                    Name\n                    <span *ngIf=\"pageRequest.sortCriterias[0].fieldName === 'name'\"\n                          [ngClass]=\"pageRequest.sortCriterias[0].sortAscending ? 'fa-caret-up' : 'fa-caret-down'\"\n                          class=\"fa\"\n                    >\n                        </span>\n                </b>\n            </th>\n            <th></th>\n        </tr>\n        </thead>\n        <tbody>\n        <tr *ngFor=\"let template of templates.items\">\n            <td class=\"title_holder\">{{ template.name }}</td>\n            <td class=\"buttons_holder\">\n                <button (click)=\"edit(template)\" *ngIf=\"template.formActions.OPEN_IN_EDITOR\" class=\"btn btn-rounded btn-default btn-align\">\n                    <i class=\"fi fi-edit\"></i>\n                    {{ template.formActions.OPEN_IN_EDITOR.actionName }}\n                </button>\n                <button (click)=\"duplicate(template)\" *ngIf=\"template.formActions.DUPLICATE_FORM || template.formActions.UPGRADE_PLAN_FOR_DUPLICATE_FORM\"\n                        [is-spinning-wheel-active]=\"btnDisable && currentActiveId === template.id\"\n                        [is-spinning-wheel-dark]=\"'true'\"\n                        class=\"btn btn-rounded btn-default btn-align\"\n                        spinning-wheel>\n                    <i class=\"fi fi-duplicate\"></i>\n                    {{ template.formActions.DUPLICATE_FORM?.actionName || template.formActions.UPGRADE_PLAN_FOR_DUPLICATE_FORM?.actionName }}\n                </button>\n                <button (click)=\"deleteItem(template)\" *ngIf=\"template.formActions.DELETE_FORM\" class=\"btn btn-delete btn-delete-empty btn-align\"></button>\n            </td>\n        </tr>\n        </tbody>\n    </table>\n</div>\n\n<div *ngIf=\"templates.items.length\" class=\"row\">\n    <div class=\"col-xs-12\">\n        <sn-pagination (renew)=\"updateTemplate($event)\" [pageNumbers]=\"pageNumbers\" [pageRequest]=\"pageRequest\" [totalItems]=\"totalItems\"></sn-pagination>\n    </div>\n</div>\n"

/***/ }),

/***/ "./web/modern/components/settings/common/template-list/template-list.scss":
/***/ (function(module, exports) {

module.exports = ".table tr {\n  border-top: 1px solid #e1e1e1; }\n\n.table .buttons_holder {\n  text-align: right; }\n  .table .buttons_holder .btn-align {\n    margin-bottom: 0;\n    margin-top: -7px; }\n\n.table .title_holder {\n  word-break: break-word; }\n"

/***/ }),

/***/ "./web/modern/components/settings/common/template-list/template-list.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var pagination_service_1 = __webpack_require__("./shared/services/pagination/pagination.service.ts");
var subscription_service_1 = __webpack_require__("./shared/services/subscription/subscription.service.ts");
var TemplateListComponent = function () {
    function TemplateListComponent(paginationService, subscriptionService) {
        _classCallCheck(this, TemplateListComponent);

        this.paginationService = paginationService;
        this.subscriptionService = subscriptionService;
        this.onEdit = new core_1.EventEmitter();
        this.onDuplicate = new core_1.EventEmitter();
        this.onDelete = new core_1.EventEmitter();
        this.updatePaginationParams = new core_1.EventEmitter();
        this.pageNumbers = [];
    }

    _createClass(TemplateListComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.updatePageRequestParams();
        }
    }, {
        key: "ngOnChanges",
        value: function ngOnChanges(changes) {
            if (changes.templates && !changes.templates.isFirstChange() && changes.templates.currentValue.items.length) {
                this.updatePageRequestParams();
            }
        }
    }, {
        key: "updateTemplate",
        value: function updateTemplate(data) {
            this.updatePaginationParams.emit(data);
        }
    }, {
        key: "edit",
        value: function edit(template) {
            this.onEdit.emit(template);
        }
    }, {
        key: "duplicate",
        value: function duplicate(template) {
            if (template.formActions.UPGRADE_PLAN_FOR_DUPLICATE_FORM) {
                this.subscriptionService.setChoosePlanOpenModalStatus({
                    state: true,
                    payload: {
                        url: template.formActions.UPGRADE_PLAN_FOR_DUPLICATE_FORM.url
                    }
                });
            } else {
                this.currentActiveId = template.id;
                this.onDuplicate.emit(template);
            }
        }
    }, {
        key: "deleteItem",
        value: function deleteItem(template) {
            this.onDelete.emit(template);
        }
    }, {
        key: "orderByField",
        value: function orderByField(field) {
            this.pageRequest.sortCriterias[0].fieldName = field;
            this.pageRequest.sortCriterias[0].sortAscending = !this.pageRequest.sortCriterias[0].sortAscending;
            this.updateTemplate(this.pageRequest);
        }
    }, {
        key: "updatePageRequestParams",
        value: function updatePageRequestParams() {
            this.totalItems = this.templates.totalSize;
            this.pageNumbers = this.paginationService.calculatePageNumbers(this.totalItems, this.pageRequest.paging.pageSize);
        }
    }]);

    return TemplateListComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], TemplateListComponent.prototype, "templates", void 0);
__decorate([core_1.Input(), __metadata("design:type", Boolean)], TemplateListComponent.prototype, "btnDisable", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], TemplateListComponent.prototype, "pageRequest", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], TemplateListComponent.prototype, "onEdit", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], TemplateListComponent.prototype, "onDuplicate", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], TemplateListComponent.prototype, "onDelete", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], TemplateListComponent.prototype, "updatePaginationParams", void 0);
TemplateListComponent = __decorate([core_1.Component({
    selector: 'template-list',
    template: __webpack_require__("./web/modern/components/settings/common/template-list/template-list.html"),
    styles: [__webpack_require__("./web/modern/components/settings/common/template-list/template-list.scss")]
}), __metadata("design:paramtypes", [pagination_service_1.PaginationService, subscription_service_1.NewSubscriptionServiceDataProvider])], TemplateListComponent);
exports.TemplateListComponent = TemplateListComponent;

/***/ }),

/***/ "./web/modern/components/settings/companies-section/companies-section.component.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"bc-wrap\">\n    <div class=\"flex-box flex-just-space\">\n        <setting-section-header [breadcrumbs]=\"breadcrumbs\"></setting-section-header>\n        <div class=\"mt-20\">\n            <settings-add-btn (onBtnClick)=\"addNewCompany()\" *ngIf=\"actionName\" [text]=\"actionName\"></settings-add-btn>\n        </div>\n    </div>\n</div>\n\n<div class=\"m-30\">\n    <setting-section-description\n            [text]=\"'Update your company logo, client portal banner and contact details, which are visible on your quotes, invoices and contracts.'\">\n    </setting-section-description>\n</div>\n\n<ng-container *ngIf=\"brands.length\">\n    <company-list-item (onCompanyDelete)=\"successDeleteBrand()\" [company]=\"company\" *ngFor=\"let company of brands\"></company-list-item>\n</ng-container>\n\n"

/***/ }),

/***/ "./web/modern/components/settings/companies-section/companies-section.component.scss":
/***/ (function(module, exports) {

module.exports = ""

/***/ }),

/***/ "./web/modern/components/settings/companies-section/companies-section.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var brands_data_service_1 = __webpack_require__("./shared/services/brands/brands.data.service.ts");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var brand_create_modal_1 = __webpack_require__("./web/modern/components/brands/modals/brand-create-modal/brand-create-modal.ts");
var import_data_modal_1 = __webpack_require__("./web/modern/components/brands/modals/import-data-modal/import-data-modal.ts");
var subscription_service_1 = __webpack_require__("./shared/services/subscription/subscription.service.ts");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var EmptyError_1 = __webpack_require__("./node_modules/rxjs/util/EmptyError.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var common_1 = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
var CompaniesSectionComponent = function () {
    function CompaniesSectionComponent(brandsDataService, snModalService, subscriptionService, messageService, location) {
        _classCallCheck(this, CompaniesSectionComponent);

        this.brandsDataService = brandsDataService;
        this.snModalService = snModalService;
        this.subscriptionService = subscriptionService;
        this.messageService = messageService;
        this.location = location;
        this.breadcrumbs = [{ link: '/', title: 'Dashboard' }, { link: '/settings', title: 'Settings' }, { link: null, title: 'Companies' }];
        this.brands = [];
        this.unsubscribe = new Subject_1.Subject();
    }

    _createClass(CompaniesSectionComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.getBrandsInfo();
            this.listenToPlanChange();
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "addNewCompany",
        value: function addNewCompany() {
            var _this = this;

            if (this.brandsActions.UPGRADE_PLAN) {
                this.subscriptionService.setChoosePlanOpenModalStatus({
                    state: true,
                    payload: { url: this.brandsActions.UPGRADE_PLAN.url }
                });
            }
            if (this.brandsActions.ADD_NEW_BRAND) {
                this.snModalService.openModal(brand_create_modal_1.BrandCreateModalComponent).result.then(function (shouldImportData) {
                    return _this.successCreateBrand(shouldImportData);
                }).catch(function () {
                    return EmptyError_1.EmptyError;
                });
            }
        }
    }, {
        key: "successCreateBrand",
        value: function successCreateBrand(brandData) {
            if (brandData.action === 'IMPORT') {
                this.handleDataImportModal(brandData.props);
            }
            if (brandData.action === 'REDIRECT') {
                this.updateAndRedirect(brandData.props.companyId);
            }
        }
    }, {
        key: "successDeleteBrand",
        value: function successDeleteBrand() {
            this.getBrandsInfo();
            this.brandsDataService.getBrandsData();
            this.messageService.showToaster('s_1', 'companyInformation');
        }
    }, {
        key: "handleDataImportModal",
        value: function handleDataImportModal(brandData) {
            var _this2 = this;

            this.importModalRef = this.snModalService.openModal(import_data_modal_1.ImportDataModalComponent);
            this.importModalRef.componentInstance.newBrandData = brandData;
            this.importModalRef.result.then(function (res) {
                if (res) {
                    _this2.updateAndRedirect(res.companyId);
                }
            }).catch();
        }
    }, {
        key: "getBrandsInfo",
        value: function getBrandsInfo() {
            var _this3 = this;

            this.brandsDataService.getBrandsInfo().pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (data) {
                var brands = data.brands,
                    actions = data.actions;

                if (actions.ADD_NEW_BRAND || actions.UPGRADE_PLAN) {
                    _this3.actionName = (actions.ADD_NEW_BRAND || actions.UPGRADE_PLAN).actionName;
                }
                _this3.brandsActions = actions;
                _this3.brands = brands;
            });
        }
    }, {
        key: "listenToPlanChange",
        value: function listenToPlanChange() {
            var _this4 = this;

            this.subscriptionService.subscriptionData.pipe(operators_1.takeUntil(this.unsubscribe), operators_1.skip(1)).subscribe(function () {
                return _this4.getBrandsInfo();
            });
        }
    }, {
        key: "updateAndRedirect",
        value: function updateAndRedirect(companyId) {
            this.location.go("/settings/company/" + companyId + "/edit");
        }
    }]);

    return CompaniesSectionComponent;
}();
CompaniesSectionComponent = __decorate([core_1.Component({
    selector: 'companies-section',
    template: __webpack_require__("./web/modern/components/settings/companies-section/companies-section.component.html"),
    styles: [__webpack_require__("./web/modern/components/settings/companies-section/companies-section.component.scss")]
}), __metadata("design:paramtypes", [brands_data_service_1.BrandsDataServiceProvider, snModal_service_1.SNModalService, subscription_service_1.NewSubscriptionServiceDataProvider, message_service_1.MessageService, common_1.Location])], CompaniesSectionComponent);
exports.CompaniesSectionComponent = CompaniesSectionComponent;

/***/ }),

/***/ "./web/modern/components/settings/companies-section/company-list-item/company-list-item.component.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"company-item\" *ngIf=\"company\">\n    <div class=\"flex-box flex-align-center\">\n        <div class=\"company-item__img\">\n            <div *ngIf=\"company.logoUrl; else defaultCompanyImg\" [style.backgroundImage]=\"'url(' + company.logoUrl + ')'\" class=\"company-item__img-logo\"></div>\n            <ng-template #defaultCompanyImg>\n                <div  class=\"company-item__img-bg\">\n                    <i class=\"fi fi-company\"></i>\n                </div>\n            </ng-template>\n        </div>\n    </div>\n    <div class=\"company-item__main\">\n        <div class=\"company-item__main-header\">\n            <h3 class=\"mt-0 mb-0\">{{ company.name }}</h3>\n        </div>\n        <div class=\"company-item__main-block\">\n            <div class=\"company-item-info\">\n                <div class=\"company-item-info__column\">\n                    <div *ngIf=\"company.phone\"><span>Phone number:</span> {{ company.phone }}</div>\n                    <div *ngIf=\"company.email\"><span>Email:</span> {{ company.email }}</div>\n                    <div *ngIf=\"company.number\"><span>{{ businessNumberLabelName }}:</span> {{ company.number }}</div>\n                </div>\n                <div class=\"company-item-info__column\">\n                    <div *ngIf=\"company.address\">{{ company.address }}</div>\n                    <div *ngIf=\"company.city\">{{ company.city }} </div>\n                    <div *ngIf=\"company.state || company.country || company.postcode\">{{ company.state }} {{ company.country }} {{ company.postcode }}</div>\n                </div>\n            </div>\n            <div class=\"flex-box company-item__buttons\">\n                <button *ngIf=\"!company.actions.PREVIEW_BRAND_FOR_UPDATE\" class=\"btn btn-default mb-0 mr-10\" disabled>\n                    <i class=\"fi fi-edit\"></i>\n                    Edit company\n                </button>\n                <a *ngIf=\"company.actions.PREVIEW_BRAND_FOR_UPDATE\" class=\"btn btn-default mb-0 mr-10\" href=\"{{'/settings/company/' + company.companyId + '/edit'}}\">\n                    <i class=\"fi fi-edit\"></i>\n                    Edit company\n                </a>\n                <button (click)=\"openDeleteCompanyModal()\" class=\"btn btn-default fa m-0 fa-trash-o f-s-14-i\" [disabled]=\"!company.actions.DELETE_BRAND.url  && !company?.actions?.DELETE_BRAND?.method\" ></button>\n            </div>\n        </div>\n    </div>\n</div>\n\n"

/***/ }),

/***/ "./web/modern/components/settings/companies-section/company-list-item/company-list-item.component.scss":
/***/ (function(module, exports) {

module.exports = ".company-item {\n  background-color: #f9f9f9;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  padding: 20px;\n  min-height: 170px;\n  border: 1px solid #e1e1e1;\n  margin-bottom: 30px; }\n  @media (max-width: 768px) {\n    .company-item {\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n      -webkit-flex-direction: column;\n          -ms-flex-direction: column;\n              flex-direction: column; } }\n  .company-item__img {\n    width: 130px;\n    height: 130px;\n    display: inline-block;\n    margin-right: 20px; }\n    .company-item__img-logo {\n      width: 130px;\n      height: 130px;\n      background: center no-repeat;\n      background-size: contain; }\n    .company-item__img-bg {\n      width: 100%;\n      height: 130px;\n      background-color: #d7d7d7;\n      display: -webkit-box;\n      display: -webkit-flex;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n      -webkit-align-items: center;\n          -ms-flex-align: center;\n              align-items: center;\n      -webkit-box-pack: center;\n      -webkit-justify-content: center;\n          -ms-flex-pack: center;\n              justify-content: center; }\n      .company-item__img-bg i {\n        font-size: 50px; }\n    @media (max-width: 768px) {\n      .company-item__img {\n        margin-bottom: 20px; } }\n  .company-item__main {\n    width: 100%; }\n    .company-item__main-header {\n      padding-bottom: 15px;\n      padding-top: 5px;\n      border-bottom: 1px solid #e1e1e1; }\n    .company-item__main-block {\n      padding-top: 10px;\n      padding-bottom: 0;\n      display: -webkit-box;\n      display: -webkit-flex;\n      display: -ms-flexbox;\n      display: flex;\n      width: 100%;\n      -webkit-box-pack: justify;\n      -webkit-justify-content: space-between;\n          -ms-flex-pack: justify;\n              justify-content: space-between; }\n      @media (max-width: 1199px) {\n        .company-item__main-block {\n          -webkit-box-orient: vertical;\n          -webkit-box-direction: normal;\n          -webkit-flex-direction: column;\n              -ms-flex-direction: column;\n                  flex-direction: column; } }\n      .company-item__main-block .btn[disabled] {\n        opacity: 0.5 !important; }\n  .company-item-info {\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    width: 100%; }\n    @media (max-width: 620px) {\n      .company-item-info {\n        -webkit-box-orient: vertical;\n        -webkit-box-direction: normal;\n        -webkit-flex-direction: column;\n            -ms-flex-direction: column;\n                flex-direction: column; } }\n    .company-item-info__column {\n      display: -webkit-box;\n      display: -webkit-flex;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n      -webkit-flex-direction: column;\n          -ms-flex-direction: column;\n              flex-direction: column;\n      width: 50%;\n      padding-right: 10px; }\n      .company-item-info__column div {\n        line-height: 2; }\n        .company-item-info__column div span {\n          font-weight: 600; }\n  .company-item__buttons {\n    padding-top: 20px;\n    -webkit-box-align: start;\n    -webkit-align-items: flex-start;\n        -ms-flex-align: start;\n            align-items: flex-start; }\n    .company-item__buttons > .btn.fa-trash-o {\n      height: 34px; }\n"

/***/ }),

/***/ "./web/modern/components/settings/companies-section/company-list-item/company-list-item.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var rxjs_1 = __webpack_require__("./node_modules/rxjs/Rx.js");
var delete_company_modal_1 = __webpack_require__("./web/modern/components/settings/companies-section/delete-company-modal/delete-company.modal.ts");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var brands_data_service_1 = __webpack_require__("./shared/services/brands/brands.data.service.ts");
var models_1 = __webpack_require__("./shared/models/models.ts");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var alert_modal_component_1 = __webpack_require__("./web/modern/components/common/alert-modal/alert-modal.component.ts");
var settings_1 = __webpack_require__("./shared/services/settings/settings.ts");
var CompanyListItemComponent = function () {
    function CompanyListItemComponent(modalService, brandsDataService, settingsService) {
        _classCallCheck(this, CompanyListItemComponent);

        this.modalService = modalService;
        this.brandsDataService = brandsDataService;
        this.settingsService = settingsService;
        this.onCompanyDelete = new core_1.EventEmitter();
        this.unsubscribe = new rxjs_1.Subject();
    }

    _createClass(CompanyListItemComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.subscribeToCustomizeLabelsChange();
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "openDeleteCompanyModal",
        value: function openDeleteCompanyModal() {
            var _this = this;

            if (this.company.actions.DELETE_BRAND.method === models_1.ActionMethodEnum.ALERT_MODAL.toString()) {
                this.showAlert(this.company.actions.DELETE_BRAND);
            } else {
                this.deleteModalRef = this.modalService.openModal(delete_company_modal_1.DeleteCompanyModalComponent, {
                    windowClass: 'ng-bootstrap-modal__small'
                });
                this.subscribeToDeleteCompanyData();
                this.deleteModalRef.componentInstance.btnDisabled = false;
                this.deleteModalRef.componentInstance.company = this.company;
                this.deleteModalRef.result.then(function (data) {
                    return _this.deleteCompanySubscription.unsubscribe();
                });
            }
        }
    }, {
        key: "subscribeToCustomizeLabelsChange",
        value: function subscribeToCustomizeLabelsChange() {
            var _this2 = this;

            this.settingsService.customizeLabelsObservable.pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (customizeLabels) {
                return _this2.businessNumberLabelName = customizeLabels.businessNumberLabel;
            });
        }
    }, {
        key: "subscribeToDeleteCompanyData",
        value: function subscribeToDeleteCompanyData() {
            var _this3 = this;

            this.deleteCompanySubscription = this.modalService.getModalData().filter(function (data) {
                return data.action === 'DELETE_COMPANY';
            }).subscribe(function (data) {
                _this3.brandsDataService.deleteBrand(data.props.actions.DELETE_BRAND.url).pipe(operators_1.takeUntil(_this3.unsubscribe)).subscribe(function () {
                    _this3.deleteModalRef.componentInstance.btnDisabled = false;
                    _this3.deleteModalRef.close();
                    _this3.onCompanyDelete.emit();
                });
            });
        }
    }, {
        key: "showAlert",
        value: function showAlert(action) {
            this.alertModalRef = this.modalService.openModal(alert_modal_component_1.AlertModalComponent, {
                windowClass: 'ng-bootstrap-modal modal-visible modal-narrow'
            });
            this.alertModalRef.componentInstance.title = action.alertMessage.title;
            this.alertModalRef.componentInstance.message = action.alertMessage.message;
        }
    }]);

    return CompanyListItemComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], CompanyListItemComponent.prototype, "company", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], CompanyListItemComponent.prototype, "onCompanyDelete", void 0);
CompanyListItemComponent = __decorate([core_1.Component({
    selector: 'company-list-item',
    template: __webpack_require__("./web/modern/components/settings/companies-section/company-list-item/company-list-item.component.html"),
    styles: [__webpack_require__("./web/modern/components/settings/companies-section/company-list-item/company-list-item.component.scss")]
}), __metadata("design:paramtypes", [snModal_service_1.SNModalService, brands_data_service_1.BrandsDataServiceProvider, settings_1.SettingsProvider])], CompanyListItemComponent);
exports.CompanyListItemComponent = CompanyListItemComponent;

/***/ }),

/***/ "./web/modern/components/settings/companies-section/delete-company-modal/delete-company.modal.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-body\" style=\"padding: 30px!important;\">\n    <form class=\"form-horizontal\" role=\"form\" (submit)=\"onSubmit()\">\n        <p class=\"f-s-16 mt-0 line-h text-center\">\n            Deleting this company will delete everything inside including clients, leads, jobs, invoices and settings.\n        </p>\n        <p class=\"f-s-16 line-h text-center mb-0 \">There is no undo. Are you sure?</p>\n        <div class=\"pt-25 text-center\">\n            <button type=\"submit\" class=\"btn btn-lg btn-danger mb-0 mr-10\" spinning-wheel [is-spinning-wheel-active]=\"btnDisabled\" [disabled]=\"btnDisabled\">Delete Company</button>\n            <button (click)=\"onDismiss()\" [disabled]=\"btnDisabled\" class=\"btn btn-lg btn-cancel mb-0\" type=\"button\">Don't Delete</button>\n        </div>\n    </form>\n</div>"

/***/ }),

/***/ "./web/modern/components/settings/companies-section/delete-company-modal/delete-company.modal.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var ng_bootstrap_1 = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/index.js");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var DeleteCompanyModalComponent = function () {
    function DeleteCompanyModalComponent(activeModal, modalService) {
        _classCallCheck(this, DeleteCompanyModalComponent);

        this.activeModal = activeModal;
        this.modalService = modalService;
        this.btnDisabled = false;
    }

    _createClass(DeleteCompanyModalComponent, [{
        key: "onSubmit",
        value: function onSubmit() {
            this.btnDisabled = true;
            this.modalService.setModalData({
                action: 'DELETE_COMPANY',
                props: this.company
            });
        }
    }, {
        key: "onDismiss",
        value: function onDismiss() {
            this.activeModal.close();
        }
    }]);

    return DeleteCompanyModalComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], DeleteCompanyModalComponent.prototype, "btnDisabled", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], DeleteCompanyModalComponent.prototype, "company", void 0);
DeleteCompanyModalComponent = __decorate([core_1.Component({
    selector: 'delete-company-modal',
    template: __webpack_require__("./web/modern/components/settings/companies-section/delete-company-modal/delete-company.modal.html"),
    changeDetection: core_1.ChangeDetectionStrategy.OnPush
}), __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal, snModal_service_1.SNModalService])], DeleteCompanyModalComponent);
exports.DeleteCompanyModalComponent = DeleteCompanyModalComponent;

/***/ }),

/***/ "./web/modern/components/settings/contact-form-section/contact-form-section.html":
/***/ (function(module, exports) {

module.exports = "<ng-container *ngIf=\"contactForm\">\n    <div class=\"bc-wrap\">\n        <div class=\"flex-box flex-just-space\">\n            <setting-section-header [breadcrumbs]=\"breadcrumbs\"></setting-section-header>\n            <div class=\"mt-20\">\n                <settings-add-btn *ngIf=\"contactForm.actions.OPEN_EDITOR_FOR_CREATION || contactForm.actions.UPGRADE_PLAN_FOR_CREATE_NEW_FORM\" (onBtnClick)=\"addNewTemplate()\" [text]=\"'Add new form'\"></settings-add-btn>\n            </div>\n        </div>\n    </div>\n    <div class=\"m-30\">\n        <setting-section-description\n                [text]=\"'Create a stylised form that automatically adds a new client and a new lead in Studio Ninja when an enquiry is submitted. You will also receive an email notification with all the details submitted via the form.'\">\n        </setting-section-description>\n    </div>\n    <div>\n        <template-list\n                (onDelete)=\"deleteTemplate($event)\"\n                (onDuplicate)=\"duplicateTemplate($event)\"\n                (onEdit)=\"editTemplate($event)\"\n                (updatePaginationParams)=\"updatePageRequestParams($event)\"\n                [pageRequest]=\"pageRequest\"\n                [btnDisable]=\"btnDisable\"\n                [templates]=\"contactForm.formPreviews\">\n        </template-list>\n    </div>\n</ng-container>\n\n"

/***/ }),

/***/ "./web/modern/components/settings/contact-form-section/contact-form-section.scss":
/***/ (function(module, exports) {

module.exports = ""

/***/ }),

/***/ "./web/modern/components/settings/contact-form-section/contact-form-section.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var delete_item_modal_1 = __webpack_require__("./web/modern/components/settings/common/delete-item-modal/delete-item-modal.ts");
var settings_data_service_1 = __webpack_require__("./web/modern/services/settings/contact-form/settings.data.service.ts");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var account_service_1 = __webpack_require__("./web/modern/services/user/account.service.ts");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var subscription_service_1 = __webpack_require__("./shared/services/subscription/subscription.service.ts");
var subscription_model_1 = __webpack_require__("./shared/models/subscription.model.ts");
var ContactFormSectionComponent = function () {
    function ContactFormSectionComponent(snModalService, settingsDataService, accountService, subscriptionService, messageService, renderer) {
        _classCallCheck(this, ContactFormSectionComponent);

        this.snModalService = snModalService;
        this.settingsDataService = settingsDataService;
        this.accountService = accountService;
        this.subscriptionService = subscriptionService;
        this.messageService = messageService;
        this.renderer = renderer;
        this.breadcrumbs = [{ link: '/', title: 'Dashboard' }, { link: '/settings', title: 'Settings' }, { link: null, title: 'Contact Form' }];
        this.unsubscribe = new Subject_1.Subject();
        this.REQUEST_PARAMS = {
            paging: {
                pageNumber: 0,
                pageSize: 5,
                searchToken: null
            },
            sortCriterias: [{
                fieldName: 'name',
                sortAscending: true
            }]
        };
    }

    _createClass(ContactFormSectionComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.getCompanyId();
            this.applyPageProductFromLocalStorage();
            this.getContactFormPreviews();
            this.onSubscriptionPaid();
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
            if (this.subscriptionPaidEvent) {
                this.subscriptionPaidEvent();
            }
        }
    }, {
        key: "getCompanyId",
        value: function getCompanyId() {
            var _this = this;

            this.accountService.companyIdObservable.subscribe(function (data) {
                _this.companyId = data;
            });
        }
    }, {
        key: "addNewTemplate",
        value: function addNewTemplate() {
            if (this.contactForm.actions.UPGRADE_PLAN_FOR_CREATE_NEW_FORM) {
                this.subscriptionService.setChoosePlanOpenModalStatus({
                    state: true,
                    payload: {
                        url: this.contactForm.actions.UPGRADE_PLAN_FOR_CREATE_NEW_FORM.url
                    }
                });
            } else {
                window.open("" + this.contactForm.actions.OPEN_EDITOR_FOR_CREATION.url, '_self');
            }
        }
    }, {
        key: "editTemplate",
        value: function editTemplate(template) {
            window.open("" + template.formActions.OPEN_IN_EDITOR.url, '_self');
        }
    }, {
        key: "duplicateTemplate",
        value: function duplicateTemplate(template) {
            var _this2 = this;

            this.btnDisable = true;
            this.settingsDataService.duplicateContactForm(template.formActions.DUPLICATE_FORM.url, template.name + " copy").pipe(operators_1.takeUntil(this.unsubscribe), operators_1.finalize(function () {
                return _this2.btnDisable = false;
            })).subscribe(function (data) {
                _this2.editTemplate(data);
            }, function (_ref) {
                var error = _ref.error;
                return _this2.errorDuplicateForm(error);
            });
        }
    }, {
        key: "deleteTemplate",
        value: function deleteTemplate(template) {
            var _this3 = this;

            this.deleteModalRef = this.snModalService.openModal(delete_item_modal_1.DeleteItemModalComponent);
            this.deleteModalRef.componentInstance.btnDisabled = false;
            this.deleteModalRef.componentInstance.itemName = template.name;
            this.deleteModalRef.componentInstance.modalTitle = 'Contact Form';
            this.deleteModalRef.componentInstance.modalData = template;
            var modalData$ = this.snModalService.getModalData().subscribe(function (data) {
                _this3.settingsDataService.deleteContactForm(data.props.formActions.DELETE_FORM.url).pipe(operators_1.takeUntil(_this3.unsubscribe), operators_1.finalize(function () {
                    return _this3.deleteModalRef.componentInstance.btnDisabled = false;
                })).subscribe(function () {
                    _this3.pageRequest.paging.pageNumber = 0;
                    _this3.pageRequest.paging.searchToken = null;
                    _this3.getContactFormPreviews();
                    _this3.deleteModalRef.close();
                    modalData$.unsubscribe();
                });
            });
        }
    }, {
        key: "updatePageRequestParams",
        value: function updatePageRequestParams(data) {
            this.pageRequest = data;
            this.getContactFormPreviews();
        }
    }, {
        key: "getContactFormPreviews",
        value: function getContactFormPreviews() {
            var _this4 = this;

            this.settingsDataService.getContactFormPreviews(this.pageRequest).pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (data) {
                _this4.contactForm = data;
                _this4.pageRequest.paging.searchToken = data.formPreviews.searchToken;
                _this4.setPageProductToLocalStorage(_this4.pageRequest);
            });
        }
    }, {
        key: "applyPageProductFromLocalStorage",
        value: function applyPageProductFromLocalStorage() {
            var pageRequestObject = JSON.parse(localStorage.getItem("contactFormRequest_" + this.companyId));
            this.pageRequest = this.REQUEST_PARAMS;
            if (pageRequestObject && pageRequestObject !== '') {
                var pageSize = pageRequestObject.pageSize,
                    fieldName = pageRequestObject.fieldName,
                    sortAscending = pageRequestObject.sortAscending;

                this.pageRequest.paging.pageSize = pageSize;
                this.pageRequest.sortCriterias[0].fieldName = fieldName;
                this.pageRequest.sortCriterias[0].sortAscending = sortAscending;
            }
        }
    }, {
        key: "setPageProductToLocalStorage",
        value: function setPageProductToLocalStorage(pageRequest) {
            var pageRequestObject = {
                pageSize: pageRequest.paging.pageSize,
                fieldName: pageRequest.sortCriterias[0].fieldName,
                sortAscending: pageRequest.sortCriterias[0].sortAscending
            };
            var pageRequestString = JSON.stringify(pageRequestObject);
            localStorage.removeItem("contactFormRequest_" + this.companyId);
            localStorage.setItem("contactFormRequest_" + this.companyId, pageRequestString);
        }
    }, {
        key: "errorDuplicateForm",
        value: function errorDuplicateForm(error) {
            var errorTitle = error.errorTitle,
                errorMessage = error.errorMessage;

            this.messageService.showErrorFromBackend(errorTitle, errorMessage);
        }
    }, {
        key: "onSubscriptionPaid",
        value: function onSubscriptionPaid() {
            var _this5 = this;

            this.subscriptionPaidEvent = this.renderer.listen('document', subscription_model_1.CommunicationEvents.planCheckoutClose, function (data) {
                return _this5.successPaymentProcessed(data.detail.data);
            });
        }
    }, {
        key: "successPaymentProcessed",
        value: function successPaymentProcessed(data) {
            var needToConfirmPayment = data.data.actions.COMPLETE_PAYMENT;
            if (!needToConfirmPayment) {
                this.getContactFormPreviews();
            }
        }
    }]);

    return ContactFormSectionComponent;
}();
ContactFormSectionComponent = __decorate([core_1.Component({
    selector: 'contact-form-section',
    template: __webpack_require__("./web/modern/components/settings/contact-form-section/contact-form-section.html"),
    styles: [__webpack_require__("./web/modern/components/settings/contact-form-section/contact-form-section.scss")]
}), __metadata("design:paramtypes", [snModal_service_1.SNModalService, settings_data_service_1.SettingsDataService, account_service_1.AccountServiceWebProvider, subscription_service_1.NewSubscriptionServiceDataProvider, message_service_1.MessageService, core_1.Renderer2])], ContactFormSectionComponent);
exports.ContactFormSectionComponent = ContactFormSectionComponent;

/***/ }),

/***/ "./web/modern/components/settings/customize-labels/customize-labels.html":
/***/ (function(module, exports) {

module.exports = "<section>\n  <div class=\"bc-wrap\">\n    <div class=\"flex-box flex-align-center flex-just-space\">\n      <setting-section-header [breadcrumbs]=\"breadcrumbs\"></setting-section-header>\n    </div>\n  </div>\n\n  <div class=\"mt-30\">\n    <h3 class=\"mt-15 text-normal\">Rename the following labels throughout Studio Ninja.</h3>\n  </div>\n\n  <collapse-panel *ngFor=\"let form of languageData; let i = index\" [title]=\"form?.language?.displayName || 'Language'\"\n    [noCollapsing]=\"languageData.length < 2\">\n    <form (ngSubmit)=\"saveData(i)\"\n          class=\"form content-container mt-15\"\n          [ngClass]=\"{\n            'ml-0': languageData.length < 2,\n            'mr-0': languageData.length < 2\n          }\"\n    >\n      <p [innerHTML]=\"form.introductionHTML\"></p>\n      <div *ngFor=\"let field of form.customLabels\" class=\"label-wrapper pb-20\">\n        <div class=\"label-item mr-md-10\">\n          <h4><b [innerHTML]=\"field.label\"></b></h4>\n          <label class=\"label-item-grow\" [innerHTML]=\"field.descriptionHTML\"></label>\n          <input type=\"text\" class=\"form-control\" [id]=\"field.fieldName\" [name]=\"field.label\"\n            [placeholder]=\"field.label\" [maxlength]=\"field?.widgetProperties?.maxLength || '15'\" [(ngModel)]=\"field.value\" required />\n          <label class=\"labels-counter text-right\">{{field?.value?.length}}/{{ field?.widgetProperties?.maxLength || 15 }}</label>\n        </div>\n      </div>\n\n      <div class=\"button-wrapper mb-40\">\n        <button [disabled]=\"disabledButtons[i]\" class=\"btn btn-success btn-submit\" spinning-wheel\n          [is-spinning-wheel-active]=\"disabledButtons[i]\">\n           {{form?.actions?.SAVE_LABELS?.actionName}}\n        </button>\n      </div>\n    </form>\n  </collapse-panel>\n</section>\n"

/***/ }),

/***/ "./web/modern/components/settings/customize-labels/customize-labels.scss":
/***/ (function(module, exports) {

module.exports = "@media (min-width: 992px) {\n  .mr-md-10 {\n    margin-right: 10px; }\n  .ml-md-10 {\n    margin-left: 10px; } }\n\n.content-container {\n  margin-left: 15px;\n  margin-right: 15px;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-wrap: wrap;\n      -ms-flex-wrap: wrap;\n          flex-wrap: wrap; }\n  .content-container .label-row, .content-container .label-wrapper {\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex; }\n  .content-container .label-wrapper {\n    width: 50%; }\n  .content-container .label-item {\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: column;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    width: 100%; }\n    .content-container .label-item-grow {\n      -webkit-box-flex: 1;\n      -webkit-flex-grow: 1;\n          -ms-flex-positive: 1;\n              flex-grow: 1; }\n    .content-container .label-item .labels-counter {\n      color: #4e5e6a;\n      opacity: 0.5;\n      font-size: 10px; }\n  @media screen and (max-width: 991px) {\n    .content-container {\n      margin-left: 0;\n      margin-right: 0; }\n      .content-container .label-row {\n        -webkit-box-orient: vertical;\n        -webkit-box-direction: normal;\n        -webkit-flex-direction: column;\n            -ms-flex-direction: column;\n                flex-direction: column; }\n      .content-container .label-wrapper {\n        width: 100%; } }\n  .content-container .button-wrapper,\n  .content-container p {\n    -webkit-box-flex: 0;\n    -webkit-flex: none;\n        -ms-flex: none;\n            flex: none;\n    width: 100%; }\n"

/***/ }),

/***/ "./web/modern/components/settings/customize-labels/customize-labels.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var language_data_service_1 = __webpack_require__("./shared/services/language/language.data.service.ts");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var settings_1 = __webpack_require__("./shared/services/settings/settings.ts");
var CustomizeLabelsComponent = function () {
    function CustomizeLabelsComponent(settingsService, messageService, languageService) {
        _classCallCheck(this, CustomizeLabelsComponent);

        this.settingsService = settingsService;
        this.messageService = messageService;
        this.languageService = languageService;
        this.onLabelsDataChange = new core_1.EventEmitter();
        this.disabledButtons = [];
        this.unsubscribe = new Subject_1.Subject();
        this.initialData = [];
        this.languageData = [];
        this.breadcrumbs = [{ link: '/', title: 'Dashboard' }, { link: '/settings', title: 'Settings' }, { link: null, title: 'Labels' }];
    }

    _createClass(CustomizeLabelsComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            var _this = this;

            this.languageService.getLabels().subscribe(function (data) {
                _this.languageData = data.data;
                _this.initialData = JSON.parse(JSON.stringify(_this.languageData));
                _this.disabledButtons = new Array(_this.languageData.length).fill(false);
            });
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "saveData",
        value: function saveData(index) {
            var _this2 = this;

            var _languageData$index = this.languageData[index],
                _languageData$index$l = _languageData$index.language;
            _languageData$index$l = _languageData$index$l === undefined ? {} : _languageData$index$l;
            var _languageData$index$l2 = _languageData$index$l.name,
                name = _languageData$index$l2 === undefined ? '' : _languageData$index$l2,
                _languageData$index$c = _languageData$index.customLabels,
                customLabels = _languageData$index$c === undefined ? [] : _languageData$index$c,
                url = _languageData$index.actions.SAVE_LABELS.url;

            var dataToSave = {
                language: name,
                customLabelsData: customLabels.map(function (_ref) {
                    var fieldName = _ref.fieldName,
                        value = _ref.value;
                    return {
                        fieldName: fieldName,
                        value: value
                    };
                })
            };
            if (this.isDataValid(dataToSave.customLabelsData)) {
                this.disabledButtons[index] = true;
                this.languageService.updateLabels(url, dataToSave).pipe(operators_1.takeUntil(this.unsubscribe), operators_1.finalize(function () {
                    return _this2.disabledButtons[index] = false;
                })).subscribe(function () {
                    return _this2.successDataChange(dataToSave);
                }, function () {
                    return _this2.messageService.showToaster('e_0', 'general');
                });
            }
        }
    }, {
        key: "successDataChange",
        value: function successDataChange(_ref2) {
            var language = _ref2.language,
                customLabelsData = _ref2.customLabelsData;

            // probably will be deleted/changed later
            if (language === 'ENGLISH') {
                var setLangs = customLabelsData.reduce(function (acc, curr) {
                    return Object.assign({}, acc, _defineProperty({}, curr.fieldName, curr.value));
                }, {});
                this.settingsService.setCustomizeLabels(setLangs);
            }
            this.onLabelsDataChange.emit();
            this.messageService.showToaster('s_0', 'customizeLabels');
        }
    }, {
        key: "isDataValid",
        value: function isDataValid(fields) {
            var spaceError = false;
            var inValid = fields.some(function (el) {
                if (el.fieldName === 'shootsLabel') {
                    if (/\s/.test(el.value)) {
                        spaceError = true;
                    }
                }
                return !el.value || !el.value.trim();
            });
            if (inValid) {
                this.messageService.showToaster('e_0', 'customizeLabels');
                return false;
            }
            if (spaceError) {
                this.messageService.showToaster('e_1', 'customizeLabels');
                return false;
            }
            return true;
        }
    }]);

    return CustomizeLabelsComponent;
}();
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], CustomizeLabelsComponent.prototype, "onLabelsDataChange", void 0);
CustomizeLabelsComponent = __decorate([core_1.Component({
    selector: 'customize-labels',
    template: __webpack_require__("./web/modern/components/settings/customize-labels/customize-labels.html"),
    styles: [__webpack_require__("./web/modern/components/settings/customize-labels/customize-labels.scss")]
}), __metadata("design:paramtypes", [settings_1.SettingsProvider, message_service_1.MessageService, language_data_service_1.LanguageDataProvider])], CustomizeLabelsComponent);
exports.CustomizeLabelsComponent = CustomizeLabelsComponent;

/***/ }),

/***/ "./web/modern/components/settings/date-time-calendar/confirm-re-sync-modal/confirm-re-sync-modal.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n    <button class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" (click)=\"onDismiss()\">&times;</button>\n    <h3 class=\"modal-title f-w-n\">Synchronize with google calendar!</h3>\n</div>\n<div class=\"modal-body\">\n    <form class=\"form-horizontal mt-20\" role=\"form\" (submit)=\"onSubmit()\">\n        <h3>All calendar events will recreate in Google Calendar!</h3>\n        <div class=\"pt-25\">\n            <button type=\"submit\" class=\"btn btn-lg btn-danger mb-0 mr-10\" spinning-wheel [is-spinning-wheel-active]=\"btnDisabled\" [disabled]=\"btnDisabled\">Synchronize</button>\n            <button (click)=\"onDismiss()\" [disabled]=\"btnDisabled\" class=\"btn btn-lg btn-default mb-0\" data-dismiss=\"modal\" type=\"button\">Cancel</button>\n        </div>\n    </form>\n</div>\n"

/***/ }),

/***/ "./web/modern/components/settings/date-time-calendar/confirm-re-sync-modal/confirm-re-sync-modal.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var ng_bootstrap_1 = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/index.js");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var ConfirmReSyncModal = function () {
    function ConfirmReSyncModal(activeModal, modalService) {
        _classCallCheck(this, ConfirmReSyncModal);

        this.activeModal = activeModal;
        this.modalService = modalService;
    }

    _createClass(ConfirmReSyncModal, [{
        key: "onSubmit",
        value: function onSubmit() {
            this.btnDisabled = true;
            this.modalService.setModalData(true);
        }
    }, {
        key: "onDismiss",
        value: function onDismiss() {
            this.activeModal.dismiss();
        }
    }]);

    return ConfirmReSyncModal;
}();
ConfirmReSyncModal = __decorate([core_1.Component({
    selector: 'confirm-re-sync-modal',
    template: __webpack_require__("./web/modern/components/settings/date-time-calendar/confirm-re-sync-modal/confirm-re-sync-modal.html"),
    changeDetection: core_1.ChangeDetectionStrategy.OnPush
}), __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal, snModal_service_1.SNModalService])], ConfirmReSyncModal);
exports.ConfirmReSyncModal = ConfirmReSyncModal;

/***/ }),

/***/ "./web/modern/components/settings/date-time-calendar/date-time-calendar.html":
/***/ (function(module, exports) {

module.exports = "<section>\n    <div class=\"bc-wrap\">\n        <div class=\"flex-box flex-align-center flex-just-space\">\n            <setting-section-header [breadcrumbs]=\"breadcrumbs\"></setting-section-header>\n        </div>\n    </div>\n\n    <div class=\"m-30\">\n        <h3 class=\"mb-15\">Calendar Integration</h3>\n        <h3 class=\"mt-15 text-normal\">Sync your Google Calendar with Studio Ninja so you have all your appointments in one place.</h3>\n    </div>\n\n    <div class=\"m-30\">\n        <button [disabled]=\"lockIntegration\"\n                *ngIf=\"!activatedCalendar\"\n                (click)=\"calendarIntegrationStart()\"\n                class=\"btn btn-success btn-lg\"\n                spinning-wheel\n                [is-spinning-wheel-active]=\"isGoogleIntegrationActive\">\n            Integrate with google calendar\n        </button>\n        <button  *ngIf=\"activatedCalendar\"\n                 [disabled]=\"lockIntegration\"\n                 class=\"btn btn-default btn-lg\"\n                 (click)=\"disconnectGoogle()\"\n                 spinning-wheel\n                 [is-spinning-wheel-dark]=\"'true'\"\n                 [is-spinning-wheel-active]=\"isGoogleDisconnectionActive\">\n            <i class=\"fi fi-disconnect\"></i>\n            Disconnect\n        </button>\n        <button [disabled]=\"lockIntegration || (!lockIntegration && !activatedCalendar)\"\n                (click)=\"showSynchronize()\"\n                class=\"btn btn-lg ml-20 btn-default\"\n                spinning-wheel\n                [is-spinning-wheel-dark]=\"'true'\"\n                [is-spinning-wheel-active]=\"isGoogleSynchronizationActive\">\n            <i class=\"fi fi-resync\"></i>\n            Re-sync\n        </button>\n    </div>\n\n    <hr>\n\n\n    <div class=\"m-30\">\n        <h3 class=\"mb-15\">Date, Time & Calendar Settings</h3>\n        <h3 class=\"mt-15 text-normal\">Choose your timezone, as well as your calendar, date and time format preferences.</h3>\n\n        <form class=\"mb-30\" role=\"form\" [formGroup]=\"dateTimeForm\" (ngSubmit)=\"saveCalendarSettings()\">\n            <div class=\"form-group flex-row flex-wrap-xs mb-25 timezone-section\">\n                <label for=\"timezone\" class=\"timezone-label col-sm-12 col-sm-3 f-s-15 text-right\">Timezone</label>\n                <div class=\"col-xs-12 col-sm-9 p-0 mb-10 timezone-dropdown\">\n                    <div class=\"select-style\">\n                        <select id=\"timezone\" formControlName=\"timeZone\">\n                            <option value=\"\" class=\"hide\">Choose Timezone</option>\n                            <option *ngFor=\"let timeZone of timeZones\" [ngValue]=\"timeZone.name\">{{ timeZone | timeZoneFilter }}</option>\n                        </select>\n                    </div>\n                </div>\n            </div>\n            <div class=\"row\">\n                <div class=\"option_group\">\n                    <div class=\"option_group__label mr-18\">\n                        <p class=\"text-right f-s-15 lh\">Week starts on</p>\n                    </div>\n                    <div class=\"option_group__radios\">\n                        <div class=\"option_group__radio mb-12\">\n                            <div class=\"styled-input-radio ml-0 pl-30\">\n                                <input type=\"radio\" id=\"0\"  formControlName=\"weekStartsOn\" [value]=\"'MONDAY'\">\n                                <label for=\"0\"></label>\n                            </div>\n                            <span class=\"f-s-14\">Monday</span>\n                        </div>\n                        <div class=\"option_group__radio mb-12\">\n                            <div class=\"styled-input-radio ml-0 pl-30\">\n                                <input type=\"radio\" id=\"1\" formControlName=\"weekStartsOn\"  [value]=\"'SATURDAY'\">\n                                <label for=\"1\"></label>\n                            </div>\n                            <span class=\"f-s-14\">Saturday</span>\n                        </div>\n                        <div class=\"option_group__radio mb-12\">\n                            <div class=\"styled-input-radio ml-0 pl-30\">\n                                <input type=\"radio\" id=\"2\" formControlName=\"weekStartsOn\" [value]=\"'SUNDAY'\">\n                                <label for=\"2\"></label>\n                            </div>\n                            <span class=\"f-s-14\">Sunday</span>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"option_group mt-25\">\n                    <div class=\"option_group__label mr-18\">\n                        <p class=\"text-right f-s-15 lh\">Date format</p>\n                    </div>\n                    <div class=\"option_group__radios\">\n                        <div class=\"option_group__radio mb-12\">\n                            <div class=\"styled-input-radio ml-0 pl-30\">\n                                <input type=\"radio\" id=\"3\" formControlName=\"dateFormat\" [value]=\"'DD_MM_YYYY'\">\n                                <label for=\"3\"></label>\n                            </div>\n                            <span class=\"f-s-14\">DD/MM/YY</span>\n                        </div>\n                        <div class=\"option_group__radio mb-12\">\n                            <div class=\"styled-input-radio ml-0 pl-30\">\n                                <input type=\"radio\" id=\"4\" formControlName=\"dateFormat\" [value]=\"'MM_DD_YYYY'\">\n                                <label for=\"4\"></label>\n                            </div>\n                            <span class=\"f-s-14\">MM/DD/YY</span>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"option_group mt-25\">\n                    <div class=\"option_group__label mr-18\">\n                        <p class=\"text-right f-s-15 lh\">Time format</p>\n                    </div>\n                    <div class=\"option_group__radios\">\n                        <div class=\"option_group__radio mb-12\">\n                            <div class=\"styled-input-radio ml-0 pl-30\">\n                                <input type=\"radio\" id=\"5\"  formControlName=\"timeFormat\" [value]=\"'T_12'\">\n                                <label for=\"5\"></label>\n                            </div>\n                            <span class=\"f-s-14\">12 hour (e.g. 5:00pm)</span>\n                        </div>\n                        <div class=\"option_group__radio mb-12\">\n                            <div class=\"styled-input-radio ml-0 pl-30\">\n                                <input type=\"radio\" id=\"6\" formControlName=\"timeFormat\" [value]=\"'T_24'\">\n                                <label for=\"6\"></label>\n                            </div>\n                            <span class=\"f-s-14\">24 hour (e.g. 17:00)</span>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <button type=\"submit\"\n                    class=\"btn btn-success btn-lg mt-30\"\n                    spinning-wheel\n                    [is-spinning-wheel-active]=\"isCalendarSettingsSaveActive\">Save Calendar Preferences\n            </button>\n        </form>\n    </div>\n\n</section>\n"

/***/ }),

/***/ "./web/modern/components/settings/date-time-calendar/date-time-calendar.scss":
/***/ (function(module, exports) {

module.exports = ".timezone-section {\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center; }\n  .timezone-section .timezone-label {\n    max-width: 125px; }\n  .timezone-section .timezone-dropdown {\n    max-width: 400px; }\n"

/***/ }),

/***/ "./web/modern/components/settings/date-time-calendar/date-time-calendar.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var settings_1 = __webpack_require__("./shared/services/settings/settings.ts");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var rxjs_1 = __webpack_require__("./node_modules/rxjs/Rx.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var calendar_integration_service_1 = __webpack_require__("./shared/services/calendar-integration/calendar-integration.service.ts");
var common_1 = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var confirm_re_sync_modal_1 = __webpack_require__("./web/modern/components/settings/date-time-calendar/confirm-re-sync-modal/confirm-re-sync-modal.ts");
var forms_1 = __webpack_require__("./node_modules/@angular/forms/esm5/forms.js");
var DateTimeCalendarComponent = function () {
    function DateTimeCalendarComponent(settingsService, messageService, calendarIntegrationService, location, modalService) {
        _classCallCheck(this, DateTimeCalendarComponent);

        this.settingsService = settingsService;
        this.messageService = messageService;
        this.calendarIntegrationService = calendarIntegrationService;
        this.location = location;
        this.modalService = modalService;
        this.activationGoogleCode = null;
        this.lockIntegration = false;
        this.activatedCalendar = false;
        this.isGoogleSynchronizationActive = false;
        this.isGoogleIntegrationActive = false;
        this.isGoogleDisconnectionActive = false;
        this.isCalendarSettingsSaveActive = false;
        this.unsubscribe = new rxjs_1.Subject();
        this.breadcrumbs = [{ link: '/', title: 'Dashboard' }, { link: '/settings', title: 'Settings' }, { link: null, title: 'Date, Time & Calendar' }];
        this.dateTimeForm = new forms_1.FormGroup({
            weekStartsOn: new forms_1.FormControl('', forms_1.Validators.required),
            dateFormat: new forms_1.FormControl('', forms_1.Validators.required),
            timeFormat: new forms_1.FormControl('', forms_1.Validators.required),
            timeZone: new forms_1.FormControl('', forms_1.Validators.required)
        });
    }

    _createClass(DateTimeCalendarComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.subscribeToActivationCode();
            this.subscribeToIntegrationChanges();
            this.subscribeToIntegrationStatus();
            this.integrateGoogleCalendar();
            this.initCalendarSettings();
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "calendarIntegrationStart",
        value: function calendarIntegrationStart() {
            var _this = this;

            this.calendarIntegrationService.setLookGoogleIntegration('integrate');
            this.calendarIntegrationService.connectGoogleCalendar().subscribe(function (_ref) {
                var message = _ref.message;

                window.location.assign(message);
            }, function () {
                _this.handleCalendarIntegrationError();
            });
        }
    }, {
        key: "disconnectGoogle",
        value: function disconnectGoogle() {
            var _this2 = this;

            this.calendarIntegrationService.setLookGoogleIntegration('disconnect');
            this.calendarIntegrationService.disconnectGoogleCalendar().subscribe(function () {
                _this2.messageService.showToaster('s_2', 'googleCalendar');
            }, function () {
                _this2.handleCalendarIntegrationError();
            }, function () {
                _this2.calendarIntegrationService.stopCalendarInterval();
                _this2.handleCalendarIntegrationError();
            });
        }
    }, {
        key: "showSynchronize",
        value: function showSynchronize() {
            var _this3 = this;

            this.reSyncModal = this.modalService.openModal(confirm_re_sync_modal_1.ConfirmReSyncModal);
            this.modalService.getModalData().filter(function (data) {
                return !!data;
            }).take(1).subscribe(function () {
                return _this3.synchronize();
            });
        }
    }, {
        key: "saveCalendarSettings",
        value: function saveCalendarSettings() {
            var _this4 = this;

            this.isCalendarSettingsSaveActive = true;
            this.settingsService.updateDateTimeSettings(this.actions.SAVE_DATE_TIME_SETTINGS.url, this.dateTimeForm.value).subscribe(function () {
                _this4.settingsService.getSettingsRequest().pipe(operators_1.takeUntil(_this4.unsubscribe)).subscribe();
                _this4.messageService.showToaster('s_0', 'calendar');
            }, function (error) {
                _this4.messageService.showToaster('e_0', 'general', error.error);
            }, function () {
                _this4.isCalendarSettingsSaveActive = false;
            });
        }
    }, {
        key: "synchronize",
        value: function synchronize() {
            var _this5 = this;

            this.calendarIntegrationService.setLookGoogleIntegration('synchronize');
            this.calendarIntegrationService.synchronizeGoogleCalendar().subscribe(function () {
                _this5.checkResultCalendarSynchronize();
            }, function () {
                _this5.handleCalendarIntegrationError();
            });
        }
    }, {
        key: "initCalendarSettings",
        value: function initCalendarSettings() {
            var _this6 = this;

            this.settingsService.getDateTimeSettingsV1().subscribe(function (_ref2) {
                var data = _ref2.data;

                _this6.createDateTimeForm(data);
            });
        }
    }, {
        key: "createDateTimeForm",
        value: function createDateTimeForm(data) {
            this.timeZones = data.availableTimeZones;
            this.actions = data.actions;
            this.dateTimeForm.patchValue(Object.assign({}, data, { timeZone: data.timeZone.name }));
        }
    }, {
        key: "integrateGoogleCalendar",
        value: function integrateGoogleCalendar() {
            var url = new URL(window.location.href);
            var googleCode = url.searchParams.get('code');
            if (googleCode !== null) {
                if (this.activationGoogleCode !== googleCode) {
                    this.calendarIntegrationService.setGoogleActivationCode(googleCode);
                    this.calendarIntegrationService.setLookGoogleIntegration('integrate');
                    this.messageService.showToaster('i_0', 'googleCalendar');
                    this.save(googleCode);
                }
            } else {
                this.calendarIntegrationService.setGoogleActivationCode(null);
                this.getActivatedCalendar();
            }
        }
    }, {
        key: "subscribeToActivationCode",
        value: function subscribeToActivationCode() {
            var _this7 = this;

            this.calendarIntegrationService.getGoogleActivationCode.pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (code) {
                return _this7.activationGoogleCode = code;
            });
        }
    }, {
        key: "subscribeToIntegrationChanges",
        value: function subscribeToIntegrationChanges() {
            var _this8 = this;

            this.calendarIntegrationService.getLookGoogleIntegration.pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (data) {
                _this8.lockIntegration = data !== 'disable';
                _this8.isGoogleIntegrationActive = data === 'integrate';
                _this8.isGoogleSynchronizationActive = data === 'synchronize';
                _this8.isGoogleDisconnectionActive = data === 'disconnect';
            });
        }
    }, {
        key: "subscribeToIntegrationStatus",
        value: function subscribeToIntegrationStatus() {
            var _this9 = this;

            this.calendarIntegrationService.getIsIntegrated.pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (data) {
                return _this9.activatedCalendar = data;
            });
        }
    }, {
        key: "getActivatedCalendar",
        value: function getActivatedCalendar() {
            var _this10 = this;

            this.calendarIntegrationService.getActivatedCalendar().subscribe(function (_ref3) {
                var data = _ref3.data;

                if (data.state === 'INTEGRATED') {
                    _this10.calendarIntegrationService.setIsIntegrated(true);
                    if (!_this10.isGoogleDisconnectionActive) {
                        _this10.calendarIntegrationService.setLookGoogleIntegration('disable');
                    }
                    _this10.calendarIntegrationService.stopCalendarInterval();
                } else if (data.state === 'SYNCHRONIZATION') {
                    _this10.calendarIntegrationService.setIsIntegrated(true);
                    if (!_this10.isGoogleSynchronizationActive) {
                        _this10.checkResultCalendarIntegration();
                    }
                    _this10.calendarIntegrationService.setLookGoogleIntegration('synchronize');
                } else {
                    _this10.calendarIntegrationService.setIsIntegrated(false);
                    _this10.calendarIntegrationService.setLookGoogleIntegration('disable');
                }
            }, function () {
                _this10.handleCalendarIntegrationError();
            });
        }
    }, {
        key: "handleCalendarIntegrationError",
        value: function handleCalendarIntegrationError() {
            this.calendarIntegrationService.setIsIntegrated(false);
            this.calendarIntegrationService.setLookGoogleIntegration('disable');
            this.removeParamsFromUrl();
        }
    }, {
        key: "removeParamsFromUrl",
        value: function removeParamsFromUrl() {
            this.location.go(window.location.pathname);
        }
    }, {
        key: "save",
        value: function save(code) {
            var _this11 = this;

            this.calendarIntegrationService.updateGoogleCalendarStatus(code).subscribe(function () {
                _this11.checkResultCalendarIntegration();
            }, function () {
                _this11.handleCalendarIntegrationError();
            });
        }
    }, {
        key: "checkResultCalendarIntegration",
        value: function checkResultCalendarIntegration() {
            var _this12 = this;

            this.calendarIntegrationService.setLookGoogleIntegration('integrate');
            this.calendarIntegrationService.startCalendarinterval();
            this.calendarIntegrationService.calendarInterval().subscribe(function (_ref4) {
                var data = _ref4.data;

                if (data.state === 'INTEGRATED') {
                    _this12.calendarIntegrationService.stopCalendarInterval();
                }
            }, function () {
                _this12.handleCalendarIntegrationError();
            }, function () {
                _this12.completeCalendarIntegration();
            });
        }
    }, {
        key: "completeCalendarIntegration",
        value: function completeCalendarIntegration() {
            this.calendarIntegrationService.setLookGoogleIntegration('disable');
            this.calendarIntegrationService.setIsIntegrated(true);
            this.messageService.showToaster('s_1', 'googleCalendar');
            this.removeParamsFromUrl();
        }
    }, {
        key: "checkResultCalendarSynchronize",
        value: function checkResultCalendarSynchronize() {
            var _this13 = this;

            this.calendarIntegrationService.startCalendarinterval();
            this.calendarIntegrationService.calendarInterval().subscribe(function (_ref5) {
                var data = _ref5.data;

                if (data.state === 'INTEGRATED') {
                    _this13.calendarIntegrationService.stopCalendarInterval();
                }
            }, function () {
                _this13.handleCalendarIntegrationError();
            }, function () {
                _this13.reSyncModal.close();
                _this13.calendarIntegrationService.setLookGoogleIntegration('disable');
                _this13.messageService.showToaster('s_1', 'googleCalendar');
                _this13.removeParamsFromUrl();
            });
        }
    }]);

    return DateTimeCalendarComponent;
}();
DateTimeCalendarComponent = __decorate([core_1.Component({
    selector: 'date-time-calendar',
    template: __webpack_require__("./web/modern/components/settings/date-time-calendar/date-time-calendar.html"),
    styles: [__webpack_require__("./web/modern/components/settings/date-time-calendar/date-time-calendar.scss")]
}), __metadata("design:paramtypes", [settings_1.SettingsProvider, message_service_1.MessageService, calendar_integration_service_1.CalendarIntegrationProvider, common_1.Location, snModal_service_1.SNModalService])], DateTimeCalendarComponent);
exports.DateTimeCalendarComponent = DateTimeCalendarComponent;

/***/ }),

/***/ "./web/modern/components/settings/edit-company-section/edit-company-section.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"bc-wrap\">\n    <div class=\"flex-box flex-align-center flex-just-space\">\n        <setting-section-header [breadcrumbs]=\"breadcrumbs\"></setting-section-header>\n    </div>\n</div>\n\n<div *ngIf=\"brandDetails\" class=\"col-xs-12 company-section pl-0 pr-0\">\n    <div class=\"form-section\">\n        <setting-section-description\n                [text]=\"'Your company details below will appear on your quotes, invoices and contracts. They are also visible to your clients in the Client Portal'\">\n        </setting-section-description>\n\n        <form (ngSubmit)=\"saveCompanyInfo()\" *ngIf=\"editCompanyForm\" [formGroup]=\"editCompanyForm\" class=\"mt-30\" role=\"form\">\n            <div *ngFor=\"let input of editBrandsInput\">\n                <div class=\"mb-20\">\n                    <label [attr.for]=\"input.formControlName\" class=\"f-w-n\">{{ input.name }}</label>\n                    <input [attr.type]=\"input.type\"\n                           [formControlName]=\"input.formControlName\"\n                           [id]=\"input.formControlName\"\n                           [maxLength]=\"150\"\n                           [placeholder]=\"input.placeholder\"\n                           class=\"form-control flex-row\">\n                </div>\n            </div>\n\n            <div *ngIf=\"brandDetails?.brandInfo?.actions?.UPDATE_BRAND_DATA\" class=\"mt-30\">\n                <button [disabled]=\"btnDisable\" [is-spinning-wheel-active]=\"btnDisable\" class=\"btn btn-success btn-lg\" spinning-wheel type=\"submit\">Save Company Details</button>\n            </div>\n        </form>\n    </div>\n    <div class=\"media-section\">\n\n        <div class=\"media-section-item\">\n            <div class=\"item-text\">\n                <h4 class=\"mt-0\">GDPR Features</h4>\n                <p>\n                    Enable if you have clients in the European Union. GDPR features will give you the ability to add opt-in\n                    consent checkboxes to your Contact Form, Contract Templates and Questionnaire Templates\n                </p>\n            </div>\n            <div class=\"item-media item-gdpr\">\n                <sn-toggle (toggleChanged)=\"onGdprChanged($event)\" [enabled]=\"gdprChecked\" [id]=\"'companyGDPR'\"></sn-toggle>\n            </div>\n        </div>\n\n        <div class=\"media-section-item\">\n            <media-drop-zone\n                    [description]=\"'Your logo must be at least 300px on the shortest side. Ideal size is 900px by 450px (RGB). Acceptable file formats are JPG and PNG. Max file size 2mb.'\"\n                    [inputFile]=\"logoImage\"\n                    [mediaConfig]=\"{maxFileSize: 2, id: mediaIds.CompanyLogo}\"\n                    [styles]=\"{'height': '150px', 'min-width': '150px', 'max-width': '150px'}\"\n                    (onDropEventSuccess)=\"saveMedia($event)\"\n                    (onRemoveEvent)=\"deleteMedia($event)\"\n                    [actions]=\"brandDetails.logo.actions\"\n                    [title]=\"'Logo'\">\n            </media-drop-zone>\n        </div>\n\n        <div class=\"media-section-item\">\n            <media-drop-zone\n                    [description]=\"'Your banner size is 1540px by 300px. Acceptable file formats are JPG and PNG. max file size 5mb.'\"\n                    [inputFile]=\"bannerImage\"\n                    [mediaConfig]=\"{maxFileSize: 5, id: mediaIds.CompanyBanner}\"\n                    [styles]=\"{'height': '150px', 'min-width': '300px', 'max-width': '300px'}\"\n                    (onDropEventSuccess)=\"saveMedia($event)\"\n                    (onRemoveEvent)=\"deleteMedia($event)\"\n                    [actions]=\"brandDetails.clientPortalBanner.actions\"\n                    [title]=\"'Client Portal Banner'\">\n            </media-drop-zone>\n        </div>\n        <div *ngIf=\"dropdownList?.length > 0\" class=\"media-section-item-for-languages\">\n            <div class=\"item-text\">\n                <h4 class=\"mt-0\">Client Portal Languages</h4>\n                <p>\n                    The Client Portal is where your clients view your quotes, invoices, contracts and questionnaires. Choose the languages that the Client Portal will display in.\n                </p>\n                <angular2-multiselect [data]=\"dropdownList\" [(ngModel)]=\"selectedItems\"\n                                      [settings]=\"dropdownSettings\"\n                                      (onDeSelect)=\"OnItemDeSelect($event)\"\n                                      (onSelect)=\"OnItemSelect()\"\n                ></angular2-multiselect>\n\n                <div class=\"mt-30\" *ngIf=\"selectedItems?.length > 1\">\n                    <p>Default Client Portal Language</p>\n                    <div class=\"select-style\">\n                    <select [(ngModel)]=\"defaultLanguageItem.id\">\n                        <option [ngValue]=\"null\" [selected]=\"true\" [hidden]=\"true\">Select Default Language</option>\n                        <option [value]=\"item?.id\" *ngFor=\"let item of selectedItems\">{{ item.itemName }}</option>\n                    </select>\n                        </div>\n                    </div>\n                <div class=\"mt-30\">\n                    <button (click)=\"prepareLanguagesDataToSave()\"\n                            [disabled]=\"btnLanguageDisable\"\n                            [is-spinning-wheel-active]=\"btnLanguageDisable\"\n                            class=\"btn btn-success btn-lg\" spinning-wheel type=\"submit\">Save Languages</button>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "./web/modern/components/settings/edit-company-section/edit-company-section.scss":
/***/ (function(module, exports) {

module.exports = ".company-section {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: row;\n      -ms-flex-direction: row;\n          flex-direction: row; }\n  .company-section .form-section {\n    -webkit-box-ordinal-group: 2;\n    -webkit-order: 1;\n        -ms-flex-order: 1;\n            order: 1; }\n  .company-section .media-section {\n    padding-left: 30px;\n    -webkit-box-ordinal-group: 3;\n    -webkit-order: 2;\n        -ms-flex-order: 2;\n            order: 2; }\n    .company-section .media-section-item, .company-section .media-section-item-for-languages {\n      display: -webkit-box;\n      display: -webkit-flex;\n      display: -ms-flexbox;\n      display: flex;\n      border-bottom: 1px solid #7c7c7c;\n      padding: 20px 0;\n      border-bottom: 1px solid #ececec; }\n    .company-section .media-section .media-section-item-for-languages .select-style {\n      height: 36px;\n      border-color: #dce1e4 !important;\n      background-position: -webkit-calc(100% - 10px) 50%;\n      background-position: calc(100% - 10px) 50%; }\n  @media screen and (max-width: 1200px) {\n    .company-section {\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n      -webkit-flex-direction: column;\n          -ms-flex-direction: column;\n              flex-direction: column; }\n      .company-section .media-section {\n        padding-left: 0;\n        -webkit-box-ordinal-group: 1;\n        -webkit-order: 0;\n            -ms-flex-order: 0;\n                order: 0; } }\n  @media screen and (min-width: 1201px) {\n    .company-section .media-section-item-for-languages {\n      border-bottom: none; } }\n"

/***/ }),

/***/ "./web/modern/components/settings/edit-company-section/edit-company-section.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var models_1 = __webpack_require__("./shared/models/models.ts");
var brands_service_1 = __webpack_require__("./shared/services/brands/brands.service.ts");
var common_1 = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
var forms_1 = __webpack_require__("./node_modules/@angular/forms/esm5/forms.js");
var brands_model_1 = __webpack_require__("./shared/models/brands.model.ts");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var gdpr_disable_modal_1 = __webpack_require__("./web/modern/components/brands/modals/gdpr-disable-modal/gdpr-disable-modal.ts");
var brands_data_service_1 = __webpack_require__("./shared/services/brands/brands.data.service.ts");
var rxjs_1 = __webpack_require__("./node_modules/rxjs/Rx.js");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var of_1 = __webpack_require__("./node_modules/rxjs/observable/of.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var settings_overview_data_service_1 = __webpack_require__("./shared/services/settings/settings-overview/settings-overview.data.service.ts");
var settings_1 = __webpack_require__("./shared/services/settings/settings.ts");
var language_data_service_1 = __webpack_require__("./shared/services/language/language.data.service.ts");
var save_languages_modal_1 = __webpack_require__("./web/modern/components/brands/modals/save-languages-modal/save-languages-modal.ts");
var EditCompanySectionComponent = function () {
    function EditCompanySectionComponent(brandsService, brandsDataService, languagesDataService, snModalService, fb, messageService, settingsOverviewService, settingsService, location) {
        _classCallCheck(this, EditCompanySectionComponent);

        this.brandsService = brandsService;
        this.brandsDataService = brandsDataService;
        this.languagesDataService = languagesDataService;
        this.snModalService = snModalService;
        this.fb = fb;
        this.messageService = messageService;
        this.settingsOverviewService = settingsOverviewService;
        this.settingsService = settingsService;
        this.location = location;
        this.breadcrumbs = [{ link: '/', title: 'Dashboard' }, { link: '/settings', title: 'Settings' }, { link: '/settings/companies', title: 'Companies' }, { link: null, title: 'Edit Company' }];
        this.editBrandsInput = JSON.parse(JSON.stringify(brands_model_1.BRAND_EDIT_FORM));
        this.gdprChecked = false;
        this.mediaIds = models_1.MediaFilesId;
        this.dropdownList = [];
        this.selectedItems = [];
        this.unsubscribe = new rxjs_1.Subject();
    }

    _createClass(EditCompanySectionComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.subscribeToCustomizeLabelsChange();
            this.getBrandInfo();
            this.getLanguagesData();
            this.setDropdownSettings();
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "updateFieldsLabels",
        value: function updateFieldsLabels(customizeLabels) {
            this.editBrandsInput.forEach(function (element) {
                if (element.formControlName === 'number') {
                    element.name = customizeLabels.businessNumberLabel;
                }
            });
        }
    }, {
        key: "onGdprChanged",
        value: function onGdprChanged(value) {
            var _this = this;

            if (!value) {
                this.snModalService.openModal(gdpr_disable_modal_1.GdprDisableModalComponent).result.then(function (disableAnyway) {
                    if (disableAnyway) {
                        _this.gdprChecked = !disableAnyway;
                        _this.updateGdprState(_this.brandDetails.gdprFeatures.actions.TURN_OFF_GDPR_FEATURES.url, !disableAnyway);
                        _this.messageService.showToaster('s_3', 'companyInformation');
                    }
                }).catch();
            } else {
                this.gdprChecked = value;
                this.updateGdprState(this.brandDetails.gdprFeatures.actions.TURN_ON_GDPR_FEATURES.url, value);
                this.messageService.showToaster('s_2', 'companyInformation');
            }
        }
    }, {
        key: "saveMedia",
        value: function saveMedia(data) {
            if (data.id === this.mediaIds.CompanyLogo) {
                this.updateMedia(this.brandDetails.logo.actions.UPDATE_BRAND_LOGO.url, data);
            }
            if (data.id === this.mediaIds.CompanyBanner) {
                this.updateMedia(this.brandDetails.clientPortalBanner.actions.UPDATE_BRAND_BANNER.url, data);
            }
        }
    }, {
        key: "saveCompanyInfo",
        value: function saveCompanyInfo() {
            var _this2 = this;

            if (this.editCompanyForm.valid) {
                this.btnDisable = true;
                this.brandsDataService.saveBrandDetailsInfo(this.brandDetails.brandInfo.actions.UPDATE_BRAND_DATA.url, this.editCompanyForm.value).pipe(operators_1.takeUntil(this.unsubscribe), operators_1.finalize(function () {
                    return _this2.btnDisable = false;
                })).subscribe(function () {
                    _this2.messageService.showToaster('s_0', 'companyInformation');
                    _this2.brandsDataService.getBrandsData();
                    _this2.settingsOverviewService.getSettingsOverviewItems().subscribe();
                });
            } else {
                this.brandsService.validateBrandFields(this.editCompanyForm.controls);
            }
        }
    }, {
        key: "OnItemSelect",
        value: function OnItemSelect() {
            this.selectedItems.sort(function (a, b) {
                return a.itemName.localeCompare(b.itemName);
            });
        }
    }, {
        key: "OnItemDeSelect",
        value: function OnItemDeSelect(item) {
            if (item.id === this.defaultLanguageItem.id) {
                this.defaultLanguageItem.id = null;
            }
        }
    }, {
        key: "prepareLanguagesDataToSave",
        value: function prepareLanguagesDataToSave() {
            var selectedItemsToSave = this.selectedItems.map(function (item) {
                return item.id;
            });
            var defaultLanguageNameToSave = this.defaultLanguageItem.id;
            if (selectedItemsToSave.length === 1) {
                defaultLanguageNameToSave = this.selectedItems[0].id;
            }
            var dataToSave = {
                selectedLanguages: selectedItemsToSave,
                defaultLanguage: defaultLanguageNameToSave
            };
            this.updateLanguages(dataToSave, defaultLanguageNameToSave);
        }
    }, {
        key: "getLanguagesData",
        value: function getLanguagesData() {
            var _this3 = this;

            this.languagesDataService.getLanguages().pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (data) {
                _this3.setLanguageData(data);
            });
        }
    }, {
        key: "setLanguageData",
        value: function setLanguageData(data) {
            if (!data) {
                return;
            }
            var initialData = JSON.parse(JSON.stringify(data.data));
            if (initialData) {
                this.dropdownList = initialData.availableLanguageList.map(function (item) {
                    return {
                        id: item.name,
                        itemName: item.displayName
                    };
                });
                this.selectedItems = initialData.selectedLanguages.map(function (item) {
                    return {
                        id: item.name,
                        itemName: item.displayName
                    };
                });
                this.getDefaultLanguageItem(initialData);
            }
        }
    }, {
        key: "getDefaultLanguageItem",
        value: function getDefaultLanguageItem(data) {
            var defaultItem = data.defaultLanguage;
            this.defaultLanguageItem = {
                id: defaultItem.name,
                itemName: defaultItem.displayName
            };
        }
    }, {
        key: "updateLanguages",
        value: function updateLanguages(dataToSave, defaultLanguageNameToSave) {
            var _this4 = this;

            if (!defaultLanguageNameToSave) {
                this.messageService.showToaster('e_5', 'companyInformation');
            } else {
                this.btnLanguageDisable = true;
                this.languagesDataService.updateLanguages(dataToSave).pipe(operators_1.takeUntil(this.unsubscribe), operators_1.finalize(function () {
                    return _this4.btnLanguageDisable = false;
                })).subscribe(function (resp) {
                    var data = resp.data,
                        withWarningMessage = resp.data.withWarningMessage;

                    if (withWarningMessage) {
                        var modal = _this4.snModalService.openModal(save_languages_modal_1.SaveLanguagesModalComponent);
                        modal.componentInstance.text = withWarningMessage.message;
                        modal.componentInstance.redirect = withWarningMessage.errorCode === 310;
                        modal.result.then(function (result) {
                            if (result) {
                                _this4.location.go('/settings/payment_methods');
                            }
                        });
                    }
                    _this4.messageService.showToaster('s_9', 'companyInformation');
                    var initialData = JSON.parse(JSON.stringify(data));
                    _this4.getDefaultLanguageItem(initialData);
                }, function (error) {
                    return _this4.messageService.handleError(error);
                });
            }
        }
    }, {
        key: "getBrandInfo",
        value: function getBrandInfo() {
            var _this5 = this;

            this.brandsDataService.getBrandDetailsInfo(this.companyId).pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (data) {
                if (!data) {
                    return;
                }
                _this5.brandDetails = data;
                _this5.gdprChecked = _this5.brandDetails.gdprFeatures.enabled;
                _this5.createFormGroup(data.brandInfo);
                if (data.logo.actions.PREVIEW_BRAND_LOGO) {
                    _this5.getEditMedia('PREVIEW_BRAND_LOGO', data.logo.actions.PREVIEW_BRAND_LOGO.url);
                }
                if (data.clientPortalBanner.actions.PREVIEW_BRAND_BANNER) {
                    _this5.getEditMedia('PREVIEW_BRAND_BANNER', data.clientPortalBanner.actions.PREVIEW_BRAND_BANNER.url);
                }
            });
        }
    }, {
        key: "subscribeToCustomizeLabelsChange",
        value: function subscribeToCustomizeLabelsChange() {
            var _this6 = this;

            this.settingsService.customizeLabelsObservable.pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (customizeLabels) {
                return _this6.updateFieldsLabels(customizeLabels);
            });
        }
    }, {
        key: "createFormGroup",
        value: function createFormGroup(data) {
            this.editCompanyForm = this.fb.group(this.brandsService.createFormGroup(brands_model_1.BRAND_EDIT_FORM, data));
        }
    }, {
        key: "updateMedia",
        value: function updateMedia(postUrl, data) {
            var _this7 = this;

            this.brandsDataService.updateMedia(postUrl, data.data).pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (response) {
                if (response.data.actions.hasOwnProperty('PREVIEW_BRAND_LOGO')) {
                    _this7.getEditMedia('PREVIEW_BRAND_LOGO', response.data.actions.PREVIEW_BRAND_LOGO.url);
                    _this7.brandDetails.logo.actions = response.data.actions;
                    _this7.messageService.showToaster('s_4', 'companyInformation');
                }
                if (response.data.actions.hasOwnProperty('PREVIEW_BRAND_BANNER')) {
                    _this7.getEditMedia('PREVIEW_BRAND_BANNER', response.data.actions.PREVIEW_BRAND_BANNER.url);
                    _this7.brandDetails.clientPortalBanner.actions = response.data.actions;
                    _this7.messageService.showToaster('s_6', 'companyInformation');
                }
                _this7.brandsDataService.updateBrands().subscribe();
                _this7.settingsOverviewService.getSettingsOverviewItems().subscribe();
            }, function (error) {
                return _this7.messageService.showErrorFromBackend(error.error.errorTitle, error.error.errorMessage);
            });
        }
    }, {
        key: "setDropdownSettings",
        value: function setDropdownSettings() {
            this.dropdownSettings = {
                singleSelection: false,
                enableCheckAll: false,
                text: 'Select Client Portal Languages',
                enableSearchFilter: false,
                classes: 'multiselect-dropdown'
            };
        }
    }, {
        key: "getEditMedia",
        value: function getEditMedia(actionName, url) {
            var _this8 = this;

            this.brandsDataService.getEditMedia(url).subscribe(function (data) {
                if (actionName === 'PREVIEW_BRAND_LOGO') {
                    _this8.logoImage = _this8.restoreFileFromBase64(data.data);
                }
                if (actionName === 'PREVIEW_BRAND_BANNER') {
                    _this8.bannerImage = _this8.restoreFileFromBase64(data.data);
                }
            });
        }
    }, {
        key: "deleteMedia",
        value: function deleteMedia(event) {
            var _this9 = this;

            if (event === this.mediaIds.CompanyLogo) {
                this.brandsDataService.deleteMedia(this.brandDetails.logo.actions.DELETE_BRAND_LOGO.url).subscribe(function () {
                    _this9.brandsDataService.updateBrands().subscribe();
                    _this9.messageService.showToaster('s_5', 'companyInformation');
                    _this9.settingsOverviewService.getSettingsOverviewItems().subscribe();
                });
            }
            if (event === this.mediaIds.CompanyBanner) {
                this.brandsDataService.deleteMedia(this.brandDetails.clientPortalBanner.actions.DELETE_BRAND_BANNER.url).subscribe(function () {
                    return _this9.messageService.showToaster('s_7', 'companyInformation');
                });
            }
        }
    }, {
        key: "restoreFileFromBase64",
        value: function restoreFileFromBase64(fileData) {
            var imageBlob = this.dataURItoBlob(fileData.base64);
            return new File([imageBlob], fileData.name, { type: fileData.contentType });
        }
    }, {
        key: "dataURItoBlob",
        value: function dataURItoBlob(dataURI) {
            var byteString = window.atob(dataURI);
            var arrayBuffer = new ArrayBuffer(byteString.length);
            var int8Array = new Uint8Array(arrayBuffer);
            for (var i = 0; i < byteString.length; i++) {
                int8Array[i] = byteString.charCodeAt(i);
            }
            var blob = new Blob([int8Array], { type: 'image/jpeg' });
            return blob;
        }
    }, {
        key: "updateGdprState",
        value: function updateGdprState(url, enabled) {
            var _this10 = this;

            this.brandsDataService.changeGdprState(url, { enabled: enabled }).pipe(operators_1.takeUntil(this.unsubscribe), operators_1.catchError(function () {
                return of_1.of(_this10.gdprChecked = !_this10.gdprChecked);
            })).subscribe(function (data) {
                _this10.brandDetails.gdprFeatures = data;
            });
        }
    }]);

    return EditCompanySectionComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Number)], EditCompanySectionComponent.prototype, "companyId", void 0);
EditCompanySectionComponent = __decorate([core_1.Component({
    selector: 'edit-company-section',
    template: __webpack_require__("./web/modern/components/settings/edit-company-section/edit-company-section.html"),
    styles: [__webpack_require__("./web/modern/components/settings/edit-company-section/edit-company-section.scss")]
}), __metadata("design:paramtypes", [brands_service_1.BrandsServiceProvider, brands_data_service_1.BrandsDataServiceProvider, language_data_service_1.LanguageDataProvider, snModal_service_1.SNModalService, forms_1.FormBuilder, message_service_1.MessageService, settings_overview_data_service_1.SettingsOverviewDataProvider, settings_1.SettingsProvider, common_1.Location])], EditCompanySectionComponent);
exports.EditCompanySectionComponent = EditCompanySectionComponent;

/***/ }),

/***/ "./web/modern/components/settings/email-settings-section/components/reply-track/reply-track.component.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"receive-replies-checkbox-holder\">\n    <div class=\"checkbox-squared receive-replies-box\">\n\n        <input [(ngModel)]=\"settingsMetadata.enabled\"\n               [checked]=\"settingsMetadata.enabled\"\n               id=\"emailReply{{id}}\"\n               name =\"enabled\"\n               type=\"checkbox\"/>\n\n        <label for=\"emailReply{{id}}\"></label>\n    </div>\n    <span class=\"receive-replies-label\">I want to track incoming email replies</span>\n</div>\n\n<div *ngIf=\" settingsMetadata.actions.COPY_TO_CLIPBOARD && settingsMetadata.enabled\" class=\"flex-row flex-wrap-xs m-0 mt-30 info-section\">\n    <div>\n        <div [innerHTML]=\"settingsMetadata.instruction | safeHtml\"></div>\n    </div>\n\n    <div #container class=\"copy-email\">\n        <p class=\"copy-email-input\">{{ getReplyEmailAddress() }}</p>\n        <button (click)=\"copyToClipboard($event)\" [cbContent]=\"getReplyEmailAddress()\" class=\"btn mt-10 btn-info pr-15 pl-15 btn-rounded copy-email-btn\" ngxClipboard>Copy to Clipboard</button>\n    </div>\n</div>\n\n<div *ngIf=\"settingsMetadata.actions.CREATE_GMAIL_REPLY_ACCOUNT && settingsMetadata.enabled\" class=\"flex-row flex-wrap-xs m-0 mt-30 info-section\">\n    <div>\n        <div [innerHTML]=\"settingsMetadata.instruction | safeHtml\"></div>\n    </div>\n    <div class=\"mt-10\">\n        <div class=\"flex-box flex-just-center\">\n            <input [(ngModel)]=\"settingsMetadata.emailAddress.username\" class=\"form-control\" name=\"snEmail\" maxlength=\"64\" placeholder=\"Enter your preferred name e.g. janedoe\" type=\"text\">\n            <span class=\"receive-replies-email\">@{{ settingsMetadata.emailAddress.domain }}</span>\n        </div>\n        <button (click)=\"submitEmailAddress()\" class=\"btn mt-10 pr-15 pl-15 btn-info-font btn-info\" type=\"button\">\n            Save Email Address\n        </button>\n    </div>\n</div>\n"

/***/ }),

/***/ "./web/modern/components/settings/email-settings-section/components/reply-track/reply-track.component.scss":
/***/ (function(module, exports) {

module.exports = ".receive-replies-checkbox-holder {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  margin-top: 20px; }\n\n.receive-replies-box {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center; }\n\n.receive-replies-label {\n  margin-top: 2px; }\n\n.receive-replies-email {\n  line-height: 30px;\n  margin: 0 10px 0 5px; }\n\n.info-section {\n  background: #f3f3f3;\n  border: 1px solid #dddddd;\n  width: 100%;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  padding: 20px; }\n  .info-section p,\n  .info-section ul > li {\n    font-size: 13px !important; }\n\n.btn-info-font {\n  font-size: 13px !important; }\n\n.copy-email-input {\n  padding: 6px 6px;\n  width: 100%;\n  background: #ffffff;\n  margin-bottom: 0;\n  border: 1px solid #dddddd; }\n\n.copy-email-btn {\n  margin-top: 20px;\n  margin-bottom: 0; }\n  @media screen and (max-width: 500px) {\n    .copy-email-btn {\n      width: 100%; } }\n"

/***/ }),

/***/ "./web/modern/components/settings/email-settings-section/components/reply-track/reply-track.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var email_reply_confirm_modal_component_1 = __webpack_require__("./web/modern/components/settings/email-settings-section/modals/email-reply-confirm-modal/email-reply-confirm-modal.component.ts");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var rxjs_1 = __webpack_require__("./node_modules/rxjs/Rx.js");
var email_settings_data_service_1 = __webpack_require__("./shared/services/settings/email-settings.data.service.ts");
var email_settings_service_1 = __webpack_require__("./shared/services/settings/email-settings.service.ts");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var ReplyTrackComponent = function () {
    function ReplyTrackComponent(messageService, modalService, emailSettingsDataService, emailSettingsService) {
        _classCallCheck(this, ReplyTrackComponent);

        this.messageService = messageService;
        this.modalService = modalService;
        this.emailSettingsDataService = emailSettingsDataService;
        this.emailSettingsService = emailSettingsService;
        this.onEmailConfirm = new core_1.EventEmitter();
        this.unsubscribe = new rxjs_1.Subject();
    }

    _createClass(ReplyTrackComponent, [{
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "getReplyEmailAddress",
        value: function getReplyEmailAddress() {
            return this.settingsMetadata.emailAddress.username + "@" + this.settingsMetadata.emailAddress.domain;
        }
    }, {
        key: "copyToClipboard",
        value: function copyToClipboard(ev) {
            ev.preventDefault();
            this.messageService.showToaster('i_1', 'emailSettings');
        }
    }, {
        key: "submitEmailAddress",
        value: function submitEmailAddress() {
            if (!this.emailSettingsService.validateDomain(this.settingsMetadata.emailAddress.username.trim())) {
                return;
            }
            this.confirmModalRef = this.modalService.openModal(email_reply_confirm_modal_component_1.EmailReplyConfirmModalComponent, {
                windowClass: 'ng-bootstrap-modal__small'
            });
            this.getModalDataForConfirmModal();
            document.body.classList.remove('modal-open');
            this.confirmModalRef.componentInstance.btnDisabled = false;
        }
    }, {
        key: "getModalDataForConfirmModal",
        value: function getModalDataForConfirmModal() {
            var _this = this;

            this.confirmModalRef.result.then(function () {
                document.body.classList.add('modal-open');
                _this.confirmModalSub.unsubscribe();
            }, function () {
                document.body.classList.add('modal-open');
                _this.confirmModalSub.unsubscribe();
            });
            this.confirmModalSub = this.modalService.getModalData().pipe(operators_1.filter(function (data) {
                return data && data.action && data.props;
            })).subscribe(function (data) {
                _this.confirmModalRef.componentInstance.btnDisabled = true;
                switch (data.action) {
                    case 'confirm_email_domain':
                        _this.saveEmailDomainConfirm();
                        break;
                    default:
                        _this.closeConfirmModal();
                        break;
                }
            });
        }
    }, {
        key: "saveEmailDomainConfirm",
        value: function saveEmailDomainConfirm() {
            var _this2 = this;

            var email = this.settingsMetadata.emailAddress.username.toLowerCase().trim();
            this.emailSettingsDataService.saveReplySNEmaiDomain(this.settingsMetadata.actions.CREATE_GMAIL_REPLY_ACCOUNT.url, email).pipe(operators_1.takeUntil(this.unsubscribe), operators_1.finalize(function () {
                return _this2.closeConfirmModal();
            })).subscribe(function (data) {
                _this2.messageService.showToaster('s_3', 'emailSettings');
                _this2.onEmailConfirm.emit(data);
            }, function (err) {
                var error = err.error;
                var errorMessage = error.errorMessage,
                    errorTitle = error.errorTitle;

                _this2.messageService.showErrorFromBackend(errorTitle, errorMessage);
            });
        }
    }, {
        key: "closeConfirmModal",
        value: function closeConfirmModal() {
            this.confirmModalRef.componentInstance.btnDisabled = false;
            this.confirmModalRef.close();
        }
    }]);

    return ReplyTrackComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Number)], ReplyTrackComponent.prototype, "id", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], ReplyTrackComponent.prototype, "settingsMetadata", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], ReplyTrackComponent.prototype, "onEmailConfirm", void 0);
ReplyTrackComponent = __decorate([core_1.Component({
    selector: 'reply-track',
    template: __webpack_require__("./web/modern/components/settings/email-settings-section/components/reply-track/reply-track.component.html"),
    styles: [__webpack_require__("./web/modern/components/settings/email-settings-section/components/reply-track/reply-track.component.scss")]
}), __metadata("design:paramtypes", [message_service_1.MessageService, snModal_service_1.SNModalService, email_settings_data_service_1.EmailSettingsDataService, email_settings_service_1.EmailSettingsService])], ReplyTrackComponent);
exports.ReplyTrackComponent = ReplyTrackComponent;

/***/ }),

/***/ "./web/modern/components/settings/email-settings-section/modals/email-alert-modal/email-alert-modal.component.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-body\" style=\"padding: 40px!important;\">\n    <div class=\"form-horizontal\">\n        <div class=\"flex-box flex-column flex-align-center\">\n            <div [innerHTML]=\"messageToShow | safeHtml\"></div>\n        </div>\n        <div class=\"pt-15 flex-box flex-just-center \">\n            <button (click)=\"confirmSave()\" [disabled]=\"btnDisabled\" [is-spinning-wheel-active]=\"btnDisabled\" class=\"btn btn-lg btn-success mb-0 mr-10\" spinning-wheel type=\"button\">Go It</button>\n        </div>\n    </div>\n</div>"

/***/ }),

/***/ "./web/modern/components/settings/email-settings-section/modals/email-alert-modal/email-alert-modal.component.scss":
/***/ (function(module, exports) {

module.exports = ""

/***/ }),

/***/ "./web/modern/components/settings/email-settings-section/modals/email-alert-modal/email-alert-modal.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var EmailAlertModalComponent = function () {
    function EmailAlertModalComponent(modalService) {
        _classCallCheck(this, EmailAlertModalComponent);

        this.modalService = modalService;
        this.btnDisabled = false;
        this.messageToShow = 'Are you sure?';
    }

    _createClass(EmailAlertModalComponent, [{
        key: "confirmSave",
        value: function confirmSave() {
            this.modalService.activeModal.close();
        }
    }]);

    return EmailAlertModalComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], EmailAlertModalComponent.prototype, "btnDisabled", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], EmailAlertModalComponent.prototype, "messageToShow", void 0);
EmailAlertModalComponent = __decorate([core_1.Component({
    selector: 'email-alert-modal',
    template: __webpack_require__("./web/modern/components/settings/email-settings-section/modals/email-alert-modal/email-alert-modal.component.html"),
    styles: [__webpack_require__("./web/modern/components/settings/email-settings-section/modals/email-alert-modal/email-alert-modal.component.scss")]
}), __metadata("design:paramtypes", [snModal_service_1.SNModalService])], EmailAlertModalComponent);
exports.EmailAlertModalComponent = EmailAlertModalComponent;

/***/ }),

/***/ "./web/modern/components/settings/email-settings-section/modals/email-reply-confirm-modal/email-reply-confirm-modal.component.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-body\" style=\"padding: 40px!important;\">\n    <form class=\"form-horizontal\" role=\"form\" (submit)=\"onSubmit()\">\n        <div class=\"flex-box flex-column flex-align-center\">\n            <p class=\"f-s-16 text-center\">Once saved, your Studio Ninja email address cannot be changed.<br>Are you sure?</p>\n        </div>\n        <div class=\"pt-15 flex-box flex-just-center \">\n            <button type=\"submit\" class=\"btn btn-lg btn-success mb-0 mr-10\" spinning-wheel [is-spinning-wheel-active]=\"btnDisabled\" [disabled]=\"btnDisabled\">Confirm and Save</button>\n            <button type=\"button\" (click)=\"onDismiss()\" class=\"btn btn-lg btn-grey-light mb-0\" [disabled]=\"btnDisabled\" >Go Back</button>\n        </div>\n    </form>\n</div>"

/***/ }),

/***/ "./web/modern/components/settings/email-settings-section/modals/email-reply-confirm-modal/email-reply-confirm-modal.component.scss":
/***/ (function(module, exports) {

module.exports = ""

/***/ }),

/***/ "./web/modern/components/settings/email-settings-section/modals/email-reply-confirm-modal/email-reply-confirm-modal.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var ng_bootstrap_1 = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/index.js");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var EmailReplyConfirmModalComponent = function () {
    function EmailReplyConfirmModalComponent(activeModal, modalService) {
        _classCallCheck(this, EmailReplyConfirmModalComponent);

        this.activeModal = activeModal;
        this.modalService = modalService;
        this.btnDisabled = false;
    }

    _createClass(EmailReplyConfirmModalComponent, [{
        key: "onSubmit",
        value: function onSubmit() {
            this.modalService.setModalData({
                action: 'confirm_email_domain',
                props: true
            });
        }
    }, {
        key: "onDismiss",
        value: function onDismiss() {
            this.activeModal.dismiss();
        }
    }]);

    return EmailReplyConfirmModalComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], EmailReplyConfirmModalComponent.prototype, "btnDisabled", void 0);
EmailReplyConfirmModalComponent = __decorate([core_1.Component({
    selector: 'email-reply-confirm-modal',
    template: __webpack_require__("./web/modern/components/settings/email-settings-section/modals/email-reply-confirm-modal/email-reply-confirm-modal.component.html"),
    styles: [__webpack_require__("./web/modern/components/settings/email-settings-section/modals/email-reply-confirm-modal/email-reply-confirm-modal.component.scss")]
}), __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal, snModal_service_1.SNModalService])], EmailReplyConfirmModalComponent);
exports.EmailReplyConfirmModalComponent = EmailReplyConfirmModalComponent;

/***/ }),

/***/ "./web/modern/components/settings/email-settings-section/modals/email-reply-modal/email-reply-modal.component.html":
/***/ (function(module, exports) {

module.exports = "<section>\n    <div class=\"container\" id=\"main-wrapper\">\n        <div class=\"modal modal-center fade\" data-backdrop=\"static\" data-keyboard=\"false\" id=\"emailReplyModal\">\n            <div class=\"modal-dialog\">\n                <div *ngIf=\"emailData\" class=\"modal-content email-reply-content\">\n                    <form #formRef=\"ngForm\" (ngSubmit)=\"saveEmailReplyForm()\" name=\"EmailReplyForm\">\n                        <div class=\"modal-header\">\n                            <button (click)=\"dismiss()\" [disabled]=\"disableBtn\" aria-hidden=\"true\" class=\"close\" data-dismiss=\"modal\" type=\"button\">&times;</button>\n                            <h3 class=\"modal-title\">Gmail settings</h3> </div>\n                        <div class=\"modal-body\">\n                            <h4>Sender name (From)</h4>\n\n                            <input [(ngModel)]=\"emailData.senderName\" autocomplete=\"off\" class=\"form-control\"\n                                   maxlength=\"255\"\n                                   name=\"senderName\"\n                                   pattern=\".*\\S+.*\"\n                                   placeholder=\"e.g Jane Doe\"\n                                   type=\"text\">\n\n                            <div class=\"mt-30 mb-10\">\n                                <h4>Connected Gmail Address</h4>\n                                <input type=\"text\"\n                                       class=\"form-control readonly-form-controll\"\n                                       name=\"senderName\"\n                                       readonly\n                                       placeholder=\"e.g Jane Doe\"\n                                       autocomplete=\"off\"\n                                       [value]=\"emailData.senderEmail\"\n                                >\n                            </div>\n\n                            <reply-track (onEmailConfirm)=\"onEmailConfirm($event)\"\n                                         *ngIf=\"emailData?.replySettingsMetadata\"\n                                         [id]=\"1\"\n                                         [settingsMetadata]=\"emailData?.replySettingsMetadata\">\n                            </reply-track>\n\n                        </div>\n                        <div class=\"modal-footer modal-foot\">\n                            <button [disabled]=\"disableBtn || (emailData.replySettingsMetadata && emailData.replySettingsMetadata.actions.CREATE_GMAIL_REPLY_ACCOUNT && emailData.replySettingsMetadata.enabled)\"\n                                    [is-spinning-wheel-active]=\"disableBtn\"\n                                    class=\"btn btn-success border-none btn-lg\"\n                                    spinning-wheel type=\"submit\"\n                                    [ngClass]=\"{'btn-grey' : disableBtn || (emailData.replySettingsMetadata && emailData.replySettingsMetadata.actions.CREATE_GMAIL_REPLY_ACCOUNT && emailData.replySettingsMetadata.enabled)}\"\n                            >Save settings</button>\n                        </div>\n                    </form>\n                </div>\n            </div>\n        </div>\n    </div>\n</section>\n\n\n\n"

/***/ }),

/***/ "./web/modern/components/settings/email-settings-section/modals/email-reply-modal/email-reply-modal.component.scss":
/***/ (function(module, exports) {

module.exports = "#emailReplyModal .modal-dialog {\n  width: 550px !important; }\n\n.btn-go-back {\n  background-color: #aaa;\n  -webkit-transition: all 0.4s ease-in;\n  transition: all 0.4s ease-in; }\n  .btn-go-back:hover {\n    background: #aaa !important;\n    opacity: 0.8; }\n\n.btn-info-font {\n  font-size: 13px !important; }\n\n.btn-grey.border-none {\n  opacity: 0.8;\n  border: none !important; }\n\n.readonly-form-controll {\n  background-color: #ffffff !important;\n  cursor: not-allowed; }\n\n.btn-success[disabled]:hover {\n  background-color: #8e8e98;\n  border: none; }\n"

/***/ }),

/***/ "./web/modern/components/settings/email-settings-section/modals/email-reply-modal/email-reply-modal.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var email_alert_modal_component_1 = __webpack_require__("./web/modern/components/settings/email-settings-section/modals/email-alert-modal/email-alert-modal.component.ts");
var EmailReplyModalComponent = function () {
    function EmailReplyModalComponent(messageService, modalService) {
        _classCallCheck(this, EmailReplyModalComponent);

        this.messageService = messageService;
        this.modalService = modalService;
        this.onSaveSettings = new core_1.EventEmitter();
        this.onModalClose = new core_1.EventEmitter();
    }

    _createClass(EmailReplyModalComponent, [{
        key: "saveEmailReplyForm",
        value: function saveEmailReplyForm() {
            if (this.emailData.replyConfirmationHtml && this.emailData.replySettingsMetadata.enabled) {
                this.openConfirmModal();
            } else {
                this.closeWithData();
            }
        }
    }, {
        key: "dismiss",
        value: function dismiss() {
            this.onModalClose.emit();
        }
    }, {
        key: "closeWithData",
        value: function closeWithData() {
            this.onSaveSettings.emit({ data: this.emailData });
        }
    }, {
        key: "onEmailConfirm",
        value: function onEmailConfirm(data) {
            this.emailData.replySettingsMetadata = JSON.parse(JSON.stringify(data));
            this.emailData.replySettingsMetadata.enabled = true;
        }
    }, {
        key: "openConfirmModal",
        value: function openConfirmModal() {
            var _this = this;

            this.confirmModalRef = this.modalService.openModal(email_alert_modal_component_1.EmailAlertModalComponent, {
                windowClass: 'ng-bootstrap-modal__small'
            });
            document.body.classList.remove('modal-open');
            this.confirmModalRef.componentInstance.btnDisabled = false;
            this.confirmModalRef.componentInstance.messageToShow = this.emailData.replyConfirmationHtml;
            this.confirmModalRef.result.then(function () {
                document.body.classList.add('modal-open');
                _this.closeWithData();
            });
        }
    }]);

    return EmailReplyModalComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], EmailReplyModalComponent.prototype, "emailData", void 0);
__decorate([core_1.Input(), __metadata("design:type", Boolean)], EmailReplyModalComponent.prototype, "disableBtn", void 0);
__decorate([core_1.Output(), __metadata("design:type", Object)], EmailReplyModalComponent.prototype, "onSaveSettings", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], EmailReplyModalComponent.prototype, "onModalClose", void 0);
EmailReplyModalComponent = __decorate([core_1.Component({
    selector: 'email-reply-modal',
    template: __webpack_require__("./web/modern/components/settings/email-settings-section/modals/email-reply-modal/email-reply-modal.component.html"),
    styles: [__webpack_require__("./web/modern/components/settings/email-settings-section/modals/email-reply-modal/email-reply-modal.component.scss")]
}), __metadata("design:paramtypes", [message_service_1.MessageService, snModal_service_1.SNModalService])], EmailReplyModalComponent);
exports.EmailReplyModalComponent = EmailReplyModalComponent;

/***/ }),

/***/ "./web/modern/components/settings/email-settings-section/modals/smtp-modal/smtp-modal.component.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal modal-center fade\" data-backdrop=\"static\" data-keyboard=\"false\" id=\"smptServerSettingsModal\">\n    <div *ngIf=\"smtpData\" class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <button aria-hidden=\"true\" class=\"close\" data-dismiss=\"modal\">&times;</button>\n                <h3 class=\"modal-title\">SMTP server settings</h3>\n            </div>\n            <form #formRef=\"ngForm\" (ngSubmit)=\"saveSMTPServerSettings(formRef.value)\" name=\"SmtpForm\" role=\"form\">\n                <div class=\"modal-body f-s-14-i\">\n                    <div class=\"form-group\">\n                        <h4>Sender name (From)</h4>\n                        <input [(ngModel)]=\"smtpData.from\" class=\"form-control\" maxlength=\"255\" name=\"from\"\n                               placeholder=\"Enter your sender name\"\n                               required\n                               type=\"text\">\n                    </div>\n                    <div class=\"form-group\">\n                        <h4 class=\"mt-10\">Username</h4>\n                        <input [(ngModel)]=\"smtpData.serverUsername\" class=\"form-control\"\n                               maxlength=\"255\" name=\"serverUsername\"\n                               pattern=\"[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+.[A-Za-z]{2,9}$\"\n                               placeholder=\"Enter your user email\"\n                               required type=\"text\">\n                    </div>\n                    <div class=\"form-group\">\n                        <h4 class=\"mt-10\">Password</h4>\n                        <input [(ngModel)]=\"smtpData.passwordMask\" class=\"form-control\" maxlength=\"255\" name=\"password\" placeholder=\"Enter your password\" required type=\"password\">\n                    </div>\n                    <div class=\"form-group\">\n                        <h4 class=\"mt-10\">SMTP server</h4>\n                        <input [(ngModel)]=\"smtpData.host\" class=\"form-control\" maxlength=\"255\" name=\"host\" placeholder=\"Enter your valid SMTP server address\"\n                               required type=\"text\">\n                    </div>\n                    <div class=\"form-group\">\n                        <h4 class=\"mt-10\">Port</h4>\n                        <div class=\"flex-row flex-wrap flex-align-center\">\n                            <input [(ngModel)]=\"smtpData.port\" class=\"form-control w-110 mr-60\" maxlength=\"5\" (keypress)=\"numberOnly($event)\"\n                                   name=\"port\" placeholder=\"SMTP port\" required type=\"text\">\n                            <div class=\"ssl-connection flex-row flex-align-center\">\n                                <div class=\"checkbox-squared\">\n                                    <input [(ngModel)]=\"smtpData.withSSL\" id=\"checkbox-squared-secured-connection\"\n                                           name=\"withSSL\"\n                                           type=\"checkbox\">\n                                    <label for=\"checkbox-squared-secured-connection\"></label>\n                                </div>\n                                <span class=\"mt-2\">Secured connection using SSL</span>\n                            </div>\n                        </div>\n                    </div>\n\n                    <reply-track (onEmailConfirm)=\"onEmailConfirm($event)\"\n                                 *ngIf=\"smtpData.replySettingsMetadata\"\n                                 [id]=\"2\"\n                                 [settingsMetadata]=\"smtpData.replySettingsMetadata\">\n                    </reply-track>\n\n                </div>\n                <div class=\"modal-footer modal-foot\">\n                    <button  [disabled]=\"btnDisable || (smtpData.replySettingsMetadata && smtpData.replySettingsMetadata.actions.CREATE_GMAIL_REPLY_ACCOUNT && smtpData.replySettingsMetadata.enabled)\"\n                             [is-spinning-wheel-active]=\"btnDisable\"\n                             [ngClass]=\"{'btn-grey' : btnDisable || (smtpData.replySettingsMetadata && smtpData.replySettingsMetadata.actions.CREATE_GMAIL_REPLY_ACCOUNT && smtpData.replySettingsMetadata.enabled)}\"\n                             class=\"btn btn-success btn-lg\"\n                             spinning-wheel\n                             type=\"submit\">\n                        Save settings\n                    </button>\n                </div>\n            </form>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "./web/modern/components/settings/email-settings-section/modals/smtp-modal/smtp-modal.component.scss":
/***/ (function(module, exports) {

module.exports = "@media (max-width: 481px) {\n  .ssl-connection {\n    margin-top: 20px; } }\n\n.btn-success[disabled] {\n  background-color: #8e8e98;\n  border: none; }\n  .btn-success[disabled]:hover {\n    background-color: #1db198; }\n"

/***/ }),

/***/ "./web/modern/components/settings/email-settings-section/modals/smtp-modal/smtp-modal.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var email_alert_modal_component_1 = __webpack_require__("./web/modern/components/settings/email-settings-section/modals/email-alert-modal/email-alert-modal.component.ts");
var rxjs_1 = __webpack_require__("./node_modules/rxjs/Rx.js");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var email_settings_service_1 = __webpack_require__("./shared/services/settings/email-settings.service.ts");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var email_settings_data_service_1 = __webpack_require__("./shared/services/settings/email-settings.data.service.ts");
var SmtpModalComponent = function () {
    function SmtpModalComponent(messageService, modalService, emailSettingsService, emailSettingsDataService) {
        _classCallCheck(this, SmtpModalComponent);

        this.messageService = messageService;
        this.modalService = modalService;
        this.emailSettingsService = emailSettingsService;
        this.emailSettingsDataService = emailSettingsDataService;
        this.onSaveSmtp = new core_1.EventEmitter();
        this.unsubscribe = new rxjs_1.Subject();
    }

    _createClass(SmtpModalComponent, [{
        key: "saveSMTPServerSettings",
        value: function saveSMTPServerSettings(formData) {
            if (this.smtpData.replyConfirmationHtml && this.smtpData.replySettingsMetadata && this.smtpData.replySettingsMetadata.enabled) {
                this.openConfirmModal();
            } else {
                this.saveSmtpConfig(formData);
            }
        }
    }, {
        key: "closeModal",
        value: function closeModal() {
            this.onSaveSmtp.emit();
        }
    }, {
        key: "numberOnly",
        value: function numberOnly(event) {
            var charCode = event.which ? event.which : event.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                return false;
            }
            return true;
        }
    }, {
        key: "onEmailConfirm",
        value: function onEmailConfirm(data) {
            this.smtpData.replySettingsMetadata = JSON.parse(JSON.stringify(data));
            this.smtpData.replySettingsMetadata.enabled = true;
        }
    }, {
        key: "saveSmtpConfig",
        value: function saveSmtpConfig(formData) {
            var _this = this;

            this.btnDisable = true;
            formData.from = this.smtpData.from;
            formData.username = formData.serverUsername.toLowerCase();
            formData.withSSL = !!formData.withSSL;
            formData.password = this.smtpData.passwordMask;
            formData.port = this.smtpData.port.toString();
            if (this.smtpData.replySettingsMetadata) {
                formData.receiveReplies = !!this.smtpData.replySettingsMetadata.enabled;
                formData.accountCredentialId = this.smtpData.replySettingsMetadata.replyAccountCredentialId;
            }
            if (!this.emailSettingsService.isSMTPSettingsValid(formData)) {
                this.btnDisable = false;
                return;
            }
            this.messageService.showToaster('i_0', 'emailSettings');
            this.emailSettingsDataService.saveSMTPServerSettings(formData).pipe(operators_1.finalize(function () {
                return _this.btnDisable = false;
            })).subscribe(function () {
                return _this.successSaveSMTPConnection();
            }, function (error) {
                return _this.errorSaveSMTPConnection(error);
            });
        }
    }, {
        key: "successSaveSMTPConnection",
        value: function successSaveSMTPConnection() {
            this.messageService.showToaster('s_2', 'emailSettings', 'SMTP email');
            this.closeModal();
        }
    }, {
        key: "errorSaveSMTPConnection",
        value: function errorSaveSMTPConnection(result) {
            var error = result.error;
            var errorCode = error.errorCode,
                errorTitle = error.errorTitle,
                errorMessage = error.errorMessage;

            errorCode ? this.messageService.showErrorFromBackend(errorTitle, errorMessage) : this.messageService.showToaster('e_2', 'emailSettings');
        }
    }, {
        key: "openConfirmModal",
        value: function openConfirmModal() {
            var _this2 = this;

            this.confirmModalRef = this.modalService.openModal(email_alert_modal_component_1.EmailAlertModalComponent, {
                windowClass: 'ng-bootstrap-modal__small'
            });
            document.body.classList.remove('modal-open');
            this.confirmModalRef.componentInstance.btnDisabled = false;
            this.confirmModalRef.componentInstance.messageToShow = this.smtpData.replyConfirmationHtml;
            this.confirmModalRef.result.then(function () {
                document.body.classList.add('modal-open');
                _this2.closeModal();
            });
        }
    }]);

    return SmtpModalComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], SmtpModalComponent.prototype, "smtpData", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], SmtpModalComponent.prototype, "onSaveSmtp", void 0);
SmtpModalComponent = __decorate([core_1.Component({
    selector: 'smtp-modal',
    template: __webpack_require__("./web/modern/components/settings/email-settings-section/modals/smtp-modal/smtp-modal.component.html"),
    styles: [__webpack_require__("./web/modern/components/settings/email-settings-section/modals/smtp-modal/smtp-modal.component.scss")]
}), __metadata("design:paramtypes", [message_service_1.MessageService, snModal_service_1.SNModalService, email_settings_service_1.EmailSettingsService, email_settings_data_service_1.EmailSettingsDataService])], SmtpModalComponent);
exports.SmtpModalComponent = SmtpModalComponent;

/***/ }),

/***/ "./web/modern/components/settings/gdpr/enable-gdpr-section/enable-gdpr-section.html":
/***/ (function(module, exports) {

module.exports = "<article class=\"flex-row bg-concrete-light gdpr-section\">\n    <div class=\"checkbox-squared\">\n        <input type=\"checkbox\" id=\"gdpr\" [checked]=\"gdprChecked\" (change)=\"onEnableGdpr(gdprChecked)\"/>\n        <label for=\"gdpr\"></label>\n    </div>\n    <div class=\"description\">\n        <h4 class=\"mt-2\">Enable GDPR features</h4>\n        <p class=\"mb-0\">Enable if you have clients in the European Union. GDPR features will give you the ability to add opt-in consent checkboxes to your Contact Form, Contract Templates and Questionnaire Templates.</p>\n    </div>\n</article>"

/***/ }),

/***/ "./web/modern/components/settings/gdpr/enable-gdpr-section/enable-gdpr-section.scss":
/***/ (function(module, exports) {

module.exports = ".gdpr-section {\n  border: 1px solid #ebebeb;\n  background: #f9f9f9;\n  padding: 15px; }\n"

/***/ }),

/***/ "./web/modern/components/settings/gdpr/enable-gdpr-section/enable-gdpr-section.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var EnableGdprSectionComponent = function () {
    function EnableGdprSectionComponent() {
        _classCallCheck(this, EnableGdprSectionComponent);

        this.enableGdbr = new core_1.EventEmitter();
    }

    _createClass(EnableGdprSectionComponent, [{
        key: "onEnableGdpr",
        value: function onEnableGdpr() {
            this.gdprChecked = !this.gdprChecked;
            this.enableGdbr.emit(this.gdprChecked);
        }
    }]);

    return EnableGdprSectionComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Boolean)], EnableGdprSectionComponent.prototype, "gdprChecked", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], EnableGdprSectionComponent.prototype, "enableGdbr", void 0);
EnableGdprSectionComponent = __decorate([core_1.Component({
    selector: 'enable-gdpr-section',
    template: __webpack_require__("./web/modern/components/settings/gdpr/enable-gdpr-section/enable-gdpr-section.html"),
    styles: [__webpack_require__("./web/modern/components/settings/gdpr/enable-gdpr-section/enable-gdpr-section.scss")]
}), __metadata("design:paramtypes", [])], EnableGdprSectionComponent);
exports.EnableGdprSectionComponent = EnableGdprSectionComponent;

/***/ }),

/***/ "./web/modern/components/settings/integrations-section/integrations-section.html":
/***/ (function(module, exports) {

module.exports = "<section id=\"main-wrapper\" class=\"setting-section\">\n<div class=\"col-md-3 pl-0\">\n    <settings-navigation></settings-navigation>\n</div>\n\n<div class=\"col-md-9 pr-0 setting-box\">\n\n    <div class=\"bc-wrap flex-box flex-just-space\">\n        <setting-section-header [breadcrumbs]=\"breadcrumbs\"></setting-section-header>\n    </div>\n\n    <div class=\"m-30\">\n        <setting-section-description\n                [text]=\"'Connect Studio Ninja with your favourite applications and tools for work. More apps coming soon!'\">\n        </setting-section-description>\n    </div>\n\n    <div class=\"row flex-row flex-wrap flex-wrap-xs-min integrations\">\n\n        <div class=\"integrations-wrap flex-row flex-wrap-md flex-item-xs-min flex-just-center flex-basis-full-sm flex-item-sm integrations-align-top\">\n            <div class=\"flex-align flex-item-w-100-lg\" style=\"height: 100px;\">\n                <img src=\"https://app.studioninja.co/build/release-pipeline-119/resources/dist/assets/images/icons/integration-icons/xero.png\">\n            </div>\n            <div class=\"flex-row flex-wrap-lg-max flex-wrap-sm-min flex-just-center integrations-main-info p-0\">\n                <div class=\"ps-10\">\n                    <h4 class=\"mt-0 mb-15\">Xero</h4>\n                    <p class=\"f-s-14-i mb-0\">Beautiful accounting software. Auto sync invoices and payments between Studio Ninja and Xero.\n                    <span  class=\"f-s-14-i mb-0\" *ngIf=\"xeroOrganization\">Connected to <b>{{ xeroOrganization }}</b></span>\n                    </p>\n                </div>\n                <div class=\"flex-align flex-item-w-100-md integrations-buttons\">\n                    <button type=\"button\" class=\"btn btn-default btn-md w-min-120 flex-basis-full-xs\"\n                            spinning-wheel [is-spinning-wheel-active]=\"isXeroSpinningWheelActive\" [is-spinning-wheel-dark]=\"'true'\"\n                            *ngIf=\"!xeroOrganization\"\n                            [disabled]=\"lockIntegrationButtons\"\n                            (click)=\"initXeroIntegration()\"\n                    >Connect\n                    </button>\n                    <button type=\"button\" class=\"btn btn-default w-min-120 flex-basis-full-xs\"\n                            spinning-wheel [is-spinning-wheel-active]=\"isXeroSpinningWheelActive\" [is-spinning-wheel-dark]=\"'true'\"\n                            *ngIf=\"xeroOrganization\"\n                            [disabled]=\"lockIntegrationButtons\"\n                            (click)=\"editXeroIntegrationSettings()\"\n                    >Edit settings\n                    </button>\n                    <button type=\"button\" class=\"btn btn-default w-min-120 flex-basis-full-xs\"\n                            spinning-wheel [is-spinning-wheel-active]=\"isXeroDisconnectSpinningWheelActive\" [is-spinning-wheel-dark]=\"'true'\"\n                            *ngIf=\"xeroOrganization\"\n                            [disabled]=\"lockIntegrationButtons\"\n                            (click)=\"disconnectXero()\"\n                    >Disconnect\n                    </button>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"integrations-wrap flex-row flex-wrap-md flex-item-xs-min flex-just-center flex-basis-full-sm flex-item-sm integrations-align-top\">\n            <div class=\"flex-align flex-item-w-100-lg\" style=\"height: 100px;\">\n                <img style=\"width: 80px;\" src=\"https://app.studioninja.co/build/release-pipeline-119/resources/dist/assets/images/icons/integration-icons/quickbooks_new.png\">\n            </div>\n            <div class=\"flex-row flex-wrap-lg-max flex-wrap-sm-min flex-just-center integrations-main-info p-0\">\n                <div class=\"ps-10\">\n                    <h4 class=\"mt-0 mb-15\">QuickBooks</h4>\n                    <p class=\"f-s-14-i mb-0\">\n                        Auto sync invoices and payments between Studio Ninja and QuickBooks. Not compatible with Self-Employed.\n                    <span class=\"f-s-14-i mb-0\" *ngIf=\"quickbooksOrganization\">Connected to <b>{{ quickbooksOrganization }}</b></span>\n                    </p>\n                </div>\n                <div class=\"flex-align flex-item-w-100-md integrations-buttons flex-basis-full-xs\">\n                    <button type=\"button\" class=\"btn btn-default btn-md w-min-120 flex-basis-full-xs quickbooks-custom-connect\"\n                            spinning-wheel [is-spinning-wheel-active]=\"isQbSpinningWheelActive\" [is-spinning-wheel-dark]=\"'true'\"\n                            *ngIf=\"!quickbooksOrganization\"\n                            [disabled] = \"lockIntegrationButtons\"\n                            (click)=\"initQuickbooksIntegration()\"\n                    >\n                        <img src=\"https://app.studioninja.co/build/release-pipeline-119/resources/dist/assets/images/icons/integration-icons/quickbooks.png\">\n                        Connect\n                    </button>\n\n                    <button type=\"button\" class=\"btn btn-default w-min-120 flex-basis-full-xs\"\n                            spinning-wheel [is-spinning-wheel-active]=\"isQbSpinningWheelActive\" [is-spinning-wheel-dark]=\"'true'\"\n                            *ngIf=\"quickbooksOrganization\"\n                            [disabled]=\"lockIntegrationButtons\"\n                            (click)=\"editQuickBooksIntegrationSettings()\"\n                    >Edit settings\n                    </button>\n\n                    <button type=\"button\" class=\"btn btn-default w-min-120 flex-basis-full-xs\"\n                            spinning-wheel [is-spinning-wheel-active]=\"isQbDisconnectSpinningWheelActive\" [is-spinning-wheel-dark]=\"'true'\"\n                            *ngIf=\"quickbooksOrganization\"\n                            [disabled]=\"lockIntegrationButtons\"\n                            (click)=\"disconnectQuickbooks()\"\n                    >Disconnect\n                    </button>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"integrations-wrap flex-row flex-wrap-md flex-item-xs-min flex-just-center flex-basis-full-sm flex-item-sm integrations-align-top\" *ngIf=\"picTimeAvailable\">\n            <div class=\"flex-align flex-item-w-100-lg\" style=\"height: 100px;\">\n                <img style=\"width: 80px;\" src=\"https://app.studioninja.co/build/release-pipeline-119/resources/dist/assets/images/icons/integration-icons/pic-time.png\">\n            </div>\n            <div class=\"flex-row flex-wrap-lg-max flex-wrap-sm-min flex-just-center integrations-main-info p-0\">\n                <div class=\"ps-10\">\n                    <h4 class=\"mt-0 mb-15\">Pic-Time</h4>\n                    <p class=\"f-s-14-i mb-0\">\n                        Connect Pic-Time galleries to your Studio Ninja jobs and import orders.\n                        <span class=\"f-s-14-i mb-0\" *ngIf=\"picTimeCompanyName\">Connected to <b>{{ picTimeCompanyName }}</b></span>\n                    </p>\n                </div>\n                <div class=\"flex-align flex-item-w-100-md integrations-buttons flex-basis-full-xs\">\n                    <button type=\"button\" class=\"btn btn-default btn-md w-min-120 flex-basis-full-xs\"\n                            spinning-wheel [is-spinning-wheel-active]=\"isPicTimeSpinningWheelActive\" [is-spinning-wheel-dark]=\"'true'\"\n                            *ngIf=\"!connectedToPicTime\"\n                            [disabled]=\"lockIntegrationButtons\"\n                            (click)=\"connectToPicTime()\"\n                    >Connect</button>\n\n                    <button type=\"button\" class=\"btn btn-default w-min-120 flex-basis-full-xs\"\n                            spinning-wheel [is-spinning-wheel-active]=\"isPicTimeSpinningWheelActive\" [is-spinning-wheel-dark]=\"'true'\"\n                            *ngIf=\"connectedToPicTime\"\n                            [disabled]=\"lockIntegrationButtons\"\n                            (click)=\"editPicTimeIntegrationSettings()\"\n                    >Edit settings\n                    </button>\n\n                    <button type=\"button\" class=\"btn btn-default w-min-120 flex-basis-full-xs\"\n                            spinning-wheel [is-spinning-wheel-active]=\"isPicTimeDisconnectSpinningWheelActive\" [is-spinning-wheel-dark]=\"'true'\"\n                            *ngIf=\"connectedToPicTime\"\n                            [disabled]=\"lockIntegrationButtons\"\n                            (click)=\"disconnectPicTime()\"\n                    >Disconnect\n                    </button>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"integrations-wrap flex-row flex-wrap-md flex-item-xs-min flex-just-center flex-basis-full-sm flex-item-sm integrations-align-top\">\n            <div class=\"flex-align flex-item-w-100-lg\" style=\"height: 100px;\">\n                <img src=\"https://app.studioninja.co/build/release-pipeline-119/resources/dist/assets/images/icons/integration-icons/shootproof.png\">\n            </div>\n            <div class=\"flex-row flex-wrap-lg-max flex-wrap-sm-min flex-just-center integrations-main-info p-0\">\n                <div class=\"ps-10 \">\n                    <h4 class=\"mt-0 mb-15\">ShootProof</h4>\n                    <p class=\"f-s-14-i mb-0\">\n                        Connect ShootProof galleries to your Studio Ninja jobs and import orders.\n                    <span class=\"f-s-14-i mb-0\" *ngIf=\"shootProofCompanyName\">Connected to <b>{{ shootProofCompanyName }}</b></span>\n                    </p>\n                </div>\n                <div class=\"flex-align flex-item-w-100-md integrations-buttons flex-basis-full-xs\">\n                    <button type=\"button\" class=\"btn btn-default btn-md w-min-120 flex-basis-full-xs\"\n                            spinning-wheel [is-spinning-wheel-active]=\"isShootProofSpinningWheelActive\" [is-spinning-wheel-dark]=\"'true'\"\n                            *ngIf=\"!shootProofCompanyName\"\n                            [disabled] = \"lockIntegrationButtons\"\n                            (click)=\"initShootProofIntegration()\"\n                    >Connect</button>\n                    <button type=\"button\" class=\"btn btn-default w-min-120 flex-basis-full-xs\"\n                             spinning-wheel [is-spinning-wheel-active]=\"isShootProofSpinningWheelActive\" [is-spinning-wheel-dark]=\"'true'\"\n                             *ngIf=\"shootProofCompanyName\"\n                             [disabled]=\"lockIntegrationButtons\"\n                             (click)=\"editShootProofIntegrationSettings()\"\n                >Edit settings\n                </button>\n\n                    <button type=\"button\" class=\"btn btn-default w-min-120 flex-basis-full-xs\"\n                            spinning-wheel [is-spinning-wheel-active]=\"isSpDisconnectSpinningWheelActive\" [is-spinning-wheel-dark]=\"'true'\"\n                            *ngIf=\"shootProofCompanyName\"\n                            [disabled]=\"lockIntegrationButtons\"\n                            (click)=\"disconnectShootProof()\"\n                    >Disconnect\n                    </button>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"integrations-wrap flex-row flex-wrap-md flex-item-xs-min flex-just-center flex-basis-full-sm flex-item-sm integrations-align-top\" *ngIf=\"fundyAvailable\">\n            <div class=\"flex-align flex-item-w-100-lg\" style=\"height: 100px;\">\n                <img src=\"https://app.studioninja.co/build/release-pipeline-119/resources/dist/assets/images/icons/integration-icons/fundy.png\">\n            </div>\n            <div class=\"flex-row flex-wrap-lg-max flex-wrap-sm-min flex-just-center integrations-main-info p-0\">\n                <div class=\"ps-10\">\n                    <h4 class=\"mt-0 mb-15\">Fundy Designer</h4>\n                    <p class=\"f-s-14-i mb-0\">\n                        Enable Fundy-friendly features to import invoices from Fundy.\n                    </p>\n                </div>\n                <div class=\"flex-align flex-item-w-100-md integrations-buttons flex-basis-full-xs\">\n                    <button type=\"button\" class=\"btn btn-default btn-md w-min-120 flex-basis-full-xs\"\n                            spinning-wheel [is-spinning-wheel-active]=\"isFundySpinningWheelActive\" [is-spinning-wheel-dark]=\"'true'\"\n                            *ngIf=\"!connectedToFundy\"\n                            [disabled]=\"lockIntegrationButtons\"\n                            (click)=\"connectToFundy()\"\n                    >Enable</button>\n\n                    <button type=\"button\" class=\"btn btn-default w-min-120 flex-basis-full-xs\"\n                            spinning-wheel [is-spinning-wheel-active]=\"isFundyDisconnectSpinningWheelActive\" [is-spinning-wheel-dark]=\"'true'\"\n                            *ngIf=\"connectedToFundy\"\n                            [disabled]=\"lockIntegrationButtons\"\n                            (click)=\"disconnectFundy()\"\n                    >Disable\n                    </button>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"integrations-wrap flex-row flex-wrap-md flex-item-xs-min flex-just-center flex-basis-full-sm flex-item-sm integrations-align-top\" *ngIf=\"proSelectAvailable\">\n            <div class=\"flex-align flex-item-w-100-lg\" style=\"height: 100px;\">\n                <img src=\"https://app.studioninja.co/build/release-pipeline-119/resources/dist/assets/images/icons/integration-icons/proSelect.png\">\n            </div>\n            <div class=\"flex-row flex-wrap-lg-max flex-wrap-sm-min flex-just-center integrations-main-info p-0\">\n                <div class=\"ps-10\">\n                    <h4 class=\"mt-0 mb-15\">ProSelect</h4>\n                    <p class=\"f-s-14-i mb-0\">\n                        Enable ProSelect-friendly features to import invoices from ProSelect.\n                    </p>\n                </div>\n                <div class=\"flex-align flex-item-w-100-md integrations-buttons flex-basis-full-xs\">\n                    <button type=\"button\" class=\"btn btn-default btn-md w-min-120 flex-basis-full-xs\"\n                            spinning-wheel [is-spinning-wheel-active]=\"isProSelectSpinningWheelActive\" [is-spinning-wheel-dark]=\"'true'\"\n                            *ngIf=\"!connectedToProSelect\"\n                            [disabled]=\"lockIntegrationButtons\"\n                            (click)=\"connectToProSelect()\"\n                    >Enable</button>\n\n                    <button type=\"button\" class=\"btn btn-default w-min-120 flex-basis-full-xs\"\n                            spinning-wheel [is-spinning-wheel-active]=\"isProSelectDisconnectSpinningWheelActive\" [is-spinning-wheel-dark]=\"'true'\"\n                            *ngIf=\"connectedToProSelect\"\n                            [disabled]=\"lockIntegrationButtons\"\n                            (click)=\"disconnectProSelect()\"\n                    >Disable\n                    </button>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n</section>\n"

/***/ }),

/***/ "./web/modern/components/settings/integrations-section/integrations-section.scss":
/***/ (function(module, exports) {

module.exports = ".quickbooks-custom-connect {\n  position: relative;\n  border-radius: 2px;\n  color: #2fa204;\n  padding: 11px 15px !important;\n  font-weight: 600;\n  text-align: end; }\n  @media (max-width: 768px) {\n    .quickbooks-custom-connect {\n      text-align: center; } }\n  .quickbooks-custom-connect img {\n    position: absolute;\n    max-width: 30px;\n    left: 5px;\n    top: 5px; }\n    @media (max-width: 768px) {\n      .quickbooks-custom-connect img {\n        position: relative;\n        top: 0;\n        margin-right: 10px; } }\n"

/***/ }),

/***/ "./web/modern/components/settings/integrations-section/integrations-section.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var common_1 = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var integrations_data_service_1 = __webpack_require__("./shared/services/integrations/integrations.data.service.ts");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var shootProof_data_service_1 = __webpack_require__("./shared/services/integrations/shootProof/shootProof.data.service.ts");
var settings_1 = __webpack_require__("./shared/services/settings/settings.ts");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var integrate_quick_books_modal_1 = __webpack_require__("./web/modern/components/settings/integrations-section/modals/integrate-quick-books-modal/integrate-quick-books-modal.ts");
var integrate_shoot_proof_modal_1 = __webpack_require__("./web/modern/components/settings/integrations-section/modals/integrate-shoot-proof-modal/integrate-shoot-proof-modal.ts");
var integrate_with_xero_v2_modal_1 = __webpack_require__("./web/modern/components/settings/integrations-section/modals/integrate-with-xero-v2/integrate-with-xero-v2-modal.ts");
var integrate_xero_modal_1 = __webpack_require__("./web/modern/components/settings/integrations-section/modals/integrate-xero-modal/integrate-xero-modal.ts");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var pickTime_data_service_1 = __webpack_require__("./shared/services/integrations/pickTime/pickTime.data.service.ts");
var integrate_pic_time_modal_1 = __webpack_require__("./web/modern/components/settings/integrations-section/modals/integrate-pic-time-modal/integrate-pic-time-modal.ts");
var confirm_general_modal_component_1 = __webpack_require__("./web/modern/components/common/confirm-general-modal/confirm-general-modal.component.ts");
var IntegrationsSection = function () {
    function IntegrationsSection(integrationsDataService, messageService, shootProofDataService, settingsService, modalService, pickTimeDataProvider, location) {
        _classCallCheck(this, IntegrationsSection);

        this.integrationsDataService = integrationsDataService;
        this.messageService = messageService;
        this.shootProofDataService = shootProofDataService;
        this.settingsService = settingsService;
        this.modalService = modalService;
        this.pickTimeDataProvider = pickTimeDataProvider;
        this.location = location;
        this.breadcrumbs = [{ link: '/', title: 'Dashboard' }, { link: '/settings', title: 'Settings' }, { link: null, title: 'Integrations' }];
        this.accountsQB = {};
        this.accountsList = {};
        this.shootProofCode = null;
        this.qbIntegration = null;
        this.xeroIntegration = null;
        this.shootProofIntegration = null;
        this.picTimeIntegration = null;
        this.xeroV2Connections = null;
        this.unsubscribe = new Subject_1.Subject();
    }

    _createClass(IntegrationsSection, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.getIntegrationStatus();
            this.initSettingsIntegration();
            var token = this.routeParams.xero;
            var tokenPicTime = this.routeParams.accessToken;
            if (token) {
                if (this.activeToken !== token) {
                    this.activeToken = token;
                    this.handleReceivedToken(token);
                }
            } else if (tokenPicTime) {
                this.handlePicTimeToken(tokenPicTime);
            } else {
                this.activeToken = '';
            }
            this.trackXeroV2Redirect();
            if (window.location.search.includes('?cancel=yes')) {
                window.history.replaceState(null, null, window.location.pathname.replace(window.location.pathname, '/settings/integrations'));
            }
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "getIntegrationStatus",
        value: function getIntegrationStatus() {
            var _this = this;

            this.lockIntegrationButtons = true;
            this.integrationsDataService.getIntegrationsV1().pipe(operators_1.takeUntil(this.unsubscribe), operators_1.finalize(function () {
                return _this.lockIntegrationButtons = false;
            })).subscribe(function (data) {
                return _this.successGetIntegrationStatus(data);
            }, function (error) {
                return _this.errorGetIntegrationStatus(error);
            });
        }
    }, {
        key: "initSettingsIntegration",
        value: function initSettingsIntegration() {
            var _this2 = this;

            this.settingsService.timeFormatSettings.pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (data) {
                if (data.fundyAvailable) {
                    _this2.fundyAvailable = true;
                    if (data.fundyIntegration === 'ENABLED') {
                        _this2.connectedToFundy = true;
                    }
                }
                if (data.proSelectAvailable) {
                    _this2.proSelectAvailable = true;
                    if (data.proSelectIntegration === 'ENABLED') {
                        _this2.connectedToProSelect = true;
                    }
                }
                if (data.picTimeAvailable) {
                    _this2.picTimeAvailable = true;
                }
            });
        }
    }, {
        key: "successGetIntegrationStatus",
        value: function successGetIntegrationStatus(data) {
            var xeroIntegration = data.xeroIntegration,
                qbIntegration = data.qbIntegration,
                shootProofIntegration = data.shootProofIntegration,
                picTimeIntegration = data.picTimeIntegration;

            this.qbIntegration = qbIntegration;
            this.xeroIntegration = xeroIntegration;
            this.shootProofIntegration = shootProofIntegration;
            this.picTimeIntegration = picTimeIntegration;
            if (xeroIntegration.connectedOrganisation) {
                this.xeroOrganization = xeroIntegration.connectedOrganisation.connectedOrganisation;
            } else if (qbIntegration.connectedOrganisation) {
                this.quickbooksOrganization = qbIntegration.connectedOrganisation.connectedOrganisation;
            } else {
                console.log('NO_INTEGRATION');
            }
            if (shootProofIntegration.connectedOrganisation) {
                this.shootProofCompanyName = shootProofIntegration.connectedOrganisation.connectedOrganisation;
            }
            if (picTimeIntegration.actions.CONNECT_PIC_TIME) {
                this.connectedToPicTime = false;
            } else {
                this.connectedToPicTime = true;
            }
            this.picTimeCompanyName = picTimeIntegration.accountName;
        }
    }, {
        key: "errorGetIntegrationStatus",
        value: function errorGetIntegrationStatus(_ref) {
            var error = _ref.error;
            var errorTitle = error.errorTitle,
                errorMessage = error.errorMessage;

            this.messageService.showErrorFromBackend(errorTitle, errorMessage);
        }
    }, {
        key: "handleReceivedToken",
        value: function handleReceivedToken(token) {
            var params = this.routeParams;
            this.lockIntegrationButtons = true;
            if (token === 'xero') {
                this.messageService.showToaster('i_0', 'xero');
                this.handleXeroToken(params);
            } else if (token === 'qb') {
                this.messageService.showToaster('i_0', 'qb');
                this.handleQuickbooksToken(params);
            } else if (token === 'shootproof') {
                this.messageService.showToaster('i_0', 'shootProof');
                this.handleShootproofToken(params);
            } else {
                console.error('Unknown token');
            }
        }
    }, {
        key: "handleXeroToken",
        value: function handleXeroToken(params) {
            this.isXeroSpinningWheelActive = true;
            if (this.accountsList) {
                delete this.accountsList;
            }
            this.saveXeroIntegration(params);
        }
    }, {
        key: "saveXeroIntegration",
        value: function saveXeroIntegration(params) {
            var _this3 = this;

            this.integrationsDataService.sendXeroToken(params).pipe(operators_1.finalize(function () {
                _this3.isXeroSpinningWheelActive = false;
                _this3.lockIntegrationButtons = false;
            }), operators_1.takeUntil(this.unsubscribe)).subscribe(function (data) {
                return _this3.showChooseAccountModal(data);
            }, function (error) {
                return _this3.messageService.showDefaultErrorMessage(error);
            });
        }
    }, {
        key: "initXeroIntegration",
        value: function initXeroIntegration() {
            var _this4 = this;

            if (this.confirmModalRequired(this.xeroIntegration.actions.CONNECT_V0) || this.confirmModalRequired(this.xeroIntegration.actions.CONNECT)) {
                return;
            }
            this.lockIntegrationButtons = true;
            this.isXeroSpinningWheelActive = true;
            if (this.xeroIntegration.actions.CONNECT_V0) {
                this.integrationsDataService.initXeroIntegration().pipe(operators_1.finalize(function () {
                    _this4.isXeroSpinningWheelActive = false;
                    _this4.lockIntegrationButtons = false;
                }), operators_1.takeUntil(this.unsubscribe)).subscribe(function (data) {
                    _this4.doRedirect(data.value);
                }, function (result) {
                    return _this4.errorConnectToXero(result.data);
                });
            }
            if (this.xeroIntegration.actions.CONNECT) {
                this.doRedirect(this.xeroIntegration.actions.CONNECT.url);
            }
        }
    }, {
        key: "editXeroIntegrationSettings",
        value: function editXeroIntegrationSettings() {
            var _this5 = this;

            this.lockIntegrationButtons = true;
            this.isXeroSpinningWheelActive = true;
            var connectedOrganisation = this.xeroIntegration.connectedOrganisation;

            if (connectedOrganisation.actions && connectedOrganisation.actions.EDIT_V0) {
                this.integrationsDataService.editXeroSettings().pipe(operators_1.finalize(function () {
                    _this5.isXeroSpinningWheelActive = false;
                    _this5.lockIntegrationButtons = false;
                }), operators_1.takeUntil(this.unsubscribe)).subscribe(function (data) {
                    return _this5.showChooseAccountModal(data);
                }, function (error) {
                    return _this5.editXeroSettingsErrorCallback(error);
                });
            }
            if (connectedOrganisation.actions && connectedOrganisation.actions.EDIT) {
                this.getXeroV2ModalData(connectedOrganisation.actions.EDIT.url);
            }
        }
    }, {
        key: "showChooseAccountModal",
        value: function showChooseAccountModal(accountsList) {
            this.accountsList = Object.assign({}, accountsList);
            this.integrateXeroModalRef = this.modalService.openModal(integrate_xero_modal_1.IntegrateXeroModal, {
                windowClass: 'ng-bootstrap-modal-middle'
            });
            this.integrateXeroModalRef.componentInstance.accountList = this.accountsList;
        }
    }, {
        key: "confirmModalRequired",
        value: function confirmModalRequired(xeroAction) {
            if (xeroAction && xeroAction.method === 'ALERT_MODAL' && xeroAction.alertMessage.errorCode === 801) {
                var _xeroAction$alertMess = xeroAction.alertMessage,
                    title = _xeroAction$alertMess.title,
                    message = _xeroAction$alertMess.message;

                this.openXeroAlertModal(title, message);
                return true;
            } else if (xeroAction && xeroAction.method === 'ALERT_MODAL' && xeroAction.alertMessage.errorCode === 102) {
                var _xeroAction$alertMess2 = xeroAction.alertMessage,
                    _title = _xeroAction$alertMess2.title,
                    _message = _xeroAction$alertMess2.message;

                this.openXeroAlertModalWithoutRedirection(_title, _message);
                return true;
            }
            return false;
        }
    }, {
        key: "editXeroSettingsErrorCallback",
        value: function editXeroSettingsErrorCallback(_ref2) {
            var data = _ref2.data,
                status = _ref2.status;

            var errorMessage = data ? data.errorMessage : null;
            var errorCode = void 0,
                errorPlace = void 0;
            if (errorMessage && status >= 400 && status < 500) {
                if (errorMessage.includes('Xero access token expired, reconnect Xero please') || errorMessage.includes('Bummer! Xero access token not authorized or revoked, reconnect Xero please') || errorMessage.includes('Bummer! Xero access token revoked, reconnect Xero please')) {
                    errorCode = 'e_14';
                    errorPlace = 'xero';
                } else if (errorMessage.includes("You don't have an active Xero subscription")) {
                    errorCode = 'e_15';
                    errorPlace = 'xero';
                }
            } else {
                errorCode = 'e_0';
                errorPlace = 'general';
            }
            this.messageService.showToaster(errorCode, errorPlace);
        }
    }, {
        key: "disconnectXero",
        value: function disconnectXero() {
            var _this6 = this;

            this.lockIntegrationButtons = true;
            this.isXeroDisconnectSpinningWheelActive = true;
            var connectedOrganisation = this.xeroIntegration.connectedOrganisation;

            if (connectedOrganisation.actions && connectedOrganisation.actions.DISCONNECT_V0) {
                this.integrationsDataService.disconnectXero().pipe(operators_1.finalize(function () {
                    _this6.lockIntegrationButtons = false;
                    _this6.isXeroDisconnectSpinningWheelActive = false;
                }), operators_1.takeUntil(this.unsubscribe)).subscribe(function () {
                    return _this6.successDisconnectXero();
                }, function (error) {
                    return _this6.messageService.showDefaultErrorMessage(error);
                });
            }
            if (connectedOrganisation.actions && connectedOrganisation.actions.DISCONNECT) {
                this.integrationsDataService.disconnectXeroV2(connectedOrganisation.actions.DISCONNECT.url).pipe(operators_1.finalize(function () {
                    _this6.lockIntegrationButtons = false;
                    _this6.isXeroDisconnectSpinningWheelActive = false;
                }), operators_1.takeUntil(this.unsubscribe)).subscribe(function () {
                    return _this6.successDisconnectXero();
                }, function (err) {
                    return _this6.errorGetIntegrationStatus(err);
                });
            }
        }
    }, {
        key: "trackXeroV2Redirect",
        value: function trackXeroV2Redirect() {
            if (window.location.pathname.includes('/integrations/xero/connect/complete')) {
                this.messageService.showToaster('i_0', 'xero');
                this.getXeroV2ModalData();
            }
        }
    }, {
        key: "getXeroV2ModalData",
        value: function getXeroV2ModalData(url) {
            var _this7 = this;

            this.lockIntegrationButtons = true;
            this.isXeroSpinningWheelActive = true;
            this.integrationsDataService.getXeroAuthorizedConnections(url).pipe(operators_1.finalize(function () {
                _this7.lockIntegrationButtons = false;
                _this7.isXeroSpinningWheelActive = false;
            }), operators_1.takeUntil(this.unsubscribe)).subscribe(function (data) {
                _this7.xeroV2Connections = data;
                _this7.integrateWithXeroV2Modal = _this7.modalService.openModal(integrate_with_xero_v2_modal_1.IntegrateWithXeroV2Modal, {
                    windowClass: 'ng-bootstrap-modal-middle'
                });
                _this7.integrateWithXeroV2Modal.componentInstance.connectionsData = _this7.xeroV2Connections;
                _this7.integrateWithXeroV2Modal.result.then(function (state) {
                    _this7.onSaveXeroConnection(state);
                });
            }, function (err) {
                return _this7.errorGetIntegrationStatus(err);
            });
        }
    }, {
        key: "onSaveXeroConnection",
        value: function onSaveXeroConnection(state) {
            if (state) {
                this.messageService.showToaster('s_0', 'xero');
            }
        }
        // QUICKBOOKS

    }, {
        key: "handleQuickbooksToken",
        value: function handleQuickbooksToken(params) {
            this.isQbSpinningWheelActive = true;
            if (this.accountsQB) {
                delete this.accountsQB;
            }
            this.saveQuickbooksIntegration(params);
        }
    }, {
        key: "saveQuickbooksIntegration",
        value: function saveQuickbooksIntegration(params) {
            var _this8 = this;

            this.integrationsDataService.sendQuickbooksToken(params).pipe(operators_1.finalize(function () {
                _this8.isQbSpinningWheelActive = false;
                _this8.lockIntegrationButtons = false;
            }), operators_1.takeUntil(this.unsubscribe)).subscribe(function (data) {
                return _this8.showQuickBooksModal(data);
            }, function (err) {
                return _this8.errorSend(err);
            });
        }
    }, {
        key: "errorSend",
        value: function errorSend(err) {
            var data = err.data || null;
            if (!data) {
                return;
            }
            if (data.errorMessage.includes('companies are not supported yet')) {
                this.messageService.showToaster('e_8', 'qb');
            } else if (data.errorMessage === 'Sorry, your QuickBooks company should have at least one Sales account') {
                this.messageService.showToaster('e_2', 'qb');
            } else if (data.errorMessage === 'Sorry, your QuickBooks company should have at least one Tax Code with sales tax rates') {
                this.messageService.showToaster('e_21', 'qb');
            }
        }
    }, {
        key: "initQuickbooksIntegration",
        value: function initQuickbooksIntegration() {
            var _this9 = this;

            this.lockIntegrationButtons = true;
            this.isQbSpinningWheelActive = true;
            if (this.qbIntegration && this.qbIntegration.actions.CONNECT_V0.method === 'ALERT_MODAL' && this.qbIntegration.actions.CONNECT_V0.alertMessage.errorCode === 102) {
                var _qbIntegration$action = this.qbIntegration.actions.CONNECT_V0.alertMessage,
                    title = _qbIntegration$action.title,
                    message = _qbIntegration$action.message;

                this.openXeroAlertModalWithoutRedirection(title, message);
                this.lockIntegrationButtons = false;
                this.isQbSpinningWheelActive = false;
                return;
            }
            if (this.qbIntegration.actions.CONNECT_V0) {
                this.integrationsDataService.initQuickbooksIntegration().pipe(operators_1.finalize(function () {
                    _this9.isQbSpinningWheelActive = false;
                    _this9.lockIntegrationButtons = false;
                }), operators_1.takeUntil(this.unsubscribe)).subscribe(function (data) {
                    return _this9.doRedirect(data.value);
                }, function (error) {
                    return _this9.errorConnectToToQuickbooks(error);
                });
            }
        }
    }, {
        key: "errorConnectToToQuickbooks",
        value: function errorConnectToToQuickbooks(_ref3) {
            var data = _ref3.data,
                status = _ref3.status;

            var errorMessage = data.errorMessage;
            var errorCode = void 0,
                errorPlace = void 0,
                value = void 0;
            if (errorMessage && status >= 400 && status < 500) {
                if (errorMessage === 'You already have integration with accounting service') {
                    var title = 'Slow down, Quickbooks error!';
                    var text = 'Your account is already connected with another accounting platform. Please disconnect and try again.';
                    this.openXeroAlertModalWithoutRedirection(title, text);
                    return;
                }
                switch (errorMessage) {
                    case 'Sorry, your QuickBooks company should have at least one Sales account':
                        errorCode = 'e_2';
                        errorPlace = 'qb';
                        break;
                    default:
                        errorCode = 'e_2';
                        errorPlace = 'general';
                        value = errorMessage;
                }
            } else {
                errorCode = 'e_0';
                errorPlace = 'general';
            }
            this.messageService.showToaster(errorCode, errorPlace, value);
        }
    }, {
        key: "editQuickBooksIntegrationSettings",
        value: function editQuickBooksIntegrationSettings() {
            var _this10 = this;

            this.lockIntegrationButtons = true;
            this.isQbSpinningWheelActive = true;
            this.integrationsDataService.editQuickBooksSettings().pipe(operators_1.finalize(function () {
                _this10.isQbSpinningWheelActive = false;
                _this10.lockIntegrationButtons = false;
            }), operators_1.takeUntil(this.unsubscribe)).subscribe(function (data) {
                return _this10.showQuickBooksModal(data);
            }, function (error) {
                return _this10.messageService.showDefaultErrorMessage(error);
            });
        }
    }, {
        key: "showQuickBooksModal",
        value: function showQuickBooksModal(accountsQB) {
            this.accountsQB = Object.assign({}, accountsQB);
            this.integrateQuickBooksModalRef = this.modalService.openModal(integrate_quick_books_modal_1.IntegrateQuickBooksModal, {
                windowClass: 'ng-bootstrap-modal-middle'
            });
            this.integrateQuickBooksModalRef.componentInstance.accountList = this.accountsQB;
        }
    }, {
        key: "disconnectQuickbooks",
        value: function disconnectQuickbooks() {
            var _this11 = this;

            this.lockIntegrationButtons = true;
            this.isQbDisconnectSpinningWheelActive = true;
            this.integrationsDataService.disconnectQuickbooks().pipe(operators_1.finalize(function () {
                _this11.lockIntegrationButtons = false;
                _this11.isQbDisconnectSpinningWheelActive = false;
            }), operators_1.takeUntil(this.unsubscribe)).subscribe(function () {
                return _this11.successDisconnectQuickbooks();
            }, function (error) {
                return _this11.messageService.showDefaultErrorMessage(error);
            });
        }
        // ShootProof

    }, {
        key: "initShootProofIntegration",
        value: function initShootProofIntegration() {
            var _this12 = this;

            this.lockIntegrationButtons = true;
            this.isShootProofSpinningWheelActive = true;
            this.shootProofDataService.initShootProofIntegrationV1().pipe(operators_1.finalize(function () {
                _this12.isShootProofSpinningWheelActive = false;
                _this12.lockIntegrationButtons = false;
            }), operators_1.takeUntil(this.unsubscribe)).subscribe(function (data) {
                return _this12.doRedirect(data.data.url);
            }, function (error) {
                return _this12.messageService.showDefaultErrorMessage(error);
            });
        }
    }, {
        key: "handleShootproofToken",
        value: function handleShootproofToken(params) {
            if (!params.error) {
                this.saveShootProofIntegration(params);
            } else {
                window.history.replaceState(null, null, window.location.pathname.replace('/shootproof', ''));
            }
        }
    }, {
        key: "saveShootProofIntegration",
        value: function saveShootProofIntegration(params) {
            var _this13 = this;

            this.shootProofDataService.getExistingShootProofSettingsV1().pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (result) {
                _this13.shootProofIntroduction = result.data !== null ? result.data.clientPortalText : '';
                _this13.shootProofCode = params.code;
                _this13.integrateShootProofModalRef = _this13.modalService.openModal(integrate_shoot_proof_modal_1.IntegrateShootProofModal, {
                    windowClass: 'ng-bootstrap-modal-middle'
                });
                _this13.integrateShootProofModalRef.componentInstance.introductionText = _this13.shootProofIntroduction;
                _this13.integrateShootProofModalRef.componentInstance.shootProofCode = _this13.shootProofCode;
            }, function (error) {
                return _this13.messageService.showDefaultErrorMessage(error);
            });
        }
    }, {
        key: "editShootProofIntegrationSettings",
        value: function editShootProofIntegrationSettings() {
            var _this14 = this;

            this.lockIntegrationButtons = true;
            this.isShootProofSpinningWheelActive = true;
            this.shootProofDataService.getExistingShootProofSettingsV1().pipe(operators_1.finalize(function () {
                _this14.isShootProofSpinningWheelActive = false;
                _this14.lockIntegrationButtons = false;
            }), operators_1.takeUntil(this.unsubscribe)).subscribe(function (result) {
                _this14.shootProofCode = null;
                _this14.shootProofIntroduction = result.data.clientPortalText || '';
                _this14.integrateShootProofModalRef = _this14.modalService.openModal(integrate_shoot_proof_modal_1.IntegrateShootProofModal, {
                    windowClass: 'ng-bootstrap-modal-middle'
                });
                _this14.integrateShootProofModalRef.componentInstance.introductionText = _this14.shootProofIntroduction;
            }, function (error) {
                return _this14.messageService.showDefaultErrorMessage(error);
            });
        }
    }, {
        key: "disconnectShootProof",
        value: function disconnectShootProof() {
            var _this15 = this;

            this.lockIntegrationButtons = true;
            this.isSpDisconnectSpinningWheelActive = true;
            this.shootProofDataService.disconnectShootProofV1().pipe(operators_1.finalize(function () {
                _this15.lockIntegrationButtons = false;
                _this15.isSpDisconnectSpinningWheelActive = false;
            }), operators_1.takeUntil(this.unsubscribe)).subscribe(function () {
                return _this15.successDisconnectShootProof();
            }, function (error) {
                return _this15.messageService.showDefaultErrorMessage(error);
            });
        }
        // Fundy

    }, {
        key: "connectToFundy",
        value: function connectToFundy() {
            var _this16 = this;

            this.lockIntegrationButtons = true;
            this.isFundySpinningWheelActive = true;
            this.integrationsDataService.updateFundyIntegrationState(true).pipe(operators_1.finalize(function () {
                _this16.lockIntegrationButtons = false;
                _this16.isFundySpinningWheelActive = false;
            }), operators_1.takeUntil(this.unsubscribe)).subscribe(function () {
                _this16.messageService.showToaster('s_0', 'fundy');
                _this16.connectedToFundy = true;
            }, function (error) {
                _this16.messageService.showDefaultErrorMessage(error);
            });
        }
    }, {
        key: "disconnectFundy",
        value: function disconnectFundy() {
            var _this17 = this;

            this.lockIntegrationButtons = true;
            this.isFundyDisconnectSpinningWheelActive = true;
            this.integrationsDataService.updateFundyIntegrationState(false).pipe(operators_1.finalize(function () {
                _this17.lockIntegrationButtons = false;
                _this17.isFundyDisconnectSpinningWheelActive = false;
            }), operators_1.takeUntil(this.unsubscribe)).subscribe(function () {
                _this17.messageService.showToaster('s_1', 'fundy');
                _this17.connectedToFundy = false;
            }, function (error) {
                _this17.messageService.showDefaultErrorMessage(error);
            });
        }
        // ProSelect

    }, {
        key: "connectToProSelect",
        value: function connectToProSelect() {
            var _this18 = this;

            this.lockIntegrationButtons = true;
            this.isProSelectSpinningWheelActive = true;
            this.integrationsDataService.updateProSelectIntegrationState(true).pipe(operators_1.finalize(function () {
                _this18.lockIntegrationButtons = false;
                _this18.isProSelectSpinningWheelActive = false;
            }), operators_1.takeUntil(this.unsubscribe)).subscribe(function () {
                _this18.messageService.showToaster('s_0', 'proSelect');
                _this18.connectedToProSelect = true;
            }, function (error) {
                _this18.messageService.handleError(error);
            });
        }
    }, {
        key: "disconnectProSelect",
        value: function disconnectProSelect() {
            var _this19 = this;

            this.lockIntegrationButtons = true;
            this.isProSelectDisconnectSpinningWheelActive = true;
            this.integrationsDataService.updateProSelectIntegrationState(false).pipe(operators_1.finalize(function () {
                _this19.lockIntegrationButtons = false;
                _this19.isProSelectDisconnectSpinningWheelActive = false;
            }), operators_1.takeUntil(this.unsubscribe)).subscribe(function () {
                _this19.messageService.showToaster('s_1', 'proSelect');
                _this19.connectedToProSelect = false;
            }, function (error) {
                _this19.messageService.handleError(error);
            });
        }
        // Helpers

    }, {
        key: "successDisconnectShootProof",
        value: function successDisconnectShootProof() {
            this.shootProofCompanyName = null;
            this.messageService.showToaster('s_10', 'shootProof');
            this.getIntegrationStatus();
        }
    }, {
        key: "successDisconnectQuickbooks",
        value: function successDisconnectQuickbooks() {
            this.quickbooksOrganization = null;
            this.messageService.showToaster('s_1', 'qb');
            this.getIntegrationStatus();
        }
    }, {
        key: "successDisconnectXero",
        value: function successDisconnectXero() {
            this.xeroOrganization = null;
            this.xeroIntegration = null;
            this.messageService.showToaster('s_2', 'xero');
            this.getIntegrationStatus();
        }
    }, {
        key: "successDisconnectPicTime",
        value: function successDisconnectPicTime() {
            this.connectedToPicTime = false;
            this.picTimeIntegration = null;
            this.messageService.showToaster('s_1', 'picTime');
            this.getIntegrationStatus();
        }
    }, {
        key: "doRedirect",
        value: function doRedirect(url) {
            this.lockIntegrationButtons = true;
            window.location.assign(url);
        }
    }, {
        key: "errorConnectToXero",
        value: function errorConnectToXero(data) {
            if (data.errorMessage === 'You already have integration with accounting service') {
                this.messageService.showToaster('e_13', 'xero');
            }
        }
        // Pic-Time

    }, {
        key: "connectToPicTime",
        value: function connectToPicTime() {
            var _this20 = this;

            this.lockIntegrationButtons = true;
            this.isPicTimeSpinningWheelActive = true;
            this.pickTimeDataProvider.initPickTimeIntegration().pipe(operators_1.finalize(function () {
                _this20.lockIntegrationButtons = true;
                _this20.isPicTimeSpinningWheelActive = true;
            }), operators_1.takeUntil(this.unsubscribe)).subscribe(function (data) {
                _this20.doRedirect(data.data.integrationUrl);
            }, function (error) {
                _this20.messageService.handleError(error);
            });
        }
    }, {
        key: "handlePicTimeToken",
        value: function handlePicTimeToken(tokenPickTime) {
            this.isPicTimeSpinningWheelActive = true;
            if (!this.routeParams.error) {
                this.savePicTimeIntegration(tokenPickTime);
            } else {
                window.history.replaceState(null, null, window.location.pathname.replace(window.location.pathname, '/settings/integrations'));
            }
        }
    }, {
        key: "savePicTimeIntegration",
        value: function savePicTimeIntegration(tokenPickTime) {
            var _this21 = this;

            this.pickTimeDataProvider.getPreFillPicTimeSettings().pipe(operators_1.finalize(function () {
                _this21.isPicTimeSpinningWheelActive = false;
            }), operators_1.takeUntil(this.unsubscribe)).subscribe(function (data) {
                _this21.clientPortalText = data.data.clientPortalText !== null ? data.data.clientPortalText : '';
                _this21.picTimeAccessToken = tokenPickTime;
                _this21.integratePickTimeModalRef = _this21.modalService.openModal(integrate_pic_time_modal_1.IntegratePicTimeModal, {
                    windowClass: 'ng-bootstrap-modal-middle'
                });
                _this21.integratePickTimeModalRef.componentInstance.clientPortalText = _this21.clientPortalText;
                _this21.integratePickTimeModalRef.componentInstance.picTimeAccessToken = _this21.picTimeAccessToken;
                _this21.integratePickTimeModalRef.result.then(function (value) {
                    if (value) {
                        _this21.connectedToPicTime = true;
                    }
                });
            }, function (error) {
                return _this21.messageService.handleError(error);
            });
        }
    }, {
        key: "editPicTimeIntegrationSettings",
        value: function editPicTimeIntegrationSettings() {
            var _this22 = this;

            this.pickTimeDataProvider.getPreFillPicTimeSettings().pipe(operators_1.finalize(function () {
                _this22.isPicTimeSpinningWheelActive = false;
            }), operators_1.takeUntil(this.unsubscribe)).subscribe(function (data) {
                _this22.clientPortalText = data.data.clientPortalText !== null ? data.data.clientPortalText : '';
                _this22.integratePickTimeModalRef = _this22.modalService.openModal(integrate_pic_time_modal_1.IntegratePicTimeModal, {
                    windowClass: 'ng-bootstrap-modal-middle'
                });
                _this22.integratePickTimeModalRef.componentInstance.clientPortalText = _this22.clientPortalText;
            }, function (error) {
                return _this22.messageService.handleError(error);
            });
        }
    }, {
        key: "disconnectPicTime",
        value: function disconnectPicTime() {
            var _this23 = this;

            this.lockIntegrationButtons = true;
            this.isPicTimeDisconnectSpinningWheelActive = true;
            if (this.picTimeIntegration.actions.DISCONNECT_PIC_TIME) {
                this.pickTimeDataProvider.disconnectPickTimeIntegration(this.picTimeIntegration.actions.DISCONNECT_PIC_TIME.url).pipe(operators_1.finalize(function () {
                    _this23.lockIntegrationButtons = false;
                    _this23.isPicTimeDisconnectSpinningWheelActive = false;
                }), operators_1.takeUntil(this.unsubscribe)).subscribe(function () {
                    _this23.successDisconnectPicTime();
                }, function (error) {
                    return _this23.messageService.handleError(error);
                });
            }
        }
    }, {
        key: "openXeroAlertModal",
        value: function openXeroAlertModal(title, message) {
            var _this24 = this;

            var modal = this.modalService.openModal(confirm_general_modal_component_1.ConfirmGeneralModalComponent);
            modal.componentInstance.title = title;
            modal.componentInstance.text = message;
            modal.componentInstance.buttons = [{
                text: 'Cancel',
                color: 'default',
                size: 'lg',
                action: 'DISCARD_ALERT'
            }, {
                text: 'Continue to 2FA setup',
                color: 'success',
                size: 'lg',
                action: 'REDIRECT_TO_PROFILE'
            }];
            modal.result.then(function (action) {
                if (action === 'REDIRECT_TO_PROFILE') {
                    _this24.location.go('/settings/profile/?redirectTo=2FA');
                }
            });
        }
    }, {
        key: "openXeroAlertModalWithoutRedirection",
        value: function openXeroAlertModalWithoutRedirection(title, message) {
            var modal = this.modalService.openModal(confirm_general_modal_component_1.ConfirmGeneralModalComponent);
            modal.componentInstance.title = title;
            modal.componentInstance.text = message;
            modal.componentInstance.buttons = [{
                text: 'Got it!',
                color: 'default',
                size: 'lg',
                action: 'REDIRECT_TO_PROFILE'
            }];
        }
    }]);

    return IntegrationsSection;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], IntegrationsSection.prototype, "routeParams", void 0);
IntegrationsSection = __decorate([core_1.Component({
    selector: 'integrations-section',
    template: __webpack_require__("./web/modern/components/settings/integrations-section/integrations-section.html"),
    styles: [__webpack_require__("./web/modern/components/settings/integrations-section/integrations-section.scss")]
}), __metadata("design:paramtypes", [integrations_data_service_1.IntegrationsDataProvider, message_service_1.MessageService, shootProof_data_service_1.ShootProofDataProvider, settings_1.SettingsProvider, snModal_service_1.SNModalService, pickTime_data_service_1.PickTimeDataProvider, common_1.Location])], IntegrationsSection);
exports.IntegrationsSection = IntegrationsSection;

/***/ }),

/***/ "./web/modern/components/settings/integrations-section/modals/integrate-pic-time-modal/integrate-pic-time-modal.html":
/***/ (function(module, exports) {

module.exports = "<form class=\"form-horizontal form-group\" (ngSubmit)=\"savePicTimeSettings()\">\n    <div class=\"modal-header\">\n        <button class=\"close\" (click)=\"onDismiss()\" data-dismiss=\"modal\">&times;</button>\n        <h3 class=\"modal-title\">Pic-Time Integration Settings</h3>\n    </div>\n    <div class=\"modal-body\">\n\n        <div class=\"integrate-galleries-settings-description\">\n            <p>Pic-Time galleries can be added to any Studio Ninja job. Once a gallery is\n                added, a \"Galleries\" page will appear inside the client portal for that job.</p>\n            <p>Enter an introduction below that your clients will see on the client portal's\n                Galleries page.</p>\n        </div>\n\n        <div class=\"field-info\">\n            <div class=\"row\">\n                <div class=\"col-xs-12\">\n                    <label>Galleries Page Introduction</label>\n                    <sn-quill-editor-web\n                            (onTextChange)=\"clientPortalText = $event\"\n                            [initValue]=\"clientPortalText\"\n                            [maxLength]=\"4000\" [toolbarSettings]=\"'image counter'\">\n                    </sn-quill-editor-web>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"modal-footer modal-foot pb-30\">\n        <button class=\"btn btn-success btn-submit pull-left\"\n                type=\"submit\"\n                [disabled]=\"button_disabled\"\n                spinning-wheel [is-spinning-wheel-active]=\"button_disabled\"\n        >Save Settings\n        </button>\n    </div>\n</form>\n"

/***/ }),

/***/ "./web/modern/components/settings/integrations-section/modals/integrate-pic-time-modal/integrate-pic-time-modal.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var ng_bootstrap_1 = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/index.js");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var pickTime_data_service_1 = __webpack_require__("./shared/services/integrations/pickTime/pickTime.data.service.ts");
var IntegratePicTimeModal = function () {
    function IntegratePicTimeModal(messageService, activeModal, pickTimeDataProvider) {
        _classCallCheck(this, IntegratePicTimeModal);

        this.messageService = messageService;
        this.activeModal = activeModal;
        this.pickTimeDataProvider = pickTimeDataProvider;
        this.unsubscribe = new Subject_1.Subject();
    }

    _createClass(IntegratePicTimeModal, [{
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "savePicTimeSettings",
        value: function savePicTimeSettings() {
            this.button_disabled = true;
            this.picTimeAccessToken ? this.setPicTimeSettings() : this.updatePicTimeSettings();
        }
    }, {
        key: "changePathAfterIntegration",
        value: function changePathAfterIntegration() {
            this.clientPortalText = '';
            this.button_disabled = false;
            if (this.picTimeAccessToken) {
                window.history.replaceState(null, null, window.location.pathname.replace(window.location.pathname, '/settings/integrations'));
            }
        }
    }, {
        key: "setPicTimeSettings",
        value: function setPicTimeSettings() {
            var _this = this;

            this.button_disabled = true;
            var authObj = {
                accessToken: this.picTimeAccessToken,
                clientPortalText: this.clientPortalText
            };
            this.pickTimeDataProvider.savePickTimeIntegration(authObj).pipe(operators_1.finalize(function () {
                _this.button_disabled = false;
            }), operators_1.takeUntil(this.unsubscribe)).subscribe(function () {
                _this.activeModal.close(true);
                _this.changePathAfterIntegration();
                _this.messageService.showToaster('s_0', 'picTime');
            }, function (error) {
                return _this.messageService.handleError(error);
            });
        }
    }, {
        key: "updatePicTimeSettings",
        value: function updatePicTimeSettings() {
            var _this2 = this;

            this.button_disabled = true;
            var settings = {
                clientPortalText: this.clientPortalText || ''
            };
            this.pickTimeDataProvider.updatePicTimeIntegration(settings).pipe(operators_1.finalize(function () {
                _this2.button_disabled = false;
            }), operators_1.takeUntil(this.unsubscribe)).subscribe(function () {
                _this2.activeModal.close();
                _this2.messageService.showToaster('s_5', 'picTime');
            }, function (error) {
                return _this2.messageService.handleError(error);
            });
        }
    }, {
        key: "onDismiss",
        value: function onDismiss() {
            this.activeModal.close();
            this.changePathAfterIntegration();
        }
    }]);

    return IntegratePicTimeModal;
}();
__decorate([core_1.Input(), __metadata("design:type", String)], IntegratePicTimeModal.prototype, "picTimeAccessToken", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], IntegratePicTimeModal.prototype, "clientPortalText", void 0);
IntegratePicTimeModal = __decorate([core_1.Component({
    selector: 'integrate-pic-time-modal',
    template: __webpack_require__("./web/modern/components/settings/integrations-section/modals/integrate-pic-time-modal/integrate-pic-time-modal.html")
}), __metadata("design:paramtypes", [message_service_1.MessageService, ng_bootstrap_1.NgbActiveModal, pickTime_data_service_1.PickTimeDataProvider])], IntegratePicTimeModal);
exports.IntegratePicTimeModal = IntegratePicTimeModal;

/***/ }),

/***/ "./web/modern/components/settings/integrations-section/modals/integrate-quick-books-modal/integrate-quick-books-modal.html":
/***/ (function(module, exports) {

module.exports = "<form class=\"form-horizontal form-group\" role=\"form\" (ngSubmit)=\"saveQuickBooksSettings()\">\n    <div class=\"modal-header\">\n        <button class=\"close\" (click)=\"onDismiss()\" data-dismiss=\"modal\">&times;</button>\n        <h3 class=\"modal-title\">QB integration settings</h3>\n    </div>\n    <div class=\"modal-body\">\n        <p class=\"f-s-15\">Creating invoices in Studio Ninja will automatically copy them to your Quickbooks account.</p>\n        <hr class=\"mb-30 mt-30\">\n        <div class=\"field-info\">\n            <h3 class=\"mb-30\"> Default revenue account </h3>\n            <p>Choose revenue account (we will copy your invoices to this account):</p>\n\n            <div class=\"flex-row\">\n                <div class=\"select-style flex-grow-1\">\n                    <select class=\"form-control\" [(ngModel)]=\"chosenAccount\" [ngModelOptions]=\"{standalone: true}\" required>\n                        <option *ngFor=\"let accountsQB of accountList?.accounts\" [ngValue]=\"accountsQB\">{{ accountsQB?.value }}</option>\n                    </select>\n                </div>\n\n            </div>\n        </div>\n        <hr class=\"mb-30 mt-30\">\n\n        <div class=\"field-info\">\n            <h3 class=\"mb-30\"> Default payment account </h3>\n            <div class=\"flex-box mb-30\">\n                <div class=\"checkbox-squared\">\n                    <input type=\"checkbox\" id=\"{{checkboxId}}\" [(ngModel)]=\"isChecked\" [ngModelOptions]=\"{standalone: true}\"/>\n                    <label for=\"{{checkboxId}}\"></label>\n                </div>\n                <label for=\"{{checkboxId}}\"> Sync payments with Quickbooks </label>\n            </div>\n\n            <ng-container *ngIf=\"isChecked\">\n                <p> Choose payment account (all Studio Ninja payments will be applied to this account): </p>\n                <div class=\"select-style flex-grow-1\">\n\n                    <select  class=\"form-control\" [(ngModel)]=\"chosenTaxCodes\" [ngModelOptions]=\"{standalone: true}\" required>\n                        <option *ngFor=\"let accountsQB of accountList?.taxCodes\" [ngValue]=\"accountsQB\">{{ accountsQB?.value }}</option>\n                    </select>\n\n                </div>\n                <div class=\"flex-row flex-wrap-xs warning-message m-0 mt-30\">\n                    <img src=\"https://app.studioninja.co/build/release-pipeline-119/resources/dist/assets/images/icons/warning-sign-icon.png\" class=\"warning-message__img\" alt=\"warning-sign\">\n                    <div class=\"warning-message__text mr-10\">\n                        <p>If you’re receiving payments via Stripe or PayPal and your Quickbooks account is connected to your bank feed, syncing payments with Quickbooks may cause the same payment to be recorded twice. To avoid recording the same payment twice, disable “sync payments with Quickbooks”.</p>\n                    </div>\n                </div>\n            </ng-container>\n        </div>\n    </div>\n\n    <div class=\"modal-footer modal-foot pb-30\">\n        <button class=\"btn btn-success btn-submit pull-left\"\n                type=\"submit\"\n                [disabled]=\"button_disabled\"\n                spinning-wheel [is-spinning-wheel-active]=\"button_disabled\"\n\n        >Save settings\n        </button>\n        <button type=\"button\" class=\"btn btn-lg btn-default ml-10\"\n                data-dismiss=\"modal\"\n                (click)=\"onDismiss()\"\n                [disabled]=\"button_disabled\"\n        >Cancel\n        </button>\n    </div>\n</form>\n"

/***/ }),

/***/ "./web/modern/components/settings/integrations-section/modals/integrate-quick-books-modal/integrate-quick-books-modal.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var integrations_data_service_1 = __webpack_require__("./shared/services/integrations/integrations.data.service.ts");
var ng_bootstrap_1 = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/index.js");
var random_string_generator_1 = __webpack_require__("./shared/services/helpers/random-string-generator.ts");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var IntegrateQuickBooksModal = function () {
    function IntegrateQuickBooksModal(messageService, activeModal, integrationsDataService, randomStringGenerator) {
        _classCallCheck(this, IntegrateQuickBooksModal);

        this.messageService = messageService;
        this.activeModal = activeModal;
        this.integrationsDataService = integrationsDataService;
        this.randomStringGenerator = randomStringGenerator;
        this.unsubscribe = new Subject_1.Subject();
    }

    _createClass(IntegrateQuickBooksModal, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            var checkboxIndex = this.randomStringGenerator.getMixedString();
            this.checkboxId = "checkbox-squared-is-checked-" + checkboxIndex;
            this.setQuickBooksAccounts();
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "setQuickBooksAccounts",
        value: function setQuickBooksAccounts() {
            var _accountList = this.accountList,
                accountId = _accountList.accountId,
                taxCodeId = _accountList.taxCodeId,
                accounts = _accountList.accounts,
                taxCodes = _accountList.taxCodes,
                paymentsEnabled = _accountList.paymentsEnabled;

            this.chosenAccount = accountId ? accounts.find(function (account) {
                return account.key === accountId;
            }) : accounts[0];
            this.chosenTaxCodes = taxCodeId ? taxCodes.find(function (account) {
                return account.key === taxCodeId;
            }) : taxCodes[0];
            this.isChecked = paymentsEnabled;
        }
    }, {
        key: "successSetAccountQuickBook",
        value: function successSetAccountQuickBook() {
            this.activeModal.close();
            this.messageService.showToaster('s_2', 'qb');
        }
    }, {
        key: "gatherData2Save",
        value: function gatherData2Save() {
            var account = {
                taxCodeId: this.chosenTaxCodes.key,
                accountId: this.chosenAccount.key,
                paymentsEnabled: this.isChecked
            };
            return account;
        }
    }, {
        key: "changePathAfterIntegration",
        value: function changePathAfterIntegration() {
            window.history.replaceState(null, null, window.location.pathname.replace('/qb', ''));
        }
    }, {
        key: "saveQuickBooksSettings",
        value: function saveQuickBooksSettings() {
            var _this = this;

            this.button_disabled = true;
            var data = this.gatherData2Save();
            var _accountList2 = this.accountList,
                accountId = _accountList2.accountId,
                taxCodeId = _accountList2.taxCodeId;

            var isSettingsToUpdate = !!(accountId || taxCodeId);
            this.integrationsDataService.saveQuickbooksSettings(isSettingsToUpdate, data).pipe(operators_1.finalize(function () {
                _this.button_disabled = false;
                _this.changePathAfterIntegration();
            }), operators_1.takeUntil(this.unsubscribe)).subscribe(function () {
                return _this.successSetAccountQuickBook();
            }, function (err) {
                return _this.messageService.showDefaultErrorMessage(err);
            });
        }
    }, {
        key: "onDismiss",
        value: function onDismiss() {
            this.activeModal.close();
            this.button_disabled = false;
            if (!this.accountList.accauntId) {
                this.changePathAfterIntegration();
            }
        }
    }]);

    return IntegrateQuickBooksModal;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], IntegrateQuickBooksModal.prototype, "accountList", void 0);
IntegrateQuickBooksModal = __decorate([core_1.Component({
    selector: 'integrate-quick-books-modal',
    template: __webpack_require__("./web/modern/components/settings/integrations-section/modals/integrate-quick-books-modal/integrate-quick-books-modal.html")
}), __metadata("design:paramtypes", [message_service_1.MessageService, ng_bootstrap_1.NgbActiveModal, integrations_data_service_1.IntegrationsDataProvider, random_string_generator_1.RandomStringGeneratorProvider])], IntegrateQuickBooksModal);
exports.IntegrateQuickBooksModal = IntegrateQuickBooksModal;

/***/ }),

/***/ "./web/modern/components/settings/integrations-section/modals/integrate-shoot-proof-modal/integrate-shoot-proof-modal.html":
/***/ (function(module, exports) {

module.exports = "<form class=\"form-horizontal form-group\" (ngSubmit)=\"saveShootProofSettings()\">\n    <div class=\"modal-header\">\n        <button class=\"close\" (click)=\"onDismiss()\" data-dismiss=\"modal\">&times;</button>\n        <h3 class=\"modal-title\">ShootProof Integration Settings</h3>\n    </div>\n    <div class=\"modal-body\">\n\n        <div class=\"integrate-galleries-settings-description\">\n            <p>ShootProof galleries can be added to any Studio Ninja job. Once a gallery is\n                added, a \"Galleries\" page will appear inside the client portal for that job.</p>\n            <p>Enter an introduction below that your clients will see on the client portal's\n                Galleries page.</p>\n        </div>\n\n        <div class=\"field-info\">\n            <div class=\"row\">\n                <div class=\"col-xs-12\">\n                    <label>Galleries Page Introduction</label>\n                    <sn-quill-editor-web\n                        (onTextChange)=\"introductionText = $event\"\n                        [initValue]=\"introductionText\"\n                        [maxLength]=\"4000\" [toolbarSettings]=\"'image counter'\">\n                </sn-quill-editor-web>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"modal-footer modal-foot pb-30\">\n        <button class=\"btn btn-success btn-submit pull-left\"\n                type=\"submit\"\n                [disabled]=\"button_disabled\"\n                spinning-wheel [is-spinning-wheel-active]=\"button_disabled\"\n        >Save Settings\n        </button>\n    </div>\n</form>\n"

/***/ }),

/***/ "./web/modern/components/settings/integrations-section/modals/integrate-shoot-proof-modal/integrate-shoot-proof-modal.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var shootProof_data_service_1 = __webpack_require__("./shared/services/integrations/shootProof/shootProof.data.service.ts");
var ng_bootstrap_1 = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/index.js");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var IntegrateShootProofModal = function () {
    function IntegrateShootProofModal(messageService, activeModal, shootProofDataService) {
        _classCallCheck(this, IntegrateShootProofModal);

        this.messageService = messageService;
        this.activeModal = activeModal;
        this.shootProofDataService = shootProofDataService;
        this.unsubscribe = new Subject_1.Subject();
    }

    _createClass(IntegrateShootProofModal, [{
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "saveShootProofSettings",
        value: function saveShootProofSettings() {
            this.button_disabled = true;
            this.shootProofCode ? this.setShootProofSettings() : this.updateShootProofSettings();
        }
    }, {
        key: "changePathAfterIntegration",
        value: function changePathAfterIntegration() {
            this.introductionText = '';
            this.button_disabled = false;
            if (this.shootProofCode) {
                window.history.replaceState(null, null, window.location.pathname.replace('/shootproof', ''));
            }
        }
    }, {
        key: "setShootProofSettings",
        value: function setShootProofSettings() {
            var _this = this;

            var settings = {
                code: this.shootProofCode,
                clientPortalText: this.introductionText || ''
            };
            this.shootProofDataService.setShootProofSettingsV1(settings).pipe(operators_1.finalize(function () {
                return _this.changePathAfterIntegration();
            }), operators_1.takeUntil(this.unsubscribe)).subscribe(function () {
                _this.activeModal.close();
                _this.messageService.showToaster('s_9', 'shootProof');
            }, function (error) {
                return _this.messageService.showDefaultErrorMessage(error);
            });
        }
    }, {
        key: "updateShootProofSettings",
        value: function updateShootProofSettings() {
            var _this2 = this;

            var settings = {
                clientPortalText: this.introductionText || ''
            };
            this.shootProofDataService.updateShootProofSettingsV1(settings).pipe(operators_1.finalize(function () {
                return _this2.button_disabled = false;
            }), operators_1.takeUntil(this.unsubscribe)).subscribe(function () {
                _this2.activeModal.close();
                _this2.messageService.showToaster('s_8', 'shootProof');
            }, function (error) {
                var _error$error = error.error,
                    errorMessage = _error$error.errorMessage,
                    errorTitle = _error$error.errorTitle;

                _this2.messageService.showErrorFromBackend(errorTitle, errorMessage);
            });
        }
    }, {
        key: "onDismiss",
        value: function onDismiss() {
            this.activeModal.close();
            this.changePathAfterIntegration();
        }
    }]);

    return IntegrateShootProofModal;
}();
__decorate([core_1.Input(), __metadata("design:type", String)], IntegrateShootProofModal.prototype, "shootProofCode", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], IntegrateShootProofModal.prototype, "introductionText", void 0);
IntegrateShootProofModal = __decorate([core_1.Component({
    selector: 'integrate-shoot-proof-modal',
    template: __webpack_require__("./web/modern/components/settings/integrations-section/modals/integrate-shoot-proof-modal/integrate-shoot-proof-modal.html")
}), __metadata("design:paramtypes", [message_service_1.MessageService, ng_bootstrap_1.NgbActiveModal, shootProof_data_service_1.ShootProofDataProvider])], IntegrateShootProofModal);
exports.IntegrateShootProofModal = IntegrateShootProofModal;

/***/ }),

/***/ "./web/modern/components/settings/integrations-section/modals/integrate-with-xero-v2/integrate-with-xero-v2-modal.html":
/***/ (function(module, exports) {

module.exports = "<div *ngIf=\"connectionsData\">\n    <form class=\"form-horizontal\" role=\"form\" (ngSubmit)=\"saveXeroSettings(revenueAccountCode, paymentAccountCode)\">\n        <div class=\"modal-header\">\n            <button class=\"close\" (click)=\"closeModal()\" [disabled]=\"buttonDisable\" data-dismiss=\"modal\">&times;</button>\n            <h3 class=\"modal-title\">Xero Integration Settings</h3>\n        </div>\n        <div class=\"modal-body\">\n            <p class=\"font-14\">Creating invoices in Studio Ninja will automatically copy them to your Xero account.</p>\n            <ng-container *ngIf=\"connectionsData.connections.length > 1\">\n\n                <hr class=\"mb-30 mt-30\">\n\n                <h3 class=\"mb-30\">Xero Organization</h3>\n\n                <div class=\"field-info\">\n                    <p class=\"font-14\">Choose organization</p>\n\n                    <div class=\"flex-row\">\n\n                        <div class=\"select-style flex-grow-1\">\n\n                            <select class=\"font-14\" (change)=\"onCompanyChange($event.target.value)\">\n                                <option *ngFor=\"let company of connectionsData.connections\"\n                                        [ngValue]=\"company.organisationName\"\n                                        [selected]=\"company.connected\"\n                                        >\n                                    {{ company.organisationName }}\n                                </option>\n                            </select>\n                        </div>\n\n                    </div>\n                </div>\n            </ng-container>\n\n            <hr class=\"mb-30 mt-30\">\n            <h3 class=\"mb-30\">Default Revenue Account</h3>\n\n            <div class=\"field-info\">\n                <p class=\"font-14\">Choose revenue account (we will copy your invoices to this account):</p>\n\n                <div class=\"flex-row\">\n\n                    <div class=\"select-style flex-grow-1\">\n                        <select class=\"font-14\" required  (change)=\"onOptionChange($event.target.value, 'revenueAccountCode')\">\n                            <option #hiddenOption value=\"\" disabled selected hidden>Choose Account</option>\n                            <ng-container *ngIf=\"selectedCompany?.revenueAccounts?.length\" >\n                                <option *ngFor=\"let revenue of selectedCompany.revenueAccounts\"\n                                        [selected]=\"revenue.selected && revenue.accountCode\"\n                                        [value]=\"revenue.accountCode\">{{ revenue.name }}</option>\n                            </ng-container>\n                        </select>\n                    </div>\n\n                </div>\n            </div>\n            <hr class=\"mb-30 mt-30\">\n            <h3 class=\"mb-30\">Default Payment Account</h3>\n            <div class=\"field-info\">\n                <div class=\"flex-row mb-10\">\n                    <div class=\"checkbox-squared\">\n                        <input type=\"checkbox\" id=\"checkbox-squared-copy-payments-2\"\n                               [checked]=\"enablePaymentsCopying\" [(ngModel)]=\"enablePaymentsCopying\" [ngModelOptions]=\"{standalone: true}\"/>\n                        <label for=\"checkbox-squared-copy-payments-2\"></label>\n                    </div>\n                    <label for=\"checkbox-squared-copy-payments-2\">Sync payments with Xero</label>\n                </div>\n                <p *ngIf=\"enablePaymentsCopying\" class=\"mt-30 font-14\">Choose payment account (all Studio Ninja payments will be applied to this account):</p>\n                <div *ngIf=\"enablePaymentsCopying\" class=\"flex-row flex-wrap\">\n                    <div class=\"select-style flex-grow-1\">\n                        <select class=\"font-14\" required (change)=\"onOptionChange($event.target.value, 'paymentAccountCode')\">\n                            <option value=\"\" disabled selected hidden>Choose Account</option>\n                            <ng-container *ngIf=\"selectedCompany?.paymentAccounts?.length\" >\n                                <option *ngFor=\"let payment of selectedCompany.paymentAccounts\"\n                                        [selected]=\"payment.selected && payment.accountCode\"\n                                        [value]=\"payment.accountCode\">{{ payment.name }}</option>\n                            </ng-container>\n                        </select>\n                    </div>\n                    <div class=\"flex-row flex-wrap-xs warning-message m-0 mt-30\">\n                        <img src=\"https://app.studioninja.co/build/release-pipeline-119/resources/dist/assets/images/icons/warning-sign-icon.png\" class=\"warning-message__img\" alt=\"warning-sign\">\n                        <div class=\"warning-message__text mr-10\">\n                            <p>If you’re receiving payments via Stripe or PayPal and your Xero account is connected to your bank feed, syncing payments with Xero may cause the same payment to be recorded twice. To avoid recording the same payment twice, disable “sync payments with Xero”.</p>\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n        </div>\n\n        <div class=\"modal-footer modal-foot pb-30\">\n            <button class=\"btn btn-success btn-submit pull-left\"\n                    type=\"submit\"\n                    [disabled]=\"buttonDisable\"\n                    spinning-wheel [is-spinning-wheel-active]=\"buttonDisable\"\n            >Save Settings\n            </button>\n            <button type=\"button\" class=\"btn btn-lg btn-default ml-10\"\n                    data-dismiss=\"modal\"\n                    [disabled]=\"buttonDisable\"\n                    (click)=\"closeModal()\"\n            >Cancel\n            </button>\n        </div>\n\n    </form>\n</div>"

/***/ }),

/***/ "./web/modern/components/settings/integrations-section/modals/integrate-with-xero-v2/integrate-with-xero-v2-modal.scss":
/***/ (function(module, exports) {

module.exports = ".font-14 {\n  font-size: 14px !important; }\n\noption[value=''][disabled] {\n  display: none; }\n"

/***/ }),

/***/ "./web/modern/components/settings/integrations-section/modals/integrate-with-xero-v2/integrate-with-xero-v2-modal.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var common_1 = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
var integrations_data_service_1 = __webpack_require__("./shared/services/integrations/integrations.data.service.ts");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var confirm_general_modal_component_1 = __webpack_require__("./web/modern/components/common/confirm-general-modal/confirm-general-modal.component.ts");
var ng_bootstrap_1 = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/index.js");
var IntegrateWithXeroV2Modal = function () {
    function IntegrateWithXeroV2Modal(integrationsDataService, messageService, modalService, location, activeModal) {
        _classCallCheck(this, IntegrateWithXeroV2Modal);

        this.integrationsDataService = integrationsDataService;
        this.messageService = messageService;
        this.modalService = modalService;
        this.location = location;
        this.activeModal = activeModal;
        this.xeroConnectState = new core_1.EventEmitter();
        this.enablePaymentsCopying = false;
    }

    _createClass(IntegrateWithXeroV2Modal, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.setDefaultValues();
        }
    }, {
        key: "closeModal",
        value: function closeModal() {
            this.selectedCompany = null;
            this.revenueAccountCode = null;
            this.paymentAccountCode = null;
            this.activeModal.close(false);
            this.changePathAfterIntegration();
        }
    }, {
        key: "saveXeroSettings",
        value: function saveXeroSettings(revenueAccountCode, paymentAccountCode) {
            var _this = this;

            var data = { revenueAccountCode: revenueAccountCode };
            if (this.enablePaymentsCopying) {
                data.paymentAccountCode = paymentAccountCode;
            }
            if (this.selectedCompany.actions.CONNECT.method === 'ALERT_MODAL') {
                this.showAlert(this.selectedCompany.actions.CONNECT.alertMessage.title, this.selectedCompany.actions.CONNECT.alertMessage.message);
                return;
            }
            if (this.isXeroDataValid(data)) {
                this.buttonDisable = true;
                this.integrationsDataService.connectXeroV2(this.selectedCompany.actions.CONNECT.url, data).pipe(operators_1.finalize(function () {
                    return _this.buttonDisable = false;
                })).subscribe(function () {
                    _this.checkForAdditionalQuestions(_this.selectedCompany.actions);
                    _this.changePathAfterIntegration();
                    _this.activeModal.close(true);
                }, function (err) {
                    return _this.errorConnectXero(err);
                });
            }
        }
    }, {
        key: "changePathAfterIntegration",
        value: function changePathAfterIntegration() {
            window.history.replaceState(null, null, window.location.pathname.replace('/integrations/xero/connect/complete', '/settings/integrations'));
        }
    }, {
        key: "onOptionChange",
        value: function onOptionChange(newValue, placeToAssign) {
            this[placeToAssign] = newValue;
        }
    }, {
        key: "onCompanyChange",
        value: function onCompanyChange(value) {
            var _this2 = this;

            var _connectionsData$conn = this.connectionsData.connections.filter(function (el) {
                return el.organisationName === value;
            });

            var _connectionsData$conn2 = _slicedToArray(_connectionsData$conn, 1);

            this.selectedCompany = _connectionsData$conn2[0];

            if (this.hiddenOption) {
                this.hiddenOption.nativeElement.selected = true;
            }
            this.revenueAccountCode = this.selectCorrectDropdownValue(this.selectedCompany.revenueAccounts);
            this.paymentAccountCode = this.selectCorrectDropdownValue(this.selectedCompany.paymentAccounts);
            this.selectedCompany.paymentAccounts.find(function (el) {
                return el.selected && el.accountCode ? _this2.enablePaymentsCopying = true : _this2.enablePaymentsCopying = false;
            });
        }
    }, {
        key: "toggleRevenueSection",
        value: function toggleRevenueSection() {
            this.enablePaymentsCopying = !this.enablePaymentsCopying;
            if (!this.enablePaymentsCopying) {
                this.paymentAccountCode = null;
                this.selectedCompany.paymentAccounts.forEach(function (item) {
                    return item.selected = false;
                });
            }
        }
    }, {
        key: "setDefaultValues",
        value: function setDefaultValues() {
            if (this.connectionsData) {
                var orgName = this.connectionsData.connections[0].organisationName;
                this.connectionsData.connections.forEach(function (el) {
                    if (el.connected) {
                        orgName = el.organisationName;
                    }
                });
                this.onCompanyChange(orgName);
            }
        }
    }, {
        key: "selectCorrectDropdownValue",
        value: function selectCorrectDropdownValue(arr) {
            if (arr.length) {
                var val = null;
                arr.forEach(function (el) {
                    if (el.selected && el.accountCode) {
                        val = el.accountCode;
                    }
                });
                return val;
            }
            return null;
        }
    }, {
        key: "errorConnectXero",
        value: function errorConnectXero(_ref) {
            var error = _ref.error;
            var errorTitle = error.errorTitle,
                errorMessage = error.errorMessage;

            this.messageService.showErrorFromBackend(errorTitle, errorMessage);
        }
    }, {
        key: "showAlert",
        value: function showAlert(title, message) {
            var alertModalRef = this.modalService.openModal(confirm_general_modal_component_1.ConfirmGeneralModalComponent, {
                windowClass: 'ng-bootstrap-modal modal-visible modal-narrow'
            });
            // TODO Remove direct class manipulations after rewriting integrations page to new Angular
            document.body.classList.remove('modal-open');
            alertModalRef.componentInstance.title = title;
            alertModalRef.componentInstance.text = message;
            alertModalRef.componentInstance.buttons = [{
                text: 'Got it',
                size: 'lg',
                color: 'default',
                action: 'CLOSE'
            }];
            alertModalRef.result.then(function () {
                document.body.classList.add('modal-open');
            });
        }
    }, {
        key: "isXeroDataValid",
        value: function isXeroDataValid(data) {
            if (!data.revenueAccountCode) {
                this.messageService.showToaster('e_18', 'xero');
                return false;
            }
            // Closing case, when account code comes as null from BE and then was chosen from dropdown.
            if (data.revenueAccountCode === 'null') {
                this.messageService.showToaster('e_21', 'xero');
                return false;
            }
            if (this.enablePaymentsCopying) {
                if (!data.paymentAccountCode) {
                    this.messageService.showToaster('e_19', 'xero');
                    return false;
                }
                if (data.paymentAccountCode === 'null') {
                    this.messageService.showToaster('e_20', 'xero');
                    return false;
                }
            }
            return true;
        }
    }, {
        key: "checkForAdditionalQuestions",
        value: function checkForAdditionalQuestions(actions) {
            var _this3 = this;

            var action = actions.CONNECT;
            if (action.withWarningMessage) {
                if (action.withWarningMessage.errorCode === 802) {
                    var _action$withWarningMe = action.withWarningMessage,
                        title = _action$withWarningMe.title,
                        message = _action$withWarningMe.message;

                    var modal = this.modalService.openModal(confirm_general_modal_component_1.ConfirmGeneralModalComponent);
                    modal.componentInstance.title = title;
                    modal.componentInstance.text = message;
                    modal.componentInstance.buttons = [{
                        text: 'Cancel',
                        color: 'default',
                        size: 'lg',
                        action: 'CLOSE_ALERT'
                    }, {
                        text: 'Continue to Invoice & Payment Settings',
                        color: 'success',
                        size: 'lg',
                        action: 'REDIRECT'
                    }];
                    modal.result.then(function (data) {
                        if (data === 'REDIRECT') {
                            _this3.location.go('/settings/payment_schedules/?redirectTo=InvoiceID');
                        }
                    });
                }
            }
        }
    }]);

    return IntegrateWithXeroV2Modal;
}();
__decorate([core_1.ViewChild('hiddenOption'), __metadata("design:type", Object)], IntegrateWithXeroV2Modal.prototype, "hiddenOption", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], IntegrateWithXeroV2Modal.prototype, "connectionsData", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], IntegrateWithXeroV2Modal.prototype, "xeroConnectState", void 0);
IntegrateWithXeroV2Modal = __decorate([core_1.Component({
    selector: 'integrate-with-xero-v2',
    template: __webpack_require__("./web/modern/components/settings/integrations-section/modals/integrate-with-xero-v2/integrate-with-xero-v2-modal.html"),
    styles: [__webpack_require__("./web/modern/components/settings/integrations-section/modals/integrate-with-xero-v2/integrate-with-xero-v2-modal.scss")]
}), __metadata("design:paramtypes", [integrations_data_service_1.IntegrationsDataProvider, message_service_1.MessageService, snModal_service_1.SNModalService, common_1.Location, ng_bootstrap_1.NgbActiveModal])], IntegrateWithXeroV2Modal);
exports.IntegrateWithXeroV2Modal = IntegrateWithXeroV2Modal;

/***/ }),

/***/ "./web/modern/components/settings/integrations-section/modals/integrate-xero-modal/integrate-xero-modal.html":
/***/ (function(module, exports) {

module.exports = "<form class=\"form-horizontal form-group\" role=\"form\" (ngSubmit)=\"saveXeroSettings()\">\n    <div class=\"modal-header\">\n        <button class=\"close\" (click)=\"onDismiss()\" data-dismiss=\"modal\">&times;</button>\n        <h3 class=\"modal-title\">Xero integration settings</h3>\n    </div>\n    <div class=\"modal-body\">\n\n        <p>Creating invoices in Studio Ninja will automatically copy them to your Xero account.</p>\n        <hr class=\"mb-30 mt-30\">\n        <h3 class=\"mb-30\">Default revenue account</h3>\n\n        <div class=\"field-info\">\n            <p>Choose revenue account (we will copy your invoices to this account):</p>\n\n            <div class=\"flex-row\">\n\n                <div class=\"select-style flex-grow-1\">\n                    <select [(ngModel)]=\"chosenRevenueAccount\" name=\"chosenRevenueAccount\" required>\n                        <option *ngFor=\"let account of accountList.revenueAccounts\">{{ account.value }}</option>\n                    </select>\n                </div>\n\n            </div>\n        </div>\n        <hr class=\"mb-30 mt-30\">\n        <h3 class=\"mb-30\">Default payment account</h3>\n        <div class=\"field-info\">\n            <div class=\"flex-row mb-10\">\n                <div class=\"checkbox-squared\">\n                    <input type=\"checkbox\" id=\"checkbox-squared-copy-payments\"\n                           [(ngModel)]=\"enablePaymentsCopying\" name=\"enablePaymentsCopying\"/>\n                    <label for=\"checkbox-squared-copy-payments\"></label>\n                </div>\n                <label for=\"checkbox-squared-copy-payments\">Sync payments with Xero</label>\n            </div>\n            <p *ngIf=\"enablePaymentsCopying\" class=\"mt-30\">Choose payment account (all Studio Ninja payments will be applied to this account):</p>\n            <div *ngIf=\"enablePaymentsCopying\" class=\"flex-row flex-wrap\">\n                <div class=\"select-style flex-grow-1\">\n                    <select [(ngModel)]=\"chosenPaymentAccount\" name=\"chosenPaymentAccount\" required>\n                        <option *ngFor=\"let account of accountList.paymentAccounts\">{{ account.value }}</option>\n                    </select>\n                </div>\n                <div class=\"flex-row flex-wrap-xs warning-message m-0 mt-30\">\n                    <img src=\"https://app.studioninja.co/build/release-pipeline-119/resources/dist/assets/images/icons/warning-sign-icon.png\" class=\"warning-message__img\" alt=\"warning-sign\">\n                    <div class=\"warning-message__text mr-10\">\n                        <p>If you’re receiving payments via Stripe or PayPal and your Xero account is connected to your bank feed, syncing payments with Xero may cause the same payment to be recorded twice. To avoid recording the same payment twice, disable “sync payments with Xero”.</p>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n    </div>\n\n    <div class=\"modal-footer modal-foot pb-30\">\n        <button class=\"btn btn-success btn-submit pull-left\"\n                type=\"submit\"\n                [disabled]=\"button_disabled\"\n                spinning-wheel [is-spinning-wheel-active]=\"button_disabled\"\n        >Save settings\n        </button>\n        <button type=\"button\" class=\"btn btn-lg btn-default ml-10\"\n                data-dismiss=\"modal\"\n                (click)=\"onDismiss()\"\n                [disabled]=\"button_disabled\"\n        >Cancel\n        </button>\n    </div>\n</form>\n"

/***/ }),

/***/ "./web/modern/components/settings/integrations-section/modals/integrate-xero-modal/integrate-xero-modal.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var rxjs_1 = __webpack_require__("./node_modules/rxjs/Rx.js");
var ng_bootstrap_1 = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/index.js");
var integrations_data_service_1 = __webpack_require__("./shared/services/integrations/integrations.data.service.ts");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var IntegrateXeroModal = function () {
    function IntegrateXeroModal(activeModal, messageService, integrationDataService) {
        _classCallCheck(this, IntegrateXeroModal);

        this.activeModal = activeModal;
        this.messageService = messageService;
        this.integrationDataService = integrationDataService;
        this.unsubscribe = new rxjs_1.Subject();
    }

    _createClass(IntegrateXeroModal, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.setXeroAccounts();
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "setXeroAccounts",
        value: function setXeroAccounts() {
            var _accountList = this.accountList,
                currentPaymentAccountId = _accountList.currentPaymentAccountId,
                currentRevenueAccountId = _accountList.currentRevenueAccountId,
                paymentAccounts = _accountList.paymentAccounts,
                revenueAccounts = _accountList.revenueAccounts;

            this.chosenPaymentAccount = currentPaymentAccountId ? paymentAccounts.find(function (account) {
                return account.key === currentPaymentAccountId;
            }) : paymentAccounts[0];
            this.chosenRevenueAccount = currentPaymentAccountId ? revenueAccounts.find(function (account) {
                return account.key === currentRevenueAccountId;
            }) : revenueAccounts[0];
            this.enablePaymentsCopying = !!currentPaymentAccountId;
        }
    }, {
        key: "successSetAccount",
        value: function successSetAccount() {
            this.activeModal.close();
            this.messageService.showToaster('s_0', 'xero');
        }
    }, {
        key: "gatherData2Save",
        value: function gatherData2Save() {
            var accounts = {
                revenueAccount: this.chosenRevenueAccount.key,
                paymentAccount: this.chosenPaymentAccount.key,
                enablePaymentsCopying: this.enablePaymentsCopying
            };
            return accounts;
        }
    }, {
        key: "changePathAfterIntegration",
        value: function changePathAfterIntegration() {
            this.button_disabled = false;
            window.history.replaceState(null, null, window.location.pathname.replace('/xero', ''));
        }
    }, {
        key: "saveXeroSettings",
        value: function saveXeroSettings() {
            var _this = this;

            this.button_disabled = true;
            var data = this.gatherData2Save();
            var _accountList2 = this.accountList,
                currentPaymentAccountId = _accountList2.currentPaymentAccountId,
                currentRevenueAccountId = _accountList2.currentRevenueAccountId;

            var isSettingsToUpdate = currentPaymentAccountId || currentRevenueAccountId;
            if (isSettingsToUpdate) {
                this.integrationDataService.editXeroSettingsById(data).pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function () {
                    _this.successSetAccount();
                });
            } else {
                this.integrationDataService.createXeroSettings(data).pipe(operators_1.finalize(function () {
                    return _this.changePathAfterIntegration();
                }), operators_1.takeUntil(this.unsubscribe)).subscribe(function () {
                    _this.successSetAccount();
                });
            }
        }
    }, {
        key: "onDismiss",
        value: function onDismiss() {
            this.changePathAfterIntegration();
            this.activeModal.close();
        }
    }]);

    return IntegrateXeroModal;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], IntegrateXeroModal.prototype, "accountList", void 0);
IntegrateXeroModal = __decorate([core_1.Component({
    selector: 'integrate-xero-modal',
    template: __webpack_require__("./web/modern/components/settings/integrations-section/modals/integrate-xero-modal/integrate-xero-modal.html")
}), __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal, message_service_1.MessageService, integrations_data_service_1.IntegrationsDataProvider])], IntegrateXeroModal);
exports.IntegrateXeroModal = IntegrateXeroModal;

/***/ }),

/***/ "./web/modern/components/settings/integrations-section/modals/pre-integrate-pick-time-modal/pre-integrate-pick-time-modal.html":
/***/ (function(module, exports) {

module.exports = "<form class=\"form-horizontal form-group\" role=\"form\" (ngSubmit)=\"savePickTimeSettings()\">\n    <div class=\"modal-header\">\n        <button type=\"button\" class=\"close\" (click)=\"onDismiss()\" data-dismiss=\"modal\">&times;</button>\n        <h3 class=\"modal-title\">Pic-Time Domain Name</h3>\n    </div>\n    <div class=\"modal-body\">\n\n        <div class=\"field-info\">\n            <p>To start the integration with Pic-Time, please enter your Pic-Time Domain Name, which can be found within your Pic-Time Site Address.</p>\n        </div>\n\n        <div class=\"pick-time-example-block\">\n            <h4>Site Address with Domain Name highlighted below</h4>\n            <div class=\"row\">\n                <div class=\"col-xs-12\">\n                    <div class=\"example-input form-control mt-20\">\n                        <div>https://<span class=\"colored-domain-name\">{{ exampleDomainName }}</span>.pic-time.com</div>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"field-info\">\n            <div class=\"row\">\n                <div class=\"col-xs-12\">\n                    <input type=\"text\" class=\"form-control mt-20\" [placeholder]=\"'Enter your Pic-Time Domain Name'\" (paste)=\"validateUrlOnPaste($event)\" (keydown.space)=\"$event.preventDefault()\" [(ngModel)]=\"typedDomainName\" [ngModelOptions]=\"{standalone: true}\" required/>\n                </div>\n            </div>\n        </div>\n\n    </div>\n\n    <div class=\"modal-footer modal-foot pb-30\">\n        <button class=\"btn btn-success btn-submit pull-left\"\n                type=\"submit\"\n                [disabled]=\"button_disabled\"\n                spinning-wheel [is-spinning-wheel-active]=\"button_disabled\"\n        >Connect\n        </button>\n    </div>\n</form>\n"

/***/ }),

/***/ "./web/modern/components/settings/integrations-section/modals/pre-integrate-pick-time-modal/pre-integrate-pick-time-modal.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var ng_bootstrap_1 = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/index.js");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var pickTime_data_service_1 = __webpack_require__("./shared/services/integrations/pickTime/pickTime.data.service.ts");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var PreIntegratePickTimeModal = function () {
    function PreIntegratePickTimeModal(activeModal, pickTimeDataProvider, messageService) {
        _classCallCheck(this, PreIntegratePickTimeModal);

        this.activeModal = activeModal;
        this.pickTimeDataProvider = pickTimeDataProvider;
        this.messageService = messageService;
        this.exampleDomainName = 'DomainName';
        this.unsubscribe = new Subject_1.Subject();
    }

    _createClass(PreIntegratePickTimeModal, [{
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "onDismiss",
        value: function onDismiss() {
            this.activeModal.close(true);
        }
    }, {
        key: "savePickTimeSettings",
        value: function savePickTimeSettings() {
            var _this = this;

            if (!this.typedDomainName) {
                this.messageService.showToaster('e_2', 'picTime');
                return;
            }
            this.button_disabled = true;
            var slicedDomainName = this.typedDomainName.replace('https://', '').split('.')[0];
            var regex = /^[a-z0-9]{1,63}$/;
            if (!slicedDomainName.match(regex)) {
                this.messageService.showToaster('e_5', 'picTime');
                this.button_disabled = false;
            } else {
                this.pickTimeDataProvider.initPickTimeIntegration().pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (data) {
                    _this.messageService.showToaster('i_0', 'picTime');
                    _this.doRedirect(data.data.integrationUrl);
                }, function (error) {
                    _this.button_disabled = false;
                    _this.messageService.handleError(error);
                });
            }
        }
    }, {
        key: "doRedirect",
        value: function doRedirect(url) {
            window.location.assign(url);
        }
    }, {
        key: "validateUrlOnPaste",
        value: function validateUrlOnPaste(event) {
            var clipboardData = event.clipboardData;
            var pastedText = clipboardData.getData('text').trim();
            this.typedDomainName = pastedText.replace(/\s+/g, '');
            event.preventDefault();
        }
    }]);

    return PreIntegratePickTimeModal;
}();
PreIntegratePickTimeModal = __decorate([core_1.Component({
    selector: 'integrate-pick-time-modal',
    template: __webpack_require__("./web/modern/components/settings/integrations-section/modals/pre-integrate-pick-time-modal/pre-integrate-pick-time-modal.html")
}), __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal, pickTime_data_service_1.PickTimeDataProvider, message_service_1.MessageService])], PreIntegratePickTimeModal);
exports.PreIntegratePickTimeModal = PreIntegratePickTimeModal;

/***/ }),

/***/ "./web/modern/components/settings/invoice-payments-section/components/invoice-numbering/invoice-numbering.component.html":
/***/ (function(module, exports) {

module.exports = "<h3>Invoice ID Format</h3>\n\n<form #invoiceID class=\"invoice\" *ngIf=\"invoiceIdData && invoiceIdForm\" [formGroup]=\"invoiceIdForm\" (ngSubmit)=\"saveInvoiceIdFormat()\">\n  <div class=\"option_group invoice-number-radio mt-20\">\n    <div class=\"option_group__label mr-18\">\n      <p class=\"f-s-13 lh\">ID Format</p>\n    </div>\n    <div class=\"option_group__radios\">\n      <div class=\"option_group__radio mb-12\">\n        <div class=\"styled-input-radio ml-0 pl-30\">\n          <input type=\"radio\" id=\"invoiceID-0\"  formControlName=\"type\" [value]=\"'DATE'\">\n          <label for=\"invoiceID-0\"></label>\n        </div>\n        <span class=\"f-s-13\">Date (e.g. {{ dateFormat?.displayName }})</span>\n      </div>\n      <div class=\"option_group__radio mb-12\">\n        <div class=\"styled-input-radio ml-0 pl-30\">\n          <input type=\"radio\" id=\"invoiceID-1\" formControlName=\"type\"  [value]=\"'LETTERS_AND_NUMBERS'\">\n          <label for=\"invoiceID-1\"></label>\n        </div>\n        <span class=\"f-s-13\">Letters & Numbers (e.g. ABC0001)</span>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"flex-box mt-15 sequential\" *ngIf=\"this.invoiceIdForm.value.type === 'LETTERS_AND_NUMBERS'\">\n    <div class=\"flex-box flex-column sequential-config\" [formGroupName]=\"'sequentialConfig'\">\n      <div class=\"flex-box flex-align-center\">\n        <label class=\"w-min-100\">Letters</label>\n        <input formControlName=\"letters\" class=\"form-control w-150\" type=\"text\" maxlength=\"10\">\n      </div>\n      <div class=\"flex-box flex-align-center mt-20\">\n        <label class=\"w-min-100\">No. of Digits</label>\n        <input formControlName=\"numberOfDigits\" class=\"form-control w-150\" type=\"number\" min=\"1\" max=\"6\">\n      </div>\n      <div class=\"flex-box flex-align-center mt-20\">\n        <label class=\"w-min-100\">Starts from</label>\n        <input formControlName=\"startsFrom\" class=\"form-control w-150\" type=\"number\" min=\"1\">\n      </div>\n    </div>\n    <div class=\"invoice-number-preview\">\n      <div class=\"invoice-number-preview_label\">\n        Preview\n      </div>\n      <div class=\"invoice-number-preview_id\">\n        {{ generatedID }}\n      </div>\n    </div>\n  </div>\n\n\n  <button type=\"submit\" class=\"btn btn-success btn-lg text-space mb-30\" [disabled]=\"buttonDisable\"\n          spinning-wheel [is-spinning-wheel-active]=\"buttonDisable\">Save Invoice ID Format</button>\n\n</form>\n"

/***/ }),

/***/ "./web/modern/components/settings/invoice-payments-section/components/invoice-numbering/invoice-numbering.component.scss":
/***/ (function(module, exports) {

module.exports = ".option_group__label {\n  max-width: 70px; }\n\n.sequential {\n  margin-bottom: 30px; }\n  .sequential-config {\n    margin-left: 118px; }\n    .sequential-config div label {\n      min-width: 90px; }\n\n.invoice-number-preview {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  min-width: 200px;\n  border: 1px solid #dce1e4;\n  margin-left: 30px;\n  padding: 10px;\n  background-color: #f9f9f9; }\n  .invoice-number-preview_label {\n    border-bottom: 1px solid #dce1e4;\n    padding: 0 5px 10px;\n    color: #8e8e98;\n    font-weight: 700; }\n  .invoice-number-preview_id {\n    margin: auto;\n    font-size: 20px; }\n\n@media screen and (max-width: 720px) {\n  .sequential {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: column;\n        -ms-flex-direction: column;\n            flex-direction: column; }\n    .sequential .invoice-number-preview {\n      height: 200px;\n      margin-top: 30px;\n      margin-left: 0; } }\n\n@media screen and (max-width: 420px) {\n  .sequential-config {\n    margin-left: 0;\n    -webkit-align-self: center;\n        -ms-flex-item-align: center;\n            align-self: center; } }\n"

/***/ }),

/***/ "./web/modern/components/settings/invoice-payments-section/components/invoice-numbering/invoice-numbering.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var common_1 = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var forms_1 = __webpack_require__("./node_modules/@angular/forms/esm5/forms.js");
var invoice_payments_data_1 = __webpack_require__("./web/modern/services/settings/invoice-payments/invoice-payments.data.ts");
var combineLatest_1 = __webpack_require__("./node_modules/rxjs/observable/combineLatest.js");
var InvoiceNumberingComponent = function () {
    function InvoiceNumberingComponent(invoicePaymentsDataService, messageService, fb, location) {
        _classCallCheck(this, InvoiceNumberingComponent);

        this.invoicePaymentsDataService = invoicePaymentsDataService;
        this.messageService = messageService;
        this.fb = fb;
        this.location = location;
        this.unsubscribe = new Subject_1.Subject();
    }

    _createClass(InvoiceNumberingComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.getInvoiceNumberingData();
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "saveInvoiceIdFormat",
        value: function saveInvoiceIdFormat() {
            if (this.isFormValid()) {
                var data = this.prepareDataToSend();
                this.saveInvoiceRules(data);
            }
        }
    }, {
        key: "saveInvoiceRules",
        value: function saveInvoiceRules(data) {
            var _this = this;

            this.buttonDisable = true;
            this.invoicePaymentsDataService.saveInvoiceNumberingRules(data).pipe(operators_1.takeUntil(this.unsubscribe), operators_1.finalize(function () {
                return _this.buttonDisable = false;
            })).subscribe(function () {
                _this.messageService.showToaster('s_5', 'paymentSchedules');
            }, function (err) {
                return _this.handleError(err);
            });
        }
    }, {
        key: "getInvoiceNumberingData",
        value: function getInvoiceNumberingData() {
            var _this2 = this;

            this.invoicePaymentsDataService.getInvoiceNumberingRules().pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (_ref) {
                var data = _ref.data;

                _this2.invoiceIdData = data;
                _this2.createForm(data);

                var _Object$keys = Object.keys(data.metadata.dateFormats),
                    _Object$keys2 = _slicedToArray(_Object$keys, 1),
                    key = _Object$keys2[0];

                _this2.dateFormat = data.metadata.dateFormats[key];
                _this2.scrollIntoView('invoiceID', 'redirectTo=InvoiceID');
            }, function (err) {
                return _this2.handleError(err);
            });
        }
    }, {
        key: "createForm",
        value: function createForm(data) {
            if (data.type === 'DATE') {
                var _invoiceIdData$metada = this.invoiceIdData.metadata.types.LETTERS_AND_NUMBERS,
                    defaultNumberOfDigits = _invoiceIdData$metada.defaultNumberOfDigits,
                    minStartsFrom = _invoiceIdData$metada.minStartsFrom;

                data.numberOfDigits = defaultNumberOfDigits;
                data.startsFrom = minStartsFrom;
            }
            this.invoiceIdForm = this.fb.group({
                type: [data.type],
                sequentialConfig: this.fb.group({
                    letters: [data.letters],
                    numberOfDigits: [data.numberOfDigits],
                    startsFrom: [data.startsFrom]
                })
            });
            this.createIdPreview();
            this.setDynamicValidators();
        }
    }, {
        key: "prepareDataToSend",
        value: function prepareDataToSend() {
            var _invoiceIdForm$value = this.invoiceIdForm.value,
                type = _invoiceIdForm$value.type,
                sequentialConfig = _invoiceIdForm$value.sequentialConfig;

            if (type === 'DATE') {
                var defaultNumberOfDigits = this.invoiceIdData.metadata.types.DATE.defaultNumberOfDigits;

                return {
                    type: type,
                    numberOfDigits: defaultNumberOfDigits,
                    dateFormat: this.dateFormat.name
                };
            }
            if (type === 'LETTERS_AND_NUMBERS') {
                var letters = sequentialConfig.letters,
                    numberOfDigits = sequentialConfig.numberOfDigits,
                    startsFrom = sequentialConfig.startsFrom;

                return {
                    type: type,
                    letters: letters,
                    numberOfDigits: numberOfDigits,
                    startsFrom: startsFrom
                };
            }
        }
    }, {
        key: "isFormValid",
        value: function isFormValid() {
            var _invoiceIdForm$value2 = this.invoiceIdForm.value,
                sequentialConfig = _invoiceIdForm$value2.sequentialConfig,
                type = _invoiceIdForm$value2.type;

            if (type === 'LETTERS_AND_NUMBERS') {
                var letters = sequentialConfig.letters;

                var regex = /^[A-z0-9\u00C0-\u00ff\s-\/\-_\\]+$/;
                if (letters && !regex.test(letters)) {
                    this.messageService.showToaster('e_5', 'paymentSchedules');
                    return false;
                }
            }
            return true;
        }
    }, {
        key: "generateNumberPortion",
        value: function generateNumberPortion(_ref2) {
            var numberOfDigits = _ref2.numberOfDigits,
                startsFrom = _ref2.startsFrom;

            startsFrom = "" + (startsFrom || 0);
            return startsFrom.length >= numberOfDigits ? startsFrom : new Array(numberOfDigits - startsFrom.length + 1).join('0') + startsFrom;
        }
    }, {
        key: "handleError",
        value: function handleError(_ref3) {
            var error = _ref3.error;
            var errorTitle = error.errorTitle,
                errorMessage = error.errorMessage;

            this.messageService.showErrorFromBackend(errorTitle, errorMessage);
        }
    }, {
        key: "createIdPreview",
        value: function createIdPreview() {
            var sequentialConfig = this.invoiceIdForm.value.sequentialConfig;

            this.generatedID = "" + sequentialConfig.letters + this.generateNumberPortion(sequentialConfig);
        }
    }, {
        key: "setDynamicValidators",
        value: function setDynamicValidators() {
            var lettersGroup = this.invoiceIdForm.get('sequentialConfig');
            combineLatest_1.combineLatest(this.trimLetters(lettersGroup.get('letters')), this.validateNumberField(lettersGroup.get('numberOfDigits'), {
                min: 1,
                max: 6,
                numbersAfterPoint: 0
            }), this.validateNumberField(lettersGroup.get('startsFrom'), {
                min: 1,
                max: 100000,
                numbersAfterPoint: 0
            })).pipe(operators_1.takeUntil(this.unsubscribe)).subscribe();
        }
    }, {
        key: "trimLetters",
        value: function trimLetters(control) {
            var _this3 = this;

            return control.valueChanges.pipe(operators_1.debounceTime(200), operators_1.map(function (value) {
                return value.replace(/\s/g, '');
            }), operators_1.map(function (value) {
                return control.patchValue(value);
            }), operators_1.tap(function () {
                return _this3.createIdPreview();
            }));
        }
    }, {
        key: "validateNumberField",
        value: function validateNumberField(control, config) {
            var _this4 = this;

            return control.valueChanges.pipe(operators_1.debounceTime(200), operators_1.tap(function (value) {
                var newValue = value;
                if (newValue) {
                    var _newValue$toString$sp = newValue.toString().split('.'),
                        _newValue$toString$sp2 = _slicedToArray(_newValue$toString$sp, 2),
                        decimal = _newValue$toString$sp2[1];

                    if (decimal && decimal.length > config.numbersAfterPoint) {
                        newValue = Math.trunc(newValue);
                    }
                }
                if (newValue < config.min) {
                    newValue = config.min;
                }
                if (newValue > config.max) {
                    newValue = config.max;
                }
                control.patchValue(newValue);
                _this4.createIdPreview();
            }));
        }
    }, {
        key: "scrollIntoView",
        value: function scrollIntoView(scrollDest, checkPath) {
            var _this5 = this;

            if (this.location.path().includes(checkPath)) {
                requestAnimationFrame(function () {
                    _this5[scrollDest].nativeElement.scrollIntoView();
                });
            }
        }
    }]);

    return InvoiceNumberingComponent;
}();
__decorate([core_1.ViewChild('invoiceID'), __metadata("design:type", core_1.ElementRef)], InvoiceNumberingComponent.prototype, "invoiceID", void 0);
InvoiceNumberingComponent = __decorate([core_1.Component({
    selector: 'invoice-numbering',
    template: __webpack_require__("./web/modern/components/settings/invoice-payments-section/components/invoice-numbering/invoice-numbering.component.html"),
    styles: [__webpack_require__("./web/modern/components/settings/invoice-payments-section/components/invoice-numbering/invoice-numbering.component.scss")]
}), __metadata("design:paramtypes", [invoice_payments_data_1.InvoicePaymentsDataService, message_service_1.MessageService, forms_1.FormBuilder, common_1.Location])], InvoiceNumberingComponent);
exports.InvoiceNumberingComponent = InvoiceNumberingComponent;

/***/ }),

/***/ "./web/modern/components/settings/lead-sources-section/lead-sources-section.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"bc-wrap\">\n    <div class=\"flex-box flex-just-space\">\n        <setting-section-header [breadcrumbs]=\"breadcrumbs\"></setting-section-header>\n        <div class=\"mt-20\">\n            <settings-add-btn *ngIf=\"addNewAction\" [text]=\"'Add New Lead Source'\" (onBtnClick)=\"openEditModal('CREATE_NEW', pageRequestActive)\"></settings-add-btn>\n        </div>\n    </div>\n</div>\n\n<div class=\"m-30\" *ngIf=\"activeTemplates && archivedTemplates\">\n    <div class=\"mb-30\">\n        <setting-section-description\n                [text]=\"'Add lead sources so you can track where your leads come from.'\">\n        </setting-section-description>\n    </div>\n\n    <dynamic-table *ngIf=\"activeTemplates?.items?.length\" [headerList]=\"tableHeader\" [pageRequest]=\"pageRequestActive\" [templates]=\"activeTemplates\" (updateTableParams)=\"updateTemplateList($event, 'ACTIVE', 'pageRequestActive')\">\n        <tbody>\n        <tr *ngFor=\"let template of activeTemplates.items; let i = index\">\n            <td class=\"name-cell-dynamic\">{{ template.name }}</td>\n            <td>\n                <div class=\"flex-box\">\n                    <lead-source-color class=\"flex-box flex-align-center\" [color]=\"template.colour.hex\"></lead-source-color>\n                    <span class=\"ml-5\">{{ template.colour.name }}</span>\n                </div>\n            </td>\n            <td class=\"text-right\">\n                <button *ngIf=\"template.actions?.EDIT\"  type=\"button\" [disabled]=\"buttonDisable\" (click)=\"openEditModal('EDIT_EXISTING', pageRequestActive, template)\"\n                        class=\"btn btn-default mb-0\">\n                    <i class=\"fi fi-edit ng-scope\"></i>\n                    Edit\n                </button>\n                <button *ngIf=\"template.actions?.ARCHIVE\" type=\"button\" [disabled]=\"buttonDisable\" (click)=\"archiveLeadSource(template)\"\n                        class=\"btn btn-default mb-0\">\n                    Archive\n                </button>\n                <button *ngIf=\"template.actions?.DELETE\" [disabled]=\"buttonDisable\" type=\"button\" (click)=\"deleteLeadSource(template, pageRequestActive)\"\n                        class=\"btn btn-delete btn-delete-empty mb-0\"></button>\n            </td>\n        </tr>\n        </tbody>\n    </dynamic-table>\n\n    <div class=\"stats__placeholder\" *ngIf=\"!activeTemplates?.items?.length\">\n        <span>You have no Lead Sources yet.</span>\n    </div>\n\n\n    <h3 class=\"mb-15\">Archived</h3>\n    <p class=\"mb-15\">Archived Lead Sources are still visible on your Dashboard, but cannot be assigned to Leads and Jobs. They will no longer appear in the Lead Source dropdown on your Contact Form(s) or Questionnaire(s).</p>\n\n    <dynamic-table *ngIf=\"archivedTemplates?.items?.length\" [headerList]=\"tableHeader\" [pageRequest]=\"pageRequestArchived\" [templates]=\"archivedTemplates\" (updateTableParams)=\"updateTemplateList($event, 'ARCHIVED', 'pageRequestArchived')\">\n        <tbody>\n        <tr *ngFor=\"let template of archivedTemplates.items; let i = index\">\n            <td class=\"name-cell-dynamic\">{{ template.name }}</td>\n            <td>\n                <div class=\"flex-box\">\n                    <lead-source-color class=\"flex-box flex-align-center\" [color]=\"template.colour.hex\"></lead-source-color>\n                    <span class=\"ml-5\">{{ template.colour.name }}</span>\n                </div>\n            </td>\n            <td class=\"text-right\">\n                <button *ngIf=\"template.actions?.EDIT\"  type=\"button\" [disabled]=\"buttonDisable\" (click)=\"openEditModal('EDIT_EXISTING', pageRequestArchived, template)\"\n                        class=\"btn btn-default mb-0\">\n                    <i class=\"fi fi-edit ng-scope\"></i>\n                    Edit\n                </button>\n                <button *ngIf=\"template.actions?.UNARCHIVE\" type=\"button\" [disabled]=\"buttonDisable\" (click)=\"unarchiveLeadSource(template)\"\n                        class=\"btn btn-default mb-0\">\n                    Unarchive\n                </button>\n                <button *ngIf=\"template.actions?.DELETE\" [disabled]=\"buttonDisable\" type=\"button\" (click)=\"deleteLeadSource(template, pageRequestArchived)\"\n                        class=\"btn btn-delete btn-delete-empty mb-0\"></button>\n            </td>\n        </tr>\n        </tbody>\n    </dynamic-table>\n\n    <div class=\"stats__placeholder\" *ngIf=\"!archivedTemplates?.items?.length\">\n        <span>You have no archived Lead Sources yet.</span>\n    </div>\n\n</div>\n\n"

/***/ }),

/***/ "./web/modern/components/settings/lead-sources-section/lead-sources-section.scss":
/***/ (function(module, exports) {

module.exports = "tbody > tr > td {\n  padding: 10px; }\n\ntr:nth-child(even) {\n  background-color: #f9f9f9; }\n\n.name-cell-dynamic {\n  width: 350px; }\n  @media screen and (max-width: 1199px) {\n    .name-cell-dynamic {\n      width: 325px; } }\n"

/***/ }),

/***/ "./web/modern/components/settings/lead-sources-section/lead-sources-section.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var rxjs_1 = __webpack_require__("./node_modules/rxjs/Rx.js");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var manage_lead_source_modal_component_1 = __webpack_require__("./web/modern/components/settings/lead-sources-section/modals/manage-lead-source-modal/manage-lead-source-modal.component.ts");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var delete_lead_source_modal_component_1 = __webpack_require__("./web/modern/components/settings/lead-sources-section/modals/delete-lead-source-modal/delete-lead-source-modal.component.ts");
var confirm_general_modal_component_1 = __webpack_require__("./web/modern/components/common/confirm-general-modal/confirm-general-modal.component.ts");
var account_service_1 = __webpack_require__("./web/modern/services/user/account.service.ts");
var lead_sources_data_service_1 = __webpack_require__("./shared/services/lead-sources/lead-sources.data.service.ts");
var of_1 = __webpack_require__("./node_modules/rxjs/observable/of.js");
var LeadSourcesSectionComponent = function () {
    function LeadSourcesSectionComponent(modalService, leadSourcesService, messageService, accountService) {
        _classCallCheck(this, LeadSourcesSectionComponent);

        this.modalService = modalService;
        this.leadSourcesService = leadSourcesService;
        this.messageService = messageService;
        this.accountService = accountService;
        this.breadcrumbs = [{ link: '/', title: 'Dashboard' }, { link: '/settings', title: 'Settings' }, { link: null, title: 'Lead Sources' }];
        this.tableHeader = [{ text: 'Source name', isSortable: true, sortingCriteria: 'name' }, { text: 'Colour', isSortable: false, sortingCriteria: null }, { text: '', isSortable: false, sortingCriteria: null }];
        this.pageRequestActive = {
            paging: {
                pageNumber: 0,
                pageSize: 10,
                searchToken: null
            },
            sortCriterias: [{
                fieldName: 'name',
                sortAscending: true
            }]
        };
        this.pageRequestArchived = {
            paging: {
                pageNumber: 0,
                pageSize: 5,
                searchToken: null
            },
            sortCriterias: [{
                fieldName: 'name',
                sortAscending: true
            }]
        };
        this.unsubscribe = new rxjs_1.Subject();
    }

    _createClass(LeadSourcesSectionComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.getCompanyId();
            this.applyPageProductFromLocalStorage('ACTIVE', this.pageRequestActive);
            this.applyPageProductFromLocalStorage('ARCHIVED', this.pageRequestArchived);
            this.getLeadSourcesList('ACTIVE', this.pageRequestActive);
            this.getLeadSourcesList('ARCHIVED', this.pageRequestArchived);
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "openEditModal",
        value: function openEditModal(action, pageRequest, item) {
            var _this = this;

            var props = action === 'CREATE_NEW' ? this.addNewAction : item.actions.EDIT;
            if (this.checkForAlertModalMethod(props)) {
                return;
            }
            var modal = this.modalService.openModal(manage_lead_source_modal_component_1.ManageLeadSourceModalComponent, {
                windowClass: 'ng-bootstrap-modal modal-visible'
            });
            modal.componentInstance.action = { action: action, props: props };
            modal.componentInstance.colours = this.availableColours;
            if (item) {
                modal.componentInstance.selectedItem = item;
            }
            modal.result.then(function (state) {
                if (state === 'CREATE_NEW') {
                    _this.saveNewLeadSource();
                }
                if (state === 'EDIT_EXISTING') {
                    _this.editLeadSourceItem(item.status, pageRequest);
                }
            }).catch();
        }
    }, {
        key: "archiveLeadSource",
        value: function archiveLeadSource(item) {
            var _this2 = this;

            if (this.checkForAlertModalMethod(item.actions.ARCHIVE)) {
                return;
            }
            var _item$actions$ARCHIVE = item.actions.ARCHIVE,
                url = _item$actions$ARCHIVE.url,
                method = _item$actions$ARCHIVE.method;

            this.buttonDisable = true;
            this.archiveOrUnarchiveLeadSource(url, method).subscribe(function () {
                _this2.messageService.showToaster('s_2', 'leadSources');
            });
        }
    }, {
        key: "unarchiveLeadSource",
        value: function unarchiveLeadSource(item) {
            var _this3 = this;

            if (this.checkForAlertModalMethod(item.actions.UNARCHIVE)) {
                return;
            }
            var _item$actions$UNARCHI = item.actions.UNARCHIVE,
                url = _item$actions$UNARCHI.url,
                method = _item$actions$UNARCHI.method;

            this.archiveOrUnarchiveLeadSource(url, method).subscribe(function () {
                _this3.messageService.showToaster('s_4', 'leadSources');
            });
        }
    }, {
        key: "updateTemplateList",
        value: function updateTemplateList(data, status, pageRequestType) {
            this[pageRequestType] = JSON.parse(JSON.stringify(data));
            this.getLeadSourcesList(status, this[pageRequestType]);
        }
    }, {
        key: "deleteLeadSource",
        value: function deleteLeadSource(item, pageRequest) {
            var _this4 = this;

            if (this.checkForAlertModalMethod(item.actions.DELETE)) {
                return;
            }
            this.buttonDisable = true;
            var _item$actions$DELETE = item.actions.DELETE,
                url = _item$actions$DELETE.url,
                method = _item$actions$DELETE.method;

            this.leadSourcesService.sendAction(url, method, {}).pipe(operators_1.takeUntil(this.unsubscribe), operators_1.finalize(function () {
                return _this4.buttonDisable = false;
            })).subscribe(function (data) {
                var metadata = data.data;
                var modal = _this4.modalService.openModal(delete_lead_source_modal_component_1.DeleteLeadSourceModalComponent, { windowClass: 'ng-bootstrap-modal modal-visible modal-short' });
                modal.componentInstance.action = metadata.actions.MERGE_AND_DELETE;
                modal.componentInstance.leadSource = item;
                modal.componentInstance.leadSourcesList = metadata.leadSources;
                modal.componentInstance.linkedEvents = metadata.totalLinkedEvents;
                modal.result.then(function () {
                    _this4.messageService.showToaster('s_3', 'leadSources');
                    pageRequest.paging.pageNumber = 0;
                    pageRequest.paging.searchToken = null;
                    _this4.getLeadSourcesList(item.status, pageRequest);
                }).catch();
            }, function (err) {
                return _this4.handleError(err);
            });
        }
    }, {
        key: "archiveOrUnarchiveLeadSource",
        value: function archiveOrUnarchiveLeadSource(url, method) {
            var _this5 = this;

            this.buttonDisable = true;
            return this.leadSourcesService.sendAction(url, method, {}).pipe(operators_1.takeUntil(this.unsubscribe), operators_1.finalize(function () {
                return _this5.buttonDisable = false;
            }), operators_1.catchError(function (err) {
                _this5.handleError(err);
                return rxjs_1.Observable.empty();
            }), operators_1.switchMap(function () {
                _this5.pageRequestActive.paging.searchToken = null;
                _this5.pageRequestActive.paging.pageNumber = 0;
                _this5.pageRequestArchived.paging.searchToken = null;
                _this5.pageRequestArchived.paging.pageNumber = 0;
                _this5.getLeadSourcesList('ACTIVE', _this5.pageRequestActive);
                _this5.getLeadSourcesList('ARCHIVED', _this5.pageRequestArchived);
                return of_1.of(null);
            }));
        }
    }, {
        key: "getLeadSourcesList",
        value: function getLeadSourcesList(status, pageRequest) {
            var _this6 = this;

            this.leadSourcesService.getLeadSourcesOverview(status, pageRequest).pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (_ref) {
                var data = _ref.data;
                return _this6.successGetLeadSourcesTemplates(data, status, pageRequest);
            }, function (err) {
                return _this6.handleError(err);
            });
        }
    }, {
        key: "successGetLeadSourcesTemplates",
        value: function successGetLeadSourcesTemplates(data, status, pageRequest) {
            if (status === 'ACTIVE' && data.actions.ADD_NEW_ONE) {
                this.addNewAction = data.actions.ADD_NEW_ONE;
            }
            this[status.toLowerCase() + "Templates"] = data.pagingResult;
            this.availableColours = data.colours;
            pageRequest.paging.searchToken = data.pagingResult.searchToken;
            this.setPageProductToLocalStorage(status, pageRequest);
        }
    }, {
        key: "saveNewLeadSource",
        value: function saveNewLeadSource() {
            this.pageRequestActive.paging.pageNumber = 0;
            this.pageRequestActive.paging.searchToken = null;
            this.getLeadSourcesList('ACTIVE', this.pageRequestActive);
            this.messageService.showToaster('s_0', 'leadSources');
        }
    }, {
        key: "editLeadSourceItem",
        value: function editLeadSourceItem(status, pageRequest) {
            this.getLeadSourcesList(status, pageRequest);
            this.messageService.showToaster('s_1', 'leadSources');
        }
    }, {
        key: "checkForAlertModalMethod",
        value: function checkForAlertModalMethod(action) {
            var method = action.method,
                alertMessage = action.alertMessage;

            if (method === 'ALERT_MODAL') {
                var title = alertMessage.title,
                    message = alertMessage.message;

                this.openAlertModal(title, message);
                return true;
            }
            return false;
        }
    }, {
        key: "openAlertModal",
        value: function openAlertModal(title, text) {
            var alertModal = this.modalService.openModal(confirm_general_modal_component_1.ConfirmGeneralModalComponent);
            alertModal.componentInstance.title = title;
            alertModal.componentInstance.text = text;
            alertModal.componentInstance.buttons = [{
                text: 'Got it',
                color: 'default',
                size: 'lg',
                action: 'CLOSE_ALERT'
            }];
        }
    }, {
        key: "applyPageProductFromLocalStorage",
        value: function applyPageProductFromLocalStorage(status, pageRequest) {
            var pageRequestObject = JSON.parse(localStorage.getItem("leadSourcesRequest" + status + "_" + this.companyId));
            if (pageRequestObject && pageRequestObject !== '') {
                var pageSize = pageRequestObject.pageSize,
                    fieldName = pageRequestObject.fieldName,
                    sortAscending = pageRequestObject.sortAscending;

                pageRequest.paging.pageSize = pageSize;
                pageRequest.sortCriterias[0].fieldName = fieldName;
                pageRequest.sortCriterias[0].sortAscending = sortAscending;
            }
        }
    }, {
        key: "setPageProductToLocalStorage",
        value: function setPageProductToLocalStorage(status, pageRequest) {
            var pageRequestObject = {
                pageSize: pageRequest.paging.pageSize,
                fieldName: pageRequest.sortCriterias[0].fieldName,
                sortAscending: pageRequest.sortCriterias[0].sortAscending
            };
            var pageRequestString = JSON.stringify(pageRequestObject);
            localStorage.removeItem("leadSourcesRequest" + status + "_" + this.companyId);
            localStorage.setItem("leadSourcesRequest" + status + "_" + this.companyId, pageRequestString);
        }
    }, {
        key: "getCompanyId",
        value: function getCompanyId() {
            var _this7 = this;

            this.accountService.companyIdObservable.pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (data) {
                return _this7.companyId = data;
            });
        }
    }, {
        key: "handleError",
        value: function handleError(_ref2) {
            var error = _ref2.error;
            var errorMessage = error.errorMessage,
                errorTitle = error.errorTitle;

            this.messageService.showErrorFromBackend(errorTitle, errorMessage);
        }
    }]);

    return LeadSourcesSectionComponent;
}();
LeadSourcesSectionComponent = __decorate([core_1.Component({
    selector: 'lead-sources-section',
    template: __webpack_require__("./web/modern/components/settings/lead-sources-section/lead-sources-section.html"),
    styles: [__webpack_require__("./web/modern/components/settings/lead-sources-section/lead-sources-section.scss")]
}), __metadata("design:paramtypes", [snModal_service_1.SNModalService, lead_sources_data_service_1.LeadSourcesDataService, message_service_1.MessageService, account_service_1.AccountServiceWebProvider])], LeadSourcesSectionComponent);
exports.LeadSourcesSectionComponent = LeadSourcesSectionComponent;

/***/ }),

/***/ "./web/modern/components/settings/lead-sources-section/modals/delete-lead-source-modal/delete-lead-source-modal.component.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-body text-align-center\">\n    <form (ngSubmit)=\"deleteLeadSource()\" class=\"form-horizontal\" role=\"form\">\n        <ng-container *ngIf=\"linkedEvents\">\n            <p class=\"mb-25\">There are <b>{{ linkedEvents }}</b> Leads/Jobs linked to this <b>{{ leadSource.name }}</b> Lead Source that will need to be migrated to a new Lead Source.</p>\n            <p class=\"mb-10 mt-0\">Please choose None or a new Lead Source from the list.</p>\n\n            <div class=\"mb-25\">\n                <div class=\"select-style\">\n                    <select [ngModel]=\"leadSourceToMergeInto\" (ngModelChange)=\"onSelectChange($event)\" [ngModelOptions]=\"{standalone: true}\">\n                        <option [ngValue]=\"null\">None</option>\n                        <ng-container *ngFor=\"let leadSourceItem of leadSourcesList\">\n                            <option *ngIf=\"leadSourceItem.name !== leadSource.name\" [ngValue]=\"leadSourceItem\">{{ leadSourceItem.name }} {{ leadSourceItem.status === 'ARCHIVED' ? '(archived)' : null }}</option>\n                        </ng-container>\n                    </select>\n\n                </div>\n            </div>\n        </ng-container>\n\n        <p class=\"mt-0 mb-0\" >To delete <span *ngIf=\"linkedEvents\">and migrate</span> <b>{{ leadSource.name }}</b>, enter DELETE below.</p>\n        <p class=\"mt-0 mb-10\">This action cannot be undone.</p>\n        <input class=\"form-control\" type=\"text\" [placeholder]=\"'Enter DELETE to confirm'\" [(ngModel)]=\"confirmWord\" [ngModelOptions]=\"{standalone: true}\">\n        <div class=\"pt-25\">\n            <button type=\"submit\" class=\"btn btn-lg btn-danger mb-0 mr-10\" spinning-wheel [is-spinning-wheel-active]=\"btnDisabled\" [disabled]=\"btnDisabled\">Delete Permanently</button>\n            <button (click)=\"onDismiss()\" [disabled]=\"btnDisabled\" class=\"btn btn-lg btn-default mb-0\" data-dismiss=\"modal\" type=\"button\">Cancel</button>\n        </div>\n    </form>\n</div>\n\n"

/***/ }),

/***/ "./web/modern/components/settings/lead-sources-section/modals/delete-lead-source-modal/delete-lead-source-modal.component.scss":
/***/ (function(module, exports) {

module.exports = ".modal-body p {\n  font-size: 14px; }\n"

/***/ }),

/***/ "./web/modern/components/settings/lead-sources-section/modals/delete-lead-source-modal/delete-lead-source-modal.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var rxjs_1 = __webpack_require__("./node_modules/rxjs/Rx.js");
var ng_bootstrap_1 = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/index.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var lead_sources_data_service_1 = __webpack_require__("./shared/services/lead-sources/lead-sources.data.service.ts");
var DeleteLeadSourceModalComponent = function () {
    function DeleteLeadSourceModalComponent(activeModal, leadSourcesService, messageService) {
        _classCallCheck(this, DeleteLeadSourceModalComponent);

        this.activeModal = activeModal;
        this.leadSourcesService = leadSourcesService;
        this.messageService = messageService;
        this.leadSourceToMergeInto = null;
        this.unsubscribe = new rxjs_1.Subject();
    }

    _createClass(DeleteLeadSourceModalComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.sortLeadSources();
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "onSelectChange",
        value: function onSelectChange(value) {
            this.leadSourceToMergeInto = value;
        }
    }, {
        key: "deleteLeadSource",
        value: function deleteLeadSource() {
            var _this = this;

            if (this.confirmWord && this.confirmWord.toUpperCase() === 'DELETE') {
                this.btnDisabled = true;
                this.leadSourcesService.sendAction(this.action.url, this.action.method, {
                    destLeadSourceId: this.leadSourceToMergeInto ? this.leadSourceToMergeInto.id : null
                }).pipe(operators_1.takeUntil(this.unsubscribe), operators_1.finalize(function () {
                    return _this.btnDisabled = false;
                })).subscribe(function () {
                    return _this.activeModal.close();
                }, function (err) {
                    return _this.handleError(err);
                });
            } else {
                this.messageService.showToaster('e_3', 'leadSources');
            }
        }
    }, {
        key: "onDismiss",
        value: function onDismiss() {
            if (!this.btnDisabled) {
                this.activeModal.dismiss();
            }
        }
    }, {
        key: "sortLeadSources",
        value: function sortLeadSources() {
            var sortFunction = function sortFunction(a, b) {
                return a.name.localeCompare(b.name);
            };
            var sortedActive = this.leadSourcesList.filter(function (item) {
                return item.status === 'ACTIVE';
            }).sort(sortFunction);
            var sortedArchived = this.leadSourcesList.filter(function (item) {
                return item.status === 'ARCHIVED';
            }).sort(sortFunction);
            this.leadSourcesList = [].concat(_toConsumableArray(sortedActive), _toConsumableArray(sortedArchived));
        }
    }, {
        key: "handleError",
        value: function handleError(_ref) {
            var error = _ref.error;
            var errorMessage = error.errorMessage,
                errorTitle = error.errorTitle;

            this.messageService.showErrorFromBackend(errorTitle, errorMessage);
        }
    }]);

    return DeleteLeadSourceModalComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], DeleteLeadSourceModalComponent.prototype, "leadSource", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], DeleteLeadSourceModalComponent.prototype, "action", void 0);
__decorate([core_1.Input(), __metadata("design:type", Array)], DeleteLeadSourceModalComponent.prototype, "leadSourcesList", void 0);
__decorate([core_1.Input(), __metadata("design:type", Number)], DeleteLeadSourceModalComponent.prototype, "linkedEvents", void 0);
DeleteLeadSourceModalComponent = __decorate([core_1.Component({
    selector: 'delete-lead-source',
    template: __webpack_require__("./web/modern/components/settings/lead-sources-section/modals/delete-lead-source-modal/delete-lead-source-modal.component.html"),
    styles: [__webpack_require__("./web/modern/components/settings/lead-sources-section/modals/delete-lead-source-modal/delete-lead-source-modal.component.scss")]
}), __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal, lead_sources_data_service_1.LeadSourcesDataService, message_service_1.MessageService])], DeleteLeadSourceModalComponent);
exports.DeleteLeadSourceModalComponent = DeleteLeadSourceModalComponent;

/***/ }),

/***/ "./web/modern/components/settings/lead-sources-section/modals/manage-lead-source-modal/manage-lead-source-modal.component.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n    <button class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" (click)=\"onDismiss()\">&times;</button>\n    <h3 class=\"modal-title f-w-n\">{{ action.action === 'CREATE_NEW' ? 'Add New' : 'Edit' }} Lead Source</h3>\n</div>\n<div class=\"modal-body\">\n    <form (ngSubmit)=\"onSubmit()\" class=\"form-horizontal\" role=\"form\">\n        <div class=\"field-info\">\n            <h4 class=\"mt-0\">Source Name</h4>\n            <input type=\"text\" class=\"form-control\" placeholder=\"e.g Referral\" maxlength=\"50\"\n                   [(ngModel)]=\"leadName\" [ngModelOptions]=\"{ standalone: true }\">\n        </div>\n\n        <div class=\"field-info mb-25\">\n            <h4>Colour</h4>\n            <div class=\"select-colour select-style\">\n\n                <div class=\"head\" (click)=\"openSelect($event)\">\n                    <span *ngIf=\"!selectedColour\">Choose colour</span>\n                    <div *ngIf=\"selectedColour\" class=\"lead-color\">\n                        <div class=\"lead-color-item\">\n                            <lead-source-color [color]=\"this.selectedColour.hex\"></lead-source-color>\n                        </div>\n                        <div class=\"lead-color-text\">{{ this.selectedColour.name }}</div>\n                    </div>\n                </div>\n\n\n                <ul class=\"options custom-options\" *ngIf=\"active\" (clickOutside)=\"closeSelect($event)\">\n                    <li *ngFor=\"let colourItem of colours\" class=\"form-control mt-5\" (click)=\"setColor(colourItem)\">\n                        <div class=\"lead-color\" *ngIf=\"colourItem\">\n                            <div class=\"lead-color-item\">\n                                <lead-source-color [color]=\"colourItem.hex\"></lead-source-color>\n                            </div>\n                            <div class=\"lead-color-text\">{{ colourItem.name }}</div>\n                        </div>\n                    </li>\n                </ul>\n            </div>\n        </div>\n        \n        <button type=\"submit\" class=\"btn btn-lg btn-success mb-0 mr-10\" spinning-wheel [is-spinning-wheel-active]=\"btnDisabled\" [disabled]=\"btnDisabled\">Save Lead Source</button>\n        <button class=\"btn btn-lg btn-default mb-0\"  [disabled]=\"btnDisabled\" (click)=\"onDismiss()\">Cancel</button>\n    </form>\n</div>"

/***/ }),

/***/ "./web/modern/components/settings/lead-sources-section/modals/manage-lead-source-modal/manage-lead-source-modal.component.scss":
/***/ (function(module, exports) {

module.exports = ".custom-options {\n  display: block;\n  z-index: 99999; }\n\n.select-colour > .custom-options {\n  max-height: 300px;\n  overflow: auto; }\n\n.head {\n  height: 32px; }\n\n.lead-color {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center; }\n  .lead-color-item {\n    height: 15px;\n    margin-right: 5px; }\n"

/***/ }),

/***/ "./web/modern/components/settings/lead-sources-section/modals/manage-lead-source-modal/manage-lead-source-modal.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var rxjs_1 = __webpack_require__("./node_modules/rxjs/Rx.js");
var ng_bootstrap_1 = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/index.js");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var lead_sources_data_service_1 = __webpack_require__("./shared/services/lead-sources/lead-sources.data.service.ts");
var ManageLeadSourceModalComponent = function () {
    function ManageLeadSourceModalComponent(activeModal, leadSourcesService, messageService) {
        _classCallCheck(this, ManageLeadSourceModalComponent);

        this.activeModal = activeModal;
        this.leadSourcesService = leadSourcesService;
        this.messageService = messageService;
        this.colours = [];
        this.leadName = '';
        this.unsubscribe = new rxjs_1.Subject();
    }

    _createClass(ManageLeadSourceModalComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.prepareDefaultDataToShow();
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "onSubmit",
        value: function onSubmit() {
            var _this = this;

            if (this.isDataValid()) {
                var dataToSave = {
                    colour: this.selectedColour.name,
                    name: this.leadName
                };
                this.btnDisabled = true;
                this.leadSourcesService.sendAction(this.action.props.url, this.action.props.method, dataToSave).pipe(operators_1.takeUntil(this.unsubscribe), operators_1.finalize(function () {
                    return _this.btnDisabled = false;
                })).subscribe(function () {
                    return _this.activeModal.close(_this.action.action);
                }, function (err) {
                    return _this.handleError(err);
                });
            }
        }
    }, {
        key: "onDismiss",
        value: function onDismiss() {
            this.activeModal.dismiss();
        }
    }, {
        key: "setColor",
        value: function setColor(colour) {
            this.selectedColour = colour;
            this.active = false;
        }
    }, {
        key: "openSelect",
        value: function openSelect(ev) {
            this.active = true;
            ev.stopPropagation();
        }
    }, {
        key: "closeSelect",
        value: function closeSelect(ev) {
            ev.stopPropagation();
            this.active = false;
        }
    }, {
        key: "isDataValid",
        value: function isDataValid() {
            if (!this.leadName || !this.leadName.trim()) {
                this.messageService.showToaster('e_0', 'leadSources');
                return false;
            }
            if (this.leadName.trim().split(' ').length === 1 && this.leadName.trim().toLowerCase() === 'none') {
                this.messageService.showToaster('e_2', 'leadSources');
                return false;
            }
            if (!this.selectedColour) {
                this.messageService.showToaster('e_1', 'leadSources');
                return false;
            }
            return true;
        }
    }, {
        key: "prepareDefaultDataToShow",
        value: function prepareDefaultDataToShow() {
            if (this.action.action === 'EDIT_EXISTING') {
                this.leadName = this.selectedItem.name;
                this.selectedColour = this.selectedItem.colour;
            }
        }
    }, {
        key: "handleError",
        value: function handleError(_ref) {
            var error = _ref.error;
            var errorMessage = error.errorMessage,
                errorTitle = error.errorTitle;

            this.messageService.showErrorFromBackend(errorTitle, errorMessage);
        }
    }]);

    return ManageLeadSourceModalComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Array)], ManageLeadSourceModalComponent.prototype, "colours", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], ManageLeadSourceModalComponent.prototype, "action", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], ManageLeadSourceModalComponent.prototype, "selectedItem", void 0);
ManageLeadSourceModalComponent = __decorate([core_1.Component({
    selector: 'manage-lead-source',
    template: __webpack_require__("./web/modern/components/settings/lead-sources-section/modals/manage-lead-source-modal/manage-lead-source-modal.component.html"),
    styles: [__webpack_require__("./web/modern/components/settings/lead-sources-section/modals/manage-lead-source-modal/manage-lead-source-modal.component.scss")]
}), __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal, lead_sources_data_service_1.LeadSourcesDataService, message_service_1.MessageService])], ManageLeadSourceModalComponent);
exports.ManageLeadSourceModalComponent = ManageLeadSourceModalComponent;

/***/ }),

/***/ "./web/modern/components/settings/payment-methods/payment-methods.component.html":
/***/ (function(module, exports) {

module.exports = "<section id=\"main-wrapper\" class=\"setting-section\">\n\n\n\t<div class=\"col-md-3 pl-0\">\n\t\t<settings-navigation></settings-navigation>\n\t</div>\n\n\t<div class=\"col-md-9 pr-0 setting-box\">\n\n\t\t<div class=\"bc-wrap flex-box flex-just-space\">\n\t\t\t<setting-section-header [breadcrumbs]=\"breadcrumbs\"></setting-section-header>\n\t\t</div>\n\n\t\t<div class=\"m-30\">\n\t\t\t<setting-section-description\n\t\t\t\t[text]=\"'How would you like your clients to pay? Set up different payment options for your clients when they receive your invoices.'\">\n\t\t\t</setting-section-description>\n\t\t</div>\n\t\t<hr>\n\n\t\t<h3>Pay by credit card</h3><i></i>\n\t\t<h3 class=\"text-normal\">Let your clients pay you via Stripe or Paypal. Used by the world's most recognisable\n\t\t\tcompanies such as Twitter and Kickstarter,\n\t\t\tStripe is a payment processor which allows you to accept online payments securely. PayPal is one of the world's\n\t\t\tlargest internet payment\n\t\t\tcompanies with 170 millions users worldwide. </h3>\n\n\t\t<div class=\"row flex-row flex-wrap-sm payment-methods flex-wrap-md\">\n\n\t\t\t<div class=\"jobs-cell-item payment-methods-wrap\">\n\t\t\t\t<div class=\"row flex-align flex-nowrap flex-wrap-xs\">\n\t\t\t\t\t<div class=\"col-sm-4 flex-align\">\n\t\t\t\t\t\t<img src=\"https://app.studioninja.co/build/release-pipeline-119/resources/dist/assets/images/icons/integration-icons/stripe.png\" class=\"payment-methods__img\">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"col-sm-5\">\n\t\t\t\t\t\t<span>Integrate with stripe. Once set up, your clients can pay directly on the Web Invoice with credit\n\t\t\t\t\t\t\tcards.</span>\n\t\t\t\t\t\t<a (click)=\"showLinkInNewTab('http://help.studioninja.co/payments-and-invoicing/how-to-integrate-with-stripe-preferred-method')\"\n\t\t\t\t\t\t\tclass=\"btn-help\">Help</a>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"col-sm-3 flex-align mt-n5\">\n\t\t\t\t\t\t<button *ngIf=\"hasStripe\" type=\"button\" class=\"btn-block btn btn-info shift-left\"\n\t\t\t\t\t\t\t(click)=\"showDeactivate();\">Deactivate\n\t\t\t\t\t\t</button>\n\t\t\t\t\t\t<button *ngIf=\"hasStripe\" type=\"button\" class=\"btn-block btn  btn-info shift-left mt-5\"\n\t\t\t\t\t\t\t(click)=\"openStripeModal();\">Edit\n\t\t\t\t\t\t</button>\n\t\t\t\t\t\t<button *ngIf=\"!hasStripe\" type=\"button\" class=\"btn btn-info shift-left\"\n\t\t\t\t\t\t\t(click)=\"openStripeModal();\">Activate\n\t\t\t\t\t\t</button>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class=\"jobs-cell-item payment-methods-wrap\">\n\t\t\t\t<div class=\"row flex-align flex-nowrap flex-wrap-xs\">\n\t\t\t\t\t<div class=\"col-sm-4 flex-align\">\n\t\t\t\t\t\t<img src=\"https://app.studioninja.co/build/release-pipeline-119/resources/dist/assets/images/icons/integration-icons/paypal.png\" class=\"payment-methods__img\">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"col-sm-5\">\n\t\t\t\t\t\t<span>Integrate with PayPal and let your clients pay invoices\n\t\t\t\t\t\t\twith their PayPal account or credit cards.</span>\n\t\t\t\t\t\t<a (click)=\"showLinkInNewTab('http://help.studioninja.co/payments-and-invoicing/how-to-integrate-with-paypal')\"\n\t\t\t\t\t\t\tclass=\"btn-help\">Help</a>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"col-sm-3 flex-align mt-n5\">\n\t\t\t\t\t\t<button *ngIf=\"hasPayPal\" type=\"button\" class=\"btn-block btn btn-info shift-left\"\n\t\t\t\t\t\t\t(click)=\"showDeactivatePaypal();\">Deactivate</button>\n\t\t\t\t\t\t<button *ngIf=\"hasPayPal\" type=\"button\" class=\"btn-block btn btn-info shift-left mt-5\"\n\t\t\t\t\t\t\t(click)=\"openPaypalModal();\">Edit</button>\n\t\t\t\t\t\t<button *ngIf=\"!hasPayPal\" type=\"button\" class=\"btn btn-info shift-left\"\n\t\t\t\t\t\t\t(click)=\"openPaypalModal();\">Activate</button>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<hr>\n\n\t\t<form class=\"mb-30\">\n\t\t\t<div class=\"col-xs-12 payment-instructions\" [ngClass]=\"{'mb-30': !last}\"\n\t\t\t\t*ngFor=\"let method of paymentMethods; let first = first; let last = last;\">\n\t\t\t\t<div class=\"row\">\n\t\t\t\t\t<hr *ngIf=\"!first\">\n\t\t\t\t\t<div class=\"flex-row flex-wrap\">\n\t\t\t\t\t\t<div class=\"checkbox-squared mt-30 mb-25\">\n\t\t\t\t\t\t\t<input type=\"checkbox\" id=\"{{method.methodType}}\" name=\"{{method.methodType}}\"\n\t\t\t\t\t\t\t\t[(ngModel)]=\"method.active\" />\n\t\t\t\t\t\t\t<label for=\"{{method.methodType}}\"></label>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<h3>{{method.title}}</h3>\n\t\t\t\t\t\t<h3 class=\"flex-basis-full mb-20 mt-0\">{{method.description}}</h3>\n\t\t\t\t\t</div>\n\t\t\t\t\t<tabs-panel (onClickTab)=\"selectTab($event.tabTitle, method.methodType)\">\n\t\t\t\t\t\t<tab-component *ngFor=\"let lang of method.languages\" [tabTitle]=\"lang.language.displayName\"\n\t\t\t\t\t\t\t[highlight]=\"method.active && !isMethodValid(lang)\" [active]=\"lang.active\">\n\t\t\t\t\t\t\t<div *ngIf=\"lang.actions.DELETE\" class=\"remove-lang\">\n\t\t\t\t\t\t\t\t<p class=\"mb-0\">{{lang.actions.DELETE.actionDescription}}</p>\n\t\t\t\t\t\t\t\t<delete-btn\n\t\t\t\t\t\t\t\t\t*ngIf=\"!isDeleteSpinnerActive\"\n\t\t\t\t\t\t\t\t\t[isDisabled]=\"!lang.actions.DELETE.method\"\n\t\t\t\t\t\t\t\t\t[addClass]=\"'mb-0'\"\n\t\t\t\t\t\t\t\t\t(clicked)=\"openDeleteModal(lang.actions.DELETE)\">\n\t\t\t\t\t\t\t\t</delete-btn>\n\t\t\t\t\t\t\t\t<button *ngIf=\"isDeleteSpinnerActive\" type=\"button\" class=\"btn btn-default btn-rounded line-n mb-0\" disabled\n\t\t\t\t\t\t\t\t\tspinning-wheel [is-spinning-wheel-active]=\"isDeleteSpinnerActive\" [is-spinning-wheel-dark]=\"'true'\">\n\t\t\t\t\t\t\t\t\tddeleting\n\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div *ngIf=\"lang.nameOfMethod\" class=\"row top-padd\">\n\t\t\t\t\t\t\t\t<div class=\"col-xs-12 col-md-3 text-xs-left text-md-right\">\n\t\t\t\t\t\t\t\t\t<label for=\"{{method.methodType + '-' + lang.language.name}}\" style=\"padding-top: 7px\"\n\t\t\t\t\t\t\t\t\t\tclass=\"control-label\">\n\t\t\t\t\t\t\t\t\t\tName of Method\n\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"col-xs-12 col-md-9\">\n\t\t\t\t\t\t\t\t\t<input id=\"{{method.methodType + '-' + lang.language.name}}\" maxlength=\"50\" autocomplete=\"off\"\n\t\t\t\t\t\t\t\t\t\t[(ngModel)]=\"lang.nameOfMethod.text\" type=\"text\" class=\"form-control\"\n\t\t\t\t\t\t\t\t\t\tname=\"{{method.methodType + '-' + lang.language.name}}\"\n\t\t\t\t\t\t\t\t\t\tplaceholder=\"{{lang.nameOfMethod.placeholder}}\" />\n\t\t\t\t\t\t\t\t\t<label class=\"label-counter\">{{ lang.nameOfMethod.text.length }}/50</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"row top-padd\">\n\t\t\t\t\t\t\t\t<div class=\"col-xs-12 col-md-3 text-xs-left text-md-right\">\n\t\t\t\t\t\t\t\t\t<label for=\"name-of-methods\" style=\"padding-top: 7px\" class=\"control-label\">\n\t\t\t\t\t\t\t\t\t\tInstructions\n\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"col-xs-12 col-md-9\">\n\t\t\t\t\t\t\t\t\t<sn-quill-editor-web [initValue]=\"lang.instructions.htmlValue\"\n\t\t\t\t\t\t\t\t\t\t[toolbarSettings]=\"'color size font image'\"\n\t\t\t\t\t\t\t\t\t\t[editorID]=\"method.methodType + '_' + lang.language.name\"\n\t\t\t\t\t\t\t\t\t\t[placeholder]=\"lang.instructions.placeholder\" (onTextChange)=\"lang.instructions.htmlValue = $event\">\n\t\t\t\t\t\t\t\t\t</sn-quill-editor-web>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</tab-component>\n\t\t\t\t\t</tabs-panel>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\n\t\t\t<button type=\"button\" class=\"btn btn-success btn-lg mt-30\" [disabled]=\"isSaveSpinnningWheelActive\"\n\t\t\t\t(click)=\"savePaymentMethods()\" spinning-wheel [is-spinning-wheel-active]=\"isSaveSpinnningWheelActive\">Save\n\t\t\t\tPayment\n\t\t\t\tMethods\n\t\t\t</button>\n\t\t</form>\n\n\t</div>\n</section>\n\n<div id=\"addStripeModal\" class=\"modal modal-center fade\" data-backdrop=\"static\" data-keyboard=\"false\">\n\t<div class=\"modal-dialog new-pay-sched-dialog \">\n\t\t<div class=\"modal-content\">\n\t\t\t<div class=\"modal-header\">\n\t\t\t\t<button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\"\n\t\t\t\t\tdata-autotest-button=\"close\">&times;</button>\n\t\t\t\t<h3 class=\"modal-title\">Stripe payment method</h3>\n\t\t\t</div>\n\t\t\t<form name=\"creationForm\" (ngSubmit)=\"saveStripeMethod();\">\n\t\t\t\t<div class=\"modal-body\">\n\t\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t\t<label *ngIf=\"stripePaymentMethod\" class=\"control-label\">Secret Key</label>\n\t\t\t\t\t\t<input class=\"form-control\" type=\"text\" autocomplete=\"off\" name=\"secretKey\" placeholder=\"Secret Key\"\n\t\t\t\t\t\t\t[(ngModel)]=\"stripePaymentMethod.stripeSecretKey\" maxlength=\"255\">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t\t<label *ngIf=\"stripePaymentMethod\" class=\"control-label\">Publishable Key</label>\n\t\t\t\t\t\t<input class=\"form-control\" type=\"text\" autocomplete=\"off\" name=\"publicKey\" placeholder=\"Public Key\"\n\t\t\t\t\t\t\t[(ngModel)]=\"stripePaymentMethod.stripePublicKey\" maxlength=\"255\">\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"modal-footer modal-foot\">\n\t\t\t\t\t<button type=\"submit\" class=\"btn btn-success btn-lg\" [disabled]=\"button_disable\" spinning-wheel\n\t\t\t\t\t\t[is-spinning-wheel-active]=\"button_disable\">Save payment method</button>\n\t\t\t\t</div>\n\t\t\t</form>\n\t\t</div>\n\t</div>\n</div>\n\n<div id=\"delStripeModal\" class=\"modal modal-center fade\" data-backdrop=\"static\" data-keyboard=\"false\">\n\t<div class=\"modal-dialog new-pay-sched-dialog \">\n\t\t<div class=\"modal-content\">\n\t\t\t<div class=\"modal-header\">\n\t\t\t\t<button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\"\n\t\t\t\t\tdata-autotest-button=\"close\">&times;</button>\n\t\t\t\t<h3 class=\"modal-title\">Delete Stripe payment method?</h3>\n\t\t\t</div>\n\t\t\t<div class=\"modal-body\">\n\t\t\t\t<strong>Are you sure?</strong>\n\t\t\t</div>\n\t\t\t<form name=\"creationForm\" (ngSubmit)=\"deactivateStripeModal();\">\n\t\t\t\t<div class=\"modal-footer modal-foot\">\n\t\t\t\t\t<button type=\"submit\" class=\"btn btn-danger btn-lg\" [disabled]=\"button_disable\" spinning-wheel\n\t\t\t\t\t\t[is-spinning-wheel-active]=\"button_disable\">Delete payment method</button>\n\t\t\t\t\t<button type=\"button\" class=\"btn btn-general btn-lg\" data-dismiss=\"modal\" aria-hidden=\"true\">Cancel</button>\n\t\t\t\t</div>\n\t\t\t</form>\n\t\t</div>\n\t</div>\n</div>\n\n<div id=\"delPayPalModal\" class=\"modal modal-center fade\" data-backdrop=\"static\" data-keyboard=\"false\">\n\t<div class=\"modal-dialog new-pay-sched-dialog \">\n\t\t<div class=\"modal-content\">\n\t\t\t<div class=\"modal-header\">\n\t\t\t\t<button class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\">&times;</button>\n\t\t\t\t<h3 class=\"modal-title\">Delete PayPal payment method?</h3>\n\t\t\t</div>\n\t\t\t<div class=\"modal-body\">\n\t\t\t\t<strong>Are you sure?</strong>\n\t\t\t</div>\n\t\t\t<form name=\"creationForm\" (ngSubmit)=\"deactivatePaypalModal();\">\n\t\t\t\t<div class=\"modal-footer modal-foot\">\n\t\t\t\t\t<button type=\"submit\" class=\"btn btn-danger btn-lg\" [disabled]=\"button_disable\" spinning-wheel\n\t\t\t\t\t\t[is-spinning-wheel-active]=\"button_disable\">Delete payment method</button>\n\t\t\t\t\t<button type=\"button\" class=\"btn btn-general btn-lg\" data-dismiss=\"modal\" aria-hidden=\"true\">Cancel</button>\n\t\t\t\t</div>\n\t\t\t</form>\n\t\t</div>\n\t</div>\n</div>\n\n<div id=\"addPaypalModal\" class=\"modal modal-center fade\" data-backdrop=\"static\" data-keyboard=\"false\">\n\t<div class=\"modal-dialog new-pay-sched-dialog \">\n\t\t<div class=\"modal-content\">\n\t\t\t<div class=\"modal-header\">\n\t\t\t\t<button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\"\n\t\t\t\t\tdata-autotest-button=\"close\">&times;</button>\n\t\t\t\t<h3 class=\"modal-title\">PayPal payment method</h3>\n\t\t\t</div>\n\t\t\t<form name=\"creationForm\" (ngSubmit)=\"savePaypalMethod();\">\n\t\t\t\t<div class=\"modal-body\">\n\t\t\t\t\t<div class=\"form-group mb-0\">\n\t\t\t\t\t\t<label class=\"control-label mb-15\">PayPal business email address:</label>\n\t\t\t\t\t\t<input class=\"form-control\" type=\"email\" name=\"paypalBusinessEmail\" placeholder=\"PayPal business email\"\n\t\t\t\t\t\t\t[(ngModel)]=\"paypalPaymentMethod.paypalEmail\">\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"modal-footer modal-foot\">\n\t\t\t\t\t<button type=\"submit\" class=\"btn btn-success btn-lg\" [disabled]=\"button_disable\" spinning-wheel\n\t\t\t\t\t\t[is-spinning-wheel-active]=\"button_disable\">Save payment method</button>\n\t\t\t\t</div>\n\t\t\t</form>\n\t\t</div>\n\t</div>\n</div>\n"

/***/ }),

/***/ "./web/modern/components/settings/payment-methods/payment-methods.component.scss":
/***/ (function(module, exports) {

module.exports = ".payment-methods .payment-methods-wrap {\n  padding: 15px 5px 15px 10px;\n  -webkit-box-flex: 1;\n  -webkit-flex: 1;\n      -ms-flex: 1;\n          flex: 1; }\n  .payment-methods .payment-methods-wrap div {\n    padding: 10px 15px; }\n\n.payment-methods .shift-left {\n  margin-left: -20px; }\n\n.payment-methods__img {\n  max-width: 100%;\n  height: 35px;\n  width: auto; }\n\n.payment-methods button {\n  margin: 0 auto;\n  width: auto !important;\n  -webkit-box-flex: 1;\n  -webkit-flex: 1 1 100%;\n      -ms-flex: 1 1 100%;\n          flex: 1 1 100%; }\n  @media (max-width: 767px) {\n    .payment-methods button {\n      -webkit-flex-basis: auto;\n          -ms-flex-preferred-size: auto;\n              flex-basis: auto;\n      margin: 5px 2px 0; } }\n\n.payment-instructions .remove-lang {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: justify;\n  -webkit-justify-content: space-between;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  padding: 9px 20px;\n  background: rgba(239, 145, 34, 0.1);\n  border-radius: 4px; }\n"

/***/ }),

/***/ "./web/modern/components/settings/payment-methods/payment-methods.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, toastr) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = __webpack_require__("./node_modules/@angular/common/esm5/http.js");
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var validation_service_1 = __webpack_require__("./shared/services/helpers/validation.service.ts");
var confirm_general_modal_component_1 = __webpack_require__("./web/modern/components/common/confirm-general-modal/confirm-general-modal.component.ts");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var payment_methods_data_service_1 = __webpack_require__("./web/modern/services/settings/payment-methods/payment-methods.data.service.ts");
var PaymentMethods = function () {
    function PaymentMethods(http, pmDataService, messageService, validationService, modalService) {
        _classCallCheck(this, PaymentMethods);

        this.http = http;
        this.pmDataService = pmDataService;
        this.messageService = messageService;
        this.validationService = validationService;
        this.modalService = modalService;
        this.isSaveSpinnningWheelActive = false;
        this.isDeleteSpinnerActive = false;
        this.paymentMethods = [];
        this.button_disable = false;
        this.stripePaymentMethod = {};
        this.paypalPaymentMethod = {};
        this.activeBankTransferTab = {};
        this.activeOtherTab = {};
        this.hasStripe = false;
        this.hasPayPal = false;
        this.breadcrumbs = [{ link: '/', title: 'Dashboard' }, { link: '/settings', title: 'Settings' }, { link: null, title: 'Payment Methods' }];
    }

    _createClass(PaymentMethods, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.getAllPaymentMethods();
            this.getPaymentInstructions();
        }
    }, {
        key: "getAllPaymentMethods",
        value: function getAllPaymentMethods() {
            var _this = this;

            this.pmDataService.getAllPaymentMethods().then(function (result) {
                _this.setPaymentMethods(result);
            }).catch(function (err) {
                _this.messageService.showDefaultErrorMessage(err);
            });
        }
    }, {
        key: "getPaymentInstructions",
        value: function getPaymentInstructions() {
            var _this2 = this;

            this.pmDataService.getPaymentInstructions().then(function (res) {
                return _this2.setPaymentInstructions(res);
            }).catch(function (e) {
                _this2.messageService.showDefaultErrorMessage(e);
            });
        }
    }, {
        key: "setPaymentInstructions",
        value: function setPaymentInstructions(_ref) {
            var _this3 = this;

            var paymentMethods = _ref.paymentMethods;

            this.paymentMethods = paymentMethods;
            this.paymentMethods.forEach(function (method) {
                if (method.active) {
                    var firstInvalid = method.languages.find(function (lang) {
                        return !_this3.isMethodValid(lang);
                    });
                    if (firstInvalid) {
                        firstInvalid.active = true;
                        _this3.selectTab(firstInvalid.language.displayName, method.methodType);
                    } else {
                        method.languages[0].active = true;
                    }
                } else {
                    method.languages[0].active = true;
                }
                var languages = method.languages;
                languages.forEach(function (language) {
                    if (language.language.displayName === _this3.activeBankTransferTab.tabTitle && method.methodType === _this3.activeBankTransferTab.methodType) {
                        method.languages[0].active = false;
                        language.active = true;
                    }
                    if (language.language.displayName === _this3.activeOtherTab.tabTitle && method.methodType === _this3.activeOtherTab.methodType) {
                        method.languages[0].active = false;
                        language.active = true;
                    }
                });
            });
        }
    }, {
        key: "selectTab",
        value: function selectTab(languageName, methodType) {
            if (methodType === 'BANK_TRANSFER_INSTRUCTIONS') {
                this.activeBankTransferTab = {
                    tabTitle: languageName,
                    methodType: methodType
                };
            }
            if (methodType === 'OTHER_INSTRUCTIONS') {
                this.activeOtherTab = {
                    tabTitle: languageName,
                    methodType: methodType
                };
            }
        }
    }, {
        key: "setPaymentMethods",
        value: function setPaymentMethods(methods) {
            if (!methods.length) {
                return;
            }
            this.stripePaymentMethod = this.findMethodByType('STRIPE', methods);
            this.paypalPaymentMethod = this.findMethodByType('PAYPAL', methods);
            if (this.stripePaymentMethod) {
                this.hasStripe = true;
            } else {
                this.stripePaymentMethod = {};
            }
            if (this.paypalPaymentMethod) {
                this.hasPayPal = true;
            } else {
                this.paypalPaymentMethod = {};
            }
        }
    }, {
        key: "findMethodByType",
        value: function findMethodByType(type, methods) {
            return methods.find(function (method) {
                return method.type === type;
            });
        }
    }, {
        key: "showDeactivatePaypal",
        value: function showDeactivatePaypal() {
            $('#delPayPalModal').modal('show');
        }
    }, {
        key: "deactivatePaypalModal",
        value: function deactivatePaypalModal() {
            this.hasPayPal = false;
            delete this.paypalPaymentMethod.paypalEmail;
            $('#delPayPalModal').modal('hide');
            this.savePayPalRequest();
        }
    }, {
        key: "showLinkInNewTab",
        value: function showLinkInNewTab(link) {
            window.open(link);
        }
    }, {
        key: "showDeactivate",
        value: function showDeactivate() {
            $('#delStripeModal').modal('show');
        }
    }, {
        key: "deactivateStripeModal",
        value: function deactivateStripeModal() {
            this.hasStripe = false;
            delete this.stripePaymentMethod.stripePublicKey;
            delete this.stripePaymentMethod.stripeSecretKey;
            $('#delStripeModal').modal('hide');
            this.saveStripeRequest();
        }
    }, {
        key: "isMethodValid",
        value: function isMethodValid(language) {
            var nameOfMethod = language.nameOfMethod,
                _language$instruction = language.instructions;
            _language$instruction = _language$instruction === undefined ? {} : _language$instruction;
            var _language$instruction2 = _language$instruction.htmlValue,
                htmlValue = _language$instruction2 === undefined ? '' : _language$instruction2;

            if (nameOfMethod !== undefined && nameOfMethod !== null) {
                if (!nameOfMethod.text || nameOfMethod.text.trim() === '') {
                    return false;
                }
            }
            if (!htmlValue || htmlValue.trim() === '') {
                return false;
            }
            return true;
        }
    }, {
        key: "preparePaymentMethods2Save",
        value: function preparePaymentMethods2Save(method2Save) {
            var method = JSON.parse(JSON.stringify(method2Save));
            if (!method.active) {
                method.active = false;
            }
            method.languages.forEach(function (el) {
                el.language = el.language.name;
            });
            return method;
        }
    }, {
        key: "checkPayments",
        value: function checkPayments(payments) {
            var _this4 = this;

            return payments.some(function (el) {
                if (el.active && el.languages.some(function (lang) {
                    return !_this4.isMethodValid(lang);
                })) {
                    _this4.messageService.showToaster('e_6', 'paymentMethods', el.title);
                    return true;
                }
                return false;
            });
        }
    }, {
        key: "savePaymentMethods",
        value: function savePaymentMethods() {
            var _this5 = this;

            this.isSaveSpinnningWheelActive = true;
            var payments = this.paymentMethods;
            if (this.checkPayments(payments)) {
                this.isSaveSpinnningWheelActive = false;
                return;
            }
            var methodsToSave = payments.map(this.preparePaymentMethods2Save);
            this.pmDataService.savePaymentMethods({
                paymentMethods: methodsToSave
            }).then(function (data) {
                _this5.messageService.showToaster('s_2', 'paymentMethods');
                _this5.isSaveSpinnningWheelActive = false;
                _this5.setPaymentInstructions(data);
            }).catch(function (err) {
                if (err.status !== 401) {
                    _this5.messageService.showDefaultErrorMessage(err);
                }
            }).finally(function () {
                _this5.isSaveSpinnningWheelActive = false;
            });
        }
    }, {
        key: "openDeleteModal",
        value: function openDeleteModal(deleteData) {
            var _this6 = this;

            if (deleteData.method === 'ALERT_MODAL' && deleteData.alertMessage) {
                this.openAlertModal(deleteData.alertMessage.message, deleteData.alertMessage.title);
            } else {
                if (!deleteData.withConfirmationMessage) {
                    this.deleteLang(deleteData.url);
                    return;
                }
                var _deleteData$withConfi = deleteData.withConfirmationMessage,
                    messageHTML = _deleteData$withConfi.messageHTML,
                    _deleteData$withConfi2 = _deleteData$withConfi.buttons,
                    cancelBtn = _deleteData$withConfi2.cancelBtn,
                    confirmBtn = _deleteData$withConfi2.confirmBtn,
                    url = deleteData.url;

                var modal = this.modalService.openModal(confirm_general_modal_component_1.ConfirmGeneralModalComponent);
                modal.componentInstance.htmlText = true;
                modal.componentInstance.text = messageHTML;
                modal.componentInstance.buttons = [{
                    text: confirmBtn.name,
                    color: 'success',
                    size: 'lg',
                    action: 'DELETE'
                }, {
                    text: cancelBtn.name,
                    color: 'default',
                    size: 'lg',
                    action: 'CANCEL'
                }];
                modal.result.then(function (action) {
                    if (action === 'DELETE') {
                        _this6.deleteLang(url);
                    }
                });
            }
        }
    }, {
        key: "openAlertModal",
        value: function openAlertModal(message, title) {
            var modal = this.modalService.openModal(confirm_general_modal_component_1.ConfirmGeneralModalComponent, {
                windowClass: 'ng-bootstrap-modal modal-visible modal-narrow'
            });
            modal.componentInstance.text = message;
            modal.componentInstance.title = title;
            modal.componentInstance.htmlText = true;
            modal.componentInstance.buttons = [{
                text: 'Got it!',
                action: 'CLOSE',
                color: 'default',
                size: 'lg'
            }];
        }
    }, {
        key: "deleteLang",
        value: function deleteLang(url) {
            var _this7 = this;

            this.isSaveSpinnningWheelActive = true;
            this.isDeleteSpinnerActive = true;
            this.pmDataService.deleteLang(url).then(function (res) {
                _this7.setPaymentInstructions(res.data);
            }).catch(function (e) {
                _this7.messageService.showDefaultErrorMessage(e);
            }).finally(function () {
                _this7.isSaveSpinnningWheelActive = false;
                _this7.isDeleteSpinnerActive = false;
            });
        }
    }, {
        key: "openStripeModal",
        value: function openStripeModal() {
            var _this8 = this;

            this.pmDataService.getPaymetMethodByType('STRIPE').then(function (result) {
                _this8.stripePaymentMethod = result || {};
                $('#addStripeModal').modal('show');
            });
        }
    }, {
        key: "saveStripeMethod",
        value: function saveStripeMethod() {
            if (!this.stripePaymentMethod || !this.stripePaymentMethod.stripeSecretKey || !this.stripePaymentMethod.stripePublicKey) {
                this.messageService.showToaster('e_4', 'paymentMethods');
            } else {
                this.saveStripeRequest();
            }
        }
    }, {
        key: "saveStripeRequest",
        value: function saveStripeRequest() {
            var _this9 = this;

            this.button_disable = true;
            var stipeMethod = this.stripePaymentMethod;
            var isStripeActive = stipeMethod.stripePublicKey && stipeMethod.stripeSecretKey;
            this.pmDataService.saveStripeRequest(this.stripePaymentMethod).then(function (result) {
                return _this9.successSaveStripe(result, isStripeActive);
            }).catch(function (result) {
                return _this9.errorSaveStripe(result);
            }).finally(function () {
                _this9.button_disable = false;
            });
        }
    }, {
        key: "successSaveStripe",
        value: function successSaveStripe(data, isStripeActive) {
            if (isStripeActive) {
                this.hasStripe = true;
            }
            $('#addStripeModal').modal('hide');
            this.messageService.showToaster('s_1', 'paymentMethods');
        }
    }, {
        key: "errorSaveStripe",
        value: function errorSaveStripe(result) {
            if (result.status === 422) {
                this.messageService.showToaster('e_2', 'paymentMethods');
            } else {
                this.messageService.showToaster('e_0', 'general');
            }
        }
    }, {
        key: "openPaypalModal",
        value: function openPaypalModal() {
            var _this10 = this;

            this.pmDataService.getPaymetMethodByType('PAYPAL').then(function (result) {
                _this10.paypalPaymentMethod = result || {};
                $('#addPaypalModal').modal('show');
            });
        }
    }, {
        key: "savePaypalMethod",
        value: function savePaypalMethod() {
            if (this.paypalPaymentMethod && this.validationService.isStringEmpty(this.paypalPaymentMethod.paypalEmail)) {
                return this.messageService.showToaster('e_3', 'paymentMethods');
            }
            if (this.paypalPaymentMethod == '') {
                $('#addPaypalModal').modal('hide');
                toastr.success('No changes');
            } else {
                this.hasPayPal = true;
                this.savePayPalRequest();
            }
        }
    }, {
        key: "savePayPalRequest",
        value: function savePayPalRequest() {
            var _this11 = this;

            this.button_disable = true;
            this.pmDataService.savePayPalRequest(this.paypalPaymentMethod).then(function (result) {
                return _this11.successSavePayPal(result);
            }).catch(function (result) {
                return _this11.errorSavePayPal(result);
            }).finally(function () {
                _this11.button_disable = false;
            });
        }
    }, {
        key: "successSavePayPal",
        value: function successSavePayPal(data) {
            $('#addPaypalModal').modal('hide');
            this.messageService.showToaster('s_0', 'paymentMethods');
        }
    }, {
        key: "errorSavePayPal",
        value: function errorSavePayPal(result) {
            if (result.status === 422) {
                this.messageService.showToaster('e_7', 'paymentMethods');
            } else {
                this.messageService.showToaster('e_0', 'general');
            }
        }
    }]);

    return PaymentMethods;
}();
PaymentMethods = __decorate([core_1.Component({
    selector: 'payment-methods',
    template: __webpack_require__("./web/modern/components/settings/payment-methods/payment-methods.component.html"),
    styles: [__webpack_require__("./web/modern/components/settings/payment-methods/payment-methods.component.scss")]
}), __metadata("design:paramtypes", [http_1.HttpClient, payment_methods_data_service_1.PaymentMethodsDataProvider, message_service_1.MessageService, validation_service_1.ValidationProvider, snModal_service_1.SNModalService])], PaymentMethods);
exports.PaymentMethods = PaymentMethods;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js"), __webpack_require__("./node_modules/toastr/toastr.js")))

/***/ }),

/***/ "./web/modern/components/settings/payment-schedules/modals/payment-schedules-modal/payment-schedules-modal.html":
/***/ (function(module, exports) {

module.exports = "<section>\n  <div id=\"paymentScheduleModal\"  class=\"modal modal-center fade\" tabindex=\"-1\" >\n    <div class=\"modal-dialog\">\n      <div class=\"modal-content\">\n        <div class=\"modal-header\">\n          <close-btn (action)='newForm(); addPayment()'></close-btn>\n          <h3 class=\"modal-title\">{{title}} payment schedule</h3>\n        </div>\n        <form [formGroup]='paymentScheduleForm' (ngSubmit)=\"save()\" ngNativeValidate>\n          <div class=\"modal-body\">\n            <h4>Name</h4>\n            <input class=\"form-control\" [placeholder]='editedPaymentSchedule ? editedPaymentSchedule.name : \"\"' formControlName='name' type=\"text\" autocomplete=\"off\" required maxlength=\"255\">\n            <div formArrayName='payments' *ngFor=\"let payment of payments?.controls; let index = index\">\n              <div [class.mt-30]='index === 0' [formGroupName]='index.toString()'>\n                <hr *ngIf=\"index !== 0\">\n                <div class=\"row\">\n                  <div class=\"col-xs-6\">\n                    <h4>{{index === 0 ? 'First payment/Deposit' : 'Next payment'}}</h4>\n                  </div>\n                  <div class=\"col-xs-6\" *ngIf='payments.controls.length > 1'>\n                    <h4>\n                      <button type=\"button\" class=\"close\" (click)=\"deletePayment(index);\">\n                        <span class=\"modal-close-btn payment-del-btn\" aria-hidden=\"true\">&times;</span>\n                      </button>\n                    </h4>\n                  </div>\n                </div>\n                <label class=\"control-label\">Amount</label>\n\n                <div class=\"row\">\n                  <div class=\"col-sm-6 form-group flex-row flex-align-center\" formGroupName='amount'>\n                    <input type=\"number\" min=\"1\" class=\"form-control\"\n                           [max]='getValidatorValue(index, \"amount\", \"maxValue\")'\n                           formControlName='value'\n                           placeholder=\"100\" required>\n                  </div>\n                  <div class=\"col-sm-6 form-group\">\n                    <div class=\"select-style\">\n                      <select formControlName='type' required>\n                        <option *ngFor='let option of paymentScheduleSettings?.data.scheduleTypes'\n                                [value]='option.key'>\n                          {{option.displayName}}\n                        </option>\n                      </select>\n                    </div>\n                  </div>\n                </div>\n                <label class=\"control-label\">Due</label>\n\n                <div class=\"row\">\n                  <div class=\"col-sm-6 form-group flex-row flex-align-center\" formGroupName='dateItemsAmount'>\n                    <input type=\"number\"\n                           [min]='getValidatorValue(index, \"dateItemsAmount\", \"minValue\")'\n                           class=\"form-control\"\n                           formControlName='value'\n                           [placeholder]=\"getValidatorValue(index, 'dateItemsAmount', 'minValue')\" required>\n                  </div>\n                  <div class=\"col-sm-6 form-group\">\n                    <div class=\"select-style\">\n                      <select formControlName=\"dateItemsType\"\n                              required>\n                        <option *ngFor='let option of paymentScheduleSettings?.data.timeUnits'\n                                [value]='option.key'>\n                          {{option.displayName}}\n                        </option>\n                      </select>\n                    </div>\n                  </div>\n                  <div class=\"col-sm-12 form-group\">\n                    <div class=\"select-style\">\n                      <select formControlName='jobDateDepending'\n                              required>\n                        <option *ngFor='let option of paymentScheduleSettings?.data.dependsTypes'\n                                [value]='option.key'>\n                          {{option.displayName}}\n                        </option>\n                      </select>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div class=\"modal-footer modal-foot\">\n            <button type=\"button\" (click)=\"addPayment()\" [disabled]=\"buttonDisable\"\n                    class=\"btn btn-info btn-add-new-sm mb-30\">Add next payment\n            </button>\n            <div class=\"add-payment\">\n              <button type=\"submit\" class=\"btn btn-success btn-lg add-payment-btn spinning-wheel spinning-wheel__display-after\"\n                      [disabled]=\"buttonDisable\"\n                      [ngClass]=\"{'spinning-wheel__active' : buttonDisable}\"\n              >Save payment schedule\n              </button>\n            </div>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div>\n</section>\n"

/***/ }),

/***/ "./web/modern/components/settings/payment-schedules/modals/payment-schedules-modal/payment-schedules-modal.scss":
/***/ (function(module, exports) {

module.exports = ""

/***/ }),

/***/ "./web/modern/components/settings/payment-schedules/modals/payment-schedules-modal/payment-schedules-modal.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(toastr) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var payments_schedules_data_service_1 = __webpack_require__("./shared/services/payments/payments-schedules-data-service/payments-schedules.data.service.ts");
var forms_1 = __webpack_require__("./node_modules/@angular/forms/esm5/forms.js");
var rxjs_1 = __webpack_require__("./node_modules/rxjs/Rx.js");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var PaymentSchedulesModalComponent = function () {
    function PaymentSchedulesModalComponent(paymentSchedulesDataService, messageService) {
        _classCallCheck(this, PaymentSchedulesModalComponent);

        this.paymentSchedulesDataService = paymentSchedulesDataService;
        this.messageService = messageService;
        this.saved = new core_1.EventEmitter();
        this.error = new core_1.EventEmitter();
        this.buttonDisable = false;
        this.editedPaymentSchedule = null;
        this.unsubscribe$ = new rxjs_1.Subject();
    }

    _createClass(PaymentSchedulesModalComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.newForm();
            this.getSettings();
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe$.next();
            this.unsubscribe$.complete();
        }
    }, {
        key: "newForm",
        value: function newForm() {
            this.editedPaymentSchedule = null;
            this.paymentScheduleForm = new forms_1.FormGroup({
                id: new forms_1.FormControl(null),
                name: new forms_1.FormControl('', [forms_1.Validators.required, forms_1.Validators.maxLength(255)]),
                payments: new forms_1.FormArray([])
            });
        }
    }, {
        key: "save",
        value: function save() {
            var _this = this;

            if (this.paymentScheduleForm.valid) {
                var formData = this.paymentScheduleForm.getRawValue();
                formData.payments.forEach(function (payment) {
                    payment.amount = payment.amount.value;
                    payment.dateItemsAmount = payment.dateItemsAmount.value;
                });
                var requestData = {
                    name: formData.name,
                    rules: formData.payments
                };
                this.buttonDisable = true;
                if (this.title === 'Edit') {
                    requestData.id = formData.id;
                    this.paymentSchedulesDataService.updatePaymentSchedule(requestData).pipe(operators_1.finalize(function () {
                        return _this.buttonDisable = false;
                    })).subscribe(function (response) {
                        return _this.onSuccess(response, 's_3');
                    }, function (error) {
                        return _this.onError(error);
                    });
                } else {
                    this.paymentSchedulesDataService.createPaymentSchedule(requestData).pipe(operators_1.finalize(function () {
                        return _this.buttonDisable = false;
                    })).subscribe(function (response) {
                        return _this.onSuccess(response, 's_0');
                    }, function (error) {
                        return _this.onError(error);
                    });
                }
            }
        }
    }, {
        key: "addPayment",
        value: function addPayment() {
            var newPayment = this.newPaymentFormGroup();
            this.setDefaultValues(newPayment);
            this.payments.push(newPayment);
        }
    }, {
        key: "deletePayment",
        value: function deletePayment(index) {
            this.payments.removeAt(index);
        }
    }, {
        key: "getValidatorValue",
        value: function getValidatorValue(index, formGroupName, validatorName) {
            var formGroup = this.payments.at(index).get(formGroupName);
            return formGroup.get(validatorName).value;
        }
    }, {
        key: "onSuccess",
        value: function onSuccess(response, messageCode) {
            if (response) {
                if (response.data) {
                    this.messageService.showToaster(messageCode, 'paymentSchedules', this.paymentScheduleForm.get('name').value);
                    this.newForm();
                    this.addPayment();
                } else {
                    toastr.error(response.result, 'Error');
                }
                this.saved.emit(response);
            }
        }
    }, {
        key: "onError",
        value: function onError(response) {
            if (response && response.error) {
                var _response$error = response.error,
                    errorTitle = _response$error.errorTitle,
                    errorMessage = _response$error.errorMessage;

                this.messageService.showErrorFromBackend(errorTitle, errorMessage);
            } else {
                this.messageService.showToaster('e_0', 'general');
            }
            this.error.emit();
        }
    }, {
        key: "getSettings",
        value: function getSettings() {
            var _this2 = this;

            this.paymentSchedulesDataService.getPaymentScheduleSettings().subscribe(function (settings) {
                _this2.paymentScheduleSettings = settings;
                _this2.addPayment();
            }, function (err) {
                return console.log(err);
            });
        }
    }, {
        key: "setInitialValues",
        value: function setInitialValues(paymentSchedule) {
            var _this3 = this;

            this.paymentScheduleForm.patchValue(paymentSchedule);
            paymentSchedule.rules.forEach(function (rule) {
                var payment = _this3.newPaymentFormGroup();
                payment.patchValue(rule);
                payment.get('amount').get('value').setValue(rule.amount);
                payment.get('dateItemsAmount').get('value').setValue(rule.dateItemsAmount);
                _this3.payments.push(payment);
            });
        }
    }, {
        key: "setDefaultValues",
        value: function setDefaultValues(formGroup) {
            var settingsData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.paymentScheduleSettings.data;

            var defaultValues = {
                type: settingsData.scheduleTypes[0].key,
                dateItemsType: settingsData.timeUnits[0].key,
                jobDateDepending: settingsData.dependsTypes[0].key
            };
            formGroup.patchValue(defaultValues);
        }
    }, {
        key: "newPaymentFormGroup",
        value: function newPaymentFormGroup() {
            var dateItemsAmount = new forms_1.FormGroup({
                value: new forms_1.FormControl(null),
                minValue: new forms_1.FormControl({ value: null, disabled: true })
            });
            var dateItemsType = new forms_1.FormControl('', [forms_1.Validators.required]);
            var jobDateDepending = new forms_1.FormControl('', [forms_1.Validators.required]);
            var type = new forms_1.FormControl('', [forms_1.Validators.required]);
            var amount = new forms_1.FormGroup({
                value: new forms_1.FormControl(null),
                maxValue: new forms_1.FormControl({ value: null, disabled: true })
            });
            var formGroup = new forms_1.FormGroup({
                id: new forms_1.FormControl(null),
                amount: amount,
                type: type,
                dateItemsAmount: dateItemsAmount,
                dateItemsType: dateItemsType,
                jobDateDepending: jobDateDepending
            });
            var dependsTypes = this.paymentScheduleSettings.data.dependsTypes;

            this.updateValidators(dependsTypes, jobDateDepending, dateItemsAmount, dateItemsType);
            var scheduleTypes = this.paymentScheduleSettings.data.scheduleTypes;

            this.updateValidators(scheduleTypes, type, amount);
            return formGroup;
        }
    }, {
        key: "updateValidators",
        value: function updateValidators(settings, typeControl, subGroup, subTypeControl) {
            typeControl.valueChanges.pipe(operators_1.takeUntil(this.unsubscribe$)).subscribe(function (value) {
                var properties = settings.find(function (option) {
                    return option.key === value;
                }).dueFieldProperties;
                var options = { onlySelf: true, emitEvent: false };
                var valueCtrl = subGroup.get('value');
                if ('minValue' in properties) {
                    valueCtrl.setValidators([forms_1.Validators.required, forms_1.Validators.min(properties.minValue)]);
                    subGroup.get('minValue').setValue(properties.minValue);
                    if (properties.enabled) {
                        valueCtrl.enable(options);
                        subTypeControl.enable(options);
                    } else {
                        valueCtrl.disable(options);
                        valueCtrl.setValue(0);
                        subTypeControl.disable(options);
                    }
                } else {
                    valueCtrl.setValidators([forms_1.Validators.required, forms_1.Validators.min(1), forms_1.Validators.max(properties.maxValue)]);
                    subGroup.get('maxValue').setValue(properties.maxValue);
                }
                subGroup.updateValueAndValidity({ onlySelf: false, emitEvent: false });
            });
        }
    }, {
        key: "paymentSchedule",
        set: function set(paymentSchedule) {
            if (paymentSchedule) {
                this.newForm();
                this.setInitialValues(paymentSchedule);
                this.editedPaymentSchedule = paymentSchedule;
            }
        }
    }, {
        key: "payments",
        get: function get() {
            if (this.paymentScheduleForm) {
                return this.paymentScheduleForm.get('payments');
            }
            return null;
        }
    }]);

    return PaymentSchedulesModalComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", String)], PaymentSchedulesModalComponent.prototype, "title", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object), __metadata("design:paramtypes", [Object])], PaymentSchedulesModalComponent.prototype, "paymentSchedule", null);
__decorate([core_1.Output(), __metadata("design:type", Object)], PaymentSchedulesModalComponent.prototype, "saved", void 0);
__decorate([core_1.Output(), __metadata("design:type", Object)], PaymentSchedulesModalComponent.prototype, "error", void 0);
PaymentSchedulesModalComponent = __decorate([core_1.Component({
    selector: 'payment-schedules-modal',
    template: __webpack_require__("./web/modern/components/settings/payment-schedules/modals/payment-schedules-modal/payment-schedules-modal.html"),
    styles: [__webpack_require__("./web/modern/components/settings/payment-schedules/modals/payment-schedules-modal/payment-schedules-modal.scss")]
}), __metadata("design:paramtypes", [payments_schedules_data_service_1.PaymentSchedulesDataProvider, message_service_1.MessageService])], PaymentSchedulesModalComponent);
exports.PaymentSchedulesModalComponent = PaymentSchedulesModalComponent;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/toastr/toastr.js")))

/***/ }),

/***/ "./web/modern/components/settings/profile/account-details/account-details.html":
/***/ (function(module, exports) {

module.exports = "<p>Update your profile information.</p>\n\n<form (ngSubmit)=\"changeName($event)\" class=\"form\">\n\n  <div class=\"input-field-group\">\n    <label for=\"firstName\">First Name</label>\n    <input class=\"form-control\" id=\"firstName\" name=\"firstName\" autocomplete=\"off\" maxlength=\"85\"\n           placeholder=\"First name\" [(ngModel)]=\"user.firstName\" required/>\n  </div>\n  <div class=\"input-field-group\">\n    <label for=\"lastName\">Last Name</label>\n    <input class=\"form-control\" id=\"lastName\" name=\"lastName\" maxlength=\"85\" autocomplete=\"off\"\n           placeholder=\"Last name\" [(ngModel)]=\"user.lastName\"/>\n  </div>\n\n\n  <button [disabled]=\"disableButton\" class=\"btn btn-success btn-submit\" spinning-wheel [is-spinning-wheel-active]=\"disableButton\">Save name</button>\n</form>"

/***/ }),

/***/ "./web/modern/components/settings/profile/account-details/account-details.scss":
/***/ (function(module, exports) {

module.exports = ""

/***/ }),

/***/ "./web/modern/components/settings/profile/account-details/account-details.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var profile_update_data_service_1 = __webpack_require__("./web/modern/services/profile/profile-update.data.service.ts");
var account_service_1 = __webpack_require__("./web/modern/services/user/account.service.ts");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var profile_update_service_1 = __webpack_require__("./web/modern/services/profile/profile-update.service.ts");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var AccountDetailsComponent = function () {
    function AccountDetailsComponent(profileUpdateService, profileService, accountService, messageService) {
        _classCallCheck(this, AccountDetailsComponent);

        this.profileUpdateService = profileUpdateService;
        this.profileService = profileService;
        this.accountService = accountService;
        this.messageService = messageService;
        this.onUserDataChange = new core_1.EventEmitter();
        this.unsubscribe = new Subject_1.Subject();
    }

    _createClass(AccountDetailsComponent, [{
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "changeName",
        value: function changeName() {
            var _this = this;

            if (this.profileService.validateName(this.user.firstName)) {
                this.disableButton = true;
                this.profileUpdateService.changeUserName(this.user).pipe(operators_1.takeUntil(this.unsubscribe), operators_1.switchMap(function () {
                    return _this.accountService.getUserWeb();
                }), operators_1.finalize(function () {
                    return _this.disableButton = false;
                })).subscribe(function (user) {
                    return _this.successUserDataChange();
                }, function () {
                    return _this.messageService.showToaster('e_0', 'general');
                });
            } else {
                this.messageService.showToaster('e_0', 'companyUsers');
            }
        }
    }, {
        key: "successUserDataChange",
        value: function successUserDataChange() {
            this.onUserDataChange.emit();
            this.messageService.showToaster('s_1', 'profile');
        }
    }]);

    return AccountDetailsComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], AccountDetailsComponent.prototype, "user", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], AccountDetailsComponent.prototype, "onUserDataChange", void 0);
AccountDetailsComponent = __decorate([core_1.Component({
    selector: 'account-details',
    template: __webpack_require__("./web/modern/components/settings/profile/account-details/account-details.html"),
    styles: [__webpack_require__("./web/modern/components/settings/profile/account-details/account-details.scss")]
}), __metadata("design:paramtypes", [profile_update_data_service_1.ProfileUpdateDataServiceProvider, profile_update_service_1.ProfileUpdateServiceProvider, account_service_1.AccountServiceWebProvider, message_service_1.MessageService])], AccountDetailsComponent);
exports.AccountDetailsComponent = AccountDetailsComponent;

/***/ }),

/***/ "./web/modern/components/settings/profile/login-change/login-change.html":
/***/ (function(module, exports) {

module.exports = "<h3>Change login email</h3>\n\n<form (ngSubmit)=\"changeEmail()\" class=\"form\">\n\n  <div class=\"input-field-group\">\n    <label for=\"userEmail\">Login email</label>\n    <input type=\"email\" class=\"form-control\" id=\"userEmail\" name=\"userEmail\"\n           placeholder=\"Login email\"\n           [(ngModel)]=\"user.email\" required/>\n  </div>\n\n  <button [disabled]=\"disableButton\" class=\"btn btn-success btn-submit\"\n          spinning-wheel [is-spinning-wheel-active]=\"disableButton\">\n    Save email\n  </button>\n\n</form>"

/***/ }),

/***/ "./web/modern/components/settings/profile/login-change/login-change.scss":
/***/ (function(module, exports) {

module.exports = ""

/***/ }),

/***/ "./web/modern/components/settings/profile/login-change/login-change.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var profile_update_data_service_1 = __webpack_require__("./web/modern/services/profile/profile-update.data.service.ts");
var profile_update_service_1 = __webpack_require__("./web/modern/services/profile/profile-update.service.ts");
var account_service_1 = __webpack_require__("./web/modern/services/user/account.service.ts");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var LoginChangeComponent = function () {
    function LoginChangeComponent(messageService, profileUpdateService, profileService, accountService) {
        _classCallCheck(this, LoginChangeComponent);

        this.messageService = messageService;
        this.profileUpdateService = profileUpdateService;
        this.profileService = profileService;
        this.accountService = accountService;
        this.onUserMailChange = new core_1.EventEmitter();
        this.unsubscribe = new Subject_1.Subject();
    }

    _createClass(LoginChangeComponent, [{
        key: "changeEmail",
        value: function changeEmail() {
            var _this = this;

            if (this.profileService.isValidEmail(this.user.email, this.initialEmail)) {
                this.disableButton = true;
                this.profileUpdateService.changeUserEmail(this.user.email).pipe(operators_1.takeUntil(this.unsubscribe), operators_1.switchMap(function () {
                    return _this.accountService.getUserWeb();
                }), operators_1.finalize(function () {
                    return _this.disableButton = false;
                })).subscribe(function (data) {
                    return _this.successChangeUserEmail(data);
                }, function (error) {
                    return _this.messageService.showErrorFromBackend('Sorry!', error.data.errorMessage);
                });
            }
        }
    }, {
        key: "successChangeUserEmail",
        value: function successChangeUserEmail(data) {
            this.onUserMailChange.emit();
            this.messageService.showToaster('s_2', 'profile');
        }
    }]);

    return LoginChangeComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], LoginChangeComponent.prototype, "user", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], LoginChangeComponent.prototype, "initialEmail", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], LoginChangeComponent.prototype, "onUserMailChange", void 0);
LoginChangeComponent = __decorate([core_1.Component({
    selector: 'login-change',
    template: __webpack_require__("./web/modern/components/settings/profile/login-change/login-change.html"),
    styles: [__webpack_require__("./web/modern/components/settings/profile/login-change/login-change.scss")]
}), __metadata("design:paramtypes", [message_service_1.MessageService, profile_update_data_service_1.ProfileUpdateDataServiceProvider, profile_update_service_1.ProfileUpdateServiceProvider, account_service_1.AccountServiceWebProvider])], LoginChangeComponent);
exports.LoginChangeComponent = LoginChangeComponent;

/***/ }),

/***/ "./web/modern/components/settings/profile/password-change/password-change.html":
/***/ (function(module, exports) {

module.exports = "<h3>Enter new password</h3>\n\n<form (ngSubmit)=\"changePassword(password, passwordConfirm)\">\n  <div class=\"input-field-group\">\n    <label for=\"password\">New password</label>\n    <input type=\"password\" class=\"form-control\" id=\"password\" name=\"password\"\n           placeholder=\"Password\" [(ngModel)]=\"password\" required/>\n  </div>\n  <div class=\"input-field-group\">\n    <label for=\"password_confirm\">Confirm password</label>\n    <input type=\"password\" class=\"form-control\" id=\"password_confirm\"\n           name=\"password_confirm\" placeholder=\"Confirm password\" required\n           [(ngModel)]=\"passwordConfirm\"/>\n  </div>\n\n  <button [disabled]=\"disableButton\" class=\"btn btn-success btn-submit\"\n          spinning-wheel [is-spinning-wheel-active]=\"disableButton\">\n    Save new password\n  </button>\n</form>"

/***/ }),

/***/ "./web/modern/components/settings/profile/password-change/password-change.scss":
/***/ (function(module, exports) {

module.exports = ""

/***/ }),

/***/ "./web/modern/components/settings/profile/password-change/password-change.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var profile_update_data_service_1 = __webpack_require__("./web/modern/services/profile/profile-update.data.service.ts");
var profile_update_service_1 = __webpack_require__("./web/modern/services/profile/profile-update.service.ts");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var PasswordChangeComponent = function () {
    function PasswordChangeComponent(messageService, profileUpdateService, profileService) {
        _classCallCheck(this, PasswordChangeComponent);

        this.messageService = messageService;
        this.profileUpdateService = profileUpdateService;
        this.profileService = profileService;
        this.onPasswordChange = new core_1.EventEmitter();
        this.unsubscribe = new Subject_1.Subject();
    }

    _createClass(PasswordChangeComponent, [{
        key: "changePassword",
        value: function changePassword() {
            var _this = this;

            if (this.profileService.isValidPassword(this.password, this.passwordConfirm)) {
                this.disableButton = true;
                this.profileUpdateService.changeUserPassword(this.password, this.passwordConfirm).pipe(operators_1.takeUntil(this.unsubscribe), operators_1.finalize(function () {
                    return _this.disableButton = false;
                })).subscribe(function (data) {
                    return _this.successChangeUserPassword(data);
                }, function () {
                    return _this.messageService.showToaster('e_0', 'general');
                });
            }
        }
    }, {
        key: "successChangeUserPassword",
        value: function successChangeUserPassword(data) {
            if (data) {
                this.password = '';
                this.passwordConfirm = '';
                this.onPasswordChange.emit();
                this.messageService.showToaster('s_0', 'profile');
            }
        }
    }]);

    return PasswordChangeComponent;
}();
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], PasswordChangeComponent.prototype, "onPasswordChange", void 0);
PasswordChangeComponent = __decorate([core_1.Component({
    selector: 'password-change',
    template: __webpack_require__("./web/modern/components/settings/profile/password-change/password-change.html"),
    styles: [__webpack_require__("./web/modern/components/settings/profile/password-change/password-change.scss")]
}), __metadata("design:paramtypes", [message_service_1.MessageService, profile_update_data_service_1.ProfileUpdateDataServiceProvider, profile_update_service_1.ProfileUpdateServiceProvider])], PasswordChangeComponent);
exports.PasswordChangeComponent = PasswordChangeComponent;

/***/ }),

/***/ "./web/modern/components/settings/profile/profile.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"bc-wrap flex-box flex-just-space\">\n  <setting-section-header [breadcrumbs]=\"breadcrumbs\"></setting-section-header>\n</div>\n\n<div class=\"box\">\n  <h3>Account Details</h3>\n  <account-details [user]=\"editedUser\"></account-details>\n  <hr>\n  <login-change [user]=\"editedUser\" [initialEmail]=\"user.email\"></login-change>\n  <password-change></password-change>\n  <hr>\n  <ng-container *ngIf=\"twoFactorData\">\n    <two-fa-settings [twoFactorSettings]=\"twoFactorData\" (updateUserProfile)=\"loadProfile($event)\"></two-fa-settings>\n    <hr #twoFa>\n  </ng-container>\n</div>\n\n<div>\n  <h3>Subscription</h3>\n  <subscription-change [user]=\"user\"></subscription-change>\n</div>\n\n"

/***/ }),

/***/ "./web/modern/components/settings/profile/profile.scss":
/***/ (function(module, exports) {

module.exports = ""

/***/ }),

/***/ "./web/modern/components/settings/profile/profile.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var common_1 = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
var account_service_1 = __webpack_require__("./web/modern/services/user/account.service.ts");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var two_fa_authentication_data_service_1 = __webpack_require__("./shared/services/user/two-fa-authentication.data.service.ts");
var ProfileComponent = function () {
    function ProfileComponent(accountService, twoFaAuthenticationService, messageService, location) {
        _classCallCheck(this, ProfileComponent);

        this.accountService = accountService;
        this.twoFaAuthenticationService = twoFaAuthenticationService;
        this.messageService = messageService;
        this.location = location;
        this.breadcrumbs = [{ link: '/', title: 'Dashboard' }, { link: '/settings', title: 'Settings' }, { link: null, title: 'Account & Subscription' }];
        this.unsubscribe = new Subject_1.Subject();
    }

    _createClass(ProfileComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.getUser();
            this.getTwoFaData();
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "loadProfile",
        value: function loadProfile(state) {
            if (state) {
                this.getTwoFaData();
            }
        }
    }, {
        key: "getUser",
        value: function getUser() {
            var _this = this;

            this.accountService.userDataObservable.pipe(operators_1.takeUntil(this.unsubscribe), operators_1.filter(function (user) {
                return user !== null && typeof user !== 'undefined';
            })).subscribe(function (user) {
                _this.user = JSON.parse(JSON.stringify(user));
                _this.editedUser = JSON.parse(JSON.stringify(user));
            });
        }
    }, {
        key: "getTwoFaData",
        value: function getTwoFaData() {
            var _this2 = this;

            this.twoFaAuthenticationService.get2FaMetadataForSetup().pipe(operators_1.takeUntil(this.unsubscribe), operators_1.filter(function (data) {
                return !!data.data;
            })).subscribe(function (data) {
                _this2.twoFactorData = data.data;
                _this2.scrollIntoView('twoFaRef', 'redirectTo=2FA');
            }, function (_ref) {
                var error = _ref.error;
                var errorMessage = error.errorMessage,
                    errorTitle = error.errorTitle;

                _this2.messageService.showErrorFromBackend(errorTitle, errorMessage);
            });
        }
    }, {
        key: "scrollIntoView",
        value: function scrollIntoView(scrollDest, checkPath) {
            var _this3 = this;

            if (this.location.path().includes(checkPath)) {
                requestAnimationFrame(function () {
                    _this3[scrollDest].nativeElement.scrollIntoView();
                });
            }
        }
    }]);

    return ProfileComponent;
}();
__decorate([core_1.ViewChild('twoFa'), __metadata("design:type", core_1.ElementRef)], ProfileComponent.prototype, "twoFaRef", void 0);
ProfileComponent = __decorate([core_1.Component({
    selector: 'profile',
    template: __webpack_require__("./web/modern/components/settings/profile/profile.html"),
    styles: [__webpack_require__("./web/modern/components/settings/profile/profile.scss")]
}), __metadata("design:paramtypes", [account_service_1.AccountServiceWebProvider, two_fa_authentication_data_service_1.TwoFaAuthenticationDataService, message_service_1.MessageService, common_1.Location])], ProfileComponent);
exports.ProfileComponent = ProfileComponent;

/***/ }),

/***/ "./web/modern/components/settings/profile/subscription-change/modals/cancel-subscription-confirm/cancel-subscription-confirm-modal.html":
/***/ (function(module, exports) {

module.exports = "<form *ngIf=\"data\" (ngSubmit)=\"cancelSubscription()\">\n    <div class=\"modal-header\">\n        <button class=\"close\" type=\"button\" [disabled]=\"btnDisable\" data-dismiss=\"modal\" aria-hidden=\"true\" (click)=\"dismiss()\">&times;</button>\n        <h3 class=\"modal-title f-w-n\">Cancel My Subscription</h3>\n    </div>\n\n    <div class=\"modal-body\">\n        <div [innerHTML]=\"data.introductionHtml | safeHtml\"></div>\n\n        <p>Describe the reason you’re leaving and suggest how we can improve:</p>\n\n        <textarea required minlength=\"20\" [(ngModel)]=\"feedback\" name=\"reason_leaving\" rows=\"4\" class=\"leaving-input\"></textarea>\n\n    </div>\n\n    <div class=\"modal-footer\">\n        <button class=\"btn btn-danger btn-submit pull-left\"\n                type=\"submit\"\n                [disabled]=\"btnDisable\"\n                [is-spinning-wheel-active]=\"btnDisable\" spinning-wheel>\n            Cancel My Subscription\n        </button>\n    </div>\n</form>\n"

/***/ }),

/***/ "./web/modern/components/settings/profile/subscription-change/modals/cancel-subscription-confirm/cancel-subscription-confirm-modal.scss":
/***/ (function(module, exports) {

module.exports = ".leaving-input {\n  outline: none;\n  resize: none;\n  width: 100%;\n  min-height: 100px; }\n\n.modal-body {\n  padding-top: 20px !important; }\n  .modal-body p {\n    font-size: 14px; }\n"

/***/ }),

/***/ "./web/modern/components/settings/profile/subscription-change/modals/cancel-subscription-confirm/cancel-subscription-confirm-modal.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var ng_bootstrap_1 = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/index.js");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var subscription_service_1 = __webpack_require__("./shared/services/subscription/subscription.service.ts");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var CancelSubscriptionConfirmModalComponent = function () {
    function CancelSubscriptionConfirmModalComponent(activeModal, modalService, messageService, subscriptionService) {
        _classCallCheck(this, CancelSubscriptionConfirmModalComponent);

        this.activeModal = activeModal;
        this.modalService = modalService;
        this.messageService = messageService;
        this.subscriptionService = subscriptionService;
        this.unsubscribe = new Subject_1.Subject();
    }

    _createClass(CancelSubscriptionConfirmModalComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.getUnsubscribeMetadata();
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "cancelSubscription",
        value: function cancelSubscription() {
            if (!this.feedbackValid()) {
                return;
            }
            this.btnDisable = true;
            this.modalService.setModalData(this.feedback);
        }
    }, {
        key: "dismiss",
        value: function dismiss() {
            this.activeModal.dismiss();
        }
    }, {
        key: "feedbackValid",
        value: function feedbackValid() {
            var limitValue = 20;
            if (!this.feedback) {
                this.messageService.showToaster('e_3', 'unsubscribe', limitValue.toString());
                return false;
            }
            if (this.feedback) {
                if (!this.feedback.trim()) {
                    this.messageService.showToaster('e_3', 'unsubscribe', limitValue.toString());
                    return false;
                }
                if (this.feedback.length < limitValue) {
                    this.messageService.showToaster('e_3', 'unsubscribe', limitValue.toString());
                    return false;
                }
            }
            return true;
        }
    }, {
        key: "getUnsubscribeMetadata",
        value: function getUnsubscribeMetadata() {
            var _this = this;

            this.subscriptionService.getUnsubscribeTemplateDescription().pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (_ref) {
                var data = _ref.data;
                return _this.data = data;
            }, this.messageService.handleError);
        }
    }]);

    return CancelSubscriptionConfirmModalComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Boolean)], CancelSubscriptionConfirmModalComponent.prototype, "btnDisable", void 0);
CancelSubscriptionConfirmModalComponent = __decorate([core_1.Component({
    selector: 'cancel-subscription-confirm-modal',
    template: __webpack_require__("./web/modern/components/settings/profile/subscription-change/modals/cancel-subscription-confirm/cancel-subscription-confirm-modal.html"),
    styles: [__webpack_require__("./web/modern/components/settings/profile/subscription-change/modals/cancel-subscription-confirm/cancel-subscription-confirm-modal.scss")]
}), __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal, snModal_service_1.SNModalService, message_service_1.MessageService, subscription_service_1.NewSubscriptionServiceDataProvider])], CancelSubscriptionConfirmModalComponent);
exports.CancelSubscriptionConfirmModalComponent = CancelSubscriptionConfirmModalComponent;

/***/ }),

/***/ "./web/modern/components/settings/profile/subscription-change/subscription-change.html":
/***/ (function(module, exports) {

module.exports = "<ng-container *ngIf=\"subscription && subscription.currentPlan\">\n  <p>Change or update your subscription plan.</p>\n\n  <div class=\"flex-column subscription-container\">\n    <div class=\"subscription\">\n\n      <div class=\"subscription--plan\">\n          <table class=\"subscription--plan__table\">\n              <tr *ngFor=\"let item of currentPlan\" class=\"t-row\">\n                <td class=\"t-cell-title\">{{ item }}</td>\n                <td class=\"t-cell-info\">{{ subscription.currentPlan.properties[item].description }}\n                    <div *ngIf=\"subscription.currentPlan.properties[item].prompt\" class=\"t-cell-info-label\">\n                        <i aria-hidden=\"true\" class=\"fa fa-info-circle\"></i>\n                        <span class=\"label label-general label-status label-response label-warning--triangle label-hover\">{{ subscription.currentPlan.properties[item].prompt }}</span>\n                    </div>\n                </td>\n              </tr>\n\n              <ng-container *ngIf=\"newPlan && newPlan.length\">\n\n                  <tr class=\"t-row-empty\"><td colspan=\"2\"></td></tr>\n                  <tr class=\"t-row-line\"><td colspan=\"2\"></tr>\n                  <tr class=\"t-row-empty\"><td colspan=\"2\"></td></tr>\n\n                  <tr *ngFor=\"let item of newPlan\" class=\"t-row\">\n                      <td class=\"t-cell-title\">{{ item }}</td>\n                      <td class=\"t-cell-info\">{{ subscription.newPlan.properties[item].description }}\n                          <div *ngIf=\"subscription.newPlan.properties[item].prompt\" class=\"t-cell-info-label\">\n                              <i aria-hidden=\"true\" class=\"fa fa-info-circle\">  <span class=\"label label-general label-status label-response label-warning--triangle label-hover\">{{ subscription.newPlan.properties[item].prompt }}</span></i>\n\n                          </div>\n                      </td>\n                  </tr>\n              </ng-container>\n          </table>\n      </div>\n\n      <div class=\"subscription--actions mt-15\">\n        <button class=\"btn btn-sm btn-success btn-rounded\" *ngIf=\"actions?.CHOOSE_PLAN\" (click)=\"showPlanChooseModal()\">\n          {{ actions?.CHOOSE_PLAN?.actionName }}\n        </button>\n\n        <ng-container *ngFor=\"let action of actionList\">\n          <button (click)=\"loadIframeModal(actions[action].url)\"\n                  *ngIf=\"actions[action].method === 'FRAME'\"\n                  [is-spinning-wheel-active]=\"disableButton\" [is-spinning-wheel-dark]=\"'true'\" class=\"btn btn-sm btn-default btn-rounded ml-8\"\n                  spinning-wheel> {{ actions[action].actionName }}\n          </button>\n        </ng-container>\n\n      </div>\n\n    </div>\n    <div class=\"subscription-cancel\">\n      <div *ngIf=\"priceComment\" class=\"subscription-cancel--info mt-10\">{{ priceComment }}\n      </div>\n      <div *ngIf=\"actions?.CANCEL_SUBSCRIPTION\" class=\"cancel inline-block mt-10\"\n           (click)=\"showCancelSubscriptionModal()\">{{ actions?.CANCEL_SUBSCRIPTION?.actionName }}\n      </div>\n    </div>\n\n  </div>\n</ng-container>\n"

/***/ }),

/***/ "./web/modern/components/settings/profile/subscription-change/subscription-change.scss":
/***/ (function(module, exports) {

module.exports = ""

/***/ }),

/***/ "./web/modern/components/settings/profile/subscription-change/subscription-change.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var subscription_service_1 = __webpack_require__("./shared/services/subscription/subscription.service.ts");
var subscription_model_1 = __webpack_require__("./shared/models/subscription.model.ts");
var iframe_service_1 = __webpack_require__("./shared/services/helpers/iframe-service/iframe.service.ts");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var cancel_subscription_confirm_modal_1 = __webpack_require__("./web/modern/components/settings/profile/subscription-change/modals/cancel-subscription-confirm/cancel-subscription-confirm-modal.ts");
var SubscriptionChangeComponent = function () {
    function SubscriptionChangeComponent(messageService, subscriptionService, iframeService, snModalService, renderer) {
        _classCallCheck(this, SubscriptionChangeComponent);

        this.messageService = messageService;
        this.subscriptionService = subscriptionService;
        this.iframeService = iframeService;
        this.snModalService = snModalService;
        this.renderer = renderer;
        this.currentPlan = [];
        this.newPlan = [];
        this.actionList = [];
        this.unsubscribe = new Subject_1.Subject();
    }

    _createClass(SubscriptionChangeComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.getSubscriptionStatus();
            this.attachIframeEvents();
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
            this.unsubscribeIframeEvents();
        }
    }, {
        key: "showCancelSubscriptionModal",
        value: function showCancelSubscriptionModal() {
            var _this = this;

            this.cancelSubscriptionModalRef = this.snModalService.openModal(cancel_subscription_confirm_modal_1.CancelSubscriptionConfirmModalComponent);
            this.snModalService.getModalData().pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (feedback) {
                return _this.cancelSubscription(feedback);
            });
        }
    }, {
        key: "showPlanChooseModal",
        value: function showPlanChooseModal() {
            this.subscriptionService.setChoosePlanOpenModalStatus({
                state: true,
                payload: null
            });
        }
    }, {
        key: "loadIframeModal",
        value: function loadIframeModal(url) {
            this.disableButton = true;
            this.iframeService.setUrlIframe(url);
        }
    }, {
        key: "cancelSubscription",
        value: function cancelSubscription(feedback) {
            this.sendFeedback(feedback);
            this.cancelUserSubscription();
        }
    }, {
        key: "attachIframeEvents",
        value: function attachIframeEvents() {
            this.onEditBillingModalIframeOpen();
            this.onConfirmPaymentOpen();
            this.onCheckoutOpenEvent();
            this.onUpdatePaymentClose();
        }
    }, {
        key: "sendFeedback",
        value: function sendFeedback(feedback) {
            if (!feedback) {
                feedback = "User with email - " + this.user.email + " unsubscribed without feedback.";
            }
            this.subscriptionService.sendFeedback(feedback).pipe(operators_1.takeUntil(this.unsubscribe)).subscribe();
        }
    }, {
        key: "cancelUserSubscription",
        value: function cancelUserSubscription() {
            var _this2 = this;

            this.subscriptionService.cancelSubscription().pipe(operators_1.takeUntil(this.unsubscribe), operators_1.map(function (data) {
                return data.data;
            }), operators_1.finalize(function () {
                _this2.cancelSubscriptionModalRef.componentInstance.btnDisable = false;
                _this2.cancelSubscriptionModalRef.dismiss();
            })).subscribe(function (data) {
                return _this2.successCancelSubscription(data);
            }, function (err) {
                return _this2.errorCancelSubscription(err);
            });
        }
    }, {
        key: "errorCancelSubscription",
        value: function errorCancelSubscription(error) {
            this.messageService.showDefaultErrorMessage(error);
        }
    }, {
        key: "successCancelSubscription",
        value: function successCancelSubscription(data) {
            this.subscriptionService.setSubscriptionData(data);
        }
    }, {
        key: "getSubscriptionStatus",
        value: function getSubscriptionStatus() {
            var _this3 = this;

            this.subscriptionService.subscriptionData.pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (data) {
                return _this3.successGetSubscriptionStatus(data);
            }, function (err) {
                return _this3.errorGetSubscriptionStatus(err);
            });
        }
    }, {
        key: "successGetSubscriptionStatus",
        value: function successGetSubscriptionStatus(data) {
            if (data && data.currentPlan && data.actions) {
                this.subscription = JSON.parse(JSON.stringify(data));
                this.currentPlan = Object.keys(this.subscription.currentPlan.properties);
                this.actions = this.subscription.actions;
                this.actionList = this.subscriptionService.createActionList(this.actions);
                if (this.subscription.priceComment) {
                    this.priceComment = this.subscription.priceComment;
                }
                if (this.subscription.newPlan) {
                    this.newPlan = Object.keys(this.subscription.newPlan.properties);
                } else {
                    this.newPlan = [];
                }
            }
        }
    }, {
        key: "errorGetSubscriptionStatus",
        value: function errorGetSubscriptionStatus(err) {
            this.messageService.showDefaultErrorMessage(err);
        }
    }, {
        key: "unsubscribeIframeEvents",
        value: function unsubscribeIframeEvents() {
            this.iframeOpenEvent();
            this.confirmPaymentOpenEvent();
            this.updateOpenEvent();
            this.checkoutPlanOpenEvent();
        }
    }, {
        key: "onEditBillingModalIframeOpen",
        value: function onEditBillingModalIframeOpen() {
            var _this4 = this;

            this.iframeOpenEvent = this.renderer.listen('document', subscription_model_1.CommunicationEvents.billingUpdateOpen, function () {
                _this4.disableButton = false;
            });
        }
    }, {
        key: "onConfirmPaymentOpen",
        value: function onConfirmPaymentOpen() {
            var _this5 = this;

            this.confirmPaymentOpenEvent = this.renderer.listen('document', subscription_model_1.CommunicationEvents.confirmPaymentOpen, function () {
                _this5.disableButton = false;
            });
        }
    }, {
        key: "onCheckoutOpenEvent",
        value: function onCheckoutOpenEvent() {
            var _this6 = this;

            this.checkoutPlanOpenEvent = this.renderer.listen('document', subscription_model_1.CommunicationEvents.planCheckoutOpen, function () {
                _this6.disableButton = false;
            });
        }
    }, {
        key: "onUpdatePaymentClose",
        value: function onUpdatePaymentClose() {
            var _this7 = this;

            this.updateOpenEvent = this.renderer.listen('document', subscription_model_1.CommunicationEvents.updatePaymentOpen, function () {
                _this7.disableButton = false;
            });
        }
    }]);

    return SubscriptionChangeComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], SubscriptionChangeComponent.prototype, "user", void 0);
SubscriptionChangeComponent = __decorate([core_1.Component({
    selector: 'subscription-change',
    template: __webpack_require__("./web/modern/components/settings/profile/subscription-change/subscription-change.html"),
    styles: [__webpack_require__("./web/modern/components/settings/profile/subscription-change/subscription-change.scss")]
}), __metadata("design:paramtypes", [message_service_1.MessageService, subscription_service_1.NewSubscriptionServiceDataProvider, iframe_service_1.IframeService, snModal_service_1.SNModalService, core_1.Renderer2])], SubscriptionChangeComponent);
exports.SubscriptionChangeComponent = SubscriptionChangeComponent;

/***/ }),

/***/ "./web/modern/components/settings/profile/two-fa-settings/two-fa-settings.html":
/***/ (function(module, exports) {

module.exports = "<h3>Two-Factor Authentication</h3>\n\n<div class=\"toggle-block\" *ngIf=\"twoFactorSettings?.user2faState\">\n    <p>Enable two-factor authentication using authenticator apps</p>\n    <div>\n        <sn-toggle [id]=\"'2fa-enable'\"\n                   [enabled]=\"enableToggle\"\n                   [disabled]=\"requestProcessed || (forceAllToggle && enableToggle)\"\n                   (toggleChanged)=\"enableToggleChange($event, false)\"></sn-toggle>\n    </div>\n</div>\n\n<div class=\"toggle-block mt-15\" *ngIf=\"twoFactorSettings?.account2faSettings\">\n    <p>Enforce two-factor authentication on all Users</p>\n    <div>\n        <sn-toggle [id]=\"'2fa-force-all'\"\n                   [disabled]=\"requestProcessed\"\n                   [enabled]=\"forceAllToggle\"\n                   (toggleChanged)=\"forceAllToggleChange($event)\"></sn-toggle>\n    </div>\n</div>"

/***/ }),

/***/ "./web/modern/components/settings/profile/two-fa-settings/two-fa-settings.scss":
/***/ (function(module, exports) {

module.exports = ".toggle-block {\n  border: 1px solid #e5e5e5;\n  padding: 15px;\n  max-width: 618px;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n  -webkit-justify-content: space-between;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center; }\n  .toggle-block p {\n    margin-bottom: 0; }\n"

/***/ }),

/***/ "./web/modern/components/settings/profile/two-fa-settings/two-fa-settings.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var two_fa_authentication_data_service_1 = __webpack_require__("./shared/services/user/two-fa-authentication.data.service.ts");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var confirm_general_modal_component_1 = __webpack_require__("./web/modern/components/common/confirm-general-modal/confirm-general-modal.component.ts");
var TwoFaSettingsComponent = function () {
    function TwoFaSettingsComponent(twoFactorAuthenticationService, messageService, modalService) {
        _classCallCheck(this, TwoFaSettingsComponent);

        this.twoFactorAuthenticationService = twoFactorAuthenticationService;
        this.messageService = messageService;
        this.modalService = modalService;
        this.updateUserProfile = new core_1.EventEmitter();
        this.enableToggle = false;
        this.forceAllToggle = false;
        this.unsubscribe = new Subject_1.Subject();
    }

    _createClass(TwoFaSettingsComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.listenToTwoFaModalActions();
        }
    }, {
        key: "ngOnChanges",
        value: function ngOnChanges(changes) {
            this.requestProcessed = false;
            this.setCorrectToggleStates();
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "enableToggleChange",
        value: function enableToggleChange(state, enforce) {
            if (state) {
                this.twoFactorAuthenticationService.setTwoFaModalControlState({
                    state: true,
                    action: 'SETUP',
                    payload: {
                        enforce: enforce,
                        user2faState: this.twoFactorSettings.user2faState,
                        loginActions: false
                    }
                });
            } else {
                var _twoFactorSettings$us = this.twoFactorSettings.user2faState.actions.TURN_OFF_2FA,
                    method = _twoFactorSettings$us.method,
                    alertMessage = _twoFactorSettings$us.alertMessage;

                if (method === 'ALERT_MODAL') {
                    var title = alertMessage.title,
                        message = alertMessage.message;

                    this.openAlertModal(title, message);
                    return;
                }
                this.confirmTwoFaDisable();
            }
            this.enableToggle = state;
        }
    }, {
        key: "forceAllToggleChange",
        value: function forceAllToggleChange(state) {
            if (state) {
                this.confirmEnforceEnable();
            } else {
                this.switchOffEnforce();
            }
            this.forceAllToggle = state;
        }
    }, {
        key: "listenToTwoFaModalActions",
        value: function listenToTwoFaModalActions() {
            var _this = this;

            this.twoFactorAuthenticationService.twoFaModalControlState.pipe(operators_1.takeUntil(this.unsubscribe), operators_1.filter(function (data) {
                return data && data.state;
            })).subscribe(function (data) {
                if (data.action === 'DISMISS_SETUP') {
                    _this.enableToggle = false;
                    if (data.payload.enforce) {
                        _this.forceAllToggle = false;
                    }
                }
                if (data.action === 'SUCCESS_SETUP') {
                    _this.updateUserProfile.emit(true);
                }
            });
        }
    }, {
        key: "setCorrectToggleStates",
        value: function setCorrectToggleStates() {
            this.enableToggle = this.twoFactorSettings.user2faState ? !!this.twoFactorSettings.user2faState.actions.TURN_OFF_2FA : false;
            this.forceAllToggle = this.twoFactorSettings.account2faSettings ? !!this.twoFactorSettings.account2faSettings.actions.MAKE_2FA_OPTIONALLY : false;
        }
    }, {
        key: "switchOff2Fa",
        value: function switchOff2Fa() {
            var _this2 = this;

            var _twoFactorSettings$us2 = this.twoFactorSettings.user2faState.actions.TURN_OFF_2FA,
                url = _twoFactorSettings$us2.url,
                method = _twoFactorSettings$us2.method;

            this.requestProcessed = true;
            this.twoFactorAuthenticationService.send2FAAction(url, method).pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function () {
                _this2.messageService.showToaster('s_1', 'twoFa');
                _this2.updateUserProfile.emit(true);
            }, function (_ref) {
                var error = _ref.error;

                _this2.enableToggle = true;
                _this2.showBackendError(error);
            });
        }
    }, {
        key: "enforce2FaForAllUsers",
        value: function enforce2FaForAllUsers() {
            var _this3 = this;

            var _twoFactorSettings$ac = this.twoFactorSettings.account2faSettings.actions.MAKE_2FA_MANDATORY,
                url = _twoFactorSettings$ac.url,
                method = _twoFactorSettings$ac.method,
                alertMessage = _twoFactorSettings$ac.alertMessage;

            if (method === 'ALERT_MODAL') {
                var title = alertMessage.title,
                    message = alertMessage.message;

                this.openAlertModal(title, message);
                this.forceAllToggle = false;
                return;
            }
            this.requestProcessed = true;
            this.twoFactorAuthenticationService.send2FAAction(url, method).pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function () {
                _this3.updateUserProfile.emit(true);
                _this3.messageService.showToaster('s_2', 'twoFa');
            }, function (_ref2) {
                var error = _ref2.error;

                _this3.forceAllToggle = false;
                _this3.showBackendError(error);
            });
        }
    }, {
        key: "switchOffEnforce",
        value: function switchOffEnforce() {
            var _this4 = this;

            var _twoFactorSettings$ac2 = this.twoFactorSettings.account2faSettings.actions.MAKE_2FA_OPTIONALLY,
                url = _twoFactorSettings$ac2.url,
                method = _twoFactorSettings$ac2.method,
                alertMessage = _twoFactorSettings$ac2.alertMessage;

            if (method === 'ALERT_MODAL') {
                var title = alertMessage.title,
                    message = alertMessage.message;

                this.openAlertModal(title, message);
                this.forceAllToggle = true;
                return;
            }
            this.requestProcessed = true;
            this.twoFactorAuthenticationService.send2FAAction(url, method).pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function () {
                _this4.updateUserProfile.emit(true);
                _this4.messageService.showToaster('s_3', 'twoFa');
            }, function (_ref3) {
                var error = _ref3.error;

                _this4.forceAllToggle = true;
                _this4.showBackendError(error);
            });
        }
    }, {
        key: "showBackendError",
        value: function showBackendError(error) {
            var errorTitle = error.errorTitle,
                errorMessage = error.errorMessage;

            this.messageService.showErrorFromBackend(errorTitle, errorMessage);
        }
    }, {
        key: "confirmTwoFaDisable",
        value: function confirmTwoFaDisable() {
            var _this5 = this;

            var confirmModal = this.modalService.openModal(confirm_general_modal_component_1.ConfirmGeneralModalComponent, {
                windowClass: 'ng-bootstrap-modal modal-visible modal-narrow'
            });
            confirmModal.componentInstance.text = 'Enabling two-factor authentication is more secure. Are you sure you want to turn this off?';
            confirmModal.componentInstance.buttons = [{
                text: 'Yes, turn it off',
                color: 'danger',
                size: 'lg',
                action: 'DISABLE_2FA'
            }, {
                text: 'No, keep it on',
                color: 'success',
                size: 'lg',
                action: 'KEEP_2FA'
            }];
            confirmModal.result.then(function (action) {
                if (action === 'DISABLE_2FA') {
                    _this5.switchOff2Fa();
                }
                if (action === 'KEEP_2FA') {
                    _this5.enableToggle = true;
                }
            });
        }
    }, {
        key: "confirmEnforceEnable",
        value: function confirmEnforceEnable() {
            var _this6 = this;

            var confirmModal = this.modalService.openModal(confirm_general_modal_component_1.ConfirmGeneralModalComponent, {
                windowClass: 'ng-bootstrap-modal modal-visible modal-narrow'
            });
            confirmModal.componentInstance.text = 'This will make it compulsory for all other Users to set up their own two-factor authentication.';
            confirmModal.componentInstance.buttons = [{
                text: 'Yes, make it compulsory',
                color: 'success',
                size: 'lg',
                action: 'ENFORCE_2FA'
            }, {
                text: 'No, leave it optional',
                color: 'default',
                size: 'lg',
                action: 'LEAVE_OPTIONAL'
            }];
            confirmModal.result.then(function (action) {
                if (action === 'ENFORCE_2FA') {
                    if (_this6.twoFactorSettings.user2faState.actions.TURN_ON_2FA) {
                        _this6.enableToggleChange(true, true);
                    } else {
                        _this6.enforce2FaForAllUsers();
                    }
                }
                if (action === 'LEAVE_OPTIONAL') {
                    _this6.forceAllToggle = false;
                }
            });
        }
    }, {
        key: "openAlertModal",
        value: function openAlertModal(title, text) {
            var _this7 = this;

            var alertModal = this.modalService.openModal(confirm_general_modal_component_1.ConfirmGeneralModalComponent);
            alertModal.componentInstance.title = title;
            alertModal.componentInstance.text = text;
            alertModal.componentInstance.buttons = [{
                text: 'Got it',
                color: 'default',
                size: 'lg',
                action: 'CLOSE_ALERT'
            }];
            alertModal.result.then(function () {
                if (_this7.twoFactorSettings.account2faSettings) {
                    _this7.forceAllToggle = true;
                }
            });
        }
    }]);

    return TwoFaSettingsComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], TwoFaSettingsComponent.prototype, "twoFactorSettings", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], TwoFaSettingsComponent.prototype, "updateUserProfile", void 0);
TwoFaSettingsComponent = __decorate([core_1.Component({
    selector: 'two-fa-settings',
    template: __webpack_require__("./web/modern/components/settings/profile/two-fa-settings/two-fa-settings.html"),
    styles: [__webpack_require__("./web/modern/components/settings/profile/two-fa-settings/two-fa-settings.scss")]
}), __metadata("design:paramtypes", [two_fa_authentication_data_service_1.TwoFaAuthenticationDataService, message_service_1.MessageService, snModal_service_1.SNModalService])], TwoFaSettingsComponent);
exports.TwoFaSettingsComponent = TwoFaSettingsComponent;

/***/ }),

/***/ "./web/modern/components/settings/questionnaire-section/questionnaire-section.html":
/***/ (function(module, exports) {

module.exports = "<ng-container *ngIf=\"questionnaireTemplatesPreviews\">\n    <div class=\"bc-wrap\">\n        <div class=\"flex-box flex-just-space\">\n            <setting-section-header [breadcrumbs]=\"breadcrumbs\"></setting-section-header>\n            <div class=\"mt-20\">\n                <settings-add-btn (onBtnClick)=\"addNewTemplate()\" *ngIf=\"questionnaireTemplatesPreviews.actions?.CREATE_NEW_TEMPLATE\" [text]=\"'Add new template'\"></settings-add-btn>\n            </div>\n        </div>\n    </div>\n    <div class=\"m-30\">\n        <setting-section-description\n                [text]=\"'Create new questionnaire templates and let your clients tell you more about who they are and what they want. You can start by using or customising our pre-written templates.'\">\n        </setting-section-description>\n    </div>\n    <div>\n        <questionnaire-template-list\n                (onDelete)=\"deleteTemplate($event)\"\n                (onDuplicate)=\"duplicateTemplate($event)\"\n                (onEdit)=\"editTemplate($event)\"\n                (updatePaginationParams)=\"updatePageRequestParams($event)\"\n                [pageRequest]=\"pageRequest\"\n                [btnDisable]=\"btnDisable\"\n                [templates]=\"questionnaireTemplatesPreviews.templatePreviews\">\n        </questionnaire-template-list>\n    </div>\n</ng-container>\n\n"

/***/ }),

/***/ "./web/modern/components/settings/questionnaire-section/questionnaire-section.scss":
/***/ (function(module, exports) {

module.exports = ""

/***/ }),

/***/ "./web/modern/components/settings/questionnaire-section/questionnaire-section.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var delete_item_modal_1 = __webpack_require__("./web/modern/components/settings/common/delete-item-modal/delete-item-modal.ts");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var subscription_service_1 = __webpack_require__("./shared/services/subscription/subscription.service.ts");
var settings_data_service_1 = __webpack_require__("./web/modern/services/settings/contact-form/settings.data.service.ts");
var account_service_1 = __webpack_require__("./web/modern/services/user/account.service.ts");
var QuestionnaireSectionComponent = function () {
    function QuestionnaireSectionComponent(snModalService, settingsDataService, accountService, subscriptionService, messageService) {
        _classCallCheck(this, QuestionnaireSectionComponent);

        this.snModalService = snModalService;
        this.settingsDataService = settingsDataService;
        this.accountService = accountService;
        this.subscriptionService = subscriptionService;
        this.messageService = messageService;
        this.breadcrumbs = [{ link: '/', title: 'Dashboard' }, { link: '/settings', title: 'Settings' }, { link: null, title: 'Questionnaire Templates' }];
        this.unsubscribe = new Subject_1.Subject();
        this.REQUEST_PARAMS = {
            paging: {
                pageNumber: 0,
                pageSize: 5,
                searchToken: null
            },
            sortCriterias: [{
                fieldName: 'name',
                sortAscending: true
            }]
        };
    }

    _createClass(QuestionnaireSectionComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.getCompanyId();
            this.applyPageProductFromLocalStorage();
            this.getQuestionnaireTemplatesPreviews();
        }
    }, {
        key: "addNewTemplate",
        value: function addNewTemplate() {
            var _this = this;

            var url = this.questionnaireTemplatesPreviews.actions.CREATE_NEW_TEMPLATE.url;

            this.settingsDataService.getNewTemplateURL(url).pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (data) {
                return _this.openQuestionnaireBuilder(data.actions.OPEN_IN_EDITOR.url);
            }, function (err) {
                return _this.handleError(err);
            });
        }
    }, {
        key: "editTemplate",
        value: function editTemplate(template) {
            window.open("" + template.actions.OPEN_IN_EDITOR.url, '_self');
        }
    }, {
        key: "duplicateTemplate",
        value: function duplicateTemplate(template) {
            var _this2 = this;

            if (!this.isValidTemplate(template)) {
                return;
            }
            this.btnDisable = true;
            this.settingsDataService.duplicateQuestionnaireTemplate(template.actions.DUPLICATE_TEMPLATE.url, template.name + " copy").pipe(operators_1.takeUntil(this.unsubscribe), operators_1.finalize(function () {
                return _this2.btnDisable = false;
            })).subscribe(function (data) {
                _this2.openQuestionnaireBuilder(data.actions.OPEN_IN_EDITOR.url, 'state=duplicate');
            }, function (err) {
                return _this2.handleError(err);
            });
        }
    }, {
        key: "deleteTemplate",
        value: function deleteTemplate(template) {
            var _this3 = this;

            this.deleteModalRef = this.snModalService.openModal(delete_item_modal_1.DeleteItemModalComponent);
            this.deleteModalRef.componentInstance.btnDisabled = false;
            this.deleteModalRef.componentInstance.itemName = template.name;
            this.deleteModalRef.componentInstance.modalTitle = 'questionnaire';
            this.deleteModalRef.componentInstance.modalData = template;
            var modalData$ = this.snModalService.getModalData().subscribe(function (data) {
                _this3.deleteModalRef.componentInstance.btnDisabled = true;
                _this3.settingsDataService.deleteQuestionnaireTemplate(data.props.actions.DELETE_TEMPLATE.url).pipe(operators_1.takeUntil(_this3.unsubscribe), operators_1.finalize(function () {
                    _this3.deleteModalRef.componentInstance.btnDisabled = false;
                    _this3.deleteModalRef.close();
                    modalData$.unsubscribe();
                })).subscribe(function () {
                    _this3.pageRequest.paging.pageNumber = 0;
                    _this3.pageRequest.paging.searchToken = null;
                    _this3.getQuestionnaireTemplatesPreviews();
                    _this3.messageService.showToaster('s_0', 'questionnaires', template.name);
                });
            });
            this.deleteModalRef.result.then(function () {
                return modalData$.unsubscribe();
            }).catch(function () {
                return modalData$.unsubscribe();
            });
        }
    }, {
        key: "updatePageRequestParams",
        value: function updatePageRequestParams(data) {
            this.pageRequest = data;
            this.getQuestionnaireTemplatesPreviews();
        }
    }, {
        key: "getQuestionnaireTemplatesPreviews",
        value: function getQuestionnaireTemplatesPreviews() {
            var _this4 = this;

            this.settingsDataService.getQuestionnaireTemplatesPreviews(this.pageRequest).pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (data) {
                _this4.questionnaireTemplatesPreviews = data;
                _this4.pageRequest.paging.searchToken = data.templatePreviews.searchToken;
                _this4.setPageProductToLocalStorage(_this4.pageRequest);
            });
        }
    }, {
        key: "applyPageProductFromLocalStorage",
        value: function applyPageProductFromLocalStorage() {
            var pageRequestObject = JSON.parse(localStorage.getItem("questionnaireTemplatesRequest_" + this.companyId));
            this.pageRequest = this.REQUEST_PARAMS;
            if (pageRequestObject && pageRequestObject !== '') {
                var pageSize = pageRequestObject.pageSize,
                    fieldName = pageRequestObject.fieldName,
                    sortAscending = pageRequestObject.sortAscending;

                this.pageRequest.paging.pageSize = pageSize;
                this.pageRequest.sortCriterias[0].fieldName = fieldName;
                this.pageRequest.sortCriterias[0].sortAscending = sortAscending;
            }
        }
    }, {
        key: "openQuestionnaireBuilder",
        value: function openQuestionnaireBuilder(url, param) {
            var urlString = url;
            if (param) {
                urlString += "?" + param;
            }
            window.open("" + urlString, '_self');
        }
    }, {
        key: "setPageProductToLocalStorage",
        value: function setPageProductToLocalStorage(pageRequest) {
            var pageRequestObject = {
                pageSize: pageRequest.paging.pageSize,
                fieldName: pageRequest.sortCriterias[0].fieldName,
                sortAscending: pageRequest.sortCriterias[0].sortAscending
            };
            var pageRequestString = JSON.stringify(pageRequestObject);
            localStorage.removeItem("questionnaireTemplatesRequest_" + this.companyId);
            localStorage.setItem("questionnaireTemplatesRequest_" + this.companyId, pageRequestString);
        }
    }, {
        key: "getCompanyId",
        value: function getCompanyId() {
            var _this5 = this;

            this.accountService.companyIdObservable.pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (data) {
                return _this5.companyId = data;
            });
        }
    }, {
        key: "isValidTemplate",
        value: function isValidTemplate(template) {
            if (template.name.length > 250) {
                this.messageService.showToaster('e_1', 'questionnaires');
                return false;
            }
            return true;
        }
    }, {
        key: "handleError",
        value: function handleError(_ref) {
            var error = _ref.error;
            var errorTitle = error.errorTitle,
                errorMessage = error.errorMessage;

            this.messageService.showErrorFromBackend(errorTitle, errorMessage);
        }
    }]);

    return QuestionnaireSectionComponent;
}();
QuestionnaireSectionComponent = __decorate([core_1.Component({
    selector: 'questionnaire-section',
    template: __webpack_require__("./web/modern/components/settings/questionnaire-section/questionnaire-section.html"),
    styles: [__webpack_require__("./web/modern/components/settings/questionnaire-section/questionnaire-section.scss")]
}), __metadata("design:paramtypes", [snModal_service_1.SNModalService, settings_data_service_1.SettingsDataService, account_service_1.AccountServiceWebProvider, subscription_service_1.NewSubscriptionServiceDataProvider, message_service_1.MessageService])], QuestionnaireSectionComponent);
exports.QuestionnaireSectionComponent = QuestionnaireSectionComponent;

/***/ }),

/***/ "./web/modern/components/settings/quote-invoice-templates/qt-templates-update/qt-custom-template-control/qt-custom-template-control.component.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"row ml-0 mr-0\">\n    <div class=\"col-sm-6 pl-0\">\n        <label class=\"f-s-13 text-semi-bold\">\n            Pick & Choose Quote Template Name\n        </label>\n        <input type=\"text\" class=\"form-control\" maxlength=\"100\" #quoteName required [(ngModel)]=\"templateData.data.name\">\n        <label class=\"label-counter\">{{ quoteName.value.length }}/100</label>\n    </div>\n    <div class=\"col-sm-6 pr-0\">\n        <label class=\"f-s-13 text-semi-bold\">\n            Pick & Choose Introduction\n        </label>\n        <textarea  [(ngModel)]=\"templateData.data.introduction\"\n                   class=\"form-control-textArea form-control\" maxlength=\"1000\"\n                   placeholder=\"e.g. Thank you for considering me! Please choose from the list of packages and products and click Accept. Don’t hesitate to contact me if you have any questions.\">\n        </textarea>\n    </div>\n</section>\n\n<hr class=\"mt-30 mb-30\">\n\n<section>\n    <h2 class=\"quote-section-name\"> Add Packages</h2>\n    <p>Create a list of packages which your client can choose between. Multiple packages can be chosen.</p>\n    <div dragula=\"packages\" class=\"package-container mb-10\" [(dragulaModel)]=\"templateData.packages.items\">\n        <div *ngFor=\"let package of templateData.packages.items; let packageIndex = index\" [class.last-package-item]=\"packageIndex === templateData.packages.items.length - 1\" class=\"dnd-package mb-20\">\n            <div class=\"dnd-icon-products handle-package\"></div>\n            <quote-create-package-block\n                    [packagesLength]=\"templateData.packages.items.length\"\n                    [package]=\"package\"\n                    [productsName]=\"templateData.packages.templates\"\n                    [isFixed]=\"false\"\n                    [index]=\"packageIndex\"\n                    [currencySymbol]=\"templateData.currency.currencyDTO.symbol\"\n                    [taxPercentage]=\"templateData.currency.percentage\"\n                    (changeProduct)=\"setNewCustomTemplatePackage($event)\"\n                    (deletePackage)=\"removeCustomTemplatePackage($event)\">\n            </quote-create-package-block>\n        </div>\n    </div>\n    <button type=\"button\" (click)=\"addNewCustomTemplatePackage()\"  class=\"btn btn-info btn-add-new-sm\">Add Package</button>\n</section>\n\n<section>\n    <h2 class=\"quote-section-name\">Add Products</h2>\n    <p>Create a list of add-on products which your client can add to the selected package. Multiple products can be added.</p>\n    <div dragula=\"products\" class=\"package-container mb-10\" [(dragulaModel)]=\"templateData.products.items\">\n        <div *ngFor=\"let product of templateData.products.items; let productIndex = index\" [class.last-package-item]=\"productIndex === templateData.products.items.length - 1\" class=\"dnd-package mb-20\">\n            <div class=\"dnd-icon-products handle-package\"></div>\n            <quote-create-package-block\n                    [packagesLength]=\"templateData.products.items.length\"\n                    [product]=\"product\"\n                    [productsName]=\"templateData.products.templates\"\n                    [isFixed]=\"false\"\n                    [index]=\"productIndex\"\n                    [currencySymbol]=\"templateData.currency.currencyDTO.symbol\"\n                    [taxPercentage]=\"templateData.currency.percentage\"\n                    (changeProduct)=\"setNewCustomTemplateProduct($event)\"\n                    (deletePackage)=\"removeCustomTemplateProduct($event)\">\n            </quote-create-package-block>\n        </div>\n    </div>\n    <button type=\"button\" (click)=\"addNewCustomTemplateProduct()\" class=\"btn btn-info btn-add-new-sm\">Add Product</button>\n</section>\n\n<section>\n    <h2 class=\"quote-section-name\">Add Discount</h2>\n    <p>Add a fixed discount to this quote.</p>\n    <div dragula=\"discounts\" class=\"discount-container mb-10\" [(dragulaModel)]=\"templateData.discounts.items\">\n        <div class=\"dnd-package mb-20\" *ngFor=\"let discount of templateData.discounts.items; let discountIndex = index\">\n            <div class=\"dnd-icon-products handle-package\"></div>\n            <discount-create-block\n                    [discount]=\"discount\"\n                    [index]=\"discountIndex\"\n                    [discountsNames]=\"templateData.discounts.templates\"\n                    [currencySymbol]=\"templateData.currency.currencyDTO.symbol\"\n                    [taxPercentage]=\"templateData.currency.percentage\"\n                    (changeDiscount)=\"setNewCustomTemplateDiscount($event)\"\n                    (deleteDiscount)=\"removeCustomTemplateDiscount($event)\"\n            ></discount-create-block>\n        </div>\n    </div>\n    <button type=\"button\" (click)=\"addNewCustomTemplateDiscount()\" class=\"btn btn-info btn-add-new-sm\">Add Discount</button>\n</section>\n\n<hr class=\"mt-40 mb-25\">\n\n<section class=\"quote-notes-container\">\n    <h2 class=\"fs-20\">Notes</h2>\n    <textarea\n            [(ngModel)]=\"templateData.data.notes\"\n            class=\"form-control quote-notes\"\n            maxlength=\"5000\"\n            placeholder=\"These are additional notes you wish to add to your quote.\"></textarea>\n</section>\n\n<section class=\"mb-30\">\n    <template-apply-group-list\n            [text]=\"'Assign a payment schedule to this quote'\"\n            [selectedTemplateId]=\"templateData.paymentSchedulerTemplateId\"\n            [templateList]=\"templateData.paymentScheduleTemplates\"\n            [templateDefaultList]=\"templateData.paymentDefaultScheduleTemplates\"\n            [label]=\"'Custom'\"\n            (onTemplateChange)=\"onPaymentScheduleChange($event)\">\n        <div *ngIf=\"+templateData.paymentSchedulerTemplateId === -3\" class=\"label-template col-xs-12 col-sm-7 col-md-4\">\n            <div>No invoice will be generated once the quote is accepted.</div>\n        </div>\n    </template-apply-group-list>\n</section>\n\n<section>\n    <template-apply-list\n            [text]=\"'Do you want to add a contract?'\"\n            [selectedTemplateId]=\"templateData.contractTemplateId\"\n            [templateList]=\"templateData.contracts\"\n            [idField]=\"'templateId'\"\n            [disabled]=\"disableContractButton\"\n            (onTemplateChange)=\"setContract($event)\">\n        <button class=\"btn btn-sm btn-default\" [disabled]=\"disableContractButton || templateData.contractTemplateId === '-1'\"\n                (click)=\"emitContractEdit()\"><i class=\"fi fi-edit\"></i>Edit Contract\n        </button>\n    </template-apply-list>\n</section>\n\n<section>\n    <template-apply-list\n            [text]=\"'Do you want to add a questionnaire?'\"\n            [selectedTemplateId]=\"templateData.questionnaireTemplateId\"\n            [templateList]=\"templateData.questionnaires\"\n            (onTemplateChange)=\"setQuestionnaire($event)\">\n    </template-apply-list>\n</section>\n\n<div *ngIf=\"generateInvoiceDisabled\" class=\"flex-box flex-align-center mb-35 mt-30\">\n    <span class=\"quote-label-info-icon mr-10 label-icon-red\"></span>\n    <span class=\"quote-label-info\">This quote will not automatically generate an invoice after acceptance.</span>\n</div>\n\n<section class=\"mb-30 mt-30\" *ngIf=\"!generateInvoiceDisabled\">\n    <div class=\"flex-row\">\n        <div class=\"checkbox-squared\">\n            <input id=\"accept-quote-checkbox\"\n                   type=\"checkbox\"\n                   name=\"mandatory\"\n                   [disabled]=\"generateInvoiceDisabled\"\n                   [(ngModel)]=\"templateData.data.generateInvoiceWhenAccepted\"\n            />\n            <label for=\"accept-quote-checkbox\"></label>\n        </div>\n        <label for=\"accept-quote-checkbox\">\n            Automatically generate an invoice once the quote is accepted\n        </label>\n    </div>\n</section>\n"

/***/ }),

/***/ "./web/modern/components/settings/quote-invoice-templates/qt-templates-update/qt-custom-template-control/qt-custom-template-control.component.scss":
/***/ (function(module, exports) {

module.exports = ""

/***/ }),

/***/ "./web/modern/components/settings/quote-invoice-templates/qt-templates-update/qt-custom-template-control/qt-custom-template-control.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var quote_update_service_1 = __webpack_require__("./shared/services/quote/quote-update.service.ts");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var ng2_dragula_1 = __webpack_require__("./node_modules/ng2-dragula/index.js");
var QtCustomTemplateControlComponent = function () {
    function QtCustomTemplateControlComponent(dragulaService) {
        _classCallCheck(this, QtCustomTemplateControlComponent);

        this.dragulaService = dragulaService;
        this.emitContractChange = new core_1.EventEmitter();
        this.emitContractToEdit = new core_1.EventEmitter();
        this.emitPaymentChange = new core_1.EventEmitter();
        this.dragulaPackagesOptions = {
            moves: function moves(el, container, handle) {
                return handle.classList.contains('handle-package');
            }
        };
        this.dragulaProductsOptions = {
            moves: function moves(el, container, handle) {
                return handle.classList.contains('handle-package');
            }
        };
        this.dragulaDiscountsOptions = {
            moves: function moves(el, container, handle) {
                return handle.classList.contains('handle-package');
            }
        };
        this.unsubscribe = new Subject_1.Subject();
    }

    _createClass(QtCustomTemplateControlComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.setDragulaOptions();
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.clear();
        }
    }, {
        key: "addNewCustomTemplatePackage",
        value: function addNewCustomTemplatePackage() {
            this.templateData.packages.items.push(quote_update_service_1.QuoteUpdateService.setEmptyProduct('PACKAGE'));
        }
    }, {
        key: "setNewCustomTemplatePackage",
        value: function setNewCustomTemplatePackage(data) {
            var _this = this;

            this.templateData.packages.items.forEach(function (packageItem, index) {
                if (index === data.index) {
                    _this.templateData.packages.items[index] = JSON.parse(JSON.stringify(Object.assign({}, data.product)));
                }
            });
        }
    }, {
        key: "removeCustomTemplatePackage",
        value: function removeCustomTemplatePackage(_ref) {
            var index = _ref.index;

            this.templateData.packages.items.splice(index, 1);
        }
    }, {
        key: "addNewCustomTemplateProduct",
        value: function addNewCustomTemplateProduct() {
            this.templateData.products.items.push(quote_update_service_1.QuoteUpdateService.setEmptyProduct('ADD_ON'));
        }
    }, {
        key: "setNewCustomTemplateProduct",
        value: function setNewCustomTemplateProduct(data) {
            var _this2 = this;

            this.templateData.products.items.forEach(function (packageItem, index) {
                if (index === data.index) {
                    _this2.templateData.products.items[index] = JSON.parse(JSON.stringify(Object.assign({}, data.product)));
                }
            });
        }
    }, {
        key: "removeCustomTemplateProduct",
        value: function removeCustomTemplateProduct(_ref2) {
            var index = _ref2.index;

            this.templateData.products.items.splice(index, 1);
        }
    }, {
        key: "addNewCustomTemplateDiscount",
        value: function addNewCustomTemplateDiscount() {
            this.templateData.discounts.items.push(quote_update_service_1.QuoteUpdateService.setEmptyProduct('GIFT'));
        }
    }, {
        key: "setNewCustomTemplateDiscount",
        value: function setNewCustomTemplateDiscount(data) {
            var _this3 = this;

            this.templateData.discounts.items.forEach(function (packageItem, index) {
                if (index === data.index) {
                    _this3.templateData.discounts.items[index] = JSON.parse(JSON.stringify(Object.assign({}, data.product)));
                }
            });
        }
    }, {
        key: "removeCustomTemplateDiscount",
        value: function removeCustomTemplateDiscount(index) {
            this.templateData.discounts.items.splice(index, 1);
        }
    }, {
        key: "onPaymentScheduleChange",
        value: function onPaymentScheduleChange(templateId) {
            this.templateData.paymentSchedulerTemplateId = templateId;
            switch (templateId) {
                case '-2':
                    this.templateData.paymentsStrategy = 'NO_SPLIT_PAYMENTS';
                    break;
                case '-3':
                    this.templateData.paymentsStrategy = 'NO_DUE_DATE';
                    break;
                default:
                    this.templateData.paymentsStrategy = 'BY_PAYMENT_SCHEDULER';
                    break;
            }
            this.emitPaymentChange.emit(templateId);
        }
    }, {
        key: "setQuestionnaire",
        value: function setQuestionnaire(templateId) {
            this.templateData.questionnaireTemplateId = templateId;
        }
    }, {
        key: "setContract",
        value: function setContract(templateId) {
            this.emitContractChange.emit(templateId);
        }
    }, {
        key: "emitContractEdit",
        value: function emitContractEdit() {
            this.emitContractToEdit.emit();
        }
    }, {
        key: "setDragulaOptions",
        value: function setDragulaOptions() {
            this.dragulaService.setOptions('products', this.dragulaProductsOptions);
            this.dragulaService.setOptions('packages', this.dragulaPackagesOptions);
            this.dragulaService.setOptions('discounts', this.dragulaDiscountsOptions);
        }
    }, {
        key: "clear",
        value: function clear() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
            this.dragulaService.destroy('products');
            this.dragulaService.destroy('packages');
            this.dragulaService.destroy('discounts');
        }
    }]);

    return QtCustomTemplateControlComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], QtCustomTemplateControlComponent.prototype, "templateData", void 0);
__decorate([core_1.Input(), __metadata("design:type", Boolean)], QtCustomTemplateControlComponent.prototype, "disableContractButton", void 0);
__decorate([core_1.Input(), __metadata("design:type", Boolean)], QtCustomTemplateControlComponent.prototype, "generateInvoiceDisabled", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], QtCustomTemplateControlComponent.prototype, "emitContractChange", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], QtCustomTemplateControlComponent.prototype, "emitContractToEdit", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], QtCustomTemplateControlComponent.prototype, "emitPaymentChange", void 0);
QtCustomTemplateControlComponent = __decorate([core_1.Component({
    selector: 'qt-custom-template-control',
    template: __webpack_require__("./web/modern/components/settings/quote-invoice-templates/qt-templates-update/qt-custom-template-control/qt-custom-template-control.component.html"),
    styles: [__webpack_require__("./web/modern/components/settings/quote-invoice-templates/qt-templates-update/qt-custom-template-control/qt-custom-template-control.component.scss")]
}), __metadata("design:paramtypes", [ng2_dragula_1.DragulaService])], QtCustomTemplateControlComponent);
exports.QtCustomTemplateControlComponent = QtCustomTemplateControlComponent;

/***/ }),

/***/ "./web/modern/components/settings/quote-invoice-templates/qt-templates-update/qt-fixed-template-control/qt-fixed-template-control.component.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"row ml-0 mr-0\" *ngIf=\"type === 'QUOTE'\">\n    <div class=\"col-sm-6 pl-0\">\n        <label class=\"f-s-13 text-semi-bold\">\n            Fixed Quote Template Name\n        </label>\n        <input type=\"text\" class=\"form-control\" maxlength=\"100\" #quoteName required [(ngModel)]=\"templateData.data.name\">\n        <label class=\"label-counter\">{{ quoteName.value.length }}/100</label>\n    </div>\n    <div class=\"col-sm-6 pr-0\">\n        <label class=\"f-s-13 text-semi-bold\">\n            Fixed Quote Introduction\n        </label>\n        <textarea  class=\"form-control-textArea form-control\" maxlength=\"1000\" [(ngModel)]=\"templateData.data.introduction\"\n                   placeholder=\"e.g. Thank you for considering me! Please review the quote below and click Accept if you’re happy to proceed. Don’t hesitate to contact me if you have any questions.\">\n        </textarea>\n    </div>\n</section>\n\n<section *ngIf=\"type === 'INVOICE'\" class=\"row ml-0 mr-0\">\n    <div class=\"col-sm-6 col-xs-12 pl-0 m-b-n-sm\">\n        <label class=\"f-s-13 text-semi-bold\">\n            Invoice Template Name\n        </label>\n        <input type=\"text\" class=\"form-control\" maxlength=\"100\" #invoiceName required [(ngModel)]=\"templateData.data.name\">\n        <label class=\"label-counter\">{{ invoiceName.value.length }}/100</label>\n    </div>\n</section>\n\n<section class=\"product-container mt-40\">\n    <div class=\"row products-header\">\n        <div class=\"col-xs-2\">Product / Package</div>\n        <div class=\"col-xs-4\">Description</div>\n        <div class=\"col-xs-6 products-inputs\">\n            <div>Price</div>\n            <div>Quantity</div>\n            <div>Discount (%)</div>\n            <div class=\"products-tax\">Tax</div>\n            <div class=\"product__amount\">Amount</div></div>\n    </div>\n    <div class=\"product-body\" dragula=\"addons\" [(dragulaModel)]=\"templateData.addons.items\">\n            <div *ngFor=\"let addon of templateData.addons.items; let productIndex = index\" [class.last-package-item]=\"productIndex === templateData.addons.items.length - 1\" class=\"dnd-package mb-20\">\n                <div class=\"dnd-icon-products handle-package\"></div>\n                <quote-create-package-block\n                        [product]=\"addon\"\n                        [productsName]=\"templateData.addons.templates\"\n                        [isFixed]=\"true\"\n                        [index]=\"productIndex\"\n                        [currencySymbol]=\"templateData.currency.currencyDTO.symbol\"\n                        [taxPercentage]=\"templateData.currency.percentage\"\n                        (changeProduct)=\"setNewFixedTemplateAddon($event)\"\n                        (deletePackage)=\"removeFixedTemplateAddon($event)\"></quote-create-package-block>\n            </div>\n        </div>\n</section>\n\n<section class=\"table-responsive mb-0\">\n    <table class=\"table vertical-top-table edit-payments-table fixed-quote-summary-table\">\n        <tbody>\n            <tr>\n                <td colspan=\"6\">\n                    <button type=\"button\" class=\"btn btn-info btn-add-new-sm\" (click)=\"addNewAddon()\">\n                        Add Product / Package\n                    </button>\n                </td>\n                <td colspan=\"2\">\n                <td colspan=\"4\">\n                    <quote-amount-info [summary]=\"templateData.summary\" [currencyAndTax]=\"templateData.currency\"></quote-amount-info>\n                </td>\n            </tr>\n        </tbody>\n    </table>\n</section>\n\n<hr class=\"mt-35 mb-35\">\n\n<section>\n    <h2 class=\"quote-section-name\">Add Discount</h2>\n    <p>Add a fixed discount to this {{ templateType | lowercase }}.</p>\n    <div dragula=\"discounts\" class=\"discount-container mb-10\" [(dragulaModel)]=\"templateData.discounts.items\">\n        <div class=\"dnd-package mb-20\" *ngFor=\"let discount of templateData.discounts.items; let discountIndex = index\">\n            <div class=\"dnd-icon-products handle-package\"></div>\n            <discount-create-block\n                    [discount]=\"discount\"\n                    [index]=\"discountIndex\"\n                    [discountsNames]=\"templateData.discounts.templates\"\n                    [currencySymbol]=\"templateData.currency.currencyDTO.symbol\"\n                    [taxPercentage]=\"templateData.currency.percentage\"\n                    (changeDiscount)=\"setNewFixedTemplateDiscount($event)\"\n                    (deleteDiscount)=\"removeFixedTemplateDiscount($event)\"\n            ></discount-create-block>\n        </div>\n    </div>\n    <button type=\"button\" (click)=\"addNewFixedTemplateDiscount()\" class=\"btn btn-info btn-add-new-sm\">Add Discount</button>\n</section>\n\n<hr class=\"mt-40 mb-25\">\n\n<section class=\"quote-notes-container\">\n        <h2 class=\"fs-20\">Notes</h2>\n        <textarea [(ngModel)]=\"templateData.data.notes\"\n                  class=\"form-control quote-notes\"\n                  maxlength=\"5000\"\n                  [attr.placeholder]=\"notesPlaceholder\"></textarea>\n</section>\n\n<section class=\"mb-30\">\n    <template-apply-group-list\n            [text]=\"paymentScheduleText\"\n            [selectedTemplateId]=\"templateData.paymentSchedulerTemplateId\"\n            [templateList]=\"templateData.paymentScheduleTemplates\"\n            [templateDefaultList]=\"templateData.paymentDefaultScheduleTemplates\"\n            [label]=\"'Custom'\"\n            (onTemplateChange)=\"onPaymentScheduleChange($event)\">\n\n        <div *ngIf=\"+templateData.paymentSchedulerTemplateId === -3\" class=\"label-template col-xs-12 col-sm-7 col-md-4\">\n            <div>No invoice will be generated once the quote is accepted.</div>\n        </div>\n    </template-apply-group-list>\n\n</section>\n\n<section class=\"mb-30\">\n    <template-apply-list\n            [text]=\"'Do you want to add a contract?'\"\n            [selectedTemplateId]=\"templateData.contractTemplateId\"\n            [templateList]=\"templateData.contracts\"\n            [disabled]=\"false\"\n            [idField]=\"'templateId'\"\n            (onTemplateChange)=\"setContract($event)\">\n        <div style=\"padding-left: 15px\">\n        <button class=\"btn btn-sm btn-default\" [disabled]=\"disableContractButton || templateData.contractTemplateId === '-1'\"\n                (click)=\"emitContractEdit()\"><i class=\"fi fi-edit\"></i>Edit Contract\n        </button>\n        </div>\n    </template-apply-list>\n</section>\n\n<section [class.mb-30]=\"type === 'INVOICE'\">\n    <template-apply-list\n            [text]=\"'Do you want to add a questionnaire?'\"\n            [selectedTemplateId]=\"templateData.questionnaireTemplateId\"\n            [templateList]=\"templateData.questionnaires\"\n            (onTemplateChange)=\"setQuestionnaire($event)\">\n    </template-apply-list>\n</section>\n\n<div *ngIf=\"generateInvoiceDisabled\" class=\"flex-box flex-align-center mb-35 mt-30\">\n    <span class=\"quote-label-info-icon mr-10 label-icon-red\"></span>\n    <span class=\"quote-label-info\">This quote will not automatically generate an invoice after acceptance.</span>\n</div>\n\n<section *ngIf=\"type === 'QUOTE' && !generateInvoiceDisabled\" class=\"mb-30 mt-30\">\n    <div class=\"flex-row\">\n        <div class=\"checkbox-squared\">\n            <input id=\"accept-quote-checkbox\"\n                   type=\"checkbox\"\n                   name=\"mandatory\"\n\t\t\t\t\t\t\t\t\t [disabled]=\"generateInvoiceDisabled\"\n                   [(ngModel)]=\"templateData.data.generateInvoiceWhenAccepted\"\n            />\n            <label for=\"accept-quote-checkbox\"></label>\n        </div>\n        <label for=\"accept-quote-checkbox\">\n            Automatically generate an invoice once the quote is accepted\n        </label>\n    </div>\n</section>\n"

/***/ }),

/***/ "./web/modern/components/settings/quote-invoice-templates/qt-templates-update/qt-fixed-template-control/qt-fixed-template-control.component.scss":
/***/ (function(module, exports) {

module.exports = ".edit-payments-table > tbody > tr > td:first-child {\n  padding-left: 0 !important; }\n"

/***/ }),

/***/ "./web/modern/components/settings/quote-invoice-templates/qt-templates-update/qt-fixed-template-control/qt-fixed-template-control.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var quote_update_service_1 = __webpack_require__("./shared/services/quote/quote-update.service.ts");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var ng2_dragula_1 = __webpack_require__("./node_modules/ng2-dragula/index.js");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var quotes_data_service_1 = __webpack_require__("./shared/services/quote/quotes-data-service/quotes.data.service.ts");
var QtFixedTemplateControlComponent = function () {
    function QtFixedTemplateControlComponent(dragulaService, quoteDataService, quoteUpdateService) {
        _classCallCheck(this, QtFixedTemplateControlComponent);

        this.dragulaService = dragulaService;
        this.quoteDataService = quoteDataService;
        this.quoteUpdateService = quoteUpdateService;
        this.emitContractChange = new core_1.EventEmitter();
        this.emitContractToEdit = new core_1.EventEmitter();
        this.emitPaymentChange = new core_1.EventEmitter();
        this.dragulaAddonsOptions = {
            moves: function moves(el, container, handle) {
                return handle.classList.contains('handle-package');
            }
        };
        this.dragulaDiscountsOptions = {
            moves: function moves(el, container, handle) {
                return handle.classList.contains('handle-package');
            }
        };
        this.unsubscribe = new Subject_1.Subject();
    }

    _createClass(QtFixedTemplateControlComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.setDragulaOptions();
            this.reactToProductPropertiesChange();
            this.templateType = this.type === 'QUOTE' ? 'Quote' : 'Invoice';
            this.notesPlaceholder = "These are additional notes you wish to add to your " + this.templateType.toLowerCase() + ".";
            this.paymentScheduleText = "Assign a payment schedule to this " + this.templateType.toLowerCase();
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.clear();
        }
    }, {
        key: "addNewAddon",
        value: function addNewAddon() {
            var item = quote_update_service_1.QuoteUpdateService.setEmptyProduct('ADD_ON');
            item.mandatory = true;
            this.templateData.addons.items.push(item);
        }
    }, {
        key: "setNewFixedTemplateAddon",
        value: function setNewFixedTemplateAddon(data) {
            var _this = this;

            this.templateData.addons.items.forEach(function (packageItem, index) {
                if (index === data.index) {
                    _this.templateData.addons.items[index] = JSON.parse(JSON.stringify(Object.assign({}, data.product, {
                        mandatory: true,
                        type: 'ADD_ON'
                    })));
                }
            });
            this.updateTemplateSummary();
        }
    }, {
        key: "removeFixedTemplateAddon",
        value: function removeFixedTemplateAddon(_ref) {
            var index = _ref.index;

            this.templateData.addons.items.splice(index, 1);
            this.updateTemplateSummary();
        }
    }, {
        key: "addNewFixedTemplateDiscount",
        value: function addNewFixedTemplateDiscount() {
            this.templateData.discounts.items.push(quote_update_service_1.QuoteUpdateService.setEmptyProduct('GIFT'));
        }
    }, {
        key: "setNewFixedTemplateDiscount",
        value: function setNewFixedTemplateDiscount(data) {
            var _this2 = this;

            this.templateData.discounts.items.forEach(function (packageItem, index) {
                if (index === data.index) {
                    _this2.templateData.discounts.items[index] = JSON.parse(JSON.stringify(Object.assign({}, data.product)));
                }
            });
            this.updateTemplateSummary();
        }
    }, {
        key: "removeFixedTemplateDiscount",
        value: function removeFixedTemplateDiscount(index) {
            this.templateData.discounts.items.splice(index, 1);
            this.updateTemplateSummary();
        }
    }, {
        key: "onPaymentScheduleChange",
        value: function onPaymentScheduleChange(templateId) {
            this.templateData.paymentSchedulerTemplateId = templateId;
            switch (templateId) {
                case '-2':
                    this.templateData.paymentsStrategy = 'NO_SPLIT_PAYMENTS';
                    break;
                case '-3':
                    this.templateData.paymentsStrategy = 'NO_DUE_DATE';
                    break;
                default:
                    this.templateData.paymentsStrategy = 'BY_PAYMENT_SCHEDULER';
                    break;
            }
            this.emitPaymentChange.emit(templateId);
        }
    }, {
        key: "setQuestionnaire",
        value: function setQuestionnaire(templateId) {
            this.templateData.questionnaireTemplateId = templateId;
        }
    }, {
        key: "setContract",
        value: function setContract(templateId) {
            this.emitContractChange.emit(templateId);
        }
    }, {
        key: "emitContractEdit",
        value: function emitContractEdit() {
            this.emitContractToEdit.emit();
        }
    }, {
        key: "reactToProductPropertiesChange",
        value: function reactToProductPropertiesChange() {
            var _this3 = this;

            this.quoteUpdateService.updatedProductObservable.pipe(operators_1.takeUntil(this.unsubscribe), operators_1.filter(function (product) {
                return product !== null;
            }), operators_1.map(function () {
                return _this3.getMergedItems();
            })).subscribe(function (items) {
                if (_this3.quoteUpdateService.validateProductsPropsDefined(items)) {
                    _this3.updateTemplateSummary();
                }
            });
        }
    }, {
        key: "updateTemplateSummary",
        value: function updateTemplateSummary() {
            var _this4 = this;

            // setTimeout fixes issue on Safari when id of product changes with delay
            setTimeout(function () {
                _this4.quoteDataService.calculateProductsSummary(_this4.getMergedItems(), _this4.templateData.currency.percentage, _this4.templateData.currency.currencyDTO.symbol).pipe(operators_1.takeUntil(_this4.unsubscribe)).subscribe(function (data) {
                    return _this4.templateData.summary = JSON.parse(JSON.stringify(data));
                });
            }, 0);
        }
    }, {
        key: "getMergedItems",
        value: function getMergedItems() {
            return [].concat(_toConsumableArray(this.templateData.addons.items), _toConsumableArray(this.templateData.discounts.items));
        }
    }, {
        key: "setDragulaOptions",
        value: function setDragulaOptions() {
            this.dragulaService.setOptions('addons', this.dragulaAddonsOptions);
            this.dragulaService.setOptions('discounts', this.dragulaDiscountsOptions);
        }
    }, {
        key: "clear",
        value: function clear() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
            this.dragulaService.destroy('addons');
            this.dragulaService.destroy('discounts');
        }
    }]);

    return QtFixedTemplateControlComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], QtFixedTemplateControlComponent.prototype, "templateData", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], QtFixedTemplateControlComponent.prototype, "type", void 0);
__decorate([core_1.Input(), __metadata("design:type", Boolean)], QtFixedTemplateControlComponent.prototype, "disableContractButton", void 0);
__decorate([core_1.Input(), __metadata("design:type", Boolean)], QtFixedTemplateControlComponent.prototype, "generateInvoiceDisabled", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], QtFixedTemplateControlComponent.prototype, "emitContractChange", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], QtFixedTemplateControlComponent.prototype, "emitContractToEdit", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], QtFixedTemplateControlComponent.prototype, "emitPaymentChange", void 0);
QtFixedTemplateControlComponent = __decorate([core_1.Component({
    selector: 'qt-fixed-template-control',
    template: __webpack_require__("./web/modern/components/settings/quote-invoice-templates/qt-templates-update/qt-fixed-template-control/qt-fixed-template-control.component.html"),
    styles: [__webpack_require__("./web/modern/components/settings/quote-invoice-templates/qt-templates-update/qt-fixed-template-control/qt-fixed-template-control.component.scss")]
}), __metadata("design:paramtypes", [ng2_dragula_1.DragulaService, quotes_data_service_1.QuotesDataProvider, quote_update_service_1.QuoteUpdateService])], QtFixedTemplateControlComponent);
exports.QtFixedTemplateControlComponent = QtFixedTemplateControlComponent;

/***/ }),

/***/ "./web/modern/components/settings/quote-invoice-templates/qt-templates-update/qt-templates-update.component.html":
/***/ (function(module, exports) {

module.exports = "<template-edit-header [disableButtons]=\"savingTemplate\" (onGoBack)=\"goBack()\" (onSave)=\"saveTemplate()\"></template-edit-header>\n\n\n<section class=\"template-edit-wrapper\" dnd-auto-scroll *ngIf=\"dataLoaded\">\n    <div class=\"template-edit-content\">\n        <ng-container *ngIf=\"templateType === 'CUSTOM_QUOTE'; then customTemplate; else fixedTemplate\"></ng-container>\n\n        <ng-template #customTemplate>\n            <qt-custom-template-control [templateData]=\"templatesData\"\n                                        [disableContractButton]=\"disableContractButton\"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t[generateInvoiceDisabled]=\"disableGenerateInvoice\"\n                                        (emitContractChange)=\"loadContractToEdit($event)\"\n                                        (emitContractToEdit)=\"editContractTemplate($event)\"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t(emitPaymentChange)=\"updateGenerateInvoiceDisabled($event)\">\n            </qt-custom-template-control>\n        </ng-template>\n\n        <ng-template #fixedTemplate>\n            <qt-fixed-template-control [type]=\"templateType\"\n                                       [templateData]=\"templatesData\"\n                                       [disableContractButton]=\"disableContractButton\"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t [generateInvoiceDisabled]=\"disableGenerateInvoice\"\n                                       (emitContractChange)=\"loadContractToEdit($event)\"\n                                       (emitContractToEdit)=\"editContractTemplate($event)\"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t (emitPaymentChange)=\"updateGenerateInvoiceDisabled($event)\">\n            </qt-fixed-template-control>\n        </ng-template>\n\n        <button class=\"btn btn-lg btn-info mb-0\" [disabled]=\"savingTemplate\"\n                spinning-wheel [is-spinning-wheel-active]=\"savingTemplate\"\n                (click)=\"saveTemplate()\">\n            Save Template\n        </button>\n\n    </div>\n\n</section>\n\n<section *ngIf=\"!dataLoaded\" class=\"loading-overlay\"></section>\n\n\n"

/***/ }),

/***/ "./web/modern/components/settings/quote-invoice-templates/qt-templates-update/qt-templates-update.component.scss":
/***/ (function(module, exports) {

module.exports = ".template-edit-wrapper {\n  width: 100%;\n  margin-top: 0; }\n  @media screen and (min-width: 1920px) {\n    .template-edit-wrapper {\n      max-width: 1920px;\n      margin: auto; } }\n\n.template-edit-content {\n  margin: 0 auto;\n  background: #ffffff;\n  padding: 30px; }\n\n.loading-overlay {\n  width: 100vw;\n  height: 100vh;\n  top: 0;\n  position: absolute; }\n  .loading-overlay::before {\n    content: '';\n    width: 100px;\n    height: 100px;\n    position: absolute;\n    display: block;\n    background: url(\"../assets/images/preloader/spinning-wheel-dark.gif\");\n    background-size: contain;\n    top: 50%;\n    left: 50%;\n    font-size: 20px;\n    -webkit-transform: translate(-50%, -50%);\n        -ms-transform: translate(-50%, -50%);\n            transform: translate(-50%, -50%); }\n"

/***/ }),

/***/ "./web/modern/components/settings/quote-invoice-templates/qt-templates-update/qt-templates-update.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var common_1 = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
var confirm_general_modal_component_1 = __webpack_require__("./web/modern/components/common/confirm-general-modal/confirm-general-modal.component.ts");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var zip_1 = __webpack_require__("./node_modules/rxjs/observable/zip.js");
var quote_update_service_1 = __webpack_require__("./shared/services/quote/quote-update.service.ts");
var product_packages_data_service_1 = __webpack_require__("./shared/services/settings/product-packages.data.service.ts");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var templates_data_service_1 = __webpack_require__("./shared/services/data-services/templates-data-service/templates.data.service.ts");
var payments_schedules_data_service_1 = __webpack_require__("./shared/services/payments/payments-schedules-data-service/payments-schedules.data.service.ts");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var settings_1 = __webpack_require__("./shared/services/settings/settings.ts");
var of_1 = __webpack_require__("./node_modules/rxjs/observable/of.js");
var edit_contract_modal_component_1 = __webpack_require__("./web/modern/components/contract/edit-contract-modal/edit-contract-modal.component.ts");
var deep_object_diff_1 = __webpack_require__("./node_modules/deep-object-diff/dist/index.js");
var save_as_template_modal_component_1 = __webpack_require__("./web/modern/components/quotes/modals/save-as-template-modal/save-as-template-modal.component.ts");
var save_new_template_modal_component_1 = __webpack_require__("./web/modern/components/quotes/modals/save-new-template-modal/save-new-template-modal.component.ts");
var contracts_data_service_1 = __webpack_require__("./shared/services/contract/contracts.data.service.ts");
var invoice_service_1 = __webpack_require__("./shared/services/invoice/invoice-service/invoice.service.ts");
var contracts_service_1 = __webpack_require__("./shared/services/contract/contracts-service/contracts.service.ts");
var quote_invoice_templates_data_service_1 = __webpack_require__("./shared/services/quote-invoice-templates/quote-invoice-templates.data.service.ts");
var quote_invoice_templates_service_1 = __webpack_require__("./shared/services/quote-invoice-templates/quote-invoice-templates.service.ts");
var QtTemplatesUpdateComponent = function () {
    function QtTemplatesUpdateComponent(location, modalService, messageService, productPackagesDataService, templatesDataService, paymentsSchedulesDataService, settingsService, quoteInvoiceTemplatesDataService, quoteInvoiceTemplatesService, quoteUpdateService, contractsDataService, contractsService) {
        _classCallCheck(this, QtTemplatesUpdateComponent);

        this.location = location;
        this.modalService = modalService;
        this.messageService = messageService;
        this.productPackagesDataService = productPackagesDataService;
        this.templatesDataService = templatesDataService;
        this.paymentsSchedulesDataService = paymentsSchedulesDataService;
        this.settingsService = settingsService;
        this.quoteInvoiceTemplatesDataService = quoteInvoiceTemplatesDataService;
        this.quoteInvoiceTemplatesService = quoteInvoiceTemplatesService;
        this.quoteUpdateService = quoteUpdateService;
        this.contractsDataService = contractsDataService;
        this.contractsService = contractsService;
        this.unsubscribe = new Subject_1.Subject();
    }

    _createClass(QtTemplatesUpdateComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.prepareBaseData();
            this.loadPageData();
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "unloadNotification",
        value: function unloadNotification($event) {
            if (this.initialTemplatesData && this.hasDataChanged()) {
                $event.returnValue = true;
            }
        }
    }, {
        key: "goBack",
        value: function goBack() {
            if (this.initialTemplatesData && this.hasDataChanged()) {
                this.showConfirmExitModal();
                return;
            }
            this.goToTemplatesPage();
        }
    }, {
        key: "saveTemplate",
        value: function saveTemplate() {
            this.templatesData.data.products = this.quoteInvoiceTemplatesService.mapLineItems(this.gatherProductsData());
            if (!this.isTemplatesValid(this.templatesData)) {
                return;
            }
            var data = this.quoteInvoiceTemplatesService.prepareTemplateForSave(this.templatesData);
            if (this.templateType === 'QUOTE') {
                data.data.products = quote_update_service_1.QuoteUpdateService.setFixedQuoteProducts(data.data.products).map(function (el) {
                    el.mandatory = true;
                    return el;
                });
            }
            if (this.templateAction === 'DUPLICATE' || this.templateAction === 'ADD') {
                this.createTemplate(data);
                return;
            }
            if (this.templateId) {
                this.editTemplate(data, this.templateId);
            }
        }
    }, {
        key: "createTemplate",
        value: function createTemplate(data) {
            var _this = this;

            this.savingTemplate = true;
            this.quoteInvoiceTemplatesDataService.saveTemplate(this.templateType, data).pipe(operators_1.takeUntil(this.unsubscribe), operators_1.finalize(function () {
                return _this.savingTemplate = false;
            })).subscribe(function () {
                _this.changesSaved = true;
                _this.goToTemplatesPage();
                _this.messageService.showToaster(_this.templateAction === 'DUPLICATE' ? 's_2' : 's_0', 'quoteInvoiceTemplates', _this.templateType === 'INVOICE' ? 'invoice' : 'quote');
            }, function (error) {
                return _this.messageService.handleError(error);
            });
        }
    }, {
        key: "editTemplate",
        value: function editTemplate(data, id) {
            var _this2 = this;

            this.savingTemplate = true;
            this.quoteInvoiceTemplatesDataService.editTemplate(this.templateType, id, data).pipe(operators_1.takeUntil(this.unsubscribe), operators_1.finalize(function () {
                return _this2.savingTemplate = false;
            })).subscribe(function () {
                _this2.changesSaved = true;
                _this2.goToTemplatesPage();
                _this2.messageService.showToaster('s_1', 'quoteInvoiceTemplates', _this2.templateType === 'INVOICE' ? 'invoice' : 'quote');
            }, function (error) {
                return _this2.messageService.handleError(error);
            });
        }
    }, {
        key: "loadContractToEdit",
        value: function loadContractToEdit(id) {
            var _this3 = this;

            this.templatesData.contractTemplateId = id;
            this.loadedContractToEdit = null;
            if (id === '-1') {
                return;
            }
            this.disableContractButton = true;
            this.templatesDataService.getTemplates('contract_full', Number(id)).pipe(operators_1.takeUntil(this.unsubscribe), operators_1.finalize(function () {
                return _this3.disableContractButton = false;
            })).subscribe(function (data) {
                return _this3.loadedContractToEdit = data;
            });
        }
    }, {
        key: "editContractTemplate",
        value: function editContractTemplate() {
            var modalRef = this.modalService.openModal(edit_contract_modal_component_1.EditContractModalComponent, {
                windowClass: 'ng-bootstrap-modal modal-visible'
            });
            modalRef.componentInstance.isFixed = this.templateType !== 'CUSTOM_QUOTE';
            modalRef.componentInstance.contractToEdit = JSON.parse(JSON.stringify(this.loadedContractToEdit));
            modalRef.componentInstance.action = 'SAVE_CONTRACT';
            var originalText = this.loadedContractToEdit.text;
            this.subscribeToModalData(modalRef, originalText);
        }
    }, {
        key: "updateGenerateInvoiceDisabled",
        value: function updateGenerateInvoiceDisabled(paymentId) {
            this.disableGenerateInvoice = +paymentId === -3;
        }
    }, {
        key: "subscribeToModalData",
        value: function subscribeToModalData(modalRef, originalText) {
            var _this4 = this;

            var modalDataSubscription = this.modalService.getModalData().subscribe(function (data) {
                if (data) {
                    var action = data.action,
                        props = data.props;

                    if (action === 'CLOSE_MODAL') {
                        _this4.modalService.closeModalByRef(modalRef, modalDataSubscription);
                    }
                    if (action === 'SAVE_CONTRACT') {
                        if (_this4.isTextDiffed(originalText, props.text)) {
                            if (!_this4.contractsService.contractTextValid(props.text)) {
                                return;
                            }
                            _this4.confirmEditingContract(props, modalRef, modalDataSubscription);
                            return;
                        }
                        _this4.modalService.closeModalByRef(modalRef, modalDataSubscription);
                    }
                }
            });
        }
    }, {
        key: "confirmEditingContract",
        value: function confirmEditingContract(props, editedModalRef, editedModalStream) {
            var _this5 = this;

            if (props) {
                var modal = this.modalService.openModal(save_as_template_modal_component_1.SaveAsTemplateModalComponent, {
                    windowClass: 'ng-bootstrap-modal'
                });
                modal.componentInstance.templateList = this.templatesData.contracts;
                modal.componentInstance.templateTypeName = 'Contract';
                modal.componentInstance.breadcrumbsText = 'Contract Templates will be saved in Settings > Contract Templates';
                modal.componentInstance.detailedDescription = 'Your contract has been edited and will need to be saved as a Contract Template.';
                var modalSubscription$ = this.modalService.modalData.subscribe(function (res) {
                    if (res.action === 'CLOSE') {
                        _this5.modalService.closeModalByRef(modal, modalSubscription$);
                    }
                    if (res.action === 'SAVE') {
                        _this5.modalService.closeModalByRef(modal, modalSubscription$);
                        _this5.saveNewContractTemplate(props, editedModalRef, editedModalStream);
                    }
                    if (res.action === 'OVERWRITE') {
                        if (!res.props) {
                            _this5.messageService.showToaster('e_2', 'quoteInvoiceTemplates');
                            return;
                        }
                        modal.componentInstance.btnDisable = true;
                        _this5.contractsDataService.overwriteContractTemplate(res.props.templateId.toString(), _this5.assignEditedContractData(Object.assign({}, props, { name: res.props.name }))).pipe(operators_1.takeUntil(_this5.unsubscribe), operators_1.finalize(function () {
                            return modal.componentInstance.btnDisable = false;
                        })).subscribe(function (_ref) {
                            var data = _ref.data;

                            _this5.messageService.showToaster('s_2', 'contractTemplates', props.name);
                            _this5.loadedContractToEdit = JSON.parse(JSON.stringify(props));
                            _this5.templatesData.contractTemplateId = data.id.toString();
                            _this5.modalService.closeModalByRef(editedModalRef, editedModalStream);
                            _this5.modalService.closeModalByRef(modal, modalSubscription$);
                        }, function (error) {
                            return _this5.messageService.handleError(error);
                        });
                    }
                });
            }
        }
    }, {
        key: "assignEditedContractData",
        value: function assignEditedContractData(props) {
            return {
                name: props.name,
                optInConsent: this.getNonFalsyValue(props.optInConsentStatement) || this.getNonFalsyValue(props.optInConsent),
                showOptInConsent: this.getNonFalsyValue(props.showOtpInConsent) || this.getNonFalsyValue(props.showOptInConsent),
                text: props.text
            };
        }
    }, {
        key: "saveNewContractTemplate",
        value: function saveNewContractTemplate(contract, contractEditModal, contractEditStream) {
            var _this6 = this;

            var modal = this.modalService.openModal(save_new_template_modal_component_1.SaveNewTemplateModalComponent, {
                windowClass: 'ng-bootstrap-modal'
            });
            modal.componentInstance.templateTypeName = 'Contract';
            modal.componentInstance.breadcrumbsText = 'Contract Templates will be saved in Settings > Contract Templates';
            modal.componentInstance.templateNameProp = contract.name;
            var modalSubscription$ = this.modalService.modalData.subscribe(function (res) {
                if (res.action === 'CLOSE') {
                    _this6.confirmEditingContract(contract, contractEditModal, contractEditStream);
                    _this6.modalService.closeModalByRef(modal, modalSubscription$);
                }
                if (res.action === 'SAVE') {
                    if (!res.props || res.props && !res.props.trim()) {
                        _this6.messageService.showToaster('e_3', 'quoteInvoiceTemplates');
                        return;
                    }
                    var newContract = JSON.parse(JSON.stringify(contract));
                    newContract.name = res.props;
                    modal.componentInstance.btnDisable = true;
                    _this6.contractsDataService.saveNewContractTemplate(_this6.assignEditedContractData(newContract)).pipe(operators_1.takeUntil(_this6.unsubscribe), operators_1.finalize(function () {
                        return modal.componentInstance.btnDisable = false;
                    })).subscribe(function (_ref2) {
                        var data = _ref2.data;

                        _this6.modalService.closeModalByRef(contractEditModal, contractEditStream);
                        _this6.modalService.closeModalByRef(modal, modalSubscription$);
                        _this6.messageService.showToaster('s_5', 'quoteInvoiceTemplates', newContract.name);
                        _this6.updateContractTemplateList();
                        _this6.templatesData.contractTemplateId = data.id.toString();
                        _this6.loadedContractToEdit.text = newContract.text;
                        _this6.loadedContractToEdit.name = newContract.name;
                    }, function (error) {
                        return _this6.messageService.handleError(error);
                    });
                }
            });
        }
    }, {
        key: "updateContractTemplateList",
        value: function updateContractTemplateList() {
            var _this7 = this;

            this.templatesDataService.getTemplates('contract_preview').pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (_ref3) {
                var contractTemplates = _ref3.contractTemplates;

                _this7.templatesData.contracts = [].concat(_toConsumableArray(contractTemplates));
            });
        }
    }, {
        key: "isTextDiffed",
        value: function isTextDiffed(original, newText) {
            return !!Object.keys(deep_object_diff_1.diff({ text: original }, { text: newText })).length;
        }
    }, {
        key: "getIntroductionIfCreate",
        value: function getIntroductionIfCreate() {
            if (!this.templateId && this.templateType !== 'INVOICE') {
                return this.quoteInvoiceTemplatesDataService.getQuoteIntroduction();
            }
            return of_1.of(null);
        }
    }, {
        key: "loadPageData",
        value: function loadPageData() {
            var _this8 = this;

            zip_1.zip(this.productPackagesDataService.getPackagesOrProducts(quote_update_service_1.QuoteUpdateService.getPageRequest()), this.templatesDataService.getTemplates('contract_preview'), this.templatesDataService.getTemplates('questionnaire_preview'), this.paymentsSchedulesDataService.getPaymentsSchedules(quote_update_service_1.QuoteUpdateService.getPaymentSchedulesPageRequest()), this.getIntroductionIfCreate(), this.settingsService.getCurrencyAndTaxes(), this.loadQuoteIfEdit()).pipe(operators_1.takeUntil(this.unsubscribe), operators_1.map(function (_ref4) {
                var _ref5 = _slicedToArray(_ref4, 7),
                    productItems = _ref5[0],
                    contracts = _ref5[1],
                    questionnaires = _ref5[2],
                    paymentSchedules = _ref5[3],
                    introductions = _ref5[4],
                    currency = _ref5[5],
                    qtTemplate = _ref5[6];

                return [productItems.items, contracts.contractTemplates, questionnaires.questionnaireTemplates, paymentSchedules.results, introductions ? introductions.data : introductions, {
                    currencyDTO: currency.currencyDTO,
                    taxName: currency.taxName,
                    percentage: currency.percentage
                }, qtTemplate];
            }), operators_1.finalize(function () {
                return _this8.dataLoaded = true;
            })).subscribe(function (data) {
                _this8.templateId ? _this8.assignEditTemplatesData(data) : _this8.assignNewTemplatesData(data);
                _this8.saveInitialDataSnapshot();
            }, function (error) {
                return _this8.messageService.handleError(error);
            });
        }
    }, {
        key: "loadQuoteIfEdit",
        value: function loadQuoteIfEdit() {
            if (this.templateId) {
                return this.quoteInvoiceTemplatesDataService.loadQtTemplate(this.templateId, this.templateType === 'CUSTOM_QUOTE' ? 'QUOTE' : this.templateType);
            }
            return of_1.of(null);
        }
    }, {
        key: "assignNewTemplatesData",
        value: function assignNewTemplatesData(_ref6) {
            var _ref7 = _slicedToArray(_ref6, 6),
                productItems = _ref7[0],
                contracts = _ref7[1],
                questionnaires = _ref7[2],
                paymentSchedules = _ref7[3],
                introductions = _ref7[4],
                currency = _ref7[5];

            var _quote_update_service = quote_update_service_1.QuoteUpdateService.setPackagesAndAddons(productItems),
                packages = _quote_update_service.packages,
                addons = _quote_update_service.addons,
                discounts = _quote_update_service.discounts;

            this.templatesData.products = {
                items: [],
                templates: addons
            };
            this.templatesData.packages = {
                items: [quote_update_service_1.QuoteUpdateService.setEmptyProduct('PACKAGE')],
                templates: packages
            };
            this.templatesData.discounts = {
                items: [],
                templates: discounts
            };
            var newAddon = quote_update_service_1.QuoteUpdateService.setEmptyProduct('ADD_ON');
            if (this.templateType === 'QUOTE') {
                newAddon.mandatory = true;
            }
            this.templatesData.addons = {
                items: [newAddon],
                templates: [].concat(_toConsumableArray(packages), _toConsumableArray(addons))
            };
            this.templatesData.data.generateInvoiceWhenAccepted = true;
            this.templatesData.contracts = contracts;
            this.templatesData.questionnaires = questionnaires;
            this.templatesData.paymentDefaultScheduleTemplates = [{
                id: -2,
                name: 'No split payments',
                disabled: false
            }];
            if (this.templateType !== 'INVOICE') {
                this.templatesData.paymentDefaultScheduleTemplates.push({
                    id: -3,
                    name: 'No payment required',
                    disabled: false
                });
            }
            this.templatesData.paymentScheduleTemplates = paymentSchedules;
            this.templatesData.currency = currency;
            this.templatesData.summary = null;
            if (this.templateType !== 'INVOICE') {
                if (this.templateType === 'CUSTOM_QUOTE') {
                    this.templatesData.data.introduction = introductions.chooseAndPickIntroduction ? introductions.chooseAndPickIntroduction.introduction : '';
                } else {
                    this.templatesData.data.introduction = introductions.fixedIntroduction ? introductions.fixedIntroduction.introduction : '';
                }
            }
        }
    }, {
        key: "assignEditTemplatesData",
        value: function assignEditTemplatesData(_ref8) {
            var _ref9 = _slicedToArray(_ref8, 7),
                productItems = _ref9[0],
                contracts = _ref9[1],
                questionnaires = _ref9[2],
                paymentSchedules = _ref9[3],
                _ = _ref9[4],
                currency = _ref9[5],
                qtTemplate = _ref9[6];

            var data = qtTemplate.data;

            var _quote_update_service2 = quote_update_service_1.QuoteUpdateService.setPackagesAndAddons(productItems),
                packages = _quote_update_service2.packages,
                addons = _quote_update_service2.addons,
                discounts = _quote_update_service2.discounts;

            var lineItems = quote_update_service_1.QuoteUpdateService.setPackagesAndAddons(data.products);
            this.templatesData.products = {
                items: [].concat(_toConsumableArray(lineItems.addons)),
                templates: addons
            };
            this.templatesData.packages = {
                items: [].concat(_toConsumableArray(lineItems.packages)),
                templates: packages
            };
            this.templatesData.discounts = {
                items: [].concat(_toConsumableArray(lineItems.discounts)),
                templates: discounts
            };
            this.templatesData.addons = {
                items: [].concat(_toConsumableArray(lineItems.packages), _toConsumableArray(lineItems.addons)),
                templates: [].concat(_toConsumableArray(packages), _toConsumableArray(addons))
            };
            this.templatesData.contracts = contracts;
            this.templatesData.contractTemplateId = data.contractTemplate ? data.contractTemplate.id.toString() : '-1';
            this.templatesData.questionnaires = questionnaires;
            this.templatesData.questionnaireTemplateId = data.questionnaireTemplate ? data.questionnaireTemplate.id.toString() : '-1';
            this.templatesData.paymentDefaultScheduleTemplates = [{
                id: -2,
                name: 'No split payments',
                disabled: false
            }];
            if (this.templateType !== 'INVOICE') {
                this.templatesData.paymentDefaultScheduleTemplates.push({
                    id: -3,
                    name: 'No payment required',
                    disabled: false
                });
            }
            this.templatesData.paymentScheduleTemplates = paymentSchedules;
            this.getPaymentSchedule(data, paymentSchedules);
            this.templatesData.data.notes = data.notes;
            this.templatesData.data.introduction = data.introduction;
            if (this.templatesData.paymentSchedulerTemplateId === '-3') {
                this.disableGenerateInvoice = true;
            }
            this.templatesData.data.generateInvoiceWhenAccepted = this.templatesData.paymentSchedulerTemplateId === '-3' && data.generateInvoiceWhenAccepted;
            this.templatesData.currency = currency;
            this.templatesData.summary = data.summary;
            this.templatesData.data.name = this.templateAction === 'DUPLICATE' ? data.name + " copy" : data.name;
            this.loadedContractToEdit = data.contractTemplate;
        }
    }, {
        key: "saveInitialDataSnapshot",
        value: function saveInitialDataSnapshot() {
            var _this9 = this;

            var streamRef$ = this.quoteUpdateService.updatedProductObservable.pipe(operators_1.filter(function (product) {
                return product !== null;
            }), operators_1.debounceTime(500)).subscribe(function () {
                _this9.initialTemplatesData = JSON.parse(JSON.stringify(_this9.templatesData));
                streamRef$.unsubscribe();
            });
        }
    }, {
        key: "hasDataChanged",
        value: function hasDataChanged() {
            var diffedData = deep_object_diff_1.diff(this.initialTemplatesData, JSON.parse(JSON.stringify(this.templatesData)));
            if (Object.keys(diffedData).length) {
                return true;
            }
            return false;
        }
    }, {
        key: "getPaymentSchedule",
        value: function getPaymentSchedule(data, paymentSchedules) {
            var rule = data.paymentsRule;
            if (rule) {
                switch (rule.strategy) {
                    case 'NO_SPLIT_PAYMENTS':
                        this.templatesData.paymentSchedulerTemplateId = '-2';
                        break;
                    case 'NO_DUE_DATE':
                        this.templatesData.paymentSchedulerTemplateId = '-3';
                        break;
                    case 'BY_PAYMENT_SCHEDULER':
                        var paymentScdl = rule.paymentSchedule;
                        if (paymentScdl) {
                            var check = paymentSchedules.some(function (el) {
                                return el.id === paymentScdl.id;
                            });
                            if (!check) {
                                this.templatesData.paymentScheduleTemplates.push(Object.assign({}, paymentScdl));
                            }
                            this.templatesData.paymentSchedulerTemplateId = paymentScdl.id.toString();
                        }
                        break;
                    default:
                        this.templatesData.paymentSchedulerTemplateId = '-2';
                }
            } else {
                if (data.paymentSchedule) {
                    var _check = paymentSchedules.some(function (el) {
                        return el.id === data.paymentSchedule.id;
                    });
                    if (!_check) {
                        this.templatesData.paymentScheduleTemplates.push(Object.assign({}, data.paymentSchedule));
                    }
                }
                this.templatesData.paymentSchedulerTemplateId = data.paymentSchedule ? data.paymentSchedule.id.toString() : '-2';
            }
        }
    }, {
        key: "isTemplatesValid",
        value: function isTemplatesValid(data) {
            if (this.templateType === 'INVOICE') {
                return this.quoteInvoiceTemplatesService.validateInvoiceTemplate(data);
            }
            return this.quoteInvoiceTemplatesService.validateQuoteTemplate(data);
        }
    }, {
        key: "gatherProductsData",
        value: function gatherProductsData() {
            if (this.templateType === 'CUSTOM_QUOTE') {
                return [].concat(_toConsumableArray(this.templatesData.products.items), _toConsumableArray(this.templatesData.packages.items), _toConsumableArray(this.templatesData.discounts.items));
            }
            return [].concat(_toConsumableArray(this.templatesData.addons.items), _toConsumableArray(this.templatesData.discounts.items));
        }
    }, {
        key: "prepareBaseData",
        value: function prepareBaseData() {
            this.templatesData = this.templateType === 'INVOICE' ? invoice_service_1.InvoiceServiceProvider.getQtBaseTemplateData() : quote_update_service_1.QuoteUpdateService.getQtBaseTemplateData();
        }
    }, {
        key: "goToTemplatesPage",
        value: function goToTemplatesPage() {
            this.location.go('/settings/quote_invoice_templates');
        }
    }, {
        key: "showConfirmExitModal",
        value: function showConfirmExitModal() {
            var _this10 = this;

            var modal = this.modalService.openModal(confirm_general_modal_component_1.ConfirmGeneralModalComponent);
            modal.componentInstance.text = "You have unsaved changes in your " + (this.templateType === 'INVOICE' ? 'Invoice' : 'Quote') + " Template.";
            modal.componentInstance.buttons = [{
                text: 'Save and Exit',
                color: 'success',
                size: 'lg',
                action: 'SAVE_AND_LEAVE'
            }, {
                text: "Exit and Don't Save",
                color: 'grey',
                size: 'lg',
                action: 'LEAVE'
            }, {
                text: 'Continue Editing',
                color: 'default',
                size: 'lg',
                action: 'STAY'
            }];
            modal.result.then(function (action) {
                if (action === 'LEAVE') {
                    _this10.goToTemplatesPage();
                }
                if (action === 'SAVE_AND_LEAVE') {
                    _this10.saveTemplate();
                }
            });
        }
    }, {
        key: "getNonFalsyValue",
        value: function getNonFalsyValue(value) {
            if (typeof value === 'boolean' || typeof value === 'string') {
                return value;
            }
            if (value === undefined) {
                return null;
            }
            return null;
        }
    }]);

    return QtTemplatesUpdateComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", String)], QtTemplatesUpdateComponent.prototype, "templateId", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], QtTemplatesUpdateComponent.prototype, "templateType", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], QtTemplatesUpdateComponent.prototype, "templateAction", void 0);
__decorate([core_1.HostListener('window:beforeunload', ['$event']), __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", void 0)], QtTemplatesUpdateComponent.prototype, "unloadNotification", null);
QtTemplatesUpdateComponent = __decorate([core_1.Component({
    selector: 'qt-templates-update',
    template: __webpack_require__("./web/modern/components/settings/quote-invoice-templates/qt-templates-update/qt-templates-update.component.html"),
    styles: [__webpack_require__("./web/modern/components/settings/quote-invoice-templates/qt-templates-update/qt-templates-update.component.scss")]
}), __metadata("design:paramtypes", [common_1.Location, snModal_service_1.SNModalService, message_service_1.MessageService, product_packages_data_service_1.ProductPackagesDataServiceProvider, templates_data_service_1.TemplatesDataProvider, payments_schedules_data_service_1.PaymentSchedulesDataProvider, settings_1.SettingsProvider, quote_invoice_templates_data_service_1.QuoteInvoiceTemplatesDataService, quote_invoice_templates_service_1.QuoteInvoiceTemplatesService, quote_update_service_1.QuoteUpdateService, contracts_data_service_1.ContractsDataProvider, contracts_service_1.ContractsServiceProvider])], QtTemplatesUpdateComponent);
exports.QtTemplatesUpdateComponent = QtTemplatesUpdateComponent;

/***/ }),

/***/ "./web/modern/components/settings/quote-invoice-templates/qt-templates/qt-templates-list/qt-templates-list.component.html":
/***/ (function(module, exports) {

module.exports = "<div [elemToScroll]=\"id\" class=\"mb-40 flex-box flex-align-center flex-just-space-between\">\n    <div class=\"flex-box flex-column flex-just-center\">\n        <h3 class=\"mt-0 mb-15\">{{templateType}} Templates</h3>\n        <p class=\"mb-0 f-s-14\">{{description}}</p>\n    </div>\n    <settings-add-btn *ngIf=\"templates?.actions?.CREATE\" [text]=\"'Add New Template'\" (onBtnClick)=\"addNewTemplate()\"></settings-add-btn>\n</div>\n\n<dynamic-table *ngIf=\"templates!.samples!.items?.length\" [headerList]=\"tableHeader\" [pageRequest]=\"pageRequest\" [templates]=\"templates.samples\" (updateTableParams)=\"updateTemplateList($event)\">\n    <tbody>\n        <tr *ngFor=\"let template of templates.samples.items; let i = index\">\n            <td class=\"name-cell-dynamic\">{{ template.name }}</td>\n            <td class=\"text-right white-space-no-wrap\">\n                <button *ngIf=\"template?.actions?.EDIT\"\n                        type=\"button\" class=\"btn btn-default mb-0\" (click)=\"editTemplate(template, 'edit')\">\n                    <i class=\"fi fi-edit\"></i>\n                    Edit\n                </button>\n                <button *ngIf=\"template?.actions?.DUPLICATE\"\n                        type=\"button\" class=\"btn btn-default mb-0\" (click)=\"editTemplate(template, 'duplicate')\">\n                    <i class=\"fi fi-duplicate\"></i>\n                    Duplicate\n                </button>\n                <button *ngIf=template?.actions?.DELETE\n                        type=\"button\" class=\"btn btn-delete btn-delete-empty mb-0\" (click)=\"openDeleteTemplateModal(template)\">\n                </button>\n            </td>\n        </tr>\n    </tbody>\n</dynamic-table>\n\n<div class=\"stats__placeholder mb-40\" *ngIf=\"!templates?.samples!.items?.length\">\n    <span>{{placeholder}}</span>\n</div>\n\n<div *ngIf=\"templateType.toLowerCase().includes('quote') && introduction\">\n    <label [attr.for]=\"templateType\" class=\"f-s-13 text-semi-bold mb-15\">\n        Default {{templateType}} Introduction\n    </label>\n    <textarea [id]=\"templateType\" class=\"form-control-textArea form-control\" [(ngModel)]=\"introduction.introduction\"  maxlength=\"1000\" [attr.placeholder]=\"introductionPlaceholder\"></textarea>\n    <button type=\"button\" class=\"btn btn-lg btn-success btn-success m-0 mt-30\"\n            *ngIf=\"introduction?.actions?.UPDATE\" (click)=\"saveIntroduction(introduction.actions.UPDATE)\"\n            [disabled]=\"introductionSaving\" spinning-wheel [is-spinning-wheel-active]=\"introductionSaving\">Save Introduction\n    </button>\n</div>\n"

/***/ }),

/***/ "./web/modern/components/settings/quote-invoice-templates/qt-templates/qt-templates-list/qt-templates-list.component.scss":
/***/ (function(module, exports) {

module.exports = ".stats__placeholder {\n  min-height: 120px; }\n\n.white-space-no-wrap {\n  white-space: nowrap; }\n"

/***/ }),

/***/ "./web/modern/components/settings/quote-invoice-templates/qt-templates/qt-templates-list/qt-templates-list.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var account_service_1 = __webpack_require__("./web/modern/services/user/account.service.ts");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var common_1 = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
var delete_item_modal_1 = __webpack_require__("./web/modern/components/settings/common/delete-item-modal/delete-item-modal.ts");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var quote_invoice_templates_data_service_1 = __webpack_require__("./shared/services/quote-invoice-templates/quote-invoice-templates.data.service.ts");
var quote_invoice_templates_service_1 = __webpack_require__("./shared/services/quote-invoice-templates/quote-invoice-templates.service.ts");
var QtTemplatesListComponent = function () {
    function QtTemplatesListComponent(accountService, modalService, messageService, qtTemplatesDataService, qtTemplatesService, location) {
        _classCallCheck(this, QtTemplatesListComponent);

        this.accountService = accountService;
        this.modalService = modalService;
        this.messageService = messageService;
        this.qtTemplatesDataService = qtTemplatesDataService;
        this.qtTemplatesService = qtTemplatesService;
        this.location = location;
        this.emitAction = new core_1.EventEmitter();
        this.tableHeader = [{ text: 'Name', isSortable: true, sortingCriteria: 'name' }, { text: '', isSortable: false, sortingCriteria: null }];
        this.pageRequest = {
            paging: {
                pageNumber: 0,
                pageSize: 10,
                searchToken: null
            },
            sortCriterias: [{
                fieldName: 'name',
                sortAscending: true
            }]
        };
        this.unsubscribe = new Subject_1.Subject();
    }

    _createClass(QtTemplatesListComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.setUpData();
        }
    }, {
        key: "ngOnChanges",
        value: function ngOnChanges(changes) {
            var templates = changes.templates;

            if (templates && !templates.isFirstChange() && templates.currentValue) {
                this.setPageRequestData();
            }
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "updateTemplateList",
        value: function updateTemplateList(event) {
            this.pageRequest = event;
            this.setOptionsToStorage(event);
            this.emitAction.emit([event, this.type]);
        }
    }, {
        key: "addNewTemplate",
        value: function addNewTemplate() {
            this.location.go("/settings/quote_invoice_templates/" + this.type.toLowerCase() + "/add");
        }
    }, {
        key: "editTemplate",
        value: function editTemplate(template, type) {
            if (!this.qtTemplatesService.isTemplateNameValid(type, template)) {
                return;
            }
            this.location.go("/settings/quote_invoice_templates/" + this.type.toLowerCase() + "/" + template.id + "/" + type);
        }
    }, {
        key: "saveIntroduction",
        value: function saveIntroduction(action) {
            var _this = this;

            var textToSend = this.prepareTextToSend(this.introduction.introduction);
            var url = action.url,
                method = action.method;

            if (textToSend) {
                this.introductionSaving = true;
                this.qtTemplatesDataService.invokeDynamicRequest(url, method, textToSend).pipe(operators_1.takeUntil(this.unsubscribe), operators_1.finalize(function () {
                    return _this.introductionSaving = false;
                })).subscribe(function () {
                    return _this.messageService.showToaster('s_4', 'quoteInvoiceTemplates');
                }, function (error) {
                    return _this.messageService.handleError(error);
                });
            }
        }
    }, {
        key: "openDeleteTemplateModal",
        value: function openDeleteTemplateModal(template) {
            var _this2 = this;

            var deleteModalRef = this.modalService.openModal(delete_item_modal_1.DeleteItemModalComponent);
            deleteModalRef.componentInstance.btnDisabled = false;
            deleteModalRef.componentInstance.itemName = template.name;
            deleteModalRef.componentInstance.modalTitle = this.templateType + " Template";
            deleteModalRef.componentInstance.modalData = template;
            var modalData$ = this.modalService.getModalData().subscribe(function (data) {
                deleteModalRef.componentInstance.btnDisabled = true;
                var _data$props$actions$D = data.props.actions.DELETE,
                    url = _data$props$actions$D.url,
                    method = _data$props$actions$D.method;

                _this2.qtTemplatesDataService.invokeDynamicRequest(url, method).pipe(operators_1.takeUntil(_this2.unsubscribe), operators_1.finalize(function () {
                    deleteModalRef.componentInstance.btnDisabled = false;
                    deleteModalRef.close();
                    modalData$.unsubscribe();
                })).subscribe(function () {
                    _this2.pageRequest.paging.pageNumber = 0;
                    _this2.pageRequest.paging.searchToken = null;
                    _this2.updateTemplateList(_this2.pageRequest);
                    _this2.messageService.showToaster('s_3', 'quoteInvoiceTemplates', _this2.type === 'INVOICE' ? 'invoice' : 'quote');
                }, function (error) {
                    return _this2.messageService.handleError(error);
                });
            });
            deleteModalRef.result.then(function () {
                return modalData$.unsubscribe();
            }).catch(function () {
                return modalData$.unsubscribe();
            });
        }
    }, {
        key: "getOptionsFromStorage",
        value: function getOptionsFromStorage(pageRequest) {
            var storageData = JSON.parse(localStorage.getItem(this.localStorageField));
            if (storageData && storageData !== '') {
                var pageSize = storageData.pageSize,
                    fieldName = storageData.fieldName,
                    sortAscending = storageData.sortAscending;

                pageRequest.paging.pageSize = pageSize;
                pageRequest.sortCriterias[0].fieldName = fieldName;
                pageRequest.sortCriterias[0].sortAscending = sortAscending;
            }
        }
    }, {
        key: "setOptionsToStorage",
        value: function setOptionsToStorage(pageRequest) {
            var pageRequestOptions = {
                pageSize: pageRequest.paging.pageSize,
                fieldName: pageRequest.sortCriterias[0].fieldName,
                sortAscending: pageRequest.sortCriterias[0].sortAscending
            };
            localStorage.removeItem(this.localStorageField);
            localStorage.setItem(this.localStorageField, JSON.stringify(pageRequestOptions));
        }
    }, {
        key: "setPageRequestData",
        value: function setPageRequestData() {
            this.pageRequest.paging.searchToken = this.templates.samples.searchToken;
        }
    }, {
        key: "setUpData",
        value: function setUpData() {
            var _this3 = this;

            this.defineTemplateType();
            this.accountService.companyIdObservable.pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (data) {
                _this3.companyId = data;
                _this3.localStorageField = _this3.type.toLowerCase() + "_templates_request_" + _this3.companyId;
                _this3.getOptionsFromStorage(_this3.pageRequest);
                _this3.setPageRequestData();
            });
        }
    }, {
        key: "prepareTextToSend",
        value: function prepareTextToSend(text) {
            if (text && text.trim().length === 0 && text.length > 0) {
                this.messageService.showToaster('e_4', 'productsPackages');
                return null;
            }
            return {
                introduction: text
            };
        }
    }, {
        key: "defineTemplateType",
        value: function defineTemplateType() {
            if (this.type === 'CUSTOM_QUOTE') {
                this.templateType = 'Pick & Choose Quote';
            } else if (this.type === 'QUOTE') {
                this.templateType = 'Fixed Quote';
            } else {
                this.templateType = 'Invoice';
            }
        }
    }]);

    return QtTemplatesListComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", String)], QtTemplatesListComponent.prototype, "placeholder", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], QtTemplatesListComponent.prototype, "introductionPlaceholder", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], QtTemplatesListComponent.prototype, "description", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], QtTemplatesListComponent.prototype, "templates", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], QtTemplatesListComponent.prototype, "type", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], QtTemplatesListComponent.prototype, "introduction", void 0);
__decorate([core_1.Input(), __metadata("design:type", String)], QtTemplatesListComponent.prototype, "id", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], QtTemplatesListComponent.prototype, "emitAction", void 0);
QtTemplatesListComponent = __decorate([core_1.Component({
    selector: 'qt-templates-list',
    template: __webpack_require__("./web/modern/components/settings/quote-invoice-templates/qt-templates/qt-templates-list/qt-templates-list.component.html"),
    styles: [__webpack_require__("./web/modern/components/settings/quote-invoice-templates/qt-templates/qt-templates-list/qt-templates-list.component.scss")]
}), __metadata("design:paramtypes", [account_service_1.AccountServiceWebProvider, snModal_service_1.SNModalService, message_service_1.MessageService, quote_invoice_templates_data_service_1.QuoteInvoiceTemplatesDataService, quote_invoice_templates_service_1.QuoteInvoiceTemplatesService, common_1.Location])], QtTemplatesListComponent);
exports.QtTemplatesListComponent = QtTemplatesListComponent;

/***/ }),

/***/ "./web/modern/components/settings/quote-invoice-templates/qt-templates/qt-templates.component.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"bc-wrap\">\n    <div class=\"flex-box flex-just-space\">\n        <setting-section-header [breadcrumbs]=\"breadcrumbs\"></setting-section-header>\n    </div>\n</div>\n\n<div class=\"m-30\">\n\n    <qt-templates-list *ngIf=\"customQuote\"\n                       [description]=\"'Pick & Choose Quotes allow your clients to choose between different packages and products.'\"\n                       [placeholder]=\"'Start your first Pick & Choose Quote Template. There’s no going back!'\"\n                       [introductionPlaceholder]=\"'e.g. Thank you for considering me! Please choose from the list of packages and products and click Accept. Don’t hesitate to contact me if you have any questions.'\"\n                       [templates]=\"customQuote\"\n                       [type]=\"'CUSTOM_QUOTE'\"\n                       [introduction]=\"pickAndChooseIntroduction\"\n                       (emitAction)=\"loadNewTemplateData($event)\"\n                       id=\"pick_and_choose\">\n    </qt-templates-list>\n\n    <hr class=\"mt-40 mb-40\" *ngIf=\"quote\">\n\n    <qt-templates-list *ngIf=\"quote\"\n                       [description]=\"'Fixed Quotes are designed to present your client with a fixed list of packages and products.'\"\n                       [placeholder]=\"'Start your first Fixed Quote Template. Free up time!'\"\n                       [introductionPlaceholder]=\"'e.g. Thank you for considering me! Please review the quote below and click Accept if you’re happy to proceed. Don’t hesitate to contact me if you have any questions.'\"\n                       [templates]=\"quote\"\n                       [type]=\"'QUOTE'\"\n                       [introduction]=\"fixedQuoteIntroduction\"\n                       (emitAction)=\"loadNewTemplateData($event)\"\n                       id=\"fixed\">\n    </qt-templates-list>\n\n    <hr class=\"mt-40 mb-40\" *ngIf=\"invoice\">\n\n    <qt-templates-list *ngIf=\"invoice\"\n                       [description]=\"'If you find yourself creating the same invoice repeatedly, it’s time to set it up as an invoice template.'\"\n                       [placeholder]=\"'Start your first Invoice Template. Speed up your invoicing!'\"\n                       [templates]=\"invoice\"\n                       [type]=\"'INVOICE'\"\n                       (emitAction)=\"loadNewTemplateData($event)\"\n                       id=\"invoice\">\n    </qt-templates-list>\n</div>\n"

/***/ }),

/***/ "./web/modern/components/settings/quote-invoice-templates/qt-templates/qt-templates.component.scss":
/***/ (function(module, exports) {

module.exports = ""

/***/ }),

/***/ "./web/modern/components/settings/quote-invoice-templates/qt-templates/qt-templates.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var account_service_1 = __webpack_require__("./web/modern/services/user/account.service.ts");
var combineLatest_1 = __webpack_require__("./node_modules/rxjs/observable/combineLatest.js");
var quote_invoice_templates_data_service_1 = __webpack_require__("./shared/services/quote-invoice-templates/quote-invoice-templates.data.service.ts");
var QtTemplatesComponent = function () {
    function QtTemplatesComponent(qtTemplatesDataService, accountService, messageService) {
        _classCallCheck(this, QtTemplatesComponent);

        this.qtTemplatesDataService = qtTemplatesDataService;
        this.accountService = accountService;
        this.messageService = messageService;
        this.breadcrumbs = [{ link: '/', title: 'Dashboard' }, { link: '/settings', title: 'Settings' }, { link: null, title: 'Quote & Invoice Templates' }];
        this.unsubscribe = new Subject_1.Subject();
    }

    _createClass(QtTemplatesComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.getInitialData();
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "loadNewTemplateData",
        value: function loadNewTemplateData(_ref) {
            var _this = this;

            var _ref2 = _slicedToArray(_ref, 2),
                pageRequest = _ref2[0],
                type = _ref2[1];

            var sectionName = this.nameConverter(type.toLowerCase());
            this.loadTemplateSection([pageRequest, sectionName]).subscribe(function (_ref3) {
                var data = _ref3.data;
                return _this[sectionName] = JSON.parse(JSON.stringify(data));
            }, function (error) {
                return _this.messageService.handleError(error);
            });
        }
    }, {
        key: "loadTemplateSection",
        value: function loadTemplateSection(_ref4) {
            var _ref5 = _slicedToArray(_ref4, 2),
                pageRequest = _ref5[0],
                sectionName = _ref5[1];

            var methodName = "get" + this.titleCase(sectionName) + "TemplatesList";
            return this.qtTemplatesDataService[methodName](pageRequest).pipe(operators_1.takeUntil(this.unsubscribe), operators_1.filter(function (data) {
                return !!data;
            }));
        }
    }, {
        key: "loadPageTemplates",
        value: function loadPageTemplates() {
            var _this2 = this;

            var types = ['CUSTOM_QUOTE', 'QUOTE', 'INVOICE'];
            combineLatest_1.combineLatest(this.loadTemplateSection([this.getPageOptions(types[0]), this.nameConverter(types[0].toLowerCase())]), this.loadTemplateSection([this.getPageOptions(types[1]), this.nameConverter(types[1].toLowerCase())]), this.loadTemplateSection([this.getPageOptions(types[2]), this.nameConverter(types[2].toLowerCase())]).pipe(operators_1.takeUntil(this.unsubscribe))).subscribe(function (payload) {
                return payload.forEach(function (_ref6, index) {
                    var data = _ref6.data;

                    var sectionName = _this2.nameConverter(types[index].toLowerCase());
                    _this2[sectionName] = JSON.parse(JSON.stringify(data));
                });
            }, function (error) {
                return _this2.messageService.handleError(error);
            });
        }
    }, {
        key: "loadIntroduction",
        value: function loadIntroduction() {
            var _this3 = this;

            this.qtTemplatesDataService.getQuoteIntroduction().pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (_ref7) {
                var data = _ref7.data;

                _this3.fixedQuoteIntroduction = data.fixedIntroduction;
                _this3.pickAndChooseIntroduction = data.chooseAndPickIntroduction;
            }, function (error) {
                return _this3.messageService.handleError(error);
            });
        }
    }, {
        key: "getInitialData",
        value: function getInitialData() {
            var _this4 = this;

            this.accountService.companyIdObservable.pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (data) {
                _this4.companyId = data;
                _this4.loadPageTemplates();
                _this4.loadIntroduction();
            });
        }
    }, {
        key: "getPageOptions",
        value: function getPageOptions(type) {
            var localStorageField = type.toLowerCase() + "_templates_request_" + this.companyId;
            var pageOptions = localStorage.getItem(localStorageField);
            var options = {
                paging: {
                    pageNumber: 0,
                    pageSize: 10,
                    searchToken: null
                },
                sortCriterias: [{
                    fieldName: 'name',
                    sortAscending: true
                }]
            };
            if (pageOptions) {
                var savedOptions = JSON.parse(pageOptions);
                options.paging.pageSize = savedOptions.pageSize;
                options.sortCriterias[0].fieldName = savedOptions.fieldName;
                options.sortCriterias[0].sortAscending = savedOptions.sortAscending;
            }
            return options;
        }
    }, {
        key: "nameConverter",
        value: function nameConverter(dashedName) {
            return dashedName.replace(/_([a-z])/g, function (_ref8) {
                var _ref9 = _slicedToArray(_ref8, 2),
                    g = _ref9[1];

                return g.toUpperCase();
            });
        }
    }, {
        key: "titleCase",
        value: function titleCase(name) {
            return name.split('').map(function (e, i) {
                return i === 0 ? e.toUpperCase() : e;
            }).join('');
        }
    }]);

    return QtTemplatesComponent;
}();
QtTemplatesComponent = __decorate([core_1.Component({
    selector: 'qt-templates',
    template: __webpack_require__("./web/modern/components/settings/quote-invoice-templates/qt-templates/qt-templates.component.html"),
    styles: [__webpack_require__("./web/modern/components/settings/quote-invoice-templates/qt-templates/qt-templates.component.scss")]
}), __metadata("design:paramtypes", [quote_invoice_templates_data_service_1.QuoteInvoiceTemplatesDataService, account_service_1.AccountServiceWebProvider, message_service_1.MessageService])], QtTemplatesComponent);
exports.QtTemplatesComponent = QtTemplatesComponent;

/***/ }),

/***/ "./web/modern/components/settings/settings-overview/settings-item/settings-item.component.html":
/***/ (function(module, exports) {

module.exports = "<a [href]=\"setting.url\">\n    <div class=\"settings-list_item\">\n        <div class=\"settings-list_item-column\">\n            <h3 class=\"m-0 f-s-18 flex-box flex-align-center\">\n                <i class=\"fi-java settings-icon {{setting.icon}}\"></i>\n                {{ setting.actionName }}\n            </h3>\n        </div>\n        <div class=\"settings-list_item-column\">\n            <p class=\"mb-0 flex-50 pl-15 settings-list_item-description\">\n                {{ setting.actionDescription }}\n            </p>\n        </div>\n    </div>\n</a>"

/***/ }),

/***/ "./web/modern/components/settings/settings-overview/settings-item/settings-item.component.scss":
/***/ (function(module, exports) {

module.exports = ".settings-icon {\n  width: 25px;\n  height: 20px;\n  margin-right: 12px; }\n\n.settings-list_item {\n  padding: 20px;\n  width: 100%;\n  cursor: pointer;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center; }\n  @media (max-width: 1199px) {\n    .settings-list_item {\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n      -webkit-flex-direction: column;\n          -ms-flex-direction: column;\n              flex-direction: column;\n      -webkit-box-align: start;\n      -webkit-align-items: flex-start;\n          -ms-flex-align: start;\n              align-items: flex-start; }\n      .settings-list_item .settings-list_item-description {\n        padding-top: 5px;\n        padding-left: 37px !important; } }\n  .settings-list_item-column {\n    -webkit-box-flex: 50%;\n    -webkit-flex: 50%;\n        -ms-flex: 50%;\n            flex: 50%; }\n    .settings-list_item-column h3 {\n      line-height: 1.25; }\n"

/***/ }),

/***/ "./web/modern/components/settings/settings-overview/settings-item/settings-item.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var SettingsItemComponent = function SettingsItemComponent() {
    _classCallCheck(this, SettingsItemComponent);
};
__decorate([core_1.Input('item'), __metadata("design:type", Object)], SettingsItemComponent.prototype, "setting", void 0);
SettingsItemComponent = __decorate([core_1.Component({
    selector: 'settings-item',
    template: __webpack_require__("./web/modern/components/settings/settings-overview/settings-item/settings-item.component.html"),
    styles: [__webpack_require__("./web/modern/components/settings/settings-overview/settings-item/settings-item.component.scss")],
    encapsulation: core_1.ViewEncapsulation.None,
    changeDetection: core_1.ChangeDetectionStrategy.OnPush
})], SettingsItemComponent);
exports.SettingsItemComponent = SettingsItemComponent;

/***/ }),

/***/ "./web/modern/components/settings/settings-overview/settings-navigation/settings-navigation.component.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"settings-nav-block mt-30\">\n    <h3 class=\"f-s-16\">Global Settings\n        <span class=\"fa settings-nav-show-more-btn hidden-md hidden-lg\" (click)=\"showGlobalSettings = !showGlobalSettings\" [ngClass]=\"{'fa-caret-down' : !showGlobalSettings, 'fa-caret-up' : showGlobalSettings}\" ></span>\n    </h3>\n    <ul class=\"settings-nav-list\" [ngClass]=\"{'settings-nav-show-menu': showGlobalSettings}\">\n        <li class=\"settings-nav-item\" [class.active]=\"checkActiveSettingsNavItem(settingLink.url)\" *ngFor=\"let settingLink of settingsLists.globalSettings\">\n            <a class=\"f-s-14\" [href]=\"settingLink.url\">\n                {{ settingLink.title }}\n            </a>\n        </li>\n    </ul>\n</div>\n<div class=\"settings-nav-block\">\n    <h3 class=\"f-s-16\">Company Settings\n        <span class=\"fa settings-nav-show-more-btn hidden-md hidden-lg\" (click)=\"showCompanySettings = !showCompanySettings\" [ngClass]=\"{ 'fa-caret-down' : !showCompanySettings, 'fa-caret-up' : showCompanySettings}\"></span>\n    </h3>\n    <div *ngFor=\"let setting of companySettingsType\">\n        <ul class=\"settings-nav-list\" [ngClass]=\"{'settings-nav-show-menu': showCompanySettings}\" >\n            <div class=\"settings-nav-list-sub\">\n                <h4>{{ setting.name.toLowerCase() | titlecase }}</h4>\n            </div>\n            <li class=\"settings-nav-item\" [class.active]=\"checkActiveSettingsNavItem(settingLink.url)\" *ngFor=\"let settingLink of setting.companySettingsList\">\n                <a class=\"f-s-14\" [href]=\"settingLink.url\">\n                    {{ settingLink.title }}\n                </a>\n            </li>\n        </ul>\n    </div>\n</div>\n"

/***/ }),

/***/ "./web/modern/components/settings/settings-overview/settings-navigation/settings-navigation.component.scss":
/***/ (function(module, exports) {

module.exports = ".settings-nav-show-more-btn {\n  position: absolute;\n  width: 100%;\n  text-align: right;\n  left: 0;\n  cursor: pointer; }\n\n.settings-nav-show-menu {\n  display: -webkit-box !important;\n  display: -webkit-flex !important;\n  display: -ms-flexbox !important;\n  display: flex !important; }\n\n.settings-nav-block {\n  margin-right: 15px;\n  margin-bottom: 35px; }\n  .settings-nav-block h3 {\n    border-bottom: 1px solid #d7d7d7;\n    margin: 0;\n    padding-bottom: 15px;\n    color: #7c7c7c;\n    position: relative; }\n\n.settings-nav-list {\n  margin: 0;\n  list-style: none;\n  padding: 0;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n      -ms-flex-direction: column;\n          flex-direction: column; }\n  .settings-nav-list-sub h4 {\n    border-bottom: 1px solid #d7d7d7;\n    margin: 0;\n    padding: 12px 15px;\n    line-height: 1.42857;\n    color: #7c7c7c;\n    position: relative; }\n  @media (max-width: 991px) {\n    .settings-nav-list {\n      display: none; }\n      .settings-nav-list.settings-nav-show-menu {\n        display: -webkit-box !important;\n        display: -webkit-flex !important;\n        display: -ms-flexbox !important;\n        display: flex !important; } }\n\n.settings-nav-item {\n  border-bottom: 1px solid #d7d7d7;\n  background-color: white;\n  -webkit-transition: all 0.3s ease-in;\n  transition: all 0.3s ease-in;\n  cursor: pointer; }\n  .settings-nav-item.active {\n    background-color: #f9f9f9; }\n    .settings-nav-item.active a {\n      color: #000000 !important; }\n  .settings-nav-item:hover {\n    background-color: #f9f9f9; }\n    .settings-nav-item:hover a {\n      text-decoration: none !important; }\n  .settings-nav-item a {\n    display: inline-block;\n    width: 100%;\n    padding: 12px 30px;\n    color: #7c7c7c !important; }\n"

/***/ }),

/***/ "./web/modern/components/settings/settings-overview/settings-navigation/settings-navigation.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = undefined && undefined.__param || function (paramIndex, decorator) {
    return function (target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var common_1 = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
var settings_overview_data_service_1 = __webpack_require__("./shared/services/settings/settings-overview/settings-overview.data.service.ts");
var SettingsNavigationComponent = function () {
    function SettingsNavigationComponent(document, settingsOverviewService) {
        _classCallCheck(this, SettingsNavigationComponent);

        this.document = document;
        this.settingsOverviewService = settingsOverviewService;
        this.showCompanySettings = false;
        this.showGlobalSettings = false;
        this.companySettingsType = [];
    }

    _createClass(SettingsNavigationComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.getSettingsOverviewList();
        }
    }, {
        key: "checkActiveSettingsNavItem",
        value: function checkActiveSettingsNavItem(url) {
            if (url === '/settings/companies' && (this.document.location.pathname === '/settings/company/edit' || this.document.location.pathname.includes('/settings/company/'))) {
                return true;
            }
            return this.document.location.pathname === url;
        }
    }, {
        key: "getSettingsOverviewList",
        value: function getSettingsOverviewList() {
            var _this = this;

            this.settingsOverviewService.settingsOverview().filter(function (data) {
                return data !== null;
            }).subscribe(function (data) {
                _this.settingsLists = data;
                if (data.companySettings) {
                    _this.createCompanySettingsStructure(data);
                }
            });
        }
    }, {
        key: "createCompanySettingsStructure",
        value: function createCompanySettingsStructure(data) {
            var _this2 = this;

            this.companySettingsType = [];
            var companySettingsTypes = [];
            data.companySettings.forEach(function (el) {
                companySettingsTypes.push(el.companySettingsType);
            });
            var newSet = new Set(companySettingsTypes);
            var setArray = [].concat(_toConsumableArray(newSet));
            setArray.forEach(function (el) {
                _this2.companySettingsList = {
                    expandedIn: false,
                    name: el,
                    companySettingsList: [].concat(_toConsumableArray(data.companySettings.filter(function (obj) {
                        return obj.companySettingsType === el;
                    })))
                };
                _this2.companySettingsType.push(_this2.companySettingsList);
            });
        }
    }]);

    return SettingsNavigationComponent;
}();
SettingsNavigationComponent = __decorate([core_1.Component({
    selector: 'settings-navigation',
    template: __webpack_require__("./web/modern/components/settings/settings-overview/settings-navigation/settings-navigation.component.html"),
    styles: [__webpack_require__("./web/modern/components/settings/settings-overview/settings-navigation/settings-navigation.component.scss")],
    encapsulation: core_1.ViewEncapsulation.None
}), __param(0, core_1.Inject(common_1.DOCUMENT)), __metadata("design:paramtypes", [Document, settings_overview_data_service_1.SettingsOverviewDataProvider])], SettingsNavigationComponent);
exports.SettingsNavigationComponent = SettingsNavigationComponent;

/***/ }),

/***/ "./web/modern/components/settings/settings-overview/settings-overview.component.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"settings-wrapper bg-white\">\n    <div class=\"row\">\n        <div class=\"col-xs-12\">\n            <h2 class=\"mb-30\">Settings</h2>\n        </div>\n    </div>\n    <div class=\"row\">\n        <div class=\"col-xs-12\">\n            <div class=\"settings-container\">\n                <div class=\"row\">\n                    <div class=\"col-sm-6\">\n                        <div class=\"settings-block\">\n                            <div class=\"row\">\n                                <div class=\"col-xs-12\">\n                                    <div class=\"settings-block-header\">\n                                        <div class=\"settings-block-header-column\">\n                                            <div class=\"h-90 flex-box flex-column\">\n                                                <h2 class=\"mt-10 mb-20\">Global Settings</h2>\n                                                <p class=\"f-s-15 m-0 \">Applied to your entire account.</p>\n                                            </div>\n                                        </div>\n                                    </div>\n                                    <div class=\"settings-list\">\n                                        <ul>\n                                            <li *ngFor=\"let setting of settingsLists.globalSettings\">\n                                                <settings-item [item]=\"setting\"></settings-item>\n                                            </li>\n                                        </ul>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"col-sm-6\">\n                        <div class=\"settings-block\">\n                            <div class=\"row\">\n                                <div class=\"col-xs-12\">\n                                    <div class=\"settings-block-header\">\n                                        <div class=\"settings-list_item-column\">\n                                            <div class=\"flex-box\">\n                                                <div class=\"company-img\" *ngIf=\"settingsLists.logoUrl; else companyWithoutLogo\" [ngStyle]=\"{'background-image': 'url('+ settingsLists.logoUrl + ')'}\"></div>\n                                                <ng-template #companyWithoutLogo>\n                                                    <div class=\"company-img\">\n                                                        <i class=\"fi fi-company\"></i>\n                                                    </div>\n                                                </ng-template>\n                                                <div class=\"h-90\">\n                                                    <h2 class=\"mt-10 mb-20\">Company Settings</h2>\n                                                    <p class=\"f-s-15 m-0\">Applied to <strong>{{ settingsLists.brandName }}</strong> only.</p>\n                                                </div>\n                                            </div>\n                                        </div>\n                                        <div class=\"text-right\">\n                                            <button *ngIf=\"!settingsLists.actions.PREVIEW_BRAND_FOR_UPDATE\" class=\"btn btn-default mb-0\" disabled>\n                                                <i class=\"fi fi-edit\"></i>\n                                                Edit company\n                                            </button>\n                                            <a *ngIf=\"settingsLists.actions.PREVIEW_BRAND_FOR_UPDATE\" class=\"btn btn-default mb-0\" href=\"{{'/settings/company/' + settingsLists.currentCompanyId + '/edit'}}\">\n                                                <i class=\"fi fi-edit\"></i>\n                                                Edit company\n                                            </a>\n                                        </div>\n                                    </div>\n\n                                    <div class=\"settings-list\">\n                                        <div class=\"panel-group\" id=\"accordion\" role=\"tablist\" aria-multiselectable=\"false\">\n                                            <div class=\"panel-wrapper\" *ngFor=\"let companySettingsLists of companySettingsType; let i = index\">\n                                                <div class=\"panel panel-default\">\n                                                    <h4 class=\"panel-title\">\n                                                        <a type=\"button\" (click)=\"saveExpanded($event, i)\" class=\"{{companySettingsLists.expandedIn ? '' : 'collapsed'}}\" data-target=\"#{{companySettingsLists.name}}\" [attr.aria-controls]=\"companySettingsLists.name\" [attr.aria-expanded]=\"companySettingsLists.expandedIn\">\n                                                            <div class=\"panel-heading\">\n                                                                {{ companySettingsLists.name.toLowerCase() | titlecase }}\n                                                            </div>\n                                                        </a>\n                                                    </h4>\n                                                    <div id=\"{{companySettingsLists.name}}\" [ngClass]=\"companySettingsLists.expandedIn === true ? 'show-accordion':'hide-accordion'\" [attr.aria-expanded]=\"companySettingsLists.expandedIn\">\n                                                        <div class=\"panel-body p-0\">\n                                                            <ul>\n                                                               <li *ngFor=\"let setting of companySettingsLists.companySettingsList\">\n                                                                   <settings-item [item]=\"setting\"></settings-item>\n                                                               </li>\n                                                            </ul>\n                                                        </div>\n                                                    </div>\n                                                </div>\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "./web/modern/components/settings/settings-overview/settings-overview.component.scss":
/***/ (function(module, exports) {

module.exports = ".settings-wrapper {\n  padding: 10px 30px; }\n  @media screen and (min-width: 1920px) {\n    .settings-wrapper {\n      max-width: 1920px;\n      margin: auto; } }\n\n.settings-container {\n  border-top: 1px solid #d7d7d7;\n  padding: 30px 0; }\n\n.settings-list {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  width: 100%; }\n  .settings-list ul {\n    margin: 0;\n    list-style: none;\n    padding: 0;\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: column;\n        -ms-flex-direction: column;\n            flex-direction: column; }\n    .settings-list ul li {\n      border-top: 1px solid #d7d7d7; }\n      .settings-list ul li a {\n        color: #45464c !important; }\n        .settings-list ul li a:hover {\n          text-decoration: none !important; }\n\n.settings-block {\n  border: 1px solid #d7d7d7;\n  margin-bottom: 30px; }\n  .settings-block-header {\n    min-height: 130px;\n    padding: 20px;\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -webkit-align-items: center;\n        -ms-flex-align: center;\n            align-items: center; }\n    .settings-block-header-column {\n      -webkit-box-flex: 50%;\n      -webkit-flex: 50%;\n          -ms-flex: 50%;\n              flex: 50%; }\n    @media (max-width: 1199px) {\n      .settings-block-header {\n        -webkit-box-orient: vertical;\n        -webkit-box-direction: normal;\n        -webkit-flex-direction: column;\n            -ms-flex-direction: column;\n                flex-direction: column;\n        -webkit-box-align: start;\n        -webkit-align-items: flex-start;\n            -ms-flex-align: start;\n                align-items: flex-start; }\n        .settings-block-header .btn-default {\n          margin-top: 20px; } }\n\n.company-img {\n  border: 1px solid #d7d7d7;\n  margin-right: 15px;\n  width: 90px;\n  min-width: 90px;\n  height: 90px;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: #f9f9f9;\n  background-size: contain !important; }\n  .company-img > i {\n    font-size: 50px; }\n\n.panel-group {\n  margin-bottom: 0; }\n  .panel-group .panel-wrapper {\n    border-top: 1px solid #d7d7d7; }\n    .panel-group .panel-wrapper .panel .panel-title > a {\n      -webkit-appearance: none;\n         -moz-appearance: none;\n              appearance: none;\n      cursor: pointer; }\n    .panel-group .panel-wrapper .panel .panel-title > a .panel-heading:before {\n      float: right !important;\n      font-family: FontAwesome;\n      color: #a9a9a9;\n      content: '\\f068';\n      padding-right: 5px; }\n    .panel-group .panel-wrapper .panel .panel-title > a.collapsed .panel-heading:before {\n      float: right !important;\n      color: #a9a9a9;\n      content: '\\f067'; }\n    .panel-group .panel-wrapper .panel .panel-title > a:hover,\n    .panel-group .panel-wrapper .panel .panel-title > a:active,\n    .panel-group .panel-wrapper .panel .panel-title > a:focus {\n      text-decoration: none; }\n    .panel-group .panel-wrapper .panel .show-accordion {\n      overflow-y: hidden;\n      max-height: 1000px;\n      height: auto;\n      -webkit-transition: all 1s ease-in-out;\n      transition: all 1s ease-in-out; }\n    .panel-group .panel-wrapper .panel .hide-accordion {\n      overflow-y: hidden;\n      height: auto;\n      -webkit-transition: all 1s ease-in-out;\n      transition: all 1s ease-in-out;\n      max-height: 0; }\n    .panel-group .panel-wrapper .panel .panel-body {\n      border-top: 0 !important; }\n"

/***/ }),

/***/ "./web/modern/components/settings/settings-overview/settings-overview.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var settings_overview_data_service_1 = __webpack_require__("./shared/services/settings/settings-overview/settings-overview.data.service.ts");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var account_service_1 = __webpack_require__("./web/modern/services/user/account.service.ts");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var SettingsOverviewComponent = function () {
    function SettingsOverviewComponent(settingsOverviewService, accountService) {
        _classCallCheck(this, SettingsOverviewComponent);

        this.settingsOverviewService = settingsOverviewService;
        this.accountService = accountService;
        this.companySettingsType = [];
        this.companySettingsTypeToSave = [];
        this.unsubscribe = new Subject_1.Subject();
    }

    _createClass(SettingsOverviewComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.getUser();
            this.getSettingsOverviewList();
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "getUser",
        value: function getUser() {
            var _this = this;

            this.accountService.userDataObservable.pipe(operators_1.takeUntil(this.unsubscribe)).subscribe(function (user) {
                _this.user = user;
            });
        }
    }, {
        key: "getSettingsOverviewList",
        value: function getSettingsOverviewList() {
            var _this2 = this;

            this.settingsOverviewService.settingsOverview().pipe(operators_1.filter(function (data) {
                return data !== null;
            })).subscribe(function (data) {
                _this2.settingsLists = data;
                if (data.companySettings) {
                    var retrievedObject = localStorage.getItem("" + _this2.settingsLists.currentCompanyId + _this2.user.id);
                    var parsedLocal = JSON.parse(retrievedObject);
                    if (parsedLocal) {
                        var fromBE = JSON.stringify(data.companySettings);
                        var fromLocalStorage = JSON.stringify(parsedLocal.reduce(function (prev, curr) {
                            return [].concat(_toConsumableArray(prev), _toConsumableArray(curr.companySettingsList));
                        }, []));
                        if (fromBE !== fromLocalStorage) {
                            _this2.createCompanySettingsStructure(data, parsedLocal);
                        } else {
                            _this2.companySettingsType = parsedLocal;
                        }
                    } else {
                        localStorage.setItem('activeUser', _this2.user.id.toString());
                        localStorage.setItem('currentCompanyId', _this2.settingsLists.currentCompanyId.toString());
                        _this2.createCompanySettingsStructure(data);
                    }
                }
            });
        }
    }, {
        key: "createCompanySettingsStructure",
        value: function createCompanySettingsStructure(data) {
            var _this3 = this;

            var parsedLocal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            var parsedKeys = {};
            if (parsedLocal) {
                parsedLocal.forEach(function (category) {
                    parsedKeys[category.name] = {
                        itemsCount: category.companySettingsList.length,
                        expanded: category.expandedIn
                    };
                });
            }
            var companySettingsTypes = [];
            data.companySettings.forEach(function (el) {
                companySettingsTypes.push(el.companySettingsType);
            });
            var newSet = new Set(companySettingsTypes);
            var setArray = [].concat(_toConsumableArray(newSet));
            setArray.forEach(function (el) {
                _this3.companySettingsList = {
                    expandedIn: true,
                    name: el,
                    companySettingsList: [].concat(_toConsumableArray(data.companySettings.filter(function (obj) {
                        return obj.companySettingsType === el;
                    })))
                };
                if (parsedKeys[el]) {
                    _this3.companySettingsList.expandedIn = parsedKeys[el].expanded || _this3.companySettingsList.companySettingsList.length !== parsedKeys[el].itemsCount;
                }
                _this3.companySettingsType.push(_this3.companySettingsList);
            });
        }
    }, {
        key: "saveExpanded",
        value: function saveExpanded(event, index) {
            this.companySettingsType[index].expandedIn = event.currentTarget.ariaExpanded !== 'true';
            if (!event.currentTarget.ariaExpanded) {
                var expanded = event.currentTarget.getAttribute('aria-expanded') === 'true';
                event.currentTarget.setAttribute('aria-expanded', !expanded);
                this.companySettingsType[index].expandedIn = event.currentTarget.getAttribute('aria-expanded') === 'true';
            }
            localStorage.setItem("" + this.settingsLists.currentCompanyId + this.user.id, JSON.stringify(this.companySettingsType));
        }
    }]);

    return SettingsOverviewComponent;
}();
SettingsOverviewComponent = __decorate([core_1.Component({
    selector: 'settings-overview',
    template: __webpack_require__("./web/modern/components/settings/settings-overview/settings-overview.component.html"),
    styles: [__webpack_require__("./web/modern/components/settings/settings-overview/settings-overview.component.scss")],
    encapsulation: core_1.ViewEncapsulation.None
}), __metadata("design:paramtypes", [settings_overview_data_service_1.SettingsOverviewDataProvider, account_service_1.AccountServiceWebProvider])], SettingsOverviewComponent);
exports.SettingsOverviewComponent = SettingsOverviewComponent;

/***/ }),

/***/ "./web/modern/components/settings/workflow-exit-modal/workflow-exit-modal.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"exit-workflow-modal\">\n    <div id=\"workflowExitModal\" class=\"modal modal-center fade\" tabindex=\"-1\" role=\"dialog\">\n        <div class=\"modal-dialog\" role=\"document\">\n            <div class=\"modal-content\">\n                <div class=\"modal-body text-center\">\n                    <p>Do you want to save this Workflow before exiting?</p>\n                </div>\n                <div class=\"modal-footer text-center\">\n                    <button type=\"button\" class=\"btn btn-success\" data-dismiss=\"modal\" (click)=\"exitWithSaving(true)\">Save Workflow and Exit</button>\n                    <button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\" (click)=\"exitWithSaving(false)\">Exit without Saving</button>\n                    <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" (click)=\"dismiss()\">Continue Editing</button>\n                </div>\n            </div>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "./web/modern/components/settings/workflow-exit-modal/workflow-exit-modal.scss":
/***/ (function(module, exports) {

module.exports = ".exit-workflow-modal {\n  padding: 15px; }\n  .exit-workflow-modal .modal-dialog {\n    width: 670px; }\n    .exit-workflow-modal .modal-dialog .modal-body {\n      padding-bottom: 10px !important; }\n    .exit-workflow-modal .modal-dialog .modal-footer {\n      padding-bottom: 30px; }\n    .exit-workflow-modal .modal-dialog .btn {\n      padding: 15px 25px;\n      margin: 15px 10px 10px;\n      letter-spacing: 0.02em; }\n    .exit-workflow-modal .modal-dialog .btn-secondary {\n      background-color: #aeaeae;\n      color: #fff; }\n"

/***/ }),

/***/ "./web/modern/components/settings/workflow-exit-modal/workflow-exit-modal.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var ng_bootstrap_1 = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/index.js");
var WorkflowExitModalComponent = function () {
    function WorkflowExitModalComponent(activeModal) {
        _classCallCheck(this, WorkflowExitModalComponent);

        this.activeModal = activeModal;
        this.changePage = new core_1.EventEmitter();
    }

    _createClass(WorkflowExitModalComponent, [{
        key: "exitWithSaving",
        value: function exitWithSaving(isSaving) {
            this.changePage.emit(isSaving);
        }
    }, {
        key: "dismiss",
        value: function dismiss() {
            this.activeModal.close();
        }
    }]);

    return WorkflowExitModalComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", String)], WorkflowExitModalComponent.prototype, "nextPage", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], WorkflowExitModalComponent.prototype, "changePage", void 0);
WorkflowExitModalComponent = __decorate([core_1.Component({
    selector: 'workflow-exit-modal',
    template: __webpack_require__("./web/modern/components/settings/workflow-exit-modal/workflow-exit-modal.html"),
    styles: [__webpack_require__("./web/modern/components/settings/workflow-exit-modal/workflow-exit-modal.scss")]
}), __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal])], WorkflowExitModalComponent);
exports.WorkflowExitModalComponent = WorkflowExitModalComponent;

/***/ }),

/***/ "./web/modern/components/subscription/modals/subscription-modal/subscription-card/subscription-card.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"card p-20 flex flex-column full-height\">\n  <div class=\"corner-ribbon\">{{ card.planCategory }}</div>\n\n  <h3 class=\"card--title\">{{ card.planName }}</h3>\n\n  <span *ngIf=\"card.planDescriptionHtml\" [innerHTML]=\"card.planDescriptionHtml | safe: 'html'\" class=\"mt-10\"></span>\n\n  <div [innerHTML]=\"card.planFeatures | safe: 'html'\" class=\"card--description\"></div>\n\n  <div class=\"align-bottom\">\n    <div class=\"card--line\"></div>\n\n    <div class=\"card--price\">\n      <span [class.text-line-through]=\"card.offeredPrice\" class=\"card--price__initial\">{{ card.price.amountWithCurrency }}</span>\n      <span *ngIf=\"card.offeredPrice\" class=\"card--price__discounted\">{{ card.offeredPrice.amountWithCurrency }}</span>\n      <span class=\"card--price__period ml-2\"> / {{ card.price.invoiceInterval.displayName }}</span>\n      <ng-container *ngIf=\"card.tags.length\">\n        <span *ngFor=\"let tag of card.tags\" class=\"card--price__saved ml-2\">{{ tag }}</span>\n      </ng-container>\n    </div>\n    <div *ngIf=\"card.priceExplanation\" class=\"card--price__explanation\">{{ card.priceExplanation }}</div>\n    <div class=\"card--select mt-20\">\n<!--      <button (click)=\"selectPlan()\" *ngIf=\"card.actions.SELECT_PLAN\" [is-spinning-wheel-active]=\"disableButton\" class=\"btn btn-sm btn-success active-plan\" spinning-wheel>{{ card.actions.SELECT_PLAN.actionName }}</button>-->\n      <buttons-handler [actions]=\"card.actions\"></buttons-handler>\n<!--      <button *ngIf=\"card.actions.CURRENT_PLAN\" [disabled]=\"true\" class=\"btn btn-sm btn-general current-plan\">{{ card.actions.CURRENT_PLAN.actionName }}</button>-->\n    </div>\n  </div>\n</div>"

/***/ }),

/***/ "./web/modern/components/subscription/modals/subscription-modal/subscription-card/subscription-card.scss":
/***/ (function(module, exports) {

module.exports = ".card {\n  padding: 20px;\n  overflow: hidden;\n  position: relative;\n  width: 265px; }\n  .card--title {\n    margin: 0; }\n  .card--description {\n    margin-top: 20px; }\n  .card--line {\n    width: 100%;\n    margin: 15px 0;\n    border-bottom: 1px solid #e1e1e1;\n    height: 1px; }\n  .card--price {\n    font-size: 1.5rem;\n    color: #000000; }\n    .card--price__initial {\n      font-weight: bold; }\n    .card--price__discounted {\n      color: #c42136;\n      font-weight: bold; }\n    .card--price__saved {\n      font-size: 1rem;\n      text-transform: uppercase;\n      background-color: #f27987;\n      color: #ffffff;\n      padding: 2px 5px;\n      font-weight: 600;\n      border-radius: 4px; }\n    .card--price__explanation {\n      font-size: 1.1rem;\n      color: #8e8e98; }\n  .card--select .active-plan .current-plan {\n    padding: 3px 15px; }\n  .card--select .current-plan {\n    border-radius: 0; }\n\n@media (max-width: 670px) {\n  .card {\n    width: 258px;\n    min-height: 400px; } }\n\n@media (max-width: 460px) {\n  .card {\n    width: 100%; } }\n\n.corner-ribbon {\n  text-align: center;\n  color: #ffffff;\n  position: absolute;\n  top: 18px;\n  right: -46px;\n  -webkit-transform: rotate(45deg);\n      -ms-transform: rotate(45deg);\n          transform: rotate(45deg);\n  background: #22baa0;\n  width: 150px;\n  line-height: 27px;\n  font-weight: 700;\n  text-transform: uppercase;\n  font-size: 1.2rem; }\n"

/***/ }),

/***/ "./web/modern/components/subscription/modals/subscription-modal/subscription-card/subscription-card.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var subscription_model_1 = __webpack_require__("./shared/models/subscription.model.ts");
var SubscriptionCardComponent = function () {
    function SubscriptionCardComponent(renderer) {
        _classCallCheck(this, SubscriptionCardComponent);

        this.renderer = renderer;
        this.planSelect = new core_1.EventEmitter();
    }

    _createClass(SubscriptionCardComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.onCheckoutModalOpenEvent();
            this.onMessageReceived();
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.checkoutOpenEvent();
            this.messageReceived();
        }
    }, {
        key: "selectPlan",
        value: function selectPlan() {
            this.disableButton = true;
            this.planSelect.emit(this.card);
        }
    }, {
        key: "onCheckoutModalOpenEvent",
        value: function onCheckoutModalOpenEvent() {
            var _this = this;

            this.checkoutOpenEvent = this.renderer.listen('document', subscription_model_1.CommunicationEvents.planCheckoutOpen, function () {
                _this.disableButton = false;
            });
        }
    }, {
        key: "onMessageReceived",
        value: function onMessageReceived() {
            var _this2 = this;

            this.messageReceived = this.renderer.listen('document', subscription_model_1.CommunicationEvents.messageReceived, function () {
                return _this2.disableButton = false;
            });
        }
    }]);

    return SubscriptionCardComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], SubscriptionCardComponent.prototype, "card", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], SubscriptionCardComponent.prototype, "planSelect", void 0);
SubscriptionCardComponent = __decorate([core_1.Component({
    selector: 'subscription-card',
    template: __webpack_require__("./web/modern/components/subscription/modals/subscription-modal/subscription-card/subscription-card.html"),
    styles: [__webpack_require__("./web/modern/components/subscription/modals/subscription-modal/subscription-card/subscription-card.scss")]
}), __metadata("design:paramtypes", [core_1.Renderer2])], SubscriptionCardComponent);
exports.SubscriptionCardComponent = SubscriptionCardComponent;

/***/ }),

/***/ "./web/modern/components/subscription/modals/subscription-modal/subscription-modal.html":
/***/ (function(module, exports) {

module.exports = "<div *ngIf=\"showModalContent\" class=\"plan-modal\">\n    <div class=\"plan-modal-content\">\n\n        <div class=\"plan-modal--header\">\n            <div class=\"plan-modal--header__logo\"></div>\n            <div class=\"plan-modal--header__close-btn\">\n                <span (click)=\"closeModal()\" class=\"pointer\">&#10005;</span>\n            </div>\n            <h2 class=\"plan-modal--header__title\">{{ modalTitle }}</h2>\n        </div>\n        <div class=\"block-column_reverse\">\n            <div class=\"middle-block-column\">\n        <div class=\"plan-modal--buttons\" *ngIf=\"categoriesNames.length > 1\">\n            <subscription-period-change [categoryNames]=\"categoriesNames\"\n                                        [activeIndex]=\"activeIndex\"\n                                        (periodChangeEmitter)=\"changeSelectedCategory($event)\"></subscription-period-change>\n        </div>\n        <div class=\"plan-modal--subscription-cards flex flex-row flex-just-space-between\">\n            <div class=\"plan-modal--subscription-cards__card \"\n                 *ngFor=\"let card of selectedCategory\">\n                <subscription-card [card]=\"card\" (planSelect)=\"selectPlan($event)\"></subscription-card>\n            </div>\n        </div>\n        <div class=\"plan-modal--after-text\">\n            {{ priceExplanation }}\n        </div>\n            </div>\n        <div *ngIf=\"currencies\" class=\"plan-modal--select-block mt-20\">\n            <div class=\"plan-modal--select-block__wrapper\">\n                <div class=\"plan-modal--select-block__wrapper__header\">\n                    <h4 class=\"plan-modal--select-block__wrapper__header__select-label\">Show plans and pay in</h4>\n                </div>\n                <div class=\"select-style\">\n                    <select class=\"form-control\" [(ngModel)]=\"selectedCurrency\" (ngModelChange)=\"chooseCurrency($event)\">\n                        <option [ngValue]=\"currency\" *ngFor=\"let currency of currencies\">{{ currency.name }}</option>\n                    </select>\n                </div>\n            </div>\n        </div>\n        </div>\n        <div class=\"plan-modal--stay-on-trial\" *ngIf=\"modalActions.STAY_ON_FREE_TRIAL\">\n            <button class=\"btn btn-lg btn-default mb-0\" (click)=\"closeModal()\">{{ modalActions.STAY_ON_FREE_TRIAL.actionName }}</button>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "./web/modern/components/subscription/modals/subscription-modal/subscription-modal.scss":
/***/ (function(module, exports) {

module.exports = ".plan-modal {\n  position: relative; }\n  .plan-modal .plan-modal-content {\n    padding: 30px 35px; }\n  .plan-modal--header__logo {\n    display: block;\n    margin-left: -55px;\n    position: absolute;\n    top: -55px;\n    left: 50%;\n    width: 110px;\n    height: 110px;\n    background: #ffffff url(\"data:image/jpeg;base64,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\") no-repeat center;\n    border-radius: 50%; }\n  .plan-modal--header__close-btn {\n    color: #bfbec3;\n    font-size: 1.7rem;\n    position: absolute;\n    top: 8px;\n    right: 14px; }\n    .plan-modal--header__close-btn i {\n      cursor: pointer; }\n  .plan-modal--header__title {\n    text-align: center;\n    color: #22baa0;\n    margin: 25px 0; }\n  .plan-modal--buttons {\n    margin-top: 20px;\n    text-align: center; }\n  .plan-modal--subscription-cards {\n    margin-top: 20px; }\n    .plan-modal--subscription-cards__card {\n      border: 1px solid #bfbec3; }\n      .plan-modal--subscription-cards__card:not(:first-child) {\n        margin-left: 15px; }\n      .plan-modal--subscription-cards__card:hover {\n        border: 1px solid #22baa0;\n        box-shadow: 0 0 22px -10px #bfbec3; }\n  .plan-modal--after-text {\n    margin-top: 20px;\n    text-align: center;\n    font-size: 1rem;\n    color: #8e8e98; }\n  .plan-modal--stay-on-trial {\n    margin-top: 30px;\n    text-align: center; }\n  .plan-modal--select-block {\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    width: 100%;\n    -webkit-box-pack: end;\n    -webkit-justify-content: flex-end;\n        -ms-flex-pack: end;\n            justify-content: flex-end; }\n    .plan-modal--select-block__wrapper {\n      display: -webkit-box;\n      display: -webkit-flex;\n      display: -ms-flexbox;\n      display: flex;\n      width: 54%;\n      -webkit-box-pack: justify;\n      -webkit-justify-content: space-between;\n          -ms-flex-pack: justify;\n              justify-content: space-between; }\n      .plan-modal--select-block__wrapper__header {\n        width: 50%; }\n        .plan-modal--select-block__wrapper__header__select-label {\n          font-size: 13px;\n          font-weight: 400;\n          text-align: right; }\n      .plan-modal--select-block__wrapper .select-style {\n        width: 49%;\n        margin-left: 10px; }\n  @media (max-width: 670px) {\n    .plan-modal {\n      margin-top: 40px;\n      margin-bottom: 20px;\n      width: 330px; }\n      .plan-modal--subscription-cards {\n        -webkit-box-orient: vertical;\n        -webkit-box-direction: normal;\n        -webkit-flex-direction: column;\n            -ms-flex-direction: column;\n                flex-direction: column;\n        margin-top: 0; }\n        .plan-modal--subscription-cards__card {\n          margin-top: 10px;\n          width: 260px; }\n          .plan-modal--subscription-cards__card:not(:first-child) {\n            margin-left: 0; }\n      .plan-modal--select-block {\n        -webkit-box-pack: left;\n        -webkit-justify-content: left;\n            -ms-flex-pack: left;\n                justify-content: left; }\n        .plan-modal--select-block__wrapper {\n          width: 100% !important;\n          -webkit-flex-wrap: wrap;\n              -ms-flex-wrap: wrap;\n                  flex-wrap: wrap; }\n          .plan-modal--select-block__wrapper__header {\n            width: 100% !important; }\n            .plan-modal--select-block__wrapper__header__select-label {\n              text-align: left; }\n          .plan-modal--select-block__wrapper .select-style {\n            width: 100% !important;\n            margin-left: 0; }\n      .plan-modal .plan-modal--header__title {\n        margin-bottom: 0; }\n      .plan-modal .block-column_reverse {\n        display: -webkit-box;\n        display: -webkit-flex;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-orient: vertical;\n        -webkit-box-direction: reverse;\n        -webkit-flex-direction: column-reverse;\n            -ms-flex-direction: column-reverse;\n                flex-direction: column-reverse; }\n      .plan-modal .middle-block-column {\n        display: -webkit-box;\n        display: -webkit-flex;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-orient: vertical;\n        -webkit-box-direction: normal;\n        -webkit-flex-direction: column;\n            -ms-flex-direction: column;\n                flex-direction: column; } }\n  @media (max-width: 460px) {\n    .plan-modal {\n      margin-top: 0;\n      margin-bottom: 0;\n      width: 100vw; }\n      .plan-modal--header__logo {\n        top: 20px; }\n      .plan-modal--header__title {\n        margin-top: 100px; }\n      .plan-modal--header__close-btn {\n        top: 28px; }\n      .plan-modal--subscription-cards__card {\n        width: 100%; } }\n"

/***/ }),

/***/ "./web/modern/components/subscription/modals/subscription-modal/subscription-modal.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var subscription_model_1 = __webpack_require__("./shared/models/subscription.model.ts");
var subscription_service_1 = __webpack_require__("./shared/services/subscription/subscription.service.ts");
var iframe_service_1 = __webpack_require__("./shared/services/helpers/iframe-service/iframe.service.ts");
var ng_bootstrap_1 = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/index.js");
var SubscriptionModalComponent = function () {
    function SubscriptionModalComponent(subscriptionService, renderer, iframeService, activeModal) {
        _classCallCheck(this, SubscriptionModalComponent);

        this.subscriptionService = subscriptionService;
        this.renderer = renderer;
        this.iframeService = iframeService;
        this.activeModal = activeModal;
        this.selectedCategory = [];
        this.categoriesNames = [];
        this.currencies = [];
        this.activeIndex = 0;
        this.unsubscribe = new Subject_1.Subject();
    }

    _createClass(SubscriptionModalComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.getCachedCurrency();
            this.fetchSubscriptionPlans();
            this.onCheckoutPlanModalIframeOpen();
            this.onCheckoutPlanModalIframeClose();
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "closeModal",
        value: function closeModal() {
            this.clearCurrencyCache();
            this.clearUrlCache();
            this.subscriptionService.setChoosePlanOpenModalStatus({
                state: false,
                payload: null
            });
            this.activeModal.dismiss();
        }
    }, {
        key: "changeSelectedCategory",
        value: function changeSelectedCategory(_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
                category = _ref2[0],
                index = _ref2[1];

            this.changeActiveCategory(category);
            this.activeIndex = index;
        }
    }, {
        key: "selectPlan",
        value: function selectPlan(plan) {
            this.iframeService.setUrlIframe(plan.actions.SELECT_PLAN.url);
        }
    }, {
        key: "changeActiveCategory",
        value: function changeActiveCategory(category) {
            this.selectedCategory = this.categories[category];
        }
    }, {
        key: "fetchSubscriptionPlans",
        value: function fetchSubscriptionPlans() {
            var _this = this;

            this.subscriptionService.getSubscriptions(this.urlToLoad, this.selectedCurrencyUrl).pipe(operators_1.takeUntil(this.unsubscribe), operators_1.map(function (data) {
                return data.data;
            })).subscribe(function (data) {
                return _this.successGetSubscriptionPlans(data);
            });
        }
    }, {
        key: "successGetSubscriptionPlans",
        value: function successGetSubscriptionPlans(data) {
            var categories = Object.keys(data.category);
            this.currencies = data.currencies;
            if (this.currencies) {
                var _currencies$filter = this.currencies.filter(function (currency) {
                    if (currency.selected) {
                        return currency;
                    }
                }),
                    _currencies$filter2 = _slicedToArray(_currencies$filter, 1),
                    selectedCurrency = _currencies$filter2[0];

                this.selectedCurrency = selectedCurrency;
            }
            this.categories = data.category;
            this.categoriesLength = categories.length;
            this.selectedCategory = this.categories[Object.keys(this.categories)[0]];
            this.categoriesNames = categories;
            this.modalTitle = data.title;
            this.priceExplanation = data.priceComment;
            this.modalActions = data.actions;
            this.showModal();
        }
    }, {
        key: "chooseCurrency",
        value: function chooseCurrency(event) {
            this.cacheCurrency(event);
            this.selectedCurrency = event;
            this.selectedCurrencyUrl = this.selectedCurrency.currencyType;
            this.activeIndex = 0;
            this.fetchSubscriptionPlans();
        }
    }, {
        key: "getCachedCurrency",
        value: function getCachedCurrency() {
            var currency = sessionStorage.getItem('cachedCurrency');
            if (currency) {
                this.selectedCurrency = JSON.parse(currency);
                this.selectedCurrencyUrl = this.selectedCurrency.currencyType;
            }
        }
    }, {
        key: "cacheCurrency",
        value: function cacheCurrency(currency) {
            sessionStorage.setItem('cachedCurrency', JSON.stringify(currency));
        }
    }, {
        key: "clearCurrencyCache",
        value: function clearCurrencyCache() {
            sessionStorage.removeItem('cachedCurrency');
        }
    }, {
        key: "clearUrlCache",
        value: function clearUrlCache() {
            sessionStorage.removeItem('cachedUrl');
        }
    }, {
        key: "showModal",
        value: function showModal() {
            this.showModalContent = true;
        }
    }, {
        key: "unsubscribeIframeEvents",
        value: function unsubscribeIframeEvents() {
            this.iframeOpenEvent();
            this.iframeCloseEvent();
        }
    }, {
        key: "onCheckoutPlanModalIframeOpen",
        value: function onCheckoutPlanModalIframeOpen() {
            this.iframeOpenEvent = this.renderer.listen('document', subscription_model_1.CommunicationEvents.planCheckoutOpen, function () {});
        }
    }, {
        key: "onCheckoutPlanModalIframeClose",
        value: function onCheckoutPlanModalIframeClose() {
            var _this2 = this;

            this.iframeCloseEvent = this.renderer.listen('document', subscription_model_1.CommunicationEvents.planCheckoutClose, function () {
                _this2.unsubscribeIframeEvents();
                _this2.iframeService.setUrlIframe(null);
            });
        }
    }]);

    return SubscriptionModalComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", String)], SubscriptionModalComponent.prototype, "urlToLoad", void 0);
SubscriptionModalComponent = __decorate([core_1.Component({
    selector: 'subscription-modal',
    template: __webpack_require__("./web/modern/components/subscription/modals/subscription-modal/subscription-modal.html"),
    styles: [__webpack_require__("./web/modern/components/subscription/modals/subscription-modal/subscription-modal.scss")]
}), __metadata("design:paramtypes", [subscription_service_1.NewSubscriptionServiceDataProvider, core_1.Renderer2, iframe_service_1.IframeService, ng_bootstrap_1.NgbActiveModal])], SubscriptionModalComponent);
exports.SubscriptionModalComponent = SubscriptionModalComponent;

/***/ }),

/***/ "./web/modern/components/subscription/modals/subscription-modal/subscription-period-change/subscription-period-change.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"btn-group btn-group-toggle\" data-toggle=\"buttons\">\n  <label (click)=\"emitPeriodChange(period,i)\" *ngFor=\"let period of categoryNames; let i = index\" [class.active]=\"i === activeIndex\" class=\"btn btn-secondary\">\n    <input type=\"radio\" name=\"options\" id=\"{{period}}\"> {{ period }}\n  </label>\n</div>\n"

/***/ }),

/***/ "./web/modern/components/subscription/modals/subscription-modal/subscription-period-change/subscription-period-change.scss":
/***/ (function(module, exports) {

module.exports = ".btn-group.btn-group-toggle .btn {\n  border: 1px solid #dddddd;\n  color: #dddddd;\n  padding: 3px 12px;\n  min-width: 80px; }\n  .btn-group.btn-group-toggle .btn.active {\n    color: #252525; }\n\n@media (max-width: 670px) {\n  .btn-group.btn-group-toggle {\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-flex-wrap: wrap;\n        -ms-flex-wrap: wrap;\n            flex-wrap: wrap;\n    -webkit-box-pack: center;\n    -webkit-justify-content: center;\n        -ms-flex-pack: center;\n            justify-content: center; } }\n"

/***/ }),

/***/ "./web/modern/components/subscription/modals/subscription-modal/subscription-period-change/subscription-period-change.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var SubscriptionPeriodChangeComponent = function () {
    function SubscriptionPeriodChangeComponent() {
        _classCallCheck(this, SubscriptionPeriodChangeComponent);

        this.activeIndex = 0;
        this.periodChangeEmitter = new core_1.EventEmitter();
    }

    _createClass(SubscriptionPeriodChangeComponent, [{
        key: "emitPeriodChange",
        value: function emitPeriodChange(period, i) {
            this.periodChangeEmitter.next([period, i]);
        }
    }]);

    return SubscriptionPeriodChangeComponent;
}();
__decorate([core_1.Input(), __metadata("design:type", Object)], SubscriptionPeriodChangeComponent.prototype, "categoryNames", void 0);
__decorate([core_1.Input(), __metadata("design:type", Object)], SubscriptionPeriodChangeComponent.prototype, "activeIndex", void 0);
__decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], SubscriptionPeriodChangeComponent.prototype, "periodChangeEmitter", void 0);
SubscriptionPeriodChangeComponent = __decorate([core_1.Component({
    selector: 'subscription-period-change',
    template: __webpack_require__("./web/modern/components/subscription/modals/subscription-modal/subscription-period-change/subscription-period-change.html"),
    styles: [__webpack_require__("./web/modern/components/subscription/modals/subscription-modal/subscription-period-change/subscription-period-change.scss")]
}), __metadata("design:paramtypes", [])], SubscriptionPeriodChangeComponent);
exports.SubscriptionPeriodChangeComponent = SubscriptionPeriodChangeComponent;

/***/ }),

/***/ "./web/modern/components/subscription/subscription-announcement-banner/subscription-announcement-banner.html":
/***/ (function(module, exports) {

module.exports = "<carousel *ngIf=\"announcementData\" class=\"not-print \">\n        <slide class=\"text-center py-5 text-white\" *ngFor=\"let action of actionList; let i = index\">\n\n            <div *ngIf=\"announcementData[i].actions[action]\">\n                <span class=\"hidden-xs\">{{ announcementData[i].description }}</span>\n                <button (click)=\"reactToButtonClick(announcementData[i].actions[action], action)\"\n                        [is-spinning-wheel-active]=\"disableButton\"\n                        [ngStyle]=\"{'background': announcementData[i].actions[action].buttonProperties.backgroundHexColor}\"\n                        class=\"btn\" spinning-wheel>{{ announcementData[i].actions[action].actionName }}\n                </button>\n            </div>\n        </slide>\n</carousel>\n"

/***/ }),

/***/ "./web/modern/components/subscription/subscription-announcement-banner/subscription-announcement-banner.scss":
/***/ (function(module, exports) {

module.exports = "carousel {\n  padding-top: 17px;\n  padding-bottom: 8px;\n  background: rgba(0, 0, 0, 0.7);\n  position: fixed;\n  bottom: 0;\n  min-height: 70px;\n  color: white;\n  width: 100%;\n  text-align: center;\n  z-index: 100; }\n  carousel span {\n    vertical-align: top;\n    font-size: 16px;\n    line-height: 36px;\n    color: white; }\n\n.btn {\n  vertical-align: top;\n  font-size: 14px;\n  color: white;\n  padding: 7px 20px;\n  border-radius: 20px; }\n  @media (min-width: 768px) {\n    .btn {\n      margin-left: 15px; } }\n\n::ng-deep .carousel-control {\n  background-image: none !important;\n  min-width: 20px;\n  width: 30px;\n  cursor: pointer; }\n\n::ng-deep .carousel-control-prev {\n  margin-left: 7%; }\n\n::ng-deep .carousel-control-next {\n  margin-right: 7%; }\n\n::ng-deep .icon-next {\n  margin-top: -21px !important; }\n\n::ng-deep .icon-prev {\n  margin-top: -21px !important; }\n\n::ng-deep .carousel-control .icon-next:before {\n  font: normal normal normal 36px/1 studioninja;\n  content: '\\e946'; }\n\n::ng-deep .carousel-control .icon-prev:before {\n  font: normal normal normal 34px/1 studioninja;\n  content: '\\e941'; }\n"

/***/ }),

/***/ "./web/modern/components/subscription/subscription-announcement-banner/subscription-announcement-banner.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var subscription_service_1 = __webpack_require__("./shared/services/subscription/subscription.service.ts");
var subscription_model_1 = __webpack_require__("./shared/models/subscription.model.ts");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var iframe_service_1 = __webpack_require__("./shared/services/helpers/iframe-service/iframe.service.ts");
var confirm_general_modal_component_1 = __webpack_require__("./web/modern/components/common/confirm-general-modal/confirm-general-modal.component.ts");
var carousel_1 = __webpack_require__("./node_modules/ngx-bootstrap/carousel/fesm5/ngx-bootstrap-carousel.js");
var SubscriptionAnnouncementBannerComponent = function () {
    function SubscriptionAnnouncementBannerComponent(subscriptionService, snModalService, iframeService, renderer) {
        _classCallCheck(this, SubscriptionAnnouncementBannerComponent);

        this.subscriptionService = subscriptionService;
        this.snModalService = snModalService;
        this.iframeService = iframeService;
        this.renderer = renderer;
        this.actionList = [];
    }

    _createClass(SubscriptionAnnouncementBannerComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.attachEventHandlers();
            this.getAnnouncementData();
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.detachEventListeners();
        }
    }, {
        key: "loadIframe",
        value: function loadIframe(url) {
            this.disableButton = true;
            this.iframeService.setUrlIframe(url);
        }
    }, {
        key: "openNewWindow",
        value: function openNewWindow(url) {
            window.open(url, '_blank');
        }
    }, {
        key: "reactToButtonClick",
        value: function reactToButtonClick(action, actionName) {
            switch (action.method) {
                case 'NEW_WINDOW':
                    return this.openNewWindow(action.url);
                case 'FRAME':
                    return this.loadIframe(action.url);
                case 'ALERT_MODAL':
                    return this.openAlertModal(action.alertMessage);
            }
            if (action.method === 'MANUAL' && actionName === 'CHOOSE_PLAN') {
                this.openChoosePlanModal();
            }
        }
    }, {
        key: "openChoosePlanModal",
        value: function openChoosePlanModal() {
            this.subscriptionService.setChoosePlanOpenModalStatus({
                state: true,
                payload: null
            });
        }
    }, {
        key: "attachEventHandlers",
        value: function attachEventHandlers() {
            this.onConfirmPaymentPaymentOpen();
            this.onCheckoutOpenEvent();
            this.onEditBillingModalIframeOpen();
            this.onUpdatePaymentClose();
        }
    }, {
        key: "detachEventListeners",
        value: function detachEventListeners() {
            this.checkoutPlanOpenEvent();
            this.confirmPaymentOpenEvent();
            this.billingOpenEvent();
            this.updateOpenEvent();
        }
    }, {
        key: "getAnnouncementData",
        value: function getAnnouncementData() {
            var _this = this;

            this.subscriptionService.subscriptionData.subscribe(function (data) {
                if (data && data.announcements && data.announcements.length) {
                    _this.announcementData = data.announcements;
                    _this.actionList = _this.announcementData.reduce(function (total, next) {
                        var _iteratorNormalCompletion = true;
                        var _didIteratorError = false;
                        var _iteratorError = undefined;

                        try {
                            for (var _iterator = _this.subscriptionService.createActionList(next.actions)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                var action = _step.value;

                                var actionMethod = next.actions[action].method;
                                if (actionMethod !== 'MANUAL') {
                                    total.push(action);
                                } else if (action === 'CHOOSE_PLAN' && actionMethod === 'MANUAL') {
                                    total.push(action);
                                }
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }
                            } finally {
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }

                        return total;
                    }, []);
                } else {
                    _this.announcementData = null;
                }
            });
        }
    }, {
        key: "openAlertModal",
        value: function openAlertModal(alert) {
            var message = alert.message,
                title = alert.title;

            var modal = this.snModalService.openModal(confirm_general_modal_component_1.ConfirmGeneralModalComponent, {
                windowClass: 'ng-bootstrap-modal modal-visible modal-narrow'
            });
            if (title) {
                modal.componentInstance.title = title;
            }
            modal.componentInstance.text = message;
            modal.componentInstance.buttons = [{
                text: 'Got it',
                action: 'CLOSE',
                color: 'default',
                size: 'lg'
            }];
        }
    }, {
        key: "onConfirmPaymentPaymentOpen",
        value: function onConfirmPaymentPaymentOpen() {
            var _this2 = this;

            this.confirmPaymentOpenEvent = this.renderer.listen('document', subscription_model_1.CommunicationEvents.confirmPaymentOpen, function () {
                _this2.disableButton = false;
            });
        }
    }, {
        key: "onCheckoutOpenEvent",
        value: function onCheckoutOpenEvent() {
            var _this3 = this;

            this.checkoutPlanOpenEvent = this.renderer.listen('document', subscription_model_1.CommunicationEvents.planCheckoutOpen, function () {
                _this3.disableButton = false;
            });
        }
    }, {
        key: "onEditBillingModalIframeOpen",
        value: function onEditBillingModalIframeOpen() {
            var _this4 = this;

            this.billingOpenEvent = this.renderer.listen('document', subscription_model_1.CommunicationEvents.billingUpdateOpen, function () {
                _this4.disableButton = false;
            });
        }
    }, {
        key: "onUpdatePaymentClose",
        value: function onUpdatePaymentClose() {
            var _this5 = this;

            this.updateOpenEvent = this.renderer.listen('document', subscription_model_1.CommunicationEvents.updatePaymentOpen, function () {
                _this5.disableButton = false;
            });
        }
    }]);

    return SubscriptionAnnouncementBannerComponent;
}();
SubscriptionAnnouncementBannerComponent = __decorate([core_1.Component({
    selector: 'subscription-announcement-banner',
    template: __webpack_require__("./web/modern/components/subscription/subscription-announcement-banner/subscription-announcement-banner.html"),
    styles: [__webpack_require__("./web/modern/components/subscription/subscription-announcement-banner/subscription-announcement-banner.scss")],
    providers: [{
        provide: carousel_1.CarouselConfig,
        useValue: { interval: 60000, noPause: false, showIndicators: false }
    }]
}), __metadata("design:paramtypes", [subscription_service_1.NewSubscriptionServiceDataProvider, snModal_service_1.SNModalService, iframe_service_1.IframeService, core_1.Renderer2])], SubscriptionAnnouncementBannerComponent);
exports.SubscriptionAnnouncementBannerComponent = SubscriptionAnnouncementBannerComponent;

/***/ }),

/***/ "./web/modern/components/subscription/subscription-choose-plan/subscription-choose-plan.html":
/***/ (function(module, exports) {

module.exports = "\n\n\n"

/***/ }),

/***/ "./web/modern/components/subscription/subscription-choose-plan/subscription-choose-plan.scss":
/***/ (function(module, exports) {

module.exports = ""

/***/ }),

/***/ "./web/modern/components/subscription/subscription-choose-plan/subscription-choose-plan.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var common_1 = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var subscription_modal_1 = __webpack_require__("./web/modern/components/subscription/modals/subscription-modal/subscription-modal.ts");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var subscription_model_1 = __webpack_require__("./shared/models/subscription.model.ts");
var iframe_service_1 = __webpack_require__("./shared/services/helpers/iframe-service/iframe.service.ts");
var subscription_service_1 = __webpack_require__("./shared/services/subscription/subscription.service.ts");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var brands_data_service_1 = __webpack_require__("./shared/services/brands/brands.data.service.ts");
var account_service_1 = __webpack_require__("./web/modern/services/user/account.service.ts");
var SubscriptionChoosePlanComponent = function () {
    function SubscriptionChoosePlanComponent(snModalService, iframeService, renderer, subscriptionService, messageService, brandsDataService, accountService, location) {
        _classCallCheck(this, SubscriptionChoosePlanComponent);

        this.snModalService = snModalService;
        this.iframeService = iframeService;
        this.renderer = renderer;
        this.subscriptionService = subscriptionService;
        this.messageService = messageService;
        this.brandsDataService = brandsDataService;
        this.accountService = accountService;
        this.location = location;
        this.unsubscribe = new Subject_1.Subject();
    }

    _createClass(SubscriptionChoosePlanComponent, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            this.attachFrameHandlers();
            this.listenForModalOpen();
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.unsubscribe.next();
            this.unsubscribe.complete();
        }
    }, {
        key: "openModal",
        value: function openModal(url) {
            this.modalRef = this.snModalService.openModal(subscription_modal_1.SubscriptionModalComponent, {
                windowClass: 'ng-bootstrap-modal choose-plan-modal modal-liquid'
            });
            this.modalRef.componentInstance.urlToLoad = url;
        }
    }, {
        key: "attachFrameHandlers",
        value: function attachFrameHandlers() {
            this.onCheckoutModalBackEvent();
            this.onCheckoutModalOpenEvent();
            this.onCheckoutModalCloseEvent();
            this.onConfirmPaymentClose();
            this.onEditBillingModalIframeClose();
            this.onMessageReceived();
            this.onUpdatePaymentClose();
        }
    }, {
        key: "listenForModalOpen",
        value: function listenForModalOpen() {
            var _this = this;

            this.subscriptionService.choosePlanModalOpenStatus.pipe(operators_1.tap(function (data) {
                if (data.payload) {
                    _this.urlToLoad = data.payload.url;
                    sessionStorage.setItem('cachedUrl', data.payload.url);
                }
                _this.getCachedUrl();
            }), operators_1.map(function (data) {
                return data.state;
            }), operators_1.distinctUntilChanged()).subscribe(function (state) {
                if (state) {
                    _this.openModal(_this.urlToLoad);
                }
            });
        }
    }, {
        key: "successPaymentProcessed",
        value: function successPaymentProcessed(data) {
            var _this2 = this;

            if (data) {
                var needToConfirmPayment = data.data.actions.COMPLETE_PAYMENT;
                if (needToConfirmPayment) {
                    this.messageService.showToaster('i_0', 'stripe');
                    this.iframeService.setUrlIframe(null);
                    setTimeout(function () {
                        return _this2.iframeService.setUrlIframe(needToConfirmPayment.url);
                    }, 0);
                } else {
                    var planName = data.data.currentPlan.planName || 'new plan';
                    this.messageService.showToaster('s_0', 'subscription', planName);
                    this.iframeService.setUrlIframe(null);
                    this.accountService.getUserWeb().subscribe(function () {
                        _this2.brandsDataService.updateBrands().subscribe();
                        _this2.redirectIfOnLogin();
                    });
                }
                this.subscriptionService.setSubscriptionData(data.data);
                this.clearCurrencyCache();
                this.clearUrlCache();
            }
        }
    }, {
        key: "redirectIfOnLogin",
        value: function redirectIfOnLogin() {
            if (this.location.path(false) === '/login') {
                this.accountService.emitUserLoginAction(true);
            }
        }
    }, {
        key: "getCachedUrl",
        value: function getCachedUrl() {
            var url = void 0;
            try {
                url = JSON.parse(sessionStorage.getItem('cachedUrl'));
            } catch (error) {
                url = sessionStorage.getItem('cachedUrl');
            }
            if (url) {
                this.urlToLoad = url;
            } else {
                this.urlToLoad = null;
            }
        }
    }, {
        key: "onCheckoutModalBackEvent",
        value: function onCheckoutModalBackEvent() {
            var _this3 = this;

            this.renderer.listen('document', subscription_model_1.CommunicationEvents.planCheckoutBack, function () {
                _this3.iframeService.setUrlIframe(null);
                _this3.subscriptionService.setChoosePlanOpenModalStatus({
                    state: true,
                    payload: {
                        url: _this3.urlToLoad
                    }
                });
            });
        }
    }, {
        key: "onCheckoutModalOpenEvent",
        value: function onCheckoutModalOpenEvent() {
            var _this4 = this;

            this.renderer.listen('document', subscription_model_1.CommunicationEvents.planCheckoutOpen, function () {
                if (_this4.modalRef) {
                    _this4.subscriptionService.setChoosePlanOpenModalStatus({
                        state: false,
                        payload: null
                    });
                    _this4.modalRef.close();
                }
            });
        }
    }, {
        key: "onCheckoutModalCloseEvent",
        value: function onCheckoutModalCloseEvent() {
            var _this5 = this;

            this.renderer.listen('document', subscription_model_1.CommunicationEvents.planCheckoutClose, function (data) {
                return _this5.successPaymentProcessed(data.detail.data);
            });
        }
    }, {
        key: "onConfirmPaymentClose",
        value: function onConfirmPaymentClose() {
            var _this6 = this;

            this.renderer.listen('document', subscription_model_1.CommunicationEvents.confirmPaymentClose, function (data) {
                if (data.detail.paymentIntent) {
                    _this6.subscriptionService.fetchSubscriptionStatus().pipe(operators_1.finalize(function () {
                        return _this6.iframeService.setUrlIframe(null);
                    })).subscribe(function (data) {
                        _this6.successPaymentProcessed({ data: data, result: 'ok' });
                    });
                } else {
                    _this6.messageService.showToaster('e_8', 'stripe');
                    _this6.iframeService.setUrlIframe(null);
                }
            });
        }
    }, {
        key: "onEditBillingModalIframeClose",
        value: function onEditBillingModalIframeClose() {
            var _this7 = this;

            this.renderer.listen('document', subscription_model_1.CommunicationEvents.billingUpdateClose, function (data) {
                _this7.iframeService.setUrlIframe(null);
                var status = data.detail.data;
                if (status) {
                    _this7.messageService.showToaster('i_1', 'subscription', 'current');
                    _this7.subscriptionService.setSubscriptionData(status.data);
                }
            });
        }
    }, {
        key: "onMessageReceived",
        value: function onMessageReceived() {
            var _this8 = this;

            this.renderer.listen('document', subscription_model_1.CommunicationEvents.messageReceived, function (data) {
                _this8.iframeService.setUrlIframe(null);
                var status = data.detail;
                if (status) {
                    _this8.messageService.showMessageFromBackend(status.messageType, status.title, status.text);
                }
            });
        }
    }, {
        key: "onUpdatePaymentClose",
        value: function onUpdatePaymentClose() {
            var _this9 = this;

            this.renderer.listen('document', subscription_model_1.CommunicationEvents.updatePaymentClose, function (data) {
                var status = data.detail.data;
                if (!status) {
                    _this9.iframeService.setUrlIframe(null);
                    return;
                }
                if (status.error) {
                    _this9.messageService.showToaster('e_8', 'stripe');
                    _this9.iframeService.setUrlIframe(null);
                    return;
                }
                if (status.paymentIntent && status.paymentIntent.status === 'succeeded') {
                    _this9.subscriptionService.fetchSubscriptionStatus().pipe(operators_1.finalize(function () {
                        return _this9.iframeService.setUrlIframe(null);
                    })).subscribe(function (data) {
                        _this9.successPaymentProcessed({ data: data, result: 'ok' });
                    });
                }
            });
        }
    }, {
        key: "clearCurrencyCache",
        value: function clearCurrencyCache() {
            sessionStorage.removeItem('cachedCurrency');
        }
    }, {
        key: "clearUrlCache",
        value: function clearUrlCache() {
            sessionStorage.removeItem('cachedUrl');
        }
    }]);

    return SubscriptionChoosePlanComponent;
}();
SubscriptionChoosePlanComponent = __decorate([core_1.Component({
    selector: 'subscription-choose-plan',
    template: __webpack_require__("./web/modern/components/subscription/subscription-choose-plan/subscription-choose-plan.html"),
    styles: [__webpack_require__("./web/modern/components/subscription/subscription-choose-plan/subscription-choose-plan.scss")]
}), __metadata("design:paramtypes", [snModal_service_1.SNModalService, iframe_service_1.IframeService, core_1.Renderer2, subscription_service_1.NewSubscriptionServiceDataProvider, message_service_1.MessageService, brands_data_service_1.BrandsDataServiceProvider, account_service_1.AccountServiceWebProvider, common_1.Location])], SubscriptionChoosePlanComponent);
exports.SubscriptionChoosePlanComponent = SubscriptionChoosePlanComponent;

/***/ }),

/***/ "./web/modern/directives/AmountValidation/amountValidation.directive.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var stringModifier_service_1 = __webpack_require__("./shared/services/helpers/string-modifier-service/stringModifier.service.ts");
var common_1 = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
var AmountValidationDirective = function () {
    function AmountValidationDirective(element, stringModifier, decimalPipe) {
        _classCallCheck(this, AmountValidationDirective);

        this.element = element;
        this.stringModifier = stringModifier;
        this.decimalPipe = decimalPipe;
    }

    _createClass(AmountValidationDirective, [{
        key: "onInputChange",
        value: function onInputChange() {
            var changedValue = this.stringModifier.convertAmountIntoNumber(this.element.nativeElement.value);
            this.showValidation(changedValue);
        }
    }, {
        key: "showValidation",
        value: function showValidation(inputValue) {
            var nativeElement = this.element.nativeElement;
            var maxValueConvert = this.decimalPipe.transform(this.maxValue, '1.0-2');
            if (inputValue > this.maxValue || inputValue === 0) {
                nativeElement.setCustomValidity("You must record an amount that is equal to or less than " + maxValueConvert + " ");
            } else {
                nativeElement.setCustomValidity('');
            }
        }
    }, {
        key: "maxValue",
        set: function set(value) {
            this._maxValue = value;
            this.showValidation(value);
        },
        get: function get() {
            return this._maxValue;
        }
    }]);

    return AmountValidationDirective;
}();
__decorate([core_1.Input('amountValidation'), __metadata("design:type", Number), __metadata("design:paramtypes", [Number])], AmountValidationDirective.prototype, "maxValue", null);
__decorate([core_1.HostListener('input', ['$event']), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", void 0)], AmountValidationDirective.prototype, "onInputChange", null);
AmountValidationDirective = __decorate([core_1.Directive({
    selector: '[amountValidation]'
}), __metadata("design:paramtypes", [core_1.ElementRef, stringModifier_service_1.StringModifierServiceProvider, common_1.DecimalPipe])], AmountValidationDirective);
exports.AmountValidationDirective = AmountValidationDirective;

/***/ }),

/***/ "./web/modern/directives/ElemToScroll/elemToScroll.directive.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var ElemToScrollDirective = function () {
    function ElemToScrollDirective(element) {
        _classCallCheck(this, ElemToScrollDirective);

        this.element = element;
        this.wasScrolled = false;
        this.scrollHash = localStorage.getItem('keyToScroll');
    }

    _createClass(ElemToScrollDirective, [{
        key: "ngOnInit",
        value: function ngOnInit() {
            var _this = this;

            if (this.scrollHash !== this.elemToScroll) {
                return;
            }
            if (!this.wasScrolled) {
                this.wasScrolled = true;
                // setTimeout with magic 500ms to compensate DOM redrawing time and get right position
                setTimeout(function () {
                    var nativeElem = _this.element.nativeElement;
                    var topScroll = nativeElem.getBoundingClientRect().top;
                    // 115 - height of header and padding to not stick header with element
                    document.documentElement.scrollTop = topScroll - 115;
                    localStorage.removeItem('keyToScroll');
                }, 500);
            }
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            this.wasScrolled = false;
        }
    }]);

    return ElemToScrollDirective;
}();
__decorate([core_1.Input(), __metadata("design:type", String)], ElemToScrollDirective.prototype, "elemToScroll", void 0);
ElemToScrollDirective = __decorate([core_1.Directive({
    selector: '[elemToScroll]'
}), __metadata("design:paramtypes", [core_1.ElementRef])], ElemToScrollDirective);
exports.ElemToScrollDirective = ElemToScrollDirective;

/***/ }),

/***/ "./web/modern/directives/iframe-resizer/iframe-resizer.directive.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var iframe_resizer_1 = __webpack_require__("./node_modules/iframe-resizer/index.js");
var IframeResizerDirective = function () {
    function IframeResizerDirective(element) {
        _classCallCheck(this, IframeResizerDirective);

        this.element = element;
    }

    _createClass(IframeResizerDirective, [{
        key: "ngAfterViewInit",
        value: function ngAfterViewInit() {
            var components = iframe_resizer_1.iframeResizer({
                log: false
            }, this.element.nativeElement);
            /* save component reference so we can close it later */
            this.component = components && components.length > 0 ? components[0] : null;
        }
    }, {
        key: "ngOnDestroy",
        value: function ngOnDestroy() {
            if (this.component && this.component.iFrameResizer) {
                this.component.iFrameResizer.close();
            }
        }
    }]);

    return IframeResizerDirective;
}();
IframeResizerDirective = __decorate([core_1.Directive({
    selector: '[snIframeResizer]'
}), __metadata("design:paramtypes", [core_1.ElementRef])], IframeResizerDirective);
exports.IframeResizerDirective = IframeResizerDirective;

/***/ }),

/***/ "./web/modern/directives/sn-date-picker-validator/sn-date-picker-validator.directive.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var SnDatePickerValidatorDirective = function () {
    function SnDatePickerValidatorDirective(el) {
        _classCallCheck(this, SnDatePickerValidatorDirective);

        this.element = el;
    }

    _createClass(SnDatePickerValidatorDirective, [{
        key: "onDateChanged",
        value: function onDateChanged(event) {
            var datepicker = this.element.nativeElement.querySelector('input[ngtype="text"]');
            if (datepicker) {
                if (!event.valid) {
                    datepicker.setCustomValidity('Please provide a date in the right format.');
                } else {
                    datepicker.setCustomValidity('');
                }
            }
        }
    }]);

    return SnDatePickerValidatorDirective;
}();
__decorate([core_1.HostListener('inputFieldChanged', ['$event']), __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", void 0)], SnDatePickerValidatorDirective.prototype, "onDateChanged", null);
SnDatePickerValidatorDirective = __decorate([core_1.Directive({
    selector: '[snDatePickerValidator]'
}), __metadata("design:paramtypes", [core_1.ElementRef])], SnDatePickerValidatorDirective);
exports.SnDatePickerValidatorDirective = SnDatePickerValidatorDirective;

/***/ }),

/***/ "./web/modern/interceptors/browserSessionToken.interceptor.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var uuid_1 = __webpack_require__("./node_modules/uuid/dist/esm-browser/index.js");
var auth_tokens_service_1 = __webpack_require__("./web/modern/auth-tokens.service.ts");
var BrowserSessionTokenInterceptor = function () {
    function BrowserSessionTokenInterceptor(authTokensService) {
        _classCallCheck(this, BrowserSessionTokenInterceptor);

        this.authTokensService = authTokensService;
        this.sessionToken = uuid_1.v4();
        this.browserToken = localStorage.getItem('BrowserToken');
        if (!this.browserToken) {
            localStorage.setItem('BrowserToken', uuid_1.v4());
        }
    }

    _createClass(BrowserSessionTokenInterceptor, [{
        key: "intercept",
        value: function intercept(req, next) {
            this.cloned = req;
            var photographerEmailToken = localStorage.getItem('PhotographerEmail');
            if (this.authTokensService.isToken(req.url, this.sessionToken)) {
                if (this.sessionToken) {
                    this.cloned = req.clone({
                        headers: req.headers.set('SessionToken', this.sessionToken)
                    });
                }
            }
            if (this.authTokensService.isToken(req.url, this.browserToken)) {
                if (this.browserToken) {
                    this.cloned = this.cloned.clone({
                        headers: this.cloned.headers.set('BrowserToken', this.browserToken)
                    });
                }
            }
            if (this.authTokensService.isToken(req.url, photographerEmailToken)) {
                if (photographerEmailToken) {
                    this.cloned = this.cloned.clone({
                        headers: this.cloned.headers.set('PhotographerEmail', photographerEmailToken)
                    });
                }
            }
            return next.handle(this.cloned);
        }
    }]);

    return BrowserSessionTokenInterceptor;
}();
BrowserSessionTokenInterceptor = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [auth_tokens_service_1.AuthTokensService])], BrowserSessionTokenInterceptor);
exports.BrowserSessionTokenInterceptor = BrowserSessionTokenInterceptor;

/***/ }),

/***/ "./web/modern/interceptors/systemNotification.interceptor.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var Observable_1 = __webpack_require__("./node_modules/rxjs/Observable.js");
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var auth_tokens_service_1 = __webpack_require__("./web/modern/auth-tokens.service.ts");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var system_notifications_service_1 = __webpack_require__("./shared/services/system-notifications/system-notifications.service.ts");
var account_service_1 = __webpack_require__("./web/modern/services/user/account.service.ts");
var appConstants_1 = __webpack_require__("./shared/models/appConstants.ts");
var SystemNotificationInterceptor = function () {
    function SystemNotificationInterceptor(authTokensService, systemNotificationsService, accountService) {
        _classCallCheck(this, SystemNotificationInterceptor);

        this.authTokensService = authTokensService;
        this.systemNotificationsService = systemNotificationsService;
        this.accountService = accountService;
    }

    _createClass(SystemNotificationInterceptor, [{
        key: "intercept",
        value: function intercept(req, next) {
            var _this = this;

            this.clonedReq = req;
            var windowVariable = appConstants_1.AppConstants.WEB_BUILD_VERSION;
            this.clonedReq = req.clone({
                headers: req.headers.set('WebBuildVersion', windowVariable)
            });
            return next.handle(this.clonedReq).pipe(operators_1.tap(function (resp) {
                return _this.checkLastSystemNotificationId(resp);
            }), operators_1.catchError(function (err) {
                return Observable_1.Observable.throw(err);
            }));
        }
    }, {
        key: "checkLastSystemNotificationId",
        value: function checkLastSystemNotificationId(req) {
            var headers = req.headers;

            if (headers) {
                if (headers.has('last-system-notification-id')) {
                    var currentSystemNotificationId = headers.get('last-system-notification-id');
                    this.lastSystemNotificationId = localStorage.getItem('lastSystemNotificationId');
                    if (this.authTokensService.getAuthToken() && this.accountService.isAdmin() === false) {
                        if (currentSystemNotificationId !== this.lastSystemNotificationId) {
                            this.systemNotificationsService.fetchSystemNotificationsData().subscribe(function (data) {
                                return data;
                            });
                            localStorage.setItem('lastSystemNotificationId', currentSystemNotificationId || '');
                        }
                    }
                }
            }
        }
    }]);

    return SystemNotificationInterceptor;
}();
SystemNotificationInterceptor = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [auth_tokens_service_1.AuthTokensService, system_notifications_service_1.SystemNotificationsServiceDataProvider, account_service_1.AccountServiceWebProvider])], SystemNotificationInterceptor);
exports.SystemNotificationInterceptor = SystemNotificationInterceptor;

/***/ }),

/***/ "./web/modern/interceptors/twoFa.interceptor.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var Observable_1 = __webpack_require__("./node_modules/rxjs/Observable.js");
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var two_fa_authentication_data_service_1 = __webpack_require__("./shared/services/user/two-fa-authentication.data.service.ts");
var TwoFactorAuthorizationInterceptor = function () {
    function TwoFactorAuthorizationInterceptor(twoFaAuthenticationService) {
        _classCallCheck(this, TwoFactorAuthorizationInterceptor);

        this.twoFaAuthenticationService = twoFaAuthenticationService;
    }

    _createClass(TwoFactorAuthorizationInterceptor, [{
        key: "intercept",
        value: function intercept(req, next) {
            var _this = this;

            return next.handle(req).catch(function (err) {
                return _this.handleTwoFaProcess(err, req);
            });
        }
    }, {
        key: "handleTwoFaProcess",
        value: function handleTwoFaProcess(err, req) {
            if (err.status === 401) {
                if (err.error.errorCode === 212) {
                    this.loadTwoFaLoginModal(req, err);
                    return Observable_1.Observable.empty();
                }
                if (err.error.errorCode === 213) {
                    this.loadTwoFaSetupModal();
                    return Observable_1.Observable.empty();
                }
            }
            return Observable_1.Observable.throw(err);
        }
    }, {
        key: "loadTwoFaLoginModal",
        value: function loadTwoFaLoginModal(req, err) {
            this.twoFaAuthenticationService.setTwoFaModalControlState({
                state: true,
                action: 'LOGIN',
                payload: {
                    userPayload: {
                        userData: this.gatherLoginData(req.body),
                        authorizationKey: req.headers.get('authorization')
                    },
                    recoverUser2FA: err.error.recoverUser2FA
                }
            });
        }
    }, {
        key: "loadTwoFaSetupModal",
        value: function loadTwoFaSetupModal() {
            var _this2 = this;

            this.twoFaAuthenticationService.get2FaMetadataForSetup().subscribe(function (data) {
                return _this2.twoFaAuthenticationService.setTwoFaModalControlState({
                    state: true,
                    action: 'SETUP',
                    payload: { user2faState: data.data.user2faState, loginActions: true }
                });
            });
        }
    }, {
        key: "gatherLoginData",
        value: function gatherLoginData(data) {
            var userData = {};
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = data.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var pair = _step.value;

                    userData[pair[0]] = pair[1];
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return userData;
        }
    }]);

    return TwoFactorAuthorizationInterceptor;
}();
TwoFactorAuthorizationInterceptor = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [two_fa_authentication_data_service_1.TwoFaAuthenticationDataService])], TwoFactorAuthorizationInterceptor);
exports.TwoFactorAuthorizationInterceptor = TwoFactorAuthorizationInterceptor;

/***/ }),

/***/ "./web/modern/interceptors/webRequestsInterceptor.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var common_1 = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
var Observable_1 = __webpack_require__("./node_modules/rxjs/Observable.js");
var http_1 = __webpack_require__("./node_modules/@angular/common/esm5/http.js");
var account_service_1 = __webpack_require__("./web/modern/services/user/account.service.ts");
var subscription_service_1 = __webpack_require__("./shared/services/subscription/subscription.service.ts");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var auth_tokens_service_1 = __webpack_require__("./web/modern/auth-tokens.service.ts");
var WebRequestsInterceptor = function () {
    function WebRequestsInterceptor(location, authTokensService, accountService, subscriptionService, messageService) {
        _classCallCheck(this, WebRequestsInterceptor);

        this.location = location;
        this.authTokensService = authTokensService;
        this.accountService = accountService;
        this.subscriptionService = subscriptionService;
        this.messageService = messageService;
    }

    _createClass(WebRequestsInterceptor, [{
        key: "intercept",
        value: function intercept(req, next) {
            var _this = this;

            req = req.clone();
            var token = this.authTokensService.getAuthToken();
            return next.handle(this.addToken(req, token)).catch(function (err) {
                return _this.catchError(err, req, next);
            });
        }
    }, {
        key: "catchError",
        value: function catchError(err, req, next) {
            if (err.error) {
                // workaround to support old callbacks in AngularJS
                err = this.modifyErrorResponse(err);
            }
            if (err.status >= 200 && err.status < 300) {
                return Observable_1.Observable.of(this.handleErrorWithSuccessStatus(err));
            }
            if (err.status === 400) {
                return this.handle400Error(err, req, next);
            }
            if (err.status === 401) {
                return this.handle401Error(err, req, next);
            }
            // this.handleUnprocessedError(err);
            return Observable_1.Observable.throw(err);
        }
    }, {
        key: "handleErrorWithSuccessStatus",
        value: function handleErrorWithSuccessStatus(err) {
            return new http_1.HttpResponse({
                body: null,
                headers: err.headers,
                status: err.status,
                statusText: err.statusText,
                url: err.url
            });
        }
    }, {
        key: "handle400Error",
        value: function handle400Error(err, req, next) {
            if (err && err.error && err.error.errorCode === 450) {
                return this.logout();
            }
            return Observable_1.Observable.throw(err);
        }
    }, {
        key: "handle401Error",
        value: function handle401Error(err, req, next) {
            var _this2 = this;

            var isInvalidAccessToken = err && err.error && err.error.errorCode === 452;
            var isInvalidRefreshToken = err && err.error && err.error.errorCode === 450;
            var isSubscriptionExpired = err && err.error && err.error.errorCode === 210;
            var hasNoAccessToTheCompany = err && err.error && err.error.errorCode === 453;
            var isEmailNotConfirmed = err && err.error && err.error.errorCode === 211;
            if (isInvalidRefreshToken) {
                return this.logout();
            }
            if (isInvalidAccessToken) {
                if (!this.authTokensService.isRefreshingInProcess()) {
                    // following requests must wait until the token comes back from the refreshToken call
                    this.authTokensService.setRefreshingInProcess(true);
                    this.authTokensService.emitTokenSubject(null);
                    var refreshToken = this.authTokensService.getRefreshToken();
                    if (!refreshToken) {
                        return this.logout();
                    }
                    var logIn = localStorage.getItem('isStayLogin');
                    if (logIn === null) {
                        this.location.go('/login');
                    }
                    return this.accountService.getRefreshedAuthTokenWeb(refreshToken).switchMap(function (tokensData) {
                        if (!tokensData) {
                            return _this2.logout();
                        }
                        var newRefreshToken = _this2.authTokensService.successGetRefreshedToken(tokensData);
                        return Observable_1.Observable.of(newRefreshToken);
                    }).switchMap(function (authToken) {
                        if (!authToken) {
                            return _this2.logout();
                        }
                        _this2.authTokensService.emitTokenSubject(authToken);
                        return next.handle(_this2.addToken(req, authToken));
                    }).catch(function (error) {
                        return _this2.catchError(error, req, next);
                    }).finally(function () {
                        _this2.authTokensService.setRefreshingInProcess(false);
                    });
                }
                return this.authTokensService.tokenSubject.filter(function (authToken) {
                    return authToken !== null;
                }).take(1).switchMap(function (authToken) {
                    return next.handle(_this2.addToken(req, authToken));
                });
            }
            if (isSubscriptionExpired) {
                return this.showPlans();
            }
            if (hasNoAccessToTheCompany) {
                this.location.go('/');
                return Observable_1.Observable.empty();
            }
            if (isEmailNotConfirmed) {
                return Observable_1.Observable.throw(err);
            }
            return this.logout();
        }
    }, {
        key: "handle403Error",
        value: function handle403Error() {
            if (!this.location.path().includes('subscription')) {
                this.location.go('subscription');
            }
            return Observable_1.Observable.empty();
        }
    }, {
        key: "logout",
        value: function logout() {
            this.accountService.successLogoutWeb();
            return Observable_1.Observable.empty();
        }
    }, {
        key: "addToken",
        value: function addToken(req, token) {
            if (this.authTokensService.isToken(req.url, token)) {
                req = req.clone({
                    headers: req.headers.set('Authorization', "Bearer " + token)
                });
            }
            return req;
        }
    }, {
        key: "modifyErrorResponse",
        value: function modifyErrorResponse(err) {
            var modifiedError = JSON.parse(JSON.stringify(err));
            try {
                var errorText = JSON.parse(modifiedError.error);
                modifiedError.data = {
                    errorMessage: errorText.errorMessage
                };
            } catch (e) {
                if (modifiedError.error.errorMessage) {
                    modifiedError.data = {
                        errorMessage: err.error.errorMessage
                    };
                } else {
                    console.log('can not parse error');
                }
            }
            return modifiedError;
        }
    }, {
        key: "showPlans",
        value: function showPlans() {
            this.subscriptionService.onSubscriptionExpired();
            return Observable_1.Observable.empty();
        }
    }, {
        key: "handleUnprocessedError",
        value: function handleUnprocessedError(err) {
            var _err$error = err.error,
                errorTitle = _err$error.errorTitle,
                errorCode = _err$error.errorCode,
                errorMessage = _err$error.errorMessage;

            if (errorCode && errorMessage) {
                this.messageService.showErrorFromBackend(errorTitle || 'Whoops!', errorMessage);
            }
        }
    }]);

    return WebRequestsInterceptor;
}();
WebRequestsInterceptor = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [common_1.Location, auth_tokens_service_1.AuthTokensService, account_service_1.AccountServiceWebProvider, subscription_service_1.NewSubscriptionServiceDataProvider, message_service_1.MessageService])], WebRequestsInterceptor);
exports.WebRequestsInterceptor = WebRequestsInterceptor;

/***/ }),

/***/ "./web/modern/services/admin/ambassadors/ambassador.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var time_service_1 = __webpack_require__("./shared/services/helpers/time-service/time.service.ts");
var validation_service_1 = __webpack_require__("./shared/services/helpers/validation.service.ts");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var http_1 = __webpack_require__("./node_modules/@angular/common/esm5/http.js");
var AmbassadorService = function () {
    function AmbassadorService(http, timeService, validationService, messageService) {
        _classCallCheck(this, AmbassadorService);

        this.http = http;
        this.timeService = timeService;
        this.validationService = validationService;
        this.messageService = messageService;
    }

    _createClass(AmbassadorService, [{
        key: "validateAmbassador",
        value: function validateAmbassador(ambassador) {
            var dateStart = void 0,
                dateEnd = void 0;
            var validAmbassador = JSON.parse(JSON.stringify(ambassador), this.timeService.parseDateFromJSON);
            if (this.validationService.isStringEmpty(ambassador.firstName)) {
                this.messageService.showToaster('e_2', 'general', 'Ambassador code is empty');
                return false;
            }
            dateStart = this.timeService.getDateInFormat(validAmbassador.startDate, 'date');
            dateEnd = this.timeService.getDateInFormat(validAmbassador.endDate, 'date');
            var isCorrectDate = this.timeService.compareDates(dateEnd, dateStart);
            if (isCorrectDate) {
                this.messageService.showToaster('e_2', 'general', 'The start date must be before the end date.');
                return false;
            }
            validAmbassador.startDate = dateStart;
            validAmbassador.endDate = dateEnd;
            return validAmbassador;
        }
    }, {
        key: "exportAmbassadorData",
        value: function exportAmbassadorData(data) {
            var httpOptions = new http_1.HttpHeaders({
                'Content-Type': 'application/json'
            });
            var url = "/api/admin/accounts/" + data.businessAccountId + "/ambassador/code-usage/export";
            return this.http.post(url, data, {
                headers: httpOptions,
                observe: 'response',
                responseType: 'blob'
            });
        }
    }, {
        key: "getAmbassadorMetadata",
        value: function getAmbassadorMetadata(businessAccountId) {
            var url = "/api/admin/accounts/" + businessAccountId + "/ambassador/metadata";
            return this.http.get(url);
        }
    }]);

    return AmbassadorService;
}();
AmbassadorService = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [http_1.HttpClient, time_service_1.TimeServiceProvider, validation_service_1.ValidationProvider, message_service_1.MessageService])], AmbassadorService);
exports.AmbassadorService = AmbassadorService;

/***/ }),

/***/ "./web/modern/services/admin/users/admin-reports.data.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = __webpack_require__("./node_modules/@angular/common/esm5/http.js");
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var AdminReportsDataService = function () {
    function AdminReportsDataService(http) {
        _classCallCheck(this, AdminReportsDataService);

        this.http = http;
        this.ADMIN_URL = '/admin/rest';
    }

    _createClass(AdminReportsDataService, [{
        key: "getSignUpReport",
        value: function getSignUpReport() {
            var url = this.ADMIN_URL + "/get-new-sign-ups-report";
            return this.http.get(url);
        }
    }, {
        key: "getPayingMembersReport",
        value: function getPayingMembersReport() {
            var url = this.ADMIN_URL + "/get-new-paying-members-report";
            return this.http.get(url);
        }
    }, {
        key: "getCancellationReport",
        value: function getCancellationReport() {
            var url = this.ADMIN_URL + "/get-new-cancellations-report";
            return this.http.get(url);
        }
    }, {
        key: "getTotalRevenueReport",
        value: function getTotalRevenueReport() {
            var url = this.ADMIN_URL + "/get-total-revenue-report";
            return this.http.get(url);
        }
    }]);

    return AdminReportsDataService;
}();
AdminReportsDataService = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [http_1.HttpClient])], AdminReportsDataService);
exports.AdminReportsDataService = AdminReportsDataService;

/***/ }),

/***/ "./web/modern/services/admin/users/admin-users.data.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = __webpack_require__("./node_modules/@angular/common/esm5/http.js");
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var AdminUsersDataService = function () {
    function AdminUsersDataService(http) {
        _classCallCheck(this, AdminUsersDataService);

        this.http = http;
        this.ADMIN_URL = '/api/admin';
    }

    _createClass(AdminUsersDataService, [{
        key: "getUserSubscription",
        value: function getUserSubscription(email) {
            var url = this.ADMIN_URL + "/user/";
            return this.http.post(url, email);
        }
    }, {
        key: "synchronize",
        value: function synchronize() {
            var url = this.ADMIN_URL + "/synchronize-admin-table-data";
            return this.http.get(url);
        }
    }, {
        key: "deleteUser",
        value: function deleteUser(email) {
            var url = this.ADMIN_URL + "/user/delete";
            var params = new http_1.HttpParams().append('userEmail', email);
            return this.http.delete(url, { params: params });
        }
    }, {
        key: "getUsers",
        value: function getUsers(data) {
            var url = this.ADMIN_URL + "/get-admin-table-data";
            return this.http.post(url, data).map(function (res) {
                return res.data;
            });
        }
    }, {
        key: "getUserTwoFaInfo",
        value: function getUserTwoFaInfo(accountId) {
            var url = this.ADMIN_URL + "/accounts/" + accountId + "/users/2fa";
            return this.http.get(url);
        }
    }, {
        key: "giveFreeAccess",
        value: function giveFreeAccess(timeConfiguration, businessAccountId, freeAccessMethod) {
            var url = this.ADMIN_URL + "/accounts/" + businessAccountId + "/" + (freeAccessMethod === 'PRORATABLE' ? 'adjust/free-time' : 'give/free-access');
            return this.http.post(url, timeConfiguration);
        }
    }, {
        key: "closeAccess",
        value: function closeAccess(businessAccountId) {
            var url = this.ADMIN_URL + "/accounts/" + businessAccountId + "/subscriptions/close-access";
            return this.http.post(url, {});
        }
    }, {
        key: "getSubscriptionInfo",
        value: function getSubscriptionInfo(user) {
            var url = this.ADMIN_URL + "/accounts/" + user.businessAccountId + "/subscriptions/details";
            return this.http.post(url, {});
        }
    }, {
        key: "getSubscriptionInfoForFreeAccess",
        value: function getSubscriptionInfoForFreeAccess(user) {
            var url = this.ADMIN_URL + "/accounts/" + user.businessAccountId + "/subscriptions/status";
            return this.http.post(url, {});
        }
    }]);

    return AdminUsersDataService;
}();
AdminUsersDataService = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [http_1.HttpClient])], AdminUsersDataService);
exports.AdminUsersDataService = AdminUsersDataService;

/***/ }),

/***/ "./web/modern/services/graph/graph.model.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
exports.revenueTabColors = ['#12afcb', '#8dc63f', '#bd8cbf', '#476173', '#22baa0', '#f7941d', '#ffcc33', '#69c0eb', '#7971ae', '#f26d7d'];

/***/ }),

/***/ "./web/modern/services/graph/graphs.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var c3 = __webpack_require__("./node_modules/c3/c3.js");
var d3 = __webpack_require__("./node_modules/d3/index.js");
var settings_1 = __webpack_require__("./shared/services/settings/settings.ts");
var graph_model_1 = __webpack_require__("./web/modern/services/graph/graph.model.ts");
var GraphsService = GraphsService_1 = function () {
    function GraphsService(settingsService) {
        var _this = this;

        _classCallCheck(this, GraphsService);

        this.settingsService = settingsService;
        this.calculateTickCulling = function (tickCount, windowWidth) {
            if (windowWidth > 1200 && windowWidth <= 1390 && tickCount > 26) {
                return Math.ceil(tickCount / 2);
            } else if (windowWidth > 600 && windowWidth <= 1200 && tickCount > 20) {
                return Math.ceil(tickCount / 2);
            } else if (windowWidth <= 600 && tickCount <= 16) {
                return Math.ceil(tickCount / 2);
            } else if (windowWidth <= 600 && tickCount > 16) {
                return Math.ceil(tickCount / 4);
            }
            return 0;
        };
        this.calculateGridTicksValues = function (data) {
            var ticks = [];
            var maxValue = void 0;
            var maxValue1 = 0;
            var maxValue2 = 0;
            var valueOfTick = 0;
            // find max value in three arrays
            maxValue = _this.findMaxValueInArray(data, 'value');
            if (Object.prototype.hasOwnProperty.call(data[0], 'value1')) {
                maxValue1 = _this.findMaxValueInArray(data, 'value1');
            }
            if (Object.prototype.hasOwnProperty.call(data[0], 'value2')) {
                maxValue2 = _this.findMaxValueInArray(data, 'value2');
            }
            maxValue = Math.ceil(Math.max(maxValue, maxValue1, maxValue2));
            // check not to run an infinite loop
            if (!maxValue || maxValue === 0) {
                return [0, 1, 2, 3, 4];
            }
            // check whether the number is multiple four
            while (maxValue % 4) {
                maxValue++;
            }
            // divide axis Y into 4 equal parts
            while (valueOfTick <= maxValue) {
                ticks.push(valueOfTick);
                valueOfTick += maxValue / 4;
            }
            return ticks;
        };
        this.findMaxValueInArray = function (array, valueName) {
            return Math.max.apply(Math, _toConsumableArray(array.map(function (value) {
                return value[valueName];
            })));
        };
        this.mergeTwoArraysOfObjects = function (arrayOne, arrayTwo) {
            var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

            var newArray = [];
            arrayOne.forEach(function (objectOne) {
                arrayTwo.forEach(function (ObjectTwo) {
                    if (objectOne.label === ObjectTwo.label) {
                        if (!objectOne.hasOwnProperty("value" + index)) {
                            var _Object$assign;

                            newArray.push(Object.assign({}, objectOne, (_Object$assign = {}, _defineProperty(_Object$assign, "value" + index, ObjectTwo.value), _defineProperty(_Object$assign, "valueLabel" + index, ObjectTwo.valueLabel), _Object$assign)));
                        }
                    }
                });
            });
            return newArray;
        };
        this.addLegend = function (chart, value, legendConfig) {
            var svg = d3.select('#chart').select('svg');
            d3.select('.chart-container').append('div').attr('class', "legend " + GraphsService_1.generateLegendClasses(value.length, legendConfig.legendRowLength)).selectAll('span').data(value).enter().append('span').attr('data-id', function (id) {
                return id;
            }).html(function (id) {
                return "<p>" + chart.data.names()[id] + "</p>";
            }).each(function (id) {
                d3.select(this).insert('div', 'p').attr('class', 'legend-name').style('background-color', chart.color(id));
                var isVisible = GraphsService_1.shouldLegendBeEnabled(legendConfig.id, GraphsService_1.getCorrectLegendValue(legendConfig.pattern, chart.data.names()[id]));
                if (isVisible) {
                    GraphsService_1.toggleLegendStyles(id);
                    chart.toggle(id);
                }
            }).on('mouseover', function (id) {
                var legendClasses = document.querySelector("[data-id=\"" + id + "\"]").classList;
                if (!legendClasses.contains('disabled')) {
                    chart.focus(id);
                }
            }).on('mouseout', function () {
                chart.revert();
            }).on('click', function (id) {
                svg.style('visibility', 'hidden');
                var action = GraphsService_1.toggleLegendStyles(id);
                chart.toggle(id);
                GraphsService_1.manageStoredLegend(legendConfig.id, action, GraphsService_1.getCorrectLegendValue(legendConfig.pattern, chart.data.names()[id]));
                setTimeout(function () {
                    return svg.style('visibility', 'visible');
                }, 250);
            });
        };
        this.shootsTabName = 'Shoots';
        this.subscribeToCustomizeLabelsChange();
    }

    _createClass(GraphsService, [{
        key: "subscribeToCustomizeLabelsChange",
        value: function subscribeToCustomizeLabelsChange() {
            var _this2 = this;

            this.settingsService.customizeLabelsObservable.subscribe(function (customizeLabels) {
                return _this2.shootsTabName = customizeLabels.shootsLabel;
            });
        }
    }, {
        key: "clear",
        value: function clear() {
            if (this.chartObject) {
                this.chartObject = this.chartObject.destroy();
            }
        }
    }, {
        key: "createLeadData",
        value: function createLeadData(leadData, acceptedLeadsData, companyId) {
            var chart = {
                json: this.mergeTwoArraysOfObjects(leadData, acceptedLeadsData),
                keys: {
                    x: 'label',
                    value: ['value', 'value1']
                },
                names: {
                    value: 'Leads',
                    value1: 'Jobs Accepted'
                },
                types: {
                    value: 'area',
                    value1: 'area'
                },
                colors: {
                    value: '#f27987',
                    value1: '#22baa1'
                },
                valueLabels: []
            };
            Object.keys(chart.json).forEach(function (objCount) {
                chart.valueLabels.push([{ value: chart.json[objCount].valueLabel }, { value1: chart.json[objCount].valueLabel1 }]);
            });
            var legendConfig = {
                needLegend: true,
                legendRowLength: 2,
                id: "legendLeads-" + companyId,
                pattern: 'NAME'
            };
            var generalConfig = {
                shortPeriod: true,
                chartName: 'lead_chart'
            };
            this.drawGraph(chart, legendConfig, generalConfig);
        }
    }, {
        key: "createShootData",
        value: function createShootData(data, companyId) {
            var chart = {
                json: data,
                keys: {
                    x: 'label',
                    value: ['value']
                },
                names: {
                    value: this.shootsTabName
                },
                types: {
                    value: 'area'
                },
                colors: {
                    value: '#22baa1'
                },
                valueLabels: []
            };
            Object.keys(chart.json).forEach(function (objCount, index) {
                chart.valueLabels.push([{ value: chart.json[objCount].valueLabel }]);
            });
            var legendConfig = {
                needLegend: false,
                legendRowLength: 2,
                id: "legendShoots-" + companyId,
                pattern: 'NAME'
            };
            var generalConfig = {
                shortPeriod: true,
                chartName: 'shoot_chart'
            };
            this.drawGraph(chart, legendConfig, generalConfig);
        }
    }, {
        key: "createPaymentsData",
        value: function createPaymentsData(payments, paymentsDue, currency, companyId) {
            var chart = {
                json: this.mergeTwoArraysOfObjects(payments, paymentsDue),
                keys: {
                    x: 'label',
                    value: ['value', 'value1']
                },
                names: {
                    value: 'Payments Received',
                    value1: 'Unpaid Payments'
                },
                types: {
                    value: 'area',
                    value1: 'area'
                },
                colors: {
                    value: '#7a6fbe',
                    value1: '#c2c2c2'
                },
                valueLabels: []
            };
            Object.keys(chart.json).forEach(function (objCount) {
                chart.valueLabels.push([{ value: chart.json[objCount].valueLabel }, { value1: chart.json[objCount].valueLabel1 }]);
            });
            var legendConfig = {
                needLegend: true,
                legendRowLength: 2,
                id: "legendPayments-" + companyId,
                pattern: 'NAME'
            };
            var generalConfig = {
                shortPeriod: true,
                chartName: 'payment_chart',
                currency: currency
            };
            this.drawGraph(chart, legendConfig, generalConfig);
        }
    }, {
        key: "createRevenueData",
        value: function createRevenueData(revenue, currency, companyId) {
            var _this3 = this;

            var chart = {
                json: [],
                keys: {
                    x: 'label',
                    value: []
                },
                names: {},
                types: {},
                colors: {},
                valueLabels: []
            };
            Object.keys(revenue).forEach(function (year, index) {
                var key = 'value';
                if (index === 0) {
                    chart.json = revenue[year].data;
                } else {
                    chart.json = _this3.mergeTwoArraysOfObjects(chart.json, revenue[year].data, index);
                    key = "value" + index;
                }
                chart.keys.value.push(key);
                chart.names[key] = year + " (" + revenue[year].totalLabel + ")";
                chart.types[key] = 'area';
                chart.colors[key] = graph_model_1.revenueTabColors[index];
            });
            var keys = Object.keys(chart.json);
            keys.forEach(function (objCount) {
                var chartValues = [];
                chartValues.push({ value: chart.json[objCount].valueLabel });
                for (var i = 0; i < keys.length; i++) {
                    if (i) {
                        chartValues.push(_defineProperty({}, "value" + i, chart.json[objCount]["valueLabel" + i]));
                    }
                }
                chart.valueLabels.push(chartValues);
            });
            var legendConfig = {
                needLegend: true,
                legendRowLength: 5,
                id: "legendRevenue-" + companyId,
                pattern: 'YEAR'
            };
            var generalConfig = {
                shortPeriod: false,
                chartName: 'revenue_chart',
                currency: currency
            };
            this.drawGraph(chart, legendConfig, generalConfig);
        }
    }, {
        key: "drawGraph",
        value: function drawGraph(data, legendConfig, chartConfig) {
            var _this4 = this;

            if (this.chartObject) {
                this.chartObject = this.chartObject.destroy();
            }
            var legend = void 0;
            var container = d3.select('.chart-container');
            var chartObj = d3.select('#chart');
            var isRevenue = chartConfig.chartName === 'revenue_chart';
            var isLead = chartConfig.chartName === 'lead_chart';
            var isShoot = chartConfig.chartName === 'shoot_chart';
            var tickValues = this.calculateGridTicksValues(data.json);
            var tickCulling = this.calculateTickCulling(data.json.length, window.innerWidth);
            var shootName = this.shootsTabName;
            d3.select('.legend').remove();
            d3.select('.pie-chart-active-legend').select('.legend-pie').remove();
            chartObj.style('height', null);
            var chart = c3.generate({
                bindto: '#chart',
                data: data,
                transition: {
                    duration: 0
                },
                grid: {
                    y: {
                        show: true
                    }
                },
                axis: {
                    x: {
                        type: 'category',
                        tick: {
                            width: 100,
                            culling: {
                                max: tickCulling
                            }
                        }
                    },
                    y: this.setYaxis(isLead, isShoot, tickValues, chartConfig.currency)
                },
                tooltip: {
                    format: {
                        title: function title() {
                            return '';
                        }
                    },
                    contents: function contents(values) {
                        var valuesCopy = JSON.parse(JSON.stringify(values));
                        var template = '';

                        var _loop = function _loop(i) {
                            // const formattedValue = d3.format(',')(valuesCopy[i].value);
                            var displayedValue = '';
                            data.valueLabels[valuesCopy[i].index].forEach(function (obj, index) {
                                Object.keys(data.valueLabels[valuesCopy[i].index][index]).forEach(function (key) {
                                    if (key === valuesCopy[i].id) {
                                        displayedValue = data.valueLabels[valuesCopy[i].index][index][key];
                                    }
                                });
                            });
                            switch (valuesCopy[i].name) {
                                case 'Payments Received':
                                    valuesCopy[i].name = 'Received';
                                    break;
                                case 'Unpaid Payments':
                                    valuesCopy[i].name = 'Unpaid';
                                    break;
                                default:
                                    break;
                            }
                            template += "<p><span class='tooltip-name'>" + (valuesCopy[i].name === 'Received' || valuesCopy[i].name === 'Unpaid' || valuesCopy[i].name === shootName || isLead ? valuesCopy[i].name : valuesCopy[i].name.slice(0, 4)) + ":</span> <span class='tooltip-value'>" +
                            // currency ? currency + formattedValue : formattedValue
                            displayedValue + "</span></p>";
                        };

                        for (var i = 0; i < valuesCopy.length; i++) {
                            _loop(i);
                        }
                        return "<div class='tooltip-container'>\n                              " + template + "\n                            </div>";
                    }
                },
                legend: {
                    show: !!(!legendConfig.needLegend && data.names.value !== this.shootsTabName)
                },
                onresized: function onresized() {
                    var windowWidth = window.innerWidth;
                    var tickCount = data.json.length;
                    var culling = void 0;
                    // need to think how to call calculateTickCulling to avoid duplicate code
                    if (isRevenue) {
                        GraphsService_1.trackRevenueWidthChange(legend, windowWidth, data.keys.value);
                        GraphsService_1.resizeRevenueDueToLegend(container, chartObj, legend);
                    }
                    if (windowWidth > 1200 && windowWidth <= 1390 && tickCount > 26) {
                        culling = Math.ceil(tickCount / 2);
                    } else if (windowWidth > 600 && windowWidth <= 1200 && tickCount > 16) {
                        culling = Math.ceil(tickCount / 2);
                    } else if (windowWidth <= 600 && tickCount <= 16) {
                        culling = Math.ceil(tickCount / 2);
                    } else if (windowWidth <= 600 && tickCount > 16) {
                        culling = Math.ceil(tickCount / 4);
                    } else {
                        culling = 0;
                    }
                    // quick solution to call "internal" property that doesn't exist in ChartAPI type, need to refactor this in future
                    var internal = 'internal';
                    chart[internal].config.axis_x_tick_culling_max = culling;
                }
            });
            this.chartObject = chart;
            if (legendConfig.needLegend) {
                GraphsService_1.setDefaultLegendValuesToStorage(legendConfig.id);
                var svg = d3.select('#chart').select('svg');
                svg.style('visibility', 'hidden');
                requestAnimationFrame(function () {
                    _this4.addLegend(chart, data.keys.value, legendConfig);
                    if (isRevenue) {
                        GraphsService_1.trackRevenueWidthChange(legend, window.innerWidth, data.keys.value);
                        GraphsService_1.resizeRevenueDueToLegend(container, chartObj, legend);
                    }
                });
                setTimeout(function () {
                    return svg.style('visibility', 'visible');
                }, 250);
            }
            requestAnimationFrame(function () {
                return chart.flush();
            });
        }
    }, {
        key: "setYaxis",
        value: function setYaxis(isLead, isShoot, tickValues, currency) {
            if (isLead || isShoot) {
                var setYaxisLead = {
                    max: tickValues[tickValues.length - 1],
                    min: 0,
                    padding: { top: 5, bottom: 5 },
                    tick: {
                        format: function format(tickValue) {
                            if (tickValue === 0) {
                                return '';
                            }
                            var formattedTickValue = d3.format(',')(tickValue);
                            return currency ? currency + " " + formattedTickValue : formattedTickValue;
                        },

                        values: tickValues
                    }
                };
                return setYaxisLead;
            }
            var setYaxisRest = {
                min: 0,
                padding: { top: 5, bottom: 5 },
                tick: {
                    format: function format(tickValue) {
                        if (tickValue === 0) {
                            return '';
                        }
                        var formattedTickValue = d3.format(',')(tickValue);
                        return currency ? currency + " " + formattedTickValue : formattedTickValue;
                    }
                }
            };
            return setYaxisRest;
        }
    }], [{
        key: "toggleLegendStyles",
        value: function toggleLegendStyles(id) {
            var legendClasses = document.querySelector("[data-id=\"" + id + "\"]").classList;
            if (legendClasses.contains('disabled')) {
                legendClasses.remove('disabled');
                return 'ADD';
            }
            legendClasses.add('disabled');
            return 'REMOVE';
        }
    }, {
        key: "trackRevenueWidthChange",
        value: function trackRevenueWidthChange(legend, width, value) {
            var maxLegendCount = width > 1199 ? 5 : 3;
            if (!legend) {
                legend = d3.select('.chart-container').select('.legend');
            }
            if (!legend.attr('class').includes("grid-columns-" + GraphsService_1.calculateCorrectGridCount(value.length, maxLegendCount))) {
                legend.attr('class', "legend grid " + GraphsService_1.generateLegendClasses(value.length, maxLegendCount));
            }
        }
    }, {
        key: "calculateCorrectGridCount",
        value: function calculateCorrectGridCount(elementsCount, maxAllowed) {
            return elementsCount > maxAllowed ? maxAllowed : elementsCount;
        }
    }, {
        key: "removeLegend",
        value: function removeLegend() {
            d3.select('.legend').remove();
            d3.select('.legend-pie').remove();
        }
    }, {
        key: "generateLegendClasses",
        value: function generateLegendClasses(elementsCount, maxAllowedRow) {
            var legend = 'grid';
            elementsCount > maxAllowedRow ? legend += " grid-columns-" + maxAllowedRow + " grid-items-start" : legend += " grid-columns-" + elementsCount + " grid-items-center";
            return legend;
        }
    }, {
        key: "resizeRevenueDueToLegend",
        value: function resizeRevenueDueToLegend(container, chart, legend) {
            if (!legend) {
                legend = d3.select('.chart-container').select('.legend');
            }
            chart.style('height', +container.style('height').slice(0, -2) - legend.style('height').slice(0, -2) - 10 + "px");
        }
    }, {
        key: "setDefaultLegendValuesToStorage",
        value: function setDefaultLegendValuesToStorage(storageId) {
            if (!localStorage.getItem(storageId)) {
                localStorage.setItem(storageId, [].join(';'));
            }
        }
    }, {
        key: "shouldLegendBeEnabled",
        value: function shouldLegendBeEnabled(storageId, value) {
            return localStorage.getItem(storageId).indexOf(value) !== -1;
        }
    }, {
        key: "manageStoredLegend",
        value: function manageStoredLegend(storageId, action, value) {
            var data = localStorage.getItem(storageId).split(';');
            if (action === 'ADD') {
                data = data.filter(function (val) {
                    return val !== value;
                });
            }
            if (action === 'REMOVE') {
                data.push(value);
            }
            localStorage.setItem(storageId, data.join(';'));
        }
    }, {
        key: "getCorrectLegendValue",
        value: function getCorrectLegendValue(type, value) {
            switch (type) {
                case 'YEAR':
                    return value.substring(0, 4);
                case 'NAME':
                    return value;
                default:
                    return value;
            }
        }
    }]);

    return GraphsService;
}();
GraphsService = GraphsService_1 = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [settings_1.SettingsProvider])], GraphsService);
exports.GraphsService = GraphsService;
var GraphsService_1;

/***/ }),

/***/ "./web/modern/services/graph/pie-graph.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var c3 = __webpack_require__("./node_modules/c3/c3.js");
var d3 = __webpack_require__("./node_modules/d3/index.js");
var PieGraphService = PieGraphService_1 = function () {
    function PieGraphService() {
        _classCallCheck(this, PieGraphService);

        this.addPieChartLegend = function (chart, value, containerSelector, options, columnFirst) {
            d3.select(containerSelector).append('div').attr('class', "legend-pie " + PieGraphService_1.generateLegendClasses(value.length, options.legendRowLength, columnFirst)).selectAll('div').data(value).enter().append('div').attr('data-id', function (id) {
                return id;
            }).html(function (id) {
                return "<p>" + id + "</p>";
            }).each(function (id) {
                d3.select(this).insert('div', 'p').attr('class', 'legend-pie-name').style('background-color', chart.color(id));
            }).on('mouseover', function (id) {
                var legendClasses = document.querySelector("[data-id=\"" + id + "\"]").classList;
                if (!legendClasses.contains('disabled')) {
                    chart.focus(id);
                }
            }).on('mouseout', function () {
                chart.revert();
            });
        };
    }

    _createClass(PieGraphService, [{
        key: "drawTabPieChart",
        value: function drawTabPieChart(data, id, customOptions) {
            var _this = this;

            var columns = data.columns,
                colors = data.colors,
                clearData = data.clearData;

            var chartConfig = {
                bindto: "#" + id,
                data: {
                    columns: columns,
                    type: 'pie',
                    colors: colors
                },
                pie: {
                    label: {
                        format: function format() {
                            return null;
                        }
                    }
                },
                legend: {
                    show: false
                },
                tooltip: {
                    contents: function contents(values) {
                        return PieGraphService_1.addTooltip(values, clearData);
                    }
                }
            };
            d3.select('.legend').remove();
            d3.select('.pie-chart-active-legend').select('.legend-pie').remove();
            var leadSourceIds = data.columns.map(function (item) {
                return item[0];
            });
            var chart = c3.generate(Object.assign(chartConfig, customOptions));
            requestAnimationFrame(function () {
                return _this.addPieChartLegend(chart, leadSourceIds, '.pie-chart-active-legend', customOptions, true);
            });
            requestAnimationFrame(function () {
                return chart.flush();
            });
        }
    }, {
        key: "drawPieChart",
        value: function drawPieChart(data, id, customOptions) {
            var columns = data.columns,
                colors = data.colors,
                clearData = data.clearData;

            var chartConfig = {
                bindto: "#" + id,
                data: {
                    columns: columns,
                    type: 'pie',
                    colors: colors
                },
                pie: {
                    label: {
                        format: function format() {
                            return null;
                        }
                    }
                },
                legend: {
                    show: false
                },
                tooltip: {
                    contents: function contents(values) {
                        return PieGraphService_1.addTooltip(values, clearData);
                    }
                }
            };
            d3.select('.legend-pie').remove();
            var leadSourceIds = data.columns.map(function (item) {
                return item[0];
            });
            var chart = c3.generate(Object.assign(chartConfig, customOptions));
            this.addPieChartLegend(chart, leadSourceIds, '.chart-pie-body', customOptions, false);
            PieGraphService_1.resizePieChart();
            chart.flush();
        }
    }, {
        key: "preparePieChartData",
        value: function preparePieChartData(items) {
            var data = {
                columns: [],
                colors: {},
                clearData: items
            };
            items.forEach(function (item) {
                data.columns.push([item.name, item.proportionNumber]);
                data.colors[item.name] = item.colour.hex;
            });
            return data;
        }
    }], [{
        key: "resizePieChart",
        value: function resizePieChart() {
            var legend = d3.select('.legend-pie');
            var chart = d3.select('#pie-chart');
            var legendHeight = parseInt(legend.style('height'));
            var newHeight = 285 - legendHeight;
            chart.style('height', null);
            chart.style('height', newHeight + "px");
        }
    }, {
        key: "addTooltip",
        value: function addTooltip(values, chartData) {
            var _values = _slicedToArray(values, 1),
                value = _values[0];

            var _chartData$filter = chartData.filter(function (item) {
                return item.name === value.id;
            }),
                _chartData$filter2 = _slicedToArray(_chartData$filter, 1),
                leadSource = _chartData$filter2[0];

            return "\n\t\t\t\t<div class=\"pie-tooltip\">\n\t\t\t\t\t<p><b>" + leadSource.name + "</b>: " + leadSource.proportionNumber + "%</p>\n\t\t\t\t\t\n\t\t\t\t\t<p><b>Count</b>: " + leadSource.count + "</p>\n\t\t\t\t</div>\n\t\t\t";
        }
    }, {
        key: "generateLegendClasses",
        value: function generateLegendClasses(elementsCount, maxAllowedRow, columnFirst) {
            var multipleRows = elementsCount > maxAllowedRow;
            var gridType = columnFirst ? 'rows' : 'columns';
            var legend = 'grid';
            multipleRows ? legend += " grid-" + gridType + "-" + maxAllowedRow + " grid-items-start" : legend += " grid-" + gridType + "-" + elementsCount + " grid-items-center";
            if (columnFirst) {
                legend += ' grid-fill-columns';
                legend = legend.replace('center', 'start');
            }
            return legend;
        }
    }]);

    return PieGraphService;
}();
PieGraphService = PieGraphService_1 = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [])], PieGraphService);
exports.PieGraphService = PieGraphService;
var PieGraphService_1;

/***/ }),

/***/ "./web/modern/services/modal/snModal.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var ng_bootstrap_1 = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/index.js");
var modal_stack_1 = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/modal/modal-stack.js");
var Subject_1 = __webpack_require__("./node_modules/rxjs/Subject.js");
var subscription_service_1 = __webpack_require__("./shared/services/subscription/subscription.service.ts");
var common_1 = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
var SNModalService = function (_ng_bootstrap_1$NgbMo) {
    _inherits(SNModalService, _ng_bootstrap_1$NgbMo);

    function SNModalService(componentFactoryResolver, injector, modalStack, subscriptionService, location) {
        _classCallCheck(this, SNModalService);

        var _this = _possibleConstructorReturn(this, (SNModalService.__proto__ || Object.getPrototypeOf(SNModalService)).call(this, componentFactoryResolver, injector, modalStack));

        _this.componentFactoryResolver = componentFactoryResolver;
        _this.injector = injector;
        _this.modalStack = modalStack;
        _this.subscriptionService = subscriptionService;
        _this.location = location;
        _this.snModalConfig = {
            windowClass: 'ng-bootstrap-modal',
            backdropClass: 'ng-bootstrap-backdrop',
            backdrop: 'static',
            keyboard: false
        };
        _this.modalData = new Subject_1.Subject();
        location.onPopState(function () {
            try {
                _this.closeActiveModal();
            } catch (error) {
                console.error(error);
            }
        });
        return _this;
    }

    _createClass(SNModalService, [{
        key: "openModal",
        value: function openModal(content, config) {
            this.activeModal = _get(SNModalService.prototype.__proto__ || Object.getPrototypeOf(SNModalService.prototype), "open", this).call(this, content, Object.assign(JSON.parse(JSON.stringify(this.snModalConfig)), config));
            return this.activeModal;
        }
    }, {
        key: "setModalData",
        value: function setModalData(data) {
            this.modalData.next(data);
        }
    }, {
        key: "getModalData",
        value: function getModalData() {
            return this.modalData.asObservable();
        }
    }, {
        key: "closeModalByRef",
        value: function closeModalByRef(modalRef, modalDataStream) {
            modalRef.dismiss();
            if (modalDataStream) {
                modalDataStream.unsubscribe();
            }
        }
    }, {
        key: "closeActiveModal",
        value: function closeActiveModal() {
            if (this.activeModal) {
                this.subscriptionService.setChoosePlanOpenModalStatus({
                    state: false,
                    payload: null
                });
                this.activeModal.dismiss();
                this.activeModal = null;
            }
        }
    }]);

    return SNModalService;
}(ng_bootstrap_1.NgbModal);
SNModalService = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [core_1.ComponentFactoryResolver, core_1.Injector, modal_stack_1.NgbModalStack, subscription_service_1.NewSubscriptionServiceDataProvider, common_1.PlatformLocation])], SNModalService);
exports.SNModalService = SNModalService;

/***/ }),

/***/ "./web/modern/services/profile/profile-update.data.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var http_1 = __webpack_require__("./node_modules/@angular/common/esm5/http.js");
var ProfileUpdateDataServiceProvider = function () {
    function ProfileUpdateDataServiceProvider(http) {
        _classCallCheck(this, ProfileUpdateDataServiceProvider);

        this.http = http;
    }

    _createClass(ProfileUpdateDataServiceProvider, [{
        key: "changeUserName",
        value: function changeUserName(user) {
            var url = '/protected/rest/user/edit';
            return this.http.post(url, user);
        }
    }, {
        key: "changeUserEmail",
        value: function changeUserEmail(email) {
            var url = '/protected/rest/user/edit/login';
            return this.http.post(url, email);
        }
    }, {
        key: "changeUserPassword",
        value: function changeUserPassword(password, password_confirm) {
            var url = '/protected/rest/user/edit/password';
            var body = new FormData();
            body.append('password', password);
            body.append('password_confirm', password_confirm);
            return this.http.post(url, body);
        }
    }]);

    return ProfileUpdateDataServiceProvider;
}();
ProfileUpdateDataServiceProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [http_1.HttpClient])], ProfileUpdateDataServiceProvider);
exports.ProfileUpdateDataServiceProvider = ProfileUpdateDataServiceProvider;

/***/ }),

/***/ "./web/modern/services/profile/profile-update.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var validation_service_1 = __webpack_require__("./shared/services/helpers/validation.service.ts");
var ProfileUpdateServiceProvider = function () {
    function ProfileUpdateServiceProvider(messageService, validationService) {
        _classCallCheck(this, ProfileUpdateServiceProvider);

        this.messageService = messageService;
        this.validationService = validationService;
    }

    _createClass(ProfileUpdateServiceProvider, [{
        key: "validateName",
        value: function validateName(firstName) {
            var isValidName = true;
            firstName = firstName.trim();
            if (!firstName || firstName === '') {
                isValidName = false;
            }
            return isValidName;
        }
    }, {
        key: "isValidEmail",
        value: function isValidEmail(email, initialEmail) {
            var isValidEmail = true;
            email = email.trim().toLowerCase();
            if (!email || email === '') {
                isValidEmail = false;
                this.messageService.showToaster('e_0', 'general');
            } else if (email === initialEmail) {
                isValidEmail = false;
                this.messageService.showToaster('i_2', 'profile');
            } else if (!this.validationService.isEmailValid(email)) {
                isValidEmail = false;
                this.messageService.showToaster('e_3', 'profile');
            }
            return isValidEmail;
        }
    }, {
        key: "isValidPassword",
        value: function isValidPassword(password, passwordConfirm) {
            var isValidPassword = true;
            if (passwordConfirm != password) {
                this.messageService.showToaster('e_0', 'profile');
                isValidPassword = false;
            } else if (password.length < 6) {
                this.messageService.showToaster('e_1', 'profile');
                isValidPassword = false;
            } else if (password.trim().length === 0) {
                this.messageService.showToaster('e_3', 'general', 'password');
                isValidPassword = false;
            }
            return isValidPassword;
        }
    }]);

    return ProfileUpdateServiceProvider;
}();
ProfileUpdateServiceProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [message_service_1.MessageService, validation_service_1.ValidationProvider])], ProfileUpdateServiceProvider);
exports.ProfileUpdateServiceProvider = ProfileUpdateServiceProvider;

/***/ }),

/***/ "./web/modern/services/services.module.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var image_converter_service_1 = __webpack_require__("./shared/services/files/image-converter.service.ts");
var workflow_drag_n_drop_1 = __webpack_require__("./shared/services/workflow/workflow-drag-n-drop.ts");
var clients_data_service_1 = __webpack_require__("./shared/services/client/clients.data.service.ts");
var payments_service_1 = __webpack_require__("./shared/services/payments/payments-service/payments.service.ts");
var invoices_data_service_1 = __webpack_require__("./shared/services/invoice/invoices-data-service/invoices.data.service.ts");
var search_service_1 = __webpack_require__("./shared/services/helpers/search.service.ts");
var time_service_1 = __webpack_require__("./shared/services/helpers/time-service/time.service.ts");
var calendar_events_data_service_1 = __webpack_require__("./shared/services/calendar/calendar-events.data.service.ts");
var workflow_service_1 = __webpack_require__("./shared/services/workflow/workflow-service/workflow.service.ts");
var random_string_generator_1 = __webpack_require__("./shared/services/helpers/random-string-generator.ts");
var mails_data_service_1 = __webpack_require__("./shared/services/email/mails.data.service.ts");
var workflow_data_service_1 = __webpack_require__("./shared/services/workflow/workflow.data.service.ts");
var validation_service_1 = __webpack_require__("./shared/services/helpers/validation.service.ts");
var file_upload_data_service_1 = __webpack_require__("./shared/services/files/file-upload.data.service.ts");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var client_service_1 = __webpack_require__("./shared/services/client/client.service.ts");
var integrations_data_service_1 = __webpack_require__("./shared/services/integrations/integrations.data.service.ts");
var contracts_data_service_1 = __webpack_require__("./shared/services/contract/contracts.data.service.ts");
var utils_service_1 = __webpack_require__("./shared/services/utils/utils-service.ts");
var appointment_service_1 = __webpack_require__("./shared/services/tasks/appointment.service.ts");
var extra_shoot_service_1 = __webpack_require__("./shared/services/tasks/extra-shoot.service.ts");
var templates_data_service_1 = __webpack_require__("./shared/services/data-services/templates-data-service/templates.data.service.ts");
var time_converter_1 = __webpack_require__("./shared/services/helpers/time-converter.ts");
var file_upload_service_1 = __webpack_require__("./shared/services/files/file-upload-service/file-upload.service.ts");
var email_service_1 = __webpack_require__("./shared/services/email/email-service/email.service.ts");
var notes_data_service_1 = __webpack_require__("./shared/services/notes/notes.data.service.ts");
var questionnaires_data_service_1 = __webpack_require__("./shared/services/questionnarie/questionnaires.data.service.ts");
var email_settings_data_service_1 = __webpack_require__("./shared/services/settings/email-settings.data.service.ts");
var account_data_service_1 = __webpack_require__("./shared/services/user/account.data.service.ts");
var stringModifier_service_1 = __webpack_require__("./shared/services/helpers/string-modifier-service/stringModifier.service.ts");
var account_service_1 = __webpack_require__("./web/modern/services/user/account.service.ts");
var user_service_1 = __webpack_require__("./web/modern/services/user/user.service.ts");
var promo_code_data_service_1 = __webpack_require__("./shared/services/subscription/promo-code.data.service.ts");
var leads_data_service_1 = __webpack_require__("./shared/services/lead/leads.data.service.ts");
var jobs_data_service_1 = __webpack_require__("./shared/services/job/jobs.data.service.ts");
var payments_data_service_1 = __webpack_require__("./shared/services/payments/payments-data-service/payments.data.service.ts");
var quotes_data_service_1 = __webpack_require__("./shared/services/quote/quotes-data-service/quotes.data.service.ts");
var job_types_data_service_1 = __webpack_require__("./shared/services/job/job-types.data.service.ts");
var language_data_service_1 = __webpack_require__("./shared/services/language/language.data.service.ts");
var settings_1 = __webpack_require__("./shared/services/settings/settings.ts");
var invoice_service_1 = __webpack_require__("./shared/services/invoice/invoice-service/invoice.service.ts");
var contracts_service_1 = __webpack_require__("./shared/services/contract/contracts-service/contracts.service.ts");
var questionnaires_service_1 = __webpack_require__("./shared/services/questionnarie/questionnaires-service/questionnaires.service.ts");
var product_packages_data_service_1 = __webpack_require__("./mobile/src/providers/product-packages-service/product-packages.data.service.ts");
var file_download_data_service_1 = __webpack_require__("./shared/services/files/file-download-service/file-download.data.service.ts");
var payments_schedules_data_service_1 = __webpack_require__("./shared/services/payments/payments-schedules-data-service/payments-schedules.data.service.ts");
var job_service_1 = __webpack_require__("./shared/services/job/job.service.ts");
var lead_service_1 = __webpack_require__("./shared/services/lead/lead.service.ts");
var ambassador_service_1 = __webpack_require__("./web/modern/services/admin/ambassadors/ambassador.service.ts");
var admin_users_data_service_1 = __webpack_require__("./web/modern/services/admin/users/admin-users.data.service.ts");
var admin_reports_data_service_1 = __webpack_require__("./web/modern/services/admin/users/admin-reports.data.service.ts");
var pagination_service_1 = __webpack_require__("./shared/services/pagination/pagination.service.ts");
var calendar_service_1 = __webpack_require__("./shared/services/calendar/calendar.service.ts");
var calendar_integration_service_1 = __webpack_require__("./shared/services/calendar-integration/calendar-integration.service.ts");
var company_settings_1 = __webpack_require__("./shared/services/settings/company-settings.ts");
var customize_labels_service_1 = __webpack_require__("./shared/services/settings/customize.labels.service.ts");
var dashboard_data_service_1 = __webpack_require__("./shared/services/dashboard/dashboard.data.service.ts");
var graphs_data_service_1 = __webpack_require__("./web/modern/components/dashboard/graphs-block/graphs.data.service.ts");
var graphs_service_1 = __webpack_require__("./web/modern/services/graph/graphs.service.ts");
var product_packages_data_service_2 = __webpack_require__("./shared/services/settings/product-packages.data.service.ts");
var payment_methods_data_service_1 = __webpack_require__("./web/modern/services/settings/payment-methods/payment-methods.data.service.ts");
var quote_update_service_1 = __webpack_require__("./shared/services/quote/quote-update.service.ts");
var profile_update_data_service_1 = __webpack_require__("./web/modern/services/profile/profile-update.data.service.ts");
var shootProof_data_service_1 = __webpack_require__("./shared/services/integrations/shootProof/shootProof.data.service.ts");
var profile_update_service_1 = __webpack_require__("./web/modern/services/profile/profile-update.service.ts");
var subscription_service_1 = __webpack_require__("./shared/services/subscription/subscription.service.ts");
var iframe_service_1 = __webpack_require__("./shared/services/helpers/iframe-service/iframe.service.ts");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var settings_data_service_1 = __webpack_require__("./web/modern/services/settings/contact-form/settings.data.service.ts");
var productPackage_service_1 = __webpack_require__("./web/modern/services/settings/productPackage.service.ts");
var brands_service_1 = __webpack_require__("./shared/services/brands/brands.service.ts");
var brands_data_service_1 = __webpack_require__("./shared/services/brands/brands.data.service.ts");
var settings_overview_data_service_1 = __webpack_require__("./shared/services/settings/settings-overview/settings-overview.data.service.ts");
var email_settings_service_1 = __webpack_require__("./shared/services/settings/email-settings.service.ts");
var two_fa_authentication_data_service_1 = __webpack_require__("./shared/services/user/two-fa-authentication.data.service.ts");
var two_fa_authentication_service_1 = __webpack_require__("./shared/services/user/two-fa-authentication.service.ts");
var lead_sources_data_service_1 = __webpack_require__("./shared/services/lead-sources/lead-sources.data.service.ts");
var pie_graph_service_1 = __webpack_require__("./web/modern/services/graph/pie-graph.service.ts");
var invoice_payments_data_1 = __webpack_require__("./web/modern/services/settings/invoice-payments/invoice-payments.data.ts");
var pickTime_data_service_1 = __webpack_require__("./shared/services/integrations/pickTime/pickTime.data.service.ts");
var integrations_service_1 = __webpack_require__("./shared/services/integrations/integrations.service.ts");
var auth_tokens_service_1 = __webpack_require__("./web/modern/auth-tokens.service.ts");
var double_booking_service_1 = __webpack_require__("./shared/services/double-booking/double-booking.service.ts");
var double_boooking_data_service_1 = __webpack_require__("./shared/services/double-booking/double-boooking.data.service.ts");
var color_service_1 = __webpack_require__("./shared/services/utils/color.service.ts");
var quote_invoice_templates_data_service_1 = __webpack_require__("./shared/services/quote-invoice-templates/quote-invoice-templates.data.service.ts");
var quote_invoice_templates_service_1 = __webpack_require__("./shared/services/quote-invoice-templates/quote-invoice-templates.service.ts");
var system_notifications_service_1 = __webpack_require__("./shared/services/system-notifications/system-notifications.service.ts");
var reports_overview_data_service_1 = __webpack_require__("./shared/services/admin/reports/reports-overview.data.service.ts");
var WebServicesModule = WebServicesModule_1 = function () {
    function WebServicesModule() {
        _classCallCheck(this, WebServicesModule);
    }

    _createClass(WebServicesModule, null, [{
        key: "forRoot",
        value: function forRoot() {
            return {
                ngModule: WebServicesModule_1,
                providers: [admin_reports_data_service_1.AdminReportsDataService, admin_users_data_service_1.AdminUsersDataService, ambassador_service_1.AmbassadorService, calendar_service_1.CalendarServiceProvider, search_service_1.SearchService, message_service_1.MessageService, appointment_service_1.AppointmentServiceProvider, validation_service_1.ValidationProvider, time_service_1.TimeServiceProvider, clients_data_service_1.ClientsDataServiceProvider, company_settings_1.CompanySettingsServiceProvider, customize_labels_service_1.CustomizeLabelsService, time_converter_1.TimeConverterProvider, client_service_1.ClientServiceProvider, extra_shoot_service_1.ExtraShootServiceProvider, image_converter_service_1.ImageConverterProvider, calendar_events_data_service_1.CalendarEventsDataProvider, calendar_service_1.CalendarServiceProvider, stringModifier_service_1.StringModifierServiceProvider, random_string_generator_1.RandomStringGeneratorProvider, integrations_data_service_1.IntegrationsDataProvider, templates_data_service_1.TemplatesDataProvider, payments_service_1.PaymentsServiceProvider, invoices_data_service_1.InvoicesDataProvider, workflow_data_service_1.WorkflowDataProvider, workflow_service_1.WorkflowProvider, workflow_drag_n_drop_1.WorkflowDragNDropProvider, email_service_1.EmailServiceProvider, mails_data_service_1.MailsDataProvider, utils_service_1.UtilsServiceProvider, notes_data_service_1.NotesDataServiceProvider, file_upload_data_service_1.FileUploadDataProvider, file_upload_service_1.FileUploadServiceProvider, file_download_data_service_1.FileDownloadDataServiceProvider, questionnaires_data_service_1.QuestionnairesDataProvider, contracts_data_service_1.ContractsDataProvider, email_settings_data_service_1.EmailSettingsDataService, account_data_service_1.AccountDataServiceProvider, account_service_1.AccountServiceWebProvider, auth_tokens_service_1.AuthTokensService, user_service_1.UserServiceWebProvider, promo_code_data_service_1.PromoCodeDataProvider, leads_data_service_1.LeadsDataServiceProvider, jobs_data_service_1.JobsDataServiceProvider, invoices_data_service_1.InvoicesDataProvider, payments_data_service_1.PaymentsDataServiceProvider, contracts_data_service_1.ContractsDataProvider, notes_data_service_1.NotesDataServiceProvider, quotes_data_service_1.QuotesDataProvider, job_types_data_service_1.JobTypesDataProvider, language_data_service_1.LanguageDataProvider, workflow_data_service_1.WorkflowDataProvider, settings_1.SettingsProvider, invoice_service_1.InvoiceServiceProvider, contracts_service_1.ContractsServiceProvider, questionnaires_service_1.QuestionnairesServiceProvider, product_packages_data_service_1.ProductPackagesServiceProvider, payments_schedules_data_service_1.PaymentSchedulesDataProvider, job_service_1.JobServiceProvider, lead_service_1.LeadServiceProvider, payments_schedules_data_service_1.PaymentSchedulesDataProvider, pagination_service_1.PaginationService, calendar_integration_service_1.CalendarIntegrationProvider, dashboard_data_service_1.DashboardDataServiceProvider, graphs_data_service_1.GraphsDataServiceProvider, graphs_service_1.GraphsService, product_packages_data_service_2.ProductPackagesDataServiceProvider, payment_methods_data_service_1.PaymentMethodsDataProvider, quote_update_service_1.QuoteUpdateService, profile_update_data_service_1.ProfileUpdateDataServiceProvider, shootProof_data_service_1.ShootProofDataProvider, profile_update_service_1.ProfileUpdateServiceProvider, subscription_service_1.NewSubscriptionServiceDataProvider, system_notifications_service_1.SystemNotificationsServiceDataProvider, iframe_service_1.IframeService, snModal_service_1.SNModalService, productPackage_service_1.ProductPackageService, settings_data_service_1.SettingsDataService, brands_service_1.BrandsServiceProvider, brands_data_service_1.BrandsDataServiceProvider, settings_overview_data_service_1.SettingsOverviewDataProvider, email_settings_service_1.EmailSettingsService, two_fa_authentication_data_service_1.TwoFaAuthenticationDataService, two_fa_authentication_service_1.TwoFaAuthenticationService, lead_sources_data_service_1.LeadSourcesDataService, pie_graph_service_1.PieGraphService, invoice_payments_data_1.InvoicePaymentsDataService, pickTime_data_service_1.PickTimeDataProvider, integrations_service_1.IntegrationsServiceProvider, double_booking_service_1.DoubleBookingService, double_boooking_data_service_1.DoubleBookingDataService, color_service_1.ColorService, quote_invoice_templates_data_service_1.QuoteInvoiceTemplatesDataService, quote_invoice_templates_service_1.QuoteInvoiceTemplatesService, reports_overview_data_service_1.ReportsOverviewDataProvider]
            };
        }
    }]);

    return WebServicesModule;
}();
WebServicesModule = WebServicesModule_1 = __decorate([core_1.NgModule({
    declarations: [],
    providers: [],
    imports: [],
    exports: []
})], WebServicesModule);
exports.WebServicesModule = WebServicesModule;
var WebServicesModule_1;

/***/ }),

/***/ "./web/modern/services/settings/contact-form/settings.data.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var http_1 = __webpack_require__("./node_modules/@angular/common/esm5/http.js");
var Observable_1 = __webpack_require__("./node_modules/rxjs/Observable.js");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var SettingsDataService = function () {
    function SettingsDataService(http, messageService) {
        _classCallCheck(this, SettingsDataService);

        this.http = http;
        this.messageService = messageService;
    }

    _createClass(SettingsDataService, [{
        key: "getContactFormPreviews",
        value: function getContactFormPreviews(pageRequest) {
            var _this = this;

            var url = '/api/user/v1/contactform/preview';
            return this.http.post(url, pageRequest).pipe(operators_1.map(function (res) {
                return res.data;
            }), operators_1.catchError(function (error) {
                return _this.messageService.catchErrorFromBackend(error);
            }));
        }
    }, {
        key: "duplicateContactForm",
        value: function duplicateContactForm(url, newName) {
            var _this2 = this;

            return this.http.post(url, { name: newName }).pipe(operators_1.map(function (res) {
                return res.data;
            }), operators_1.catchError(function (error) {
                return _this2.messageService.catchErrorFromBackend(error);
            }));
        }
    }, {
        key: "deleteContactForm",
        value: function deleteContactForm(url) {
            var _this3 = this;

            return this.http.delete(url).pipe(operators_1.catchError(function (error) {
                return _this3.messageService.catchErrorFromBackend(error);
            }));
        }
    }, {
        key: "getNewTemplateURL",
        value: function getNewTemplateURL(url) {
            var _this4 = this;

            var requestBody = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            return this.http.post(url, requestBody).pipe(operators_1.map(function (data) {
                return data.data;
            }), operators_1.catchError(function (error) {
                return _this4.messageService.catchErrorFromBackend(error);
            }));
        }
    }, {
        key: "getQuestionnaireTemplatesPreviews",
        value: function getQuestionnaireTemplatesPreviews(pageRequest) {
            var _this5 = this;

            var url = '/api/user/v2/questionnaire-templates/preview';
            return this.http.post(url, pageRequest).pipe(operators_1.map(function (data) {
                return data.data;
            }), operators_1.catchError(function (error) {
                return _this5.messageService.catchErrorFromBackend(error);
            }));
        }
    }, {
        key: "duplicateQuestionnaireTemplate",
        value: function duplicateQuestionnaireTemplate(url, newName) {
            var _this6 = this;

            return this.http.post(url, { name: newName }).pipe(operators_1.map(function (data) {
                return data.data;
            }), operators_1.catchError(function (error) {
                return _this6.messageService.catchErrorFromBackend(error);
            }));
        }
    }, {
        key: "deleteQuestionnaireTemplate",
        value: function deleteQuestionnaireTemplate(url) {
            var _this7 = this;

            return this.http.delete(url).pipe(operators_1.catchError(function (error) {
                _this7.messageService.catchErrorFromBackend(error);
                return Observable_1.Observable.throw(error);
            }));
        }
    }]);

    return SettingsDataService;
}();
SettingsDataService = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [http_1.HttpClient, message_service_1.MessageService])], SettingsDataService);
exports.SettingsDataService = SettingsDataService;

/***/ }),

/***/ "./web/modern/services/settings/invoice-payments/invoice-payments.data.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var http_1 = __webpack_require__("./node_modules/@angular/common/esm5/http.js");
var InvoicePaymentsDataService = function () {
    function InvoicePaymentsDataService(http) {
        _classCallCheck(this, InvoicePaymentsDataService);

        this.http = http;
    }

    _createClass(InvoicePaymentsDataService, [{
        key: "getInvoiceNumberingRules",
        value: function getInvoiceNumberingRules() {
            var url = '/api/user/v1/invoice/numbering/rule';
            return this.http.get(url);
        }
    }, {
        key: "saveInvoiceNumberingRules",
        value: function saveInvoiceNumberingRules(data) {
            var url = '/api/user/v1/invoice/numbering/rule';
            return this.http.post(url, data);
        }
    }]);

    return InvoicePaymentsDataService;
}();
InvoicePaymentsDataService = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [http_1.HttpClient])], InvoicePaymentsDataService);
exports.InvoicePaymentsDataService = InvoicePaymentsDataService;

/***/ }),

/***/ "./web/modern/services/settings/payment-methods/payment-methods.data.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = __webpack_require__("./node_modules/@angular/common/esm5/http.js");
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var PaymentMethodsDataProvider = function () {
    function PaymentMethodsDataProvider(http) {
        _classCallCheck(this, PaymentMethodsDataProvider);

        this.http = http;
    }

    _createClass(PaymentMethodsDataProvider, [{
        key: "deleteLang",
        value: function deleteLang(url) {
            return this.http.delete(url).toPromise();
        }
    }, {
        key: "getAllPaymentMethods",
        value: function getAllPaymentMethods() {
            return this.http.get('/protected/rest/payment_method').toPromise();
        }
    }, {
        key: "getPaymentInstructions",
        value: function getPaymentInstructions() {
            return this.http.get('/api/user/payment-methods/instructions').toPromise();
        }
    }, {
        key: "savePaymentMethods",
        value: function savePaymentMethods(methodsToSave) {
            return this.http.post('/api/user/payment-methods/instructions', methodsToSave).toPromise();
        }
    }, {
        key: "getPaymetMethodByType",
        value: function getPaymetMethodByType(type) {
            return this.http.get("/protected/rest/payment_method/get?type=" + type).toPromise();
        }
    }, {
        key: "saveStripeRequest",
        value: function saveStripeRequest(stripePaymentMethod) {
            return this.http.post('/protected/rest/payment_method/save_stripe', stripePaymentMethod).toPromise();
        }
    }, {
        key: "savePayPalRequest",
        value: function savePayPalRequest(paypalPaymentMethod) {
            return this.http.post('/protected/rest/payment_method/save_paypal', paypalPaymentMethod).toPromise();
        }
    }]);

    return PaymentMethodsDataProvider;
}();
PaymentMethodsDataProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [http_1.HttpClient])], PaymentMethodsDataProvider);
exports.PaymentMethodsDataProvider = PaymentMethodsDataProvider;

/***/ }),

/***/ "./web/modern/services/settings/productPackage.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var user_service_1 = __webpack_require__("./web/modern/services/user/user.service.ts");
var ProductPackageService = function () {
    function ProductPackageService(userService) {
        _classCallCheck(this, ProductPackageService);

        this.userService = userService;
    }

    _createClass(ProductPackageService, [{
        key: "getCurrensySymbol",
        value: function getCurrensySymbol() {
            var currensySymbol = this.userService.userCurrencySymbol;
            if (currensySymbol === 'د.إ') {
                currensySymbol = '';
            }
            return currensySymbol;
        }
    }, {
        key: "getTaxLabel",
        value: function getTaxLabel(taxType) {
            var taxLabel = '';
            switch (taxType) {
                case 'INCLUDED':
                    taxLabel = 'Includes';
                    break;
                case 'EXCLUDED':
                    taxLabel = 'Excludes';
                    break;
                case 'NO_TAX':
                    taxLabel = 'No';
                    break;
                default:
                    return '';
            }
            return taxLabel;
        }
    }]);

    return ProductPackageService;
}();
ProductPackageService = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [user_service_1.UserServiceWebProvider])], ProductPackageService);
exports.ProductPackageService = ProductPackageService;

/***/ }),

/***/ "./web/modern/services/user/account.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var common_1 = __webpack_require__("./node_modules/@angular/common/esm5/common.js");
var account_data_service_1 = __webpack_require__("./shared/services/user/account.data.service.ts");
var message_service_1 = __webpack_require__("./shared/services/helpers/message-service/message.service.ts");
var validation_service_1 = __webpack_require__("./shared/services/helpers/validation.service.ts");
var Observable_1 = __webpack_require__("./node_modules/rxjs/Observable.js");
var BehaviorSubject_1 = __webpack_require__("./node_modules/rxjs/BehaviorSubject.js");
var settings_1 = __webpack_require__("./shared/services/settings/settings.ts");
var rxjs_1 = __webpack_require__("./node_modules/rxjs/Rx.js");
var subscription_service_1 = __webpack_require__("./shared/services/subscription/subscription.service.ts");
var snModal_service_1 = __webpack_require__("./web/modern/services/modal/snModal.service.ts");
var of_1 = __webpack_require__("./node_modules/rxjs/observable/of.js");
var settings_overview_data_service_1 = __webpack_require__("./shared/services/settings/settings-overview/settings-overview.data.service.ts");
var operators_1 = __webpack_require__("./node_modules/rxjs/operators.js");
var brands_data_service_1 = __webpack_require__("./shared/services/brands/brands.data.service.ts");
var auth_tokens_service_1 = __webpack_require__("./web/modern/auth-tokens.service.ts");
var AccountServiceWebProvider = function () {
    function AccountServiceWebProvider(accountDataService, messageService, validationService, location, settingsService, snModalService, subscriptionService, brandsDataService, settingsOverviewService, storageService) {
        var _this = this;

        _classCallCheck(this, AccountServiceWebProvider);

        this.accountDataService = accountDataService;
        this.messageService = messageService;
        this.validationService = validationService;
        this.location = location;
        this.settingsService = settingsService;
        this.snModalService = snModalService;
        this.subscriptionService = subscriptionService;
        this.brandsDataService = brandsDataService;
        this.settingsOverviewService = settingsOverviewService;
        this.storageService = storageService;
        this.authenticated = false;
        this.subscriptionData = new BehaviorSubject_1.BehaviorSubject(null);
        this.userData = new BehaviorSubject_1.BehaviorSubject(null);
        this.navigationData = new BehaviorSubject_1.BehaviorSubject({});
        this.companyId$ = new rxjs_1.ReplaySubject(1);
        this.showHeader$ = new BehaviorSubject_1.BehaviorSubject(false);
        this.userLoginAction$ = new BehaviorSubject_1.BehaviorSubject(false);
        this.paths = {
            USER_MENU_PATH: 'authenticatedUser',
            USER_HOME_PATH: 'authenticatedUser',
            SETTING_NAVBAR_PATH: 'authenticatedUser',
            ANONYMOUS_MENU_PATH: 'anonymousUser',
            ANONYMOUS_HOME_PATH: 'anonymousUser',
            ADMIN_MENU_PATH: 'adminUser',
            ADMIN_HOME_PATH: 'adminUser'
        };
        this.setNavigationSettings = function (menuPath, homePath) {
            var navbarPath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'authenticatedUser';

            var path = _this.location.path();
            if (path.includes('/subscription') || path.includes('/reactivate')) {
                menuPath = null;
                homePath = null;
            }
            _this.navigationData.next({
                menu_path: menuPath,
                home_path: homePath || menuPath,
                settings_navbar_path: navbarPath
            });
        };
    }

    _createClass(AccountServiceWebProvider, [{
        key: "emitUser",
        value: function emitUser(user) {
            this.userData.next(user);
        }
    }, {
        key: "emitSubscriptionInfo",
        value: function emitSubscriptionInfo(data) {
            this.subscriptionData.next(data);
        }
    }, {
        key: "emitShowHeader",
        value: function emitShowHeader(value) {
            this.showHeader$.next(value);
        }
    }, {
        key: "emitUserLoginAction",
        value: function emitUserLoginAction(state) {
            this.userLoginAction$.next(state);
        }
    }, {
        key: "getUserWeb",
        value: function getUserWeb() {
            var _this2 = this;

            return this.accountDataService.getUser().catch(function (error) {
                _this2.messageService.showDefaultErrorMessage(error);
                return Observable_1.Observable.throw(error);
            }).map(function (data) {
                return _this2.getUserWebSuccessCallback(data);
            });
        }
    }, {
        key: "logoutWeb",
        value: function logoutWeb() {
            var _this3 = this;

            return this.accountDataService.logout().catch(function (error) {
                _this3.messageService.showDefaultErrorMessage(error);
                return Observable_1.Observable.throw(error);
            }).subscribe(function () {
                return _this3.successLogoutWeb();
            });
        }
    }, {
        key: "successLogoutWeb",
        value: function successLogoutWeb() {
            this.setUserAuthenticated(false);
            this.setNavigationSettings(null, null, null);
            this.emitUser(null);
            this.subscriptionService.setSubscriptionData(null);
            this.snModalService.closeActiveModal();
            this.storageService.removeTokens();
            delete this.user;
            this.location.go('/login');
            Intercom('shutdown');
        }
    }, {
        key: "isUserAuthenticated",
        value: function isUserAuthenticated() {
            return this.authenticated;
        }
    }, {
        key: "isAdmin",
        value: function isAdmin() {
            return this.user && this.user.admin;
        }
    }, {
        key: "setUserAuthenticated",
        value: function setUserAuthenticated(isAuthenticated) {
            this.authenticated = isAuthenticated;
        }
    }, {
        key: "authenticateWeb",
        value: function authenticateWeb(email, password, stayLogin) {
            var _this4 = this;

            // ): Observable<HttpEvent<any>> {
            if (this.validationService.isStringEmpty(password) || this.validationService.isStringEmpty(email)) {
                this.messageService.showToaster('e_0', 'login');
                return Observable_1.Observable.throw(new Error('validation error'));
            }
            return this.accountDataService.authenticateWeb(email, password, stayLogin).catch(function (error) {
                return _this4.errorAuthenticate(error);
            });
        }
    }, {
        key: "getRefreshedAuthTokenWeb",
        value: function getRefreshedAuthTokenWeb(token) {
            return this.accountDataService.getRefreshedAuthTokenWeb(token);
        }
    }, {
        key: "signUp",
        value: function signUp(signUpData, signUpSuccessCallback, signUpErrorCallback) {
            this.accountDataService.signUp(signUpData).subscribe(function (data) {
                return signUpSuccessCallback(data);
            }, function (result) {
                return signUpErrorCallback(result);
            });
        }
    }, {
        key: "confirmSignUp",
        value: function confirmSignUp(signUpSuccessCallback, signUpErrorCallback) {
            var url = this.location.path();
            this.accountDataService.confirmSignUp(url).subscribe(function (result) {
                return signUpSuccessCallback(result);
            }, function (result) {
                return signUpErrorCallback(result);
            });
        }
    }, {
        key: "companyRegister",
        value: function companyRegister(registrationData, successCallback, errorCallback) {
            this.accountDataService.signUp(registrationData).subscribe(function (result) {
                return successCallback(result);
            }, function (result) {
                return errorCallback(result);
            });
        }
    }, {
        key: "getInvitationCompany",
        value: function getInvitationCompany() {
            var confirmPathPart = 'register/';
            var url = this.location.path();
            var index = url.indexOf(confirmPathPart);
            var token = null;
            if (index !== -1 && index + confirmPathPart.length < url.length) {
                token = url.substring(confirmPathPart.length + index, url.length);
            }
            if (token) {
                return this.accountDataService.getInvitationCompany(token);
            }
        }
    }, {
        key: "saveBrand",
        value: function saveBrand(brand) {
            if (!brand.toImportData && brand.toImportData !== null) {
                brand.toImportData = null;
            }
            return this.brandsDataService.saveBrand(brand);
        }
    }, {
        key: "updateSystemDueToBrandChange",
        value: function updateSystemDueToBrandChange() {
            var _this5 = this;

            return of_1.of(null).pipe(operators_1.switchMap(function () {
                return _this5.subscriptionService.updateStatus();
            }), operators_1.switchMap(function () {
                return _this5.getUserWeb();
            }), operators_1.switchMap(function () {
                return _this5.brandsDataService.updateBrands();
            }), operators_1.catchError(function (err) {
                _this5.messageService.showDefaultErrorMessage(err);
                return of_1.of(null);
            }));
        }
    }, {
        key: "errorAuthenticate",
        value: function errorAuthenticate(result) {
            var error = result.error;

            if (error.error === 'unauthorized' || error.error === 'invalid_grant') {
                this.messageService.showToaster('e_0', 'login');
            } else {
                this.messageService.showToaster('e_0', 'general');
            }
            return Observable_1.Observable.throw(error);
        }
    }, {
        key: "bootIntercom",
        value: function bootIntercom() {
            var app_id = window.location.hostname !== 'app.studioninja.co' ? 'wa5e1gxe' : 'puddxy5b';
            Intercom('boot', { app_id: app_id });
        }
    }, {
        key: "getUserWebSuccessCallback",
        value: function getUserWebSuccessCallback(data) {
            if (!data) {
                console.error('No user data');
                return;
            }
            var _paths = this.paths,
                USER_MENU_PATH = _paths.USER_MENU_PATH,
                USER_HOME_PATH = _paths.USER_HOME_PATH,
                SETTING_NAVBAR_PATH = _paths.SETTING_NAVBAR_PATH,
                ADMIN_MENU_PATH = _paths.ADMIN_MENU_PATH,
                ADMIN_HOME_PATH = _paths.ADMIN_HOME_PATH;

            this.user = data;
            var isAdmin = data.admin;
            if (isAdmin) {
                this.setUserAuthenticated(true);
                this.settingsService.setDefaultTimeFormatSettings();
                this.setNavigationSettings(ADMIN_MENU_PATH, ADMIN_HOME_PATH, SETTING_NAVBAR_PATH);
            } else if (data.termsOfUseAgree !== true) {
                this.setUserAuthenticated(true);
                this.settingsService.getSettingsRequest().subscribe();
                this.settingsOverviewService.getSettingsOverviewItems().subscribe();
                if (this.location.path() !== '/login') {
                    this.logoutWeb();
                }
            } else if (data.enabled) {
                this.bootIntercom();
                this.setUserAuthenticated(true);
                this.settingsService.getSettingsRequest().subscribe();
                this.settingsOverviewService.getSettingsOverviewItems().subscribe();
                this.setNavigationSettings(USER_MENU_PATH, USER_HOME_PATH, SETTING_NAVBAR_PATH);
                this.updateIntercom(data);
            } else {
                console.error('Anonymous User');
            }
            if (data.intercomCompany && data.intercomCompany.id) {
                this.companyId$.next(data.intercomCompany.id);
            }
            this.emitUser(this.user);
            return data;
        }
    }, {
        key: "updateIntercom",
        value: function updateIntercom(data) {
            var id = data.id,
                firstName = data.firstName,
                email = data.email,
                registeredAt = data.registeredAt,
                intercomCompany = data.intercomCompany;

            Intercom('update', {
                user_id: id,
                name: firstName,
                email: email,
                created_at: registeredAt,
                plan: intercomCompany.subscriptionStatus,
                company: {
                    id: intercomCompany.id,
                    name: intercomCompany.name,
                    email: intercomCompany.email,
                    created_at: intercomCompany.createdAt,
                    plan: intercomCompany.plan,
                    jobs: intercomCompany.jobsCount,
                    invoices: intercomCompany.invoiceCount,
                    quotes: intercomCompany.quoteCount,
                    contracts: intercomCompany.contractCount,
                    questionnaires: intercomCompany.questionnaireCount,
                    promo_code: intercomCompany.companyPromoCode
                }
            });
        }
    }, {
        key: "userDataObservable",
        get: function get() {
            return this.userData.asObservable();
        }
    }, {
        key: "navDataObservable",
        get: function get() {
            return this.navigationData.asObservable();
        }
    }, {
        key: "showHeaderObservable",
        get: function get() {
            return this.showHeader$.asObservable();
        }
    }, {
        key: "userLoginActionObservable",
        get: function get() {
            return this.userLoginAction$.asObservable();
        }
    }, {
        key: "companyIdObservable",
        get: function get() {
            return this.companyId$;
        }
    }]);

    return AccountServiceWebProvider;
}();
AccountServiceWebProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [account_data_service_1.AccountDataServiceProvider, message_service_1.MessageService, validation_service_1.ValidationProvider, common_1.Location, settings_1.SettingsProvider, snModal_service_1.SNModalService, subscription_service_1.NewSubscriptionServiceDataProvider, brands_data_service_1.BrandsDataServiceProvider, settings_overview_data_service_1.SettingsOverviewDataProvider, auth_tokens_service_1.AuthTokensService])], AccountServiceWebProvider);
exports.AccountServiceWebProvider = AccountServiceWebProvider;

/***/ }),

/***/ "./web/modern/services/user/user.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function (k, v) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var account_service_1 = __webpack_require__("./web/modern/services/user/account.service.ts");
var UserServiceWebProvider = function () {
    function UserServiceWebProvider(accountService) {
        _classCallCheck(this, UserServiceWebProvider);

        this.accountService = accountService;
        this.getUser();
        // this.getSubscription();
    }

    _createClass(UserServiceWebProvider, [{
        key: "getUser",
        value: function getUser() {
            var _this = this;

            this.accountService.userDataObservable.subscribe(function (user) {
                if (user !== null && typeof user !== 'undefined' && user.id !== null) {
                    _this.user = user;
                }
            });
        }
    }, {
        key: "userData",
        get: function get() {
            return this.user;
        }
    }, {
        key: "subscriptionData",
        get: function get() {
            return this.subscription;
        }
    }, {
        key: "userCurrencyCode",
        get: function get() {
            if (typeof this.user !== 'undefined') {
                return this.user.currency.currencyCode;
            }
            return '';
        }
    }, {
        key: "userCurrencySymbol",
        get: function get() {
            if (typeof this.user !== 'undefined' && typeof this.user.currency !== 'undefined') {
                return this.user.currency.symbol;
            }
            return '';
        }
    }]);

    return UserServiceWebProvider;
}();
UserServiceWebProvider = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [account_service_1.AccountServiceWebProvider])], UserServiceWebProvider);
exports.UserServiceWebProvider = UserServiceWebProvider;

/***/ }),

/***/ "./web/scss/main.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./web/scss/vendors.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./web/upgrade/upgradeHelper.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
// https://github.com/dormd/angularjs-to-angular4/blob/master/hybrid-helper.ts
var angular = __webpack_require__("./node_modules/angular/index.js");
var static_1 = __webpack_require__("./node_modules/@angular/upgrade/esm5/static.js");
function buildFactoryForUpgradeProvider(ng1Name) {
    return function (injector) {
        return injector.get(ng1Name);
    };
}
exports.HybridHelper = {
    downgradeComponent: function downgradeComponent(moduleName, componentName, componentClass, options) {
        options = options || {};
        var inputs = options.inputs || [];
        var outputs = options.outputs || [];
        var component = componentClass;
        angular.module(moduleName).directive(componentName, static_1.downgradeComponent({
            component: component,
            inputs: inputs,
            outputs: outputs
        }));
        return exports.HybridHelper;
    },
    downgradeProvider: function downgradeProvider(moduleName, providerName, providerClass) {
        angular.module(moduleName).factory(providerName, static_1.downgradeInjectable(providerClass));
        return exports.HybridHelper;
    },
    buildProviderForUpgrade: function buildProviderForUpgrade(ng1Name, ng2Name) {
        ng2Name = ng2Name || ng1Name;
        return {
            provide: ng2Name,
            useFactory: buildFactoryForUpgradeProvider(ng1Name),
            deps: ['$injector']
        };
    }
};

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/babel-polyfill/lib/index.js");
__webpack_require__("./web/main.ts");
__webpack_require__("./web/js/app.js");
__webpack_require__("./web/js/controllers/addWorkflowController.js");
__webpack_require__("./web/js/controllers/admin/adminControllers.js");
__webpack_require__("./web/js/controllers/admin/ambassadorsController.js");
__webpack_require__("./web/js/controllers/admin/campaignsController.js");
__webpack_require__("./web/js/controllers/admin/referralsController.js");
__webpack_require__("./web/js/controllers/basePathController.js");
__webpack_require__("./web/js/controllers/calendarController.js");
__webpack_require__("./web/js/controllers/clientProfileController.js");
__webpack_require__("./web/js/controllers/clientsController.js");
__webpack_require__("./web/js/controllers/clientsPortal/ClientContactFormController.js");
__webpack_require__("./web/js/controllers/companyUsersController.js");
__webpack_require__("./web/js/controllers/contractsController.js");
__webpack_require__("./web/js/controllers/googleAutocompleteController.js");
__webpack_require__("./web/js/controllers/homeController.js");
__webpack_require__("./web/js/controllers/invoiceViewController.js");
__webpack_require__("./web/js/controllers/job/jobContractController.js");
__webpack_require__("./web/js/controllers/job/jobController.js");
__webpack_require__("./web/js/controllers/job/jobQuestionnaireController.js");
__webpack_require__("./web/js/controllers/job/jobViewController.js");
__webpack_require__("./web/js/controllers/lead/leadOverviewController.js");
__webpack_require__("./web/js/controllers/lead/leadViewController.js");
__webpack_require__("./web/js/controllers/login/changeLoginController.js");
__webpack_require__("./web/js/controllers/login/changePasswordController.js");
__webpack_require__("./web/js/controllers/login/confirmForgotPasswordController.js");
__webpack_require__("./web/js/controllers/login/confirmSignUpController.js");
__webpack_require__("./web/js/controllers/login/forgotPasswordController.js");
__webpack_require__("./web/js/controllers/login/loginController.js");
__webpack_require__("./web/js/controllers/login/signUpController.js");
__webpack_require__("./web/js/controllers/login/thankYouSignupController.js");
__webpack_require__("./web/js/controllers/login/tlcController.js");
__webpack_require__("./web/js/controllers/login/unsubscribeEmailsController.js");
__webpack_require__("./web/js/controllers/paymentsOverviewController.js");
__webpack_require__("./web/js/controllers/questionnairyController.js");
__webpack_require__("./web/js/controllers/quoteViewController.js");
__webpack_require__("./web/js/controllers/settings/calendarSettingsController.js");
__webpack_require__("./web/js/controllers/settings/companyInformationController.js");
__webpack_require__("./web/js/controllers/settings/contactFormController.js");
__webpack_require__("./web/js/controllers/settings/currencyAndTaxesController.js");
__webpack_require__("./web/js/controllers/settings/emailSettingsController.js");
__webpack_require__("./web/js/controllers/settings/emailTemplatesController.js");
__webpack_require__("./web/js/controllers/settings/integrationsController.js");
__webpack_require__("./web/js/controllers/settings/jobTypesController.js");
__webpack_require__("./web/js/controllers/settings/labelsSettingsController.js");
__webpack_require__("./web/js/controllers/settings/leadSourcesSettingsController.js");
__webpack_require__("./web/js/controllers/settings/paymentMethodsController.js");
__webpack_require__("./web/js/controllers/settings/paymentSchedulesControllers.js");
__webpack_require__("./web/js/controllers/settings/productsController.js");
__webpack_require__("./web/js/controllers/settings/profileController.js");
__webpack_require__("./web/js/controllers/settings/quoteInvoiceTemplatesController.js");
__webpack_require__("./web/js/controllers/settings/quoteInvoiceTemplatesUpdateController.js");
__webpack_require__("./web/js/controllers/settings/referController.js");
__webpack_require__("./web/js/controllers/settings/settingsController.js");
__webpack_require__("./web/js/controllers/updateInvoiceController.js");
__webpack_require__("./web/js/controllers/updateQuoteController.js");
__webpack_require__("./web/js/controllers/workflowController.js");
__webpack_require__("./web/js/components/admin/addAmbassadorCodeModal.js");
__webpack_require__("./web/js/components/admin/addPromoCodeModal.js");
__webpack_require__("./web/js/components/admin/adminSubscriptionModal.js");
__webpack_require__("./web/js/components/Buttons/btnAddNewJobElement.js");
__webpack_require__("./web/js/components/Buttons/btnAddSignature.js");
__webpack_require__("./web/js/components/Buttons/btnClose.js");
__webpack_require__("./web/js/components/Buttons/btnCopyToQuickbooks.js");
__webpack_require__("./web/js/components/Buttons/btnCopyToXero.js");
__webpack_require__("./web/js/components/Buttons/btnDelete.js");
__webpack_require__("./web/js/components/Buttons/btnDeleteJob.js");
__webpack_require__("./web/js/components/Buttons/btnEdit.js");
__webpack_require__("./web/js/components/Buttons/btnLgBlock.js");
__webpack_require__("./web/js/components/Buttons/btnPrint.js");
__webpack_require__("./web/js/components/Buttons/btnSend.js");
__webpack_require__("./web/js/components/Buttons/btnSendEmail.js");
__webpack_require__("./web/js/components/Buttons/btnUrl.js");
__webpack_require__("./web/js/components/Buttons/btnView.js");
__webpack_require__("./web/js/components/contract/sendContract.component.js");
__webpack_require__("./web/js/components/downgradedComponents.js");
__webpack_require__("./web/js/components/Elements/angularGoogleAutocomplete.js");
__webpack_require__("./web/js/components/Elements/fileInput.js");
__webpack_require__("./web/js/components/Elements/maxAmountValidator.js");
__webpack_require__("./web/js/components/Elements/snAttachFiles.js");
__webpack_require__("./web/js/components/Elements/snCheckbox.js");
__webpack_require__("./web/js/components/Elements/snSelect.js");
__webpack_require__("./web/js/components/Elements/webshimPolyfill.js");
__webpack_require__("./web/js/components/Filelds/contactFullName.js");
__webpack_require__("./web/js/components/Filelds/convertToNumber.js");
__webpack_require__("./web/js/components/Filelds/fullDateTime.js");
__webpack_require__("./web/js/components/Filelds/jobCellHead.js");
__webpack_require__("./web/js/components/Filelds/mainShootDate.js");
__webpack_require__("./web/js/components/Filelds/snFieldEmail.js");
__webpack_require__("./web/js/components/Filelds/snFieldInfo.js");
__webpack_require__("./web/js/components/Filelds/snFieldInput.js");
__webpack_require__("./web/js/components/fileModel.js");
__webpack_require__("./web/js/components/home/adminHome.component.js");
__webpack_require__("./web/js/components/home/anonymousHome.component.js");
__webpack_require__("./web/js/components/home/userHome.component.js");
__webpack_require__("./web/js/components/invoice/sendInvoice.component.js");
__webpack_require__("./web/js/components/mailList.js");
__webpack_require__("./web/js/components/Modals/private/addAppointmentModal.js");
__webpack_require__("./web/js/components/Modals/private/attachFilesModal.js");
__webpack_require__("./web/js/components/Modals/private/changeModal.js");
__webpack_require__("./web/js/components/Modals/private/createNewClientModal.js");
__webpack_require__("./web/js/components/Modals/private/deleteAppointmentModal.js");
__webpack_require__("./web/js/components/Modals/private/deleteAttachmentModal.js");
__webpack_require__("./web/js/components/Modals/private/deleteExtrashootModal.js");
__webpack_require__("./web/js/components/Modals/private/editContractModal.js");
__webpack_require__("./web/js/components/Modals/private/helperSubscription/mailInfoModal.js");
__webpack_require__("./web/js/components/Modals/private/helperSubscription/subscriptionBannerList.js");
__webpack_require__("./web/js/components/Modals/private/importClientsModal.js");
__webpack_require__("./web/js/components/Modals/private/modalLinkEditor.js");
__webpack_require__("./web/js/components/Modals/private/modalSendMail.js");
__webpack_require__("./web/js/components/Modals/private/updateJobModal.js");
__webpack_require__("./web/js/components/Modals/private/updateLeadModal.js");
__webpack_require__("./web/js/components/Modals/public/modalHello.js");
__webpack_require__("./web/js/components/Modals/public/modalTerms.js");
__webpack_require__("./web/js/components/navigation/admin-navbar/adminNavbar.component.js");
__webpack_require__("./web/js/components/navigation/anonymous-navbar/anonymousNavbar.component.js");
__webpack_require__("./web/js/components/navigation/company-navbar/companyNavbar.component.js");
__webpack_require__("./web/js/components/navigation/header/header.component.js");
__webpack_require__("./web/js/components/navigation/subscriptionNavbar.component.js");
__webpack_require__("./web/js/components/navigation/user-navbar/userNavbar.component.js");
__webpack_require__("./web/js/components/onloadlogoComponent.js");
__webpack_require__("./web/js/components/PageCalendar/addCalendarEventModal.js");
__webpack_require__("./web/js/components/PageCalendar/eventTypeCell.js");
__webpack_require__("./web/js/components/PageCalendar/thCalendarMonth.js");
__webpack_require__("./web/js/components/PageCalendar/thCalendarWeek.js");
__webpack_require__("./web/js/components/PageCalendar/trWeekAllDays.js");
__webpack_require__("./web/js/components/PageCalendar/weekEventCell.js");
__webpack_require__("./web/js/components/pageInvoice/tdPaid.js");
__webpack_require__("./web/js/components/pageJob/jobCellHeader.js");
__webpack_require__("./web/js/components/PageJobsOverview/isLeadJob.js");
__webpack_require__("./web/js/components/PageJobsOverview/jobProgress.js");
__webpack_require__("./web/js/components/questionnaire/sendQuestionnaire.component.js");
__webpack_require__("./web/js/components/quote/sendQuote.component.js");
__webpack_require__("./web/js/components/snTextAngular.js");
__webpack_require__("./web/js/components/snTimepicker.js");
__webpack_require__("./web/js/components/spinningWheel.js");
__webpack_require__("./web/js/components/tableRowLink.js");
__webpack_require__("./web/js/components/textAreaElastic.js");
__webpack_require__("./web/js/components/Workflow/animateNewTask.js");
__webpack_require__("./web/js/components/Workflow/buttons/workflowOptions.js");
__webpack_require__("./web/js/components/Workflow/Modals/addAppointmentWithoutScheduleModal.js");
__webpack_require__("./web/js/components/Workflow/Modals/addAutomationModal.js");
__webpack_require__("./web/js/components/Workflow/Modals/addContract.js");
__webpack_require__("./web/js/components/Workflow/Modals/addExtraShootModal.js");
__webpack_require__("./web/js/components/Workflow/Modals/addExtraShootWithoutScheduleModal.js");
__webpack_require__("./web/js/components/Workflow/Modals/addMail.js");
__webpack_require__("./web/js/components/Workflow/Modals/addMailOrTemplate.js");
__webpack_require__("./web/js/components/Workflow/Modals/addQuestionnaire.js");
__webpack_require__("./web/js/components/Workflow/Modals/addTodoModal.js");
__webpack_require__("./web/js/components/Workflow/Modals/addWorkflowTaskModal.js");
__webpack_require__("./web/js/components/Workflow/Modals/deleteWorkflowTaskModal.js");
__webpack_require__("./web/js/components/Workflow/workflowList.js");
__webpack_require__("./web/js/services/copyToClipboardService.js");
__webpack_require__("./web/js/services/dataServices/ambassadorsDataService.js");
__webpack_require__("./web/js/services/dataServices/jobDataService.js");
__webpack_require__("./web/js/services/dataServices/referralsDataService.js");
__webpack_require__("./web/js/services/downgradedServices.js");
__webpack_require__("./web/js/services/fileUploadService.js");
__webpack_require__("./web/js/services/filters/cutEmailFilter.js");
__webpack_require__("./web/js/services/filters/cutStringFilter.js");
__webpack_require__("./web/js/services/filters/profilePriceFilter.js");
__webpack_require__("./web/js/services/filters/timeFilter.js");
__webpack_require__("./web/js/services/filters/timezoneFilter.js");
__webpack_require__("./web/js/services/paymentVariablesService.js");
__webpack_require__("./web/js/services/routeResolverService.js");
__webpack_require__("./web/js/services/workflowDragNDropService.js");
module.exports = __webpack_require__("./web/js/services/workflowService.js");


/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

/* (ignored) */

/***/ })

},[0]);


// WEBPACK FOOTER //
// web.f053e29bf8f85e0ae572.bundle.js